function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2d52"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2d52"] = parcelRequire;
}
parcelRequire.register("9zeGj", function(module, exports) {
"use strict";

module.exports = (parcelRequire("bAwim"));

});
parcelRequire.register("bAwim", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $86fc1b9f8c19a954$export$ffb0004e005737fa; }, function (v) { return $86fc1b9f8c19a954$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $86fc1b9f8c19a954$export$34b9dba7ce09269b; }, function (v) { return $86fc1b9f8c19a954$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $86fc1b9f8c19a954$export$25062201e9e25d76; }, function (v) { return $86fc1b9f8c19a954$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $86fc1b9f8c19a954$export$ffb0004e005737fa;
var $86fc1b9f8c19a954$export$34b9dba7ce09269b;
var $86fc1b9f8c19a954$export$25062201e9e25d76;
"use strict";

var $eCoWV = parcelRequire("eCoWV");
var $86fc1b9f8c19a954$var$k = Symbol.for("react.element"), $86fc1b9f8c19a954$var$l = Symbol.for("react.fragment"), $86fc1b9f8c19a954$var$m = Object.prototype.hasOwnProperty, $86fc1b9f8c19a954$var$n = $eCoWV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $86fc1b9f8c19a954$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $86fc1b9f8c19a954$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$86fc1b9f8c19a954$var$m.call(a, b) && !$86fc1b9f8c19a954$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $86fc1b9f8c19a954$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $86fc1b9f8c19a954$var$n.current
    };
}
$86fc1b9f8c19a954$export$ffb0004e005737fa = $86fc1b9f8c19a954$var$l;
$86fc1b9f8c19a954$export$34b9dba7ce09269b = $86fc1b9f8c19a954$var$q;
$86fc1b9f8c19a954$export$25062201e9e25d76 = $86fc1b9f8c19a954$var$q;

});
parcelRequire.register("eCoWV", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jiG8J"));

});
parcelRequire.register("jiG8J", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $e0d062d99320e0c6$export$dca3b0875bd9a954; }, function (v) { return $e0d062d99320e0c6$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $e0d062d99320e0c6$export$16fa2f45be04daa8; }, function (v) { return $e0d062d99320e0c6$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $e0d062d99320e0c6$export$ffb0004e005737fa; }, function (v) { return $e0d062d99320e0c6$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $e0d062d99320e0c6$export$e2c29f18771995cb; }, function (v) { return $e0d062d99320e0c6$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $e0d062d99320e0c6$export$221d75b3f55bb0bd; }, function (v) { return $e0d062d99320e0c6$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $e0d062d99320e0c6$export$5f8d39834fd61797; }, function (v) { return $e0d062d99320e0c6$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $e0d062d99320e0c6$export$74bf444e3cd11ea5; }, function (v) { return $e0d062d99320e0c6$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $e0d062d99320e0c6$export$ae55be85d98224ed; }, function (v) { return $e0d062d99320e0c6$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $e0d062d99320e0c6$export$e530037191fcd5d7; }, function (v) { return $e0d062d99320e0c6$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $e0d062d99320e0c6$export$fd42f52fd3ae1109; }, function (v) { return $e0d062d99320e0c6$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $e0d062d99320e0c6$export$c8a8987d4410bf2d; }, function (v) { return $e0d062d99320e0c6$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $e0d062d99320e0c6$export$d38cd72104c1f0e9; }, function (v) { return $e0d062d99320e0c6$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $e0d062d99320e0c6$export$7d1e3a5e95ceca43; }, function (v) { return $e0d062d99320e0c6$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $e0d062d99320e0c6$export$257a8862b851cb5b; }, function (v) { return $e0d062d99320e0c6$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $e0d062d99320e0c6$export$a8257692ac88316c; }, function (v) { return $e0d062d99320e0c6$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $e0d062d99320e0c6$export$488013bae63b21da; }, function (v) { return $e0d062d99320e0c6$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $e0d062d99320e0c6$export$7c73462e0d25e514; }, function (v) { return $e0d062d99320e0c6$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $e0d062d99320e0c6$export$7568632d0d33d16d; }, function (v) { return $e0d062d99320e0c6$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $e0d062d99320e0c6$export$88948ce120ea2619; }, function (v) { return $e0d062d99320e0c6$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $e0d062d99320e0c6$export$35808ee640e87ca7; }, function (v) { return $e0d062d99320e0c6$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $e0d062d99320e0c6$export$fae74005e78b1a27; }, function (v) { return $e0d062d99320e0c6$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $e0d062d99320e0c6$export$dc8fbce3eb94dc1e; }, function (v) { return $e0d062d99320e0c6$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $e0d062d99320e0c6$export$6a7bc4e911dc01cf; }, function (v) { return $e0d062d99320e0c6$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $e0d062d99320e0c6$export$6d9c69b0de29b591; }, function (v) { return $e0d062d99320e0c6$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $e0d062d99320e0c6$export$f680877a34711e37; }, function (v) { return $e0d062d99320e0c6$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $e0d062d99320e0c6$export$d5a552a76deda3c2; }, function (v) { return $e0d062d99320e0c6$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $e0d062d99320e0c6$export$aaabe4eda9ed9969; }, function (v) { return $e0d062d99320e0c6$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $e0d062d99320e0c6$export$e5c5a5f917a5871c; }, function (v) { return $e0d062d99320e0c6$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $e0d062d99320e0c6$export$1538c33de8887b59; }, function (v) { return $e0d062d99320e0c6$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $e0d062d99320e0c6$export$13e3392192263954; }, function (v) { return $e0d062d99320e0c6$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $e0d062d99320e0c6$export$b8f5890fc79d6aca; }, function (v) { return $e0d062d99320e0c6$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $e0d062d99320e0c6$export$60241385465d0a34; }, function (v) { return $e0d062d99320e0c6$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $e0d062d99320e0c6$export$306c0aa65ff9ec16; }, function (v) { return $e0d062d99320e0c6$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $e0d062d99320e0c6$export$7b286972b8d8ccbf; }, function (v) { return $e0d062d99320e0c6$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $e0d062d99320e0c6$export$83d89fbfd8236492; }, function (v) { return $e0d062d99320e0c6$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e0d062d99320e0c6$export$dca3b0875bd9a954;
var $e0d062d99320e0c6$export$16fa2f45be04daa8;
var $e0d062d99320e0c6$export$ffb0004e005737fa;
var $e0d062d99320e0c6$export$e2c29f18771995cb;
var $e0d062d99320e0c6$export$221d75b3f55bb0bd;
var $e0d062d99320e0c6$export$5f8d39834fd61797;
var $e0d062d99320e0c6$export$74bf444e3cd11ea5;
var $e0d062d99320e0c6$export$ae55be85d98224ed;
var $e0d062d99320e0c6$export$e530037191fcd5d7;
var $e0d062d99320e0c6$export$fd42f52fd3ae1109;
var $e0d062d99320e0c6$export$c8a8987d4410bf2d;
var $e0d062d99320e0c6$export$d38cd72104c1f0e9;
var $e0d062d99320e0c6$export$7d1e3a5e95ceca43;
var $e0d062d99320e0c6$export$257a8862b851cb5b;
var $e0d062d99320e0c6$export$a8257692ac88316c;
var $e0d062d99320e0c6$export$488013bae63b21da;
var $e0d062d99320e0c6$export$7c73462e0d25e514;
var $e0d062d99320e0c6$export$7568632d0d33d16d;
var $e0d062d99320e0c6$export$88948ce120ea2619;
var $e0d062d99320e0c6$export$35808ee640e87ca7;
var $e0d062d99320e0c6$export$fae74005e78b1a27;
var $e0d062d99320e0c6$export$dc8fbce3eb94dc1e;
var $e0d062d99320e0c6$export$6a7bc4e911dc01cf;
var $e0d062d99320e0c6$export$6d9c69b0de29b591;
var $e0d062d99320e0c6$export$f680877a34711e37;
var $e0d062d99320e0c6$export$d5a552a76deda3c2;
var $e0d062d99320e0c6$export$aaabe4eda9ed9969;
var $e0d062d99320e0c6$export$e5c5a5f917a5871c;
var $e0d062d99320e0c6$export$1538c33de8887b59;
var $e0d062d99320e0c6$export$13e3392192263954;
var $e0d062d99320e0c6$export$b8f5890fc79d6aca;
var $e0d062d99320e0c6$export$60241385465d0a34;
var $e0d062d99320e0c6$export$306c0aa65ff9ec16;
var $e0d062d99320e0c6$export$7b286972b8d8ccbf;
var $e0d062d99320e0c6$export$83d89fbfd8236492;
"use strict";
var $e0d062d99320e0c6$var$l = Symbol.for("react.element"), $e0d062d99320e0c6$var$n = Symbol.for("react.portal"), $e0d062d99320e0c6$var$p = Symbol.for("react.fragment"), $e0d062d99320e0c6$var$q = Symbol.for("react.strict_mode"), $e0d062d99320e0c6$var$r = Symbol.for("react.profiler"), $e0d062d99320e0c6$var$t = Symbol.for("react.provider"), $e0d062d99320e0c6$var$u = Symbol.for("react.context"), $e0d062d99320e0c6$var$v = Symbol.for("react.forward_ref"), $e0d062d99320e0c6$var$w = Symbol.for("react.suspense"), $e0d062d99320e0c6$var$x = Symbol.for("react.memo"), $e0d062d99320e0c6$var$y = Symbol.for("react.lazy"), $e0d062d99320e0c6$var$z = Symbol.iterator;
function $e0d062d99320e0c6$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $e0d062d99320e0c6$var$z && a[$e0d062d99320e0c6$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $e0d062d99320e0c6$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $e0d062d99320e0c6$var$C = Object.assign, $e0d062d99320e0c6$var$D = {};
function $e0d062d99320e0c6$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e0d062d99320e0c6$var$D;
    this.updater = e || $e0d062d99320e0c6$var$B;
}
$e0d062d99320e0c6$var$E.prototype.isReactComponent = {};
$e0d062d99320e0c6$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$e0d062d99320e0c6$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $e0d062d99320e0c6$var$F() {}
$e0d062d99320e0c6$var$F.prototype = $e0d062d99320e0c6$var$E.prototype;
function $e0d062d99320e0c6$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $e0d062d99320e0c6$var$D;
    this.updater = e || $e0d062d99320e0c6$var$B;
}
var $e0d062d99320e0c6$var$H = $e0d062d99320e0c6$var$G.prototype = new $e0d062d99320e0c6$var$F;
$e0d062d99320e0c6$var$H.constructor = $e0d062d99320e0c6$var$G;
$e0d062d99320e0c6$var$C($e0d062d99320e0c6$var$H, $e0d062d99320e0c6$var$E.prototype);
$e0d062d99320e0c6$var$H.isPureReactComponent = !0;
var $e0d062d99320e0c6$var$I = Array.isArray, $e0d062d99320e0c6$var$J = Object.prototype.hasOwnProperty, $e0d062d99320e0c6$var$K = {
    current: null
}, $e0d062d99320e0c6$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $e0d062d99320e0c6$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$e0d062d99320e0c6$var$J.call(b, d) && !$e0d062d99320e0c6$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $e0d062d99320e0c6$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $e0d062d99320e0c6$var$K.current
    };
}
function $e0d062d99320e0c6$var$N(a, b) {
    return {
        $$typeof: $e0d062d99320e0c6$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $e0d062d99320e0c6$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $e0d062d99320e0c6$var$l;
}
function $e0d062d99320e0c6$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $e0d062d99320e0c6$var$P = /\/+/g;
function $e0d062d99320e0c6$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $e0d062d99320e0c6$var$escape("" + a.key) : b.toString(36);
}
function $e0d062d99320e0c6$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $e0d062d99320e0c6$var$l:
                case $e0d062d99320e0c6$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $e0d062d99320e0c6$var$Q(h, 0) : d, $e0d062d99320e0c6$var$I(c) ? (e = "", null != a && (e = a.replace($e0d062d99320e0c6$var$P, "$&/") + "/"), $e0d062d99320e0c6$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($e0d062d99320e0c6$var$O(c) && (c = $e0d062d99320e0c6$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($e0d062d99320e0c6$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($e0d062d99320e0c6$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $e0d062d99320e0c6$var$Q(k, g);
        h += $e0d062d99320e0c6$var$R(k, b, e, f, c);
    }
    else if (f = $e0d062d99320e0c6$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $e0d062d99320e0c6$var$Q(k, g++), h += $e0d062d99320e0c6$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $e0d062d99320e0c6$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $e0d062d99320e0c6$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $e0d062d99320e0c6$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $e0d062d99320e0c6$var$U = {
    current: null
}, $e0d062d99320e0c6$var$V = {
    transition: null
}, $e0d062d99320e0c6$var$W = {
    ReactCurrentDispatcher: $e0d062d99320e0c6$var$U,
    ReactCurrentBatchConfig: $e0d062d99320e0c6$var$V,
    ReactCurrentOwner: $e0d062d99320e0c6$var$K
};
$e0d062d99320e0c6$export$dca3b0875bd9a954 = {
    map: $e0d062d99320e0c6$var$S,
    forEach: function(a, b, e) {
        $e0d062d99320e0c6$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $e0d062d99320e0c6$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $e0d062d99320e0c6$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$e0d062d99320e0c6$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$e0d062d99320e0c6$export$16fa2f45be04daa8 = $e0d062d99320e0c6$var$E;
$e0d062d99320e0c6$export$ffb0004e005737fa = $e0d062d99320e0c6$var$p;
$e0d062d99320e0c6$export$e2c29f18771995cb = $e0d062d99320e0c6$var$r;
$e0d062d99320e0c6$export$221d75b3f55bb0bd = $e0d062d99320e0c6$var$G;
$e0d062d99320e0c6$export$5f8d39834fd61797 = $e0d062d99320e0c6$var$q;
$e0d062d99320e0c6$export$74bf444e3cd11ea5 = $e0d062d99320e0c6$var$w;
$e0d062d99320e0c6$export$ae55be85d98224ed = $e0d062d99320e0c6$var$W;
$e0d062d99320e0c6$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $e0d062d99320e0c6$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $e0d062d99320e0c6$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$e0d062d99320e0c6$var$J.call(b, f) && !$e0d062d99320e0c6$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $e0d062d99320e0c6$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$e0d062d99320e0c6$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $e0d062d99320e0c6$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $e0d062d99320e0c6$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$e0d062d99320e0c6$export$c8a8987d4410bf2d = $e0d062d99320e0c6$var$M;
$e0d062d99320e0c6$export$d38cd72104c1f0e9 = function(a) {
    var b = $e0d062d99320e0c6$var$M.bind(null, a);
    b.type = a;
    return b;
};
$e0d062d99320e0c6$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$e0d062d99320e0c6$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $e0d062d99320e0c6$var$v,
        render: a
    };
};
$e0d062d99320e0c6$export$a8257692ac88316c = $e0d062d99320e0c6$var$O;
$e0d062d99320e0c6$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $e0d062d99320e0c6$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $e0d062d99320e0c6$var$T
    };
};
$e0d062d99320e0c6$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $e0d062d99320e0c6$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$e0d062d99320e0c6$export$7568632d0d33d16d = function(a) {
    var b = $e0d062d99320e0c6$var$V.transition;
    $e0d062d99320e0c6$var$V.transition = {};
    try {
        a();
    } finally{
        $e0d062d99320e0c6$var$V.transition = b;
    }
};
$e0d062d99320e0c6$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$e0d062d99320e0c6$export$35808ee640e87ca7 = function(a, b) {
    return $e0d062d99320e0c6$var$U.current.useCallback(a, b);
};
$e0d062d99320e0c6$export$fae74005e78b1a27 = function(a) {
    return $e0d062d99320e0c6$var$U.current.useContext(a);
};
$e0d062d99320e0c6$export$dc8fbce3eb94dc1e = function() {};
$e0d062d99320e0c6$export$6a7bc4e911dc01cf = function(a) {
    return $e0d062d99320e0c6$var$U.current.useDeferredValue(a);
};
$e0d062d99320e0c6$export$6d9c69b0de29b591 = function(a, b) {
    return $e0d062d99320e0c6$var$U.current.useEffect(a, b);
};
$e0d062d99320e0c6$export$f680877a34711e37 = function() {
    return $e0d062d99320e0c6$var$U.current.useId();
};
$e0d062d99320e0c6$export$d5a552a76deda3c2 = function(a, b, e) {
    return $e0d062d99320e0c6$var$U.current.useImperativeHandle(a, b, e);
};
$e0d062d99320e0c6$export$aaabe4eda9ed9969 = function(a, b) {
    return $e0d062d99320e0c6$var$U.current.useInsertionEffect(a, b);
};
$e0d062d99320e0c6$export$e5c5a5f917a5871c = function(a, b) {
    return $e0d062d99320e0c6$var$U.current.useLayoutEffect(a, b);
};
$e0d062d99320e0c6$export$1538c33de8887b59 = function(a, b) {
    return $e0d062d99320e0c6$var$U.current.useMemo(a, b);
};
$e0d062d99320e0c6$export$13e3392192263954 = function(a, b, e) {
    return $e0d062d99320e0c6$var$U.current.useReducer(a, b, e);
};
$e0d062d99320e0c6$export$b8f5890fc79d6aca = function(a) {
    return $e0d062d99320e0c6$var$U.current.useRef(a);
};
$e0d062d99320e0c6$export$60241385465d0a34 = function(a) {
    return $e0d062d99320e0c6$var$U.current.useState(a);
};
$e0d062d99320e0c6$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $e0d062d99320e0c6$var$U.current.useSyncExternalStore(a, b, e);
};
$e0d062d99320e0c6$export$7b286972b8d8ccbf = function() {
    return $e0d062d99320e0c6$var$U.current.useTransition();
};
$e0d062d99320e0c6$export$83d89fbfd8236492 = "18.2.0";

});




parcelRequire.register("iVz18", function(module, exports) {
"use strict";
function $dc78b69813dec2d9$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($dc78b69813dec2d9$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$dc78b69813dec2d9$var$checkDCE();

module.exports = (parcelRequire("ajk4a"));

});
parcelRequire.register("ajk4a", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $781b3e78c0ece49a$export$ae55be85d98224ed; }, function (v) { return $781b3e78c0ece49a$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $781b3e78c0ece49a$export$d39a5bbd09211389; }, function (v) { return $781b3e78c0ece49a$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $781b3e78c0ece49a$export$882461b6382ed46c; }, function (v) { return $781b3e78c0ece49a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $781b3e78c0ece49a$export$466bfc07425424d5; }, function (v) { return $781b3e78c0ece49a$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $781b3e78c0ece49a$export$cd75ccfd720a3cd4; }, function (v) { return $781b3e78c0ece49a$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $781b3e78c0ece49a$export$fa8d919ba61d84db; }, function (v) { return $781b3e78c0ece49a$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $781b3e78c0ece49a$export$757ceba2d55c277e; }, function (v) { return $781b3e78c0ece49a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $781b3e78c0ece49a$export$b3890eb0ae9dca99; }, function (v) { return $781b3e78c0ece49a$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $781b3e78c0ece49a$export$502457920280e6be; }, function (v) { return $781b3e78c0ece49a$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $781b3e78c0ece49a$export$c78a37762a8d58e1; }, function (v) { return $781b3e78c0ece49a$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $781b3e78c0ece49a$export$dc54d992c10e8a18; }, function (v) { return $781b3e78c0ece49a$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $781b3e78c0ece49a$export$83d89fbfd8236492; }, function (v) { return $781b3e78c0ece49a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $781b3e78c0ece49a$export$ae55be85d98224ed;
var $781b3e78c0ece49a$export$d39a5bbd09211389;
var $781b3e78c0ece49a$export$882461b6382ed46c;
var $781b3e78c0ece49a$export$466bfc07425424d5;
var $781b3e78c0ece49a$export$cd75ccfd720a3cd4;
var $781b3e78c0ece49a$export$fa8d919ba61d84db;
var $781b3e78c0ece49a$export$757ceba2d55c277e;
var $781b3e78c0ece49a$export$b3890eb0ae9dca99;
var $781b3e78c0ece49a$export$502457920280e6be;
var $781b3e78c0ece49a$export$c78a37762a8d58e1;
var $781b3e78c0ece49a$export$dc54d992c10e8a18;
var $781b3e78c0ece49a$export$83d89fbfd8236492;
"use strict";

var $eCoWV = parcelRequire("eCoWV");

var $f2Ki7 = parcelRequire("f2Ki7");
function $781b3e78c0ece49a$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $781b3e78c0ece49a$var$da = new Set, $781b3e78c0ece49a$var$ea = {};
function $781b3e78c0ece49a$var$fa(a, b) {
    $781b3e78c0ece49a$var$ha(a, b);
    $781b3e78c0ece49a$var$ha(a + "Capture", b);
}
function $781b3e78c0ece49a$var$ha(a, b) {
    $781b3e78c0ece49a$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$781b3e78c0ece49a$var$da.add(b[a]);
}
var $781b3e78c0ece49a$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $781b3e78c0ece49a$var$ja = Object.prototype.hasOwnProperty, $781b3e78c0ece49a$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $781b3e78c0ece49a$var$la = {}, $781b3e78c0ece49a$var$ma = {};
function $781b3e78c0ece49a$var$oa(a) {
    if ($781b3e78c0ece49a$var$ja.call($781b3e78c0ece49a$var$ma, a)) return !0;
    if ($781b3e78c0ece49a$var$ja.call($781b3e78c0ece49a$var$la, a)) return !1;
    if ($781b3e78c0ece49a$var$ka.test(a)) return $781b3e78c0ece49a$var$ma[a] = !0;
    $781b3e78c0ece49a$var$la[a] = !0;
    return !1;
}
function $781b3e78c0ece49a$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $781b3e78c0ece49a$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $781b3e78c0ece49a$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $781b3e78c0ece49a$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $781b3e78c0ece49a$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $781b3e78c0ece49a$var$z[b] = new $781b3e78c0ece49a$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $781b3e78c0ece49a$var$ra = /[\-:]([a-z])/g;
function $781b3e78c0ece49a$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($781b3e78c0ece49a$var$ra, $781b3e78c0ece49a$var$sa);
    $781b3e78c0ece49a$var$z[b] = new $781b3e78c0ece49a$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($781b3e78c0ece49a$var$ra, $781b3e78c0ece49a$var$sa);
    $781b3e78c0ece49a$var$z[b] = new $781b3e78c0ece49a$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($781b3e78c0ece49a$var$ra, $781b3e78c0ece49a$var$sa);
    $781b3e78c0ece49a$var$z[b] = new $781b3e78c0ece49a$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$781b3e78c0ece49a$var$z.xlinkHref = new $781b3e78c0ece49a$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $781b3e78c0ece49a$var$z[a] = new $781b3e78c0ece49a$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $781b3e78c0ece49a$var$ta(a, b, c, d) {
    var e = $781b3e78c0ece49a$var$z.hasOwnProperty(b) ? $781b3e78c0ece49a$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $781b3e78c0ece49a$var$qa(b, c, e, d) && (c = null), d || null === e ? $781b3e78c0ece49a$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $781b3e78c0ece49a$var$ua = $eCoWV.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $781b3e78c0ece49a$var$va = Symbol.for("react.element"), $781b3e78c0ece49a$var$wa = Symbol.for("react.portal"), $781b3e78c0ece49a$var$ya = Symbol.for("react.fragment"), $781b3e78c0ece49a$var$za = Symbol.for("react.strict_mode"), $781b3e78c0ece49a$var$Aa = Symbol.for("react.profiler"), $781b3e78c0ece49a$var$Ba = Symbol.for("react.provider"), $781b3e78c0ece49a$var$Ca = Symbol.for("react.context"), $781b3e78c0ece49a$var$Da = Symbol.for("react.forward_ref"), $781b3e78c0ece49a$var$Ea = Symbol.for("react.suspense"), $781b3e78c0ece49a$var$Fa = Symbol.for("react.suspense_list"), $781b3e78c0ece49a$var$Ga = Symbol.for("react.memo"), $781b3e78c0ece49a$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $781b3e78c0ece49a$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $781b3e78c0ece49a$var$Ja = Symbol.iterator;
function $781b3e78c0ece49a$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $781b3e78c0ece49a$var$Ja && a[$781b3e78c0ece49a$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $781b3e78c0ece49a$var$A = Object.assign, $781b3e78c0ece49a$var$La;
function $781b3e78c0ece49a$var$Ma(a) {
    if (void 0 === $781b3e78c0ece49a$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $781b3e78c0ece49a$var$La = b && b[1] || "";
    }
    return "\n" + $781b3e78c0ece49a$var$La + a;
}
var $781b3e78c0ece49a$var$Na = !1;
function $781b3e78c0ece49a$var$Oa(a, b) {
    if (!a || $781b3e78c0ece49a$var$Na) return "";
    $781b3e78c0ece49a$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $781b3e78c0ece49a$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $781b3e78c0ece49a$var$Ma(a) : "";
}
function $781b3e78c0ece49a$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $781b3e78c0ece49a$var$Ma(a.type);
        case 16:
            return $781b3e78c0ece49a$var$Ma("Lazy");
        case 13:
            return $781b3e78c0ece49a$var$Ma("Suspense");
        case 19:
            return $781b3e78c0ece49a$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $781b3e78c0ece49a$var$Oa(a.type, !1), a;
        case 11:
            return a = $781b3e78c0ece49a$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $781b3e78c0ece49a$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $781b3e78c0ece49a$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $781b3e78c0ece49a$var$ya:
            return "Fragment";
        case $781b3e78c0ece49a$var$wa:
            return "Portal";
        case $781b3e78c0ece49a$var$Aa:
            return "Profiler";
        case $781b3e78c0ece49a$var$za:
            return "StrictMode";
        case $781b3e78c0ece49a$var$Ea:
            return "Suspense";
        case $781b3e78c0ece49a$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $781b3e78c0ece49a$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $781b3e78c0ece49a$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $781b3e78c0ece49a$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $781b3e78c0ece49a$var$Ga:
            return b = a.displayName || null, null !== b ? b : $781b3e78c0ece49a$var$Qa(a.type) || "Memo";
        case $781b3e78c0ece49a$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $781b3e78c0ece49a$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $781b3e78c0ece49a$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $781b3e78c0ece49a$var$Qa(b);
        case 8:
            return b === $781b3e78c0ece49a$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $781b3e78c0ece49a$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $781b3e78c0ece49a$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $781b3e78c0ece49a$var$Ua(a) {
    var b = $781b3e78c0ece49a$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $781b3e78c0ece49a$var$Va(a) {
    a._valueTracker || (a._valueTracker = $781b3e78c0ece49a$var$Ua(a));
}
function $781b3e78c0ece49a$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $781b3e78c0ece49a$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $781b3e78c0ece49a$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $781b3e78c0ece49a$var$Ya(a, b) {
    var c = b.checked;
    return $781b3e78c0ece49a$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $781b3e78c0ece49a$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $781b3e78c0ece49a$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $781b3e78c0ece49a$var$ab(a, b) {
    b = b.checked;
    null != b && $781b3e78c0ece49a$var$ta(a, "checked", b, !1);
}
function $781b3e78c0ece49a$var$bb(a, b) {
    $781b3e78c0ece49a$var$ab(a, b);
    var c = $781b3e78c0ece49a$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $781b3e78c0ece49a$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $781b3e78c0ece49a$var$cb(a, b.type, $781b3e78c0ece49a$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $781b3e78c0ece49a$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $781b3e78c0ece49a$var$cb(a, b, c) {
    if ("number" !== b || $781b3e78c0ece49a$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $781b3e78c0ece49a$var$eb = Array.isArray;
function $781b3e78c0ece49a$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $781b3e78c0ece49a$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $781b3e78c0ece49a$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($781b3e78c0ece49a$var$p(91));
    return $781b3e78c0ece49a$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $781b3e78c0ece49a$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($781b3e78c0ece49a$var$p(92));
            if ($781b3e78c0ece49a$var$eb(c)) {
                if (1 < c.length) throw Error($781b3e78c0ece49a$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $781b3e78c0ece49a$var$Sa(c)
    };
}
function $781b3e78c0ece49a$var$ib(a, b) {
    var c = $781b3e78c0ece49a$var$Sa(b.value), d = $781b3e78c0ece49a$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $781b3e78c0ece49a$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $781b3e78c0ece49a$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $781b3e78c0ece49a$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $781b3e78c0ece49a$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $781b3e78c0ece49a$var$mb, $781b3e78c0ece49a$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $781b3e78c0ece49a$var$mb = $781b3e78c0ece49a$var$mb || document.createElement("div");
        $781b3e78c0ece49a$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $781b3e78c0ece49a$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $781b3e78c0ece49a$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $781b3e78c0ece49a$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $781b3e78c0ece49a$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($781b3e78c0ece49a$var$pb).forEach(function(a) {
    $781b3e78c0ece49a$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $781b3e78c0ece49a$var$pb[b] = $781b3e78c0ece49a$var$pb[a];
    });
});
function $781b3e78c0ece49a$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $781b3e78c0ece49a$var$pb.hasOwnProperty(a) && $781b3e78c0ece49a$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $781b3e78c0ece49a$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $781b3e78c0ece49a$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $781b3e78c0ece49a$var$tb = $781b3e78c0ece49a$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $781b3e78c0ece49a$var$ub(a, b) {
    if (b) {
        if ($781b3e78c0ece49a$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($781b3e78c0ece49a$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($781b3e78c0ece49a$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($781b3e78c0ece49a$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($781b3e78c0ece49a$var$p(62));
    }
}
function $781b3e78c0ece49a$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $781b3e78c0ece49a$var$wb = null;
function $781b3e78c0ece49a$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $781b3e78c0ece49a$var$yb = null, $781b3e78c0ece49a$var$zb = null, $781b3e78c0ece49a$var$Ab = null;
function $781b3e78c0ece49a$var$Bb(a) {
    if (a = $781b3e78c0ece49a$var$Cb(a)) {
        if ("function" !== typeof $781b3e78c0ece49a$var$yb) throw Error($781b3e78c0ece49a$var$p(280));
        var b = a.stateNode;
        b && (b = $781b3e78c0ece49a$var$Db(b), $781b3e78c0ece49a$var$yb(a.stateNode, a.type, b));
    }
}
function $781b3e78c0ece49a$var$Eb(a) {
    $781b3e78c0ece49a$var$zb ? $781b3e78c0ece49a$var$Ab ? $781b3e78c0ece49a$var$Ab.push(a) : $781b3e78c0ece49a$var$Ab = [
        a
    ] : $781b3e78c0ece49a$var$zb = a;
}
function $781b3e78c0ece49a$var$Fb() {
    if ($781b3e78c0ece49a$var$zb) {
        var a = $781b3e78c0ece49a$var$zb, b = $781b3e78c0ece49a$var$Ab;
        $781b3e78c0ece49a$var$Ab = $781b3e78c0ece49a$var$zb = null;
        $781b3e78c0ece49a$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$781b3e78c0ece49a$var$Bb(b[a]);
    }
}
function $781b3e78c0ece49a$var$Gb(a, b) {
    return a(b);
}
function $781b3e78c0ece49a$var$Hb() {}
var $781b3e78c0ece49a$var$Ib = !1;
function $781b3e78c0ece49a$var$Jb(a, b, c) {
    if ($781b3e78c0ece49a$var$Ib) return a(b, c);
    $781b3e78c0ece49a$var$Ib = !0;
    try {
        return $781b3e78c0ece49a$var$Gb(a, b, c);
    } finally{
        if ($781b3e78c0ece49a$var$Ib = !1, null !== $781b3e78c0ece49a$var$zb || null !== $781b3e78c0ece49a$var$Ab) $781b3e78c0ece49a$var$Hb(), $781b3e78c0ece49a$var$Fb();
    }
}
function $781b3e78c0ece49a$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $781b3e78c0ece49a$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($781b3e78c0ece49a$var$p(231, b, typeof c));
    return c;
}
var $781b3e78c0ece49a$var$Lb = !1;
if ($781b3e78c0ece49a$var$ia) try {
    var $781b3e78c0ece49a$var$Mb = {};
    Object.defineProperty($781b3e78c0ece49a$var$Mb, "passive", {
        get: function() {
            $781b3e78c0ece49a$var$Lb = !0;
        }
    });
    window.addEventListener("test", $781b3e78c0ece49a$var$Mb, $781b3e78c0ece49a$var$Mb);
    window.removeEventListener("test", $781b3e78c0ece49a$var$Mb, $781b3e78c0ece49a$var$Mb);
} catch (a) {
    $781b3e78c0ece49a$var$Lb = !1;
}
function $781b3e78c0ece49a$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $781b3e78c0ece49a$var$Ob = !1, $781b3e78c0ece49a$var$Pb = null, $781b3e78c0ece49a$var$Qb = !1, $781b3e78c0ece49a$var$Rb = null, $781b3e78c0ece49a$var$Sb = {
    onError: function(a) {
        $781b3e78c0ece49a$var$Ob = !0;
        $781b3e78c0ece49a$var$Pb = a;
    }
};
function $781b3e78c0ece49a$var$Tb(a, b, c, d, e, f, g, h, k) {
    $781b3e78c0ece49a$var$Ob = !1;
    $781b3e78c0ece49a$var$Pb = null;
    $781b3e78c0ece49a$var$Nb.apply($781b3e78c0ece49a$var$Sb, arguments);
}
function $781b3e78c0ece49a$var$Ub(a, b, c, d, e, f, g, h, k) {
    $781b3e78c0ece49a$var$Tb.apply(this, arguments);
    if ($781b3e78c0ece49a$var$Ob) {
        if ($781b3e78c0ece49a$var$Ob) {
            var l = $781b3e78c0ece49a$var$Pb;
            $781b3e78c0ece49a$var$Ob = !1;
            $781b3e78c0ece49a$var$Pb = null;
        } else throw Error($781b3e78c0ece49a$var$p(198));
        $781b3e78c0ece49a$var$Qb || ($781b3e78c0ece49a$var$Qb = !0, $781b3e78c0ece49a$var$Rb = l);
    }
}
function $781b3e78c0ece49a$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $781b3e78c0ece49a$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $781b3e78c0ece49a$var$Xb(a) {
    if ($781b3e78c0ece49a$var$Vb(a) !== a) throw Error($781b3e78c0ece49a$var$p(188));
}
function $781b3e78c0ece49a$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $781b3e78c0ece49a$var$Vb(a);
        if (null === b) throw Error($781b3e78c0ece49a$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $781b3e78c0ece49a$var$Xb(e), a;
                if (f === d) return $781b3e78c0ece49a$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($781b3e78c0ece49a$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($781b3e78c0ece49a$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($781b3e78c0ece49a$var$p(190));
    }
    if (3 !== c.tag) throw Error($781b3e78c0ece49a$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $781b3e78c0ece49a$var$Zb(a) {
    a = $781b3e78c0ece49a$var$Yb(a);
    return null !== a ? $781b3e78c0ece49a$var$$b(a) : null;
}
function $781b3e78c0ece49a$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $781b3e78c0ece49a$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $781b3e78c0ece49a$var$ac = $f2Ki7.unstable_scheduleCallback, $781b3e78c0ece49a$var$bc = $f2Ki7.unstable_cancelCallback, $781b3e78c0ece49a$var$cc = $f2Ki7.unstable_shouldYield, $781b3e78c0ece49a$var$dc = $f2Ki7.unstable_requestPaint, $781b3e78c0ece49a$var$B = $f2Ki7.unstable_now, $781b3e78c0ece49a$var$ec = $f2Ki7.unstable_getCurrentPriorityLevel, $781b3e78c0ece49a$var$fc = $f2Ki7.unstable_ImmediatePriority, $781b3e78c0ece49a$var$gc = $f2Ki7.unstable_UserBlockingPriority, $781b3e78c0ece49a$var$hc = $f2Ki7.unstable_NormalPriority, $781b3e78c0ece49a$var$ic = $f2Ki7.unstable_LowPriority, $781b3e78c0ece49a$var$jc = $f2Ki7.unstable_IdlePriority, $781b3e78c0ece49a$var$kc = null, $781b3e78c0ece49a$var$lc = null;
function $781b3e78c0ece49a$var$mc(a) {
    if ($781b3e78c0ece49a$var$lc && "function" === typeof $781b3e78c0ece49a$var$lc.onCommitFiberRoot) try {
        $781b3e78c0ece49a$var$lc.onCommitFiberRoot($781b3e78c0ece49a$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $781b3e78c0ece49a$var$oc = Math.clz32 ? Math.clz32 : $781b3e78c0ece49a$var$nc, $781b3e78c0ece49a$var$pc = Math.log, $781b3e78c0ece49a$var$qc = Math.LN2;
function $781b3e78c0ece49a$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($781b3e78c0ece49a$var$pc(a) / $781b3e78c0ece49a$var$qc | 0) | 0;
}
var $781b3e78c0ece49a$var$rc = 64, $781b3e78c0ece49a$var$sc = 4194304;
function $781b3e78c0ece49a$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $781b3e78c0ece49a$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $781b3e78c0ece49a$var$tc(h) : (f &= g, 0 !== f && (d = $781b3e78c0ece49a$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $781b3e78c0ece49a$var$tc(g) : 0 !== f && (d = $781b3e78c0ece49a$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $781b3e78c0ece49a$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $781b3e78c0ece49a$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $781b3e78c0ece49a$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $781b3e78c0ece49a$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $781b3e78c0ece49a$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $781b3e78c0ece49a$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $781b3e78c0ece49a$var$yc() {
    var a = $781b3e78c0ece49a$var$rc;
    $781b3e78c0ece49a$var$rc <<= 1;
    0 === ($781b3e78c0ece49a$var$rc & 4194240) && ($781b3e78c0ece49a$var$rc = 64);
    return a;
}
function $781b3e78c0ece49a$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $781b3e78c0ece49a$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $781b3e78c0ece49a$var$oc(b);
    a[b] = c;
}
function $781b3e78c0ece49a$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $781b3e78c0ece49a$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $781b3e78c0ece49a$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $781b3e78c0ece49a$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $781b3e78c0ece49a$var$C = 0;
function $781b3e78c0ece49a$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $781b3e78c0ece49a$var$Ec, $781b3e78c0ece49a$var$Fc, $781b3e78c0ece49a$var$Gc, $781b3e78c0ece49a$var$Hc, $781b3e78c0ece49a$var$Ic, $781b3e78c0ece49a$var$Jc = !1, $781b3e78c0ece49a$var$Kc = [], $781b3e78c0ece49a$var$Lc = null, $781b3e78c0ece49a$var$Mc = null, $781b3e78c0ece49a$var$Nc = null, $781b3e78c0ece49a$var$Oc = new Map, $781b3e78c0ece49a$var$Pc = new Map, $781b3e78c0ece49a$var$Qc = [], $781b3e78c0ece49a$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $781b3e78c0ece49a$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $781b3e78c0ece49a$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $781b3e78c0ece49a$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $781b3e78c0ece49a$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $781b3e78c0ece49a$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $781b3e78c0ece49a$var$Pc.delete(b.pointerId);
    }
}
function $781b3e78c0ece49a$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $781b3e78c0ece49a$var$Cb(b), null !== b && $781b3e78c0ece49a$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $781b3e78c0ece49a$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $781b3e78c0ece49a$var$Lc = $781b3e78c0ece49a$var$Tc($781b3e78c0ece49a$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $781b3e78c0ece49a$var$Mc = $781b3e78c0ece49a$var$Tc($781b3e78c0ece49a$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $781b3e78c0ece49a$var$Nc = $781b3e78c0ece49a$var$Tc($781b3e78c0ece49a$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $781b3e78c0ece49a$var$Oc.set(f, $781b3e78c0ece49a$var$Tc($781b3e78c0ece49a$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $781b3e78c0ece49a$var$Pc.set(f, $781b3e78c0ece49a$var$Tc($781b3e78c0ece49a$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $781b3e78c0ece49a$var$Vc(a) {
    var b = $781b3e78c0ece49a$var$Wc(a.target);
    if (null !== b) {
        var c = $781b3e78c0ece49a$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $781b3e78c0ece49a$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $781b3e78c0ece49a$var$Ic(a.priority, function() {
                        $781b3e78c0ece49a$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $781b3e78c0ece49a$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $781b3e78c0ece49a$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $781b3e78c0ece49a$var$wb = d;
            c.target.dispatchEvent(d);
            $781b3e78c0ece49a$var$wb = null;
        } else return b = $781b3e78c0ece49a$var$Cb(c), null !== b && $781b3e78c0ece49a$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $781b3e78c0ece49a$var$Zc(a, b, c) {
    $781b3e78c0ece49a$var$Xc(a) && c.delete(b);
}
function $781b3e78c0ece49a$var$$c() {
    $781b3e78c0ece49a$var$Jc = !1;
    null !== $781b3e78c0ece49a$var$Lc && $781b3e78c0ece49a$var$Xc($781b3e78c0ece49a$var$Lc) && ($781b3e78c0ece49a$var$Lc = null);
    null !== $781b3e78c0ece49a$var$Mc && $781b3e78c0ece49a$var$Xc($781b3e78c0ece49a$var$Mc) && ($781b3e78c0ece49a$var$Mc = null);
    null !== $781b3e78c0ece49a$var$Nc && $781b3e78c0ece49a$var$Xc($781b3e78c0ece49a$var$Nc) && ($781b3e78c0ece49a$var$Nc = null);
    $781b3e78c0ece49a$var$Oc.forEach($781b3e78c0ece49a$var$Zc);
    $781b3e78c0ece49a$var$Pc.forEach($781b3e78c0ece49a$var$Zc);
}
function $781b3e78c0ece49a$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $781b3e78c0ece49a$var$Jc || ($781b3e78c0ece49a$var$Jc = !0, $f2Ki7.unstable_scheduleCallback($f2Ki7.unstable_NormalPriority, $781b3e78c0ece49a$var$$c)));
}
function $781b3e78c0ece49a$var$bd(a) {
    function b(b) {
        return $781b3e78c0ece49a$var$ad(b, a);
    }
    if (0 < $781b3e78c0ece49a$var$Kc.length) {
        $781b3e78c0ece49a$var$ad($781b3e78c0ece49a$var$Kc[0], a);
        for(var c = 1; c < $781b3e78c0ece49a$var$Kc.length; c++){
            var d = $781b3e78c0ece49a$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $781b3e78c0ece49a$var$Lc && $781b3e78c0ece49a$var$ad($781b3e78c0ece49a$var$Lc, a);
    null !== $781b3e78c0ece49a$var$Mc && $781b3e78c0ece49a$var$ad($781b3e78c0ece49a$var$Mc, a);
    null !== $781b3e78c0ece49a$var$Nc && $781b3e78c0ece49a$var$ad($781b3e78c0ece49a$var$Nc, a);
    $781b3e78c0ece49a$var$Oc.forEach(b);
    $781b3e78c0ece49a$var$Pc.forEach(b);
    for(c = 0; c < $781b3e78c0ece49a$var$Qc.length; c++)d = $781b3e78c0ece49a$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $781b3e78c0ece49a$var$Qc.length && (c = $781b3e78c0ece49a$var$Qc[0], null === c.blockedOn);)$781b3e78c0ece49a$var$Vc(c), null === c.blockedOn && $781b3e78c0ece49a$var$Qc.shift();
}
var $781b3e78c0ece49a$var$cd = $781b3e78c0ece49a$var$ua.ReactCurrentBatchConfig, $781b3e78c0ece49a$var$dd = !0;
function $781b3e78c0ece49a$var$ed(a, b, c, d) {
    var e = $781b3e78c0ece49a$var$C, f = $781b3e78c0ece49a$var$cd.transition;
    $781b3e78c0ece49a$var$cd.transition = null;
    try {
        $781b3e78c0ece49a$var$C = 1, $781b3e78c0ece49a$var$fd(a, b, c, d);
    } finally{
        $781b3e78c0ece49a$var$C = e, $781b3e78c0ece49a$var$cd.transition = f;
    }
}
function $781b3e78c0ece49a$var$gd(a, b, c, d) {
    var e = $781b3e78c0ece49a$var$C, f = $781b3e78c0ece49a$var$cd.transition;
    $781b3e78c0ece49a$var$cd.transition = null;
    try {
        $781b3e78c0ece49a$var$C = 4, $781b3e78c0ece49a$var$fd(a, b, c, d);
    } finally{
        $781b3e78c0ece49a$var$C = e, $781b3e78c0ece49a$var$cd.transition = f;
    }
}
function $781b3e78c0ece49a$var$fd(a, b, c, d) {
    if ($781b3e78c0ece49a$var$dd) {
        var e = $781b3e78c0ece49a$var$Yc(a, b, c, d);
        if (null === e) $781b3e78c0ece49a$var$hd(a, b, d, $781b3e78c0ece49a$var$id, c), $781b3e78c0ece49a$var$Sc(a, d);
        else if ($781b3e78c0ece49a$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($781b3e78c0ece49a$var$Sc(a, d), b & 4 && -1 < $781b3e78c0ece49a$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $781b3e78c0ece49a$var$Cb(e);
                null !== f && $781b3e78c0ece49a$var$Ec(f);
                f = $781b3e78c0ece49a$var$Yc(a, b, c, d);
                null === f && $781b3e78c0ece49a$var$hd(a, b, d, $781b3e78c0ece49a$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $781b3e78c0ece49a$var$hd(a, b, d, null, c);
    }
}
var $781b3e78c0ece49a$var$id = null;
function $781b3e78c0ece49a$var$Yc(a, b, c, d) {
    $781b3e78c0ece49a$var$id = null;
    a = $781b3e78c0ece49a$var$xb(d);
    a = $781b3e78c0ece49a$var$Wc(a);
    if (null !== a) {
        if (b = $781b3e78c0ece49a$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $781b3e78c0ece49a$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $781b3e78c0ece49a$var$id = a;
    return null;
}
function $781b3e78c0ece49a$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($781b3e78c0ece49a$var$ec()){
                case $781b3e78c0ece49a$var$fc:
                    return 1;
                case $781b3e78c0ece49a$var$gc:
                    return 4;
                case $781b3e78c0ece49a$var$hc:
                case $781b3e78c0ece49a$var$ic:
                    return 16;
                case $781b3e78c0ece49a$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $781b3e78c0ece49a$var$kd = null, $781b3e78c0ece49a$var$ld = null, $781b3e78c0ece49a$var$md = null;
function $781b3e78c0ece49a$var$nd() {
    if ($781b3e78c0ece49a$var$md) return $781b3e78c0ece49a$var$md;
    var a, b = $781b3e78c0ece49a$var$ld, c = b.length, d, e = "value" in $781b3e78c0ece49a$var$kd ? $781b3e78c0ece49a$var$kd.value : $781b3e78c0ece49a$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $781b3e78c0ece49a$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $781b3e78c0ece49a$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $781b3e78c0ece49a$var$pd() {
    return !0;
}
function $781b3e78c0ece49a$var$qd() {
    return !1;
}
function $781b3e78c0ece49a$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $781b3e78c0ece49a$var$pd : $781b3e78c0ece49a$var$qd;
        this.isPropagationStopped = $781b3e78c0ece49a$var$qd;
        return this;
    }
    $781b3e78c0ece49a$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $781b3e78c0ece49a$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $781b3e78c0ece49a$var$pd);
        },
        persist: function() {},
        isPersistent: $781b3e78c0ece49a$var$pd
    });
    return b;
}
var $781b3e78c0ece49a$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $781b3e78c0ece49a$var$td = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$sd), $781b3e78c0ece49a$var$ud = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$sd, {
    view: 0,
    detail: 0
}), $781b3e78c0ece49a$var$vd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$ud), $781b3e78c0ece49a$var$wd, $781b3e78c0ece49a$var$xd, $781b3e78c0ece49a$var$yd, $781b3e78c0ece49a$var$Ad = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $781b3e78c0ece49a$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $781b3e78c0ece49a$var$yd && ($781b3e78c0ece49a$var$yd && "mousemove" === a.type ? ($781b3e78c0ece49a$var$wd = a.screenX - $781b3e78c0ece49a$var$yd.screenX, $781b3e78c0ece49a$var$xd = a.screenY - $781b3e78c0ece49a$var$yd.screenY) : $781b3e78c0ece49a$var$xd = $781b3e78c0ece49a$var$wd = 0, $781b3e78c0ece49a$var$yd = a);
        return $781b3e78c0ece49a$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $781b3e78c0ece49a$var$xd;
    }
}), $781b3e78c0ece49a$var$Bd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Ad), $781b3e78c0ece49a$var$Cd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$Ad, {
    dataTransfer: 0
}), $781b3e78c0ece49a$var$Dd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Cd), $781b3e78c0ece49a$var$Ed = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$ud, {
    relatedTarget: 0
}), $781b3e78c0ece49a$var$Fd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Ed), $781b3e78c0ece49a$var$Gd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $781b3e78c0ece49a$var$Hd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Gd), $781b3e78c0ece49a$var$Id = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $781b3e78c0ece49a$var$Jd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Id), $781b3e78c0ece49a$var$Kd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$sd, {
    data: 0
}), $781b3e78c0ece49a$var$Ld = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Kd), $781b3e78c0ece49a$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $781b3e78c0ece49a$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $781b3e78c0ece49a$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $781b3e78c0ece49a$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $781b3e78c0ece49a$var$Od[a]) ? !!b[a] : !1;
}
function $781b3e78c0ece49a$var$zd() {
    return $781b3e78c0ece49a$var$Pd;
}
var $781b3e78c0ece49a$var$Qd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $781b3e78c0ece49a$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $781b3e78c0ece49a$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $781b3e78c0ece49a$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $781b3e78c0ece49a$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $781b3e78c0ece49a$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $781b3e78c0ece49a$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $781b3e78c0ece49a$var$Rd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Qd), $781b3e78c0ece49a$var$Sd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $781b3e78c0ece49a$var$Td = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Sd), $781b3e78c0ece49a$var$Ud = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $781b3e78c0ece49a$var$zd
}), $781b3e78c0ece49a$var$Vd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Ud), $781b3e78c0ece49a$var$Wd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $781b3e78c0ece49a$var$Xd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Wd), $781b3e78c0ece49a$var$Yd = $781b3e78c0ece49a$var$A({}, $781b3e78c0ece49a$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $781b3e78c0ece49a$var$Zd = $781b3e78c0ece49a$var$rd($781b3e78c0ece49a$var$Yd), $781b3e78c0ece49a$var$$d = [
    9,
    13,
    27,
    32
], $781b3e78c0ece49a$var$ae = $781b3e78c0ece49a$var$ia && "CompositionEvent" in window, $781b3e78c0ece49a$var$be = null;
$781b3e78c0ece49a$var$ia && "documentMode" in document && ($781b3e78c0ece49a$var$be = document.documentMode);
var $781b3e78c0ece49a$var$ce = $781b3e78c0ece49a$var$ia && "TextEvent" in window && !$781b3e78c0ece49a$var$be, $781b3e78c0ece49a$var$de = $781b3e78c0ece49a$var$ia && (!$781b3e78c0ece49a$var$ae || $781b3e78c0ece49a$var$be && 8 < $781b3e78c0ece49a$var$be && 11 >= $781b3e78c0ece49a$var$be), $781b3e78c0ece49a$var$ee = String.fromCharCode(32), $781b3e78c0ece49a$var$fe = !1;
function $781b3e78c0ece49a$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $781b3e78c0ece49a$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $781b3e78c0ece49a$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $781b3e78c0ece49a$var$ie = !1;
function $781b3e78c0ece49a$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $781b3e78c0ece49a$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $781b3e78c0ece49a$var$fe = !0;
            return $781b3e78c0ece49a$var$ee;
        case "textInput":
            return a = b.data, a === $781b3e78c0ece49a$var$ee && $781b3e78c0ece49a$var$fe ? null : a;
        default:
            return null;
    }
}
function $781b3e78c0ece49a$var$ke(a, b) {
    if ($781b3e78c0ece49a$var$ie) return "compositionend" === a || !$781b3e78c0ece49a$var$ae && $781b3e78c0ece49a$var$ge(a, b) ? (a = $781b3e78c0ece49a$var$nd(), $781b3e78c0ece49a$var$md = $781b3e78c0ece49a$var$ld = $781b3e78c0ece49a$var$kd = null, $781b3e78c0ece49a$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $781b3e78c0ece49a$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $781b3e78c0ece49a$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $781b3e78c0ece49a$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$781b3e78c0ece49a$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $781b3e78c0ece49a$var$ne(a, b, c, d) {
    $781b3e78c0ece49a$var$Eb(d);
    b = $781b3e78c0ece49a$var$oe(b, "onChange");
    0 < b.length && (c = new $781b3e78c0ece49a$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $781b3e78c0ece49a$var$pe = null, $781b3e78c0ece49a$var$qe = null;
function $781b3e78c0ece49a$var$re(a) {
    $781b3e78c0ece49a$var$se(a, 0);
}
function $781b3e78c0ece49a$var$te(a) {
    var b = $781b3e78c0ece49a$var$ue(a);
    if ($781b3e78c0ece49a$var$Wa(b)) return a;
}
function $781b3e78c0ece49a$var$ve(a, b) {
    if ("change" === a) return b;
}
var $781b3e78c0ece49a$var$we = !1;
if ($781b3e78c0ece49a$var$ia) {
    var $781b3e78c0ece49a$var$xe;
    if ($781b3e78c0ece49a$var$ia) {
        var $781b3e78c0ece49a$var$ye = "oninput" in document;
        if (!$781b3e78c0ece49a$var$ye) {
            var $781b3e78c0ece49a$var$ze = document.createElement("div");
            $781b3e78c0ece49a$var$ze.setAttribute("oninput", "return;");
            $781b3e78c0ece49a$var$ye = "function" === typeof $781b3e78c0ece49a$var$ze.oninput;
        }
        $781b3e78c0ece49a$var$xe = $781b3e78c0ece49a$var$ye;
    } else $781b3e78c0ece49a$var$xe = !1;
    $781b3e78c0ece49a$var$we = $781b3e78c0ece49a$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $781b3e78c0ece49a$var$Ae() {
    $781b3e78c0ece49a$var$pe && ($781b3e78c0ece49a$var$pe.detachEvent("onpropertychange", $781b3e78c0ece49a$var$Be), $781b3e78c0ece49a$var$qe = $781b3e78c0ece49a$var$pe = null);
}
function $781b3e78c0ece49a$var$Be(a) {
    if ("value" === a.propertyName && $781b3e78c0ece49a$var$te($781b3e78c0ece49a$var$qe)) {
        var b = [];
        $781b3e78c0ece49a$var$ne(b, $781b3e78c0ece49a$var$qe, a, $781b3e78c0ece49a$var$xb(a));
        $781b3e78c0ece49a$var$Jb($781b3e78c0ece49a$var$re, b);
    }
}
function $781b3e78c0ece49a$var$Ce(a, b, c) {
    "focusin" === a ? ($781b3e78c0ece49a$var$Ae(), $781b3e78c0ece49a$var$pe = b, $781b3e78c0ece49a$var$qe = c, $781b3e78c0ece49a$var$pe.attachEvent("onpropertychange", $781b3e78c0ece49a$var$Be)) : "focusout" === a && $781b3e78c0ece49a$var$Ae();
}
function $781b3e78c0ece49a$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $781b3e78c0ece49a$var$te($781b3e78c0ece49a$var$qe);
}
function $781b3e78c0ece49a$var$Ee(a, b) {
    if ("click" === a) return $781b3e78c0ece49a$var$te(b);
}
function $781b3e78c0ece49a$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $781b3e78c0ece49a$var$te(b);
}
function $781b3e78c0ece49a$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $781b3e78c0ece49a$var$He = "function" === typeof Object.is ? Object.is : $781b3e78c0ece49a$var$Ge;
function $781b3e78c0ece49a$var$Ie(a, b) {
    if ($781b3e78c0ece49a$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$781b3e78c0ece49a$var$ja.call(b, e) || !$781b3e78c0ece49a$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $781b3e78c0ece49a$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $781b3e78c0ece49a$var$Ke(a, b) {
    var c = $781b3e78c0ece49a$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $781b3e78c0ece49a$var$Je(c);
    }
}
function $781b3e78c0ece49a$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $781b3e78c0ece49a$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $781b3e78c0ece49a$var$Me() {
    for(var a = window, b = $781b3e78c0ece49a$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $781b3e78c0ece49a$var$Xa(a.document);
    }
    return b;
}
function $781b3e78c0ece49a$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $781b3e78c0ece49a$var$Oe(a) {
    var b = $781b3e78c0ece49a$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $781b3e78c0ece49a$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $781b3e78c0ece49a$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $781b3e78c0ece49a$var$Ke(c, f);
                var g = $781b3e78c0ece49a$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $781b3e78c0ece49a$var$Pe = $781b3e78c0ece49a$var$ia && "documentMode" in document && 11 >= document.documentMode, $781b3e78c0ece49a$var$Qe = null, $781b3e78c0ece49a$var$Re = null, $781b3e78c0ece49a$var$Se = null, $781b3e78c0ece49a$var$Te = !1;
function $781b3e78c0ece49a$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $781b3e78c0ece49a$var$Te || null == $781b3e78c0ece49a$var$Qe || $781b3e78c0ece49a$var$Qe !== $781b3e78c0ece49a$var$Xa(d) || (d = $781b3e78c0ece49a$var$Qe, "selectionStart" in d && $781b3e78c0ece49a$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $781b3e78c0ece49a$var$Se && $781b3e78c0ece49a$var$Ie($781b3e78c0ece49a$var$Se, d) || ($781b3e78c0ece49a$var$Se = d, d = $781b3e78c0ece49a$var$oe($781b3e78c0ece49a$var$Re, "onSelect"), 0 < d.length && (b = new $781b3e78c0ece49a$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $781b3e78c0ece49a$var$Qe)));
}
function $781b3e78c0ece49a$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $781b3e78c0ece49a$var$We = {
    animationend: $781b3e78c0ece49a$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $781b3e78c0ece49a$var$Ve("Animation", "AnimationIteration"),
    animationstart: $781b3e78c0ece49a$var$Ve("Animation", "AnimationStart"),
    transitionend: $781b3e78c0ece49a$var$Ve("Transition", "TransitionEnd")
}, $781b3e78c0ece49a$var$Xe = {}, $781b3e78c0ece49a$var$Ye = {};
$781b3e78c0ece49a$var$ia && ($781b3e78c0ece49a$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $781b3e78c0ece49a$var$We.animationend.animation, delete $781b3e78c0ece49a$var$We.animationiteration.animation, delete $781b3e78c0ece49a$var$We.animationstart.animation), "TransitionEvent" in window || delete $781b3e78c0ece49a$var$We.transitionend.transition);
function $781b3e78c0ece49a$var$Ze(a) {
    if ($781b3e78c0ece49a$var$Xe[a]) return $781b3e78c0ece49a$var$Xe[a];
    if (!$781b3e78c0ece49a$var$We[a]) return a;
    var b = $781b3e78c0ece49a$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $781b3e78c0ece49a$var$Ye) return $781b3e78c0ece49a$var$Xe[a] = b[c];
    return a;
}
var $781b3e78c0ece49a$var$$e = $781b3e78c0ece49a$var$Ze("animationend"), $781b3e78c0ece49a$var$af = $781b3e78c0ece49a$var$Ze("animationiteration"), $781b3e78c0ece49a$var$bf = $781b3e78c0ece49a$var$Ze("animationstart"), $781b3e78c0ece49a$var$cf = $781b3e78c0ece49a$var$Ze("transitionend"), $781b3e78c0ece49a$var$df = new Map, $781b3e78c0ece49a$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $781b3e78c0ece49a$var$ff(a, b) {
    $781b3e78c0ece49a$var$df.set(a, b);
    $781b3e78c0ece49a$var$fa(b, [
        a
    ]);
}
for(var $781b3e78c0ece49a$var$gf = 0; $781b3e78c0ece49a$var$gf < $781b3e78c0ece49a$var$ef.length; $781b3e78c0ece49a$var$gf++){
    var $781b3e78c0ece49a$var$hf = $781b3e78c0ece49a$var$ef[$781b3e78c0ece49a$var$gf], $781b3e78c0ece49a$var$jf = $781b3e78c0ece49a$var$hf.toLowerCase(), $781b3e78c0ece49a$var$kf = $781b3e78c0ece49a$var$hf[0].toUpperCase() + $781b3e78c0ece49a$var$hf.slice(1);
    $781b3e78c0ece49a$var$ff($781b3e78c0ece49a$var$jf, "on" + $781b3e78c0ece49a$var$kf);
}
$781b3e78c0ece49a$var$ff($781b3e78c0ece49a$var$$e, "onAnimationEnd");
$781b3e78c0ece49a$var$ff($781b3e78c0ece49a$var$af, "onAnimationIteration");
$781b3e78c0ece49a$var$ff($781b3e78c0ece49a$var$bf, "onAnimationStart");
$781b3e78c0ece49a$var$ff("dblclick", "onDoubleClick");
$781b3e78c0ece49a$var$ff("focusin", "onFocus");
$781b3e78c0ece49a$var$ff("focusout", "onBlur");
$781b3e78c0ece49a$var$ff($781b3e78c0ece49a$var$cf, "onTransitionEnd");
$781b3e78c0ece49a$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$781b3e78c0ece49a$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$781b3e78c0ece49a$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$781b3e78c0ece49a$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$781b3e78c0ece49a$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$781b3e78c0ece49a$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$781b3e78c0ece49a$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$781b3e78c0ece49a$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$781b3e78c0ece49a$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$781b3e78c0ece49a$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $781b3e78c0ece49a$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $781b3e78c0ece49a$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($781b3e78c0ece49a$var$lf));
function $781b3e78c0ece49a$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $781b3e78c0ece49a$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $781b3e78c0ece49a$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $781b3e78c0ece49a$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $781b3e78c0ece49a$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($781b3e78c0ece49a$var$Qb) throw a = $781b3e78c0ece49a$var$Rb, $781b3e78c0ece49a$var$Qb = !1, $781b3e78c0ece49a$var$Rb = null, a;
}
function $781b3e78c0ece49a$var$D(a, b) {
    var c = b[$781b3e78c0ece49a$var$of];
    void 0 === c && (c = b[$781b3e78c0ece49a$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($781b3e78c0ece49a$var$pf(b, a, 2, !1), c.add(d));
}
function $781b3e78c0ece49a$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $781b3e78c0ece49a$var$pf(c, a, d, b);
}
var $781b3e78c0ece49a$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $781b3e78c0ece49a$var$sf(a) {
    if (!a[$781b3e78c0ece49a$var$rf]) {
        a[$781b3e78c0ece49a$var$rf] = !0;
        $781b3e78c0ece49a$var$da.forEach(function(b) {
            "selectionchange" !== b && ($781b3e78c0ece49a$var$mf.has(b) || $781b3e78c0ece49a$var$qf(b, !1, a), $781b3e78c0ece49a$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$781b3e78c0ece49a$var$rf] || (b[$781b3e78c0ece49a$var$rf] = !0, $781b3e78c0ece49a$var$qf("selectionchange", !1, b));
    }
}
function $781b3e78c0ece49a$var$pf(a, b, c, d) {
    switch($781b3e78c0ece49a$var$jd(b)){
        case 1:
            var e = $781b3e78c0ece49a$var$ed;
            break;
        case 4:
            e = $781b3e78c0ece49a$var$gd;
            break;
        default:
            e = $781b3e78c0ece49a$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$781b3e78c0ece49a$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $781b3e78c0ece49a$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $781b3e78c0ece49a$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $781b3e78c0ece49a$var$Jb(function() {
        var d = f, e = $781b3e78c0ece49a$var$xb(c), g = [];
        a: {
            var h = $781b3e78c0ece49a$var$df.get(a);
            if (void 0 !== h) {
                var k = $781b3e78c0ece49a$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $781b3e78c0ece49a$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $781b3e78c0ece49a$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $781b3e78c0ece49a$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $781b3e78c0ece49a$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $781b3e78c0ece49a$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $781b3e78c0ece49a$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $781b3e78c0ece49a$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $781b3e78c0ece49a$var$Vd;
                        break;
                    case $781b3e78c0ece49a$var$$e:
                    case $781b3e78c0ece49a$var$af:
                    case $781b3e78c0ece49a$var$bf:
                        k = $781b3e78c0ece49a$var$Hd;
                        break;
                    case $781b3e78c0ece49a$var$cf:
                        k = $781b3e78c0ece49a$var$Xd;
                        break;
                    case "scroll":
                        k = $781b3e78c0ece49a$var$vd;
                        break;
                    case "wheel":
                        k = $781b3e78c0ece49a$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $781b3e78c0ece49a$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $781b3e78c0ece49a$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $781b3e78c0ece49a$var$Kb(w, x), null != F && t.push($781b3e78c0ece49a$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $781b3e78c0ece49a$var$wb && (n = c.relatedTarget || c.fromElement) && ($781b3e78c0ece49a$var$Wc(n) || n[$781b3e78c0ece49a$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $781b3e78c0ece49a$var$Wc(n) : null, null !== n && (J = $781b3e78c0ece49a$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $781b3e78c0ece49a$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $781b3e78c0ece49a$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $781b3e78c0ece49a$var$ue(k);
                        u = null == n ? h : $781b3e78c0ece49a$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $781b3e78c0ece49a$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $781b3e78c0ece49a$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $781b3e78c0ece49a$var$vf(F))u++;
                            for(; 0 < w - u;)t = $781b3e78c0ece49a$var$vf(t), w--;
                            for(; 0 < u - w;)x = $781b3e78c0ece49a$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $781b3e78c0ece49a$var$vf(t);
                                x = $781b3e78c0ece49a$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $781b3e78c0ece49a$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $781b3e78c0ece49a$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $781b3e78c0ece49a$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $781b3e78c0ece49a$var$ve;
                else if ($781b3e78c0ece49a$var$me(h)) {
                    if ($781b3e78c0ece49a$var$we) na = $781b3e78c0ece49a$var$Fe;
                    else {
                        na = $781b3e78c0ece49a$var$De;
                        var xa = $781b3e78c0ece49a$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $781b3e78c0ece49a$var$Ee);
                if (na && (na = na(a, d))) {
                    $781b3e78c0ece49a$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $781b3e78c0ece49a$var$cb(h, "number", h.value);
            }
            xa = d ? $781b3e78c0ece49a$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($781b3e78c0ece49a$var$me(xa) || "true" === xa.contentEditable) $781b3e78c0ece49a$var$Qe = xa, $781b3e78c0ece49a$var$Re = d, $781b3e78c0ece49a$var$Se = null;
                    break;
                case "focusout":
                    $781b3e78c0ece49a$var$Se = $781b3e78c0ece49a$var$Re = $781b3e78c0ece49a$var$Qe = null;
                    break;
                case "mousedown":
                    $781b3e78c0ece49a$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $781b3e78c0ece49a$var$Te = !1;
                    $781b3e78c0ece49a$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($781b3e78c0ece49a$var$Pe) break;
                case "keydown":
                case "keyup":
                    $781b3e78c0ece49a$var$Ue(g, c, e);
            }
            var $a;
            if ($781b3e78c0ece49a$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $781b3e78c0ece49a$var$ie ? $781b3e78c0ece49a$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($781b3e78c0ece49a$var$de && "ko" !== c.locale && ($781b3e78c0ece49a$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $781b3e78c0ece49a$var$ie && ($a = $781b3e78c0ece49a$var$nd()) : ($781b3e78c0ece49a$var$kd = e, $781b3e78c0ece49a$var$ld = "value" in $781b3e78c0ece49a$var$kd ? $781b3e78c0ece49a$var$kd.value : $781b3e78c0ece49a$var$kd.textContent, $781b3e78c0ece49a$var$ie = !0)), xa = $781b3e78c0ece49a$var$oe(d, ba), 0 < xa.length && (ba = new $781b3e78c0ece49a$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $781b3e78c0ece49a$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $781b3e78c0ece49a$var$ce ? $781b3e78c0ece49a$var$je(a, c) : $781b3e78c0ece49a$var$ke(a, c)) d = $781b3e78c0ece49a$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $781b3e78c0ece49a$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $781b3e78c0ece49a$var$se(g, b);
    });
}
function $781b3e78c0ece49a$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $781b3e78c0ece49a$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $781b3e78c0ece49a$var$Kb(a, c), null != f && d.unshift($781b3e78c0ece49a$var$tf(a, f, e)), f = $781b3e78c0ece49a$var$Kb(a, b), null != f && d.push($781b3e78c0ece49a$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $781b3e78c0ece49a$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $781b3e78c0ece49a$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $781b3e78c0ece49a$var$Kb(c, f), null != k && g.unshift($781b3e78c0ece49a$var$tf(c, k, h))) : e || (k = $781b3e78c0ece49a$var$Kb(c, f), null != k && g.push($781b3e78c0ece49a$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $781b3e78c0ece49a$var$xf = /\r\n?/g, $781b3e78c0ece49a$var$yf = /\u0000|\uFFFD/g;
function $781b3e78c0ece49a$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($781b3e78c0ece49a$var$xf, "\n").replace($781b3e78c0ece49a$var$yf, "");
}
function $781b3e78c0ece49a$var$Af(a, b, c) {
    b = $781b3e78c0ece49a$var$zf(b);
    if ($781b3e78c0ece49a$var$zf(a) !== b && c) throw Error($781b3e78c0ece49a$var$p(425));
}
function $781b3e78c0ece49a$var$Bf() {}
var $781b3e78c0ece49a$var$Cf = null, $781b3e78c0ece49a$var$Df = null;
function $781b3e78c0ece49a$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $781b3e78c0ece49a$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $781b3e78c0ece49a$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $781b3e78c0ece49a$var$Hf = "function" === typeof Promise ? Promise : void 0, $781b3e78c0ece49a$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $781b3e78c0ece49a$var$Hf ? function(a) {
    return $781b3e78c0ece49a$var$Hf.resolve(null).then(a).catch($781b3e78c0ece49a$var$If);
} : $781b3e78c0ece49a$var$Ff;
function $781b3e78c0ece49a$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $781b3e78c0ece49a$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $781b3e78c0ece49a$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $781b3e78c0ece49a$var$bd(b);
}
function $781b3e78c0ece49a$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $781b3e78c0ece49a$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $781b3e78c0ece49a$var$Nf = Math.random().toString(36).slice(2), $781b3e78c0ece49a$var$Of = "__reactFiber$" + $781b3e78c0ece49a$var$Nf, $781b3e78c0ece49a$var$Pf = "__reactProps$" + $781b3e78c0ece49a$var$Nf, $781b3e78c0ece49a$var$uf = "__reactContainer$" + $781b3e78c0ece49a$var$Nf, $781b3e78c0ece49a$var$of = "__reactEvents$" + $781b3e78c0ece49a$var$Nf, $781b3e78c0ece49a$var$Qf = "__reactListeners$" + $781b3e78c0ece49a$var$Nf, $781b3e78c0ece49a$var$Rf = "__reactHandles$" + $781b3e78c0ece49a$var$Nf;
function $781b3e78c0ece49a$var$Wc(a) {
    var b = a[$781b3e78c0ece49a$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$781b3e78c0ece49a$var$uf] || c[$781b3e78c0ece49a$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $781b3e78c0ece49a$var$Mf(a); null !== a;){
                if (c = a[$781b3e78c0ece49a$var$Of]) return c;
                a = $781b3e78c0ece49a$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $781b3e78c0ece49a$var$Cb(a) {
    a = a[$781b3e78c0ece49a$var$Of] || a[$781b3e78c0ece49a$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $781b3e78c0ece49a$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($781b3e78c0ece49a$var$p(33));
}
function $781b3e78c0ece49a$var$Db(a) {
    return a[$781b3e78c0ece49a$var$Pf] || null;
}
var $781b3e78c0ece49a$var$Sf = [], $781b3e78c0ece49a$var$Tf = -1;
function $781b3e78c0ece49a$var$Uf(a) {
    return {
        current: a
    };
}
function $781b3e78c0ece49a$var$E(a) {
    0 > $781b3e78c0ece49a$var$Tf || (a.current = $781b3e78c0ece49a$var$Sf[$781b3e78c0ece49a$var$Tf], $781b3e78c0ece49a$var$Sf[$781b3e78c0ece49a$var$Tf] = null, $781b3e78c0ece49a$var$Tf--);
}
function $781b3e78c0ece49a$var$G(a, b) {
    $781b3e78c0ece49a$var$Tf++;
    $781b3e78c0ece49a$var$Sf[$781b3e78c0ece49a$var$Tf] = a.current;
    a.current = b;
}
var $781b3e78c0ece49a$var$Vf = {}, $781b3e78c0ece49a$var$H = $781b3e78c0ece49a$var$Uf($781b3e78c0ece49a$var$Vf), $781b3e78c0ece49a$var$Wf = $781b3e78c0ece49a$var$Uf(!1), $781b3e78c0ece49a$var$Xf = $781b3e78c0ece49a$var$Vf;
function $781b3e78c0ece49a$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $781b3e78c0ece49a$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $781b3e78c0ece49a$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $781b3e78c0ece49a$var$$f() {
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf);
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$H);
}
function $781b3e78c0ece49a$var$ag(a, b, c) {
    if ($781b3e78c0ece49a$var$H.current !== $781b3e78c0ece49a$var$Vf) throw Error($781b3e78c0ece49a$var$p(168));
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$H, b);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Wf, c);
}
function $781b3e78c0ece49a$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($781b3e78c0ece49a$var$p(108, $781b3e78c0ece49a$var$Ra(a) || "Unknown", e));
    return $781b3e78c0ece49a$var$A({}, c, d);
}
function $781b3e78c0ece49a$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $781b3e78c0ece49a$var$Vf;
    $781b3e78c0ece49a$var$Xf = $781b3e78c0ece49a$var$H.current;
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$H, a);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Wf, $781b3e78c0ece49a$var$Wf.current);
    return !0;
}
function $781b3e78c0ece49a$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($781b3e78c0ece49a$var$p(169));
    c ? (a = $781b3e78c0ece49a$var$bg(a, b, $781b3e78c0ece49a$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf), $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$H), $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$H, a)) : $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Wf, c);
}
var $781b3e78c0ece49a$var$eg = null, $781b3e78c0ece49a$var$fg = !1, $781b3e78c0ece49a$var$gg = !1;
function $781b3e78c0ece49a$var$hg(a) {
    null === $781b3e78c0ece49a$var$eg ? $781b3e78c0ece49a$var$eg = [
        a
    ] : $781b3e78c0ece49a$var$eg.push(a);
}
function $781b3e78c0ece49a$var$ig(a) {
    $781b3e78c0ece49a$var$fg = !0;
    $781b3e78c0ece49a$var$hg(a);
}
function $781b3e78c0ece49a$var$jg() {
    if (!$781b3e78c0ece49a$var$gg && null !== $781b3e78c0ece49a$var$eg) {
        $781b3e78c0ece49a$var$gg = !0;
        var a = 0, b = $781b3e78c0ece49a$var$C;
        try {
            var c = $781b3e78c0ece49a$var$eg;
            for($781b3e78c0ece49a$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $781b3e78c0ece49a$var$eg = null;
            $781b3e78c0ece49a$var$fg = !1;
        } catch (e) {
            throw null !== $781b3e78c0ece49a$var$eg && ($781b3e78c0ece49a$var$eg = $781b3e78c0ece49a$var$eg.slice(a + 1)), $781b3e78c0ece49a$var$ac($781b3e78c0ece49a$var$fc, $781b3e78c0ece49a$var$jg), e;
        } finally{
            $781b3e78c0ece49a$var$C = b, $781b3e78c0ece49a$var$gg = !1;
        }
    }
    return null;
}
var $781b3e78c0ece49a$var$kg = [], $781b3e78c0ece49a$var$lg = 0, $781b3e78c0ece49a$var$mg = null, $781b3e78c0ece49a$var$ng = 0, $781b3e78c0ece49a$var$og = [], $781b3e78c0ece49a$var$pg = 0, $781b3e78c0ece49a$var$qg = null, $781b3e78c0ece49a$var$rg = 1, $781b3e78c0ece49a$var$sg = "";
function $781b3e78c0ece49a$var$tg(a, b) {
    $781b3e78c0ece49a$var$kg[$781b3e78c0ece49a$var$lg++] = $781b3e78c0ece49a$var$ng;
    $781b3e78c0ece49a$var$kg[$781b3e78c0ece49a$var$lg++] = $781b3e78c0ece49a$var$mg;
    $781b3e78c0ece49a$var$mg = a;
    $781b3e78c0ece49a$var$ng = b;
}
function $781b3e78c0ece49a$var$ug(a, b, c) {
    $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$rg;
    $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$sg;
    $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$qg;
    $781b3e78c0ece49a$var$qg = a;
    var d = $781b3e78c0ece49a$var$rg;
    a = $781b3e78c0ece49a$var$sg;
    var e = 32 - $781b3e78c0ece49a$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $781b3e78c0ece49a$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $781b3e78c0ece49a$var$rg = 1 << 32 - $781b3e78c0ece49a$var$oc(b) + e | c << e | d;
        $781b3e78c0ece49a$var$sg = f + a;
    } else $781b3e78c0ece49a$var$rg = 1 << f | c << e | d, $781b3e78c0ece49a$var$sg = a;
}
function $781b3e78c0ece49a$var$vg(a) {
    null !== a.return && ($781b3e78c0ece49a$var$tg(a, 1), $781b3e78c0ece49a$var$ug(a, 1, 0));
}
function $781b3e78c0ece49a$var$wg(a) {
    for(; a === $781b3e78c0ece49a$var$mg;)$781b3e78c0ece49a$var$mg = $781b3e78c0ece49a$var$kg[--$781b3e78c0ece49a$var$lg], $781b3e78c0ece49a$var$kg[$781b3e78c0ece49a$var$lg] = null, $781b3e78c0ece49a$var$ng = $781b3e78c0ece49a$var$kg[--$781b3e78c0ece49a$var$lg], $781b3e78c0ece49a$var$kg[$781b3e78c0ece49a$var$lg] = null;
    for(; a === $781b3e78c0ece49a$var$qg;)$781b3e78c0ece49a$var$qg = $781b3e78c0ece49a$var$og[--$781b3e78c0ece49a$var$pg], $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg] = null, $781b3e78c0ece49a$var$sg = $781b3e78c0ece49a$var$og[--$781b3e78c0ece49a$var$pg], $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg] = null, $781b3e78c0ece49a$var$rg = $781b3e78c0ece49a$var$og[--$781b3e78c0ece49a$var$pg], $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg] = null;
}
var $781b3e78c0ece49a$var$xg = null, $781b3e78c0ece49a$var$yg = null, $781b3e78c0ece49a$var$I = !1, $781b3e78c0ece49a$var$zg = null;
function $781b3e78c0ece49a$var$Ag(a, b) {
    var c = $781b3e78c0ece49a$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $781b3e78c0ece49a$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $781b3e78c0ece49a$var$xg = a, $781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $781b3e78c0ece49a$var$xg = a, $781b3e78c0ece49a$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $781b3e78c0ece49a$var$qg ? {
                id: $781b3e78c0ece49a$var$rg,
                overflow: $781b3e78c0ece49a$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $781b3e78c0ece49a$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $781b3e78c0ece49a$var$xg = a, $781b3e78c0ece49a$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $781b3e78c0ece49a$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $781b3e78c0ece49a$var$Eg(a) {
    if ($781b3e78c0ece49a$var$I) {
        var b = $781b3e78c0ece49a$var$yg;
        if (b) {
            var c = b;
            if (!$781b3e78c0ece49a$var$Cg(a, b)) {
                if ($781b3e78c0ece49a$var$Dg(a)) throw Error($781b3e78c0ece49a$var$p(418));
                b = $781b3e78c0ece49a$var$Lf(c.nextSibling);
                var d = $781b3e78c0ece49a$var$xg;
                b && $781b3e78c0ece49a$var$Cg(a, b) ? $781b3e78c0ece49a$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $781b3e78c0ece49a$var$I = !1, $781b3e78c0ece49a$var$xg = a);
            }
        } else {
            if ($781b3e78c0ece49a$var$Dg(a)) throw Error($781b3e78c0ece49a$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $781b3e78c0ece49a$var$I = !1;
            $781b3e78c0ece49a$var$xg = a;
        }
    }
}
function $781b3e78c0ece49a$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $781b3e78c0ece49a$var$xg = a;
}
function $781b3e78c0ece49a$var$Gg(a) {
    if (a !== $781b3e78c0ece49a$var$xg) return !1;
    if (!$781b3e78c0ece49a$var$I) return $781b3e78c0ece49a$var$Fg(a), $781b3e78c0ece49a$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$781b3e78c0ece49a$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $781b3e78c0ece49a$var$yg)) {
        if ($781b3e78c0ece49a$var$Dg(a)) throw $781b3e78c0ece49a$var$Hg(), Error($781b3e78c0ece49a$var$p(418));
        for(; b;)$781b3e78c0ece49a$var$Ag(a, b), b = $781b3e78c0ece49a$var$Lf(b.nextSibling);
    }
    $781b3e78c0ece49a$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($781b3e78c0ece49a$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $781b3e78c0ece49a$var$yg = null;
        }
    } else $781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$xg ? $781b3e78c0ece49a$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $781b3e78c0ece49a$var$Hg() {
    for(var a = $781b3e78c0ece49a$var$yg; a;)a = $781b3e78c0ece49a$var$Lf(a.nextSibling);
}
function $781b3e78c0ece49a$var$Ig() {
    $781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$xg = null;
    $781b3e78c0ece49a$var$I = !1;
}
function $781b3e78c0ece49a$var$Jg(a) {
    null === $781b3e78c0ece49a$var$zg ? $781b3e78c0ece49a$var$zg = [
        a
    ] : $781b3e78c0ece49a$var$zg.push(a);
}
var $781b3e78c0ece49a$var$Kg = $781b3e78c0ece49a$var$ua.ReactCurrentBatchConfig;
function $781b3e78c0ece49a$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $781b3e78c0ece49a$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $781b3e78c0ece49a$var$Mg = $781b3e78c0ece49a$var$Uf(null), $781b3e78c0ece49a$var$Ng = null, $781b3e78c0ece49a$var$Og = null, $781b3e78c0ece49a$var$Pg = null;
function $781b3e78c0ece49a$var$Qg() {
    $781b3e78c0ece49a$var$Pg = $781b3e78c0ece49a$var$Og = $781b3e78c0ece49a$var$Ng = null;
}
function $781b3e78c0ece49a$var$Rg(a) {
    var b = $781b3e78c0ece49a$var$Mg.current;
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Mg);
    a._currentValue = b;
}
function $781b3e78c0ece49a$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $781b3e78c0ece49a$var$Tg(a, b) {
    $781b3e78c0ece49a$var$Ng = a;
    $781b3e78c0ece49a$var$Pg = $781b3e78c0ece49a$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($781b3e78c0ece49a$var$Ug = !0), a.firstContext = null);
}
function $781b3e78c0ece49a$var$Vg(a) {
    var b = a._currentValue;
    if ($781b3e78c0ece49a$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $781b3e78c0ece49a$var$Og) {
            if (null === $781b3e78c0ece49a$var$Ng) throw Error($781b3e78c0ece49a$var$p(308));
            $781b3e78c0ece49a$var$Og = a;
            $781b3e78c0ece49a$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $781b3e78c0ece49a$var$Og = $781b3e78c0ece49a$var$Og.next = a;
    }
    return b;
}
var $781b3e78c0ece49a$var$Wg = null;
function $781b3e78c0ece49a$var$Xg(a) {
    null === $781b3e78c0ece49a$var$Wg ? $781b3e78c0ece49a$var$Wg = [
        a
    ] : $781b3e78c0ece49a$var$Wg.push(a);
}
function $781b3e78c0ece49a$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $781b3e78c0ece49a$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $781b3e78c0ece49a$var$Zg(a, d);
}
function $781b3e78c0ece49a$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $781b3e78c0ece49a$var$$g = !1;
function $781b3e78c0ece49a$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $781b3e78c0ece49a$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $781b3e78c0ece49a$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $781b3e78c0ece49a$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($781b3e78c0ece49a$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $781b3e78c0ece49a$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $781b3e78c0ece49a$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $781b3e78c0ece49a$var$Zg(a, c);
}
function $781b3e78c0ece49a$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $781b3e78c0ece49a$var$Cc(a, c);
    }
}
function $781b3e78c0ece49a$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $781b3e78c0ece49a$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $781b3e78c0ece49a$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $781b3e78c0ece49a$var$A({}, q, r);
                            break a;
                        case 2:
                            $781b3e78c0ece49a$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $781b3e78c0ece49a$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $781b3e78c0ece49a$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($781b3e78c0ece49a$var$p(191, e));
            e.call(d);
        }
    }
}
var $781b3e78c0ece49a$var$jh = (new $eCoWV.Component).refs;
function $781b3e78c0ece49a$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $781b3e78c0ece49a$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $781b3e78c0ece49a$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $781b3e78c0ece49a$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $781b3e78c0ece49a$var$L(), e = $781b3e78c0ece49a$var$lh(a), f = $781b3e78c0ece49a$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $781b3e78c0ece49a$var$dh(a, f, e);
        null !== b && ($781b3e78c0ece49a$var$mh(b, a, e, d), $781b3e78c0ece49a$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $781b3e78c0ece49a$var$L(), e = $781b3e78c0ece49a$var$lh(a), f = $781b3e78c0ece49a$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $781b3e78c0ece49a$var$dh(a, f, e);
        null !== b && ($781b3e78c0ece49a$var$mh(b, a, e, d), $781b3e78c0ece49a$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $781b3e78c0ece49a$var$L(), d = $781b3e78c0ece49a$var$lh(a), e = $781b3e78c0ece49a$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $781b3e78c0ece49a$var$dh(a, e, d);
        null !== b && ($781b3e78c0ece49a$var$mh(b, a, d, c), $781b3e78c0ece49a$var$eh(b, a, d));
    }
};
function $781b3e78c0ece49a$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$781b3e78c0ece49a$var$Ie(c, d) || !$781b3e78c0ece49a$var$Ie(e, f) : !0;
}
function $781b3e78c0ece49a$var$ph(a, b, c) {
    var d = !1, e = $781b3e78c0ece49a$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $781b3e78c0ece49a$var$Vg(f) : (e = $781b3e78c0ece49a$var$Zf(b) ? $781b3e78c0ece49a$var$Xf : $781b3e78c0ece49a$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $781b3e78c0ece49a$var$Yf(a, e) : $781b3e78c0ece49a$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $781b3e78c0ece49a$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $781b3e78c0ece49a$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $781b3e78c0ece49a$var$nh.enqueueReplaceState(b, b.state, null);
}
function $781b3e78c0ece49a$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $781b3e78c0ece49a$var$jh;
    $781b3e78c0ece49a$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $781b3e78c0ece49a$var$Vg(f) : (f = $781b3e78c0ece49a$var$Zf(b) ? $781b3e78c0ece49a$var$Xf : $781b3e78c0ece49a$var$H.current, e.context = $781b3e78c0ece49a$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($781b3e78c0ece49a$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $781b3e78c0ece49a$var$nh.enqueueReplaceState(e, e.state, null), $781b3e78c0ece49a$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $781b3e78c0ece49a$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($781b3e78c0ece49a$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($781b3e78c0ece49a$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $781b3e78c0ece49a$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($781b3e78c0ece49a$var$p(284));
        if (!c._owner) throw Error($781b3e78c0ece49a$var$p(290, a));
    }
    return a;
}
function $781b3e78c0ece49a$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($781b3e78c0ece49a$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $781b3e78c0ece49a$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $781b3e78c0ece49a$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $781b3e78c0ece49a$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $781b3e78c0ece49a$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $781b3e78c0ece49a$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $781b3e78c0ece49a$var$Ha && $781b3e78c0ece49a$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $781b3e78c0ece49a$var$sh(a, b, c), d.return = a, d;
        d = $781b3e78c0ece49a$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $781b3e78c0ece49a$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $781b3e78c0ece49a$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $781b3e78c0ece49a$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $781b3e78c0ece49a$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $781b3e78c0ece49a$var$va:
                    return c = $781b3e78c0ece49a$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $781b3e78c0ece49a$var$sh(a, null, b), c.return = a, c;
                case $781b3e78c0ece49a$var$wa:
                    return b = $781b3e78c0ece49a$var$zh(b, a.mode, c), b.return = a, b;
                case $781b3e78c0ece49a$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($781b3e78c0ece49a$var$eb(b) || $781b3e78c0ece49a$var$Ka(b)) return b = $781b3e78c0ece49a$var$Ah(b, a.mode, c, null), b.return = a, b;
            $781b3e78c0ece49a$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $781b3e78c0ece49a$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $781b3e78c0ece49a$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $781b3e78c0ece49a$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($781b3e78c0ece49a$var$eb(c) || $781b3e78c0ece49a$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $781b3e78c0ece49a$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $781b3e78c0ece49a$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $781b3e78c0ece49a$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $781b3e78c0ece49a$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($781b3e78c0ece49a$var$eb(d) || $781b3e78c0ece49a$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $781b3e78c0ece49a$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $781b3e78c0ece49a$var$Ka(h);
        if ("function" !== typeof l) throw Error($781b3e78c0ece49a$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($781b3e78c0ece49a$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $781b3e78c0ece49a$var$I && $781b3e78c0ece49a$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $781b3e78c0ece49a$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $781b3e78c0ece49a$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $781b3e78c0ece49a$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $781b3e78c0ece49a$var$Ha && $781b3e78c0ece49a$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $781b3e78c0ece49a$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $781b3e78c0ece49a$var$ya ? (d = $781b3e78c0ece49a$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $781b3e78c0ece49a$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $781b3e78c0ece49a$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $781b3e78c0ece49a$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $781b3e78c0ece49a$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $781b3e78c0ece49a$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($781b3e78c0ece49a$var$eb(f)) return n(a, d, f, h);
            if ($781b3e78c0ece49a$var$Ka(f)) return t(a, d, f, h);
            $781b3e78c0ece49a$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $781b3e78c0ece49a$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $781b3e78c0ece49a$var$Bh = $781b3e78c0ece49a$var$vh(!0), $781b3e78c0ece49a$var$Ch = $781b3e78c0ece49a$var$vh(!1), $781b3e78c0ece49a$var$Dh = {}, $781b3e78c0ece49a$var$Eh = $781b3e78c0ece49a$var$Uf($781b3e78c0ece49a$var$Dh), $781b3e78c0ece49a$var$Fh = $781b3e78c0ece49a$var$Uf($781b3e78c0ece49a$var$Dh), $781b3e78c0ece49a$var$Gh = $781b3e78c0ece49a$var$Uf($781b3e78c0ece49a$var$Dh);
function $781b3e78c0ece49a$var$Hh(a) {
    if (a === $781b3e78c0ece49a$var$Dh) throw Error($781b3e78c0ece49a$var$p(174));
    return a;
}
function $781b3e78c0ece49a$var$Ih(a, b) {
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Gh, b);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Fh, a);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Eh, $781b3e78c0ece49a$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $781b3e78c0ece49a$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $781b3e78c0ece49a$var$lb(b, a);
    }
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Eh);
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Eh, b);
}
function $781b3e78c0ece49a$var$Jh() {
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Eh);
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Fh);
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Gh);
}
function $781b3e78c0ece49a$var$Kh(a) {
    $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Gh.current);
    var b = $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Eh.current);
    var c = $781b3e78c0ece49a$var$lb(b, a.type);
    b !== c && ($781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Fh, a), $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Eh, c));
}
function $781b3e78c0ece49a$var$Lh(a) {
    $781b3e78c0ece49a$var$Fh.current === a && ($781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Eh), $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Fh));
}
var $781b3e78c0ece49a$var$M = $781b3e78c0ece49a$var$Uf(0);
function $781b3e78c0ece49a$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $781b3e78c0ece49a$var$Nh = [];
function $781b3e78c0ece49a$var$Oh() {
    for(var a = 0; a < $781b3e78c0ece49a$var$Nh.length; a++)$781b3e78c0ece49a$var$Nh[a]._workInProgressVersionPrimary = null;
    $781b3e78c0ece49a$var$Nh.length = 0;
}
var $781b3e78c0ece49a$var$Ph = $781b3e78c0ece49a$var$ua.ReactCurrentDispatcher, $781b3e78c0ece49a$var$Qh = $781b3e78c0ece49a$var$ua.ReactCurrentBatchConfig, $781b3e78c0ece49a$var$Rh = 0, $781b3e78c0ece49a$var$N = null, $781b3e78c0ece49a$var$O = null, $781b3e78c0ece49a$var$P = null, $781b3e78c0ece49a$var$Sh = !1, $781b3e78c0ece49a$var$Th = !1, $781b3e78c0ece49a$var$Uh = 0, $781b3e78c0ece49a$var$Vh = 0;
function $781b3e78c0ece49a$var$Q() {
    throw Error($781b3e78c0ece49a$var$p(321));
}
function $781b3e78c0ece49a$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$781b3e78c0ece49a$var$He(a[c], b[c])) return !1;
    return !0;
}
function $781b3e78c0ece49a$var$Xh(a, b, c, d, e, f) {
    $781b3e78c0ece49a$var$Rh = f;
    $781b3e78c0ece49a$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $781b3e78c0ece49a$var$Ph.current = null === a || null === a.memoizedState ? $781b3e78c0ece49a$var$Yh : $781b3e78c0ece49a$var$Zh;
    a = c(d, e);
    if ($781b3e78c0ece49a$var$Th) {
        f = 0;
        do {
            $781b3e78c0ece49a$var$Th = !1;
            $781b3e78c0ece49a$var$Uh = 0;
            if (25 <= f) throw Error($781b3e78c0ece49a$var$p(301));
            f += 1;
            $781b3e78c0ece49a$var$P = $781b3e78c0ece49a$var$O = null;
            b.updateQueue = null;
            $781b3e78c0ece49a$var$Ph.current = $781b3e78c0ece49a$var$$h;
            a = c(d, e);
        }while ($781b3e78c0ece49a$var$Th);
    }
    $781b3e78c0ece49a$var$Ph.current = $781b3e78c0ece49a$var$ai;
    b = null !== $781b3e78c0ece49a$var$O && null !== $781b3e78c0ece49a$var$O.next;
    $781b3e78c0ece49a$var$Rh = 0;
    $781b3e78c0ece49a$var$P = $781b3e78c0ece49a$var$O = $781b3e78c0ece49a$var$N = null;
    $781b3e78c0ece49a$var$Sh = !1;
    if (b) throw Error($781b3e78c0ece49a$var$p(300));
    return a;
}
function $781b3e78c0ece49a$var$bi() {
    var a = 0 !== $781b3e78c0ece49a$var$Uh;
    $781b3e78c0ece49a$var$Uh = 0;
    return a;
}
function $781b3e78c0ece49a$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $781b3e78c0ece49a$var$P ? $781b3e78c0ece49a$var$N.memoizedState = $781b3e78c0ece49a$var$P = a : $781b3e78c0ece49a$var$P = $781b3e78c0ece49a$var$P.next = a;
    return $781b3e78c0ece49a$var$P;
}
function $781b3e78c0ece49a$var$di() {
    if (null === $781b3e78c0ece49a$var$O) {
        var a = $781b3e78c0ece49a$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $781b3e78c0ece49a$var$O.next;
    var b = null === $781b3e78c0ece49a$var$P ? $781b3e78c0ece49a$var$N.memoizedState : $781b3e78c0ece49a$var$P.next;
    if (null !== b) $781b3e78c0ece49a$var$P = b, $781b3e78c0ece49a$var$O = a;
    else {
        if (null === a) throw Error($781b3e78c0ece49a$var$p(310));
        $781b3e78c0ece49a$var$O = a;
        a = {
            memoizedState: $781b3e78c0ece49a$var$O.memoizedState,
            baseState: $781b3e78c0ece49a$var$O.baseState,
            baseQueue: $781b3e78c0ece49a$var$O.baseQueue,
            queue: $781b3e78c0ece49a$var$O.queue,
            next: null
        };
        null === $781b3e78c0ece49a$var$P ? $781b3e78c0ece49a$var$N.memoizedState = $781b3e78c0ece49a$var$P = a : $781b3e78c0ece49a$var$P = $781b3e78c0ece49a$var$P.next = a;
    }
    return $781b3e78c0ece49a$var$P;
}
function $781b3e78c0ece49a$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $781b3e78c0ece49a$var$fi(a) {
    var b = $781b3e78c0ece49a$var$di(), c = b.queue;
    if (null === c) throw Error($781b3e78c0ece49a$var$p(311));
    c.lastRenderedReducer = a;
    var d = $781b3e78c0ece49a$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($781b3e78c0ece49a$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $781b3e78c0ece49a$var$N.lanes |= m;
                $781b3e78c0ece49a$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $781b3e78c0ece49a$var$He(d, b.memoizedState) || ($781b3e78c0ece49a$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $781b3e78c0ece49a$var$N.lanes |= f, $781b3e78c0ece49a$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $781b3e78c0ece49a$var$gi(a) {
    var b = $781b3e78c0ece49a$var$di(), c = b.queue;
    if (null === c) throw Error($781b3e78c0ece49a$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $781b3e78c0ece49a$var$He(f, b.memoizedState) || ($781b3e78c0ece49a$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $781b3e78c0ece49a$var$hi() {}
function $781b3e78c0ece49a$var$ii(a, b) {
    var c = $781b3e78c0ece49a$var$N, d = $781b3e78c0ece49a$var$di(), e = b(), f = !$781b3e78c0ece49a$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $781b3e78c0ece49a$var$Ug = !0);
    d = d.queue;
    $781b3e78c0ece49a$var$ji($781b3e78c0ece49a$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $781b3e78c0ece49a$var$P && $781b3e78c0ece49a$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $781b3e78c0ece49a$var$li(9, $781b3e78c0ece49a$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $781b3e78c0ece49a$var$R) throw Error($781b3e78c0ece49a$var$p(349));
        0 !== ($781b3e78c0ece49a$var$Rh & 30) || $781b3e78c0ece49a$var$ni(c, b, e);
    }
    return e;
}
function $781b3e78c0ece49a$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $781b3e78c0ece49a$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $781b3e78c0ece49a$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $781b3e78c0ece49a$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $781b3e78c0ece49a$var$oi(b) && $781b3e78c0ece49a$var$pi(a);
}
function $781b3e78c0ece49a$var$ki(a, b, c) {
    return c(function() {
        $781b3e78c0ece49a$var$oi(b) && $781b3e78c0ece49a$var$pi(a);
    });
}
function $781b3e78c0ece49a$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$781b3e78c0ece49a$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $781b3e78c0ece49a$var$pi(a) {
    var b = $781b3e78c0ece49a$var$Zg(a, 1);
    null !== b && $781b3e78c0ece49a$var$mh(b, a, 1, -1);
}
function $781b3e78c0ece49a$var$qi(a) {
    var b = $781b3e78c0ece49a$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $781b3e78c0ece49a$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $781b3e78c0ece49a$var$ri.bind(null, $781b3e78c0ece49a$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $781b3e78c0ece49a$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $781b3e78c0ece49a$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $781b3e78c0ece49a$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $781b3e78c0ece49a$var$si() {
    return $781b3e78c0ece49a$var$di().memoizedState;
}
function $781b3e78c0ece49a$var$ti(a, b, c, d) {
    var e = $781b3e78c0ece49a$var$ci();
    $781b3e78c0ece49a$var$N.flags |= a;
    e.memoizedState = $781b3e78c0ece49a$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $781b3e78c0ece49a$var$ui(a, b, c, d) {
    var e = $781b3e78c0ece49a$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $781b3e78c0ece49a$var$O) {
        var g = $781b3e78c0ece49a$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $781b3e78c0ece49a$var$Wh(d, g.deps)) {
            e.memoizedState = $781b3e78c0ece49a$var$li(b, c, f, d);
            return;
        }
    }
    $781b3e78c0ece49a$var$N.flags |= a;
    e.memoizedState = $781b3e78c0ece49a$var$li(1 | b, c, f, d);
}
function $781b3e78c0ece49a$var$vi(a, b) {
    return $781b3e78c0ece49a$var$ti(8390656, 8, a, b);
}
function $781b3e78c0ece49a$var$ji(a, b) {
    return $781b3e78c0ece49a$var$ui(2048, 8, a, b);
}
function $781b3e78c0ece49a$var$wi(a, b) {
    return $781b3e78c0ece49a$var$ui(4, 2, a, b);
}
function $781b3e78c0ece49a$var$xi(a, b) {
    return $781b3e78c0ece49a$var$ui(4, 4, a, b);
}
function $781b3e78c0ece49a$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $781b3e78c0ece49a$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $781b3e78c0ece49a$var$ui(4, 4, $781b3e78c0ece49a$var$yi.bind(null, b, a), c);
}
function $781b3e78c0ece49a$var$Ai() {}
function $781b3e78c0ece49a$var$Bi(a, b) {
    var c = $781b3e78c0ece49a$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $781b3e78c0ece49a$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $781b3e78c0ece49a$var$Ci(a, b) {
    var c = $781b3e78c0ece49a$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $781b3e78c0ece49a$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $781b3e78c0ece49a$var$Di(a, b, c) {
    if (0 === ($781b3e78c0ece49a$var$Rh & 21)) return a.baseState && (a.baseState = !1, $781b3e78c0ece49a$var$Ug = !0), a.memoizedState = c;
    $781b3e78c0ece49a$var$He(c, b) || (c = $781b3e78c0ece49a$var$yc(), $781b3e78c0ece49a$var$N.lanes |= c, $781b3e78c0ece49a$var$hh |= c, a.baseState = !0);
    return b;
}
function $781b3e78c0ece49a$var$Ei(a, b) {
    var c = $781b3e78c0ece49a$var$C;
    $781b3e78c0ece49a$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $781b3e78c0ece49a$var$Qh.transition;
    $781b3e78c0ece49a$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $781b3e78c0ece49a$var$C = c, $781b3e78c0ece49a$var$Qh.transition = d;
    }
}
function $781b3e78c0ece49a$var$Fi() {
    return $781b3e78c0ece49a$var$di().memoizedState;
}
function $781b3e78c0ece49a$var$Gi(a, b, c) {
    var d = $781b3e78c0ece49a$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($781b3e78c0ece49a$var$Hi(a)) $781b3e78c0ece49a$var$Ii(b, c);
    else if (c = $781b3e78c0ece49a$var$Yg(a, b, c, d), null !== c) {
        var e = $781b3e78c0ece49a$var$L();
        $781b3e78c0ece49a$var$mh(c, a, d, e);
        $781b3e78c0ece49a$var$Ji(c, b, d);
    }
}
function $781b3e78c0ece49a$var$ri(a, b, c) {
    var d = $781b3e78c0ece49a$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($781b3e78c0ece49a$var$Hi(a)) $781b3e78c0ece49a$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($781b3e78c0ece49a$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $781b3e78c0ece49a$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $781b3e78c0ece49a$var$Yg(a, b, e, d);
        null !== c && (e = $781b3e78c0ece49a$var$L(), $781b3e78c0ece49a$var$mh(c, a, d, e), $781b3e78c0ece49a$var$Ji(c, b, d));
    }
}
function $781b3e78c0ece49a$var$Hi(a) {
    var b = a.alternate;
    return a === $781b3e78c0ece49a$var$N || null !== b && b === $781b3e78c0ece49a$var$N;
}
function $781b3e78c0ece49a$var$Ii(a, b) {
    $781b3e78c0ece49a$var$Th = $781b3e78c0ece49a$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $781b3e78c0ece49a$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $781b3e78c0ece49a$var$Cc(a, c);
    }
}
var $781b3e78c0ece49a$var$ai = {
    readContext: $781b3e78c0ece49a$var$Vg,
    useCallback: $781b3e78c0ece49a$var$Q,
    useContext: $781b3e78c0ece49a$var$Q,
    useEffect: $781b3e78c0ece49a$var$Q,
    useImperativeHandle: $781b3e78c0ece49a$var$Q,
    useInsertionEffect: $781b3e78c0ece49a$var$Q,
    useLayoutEffect: $781b3e78c0ece49a$var$Q,
    useMemo: $781b3e78c0ece49a$var$Q,
    useReducer: $781b3e78c0ece49a$var$Q,
    useRef: $781b3e78c0ece49a$var$Q,
    useState: $781b3e78c0ece49a$var$Q,
    useDebugValue: $781b3e78c0ece49a$var$Q,
    useDeferredValue: $781b3e78c0ece49a$var$Q,
    useTransition: $781b3e78c0ece49a$var$Q,
    useMutableSource: $781b3e78c0ece49a$var$Q,
    useSyncExternalStore: $781b3e78c0ece49a$var$Q,
    useId: $781b3e78c0ece49a$var$Q,
    unstable_isNewReconciler: !1
}, $781b3e78c0ece49a$var$Yh = {
    readContext: $781b3e78c0ece49a$var$Vg,
    useCallback: function(a, b) {
        $781b3e78c0ece49a$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $781b3e78c0ece49a$var$Vg,
    useEffect: $781b3e78c0ece49a$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $781b3e78c0ece49a$var$ti(4194308, 4, $781b3e78c0ece49a$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $781b3e78c0ece49a$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $781b3e78c0ece49a$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $781b3e78c0ece49a$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $781b3e78c0ece49a$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $781b3e78c0ece49a$var$Gi.bind(null, $781b3e78c0ece49a$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $781b3e78c0ece49a$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $781b3e78c0ece49a$var$qi,
    useDebugValue: $781b3e78c0ece49a$var$Ai,
    useDeferredValue: function(a) {
        return $781b3e78c0ece49a$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $781b3e78c0ece49a$var$qi(!1), b = a[0];
        a = $781b3e78c0ece49a$var$Ei.bind(null, a[1]);
        $781b3e78c0ece49a$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $781b3e78c0ece49a$var$N, e = $781b3e78c0ece49a$var$ci();
        if ($781b3e78c0ece49a$var$I) {
            if (void 0 === c) throw Error($781b3e78c0ece49a$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $781b3e78c0ece49a$var$R) throw Error($781b3e78c0ece49a$var$p(349));
            0 !== ($781b3e78c0ece49a$var$Rh & 30) || $781b3e78c0ece49a$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $781b3e78c0ece49a$var$vi($781b3e78c0ece49a$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $781b3e78c0ece49a$var$li(9, $781b3e78c0ece49a$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $781b3e78c0ece49a$var$ci(), b = $781b3e78c0ece49a$var$R.identifierPrefix;
        if ($781b3e78c0ece49a$var$I) {
            var c = $781b3e78c0ece49a$var$sg;
            var d = $781b3e78c0ece49a$var$rg;
            c = (d & ~(1 << 32 - $781b3e78c0ece49a$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $781b3e78c0ece49a$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $781b3e78c0ece49a$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $781b3e78c0ece49a$var$Zh = {
    readContext: $781b3e78c0ece49a$var$Vg,
    useCallback: $781b3e78c0ece49a$var$Bi,
    useContext: $781b3e78c0ece49a$var$Vg,
    useEffect: $781b3e78c0ece49a$var$ji,
    useImperativeHandle: $781b3e78c0ece49a$var$zi,
    useInsertionEffect: $781b3e78c0ece49a$var$wi,
    useLayoutEffect: $781b3e78c0ece49a$var$xi,
    useMemo: $781b3e78c0ece49a$var$Ci,
    useReducer: $781b3e78c0ece49a$var$fi,
    useRef: $781b3e78c0ece49a$var$si,
    useState: function() {
        return $781b3e78c0ece49a$var$fi($781b3e78c0ece49a$var$ei);
    },
    useDebugValue: $781b3e78c0ece49a$var$Ai,
    useDeferredValue: function(a) {
        var b = $781b3e78c0ece49a$var$di();
        return $781b3e78c0ece49a$var$Di(b, $781b3e78c0ece49a$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $781b3e78c0ece49a$var$fi($781b3e78c0ece49a$var$ei)[0], b = $781b3e78c0ece49a$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $781b3e78c0ece49a$var$hi,
    useSyncExternalStore: $781b3e78c0ece49a$var$ii,
    useId: $781b3e78c0ece49a$var$Fi,
    unstable_isNewReconciler: !1
}, $781b3e78c0ece49a$var$$h = {
    readContext: $781b3e78c0ece49a$var$Vg,
    useCallback: $781b3e78c0ece49a$var$Bi,
    useContext: $781b3e78c0ece49a$var$Vg,
    useEffect: $781b3e78c0ece49a$var$ji,
    useImperativeHandle: $781b3e78c0ece49a$var$zi,
    useInsertionEffect: $781b3e78c0ece49a$var$wi,
    useLayoutEffect: $781b3e78c0ece49a$var$xi,
    useMemo: $781b3e78c0ece49a$var$Ci,
    useReducer: $781b3e78c0ece49a$var$gi,
    useRef: $781b3e78c0ece49a$var$si,
    useState: function() {
        return $781b3e78c0ece49a$var$gi($781b3e78c0ece49a$var$ei);
    },
    useDebugValue: $781b3e78c0ece49a$var$Ai,
    useDeferredValue: function(a) {
        var b = $781b3e78c0ece49a$var$di();
        return null === $781b3e78c0ece49a$var$O ? b.memoizedState = a : $781b3e78c0ece49a$var$Di(b, $781b3e78c0ece49a$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $781b3e78c0ece49a$var$gi($781b3e78c0ece49a$var$ei)[0], b = $781b3e78c0ece49a$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $781b3e78c0ece49a$var$hi,
    useSyncExternalStore: $781b3e78c0ece49a$var$ii,
    useId: $781b3e78c0ece49a$var$Fi,
    unstable_isNewReconciler: !1
};
function $781b3e78c0ece49a$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $781b3e78c0ece49a$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $781b3e78c0ece49a$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $781b3e78c0ece49a$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $781b3e78c0ece49a$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $781b3e78c0ece49a$var$Oi(a, b, c) {
    c = $781b3e78c0ece49a$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $781b3e78c0ece49a$var$Pi || ($781b3e78c0ece49a$var$Pi = !0, $781b3e78c0ece49a$var$Qi = d);
        $781b3e78c0ece49a$var$Mi(a, b);
    };
    return c;
}
function $781b3e78c0ece49a$var$Ri(a, b, c) {
    c = $781b3e78c0ece49a$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $781b3e78c0ece49a$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $781b3e78c0ece49a$var$Mi(a, b);
        "function" !== typeof d && (null === $781b3e78c0ece49a$var$Si ? $781b3e78c0ece49a$var$Si = new Set([
            this
        ]) : $781b3e78c0ece49a$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $781b3e78c0ece49a$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $781b3e78c0ece49a$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $781b3e78c0ece49a$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $781b3e78c0ece49a$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $781b3e78c0ece49a$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $781b3e78c0ece49a$var$ch(-1, 1), b.tag = 2, $781b3e78c0ece49a$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $781b3e78c0ece49a$var$Xi = $781b3e78c0ece49a$var$ua.ReactCurrentOwner, $781b3e78c0ece49a$var$Ug = !1;
function $781b3e78c0ece49a$var$Yi(a, b, c, d) {
    b.child = null === a ? $781b3e78c0ece49a$var$Ch(b, null, c, d) : $781b3e78c0ece49a$var$Bh(b, a.child, c, d);
}
function $781b3e78c0ece49a$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $781b3e78c0ece49a$var$Tg(b, e);
    d = $781b3e78c0ece49a$var$Xh(a, b, c, d, f, e);
    c = $781b3e78c0ece49a$var$bi();
    if (null !== a && !$781b3e78c0ece49a$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $781b3e78c0ece49a$var$$i(a, b, e);
    $781b3e78c0ece49a$var$I && c && $781b3e78c0ece49a$var$vg(b);
    b.flags |= 1;
    $781b3e78c0ece49a$var$Yi(a, b, d, e);
    return b.child;
}
function $781b3e78c0ece49a$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$781b3e78c0ece49a$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $781b3e78c0ece49a$var$cj(a, b, f, d, e);
        a = $781b3e78c0ece49a$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $781b3e78c0ece49a$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $781b3e78c0ece49a$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $781b3e78c0ece49a$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $781b3e78c0ece49a$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($781b3e78c0ece49a$var$Ie(f, d) && a.ref === b.ref) {
            if ($781b3e78c0ece49a$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($781b3e78c0ece49a$var$Ug = !0);
            else return b.lanes = a.lanes, $781b3e78c0ece49a$var$$i(a, b, e);
        }
    }
    return $781b3e78c0ece49a$var$dj(a, b, c, d, e);
}
function $781b3e78c0ece49a$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$fj, $781b3e78c0ece49a$var$gj), $781b3e78c0ece49a$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$fj, $781b3e78c0ece49a$var$gj), $781b3e78c0ece49a$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$fj, $781b3e78c0ece49a$var$gj);
            $781b3e78c0ece49a$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$fj, $781b3e78c0ece49a$var$gj), $781b3e78c0ece49a$var$gj |= d;
    $781b3e78c0ece49a$var$Yi(a, b, e, c);
    return b.child;
}
function $781b3e78c0ece49a$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $781b3e78c0ece49a$var$dj(a, b, c, d, e) {
    var f = $781b3e78c0ece49a$var$Zf(c) ? $781b3e78c0ece49a$var$Xf : $781b3e78c0ece49a$var$H.current;
    f = $781b3e78c0ece49a$var$Yf(b, f);
    $781b3e78c0ece49a$var$Tg(b, e);
    c = $781b3e78c0ece49a$var$Xh(a, b, c, d, f, e);
    d = $781b3e78c0ece49a$var$bi();
    if (null !== a && !$781b3e78c0ece49a$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $781b3e78c0ece49a$var$$i(a, b, e);
    $781b3e78c0ece49a$var$I && d && $781b3e78c0ece49a$var$vg(b);
    b.flags |= 1;
    $781b3e78c0ece49a$var$Yi(a, b, c, e);
    return b.child;
}
function $781b3e78c0ece49a$var$ij(a, b, c, d, e) {
    if ($781b3e78c0ece49a$var$Zf(c)) {
        var f = !0;
        $781b3e78c0ece49a$var$cg(b);
    } else f = !1;
    $781b3e78c0ece49a$var$Tg(b, e);
    if (null === b.stateNode) $781b3e78c0ece49a$var$jj(a, b), $781b3e78c0ece49a$var$ph(b, c, d), $781b3e78c0ece49a$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $781b3e78c0ece49a$var$Vg(l) : (l = $781b3e78c0ece49a$var$Zf(c) ? $781b3e78c0ece49a$var$Xf : $781b3e78c0ece49a$var$H.current, l = $781b3e78c0ece49a$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $781b3e78c0ece49a$var$qh(b, g, d, l);
        $781b3e78c0ece49a$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $781b3e78c0ece49a$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $781b3e78c0ece49a$var$Wf.current || $781b3e78c0ece49a$var$$g ? ("function" === typeof m && ($781b3e78c0ece49a$var$kh(b, c, m, d), k = b.memoizedState), (h = $781b3e78c0ece49a$var$$g || $781b3e78c0ece49a$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $781b3e78c0ece49a$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $781b3e78c0ece49a$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $781b3e78c0ece49a$var$Vg(k) : (k = $781b3e78c0ece49a$var$Zf(c) ? $781b3e78c0ece49a$var$Xf : $781b3e78c0ece49a$var$H.current, k = $781b3e78c0ece49a$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $781b3e78c0ece49a$var$qh(b, g, d, k);
        $781b3e78c0ece49a$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $781b3e78c0ece49a$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $781b3e78c0ece49a$var$Wf.current || $781b3e78c0ece49a$var$$g ? ("function" === typeof y && ($781b3e78c0ece49a$var$kh(b, c, y, d), n = b.memoizedState), (l = $781b3e78c0ece49a$var$$g || $781b3e78c0ece49a$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $781b3e78c0ece49a$var$kj(a, b, c, d, f, e);
}
function $781b3e78c0ece49a$var$kj(a, b, c, d, e, f) {
    $781b3e78c0ece49a$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $781b3e78c0ece49a$var$dg(b, c, !1), $781b3e78c0ece49a$var$$i(a, b, f);
    d = b.stateNode;
    $781b3e78c0ece49a$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $781b3e78c0ece49a$var$Bh(b, a.child, null, f), b.child = $781b3e78c0ece49a$var$Bh(b, null, h, f)) : $781b3e78c0ece49a$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $781b3e78c0ece49a$var$dg(b, c, !0);
    return b.child;
}
function $781b3e78c0ece49a$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $781b3e78c0ece49a$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $781b3e78c0ece49a$var$ag(a, b.context, !1);
    $781b3e78c0ece49a$var$Ih(a, b.containerInfo);
}
function $781b3e78c0ece49a$var$mj(a, b, c, d, e) {
    $781b3e78c0ece49a$var$Ig();
    $781b3e78c0ece49a$var$Jg(e);
    b.flags |= 256;
    $781b3e78c0ece49a$var$Yi(a, b, c, d);
    return b.child;
}
var $781b3e78c0ece49a$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $781b3e78c0ece49a$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $781b3e78c0ece49a$var$pj(a, b, c) {
    var d = b.pendingProps, e = $781b3e78c0ece49a$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, e & 1);
    if (null === a) {
        $781b3e78c0ece49a$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $781b3e78c0ece49a$var$qj(g, d, 0, null), a = $781b3e78c0ece49a$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $781b3e78c0ece49a$var$oj(c), b.memoizedState = $781b3e78c0ece49a$var$nj, a) : $781b3e78c0ece49a$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $781b3e78c0ece49a$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $781b3e78c0ece49a$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $781b3e78c0ece49a$var$wh(h, f) : (f = $781b3e78c0ece49a$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $781b3e78c0ece49a$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $781b3e78c0ece49a$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $781b3e78c0ece49a$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $781b3e78c0ece49a$var$rj(a, b) {
    b = $781b3e78c0ece49a$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $781b3e78c0ece49a$var$tj(a, b, c, d) {
    null !== d && $781b3e78c0ece49a$var$Jg(d);
    $781b3e78c0ece49a$var$Bh(b, a.child, null, c);
    a = $781b3e78c0ece49a$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $781b3e78c0ece49a$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $781b3e78c0ece49a$var$Li(Error($781b3e78c0ece49a$var$p(422))), $781b3e78c0ece49a$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $781b3e78c0ece49a$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $781b3e78c0ece49a$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $781b3e78c0ece49a$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $781b3e78c0ece49a$var$oj(g);
        b.memoizedState = $781b3e78c0ece49a$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $781b3e78c0ece49a$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($781b3e78c0ece49a$var$p(419));
        d = $781b3e78c0ece49a$var$Li(f, d, void 0);
        return $781b3e78c0ece49a$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($781b3e78c0ece49a$var$Ug || h) {
        d = $781b3e78c0ece49a$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $781b3e78c0ece49a$var$Zg(a, e), $781b3e78c0ece49a$var$mh(d, a, e, -1));
        }
        $781b3e78c0ece49a$var$uj();
        d = $781b3e78c0ece49a$var$Li(Error($781b3e78c0ece49a$var$p(421)));
        return $781b3e78c0ece49a$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $781b3e78c0ece49a$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$Lf(e.nextSibling);
    $781b3e78c0ece49a$var$xg = b;
    $781b3e78c0ece49a$var$I = !0;
    $781b3e78c0ece49a$var$zg = null;
    null !== a && ($781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$rg, $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$sg, $781b3e78c0ece49a$var$og[$781b3e78c0ece49a$var$pg++] = $781b3e78c0ece49a$var$qg, $781b3e78c0ece49a$var$rg = a.id, $781b3e78c0ece49a$var$sg = a.overflow, $781b3e78c0ece49a$var$qg = b);
    b = $781b3e78c0ece49a$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $781b3e78c0ece49a$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $781b3e78c0ece49a$var$Sg(a.return, b, c);
}
function $781b3e78c0ece49a$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $781b3e78c0ece49a$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $781b3e78c0ece49a$var$Yi(a, b, d.children, c);
    d = $781b3e78c0ece49a$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $781b3e78c0ece49a$var$wj(a, c, b);
            else if (19 === a.tag) $781b3e78c0ece49a$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $781b3e78c0ece49a$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $781b3e78c0ece49a$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $781b3e78c0ece49a$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $781b3e78c0ece49a$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $781b3e78c0ece49a$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $781b3e78c0ece49a$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $781b3e78c0ece49a$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $781b3e78c0ece49a$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($781b3e78c0ece49a$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $781b3e78c0ece49a$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $781b3e78c0ece49a$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $781b3e78c0ece49a$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $781b3e78c0ece49a$var$lj(b);
            $781b3e78c0ece49a$var$Ig();
            break;
        case 5:
            $781b3e78c0ece49a$var$Kh(b);
            break;
        case 1:
            $781b3e78c0ece49a$var$Zf(b.type) && $781b3e78c0ece49a$var$cg(b);
            break;
        case 4:
            $781b3e78c0ece49a$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, $781b3e78c0ece49a$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $781b3e78c0ece49a$var$pj(a, b, c);
                $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, $781b3e78c0ece49a$var$M.current & 1);
                a = $781b3e78c0ece49a$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, $781b3e78c0ece49a$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $781b3e78c0ece49a$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, $781b3e78c0ece49a$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $781b3e78c0ece49a$var$ej(a, b, c);
    }
    return $781b3e78c0ece49a$var$$i(a, b, c);
}
var $781b3e78c0ece49a$var$Aj, $781b3e78c0ece49a$var$Bj, $781b3e78c0ece49a$var$Cj, $781b3e78c0ece49a$var$Dj;
$781b3e78c0ece49a$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$781b3e78c0ece49a$var$Bj = function() {};
$781b3e78c0ece49a$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $781b3e78c0ece49a$var$Ya(a, e);
                d = $781b3e78c0ece49a$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $781b3e78c0ece49a$var$A({}, e, {
                    value: void 0
                });
                d = $781b3e78c0ece49a$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $781b3e78c0ece49a$var$gb(a, e);
                d = $781b3e78c0ece49a$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $781b3e78c0ece49a$var$Bf);
        }
        $781b3e78c0ece49a$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($781b3e78c0ece49a$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($781b3e78c0ece49a$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $781b3e78c0ece49a$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$781b3e78c0ece49a$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $781b3e78c0ece49a$var$Ej(a, b) {
    if (!$781b3e78c0ece49a$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $781b3e78c0ece49a$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $781b3e78c0ece49a$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $781b3e78c0ece49a$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $781b3e78c0ece49a$var$S(b), null;
        case 1:
            return $781b3e78c0ece49a$var$Zf(b.type) && $781b3e78c0ece49a$var$$f(), $781b3e78c0ece49a$var$S(b), null;
        case 3:
            d = b.stateNode;
            $781b3e78c0ece49a$var$Jh();
            $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf);
            $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$H);
            $781b3e78c0ece49a$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $781b3e78c0ece49a$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $781b3e78c0ece49a$var$zg && ($781b3e78c0ece49a$var$Gj($781b3e78c0ece49a$var$zg), $781b3e78c0ece49a$var$zg = null));
            $781b3e78c0ece49a$var$Bj(a, b);
            $781b3e78c0ece49a$var$S(b);
            return null;
        case 5:
            $781b3e78c0ece49a$var$Lh(b);
            var e = $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $781b3e78c0ece49a$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($781b3e78c0ece49a$var$p(166));
                    $781b3e78c0ece49a$var$S(b);
                    return null;
                }
                a = $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Eh.current);
                if ($781b3e78c0ece49a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$781b3e78c0ece49a$var$Of] = b;
                    d[$781b3e78c0ece49a$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $781b3e78c0ece49a$var$D("cancel", d);
                            $781b3e78c0ece49a$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $781b3e78c0ece49a$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $781b3e78c0ece49a$var$lf.length; e++)$781b3e78c0ece49a$var$D($781b3e78c0ece49a$var$lf[e], d);
                            break;
                        case "source":
                            $781b3e78c0ece49a$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $781b3e78c0ece49a$var$D("error", d);
                            $781b3e78c0ece49a$var$D("load", d);
                            break;
                        case "details":
                            $781b3e78c0ece49a$var$D("toggle", d);
                            break;
                        case "input":
                            $781b3e78c0ece49a$var$Za(d, f);
                            $781b3e78c0ece49a$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $781b3e78c0ece49a$var$D("invalid", d);
                            break;
                        case "textarea":
                            $781b3e78c0ece49a$var$hb(d, f), $781b3e78c0ece49a$var$D("invalid", d);
                    }
                    $781b3e78c0ece49a$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $781b3e78c0ece49a$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $781b3e78c0ece49a$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $781b3e78c0ece49a$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $781b3e78c0ece49a$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $781b3e78c0ece49a$var$Va(d);
                            $781b3e78c0ece49a$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $781b3e78c0ece49a$var$Va(d);
                            $781b3e78c0ece49a$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $781b3e78c0ece49a$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $781b3e78c0ece49a$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$781b3e78c0ece49a$var$Of] = b;
                    a[$781b3e78c0ece49a$var$Pf] = d;
                    $781b3e78c0ece49a$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $781b3e78c0ece49a$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $781b3e78c0ece49a$var$D("cancel", a);
                                $781b3e78c0ece49a$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $781b3e78c0ece49a$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $781b3e78c0ece49a$var$lf.length; e++)$781b3e78c0ece49a$var$D($781b3e78c0ece49a$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $781b3e78c0ece49a$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $781b3e78c0ece49a$var$D("error", a);
                                $781b3e78c0ece49a$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $781b3e78c0ece49a$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $781b3e78c0ece49a$var$Za(a, d);
                                e = $781b3e78c0ece49a$var$Ya(a, d);
                                $781b3e78c0ece49a$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $781b3e78c0ece49a$var$A({}, d, {
                                    value: void 0
                                });
                                $781b3e78c0ece49a$var$D("invalid", a);
                                break;
                            case "textarea":
                                $781b3e78c0ece49a$var$hb(a, d);
                                e = $781b3e78c0ece49a$var$gb(a, d);
                                $781b3e78c0ece49a$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $781b3e78c0ece49a$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $781b3e78c0ece49a$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $781b3e78c0ece49a$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $781b3e78c0ece49a$var$ob(a, k) : "number" === typeof k && $781b3e78c0ece49a$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($781b3e78c0ece49a$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $781b3e78c0ece49a$var$D("scroll", a) : null != k && $781b3e78c0ece49a$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $781b3e78c0ece49a$var$Va(a);
                                $781b3e78c0ece49a$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $781b3e78c0ece49a$var$Va(a);
                                $781b3e78c0ece49a$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $781b3e78c0ece49a$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $781b3e78c0ece49a$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $781b3e78c0ece49a$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $781b3e78c0ece49a$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $781b3e78c0ece49a$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $781b3e78c0ece49a$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($781b3e78c0ece49a$var$p(166));
                c = $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Gh.current);
                $781b3e78c0ece49a$var$Hh($781b3e78c0ece49a$var$Eh.current);
                if ($781b3e78c0ece49a$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$781b3e78c0ece49a$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $781b3e78c0ece49a$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $781b3e78c0ece49a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $781b3e78c0ece49a$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$781b3e78c0ece49a$var$Of] = b, b.stateNode = d;
            }
            $781b3e78c0ece49a$var$S(b);
            return null;
        case 13:
            $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($781b3e78c0ece49a$var$I && null !== $781b3e78c0ece49a$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $781b3e78c0ece49a$var$Hg(), $781b3e78c0ece49a$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $781b3e78c0ece49a$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($781b3e78c0ece49a$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($781b3e78c0ece49a$var$p(317));
                        f[$781b3e78c0ece49a$var$Of] = b;
                    } else $781b3e78c0ece49a$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $781b3e78c0ece49a$var$S(b);
                    f = !1;
                } else null !== $781b3e78c0ece49a$var$zg && ($781b3e78c0ece49a$var$Gj($781b3e78c0ece49a$var$zg), $781b3e78c0ece49a$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($781b3e78c0ece49a$var$M.current & 1) ? 0 === $781b3e78c0ece49a$var$T && ($781b3e78c0ece49a$var$T = 3) : $781b3e78c0ece49a$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $781b3e78c0ece49a$var$S(b);
            return null;
        case 4:
            return $781b3e78c0ece49a$var$Jh(), $781b3e78c0ece49a$var$Bj(a, b), null === a && $781b3e78c0ece49a$var$sf(b.stateNode.containerInfo), $781b3e78c0ece49a$var$S(b), null;
        case 10:
            return $781b3e78c0ece49a$var$Rg(b.type._context), $781b3e78c0ece49a$var$S(b), null;
        case 17:
            return $781b3e78c0ece49a$var$Zf(b.type) && $781b3e78c0ece49a$var$$f(), $781b3e78c0ece49a$var$S(b), null;
        case 19:
            $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M);
            f = b.memoizedState;
            if (null === f) return $781b3e78c0ece49a$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $781b3e78c0ece49a$var$Ej(f, !1);
                else {
                    if (0 !== $781b3e78c0ece49a$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $781b3e78c0ece49a$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $781b3e78c0ece49a$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, $781b3e78c0ece49a$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $781b3e78c0ece49a$var$B() > $781b3e78c0ece49a$var$Hj && (b.flags |= 128, d = !0, $781b3e78c0ece49a$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $781b3e78c0ece49a$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $781b3e78c0ece49a$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$781b3e78c0ece49a$var$I) return $781b3e78c0ece49a$var$S(b), null;
                    } else 2 * $781b3e78c0ece49a$var$B() - f.renderingStartTime > $781b3e78c0ece49a$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $781b3e78c0ece49a$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $781b3e78c0ece49a$var$B(), b.sibling = null, c = $781b3e78c0ece49a$var$M.current, $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$M, d ? c & 1 | 2 : c & 1), b;
            $781b3e78c0ece49a$var$S(b);
            return null;
        case 22:
        case 23:
            return $781b3e78c0ece49a$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($781b3e78c0ece49a$var$gj & 1073741824) && ($781b3e78c0ece49a$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $781b3e78c0ece49a$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($781b3e78c0ece49a$var$p(156, b.tag));
}
function $781b3e78c0ece49a$var$Jj(a, b) {
    $781b3e78c0ece49a$var$wg(b);
    switch(b.tag){
        case 1:
            return $781b3e78c0ece49a$var$Zf(b.type) && $781b3e78c0ece49a$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $781b3e78c0ece49a$var$Jh(), $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf), $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$H), $781b3e78c0ece49a$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $781b3e78c0ece49a$var$Lh(b), null;
        case 13:
            $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($781b3e78c0ece49a$var$p(340));
                $781b3e78c0ece49a$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M), null;
        case 4:
            return $781b3e78c0ece49a$var$Jh(), null;
        case 10:
            return $781b3e78c0ece49a$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $781b3e78c0ece49a$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $781b3e78c0ece49a$var$Kj = !1, $781b3e78c0ece49a$var$U = !1, $781b3e78c0ece49a$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $781b3e78c0ece49a$var$V = null;
function $781b3e78c0ece49a$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $781b3e78c0ece49a$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $781b3e78c0ece49a$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $781b3e78c0ece49a$var$W(a, b, d);
    }
}
var $781b3e78c0ece49a$var$Oj = !1;
function $781b3e78c0ece49a$var$Pj(a, b) {
    $781b3e78c0ece49a$var$Cf = $781b3e78c0ece49a$var$dd;
    a = $781b3e78c0ece49a$var$Me();
    if ($781b3e78c0ece49a$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $781b3e78c0ece49a$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $781b3e78c0ece49a$var$dd = !1;
    for($781b3e78c0ece49a$var$V = b; null !== $781b3e78c0ece49a$var$V;)if (b = $781b3e78c0ece49a$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $781b3e78c0ece49a$var$V = a;
    else for(; null !== $781b3e78c0ece49a$var$V;){
        b = $781b3e78c0ece49a$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $781b3e78c0ece49a$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($781b3e78c0ece49a$var$p(163));
            }
        } catch (F) {
            $781b3e78c0ece49a$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $781b3e78c0ece49a$var$V = a;
            break;
        }
        $781b3e78c0ece49a$var$V = b.return;
    }
    n = $781b3e78c0ece49a$var$Oj;
    $781b3e78c0ece49a$var$Oj = !1;
    return n;
}
function $781b3e78c0ece49a$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $781b3e78c0ece49a$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $781b3e78c0ece49a$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $781b3e78c0ece49a$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $781b3e78c0ece49a$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $781b3e78c0ece49a$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$781b3e78c0ece49a$var$Of], delete b[$781b3e78c0ece49a$var$Pf], delete b[$781b3e78c0ece49a$var$of], delete b[$781b3e78c0ece49a$var$Qf], delete b[$781b3e78c0ece49a$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $781b3e78c0ece49a$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $781b3e78c0ece49a$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $781b3e78c0ece49a$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $781b3e78c0ece49a$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $781b3e78c0ece49a$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($781b3e78c0ece49a$var$Wj(a, b, c), a = a.sibling; null !== a;)$781b3e78c0ece49a$var$Wj(a, b, c), a = a.sibling;
}
function $781b3e78c0ece49a$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($781b3e78c0ece49a$var$Xj(a, b, c), a = a.sibling; null !== a;)$781b3e78c0ece49a$var$Xj(a, b, c), a = a.sibling;
}
var $781b3e78c0ece49a$var$X = null, $781b3e78c0ece49a$var$Yj = !1;
function $781b3e78c0ece49a$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$781b3e78c0ece49a$var$ak(a, b, c), c = c.sibling;
}
function $781b3e78c0ece49a$var$ak(a, b, c) {
    if ($781b3e78c0ece49a$var$lc && "function" === typeof $781b3e78c0ece49a$var$lc.onCommitFiberUnmount) try {
        $781b3e78c0ece49a$var$lc.onCommitFiberUnmount($781b3e78c0ece49a$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $781b3e78c0ece49a$var$U || $781b3e78c0ece49a$var$Mj(c, b);
        case 6:
            var d = $781b3e78c0ece49a$var$X, e = $781b3e78c0ece49a$var$Yj;
            $781b3e78c0ece49a$var$X = null;
            $781b3e78c0ece49a$var$Zj(a, b, c);
            $781b3e78c0ece49a$var$X = d;
            $781b3e78c0ece49a$var$Yj = e;
            null !== $781b3e78c0ece49a$var$X && ($781b3e78c0ece49a$var$Yj ? (a = $781b3e78c0ece49a$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $781b3e78c0ece49a$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $781b3e78c0ece49a$var$X && ($781b3e78c0ece49a$var$Yj ? (a = $781b3e78c0ece49a$var$X, c = c.stateNode, 8 === a.nodeType ? $781b3e78c0ece49a$var$Kf(a.parentNode, c) : 1 === a.nodeType && $781b3e78c0ece49a$var$Kf(a, c), $781b3e78c0ece49a$var$bd(a)) : $781b3e78c0ece49a$var$Kf($781b3e78c0ece49a$var$X, c.stateNode));
            break;
        case 4:
            d = $781b3e78c0ece49a$var$X;
            e = $781b3e78c0ece49a$var$Yj;
            $781b3e78c0ece49a$var$X = c.stateNode.containerInfo;
            $781b3e78c0ece49a$var$Yj = !0;
            $781b3e78c0ece49a$var$Zj(a, b, c);
            $781b3e78c0ece49a$var$X = d;
            $781b3e78c0ece49a$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$781b3e78c0ece49a$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $781b3e78c0ece49a$var$Nj(c, b, g) : 0 !== (f & 4) && $781b3e78c0ece49a$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $781b3e78c0ece49a$var$Zj(a, b, c);
            break;
        case 1:
            if (!$781b3e78c0ece49a$var$U && ($781b3e78c0ece49a$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $781b3e78c0ece49a$var$W(c, b, h);
            }
            $781b3e78c0ece49a$var$Zj(a, b, c);
            break;
        case 21:
            $781b3e78c0ece49a$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($781b3e78c0ece49a$var$U = (d = $781b3e78c0ece49a$var$U) || null !== c.memoizedState, $781b3e78c0ece49a$var$Zj(a, b, c), $781b3e78c0ece49a$var$U = d) : $781b3e78c0ece49a$var$Zj(a, b, c);
            break;
        default:
            $781b3e78c0ece49a$var$Zj(a, b, c);
    }
}
function $781b3e78c0ece49a$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $781b3e78c0ece49a$var$Lj);
        b.forEach(function(b) {
            var d = $781b3e78c0ece49a$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $781b3e78c0ece49a$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $781b3e78c0ece49a$var$X = h.stateNode;
                        $781b3e78c0ece49a$var$Yj = !1;
                        break a;
                    case 3:
                        $781b3e78c0ece49a$var$X = h.stateNode.containerInfo;
                        $781b3e78c0ece49a$var$Yj = !0;
                        break a;
                    case 4:
                        $781b3e78c0ece49a$var$X = h.stateNode.containerInfo;
                        $781b3e78c0ece49a$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $781b3e78c0ece49a$var$X) throw Error($781b3e78c0ece49a$var$p(160));
            $781b3e78c0ece49a$var$ak(f, g, e);
            $781b3e78c0ece49a$var$X = null;
            $781b3e78c0ece49a$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $781b3e78c0ece49a$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$781b3e78c0ece49a$var$ek(b, a), b = b.sibling;
}
function $781b3e78c0ece49a$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            if (d & 4) {
                try {
                    $781b3e78c0ece49a$var$Qj(3, a, a.return), $781b3e78c0ece49a$var$Rj(3, a);
                } catch (t) {
                    $781b3e78c0ece49a$var$W(a, a.return, t);
                }
                try {
                    $781b3e78c0ece49a$var$Qj(5, a, a.return);
                } catch (t) {
                    $781b3e78c0ece49a$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            d & 512 && null !== c && $781b3e78c0ece49a$var$Mj(c, c.return);
            break;
        case 5:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            d & 512 && null !== c && $781b3e78c0ece49a$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $781b3e78c0ece49a$var$ob(e, "");
                } catch (t) {
                    $781b3e78c0ece49a$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $781b3e78c0ece49a$var$ab(e, f);
                    $781b3e78c0ece49a$var$vb(h, g);
                    var l = $781b3e78c0ece49a$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $781b3e78c0ece49a$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $781b3e78c0ece49a$var$nb(e, q) : "children" === m ? $781b3e78c0ece49a$var$ob(e, q) : $781b3e78c0ece49a$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $781b3e78c0ece49a$var$bb(e, f);
                            break;
                        case "textarea":
                            $781b3e78c0ece49a$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $781b3e78c0ece49a$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $781b3e78c0ece49a$var$fb(e, !!f.multiple, f.defaultValue, !0) : $781b3e78c0ece49a$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$781b3e78c0ece49a$var$Pf] = f;
                } catch (t) {
                    $781b3e78c0ece49a$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($781b3e78c0ece49a$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $781b3e78c0ece49a$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $781b3e78c0ece49a$var$bd(b.containerInfo);
            } catch (t) {
                $781b3e78c0ece49a$var$W(a, a.return, t);
            }
            break;
        case 4:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            break;
        case 13:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($781b3e78c0ece49a$var$gk = $781b3e78c0ece49a$var$B()));
            d & 4 && $781b3e78c0ece49a$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($781b3e78c0ece49a$var$U = (l = $781b3e78c0ece49a$var$U) || m, $781b3e78c0ece49a$var$dk(b, a), $781b3e78c0ece49a$var$U = l) : $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($781b3e78c0ece49a$var$V = a, m = a.child; null !== m;){
                    for(q = $781b3e78c0ece49a$var$V = m; null !== $781b3e78c0ece49a$var$V;){
                        r = $781b3e78c0ece49a$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $781b3e78c0ece49a$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $781b3e78c0ece49a$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $781b3e78c0ece49a$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $781b3e78c0ece49a$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $781b3e78c0ece49a$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $781b3e78c0ece49a$var$V = y) : $781b3e78c0ece49a$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $781b3e78c0ece49a$var$rb("display", g));
                            } catch (t) {
                                $781b3e78c0ece49a$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $781b3e78c0ece49a$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $781b3e78c0ece49a$var$dk(b, a);
            $781b3e78c0ece49a$var$fk(a);
            d & 4 && $781b3e78c0ece49a$var$bk(a);
            break;
        case 21:
            break;
        default:
            $781b3e78c0ece49a$var$dk(b, a), $781b3e78c0ece49a$var$fk(a);
    }
}
function $781b3e78c0ece49a$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($781b3e78c0ece49a$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($781b3e78c0ece49a$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($781b3e78c0ece49a$var$ob(e, ""), d.flags &= -33);
                    var f = $781b3e78c0ece49a$var$Vj(a);
                    $781b3e78c0ece49a$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $781b3e78c0ece49a$var$Vj(a);
                    $781b3e78c0ece49a$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($781b3e78c0ece49a$var$p(161));
            }
        } catch (k) {
            $781b3e78c0ece49a$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $781b3e78c0ece49a$var$ik(a, b, c) {
    $781b3e78c0ece49a$var$V = a;
    $781b3e78c0ece49a$var$jk(a, b, c);
}
function $781b3e78c0ece49a$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $781b3e78c0ece49a$var$V;){
        var e = $781b3e78c0ece49a$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $781b3e78c0ece49a$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $781b3e78c0ece49a$var$U;
                h = $781b3e78c0ece49a$var$Kj;
                var l = $781b3e78c0ece49a$var$U;
                $781b3e78c0ece49a$var$Kj = g;
                if (($781b3e78c0ece49a$var$U = k) && !l) for($781b3e78c0ece49a$var$V = e; null !== $781b3e78c0ece49a$var$V;)g = $781b3e78c0ece49a$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $781b3e78c0ece49a$var$kk(e) : null !== k ? (k.return = g, $781b3e78c0ece49a$var$V = k) : $781b3e78c0ece49a$var$kk(e);
                for(; null !== f;)$781b3e78c0ece49a$var$V = f, $781b3e78c0ece49a$var$jk(f, b, c), f = f.sibling;
                $781b3e78c0ece49a$var$V = e;
                $781b3e78c0ece49a$var$Kj = h;
                $781b3e78c0ece49a$var$U = l;
            }
            $781b3e78c0ece49a$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $781b3e78c0ece49a$var$V = f) : $781b3e78c0ece49a$var$lk(a, b, c);
    }
}
function $781b3e78c0ece49a$var$lk(a) {
    for(; null !== $781b3e78c0ece49a$var$V;){
        var b = $781b3e78c0ece49a$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $781b3e78c0ece49a$var$U || $781b3e78c0ece49a$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$781b3e78c0ece49a$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $781b3e78c0ece49a$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $781b3e78c0ece49a$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $781b3e78c0ece49a$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $781b3e78c0ece49a$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($781b3e78c0ece49a$var$p(163));
                }
                $781b3e78c0ece49a$var$U || b.flags & 512 && $781b3e78c0ece49a$var$Sj(b);
            } catch (r) {
                $781b3e78c0ece49a$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $781b3e78c0ece49a$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $781b3e78c0ece49a$var$V = c;
            break;
        }
        $781b3e78c0ece49a$var$V = b.return;
    }
}
function $781b3e78c0ece49a$var$hk(a) {
    for(; null !== $781b3e78c0ece49a$var$V;){
        var b = $781b3e78c0ece49a$var$V;
        if (b === a) {
            $781b3e78c0ece49a$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $781b3e78c0ece49a$var$V = c;
            break;
        }
        $781b3e78c0ece49a$var$V = b.return;
    }
}
function $781b3e78c0ece49a$var$kk(a) {
    for(; null !== $781b3e78c0ece49a$var$V;){
        var b = $781b3e78c0ece49a$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $781b3e78c0ece49a$var$Rj(4, b);
                    } catch (k) {
                        $781b3e78c0ece49a$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $781b3e78c0ece49a$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $781b3e78c0ece49a$var$Sj(b);
                    } catch (k) {
                        $781b3e78c0ece49a$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $781b3e78c0ece49a$var$Sj(b);
                    } catch (k) {
                        $781b3e78c0ece49a$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $781b3e78c0ece49a$var$W(b, b.return, k);
        }
        if (b === a) {
            $781b3e78c0ece49a$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $781b3e78c0ece49a$var$V = h;
            break;
        }
        $781b3e78c0ece49a$var$V = b.return;
    }
}
var $781b3e78c0ece49a$var$mk = Math.ceil, $781b3e78c0ece49a$var$nk = $781b3e78c0ece49a$var$ua.ReactCurrentDispatcher, $781b3e78c0ece49a$var$ok = $781b3e78c0ece49a$var$ua.ReactCurrentOwner, $781b3e78c0ece49a$var$pk = $781b3e78c0ece49a$var$ua.ReactCurrentBatchConfig, $781b3e78c0ece49a$var$K = 0, $781b3e78c0ece49a$var$R = null, $781b3e78c0ece49a$var$Y = null, $781b3e78c0ece49a$var$Z = 0, $781b3e78c0ece49a$var$gj = 0, $781b3e78c0ece49a$var$fj = $781b3e78c0ece49a$var$Uf(0), $781b3e78c0ece49a$var$T = 0, $781b3e78c0ece49a$var$qk = null, $781b3e78c0ece49a$var$hh = 0, $781b3e78c0ece49a$var$rk = 0, $781b3e78c0ece49a$var$sk = 0, $781b3e78c0ece49a$var$tk = null, $781b3e78c0ece49a$var$uk = null, $781b3e78c0ece49a$var$gk = 0, $781b3e78c0ece49a$var$Hj = Infinity, $781b3e78c0ece49a$var$vk = null, $781b3e78c0ece49a$var$Pi = !1, $781b3e78c0ece49a$var$Qi = null, $781b3e78c0ece49a$var$Si = null, $781b3e78c0ece49a$var$wk = !1, $781b3e78c0ece49a$var$xk = null, $781b3e78c0ece49a$var$yk = 0, $781b3e78c0ece49a$var$zk = 0, $781b3e78c0ece49a$var$Ak = null, $781b3e78c0ece49a$var$Bk = -1, $781b3e78c0ece49a$var$Ck = 0;
function $781b3e78c0ece49a$var$L() {
    return 0 !== ($781b3e78c0ece49a$var$K & 6) ? $781b3e78c0ece49a$var$B() : -1 !== $781b3e78c0ece49a$var$Bk ? $781b3e78c0ece49a$var$Bk : $781b3e78c0ece49a$var$Bk = $781b3e78c0ece49a$var$B();
}
function $781b3e78c0ece49a$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($781b3e78c0ece49a$var$K & 2) && 0 !== $781b3e78c0ece49a$var$Z) return $781b3e78c0ece49a$var$Z & -$781b3e78c0ece49a$var$Z;
    if (null !== $781b3e78c0ece49a$var$Kg.transition) return 0 === $781b3e78c0ece49a$var$Ck && ($781b3e78c0ece49a$var$Ck = $781b3e78c0ece49a$var$yc()), $781b3e78c0ece49a$var$Ck;
    a = $781b3e78c0ece49a$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $781b3e78c0ece49a$var$jd(a.type);
    return a;
}
function $781b3e78c0ece49a$var$mh(a, b, c, d) {
    if (50 < $781b3e78c0ece49a$var$zk) throw $781b3e78c0ece49a$var$zk = 0, $781b3e78c0ece49a$var$Ak = null, Error($781b3e78c0ece49a$var$p(185));
    $781b3e78c0ece49a$var$Ac(a, c, d);
    if (0 === ($781b3e78c0ece49a$var$K & 2) || a !== $781b3e78c0ece49a$var$R) a === $781b3e78c0ece49a$var$R && (0 === ($781b3e78c0ece49a$var$K & 2) && ($781b3e78c0ece49a$var$rk |= c), 4 === $781b3e78c0ece49a$var$T && $781b3e78c0ece49a$var$Dk(a, $781b3e78c0ece49a$var$Z)), $781b3e78c0ece49a$var$Ek(a, d), 1 === c && 0 === $781b3e78c0ece49a$var$K && 0 === (b.mode & 1) && ($781b3e78c0ece49a$var$Hj = $781b3e78c0ece49a$var$B() + 500, $781b3e78c0ece49a$var$fg && $781b3e78c0ece49a$var$jg());
}
function $781b3e78c0ece49a$var$Ek(a, b) {
    var c = a.callbackNode;
    $781b3e78c0ece49a$var$wc(a, b);
    var d = $781b3e78c0ece49a$var$uc(a, a === $781b3e78c0ece49a$var$R ? $781b3e78c0ece49a$var$Z : 0);
    if (0 === d) null !== c && $781b3e78c0ece49a$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $781b3e78c0ece49a$var$bc(c);
        if (1 === b) 0 === a.tag ? $781b3e78c0ece49a$var$ig($781b3e78c0ece49a$var$Fk.bind(null, a)) : $781b3e78c0ece49a$var$hg($781b3e78c0ece49a$var$Fk.bind(null, a)), $781b3e78c0ece49a$var$Jf(function() {
            0 === ($781b3e78c0ece49a$var$K & 6) && $781b3e78c0ece49a$var$jg();
        }), c = null;
        else {
            switch($781b3e78c0ece49a$var$Dc(d)){
                case 1:
                    c = $781b3e78c0ece49a$var$fc;
                    break;
                case 4:
                    c = $781b3e78c0ece49a$var$gc;
                    break;
                case 16:
                    c = $781b3e78c0ece49a$var$hc;
                    break;
                case 536870912:
                    c = $781b3e78c0ece49a$var$jc;
                    break;
                default:
                    c = $781b3e78c0ece49a$var$hc;
            }
            c = $781b3e78c0ece49a$var$Gk(c, $781b3e78c0ece49a$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $781b3e78c0ece49a$var$Hk(a, b) {
    $781b3e78c0ece49a$var$Bk = -1;
    $781b3e78c0ece49a$var$Ck = 0;
    if (0 !== ($781b3e78c0ece49a$var$K & 6)) throw Error($781b3e78c0ece49a$var$p(327));
    var c = a.callbackNode;
    if ($781b3e78c0ece49a$var$Ik() && a.callbackNode !== c) return null;
    var d = $781b3e78c0ece49a$var$uc(a, a === $781b3e78c0ece49a$var$R ? $781b3e78c0ece49a$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $781b3e78c0ece49a$var$Jk(a, d);
    else {
        b = d;
        var e = $781b3e78c0ece49a$var$K;
        $781b3e78c0ece49a$var$K |= 2;
        var f = $781b3e78c0ece49a$var$Kk();
        if ($781b3e78c0ece49a$var$R !== a || $781b3e78c0ece49a$var$Z !== b) $781b3e78c0ece49a$var$vk = null, $781b3e78c0ece49a$var$Hj = $781b3e78c0ece49a$var$B() + 500, $781b3e78c0ece49a$var$Lk(a, b);
        for(;;)try {
            $781b3e78c0ece49a$var$Mk();
            break;
        } catch (h) {
            $781b3e78c0ece49a$var$Nk(a, h);
        }
        $781b3e78c0ece49a$var$Qg();
        $781b3e78c0ece49a$var$nk.current = f;
        $781b3e78c0ece49a$var$K = e;
        null !== $781b3e78c0ece49a$var$Y ? b = 0 : ($781b3e78c0ece49a$var$R = null, $781b3e78c0ece49a$var$Z = 0, b = $781b3e78c0ece49a$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $781b3e78c0ece49a$var$xc(a), 0 !== e && (d = e, b = $781b3e78c0ece49a$var$Ok(a, e)));
        if (1 === b) throw c = $781b3e78c0ece49a$var$qk, $781b3e78c0ece49a$var$Lk(a, 0), $781b3e78c0ece49a$var$Dk(a, d), $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B()), c;
        if (6 === b) $781b3e78c0ece49a$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$781b3e78c0ece49a$var$Pk(e) && (b = $781b3e78c0ece49a$var$Jk(a, d), 2 === b && (f = $781b3e78c0ece49a$var$xc(a), 0 !== f && (d = f, b = $781b3e78c0ece49a$var$Ok(a, f))), 1 === b)) throw c = $781b3e78c0ece49a$var$qk, $781b3e78c0ece49a$var$Lk(a, 0), $781b3e78c0ece49a$var$Dk(a, d), $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($781b3e78c0ece49a$var$p(345));
                case 2:
                    $781b3e78c0ece49a$var$Qk(a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk);
                    break;
                case 3:
                    $781b3e78c0ece49a$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $781b3e78c0ece49a$var$gk + 500 - $781b3e78c0ece49a$var$B(), 10 < b)) {
                        if (0 !== $781b3e78c0ece49a$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $781b3e78c0ece49a$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $781b3e78c0ece49a$var$Ff($781b3e78c0ece49a$var$Qk.bind(null, a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk), b);
                        break;
                    }
                    $781b3e78c0ece49a$var$Qk(a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk);
                    break;
                case 4:
                    $781b3e78c0ece49a$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $781b3e78c0ece49a$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $781b3e78c0ece49a$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $781b3e78c0ece49a$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $781b3e78c0ece49a$var$Ff($781b3e78c0ece49a$var$Qk.bind(null, a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk), d);
                        break;
                    }
                    $781b3e78c0ece49a$var$Qk(a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk);
                    break;
                case 5:
                    $781b3e78c0ece49a$var$Qk(a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk);
                    break;
                default:
                    throw Error($781b3e78c0ece49a$var$p(329));
            }
        }
    }
    $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B());
    return a.callbackNode === c ? $781b3e78c0ece49a$var$Hk.bind(null, a) : null;
}
function $781b3e78c0ece49a$var$Ok(a, b) {
    var c = $781b3e78c0ece49a$var$tk;
    a.current.memoizedState.isDehydrated && ($781b3e78c0ece49a$var$Lk(a, b).flags |= 256);
    a = $781b3e78c0ece49a$var$Jk(a, b);
    2 !== a && (b = $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$uk = c, null !== b && $781b3e78c0ece49a$var$Gj(b));
    return a;
}
function $781b3e78c0ece49a$var$Gj(a) {
    null === $781b3e78c0ece49a$var$uk ? $781b3e78c0ece49a$var$uk = a : $781b3e78c0ece49a$var$uk.push.apply($781b3e78c0ece49a$var$uk, a);
}
function $781b3e78c0ece49a$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$781b3e78c0ece49a$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $781b3e78c0ece49a$var$Dk(a, b) {
    b &= ~$781b3e78c0ece49a$var$sk;
    b &= ~$781b3e78c0ece49a$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $781b3e78c0ece49a$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $781b3e78c0ece49a$var$Fk(a) {
    if (0 !== ($781b3e78c0ece49a$var$K & 6)) throw Error($781b3e78c0ece49a$var$p(327));
    $781b3e78c0ece49a$var$Ik();
    var b = $781b3e78c0ece49a$var$uc(a, 0);
    if (0 === (b & 1)) return $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B()), null;
    var c = $781b3e78c0ece49a$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $781b3e78c0ece49a$var$xc(a);
        0 !== d && (b = d, c = $781b3e78c0ece49a$var$Ok(a, d));
    }
    if (1 === c) throw c = $781b3e78c0ece49a$var$qk, $781b3e78c0ece49a$var$Lk(a, 0), $781b3e78c0ece49a$var$Dk(a, b), $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B()), c;
    if (6 === c) throw Error($781b3e78c0ece49a$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $781b3e78c0ece49a$var$Qk(a, $781b3e78c0ece49a$var$uk, $781b3e78c0ece49a$var$vk);
    $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B());
    return null;
}
function $781b3e78c0ece49a$var$Rk(a, b) {
    var c = $781b3e78c0ece49a$var$K;
    $781b3e78c0ece49a$var$K |= 1;
    try {
        return a(b);
    } finally{
        $781b3e78c0ece49a$var$K = c, 0 === $781b3e78c0ece49a$var$K && ($781b3e78c0ece49a$var$Hj = $781b3e78c0ece49a$var$B() + 500, $781b3e78c0ece49a$var$fg && $781b3e78c0ece49a$var$jg());
    }
}
function $781b3e78c0ece49a$var$Sk(a) {
    null !== $781b3e78c0ece49a$var$xk && 0 === $781b3e78c0ece49a$var$xk.tag && 0 === ($781b3e78c0ece49a$var$K & 6) && $781b3e78c0ece49a$var$Ik();
    var b = $781b3e78c0ece49a$var$K;
    $781b3e78c0ece49a$var$K |= 1;
    var c = $781b3e78c0ece49a$var$pk.transition, d = $781b3e78c0ece49a$var$C;
    try {
        if ($781b3e78c0ece49a$var$pk.transition = null, $781b3e78c0ece49a$var$C = 1, a) return a();
    } finally{
        $781b3e78c0ece49a$var$C = d, $781b3e78c0ece49a$var$pk.transition = c, $781b3e78c0ece49a$var$K = b, 0 === ($781b3e78c0ece49a$var$K & 6) && $781b3e78c0ece49a$var$jg();
    }
}
function $781b3e78c0ece49a$var$Ij() {
    $781b3e78c0ece49a$var$gj = $781b3e78c0ece49a$var$fj.current;
    $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$fj);
}
function $781b3e78c0ece49a$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $781b3e78c0ece49a$var$Gf(c));
    if (null !== $781b3e78c0ece49a$var$Y) for(c = $781b3e78c0ece49a$var$Y.return; null !== c;){
        var d = c;
        $781b3e78c0ece49a$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $781b3e78c0ece49a$var$$f();
                break;
            case 3:
                $781b3e78c0ece49a$var$Jh();
                $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$Wf);
                $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$H);
                $781b3e78c0ece49a$var$Oh();
                break;
            case 5:
                $781b3e78c0ece49a$var$Lh(d);
                break;
            case 4:
                $781b3e78c0ece49a$var$Jh();
                break;
            case 13:
                $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M);
                break;
            case 19:
                $781b3e78c0ece49a$var$E($781b3e78c0ece49a$var$M);
                break;
            case 10:
                $781b3e78c0ece49a$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $781b3e78c0ece49a$var$Ij();
        }
        c = c.return;
    }
    $781b3e78c0ece49a$var$R = a;
    $781b3e78c0ece49a$var$Y = a = $781b3e78c0ece49a$var$wh(a.current, null);
    $781b3e78c0ece49a$var$Z = $781b3e78c0ece49a$var$gj = b;
    $781b3e78c0ece49a$var$T = 0;
    $781b3e78c0ece49a$var$qk = null;
    $781b3e78c0ece49a$var$sk = $781b3e78c0ece49a$var$rk = $781b3e78c0ece49a$var$hh = 0;
    $781b3e78c0ece49a$var$uk = $781b3e78c0ece49a$var$tk = null;
    if (null !== $781b3e78c0ece49a$var$Wg) {
        for(b = 0; b < $781b3e78c0ece49a$var$Wg.length; b++)if (c = $781b3e78c0ece49a$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $781b3e78c0ece49a$var$Wg = null;
    }
    return a;
}
function $781b3e78c0ece49a$var$Nk(a, b) {
    do {
        var c = $781b3e78c0ece49a$var$Y;
        try {
            $781b3e78c0ece49a$var$Qg();
            $781b3e78c0ece49a$var$Ph.current = $781b3e78c0ece49a$var$ai;
            if ($781b3e78c0ece49a$var$Sh) {
                for(var d = $781b3e78c0ece49a$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $781b3e78c0ece49a$var$Sh = !1;
            }
            $781b3e78c0ece49a$var$Rh = 0;
            $781b3e78c0ece49a$var$P = $781b3e78c0ece49a$var$O = $781b3e78c0ece49a$var$N = null;
            $781b3e78c0ece49a$var$Th = !1;
            $781b3e78c0ece49a$var$Uh = 0;
            $781b3e78c0ece49a$var$ok.current = null;
            if (null === c || null === c.return) {
                $781b3e78c0ece49a$var$T = 1;
                $781b3e78c0ece49a$var$qk = b;
                $781b3e78c0ece49a$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $781b3e78c0ece49a$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $781b3e78c0ece49a$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $781b3e78c0ece49a$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $781b3e78c0ece49a$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $781b3e78c0ece49a$var$Ti(f, l, b);
                            $781b3e78c0ece49a$var$uj();
                            break a;
                        }
                        k = Error($781b3e78c0ece49a$var$p(426));
                    }
                } else if ($781b3e78c0ece49a$var$I && h.mode & 1) {
                    var J = $781b3e78c0ece49a$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $781b3e78c0ece49a$var$Wi(J, g, h, f, b);
                        $781b3e78c0ece49a$var$Jg($781b3e78c0ece49a$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $781b3e78c0ece49a$var$Ki(k, h);
                4 !== $781b3e78c0ece49a$var$T && ($781b3e78c0ece49a$var$T = 2);
                null === $781b3e78c0ece49a$var$tk ? $781b3e78c0ece49a$var$tk = [
                    f
                ] : $781b3e78c0ece49a$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $781b3e78c0ece49a$var$Oi(f, k, b);
                            $781b3e78c0ece49a$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $781b3e78c0ece49a$var$Si || !$781b3e78c0ece49a$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $781b3e78c0ece49a$var$Ri(f, h, b);
                                $781b3e78c0ece49a$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $781b3e78c0ece49a$var$Tk(c);
        } catch (na) {
            b = na;
            $781b3e78c0ece49a$var$Y === c && null !== c && ($781b3e78c0ece49a$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $781b3e78c0ece49a$var$Kk() {
    var a = $781b3e78c0ece49a$var$nk.current;
    $781b3e78c0ece49a$var$nk.current = $781b3e78c0ece49a$var$ai;
    return null === a ? $781b3e78c0ece49a$var$ai : a;
}
function $781b3e78c0ece49a$var$uj() {
    if (0 === $781b3e78c0ece49a$var$T || 3 === $781b3e78c0ece49a$var$T || 2 === $781b3e78c0ece49a$var$T) $781b3e78c0ece49a$var$T = 4;
    null === $781b3e78c0ece49a$var$R || 0 === ($781b3e78c0ece49a$var$hh & 268435455) && 0 === ($781b3e78c0ece49a$var$rk & 268435455) || $781b3e78c0ece49a$var$Dk($781b3e78c0ece49a$var$R, $781b3e78c0ece49a$var$Z);
}
function $781b3e78c0ece49a$var$Jk(a, b) {
    var c = $781b3e78c0ece49a$var$K;
    $781b3e78c0ece49a$var$K |= 2;
    var d = $781b3e78c0ece49a$var$Kk();
    if ($781b3e78c0ece49a$var$R !== a || $781b3e78c0ece49a$var$Z !== b) $781b3e78c0ece49a$var$vk = null, $781b3e78c0ece49a$var$Lk(a, b);
    for(;;)try {
        $781b3e78c0ece49a$var$Uk();
        break;
    } catch (e) {
        $781b3e78c0ece49a$var$Nk(a, e);
    }
    $781b3e78c0ece49a$var$Qg();
    $781b3e78c0ece49a$var$K = c;
    $781b3e78c0ece49a$var$nk.current = d;
    if (null !== $781b3e78c0ece49a$var$Y) throw Error($781b3e78c0ece49a$var$p(261));
    $781b3e78c0ece49a$var$R = null;
    $781b3e78c0ece49a$var$Z = 0;
    return $781b3e78c0ece49a$var$T;
}
function $781b3e78c0ece49a$var$Uk() {
    for(; null !== $781b3e78c0ece49a$var$Y;)$781b3e78c0ece49a$var$Vk($781b3e78c0ece49a$var$Y);
}
function $781b3e78c0ece49a$var$Mk() {
    for(; null !== $781b3e78c0ece49a$var$Y && !$781b3e78c0ece49a$var$cc();)$781b3e78c0ece49a$var$Vk($781b3e78c0ece49a$var$Y);
}
function $781b3e78c0ece49a$var$Vk(a) {
    var b = $781b3e78c0ece49a$var$Wk(a.alternate, a, $781b3e78c0ece49a$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $781b3e78c0ece49a$var$Tk(a) : $781b3e78c0ece49a$var$Y = b;
    $781b3e78c0ece49a$var$ok.current = null;
}
function $781b3e78c0ece49a$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $781b3e78c0ece49a$var$Fj(c, b, $781b3e78c0ece49a$var$gj), null !== c) {
                $781b3e78c0ece49a$var$Y = c;
                return;
            }
        } else {
            c = $781b3e78c0ece49a$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $781b3e78c0ece49a$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $781b3e78c0ece49a$var$T = 6;
                $781b3e78c0ece49a$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $781b3e78c0ece49a$var$Y = b;
            return;
        }
        $781b3e78c0ece49a$var$Y = b = a;
    }while (null !== b);
    0 === $781b3e78c0ece49a$var$T && ($781b3e78c0ece49a$var$T = 5);
}
function $781b3e78c0ece49a$var$Qk(a, b, c) {
    var d = $781b3e78c0ece49a$var$C, e = $781b3e78c0ece49a$var$pk.transition;
    try {
        $781b3e78c0ece49a$var$pk.transition = null, $781b3e78c0ece49a$var$C = 1, $781b3e78c0ece49a$var$Xk(a, b, c, d);
    } finally{
        $781b3e78c0ece49a$var$pk.transition = e, $781b3e78c0ece49a$var$C = d;
    }
    return null;
}
function $781b3e78c0ece49a$var$Xk(a, b, c, d) {
    do $781b3e78c0ece49a$var$Ik();
    while (null !== $781b3e78c0ece49a$var$xk);
    if (0 !== ($781b3e78c0ece49a$var$K & 6)) throw Error($781b3e78c0ece49a$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($781b3e78c0ece49a$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $781b3e78c0ece49a$var$Bc(a, f);
    a === $781b3e78c0ece49a$var$R && ($781b3e78c0ece49a$var$Y = $781b3e78c0ece49a$var$R = null, $781b3e78c0ece49a$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $781b3e78c0ece49a$var$wk || ($781b3e78c0ece49a$var$wk = !0, $781b3e78c0ece49a$var$Gk($781b3e78c0ece49a$var$hc, function() {
        $781b3e78c0ece49a$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $781b3e78c0ece49a$var$pk.transition;
        $781b3e78c0ece49a$var$pk.transition = null;
        var g = $781b3e78c0ece49a$var$C;
        $781b3e78c0ece49a$var$C = 1;
        var h = $781b3e78c0ece49a$var$K;
        $781b3e78c0ece49a$var$K |= 4;
        $781b3e78c0ece49a$var$ok.current = null;
        $781b3e78c0ece49a$var$Pj(a, c);
        $781b3e78c0ece49a$var$ek(c, a);
        $781b3e78c0ece49a$var$Oe($781b3e78c0ece49a$var$Df);
        $781b3e78c0ece49a$var$dd = !!$781b3e78c0ece49a$var$Cf;
        $781b3e78c0ece49a$var$Df = $781b3e78c0ece49a$var$Cf = null;
        a.current = c;
        $781b3e78c0ece49a$var$ik(c, a, e);
        $781b3e78c0ece49a$var$dc();
        $781b3e78c0ece49a$var$K = h;
        $781b3e78c0ece49a$var$C = g;
        $781b3e78c0ece49a$var$pk.transition = f;
    } else a.current = c;
    $781b3e78c0ece49a$var$wk && ($781b3e78c0ece49a$var$wk = !1, $781b3e78c0ece49a$var$xk = a, $781b3e78c0ece49a$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($781b3e78c0ece49a$var$Si = null);
    $781b3e78c0ece49a$var$mc(c.stateNode, d);
    $781b3e78c0ece49a$var$Ek(a, $781b3e78c0ece49a$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($781b3e78c0ece49a$var$Pi) throw $781b3e78c0ece49a$var$Pi = !1, a = $781b3e78c0ece49a$var$Qi, $781b3e78c0ece49a$var$Qi = null, a;
    0 !== ($781b3e78c0ece49a$var$yk & 1) && 0 !== a.tag && $781b3e78c0ece49a$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $781b3e78c0ece49a$var$Ak ? $781b3e78c0ece49a$var$zk++ : ($781b3e78c0ece49a$var$zk = 0, $781b3e78c0ece49a$var$Ak = a) : $781b3e78c0ece49a$var$zk = 0;
    $781b3e78c0ece49a$var$jg();
    return null;
}
function $781b3e78c0ece49a$var$Ik() {
    if (null !== $781b3e78c0ece49a$var$xk) {
        var a = $781b3e78c0ece49a$var$Dc($781b3e78c0ece49a$var$yk), b = $781b3e78c0ece49a$var$pk.transition, c = $781b3e78c0ece49a$var$C;
        try {
            $781b3e78c0ece49a$var$pk.transition = null;
            $781b3e78c0ece49a$var$C = 16 > a ? 16 : a;
            if (null === $781b3e78c0ece49a$var$xk) var d = !1;
            else {
                a = $781b3e78c0ece49a$var$xk;
                $781b3e78c0ece49a$var$xk = null;
                $781b3e78c0ece49a$var$yk = 0;
                if (0 !== ($781b3e78c0ece49a$var$K & 6)) throw Error($781b3e78c0ece49a$var$p(331));
                var e = $781b3e78c0ece49a$var$K;
                $781b3e78c0ece49a$var$K |= 4;
                for($781b3e78c0ece49a$var$V = a.current; null !== $781b3e78c0ece49a$var$V;){
                    var f = $781b3e78c0ece49a$var$V, g = f.child;
                    if (0 !== ($781b3e78c0ece49a$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($781b3e78c0ece49a$var$V = l; null !== $781b3e78c0ece49a$var$V;){
                                    var m = $781b3e78c0ece49a$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $781b3e78c0ece49a$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $781b3e78c0ece49a$var$V = q;
                                    else for(; null !== $781b3e78c0ece49a$var$V;){
                                        m = $781b3e78c0ece49a$var$V;
                                        var r = m.sibling, y = m.return;
                                        $781b3e78c0ece49a$var$Tj(m);
                                        if (m === l) {
                                            $781b3e78c0ece49a$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $781b3e78c0ece49a$var$V = r;
                                            break;
                                        }
                                        $781b3e78c0ece49a$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $781b3e78c0ece49a$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $781b3e78c0ece49a$var$V = g;
                    else b: for(; null !== $781b3e78c0ece49a$var$V;){
                        f = $781b3e78c0ece49a$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $781b3e78c0ece49a$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $781b3e78c0ece49a$var$V = x;
                            break b;
                        }
                        $781b3e78c0ece49a$var$V = f.return;
                    }
                }
                var w = a.current;
                for($781b3e78c0ece49a$var$V = w; null !== $781b3e78c0ece49a$var$V;){
                    g = $781b3e78c0ece49a$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $781b3e78c0ece49a$var$V = u;
                    else b: for(g = w; null !== $781b3e78c0ece49a$var$V;){
                        h = $781b3e78c0ece49a$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $781b3e78c0ece49a$var$Rj(9, h);
                            }
                        } catch (na) {
                            $781b3e78c0ece49a$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $781b3e78c0ece49a$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $781b3e78c0ece49a$var$V = F;
                            break b;
                        }
                        $781b3e78c0ece49a$var$V = h.return;
                    }
                }
                $781b3e78c0ece49a$var$K = e;
                $781b3e78c0ece49a$var$jg();
                if ($781b3e78c0ece49a$var$lc && "function" === typeof $781b3e78c0ece49a$var$lc.onPostCommitFiberRoot) try {
                    $781b3e78c0ece49a$var$lc.onPostCommitFiberRoot($781b3e78c0ece49a$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $781b3e78c0ece49a$var$C = c, $781b3e78c0ece49a$var$pk.transition = b;
        }
    }
    return !1;
}
function $781b3e78c0ece49a$var$Yk(a, b, c) {
    b = $781b3e78c0ece49a$var$Ki(c, b);
    b = $781b3e78c0ece49a$var$Oi(a, b, 1);
    a = $781b3e78c0ece49a$var$dh(a, b, 1);
    b = $781b3e78c0ece49a$var$L();
    null !== a && ($781b3e78c0ece49a$var$Ac(a, 1, b), $781b3e78c0ece49a$var$Ek(a, b));
}
function $781b3e78c0ece49a$var$W(a, b, c) {
    if (3 === a.tag) $781b3e78c0ece49a$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $781b3e78c0ece49a$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $781b3e78c0ece49a$var$Si || !$781b3e78c0ece49a$var$Si.has(d))) {
                a = $781b3e78c0ece49a$var$Ki(c, a);
                a = $781b3e78c0ece49a$var$Ri(b, a, 1);
                b = $781b3e78c0ece49a$var$dh(b, a, 1);
                a = $781b3e78c0ece49a$var$L();
                null !== b && ($781b3e78c0ece49a$var$Ac(b, 1, a), $781b3e78c0ece49a$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $781b3e78c0ece49a$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $781b3e78c0ece49a$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $781b3e78c0ece49a$var$R === a && ($781b3e78c0ece49a$var$Z & c) === c && (4 === $781b3e78c0ece49a$var$T || 3 === $781b3e78c0ece49a$var$T && ($781b3e78c0ece49a$var$Z & 130023424) === $781b3e78c0ece49a$var$Z && 500 > $781b3e78c0ece49a$var$B() - $781b3e78c0ece49a$var$gk ? $781b3e78c0ece49a$var$Lk(a, 0) : $781b3e78c0ece49a$var$sk |= c);
    $781b3e78c0ece49a$var$Ek(a, b);
}
function $781b3e78c0ece49a$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $781b3e78c0ece49a$var$sc, $781b3e78c0ece49a$var$sc <<= 1, 0 === ($781b3e78c0ece49a$var$sc & 130023424) && ($781b3e78c0ece49a$var$sc = 4194304)));
    var c = $781b3e78c0ece49a$var$L();
    a = $781b3e78c0ece49a$var$Zg(a, b);
    null !== a && ($781b3e78c0ece49a$var$Ac(a, b, c), $781b3e78c0ece49a$var$Ek(a, c));
}
function $781b3e78c0ece49a$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $781b3e78c0ece49a$var$Zk(a, c);
}
function $781b3e78c0ece49a$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($781b3e78c0ece49a$var$p(314));
    }
    null !== d && d.delete(b);
    $781b3e78c0ece49a$var$Zk(a, c);
}
var $781b3e78c0ece49a$var$Wk;
$781b3e78c0ece49a$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $781b3e78c0ece49a$var$Wf.current) $781b3e78c0ece49a$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $781b3e78c0ece49a$var$Ug = !1, $781b3e78c0ece49a$var$zj(a, b, c);
            $781b3e78c0ece49a$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $781b3e78c0ece49a$var$Ug = !1, $781b3e78c0ece49a$var$I && 0 !== (b.flags & 1048576) && $781b3e78c0ece49a$var$ug(b, $781b3e78c0ece49a$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $781b3e78c0ece49a$var$jj(a, b);
            a = b.pendingProps;
            var e = $781b3e78c0ece49a$var$Yf(b, $781b3e78c0ece49a$var$H.current);
            $781b3e78c0ece49a$var$Tg(b, c);
            e = $781b3e78c0ece49a$var$Xh(null, b, d, a, e, c);
            var f = $781b3e78c0ece49a$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $781b3e78c0ece49a$var$Zf(d) ? (f = !0, $781b3e78c0ece49a$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $781b3e78c0ece49a$var$ah(b), e.updater = $781b3e78c0ece49a$var$nh, b.stateNode = e, e._reactInternals = b, $781b3e78c0ece49a$var$rh(b, d, a, c), b = $781b3e78c0ece49a$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $781b3e78c0ece49a$var$I && f && $781b3e78c0ece49a$var$vg(b), $781b3e78c0ece49a$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $781b3e78c0ece49a$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $781b3e78c0ece49a$var$$k(d);
                a = $781b3e78c0ece49a$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $781b3e78c0ece49a$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $781b3e78c0ece49a$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $781b3e78c0ece49a$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $781b3e78c0ece49a$var$aj(null, b, d, $781b3e78c0ece49a$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($781b3e78c0ece49a$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $781b3e78c0ece49a$var$Lg(d, e), $781b3e78c0ece49a$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $781b3e78c0ece49a$var$Lg(d, e), $781b3e78c0ece49a$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $781b3e78c0ece49a$var$lj(b);
                if (null === a) throw Error($781b3e78c0ece49a$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $781b3e78c0ece49a$var$bh(a, b);
                $781b3e78c0ece49a$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $781b3e78c0ece49a$var$Ki(Error($781b3e78c0ece49a$var$p(423)), b);
                        b = $781b3e78c0ece49a$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $781b3e78c0ece49a$var$Ki(Error($781b3e78c0ece49a$var$p(424)), b);
                        b = $781b3e78c0ece49a$var$mj(a, b, d, c, e);
                        break a;
                    } else for($781b3e78c0ece49a$var$yg = $781b3e78c0ece49a$var$Lf(b.stateNode.containerInfo.firstChild), $781b3e78c0ece49a$var$xg = b, $781b3e78c0ece49a$var$I = !0, $781b3e78c0ece49a$var$zg = null, c = $781b3e78c0ece49a$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $781b3e78c0ece49a$var$Ig();
                    if (d === e) {
                        b = $781b3e78c0ece49a$var$$i(a, b, c);
                        break a;
                    }
                    $781b3e78c0ece49a$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $781b3e78c0ece49a$var$Kh(b), null === a && $781b3e78c0ece49a$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $781b3e78c0ece49a$var$Ef(d, e) ? g = null : null !== f && $781b3e78c0ece49a$var$Ef(d, f) && (b.flags |= 32), $781b3e78c0ece49a$var$hj(a, b), $781b3e78c0ece49a$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $781b3e78c0ece49a$var$Eg(b), null;
        case 13:
            return $781b3e78c0ece49a$var$pj(a, b, c);
        case 4:
            return $781b3e78c0ece49a$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $781b3e78c0ece49a$var$Bh(b, null, d, c) : $781b3e78c0ece49a$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $781b3e78c0ece49a$var$Lg(d, e), $781b3e78c0ece49a$var$Zi(a, b, d, e, c);
        case 7:
            return $781b3e78c0ece49a$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $781b3e78c0ece49a$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $781b3e78c0ece49a$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $781b3e78c0ece49a$var$G($781b3e78c0ece49a$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($781b3e78c0ece49a$var$He(f.value, g)) {
                        if (f.children === e.children && !$781b3e78c0ece49a$var$Wf.current) {
                            b = $781b3e78c0ece49a$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $781b3e78c0ece49a$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $781b3e78c0ece49a$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($781b3e78c0ece49a$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $781b3e78c0ece49a$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $781b3e78c0ece49a$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $781b3e78c0ece49a$var$Tg(b, c), e = $781b3e78c0ece49a$var$Vg(e), d = d(e), b.flags |= 1, $781b3e78c0ece49a$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $781b3e78c0ece49a$var$Lg(d, b.pendingProps), e = $781b3e78c0ece49a$var$Lg(d.type, e), $781b3e78c0ece49a$var$aj(a, b, d, e, c);
        case 15:
            return $781b3e78c0ece49a$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $781b3e78c0ece49a$var$Lg(d, e), $781b3e78c0ece49a$var$jj(a, b), b.tag = 1, $781b3e78c0ece49a$var$Zf(d) ? (a = !0, $781b3e78c0ece49a$var$cg(b)) : a = !1, $781b3e78c0ece49a$var$Tg(b, c), $781b3e78c0ece49a$var$ph(b, d, e), $781b3e78c0ece49a$var$rh(b, d, e, c), $781b3e78c0ece49a$var$kj(null, b, d, !0, a, c);
        case 19:
            return $781b3e78c0ece49a$var$yj(a, b, c);
        case 22:
            return $781b3e78c0ece49a$var$ej(a, b, c);
    }
    throw Error($781b3e78c0ece49a$var$p(156, b.tag));
};
function $781b3e78c0ece49a$var$Gk(a, b) {
    return $781b3e78c0ece49a$var$ac(a, b);
}
function $781b3e78c0ece49a$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $781b3e78c0ece49a$var$Bg(a, b, c, d) {
    return new $781b3e78c0ece49a$var$al(a, b, c, d);
}
function $781b3e78c0ece49a$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $781b3e78c0ece49a$var$$k(a) {
    if ("function" === typeof a) return $781b3e78c0ece49a$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $781b3e78c0ece49a$var$Da) return 11;
        if (a === $781b3e78c0ece49a$var$Ga) return 14;
    }
    return 2;
}
function $781b3e78c0ece49a$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $781b3e78c0ece49a$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $781b3e78c0ece49a$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $781b3e78c0ece49a$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $781b3e78c0ece49a$var$ya:
            return $781b3e78c0ece49a$var$Ah(c.children, e, f, b);
        case $781b3e78c0ece49a$var$za:
            g = 8;
            e |= 8;
            break;
        case $781b3e78c0ece49a$var$Aa:
            return a = $781b3e78c0ece49a$var$Bg(12, c, b, e | 2), a.elementType = $781b3e78c0ece49a$var$Aa, a.lanes = f, a;
        case $781b3e78c0ece49a$var$Ea:
            return a = $781b3e78c0ece49a$var$Bg(13, c, b, e), a.elementType = $781b3e78c0ece49a$var$Ea, a.lanes = f, a;
        case $781b3e78c0ece49a$var$Fa:
            return a = $781b3e78c0ece49a$var$Bg(19, c, b, e), a.elementType = $781b3e78c0ece49a$var$Fa, a.lanes = f, a;
        case $781b3e78c0ece49a$var$Ia:
            return $781b3e78c0ece49a$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $781b3e78c0ece49a$var$Ba:
                    g = 10;
                    break a;
                case $781b3e78c0ece49a$var$Ca:
                    g = 9;
                    break a;
                case $781b3e78c0ece49a$var$Da:
                    g = 11;
                    break a;
                case $781b3e78c0ece49a$var$Ga:
                    g = 14;
                    break a;
                case $781b3e78c0ece49a$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($781b3e78c0ece49a$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $781b3e78c0ece49a$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $781b3e78c0ece49a$var$Ah(a, b, c, d) {
    a = $781b3e78c0ece49a$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $781b3e78c0ece49a$var$qj(a, b, c, d) {
    a = $781b3e78c0ece49a$var$Bg(22, a, d, b);
    a.elementType = $781b3e78c0ece49a$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $781b3e78c0ece49a$var$xh(a, b, c) {
    a = $781b3e78c0ece49a$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $781b3e78c0ece49a$var$zh(a, b, c) {
    b = $781b3e78c0ece49a$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $781b3e78c0ece49a$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $781b3e78c0ece49a$var$zc(0);
    this.expirationTimes = $781b3e78c0ece49a$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $781b3e78c0ece49a$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $781b3e78c0ece49a$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $781b3e78c0ece49a$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $781b3e78c0ece49a$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $781b3e78c0ece49a$var$ah(f);
    return a;
}
function $781b3e78c0ece49a$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $781b3e78c0ece49a$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $781b3e78c0ece49a$var$el(a) {
    if (!a) return $781b3e78c0ece49a$var$Vf;
    a = a._reactInternals;
    a: {
        if ($781b3e78c0ece49a$var$Vb(a) !== a || 1 !== a.tag) throw Error($781b3e78c0ece49a$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($781b3e78c0ece49a$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($781b3e78c0ece49a$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($781b3e78c0ece49a$var$Zf(c)) return $781b3e78c0ece49a$var$bg(a, c, b);
    }
    return b;
}
function $781b3e78c0ece49a$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $781b3e78c0ece49a$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $781b3e78c0ece49a$var$el(null);
    c = a.current;
    d = $781b3e78c0ece49a$var$L();
    e = $781b3e78c0ece49a$var$lh(c);
    f = $781b3e78c0ece49a$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $781b3e78c0ece49a$var$dh(c, f, e);
    a.current.lanes = e;
    $781b3e78c0ece49a$var$Ac(a, e, d);
    $781b3e78c0ece49a$var$Ek(a, d);
    return a;
}
function $781b3e78c0ece49a$var$gl(a, b, c, d) {
    var e = b.current, f = $781b3e78c0ece49a$var$L(), g = $781b3e78c0ece49a$var$lh(e);
    c = $781b3e78c0ece49a$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $781b3e78c0ece49a$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $781b3e78c0ece49a$var$dh(e, b, g);
    null !== a && ($781b3e78c0ece49a$var$mh(a, e, g, f), $781b3e78c0ece49a$var$eh(a, e, g));
    return g;
}
function $781b3e78c0ece49a$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $781b3e78c0ece49a$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $781b3e78c0ece49a$var$jl(a, b) {
    $781b3e78c0ece49a$var$il(a, b);
    (a = a.alternate) && $781b3e78c0ece49a$var$il(a, b);
}
function $781b3e78c0ece49a$var$kl() {
    return null;
}
var $781b3e78c0ece49a$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $781b3e78c0ece49a$var$ml(a) {
    this._internalRoot = a;
}
$781b3e78c0ece49a$var$nl.prototype.render = $781b3e78c0ece49a$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($781b3e78c0ece49a$var$p(409));
    $781b3e78c0ece49a$var$gl(a, b, null, null);
};
$781b3e78c0ece49a$var$nl.prototype.unmount = $781b3e78c0ece49a$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $781b3e78c0ece49a$var$Sk(function() {
            $781b3e78c0ece49a$var$gl(null, a, null, null);
        });
        b[$781b3e78c0ece49a$var$uf] = null;
    }
};
function $781b3e78c0ece49a$var$nl(a) {
    this._internalRoot = a;
}
$781b3e78c0ece49a$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $781b3e78c0ece49a$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $781b3e78c0ece49a$var$Qc.length && 0 !== b && b < $781b3e78c0ece49a$var$Qc[c].priority; c++);
        $781b3e78c0ece49a$var$Qc.splice(c, 0, a);
        0 === c && $781b3e78c0ece49a$var$Vc(a);
    }
};
function $781b3e78c0ece49a$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $781b3e78c0ece49a$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $781b3e78c0ece49a$var$ql() {}
function $781b3e78c0ece49a$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $781b3e78c0ece49a$var$hl(g);
                f.call(a);
            };
        }
        var g = $781b3e78c0ece49a$var$fl(b, d, a, 0, null, !1, !1, "", $781b3e78c0ece49a$var$ql);
        a._reactRootContainer = g;
        a[$781b3e78c0ece49a$var$uf] = g.current;
        $781b3e78c0ece49a$var$sf(8 === a.nodeType ? a.parentNode : a);
        $781b3e78c0ece49a$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $781b3e78c0ece49a$var$hl(k);
            h.call(a);
        };
    }
    var k = $781b3e78c0ece49a$var$cl(a, 0, !1, null, null, !1, !1, "", $781b3e78c0ece49a$var$ql);
    a._reactRootContainer = k;
    a[$781b3e78c0ece49a$var$uf] = k.current;
    $781b3e78c0ece49a$var$sf(8 === a.nodeType ? a.parentNode : a);
    $781b3e78c0ece49a$var$Sk(function() {
        $781b3e78c0ece49a$var$gl(b, k, c, d);
    });
    return k;
}
function $781b3e78c0ece49a$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $781b3e78c0ece49a$var$hl(g);
                h.call(a);
            };
        }
        $781b3e78c0ece49a$var$gl(b, g, a, e);
    } else g = $781b3e78c0ece49a$var$rl(c, b, a, e, d);
    return $781b3e78c0ece49a$var$hl(g);
}
$781b3e78c0ece49a$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $781b3e78c0ece49a$var$tc(b.pendingLanes);
                0 !== c && ($781b3e78c0ece49a$var$Cc(b, c | 1), $781b3e78c0ece49a$var$Ek(b, $781b3e78c0ece49a$var$B()), 0 === ($781b3e78c0ece49a$var$K & 6) && ($781b3e78c0ece49a$var$Hj = $781b3e78c0ece49a$var$B() + 500, $781b3e78c0ece49a$var$jg()));
            }
            break;
        case 13:
            $781b3e78c0ece49a$var$Sk(function() {
                var b = $781b3e78c0ece49a$var$Zg(a, 1);
                if (null !== b) {
                    var c = $781b3e78c0ece49a$var$L();
                    $781b3e78c0ece49a$var$mh(b, a, 1, c);
                }
            }), $781b3e78c0ece49a$var$jl(a, 1);
    }
};
$781b3e78c0ece49a$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $781b3e78c0ece49a$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $781b3e78c0ece49a$var$L();
            $781b3e78c0ece49a$var$mh(b, a, 134217728, c);
        }
        $781b3e78c0ece49a$var$jl(a, 134217728);
    }
};
$781b3e78c0ece49a$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $781b3e78c0ece49a$var$lh(a), c = $781b3e78c0ece49a$var$Zg(a, b);
        if (null !== c) {
            var d = $781b3e78c0ece49a$var$L();
            $781b3e78c0ece49a$var$mh(c, a, b, d);
        }
        $781b3e78c0ece49a$var$jl(a, b);
    }
};
$781b3e78c0ece49a$var$Hc = function() {
    return $781b3e78c0ece49a$var$C;
};
$781b3e78c0ece49a$var$Ic = function(a, b) {
    var c = $781b3e78c0ece49a$var$C;
    try {
        return $781b3e78c0ece49a$var$C = a, b();
    } finally{
        $781b3e78c0ece49a$var$C = c;
    }
};
$781b3e78c0ece49a$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $781b3e78c0ece49a$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $781b3e78c0ece49a$var$Db(d);
                        if (!e) throw Error($781b3e78c0ece49a$var$p(90));
                        $781b3e78c0ece49a$var$Wa(d);
                        $781b3e78c0ece49a$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $781b3e78c0ece49a$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $781b3e78c0ece49a$var$fb(a, !!c.multiple, b, !1);
    }
};
$781b3e78c0ece49a$var$Gb = $781b3e78c0ece49a$var$Rk;
$781b3e78c0ece49a$var$Hb = $781b3e78c0ece49a$var$Sk;
var $781b3e78c0ece49a$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $781b3e78c0ece49a$var$Cb,
        $781b3e78c0ece49a$var$ue,
        $781b3e78c0ece49a$var$Db,
        $781b3e78c0ece49a$var$Eb,
        $781b3e78c0ece49a$var$Fb,
        $781b3e78c0ece49a$var$Rk
    ]
}, $781b3e78c0ece49a$var$ul = {
    findFiberByHostInstance: $781b3e78c0ece49a$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $781b3e78c0ece49a$var$vl = {
    bundleType: $781b3e78c0ece49a$var$ul.bundleType,
    version: $781b3e78c0ece49a$var$ul.version,
    rendererPackageName: $781b3e78c0ece49a$var$ul.rendererPackageName,
    rendererConfig: $781b3e78c0ece49a$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $781b3e78c0ece49a$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $781b3e78c0ece49a$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $781b3e78c0ece49a$var$ul.findFiberByHostInstance || $781b3e78c0ece49a$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $781b3e78c0ece49a$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$781b3e78c0ece49a$var$wl.isDisabled && $781b3e78c0ece49a$var$wl.supportsFiber) try {
        $781b3e78c0ece49a$var$kc = $781b3e78c0ece49a$var$wl.inject($781b3e78c0ece49a$var$vl), $781b3e78c0ece49a$var$lc = $781b3e78c0ece49a$var$wl;
    } catch (a) {}
}
$781b3e78c0ece49a$export$ae55be85d98224ed = $781b3e78c0ece49a$var$tl;
$781b3e78c0ece49a$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$781b3e78c0ece49a$var$ol(b)) throw Error($781b3e78c0ece49a$var$p(200));
    return $781b3e78c0ece49a$var$dl(a, b, null, c);
};
$781b3e78c0ece49a$export$882461b6382ed46c = function(a, b) {
    if (!$781b3e78c0ece49a$var$ol(a)) throw Error($781b3e78c0ece49a$var$p(299));
    var c = !1, d = "", e = $781b3e78c0ece49a$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $781b3e78c0ece49a$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$781b3e78c0ece49a$var$uf] = b.current;
    $781b3e78c0ece49a$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $781b3e78c0ece49a$var$ml(b);
};
$781b3e78c0ece49a$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($781b3e78c0ece49a$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($781b3e78c0ece49a$var$p(268, a));
    }
    a = $781b3e78c0ece49a$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$781b3e78c0ece49a$export$cd75ccfd720a3cd4 = function(a) {
    return $781b3e78c0ece49a$var$Sk(a);
};
$781b3e78c0ece49a$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$781b3e78c0ece49a$var$pl(b)) throw Error($781b3e78c0ece49a$var$p(200));
    return $781b3e78c0ece49a$var$sl(null, a, b, !0, c);
};
$781b3e78c0ece49a$export$757ceba2d55c277e = function(a, b, c) {
    if (!$781b3e78c0ece49a$var$ol(a)) throw Error($781b3e78c0ece49a$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $781b3e78c0ece49a$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $781b3e78c0ece49a$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$781b3e78c0ece49a$var$uf] = b.current;
    $781b3e78c0ece49a$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $781b3e78c0ece49a$var$nl(b);
};
$781b3e78c0ece49a$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$781b3e78c0ece49a$var$pl(b)) throw Error($781b3e78c0ece49a$var$p(200));
    return $781b3e78c0ece49a$var$sl(null, a, b, !1, c);
};
$781b3e78c0ece49a$export$502457920280e6be = function(a) {
    if (!$781b3e78c0ece49a$var$pl(a)) throw Error($781b3e78c0ece49a$var$p(40));
    return a._reactRootContainer ? ($781b3e78c0ece49a$var$Sk(function() {
        $781b3e78c0ece49a$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$781b3e78c0ece49a$var$uf] = null;
        });
    }), !0) : !1;
};
$781b3e78c0ece49a$export$c78a37762a8d58e1 = $781b3e78c0ece49a$var$Rk;
$781b3e78c0ece49a$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$781b3e78c0ece49a$var$pl(c)) throw Error($781b3e78c0ece49a$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($781b3e78c0ece49a$var$p(38));
    return $781b3e78c0ece49a$var$sl(a, b, c, !1, d);
};
$781b3e78c0ece49a$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRequire.register("f2Ki7", function(module, exports) {
"use strict";

module.exports = (parcelRequire("6UJWw"));

});
parcelRequire.register("6UJWw", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $508b9c545b0bd231$export$c4744153514ff05d; }, function (v) { return $508b9c545b0bd231$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $508b9c545b0bd231$export$3e506c1ccc9cc1a7; }, function (v) { return $508b9c545b0bd231$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $508b9c545b0bd231$export$e26fe2ed2fa76875; }, function (v) { return $508b9c545b0bd231$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $508b9c545b0bd231$export$502329bbf4b505b1; }, function (v) { return $508b9c545b0bd231$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $508b9c545b0bd231$export$6e3807111c4874c4; }, function (v) { return $508b9c545b0bd231$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $508b9c545b0bd231$export$c27134553091fb3a; }, function (v) { return $508b9c545b0bd231$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $508b9c545b0bd231$export$33ee1acdc04fd2a2; }, function (v) { return $508b9c545b0bd231$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $508b9c545b0bd231$export$b00a404bbd5edef2; }, function (v) { return $508b9c545b0bd231$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $508b9c545b0bd231$export$8352ce38b91d0c62; }, function (v) { return $508b9c545b0bd231$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $508b9c545b0bd231$export$d66a1c1c77bd778b; }, function (v) { return $508b9c545b0bd231$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $508b9c545b0bd231$export$d3dfb8e4810cb555; }, function (v) { return $508b9c545b0bd231$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $508b9c545b0bd231$export$839f9183b0465a69; }, function (v) { return $508b9c545b0bd231$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $508b9c545b0bd231$export$72fdf0e06517287b; }, function (v) { return $508b9c545b0bd231$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $508b9c545b0bd231$export$4b844e58a3e414b4; }, function (v) { return $508b9c545b0bd231$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $508b9c545b0bd231$export$816d2913ae6b83b1; }, function (v) { return $508b9c545b0bd231$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $508b9c545b0bd231$export$61bcfe829111a1d0; }, function (v) { return $508b9c545b0bd231$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $508b9c545b0bd231$export$7ee8c9beb337bc3f; }, function (v) { return $508b9c545b0bd231$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $508b9c545b0bd231$export$b5836b71941fa3ed; }, function (v) { return $508b9c545b0bd231$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $508b9c545b0bd231$export$cf845f2c119da08a; }, function (v) { return $508b9c545b0bd231$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $508b9c545b0bd231$export$c4744153514ff05d;
var $508b9c545b0bd231$export$3e506c1ccc9cc1a7;
var $508b9c545b0bd231$export$e26fe2ed2fa76875;
var $508b9c545b0bd231$export$502329bbf4b505b1;
var $508b9c545b0bd231$export$6e3807111c4874c4;
var $508b9c545b0bd231$export$c27134553091fb3a;
var $508b9c545b0bd231$export$33ee1acdc04fd2a2;
var $508b9c545b0bd231$export$b00a404bbd5edef2;
var $508b9c545b0bd231$export$8352ce38b91d0c62;
var $508b9c545b0bd231$export$d66a1c1c77bd778b;
var $508b9c545b0bd231$export$d3dfb8e4810cb555;
var $508b9c545b0bd231$export$839f9183b0465a69;
var $508b9c545b0bd231$export$72fdf0e06517287b;
var $508b9c545b0bd231$export$4b844e58a3e414b4;
var $508b9c545b0bd231$export$816d2913ae6b83b1;
var $508b9c545b0bd231$export$61bcfe829111a1d0;
var $508b9c545b0bd231$export$7ee8c9beb337bc3f;
var $508b9c545b0bd231$export$b5836b71941fa3ed;
var $508b9c545b0bd231$export$cf845f2c119da08a;
"use strict";
function $508b9c545b0bd231$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $508b9c545b0bd231$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $508b9c545b0bd231$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $508b9c545b0bd231$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $508b9c545b0bd231$var$g(C, c)) n < e && 0 > $508b9c545b0bd231$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $508b9c545b0bd231$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $508b9c545b0bd231$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $508b9c545b0bd231$var$l = performance;
    $508b9c545b0bd231$export$c4744153514ff05d = function() {
        return $508b9c545b0bd231$var$l.now();
    };
} else {
    var $508b9c545b0bd231$var$p = Date, $508b9c545b0bd231$var$q = $508b9c545b0bd231$var$p.now();
    $508b9c545b0bd231$export$c4744153514ff05d = function() {
        return $508b9c545b0bd231$var$p.now() - $508b9c545b0bd231$var$q;
    };
}
var $508b9c545b0bd231$var$r = [], $508b9c545b0bd231$var$t = [], $508b9c545b0bd231$var$u = 1, $508b9c545b0bd231$var$v = null, $508b9c545b0bd231$var$y = 3, $508b9c545b0bd231$var$z = !1, $508b9c545b0bd231$var$A = !1, $508b9c545b0bd231$var$B = !1, $508b9c545b0bd231$var$D = "function" === typeof setTimeout ? setTimeout : null, $508b9c545b0bd231$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $508b9c545b0bd231$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $508b9c545b0bd231$var$G(a) {
    for(var b = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$t); null !== b;){
        if (null === b.callback) $508b9c545b0bd231$var$k($508b9c545b0bd231$var$t);
        else if (b.startTime <= a) $508b9c545b0bd231$var$k($508b9c545b0bd231$var$t), b.sortIndex = b.expirationTime, $508b9c545b0bd231$var$f($508b9c545b0bd231$var$r, b);
        else break;
        b = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$t);
    }
}
function $508b9c545b0bd231$var$H(a) {
    $508b9c545b0bd231$var$B = !1;
    $508b9c545b0bd231$var$G(a);
    if (!$508b9c545b0bd231$var$A) {
        if (null !== $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r)) $508b9c545b0bd231$var$A = !0, $508b9c545b0bd231$var$I($508b9c545b0bd231$var$J);
        else {
            var b = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$t);
            null !== b && $508b9c545b0bd231$var$K($508b9c545b0bd231$var$H, b.startTime - a);
        }
    }
}
function $508b9c545b0bd231$var$J(a, b) {
    $508b9c545b0bd231$var$A = !1;
    $508b9c545b0bd231$var$B && ($508b9c545b0bd231$var$B = !1, $508b9c545b0bd231$var$E($508b9c545b0bd231$var$L), $508b9c545b0bd231$var$L = -1);
    $508b9c545b0bd231$var$z = !0;
    var c = $508b9c545b0bd231$var$y;
    try {
        $508b9c545b0bd231$var$G(b);
        for($508b9c545b0bd231$var$v = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r); null !== $508b9c545b0bd231$var$v && (!($508b9c545b0bd231$var$v.expirationTime > b) || a && !$508b9c545b0bd231$var$M());){
            var d = $508b9c545b0bd231$var$v.callback;
            if ("function" === typeof d) {
                $508b9c545b0bd231$var$v.callback = null;
                $508b9c545b0bd231$var$y = $508b9c545b0bd231$var$v.priorityLevel;
                var e = d($508b9c545b0bd231$var$v.expirationTime <= b);
                b = $508b9c545b0bd231$export$c4744153514ff05d();
                "function" === typeof e ? $508b9c545b0bd231$var$v.callback = e : $508b9c545b0bd231$var$v === $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r) && $508b9c545b0bd231$var$k($508b9c545b0bd231$var$r);
                $508b9c545b0bd231$var$G(b);
            } else $508b9c545b0bd231$var$k($508b9c545b0bd231$var$r);
            $508b9c545b0bd231$var$v = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r);
        }
        if (null !== $508b9c545b0bd231$var$v) var w = !0;
        else {
            var m = $508b9c545b0bd231$var$h($508b9c545b0bd231$var$t);
            null !== m && $508b9c545b0bd231$var$K($508b9c545b0bd231$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $508b9c545b0bd231$var$v = null, $508b9c545b0bd231$var$y = c, $508b9c545b0bd231$var$z = !1;
    }
}
var $508b9c545b0bd231$var$N = !1, $508b9c545b0bd231$var$O = null, $508b9c545b0bd231$var$L = -1, $508b9c545b0bd231$var$P = 5, $508b9c545b0bd231$var$Q = -1;
function $508b9c545b0bd231$var$M() {
    return $508b9c545b0bd231$export$c4744153514ff05d() - $508b9c545b0bd231$var$Q < $508b9c545b0bd231$var$P ? !1 : !0;
}
function $508b9c545b0bd231$var$R() {
    if (null !== $508b9c545b0bd231$var$O) {
        var a = $508b9c545b0bd231$export$c4744153514ff05d();
        $508b9c545b0bd231$var$Q = a;
        var b = !0;
        try {
            b = $508b9c545b0bd231$var$O(!0, a);
        } finally{
            b ? $508b9c545b0bd231$var$S() : ($508b9c545b0bd231$var$N = !1, $508b9c545b0bd231$var$O = null);
        }
    } else $508b9c545b0bd231$var$N = !1;
}
var $508b9c545b0bd231$var$S;
if ("function" === typeof $508b9c545b0bd231$var$F) $508b9c545b0bd231$var$S = function() {
    $508b9c545b0bd231$var$F($508b9c545b0bd231$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $508b9c545b0bd231$var$T = new MessageChannel, $508b9c545b0bd231$var$U = $508b9c545b0bd231$var$T.port2;
    $508b9c545b0bd231$var$T.port1.onmessage = $508b9c545b0bd231$var$R;
    $508b9c545b0bd231$var$S = function() {
        $508b9c545b0bd231$var$U.postMessage(null);
    };
} else $508b9c545b0bd231$var$S = function() {
    $508b9c545b0bd231$var$D($508b9c545b0bd231$var$R, 0);
};
function $508b9c545b0bd231$var$I(a) {
    $508b9c545b0bd231$var$O = a;
    $508b9c545b0bd231$var$N || ($508b9c545b0bd231$var$N = !0, $508b9c545b0bd231$var$S());
}
function $508b9c545b0bd231$var$K(a, b) {
    $508b9c545b0bd231$var$L = $508b9c545b0bd231$var$D(function() {
        a($508b9c545b0bd231$export$c4744153514ff05d());
    }, b);
}
$508b9c545b0bd231$export$3e506c1ccc9cc1a7 = 5;
$508b9c545b0bd231$export$e26fe2ed2fa76875 = 1;
$508b9c545b0bd231$export$502329bbf4b505b1 = 4;
$508b9c545b0bd231$export$6e3807111c4874c4 = 3;
$508b9c545b0bd231$export$c27134553091fb3a = null;
$508b9c545b0bd231$export$33ee1acdc04fd2a2 = 2;
$508b9c545b0bd231$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$508b9c545b0bd231$export$8352ce38b91d0c62 = function() {
    $508b9c545b0bd231$var$A || $508b9c545b0bd231$var$z || ($508b9c545b0bd231$var$A = !0, $508b9c545b0bd231$var$I($508b9c545b0bd231$var$J));
};
$508b9c545b0bd231$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $508b9c545b0bd231$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$508b9c545b0bd231$export$d3dfb8e4810cb555 = function() {
    return $508b9c545b0bd231$var$y;
};
$508b9c545b0bd231$export$839f9183b0465a69 = function() {
    return $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r);
};
$508b9c545b0bd231$export$72fdf0e06517287b = function(a) {
    switch($508b9c545b0bd231$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $508b9c545b0bd231$var$y;
    }
    var c = $508b9c545b0bd231$var$y;
    $508b9c545b0bd231$var$y = b;
    try {
        return a();
    } finally{
        $508b9c545b0bd231$var$y = c;
    }
};
$508b9c545b0bd231$export$4b844e58a3e414b4 = function() {};
$508b9c545b0bd231$export$816d2913ae6b83b1 = function() {};
$508b9c545b0bd231$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $508b9c545b0bd231$var$y;
    $508b9c545b0bd231$var$y = a;
    try {
        return b();
    } finally{
        $508b9c545b0bd231$var$y = c;
    }
};
$508b9c545b0bd231$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $508b9c545b0bd231$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $508b9c545b0bd231$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $508b9c545b0bd231$var$f($508b9c545b0bd231$var$t, a), null === $508b9c545b0bd231$var$h($508b9c545b0bd231$var$r) && a === $508b9c545b0bd231$var$h($508b9c545b0bd231$var$t) && ($508b9c545b0bd231$var$B ? ($508b9c545b0bd231$var$E($508b9c545b0bd231$var$L), $508b9c545b0bd231$var$L = -1) : $508b9c545b0bd231$var$B = !0, $508b9c545b0bd231$var$K($508b9c545b0bd231$var$H, c - d))) : (a.sortIndex = e, $508b9c545b0bd231$var$f($508b9c545b0bd231$var$r, a), $508b9c545b0bd231$var$A || $508b9c545b0bd231$var$z || ($508b9c545b0bd231$var$A = !0, $508b9c545b0bd231$var$I($508b9c545b0bd231$var$J)));
    return a;
};
$508b9c545b0bd231$export$b5836b71941fa3ed = $508b9c545b0bd231$var$M;
$508b9c545b0bd231$export$cf845f2c119da08a = function(a) {
    var b = $508b9c545b0bd231$var$y;
    return function() {
        var c = $508b9c545b0bd231$var$y;
        $508b9c545b0bd231$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $508b9c545b0bd231$var$y = c;
        }
    };
};

});




parcelRequire.register("hqomP", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $caf7c42fd7e03055$var$ReactIs, $caf7c42fd7e03055$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
module.exports = (parcelRequire("5P0qQ"))();

});
parcelRequire.register("5P0qQ", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";

var $cAdzk = parcelRequire("cAdzk");
function $43d20cf101dd7fbe$var$emptyFunction() {}
function $43d20cf101dd7fbe$var$emptyFunctionWithReset() {}
$43d20cf101dd7fbe$var$emptyFunctionWithReset.resetWarningCache = $43d20cf101dd7fbe$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $cAdzk) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = "Invariant Violation";
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $43d20cf101dd7fbe$var$emptyFunctionWithReset,
        resetWarningCache: $43d20cf101dd7fbe$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRequire.register("cAdzk", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var $92935f4beeeae20d$var$ReactPropTypesSecret = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
module.exports = $92935f4beeeae20d$var$ReactPropTypesSecret;

});



parcelRequire.register("bGN6i", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return (parcelRequire("5t2HV")).deduplicate; });
$parcel$export(module.exports, "isSameArray", function () { return (parcelRequire("5ddkS")).isSameArray; });
$parcel$export(module.exports, "cond", function () { return (parcelRequire("5CQIb")).cond; });
$parcel$export(module.exports, "condArray", function () { return (parcelRequire("5CQIb")).condArray; });
$parcel$export(module.exports, "conditional", function () { return (parcelRequire("5CQIb")).conditional; });
$parcel$export(module.exports, "conditionalArray", function () { return (parcelRequire("5CQIb")).conditionalArray; });
$parcel$export(module.exports, "conditionalString", function () { return (parcelRequire("5CQIb")).conditionalString; });
$parcel$export(module.exports, "noop", function () { return (parcelRequire("aWIy6")).noop; });
$parcel$export(module.exports, "trySafe", function () { return (parcelRequire("aWIy6")).trySafe; });
$parcel$export(module.exports, "pick", function () { return (parcelRequire("apgZ7")).pick; });
$parcel$export(module.exports, "yes", function () { return (parcelRequire("vZyB0")).yes; });
$parcel$export(module.exports, "getSafe", function () { return (parcelRequire("20diy")).getSafe; });
$parcel$export(module.exports, "appendPath", function () { return (parcelRequire("b9zrd")).appendPath; });
$parcel$export(module.exports, "joinPath", function () { return (parcelRequire("b9zrd")).joinPath; });

var $5t2HV = parcelRequire("5t2HV");

var $iAWsc = parcelRequire("iAWsc");

var $5ddkS = parcelRequire("5ddkS");

var $5CQIb = parcelRequire("5CQIb");

var $kIJjr = parcelRequire("kIJjr");

var $aWIy6 = parcelRequire("aWIy6");

var $apgZ7 = parcelRequire("apgZ7");

var $vZyB0 = parcelRequire("vZyB0");

var $20diy = parcelRequire("20diy");

var $b9zrd = parcelRequire("b9zrd");

var $gvOOV = parcelRequire("gvOOV");

var $gNTPK = parcelRequire("gNTPK");

});
parcelRequire.register("5t2HV", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return $3fb1c2ce947253f7$export$6b75200e58bc97d0; });
const $3fb1c2ce947253f7$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $3fb1c2ce947253f7$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $3fb1c2ce947253f7$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];

});

parcelRequire.register("iAWsc", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $d898ee7d6cf138f0$export$a7a9523472993e97; });
// https://github.com/facebook/jest/issues/7547
const $d898ee7d6cf138f0$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};

});

parcelRequire.register("5ddkS", function(module, exports) {

$parcel$export(module.exports, "isSameArray", function () { return $3cb882d9cd4d5d5c$export$12dc7a11e2f7584e; });
$parcel$export(module.exports, "notFalsy", function () { return $3cb882d9cd4d5d5c$export$ccb441c9c5feb3fc; });
// eslint-disable-next-line id-length
const $3cb882d9cd4d5d5c$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $3cb882d9cd4d5d5c$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($3cb882d9cd4d5d5c$var$compareFunction);
    const sortedB = array2.slice().sort($3cb882d9cd4d5d5c$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $3cb882d9cd4d5d5c$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $3cb882d9cd4d5d5c$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $3cb882d9cd4d5d5c$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $3cb882d9cd4d5d5c$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));

});

parcelRequire.register("5CQIb", function(module, exports) {

$parcel$export(module.exports, "conditional", function () { return $418963c68e68eac3$export$c327da55a124987a; });
$parcel$export(module.exports, "cond", function () { return $418963c68e68eac3$export$7ffafceb12143143; });
$parcel$export(module.exports, "conditionalString", function () { return $418963c68e68eac3$export$78aa88a01782ee9d; });
$parcel$export(module.exports, "conditionalArray", function () { return $418963c68e68eac3$export$c96eff0e57d59a5e; });
$parcel$export(module.exports, "condArray", function () { return $418963c68e68eac3$export$68c43792fed28aa6; });

var $5ddkS = parcelRequire("5ddkS");
const $418963c68e68eac3$export$133fc36489ac9add = (exp)=>(0, $5ddkS.notFalsy)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $418963c68e68eac3$export$c327da55a124987a = (exp)=>(0, $5ddkS.notFalsy)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $418963c68e68eac3$export$7ffafceb12143143 = $418963c68e68eac3$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $418963c68e68eac3$export$78aa88a01782ee9d = (exp)=>(0, $5ddkS.notFalsy)(exp) ? String(exp) : "";
/** Alias for {@link conditionalString}. */ const $418963c68e68eac3$export$723fe479c809eebc = $418963c68e68eac3$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $418963c68e68eac3$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $5ddkS.notFalsy)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $418963c68e68eac3$export$68c43792fed28aa6 = $418963c68e68eac3$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $418963c68e68eac3$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $5ddkS.notFalsy)(value)));
/** Alias for {@link conditionalObject}. */ const $418963c68e68eac3$export$48ab0026c89e64fa = $418963c68e68eac3$export$6d93be478c042166;

});

parcelRequire.register("kIJjr", function(module, exports) {

$parcel$export(module.exports, "isNode", function () { return $f15b10d9b57abe7c$export$8ee0fc9ee280b4ee; });

var $iAWsc = parcelRequire("iAWsc");

var $f9dfJ = parcelRequire("f9dfJ");
// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $f15b10d9b57abe7c$export$4bd44a2aa29d3d6e = (key, fallback = "")=>$f9dfJ?.env[key] ?? fallback;
const $f15b10d9b57abe7c$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $f15b10d9b57abe7c$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $f15b10d9b57abe7c$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $f9dfJ?.env[key];
    (0, $iAWsc.assert)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $f15b10d9b57abe7c$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";

});
parcelRequire.register("f9dfJ", function(module, exports) {
// shim for using process in browser
var $b071f9f9e2fee08d$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $b071f9f9e2fee08d$var$cachedSetTimeout;
var $b071f9f9e2fee08d$var$cachedClearTimeout;
function $b071f9f9e2fee08d$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $b071f9f9e2fee08d$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $b071f9f9e2fee08d$var$cachedSetTimeout = setTimeout;
        else $b071f9f9e2fee08d$var$cachedSetTimeout = $b071f9f9e2fee08d$var$defaultSetTimout;
    } catch (e) {
        $b071f9f9e2fee08d$var$cachedSetTimeout = $b071f9f9e2fee08d$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $b071f9f9e2fee08d$var$cachedClearTimeout = clearTimeout;
        else $b071f9f9e2fee08d$var$cachedClearTimeout = $b071f9f9e2fee08d$var$defaultClearTimeout;
    } catch (e) {
        $b071f9f9e2fee08d$var$cachedClearTimeout = $b071f9f9e2fee08d$var$defaultClearTimeout;
    }
})();
function $b071f9f9e2fee08d$var$runTimeout(fun) {
    if ($b071f9f9e2fee08d$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($b071f9f9e2fee08d$var$cachedSetTimeout === $b071f9f9e2fee08d$var$defaultSetTimout || !$b071f9f9e2fee08d$var$cachedSetTimeout) && setTimeout) {
        $b071f9f9e2fee08d$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b071f9f9e2fee08d$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $b071f9f9e2fee08d$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $b071f9f9e2fee08d$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $b071f9f9e2fee08d$var$runClearTimeout(marker) {
    if ($b071f9f9e2fee08d$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($b071f9f9e2fee08d$var$cachedClearTimeout === $b071f9f9e2fee08d$var$defaultClearTimeout || !$b071f9f9e2fee08d$var$cachedClearTimeout) && clearTimeout) {
        $b071f9f9e2fee08d$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $b071f9f9e2fee08d$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $b071f9f9e2fee08d$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $b071f9f9e2fee08d$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $b071f9f9e2fee08d$var$queue = [];
var $b071f9f9e2fee08d$var$draining = false;
var $b071f9f9e2fee08d$var$currentQueue;
var $b071f9f9e2fee08d$var$queueIndex = -1;
function $b071f9f9e2fee08d$var$cleanUpNextTick() {
    if (!$b071f9f9e2fee08d$var$draining || !$b071f9f9e2fee08d$var$currentQueue) return;
    $b071f9f9e2fee08d$var$draining = false;
    if ($b071f9f9e2fee08d$var$currentQueue.length) $b071f9f9e2fee08d$var$queue = $b071f9f9e2fee08d$var$currentQueue.concat($b071f9f9e2fee08d$var$queue);
    else $b071f9f9e2fee08d$var$queueIndex = -1;
    if ($b071f9f9e2fee08d$var$queue.length) $b071f9f9e2fee08d$var$drainQueue();
}
function $b071f9f9e2fee08d$var$drainQueue() {
    if ($b071f9f9e2fee08d$var$draining) return;
    var timeout = $b071f9f9e2fee08d$var$runTimeout($b071f9f9e2fee08d$var$cleanUpNextTick);
    $b071f9f9e2fee08d$var$draining = true;
    var len = $b071f9f9e2fee08d$var$queue.length;
    while(len){
        $b071f9f9e2fee08d$var$currentQueue = $b071f9f9e2fee08d$var$queue;
        $b071f9f9e2fee08d$var$queue = [];
        while(++$b071f9f9e2fee08d$var$queueIndex < len)if ($b071f9f9e2fee08d$var$currentQueue) $b071f9f9e2fee08d$var$currentQueue[$b071f9f9e2fee08d$var$queueIndex].run();
        $b071f9f9e2fee08d$var$queueIndex = -1;
        len = $b071f9f9e2fee08d$var$queue.length;
    }
    $b071f9f9e2fee08d$var$currentQueue = null;
    $b071f9f9e2fee08d$var$draining = false;
    $b071f9f9e2fee08d$var$runClearTimeout(timeout);
}
$b071f9f9e2fee08d$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $b071f9f9e2fee08d$var$queue.push(new $b071f9f9e2fee08d$var$Item(fun, args));
    if ($b071f9f9e2fee08d$var$queue.length === 1 && !$b071f9f9e2fee08d$var$draining) $b071f9f9e2fee08d$var$runTimeout($b071f9f9e2fee08d$var$drainQueue);
};
// v8 likes predictible objects
function $b071f9f9e2fee08d$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$b071f9f9e2fee08d$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$b071f9f9e2fee08d$var$process.title = "browser";
$b071f9f9e2fee08d$var$process.browser = true;
$b071f9f9e2fee08d$var$process.env = {};
$b071f9f9e2fee08d$var$process.argv = [];
$b071f9f9e2fee08d$var$process.version = ""; // empty string to avoid regexp issues
$b071f9f9e2fee08d$var$process.versions = {};
function $b071f9f9e2fee08d$var$noop() {}
$b071f9f9e2fee08d$var$process.on = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.addListener = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.once = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.off = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.removeListener = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.removeAllListeners = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.emit = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.prependListener = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.prependOnceListener = $b071f9f9e2fee08d$var$noop;
$b071f9f9e2fee08d$var$process.listeners = function(name) {
    return [];
};
$b071f9f9e2fee08d$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$b071f9f9e2fee08d$var$process.cwd = function() {
    return "/";
};
$b071f9f9e2fee08d$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$b071f9f9e2fee08d$var$process.umask = function() {
    return 0;
};

});


parcelRequire.register("aWIy6", function(module, exports) {

$parcel$export(module.exports, "noop", function () { return $7f81e0ae53efc969$export$8793edee2d425525; });
$parcel$export(module.exports, "trySafe", function () { return $7f81e0ae53efc969$export$a3a27526e073307; });
// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $7f81e0ae53efc969$export$8793edee2d425525 = ()=>{};
const $7f81e0ae53efc969$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
const $7f81e0ae53efc969$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $7f81e0ae53efc969$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
const $7f81e0ae53efc969$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $7f81e0ae53efc969$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};

});

parcelRequire.register("apgZ7", function(module, exports) {

$parcel$export(module.exports, "pick", function () { return $793969fd5a5cbd63$export$357523c63a2253b9; });
const $793969fd5a5cbd63$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $793969fd5a5cbd63$export$42fd73f889ee4d63 = (...keys)=>(state)=>$793969fd5a5cbd63$export$357523c63a2253b9(state, ...keys);

});

parcelRequire.register("vZyB0", function(module, exports) {

$parcel$export(module.exports, "yes", function () { return $0602a54d71804256$export$7a668e70ea2210d9; });

var $kIJjr = parcelRequire("kIJjr");

var $5wduI = parcelRequire("5wduI");
var $0602a54d71804256$require$Buffer = $5wduI.Buffer;
function $0602a54d71804256$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replace(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replace(/-/g, " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $0602a54d71804256$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
const $0602a54d71804256$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replace(/-/g, "+").replace(/_/g, "/");
const $0602a54d71804256$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = (0, $kIJjr.isNode)() ? $0602a54d71804256$require$Buffer.from(rawString, "utf8").toString("base64") : window.btoa(unescape(encodeURIComponent(rawString)));
        return $0602a54d71804256$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $0602a54d71804256$var$restoreNonUrlSafeCharacters(encodedString);
        return (0, $kIJjr.isNode)() ? $0602a54d71804256$require$Buffer.from(nonUrlSafeEncodedString, "base64").toString("utf8") : decodeURIComponent(escape(window.atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $0602a54d71804256$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $0602a54d71804256$var$restoreNonUrlSafeCharacters
};
const $0602a54d71804256$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());

});
parcelRequire.register("5wduI", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $404a68a26d24bdd1$export$a143d493d941bafc; }, function (v) { return $404a68a26d24bdd1$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $404a68a26d24bdd1$export$f99ded8fe4b79145; }, function (v) { return $404a68a26d24bdd1$export$f99ded8fe4b79145 = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $404a68a26d24bdd1$export$a143d493d941bafc;
var $404a68a26d24bdd1$export$e4cf37d7f6fb9e0a;
var $404a68a26d24bdd1$export$f99ded8fe4b79145;
var $404a68a26d24bdd1$export$599f31c3813fae4d;
"use strict";

var $9Zk7o = parcelRequire("9Zk7o");

var $69aqW = parcelRequire("69aqW");
var $404a68a26d24bdd1$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$404a68a26d24bdd1$export$a143d493d941bafc = $404a68a26d24bdd1$var$Buffer;
$404a68a26d24bdd1$export$e4cf37d7f6fb9e0a = $404a68a26d24bdd1$var$SlowBuffer;
$404a68a26d24bdd1$export$f99ded8fe4b79145 = 50;
var $404a68a26d24bdd1$var$K_MAX_LENGTH = 0x7fffffff;
$404a68a26d24bdd1$export$599f31c3813fae4d = $404a68a26d24bdd1$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $404a68a26d24bdd1$var$Buffer.TYPED_ARRAY_SUPPORT = $404a68a26d24bdd1$var$typedArraySupport();
if (!$404a68a26d24bdd1$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $404a68a26d24bdd1$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        var arr = new Uint8Array(1);
        var proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($404a68a26d24bdd1$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$404a68a26d24bdd1$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($404a68a26d24bdd1$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$404a68a26d24bdd1$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $404a68a26d24bdd1$var$createBuffer(length) {
    if (length > $404a68a26d24bdd1$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    var buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $404a68a26d24bdd1$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $404a68a26d24bdd1$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $404a68a26d24bdd1$var$allocUnsafe(arg);
    }
    return $404a68a26d24bdd1$var$from(arg, encodingOrOffset, length);
}
$404a68a26d24bdd1$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $404a68a26d24bdd1$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $404a68a26d24bdd1$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $404a68a26d24bdd1$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($404a68a26d24bdd1$var$isInstance(value, ArrayBuffer) || value && $404a68a26d24bdd1$var$isInstance(value.buffer, ArrayBuffer)) return $404a68a26d24bdd1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($404a68a26d24bdd1$var$isInstance(value, SharedArrayBuffer) || value && $404a68a26d24bdd1$var$isInstance(value.buffer, SharedArrayBuffer))) return $404a68a26d24bdd1$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    var valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $404a68a26d24bdd1$var$Buffer.from(valueOf, encodingOrOffset, length);
    var b = $404a68a26d24bdd1$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $404a68a26d24bdd1$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $404a68a26d24bdd1$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $404a68a26d24bdd1$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($404a68a26d24bdd1$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($404a68a26d24bdd1$var$Buffer, Uint8Array);
function $404a68a26d24bdd1$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $404a68a26d24bdd1$var$alloc(size, fill, encoding) {
    $404a68a26d24bdd1$var$assertSize(size);
    if (size <= 0) return $404a68a26d24bdd1$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $404a68a26d24bdd1$var$createBuffer(size).fill(fill, encoding) : $404a68a26d24bdd1$var$createBuffer(size).fill(fill);
    return $404a68a26d24bdd1$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $404a68a26d24bdd1$var$Buffer.alloc = function(size, fill, encoding) {
    return $404a68a26d24bdd1$var$alloc(size, fill, encoding);
};
function $404a68a26d24bdd1$var$allocUnsafe(size) {
    $404a68a26d24bdd1$var$assertSize(size);
    return $404a68a26d24bdd1$var$createBuffer(size < 0 ? 0 : $404a68a26d24bdd1$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $404a68a26d24bdd1$var$Buffer.allocUnsafe = function(size) {
    return $404a68a26d24bdd1$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $404a68a26d24bdd1$var$Buffer.allocUnsafeSlow = function(size) {
    return $404a68a26d24bdd1$var$allocUnsafe(size);
};
function $404a68a26d24bdd1$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$404a68a26d24bdd1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    var length = $404a68a26d24bdd1$var$byteLength(string, encoding) | 0;
    var buf = $404a68a26d24bdd1$var$createBuffer(length);
    var actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $404a68a26d24bdd1$var$fromArrayLike(array) {
    var length = array.length < 0 ? 0 : $404a68a26d24bdd1$var$checked(array.length) | 0;
    var buf = $404a68a26d24bdd1$var$createBuffer(length);
    for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $404a68a26d24bdd1$var$fromArrayView(arrayView) {
    if ($404a68a26d24bdd1$var$isInstance(arrayView, Uint8Array)) {
        var copy = new Uint8Array(arrayView);
        return $404a68a26d24bdd1$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $404a68a26d24bdd1$var$fromArrayLike(arrayView);
}
function $404a68a26d24bdd1$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    var buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $404a68a26d24bdd1$var$Buffer.prototype);
    return buf;
}
function $404a68a26d24bdd1$var$fromObject(obj) {
    if ($404a68a26d24bdd1$var$Buffer.isBuffer(obj)) {
        var len = $404a68a26d24bdd1$var$checked(obj.length) | 0;
        var buf = $404a68a26d24bdd1$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $404a68a26d24bdd1$var$numberIsNaN(obj.length)) return $404a68a26d24bdd1$var$createBuffer(0);
        return $404a68a26d24bdd1$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $404a68a26d24bdd1$var$fromArrayLike(obj.data);
}
function $404a68a26d24bdd1$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $404a68a26d24bdd1$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $404a68a26d24bdd1$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $404a68a26d24bdd1$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $404a68a26d24bdd1$var$Buffer.alloc(+length);
}
$404a68a26d24bdd1$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $404a68a26d24bdd1$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$404a68a26d24bdd1$var$Buffer.compare = function compare(a, b) {
    if ($404a68a26d24bdd1$var$isInstance(a, Uint8Array)) a = $404a68a26d24bdd1$var$Buffer.from(a, a.offset, a.byteLength);
    if ($404a68a26d24bdd1$var$isInstance(b, Uint8Array)) b = $404a68a26d24bdd1$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$404a68a26d24bdd1$var$Buffer.isBuffer(a) || !$404a68a26d24bdd1$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$404a68a26d24bdd1$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$404a68a26d24bdd1$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $404a68a26d24bdd1$var$Buffer.alloc(0);
    var i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    var buffer = $404a68a26d24bdd1$var$Buffer.allocUnsafe(length);
    var pos = 0;
    for(i = 0; i < list.length; ++i){
        var buf = list[i];
        if ($404a68a26d24bdd1$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) $404a68a26d24bdd1$var$Buffer.from(buf).copy(buffer, pos);
            else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$404a68a26d24bdd1$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $404a68a26d24bdd1$var$byteLength(string, encoding) {
    if ($404a68a26d24bdd1$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $404a68a26d24bdd1$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    var len = string.length;
    var mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    var loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $404a68a26d24bdd1$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $404a68a26d24bdd1$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $404a68a26d24bdd1$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$404a68a26d24bdd1$var$Buffer.byteLength = $404a68a26d24bdd1$var$byteLength;
function $404a68a26d24bdd1$var$slowToString(encoding, start, end) {
    var loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $404a68a26d24bdd1$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $404a68a26d24bdd1$var$utf8Slice(this, start, end);
        case "ascii":
            return $404a68a26d24bdd1$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $404a68a26d24bdd1$var$latin1Slice(this, start, end);
        case "base64":
            return $404a68a26d24bdd1$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $404a68a26d24bdd1$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$404a68a26d24bdd1$var$Buffer.prototype._isBuffer = true;
function $404a68a26d24bdd1$var$swap(b, n, m) {
    var i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$404a68a26d24bdd1$var$Buffer.prototype.swap16 = function swap16() {
    var len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(var i = 0; i < len; i += 2)$404a68a26d24bdd1$var$swap(this, i, i + 1);
    return this;
};
$404a68a26d24bdd1$var$Buffer.prototype.swap32 = function swap32() {
    var len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(var i = 0; i < len; i += 4){
        $404a68a26d24bdd1$var$swap(this, i, i + 3);
        $404a68a26d24bdd1$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$404a68a26d24bdd1$var$Buffer.prototype.swap64 = function swap64() {
    var len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(var i = 0; i < len; i += 8){
        $404a68a26d24bdd1$var$swap(this, i, i + 7);
        $404a68a26d24bdd1$var$swap(this, i + 1, i + 6);
        $404a68a26d24bdd1$var$swap(this, i + 2, i + 5);
        $404a68a26d24bdd1$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$404a68a26d24bdd1$var$Buffer.prototype.toString = function toString() {
    var length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $404a68a26d24bdd1$var$utf8Slice(this, 0, length);
    return $404a68a26d24bdd1$var$slowToString.apply(this, arguments);
};
$404a68a26d24bdd1$var$Buffer.prototype.toLocaleString = $404a68a26d24bdd1$var$Buffer.prototype.toString;
$404a68a26d24bdd1$var$Buffer.prototype.equals = function equals(b) {
    if (!$404a68a26d24bdd1$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $404a68a26d24bdd1$var$Buffer.compare(this, b) === 0;
};
$404a68a26d24bdd1$var$Buffer.prototype.inspect = function inspect() {
    var str = "";
    var max = $404a68a26d24bdd1$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($404a68a26d24bdd1$var$customInspectSymbol) $404a68a26d24bdd1$var$Buffer.prototype[$404a68a26d24bdd1$var$customInspectSymbol] = $404a68a26d24bdd1$var$Buffer.prototype.inspect;
$404a68a26d24bdd1$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($404a68a26d24bdd1$var$isInstance(target, Uint8Array)) target = $404a68a26d24bdd1$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$404a68a26d24bdd1$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    var x = thisEnd - thisStart;
    var y = end - start;
    var len = Math.min(x, y);
    var thisCopy = this.slice(thisStart, thisEnd);
    var targetCopy = target.slice(start, end);
    for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $404a68a26d24bdd1$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($404a68a26d24bdd1$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $404a68a26d24bdd1$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($404a68a26d24bdd1$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $404a68a26d24bdd1$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $404a68a26d24bdd1$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $404a68a26d24bdd1$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    var indexSize = 1;
    var arrLength = arr.length;
    var valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    var i;
    if (dir) {
        var foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            var found = true;
            for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$404a68a26d24bdd1$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$404a68a26d24bdd1$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $404a68a26d24bdd1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$404a68a26d24bdd1$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $404a68a26d24bdd1$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $404a68a26d24bdd1$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    var remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    var strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    for(var i = 0; i < length; ++i){
        var parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($404a68a26d24bdd1$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $404a68a26d24bdd1$var$utf8Write(buf, string, offset, length) {
    return $404a68a26d24bdd1$var$blitBuffer($404a68a26d24bdd1$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $404a68a26d24bdd1$var$asciiWrite(buf, string, offset, length) {
    return $404a68a26d24bdd1$var$blitBuffer($404a68a26d24bdd1$var$asciiToBytes(string), buf, offset, length);
}
function $404a68a26d24bdd1$var$base64Write(buf, string, offset, length) {
    return $404a68a26d24bdd1$var$blitBuffer($404a68a26d24bdd1$var$base64ToBytes(string), buf, offset, length);
}
function $404a68a26d24bdd1$var$ucs2Write(buf, string, offset, length) {
    return $404a68a26d24bdd1$var$blitBuffer($404a68a26d24bdd1$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$404a68a26d24bdd1$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    var remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    var loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $404a68a26d24bdd1$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $404a68a26d24bdd1$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $404a68a26d24bdd1$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $404a68a26d24bdd1$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $404a68a26d24bdd1$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$404a68a26d24bdd1$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $404a68a26d24bdd1$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $9Zk7o.fromByteArray(buf);
    else return $9Zk7o.fromByteArray(buf.slice(start, end));
}
function $404a68a26d24bdd1$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    var res = [];
    var i = start;
    while(i < end){
        var firstByte = buf[i];
        var codePoint = null;
        var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            var secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $404a68a26d24bdd1$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var $404a68a26d24bdd1$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $404a68a26d24bdd1$var$decodeCodePointsArray(codePoints) {
    var len = codePoints.length;
    if (len <= $404a68a26d24bdd1$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    var res = "";
    var i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $404a68a26d24bdd1$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $404a68a26d24bdd1$var$asciiSlice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $404a68a26d24bdd1$var$latin1Slice(buf, start, end) {
    var ret = "";
    end = Math.min(buf.length, end);
    for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $404a68a26d24bdd1$var$hexSlice(buf, start, end) {
    var len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    var out = "";
    for(var i = start; i < end; ++i)out += $404a68a26d24bdd1$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $404a68a26d24bdd1$var$utf16leSlice(buf, start, end) {
    var bytes = buf.slice(start, end);
    var res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(var i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$404a68a26d24bdd1$var$Buffer.prototype.slice = function slice(start, end) {
    var len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    var newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $404a68a26d24bdd1$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $404a68a26d24bdd1$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$404a68a26d24bdd1$var$Buffer.prototype.readUintLE = $404a68a26d24bdd1$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readUintBE = $404a68a26d24bdd1$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset + --byteLength];
    var mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readUint8 = $404a68a26d24bdd1$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$404a68a26d24bdd1$var$Buffer.prototype.readUint16LE = $404a68a26d24bdd1$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$404a68a26d24bdd1$var$Buffer.prototype.readUint16BE = $404a68a26d24bdd1$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$404a68a26d24bdd1$var$Buffer.prototype.readUint32LE = $404a68a26d24bdd1$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$404a68a26d24bdd1$var$Buffer.prototype.readUint32BE = $404a68a26d24bdd1$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$404a68a26d24bdd1$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, byteLength, this.length);
    var val = this[offset];
    var mul = 1;
    var i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, byteLength, this.length);
    var i = byteLength;
    var mul = 1;
    var val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$404a68a26d24bdd1$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 2, this.length);
    var val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 2, this.length);
    var val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$404a68a26d24bdd1$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$404a68a26d24bdd1$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$404a68a26d24bdd1$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return $69aqW.read(this, offset, true, 23, 4);
};
$404a68a26d24bdd1$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 4, this.length);
    return $69aqW.read(this, offset, false, 23, 4);
};
$404a68a26d24bdd1$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 8, this.length);
    return $69aqW.read(this, offset, true, 52, 8);
};
$404a68a26d24bdd1$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkOffset(offset, 8, this.length);
    return $69aqW.read(this, offset, false, 52, 8);
};
function $404a68a26d24bdd1$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$404a68a26d24bdd1$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$404a68a26d24bdd1$var$Buffer.prototype.writeUintLE = $404a68a26d24bdd1$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $404a68a26d24bdd1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var mul = 1;
    var i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUintBE = $404a68a26d24bdd1$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        var maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $404a68a26d24bdd1$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    var i = byteLength - 1;
    var mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUint8 = $404a68a26d24bdd1$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUint16LE = $404a68a26d24bdd1$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUint16BE = $404a68a26d24bdd1$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUint32LE = $404a68a26d24bdd1$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeUint32BE = $404a68a26d24bdd1$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $404a68a26d24bdd1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = 0;
    var mul = 1;
    var sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        var limit = Math.pow(2, 8 * byteLength - 1);
        $404a68a26d24bdd1$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    var i = byteLength - 1;
    var mul = 1;
    var sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$404a68a26d24bdd1$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $404a68a26d24bdd1$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $404a68a26d24bdd1$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $69aqW.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$404a68a26d24bdd1$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $404a68a26d24bdd1$var$writeFloat(this, value, offset, true, noAssert);
};
$404a68a26d24bdd1$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $404a68a26d24bdd1$var$writeFloat(this, value, offset, false, noAssert);
};
function $404a68a26d24bdd1$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $404a68a26d24bdd1$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $69aqW.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$404a68a26d24bdd1$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $404a68a26d24bdd1$var$writeDouble(this, value, offset, true, noAssert);
};
$404a68a26d24bdd1$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $404a68a26d24bdd1$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$404a68a26d24bdd1$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$404a68a26d24bdd1$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    var len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$404a68a26d24bdd1$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$404a68a26d24bdd1$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            var code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    var i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        var bytes = $404a68a26d24bdd1$var$Buffer.isBuffer(val) ? val : $404a68a26d24bdd1$var$Buffer.from(val, encoding);
        var len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// HELPER FUNCTIONS
// ================
var $404a68a26d24bdd1$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $404a68a26d24bdd1$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($404a68a26d24bdd1$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $404a68a26d24bdd1$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    var codePoint;
    var length = string.length;
    var leadSurrogate = null;
    var bytes = [];
    for(var i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $404a68a26d24bdd1$var$asciiToBytes(str) {
    var byteArray = [];
    for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $404a68a26d24bdd1$var$utf16leToBytes(str, units) {
    var c, hi, lo;
    var byteArray = [];
    for(var i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $404a68a26d24bdd1$var$base64ToBytes(str) {
    return $9Zk7o.toByteArray($404a68a26d24bdd1$var$base64clean(str));
}
function $404a68a26d24bdd1$var$blitBuffer(src, dst, offset, length) {
    for(var i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $404a68a26d24bdd1$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $404a68a26d24bdd1$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var $404a68a26d24bdd1$var$hexSliceLookupTable = function() {
    var alphabet = "0123456789abcdef";
    var table = new Array(256);
    for(var i = 0; i < 16; ++i){
        var i16 = i * 16;
        for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();

});
parcelRequire.register("9Zk7o", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $74596a9eb93ffc86$export$d622b2ad8d90c771; }, function (v) { return $74596a9eb93ffc86$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $74596a9eb93ffc86$export$6100ba28696e12de; }, function (v) { return $74596a9eb93ffc86$export$6100ba28696e12de = v; });
var $74596a9eb93ffc86$export$a48f0734ac7c2329;
var $74596a9eb93ffc86$export$d622b2ad8d90c771;
var $74596a9eb93ffc86$export$6100ba28696e12de;
"use strict";
$74596a9eb93ffc86$export$a48f0734ac7c2329 = $74596a9eb93ffc86$var$byteLength;
$74596a9eb93ffc86$export$d622b2ad8d90c771 = $74596a9eb93ffc86$var$toByteArray;
$74596a9eb93ffc86$export$6100ba28696e12de = $74596a9eb93ffc86$var$fromByteArray;
var $74596a9eb93ffc86$var$lookup = [];
var $74596a9eb93ffc86$var$revLookup = [];
var $74596a9eb93ffc86$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $74596a9eb93ffc86$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $74596a9eb93ffc86$var$i = 0, $74596a9eb93ffc86$var$len = $74596a9eb93ffc86$var$code.length; $74596a9eb93ffc86$var$i < $74596a9eb93ffc86$var$len; ++$74596a9eb93ffc86$var$i){
    $74596a9eb93ffc86$var$lookup[$74596a9eb93ffc86$var$i] = $74596a9eb93ffc86$var$code[$74596a9eb93ffc86$var$i];
    $74596a9eb93ffc86$var$revLookup[$74596a9eb93ffc86$var$code.charCodeAt($74596a9eb93ffc86$var$i)] = $74596a9eb93ffc86$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$74596a9eb93ffc86$var$revLookup["-".charCodeAt(0)] = 62;
$74596a9eb93ffc86$var$revLookup["_".charCodeAt(0)] = 63;
function $74596a9eb93ffc86$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $74596a9eb93ffc86$var$byteLength(b64) {
    var lens = $74596a9eb93ffc86$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $74596a9eb93ffc86$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $74596a9eb93ffc86$var$toByteArray(b64) {
    var tmp;
    var lens = $74596a9eb93ffc86$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $74596a9eb93ffc86$var$Arr($74596a9eb93ffc86$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i)] << 18 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i)] << 2 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i)] << 10 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $74596a9eb93ffc86$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $74596a9eb93ffc86$var$tripletToBase64(num) {
    return $74596a9eb93ffc86$var$lookup[num >> 18 & 0x3F] + $74596a9eb93ffc86$var$lookup[num >> 12 & 0x3F] + $74596a9eb93ffc86$var$lookup[num >> 6 & 0x3F] + $74596a9eb93ffc86$var$lookup[num & 0x3F];
}
function $74596a9eb93ffc86$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($74596a9eb93ffc86$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $74596a9eb93ffc86$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($74596a9eb93ffc86$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($74596a9eb93ffc86$var$lookup[tmp >> 2] + $74596a9eb93ffc86$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($74596a9eb93ffc86$var$lookup[tmp >> 10] + $74596a9eb93ffc86$var$lookup[tmp >> 4 & 0x3F] + $74596a9eb93ffc86$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRequire.register("69aqW", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $479bad339fb46d7d$export$aafa59e2e03f2942; }, function (v) { return $479bad339fb46d7d$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $479bad339fb46d7d$export$68d8715fc104d294; }, function (v) { return $479bad339fb46d7d$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $479bad339fb46d7d$export$aafa59e2e03f2942;
var $479bad339fb46d7d$export$68d8715fc104d294;
$479bad339fb46d7d$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$479bad339fb46d7d$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});



parcelRequire.register("20diy", function(module, exports) {

$parcel$export(module.exports, "getSafe", function () { return $1755e59eda90fd47$export$fedb900c0ea4e699; });

var $aWIy6 = parcelRequire("aWIy6");
const $1755e59eda90fd47$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $1755e59eda90fd47$export$fedb900c0ea4e699 = (...args)=>(0, $aWIy6.trySafe)(()=>$1755e59eda90fd47$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $1755e59eda90fd47$export$bf7199a9ebcb84a9 = (object, keySerial)=>$1755e59eda90fd47$export$3988ae62b71be9a3(object, keySerial);

});

parcelRequire.register("b9zrd", function(module, exports) {

$parcel$export(module.exports, "joinPath", function () { return $81ec06332cd8fc46$export$b891921babc70093; });
$parcel$export(module.exports, "appendPath", function () { return $81ec06332cd8fc46$export$c3cef1c0537c0eb2; });
/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $81ec06332cd8fc46$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $81ec06332cd8fc46$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($81ec06332cd8fc46$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);

});

parcelRequire.register("gvOOV", function(module, exports) {
// eslint-disable-next-line @typescript-eslint/ban-types
const $c056f672088f152c$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $c056f672088f152c$export$dd89c3a817f05bc7 = (object, key)=>$c056f672088f152c$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ const $c056f672088f152c$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));

});

parcelRequire.register("gNTPK", function(module, exports) {
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $c3bc8854d68bc7fd$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}

});


parcelRequire.register("3p6UC", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("8T8Hd")),
    import("./" + (parcelRequire("kucSS")).resolve("axD0K")),
    import("./" + (parcelRequire("kucSS")).resolve("34GRJ"))
]).then(()=>parcelRequire("hAXJZ"));

});

parcelRequire.register("8Uxne", function(module, exports) {




module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("fVKOU")),
    import("./" + (parcelRequire("kucSS")).resolve("8T8Hd")),
    import("./" + (parcelRequire("kucSS")).resolve("axD0K")),
    import("./" + (parcelRequire("kucSS")).resolve("fJEFp"))
]).then(()=>parcelRequire("2KTk8"));

});

parcelRequire.register("lkbZ6", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("fVKOU")),
    import("./" + (parcelRequire("kucSS")).resolve("axD0K")),
    import("./" + (parcelRequire("kucSS")).resolve("274y9"))
]).then(()=>parcelRequire("l74cr"));

});

parcelRequire.register("cL8zv", function(module, exports) {
$parcel$export(module.exports, "generateStandardId", function () { return (parcelRequire("jKlLV")).generateStandardId; });
$parcel$export(module.exports, "generateStandardSecret", function () { return (parcelRequire("jKlLV")).generateStandardSecret; });
$parcel$export(module.exports, "generateStandardShortId", function () { return (parcelRequire("jKlLV")).generateStandardShortId; });
parcelRequire("b5Mkr");
parcelRequire("k9FWp");

});
parcelRequire.register("b5Mkr", function(module, exports) {
/*
  We does not export `sql.ts` here since it requires slonik which is not universal.
  It will be exported separately in `/src/index.ts`.
*/ parcelRequire("hma4M");

});
parcelRequire.register("hma4M", function(module, exports) {

});


parcelRequire.register("k9FWp", function(module, exports) {
$parcel$export(module.exports, "generateStandardId", function () { return (parcelRequire("jKlLV")).generateStandardId; });
$parcel$export(module.exports, "generateStandardSecret", function () { return (parcelRequire("jKlLV")).generateStandardSecret; });
$parcel$export(module.exports, "generateStandardShortId", function () { return (parcelRequire("jKlLV")).generateStandardShortId; });
parcelRequire("ddFjR");
parcelRequire("faDpC");
parcelRequire("jKlLV");
parcelRequire("5Jqsk");

});
parcelRequire.register("ddFjR", function(module, exports) {
const $99fc8a66a5a647e5$export$dd89c3a817f05bc7 = (object, key)=>object !== null && typeof object === "object" && key in object;

});

parcelRequire.register("faDpC", function(module, exports) {
class $b0b65ca6f5f6d7b0$export$4421a7403324ea68 {
    constructor(ttl = Number.POSITIVE_INFINITY){
        this.ttl = ttl;
        this.data = new Map();
        this.expiration = new Map();
    }
    set(key, value, ttl = this.ttl) {
        if (value === undefined) throw new TypeError("Value cannot be undefined");
        this.expiration.set(key, Date.now() + ttl);
        this.data.set(key, value);
    }
    get(key) {
        this.#purge(key);
        return this.data.get(key);
    }
    has(key) {
        this.#purge(key);
        return this.data.has(key);
    }
    delete(key) {
        this.expiration.delete(key);
        return this.data.delete(key);
    }
    clear() {
        this.expiration.clear();
        this.data.clear();
    }
    #purge(key) {
        const expiration = this.expiration.get(key);
        if (expiration !== undefined && expiration < Date.now()) this.delete(key);
    }
}

});

parcelRequire.register("jKlLV", function(module, exports) {

$parcel$export(module.exports, "generateStandardId", function () { return $e60333ab1259835c$export$7e648d54e633633e; });
$parcel$export(module.exports, "generateStandardShortId", function () { return $e60333ab1259835c$export$8702116b552d3dba; });
$parcel$export(module.exports, "generateStandardSecret", function () { return $e60333ab1259835c$export$877b6275f1b9e856; });

var $3iNy0 = parcelRequire("3iNy0");
const $e60333ab1259835c$var$lowercaseAlphabet = "0123456789abcdefghijklmnopqrstuvwxyz";
const $e60333ab1259835c$var$alphabet = `${$e60333ab1259835c$var$lowercaseAlphabet}ABCDEFGHIJKLMNOPQRSTUVWXYZ`;
const $e60333ab1259835c$var$buildIdGenerator = (size, includingUppercase = true)=>(0, $3iNy0.customAlphabet)(includingUppercase ? $e60333ab1259835c$var$alphabet : $e60333ab1259835c$var$lowercaseAlphabet, size);
const $e60333ab1259835c$export$7e648d54e633633e = $e60333ab1259835c$var$buildIdGenerator(21, false);
const $e60333ab1259835c$export$8702116b552d3dba = $e60333ab1259835c$var$buildIdGenerator(12, false);
const $e60333ab1259835c$export$877b6275f1b9e856 = $e60333ab1259835c$var$buildIdGenerator(32);

});
parcelRequire.register("3iNy0", function(module, exports) {

$parcel$export(module.exports, "customAlphabet", function () { return $26797ca7e73044b0$export$62e99e5c9f473d7f; });
$parcel$export(module.exports, "nanoid", function () { return $26797ca7e73044b0$export$ac4959f4f1338dfc; });

let $26797ca7e73044b0$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $26797ca7e73044b0$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = "";
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || "";
                if (id.length === size) return id;
            }
        }
    };
};
let $26797ca7e73044b0$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$26797ca7e73044b0$export$a5cee9e955a615e5(alphabet, size, $26797ca7e73044b0$export$4385e60b38654f68);
let $26797ca7e73044b0$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += "-";
        else id += "_";
        return id;
    }, "");

});


parcelRequire.register("5Jqsk", function(module, exports) {
/**
 * Get user display name from multiple fields
 */ const $42c5ad49e6f2fe14$export$b86884fca6ca2c21 = ({ name: name, username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone })=>{
    return name ?? username ?? primaryEmail ?? primaryPhone ?? "Unnamed User";
};

});



parcelRequire.register("2CYkO", function(module, exports) {

$parcel$export(module.exports, "string", function () { return $f956ec92c1beba23$export$22b082955e083ec3; });
$parcel$export(module.exports, "number", function () { return $f956ec92c1beba23$export$98e628dec113755e; });
$parcel$export(module.exports, "any", function () { return $f956ec92c1beba23$export$4154a199d7d90455; });
$parcel$export(module.exports, "array", function () { return $f956ec92c1beba23$export$2f23118c22fb2630; });
$parcel$export(module.exports, "object", function () { return $f956ec92c1beba23$export$be5493f9613cbbe; });
$parcel$export(module.exports, "z", function () { return $f956ec92c1beba23$export$2e2bcd8739ae039; });
var $f956ec92c1beba23$export$7debb50ef11d5e0b;
(function(util) {
    util.assertEqual = (val)=>val;
    function assertIs(_arg) {}
    util.assertIs = assertIs;
    function assertNever(_x) {
        throw new Error();
    }
    util.assertNever = assertNever;
    util.arrayToEnum = (items)=>{
        const obj = {};
        for (const item of items)obj[item] = item;
        return obj;
    };
    util.getValidEnumValues = (obj)=>{
        const validKeys = util.objectKeys(obj).filter((k)=>typeof obj[obj[k]] !== "number");
        const filtered = {};
        for (const k of validKeys)filtered[k] = obj[k];
        return util.objectValues(filtered);
    };
    util.objectValues = (obj)=>{
        return util.objectKeys(obj).map(function(e) {
            return obj[e];
        });
    };
    util.objectKeys = typeof Object.keys === "function" // eslint-disable-line ban/ban
     ? (obj)=>Object.keys(obj) // eslint-disable-line ban/ban
     : (object)=>{
        const keys = [];
        for(const key in object)if (Object.prototype.hasOwnProperty.call(object, key)) keys.push(key);
        return keys;
    };
    util.find = (arr, checker)=>{
        for (const item of arr){
            if (checker(item)) return item;
        }
        return undefined;
    };
    util.isInteger = typeof Number.isInteger === "function" ? (val)=>Number.isInteger(val) // eslint-disable-line ban/ban
     : (val)=>typeof val === "number" && isFinite(val) && Math.floor(val) === val;
    function joinValues(array, separator = " | ") {
        return array.map((val)=>typeof val === "string" ? `'${val}'` : val).join(separator);
    }
    util.joinValues = joinValues;
    util.jsonStringifyReplacer = (_, value)=>{
        if (typeof value === "bigint") return value.toString();
        return value;
    };
})($f956ec92c1beba23$export$7debb50ef11d5e0b || ($f956ec92c1beba23$export$7debb50ef11d5e0b = {}));
var $f956ec92c1beba23$export$4aa2142c225fd5c7;
(function(objectUtil) {
    objectUtil.mergeShapes = (first, second)=>{
        return {
            ...first,
            ...second
        };
    };
})($f956ec92c1beba23$export$4aa2142c225fd5c7 || ($f956ec92c1beba23$export$4aa2142c225fd5c7 = {}));
const $f956ec92c1beba23$export$5716da67bfaa244d = $f956ec92c1beba23$export$7debb50ef11d5e0b.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
]);
const $f956ec92c1beba23$export$3e9057828ebd5c7a = (data)=>{
    const t = typeof data;
    switch(t){
        case "undefined":
            return $f956ec92c1beba23$export$5716da67bfaa244d.undefined;
        case "string":
            return $f956ec92c1beba23$export$5716da67bfaa244d.string;
        case "number":
            return isNaN(data) ? $f956ec92c1beba23$export$5716da67bfaa244d.nan : $f956ec92c1beba23$export$5716da67bfaa244d.number;
        case "boolean":
            return $f956ec92c1beba23$export$5716da67bfaa244d.boolean;
        case "function":
            return $f956ec92c1beba23$export$5716da67bfaa244d.function;
        case "bigint":
            return $f956ec92c1beba23$export$5716da67bfaa244d.bigint;
        case "symbol":
            return $f956ec92c1beba23$export$5716da67bfaa244d.symbol;
        case "object":
            if (Array.isArray(data)) return $f956ec92c1beba23$export$5716da67bfaa244d.array;
            if (data === null) return $f956ec92c1beba23$export$5716da67bfaa244d.null;
            if (data.then && typeof data.then === "function" && data.catch && typeof data.catch === "function") return $f956ec92c1beba23$export$5716da67bfaa244d.promise;
            if (typeof Map !== "undefined" && data instanceof Map) return $f956ec92c1beba23$export$5716da67bfaa244d.map;
            if (typeof Set !== "undefined" && data instanceof Set) return $f956ec92c1beba23$export$5716da67bfaa244d.set;
            if (typeof Date !== "undefined" && data instanceof Date) return $f956ec92c1beba23$export$5716da67bfaa244d.date;
            return $f956ec92c1beba23$export$5716da67bfaa244d.object;
        default:
            return $f956ec92c1beba23$export$5716da67bfaa244d.unknown;
    }
};
const $f956ec92c1beba23$export$5ba560653e4a1035 = $f956ec92c1beba23$export$7debb50ef11d5e0b.arrayToEnum([
    "invalid_type",
    "invalid_literal",
    "custom",
    "invalid_union",
    "invalid_union_discriminator",
    "invalid_enum_value",
    "unrecognized_keys",
    "invalid_arguments",
    "invalid_return_type",
    "invalid_date",
    "invalid_string",
    "too_small",
    "too_big",
    "invalid_intersection_types",
    "not_multiple_of",
    "not_finite"
]);
const $f956ec92c1beba23$export$913eddeaf297cfea = (obj)=>{
    const json = JSON.stringify(obj, null, 2);
    return json.replace(/"([^"]+)":/g, "$1:");
};
class $f956ec92c1beba23$export$f98dac4b251ab333 extends Error {
    constructor(issues){
        super();
        this.issues = [];
        this.addIssue = (sub)=>{
            this.issues = [
                ...this.issues,
                sub
            ];
        };
        this.addIssues = (subs = [])=>{
            this.issues = [
                ...this.issues,
                ...subs
            ];
        };
        const actualProto = new.target.prototype;
        if (Object.setPrototypeOf) // eslint-disable-next-line ban/ban
        Object.setPrototypeOf(this, actualProto);
        else this.__proto__ = actualProto;
        this.name = "ZodError";
        this.issues = issues;
    }
    get errors() {
        return this.issues;
    }
    format(_mapper) {
        const mapper = _mapper || function(issue) {
            return issue.message;
        };
        const fieldErrors = {
            _errors: []
        };
        const processError = (error)=>{
            for (const issue of error.issues){
                if (issue.code === "invalid_union") issue.unionErrors.map(processError);
                else if (issue.code === "invalid_return_type") processError(issue.returnTypeError);
                else if (issue.code === "invalid_arguments") processError(issue.argumentsError);
                else if (issue.path.length === 0) fieldErrors._errors.push(mapper(issue));
                else {
                    let curr = fieldErrors;
                    let i = 0;
                    while(i < issue.path.length){
                        const el = issue.path[i];
                        const terminal = i === issue.path.length - 1;
                        if (!terminal) curr[el] = curr[el] || {
                            _errors: []
                        };
                        else {
                            curr[el] = curr[el] || {
                                _errors: []
                            };
                            curr[el]._errors.push(mapper(issue));
                        }
                        curr = curr[el];
                        i++;
                    }
                }
            }
        };
        processError(this);
        return fieldErrors;
    }
    toString() {
        return this.message;
    }
    get message() {
        return JSON.stringify(this.issues, $f956ec92c1beba23$export$7debb50ef11d5e0b.jsonStringifyReplacer, 2);
    }
    get isEmpty() {
        return this.issues.length === 0;
    }
    flatten(mapper = (issue)=>issue.message) {
        const fieldErrors = {};
        const formErrors = [];
        for (const sub of this.issues)if (sub.path.length > 0) {
            fieldErrors[sub.path[0]] = fieldErrors[sub.path[0]] || [];
            fieldErrors[sub.path[0]].push(mapper(sub));
        } else formErrors.push(mapper(sub));
        return {
            formErrors: formErrors,
            fieldErrors: fieldErrors
        };
    }
    get formErrors() {
        return this.flatten();
    }
}
$f956ec92c1beba23$export$f98dac4b251ab333.create = (issues)=>{
    const error = new $f956ec92c1beba23$export$f98dac4b251ab333(issues);
    return error;
};
const $f956ec92c1beba23$export$341b0b6e0a6f5099 = (issue, _ctx)=>{
    let message;
    switch(issue.code){
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type:
            if (issue.received === $f956ec92c1beba23$export$5716da67bfaa244d.undefined) message = "Required";
            else message = `Expected ${issue.expected}, received ${issue.received}`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_literal:
            message = `Invalid literal value, expected ${JSON.stringify(issue.expected, $f956ec92c1beba23$export$7debb50ef11d5e0b.jsonStringifyReplacer)}`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.unrecognized_keys:
            message = `Unrecognized key(s) in object: ${$f956ec92c1beba23$export$7debb50ef11d5e0b.joinValues(issue.keys, ", ")}`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_union:
            message = `Invalid input`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_union_discriminator:
            message = `Invalid discriminator value. Expected ${$f956ec92c1beba23$export$7debb50ef11d5e0b.joinValues(issue.options)}`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_enum_value:
            message = `Invalid enum value. Expected ${$f956ec92c1beba23$export$7debb50ef11d5e0b.joinValues(issue.options)}, received '${issue.received}'`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_arguments:
            message = `Invalid function arguments`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_return_type:
            message = `Invalid function return type`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_date:
            message = `Invalid date`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string:
            if (typeof issue.validation === "object") {
                if ("includes" in issue.validation) {
                    message = `Invalid input: must include "${issue.validation.includes}"`;
                    if (typeof issue.validation.position === "number") message = `${message} at one or more positions greater than or equal to ${issue.validation.position}`;
                } else if ("startsWith" in issue.validation) message = `Invalid input: must start with "${issue.validation.startsWith}"`;
                else if ("endsWith" in issue.validation) message = `Invalid input: must end with "${issue.validation.endsWith}"`;
                else $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(issue.validation);
            } else if (issue.validation !== "regex") message = `Invalid ${issue.validation}`;
            else message = "Invalid";
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.too_small:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `more than`} ${issue.minimum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? "exactly" : issue.inclusive ? `at least` : `over`} ${issue.minimum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${issue.minimum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly equal to ` : issue.inclusive ? `greater than or equal to ` : `greater than `}${new Date(Number(issue.minimum))}`;
            else message = "Invalid input";
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.too_big:
            if (issue.type === "array") message = `Array must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `less than`} ${issue.maximum} element(s)`;
            else if (issue.type === "string") message = `String must contain ${issue.exact ? `exactly` : issue.inclusive ? `at most` : `under`} ${issue.maximum} character(s)`;
            else if (issue.type === "number") message = `Number must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "bigint") message = `BigInt must be ${issue.exact ? `exactly` : issue.inclusive ? `less than or equal to` : `less than`} ${issue.maximum}`;
            else if (issue.type === "date") message = `Date must be ${issue.exact ? `exactly` : issue.inclusive ? `smaller than or equal to` : `smaller than`} ${new Date(Number(issue.maximum))}`;
            else message = "Invalid input";
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.custom:
            message = `Invalid input`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.invalid_intersection_types:
            message = `Intersection results could not be merged`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.not_multiple_of:
            message = `Number must be a multiple of ${issue.multipleOf}`;
            break;
        case $f956ec92c1beba23$export$5ba560653e4a1035.not_finite:
            message = "Number must be finite";
            break;
        default:
            message = _ctx.defaultError;
            $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(issue);
    }
    return {
        message: message
    };
};
let $f956ec92c1beba23$var$overrideErrorMap = $f956ec92c1beba23$export$341b0b6e0a6f5099;
function $f956ec92c1beba23$export$1097a8289cfd22d7(map) {
    $f956ec92c1beba23$var$overrideErrorMap = map;
}
function $f956ec92c1beba23$export$32f27c719778d4c4() {
    return $f956ec92c1beba23$var$overrideErrorMap;
}
const $f956ec92c1beba23$export$244a85fde9c419ed = (params)=>{
    const { data: data, path: path, errorMaps: errorMaps, issueData: issueData } = params;
    const fullPath = [
        ...path,
        ...issueData.path || []
    ];
    const fullIssue = {
        ...issueData,
        path: fullPath
    };
    let errorMessage = "";
    const maps = errorMaps.filter((m)=>!!m).slice().reverse();
    for (const map of maps)errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
    }).message;
    return {
        ...issueData,
        path: fullPath,
        message: issueData.message || errorMessage
    };
};
const $f956ec92c1beba23$export$1526d2e05f74572 = [];
function $f956ec92c1beba23$export$db7caee60e5d514d(ctx, issueData) {
    const issue = $f956ec92c1beba23$export$244a85fde9c419ed({
        issueData: issueData,
        data: ctx.data,
        path: ctx.path,
        errorMaps: [
            ctx.common.contextualErrorMap,
            ctx.schemaErrorMap,
            $f956ec92c1beba23$export$32f27c719778d4c4(),
            $f956ec92c1beba23$export$341b0b6e0a6f5099
        ].filter((x)=>!!x)
    });
    ctx.common.issues.push(issue);
}
class $f956ec92c1beba23$export$5b20a5c3d05c1f6f {
    constructor(){
        this.value = "valid";
    }
    dirty() {
        if (this.value === "valid") this.value = "dirty";
    }
    abort() {
        if (this.value !== "aborted") this.value = "aborted";
    }
    static mergeArray(status, results) {
        const arrayValue = [];
        for (const s of results){
            if (s.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
            if (s.status === "dirty") status.dirty();
            arrayValue.push(s.value);
        }
        return {
            status: status.value,
            value: arrayValue
        };
    }
    static async mergeObjectAsync(status, pairs) {
        const syncPairs = [];
        for (const pair of pairs)syncPairs.push({
            key: await pair.key,
            value: await pair.value
        });
        return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
    }
    static mergeObjectSync(status, pairs) {
        const finalObject = {};
        for (const pair of pairs){
            const { key: key, value: value } = pair;
            if (key.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
            if (value.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
            if (key.status === "dirty") status.dirty();
            if (value.status === "dirty") status.dirty();
            if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) finalObject[key.value] = value.value;
        }
        return {
            status: status.value,
            value: finalObject
        };
    }
}
const $f956ec92c1beba23$export$9a105a556e65c2c0 = Object.freeze({
    status: "aborted"
});
const $f956ec92c1beba23$export$325a211da9693fcf = (value)=>({
        status: "dirty",
        value: value
    });
const $f956ec92c1beba23$export$c6813a8d51f77eaf = (value)=>({
        status: "valid",
        value: value
    });
const $f956ec92c1beba23$export$afa861e3c5730743 = (x)=>x.status === "aborted";
const $f956ec92c1beba23$export$910b6cdd390341b3 = (x)=>x.status === "dirty";
const $f956ec92c1beba23$export$1ea939691cdc45b8 = (x)=>x.status === "valid";
const $f956ec92c1beba23$export$aefee5ebe1dcfd9e = (x)=>typeof Promise !== "undefined" && x instanceof Promise;
var $f956ec92c1beba23$var$errorUtil;
(function(errorUtil) {
    errorUtil.errToObj = (message)=>typeof message === "string" ? {
            message: message
        } : message || {};
    errorUtil.toString = (message)=>typeof message === "string" ? message : message === null || message === void 0 ? void 0 : message.message;
})($f956ec92c1beba23$var$errorUtil || ($f956ec92c1beba23$var$errorUtil = {}));
class $f956ec92c1beba23$var$ParseInputLazyPath {
    constructor(parent, value, path, key){
        this._cachedPath = [];
        this.parent = parent;
        this.data = value;
        this._path = path;
        this._key = key;
    }
    get path() {
        if (!this._cachedPath.length) {
            if (this._key instanceof Array) this._cachedPath.push(...this._path, ...this._key);
            else this._cachedPath.push(...this._path, this._key);
        }
        return this._cachedPath;
    }
}
const $f956ec92c1beba23$var$handleResult = (ctx, result)=>{
    if ($f956ec92c1beba23$export$1ea939691cdc45b8(result)) return {
        success: true,
        data: result.value
    };
    else {
        if (!ctx.common.issues.length) throw new Error("Validation failed but no issues detected.");
        return {
            success: false,
            get error () {
                if (this._error) return this._error;
                const error = new $f956ec92c1beba23$export$f98dac4b251ab333(ctx.common.issues);
                this._error = error;
                return this._error;
            }
        };
    }
};
function $f956ec92c1beba23$var$processCreateParams(params) {
    if (!params) return {};
    const { errorMap: errorMap, invalid_type_error: invalid_type_error, required_error: required_error, description: description } = params;
    if (errorMap && (invalid_type_error || required_error)) throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    if (errorMap) return {
        errorMap: errorMap,
        description: description
    };
    const customMap = (iss, ctx)=>{
        if (iss.code !== "invalid_type") return {
            message: ctx.defaultError
        };
        if (typeof ctx.data === "undefined") return {
            message: required_error !== null && required_error !== void 0 ? required_error : ctx.defaultError
        };
        return {
            message: invalid_type_error !== null && invalid_type_error !== void 0 ? invalid_type_error : ctx.defaultError
        };
    };
    return {
        errorMap: customMap,
        description: description
    };
}
class $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(def){
        /** Alias of safeParseAsync */ this.spa = this.safeParseAsync;
        this._def = def;
        this.parse = this.parse.bind(this);
        this.safeParse = this.safeParse.bind(this);
        this.parseAsync = this.parseAsync.bind(this);
        this.safeParseAsync = this.safeParseAsync.bind(this);
        this.spa = this.spa.bind(this);
        this.refine = this.refine.bind(this);
        this.refinement = this.refinement.bind(this);
        this.superRefine = this.superRefine.bind(this);
        this.optional = this.optional.bind(this);
        this.nullable = this.nullable.bind(this);
        this.nullish = this.nullish.bind(this);
        this.array = this.array.bind(this);
        this.promise = this.promise.bind(this);
        this.or = this.or.bind(this);
        this.and = this.and.bind(this);
        this.transform = this.transform.bind(this);
        this.brand = this.brand.bind(this);
        this.default = this.default.bind(this);
        this.catch = this.catch.bind(this);
        this.describe = this.describe.bind(this);
        this.pipe = this.pipe.bind(this);
        this.readonly = this.readonly.bind(this);
        this.isNullable = this.isNullable.bind(this);
        this.isOptional = this.isOptional.bind(this);
    }
    get description() {
        return this._def.description;
    }
    _getType(input) {
        return $f956ec92c1beba23$export$3e9057828ebd5c7a(input.data);
    }
    _getOrReturnCtx(input, ctx) {
        return ctx || {
            common: input.parent.common,
            data: input.data,
            parsedType: $f956ec92c1beba23$export$3e9057828ebd5c7a(input.data),
            schemaErrorMap: this._def.errorMap,
            path: input.path,
            parent: input.parent
        };
    }
    _processInputParams(input) {
        return {
            status: new $f956ec92c1beba23$export$5b20a5c3d05c1f6f(),
            ctx: {
                common: input.parent.common,
                data: input.data,
                parsedType: $f956ec92c1beba23$export$3e9057828ebd5c7a(input.data),
                schemaErrorMap: this._def.errorMap,
                path: input.path,
                parent: input.parent
            }
        };
    }
    _parseSync(input) {
        const result = this._parse(input);
        if ($f956ec92c1beba23$export$aefee5ebe1dcfd9e(result)) throw new Error("Synchronous parse encountered promise.");
        return result;
    }
    _parseAsync(input) {
        const result = this._parse(input);
        return Promise.resolve(result);
    }
    parse(data, params) {
        const result = this.safeParse(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    safeParse(data, params) {
        var _a;
        const ctx = {
            common: {
                issues: [],
                async: (_a = params === null || params === void 0 ? void 0 : params.async) !== null && _a !== void 0 ? _a : false,
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f956ec92c1beba23$export$3e9057828ebd5c7a(data)
        };
        const result = this._parseSync({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        return $f956ec92c1beba23$var$handleResult(ctx, result);
    }
    async parseAsync(data, params) {
        const result = await this.safeParseAsync(data, params);
        if (result.success) return result.data;
        throw result.error;
    }
    async safeParseAsync(data, params) {
        const ctx = {
            common: {
                issues: [],
                contextualErrorMap: params === null || params === void 0 ? void 0 : params.errorMap,
                async: true
            },
            path: (params === null || params === void 0 ? void 0 : params.path) || [],
            schemaErrorMap: this._def.errorMap,
            parent: null,
            data: data,
            parsedType: $f956ec92c1beba23$export$3e9057828ebd5c7a(data)
        };
        const maybeAsyncResult = this._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
        const result = await ($f956ec92c1beba23$export$aefee5ebe1dcfd9e(maybeAsyncResult) ? maybeAsyncResult : Promise.resolve(maybeAsyncResult));
        return $f956ec92c1beba23$var$handleResult(ctx, result);
    }
    refine(check, message) {
        const getIssueProperties = (val)=>{
            if (typeof message === "string" || typeof message === "undefined") return {
                message: message
            };
            else if (typeof message === "function") return message(val);
            else return message;
        };
        return this._refinement((val, ctx)=>{
            const result = check(val);
            const setError = ()=>ctx.addIssue({
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.custom,
                    ...getIssueProperties(val)
                });
            if (typeof Promise !== "undefined" && result instanceof Promise) return result.then((data)=>{
                if (!data) {
                    setError();
                    return false;
                } else return true;
            });
            if (!result) {
                setError();
                return false;
            } else return true;
        });
    }
    refinement(check, refinementData) {
        return this._refinement((val, ctx)=>{
            if (!check(val)) {
                ctx.addIssue(typeof refinementData === "function" ? refinementData(val, ctx) : refinementData);
                return false;
            } else return true;
        });
    }
    _refinement(refinement) {
        return new $f956ec92c1beba23$export$a60af00cc0ce2582({
            schema: this,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "refinement",
                refinement: refinement
            }
        });
    }
    superRefine(refinement) {
        return this._refinement(refinement);
    }
    optional() {
        return $f956ec92c1beba23$export$aa56fec1e9d629b8.create(this, this._def);
    }
    nullable() {
        return $f956ec92c1beba23$export$aaac0b8b429cef5.create(this, this._def);
    }
    nullish() {
        return this.nullable().optional();
    }
    array() {
        return $f956ec92c1beba23$export$7acfc3e64785411.create(this, this._def);
    }
    promise() {
        return $f956ec92c1beba23$export$3f196b0127d6e50a.create(this, this._def);
    }
    or(option) {
        return $f956ec92c1beba23$export$a8b236cb5070a311.create([
            this,
            option
        ], this._def);
    }
    and(incoming) {
        return $f956ec92c1beba23$export$c02deaf0bb5203d4.create(this, incoming, this._def);
    }
    transform(transform) {
        return new $f956ec92c1beba23$export$a60af00cc0ce2582({
            ...$f956ec92c1beba23$var$processCreateParams(this._def),
            schema: this,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodEffects,
            effect: {
                type: "transform",
                transform: transform
            }
        });
    }
    default(def) {
        const defaultValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f956ec92c1beba23$export$bb19b37874861e7e({
            ...$f956ec92c1beba23$var$processCreateParams(this._def),
            innerType: this,
            defaultValue: defaultValueFunc,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodDefault
        });
    }
    brand() {
        return new $f956ec92c1beba23$export$66b0c798a395271f({
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodBranded,
            type: this,
            ...$f956ec92c1beba23$var$processCreateParams(this._def)
        });
    }
    catch(def) {
        const catchValueFunc = typeof def === "function" ? def : ()=>def;
        return new $f956ec92c1beba23$export$75a44ec6249ac76b({
            ...$f956ec92c1beba23$var$processCreateParams(this._def),
            innerType: this,
            catchValue: catchValueFunc,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodCatch
        });
    }
    describe(description) {
        const This = this.constructor;
        return new This({
            ...this._def,
            description: description
        });
    }
    pipe(target) {
        return $f956ec92c1beba23$export$a3c3ef8a0e95c6da.create(this, target);
    }
    readonly() {
        return $f956ec92c1beba23$export$5d1f7ef05c4e493a.create(this);
    }
    isOptional() {
        return this.safeParse(undefined).success;
    }
    isNullable() {
        return this.safeParse(null).success;
    }
}
const $f956ec92c1beba23$var$cuidRegex = /^c[^\s-]{8,}$/i;
const $f956ec92c1beba23$var$cuid2Regex = /^[a-z][a-z0-9]*$/;
const $f956ec92c1beba23$var$ulidRegex = /^[0-9A-HJKMNP-TV-Z]{26}$/;
// const uuidRegex =
//   /^([a-f0-9]{8}-[a-f0-9]{4}-[1-5][a-f0-9]{3}-[a-f0-9]{4}-[a-f0-9]{12}|00000000-0000-0000-0000-000000000000)$/i;
const $f956ec92c1beba23$var$uuidRegex = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i;
// from https://stackoverflow.com/a/46181/1550155
// old version: too slow, didn't support unicode
// const emailRegex = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i;
//old email regex
// const emailRegex = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@((?!-)([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{1,})[^-<>()[\].,;:\s@"]$/i;
// eslint-disable-next-line
// const emailRegex =
//   /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\])|(\[IPv6:(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))\])|([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])*(\.[A-Za-z]{2,})+))$/;
// const emailRegex =
//   /^[a-zA-Z0-9\.\!\#\$\%\&\'\*\+\/\=\?\^\_\`\{\|\}\~\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
// const emailRegex =
//   /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
const $f956ec92c1beba23$var$emailRegex = /^(?!\.)(?!.*\.\.)([A-Z0-9_+-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i;
// const emailRegex =
//   /^[a-z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-z0-9-]+(?:\.[a-z0-9\-]+)*$/i;
// from https://thekevinscott.com/emojis-in-javascript/#writing-a-regular-expression
const $f956ec92c1beba23$var$_emojiRegex = `^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$`;
let $f956ec92c1beba23$var$emojiRegex;
const $f956ec92c1beba23$var$ipv4Regex = /^(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))$/;
const $f956ec92c1beba23$var$ipv6Regex = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/;
// Adapted from https://stackoverflow.com/a/3143231
const $f956ec92c1beba23$var$datetimeRegex = (args)=>{
    if (args.precision) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}\\.\\d{${args.precision}}Z$`);
    } else if (args.precision === 0) {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}Z$`);
    } else {
        if (args.offset) return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?(([+-]\\d{2}(:?\\d{2})?)|Z)$`);
        else return new RegExp(`^\\d{4}-\\d{2}-\\d{2}T\\d{2}:\\d{2}:\\d{2}(\\.\\d+)?Z$`);
    }
};
function $f956ec92c1beba23$var$isValidIP(ip, version) {
    if ((version === "v4" || !version) && $f956ec92c1beba23$var$ipv4Regex.test(ip)) return true;
    if ((version === "v6" || !version) && $f956ec92c1beba23$var$ipv6Regex.test(ip)) return true;
    return false;
}
class $f956ec92c1beba23$export$1230eb29b8d3b502 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = String(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.string) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.string,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const status = new $f956ec92c1beba23$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.length < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.length > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "length") {
                const tooBig = input.data.length > check.value;
                const tooSmall = input.data.length < check.value;
                if (tooBig || tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    if (tooBig) $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    else if (tooSmall) $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "string",
                        inclusive: true,
                        exact: true,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "email") {
                if (!$f956ec92c1beba23$var$emailRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "email",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "emoji") {
                if (!$f956ec92c1beba23$var$emojiRegex) $f956ec92c1beba23$var$emojiRegex = new RegExp($f956ec92c1beba23$var$_emojiRegex, "u");
                if (!$f956ec92c1beba23$var$emojiRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "emoji",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "uuid") {
                if (!$f956ec92c1beba23$var$uuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "uuid",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid") {
                if (!$f956ec92c1beba23$var$cuidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "cuid",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "cuid2") {
                if (!$f956ec92c1beba23$var$cuid2Regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "cuid2",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ulid") {
                if (!$f956ec92c1beba23$var$ulidRegex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "ulid",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "url") try {
                new URL(input.data);
            } catch (_a) {
                ctx = this._getOrReturnCtx(input, ctx);
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    validation: "url",
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                    message: check.message
                });
                status.dirty();
            }
            else if (check.kind === "regex") {
                check.regex.lastIndex = 0;
                const testResult = check.regex.test(input.data);
                if (!testResult) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "regex",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "trim") input.data = input.data.trim();
            else if (check.kind === "includes") {
                if (!input.data.includes(check.value, check.position)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            includes: check.value,
                            position: check.position
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "toLowerCase") input.data = input.data.toLowerCase();
            else if (check.kind === "toUpperCase") input.data = input.data.toUpperCase();
            else if (check.kind === "startsWith") {
                if (!input.data.startsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            startsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "endsWith") {
                if (!input.data.endsWith(check.value)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        validation: {
                            endsWith: check.value
                        },
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "datetime") {
                const regex = $f956ec92c1beba23$var$datetimeRegex(check);
                if (!regex.test(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        validation: "datetime",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "ip") {
                if (!$f956ec92c1beba23$var$isValidIP(input.data, check.version)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        validation: "ip",
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    _regex(regex, validation, message) {
        return this.refinement((data)=>regex.test(data), {
            validation: validation,
            code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_string,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    _addCheck(check) {
        return new $f956ec92c1beba23$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    email(message) {
        return this._addCheck({
            kind: "email",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    url(message) {
        return this._addCheck({
            kind: "url",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    emoji(message) {
        return this._addCheck({
            kind: "emoji",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    uuid(message) {
        return this._addCheck({
            kind: "uuid",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    cuid(message) {
        return this._addCheck({
            kind: "cuid",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    cuid2(message) {
        return this._addCheck({
            kind: "cuid2",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    ulid(message) {
        return this._addCheck({
            kind: "ulid",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    ip(options) {
        return this._addCheck({
            kind: "ip",
            ...$f956ec92c1beba23$var$errorUtil.errToObj(options)
        });
    }
    datetime(options) {
        var _a;
        if (typeof options === "string") return this._addCheck({
            kind: "datetime",
            precision: null,
            offset: false,
            message: options
        });
        return this._addCheck({
            kind: "datetime",
            precision: typeof (options === null || options === void 0 ? void 0 : options.precision) === "undefined" ? null : options === null || options === void 0 ? void 0 : options.precision,
            offset: (_a = options === null || options === void 0 ? void 0 : options.offset) !== null && _a !== void 0 ? _a : false,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    regex(regex, message) {
        return this._addCheck({
            kind: "regex",
            regex: regex,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    includes(value, options) {
        return this._addCheck({
            kind: "includes",
            value: value,
            position: options === null || options === void 0 ? void 0 : options.position,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(options === null || options === void 0 ? void 0 : options.message)
        });
    }
    startsWith(value, message) {
        return this._addCheck({
            kind: "startsWith",
            value: value,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    endsWith(value, message) {
        return this._addCheck({
            kind: "endsWith",
            value: value,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    min(minLength, message) {
        return this._addCheck({
            kind: "min",
            value: minLength,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    max(maxLength, message) {
        return this._addCheck({
            kind: "max",
            value: maxLength,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    length(len, message) {
        return this._addCheck({
            kind: "length",
            value: len,
            ...$f956ec92c1beba23$var$errorUtil.errToObj(message)
        });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */ nonempty(message) {
        return this.min(1, $f956ec92c1beba23$var$errorUtil.errToObj(message));
    }
    trim() {
        return new $f956ec92c1beba23$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "trim"
                }
            ]
        });
    }
    toLowerCase() {
        return new $f956ec92c1beba23$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toLowerCase"
                }
            ]
        });
    }
    toUpperCase() {
        return new $f956ec92c1beba23$export$1230eb29b8d3b502({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: "toUpperCase"
                }
            ]
        });
    }
    get isDatetime() {
        return !!this._def.checks.find((ch)=>ch.kind === "datetime");
    }
    get isEmail() {
        return !!this._def.checks.find((ch)=>ch.kind === "email");
    }
    get isURL() {
        return !!this._def.checks.find((ch)=>ch.kind === "url");
    }
    get isEmoji() {
        return !!this._def.checks.find((ch)=>ch.kind === "emoji");
    }
    get isUUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "uuid");
    }
    get isCUID() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid");
    }
    get isCUID2() {
        return !!this._def.checks.find((ch)=>ch.kind === "cuid2");
    }
    get isULID() {
        return !!this._def.checks.find((ch)=>ch.kind === "ulid");
    }
    get isIP() {
        return !!this._def.checks.find((ch)=>ch.kind === "ip");
    }
    get minLength() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxLength() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f956ec92c1beba23$export$1230eb29b8d3b502.create = (params)=>{
    var _a;
    return new $f956ec92c1beba23$export$1230eb29b8d3b502({
        checks: [],
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodString,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
// https://stackoverflow.com/questions/3966484/why-does-modulus-operator-return-fractional-number-in-javascript/31711034#31711034
function $f956ec92c1beba23$var$floatSafeRemainder(val, step) {
    const valDecCount = (val.toString().split(".")[1] || "").length;
    const stepDecCount = (step.toString().split(".")[1] || "").length;
    const decCount = valDecCount > stepDecCount ? valDecCount : stepDecCount;
    const valInt = parseInt(val.toFixed(decCount).replace(".", ""));
    const stepInt = parseInt(step.toFixed(decCount).replace(".", ""));
    return valInt % stepInt / Math.pow(10, decCount);
}
class $f956ec92c1beba23$export$5b070a55c0c43e09 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
        this.step = this.multipleOf;
    }
    _parse(input) {
        if (this._def.coerce) input.data = Number(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.number) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.number,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f956ec92c1beba23$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "int") {
                if (!$f956ec92c1beba23$export$7debb50ef11d5e0b.isInteger(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                        expected: "integer",
                        received: "float",
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                        minimum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                        maximum: check.value,
                        type: "number",
                        inclusive: check.inclusive,
                        exact: false,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if ($f956ec92c1beba23$var$floatSafeRemainder(input.data, check.value) !== 0) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "finite") {
                if (!Number.isFinite(input.data)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.not_finite,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f956ec92c1beba23$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f956ec92c1beba23$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f956ec92c1beba23$export$5b070a55c0c43e09({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    int(message) {
        return this._addCheck({
            kind: "int",
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: false,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: false,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: 0,
            inclusive: true,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: 0,
            inclusive: true,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    finite(message) {
        return this._addCheck({
            kind: "finite",
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    safe(message) {
        return this._addCheck({
            kind: "min",
            inclusive: true,
            value: Number.MIN_SAFE_INTEGER,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        })._addCheck({
            kind: "max",
            inclusive: true,
            value: Number.MAX_SAFE_INTEGER,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
    get isInt() {
        return !!this._def.checks.find((ch)=>ch.kind === "int" || ch.kind === "multipleOf" && $f956ec92c1beba23$export$7debb50ef11d5e0b.isInteger(ch.value));
    }
    get isFinite() {
        let max = null, min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "finite" || ch.kind === "int" || ch.kind === "multipleOf") return true;
            else if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            } else if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return Number.isFinite(min) && Number.isFinite(max);
    }
}
$f956ec92c1beba23$export$5b070a55c0c43e09.create = (params)=>{
    return new $f956ec92c1beba23$export$5b070a55c0c43e09({
        checks: [],
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNumber,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$67d741fd70ff98f4 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.min = this.gte;
        this.max = this.lte;
    }
    _parse(input) {
        if (this._def.coerce) input.data = BigInt(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.bigint) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.bigint,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        let ctx = undefined;
        const status = new $f956ec92c1beba23$export$5b20a5c3d05c1f6f();
        for (const check of this._def.checks){
            if (check.kind === "min") {
                const tooSmall = check.inclusive ? input.data < check.value : input.data <= check.value;
                if (tooSmall) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                        type: "bigint",
                        minimum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                const tooBig = check.inclusive ? input.data > check.value : input.data >= check.value;
                if (tooBig) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                        type: "bigint",
                        maximum: check.value,
                        inclusive: check.inclusive,
                        message: check.message
                    });
                    status.dirty();
                }
            } else if (check.kind === "multipleOf") {
                if (input.data % check.value !== BigInt(0)) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.not_multiple_of,
                        multipleOf: check.value,
                        message: check.message
                    });
                    status.dirty();
                }
            } else $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: input.data
        };
    }
    gte(value, message) {
        return this.setLimit("min", value, true, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    gt(value, message) {
        return this.setLimit("min", value, false, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    lte(value, message) {
        return this.setLimit("max", value, true, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    lt(value, message) {
        return this.setLimit("max", value, false, $f956ec92c1beba23$var$errorUtil.toString(message));
    }
    setLimit(kind, value, inclusive, message) {
        return new $f956ec92c1beba23$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                {
                    kind: kind,
                    value: value,
                    inclusive: inclusive,
                    message: $f956ec92c1beba23$var$errorUtil.toString(message)
                }
            ]
        });
    }
    _addCheck(check) {
        return new $f956ec92c1beba23$export$67d741fd70ff98f4({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    positive(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: false,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    negative(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: false,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    nonpositive(message) {
        return this._addCheck({
            kind: "max",
            value: BigInt(0),
            inclusive: true,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    nonnegative(message) {
        return this._addCheck({
            kind: "min",
            value: BigInt(0),
            inclusive: true,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    multipleOf(value, message) {
        return this._addCheck({
            kind: "multipleOf",
            value: value,
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    get minValue() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min;
    }
    get maxValue() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max;
    }
}
$f956ec92c1beba23$export$67d741fd70ff98f4.create = (params)=>{
    var _a;
    return new $f956ec92c1beba23$export$67d741fd70ff98f4({
        checks: [],
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodBigInt,
        coerce: (_a = params === null || params === void 0 ? void 0 : params.coerce) !== null && _a !== void 0 ? _a : false,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$723d146f80596191 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = Boolean(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.boolean) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.boolean,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$723d146f80596191.create = (params)=>{
    return new $f956ec92c1beba23$export$723d146f80596191({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodBoolean,
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$e974be33bdc55521 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        if (this._def.coerce) input.data = new Date(input.data);
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.date) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.date,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (isNaN(input.data.getTime())) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_date
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const status = new $f956ec92c1beba23$export$5b20a5c3d05c1f6f();
        let ctx = undefined;
        for (const check of this._def.checks){
            if (check.kind === "min") {
                if (input.data.getTime() < check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        minimum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else if (check.kind === "max") {
                if (input.data.getTime() > check.value) {
                    ctx = this._getOrReturnCtx(input, ctx);
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                        message: check.message,
                        inclusive: true,
                        exact: false,
                        maximum: check.value,
                        type: "date"
                    });
                    status.dirty();
                }
            } else $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(check);
        }
        return {
            status: status.value,
            value: new Date(input.data.getTime())
        };
    }
    _addCheck(check) {
        return new $f956ec92c1beba23$export$e974be33bdc55521({
            ...this._def,
            checks: [
                ...this._def.checks,
                check
            ]
        });
    }
    min(minDate, message) {
        return this._addCheck({
            kind: "min",
            value: minDate.getTime(),
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    max(maxDate, message) {
        return this._addCheck({
            kind: "max",
            value: maxDate.getTime(),
            message: $f956ec92c1beba23$var$errorUtil.toString(message)
        });
    }
    get minDate() {
        let min = null;
        for (const ch of this._def.checks){
            if (ch.kind === "min") {
                if (min === null || ch.value > min) min = ch.value;
            }
        }
        return min != null ? new Date(min) : null;
    }
    get maxDate() {
        let max = null;
        for (const ch of this._def.checks){
            if (ch.kind === "max") {
                if (max === null || ch.value < max) max = ch.value;
            }
        }
        return max != null ? new Date(max) : null;
    }
}
$f956ec92c1beba23$export$e974be33bdc55521.create = (params)=>{
    return new $f956ec92c1beba23$export$e974be33bdc55521({
        checks: [],
        coerce: (params === null || params === void 0 ? void 0 : params.coerce) || false,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodDate,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$bcc3b40f6b638044 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.symbol) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.symbol,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$bcc3b40f6b638044.create = (params)=>{
    return new $f956ec92c1beba23$export$bcc3b40f6b638044({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodSymbol,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$4e780e961c30340d extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.undefined,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$4e780e961c30340d.create = (params)=>{
    return new $f956ec92c1beba23$export$4e780e961c30340d({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodUndefined,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$a96281f914484f2d extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.null) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.null,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$a96281f914484f2d.create = (params)=>{
    return new $f956ec92c1beba23$export$a96281f914484f2d({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNull,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$b9d1edb536b4e4eb extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // to prevent instances of other classes from extending ZodAny. this causes issues with catchall in ZodObject.
        this._any = true;
    }
    _parse(input) {
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$b9d1edb536b4e4eb.create = (params)=>{
    return new $f956ec92c1beba23$export$b9d1edb536b4e4eb({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodAny,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$ef3b1bb1630977ae extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        // required
        this._unknown = true;
    }
    _parse(input) {
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$ef3b1bb1630977ae.create = (params)=>{
    return new $f956ec92c1beba23$export$ef3b1bb1630977ae({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodUnknown,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$1e576a20c3ce9fb5 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const ctx = this._getOrReturnCtx(input);
        $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
            code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
            expected: $f956ec92c1beba23$export$5716da67bfaa244d.never,
            received: ctx.parsedType
        });
        return $f956ec92c1beba23$export$9a105a556e65c2c0;
    }
}
$f956ec92c1beba23$export$1e576a20c3ce9fb5.create = (params)=>{
    return new $f956ec92c1beba23$export$1e576a20c3ce9fb5({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNever,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$7d39f5df85f21031 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.undefined) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.void,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
}
$f956ec92c1beba23$export$7d39f5df85f21031.create = (params)=>{
    return new $f956ec92c1beba23$export$7d39f5df85f21031({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodVoid,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$7acfc3e64785411 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx, status: status } = this._processInputParams(input);
        const def = this._def;
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.array) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (def.exactLength !== null) {
            const tooBig = ctx.data.length > def.exactLength.value;
            const tooSmall = ctx.data.length < def.exactLength.value;
            if (tooBig || tooSmall) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: tooBig ? $f956ec92c1beba23$export$5ba560653e4a1035.too_big : $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                    minimum: tooSmall ? def.exactLength.value : undefined,
                    maximum: tooBig ? def.exactLength.value : undefined,
                    type: "array",
                    inclusive: true,
                    exact: true,
                    message: def.exactLength.message
                });
                status.dirty();
            }
        }
        if (def.minLength !== null) {
            if (ctx.data.length < def.minLength.value) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                    minimum: def.minLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.minLength.message
                });
                status.dirty();
            }
        }
        if (def.maxLength !== null) {
            if (ctx.data.length > def.maxLength.value) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                    maximum: def.maxLength.value,
                    type: "array",
                    inclusive: true,
                    exact: false,
                    message: def.maxLength.message
                });
                status.dirty();
            }
        }
        if (ctx.common.async) return Promise.all([
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseAsync(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        })).then((result)=>{
            return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeArray(status, result);
        });
        const result = [
            ...ctx.data
        ].map((item, i)=>{
            return def.type._parseSync(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, item, ctx.path, i));
        });
        return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeArray(status, result);
    }
    get element() {
        return this._def.type;
    }
    min(minLength, message) {
        return new $f956ec92c1beba23$export$7acfc3e64785411({
            ...this._def,
            minLength: {
                value: minLength,
                message: $f956ec92c1beba23$var$errorUtil.toString(message)
            }
        });
    }
    max(maxLength, message) {
        return new $f956ec92c1beba23$export$7acfc3e64785411({
            ...this._def,
            maxLength: {
                value: maxLength,
                message: $f956ec92c1beba23$var$errorUtil.toString(message)
            }
        });
    }
    length(len, message) {
        return new $f956ec92c1beba23$export$7acfc3e64785411({
            ...this._def,
            exactLength: {
                value: len,
                message: $f956ec92c1beba23$var$errorUtil.toString(message)
            }
        });
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f956ec92c1beba23$export$7acfc3e64785411.create = (schema, params)=>{
    return new $f956ec92c1beba23$export$7acfc3e64785411({
        type: schema,
        minLength: null,
        maxLength: null,
        exactLength: null,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodArray,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
function $f956ec92c1beba23$var$deepPartialify(schema) {
    if (schema instanceof $f956ec92c1beba23$export$736315c5b55efbad) {
        const newShape = {};
        for(const key in schema.shape){
            const fieldSchema = schema.shape[key];
            newShape[key] = $f956ec92c1beba23$export$aa56fec1e9d629b8.create($f956ec92c1beba23$var$deepPartialify(fieldSchema));
        }
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...schema._def,
            shape: ()=>newShape
        });
    } else if (schema instanceof $f956ec92c1beba23$export$7acfc3e64785411) return new $f956ec92c1beba23$export$7acfc3e64785411({
        ...schema._def,
        type: $f956ec92c1beba23$var$deepPartialify(schema.element)
    });
    else if (schema instanceof $f956ec92c1beba23$export$aa56fec1e9d629b8) return $f956ec92c1beba23$export$aa56fec1e9d629b8.create($f956ec92c1beba23$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f956ec92c1beba23$export$aaac0b8b429cef5) return $f956ec92c1beba23$export$aaac0b8b429cef5.create($f956ec92c1beba23$var$deepPartialify(schema.unwrap()));
    else if (schema instanceof $f956ec92c1beba23$export$e2a18bb771d8e6a3) return $f956ec92c1beba23$export$e2a18bb771d8e6a3.create(schema.items.map((item)=>$f956ec92c1beba23$var$deepPartialify(item)));
    else return schema;
}
class $f956ec92c1beba23$export$736315c5b55efbad extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this._cached = null;
        /**
         * @deprecated In most cases, this is no longer needed - unknown properties are now silently stripped.
         * If you want to pass through unknown properties, use `.passthrough()` instead.
         */ this.nonstrict = this.passthrough;
        // extend<
        //   Augmentation extends ZodRawShape,
        //   NewOutput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
        //       ? Augmentation[k]["_output"]
        //       : k extends keyof Output
        //       ? Output[k]
        //       : never;
        //   }>,
        //   NewInput extends util.flatten<{
        //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
        //       ? Augmentation[k]["_input"]
        //       : k extends keyof Input
        //       ? Input[k]
        //       : never;
        //   }>
        // >(
        //   augmentation: Augmentation
        // ): ZodObject<
        //   extendShape<T, Augmentation>,
        //   UnknownKeys,
        //   Catchall,
        //   NewOutput,
        //   NewInput
        // > {
        //   return new ZodObject({
        //     ...this._def,
        //     shape: () => ({
        //       ...this._def.shape(),
        //       ...augmentation,
        //     }),
        //   }) as any;
        // }
        /**
         * @deprecated Use `.extend` instead
         *  */ this.augment = this.extend;
    }
    _getCached() {
        if (this._cached !== null) return this._cached;
        const shape = this._def.shape();
        const keys = $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(shape);
        return this._cached = {
            shape: shape,
            keys: keys
        };
    }
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.object) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const { shape: shape, keys: shapeKeys } = this._getCached();
        const extraKeys = [];
        if (!(this._def.catchall instanceof $f956ec92c1beba23$export$1e576a20c3ce9fb5 && this._def.unknownKeys === "strip")) {
            for(const key in ctx.data)if (!shapeKeys.includes(key)) extraKeys.push(key);
        }
        const pairs = [];
        for (const key of shapeKeys){
            const keyValidator = shape[key];
            const value = ctx.data[key];
            pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: keyValidator._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, value, ctx.path, key)),
                alwaysSet: key in ctx.data
            });
        }
        if (this._def.catchall instanceof $f956ec92c1beba23$export$1e576a20c3ce9fb5) {
            const unknownKeys = this._def.unknownKeys;
            if (unknownKeys === "passthrough") for (const key of extraKeys)pairs.push({
                key: {
                    status: "valid",
                    value: key
                },
                value: {
                    status: "valid",
                    value: ctx.data[key]
                }
            });
            else if (unknownKeys === "strict") {
                if (extraKeys.length > 0) {
                    $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                        code: $f956ec92c1beba23$export$5ba560653e4a1035.unrecognized_keys,
                        keys: extraKeys
                    });
                    status.dirty();
                }
            } else if (unknownKeys === "strip") ;
            else throw new Error(`Internal ZodObject error: invalid unknownKeys value.`);
        } else {
            // run catchall validation
            const catchall = this._def.catchall;
            for (const key of extraKeys){
                const value = ctx.data[key];
                pairs.push({
                    key: {
                        status: "valid",
                        value: key
                    },
                    value: catchall._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, value, ctx.path, key) //, ctx.child(key), value, getParsedType(value)
                    ),
                    alwaysSet: key in ctx.data
                });
            }
        }
        if (ctx.common.async) return Promise.resolve().then(async ()=>{
            const syncPairs = [];
            for (const pair of pairs){
                const key = await pair.key;
                syncPairs.push({
                    key: key,
                    value: await pair.value,
                    alwaysSet: pair.alwaysSet
                });
            }
            return syncPairs;
        }).then((syncPairs)=>{
            return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeObjectSync(status, syncPairs);
        });
        else return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get shape() {
        return this._def.shape();
    }
    strict(message) {
        $f956ec92c1beba23$var$errorUtil.errToObj;
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strict",
            ...message !== undefined ? {
                errorMap: (issue, ctx)=>{
                    var _a, _b, _c, _d;
                    const defaultError = (_c = (_b = (_a = this._def).errorMap) === null || _b === void 0 ? void 0 : _b.call(_a, issue, ctx).message) !== null && _c !== void 0 ? _c : ctx.defaultError;
                    if (issue.code === "unrecognized_keys") return {
                        message: (_d = $f956ec92c1beba23$var$errorUtil.errToObj(message).message) !== null && _d !== void 0 ? _d : defaultError
                    };
                    return {
                        message: defaultError
                    };
                }
            } : {}
        });
    }
    strip() {
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "strip"
        });
    }
    passthrough() {
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            unknownKeys: "passthrough"
        });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(augmentation) {
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>({
                    ...this._def.shape(),
                    ...augmentation
                })
        });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */ merge(merging) {
        const merged = new $f956ec92c1beba23$export$736315c5b55efbad({
            unknownKeys: merging._def.unknownKeys,
            catchall: merging._def.catchall,
            shape: ()=>({
                    ...this._def.shape(),
                    ...merging._def.shape()
                }),
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodObject
        });
        return merged;
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(key, schema) {
        return this.augment({
            [key]: schema
        });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(index) {
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            catchall: index
        });
    }
    pick(mask) {
        const shape = {};
        $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(mask).forEach((key)=>{
            if (mask[key] && this.shape[key]) shape[key] = this.shape[key];
        });
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    omit(mask) {
        const shape = {};
        $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (!mask[key]) shape[key] = this.shape[key];
        });
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>shape
        });
    }
    /**
     * @deprecated
     */ deepPartial() {
        return $f956ec92c1beba23$var$deepPartialify(this);
    }
    partial(mask) {
        const newShape = {};
        $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            const fieldSchema = this.shape[key];
            if (mask && !mask[key]) newShape[key] = fieldSchema;
            else newShape[key] = fieldSchema.optional();
        });
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    required(mask) {
        const newShape = {};
        $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(this.shape).forEach((key)=>{
            if (mask && !mask[key]) newShape[key] = this.shape[key];
            else {
                const fieldSchema = this.shape[key];
                let newField = fieldSchema;
                while(newField instanceof $f956ec92c1beba23$export$aa56fec1e9d629b8)newField = newField._def.innerType;
                newShape[key] = newField;
            }
        });
        return new $f956ec92c1beba23$export$736315c5b55efbad({
            ...this._def,
            shape: ()=>newShape
        });
    }
    keyof() {
        return $f956ec92c1beba23$var$createZodEnum($f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(this.shape));
    }
}
$f956ec92c1beba23$export$736315c5b55efbad.create = (shape, params)=>{
    return new $f956ec92c1beba23$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strip",
        catchall: $f956ec92c1beba23$export$1e576a20c3ce9fb5.create(),
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodObject,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
$f956ec92c1beba23$export$736315c5b55efbad.strictCreate = (shape, params)=>{
    return new $f956ec92c1beba23$export$736315c5b55efbad({
        shape: ()=>shape,
        unknownKeys: "strict",
        catchall: $f956ec92c1beba23$export$1e576a20c3ce9fb5.create(),
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodObject,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
$f956ec92c1beba23$export$736315c5b55efbad.lazycreate = (shape, params)=>{
    return new $f956ec92c1beba23$export$736315c5b55efbad({
        shape: shape,
        unknownKeys: "strip",
        catchall: $f956ec92c1beba23$export$1e576a20c3ce9fb5.create(),
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodObject,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$a8b236cb5070a311 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const options = this._def.options;
        function handleResults(results) {
            // return first issue-free validation if it exists
            for (const result of results){
                if (result.result.status === "valid") return result.result;
            }
            for (const result of results)if (result.result.status === "dirty") {
                // add issues from dirty option
                ctx.common.issues.push(...result.ctx.common.issues);
                return result.result;
            }
            // return invalid
            const unionErrors = results.map((result)=>new $f956ec92c1beba23$export$f98dac4b251ab333(result.ctx.common.issues));
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return Promise.all(options.map(async (option)=>{
            const childCtx = {
                ...ctx,
                common: {
                    ...ctx.common,
                    issues: []
                },
                parent: null
            };
            return {
                result: await option._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                }),
                ctx: childCtx
            };
        })).then(handleResults);
        else {
            let dirty = undefined;
            const issues = [];
            for (const option of options){
                const childCtx = {
                    ...ctx,
                    common: {
                        ...ctx.common,
                        issues: []
                    },
                    parent: null
                };
                const result = option._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: childCtx
                });
                if (result.status === "valid") return result;
                else if (result.status === "dirty" && !dirty) dirty = {
                    result: result,
                    ctx: childCtx
                };
                if (childCtx.common.issues.length) issues.push(childCtx.common.issues);
            }
            if (dirty) {
                ctx.common.issues.push(...dirty.ctx.common.issues);
                return dirty.result;
            }
            const unionErrors = issues.map((issues)=>new $f956ec92c1beba23$export$f98dac4b251ab333(issues));
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_union,
                unionErrors: unionErrors
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
    }
    get options() {
        return this._def.options;
    }
}
$f956ec92c1beba23$export$a8b236cb5070a311.create = (types, params)=>{
    return new $f956ec92c1beba23$export$a8b236cb5070a311({
        options: types,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodUnion,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
//////////                                 //////////
//////////      ZodDiscriminatedUnion      //////////
//////////                                 //////////
/////////////////////////////////////////////////////
/////////////////////////////////////////////////////
const $f956ec92c1beba23$var$getDiscriminator = (type)=>{
    if (type instanceof $f956ec92c1beba23$export$378d0cfce37406e6) return $f956ec92c1beba23$var$getDiscriminator(type.schema);
    else if (type instanceof $f956ec92c1beba23$export$a60af00cc0ce2582) return $f956ec92c1beba23$var$getDiscriminator(type.innerType());
    else if (type instanceof $f956ec92c1beba23$export$7e44096782a165d3) return [
        type.value
    ];
    else if (type instanceof $f956ec92c1beba23$export$d325d1f0e1c20179) return type.options;
    else if (type instanceof $f956ec92c1beba23$export$370b2e8d6d6f5c56) // eslint-disable-next-line ban/ban
    return Object.keys(type.enum);
    else if (type instanceof $f956ec92c1beba23$export$bb19b37874861e7e) return $f956ec92c1beba23$var$getDiscriminator(type._def.innerType);
    else if (type instanceof $f956ec92c1beba23$export$4e780e961c30340d) return [
        undefined
    ];
    else if (type instanceof $f956ec92c1beba23$export$a96281f914484f2d) return [
        null
    ];
    else return null;
};
class $f956ec92c1beba23$export$5ef2424805ac76a3 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.object) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const discriminator = this.discriminator;
        const discriminatorValue = ctx.data[discriminator];
        const option = this.optionsMap.get(discriminatorValue);
        if (!option) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_union_discriminator,
                options: Array.from(this.optionsMap.keys()),
                path: [
                    discriminator
                ]
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (ctx.common.async) return option._parseAsync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
        else return option._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
    get discriminator() {
        return this._def.discriminator;
    }
    get options() {
        return this._def.options;
    }
    get optionsMap() {
        return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */ static create(discriminator, options, params) {
        // Get all the valid discriminator values
        const optionsMap = new Map();
        // try {
        for (const type of options){
            const discriminatorValues = $f956ec92c1beba23$var$getDiscriminator(type.shape[discriminator]);
            if (!discriminatorValues) throw new Error(`A discriminator value for key \`${discriminator}\` could not be extracted from all schema options`);
            for (const value of discriminatorValues){
                if (optionsMap.has(value)) throw new Error(`Discriminator property ${String(discriminator)} has duplicate value ${String(value)}`);
                optionsMap.set(value, type);
            }
        }
        return new $f956ec92c1beba23$export$5ef2424805ac76a3({
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodDiscriminatedUnion,
            discriminator: discriminator,
            options: options,
            optionsMap: optionsMap,
            ...$f956ec92c1beba23$var$processCreateParams(params)
        });
    }
}
function $f956ec92c1beba23$var$mergeValues(a, b) {
    const aType = $f956ec92c1beba23$export$3e9057828ebd5c7a(a);
    const bType = $f956ec92c1beba23$export$3e9057828ebd5c7a(b);
    if (a === b) return {
        valid: true,
        data: a
    };
    else if (aType === $f956ec92c1beba23$export$5716da67bfaa244d.object && bType === $f956ec92c1beba23$export$5716da67bfaa244d.object) {
        const bKeys = $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(b);
        const sharedKeys = $f956ec92c1beba23$export$7debb50ef11d5e0b.objectKeys(a).filter((key)=>bKeys.indexOf(key) !== -1);
        const newObj = {
            ...a,
            ...b
        };
        for (const key of sharedKeys){
            const sharedValue = $f956ec92c1beba23$var$mergeValues(a[key], b[key]);
            if (!sharedValue.valid) return {
                valid: false
            };
            newObj[key] = sharedValue.data;
        }
        return {
            valid: true,
            data: newObj
        };
    } else if (aType === $f956ec92c1beba23$export$5716da67bfaa244d.array && bType === $f956ec92c1beba23$export$5716da67bfaa244d.array) {
        if (a.length !== b.length) return {
            valid: false
        };
        const newArray = [];
        for(let index = 0; index < a.length; index++){
            const itemA = a[index];
            const itemB = b[index];
            const sharedValue = $f956ec92c1beba23$var$mergeValues(itemA, itemB);
            if (!sharedValue.valid) return {
                valid: false
            };
            newArray.push(sharedValue.data);
        }
        return {
            valid: true,
            data: newArray
        };
    } else if (aType === $f956ec92c1beba23$export$5716da67bfaa244d.date && bType === $f956ec92c1beba23$export$5716da67bfaa244d.date && +a === +b) return {
        valid: true,
        data: a
    };
    else return {
        valid: false
    };
}
class $f956ec92c1beba23$export$c02deaf0bb5203d4 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const handleParsed = (parsedLeft, parsedRight)=>{
            if ($f956ec92c1beba23$export$afa861e3c5730743(parsedLeft) || $f956ec92c1beba23$export$afa861e3c5730743(parsedRight)) return $f956ec92c1beba23$export$9a105a556e65c2c0;
            const merged = $f956ec92c1beba23$var$mergeValues(parsedLeft.value, parsedRight.value);
            if (!merged.valid) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_intersection_types
                });
                return $f956ec92c1beba23$export$9a105a556e65c2c0;
            }
            if ($f956ec92c1beba23$export$910b6cdd390341b3(parsedLeft) || $f956ec92c1beba23$export$910b6cdd390341b3(parsedRight)) status.dirty();
            return {
                status: status.value,
                value: merged.data
            };
        };
        if (ctx.common.async) return Promise.all([
            this._def.left._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }),
            this._def.right._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            })
        ]).then(([left, right])=>handleParsed(left, right));
        else return handleParsed(this._def.left._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }), this._def.right._parseSync({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        }));
    }
}
$f956ec92c1beba23$export$c02deaf0bb5203d4.create = (left, right, params)=>{
    return new $f956ec92c1beba23$export$c02deaf0bb5203d4({
        left: left,
        right: right,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodIntersection,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$e2a18bb771d8e6a3 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.array) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.array,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (ctx.data.length < this._def.items.length) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                minimum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const rest = this._def.rest;
        if (!rest && ctx.data.length > this._def.items.length) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                maximum: this._def.items.length,
                inclusive: true,
                exact: false,
                type: "array"
            });
            status.dirty();
        }
        const items = [
            ...ctx.data
        ].map((item, itemIndex)=>{
            const schema = this._def.items[itemIndex] || this._def.rest;
            if (!schema) return null;
            return schema._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, item, ctx.path, itemIndex));
        }).filter((x)=>!!x); // filter nulls
        if (ctx.common.async) return Promise.all(items).then((results)=>{
            return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeArray(status, results);
        });
        else return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeArray(status, items);
    }
    get items() {
        return this._def.items;
    }
    rest(rest) {
        return new $f956ec92c1beba23$export$e2a18bb771d8e6a3({
            ...this._def,
            rest: rest
        });
    }
}
$f956ec92c1beba23$export$e2a18bb771d8e6a3.create = (schemas, params)=>{
    if (!Array.isArray(schemas)) throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new $f956ec92c1beba23$export$e2a18bb771d8e6a3({
        items: schemas,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodTuple,
        rest: null,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$a2acc09968cb4b7f extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.object) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.object,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const pairs = [];
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        for(const key in ctx.data)pairs.push({
            key: keyType._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, key, ctx.path, key)),
            value: valueType._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, ctx.data[key], ctx.path, key))
        });
        if (ctx.common.async) return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeObjectAsync(status, pairs);
        else return $f956ec92c1beba23$export$5b20a5c3d05c1f6f.mergeObjectSync(status, pairs);
    }
    get element() {
        return this._def.valueType;
    }
    static create(first, second, third) {
        if (second instanceof $f956ec92c1beba23$export$19342e026b58ebb7) return new $f956ec92c1beba23$export$a2acc09968cb4b7f({
            keyType: first,
            valueType: second,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodRecord,
            ...$f956ec92c1beba23$var$processCreateParams(third)
        });
        return new $f956ec92c1beba23$export$a2acc09968cb4b7f({
            keyType: $f956ec92c1beba23$export$1230eb29b8d3b502.create(),
            valueType: first,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodRecord,
            ...$f956ec92c1beba23$var$processCreateParams(second)
        });
    }
}
class $f956ec92c1beba23$export$163b6a2b712d9542 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    get keySchema() {
        return this._def.keyType;
    }
    get valueSchema() {
        return this._def.valueType;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.map) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.map,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const keyType = this._def.keyType;
        const valueType = this._def.valueType;
        const pairs = [
            ...ctx.data.entries()
        ].map(([key, value], index)=>{
            return {
                key: keyType._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, key, ctx.path, [
                    index,
                    "key"
                ])),
                value: valueType._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, value, ctx.path, [
                    index,
                    "value"
                ]))
            };
        });
        if (ctx.common.async) {
            const finalMap = new Map();
            return Promise.resolve().then(async ()=>{
                for (const pair of pairs){
                    const key = await pair.key;
                    const value = await pair.value;
                    if (key.status === "aborted" || value.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                    if (key.status === "dirty" || value.status === "dirty") status.dirty();
                    finalMap.set(key.value, value.value);
                }
                return {
                    status: status.value,
                    value: finalMap
                };
            });
        } else {
            const finalMap = new Map();
            for (const pair of pairs){
                const key = pair.key;
                const value = pair.value;
                if (key.status === "aborted" || value.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                if (key.status === "dirty" || value.status === "dirty") status.dirty();
                finalMap.set(key.value, value.value);
            }
            return {
                status: status.value,
                value: finalMap
            };
        }
    }
}
$f956ec92c1beba23$export$163b6a2b712d9542.create = (keyType, valueType, params)=>{
    return new $f956ec92c1beba23$export$163b6a2b712d9542({
        valueType: valueType,
        keyType: keyType,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodMap,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$977057706f816712 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.set) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.set,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const def = this._def;
        if (def.minSize !== null) {
            if (ctx.data.size < def.minSize.value) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.too_small,
                    minimum: def.minSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.minSize.message
                });
                status.dirty();
            }
        }
        if (def.maxSize !== null) {
            if (ctx.data.size > def.maxSize.value) {
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.too_big,
                    maximum: def.maxSize.value,
                    type: "set",
                    inclusive: true,
                    exact: false,
                    message: def.maxSize.message
                });
                status.dirty();
            }
        }
        const valueType = this._def.valueType;
        function finalizeSet(elements) {
            const parsedSet = new Set();
            for (const element of elements){
                if (element.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                if (element.status === "dirty") status.dirty();
                parsedSet.add(element.value);
            }
            return {
                status: status.value,
                value: parsedSet
            };
        }
        const elements = [
            ...ctx.data.values()
        ].map((item, i)=>valueType._parse(new $f956ec92c1beba23$var$ParseInputLazyPath(ctx, item, ctx.path, i)));
        if (ctx.common.async) return Promise.all(elements).then((elements)=>finalizeSet(elements));
        else return finalizeSet(elements);
    }
    min(minSize, message) {
        return new $f956ec92c1beba23$export$977057706f816712({
            ...this._def,
            minSize: {
                value: minSize,
                message: $f956ec92c1beba23$var$errorUtil.toString(message)
            }
        });
    }
    max(maxSize, message) {
        return new $f956ec92c1beba23$export$977057706f816712({
            ...this._def,
            maxSize: {
                value: maxSize,
                message: $f956ec92c1beba23$var$errorUtil.toString(message)
            }
        });
    }
    size(size, message) {
        return this.min(size, message).max(size, message);
    }
    nonempty(message) {
        return this.min(1, message);
    }
}
$f956ec92c1beba23$export$977057706f816712.create = (valueType, params)=>{
    return new $f956ec92c1beba23$export$977057706f816712({
        valueType: valueType,
        minSize: null,
        maxSize: null,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodSet,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$d4602ba55673f53c extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    constructor(){
        super(...arguments);
        this.validate = this.implement;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.function) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.function,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        function makeArgsIssue(args, error) {
            return $f956ec92c1beba23$export$244a85fde9c419ed({
                data: args,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f956ec92c1beba23$export$32f27c719778d4c4(),
                    $f956ec92c1beba23$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_arguments,
                    argumentsError: error
                }
            });
        }
        function makeReturnsIssue(returns, error) {
            return $f956ec92c1beba23$export$244a85fde9c419ed({
                data: returns,
                path: ctx.path,
                errorMaps: [
                    ctx.common.contextualErrorMap,
                    ctx.schemaErrorMap,
                    $f956ec92c1beba23$export$32f27c719778d4c4(),
                    $f956ec92c1beba23$export$341b0b6e0a6f5099
                ].filter((x)=>!!x),
                issueData: {
                    code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_return_type,
                    returnTypeError: error
                }
            });
        }
        const params = {
            errorMap: ctx.common.contextualErrorMap
        };
        const fn = ctx.data;
        if (this._def.returns instanceof $f956ec92c1beba23$export$3f196b0127d6e50a) {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f956ec92c1beba23$export$c6813a8d51f77eaf(async function(...args) {
                const error = new $f956ec92c1beba23$export$f98dac4b251ab333([]);
                const parsedArgs = await me._def.args.parseAsync(args, params).catch((e)=>{
                    error.addIssue(makeArgsIssue(args, e));
                    throw error;
                });
                const result = await Reflect.apply(fn, this, parsedArgs);
                const parsedReturns = await me._def.returns._def.type.parseAsync(result, params).catch((e)=>{
                    error.addIssue(makeReturnsIssue(result, e));
                    throw error;
                });
                return parsedReturns;
            });
        } else {
            // Would love a way to avoid disabling this rule, but we need
            // an alias (using an arrow function was what caused 2651).
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const me = this;
            return $f956ec92c1beba23$export$c6813a8d51f77eaf(function(...args) {
                const parsedArgs = me._def.args.safeParse(args, params);
                if (!parsedArgs.success) throw new $f956ec92c1beba23$export$f98dac4b251ab333([
                    makeArgsIssue(args, parsedArgs.error)
                ]);
                const result = Reflect.apply(fn, this, parsedArgs.data);
                const parsedReturns = me._def.returns.safeParse(result, params);
                if (!parsedReturns.success) throw new $f956ec92c1beba23$export$f98dac4b251ab333([
                    makeReturnsIssue(result, parsedReturns.error)
                ]);
                return parsedReturns.data;
            });
        }
    }
    parameters() {
        return this._def.args;
    }
    returnType() {
        return this._def.returns;
    }
    args(...items) {
        return new $f956ec92c1beba23$export$d4602ba55673f53c({
            ...this._def,
            args: $f956ec92c1beba23$export$e2a18bb771d8e6a3.create(items).rest($f956ec92c1beba23$export$ef3b1bb1630977ae.create())
        });
    }
    returns(returnType) {
        return new $f956ec92c1beba23$export$d4602ba55673f53c({
            ...this._def,
            returns: returnType
        });
    }
    implement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    strictImplement(func) {
        const validatedFunc = this.parse(func);
        return validatedFunc;
    }
    static create(args, returns, params) {
        return new $f956ec92c1beba23$export$d4602ba55673f53c({
            args: args ? args : $f956ec92c1beba23$export$e2a18bb771d8e6a3.create([]).rest($f956ec92c1beba23$export$ef3b1bb1630977ae.create()),
            returns: returns || $f956ec92c1beba23$export$ef3b1bb1630977ae.create(),
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodFunction,
            ...$f956ec92c1beba23$var$processCreateParams(params)
        });
    }
}
class $f956ec92c1beba23$export$378d0cfce37406e6 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    get schema() {
        return this._def.getter();
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const lazySchema = this._def.getter();
        return lazySchema._parse({
            data: ctx.data,
            path: ctx.path,
            parent: ctx
        });
    }
}
$f956ec92c1beba23$export$378d0cfce37406e6.create = (getter, params)=>{
    return new $f956ec92c1beba23$export$378d0cfce37406e6({
        getter: getter,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodLazy,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$7e44096782a165d3 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        if (input.data !== this._def.value) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_literal,
                expected: this._def.value
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
    get value() {
        return this._def.value;
    }
}
$f956ec92c1beba23$export$7e44096782a165d3.create = (value, params)=>{
    return new $f956ec92c1beba23$export$7e44096782a165d3({
        value: value,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodLiteral,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
function $f956ec92c1beba23$var$createZodEnum(values, params) {
    return new $f956ec92c1beba23$export$d325d1f0e1c20179({
        values: values,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodEnum,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
}
class $f956ec92c1beba23$export$d325d1f0e1c20179 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        if (typeof input.data !== "string") {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                expected: $f956ec92c1beba23$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (this._def.values.indexOf(input.data) === -1) {
            const ctx = this._getOrReturnCtx(input);
            const expectedValues = this._def.values;
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
    get options() {
        return this._def.values;
    }
    get enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Values() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    get Enum() {
        const enumValues = {};
        for (const val of this._def.values)enumValues[val] = val;
        return enumValues;
    }
    extract(values) {
        return $f956ec92c1beba23$export$d325d1f0e1c20179.create(values);
    }
    exclude(values) {
        return $f956ec92c1beba23$export$d325d1f0e1c20179.create(this.options.filter((opt)=>!values.includes(opt)));
    }
}
$f956ec92c1beba23$export$d325d1f0e1c20179.create = $f956ec92c1beba23$var$createZodEnum;
class $f956ec92c1beba23$export$370b2e8d6d6f5c56 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const nativeEnumValues = $f956ec92c1beba23$export$7debb50ef11d5e0b.getValidEnumValues(this._def.values);
        const ctx = this._getOrReturnCtx(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.string && ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.number) {
            const expectedValues = $f956ec92c1beba23$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                expected: $f956ec92c1beba23$export$7debb50ef11d5e0b.joinValues(expectedValues),
                received: ctx.parsedType,
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        if (nativeEnumValues.indexOf(input.data) === -1) {
            const expectedValues = $f956ec92c1beba23$export$7debb50ef11d5e0b.objectValues(nativeEnumValues);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                received: ctx.data,
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_enum_value,
                options: expectedValues
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(input.data);
    }
    get enum() {
        return this._def.values;
    }
}
$f956ec92c1beba23$export$370b2e8d6d6f5c56.create = (values, params)=>{
    return new $f956ec92c1beba23$export$370b2e8d6d6f5c56({
        values: values,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNativeEnum,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$3f196b0127d6e50a extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    unwrap() {
        return this._def.type;
    }
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        if (ctx.parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.promise && ctx.common.async === false) {
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.promise,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        const promisified = ctx.parsedType === $f956ec92c1beba23$export$5716da67bfaa244d.promise ? ctx.data : Promise.resolve(ctx.data);
        return $f956ec92c1beba23$export$c6813a8d51f77eaf(promisified.then((data)=>{
            return this._def.type.parseAsync(data, {
                path: ctx.path,
                errorMap: ctx.common.contextualErrorMap
            });
        }));
    }
}
$f956ec92c1beba23$export$3f196b0127d6e50a.create = (schema, params)=>{
    return new $f956ec92c1beba23$export$3f196b0127d6e50a({
        type: schema,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodPromise,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$a60af00cc0ce2582 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    innerType() {
        return this._def.schema;
    }
    sourceType() {
        return this._def.schema._def.typeName === $f956ec92c1beba23$export$558106ce543bd011.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        const effect = this._def.effect || null;
        const checkCtx = {
            addIssue: (arg)=>{
                $f956ec92c1beba23$export$db7caee60e5d514d(ctx, arg);
                if (arg.fatal) status.abort();
                else status.dirty();
            },
            get path () {
                return ctx.path;
            }
        };
        checkCtx.addIssue = checkCtx.addIssue.bind(checkCtx);
        if (effect.type === "preprocess") {
            const processed = effect.transform(ctx.data, checkCtx);
            if (ctx.common.issues.length) return {
                status: "dirty",
                value: ctx.data
            };
            if (ctx.common.async) return Promise.resolve(processed).then((processed)=>{
                return this._def.schema._parseAsync({
                    data: processed,
                    path: ctx.path,
                    parent: ctx
                });
            });
            else return this._def.schema._parseSync({
                data: processed,
                path: ctx.path,
                parent: ctx
            });
        }
        if (effect.type === "refinement") {
            const executeRefinement = (acc)=>{
                const result = effect.refinement(acc, checkCtx);
                if (ctx.common.async) return Promise.resolve(result);
                if (result instanceof Promise) throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
                return acc;
            };
            if (ctx.common.async === false) {
                const inner = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inner.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                // return value is ignored
                executeRefinement(inner.value);
                return {
                    status: status.value,
                    value: inner.value
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((inner)=>{
                if (inner.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                if (inner.status === "dirty") status.dirty();
                return executeRefinement(inner.value).then(()=>{
                    return {
                        status: status.value,
                        value: inner.value
                    };
                });
            });
        }
        if (effect.type === "transform") {
            if (ctx.common.async === false) {
                const base = this._def.schema._parseSync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (!$f956ec92c1beba23$export$1ea939691cdc45b8(base)) return base;
                const result = effect.transform(base.value, checkCtx);
                if (result instanceof Promise) throw new Error(`Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.`);
                return {
                    status: status.value,
                    value: result
                };
            } else return this._def.schema._parseAsync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            }).then((base)=>{
                if (!$f956ec92c1beba23$export$1ea939691cdc45b8(base)) return base;
                return Promise.resolve(effect.transform(base.value, checkCtx)).then((result)=>({
                        status: status.value,
                        value: result
                    }));
            });
        }
        $f956ec92c1beba23$export$7debb50ef11d5e0b.assertNever(effect);
    }
}
$f956ec92c1beba23$export$a60af00cc0ce2582.create = (schema, effect, params)=>{
    return new $f956ec92c1beba23$export$a60af00cc0ce2582({
        schema: schema,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodEffects,
        effect: effect,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
$f956ec92c1beba23$export$a60af00cc0ce2582.createWithPreprocess = (preprocess, schema, params)=>{
    return new $f956ec92c1beba23$export$a60af00cc0ce2582({
        schema: schema,
        effect: {
            type: "preprocess",
            transform: preprocess
        },
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodEffects,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$aa56fec1e9d629b8 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f956ec92c1beba23$export$5716da67bfaa244d.undefined) return $f956ec92c1beba23$export$c6813a8d51f77eaf(undefined);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f956ec92c1beba23$export$aa56fec1e9d629b8.create = (type, params)=>{
    return new $f956ec92c1beba23$export$aa56fec1e9d629b8({
        innerType: type,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodOptional,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$aaac0b8b429cef5 extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType === $f956ec92c1beba23$export$5716da67bfaa244d.null) return $f956ec92c1beba23$export$c6813a8d51f77eaf(null);
        return this._def.innerType._parse(input);
    }
    unwrap() {
        return this._def.innerType;
    }
}
$f956ec92c1beba23$export$aaac0b8b429cef5.create = (type, params)=>{
    return new $f956ec92c1beba23$export$aaac0b8b429cef5({
        innerType: type,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNullable,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$bb19b37874861e7e extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        let data = ctx.data;
        if (ctx.parsedType === $f956ec92c1beba23$export$5716da67bfaa244d.undefined) data = this._def.defaultValue();
        return this._def.innerType._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    removeDefault() {
        return this._def.innerType;
    }
}
$f956ec92c1beba23$export$bb19b37874861e7e.create = (type, params)=>{
    return new $f956ec92c1beba23$export$bb19b37874861e7e({
        innerType: type,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodDefault,
        defaultValue: typeof params.default === "function" ? params.default : ()=>params.default,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$75a44ec6249ac76b extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        // newCtx is used to not collect issues from inner types in ctx
        const newCtx = {
            ...ctx,
            common: {
                ...ctx.common,
                issues: []
            }
        };
        const result = this._def.innerType._parse({
            data: newCtx.data,
            path: newCtx.path,
            parent: {
                ...newCtx
            }
        });
        if ($f956ec92c1beba23$export$aefee5ebe1dcfd9e(result)) return result.then((result)=>{
            return {
                status: "valid",
                value: result.status === "valid" ? result.value : this._def.catchValue({
                    get error () {
                        return new $f956ec92c1beba23$export$f98dac4b251ab333(newCtx.common.issues);
                    },
                    input: newCtx.data
                })
            };
        });
        else return {
            status: "valid",
            value: result.status === "valid" ? result.value : this._def.catchValue({
                get error () {
                    return new $f956ec92c1beba23$export$f98dac4b251ab333(newCtx.common.issues);
                },
                input: newCtx.data
            })
        };
    }
    removeCatch() {
        return this._def.innerType;
    }
}
$f956ec92c1beba23$export$75a44ec6249ac76b.create = (type, params)=>{
    return new $f956ec92c1beba23$export$75a44ec6249ac76b({
        innerType: type,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodCatch,
        catchValue: typeof params.catch === "function" ? params.catch : ()=>params.catch,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
class $f956ec92c1beba23$export$26ccfa0145e8511f extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const parsedType = this._getType(input);
        if (parsedType !== $f956ec92c1beba23$export$5716da67bfaa244d.nan) {
            const ctx = this._getOrReturnCtx(input);
            $f956ec92c1beba23$export$db7caee60e5d514d(ctx, {
                code: $f956ec92c1beba23$export$5ba560653e4a1035.invalid_type,
                expected: $f956ec92c1beba23$export$5716da67bfaa244d.nan,
                received: ctx.parsedType
            });
            return $f956ec92c1beba23$export$9a105a556e65c2c0;
        }
        return {
            status: "valid",
            value: input.data
        };
    }
}
$f956ec92c1beba23$export$26ccfa0145e8511f.create = (params)=>{
    return new $f956ec92c1beba23$export$26ccfa0145e8511f({
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodNaN,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
const $f956ec92c1beba23$export$cf2deea74cde46b4 = Symbol("zod_brand");
class $f956ec92c1beba23$export$66b0c798a395271f extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { ctx: ctx } = this._processInputParams(input);
        const data = ctx.data;
        return this._def.type._parse({
            data: data,
            path: ctx.path,
            parent: ctx
        });
    }
    unwrap() {
        return this._def.type;
    }
}
class $f956ec92c1beba23$export$a3c3ef8a0e95c6da extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const { status: status, ctx: ctx } = this._processInputParams(input);
        if (ctx.common.async) {
            const handleAsync = async ()=>{
                const inResult = await this._def.in._parseAsync({
                    data: ctx.data,
                    path: ctx.path,
                    parent: ctx
                });
                if (inResult.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
                if (inResult.status === "dirty") {
                    status.dirty();
                    return $f956ec92c1beba23$export$325a211da9693fcf(inResult.value);
                } else return this._def.out._parseAsync({
                    data: inResult.value,
                    path: ctx.path,
                    parent: ctx
                });
            };
            return handleAsync();
        } else {
            const inResult = this._def.in._parseSync({
                data: ctx.data,
                path: ctx.path,
                parent: ctx
            });
            if (inResult.status === "aborted") return $f956ec92c1beba23$export$9a105a556e65c2c0;
            if (inResult.status === "dirty") {
                status.dirty();
                return {
                    status: "dirty",
                    value: inResult.value
                };
            } else return this._def.out._parseSync({
                data: inResult.value,
                path: ctx.path,
                parent: ctx
            });
        }
    }
    static create(a, b) {
        return new $f956ec92c1beba23$export$a3c3ef8a0e95c6da({
            in: a,
            out: b,
            typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodPipeline
        });
    }
}
class $f956ec92c1beba23$export$5d1f7ef05c4e493a extends $f956ec92c1beba23$export$19342e026b58ebb7 {
    _parse(input) {
        const result = this._def.innerType._parse(input);
        if ($f956ec92c1beba23$export$1ea939691cdc45b8(result)) result.value = Object.freeze(result.value);
        return result;
    }
}
$f956ec92c1beba23$export$5d1f7ef05c4e493a.create = (type, params)=>{
    return new $f956ec92c1beba23$export$5d1f7ef05c4e493a({
        innerType: type,
        typeName: $f956ec92c1beba23$export$558106ce543bd011.ZodReadonly,
        ...$f956ec92c1beba23$var$processCreateParams(params)
    });
};
const $f956ec92c1beba23$export$4c00f665f0d4b443 = (check, params = {}, /**
 * @deprecated
 *
 * Pass `fatal` into the params object instead:
 *
 * ```ts
 * z.string().custom((val) => val.length > 5, { fatal: false })
 * ```
 *
 */ fatal)=>{
    if (check) return $f956ec92c1beba23$export$b9d1edb536b4e4eb.create().superRefine((data, ctx)=>{
        var _a, _b;
        if (!check(data)) {
            const p = typeof params === "function" ? params(data) : typeof params === "string" ? {
                message: params
            } : params;
            const _fatal = (_b = (_a = p.fatal) !== null && _a !== void 0 ? _a : fatal) !== null && _b !== void 0 ? _b : true;
            const p2 = typeof p === "string" ? {
                message: p
            } : p;
            ctx.addIssue({
                code: "custom",
                ...p2,
                fatal: _fatal
            });
        }
    });
    return $f956ec92c1beba23$export$b9d1edb536b4e4eb.create();
};
const $f956ec92c1beba23$export$1ee8ee30835eab8b = {
    object: $f956ec92c1beba23$export$736315c5b55efbad.lazycreate
};
var $f956ec92c1beba23$export$558106ce543bd011;
(function(ZodFirstPartyTypeKind) {
    ZodFirstPartyTypeKind["ZodString"] = "ZodString";
    ZodFirstPartyTypeKind["ZodNumber"] = "ZodNumber";
    ZodFirstPartyTypeKind["ZodNaN"] = "ZodNaN";
    ZodFirstPartyTypeKind["ZodBigInt"] = "ZodBigInt";
    ZodFirstPartyTypeKind["ZodBoolean"] = "ZodBoolean";
    ZodFirstPartyTypeKind["ZodDate"] = "ZodDate";
    ZodFirstPartyTypeKind["ZodSymbol"] = "ZodSymbol";
    ZodFirstPartyTypeKind["ZodUndefined"] = "ZodUndefined";
    ZodFirstPartyTypeKind["ZodNull"] = "ZodNull";
    ZodFirstPartyTypeKind["ZodAny"] = "ZodAny";
    ZodFirstPartyTypeKind["ZodUnknown"] = "ZodUnknown";
    ZodFirstPartyTypeKind["ZodNever"] = "ZodNever";
    ZodFirstPartyTypeKind["ZodVoid"] = "ZodVoid";
    ZodFirstPartyTypeKind["ZodArray"] = "ZodArray";
    ZodFirstPartyTypeKind["ZodObject"] = "ZodObject";
    ZodFirstPartyTypeKind["ZodUnion"] = "ZodUnion";
    ZodFirstPartyTypeKind["ZodDiscriminatedUnion"] = "ZodDiscriminatedUnion";
    ZodFirstPartyTypeKind["ZodIntersection"] = "ZodIntersection";
    ZodFirstPartyTypeKind["ZodTuple"] = "ZodTuple";
    ZodFirstPartyTypeKind["ZodRecord"] = "ZodRecord";
    ZodFirstPartyTypeKind["ZodMap"] = "ZodMap";
    ZodFirstPartyTypeKind["ZodSet"] = "ZodSet";
    ZodFirstPartyTypeKind["ZodFunction"] = "ZodFunction";
    ZodFirstPartyTypeKind["ZodLazy"] = "ZodLazy";
    ZodFirstPartyTypeKind["ZodLiteral"] = "ZodLiteral";
    ZodFirstPartyTypeKind["ZodEnum"] = "ZodEnum";
    ZodFirstPartyTypeKind["ZodEffects"] = "ZodEffects";
    ZodFirstPartyTypeKind["ZodNativeEnum"] = "ZodNativeEnum";
    ZodFirstPartyTypeKind["ZodOptional"] = "ZodOptional";
    ZodFirstPartyTypeKind["ZodNullable"] = "ZodNullable";
    ZodFirstPartyTypeKind["ZodDefault"] = "ZodDefault";
    ZodFirstPartyTypeKind["ZodCatch"] = "ZodCatch";
    ZodFirstPartyTypeKind["ZodPromise"] = "ZodPromise";
    ZodFirstPartyTypeKind["ZodBranded"] = "ZodBranded";
    ZodFirstPartyTypeKind["ZodPipeline"] = "ZodPipeline";
    ZodFirstPartyTypeKind["ZodReadonly"] = "ZodReadonly";
})($f956ec92c1beba23$export$558106ce543bd011 || ($f956ec92c1beba23$export$558106ce543bd011 = {}));
const $f956ec92c1beba23$export$3d916e7c22dbd8b5 = (// const instanceOfType = <T extends new (...args: any[]) => any>(
cls, params = {
    message: `Input not instance of ${cls.name}`
})=>$f956ec92c1beba23$export$4c00f665f0d4b443((data)=>data instanceof cls, params);
const $f956ec92c1beba23$export$22b082955e083ec3 = $f956ec92c1beba23$export$1230eb29b8d3b502.create;
const $f956ec92c1beba23$export$98e628dec113755e = $f956ec92c1beba23$export$5b070a55c0c43e09.create;
const $f956ec92c1beba23$export$9e06de0973666692 = $f956ec92c1beba23$export$26ccfa0145e8511f.create;
const $f956ec92c1beba23$export$a0f65b52274bcc00 = $f956ec92c1beba23$export$67d741fd70ff98f4.create;
const $f956ec92c1beba23$export$4a21f16c33752377 = $f956ec92c1beba23$export$723d146f80596191.create;
const $f956ec92c1beba23$export$324d90190a8b822a = $f956ec92c1beba23$export$e974be33bdc55521.create;
const $f956ec92c1beba23$export$8f701197936bc2a6 = $f956ec92c1beba23$export$bcc3b40f6b638044.create;
const $f956ec92c1beba23$export$1db45310990710a5 = $f956ec92c1beba23$export$4e780e961c30340d.create;
const $f956ec92c1beba23$export$7b1b591b262c240 = $f956ec92c1beba23$export$a96281f914484f2d.create;
const $f956ec92c1beba23$export$4154a199d7d90455 = $f956ec92c1beba23$export$b9d1edb536b4e4eb.create;
const $f956ec92c1beba23$export$19282c40b967aec6 = $f956ec92c1beba23$export$ef3b1bb1630977ae.create;
const $f956ec92c1beba23$export$b3e22bcfd64c1022 = $f956ec92c1beba23$export$1e576a20c3ce9fb5.create;
const $f956ec92c1beba23$export$490e536ee7389aeb = $f956ec92c1beba23$export$7d39f5df85f21031.create;
const $f956ec92c1beba23$export$2f23118c22fb2630 = $f956ec92c1beba23$export$7acfc3e64785411.create;
const $f956ec92c1beba23$export$be5493f9613cbbe = $f956ec92c1beba23$export$736315c5b55efbad.create;
const $f956ec92c1beba23$export$8fb0df5f40d0b477 = $f956ec92c1beba23$export$736315c5b55efbad.strictCreate;
const $f956ec92c1beba23$export$971dd5b0dfd021b6 = $f956ec92c1beba23$export$a8b236cb5070a311.create;
const $f956ec92c1beba23$export$4b888e40c4ee26dd = $f956ec92c1beba23$export$5ef2424805ac76a3.create;
const $f956ec92c1beba23$export$bc86dfbf7795668c = $f956ec92c1beba23$export$c02deaf0bb5203d4.create;
const $f956ec92c1beba23$export$65e3907585753458 = $f956ec92c1beba23$export$e2a18bb771d8e6a3.create;
const $f956ec92c1beba23$export$e5185e241753e543 = $f956ec92c1beba23$export$a2acc09968cb4b7f.create;
const $f956ec92c1beba23$export$871de8747c9eaa88 = $f956ec92c1beba23$export$163b6a2b712d9542.create;
const $f956ec92c1beba23$export$adaa4cf7ef1b65be = $f956ec92c1beba23$export$977057706f816712.create;
const $f956ec92c1beba23$export$44e51c8aac7c2deb = $f956ec92c1beba23$export$d4602ba55673f53c.create;
const $f956ec92c1beba23$export$488013bae63b21da = $f956ec92c1beba23$export$378d0cfce37406e6.create;
const $f956ec92c1beba23$export$c8ec6e1ec9fefcb0 = $f956ec92c1beba23$export$7e44096782a165d3.create;
const $f956ec92c1beba23$export$78a99c8d44d72635 = $f956ec92c1beba23$export$d325d1f0e1c20179.create;
const $f956ec92c1beba23$export$6fe7eca19ebe5199 = $f956ec92c1beba23$export$370b2e8d6d6f5c56.create;
const $f956ec92c1beba23$export$c957ef27a0ebfd4 = $f956ec92c1beba23$export$3f196b0127d6e50a.create;
const $f956ec92c1beba23$export$dc573d8a6576cdb3 = $f956ec92c1beba23$export$a60af00cc0ce2582.create;
const $f956ec92c1beba23$export$516e28dec6a4b6d4 = $f956ec92c1beba23$export$aa56fec1e9d629b8.create;
const $f956ec92c1beba23$export$133fc36489ac9add = $f956ec92c1beba23$export$aaac0b8b429cef5.create;
const $f956ec92c1beba23$export$fc37fe19dfda43ee = $f956ec92c1beba23$export$a60af00cc0ce2582.createWithPreprocess;
const $f956ec92c1beba23$export$43f28b24e1eb8181 = $f956ec92c1beba23$export$a3c3ef8a0e95c6da.create;
const $f956ec92c1beba23$export$3b3d07727c5b702c = ()=>$f956ec92c1beba23$export$22b082955e083ec3().optional();
const $f956ec92c1beba23$export$eb150471a61fced6 = ()=>$f956ec92c1beba23$export$98e628dec113755e().optional();
const $f956ec92c1beba23$export$269251733cdcbbf1 = ()=>$f956ec92c1beba23$export$4a21f16c33752377().optional();
const $f956ec92c1beba23$export$8c14e57e778d3873 = {
    string: (arg)=>$f956ec92c1beba23$export$1230eb29b8d3b502.create({
            ...arg,
            coerce: true
        }),
    number: (arg)=>$f956ec92c1beba23$export$5b070a55c0c43e09.create({
            ...arg,
            coerce: true
        }),
    boolean: (arg)=>$f956ec92c1beba23$export$723d146f80596191.create({
            ...arg,
            coerce: true
        }),
    bigint: (arg)=>$f956ec92c1beba23$export$67d741fd70ff98f4.create({
            ...arg,
            coerce: true
        }),
    date: (arg)=>$f956ec92c1beba23$export$e974be33bdc55521.create({
            ...arg,
            coerce: true
        })
};
const $f956ec92c1beba23$export$96c94437c95d7862 = $f956ec92c1beba23$export$9a105a556e65c2c0;
var $f956ec92c1beba23$export$2e2bcd8739ae039 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    defaultErrorMap: $f956ec92c1beba23$export$341b0b6e0a6f5099,
    setErrorMap: $f956ec92c1beba23$export$1097a8289cfd22d7,
    getErrorMap: $f956ec92c1beba23$export$32f27c719778d4c4,
    makeIssue: $f956ec92c1beba23$export$244a85fde9c419ed,
    EMPTY_PATH: $f956ec92c1beba23$export$1526d2e05f74572,
    addIssueToContext: $f956ec92c1beba23$export$db7caee60e5d514d,
    ParseStatus: $f956ec92c1beba23$export$5b20a5c3d05c1f6f,
    INVALID: $f956ec92c1beba23$export$9a105a556e65c2c0,
    DIRTY: $f956ec92c1beba23$export$325a211da9693fcf,
    OK: $f956ec92c1beba23$export$c6813a8d51f77eaf,
    isAborted: $f956ec92c1beba23$export$afa861e3c5730743,
    isDirty: $f956ec92c1beba23$export$910b6cdd390341b3,
    isValid: $f956ec92c1beba23$export$1ea939691cdc45b8,
    isAsync: $f956ec92c1beba23$export$aefee5ebe1dcfd9e,
    get util () {
        return $f956ec92c1beba23$export$7debb50ef11d5e0b;
    },
    get objectUtil () {
        return $f956ec92c1beba23$export$4aa2142c225fd5c7;
    },
    ZodParsedType: $f956ec92c1beba23$export$5716da67bfaa244d,
    getParsedType: $f956ec92c1beba23$export$3e9057828ebd5c7a,
    ZodType: $f956ec92c1beba23$export$19342e026b58ebb7,
    ZodString: $f956ec92c1beba23$export$1230eb29b8d3b502,
    ZodNumber: $f956ec92c1beba23$export$5b070a55c0c43e09,
    ZodBigInt: $f956ec92c1beba23$export$67d741fd70ff98f4,
    ZodBoolean: $f956ec92c1beba23$export$723d146f80596191,
    ZodDate: $f956ec92c1beba23$export$e974be33bdc55521,
    ZodSymbol: $f956ec92c1beba23$export$bcc3b40f6b638044,
    ZodUndefined: $f956ec92c1beba23$export$4e780e961c30340d,
    ZodNull: $f956ec92c1beba23$export$a96281f914484f2d,
    ZodAny: $f956ec92c1beba23$export$b9d1edb536b4e4eb,
    ZodUnknown: $f956ec92c1beba23$export$ef3b1bb1630977ae,
    ZodNever: $f956ec92c1beba23$export$1e576a20c3ce9fb5,
    ZodVoid: $f956ec92c1beba23$export$7d39f5df85f21031,
    ZodArray: $f956ec92c1beba23$export$7acfc3e64785411,
    ZodObject: $f956ec92c1beba23$export$736315c5b55efbad,
    ZodUnion: $f956ec92c1beba23$export$a8b236cb5070a311,
    ZodDiscriminatedUnion: $f956ec92c1beba23$export$5ef2424805ac76a3,
    ZodIntersection: $f956ec92c1beba23$export$c02deaf0bb5203d4,
    ZodTuple: $f956ec92c1beba23$export$e2a18bb771d8e6a3,
    ZodRecord: $f956ec92c1beba23$export$a2acc09968cb4b7f,
    ZodMap: $f956ec92c1beba23$export$163b6a2b712d9542,
    ZodSet: $f956ec92c1beba23$export$977057706f816712,
    ZodFunction: $f956ec92c1beba23$export$d4602ba55673f53c,
    ZodLazy: $f956ec92c1beba23$export$378d0cfce37406e6,
    ZodLiteral: $f956ec92c1beba23$export$7e44096782a165d3,
    ZodEnum: $f956ec92c1beba23$export$d325d1f0e1c20179,
    ZodNativeEnum: $f956ec92c1beba23$export$370b2e8d6d6f5c56,
    ZodPromise: $f956ec92c1beba23$export$3f196b0127d6e50a,
    ZodEffects: $f956ec92c1beba23$export$a60af00cc0ce2582,
    ZodTransformer: $f956ec92c1beba23$export$a60af00cc0ce2582,
    ZodOptional: $f956ec92c1beba23$export$aa56fec1e9d629b8,
    ZodNullable: $f956ec92c1beba23$export$aaac0b8b429cef5,
    ZodDefault: $f956ec92c1beba23$export$bb19b37874861e7e,
    ZodCatch: $f956ec92c1beba23$export$75a44ec6249ac76b,
    ZodNaN: $f956ec92c1beba23$export$26ccfa0145e8511f,
    BRAND: $f956ec92c1beba23$export$cf2deea74cde46b4,
    ZodBranded: $f956ec92c1beba23$export$66b0c798a395271f,
    ZodPipeline: $f956ec92c1beba23$export$a3c3ef8a0e95c6da,
    ZodReadonly: $f956ec92c1beba23$export$5d1f7ef05c4e493a,
    custom: $f956ec92c1beba23$export$4c00f665f0d4b443,
    Schema: $f956ec92c1beba23$export$19342e026b58ebb7,
    ZodSchema: $f956ec92c1beba23$export$19342e026b58ebb7,
    late: $f956ec92c1beba23$export$1ee8ee30835eab8b,
    get ZodFirstPartyTypeKind () {
        return $f956ec92c1beba23$export$558106ce543bd011;
    },
    coerce: $f956ec92c1beba23$export$8c14e57e778d3873,
    any: $f956ec92c1beba23$export$4154a199d7d90455,
    array: $f956ec92c1beba23$export$2f23118c22fb2630,
    bigint: $f956ec92c1beba23$export$a0f65b52274bcc00,
    boolean: $f956ec92c1beba23$export$4a21f16c33752377,
    date: $f956ec92c1beba23$export$324d90190a8b822a,
    discriminatedUnion: $f956ec92c1beba23$export$4b888e40c4ee26dd,
    effect: $f956ec92c1beba23$export$dc573d8a6576cdb3,
    "enum": $f956ec92c1beba23$export$78a99c8d44d72635,
    "function": $f956ec92c1beba23$export$44e51c8aac7c2deb,
    "instanceof": $f956ec92c1beba23$export$3d916e7c22dbd8b5,
    intersection: $f956ec92c1beba23$export$bc86dfbf7795668c,
    lazy: $f956ec92c1beba23$export$488013bae63b21da,
    literal: $f956ec92c1beba23$export$c8ec6e1ec9fefcb0,
    map: $f956ec92c1beba23$export$871de8747c9eaa88,
    nan: $f956ec92c1beba23$export$9e06de0973666692,
    nativeEnum: $f956ec92c1beba23$export$6fe7eca19ebe5199,
    never: $f956ec92c1beba23$export$b3e22bcfd64c1022,
    "null": $f956ec92c1beba23$export$7b1b591b262c240,
    nullable: $f956ec92c1beba23$export$133fc36489ac9add,
    number: $f956ec92c1beba23$export$98e628dec113755e,
    object: $f956ec92c1beba23$export$be5493f9613cbbe,
    oboolean: $f956ec92c1beba23$export$269251733cdcbbf1,
    onumber: $f956ec92c1beba23$export$eb150471a61fced6,
    optional: $f956ec92c1beba23$export$516e28dec6a4b6d4,
    ostring: $f956ec92c1beba23$export$3b3d07727c5b702c,
    pipeline: $f956ec92c1beba23$export$43f28b24e1eb8181,
    preprocess: $f956ec92c1beba23$export$fc37fe19dfda43ee,
    promise: $f956ec92c1beba23$export$c957ef27a0ebfd4,
    record: $f956ec92c1beba23$export$e5185e241753e543,
    set: $f956ec92c1beba23$export$adaa4cf7ef1b65be,
    strictObject: $f956ec92c1beba23$export$8fb0df5f40d0b477,
    string: $f956ec92c1beba23$export$22b082955e083ec3,
    symbol: $f956ec92c1beba23$export$8f701197936bc2a6,
    transformer: $f956ec92c1beba23$export$dc573d8a6576cdb3,
    tuple: $f956ec92c1beba23$export$65e3907585753458,
    "undefined": $f956ec92c1beba23$export$1db45310990710a5,
    union: $f956ec92c1beba23$export$971dd5b0dfd021b6,
    unknown: $f956ec92c1beba23$export$19282c40b967aec6,
    "void": $f956ec92c1beba23$export$490e536ee7389aeb,
    NEVER: $f956ec92c1beba23$export$96c94437c95d7862,
    ZodIssueCode: $f956ec92c1beba23$export$5ba560653e4a1035,
    quotelessJson: $f956ec92c1beba23$export$913eddeaf297cfea,
    ZodError: $f956ec92c1beba23$export$f98dac4b251ab333
});

});

parcelRequire.register("horhC", function(module, exports) {

$parcel$export(module.exports, "resolveValue", function () { return $ca99d77237f429ee$export$d812c8e1906863d0; });
$parcel$export(module.exports, "toast", function () { return $ca99d77237f429ee$export$b410431fab84fa58; });
$parcel$export(module.exports, "Toaster", function () { return $ca99d77237f429ee$export$fb98e3a2a4cd92d7; });

var $eCoWV = parcelRequire("eCoWV");

var $epf33 = parcelRequire("epf33");
function $ca99d77237f429ee$var$_extends() {
    $ca99d77237f429ee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ca99d77237f429ee$var$_extends.apply(this, arguments);
}
function $ca99d77237f429ee$var$_taggedTemplateLiteralLoose(strings, raw) {
    if (!raw) raw = strings.slice(0);
    strings.raw = raw;
    return strings;
}
var $ca99d77237f429ee$var$isFunction = function isFunction(valOrFunction) {
    return typeof valOrFunction === "function";
};
var $ca99d77237f429ee$export$d812c8e1906863d0 = function resolveValue(valOrFunction, arg) {
    return $ca99d77237f429ee$var$isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};
var $ca99d77237f429ee$var$genId = /*#__PURE__*/ function() {
    var count = 0;
    return function() {
        return (++count).toString();
    };
}();
var $ca99d77237f429ee$var$createRectRef = function createRectRef(onRect) {
    return function(el) {
        if (el) setTimeout(function() {
            var boundingRect = el.getBoundingClientRect();
            onRect(boundingRect);
        });
    };
};
var $ca99d77237f429ee$var$prefersReducedMotion = /*#__PURE__*/ function() {
    // Cache result
    var shouldReduceMotion = undefined;
    return function() {
        if (shouldReduceMotion === undefined && typeof window !== "undefined") {
            var mediaQuery = matchMedia("(prefers-reduced-motion: reduce)");
            shouldReduceMotion = !mediaQuery || mediaQuery.matches;
        }
        return shouldReduceMotion;
    };
}();
var $ca99d77237f429ee$var$TOAST_LIMIT = 20;
var $ca99d77237f429ee$var$ActionType;
(function(ActionType) {
    ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
    ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
    ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
    ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
    ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
    ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
    ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})($ca99d77237f429ee$var$ActionType || ($ca99d77237f429ee$var$ActionType = {}));
var $ca99d77237f429ee$var$toastTimeouts = /*#__PURE__*/ new Map();
var $ca99d77237f429ee$var$addToRemoveQueue = function addToRemoveQueue(toastId) {
    if ($ca99d77237f429ee$var$toastTimeouts.has(toastId)) return;
    var timeout = setTimeout(function() {
        $ca99d77237f429ee$var$toastTimeouts["delete"](toastId);
        $ca99d77237f429ee$var$dispatch({
            type: $ca99d77237f429ee$var$ActionType.REMOVE_TOAST,
            toastId: toastId
        });
    }, 1000);
    $ca99d77237f429ee$var$toastTimeouts.set(toastId, timeout);
};
var $ca99d77237f429ee$var$clearFromRemoveQueue = function clearFromRemoveQueue(toastId) {
    var timeout = $ca99d77237f429ee$var$toastTimeouts.get(toastId);
    if (timeout) clearTimeout(timeout);
};
var $ca99d77237f429ee$var$reducer = function reducer(state, action) {
    switch(action.type){
        case $ca99d77237f429ee$var$ActionType.ADD_TOAST:
            return $ca99d77237f429ee$var$_extends({}, state, {
                toasts: [
                    action.toast
                ].concat(state.toasts).slice(0, $ca99d77237f429ee$var$TOAST_LIMIT)
            });
        case $ca99d77237f429ee$var$ActionType.UPDATE_TOAST:
            //  ! Side effects !
            if (action.toast.id) $ca99d77237f429ee$var$clearFromRemoveQueue(action.toast.id);
            return $ca99d77237f429ee$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === action.toast.id ? $ca99d77237f429ee$var$_extends({}, t, action.toast) : t;
                })
            });
        case $ca99d77237f429ee$var$ActionType.UPSERT_TOAST:
            var toast = action.toast;
            return state.toasts.find(function(t) {
                return t.id === toast.id;
            }) ? reducer(state, {
                type: $ca99d77237f429ee$var$ActionType.UPDATE_TOAST,
                toast: toast
            }) : reducer(state, {
                type: $ca99d77237f429ee$var$ActionType.ADD_TOAST,
                toast: toast
            });
        case $ca99d77237f429ee$var$ActionType.DISMISS_TOAST:
            var toastId = action.toastId; // ! Side effects ! - This could be execrated into a dismissToast() action, but I'll keep it here for simplicity
            if (toastId) $ca99d77237f429ee$var$addToRemoveQueue(toastId);
            else state.toasts.forEach(function(toast) {
                $ca99d77237f429ee$var$addToRemoveQueue(toast.id);
            });
            return $ca99d77237f429ee$var$_extends({}, state, {
                toasts: state.toasts.map(function(t) {
                    return t.id === toastId || toastId === undefined ? $ca99d77237f429ee$var$_extends({}, t, {
                        visible: false
                    }) : t;
                })
            });
        case $ca99d77237f429ee$var$ActionType.REMOVE_TOAST:
            if (action.toastId === undefined) return $ca99d77237f429ee$var$_extends({}, state, {
                toasts: []
            });
            return $ca99d77237f429ee$var$_extends({}, state, {
                toasts: state.toasts.filter(function(t) {
                    return t.id !== action.toastId;
                })
            });
        case $ca99d77237f429ee$var$ActionType.START_PAUSE:
            return $ca99d77237f429ee$var$_extends({}, state, {
                pausedAt: action.time
            });
        case $ca99d77237f429ee$var$ActionType.END_PAUSE:
            var diff = action.time - (state.pausedAt || 0);
            return $ca99d77237f429ee$var$_extends({}, state, {
                pausedAt: undefined,
                toasts: state.toasts.map(function(t) {
                    return $ca99d77237f429ee$var$_extends({}, t, {
                        pauseDuration: t.pauseDuration + diff
                    });
                })
            });
    }
};
var $ca99d77237f429ee$var$listeners = [];
var $ca99d77237f429ee$var$memoryState = {
    toasts: [],
    pausedAt: undefined
};
var $ca99d77237f429ee$var$dispatch = function dispatch(action) {
    $ca99d77237f429ee$var$memoryState = $ca99d77237f429ee$var$reducer($ca99d77237f429ee$var$memoryState, action);
    $ca99d77237f429ee$var$listeners.forEach(function(listener) {
        listener($ca99d77237f429ee$var$memoryState);
    });
};
var $ca99d77237f429ee$var$defaultTimeouts = {
    blank: 4000,
    error: 4000,
    success: 2000,
    loading: Infinity,
    custom: 4000
};
var $ca99d77237f429ee$export$3960353ab538dc47 = function useStore(toastOptions) {
    if (toastOptions === void 0) toastOptions = {};
    var _useState = (0, $eCoWV.useState)($ca99d77237f429ee$var$memoryState), state = _useState[0], setState = _useState[1];
    (0, $eCoWV.useEffect)(function() {
        $ca99d77237f429ee$var$listeners.push(setState);
        return function() {
            var index = $ca99d77237f429ee$var$listeners.indexOf(setState);
            if (index > -1) $ca99d77237f429ee$var$listeners.splice(index, 1);
        };
    }, [
        state
    ]);
    var mergedToasts = state.toasts.map(function(t) {
        var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;
        return $ca99d77237f429ee$var$_extends({}, toastOptions, toastOptions[t.type], t, {
            duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || $ca99d77237f429ee$var$defaultTimeouts[t.type],
            style: $ca99d77237f429ee$var$_extends({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
        });
    });
    return $ca99d77237f429ee$var$_extends({}, state, {
        toasts: mergedToasts
    });
};
var $ca99d77237f429ee$var$createToast = function createToast(message, type, opts) {
    if (type === void 0) type = "blank";
    return $ca99d77237f429ee$var$_extends({
        createdAt: Date.now(),
        visible: true,
        type: type,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: message,
        pauseDuration: 0
    }, opts, {
        id: (opts == null ? void 0 : opts.id) || $ca99d77237f429ee$var$genId()
    });
};
var $ca99d77237f429ee$var$createHandler = function createHandler(type) {
    return function(message, options) {
        var toast = $ca99d77237f429ee$var$createToast(message, type, options);
        $ca99d77237f429ee$var$dispatch({
            type: $ca99d77237f429ee$var$ActionType.UPSERT_TOAST,
            toast: toast
        });
        return toast.id;
    };
};
var $ca99d77237f429ee$export$b410431fab84fa58 = function toast(message, opts) {
    return $ca99d77237f429ee$var$createHandler("blank")(message, opts);
};
$ca99d77237f429ee$export$b410431fab84fa58.error = /*#__PURE__*/ $ca99d77237f429ee$var$createHandler("error");
$ca99d77237f429ee$export$b410431fab84fa58.success = /*#__PURE__*/ $ca99d77237f429ee$var$createHandler("success");
$ca99d77237f429ee$export$b410431fab84fa58.loading = /*#__PURE__*/ $ca99d77237f429ee$var$createHandler("loading");
$ca99d77237f429ee$export$b410431fab84fa58.custom = /*#__PURE__*/ $ca99d77237f429ee$var$createHandler("custom");
$ca99d77237f429ee$export$b410431fab84fa58.dismiss = function(toastId) {
    $ca99d77237f429ee$var$dispatch({
        type: $ca99d77237f429ee$var$ActionType.DISMISS_TOAST,
        toastId: toastId
    });
};
$ca99d77237f429ee$export$b410431fab84fa58.remove = function(toastId) {
    return $ca99d77237f429ee$var$dispatch({
        type: $ca99d77237f429ee$var$ActionType.REMOVE_TOAST,
        toastId: toastId
    });
};
$ca99d77237f429ee$export$b410431fab84fa58.promise = function(promise, msgs, opts) {
    var id = $ca99d77237f429ee$export$b410431fab84fa58.loading(msgs.loading, $ca99d77237f429ee$var$_extends({}, opts, opts == null ? void 0 : opts.loading));
    promise.then(function(p) {
        $ca99d77237f429ee$export$b410431fab84fa58.success($ca99d77237f429ee$export$d812c8e1906863d0(msgs.success, p), $ca99d77237f429ee$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.success));
        return p;
    })["catch"](function(e) {
        $ca99d77237f429ee$export$b410431fab84fa58.error($ca99d77237f429ee$export$d812c8e1906863d0(msgs.error, e), $ca99d77237f429ee$var$_extends({
            id: id
        }, opts, opts == null ? void 0 : opts.error));
    });
    return promise;
};
var $ca99d77237f429ee$export$f46171b59bb094f9 = function useToaster(toastOptions) {
    var _useStore = $ca99d77237f429ee$export$3960353ab538dc47(toastOptions), toasts = _useStore.toasts, pausedAt = _useStore.pausedAt;
    (0, $eCoWV.useEffect)(function() {
        if (pausedAt) return;
        var now = Date.now();
        var timeouts = toasts.map(function(t) {
            if (t.duration === Infinity) return;
            var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);
            if (durationLeft < 0) {
                if (t.visible) $ca99d77237f429ee$export$b410431fab84fa58.dismiss(t.id);
                return;
            }
            return setTimeout(function() {
                return $ca99d77237f429ee$export$b410431fab84fa58.dismiss(t.id);
            }, durationLeft);
        });
        return function() {
            timeouts.forEach(function(timeout) {
                return timeout && clearTimeout(timeout);
            });
        };
    }, [
        toasts,
        pausedAt
    ]);
    var handlers = (0, $eCoWV.useMemo)(function() {
        return {
            startPause: function startPause() {
                $ca99d77237f429ee$var$dispatch({
                    type: $ca99d77237f429ee$var$ActionType.START_PAUSE,
                    time: Date.now()
                });
            },
            endPause: function endPause() {
                if (pausedAt) $ca99d77237f429ee$var$dispatch({
                    type: $ca99d77237f429ee$var$ActionType.END_PAUSE,
                    time: Date.now()
                });
            },
            updateHeight: function updateHeight(toastId, height) {
                return $ca99d77237f429ee$var$dispatch({
                    type: $ca99d77237f429ee$var$ActionType.UPDATE_TOAST,
                    toast: {
                        id: toastId,
                        height: height
                    }
                });
            },
            calculateOffset: function calculateOffset(toast, opts) {
                var _relevantToasts$filte;
                var _ref = opts || {}, _ref$reverseOrder = _ref.reverseOrder, reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder, _ref$gutter = _ref.gutter, gutter = _ref$gutter === void 0 ? 8 : _ref$gutter, defaultPosition = _ref.defaultPosition;
                var relevantToasts = toasts.filter(function(t) {
                    return (t.position || defaultPosition) === (toast.position || defaultPosition) && t.height;
                });
                var toastIndex = relevantToasts.findIndex(function(t) {
                    return t.id === toast.id;
                });
                var toastsBefore = relevantToasts.filter(function(toast, i) {
                    return i < toastIndex && toast.visible;
                }).length;
                var offset = (_relevantToasts$filte = relevantToasts.filter(function(t) {
                    return t.visible;
                })).slice.apply(_relevantToasts$filte, reverseOrder ? [
                    toastsBefore + 1
                ] : [
                    0,
                    toastsBefore
                ]).reduce(function(acc, t) {
                    return acc + (t.height || 0) + gutter;
                }, 0);
                return offset;
            }
        };
    }, [
        toasts,
        pausedAt
    ]);
    return {
        toasts: toasts,
        handlers: handlers
    };
};
function $ca99d77237f429ee$var$_templateObject4() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ",
        ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ",
        " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"
    ]);
    $ca99d77237f429ee$var$_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject3() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(90deg);\n	opacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n	opacity: 1;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject2() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(45deg);\n	opacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var $ca99d77237f429ee$var$circleAnimation = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject());
var $ca99d77237f429ee$var$firstLineAnimation = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject2());
var $ca99d77237f429ee$var$secondLineAnimation = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject3());
var $ca99d77237f429ee$export$19bc16ee58e19b3d = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject4(), function(p) {
    return p.primary || "#ff4b4b";
}, $ca99d77237f429ee$var$circleAnimation, $ca99d77237f429ee$var$firstLineAnimation, function(p) {
    return p.secondary || "#fff";
}, $ca99d77237f429ee$var$secondLineAnimation);
function $ca99d77237f429ee$var$_templateObject2$1() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ",
        ";\n  border-right-color: ",
        ";\n  animation: ",
        " 1s linear infinite;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject2$1 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject$1() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"
    ]);
    $ca99d77237f429ee$var$_templateObject$1 = function _templateObject() {
        return data;
    };
    return data;
}
var $ca99d77237f429ee$var$rotate = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject$1());
var $ca99d77237f429ee$export$647aae5028016fe9 = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject2$1(), function(p) {
    return p.secondary || "#e0e0e0";
}, function(p) {
    return p.primary || "#616161";
}, $ca99d77237f429ee$var$rotate);
function $ca99d77237f429ee$var$_templateObject3$1() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ",
        ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ",
        " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ",
        " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ",
        ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"
    ]);
    $ca99d77237f429ee$var$_templateObject3$1 = function _templateObject3() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject2$2() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n0% {\n	height: 0;\n	width: 0;\n	opacity: 0;\n}\n40% {\n  height: 0;\n	width: 6px;\n	opacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject2$2 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject$2() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0) rotate(45deg);\n	opacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n	opacity: 1;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject$2 = function _templateObject() {
        return data;
    };
    return data;
}
var $ca99d77237f429ee$var$circleAnimation$1 = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject$2());
var $ca99d77237f429ee$var$checkmarkAnimation = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject2$2());
var $ca99d77237f429ee$export$906a919e30cdbd5c = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject3$1(), function(p) {
    return p.primary || "#61d345";
}, $ca99d77237f429ee$var$circleAnimation$1, $ca99d77237f429ee$var$checkmarkAnimation, function(p) {
    return p.secondary || "#fff";
});
function $ca99d77237f429ee$var$_templateObject4$1() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ",
        " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject4$1 = function _templateObject4() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject3$2() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"
    ]);
    $ca99d77237f429ee$var$_templateObject3$2 = function _templateObject3() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject2$3() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject2$3 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject$3() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  position: absolute;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject$3 = function _templateObject() {
        return data;
    };
    return data;
}
var $ca99d77237f429ee$var$StatusWrapper = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject$3());
var $ca99d77237f429ee$var$IndicatorWrapper = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject2$3());
var $ca99d77237f429ee$var$enter = /*#__PURE__*/ (0, $epf33.keyframes)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject3$2());
var $ca99d77237f429ee$var$AnimatedIconWrapper = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject4$1(), $ca99d77237f429ee$var$enter);
var $ca99d77237f429ee$export$55554e87ff8bb60f = function ToastIcon(_ref) {
    var toast = _ref.toast;
    var icon = toast.icon, type = toast.type, iconTheme = toast.iconTheme;
    if (icon !== undefined) {
        if (typeof icon === "string") return (0, $eCoWV.createElement)($ca99d77237f429ee$var$AnimatedIconWrapper, null, icon);
        else return icon;
    }
    if (type === "blank") return null;
    return (0, $eCoWV.createElement)($ca99d77237f429ee$var$IndicatorWrapper, null, (0, $eCoWV.createElement)($ca99d77237f429ee$export$647aae5028016fe9, Object.assign({}, iconTheme)), type !== "loading" && (0, $eCoWV.createElement)($ca99d77237f429ee$var$StatusWrapper, null, type === "error" ? (0, $eCoWV.createElement)($ca99d77237f429ee$export$19bc16ee58e19b3d, Object.assign({}, iconTheme)) : (0, $eCoWV.createElement)($ca99d77237f429ee$export$906a919e30cdbd5c, Object.assign({}, iconTheme))));
};
function $ca99d77237f429ee$var$_templateObject2$4() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n  white-space: pre-line;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject2$4 = function _templateObject2() {
        return data;
    };
    return data;
}
function $ca99d77237f429ee$var$_templateObject$4() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"
    ]);
    $ca99d77237f429ee$var$_templateObject$4 = function _templateObject() {
        return data;
    };
    return data;
}
var $ca99d77237f429ee$var$enterAnimation = function enterAnimation(factor) {
    return "\n0% {transform: translate3d(0," + factor * -200 + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};
var $ca99d77237f429ee$var$exitAnimation = function exitAnimation(factor) {
    return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -150 + "%,-1px) scale(.6); opacity:0;}\n";
};
var $ca99d77237f429ee$var$fadeInAnimation = "0%{opacity:0;} 100%{opacity:1;}";
var $ca99d77237f429ee$var$fadeOutAnimation = "0%{opacity:1;} 100%{opacity:0;}";
var $ca99d77237f429ee$var$ToastBarBase = /*#__PURE__*/ (0, $epf33.styled)("div", (0, $eCoWV.forwardRef))(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject$4());
var $ca99d77237f429ee$var$Message = /*#__PURE__*/ (0, $epf33.styled)("div")(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject2$4());
var $ca99d77237f429ee$var$getAnimationStyle = function getAnimationStyle(position, visible) {
    var top = position.includes("top");
    var factor = top ? 1 : -1;
    var _ref = $ca99d77237f429ee$var$prefersReducedMotion() ? [
        $ca99d77237f429ee$var$fadeInAnimation,
        $ca99d77237f429ee$var$fadeOutAnimation
    ] : [
        $ca99d77237f429ee$var$enterAnimation(factor),
        $ca99d77237f429ee$var$exitAnimation(factor)
    ], enter = _ref[0], exit = _ref[1];
    return {
        animation: visible ? (0, $epf33.keyframes)(enter) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : (0, $epf33.keyframes)(exit) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
    };
};
var $ca99d77237f429ee$export$af68597b0c62c1df = /*#__PURE__*/ (0, $eCoWV.memo)(function(_ref2) {
    var toast = _ref2.toast, position = _ref2.position, style = _ref2.style, children = _ref2.children;
    var animationStyle = toast != null && toast.height ? $ca99d77237f429ee$var$getAnimationStyle(toast.position || position || "top-center", toast.visible) : {
        opacity: 0
    };
    var icon = (0, $eCoWV.createElement)($ca99d77237f429ee$export$55554e87ff8bb60f, {
        toast: toast
    });
    var message = (0, $eCoWV.createElement)($ca99d77237f429ee$var$Message, Object.assign({}, toast.ariaProps), $ca99d77237f429ee$export$d812c8e1906863d0(toast.message, toast));
    return (0, $eCoWV.createElement)($ca99d77237f429ee$var$ToastBarBase, {
        className: toast.className,
        style: $ca99d77237f429ee$var$_extends({}, animationStyle, style, toast.style)
    }, typeof children === "function" ? children({
        icon: icon,
        message: message
    }) : (0, $eCoWV.createElement)((0, $eCoWV.Fragment), null, icon, message));
});
function $ca99d77237f429ee$var$_templateObject$5() {
    var data = $ca99d77237f429ee$var$_taggedTemplateLiteralLoose([
        "\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"
    ]);
    $ca99d77237f429ee$var$_templateObject$5 = function _templateObject() {
        return data;
    };
    return data;
}
(0, $epf33.setup)((0, $eCoWV.createElement));
var $ca99d77237f429ee$var$getPositionStyle = function getPositionStyle(position, offset) {
    var top = position.includes("top");
    var verticalStyle = top ? {
        top: 0
    } : {
        bottom: 0
    };
    var horizontalStyle = position.includes("center") ? {
        justifyContent: "center"
    } : position.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return $ca99d77237f429ee$var$_extends({
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: $ca99d77237f429ee$var$prefersReducedMotion() ? undefined : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
    }, verticalStyle, horizontalStyle);
};
var $ca99d77237f429ee$var$activeClass = /*#__PURE__*/ (0, $epf33.css)(/*#__PURE__*/ $ca99d77237f429ee$var$_templateObject$5());
var $ca99d77237f429ee$var$DEFAULT_OFFSET = 16;
var $ca99d77237f429ee$export$fb98e3a2a4cd92d7 = function Toaster(_ref) {
    var reverseOrder = _ref.reverseOrder, _ref$position = _ref.position, position = _ref$position === void 0 ? "top-center" : _ref$position, toastOptions = _ref.toastOptions, gutter = _ref.gutter, children = _ref.children, containerStyle = _ref.containerStyle, containerClassName = _ref.containerClassName;
    var _useToaster = $ca99d77237f429ee$export$f46171b59bb094f9(toastOptions), toasts = _useToaster.toasts, handlers = _useToaster.handlers;
    return (0, $eCoWV.createElement)("div", {
        style: $ca99d77237f429ee$var$_extends({
            position: "fixed",
            zIndex: 9999,
            top: $ca99d77237f429ee$var$DEFAULT_OFFSET,
            left: $ca99d77237f429ee$var$DEFAULT_OFFSET,
            right: $ca99d77237f429ee$var$DEFAULT_OFFSET,
            bottom: $ca99d77237f429ee$var$DEFAULT_OFFSET,
            pointerEvents: "none"
        }, containerStyle),
        className: containerClassName,
        onMouseEnter: handlers.startPause,
        onMouseLeave: handlers.endPause
    }, toasts.map(function(t) {
        var toastPosition = t.position || position;
        var offset = handlers.calculateOffset(t, {
            reverseOrder: reverseOrder,
            gutter: gutter,
            defaultPosition: position
        });
        var positionStyle = $ca99d77237f429ee$var$getPositionStyle(toastPosition, offset);
        var ref = t.height ? undefined : $ca99d77237f429ee$var$createRectRef(function(rect) {
            handlers.updateHeight(t.id, rect.height);
        });
        return (0, $eCoWV.createElement)("div", {
            ref: ref,
            className: t.visible ? $ca99d77237f429ee$var$activeClass : "",
            key: t.id,
            style: positionStyle
        }, t.type === "custom" ? $ca99d77237f429ee$export$d812c8e1906863d0(t.message, t) : children ? children(t) : (0, $eCoWV.createElement)($ca99d77237f429ee$export$af68597b0c62c1df, {
            toast: t,
            position: toastPosition
        }));
    }));
};
var $ca99d77237f429ee$export$2e2bcd8739ae039 = $ca99d77237f429ee$export$b410431fab84fa58;

});
parcelRequire.register("epf33", function(module, exports) {

$parcel$export(module.exports, "css", function () { return $a7cf12bf32b8279e$export$dbf350e5966cf602; });
$parcel$export(module.exports, "keyframes", function () { return $a7cf12bf32b8279e$export$d25ddfdf17c3ad3e; });
$parcel$export(module.exports, "setup", function () { return $a7cf12bf32b8279e$export$de27182ff8187d6c; });
$parcel$export(module.exports, "styled", function () { return $a7cf12bf32b8279e$export$3817b7a54a07cec7; });
let $a7cf12bf32b8279e$var$e = {
    data: ""
}, $a7cf12bf32b8279e$var$t = (t)=>"object" == typeof window ? ((t ? t.querySelector("#_goober") : window._goober) || Object.assign((t || document.head).appendChild(document.createElement("style")), {
        innerHTML: " ",
        id: "_goober"
    })).firstChild : t || $a7cf12bf32b8279e$var$e, $a7cf12bf32b8279e$export$54aba348a7896325 = (e)=>{
    let r = $a7cf12bf32b8279e$var$t(e), l = r.data;
    return r.data = "", l;
}, $a7cf12bf32b8279e$var$l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, $a7cf12bf32b8279e$var$a = /\/\*[^]*?\*\/|\s\s+|\n/g, $a7cf12bf32b8279e$var$n = (e, t)=>{
    let r = "", l = "", a = "";
    for(let o in e){
        let s = e[o];
        "@" == o[0] ? "i" == o[1] ? r = o + " " + s + ";" : l += "f" == o[1] ? $a7cf12bf32b8279e$var$n(s, o) : o + "{" + $a7cf12bf32b8279e$var$n(s, "k" == o[1] ? "" : t) + "}" : "object" == typeof s ? l += $a7cf12bf32b8279e$var$n(s, t ? t.replace(/([^,])+/g, (e)=>o.replace(/(^:.*)|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : o) : null != s && (o = /^--/.test(o) ? o : o.replace(/[A-Z]/g, "-$&").toLowerCase(), a += $a7cf12bf32b8279e$var$n.p ? $a7cf12bf32b8279e$var$n.p(o, s) : o + ":" + s + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, $a7cf12bf32b8279e$var$o = {}, $a7cf12bf32b8279e$var$s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + $a7cf12bf32b8279e$var$s(e[r]);
        return t;
    }
    return e;
}, $a7cf12bf32b8279e$var$c = (e, t, r, c, i)=>{
    let u = $a7cf12bf32b8279e$var$s(e), p = $a7cf12bf32b8279e$var$o[u] || ($a7cf12bf32b8279e$var$o[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!$a7cf12bf32b8279e$var$o[p]) {
        let t = u !== e ? e : ((e)=>{
            let t, r = [
                {}
            ];
            for(; t = $a7cf12bf32b8279e$var$l.exec(e.replace($a7cf12bf32b8279e$var$a, ""));)t[4] ? r.shift() : t[3] ? r.unshift(r[0][t[3]] = r[0][t[3]] || {}) : r[0][t[1]] = t[2];
            return r[0];
        })(e);
        $a7cf12bf32b8279e$var$o[p] = $a7cf12bf32b8279e$var$n(i ? {
            ["@keyframes " + p]: t
        } : t, r ? "" : "." + p);
    }
    return ((e, t, r)=>{
        -1 == t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })($a7cf12bf32b8279e$var$o[p], t, c), p;
}, $a7cf12bf32b8279e$var$i = (e, t, r)=>e.reduce((e, l, a)=>{
        let o = t[a];
        if (o && o.call) {
            let e = o(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            o = t ? "." + t : e && "object" == typeof e ? e.props ? "" : $a7cf12bf32b8279e$var$n(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == o ? "" : o);
    }, "");
function $a7cf12bf32b8279e$export$dbf350e5966cf602(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return $a7cf12bf32b8279e$var$c(l.unshift ? l.raw ? $a7cf12bf32b8279e$var$i(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, $a7cf12bf32b8279e$var$t(r.target), r.g, r.o, r.k);
}
let $a7cf12bf32b8279e$var$p, $a7cf12bf32b8279e$var$d, $a7cf12bf32b8279e$var$f, $a7cf12bf32b8279e$export$442f1a04865e4790 = $a7cf12bf32b8279e$export$dbf350e5966cf602.bind({
    g: 1
}), $a7cf12bf32b8279e$export$d25ddfdf17c3ad3e = $a7cf12bf32b8279e$export$dbf350e5966cf602.bind({
    k: 1
});
function $a7cf12bf32b8279e$export$de27182ff8187d6c(e, t, r, l) {
    $a7cf12bf32b8279e$var$n.p = t, $a7cf12bf32b8279e$var$p = e, $a7cf12bf32b8279e$var$d = r, $a7cf12bf32b8279e$var$f = l;
}
function $a7cf12bf32b8279e$export$3817b7a54a07cec7(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let s = Object.assign({}, n), c = s.className || a.className;
            r.p = Object.assign({
                theme: $a7cf12bf32b8279e$var$d && $a7cf12bf32b8279e$var$d()
            }, s), r.o = / *go\d+/.test(c), s.className = $a7cf12bf32b8279e$export$dbf350e5966cf602.apply(r, l) + (c ? " " + c : ""), t && (s.ref = o);
            let i = e;
            return e[0] && (i = s.as || e, delete s.as), $a7cf12bf32b8279e$var$f && i[0] && $a7cf12bf32b8279e$var$f(s), $a7cf12bf32b8279e$var$p(i, s);
        }
        return t ? t(a) : a;
    };
}

});


parcelRequire.register("6ZMK7", function(module, exports) {
$parcel$export(module.exports, "darkModeApplicationIconMap", function () { return (parcelRequire("hWlPe")).darkModeApplicationIconMap; });
$parcel$export(module.exports, "lightModeApplicationIconMap", function () { return (parcelRequire("hWlPe")).lightModeApplicationIconMap; });
$parcel$export(module.exports, "connectorPlatformLabel", function () { return (parcelRequire("kiVDZ")).connectorPlatformLabel; });
$parcel$export(module.exports, "defaultEmailConnectorGroup", function () { return (parcelRequire("kiVDZ")).defaultEmailConnectorGroup; });
$parcel$export(module.exports, "defaultSmsConnectorGroup", function () { return (parcelRequire("kiVDZ")).defaultSmsConnectorGroup; });
$parcel$export(module.exports, "supportNativePlatformTargets", function () { return (parcelRequire("kiVDZ")).supportNativePlatformTargets; });
$parcel$export(module.exports, "auditLogEventTitle", function () { return (parcelRequire("adtV2")).auditLogEventTitle; });
$parcel$export(module.exports, "cloudApi", function () { return (parcelRequire("5Q2pm")).cloudApi; });
$parcel$export(module.exports, "meApi", function () { return (parcelRequire("5Q2pm")).meApi; });
$parcel$export(module.exports, "adminTenantEndpoint", function () { return (parcelRequire("9oLtf")).adminTenantEndpoint; });
$parcel$export(module.exports, "mainTitle", function () { return (parcelRequire("9oLtf")).mainTitle; });
$parcel$export(module.exports, "ApiResourceDetailsTabs", function () { return (parcelRequire("emGEN")).ApiResourceDetailsTabs; });
$parcel$export(module.exports, "ApplicationDetailsTabs", function () { return (parcelRequire("emGEN")).ApplicationDetailsTabs; });
$parcel$export(module.exports, "ConnectorsTabs", function () { return (parcelRequire("emGEN")).ConnectorsTabs; });
$parcel$export(module.exports, "EnterpriseSsoDetailsTabs", function () { return (parcelRequire("emGEN")).EnterpriseSsoDetailsTabs; });
$parcel$export(module.exports, "RoleDetailsTabs", function () { return (parcelRequire("emGEN")).RoleDetailsTabs; });
$parcel$export(module.exports, "TenantSettingsTabs", function () { return (parcelRequire("emGEN")).TenantSettingsTabs; });
$parcel$export(module.exports, "UserDetailsTabs", function () { return (parcelRequire("emGEN")).UserDetailsTabs; });
$parcel$export(module.exports, "WebhookDetailsTabs", function () { return (parcelRequire("emGEN")).WebhookDetailsTabs; });
$parcel$export(module.exports, "contactEmail", function () { return (parcelRequire("o53Y2")).contactEmail; });
$parcel$export(module.exports, "contactEmailLink", function () { return (parcelRequire("o53Y2")).contactEmailLink; });
$parcel$export(module.exports, "discordLink", function () { return (parcelRequire("o53Y2")).discordLink; });
$parcel$export(module.exports, "envTagsFeatureLink", function () { return (parcelRequire("o53Y2")).envTagsFeatureLink; });
$parcel$export(module.exports, "githubIssuesLink", function () { return (parcelRequire("o53Y2")).githubIssuesLink; });
$parcel$export(module.exports, "githubOrgLink", function () { return (parcelRequire("o53Y2")).githubOrgLink; });
$parcel$export(module.exports, "pricingLink", function () { return (parcelRequire("o53Y2")).pricingLink; });
$parcel$export(module.exports, "reservationLink", function () { return (parcelRequire("o53Y2")).reservationLink; });
$parcel$export(module.exports, "trustAndSecurityLink", function () { return (parcelRequire("o53Y2")).trustAndSecurityLink; });
$parcel$export(module.exports, "storageKeys", function () { return (parcelRequire("mbOAD")).storageKeys; });

$parcel$export(module.exports, "requestTimeout", function () { return $14bcc3418b46c2b0$export$363ac302bdbd807b; });
$parcel$export(module.exports, "defaultPageSize", function () { return $14bcc3418b46c2b0$export$d515e179bb47bd84; });
$parcel$export(module.exports, "searchKeys", function () { return $14bcc3418b46c2b0$export$7b45cbfd4fd1e917; });
parcelRequire("hWlPe");
parcelRequire("kiVDZ");
parcelRequire("adtV2");
parcelRequire("5Q2pm");
parcelRequire("9oLtf");
parcelRequire("emGEN");
parcelRequire("o53Y2");
parcelRequire("mbOAD");
const $14bcc3418b46c2b0$export$363ac302bdbd807b = 20000;
const $14bcc3418b46c2b0$export$d515e179bb47bd84 = 20;
var $14bcc3418b46c2b0$export$7b45cbfd4fd1e917;
(function(searchKeys) {
    searchKeys["signUp"] = "sign_up";
})($14bcc3418b46c2b0$export$7b45cbfd4fd1e917 || ($14bcc3418b46c2b0$export$7b45cbfd4fd1e917 = {}));

});
parcelRequire.register("hWlPe", function(module, exports) {

$parcel$export(module.exports, "lightModeApplicationIconMap", function () { return $c8ab9367b97da3c7$export$ae9903c14ae038a2; });
$parcel$export(module.exports, "darkModeApplicationIconMap", function () { return $c8ab9367b97da3c7$export$3d5d47bf867c811b; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $gjD7B = parcelRequire("gjD7B");

var $7MH9A = parcelRequire("7MH9A");

var $35M8v = parcelRequire("35M8v");

var $aCb8M = parcelRequire("aCb8M");

var $jwpnw = parcelRequire("jwpnw");

var $as8rT = parcelRequire("as8rT");

var $4IDAs = parcelRequire("4IDAs");

var $4KAe3 = parcelRequire("4KAe3");
const $c8ab9367b97da3c7$export$ae9903c14ae038a2 = Object.freeze({
    [(0, $3kVX5.ApplicationType).Native]: (0, $aCb8M.default),
    [(0, $3kVX5.ApplicationType).SPA]: (0, $as8rT.default),
    [(0, $3kVX5.ApplicationType).Traditional]: (0, $4KAe3.default),
    [(0, $3kVX5.ApplicationType).MachineToMachine]: (0, $7MH9A.default)
});
const $c8ab9367b97da3c7$export$3d5d47bf867c811b = Object.freeze({
    [(0, $3kVX5.ApplicationType).Native]: (0, $35M8v.default),
    [(0, $3kVX5.ApplicationType).SPA]: (0, $jwpnw.default),
    [(0, $3kVX5.ApplicationType).Traditional]: (0, $4IDAs.default),
    [(0, $3kVX5.ApplicationType).MachineToMachine]: (0, $gjD7B.default)
});

});
parcelRequire.register("j6dBR", function(module, exports) {
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("eyD2M")).customClientMetadataGuard; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("1EA0k")).DomainStatus; });
$parcel$export(module.exports, "HookEvent", function () { return (parcelRequire("lq5Qn")).HookEvent; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("123dJ")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("123dJ")).jsonObjectGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("lSUTm")).LogResult; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("bd0Y0")).MfaFactor; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("bd0Y0")).MfaPolicy; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("bd0Y0")).SignInIdentifier; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("9NTe8")).ssoBrandingGuard; });
$parcel$export(module.exports, "ApplicationType", function () { return (parcelRequire("3kVX5")).ApplicationType; });
$parcel$export(module.exports, "RoleType", function () { return (parcelRequire("3kVX5")).RoleType; });
$parcel$export(module.exports, "SignInMode", function () { return (parcelRequire("3kVX5")).SignInMode; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("86S23")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("fU2Vo")).ConnectorType; });
$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return (parcelRequire("7bVxi")).hookTestErrorResponseDataGuard; });
$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return (parcelRequire("gmXIe")).LogtoOidcConfigKeyType; });
$parcel$export(module.exports, "maxUploadFileSize", function () { return (parcelRequire("b63Fl")).maxUploadFileSize; });
$parcel$export(module.exports, "PredefinedScope", function () { return (parcelRequire("az3ON")).PredefinedScope; });
$parcel$export(module.exports, "SsoProviderName", function () { return (parcelRequire("5Je5u")).SsoProviderName; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return (parcelRequire("gmXIe")).SupportedSigningKeyAlgorithm; });
$parcel$export(module.exports, "TenantTag", function () { return (parcelRequire("3GN9E")).TenantTag; });
$parcel$export(module.exports, "Theme", function () { return (parcelRequire("bhvxB")).Theme; });
$parcel$export(module.exports, "adminConsoleApplicationId", function () { return (parcelRequire("faCyI")).adminConsoleApplicationId; });
$parcel$export(module.exports, "adminTenantId", function () { return (parcelRequire("8zpKJ")).adminTenantId; });
$parcel$export(module.exports, "cloudApiIndicator", function () { return (parcelRequire("7ZL8j")).cloudApiIndicator; });
$parcel$export(module.exports, "CloudScope", function () { return (parcelRequire("7ZL8j")).CloudScope; });
$parcel$export(module.exports, "defaultManagementApi", function () { return (parcelRequire("5fvIO")).defaultManagementApi; });
$parcel$export(module.exports, "defaultTenantId", function () { return (parcelRequire("8zpKJ")).defaultTenantId; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return (parcelRequire("faCyI")).demoAppApplicationId; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return (parcelRequire("5fvIO")).getManagementApiResourceIndicator; });
$parcel$export(module.exports, "customClientMetadataDefault", function () { return (parcelRequire("duSFh")).customClientMetadataDefault; });
$parcel$export(module.exports, "maxFreeTenantLimit", function () { return (parcelRequire("6iE6O")).maxFreeTenantLimit; });
$parcel$export(module.exports, "ossConsolePath", function () { return (parcelRequire("ceK0K")).ossConsolePath; });
$parcel$export(module.exports, "ReservedPlanId", function () { return (parcelRequire("ckJfF")).ReservedPlanId; });
$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return (parcelRequire("khQz7")).findDuplicatedOrBlockedEmailDomains; });
$parcel$export(module.exports, "internalRolePrefix", function () { return (parcelRequire("2O7i9")).internalRolePrefix; });
$parcel$export(module.exports, "isManagementApi", function () { return (parcelRequire("MRt6E")).isManagementApi; });
parcelRequire("irxkh");
parcelRequire("28jVG");
parcelRequire("9Sgat");
parcelRequire("3mK2t");
parcelRequire("hubhU");
parcelRequire("5d763");
parcelRequire("9sGuP");

});
parcelRequire.register("irxkh", function(module, exports) {
$parcel$export(module.exports, "brandingGuard", function () { return (parcelRequire("bd0Y0")).brandingGuard; });
$parcel$export(module.exports, "cloudflareDataGuard", function () { return (parcelRequire("1EA0k")).cloudflareDataGuard; });
$parcel$export(module.exports, "colorGuard", function () { return (parcelRequire("bd0Y0")).colorGuard; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("86S23")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return (parcelRequire("bd0Y0")).connectorTargetsGuard; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("eyD2M")).customClientMetadataGuard; });
$parcel$export(module.exports, "customContentGuard", function () { return (parcelRequire("bd0Y0")).customContentGuard; });
$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return (parcelRequire("1EA0k")).domainDnsRecordsGuard; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("1EA0k")).DomainStatus; });
$parcel$export(module.exports, "domainStatusGuard", function () { return (parcelRequire("1EA0k")).domainStatusGuard; });
$parcel$export(module.exports, "hookConfigGuard", function () { return (parcelRequire("lq5Qn")).hookConfigGuard; });
$parcel$export(module.exports, "HookEvent", function () { return (parcelRequire("lq5Qn")).HookEvent; });
$parcel$export(module.exports, "hookEventGuard", function () { return (parcelRequire("lq5Qn")).hookEventGuard; });
$parcel$export(module.exports, "hookEventsGuard", function () { return (parcelRequire("lq5Qn")).hookEventsGuard; });
$parcel$export(module.exports, "identitiesGuard", function () { return (parcelRequire("8AotL")).identitiesGuard; });
$parcel$export(module.exports, "jsonGuard", function () { return (parcelRequire("123dJ")).jsonGuard; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return (parcelRequire("123dJ")).jsonObjectGuard; });
$parcel$export(module.exports, "languageInfoGuard", function () { return (parcelRequire("bd0Y0")).languageInfoGuard; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return (parcelRequire("lSUTm")).logContextPayloadGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("lSUTm")).LogResult; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("bd0Y0")).MfaFactor; });
$parcel$export(module.exports, "mfaGuard", function () { return (parcelRequire("bd0Y0")).mfaGuard; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("bd0Y0")).MfaPolicy; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return (parcelRequire("8AotL")).mfaVerificationsGuard; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return (parcelRequire("eyD2M")).oidcClientMetadataGuard; });
$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return (parcelRequire("eyD2M")).oidcModelInstancePayloadGuard; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return (parcelRequire("lSUTm")).partialPasswordPolicyGuard; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityActionGuard; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityPayloadGuard; });
$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityTargetTypeGuard; });
$parcel$export(module.exports, "signInGuard", function () { return (parcelRequire("bd0Y0")).signInGuard; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("bd0Y0")).SignInIdentifier; });
$parcel$export(module.exports, "signUpGuard", function () { return (parcelRequire("bd0Y0")).signUpGuard; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("9NTe8")).ssoBrandingGuard; });
$parcel$export(module.exports, "ssoDomainsGuard", function () { return (parcelRequire("9NTe8")).ssoDomainsGuard; });
$parcel$export(module.exports, "translationGuard", function () { return (parcelRequire("2r8y8")).translationGuard; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return (parcelRequire("8AotL")).webAuthnTransportGuard; });
parcelRequire("cb49z");
parcelRequire("123dJ");

});
parcelRequire.register("cb49z", function(module, exports) {

});

parcelRequire.register("123dJ", function(module, exports) {
$parcel$export(module.exports, "cloudflareDataGuard", function () { return (parcelRequire("1EA0k")).cloudflareDataGuard; });
$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return (parcelRequire("1EA0k")).domainDnsRecordsGuard; });
$parcel$export(module.exports, "DomainStatus", function () { return (parcelRequire("1EA0k")).DomainStatus; });
$parcel$export(module.exports, "domainStatusGuard", function () { return (parcelRequire("1EA0k")).domainStatusGuard; });
$parcel$export(module.exports, "hookConfigGuard", function () { return (parcelRequire("lq5Qn")).hookConfigGuard; });
$parcel$export(module.exports, "HookEvent", function () { return (parcelRequire("lq5Qn")).HookEvent; });
$parcel$export(module.exports, "hookEventGuard", function () { return (parcelRequire("lq5Qn")).hookEventGuard; });
$parcel$export(module.exports, "hookEventsGuard", function () { return (parcelRequire("lq5Qn")).hookEventsGuard; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return (parcelRequire("lSUTm")).logContextPayloadGuard; });
$parcel$export(module.exports, "LogResult", function () { return (parcelRequire("lSUTm")).LogResult; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return (parcelRequire("lSUTm")).partialPasswordPolicyGuard; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return (parcelRequire("eyD2M")).customClientMetadataGuard; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return (parcelRequire("eyD2M")).oidcClientMetadataGuard; });
$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return (parcelRequire("eyD2M")).oidcModelInstancePayloadGuard; });
$parcel$export(module.exports, "translationGuard", function () { return (parcelRequire("2r8y8")).translationGuard; });
$parcel$export(module.exports, "brandingGuard", function () { return (parcelRequire("bd0Y0")).brandingGuard; });
$parcel$export(module.exports, "colorGuard", function () { return (parcelRequire("bd0Y0")).colorGuard; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return (parcelRequire("bd0Y0")).connectorTargetsGuard; });
$parcel$export(module.exports, "customContentGuard", function () { return (parcelRequire("bd0Y0")).customContentGuard; });
$parcel$export(module.exports, "languageInfoGuard", function () { return (parcelRequire("bd0Y0")).languageInfoGuard; });
$parcel$export(module.exports, "MfaFactor", function () { return (parcelRequire("bd0Y0")).MfaFactor; });
$parcel$export(module.exports, "mfaGuard", function () { return (parcelRequire("bd0Y0")).mfaGuard; });
$parcel$export(module.exports, "MfaPolicy", function () { return (parcelRequire("bd0Y0")).MfaPolicy; });
$parcel$export(module.exports, "signInGuard", function () { return (parcelRequire("bd0Y0")).signInGuard; });
$parcel$export(module.exports, "SignInIdentifier", function () { return (parcelRequire("bd0Y0")).SignInIdentifier; });
$parcel$export(module.exports, "signUpGuard", function () { return (parcelRequire("bd0Y0")).signUpGuard; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityActionGuard; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityPayloadGuard; });
$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return (parcelRequire("jMgxv")).sentinelActivityTargetTypeGuard; });
$parcel$export(module.exports, "identitiesGuard", function () { return (parcelRequire("8AotL")).identitiesGuard; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return (parcelRequire("8AotL")).mfaVerificationsGuard; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return (parcelRequire("8AotL")).webAuthnTransportGuard; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return (parcelRequire("9NTe8")).ssoBrandingGuard; });
$parcel$export(module.exports, "ssoDomainsGuard", function () { return (parcelRequire("9NTe8")).ssoDomainsGuard; });

$parcel$export(module.exports, "jsonGuard", function () { return $0c0879d8640c78ee$export$80d8b5946da2a05e; });
$parcel$export(module.exports, "jsonObjectGuard", function () { return $0c0879d8640c78ee$export$4ac62c0537cd0db7; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("86S23")).configurableConnectorMetadataGuard; });

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("1EA0k");
parcelRequire("lq5Qn");
parcelRequire("lSUTm");
parcelRequire("eyD2M");
parcelRequire("2r8y8");
parcelRequire("bd0Y0");
parcelRequire("jMgxv");
parcelRequire("8AotL");
parcelRequire("9NTe8");
parcelRequire("j7Jj8");
var $86S23 = parcelRequire("86S23");
/* === Commonly Used === */ // Copied from https://github.com/colinhacks/zod#json-type
const $0c0879d8640c78ee$var$literalSchema = (0, $2CYkO.z).union([
    (0, $2CYkO.z).string(),
    (0, $2CYkO.z).number(),
    (0, $2CYkO.z).boolean(),
    (0, $2CYkO.z).null()
]);
const $0c0879d8640c78ee$export$80d8b5946da2a05e = (0, $2CYkO.z).lazy(()=>(0, $2CYkO.z).union([
        $0c0879d8640c78ee$var$literalSchema,
        (0, $2CYkO.z).array($0c0879d8640c78ee$export$80d8b5946da2a05e),
        (0, $2CYkO.z).record($0c0879d8640c78ee$export$80d8b5946da2a05e)
    ]));
const $0c0879d8640c78ee$export$4ac62c0537cd0db7 = (0, $2CYkO.z).record($0c0879d8640c78ee$export$80d8b5946da2a05e);

});
parcelRequire.register("1EA0k", function(module, exports) {

$parcel$export(module.exports, "domainDnsRecordsGuard", function () { return $13457496be5ac4b8$export$ab6045338fa7d71b; });
$parcel$export(module.exports, "cloudflareDataGuard", function () { return $13457496be5ac4b8$export$10762083065a1f71; });
$parcel$export(module.exports, "DomainStatus", function () { return $13457496be5ac4b8$export$4bfadd7b59276a6c; });
$parcel$export(module.exports, "domainStatusGuard", function () { return $13457496be5ac4b8$export$fda7fbe88a5ffb61; });

var $2CYkO = parcelRequire("2CYkO");
const $13457496be5ac4b8$export$48c1db756576ae1 = (0, $2CYkO.z).object({
    name: (0, $2CYkO.z).string(),
    type: (0, $2CYkO.z).string(),
    value: (0, $2CYkO.z).string()
});
const $13457496be5ac4b8$export$ab6045338fa7d71b = $13457496be5ac4b8$export$48c1db756576ae1.array();
const $13457496be5ac4b8$export$10762083065a1f71 = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    status: (0, $2CYkO.z).string(),
    ssl: (0, $2CYkO.z).object({
        status: (0, $2CYkO.z).string(),
        validation_errors: (0, $2CYkO.z).object({
            message: (0, $2CYkO.z).string()
        }).catchall((0, $2CYkO.z).unknown()).array().optional()
    }).catchall((0, $2CYkO.z).unknown()),
    verification_errors: (0, $2CYkO.z).string().array().optional()
}).catchall((0, $2CYkO.z).unknown());
var $13457496be5ac4b8$export$4bfadd7b59276a6c;
(function(DomainStatus) {
    DomainStatus["PendingVerification"] = "PendingVerification";
    DomainStatus["PendingSsl"] = "PendingSsl";
    DomainStatus["Active"] = "Active";
    DomainStatus["Error"] = "Error";
})($13457496be5ac4b8$export$4bfadd7b59276a6c || ($13457496be5ac4b8$export$4bfadd7b59276a6c = {}));
const $13457496be5ac4b8$export$fda7fbe88a5ffb61 = (0, $2CYkO.z).nativeEnum($13457496be5ac4b8$export$4bfadd7b59276a6c);

});

parcelRequire.register("lq5Qn", function(module, exports) {

$parcel$export(module.exports, "HookEvent", function () { return $f9808f21babe7df8$export$9b32daede159ad68; });
$parcel$export(module.exports, "hookEventGuard", function () { return $f9808f21babe7df8$export$2d2b15eb4f8d4fc9; });
$parcel$export(module.exports, "hookEventsGuard", function () { return $f9808f21babe7df8$export$56e77a150fce61b; });
$parcel$export(module.exports, "hookConfigGuard", function () { return $f9808f21babe7df8$export$924993b6fcd8d738; });

var $2CYkO = parcelRequire("2CYkO");
var $f9808f21babe7df8$export$9b32daede159ad68;
(function(HookEvent) {
    HookEvent["PostRegister"] = "PostRegister";
    HookEvent["PostSignIn"] = "PostSignIn";
    HookEvent["PostResetPassword"] = "PostResetPassword";
})($f9808f21babe7df8$export$9b32daede159ad68 || ($f9808f21babe7df8$export$9b32daede159ad68 = {}));
const $f9808f21babe7df8$export$2d2b15eb4f8d4fc9 = (0, $2CYkO.z).nativeEnum($f9808f21babe7df8$export$9b32daede159ad68);
const $f9808f21babe7df8$export$56e77a150fce61b = $f9808f21babe7df8$export$2d2b15eb4f8d4fc9.array();
const $f9808f21babe7df8$export$924993b6fcd8d738 = (0, $2CYkO.z).object({
    /** We don't need `type` since v1 only has web hook */ // type: 'web';
    /** Method fixed to `POST` */ url: (0, $2CYkO.z).string(),
    /** Additional headers that attach to the request */ headers: (0, $2CYkO.z).record((0, $2CYkO.z).string()).optional(),
    /**
     * @deprecated
     * Retry times when hook response status >= 500.
     * Now the retry times is fixed to 3.
     * Keep for backward compatibility.
     */ retries: (0, $2CYkO.z).number().gte(0).lte(3).optional()
});

});

parcelRequire.register("lSUTm", function(module, exports) {

$parcel$export(module.exports, "LogResult", function () { return $feeac5a70c13c1f9$export$a20c8b5ccf36e075; });
$parcel$export(module.exports, "logContextPayloadGuard", function () { return $feeac5a70c13c1f9$export$2938cb1ca9b4e331; });
$parcel$export(module.exports, "partialPasswordPolicyGuard", function () { return $feeac5a70c13c1f9$export$eee4f836f95656a7; });
parcelRequire("8Hfh4");
var $311RW = parcelRequire("311RW");

var $2CYkO = parcelRequire("2CYkO");
var $feeac5a70c13c1f9$export$a20c8b5ccf36e075;
(function(LogResult) {
    LogResult["Success"] = "Success";
    LogResult["Error"] = "Error";
})($feeac5a70c13c1f9$export$a20c8b5ccf36e075 || ($feeac5a70c13c1f9$export$a20c8b5ccf36e075 = {}));
const $feeac5a70c13c1f9$export$2938cb1ca9b4e331 = (0, $2CYkO.z).object({
    key: (0, $2CYkO.z).string(),
    result: (0, $2CYkO.z).nativeEnum($feeac5a70c13c1f9$export$a20c8b5ccf36e075),
    error: (0, $2CYkO.z).record((0, $2CYkO.z).string(), (0, $2CYkO.z).unknown()).or((0, $2CYkO.z).string()).optional(),
    ip: (0, $2CYkO.z).string().optional(),
    userAgent: (0, $2CYkO.z).string().optional(),
    userId: (0, $2CYkO.z).string().optional(),
    applicationId: (0, $2CYkO.z).string().optional(),
    sessionId: (0, $2CYkO.z).string().optional()
}).catchall((0, $2CYkO.z).unknown());
const $feeac5a70c13c1f9$export$eee4f836f95656a7 = (0, $311RW.passwordPolicyGuard).deepPartial();

});
parcelRequire.register("8Hfh4", function(module, exports) {
$parcel$export(module.exports, "generateDarkColor", function () { return (parcelRequire("hVcgO")).generateDarkColor; });
$parcel$export(module.exports, "validateRedirectUrl", function () { return (parcelRequire("91b1s")).validateRedirectUrl; });
$parcel$export(module.exports, "emailRegEx", function () { return (parcelRequire("dQcUe")).emailRegEx; });
$parcel$export(module.exports, "hexColorRegEx", function () { return (parcelRequire("dQcUe")).hexColorRegEx; });
$parcel$export(module.exports, "noSpaceRegEx", function () { return (parcelRequire("dQcUe")).noSpaceRegEx; });
$parcel$export(module.exports, "phoneInputRegEx", function () { return (parcelRequire("dQcUe")).phoneInputRegEx; });
$parcel$export(module.exports, "phoneRegEx", function () { return (parcelRequire("dQcUe")).phoneRegEx; });
$parcel$export(module.exports, "usernameRegEx", function () { return (parcelRequire("dQcUe")).usernameRegEx; });
$parcel$export(module.exports, "UserScope", function () { return (parcelRequire("lvEG3")).UserScope; });
$parcel$export(module.exports, "httpCodeToMessage", function () { return (parcelRequire("6A6hX")).httpCodeToMessage; });
$parcel$export(module.exports, "PasswordPolicyChecker", function () { return (parcelRequire("311RW")).PasswordPolicyChecker; });
$parcel$export(module.exports, "passwordPolicyGuard", function () { return (parcelRequire("311RW")).passwordPolicyGuard; });
parcelRequire("2zpRY");
parcelRequire("dQcUe");
parcelRequire("lvEG3");
parcelRequire("gKqYh");
parcelRequire("6A6hX");
parcelRequire("311RW");

});
parcelRequire.register("2zpRY", function(module, exports) {
$parcel$export(module.exports, "generateDarkColor", function () { return (parcelRequire("hVcgO")).generateDarkColor; });
$parcel$export(module.exports, "validateRedirectUrl", function () { return (parcelRequire("91b1s")).validateRedirectUrl; });
parcelRequire("hVcgO");
parcelRequire("91b1s");

});
parcelRequire.register("hVcgO", function(module, exports) {

$parcel$export(module.exports, "generateDarkColor", function () { return $d0c147248ea4cf4a$export$2feb0cd4df065982; });

var $2v9nZ = parcelRequire("2v9nZ");
const $d0c147248ea4cf4a$export$2b47dd798c93e22f = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2v9nZ)))([
        hslArray[0] ?? 0,
        hslArray[1] ?? 0,
        (hslArray[2] ?? 0) + delta
    ], "hsl");
};
const $d0c147248ea4cf4a$export$13a5971b241f058c = (baseColor, delta)=>{
    const hslArray = baseColor.hsl().round().array();
    return (0, (/*@__PURE__*/$parcel$interopDefault($2v9nZ)))([
        hslArray[0] ?? 0,
        hslArray[1] ?? 0,
        (hslArray[2] ?? 0) - delta
    ], "hsl");
};
const $d0c147248ea4cf4a$export$2feb0cd4df065982 = (lightColor)=>$d0c147248ea4cf4a$export$2b47dd798c93e22f((0, (/*@__PURE__*/$parcel$interopDefault($2v9nZ)))(lightColor), 10).hex();

});
parcelRequire.register("2v9nZ", function(module, exports) {

var $51EnB = parcelRequire("51EnB");

var $j2FXN = parcelRequire("j2FXN");
const $1d25c1e5a9c2671e$var$skippedModels = [
    // To be honest, I don't really feel like keyword belongs in color convert, but eh.
    "keyword",
    // Gray conflicts with some method names, and has its own method defined.
    "gray",
    // Shouldn't really be in color-convert either...
    "hex"
];
const $1d25c1e5a9c2671e$var$hashedModelKeys = {};
for (const model of Object.keys($j2FXN))$1d25c1e5a9c2671e$var$hashedModelKeys[[
    ...$j2FXN[model].labels
].sort().join("")] = model;
const $1d25c1e5a9c2671e$var$limiters = {};
function $1d25c1e5a9c2671e$var$Color(object, model) {
    if (!(this instanceof $1d25c1e5a9c2671e$var$Color)) return new $1d25c1e5a9c2671e$var$Color(object, model);
    if (model && model in $1d25c1e5a9c2671e$var$skippedModels) model = null;
    if (model && !(model in $j2FXN)) throw new Error("Unknown model: " + model);
    let i;
    let channels;
    if (object == null) {
        this.model = "rgb";
        this.color = [
            0,
            0,
            0
        ];
        this.valpha = 1;
    } else if (object instanceof $1d25c1e5a9c2671e$var$Color) {
        this.model = object.model;
        this.color = [
            ...object.color
        ];
        this.valpha = object.valpha;
    } else if (typeof object === "string") {
        const result = $51EnB.get(object);
        if (result === null) throw new Error("Unable to parse color from string: " + object);
        this.model = result.model;
        channels = $j2FXN[this.model].channels;
        this.color = result.value.slice(0, channels);
        this.valpha = typeof result.value[channels] === "number" ? result.value[channels] : 1;
    } else if (object.length > 0) {
        this.model = model || "rgb";
        channels = $j2FXN[this.model].channels;
        const newArray = Array.prototype.slice.call(object, 0, channels);
        this.color = $1d25c1e5a9c2671e$var$zeroArray(newArray, channels);
        this.valpha = typeof object[channels] === "number" ? object[channels] : 1;
    } else if (typeof object === "number") {
        // This is always RGB - can be converted later on.
        this.model = "rgb";
        this.color = [
            object >> 16 & 0xFF,
            object >> 8 & 0xFF,
            object & 0xFF
        ];
        this.valpha = 1;
    } else {
        this.valpha = 1;
        const keys = Object.keys(object);
        if ("alpha" in object) {
            keys.splice(keys.indexOf("alpha"), 1);
            this.valpha = typeof object.alpha === "number" ? object.alpha : 0;
        }
        const hashedKeys = keys.sort().join("");
        if (!(hashedKeys in $1d25c1e5a9c2671e$var$hashedModelKeys)) throw new Error("Unable to parse color from object: " + JSON.stringify(object));
        this.model = $1d25c1e5a9c2671e$var$hashedModelKeys[hashedKeys];
        const { labels: labels } = $j2FXN[this.model];
        const color = [];
        for(i = 0; i < labels.length; i++)color.push(object[labels[i]]);
        this.color = $1d25c1e5a9c2671e$var$zeroArray(color);
    }
    // Perform limitations (clamping, etc.)
    if ($1d25c1e5a9c2671e$var$limiters[this.model]) {
        channels = $j2FXN[this.model].channels;
        for(i = 0; i < channels; i++){
            const limit = $1d25c1e5a9c2671e$var$limiters[this.model][i];
            if (limit) this.color[i] = limit(this.color[i]);
        }
    }
    this.valpha = Math.max(0, Math.min(1, this.valpha));
    if (Object.freeze) Object.freeze(this);
}
$1d25c1e5a9c2671e$var$Color.prototype = {
    toString () {
        return this.string();
    },
    toJSON () {
        return this[this.model]();
    },
    string (places) {
        let self = this.model in $51EnB.to ? this : this.rgb();
        self = self.round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $51EnB.to[self.model](args);
    },
    percentString (places) {
        const self = this.rgb().round(typeof places === "number" ? places : 1);
        const args = self.valpha === 1 ? self.color : [
            ...self.color,
            this.valpha
        ];
        return $51EnB.to.rgb.percent(args);
    },
    array () {
        return this.valpha === 1 ? [
            ...this.color
        ] : [
            ...this.color,
            this.valpha
        ];
    },
    object () {
        const result = {};
        const { channels: channels } = $j2FXN[this.model];
        const { labels: labels } = $j2FXN[this.model];
        for(let i = 0; i < channels; i++)result[labels[i]] = this.color[i];
        if (this.valpha !== 1) result.alpha = this.valpha;
        return result;
    },
    unitArray () {
        const rgb = this.rgb().color;
        rgb[0] /= 255;
        rgb[1] /= 255;
        rgb[2] /= 255;
        if (this.valpha !== 1) rgb.push(this.valpha);
        return rgb;
    },
    unitObject () {
        const rgb = this.rgb().object();
        rgb.r /= 255;
        rgb.g /= 255;
        rgb.b /= 255;
        if (this.valpha !== 1) rgb.alpha = this.valpha;
        return rgb;
    },
    round (places) {
        places = Math.max(places || 0, 0);
        return new $1d25c1e5a9c2671e$var$Color([
            ...this.color.map($1d25c1e5a9c2671e$var$roundToPlace(places)),
            this.valpha
        ], this.model);
    },
    alpha (value) {
        if (value !== undefined) return new $1d25c1e5a9c2671e$var$Color([
            ...this.color,
            Math.max(0, Math.min(1, value))
        ], this.model);
        return this.valpha;
    },
    // Rgb
    red: $1d25c1e5a9c2671e$var$getset("rgb", 0, $1d25c1e5a9c2671e$var$maxfn(255)),
    green: $1d25c1e5a9c2671e$var$getset("rgb", 1, $1d25c1e5a9c2671e$var$maxfn(255)),
    blue: $1d25c1e5a9c2671e$var$getset("rgb", 2, $1d25c1e5a9c2671e$var$maxfn(255)),
    hue: $1d25c1e5a9c2671e$var$getset([
        "hsl",
        "hsv",
        "hsl",
        "hwb",
        "hcg"
    ], 0, (value)=>(value % 360 + 360) % 360),
    saturationl: $1d25c1e5a9c2671e$var$getset("hsl", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    lightness: $1d25c1e5a9c2671e$var$getset("hsl", 2, $1d25c1e5a9c2671e$var$maxfn(100)),
    saturationv: $1d25c1e5a9c2671e$var$getset("hsv", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    value: $1d25c1e5a9c2671e$var$getset("hsv", 2, $1d25c1e5a9c2671e$var$maxfn(100)),
    chroma: $1d25c1e5a9c2671e$var$getset("hcg", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    gray: $1d25c1e5a9c2671e$var$getset("hcg", 2, $1d25c1e5a9c2671e$var$maxfn(100)),
    white: $1d25c1e5a9c2671e$var$getset("hwb", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    wblack: $1d25c1e5a9c2671e$var$getset("hwb", 2, $1d25c1e5a9c2671e$var$maxfn(100)),
    cyan: $1d25c1e5a9c2671e$var$getset("cmyk", 0, $1d25c1e5a9c2671e$var$maxfn(100)),
    magenta: $1d25c1e5a9c2671e$var$getset("cmyk", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    yellow: $1d25c1e5a9c2671e$var$getset("cmyk", 2, $1d25c1e5a9c2671e$var$maxfn(100)),
    black: $1d25c1e5a9c2671e$var$getset("cmyk", 3, $1d25c1e5a9c2671e$var$maxfn(100)),
    x: $1d25c1e5a9c2671e$var$getset("xyz", 0, $1d25c1e5a9c2671e$var$maxfn(95.047)),
    y: $1d25c1e5a9c2671e$var$getset("xyz", 1, $1d25c1e5a9c2671e$var$maxfn(100)),
    z: $1d25c1e5a9c2671e$var$getset("xyz", 2, $1d25c1e5a9c2671e$var$maxfn(108.833)),
    l: $1d25c1e5a9c2671e$var$getset("lab", 0, $1d25c1e5a9c2671e$var$maxfn(100)),
    a: $1d25c1e5a9c2671e$var$getset("lab", 1),
    b: $1d25c1e5a9c2671e$var$getset("lab", 2),
    keyword (value) {
        if (value !== undefined) return new $1d25c1e5a9c2671e$var$Color(value);
        return $j2FXN[this.model].keyword(this.color);
    },
    hex (value) {
        if (value !== undefined) return new $1d25c1e5a9c2671e$var$Color(value);
        return $51EnB.to.hex(this.rgb().round().color);
    },
    hexa (value) {
        if (value !== undefined) return new $1d25c1e5a9c2671e$var$Color(value);
        const rgbArray = this.rgb().round().color;
        let alphaHex = Math.round(this.valpha * 255).toString(16).toUpperCase();
        if (alphaHex.length === 1) alphaHex = "0" + alphaHex;
        return $51EnB.to.hex(rgbArray) + alphaHex;
    },
    rgbNumber () {
        const rgb = this.rgb().color;
        return (rgb[0] & 0xFF) << 16 | (rgb[1] & 0xFF) << 8 | rgb[2] & 0xFF;
    },
    luminosity () {
        // http://www.w3.org/TR/WCAG20/#relativeluminancedef
        const rgb = this.rgb().color;
        const lum = [];
        for (const [i, element] of rgb.entries()){
            const chan = element / 255;
            lum[i] = chan <= 0.04045 ? chan / 12.92 : ((chan + 0.055) / 1.055) ** 2.4;
        }
        return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast (color2) {
        // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
        const lum1 = this.luminosity();
        const lum2 = color2.luminosity();
        if (lum1 > lum2) return (lum1 + 0.05) / (lum2 + 0.05);
        return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level (color2) {
        // https://www.w3.org/TR/WCAG/#contrast-enhanced
        const contrastRatio = this.contrast(color2);
        if (contrastRatio >= 7) return "AAA";
        return contrastRatio >= 4.5 ? "AA" : "";
    },
    isDark () {
        // YIQ equation from http://24ways.org/2010/calculating-color-contrast
        const rgb = this.rgb().color;
        const yiq = (rgb[0] * 2126 + rgb[1] * 7152 + rgb[2] * 722) / 10000;
        return yiq < 128;
    },
    isLight () {
        return !this.isDark();
    },
    negate () {
        const rgb = this.rgb();
        for(let i = 0; i < 3; i++)rgb.color[i] = 255 - rgb.color[i];
        return rgb;
    },
    lighten (ratio) {
        const hsl = this.hsl();
        hsl.color[2] += hsl.color[2] * ratio;
        return hsl;
    },
    darken (ratio) {
        const hsl = this.hsl();
        hsl.color[2] -= hsl.color[2] * ratio;
        return hsl;
    },
    saturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] += hsl.color[1] * ratio;
        return hsl;
    },
    desaturate (ratio) {
        const hsl = this.hsl();
        hsl.color[1] -= hsl.color[1] * ratio;
        return hsl;
    },
    whiten (ratio) {
        const hwb = this.hwb();
        hwb.color[1] += hwb.color[1] * ratio;
        return hwb;
    },
    blacken (ratio) {
        const hwb = this.hwb();
        hwb.color[2] += hwb.color[2] * ratio;
        return hwb;
    },
    grayscale () {
        // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
        const rgb = this.rgb().color;
        const value = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
        return $1d25c1e5a9c2671e$var$Color.rgb(value, value, value);
    },
    fade (ratio) {
        return this.alpha(this.valpha - this.valpha * ratio);
    },
    opaquer (ratio) {
        return this.alpha(this.valpha + this.valpha * ratio);
    },
    rotate (degrees) {
        const hsl = this.hsl();
        let hue = hsl.color[0];
        hue = (hue + degrees) % 360;
        hue = hue < 0 ? 360 + hue : hue;
        hsl.color[0] = hue;
        return hsl;
    },
    mix (mixinColor, weight) {
        // Ported from sass implementation in C
        // https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
        if (!mixinColor || !mixinColor.rgb) throw new Error('Argument to "mix" was not a Color instance, but rather an instance of ' + typeof mixinColor);
        const color1 = mixinColor.rgb();
        const color2 = this.rgb();
        const p = weight === undefined ? 0.5 : weight;
        const w = 2 * p - 1;
        const a = color1.alpha() - color2.alpha();
        const w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2;
        const w2 = 1 - w1;
        return $1d25c1e5a9c2671e$var$Color.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue(), color1.alpha() * p + color2.alpha() * (1 - p));
    }
};
// Model conversion methods and static constructors
for (const model of Object.keys($j2FXN)){
    if ($1d25c1e5a9c2671e$var$skippedModels.includes(model)) continue;
    const { channels: channels } = $j2FXN[model];
    // Conversion methods
    $1d25c1e5a9c2671e$var$Color.prototype[model] = function(...args) {
        if (this.model === model) return new $1d25c1e5a9c2671e$var$Color(this);
        if (args.length > 0) return new $1d25c1e5a9c2671e$var$Color(args, model);
        return new $1d25c1e5a9c2671e$var$Color([
            ...$1d25c1e5a9c2671e$var$assertArray($j2FXN[this.model][model].raw(this.color)),
            this.valpha
        ], model);
    };
    // 'static' construction methods
    $1d25c1e5a9c2671e$var$Color[model] = function(...args) {
        let color = args[0];
        if (typeof color === "number") color = $1d25c1e5a9c2671e$var$zeroArray(args, channels);
        return new $1d25c1e5a9c2671e$var$Color(color, model);
    };
}
function $1d25c1e5a9c2671e$var$roundTo(number, places) {
    return Number(number.toFixed(places));
}
function $1d25c1e5a9c2671e$var$roundToPlace(places) {
    return function(number) {
        return $1d25c1e5a9c2671e$var$roundTo(number, places);
    };
}
function $1d25c1e5a9c2671e$var$getset(model, channel, modifier) {
    model = Array.isArray(model) ? model : [
        model
    ];
    for (const m of model)($1d25c1e5a9c2671e$var$limiters[m] || ($1d25c1e5a9c2671e$var$limiters[m] = []))[channel] = modifier;
    model = model[0];
    return function(value) {
        let result;
        if (value !== undefined) {
            if (modifier) value = modifier(value);
            result = this[model]();
            result.color[channel] = value;
            return result;
        }
        result = this[model]().color[channel];
        if (modifier) result = modifier(result);
        return result;
    };
}
function $1d25c1e5a9c2671e$var$maxfn(max) {
    return function(v) {
        return Math.max(0, Math.min(max, v));
    };
}
function $1d25c1e5a9c2671e$var$assertArray(value) {
    return Array.isArray(value) ? value : [
        value
    ];
}
function $1d25c1e5a9c2671e$var$zeroArray(array, length) {
    for(let i = 0; i < length; i++)if (typeof array[i] !== "number") array[i] = 0;
    return array;
}
module.exports = $1d25c1e5a9c2671e$var$Color;

});
parcelRequire.register("51EnB", function(module, exports) {
/* MIT license */ 
var $kqzER = parcelRequire("kqzER");

var $aJrFg = parcelRequire("aJrFg");
var $3a8c5e52e73db19f$var$hasOwnProperty = Object.hasOwnProperty;
var $3a8c5e52e73db19f$var$reverseNames = Object.create(null);
// create a list of reverse color names
for(var $3a8c5e52e73db19f$var$name in $kqzER)if ($3a8c5e52e73db19f$var$hasOwnProperty.call($kqzER, $3a8c5e52e73db19f$var$name)) $3a8c5e52e73db19f$var$reverseNames[$kqzER[$3a8c5e52e73db19f$var$name]] = $3a8c5e52e73db19f$var$name;
var $3a8c5e52e73db19f$var$cs = module.exports = {
    to: {},
    get: {}
};
$3a8c5e52e73db19f$var$cs.get = function(string) {
    var prefix = string.substring(0, 3).toLowerCase();
    var val;
    var model;
    switch(prefix){
        case "hsl":
            val = $3a8c5e52e73db19f$var$cs.get.hsl(string);
            model = "hsl";
            break;
        case "hwb":
            val = $3a8c5e52e73db19f$var$cs.get.hwb(string);
            model = "hwb";
            break;
        default:
            val = $3a8c5e52e73db19f$var$cs.get.rgb(string);
            model = "rgb";
            break;
    }
    if (!val) return null;
    return {
        model: model,
        value: val
    };
};
$3a8c5e52e73db19f$var$cs.get.rgb = function(string) {
    if (!string) return null;
    var abbr = /^#([a-f0-9]{3,4})$/i;
    var hex = /^#([a-f0-9]{6})([a-f0-9]{2})?$/i;
    var rgba = /^rgba?\(\s*([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)(?=[\s,])\s*(?:,\s*)?([+-]?\d+)\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*,?\s*([+-]?[\d\.]+)\%\s*(?:[,|\/]\s*([+-]?[\d\.]+)(%?)\s*)?\)$/;
    var keyword = /^(\w+)$/;
    var rgb = [
        0,
        0,
        0,
        1
    ];
    var match;
    var i;
    var hexAlpha;
    if (match = string.match(hex)) {
        hexAlpha = match[2];
        match = match[1];
        for(i = 0; i < 3; i++){
            // https://jsperf.com/slice-vs-substr-vs-substring-methods-long-string/19
            var i2 = i * 2;
            rgb[i] = parseInt(match.slice(i2, i2 + 2), 16);
        }
        if (hexAlpha) rgb[3] = parseInt(hexAlpha, 16) / 255;
    } else if (match = string.match(abbr)) {
        match = match[1];
        hexAlpha = match[3];
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i] + match[i], 16);
        if (hexAlpha) rgb[3] = parseInt(hexAlpha + hexAlpha, 16) / 255;
    } else if (match = string.match(rgba)) {
        for(i = 0; i < 3; i++)rgb[i] = parseInt(match[i + 1], 0);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(per)) {
        for(i = 0; i < 3; i++)rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
        if (match[4]) {
            if (match[5]) rgb[3] = parseFloat(match[4]) * 0.01;
            else rgb[3] = parseFloat(match[4]);
        }
    } else if (match = string.match(keyword)) {
        if (match[1] === "transparent") return [
            0,
            0,
            0,
            0
        ];
        if (!$3a8c5e52e73db19f$var$hasOwnProperty.call($kqzER, match[1])) return null;
        rgb = $kqzER[match[1]];
        rgb[3] = 1;
        return rgb;
    } else return null;
    for(i = 0; i < 3; i++)rgb[i] = $3a8c5e52e73db19f$var$clamp(rgb[i], 0, 255);
    rgb[3] = $3a8c5e52e73db19f$var$clamp(rgb[3], 0, 1);
    return rgb;
};
$3a8c5e52e73db19f$var$cs.get.hsl = function(string) {
    if (!string) return null;
    var hsl = /^hsla?\(\s*([+-]?(?:\d{0,3}\.)?\d+)(?:deg)?\s*,?\s*([+-]?[\d\.]+)%\s*,?\s*([+-]?[\d\.]+)%\s*(?:[,|\/]\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hsl);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var s = $3a8c5e52e73db19f$var$clamp(parseFloat(match[2]), 0, 100);
        var l = $3a8c5e52e73db19f$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $3a8c5e52e73db19f$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            s,
            l,
            a
        ];
    }
    return null;
};
$3a8c5e52e73db19f$var$cs.get.hwb = function(string) {
    if (!string) return null;
    var hwb = /^hwb\(\s*([+-]?\d{0,3}(?:\.\d+)?)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?(?=\.\d|\d)(?:0|[1-9]\d*)?(?:\.\d*)?(?:[eE][+-]?\d+)?)\s*)?\)$/;
    var match = string.match(hwb);
    if (match) {
        var alpha = parseFloat(match[4]);
        var h = (parseFloat(match[1]) % 360 + 360) % 360;
        var w = $3a8c5e52e73db19f$var$clamp(parseFloat(match[2]), 0, 100);
        var b = $3a8c5e52e73db19f$var$clamp(parseFloat(match[3]), 0, 100);
        var a = $3a8c5e52e73db19f$var$clamp(isNaN(alpha) ? 1 : alpha, 0, 1);
        return [
            h,
            w,
            b,
            a
        ];
    }
    return null;
};
$3a8c5e52e73db19f$var$cs.to.hex = function() {
    var rgba = $aJrFg(arguments);
    return "#" + $3a8c5e52e73db19f$var$hexDouble(rgba[0]) + $3a8c5e52e73db19f$var$hexDouble(rgba[1]) + $3a8c5e52e73db19f$var$hexDouble(rgba[2]) + (rgba[3] < 1 ? $3a8c5e52e73db19f$var$hexDouble(Math.round(rgba[3] * 255)) : "");
};
$3a8c5e52e73db19f$var$cs.to.rgb = function() {
    var rgba = $aJrFg(arguments);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ")" : "rgba(" + Math.round(rgba[0]) + ", " + Math.round(rgba[1]) + ", " + Math.round(rgba[2]) + ", " + rgba[3] + ")";
};
$3a8c5e52e73db19f$var$cs.to.rgb.percent = function() {
    var rgba = $aJrFg(arguments);
    var r = Math.round(rgba[0] / 255 * 100);
    var g = Math.round(rgba[1] / 255 * 100);
    var b = Math.round(rgba[2] / 255 * 100);
    return rgba.length < 4 || rgba[3] === 1 ? "rgb(" + r + "%, " + g + "%, " + b + "%)" : "rgba(" + r + "%, " + g + "%, " + b + "%, " + rgba[3] + ")";
};
$3a8c5e52e73db19f$var$cs.to.hsl = function() {
    var hsla = $aJrFg(arguments);
    return hsla.length < 4 || hsla[3] === 1 ? "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)" : "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + hsla[3] + ")";
};
// hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
// (hwb have alpha optional & 1 is default value)
$3a8c5e52e73db19f$var$cs.to.hwb = function() {
    var hwba = $aJrFg(arguments);
    var a = "";
    if (hwba.length >= 4 && hwba[3] !== 1) a = ", " + hwba[3];
    return "hwb(" + hwba[0] + ", " + hwba[1] + "%, " + hwba[2] + "%" + a + ")";
};
$3a8c5e52e73db19f$var$cs.to.keyword = function(rgb) {
    return $3a8c5e52e73db19f$var$reverseNames[rgb.slice(0, 3)];
};
// helpers
function $3a8c5e52e73db19f$var$clamp(num, min, max) {
    return Math.min(Math.max(min, num), max);
}
function $3a8c5e52e73db19f$var$hexDouble(num) {
    var str = Math.round(num).toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
}

});
parcelRequire.register("kqzER", function(module, exports) {
"use strict";
module.exports = {
    "aliceblue": [
        240,
        248,
        255
    ],
    "antiquewhite": [
        250,
        235,
        215
    ],
    "aqua": [
        0,
        255,
        255
    ],
    "aquamarine": [
        127,
        255,
        212
    ],
    "azure": [
        240,
        255,
        255
    ],
    "beige": [
        245,
        245,
        220
    ],
    "bisque": [
        255,
        228,
        196
    ],
    "black": [
        0,
        0,
        0
    ],
    "blanchedalmond": [
        255,
        235,
        205
    ],
    "blue": [
        0,
        0,
        255
    ],
    "blueviolet": [
        138,
        43,
        226
    ],
    "brown": [
        165,
        42,
        42
    ],
    "burlywood": [
        222,
        184,
        135
    ],
    "cadetblue": [
        95,
        158,
        160
    ],
    "chartreuse": [
        127,
        255,
        0
    ],
    "chocolate": [
        210,
        105,
        30
    ],
    "coral": [
        255,
        127,
        80
    ],
    "cornflowerblue": [
        100,
        149,
        237
    ],
    "cornsilk": [
        255,
        248,
        220
    ],
    "crimson": [
        220,
        20,
        60
    ],
    "cyan": [
        0,
        255,
        255
    ],
    "darkblue": [
        0,
        0,
        139
    ],
    "darkcyan": [
        0,
        139,
        139
    ],
    "darkgoldenrod": [
        184,
        134,
        11
    ],
    "darkgray": [
        169,
        169,
        169
    ],
    "darkgreen": [
        0,
        100,
        0
    ],
    "darkgrey": [
        169,
        169,
        169
    ],
    "darkkhaki": [
        189,
        183,
        107
    ],
    "darkmagenta": [
        139,
        0,
        139
    ],
    "darkolivegreen": [
        85,
        107,
        47
    ],
    "darkorange": [
        255,
        140,
        0
    ],
    "darkorchid": [
        153,
        50,
        204
    ],
    "darkred": [
        139,
        0,
        0
    ],
    "darksalmon": [
        233,
        150,
        122
    ],
    "darkseagreen": [
        143,
        188,
        143
    ],
    "darkslateblue": [
        72,
        61,
        139
    ],
    "darkslategray": [
        47,
        79,
        79
    ],
    "darkslategrey": [
        47,
        79,
        79
    ],
    "darkturquoise": [
        0,
        206,
        209
    ],
    "darkviolet": [
        148,
        0,
        211
    ],
    "deeppink": [
        255,
        20,
        147
    ],
    "deepskyblue": [
        0,
        191,
        255
    ],
    "dimgray": [
        105,
        105,
        105
    ],
    "dimgrey": [
        105,
        105,
        105
    ],
    "dodgerblue": [
        30,
        144,
        255
    ],
    "firebrick": [
        178,
        34,
        34
    ],
    "floralwhite": [
        255,
        250,
        240
    ],
    "forestgreen": [
        34,
        139,
        34
    ],
    "fuchsia": [
        255,
        0,
        255
    ],
    "gainsboro": [
        220,
        220,
        220
    ],
    "ghostwhite": [
        248,
        248,
        255
    ],
    "gold": [
        255,
        215,
        0
    ],
    "goldenrod": [
        218,
        165,
        32
    ],
    "gray": [
        128,
        128,
        128
    ],
    "green": [
        0,
        128,
        0
    ],
    "greenyellow": [
        173,
        255,
        47
    ],
    "grey": [
        128,
        128,
        128
    ],
    "honeydew": [
        240,
        255,
        240
    ],
    "hotpink": [
        255,
        105,
        180
    ],
    "indianred": [
        205,
        92,
        92
    ],
    "indigo": [
        75,
        0,
        130
    ],
    "ivory": [
        255,
        255,
        240
    ],
    "khaki": [
        240,
        230,
        140
    ],
    "lavender": [
        230,
        230,
        250
    ],
    "lavenderblush": [
        255,
        240,
        245
    ],
    "lawngreen": [
        124,
        252,
        0
    ],
    "lemonchiffon": [
        255,
        250,
        205
    ],
    "lightblue": [
        173,
        216,
        230
    ],
    "lightcoral": [
        240,
        128,
        128
    ],
    "lightcyan": [
        224,
        255,
        255
    ],
    "lightgoldenrodyellow": [
        250,
        250,
        210
    ],
    "lightgray": [
        211,
        211,
        211
    ],
    "lightgreen": [
        144,
        238,
        144
    ],
    "lightgrey": [
        211,
        211,
        211
    ],
    "lightpink": [
        255,
        182,
        193
    ],
    "lightsalmon": [
        255,
        160,
        122
    ],
    "lightseagreen": [
        32,
        178,
        170
    ],
    "lightskyblue": [
        135,
        206,
        250
    ],
    "lightslategray": [
        119,
        136,
        153
    ],
    "lightslategrey": [
        119,
        136,
        153
    ],
    "lightsteelblue": [
        176,
        196,
        222
    ],
    "lightyellow": [
        255,
        255,
        224
    ],
    "lime": [
        0,
        255,
        0
    ],
    "limegreen": [
        50,
        205,
        50
    ],
    "linen": [
        250,
        240,
        230
    ],
    "magenta": [
        255,
        0,
        255
    ],
    "maroon": [
        128,
        0,
        0
    ],
    "mediumaquamarine": [
        102,
        205,
        170
    ],
    "mediumblue": [
        0,
        0,
        205
    ],
    "mediumorchid": [
        186,
        85,
        211
    ],
    "mediumpurple": [
        147,
        112,
        219
    ],
    "mediumseagreen": [
        60,
        179,
        113
    ],
    "mediumslateblue": [
        123,
        104,
        238
    ],
    "mediumspringgreen": [
        0,
        250,
        154
    ],
    "mediumturquoise": [
        72,
        209,
        204
    ],
    "mediumvioletred": [
        199,
        21,
        133
    ],
    "midnightblue": [
        25,
        25,
        112
    ],
    "mintcream": [
        245,
        255,
        250
    ],
    "mistyrose": [
        255,
        228,
        225
    ],
    "moccasin": [
        255,
        228,
        181
    ],
    "navajowhite": [
        255,
        222,
        173
    ],
    "navy": [
        0,
        0,
        128
    ],
    "oldlace": [
        253,
        245,
        230
    ],
    "olive": [
        128,
        128,
        0
    ],
    "olivedrab": [
        107,
        142,
        35
    ],
    "orange": [
        255,
        165,
        0
    ],
    "orangered": [
        255,
        69,
        0
    ],
    "orchid": [
        218,
        112,
        214
    ],
    "palegoldenrod": [
        238,
        232,
        170
    ],
    "palegreen": [
        152,
        251,
        152
    ],
    "paleturquoise": [
        175,
        238,
        238
    ],
    "palevioletred": [
        219,
        112,
        147
    ],
    "papayawhip": [
        255,
        239,
        213
    ],
    "peachpuff": [
        255,
        218,
        185
    ],
    "peru": [
        205,
        133,
        63
    ],
    "pink": [
        255,
        192,
        203
    ],
    "plum": [
        221,
        160,
        221
    ],
    "powderblue": [
        176,
        224,
        230
    ],
    "purple": [
        128,
        0,
        128
    ],
    "rebeccapurple": [
        102,
        51,
        153
    ],
    "red": [
        255,
        0,
        0
    ],
    "rosybrown": [
        188,
        143,
        143
    ],
    "royalblue": [
        65,
        105,
        225
    ],
    "saddlebrown": [
        139,
        69,
        19
    ],
    "salmon": [
        250,
        128,
        114
    ],
    "sandybrown": [
        244,
        164,
        96
    ],
    "seagreen": [
        46,
        139,
        87
    ],
    "seashell": [
        255,
        245,
        238
    ],
    "sienna": [
        160,
        82,
        45
    ],
    "silver": [
        192,
        192,
        192
    ],
    "skyblue": [
        135,
        206,
        235
    ],
    "slateblue": [
        106,
        90,
        205
    ],
    "slategray": [
        112,
        128,
        144
    ],
    "slategrey": [
        112,
        128,
        144
    ],
    "snow": [
        255,
        250,
        250
    ],
    "springgreen": [
        0,
        255,
        127
    ],
    "steelblue": [
        70,
        130,
        180
    ],
    "tan": [
        210,
        180,
        140
    ],
    "teal": [
        0,
        128,
        128
    ],
    "thistle": [
        216,
        191,
        216
    ],
    "tomato": [
        255,
        99,
        71
    ],
    "turquoise": [
        64,
        224,
        208
    ],
    "violet": [
        238,
        130,
        238
    ],
    "wheat": [
        245,
        222,
        179
    ],
    "white": [
        255,
        255,
        255
    ],
    "whitesmoke": [
        245,
        245,
        245
    ],
    "yellow": [
        255,
        255,
        0
    ],
    "yellowgreen": [
        154,
        205,
        50
    ]
};

});

parcelRequire.register("aJrFg", function(module, exports) {
"use strict";

var $3UovO = parcelRequire("3UovO");
var $7d0390f11e8dec67$var$concat = Array.prototype.concat;
var $7d0390f11e8dec67$var$slice = Array.prototype.slice;
var $7d0390f11e8dec67$var$swizzle = module.exports = function swizzle(args) {
    var results = [];
    for(var i = 0, len = args.length; i < len; i++){
        var arg = args[i];
        if ($3UovO(arg)) // http://jsperf.com/javascript-array-concat-vs-push/98
        results = $7d0390f11e8dec67$var$concat.call(results, $7d0390f11e8dec67$var$slice.call(arg));
        else results.push(arg);
    }
    return results;
};
$7d0390f11e8dec67$var$swizzle.wrap = function(fn) {
    return function() {
        return fn($7d0390f11e8dec67$var$swizzle(arguments));
    };
};

});
parcelRequire.register("3UovO", function(module, exports) {
module.exports = function isArrayish(obj) {
    if (!obj || typeof obj === "string") return false;
    return obj instanceof Array || Array.isArray(obj) || obj.length >= 0 && (obj.splice instanceof Function || Object.getOwnPropertyDescriptor(obj, obj.length - 1) && obj.constructor.name !== "String");
};

});



parcelRequire.register("j2FXN", function(module, exports) {

var $jACRj = parcelRequire("jACRj");

var $42IvR = parcelRequire("42IvR");
const $ddcec14bc39d9468$var$convert = {};
const $ddcec14bc39d9468$var$models = Object.keys($jACRj);
function $ddcec14bc39d9468$var$wrapRaw(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        return fn(args);
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
function $ddcec14bc39d9468$var$wrapRounded(fn) {
    const wrappedFn = function(...args) {
        const arg0 = args[0];
        if (arg0 === undefined || arg0 === null) return arg0;
        if (arg0.length > 1) args = arg0;
        const result = fn(args);
        // We're assuming the result is an array here.
        // see notice in conversions.js; don't use box types
        // in conversion functions.
        if (typeof result === "object") for(let len = result.length, i = 0; i < len; i++)result[i] = Math.round(result[i]);
        return result;
    };
    // Preserve .conversion property if there is one
    if ("conversion" in fn) wrappedFn.conversion = fn.conversion;
    return wrappedFn;
}
$ddcec14bc39d9468$var$models.forEach((fromModel)=>{
    $ddcec14bc39d9468$var$convert[fromModel] = {};
    Object.defineProperty($ddcec14bc39d9468$var$convert[fromModel], "channels", {
        value: $jACRj[fromModel].channels
    });
    Object.defineProperty($ddcec14bc39d9468$var$convert[fromModel], "labels", {
        value: $jACRj[fromModel].labels
    });
    const routes = $42IvR(fromModel);
    const routeModels = Object.keys(routes);
    routeModels.forEach((toModel)=>{
        const fn = routes[toModel];
        $ddcec14bc39d9468$var$convert[fromModel][toModel] = $ddcec14bc39d9468$var$wrapRounded(fn);
        $ddcec14bc39d9468$var$convert[fromModel][toModel].raw = $ddcec14bc39d9468$var$wrapRaw(fn);
    });
});
module.exports = $ddcec14bc39d9468$var$convert;

});
parcelRequire.register("jACRj", function(module, exports) {
/* MIT license */ /* eslint-disable no-mixed-operators */ 
var $kqzER = parcelRequire("kqzER");
// NOTE: conversions should only return primitive values (i.e. arrays, or
//       values that give correct `typeof` results).
//       do not use box values types (i.e. Number(), String(), etc.)
const $e42f85ab22620e72$var$reverseKeywords = {};
for (const key of Object.keys($kqzER))$e42f85ab22620e72$var$reverseKeywords[$kqzER[key]] = key;
const $e42f85ab22620e72$var$convert = {
    rgb: {
        channels: 3,
        labels: "rgb"
    },
    hsl: {
        channels: 3,
        labels: "hsl"
    },
    hsv: {
        channels: 3,
        labels: "hsv"
    },
    hwb: {
        channels: 3,
        labels: "hwb"
    },
    cmyk: {
        channels: 4,
        labels: "cmyk"
    },
    xyz: {
        channels: 3,
        labels: "xyz"
    },
    lab: {
        channels: 3,
        labels: "lab"
    },
    lch: {
        channels: 3,
        labels: "lch"
    },
    hex: {
        channels: 1,
        labels: [
            "hex"
        ]
    },
    keyword: {
        channels: 1,
        labels: [
            "keyword"
        ]
    },
    ansi16: {
        channels: 1,
        labels: [
            "ansi16"
        ]
    },
    ansi256: {
        channels: 1,
        labels: [
            "ansi256"
        ]
    },
    hcg: {
        channels: 3,
        labels: [
            "h",
            "c",
            "g"
        ]
    },
    apple: {
        channels: 3,
        labels: [
            "r16",
            "g16",
            "b16"
        ]
    },
    gray: {
        channels: 1,
        labels: [
            "gray"
        ]
    }
};
module.exports = $e42f85ab22620e72$var$convert;
// Hide .channels and .labels properties
for (const model of Object.keys($e42f85ab22620e72$var$convert)){
    if (!("channels" in $e42f85ab22620e72$var$convert[model])) throw new Error("missing channels property: " + model);
    if (!("labels" in $e42f85ab22620e72$var$convert[model])) throw new Error("missing channel labels property: " + model);
    if ($e42f85ab22620e72$var$convert[model].labels.length !== $e42f85ab22620e72$var$convert[model].channels) throw new Error("channel and label counts mismatch: " + model);
    const { channels: channels, labels: labels } = $e42f85ab22620e72$var$convert[model];
    delete $e42f85ab22620e72$var$convert[model].channels;
    delete $e42f85ab22620e72$var$convert[model].labels;
    Object.defineProperty($e42f85ab22620e72$var$convert[model], "channels", {
        value: channels
    });
    Object.defineProperty($e42f85ab22620e72$var$convert[model], "labels", {
        value: labels
    });
}
$e42f85ab22620e72$var$convert.rgb.hsl = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const min = Math.min(r, g, b);
    const max = Math.max(r, g, b);
    const delta = max - min;
    let h;
    let s;
    if (max === min) h = 0;
    else if (r === max) h = (g - b) / delta;
    else if (g === max) h = 2 + (b - r) / delta;
    else if (b === max) h = 4 + (r - g) / delta;
    h = Math.min(h * 60, 360);
    if (h < 0) h += 360;
    const l = (min + max) / 2;
    if (max === min) s = 0;
    else if (l <= 0.5) s = delta / (max + min);
    else s = delta / (2 - max - min);
    return [
        h,
        s * 100,
        l * 100
    ];
};
$e42f85ab22620e72$var$convert.rgb.hsv = function(rgb) {
    let rdif;
    let gdif;
    let bdif;
    let h;
    let s;
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const v = Math.max(r, g, b);
    const diff = v - Math.min(r, g, b);
    const diffc = function(c) {
        return (v - c) / 6 / diff + 0.5;
    };
    if (diff === 0) {
        h = 0;
        s = 0;
    } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) h = bdif - gdif;
        else if (g === v) h = 1 / 3 + rdif - bdif;
        else if (b === v) h = 2 / 3 + gdif - rdif;
        if (h < 0) h += 1;
        else if (h > 1) h -= 1;
    }
    return [
        h * 360,
        s * 100,
        v * 100
    ];
};
$e42f85ab22620e72$var$convert.rgb.hwb = function(rgb) {
    const r = rgb[0];
    const g = rgb[1];
    let b = rgb[2];
    const h = $e42f85ab22620e72$var$convert.rgb.hsl(rgb)[0];
    const w = 1 / 255 * Math.min(r, Math.min(g, b));
    b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
    return [
        h,
        w * 100,
        b * 100
    ];
};
$e42f85ab22620e72$var$convert.rgb.cmyk = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const k = Math.min(1 - r, 1 - g, 1 - b);
    const c = (1 - r - k) / (1 - k) || 0;
    const m = (1 - g - k) / (1 - k) || 0;
    const y = (1 - b - k) / (1 - k) || 0;
    return [
        c * 100,
        m * 100,
        y * 100,
        k * 100
    ];
};
function $e42f85ab22620e72$var$comparativeDistance(x, y) {
    /*
		See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
	*/ return (x[0] - y[0]) ** 2 + (x[1] - y[1]) ** 2 + (x[2] - y[2]) ** 2;
}
$e42f85ab22620e72$var$convert.rgb.keyword = function(rgb) {
    const reversed = $e42f85ab22620e72$var$reverseKeywords[rgb];
    if (reversed) return reversed;
    let currentClosestDistance = Infinity;
    let currentClosestKeyword;
    for (const keyword of Object.keys($kqzER)){
        const value = $kqzER[keyword];
        // Compute comparative distance
        const distance = $e42f85ab22620e72$var$comparativeDistance(rgb, value);
        // Check if its less, if so set as closest
        if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
        }
    }
    return currentClosestKeyword;
};
$e42f85ab22620e72$var$convert.keyword.rgb = function(keyword) {
    return $kqzER[keyword];
};
$e42f85ab22620e72$var$convert.rgb.xyz = function(rgb) {
    let r = rgb[0] / 255;
    let g = rgb[1] / 255;
    let b = rgb[2] / 255;
    // Assume sRGB
    r = r > 0.04045 ? ((r + 0.055) / 1.055) ** 2.4 : r / 12.92;
    g = g > 0.04045 ? ((g + 0.055) / 1.055) ** 2.4 : g / 12.92;
    b = b > 0.04045 ? ((b + 0.055) / 1.055) ** 2.4 : b / 12.92;
    const x = r * 0.4124 + g * 0.3576 + b * 0.1805;
    const y = r * 0.2126 + g * 0.7152 + b * 0.0722;
    const z = r * 0.0193 + g * 0.1192 + b * 0.9505;
    return [
        x * 100,
        y * 100,
        z * 100
    ];
};
$e42f85ab22620e72$var$convert.rgb.lab = function(rgb) {
    const xyz = $e42f85ab22620e72$var$convert.rgb.xyz(rgb);
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$e42f85ab22620e72$var$convert.hsl.rgb = function(hsl) {
    const h = hsl[0] / 360;
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    let t2;
    let t3;
    let val;
    if (s === 0) {
        val = l * 255;
        return [
            val,
            val,
            val
        ];
    }
    if (l < 0.5) t2 = l * (1 + s);
    else t2 = l + s - l * s;
    const t1 = 2 * l - t2;
    const rgb = [
        0,
        0,
        0
    ];
    for(let i = 0; i < 3; i++){
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) t3++;
        if (t3 > 1) t3--;
        if (6 * t3 < 1) val = t1 + (t2 - t1) * 6 * t3;
        else if (2 * t3 < 1) val = t2;
        else if (3 * t3 < 2) val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        else val = t1;
        rgb[i] = val * 255;
    }
    return rgb;
};
$e42f85ab22620e72$var$convert.hsl.hsv = function(hsl) {
    const h = hsl[0];
    let s = hsl[1] / 100;
    let l = hsl[2] / 100;
    let smin = s;
    const lmin = Math.max(l, 0.01);
    l *= 2;
    s *= l <= 1 ? l : 2 - l;
    smin *= lmin <= 1 ? lmin : 2 - lmin;
    const v = (l + s) / 2;
    const sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
    return [
        h,
        sv * 100,
        v * 100
    ];
};
$e42f85ab22620e72$var$convert.hsv.rgb = function(hsv) {
    const h = hsv[0] / 60;
    const s = hsv[1] / 100;
    let v = hsv[2] / 100;
    const hi = Math.floor(h) % 6;
    const f = h - Math.floor(h);
    const p = 255 * v * (1 - s);
    const q = 255 * v * (1 - s * f);
    const t = 255 * v * (1 - s * (1 - f));
    v *= 255;
    switch(hi){
        case 0:
            return [
                v,
                t,
                p
            ];
        case 1:
            return [
                q,
                v,
                p
            ];
        case 2:
            return [
                p,
                v,
                t
            ];
        case 3:
            return [
                p,
                q,
                v
            ];
        case 4:
            return [
                t,
                p,
                v
            ];
        case 5:
            return [
                v,
                p,
                q
            ];
    }
};
$e42f85ab22620e72$var$convert.hsv.hsl = function(hsv) {
    const h = hsv[0];
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const vmin = Math.max(v, 0.01);
    let sl;
    let l;
    l = (2 - s) * v;
    const lmin = (2 - s) * vmin;
    sl = s * vmin;
    sl /= lmin <= 1 ? lmin : 2 - lmin;
    sl = sl || 0;
    l /= 2;
    return [
        h,
        sl * 100,
        l * 100
    ];
};
// http://dev.w3.org/csswg/css-color/#hwb-to-rgb
$e42f85ab22620e72$var$convert.hwb.rgb = function(hwb) {
    const h = hwb[0] / 360;
    let wh = hwb[1] / 100;
    let bl = hwb[2] / 100;
    const ratio = wh + bl;
    let f;
    // Wh + bl cant be > 1
    if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
    }
    const i = Math.floor(6 * h);
    const v = 1 - bl;
    f = 6 * h - i;
    if ((i & 0x01) !== 0) f = 1 - f;
    const n = wh + f * (v - wh); // Linear interpolation
    let r;
    let g;
    let b;
    /* eslint-disable max-statements-per-line,no-multi-spaces */ switch(i){
        default:
        case 6:
        case 0:
            r = v;
            g = n;
            b = wh;
            break;
        case 1:
            r = n;
            g = v;
            b = wh;
            break;
        case 2:
            r = wh;
            g = v;
            b = n;
            break;
        case 3:
            r = wh;
            g = n;
            b = v;
            break;
        case 4:
            r = n;
            g = wh;
            b = v;
            break;
        case 5:
            r = v;
            g = wh;
            b = n;
            break;
    }
    /* eslint-enable max-statements-per-line,no-multi-spaces */ return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$e42f85ab22620e72$var$convert.cmyk.rgb = function(cmyk) {
    const c = cmyk[0] / 100;
    const m = cmyk[1] / 100;
    const y = cmyk[2] / 100;
    const k = cmyk[3] / 100;
    const r = 1 - Math.min(1, c * (1 - k) + k);
    const g = 1 - Math.min(1, m * (1 - k) + k);
    const b = 1 - Math.min(1, y * (1 - k) + k);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$e42f85ab22620e72$var$convert.xyz.rgb = function(xyz) {
    const x = xyz[0] / 100;
    const y = xyz[1] / 100;
    const z = xyz[2] / 100;
    let r;
    let g;
    let b;
    r = x * 3.2406 + y * -1.5372 + z * -0.4986;
    g = x * -0.9689 + y * 1.8758 + z * 0.0415;
    b = x * 0.0557 + y * -0.204 + z * 1.0570;
    // Assume sRGB
    r = r > 0.0031308 ? 1.055 * r ** (1.0 / 2.4) - 0.055 : r * 12.92;
    g = g > 0.0031308 ? 1.055 * g ** (1.0 / 2.4) - 0.055 : g * 12.92;
    b = b > 0.0031308 ? 1.055 * b ** (1.0 / 2.4) - 0.055 : b * 12.92;
    r = Math.min(Math.max(0, r), 1);
    g = Math.min(Math.max(0, g), 1);
    b = Math.min(Math.max(0, b), 1);
    return [
        r * 255,
        g * 255,
        b * 255
    ];
};
$e42f85ab22620e72$var$convert.xyz.lab = function(xyz) {
    let x = xyz[0];
    let y = xyz[1];
    let z = xyz[2];
    x /= 95.047;
    y /= 100;
    z /= 108.883;
    x = x > 0.008856 ? x ** (1 / 3) : 7.787 * x + 16 / 116;
    y = y > 0.008856 ? y ** (1 / 3) : 7.787 * y + 16 / 116;
    z = z > 0.008856 ? z ** (1 / 3) : 7.787 * z + 16 / 116;
    const l = 116 * y - 16;
    const a = 500 * (x - y);
    const b = 200 * (y - z);
    return [
        l,
        a,
        b
    ];
};
$e42f85ab22620e72$var$convert.lab.xyz = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let x;
    let y;
    let z;
    y = (l + 16) / 116;
    x = a / 500 + y;
    z = y - b / 200;
    const y2 = y ** 3;
    const x2 = x ** 3;
    const z2 = z ** 3;
    y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
    x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
    z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
    x *= 95.047;
    y *= 100;
    z *= 108.883;
    return [
        x,
        y,
        z
    ];
};
$e42f85ab22620e72$var$convert.lab.lch = function(lab) {
    const l = lab[0];
    const a = lab[1];
    const b = lab[2];
    let h;
    const hr = Math.atan2(b, a);
    h = hr * 360 / 2 / Math.PI;
    if (h < 0) h += 360;
    const c = Math.sqrt(a * a + b * b);
    return [
        l,
        c,
        h
    ];
};
$e42f85ab22620e72$var$convert.lch.lab = function(lch) {
    const l = lch[0];
    const c = lch[1];
    const h = lch[2];
    const hr = h / 360 * 2 * Math.PI;
    const a = c * Math.cos(hr);
    const b = c * Math.sin(hr);
    return [
        l,
        a,
        b
    ];
};
$e42f85ab22620e72$var$convert.rgb.ansi16 = function(args, saturation = null) {
    const [r, g, b] = args;
    let value = saturation === null ? $e42f85ab22620e72$var$convert.rgb.hsv(args)[2] : saturation; // Hsv -> ansi16 optimization
    value = Math.round(value / 50);
    if (value === 0) return 30;
    let ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
    if (value === 2) ansi += 60;
    return ansi;
};
$e42f85ab22620e72$var$convert.hsv.ansi16 = function(args) {
    // Optimization here; we already know the value and don't need to get
    // it converted for us.
    return $e42f85ab22620e72$var$convert.rgb.ansi16($e42f85ab22620e72$var$convert.hsv.rgb(args), args[2]);
};
$e42f85ab22620e72$var$convert.rgb.ansi256 = function(args) {
    const r = args[0];
    const g = args[1];
    const b = args[2];
    // We use the extended greyscale palette here, with the exception of
    // black and white. normal palette only has 4 greyscale shades.
    if (r === g && g === b) {
        if (r < 8) return 16;
        if (r > 248) return 231;
        return Math.round((r - 8) / 247 * 24) + 232;
    }
    const ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
    return ansi;
};
$e42f85ab22620e72$var$convert.ansi16.rgb = function(args) {
    let color = args % 10;
    // Handle greyscale
    if (color === 0 || color === 7) {
        if (args > 50) color += 3.5;
        color = color / 10.5 * 255;
        return [
            color,
            color,
            color
        ];
    }
    const mult = (~~(args > 50) + 1) * 0.5;
    const r = (color & 1) * mult * 255;
    const g = (color >> 1 & 1) * mult * 255;
    const b = (color >> 2 & 1) * mult * 255;
    return [
        r,
        g,
        b
    ];
};
$e42f85ab22620e72$var$convert.ansi256.rgb = function(args) {
    // Handle greyscale
    if (args >= 232) {
        const c = (args - 232) * 10 + 8;
        return [
            c,
            c,
            c
        ];
    }
    args -= 16;
    let rem;
    const r = Math.floor(args / 36) / 5 * 255;
    const g = Math.floor((rem = args % 36) / 6) / 5 * 255;
    const b = rem % 6 / 5 * 255;
    return [
        r,
        g,
        b
    ];
};
$e42f85ab22620e72$var$convert.rgb.hex = function(args) {
    const integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$e42f85ab22620e72$var$convert.hex.rgb = function(args) {
    const match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
    if (!match) return [
        0,
        0,
        0
    ];
    let colorString = match[0];
    if (match[0].length === 3) colorString = colorString.split("").map((char)=>{
        return char + char;
    }).join("");
    const integer = parseInt(colorString, 16);
    const r = integer >> 16 & 0xFF;
    const g = integer >> 8 & 0xFF;
    const b = integer & 0xFF;
    return [
        r,
        g,
        b
    ];
};
$e42f85ab22620e72$var$convert.rgb.hcg = function(rgb) {
    const r = rgb[0] / 255;
    const g = rgb[1] / 255;
    const b = rgb[2] / 255;
    const max = Math.max(Math.max(r, g), b);
    const min = Math.min(Math.min(r, g), b);
    const chroma = max - min;
    let grayscale;
    let hue;
    if (chroma < 1) grayscale = min / (1 - chroma);
    else grayscale = 0;
    if (chroma <= 0) hue = 0;
    else if (max === r) hue = (g - b) / chroma % 6;
    else if (max === g) hue = 2 + (b - r) / chroma;
    else hue = 4 + (r - g) / chroma;
    hue /= 6;
    hue %= 1;
    return [
        hue * 360,
        chroma * 100,
        grayscale * 100
    ];
};
$e42f85ab22620e72$var$convert.hsl.hcg = function(hsl) {
    const s = hsl[1] / 100;
    const l = hsl[2] / 100;
    const c = l < 0.5 ? 2.0 * s * l : 2.0 * s * (1.0 - l);
    let f = 0;
    if (c < 1.0) f = (l - 0.5 * c) / (1.0 - c);
    return [
        hsl[0],
        c * 100,
        f * 100
    ];
};
$e42f85ab22620e72$var$convert.hsv.hcg = function(hsv) {
    const s = hsv[1] / 100;
    const v = hsv[2] / 100;
    const c = s * v;
    let f = 0;
    if (c < 1.0) f = (v - c) / (1 - c);
    return [
        hsv[0],
        c * 100,
        f * 100
    ];
};
$e42f85ab22620e72$var$convert.hcg.rgb = function(hcg) {
    const h = hcg[0] / 360;
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    if (c === 0.0) return [
        g * 255,
        g * 255,
        g * 255
    ];
    const pure = [
        0,
        0,
        0
    ];
    const hi = h % 1 * 6;
    const v = hi % 1;
    const w = 1 - v;
    let mg = 0;
    /* eslint-disable max-statements-per-line */ switch(Math.floor(hi)){
        case 0:
            pure[0] = 1;
            pure[1] = v;
            pure[2] = 0;
            break;
        case 1:
            pure[0] = w;
            pure[1] = 1;
            pure[2] = 0;
            break;
        case 2:
            pure[0] = 0;
            pure[1] = 1;
            pure[2] = v;
            break;
        case 3:
            pure[0] = 0;
            pure[1] = w;
            pure[2] = 1;
            break;
        case 4:
            pure[0] = v;
            pure[1] = 0;
            pure[2] = 1;
            break;
        default:
            pure[0] = 1;
            pure[1] = 0;
            pure[2] = w;
    }
    /* eslint-enable max-statements-per-line */ mg = (1.0 - c) * g;
    return [
        (c * pure[0] + mg) * 255,
        (c * pure[1] + mg) * 255,
        (c * pure[2] + mg) * 255
    ];
};
$e42f85ab22620e72$var$convert.hcg.hsv = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    let f = 0;
    if (v > 0.0) f = c / v;
    return [
        hcg[0],
        f * 100,
        v * 100
    ];
};
$e42f85ab22620e72$var$convert.hcg.hsl = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const l = g * (1.0 - c) + 0.5 * c;
    let s = 0;
    if (l > 0.0 && l < 0.5) s = c / (2 * l);
    else if (l >= 0.5 && l < 1.0) s = c / (2 * (1 - l));
    return [
        hcg[0],
        s * 100,
        l * 100
    ];
};
$e42f85ab22620e72$var$convert.hcg.hwb = function(hcg) {
    const c = hcg[1] / 100;
    const g = hcg[2] / 100;
    const v = c + g * (1.0 - c);
    return [
        hcg[0],
        (v - c) * 100,
        (1 - v) * 100
    ];
};
$e42f85ab22620e72$var$convert.hwb.hcg = function(hwb) {
    const w = hwb[1] / 100;
    const b = hwb[2] / 100;
    const v = 1 - b;
    const c = v - w;
    let g = 0;
    if (c < 1) g = (v - c) / (1 - c);
    return [
        hwb[0],
        c * 100,
        g * 100
    ];
};
$e42f85ab22620e72$var$convert.apple.rgb = function(apple) {
    return [
        apple[0] / 65535 * 255,
        apple[1] / 65535 * 255,
        apple[2] / 65535 * 255
    ];
};
$e42f85ab22620e72$var$convert.rgb.apple = function(rgb) {
    return [
        rgb[0] / 255 * 65535,
        rgb[1] / 255 * 65535,
        rgb[2] / 255 * 65535
    ];
};
$e42f85ab22620e72$var$convert.gray.rgb = function(args) {
    return [
        args[0] / 100 * 255,
        args[0] / 100 * 255,
        args[0] / 100 * 255
    ];
};
$e42f85ab22620e72$var$convert.gray.hsl = function(args) {
    return [
        0,
        0,
        args[0]
    ];
};
$e42f85ab22620e72$var$convert.gray.hsv = $e42f85ab22620e72$var$convert.gray.hsl;
$e42f85ab22620e72$var$convert.gray.hwb = function(gray) {
    return [
        0,
        100,
        gray[0]
    ];
};
$e42f85ab22620e72$var$convert.gray.cmyk = function(gray) {
    return [
        0,
        0,
        0,
        gray[0]
    ];
};
$e42f85ab22620e72$var$convert.gray.lab = function(gray) {
    return [
        gray[0],
        0,
        0
    ];
};
$e42f85ab22620e72$var$convert.gray.hex = function(gray) {
    const val = Math.round(gray[0] / 100 * 255) & 0xFF;
    const integer = (val << 16) + (val << 8) + val;
    const string = integer.toString(16).toUpperCase();
    return "000000".substring(string.length) + string;
};
$e42f85ab22620e72$var$convert.rgb.gray = function(rgb) {
    const val = (rgb[0] + rgb[1] + rgb[2]) / 3;
    return [
        val / 255 * 100
    ];
};

});

parcelRequire.register("42IvR", function(module, exports) {

var $jACRj = parcelRequire("jACRj");
/*
	This function routes a model to all other models.

	all functions that are routed have a property `.conversion` attached
	to the returned synthetic function. This property is an array
	of strings, each with the steps in between the 'from' and 'to'
	color models (inclusive).

	conversions that are not possible simply are not included.
*/ function $2f19e0aa82c13706$var$buildGraph() {
    const graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    const models = Object.keys($jACRj);
    for(let len = models.length, i = 0; i < len; i++)graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
    };
    return graph;
}
// https://en.wikipedia.org/wiki/Breadth-first_search
function $2f19e0aa82c13706$var$deriveBFS(fromModel) {
    const graph = $2f19e0aa82c13706$var$buildGraph();
    const queue = [
        fromModel
    ]; // Unshift -> queue -> pop
    graph[fromModel].distance = 0;
    while(queue.length){
        const current = queue.pop();
        const adjacents = Object.keys($jACRj[current]);
        for(let len = adjacents.length, i = 0; i < len; i++){
            const adjacent = adjacents[i];
            const node = graph[adjacent];
            if (node.distance === -1) {
                node.distance = graph[current].distance + 1;
                node.parent = current;
                queue.unshift(adjacent);
            }
        }
    }
    return graph;
}
function $2f19e0aa82c13706$var$link(from, to) {
    return function(args) {
        return to(from(args));
    };
}
function $2f19e0aa82c13706$var$wrapConversion(toModel, graph) {
    const path = [
        graph[toModel].parent,
        toModel
    ];
    let fn = $jACRj[graph[toModel].parent][toModel];
    let cur = graph[toModel].parent;
    while(graph[cur].parent){
        path.unshift(graph[cur].parent);
        fn = $2f19e0aa82c13706$var$link($jACRj[graph[cur].parent][cur], fn);
        cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
}
module.exports = function(fromModel) {
    const graph = $2f19e0aa82c13706$var$deriveBFS(fromModel);
    const conversion = {};
    const models = Object.keys(graph);
    for(let len = models.length, i = 0; i < len; i++){
        const toModel = models[i];
        const node = graph[toModel];
        if (node.parent === null) continue;
        conversion[toModel] = $2f19e0aa82c13706$var$wrapConversion(toModel, graph);
    }
    return conversion;
};

});




parcelRequire.register("91b1s", function(module, exports) {

$parcel$export(module.exports, "validateRedirectUrl", function () { return $690cc1e5abe04d65$export$eabdc444ee87166e; });

var $dQcUe = parcelRequire("dQcUe");
const $690cc1e5abe04d65$export$eabdc444ee87166e = (url, type)=>{
    try {
        const { protocol: protocol } = new URL(url);
        const protocolRegEx = type === "mobile" ? (0, $dQcUe.mobileUriSchemeProtocolRegEx) : (0, $dQcUe.webRedirectUriProtocolRegEx);
        return protocolRegEx.test(protocol);
    } catch  {
        return false;
    }
};
const $690cc1e5abe04d65$export$6ac9a0b3ab4a632f = (url)=>{
    try {
        return new URL(url).origin === url;
    } catch  {
        return false;
    }
};

});
parcelRequire.register("dQcUe", function(module, exports) {

$parcel$export(module.exports, "emailRegEx", function () { return $a13a249204784c3c$export$bdb23a0789f9885e; });
$parcel$export(module.exports, "phoneRegEx", function () { return $a13a249204784c3c$export$205be3a4a78028e; });
$parcel$export(module.exports, "phoneInputRegEx", function () { return $a13a249204784c3c$export$3b90d915073188c; });
$parcel$export(module.exports, "usernameRegEx", function () { return $a13a249204784c3c$export$221be9ce6b96eec3; });
$parcel$export(module.exports, "webRedirectUriProtocolRegEx", function () { return $a13a249204784c3c$export$faa873956c7a1484; });
$parcel$export(module.exports, "mobileUriSchemeProtocolRegEx", function () { return $a13a249204784c3c$export$cda568c01bd42f00; });
$parcel$export(module.exports, "hexColorRegEx", function () { return $a13a249204784c3c$export$ad64c5d64b2f359b; });
$parcel$export(module.exports, "noSpaceRegEx", function () { return $a13a249204784c3c$export$14b44af55c20c1e5; });
const $a13a249204784c3c$export$bdb23a0789f9885e = /^\S+@\S+\.\S+$/;
const $a13a249204784c3c$export$205be3a4a78028e = /^\d+$/;
const $a13a249204784c3c$export$3b90d915073188c = /^\+?[\d-( )]+$/;
const $a13a249204784c3c$export$221be9ce6b96eec3 = /^[A-Z_a-z]\w*$/;
const $a13a249204784c3c$export$faa873956c7a1484 = /^https?:$/;
const $a13a249204784c3c$export$cda568c01bd42f00 = /^[a-z][\d+_a-z-]*(\.[\d+_a-z-]+)+:$/;
const $a13a249204784c3c$export$ad64c5d64b2f359b = /^#[\da-f]{3}([\da-f]{3})?$/i;
const $a13a249204784c3c$export$2586bfd81a855904 = /^\d{4}(-\d{2}){2}/;
const $a13a249204784c3c$export$14b44af55c20c1e5 = /^\S+$/;

});



parcelRequire.register("lvEG3", function(module, exports) {

$parcel$export(module.exports, "UserScope", function () { return $fa8c0be811bb021e$export$4b02c5b431f6eb78; });
/** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $fa8c0be811bb021e$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($fa8c0be811bb021e$export$1d2e82cebfd4b08 || ($fa8c0be811bb021e$export$1d2e82cebfd4b08 = {}));
var $fa8c0be811bb021e$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($fa8c0be811bb021e$export$36ba08a8e14b2df6 || ($fa8c0be811bb021e$export$36ba08a8e14b2df6 = {}));
var $fa8c0be811bb021e$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($fa8c0be811bb021e$export$4b02c5b431f6eb78 || ($fa8c0be811bb021e$export$4b02c5b431f6eb78 = {}));
const $fa8c0be811bb021e$export$f57bb8dda2a18319 = Object.freeze({
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Profile]: [
        "name",
        "picture",
        "username"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Email]: [
        "email",
        "email_verified"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Phone]: [
        "phone_number",
        "phone_number_verified"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Roles]: [
        "roles"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Organizations]: [
        "organizations"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.OrganizationRoles]: [
        "organization_roles"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.CustomData]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Identities]: []
});
const $fa8c0be811bb021e$export$c11d5a3385aa71dd = Object.freeze({
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Profile]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Email]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Phone]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Roles]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Organizations]: [
        "organization_data"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.CustomData]: [
        "custom_data"
    ],
    [$fa8c0be811bb021e$export$4b02c5b431f6eb78.Identities]: [
        "identities"
    ]
});
const $fa8c0be811bb021e$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($fa8c0be811bb021e$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$fa8c0be811bb021e$export$f57bb8dda2a18319[current],
            ...$fa8c0be811bb021e$export$c11d5a3385aa71dd[current]
        ]
    ])));
const $fa8c0be811bb021e$export$fc38cc6da79faa5c = "urn:logto:organization:";
const $fa8c0be811bb021e$export$22667c0b6b2d7fac = (organizationId)=>`${$fa8c0be811bb021e$export$fc38cc6da79faa5c}${organizationId}`;
const $fa8c0be811bb021e$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($fa8c0be811bb021e$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($fa8c0be811bb021e$export$fc38cc6da79faa5c.length);
};

});

parcelRequire.register("gKqYh", function(module, exports) {
parcelRequire("jyES9");

});
parcelRequire.register("jyES9", function(module, exports) {
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
// Use lowercase letters for tenant IDs to improve compatibility
const $e3d0e5b618c874c7$var$generateTenantId = ()=>(0, $jKlLV.generateStandardId)(6);
const $e3d0e5b618c874c7$export$ac26273771c70863 = (databaseName, tenantId = $e3d0e5b618c874c7$var$generateTenantId())=>{
    const parentRole = `logto_tenant_${databaseName}`;
    const role = `logto_tenant_${databaseName}_${tenantId}`;
    const password = (0, $jKlLV.generateStandardId)(32);
    return {
        id: tenantId,
        parentRole: parentRole,
        role: role,
        password: password
    };
};

});


parcelRequire.register("6A6hX", function(module, exports) {

$parcel$export(module.exports, "httpCodeToMessage", function () { return $4caafbafa14be1f7$export$fd24084cc418abf6; });
const $4caafbafa14be1f7$export$fd24084cc418abf6 = Object.freeze({
    200: "OK",
    201: "Created",
    202: "Accepted",
    203: "Non-Authoritative Information",
    204: "No Content",
    205: "Reset Content",
    206: "Partial Content",
    300: "Multiple Choices",
    301: "Moved Permanently",
    302: "Found",
    303: "See Other",
    304: "Not Modified",
    305: "Use Proxy",
    306: "Unused",
    307: "Temporary Redirect",
    400: "Bad Request",
    401: "Unauthorized",
    402: "Payment Required",
    403: "Forbidden",
    404: "Not Found",
    405: "Method Not Allowed",
    406: "Not Acceptable",
    407: "Proxy Authentication Required",
    408: "Request Timeout",
    409: "Conflict",
    410: "Gone",
    411: "Length Required",
    412: "Precondition Required",
    413: "Request Entry Too Large",
    414: "Request-URI Too Long",
    415: "Unsupported Media Type",
    416: "Requested Range Not Satisfiable",
    417: "Expectation Failed",
    418: "I'm a teapot",
    422: "Unprocessable Content",
    429: "Too Many Requests",
    500: "Internal Server Error",
    501: "Not Implemented",
    502: "Bad Gateway",
    503: "Service Unavailable",
    504: "Gateway Timeout",
    505: "HTTP Version Not Supported"
});

});

parcelRequire.register("311RW", function(module, exports) {

$parcel$export(module.exports, "passwordPolicyGuard", function () { return $2322ea43001a40db$export$5fffa90e2e38377b; });
$parcel$export(module.exports, "PasswordPolicyChecker", function () { return $2322ea43001a40db$export$d2f225c121fa68bd; });

var $2CYkO = parcelRequire("2CYkO");
const $2322ea43001a40db$export$5fffa90e2e38377b = (0, $2CYkO.z).object({
    length: (0, $2CYkO.z).object({
        min: (0, $2CYkO.z).number().int().min(1).default(8),
        max: (0, $2CYkO.z).number().int().min(1).default(256)
    }).default({}),
    characterTypes: (0, $2CYkO.z).object({
        min: (0, $2CYkO.z).number().int().min(1).max(4).optional().default(1)
    }).default({}),
    rejects: (0, $2CYkO.z).object({
        pwned: (0, $2CYkO.z).boolean().default(true),
        repetitionAndSequence: (0, $2CYkO.z).boolean().default(true),
        userInfo: (0, $2CYkO.z).boolean().default(true),
        words: (0, $2CYkO.z).string().array().default([])
    }).default({})
});
/**
 * The class for checking if a password meets the policy. The policy is defined as
 * {@link PasswordPolicy}.
 *
 * @example
 * ```ts
 * const checker = new PasswordPolicyChecker({
 *   length: { min: 8, max: 256 },
 *   characterTypes: { min: 2 },
 *   rejects: { pwned: true, repetitionAndSequence: true, words: [] },
 * });
 *
 * const issues = await checker.check('123456');
 * console.log(issues);
 * // [
 * //   { code: 'password_rejected.too_short' },
 * //   { code: 'password_rejected.character_types', interpolation: { min: 2 } },
 * //   { code: 'password_rejected.pwned' },
 * //   { code: 'password_rejected.restricted.sequence' },
 * // ]
 * ```
 */ class $2322ea43001a40db$export$d2f225c121fa68bd {
    static #_ = (()=>{
        this.symbols = Object.freeze("!\"#$%&'()*+,-./:;<=>?@[\\]^_`{|}~ ");
    })();
    static #_1 = (()=>{
        this.sequence = Object.freeze([
            "0123456789",
            "abcdefghijklmnopqrstuvwxyz",
            "qwertyuiop",
            "asdfghjkl",
            "zxcvbnm",
            "1qaz",
            "2wsx",
            "3edc",
            "4rfv",
            "5tgb",
            "6yhn",
            "7ujm",
            "8ik",
            "9ol"
        ]);
    })();
    static #_2 = (()=>{
        this.repetitionAndSequenceThreshold = 3;
    })();
    static #_3 = (()=>{
        this.restrictedPhrasesTolerance = 3;
    })();
    /** Get the length threshold for checking restricted phrases. */ static getRestrictedPhraseThreshold(password) {
        const { restrictedPhrasesTolerance: restrictedPhrasesTolerance } = $2322ea43001a40db$export$d2f225c121fa68bd;
        return Math.max(1, password.length - restrictedPhrasesTolerance);
    }
    constructor(policy, /** The Web Crypto API to use. By default, the global `crypto.subtle` will be used. */ subtle = crypto.subtle){
        this.subtle = subtle;
        this.policy = $2322ea43001a40db$export$5fffa90e2e38377b.parse(policy);
    }
    /**
     * Check if a password meets all the policy requirements.
     *
     * @param password - Password to check.
     * @param userInfo - User information to check. Required if the policy
     * requires to reject passwords that include user information.
     * @returns An array of issues. If the password meets the policy, an empty array will be returned.
     * @throws TypeError - If the policy requires to reject passwords that include user information
     * but the user information is not provided.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ async check(password, userInfo) {
        const issues = this.fastCheck(password);
        if (this.policy.rejects.pwned && await this.hasBeenPwned(password)) issues.push({
            code: "password_rejected.pwned"
        });
        // `hashArray[i]` indicates whether the `i`th character violates the restriction.
        // We'll gradually set the value to `1` if needed.
        // The algorithm time complexity should be O(n^2), but it's fast enough for a password.
        const hashArray = Array.from({
            length: password.length
        }).fill(0);
        const issueCodes = new Set();
        const { repetitionAndSequence: repetitionAndSequence, words: words, userInfo: rejectUserInfo } = this.policy.rejects;
        const rejectWords = words.length > 0;
        const fillHashArray = (startIndex, length, code)=>{
            if (length <= 0) return;
            for(let i = startIndex; i < startIndex + length; i += 1)hashArray[i] = 1;
            issueCodes.add(code);
        };
        for(let i = 0; i < password.length; i += 1){
            const sliced = password.slice(i);
            if (repetitionAndSequence) {
                fillHashArray(i, this.repetitionLength(sliced), "restricted.repetition");
                fillHashArray(i, this.sequenceLength(sliced), "restricted.sequence");
            }
            if (rejectWords) fillHashArray(i, this.wordLength(sliced), "restricted.words");
            if (rejectUserInfo) {
                if (!userInfo) throw new TypeError("User information data is required to check user information.");
                fillHashArray(i, this.userInfoLength(sliced, userInfo), "restricted.user_info");
            }
        }
        return hashArray.reduce((total, current)=>total + current, 0) > $2322ea43001a40db$export$d2f225c121fa68bd.getRestrictedPhraseThreshold(password) ? [
            ...issues,
            ...[
                ...issueCodes
            ].map((code)=>({
                    code: `password_rejected.${code}`
                }))
        ] : issues;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods */ /**
     * Perform a fast check to see if the password passes the basic requirements.
     * Only the length and character types will be checked.
     *
     * This method is used for frontend validation.
     *
     * @param password - Password to check.
     * @returns Whether the password passes the basic requirements.
     */ /* eslint-disable @silverhand/fp/no-mutating-methods */ fastCheck(password) {
        const issues = [];
        if (password.length < this.policy.length.min) issues.push({
            code: "password_rejected.too_short",
            interpolation: {
                min: this.policy.length.min
            }
        });
        else if (password.length > this.policy.length.max) issues.push({
            code: "password_rejected.too_long",
            interpolation: {
                max: this.policy.length.max
            }
        });
        const characterTypes = this.checkCharTypes(password);
        if (characterTypes === "unsupported") issues.push({
            code: "password_rejected.unsupported_characters"
        });
        else if (!characterTypes) issues.push({
            code: "password_rejected.character_types",
            interpolation: {
                min: this.policy.characterTypes.min
            }
        });
        return issues;
    }
    /* eslint-enable @silverhand/fp/no-mutating-methods */ /**
     * Check if the given password contains enough character types.
     *
     * @param password - Password to check.
     * @returns Whether the password contains enough character types; or `'unsupported'`
     * if the password contains unsupported characters.
     */ checkCharTypes(password) {
        const characterTypes = new Set();
        for (const char of password){
            if (char >= "a" && char <= "z") characterTypes.add("lowercase");
            else if (char >= "A" && char <= "Z") characterTypes.add("uppercase");
            else if (char >= "0" && char <= "9") characterTypes.add("digits");
            else if ($2322ea43001a40db$export$d2f225c121fa68bd.symbols.includes(char)) characterTypes.add("symbols");
            else return "unsupported";
        }
        return characterTypes.size >= this.policy.characterTypes.min;
    }
    /**
     * Check if the given password has been pwned.
     *
     * @param password - Password to check.
     * @returns Whether the password has been pwned.
     */ async hasBeenPwned(password) {
        const hash = await this.subtle.digest("SHA-1", new TextEncoder().encode(password));
        const hashHex = Array.from(new Uint8Array(hash)).map((binary)=>binary.toString(16).padStart(2, "0")).join("");
        const hashPrefix = hashHex.slice(0, 5);
        const hashSuffix = hashHex.slice(5);
        const response = await fetch(`https://api.pwnedpasswords.com/range/${hashPrefix}`);
        const text = await response.text();
        const hashes = text.split("\n");
        const found = hashes.some((hex)=>hex.toLowerCase().startsWith(hashSuffix));
        return found;
    }
    /**
     * Get the length of the repetition at the beginning of the given string.
     * For example, `repetitionLength('aaaaa')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ repetitionLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $2322ea43001a40db$export$d2f225c121fa68bd;
        const firstChar = password[0];
        let length = 0;
        if (firstChar === undefined) return 0;
        for (const char of password){
            if (char === firstChar) length += 1;
            else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the user information at the beginning of the given string.
     * For example, `userInfoLength('silverhand', { username: 'silverhand' })` will return `10`.
     *
     * For multiple matches, the longest length will be returned.
     */ // eslint-disable-next-line complexity
    userInfoLength(password, userInfo) {
        const lowercased = password.toLowerCase();
        const { name: name, username: username, email: email, phoneNumber: phoneNumber } = userInfo;
        // eslint-disable-next-line @silverhand/fp/no-let
        let length = 0;
        const updateLength = (newLength)=>{
            if (newLength > length) // eslint-disable-next-line @silverhand/fp/no-mutation
            length = newLength;
        };
        if (name) {
            const joined = name.replaceAll(/\s+/g, "");
            // The original name should be the longest string, so we check it first.
            if (lowercased.startsWith(name.toLowerCase())) updateLength(name.length);
            else {
                if (lowercased.startsWith(joined.toLowerCase())) updateLength(joined.length);
                for (const word of name.split(" "))if (lowercased.startsWith(word.toLowerCase())) updateLength(word.length);
            }
        }
        if (username && lowercased.startsWith(username.toLowerCase())) updateLength(username.length);
        if (email) {
            const emailPrefix = email.split("@")[0];
            if (emailPrefix && lowercased.startsWith(emailPrefix.toLowerCase())) updateLength(emailPrefix.length);
        }
        if (phoneNumber && lowercased.startsWith(phoneNumber)) updateLength(phoneNumber.length);
        return length;
    }
    /**
     * Get the length of the word that matches the word list at the beginning of the given string.
     *
     * For multiple matches, the longest length will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ wordLength(password) {
        const sliced = password.toLowerCase();
        let length = 0;
        for (const word of this.policy.rejects.words)if (sliced.startsWith(word.toLowerCase()) && word.length > length) length = word.length;
        return length;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Get the length of the sequence at the beginning of the given string.
     * For example, `sequenceLength('12345')` will return `5`.
     *
     * If the length is less than {@link PasswordPolicyChecker.repetitionAndSequenceThreshold},
     * `0` will be returned.
     */ /* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ sequenceLength(password) {
        const { repetitionAndSequenceThreshold: repetitionAndSequenceThreshold } = $2322ea43001a40db$export$d2f225c121fa68bd;
        let value = "";
        let length = 0;
        for (const char of password){
            if (!value || this.isSequential(value + char)) {
                value += char;
                length += 1;
            } else break;
        }
        return length >= repetitionAndSequenceThreshold ? length : 0;
    }
    /* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ /**
     * Check if the given string is sequential by iterating through the {@link PasswordPolicyChecker.sequence}.
     */ isSequential(value) {
        const { sequence: sequence } = $2322ea43001a40db$export$d2f225c121fa68bd;
        for (const seq of sequence){
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods -- created a new array before mutating
            const reversedSeq = [
                ...seq
            ].reverse().join("");
            if ([
                seq,
                reversedSeq,
                seq.toUpperCase(),
                reversedSeq.toUpperCase()
            ].some((item)=>item.includes(value))) return true;
        }
        return false;
    }
}

});



parcelRequire.register("eyD2M", function(module, exports) {

$parcel$export(module.exports, "oidcModelInstancePayloadGuard", function () { return $a99286f1b663e6d7$export$525df20e0fb1714c; });
$parcel$export(module.exports, "oidcClientMetadataGuard", function () { return $a99286f1b663e6d7$export$2b5eeb3c40bff26b; });
$parcel$export(module.exports, "customClientMetadataGuard", function () { return $a99286f1b663e6d7$export$44618fabe8266610; });
parcelRequire("8Hfh4");
var $91b1s = parcelRequire("91b1s");

var $2CYkO = parcelRequire("2CYkO");
const $a99286f1b663e6d7$export$525df20e0fb1714c = (0, $2CYkO.z).object({
    userCode: (0, $2CYkO.z).string().optional(),
    uid: (0, $2CYkO.z).string().optional(),
    grantId: (0, $2CYkO.z).string().optional()
})/**
     * Try to use `.passthrough()` if type has been fixed.
     * https://github.com/colinhacks/zod/issues/452
     */ .catchall((0, $2CYkO.z).unknown());
const $a99286f1b663e6d7$export$2b5eeb3c40bff26b = (0, $2CYkO.z).object({
    redirectUris: (0, $2CYkO.z).string().refine((url)=>(0, $91b1s.validateRedirectUrl)(url, "web")).or((0, $2CYkO.z).string().refine((url)=>(0, $91b1s.validateRedirectUrl)(url, "mobile"))).array(),
    postLogoutRedirectUris: (0, $2CYkO.z).string().url().array(),
    logoUri: (0, $2CYkO.z).string().optional()
});
var $a99286f1b663e6d7$export$35a50069c63f27cc;
(function(CustomClientMetadataKey) {
    CustomClientMetadataKey["CorsAllowedOrigins"] = "corsAllowedOrigins";
    CustomClientMetadataKey["IdTokenTtl"] = "idTokenTtl";
    /** @deprecated Use {@link RefreshTokenTtlInDays} instead. */ CustomClientMetadataKey["RefreshTokenTtl"] = "refreshTokenTtl";
    CustomClientMetadataKey["RefreshTokenTtlInDays"] = "refreshTokenTtlInDays";
    CustomClientMetadataKey["TenantId"] = "tenantId";
    /**
     * Enabling this configuration will allow Logto to always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request.
     *
     * It only works for web applications when the client allowed grant types includes `refresh_token`.
     *
     * This config is for the third-party integrations that do not strictly follow OpenID Connect standards due to some reasons (e.g. they only know OAuth, but requires a Refresh Token to be returned anyway).
     */ CustomClientMetadataKey["AlwaysIssueRefreshToken"] = "alwaysIssueRefreshToken";
    /**
     * When enabled (default), Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed.
     *
     * It can be turned off for only traditional web apps for enhanced security.
     */ CustomClientMetadataKey["RotateRefreshToken"] = "rotateRefreshToken";
})($a99286f1b663e6d7$export$35a50069c63f27cc || ($a99286f1b663e6d7$export$35a50069c63f27cc = {}));
const $a99286f1b663e6d7$export$44618fabe8266610 = (0, $2CYkO.z).object({
    [$a99286f1b663e6d7$export$35a50069c63f27cc.CorsAllowedOrigins]: (0, $2CYkO.z).string().min(1).array().optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.IdTokenTtl]: (0, $2CYkO.z).number().optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.RefreshTokenTtl]: (0, $2CYkO.z).number().optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.RefreshTokenTtlInDays]: (0, $2CYkO.z).number().int().min(1).max(90).optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.TenantId]: (0, $2CYkO.z).string().optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.AlwaysIssueRefreshToken]: (0, $2CYkO.z).boolean().optional(),
    [$a99286f1b663e6d7$export$35a50069c63f27cc.RotateRefreshToken]: (0, $2CYkO.z).boolean().optional()
});

});

parcelRequire.register("2r8y8", function(module, exports) {

$parcel$export(module.exports, "translationGuard", function () { return $1c64bc2d4624755e$export$aea1b2a91583fcef; });

var $2CYkO = parcelRequire("2CYkO");
const $1c64bc2d4624755e$export$aea1b2a91583fcef = (0, $2CYkO.z).lazy(()=>(0, $2CYkO.z).record((0, $2CYkO.z).string().or($1c64bc2d4624755e$export$aea1b2a91583fcef)));

});

parcelRequire.register("bd0Y0", function(module, exports) {

$parcel$export(module.exports, "colorGuard", function () { return $8291a897e5bb886c$export$5c91807cab7a8dc1; });
$parcel$export(module.exports, "brandingGuard", function () { return $8291a897e5bb886c$export$c9d0acdc98ac45b; });
$parcel$export(module.exports, "languageInfoGuard", function () { return $8291a897e5bb886c$export$b8fe26243f8b3b37; });
$parcel$export(module.exports, "SignInIdentifier", function () { return $8291a897e5bb886c$export$f2322d76aef584c7; });
$parcel$export(module.exports, "signUpGuard", function () { return $8291a897e5bb886c$export$fd48acc070c38d7b; });
$parcel$export(module.exports, "signInGuard", function () { return $8291a897e5bb886c$export$8665c7c0edac5e7a; });
$parcel$export(module.exports, "connectorTargetsGuard", function () { return $8291a897e5bb886c$export$276d424b39387296; });
$parcel$export(module.exports, "customContentGuard", function () { return $8291a897e5bb886c$export$7dfc08c51ef177a5; });
$parcel$export(module.exports, "MfaFactor", function () { return $8291a897e5bb886c$export$c62e7669a75c5961; });
$parcel$export(module.exports, "MfaPolicy", function () { return $8291a897e5bb886c$export$da22c5f01b0bc81; });
$parcel$export(module.exports, "mfaGuard", function () { return $8291a897e5bb886c$export$74899fc35c1207c8; });
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");
parcelRequire("66B2B");
var $dMkQh = parcelRequire("dMkQh");

var $2CYkO = parcelRequire("2CYkO");
const $8291a897e5bb886c$export$5c91807cab7a8dc1 = (0, $2CYkO.z).object({
    primaryColor: (0, $2CYkO.z).string().regex((0, $dQcUe.hexColorRegEx)),
    isDarkModeEnabled: (0, $2CYkO.z).boolean(),
    darkPrimaryColor: (0, $2CYkO.z).string().regex((0, $dQcUe.hexColorRegEx))
});
const $8291a897e5bb886c$export$c9d0acdc98ac45b = (0, $2CYkO.z).object({
    logoUrl: (0, $2CYkO.z).string().url().optional(),
    darkLogoUrl: (0, $2CYkO.z).string().url().optional(),
    favicon: (0, $2CYkO.z).string().url().optional()
});
const $8291a897e5bb886c$export$b8fe26243f8b3b37 = (0, $2CYkO.z).object({
    autoDetect: (0, $2CYkO.z).boolean(),
    fallbackLanguage: (0, $dMkQh.languageTagGuard)
});
var $8291a897e5bb886c$export$f2322d76aef584c7;
(function(SignInIdentifier) {
    SignInIdentifier["Username"] = "username";
    SignInIdentifier["Email"] = "email";
    SignInIdentifier["Phone"] = "phone";
})($8291a897e5bb886c$export$f2322d76aef584c7 || ($8291a897e5bb886c$export$f2322d76aef584c7 = {}));
const $8291a897e5bb886c$export$fd48acc070c38d7b = (0, $2CYkO.z).object({
    identifiers: (0, $2CYkO.z).nativeEnum($8291a897e5bb886c$export$f2322d76aef584c7).array(),
    password: (0, $2CYkO.z).boolean(),
    verify: (0, $2CYkO.z).boolean()
});
const $8291a897e5bb886c$export$8665c7c0edac5e7a = (0, $2CYkO.z).object({
    methods: (0, $2CYkO.z).object({
        identifier: (0, $2CYkO.z).nativeEnum($8291a897e5bb886c$export$f2322d76aef584c7),
        password: (0, $2CYkO.z).boolean(),
        verificationCode: (0, $2CYkO.z).boolean(),
        isPasswordPrimary: (0, $2CYkO.z).boolean()
    }).array()
});
const $8291a897e5bb886c$export$276d424b39387296 = (0, $2CYkO.z).string().array();
const $8291a897e5bb886c$export$7dfc08c51ef177a5 = (0, $2CYkO.z).record((0, $2CYkO.z).string());
var $8291a897e5bb886c$export$c62e7669a75c5961;
(function(MfaFactor) {
    MfaFactor["TOTP"] = "Totp";
    MfaFactor["WebAuthn"] = "WebAuthn";
    MfaFactor["BackupCode"] = "BackupCode";
})($8291a897e5bb886c$export$c62e7669a75c5961 || ($8291a897e5bb886c$export$c62e7669a75c5961 = {}));
const $8291a897e5bb886c$export$10c80e60471dfbfa = (0, $2CYkO.z).nativeEnum($8291a897e5bb886c$export$c62e7669a75c5961).array();
var $8291a897e5bb886c$export$da22c5f01b0bc81;
(function(MfaPolicy) {
    MfaPolicy["UserControlled"] = "UserControlled";
    MfaPolicy["Mandatory"] = "Mandatory";
})($8291a897e5bb886c$export$da22c5f01b0bc81 || ($8291a897e5bb886c$export$da22c5f01b0bc81 = {}));
const $8291a897e5bb886c$export$74899fc35c1207c8 = (0, $2CYkO.z).object({
    factors: $8291a897e5bb886c$export$10c80e60471dfbfa,
    policy: (0, $2CYkO.z).nativeEnum($8291a897e5bb886c$export$da22c5f01b0bc81)
});

});
parcelRequire.register("66B2B", function(module, exports) {
$parcel$export(module.exports, "languages", function () { return (parcelRequire("3nY0n")).languages; });
$parcel$export(module.exports, "fallback", function () { return (parcelRequire("dMkQh")).fallback; });
$parcel$export(module.exports, "isLanguageTag", function () { return (parcelRequire("dMkQh")).isLanguageTag; });
$parcel$export(module.exports, "languageTagGuard", function () { return (parcelRequire("dMkQh")).languageTagGuard; });
parcelRequire("3nY0n");
parcelRequire("3fGAq");
parcelRequire("dMkQh");

});
parcelRequire.register("3nY0n", function(module, exports) {

$parcel$export(module.exports, "languages", function () { return $277210dad40603a1$export$d0d68bb9ed2c643d; });
const $277210dad40603a1$export$d0d68bb9ed2c643d = Object.freeze({
    "af-ZA": "Afrikaans",
    "am-ET": "አማርኛ",
    "ar-AR": "العربية",
    "as-IN": "অসমীয়া",
    "az-AZ": "Azərbaycan dili",
    "be-BY": "Беларуская",
    "bg-BG": "Български",
    "bn-IN": "বাংলা",
    "br-FR": "Brezhoneg",
    "bs-BA": "Bosanski",
    "ca-ES": "Catal\xe0",
    "cb-IQ": "کوردیی ناوەندی",
    "co-FR": "Corsu",
    "cs-CZ": "Čeština",
    "cx-PH": "Bisaya",
    "cy-GB": "Cymraeg",
    "da-DK": "Dansk",
    de: "Deutsch",
    "de-DE": "Deutsch (Deutschland)",
    "el-GR": "Ελληνικά",
    en: "English",
    "en-GB": "English (UK)",
    "en-US": "English (US)",
    "eo-EO": "Esperanto",
    es: "Espa\xf1ol",
    "es-ES": "Espa\xf1ol (Espa\xf1a)",
    "es-419": "Espa\xf1ol (Latinoam\xe9rica)",
    "et-EE": "Eesti",
    "eu-ES": "Euskara",
    "fa-IR": "فارسی",
    "ff-NG": "Fula",
    "fi-FI": "Suomi",
    "fo-FO": "F\xf8royskt",
    fr: "Fran\xe7ais",
    "fr-CA": "Fran\xe7ais (Canada)",
    "fr-FR": "Fran\xe7ais (France)",
    "fy-NL": "Frysk",
    "ga-IE": "Gaeilge",
    "gl-ES": "Galego",
    "gn-PY": "Guarani",
    "gu-IN": "ગુજરાતી",
    "ha-NG": "Hausa",
    "he-IL": "עברית",
    "hi-IN": "हिन्दी",
    "hr-HR": "Hrvatski",
    "ht-HT": "Krey\xf2l Ayisyen",
    "hu-HU": "Magyar",
    "hy-AM": "Հայերեն",
    "id-ID": "Bahasa Indonesia",
    "ik-US": "I\xf1upiatun",
    "is-IS": "\xcdslenska",
    it: "Italiano",
    "it-IT": "Italiano (Italia)",
    "iu-CA": "Inuktitut",
    ja: "日本語",
    "ja-JP": "日本語",
    "ja-KS": "日本語(関西)",
    "jv-ID": "Basa Jawa",
    "ka-GE": "ქართული",
    "kk-KZ": "Қазақша",
    "km-KH": "ភាសាខ្មែរ",
    "kn-IN": "ಕನ್ನಡ",
    ko: "한국어",
    "ko-KR": "한국어",
    "ku-TR": "Kurd\xee (Kurmanc\xee)",
    "ky-KG": "кыргызча",
    "lo-LA": "ພາສາລາວ",
    "lt-LT": "Lietuvių",
    "lv-LV": "Latviešu",
    "mg-MG": "Malagasy",
    "mk-MK": "Македонски",
    "ml-IN": "മലയാളം",
    "mn-MN": "Монгол",
    "mr-IN": "मराठी",
    "ms-MY": "Bahasa Melayu",
    "mt-MT": "Malti",
    "my-MM": "မြန်မာဘာသာ",
    "nb-NO": "Norsk (bokm\xe5l)",
    "ne-NP": "नेपाली",
    "nl-BE": "Vlaams",
    "nl-NL": "Nederlands",
    "nn-NO": "Norsk (nynorsk)",
    "or-IN": "ଓଡ଼ିଆ",
    "pa-IN": "ਪੰਜਾਬੀ",
    "pl-PL": "Polski",
    "ps-AF": "پښتو",
    pt: "portugu\xeas",
    "pt-BR": "Portugu\xeas (Brasil)",
    "pt-PT": "Portugu\xeas (Portugal)",
    "ro-RO": "Rom\xe2nă",
    ru: "Русский",
    "ru-RU": "Русский",
    "rw-RW": "Ikinyarwanda",
    "sc-IT": "Sardu",
    "si-LK": "සිංහල",
    "sk-SK": "Slovenčina",
    "sl-SI": "Slovenščina",
    "sn-ZW": "Shona",
    "sq-AL": "Shqip",
    "sr-RS": "Српски",
    "sv-SE": "Svenska",
    "sw-KE": "Kiswahili",
    "sy-SY": "ܣܘܪܝܝܐ",
    "sz-PL": "ślōnskŏ gŏdka",
    "ta-IN": "தமிழ்",
    "te-IN": "తెలుగు",
    "tg-TJ": "Тоҷикӣ",
    "th-TH": "ภาษาไทย",
    "tl-PH": "Filipino",
    tr: "T\xfcrk\xe7e",
    "tr-TR": "T\xfcrk\xe7e",
    "tt-RU": "Татарча",
    "tz-MA": "ⵜⴰⵎⴰⵣⵉⵖⵜ",
    "uk-UA": "Українська",
    "ur-PK": "اردو",
    "uz-UZ": "O'zbek",
    "vi-VN": "Tiếng Việt",
    zh: "中文",
    "zh-CN": "简体中文",
    "zh-HK": "繁體中文（香港）",
    "zh-MO": "繁體中文（澳門）",
    "zh-TW": "繁體中文（台灣）",
    "zz-TR": "Zaza"
});

});

parcelRequire.register("3fGAq", function(module, exports) {

});

parcelRequire.register("dMkQh", function(module, exports) {

$parcel$export(module.exports, "isLanguageTag", function () { return $a07fecddf1041c3a$export$ab649249f0bfeb57; });
$parcel$export(module.exports, "languageTagGuard", function () { return $a07fecddf1041c3a$export$2b8b19a59fcec1e6; });
$parcel$export(module.exports, "fallback", function () { return $a07fecddf1041c3a$export$bcd1dd1f397bba12; });

var $2CYkO = parcelRequire("2CYkO");

var $3nY0n = parcelRequire("3nY0n");
const $a07fecddf1041c3a$export$ab649249f0bfeb57 = (value)=>typeof value === "string" && value in (0, $3nY0n.languages);
const $a07fecddf1041c3a$export$2b8b19a59fcec1e6 = (0, $2CYkO.z).any().refine((value)=>$a07fecddf1041c3a$export$ab649249f0bfeb57(value));
function $a07fecddf1041c3a$export$bcd1dd1f397bba12(value) {
    return (0, $2CYkO.any)().transform(()=>value);
}

});



parcelRequire.register("jMgxv", function(module, exports) {

$parcel$export(module.exports, "sentinelActivityTargetTypeGuard", function () { return $e65f546647b496b1$export$47228912e855c2e6; });
$parcel$export(module.exports, "sentinelActivityActionGuard", function () { return $e65f546647b496b1$export$8cdcc536cbf8daf0; });
$parcel$export(module.exports, "sentinelActivityPayloadGuard", function () { return $e65f546647b496b1$export$ef3e193200f88c05; });

var $2CYkO = parcelRequire("2CYkO");
var $e65f546647b496b1$export$f6585a37d5516193;
(function(SentinelActivityTargetType) {
    SentinelActivityTargetType["User"] = "User";
    SentinelActivityTargetType["App"] = "App";
})($e65f546647b496b1$export$f6585a37d5516193 || ($e65f546647b496b1$export$f6585a37d5516193 = {}));
const $e65f546647b496b1$export$47228912e855c2e6 = (0, $2CYkO.z).nativeEnum($e65f546647b496b1$export$f6585a37d5516193);
var $e65f546647b496b1$export$e4c510688679a019;
(function(SentinelActivityAction) {
    /**
     * The subject tries to pass a verification by inputting a password.
     *
     * For example, a user (subject) who inputted a password (action) to authenticate themselves
     * (target).
     */ SentinelActivityAction["Password"] = "Password";
    /**
     * The subject tries to pass a verification by inputting a verification code.
     *
     * For example, a user (subject) who inputted a verification code (action) to authenticate
     * themselves (target).
     */ SentinelActivityAction["VerificationCode"] = "VerificationCode";
})($e65f546647b496b1$export$e4c510688679a019 || ($e65f546647b496b1$export$e4c510688679a019 = {}));
const $e65f546647b496b1$export$8cdcc536cbf8daf0 = (0, $2CYkO.z).nativeEnum($e65f546647b496b1$export$e4c510688679a019);
const $e65f546647b496b1$export$ef3e193200f88c05 = (0, $2CYkO.z).record((0, $2CYkO.z).unknown());

});

parcelRequire.register("8AotL", function(module, exports) {

$parcel$export(module.exports, "identitiesGuard", function () { return $6404ac89b3179130$export$9240af6bda06dde7; });
$parcel$export(module.exports, "webAuthnTransportGuard", function () { return $6404ac89b3179130$export$aa941865a0228ea6; });
$parcel$export(module.exports, "mfaVerificationsGuard", function () { return $6404ac89b3179130$export$cd58e15effbd05b2; });

var $2CYkO = parcelRequire("2CYkO");

var $bd0Y0 = parcelRequire("bd0Y0");
const $6404ac89b3179130$export$5b0e1cc5f5293c3b = (0, $2CYkO.z).string().array();
const $6404ac89b3179130$var$identityGuard = (0, $2CYkO.z).object({
    userId: (0, $2CYkO.z).string(),
    details: (0, $2CYkO.z).record((0, $2CYkO.z).unknown()).optional()
});
const $6404ac89b3179130$export$9240af6bda06dde7 = (0, $2CYkO.z).record($6404ac89b3179130$var$identityGuard);
const $6404ac89b3179130$export$45938720c8cd17da = {
    id: (0, $2CYkO.z).string(),
    createdAt: (0, $2CYkO.z).string(),
    lastUsedAt: (0, $2CYkO.z).string().optional()
};
const $6404ac89b3179130$export$247de21853358ba3 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).TOTP),
    ...$6404ac89b3179130$export$45938720c8cd17da,
    key: (0, $2CYkO.z).string()
});
const $6404ac89b3179130$export$aa941865a0228ea6 = (0, $2CYkO.z).enum([
    "usb",
    "nfc",
    "ble",
    "internal",
    "cable",
    "hybrid",
    "smart-card"
]);
const $6404ac89b3179130$export$d887df993511916c = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).WebAuthn),
    ...$6404ac89b3179130$export$45938720c8cd17da,
    credentialId: (0, $2CYkO.z).string(),
    publicKey: (0, $2CYkO.z).string(),
    transports: $6404ac89b3179130$export$aa941865a0228ea6.array().optional(),
    counter: (0, $2CYkO.z).number(),
    agent: (0, $2CYkO.z).string()
});
const $6404ac89b3179130$export$b31bbb972ba29c41 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).BackupCode),
    ...$6404ac89b3179130$export$45938720c8cd17da,
    codes: (0, $2CYkO.z).object({
        code: (0, $2CYkO.z).string(),
        usedAt: (0, $2CYkO.z).string().optional()
    }).array()
});
const $6404ac89b3179130$export$e0149a7d7403659d = (0, $2CYkO.z).discriminatedUnion("type", [
    $6404ac89b3179130$export$247de21853358ba3,
    $6404ac89b3179130$export$d887df993511916c,
    $6404ac89b3179130$export$b31bbb972ba29c41
]);
const $6404ac89b3179130$export$cd58e15effbd05b2 = $6404ac89b3179130$export$e0149a7d7403659d.array();

});

parcelRequire.register("9NTe8", function(module, exports) {

$parcel$export(module.exports, "ssoDomainsGuard", function () { return $72338799404de4fa$export$d7a665f9067dd8f8; });
$parcel$export(module.exports, "ssoBrandingGuard", function () { return $72338799404de4fa$export$363bdce991737de; });

var $2CYkO = parcelRequire("2CYkO");
const $72338799404de4fa$export$d7a665f9067dd8f8 = (0, $2CYkO.z).array((0, $2CYkO.z).string());
const $72338799404de4fa$export$363bdce991737de = (0, $2CYkO.z).object({
    displayName: (0, $2CYkO.z).string().optional(),
    logo: (0, $2CYkO.z).string().optional(),
    darkLogo: (0, $2CYkO.z).string().optional()
});

});

parcelRequire.register("j7Jj8", function(module, exports) {
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("86S23")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return (parcelRequire("g3kBE")).ConnectorConfigFormItemType; });
$parcel$export(module.exports, "ConnectorError", function () { return (parcelRequire("14hC6")).ConnectorError; });
$parcel$export(module.exports, "ConnectorErrorCodes", function () { return (parcelRequire("14hC6")).ConnectorErrorCodes; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return (parcelRequire("86S23")).connectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("86S23")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("fU2Vo")).ConnectorType; });
$parcel$export(module.exports, "ServiceConnector", function () { return (parcelRequire("4at8B")).ServiceConnector; });
$parcel$export(module.exports, "socialUserInfoGuard", function () { return (parcelRequire("9rcvl")).socialUserInfoGuard; });
$parcel$export(module.exports, "urlRegEx", function () { return (parcelRequire("8shoi")).urlRegEx; });
parcelRequire("4at8B");
var $14hC6 = parcelRequire("14hC6");
function $dec1d0e57872a650$export$127f9a442b42d18(config, guard) {
    const result = guard.safeParse(config);
    if (!result.success) throw new (0, $14hC6.ConnectorError)((0, $14hC6.ConnectorErrorCodes).InvalidConfig, result.error);
}
const $dec1d0e57872a650$export$18c43dcebf00e571 = (jsonString, errorCode = (0, $14hC6.ConnectorErrorCodes).InvalidResponse, errorPayload)=>{
    try {
        return JSON.parse(jsonString);
    } catch  {
        throw new (0, $14hC6.ConnectorError)(errorCode, errorPayload ?? jsonString);
    }
};
const $dec1d0e57872a650$export$7b9340ca5373286 = (...args)=>{
    const parsed = $dec1d0e57872a650$export$18c43dcebf00e571(...args);
    if (!(parsed !== null && typeof parsed === "object")) throw new (0, $14hC6.ConnectorError)((0, $14hC6.ConnectorErrorCodes).InvalidResponse, parsed);
    return parsed;
};
const $dec1d0e57872a650$export$4fe65911a1cf396d = "logto_mock_verification_code_record.txt";

});
parcelRequire.register("4at8B", function(module, exports) {
$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return (parcelRequire("g3kBE")).ConnectorConfigFormItemType; });
$parcel$export(module.exports, "ConnectorError", function () { return (parcelRequire("14hC6")).ConnectorError; });
$parcel$export(module.exports, "ConnectorErrorCodes", function () { return (parcelRequire("14hC6")).ConnectorErrorCodes; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return (parcelRequire("86S23")).configurableConnectorMetadataGuard; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return (parcelRequire("86S23")).connectorMetadataGuard; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("86S23")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("fU2Vo")).ConnectorType; });
$parcel$export(module.exports, "urlRegEx", function () { return (parcelRequire("8shoi")).urlRegEx; });
$parcel$export(module.exports, "socialUserInfoGuard", function () { return (parcelRequire("9rcvl")).socialUserInfoGuard; });

$parcel$export(module.exports, "ServiceConnector", function () { return $308eb2c4de637245$export$59c1b079c431ef40; });
parcelRequire("g3kBE");
parcelRequire("14hC6");
parcelRequire("86S23");
parcelRequire("fU2Vo");
parcelRequire("8shoi");
parcelRequire("9rcvl");
var $308eb2c4de637245$export$5dbd9b9b0aba9316;
(function(DemoConnector) {
    DemoConnector["Sms"] = "logto-sms";
    DemoConnector["Social"] = "logto-social-demo";
})($308eb2c4de637245$export$5dbd9b9b0aba9316 || ($308eb2c4de637245$export$5dbd9b9b0aba9316 = {}));
const $308eb2c4de637245$export$a1fe89342af5f2bc = Object.freeze([
    $308eb2c4de637245$export$5dbd9b9b0aba9316.Sms,
    $308eb2c4de637245$export$5dbd9b9b0aba9316.Social
]);
var $308eb2c4de637245$export$59c1b079c431ef40;
(function(ServiceConnector) {
    ServiceConnector["Email"] = "logto-email";
})($308eb2c4de637245$export$59c1b079c431ef40 || ($308eb2c4de637245$export$59c1b079c431ef40 = {}));
const $308eb2c4de637245$export$4a0935744d2041a0 = Object.freeze([
    $308eb2c4de637245$export$59c1b079c431ef40.Email
]);

});
parcelRequire.register("g3kBE", function(module, exports) {

$parcel$export(module.exports, "ConnectorConfigFormItemType", function () { return $bafce91da95902a2$export$dc13b60e2521b1fc; });
$parcel$export(module.exports, "connectorConfigFormItemGuard", function () { return $bafce91da95902a2$export$ee34796348b9598a; });

var $2CYkO = parcelRequire("2CYkO");
var $bafce91da95902a2$export$dc13b60e2521b1fc;
(function(ConnectorConfigFormItemType) {
    ConnectorConfigFormItemType["Text"] = "Text";
    ConnectorConfigFormItemType["Number"] = "Number";
    ConnectorConfigFormItemType["MultilineText"] = "MultilineText";
    ConnectorConfigFormItemType["Switch"] = "Switch";
    ConnectorConfigFormItemType["Select"] = "Select";
    ConnectorConfigFormItemType["Json"] = "Json";
})($bafce91da95902a2$export$dc13b60e2521b1fc || ($bafce91da95902a2$export$dc13b60e2521b1fc = {}));
const $bafce91da95902a2$var$baseConfigFormItem = {
    key: (0, $2CYkO.z).string(),
    label: (0, $2CYkO.z).string(),
    placeholder: (0, $2CYkO.z).string().optional(),
    required: (0, $2CYkO.z).boolean().optional(),
    defaultValue: (0, $2CYkO.z).unknown().optional(),
    showConditions: (0, $2CYkO.z).array((0, $2CYkO.z).object({
        targetKey: (0, $2CYkO.z).string(),
        expectValue: (0, $2CYkO.z).unknown().optional()
    })).optional(),
    description: (0, $2CYkO.z).string().optional(),
    tooltip: (0, $2CYkO.z).string().optional(),
    isConfidential: (0, $2CYkO.z).boolean().optional()
};
const $bafce91da95902a2$export$ee34796348b9598a = (0, $2CYkO.z).discriminatedUnion("type", [
    (0, $2CYkO.z).object({
        type: (0, $2CYkO.z).literal($bafce91da95902a2$export$dc13b60e2521b1fc.Select),
        selectItems: (0, $2CYkO.z).array((0, $2CYkO.z).object({
            value: (0, $2CYkO.z).string(),
            title: (0, $2CYkO.z).string()
        })),
        ...$bafce91da95902a2$var$baseConfigFormItem
    }),
    (0, $2CYkO.z).object({
        type: (0, $2CYkO.z).enum([
            $bafce91da95902a2$export$dc13b60e2521b1fc.Text,
            $bafce91da95902a2$export$dc13b60e2521b1fc.Number,
            $bafce91da95902a2$export$dc13b60e2521b1fc.MultilineText,
            $bafce91da95902a2$export$dc13b60e2521b1fc.Switch,
            $bafce91da95902a2$export$dc13b60e2521b1fc.Json
        ]),
        ...$bafce91da95902a2$var$baseConfigFormItem
    })
]);

});

parcelRequire.register("14hC6", function(module, exports) {

$parcel$export(module.exports, "ConnectorErrorCodes", function () { return $0c73d3d8564e6c49$export$2ecd4a627c6913d4; });
$parcel$export(module.exports, "ConnectorError", function () { return $0c73d3d8564e6c49$export$1a6b62c5b97f19bd; });
var $0c73d3d8564e6c49$export$2ecd4a627c6913d4;
(function(ConnectorErrorCodes) {
    ConnectorErrorCodes["General"] = "general";
    ConnectorErrorCodes["InvalidMetadata"] = "invalid_metadata";
    ConnectorErrorCodes["UnexpectedType"] = "unexpected_type";
    ConnectorErrorCodes["InvalidConfigGuard"] = "invalid_config_guard";
    ConnectorErrorCodes["InvalidRequestParameters"] = "invalid_request_parameters";
    ConnectorErrorCodes["InsufficientRequestParameters"] = "insufficient_request_parameters";
    ConnectorErrorCodes["InvalidConfig"] = "invalid_config";
    ConnectorErrorCodes["InvalidCertificate"] = "invalid_certificate";
    ConnectorErrorCodes["InvalidResponse"] = "invalid_response";
    /** The template is not found for the given type. */ ConnectorErrorCodes["TemplateNotFound"] = "template_not_found";
    /** The template type is not supported by the connector. */ ConnectorErrorCodes["TemplateNotSupported"] = "template_not_supported";
    ConnectorErrorCodes["RateLimitExceeded"] = "rate_limit_exceeded";
    ConnectorErrorCodes["NotImplemented"] = "not_implemented";
    ConnectorErrorCodes["SocialAuthCodeInvalid"] = "social_auth_code_invalid";
    ConnectorErrorCodes["SocialAccessTokenInvalid"] = "social_invalid_access_token";
    ConnectorErrorCodes["SocialIdTokenInvalid"] = "social_invalid_id_token";
    ConnectorErrorCodes["AuthorizationFailed"] = "authorization_failed";
})($0c73d3d8564e6c49$export$2ecd4a627c6913d4 || ($0c73d3d8564e6c49$export$2ecd4a627c6913d4 = {}));
class $0c73d3d8564e6c49$export$1a6b62c5b97f19bd extends Error {
    constructor(code, data){
        const message = `ConnectorError: ${data ? JSON.stringify(data) : code}`;
        super(message);
        this.code = code;
        this.data = typeof data === "string" ? {
            message: data
        } : data;
    }
}

});

parcelRequire.register("86S23", function(module, exports) {

$parcel$export(module.exports, "ConnectorPlatform", function () { return $5e78cbee4e91b20f$export$e2b8cfc001e78efb; });
$parcel$export(module.exports, "connectorMetadataGuard", function () { return $5e78cbee4e91b20f$export$f7d2da53d88c923c; });
$parcel$export(module.exports, "configurableConnectorMetadataGuard", function () { return $5e78cbee4e91b20f$export$155cba4e58565525; });
parcelRequire("66B2B");
var $dMkQh = parcelRequire("dMkQh");

var $2CYkO = parcelRequire("2CYkO");

var $g3kBE = parcelRequire("g3kBE");
var $5e78cbee4e91b20f$export$e2b8cfc001e78efb;
(function(ConnectorPlatform) {
    ConnectorPlatform["Native"] = "Native";
    ConnectorPlatform["Universal"] = "Universal";
    ConnectorPlatform["Web"] = "Web";
})($5e78cbee4e91b20f$export$e2b8cfc001e78efb || ($5e78cbee4e91b20f$export$e2b8cfc001e78efb = {}));
const $5e78cbee4e91b20f$export$7241e9f50f26948a = (0, $2CYkO.z).object({
    en: (0, $2CYkO.z).string()
}).and((0, $2CYkO.z).record((0, $2CYkO.z).string())).refine((i18nObject)=>{
    const keys = Object.keys(i18nObject);
    if (!keys.includes("en")) return false;
    for (const value of keys){
        if (!(0, $dMkQh.isLanguageTag)(value)) return false;
    }
    return true;
});
const $5e78cbee4e91b20f$export$7d252e66ae683236 = (0, $2CYkO.z).object({
    // Social connector platform. TODO: @darcyYe considering remove the nullable and make all the social connector field optional
    platform: (0, $2CYkO.z).nativeEnum($5e78cbee4e91b20f$export$e2b8cfc001e78efb).nullable(),
    // Indicates custom connector that follows standard protocol. Currently supported standard connectors are OIDC, OAuth2, and SAML2
    isStandard: (0, $2CYkO.z).boolean().optional()
});
const $5e78cbee4e91b20f$export$f7d2da53d88c923c = (0, $2CYkO.z).object({
    // Unique connector factory id
    id: (0, $2CYkO.z).string(),
    /* Connector provider. Unique for each provider. Users can have only one social identity per provider
      For Social connectors, it's manually set on connector creation
      For SSO connectors, it's the same as the issuer
    */ target: (0, $2CYkO.z).string(),
    name: $5e78cbee4e91b20f$export$7241e9f50f26948a,
    description: $5e78cbee4e91b20f$export$7241e9f50f26948a,
    logo: (0, $2CYkO.z).string(),
    logoDark: (0, $2CYkO.z).string().nullable(),
    readme: (0, $2CYkO.z).string(),
    configTemplate: (0, $2CYkO.z).string().optional(),
    formItems: (0, $g3kBE.connectorConfigFormItemGuard).array().optional()
}).merge($5e78cbee4e91b20f$export$7d252e66ae683236).catchall((0, $2CYkO.z).unknown());
const $5e78cbee4e91b20f$export$155cba4e58565525 = $5e78cbee4e91b20f$export$f7d2da53d88c923c.pick({
    target: true,
    name: true,
    logo: true,
    logoDark: true
}).partial();

});

parcelRequire.register("fU2Vo", function(module, exports) {

$parcel$export(module.exports, "ConnectorType", function () { return $b93e5ac3dce216fb$export$18dbf40ba8d1d9db; });
var $b93e5ac3dce216fb$export$18dbf40ba8d1d9db;
(function(ConnectorType) {
    ConnectorType["Email"] = "Email";
    ConnectorType["Sms"] = "Sms";
    ConnectorType["Social"] = "Social";
})($b93e5ac3dce216fb$export$18dbf40ba8d1d9db || ($b93e5ac3dce216fb$export$18dbf40ba8d1d9db = {}));

});

parcelRequire.register("8shoi", function(module, exports) {

$parcel$export(module.exports, "urlRegEx", function () { return $627e6db3501f8374$export$51e0082496d4c1ff; });
// MARK: SMS + Email connector

var $2CYkO = parcelRequire("2CYkO");
var $627e6db3501f8374$export$849d15400f87ce3f;
(function(VerificationCodeType) {
    VerificationCodeType["SignIn"] = "SignIn";
    VerificationCodeType["Register"] = "Register";
    VerificationCodeType["ForgotPassword"] = "ForgotPassword";
    VerificationCodeType["Generic"] = "Generic";
    /** @deprecated Use `Generic` type template for sending test sms/email use case */ VerificationCodeType["Test"] = "Test";
})($627e6db3501f8374$export$849d15400f87ce3f || ($627e6db3501f8374$export$849d15400f87ce3f = {}));
const $627e6db3501f8374$export$61cf650ef6de814a = (0, $2CYkO.z).nativeEnum($627e6db3501f8374$export$849d15400f87ce3f);
const $627e6db3501f8374$export$f9b3e019678b784e = (0, $2CYkO.z).object({
    code: (0, $2CYkO.z).string()
});
const $627e6db3501f8374$export$51e0082496d4c1ff = /(https?:\/\/)?(?:www\.)?[\w#%+.:=@~-]{1,256}\.[\d()A-Za-z]{1,6}\b[\w#%&()+./:=?@~-]*/;
const $627e6db3501f8374$export$21b1fc3b40375a1b = (0, $2CYkO.z).object({
    senderName: (0, $2CYkO.z).string().refine((address)=>!$627e6db3501f8374$export$51e0082496d4c1ff.test(address), "DO NOT include URL in the sender name!"),
    companyInformation: (0, $2CYkO.z).string().refine((address)=>!$627e6db3501f8374$export$51e0082496d4c1ff.test(address), "DO NOT include URL in the company information!"),
    appLogo: (0, $2CYkO.z).string().url()
}).partial();
const $627e6db3501f8374$export$d68193cee3e4f305 = (0, $2CYkO.z).object({
    to: (0, $2CYkO.z).string(),
    type: $627e6db3501f8374$export$61cf650ef6de814a,
    payload: $627e6db3501f8374$export$f9b3e019678b784e
});

});

parcelRequire.register("9rcvl", function(module, exports) {

$parcel$export(module.exports, "socialUserInfoGuard", function () { return $6df055d451362214$export$3788bacea3bf0dba; });
// MARK: Social connector

var $2CYkO = parcelRequire("2CYkO");
const $6df055d451362214$export$3788bacea3bf0dba = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    email: (0, $2CYkO.z).string().optional(),
    phone: (0, $2CYkO.z).string().optional(),
    name: (0, $2CYkO.z).string().optional(),
    avatar: (0, $2CYkO.z).string().optional()
});
const $6df055d451362214$export$d09576a05941985c = (0, $2CYkO.z).object({
    nonce: (0, $2CYkO.z).string(),
    redirectUri: (0, $2CYkO.z).string(),
    connectorId: (0, $2CYkO.z).string(),
    connectorFactoryId: (0, $2CYkO.z).string(),
    jti: (0, $2CYkO.z).string(),
    state: (0, $2CYkO.z).string()
}).partial()// Accept arbitrary unspecified keys so developers who can not publish @logto/connector-kit can more flexibly utilize connector session.
.catchall((0, $2CYkO.z).unknown());

});





parcelRequire.register("28jVG", function(module, exports) {
$parcel$export(module.exports, "ApplicationType", function () { return (parcelRequire("3kVX5")).ApplicationType; });
$parcel$export(module.exports, "RoleType", function () { return (parcelRequire("3kVX5")).RoleType; });
$parcel$export(module.exports, "SignInMode", function () { return (parcelRequire("3kVX5")).SignInMode; });
$parcel$export(module.exports, "Applications", function () { return (parcelRequire("d7Klp")).Applications; });
$parcel$export(module.exports, "Connectors", function () { return (parcelRequire("6Sjtu")).Connectors; });
$parcel$export(module.exports, "Domains", function () { return (parcelRequire("6eJOs")).Domains; });
$parcel$export(module.exports, "Hooks", function () { return (parcelRequire("iHoE6")).Hooks; });
$parcel$export(module.exports, "OrganizationRoles", function () { return (parcelRequire("kGaan")).OrganizationRoles; });
$parcel$export(module.exports, "Organizations", function () { return (parcelRequire("eaNw6")).Organizations; });
$parcel$export(module.exports, "Resources", function () { return (parcelRequire("6E1ca")).Resources; });
$parcel$export(module.exports, "Scopes", function () { return (parcelRequire("gYQf2")).Scopes; });
$parcel$export(module.exports, "UserSsoIdentities", function () { return (parcelRequire("pBtP5")).UserSsoIdentities; });
$parcel$export(module.exports, "Users", function () { return (parcelRequire("6VJ3w")).Users; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
parcelRequire("3kVX5");
parcelRequire("2rcW6");
parcelRequire("iWlXX");
parcelRequire("hqU3z");
parcelRequire("7Dncx");
parcelRequire("d7Klp");
parcelRequire("4OdrD");
parcelRequire("6Sjtu");
parcelRequire("kcV6h");
parcelRequire("ip8hX");
parcelRequire("6eJOs");
parcelRequire("iHoE6");
parcelRequire("eJRvm");
parcelRequire("bnZeF");
parcelRequire("1NnGm");
parcelRequire("dIQ9M");
parcelRequire("gEkyw");
parcelRequire("kGaan");
parcelRequire("b6BCL");
parcelRequire("64kiC");
parcelRequire("eaNw6");
parcelRequire("e8m7I");
parcelRequire("6E1ca");
parcelRequire("h3usV");
parcelRequire("eTn3z");
parcelRequire("gYQf2");
parcelRequire("1VwvP");
parcelRequire("bzmoe");
parcelRequire("3uvwg");
parcelRequire("gVPlq");
parcelRequire("5uX8T");
parcelRequire("pBtP5");
parcelRequire("6VJ3w");
parcelRequire("gHzUB");
parcelRequire("b6LKK");

});
parcelRequire.register("3kVX5", function(module, exports) {

$parcel$export(module.exports, "ApplicationType", function () { return $26e0316e503e54e4$export$d16f8fdf0c548b68; });
$parcel$export(module.exports, "RoleType", function () { return $26e0316e503e54e4$export$e57c3ccf0ca02b45; });
$parcel$export(module.exports, "SentinelActionResult", function () { return $26e0316e503e54e4$export$dc6c7df092741a48; });
$parcel$export(module.exports, "SentinelDecision", function () { return $26e0316e503e54e4$export$418d76209f25e60e; });
$parcel$export(module.exports, "SignInMode", function () { return $26e0316e503e54e4$export$f927bbb3d448dc2b; });
$parcel$export(module.exports, "UsersPasswordEncryptionMethod", function () { return $26e0316e503e54e4$export$b3dbe23797267513; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var $26e0316e503e54e4$export$d16f8fdf0c548b68;
(function(ApplicationType) {
    ApplicationType["Native"] = "Native";
    ApplicationType["SPA"] = "SPA";
    ApplicationType["Traditional"] = "Traditional";
    ApplicationType["MachineToMachine"] = "MachineToMachine";
})($26e0316e503e54e4$export$d16f8fdf0c548b68 || ($26e0316e503e54e4$export$d16f8fdf0c548b68 = {}));
var $26e0316e503e54e4$export$e57c3ccf0ca02b45;
(function(RoleType) {
    RoleType["User"] = "User";
    RoleType["MachineToMachine"] = "MachineToMachine";
})($26e0316e503e54e4$export$e57c3ccf0ca02b45 || ($26e0316e503e54e4$export$e57c3ccf0ca02b45 = {}));
var $26e0316e503e54e4$export$dc6c7df092741a48;
(function(SentinelActionResult) {
    SentinelActionResult["Success"] = "Success";
    SentinelActionResult["Failed"] = "Failed";
})($26e0316e503e54e4$export$dc6c7df092741a48 || ($26e0316e503e54e4$export$dc6c7df092741a48 = {}));
var $26e0316e503e54e4$export$418d76209f25e60e;
(function(SentinelDecision) {
    SentinelDecision["Undecided"] = "Undecided";
    SentinelDecision["Allowed"] = "Allowed";
    SentinelDecision["Blocked"] = "Blocked";
    SentinelDecision["Challenge"] = "Challenge";
})($26e0316e503e54e4$export$418d76209f25e60e || ($26e0316e503e54e4$export$418d76209f25e60e = {}));
var $26e0316e503e54e4$export$f927bbb3d448dc2b;
(function(SignInMode) {
    SignInMode["SignIn"] = "SignIn";
    SignInMode["Register"] = "Register";
    SignInMode["SignInAndRegister"] = "SignInAndRegister";
})($26e0316e503e54e4$export$f927bbb3d448dc2b || ($26e0316e503e54e4$export$f927bbb3d448dc2b = {}));
var $26e0316e503e54e4$export$b3dbe23797267513;
(function(UsersPasswordEncryptionMethod) {
    UsersPasswordEncryptionMethod["Argon2i"] = "Argon2i";
})($26e0316e503e54e4$export$b3dbe23797267513 || ($26e0316e503e54e4$export$b3dbe23797267513 = {}));

});

parcelRequire.register("2rcW6", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("iWlXX", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("hqU3z", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("7Dncx", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

});

parcelRequire.register("d7Klp", function(module, exports) {

$parcel$export(module.exports, "Applications", function () { return $98dfe0cd21b05f24$export$73c91b53927e421e; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $eyD2M = parcelRequire("eyD2M");

var $3kVX5 = parcelRequire("3kVX5");
const $98dfe0cd21b05f24$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(256),
    secret: (0, $2CYkO.z).string().min(1).max(64),
    description: (0, $2CYkO.z).string().nullable().optional(),
    type: (0, $2CYkO.z).nativeEnum((0, $3kVX5.ApplicationType)),
    oidcClientMetadata: (0, $eyD2M.oidcClientMetadataGuard),
    customClientMetadata: (0, $eyD2M.customClientMetadataGuard).optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $98dfe0cd21b05f24$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(256),
    secret: (0, $2CYkO.z).string().min(1).max(64),
    description: (0, $2CYkO.z).string().nullable(),
    type: (0, $2CYkO.z).nativeEnum((0, $3kVX5.ApplicationType)),
    oidcClientMetadata: (0, $eyD2M.oidcClientMetadataGuard),
    customClientMetadata: (0, $eyD2M.customClientMetadataGuard),
    createdAt: (0, $2CYkO.z).number()
});
const $98dfe0cd21b05f24$export$73c91b53927e421e = Object.freeze({
    table: "applications",
    tableSingular: "application",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        secret: "secret",
        description: "description",
        type: "type",
        oidcClientMetadata: "oidc_client_metadata",
        customClientMetadata: "custom_client_metadata",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "secret",
        "description",
        "type",
        "oidcClientMetadata",
        "customClientMetadata",
        "createdAt"
    ],
    createGuard: $98dfe0cd21b05f24$var$createGuard,
    guard: $98dfe0cd21b05f24$var$guard,
    updateGuard: $98dfe0cd21b05f24$var$guard.partial()
});

});

parcelRequire.register("4OdrD", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $380642cbaa06a32c$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    applicationId: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21)
});
const $380642cbaa06a32c$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    applicationId: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21)
});
const $380642cbaa06a32c$export$9e9228a1487950f9 = Object.freeze({
    table: "applications_roles",
    tableSingular: "applications_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        applicationId: "application_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "applicationId",
        "roleId"
    ],
    createGuard: $380642cbaa06a32c$var$createGuard,
    guard: $380642cbaa06a32c$var$guard,
    updateGuard: $380642cbaa06a32c$var$guard.partial()
});

});

parcelRequire.register("6Sjtu", function(module, exports) {

$parcel$export(module.exports, "Connectors", function () { return $014ab11aa9318eac$export$87ce1179d2402b5a; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
var $86S23 = parcelRequire("86S23");
const $014ab11aa9318eac$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(128),
    syncProfile: (0, $2CYkO.z).boolean().optional(),
    connectorId: (0, $2CYkO.z).string().min(1).max(128),
    config: (0, $123dJ.jsonObjectGuard).optional(),
    metadata: (0, $86S23.configurableConnectorMetadataGuard).optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $014ab11aa9318eac$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(128),
    syncProfile: (0, $2CYkO.z).boolean(),
    connectorId: (0, $2CYkO.z).string().min(1).max(128),
    config: (0, $123dJ.jsonObjectGuard),
    metadata: (0, $86S23.configurableConnectorMetadataGuard),
    createdAt: (0, $2CYkO.z).number()
});
const $014ab11aa9318eac$export$87ce1179d2402b5a = Object.freeze({
    table: "connectors",
    tableSingular: "connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        syncProfile: "sync_profile",
        connectorId: "connector_id",
        config: "config",
        metadata: "metadata",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "syncProfile",
        "connectorId",
        "config",
        "metadata",
        "createdAt"
    ],
    createGuard: $014ab11aa9318eac$var$createGuard,
    guard: $014ab11aa9318eac$var$guard,
    updateGuard: $014ab11aa9318eac$var$guard.partial()
});

});

parcelRequire.register("kcV6h", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $2r8y8 = parcelRequire("2r8y8");
const $eb61388e07af9d62$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    languageTag: (0, $2CYkO.z).string().min(1).max(16),
    translation: (0, $2r8y8.translationGuard)
});
const $eb61388e07af9d62$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    languageTag: (0, $2CYkO.z).string().min(1).max(16),
    translation: (0, $2r8y8.translationGuard)
});
const $eb61388e07af9d62$export$68f045a468761c0e = Object.freeze({
    table: "custom_phrases",
    tableSingular: "custom_phrase",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        languageTag: "language_tag",
        translation: "translation"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "languageTag",
        "translation"
    ],
    createGuard: $eb61388e07af9d62$var$createGuard,
    guard: $eb61388e07af9d62$var$guard,
    updateGuard: $eb61388e07af9d62$var$guard.partial()
});

});

parcelRequire.register("ip8hX", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $d660fdbf52671199$var$createGuard = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string().min(1).max(21),
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    date: (0, $2CYkO.z).number()
});
const $d660fdbf52671199$var$guard = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string().min(1).max(21),
    tenantId: (0, $2CYkO.z).string().max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    date: (0, $2CYkO.z).number()
});
const $d660fdbf52671199$export$d153bb698683b0a7 = Object.freeze({
    table: "daily_active_users",
    tableSingular: "daily_active_user",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        userId: "user_id",
        date: "date"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "userId",
        "date"
    ],
    createGuard: $d660fdbf52671199$var$createGuard,
    guard: $d660fdbf52671199$var$guard,
    updateGuard: $d660fdbf52671199$var$guard.partial()
});

});

parcelRequire.register("6eJOs", function(module, exports) {

$parcel$export(module.exports, "Domains", function () { return $48a79660132967a7$export$e3e9d7fdf7b67caa; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $1EA0k = parcelRequire("1EA0k");
const $48a79660132967a7$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    domain: (0, $2CYkO.z).string().min(1).max(256),
    status: (0, $1EA0k.domainStatusGuard).optional(),
    errorMessage: (0, $2CYkO.z).string().max(1024).nullable().optional(),
    dnsRecords: (0, $1EA0k.domainDnsRecordsGuard).optional(),
    cloudflareData: (0, $1EA0k.cloudflareDataGuard).nullable().optional(),
    updatedAt: (0, $2CYkO.z).number().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $48a79660132967a7$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    domain: (0, $2CYkO.z).string().min(1).max(256),
    status: (0, $1EA0k.domainStatusGuard),
    errorMessage: (0, $2CYkO.z).string().max(1024).nullable(),
    dnsRecords: (0, $1EA0k.domainDnsRecordsGuard),
    cloudflareData: (0, $1EA0k.cloudflareDataGuard).nullable(),
    updatedAt: (0, $2CYkO.z).number(),
    createdAt: (0, $2CYkO.z).number()
});
const $48a79660132967a7$export$e3e9d7fdf7b67caa = Object.freeze({
    table: "domains",
    tableSingular: "domain",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        domain: "domain",
        status: "status",
        errorMessage: "error_message",
        dnsRecords: "dns_records",
        cloudflareData: "cloudflare_data",
        updatedAt: "updated_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "domain",
        "status",
        "errorMessage",
        "dnsRecords",
        "cloudflareData",
        "updatedAt",
        "createdAt"
    ],
    createGuard: $48a79660132967a7$var$createGuard,
    guard: $48a79660132967a7$var$guard,
    updateGuard: $48a79660132967a7$var$guard.partial()
});

});

parcelRequire.register("iHoE6", function(module, exports) {

$parcel$export(module.exports, "Hooks", function () { return $d9cf5c4ef2fd1322$export$5fbefe39e79899a6; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $lq5Qn = parcelRequire("lq5Qn");
const $d9cf5c4ef2fd1322$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(256).optional(),
    event: (0, $lq5Qn.hookEventGuard).nullable().optional(),
    events: (0, $lq5Qn.hookEventsGuard).optional(),
    config: (0, $lq5Qn.hookConfigGuard),
    signingKey: (0, $2CYkO.z).string().min(1).max(64).optional(),
    enabled: (0, $2CYkO.z).boolean().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $d9cf5c4ef2fd1322$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().max(256),
    event: (0, $lq5Qn.hookEventGuard).nullable(),
    events: (0, $lq5Qn.hookEventsGuard),
    config: (0, $lq5Qn.hookConfigGuard),
    signingKey: (0, $2CYkO.z).string().max(64),
    enabled: (0, $2CYkO.z).boolean(),
    createdAt: (0, $2CYkO.z).number()
});
const $d9cf5c4ef2fd1322$export$5fbefe39e79899a6 = Object.freeze({
    table: "hooks",
    tableSingular: "hook",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        event: "event",
        events: "events",
        config: "config",
        signingKey: "signing_key",
        enabled: "enabled",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "event",
        "events",
        "config",
        "signingKey",
        "enabled",
        "createdAt"
    ],
    createGuard: $d9cf5c4ef2fd1322$var$createGuard,
    guard: $d9cf5c4ef2fd1322$var$guard,
    updateGuard: $d9cf5c4ef2fd1322$var$guard.partial()
});

});

parcelRequire.register("eJRvm", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $lSUTm = parcelRequire("lSUTm");
const $abaec59f84295821$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    key: (0, $2CYkO.z).string().min(1).max(128),
    payload: (0, $lSUTm.logContextPayloadGuard).optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $abaec59f84295821$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    key: (0, $2CYkO.z).string().min(1).max(128),
    payload: (0, $lSUTm.logContextPayloadGuard),
    createdAt: (0, $2CYkO.z).number()
});
const $abaec59f84295821$export$55c65d61db3da5ca = Object.freeze({
    table: "logs",
    tableSingular: "log",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        key: "key",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "key",
        "payload",
        "createdAt"
    ],
    createGuard: $abaec59f84295821$var$createGuard,
    guard: $abaec59f84295821$var$guard,
    updateGuard: $abaec59f84295821$var$guard.partial()
});

});

parcelRequire.register("bnZeF", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
const $84a157d0349eca3a$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    key: (0, $2CYkO.z).string().min(1).max(256),
    value: (0, $123dJ.jsonGuard).optional()
});
const $84a157d0349eca3a$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    key: (0, $2CYkO.z).string().min(1).max(256),
    value: (0, $123dJ.jsonGuard)
});
const $84a157d0349eca3a$export$d95c9c1f4b55e315 = Object.freeze({
    table: "logto_configs",
    tableSingular: "logto_config",
    fields: {
        tenantId: "tenant_id",
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "tenantId",
        "key",
        "value"
    ],
    createGuard: $84a157d0349eca3a$var$createGuard,
    guard: $84a157d0349eca3a$var$guard,
    updateGuard: $84a157d0349eca3a$var$guard.partial()
});

});

parcelRequire.register("1NnGm", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $eyD2M = parcelRequire("eyD2M");
const $14ecbcd8056fb353$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    modelName: (0, $2CYkO.z).string().min(1).max(64),
    id: (0, $2CYkO.z).string().min(1).max(128),
    payload: (0, $eyD2M.oidcModelInstancePayloadGuard),
    expiresAt: (0, $2CYkO.z).number(),
    consumedAt: (0, $2CYkO.z).number().nullable().optional()
});
const $14ecbcd8056fb353$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    modelName: (0, $2CYkO.z).string().min(1).max(64),
    id: (0, $2CYkO.z).string().min(1).max(128),
    payload: (0, $eyD2M.oidcModelInstancePayloadGuard),
    expiresAt: (0, $2CYkO.z).number(),
    consumedAt: (0, $2CYkO.z).number().nullable()
});
const $14ecbcd8056fb353$export$4825f32a2bacdbff = Object.freeze({
    table: "oidc_model_instances",
    tableSingular: "oidc_model_instance",
    fields: {
        tenantId: "tenant_id",
        modelName: "model_name",
        id: "id",
        payload: "payload",
        expiresAt: "expires_at",
        consumedAt: "consumed_at"
    },
    fieldKeys: [
        "tenantId",
        "modelName",
        "id",
        "payload",
        "expiresAt",
        "consumedAt"
    ],
    createGuard: $14ecbcd8056fb353$var$createGuard,
    guard: $14ecbcd8056fb353$var$guard,
    updateGuard: $14ecbcd8056fb353$var$guard.partial()
});

});

parcelRequire.register("dIQ9M", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $9fd7d7a6596ca447$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    organizationRoleId: (0, $2CYkO.z).string().min(1).max(21),
    organizationScopeId: (0, $2CYkO.z).string().min(1).max(21)
});
const $9fd7d7a6596ca447$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    organizationRoleId: (0, $2CYkO.z).string().min(1).max(21),
    organizationScopeId: (0, $2CYkO.z).string().min(1).max(21)
});
const $9fd7d7a6596ca447$export$3c85c8a4a8d43867 = Object.freeze({
    table: "organization_role_scope_relations",
    tableSingular: "organization_role_scope_relation",
    fields: {
        tenantId: "tenant_id",
        organizationRoleId: "organization_role_id",
        organizationScopeId: "organization_scope_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationRoleId",
        "organizationScopeId"
    ],
    createGuard: $9fd7d7a6596ca447$var$createGuard,
    guard: $9fd7d7a6596ca447$var$guard,
    updateGuard: $9fd7d7a6596ca447$var$guard.partial()
});

});

parcelRequire.register("gEkyw", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $c1f053beac10015b$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    organizationId: (0, $2CYkO.z).string().min(1).max(21),
    organizationRoleId: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21)
});
const $c1f053beac10015b$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    organizationId: (0, $2CYkO.z).string().min(1).max(21),
    organizationRoleId: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21)
});
const $c1f053beac10015b$export$92d9ab4d1ade1798 = Object.freeze({
    table: "organization_role_user_relations",
    tableSingular: "organization_role_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        organizationRoleId: "organization_role_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "organizationRoleId",
        "userId"
    ],
    createGuard: $c1f053beac10015b$var$createGuard,
    guard: $c1f053beac10015b$var$guard,
    updateGuard: $c1f053beac10015b$var$guard.partial()
});

});

parcelRequire.register("kGaan", function(module, exports) {

$parcel$export(module.exports, "OrganizationRoles", function () { return $f0df9db433850609$export$29f120f254b547e7; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $f0df9db433850609$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable().optional()
});
const $f0df9db433850609$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable()
});
const $f0df9db433850609$export$29f120f254b547e7 = Object.freeze({
    table: "organization_roles",
    tableSingular: "organization_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $f0df9db433850609$var$createGuard,
    guard: $f0df9db433850609$var$guard,
    updateGuard: $f0df9db433850609$var$guard.partial()
});

});

parcelRequire.register("b6BCL", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $815d70a13ddda2f7$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable().optional()
});
const $815d70a13ddda2f7$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable()
});
const $815d70a13ddda2f7$export$9d110f69f69dde7a = Object.freeze({
    table: "organization_scopes",
    tableSingular: "organization_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description"
    ],
    createGuard: $815d70a13ddda2f7$var$createGuard,
    guard: $815d70a13ddda2f7$var$guard,
    updateGuard: $815d70a13ddda2f7$var$guard.partial()
});

});

parcelRequire.register("64kiC", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $46b2dcd10b3a5a82$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    organizationId: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21)
});
const $46b2dcd10b3a5a82$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    organizationId: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21)
});
const $46b2dcd10b3a5a82$export$cd9bcab5c5506817 = Object.freeze({
    table: "organization_user_relations",
    tableSingular: "organization_user_relation",
    fields: {
        tenantId: "tenant_id",
        organizationId: "organization_id",
        userId: "user_id"
    },
    fieldKeys: [
        "tenantId",
        "organizationId",
        "userId"
    ],
    createGuard: $46b2dcd10b3a5a82$var$createGuard,
    guard: $46b2dcd10b3a5a82$var$guard,
    updateGuard: $46b2dcd10b3a5a82$var$guard.partial()
});

});

parcelRequire.register("eaNw6", function(module, exports) {

$parcel$export(module.exports, "Organizations", function () { return $a51868d6b92f1c90$export$8cdb1b004e612f6c; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $a51868d6b92f1c90$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $a51868d6b92f1c90$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().max(256).nullable(),
    createdAt: (0, $2CYkO.z).number()
});
const $a51868d6b92f1c90$export$8cdb1b004e612f6c = Object.freeze({
    table: "organizations",
    tableSingular: "organization",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $a51868d6b92f1c90$var$createGuard,
    guard: $a51868d6b92f1c90$var$guard,
    updateGuard: $a51868d6b92f1c90$var$guard.partial()
});

});

parcelRequire.register("e8m7I", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $a4a2f94a62de687a$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    interactionJti: (0, $2CYkO.z).string().max(128).nullable().optional(),
    phone: (0, $2CYkO.z).string().max(32).nullable().optional(),
    email: (0, $2CYkO.z).string().max(128).nullable().optional(),
    type: (0, $2CYkO.z).string().min(1).max(32),
    code: (0, $2CYkO.z).string().min(1).max(6),
    consumed: (0, $2CYkO.z).boolean().optional(),
    tryCount: (0, $2CYkO.z).number().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $a4a2f94a62de687a$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    interactionJti: (0, $2CYkO.z).string().max(128).nullable(),
    phone: (0, $2CYkO.z).string().max(32).nullable(),
    email: (0, $2CYkO.z).string().max(128).nullable(),
    type: (0, $2CYkO.z).string().min(1).max(32),
    code: (0, $2CYkO.z).string().min(1).max(6),
    consumed: (0, $2CYkO.z).boolean(),
    tryCount: (0, $2CYkO.z).number(),
    createdAt: (0, $2CYkO.z).number()
});
const $a4a2f94a62de687a$export$9bbf548a87a223fc = Object.freeze({
    table: "passcodes",
    tableSingular: "passcode",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        interactionJti: "interaction_jti",
        phone: "phone",
        email: "email",
        type: "type",
        code: "code",
        consumed: "consumed",
        tryCount: "try_count",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "interactionJti",
        "phone",
        "email",
        "type",
        "code",
        "consumed",
        "tryCount",
        "createdAt"
    ],
    createGuard: $a4a2f94a62de687a$var$createGuard,
    guard: $a4a2f94a62de687a$var$guard,
    updateGuard: $a4a2f94a62de687a$var$guard.partial()
});

});

parcelRequire.register("6E1ca", function(module, exports) {

$parcel$export(module.exports, "Resources", function () { return $4d6767d8f3ecc3bb$export$e9a269813a6315a4; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $4d6767d8f3ecc3bb$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1),
    indicator: (0, $2CYkO.z).string().min(1),
    isDefault: (0, $2CYkO.z).boolean().optional(),
    accessTokenTtl: (0, $2CYkO.z).number().optional()
});
const $4d6767d8f3ecc3bb$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1),
    indicator: (0, $2CYkO.z).string().min(1),
    isDefault: (0, $2CYkO.z).boolean(),
    accessTokenTtl: (0, $2CYkO.z).number()
});
const $4d6767d8f3ecc3bb$export$e9a269813a6315a4 = Object.freeze({
    table: "resources",
    tableSingular: "resource",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        indicator: "indicator",
        isDefault: "is_default",
        accessTokenTtl: "access_token_ttl"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "indicator",
        "isDefault",
        "accessTokenTtl"
    ],
    createGuard: $4d6767d8f3ecc3bb$var$createGuard,
    guard: $4d6767d8f3ecc3bb$var$guard,
    updateGuard: $4d6767d8f3ecc3bb$var$guard.partial()
});

});

parcelRequire.register("h3usV", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");

var $3kVX5 = parcelRequire("3kVX5");
const $c6aa59538322e8ae$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().min(1).max(128),
    type: (0, $2CYkO.z).nativeEnum((0, $3kVX5.RoleType)).optional()
});
const $c6aa59538322e8ae$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(128),
    description: (0, $2CYkO.z).string().min(1).max(128),
    type: (0, $2CYkO.z).nativeEnum((0, $3kVX5.RoleType))
});
const $c6aa59538322e8ae$export$d1d9e451800db729 = Object.freeze({
    table: "roles",
    tableSingular: "role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        name: "name",
        description: "description",
        type: "type"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "name",
        "description",
        "type"
    ],
    createGuard: $c6aa59538322e8ae$var$createGuard,
    guard: $c6aa59538322e8ae$var$guard,
    updateGuard: $c6aa59538322e8ae$var$guard.partial()
});

});

parcelRequire.register("eTn3z", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $ad7816501d7f3bb0$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21),
    scopeId: (0, $2CYkO.z).string().min(1).max(21)
});
const $ad7816501d7f3bb0$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21),
    scopeId: (0, $2CYkO.z).string().min(1).max(21)
});
const $ad7816501d7f3bb0$export$a3e241bf0004129f = Object.freeze({
    table: "roles_scopes",
    tableSingular: "roles_scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        roleId: "role_id",
        scopeId: "scope_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "roleId",
        "scopeId"
    ],
    createGuard: $ad7816501d7f3bb0$var$createGuard,
    guard: $ad7816501d7f3bb0$var$guard,
    updateGuard: $ad7816501d7f3bb0$var$guard.partial()
});

});

parcelRequire.register("gYQf2", function(module, exports) {

$parcel$export(module.exports, "Scopes", function () { return $c5cac604c06364fa$export$8546186883d6ff3e; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $c5cac604c06364fa$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    resourceId: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(256),
    description: (0, $2CYkO.z).string().min(1),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $c5cac604c06364fa$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    resourceId: (0, $2CYkO.z).string().min(1).max(21),
    name: (0, $2CYkO.z).string().min(1).max(256),
    description: (0, $2CYkO.z).string().min(1),
    createdAt: (0, $2CYkO.z).number()
});
const $c5cac604c06364fa$export$8546186883d6ff3e = Object.freeze({
    table: "scopes",
    tableSingular: "scope",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        resourceId: "resource_id",
        name: "name",
        description: "description",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "resourceId",
        "name",
        "description",
        "createdAt"
    ],
    createGuard: $c5cac604c06364fa$var$createGuard,
    guard: $c5cac604c06364fa$var$guard,
    updateGuard: $c5cac604c06364fa$var$guard.partial()
});

});

parcelRequire.register("1VwvP", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $jMgxv = parcelRequire("jMgxv");

var $3kVX5 = parcelRequire("3kVX5");
const $1674559238e1456f$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    targetType: (0, $jMgxv.sentinelActivityTargetTypeGuard),
    targetHash: (0, $2CYkO.z).string().min(1).max(64),
    action: (0, $jMgxv.sentinelActivityActionGuard),
    actionResult: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SentinelActionResult)),
    payload: (0, $jMgxv.sentinelActivityPayloadGuard),
    decision: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SentinelDecision)),
    decisionExpiresAt: (0, $2CYkO.z).number().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $1674559238e1456f$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    targetType: (0, $jMgxv.sentinelActivityTargetTypeGuard),
    targetHash: (0, $2CYkO.z).string().min(1).max(64),
    action: (0, $jMgxv.sentinelActivityActionGuard),
    actionResult: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SentinelActionResult)),
    payload: (0, $jMgxv.sentinelActivityPayloadGuard),
    decision: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SentinelDecision)),
    decisionExpiresAt: (0, $2CYkO.z).number(),
    createdAt: (0, $2CYkO.z).number()
});
const $1674559238e1456f$export$ac14f56217b6b757 = Object.freeze({
    table: "sentinel_activities",
    tableSingular: "sentinel_activity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        targetType: "target_type",
        targetHash: "target_hash",
        action: "action",
        actionResult: "action_result",
        payload: "payload",
        decision: "decision",
        decisionExpiresAt: "decision_expires_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "targetType",
        "targetHash",
        "action",
        "actionResult",
        "payload",
        "decision",
        "decisionExpiresAt",
        "createdAt"
    ],
    createGuard: $1674559238e1456f$var$createGuard,
    guard: $1674559238e1456f$var$guard,
    updateGuard: $1674559238e1456f$var$guard.partial()
});

});

parcelRequire.register("bzmoe", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
const $86c454c48c65810c$var$createGuard = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string().min(1).max(21),
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    type: (0, $2CYkO.z).string().min(1).max(64),
    payload: (0, $123dJ.jsonObjectGuard).optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $86c454c48c65810c$var$guard = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string().min(1).max(21),
    tenantId: (0, $2CYkO.z).string().max(21),
    type: (0, $2CYkO.z).string().min(1).max(64),
    payload: (0, $123dJ.jsonObjectGuard),
    createdAt: (0, $2CYkO.z).number()
});
const $86c454c48c65810c$export$22ef66d3c161d6a7 = Object.freeze({
    table: "service_logs",
    tableSingular: "service_log",
    fields: {
        id: "id",
        tenantId: "tenant_id",
        type: "type",
        payload: "payload",
        createdAt: "created_at"
    },
    fieldKeys: [
        "id",
        "tenantId",
        "type",
        "payload",
        "createdAt"
    ],
    createGuard: $86c454c48c65810c$var$createGuard,
    guard: $86c454c48c65810c$var$guard,
    updateGuard: $86c454c48c65810c$var$guard.partial()
});

});

parcelRequire.register("3uvwg", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $bd0Y0 = parcelRequire("bd0Y0");
var $lSUTm = parcelRequire("lSUTm");

var $3kVX5 = parcelRequire("3kVX5");
const $28ac9f8c9006c5d7$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    color: (0, $bd0Y0.colorGuard),
    branding: (0, $bd0Y0.brandingGuard),
    languageInfo: (0, $bd0Y0.languageInfoGuard),
    termsOfUseUrl: (0, $2CYkO.z).string().max(2048).nullable().optional(),
    privacyPolicyUrl: (0, $2CYkO.z).string().max(2048).nullable().optional(),
    signIn: (0, $bd0Y0.signInGuard),
    signUp: (0, $bd0Y0.signUpGuard),
    socialSignInConnectorTargets: (0, $bd0Y0.connectorTargetsGuard).optional(),
    signInMode: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SignInMode)).optional(),
    customCss: (0, $2CYkO.z).string().nullable().optional(),
    customContent: (0, $bd0Y0.customContentGuard).optional(),
    passwordPolicy: (0, $lSUTm.partialPasswordPolicyGuard).optional(),
    mfa: (0, $bd0Y0.mfaGuard).optional(),
    singleSignOnEnabled: (0, $2CYkO.z).boolean().optional()
});
const $28ac9f8c9006c5d7$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    color: (0, $bd0Y0.colorGuard),
    branding: (0, $bd0Y0.brandingGuard),
    languageInfo: (0, $bd0Y0.languageInfoGuard),
    termsOfUseUrl: (0, $2CYkO.z).string().max(2048).nullable(),
    privacyPolicyUrl: (0, $2CYkO.z).string().max(2048).nullable(),
    signIn: (0, $bd0Y0.signInGuard),
    signUp: (0, $bd0Y0.signUpGuard),
    socialSignInConnectorTargets: (0, $bd0Y0.connectorTargetsGuard),
    signInMode: (0, $2CYkO.z).nativeEnum((0, $3kVX5.SignInMode)),
    customCss: (0, $2CYkO.z).string().nullable(),
    customContent: (0, $bd0Y0.customContentGuard),
    passwordPolicy: (0, $lSUTm.partialPasswordPolicyGuard),
    mfa: (0, $bd0Y0.mfaGuard),
    singleSignOnEnabled: (0, $2CYkO.z).boolean()
});
const $28ac9f8c9006c5d7$export$761297ae014f2673 = Object.freeze({
    table: "sign_in_experiences",
    tableSingular: "sign_in_experience",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        color: "color",
        branding: "branding",
        languageInfo: "language_info",
        termsOfUseUrl: "terms_of_use_url",
        privacyPolicyUrl: "privacy_policy_url",
        signIn: "sign_in",
        signUp: "sign_up",
        socialSignInConnectorTargets: "social_sign_in_connector_targets",
        signInMode: "sign_in_mode",
        customCss: "custom_css",
        customContent: "custom_content",
        passwordPolicy: "password_policy",
        mfa: "mfa",
        singleSignOnEnabled: "single_sign_on_enabled"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "color",
        "branding",
        "languageInfo",
        "termsOfUseUrl",
        "privacyPolicyUrl",
        "signIn",
        "signUp",
        "socialSignInConnectorTargets",
        "signInMode",
        "customCss",
        "customContent",
        "passwordPolicy",
        "mfa",
        "singleSignOnEnabled"
    ],
    createGuard: $28ac9f8c9006c5d7$var$createGuard,
    guard: $28ac9f8c9006c5d7$var$guard,
    updateGuard: $28ac9f8c9006c5d7$var$guard.partial()
});

});

parcelRequire.register("gVPlq", function(module, exports) {

$parcel$export(module.exports, "SsoConnectors", function () { return $c539cc2e0faa0d75$export$cb7d2ef46acb2840; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
var $9NTe8 = parcelRequire("9NTe8");
const $c539cc2e0faa0d75$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(128),
    providerName: (0, $2CYkO.z).string().min(1).max(128),
    connectorName: (0, $2CYkO.z).string().min(1).max(128),
    config: (0, $123dJ.jsonObjectGuard).optional(),
    domains: (0, $9NTe8.ssoDomainsGuard).optional(),
    branding: (0, $9NTe8.ssoBrandingGuard).optional(),
    syncProfile: (0, $2CYkO.z).boolean().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $c539cc2e0faa0d75$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(128),
    providerName: (0, $2CYkO.z).string().min(1).max(128),
    connectorName: (0, $2CYkO.z).string().min(1).max(128),
    config: (0, $123dJ.jsonObjectGuard),
    domains: (0, $9NTe8.ssoDomainsGuard),
    branding: (0, $9NTe8.ssoBrandingGuard),
    syncProfile: (0, $2CYkO.z).boolean(),
    createdAt: (0, $2CYkO.z).number()
});
const $c539cc2e0faa0d75$export$cb7d2ef46acb2840 = Object.freeze({
    table: "sso_connectors",
    tableSingular: "sso_connector",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        providerName: "provider_name",
        connectorName: "connector_name",
        config: "config",
        domains: "domains",
        branding: "branding",
        syncProfile: "sync_profile",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "providerName",
        "connectorName",
        "config",
        "domains",
        "branding",
        "syncProfile",
        "createdAt"
    ],
    createGuard: $c539cc2e0faa0d75$var$createGuard,
    guard: $c539cc2e0faa0d75$var$guard,
    updateGuard: $c539cc2e0faa0d75$var$guard.partial()
});

});

parcelRequire.register("5uX8T", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
const $400da18611f9477c$var$createGuard = (0, $2CYkO.z).object({
    key: (0, $2CYkO.z).string().min(1).max(256),
    value: (0, $123dJ.jsonObjectGuard).optional()
});
const $400da18611f9477c$var$guard = (0, $2CYkO.z).object({
    key: (0, $2CYkO.z).string().min(1).max(256),
    value: (0, $123dJ.jsonObjectGuard)
});
const $400da18611f9477c$export$2b3c0ad5912d86e2 = Object.freeze({
    table: "systems",
    tableSingular: "system",
    fields: {
        key: "key",
        value: "value"
    },
    fieldKeys: [
        "key",
        "value"
    ],
    createGuard: $400da18611f9477c$var$createGuard,
    guard: $400da18611f9477c$var$guard,
    updateGuard: $400da18611f9477c$var$guard.partial()
});

});

parcelRequire.register("pBtP5", function(module, exports) {

$parcel$export(module.exports, "UserSsoIdentities", function () { return $04cf68aa1959fae3$export$53f83427a403da1f; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
const $04cf68aa1959fae3$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(12),
    issuer: (0, $2CYkO.z).string().min(1).max(256),
    identityId: (0, $2CYkO.z).string().min(1).max(128),
    detail: (0, $123dJ.jsonObjectGuard).optional(),
    createdAt: (0, $2CYkO.z).number().optional(),
    ssoConnectorId: (0, $2CYkO.z).string().min(1).max(128)
});
const $04cf68aa1959fae3$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(12),
    issuer: (0, $2CYkO.z).string().min(1).max(256),
    identityId: (0, $2CYkO.z).string().min(1).max(128),
    detail: (0, $123dJ.jsonObjectGuard),
    createdAt: (0, $2CYkO.z).number(),
    ssoConnectorId: (0, $2CYkO.z).string().min(1).max(128)
});
const $04cf68aa1959fae3$export$53f83427a403da1f = Object.freeze({
    table: "user_sso_identities",
    tableSingular: "user_sso_identity",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        issuer: "issuer",
        identityId: "identity_id",
        detail: "detail",
        createdAt: "created_at",
        ssoConnectorId: "sso_connector_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "issuer",
        "identityId",
        "detail",
        "createdAt",
        "ssoConnectorId"
    ],
    createGuard: $04cf68aa1959fae3$var$createGuard,
    guard: $04cf68aa1959fae3$var$guard,
    updateGuard: $04cf68aa1959fae3$var$guard.partial()
});

});

parcelRequire.register("6VJ3w", function(module, exports) {

$parcel$export(module.exports, "Users", function () { return $50bb041b27f82bf1$export$a69f017b19597ff5; });
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $8AotL = parcelRequire("8AotL");
var $123dJ = parcelRequire("123dJ");

var $3kVX5 = parcelRequire("3kVX5");
const $50bb041b27f82bf1$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(12),
    username: (0, $2CYkO.z).string().max(128).nullable().optional(),
    primaryEmail: (0, $2CYkO.z).string().max(128).nullable().optional(),
    primaryPhone: (0, $2CYkO.z).string().max(128).nullable().optional(),
    passwordEncrypted: (0, $2CYkO.z).string().max(128).nullable().optional(),
    passwordEncryptionMethod: (0, $2CYkO.z).nativeEnum((0, $3kVX5.UsersPasswordEncryptionMethod)).nullable().optional(),
    name: (0, $2CYkO.z).string().max(128).nullable().optional(),
    avatar: (0, $2CYkO.z).string().max(2048).nullable().optional(),
    applicationId: (0, $2CYkO.z).string().max(21).nullable().optional(),
    identities: (0, $8AotL.identitiesGuard).optional(),
    customData: (0, $123dJ.jsonObjectGuard).optional(),
    logtoConfig: (0, $123dJ.jsonObjectGuard).optional(),
    mfaVerifications: (0, $8AotL.mfaVerificationsGuard).optional(),
    isSuspended: (0, $2CYkO.z).boolean().optional(),
    lastSignInAt: (0, $2CYkO.z).number().nullable().optional(),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $50bb041b27f82bf1$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(12),
    username: (0, $2CYkO.z).string().max(128).nullable(),
    primaryEmail: (0, $2CYkO.z).string().max(128).nullable(),
    primaryPhone: (0, $2CYkO.z).string().max(128).nullable(),
    passwordEncrypted: (0, $2CYkO.z).string().max(128).nullable(),
    passwordEncryptionMethod: (0, $2CYkO.z).nativeEnum((0, $3kVX5.UsersPasswordEncryptionMethod)).nullable(),
    name: (0, $2CYkO.z).string().max(128).nullable(),
    avatar: (0, $2CYkO.z).string().max(2048).nullable(),
    applicationId: (0, $2CYkO.z).string().max(21).nullable(),
    identities: (0, $8AotL.identitiesGuard),
    customData: (0, $123dJ.jsonObjectGuard),
    logtoConfig: (0, $123dJ.jsonObjectGuard),
    mfaVerifications: (0, $8AotL.mfaVerificationsGuard),
    isSuspended: (0, $2CYkO.z).boolean(),
    lastSignInAt: (0, $2CYkO.z).number().nullable(),
    createdAt: (0, $2CYkO.z).number()
});
const $50bb041b27f82bf1$export$a69f017b19597ff5 = Object.freeze({
    table: "users",
    tableSingular: "user",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        username: "username",
        primaryEmail: "primary_email",
        primaryPhone: "primary_phone",
        passwordEncrypted: "password_encrypted",
        passwordEncryptionMethod: "password_encryption_method",
        name: "name",
        avatar: "avatar",
        applicationId: "application_id",
        identities: "identities",
        customData: "custom_data",
        logtoConfig: "logto_config",
        mfaVerifications: "mfa_verifications",
        isSuspended: "is_suspended",
        lastSignInAt: "last_sign_in_at",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "username",
        "primaryEmail",
        "primaryPhone",
        "passwordEncrypted",
        "passwordEncryptionMethod",
        "name",
        "avatar",
        "applicationId",
        "identities",
        "customData",
        "logtoConfig",
        "mfaVerifications",
        "isSuspended",
        "lastSignInAt",
        "createdAt"
    ],
    createGuard: $50bb041b27f82bf1$var$createGuard,
    guard: $50bb041b27f82bf1$var$guard,
    updateGuard: $50bb041b27f82bf1$var$guard.partial()
});

});

parcelRequire.register("gHzUB", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $c28c84dc32f6d1bd$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21)
});
const $c28c84dc32f6d1bd$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    roleId: (0, $2CYkO.z).string().min(1).max(21)
});
const $c28c84dc32f6d1bd$export$a93a64b4653e6020 = Object.freeze({
    table: "users_roles",
    tableSingular: "users_role",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        roleId: "role_id"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "roleId"
    ],
    createGuard: $c28c84dc32f6d1bd$var$createGuard,
    guard: $c28c84dc32f6d1bd$var$guard,
    updateGuard: $c28c84dc32f6d1bd$var$guard.partial()
});

});

parcelRequire.register("b6LKK", function(module, exports) {
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

var $2CYkO = parcelRequire("2CYkO");
const $81654c0162849569$var$createGuard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21).optional(),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    createdAt: (0, $2CYkO.z).number().optional()
});
const $81654c0162849569$var$guard = (0, $2CYkO.z).object({
    tenantId: (0, $2CYkO.z).string().max(21),
    id: (0, $2CYkO.z).string().min(1).max(21),
    userId: (0, $2CYkO.z).string().min(1).max(21),
    createdAt: (0, $2CYkO.z).number()
});
const $81654c0162849569$export$730f48ea7aa802b0 = Object.freeze({
    table: "verification_statuses",
    tableSingular: "verification_status",
    fields: {
        tenantId: "tenant_id",
        id: "id",
        userId: "user_id",
        createdAt: "created_at"
    },
    fieldKeys: [
        "tenantId",
        "id",
        "userId",
        "createdAt"
    ],
    createGuard: $81654c0162849569$var$createGuard,
    guard: $81654c0162849569$var$guard,
    updateGuard: $81654c0162849569$var$guard.partial()
});

});


parcelRequire.register("9Sgat", function(module, exports) {
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("86S23")).ConnectorPlatform; });
$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("fU2Vo")).ConnectorType; });
$parcel$export(module.exports, "AdminTenantRole", function () { return (parcelRequire("az3ON")).AdminTenantRole; });
$parcel$export(module.exports, "InternalRole", function () { return (parcelRequire("az3ON")).InternalRole; });
$parcel$export(module.exports, "PredefinedScope", function () { return (parcelRequire("az3ON")).PredefinedScope; });
$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return (parcelRequire("gmXIe")).LogtoOidcConfigKeyType; });
$parcel$export(module.exports, "LogtoTenantConfigKey", function () { return (parcelRequire("gmXIe")).LogtoTenantConfigKey; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return (parcelRequire("gmXIe")).SupportedSigningKeyAlgorithm; });
$parcel$export(module.exports, "maxUploadFileSize", function () { return (parcelRequire("b63Fl")).maxUploadFileSize; });
$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return (parcelRequire("7bVxi")).hookTestErrorResponseDataGuard; });
$parcel$export(module.exports, "Theme", function () { return (parcelRequire("bhvxB")).Theme; });
$parcel$export(module.exports, "SsoProviderName", function () { return (parcelRequire("5Je5u")).SsoProviderName; });
$parcel$export(module.exports, "TenantTag", function () { return (parcelRequire("3GN9E")).TenantTag; });
parcelRequire("aKOxQ");
parcelRequire("6cLiY");
parcelRequire("5XjkJ");
parcelRequire("az3ON");
parcelRequire("gmXIe");
parcelRequire("kfvQz");
parcelRequire("5HWIM");
parcelRequire("kj8Uj");
parcelRequire("is0c3");
parcelRequire("cWsht");
parcelRequire("4n9hf");
parcelRequire("8uiSc");
parcelRequire("2Pcks");
parcelRequire("b63Fl");
parcelRequire("7bVxi");
parcelRequire("4neNw");
parcelRequire("bhvxB");
parcelRequire("2o5Od");
parcelRequire("b4e8y");
parcelRequire("d4sIp");
parcelRequire("9AHlk");
parcelRequire("ENHWc");
parcelRequire("3Qlsh");
parcelRequire("5Je5u");
parcelRequire("3GN9E");

});
parcelRequire.register("aKOxQ", function(module, exports) {

$parcel$export(module.exports, "ConnectorType", function () { return (parcelRequire("fU2Vo")).ConnectorType; });
$parcel$export(module.exports, "ConnectorPlatform", function () { return (parcelRequire("86S23")).ConnectorPlatform; });
parcelRequire("j7Jj8");
var $86S23 = parcelRequire("86S23");
var $fU2Vo = parcelRequire("fU2Vo");

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("28jVG");
var $6Sjtu = parcelRequire("6Sjtu");
const $7d456867c305c0cc$export$b52523f950bcfb2f = (0, $6Sjtu.Connectors).guard.pick({
    id: true,
    syncProfile: true,
    config: true,
    metadata: true,
    connectorId: true
}).merge((0, $86S23.connectorMetadataGuard)).merge((0, $2CYkO.z).object({
    type: (0, $2CYkO.z).nativeEnum((0, $fU2Vo.ConnectorType)),
    isDemo: (0, $2CYkO.z).boolean().optional(),
    extraInfo: (0, $2CYkO.z).record((0, $2CYkO.z).unknown()).optional(),
    usage: (0, $2CYkO.z).number().optional()
}));
const $7d456867c305c0cc$export$8169eaabc815830f = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).nativeEnum((0, $fU2Vo.ConnectorType)),
    isDemo: (0, $2CYkO.z).boolean().optional()
}).merge((0, $86S23.connectorMetadataGuard));

});

parcelRequire.register("6cLiY", function(module, exports) {

var $4Za4K = parcelRequire("4Za4K");

var $5jKol = parcelRequire("5jKol");

var $axsUc = parcelRequire("axsUc");
const $48488ee1b8f44610$export$603af3d01cbca1e0 = "Unknown";

});
parcelRequire.register("4Za4K", function(module, exports) {
const $3a14acbceaa28929$export$82e9f45cca5ba907 = "Interaction";
var $3a14acbceaa28929$export$a455218a85c89869;
(function(Field) {
    Field["Event"] = "Event";
    Field["Identifier"] = "Identifier";
    Field["Profile"] = "Profile";
    Field["BindMfa"] = "BindMfa";
    Field["Mfa"] = "Mfa";
})($3a14acbceaa28929$export$a455218a85c89869 || ($3a14acbceaa28929$export$a455218a85c89869 = {}));
var $3a14acbceaa28929$export$31bb55db0b3e4187;
(function(Method) {
    Method["Password"] = "Password";
    Method["VerificationCode"] = "VerificationCode";
    Method["Social"] = "Social";
    Method["SingleSignOn"] = "SingleSignOn";
})($3a14acbceaa28929$export$31bb55db0b3e4187 || ($3a14acbceaa28929$export$31bb55db0b3e4187 = {}));
var $3a14acbceaa28929$export$e19cd5f9376f8cee;
(function(Action) {
    /** Create a new entity. (E.g. create an interaction, create a verification code) */ Action["Create"] = "Create";
    /** Update an existing entity. (E.g. change interaction type) */ Action["Update"] = "Update";
    /** Submit updated info to an entity, or submit to the system. (E.g. submit an interaction, submit a verification code to get verified) */ Action["Submit"] = "Submit";
    /** Delete a existing entity. (E.g delete profile ) */ Action["Delete"] = "Delete";
    /** Change an entity to the end state. (E.g. end an interaction) */ Action["End"] = "End";
})($3a14acbceaa28929$export$e19cd5f9376f8cee || ($3a14acbceaa28929$export$e19cd5f9376f8cee = {}));

});

parcelRequire.register("5jKol", function(module, exports) {
/** The type of a token event. */ var $3df2b6835a700132$export$92738401e1603719;
(function(Type) {
    Type["ExchangeTokenBy"] = "ExchangeTokenBy";
    Type["RevokeToken"] = "RevokeToken";
})($3df2b6835a700132$export$92738401e1603719 || ($3df2b6835a700132$export$92738401e1603719 = {}));
var $3df2b6835a700132$export$f435f793048e7a0f;
(function(TokenType) {
    TokenType["AccessToken"] = "AccessToken";
    TokenType["RefreshToken"] = "RefreshToken";
    TokenType["IdToken"] = "IdToken";
    TokenType["AuthorizationCode"] = "AuthorizationCode";
    TokenType["DeviceCode"] = "DeviceCode";
    TokenType["BackchannelAuthenticationRequest"] = "BackchannelAuthenticationRequest";
})($3df2b6835a700132$export$f435f793048e7a0f || ($3df2b6835a700132$export$f435f793048e7a0f = {}));
var $3df2b6835a700132$export$4a1942e414bbb622;
(function(ExchangeByType) {
    ExchangeByType["Unknown"] = "Unknown";
    ExchangeByType["AuthorizationCode"] = "AuthorizationCode";
    ExchangeByType["RefreshToken"] = "RefreshToken";
    ExchangeByType["ClientCredentials"] = "ClientCredentials";
})($3df2b6835a700132$export$4a1942e414bbb622 || ($3df2b6835a700132$export$4a1942e414bbb622 = {}));

});

parcelRequire.register("axsUc", function(module, exports) {
/** The type of a hook event. */ var $7ac3687cbde7d554$export$92738401e1603719;
(function(Type) {
    Type["TriggerHook"] = "TriggerHook";
})($7ac3687cbde7d554$export$92738401e1603719 || ($7ac3687cbde7d554$export$92738401e1603719 = {}));

});


parcelRequire.register("5XjkJ", function(module, exports) {
var $456175a1a1a9c754$export$ce68f19b50b39c0b;
(function(GrantType) {
    GrantType["AuthorizationCode"] = "authorization_code";
    GrantType["RefreshToken"] = "refresh_token";
    GrantType["ClientCredentials"] = "client_credentials";
})($456175a1a1a9c754$export$ce68f19b50b39c0b || ($456175a1a1a9c754$export$ce68f19b50b39c0b = {}));

});

parcelRequire.register("az3ON", function(module, exports) {

$parcel$export(module.exports, "userInfoGuard", function () { return $7b102281622b43a4$export$996c89999cd0d06b; });
$parcel$export(module.exports, "InternalRole", function () { return $7b102281622b43a4$export$a17952fc1a8aded7; });
$parcel$export(module.exports, "AdminTenantRole", function () { return $7b102281622b43a4$export$cc68ab3265ed0467; });
$parcel$export(module.exports, "PredefinedScope", function () { return $7b102281622b43a4$export$90d62586f282d378; });

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("28jVG");
var $6VJ3w = parcelRequire("6VJ3w");
var $pBtP5 = parcelRequire("pBtP5");
parcelRequire("irxkh");
var $bd0Y0 = parcelRequire("bd0Y0");
const $7b102281622b43a4$export$c917e1f6c2e1df9e = Object.freeze([
    "id",
    "username",
    "primaryEmail",
    "primaryPhone",
    "name",
    "avatar",
    "customData",
    "identities",
    "lastSignInAt",
    "createdAt",
    "applicationId",
    "isSuspended"
]);
const $7b102281622b43a4$export$996c89999cd0d06b = (0, $6VJ3w.Users).guard.pick(Object.fromEntries($7b102281622b43a4$export$c917e1f6c2e1df9e.map((key)=>[
        key,
        true
    ])));
const $7b102281622b43a4$export$78c9be0b3d74e4aa = $7b102281622b43a4$export$996c89999cd0d06b.extend({
    hasPassword: (0, $2CYkO.z).boolean().optional(),
    ssoIdentities: (0, $2CYkO.z).array((0, $pBtP5.UserSsoIdentities).guard).optional()
});
const $7b102281622b43a4$export$45a6ff4daa005563 = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    createdAt: (0, $2CYkO.z).string(),
    type: (0, $2CYkO.z).nativeEnum((0, $bd0Y0.MfaFactor)),
    agent: (0, $2CYkO.z).string().optional(),
    remainCodes: (0, $2CYkO.z).number().optional()
}).array();
var $7b102281622b43a4$export$a17952fc1a8aded7;
(function(InternalRole) {
    /**
     * Internal admin role for Machine-to-Machine apps in Logto user tenants.
     *
     * It should NOT be assigned to any user.
     */ InternalRole["Admin"] = "#internal:admin";
})($7b102281622b43a4$export$a17952fc1a8aded7 || ($7b102281622b43a4$export$a17952fc1a8aded7 = {}));
var $7b102281622b43a4$export$cc68ab3265ed0467;
(function(AdminTenantRole) {
    AdminTenantRole["Admin"] = "admin";
    /** Common user role in admin tenant. */ AdminTenantRole["User"] = "user";
    /** The role for machine to machine applications that represent a user tenant and send requests to Logto Cloud. */ AdminTenantRole["TenantApplication"] = "tenantApplication";
})($7b102281622b43a4$export$cc68ab3265ed0467 || ($7b102281622b43a4$export$cc68ab3265ed0467 = {}));
var $7b102281622b43a4$export$90d62586f282d378;
(function(PredefinedScope) {
    PredefinedScope["All"] = "all";
})($7b102281622b43a4$export$90d62586f282d378 || ($7b102281622b43a4$export$90d62586f282d378 = {}));
const $7b102281622b43a4$export$7ffb47057ef1f416 = (0, $6VJ3w.Users).guard.pick({
    id: true,
    avatar: true,
    name: true
});

});

parcelRequire.register("gmXIe", function(module, exports) {

$parcel$export(module.exports, "LogtoOidcConfigKeyType", function () { return $bead0511dc2512ef$export$15b2d6ce08800aad; });
$parcel$export(module.exports, "SupportedSigningKeyAlgorithm", function () { return $bead0511dc2512ef$export$e33814a1cc7d5e24; });
$parcel$export(module.exports, "LogtoTenantConfigKey", function () { return $bead0511dc2512ef$export$a249f1a8f5d6b725; });

var $2CYkO = parcelRequire("2CYkO");

var $3GN9E = parcelRequire("3GN9E");
var $bead0511dc2512ef$export$15b2d6ce08800aad;
(function(LogtoOidcConfigKeyType) {
    LogtoOidcConfigKeyType["PrivateKeys"] = "private-keys";
    LogtoOidcConfigKeyType["CookieKeys"] = "cookie-keys";
})($bead0511dc2512ef$export$15b2d6ce08800aad || ($bead0511dc2512ef$export$15b2d6ce08800aad = {}));
var $bead0511dc2512ef$export$30b1b445ccf496a4;
(function(LogtoOidcConfigKey) {
    LogtoOidcConfigKey["PrivateKeys"] = "oidc.privateKeys";
    LogtoOidcConfigKey["CookieKeys"] = "oidc.cookieKeys";
})($bead0511dc2512ef$export$30b1b445ccf496a4 || ($bead0511dc2512ef$export$30b1b445ccf496a4 = {}));
var $bead0511dc2512ef$export$e33814a1cc7d5e24;
(function(SupportedSigningKeyAlgorithm) {
    SupportedSigningKeyAlgorithm["RSA"] = "RSA";
    SupportedSigningKeyAlgorithm["EC"] = "EC";
})($bead0511dc2512ef$export$e33814a1cc7d5e24 || ($bead0511dc2512ef$export$e33814a1cc7d5e24 = {}));
const $bead0511dc2512ef$export$a1c94f11d0704ec5 = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    value: (0, $2CYkO.z).string(),
    createdAt: (0, $2CYkO.z).number()
});
const $bead0511dc2512ef$export$f5f9e866e854b681 = Object.freeze({
    [$bead0511dc2512ef$export$30b1b445ccf496a4.PrivateKeys]: $bead0511dc2512ef$export$a1c94f11d0704ec5.array(),
    [$bead0511dc2512ef$export$30b1b445ccf496a4.CookieKeys]: $bead0511dc2512ef$export$a1c94f11d0704ec5.array()
});
const $bead0511dc2512ef$export$73b6ce9fa4b1d915 = (0, $2CYkO.z).object({
    signInExperienceCustomized: (0, $2CYkO.z).boolean(),
    organizationCreated: (0, $2CYkO.z).boolean(),
    developmentTenantMigrationNotification: (0, $2CYkO.z).object({
        isPaidTenant: (0, $2CYkO.z).boolean(),
        tag: (0, $2CYkO.z).nativeEnum((0, $3GN9E.TenantTag)),
        readAt: (0, $2CYkO.z).number().optional()
    }).optional()
});
const $bead0511dc2512ef$export$bf5ba14ccde3732d = (0, $2CYkO.z).object({
    appId: (0, $2CYkO.z).string(),
    appSecret: (0, $2CYkO.z).string(),
    resource: (0, $2CYkO.z).string()
});
var $bead0511dc2512ef$export$a249f1a8f5d6b725;
(function(LogtoTenantConfigKey) {
    LogtoTenantConfigKey["AdminConsole"] = "adminConsole";
    LogtoTenantConfigKey["CloudConnection"] = "cloudConnection";
    /** The URL to redirect when session not found in Sign-in Experience. */ LogtoTenantConfigKey["SessionNotFoundRedirectUrl"] = "sessionNotFoundRedirectUrl";
})($bead0511dc2512ef$export$a249f1a8f5d6b725 || ($bead0511dc2512ef$export$a249f1a8f5d6b725 = {}));
const $bead0511dc2512ef$export$aebdc60e0ed8c4a5 = Object.freeze({
    [$bead0511dc2512ef$export$a249f1a8f5d6b725.AdminConsole]: $bead0511dc2512ef$export$73b6ce9fa4b1d915,
    [$bead0511dc2512ef$export$a249f1a8f5d6b725.CloudConnection]: $bead0511dc2512ef$export$bf5ba14ccde3732d,
    [$bead0511dc2512ef$export$a249f1a8f5d6b725.SessionNotFoundRedirectUrl]: (0, $2CYkO.z).object({
        url: (0, $2CYkO.z).string()
    })
});
const $bead0511dc2512ef$export$581c47e529f15f7a = Object.freeze([
    ...Object.values($bead0511dc2512ef$export$30b1b445ccf496a4),
    ...Object.values($bead0511dc2512ef$export$a249f1a8f5d6b725)
]);
const $bead0511dc2512ef$export$7684a7ad17d11565 = Object.freeze({
    ...$bead0511dc2512ef$export$f5f9e866e854b681,
    ...$bead0511dc2512ef$export$aebdc60e0ed8c4a5
});
const $bead0511dc2512ef$export$aeb5ffc4d17f8d05 = $bead0511dc2512ef$export$a1c94f11d0704ec5.omit({
    value: true
}).merge((0, $2CYkO.z).object({
    signingKeyAlgorithm: (0, $2CYkO.z).nativeEnum($bead0511dc2512ef$export$e33814a1cc7d5e24).optional()
}));

});
parcelRequire.register("3GN9E", function(module, exports) {

$parcel$export(module.exports, "TenantTag", function () { return $2afb6c6981894437$export$3baa67aafdc7045f; });
var $2afb6c6981894437$export$3baa67aafdc7045f;
(function(TenantTag) {
    /* Development tenants are free to use but are not meant to be used as production environment */ TenantTag["Development"] = "development";
    /* @deprecated */ TenantTag["Staging"] = "staging";
    /* A production tenant must have an associated subscription plan, even if it's a free plan */ TenantTag["Production"] = "production";
})($2afb6c6981894437$export$3baa67aafdc7045f || ($2afb6c6981894437$export$3baa67aafdc7045f = {}));

});


parcelRequire.register("kfvQz", function(module, exports) {
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("irxkh");
var $123dJ = parcelRequire("123dJ");
var $bd0Y0 = parcelRequire("bd0Y0");
var $8AotL = parcelRequire("8AotL");

var $4n9hf = parcelRequire("4n9hf");
const $ebdde983f395606e$export$6df2cc07ea6d94e4 = (0, $2CYkO.z).object({
    username: (0, $2CYkO.z).string().min(1),
    password: (0, $2CYkO.z).string().min(1)
});
const $ebdde983f395606e$export$fe8dab8622cea973 = (0, $2CYkO.z).object({
    email: (0, $2CYkO.z).string().min(1),
    password: (0, $2CYkO.z).string().min(1)
});
const $ebdde983f395606e$export$654a1e6496f28807 = (0, $2CYkO.z).object({
    phone: (0, $2CYkO.z).string().min(1),
    password: (0, $2CYkO.z).string().min(1)
});
const $ebdde983f395606e$export$37cf496dfd2fc283 = (0, $2CYkO.z).object({
    connectorId: (0, $2CYkO.z).string(),
    connectorData: (0, $123dJ.jsonObjectGuard)
});
const $ebdde983f395606e$export$c45e1b6fde4cf46f = (0, $2CYkO.z).object({
    connectorId: (0, $2CYkO.z).string(),
    email: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$368d623e521112fc = (0, $2CYkO.z).object({
    connectorId: (0, $2CYkO.z).string(),
    phone: (0, $2CYkO.z).string()
});
var $ebdde983f395606e$export$5b6496a0e009b82d;
(function(InteractionEvent) {
    InteractionEvent["SignIn"] = "SignIn";
    InteractionEvent["Register"] = "Register";
    InteractionEvent["ForgotPassword"] = "ForgotPassword";
})($ebdde983f395606e$export$5b6496a0e009b82d || ($ebdde983f395606e$export$5b6496a0e009b82d = {}));
const $ebdde983f395606e$export$bdffc825a5318abd = (0, $2CYkO.z).nativeEnum($ebdde983f395606e$export$5b6496a0e009b82d);
const $ebdde983f395606e$export$683a5ef9930735ce = (0, $2CYkO.z).union([
    $ebdde983f395606e$export$6df2cc07ea6d94e4,
    $ebdde983f395606e$export$fe8dab8622cea973,
    $ebdde983f395606e$export$654a1e6496f28807,
    (0, $4n9hf.emailVerificationCodePayloadGuard),
    (0, $4n9hf.phoneVerificationCodePayloadGuard),
    $ebdde983f395606e$export$37cf496dfd2fc283,
    $ebdde983f395606e$export$c45e1b6fde4cf46f,
    $ebdde983f395606e$export$368d623e521112fc
]);
const $ebdde983f395606e$export$5f4b9d03b6e579b = (0, $2CYkO.z).object({
    username: (0, $2CYkO.z).string().regex((0, $dQcUe.usernameRegEx)).optional(),
    email: (0, $2CYkO.z).string().regex((0, $dQcUe.emailRegEx)).optional(),
    phone: (0, $2CYkO.z).string().regex((0, $dQcUe.phoneRegEx)).optional(),
    connectorId: (0, $2CYkO.z).string().optional(),
    password: (0, $2CYkO.z).string().optional()
});
var $ebdde983f395606e$export$68a887ed3b61b98e;
(function(MissingProfile) {
    MissingProfile["username"] = "username";
    MissingProfile["email"] = "email";
    MissingProfile["phone"] = "phone";
    MissingProfile["password"] = "password";
    MissingProfile["emailOrPhone"] = "emailOrPhone";
})($ebdde983f395606e$export$68a887ed3b61b98e || ($ebdde983f395606e$export$68a887ed3b61b98e = {}));
const $ebdde983f395606e$export$3cf8b0ef3f34f283 = (0, $2CYkO.z).object({
    // Unlike identifier payload which has indicator like "email",
    // mfa payload must have an additional type field to indicate type
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).TOTP),
    code: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$909f398f25e38a05 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).WebAuthn),
    id: (0, $2CYkO.z).string(),
    rawId: (0, $2CYkO.z).string(),
    /**
     * The response from WebAuthn API
     *
     * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/PublicKeyCredential}
     */ response: (0, $2CYkO.z).object({
        clientDataJSON: (0, $2CYkO.z).string(),
        attestationObject: (0, $2CYkO.z).string(),
        authenticatorData: (0, $2CYkO.z).string().optional(),
        transports: (0, $8AotL.webAuthnTransportGuard).array().optional(),
        publicKeyAlgorithm: (0, $2CYkO.z).number().optional(),
        publicKey: (0, $2CYkO.z).string().optional()
    }),
    authenticatorAttachment: (0, $2CYkO.z).enum([
        "cross-platform",
        "platform"
    ]).optional(),
    clientExtensionResults: (0, $2CYkO.z).object({
        appid: (0, $2CYkO.z).boolean().optional(),
        crepProps: (0, $2CYkO.z).object({
            rk: (0, $2CYkO.z).boolean().optional()
        }).optional(),
        hmacCreateSecret: (0, $2CYkO.z).boolean().optional()
    })
});
const $ebdde983f395606e$export$f2b00820cf0758fd = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).BackupCode)
});
const $ebdde983f395606e$export$dd85cb6e2ec2273d = (0, $2CYkO.z).discriminatedUnion("type", [
    $ebdde983f395606e$export$3cf8b0ef3f34f283,
    $ebdde983f395606e$export$909f398f25e38a05,
    $ebdde983f395606e$export$f2b00820cf0758fd
]);
const $ebdde983f395606e$export$850eb029f701b547 = $ebdde983f395606e$export$3cf8b0ef3f34f283;
const $ebdde983f395606e$export$4cf08ba69fb7c5b0 = $ebdde983f395606e$export$909f398f25e38a05.omit({
    response: true
}).extend({
    response: (0, $2CYkO.z).object({
        clientDataJSON: (0, $2CYkO.z).string(),
        authenticatorData: (0, $2CYkO.z).string(),
        signature: (0, $2CYkO.z).string(),
        userHandle: (0, $2CYkO.z).string().optional()
    })
});
const $ebdde983f395606e$export$975166347c3a7642 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).BackupCode),
    code: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$4d6ec7236b10bd3 = (0, $2CYkO.z).discriminatedUnion("type", [
    $ebdde983f395606e$export$850eb029f701b547,
    $ebdde983f395606e$export$4cf08ba69fb7c5b0,
    $ebdde983f395606e$export$975166347c3a7642
]);
const $ebdde983f395606e$export$fc67cd5d235908c3 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).TOTP),
    secret: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$5159fecc862158ed = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).WebAuthn),
    challenge: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$ea1eb8d3018f63a8 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).BackupCode),
    codes: (0, $2CYkO.z).array((0, $2CYkO.z).string())
});
const $ebdde983f395606e$export$ad9fd10992842c85 = (0, $2CYkO.z).discriminatedUnion("type", [
    $ebdde983f395606e$export$fc67cd5d235908c3,
    $ebdde983f395606e$export$5159fecc862158ed,
    $ebdde983f395606e$export$ea1eb8d3018f63a8
]);
const $ebdde983f395606e$export$4a8ba443157a60f8 = $ebdde983f395606e$export$fc67cd5d235908c3;
const $ebdde983f395606e$export$9c31fcc1c40b68d4 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).literal((0, $bd0Y0.MfaFactor).WebAuthn),
    credentialId: (0, $2CYkO.z).string(),
    publicKey: (0, $2CYkO.z).string(),
    transports: (0, $8AotL.webAuthnTransportGuard).array(),
    counter: (0, $2CYkO.z).number(),
    agent: (0, $2CYkO.z).string()
});
const $ebdde983f395606e$export$d103a080e257fd4e = $ebdde983f395606e$export$ea1eb8d3018f63a8;
const $ebdde983f395606e$export$346032d688e2ee1d = (0, $2CYkO.z).discriminatedUnion("type", [
    $ebdde983f395606e$export$4a8ba443157a60f8,
    $ebdde983f395606e$export$9c31fcc1c40b68d4,
    $ebdde983f395606e$export$d103a080e257fd4e
]);
const $ebdde983f395606e$export$7d4f7ea03460ffc6 = (0, $2CYkO.z).object({
    type: (0, $2CYkO.z).nativeEnum((0, $bd0Y0.MfaFactor)),
    id: (0, $2CYkO.z).string()
});

});
parcelRequire.register("4n9hf", function(module, exports) {

$parcel$export(module.exports, "emailVerificationCodePayloadGuard", function () { return $32f081a40769d4e3$export$37e88450d6946bf5; });
$parcel$export(module.exports, "phoneVerificationCodePayloadGuard", function () { return $32f081a40769d4e3$export$7934fcc6bad2c738; });
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");

var $2CYkO = parcelRequire("2CYkO");
const $32f081a40769d4e3$var$emailIdentifierGuard = (0, $2CYkO.z).string().regex((0, $dQcUe.emailRegEx));
const $32f081a40769d4e3$var$phoneIdentifierGuard = (0, $2CYkO.z).string().regex((0, $dQcUe.phoneRegEx));
const $32f081a40769d4e3$var$codeGuard = (0, $2CYkO.z).string().min(1);
const $32f081a40769d4e3$export$6d0d05bfd78fb80d = (0, $2CYkO.z).union([
    (0, $2CYkO.z).object({
        email: $32f081a40769d4e3$var$emailIdentifierGuard
    }),
    (0, $2CYkO.z).object({
        phone: $32f081a40769d4e3$var$phoneIdentifierGuard
    })
]);
const $32f081a40769d4e3$export$37e88450d6946bf5 = (0, $2CYkO.z).object({
    email: $32f081a40769d4e3$var$emailIdentifierGuard,
    verificationCode: $32f081a40769d4e3$var$codeGuard
});
const $32f081a40769d4e3$export$7934fcc6bad2c738 = (0, $2CYkO.z).object({
    phone: $32f081a40769d4e3$var$phoneIdentifierGuard,
    verificationCode: $32f081a40769d4e3$var$codeGuard
});
const $32f081a40769d4e3$export$40faae2aa67d03fa = (0, $2CYkO.z).union([
    $32f081a40769d4e3$export$37e88450d6946bf5,
    $32f081a40769d4e3$export$7934fcc6bad2c738
]);

});


parcelRequire.register("5HWIM", function(module, exports) {
/** Mode for matching the given value(s) and database entries. */ var $427e84b85785f9dd$export$a51f1551b9b55e4d;
(function(SearchMatchMode) {
    /** Use `=` or in-array checking. */ SearchMatchMode["Exact"] = "exact";
    /** Use the keyword `LIKE`. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-LIKE). */ SearchMatchMode["Like"] = "like";
    /** Use the keyword `SIMILAR TO` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-SIMILARTO-REGEXP). */ SearchMatchMode["SimilarTo"] = "similar_to";
    /** Use the keyword `POSIX` for regular expression matching. See [Postgres docs](https://www.postgresql.org/docs/current/functions-matching.html#FUNCTIONS-POSIX-REGEXP). */ SearchMatchMode["Posix"] = "posix";
})($427e84b85785f9dd$export$a51f1551b9b55e4d || ($427e84b85785f9dd$export$a51f1551b9b55e4d = {}));
var $427e84b85785f9dd$export$6d217b707eba5852;
(function(SearchJointMode) {
    SearchJointMode["Or"] = "or";
    SearchJointMode["And"] = "and";
})($427e84b85785f9dd$export$6d217b707eba5852 || ($427e84b85785f9dd$export$6d217b707eba5852 = {}));

});

parcelRequire.register("kj8Uj", function(module, exports) {

});

parcelRequire.register("is0c3", function(module, exports) {
parcelRequire("28jVG");
var $gYQf2 = parcelRequire("gYQf2");
var $6E1ca = parcelRequire("6E1ca");
const $d6eafdee94ff89ee$export$3efa9f96d1ddc3f2 = (0, $gYQf2.Scopes).guard.extend({
    resource: (0, $6E1ca.Resources).guard
});

});

parcelRequire.register("cWsht", function(module, exports) {

});

parcelRequire.register("8uiSc", function(module, exports) {
parcelRequire("28jVG");
var $d7Klp = parcelRequire("d7Klp");
const $62dfc3e39a4be473$export$71547dc50acd9a7c = (0, $d7Klp.Applications).guard.pick({
    id: true,
    name: true,
    type: true
});

});

parcelRequire.register("2Pcks", function(module, exports) {

var $2CYkO = parcelRequire("2CYkO");
var $20e9e873dc6ac464$export$4857b48889187a39;
(function(AlterationStateKey) {
    AlterationStateKey["AlterationState"] = "alterationState";
})($20e9e873dc6ac464$export$4857b48889187a39 || ($20e9e873dc6ac464$export$4857b48889187a39 = {}));
const $20e9e873dc6ac464$export$b648b84528d1cda3 = Object.freeze({
    [$20e9e873dc6ac464$export$4857b48889187a39.AlterationState]: (0, $2CYkO.z).object({
        timestamp: (0, $2CYkO.z).number(),
        updatedAt: (0, $2CYkO.z).string().optional()
    })
});
var $20e9e873dc6ac464$export$465a18018f692373;
(function(StorageProvider) {
    StorageProvider["AzureStorage"] = "AzureStorage";
    StorageProvider["S3Storage"] = "S3Storage";
    StorageProvider["GoogleStorage"] = "GoogleStorage";
})($20e9e873dc6ac464$export$465a18018f692373 || ($20e9e873dc6ac464$export$465a18018f692373 = {}));
const $20e9e873dc6ac464$var$basicConfig = {
    publicUrl: (0, $2CYkO.z).string().optional()
};
const $20e9e873dc6ac464$export$6882da4bfe6c548e = (0, $2CYkO.z).discriminatedUnion("provider", [
    (0, $2CYkO.z).object({
        provider: (0, $2CYkO.z).literal($20e9e873dc6ac464$export$465a18018f692373.AzureStorage),
        connectionString: (0, $2CYkO.z).string(),
        container: (0, $2CYkO.z).string(),
        ...$20e9e873dc6ac464$var$basicConfig
    }),
    (0, $2CYkO.z).object({
        provider: (0, $2CYkO.z).literal($20e9e873dc6ac464$export$465a18018f692373.S3Storage),
        endpoint: (0, $2CYkO.z).string().optional(),
        region: (0, $2CYkO.z).string().optional(),
        bucket: (0, $2CYkO.z).string(),
        accessKeyId: (0, $2CYkO.z).string(),
        accessSecretKey: (0, $2CYkO.z).string(),
        ...$20e9e873dc6ac464$var$basicConfig
    }),
    (0, $2CYkO.z).object({
        provider: (0, $2CYkO.z).literal($20e9e873dc6ac464$export$465a18018f692373.GoogleStorage),
        projectId: (0, $2CYkO.z).string(),
        keyFilename: (0, $2CYkO.z).string(),
        bucketName: (0, $2CYkO.z).string(),
        ...$20e9e873dc6ac464$var$basicConfig
    })
]);
var $20e9e873dc6ac464$export$589fea410707bd1e;
(function(StorageProviderKey) {
    StorageProviderKey["StorageProvider"] = "storageProvider";
})($20e9e873dc6ac464$export$589fea410707bd1e || ($20e9e873dc6ac464$export$589fea410707bd1e = {}));
const $20e9e873dc6ac464$export$1755428192b369f4 = Object.freeze({
    [$20e9e873dc6ac464$export$589fea410707bd1e.StorageProvider]: $20e9e873dc6ac464$export$6882da4bfe6c548e
});
var $20e9e873dc6ac464$export$c04e0db396d22ede;
(function(EmailServiceProvider) {
    EmailServiceProvider["SendGrid"] = "SendGrid";
})($20e9e873dc6ac464$export$c04e0db396d22ede || ($20e9e873dc6ac464$export$c04e0db396d22ede = {}));
const $20e9e873dc6ac464$export$ae559586eab6a29d = (0, $2CYkO.z).object({
    provider: (0, $2CYkO.z).literal($20e9e873dc6ac464$export$c04e0db396d22ede.SendGrid),
    apiKey: (0, $2CYkO.z).string(),
    templateId: (0, $2CYkO.z).string(),
    fromName: (0, $2CYkO.z).string(),
    fromEmail: (0, $2CYkO.z).string()
});
const $20e9e873dc6ac464$export$eed90e6abe4b6331 = (0, $2CYkO.z).discriminatedUnion("provider", [
    $20e9e873dc6ac464$export$ae559586eab6a29d
]);
var $20e9e873dc6ac464$export$1b716a2fb233f165;
(function(EmailServiceProviderKey) {
    EmailServiceProviderKey["EmailServiceProvider"] = "emailServiceProvider";
})($20e9e873dc6ac464$export$1b716a2fb233f165 || ($20e9e873dc6ac464$export$1b716a2fb233f165 = {}));
const $20e9e873dc6ac464$export$148ac52baf2fe1fe = Object.freeze({
    [$20e9e873dc6ac464$export$1b716a2fb233f165.EmailServiceProvider]: $20e9e873dc6ac464$export$eed90e6abe4b6331
});
var $20e9e873dc6ac464$export$3f96ea771b870c9b;
(function(DemoSocialProvider) {
    DemoSocialProvider["Google"] = "google";
    DemoSocialProvider["GitHub"] = "github";
    DemoSocialProvider["Discord"] = "discord";
})($20e9e873dc6ac464$export$3f96ea771b870c9b || ($20e9e873dc6ac464$export$3f96ea771b870c9b = {}));
const $20e9e873dc6ac464$export$b0cb774a6cdd5c2c = (0, $2CYkO.z).object({
    name: (0, $2CYkO.z).string(),
    logo: (0, $2CYkO.z).string(),
    logoDark: (0, $2CYkO.z).string(),
    provider: (0, $2CYkO.z).nativeEnum($20e9e873dc6ac464$export$3f96ea771b870c9b),
    clientId: (0, $2CYkO.z).string()
}).array();
var $20e9e873dc6ac464$export$2b6e95870946a21e;
(function(DemoSocialKey) {
    DemoSocialKey["DemoSocial"] = "demoSocial";
})($20e9e873dc6ac464$export$2b6e95870946a21e || ($20e9e873dc6ac464$export$2b6e95870946a21e = {}));
const $20e9e873dc6ac464$export$ae90bacd174e78c0 = Object.freeze({
    [$20e9e873dc6ac464$export$2b6e95870946a21e.DemoSocial]: $20e9e873dc6ac464$export$b0cb774a6cdd5c2c
});
const $20e9e873dc6ac464$export$4792a20f2d99e347 = (0, $2CYkO.z).object({
    zoneId: (0, $2CYkO.z).string(),
    apiToken: (0, $2CYkO.z).string()
});
var $20e9e873dc6ac464$export$24bf5ccdb699e65e;
(function(CloudflareKey) {
    CloudflareKey["HostnameProvider"] = "cloudflareHostnameProvider";
})($20e9e873dc6ac464$export$24bf5ccdb699e65e || ($20e9e873dc6ac464$export$24bf5ccdb699e65e = {}));
const $20e9e873dc6ac464$export$7dae3b09179b4445 = Object.freeze({
    [$20e9e873dc6ac464$export$24bf5ccdb699e65e.HostnameProvider]: $20e9e873dc6ac464$export$4792a20f2d99e347
});
const $20e9e873dc6ac464$export$20b0450fb73770e2 = Object.freeze([
    ...Object.values($20e9e873dc6ac464$export$4857b48889187a39),
    ...Object.values($20e9e873dc6ac464$export$589fea410707bd1e),
    ...Object.values($20e9e873dc6ac464$export$2b6e95870946a21e),
    ...Object.values($20e9e873dc6ac464$export$24bf5ccdb699e65e),
    ...Object.values($20e9e873dc6ac464$export$1b716a2fb233f165)
]);
const $20e9e873dc6ac464$export$b74a29afb5bd243f = Object.freeze({
    ...$20e9e873dc6ac464$export$b648b84528d1cda3,
    ...$20e9e873dc6ac464$export$1755428192b369f4,
    ...$20e9e873dc6ac464$export$ae90bacd174e78c0,
    ...$20e9e873dc6ac464$export$7dae3b09179b4445,
    ...$20e9e873dc6ac464$export$148ac52baf2fe1fe
});

});

parcelRequire.register("b63Fl", function(module, exports) {

$parcel$export(module.exports, "maxUploadFileSize", function () { return $814319304405a86d$export$8ef133238cd2874; });

var $2CYkO = parcelRequire("2CYkO");
const $814319304405a86d$export$8ef133238cd2874 = 8388608; // 8MB
const $814319304405a86d$export$e2adfe8ff5d50ee4 = [
    "image/jpeg",
    "image/png",
    "image/gif",
    "image/vnd.microsoft.icon",
    "image/svg+xml",
    "image/tiff",
    "image/webp",
    "image/bmp"
];
const $814319304405a86d$var$allowUploadMimeTypeGuard = (0, $2CYkO.z).enum($814319304405a86d$export$e2adfe8ff5d50ee4);
const $814319304405a86d$export$2dd272e4b553b8ba = (0, $2CYkO.z).object({
    status: (0, $2CYkO.z).union([
        (0, $2CYkO.z).literal("ready"),
        (0, $2CYkO.z).literal("not_configured")
    ]),
    allowUploadMimeTypes: (0, $2CYkO.z).array($814319304405a86d$var$allowUploadMimeTypeGuard).optional(),
    maxUploadFileSize: (0, $2CYkO.z).number().optional()
});
const $814319304405a86d$export$aaf4674b6bfc26fb = (0, $2CYkO.z).object({
    url: (0, $2CYkO.z).string()
});

});

parcelRequire.register("7bVxi", function(module, exports) {

$parcel$export(module.exports, "hookTestErrorResponseDataGuard", function () { return $53c630f5c5d86c81$export$4d1fa1bc05a05454; });

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("28jVG");
var $iHoE6 = parcelRequire("iHoE6");
const $53c630f5c5d86c81$var$hookExecutionStatsGuard = (0, $2CYkO.z).object({
    successCount: (0, $2CYkO.z).number(),
    requestCount: (0, $2CYkO.z).number()
});
const $53c630f5c5d86c81$export$5c5f088aefddc59e = (0, $iHoE6.Hooks).guard.extend({
    executionStats: $53c630f5c5d86c81$var$hookExecutionStatsGuard
});
const $53c630f5c5d86c81$export$4d1fa1bc05a05454 = (0, $2CYkO.z).object({
    responseStatus: (0, $2CYkO.z).number(),
    responseBody: (0, $2CYkO.z).string()
});

});

parcelRequire.register("4neNw", function(module, exports) {
var $32f4c9f3d4c8dc1b$export$2cad645b7df28dd5;
(function(ServiceLogType) {
    ServiceLogType["SendEmail"] = "sendEmail";
    ServiceLogType["SendSms"] = "sendSms";
})($32f4c9f3d4c8dc1b$export$2cad645b7df28dd5 || ($32f4c9f3d4c8dc1b$export$2cad645b7df28dd5 = {}));

});

parcelRequire.register("bhvxB", function(module, exports) {

$parcel$export(module.exports, "Theme", function () { return $8369bf98e7cb11fd$export$14faa19a0f3bbeb2; });
var $8369bf98e7cb11fd$export$14faa19a0f3bbeb2;
(function(Theme) {
    Theme["Light"] = "light";
    Theme["Dark"] = "dark";
})($8369bf98e7cb11fd$export$14faa19a0f3bbeb2 || ($8369bf98e7cb11fd$export$14faa19a0f3bbeb2 = {}));

});

parcelRequire.register("2o5Od", function(module, exports) {

var $2CYkO = parcelRequire("2CYkO");
const $1bd25432144fe7c2$export$3b9208034fe791c1 = (0, $2CYkO.z).object({
    appId: (0, $2CYkO.z).string()
}).partial();

});

parcelRequire.register("b4e8y", function(module, exports) {

var $2CYkO = parcelRequire("2CYkO");
const $80eb08bfe90c2421$var$dashboardUsersDataGuard = (0, $2CYkO.object)({
    count: (0, $2CYkO.number)(),
    delta: (0, $2CYkO.number)()
});
const $80eb08bfe90c2421$export$9d1c6ddb5817c52e = (0, $2CYkO.object)({
    today: $80eb08bfe90c2421$var$dashboardUsersDataGuard,
    last7Days: $80eb08bfe90c2421$var$dashboardUsersDataGuard
});
const $80eb08bfe90c2421$export$fd0651ecbc2a1652 = (0, $2CYkO.object)({
    dauCurve: (0, $2CYkO.array)((0, $2CYkO.object)({
        date: (0, $2CYkO.string)(),
        count: (0, $2CYkO.number)()
    })),
    dau: $80eb08bfe90c2421$var$dashboardUsersDataGuard,
    wau: $80eb08bfe90c2421$var$dashboardUsersDataGuard,
    mau: $80eb08bfe90c2421$var$dashboardUsersDataGuard
});

});

parcelRequire.register("d4sIp", function(module, exports) {
parcelRequire("28jVG");
var $6eJOs = parcelRequire("6eJOs");
const $9841ec56230fe2f9$export$81290fbb16f7e442 = Object.freeze([
    "id",
    "domain",
    "status",
    "errorMessage",
    "dnsRecords"
]);
const $9841ec56230fe2f9$export$8181686bf073ccc4 = (0, $6eJOs.Domains).guard.pick({
    id: true,
    domain: true,
    status: true,
    errorMessage: true,
    dnsRecords: true
});

});

parcelRequire.register("9AHlk", function(module, exports) {
/**
 * The sentinel class interface.
 *
 * Sentinels are responsible for accepting activity reports and making decisions based on them.
 *
 * For example, for a user sign-in activity, the sentinel might decide to:
 *
 * - Accept since the user uses the same device and location as usual;
 * - Require a MFA code since the user uses a new device or location;
 * - Block the user since the user tried to sign-in too many times with an incorrect password.
 *
 * The implementation should be privacy-aware and not store any personal identifiable information.
 */ class $01cd4eda2fca4ea6$export$84d34c4405d4a2e8 {
}

});

parcelRequire.register("ENHWc", function(module, exports) {

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("123dJ");
var $8AotL = parcelRequire("8AotL");
const $07aa4b73370551de$export$2334438dedb2ca6f = (0, $2CYkO.z).object({
    rp: (0, $2CYkO.z).object({
        name: (0, $2CYkO.z).string(),
        id: (0, $2CYkO.z).string().optional()
    }),
    user: (0, $2CYkO.z).object({
        id: (0, $2CYkO.z).string(),
        name: (0, $2CYkO.z).string(),
        displayName: (0, $2CYkO.z).string()
    }),
    challenge: (0, $2CYkO.z).string(),
    pubKeyCredParams: (0, $2CYkO.z).array((0, $2CYkO.z).object({
        type: (0, $2CYkO.z).literal("public-key"),
        alg: (0, $2CYkO.z).number()
    })),
    timeout: (0, $2CYkO.z).number().optional(),
    excludeCredentials: (0, $2CYkO.z).array((0, $2CYkO.z).object({
        type: (0, $2CYkO.z).literal("public-key"),
        id: (0, $2CYkO.z).string(),
        transports: (0, $8AotL.webAuthnTransportGuard).array().optional()
    })).optional(),
    authenticatorSelection: (0, $2CYkO.z).object({
        authenticatorAttachment: (0, $2CYkO.z).enum([
            "platform",
            "cross-platform"
        ]).optional(),
        requireResidentKey: (0, $2CYkO.z).boolean().optional(),
        residentKey: (0, $2CYkO.z).enum([
            "discouraged",
            "preferred",
            "required"
        ]).optional(),
        userVerification: (0, $2CYkO.z).enum([
            "required",
            "preferred",
            "discouraged"
        ]).optional()
    }).optional(),
    attestation: (0, $2CYkO.z).enum([
        "none",
        "indirect",
        "direct",
        "enterprise"
    ]).optional(),
    extensions: (0, $2CYkO.z).object({
        appid: (0, $2CYkO.z).string().optional(),
        credProps: (0, $2CYkO.z).boolean().optional(),
        hmacCreateSecret: (0, $2CYkO.z).boolean().optional()
    }).optional()
});
const $07aa4b73370551de$export$e849189769e7ddda = (0, $2CYkO.z).object({
    challenge: (0, $2CYkO.z).string(),
    timeout: (0, $2CYkO.z).number().optional(),
    rpId: (0, $2CYkO.z).string().optional(),
    allowCredentials: (0, $2CYkO.z).array((0, $2CYkO.z).object({
        type: (0, $2CYkO.z).literal("public-key"),
        id: (0, $2CYkO.z).string(),
        transports: (0, $8AotL.webAuthnTransportGuard).array().optional()
    })).optional(),
    userVerification: (0, $2CYkO.z).enum([
        "required",
        "preferred",
        "discouraged"
    ]).optional(),
    extensions: (0, $2CYkO.z).object({
        appid: (0, $2CYkO.z).string().optional(),
        credProps: (0, $2CYkO.z).boolean().optional(),
        hmacCreateSecret: (0, $2CYkO.z).boolean().optional()
    }).optional()
});

});

parcelRequire.register("3Qlsh", function(module, exports) {

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("28jVG");
var $kGaan = parcelRequire("kGaan");
var $eaNw6 = parcelRequire("eaNw6");

var $az3ON = parcelRequire("az3ON");
const $2cc6defd8dfce58a$export$a8f6e59aae709371 = (0, $kGaan.OrganizationRoles).guard.extend({
    scopes: (0, $2CYkO.z).object({
        id: (0, $2CYkO.z).string(),
        name: (0, $2CYkO.z).string()
    }).array()
});
const $2cc6defd8dfce58a$var$organizationRoleEntityGuard = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    name: (0, $2CYkO.z).string()
});
const $2cc6defd8dfce58a$export$a1b68498f213370c = (0, $eaNw6.Organizations).guard.extend({
    organizationRoles: $2cc6defd8dfce58a$var$organizationRoleEntityGuard.array()
});
const $2cc6defd8dfce58a$export$6c095334bcf53b71 = (0, $az3ON.userInfoGuard).extend({
    organizationRoles: $2cc6defd8dfce58a$var$organizationRoleEntityGuard.array()
});

});

parcelRequire.register("5Je5u", function(module, exports) {

$parcel$export(module.exports, "SsoProviderName", function () { return $42bc153bbc5c8509$export$88b6bcc5c3531d29; });
$parcel$export(module.exports, "singleSignOnDomainBlackList", function () { return $42bc153bbc5c8509$export$92ee0fc3a3bf5566; });

var $2CYkO = parcelRequire("2CYkO");

var $gVPlq = parcelRequire("gVPlq");
const $42bc153bbc5c8509$export$7f91c1744e02ec3c = (0, $2CYkO.z).object({
    id: (0, $2CYkO.z).string(),
    connectorName: (0, $2CYkO.z).string(),
    logo: (0, $2CYkO.z).string(),
    darkLogo: (0, $2CYkO.z).string().optional()
});
var $42bc153bbc5c8509$export$88b6bcc5c3531d29;
(function(SsoProviderName) {
    SsoProviderName["OIDC"] = "OIDC";
    SsoProviderName["SAML"] = "SAML";
    SsoProviderName["AZURE_AD"] = "AzureAD";
    SsoProviderName["GOOGLE_WORKSPACE"] = "GoogleWorkspace";
    SsoProviderName["OKTA"] = "Okta";
})($42bc153bbc5c8509$export$88b6bcc5c3531d29 || ($42bc153bbc5c8509$export$88b6bcc5c3531d29 = {}));
const $42bc153bbc5c8509$export$92ee0fc3a3bf5566 = Object.freeze([
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "live.com",
    "icloud.com",
    "aol.com",
    "yandex.com",
    "mail.com",
    "protonmail.com",
    "yanex.com",
    "gmx.com",
    "mail.ru",
    "zoho.com",
    "qq.com",
    "163.com",
    "126.com",
    "sina.com",
    "sohu.com"
]);
const $42bc153bbc5c8509$var$ssoConnectorProviderDetailGuard = (0, $2CYkO.z).object({
    providerName: (0, $2CYkO.z).nativeEnum($42bc153bbc5c8509$export$88b6bcc5c3531d29),
    logo: (0, $2CYkO.z).string(),
    logoDark: (0, $2CYkO.z).string(),
    description: (0, $2CYkO.z).string(),
    name: (0, $2CYkO.z).string()
});
const $42bc153bbc5c8509$export$daec852f2106e44c = (0, $2CYkO.z).array($42bc153bbc5c8509$var$ssoConnectorProviderDetailGuard);
const $42bc153bbc5c8509$export$a536522a091757cc = (0, $gVPlq.SsoConnectors).guard.omit({
    providerName: true
}).merge((0, $2CYkO.z).object({
    name: (0, $2CYkO.z).string(),
    providerName: (0, $2CYkO.z).nativeEnum($42bc153bbc5c8509$export$88b6bcc5c3531d29),
    providerLogo: (0, $2CYkO.z).string(),
    providerLogoDark: (0, $2CYkO.z).string(),
    providerConfig: (0, $2CYkO.z).record((0, $2CYkO.z).unknown()).optional()
}));

});


parcelRequire.register("3mK2t", function(module, exports) {
parcelRequire("e7q2d");

});
parcelRequire.register("e7q2d", function(module, exports) {

});


parcelRequire.register("hubhU", function(module, exports) {
$parcel$export(module.exports, "adminConsoleApplicationId", function () { return (parcelRequire("faCyI")).adminConsoleApplicationId; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return (parcelRequire("faCyI")).demoAppApplicationId; });
$parcel$export(module.exports, "cloudApiIndicator", function () { return (parcelRequire("7ZL8j")).cloudApiIndicator; });
$parcel$export(module.exports, "CloudScope", function () { return (parcelRequire("7ZL8j")).CloudScope; });
$parcel$export(module.exports, "defaultManagementApi", function () { return (parcelRequire("5fvIO")).defaultManagementApi; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return (parcelRequire("5fvIO")).getManagementApiResourceIndicator; });
$parcel$export(module.exports, "adminTenantId", function () { return (parcelRequire("8zpKJ")).adminTenantId; });
$parcel$export(module.exports, "defaultTenantId", function () { return (parcelRequire("8zpKJ")).defaultTenantId; });
parcelRequire("faCyI");
parcelRequire("7ZL8j");
parcelRequire("5fvIO");
parcelRequire("8OiiV");
parcelRequire("5nfgF");
parcelRequire("8zpKJ");

});
parcelRequire.register("faCyI", function(module, exports) {

$parcel$export(module.exports, "adminConsoleApplicationId", function () { return $b0b5b32e091c273b$export$1bb5e159b3d64354; });
$parcel$export(module.exports, "demoAppApplicationId", function () { return $b0b5b32e091c273b$export$92b495973538657d; });
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("28jVG");
var $3kVX5 = parcelRequire("3kVX5");

var $8zpKJ = parcelRequire("8zpKJ");
const $b0b5b32e091c273b$export$1bb5e159b3d64354 = "admin-console";
const $b0b5b32e091c273b$export$92b495973538657d = "demo-app";
const $b0b5b32e091c273b$export$c3f41e16cf1f3ff0 = (tenantId)=>({
        tenantId: tenantId,
        id: $b0b5b32e091c273b$export$92b495973538657d,
        name: "Live Preview",
        secret: "N/A",
        description: "Preview for Sign-in Experience.",
        type: (0, $3kVX5.ApplicationType).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {},
        createdAt: 0
    });
const $b0b5b32e091c273b$export$e6ae95e19af732a3 = ()=>Object.freeze({
        tenantId: (0, $8zpKJ.adminTenantId),
        id: $b0b5b32e091c273b$export$1bb5e159b3d64354,
        name: "Admin Console",
        secret: (0, $jKlLV.generateStandardSecret)(),
        description: "Logto Admin Console.",
        type: (0, $3kVX5.ApplicationType).SPA,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        }
    });
const $b0b5b32e091c273b$export$7480c3dfa7c833f3 = (tenantId)=>Object.freeze({
        tenantId: (0, $8zpKJ.adminTenantId),
        id: (0, $jKlLV.generateStandardId)(),
        name: "Cloud Service",
        description: `Machine to machine application for tenant ${tenantId}`,
        secret: (0, $jKlLV.generateStandardSecret)(),
        type: (0, $3kVX5.ApplicationType).MachineToMachine,
        oidcClientMetadata: {
            redirectUris: [],
            postLogoutRedirectUris: []
        },
        customClientMetadata: {
            tenantId: tenantId
        }
    });
const $b0b5b32e091c273b$export$2d5b05d2f01b280 = (applicationId, roleId)=>Object.freeze({
        id: (0, $jKlLV.generateStandardId)(),
        tenantId: (0, $8zpKJ.adminTenantId),
        applicationId: applicationId,
        roleId: roleId
    });

});
parcelRequire.register("8zpKJ", function(module, exports) {

$parcel$export(module.exports, "defaultTenantId", function () { return $63d5918dbf7b8dbd$export$ccc9014151910116; });
$parcel$export(module.exports, "adminTenantId", function () { return $63d5918dbf7b8dbd$export$87d9f170d46b6e1e; });
const $63d5918dbf7b8dbd$export$ccc9014151910116 = "default";
const $63d5918dbf7b8dbd$export$87d9f170d46b6e1e = "admin";

});


parcelRequire.register("7ZL8j", function(module, exports) {

$parcel$export(module.exports, "cloudApiIndicator", function () { return $5d22ca8941770efe$export$e3fa12c425ddba26; });
$parcel$export(module.exports, "CloudScope", function () { return $5d22ca8941770efe$export$fd6cfb345221c2ba; });
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("28jVG");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("9Sgat");
var $az3ON = parcelRequire("az3ON");

var $8zpKJ = parcelRequire("8zpKJ");
const $5d22ca8941770efe$export$e3fa12c425ddba26 = "https://cloud.logto.io/api";
var $5d22ca8941770efe$export$fd6cfb345221c2ba;
(function(CloudScope) {
    /** The user can create a user tenant. */ CloudScope["CreateTenant"] = "create:tenant";
    /** The user can perform arbitrary operations on any tenant. */ CloudScope["ManageTenant"] = "manage:tenant";
    /** The user can update or delete its own tenants. */ CloudScope["ManageTenantSelf"] = "manage:tenant:self";
    CloudScope["SendSms"] = "send:sms";
    CloudScope["SendEmail"] = "send:email";
    /** The user can see and manage affiliates, including create, update, and delete. */ CloudScope["ManageAffiliate"] = "manage:affiliate";
    /** The user can create new affiliates and logs. */ CloudScope["CreateAffiliate"] = "create:affiliate";
})($5d22ca8941770efe$export$fd6cfb345221c2ba || ($5d22ca8941770efe$export$fd6cfb345221c2ba = {}));
const $5d22ca8941770efe$export$3ae0ed740a70db11 = ()=>{
    const resourceId = (0, $jKlLV.generateStandardId)();
    const buildScope = (name, description)=>({
            tenantId: (0, $8zpKJ.adminTenantId),
            id: (0, $jKlLV.generateStandardId)(),
            name: name,
            description: description,
            resourceId: resourceId
        });
    return Object.freeze([
        {
            resource: {
                tenantId: (0, $8zpKJ.adminTenantId),
                id: resourceId,
                indicator: $5d22ca8941770efe$export$e3fa12c425ddba26,
                name: `Logto Cloud API`
            },
            scopes: [
                buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.CreateTenant, "Allow creating new tenants."),
                buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.ManageTenantSelf, "Allow managing tenant itself, including update and delete.")
            ],
            role: {
                tenantId: (0, $8zpKJ.adminTenantId),
                name: (0, $az3ON.AdminTenantRole).User
            }
        },
        buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.ManageTenant, "Allow managing existing tenants, including create without limitation, update, and delete."),
        buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.SendEmail, "Allow sending emails. This scope is only available to M2M application."),
        buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.SendSms, "Allow sending SMS. This scope is only available to M2M application."),
        buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.CreateAffiliate, "Allow creating new affiliates and logs."),
        buildScope($5d22ca8941770efe$export$fd6cfb345221c2ba.ManageAffiliate, "Allow managing affiliates, including create, update, and delete.")
    ]);
};
const $5d22ca8941770efe$export$233b871be9b6564f = ()=>({
        tenantId: (0, $8zpKJ.adminTenantId),
        id: (0, $jKlLV.generateStandardId)(),
        name: (0, $az3ON.AdminTenantRole).TenantApplication,
        description: "The role for M2M applications that represent a user tenant and send requests to Logto Cloud.",
        type: (0, $3kVX5.RoleType).MachineToMachine
    });

});

parcelRequire.register("5fvIO", function(module, exports) {

$parcel$export(module.exports, "defaultManagementApi", function () { return $3d26f5bbbe14e0f5$export$711b817cd779af20; });
$parcel$export(module.exports, "getManagementApiResourceIndicator", function () { return $3d26f5bbbe14e0f5$export$245dbc301cf93887; });
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("28jVG");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("9Sgat");
var $az3ON = parcelRequire("az3ON");

var $8zpKJ = parcelRequire("8zpKJ");
// Consider remove the dependency of IDs
const $3d26f5bbbe14e0f5$var$defaultResourceId = "management-api";
const $3d26f5bbbe14e0f5$var$defaultScopeAllId = "management-api-all";
const $3d26f5bbbe14e0f5$export$711b817cd779af20 = Object.freeze({
    resource: {
        tenantId: (0, $8zpKJ.defaultTenantId),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: $3d26f5bbbe14e0f5$var$defaultResourceId,
        /**
         * The fixed resource indicator for Management APIs.
         *
         * Admin Console requires the access token of this resource to be functional.
         */ indicator: `https://${(0, $8zpKJ.defaultTenantId)}.logto.app/api`,
        name: "Logto Management API"
    },
    scopes: [
        {
            tenantId: (0, $8zpKJ.defaultTenantId),
            /** @deprecated You should not rely on this constant. Change to something else. */ id: $3d26f5bbbe14e0f5$var$defaultScopeAllId,
            name: (0, $az3ON.PredefinedScope).All,
            description: "Default scope for Management API, allows all permissions.",
            /** @deprecated You should not rely on this constant. Change to something else. */ resourceId: $3d26f5bbbe14e0f5$var$defaultResourceId
        }
    ],
    role: {
        tenantId: (0, $8zpKJ.defaultTenantId),
        /** @deprecated You should not rely on this constant. Change to something else. */ id: "admin-role",
        name: (0, $az3ON.InternalRole).Admin,
        description: `Internal admin role for Logto tenant ${(0, $8zpKJ.defaultTenantId)}.`,
        type: (0, $3kVX5.RoleType).MachineToMachine
    }
});
function $3d26f5bbbe14e0f5$export$245dbc301cf93887(tenantId, path = "api") {
    return `https://${tenantId}.logto.app/${path}`;
}
const $3d26f5bbbe14e0f5$export$e85ff742161e6613 = (tenantId)=>`${tenantId}:${(0, $az3ON.AdminTenantRole).Admin}`;
const $3d26f5bbbe14e0f5$export$c7852ca43795084 = (tenantId)=>{
    const resourceId = (0, $jKlLV.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: tenantId,
            id: resourceId,
            indicator: $3d26f5bbbe14e0f5$export$245dbc301cf93887(tenantId),
            name: `Logto Management API`
        },
        scopes: [
            {
                tenantId: tenantId,
                id: (0, $jKlLV.generateStandardId)(),
                name: (0, $az3ON.PredefinedScope).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: tenantId,
            id: (0, $jKlLV.generateStandardId)(),
            name: (0, $az3ON.InternalRole).Admin,
            description: `Internal admin role for Logto tenant ${(0, $8zpKJ.defaultTenantId)}.`,
            type: (0, $3kVX5.RoleType).MachineToMachine
        }
    });
};
const $3d26f5bbbe14e0f5$export$305b333dcaea6e0e = (tenantId)=>{
    const resourceId = (0, $jKlLV.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: (0, $8zpKJ.adminTenantId),
            id: resourceId,
            indicator: $3d26f5bbbe14e0f5$export$245dbc301cf93887(tenantId),
            name: `Logto Management API for tenant ${tenantId}`
        },
        scopes: [
            {
                tenantId: (0, $8zpKJ.adminTenantId),
                id: (0, $jKlLV.generateStandardId)(),
                name: (0, $az3ON.PredefinedScope).All,
                description: "Default scope for Management API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: (0, $8zpKJ.adminTenantId),
            id: (0, $jKlLV.generateStandardId)(),
            name: $3d26f5bbbe14e0f5$export$e85ff742161e6613(tenantId),
            description: `Admin tenant admin role for Logto tenant ${tenantId}.`,
            type: (0, $3kVX5.RoleType).User
        }
    });
};
const $3d26f5bbbe14e0f5$export$3e34893e87727786 = ()=>{
    const resourceId = (0, $jKlLV.generateStandardId)();
    return Object.freeze({
        resource: {
            tenantId: (0, $8zpKJ.adminTenantId),
            id: resourceId,
            indicator: $3d26f5bbbe14e0f5$export$245dbc301cf93887((0, $8zpKJ.adminTenantId), "me"),
            name: `Logto Me API`
        },
        scopes: [
            {
                tenantId: (0, $8zpKJ.adminTenantId),
                id: (0, $jKlLV.generateStandardId)(),
                name: (0, $az3ON.PredefinedScope).All,
                description: "Default scope for Me API, allows all permissions.",
                resourceId: resourceId
            }
        ],
        role: {
            tenantId: (0, $8zpKJ.adminTenantId),
            id: (0, $jKlLV.generateStandardId)(),
            name: (0, $az3ON.AdminTenantRole).User,
            description: "Default role for admin tenant.",
            type: (0, $3kVX5.RoleType).User
        }
    });
};

});

parcelRequire.register("8OiiV", function(module, exports) {
parcelRequire("9Sgat");
var $gmXIe = parcelRequire("gmXIe");

var $7ZL8j = parcelRequire("7ZL8j");
const $66a13115c9db72a5$export$eac2ea73871449a = (forTenantId)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $gmXIe.LogtoTenantConfigKey).AdminConsole,
        value: {
            signInExperienceCustomized: false,
            organizationCreated: false
        }
    });
const $66a13115c9db72a5$export$fb8e6733ef2d5505 = (forTenantId, appId, appSecret)=>Object.freeze({
        tenantId: forTenantId,
        key: (0, $gmXIe.LogtoTenantConfigKey).CloudConnection,
        value: {
            appId: appId,
            appSecret: appSecret,
            resource: (0, $7ZL8j.cloudApiIndicator)
        }
    });

});

parcelRequire.register("5nfgF", function(module, exports) {
parcelRequire("8Hfh4");
var $hVcgO = parcelRequire("hVcgO");
parcelRequire("28jVG");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("irxkh");
var $bd0Y0 = parcelRequire("bd0Y0");

var $8zpKJ = parcelRequire("8zpKJ");
const $3e9af19ef9dc6fbd$var$defaultPrimaryColor = "#6139F6";
const $3e9af19ef9dc6fbd$export$9aabb866d7e7cb45 = (forTenantId, isCloud)=>Object.freeze({
        tenantId: forTenantId,
        id: "default",
        color: {
            primaryColor: $3e9af19ef9dc6fbd$var$defaultPrimaryColor,
            isDarkModeEnabled: false,
            darkPrimaryColor: (0, $hVcgO.generateDarkColor)($3e9af19ef9dc6fbd$var$defaultPrimaryColor)
        },
        branding: {
            logoUrl: isCloud ? undefined : "https://logto.io/logo.svg",
            darkLogoUrl: isCloud ? undefined : "https://logto.io/logo-dark.svg"
        },
        languageInfo: {
            autoDetect: true,
            fallbackLanguage: "en"
        },
        termsOfUseUrl: null,
        privacyPolicyUrl: null,
        signUp: {
            identifiers: [
                isCloud ? (0, $bd0Y0.SignInIdentifier).Email : (0, $bd0Y0.SignInIdentifier).Username
            ],
            password: true,
            verify: isCloud
        },
        signIn: {
            methods: [
                {
                    identifier: isCloud ? (0, $bd0Y0.SignInIdentifier).Email : (0, $bd0Y0.SignInIdentifier).Username,
                    password: true,
                    verificationCode: false,
                    isPasswordPrimary: true
                }
            ]
        },
        socialSignInConnectorTargets: [],
        signInMode: (0, $3kVX5.SignInMode).SignInAndRegister,
        customCss: null,
        customContent: {},
        passwordPolicy: {},
        mfa: {
            factors: [],
            policy: (0, $bd0Y0.MfaPolicy).UserControlled
        }
    });
const $3e9af19ef9dc6fbd$export$7e36ef2bc7e2871f = $3e9af19ef9dc6fbd$export$9aabb866d7e7cb45((0, $8zpKJ.defaultTenantId), false);
const $3e9af19ef9dc6fbd$export$e9fd471c1ae91561 = ()=>Object.freeze({
        ...$3e9af19ef9dc6fbd$export$7e36ef2bc7e2871f,
        tenantId: (0, $8zpKJ.adminTenantId),
        color: {
            ...$3e9af19ef9dc6fbd$export$7e36ef2bc7e2871f.color,
            isDarkModeEnabled: true
        },
        signInMode: (0, $3kVX5.SignInMode).Register,
        branding: {
            logoUrl: "https://logto.io/logo.svg",
            darkLogoUrl: "https://logto.io/logo-dark.svg"
        }
    });

});


parcelRequire.register("5d763", function(module, exports) {
$parcel$export(module.exports, "ossConsolePath", function () { return (parcelRequire("ceK0K")).ossConsolePath; });
$parcel$export(module.exports, "customClientMetadataDefault", function () { return (parcelRequire("duSFh")).customClientMetadataDefault; });
$parcel$export(module.exports, "maxFreeTenantLimit", function () { return (parcelRequire("6iE6O")).maxFreeTenantLimit; });
$parcel$export(module.exports, "ReservedPlanId", function () { return (parcelRequire("ckJfF")).ReservedPlanId; });
parcelRequire("9e3Oh");
parcelRequire("ceK0K");
parcelRequire("duSFh");
parcelRequire("adwy8");
parcelRequire("6iE6O");
parcelRequire("ckJfF");

});
parcelRequire.register("9e3Oh", function(module, exports) {
const $6b786075ac32069d$export$58a828960e98f161 = "_logto";

});

parcelRequire.register("ceK0K", function(module, exports) {

$parcel$export(module.exports, "ossConsolePath", function () { return $8e8a7ba92f1c0c9c$export$c114d6e260d7e866; });
/**
 * In OSS:
 *
 * - Only one single user tenant (`default`) is available.
 * - Admin tenant and Admin Console share one endpoint (`ADMIN_ENDPOINT`).
 *
 * There's no need to parse tenant ID from the first path segment in OSS, and the segment should be a fixed value.
 *
 * If we use `/default`, the URL will look ugly; thus we keep the old fashion `/console`.
 */ const $8e8a7ba92f1c0c9c$export$c114d6e260d7e866 = "/console";

});

parcelRequire.register("duSFh", function(module, exports) {

$parcel$export(module.exports, "customClientMetadataDefault", function () { return $9d387b0413b681b7$export$2d48ae5b9b7ef84; });

var $adwy8 = parcelRequire("adwy8");
const $9d387b0413b681b7$export$69773729edd6695 = "tenant_id";
const $9d387b0413b681b7$export$2d48ae5b9b7ef84 = Object.freeze({
    idTokenTtl: (0, $adwy8.inSeconds).oneHour,
    refreshTokenTtlInDays: 14,
    rotateRefreshToken: true
});

});
parcelRequire.register("adwy8", function(module, exports) {

$parcel$export(module.exports, "inSeconds", function () { return $77045df5d380bfb2$export$41e1f3752bfbbffc; });
const $77045df5d380bfb2$export$41e1f3752bfbbffc = Object.freeze({
    oneMinute: 60,
    oneHour: 3600,
    oneDay: 86400
});

});


parcelRequire.register("6iE6O", function(module, exports) {

$parcel$export(module.exports, "maxFreeTenantLimit", function () { return $4963894c5390605b$export$33e784254961b75a; });
const $4963894c5390605b$export$33e784254961b75a = 10;

});

parcelRequire.register("ckJfF", function(module, exports) {

$parcel$export(module.exports, "ReservedPlanId", function () { return $8faa7452d8264f01$export$70d79c7c84af5a3e; });
var $8faa7452d8264f01$export$70d79c7c84af5a3e;
(function(ReservedPlanId) {
    ReservedPlanId["Free"] = "free";
    ReservedPlanId["Hobby"] = "hobby";
    ReservedPlanId["Pro"] = "pro";
    ReservedPlanId["Development"] = "dev";
})($8faa7452d8264f01$export$70d79c7c84af5a3e || ($8faa7452d8264f01$export$70d79c7c84af5a3e = {}));

});


parcelRequire.register("9sGuP", function(module, exports) {
$parcel$export(module.exports, "internalRolePrefix", function () { return (parcelRequire("2O7i9")).internalRolePrefix; });
$parcel$export(module.exports, "isManagementApi", function () { return (parcelRequire("MRt6E")).isManagementApi; });
$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return (parcelRequire("khQz7")).findDuplicatedOrBlockedEmailDomains; });
parcelRequire("2O7i9");
parcelRequire("MRt6E");
parcelRequire("khQz7");

});
parcelRequire.register("2O7i9", function(module, exports) {

$parcel$export(module.exports, "internalRolePrefix", function () { return $20b5e84c319ae12d$export$7ebc507e3327c47b; });
const $20b5e84c319ae12d$export$7ebc507e3327c47b = "#internal:";
const $20b5e84c319ae12d$export$9aaedfefea44825f = (roleName)=>roleName.startsWith($20b5e84c319ae12d$export$7ebc507e3327c47b);

});

parcelRequire.register("MRt6E", function(module, exports) {

$parcel$export(module.exports, "isManagementApi", function () { return $092df587ef0bc907$export$5ae1b4d89745ee61; });
const $092df587ef0bc907$export$5ae1b4d89745ee61 = (indicator)=>/^https:\/\/[^.]+\.logto\.app\/api$/.test(indicator);

});

parcelRequire.register("khQz7", function(module, exports) {

$parcel$export(module.exports, "findDuplicatedOrBlockedEmailDomains", function () { return $ec4e2b9554a12d50$export$642cfcc4b084a733; });

var $5Je5u = parcelRequire("5Je5u");
const $ec4e2b9554a12d50$export$642cfcc4b084a733 = (domains)=>{
    const blackListSet = new Set((0, $5Je5u.singleSignOnDomainBlackList));
    const validDomainSet = new Set();
    const duplicatedDomains = new Set();
    const forbiddenDomains = new Set();
    for (const domain of domains ?? []){
        if (blackListSet.has(domain)) forbiddenDomains.add(domain);
        if (validDomainSet.has(domain)) duplicatedDomains.add(domain);
        else validDomainSet.add(domain);
    }
    return {
        duplicatedDomains: duplicatedDomains,
        forbiddenDomains: forbiddenDomains
    };
};

});



parcelRequire.register("gjD7B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d1a7517d60b6f296$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d1a7517d60b6f296$var$SvgMachineToMachineDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M17 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V6Z",
                fill: "url(#paint0_linear_1091_20373)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#D361E7",
                d: "M17 8h18v1H17z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 6,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 6,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 11,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 21,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 16,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 21,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#D361E7",
                d: "M17 13h18v1H17z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M5 24a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24Z",
                fill: "url(#paint1_linear_1091_20373)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M5 26h18v1H5z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 24,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 24,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 29,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 9,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 34,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 9,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M5 31h18v1H5z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.4,
                d: "M20 27a8 8 0 0 0 8-8m-16 1a8 8 0 0 1 8-8",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20373",
                        x1: 12.5,
                        y1: 13.333,
                        x2: 36.414,
                        y2: 9.979,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E4A3FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20373",
                        x1: 3.521,
                        y1: 30.021,
                        x2: 21.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $d1a7517d60b6f296$export$2e2bcd8739ae039 = $d1a7517d60b6f296$var$SvgMachineToMachineDark;

});

parcelRequire.register("7MH9A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b4ac46fc5dd9f149$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b4ac46fc5dd9f149$var$SvgMachineToMachine = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M17 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H19a2 2 0 0 1-2-2V6Z",
                fill: "url(#paint0_linear_1091_20131)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#D361E7",
                d: "M17 8h18v1H17z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 6,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 6,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 11,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 21,
                y: 11,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 27,
                y: 16,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 21,
                y: 16,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#D361E7",
                d: "M17 13h18v1H17z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M5 24a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V24Z",
                fill: "url(#paint1_linear_1091_20131)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M5 26h18v1H5z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 24,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 24,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 29,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 9,
                y: 29,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 34,
                width: 6,
                height: 1,
                rx: 0.5,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 7,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 9,
                y: 34,
                width: 1,
                height: 1,
                rx: 0.5,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M5 31h18v1H5z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M20 27a8 8 0 0 0 8-8m-16 1a8 8 0 0 1 8-8",
                stroke: "#C9C5D0",
                strokeWidth: 2,
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20131",
                        x1: 12.5,
                        y1: 13.333,
                        x2: 36.414,
                        y2: 9.979,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E4A3FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20131",
                        x1: 3.521,
                        y1: 30.021,
                        x2: 21.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $b4ac46fc5dd9f149$export$2e2bcd8739ae039 = $b4ac46fc5dd9f149$var$SvgMachineToMachine;

});

parcelRequire.register("35M8v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $269a2ab157b42725$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $269a2ab157b42725$var$SvgNativeAppDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12,
                y: 5,
                width: 16,
                height: 30,
                rx: 4,
                fill: "url(#paint0_linear_1091_20297)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 20,
                cy: 31,
                r: 1.5,
                stroke: "#D3BCF3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16 5h8v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5Z",
                fill: "#5938A3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M28.35 4a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H23.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 10,
                cy: 26,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20297",
                    x1: 10.686,
                    y1: 22.188,
                    x2: 29.393,
                    y2: 18.504,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#614DDD"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D47AFE"
                        })
                    ]
                })
            })
        ]
    });
var $269a2ab157b42725$export$2e2bcd8739ae039 = $269a2ab157b42725$var$SvgNativeAppDark;

});

parcelRequire.register("aCb8M", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d710ac744c8171fe$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d710ac744c8171fe$var$SvgNativeApp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12,
                y: 5,
                width: 16,
                height: 30,
                rx: 4,
                fill: "url(#paint0_linear_1091_20216)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 20,
                cy: 31,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16 5h8v2a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1V5Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.8,
                d: "M28.35 3a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H23.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 10,
                cy: 26,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20216",
                    x1: 10.686,
                    y1: 22.188,
                    x2: 29.393,
                    y2: 18.504,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $d710ac744c8171fe$export$2e2bcd8739ae039 = $d710ac744c8171fe$var$SvgNativeApp;

});

parcelRequire.register("jwpnw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $87fb16f26ae2048c$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $87fb16f26ae2048c$var$SvgSinglePageAppDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.5 12c0 2.148-.436 4.069-1.119 5.433C26.684 18.828 25.813 19.5 25 19.5c-.813 0-1.684-.672-2.381-2.067C21.936 16.07 21.5 14.148 21.5 12c0-2.148.436-4.069 1.119-5.433C23.316 5.172 24.187 4.5 25 4.5c.813 0 1.684.672 2.381 2.067C28.064 7.93 28.5 9.852 28.5 12Z",
                stroke: "#9D85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M26.75 8.969c1.86 1.074 3.305 2.412 4.146 3.685.859 1.302 1.006 2.392.6 3.096-.407.704-1.425 1.122-2.981 1.029-1.523-.092-3.405-.674-5.265-1.748-1.86-1.074-3.305-2.412-4.146-3.685-.859-1.302-1.006-2.392-.6-3.096.407-.704 1.425-1.122 2.981-1.029 1.523.092 3.405.674 5.265 1.748Z",
                stroke: "#9D85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23.25 8.969c-1.86 1.074-3.305 2.412-4.146 3.685-.859 1.302-1.006 2.392-.6 3.096.407.704 1.425 1.122 2.981 1.029 1.523-.092 3.405-.674 5.265-1.748 1.86-1.074 3.305-2.412 4.146-3.685.859-1.302 1.006-2.392.6-3.096-.407-.704-1.425-1.122-2.981-1.029-1.523.092-3.405.674-5.265 1.748Z",
                stroke: "#9C85FD",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 25,
                cy: 12,
                r: 1,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m4.778 17.74 4.906-1.635a1 1 0 0 1 .632 0l4.906 1.636a1 1 0 0 1 .676 1.073l-.825 6.6a1 1 0 0 1-.62.805l-4.082 1.632a1 1 0 0 1-.742 0L5.548 26.22a1 1 0 0 1-.621-.804l-.825-6.601a1 1 0 0 1 .676-1.073Z",
                fill: "url(#paint0_linear_1091_20314)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.582 25H13l-2.218-6H9.214L7 25h1.37l.486-1.455h2.24L11.582 25ZM9.96 20.148h.031l.818 2.457H9.143l.817-2.457Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                fill: "url(#paint1_linear_1091_20314)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_1091_20314",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 18,
                y: 22,
                width: 18,
                height: 14,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    opacity: 0.7,
                    d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                    fill: "#7958FF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_1091_20314)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "m22 22 4.576 7.322a.5.5 0 0 0 .848 0L32 22H22Z",
                    fill: "#4300DA"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20314",
                        x1: 1,
                        y1: 24,
                        x2: 16.943,
                        y2: 21.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20314",
                        x1: 16.521,
                        y1: 30.021,
                        x2: 34.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $87fb16f26ae2048c$export$2e2bcd8739ae039 = $87fb16f26ae2048c$var$SvgSinglePageAppDark;

});

parcelRequire.register("as8rT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebfa040f5a060680$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ebfa040f5a060680$var$SvgSinglePageApp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.5 12c0 2.148-.436 4.069-1.119 5.433C26.684 18.828 25.813 19.5 25 19.5c-.813 0-1.684-.672-2.381-2.067C21.936 16.07 21.5 14.148 21.5 12c0-2.148.436-4.069 1.119-5.433C23.316 5.172 24.187 4.5 25 4.5c.813 0 1.684.672 2.381 2.067C28.064 7.93 28.5 9.852 28.5 12Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M26.75 8.969c1.86 1.074 3.305 2.412 4.146 3.685.859 1.302 1.006 2.392.6 3.096-.407.704-1.425 1.122-2.981 1.029-1.523-.092-3.405-.674-5.265-1.748-1.86-1.074-3.305-2.412-4.146-3.685-.859-1.302-1.006-2.392-.6-3.096.407-.704 1.425-1.122 2.981-1.029 1.523.092 3.405.674 5.265 1.748Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23.25 8.969c-1.86 1.074-3.305 2.412-4.146 3.685-.859 1.302-1.006 2.392-.6 3.096.407.704 1.425 1.122 2.981 1.029 1.523-.092 3.405-.674 5.265-1.748 1.86-1.074 3.305-2.412 4.146-3.685.859-1.302 1.006-2.392.6-3.096-.407-.704-1.425-1.122-2.981-1.029-1.523.092-3.405.674-5.265 1.748Z",
                stroke: "#7958FF",
                strokeMiterlimit: 16,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 25,
                cy: 12,
                r: 1,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m4.778 17.74 4.906-1.635a1 1 0 0 1 .632 0l4.906 1.636a1 1 0 0 1 .676 1.073l-.825 6.6a1 1 0 0 1-.62.805l-4.082 1.632a1 1 0 0 1-.742 0L5.548 26.22a1 1 0 0 1-.621-.804l-.825-6.601a1 1 0 0 1 .676-1.073Z",
                fill: "url(#paint0_linear_1091_20233)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.582 25H13l-2.218-6H9.214L7 25h1.37l.486-1.455h2.24L11.582 25ZM9.96 20.148h.031l.818 2.457H9.143l.817-2.457Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                fill: "url(#paint1_linear_1091_20233)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_1091_20233",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 18,
                y: 22,
                width: 18,
                height: 14,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    opacity: 0.7,
                    d: "m18.495 22.77 8.084 12.576a.5.5 0 0 0 .842 0l8.084-12.576a.5.5 0 0 0-.42-.77h-5.817a.5.5 0 0 0-.416.223L27 25l-1.852-2.777a.5.5 0 0 0-.416-.223h-5.816a.5.5 0 0 0-.42.77Z",
                    fill: "#7958FF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_1091_20233)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "m22 22 4.576 7.322a.5.5 0 0 0 .848 0L32 22H22Z",
                    fill: "#4300DA"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1091_20233",
                        x1: 1,
                        y1: 24,
                        x2: 16.943,
                        y2: 21.125,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#EC78FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1091_20233",
                        x1: 16.521,
                        y1: 30.021,
                        x2: 34.363,
                        y2: 21.551,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $ebfa040f5a060680$export$2e2bcd8739ae039 = $ebfa040f5a060680$var$SvgSinglePageApp;

});

parcelRequire.register("4IDAs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d94794f5da4a16e3$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d94794f5da4a16e3$var$SvgTraditionalWebAppDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.8,
                x: 7.5,
                y: 11,
                width: 25,
                height: 19,
                rx: 2,
                fill: "url(#paint0_linear_1091_20258)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M7.5 15.072h25V13a2 2 0 0 0-2-2h-21a2 2 0 0 0-2 2v2.072Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.277,
                y: 17.786,
                width: 8.333,
                height: 1.357,
                rx: 0.679,
                fill: "#D3BCF3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.277,
                y: 21.857,
                width: 16.667,
                height: 1.357,
                rx: 0.679,
                fill: "#D3BCF3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M29.35 25a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H24.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20258",
                    x1: 5.446,
                    y1: 21.885,
                    x2: 30.012,
                    y2: 9.951,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $d94794f5da4a16e3$export$2e2bcd8739ae039 = $d94794f5da4a16e3$var$SvgTraditionalWebAppDark;

});

parcelRequire.register("4KAe3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c50dd5ae0a6f327$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $3c50dd5ae0a6f327$var$SvgTraditionalWebApp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.8,
                x: 7.5,
                y: 11,
                width: 25,
                height: 19,
                rx: 2,
                fill: "url(#paint0_linear_1091_20177)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M7.5 15.072h25V13a2 2 0 0 0-2-2h-21a2 2 0 0 0-2 2v2.072Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.277,
                y: 17.786,
                width: 8.333,
                height: 1.357,
                rx: 0.679,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.277,
                y: 21.857,
                width: 16.667,
                height: 1.357,
                rx: 0.679,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.8,
                d: "M29.35 25a.667.667 0 0 1 1.156 0l5.773 10a.667.667 0 0 1-.577 1H24.155a.667.667 0 0 1-.578-1l5.774-10Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 10,
                cy: 10,
                r: 6,
                fill: "#F07EFF",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1091_20177",
                    x1: 5.446,
                    y1: 21.885,
                    x2: 30.012,
                    y2: 9.951,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $3c50dd5ae0a6f327$export$2e2bcd8739ae039 = $3c50dd5ae0a6f327$var$SvgTraditionalWebApp;

});


parcelRequire.register("kiVDZ", function(module, exports) {

$parcel$export(module.exports, "connectorTitlePlaceHolder", function () { return $b409e12de8a8a240$export$8cda72be599ebe6e; });
$parcel$export(module.exports, "connectorPlatformLabel", function () { return $b409e12de8a8a240$export$c4d4d16912adcc79; });
$parcel$export(module.exports, "connectorPlaceholderIcon", function () { return $b409e12de8a8a240$export$bba2184b1a46bf3c; });
$parcel$export(module.exports, "defaultSmsConnectorGroup", function () { return $b409e12de8a8a240$export$2622c3c996991e6; });
$parcel$export(module.exports, "defaultEmailConnectorGroup", function () { return $b409e12de8a8a240$export$bdeb041190326b74; });
$parcel$export(module.exports, "supportNativePlatformTargets", function () { return $b409e12de8a8a240$export$1457ebbf3974f034; });
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
var $86S23 = parcelRequire("86S23");

var $g7J2A = parcelRequire("g7J2A");

var $54CN0 = parcelRequire("54CN0");
const $b409e12de8a8a240$export$8cda72be599ebe6e = Object.freeze({
    [(0, $fU2Vo.ConnectorType).Sms]: "connectors.type.sms",
    [(0, $fU2Vo.ConnectorType).Email]: "connectors.type.email",
    [(0, $fU2Vo.ConnectorType).Social]: "connectors.type.social"
});
const $b409e12de8a8a240$export$c4d4d16912adcc79 = Object.freeze({
    [(0, $86S23.ConnectorPlatform).Native]: "connectors.platform.native",
    [(0, $86S23.ConnectorPlatform).Universal]: "connectors.platform.universal",
    [(0, $86S23.ConnectorPlatform).Web]: "connectors.platform.web"
});
const $b409e12de8a8a240$export$bba2184b1a46bf3c = Object.freeze({
    [(0, $fU2Vo.ConnectorType).Sms]: (0, $54CN0.default),
    [(0, $fU2Vo.ConnectorType).Email]: (0, $g7J2A.default)
});
const $b409e12de8a8a240$export$2622c3c996991e6 = {
    id: "default-sms-connector",
    type: (0, $fU2Vo.ConnectorType).Sms,
    connectors: [],
    name: {
        en: ""
    },
    description: {
        en: ""
    },
    logo: "",
    logoDark: null,
    target: ""
};
const $b409e12de8a8a240$export$bdeb041190326b74 = {
    id: "default-email-connector",
    type: (0, $fU2Vo.ConnectorType).Email,
    connectors: [],
    name: {
        en: ""
    },
    description: {
        en: ""
    },
    logo: "",
    logoDark: null,
    target: ""
};
const $b409e12de8a8a240$export$1457ebbf3974f034 = [
    "wechat",
    "alipay"
];

});
parcelRequire.register("g7J2A", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c7c8b4d51a00427$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $6c7c8b4d51a00427$var$SvgConnectorEmail = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 24,
        height: 20,
        viewBox: "0 0 24 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.55.037 12 8.587 3.452.036C3.632.013 3.814 0 4 0h16c.186 0 .37.013.55.037ZM12 10.95a.998.998 0 0 1-.758-.292L1.48.893A3.992 3.992 0 0 0 0 4v12a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4V4A3.992 3.992 0 0 0 22.521.894l-9.762 9.763a.997.997 0 0 1-.758.291Z",
                fill: "url(#paint0_linear_1570_8802)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1570_8802",
                    x1: 17,
                    y1: 0,
                    x2: -1.5,
                    y2: 20,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $6c7c8b4d51a00427$export$2e2bcd8739ae039 = $6c7c8b4d51a00427$var$SvgConnectorEmail;

});

parcelRequire.register("54CN0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $20358f97f89e8ea5$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $20358f97f89e8ea5$var$SvgConnectorSms = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 26,
        height: 28,
        viewBox: "0 0 26 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 16,
                height: 28,
                rx: 4,
                fill: "url(#paint0_linear_3194_16010)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 8,
                cy: 25,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M4 0h8v1a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V0Z",
                fill: "#2D009D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M8 9a4 4 0 0 1 4-4h10a4 4 0 0 1 4 4v5a4 4 0 0 1-4 4h-7.892a4 4 0 0 0-2.058.57l-2.536 1.521A1 1 0 0 1 8 19.234V9Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M12.077 14.114c1.113 0 1.778-.55 1.778-1.415v-.003c0-.682-.41-1.043-1.31-1.219l-.436-.084c-.457-.091-.65-.223-.65-.463v-.003c0-.252.229-.425.615-.425.39 0 .653.176.697.44l.006.035h.996l-.002-.036c-.065-.747-.642-1.283-1.703-1.283-.972 0-1.675.533-1.678 1.363v.002c0 .66.386 1.082 1.28 1.254l.436.085c.496.097.683.208.683.446v.002c0 .27-.275.46-.694.46-.434 0-.724-.187-.753-.448l-.003-.026h-1.026l.003.053c.044.785.707 1.265 1.761 1.265ZM14.55 14h.946v-2.692h.059l.96 2.692h.613l.961-2.692h.062V14h.943V9.772h-1.222l-1.02 2.869h-.055l-1.023-2.869H14.55V14Zm7.002.114c1.113 0 1.778-.55 1.778-1.415v-.003c0-.682-.41-1.043-1.31-1.219l-.436-.084c-.457-.091-.65-.223-.65-.463v-.003c0-.252.228-.425.615-.425.39 0 .653.176.697.44l.006.035h.996l-.003-.036c-.064-.747-.641-1.283-1.702-1.283-.973 0-1.676.533-1.678 1.363v.002c0 .66.386 1.082 1.28 1.254l.436.085c.495.097.683.208.683.446v.002c0 .27-.276.46-.694.46-.434 0-.724-.187-.753-.448l-.003-.026h-1.026l.003.053c.044.785.706 1.265 1.761 1.265Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_3194_16010",
                    x1: -1.314,
                    y1: 16.042,
                    x2: 17.291,
                    y2: 12.116,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $20358f97f89e8ea5$export$2e2bcd8739ae039 = $20358f97f89e8ea5$var$SvgConnectorSms;

});


parcelRequire.register("adtV2", function(module, exports) {

$parcel$export(module.exports, "auditLogEventTitle", function () { return $839ac26ed0cd020c$export$68fd187e42e1a450; });
$parcel$export(module.exports, "logEventTitle", function () { return $839ac26ed0cd020c$export$dd2e226a5b5c4031; });
const $839ac26ed0cd020c$export$68fd187e42e1a450 = Object.freeze({
    "ExchangeTokenBy.AuthorizationCode": "Exchange token by Code",
    "ExchangeTokenBy.ClientCredentials": "Exchange token by Client Credentials",
    "ExchangeTokenBy.RefreshToken": "Exchange token by Refresh Token",
    "ExchangeTokenBy.Unknown": undefined,
    "Interaction.Create": "Interaction started",
    "Interaction.End": "Interaction ended",
    "Interaction.ForgotPassword.Identifier.VerificationCode.Create": "Create and send forgot-password verification code",
    "Interaction.ForgotPassword.Identifier.VerificationCode.Submit": "Submit and verify forgot-password verification code",
    "Interaction.ForgotPassword.Profile.Create": "Put new forgot-password interaction profile",
    "Interaction.ForgotPassword.Profile.Delete": "Delete forgot-password interaction profile",
    "Interaction.ForgotPassword.Profile.Update": "Patch update forgot-password interaction profile",
    "Interaction.ForgotPassword.Submit": "Submit forgot-password interaction",
    "Interaction.ForgotPassword.Update": "Update forgot-password interaction",
    "Interaction.ForgotPassword.BindMfa.Totp.Create": undefined,
    "Interaction.ForgotPassword.BindMfa.Totp.Submit": undefined,
    "Interaction.ForgotPassword.BindMfa.BackupCode.Create": undefined,
    "Interaction.ForgotPassword.BindMfa.BackupCode.Submit": undefined,
    "Interaction.ForgotPassword.BindMfa.WebAuthn.Create": undefined,
    "Interaction.ForgotPassword.BindMfa.WebAuthn.Submit": undefined,
    "Interaction.Register.Identifier.Password.Submit": undefined,
    "Interaction.Register.Identifier.Social.Create": undefined,
    "Interaction.Register.Identifier.Social.Submit": undefined,
    "Interaction.Register.Identifier.VerificationCode.Create": "Create and send register identifier with verification code",
    "Interaction.Register.Identifier.VerificationCode.Submit": "Submit and verify register verification code",
    "Interaction.Register.Profile.Create": "Put new register interaction profile",
    "Interaction.Register.Profile.Delete": "Delete register interaction profile",
    "Interaction.Register.Profile.Update": "Patch update register interaction profile",
    "Interaction.Register.Submit": "Submit register interaction",
    "Interaction.Register.Update": "Update register interaction",
    "Interaction.Register.BindMfa.Totp.Create": undefined,
    "Interaction.Register.BindMfa.Totp.Submit": undefined,
    "Interaction.Register.BindMfa.BackupCode.Create": undefined,
    "Interaction.Register.BindMfa.BackupCode.Submit": undefined,
    "Interaction.Register.BindMfa.WebAuthn.Create": undefined,
    "Interaction.Register.BindMfa.WebAuthn.Submit": undefined,
    "Interaction.Register.SingleSignOn.Create": undefined,
    "Interaction.Register.SingleSignOn.Submit": undefined,
    "Interaction.SignIn.Identifier.Password.Submit": "Submit sign-in identifier with password",
    "Interaction.SignIn.Identifier.Social.Create": "Create social sign-in authorization-url",
    "Interaction.SignIn.Identifier.Social.Submit": "Authenticate and submit social identifier",
    "Interaction.SignIn.Identifier.VerificationCode.Create": "Create and send sign-in verification code",
    "Interaction.SignIn.Identifier.VerificationCode.Submit": "Submit and verify sign-in identifier with verification code",
    "Interaction.SignIn.Profile.Create": "Put new sign-in interaction profile",
    "Interaction.SignIn.Profile.Delete": "Delete sign-in interaction profile",
    "Interaction.SignIn.Profile.Update": "Patch Update sign-in interaction profile",
    "Interaction.SignIn.Submit": "Submit sign-in interaction",
    "Interaction.SignIn.Update": "Update sign-in interaction",
    "Interaction.SignIn.BindMfa.Totp.Create": undefined,
    "Interaction.SignIn.BindMfa.Totp.Submit": undefined,
    "Interaction.SignIn.BindMfa.BackupCode.Create": undefined,
    "Interaction.SignIn.BindMfa.BackupCode.Submit": undefined,
    "Interaction.SignIn.BindMfa.WebAuthn.Create": undefined,
    "Interaction.SignIn.BindMfa.WebAuthn.Submit": undefined,
    "Interaction.SignIn.Mfa.Totp.Create": undefined,
    "Interaction.SignIn.Mfa.Totp.Submit": undefined,
    "Interaction.SignIn.Mfa.BackupCode.Create": undefined,
    "Interaction.SignIn.Mfa.BackupCode.Submit": undefined,
    "Interaction.SignIn.Mfa.WebAuthn.Create": undefined,
    "Interaction.SignIn.Mfa.WebAuthn.Submit": undefined,
    "Interaction.SignIn.Identifier.SingleSignOn.Create": "Create single-sign-on authentication session",
    "Interaction.SignIn.Identifier.SingleSignOn.Submit": "Submit single-sign-on authentication interaction",
    "Interaction.Register.Identifier.SingleSignOn.Create": undefined,
    "Interaction.Register.Identifier.SingleSignOn.Submit": undefined,
    RevokeToken: undefined,
    Unknown: undefined
});
// `webhookLogEventTitle` and `logEventTitle` are not used yet, keep them just in case.
const $839ac26ed0cd020c$var$webhookLogEventTitle = Object.freeze({
    "TriggerHook.PostRegister": undefined,
    "TriggerHook.PostResetPassword": undefined,
    "TriggerHook.PostSignIn": undefined
});
const $839ac26ed0cd020c$export$dd2e226a5b5c4031 = {
    ...$839ac26ed0cd020c$export$68fd187e42e1a450,
    ...$839ac26ed0cd020c$var$webhookLogEventTitle
};

});

parcelRequire.register("5Q2pm", function(module, exports) {

$parcel$export(module.exports, "getManagementApi", function () { return $ba2bfe993e352e85$export$bf13d33c4ce8e38d; });
$parcel$export(module.exports, "meApi", function () { return $ba2bfe993e352e85$export$6acfde9189b78772; });
$parcel$export(module.exports, "cloudApi", function () { return $ba2bfe993e352e85$export$84e66cc9b5c68656; });
parcelRequire("j6dBR");
var $5fvIO = parcelRequire("5fvIO");
var $az3ON = parcelRequire("az3ON");
var $8zpKJ = parcelRequire("8zpKJ");
var $7ZL8j = parcelRequire("7ZL8j");
const $ba2bfe993e352e85$export$bf13d33c4ce8e38d = (tenantId)=>Object.freeze({
        indicator: (0, $5fvIO.getManagementApiResourceIndicator)(tenantId),
        scopes: (0, $az3ON.PredefinedScope)
    });
const $ba2bfe993e352e85$export$6acfde9189b78772 = Object.freeze({
    indicator: (0, $5fvIO.getManagementApiResourceIndicator)((0, $8zpKJ.adminTenantId), "me"),
    scopes: (0, $az3ON.PredefinedScope)
});
const $ba2bfe993e352e85$export$84e66cc9b5c68656 = Object.freeze({
    indicator: (0, $7ZL8j.cloudApiIndicator),
    scopes: (0, $7ZL8j.CloudScope)
});

});

parcelRequire.register("9oLtf", function(module, exports) {

$parcel$export(module.exports, "adminTenantEndpoint", function () { return $2b23904a1db37def$export$b21900f0ee1c3331; });
$parcel$export(module.exports, "mainTitle", function () { return $2b23904a1db37def$export$148f1d8a17c0f2b1; });

var $V1X8c = parcelRequire("V1X8c");
const $2b23904a1db37def$var$getAdminTenantEndpoint = ()=>{
    // Allow endpoint override for dev or testing
    if (0, $V1X8c.adminEndpoint) return new URL((0, $V1X8c.adminEndpoint));
    return new URL((0, $V1X8c.isCloud) ? window.location.origin.replace("cloud.", "auth.") : window.location.origin);
};
const $2b23904a1db37def$export$b21900f0ee1c3331 = $2b23904a1db37def$var$getAdminTenantEndpoint();
const $2b23904a1db37def$export$148f1d8a17c0f2b1 = (0, $V1X8c.isCloud) ? "Logto Cloud" : "Logto Console";

});
parcelRequire.register("V1X8c", function(module, exports) {

$parcel$export(module.exports, "isCloud", function () { return $2b496194ea8d8e8f$export$12546c493525abfc; });
$parcel$export(module.exports, "adminEndpoint", function () { return $2b496194ea8d8e8f$export$348a11e4ba7c8edf; });
parcelRequire("bGN6i");
var $vZyB0 = parcelRequire("vZyB0");
const $2b496194ea8d8e8f$export$f15d00aa73aafac4 = true;
const $2b496194ea8d8e8f$export$12546c493525abfc = (0, $vZyB0.yes)(undefined);
const $2b496194ea8d8e8f$export$348a11e4ba7c8edf = undefined;
const $2b496194ea8d8e8f$export$40f514de6322fa2e = !$2b496194ea8d8e8f$export$f15d00aa73aafac4 || (0, $vZyB0.yes)("") || (0, $vZyB0.yes)(undefined);

});


parcelRequire.register("emGEN", function(module, exports) {

$parcel$export(module.exports, "ApplicationDetailsTabs", function () { return $0d2db985c02d4f94$export$41c455531d6f2c11; });
$parcel$export(module.exports, "ApiResourceDetailsTabs", function () { return $0d2db985c02d4f94$export$973f987da39d2e74; });
$parcel$export(module.exports, "ConnectorsTabs", function () { return $0d2db985c02d4f94$export$b3bd1d3dc666a7f6; });
$parcel$export(module.exports, "WebhookDetailsTabs", function () { return $0d2db985c02d4f94$export$6fe03a8e666f5ee8; });
$parcel$export(module.exports, "UserDetailsTabs", function () { return $0d2db985c02d4f94$export$459a32b7ea60495c; });
$parcel$export(module.exports, "RoleDetailsTabs", function () { return $0d2db985c02d4f94$export$a6a250d41b5029e4; });
$parcel$export(module.exports, "TenantSettingsTabs", function () { return $0d2db985c02d4f94$export$ff87e72992de0630; });
$parcel$export(module.exports, "EnterpriseSsoDetailsTabs", function () { return $0d2db985c02d4f94$export$b021f61ae8cc4286; });
var $0d2db985c02d4f94$export$41c455531d6f2c11;
(function(ApplicationDetailsTabs) {
    ApplicationDetailsTabs["Settings"] = "settings";
    ApplicationDetailsTabs["AdvancedSettings"] = "advanced-settings";
    ApplicationDetailsTabs["Roles"] = "roles";
    ApplicationDetailsTabs["Logs"] = "logs";
})($0d2db985c02d4f94$export$41c455531d6f2c11 || ($0d2db985c02d4f94$export$41c455531d6f2c11 = {}));
var $0d2db985c02d4f94$export$973f987da39d2e74;
(function(ApiResourceDetailsTabs) {
    ApiResourceDetailsTabs["Settings"] = "settings";
    ApiResourceDetailsTabs["Permissions"] = "permissions";
})($0d2db985c02d4f94$export$973f987da39d2e74 || ($0d2db985c02d4f94$export$973f987da39d2e74 = {}));
var $0d2db985c02d4f94$export$b3bd1d3dc666a7f6;
(function(ConnectorsTabs) {
    ConnectorsTabs["Passwordless"] = "passwordless";
    ConnectorsTabs["Social"] = "social";
})($0d2db985c02d4f94$export$b3bd1d3dc666a7f6 || ($0d2db985c02d4f94$export$b3bd1d3dc666a7f6 = {}));
var $0d2db985c02d4f94$export$6fe03a8e666f5ee8;
(function(WebhookDetailsTabs) {
    WebhookDetailsTabs["Settings"] = "settings";
    WebhookDetailsTabs["RecentRequests"] = "recent-requests";
})($0d2db985c02d4f94$export$6fe03a8e666f5ee8 || ($0d2db985c02d4f94$export$6fe03a8e666f5ee8 = {}));
var $0d2db985c02d4f94$export$459a32b7ea60495c;
(function(UserDetailsTabs) {
    UserDetailsTabs["Settings"] = "settings";
    UserDetailsTabs["Roles"] = "roles";
    UserDetailsTabs["Logs"] = "logs";
    UserDetailsTabs["Organizations"] = "organizations";
})($0d2db985c02d4f94$export$459a32b7ea60495c || ($0d2db985c02d4f94$export$459a32b7ea60495c = {}));
var $0d2db985c02d4f94$export$a6a250d41b5029e4;
(function(RoleDetailsTabs) {
    RoleDetailsTabs["Settings"] = "settings";
    RoleDetailsTabs["Permissions"] = "permissions";
    RoleDetailsTabs["Users"] = "users";
    RoleDetailsTabs["M2mApps"] = "machine-to-machine-apps";
})($0d2db985c02d4f94$export$a6a250d41b5029e4 || ($0d2db985c02d4f94$export$a6a250d41b5029e4 = {}));
var $0d2db985c02d4f94$export$ff87e72992de0630;
(function(TenantSettingsTabs) {
    TenantSettingsTabs["Settings"] = "settings";
    TenantSettingsTabs["Domains"] = "domains";
    TenantSettingsTabs["Subscription"] = "subscription";
    TenantSettingsTabs["BillingHistory"] = "billing-history";
})($0d2db985c02d4f94$export$ff87e72992de0630 || ($0d2db985c02d4f94$export$ff87e72992de0630 = {}));
var $0d2db985c02d4f94$export$b021f61ae8cc4286;
(function(EnterpriseSsoDetailsTabs) {
    EnterpriseSsoDetailsTabs["Connection"] = "connection";
    EnterpriseSsoDetailsTabs["Experience"] = "experience";
})($0d2db985c02d4f94$export$b021f61ae8cc4286 || ($0d2db985c02d4f94$export$b021f61ae8cc4286 = {}));

});

parcelRequire.register("o53Y2", function(module, exports) {

$parcel$export(module.exports, "discordLink", function () { return $1a6478347a34bb5b$export$770bac037405f4d8; });
$parcel$export(module.exports, "githubOrgLink", function () { return $1a6478347a34bb5b$export$e6d4ee48329e88d9; });
$parcel$export(module.exports, "githubIssuesLink", function () { return $1a6478347a34bb5b$export$65835372d5db9813; });
$parcel$export(module.exports, "contactEmail", function () { return $1a6478347a34bb5b$export$216bebe50ea21113; });
$parcel$export(module.exports, "contactEmailLink", function () { return $1a6478347a34bb5b$export$6926f778a352c0aa; });
$parcel$export(module.exports, "reservationLink", function () { return $1a6478347a34bb5b$export$f3387181d20561c1; });
$parcel$export(module.exports, "trustAndSecurityLink", function () { return $1a6478347a34bb5b$export$7ab2cab94b61f6c0; });
$parcel$export(module.exports, "pricingLink", function () { return $1a6478347a34bb5b$export$caf913631c801f96; });
$parcel$export(module.exports, "envTagsFeatureLink", function () { return $1a6478347a34bb5b$export$34d13a5fd583d5bb; });

var $h7VLF = parcelRequire("h7VLF");
const $1a6478347a34bb5b$export$770bac037405f4d8 = "https://discord.gg/UEPaF3j5e6";
const $1a6478347a34bb5b$export$e6d4ee48329e88d9 = "https://github.com/logto-io";
const $1a6478347a34bb5b$export$f282d82959650472 = "https://github.com/logto-io/logto";
const $1a6478347a34bb5b$export$65835372d5db9813 = "https://github.com/logto-io/logto/issues";
const $1a6478347a34bb5b$export$216bebe50ea21113 = "contact@logto.io";
const $1a6478347a34bb5b$export$6926f778a352c0aa = `mailto:${$1a6478347a34bb5b$export$216bebe50ea21113}`;
const $1a6478347a34bb5b$export$f3387181d20561c1 = (0, $h7VLF.buildUrl)("https://calendly.com/logto/30min", {
    // Note: month format is YYYY-MM
    month: new Date().toISOString().slice(0, 7)
});
const $1a6478347a34bb5b$export$7ab2cab94b61f6c0 = "https://logto.io/trust-and-security";
const $1a6478347a34bb5b$export$caf913631c801f96 = "https://logto.io/pricing";
const $1a6478347a34bb5b$export$34d13a5fd583d5bb = "/docs/recipes/tenant-type";

});
parcelRequire.register("h7VLF", function(module, exports) {

$parcel$export(module.exports, "buildUrl", function () { return $494444a58804faaa$export$b5cd97dee32de81d; });
$parcel$export(module.exports, "formatSearchKeyword", function () { return $494444a58804faaa$export$9d3815b1d377c7ae; });
$parcel$export(module.exports, "isInCallback", function () { return $494444a58804faaa$export$412c684fc323ffe4; });
$parcel$export(module.exports, "isAbsoluteUrl", function () { return $494444a58804faaa$export$a1cbf2de32a9fd1; });
$parcel$export(module.exports, "dropLeadingSlash", function () { return $494444a58804faaa$export$89d2b00dec6d70aa; });
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");
const $494444a58804faaa$export$b5cd97dee32de81d = (path, searchParameters)=>`${path}?${new URLSearchParams(searchParameters).toString()}`;
const $494444a58804faaa$export$9d3815b1d377c7ae = (keyword)=>`%${keyword}%`;
const $494444a58804faaa$export$412c684fc323ffe4 = ()=>[
        "/callback",
        "-callback"
    ].some((path)=>window.location.pathname.endsWith(path));
const $494444a58804faaa$export$a1cbf2de32a9fd1 = (url)=>Boolean((0, $aWIy6.trySafe)(()=>url && new URL(url)));
const $494444a58804faaa$export$89d2b00dec6d70aa = (path)=>path.replace(/^\/+/, "");

});


parcelRequire.register("mbOAD", function(module, exports) {

$parcel$export(module.exports, "storageKeys", function () { return $1368ef28c396ea6b$export$4a127c3d87b83db7; });
const $1368ef28c396ea6b$export$902ba6ec74c93f9d = (forType)=>`logto:admin_console:${forType}`;
const $1368ef28c396ea6b$export$4a127c3d87b83db7 = Object.freeze({
    appearanceMode: $1368ef28c396ea6b$export$902ba6ec74c93f9d("appearance_mode"),
    linkingSocialConnector: $1368ef28c396ea6b$export$902ba6ec74c93f9d("linking_social_connector"),
    checkoutSession: $1368ef28c396ea6b$export$902ba6ec74c93f9d("checkout_session"),
    /** The react-router redirect location after sign in. The value should be a stringified Location object. */ redirectAfterSignIn: $1368ef28c396ea6b$export$902ba6ec74c93f9d("redirect_after_sign_in"),
    webhookTestResult: $1368ef28c396ea6b$export$902ba6ec74c93f9d("webhook_test_result")
});

});


parcelRequire.register("iyeK6", function(module, exports) {
/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    "use strict";
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = [];
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (!arg) continue;
            var argType = typeof arg;
            if (argType === "string" || argType === "number") classes.push(arg);
            else if (Array.isArray(arg)) {
                if (arg.length) {
                    var inner = classNames.apply(null, arg);
                    if (inner) classes.push(inner);
                }
            } else if (argType === "object") {
                if (arg.toString === Object.prototype.toString) {
                    for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes.push(key);
                } else classes.push(arg.toString());
            }
        }
        return classes.join(" ");
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) // register as 'classnames', consistent with npm package name
    define("classnames", [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});

parcelRequire.register("dTZwU", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return (parcelRequire("j9r7N")).Trans; });
$parcel$export(module.exports, "useTranslation", function () { return (parcelRequire("2A6IJ")).useTranslation; });
$parcel$export(module.exports, "withTranslation", function () { return (parcelRequire("kiiuf")).withTranslation; });
$parcel$export(module.exports, "initReactI18next", function () { return (parcelRequire("29gsH")).initReactI18next; });

var $j9r7N = parcelRequire("j9r7N");

var $a5U5G = parcelRequire("a5U5G");

var $2A6IJ = parcelRequire("2A6IJ");

var $kiiuf = parcelRequire("kiiuf");

var $aXilW = parcelRequire("aXilW");

var $3OpbJ = parcelRequire("3OpbJ");

var $aFm3t = parcelRequire("aFm3t");

var $kgDlb = parcelRequire("kgDlb");

var $29gsH = parcelRequire("29gsH");

var $lOdB5 = parcelRequire("lOdB5");

var $lVsXh = parcelRequire("lVsXh");

var $4sJzM = parcelRequire("4sJzM");
var $a1f023ef2706af3a$export$324d90190a8b822a = function date() {
    return "";
};
var $a1f023ef2706af3a$export$2da9be4cfdb689b1 = function time() {
    return "";
};
var $a1f023ef2706af3a$export$98e628dec113755e = function number() {
    return "";
};
var $a1f023ef2706af3a$export$2e6c959c16ff56b8 = function select() {
    return "";
};
var $a1f023ef2706af3a$export$4e35d5c922a95490 = function plural() {
    return "";
};
var $a1f023ef2706af3a$export$720a3b9db04b7a0f = function selectOrdinal() {
    return "";
};

});
parcelRequire.register("j9r7N", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $df13e5ff390c6c7b$export$8d6a9236f2e3f2ce; });

var $cAQCs = parcelRequire("cAQCs");

var $6slr9 = parcelRequire("6slr9");

var $eCoWV = parcelRequire("eCoWV");

var $a5U5G = parcelRequire("a5U5G");

var $4sJzM = parcelRequire("4sJzM");
var $lVsXh = parcelRequire("lVsXh");
var $df13e5ff390c6c7b$var$_excluded = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $df13e5ff390c6c7b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $df13e5ff390c6c7b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $df13e5ff390c6c7b$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $df13e5ff390c6c7b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $df13e5ff390c6c7b$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $6slr9.default)(_ref, $df13e5ff390c6c7b$var$_excluded);
    var _ref2 = (0, $eCoWV.useContext)((0, $4sJzM.I18nContext)) || {}, i18nFromContext = _ref2.i18n, defaultNSFromContext = _ref2.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $lVsXh.getI18n)();
    var t = tFromProps || i18n && i18n.t.bind(i18n);
    return (0, $a5U5G.Trans)($df13e5ff390c6c7b$var$_objectSpread({
        children: children,
        count: count,
        parent: parent,
        i18nKey: i18nKey,
        context: context,
        tOptions: tOptions,
        values: values,
        defaults: defaults,
        components: components,
        ns: ns || t && t.ns || defaultNSFromContext || i18n && i18n.options && i18n.options.defaultNS,
        i18n: i18n,
        t: tFromProps,
        shouldUnescape: shouldUnescape
    }, additionalProps));
}

});
parcelRequire.register("cAQCs", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $92b1a9e8f8401ced$export$2e2bcd8739ae039; });

var $hPqK0 = parcelRequire("hPqK0");
function $92b1a9e8f8401ced$export$2e2bcd8739ae039(obj, key, value) {
    key = (0, $hPqK0.default)(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});
parcelRequire.register("hPqK0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cfabf14ba3084e51$export$2e2bcd8739ae039; });

var $f6w4m = parcelRequire("f6w4m");

var $5Hofl = parcelRequire("5Hofl");
function $cfabf14ba3084e51$export$2e2bcd8739ae039(arg) {
    var key = (0, $5Hofl.default)(arg, "string");
    return (0, $f6w4m.default)(key) === "symbol" ? key : String(key);
}

});
parcelRequire.register("f6w4m", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aff04ad6e2a38e0c$export$2e2bcd8739ae039; });
function $aff04ad6e2a38e0c$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $aff04ad6e2a38e0c$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $aff04ad6e2a38e0c$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("5Hofl", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4263c6b9f6834927$export$2e2bcd8739ae039; });

var $f6w4m = parcelRequire("f6w4m");
function $4263c6b9f6834927$export$2e2bcd8739ae039(input, hint) {
    if ((0, $f6w4m.default)(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ((0, $f6w4m.default)(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

});



parcelRequire.register("6slr9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4b35fc8934622263$export$2e2bcd8739ae039; });

var $dzm1y = parcelRequire("dzm1y");
function $4b35fc8934622263$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $dzm1y.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("dzm1y", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e0fa0c3dc137b46$export$2e2bcd8739ae039; });
function $9e0fa0c3dc137b46$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("a5U5G", function(module, exports) {

$parcel$export(module.exports, "Trans", function () { return $7595e17307b20ff1$export$8d6a9236f2e3f2ce; });

var $6slr9 = parcelRequire("6slr9");

var $f6w4m = parcelRequire("f6w4m");

var $cAQCs = parcelRequire("cAQCs");

var $eCoWV = parcelRequire("eCoWV");

var $3cZXo = parcelRequire("3cZXo");

var $e8fRk = parcelRequire("e8fRk");

var $lOdB5 = parcelRequire("lOdB5");

var $lVsXh = parcelRequire("lVsXh");
var $7595e17307b20ff1$var$_excluded = [
    "format"
], $7595e17307b20ff1$var$_excluded2 = [
    "children",
    "count",
    "parent",
    "i18nKey",
    "context",
    "tOptions",
    "values",
    "defaults",
    "components",
    "ns",
    "i18n",
    "t",
    "shouldUnescape"
];
function $7595e17307b20ff1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7595e17307b20ff1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7595e17307b20ff1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7595e17307b20ff1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7595e17307b20ff1$var$hasChildren(node, checkLength) {
    if (!node) return false;
    var base = node.props ? node.props.children : node.children;
    if (checkLength) return base.length > 0;
    return !!base;
}
function $7595e17307b20ff1$var$getChildren(node) {
    if (!node) return [];
    return node.props ? node.props.children : node.children;
}
function $7595e17307b20ff1$var$hasValidReactChildren(children) {
    if (Object.prototype.toString.call(children) !== "[object Array]") return false;
    return children.every(function(child) {
        return (0, $eCoWV.isValidElement)(child);
    });
}
function $7595e17307b20ff1$var$getAsArray(data) {
    return Array.isArray(data) ? data : [
        data
    ];
}
function $7595e17307b20ff1$var$mergeProps(source, target) {
    var newTarget = $7595e17307b20ff1$var$_objectSpread({}, target);
    newTarget.props = Object.assign(source.props, target.props);
    return newTarget;
}
function $7595e17307b20ff1$export$4f7a36dd898f1267(children, i18nOptions) {
    if (!children) return "";
    var stringNode = "";
    var childrenArray = $7595e17307b20ff1$var$getAsArray(children);
    var keepArray = i18nOptions.transSupportBasicHtmlNodes && i18nOptions.transKeepBasicHtmlNodesFor ? i18nOptions.transKeepBasicHtmlNodesFor : [];
    childrenArray.forEach(function(child, childIndex) {
        if (typeof child === "string") stringNode += "".concat(child);
        else if ((0, $eCoWV.isValidElement)(child)) {
            var childPropsCount = Object.keys(child.props).length;
            var shouldKeepChild = keepArray.indexOf(child.type) > -1;
            var childChildren = child.props.children;
            if (!childChildren && shouldKeepChild && childPropsCount === 0) stringNode += "<".concat(child.type, "/>");
            else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (child.props.i18nIsDynamicList) stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
            else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === "string") stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
            else {
                var content = $7595e17307b20ff1$export$4f7a36dd898f1267(childChildren, i18nOptions);
                stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
            }
        } else if (child === null) (0, $e8fRk.warn)("Trans: the passed in value is invalid - seems you passed in a null child.");
        else if ((0, $f6w4m.default)(child) === "object") {
            var format = child.format, clone = (0, $6slr9.default)(child, $7595e17307b20ff1$var$_excluded);
            var keys = Object.keys(clone);
            if (keys.length === 1) {
                var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
                stringNode += "{{".concat(value, "}}");
            } else (0, $e8fRk.warn)("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
        } else (0, $e8fRk.warn)("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    });
    return stringNode;
}
function $7595e17307b20ff1$var$renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts, shouldUnescape) {
    if (targetString === "") return [];
    var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
    var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join("|")).test(targetString);
    if (!children && !emptyChildrenButNeedsHandling) return [
        targetString
    ];
    var data = {};
    function getData(childs) {
        var childrenArray = $7595e17307b20ff1$var$getAsArray(childs);
        childrenArray.forEach(function(child) {
            if (typeof child === "string") return;
            if ($7595e17307b20ff1$var$hasChildren(child)) getData($7595e17307b20ff1$var$getChildren(child));
            else if ((0, $f6w4m.default)(child) === "object" && !(0, $eCoWV.isValidElement)(child)) Object.assign(data, child);
        });
    }
    getData(children);
    var ast = (0, $3cZXo.default).parse("<0>".concat(targetString, "</0>"));
    var opts = $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, data), combinedTOpts);
    function renderInner(child, node, rootReactNode) {
        var childs = $7595e17307b20ff1$var$getChildren(child);
        var mappedChildren = mapAST(childs, node.children, rootReactNode);
        return $7595e17307b20ff1$var$hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
    }
    function pushTranslatedJSX(child, inner, mem, i, isVoid) {
        if (child.dummy) child.children = inner;
        mem.push((0, $eCoWV.cloneElement)(child, $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, child.props), {}, {
            key: i
        }), isVoid ? undefined : inner));
    }
    function mapAST(reactNode, astNode, rootReactNode) {
        var reactNodes = $7595e17307b20ff1$var$getAsArray(reactNode);
        var astNodes = $7595e17307b20ff1$var$getAsArray(astNode);
        return astNodes.reduce(function(mem, node, i) {
            var translationContent = node.children && node.children[0] && node.children[0].content && i18n.services.interpolator.interpolate(node.children[0].content, opts, i18n.language);
            if (node.type === "tag") {
                var tmp = reactNodes[parseInt(node.name, 10)];
                if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
                if (!tmp) tmp = {};
                var child = Object.keys(node.attrs).length !== 0 ? $7595e17307b20ff1$var$mergeProps({
                    props: node.attrs
                }, tmp) : tmp;
                var isElement = (0, $eCoWV.isValidElement)(child);
                var isValidTranslationWithChildren = isElement && $7595e17307b20ff1$var$hasChildren(node, true) && !node.voidElement;
                var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && (0, $f6w4m.default)(child) === "object" && child.dummy && !isElement;
                var isKnownComponent = (0, $f6w4m.default)(children) === "object" && children !== null && Object.hasOwnProperty.call(children, node.name);
                if (typeof child === "string") {
                    var value = i18n.services.interpolator.interpolate(child, opts, i18n.language);
                    mem.push(value);
                } else if ($7595e17307b20ff1$var$hasChildren(child) || isValidTranslationWithChildren) {
                    var inner = renderInner(child, node, rootReactNode);
                    pushTranslatedJSX(child, inner, mem, i);
                } else if (isEmptyTransWithHTML) {
                    var _inner = mapAST(reactNodes, node.children, rootReactNode);
                    mem.push((0, $eCoWV.cloneElement)(child, $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, child.props), {}, {
                        key: i
                    }), _inner));
                } else if (Number.isNaN(parseFloat(node.name))) {
                    if (isKnownComponent) {
                        var _inner2 = renderInner(child, node, rootReactNode);
                        pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
                    } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
                        if (node.voidElement) mem.push((0, $eCoWV.createElement)(node.name, {
                            key: "".concat(node.name, "-").concat(i)
                        }));
                        else {
                            var _inner3 = mapAST(reactNodes, node.children, rootReactNode);
                            mem.push((0, $eCoWV.createElement)(node.name, {
                                key: "".concat(node.name, "-").concat(i)
                            }, _inner3));
                        }
                    } else if (node.voidElement) mem.push("<".concat(node.name, " />"));
                    else {
                        var _inner4 = mapAST(reactNodes, node.children, rootReactNode);
                        mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
                    }
                } else if ((0, $f6w4m.default)(child) === "object" && !isElement) {
                    var content = node.children[0] ? translationContent : null;
                    if (content) mem.push(content);
                } else if (node.children.length === 1 && translationContent) mem.push((0, $eCoWV.cloneElement)(child, $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, child.props), {}, {
                    key: i
                }), translationContent));
                else mem.push((0, $eCoWV.cloneElement)(child, $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, child.props), {}, {
                    key: i
                })));
            } else if (node.type === "text") {
                var wrapTextNodes = i18nOptions.transWrapTextNodes;
                var _content = shouldUnescape ? i18nOptions.unescape(i18n.services.interpolator.interpolate(node.content, opts, i18n.language)) : i18n.services.interpolator.interpolate(node.content, opts, i18n.language);
                if (wrapTextNodes) mem.push((0, $eCoWV.createElement)(wrapTextNodes, {
                    key: "".concat(node.name, "-").concat(i)
                }, _content));
                else mem.push(_content);
            }
            return mem;
        }, []);
    }
    var result = mapAST([
        {
            dummy: true,
            children: children || []
        }
    ], ast, $7595e17307b20ff1$var$getAsArray(children || []));
    return $7595e17307b20ff1$var$getChildren(result[0]);
}
function $7595e17307b20ff1$export$8d6a9236f2e3f2ce(_ref) {
    var children = _ref.children, count = _ref.count, parent = _ref.parent, i18nKey = _ref.i18nKey, context = _ref.context, _ref$tOptions = _ref.tOptions, tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions, values = _ref.values, defaults = _ref.defaults, components = _ref.components, ns = _ref.ns, i18nFromProps = _ref.i18n, tFromProps = _ref.t, shouldUnescape = _ref.shouldUnescape, additionalProps = (0, $6slr9.default)(_ref, $7595e17307b20ff1$var$_excluded2);
    var i18n = i18nFromProps || (0, $lVsXh.getI18n)();
    if (!i18n) {
        (0, $e8fRk.warnOnce)("You will need to pass in an i18next instance by using i18nextReactModule");
        return children;
    }
    var t = tFromProps || i18n.t.bind(i18n) || function(k) {
        return k;
    };
    if (context) tOptions.context = context;
    var reactI18nextOptions = $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, (0, $lOdB5.getDefaults)()), i18n.options && i18n.options.react);
    var namespaces = ns || t.ns || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    var defaultValue = defaults || $7595e17307b20ff1$export$4f7a36dd898f1267(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
    var hashTransKey = reactI18nextOptions.hashTransKey;
    var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
    var interpolationOverride = values ? tOptions.interpolation : {
        interpolation: $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, tOptions.interpolation), {}, {
            prefix: "#$?",
            suffix: "?$#"
        })
    };
    var combinedTOpts = $7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread($7595e17307b20ff1$var$_objectSpread({}, tOptions), {}, {
        count: count
    }, values), interpolationOverride), {}, {
        defaultValue: defaultValue,
        ns: namespaces
    });
    var translation = key ? t(key, combinedTOpts) : defaultValue;
    var content = $7595e17307b20ff1$var$renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts, shouldUnescape);
    var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
    return useAsParent ? (0, $eCoWV.createElement)(useAsParent, additionalProps, content) : content;
}

});
parcelRequire.register("3cZXo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $25628d6dec0b1035$export$2e2bcd8739ae039; });

var $fiQE5 = parcelRequire("fiQE5");
var $25628d6dec0b1035$var$t = /\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;
function $25628d6dec0b1035$var$n(n) {
    var r = {
        type: "tag",
        name: "",
        voidElement: !1,
        attrs: {},
        children: []
    }, i = n.match(/<\/?([^\s]+?)[/\s>]/);
    if (i && (r.name = i[1], ((0, (/*@__PURE__*/$parcel$interopDefault($fiQE5)))[i[1]] || "/" === n.charAt(n.length - 2)) && (r.voidElement = !0), r.name.startsWith("!--"))) {
        var s = n.indexOf("-->");
        return {
            type: "comment",
            comment: -1 !== s ? n.slice(4, s) : ""
        };
    }
    for(var a = new RegExp($25628d6dec0b1035$var$t), c = null; null !== (c = a.exec(n));)if (c[0].trim()) {
        if (c[1]) {
            var o = c[1].trim(), l = [
                o,
                ""
            ];
            o.indexOf("=") > -1 && (l = o.split("=")), r.attrs[l[0]] = l[1], a.lastIndex--;
        } else c[2] && (r.attrs[c[2]] = c[3].trim().substring(1, c[3].length - 1));
    }
    return r;
}
var $25628d6dec0b1035$var$r = /<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g, $25628d6dec0b1035$var$i = /^\s*$/, $25628d6dec0b1035$var$s = Object.create(null);
function $25628d6dec0b1035$var$a(e, t) {
    switch(t.type){
        case "text":
            return e + t.content;
        case "tag":
            return e += "<" + t.name + (t.attrs ? function(e) {
                var t = [];
                for(var n in e)t.push(n + '="' + e[n] + '"');
                return t.length ? " " + t.join(" ") : "";
            }(t.attrs) : "") + (t.voidElement ? "/>" : ">"), t.voidElement ? e : e + t.children.reduce($25628d6dec0b1035$var$a, "") + "</" + t.name + ">";
        case "comment":
            return e + "<!--" + t.comment + "-->";
    }
}
var $25628d6dec0b1035$var$c = {
    parse: function(e, t) {
        t || (t = {}), t.components || (t.components = $25628d6dec0b1035$var$s);
        var a, c = [], o = [], l = -1, m = !1;
        if (0 !== e.indexOf("<")) {
            var u = e.indexOf("<");
            c.push({
                type: "text",
                content: -1 === u ? e : e.substring(0, u)
            });
        }
        return e.replace($25628d6dec0b1035$var$r, function(r, s) {
            if (m) {
                if (r !== "</" + a.name + ">") return;
                m = !1;
            }
            var u, f = "/" !== r.charAt(1), h = r.startsWith("<!--"), p = s + r.length, d = e.charAt(p);
            if (h) {
                var v = $25628d6dec0b1035$var$n(r);
                return l < 0 ? (c.push(v), c) : ((u = o[l]).children.push(v), c);
            }
            if (f && (l++, "tag" === (a = $25628d6dec0b1035$var$n(r)).type && t.components[a.name] && (a.type = "component", m = !0), a.voidElement || m || !d || "<" === d || a.children.push({
                type: "text",
                content: e.slice(p, e.indexOf("<", p))
            }), 0 === l && c.push(a), (u = o[l - 1]) && u.children.push(a), o[l] = a), (!f || a.voidElement) && (l > -1 && (a.voidElement || a.name === r.slice(2, -1)) && (l--, a = -1 === l ? c : o[l]), !m && "<" !== d && d)) {
                u = -1 === l ? c : o[l].children;
                var x = e.indexOf("<", p), g = e.slice(p, -1 === x ? void 0 : x);
                $25628d6dec0b1035$var$i.test(g) && (g = " "), (x > -1 && l + u.length >= 0 || " " !== g) && u.push({
                    type: "text",
                    content: g
                });
            }
        }), c;
    },
    stringify: function(e) {
        return e.reduce(function(e, t) {
            return e + $25628d6dec0b1035$var$a("", t);
        }, "");
    }
};
var $25628d6dec0b1035$export$2e2bcd8739ae039 = $25628d6dec0b1035$var$c;

});
parcelRequire.register("fiQE5", function(module, exports) {
/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */ module.exports = {
    "area": true,
    "base": true,
    "br": true,
    "col": true,
    "embed": true,
    "hr": true,
    "img": true,
    "input": true,
    "link": true,
    "meta": true,
    "param": true,
    "source": true,
    "track": true,
    "wbr": true
};

});


parcelRequire.register("e8fRk", function(module, exports) {

$parcel$export(module.exports, "warn", function () { return $a49e1d53e505cb69$export$c106dd0671a0fc2d; });
$parcel$export(module.exports, "warnOnce", function () { return $a49e1d53e505cb69$export$5b28268982f175ba; });
$parcel$export(module.exports, "loadNamespaces", function () { return $a49e1d53e505cb69$export$83be934b53fff43b; });
$parcel$export(module.exports, "loadLanguages", function () { return $a49e1d53e505cb69$export$8cd7e7a54fa865bc; });
$parcel$export(module.exports, "hasLoadedNamespace", function () { return $a49e1d53e505cb69$export$93d9ee97c1ad3f31; });
$parcel$export(module.exports, "getDisplayName", function () { return $a49e1d53e505cb69$export$be63e0664592e141; });
function $a49e1d53e505cb69$export$c106dd0671a0fc2d() {
    if (console && console.warn) {
        var _console;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (typeof args[0] === "string") args[0] = "react-i18next:: ".concat(args[0]);
        (_console = console).warn.apply(_console, args);
    }
}
var $a49e1d53e505cb69$var$alreadyWarned = {};
function $a49e1d53e505cb69$export$5b28268982f175ba() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (typeof args[0] === "string" && $a49e1d53e505cb69$var$alreadyWarned[args[0]]) return;
    if (typeof args[0] === "string") $a49e1d53e505cb69$var$alreadyWarned[args[0]] = new Date();
    $a49e1d53e505cb69$export$c106dd0671a0fc2d.apply(void 0, args);
}
var $a49e1d53e505cb69$var$loadedClb = function loadedClb(i18n, cb) {
    return function() {
        if (i18n.isInitialized) cb();
        else {
            var initialized = function initialized() {
                setTimeout(function() {
                    i18n.off("initialized", initialized);
                }, 0);
                cb();
            };
            i18n.on("initialized", initialized);
        }
    };
};
function $a49e1d53e505cb69$export$83be934b53fff43b(i18n, ns, cb) {
    i18n.loadNamespaces(ns, $a49e1d53e505cb69$var$loadedClb(i18n, cb));
}
function $a49e1d53e505cb69$export$8cd7e7a54fa865bc(i18n, lng, ns, cb) {
    if (typeof ns === "string") ns = [
        ns
    ];
    ns.forEach(function(n) {
        if (i18n.options.ns.indexOf(n) < 0) i18n.options.ns.push(n);
    });
    i18n.loadLanguages(lng, $a49e1d53e505cb69$var$loadedClb(i18n, cb));
}
function $a49e1d53e505cb69$var$oldI18nextHasLoadedNamespace(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var lng = i18n.languages[0];
    var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
    var lastLng = i18n.languages[i18n.languages.length - 1];
    if (lng.toLowerCase() === "cimode") return true;
    var loadNotPending = function loadNotPending(l, n) {
        var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
        return loadState === -1 || loadState === 2;
    };
    if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
    if (i18n.hasResourceBundle(lng, ns)) return true;
    if (!i18n.services.backendConnector.backend || i18n.options.resources && !i18n.options.partialBundledLanguages) return true;
    if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
    return false;
}
function $a49e1d53e505cb69$export$93d9ee97c1ad3f31(ns, i18n) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (!i18n.languages || !i18n.languages.length) {
        $a49e1d53e505cb69$export$5b28268982f175ba("i18n.languages were undefined or empty", i18n.languages);
        return true;
    }
    var isNewerI18next = i18n.options.ignoreJSONStructure !== undefined;
    if (!isNewerI18next) return $a49e1d53e505cb69$var$oldI18nextHasLoadedNamespace(ns, i18n, options);
    return i18n.hasLoadedNamespace(ns, {
        lng: options.lng,
        precheck: function precheck(i18nInstance, loadNotPending) {
            if (options.bindI18n && options.bindI18n.indexOf("languageChanging") > -1 && i18nInstance.services.backendConnector.backend && i18nInstance.isLanguageChangingTo && !loadNotPending(i18nInstance.isLanguageChangingTo, ns)) return false;
        }
    });
}
function $a49e1d53e505cb69$export$be63e0664592e141(Component) {
    return Component.displayName || Component.name || (typeof Component === "string" && Component.length > 0 ? Component : "Unknown");
}

});

parcelRequire.register("lOdB5", function(module, exports) {

$parcel$export(module.exports, "setDefaults", function () { return $fe08d095f531f12c$export$2e2366488d12e20d; });
$parcel$export(module.exports, "getDefaults", function () { return $fe08d095f531f12c$export$212bb2fc580a90a8; });

var $cAQCs = parcelRequire("cAQCs");

var $05gFl = parcelRequire("05gFl");
function $fe08d095f531f12c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fe08d095f531f12c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fe08d095f531f12c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fe08d095f531f12c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $fe08d095f531f12c$var$defaultOptions = {
    bindI18n: "languageChanged",
    bindI18nStore: "",
    transEmptyNodeValue: "",
    transSupportBasicHtmlNodes: true,
    transWrapTextNodes: "",
    transKeepBasicHtmlNodesFor: [
        "br",
        "strong",
        "i",
        "p"
    ],
    useSuspense: true,
    unescape: (0, $05gFl.unescape)
};
function $fe08d095f531f12c$export$2e2366488d12e20d() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    $fe08d095f531f12c$var$defaultOptions = $fe08d095f531f12c$var$_objectSpread($fe08d095f531f12c$var$_objectSpread({}, $fe08d095f531f12c$var$defaultOptions), options);
}
function $fe08d095f531f12c$export$212bb2fc580a90a8() {
    return $fe08d095f531f12c$var$defaultOptions;
}

});
parcelRequire.register("05gFl", function(module, exports) {

$parcel$export(module.exports, "unescape", function () { return $00fd654026a35c81$export$e8bacd2802a88316; });
var $00fd654026a35c81$var$matchHtmlEntity = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g;
var $00fd654026a35c81$var$htmlEntities = {
    "&amp;": "&",
    "&#38;": "&",
    "&lt;": "<",
    "&#60;": "<",
    "&gt;": ">",
    "&#62;": ">",
    "&apos;": "'",
    "&#39;": "'",
    "&quot;": '"',
    "&#34;": '"',
    "&nbsp;": " ",
    "&#160;": " ",
    "&copy;": "\xa9",
    "&#169;": "\xa9",
    "&reg;": "\xae",
    "&#174;": "\xae",
    "&hellip;": "…",
    "&#8230;": "…",
    "&#x2F;": "/",
    "&#47;": "/"
};
var $00fd654026a35c81$var$unescapeHtmlEntity = function unescapeHtmlEntity(m) {
    return $00fd654026a35c81$var$htmlEntities[m];
};
var $00fd654026a35c81$export$e8bacd2802a88316 = function unescape(text) {
    return text.replace($00fd654026a35c81$var$matchHtmlEntity, $00fd654026a35c81$var$unescapeHtmlEntity);
};

});


parcelRequire.register("lVsXh", function(module, exports) {

$parcel$export(module.exports, "setI18n", function () { return $ff6561b8ec934142$export$a039134f2fc7e0; });
$parcel$export(module.exports, "getI18n", function () { return $ff6561b8ec934142$export$64af334f494c2f47; });
var $ff6561b8ec934142$var$i18nInstance;
function $ff6561b8ec934142$export$a039134f2fc7e0(instance) {
    $ff6561b8ec934142$var$i18nInstance = instance;
}
function $ff6561b8ec934142$export$64af334f494c2f47() {
    return $ff6561b8ec934142$var$i18nInstance;
}

});


parcelRequire.register("4sJzM", function(module, exports) {

$parcel$export(module.exports, "I18nContext", function () { return $33fd216b3a70678d$export$5603ab5ced17ce64; });
$parcel$export(module.exports, "ReportNamespaces", function () { return $33fd216b3a70678d$export$ea171b67e3820290; });
$parcel$export(module.exports, "composeInitialProps", function () { return $33fd216b3a70678d$export$30ff0342ccf735a; });
$parcel$export(module.exports, "getDefaults", function () { return (parcelRequire("lOdB5")).getDefaults; });
$parcel$export(module.exports, "getI18n", function () { return (parcelRequire("lVsXh")).getI18n; });

var $cAQCs = parcelRequire("cAQCs");

var $gfYX1 = parcelRequire("gfYX1");

var $gvD6c = parcelRequire("gvD6c");

var $eCoWV = parcelRequire("eCoWV");

var $lOdB5 = parcelRequire("lOdB5");

var $lVsXh = parcelRequire("lVsXh");

var $29gsH = parcelRequire("29gsH");
function $33fd216b3a70678d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $33fd216b3a70678d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $33fd216b3a70678d$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $33fd216b3a70678d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $33fd216b3a70678d$export$5603ab5ced17ce64 = (0, $eCoWV.createContext)();
var $33fd216b3a70678d$export$ea171b67e3820290 = function() {
    function ReportNamespaces() {
        (0, $gfYX1.default)(this, ReportNamespaces);
        this.usedNamespaces = {};
    }
    (0, $gvD6c.default)(ReportNamespaces, [
        {
            key: "addUsedNamespaces",
            value: function addUsedNamespaces(namespaces) {
                var _this = this;
                namespaces.forEach(function(ns) {
                    if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
                });
            }
        },
        {
            key: "getUsedNamespaces",
            value: function getUsedNamespaces() {
                return Object.keys(this.usedNamespaces);
            }
        }
    ]);
    return ReportNamespaces;
}();
function $33fd216b3a70678d$export$30ff0342ccf735a(ForComponent) {
    return function(ctx) {
        return new Promise(function(resolve) {
            var i18nInitialProps = $33fd216b3a70678d$export$704200e5d0b9e8f();
            if (ForComponent.getInitialProps) ForComponent.getInitialProps(ctx).then(function(componentsInitialProps) {
                resolve($33fd216b3a70678d$var$_objectSpread($33fd216b3a70678d$var$_objectSpread({}, componentsInitialProps), i18nInitialProps));
            });
            else resolve(i18nInitialProps);
        });
    };
}
function $33fd216b3a70678d$export$704200e5d0b9e8f() {
    var i18n = (0, $lVsXh.getI18n)();
    var namespaces = i18n.reportNamespaces ? i18n.reportNamespaces.getUsedNamespaces() : [];
    var ret = {};
    var initialI18nStore = {};
    i18n.languages.forEach(function(l) {
        initialI18nStore[l] = {};
        namespaces.forEach(function(ns) {
            initialI18nStore[l][ns] = i18n.getResourceBundle(l, ns) || {};
        });
    });
    ret.initialI18nStore = initialI18nStore;
    ret.initialLanguage = i18n.language;
    return ret;
}

});
parcelRequire.register("gfYX1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bd5d53aa41a35dd1$export$2e2bcd8739ae039; });
function $bd5d53aa41a35dd1$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("gvD6c", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c04dded876ea7547$export$2e2bcd8739ae039; });

var $hPqK0 = parcelRequire("hPqK0");
function $c04dded876ea7547$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, (0, $hPqK0.default)(descriptor.key), descriptor);
    }
}
function $c04dded876ea7547$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $c04dded876ea7547$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c04dded876ea7547$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRequire.register("29gsH", function(module, exports) {

$parcel$export(module.exports, "initReactI18next", function () { return $1909310c472dcf66$export$ae7e14d40d89f296; });

var $lOdB5 = parcelRequire("lOdB5");

var $lVsXh = parcelRequire("lVsXh");
var $1909310c472dcf66$export$ae7e14d40d89f296 = {
    type: "3rdParty",
    init: function init(instance) {
        (0, $lOdB5.setDefaults)(instance.options.react);
        (0, $lVsXh.setI18n)(instance);
    }
};

});



parcelRequire.register("2A6IJ", function(module, exports) {

$parcel$export(module.exports, "useTranslation", function () { return $1e14281e3cf3fe7f$export$9fc83ad70ead8663; });

var $kiLiZ = parcelRequire("kiLiZ");

var $cAQCs = parcelRequire("cAQCs");

var $f6w4m = parcelRequire("f6w4m");

var $eCoWV = parcelRequire("eCoWV");

var $4sJzM = parcelRequire("4sJzM");
var $lVsXh = parcelRequire("lVsXh");
var $lOdB5 = parcelRequire("lOdB5");

var $e8fRk = parcelRequire("e8fRk");
function $1e14281e3cf3fe7f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1e14281e3cf3fe7f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1e14281e3cf3fe7f$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1e14281e3cf3fe7f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $1e14281e3cf3fe7f$var$usePrevious = function usePrevious(value, ignore) {
    var ref = (0, $eCoWV.useRef)();
    (0, $eCoWV.useEffect)(function() {
        ref.current = ignore ? ref.current : value;
    }, [
        value,
        ignore
    ]);
    return ref.current;
};
function $1e14281e3cf3fe7f$export$9fc83ad70ead8663(ns) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eCoWV.useContext)((0, $4sJzM.I18nContext)) || {}, i18nFromContext = _ref.i18n, defaultNSFromContext = _ref.defaultNS;
    var i18n = i18nFromProps || i18nFromContext || (0, $lVsXh.getI18n)();
    if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new (0, $4sJzM.ReportNamespaces)();
    if (!i18n) {
        (0, $e8fRk.warnOnce)("You will need to pass in an i18next instance by using initReactI18next");
        var notReadyT = function notReadyT(k, optsOrDefaultValue) {
            if (typeof optsOrDefaultValue === "string") return optsOrDefaultValue;
            if (optsOrDefaultValue && (0, $f6w4m.default)(optsOrDefaultValue) === "object" && typeof optsOrDefaultValue.defaultValue === "string") return optsOrDefaultValue.defaultValue;
            return Array.isArray(k) ? k[k.length - 1] : k;
        };
        var retNotReady = [
            notReadyT,
            {},
            false
        ];
        retNotReady.t = notReadyT;
        retNotReady.i18n = {};
        retNotReady.ready = false;
        return retNotReady;
    }
    if (i18n.options.react && i18n.options.react.wait !== undefined) (0, $e8fRk.warnOnce)("It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
    var i18nOptions = $1e14281e3cf3fe7f$var$_objectSpread($1e14281e3cf3fe7f$var$_objectSpread($1e14281e3cf3fe7f$var$_objectSpread({}, (0, $lOdB5.getDefaults)()), i18n.options.react), props);
    var useSuspense = i18nOptions.useSuspense, keyPrefix = i18nOptions.keyPrefix;
    var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
    namespaces = typeof namespaces === "string" ? [
        namespaces
    ] : namespaces || [
        "translation"
    ];
    if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
    var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function(n) {
        return (0, $e8fRk.hasLoadedNamespace)(n, i18n, i18nOptions);
    });
    function getT() {
        return i18n.getFixedT(props.lng || null, i18nOptions.nsMode === "fallback" ? namespaces : namespaces[0], keyPrefix);
    }
    var _useState = (0, $eCoWV.useState)(getT), _useState2 = (0, $kiLiZ.default)(_useState, 2), t = _useState2[0], setT = _useState2[1];
    var joinedNS = namespaces.join();
    if (props.lng) joinedNS = "".concat(props.lng).concat(joinedNS);
    var previousJoinedNS = $1e14281e3cf3fe7f$var$usePrevious(joinedNS);
    var isMounted = (0, $eCoWV.useRef)(true);
    (0, $eCoWV.useEffect)(function() {
        var bindI18n = i18nOptions.bindI18n, bindI18nStore = i18nOptions.bindI18nStore;
        isMounted.current = true;
        if (!ready && !useSuspense) {
            if (props.lng) (0, $e8fRk.loadLanguages)(i18n, props.lng, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
            else (0, $e8fRk.loadNamespaces)(i18n, namespaces, function() {
                if (isMounted.current) setT(getT);
            });
        }
        if (ready && previousJoinedNS && previousJoinedNS !== joinedNS && isMounted.current) setT(getT);
        function boundReset() {
            if (isMounted.current) setT(getT);
        }
        if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
        if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
        return function() {
            isMounted.current = false;
            if (bindI18n && i18n) bindI18n.split(" ").forEach(function(e) {
                return i18n.off(e, boundReset);
            });
            if (bindI18nStore && i18n) bindI18nStore.split(" ").forEach(function(e) {
                return i18n.store.off(e, boundReset);
            });
        };
    }, [
        i18n,
        joinedNS
    ]);
    var isInitial = (0, $eCoWV.useRef)(true);
    (0, $eCoWV.useEffect)(function() {
        if (isMounted.current && !isInitial.current) setT(getT);
        isInitial.current = false;
    }, [
        i18n,
        keyPrefix
    ]);
    var ret = [
        t,
        i18n,
        ready
    ];
    ret.t = t;
    ret.i18n = i18n;
    ret.ready = ready;
    if (ready) return ret;
    if (!ready && !useSuspense) return ret;
    throw new Promise(function(resolve) {
        if (props.lng) (0, $e8fRk.loadLanguages)(i18n, props.lng, namespaces, function() {
            return resolve();
        });
        else (0, $e8fRk.loadNamespaces)(i18n, namespaces, function() {
            return resolve();
        });
    });
}

});
parcelRequire.register("kiLiZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ec7a2eeb67d5346c$export$2e2bcd8739ae039; });

var $d9aks = parcelRequire("d9aks");

var $fmxdw = parcelRequire("fmxdw");

var $jxBKF = parcelRequire("jxBKF");

var $7FpJP = parcelRequire("7FpJP");
function $ec7a2eeb67d5346c$export$2e2bcd8739ae039(arr, i) {
    return (0, $d9aks.default)(arr) || (0, $fmxdw.default)(arr, i) || (0, $jxBKF.default)(arr, i) || (0, $7FpJP.default)();
}

});
parcelRequire.register("d9aks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $992420ba90f6a883$export$2e2bcd8739ae039; });
function $992420ba90f6a883$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("fmxdw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2f2ad528d01081d$export$2e2bcd8739ae039; });
function $b2f2ad528d01081d$export$2e2bcd8739ae039(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}

});

parcelRequire.register("jxBKF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e39e6213b3e8e583$export$2e2bcd8739ae039; });

var $8VCtj = parcelRequire("8VCtj");
function $e39e6213b3e8e583$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $8VCtj.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $8VCtj.default)(o, minLen);
}

});
parcelRequire.register("8VCtj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $68017d4ae4a34cfe$export$2e2bcd8739ae039; });
function $68017d4ae4a34cfe$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("7FpJP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $595053c7bcc8f0b5$export$2e2bcd8739ae039; });
function $595053c7bcc8f0b5$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRequire.register("kiiuf", function(module, exports) {

$parcel$export(module.exports, "withTranslation", function () { return $ec63d42ce026b65e$export$2dcb0053efd21124; });

var $cAQCs = parcelRequire("cAQCs");

var $kiLiZ = parcelRequire("kiLiZ");

var $6slr9 = parcelRequire("6slr9");

var $eCoWV = parcelRequire("eCoWV");

var $2A6IJ = parcelRequire("2A6IJ");

var $e8fRk = parcelRequire("e8fRk");
var $ec63d42ce026b65e$var$_excluded = [
    "forwardedRef"
];
function $ec63d42ce026b65e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ec63d42ce026b65e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ec63d42ce026b65e$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ec63d42ce026b65e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ec63d42ce026b65e$export$2dcb0053efd21124(ns) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return function Extend(WrappedComponent) {
        function I18nextWithTranslation(_ref) {
            var forwardedRef = _ref.forwardedRef, rest = (0, $6slr9.default)(_ref, $ec63d42ce026b65e$var$_excluded);
            var _useTranslation = (0, $2A6IJ.useTranslation)(ns, $ec63d42ce026b65e$var$_objectSpread($ec63d42ce026b65e$var$_objectSpread({}, rest), {}, {
                keyPrefix: options.keyPrefix
            })), _useTranslation2 = (0, $kiLiZ.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
            var passDownProps = $ec63d42ce026b65e$var$_objectSpread($ec63d42ce026b65e$var$_objectSpread({}, rest), {}, {
                t: t,
                i18n: i18n,
                tReady: ready
            });
            if (options.withRef && forwardedRef) passDownProps.ref = forwardedRef;
            else if (!options.withRef && forwardedRef) passDownProps.forwardedRef = forwardedRef;
            return (0, $eCoWV.createElement)(WrappedComponent, passDownProps);
        }
        I18nextWithTranslation.displayName = "withI18nextTranslation(".concat((0, $e8fRk.getDisplayName)(WrappedComponent), ")");
        I18nextWithTranslation.WrappedComponent = WrappedComponent;
        var forwardRef = function forwardRef(props, ref) {
            return (0, $eCoWV.createElement)(I18nextWithTranslation, Object.assign({}, props, {
                forwardedRef: ref
            }));
        };
        return options.withRef ? (0, $eCoWV.forwardRef)(forwardRef) : I18nextWithTranslation;
    };
}

});

parcelRequire.register("aXilW", function(module, exports) {

var $kiLiZ = parcelRequire("kiLiZ");

var $6slr9 = parcelRequire("6slr9");

var $2A6IJ = parcelRequire("2A6IJ");
var $7f9da68f1d4e046b$var$_excluded = [
    "ns",
    "children"
];
function $7f9da68f1d4e046b$export$b63289fbda65eed1(props) {
    var ns = props.ns, children = props.children, options = (0, $6slr9.default)(props, $7f9da68f1d4e046b$var$_excluded);
    var _useTranslation = (0, $2A6IJ.useTranslation)(ns, options), _useTranslation2 = (0, $kiLiZ.default)(_useTranslation, 3), t = _useTranslation2[0], i18n = _useTranslation2[1], ready = _useTranslation2[2];
    return children(t, {
        i18n: i18n,
        lng: i18n.language
    }, ready);
}

});

parcelRequire.register("3OpbJ", function(module, exports) {

var $eCoWV = parcelRequire("eCoWV");

var $4sJzM = parcelRequire("4sJzM");
function $2c69947246a6816b$export$1325e8699caa160f(_ref) {
    var i18n = _ref.i18n, defaultNS = _ref.defaultNS, children = _ref.children;
    var value = (0, $eCoWV.useMemo)(function() {
        return {
            i18n: i18n,
            defaultNS: defaultNS
        };
    }, [
        i18n,
        defaultNS
    ]);
    return (0, $eCoWV.createElement)((0, $4sJzM.I18nContext).Provider, {
        value: value
    }, children);
}

});

parcelRequire.register("aFm3t", function(module, exports) {

var $cAQCs = parcelRequire("cAQCs");

var $6slr9 = parcelRequire("6slr9");

var $eCoWV = parcelRequire("eCoWV");

var $kgDlb = parcelRequire("kgDlb");

var $4sJzM = parcelRequire("4sJzM");

var $e8fRk = parcelRequire("e8fRk");
var $7c3ed76207b362c1$var$_excluded = [
    "initialI18nStore",
    "initialLanguage"
];
function $7c3ed76207b362c1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7c3ed76207b362c1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $7c3ed76207b362c1$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $7c3ed76207b362c1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7c3ed76207b362c1$export$80dfa519af1c8605() {
    return function Extend(WrappedComponent) {
        function I18nextWithSSR(_ref) {
            var initialI18nStore = _ref.initialI18nStore, initialLanguage = _ref.initialLanguage, rest = (0, $6slr9.default)(_ref, $7c3ed76207b362c1$var$_excluded);
            (0, $kgDlb.useSSR)(initialI18nStore, initialLanguage);
            return (0, $eCoWV.createElement)(WrappedComponent, $7c3ed76207b362c1$var$_objectSpread({}, rest));
        }
        I18nextWithSSR.getInitialProps = (0, $4sJzM.composeInitialProps)(WrappedComponent);
        I18nextWithSSR.displayName = "withI18nextSSR(".concat((0, $e8fRk.getDisplayName)(WrappedComponent), ")");
        I18nextWithSSR.WrappedComponent = WrappedComponent;
        return I18nextWithSSR;
    };
}

});
parcelRequire.register("kgDlb", function(module, exports) {

$parcel$export(module.exports, "useSSR", function () { return $ec13d186cce2706c$export$3526fb65ade8d8b7; });

var $eCoWV = parcelRequire("eCoWV");

var $4sJzM = parcelRequire("4sJzM");
var $lVsXh = parcelRequire("lVsXh");
function $ec13d186cce2706c$export$3526fb65ade8d8b7(initialI18nStore, initialLanguage) {
    var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var i18nFromProps = props.i18n;
    var _ref = (0, $eCoWV.useContext)((0, $4sJzM.I18nContext)) || {}, i18nFromContext = _ref.i18n;
    var i18n = i18nFromProps || i18nFromContext || (0, $lVsXh.getI18n)();
    if (i18n.options && i18n.options.isClone) return;
    if (initialI18nStore && !i18n.initializedStoreOnce) {
        i18n.services.resourceStore.data = initialI18nStore;
        i18n.options.ns = Object.values(initialI18nStore).reduce(function(mem, lngResources) {
            Object.keys(lngResources).forEach(function(ns) {
                if (mem.indexOf(ns) < 0) mem.push(ns);
            });
            return mem;
        }, i18n.options.ns);
        i18n.initializedStoreOnce = true;
        i18n.isInitialized = true;
    }
    if (initialLanguage && !i18n.initializedLanguageOnce) {
        i18n.changeLanguage(initialLanguage);
        i18n.initializedLanguageOnce = true;
    }
}

});



parcelRequire.register("2mi28", function(module, exports) {

$parcel$export(module.exports, "SWRConfig", function () { return $4793b45759a85fc7$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "default", function () { return $4793b45759a85fc7$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "useSWRConfig", function () { return (parcelRequire("4Korf")).useSWRConfig; });

var $eCoWV = parcelRequire("eCoWV");

var $7ugWC = parcelRequire("7ugWC");

var $4Korf = parcelRequire("4Korf");
const $4793b45759a85fc7$export$dbab534a48e651ef = (key)=>(0, $4Korf.serialize)(key)[0];
/// <reference types="react/experimental" />
const $4793b45759a85fc7$var$use = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).use || ((promise)=>{
    if (promise.status === "pending") throw promise;
    else if (promise.status === "fulfilled") return promise.value;
    else if (promise.status === "rejected") throw promise.reason;
    else {
        promise.status = "pending";
        promise.then((v)=>{
            promise.status = "fulfilled";
            promise.value = v;
        }, (e)=>{
            promise.status = "rejected";
            promise.reason = e;
        });
        throw promise;
    }
});
const $4793b45759a85fc7$var$WITH_DEDUPE = {
    dedupe: true
};
const $4793b45759a85fc7$var$useSWRHandler = (_key, fetcher, config)=>{
    const { cache: cache, compare: compare, suspense: suspense, fallbackData: fallbackData, revalidateOnMount: revalidateOnMount, revalidateIfStale: revalidateIfStale, refreshInterval: refreshInterval, refreshWhenHidden: refreshWhenHidden, refreshWhenOffline: refreshWhenOffline, keepPreviousData: keepPreviousData } = config;
    const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = (0, $4Korf.SWRGlobalState).get(cache);
    // `key` is the identifier of the SWR internal state,
    // `fnArg` is the argument/arguments parsed from the key, which will be passed
    // to the fetcher.
    // All of them are derived from `_key`.
    const [key, fnArg] = (0, $4Korf.serialize)(_key);
    // If it's the initial render of this hook.
    const initialMountedRef = (0, $eCoWV.useRef)(false);
    // If the hook is unmounted already. This will be used to prevent some effects
    // to be called after unmounting.
    const unmountedRef = (0, $eCoWV.useRef)(false);
    // Refs to keep the key and config.
    const keyRef = (0, $eCoWV.useRef)(key);
    const fetcherRef = (0, $eCoWV.useRef)(fetcher);
    const configRef = (0, $eCoWV.useRef)(config);
    const getConfig = ()=>configRef.current;
    const isActive = ()=>getConfig().isVisible() && getConfig().isOnline();
    const [getCache, setCache, subscribeCache, getInitialCache] = (0, $4Korf.createCacheHelper)(cache, key);
    const stateDependencies = (0, $eCoWV.useRef)({}).current;
    const fallback = (0, $4Korf.isUndefined)(fallbackData) ? config.fallback[key] : fallbackData;
    const isEqual = (prev, current)=>{
        for(const _ in stateDependencies){
            const t = _;
            if (t === "data") {
                if (!compare(prev[t], current[t])) {
                    if (!(0, $4Korf.isUndefined)(prev[t])) return false;
                    if (!compare(returnedData, current[t])) return false;
                }
            } else {
                if (current[t] !== prev[t]) return false;
            }
        }
        return true;
    };
    const getSnapshot = (0, $eCoWV.useMemo)(()=>{
        const shouldStartRequest = (()=>{
            if (!key) return false;
            if (!fetcher) return false;
            // If `revalidateOnMount` is set, we take the value directly.
            if (!(0, $4Korf.isUndefined)(revalidateOnMount)) return revalidateOnMount;
            // If it's paused, we skip revalidation.
            if (getConfig().isPaused()) return false;
            if (suspense) return false;
            if (!(0, $4Korf.isUndefined)(revalidateIfStale)) return revalidateIfStale;
            return true;
        })();
        // Get the cache and merge it with expected states.
        const getSelectedCache = (state)=>{
            // We only select the needed fields from the state.
            const snapshot = (0, $4Korf.mergeObjects)(state);
            delete snapshot._k;
            if (!shouldStartRequest) return snapshot;
            return {
                isValidating: true,
                isLoading: true,
                ...snapshot
            };
        };
        const cachedData = getCache();
        const initialData = getInitialCache();
        const clientSnapshot = getSelectedCache(cachedData);
        const serverSnapshot = cachedData === initialData ? clientSnapshot : getSelectedCache(initialData);
        // To make sure that we are returning the same object reference to avoid
        // unnecessary re-renders, we keep the previous snapshot and use deep
        // comparison to check if we need to return a new one.
        let memorizedSnapshot = clientSnapshot;
        return [
            ()=>{
                const newSnapshot = getSelectedCache(getCache());
                const compareResult = isEqual(newSnapshot, memorizedSnapshot);
                if (compareResult) {
                    // Mentally, we should always return the `memorizedSnapshot` here
                    // as there's no change between the new and old snapshots.
                    // However, since the `isEqual` function only compares selected fields,
                    // the values of the unselected fields might be changed. That's
                    // simply because we didn't track them.
                    // To support the case in https://github.com/vercel/swr/pull/2576,
                    // we need to update these fields in the `memorizedSnapshot` too
                    // with direct mutations to ensure the snapshot is always up-to-date
                    // even for the unselected fields, but only trigger re-renders when
                    // the selected fields are changed.
                    memorizedSnapshot.data = newSnapshot.data;
                    memorizedSnapshot.isLoading = newSnapshot.isLoading;
                    memorizedSnapshot.isValidating = newSnapshot.isValidating;
                    memorizedSnapshot.error = newSnapshot.error;
                    return memorizedSnapshot;
                } else {
                    memorizedSnapshot = newSnapshot;
                    return newSnapshot;
                }
            },
            ()=>serverSnapshot
        ];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        cache,
        key
    ]);
    // Get the current state that SWR should return.
    const cached = (0, $7ugWC.useSyncExternalStore)((0, $eCoWV.useCallback)((callback)=>subscribeCache(key, (current, prev)=>{
            if (!isEqual(prev, current)) callback();
        }), [
        cache,
        key
    ]), getSnapshot[0], getSnapshot[1]);
    const isInitialMount = !initialMountedRef.current;
    const hasRevalidator = EVENT_REVALIDATORS[key] && EVENT_REVALIDATORS[key].length > 0;
    const cachedData = cached.data;
    const data = (0, $4Korf.isUndefined)(cachedData) ? fallback : cachedData;
    const error = cached.error;
    // Use a ref to store previously returned data. Use the initial data as its initial value.
    const laggyDataRef = (0, $eCoWV.useRef)(data);
    const returnedData = keepPreviousData ? (0, $4Korf.isUndefined)(cachedData) ? laggyDataRef.current : cachedData : data;
    // - Suspense mode and there's stale data for the initial render.
    // - Not suspense mode and there is no fallback data and `revalidateIfStale` is enabled.
    // - `revalidateIfStale` is enabled but `data` is not defined.
    const shouldDoInitialRevalidation = (()=>{
        // if a key already has revalidators and also has error, we should not trigger revalidation
        if (hasRevalidator && !(0, $4Korf.isUndefined)(error)) return false;
        // If `revalidateOnMount` is set, we take the value directly.
        if (isInitialMount && !(0, $4Korf.isUndefined)(revalidateOnMount)) return revalidateOnMount;
        // If it's paused, we skip revalidation.
        if (getConfig().isPaused()) return false;
        // Under suspense mode, it will always fetch on render if there is no
        // stale data so no need to revalidate immediately mount it again.
        // If data exists, only revalidate if `revalidateIfStale` is true.
        if (suspense) return (0, $4Korf.isUndefined)(data) ? false : revalidateIfStale;
        // If there is no stale data, we need to revalidate when mount;
        // If `revalidateIfStale` is set to true, we will always revalidate.
        return (0, $4Korf.isUndefined)(data) || revalidateIfStale;
    })();
    // Resolve the default validating state:
    // If it's able to validate, and it should revalidate when mount, this will be true.
    const defaultValidatingState = !!(key && fetcher && isInitialMount && shouldDoInitialRevalidation);
    const isValidating = (0, $4Korf.isUndefined)(cached.isValidating) ? defaultValidatingState : cached.isValidating;
    const isLoading = (0, $4Korf.isUndefined)(cached.isLoading) ? defaultValidatingState : cached.isLoading;
    // The revalidation function is a carefully crafted wrapper of the original
    // `fetcher`, to correctly handle the many edge cases.
    const revalidate = (0, $eCoWV.useCallback)(async (revalidateOpts)=>{
        const currentFetcher = fetcherRef.current;
        if (!key || !currentFetcher || unmountedRef.current || getConfig().isPaused()) return false;
        let newData;
        let startAt;
        let loading = true;
        const opts = revalidateOpts || {};
        // If there is no ongoing concurrent request, or `dedupe` is not set, a
        // new request should be initiated.
        const shouldStartNewRequest = !FETCH[key] || !opts.dedupe;
        /*
         For React 17
         Do unmount check for calls:
         If key has changed during the revalidation, or the component has been
         unmounted, old dispatch and old event callbacks should not take any
         effect

        For React 18
        only check if key has changed
        https://github.com/reactwg/react-18/discussions/82
      */ const callbackSafeguard = ()=>{
            if (0, $4Korf.IS_REACT_LEGACY) return !unmountedRef.current && key === keyRef.current && initialMountedRef.current;
            return key === keyRef.current;
        };
        // The final state object when the request finishes.
        const finalState = {
            isValidating: false,
            isLoading: false
        };
        const finishRequestAndUpdateState = ()=>{
            setCache(finalState);
        };
        const cleanupState = ()=>{
            // Check if it's still the same request before deleting it.
            const requestInfo = FETCH[key];
            if (requestInfo && requestInfo[1] === startAt) delete FETCH[key];
        };
        // Start fetching. Change the `isValidating` state, update the cache.
        const initialState = {
            isValidating: true
        };
        // It is in the `isLoading` state, if and only if there is no cached data.
        // This bypasses fallback data and laggy data.
        if ((0, $4Korf.isUndefined)(getCache().data)) initialState.isLoading = true;
        try {
            if (shouldStartNewRequest) {
                setCache(initialState);
                // If no cache is being rendered currently (it shows a blank page),
                // we trigger the loading slow event.
                if (config.loadingTimeout && (0, $4Korf.isUndefined)(getCache().data)) setTimeout(()=>{
                    if (loading && callbackSafeguard()) getConfig().onLoadingSlow(key, config);
                }, config.loadingTimeout);
                // Start the request and save the timestamp.
                // Key must be truthy if entering here.
                FETCH[key] = [
                    currentFetcher(fnArg),
                    (0, $4Korf.getTimestamp)()
                ];
            }
            [newData, startAt] = FETCH[key];
            newData = await newData;
            if (shouldStartNewRequest) // If the request isn't interrupted, clean it up after the
            // deduplication interval.
            setTimeout(cleanupState, config.dedupingInterval);
            // If there're other ongoing request(s), started after the current one,
            // we need to ignore the current one to avoid possible race conditions:
            //   req1------------------>res1        (current one)
            //        req2---------------->res2
            // the request that fired later will always be kept.
            // The timestamp maybe be `undefined` or a number
            if (!FETCH[key] || FETCH[key][1] !== startAt) {
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Clear error.
            finalState.error = (0, $4Korf.UNDEFINED);
            // If there're other mutations(s), that overlapped with the current revalidation:
            // case 1:
            //   req------------------>res
            //       mutate------>end
            // case 2:
            //         req------------>res
            //   mutate------>end
            // case 3:
            //   req------------------>res
            //       mutate-------...---------->
            // we have to ignore the revalidation result (res) because it's no longer fresh.
            // meanwhile, a new revalidation should be triggered when the mutation ends.
            const mutationInfo = MUTATION[key];
            if (!(0, $4Korf.isUndefined)(mutationInfo) && // case 1
            (startAt <= mutationInfo[0] || // case 2
            startAt <= mutationInfo[1] || // case 3
            mutationInfo[1] === 0)) {
                finishRequestAndUpdateState();
                if (shouldStartNewRequest) {
                    if (callbackSafeguard()) getConfig().onDiscarded(key);
                }
                return false;
            }
            // Deep compare with the latest state to avoid extra re-renders.
            // For local state, compare and assign.
            const cacheData = getCache().data;
            // Since the compare fn could be custom fn
            // cacheData might be different from newData even when compare fn returns True
            finalState.data = compare(cacheData, newData) ? cacheData : newData;
            // Trigger the successful callback if it's the original request.
            if (shouldStartNewRequest) {
                if (callbackSafeguard()) getConfig().onSuccess(newData, key, config);
            }
        } catch (err) {
            cleanupState();
            const currentConfig = getConfig();
            const { shouldRetryOnError: shouldRetryOnError } = currentConfig;
            // Not paused, we continue handling the error. Otherwise, discard it.
            if (!currentConfig.isPaused()) {
                // Get a new error, don't use deep comparison for errors.
                finalState.error = err;
                // Error event and retry logic. Only for the actual request, not
                // deduped ones.
                if (shouldStartNewRequest && callbackSafeguard()) {
                    currentConfig.onError(err, key, currentConfig);
                    if (shouldRetryOnError === true || (0, $4Korf.isFunction)(shouldRetryOnError) && shouldRetryOnError(err)) {
                        if (isActive()) // If it's inactive, stop. It will auto-revalidate when
                        // refocusing or reconnecting.
                        // When retrying, deduplication is always enabled.
                        currentConfig.onErrorRetry(err, key, currentConfig, (_opts)=>{
                            const revalidators = EVENT_REVALIDATORS[key];
                            if (revalidators && revalidators[0]) revalidators[0]((0, $4Korf.revalidateEvents).ERROR_REVALIDATE_EVENT, _opts);
                        }, {
                            retryCount: (opts.retryCount || 0) + 1,
                            dedupe: true
                        });
                    }
                }
            }
        }
        // Mark loading as stopped.
        loading = false;
        // Update the current hook's state.
        finishRequestAndUpdateState();
        return true;
    }, // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key,
        cache
    ]);
    // Similar to the global mutate but bound to the current cache and key.
    // `cache` isn't allowed to change during the lifecycle.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const boundMutate = (0, $eCoWV.useCallback)((...args)=>{
        return (0, $4Korf.internalMutate)(cache, keyRef.current, ...args);
    }, []);
    // The logic for updating refs.
    (0, $4Korf.useIsomorphicLayoutEffect)(()=>{
        fetcherRef.current = fetcher;
        configRef.current = config;
        // Handle laggy data updates. If there's cached data of the current key,
        // it'll be the correct reference.
        if (!(0, $4Korf.isUndefined)(cachedData)) laggyDataRef.current = cachedData;
    });
    // After mounted or key changed.
    (0, $4Korf.useIsomorphicLayoutEffect)(()=>{
        if (!key) return;
        const softRevalidate = revalidate.bind((0, $4Korf.UNDEFINED), $4793b45759a85fc7$var$WITH_DEDUPE);
        // Expose revalidators to global event listeners. So we can trigger
        // revalidation from the outside.
        let nextFocusRevalidatedAt = 0;
        const onRevalidate = (type, opts = {})=>{
            if (type == (0, $4Korf.revalidateEvents).FOCUS_EVENT) {
                const now = Date.now();
                if (getConfig().revalidateOnFocus && now > nextFocusRevalidatedAt && isActive()) {
                    nextFocusRevalidatedAt = now + getConfig().focusThrottleInterval;
                    softRevalidate();
                }
            } else if (type == (0, $4Korf.revalidateEvents).RECONNECT_EVENT) {
                if (getConfig().revalidateOnReconnect && isActive()) softRevalidate();
            } else if (type == (0, $4Korf.revalidateEvents).MUTATE_EVENT) return revalidate();
            else if (type == (0, $4Korf.revalidateEvents).ERROR_REVALIDATE_EVENT) return revalidate(opts);
            return;
        };
        const unsubEvents = (0, $4Korf.subscribeCallback)(key, EVENT_REVALIDATORS, onRevalidate);
        // Mark the component as mounted and update corresponding refs.
        unmountedRef.current = false;
        keyRef.current = key;
        initialMountedRef.current = true;
        // Keep the original key in the cache.
        setCache({
            _k: fnArg
        });
        // Trigger a revalidation
        if (shouldDoInitialRevalidation) {
            if ((0, $4Korf.isUndefined)(data) || (0, $4Korf.IS_SERVER)) // Revalidate immediately.
            softRevalidate();
            else // Delay the revalidate if we have data to return so we won't block
            // rendering.
            (0, $4Korf.rAF)(softRevalidate);
        }
        return ()=>{
            // Mark it as unmounted.
            unmountedRef.current = true;
            unsubEvents();
        };
    }, [
        key
    ]);
    // Polling
    (0, $4Korf.useIsomorphicLayoutEffect)(()=>{
        let timer;
        function next() {
            // Use the passed interval
            // ...or invoke the function with the updated data to get the interval
            const interval = (0, $4Korf.isFunction)(refreshInterval) ? refreshInterval(getCache().data) : refreshInterval;
            // We only start the next interval if `refreshInterval` is not 0, and:
            // - `force` is true, which is the start of polling
            // - or `timer` is not 0, which means the effect wasn't canceled
            if (interval && timer !== -1) timer = setTimeout(execute, interval);
        }
        function execute() {
            // Check if it's OK to execute:
            // Only revalidate when the page is visible, online, and not errored.
            if (!getCache().error && (refreshWhenHidden || getConfig().isVisible()) && (refreshWhenOffline || getConfig().isOnline())) revalidate($4793b45759a85fc7$var$WITH_DEDUPE).then(next);
            else // Schedule the next interval to check again.
            next();
        }
        next();
        return ()=>{
            if (timer) {
                clearTimeout(timer);
                timer = -1;
            }
        };
    }, [
        refreshInterval,
        refreshWhenHidden,
        refreshWhenOffline,
        key
    ]);
    // Display debug info in React DevTools.
    (0, $eCoWV.useDebugValue)(returnedData);
    // In Suspense mode, we can't return the empty `data` state.
    // If there is an `error`, the `error` needs to be thrown to the error boundary.
    // If there is no `error`, the `revalidation` promise needs to be thrown to
    // the suspense boundary.
    if (suspense && (0, $4Korf.isUndefined)(data) && key) {
        // SWR should throw when trying to use Suspense on the server with React 18,
        // without providing any initial data. See:
        // https://github.com/vercel/swr/issues/1832
        if (!(0, $4Korf.IS_REACT_LEGACY) && (0, $4Korf.IS_SERVER)) throw new Error("Fallback data is required when using suspense in SSR.");
        // Always update fetcher and config refs even with the Suspense mode.
        fetcherRef.current = fetcher;
        configRef.current = config;
        unmountedRef.current = false;
        const req = PRELOAD[key];
        if (!(0, $4Korf.isUndefined)(req)) {
            const promise = boundMutate(req);
            $4793b45759a85fc7$var$use(promise);
        }
        if ((0, $4Korf.isUndefined)(error)) {
            const promise = revalidate($4793b45759a85fc7$var$WITH_DEDUPE);
            if (!(0, $4Korf.isUndefined)(returnedData)) {
                promise.status = "fulfilled";
                promise.value = true;
            }
            $4793b45759a85fc7$var$use(promise);
        } else throw error;
    }
    return {
        mutate: boundMutate,
        get data () {
            stateDependencies.data = true;
            return returnedData;
        },
        get error () {
            stateDependencies.error = true;
            return error;
        },
        get isValidating () {
            stateDependencies.isValidating = true;
            return isValidating;
        },
        get isLoading () {
            stateDependencies.isLoading = true;
            return isLoading;
        }
    };
};
const $4793b45759a85fc7$export$4c7bbecdacc3ca2c = (0, $4Korf.OBJECT).defineProperty((0, $4Korf.SWRConfig), "defaultValue", {
    value: (0, $4Korf.defaultConfig)
});
/**
 * A hook to fetch data.
 *
 * @link https://swr.vercel.app
 * @example
 * ```jsx
 * import useSWR from 'swr'
 * function Profile() {
 *   const { data, error } = useSWR('/api/user', fetcher)
 *   if (error) return <div>failed to load</div>
 *   if (!data) return <div>loading...</div>
 *   return <div>hello {data.name}!</div>
 * }
 * ```
 */ const $4793b45759a85fc7$export$2e2bcd8739ae039 = (0, $4Korf.withArgs)($4793b45759a85fc7$var$useSWRHandler);

});
parcelRequire.register("7ugWC", function(module, exports) {
"use strict";

module.exports = (parcelRequire("8k00C"));

});
parcelRequire.register("8k00C", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $60f032bf2471cca3$export$306c0aa65ff9ec16; }, function (v) { return $60f032bf2471cca3$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $60f032bf2471cca3$export$306c0aa65ff9ec16;
"use strict";

var $eCoWV = parcelRequire("eCoWV");
function $60f032bf2471cca3$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $60f032bf2471cca3$var$k = "function" === typeof Object.is ? Object.is : $60f032bf2471cca3$var$h, $60f032bf2471cca3$var$l = $eCoWV.useState, $60f032bf2471cca3$var$m = $eCoWV.useEffect, $60f032bf2471cca3$var$n = $eCoWV.useLayoutEffect, $60f032bf2471cca3$var$p = $eCoWV.useDebugValue;
function $60f032bf2471cca3$var$q(a, b) {
    var d = b(), f = $60f032bf2471cca3$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $60f032bf2471cca3$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $60f032bf2471cca3$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $60f032bf2471cca3$var$m(function() {
        $60f032bf2471cca3$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $60f032bf2471cca3$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $60f032bf2471cca3$var$p(d);
    return d;
}
function $60f032bf2471cca3$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$60f032bf2471cca3$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $60f032bf2471cca3$var$t(a, b) {
    return b();
}
var $60f032bf2471cca3$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $60f032bf2471cca3$var$t : $60f032bf2471cca3$var$q;
$60f032bf2471cca3$export$306c0aa65ff9ec16 = void 0 !== $eCoWV.useSyncExternalStore ? $eCoWV.useSyncExternalStore : $60f032bf2471cca3$var$u;

});


parcelRequire.register("4Korf", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", function () { return $ed53cdd88593f6a0$export$6db089fe7b26f5b6; });
$parcel$export(module.exports, "OBJECT", function () { return $ed53cdd88593f6a0$export$8b8a958a7f6f130c; });
$parcel$export(module.exports, "isUndefined", function () { return $ed53cdd88593f6a0$export$fce6876652108ab; });
$parcel$export(module.exports, "isFunction", function () { return $ed53cdd88593f6a0$export$f6e2535fb5126e54; });
$parcel$export(module.exports, "mergeObjects", function () { return $ed53cdd88593f6a0$export$2321aea138b44780; });
$parcel$export(module.exports, "SWRGlobalState", function () { return $ed53cdd88593f6a0$export$b94ca9901c60634; });
$parcel$export(module.exports, "createCacheHelper", function () { return $ed53cdd88593f6a0$export$1251d51d9c571b45; });
$parcel$export(module.exports, "IS_REACT_LEGACY", function () { return $ed53cdd88593f6a0$export$ddb64fe6466374f7; });
$parcel$export(module.exports, "IS_SERVER", function () { return $ed53cdd88593f6a0$export$d2f4d8e74279c212; });
$parcel$export(module.exports, "rAF", function () { return $ed53cdd88593f6a0$export$eba6076d3d7d0c06; });
$parcel$export(module.exports, "useIsomorphicLayoutEffect", function () { return $ed53cdd88593f6a0$export$700979bc83e7db82; });
$parcel$export(module.exports, "serialize", function () { return $ed53cdd88593f6a0$export$dfdc1655ccc5b9cb; });
$parcel$export(module.exports, "getTimestamp", function () { return $ed53cdd88593f6a0$export$3c95c4c8b671ef0; });
$parcel$export(module.exports, "revalidateEvents", function () { return $ed53cdd88593f6a0$export$10213d6aa5ce32e6; });
$parcel$export(module.exports, "internalMutate", function () { return $ed53cdd88593f6a0$export$c9d44e5bea4509be; });
$parcel$export(module.exports, "defaultConfig", function () { return $ed53cdd88593f6a0$export$f84bd70098573c5c; });
$parcel$export(module.exports, "SWRConfig", function () { return $ed53cdd88593f6a0$export$4c7bbecdacc3ca2c; });
$parcel$export(module.exports, "useSWRConfig", function () { return $ed53cdd88593f6a0$export$f1dc0e282d4c1c0; });
$parcel$export(module.exports, "withArgs", function () { return $ed53cdd88593f6a0$export$84d44e54e14b0133; });
$parcel$export(module.exports, "subscribeCallback", function () { return $ed53cdd88593f6a0$export$e005210ed621746; });
$parcel$export(module.exports, "withMiddleware", function () { return $ed53cdd88593f6a0$export$525ea7fc6ba00096; });

var $eCoWV = parcelRequire("eCoWV");
// Shared state between server components and client components
const $ed53cdd88593f6a0$export$8793edee2d425525 = ()=>{};
// Using noop() as the undefined value as undefined can be replaced
// by something else. Prettier ignore and extra parentheses are necessary here
// to ensure that tsc doesn't remove the __NOINLINE__ comment.
// prettier-ignore
const $ed53cdd88593f6a0$export$6db089fe7b26f5b6 = /*#__NOINLINE__*/ $ed53cdd88593f6a0$export$8793edee2d425525();
const $ed53cdd88593f6a0$export$8b8a958a7f6f130c = Object;
const $ed53cdd88593f6a0$export$fce6876652108ab = (v)=>v === $ed53cdd88593f6a0$export$6db089fe7b26f5b6;
const $ed53cdd88593f6a0$export$f6e2535fb5126e54 = (v)=>typeof v == "function";
const $ed53cdd88593f6a0$export$2321aea138b44780 = (a, b)=>({
        ...a,
        ...b
    });
const $ed53cdd88593f6a0$export$ae936b9d47e5870e = (x)=>$ed53cdd88593f6a0$export$f6e2535fb5126e54(x.then);
// use WeakMap to store the object->key mapping
// so the objects can be garbage collected.
// WeakMap uses a hashtable under the hood, so the lookup
// complexity is almost O(1).
const $ed53cdd88593f6a0$var$table = new WeakMap();
// counter of the key
let $ed53cdd88593f6a0$var$counter = 0;
// A stable hash implementation that supports:
// - Fast and ensures unique hash properties
// - Handles unserializable values
// - Handles object key ordering
// - Generates short results
//
// This is not a serialization function, and the result is not guaranteed to be
// parsable.
const $ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4 = (arg)=>{
    const type = typeof arg;
    const constructor = arg && arg.constructor;
    const isDate = constructor == Date;
    let result;
    let index;
    if ($ed53cdd88593f6a0$export$8b8a958a7f6f130c(arg) === arg && !isDate && constructor != RegExp) {
        // Object/function, not null/date/regexp. Use WeakMap to store the id first.
        // If it's already hashed, directly return the result.
        result = $ed53cdd88593f6a0$var$table.get(arg);
        if (result) return result;
        // Store the hash first for circular reference detection before entering the
        // recursive `stableHash` calls.
        // For other objects like set and map, we use this id directly as the hash.
        result = ++$ed53cdd88593f6a0$var$counter + "~";
        $ed53cdd88593f6a0$var$table.set(arg, result);
        if (constructor == Array) {
            // Array.
            result = "@";
            for(index = 0; index < arg.length; index++)result += $ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $ed53cdd88593f6a0$var$table.set(arg, result);
        }
        if (constructor == $ed53cdd88593f6a0$export$8b8a958a7f6f130c) {
            // Object, sort keys.
            result = "#";
            const keys = $ed53cdd88593f6a0$export$8b8a958a7f6f130c.keys(arg).sort();
            while(!$ed53cdd88593f6a0$export$fce6876652108ab(index = keys.pop()))if (!$ed53cdd88593f6a0$export$fce6876652108ab(arg[index])) result += index + ":" + $ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4(arg[index]) + ",";
            $ed53cdd88593f6a0$var$table.set(arg, result);
        }
    } else result = isDate ? arg.toJSON() : type == "symbol" ? arg.toString() : type == "string" ? JSON.stringify(arg) : "" + arg;
    return result;
};
// Global state used to deduplicate requests and store listeners
const $ed53cdd88593f6a0$export$b94ca9901c60634 = new WeakMap();
const $ed53cdd88593f6a0$var$EMPTY_CACHE = {};
const $ed53cdd88593f6a0$var$INITIAL_CACHE = {};
const $ed53cdd88593f6a0$var$STR_UNDEFINED = "undefined";
// NOTE: Use the function to guarantee it's re-evaluated between jsdom and node runtime for tests.
const $ed53cdd88593f6a0$export$6e85fd745dc51282 = typeof window != $ed53cdd88593f6a0$var$STR_UNDEFINED;
const $ed53cdd88593f6a0$export$842dfe7a9f24298 = typeof document != $ed53cdd88593f6a0$var$STR_UNDEFINED;
const $ed53cdd88593f6a0$export$a9116928c9d15917 = ()=>$ed53cdd88593f6a0$export$6e85fd745dc51282 && typeof window["requestAnimationFrame"] != $ed53cdd88593f6a0$var$STR_UNDEFINED;
const $ed53cdd88593f6a0$export$1251d51d9c571b45 = (cache, key)=>{
    const state = $ed53cdd88593f6a0$export$b94ca9901c60634.get(cache);
    return [
        // Getter
        ()=>!$ed53cdd88593f6a0$export$fce6876652108ab(key) && cache.get(key) || $ed53cdd88593f6a0$var$EMPTY_CACHE,
        // Setter
        (info)=>{
            if (!$ed53cdd88593f6a0$export$fce6876652108ab(key)) {
                const prev = cache.get(key);
                // Before writing to the store, we keep the value in the initial cache
                // if it's not there yet.
                if (!(key in $ed53cdd88593f6a0$var$INITIAL_CACHE)) $ed53cdd88593f6a0$var$INITIAL_CACHE[key] = prev;
                state[5](key, $ed53cdd88593f6a0$export$2321aea138b44780(prev, info), prev || $ed53cdd88593f6a0$var$EMPTY_CACHE);
            }
        },
        // Subscriber
        state[6],
        // Get server cache snapshot
        ()=>{
            if (!$ed53cdd88593f6a0$export$fce6876652108ab(key)) {
                // If the cache was updated on the client, we return the stored initial value.
                if (key in $ed53cdd88593f6a0$var$INITIAL_CACHE) return $ed53cdd88593f6a0$var$INITIAL_CACHE[key];
            }
            // If we haven't done any client-side updates, we return the current value.
            return !$ed53cdd88593f6a0$export$fce6876652108ab(key) && cache.get(key) || $ed53cdd88593f6a0$var$EMPTY_CACHE;
        }
    ];
} // export { UNDEFINED, OBJECT, isUndefined, isFunction, mergeObjects, isPromiseLike }
;
/**
 * Due to the bug https://bugs.chromium.org/p/chromium/issues/detail?id=678075,
 * it's not reliable to detect if the browser is currently online or offline
 * based on `navigator.onLine`.
 * As a workaround, we always assume it's online on the first load, and change
 * the status upon `online` or `offline` events.
 */ let $ed53cdd88593f6a0$var$online = true;
const $ed53cdd88593f6a0$var$isOnline = ()=>$ed53cdd88593f6a0$var$online;
// For node and React Native, `add/removeEventListener` doesn't exist on window.
const [$ed53cdd88593f6a0$var$onWindowEvent, $ed53cdd88593f6a0$var$offWindowEvent] = $ed53cdd88593f6a0$export$6e85fd745dc51282 && window.addEventListener ? [
    window.addEventListener.bind(window),
    window.removeEventListener.bind(window)
] : [
    $ed53cdd88593f6a0$export$8793edee2d425525,
    $ed53cdd88593f6a0$export$8793edee2d425525
];
const $ed53cdd88593f6a0$var$isVisible = ()=>{
    const visibilityState = $ed53cdd88593f6a0$export$842dfe7a9f24298 && document.visibilityState;
    return $ed53cdd88593f6a0$export$fce6876652108ab(visibilityState) || visibilityState !== "hidden";
};
const $ed53cdd88593f6a0$var$initFocus = (callback)=>{
    // focus revalidate
    if ($ed53cdd88593f6a0$export$842dfe7a9f24298) document.addEventListener("visibilitychange", callback);
    $ed53cdd88593f6a0$var$onWindowEvent("focus", callback);
    return ()=>{
        if ($ed53cdd88593f6a0$export$842dfe7a9f24298) document.removeEventListener("visibilitychange", callback);
        $ed53cdd88593f6a0$var$offWindowEvent("focus", callback);
    };
};
const $ed53cdd88593f6a0$var$initReconnect = (callback)=>{
    // revalidate on reconnected
    const onOnline = ()=>{
        $ed53cdd88593f6a0$var$online = true;
        callback();
    };
    // nothing to revalidate, just update the status
    const onOffline = ()=>{
        $ed53cdd88593f6a0$var$online = false;
    };
    $ed53cdd88593f6a0$var$onWindowEvent("online", onOnline);
    $ed53cdd88593f6a0$var$onWindowEvent("offline", onOffline);
    return ()=>{
        $ed53cdd88593f6a0$var$offWindowEvent("online", onOnline);
        $ed53cdd88593f6a0$var$offWindowEvent("offline", onOffline);
    };
};
const $ed53cdd88593f6a0$export$f5ab8217e0edff04 = {
    isOnline: $ed53cdd88593f6a0$var$isOnline,
    isVisible: $ed53cdd88593f6a0$var$isVisible
};
const $ed53cdd88593f6a0$export$b1857f3440a65373 = {
    initFocus: $ed53cdd88593f6a0$var$initFocus,
    initReconnect: $ed53cdd88593f6a0$var$initReconnect
};
const $ed53cdd88593f6a0$export$ddb64fe6466374f7 = !(0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useId;
const $ed53cdd88593f6a0$export$d2f4d8e74279c212 = !$ed53cdd88593f6a0$export$6e85fd745dc51282 || "Deno" in window;
// Polyfill requestAnimationFrame
const $ed53cdd88593f6a0$export$eba6076d3d7d0c06 = (f)=>$ed53cdd88593f6a0$export$a9116928c9d15917() ? window["requestAnimationFrame"](f) : setTimeout(f, 1);
// React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
const $ed53cdd88593f6a0$export$700979bc83e7db82 = $ed53cdd88593f6a0$export$d2f4d8e74279c212 ? (0, $eCoWV.useEffect) : (0, $eCoWV.useLayoutEffect);
// This assignment is to extend the Navigator type to use effectiveType.
const $ed53cdd88593f6a0$var$navigatorConnection = typeof navigator !== "undefined" && navigator.connection;
// Adjust the config based on slow connection status (<= 70Kbps).
const $ed53cdd88593f6a0$export$3723beb60427dc52 = !$ed53cdd88593f6a0$export$d2f4d8e74279c212 && $ed53cdd88593f6a0$var$navigatorConnection && ([
    "slow-2g",
    "2g"
].includes($ed53cdd88593f6a0$var$navigatorConnection.effectiveType) || $ed53cdd88593f6a0$var$navigatorConnection.saveData);
const $ed53cdd88593f6a0$export$dfdc1655ccc5b9cb = (key)=>{
    if ($ed53cdd88593f6a0$export$f6e2535fb5126e54(key)) try {
        key = key();
    } catch (err) {
        // dependencies not ready
        key = "";
    }
    // Use the original key as the argument of fetcher. This can be a string or an
    // array of values.
    const args = key;
    // If key is not falsy, or not an empty array, hash it.
    key = typeof key == "string" ? key : (Array.isArray(key) ? key.length : key) ? $ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4(key) : "";
    return [
        key,
        args
    ];
};
// Global timestamp.
let $ed53cdd88593f6a0$var$__timestamp = 0;
const $ed53cdd88593f6a0$export$3c95c4c8b671ef0 = ()=>++$ed53cdd88593f6a0$var$__timestamp;
const $ed53cdd88593f6a0$var$FOCUS_EVENT = 0;
const $ed53cdd88593f6a0$var$RECONNECT_EVENT = 1;
const $ed53cdd88593f6a0$var$MUTATE_EVENT = 2;
const $ed53cdd88593f6a0$var$ERROR_REVALIDATE_EVENT = 3;
var $ed53cdd88593f6a0$export$10213d6aa5ce32e6 = {
    __proto__: null,
    ERROR_REVALIDATE_EVENT: $ed53cdd88593f6a0$var$ERROR_REVALIDATE_EVENT,
    FOCUS_EVENT: $ed53cdd88593f6a0$var$FOCUS_EVENT,
    MUTATE_EVENT: $ed53cdd88593f6a0$var$MUTATE_EVENT,
    RECONNECT_EVENT: $ed53cdd88593f6a0$var$RECONNECT_EVENT
};
async function $ed53cdd88593f6a0$export$c9d44e5bea4509be(...args) {
    const [cache, _key, _data, _opts] = args;
    // When passing as a boolean, it's explicitly used to disable/enable
    // revalidation.
    const options = $ed53cdd88593f6a0$export$2321aea138b44780({
        populateCache: true,
        throwOnError: true
    }, typeof _opts === "boolean" ? {
        revalidate: _opts
    } : _opts || {});
    let populateCache = options.populateCache;
    const rollbackOnErrorOption = options.rollbackOnError;
    let optimisticData = options.optimisticData;
    const revalidate = options.revalidate !== false;
    const rollbackOnError = (error)=>{
        return typeof rollbackOnErrorOption === "function" ? rollbackOnErrorOption(error) : rollbackOnErrorOption !== false;
    };
    const throwOnError = options.throwOnError;
    // If the second argument is a key filter, return the mutation results for all
    // filtered keys.
    if ($ed53cdd88593f6a0$export$f6e2535fb5126e54(_key)) {
        const keyFilter = _key;
        const matchedKeys = [];
        const it = cache.keys();
        for (const key of it)if (!/^\$(inf|sub)\$/.test(key) && keyFilter(cache.get(key)._k)) matchedKeys.push(key);
        return Promise.all(matchedKeys.map(mutateByKey));
    }
    return mutateByKey(_key);
    async function mutateByKey(_k) {
        // Serialize key
        const [key] = $ed53cdd88593f6a0$export$dfdc1655ccc5b9cb(_k);
        if (!key) return;
        const [get, set] = $ed53cdd88593f6a0$export$1251d51d9c571b45(cache, key);
        const [EVENT_REVALIDATORS, MUTATION, FETCH, PRELOAD] = $ed53cdd88593f6a0$export$b94ca9901c60634.get(cache);
        const revalidators = EVENT_REVALIDATORS[key];
        const startRevalidate = ()=>{
            if (revalidate) {
                // Invalidate the key by deleting the concurrent request markers so new
                // requests will not be deduped.
                delete FETCH[key];
                delete PRELOAD[key];
                if (revalidators && revalidators[0]) return revalidators[0]($ed53cdd88593f6a0$var$MUTATE_EVENT).then(()=>get().data);
            }
            return get().data;
        };
        // If there is no new data provided, revalidate the key with current state.
        if (args.length < 3) // Revalidate and broadcast state.
        return startRevalidate();
        let data = _data;
        let error;
        // Update global timestamps.
        const beforeMutationTs = $ed53cdd88593f6a0$export$3c95c4c8b671ef0();
        MUTATION[key] = [
            beforeMutationTs,
            0
        ];
        const hasOptimisticData = !$ed53cdd88593f6a0$export$fce6876652108ab(optimisticData);
        const state = get();
        // `displayedData` is the current value on screen. It could be the optimistic value
        // that is going to be overridden by a `committedData`, or get reverted back.
        // `committedData` is the validated value that comes from a fetch or mutation.
        const displayedData = state.data;
        const currentData = state._c;
        const committedData = $ed53cdd88593f6a0$export$fce6876652108ab(currentData) ? displayedData : currentData;
        // Do optimistic data update.
        if (hasOptimisticData) {
            optimisticData = $ed53cdd88593f6a0$export$f6e2535fb5126e54(optimisticData) ? optimisticData(committedData, displayedData) : optimisticData;
            // When we set optimistic data, backup the current committedData data in `_c`.
            set({
                data: optimisticData,
                _c: committedData
            });
        }
        if ($ed53cdd88593f6a0$export$f6e2535fb5126e54(data)) // `data` is a function, call it passing current cache value.
        try {
            data = data(committedData);
        } catch (err) {
            // If it throws an error synchronously, we shouldn't update the cache.
            error = err;
        }
        // `data` is a promise/thenable, resolve the final data first.
        if (data && $ed53cdd88593f6a0$export$ae936b9d47e5870e(data)) {
            // This means that the mutation is async, we need to check timestamps to
            // avoid race conditions.
            data = await data.catch((err)=>{
                error = err;
            });
            // Check if other mutations have occurred since we've started this mutation.
            // If there's a race we don't update cache or broadcast the change,
            // just return the data.
            if (beforeMutationTs !== MUTATION[key][0]) {
                if (error) throw error;
                return data;
            } else if (error && hasOptimisticData && rollbackOnError(error)) {
                // Rollback. Always populate the cache in this case but without
                // transforming the data.
                populateCache = true;
                data = committedData;
                // Reset data to be the latest committed data, and clear the `_c` value.
                set({
                    data: data,
                    _c: $ed53cdd88593f6a0$export$6db089fe7b26f5b6
                });
            }
        }
        // If we should write back the cache after request.
        if (populateCache) {
            if (!error) {
                // Transform the result into data.
                if ($ed53cdd88593f6a0$export$f6e2535fb5126e54(populateCache)) data = populateCache(data, committedData);
                // Only update cached data and reset the error if there's no error. Data can be `undefined` here.
                set({
                    data: data,
                    error: $ed53cdd88593f6a0$export$6db089fe7b26f5b6,
                    _c: $ed53cdd88593f6a0$export$6db089fe7b26f5b6
                });
            }
        }
        // Reset the timestamp to mark the mutation has ended.
        MUTATION[key][1] = $ed53cdd88593f6a0$export$3c95c4c8b671ef0();
        // Update existing SWR Hooks' internal states:
        const res = await startRevalidate();
        // The mutation and revalidation are ended, we can clear it since the data is
        // not an optimistic value anymore.
        set({
            _c: $ed53cdd88593f6a0$export$6db089fe7b26f5b6
        });
        // Throw error or return data
        if (error) {
            if (throwOnError) throw error;
            return;
        }
        return populateCache ? res : data;
    }
}
const $ed53cdd88593f6a0$var$revalidateAllKeys = (revalidators, type)=>{
    for(const key in revalidators)if (revalidators[key][0]) revalidators[key][0](type);
};
const $ed53cdd88593f6a0$export$4008f5b66f9e0b3c = (provider, options)=>{
    // The global state for a specific provider will be used to deduplicate
    // requests and store listeners. As well as a mutate function that is bound to
    // the cache.
    // The provider's global state might be already initialized. Let's try to get the
    // global state associated with the provider first.
    if (!$ed53cdd88593f6a0$export$b94ca9901c60634.has(provider)) {
        const opts = $ed53cdd88593f6a0$export$2321aea138b44780($ed53cdd88593f6a0$export$b1857f3440a65373, options);
        // If there's no global state bound to the provider, create a new one with the
        // new mutate function.
        const EVENT_REVALIDATORS = {};
        const mutate = $ed53cdd88593f6a0$export$c9d44e5bea4509be.bind($ed53cdd88593f6a0$export$6db089fe7b26f5b6, provider);
        let unmount = $ed53cdd88593f6a0$export$8793edee2d425525;
        const subscriptions = {};
        const subscribe = (key, callback)=>{
            const subs = subscriptions[key] || [];
            subscriptions[key] = subs;
            subs.push(callback);
            return ()=>subs.splice(subs.indexOf(callback), 1);
        };
        const setter = (key, value, prev)=>{
            provider.set(key, value);
            const subs = subscriptions[key];
            if (subs) for (const fn of subs)fn(value, prev);
        };
        const initProvider = ()=>{
            if (!$ed53cdd88593f6a0$export$b94ca9901c60634.has(provider)) {
                // Update the state if it's new, or if the provider has been extended.
                $ed53cdd88593f6a0$export$b94ca9901c60634.set(provider, [
                    EVENT_REVALIDATORS,
                    {},
                    {},
                    {},
                    mutate,
                    setter,
                    subscribe
                ]);
                if (!$ed53cdd88593f6a0$export$d2f4d8e74279c212) {
                    // When listening to the native events for auto revalidations,
                    // we intentionally put a delay (setTimeout) here to make sure they are
                    // fired after immediate JavaScript executions, which can be
                    // React's state updates.
                    // This avoids some unnecessary revalidations such as
                    // https://github.com/vercel/swr/issues/1680.
                    const releaseFocus = opts.initFocus(setTimeout.bind($ed53cdd88593f6a0$export$6db089fe7b26f5b6, $ed53cdd88593f6a0$var$revalidateAllKeys.bind($ed53cdd88593f6a0$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $ed53cdd88593f6a0$var$FOCUS_EVENT)));
                    const releaseReconnect = opts.initReconnect(setTimeout.bind($ed53cdd88593f6a0$export$6db089fe7b26f5b6, $ed53cdd88593f6a0$var$revalidateAllKeys.bind($ed53cdd88593f6a0$export$6db089fe7b26f5b6, EVENT_REVALIDATORS, $ed53cdd88593f6a0$var$RECONNECT_EVENT)));
                    unmount = ()=>{
                        releaseFocus && releaseFocus();
                        releaseReconnect && releaseReconnect();
                        // When un-mounting, we need to remove the cache provider from the state
                        // storage too because it's a side-effect. Otherwise, when re-mounting we
                        // will not re-register those event listeners.
                        $ed53cdd88593f6a0$export$b94ca9901c60634.delete(provider);
                    };
                }
            }
        };
        initProvider();
        // This is a new provider, we need to initialize it and setup DOM events
        // listeners for `focus` and `reconnect` actions.
        // We might want to inject an extra layer on top of `provider` in the future,
        // such as key serialization, auto GC, etc.
        // For now, it's just a `Map` interface without any modifications.
        return [
            provider,
            mutate,
            initProvider,
            unmount
        ];
    }
    return [
        provider,
        $ed53cdd88593f6a0$export$b94ca9901c60634.get(provider)[4]
    ];
};
// error retry
const $ed53cdd88593f6a0$var$onErrorRetry = (_, __, config, revalidate, opts)=>{
    const maxRetryCount = config.errorRetryCount;
    const currentRetryCount = opts.retryCount;
    // Exponential backoff
    const timeout = ~~((Math.random() + 0.5) * (1 << (currentRetryCount < 8 ? currentRetryCount : 8))) * config.errorRetryInterval;
    if (!$ed53cdd88593f6a0$export$fce6876652108ab(maxRetryCount) && currentRetryCount > maxRetryCount) return;
    setTimeout(revalidate, timeout, opts);
};
const $ed53cdd88593f6a0$export$398604a469f7de9a = (currentData, newData)=>$ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4(currentData) == $ed53cdd88593f6a0$export$e9a4e06c7dfb0bd4(newData);
// Default cache provider
const [$ed53cdd88593f6a0$export$69a3209f1a06c04d, $ed53cdd88593f6a0$export$57e795267c26e600] = $ed53cdd88593f6a0$export$4008f5b66f9e0b3c(new Map());
// Default config
const $ed53cdd88593f6a0$export$f84bd70098573c5c = $ed53cdd88593f6a0$export$2321aea138b44780({
    // events
    onLoadingSlow: $ed53cdd88593f6a0$export$8793edee2d425525,
    onSuccess: $ed53cdd88593f6a0$export$8793edee2d425525,
    onError: $ed53cdd88593f6a0$export$8793edee2d425525,
    onErrorRetry: $ed53cdd88593f6a0$var$onErrorRetry,
    onDiscarded: $ed53cdd88593f6a0$export$8793edee2d425525,
    // switches
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    revalidateIfStale: true,
    shouldRetryOnError: true,
    // timeouts
    errorRetryInterval: $ed53cdd88593f6a0$export$3723beb60427dc52 ? 10000 : 5000,
    focusThrottleInterval: 5000,
    dedupingInterval: 2000,
    loadingTimeout: $ed53cdd88593f6a0$export$3723beb60427dc52 ? 5000 : 3000,
    compare: // providers
    $ed53cdd88593f6a0$export$398604a469f7de9a,
    isPaused: ()=>false,
    cache: $ed53cdd88593f6a0$export$69a3209f1a06c04d,
    mutate: $ed53cdd88593f6a0$export$57e795267c26e600,
    fallback: {}
}, $ed53cdd88593f6a0$export$f5ab8217e0edff04);
const $ed53cdd88593f6a0$export$5d86b86a654a7039 = (a, b)=>{
    // Need to create a new object to avoid mutating the original here.
    const v = $ed53cdd88593f6a0$export$2321aea138b44780(a, b);
    // If two configs are provided, merge their `use` and `fallback` options.
    if (b) {
        const { use: u1, fallback: f1 } = a;
        const { use: u2, fallback: f2 } = b;
        if (u1 && u2) v.use = u1.concat(u2);
        if (f1 && f2) v.fallback = $ed53cdd88593f6a0$export$2321aea138b44780(f1, f2);
    }
    return v;
};
const $ed53cdd88593f6a0$var$SWRConfigContext = (0, $eCoWV.createContext)({});
const $ed53cdd88593f6a0$export$4c7bbecdacc3ca2c = (props)=>{
    const { value: value } = props;
    const parentConfig = (0, $eCoWV.useContext)($ed53cdd88593f6a0$var$SWRConfigContext);
    const isFunctionalConfig = $ed53cdd88593f6a0$export$f6e2535fb5126e54(value);
    const config = (0, $eCoWV.useMemo)(()=>isFunctionalConfig ? value(parentConfig) : value, [
        isFunctionalConfig,
        parentConfig,
        value
    ]);
    // Extend parent context values and middleware.
    const extendedConfig = (0, $eCoWV.useMemo)(()=>isFunctionalConfig ? config : $ed53cdd88593f6a0$export$5d86b86a654a7039(parentConfig, config), [
        isFunctionalConfig,
        parentConfig,
        config
    ]);
    // Should not use the inherited provider.
    const provider = config && config.provider;
    // initialize the cache only on first access.
    const cacheContextRef = (0, $eCoWV.useRef)($ed53cdd88593f6a0$export$6db089fe7b26f5b6);
    if (provider && !cacheContextRef.current) cacheContextRef.current = $ed53cdd88593f6a0$export$4008f5b66f9e0b3c(provider(extendedConfig.cache || $ed53cdd88593f6a0$export$69a3209f1a06c04d), config);
    const cacheContext = cacheContextRef.current;
    // Override the cache if a new provider is given.
    if (cacheContext) {
        extendedConfig.cache = cacheContext[0];
        extendedConfig.mutate = cacheContext[1];
    }
    // Unsubscribe events.
    $ed53cdd88593f6a0$export$700979bc83e7db82(()=>{
        if (cacheContext) {
            cacheContext[2] && cacheContext[2]();
            return cacheContext[3];
        }
    }, []);
    return (0, $eCoWV.createElement)($ed53cdd88593f6a0$var$SWRConfigContext.Provider, $ed53cdd88593f6a0$export$2321aea138b44780(props, {
        value: extendedConfig
    }));
};
// @ts-expect-error
const $ed53cdd88593f6a0$var$enableDevtools = $ed53cdd88593f6a0$export$6e85fd745dc51282 && window.__SWR_DEVTOOLS_USE__;
const $ed53cdd88593f6a0$var$use = $ed53cdd88593f6a0$var$enableDevtools ? window.__SWR_DEVTOOLS_USE__ : [];
const $ed53cdd88593f6a0$var$setupDevTools = ()=>{
    if ($ed53cdd88593f6a0$var$enableDevtools) // @ts-expect-error
    window.__SWR_DEVTOOLS_REACT__ = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV)));
};
const $ed53cdd88593f6a0$export$a3295358bff77e = (args)=>{
    return $ed53cdd88593f6a0$export$f6e2535fb5126e54(args[1]) ? [
        args[0],
        args[1],
        args[2] || {}
    ] : [
        args[0],
        null,
        (args[1] === null ? args[2] : args[1]) || {}
    ];
};
const $ed53cdd88593f6a0$export$f1dc0e282d4c1c0 = ()=>{
    return $ed53cdd88593f6a0$export$2321aea138b44780($ed53cdd88593f6a0$export$f84bd70098573c5c, (0, $eCoWV.useContext)($ed53cdd88593f6a0$var$SWRConfigContext));
};
const $ed53cdd88593f6a0$export$513ccb98c53b8039 = (key_, fetcher)=>{
    const [key, fnArg] = $ed53cdd88593f6a0$export$dfdc1655ccc5b9cb(key_);
    const [, , , PRELOAD] = $ed53cdd88593f6a0$export$b94ca9901c60634.get($ed53cdd88593f6a0$export$69a3209f1a06c04d);
    // Prevent preload to be called multiple times before used.
    if (PRELOAD[key]) return PRELOAD[key];
    const req = fetcher(fnArg);
    PRELOAD[key] = req;
    return req;
};
const $ed53cdd88593f6a0$var$middleware = (useSWRNext)=>(key_, fetcher_, config)=>{
        // fetcher might be a sync function, so this should not be an async function
        const fetcher = fetcher_ && ((...args)=>{
            const [key] = $ed53cdd88593f6a0$export$dfdc1655ccc5b9cb(key_);
            const [, , , PRELOAD] = $ed53cdd88593f6a0$export$b94ca9901c60634.get($ed53cdd88593f6a0$export$69a3209f1a06c04d);
            const req = PRELOAD[key];
            if ($ed53cdd88593f6a0$export$fce6876652108ab(req)) return fetcher_(...args);
            delete PRELOAD[key];
            return req;
        });
        return useSWRNext(key_, fetcher, config);
    };
const $ed53cdd88593f6a0$var$BUILT_IN_MIDDLEWARE = $ed53cdd88593f6a0$var$use.concat($ed53cdd88593f6a0$var$middleware);
// It's tricky to pass generic types as parameters, so we just directly override
// the types here.
const $ed53cdd88593f6a0$export$84d44e54e14b0133 = (hook)=>{
    return function useSWRArgs(...args) {
        // Get the default and inherited configuration.
        const fallbackConfig = $ed53cdd88593f6a0$export$f1dc0e282d4c1c0();
        // Normalize arguments.
        const [key, fn, _config] = $ed53cdd88593f6a0$export$a3295358bff77e(args);
        // Merge configurations.
        const config = $ed53cdd88593f6a0$export$5d86b86a654a7039(fallbackConfig, _config);
        // Apply middleware
        let next = hook;
        const { use: use } = config;
        const middleware = (use || []).concat($ed53cdd88593f6a0$var$BUILT_IN_MIDDLEWARE);
        for(let i = middleware.length; i--;)next = middleware[i](next);
        return next(key, fn || config.fetcher || null, config);
    };
};
/**
 * An implementation of state with dependency-tracking.
 */ const $ed53cdd88593f6a0$export$e1784150b9e765ac = (state)=>{
    const rerender = (0, $eCoWV.useState)({})[1];
    const unmountedRef = (0, $eCoWV.useRef)(false);
    const stateRef = (0, $eCoWV.useRef)(state);
    // If a state property (data, error, or isValidating) is accessed by the render
    // function, we mark the property as a dependency so if it is updated again
    // in the future, we trigger a rerender.
    // This is also known as dependency-tracking.
    const stateDependenciesRef = (0, $eCoWV.useRef)({
        data: false,
        error: false,
        isValidating: false
    });
    /**
   * @param payload To change stateRef, pass the values explicitly to setState:
   * @example
   * ```js
   * setState({
   *   isValidating: false
   *   data: newData // set data to newData
   *   error: undefined // set error to undefined
   * })
   *
   * setState({
   *   isValidating: false
   *   data: undefined // set data to undefined
   *   error: err // set error to err
   * })
   * ```
   */ const setState = (0, $eCoWV.useCallback)((payload)=>{
        let shouldRerender = false;
        const currentState = stateRef.current;
        for(const _ in payload){
            const k = _;
            // If the property has changed, update the state and mark rerender as
            // needed.
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed by the component, a rerender should be
                // triggered.
                if (stateDependenciesRef.current[k]) shouldRerender = true;
            }
        }
        if (shouldRerender && !unmountedRef.current) {
            if ($ed53cdd88593f6a0$export$ddb64fe6466374f7) rerender({});
            else (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).startTransition(()=>rerender({}));
        }
    }, [
        rerender
    ]);
    $ed53cdd88593f6a0$export$700979bc83e7db82(()=>{
        unmountedRef.current = false;
        return ()=>{
            unmountedRef.current = true;
        };
    });
    return [
        stateRef,
        stateDependenciesRef.current,
        setState
    ];
};
// Add a callback function to a list of keyed callback functions and return
// the unsubscribe function.
const $ed53cdd88593f6a0$export$e005210ed621746 = (key, callbacks, callback)=>{
    const keyedRevalidators = callbacks[key] || (callbacks[key] = []);
    keyedRevalidators.push(callback);
    return ()=>{
        const index = keyedRevalidators.indexOf(callback);
        if (index >= 0) {
            // O(1): faster than splice
            keyedRevalidators[index] = keyedRevalidators[keyedRevalidators.length - 1];
            keyedRevalidators.pop();
        }
    };
};
// Create a custom hook with a middleware
const $ed53cdd88593f6a0$export$525ea7fc6ba00096 = (useSWR, middleware)=>{
    return (...args)=>{
        const [key, fn, config] = $ed53cdd88593f6a0$export$a3295358bff77e(args);
        const uses = (config.use || []).concat(middleware);
        return useSWR(key, fn, {
            ...config,
            use: uses
        });
    };
};
$ed53cdd88593f6a0$var$setupDevTools();

});


parcelRequire.register("2ANSb", function(module, exports) {

$parcel$export(module.exports, "RequestError", function () { return $cf6f71a1f9246f42$export$43ee7d0e4f429743; });
$parcel$export(module.exports, "useStaticApi", function () { return $cf6f71a1f9246f42$export$181b551a2bac23b4; });
$parcel$export(module.exports, "default", function () { return $cf6f71a1f9246f42$export$2e2bcd8739ae039; });
parcelRequire("8Hfh4");
var $6A6hX = parcelRequire("6A6hX");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("j6dBR");
var $5fvIO = parcelRequire("5fvIO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $5bxQK = parcelRequire("5bxQK");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $6ZMK7 = parcelRequire("6ZMK7");

var $eEyjP = parcelRequire("eEyjP");

var $2wPYZ = parcelRequire("2wPYZ");

var $9ENFn = parcelRequire("9ENFn");

var $iYZTa = parcelRequire("iYZTa");
class $cf6f71a1f9246f42$export$43ee7d0e4f429743 extends Error {
    constructor(status, body){
        super("Request error occurred.");
        this.status = status;
        this.body = body;
    }
}
const $cf6f71a1f9246f42$export$181b551a2bac23b4 = ({ prefixUrl: prefixUrl, hideErrorToast: hideErrorToast, resourceIndicator: resourceIndicator })=>{
    const { isAuthenticated: isAuthenticated, getAccessToken: getAccessToken, signOut: signOut } = (0, $dtOpc.useLogto)();
    const { t: t, i18n: i18n } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const postSignOutRedirectUri = (0, $iYZTa.default)("signOut");
    const toastError = (0, $eCoWV.useCallback)(async (response)=>{
        const fallbackErrorMessage = t("errors.unknown_server_error");
        try {
            // Clone the response to avoid "Response body is already used".
            const data = await response.clone().json();
            // Inform and redirect un-authorized users to sign in page.
            if (data.code === "auth.forbidden") {
                await show({
                    ModalContent: data.message,
                    type: "alert",
                    cancelButtonText: "general.got_it"
                });
                await signOut(postSignOutRedirectUri.href);
                return;
            }
            (0, $horhC.toast).error([
                data.message,
                data.details
            ].join("\n") || fallbackErrorMessage);
        } catch  {
            (0, $horhC.toast).error((0, $6A6hX.httpCodeToMessage)[response.status] ?? fallbackErrorMessage);
        }
    }, [
        show,
        signOut,
        t,
        postSignOutRedirectUri
    ]);
    const api = (0, $eCoWV.useMemo)(()=>(0, $5bxQK.default).create({
            prefixUrl: prefixUrl,
            timeout: (0, $6ZMK7.requestTimeout),
            hooks: {
                beforeError: (0, $5CQIb.conditionalArray)(!hideErrorToast && (async (error)=>{
                    await toastError(error.response);
                    return error;
                })),
                beforeRequest: [
                    async (request)=>{
                        if (isAuthenticated) {
                            const accessToken = await getAccessToken(resourceIndicator);
                            request.headers.set("Authorization", `Bearer ${accessToken ?? ""}`);
                            request.headers.set("Accept-Language", i18n.language);
                        }
                    }
                ]
            }
        }), [
        prefixUrl,
        hideErrorToast,
        toastError,
        isAuthenticated,
        getAccessToken,
        resourceIndicator,
        i18n.language
    ]);
    return api;
};
const $cf6f71a1f9246f42$var$useApi = (props = {})=>{
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    return $cf6f71a1f9246f42$export$181b551a2bac23b4({
        ...props,
        prefixUrl: tenantEndpoint,
        resourceIndicator: (0, $5fvIO.getManagementApiResourceIndicator)(currentTenantId)
    });
};
var $cf6f71a1f9246f42$export$2e2bcd8739ae039 = $cf6f71a1f9246f42$var$useApi;

});
parcelRequire.register("cDiVA", function(module, exports) {

$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("jwQhE")).LogtoClientError; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("du5TZ")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("du5TZ")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("du5TZ")).OidcError; });
$parcel$export(module.exports, "LogtoProvider", function () { return (parcelRequire("dbZ39")).LogtoProvider; });
$parcel$export(module.exports, "useHandleSignInCallback", function () { return (parcelRequire("dtOpc")).useHandleSignInCallback; });
$parcel$export(module.exports, "useLogto", function () { return (parcelRequire("dtOpc")).useLogto; });
parcelRequire("4OCmV");
var $jwQhE = parcelRequire("jwQhE");
var $du5TZ = parcelRequire("du5TZ");

var $dbZ39 = parcelRequire("dbZ39");

var $dtOpc = parcelRequire("dtOpc");

});
parcelRequire.register("4OCmV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3819982657068643$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("jwQhE")).LogtoClientError; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("du5TZ")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("du5TZ")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("du5TZ")).OidcError; });
parcelRequire("iP5g2");
var $70kRi = parcelRequire("70kRi");
var $iP5g2 = parcelRequire("iP5g2");
var $jwQhE = parcelRequire("jwQhE");
var $du5TZ = parcelRequire("du5TZ");
parcelRequire("i6nxh");
var $154Ff = parcelRequire("154Ff");

var $i6ct6 = parcelRequire("i6ct6");

var $bNOoh = parcelRequire("bNOoh");

var $jrkmB = parcelRequire("jrkmB");
const $3819982657068643$var$navigate = (url)=>{
    window.location.assign(url);
};
class $3819982657068643$export$2e2bcd8739ae039 extends (0, $iP5g2.default) {
    /**
     * @param config The configuration object for the client.
     * @param [unstable_enableCache=false] Whether to enable cache for well-known data.
     * Use sessionStorage by default.
     */ constructor(config, unstable_enableCache = false){
        const requester = (0, $70kRi.createRequester)(fetch);
        super(config, {
            requester: requester,
            navigate: $3819982657068643$var$navigate,
            storage: new (0, $bNOoh.BrowserStorage)(config.appId),
            unstable_cache: (0, $154Ff.conditional)(unstable_enableCache && new (0, $i6ct6.CacheStorage)(config.appId)),
            generateCodeChallenge: $jrkmB.generateCodeChallenge,
            generateCodeVerifier: $jrkmB.generateCodeVerifier,
            generateState: $jrkmB.generateState
        });
    }
}

});
parcelRequire.register("iP5g2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $db4111762c8c8c8c$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("du5TZ")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("du5TZ")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("du5TZ")).OidcError; });
$parcel$export(module.exports, "createRequester", function () { return (parcelRequire("70kRi")).createRequester; });
$parcel$export(module.exports, "LogtoClientError", function () { return (parcelRequire("jwQhE")).LogtoClientError; });
parcelRequire("9JeGV");
var $4OAMv = parcelRequire("4OAMv");
var $hY42Z = parcelRequire("hY42Z");
var $cIIwT = parcelRequire("cIIwT");
var $7yeUb = parcelRequire("7yeUb");
var $MM0rY = parcelRequire("MM0rY");
var $brobN = parcelRequire("brobN");
var $gNGQN = parcelRequire("gNGQN");
var $6f1Q2 = parcelRequire("6f1Q2");
var $7xrzW = parcelRequire("7xrzW");
var $3FAnm = parcelRequire("3FAnm");
var $du5TZ = parcelRequire("du5TZ");
parcelRequire("dTynv");
var $54Ouh = parcelRequire("54Ouh");

var $kE3hY = parcelRequire("kE3hY");

var $jwQhE = parcelRequire("jwQhE");

var $kCFLl = parcelRequire("kCFLl");

var $agFc7 = parcelRequire("agFc7");

var $5Yufm = parcelRequire("5Yufm");

var $koOVm = parcelRequire("koOVm");

var $j34cR = parcelRequire("j34cR");

var $8r3Dj = parcelRequire("8r3Dj");

var $70kRi = parcelRequire("70kRi");
/* eslint-disable max-lines */ /**
 * The Logto base client class that provides the essential methods for
 * interacting with the Logto server.
 *
 * It also provides an adapter object that allows the customizations of the
 * client behavior for different environments.
 */ class $db4111762c8c8c8c$export$2e2bcd8739ae039 {
    constructor(logtoConfig, adapter){
        this.getOidcConfig = (0, $koOVm.memoize)(this.#getOidcConfig);
        /**
         * Get the access token from the storage with refresh strategy.
         *
         * - If the access token has expired, it will try to fetch a new one using the Refresh Token.
         * - If there's an ongoing Promise to fetch the access token, it will return the Promise.
         *
         * If you want to get the access token claims, use {@link getAccessTokenClaims} instead.
         *
         * @param resource The resource that the access token is granted for. If not
         * specified, the access token will be used for OpenID Connect or the default
         * resource, as specified in the Logto Console.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         */ this.getAccessToken = (0, $koOVm.memoize)(this.#getAccessToken);
        /**
         * Get the access token for the specified organization from the storage with refresh strategy.
         *
         * Scope {@link UserScope.Organizations} is required in the config to use organization-related
         * methods.
         *
         * @param organizationId The ID of the organization that the access token is granted for.
         * @returns The access token string.
         * @throws LogtoClientError if the user is not authenticated.
         * @remarks
         * It uses the same refresh strategy as {@link getAccessToken}.
         */ this.getOrganizationToken = (0, $koOVm.memoize)(this.#getOrganizationToken);
        this.getJwtVerifyGetKey = (0, $j34cR.once)(this.#getJwtVerifyGetKey);
        this.accessTokenMap = new Map();
        this.logtoConfig = (0, $agFc7.normalizeLogtoConfig)(logtoConfig);
        this.adapter = new (0, $kE3hY.ClientAdapterInstance)(adapter);
        this.loadAccessTokenMap();
    }
    /**
     * Check if the user is authenticated by checking if the ID token exists.
     */ async isAuthenticated() {
        return Boolean(await this.getIdToken());
    }
    /**
     * Get the Refresh Token from the storage.
     */ async getRefreshToken() {
        return this.adapter.storage.getItem("refreshToken");
    }
    /**
     * Get the ID Token from the storage. If you want to get the ID Token claims,
     * use {@link getIdTokenClaims} instead.
     */ async getIdToken() {
        return this.adapter.storage.getItem("idToken");
    }
    /**
     * Get the ID Token claims.
     */ async getIdTokenClaims() {
        const idToken = await this.getIdToken();
        if (!idToken) throw new (0, $jwQhE.LogtoClientError)("not_authenticated");
        return (0, $4OAMv.decodeIdToken)(idToken);
    }
    /**
     * Get the access token claims for the specified resource.
     *
     * @param resource The resource that the access token is granted for. If not
     * specified, the access token will be used for OpenID Connect or the default
     * resource, as specified in the Logto Console.
     */ async getAccessTokenClaims(resource) {
        const accessToken = await this.getAccessToken(resource);
        return (0, $hY42Z.decodeAccessToken)(accessToken);
    }
    /**
     * Get the organization token claims for the specified organization.
     *
     * @param organizationId The ID of the organization that the access token is granted for.
     */ async getOrganizationTokenClaims(organizationId) {
        const accessToken = await this.getOrganizationToken(organizationId);
        return (0, $hY42Z.decodeAccessToken)(accessToken);
    }
    /**
     * Get the user information from the Userinfo Endpoint.
     *
     * Note the Userinfo Endpoint will return more claims than the ID Token. See
     * {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#fetch-user-information | Fetch user information}
     * for more information.
     *
     * @returns The user information.
     * @throws LogtoClientError if the user is not authenticated.
     */ async fetchUserInfo() {
        const { userinfoEndpoint: userinfoEndpoint } = await this.getOidcConfig();
        const accessToken = await this.getAccessToken();
        if (!accessToken) throw new (0, $jwQhE.LogtoClientError)("fetch_user_info_failed");
        return (0, $cIIwT.fetchUserInfo)(userinfoEndpoint, accessToken, this.adapter.requester);
    }
    /**
     * Start the sign-in flow with the specified redirect URI. The URI must be
     * registered in the Logto Console.
     *
     * The user will be redirected to that URI after the sign-in flow is completed,
     * and the client will be able to get the authorization code from the URI.
     * To fetch the tokens from the authorization code, use {@link handleSignInCallback}
     * after the user is redirected in the callback URI.
     *
     * @param redirectUri The redirect URI that the user will be redirected to after the sign-in flow is completed.
     * @param interactionMode The interaction mode to be used for the authorization request. Note it's not
     * a part of the OIDC standard, but a Logto-specific extension. Defaults to `signIn`.
     *
     * @see {@link https://docs.logto.io/docs/recipes/integrate-logto/vanilla-js/#sign-in | Sign in} for more information.
     * @see {@link InteractionMode}
     */ async signIn(redirectUri, interactionMode) {
        const { appId: clientId, prompt: prompt, resources: resources, scopes: scopes } = this.logtoConfig;
        const { authorizationEndpoint: authorizationEndpoint } = await this.getOidcConfig();
        const codeVerifier = this.adapter.generateCodeVerifier();
        const codeChallenge = await this.adapter.generateCodeChallenge(codeVerifier);
        const state = this.adapter.generateState();
        const signInUri = (0, $7yeUb.generateSignInUri)({
            authorizationEndpoint: authorizationEndpoint,
            clientId: clientId,
            redirectUri: redirectUri,
            codeChallenge: codeChallenge,
            state: state,
            scopes: scopes,
            resources: resources,
            prompt: prompt,
            interactionMode: interactionMode
        });
        await Promise.all([
            this.setSignInSession({
                redirectUri: redirectUri,
                codeVerifier: codeVerifier,
                state: state
            }),
            this.setRefreshToken(null),
            this.setIdToken(null)
        ]);
        await this.adapter.navigate(signInUri);
    }
    /**
     * Check if the user is redirected from the sign-in page by checking if the
     * current URL matches the redirect URI in the sign-in session.
     *
     * If there's no sign-in session, it will return `false`.
     *
     * @param url The current URL.
     */ async isSignInRedirected(url) {
        const signInSession = await this.getSignInSession();
        if (!signInSession) return false;
        const { redirectUri: redirectUri } = signInSession;
        const { origin: origin, pathname: pathname } = new URL(url);
        return `${origin}${pathname}` === redirectUri;
    }
    /**
     * Handle the sign-in callback by parsing the authorization code from the
     * callback URI and exchanging it for the tokens.
     *
     * @param callbackUri The callback URI, including the search params, that the user is redirected to after the sign-in flow is completed.
     * The origin and pathname of this URI must match the origin and pathname of the redirect URI specified in {@link signIn}.
     * In many cases you'll probably end up passing `window.location.href` as the argument to this function.
     * @throws LogtoClientError if the sign-in session is not found.
     */ async handleSignInCallback(callbackUri) {
        const { requester: requester } = this.adapter;
        const signInSession = await this.getSignInSession();
        if (!signInSession) throw new (0, $jwQhE.LogtoClientError)("sign_in_session.not_found");
        const { redirectUri: redirectUri, state: state, codeVerifier: codeVerifier } = signInSession;
        const code = (0, $MM0rY.verifyAndParseCodeFromCallbackUri)(callbackUri, redirectUri, state);
        // NOTE: Will add scope to accessTokenKey when needed. (Linear issue LOG-1589)
        const accessTokenKey = (0, $5Yufm.buildAccessTokenKey)();
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { idToken: idToken, refreshToken: refreshToken, accessToken: accessToken, scope: scope, expiresIn: expiresIn } = await (0, $brobN.fetchTokenByAuthorizationCode)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            redirectUri: redirectUri,
            codeVerifier: codeVerifier,
            code: code
        }, requester);
        await this.verifyIdToken(idToken);
        await this.setRefreshToken(refreshToken ?? null);
        await this.setIdToken(idToken);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        await this.setSignInSession(null);
    }
    /**
     * Start the sign-out flow with the specified redirect URI. The URI must be
     * registered in the Logto Console.
     *
     * It will also revoke all the tokens and clean up the storage.
     *
     * The user will be redirected that URI after the sign-out flow is completed.
     * If the `postLogoutRedirectUri` is not specified, the user will be redirected
     * to a default page.
     */ async signOut(postLogoutRedirectUri) {
        const { appId: clientId } = this.logtoConfig;
        const { endSessionEndpoint: endSessionEndpoint, revocationEndpoint: revocationEndpoint } = await this.getOidcConfig();
        const refreshToken = await this.getRefreshToken();
        if (refreshToken) try {
            await (0, $gNGQN.revoke)(revocationEndpoint, clientId, refreshToken, this.adapter.requester);
        } catch  {
        // Do nothing at this point, as we don't want to break the sign-out flow even if the revocation is failed
        }
        const url = (0, $6f1Q2.generateSignOutUri)({
            endSessionEndpoint: endSessionEndpoint,
            postLogoutRedirectUri: postLogoutRedirectUri,
            clientId: clientId
        });
        this.accessTokenMap.clear();
        await Promise.all([
            this.setRefreshToken(null),
            this.setIdToken(null),
            this.adapter.storage.removeItem("accessToken")
        ]);
        await this.adapter.navigate(url);
    }
    async getSignInSession() {
        const jsonItem = await this.adapter.storage.getItem("signInSession");
        if (!jsonItem) return null;
        const item = JSON.parse(jsonItem);
        if (!(0, $agFc7.isLogtoSignInSessionItem)(item)) throw new (0, $jwQhE.LogtoClientError)("sign_in_session.invalid");
        return item;
    }
    async setSignInSession(value) {
        return this.adapter.setStorageItem((0, $8r3Dj.PersistKey).SignInSession, value && JSON.stringify(value));
    }
    async setIdToken(value) {
        return this.adapter.setStorageItem((0, $8r3Dj.PersistKey).IdToken, value);
    }
    async setRefreshToken(value) {
        return this.adapter.setStorageItem((0, $8r3Dj.PersistKey).RefreshToken, value);
    }
    async getAccessTokenByRefreshToken(resource, organizationId) {
        const currentRefreshToken = await this.getRefreshToken();
        if (!currentRefreshToken) throw new (0, $jwQhE.LogtoClientError)("not_authenticated");
        const accessTokenKey = (0, $5Yufm.buildAccessTokenKey)(resource, organizationId);
        const { appId: clientId } = this.logtoConfig;
        const { tokenEndpoint: tokenEndpoint } = await this.getOidcConfig();
        const requestedAt = Math.round(Date.now() / 1000);
        const { accessToken: accessToken, refreshToken: refreshToken, idToken: idToken, scope: scope, expiresIn: expiresIn } = await (0, $brobN.fetchTokenByRefreshToken)({
            clientId: clientId,
            tokenEndpoint: tokenEndpoint,
            refreshToken: currentRefreshToken,
            resource: resource,
            organizationId: organizationId
        }, this.adapter.requester);
        this.accessTokenMap.set(accessTokenKey, {
            token: accessToken,
            scope: scope,
            /** The `expiresAt` variable provides an approximate estimation of the actual `exp` property
             * in the token claims. It is utilized by the client to determine if the cached access token
             * has expired and when a new access token should be requested.
             */ expiresAt: requestedAt + expiresIn
        });
        await this.saveAccessTokenMap();
        if (refreshToken) await this.setRefreshToken(refreshToken);
        if (idToken) {
            await this.verifyIdToken(idToken);
            await this.setIdToken(idToken);
        }
        return accessToken;
    }
    async verifyIdToken(idToken) {
        const { appId: appId } = this.logtoConfig;
        const { issuer: issuer } = await this.getOidcConfig();
        const jwtVerifyGetKey = await this.getJwtVerifyGetKey();
        await (0, $4OAMv.verifyIdToken)(idToken, appId, issuer, jwtVerifyGetKey);
    }
    async saveAccessTokenMap() {
        const data = {};
        for (const [key, accessToken] of this.accessTokenMap.entries())// eslint-disable-next-line @silverhand/fp/no-mutation
        data[key] = accessToken;
        await this.adapter.storage.setItem("accessToken", JSON.stringify(data));
    }
    async loadAccessTokenMap() {
        const raw = await this.adapter.storage.getItem("accessToken");
        if (!raw) return;
        try {
            const json = JSON.parse(raw);
            if (!(0, $agFc7.isLogtoAccessTokenMap)(json)) return;
            this.accessTokenMap.clear();
            for (const [key, accessToken] of Object.entries(json))this.accessTokenMap.set(key, accessToken);
        } catch (error) {
            console.warn(error);
        }
    }
    async #getOidcConfig() {
        return this.adapter.getWithCache((0, $8r3Dj.CacheKey).OpenidConfig, async ()=>{
            return (0, $7xrzW.fetchOidcConfig)((0, $5Yufm.getDiscoveryEndpoint)(this.logtoConfig.endpoint), this.adapter.requester);
        });
    }
    async #getJwtVerifyGetKey() {
        const { jwksUri: jwksUri } = await this.getOidcConfig();
        if (!this.adapter.unstable_cache) return (0, $54Ouh.createRemoteJWKSet)(new URL(jwksUri));
        const cachedJwkSet = new (0, $kCFLl.CachedRemoteJwkSet)(new URL(jwksUri), this.adapter);
        return async (...args)=>cachedJwkSet.getKey(...args);
    }
    async #getAccessToken(resource, organizationId) {
        if (!await this.isAuthenticated()) throw new (0, $jwQhE.LogtoClientError)("not_authenticated");
        const accessTokenKey = (0, $5Yufm.buildAccessTokenKey)(resource, organizationId);
        const accessToken = this.accessTokenMap.get(accessTokenKey);
        if (accessToken && accessToken.expiresAt > Date.now() / 1000) return accessToken.token;
        // Since the access token has expired, delete it from the map.
        if (accessToken) this.accessTokenMap.delete(accessTokenKey);
        /**
         * Need to fetch a new access token using refresh token.
         */ return this.getAccessTokenByRefreshToken(resource, organizationId);
    }
    async #getOrganizationToken(organizationId) {
        if (!this.logtoConfig.scopes?.includes((0, $3FAnm.UserScope).Organizations)) throw new (0, $jwQhE.LogtoClientError)("missing_scope_organizations");
        return this.#getAccessToken(undefined, organizationId);
    }
}

});
parcelRequire.register("9JeGV", function(module, exports) {

$parcel$export(module.exports, "fetchTokenByAuthorizationCode", function () { return (parcelRequire("brobN")).fetchTokenByAuthorizationCode; });
$parcel$export(module.exports, "fetchTokenByRefreshToken", function () { return (parcelRequire("brobN")).fetchTokenByRefreshToken; });
$parcel$export(module.exports, "discoveryPath", function () { return (parcelRequire("7xrzW")).discoveryPath; });
$parcel$export(module.exports, "fetchOidcConfig", function () { return (parcelRequire("7xrzW")).fetchOidcConfig; });
$parcel$export(module.exports, "revoke", function () { return (parcelRequire("gNGQN")).revoke; });
$parcel$export(module.exports, "generateSignInUri", function () { return (parcelRequire("7yeUb")).generateSignInUri; });
$parcel$export(module.exports, "generateSignOutUri", function () { return (parcelRequire("6f1Q2")).generateSignOutUri; });
$parcel$export(module.exports, "fetchUserInfo", function () { return (parcelRequire("cIIwT")).fetchUserInfo; });
$parcel$export(module.exports, "verifyAndParseCodeFromCallbackUri", function () { return (parcelRequire("MM0rY")).verifyAndParseCodeFromCallbackUri; });
$parcel$export(module.exports, "LogtoError", function () { return (parcelRequire("du5TZ")).LogtoError; });
$parcel$export(module.exports, "LogtoRequestError", function () { return (parcelRequire("du5TZ")).LogtoRequestError; });
$parcel$export(module.exports, "OidcError", function () { return (parcelRequire("du5TZ")).OidcError; });
$parcel$export(module.exports, "isLogtoRequestError", function () { return (parcelRequire("du5TZ")).isLogtoRequestError; });
$parcel$export(module.exports, "decodeIdToken", function () { return (parcelRequire("4OAMv")).decodeIdToken; });
$parcel$export(module.exports, "verifyIdToken", function () { return (parcelRequire("4OAMv")).verifyIdToken; });
$parcel$export(module.exports, "decodeAccessToken", function () { return (parcelRequire("hY42Z")).decodeAccessToken; });
$parcel$export(module.exports, "withDefaultScopes", function () { return (parcelRequire("fgp9B")).withDefaultScopes; });
$parcel$export(module.exports, "isArbitraryObject", function () { return (parcelRequire("1SubF")).isArbitraryObject; });
$parcel$export(module.exports, "Prompt", function () { return (parcelRequire("6Woc4")).Prompt; });
$parcel$export(module.exports, "ReservedResource", function () { return (parcelRequire("3FAnm")).ReservedResource; });
$parcel$export(module.exports, "UserScope", function () { return (parcelRequire("3FAnm")).UserScope; });

var $brobN = parcelRequire("brobN");

var $7xrzW = parcelRequire("7xrzW");

var $gNGQN = parcelRequire("gNGQN");

var $7yeUb = parcelRequire("7yeUb");

var $6f1Q2 = parcelRequire("6f1Q2");

var $cIIwT = parcelRequire("cIIwT");

var $MM0rY = parcelRequire("MM0rY");

var $du5TZ = parcelRequire("du5TZ");

var $4OAMv = parcelRequire("4OAMv");

var $hY42Z = parcelRequire("hY42Z");

var $fgp9B = parcelRequire("fgp9B");

var $1SubF = parcelRequire("1SubF");

var $6Woc4 = parcelRequire("6Woc4");

var $3FAnm = parcelRequire("3FAnm");

});
parcelRequire.register("brobN", function(module, exports) {

$parcel$export(module.exports, "fetchTokenByAuthorizationCode", function () { return $8544fad05d466021$export$684f740cd70532d4; });
$parcel$export(module.exports, "fetchTokenByRefreshToken", function () { return $8544fad05d466021$export$9909137b467efb8b; });

var $ikvgY = parcelRequire("ikvgY");

var $6Woc4 = parcelRequire("6Woc4");
const $8544fad05d466021$export$684f740cd70532d4 = async ({ clientId: clientId, tokenEndpoint: tokenEndpoint, redirectUri: redirectUri, codeVerifier: codeVerifier, code: code, resource: resource }, requester)=>{
    const parameters = new URLSearchParams();
    parameters.append((0, $6Woc4.QueryKey).ClientId, clientId);
    parameters.append((0, $6Woc4.QueryKey).Code, code);
    parameters.append((0, $6Woc4.QueryKey).CodeVerifier, codeVerifier);
    parameters.append((0, $6Woc4.QueryKey).RedirectUri, redirectUri);
    parameters.append((0, $6Woc4.QueryKey).GrantType, (0, $6Woc4.TokenGrantType).AuthorizationCode);
    if (resource) parameters.append((0, $6Woc4.QueryKey).Resource, resource);
    const snakeCaseCodeTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $6Woc4.ContentType).formUrlEncoded,
        body: parameters
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ikvgY)))(snakeCaseCodeTokenResponse);
};
/**
 * Fetch access token by refresh token using the token endpoint and `refresh_token` grant type.
 * @param params The parameters for fetching access token.
 * @param requester The requester for sending HTTP request.
 * @returns A Promise that resolves to the access token response.
 */ const $8544fad05d466021$export$9909137b467efb8b = async (params, requester)=>{
    const { clientId: clientId, tokenEndpoint: tokenEndpoint, refreshToken: refreshToken, resource: resource, organizationId: organizationId, scopes: scopes } = params;
    const parameters = new URLSearchParams();
    parameters.append((0, $6Woc4.QueryKey).ClientId, clientId);
    parameters.append((0, $6Woc4.QueryKey).RefreshToken, refreshToken);
    parameters.append((0, $6Woc4.QueryKey).GrantType, (0, $6Woc4.TokenGrantType).RefreshToken);
    if (resource) parameters.append((0, $6Woc4.QueryKey).Resource, resource);
    if (organizationId) parameters.append((0, $6Woc4.QueryKey).OrganizationId, organizationId);
    if (scopes?.length) parameters.append((0, $6Woc4.QueryKey).Scope, scopes.join(" "));
    const snakeCaseRefreshTokenTokenResponse = await requester(tokenEndpoint, {
        method: "POST",
        headers: (0, $6Woc4.ContentType).formUrlEncoded,
        body: parameters
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($ikvgY)))(snakeCaseRefreshTokenTokenResponse);
};

});
parcelRequire.register("ikvgY", function(module, exports) {
"use strict";

var $lUepA = parcelRequire("lUepA");

var $86ZsV = parcelRequire("86ZsV");

var $8gYjW = parcelRequire("8gYjW");
const $d5825a5fcd93b1ab$var$has = (array, key)=>array.some((x)=>{
        if (typeof x === "string") return x === key;
        x.lastIndex = 0;
        return x.test(key);
    });
const $d5825a5fcd93b1ab$var$cache = new $8gYjW({
    maxSize: 100000
});
// Reproduces behavior from `map-obj`
const $d5825a5fcd93b1ab$var$isObject = (value)=>typeof value === "object" && value !== null && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $d5825a5fcd93b1ab$var$camelCaseConvert = (input, options)=>{
    if (!$d5825a5fcd93b1ab$var$isObject(input)) return input;
    options = {
        deep: false,
        pascalCase: false,
        ...options
    };
    const { exclude: exclude, pascalCase: pascalCase, stopPaths: stopPaths, deep: deep } = options;
    const stopPathsSet = new Set(stopPaths);
    const makeMapper = (parentPath)=>(key, value)=>{
            if (deep && $d5825a5fcd93b1ab$var$isObject(value)) {
                const path = parentPath === undefined ? key : `${parentPath}.${key}`;
                if (!stopPathsSet.has(path)) value = $lUepA(value, makeMapper(path));
            }
            if (!(exclude && $d5825a5fcd93b1ab$var$has(exclude, key))) {
                const cacheKey = pascalCase ? `${key}_` : key;
                if ($d5825a5fcd93b1ab$var$cache.has(cacheKey)) key = $d5825a5fcd93b1ab$var$cache.get(cacheKey);
                else {
                    const returnValue = $86ZsV(key, {
                        pascalCase: pascalCase,
                        locale: false
                    });
                    if (key.length < 100) $d5825a5fcd93b1ab$var$cache.set(cacheKey, returnValue);
                    key = returnValue;
                }
            }
            return [
                key,
                value
            ];
        };
    return $lUepA(input, makeMapper(undefined));
};
module.exports = (input, options)=>{
    if (Array.isArray(input)) return Object.keys(input).map((key)=>$d5825a5fcd93b1ab$var$camelCaseConvert(input[key], options));
    return $d5825a5fcd93b1ab$var$camelCaseConvert(input, options);
};

});
parcelRequire.register("lUepA", function(module, exports) {
"use strict";
const $ff2a01ce045d01ce$var$isObject = (value)=>typeof value === "object" && value !== null;
const $ff2a01ce045d01ce$var$mapObjectSkip = Symbol("skip");
// Customized for this use-case
const $ff2a01ce045d01ce$var$isObjectCustom = (value)=>$ff2a01ce045d01ce$var$isObject(value) && !(value instanceof RegExp) && !(value instanceof Error) && !(value instanceof Date);
const $ff2a01ce045d01ce$var$mapObject = (object, mapper, options, isSeen = new WeakMap())=>{
    options = {
        deep: false,
        target: {},
        ...options
    };
    if (isSeen.has(object)) return isSeen.get(object);
    isSeen.set(object, options.target);
    const { target: target } = options;
    delete options.target;
    const mapArray = (array)=>array.map((element)=>$ff2a01ce045d01ce$var$isObjectCustom(element) ? $ff2a01ce045d01ce$var$mapObject(element, mapper, options, isSeen) : element);
    if (Array.isArray(object)) return mapArray(object);
    for (const [key, value] of Object.entries(object)){
        const mapResult = mapper(key, value, object);
        if (mapResult === $ff2a01ce045d01ce$var$mapObjectSkip) continue;
        let [newKey, newValue, { shouldRecurse: shouldRecurse = true } = {}] = mapResult;
        // Drop `__proto__` keys.
        if (newKey === "__proto__") continue;
        if (options.deep && shouldRecurse && $ff2a01ce045d01ce$var$isObjectCustom(newValue)) newValue = Array.isArray(newValue) ? mapArray(newValue) : $ff2a01ce045d01ce$var$mapObject(newValue, mapper, options, isSeen);
        target[newKey] = newValue;
    }
    return target;
};
module.exports = (object, mapper, options)=>{
    if (!$ff2a01ce045d01ce$var$isObject(object)) throw new TypeError(`Expected an object, got \`${object}\` (${typeof object})`);
    return $ff2a01ce045d01ce$var$mapObject(object, mapper, options);
};
module.exports.mapObjectSkip = $ff2a01ce045d01ce$var$mapObjectSkip;

});

parcelRequire.register("86ZsV", function(module, exports) {
"use strict";
const $5e7e900c5fff8058$var$UPPERCASE = /[\p{Lu}]/u;
const $5e7e900c5fff8058$var$LOWERCASE = /[\p{Ll}]/u;
const $5e7e900c5fff8058$var$LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const $5e7e900c5fff8058$var$IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const $5e7e900c5fff8058$var$SEPARATORS = /[_.\- ]+/;
const $5e7e900c5fff8058$var$LEADING_SEPARATORS = new RegExp("^" + $5e7e900c5fff8058$var$SEPARATORS.source);
const $5e7e900c5fff8058$var$SEPARATORS_AND_IDENTIFIER = new RegExp($5e7e900c5fff8058$var$SEPARATORS.source + $5e7e900c5fff8058$var$IDENTIFIER.source, "gu");
const $5e7e900c5fff8058$var$NUMBERS_AND_IDENTIFIER = new RegExp("\\d+" + $5e7e900c5fff8058$var$IDENTIFIER.source, "gu");
const $5e7e900c5fff8058$var$preserveCamelCase = (string, toLowerCase, toUpperCase)=>{
    let isLastCharLower = false;
    let isLastCharUpper = false;
    let isLastLastCharUpper = false;
    for(let i = 0; i < string.length; i++){
        const character = string[i];
        if (isLastCharLower && $5e7e900c5fff8058$var$UPPERCASE.test(character)) {
            string = string.slice(0, i) + "-" + string.slice(i);
            isLastCharLower = false;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = true;
            i++;
        } else if (isLastCharUpper && isLastLastCharUpper && $5e7e900c5fff8058$var$LOWERCASE.test(character)) {
            string = string.slice(0, i - 1) + "-" + string.slice(i - 1);
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = false;
            isLastCharLower = true;
        } else {
            isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
            isLastLastCharUpper = isLastCharUpper;
            isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
        }
    }
    return string;
};
const $5e7e900c5fff8058$var$preserveConsecutiveUppercase = (input, toLowerCase)=>{
    $5e7e900c5fff8058$var$LEADING_CAPITAL.lastIndex = 0;
    return input.replace($5e7e900c5fff8058$var$LEADING_CAPITAL, (m1)=>toLowerCase(m1));
};
const $5e7e900c5fff8058$var$postProcess = (input, toUpperCase)=>{
    $5e7e900c5fff8058$var$SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
    $5e7e900c5fff8058$var$NUMBERS_AND_IDENTIFIER.lastIndex = 0;
    return input.replace($5e7e900c5fff8058$var$SEPARATORS_AND_IDENTIFIER, (_, identifier)=>toUpperCase(identifier)).replace($5e7e900c5fff8058$var$NUMBERS_AND_IDENTIFIER, (m)=>toUpperCase(m));
};
const $5e7e900c5fff8058$var$camelCase = (input, options)=>{
    if (!(typeof input === "string" || Array.isArray(input))) throw new TypeError("Expected the input to be `string | string[]`");
    options = {
        pascalCase: false,
        preserveConsecutiveUppercase: false,
        ...options
    };
    if (Array.isArray(input)) input = input.map((x)=>x.trim()).filter((x)=>x.length).join("-");
    else input = input.trim();
    if (input.length === 0) return "";
    const toLowerCase = options.locale === false ? (string)=>string.toLowerCase() : (string)=>string.toLocaleLowerCase(options.locale);
    const toUpperCase = options.locale === false ? (string)=>string.toUpperCase() : (string)=>string.toLocaleUpperCase(options.locale);
    if (input.length === 1) return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
    const hasUpperCase = input !== toLowerCase(input);
    if (hasUpperCase) input = $5e7e900c5fff8058$var$preserveCamelCase(input, toLowerCase, toUpperCase);
    input = input.replace($5e7e900c5fff8058$var$LEADING_SEPARATORS, "");
    if (options.preserveConsecutiveUppercase) input = $5e7e900c5fff8058$var$preserveConsecutiveUppercase(input, toLowerCase);
    else input = toLowerCase(input);
    if (options.pascalCase) input = toUpperCase(input.charAt(0)) + input.slice(1);
    return $5e7e900c5fff8058$var$postProcess(input, toUpperCase);
};
module.exports = $5e7e900c5fff8058$var$camelCase;
// TODO: Remove this for the next major release
module.exports.default = $5e7e900c5fff8058$var$camelCase;

});

parcelRequire.register("8gYjW", function(module, exports) {
"use strict";
class $605e9bc2e69825ed$var$QuickLRU {
    constructor(options = {}){
        if (!(options.maxSize && options.maxSize > 0)) throw new TypeError("`maxSize` must be a number greater than 0");
        this.maxSize = options.maxSize;
        this.onEviction = options.onEviction;
        this.cache = new Map();
        this.oldCache = new Map();
        this._size = 0;
    }
    _set(key, value) {
        this.cache.set(key, value);
        this._size++;
        if (this._size >= this.maxSize) {
            this._size = 0;
            if (typeof this.onEviction === "function") for (const [key, value] of this.oldCache.entries())this.onEviction(key, value);
            this.oldCache = this.cache;
            this.cache = new Map();
        }
    }
    get(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) {
            const value = this.oldCache.get(key);
            this.oldCache.delete(key);
            this._set(key, value);
            return value;
        }
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.set(key, value);
        else this._set(key, value);
        return this;
    }
    has(key) {
        return this.cache.has(key) || this.oldCache.has(key);
    }
    peek(key) {
        if (this.cache.has(key)) return this.cache.get(key);
        if (this.oldCache.has(key)) return this.oldCache.get(key);
    }
    delete(key) {
        const deleted = this.cache.delete(key);
        if (deleted) this._size--;
        return this.oldCache.delete(key) || deleted;
    }
    clear() {
        this.cache.clear();
        this.oldCache.clear();
        this._size = 0;
    }
    *keys() {
        for (const [key] of this)yield key;
    }
    *values() {
        for (const [, value] of this)yield value;
    }
    *[Symbol.iterator]() {
        for (const item of this.cache)yield item;
        for (const item of this.oldCache){
            const [key] = item;
            if (!this.cache.has(key)) yield item;
        }
    }
    get size() {
        let oldCacheSize = 0;
        for (const key of this.oldCache.keys())if (!this.cache.has(key)) oldCacheSize++;
        return Math.min(this._size + oldCacheSize, this.maxSize);
    }
}
module.exports = $605e9bc2e69825ed$var$QuickLRU;

});


parcelRequire.register("6Woc4", function(module, exports) {

$parcel$export(module.exports, "ContentType", function () { return $50daed3a37cf8d46$export$e2e108cbe2e4f865; });
$parcel$export(module.exports, "TokenGrantType", function () { return $50daed3a37cf8d46$export$3f2aafdd1ccae76c; });
$parcel$export(module.exports, "QueryKey", function () { return $50daed3a37cf8d46$export$65f63a8bc3cba53d; });
$parcel$export(module.exports, "Prompt", function () { return $50daed3a37cf8d46$export$83716a4aa1642908; });

var $3FAnm = parcelRequire("3FAnm");
const $50daed3a37cf8d46$export$e2e108cbe2e4f865 = {
    formUrlEncoded: {
        "Content-Type": "application/x-www-form-urlencoded"
    }
};
var $50daed3a37cf8d46$export$3f2aafdd1ccae76c;
(function(TokenGrantType) {
    TokenGrantType["AuthorizationCode"] = "authorization_code";
    TokenGrantType["RefreshToken"] = "refresh_token";
})($50daed3a37cf8d46$export$3f2aafdd1ccae76c || ($50daed3a37cf8d46$export$3f2aafdd1ccae76c = {}));
var $50daed3a37cf8d46$export$65f63a8bc3cba53d;
(function(QueryKey) {
    QueryKey["ClientId"] = "client_id";
    QueryKey["Code"] = "code";
    QueryKey["CodeChallenge"] = "code_challenge";
    QueryKey["CodeChallengeMethod"] = "code_challenge_method";
    QueryKey["CodeVerifier"] = "code_verifier";
    QueryKey["Error"] = "error";
    QueryKey["ErrorDescription"] = "error_description";
    QueryKey["GrantType"] = "grant_type";
    QueryKey["IdToken"] = "id_token";
    QueryKey["IdTokenHint"] = "id_token_hint";
    QueryKey["PostLogoutRedirectUri"] = "post_logout_redirect_uri";
    QueryKey["Prompt"] = "prompt";
    QueryKey["RedirectUri"] = "redirect_uri";
    QueryKey["RefreshToken"] = "refresh_token";
    QueryKey["Resource"] = "resource";
    QueryKey["ResponseType"] = "response_type";
    QueryKey["Scope"] = "scope";
    QueryKey["State"] = "state";
    QueryKey["Token"] = "token";
    // Need to align with the OIDC extraParams settings in core
    QueryKey["InteractionMode"] = "interaction_mode";
    /** The query key for specifying the organization ID. */ QueryKey["OrganizationId"] = "organization_id";
})($50daed3a37cf8d46$export$65f63a8bc3cba53d || ($50daed3a37cf8d46$export$65f63a8bc3cba53d = {}));
/** The prompt parameter to be used for the authorization request. */ var $50daed3a37cf8d46$export$83716a4aa1642908;
(function(Prompt) {
    /**
     * The Authorization Server MUST prompt the End-User for consent
     * before returning information to the Client.
     */ Prompt["Consent"] = "consent";
    /**
     * The Authorization Server MUST prompt the End-User for re-authentication,
     * forcing the user to log in again. Note the there'll be no Refresh Token
     * returned in this case.
     */ Prompt["Login"] = "login";
})($50daed3a37cf8d46$export$83716a4aa1642908 || ($50daed3a37cf8d46$export$83716a4aa1642908 = {}));

});
parcelRequire.register("3FAnm", function(module, exports) {

$parcel$export(module.exports, "ReservedScope", function () { return $2ac16ae4e97ac475$export$1d2e82cebfd4b08; });
$parcel$export(module.exports, "ReservedResource", function () { return $2ac16ae4e97ac475$export$36ba08a8e14b2df6; });
$parcel$export(module.exports, "UserScope", function () { return $2ac16ae4e97ac475$export$4b02c5b431f6eb78; });
/**
 * @overview Constants for Logto. Synchronized with `@logto/core-kit` package at hash `081094d`.
 */ /** Scopes that reserved by Logto, which will be added to the auth request automatically. */ var $2ac16ae4e97ac475$export$1d2e82cebfd4b08;
(function(ReservedScope) {
    ReservedScope["OpenId"] = "openid";
    ReservedScope["OfflineAccess"] = "offline_access";
})($2ac16ae4e97ac475$export$1d2e82cebfd4b08 || ($2ac16ae4e97ac475$export$1d2e82cebfd4b08 = {}));
/** Resources that reserved by Logto, which cannot be defined by users. */ var $2ac16ae4e97ac475$export$36ba08a8e14b2df6;
(function(ReservedResource) {
    /**
     * The resource for organization template per RFC 0001.
     *
     * @see {@link https://github.com/logto-io/rfcs | RFC 0001} for more details.
     */ ReservedResource["Organization"] = "urn:logto:resource:organizations";
})($2ac16ae4e97ac475$export$36ba08a8e14b2df6 || ($2ac16ae4e97ac475$export$36ba08a8e14b2df6 = {}));
/**
 * Scopes for ID Token and Userinfo Endpoint.
 */ var $2ac16ae4e97ac475$export$4b02c5b431f6eb78;
(function(UserScope) {
    /**
     * Scope for basic user info.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Profile"] = "profile";
    /**
     * Scope for user email address.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Email"] = "email";
    /**
     * Scope for user phone number.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Phone"] = "phone";
    /**
     * Scope for user's custom data.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["CustomData"] = "custom_data";
    /**
     * Scope for user's social identity details.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Identities"] = "identities";
    /**
     * Scope for user's roles.
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Roles"] = "roles";
    /**
     * Scope for user's organization IDs and perform organization token grant per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["Organizations"] = "urn:logto:scope:organizations";
    /**
     * Scope for user's organization roles per [RFC 0001](https://github.com/logto-io/rfcs).
     *
     * See {@link idTokenClaims} for mapped claims in ID Token and {@link userinfoClaims} for additional claims in Userinfo Endpoint.
     */ UserScope["OrganizationRoles"] = "urn:logto:scope:organization_roles";
})($2ac16ae4e97ac475$export$4b02c5b431f6eb78 || ($2ac16ae4e97ac475$export$4b02c5b431f6eb78 = {}));
/**
 * Mapped claims that ID Token includes.
 */ const $2ac16ae4e97ac475$export$f57bb8dda2a18319 = Object.freeze({
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Profile]: [
        "name",
        "picture",
        "username"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Email]: [
        "email",
        "email_verified"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Phone]: [
        "phone_number",
        "phone_number_verified"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Roles]: [
        "roles"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Organizations]: [
        "organizations"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.OrganizationRoles]: [
        "organization_roles"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.CustomData]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Identities]: []
});
/**
 * Additional claims that Userinfo Endpoint returns.
 */ const $2ac16ae4e97ac475$export$c11d5a3385aa71dd = Object.freeze({
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Profile]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Email]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Phone]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Roles]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Organizations]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.OrganizationRoles]: [],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.CustomData]: [
        "custom_data"
    ],
    [$2ac16ae4e97ac475$export$4b02c5b431f6eb78.Identities]: [
        "identities"
    ]
});
const $2ac16ae4e97ac475$export$6c46daeabb0176f9 = Object.freeze(// Hard to infer type directly, use `as` for a workaround.
// eslint-disable-next-line no-restricted-syntax
Object.fromEntries(Object.values($2ac16ae4e97ac475$export$4b02c5b431f6eb78).map((current)=>[
        current,
        [
            ...$2ac16ae4e97ac475$export$f57bb8dda2a18319[current],
            ...$2ac16ae4e97ac475$export$c11d5a3385aa71dd[current]
        ]
    ])));
/**
 * The prefix of the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @example
 * ```
 * urn:logto:organization:123 // organization with ID 123
 * ```
 * @see {@link https://en.wikipedia.org/wiki/Uniform_Resource_Name | Uniform Resource Name}
 */ const $2ac16ae4e97ac475$export$fc38cc6da79faa5c = "urn:logto:organization:";
/**
 * Build the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param organizationId The ID of the organization.
 * @returns The URN for the organization.
 * @see {@link organizationUrnPrefix} for the prefix of the URN.
 * @example
 * ```ts
 * buildOrganizationUrn('1') // returns 'urn:logto:organization:1'
 * ```
 */ const $2ac16ae4e97ac475$export$22667c0b6b2d7fac = (organizationId)=>`${$2ac16ae4e97ac475$export$fc38cc6da79faa5c}${organizationId}`;
/**
 * Get the organization ID from the URN (Uniform Resource Name) for the organization in Logto.
 *
 * @param urn The URN for the organization. Must start with {@link organizationUrnPrefix}.
 * @returns The ID of the organization.
 * @throws {TypeError} If the URN is invalid.
 * @example
 * ```ts
 * getOrganizationIdFromUrn('1') // throws TypeError
 * getOrganizationIdFromUrn('urn:logto:organization:1') // returns '1'
 * ```
 */ const $2ac16ae4e97ac475$export$a237ae1b02e4e718 = (urn)=>{
    if (!urn.startsWith($2ac16ae4e97ac475$export$fc38cc6da79faa5c)) throw new TypeError("Invalid organization URN.");
    return urn.slice($2ac16ae4e97ac475$export$fc38cc6da79faa5c.length);
};

});



parcelRequire.register("7xrzW", function(module, exports) {

$parcel$export(module.exports, "discoveryPath", function () { return $57d1020940ca9a08$export$815bda5ead26b243; });
$parcel$export(module.exports, "fetchOidcConfig", function () { return $57d1020940ca9a08$export$98242d8e822ad11f; });

var $ikvgY = parcelRequire("ikvgY");
const $57d1020940ca9a08$export$815bda5ead26b243 = "/oidc/.well-known/openid-configuration";
const $57d1020940ca9a08$export$98242d8e822ad11f = async (endpoint, requester)=>(0, (/*@__PURE__*/$parcel$interopDefault($ikvgY)))(await requester(endpoint));

});

parcelRequire.register("gNGQN", function(module, exports) {

$parcel$export(module.exports, "revoke", function () { return $c3b2763112a204b8$export$573f8dbbf6fbef75; });

var $6Woc4 = parcelRequire("6Woc4");
const $c3b2763112a204b8$export$573f8dbbf6fbef75 = async (revocationEndpoint, clientId, token, requester)=>requester(revocationEndpoint, {
        method: "POST",
        headers: (0, $6Woc4.ContentType).formUrlEncoded,
        body: new URLSearchParams({
            [(0, $6Woc4.QueryKey).ClientId]: clientId,
            [(0, $6Woc4.QueryKey).Token]: token
        })
    });

});

parcelRequire.register("7yeUb", function(module, exports) {

$parcel$export(module.exports, "generateSignInUri", function () { return $57f7453b73b09302$export$b01a187f12b774c6; });

var $6Woc4 = parcelRequire("6Woc4");
parcelRequire("i6nxh");
parcelRequire("dTynv");

var $fgp9B = parcelRequire("fgp9B");
const $57f7453b73b09302$var$codeChallengeMethod = "S256";
const $57f7453b73b09302$var$responseType = "code";
const $57f7453b73b09302$export$b01a187f12b774c6 = ({ authorizationEndpoint: authorizationEndpoint, clientId: clientId, redirectUri: redirectUri, codeChallenge: codeChallenge, state: state, scopes: scopes, resources: resources, prompt: prompt, interactionMode: interactionMode })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $6Woc4.QueryKey).ClientId]: clientId,
        [(0, $6Woc4.QueryKey).RedirectUri]: redirectUri,
        [(0, $6Woc4.QueryKey).CodeChallenge]: codeChallenge,
        [(0, $6Woc4.QueryKey).CodeChallengeMethod]: $57f7453b73b09302$var$codeChallengeMethod,
        [(0, $6Woc4.QueryKey).State]: state,
        [(0, $6Woc4.QueryKey).ResponseType]: $57f7453b73b09302$var$responseType,
        [(0, $6Woc4.QueryKey).Prompt]: prompt ?? (0, $6Woc4.Prompt).Consent,
        [(0, $6Woc4.QueryKey).Scope]: (0, $fgp9B.withDefaultScopes)(scopes)
    });
    for (const resource of resources ?? [])urlSearchParameters.append((0, $6Woc4.QueryKey).Resource, resource);
    // Set interactionMode to signUp for a create account user experience
    if (interactionMode) urlSearchParameters.append((0, $6Woc4.QueryKey).InteractionMode, interactionMode);
    return `${authorizationEndpoint}?${urlSearchParameters.toString()}`;
};

});
parcelRequire.register("i6nxh", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return (parcelRequire("8A4N0")).deduplicate; });
$parcel$export(module.exports, "conditional", function () { return (parcelRequire("154Ff")).conditional; });
$parcel$export(module.exports, "conditionalString", function () { return (parcelRequire("154Ff")).conditionalString; });
$parcel$export(module.exports, "trySafe", function () { return (parcelRequire("4V8bV")).trySafe; });
$parcel$export(module.exports, "urlSafeBase64", function () { return (parcelRequire("5j2Dg")).urlSafeBase64; });
$parcel$export(module.exports, "isObject", function () { return (parcelRequire("8dGzF")).isObject; });

var $8A4N0 = parcelRequire("8A4N0");

var $chp1o = parcelRequire("chp1o");

var $lUhCK = parcelRequire("lUhCK");

var $154Ff = parcelRequire("154Ff");

var $8FXZo = parcelRequire("8FXZo");

var $4V8bV = parcelRequire("4V8bV");

var $jQZmo = parcelRequire("jQZmo");

var $5j2Dg = parcelRequire("5j2Dg");

var $leyCb = parcelRequire("leyCb");

var $liHh8 = parcelRequire("liHh8");

var $8dGzF = parcelRequire("8dGzF");

var $2Je5h = parcelRequire("2Je5h");

});
parcelRequire.register("8A4N0", function(module, exports) {

$parcel$export(module.exports, "deduplicate", function () { return $63f5669a171edbae$export$6b75200e58bc97d0; });
const $63f5669a171edbae$export$670d48958e84d448 = (value)=>{
    if (value) return Array.isArray(value) ? value : [
        value
    ];
    return [];
};
// Disable FP rules here to use the performant approach while keep the function itself "FP"
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $63f5669a171edbae$export$76d90c956114f2c2 = (times, initial, iterate)=>{
    let result = initial;
    while(times--)result = iterate(result);
    return result;
};
/* eslint-enable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ const $63f5669a171edbae$export$6b75200e58bc97d0 = (array)=>[
        ...new Set(array)
    ];

});

parcelRequire.register("chp1o", function(module, exports) {

$parcel$export(module.exports, "assert", function () { return $8f0a7b4c4ef25a4c$export$a7a9523472993e97; });
// https://github.com/facebook/jest/issues/7547
const $8f0a7b4c4ef25a4c$export$a7a9523472993e97 = (value, error)=>{
    if (!value) // https://github.com/typescript-eslint/typescript-eslint/issues/3814
    // eslint-disable-next-line @typescript-eslint/no-throw-literal
    throw error;
};

});

parcelRequire.register("lUhCK", function(module, exports) {

$parcel$export(module.exports, "notFalsy", function () { return $ff2c7fae75f3c313$export$ccb441c9c5feb3fc; });
// eslint-disable-next-line id-length
const $ff2c7fae75f3c313$var$compareFunction = (a, b)=>{
    if (typeof a === "string" && typeof b === "string") return a.localeCompare(b);
    if (typeof a === "number" && typeof b === "number") return a - b;
    if (typeof a === "boolean" && typeof b === "boolean") return Number(a) - Number(b);
    throw new Error("Unsupported compare type");
};
const $ff2c7fae75f3c313$export$12dc7a11e2f7584e = (array1, array2)=>{
    if (array1.length !== array2.length) return false;
    const sortedA = array1.slice().sort($ff2c7fae75f3c313$var$compareFunction);
    const sortedB = array2.slice().sort($ff2c7fae75f3c313$var$compareFunction);
    return sortedA.every((value, index)=>value === sortedB[index]);
};
// eslint-disable-next-line unicorn/prefer-native-coercion-functions
const $ff2c7fae75f3c313$export$ccb441c9c5feb3fc = (value)=>Boolean(value);
const $ff2c7fae75f3c313$export$b29ea735dcfba3c1 = (value)=>value !== null && value !== undefined;
const $ff2c7fae75f3c313$export$a4f4bb6b1453fff5 = (data, property)=>Object.prototype.hasOwnProperty.call(data, property);
const $ff2c7fae75f3c313$export$fb789885f1f64dd7 = (string)=>Boolean(/[\u3400-\u4DBF\u4E00-\u9FFF\uF900-\uFAFF]/.test(string));

});

parcelRequire.register("154Ff", function(module, exports) {

$parcel$export(module.exports, "conditional", function () { return $0c99e04b1420fe0c$export$c327da55a124987a; });
$parcel$export(module.exports, "conditionalString", function () { return $0c99e04b1420fe0c$export$78aa88a01782ee9d; });

var $lUhCK = parcelRequire("lUhCK");
const $0c99e04b1420fe0c$export$133fc36489ac9add = (exp)=>(0, $lUhCK.notFalsy)(exp) ? exp : null;
/**
 * Conditional return the expression result when it's not {@link Falsy};
 * otherwise return `undefined`.
 *
 * @example
 * ```ts
 * conditional(1 && '2') // '2'
 * conditional(false && '1') // undefined
 * ```
 */ const $0c99e04b1420fe0c$export$c327da55a124987a = (exp)=>(0, $lUhCK.notFalsy)(exp) ? exp : undefined;
/** Alias for {@link conditional}. */ const $0c99e04b1420fe0c$export$7ffafceb12143143 = $0c99e04b1420fe0c$export$c327da55a124987a;
/**
 * Conditional return the stringified expression result (using `String`) when it's not {@link Falsy};
 * otherwise return an empty string.
 *
 * @example
 * ```ts
 * conditionalString(1 && 2) // '2'
 * conditionalString(false && '1') // ''
 * ```
 */ const $0c99e04b1420fe0c$export$78aa88a01782ee9d = (exp)=>(0, $lUhCK.notFalsy)(exp) ? String(exp) : "";
/** Alias for {@link conditionalString}. */ const $0c99e04b1420fe0c$export$723fe479c809eebc = $0c99e04b1420fe0c$export$78aa88a01782ee9d;
/**
 * Conditional concat multiple expression results into a array by filtering all {@link Falsy} results
 * and flatten 1 level deep if the expression result is an array.
 *
 * @example
 * ```ts
 * conditionalArray(1, [2, 3]) // [1, 2, 3]
 * ```
 */ const $0c99e04b1420fe0c$export$c96eff0e57d59a5e = (...exps)=>exps.filter((value)=>(0, $lUhCK.notFalsy)(value)).flat();
/** Alias for {@link conditionalArray}. */ const $0c99e04b1420fe0c$export$68c43792fed28aa6 = $0c99e04b1420fe0c$export$c96eff0e57d59a5e;
/**
 * Return a new object with all {@link Falsy} values removed.
 * This function only performs a shallow removal, i.e. it does not remove
 * {@link Falsy} values nested in objects.
 *
 * @example
 * ```ts
 * conditionalObject({
 *   foo: 'foo',
 *   bar: undefined,
 *   baz: false,
 * }) // { foo: 'foo' }
 * ```
 */ const $0c99e04b1420fe0c$export$6d93be478c042166 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>(0, $lUhCK.notFalsy)(value)));
/** Alias for {@link conditionalObject}. */ const $0c99e04b1420fe0c$export$48ab0026c89e64fa = $0c99e04b1420fe0c$export$6d93be478c042166;

});

parcelRequire.register("8FXZo", function(module, exports) {

$parcel$export(module.exports, "isNode", function () { return $6510afb0ead781b0$export$8ee0fc9ee280b4ee; });

var $chp1o = parcelRequire("chp1o");

var $f9dfJ = parcelRequire("f9dfJ");
// Browsers don't have `process`
// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
const $6510afb0ead781b0$export$4bd44a2aa29d3d6e = (key, fallback = "")=>$f9dfJ?.env[key] ?? fallback;
const $6510afb0ead781b0$export$912b126b3b8a9cf1 = (envKey, fallback = [])=>{
    const rawValue = $6510afb0ead781b0$export$4bd44a2aa29d3d6e(envKey);
    if (!rawValue) return fallback;
    return rawValue.split(",").map((value)=>value.trim()).filter(Boolean);
};
const $6510afb0ead781b0$export$9f11f28d727ba39d = (key)=>{
    // Browsers don't have `process`
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    const value = $f9dfJ?.env[key];
    (0, $chp1o.assert)(value, new Error(`env variable ${key} not found`));
    return value;
};
const $6510afb0ead781b0$export$8ee0fc9ee280b4ee = ()=>typeof window === "undefined";

});

parcelRequire.register("4V8bV", function(module, exports) {

$parcel$export(module.exports, "trySafe", function () { return $3952d6e89bc3467d$export$a3a27526e073307; });
// Intended
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $3952d6e89bc3467d$export$8793edee2d425525 = ()=>{};
const $3952d6e89bc3467d$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";
const $3952d6e89bc3467d$export$2cb2cb98cc670b59 = (exec, onError)=>{
    const handleError = (error)=>{
        if (onError instanceof Error) throw onError;
        return onError(error);
    };
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $3952d6e89bc3467d$export$4369c812aac99591(unwrapped) ? unwrapped.catch(handleError) : unwrapped;
    } catch (error) {
        return handleError(error);
    }
};
const $3952d6e89bc3467d$export$a3a27526e073307 = (exec, onError)=>{
    try {
        const unwrapped = typeof exec === "function" ? exec() : exec;
        return $3952d6e89bc3467d$export$4369c812aac99591(unwrapped) ? unwrapped.catch((error)=>{
            onError?.(error);
        }) : unwrapped;
    } catch (error) {
        onError?.(error);
    }
};

});

parcelRequire.register("jQZmo", function(module, exports) {
const $e742787b146b5f5a$export$357523c63a2253b9 = (object, ...keys)=>{
    // eslint-disable-next-line no-restricted-syntax
    return Object.fromEntries(keys.map((key)=>[
            key,
            object[key]
        ]));
};
const $e742787b146b5f5a$export$42fd73f889ee4d63 = (...keys)=>(state)=>$e742787b146b5f5a$export$357523c63a2253b9(state, ...keys);

});

parcelRequire.register("5j2Dg", function(module, exports) {

$parcel$export(module.exports, "urlSafeBase64", function () { return $3dd0c4d780b94881$export$cf6f352aaefa956f; });

var $8FXZo = parcelRequire("8FXZo");

var $5wduI = parcelRequire("5wduI");
var $3dd0c4d780b94881$require$Buffer = $5wduI.Buffer;
function $3dd0c4d780b94881$export$1294308be85b4eca(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replace(/(?:^|\s|-)\S/g, (value)=>value.toUpperCase()).replace(/-/g, " ");
}
/**
 * RFC 4648 section 5: base64url (URL- and filename-safe standard)
 * @link https://datatracker.ietf.org/doc/html/rfc4648#section-5
 */ const $3dd0c4d780b94881$var$replaceNonUrlSafeCharacters = (base64String)=>base64String.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
const $3dd0c4d780b94881$var$restoreNonUrlSafeCharacters = (base64String)=>base64String.replace(/-/g, "+").replace(/_/g, "/");
const $3dd0c4d780b94881$export$cf6f352aaefa956f = {
    isSafe: (input)=>/^[\w-]*$/.test(input),
    encode: (rawString)=>{
        const encodedString = (0, $8FXZo.isNode)() ? $3dd0c4d780b94881$require$Buffer.from(rawString, "utf8").toString("base64") : window.btoa(unescape(encodeURIComponent(rawString)));
        return $3dd0c4d780b94881$var$replaceNonUrlSafeCharacters(encodedString);
    },
    decode: (encodedString)=>{
        const nonUrlSafeEncodedString = $3dd0c4d780b94881$var$restoreNonUrlSafeCharacters(encodedString);
        return (0, $8FXZo.isNode)() ? $3dd0c4d780b94881$require$Buffer.from(nonUrlSafeEncodedString, "base64").toString("utf8") : decodeURIComponent(escape(window.atob(nonUrlSafeEncodedString)));
    },
    replaceNonUrlSafeCharacters: $3dd0c4d780b94881$var$replaceNonUrlSafeCharacters,
    restoreNonUrlSafeCharacters: $3dd0c4d780b94881$var$restoreNonUrlSafeCharacters
};
const $3dd0c4d780b94881$export$7a668e70ea2210d9 = (value)=>// eslint-disable-next-line no-implicit-coercion
    !!value && [
        "1",
        "true",
        "y",
        "yes",
        "yep",
        "yeah"
    ].includes(value.toLowerCase());

});

parcelRequire.register("leyCb", function(module, exports) {

var $4V8bV = parcelRequire("4V8bV");
const $f755c19861baa64c$export$3988ae62b71be9a3 = (object, keySerial)=>{
    if (object === null || typeof object !== "object") throw new TypeError("Non-object received in `get()`.");
    let result = object;
    for (const key of keySerial.split("."))// @ts-expect-error for performance
    result = result[key];
    return result;
};
const $f755c19861baa64c$export$fedb900c0ea4e699 = (...args)=>(0, $4V8bV.trySafe)(()=>$f755c19861baa64c$export$3988ae62b71be9a3(...args));
/** Same to `get()` but with the strict type definition only to enable IntelliSense. */ const $f755c19861baa64c$export$bf7199a9ebcb84a9 = (object, keySerial)=>$f755c19861baa64c$export$3988ae62b71be9a3(object, keySerial);

});

parcelRequire.register("liHh8", function(module, exports) {
/** Join multiple path segments. This function exists since there's no native implementation in browser. */ const $f81cd906d55c5e0c$export$b891921babc70093 = (...segments)=>{
    const result = [];
    for (const segment of segments.join("/").split("/")){
        if (!segment || segment === ".") continue;
        if ([
            ...segment
        ].every((char)=>char === ".")) {
            // eslint-disable-next-line @silverhand/fp/no-mutating-methods
            result.pop();
            continue;
        }
        // eslint-disable-next-line @silverhand/fp/no-mutating-methods
        result.push(segment);
    }
    return "/" + result.join("/");
};
/** Append path segments to the base URL. */ const $f81cd906d55c5e0c$export$c3cef1c0537c0eb2 = (baseUrl, ...pathnames)=>new URL($f81cd906d55c5e0c$export$b891921babc70093(baseUrl.pathname, ...pathnames), baseUrl);

});

parcelRequire.register("8dGzF", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $5fc09003bb73fff0$export$a6cdc56e425d0d0a; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $5fc09003bb73fff0$export$a6cdc56e425d0d0a = (object)=>object !== null && typeof object === "object";
const $5fc09003bb73fff0$export$dd89c3a817f05bc7 = (object, key)=>$5fc09003bb73fff0$export$a6cdc56e425d0d0a(object) && key in object;
/**
 * Remove all keys with `undefined` values from an object. This function only
 * performs a shallow removal, i.e. it does not remove `undefined` values nested
 * in objects.
 *
 * @param object The object to remove `undefined` keys from.
 * @returns A new object with all `undefined` keys removed.
 */ const $5fc09003bb73fff0$export$8e7457d724841712 = (object)=>// eslint-disable-next-line no-restricted-syntax
    Object.fromEntries(Object.entries(object).filter(([, value])=>value !== undefined));

});

parcelRequire.register("2Je5h", function(module, exports) {
/* eslint-disable @silverhand/fp/no-let, @silverhand/fp/no-mutation */ function $1fcab591bb068495$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}

});


parcelRequire.register("dTynv", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", function () { return (parcelRequire("k3kQX")).jwtVerify; });
$parcel$export(module.exports, "createLocalJWKSet", function () { return (parcelRequire("kAtWh")).createLocalJWKSet; });
$parcel$export(module.exports, "createRemoteJWKSet", function () { return (parcelRequire("54Ouh")).createRemoteJWKSet; });

var $gXCEm = parcelRequire("gXCEm");

var $eFlHe = parcelRequire("eFlHe");

var $4iRJo = parcelRequire("4iRJo");

var $hZRG1 = parcelRequire("hZRG1");

var $br1lm = parcelRequire("br1lm");

var $37HDY = parcelRequire("37HDY");

var $2rjNZ = parcelRequire("2rjNZ");

var $k3kQX = parcelRequire("k3kQX");

var $eKJW3 = parcelRequire("eKJW3");

var $iHeZ7 = parcelRequire("iHeZ7");

var $f85w7 = parcelRequire("f85w7");

var $a0CQJ = parcelRequire("a0CQJ");

var $2pxbd = parcelRequire("2pxbd");

var $84Ai3 = parcelRequire("84Ai3");

var $hzUUu = parcelRequire("hzUUu");

var $hLieE = parcelRequire("hLieE");

var $b4d8K = parcelRequire("b4d8K");

var $bBFuw = parcelRequire("bBFuw");

var $kAtWh = parcelRequire("kAtWh");

var $54Ouh = parcelRequire("54Ouh");

var $2LuaL = parcelRequire("2LuaL");

var $dzQAf = parcelRequire("dzQAf");

var $pGamf = parcelRequire("pGamf");

var $kuFUq = parcelRequire("kuFUq");

var $fZAZQ = parcelRequire("fZAZQ");

var $kuJKd = parcelRequire("kuJKd");

var $3bQx5 = parcelRequire("3bQx5");

var $4Agra = parcelRequire("4Agra");

var $cmD9g = parcelRequire("cmD9g");

var $hPhzz = parcelRequire("hPhzz");

});
parcelRequire.register("gXCEm", function(module, exports) {

$parcel$export(module.exports, "compactDecrypt", function () { return $c590231ceef61db2$export$c9a8efe6bfd872ce; });

var $eFlHe = parcelRequire("eFlHe");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");
async function $c590231ceef61db2$export$c9a8efe6bfd872ce(jwe, key, options) {
    if (jwe instanceof Uint8Array) jwe = (0, $1VVH7.decoder).decode(jwe);
    if (typeof jwe !== "string") throw new (0, $kuJKd.JWEInvalid)("Compact JWE must be a string or Uint8Array");
    const { 0: protectedHeader, 1: encryptedKey, 2: iv, 3: ciphertext, 4: tag, length: length } = jwe.split(".");
    if (length !== 5) throw new (0, $kuJKd.JWEInvalid)("Invalid Compact JWE");
    const decrypted = await (0, $eFlHe.flattenedDecrypt)({
        ciphertext: ciphertext,
        iv: iv || undefined,
        protected: protectedHeader || undefined,
        tag: tag || undefined,
        encrypted_key: encryptedKey || undefined
    }, key, options);
    const result = {
        plaintext: decrypted.plaintext,
        protectedHeader: decrypted.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});
parcelRequire.register("eFlHe", function(module, exports) {

$parcel$export(module.exports, "flattenedDecrypt", function () { return $aad5b96e227635a1$export$b75cd12892ae94d2; });

var $jvlXK = parcelRequire("jvlXK");

var $cVxFG = parcelRequire("cVxFG");

var $kuJKd = parcelRequire("kuJKd");

var $bQd3d = parcelRequire("bQd3d");

var $bMRvC = parcelRequire("bMRvC");

var $eOgKN = parcelRequire("eOgKN");

var $1VVH7 = parcelRequire("1VVH7");

var $8Zsox = parcelRequire("8Zsox");

var $lHxdO = parcelRequire("lHxdO");

var $lkMDw = parcelRequire("lkMDw");
async function $aad5b96e227635a1$export$b75cd12892ae94d2(jwe, key, options) {
    if (!(0, $bMRvC.default)(jwe)) throw new (0, $kuJKd.JWEInvalid)("Flattened JWE must be an object");
    if (jwe.protected === undefined && jwe.header === undefined && jwe.unprotected === undefined) throw new (0, $kuJKd.JWEInvalid)("JOSE Header missing");
    if (typeof jwe.iv !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE Initialization Vector missing or incorrect type");
    if (typeof jwe.ciphertext !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE Ciphertext missing or incorrect type");
    if (typeof jwe.tag !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE Authentication Tag missing or incorrect type");
    if (jwe.protected !== undefined && typeof jwe.protected !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE Protected Header incorrect type");
    if (jwe.encrypted_key !== undefined && typeof jwe.encrypted_key !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key incorrect type");
    if (jwe.aad !== undefined && typeof jwe.aad !== "string") throw new (0, $kuJKd.JWEInvalid)("JWE AAD incorrect type");
    if (jwe.header !== undefined && !(0, $bMRvC.default)(jwe.header)) throw new (0, $kuJKd.JWEInvalid)("JWE Shared Unprotected Header incorrect type");
    if (jwe.unprotected !== undefined && !(0, $bMRvC.default)(jwe.unprotected)) throw new (0, $kuJKd.JWEInvalid)("JWE Per-Recipient Unprotected Header incorrect type");
    let parsedProt;
    if (jwe.protected) try {
        const protectedHeader = (0, $jvlXK.decode)(jwe.protected);
        parsedProt = JSON.parse((0, $1VVH7.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("JWE Protected Header is invalid");
    }
    if (!(0, $bQd3d.default)(parsedProt, jwe.header, jwe.unprotected)) throw new (0, $kuJKd.JWEInvalid)("JWE Protected, JWE Unprotected Header, and JWE Per-Recipient Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jwe.header,
        ...jwe.unprotected
    };
    (0, $lHxdO.default)((0, $kuJKd.JWEInvalid), new Map(), options?.crit, parsedProt, joseHeader);
    if (joseHeader.zip !== undefined) throw new (0, $kuJKd.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
    const { alg: alg, enc: enc } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $kuJKd.JWEInvalid)("missing JWE Algorithm (alg) in JWE Header");
    if (typeof enc !== "string" || !enc) throw new (0, $kuJKd.JWEInvalid)("missing JWE Encryption Algorithm (enc) in JWE Header");
    const keyManagementAlgorithms = options && (0, $lkMDw.default)("keyManagementAlgorithms", options.keyManagementAlgorithms);
    const contentEncryptionAlgorithms = options && (0, $lkMDw.default)("contentEncryptionAlgorithms", options.contentEncryptionAlgorithms);
    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg) || !keyManagementAlgorithms && alg.startsWith("PBES2")) throw new (0, $kuJKd.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) throw new (0, $kuJKd.JOSEAlgNotAllowed)('"enc" (Encryption Algorithm) Header Parameter value not allowed');
    let encryptedKey;
    if (jwe.encrypted_key !== undefined) try {
        encryptedKey = (0, $jvlXK.decode)(jwe.encrypted_key);
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the encrypted_key");
    }
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jwe);
        resolvedKey = true;
    }
    let cek;
    try {
        cek = await (0, $eOgKN.default)(alg, key, encryptedKey, joseHeader, options);
    } catch (err) {
        if (err instanceof TypeError || err instanceof (0, $kuJKd.JWEInvalid) || err instanceof (0, $kuJKd.JOSENotSupported)) throw err;
        cek = (0, $8Zsox.default)(enc);
    }
    let iv;
    let tag;
    try {
        iv = (0, $jvlXK.decode)(jwe.iv);
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the iv");
    }
    try {
        tag = (0, $jvlXK.decode)(jwe.tag);
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the tag");
    }
    const protectedHeader = (0, $1VVH7.encoder).encode(jwe.protected ?? "");
    let additionalData;
    if (jwe.aad !== undefined) additionalData = (0, $1VVH7.concat)(protectedHeader, (0, $1VVH7.encoder).encode("."), (0, $1VVH7.encoder).encode(jwe.aad));
    else additionalData = protectedHeader;
    let ciphertext;
    try {
        ciphertext = (0, $jvlXK.decode)(jwe.ciphertext);
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the ciphertext");
    }
    let plaintext = await (0, $cVxFG.default)(enc, cek, ciphertext, iv, tag, additionalData);
    const result = {
        plaintext: plaintext
    };
    if (jwe.protected !== undefined) result.protectedHeader = parsedProt;
    if (jwe.aad !== undefined) try {
        result.additionalAuthenticatedData = (0, $jvlXK.decode)(jwe.aad);
    } catch  {
        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the aad");
    }
    if (jwe.unprotected !== undefined) result.sharedUnprotectedHeader = jwe.unprotected;
    if (jwe.header !== undefined) result.unprotectedHeader = jwe.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRequire.register("jvlXK", function(module, exports) {

$parcel$export(module.exports, "encodeBase64", function () { return $e331f2e30fcbb219$export$8fb536984ec8b4d7; });
$parcel$export(module.exports, "encode", function () { return $e331f2e30fcbb219$export$c564cdbbe6da493; });
$parcel$export(module.exports, "decodeBase64", function () { return $e331f2e30fcbb219$export$94fdf11bafc8de6b; });
$parcel$export(module.exports, "decode", function () { return $e331f2e30fcbb219$export$2f872c0f2117be69; });

var $1VVH7 = parcelRequire("1VVH7");
const $e331f2e30fcbb219$export$8fb536984ec8b4d7 = (input)=>{
    let unencoded = input;
    if (typeof unencoded === "string") unencoded = (0, $1VVH7.encoder).encode(unencoded);
    const CHUNK_SIZE = 0x8000;
    const arr = [];
    for(let i = 0; i < unencoded.length; i += CHUNK_SIZE)arr.push(String.fromCharCode.apply(null, unencoded.subarray(i, i + CHUNK_SIZE)));
    return btoa(arr.join(""));
};
const $e331f2e30fcbb219$export$c564cdbbe6da493 = (input)=>{
    return $e331f2e30fcbb219$export$8fb536984ec8b4d7(input).replace(/=/g, "").replace(/\+/g, "-").replace(/\//g, "_");
};
const $e331f2e30fcbb219$export$94fdf11bafc8de6b = (encoded)=>{
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for(let i = 0; i < binary.length; i++)bytes[i] = binary.charCodeAt(i);
    return bytes;
};
const $e331f2e30fcbb219$export$2f872c0f2117be69 = (input)=>{
    let encoded = input;
    if (encoded instanceof Uint8Array) encoded = (0, $1VVH7.decoder).decode(encoded);
    encoded = encoded.replace(/-/g, "+").replace(/_/g, "/").replace(/\s/g, "");
    try {
        return $e331f2e30fcbb219$export$94fdf11bafc8de6b(encoded);
    } catch  {
        throw new TypeError("The input to be decoded is not correctly encoded.");
    }
};

});
parcelRequire.register("1VVH7", function(module, exports) {

$parcel$export(module.exports, "encoder", function () { return $1687de3582221164$export$5486af06137bf21a; });
$parcel$export(module.exports, "decoder", function () { return $1687de3582221164$export$124c96e6ce37090b; });
$parcel$export(module.exports, "concat", function () { return $1687de3582221164$export$ee1b3e54f0441b22; });
$parcel$export(module.exports, "p2s", function () { return $1687de3582221164$export$256d3ca12372f112; });
$parcel$export(module.exports, "uint64be", function () { return $1687de3582221164$export$e7b531e00a18fdd7; });
$parcel$export(module.exports, "uint32be", function () { return $1687de3582221164$export$74c16dba6c885532; });
$parcel$export(module.exports, "lengthAndInput", function () { return $1687de3582221164$export$c1498c4a3718d967; });
$parcel$export(module.exports, "concatKdf", function () { return $1687de3582221164$export$67163693c21af44f; });

var $5PYa8 = parcelRequire("5PYa8");
const $1687de3582221164$export$5486af06137bf21a = new TextEncoder();
const $1687de3582221164$export$124c96e6ce37090b = new TextDecoder();
const $1687de3582221164$var$MAX_INT32 = 2 ** 32;
function $1687de3582221164$export$ee1b3e54f0441b22(...buffers) {
    const size = buffers.reduce((acc, { length: length })=>acc + length, 0);
    const buf = new Uint8Array(size);
    let i = 0;
    buffers.forEach((buffer)=>{
        buf.set(buffer, i);
        i += buffer.length;
    });
    return buf;
}
function $1687de3582221164$export$256d3ca12372f112(alg, p2sInput) {
    return $1687de3582221164$export$ee1b3e54f0441b22($1687de3582221164$export$5486af06137bf21a.encode(alg), new Uint8Array([
        0
    ]), p2sInput);
}
function $1687de3582221164$var$writeUInt32BE(buf, value, offset) {
    if (value < 0 || value >= $1687de3582221164$var$MAX_INT32) throw new RangeError(`value must be >= 0 and <= ${$1687de3582221164$var$MAX_INT32 - 1}. Received ${value}`);
    buf.set([
        value >>> 24,
        value >>> 16,
        value >>> 8,
        value & 0xff
    ], offset);
}
function $1687de3582221164$export$e7b531e00a18fdd7(value) {
    const high = Math.floor(value / $1687de3582221164$var$MAX_INT32);
    const low = value % $1687de3582221164$var$MAX_INT32;
    const buf = new Uint8Array(8);
    $1687de3582221164$var$writeUInt32BE(buf, high, 0);
    $1687de3582221164$var$writeUInt32BE(buf, low, 4);
    return buf;
}
function $1687de3582221164$export$74c16dba6c885532(value) {
    const buf = new Uint8Array(4);
    $1687de3582221164$var$writeUInt32BE(buf, value);
    return buf;
}
function $1687de3582221164$export$c1498c4a3718d967(input) {
    return $1687de3582221164$export$ee1b3e54f0441b22($1687de3582221164$export$74c16dba6c885532(input.length), input);
}
async function $1687de3582221164$export$67163693c21af44f(secret, bits, value) {
    const iterations = Math.ceil((bits >> 3) / 32);
    const res = new Uint8Array(iterations * 32);
    for(let iter = 0; iter < iterations; iter++){
        const buf = new Uint8Array(4 + secret.length + value.length);
        buf.set($1687de3582221164$export$74c16dba6c885532(iter + 1));
        buf.set(secret, 4);
        buf.set(value, 4 + secret.length);
        res.set(await (0, $5PYa8.default)("sha256", buf), iter * 32);
    }
    return res.slice(0, bits >> 3);
}

});
parcelRequire.register("5PYa8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $440062296a7c2aa8$export$2e2bcd8739ae039; });

var $5hNwt = parcelRequire("5hNwt");
const $440062296a7c2aa8$var$digest = async (algorithm, data)=>{
    const subtleDigest = `SHA-${algorithm.slice(-3)}`;
    return new Uint8Array(await (0, $5hNwt.default).subtle.digest(subtleDigest, data));
};
var $440062296a7c2aa8$export$2e2bcd8739ae039 = $440062296a7c2aa8$var$digest;

});
parcelRequire.register("5hNwt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d94f473f1d93858$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "isCryptoKey", function () { return $3d94f473f1d93858$export$600b5603bbac4c6; });
var $3d94f473f1d93858$export$2e2bcd8739ae039 = crypto;
const $3d94f473f1d93858$export$600b5603bbac4c6 = (key)=>key instanceof CryptoKey;

});




parcelRequire.register("cVxFG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9694ed57d45346fd$export$2e2bcd8739ae039; });

var $1VVH7 = parcelRequire("1VVH7");

var $iacjz = parcelRequire("iacjz");

var $dcZIb = parcelRequire("dcZIb");

var $kmPRS = parcelRequire("kmPRS");

var $kuJKd = parcelRequire("kuJKd");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
async function $9694ed57d45346fd$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $eU8iv.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $5hNwt.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "decrypt"
    ]);
    const macKey = await (0, $5hNwt.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const macData = (0, $1VVH7.concat)(aad, iv, ciphertext, (0, $1VVH7.uint64be)(aad.length << 3));
    const expectedTag = new Uint8Array((await (0, $5hNwt.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    let macCheckPassed;
    try {
        macCheckPassed = (0, $kmPRS.default)(tag, expectedTag);
    } catch  {}
    if (!macCheckPassed) throw new (0, $kuJKd.JWEDecryptionFailed)();
    let plaintext;
    try {
        plaintext = new Uint8Array(await (0, $5hNwt.default).subtle.decrypt({
            iv: iv,
            name: "AES-CBC"
        }, encKey, ciphertext));
    } catch  {}
    if (!plaintext) throw new (0, $kuJKd.JWEDecryptionFailed)();
    return plaintext;
}
async function $9694ed57d45346fd$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $5hNwt.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "decrypt"
    ]);
    else {
        (0, $eb6en.checkEncCryptoKey)(cek, enc, "decrypt");
        encKey = cek;
    }
    try {
        return new Uint8Array(await (0, $5hNwt.default).subtle.decrypt({
            additionalData: aad,
            iv: iv,
            name: "AES-GCM",
            tagLength: 128
        }, encKey, (0, $1VVH7.concat)(ciphertext, tag)));
    } catch  {
        throw new (0, $kuJKd.JWEDecryptionFailed)();
    }
}
const $9694ed57d45346fd$var$decrypt = async (enc, cek, ciphertext, iv, tag, aad)=>{
    if (!(0, $5hNwt.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $eU8iv.default)(cek, ...(0, $2etxt.types), "Uint8Array"));
    (0, $iacjz.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $dcZIb.default)(cek, parseInt(enc.slice(-3), 10));
            return $9694ed57d45346fd$var$cbcDecrypt(enc, cek, ciphertext, iv, tag, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $dcZIb.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $9694ed57d45346fd$var$gcmDecrypt(enc, cek, ciphertext, iv, tag, aad);
        default:
            throw new (0, $kuJKd.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $9694ed57d45346fd$export$2e2bcd8739ae039 = $9694ed57d45346fd$var$decrypt;

});
parcelRequire.register("iacjz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d392b69dc5b9534b$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");

var $agiw7 = parcelRequire("agiw7");
const $d392b69dc5b9534b$var$checkIvLength = (enc, iv)=>{
    if (iv.length << 3 !== (0, $agiw7.bitLength)(enc)) throw new (0, $kuJKd.JWEInvalid)("Invalid Initialization Vector length");
};
var $d392b69dc5b9534b$export$2e2bcd8739ae039 = $d392b69dc5b9534b$var$checkIvLength;

});
parcelRequire.register("kuJKd", function(module, exports) {

$parcel$export(module.exports, "JOSEError", function () { return $eeba17dfb98cb24b$export$f754d6850d76bf87; });
$parcel$export(module.exports, "JWTClaimValidationFailed", function () { return $eeba17dfb98cb24b$export$f1e14efb908196e9; });
$parcel$export(module.exports, "JWTExpired", function () { return $eeba17dfb98cb24b$export$4b386bf852b7863d; });
$parcel$export(module.exports, "JOSEAlgNotAllowed", function () { return $eeba17dfb98cb24b$export$d51fd7fedeccc338; });
$parcel$export(module.exports, "JOSENotSupported", function () { return $eeba17dfb98cb24b$export$19ddbcbf2016ab28; });
$parcel$export(module.exports, "JWEDecryptionFailed", function () { return $eeba17dfb98cb24b$export$1a57512ad9773b2a; });
$parcel$export(module.exports, "JWEInvalid", function () { return $eeba17dfb98cb24b$export$19f281f2275f6a15; });
$parcel$export(module.exports, "JWSInvalid", function () { return $eeba17dfb98cb24b$export$e838de724af3d116; });
$parcel$export(module.exports, "JWTInvalid", function () { return $eeba17dfb98cb24b$export$936b39ada0bbfceb; });
$parcel$export(module.exports, "JWKInvalid", function () { return $eeba17dfb98cb24b$export$b3992e0f88fb07e3; });
$parcel$export(module.exports, "JWKSInvalid", function () { return $eeba17dfb98cb24b$export$9b22c2a1e2403b8e; });
$parcel$export(module.exports, "JWKSNoMatchingKey", function () { return $eeba17dfb98cb24b$export$3d5ed1a538bed04e; });
$parcel$export(module.exports, "JWKSMultipleMatchingKeys", function () { return $eeba17dfb98cb24b$export$dc036de401a5c284; });
$parcel$export(module.exports, "JWKSTimeout", function () { return $eeba17dfb98cb24b$export$3f30acebf25c04e6; });
$parcel$export(module.exports, "JWSSignatureVerificationFailed", function () { return $eeba17dfb98cb24b$export$c67a0218e7c50378; });
class $eeba17dfb98cb24b$export$f754d6850d76bf87 extends Error {
    static get code() {
        return "ERR_JOSE_GENERIC";
    }
    constructor(message){
        super(message);
        this.code = "ERR_JOSE_GENERIC";
        this.name = this.constructor.name;
        Error.captureStackTrace?.(this, this.constructor);
    }
}
class $eeba17dfb98cb24b$export$f1e14efb908196e9 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_CLAIM_VALIDATION_FAILED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_CLAIM_VALIDATION_FAILED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $eeba17dfb98cb24b$export$4b386bf852b7863d extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    static get code() {
        return "ERR_JWT_EXPIRED";
    }
    constructor(message, claim = "unspecified", reason = "unspecified"){
        super(message);
        this.code = "ERR_JWT_EXPIRED";
        this.claim = claim;
        this.reason = reason;
    }
}
class $eeba17dfb98cb24b$export$d51fd7fedeccc338 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_ALG_NOT_ALLOWED";
    }
    static get code() {
        return "ERR_JOSE_ALG_NOT_ALLOWED";
    }
}
class $eeba17dfb98cb24b$export$19ddbcbf2016ab28 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JOSE_NOT_SUPPORTED";
    }
    static get code() {
        return "ERR_JOSE_NOT_SUPPORTED";
    }
}
class $eeba17dfb98cb24b$export$1a57512ad9773b2a extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_DECRYPTION_FAILED";
        this.message = "decryption operation failed";
    }
    static get code() {
        return "ERR_JWE_DECRYPTION_FAILED";
    }
}
class $eeba17dfb98cb24b$export$19f281f2275f6a15 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWE_INVALID";
    }
    static get code() {
        return "ERR_JWE_INVALID";
    }
}
class $eeba17dfb98cb24b$export$e838de724af3d116 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_INVALID";
    }
    static get code() {
        return "ERR_JWS_INVALID";
    }
}
class $eeba17dfb98cb24b$export$936b39ada0bbfceb extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWT_INVALID";
    }
    static get code() {
        return "ERR_JWT_INVALID";
    }
}
class $eeba17dfb98cb24b$export$b3992e0f88fb07e3 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWK_INVALID";
    }
    static get code() {
        return "ERR_JWK_INVALID";
    }
}
class $eeba17dfb98cb24b$export$9b22c2a1e2403b8e extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_INVALID";
    }
    static get code() {
        return "ERR_JWKS_INVALID";
    }
}
class $eeba17dfb98cb24b$export$3d5ed1a538bed04e extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_NO_MATCHING_KEY";
        this.message = "no applicable key found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_NO_MATCHING_KEY";
    }
}
class $eeba17dfb98cb24b$export$dc036de401a5c284 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
        this.message = "multiple matching keys found in the JSON Web Key Set";
    }
    static get code() {
        return "ERR_JWKS_MULTIPLE_MATCHING_KEYS";
    }
}
Symbol.asyncIterator;
class $eeba17dfb98cb24b$export$3f30acebf25c04e6 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWKS_TIMEOUT";
        this.message = "request timed out";
    }
    static get code() {
        return "ERR_JWKS_TIMEOUT";
    }
}
class $eeba17dfb98cb24b$export$c67a0218e7c50378 extends $eeba17dfb98cb24b$export$f754d6850d76bf87 {
    constructor(){
        super(...arguments);
        this.code = "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
        this.message = "signature verification failed";
    }
    static get code() {
        return "ERR_JWS_SIGNATURE_VERIFICATION_FAILED";
    }
}

});

parcelRequire.register("agiw7", function(module, exports) {

$parcel$export(module.exports, "bitLength", function () { return $7789c32127592d25$export$db433e85ac514a95; });
$parcel$export(module.exports, "default", function () { return $7789c32127592d25$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");

var $5eZQT = parcelRequire("5eZQT");
function $7789c32127592d25$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
        case "A128GCMKW":
        case "A192GCM":
        case "A192GCMKW":
        case "A256GCM":
        case "A256GCMKW":
            return 96;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            return 128;
        default:
            throw new (0, $kuJKd.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $7789c32127592d25$export$2e2bcd8739ae039 = (alg)=>(0, $5eZQT.default)(new Uint8Array($7789c32127592d25$export$db433e85ac514a95(alg) >> 3));

});
parcelRequire.register("5eZQT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d0e3d1a389ec32d$export$2e2bcd8739ae039; });

var $5hNwt = parcelRequire("5hNwt");
var $3d0e3d1a389ec32d$export$2e2bcd8739ae039 = (0, $5hNwt.default).getRandomValues.bind((0, $5hNwt.default));

});



parcelRequire.register("dcZIb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99dc4400ca664b40$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
const $99dc4400ca664b40$var$checkCekLength = (cek, expected)=>{
    const actual = cek.byteLength << 3;
    if (actual !== expected) throw new (0, $kuJKd.JWEInvalid)(`Invalid Content Encryption Key length. Expected ${expected} bits, got ${actual} bits`);
};
var $99dc4400ca664b40$export$2e2bcd8739ae039 = $99dc4400ca664b40$var$checkCekLength;

});

parcelRequire.register("kmPRS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed3e18a5ae97c80a$export$2e2bcd8739ae039; });
const $ed3e18a5ae97c80a$var$timingSafeEqual = (a, b)=>{
    if (!(a instanceof Uint8Array)) throw new TypeError("First argument must be a buffer");
    if (!(b instanceof Uint8Array)) throw new TypeError("Second argument must be a buffer");
    if (a.length !== b.length) throw new TypeError("Input buffers must have the same length");
    const len = a.length;
    let out = 0;
    let i = -1;
    while(++i < len)out |= a[i] ^ b[i];
    return out === 0;
};
var $ed3e18a5ae97c80a$export$2e2bcd8739ae039 = $ed3e18a5ae97c80a$var$timingSafeEqual;

});

parcelRequire.register("eb6en", function(module, exports) {

$parcel$export(module.exports, "checkSigCryptoKey", function () { return $a526ed1a9f7ad008$export$39a36029eee6729; });
$parcel$export(module.exports, "checkEncCryptoKey", function () { return $a526ed1a9f7ad008$export$41a67f89f6678b35; });
function $a526ed1a9f7ad008$var$unusable(name, prop = "algorithm.name") {
    return new TypeError(`CryptoKey does not support this operation, its ${prop} must be ${name}`);
}
function $a526ed1a9f7ad008$var$isAlgorithm(algorithm, name) {
    return algorithm.name === name;
}
function $a526ed1a9f7ad008$var$getHashLength(hash) {
    return parseInt(hash.name.slice(4), 10);
}
function $a526ed1a9f7ad008$var$getNamedCurve(alg) {
    switch(alg){
        case "ES256":
            return "P-256";
        case "ES384":
            return "P-384";
        case "ES512":
            return "P-521";
        default:
            throw new Error("unreachable");
    }
}
function $a526ed1a9f7ad008$var$checkUsage(key, usages) {
    if (usages.length && !usages.some((expected)=>key.usages.includes(expected))) {
        let msg = "CryptoKey does not support this operation, its usages must include ";
        if (usages.length > 2) {
            const last = usages.pop();
            msg += `one of ${usages.join(", ")}, or ${last}.`;
        } else if (usages.length === 2) msg += `one of ${usages[0]} or ${usages[1]}.`;
        else msg += `${usages[0]}.`;
        throw new TypeError(msg);
    }
}
function $a526ed1a9f7ad008$export$39a36029eee6729(key, alg, ...usages) {
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "HMAC")) throw $a526ed1a9f7ad008$var$unusable("HMAC");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $a526ed1a9f7ad008$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "RS256":
        case "RS384":
        case "RS512":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "RSASSA-PKCS1-v1_5")) throw $a526ed1a9f7ad008$var$unusable("RSASSA-PKCS1-v1_5");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $a526ed1a9f7ad008$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "PS256":
        case "PS384":
        case "PS512":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "RSA-PSS")) throw $a526ed1a9f7ad008$var$unusable("RSA-PSS");
                const expected = parseInt(alg.slice(2), 10);
                const actual = $a526ed1a9f7ad008$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        case "EdDSA":
            if (key.algorithm.name !== "Ed25519" && key.algorithm.name !== "Ed448") throw $a526ed1a9f7ad008$var$unusable("Ed25519 or Ed448");
            break;
        case "ES256":
        case "ES384":
        case "ES512":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "ECDSA")) throw $a526ed1a9f7ad008$var$unusable("ECDSA");
                const expected = $a526ed1a9f7ad008$var$getNamedCurve(alg);
                const actual = key.algorithm.namedCurve;
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(expected, "algorithm.namedCurve");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $a526ed1a9f7ad008$var$checkUsage(key, usages);
}
function $a526ed1a9f7ad008$export$41a67f89f6678b35(key, alg, ...usages) {
    switch(alg){
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "AES-GCM")) throw $a526ed1a9f7ad008$var$unusable("AES-GCM");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(expected, "algorithm.length");
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "AES-KW")) throw $a526ed1a9f7ad008$var$unusable("AES-KW");
                const expected = parseInt(alg.slice(1, 4), 10);
                const actual = key.algorithm.length;
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(expected, "algorithm.length");
                break;
            }
        case "ECDH":
            switch(key.algorithm.name){
                case "ECDH":
                case "X25519":
                case "X448":
                    break;
                default:
                    throw $a526ed1a9f7ad008$var$unusable("ECDH, X25519, or X448");
            }
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "PBKDF2")) throw $a526ed1a9f7ad008$var$unusable("PBKDF2");
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            {
                if (!$a526ed1a9f7ad008$var$isAlgorithm(key.algorithm, "RSA-OAEP")) throw $a526ed1a9f7ad008$var$unusable("RSA-OAEP");
                const expected = parseInt(alg.slice(9), 10) || 1;
                const actual = $a526ed1a9f7ad008$var$getHashLength(key.algorithm.hash);
                if (actual !== expected) throw $a526ed1a9f7ad008$var$unusable(`SHA-${expected}`, "algorithm.hash");
                break;
            }
        default:
            throw new TypeError("CryptoKey does not support this operation");
    }
    $a526ed1a9f7ad008$var$checkUsage(key, usages);
}

});

parcelRequire.register("eU8iv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ad9cbb5cabd6a63e$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "withAlg", function () { return $ad9cbb5cabd6a63e$export$e94f758d09bc1828; });
function $ad9cbb5cabd6a63e$var$message(msg, actual, ...types) {
    if (types.length > 2) {
        const last = types.pop();
        msg += `one of type ${types.join(", ")}, or ${last}.`;
    } else if (types.length === 2) msg += `one of type ${types[0]} or ${types[1]}.`;
    else msg += `of type ${types[0]}.`;
    if (actual == null) msg += ` Received ${actual}`;
    else if (typeof actual === "function" && actual.name) msg += ` Received function ${actual.name}`;
    else if (typeof actual === "object" && actual != null) {
        if (actual.constructor && actual.constructor.name) msg += ` Received an instance of ${actual.constructor.name}`;
    }
    return msg;
}
var $ad9cbb5cabd6a63e$export$2e2bcd8739ae039 = (actual, ...types)=>{
    return $ad9cbb5cabd6a63e$var$message("Key must be ", actual, ...types);
};
function $ad9cbb5cabd6a63e$export$e94f758d09bc1828(alg, actual, ...types) {
    return $ad9cbb5cabd6a63e$var$message(`Key for the ${alg} algorithm must be `, actual, ...types);
}

});

parcelRequire.register("2etxt", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1a03cd5d25bc0c45$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "types", function () { return $1a03cd5d25bc0c45$export$b14ad400b1d09e0f; });

var $5hNwt = parcelRequire("5hNwt");
var $1a03cd5d25bc0c45$export$2e2bcd8739ae039 = (key)=>{
    return (0, $5hNwt.isCryptoKey)(key);
};
const $1a03cd5d25bc0c45$export$b14ad400b1d09e0f = [
    "CryptoKey"
];

});


parcelRequire.register("bQd3d", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $89eeaca7ebd678af$export$2e2bcd8739ae039; });
const $89eeaca7ebd678af$var$isDisjoint = (...headers)=>{
    const sources = headers.filter(Boolean);
    if (sources.length === 0 || sources.length === 1) return true;
    let acc;
    for (const header of sources){
        const parameters = Object.keys(header);
        if (!acc || acc.size === 0) {
            acc = new Set(parameters);
            continue;
        }
        for (const parameter of parameters){
            if (acc.has(parameter)) return false;
            acc.add(parameter);
        }
    }
    return true;
};
var $89eeaca7ebd678af$export$2e2bcd8739ae039 = $89eeaca7ebd678af$var$isDisjoint;

});

parcelRequire.register("bMRvC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894daf27c24527a2$export$2e2bcd8739ae039; });
function $894daf27c24527a2$var$isObjectLike(value) {
    return typeof value === "object" && value !== null;
}
function $894daf27c24527a2$export$2e2bcd8739ae039(input) {
    if (!$894daf27c24527a2$var$isObjectLike(input) || Object.prototype.toString.call(input) !== "[object Object]") return false;
    if (Object.getPrototypeOf(input) === null) return true;
    let proto = input;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(input) === proto;
}

});

parcelRequire.register("eOgKN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ac82bb2d25473a07$export$2e2bcd8739ae039; });

var $ex2OT = parcelRequire("ex2OT");

var $2ilTp = parcelRequire("2ilTp");

var $7abkg = parcelRequire("7abkg");

var $c5Ykk = parcelRequire("c5Ykk");

var $jvlXK = parcelRequire("jvlXK");

var $kuJKd = parcelRequire("kuJKd");

var $8Zsox = parcelRequire("8Zsox");

var $pGamf = parcelRequire("pGamf");

var $2zSnc = parcelRequire("2zSnc");

var $bMRvC = parcelRequire("bMRvC");

var $65iIP = parcelRequire("65iIP");
async function $ac82bb2d25473a07$var$decryptKeyManagement(alg, key, encryptedKey, joseHeader, options) {
    (0, $2zSnc.default)(alg, key, "decrypt");
    switch(alg){
        case "dir":
            if (encryptedKey !== undefined) throw new (0, $kuJKd.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
            return key;
        case "ECDH-ES":
            if (encryptedKey !== undefined) throw new (0, $kuJKd.JWEInvalid)("Encountered unexpected JWE Encrypted Key");
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!(0, $bMRvC.default)(joseHeader.epk)) throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "epk" (Ephemeral Public Key) missing or invalid`);
                if (!$2ilTp.ecdhAllowed(key)) throw new (0, $kuJKd.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const epk = await (0, $pGamf.importJWK)(joseHeader.epk, alg);
                let partyUInfo;
                let partyVInfo;
                if (joseHeader.apu !== undefined) {
                    if (typeof joseHeader.apu !== "string") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "apu" (Agreement PartyUInfo) invalid`);
                    try {
                        partyUInfo = (0, $jvlXK.decode)(joseHeader.apu);
                    } catch  {
                        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the apu");
                    }
                }
                if (joseHeader.apv !== undefined) {
                    if (typeof joseHeader.apv !== "string") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "apv" (Agreement PartyVInfo) invalid`);
                    try {
                        partyVInfo = (0, $jvlXK.decode)(joseHeader.apv);
                    } catch  {
                        throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the apv");
                    }
                }
                const sharedSecret = await $2ilTp.deriveKey(epk, key, alg === "ECDH-ES" ? joseHeader.enc : alg, alg === "ECDH-ES" ? (0, $8Zsox.bitLength)(joseHeader.enc) : parseInt(alg.slice(-5, -2), 10), partyUInfo, partyVInfo);
                if (alg === "ECDH-ES") return sharedSecret;
                if (encryptedKey === undefined) throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key missing");
                return (0, $ex2OT.unwrap)(alg.slice(-6), sharedSecret, encryptedKey);
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            if (encryptedKey === undefined) throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $c5Ykk.decrypt)(alg, key, encryptedKey);
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                if (encryptedKey === undefined) throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.p2c !== "number") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) missing or invalid`);
                const p2cLimit = options?.maxPBES2Count || 10000;
                if (joseHeader.p2c > p2cLimit) throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds`);
                if (typeof joseHeader.p2s !== "string") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "p2s" (PBES2 Salt) missing or invalid`);
                let p2s;
                try {
                    p2s = (0, $jvlXK.decode)(joseHeader.p2s);
                } catch  {
                    throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the p2s");
                }
                return (0, $7abkg.decrypt)(alg, key, encryptedKey, joseHeader.p2c, p2s);
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            if (encryptedKey === undefined) throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key missing");
            return (0, $ex2OT.unwrap)(alg, key, encryptedKey);
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                if (encryptedKey === undefined) throw new (0, $kuJKd.JWEInvalid)("JWE Encrypted Key missing");
                if (typeof joseHeader.iv !== "string") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "iv" (Initialization Vector) missing or invalid`);
                if (typeof joseHeader.tag !== "string") throw new (0, $kuJKd.JWEInvalid)(`JOSE Header "tag" (Authentication Tag) missing or invalid`);
                let iv;
                try {
                    iv = (0, $jvlXK.decode)(joseHeader.iv);
                } catch  {
                    throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the iv");
                }
                let tag;
                try {
                    tag = (0, $jvlXK.decode)(joseHeader.tag);
                } catch  {
                    throw new (0, $kuJKd.JWEInvalid)("Failed to base64url decode the tag");
                }
                return (0, $65iIP.unwrap)(alg, key, encryptedKey, iv, tag);
            }
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
}
var $ac82bb2d25473a07$export$2e2bcd8739ae039 = $ac82bb2d25473a07$var$decryptKeyManagement;

});
parcelRequire.register("ex2OT", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $a94655b9c6264b94$export$4997ffc0176396a6; });
$parcel$export(module.exports, "unwrap", function () { return $a94655b9c6264b94$export$debb760848ca95a; });

var $3CXgO = parcelRequire("3CXgO");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
function $a94655b9c6264b94$var$checkKeySize(key, alg) {
    if (key.algorithm.length !== parseInt(alg.slice(1, 4), 10)) throw new TypeError(`Invalid key size for alg: ${alg}`);
}
function $a94655b9c6264b94$var$getCryptoKey(key, alg, usage) {
    if ((0, $5hNwt.isCryptoKey)(key)) {
        (0, $eb6en.checkEncCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) return (0, $5hNwt.default).subtle.importKey("raw", key, "AES-KW", true, [
        usage
    ]);
    throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types), "Uint8Array"));
}
const $a94655b9c6264b94$export$4997ffc0176396a6 = async (alg, key, cek)=>{
    const cryptoKey = await $a94655b9c6264b94$var$getCryptoKey(key, alg, "wrapKey");
    $a94655b9c6264b94$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $5hNwt.default).subtle.importKey("raw", cek, ...(0, $3CXgO.default));
    return new Uint8Array(await (0, $5hNwt.default).subtle.wrapKey("raw", cryptoKeyCek, cryptoKey, "AES-KW"));
};
const $a94655b9c6264b94$export$debb760848ca95a = async (alg, key, encryptedKey)=>{
    const cryptoKey = await $a94655b9c6264b94$var$getCryptoKey(key, alg, "unwrapKey");
    $a94655b9c6264b94$var$checkKeySize(cryptoKey, alg);
    const cryptoKeyCek = await (0, $5hNwt.default).subtle.unwrapKey("raw", encryptedKey, cryptoKey, "AES-KW", ...(0, $3CXgO.default));
    return new Uint8Array(await (0, $5hNwt.default).subtle.exportKey("raw", cryptoKeyCek));
};

});
parcelRequire.register("3CXgO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2a42e58297290955$export$2e2bcd8739ae039; });
const $2a42e58297290955$var$bogusWebCrypto = [
    {
        hash: "SHA-256",
        name: "HMAC"
    },
    true,
    [
        "sign"
    ]
];
var $2a42e58297290955$export$2e2bcd8739ae039 = $2a42e58297290955$var$bogusWebCrypto;

});


parcelRequire.register("2ilTp", function(module, exports) {

$parcel$export(module.exports, "deriveKey", function () { return $1abe3e9e73b34e24$export$87770b6b245073b5; });
$parcel$export(module.exports, "generateEpk", function () { return $1abe3e9e73b34e24$export$1338dee8c889e310; });
$parcel$export(module.exports, "ecdhAllowed", function () { return $1abe3e9e73b34e24$export$f28ab77d793719b2; });

var $1VVH7 = parcelRequire("1VVH7");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
async function $1abe3e9e73b34e24$export$87770b6b245073b5(publicKey, privateKey, algorithm, keyLength, apu = new Uint8Array(0), apv = new Uint8Array(0)) {
    if (!(0, $5hNwt.isCryptoKey)(publicKey)) throw new TypeError((0, $eU8iv.default)(publicKey, ...(0, $2etxt.types)));
    (0, $eb6en.checkEncCryptoKey)(publicKey, "ECDH");
    if (!(0, $5hNwt.isCryptoKey)(privateKey)) throw new TypeError((0, $eU8iv.default)(privateKey, ...(0, $2etxt.types)));
    (0, $eb6en.checkEncCryptoKey)(privateKey, "ECDH", "deriveBits");
    const value = (0, $1VVH7.concat)((0, $1VVH7.lengthAndInput)((0, $1VVH7.encoder).encode(algorithm)), (0, $1VVH7.lengthAndInput)(apu), (0, $1VVH7.lengthAndInput)(apv), (0, $1VVH7.uint32be)(keyLength));
    let length;
    if (publicKey.algorithm.name === "X25519") length = 256;
    else if (publicKey.algorithm.name === "X448") length = 448;
    else length = Math.ceil(parseInt(publicKey.algorithm.namedCurve.substr(-3), 10) / 8) << 3;
    const sharedSecret = new Uint8Array(await (0, $5hNwt.default).subtle.deriveBits({
        name: publicKey.algorithm.name,
        public: publicKey
    }, privateKey, length));
    return (0, $1VVH7.concatKdf)(sharedSecret, keyLength, value);
}
async function $1abe3e9e73b34e24$export$1338dee8c889e310(key) {
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
    return (0, $5hNwt.default).subtle.generateKey(key.algorithm, true, [
        "deriveBits"
    ]);
}
function $1abe3e9e73b34e24$export$f28ab77d793719b2(key) {
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
    return [
        "P-256",
        "P-384",
        "P-521"
    ].includes(key.algorithm.namedCurve) || key.algorithm.name === "X25519" || key.algorithm.name === "X448";
}

});

parcelRequire.register("7abkg", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $537240a0b671f93b$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $537240a0b671f93b$export$e85a0c9a1067c5d3; });

var $5eZQT = parcelRequire("5eZQT");

var $1VVH7 = parcelRequire("1VVH7");

var $jvlXK = parcelRequire("jvlXK");

var $ex2OT = parcelRequire("ex2OT");

var $cy4Cb = parcelRequire("cy4Cb");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
function $537240a0b671f93b$var$getCryptoKey(key, alg) {
    if (key instanceof Uint8Array) return (0, $5hNwt.default).subtle.importKey("raw", key, "PBKDF2", false, [
        "deriveBits"
    ]);
    if ((0, $5hNwt.isCryptoKey)(key)) {
        (0, $eb6en.checkEncCryptoKey)(key, alg, "deriveBits", "deriveKey");
        return key;
    }
    throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types), "Uint8Array"));
}
async function $537240a0b671f93b$var$deriveKey(p2s, alg, p2c, key) {
    (0, $cy4Cb.default)(p2s);
    const salt = (0, $1VVH7.p2s)(alg, p2s);
    const keylen = parseInt(alg.slice(13, 16), 10);
    const subtleAlg = {
        hash: `SHA-${alg.slice(8, 11)}`,
        iterations: p2c,
        name: "PBKDF2",
        salt: salt
    };
    const wrapAlg = {
        length: keylen,
        name: "AES-KW"
    };
    const cryptoKey = await $537240a0b671f93b$var$getCryptoKey(key, alg);
    if (cryptoKey.usages.includes("deriveBits")) return new Uint8Array(await (0, $5hNwt.default).subtle.deriveBits(subtleAlg, cryptoKey, keylen));
    if (cryptoKey.usages.includes("deriveKey")) return (0, $5hNwt.default).subtle.deriveKey(subtleAlg, cryptoKey, wrapAlg, false, [
        "wrapKey",
        "unwrapKey"
    ]);
    throw new TypeError('PBKDF2 key "usages" must include "deriveBits" or "deriveKey"');
}
const $537240a0b671f93b$export$5b0f6292f11d1d18 = async (alg, key, cek, p2c = 2048, p2s = (0, $5eZQT.default)(new Uint8Array(16)))=>{
    const derived = await $537240a0b671f93b$var$deriveKey(p2s, alg, p2c, key);
    const encryptedKey = await (0, $ex2OT.wrap)(alg.slice(-6), derived, cek);
    return {
        encryptedKey: encryptedKey,
        p2c: p2c,
        p2s: (0, $jvlXK.encode)(p2s)
    };
};
const $537240a0b671f93b$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey, p2c, p2s)=>{
    const derived = await $537240a0b671f93b$var$deriveKey(p2s, alg, p2c, key);
    return (0, $ex2OT.unwrap)(alg.slice(-6), derived, encryptedKey);
};

});
parcelRequire.register("cy4Cb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $922c3d6f836f38b8$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
function $922c3d6f836f38b8$export$2e2bcd8739ae039(p2s) {
    if (!(p2s instanceof Uint8Array) || p2s.length < 8) throw new (0, $kuJKd.JWEInvalid)("PBES2 Salt Input must be 8 or more octets");
}

});


parcelRequire.register("c5Ykk", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $8ce4bf525cfd9a33$export$5b0f6292f11d1d18; });
$parcel$export(module.exports, "decrypt", function () { return $8ce4bf525cfd9a33$export$e85a0c9a1067c5d3; });

var $4Flf9 = parcelRequire("4Flf9");

var $3CXgO = parcelRequire("3CXgO");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $gsq4n = parcelRequire("gsq4n");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
const $8ce4bf525cfd9a33$export$5b0f6292f11d1d18 = async (alg, key, cek)=>{
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
    (0, $eb6en.checkEncCryptoKey)(key, alg, "encrypt", "wrapKey");
    (0, $gsq4n.default)(alg, key);
    if (key.usages.includes("encrypt")) return new Uint8Array(await (0, $5hNwt.default).subtle.encrypt((0, $4Flf9.default)(alg), key, cek));
    if (key.usages.includes("wrapKey")) {
        const cryptoKeyCek = await (0, $5hNwt.default).subtle.importKey("raw", cek, ...(0, $3CXgO.default));
        return new Uint8Array(await (0, $5hNwt.default).subtle.wrapKey("raw", cryptoKeyCek, key, (0, $4Flf9.default)(alg)));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "encrypt" or "wrapKey" for this operation');
};
const $8ce4bf525cfd9a33$export$e85a0c9a1067c5d3 = async (alg, key, encryptedKey)=>{
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
    (0, $eb6en.checkEncCryptoKey)(key, alg, "decrypt", "unwrapKey");
    (0, $gsq4n.default)(alg, key);
    if (key.usages.includes("decrypt")) return new Uint8Array(await (0, $5hNwt.default).subtle.decrypt((0, $4Flf9.default)(alg), key, encryptedKey));
    if (key.usages.includes("unwrapKey")) {
        const cryptoKeyCek = await (0, $5hNwt.default).subtle.unwrapKey("raw", encryptedKey, key, (0, $4Flf9.default)(alg), ...(0, $3CXgO.default));
        return new Uint8Array(await (0, $5hNwt.default).subtle.exportKey("raw", cryptoKeyCek));
    }
    throw new TypeError('RSA-OAEP key "usages" must include "decrypt" or "unwrapKey" for this operation');
};

});
parcelRequire.register("4Flf9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $365b783bbb06ff80$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
function $365b783bbb06ff80$export$2e2bcd8739ae039(alg) {
    switch(alg){
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            return "RSA-OAEP";
        default:
            throw new (0, $kuJKd.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRequire.register("gsq4n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bfb37bbf26b8d2cf$export$2e2bcd8739ae039; });
var $bfb37bbf26b8d2cf$export$2e2bcd8739ae039 = (alg, key)=>{
    if (alg.startsWith("RS") || alg.startsWith("PS")) {
        const { modulusLength: modulusLength } = key.algorithm;
        if (typeof modulusLength !== "number" || modulusLength < 2048) throw new TypeError(`${alg} requires key modulusLength to be 2048 bits or larger`);
    }
};

});


parcelRequire.register("8Zsox", function(module, exports) {

$parcel$export(module.exports, "bitLength", function () { return $68ba0bd33f9d776e$export$db433e85ac514a95; });
$parcel$export(module.exports, "default", function () { return $68ba0bd33f9d776e$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");

var $5eZQT = parcelRequire("5eZQT");
function $68ba0bd33f9d776e$export$db433e85ac514a95(alg) {
    switch(alg){
        case "A128GCM":
            return 128;
        case "A192GCM":
            return 192;
        case "A256GCM":
        case "A128CBC-HS256":
            return 256;
        case "A192CBC-HS384":
            return 384;
        case "A256CBC-HS512":
            return 512;
        default:
            throw new (0, $kuJKd.JOSENotSupported)(`Unsupported JWE Algorithm: ${alg}`);
    }
}
var $68ba0bd33f9d776e$export$2e2bcd8739ae039 = (alg)=>(0, $5eZQT.default)(new Uint8Array($68ba0bd33f9d776e$export$db433e85ac514a95(alg) >> 3));

});

parcelRequire.register("pGamf", function(module, exports) {

$parcel$export(module.exports, "importJWK", function () { return $04d30b374dd51aa9$export$2b70d37b4d0b888b; });

var $jvlXK = parcelRequire("jvlXK");

var $aATqH = parcelRequire("aATqH");

var $fi1tm = parcelRequire("fi1tm");

var $kuJKd = parcelRequire("kuJKd");

var $bMRvC = parcelRequire("bMRvC");
async function $04d30b374dd51aa9$export$7cdfc961c11d0266(spki, alg, options) {
    if (typeof spki !== "string" || spki.indexOf("-----BEGIN PUBLIC KEY-----") !== 0) throw new TypeError('"spki" must be SPKI formatted string');
    return (0, $aATqH.fromSPKI)(spki, alg, options);
}
async function $04d30b374dd51aa9$export$948757ecbbf4a918(x509, alg, options) {
    if (typeof x509 !== "string" || x509.indexOf("-----BEGIN CERTIFICATE-----") !== 0) throw new TypeError('"x509" must be X.509 formatted string');
    return (0, $aATqH.fromX509)(x509, alg, options);
}
async function $04d30b374dd51aa9$export$17f5e7f6d2848df5(pkcs8, alg, options) {
    if (typeof pkcs8 !== "string" || pkcs8.indexOf("-----BEGIN PRIVATE KEY-----") !== 0) throw new TypeError('"pkcs8" must be PKCS#8 formatted string');
    return (0, $aATqH.fromPKCS8)(pkcs8, alg, options);
}
async function $04d30b374dd51aa9$export$2b70d37b4d0b888b(jwk, alg) {
    if (!(0, $bMRvC.default)(jwk)) throw new TypeError("JWK must be an object");
    alg || (alg = jwk.alg);
    switch(jwk.kty){
        case "oct":
            if (typeof jwk.k !== "string" || !jwk.k) throw new TypeError('missing "k" (Key Value) Parameter value');
            return (0, $jvlXK.decode)(jwk.k);
        case "RSA":
            if (jwk.oth !== undefined) throw new (0, $kuJKd.JOSENotSupported)('RSA JWK "oth" (Other Primes Info) Parameter value is not supported');
        case "EC":
        case "OKP":
            return (0, $fi1tm.default)({
                ...jwk,
                alg: alg
            });
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Unsupported "kty" (Key Type) Parameter value');
    }
}

});
parcelRequire.register("aATqH", function(module, exports) {

$parcel$export(module.exports, "toSPKI", function () { return $7b68435a821fcd40$export$cfba7e924fe414ca; });
$parcel$export(module.exports, "toPKCS8", function () { return $7b68435a821fcd40$export$cac76a78a90b914d; });
$parcel$export(module.exports, "fromPKCS8", function () { return $7b68435a821fcd40$export$224b0a6339c7267f; });
$parcel$export(module.exports, "fromSPKI", function () { return $7b68435a821fcd40$export$f9a3505cdaa1fb3e; });
$parcel$export(module.exports, "fromX509", function () { return $7b68435a821fcd40$export$ed788b6a8533858f; });

var $5hNwt = parcelRequire("5hNwt");

var $eU8iv = parcelRequire("eU8iv");

var $jvlXK = parcelRequire("jvlXK");

var $4bYMT = parcelRequire("4bYMT");

var $kuJKd = parcelRequire("kuJKd");

var $2etxt = parcelRequire("2etxt");
const $7b68435a821fcd40$var$genericExport = async (keyType, keyFormat, key)=>{
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
    if (!key.extractable) throw new TypeError("CryptoKey is not extractable");
    if (key.type !== keyType) throw new TypeError(`key is not a ${keyType} key`);
    return (0, $4bYMT.default)((0, $jvlXK.encodeBase64)(new Uint8Array(await (0, $5hNwt.default).subtle.exportKey(keyFormat, key))), `${keyType.toUpperCase()} KEY`);
};
const $7b68435a821fcd40$export$cfba7e924fe414ca = (key)=>{
    return $7b68435a821fcd40$var$genericExport("public", "spki", key);
};
const $7b68435a821fcd40$export$cac76a78a90b914d = (key)=>{
    return $7b68435a821fcd40$var$genericExport("private", "pkcs8", key);
};
const $7b68435a821fcd40$var$findOid = (keyData, oid, from = 0)=>{
    if (from === 0) {
        oid.unshift(oid.length);
        oid.unshift(0x06);
    }
    let i = keyData.indexOf(oid[0], from);
    if (i === -1) return false;
    const sub = keyData.subarray(i, i + oid.length);
    if (sub.length !== oid.length) return false;
    return sub.every((value, index)=>value === oid[index]) || $7b68435a821fcd40$var$findOid(keyData, oid, i + 1);
};
const $7b68435a821fcd40$var$getNamedCurve = (keyData)=>{
    switch(true){
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2a,
            0x86,
            0x48,
            0xce,
            0x3d,
            0x03,
            0x01,
            0x07
        ]):
            return "P-256";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x22
        ]):
            return "P-384";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x81,
            0x04,
            0x00,
            0x23
        ]):
            return "P-521";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6e
        ]):
            return "X25519";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x65,
            0x6f
        ]):
            return "X448";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x65,
            0x70
        ]):
            return "Ed25519";
        case $7b68435a821fcd40$var$findOid(keyData, [
            0x2b,
            0x65,
            0x71
        ]):
            return "Ed448";
        default:
            throw new (0, $kuJKd.JOSENotSupported)("Invalid or unsupported EC Key Curve or OKP Key Sub Type");
    }
};
const $7b68435a821fcd40$var$genericImport = async (replace, keyFormat, pem, alg, options)=>{
    let algorithm;
    let keyUsages;
    const keyData = new Uint8Array(atob(pem.replace(replace, "")).split("").map((c)=>c.charCodeAt(0)));
    const isPublic = keyFormat === "spki";
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`
            };
            keyUsages = isPublic ? [
                "encrypt",
                "wrapKey"
            ] : [
                "decrypt",
                "unwrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                const namedCurve = $7b68435a821fcd40$var$getNamedCurve(keyData);
                algorithm = namedCurve.startsWith("P-") ? {
                    name: "ECDH",
                    namedCurve: namedCurve
                } : {
                    name: namedCurve
                };
                keyUsages = isPublic ? [] : [
                    "deriveBits"
                ];
                break;
            }
        case "EdDSA":
            algorithm = {
                name: $7b68435a821fcd40$var$getNamedCurve(keyData)
            };
            keyUsages = isPublic ? [
                "verify"
            ] : [
                "sign"
            ];
            break;
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported "alg" (Algorithm) value');
    }
    return (0, $5hNwt.default).subtle.importKey(keyFormat, keyData, algorithm, options?.extractable ?? false, keyUsages);
};
const $7b68435a821fcd40$export$224b0a6339c7267f = (pem, alg, options)=>{
    return $7b68435a821fcd40$var$genericImport(/(?:-----(?:BEGIN|END) PRIVATE KEY-----|\s)/g, "pkcs8", pem, alg, options);
};
const $7b68435a821fcd40$export$f9a3505cdaa1fb3e = (pem, alg, options)=>{
    return $7b68435a821fcd40$var$genericImport(/(?:-----(?:BEGIN|END) PUBLIC KEY-----|\s)/g, "spki", pem, alg, options);
};
function $7b68435a821fcd40$var$getElement(seq) {
    let result = [];
    let next = 0;
    while(next < seq.length){
        let nextPart = $7b68435a821fcd40$var$parseElement(seq.subarray(next));
        result.push(nextPart);
        next += nextPart.byteLength;
    }
    return result;
}
function $7b68435a821fcd40$var$parseElement(bytes) {
    let position = 0;
    let tag = bytes[0] & 0x1f;
    position++;
    if (tag === 0x1f) {
        tag = 0;
        while(bytes[position] >= 0x80){
            tag = tag * 128 + bytes[position] - 0x80;
            position++;
        }
        tag = tag * 128 + bytes[position] - 0x80;
        position++;
    }
    let length = 0;
    if (bytes[position] < 0x80) {
        length = bytes[position];
        position++;
    } else if (length === 0x80) {
        length = 0;
        while(bytes[position + length] !== 0 || bytes[position + length + 1] !== 0){
            if (length > bytes.byteLength) throw new TypeError("invalid indefinite form length");
            length++;
        }
        const byteLength = position + length + 2;
        return {
            byteLength: byteLength,
            contents: bytes.subarray(position, position + length),
            raw: bytes.subarray(0, byteLength)
        };
    } else {
        let numberOfDigits = bytes[position] & 0x7f;
        position++;
        length = 0;
        for(let i = 0; i < numberOfDigits; i++){
            length = length * 256 + bytes[position];
            position++;
        }
    }
    const byteLength = position + length;
    return {
        byteLength: byteLength,
        contents: bytes.subarray(position, byteLength),
        raw: bytes.subarray(0, byteLength)
    };
}
function $7b68435a821fcd40$var$spkiFromX509(buf) {
    const tbsCertificate = $7b68435a821fcd40$var$getElement($7b68435a821fcd40$var$getElement($7b68435a821fcd40$var$parseElement(buf).contents)[0].contents);
    return (0, $jvlXK.encodeBase64)(tbsCertificate[tbsCertificate[0].raw[0] === 0xa0 ? 6 : 5].raw);
}
function $7b68435a821fcd40$var$getSPKI(x509) {
    const pem = x509.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, "");
    const raw = (0, $jvlXK.decodeBase64)(pem);
    return (0, $4bYMT.default)($7b68435a821fcd40$var$spkiFromX509(raw), "PUBLIC KEY");
}
const $7b68435a821fcd40$export$ed788b6a8533858f = (pem, alg, options)=>{
    let spki;
    try {
        spki = $7b68435a821fcd40$var$getSPKI(pem);
    } catch (cause) {
        throw new TypeError("Failed to parse the X.509 certificate", {
            cause: cause
        });
    }
    return $7b68435a821fcd40$export$f9a3505cdaa1fb3e(spki, alg, options);
};

});
parcelRequire.register("4bYMT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30d757a5fc9803e8$export$2e2bcd8739ae039; });
var $30d757a5fc9803e8$export$2e2bcd8739ae039 = (b64, descriptor)=>{
    const newlined = (b64.match(/.{1,64}/g) || []).join("\n");
    return `-----BEGIN ${descriptor}-----\n${newlined}\n-----END ${descriptor}-----`;
};

});


parcelRequire.register("fi1tm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b219addbd4025da2$export$2e2bcd8739ae039; });

var $5hNwt = parcelRequire("5hNwt");

var $kuJKd = parcelRequire("kuJKd");
function $b219addbd4025da2$var$subtleMapping(jwk) {
    let algorithm;
    let keyUsages;
    switch(jwk.kty){
        case "RSA":
            switch(jwk.alg){
                case "PS256":
                case "PS384":
                case "PS512":
                    algorithm = {
                        name: "RSA-PSS",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RS256":
                case "RS384":
                case "RS512":
                    algorithm = {
                        name: "RSASSA-PKCS1-v1_5",
                        hash: `SHA-${jwk.alg.slice(-3)}`
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "RSA-OAEP":
                case "RSA-OAEP-256":
                case "RSA-OAEP-384":
                case "RSA-OAEP-512":
                    algorithm = {
                        name: "RSA-OAEP",
                        hash: `SHA-${parseInt(jwk.alg.slice(-3), 10) || 1}`
                    };
                    keyUsages = jwk.d ? [
                        "decrypt",
                        "unwrapKey"
                    ] : [
                        "encrypt",
                        "wrapKey"
                    ];
                    break;
                default:
                    throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "EC":
            switch(jwk.alg){
                case "ES256":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-256"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES384":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-384"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ES512":
                    algorithm = {
                        name: "ECDSA",
                        namedCurve: "P-521"
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: "ECDH",
                        namedCurve: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        case "OKP":
            switch(jwk.alg){
                case "EdDSA":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "sign"
                    ] : [
                        "verify"
                    ];
                    break;
                case "ECDH-ES":
                case "ECDH-ES+A128KW":
                case "ECDH-ES+A192KW":
                case "ECDH-ES+A256KW":
                    algorithm = {
                        name: jwk.crv
                    };
                    keyUsages = jwk.d ? [
                        "deriveBits"
                    ] : [];
                    break;
                default:
                    throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
            }
            break;
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "kty" (Key Type) Parameter value');
    }
    return {
        algorithm: algorithm,
        keyUsages: keyUsages
    };
}
const $b219addbd4025da2$var$parse = async (jwk)=>{
    if (!jwk.alg) throw new TypeError('"alg" argument is required when "jwk.alg" is not present');
    const { algorithm: algorithm, keyUsages: keyUsages } = $b219addbd4025da2$var$subtleMapping(jwk);
    const rest = [
        algorithm,
        jwk.ext ?? false,
        jwk.key_ops ?? keyUsages
    ];
    const keyData = {
        ...jwk
    };
    delete keyData.alg;
    delete keyData.use;
    return (0, $5hNwt.default).subtle.importKey("jwk", keyData, ...rest);
};
var $b219addbd4025da2$export$2e2bcd8739ae039 = $b219addbd4025da2$var$parse;

});


parcelRequire.register("2zSnc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1e090705a1bbfd7e$export$2e2bcd8739ae039; });

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
const $1e090705a1bbfd7e$var$symmetricTypeCheck = (alg, key)=>{
    if (key instanceof Uint8Array) return;
    if (!(0, $2etxt.default)(key)) throw new TypeError((0, $eU8iv.withAlg)(alg, key, ...(0, $2etxt.types), "Uint8Array"));
    if (key.type !== "secret") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for symmetric algorithms must be of type "secret"`);
};
const $1e090705a1bbfd7e$var$asymmetricTypeCheck = (alg, key, usage)=>{
    if (!(0, $2etxt.default)(key)) throw new TypeError((0, $eU8iv.withAlg)(alg, key, ...(0, $2etxt.types)));
    if (key.type === "secret") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for asymmetric algorithms must not be of type "secret"`);
    if (usage === "sign" && key.type === "public") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for asymmetric algorithm signing must be of type "private"`);
    if (usage === "decrypt" && key.type === "public") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for asymmetric algorithm decryption must be of type "private"`);
    if (key.algorithm && usage === "verify" && key.type === "private") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for asymmetric algorithm verifying must be of type "public"`);
    if (key.algorithm && usage === "encrypt" && key.type === "private") throw new TypeError(`${(0, $2etxt.types).join(" or ")} instances for asymmetric algorithm encryption must be of type "public"`);
};
const $1e090705a1bbfd7e$var$checkKeyType = (alg, key, usage)=>{
    const symmetric = alg.startsWith("HS") || alg === "dir" || alg.startsWith("PBES2") || /^A\d{3}(?:GCM)?KW$/.test(alg);
    if (symmetric) $1e090705a1bbfd7e$var$symmetricTypeCheck(alg, key);
    else $1e090705a1bbfd7e$var$asymmetricTypeCheck(alg, key, usage);
};
var $1e090705a1bbfd7e$export$2e2bcd8739ae039 = $1e090705a1bbfd7e$var$checkKeyType;

});

parcelRequire.register("65iIP", function(module, exports) {

$parcel$export(module.exports, "wrap", function () { return $46e1bb87b37cda81$export$4997ffc0176396a6; });
$parcel$export(module.exports, "unwrap", function () { return $46e1bb87b37cda81$export$debb760848ca95a; });

var $1ulpc = parcelRequire("1ulpc");

var $cVxFG = parcelRequire("cVxFG");

var $agiw7 = parcelRequire("agiw7");

var $jvlXK = parcelRequire("jvlXK");
async function $46e1bb87b37cda81$export$4997ffc0176396a6(alg, key, cek, iv) {
    const jweAlgorithm = alg.slice(0, 7);
    iv || (iv = (0, $agiw7.default)(jweAlgorithm));
    const { ciphertext: encryptedKey, tag: tag } = await (0, $1ulpc.default)(jweAlgorithm, cek, key, iv, new Uint8Array(0));
    return {
        encryptedKey: encryptedKey,
        iv: (0, $jvlXK.encode)(iv),
        tag: (0, $jvlXK.encode)(tag)
    };
}
async function $46e1bb87b37cda81$export$debb760848ca95a(alg, key, encryptedKey, iv, tag) {
    const jweAlgorithm = alg.slice(0, 7);
    return (0, $cVxFG.default)(jweAlgorithm, key, encryptedKey, iv, tag, new Uint8Array(0));
}

});
parcelRequire.register("1ulpc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $11593278e9d288c4$export$2e2bcd8739ae039; });

var $1VVH7 = parcelRequire("1VVH7");

var $iacjz = parcelRequire("iacjz");

var $dcZIb = parcelRequire("dcZIb");

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $kuJKd = parcelRequire("kuJKd");

var $2etxt = parcelRequire("2etxt");
async function $11593278e9d288c4$var$cbcEncrypt(enc, plaintext, cek, iv, aad) {
    if (!(cek instanceof Uint8Array)) throw new TypeError((0, $eU8iv.default)(cek, "Uint8Array"));
    const keySize = parseInt(enc.slice(1, 4), 10);
    const encKey = await (0, $5hNwt.default).subtle.importKey("raw", cek.subarray(keySize >> 3), "AES-CBC", false, [
        "encrypt"
    ]);
    const macKey = await (0, $5hNwt.default).subtle.importKey("raw", cek.subarray(0, keySize >> 3), {
        hash: `SHA-${keySize << 1}`,
        name: "HMAC"
    }, false, [
        "sign"
    ]);
    const ciphertext = new Uint8Array(await (0, $5hNwt.default).subtle.encrypt({
        iv: iv,
        name: "AES-CBC"
    }, encKey, plaintext));
    const macData = (0, $1VVH7.concat)(aad, iv, ciphertext, (0, $1VVH7.uint64be)(aad.length << 3));
    const tag = new Uint8Array((await (0, $5hNwt.default).subtle.sign("HMAC", macKey, macData)).slice(0, keySize >> 3));
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
async function $11593278e9d288c4$var$gcmEncrypt(enc, plaintext, cek, iv, aad) {
    let encKey;
    if (cek instanceof Uint8Array) encKey = await (0, $5hNwt.default).subtle.importKey("raw", cek, "AES-GCM", false, [
        "encrypt"
    ]);
    else {
        (0, $eb6en.checkEncCryptoKey)(cek, enc, "encrypt");
        encKey = cek;
    }
    const encrypted = new Uint8Array(await (0, $5hNwt.default).subtle.encrypt({
        additionalData: aad,
        iv: iv,
        name: "AES-GCM",
        tagLength: 128
    }, encKey, plaintext));
    const tag = encrypted.slice(-16);
    const ciphertext = encrypted.slice(0, -16);
    return {
        ciphertext: ciphertext,
        tag: tag
    };
}
const $11593278e9d288c4$var$encrypt = async (enc, plaintext, cek, iv, aad)=>{
    if (!(0, $5hNwt.isCryptoKey)(cek) && !(cek instanceof Uint8Array)) throw new TypeError((0, $eU8iv.default)(cek, ...(0, $2etxt.types), "Uint8Array"));
    (0, $iacjz.default)(enc, iv);
    switch(enc){
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            if (cek instanceof Uint8Array) (0, $dcZIb.default)(cek, parseInt(enc.slice(-3), 10));
            return $11593278e9d288c4$var$cbcEncrypt(enc, plaintext, cek, iv, aad);
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            if (cek instanceof Uint8Array) (0, $dcZIb.default)(cek, parseInt(enc.slice(1, 4), 10));
            return $11593278e9d288c4$var$gcmEncrypt(enc, plaintext, cek, iv, aad);
        default:
            throw new (0, $kuJKd.JOSENotSupported)("Unsupported JWE Content Encryption Algorithm");
    }
};
var $11593278e9d288c4$export$2e2bcd8739ae039 = $11593278e9d288c4$var$encrypt;

});



parcelRequire.register("lHxdO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fcc76246ded29d34$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
function $fcc76246ded29d34$var$validateCrit(Err, recognizedDefault, recognizedOption, protectedHeader, joseHeader) {
    if (joseHeader.crit !== undefined && protectedHeader.crit === undefined) throw new Err('"crit" (Critical) Header Parameter MUST be integrity protected');
    if (!protectedHeader || protectedHeader.crit === undefined) return new Set();
    if (!Array.isArray(protectedHeader.crit) || protectedHeader.crit.length === 0 || protectedHeader.crit.some((input)=>typeof input !== "string" || input.length === 0)) throw new Err('"crit" (Critical) Header Parameter MUST be an array of non-empty strings when present');
    let recognized;
    if (recognizedOption !== undefined) recognized = new Map([
        ...Object.entries(recognizedOption),
        ...recognizedDefault.entries()
    ]);
    else recognized = recognizedDefault;
    for (const parameter of protectedHeader.crit){
        if (!recognized.has(parameter)) throw new (0, $kuJKd.JOSENotSupported)(`Extension Header Parameter "${parameter}" is not recognized`);
        if (joseHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" is missing`);
        else if (recognized.get(parameter) && protectedHeader[parameter] === undefined) throw new Err(`Extension Header Parameter "${parameter}" MUST be integrity protected`);
    }
    return new Set(protectedHeader.crit);
}
var $fcc76246ded29d34$export$2e2bcd8739ae039 = $fcc76246ded29d34$var$validateCrit;

});

parcelRequire.register("lkMDw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f8813168cc046f6d$export$2e2bcd8739ae039; });
const $f8813168cc046f6d$var$validateAlgorithms = (option, algorithms)=>{
    if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some((s)=>typeof s !== "string"))) throw new TypeError(`"${option}" option must be an array of strings`);
    if (!algorithms) return undefined;
    return new Set(algorithms);
};
var $f8813168cc046f6d$export$2e2bcd8739ae039 = $f8813168cc046f6d$var$validateAlgorithms;

});



parcelRequire.register("4iRJo", function(module, exports) {

var $eFlHe = parcelRequire("eFlHe");

var $kuJKd = parcelRequire("kuJKd");

var $bMRvC = parcelRequire("bMRvC");
async function $322285c01e5b66d9$export$56bc728c88264430(jwe, key, options) {
    if (!(0, $bMRvC.default)(jwe)) throw new (0, $kuJKd.JWEInvalid)("General JWE must be an object");
    if (!Array.isArray(jwe.recipients) || !jwe.recipients.every((0, $bMRvC.default))) throw new (0, $kuJKd.JWEInvalid)("JWE Recipients missing or incorrect type");
    if (!jwe.recipients.length) throw new (0, $kuJKd.JWEInvalid)("JWE Recipients has no members");
    for (const recipient of jwe.recipients)try {
        return await (0, $eFlHe.flattenedDecrypt)({
            aad: jwe.aad,
            ciphertext: jwe.ciphertext,
            encrypted_key: recipient.encrypted_key,
            header: recipient.header,
            iv: jwe.iv,
            protected: jwe.protected,
            tag: jwe.tag,
            unprotected: jwe.unprotected
        }, key, options);
    } catch  {}
    throw new (0, $kuJKd.JWEDecryptionFailed)();
}

});

parcelRequire.register("hZRG1", function(module, exports) {

var $f85w7 = parcelRequire("f85w7");

var $kuJKd = parcelRequire("kuJKd");

var $8Zsox = parcelRequire("8Zsox");

var $bQd3d = parcelRequire("bQd3d");

var $8FiyL = parcelRequire("8FiyL");

var $jvlXK = parcelRequire("jvlXK");

var $lHxdO = parcelRequire("lHxdO");
class $d1a1c540968fa86a$var$IndividualRecipient {
    constructor(enc, key, options){
        this.parent = enc;
        this.key = key;
        this.options = options;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addRecipient(...args) {
        return this.parent.addRecipient(...args);
    }
    encrypt(...args) {
        return this.parent.encrypt(...args);
    }
    done() {
        return this.parent;
    }
}
class $d1a1c540968fa86a$export$44234adffc6b0b92 {
    constructor(plaintext){
        this._recipients = [];
        this._plaintext = plaintext;
    }
    addRecipient(key, options) {
        const recipient = new $d1a1c540968fa86a$var$IndividualRecipient(this, key, {
            crit: options?.crit
        });
        this._recipients.push(recipient);
        return recipient;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._unprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    async encrypt() {
        if (!this._recipients.length) throw new (0, $kuJKd.JWEInvalid)("at least one recipient must be added");
        if (this._recipients.length === 1) {
            const [recipient] = this._recipients;
            const flattened = await new (0, $f85w7.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).encrypt(recipient.key, {
                ...recipient.options
            });
            let jwe = {
                ciphertext: flattened.ciphertext,
                iv: flattened.iv,
                recipients: [
                    {}
                ],
                tag: flattened.tag
            };
            if (flattened.aad) jwe.aad = flattened.aad;
            if (flattened.protected) jwe.protected = flattened.protected;
            if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
            if (flattened.encrypted_key) jwe.recipients[0].encrypted_key = flattened.encrypted_key;
            if (flattened.header) jwe.recipients[0].header = flattened.header;
            return jwe;
        }
        let enc;
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            if (!(0, $bQd3d.default)(this._protectedHeader, this._unprotectedHeader, recipient.unprotectedHeader)) throw new (0, $kuJKd.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const { alg: alg } = joseHeader;
            if (typeof alg !== "string" || !alg) throw new (0, $kuJKd.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
            if (alg === "dir" || alg === "ECDH-ES") throw new (0, $kuJKd.JWEInvalid)('"dir" and "ECDH-ES" alg may only be used with a single recipient');
            if (typeof joseHeader.enc !== "string" || !joseHeader.enc) throw new (0, $kuJKd.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
            if (!enc) enc = joseHeader.enc;
            else if (enc !== joseHeader.enc) throw new (0, $kuJKd.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter must be the same for all recipients');
            (0, $lHxdO.default)((0, $kuJKd.JWEInvalid), new Map(), recipient.options.crit, this._protectedHeader, joseHeader);
            if (joseHeader.zip !== undefined) throw new (0, $kuJKd.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        }
        const cek = (0, $8Zsox.default)(enc);
        let jwe = {
            ciphertext: "",
            iv: "",
            recipients: [],
            tag: ""
        };
        for(let i = 0; i < this._recipients.length; i++){
            const recipient = this._recipients[i];
            const target = {};
            jwe.recipients.push(target);
            const joseHeader = {
                ...this._protectedHeader,
                ...this._unprotectedHeader,
                ...recipient.unprotectedHeader
            };
            const p2c = joseHeader.alg.startsWith("PBES2") ? 2048 + i : undefined;
            if (i === 0) {
                const flattened = await new (0, $f85w7.FlattenedEncrypt)(this._plaintext).setAdditionalAuthenticatedData(this._aad).setContentEncryptionKey(cek).setProtectedHeader(this._protectedHeader).setSharedUnprotectedHeader(this._unprotectedHeader).setUnprotectedHeader(recipient.unprotectedHeader).setKeyManagementParameters({
                    p2c: p2c
                }).encrypt(recipient.key, {
                    ...recipient.options,
                    [(0, $f85w7.unprotected)]: true
                });
                jwe.ciphertext = flattened.ciphertext;
                jwe.iv = flattened.iv;
                jwe.tag = flattened.tag;
                if (flattened.aad) jwe.aad = flattened.aad;
                if (flattened.protected) jwe.protected = flattened.protected;
                if (flattened.unprotected) jwe.unprotected = flattened.unprotected;
                target.encrypted_key = flattened.encrypted_key;
                if (flattened.header) target.header = flattened.header;
                continue;
            }
            const { encryptedKey: encryptedKey, parameters: parameters } = await (0, $8FiyL.default)(recipient.unprotectedHeader?.alg || this._protectedHeader?.alg || this._unprotectedHeader?.alg, enc, recipient.key, cek, {
                p2c: p2c
            });
            target.encrypted_key = (0, $jvlXK.encode)(encryptedKey);
            if (recipient.unprotectedHeader || parameters) target.header = {
                ...recipient.unprotectedHeader,
                ...parameters
            };
        }
        return jwe;
    }
}

});
parcelRequire.register("f85w7", function(module, exports) {

$parcel$export(module.exports, "unprotected", function () { return $b03be1f347b6f783$export$39c45cb77eaf132; });
$parcel$export(module.exports, "FlattenedEncrypt", function () { return $b03be1f347b6f783$export$eec23736d3c24809; });

var $jvlXK = parcelRequire("jvlXK");

var $1ulpc = parcelRequire("1ulpc");

var $agiw7 = parcelRequire("agiw7");

var $8FiyL = parcelRequire("8FiyL");

var $kuJKd = parcelRequire("kuJKd");

var $bQd3d = parcelRequire("bQd3d");

var $1VVH7 = parcelRequire("1VVH7");

var $lHxdO = parcelRequire("lHxdO");
const $b03be1f347b6f783$export$39c45cb77eaf132 = Symbol();
class $b03be1f347b6f783$export$eec23736d3c24809 {
    constructor(plaintext){
        if (!(plaintext instanceof Uint8Array)) throw new TypeError("plaintext must be an instance of Uint8Array");
        this._plaintext = plaintext;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setSharedUnprotectedHeader(sharedUnprotectedHeader) {
        if (this._sharedUnprotectedHeader) throw new TypeError("setSharedUnprotectedHeader can only be called once");
        this._sharedUnprotectedHeader = sharedUnprotectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    setAdditionalAuthenticatedData(aad) {
        this._aad = aad;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    async encrypt(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader && !this._sharedUnprotectedHeader) throw new (0, $kuJKd.JWEInvalid)("either setProtectedHeader, setUnprotectedHeader, or sharedUnprotectedHeader must be called before #encrypt()");
        if (!(0, $bQd3d.default)(this._protectedHeader, this._unprotectedHeader, this._sharedUnprotectedHeader)) throw new (0, $kuJKd.JWEInvalid)("JWE Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader,
            ...this._sharedUnprotectedHeader
        };
        (0, $lHxdO.default)((0, $kuJKd.JWEInvalid), new Map(), options?.crit, this._protectedHeader, joseHeader);
        if (joseHeader.zip !== undefined) throw new (0, $kuJKd.JOSENotSupported)('JWE "zip" (Compression Algorithm) Header Parameter is not supported.');
        const { alg: alg, enc: enc } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $kuJKd.JWEInvalid)('JWE "alg" (Algorithm) Header Parameter missing or invalid');
        if (typeof enc !== "string" || !enc) throw new (0, $kuJKd.JWEInvalid)('JWE "enc" (Encryption Algorithm) Header Parameter missing or invalid');
        let encryptedKey;
        if (alg === "dir") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Encryption");
        } else if (alg === "ECDH-ES") {
            if (this._cek) throw new TypeError("setContentEncryptionKey cannot be called when using Direct Key Agreement");
        }
        let cek;
        {
            let parameters;
            ({ cek: cek, encryptedKey: encryptedKey, parameters: parameters } = await (0, $8FiyL.default)(alg, enc, key, this._cek, this._keyManagementParameters));
            if (parameters) {
                if (options && $b03be1f347b6f783$export$39c45cb77eaf132 in options) {
                    if (!this._unprotectedHeader) this.setUnprotectedHeader(parameters);
                    else this._unprotectedHeader = {
                        ...this._unprotectedHeader,
                        ...parameters
                    };
                } else if (!this._protectedHeader) this.setProtectedHeader(parameters);
                else this._protectedHeader = {
                    ...this._protectedHeader,
                    ...parameters
                };
            }
        }
        this._iv || (this._iv = (0, $agiw7.default)(enc));
        let additionalData;
        let protectedHeader;
        let aadMember;
        if (this._protectedHeader) protectedHeader = (0, $1VVH7.encoder).encode((0, $jvlXK.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $1VVH7.encoder).encode("");
        if (this._aad) {
            aadMember = (0, $jvlXK.encode)(this._aad);
            additionalData = (0, $1VVH7.concat)(protectedHeader, (0, $1VVH7.encoder).encode("."), (0, $1VVH7.encoder).encode(aadMember));
        } else additionalData = protectedHeader;
        const { ciphertext: ciphertext, tag: tag } = await (0, $1ulpc.default)(enc, this._plaintext, cek, this._iv, additionalData);
        const jwe = {
            ciphertext: (0, $jvlXK.encode)(ciphertext),
            iv: (0, $jvlXK.encode)(this._iv),
            tag: (0, $jvlXK.encode)(tag)
        };
        if (encryptedKey) jwe.encrypted_key = (0, $jvlXK.encode)(encryptedKey);
        if (aadMember) jwe.aad = aadMember;
        if (this._protectedHeader) jwe.protected = (0, $1VVH7.decoder).decode(protectedHeader);
        if (this._sharedUnprotectedHeader) jwe.unprotected = this._sharedUnprotectedHeader;
        if (this._unprotectedHeader) jwe.header = this._unprotectedHeader;
        return jwe;
    }
}

});
parcelRequire.register("8FiyL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $64f08c9ec3e6d361$export$2e2bcd8739ae039; });

var $ex2OT = parcelRequire("ex2OT");

var $2ilTp = parcelRequire("2ilTp");

var $7abkg = parcelRequire("7abkg");

var $c5Ykk = parcelRequire("c5Ykk");

var $jvlXK = parcelRequire("jvlXK");

var $8Zsox = parcelRequire("8Zsox");

var $kuJKd = parcelRequire("kuJKd");

var $dzQAf = parcelRequire("dzQAf");

var $2zSnc = parcelRequire("2zSnc");

var $65iIP = parcelRequire("65iIP");
async function $64f08c9ec3e6d361$var$encryptKeyManagement(alg, enc, key, providedCek, providedParameters = {}) {
    let encryptedKey;
    let parameters;
    let cek;
    (0, $2zSnc.default)(alg, key, "encrypt");
    switch(alg){
        case "dir":
            cek = key;
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                if (!$2ilTp.ecdhAllowed(key)) throw new (0, $kuJKd.JOSENotSupported)("ECDH with the provided key is not allowed or not supported by your javascript runtime");
                const { apu: apu, apv: apv } = providedParameters;
                let { epk: ephemeralKey } = providedParameters;
                ephemeralKey || (ephemeralKey = (await $2ilTp.generateEpk(key)).privateKey);
                const { x: x, y: y, crv: crv, kty: kty } = await (0, $dzQAf.exportJWK)(ephemeralKey);
                const sharedSecret = await $2ilTp.deriveKey(key, ephemeralKey, alg === "ECDH-ES" ? enc : alg, alg === "ECDH-ES" ? (0, $8Zsox.bitLength)(enc) : parseInt(alg.slice(-5, -2), 10), apu, apv);
                parameters = {
                    epk: {
                        x: x,
                        crv: crv,
                        kty: kty
                    }
                };
                if (kty === "EC") parameters.epk.y = y;
                if (apu) parameters.apu = (0, $jvlXK.encode)(apu);
                if (apv) parameters.apv = (0, $jvlXK.encode)(apv);
                if (alg === "ECDH-ES") {
                    cek = sharedSecret;
                    break;
                }
                cek = providedCek || (0, $8Zsox.default)(enc);
                const kwAlg = alg.slice(-6);
                encryptedKey = await (0, $ex2OT.wrap)(kwAlg, sharedSecret, cek);
                break;
            }
        case "RSA1_5":
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            cek = providedCek || (0, $8Zsox.default)(enc);
            encryptedKey = await (0, $c5Ykk.encrypt)(alg, key, cek);
            break;
        case "PBES2-HS256+A128KW":
        case "PBES2-HS384+A192KW":
        case "PBES2-HS512+A256KW":
            {
                cek = providedCek || (0, $8Zsox.default)(enc);
                const { p2c: p2c, p2s: p2s } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $7abkg.encrypt)(alg, key, cek, p2c, p2s));
                break;
            }
        case "A128KW":
        case "A192KW":
        case "A256KW":
            cek = providedCek || (0, $8Zsox.default)(enc);
            encryptedKey = await (0, $ex2OT.wrap)(alg, key, cek);
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
            {
                cek = providedCek || (0, $8Zsox.default)(enc);
                const { iv: iv } = providedParameters;
                ({ encryptedKey: encryptedKey, ...parameters } = await (0, $65iIP.wrap)(alg, key, cek, iv));
                break;
            }
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported "alg" (JWE Algorithm) header value');
    }
    return {
        cek: cek,
        encryptedKey: encryptedKey,
        parameters: parameters
    };
}
var $64f08c9ec3e6d361$export$2e2bcd8739ae039 = $64f08c9ec3e6d361$var$encryptKeyManagement;

});
parcelRequire.register("dzQAf", function(module, exports) {

$parcel$export(module.exports, "exportJWK", function () { return $9e275546165f962f$export$ffb510cfd482ce82; });

var $aATqH = parcelRequire("aATqH");

var $dPWik = parcelRequire("dPWik");
async function $9e275546165f962f$export$7f687badbeed246d(key) {
    return (0, $aATqH.toSPKI)(key);
}
async function $9e275546165f962f$export$ba4a7192ac1a47fe(key) {
    return (0, $aATqH.toPKCS8)(key);
}
async function $9e275546165f962f$export$ffb510cfd482ce82(key) {
    return (0, $dPWik.default)(key);
}

});
parcelRequire.register("dPWik", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a12d41e26a794be3$export$2e2bcd8739ae039; });

var $5hNwt = parcelRequire("5hNwt");

var $eU8iv = parcelRequire("eU8iv");

var $jvlXK = parcelRequire("jvlXK");

var $2etxt = parcelRequire("2etxt");
const $a12d41e26a794be3$var$keyToJWK = async (key)=>{
    if (key instanceof Uint8Array) return {
        kty: "oct",
        k: (0, $jvlXK.encode)(key)
    };
    if (!(0, $5hNwt.isCryptoKey)(key)) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types), "Uint8Array"));
    if (!key.extractable) throw new TypeError("non-extractable CryptoKey cannot be exported as a JWK");
    const { ext: ext, key_ops: key_ops, alg: alg, use: use, ...jwk } = await (0, $5hNwt.default).subtle.exportKey("jwk", key);
    return jwk;
};
var $a12d41e26a794be3$export$2e2bcd8739ae039 = $a12d41e26a794be3$var$keyToJWK;

});





parcelRequire.register("br1lm", function(module, exports) {

$parcel$export(module.exports, "compactVerify", function () { return $8533421b20b1dc5f$export$996150e72a8992e; });

var $37HDY = parcelRequire("37HDY");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");
async function $8533421b20b1dc5f$export$996150e72a8992e(jws, key, options) {
    if (jws instanceof Uint8Array) jws = (0, $1VVH7.decoder).decode(jws);
    if (typeof jws !== "string") throw new (0, $kuJKd.JWSInvalid)("Compact JWS must be a string or Uint8Array");
    const { 0: protectedHeader, 1: payload, 2: signature, length: length } = jws.split(".");
    if (length !== 3) throw new (0, $kuJKd.JWSInvalid)("Invalid Compact JWS");
    const verified = await (0, $37HDY.flattenedVerify)({
        payload: payload,
        protected: protectedHeader,
        signature: signature
    }, key, options);
    const result = {
        payload: verified.payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRequire.register("37HDY", function(module, exports) {

$parcel$export(module.exports, "flattenedVerify", function () { return $2463e142dda73600$export$b2614975507c40c9; });

var $jvlXK = parcelRequire("jvlXK");

var $79fUz = parcelRequire("79fUz");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");

var $bQd3d = parcelRequire("bQd3d");

var $bMRvC = parcelRequire("bMRvC");

var $2zSnc = parcelRequire("2zSnc");

var $lHxdO = parcelRequire("lHxdO");

var $lkMDw = parcelRequire("lkMDw");
async function $2463e142dda73600$export$b2614975507c40c9(jws, key, options) {
    if (!(0, $bMRvC.default)(jws)) throw new (0, $kuJKd.JWSInvalid)("Flattened JWS must be an object");
    if (jws.protected === undefined && jws.header === undefined) throw new (0, $kuJKd.JWSInvalid)('Flattened JWS must have either of the "protected" or "header" members');
    if (jws.protected !== undefined && typeof jws.protected !== "string") throw new (0, $kuJKd.JWSInvalid)("JWS Protected Header incorrect type");
    if (jws.payload === undefined) throw new (0, $kuJKd.JWSInvalid)("JWS Payload missing");
    if (typeof jws.signature !== "string") throw new (0, $kuJKd.JWSInvalid)("JWS Signature missing or incorrect type");
    if (jws.header !== undefined && !(0, $bMRvC.default)(jws.header)) throw new (0, $kuJKd.JWSInvalid)("JWS Unprotected Header incorrect type");
    let parsedProt = {};
    if (jws.protected) try {
        const protectedHeader = (0, $jvlXK.decode)(jws.protected);
        parsedProt = JSON.parse((0, $1VVH7.decoder).decode(protectedHeader));
    } catch  {
        throw new (0, $kuJKd.JWSInvalid)("JWS Protected Header is invalid");
    }
    if (!(0, $bQd3d.default)(parsedProt, jws.header)) throw new (0, $kuJKd.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
    const joseHeader = {
        ...parsedProt,
        ...jws.header
    };
    const extensions = (0, $lHxdO.default)((0, $kuJKd.JWSInvalid), new Map([
        [
            "b64",
            true
        ]
    ]), options?.crit, parsedProt, joseHeader);
    let b64 = true;
    if (extensions.has("b64")) {
        b64 = parsedProt.b64;
        if (typeof b64 !== "boolean") throw new (0, $kuJKd.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
    }
    const { alg: alg } = joseHeader;
    if (typeof alg !== "string" || !alg) throw new (0, $kuJKd.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
    const algorithms = options && (0, $lkMDw.default)("algorithms", options.algorithms);
    if (algorithms && !algorithms.has(alg)) throw new (0, $kuJKd.JOSEAlgNotAllowed)('"alg" (Algorithm) Header Parameter value not allowed');
    if (b64) {
        if (typeof jws.payload !== "string") throw new (0, $kuJKd.JWSInvalid)("JWS Payload must be a string");
    } else if (typeof jws.payload !== "string" && !(jws.payload instanceof Uint8Array)) throw new (0, $kuJKd.JWSInvalid)("JWS Payload must be a string or an Uint8Array instance");
    let resolvedKey = false;
    if (typeof key === "function") {
        key = await key(parsedProt, jws);
        resolvedKey = true;
    }
    (0, $2zSnc.default)(alg, key, "verify");
    const data = (0, $1VVH7.concat)((0, $1VVH7.encoder).encode(jws.protected ?? ""), (0, $1VVH7.encoder).encode("."), typeof jws.payload === "string" ? (0, $1VVH7.encoder).encode(jws.payload) : jws.payload);
    let signature;
    try {
        signature = (0, $jvlXK.decode)(jws.signature);
    } catch  {
        throw new (0, $kuJKd.JWSInvalid)("Failed to base64url decode the signature");
    }
    const verified = await (0, $79fUz.default)(alg, key, signature, data);
    if (!verified) throw new (0, $kuJKd.JWSSignatureVerificationFailed)();
    let payload;
    if (b64) try {
        payload = (0, $jvlXK.decode)(jws.payload);
    } catch  {
        throw new (0, $kuJKd.JWSInvalid)("Failed to base64url decode the payload");
    }
    else if (typeof jws.payload === "string") payload = (0, $1VVH7.encoder).encode(jws.payload);
    else payload = jws.payload;
    const result = {
        payload: payload
    };
    if (jws.protected !== undefined) result.protectedHeader = parsedProt;
    if (jws.header !== undefined) result.unprotectedHeader = jws.header;
    if (resolvedKey) return {
        ...result,
        key: key
    };
    return result;
}

});
parcelRequire.register("79fUz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5345b75ead670c48$export$2e2bcd8739ae039; });

var $i7Zun = parcelRequire("i7Zun");

var $5hNwt = parcelRequire("5hNwt");

var $gsq4n = parcelRequire("gsq4n");

var $4C26F = parcelRequire("4C26F");
const $5345b75ead670c48$var$verify = async (alg, key, signature, data)=>{
    const cryptoKey = await (0, $4C26F.default)(alg, key, "verify");
    (0, $gsq4n.default)(alg, cryptoKey);
    const algorithm = (0, $i7Zun.default)(alg, cryptoKey.algorithm);
    try {
        return await (0, $5hNwt.default).subtle.verify(algorithm, cryptoKey, signature, data);
    } catch  {
        return false;
    }
};
var $5345b75ead670c48$export$2e2bcd8739ae039 = $5345b75ead670c48$var$verify;

});
parcelRequire.register("i7Zun", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d32893dc4545c8b1$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
function $d32893dc4545c8b1$export$2e2bcd8739ae039(alg, algorithm) {
    const hash = `SHA-${alg.slice(-3)}`;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            return {
                hash: hash,
                name: "HMAC"
            };
        case "PS256":
        case "PS384":
        case "PS512":
            return {
                hash: hash,
                name: "RSA-PSS",
                saltLength: alg.slice(-3) >> 3
            };
        case "RS256":
        case "RS384":
        case "RS512":
            return {
                hash: hash,
                name: "RSASSA-PKCS1-v1_5"
            };
        case "ES256":
        case "ES384":
        case "ES512":
            return {
                hash: hash,
                name: "ECDSA",
                namedCurve: algorithm.namedCurve
            };
        case "EdDSA":
            return {
                name: algorithm.name
            };
        default:
            throw new (0, $kuJKd.JOSENotSupported)(`alg ${alg} is not supported either by JOSE or your javascript runtime`);
    }
}

});

parcelRequire.register("4C26F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $35bc585e628730af$export$2e2bcd8739ae039; });

var $5hNwt = parcelRequire("5hNwt");

var $eb6en = parcelRequire("eb6en");

var $eU8iv = parcelRequire("eU8iv");

var $2etxt = parcelRequire("2etxt");
function $35bc585e628730af$export$2e2bcd8739ae039(alg, key, usage) {
    if ((0, $5hNwt.isCryptoKey)(key)) {
        (0, $eb6en.checkSigCryptoKey)(key, alg, usage);
        return key;
    }
    if (key instanceof Uint8Array) {
        if (!alg.startsWith("HS")) throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types)));
        return (0, $5hNwt.default).subtle.importKey("raw", key, {
            hash: `SHA-${alg.slice(-3)}`,
            name: "HMAC"
        }, false, [
            usage
        ]);
    }
    throw new TypeError((0, $eU8iv.default)(key, ...(0, $2etxt.types), "Uint8Array"));
}

});




parcelRequire.register("2rjNZ", function(module, exports) {

var $37HDY = parcelRequire("37HDY");

var $kuJKd = parcelRequire("kuJKd");

var $bMRvC = parcelRequire("bMRvC");
async function $1c6d7748503c3b01$export$45b643129436bc63(jws, key, options) {
    if (!(0, $bMRvC.default)(jws)) throw new (0, $kuJKd.JWSInvalid)("General JWS must be an object");
    if (!Array.isArray(jws.signatures) || !jws.signatures.every((0, $bMRvC.default))) throw new (0, $kuJKd.JWSInvalid)("JWS Signatures missing or incorrect type");
    for (const signature of jws.signatures)try {
        return await (0, $37HDY.flattenedVerify)({
            header: signature.header,
            payload: jws.payload,
            protected: signature.protected,
            signature: signature.signature
        }, key, options);
    } catch  {}
    throw new (0, $kuJKd.JWSSignatureVerificationFailed)();
}

});

parcelRequire.register("k3kQX", function(module, exports) {

$parcel$export(module.exports, "jwtVerify", function () { return $e9944378b727b295$export$c878fd0f8381da51; });

var $br1lm = parcelRequire("br1lm");

var $a92RM = parcelRequire("a92RM");

var $kuJKd = parcelRequire("kuJKd");
async function $e9944378b727b295$export$c878fd0f8381da51(jwt, key, options) {
    const verified = await (0, $br1lm.compactVerify)(jwt, key, options);
    if (verified.protectedHeader.crit?.includes("b64") && verified.protectedHeader.b64 === false) throw new (0, $kuJKd.JWTInvalid)("JWTs MUST NOT use unencoded payload");
    const payload = (0, $a92RM.default)(verified.protectedHeader, verified.payload, options);
    const result = {
        payload: payload,
        protectedHeader: verified.protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: verified.key
    };
    return result;
}

});
parcelRequire.register("a92RM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $762cf7e1ce82612d$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");

var $4P2VX = parcelRequire("4P2VX");

var $85x2a = parcelRequire("85x2a");

var $bMRvC = parcelRequire("bMRvC");
const $762cf7e1ce82612d$var$normalizeTyp = (value)=>value.toLowerCase().replace(/^application\//, "");
const $762cf7e1ce82612d$var$checkAudiencePresence = (audPayload, audOption)=>{
    if (typeof audPayload === "string") return audOption.includes(audPayload);
    if (Array.isArray(audPayload)) return audOption.some(Set.prototype.has.bind(new Set(audPayload)));
    return false;
};
var $762cf7e1ce82612d$export$2e2bcd8739ae039 = (protectedHeader, encodedPayload, options = {})=>{
    const { typ: typ } = options;
    if (typ && (typeof protectedHeader.typ !== "string" || $762cf7e1ce82612d$var$normalizeTyp(protectedHeader.typ) !== $762cf7e1ce82612d$var$normalizeTyp(typ))) throw new (0, $kuJKd.JWTClaimValidationFailed)('unexpected "typ" JWT header value', "typ", "check_failed");
    let payload;
    try {
        payload = JSON.parse((0, $1VVH7.decoder).decode(encodedPayload));
    } catch  {}
    if (!(0, $bMRvC.default)(payload)) throw new (0, $kuJKd.JWTInvalid)("JWT Claims Set must be a top-level JSON object");
    const { requiredClaims: requiredClaims = [], issuer: issuer, subject: subject, audience: audience, maxTokenAge: maxTokenAge } = options;
    if (maxTokenAge !== undefined) requiredClaims.push("iat");
    if (audience !== undefined) requiredClaims.push("aud");
    if (subject !== undefined) requiredClaims.push("sub");
    if (issuer !== undefined) requiredClaims.push("iss");
    for (const claim of new Set(requiredClaims.reverse())){
        if (!(claim in payload)) throw new (0, $kuJKd.JWTClaimValidationFailed)(`missing required "${claim}" claim`, claim, "missing");
    }
    if (issuer && !(Array.isArray(issuer) ? issuer : [
        issuer
    ]).includes(payload.iss)) throw new (0, $kuJKd.JWTClaimValidationFailed)('unexpected "iss" claim value', "iss", "check_failed");
    if (subject && payload.sub !== subject) throw new (0, $kuJKd.JWTClaimValidationFailed)('unexpected "sub" claim value', "sub", "check_failed");
    if (audience && !$762cf7e1ce82612d$var$checkAudiencePresence(payload.aud, typeof audience === "string" ? [
        audience
    ] : audience)) throw new (0, $kuJKd.JWTClaimValidationFailed)('unexpected "aud" claim value', "aud", "check_failed");
    let tolerance;
    switch(typeof options.clockTolerance){
        case "string":
            tolerance = (0, $85x2a.default)(options.clockTolerance);
            break;
        case "number":
            tolerance = options.clockTolerance;
            break;
        case "undefined":
            tolerance = 0;
            break;
        default:
            throw new TypeError("Invalid clockTolerance option type");
    }
    const { currentDate: currentDate } = options;
    const now = (0, $4P2VX.default)(currentDate || new Date());
    if ((payload.iat !== undefined || maxTokenAge) && typeof payload.iat !== "number") throw new (0, $kuJKd.JWTClaimValidationFailed)('"iat" claim must be a number', "iat", "invalid");
    if (payload.nbf !== undefined) {
        if (typeof payload.nbf !== "number") throw new (0, $kuJKd.JWTClaimValidationFailed)('"nbf" claim must be a number', "nbf", "invalid");
        if (payload.nbf > now + tolerance) throw new (0, $kuJKd.JWTClaimValidationFailed)('"nbf" claim timestamp check failed', "nbf", "check_failed");
    }
    if (payload.exp !== undefined) {
        if (typeof payload.exp !== "number") throw new (0, $kuJKd.JWTClaimValidationFailed)('"exp" claim must be a number', "exp", "invalid");
        if (payload.exp <= now - tolerance) throw new (0, $kuJKd.JWTExpired)('"exp" claim timestamp check failed', "exp", "check_failed");
    }
    if (maxTokenAge) {
        const age = now - payload.iat;
        const max = typeof maxTokenAge === "number" ? maxTokenAge : (0, $85x2a.default)(maxTokenAge);
        if (age - tolerance > max) throw new (0, $kuJKd.JWTExpired)('"iat" claim timestamp check failed (too far in the past)', "iat", "check_failed");
        if (age < 0 - tolerance) throw new (0, $kuJKd.JWTClaimValidationFailed)('"iat" claim timestamp check failed (it should be in the past)', "iat", "check_failed");
    }
    return payload;
};

});
parcelRequire.register("4P2VX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $382e336c75dfdb29$export$2e2bcd8739ae039; });
var $382e336c75dfdb29$export$2e2bcd8739ae039 = (date)=>Math.floor(date.getTime() / 1000);

});

parcelRequire.register("85x2a", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5e386a39d218f445$export$2e2bcd8739ae039; });
const $5e386a39d218f445$var$minute = 60;
const $5e386a39d218f445$var$hour = $5e386a39d218f445$var$minute * 60;
const $5e386a39d218f445$var$day = $5e386a39d218f445$var$hour * 24;
const $5e386a39d218f445$var$week = $5e386a39d218f445$var$day * 7;
const $5e386a39d218f445$var$year = $5e386a39d218f445$var$day * 365.25;
const $5e386a39d218f445$var$REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i;
var $5e386a39d218f445$export$2e2bcd8739ae039 = (str)=>{
    const matched = $5e386a39d218f445$var$REGEX.exec(str);
    if (!matched) throw new TypeError("Invalid time period format");
    const value = parseFloat(matched[1]);
    const unit = matched[2].toLowerCase();
    switch(unit){
        case "sec":
        case "secs":
        case "second":
        case "seconds":
        case "s":
            return Math.round(value);
        case "minute":
        case "minutes":
        case "min":
        case "mins":
        case "m":
            return Math.round(value * $5e386a39d218f445$var$minute);
        case "hour":
        case "hours":
        case "hr":
        case "hrs":
        case "h":
            return Math.round(value * $5e386a39d218f445$var$hour);
        case "day":
        case "days":
        case "d":
            return Math.round(value * $5e386a39d218f445$var$day);
        case "week":
        case "weeks":
        case "w":
            return Math.round(value * $5e386a39d218f445$var$week);
        default:
            return Math.round(value * $5e386a39d218f445$var$year);
    }
};

});



parcelRequire.register("eKJW3", function(module, exports) {

var $gXCEm = parcelRequire("gXCEm");

var $a92RM = parcelRequire("a92RM");

var $kuJKd = parcelRequire("kuJKd");
async function $abd8fe61e3ff9377$export$6ee899505bc40a19(jwt, key, options) {
    const decrypted = await (0, $gXCEm.compactDecrypt)(jwt, key, options);
    const payload = (0, $a92RM.default)(decrypted.protectedHeader, decrypted.plaintext, options);
    const { protectedHeader: protectedHeader } = decrypted;
    if (protectedHeader.iss !== undefined && protectedHeader.iss !== payload.iss) throw new (0, $kuJKd.JWTClaimValidationFailed)('replicated "iss" claim header parameter mismatch', "iss", "mismatch");
    if (protectedHeader.sub !== undefined && protectedHeader.sub !== payload.sub) throw new (0, $kuJKd.JWTClaimValidationFailed)('replicated "sub" claim header parameter mismatch', "sub", "mismatch");
    if (protectedHeader.aud !== undefined && JSON.stringify(protectedHeader.aud) !== JSON.stringify(payload.aud)) throw new (0, $kuJKd.JWTClaimValidationFailed)('replicated "aud" claim header parameter mismatch', "aud", "mismatch");
    const result = {
        payload: payload,
        protectedHeader: protectedHeader
    };
    if (typeof key === "function") return {
        ...result,
        key: decrypted.key
    };
    return result;
}

});

parcelRequire.register("iHeZ7", function(module, exports) {

$parcel$export(module.exports, "CompactEncrypt", function () { return $d9c7ddd1b193eb8c$export$965e4de9938e070e; });

var $f85w7 = parcelRequire("f85w7");
class $d9c7ddd1b193eb8c$export$965e4de9938e070e {
    constructor(plaintext){
        this._flattened = new (0, $f85w7.FlattenedEncrypt)(plaintext);
    }
    setContentEncryptionKey(cek) {
        this._flattened.setContentEncryptionKey(cek);
        return this;
    }
    setInitializationVector(iv) {
        this._flattened.setInitializationVector(iv);
        return this;
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    setKeyManagementParameters(parameters) {
        this._flattened.setKeyManagementParameters(parameters);
        return this;
    }
    async encrypt(key, options) {
        const jwe = await this._flattened.encrypt(key, options);
        return [
            jwe.protected,
            jwe.encrypted_key,
            jwe.iv,
            jwe.ciphertext,
            jwe.tag
        ].join(".");
    }
}

});

parcelRequire.register("a0CQJ", function(module, exports) {

$parcel$export(module.exports, "CompactSign", function () { return $74980a324c2b8201$export$b6738d8e70498d17; });

var $2pxbd = parcelRequire("2pxbd");
class $74980a324c2b8201$export$b6738d8e70498d17 {
    constructor(payload){
        this._flattened = new (0, $2pxbd.FlattenedSign)(payload);
    }
    setProtectedHeader(protectedHeader) {
        this._flattened.setProtectedHeader(protectedHeader);
        return this;
    }
    async sign(key, options) {
        const jws = await this._flattened.sign(key, options);
        if (jws.payload === undefined) throw new TypeError("use the flattened module for creating JWS with b64: false");
        return `${jws.protected}.${jws.payload}.${jws.signature}`;
    }
}

});
parcelRequire.register("2pxbd", function(module, exports) {

$parcel$export(module.exports, "FlattenedSign", function () { return $1c17a7652280194b$export$9a8af5200da5ddb1; });

var $jvlXK = parcelRequire("jvlXK");

var $16TeY = parcelRequire("16TeY");

var $bQd3d = parcelRequire("bQd3d");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");

var $2zSnc = parcelRequire("2zSnc");

var $lHxdO = parcelRequire("lHxdO");
class $1c17a7652280194b$export$9a8af5200da5ddb1 {
    constructor(payload){
        if (!(payload instanceof Uint8Array)) throw new TypeError("payload must be an instance of Uint8Array");
        this._payload = payload;
    }
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this._unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this._unprotectedHeader = unprotectedHeader;
        return this;
    }
    async sign(key, options) {
        if (!this._protectedHeader && !this._unprotectedHeader) throw new (0, $kuJKd.JWSInvalid)("either setProtectedHeader or setUnprotectedHeader must be called before #sign()");
        if (!(0, $bQd3d.default)(this._protectedHeader, this._unprotectedHeader)) throw new (0, $kuJKd.JWSInvalid)("JWS Protected and JWS Unprotected Header Parameter names must be disjoint");
        const joseHeader = {
            ...this._protectedHeader,
            ...this._unprotectedHeader
        };
        const extensions = (0, $lHxdO.default)((0, $kuJKd.JWSInvalid), new Map([
            [
                "b64",
                true
            ]
        ]), options?.crit, this._protectedHeader, joseHeader);
        let b64 = true;
        if (extensions.has("b64")) {
            b64 = this._protectedHeader.b64;
            if (typeof b64 !== "boolean") throw new (0, $kuJKd.JWSInvalid)('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        }
        const { alg: alg } = joseHeader;
        if (typeof alg !== "string" || !alg) throw new (0, $kuJKd.JWSInvalid)('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        (0, $2zSnc.default)(alg, key, "sign");
        let payload = this._payload;
        if (b64) payload = (0, $1VVH7.encoder).encode((0, $jvlXK.encode)(payload));
        let protectedHeader;
        if (this._protectedHeader) protectedHeader = (0, $1VVH7.encoder).encode((0, $jvlXK.encode)(JSON.stringify(this._protectedHeader)));
        else protectedHeader = (0, $1VVH7.encoder).encode("");
        const data = (0, $1VVH7.concat)(protectedHeader, (0, $1VVH7.encoder).encode("."), payload);
        const signature = await (0, $16TeY.default)(alg, key, data);
        const jws = {
            signature: (0, $jvlXK.encode)(signature),
            payload: ""
        };
        if (b64) jws.payload = (0, $1VVH7.decoder).decode(payload);
        if (this._unprotectedHeader) jws.header = this._unprotectedHeader;
        if (this._protectedHeader) jws.protected = (0, $1VVH7.decoder).decode(protectedHeader);
        return jws;
    }
}

});
parcelRequire.register("16TeY", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0cf1339c7fb4084d$export$2e2bcd8739ae039; });

var $i7Zun = parcelRequire("i7Zun");

var $5hNwt = parcelRequire("5hNwt");

var $gsq4n = parcelRequire("gsq4n");

var $4C26F = parcelRequire("4C26F");
const $0cf1339c7fb4084d$var$sign = async (alg, key, data)=>{
    const cryptoKey = await (0, $4C26F.default)(alg, key, "sign");
    (0, $gsq4n.default)(alg, cryptoKey);
    const signature = await (0, $5hNwt.default).subtle.sign((0, $i7Zun.default)(alg, cryptoKey.algorithm), cryptoKey, data);
    return new Uint8Array(signature);
};
var $0cf1339c7fb4084d$export$2e2bcd8739ae039 = $0cf1339c7fb4084d$var$sign;

});



parcelRequire.register("84Ai3", function(module, exports) {

var $2pxbd = parcelRequire("2pxbd");

var $kuJKd = parcelRequire("kuJKd");
class $5e0ad8e93cbe7744$var$IndividualSignature {
    constructor(sig, key, options){
        this.parent = sig;
        this.key = key;
        this.options = options;
    }
    setProtectedHeader(protectedHeader) {
        if (this.protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this.protectedHeader = protectedHeader;
        return this;
    }
    setUnprotectedHeader(unprotectedHeader) {
        if (this.unprotectedHeader) throw new TypeError("setUnprotectedHeader can only be called once");
        this.unprotectedHeader = unprotectedHeader;
        return this;
    }
    addSignature(...args) {
        return this.parent.addSignature(...args);
    }
    sign(...args) {
        return this.parent.sign(...args);
    }
    done() {
        return this.parent;
    }
}
class $5e0ad8e93cbe7744$export$7e2f94727ed1a34b {
    constructor(payload){
        this._signatures = [];
        this._payload = payload;
    }
    addSignature(key, options) {
        const signature = new $5e0ad8e93cbe7744$var$IndividualSignature(this, key, options);
        this._signatures.push(signature);
        return signature;
    }
    async sign() {
        if (!this._signatures.length) throw new (0, $kuJKd.JWSInvalid)("at least one signature must be added");
        const jws = {
            signatures: [],
            payload: ""
        };
        for(let i = 0; i < this._signatures.length; i++){
            const signature = this._signatures[i];
            const flattened = new (0, $2pxbd.FlattenedSign)(this._payload);
            flattened.setProtectedHeader(signature.protectedHeader);
            flattened.setUnprotectedHeader(signature.unprotectedHeader);
            const { payload: payload, ...rest } = await flattened.sign(signature.key, signature.options);
            if (i === 0) jws.payload = payload;
            else if (jws.payload !== payload) throw new (0, $kuJKd.JWSInvalid)("inconsistent use of JWS Unencoded Payload (RFC7797)");
            jws.signatures.push(rest);
        }
        return jws;
    }
}

});

parcelRequire.register("hzUUu", function(module, exports) {

var $a0CQJ = parcelRequire("a0CQJ");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");

var $aKrku = parcelRequire("aKrku");
class $ccc1d9b75bbc6d06$export$88d4e5d23fbe6c84 extends (0, $aKrku.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        this._protectedHeader = protectedHeader;
        return this;
    }
    async sign(key, options) {
        const sig = new (0, $a0CQJ.CompactSign)((0, $1VVH7.encoder).encode(JSON.stringify(this._payload)));
        sig.setProtectedHeader(this._protectedHeader);
        if (Array.isArray(this._protectedHeader?.crit) && this._protectedHeader.crit.includes("b64") && this._protectedHeader.b64 === false) throw new (0, $kuJKd.JWTInvalid)("JWTs MUST NOT use unencoded payload");
        return sig.sign(key, options);
    }
}

});
parcelRequire.register("aKrku", function(module, exports) {

$parcel$export(module.exports, "ProduceJWT", function () { return $0204f5437263fb4e$export$2ef1b74b7c7e6eb3; });

var $4P2VX = parcelRequire("4P2VX");

var $bMRvC = parcelRequire("bMRvC");

var $85x2a = parcelRequire("85x2a");
function $0204f5437263fb4e$var$validateInput(label, input) {
    if (!Number.isFinite(input)) throw new TypeError(`Invalid ${label} input`);
    return input;
}
class $0204f5437263fb4e$export$2ef1b74b7c7e6eb3 {
    constructor(payload = {}){
        if (!(0, $bMRvC.default)(payload)) throw new TypeError("JWT Claims Set MUST be an object");
        this._payload = payload;
    }
    setIssuer(issuer) {
        this._payload = {
            ...this._payload,
            iss: issuer
        };
        return this;
    }
    setSubject(subject) {
        this._payload = {
            ...this._payload,
            sub: subject
        };
        return this;
    }
    setAudience(audience) {
        this._payload = {
            ...this._payload,
            aud: audience
        };
        return this;
    }
    setJti(jwtId) {
        this._payload = {
            ...this._payload,
            jti: jwtId
        };
        return this;
    }
    setNotBefore(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            nbf: $0204f5437263fb4e$var$validateInput("setNotBefore", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            nbf: $0204f5437263fb4e$var$validateInput("setNotBefore", (0, $4P2VX.default)(input))
        };
        else this._payload = {
            ...this._payload,
            nbf: (0, $4P2VX.default)(new Date()) + (0, $85x2a.default)(input)
        };
        return this;
    }
    setExpirationTime(input) {
        if (typeof input === "number") this._payload = {
            ...this._payload,
            exp: $0204f5437263fb4e$var$validateInput("setExpirationTime", input)
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            exp: $0204f5437263fb4e$var$validateInput("setExpirationTime", (0, $4P2VX.default)(input))
        };
        else this._payload = {
            ...this._payload,
            exp: (0, $4P2VX.default)(new Date()) + (0, $85x2a.default)(input)
        };
        return this;
    }
    setIssuedAt(input) {
        if (typeof input === "undefined") this._payload = {
            ...this._payload,
            iat: (0, $4P2VX.default)(new Date())
        };
        else if (input instanceof Date) this._payload = {
            ...this._payload,
            iat: $0204f5437263fb4e$var$validateInput("setIssuedAt", (0, $4P2VX.default)(input))
        };
        else this._payload = {
            ...this._payload,
            iat: $0204f5437263fb4e$var$validateInput("setIssuedAt", input)
        };
        return this;
    }
}

});


parcelRequire.register("hLieE", function(module, exports) {

var $iHeZ7 = parcelRequire("iHeZ7");

var $1VVH7 = parcelRequire("1VVH7");

var $aKrku = parcelRequire("aKrku");
class $cee4f8951cf39f0d$export$28c9f8d29aec6f3d extends (0, $aKrku.ProduceJWT) {
    setProtectedHeader(protectedHeader) {
        if (this._protectedHeader) throw new TypeError("setProtectedHeader can only be called once");
        this._protectedHeader = protectedHeader;
        return this;
    }
    setKeyManagementParameters(parameters) {
        if (this._keyManagementParameters) throw new TypeError("setKeyManagementParameters can only be called once");
        this._keyManagementParameters = parameters;
        return this;
    }
    setContentEncryptionKey(cek) {
        if (this._cek) throw new TypeError("setContentEncryptionKey can only be called once");
        this._cek = cek;
        return this;
    }
    setInitializationVector(iv) {
        if (this._iv) throw new TypeError("setInitializationVector can only be called once");
        this._iv = iv;
        return this;
    }
    replicateIssuerAsHeader() {
        this._replicateIssuerAsHeader = true;
        return this;
    }
    replicateSubjectAsHeader() {
        this._replicateSubjectAsHeader = true;
        return this;
    }
    replicateAudienceAsHeader() {
        this._replicateAudienceAsHeader = true;
        return this;
    }
    async encrypt(key, options) {
        const enc = new (0, $iHeZ7.CompactEncrypt)((0, $1VVH7.encoder).encode(JSON.stringify(this._payload)));
        if (this._replicateIssuerAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            iss: this._payload.iss
        };
        if (this._replicateSubjectAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            sub: this._payload.sub
        };
        if (this._replicateAudienceAsHeader) this._protectedHeader = {
            ...this._protectedHeader,
            aud: this._payload.aud
        };
        enc.setProtectedHeader(this._protectedHeader);
        if (this._iv) enc.setInitializationVector(this._iv);
        if (this._cek) enc.setContentEncryptionKey(this._cek);
        if (this._keyManagementParameters) enc.setKeyManagementParameters(this._keyManagementParameters);
        return enc.encrypt(key, options);
    }
}

});

parcelRequire.register("b4d8K", function(module, exports) {

var $5PYa8 = parcelRequire("5PYa8");

var $jvlXK = parcelRequire("jvlXK");

var $kuJKd = parcelRequire("kuJKd");

var $1VVH7 = parcelRequire("1VVH7");

var $bMRvC = parcelRequire("bMRvC");
const $80ea42c4ce3855f8$var$check = (value, description)=>{
    if (typeof value !== "string" || !value) throw new (0, $kuJKd.JWKInvalid)(`${description} missing or invalid`);
};
async function $80ea42c4ce3855f8$export$f1ec189735e8660f(jwk, digestAlgorithm) {
    if (!(0, $bMRvC.default)(jwk)) throw new TypeError("JWK must be an object");
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    if (digestAlgorithm !== "sha256" && digestAlgorithm !== "sha384" && digestAlgorithm !== "sha512") throw new TypeError('digestAlgorithm must one of "sha256", "sha384", or "sha512"');
    let components;
    switch(jwk.kty){
        case "EC":
            $80ea42c4ce3855f8$var$check(jwk.crv, '"crv" (Curve) Parameter');
            $80ea42c4ce3855f8$var$check(jwk.x, '"x" (X Coordinate) Parameter');
            $80ea42c4ce3855f8$var$check(jwk.y, '"y" (Y Coordinate) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x,
                y: jwk.y
            };
            break;
        case "OKP":
            $80ea42c4ce3855f8$var$check(jwk.crv, '"crv" (Subtype of Key Pair) Parameter');
            $80ea42c4ce3855f8$var$check(jwk.x, '"x" (Public Key) Parameter');
            components = {
                crv: jwk.crv,
                kty: jwk.kty,
                x: jwk.x
            };
            break;
        case "RSA":
            $80ea42c4ce3855f8$var$check(jwk.e, '"e" (Exponent) Parameter');
            $80ea42c4ce3855f8$var$check(jwk.n, '"n" (Modulus) Parameter');
            components = {
                e: jwk.e,
                kty: jwk.kty,
                n: jwk.n
            };
            break;
        case "oct":
            $80ea42c4ce3855f8$var$check(jwk.k, '"k" (Key Value) Parameter');
            components = {
                k: jwk.k,
                kty: jwk.kty
            };
            break;
        default:
            throw new (0, $kuJKd.JOSENotSupported)('"kty" (Key Type) Parameter missing or unsupported');
    }
    const data = (0, $1VVH7.encoder).encode(JSON.stringify(components));
    return (0, $jvlXK.encode)(await (0, $5PYa8.default)(digestAlgorithm, data));
}
async function $80ea42c4ce3855f8$export$b9879ebc49d4fd7a(jwk, digestAlgorithm) {
    digestAlgorithm ?? (digestAlgorithm = "sha256");
    const thumbprint = await $80ea42c4ce3855f8$export$f1ec189735e8660f(jwk, digestAlgorithm);
    return `urn:ietf:params:oauth:jwk-thumbprint:sha-${digestAlgorithm.slice(-3)}:${thumbprint}`;
}

});

parcelRequire.register("bBFuw", function(module, exports) {

var $pGamf = parcelRequire("pGamf");

var $bMRvC = parcelRequire("bMRvC");

var $kuJKd = parcelRequire("kuJKd");
async function $873355bb0ebc9885$export$c51e3062a159ef59(protectedHeader, token) {
    const joseHeader = {
        ...protectedHeader,
        ...token?.header
    };
    if (!(0, $bMRvC.default)(joseHeader.jwk)) throw new (0, $kuJKd.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a JSON object');
    const key = await (0, $pGamf.importJWK)({
        ...joseHeader.jwk,
        ext: true
    }, joseHeader.alg);
    if (key instanceof Uint8Array || key.type !== "public") throw new (0, $kuJKd.JWSInvalid)('"jwk" (JSON Web Key) Header Parameter must be a public key');
    return key;
}

});

parcelRequire.register("kAtWh", function(module, exports) {

$parcel$export(module.exports, "isJWKSLike", function () { return $efce64b238c8589f$export$d01e0ebadbb4baf; });
$parcel$export(module.exports, "LocalJWKSet", function () { return $efce64b238c8589f$export$cfeaec9a672ea12b; });
$parcel$export(module.exports, "createLocalJWKSet", function () { return $efce64b238c8589f$export$4892abc640e5f80e; });

var $pGamf = parcelRequire("pGamf");

var $kuJKd = parcelRequire("kuJKd");

var $bMRvC = parcelRequire("bMRvC");
function $efce64b238c8589f$var$getKtyFromAlg(alg) {
    switch(typeof alg === "string" && alg.slice(0, 2)){
        case "RS":
        case "PS":
            return "RSA";
        case "ES":
            return "EC";
        case "Ed":
            return "OKP";
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Unsupported "alg" value for a JSON Web Key Set');
    }
}
function $efce64b238c8589f$export$d01e0ebadbb4baf(jwks) {
    return jwks && typeof jwks === "object" && Array.isArray(jwks.keys) && jwks.keys.every($efce64b238c8589f$var$isJWKLike);
}
function $efce64b238c8589f$var$isJWKLike(key) {
    return (0, $bMRvC.default)(key);
}
function $efce64b238c8589f$var$clone(obj) {
    if (typeof structuredClone === "function") return structuredClone(obj);
    return JSON.parse(JSON.stringify(obj));
}
class $efce64b238c8589f$export$cfeaec9a672ea12b {
    constructor(jwks){
        this._cached = new WeakMap();
        if (!$efce64b238c8589f$export$d01e0ebadbb4baf(jwks)) throw new (0, $kuJKd.JWKSInvalid)("JSON Web Key Set malformed");
        this._jwks = $efce64b238c8589f$var$clone(jwks);
    }
    async getKey(protectedHeader, token) {
        const { alg: alg, kid: kid } = {
            ...protectedHeader,
            ...token?.header
        };
        const kty = $efce64b238c8589f$var$getKtyFromAlg(alg);
        const candidates = this._jwks.keys.filter((jwk)=>{
            let candidate = kty === jwk.kty;
            if (candidate && typeof kid === "string") candidate = kid === jwk.kid;
            if (candidate && typeof jwk.alg === "string") candidate = alg === jwk.alg;
            if (candidate && typeof jwk.use === "string") candidate = jwk.use === "sig";
            if (candidate && Array.isArray(jwk.key_ops)) candidate = jwk.key_ops.includes("verify");
            if (candidate && alg === "EdDSA") candidate = jwk.crv === "Ed25519" || jwk.crv === "Ed448";
            if (candidate) switch(alg){
                case "ES256":
                    candidate = jwk.crv === "P-256";
                    break;
                case "ES256K":
                    candidate = jwk.crv === "secp256k1";
                    break;
                case "ES384":
                    candidate = jwk.crv === "P-384";
                    break;
                case "ES512":
                    candidate = jwk.crv === "P-521";
                    break;
            }
            return candidate;
        });
        const { 0: jwk, length: length } = candidates;
        if (length === 0) throw new (0, $kuJKd.JWKSNoMatchingKey)();
        else if (length !== 1) {
            const error = new (0, $kuJKd.JWKSMultipleMatchingKeys)();
            const { _cached: _cached } = this;
            error[Symbol.asyncIterator] = async function*() {
                for (const jwk of candidates)try {
                    yield await $efce64b238c8589f$var$importWithAlgCache(_cached, jwk, alg);
                } catch  {
                    continue;
                }
            };
            throw error;
        }
        return $efce64b238c8589f$var$importWithAlgCache(this._cached, jwk, alg);
    }
}
async function $efce64b238c8589f$var$importWithAlgCache(cache, jwk, alg) {
    const cached = cache.get(jwk) || cache.set(jwk, {}).get(jwk);
    if (cached[alg] === undefined) {
        const key = await (0, $pGamf.importJWK)({
            ...jwk,
            ext: true
        }, alg);
        if (key instanceof Uint8Array || key.type !== "public") throw new (0, $kuJKd.JWKSInvalid)("JSON Web Key Set members must be public keys");
        cached[alg] = key;
    }
    return cached[alg];
}
function $efce64b238c8589f$export$4892abc640e5f80e(jwks) {
    const set = new $efce64b238c8589f$export$cfeaec9a672ea12b(jwks);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

});

parcelRequire.register("54Ouh", function(module, exports) {

$parcel$export(module.exports, "createRemoteJWKSet", function () { return $3b247d3102bd7d4f$export$78ce35c2df51c333; });

var $glF0t = parcelRequire("glF0t");

var $kuJKd = parcelRequire("kuJKd");

var $kAtWh = parcelRequire("kAtWh");
function $3b247d3102bd7d4f$var$isCloudflareWorkers() {
    return typeof WebSocketPair !== "undefined" || typeof navigator !== "undefined" && navigator.userAgent === "Cloudflare-Workers" || typeof EdgeRuntime !== "undefined" && EdgeRuntime === "vercel";
}
class $3b247d3102bd7d4f$var$RemoteJWKSet extends (0, $kAtWh.LocalJWKSet) {
    constructor(url, options){
        super({
            keys: []
        });
        this._jwks = undefined;
        if (!(url instanceof URL)) throw new TypeError("url must be an instance of URL");
        this._url = new URL(url.href);
        this._options = {
            agent: options?.agent,
            headers: options?.headers
        };
        this._timeoutDuration = typeof options?.timeoutDuration === "number" ? options?.timeoutDuration : 5000;
        this._cooldownDuration = typeof options?.cooldownDuration === "number" ? options?.cooldownDuration : 30000;
        this._cacheMaxAge = typeof options?.cacheMaxAge === "number" ? options?.cacheMaxAge : 600000;
    }
    coolingDown() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cooldownDuration : false;
    }
    fresh() {
        return typeof this._jwksTimestamp === "number" ? Date.now() < this._jwksTimestamp + this._cacheMaxAge : false;
    }
    async getKey(protectedHeader, token) {
        if (!this._jwks || !this.fresh()) await this.reload();
        try {
            return await super.getKey(protectedHeader, token);
        } catch (err) {
            if (err instanceof (0, $kuJKd.JWKSNoMatchingKey)) {
                if (this.coolingDown() === false) {
                    await this.reload();
                    return super.getKey(protectedHeader, token);
                }
            }
            throw err;
        }
    }
    async reload() {
        if (this._pendingFetch && $3b247d3102bd7d4f$var$isCloudflareWorkers()) this._pendingFetch = undefined;
        this._pendingFetch || (this._pendingFetch = (0, $glF0t.default)(this._url, this._timeoutDuration, this._options).then((json)=>{
            if (!(0, $kAtWh.isJWKSLike)(json)) throw new (0, $kuJKd.JWKSInvalid)("JSON Web Key Set malformed");
            this._jwks = {
                keys: json.keys
            };
            this._jwksTimestamp = Date.now();
            this._pendingFetch = undefined;
        }).catch((err)=>{
            this._pendingFetch = undefined;
            throw err;
        }));
        await this._pendingFetch;
    }
}
function $3b247d3102bd7d4f$export$78ce35c2df51c333(url, options) {
    const set = new $3b247d3102bd7d4f$var$RemoteJWKSet(url, options);
    return async function(protectedHeader, token) {
        return set.getKey(protectedHeader, token);
    };
}

});
parcelRequire.register("glF0t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $be6e6a90b8b547df$export$2e2bcd8739ae039; });

var $kuJKd = parcelRequire("kuJKd");
const $be6e6a90b8b547df$var$fetchJwks = async (url, timeout, options)=>{
    let controller;
    let id;
    let timedOut = false;
    if (typeof AbortController === "function") {
        controller = new AbortController();
        id = setTimeout(()=>{
            timedOut = true;
            controller.abort();
        }, timeout);
    }
    const response = await fetch(url.href, {
        signal: controller ? controller.signal : undefined,
        redirect: "manual",
        headers: options.headers
    }).catch((err)=>{
        if (timedOut) throw new (0, $kuJKd.JWKSTimeout)();
        throw err;
    });
    if (id !== undefined) clearTimeout(id);
    if (response.status !== 200) throw new (0, $kuJKd.JOSEError)("Expected 200 OK from the JSON Web Key Set HTTP response");
    try {
        return await response.json();
    } catch  {
        throw new (0, $kuJKd.JOSEError)("Failed to parse the JSON Web Key Set HTTP response as JSON");
    }
};
var $be6e6a90b8b547df$export$2e2bcd8739ae039 = $be6e6a90b8b547df$var$fetchJwks;

});


parcelRequire.register("2LuaL", function(module, exports) {

var $jvlXK = parcelRequire("jvlXK");

var $1VVH7 = parcelRequire("1VVH7");

var $kuJKd = parcelRequire("kuJKd");

var $a92RM = parcelRequire("a92RM");

var $aKrku = parcelRequire("aKrku");
class $203760315657db9b$export$6404fb90f16d8733 extends (0, $aKrku.ProduceJWT) {
    encode() {
        const header = $jvlXK.encode(JSON.stringify({
            alg: "none"
        }));
        const payload = $jvlXK.encode(JSON.stringify(this._payload));
        return `${header}.${payload}.`;
    }
    static decode(jwt, options) {
        if (typeof jwt !== "string") throw new (0, $kuJKd.JWTInvalid)("Unsecured JWT must be a string");
        const { 0: encodedHeader, 1: encodedPayload, 2: signature, length: length } = jwt.split(".");
        if (length !== 3 || signature !== "") throw new (0, $kuJKd.JWTInvalid)("Invalid Unsecured JWT");
        let header;
        try {
            header = JSON.parse((0, $1VVH7.decoder).decode($jvlXK.decode(encodedHeader)));
            if (header.alg !== "none") throw new Error();
        } catch  {
            throw new (0, $kuJKd.JWTInvalid)("Invalid Unsecured JWT");
        }
        const payload = (0, $a92RM.default)(header, $jvlXK.decode(encodedPayload), options);
        return {
            payload: payload,
            header: header
        };
    }
}

});

parcelRequire.register("kuFUq", function(module, exports) {

var $cmD9g = parcelRequire("cmD9g");

var $1VVH7 = parcelRequire("1VVH7");

var $bMRvC = parcelRequire("bMRvC");
function $eeb71e4421d69eaa$export$ca23208356ba8d90(token) {
    let protectedB64u;
    if (typeof token === "string") {
        const parts = token.split(".");
        if (parts.length === 3 || parts.length === 5) [protectedB64u] = parts;
    } else if (typeof token === "object" && token) {
        if ("protected" in token) protectedB64u = token.protected;
        else throw new TypeError("Token does not contain a Protected Header");
    }
    try {
        if (typeof protectedB64u !== "string" || !protectedB64u) throw new Error();
        const result = JSON.parse((0, $1VVH7.decoder).decode((0, $cmD9g.decode)(protectedB64u)));
        if (!(0, $bMRvC.default)(result)) throw new Error();
        return result;
    } catch  {
        throw new TypeError("Invalid Token or Protected Header formatting");
    }
}

});
parcelRequire.register("cmD9g", function(module, exports) {

$parcel$export(module.exports, "decode", function () { return $9005e825dc995f8e$export$2f872c0f2117be69; });

var $jvlXK = parcelRequire("jvlXK");
const $9005e825dc995f8e$export$c564cdbbe6da493 = $jvlXK.encode;
const $9005e825dc995f8e$export$2f872c0f2117be69 = $jvlXK.decode;

});


parcelRequire.register("fZAZQ", function(module, exports) {

var $cmD9g = parcelRequire("cmD9g");

var $1VVH7 = parcelRequire("1VVH7");

var $bMRvC = parcelRequire("bMRvC");

var $kuJKd = parcelRequire("kuJKd");
function $ba494045f0adb420$export$dcef71b8fb9a6794(jwt) {
    if (typeof jwt !== "string") throw new (0, $kuJKd.JWTInvalid)("JWTs must use Compact JWS serialization, JWT must be a string");
    const { 1: payload, length: length } = jwt.split(".");
    if (length === 5) throw new (0, $kuJKd.JWTInvalid)("Only JWTs using Compact JWS serialization can be decoded");
    if (length !== 3) throw new (0, $kuJKd.JWTInvalid)("Invalid JWT");
    if (!payload) throw new (0, $kuJKd.JWTInvalid)("JWTs must contain a payload");
    let decoded;
    try {
        decoded = (0, $cmD9g.decode)(payload);
    } catch  {
        throw new (0, $kuJKd.JWTInvalid)("Failed to base64url decode the payload");
    }
    let result;
    try {
        result = JSON.parse((0, $1VVH7.decoder).decode(decoded));
    } catch  {
        throw new (0, $kuJKd.JWTInvalid)("Failed to parse the decoded payload as JSON");
    }
    if (!(0, $bMRvC.default)(result)) throw new (0, $kuJKd.JWTInvalid)("Invalid JWT Claims Set");
    return result;
}

});

parcelRequire.register("3bQx5", function(module, exports) {

var $1PXdM = parcelRequire("1PXdM");
async function $252b261320a794d0$export$a949d36eab55b41f(alg, options) {
    return (0, $1PXdM.generateKeyPair)(alg, options);
}

});
parcelRequire.register("1PXdM", function(module, exports) {

$parcel$export(module.exports, "generateSecret", function () { return $15687dfaa6701ad3$export$25395fe8d170ad7; });
$parcel$export(module.exports, "generateKeyPair", function () { return $15687dfaa6701ad3$export$a949d36eab55b41f; });

var $5hNwt = parcelRequire("5hNwt");

var $kuJKd = parcelRequire("kuJKd");

var $5eZQT = parcelRequire("5eZQT");
async function $15687dfaa6701ad3$export$25395fe8d170ad7(alg, options) {
    let length;
    let algorithm;
    let keyUsages;
    switch(alg){
        case "HS256":
        case "HS384":
        case "HS512":
            length = parseInt(alg.slice(-3), 10);
            algorithm = {
                name: "HMAC",
                hash: `SHA-${length}`,
                length: length
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "A128CBC-HS256":
        case "A192CBC-HS384":
        case "A256CBC-HS512":
            length = parseInt(alg.slice(-3), 10);
            return (0, $5eZQT.default)(new Uint8Array(length >> 3));
        case "A128KW":
        case "A192KW":
        case "A256KW":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-KW",
                length: length
            };
            keyUsages = [
                "wrapKey",
                "unwrapKey"
            ];
            break;
        case "A128GCMKW":
        case "A192GCMKW":
        case "A256GCMKW":
        case "A128GCM":
        case "A192GCM":
        case "A256GCM":
            length = parseInt(alg.slice(1, 4), 10);
            algorithm = {
                name: "AES-GCM",
                length: length
            };
            keyUsages = [
                "encrypt",
                "decrypt"
            ];
            break;
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5hNwt.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}
function $15687dfaa6701ad3$var$getModulusLengthOption(options) {
    const modulusLength = options?.modulusLength ?? 2048;
    if (typeof modulusLength !== "number" || modulusLength < 2048) throw new (0, $kuJKd.JOSENotSupported)("Invalid or unsupported modulusLength option provided, 2048 bits or larger keys must be used");
    return modulusLength;
}
async function $15687dfaa6701ad3$export$a949d36eab55b41f(alg, options) {
    let algorithm;
    let keyUsages;
    switch(alg){
        case "PS256":
        case "PS384":
        case "PS512":
            algorithm = {
                name: "RSA-PSS",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $15687dfaa6701ad3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RS256":
        case "RS384":
        case "RS512":
            algorithm = {
                name: "RSASSA-PKCS1-v1_5",
                hash: `SHA-${alg.slice(-3)}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $15687dfaa6701ad3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "RSA-OAEP":
        case "RSA-OAEP-256":
        case "RSA-OAEP-384":
        case "RSA-OAEP-512":
            algorithm = {
                name: "RSA-OAEP",
                hash: `SHA-${parseInt(alg.slice(-3), 10) || 1}`,
                publicExponent: new Uint8Array([
                    0x01,
                    0x00,
                    0x01
                ]),
                modulusLength: $15687dfaa6701ad3$var$getModulusLengthOption(options)
            };
            keyUsages = [
                "decrypt",
                "unwrapKey",
                "encrypt",
                "wrapKey"
            ];
            break;
        case "ES256":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-256"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES384":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-384"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "ES512":
            algorithm = {
                name: "ECDSA",
                namedCurve: "P-521"
            };
            keyUsages = [
                "sign",
                "verify"
            ];
            break;
        case "EdDSA":
            keyUsages = [
                "sign",
                "verify"
            ];
            const crv = options?.crv ?? "Ed25519";
            switch(crv){
                case "Ed25519":
                case "Ed448":
                    algorithm = {
                        name: crv
                    };
                    break;
                default:
                    throw new (0, $kuJKd.JOSENotSupported)("Invalid or unsupported crv option provided");
            }
            break;
        case "ECDH-ES":
        case "ECDH-ES+A128KW":
        case "ECDH-ES+A192KW":
        case "ECDH-ES+A256KW":
            {
                keyUsages = [
                    "deriveKey",
                    "deriveBits"
                ];
                const crv = options?.crv ?? "P-256";
                switch(crv){
                    case "P-256":
                    case "P-384":
                    case "P-521":
                        algorithm = {
                            name: "ECDH",
                            namedCurve: crv
                        };
                        break;
                    case "X25519":
                    case "X448":
                        algorithm = {
                            name: crv
                        };
                        break;
                    default:
                        throw new (0, $kuJKd.JOSENotSupported)("Invalid or unsupported crv option provided, supported values are P-256, P-384, P-521, X25519, and X448");
                }
                break;
            }
        default:
            throw new (0, $kuJKd.JOSENotSupported)('Invalid or unsupported JWK "alg" (Algorithm) Parameter value');
    }
    return (0, $5hNwt.default).subtle.generateKey(algorithm, options?.extractable ?? false, keyUsages);
}

});


parcelRequire.register("4Agra", function(module, exports) {

var $1PXdM = parcelRequire("1PXdM");
async function $35674648f2b80f5d$export$25395fe8d170ad7(alg, options) {
    return (0, $1PXdM.generateSecret)(alg, options);
}

});

parcelRequire.register("hPhzz", function(module, exports) {

var $6bvWZ = parcelRequire("6bvWZ");
var $cfa4d4ab400872b7$export$2e2bcd8739ae039 = (0, $6bvWZ.default);

});
parcelRequire.register("6bvWZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $480c8dd3bb349949$export$2e2bcd8739ae039; });
var $480c8dd3bb349949$export$2e2bcd8739ae039 = "WebCryptoAPI";

});



parcelRequire.register("fgp9B", function(module, exports) {

$parcel$export(module.exports, "withDefaultScopes", function () { return $b1cbdcb021201dd1$export$3cf0748e30b766d7; });
parcelRequire("6Woc4");

var $3FAnm = parcelRequire("3FAnm");
/**
 * @param originalScopes
 * @return scopes should contain all default scopes (`openid`, `offline_access` and `profile`)
 */ const $b1cbdcb021201dd1$export$3cf0748e30b766d7 = (originalScopes)=>{
    const reservedScopes = Object.values((0, $3FAnm.ReservedScope));
    const uniqueScopes = new Set([
        ...reservedScopes,
        (0, $3FAnm.UserScope).Profile,
        ...originalScopes ?? []
    ]);
    return Array.from(uniqueScopes).join(" ");
};

});


parcelRequire.register("6f1Q2", function(module, exports) {

$parcel$export(module.exports, "generateSignOutUri", function () { return $48b591d6df8c6577$export$b3c9a2bd2330de28; });

var $6Woc4 = parcelRequire("6Woc4");
const $48b591d6df8c6577$export$b3c9a2bd2330de28 = ({ endSessionEndpoint: endSessionEndpoint, clientId: clientId, postLogoutRedirectUri: postLogoutRedirectUri })=>{
    const urlSearchParameters = new URLSearchParams({
        [(0, $6Woc4.QueryKey).ClientId]: clientId
    });
    if (postLogoutRedirectUri) urlSearchParameters.append((0, $6Woc4.QueryKey).PostLogoutRedirectUri, postLogoutRedirectUri);
    return `${endSessionEndpoint}?${urlSearchParameters.toString()}`;
};

});

parcelRequire.register("cIIwT", function(module, exports) {

$parcel$export(module.exports, "fetchUserInfo", function () { return $942c22b857f982bc$export$eee09f98e5b044aa; });
const $942c22b857f982bc$export$eee09f98e5b044aa = async (userInfoEndpoint, accessToken, requester)=>requester(userInfoEndpoint, {
        headers: {
            Authorization: `Bearer ${accessToken}`
        }
    });

});

parcelRequire.register("MM0rY", function(module, exports) {

$parcel$export(module.exports, "verifyAndParseCodeFromCallbackUri", function () { return $0929b8da7016c068$export$dc3fae3c99763885; });
parcelRequire("i6nxh");
var $154Ff = parcelRequire("154Ff");

var $6Woc4 = parcelRequire("6Woc4");

var $du5TZ = parcelRequire("du5TZ");
const $0929b8da7016c068$export$4851e69315d5b72c = (uri)=>{
    const [, queryString = ""] = uri.split("?");
    return new URLSearchParams(queryString);
};
const $0929b8da7016c068$export$dc3fae3c99763885 = (callbackUri, redirectUri, state)=>{
    if (!callbackUri.startsWith(redirectUri)) throw new (0, $du5TZ.LogtoError)("callback_uri_verification.redirect_uri_mismatched");
    const uriParameters = $0929b8da7016c068$export$4851e69315d5b72c(callbackUri);
    const error = (0, $154Ff.conditional)(uriParameters.get((0, $6Woc4.QueryKey).Error));
    const errorDescription = (0, $154Ff.conditional)(uriParameters.get((0, $6Woc4.QueryKey).ErrorDescription));
    if (error) throw new (0, $du5TZ.LogtoError)("callback_uri_verification.error_found", new (0, $du5TZ.OidcError)(error, errorDescription));
    const stateFromCallbackUri = uriParameters.get((0, $6Woc4.QueryKey).State);
    if (!stateFromCallbackUri) throw new (0, $du5TZ.LogtoError)("callback_uri_verification.missing_state");
    if (stateFromCallbackUri !== state) throw new (0, $du5TZ.LogtoError)("callback_uri_verification.state_mismatched");
    const code = uriParameters.get((0, $6Woc4.QueryKey).Code);
    if (!code) throw new (0, $du5TZ.LogtoError)("callback_uri_verification.missing_code");
    return code;
};

});
parcelRequire.register("du5TZ", function(module, exports) {

$parcel$export(module.exports, "LogtoError", function () { return $9d12a7b81c4ec757$export$ba60d77e6748b659; });
$parcel$export(module.exports, "isLogtoRequestError", function () { return $9d12a7b81c4ec757$export$27f79c8238476d38; });
$parcel$export(module.exports, "LogtoRequestError", function () { return $9d12a7b81c4ec757$export$e6e15b8ba42b9b70; });
$parcel$export(module.exports, "OidcError", function () { return $9d12a7b81c4ec757$export$d4832bcf9ce430e0; });

var $1SubF = parcelRequire("1SubF");
const $9d12a7b81c4ec757$var$logtoErrorCodes = Object.freeze({
    "id_token.invalid_iat": "Invalid issued at time in the ID token",
    "id_token.invalid_token": "Invalid ID token",
    "callback_uri_verification.redirect_uri_mismatched": "The callback URI mismatches the redirect URI.",
    "callback_uri_verification.error_found": "Error found in the callback URI",
    "callback_uri_verification.missing_state": "Missing state in the callback URI",
    "callback_uri_verification.state_mismatched": "State mismatched in the callback URI",
    "callback_uri_verification.missing_code": "Missing code in the callback URI",
    crypto_subtle_unavailable: "Crypto.subtle is unavailable in insecure contexts (non-HTTPS).",
    unexpected_response_error: "Unexpected response error from the server."
});
class $9d12a7b81c4ec757$export$ba60d77e6748b659 extends Error {
    constructor(code, data){
        super($9d12a7b81c4ec757$var$logtoErrorCodes[code]);
        this.code = code;
        this.data = data;
    }
}
const $9d12a7b81c4ec757$export$27f79c8238476d38 = (data)=>{
    if (!(0, $1SubF.isArbitraryObject)(data)) return false;
    return typeof data.code === "string" && typeof data.message === "string";
};
class $9d12a7b81c4ec757$export$e6e15b8ba42b9b70 extends Error {
    constructor(code, message){
        super(message);
        this.code = code;
    }
}
class $9d12a7b81c4ec757$export$d4832bcf9ce430e0 {
    constructor(error, errorDescription){
        this.error = error;
        this.errorDescription = errorDescription;
    }
}

});
parcelRequire.register("1SubF", function(module, exports) {

$parcel$export(module.exports, "isArbitraryObject", function () { return $15e240232426e0b5$export$aa016a295c6092c8; });
const $15e240232426e0b5$export$aa016a295c6092c8 = (data)=>typeof data === "object" && data !== null;

});



parcelRequire.register("4OAMv", function(module, exports) {

$parcel$export(module.exports, "verifyIdToken", function () { return $38185cf442405486$export$b5b3317c8aecbcd5; });
$parcel$export(module.exports, "decodeIdToken", function () { return $38185cf442405486$export$aac2d5b7f5cd16d5; });
parcelRequire("i6nxh");
var $5j2Dg = parcelRequire("5j2Dg");
parcelRequire("dTynv");
var $k3kQX = parcelRequire("k3kQX");

var $1SubF = parcelRequire("1SubF");

var $du5TZ = parcelRequire("du5TZ");
const $38185cf442405486$var$issuedAtTimeTolerance = 300; // 5 minutes
/* eslint-disable complexity */ /**
 * @link [ID Token](https://openid.net/specs/openid-connect-core-1_0.html#IDToken)
 */ function $38185cf442405486$var$assertIdTokenClaims(data) {
    if (!(0, $1SubF.isArbitraryObject)(data)) throw new TypeError("IdToken is expected to be an object");
    for (const key of [
        "iss",
        "sub",
        "aud"
    ]){
        if (typeof data[key] !== "string") throw new TypeError(`At path: IdToken.${key}: expected a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (typeof data[key] !== "number") throw new TypeError(`At path: IdToken.${key}: expected a number`);
    }
    for (const key of [
        "at_hash",
        "name",
        "username",
        "picture",
        "email",
        "phone_number"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: IdToken.${key}: expected null or a string`);
    }
    for (const key of [
        "email_verified",
        "phone_number_verified"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "boolean") throw new TypeError(`At path: IdToken.${key}: expected a boolean`);
    }
}
/* eslint-enable complexity */ const $38185cf442405486$export$b5b3317c8aecbcd5 = async (idToken, clientId, issuer, jwks)=>{
    const result = await (0, $k3kQX.jwtVerify)(idToken, jwks, {
        audience: clientId,
        issuer: issuer
    });
    if (Math.abs((result.payload.iat ?? 0) - Date.now() / 1000) > $38185cf442405486$var$issuedAtTimeTolerance) throw new (0, $du5TZ.LogtoError)("id_token.invalid_iat");
};
const $38185cf442405486$export$aac2d5b7f5cd16d5 = (token)=>{
    const { 1: encodedPayload } = token.split(".");
    if (!encodedPayload) throw new (0, $du5TZ.LogtoError)("id_token.invalid_token");
    const json = (0, $5j2Dg.urlSafeBase64).decode(encodedPayload);
    const idTokenClaims = JSON.parse(json);
    $38185cf442405486$var$assertIdTokenClaims(idTokenClaims);
    return idTokenClaims;
};

});

parcelRequire.register("hY42Z", function(module, exports) {

$parcel$export(module.exports, "decodeAccessToken", function () { return $d14b2df3212faaa3$export$1b57a6e65b75f5b3; });
parcelRequire("i6nxh");
var $5j2Dg = parcelRequire("5j2Dg");

var $1SubF = parcelRequire("1SubF");
// https://docs.logto.io/docs/recipes/protect-your-api/
function $d14b2df3212faaa3$var$assertAccessTokenClaims(data) {
    if (!(0, $1SubF.isArbitraryObject)(data)) throw new TypeError("AccessToken is expected to be an object");
    for (const key of [
        "jti",
        "iss",
        "sub",
        "aud",
        "client_id",
        "scope"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "string" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a string`);
    }
    for (const key of [
        "exp",
        "iat"
    ]){
        if (data[key] === undefined) continue;
        if (typeof data[key] !== "number" && data[key] !== null) throw new TypeError(`At path: AccessToken.${key}: expected null or a number`);
    }
}
const $d14b2df3212faaa3$export$1b57a6e65b75f5b3 = (accessToken)=>{
    const { 1: encodedPayload } = accessToken.split(".");
    if (!encodedPayload) // Non-JWT format token string
    return {};
    const json = (0, $5j2Dg.urlSafeBase64).decode(encodedPayload);
    const accessTokenClaims = JSON.parse(json);
    $d14b2df3212faaa3$var$assertAccessTokenClaims(accessTokenClaims);
    return accessTokenClaims;
};

});


parcelRequire.register("kE3hY", function(module, exports) {

$parcel$export(module.exports, "ClientAdapterInstance", function () { return $f07a182debba3ef6$export$63ca545e0fd86684; });
parcelRequire("i6nxh");
var $4V8bV = parcelRequire("4V8bV");
var $154Ff = parcelRequire("154Ff");

var $8r3Dj = parcelRequire("8r3Dj");
class $f07a182debba3ef6$export$63ca545e0fd86684 {
    /* END OF IMPLEMENTATION */ constructor(adapter){
        // eslint-disable-next-line @silverhand/fp/no-mutating-assign
        Object.assign(this, adapter);
    }
    async setStorageItem(key, value) {
        if (!value) {
            await this.storage.removeItem(key);
            return;
        }
        await this.storage.setItem(key, value);
    }
    /**
     * Try to get the string value from the cache and parse as JSON.
     * Return the parsed value if it is an object, return `undefined` otherwise.
     *
     * @param key The cache key to get value from.
     */ async getCachedObject(key) {
        const cached = await (0, $4V8bV.trySafe)(async ()=>{
            const data = await this.unstable_cache?.getItem(key);
            // It's actually `unknown`
            // eslint-disable-next-line no-restricted-syntax
            return (0, $154Ff.conditional)(data && JSON.parse(data));
        });
        if (cached && typeof cached === "object") // Trust cache for now
        // eslint-disable-next-line no-restricted-syntax
        return cached;
    }
    /**
     * Try to get the value from the cache first, if it doesn't exist in cache,
     * run the getter function and store the result into cache.
     *
     * @param key The cache key to get value from.
     */ async getWithCache(key, getter) {
        const cached = await this.getCachedObject(key);
        if (cached) return cached;
        const result = await getter();
        await this.unstable_cache?.setItem(key, JSON.stringify(result));
        return result;
    }
}

});
parcelRequire.register("8r3Dj", function(module, exports) {

$parcel$export(module.exports, "PersistKey", function () { return $6243a9ccb8e724b9$export$ae0fd1fd1ad1c3f8; });
$parcel$export(module.exports, "CacheKey", function () { return $6243a9ccb8e724b9$export$2cb47d384c8dd787; });
var $6243a9ccb8e724b9$export$ae0fd1fd1ad1c3f8;
(function(PersistKey) {
    PersistKey["IdToken"] = "idToken";
    PersistKey["RefreshToken"] = "refreshToken";
    PersistKey["AccessToken"] = "accessToken";
    PersistKey["SignInSession"] = "signInSession";
})($6243a9ccb8e724b9$export$ae0fd1fd1ad1c3f8 || ($6243a9ccb8e724b9$export$ae0fd1fd1ad1c3f8 = {}));
var $6243a9ccb8e724b9$export$2cb47d384c8dd787;
(function(CacheKey) {
    /**
     * OpenID Configuration endpoint response.
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0.html#ProviderConfigurationResponse | OpenID Connect Discovery 1.0}
     */ CacheKey["OpenidConfig"] = "openidConfiguration";
    /**
     * The content of OpenID Provider's `jwks_uri` (JSON Web Key Set).
     *
     * @see {@link https://openid.net/specs/openid-connect-discovery-1_0-21.html#ProviderMetadata | OpenID Connect Discovery 1.0}
     */ CacheKey["Jwks"] = "jwks";
})($6243a9ccb8e724b9$export$2cb47d384c8dd787 || ($6243a9ccb8e724b9$export$2cb47d384c8dd787 = {}));

});


parcelRequire.register("jwQhE", function(module, exports) {

$parcel$export(module.exports, "LogtoClientError", function () { return $e3798feba2b6dbd0$export$877962ca249b8fc8; });
parcelRequire("9JeGV");
var $3FAnm = parcelRequire("3FAnm");
const $e3798feba2b6dbd0$var$logtoClientErrorCodes = Object.freeze({
    "sign_in_session.invalid": "Invalid sign-in session.",
    "sign_in_session.not_found": "Sign-in session not found.",
    not_authenticated: "Not authenticated.",
    fetch_user_info_failed: "Unable to fetch user info. The access token may be invalid.",
    user_cancelled: "The user cancelled the action.",
    missing_scope_organizations: `The \`${(0, $3FAnm.UserScope).Organizations}\` scope is required`
});
class $e3798feba2b6dbd0$export$877962ca249b8fc8 extends Error {
    constructor(code, data){
        super($e3798feba2b6dbd0$var$logtoClientErrorCodes[code]);
        this.name = "LogtoClientError";
        this.code = code;
        this.data = data;
    }
}

});

parcelRequire.register("kCFLl", function(module, exports) {

$parcel$export(module.exports, "CachedRemoteJwkSet", function () { return $f037c0710f7bc311$export$da08ef74d5a8d180; });
parcelRequire("i6nxh");
var $8dGzF = parcelRequire("8dGzF");
parcelRequire("dTynv");
var $kAtWh = parcelRequire("kAtWh");

var $8r3Dj = parcelRequire("8r3Dj");
// Edited from jose's internal util `isJWKSLike`
function $f037c0710f7bc311$var$isJwkSetLike(jwkSet) {
    return Boolean(jwkSet && typeof jwkSet === "object" && "keys" in jwkSet && Array.isArray(jwkSet.keys) && jwkSet.keys.every((element)=>(0, $8dGzF.isObject)(element)));
}
class $f037c0710f7bc311$export$da08ef74d5a8d180 {
    constructor(url, adapter){
        this.url = url;
        this.adapter = adapter;
        if (!adapter.unstable_cache) throw new Error("No cache found in the client adapter. Use `createRemoteJWKSet()` from 'jose' instead.");
    }
    async getKey(...args) {
        if (!this.jwkSet) this.jwkSet = await this.#load();
        try {
            return await this.#getLocalKey(...args);
        } catch (error) {
            // Jose does not export the error definition
            // Found in https://github.com/panva/jose/blob/d5b3cb672736112b1e1e31ac4d5e9cd641675206/src/util/errors.ts#L347
            if (error instanceof Error && "code" in error && error.code === "ERR_JWKS_NO_MATCHING_KEY") {
                this.jwkSet = await this.#load();
                return this.#getLocalKey(...args);
            }
            throw error;
        }
    }
    async #load() {
        return this.adapter.getWithCache((0, $8r3Dj.CacheKey).Jwks, async ()=>{
            const controller = new AbortController();
            const response = await fetch(this.url, {
                signal: controller.signal,
                redirect: "manual"
            });
            if (!response.ok) throw new Error("Expected OK from the JSON Web Key Set HTTP response");
            const json = await response.json();
            if (!$f037c0710f7bc311$var$isJwkSetLike(json)) throw new Error("JSON Web Key Set malformed");
            return json;
        });
    }
    async #getLocalKey(...args) {
        if (!this.jwkSet) throw new Error("No local JWK Set found.");
        return (0, $kAtWh.createLocalJWKSet)(this.jwkSet)(...args);
    }
}

});

parcelRequire.register("agFc7", function(module, exports) {

$parcel$export(module.exports, "normalizeLogtoConfig", function () { return $779b5a5989c5ce59$export$36dfb28a0f06fe9c; });
$parcel$export(module.exports, "isLogtoSignInSessionItem", function () { return $779b5a5989c5ce59$export$5d8adf6e063019de; });
$parcel$export(module.exports, "isLogtoAccessTokenMap", function () { return $779b5a5989c5ce59$export$c12fab42a9a3e2a6; });
parcelRequire("9JeGV");
var $6Woc4 = parcelRequire("6Woc4");
var $fgp9B = parcelRequire("fgp9B");
var $3FAnm = parcelRequire("3FAnm");
var $1SubF = parcelRequire("1SubF");
parcelRequire("i6nxh");
var $8A4N0 = parcelRequire("8A4N0");
/**
 * Normalize the Logto client configuration per the following rules:
 *
 * - Add default scopes (`openid`, `offline_access` and `profile`) if not provided.
 * - Add {@link ReservedResource.Organization} to resources if {@link UserScope.Organizations} is included in scopes.
 *
 * @param config The Logto client configuration to be normalized.
 * @returns The normalized Logto client configuration.
 */ const $779b5a5989c5ce59$export$36dfb28a0f06fe9c = (config)=>{
    const { prompt: prompt = (0, $6Woc4.Prompt).Consent, scopes: scopes = [], resources: resources, ...rest } = config;
    return {
        ...rest,
        prompt: prompt,
        scopes: (0, $fgp9B.withDefaultScopes)(scopes).split(" "),
        resources: scopes.includes((0, $3FAnm.UserScope).Organizations) ? (0, $8A4N0.deduplicate)([
            ...resources ?? [],
            (0, $3FAnm.ReservedResource).Organization
        ]) : resources
    };
};
const $779b5a5989c5ce59$export$5d8adf6e063019de = (data)=>{
    if (!(0, $1SubF.isArbitraryObject)(data)) return false;
    return [
        "redirectUri",
        "codeVerifier",
        "state"
    ].every((key)=>typeof data[key] === "string");
};
const $779b5a5989c5ce59$export$c12fab42a9a3e2a6 = (data)=>{
    if (!(0, $1SubF.isArbitraryObject)(data)) return false;
    return Object.values(data).every((value)=>{
        if (!(0, $1SubF.isArbitraryObject)(value)) return false;
        return typeof value.token === "string" && typeof value.scope === "string" && typeof value.expiresAt === "number";
    });
};

});

parcelRequire.register("5Yufm", function(module, exports) {

$parcel$export(module.exports, "buildAccessTokenKey", function () { return $459a04bc42785533$export$8f595bd2a47bcea6; });
$parcel$export(module.exports, "getDiscoveryEndpoint", function () { return $459a04bc42785533$export$5d9c34f69c80822b; });
parcelRequire("9JeGV");
var $7xrzW = parcelRequire("7xrzW");
parcelRequire("i6nxh");
var $154Ff = parcelRequire("154Ff");
const $459a04bc42785533$export$8f595bd2a47bcea6 = (resource = "", organizationId, scopes = [])=>`${scopes.slice().sort().join(" ")}@${resource}${(0, $154Ff.conditionalString)(organizationId && `#${organizationId}`)}`;
const $459a04bc42785533$export$5d9c34f69c80822b = (endpoint)=>new URL((0, $7xrzW.discoveryPath), endpoint).toString();

});

parcelRequire.register("koOVm", function(module, exports) {

$parcel$export(module.exports, "memoize", function () { return $ed9d8d0624322120$export$fc10aeed3a532e2a; });
function $ed9d8d0624322120$export$fc10aeed3a532e2a(run) {
    const promiseCache = new Map();
    const memoized = async function(...args) {
        const promiseKey = args[0];
        const cachedPromise = promiseCache.get(promiseKey);
        if (cachedPromise) return cachedPromise;
        const promise = (async ()=>{
            try {
                return await run.apply(this, args);
            } finally{
                promiseCache.delete(promiseKey);
            }
        })();
        promiseCache.set(promiseKey, promise);
        return promise;
    };
    return memoized;
}

});

parcelRequire.register("j34cR", function(module, exports) {

$parcel$export(module.exports, "once", function () { return $dde18f714ae47e35$export$d2de3aaeafa91619; });
// TODO @sijie move to essentials
/* eslint-disable @silverhand/fp/no-let */ /* eslint-disable @silverhand/fp/no-mutation */ function $dde18f714ae47e35$export$d2de3aaeafa91619(function_) {
    let called = false;
    let result;
    return function(...args) {
        if (!called) {
            called = true;
            result = function_.apply(this, args);
        }
        return result;
    };
}

});

parcelRequire.register("70kRi", function(module, exports) {

$parcel$export(module.exports, "createRequester", function () { return $5198b697e0a3cc5a$export$8d54726fdbf08e0a; });
parcelRequire("9JeGV");
var $du5TZ = parcelRequire("du5TZ");
/**
 * A factory function that creates a requester by accepting a `fetch`-like function.
 *
 * @param fetchFunction A `fetch`-like function.
 * @returns A requester function.
 * @see {@link Requester}
 */ const $5198b697e0a3cc5a$export$8d54726fdbf08e0a = (fetchFunction)=>{
    return async (...args)=>{
        const response = await fetchFunction(...args);
        if (!response.ok) {
            const responseJson = await response.json();
            if (!(0, $du5TZ.isLogtoRequestError)(responseJson)) throw new (0, $du5TZ.LogtoError)("unexpected_response_error", responseJson);
            // Expected request error from server
            const { code: code, message: message } = responseJson;
            throw new (0, $du5TZ.LogtoRequestError)(code, message);
        }
        return response.json();
    };
};

});


parcelRequire.register("i6ct6", function(module, exports) {

$parcel$export(module.exports, "CacheStorage", function () { return $d2d2757e8dbe08cc$export$2b715f8922748263; });
const $d2d2757e8dbe08cc$var$keyPrefix = `logto_cache`;
class $d2d2757e8dbe08cc$export$2b715f8922748263 {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$d2d2757e8dbe08cc$var$keyPrefix}:${this.appId}`;
        return `${$d2d2757e8dbe08cc$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        return sessionStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        sessionStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        sessionStorage.removeItem(`${this.getKey(key)}`);
    }
}

});

parcelRequire.register("bNOoh", function(module, exports) {

$parcel$export(module.exports, "BrowserStorage", function () { return $897b5bdd2c9a810f$export$2baa60fa09b100be; });
const $897b5bdd2c9a810f$var$keyPrefix = `logto`;
class $897b5bdd2c9a810f$export$2baa60fa09b100be {
    constructor(appId){
        this.appId = appId;
    }
    getKey(item) {
        if (item === undefined) return `${$897b5bdd2c9a810f$var$keyPrefix}:${this.appId}`;
        return `${$897b5bdd2c9a810f$var$keyPrefix}:${this.appId}:${item}`;
    }
    async getItem(key) {
        if (key === "signInSession") // The latter `getItem()` is for backward compatibility. Can be removed when major bump.
        return sessionStorage.getItem(this.getKey(key)) ?? sessionStorage.getItem(this.getKey());
        return localStorage.getItem(this.getKey(key));
    }
    async setItem(key, value) {
        if (key === "signInSession") {
            sessionStorage.setItem(this.getKey(key), value);
            return;
        }
        localStorage.setItem(this.getKey(key), value);
    }
    async removeItem(key) {
        if (key === "signInSession") {
            sessionStorage.removeItem(this.getKey(key));
            return;
        }
        localStorage.removeItem(this.getKey(key));
    }
}

});

parcelRequire.register("jrkmB", function(module, exports) {

$parcel$export(module.exports, "generateState", function () { return $e27055bcba3bdb84$export$9ccd2716e53a229b; });
$parcel$export(module.exports, "generateCodeVerifier", function () { return $e27055bcba3bdb84$export$cf1891f923f5943a; });
$parcel$export(module.exports, "generateCodeChallenge", function () { return $e27055bcba3bdb84$export$414b01b1f867308a; });
parcelRequire("iP5g2");
var $du5TZ = parcelRequire("du5TZ");

var $l5jM9 = parcelRequire("l5jM9");
/** @link [Proof Key for Code Exchange by OAuth Public Clients](https://datatracker.ietf.org/doc/html/rfc7636) */ /**
 * @param length The length of the raw random data.
 */ const $e27055bcba3bdb84$var$generateRandomString = (length = 64)=>(0, $l5jM9.fromUint8Array)(crypto.getRandomValues(new Uint8Array(length)), true);
/**
 * Generates random string for state and encodes them in url safe base64
 */ const $e27055bcba3bdb84$export$9ccd2716e53a229b = ()=>$e27055bcba3bdb84$var$generateRandomString();
/**
 * Generates code verifier
 *
 * @link [Client Creates a Code Verifier](https://datatracker.ietf.org/doc/html/rfc7636#section-4.1)
 */ const $e27055bcba3bdb84$export$cf1891f923f5943a = ()=>$e27055bcba3bdb84$var$generateRandomString();
/**
 * Calculates the S256 PKCE code challenge for an arbitrary code verifier and encodes it in url safe base64
 *
 * @param {String} codeVerifier Code verifier to calculate the S256 code challenge for
 * @link [Client Creates the Code Challenge](https://datatracker.ietf.org/doc/html/rfc7636#section-4.2)
 */ const $e27055bcba3bdb84$export$414b01b1f867308a = async (codeVerifier)=>{
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (crypto.subtle === undefined) /**
         * `crypto.subtle` is available only in secure contexts (HTTPS) in some or all supporting browsers,
         * https://developer.mozilla.org/en-US/docs/Web/API/Crypto/subtle
         * https://www.chromium.org/blink/webcrypto/#accessing-it
         */ throw new (0, $du5TZ.LogtoError)("crypto_subtle_unavailable");
    const encodedCodeVerifier = new TextEncoder().encode(codeVerifier);
    const codeChallenge = new Uint8Array(await crypto.subtle.digest("SHA-256", encodedCodeVerifier));
    return (0, $l5jM9.fromUint8Array)(codeChallenge, true);
};

});
parcelRequire.register("l5jM9", function(module, exports) {

$parcel$export(module.exports, "fromUint8Array", function () { return $40211cd58a057a1c$export$27bbb4e040978768; });
/**
 *  base64.ts
 *
 *  Licensed under the BSD 3-Clause License.
 *    http://opensource.org/licenses/BSD-3-Clause
 *
 *  References:
 *    http://en.wikipedia.org/wiki/Base64
 *
 * @author Dan Kogai (https://github.com/dankogai)
 */ 
var $5wduI = parcelRequire("5wduI");
var $40211cd58a057a1c$require$Buffer = $5wduI.Buffer;
const $40211cd58a057a1c$export$83d89fbfd8236492 = "3.7.5";
/**
 * @deprecated use lowercase `version`.
 */ const $40211cd58a057a1c$export$a4ad2735b021c132 = $40211cd58a057a1c$export$83d89fbfd8236492;
const $40211cd58a057a1c$var$_hasatob = typeof atob === "function";
const $40211cd58a057a1c$var$_hasbtoa = typeof btoa === "function";
const $40211cd58a057a1c$var$_hasBuffer = typeof $40211cd58a057a1c$require$Buffer === "function";
const $40211cd58a057a1c$var$_TD = typeof TextDecoder === "function" ? new TextDecoder() : undefined;
const $40211cd58a057a1c$var$_TE = typeof TextEncoder === "function" ? new TextEncoder() : undefined;
const $40211cd58a057a1c$var$b64ch = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
const $40211cd58a057a1c$var$b64chs = Array.prototype.slice.call($40211cd58a057a1c$var$b64ch);
const $40211cd58a057a1c$var$b64tab = ((a)=>{
    let tab = {};
    a.forEach((c, i)=>tab[c] = i);
    return tab;
})($40211cd58a057a1c$var$b64chs);
const $40211cd58a057a1c$var$b64re = /^(?:[A-Za-z\d+\/]{4})*?(?:[A-Za-z\d+\/]{2}(?:==)?|[A-Za-z\d+\/]{3}=?)?$/;
const $40211cd58a057a1c$var$_fromCC = String.fromCharCode.bind(String);
const $40211cd58a057a1c$var$_U8Afrom = typeof Uint8Array.from === "function" ? Uint8Array.from.bind(Uint8Array) : (it)=>new Uint8Array(Array.prototype.slice.call(it, 0));
const $40211cd58a057a1c$var$_mkUriSafe = (src)=>src.replace(/=/g, "").replace(/[+\/]/g, (m0)=>m0 == "+" ? "-" : "_");
const $40211cd58a057a1c$var$_tidyB64 = (s)=>s.replace(/[^A-Za-z0-9\+\/]/g, "");
/**
 * polyfill version of `btoa`
 */ const $40211cd58a057a1c$export$ec0fb543302ee251 = (bin)=>{
    // console.log('polyfilled');
    let u32, c0, c1, c2, asc = "";
    const pad = bin.length % 3;
    for(let i = 0; i < bin.length;){
        if ((c0 = bin.charCodeAt(i++)) > 255 || (c1 = bin.charCodeAt(i++)) > 255 || (c2 = bin.charCodeAt(i++)) > 255) throw new TypeError("invalid character found");
        u32 = c0 << 16 | c1 << 8 | c2;
        asc += $40211cd58a057a1c$var$b64chs[u32 >> 18 & 63] + $40211cd58a057a1c$var$b64chs[u32 >> 12 & 63] + $40211cd58a057a1c$var$b64chs[u32 >> 6 & 63] + $40211cd58a057a1c$var$b64chs[u32 & 63];
    }
    return pad ? asc.slice(0, pad - 3) + "===".substring(pad) : asc;
};
/**
 * does what `window.btoa` of web browsers do.
 * @param {String} bin binary string
 * @returns {string} Base64-encoded string
 */ const $40211cd58a057a1c$export$a32219e24f8d1e2 = $40211cd58a057a1c$var$_hasbtoa ? (bin)=>btoa(bin) : $40211cd58a057a1c$var$_hasBuffer ? (bin)=>$40211cd58a057a1c$require$Buffer.from(bin, "binary").toString("base64") : $40211cd58a057a1c$export$ec0fb543302ee251;
const $40211cd58a057a1c$var$_fromUint8Array = $40211cd58a057a1c$var$_hasBuffer ? (u8a)=>$40211cd58a057a1c$require$Buffer.from(u8a).toString("base64") : (u8a)=>{
    // cf. https://stackoverflow.com/questions/12710001/how-to-convert-uint8-array-to-base64-encoded-string/12713326#12713326
    const maxargs = 0x1000;
    let strs = [];
    for(let i = 0, l = u8a.length; i < l; i += maxargs)strs.push($40211cd58a057a1c$var$_fromCC.apply(null, u8a.subarray(i, i + maxargs)));
    return $40211cd58a057a1c$export$a32219e24f8d1e2(strs.join(""));
};
/**
 * converts a Uint8Array to a Base64 string.
 * @param {boolean} [urlsafe] URL-and-filename-safe a la RFC4648 §5
 * @returns {string} Base64 string
 */ const $40211cd58a057a1c$export$27bbb4e040978768 = (u8a, urlsafe = false)=>urlsafe ? $40211cd58a057a1c$var$_mkUriSafe($40211cd58a057a1c$var$_fromUint8Array(u8a)) : $40211cd58a057a1c$var$_fromUint8Array(u8a);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const utob = (src: string) => unescape(encodeURIComponent(src));
// reverting good old fationed regexp
const $40211cd58a057a1c$var$cb_utob = (c)=>{
    if (c.length < 2) {
        var cc = c.charCodeAt(0);
        return cc < 0x80 ? c : cc < 0x800 ? $40211cd58a057a1c$var$_fromCC(0xc0 | cc >>> 6) + $40211cd58a057a1c$var$_fromCC(0x80 | cc & 0x3f) : $40211cd58a057a1c$var$_fromCC(0xe0 | cc >>> 12 & 0x0f) + $40211cd58a057a1c$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $40211cd58a057a1c$var$_fromCC(0x80 | cc & 0x3f);
    } else {
        var cc = 0x10000 + (c.charCodeAt(0) - 0xD800) * 0x400 + (c.charCodeAt(1) - 0xDC00);
        return $40211cd58a057a1c$var$_fromCC(0xf0 | cc >>> 18 & 0x07) + $40211cd58a057a1c$var$_fromCC(0x80 | cc >>> 12 & 0x3f) + $40211cd58a057a1c$var$_fromCC(0x80 | cc >>> 6 & 0x3f) + $40211cd58a057a1c$var$_fromCC(0x80 | cc & 0x3f);
    }
};
const $40211cd58a057a1c$var$re_utob = /[\uD800-\uDBFF][\uDC00-\uDFFFF]|[^\x00-\x7F]/g;
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-8 string
 * @returns {string} UTF-16 string
 */ const $40211cd58a057a1c$export$10d4b9bd20a66b0 = (u)=>u.replace($40211cd58a057a1c$var$re_utob, $40211cd58a057a1c$var$cb_utob);
//
const $40211cd58a057a1c$var$_encode = $40211cd58a057a1c$var$_hasBuffer ? (s)=>$40211cd58a057a1c$require$Buffer.from(s, "utf8").toString("base64") : $40211cd58a057a1c$var$_TE ? (s)=>$40211cd58a057a1c$var$_fromUint8Array($40211cd58a057a1c$var$_TE.encode(s)) : (s)=>$40211cd58a057a1c$export$a32219e24f8d1e2($40211cd58a057a1c$export$10d4b9bd20a66b0(s));
/**
 * converts a UTF-8-encoded string to a Base64 string.
 * @param {boolean} [urlsafe] if `true` make the result URL-safe
 * @returns {string} Base64 string
 */ const $40211cd58a057a1c$export$37cc283d8fbd3462 = (src, urlsafe = false)=>urlsafe ? $40211cd58a057a1c$var$_mkUriSafe($40211cd58a057a1c$var$_encode(src)) : $40211cd58a057a1c$var$_encode(src);
/**
 * converts a UTF-8-encoded string to URL-safe Base64 RFC4648 §5.
 * @returns {string} Base64 string
 */ const $40211cd58a057a1c$export$90c31d5baa78df44 = (src)=>$40211cd58a057a1c$export$37cc283d8fbd3462(src, true);
// This trick is found broken https://github.com/dankogai/js-base64/issues/130
// const btou = (src: string) => decodeURIComponent(escape(src));
// reverting good old fationed regexp
const $40211cd58a057a1c$var$re_btou = /[\xC0-\xDF][\x80-\xBF]|[\xE0-\xEF][\x80-\xBF]{2}|[\xF0-\xF7][\x80-\xBF]{3}/g;
const $40211cd58a057a1c$var$cb_btou = (cccc)=>{
    switch(cccc.length){
        case 4:
            var cp = (0x07 & cccc.charCodeAt(0)) << 18 | (0x3f & cccc.charCodeAt(1)) << 12 | (0x3f & cccc.charCodeAt(2)) << 6 | 0x3f & cccc.charCodeAt(3), offset = cp - 0x10000;
            return $40211cd58a057a1c$var$_fromCC((offset >>> 10) + 0xD800) + $40211cd58a057a1c$var$_fromCC((offset & 0x3FF) + 0xDC00);
        case 3:
            return $40211cd58a057a1c$var$_fromCC((0x0f & cccc.charCodeAt(0)) << 12 | (0x3f & cccc.charCodeAt(1)) << 6 | 0x3f & cccc.charCodeAt(2));
        default:
            return $40211cd58a057a1c$var$_fromCC((0x1f & cccc.charCodeAt(0)) << 6 | 0x3f & cccc.charCodeAt(1));
    }
};
/**
 * @deprecated should have been internal use only.
 * @param {string} src UTF-16 string
 * @returns {string} UTF-8 string
 */ const $40211cd58a057a1c$export$67e9defdeac3dd95 = (b)=>b.replace($40211cd58a057a1c$var$re_btou, $40211cd58a057a1c$var$cb_btou);
/**
 * polyfill version of `atob`
 */ const $40211cd58a057a1c$export$7f16d8e674ddec24 = (asc)=>{
    // console.log('polyfilled');
    asc = asc.replace(/\s+/g, "");
    if (!$40211cd58a057a1c$var$b64re.test(asc)) throw new TypeError("malformed base64.");
    asc += "==".slice(2 - (asc.length & 3));
    let u24, bin = "", r1, r2;
    for(let i = 0; i < asc.length;){
        u24 = $40211cd58a057a1c$var$b64tab[asc.charAt(i++)] << 18 | $40211cd58a057a1c$var$b64tab[asc.charAt(i++)] << 12 | (r1 = $40211cd58a057a1c$var$b64tab[asc.charAt(i++)]) << 6 | (r2 = $40211cd58a057a1c$var$b64tab[asc.charAt(i++)]);
        bin += r1 === 64 ? $40211cd58a057a1c$var$_fromCC(u24 >> 16 & 255) : r2 === 64 ? $40211cd58a057a1c$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255) : $40211cd58a057a1c$var$_fromCC(u24 >> 16 & 255, u24 >> 8 & 255, u24 & 255);
    }
    return bin;
};
/**
 * does what `window.atob` of web browsers do.
 * @param {String} asc Base64-encoded string
 * @returns {string} binary string
 */ const $40211cd58a057a1c$export$1406ac7a6dfd7b7a = $40211cd58a057a1c$var$_hasatob ? (asc)=>atob($40211cd58a057a1c$var$_tidyB64(asc)) : $40211cd58a057a1c$var$_hasBuffer ? (asc)=>$40211cd58a057a1c$require$Buffer.from(asc, "base64").toString("binary") : $40211cd58a057a1c$export$7f16d8e674ddec24;
//
const $40211cd58a057a1c$var$_toUint8Array = $40211cd58a057a1c$var$_hasBuffer ? (a)=>$40211cd58a057a1c$var$_U8Afrom($40211cd58a057a1c$require$Buffer.from(a, "base64")) : (a)=>$40211cd58a057a1c$var$_U8Afrom($40211cd58a057a1c$export$1406ac7a6dfd7b7a(a).split("").map((c)=>c.charCodeAt(0)));
/**
 * converts a Base64 string to a Uint8Array.
 */ const $40211cd58a057a1c$export$73470fd2221e6aef = (a)=>$40211cd58a057a1c$var$_toUint8Array($40211cd58a057a1c$var$_unURI(a));
//
const $40211cd58a057a1c$var$_decode = $40211cd58a057a1c$var$_hasBuffer ? (a)=>$40211cd58a057a1c$require$Buffer.from(a, "base64").toString("utf8") : $40211cd58a057a1c$var$_TD ? (a)=>$40211cd58a057a1c$var$_TD.decode($40211cd58a057a1c$var$_toUint8Array(a)) : (a)=>$40211cd58a057a1c$export$67e9defdeac3dd95($40211cd58a057a1c$export$1406ac7a6dfd7b7a(a));
const $40211cd58a057a1c$var$_unURI = (a)=>$40211cd58a057a1c$var$_tidyB64(a.replace(/[-_]/g, (m0)=>m0 == "-" ? "+" : "/"));
/**
 * converts a Base64 string to a UTF-8 string.
 * @param {String} src Base64 string.  Both normal and URL-safe are supported
 * @returns {string} UTF-8 string
 */ const $40211cd58a057a1c$export$c537b38001c583b7 = (src)=>$40211cd58a057a1c$var$_decode($40211cd58a057a1c$var$_unURI(src));
/**
 * check if a value is a valid Base64 string
 * @param {String} src a value to check
  */ const $40211cd58a057a1c$export$1ea939691cdc45b8 = (src)=>{
    if (typeof src !== "string") return false;
    const s = src.replace(/\s+/g, "").replace(/={0,2}$/, "");
    return !/[^\s0-9a-zA-Z\+/]/.test(s) || !/[^\s0-9a-zA-Z\-_]/.test(s);
};
//
const $40211cd58a057a1c$var$_noEnum = (v)=>{
    return {
        value: v,
        enumerable: false,
        writable: true,
        configurable: true
    };
};
/**
 * extend String.prototype with relevant methods
 */ const $40211cd58a057a1c$export$4678ebf2295c49b = function() {
    const _add = (name, body)=>Object.defineProperty(String.prototype, name, $40211cd58a057a1c$var$_noEnum(body));
    _add("fromBase64", function() {
        return $40211cd58a057a1c$export$c537b38001c583b7(this);
    });
    _add("toBase64", function(urlsafe) {
        return $40211cd58a057a1c$export$37cc283d8fbd3462(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $40211cd58a057a1c$export$37cc283d8fbd3462(this, true);
    });
    _add("toBase64URL", function() {
        return $40211cd58a057a1c$export$37cc283d8fbd3462(this, true);
    });
    _add("toUint8Array", function() {
        return $40211cd58a057a1c$export$73470fd2221e6aef(this);
    });
};
/**
 * extend Uint8Array.prototype with relevant methods
 */ const $40211cd58a057a1c$export$a105d6a15258bd2 = function() {
    const _add = (name, body)=>Object.defineProperty(Uint8Array.prototype, name, $40211cd58a057a1c$var$_noEnum(body));
    _add("toBase64", function(urlsafe) {
        return $40211cd58a057a1c$export$27bbb4e040978768(this, urlsafe);
    });
    _add("toBase64URI", function() {
        return $40211cd58a057a1c$export$27bbb4e040978768(this, true);
    });
    _add("toBase64URL", function() {
        return $40211cd58a057a1c$export$27bbb4e040978768(this, true);
    });
};
/**
 * extend Builtin prototypes with relevant methods
 */ const $40211cd58a057a1c$export$1abf1fe5ebfd5245 = ()=>{
    $40211cd58a057a1c$export$4678ebf2295c49b();
    $40211cd58a057a1c$export$a105d6a15258bd2();
};
const $40211cd58a057a1c$export$f436b0c2107cbd35 = {
    version: $40211cd58a057a1c$export$83d89fbfd8236492,
    VERSION: $40211cd58a057a1c$export$a4ad2735b021c132,
    atob: $40211cd58a057a1c$export$1406ac7a6dfd7b7a,
    atobPolyfill: $40211cd58a057a1c$export$7f16d8e674ddec24,
    btoa: $40211cd58a057a1c$export$a32219e24f8d1e2,
    btoaPolyfill: $40211cd58a057a1c$export$ec0fb543302ee251,
    fromBase64: $40211cd58a057a1c$export$c537b38001c583b7,
    toBase64: $40211cd58a057a1c$export$37cc283d8fbd3462,
    encode: $40211cd58a057a1c$export$37cc283d8fbd3462,
    encodeURI: $40211cd58a057a1c$export$90c31d5baa78df44,
    encodeURL: $40211cd58a057a1c$export$90c31d5baa78df44,
    utob: $40211cd58a057a1c$export$10d4b9bd20a66b0,
    btou: $40211cd58a057a1c$export$67e9defdeac3dd95,
    decode: $40211cd58a057a1c$export$c537b38001c583b7,
    isValid: $40211cd58a057a1c$export$1ea939691cdc45b8,
    fromUint8Array: $40211cd58a057a1c$export$27bbb4e040978768,
    toUint8Array: $40211cd58a057a1c$export$73470fd2221e6aef,
    extendString: $40211cd58a057a1c$export$4678ebf2295c49b,
    extendUint8Array: $40211cd58a057a1c$export$a105d6a15258bd2,
    extendBuiltins: $40211cd58a057a1c$export$1abf1fe5ebfd5245
};

});



parcelRequire.register("dbZ39", function(module, exports) {

$parcel$export(module.exports, "LogtoProvider", function () { return $99aba8ab99a44d3a$export$bfa587c2c3245948; });

var $9zeGj = parcelRequire("9zeGj");

var $4OCmV = parcelRequire("4OCmV");

var $eCoWV = parcelRequire("eCoWV");

var $8Er2w = parcelRequire("8Er2w");
const $99aba8ab99a44d3a$export$bfa587c2c3245948 = ({ config: config, children: children, unstable_enableCache: unstable_enableCache = false })=>{
    const [loadingCount, setLoadingCount] = (0, $eCoWV.useState)(1);
    const memorizedLogtoClient = (0, $eCoWV.useMemo)(()=>({
            logtoClient: new (0, $4OCmV.default)(config, unstable_enableCache)
        }), [
        config,
        unstable_enableCache
    ]);
    const [isAuthenticated, setIsAuthenticated] = (0, $eCoWV.useState)(false);
    const [error, setError] = (0, $eCoWV.useState)();
    (0, $eCoWV.useEffect)(()=>{
        (async ()=>{
            const isAuthenticated = await memorizedLogtoClient.logtoClient.isAuthenticated();
            setIsAuthenticated(isAuthenticated);
            setLoadingCount((count)=>Math.max(0, count - 1));
        })();
    }, [
        memorizedLogtoClient
    ]);
    const memorizedContextValue = (0, $eCoWV.useMemo)(()=>({
            ...memorizedLogtoClient,
            isAuthenticated: isAuthenticated,
            setIsAuthenticated: setIsAuthenticated,
            loadingCount: loadingCount,
            setLoadingCount: setLoadingCount,
            error: error,
            setError: setError
        }), [
        memorizedLogtoClient,
        isAuthenticated,
        loadingCount,
        error
    ]);
    return (0, $9zeGj.jsx)((0, $8Er2w.LogtoContext).Provider, {
        value: memorizedContextValue,
        children: children
    });
};

});
parcelRequire.register("8Er2w", function(module, exports) {

$parcel$export(module.exports, "throwContextError", function () { return $64c708a951ebbaf9$export$838ead842aa548e7; });
$parcel$export(module.exports, "LogtoContext", function () { return $64c708a951ebbaf9$export$e5bf247804b97da7; });

var $eCoWV = parcelRequire("eCoWV");
const $64c708a951ebbaf9$export$838ead842aa548e7 = ()=>{
    throw new Error("Must be used inside <LogtoProvider> context.");
};
const $64c708a951ebbaf9$export$e5bf247804b97da7 = (0, $eCoWV.createContext)({
    logtoClient: undefined,
    isAuthenticated: false,
    loadingCount: 0,
    error: undefined,
    setIsAuthenticated: $64c708a951ebbaf9$export$838ead842aa548e7,
    setLoadingCount: $64c708a951ebbaf9$export$838ead842aa548e7,
    setError: $64c708a951ebbaf9$export$838ead842aa548e7
});

});


parcelRequire.register("dtOpc", function(module, exports) {

$parcel$export(module.exports, "useHandleSignInCallback", function () { return $9d0515444eeb1d1a$export$84e88c4b3c082374; });
$parcel$export(module.exports, "useLogto", function () { return $9d0515444eeb1d1a$export$44fc9df4d2a1789a; });

var $eCoWV = parcelRequire("eCoWV");

var $8Er2w = parcelRequire("8Er2w");
const $9d0515444eeb1d1a$var$useLoadingState = ()=>{
    const { loadingCount: loadingCount, setLoadingCount: setLoadingCount } = (0, $eCoWV.useContext)((0, $8Er2w.LogtoContext));
    const isLoading = loadingCount > 0;
    const setLoadingState = (0, $eCoWV.useCallback)((state)=>{
        if (state) setLoadingCount((count)=>count + 1);
        else setLoadingCount((count)=>Math.max(0, count - 1));
    }, [
        setLoadingCount
    ]);
    return {
        isLoading: isLoading,
        setLoadingState: setLoadingState
    };
};
const $9d0515444eeb1d1a$var$useErrorHandler = ()=>{
    const { setError: setError } = (0, $eCoWV.useContext)((0, $8Er2w.LogtoContext));
    const handleError = (0, $eCoWV.useCallback)((error, fallbackErrorMessage)=>{
        if (error instanceof Error) setError(error);
        else if (fallbackErrorMessage) setError(new Error(fallbackErrorMessage));
        console.error(error);
    }, [
        setError
    ]);
    return {
        handleError: handleError
    };
};
const $9d0515444eeb1d1a$export$84e88c4b3c082374 = (callback)=>{
    const { logtoClient: logtoClient, isAuthenticated: isAuthenticated, error: error, setIsAuthenticated: setIsAuthenticated } = (0, $eCoWV.useContext)((0, $8Er2w.LogtoContext));
    const { isLoading: isLoading, setLoadingState: setLoadingState } = $9d0515444eeb1d1a$var$useLoadingState();
    const { handleError: handleError } = $9d0515444eeb1d1a$var$useErrorHandler();
    const callbackRef = (0, $eCoWV.useRef)();
    (0, $eCoWV.useEffect)(()=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        callbackRef.current = callback; // Update ref to the latest callback.
    }, [
        callback
    ]);
    const handleSignInCallback = (0, $eCoWV.useCallback)(async (callbackUri)=>{
        if (!logtoClient) return (0, $8Er2w.throwContextError)();
        try {
            setLoadingState(true);
            await logtoClient.handleSignInCallback(callbackUri);
            setIsAuthenticated(true);
            callbackRef.current?.();
        } catch (error) {
            handleError(error, "Unexpected error occurred while handling sign in callback.");
        } finally{
            setLoadingState(false);
        }
    }, [
        logtoClient,
        setLoadingState,
        setIsAuthenticated,
        handleError
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!logtoClient) return;
        (async ()=>{
            const currentPageUrl = window.location.href;
            const isAuthenticated = await logtoClient.isAuthenticated();
            const isRedirected = await logtoClient.isSignInRedirected(currentPageUrl);
            if (!isAuthenticated && isRedirected) handleSignInCallback(currentPageUrl);
        })();
    }, [
        handleSignInCallback,
        isAuthenticated,
        logtoClient
    ]);
    return {
        isLoading: isLoading,
        isAuthenticated: isAuthenticated,
        error: error
    };
};
const $9d0515444eeb1d1a$export$44fc9df4d2a1789a = ()=>{
    const { logtoClient: logtoClient, loadingCount: loadingCount, isAuthenticated: isAuthenticated, error: error } = (0, $eCoWV.useContext)((0, $8Er2w.LogtoContext));
    const { setLoadingState: setLoadingState } = $9d0515444eeb1d1a$var$useLoadingState();
    const { handleError: handleError } = $9d0515444eeb1d1a$var$useErrorHandler();
    const isLoading = loadingCount > 0;
    const client = logtoClient ?? (0, $8Er2w.throwContextError)();
    const proxy = (0, $eCoWV.useCallback)((run, resetLoadingState = true)=>{
        return async (...args)=>{
            try {
                setLoadingState(true);
                return await run(...args);
            } catch (error) {
                handleError(error, `Unexpected error occurred while calling ${run.name}.`);
            } finally{
                if (resetLoadingState) setLoadingState(false);
            }
        };
    }, [
        setLoadingState,
        handleError
    ]);
    const methods = (0, $eCoWV.useMemo)(()=>({
            getRefreshToken: proxy(client.getRefreshToken.bind(client)),
            getAccessToken: proxy(client.getAccessToken.bind(client)),
            getAccessTokenClaims: proxy(client.getAccessTokenClaims.bind(client)),
            getOrganizationToken: proxy(client.getOrganizationToken.bind(client)),
            getOrganizationTokenClaims: proxy(client.getOrganizationTokenClaims.bind(client)),
            getIdToken: proxy(client.getIdToken.bind(client)),
            getIdTokenClaims: proxy(client.getIdTokenClaims.bind(client)),
            signIn: proxy(client.signIn.bind(client), false),
            // We deliberately do NOT set isAuthenticated to false in the function below, because the app state
            // may change immediately even before navigating to the oidc end session endpoint, which might cause
            // rendering problems.
            // Moreover, since the location will be redirected, the isAuthenticated state will not matter any more.
            signOut: proxy(client.signOut.bind(client)),
            fetchUserInfo: proxy(client.fetchUserInfo.bind(client))
        }), [
        client,
        proxy
    ]);
    return {
        isAuthenticated: isAuthenticated,
        isLoading: isLoading,
        error: error,
        ...methods
    };
};

});


parcelRequire.register("5bxQK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3c683cad90850e15$export$2e2bcd8739ae039; });
/*! MIT License © Sindre Sorhus */ 
var $8adJa = parcelRequire("8adJa");

var $3SdBO = parcelRequire("3SdBO");

var $2SsOB = parcelRequire("2SsOB");

var $d2Ivz = parcelRequire("d2Ivz");

const $3c683cad90850e15$var$createInstance = (defaults)=>{
    // eslint-disable-next-line @typescript-eslint/promise-function-async
    const ky = (input, options)=>(0, $8adJa.Ky).create(input, (0, $2SsOB.validateAndMerge)(defaults, options));
    for (const method of (0, $3SdBO.requestMethods))// eslint-disable-next-line @typescript-eslint/promise-function-async
    ky[method] = (input, options)=>(0, $8adJa.Ky).create(input, (0, $2SsOB.validateAndMerge)(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$3c683cad90850e15$var$createInstance((0, $2SsOB.validateAndMerge)(newDefaults));
    ky.extend = (newDefaults)=>$3c683cad90850e15$var$createInstance((0, $2SsOB.validateAndMerge)(defaults, newDefaults));
    ky.stop = (0, $3SdBO.stop);
    return ky;
};
const $3c683cad90850e15$var$ky = $3c683cad90850e15$var$createInstance();
var $3c683cad90850e15$export$2e2bcd8739ae039 = $3c683cad90850e15$var$ky;

});
parcelRequire.register("8adJa", function(module, exports) {

$parcel$export(module.exports, "Ky", function () { return $5f19e7e009325baf$export$c482d6f00e170af3; });

var $d2Ivz = parcelRequire("d2Ivz");

var $lTS24 = parcelRequire("lTS24");

var $2SsOB = parcelRequire("2SsOB");

var $ahdkv = parcelRequire("ahdkv");

var $1XIoN = parcelRequire("1XIoN");

var $hKGS8 = parcelRequire("hKGS8");

var $3SdBO = parcelRequire("3SdBO");
class $5f19e7e009325baf$export$c482d6f00e170af3 {
    static create(input, options) {
        const ky = new $5f19e7e009325baf$export$c482d6f00e170af3(input, options);
        const fn = async ()=>{
            if (typeof ky._options.timeout === "number" && ky._options.timeout > (0, $3SdBO.maxSafeTimeout)) throw new RangeError(`The \`timeout\` option cannot be greater than ${(0, $3SdBO.maxSafeTimeout)}`);
            // Delay the fetch so that body method shortcuts can set the Accept header
            await Promise.resolve();
            let response = await ky._fetch();
            for (const hook of ky._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(ky.request, ky._options, ky._decorateResponse(response.clone()));
                if (modifiedResponse instanceof globalThis.Response) response = modifiedResponse;
            }
            ky._decorateResponse(response);
            if (!response.ok && ky._options.throwHttpErrors) {
                let error = new (0, $d2Ivz.HTTPError)(response, ky.request, ky._options);
                for (const hook of ky._options.hooks.beforeError)// eslint-disable-next-line no-await-in-loop
                error = await hook(error);
                throw error;
            }
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (ky._options.onDownloadProgress) {
                if (typeof ky._options.onDownloadProgress !== "function") throw new TypeError("The `onDownloadProgress` option must be a function");
                if (!(0, $3SdBO.supportsResponseStreams)) throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
                return ky._stream(response.clone(), ky._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = ky._options.retry.methods.includes(ky.request.method.toLowerCase());
        const result = isRetriableMethod ? ky._retry(fn) : fn();
        for (const [type, mimeType] of Object.entries((0, $3SdBO.responseTypes)))result[type] = async ()=>{
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            ky.request.headers.set("accept", ky.request.headers.get("accept") || mimeType);
            const awaitedResult = await result;
            const response = awaitedResult.clone();
            if (type === "json") {
                if (response.status === 204) return "";
                const arrayBuffer = await response.clone().arrayBuffer();
                const responseSize = arrayBuffer.byteLength;
                if (responseSize === 0) return "";
                if (options.parseJson) return options.parseJson(await response.text());
            }
            return response[type]();
        };
        return result;
    }
    // eslint-disable-next-line complexity
    constructor(input, options = {}){
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "abortController", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_retryCount", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 0
        });
        Object.defineProperty(this, "_input", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this._input = input;
        this._options = {
            // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
            credentials: this._input.credentials || "same-origin",
            ...options,
            headers: (0, $2SsOB.mergeHeaders)(this._input.headers, options.headers),
            hooks: (0, $2SsOB.deepMerge)({
                beforeRequest: [],
                beforeRetry: [],
                beforeError: [],
                afterResponse: []
            }, options.hooks),
            method: (0, $ahdkv.normalizeRequestMethod)(options.method ?? this._input.method),
            // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
            prefixUrl: String(options.prefixUrl || ""),
            retry: (0, $ahdkv.normalizeRetryOptions)(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: options.timeout ?? 10000,
            fetch: options.fetch ?? globalThis.fetch.bind(globalThis)
        };
        if (typeof this._input !== "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request)) throw new TypeError("`input` must be a string, URL, or Request");
        if (this._options.prefixUrl && typeof this._input === "string") {
            if (this._input.startsWith("/")) throw new Error("`input` must not begin with a slash when using `prefixUrl`");
            if (!this._options.prefixUrl.endsWith("/")) this._options.prefixUrl += "/";
            this._input = this._options.prefixUrl + this._input;
        }
        if (0, $3SdBO.supportsAbortController) {
            this.abortController = new globalThis.AbortController();
            if (this._options.signal) {
                const originalSignal = this._options.signal;
                this._options.signal.addEventListener("abort", ()=>{
                    this.abortController.abort(originalSignal.reason);
                });
            }
            this._options.signal = this.abortController.signal;
        }
        if (0, $3SdBO.supportsRequestStreams) // @ts-expect-error - Types are outdated.
        this._options.duplex = "half";
        this.request = new globalThis.Request(this._input, this._options);
        if (this._options.searchParams) {
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const textSearchParams = typeof this._options.searchParams === "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString();
            // eslint-disable-next-line unicorn/prevent-abbreviations
            const searchParams = "?" + textSearchParams;
            const url = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, searchParams);
            // To provide correct form boundary, Content-Type header should be deleted each time when new Request instantiated from another one
            if (((0, $3SdBO.supportsFormData) && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"])) this.request.headers.delete("content-type");
            // The spread of `this.request` is required as otherwise it misses the `duplex` option for some reason and throws.
            this.request = new globalThis.Request(new globalThis.Request(url, {
                ...this.request
            }), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json");
            this.request = new globalThis.Request(this.request, {
                body: this._options.body
            });
        }
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount < this._options.retry.limit && !(error instanceof (0, $lTS24.TimeoutError))) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                const retryAfter = error.response.headers.get("Retry-After");
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                    else after *= 1000;
                    if (this._options.retry.maxRetryAfter !== undefined && after > this._options.retry.maxRetryAfter) return 0;
                    return after;
                }
                if (error.response.status === 413) return 0;
            }
            const BACKOFF_FACTOR = 0.3;
            return Math.min(this._options.retry.backoffLimit, BACKOFF_FACTOR * 2 ** (this._retryCount - 1) * 1000);
        }
        return 0;
    }
    _decorateResponse(response) {
        if (this._options.parseJson) response.json = async ()=>this._options.parseJson(await response.text());
        return response;
    }
    async _retry(fn) {
        try {
            return await fn();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), (0, $3SdBO.maxSafeTimeout));
            if (ms !== 0 && this._retryCount > 0) {
                await (0, $hKGS8.default)(ms, {
                    signal: this._options.signal
                });
                for (const hook of this._options.hooks.beforeRetry){
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook({
                        request: this.request,
                        options: this._options,
                        error: error,
                        retryCount: this._retryCount
                    });
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === (0, $3SdBO.stop)) return;
                }
                return this._retry(fn);
            }
            throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        if (this._options.timeout === false) return this._options.fetch(this.request.clone());
        return (0, $1XIoN.default)(this.request.clone(), this.abortController, this._options);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get("content-length")) || 0;
        let transferredBytes = 0;
        if (response.status === 204) {
            if (onDownloadProgress) onDownloadProgress({
                percent: 1,
                totalBytes: totalBytes,
                transferredBytes: transferredBytes
            }, new Uint8Array());
            return new globalThis.Response(null, {
                status: response.status,
                statusText: response.statusText,
                headers: response.headers
            });
        }
        return new globalThis.Response(new globalThis.ReadableStream({
            async start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    await read();
                }
                await read();
            }
        }), {
            status: response.status,
            statusText: response.statusText,
            headers: response.headers
        });
    }
}

});
parcelRequire.register("d2Ivz", function(module, exports) {

$parcel$export(module.exports, "HTTPError", function () { return $97edfcac3dcecd3f$export$aa9d629c530f62a7; });
// eslint-lint-disable-next-line @typescript-eslint/naming-convention
class $97edfcac3dcecd3f$export$aa9d629c530f62a7 extends Error {
    constructor(response, request, options){
        const code = response.status || response.status === 0 ? response.status : "";
        const title = response.statusText || "";
        const status = `${code} ${title}`.trim();
        const reason = status ? `status code ${status}` : "an unknown error";
        super(`Request failed with ${reason}`);
        Object.defineProperty(this, "response", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "options", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "HTTPError";
        this.response = response;
        this.request = request;
        this.options = options;
    }
}

});

parcelRequire.register("lTS24", function(module, exports) {

$parcel$export(module.exports, "TimeoutError", function () { return $ff18a5b779781895$export$66d311bf29d5c89c; });
class $ff18a5b779781895$export$66d311bf29d5c89c extends Error {
    constructor(request){
        super("Request timed out");
        Object.defineProperty(this, "request", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.name = "TimeoutError";
        this.request = request;
    }
}

});

parcelRequire.register("2SsOB", function(module, exports) {

$parcel$export(module.exports, "validateAndMerge", function () { return $2186f9fd545fcbc6$export$8886f5ba30bd5e0; });
$parcel$export(module.exports, "deepMerge", function () { return $2186f9fd545fcbc6$export$6969335ea1e4e77c; });
$parcel$export(module.exports, "mergeHeaders", function () { return $2186f9fd545fcbc6$export$eee1781d075786ae; });

var $5m9ub = parcelRequire("5m9ub");
const $2186f9fd545fcbc6$export$8886f5ba30bd5e0 = (...sources)=>{
    for (const source of sources){
        if ((!(0, $5m9ub.isObject)(source) || Array.isArray(source)) && source !== undefined) throw new TypeError("The `options` argument must be an object");
    }
    return $2186f9fd545fcbc6$export$6969335ea1e4e77c({}, ...sources);
};
const $2186f9fd545fcbc6$export$eee1781d075786ae = (source1 = {}, source2 = {})=>{
    const result = new globalThis.Headers(source1);
    const isHeadersInstance = source2 instanceof globalThis.Headers;
    const source = new globalThis.Headers(source2);
    for (const [key, value] of source.entries())if (isHeadersInstance && value === "undefined" || value === undefined) result.delete(key);
    else result.set(key, value);
    return result;
};
const $2186f9fd545fcbc6$export$6969335ea1e4e77c = (...sources)=>{
    let returnValue = {};
    let headers = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ((0, $5m9ub.isObject)(source)) {
            for (let [key, value] of Object.entries(source)){
                if ((0, $5m9ub.isObject)(value) && key in returnValue) value = $2186f9fd545fcbc6$export$6969335ea1e4e77c(returnValue[key], value);
                returnValue = {
                    ...returnValue,
                    [key]: value
                };
            }
            if ((0, $5m9ub.isObject)(source.headers)) {
                headers = $2186f9fd545fcbc6$export$eee1781d075786ae(headers, source.headers);
                returnValue.headers = headers;
            }
        }
    }
    return returnValue;
};

});
parcelRequire.register("5m9ub", function(module, exports) {

$parcel$export(module.exports, "isObject", function () { return $3e665d86c7d41a5d$export$a6cdc56e425d0d0a; });
// eslint-disable-next-line @typescript-eslint/ban-types
const $3e665d86c7d41a5d$export$a6cdc56e425d0d0a = (value)=>value !== null && typeof value === "object";

});


parcelRequire.register("ahdkv", function(module, exports) {

$parcel$export(module.exports, "normalizeRequestMethod", function () { return $77b5d4e5e079c4ff$export$d585027d4667ffce; });
$parcel$export(module.exports, "normalizeRetryOptions", function () { return $77b5d4e5e079c4ff$export$3e5471bb9440c9c1; });

var $3SdBO = parcelRequire("3SdBO");
const $77b5d4e5e079c4ff$export$d585027d4667ffce = (input)=>(0, $3SdBO.requestMethods).includes(input) ? input.toUpperCase() : input;
const $77b5d4e5e079c4ff$var$retryMethods = [
    "get",
    "put",
    "head",
    "delete",
    "options",
    "trace"
];
const $77b5d4e5e079c4ff$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $77b5d4e5e079c4ff$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $77b5d4e5e079c4ff$var$defaultRetryOptions = {
    limit: 2,
    methods: $77b5d4e5e079c4ff$var$retryMethods,
    statusCodes: $77b5d4e5e079c4ff$var$retryStatusCodes,
    afterStatusCodes: $77b5d4e5e079c4ff$var$retryAfterStatusCodes,
    maxRetryAfter: Number.POSITIVE_INFINITY,
    backoffLimit: Number.POSITIVE_INFINITY
};
const $77b5d4e5e079c4ff$export$3e5471bb9440c9c1 = (retry = {})=>{
    if (typeof retry === "number") return {
        ...$77b5d4e5e079c4ff$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error("retry.methods must be an array");
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error("retry.statusCodes must be an array");
    return {
        ...$77b5d4e5e079c4ff$var$defaultRetryOptions,
        ...retry,
        afterStatusCodes: $77b5d4e5e079c4ff$var$retryAfterStatusCodes
    };
};

});
parcelRequire.register("3SdBO", function(module, exports) {

$parcel$export(module.exports, "supportsRequestStreams", function () { return $2d20f8b0a61e7649$export$d8618555562b76b7; });
$parcel$export(module.exports, "supportsAbortController", function () { return $2d20f8b0a61e7649$export$6c0aacaed85a4966; });
$parcel$export(module.exports, "supportsResponseStreams", function () { return $2d20f8b0a61e7649$export$135162ac70ac2b21; });
$parcel$export(module.exports, "supportsFormData", function () { return $2d20f8b0a61e7649$export$f1525fa7979d0aa9; });
$parcel$export(module.exports, "requestMethods", function () { return $2d20f8b0a61e7649$export$fb003dbd6df95edb; });
$parcel$export(module.exports, "responseTypes", function () { return $2d20f8b0a61e7649$export$a6f212d4ee888d8c; });
$parcel$export(module.exports, "maxSafeTimeout", function () { return $2d20f8b0a61e7649$export$9b60a72e3f70a1d2; });
$parcel$export(module.exports, "stop", function () { return $2d20f8b0a61e7649$export$fa6813432f753b0d; });
const $2d20f8b0a61e7649$export$d8618555562b76b7 = (()=>{
    let duplexAccessed = false;
    let hasContentType = false;
    const supportsReadableStream = typeof globalThis.ReadableStream === "function";
    const supportsRequest = typeof globalThis.Request === "function";
    if (supportsReadableStream && supportsRequest) hasContentType = new globalThis.Request("https://empty.invalid", {
        body: new globalThis.ReadableStream(),
        method: "POST",
        // @ts-expect-error - Types are outdated.
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
})();
const $2d20f8b0a61e7649$export$6c0aacaed85a4966 = typeof globalThis.AbortController === "function";
const $2d20f8b0a61e7649$export$135162ac70ac2b21 = typeof globalThis.ReadableStream === "function";
const $2d20f8b0a61e7649$export$f1525fa7979d0aa9 = typeof globalThis.FormData === "function";
const $2d20f8b0a61e7649$export$fb003dbd6df95edb = [
    "get",
    "post",
    "put",
    "patch",
    "head",
    "delete"
];
const $2d20f8b0a61e7649$var$validate = ()=>undefined;
$2d20f8b0a61e7649$var$validate();
const $2d20f8b0a61e7649$export$a6f212d4ee888d8c = {
    json: "application/json",
    text: "text/*",
    formData: "multipart/form-data",
    arrayBuffer: "*/*",
    blob: "*/*"
};
const $2d20f8b0a61e7649$export$9b60a72e3f70a1d2 = 2147483647;
const $2d20f8b0a61e7649$export$fa6813432f753b0d = Symbol("stop");

});


parcelRequire.register("1XIoN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $16ddbdd0ad91065d$export$2e2bcd8739ae039; });

var $lTS24 = parcelRequire("lTS24");
async function $16ddbdd0ad91065d$export$2e2bcd8739ae039(request, abortController, options) {
    return new Promise((resolve, reject)=>{
        const timeoutId = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new (0, $lTS24.TimeoutError)(request));
        }, options.timeout);
        options.fetch(request).then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutId);
        });
    });
}

});

parcelRequire.register("hKGS8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cec7fd0c309a3bfd$export$2e2bcd8739ae039; });
// https://github.com/sindresorhus/delay/tree/ab98ae8dfcb38e1593286c94d934e70d14a4e111
async function $cec7fd0c309a3bfd$export$2e2bcd8739ae039(ms, { signal: signal }) {
    return new Promise((resolve, reject)=>{
        if (signal) {
            signal.throwIfAborted();
            signal.addEventListener("abort", abortHandler, {
                once: true
            });
        }
        function abortHandler() {
            clearTimeout(timeoutId);
            reject(signal.reason);
        }
        const timeoutId = setTimeout(()=>{
            signal?.removeEventListener("abort", abortHandler);
            resolve();
        }, ms);
    });
}

});



parcelRequire.register("eEyjP", function(module, exports) {

$parcel$export(module.exports, "AppDataContext", function () { return $8a1df286820c091e$export$7dc2bc02137acda8; });
$parcel$export(module.exports, "default", function () { return $8a1df286820c091e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $5bxQK = parcelRequire("5bxQK");

var $eCoWV = parcelRequire("eCoWV");

var $iwEyX = parcelRequire("iwEyX");
parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");

var $2wPYZ = parcelRequire("2wPYZ");
const $8a1df286820c091e$export$7dc2bc02137acda8 = /*#__PURE__*/ (0, $eCoWV.createContext)({});
/** The context provider for the global app data. */ function $8a1df286820c091e$var$AppDataProvider({ children: children }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: tenantEndpoint } = (0, $iwEyX.default)(`api/.well-known/endpoints/${currentTenantId}`, async (pathname)=>{
        const { user: user } = await (0, $5bxQK.default).get(new URL(pathname, (0, $9oLtf.adminTenantEndpoint))).json();
        return new URL(user);
    });
    const memorizedContext = (0, $eCoWV.useMemo)(()=>({
            tenantEndpoint: tenantEndpoint
        }), [
        tenantEndpoint
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)($8a1df286820c091e$export$7dc2bc02137acda8.Provider, {
        value: memorizedContext,
        children: children
    });
}
var $8a1df286820c091e$export$2e2bcd8739ae039 = $8a1df286820c091e$var$AppDataProvider;

});
parcelRequire.register("iwEyX", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e2bf72b6fb411f8f$export$2e2bcd8739ae039; });

var $2mi28 = parcelRequire("2mi28");

var $4Korf = parcelRequire("4Korf");
const $e2bf72b6fb411f8f$export$fc3a40dec7b33bf = (useSWRNext)=>(key, fetcher, config)=>{
        // Always override all revalidate options.
        config.revalidateOnFocus = false;
        config.revalidateIfStale = false;
        config.revalidateOnReconnect = false;
        return useSWRNext(key, fetcher, config);
    };
const $e2bf72b6fb411f8f$export$2e2bcd8739ae039 = (0, $4Korf.withMiddleware)((0, $2mi28.default), $e2bf72b6fb411f8f$export$fc3a40dec7b33bf);

});

parcelRequire.register("2wPYZ", function(module, exports) {

$parcel$export(module.exports, "GlobalAnonymousRoute", function () { return $5125fd94e57f6fd1$export$5f9d5f8506602833; });
$parcel$export(module.exports, "GlobalRoute", function () { return $5125fd94e57f6fd1$export$e120f3f2345ed69b; });
$parcel$export(module.exports, "TenantsContext", function () { return $5125fd94e57f6fd1$export$c55cece32887d01f; });
$parcel$export(module.exports, "default", function () { return $5125fd94e57f6fd1$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $5fvIO = parcelRequire("5fvIO");
var $3GN9E = parcelRequire("3GN9E");
var $ckJfF = parcelRequire("ckJfF");
var $8zpKJ = parcelRequire("8zpKJ");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $aWIy6 = parcelRequire("aWIy6");

var $bNFMZ = parcelRequire("bNFMZ");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $V1X8c = parcelRequire("V1X8c");
var $5125fd94e57f6fd1$export$5f9d5f8506602833;
(function(GlobalAnonymousRoute) {
    GlobalAnonymousRoute["Callback"] = "/callback";
    GlobalAnonymousRoute["SocialDemoCallback"] = "/social-demo-callback";
})($5125fd94e57f6fd1$export$5f9d5f8506602833 || ($5125fd94e57f6fd1$export$5f9d5f8506602833 = {}));
var $5125fd94e57f6fd1$export$e120f3f2345ed69b;
(function(GlobalRoute) {
    GlobalRoute["CheckoutSuccessCallback"] = "/checkout-success-callback";
})($5125fd94e57f6fd1$export$e120f3f2345ed69b || ($5125fd94e57f6fd1$export$e120f3f2345ed69b = {}));
const $5125fd94e57f6fd1$var$reservedRoutes = Object.freeze([
    ...Object.values($5125fd94e57f6fd1$export$5f9d5f8506602833),
    ...Object.values($5125fd94e57f6fd1$export$e120f3f2345ed69b)
]);
const { tenantId: $5125fd94e57f6fd1$var$tenantId, indicator: $5125fd94e57f6fd1$var$indicator } = (0, $5fvIO.defaultManagementApi).resource;
/**
 * - For cloud, the initial tenants data is empty, and it will be fetched from the cloud API.
 * - OSS has a fixed tenant with ID `default` and no cloud API to dynamically fetch tenants.
 */ const $5125fd94e57f6fd1$var$defaultTenantResponse = {
    id: $5125fd94e57f6fd1$var$tenantId,
    name: `tenant_${$5125fd94e57f6fd1$var$tenantId}`,
    tag: (0, $3GN9E.TenantTag).Production,
    indicator: $5125fd94e57f6fd1$var$indicator,
    subscription: {
        status: "active",
        planId: (0, $ckJfF.ReservedPlanId).Free,
        currentPeriodStart: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))().toDate(),
        currentPeriodEnd: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))().add(1, "month").toDate()
    },
    usage: {
        activeUsers: 0,
        cost: 0
    },
    openInvoices: [],
    isSuspended: false,
    planId: (0, $ckJfF.ReservedPlanId).Free
};
const $5125fd94e57f6fd1$var$initialTenants = Object.freeze((0, $5CQIb.conditionalArray)(!(0, $V1X8c.isCloud) && $5125fd94e57f6fd1$var$defaultTenantResponse));
const $5125fd94e57f6fd1$export$c55cece32887d01f = /*#__PURE__*/ (0, $eCoWV.createContext)({
    tenants: $5125fd94e57f6fd1$var$initialTenants,
    isInitComplete: false,
    resetTenants: (0, $aWIy6.noop),
    prependTenant: (0, $aWIy6.noop),
    removeTenant: (0, $aWIy6.noop),
    updateTenant: (0, $aWIy6.noop),
    currentTenantId: "",
    isDevTenant: false,
    currentTenantStatus: "pending",
    setCurrentTenantStatus: (0, $aWIy6.noop),
    navigateTenant: (0, $aWIy6.noop)
});
/**
 * The global tenants context provider for all available tenants of the current users.
 * It is used to manage the tenants information, including create, update, and delete;
 * also for navigating between tenants.
 *
 * Note it is not practical to use `useSWR()` for tenants context, since fetching tenants
 * requires authentication, and the authentication is managed by the `LogtoProvider` which
 * depends and locates inside the `TenantsProvider`. Thus the fetching tenants action should
 * be done by a component inside the `LogtoProvider`, which `useSWR()` cannot handle.
 */ function $5125fd94e57f6fd1$var$TenantsProvider({ children: children }) {
    const [tenants, setTenants] = (0, $eCoWV.useState)($5125fd94e57f6fd1$var$initialTenants);
    /** @see {@link initialTenants} */ const [isInitComplete, setIsInitComplete] = (0, $eCoWV.useState)(!(0, $V1X8c.isCloud));
    const match = (0, $9X5Bp.useMatch)("/:tenantId/*");
    const navigate = (0, $9X5Bp.useNavigate)();
    const currentTenantId = (0, $eCoWV.useMemo)(()=>{
        if (!(0, $V1X8c.isCloud)) return 0, $8zpKJ.defaultTenantId;
        if (!match || $5125fd94e57f6fd1$var$reservedRoutes.includes(match.pathname)) return "";
        return match.params.tenantId ?? "";
    }, [
        match
    ]);
    const [currentTenantStatus, setCurrentTenantStatus] = (0, $eCoWV.useState)("pending");
    const navigateTenant = (0, $eCoWV.useCallback)((tenantId)=>{
        navigate(`/${tenantId}`);
        setCurrentTenantStatus("pending");
    }, [
        navigate
    ]);
    const currentTenant = (0, $eCoWV.useMemo)(()=>tenants.find((tenant)=>tenant.id === currentTenantId), [
        currentTenantId,
        tenants
    ]);
    const memorizedContext = (0, $eCoWV.useMemo)(()=>({
            tenants: tenants,
            resetTenants: (tenants)=>{
                setTenants(tenants);
                setCurrentTenantStatus("pending");
                setIsInitComplete(true);
            },
            prependTenant: (tenant)=>{
                setTenants((tenants)=>[
                        tenant,
                        ...tenants
                    ]);
            },
            removeTenant: (tenantId)=>{
                setTenants((tenants)=>tenants.filter((tenant)=>tenant.id !== tenantId));
            },
            updateTenant: (tenantId, data)=>{
                setTenants((tenants)=>tenants.map((tenant)=>tenant.id === tenantId ? {
                            ...tenant,
                            ...data
                        } : tenant));
            },
            isInitComplete: isInitComplete,
            currentTenantId: currentTenantId,
            isDevTenant: currentTenant?.tag === (0, $3GN9E.TenantTag).Development,
            currentTenant: currentTenant,
            currentTenantStatus: currentTenantStatus,
            setCurrentTenantStatus: setCurrentTenantStatus,
            navigateTenant: navigateTenant
        }), [
        currentTenant,
        currentTenantId,
        currentTenantStatus,
        isInitComplete,
        navigateTenant,
        tenants
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)($5125fd94e57f6fd1$export$c55cece32887d01f.Provider, {
        value: memorizedContext,
        children: children
    });
}
var $5125fd94e57f6fd1$export$2e2bcd8739ae039 = $5125fd94e57f6fd1$var$TenantsProvider;

});
parcelRequire.register("bNFMZ", function(module, exports) {
!function(t, e) {
    module.exports = e();
}(module.exports, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", f = "month", h = "quarter", c = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, f), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), f);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: f,
                y: c,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: h
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = function(t) {
        return t instanceof _;
    }, S = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, w = function(t, e) {
        if (p(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, O = v;
    O.l = S, O.i = p, O.w = function(t, e) {
        return w(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = S(t.locale, null, !0), this.parse(t);
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (O.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.$x = t.x || {}, this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return O;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = w(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return w(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < w(t);
        }, m.$g = function(t, e, n) {
            return O.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!O.u(e) || e, h = O.p(t), l = function(t, e) {
                var i = O.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return O.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(h){
                case c:
                    return r ? l(1, 0) : l(31, 11);
                case f:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = O.p(t), h = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = h + "Date", n[d] = h + "Date", n[f] = h + "Month", n[c] = h + "FullYear", n[u] = h + "Hours", n[s] = h + "Minutes", n[i] = h + "Seconds", n[r] = h + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === f || o === c) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[O.p(t)]();
        }, m.add = function(r, h) {
            var d, l = this;
            r = Number(r);
            var $ = O.p(h), y = function(t) {
                var e = w(l);
                return O.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === f) return this.set(f, this.$M + r);
            if ($ === c) return this.set(c, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return O.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = O.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, f = n.months, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, c = function(t) {
                return O.s(s % 12 || 12, t, "0");
            }, d = n.meridiem || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            }, $ = {
                YY: String(this.$y).slice(-2),
                YYYY: this.$y,
                M: a + 1,
                MM: O.s(a + 1, 2, "0"),
                MMM: h(n.monthsShort, a, f, 3),
                MMMM: h(f, a),
                D: this.$D,
                DD: O.s(this.$D, 2, "0"),
                d: String(this.$W),
                dd: h(n.weekdaysMin, this.$W, o, 2),
                ddd: h(n.weekdaysShort, this.$W, o, 3),
                dddd: o[this.$W],
                H: String(s),
                HH: O.s(s, 2, "0"),
                h: c(1),
                hh: c(2),
                a: d(s, u, !0),
                A: d(s, u, !1),
                m: String(u),
                mm: O.s(u, 2, "0"),
                s: String(this.$s),
                ss: O.s(this.$s, 2, "0"),
                SSS: O.s(this.$ms, 3, "0"),
                Z: i
            };
            return r.replace(y, function(t, e) {
                return e || $[t] || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = O.p(d), M = w(r), m = (M.utcOffset() - this.utcOffset()) * e, v = this - M, g = O.m(this, M);
            return g = ($ = {}, $[c] = g / 12, $[f] = g, $[h] = g / 3, $[o] = (v - m) / 6048e5, $[a] = (v - m) / 864e5, $[u] = v / n, $[s] = v / e, $[i] = v / t, $)[y] || v, l ? g : O.a(g);
        }, m.daysInMonth = function() {
            return this.endOf(f).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = S(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return O.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), T = _.prototype;
    return w.prototype = T, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            f
        ],
        [
            "$y",
            c
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        T[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), w.extend = function(t, e) {
        return t.$i || (t(e, _, w), t.$i = !0), w;
    }, w.locale = S, w.isDayjs = p, w.unix = function(t) {
        return w(1e3 * t);
    }, w.en = D[g], w.Ls = D, w.p = {}, w;
});

});

parcelRequire.register("9X5Bp", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_DataRouterContext", function () { return $73edf84010a12d57$export$3add0d5dce533e2e; });
$parcel$export(module.exports, "UNSAFE_DataRouterStateContext", function () { return $73edf84010a12d57$export$145dfa71566a64dc; });
$parcel$export(module.exports, "UNSAFE_NavigationContext", function () { return $73edf84010a12d57$export$26749e8557646306; });
$parcel$export(module.exports, "UNSAFE_RouteContext", function () { return $73edf84010a12d57$export$9072aa6dd1f93057; });
$parcel$export(module.exports, "useHref", function () { return $73edf84010a12d57$export$b66bb29c5006f12f; });
$parcel$export(module.exports, "useResolvedPath", function () { return $73edf84010a12d57$export$e75d2a2d1b3c245b; });
$parcel$export(module.exports, "useLocation", function () { return $73edf84010a12d57$export$45d76561a5302f2b; });
$parcel$export(module.exports, "useMatch", function () { return $73edf84010a12d57$export$6c330e8992e8a295; });
$parcel$export(module.exports, "useNavigate", function () { return $73edf84010a12d57$export$9770f232ac06a008; });
$parcel$export(module.exports, "useOutletContext", function () { return $73edf84010a12d57$export$4138103a3ae699cc; });
$parcel$export(module.exports, "useParams", function () { return $73edf84010a12d57$export$99eaa27ddbbb95ef; });
$parcel$export(module.exports, "useNavigation", function () { return $73edf84010a12d57$export$d0fd4b7106de2769; });
$parcel$export(module.exports, "useMatches", function () { return $73edf84010a12d57$export$2378eb7f5ff86053; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return $73edf84010a12d57$export$2af03a1de5c0910; });
$parcel$export(module.exports, "RouterProvider", function () { return $73edf84010a12d57$export$323e4fc2fa4753fb; });
$parcel$export(module.exports, "Router", function () { return $73edf84010a12d57$export$55185c17a0fcbe46; });
$parcel$export(module.exports, "Routes", function () { return $73edf84010a12d57$export$3565eb3d00ca5a74; });
$parcel$export(module.exports, "Navigate", function () { return $73edf84010a12d57$export$444b3ab0cb9aec40; });
$parcel$export(module.exports, "Outlet", function () { return $73edf84010a12d57$export$910ae8079b2c2852; });
$parcel$export(module.exports, "Route", function () { return $73edf84010a12d57$export$e7b0ac011bb776c6; });
$parcel$export(module.exports, "UNSAFE_detectErrorBoundary", function () { return $73edf84010a12d57$export$48907b48b599f040; });
$parcel$export(module.exports, "matchPath", function () { return (parcelRequire("gaxbO")).matchPath; });
/**
 * React Router v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gaxbO = parcelRequire("gaxbO");

var $eCoWV = parcelRequire("eCoWV");
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */ function $73edf84010a12d57$var$isPolyfill(x, y) {
    return x === y && (x !== 0 || 1 / x === 1 / y) || x !== x && y !== y // eslint-disable-line no-self-compare
    ;
}
const $73edf84010a12d57$var$is = typeof Object.is === "function" ? Object.is : $73edf84010a12d57$var$isPolyfill; // Intentionally not using named imports because Rollup uses dynamic
// dispatch for CommonJS interop named imports.
const { useState: $73edf84010a12d57$var$useState, useEffect: $73edf84010a12d57$var$useEffect, useLayoutEffect: $73edf84010a12d57$var$useLayoutEffect, useDebugValue: $73edf84010a12d57$var$useDebugValue } = $eCoWV;
let $73edf84010a12d57$var$didWarnOld18Alpha = false;
let $73edf84010a12d57$var$didWarnUncachedGetSnapshot = false; // Disclaimer: This shim breaks many of the rules of React, and only works
// because of a very particular set of implementation details and assumptions
// -- change any one of them and it will break. The most important assumption
// is that updates are always synchronous, because concurrent rendering is
// only available in versions of React that also have a built-in
// useSyncExternalStore API. And we only use this shim when the built-in API
// does not exist.
//
// Do not assume that the clever hacks used by this hook also work in general.
// The point of this shim is to replace the need for hacks by other libraries.
function $73edf84010a12d57$var$useSyncExternalStore$2(subscribe, getSnapshot, // React do not expose a way to check if we're hydrating. So users of the shim
// will need to track that themselves and return the correct value
// from `getSnapshot`.
getServerSnapshot) {
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    const value = getSnapshot();
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    const [{ inst: inst }, forceUpdate] = $73edf84010a12d57$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }); // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    $73edf84010a12d57$var$useLayoutEffect(()=>{
        inst.value = value;
        inst.getSnapshot = getSnapshot; // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($73edf84010a12d57$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
         // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $73edf84010a12d57$var$useEffect(()=>{
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($73edf84010a12d57$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        const handleStoreChange = ()=>{
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($73edf84010a12d57$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        }; // Subscribe to the store and return a clean-up function.
        return subscribe(handleStoreChange); // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        subscribe
    ]);
    $73edf84010a12d57$var$useDebugValue(value);
    return value;
}
function $73edf84010a12d57$var$checkIfSnapshotChanged(inst) {
    const latestGetSnapshot = inst.getSnapshot;
    const prevValue = inst.value;
    try {
        const nextValue = latestGetSnapshot();
        return !$73edf84010a12d57$var$is(prevValue, nextValue);
    } catch (error) {
        return true;
    }
}
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */ function $73edf84010a12d57$var$useSyncExternalStore$1(subscribe, getSnapshot, getServerSnapshot) {
    // Note: The shim does not use getServerSnapshot, because pre-18 versions of
    // React do not expose a way to check if we're hydrating. So users of the shim
    // will need to track that themselves and return the correct value
    // from `getSnapshot`.
    return getSnapshot();
}
/**
 * Inlined into the react-router repo since use-sync-external-store does not
 * provide a UMD-compatible package, so we need this to be able to distribute
 * UMD react-router bundles
 */ const $73edf84010a12d57$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
const $73edf84010a12d57$var$isServerEnvironment = !$73edf84010a12d57$var$canUseDOM;
const $73edf84010a12d57$var$shim = $73edf84010a12d57$var$isServerEnvironment ? $73edf84010a12d57$var$useSyncExternalStore$1 : $73edf84010a12d57$var$useSyncExternalStore$2;
const $73edf84010a12d57$var$useSyncExternalStore = "useSyncExternalStore" in $eCoWV ? ((module)=>module.useSyncExternalStore)($eCoWV) : $73edf84010a12d57$var$shim;
const $73edf84010a12d57$export$3add0d5dce533e2e = /*#__PURE__*/ $eCoWV.createContext(null);
const $73edf84010a12d57$export$145dfa71566a64dc = /*#__PURE__*/ $eCoWV.createContext(null);
const $73edf84010a12d57$var$AwaitContext = /*#__PURE__*/ $eCoWV.createContext(null);
const $73edf84010a12d57$export$26749e8557646306 = /*#__PURE__*/ $eCoWV.createContext(null);
const $73edf84010a12d57$export$c7914228fb69b0f5 = /*#__PURE__*/ $eCoWV.createContext(null);
const $73edf84010a12d57$export$9072aa6dd1f93057 = /*#__PURE__*/ $eCoWV.createContext({
    outlet: null,
    matches: []
});
const $73edf84010a12d57$var$RouteErrorContext = /*#__PURE__*/ $eCoWV.createContext(null);
function $73edf84010a12d57$var$_extends() {
    $73edf84010a12d57$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $73edf84010a12d57$var$_extends.apply(this, arguments);
}
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $73edf84010a12d57$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eCoWV.useContext($73edf84010a12d57$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $73edf84010a12d57$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $gaxbO.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $73edf84010a12d57$export$9c954a9d03d32f4a() {
    return $eCoWV.useContext($73edf84010a12d57$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $73edf84010a12d57$export$45d76561a5302f2b() {
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    return $eCoWV.useContext($73edf84010a12d57$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $73edf84010a12d57$export$1b3f31771c5d07c() {
    return $eCoWV.useContext($73edf84010a12d57$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $73edf84010a12d57$export$6c330e8992e8a295(pattern) {
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    let { pathname: pathname } = $73edf84010a12d57$export$45d76561a5302f2b();
    return $eCoWV.useMemo(()=>(0, $gaxbO.matchPath)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ /**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $73edf84010a12d57$export$9770f232ac06a008() {
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    let { basename: basename, navigator: navigator } = $eCoWV.useContext($73edf84010a12d57$export$26749e8557646306);
    let { matches: matches } = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $73edf84010a12d57$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $gaxbO.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    let activeRef = $eCoWV.useRef(false);
    $eCoWV.useEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $eCoWV.useCallback(function(to, options) {
        if (options === void 0) options = {};
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $gaxbO.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history.  If this is a root navigation, then we
        // navigate to the raw basename which allows the basename to have full
        // control over the presence of a trailing slash on root links
        if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gaxbO.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname
    ]);
    return navigate;
}
const $73edf84010a12d57$var$OutletContext = /*#__PURE__*/ $eCoWV.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $73edf84010a12d57$export$4138103a3ae699cc() {
    return $eCoWV.useContext($73edf84010a12d57$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $73edf84010a12d57$export$a3be3530d8e40d0b(context) {
    let outlet = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $73edf84010a12d57$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $73edf84010a12d57$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { matches: matches } = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $73edf84010a12d57$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $gaxbO.UNSAFE_getPathContributingMatches)(matches).map((match)=>match.pathnameBase));
    return $eCoWV.useMemo(()=>(0, $gaxbO.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $73edf84010a12d57$export$5d3fca4a98652595(routes, locationArg) {
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    let { navigator: navigator } = $eCoWV.useContext($73edf84010a12d57$export$26749e8557646306);
    let dataRouterStateContext = $eCoWV.useContext($73edf84010a12d57$export$145dfa71566a64dc);
    let { matches: parentMatches } = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $73edf84010a12d57$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $gaxbO.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $gaxbO.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $gaxbO.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $73edf84010a12d57$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $gaxbO.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $gaxbO.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterStateContext || undefined); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $73edf84010a12d57$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $gaxbO.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $73edf84010a12d57$var$DefaultErrorComponent() {
    let error = $73edf84010a12d57$export$ed527bf60f6e05f2();
    let message = (0, $gaxbO.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $eCoWV.createElement($eCoWV.Fragment, null, /*#__PURE__*/ $eCoWV.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $eCoWV.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $eCoWV.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
class $73edf84010a12d57$var$RenderErrorBoundary extends $eCoWV.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location) return {
            error: props.error,
            location: props.location
        };
         // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error ? /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $73edf84010a12d57$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $eCoWV.useContext($73edf84010a12d57$export$3add0d5dce533e2e); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $73edf84010a12d57$var$_renderMatches(matches, parentMatches, dataRouterState) {
    if (parentMatches === void 0) parentMatches = [];
    if (matches == null) {
        if (dataRouterState != null && dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    let errors = dataRouterState == null ? void 0 : dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $gaxbO.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        let errorElement = null;
        if (dataRouterState) {
            if (match.route.ErrorBoundary) errorElement = /*#__PURE__*/ $eCoWV.createElement(match.route.ErrorBoundary, null);
            else if (match.route.errorElement) errorElement = match.route.errorElement;
            else errorElement = /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$DefaultErrorComponent, null);
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children = outlet;
            if (error) children = errorElement;
            else if (match.route.Component) children = /*#__PURE__*/ $eCoWV.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches
            }
        }) : getChildren();
    }, null);
}
var $73edf84010a12d57$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
})($73edf84010a12d57$var$DataRouterHook || ($73edf84010a12d57$var$DataRouterHook = {}));
var $73edf84010a12d57$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
})($73edf84010a12d57$var$DataRouterStateHook || ($73edf84010a12d57$var$DataRouterStateHook = {}));
function $73edf84010a12d57$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $73edf84010a12d57$var$useDataRouterContext(hookName) {
    let ctx = $eCoWV.useContext($73edf84010a12d57$export$3add0d5dce533e2e);
    !ctx && (0, $gaxbO.UNSAFE_invariant)(false);
    return ctx;
}
function $73edf84010a12d57$var$useDataRouterState(hookName) {
    let state = $eCoWV.useContext($73edf84010a12d57$export$145dfa71566a64dc);
    !state && (0, $gaxbO.UNSAFE_invariant)(false);
    return state;
}
function $73edf84010a12d57$var$useRouteContext(hookName) {
    let route = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    !route && (0, $gaxbO.UNSAFE_invariant)(false);
    return route;
}
function $73edf84010a12d57$var$useCurrentRouteId(hookName) {
    let route = $73edf84010a12d57$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $gaxbO.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $73edf84010a12d57$export$d0fd4b7106de2769() {
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $73edf84010a12d57$export$600dc272ed516c15() {
    let dataRouterContext = $73edf84010a12d57$var$useDataRouterContext($73edf84010a12d57$var$DataRouterHook.UseRevalidator);
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $73edf84010a12d57$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseMatches);
    return $eCoWV.useMemo(()=>matches.map((match)=>{
            let { pathname: pathname, params: params } = match; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname: pathname,
                params: params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        }), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $73edf84010a12d57$export$1448a5050d252c4d() {
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseLoaderData);
    let routeId = $73edf84010a12d57$var$useCurrentRouteId($73edf84010a12d57$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $73edf84010a12d57$export$fd5d37484eab868d(routeId) {
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $73edf84010a12d57$export$fdc00f3f26066d5e() {
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseActionData);
    let route = $eCoWV.useContext($73edf84010a12d57$export$9072aa6dd1f93057);
    !route && (0, $gaxbO.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $73edf84010a12d57$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $eCoWV.useContext($73edf84010a12d57$var$RouteErrorContext);
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseRouteError);
    let routeId = $73edf84010a12d57$var$useCurrentRouteId($73edf84010a12d57$var$DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function $73edf84010a12d57$export$78a72ddb39bdd145() {
    let value = $eCoWV.useContext($73edf84010a12d57$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function $73edf84010a12d57$export$17f53340677d5831() {
    let value = $eCoWV.useContext($73edf84010a12d57$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $73edf84010a12d57$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $73edf84010a12d57$export$2af03a1de5c0910(shouldBlock) {
    let { router: router } = $73edf84010a12d57$var$useDataRouterContext($73edf84010a12d57$var$DataRouterHook.UseBlocker);
    let state = $73edf84010a12d57$var$useDataRouterState($73edf84010a12d57$var$DataRouterStateHook.UseBlocker);
    let [blockerKey] = $eCoWV.useState(()=>String(++$73edf84010a12d57$var$blockerId));
    let blockerFunction = $eCoWV.useCallback((args)=>{
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    let blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    $eCoWV.useEffect(()=>()=>router.deleteBlocker(blockerKey), [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
const $73edf84010a12d57$var$alreadyWarned = {};
function $73edf84010a12d57$var$warningOnce(key, cond, message) {
    if (!cond && !$73edf84010a12d57$var$alreadyWarned[key]) $73edf84010a12d57$var$alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $73edf84010a12d57$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router } = _ref;
    let getState = $eCoWV.useCallback(()=>router.state, [
        router
    ]); // Sync router state to our component state to force re-renders
    let state = $73edf84010a12d57$var$useSyncExternalStore(router.subscribe, getState, // but we pass our serialized hydration data into the router so state here
    // is already synced with what the server saw
    getState);
    let navigator = $eCoWV.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $eCoWV.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $eCoWV.createElement($eCoWV.Fragment, null, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$55185c17a0fcbe46, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$3565eb3d00ca5a74, null) : fallbackElement))), null);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $73edf84010a12d57$export$ae46f04cfaffe093(_ref2) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex } = _ref2;
    let historyRef = $eCoWV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gaxbO.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eCoWV.useState({
        action: history.action,
        location: history.location
    });
    $eCoWV.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $73edf84010a12d57$export$444b3ab0cb9aec40(_ref3) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref3;
    !$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false);
    let dataRouterState = $eCoWV.useContext($73edf84010a12d57$export$145dfa71566a64dc);
    let navigate = $73edf84010a12d57$export$9770f232ac06a008();
    $eCoWV.useEffect(()=>{
        // Avoid kicking off multiple navigations if we're in the middle of a
        // data-router navigation, since components get re-rendered when we enter
        // a submitting/loading state
        if (dataRouterState && dataRouterState.navigation.state !== "idle") return;
        navigate(to, {
            replace: replace,
            state: state,
            relative: relative
        });
    });
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $73edf84010a12d57$export$910ae8079b2c2852(props) {
    return $73edf84010a12d57$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $73edf84010a12d57$export$e7b0ac011bb776c6(_props) {
    (0, $gaxbO.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $73edf84010a12d57$export$55185c17a0fcbe46(_ref4) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $gaxbO.Action).Pop, navigator: navigator, static: staticProp = false } = _ref4;
    !!$73edf84010a12d57$export$9c954a9d03d32f4a() && (0, $gaxbO.UNSAFE_invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $eCoWV.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp
        }), [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $gaxbO.parsePath)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $eCoWV.useMemo(()=>{
        let trailingPathname = (0, $gaxbO.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $73edf84010a12d57$export$3565eb3d00ca5a74(_ref5) {
    let { children: children, location: location } = _ref5;
    let dataRouterContext = $eCoWV.useContext($73edf84010a12d57$export$3add0d5dce533e2e); // When in a DataRouterContext _without_ children, we use the router routes
    // directly.  If we have children, then we're in a descendant tree and we
    // need to use child routes.
    let routes = dataRouterContext && !children ? dataRouterContext.router.routes : $73edf84010a12d57$export$16da398f5434bdec(children);
    return $73edf84010a12d57$export$5d3fca4a98652595(routes, location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $73edf84010a12d57$export$6ddabde395c8c576(_ref6) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref6;
    return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$ResolveAwait, null, children));
}
var $73edf84010a12d57$var$AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})($73edf84010a12d57$var$AwaitRenderStatus || ($73edf84010a12d57$var$AwaitRenderStatus = {}));
const $73edf84010a12d57$var$neverSettledPromise = new Promise(()=>{});
class $73edf84010a12d57$var$AwaitErrorBoundary extends $eCoWV.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $73edf84010a12d57$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $73edf84010a12d57$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $73edf84010a12d57$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $73edf84010a12d57$var$AwaitRenderStatus.error : promise._data !== undefined ? $73edf84010a12d57$var$AwaitRenderStatus.success : $73edf84010a12d57$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $73edf84010a12d57$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $73edf84010a12d57$var$AwaitRenderStatus.error && promise._error instanceof (0, $gaxbO.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw $73edf84010a12d57$var$neverSettledPromise;
        if (status === $73edf84010a12d57$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $73edf84010a12d57$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $73edf84010a12d57$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $eCoWV.createElement($73edf84010a12d57$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
         // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function $73edf84010a12d57$var$ResolveAwait(_ref7) {
    let { children: children } = _ref7;
    let data = $73edf84010a12d57$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $eCoWV.createElement($eCoWV.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $73edf84010a12d57$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $eCoWV.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $eCoWV.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $eCoWV.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $73edf84010a12d57$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $73edf84010a12d57$export$e7b0ac011bb776c6) && (0, $gaxbO.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, $gaxbO.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $73edf84010a12d57$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $73edf84010a12d57$export$daf73786167a7f72(matches) {
    return $73edf84010a12d57$var$_renderMatches(matches);
}
function $73edf84010a12d57$export$48907b48b599f040(route) {
    // there if you change this
    return Boolean(route.ErrorBoundary) || Boolean(route.errorElement);
}
function $73edf84010a12d57$export$f30f7e456d254e83(routes, opts) {
    return (0, $gaxbO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $gaxbO.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        detectErrorBoundary: $73edf84010a12d57$export$48907b48b599f040
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////

});
parcelRequire.register("gaxbO", function(module, exports) {

$parcel$export(module.exports, "Action", function () { return $bc575342bbb76cde$export$e19cd5f9376f8cee; });
$parcel$export(module.exports, "createMemoryHistory", function () { return $bc575342bbb76cde$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createPath", function () { return $bc575342bbb76cde$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $bc575342bbb76cde$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $bc575342bbb76cde$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $bc575342bbb76cde$export$b71fdd3798280242; });
$parcel$export(module.exports, "UNSAFE_invariant", function () { return $bc575342bbb76cde$export$3e9cee6b33872309; });
$parcel$export(module.exports, "matchRoutes", function () { return $bc575342bbb76cde$export$2708184779ceb39d; });
$parcel$export(module.exports, "stripBasename", function () { return $bc575342bbb76cde$export$b69e3301ce081aa3; });
$parcel$export(module.exports, "joinPaths", function () { return $bc575342bbb76cde$export$86d9a7913e44197e; });
$parcel$export(module.exports, "matchPath", function () { return $bc575342bbb76cde$export$81336c211d5ff295; });
$parcel$export(module.exports, "UNSAFE_getPathContributingMatches", function () { return $bc575342bbb76cde$export$90ba53ce1c7fdff2; });
$parcel$export(module.exports, "resolveTo", function () { return $bc575342bbb76cde$export$cae722b0cc860f13; });
$parcel$export(module.exports, "AbortedDeferredError", function () { return $bc575342bbb76cde$export$42a99a7a4bc0e76a; });
$parcel$export(module.exports, "ErrorResponse", function () { return $bc575342bbb76cde$export$acf1a680051f5031; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return $bc575342bbb76cde$export$972111febbeef05b; });
$parcel$export(module.exports, "createRouter", function () { return $bc575342bbb76cde$export$baddd0131ee8c05b; });
/**
 * @remix-run/router v1.5.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $bc575342bbb76cde$var$_extends() {
    $bc575342bbb76cde$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc575342bbb76cde$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $bc575342bbb76cde$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($bc575342bbb76cde$export$e19cd5f9376f8cee || ($bc575342bbb76cde$export$e19cd5f9376f8cee = {}));
const $bc575342bbb76cde$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $bc575342bbb76cde$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $bc575342bbb76cde$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $bc575342bbb76cde$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $bc575342bbb76cde$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $bc575342bbb76cde$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $bc575342bbb76cde$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $bc575342bbb76cde$export$fe53371bee54353d(to);
    }
    return $bc575342bbb76cde$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $bc575342bbb76cde$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $bc575342bbb76cde$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        return $bc575342bbb76cde$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $bc575342bbb76cde$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $bc575342bbb76cde$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $bc575342bbb76cde$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $bc575342bbb76cde$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $bc575342bbb76cde$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $bc575342bbb76cde$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $bc575342bbb76cde$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $bc575342bbb76cde$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $bc575342bbb76cde$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $bc575342bbb76cde$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $bc575342bbb76cde$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $bc575342bbb76cde$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $bc575342bbb76cde$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($bc575342bbb76cde$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Push;
        let location = $bc575342bbb76cde$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $bc575342bbb76cde$var$getHistoryState(location, index);
        let url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace;
        let location = $bc575342bbb76cde$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $bc575342bbb76cde$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $bc575342bbb76cde$export$fe53371bee54353d(to);
        $bc575342bbb76cde$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($bc575342bbb76cde$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($bc575342bbb76cde$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var $bc575342bbb76cde$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($bc575342bbb76cde$var$ResultType || ($bc575342bbb76cde$var$ResultType = {}));
const $bc575342bbb76cde$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $bc575342bbb76cde$var$isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function $bc575342bbb76cde$export$4a6d22b32134ea5d(routes, detectErrorBoundary, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $bc575342bbb76cde$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $bc575342bbb76cde$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($bc575342bbb76cde$var$isIndexRoute(route)) {
            let indexRoute = $bc575342bbb76cde$var$_extends({}, route, {
                hasErrorBoundary: detectErrorBoundary(route),
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $bc575342bbb76cde$var$_extends({}, route, {
                id: id,
                hasErrorBoundary: detectErrorBoundary(route),
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $bc575342bbb76cde$export$4a6d22b32134ea5d(route.children, detectErrorBoundary, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $bc575342bbb76cde$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $bc575342bbb76cde$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $bc575342bbb76cde$var$flattenRoutes(routes);
    $bc575342bbb76cde$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $bc575342bbb76cde$var$matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $bc575342bbb76cde$var$safelyDecodeURI(pathname));
    return matches;
}
function $bc575342bbb76cde$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $bc575342bbb76cde$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $bc575342bbb76cde$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $bc575342bbb76cde$export$3e9cee6b33872309(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $bc575342bbb76cde$var$flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $bc575342bbb76cde$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $bc575342bbb76cde$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $bc575342bbb76cde$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments; // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $bc575342bbb76cde$var$explodeOptionalSegments(rest.join("/"));
    let result = []; // All child paths with the prefix.  Do this for all children before the
    // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/"))); // Then if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
     // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $bc575342bbb76cde$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $bc575342bbb76cde$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $bc575342bbb76cde$var$paramRe = /^:\w+$/;
const $bc575342bbb76cde$var$dynamicSegmentValue = 3;
const $bc575342bbb76cde$var$indexRouteValue = 2;
const $bc575342bbb76cde$var$emptySegmentValue = 1;
const $bc575342bbb76cde$var$staticSegmentValue = 10;
const $bc575342bbb76cde$var$splatPenalty = -2;
const $bc575342bbb76cde$var$isSplat = (s)=>s === "*";
function $bc575342bbb76cde$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($bc575342bbb76cde$var$isSplat)) initialScore += $bc575342bbb76cde$var$splatPenalty;
    if (index) initialScore += $bc575342bbb76cde$var$indexRouteValue;
    return segments.filter((s)=>!$bc575342bbb76cde$var$isSplat(s)).reduce((score, segment)=>score + ($bc575342bbb76cde$var$paramRe.test(segment) ? $bc575342bbb76cde$var$dynamicSegmentValue : segment === "" ? $bc575342bbb76cde$var$emptySegmentValue : $bc575342bbb76cde$var$staticSegmentValue), initialScore);
}
function $bc575342bbb76cde$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function $bc575342bbb76cde$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $bc575342bbb76cde$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $bc575342bbb76cde$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $bc575342bbb76cde$export$a5c6d149b50c1d86($bc575342bbb76cde$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $bc575342bbb76cde$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $bc575342bbb76cde$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $bc575342bbb76cde$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            const starParam = params[star]; // Apply the splat
            return starParam;
        }
        const keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) $bc575342bbb76cde$export$3e9cee6b33872309(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $bc575342bbb76cde$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, paramNames] = $bc575342bbb76cde$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = paramNames.reduce((memo, paramName, index)=>{
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = $bc575342bbb76cde$var$safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $bc575342bbb76cde$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $bc575342bbb76cde$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let paramNames = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, (_, paramName)=>{
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function $bc575342bbb76cde$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $bc575342bbb76cde$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $bc575342bbb76cde$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $bc575342bbb76cde$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $bc575342bbb76cde$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $bc575342bbb76cde$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $bc575342bbb76cde$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $bc575342bbb76cde$var$normalizeSearch(search),
        hash: $bc575342bbb76cde$var$normalizeHash(hash)
    };
}
function $bc575342bbb76cde$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $bc575342bbb76cde$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $bc575342bbb76cde$export$90ba53ce1c7fdff2(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
/**
 * @private
 */ function $bc575342bbb76cde$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $bc575342bbb76cde$export$8ccf933b0513f8d0(toArg);
    else {
        to = $bc575342bbb76cde$var$_extends({}, toArg);
        $bc575342bbb76cde$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $bc575342bbb76cde$var$getInvalidPathError("?", "pathname", "search", to));
        $bc575342bbb76cde$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $bc575342bbb76cde$var$getInvalidPathError("#", "pathname", "hash", to));
        $bc575342bbb76cde$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $bc575342bbb76cde$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $bc575342bbb76cde$export$b09f2ff0bbcb43c7(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $bc575342bbb76cde$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $bc575342bbb76cde$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $bc575342bbb76cde$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $bc575342bbb76cde$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $bc575342bbb76cde$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $bc575342bbb76cde$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $bc575342bbb76cde$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $bc575342bbb76cde$export$42a99a7a4bc0e76a extends Error {
}
class $bc575342bbb76cde$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $bc575342bbb76cde$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $bc575342bbb76cde$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref)=>{
            let [key, value] = _ref;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, null, data), (error)=>this.onSettle(promise, key, error)); // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $bc575342bbb76cde$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        if (error) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $bc575342bbb76cde$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: $bc575342bbb76cde$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $bc575342bbb76cde$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $bc575342bbb76cde$var$unwrapTrackedPromise(value) {
    if (!$bc575342bbb76cde$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $bc575342bbb76cde$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $bc575342bbb76cde$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $bc575342bbb76cde$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $bc575342bbb76cde$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ class $bc575342bbb76cde$export$acf1a680051f5031 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $bc575342bbb76cde$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $bc575342bbb76cde$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $bc575342bbb76cde$var$validMutationMethods = new Set($bc575342bbb76cde$var$validMutationMethodsArr);
const $bc575342bbb76cde$var$validRequestMethodsArr = [
    "get",
    ...$bc575342bbb76cde$var$validMutationMethodsArr
];
const $bc575342bbb76cde$var$validRequestMethods = new Set($bc575342bbb76cde$var$validRequestMethodsArr);
const $bc575342bbb76cde$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $bc575342bbb76cde$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $bc575342bbb76cde$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $bc575342bbb76cde$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
const $bc575342bbb76cde$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $bc575342bbb76cde$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $bc575342bbb76cde$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $bc575342bbb76cde$var$isServer = !$bc575342bbb76cde$var$isBrowser;
const $bc575342bbb76cde$var$defaultDetectErrorBoundary = (route)=>Boolean(route.hasErrorBoundary); //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $bc575342bbb76cde$export$baddd0131ee8c05b(init) {
    $bc575342bbb76cde$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let detectErrorBoundary = init.detectErrorBoundary || $bc575342bbb76cde$var$defaultDetectErrorBoundary; // Routes keyed by ID
    let manifest = {}; // Routes in tree format for matching
    let dataRoutes = $bc575342bbb76cde$export$4a6d22b32134ea5d(init.routes, detectErrorBoundary, undefined, manifest);
    let inFlightDataRoutes; // Config driven behavior flags
    let future = $bc575342bbb76cde$var$_extends({
        v7_normalizeFormMethod: false
    }, init.future); // Cleanup function for history
    let unlistenHistory = null; // Externally-provided functions to call on all state changes
    let subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    let getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $bc575342bbb76cde$export$2708184779ceb39d(dataRoutes, init.history.location, init.basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $bc575342bbb76cde$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $bc575342bbb76cde$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some((m)=>m.route.lazy) && (!initialMatches.some((m)=>m.route.loader) || init.hydrationData != null);
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $bc575342bbb76cde$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false; // AbortController for the active navigation
    let pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidate()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map(); // Track loads based on the order in which they started
    let incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations from their actions
    let fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $bc575342bbb76cde$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($bc575342bbb76cde$export$e19cd5f9376f8cee.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = $bc575342bbb76cde$var$_extends({}, state, newState);
        subscribers.forEach((subscriber)=>subscriber(state));
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $bc575342bbb76cde$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $bc575342bbb76cde$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        for (let [key] of blockerFunctions)deleteBlocker(key);
         // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $bc575342bbb76cde$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState($bc575342bbb76cde$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $bc575342bbb76cde$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $bc575342bbb76cde$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let { path: path, submission: submission, error: error } = $bc575342bbb76cde$var$normalizeNavigateOptions(to, future, opts);
        let currentLocation = state.location;
        let nextLocation = $bc575342bbb76cde$var$createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $bc575342bbb76cde$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $bc575342bbb76cde$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    }); // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    deleteBlocker(blockerKey);
                    updateState({
                        blockers: new Map(state.blockers)
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace
        });
    } // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $bc575342bbb76cde$export$2708184779ceb39d(routesToUse, location, init.basename); // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $bc575342bbb76cde$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bc575342bbb76cde$var$getShortCircuitMatches(routesToUse); // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            });
            return;
        } // Short circuit if it's only a hash change and not a mutation submission
        // For example, on /page#hash and submit a <Form method="post"> which will
        // default to a navigation to /page
        if ($bc575342bbb76cde$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $bc575342bbb76cde$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            });
            return;
        } // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $bc575342bbb76cde$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$bc575342bbb76cde$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $bc575342bbb76cde$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            let navigation = $bc575342bbb76cde$var$_extends({
                state: "loading",
                location: location
            }, opts.submission);
            loadingNavigation = navigation; // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        } // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError);
        if (shortCircuited) return;
         // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $bc575342bbb76cde$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    } // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        interruptActiveLoads(); // Put us in a submitting state
        let navigation = $bc575342bbb76cde$var$_extends({
            state: "submitting",
            location: location
        }, submission);
        updateState({
            navigation: navigation
        }); // Call our action and get the result
        let result;
        let actionMatch = $bc575342bbb76cde$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $bc575342bbb76cde$var$ResultType.error,
            error: $bc575342bbb76cde$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $bc575342bbb76cde$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, router.basename);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($bc575342bbb76cde$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($bc575342bbb76cde$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $bc575342bbb76cde$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($bc575342bbb76cde$var$isDeferredResult(result)) throw $bc575342bbb76cde$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    } // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation;
        if (!loadingNavigation) {
            let navigation = $bc575342bbb76cde$var$_extends({
                state: "loading",
                location: location,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            }, submission);
            loadingNavigation = navigation;
        } // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
            formMethod: loadingNavigation.formMethod,
            formAction: loadingNavigation.formAction,
            formData: loadingNavigation.formData,
            formEncType: loadingNavigation.formEncType
        } : undefined;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $bc575342bbb76cde$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, pendingActionData, pendingError); // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId)); // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            completeNavigation(location, $bc575342bbb76cde$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}));
            return {
                shortCircuited: true
            };
        } // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        if (!isUninterruptedRevalidation) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = {
                    state: "loading",
                    data: fetcher && fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($bc575342bbb76cde$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}));
        }
        pendingNavigationLoadId = ++incrementingLoadId;
        revalidatingFetchers.forEach((rf)=>fetchControllers.set(rf.key, pendingNavigationController));
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
         // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key)); // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $bc575342bbb76cde$var$findRedirect(results);
        if (redirect) {
            await startRedirectNavigation(state, redirect, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        } // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bc575342bbb76cde$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds); // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        return $bc575342bbb76cde$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, didAbortFetchLoads || revalidatingFetchers.length > 0 ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || $bc575342bbb76cde$export$52eace9c284d3585;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if ($bc575342bbb76cde$var$isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = $bc575342bbb76cde$export$2708184779ceb39d(routesToUse, href, init.basename);
        if (!matches) {
            setFetcherError(key, routeId, $bc575342bbb76cde$var$getInternalRouterError(404, {
                pathname: href
            }));
            return;
        }
        let { path: path, submission: submission } = $bc575342bbb76cde$var$normalizeNavigateOptions(href, future, opts, true);
        let match = $bc575342bbb76cde$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $bc575342bbb76cde$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $bc575342bbb76cde$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error);
            return;
        } // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        let fetcher = $bc575342bbb76cde$var$_extends({
            state: "submitting"
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $bc575342bbb76cde$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let actionResult = await $bc575342bbb76cde$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, detectErrorBoundary, router.basename);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by ou our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if ($bc575342bbb76cde$var$isRedirectResult(actionResult)) {
            fetchControllers.delete(key);
            fetchRedirectIds.add(key);
            let loadingFetcher = $bc575342bbb76cde$var$_extends({
                state: "loading"
            }, submission, {
                data: undefined,
                " _hasFetcherDoneAnything ": true
            });
            state.fetchers.set(key, loadingFetcher);
            updateState({
                fetchers: new Map(state.fetchers)
            });
            return startRedirectNavigation(state, actionResult, {
                submission: submission,
                isFetchActionRedirect: true
            });
        } // Process any non-redirect errors thrown
        if ($bc575342bbb76cde$var$isErrorResult(actionResult)) {
            setFetcherError(key, routeId, actionResult.error);
            return;
        }
        if ($bc575342bbb76cde$var$isDeferredResult(actionResult)) throw $bc575342bbb76cde$var$getInternalRouterError(400, {
            type: "defer-action"
        });
         // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $bc575342bbb76cde$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $bc575342bbb76cde$export$2708184779ceb39d(routesToUse, state.navigation.location, init.basename) : state.matches;
        $bc575342bbb76cde$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $bc575342bbb76cde$var$_extends({
            state: "loading",
            data: actionResult.data
        }, submission, {
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $bc575342bbb76cde$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, init.basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        ); // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = {
                state: "loading",
                data: existingFetcher && existingFetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(staleKey, revalidatingFetcher);
            fetchControllers.set(staleKey, abortController);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $bc575342bbb76cde$var$findRedirect(results);
        if (redirect) return startRedirectNavigation(state, redirect);
         // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $bc575342bbb76cde$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        let doneFetcher = {
            state: "idle",
            data: actionResult.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        let didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $bc575342bbb76cde$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState($bc575342bbb76cde$var$_extends({
                errors: errors,
                loaderData: $bc575342bbb76cde$var$mergeLoaderData(state.loaderData, loaderData, matches, errors)
            }, didAbortFetchLoads ? {
                fetchers: new Map(state.fetchers)
            } : {}));
            isRevalidationRequired = false;
        }
    } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        let existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
        let loadingFetcher = $bc575342bbb76cde$var$_extends({
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined
        }, submission, {
            data: existingFetcher && existingFetcher.data,
            " _hasFetcherDoneAnything ": true
        });
        state.fetchers.set(key, loadingFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }); // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $bc575342bbb76cde$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let result = await $bc575342bbb76cde$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, detectErrorBoundary, router.basename); // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($bc575342bbb76cde$var$isDeferredResult(result)) result = await $bc575342bbb76cde$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
         // We can delete this so long as we weren't aborted by ou our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
         // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($bc575342bbb76cde$var$isRedirectResult(result)) {
            await startRedirectNavigation(state, result);
            return;
        } // Process any non-redirect errors thrown
        if ($bc575342bbb76cde$var$isErrorResult(result)) {
            let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(state.matches, routeId);
            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
            // do we need to behave any differently with our non-redirect errors?
            // What if it was a non-redirect Response?
            updateState({
                fetchers: new Map(state.fetchers),
                errors: {
                    [boundaryMatch.route.id]: result.error
                }
            });
            return;
        }
        $bc575342bbb76cde$export$3e9cee6b33872309(!$bc575342bbb76cde$var$isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
        let doneFetcher = {
            state: "idle",
            data: result.data,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            " _hasFetcherDoneAnything ": true
        };
        state.fetchers.set(key, doneFetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp) {
        var _window;
        let { submission: submission, replace: replace, isFetchActionRedirect: isFetchActionRedirect } = _temp === void 0 ? {} : _temp;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $bc575342bbb76cde$var$createLocation(state.location, redirect.location, $bc575342bbb76cde$var$_extends({
            _isRedirect: true
        }, isFetchActionRedirect ? {
            _isFetchActionRedirect: true
        } : {}));
        $bc575342bbb76cde$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
        if ($bc575342bbb76cde$var$ABSOLUTE_URL_REGEX.test(redirect.location) && $bc575342bbb76cde$var$isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
            let url = init.history.createURL(redirect.location);
            let isDifferentBasename = $bc575342bbb76cde$export$b69e3301ce081aa3(url.pathname, init.basename || "/") == null;
            if (window.location.origin !== url.origin || isDifferentBasename) {
                if (replace) window.location.replace(redirect.location);
                else window.location.assign(redirect.location);
                return;
            }
        } // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $bc575342bbb76cde$export$e19cd5f9376f8cee.Replace : $bc575342bbb76cde$export$e19cd5f9376f8cee.Push; // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, formData: formData } = state.navigation;
        if (!submission && formMethod && formAction && formData && formEncType) submission = {
            formMethod: formMethod,
            formAction: formAction,
            formEncType: formEncType,
            formData: formData
        };
         // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        if ($bc575342bbb76cde$var$redirectPreserveMethodStatusCodes.has(redirect.status) && submission && $bc575342bbb76cde$var$isMutationMethod(submission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $bc575342bbb76cde$var$_extends({}, submission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else if (isFetchActionRedirect) // For a fetch action redirect, we kick off a new loading navigation
        // without the fetcher submission, but we send it along for shouldRevalidate
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined
            },
            fetcherSubmission: submission,
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else // Otherwise, we kick off a new loading navigation, preserving the
        // submission info for the duration of this navigation
        await startNavigation(redirectHistoryAction, redirectLocation, {
            overrideNavigation: {
                state: "loading",
                location: redirectLocation,
                formMethod: submission ? submission.formMethod : undefined,
                formAction: submission ? submission.formAction : undefined,
                formEncType: submission ? submission.formEncType : undefined,
                formData: submission ? submission.formData : undefined
            },
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$bc575342bbb76cde$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, router.basename)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match) return $bc575342bbb76cde$var$callLoaderOrAction("loader", $bc575342bbb76cde$var$createClientSideRequest(init.history, f.path, request.signal), f.match, f.matches, manifest, detectErrorBoundary, router.basename);
                else {
                    let error = {
                        type: $bc575342bbb76cde$var$ResultType.error,
                        error: $bc575342bbb76cde$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $bc575342bbb76cde$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, request.signal, false, state.loaderData),
            $bc575342bbb76cde$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, request.signal, true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds()); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $bc575342bbb76cde$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = {
                state: "idle",
                data: fetcher.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $bc575342bbb76cde$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
            }
        }
        markFetchersDone(doneKeys);
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $bc575342bbb76cde$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $bc575342bbb76cde$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $bc575342bbb76cde$export$386d57f03f0b2883; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $bc575342bbb76cde$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $bc575342bbb76cde$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || ((location)=>location.key); // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $bc575342bbb76cde$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$bc575342bbb76cde$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            let userMatches = matches.map((m)=>$bc575342bbb76cde$var$createUseMatchesMatch(m, state.loaderData));
            let key = getScrollRestorationKey(location, userMatches) || location.key;
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        inFlightDataRoutes = newRoutes;
    }
    router = {
        get basename () {
            return init.basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcher,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $bc575342bbb76cde$export$4d0306f8f6a4585b = Symbol("deferred");
function $bc575342bbb76cde$export$3336b097a6fbc59a(routes, opts) {
    $bc575342bbb76cde$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let detectErrorBoundary = (opts == null ? void 0 : opts.detectErrorBoundary) || $bc575342bbb76cde$var$defaultDetectErrorBoundary;
    let dataRoutes = $bc575342bbb76cde$export$4a6d22b32134ea5d(routes, detectErrorBoundary, undefined, manifest);
    let basename = (opts ? opts.basename : null) || "/";
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp2) {
        let { requestContext: requestContext } = _temp2 === void 0 ? {} : _temp2;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bc575342bbb76cde$var$createLocation("", $bc575342bbb76cde$export$fe53371bee54353d(url), null, "default");
        let matches = $bc575342bbb76cde$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$bc575342bbb76cde$var$isValidMethod(method) && method !== "HEAD") {
            let error = $bc575342bbb76cde$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $bc575342bbb76cde$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $bc575342bbb76cde$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $bc575342bbb76cde$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($bc575342bbb76cde$var$isResponse(result)) return result;
         // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $bc575342bbb76cde$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp3) {
        let { routeId: routeId, requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $bc575342bbb76cde$var$createLocation("", $bc575342bbb76cde$export$fe53371bee54353d(url), null, "default");
        let matches = $bc575342bbb76cde$export$2708184779ceb39d(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
        if (!$bc575342bbb76cde$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $bc575342bbb76cde$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $bc575342bbb76cde$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $bc575342bbb76cde$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $bc575342bbb76cde$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $bc575342bbb76cde$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($bc575342bbb76cde$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
         // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$bc575342bbb76cde$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $bc575342bbb76cde$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($bc575342bbb76cde$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $bc575342bbb76cde$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $bc575342bbb76cde$var$isResponse(result) ? result : $bc575342bbb76cde$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($bc575342bbb76cde$var$isQueryRouteResponse(e)) {
                if (e.type === $bc575342bbb76cde$var$ResultType.error && !$bc575342bbb76cde$var$isRedirectResponse(e.response)) throw e.response;
                return e.response;
            } // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($bc575342bbb76cde$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $bc575342bbb76cde$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bc575342bbb76cde$var$ResultType.error,
                error: error
            };
        } else {
            result = await $bc575342bbb76cde$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext);
            if (request.signal.aborted) {
                let method = isRouteRequest ? "queryRoute" : "query";
                throw new Error(method + "() call aborted");
            }
        }
        if ($bc575342bbb76cde$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($bc575342bbb76cde$var$isDeferredResult(result)) {
            let error = $bc575342bbb76cde$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $bc575342bbb76cde$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($bc575342bbb76cde$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($bc575342bbb76cde$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            }); // action status codes take precedence over loader status codes
            return $bc575342bbb76cde$var$_extends({}, context, {
                statusCode: $bc575342bbb76cde$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $bc575342bbb76cde$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        } // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $bc575342bbb76cde$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $bc575342bbb76cde$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $bc575342bbb76cde$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $bc575342bbb76cde$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy); // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$bc575342bbb76cde$var$callLoaderOrAction("loader", request, match, matches, manifest, detectErrorBoundary, basename, true, isRouteRequest, requestContext))
        ]);
        if (request.signal.aborted) {
            let method = isRouteRequest ? "queryRoute" : "query";
            throw new Error(method + "() call aborted");
        } // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $bc575342bbb76cde$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $bc575342bbb76cde$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $bc575342bbb76cde$export$fec11da027c70692(routes, context, error) {
    let newContext = $bc575342bbb76cde$var$_extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $bc575342bbb76cde$var$isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $bc575342bbb76cde$var$normalizeNavigateOptions(to, future, opts, isFetcher) {
    if (isFetcher === void 0) isFetcher = false;
    let path = typeof to === "string" ? to : $bc575342bbb76cde$export$fe53371bee54353d(to); // Return location verbatim on non-submission navigations
    if (!opts || !$bc575342bbb76cde$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$bc575342bbb76cde$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $bc575342bbb76cde$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    let submission;
    if (opts.formData) {
        let formMethod = opts.formMethod || "get";
        submission = {
            formMethod: future.v7_normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: $bc575342bbb76cde$var$stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if ($bc575342bbb76cde$var$isMutationMethod(submission.formMethod)) return {
            path: path,
            submission: submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $bc575342bbb76cde$export$8ccf933b0513f8d0(path);
    let searchParams = $bc575342bbb76cde$var$convertFormDataToSearchParams(opts.formData); // Since fetcher GET submissions only run a single loader (as opposed to
    // navigation GET submissions which run all loaders), we need to preserve
    // any incoming ?index params
    if (isFetcher && parsedPath.search && $bc575342bbb76cde$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $bc575342bbb76cde$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $bc575342bbb76cde$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $bc575342bbb76cde$var$getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let defaultShouldRevalidate = isRevalidationRequired || // Clicked the same link, resubmitted a GET form
    currentUrl.toString() === nextUrl.toString() || // Search params affect all loaders
    currentUrl.search !== nextUrl.search; // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $bc575342bbb76cde$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if ($bc575342bbb76cde$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $bc575342bbb76cde$var$shouldRevalidateLoader(match, $bc575342bbb76cde$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate || $bc575342bbb76cde$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some((m)=>m.route.id === f.routeId)) return;
        let fetcherMatches = $bc575342bbb76cde$export$2708184779ceb39d(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push($bc575342bbb76cde$var$_extends({
                key: key
            }, f, {
                matches: null,
                match: null
            }));
            return;
        }
        let fetcherMatch = $bc575342bbb76cde$var$getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push($bc575342bbb76cde$var$_extends({
                key: key,
                matches: fetcherMatches,
                match: fetcherMatch
            }, f));
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        let shouldRevalidate = $bc575342bbb76cde$var$shouldRevalidateLoader(fetcherMatch, $bc575342bbb76cde$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: defaultShouldRevalidate
        }));
        if (shouldRevalidate) revalidatingFetchers.push($bc575342bbb76cde$var$_extends({
            key: key,
            matches: fetcherMatches,
            match: fetcherMatch
        }, f));
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $bc575342bbb76cde$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $bc575342bbb76cde$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $bc575342bbb76cde$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $bc575342bbb76cde$var$loadLazyRouteModule(route, detectErrorBoundary, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy(); // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $bc575342bbb76cde$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $bc575342bbb76cde$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$bc575342bbb76cde$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    } // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to detectErrorBoundary
    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, {
        // To keep things framework agnostic, we use the provided
        // `detectErrorBoundary` function to set the `hasErrorBoundary` route
        // property since the logic will differ between frameworks.
        hasErrorBoundary: detectErrorBoundary($bc575342bbb76cde$var$_extends({}, routeToUpdate)),
        lazy: undefined
    });
}
async function $bc575342bbb76cde$var$callLoaderOrAction(type, request, match, matches, manifest, detectErrorBoundary, basename, isStaticRequest, isRouteRequest, requestContext) {
    if (basename === void 0) basename = "/";
    if (isStaticRequest === void 0) isStaticRequest = false;
    if (isRouteRequest === void 0) isRouteRequest = false;
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let values = await Promise.all([
                    runHandler(handler),
                    $bc575342bbb76cde$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest)
                ]);
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $bc575342bbb76cde$var$loadLazyRouteModule(match.route, detectErrorBoundary, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") throw $bc575342bbb76cde$var$getInternalRouterError(405, {
                    method: request.method,
                    pathname: new URL(request.url).pathname,
                    routeId: match.route.id
                });
                else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $bc575342bbb76cde$var$ResultType.data,
                    data: undefined
                };
            }
        } else {
            $bc575342bbb76cde$export$3e9cee6b33872309(handler, "Could not find the " + type + ' to run on the "' + match.route.id + '" route');
            result = await runHandler(handler);
        }
        $bc575342bbb76cde$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $bc575342bbb76cde$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($bc575342bbb76cde$var$isResponse(result)) {
        let status = result.status; // Process redirects
        if ($bc575342bbb76cde$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $bc575342bbb76cde$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
            if (!$bc575342bbb76cde$var$ABSOLUTE_URL_REGEX.test(location)) {
                let activeMatches = matches.slice(0, matches.indexOf(match) + 1);
                let routePathnames = $bc575342bbb76cde$export$90ba53ce1c7fdff2(activeMatches).map((match)=>match.pathnameBase);
                let resolvedLocation = $bc575342bbb76cde$export$cae722b0cc860f13(location, routePathnames, new URL(request.url).pathname);
                $bc575342bbb76cde$export$3e9cee6b33872309($bc575342bbb76cde$export$fe53371bee54353d(resolvedLocation), "Unable to resolve redirect location: " + location); // Prepend the basename to the redirect location if we have one
                if (basename) {
                    let path = resolvedLocation.pathname;
                    resolvedLocation.pathname = path === "/" ? basename : $bc575342bbb76cde$export$86d9a7913e44197e([
                        basename,
                        path
                    ]);
                }
                location = $bc575342bbb76cde$export$fe53371bee54353d(resolvedLocation);
            } else if (!isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $bc575342bbb76cde$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            } // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $bc575342bbb76cde$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null
            };
        } // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (isRouteRequest) // eslint-disable-next-line no-throw-literal
        throw {
            type: resultType || $bc575342bbb76cde$var$ResultType.data,
            response: result
        };
        let data;
        let contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
        // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
        if (contentType && /\bapplication\/json\b/.test(contentType)) data = await result.json();
        else data = await result.text();
        if (resultType === $bc575342bbb76cde$var$ResultType.error) return {
            type: resultType,
            error: new $bc575342bbb76cde$export$acf1a680051f5031(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $bc575342bbb76cde$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $bc575342bbb76cde$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($bc575342bbb76cde$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $bc575342bbb76cde$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $bc575342bbb76cde$var$ResultType.data,
        data: result
    };
} // Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $bc575342bbb76cde$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($bc575342bbb76cde$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $bc575342bbb76cde$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType, formData: formData } = submission; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? $bc575342bbb76cde$var$convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function $bc575342bbb76cde$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, value instanceof File ? value.name : value);
    return searchParams;
}
function $bc575342bbb76cde$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $bc575342bbb76cde$export$3e9cee6b33872309(!$bc575342bbb76cde$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($bc575342bbb76cde$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(matches, id);
            let error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $bc575342bbb76cde$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($bc575342bbb76cde$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $bc575342bbb76cde$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $bc575342bbb76cde$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds); // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match } = revalidatingFetchers[index];
        $bc575342bbb76cde$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index]; // Process fetcher non-redirect errors
        if ($bc575342bbb76cde$var$isErrorResult(result)) {
            let boundaryMatch = $bc575342bbb76cde$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $bc575342bbb76cde$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($bc575342bbb76cde$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $bc575342bbb76cde$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($bc575342bbb76cde$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $bc575342bbb76cde$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $bc575342bbb76cde$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $bc575342bbb76cde$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $bc575342bbb76cde$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $bc575342bbb76cde$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $bc575342bbb76cde$var$getInternalRouterError(status, _temp4) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp4 === void 0 ? {} : _temp4;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $bc575342bbb76cde$export$acf1a680051f5031(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function $bc575342bbb76cde$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($bc575342bbb76cde$var$isRedirectResult(result)) return result;
    }
}
function $bc575342bbb76cde$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(path) : path;
    return $bc575342bbb76cde$export$fe53371bee54353d($bc575342bbb76cde$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $bc575342bbb76cde$var$isHashChangeOnly(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash !== b.hash;
}
function $bc575342bbb76cde$var$isDeferredResult(result) {
    return result.type === $bc575342bbb76cde$var$ResultType.deferred;
}
function $bc575342bbb76cde$var$isErrorResult(result) {
    return result.type === $bc575342bbb76cde$var$ResultType.error;
}
function $bc575342bbb76cde$var$isRedirectResult(result) {
    return (result && result.type) === $bc575342bbb76cde$var$ResultType.redirect;
}
function $bc575342bbb76cde$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $bc575342bbb76cde$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $bc575342bbb76cde$var$isRedirectResponse(result) {
    if (!$bc575342bbb76cde$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $bc575342bbb76cde$var$isQueryRouteResponse(obj) {
    return obj && $bc575342bbb76cde$var$isResponse(obj.response) && (obj.type === $bc575342bbb76cde$var$ResultType.data || $bc575342bbb76cde$var$ResultType.error);
}
function $bc575342bbb76cde$var$isValidMethod(method) {
    return $bc575342bbb76cde$var$validRequestMethods.has(method.toLowerCase());
}
function $bc575342bbb76cde$var$isMutationMethod(method) {
    return $bc575342bbb76cde$var$validMutationMethods.has(method.toLowerCase());
}
async function $bc575342bbb76cde$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signal, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$bc575342bbb76cde$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($bc575342bbb76cde$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $bc575342bbb76cde$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
            if (result) results[index] = result || results[index];
        });
    }
}
async function $bc575342bbb76cde$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $bc575342bbb76cde$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $bc575342bbb76cde$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $bc575342bbb76cde$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $bc575342bbb76cde$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function $bc575342bbb76cde$var$createUseMatchesMatch(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $bc575342bbb76cde$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $bc575342bbb76cde$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $bc575342bbb76cde$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $bc575342bbb76cde$export$90ba53ce1c7fdff2(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

});


parcelRequire.register("8pPfi", function(module, exports) {

$parcel$export(module.exports, "createBrowserRouter", function () { return $620868da8c35addb$export$1f3f55432a00e06d; });
$parcel$export(module.exports, "Link", function () { return $620868da8c35addb$export$a6c7ac8248d6e38a; });
$parcel$export(module.exports, "useSearchParams", function () { return $620868da8c35addb$export$f1a78c17382fe22a; });
$parcel$export(module.exports, "unstable_useBlocker", function () { return (parcelRequire("9X5Bp")).unstable_useBlocker; });
$parcel$export(module.exports, "useHref", function () { return (parcelRequire("9X5Bp")).useHref; });
$parcel$export(module.exports, "useLocation", function () { return (parcelRequire("9X5Bp")).useLocation; });
$parcel$export(module.exports, "useNavigate", function () { return (parcelRequire("9X5Bp")).useNavigate; });
/**
 * React Router DOM v6.10.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eCoWV = parcelRequire("eCoWV");

var $gaxbO = parcelRequire("gaxbO");
var $9X5Bp = parcelRequire("9X5Bp");
var $gaxbO = parcelRequire("gaxbO");

var $gaxbO = parcelRequire("gaxbO");
function $620868da8c35addb$var$_extends() {
    $620868da8c35addb$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $620868da8c35addb$var$_extends.apply(this, arguments);
}
function $620868da8c35addb$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $620868da8c35addb$var$defaultMethod = "get";
const $620868da8c35addb$var$defaultEncType = "application/x-www-form-urlencoded";
function $620868da8c35addb$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $620868da8c35addb$var$isButtonElement(object) {
    return $620868da8c35addb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $620868da8c35addb$var$isFormElement(object) {
    return $620868da8c35addb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $620868da8c35addb$var$isInputElement(object) {
    return $620868da8c35addb$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $620868da8c35addb$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $620868da8c35addb$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$620868da8c35addb$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $620868da8c35addb$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $620868da8c35addb$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $620868da8c35addb$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) {
        for (let key of defaultSearchParams.keys())if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    }
    return searchParams;
}
function $620868da8c35addb$var$getFormSubmissionInfo(target, defaultAction, options) {
    let method;
    let action;
    let encType;
    let formData;
    if ($620868da8c35addb$var$isFormElement(target)) {
        let submissionTrigger = options.submissionTrigger;
        method = options.method || target.getAttribute("method") || $620868da8c35addb$var$defaultMethod;
        action = options.action || target.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("enctype") || $620868da8c35addb$var$defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if ($620868da8c35addb$var$isButtonElement(target) || $620868da8c35addb$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || $620868da8c35addb$var$defaultMethod;
        action = options.action || target.getAttribute("formaction") || form.getAttribute("action") || defaultAction;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || $620868da8c35addb$var$defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if ($620868da8c35addb$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || $620868da8c35addb$var$defaultMethod;
        action = options.action || defaultAction;
        encType = options.encType || $620868da8c35addb$var$defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            if (target instanceof URLSearchParams) for (let [name, value] of target)formData.append(name, value);
            else if (target != null) for (let name of Object.keys(target))formData.append(name, target[name]);
        }
    }
    let { protocol: protocol, host: host } = window.location;
    let url = new URL(action, protocol + "//" + host);
    return {
        url: url,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData
    };
}
const $620868da8c35addb$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], $620868da8c35addb$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], $620868da8c35addb$var$_excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function $620868da8c35addb$export$1f3f55432a00e06d(routes, opts) {
    return (0, $gaxbO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $gaxbO.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $620868da8c35addb$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $9X5Bp.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $620868da8c35addb$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $gaxbO.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: opts == null ? void 0 : opts.future,
        history: (0, $gaxbO.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $620868da8c35addb$var$parseHydrationData(),
        routes: routes,
        detectErrorBoundary: (0, $9X5Bp.UNSAFE_detectErrorBoundary)
    }).initialize();
}
function $620868da8c35addb$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $620868da8c35addb$var$_extends({}, state, {
        errors: $620868da8c35addb$var$deserializeErrors(state.errors)
    });
    return state;
}
function $620868da8c35addb$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $gaxbO.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            let error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
            // because we don't serialize SSR stack traces for security reasons
            error.stack = "";
            serialized[key] = error;
        } else serialized[key] = val;
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $620868da8c35addb$export$9ba4e89fdfa1fc54(_ref) {
    let { basename: basename, children: children, window: window1 } = _ref;
    let historyRef = $eCoWV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gaxbO.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eCoWV.useState({
        action: history.action,
        location: history.location
    });
    $eCoWV.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eCoWV.createElement((0, $9X5Bp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $620868da8c35addb$export$7221d69dcfc8e36b(_ref2) {
    let { basename: basename, children: children, window: window1 } = _ref2;
    let historyRef = $eCoWV.useRef();
    if (historyRef.current == null) historyRef.current = (0, $gaxbO.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setState] = $eCoWV.useState({
        action: history.action,
        location: history.location
    });
    $eCoWV.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eCoWV.createElement((0, $9X5Bp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $620868da8c35addb$export$eefb0c834599897e(_ref3) {
    let { basename: basename, children: children, history: history } = _ref3;
    const [state, setState] = $eCoWV.useState({
        action: history.action,
        location: history.location
    });
    $eCoWV.useLayoutEffect(()=>history.listen(setState), [
        history
    ]);
    return /*#__PURE__*/ $eCoWV.createElement((0, $9X5Bp.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
const $620868da8c35addb$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $620868da8c35addb$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ const $620868da8c35addb$export$a6c7ac8248d6e38a = /*#__PURE__*/ $eCoWV.forwardRef(function LinkWithRef(_ref4, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset } = _ref4, rest = $620868da8c35addb$var$_objectWithoutPropertiesLoose(_ref4, $620868da8c35addb$var$_excluded);
    let { basename: basename } = $eCoWV.useContext((0, $9X5Bp.UNSAFE_NavigationContext)); // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $620868da8c35addb$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if ($620868da8c35addb$var$isBrowser) {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $gaxbO.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        }
    } // Rendered into <a href> for relative URLs
    let href = (0, $9X5Bp.useHref)(to, {
        relative: relative
    });
    let internalOnClick = $620868da8c35addb$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $eCoWV.createElement("a", $620868da8c35addb$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ const $620868da8c35addb$export$b0d92dbee9b5b60d = /*#__PURE__*/ $eCoWV.forwardRef(function NavLinkWithRef(_ref5, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, children: children } = _ref5, rest = $620868da8c35addb$var$_objectWithoutPropertiesLoose(_ref5, $620868da8c35addb$var$_excluded2);
    let path = (0, $9X5Bp.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, $9X5Bp.useLocation)();
    let routerState = $eCoWV.useContext((0, $9X5Bp.UNSAFE_DataRouterStateContext));
    let { navigator: navigator } = $eCoWV.useContext((0, $9X5Bp.UNSAFE_NavigationContext));
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive: isActive,
        isPending: isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp({
        isActive: isActive,
        isPending: isPending
    }) : styleProp;
    return /*#__PURE__*/ $eCoWV.createElement($620868da8c35addb$export$a6c7ac8248d6e38a, $620868da8c35addb$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive: isActive,
        isPending: isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $620868da8c35addb$export$a7fed597f4b8afd8 = /*#__PURE__*/ $eCoWV.forwardRef((props, ref)=>{
    return /*#__PURE__*/ $eCoWV.createElement($620868da8c35addb$var$FormImpl, $620868da8c35addb$var$_extends({}, props, {
        ref: ref
    }));
});
const $620868da8c35addb$var$FormImpl = /*#__PURE__*/ $eCoWV.forwardRef((_ref6, forwardedRef)=>{
    let { reloadDocument: reloadDocument, replace: replace, method: method = $620868da8c35addb$var$defaultMethod, action: action, onSubmit: onSubmit, fetcherKey: fetcherKey, routeId: routeId, relative: relative, preventScrollReset: preventScrollReset } = _ref6, props = $620868da8c35addb$var$_objectWithoutPropertiesLoose(_ref6, $620868da8c35addb$var$_excluded3);
    let submit = $620868da8c35addb$var$useSubmitImpl(fetcherKey, routeId);
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let formAction = $620868da8c35addb$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace: replace,
            relative: relative,
            preventScrollReset: preventScrollReset
        });
    };
    return /*#__PURE__*/ $eCoWV.createElement("form", $620868da8c35addb$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $620868da8c35addb$export$11aac1aab828f1fa(_ref7) {
    let { getKey: getKey, storageKey: storageKey } = _ref7;
    $620868da8c35addb$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $620868da8c35addb$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})($620868da8c35addb$var$DataRouterHook || ($620868da8c35addb$var$DataRouterHook = {}));
var $620868da8c35addb$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($620868da8c35addb$var$DataRouterStateHook || ($620868da8c35addb$var$DataRouterStateHook = {}));
function $620868da8c35addb$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $620868da8c35addb$var$useDataRouterContext(hookName) {
    let ctx = $eCoWV.useContext((0, $9X5Bp.UNSAFE_DataRouterContext));
    !ctx && (0, $gaxbO.UNSAFE_invariant)(false);
    return ctx;
}
function $620868da8c35addb$var$useDataRouterState(hookName) {
    let state = $eCoWV.useContext((0, $9X5Bp.UNSAFE_DataRouterStateContext));
    !state && (0, $gaxbO.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $620868da8c35addb$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $9X5Bp.useNavigate)();
    let location = (0, $9X5Bp.useLocation)();
    let path = (0, $9X5Bp.useResolvedPath)(to, {
        relative: relative
    });
    return $eCoWV.useCallback((event)=>{
        if ($620868da8c35addb$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $gaxbO.createPath)(location) === (0, $gaxbO.createPath)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $620868da8c35addb$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $eCoWV.useRef($620868da8c35addb$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $eCoWV.useRef(false);
    let location = (0, $9X5Bp.useLocation)();
    let searchParams = $eCoWV.useMemo(()=>// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $620868da8c35addb$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $9X5Bp.useNavigate)();
    let setSearchParams = $eCoWV.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $620868da8c35addb$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $620868da8c35addb$export$47c85c6e3a081d3() {
    return $620868da8c35addb$var$useSubmitImpl();
}
function $620868da8c35addb$var$useSubmitImpl(fetcherKey, routeId) {
    let { router: router } = $620868da8c35addb$var$useDataRouterContext($620868da8c35addb$var$DataRouterHook.UseSubmitImpl);
    let defaultAction = $620868da8c35addb$export$89a6bd6db0d97c56();
    return $eCoWV.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        let { method: method, encType: encType, formData: formData, url: url } = $620868da8c35addb$var$getFormSubmissionInfo(target, defaultAction, options);
        let href = url.pathname + url.search;
        let opts = {
            replace: options.replace,
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(routeId != null) && (0, $gaxbO.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href, opts);
        } else router.navigate(href, opts);
    }, [
        defaultAction,
        router,
        fetcherKey,
        routeId
    ]);
}
function $620868da8c35addb$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $eCoWV.useContext((0, $9X5Bp.UNSAFE_NavigationContext));
    let routeContext = $eCoWV.useContext((0, $9X5Bp.UNSAFE_RouteContext));
    !routeContext && (0, $gaxbO.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1); // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $620868da8c35addb$var$_extends({}, (0, $9X5Bp.useResolvedPath)(action ? action : ".", {
        relative: relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $9X5Bp.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            let params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $gaxbO.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $gaxbO.createPath)(path);
}
function $620868da8c35addb$var$createFetcherForm(fetcherKey, routeId) {
    let FetcherForm = /*#__PURE__*/ $eCoWV.forwardRef((props, ref)=>{
        return /*#__PURE__*/ $eCoWV.createElement($620868da8c35addb$var$FormImpl, $620868da8c35addb$var$_extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
let $620868da8c35addb$var$fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $620868da8c35addb$export$5b0d2d9a9921565a() {
    var _route$matches;
    let { router: router } = $620868da8c35addb$var$useDataRouterContext($620868da8c35addb$var$DataRouterHook.UseFetcher);
    let route = $eCoWV.useContext((0, $9X5Bp.UNSAFE_RouteContext));
    !route && (0, $gaxbO.UNSAFE_invariant)(false);
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, $gaxbO.UNSAFE_invariant)(false);
    let [fetcherKey] = $eCoWV.useState(()=>String(++$620868da8c35addb$var$fetcherId));
    let [Form] = $eCoWV.useState(()=>{
        !routeId && (0, $gaxbO.UNSAFE_invariant)(false);
        return $620868da8c35addb$var$createFetcherForm(fetcherKey, routeId);
    });
    let [load] = $eCoWV.useState(()=>(href)=>{
            !router && (0, $gaxbO.UNSAFE_invariant)(false);
            !routeId && (0, $gaxbO.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        });
    let submit = $620868da8c35addb$var$useSubmitImpl(fetcherKey, routeId);
    let fetcher = router.getFetcher(fetcherKey);
    let fetcherWithComponents = $eCoWV.useMemo(()=>$620868da8c35addb$var$_extends({
            Form: Form,
            submit: submit,
            load: load
        }, fetcher), [
        fetcher,
        Form,
        submit,
        load
    ]);
    $eCoWV.useEffect(()=>{
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return ()=>{
            if (!router) {
                console.warn("No fetcher available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $620868da8c35addb$export$fa996778a3a31087() {
    let state = $620868da8c35addb$var$useDataRouterState($620868da8c35addb$var$DataRouterStateHook.UseFetchers);
    return [
        ...state.fetchers.values()
    ];
}
const $620868da8c35addb$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $620868da8c35addb$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $620868da8c35addb$export$25057cfe5591e3e9(_temp3) {
    let { getKey: getKey, storageKey: storageKey } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $620868da8c35addb$var$useDataRouterContext($620868da8c35addb$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $620868da8c35addb$var$useDataRouterState($620868da8c35addb$var$DataRouterStateHook.UseScrollRestoration);
    let location = (0, $9X5Bp.useLocation)();
    let matches = (0, $9X5Bp.useMatches)();
    let navigation = (0, $9X5Bp.useNavigation)(); // Trigger manual scroll restoration while we're active
    $eCoWV.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    $620868da8c35addb$var$usePageHide($eCoWV.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $620868da8c35addb$var$savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || $620868da8c35addb$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($620868da8c35addb$var$savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eCoWV.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $620868da8c35addb$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $620868da8c35addb$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eCoWV.useLayoutEffect(()=>{
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($620868da8c35addb$var$savedScrollPositions, ()=>window.scrollY, getKey);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $eCoWV.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $620868da8c35addb$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $eCoWV.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $620868da8c35addb$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $eCoWV.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $620868da8c35addb$export$39f4eb3dbd812741(_ref8) {
    let { when: when, message: message } = _ref8;
    let blocker = (0, $9X5Bp.unstable_useBlocker)(when);
    $eCoWV.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    $eCoWV.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

});



parcelRequire.register("9ENFn", function(module, exports) {

$parcel$export(module.exports, "useConfirmModal", function () { return $bca2f1fa273364a1$export$753980156bc86c10; });

var $eCoWV = parcelRequire("eCoWV");

var $8Rn6p = parcelRequire("8Rn6p");
const $bca2f1fa273364a1$export$753980156bc86c10 = ()=>(0, $eCoWV.useContext)((0, $8Rn6p.AppConfirmModalContext));

});
parcelRequire.register("8Rn6p", function(module, exports) {

$parcel$export(module.exports, "AppConfirmModalContext", function () { return $ec60f74de587a5d9$export$9967fa47cf125764; });
$parcel$export(module.exports, "default", function () { return $ec60f74de587a5d9$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $eCoWV = parcelRequire("eCoWV");

var $kMAP9 = parcelRequire("kMAP9");
const $ec60f74de587a5d9$export$9967fa47cf125764 = /*#__PURE__*/ (0, $eCoWV.createContext)({
    show: async ()=>[
            true
        ],
    confirm: (0, $aWIy6.noop),
    cancel: (0, $aWIy6.noop)
});
const $ec60f74de587a5d9$var$defaultModalState = {
    isOpen: false,
    type: "confirm",
    ModalContent: ()=>null
};
function $ec60f74de587a5d9$var$AppConfirmModalProvider({ children: children }) {
    const [modalState, setModalState] = (0, $eCoWV.useState)($ec60f74de587a5d9$var$defaultModalState);
    const resolver = (0, $eCoWV.useRef)();
    const handleShow = (0, $eCoWV.useCallback)(async ({ type: type = "confirm", ...props })=>{
        resolver.current?.([
            false
        ]);
        setModalState({
            isOpen: true,
            type: type,
            ...props
        });
        return new Promise((resolve)=>{
            // eslint-disable-next-line @silverhand/fp/no-mutation
            resolver.current = resolve;
        });
    }, []);
    const handleConfirm = (0, $eCoWV.useCallback)((data)=>{
        resolver.current?.([
            true,
            data
        ]);
        setModalState($ec60f74de587a5d9$var$defaultModalState);
    }, []);
    const handleCancel = (0, $eCoWV.useCallback)((data)=>{
        resolver.current?.([
            false,
            data
        ]);
        setModalState($ec60f74de587a5d9$var$defaultModalState);
    }, []);
    const contextValue = (0, $eCoWV.useMemo)(()=>({
            show: handleShow,
            confirm: handleConfirm,
            cancel: handleCancel
        }), [
        handleCancel,
        handleConfirm,
        handleShow
    ]);
    (0, $eCoWV.useEffect)(()=>{
        const handlePathChange = ()=>{
            handleCancel();
        };
        /**
     * Note: Close the modal when the location path changes.
     * We don't use react-router-dom's `UseLocation` since this is a global component and not relying on the router.
     */ window.addEventListener("popstate", handlePathChange);
        return ()=>{
            window.removeEventListener("popstate", handlePathChange);
        };
    }, [
        handleCancel
    ]);
    const { ModalContent: ModalContent, type: type, ...restProps } = modalState;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)($ec60f74de587a5d9$export$9967fa47cf125764.Provider, {
        value: contextValue,
        children: [
            children,
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                ...restProps,
                onConfirm: type === "confirm" ? ()=>{
                    handleConfirm();
                } : undefined,
                onCancel: ()=>{
                    handleCancel();
                },
                children: typeof ModalContent === "string" ? ModalContent : /*#__PURE__*/ (0, $9zeGj.jsx)(ModalContent, {
                    confirm: handleConfirm,
                    cancel: handleCancel
                })
            })
        ]
    });
}
var $ec60f74de587a5d9$export$2e2bcd8739ae039 = $ec60f74de587a5d9$var$AppConfirmModalProvider;

});
parcelRequire.register("kMAP9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d2cb2a9a0b5ab58$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $bFFWx = parcelRequire("bFFWx");

var $kcPww = parcelRequire("kcPww");

var $7iZsu = parcelRequire("7iZsu");

var $bNHoO = parcelRequire("bNHoO");

var $gsHBE = parcelRequire("gsHBE");
function $0d2cb2a9a0b5ab58$var$ConfirmModal({ children: children, className: className, title: title = "general.reminder", confirmButtonType: confirmButtonType = "danger", confirmButtonText: confirmButtonText = "general.confirm", cancelButtonText: cancelButtonText = "general.cancel", isOpen: isOpen, isConfirmButtonDisabled: isConfirmButtonDisabled = false, isLoading: isLoading = false, isCancelButtonVisible: isCancelButtonVisible = true, size: size, onCancel: onCancel, onConfirm: onConfirm }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onCancel,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: title,
            footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    isCancelButtonVisible && onCancel && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: cancelButtonText,
                        onClick: onCancel
                    }),
                    onConfirm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: confirmButtonType,
                        title: confirmButtonText,
                        disabled: isConfirmButtonDisabled,
                        isLoading: isLoading,
                        onClick: onConfirm
                    })
                ]
            }),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($gsHBE.content, className),
            size: size,
            onClose: onCancel,
            children: children
        })
    });
}
var $0d2cb2a9a0b5ab58$export$2e2bcd8739ae039 = $0d2cb2a9a0b5ab58$var$ConfirmModal;

});
parcelRequire.register("bFFWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8QKwW = parcelRequire("8QKwW");
var $87f40f1b2fb64de3$var$_Modal2 = $87f40f1b2fb64de3$var$_interopRequireDefault($8QKwW);
function $87f40f1b2fb64de3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = $87f40f1b2fb64de3$var$_Modal2.default;
module.exports = module.exports["default"];

});
parcelRequire.register("8QKwW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bodyOpenClassName = module.exports.portalClassName = undefined;
var $67174607a248b030$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $67174607a248b030$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eCoWV = parcelRequire("eCoWV");
var $67174607a248b030$var$_react2 = $67174607a248b030$var$_interopRequireDefault($eCoWV);

var $iVz18 = parcelRequire("iVz18");
var $67174607a248b030$var$_reactDom2 = $67174607a248b030$var$_interopRequireDefault($iVz18);

var $hqomP = parcelRequire("hqomP");
var $67174607a248b030$var$_propTypes2 = $67174607a248b030$var$_interopRequireDefault($hqomP);

var $2SNtD = parcelRequire("2SNtD");
var $67174607a248b030$var$_ModalPortal2 = $67174607a248b030$var$_interopRequireDefault($2SNtD);

var $9bgNd = parcelRequire("9bgNd");
var $67174607a248b030$var$ariaAppHider = $67174607a248b030$var$_interopRequireWildcard($9bgNd);

var $2715L = parcelRequire("2715L");
var $67174607a248b030$var$_safeHTMLElement2 = $67174607a248b030$var$_interopRequireDefault($2715L);

var $aUKHN = parcelRequire("aUKHN");
function $67174607a248b030$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $67174607a248b030$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $67174607a248b030$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $67174607a248b030$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $67174607a248b030$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $67174607a248b030$var$portalClassName = module.exports.portalClassName = "ReactModalPortal";
var $67174607a248b030$var$bodyOpenClassName = module.exports.bodyOpenClassName = "ReactModal__Body--open";
var $67174607a248b030$var$isReact16 = $2715L.canUseDOM && $67174607a248b030$var$_reactDom2.default.createPortal !== undefined;
var $67174607a248b030$var$createHTMLElement = function createHTMLElement(name) {
    return document.createElement(name);
};
var $67174607a248b030$var$getCreatePortal = function getCreatePortal() {
    return $67174607a248b030$var$isReact16 ? $67174607a248b030$var$_reactDom2.default.createPortal : $67174607a248b030$var$_reactDom2.default.unstable_renderSubtreeIntoContainer;
};
function $67174607a248b030$var$getParentElement(parentSelector) {
    return parentSelector();
}
var $67174607a248b030$var$Modal = function(_Component) {
    $67174607a248b030$var$_inherits(Modal, _Component);
    function Modal() {
        var _ref;
        var _temp, _this, _ret;
        $67174607a248b030$var$_classCallCheck(this, Modal);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $67174607a248b030$var$_possibleConstructorReturn(this, (_ref = Modal.__proto__ || Object.getPrototypeOf(Modal)).call.apply(_ref, [
            this
        ].concat(args))), _this), _this.removePortal = function() {
            !$67174607a248b030$var$isReact16 && $67174607a248b030$var$_reactDom2.default.unmountComponentAtNode(_this.node);
            var parent = $67174607a248b030$var$getParentElement(_this.props.parentSelector);
            if (parent && parent.contains(_this.node)) parent.removeChild(_this.node);
            else // eslint-disable-next-line no-console
            console.warn('React-Modal: "parentSelector" prop did not returned any DOM element. Make sure that the parent element is unmounted to avoid any memory leaks.');
        }, _this.portalRef = function(ref) {
            _this.portal = ref;
        }, _this.renderPortal = function(props) {
            var createPortal = $67174607a248b030$var$getCreatePortal();
            var portal = createPortal(_this, $67174607a248b030$var$_react2.default.createElement($67174607a248b030$var$_ModalPortal2.default, $67174607a248b030$var$_extends({
                defaultStyles: Modal.defaultStyles
            }, props)), _this.node);
            _this.portalRef(portal);
        }, _temp), $67174607a248b030$var$_possibleConstructorReturn(_this, _ret);
    }
    $67174607a248b030$var$_createClass(Modal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (!$2715L.canUseDOM) return;
                if (!$67174607a248b030$var$isReact16) this.node = $67174607a248b030$var$createHTMLElement("div");
                this.node.className = this.props.portalClassName;
                var parent = $67174607a248b030$var$getParentElement(this.props.parentSelector);
                parent.appendChild(this.node);
                !$67174607a248b030$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "getSnapshotBeforeUpdate",
            value: function getSnapshotBeforeUpdate(prevProps) {
                var prevParent = $67174607a248b030$var$getParentElement(prevProps.parentSelector);
                var nextParent = $67174607a248b030$var$getParentElement(this.props.parentSelector);
                return {
                    prevParent: prevParent,
                    nextParent: nextParent
                };
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, _, snapshot) {
                if (!$2715L.canUseDOM) return;
                var _props = this.props, isOpen = _props.isOpen, portalClassName = _props.portalClassName;
                if (prevProps.portalClassName !== portalClassName) this.node.className = portalClassName;
                var prevParent = snapshot.prevParent, nextParent = snapshot.nextParent;
                if (nextParent !== prevParent) {
                    prevParent.removeChild(this.node);
                    nextParent.appendChild(this.node);
                }
                // Stop unnecessary renders if modal is remaining closed
                if (!prevProps.isOpen && !isOpen) return;
                !$67174607a248b030$var$isReact16 && this.renderPortal(this.props);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (!$2715L.canUseDOM || !this.node || !this.portal) return;
                var state = this.portal.state;
                var now = Date.now();
                var closesAt = state.isOpen && this.props.closeTimeoutMS && (state.closesAt || now + this.props.closeTimeoutMS);
                if (closesAt) {
                    if (!state.beforeClose) this.portal.closeWithTimeout();
                    setTimeout(this.removePortal, closesAt - now);
                } else this.removePortal();
            }
        },
        {
            key: "render",
            value: function render() {
                if (!$2715L.canUseDOM || !$67174607a248b030$var$isReact16) return null;
                if (!this.node && $67174607a248b030$var$isReact16) this.node = $67174607a248b030$var$createHTMLElement("div");
                var createPortal = $67174607a248b030$var$getCreatePortal();
                return createPortal($67174607a248b030$var$_react2.default.createElement($67174607a248b030$var$_ModalPortal2.default, $67174607a248b030$var$_extends({
                    ref: this.portalRef,
                    defaultStyles: Modal.defaultStyles
                }, this.props)), this.node);
            }
        }
    ], [
        {
            key: "setAppElement",
            value: function setAppElement(element) {
                $67174607a248b030$var$ariaAppHider.setElement(element);
            }
        }
    ]);
    return Modal;
}($eCoWV.Component);
$67174607a248b030$var$Modal.propTypes = {
    isOpen: $67174607a248b030$var$_propTypes2.default.bool.isRequired,
    style: $67174607a248b030$var$_propTypes2.default.shape({
        content: $67174607a248b030$var$_propTypes2.default.object,
        overlay: $67174607a248b030$var$_propTypes2.default.object
    }),
    portalClassName: $67174607a248b030$var$_propTypes2.default.string,
    bodyOpenClassName: $67174607a248b030$var$_propTypes2.default.string,
    htmlOpenClassName: $67174607a248b030$var$_propTypes2.default.string,
    className: $67174607a248b030$var$_propTypes2.default.oneOfType([
        $67174607a248b030$var$_propTypes2.default.string,
        $67174607a248b030$var$_propTypes2.default.shape({
            base: $67174607a248b030$var$_propTypes2.default.string.isRequired,
            afterOpen: $67174607a248b030$var$_propTypes2.default.string.isRequired,
            beforeClose: $67174607a248b030$var$_propTypes2.default.string.isRequired
        })
    ]),
    overlayClassName: $67174607a248b030$var$_propTypes2.default.oneOfType([
        $67174607a248b030$var$_propTypes2.default.string,
        $67174607a248b030$var$_propTypes2.default.shape({
            base: $67174607a248b030$var$_propTypes2.default.string.isRequired,
            afterOpen: $67174607a248b030$var$_propTypes2.default.string.isRequired,
            beforeClose: $67174607a248b030$var$_propTypes2.default.string.isRequired
        })
    ]),
    appElement: $67174607a248b030$var$_propTypes2.default.oneOfType([
        $67174607a248b030$var$_propTypes2.default.instanceOf($67174607a248b030$var$_safeHTMLElement2.default),
        $67174607a248b030$var$_propTypes2.default.instanceOf($2715L.SafeHTMLCollection),
        $67174607a248b030$var$_propTypes2.default.instanceOf($2715L.SafeNodeList),
        $67174607a248b030$var$_propTypes2.default.arrayOf($67174607a248b030$var$_propTypes2.default.instanceOf($67174607a248b030$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $67174607a248b030$var$_propTypes2.default.func,
    onRequestClose: $67174607a248b030$var$_propTypes2.default.func,
    closeTimeoutMS: $67174607a248b030$var$_propTypes2.default.number,
    ariaHideApp: $67174607a248b030$var$_propTypes2.default.bool,
    shouldFocusAfterRender: $67174607a248b030$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $67174607a248b030$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $67174607a248b030$var$_propTypes2.default.bool,
    preventScroll: $67174607a248b030$var$_propTypes2.default.bool,
    parentSelector: $67174607a248b030$var$_propTypes2.default.func,
    aria: $67174607a248b030$var$_propTypes2.default.object,
    data: $67174607a248b030$var$_propTypes2.default.object,
    role: $67174607a248b030$var$_propTypes2.default.string,
    contentLabel: $67174607a248b030$var$_propTypes2.default.string,
    shouldCloseOnEsc: $67174607a248b030$var$_propTypes2.default.bool,
    overlayRef: $67174607a248b030$var$_propTypes2.default.func,
    contentRef: $67174607a248b030$var$_propTypes2.default.func,
    id: $67174607a248b030$var$_propTypes2.default.string,
    overlayElement: $67174607a248b030$var$_propTypes2.default.func,
    contentElement: $67174607a248b030$var$_propTypes2.default.func
};
$67174607a248b030$var$Modal.defaultProps = {
    isOpen: false,
    portalClassName: $67174607a248b030$var$portalClassName,
    bodyOpenClassName: $67174607a248b030$var$bodyOpenClassName,
    role: "dialog",
    ariaHideApp: true,
    closeTimeoutMS: 0,
    shouldFocusAfterRender: true,
    shouldCloseOnEsc: true,
    shouldCloseOnOverlayClick: true,
    shouldReturnFocusAfterClose: true,
    preventScroll: false,
    parentSelector: function parentSelector() {
        return document.body;
    },
    overlayElement: function overlayElement(props, contentEl) {
        return $67174607a248b030$var$_react2.default.createElement("div", props, contentEl);
    },
    contentElement: function contentElement(props, children) {
        return $67174607a248b030$var$_react2.default.createElement("div", props, children);
    }
};
$67174607a248b030$var$Modal.defaultStyles = {
    overlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(255, 255, 255, 0.75)"
    },
    content: {
        position: "absolute",
        top: "40px",
        left: "40px",
        right: "40px",
        bottom: "40px",
        border: "1px solid #ccc",
        background: "#fff",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        borderRadius: "4px",
        outline: "none",
        padding: "20px"
    }
};
(0, $aUKHN.polyfill)($67174607a248b030$var$Modal);
module.exports.default = $67174607a248b030$var$Modal;

});
parcelRequire.register("2SNtD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $219700feadff1a24$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $219700feadff1a24$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $219700feadff1a24$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");
var $219700feadff1a24$var$_propTypes2 = $219700feadff1a24$var$_interopRequireDefault($hqomP);

var $JRYjT = parcelRequire("JRYjT");
var $219700feadff1a24$var$focusManager = $219700feadff1a24$var$_interopRequireWildcard($JRYjT);

var $776s4 = parcelRequire("776s4");
var $219700feadff1a24$var$_scopeTab2 = $219700feadff1a24$var$_interopRequireDefault($776s4);

var $9bgNd = parcelRequire("9bgNd");
var $219700feadff1a24$var$ariaAppHider = $219700feadff1a24$var$_interopRequireWildcard($9bgNd);

var $j1jC2 = parcelRequire("j1jC2");
var $219700feadff1a24$var$classList = $219700feadff1a24$var$_interopRequireWildcard($j1jC2);

var $2715L = parcelRequire("2715L");
var $219700feadff1a24$var$_safeHTMLElement2 = $219700feadff1a24$var$_interopRequireDefault($2715L);

var $dMgIx = parcelRequire("dMgIx");
var $219700feadff1a24$var$_portalOpenInstances2 = $219700feadff1a24$var$_interopRequireDefault($dMgIx);
parcelRequire("jpfAT");
function $219700feadff1a24$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
        }
        newObj.default = obj;
        return newObj;
    }
}
function $219700feadff1a24$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $219700feadff1a24$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $219700feadff1a24$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $219700feadff1a24$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
// so that our CSS is statically analyzable
var $219700feadff1a24$var$CLASS_NAMES = {
    overlay: "ReactModal__Overlay",
    content: "ReactModal__Content"
};
var $219700feadff1a24$var$TAB_KEY = 9;
var $219700feadff1a24$var$ESC_KEY = 27;
var $219700feadff1a24$var$ariaHiddenInstances = 0;
var $219700feadff1a24$var$ModalPortal = function(_Component) {
    $219700feadff1a24$var$_inherits(ModalPortal, _Component);
    function ModalPortal(props) {
        $219700feadff1a24$var$_classCallCheck(this, ModalPortal);
        var _this = $219700feadff1a24$var$_possibleConstructorReturn(this, (ModalPortal.__proto__ || Object.getPrototypeOf(ModalPortal)).call(this, props));
        _this.setOverlayRef = function(overlay) {
            _this.overlay = overlay;
            _this.props.overlayRef && _this.props.overlayRef(overlay);
        };
        _this.setContentRef = function(content) {
            _this.content = content;
            _this.props.contentRef && _this.props.contentRef(content);
        };
        _this.afterClose = function() {
            var _this$props = _this.props, appElement = _this$props.appElement, ariaHideApp = _this$props.ariaHideApp, htmlOpenClassName = _this$props.htmlOpenClassName, bodyOpenClassName = _this$props.bodyOpenClassName;
            // Remove classes.
            bodyOpenClassName && $219700feadff1a24$var$classList.remove(document.body, bodyOpenClassName);
            htmlOpenClassName && $219700feadff1a24$var$classList.remove(document.getElementsByTagName("html")[0], htmlOpenClassName);
            // Reset aria-hidden attribute if all modals have been removed
            if (ariaHideApp && $219700feadff1a24$var$ariaHiddenInstances > 0) {
                $219700feadff1a24$var$ariaHiddenInstances -= 1;
                if ($219700feadff1a24$var$ariaHiddenInstances === 0) $219700feadff1a24$var$ariaAppHider.show(appElement);
            }
            if (_this.props.shouldFocusAfterRender) {
                if (_this.props.shouldReturnFocusAfterClose) {
                    $219700feadff1a24$var$focusManager.returnFocus(_this.props.preventScroll);
                    $219700feadff1a24$var$focusManager.teardownScopedFocus();
                } else $219700feadff1a24$var$focusManager.popWithoutFocus();
            }
            if (_this.props.onAfterClose) _this.props.onAfterClose();
            $219700feadff1a24$var$_portalOpenInstances2.default.deregister(_this);
        };
        _this.open = function() {
            _this.beforeOpen();
            if (_this.state.afterOpen && _this.state.beforeClose) {
                clearTimeout(_this.closeTimer);
                _this.setState({
                    beforeClose: false
                });
            } else {
                if (_this.props.shouldFocusAfterRender) {
                    $219700feadff1a24$var$focusManager.setupScopedFocus(_this.node);
                    $219700feadff1a24$var$focusManager.markForFocusLater();
                }
                _this.setState({
                    isOpen: true
                }, function() {
                    _this.openAnimationFrame = requestAnimationFrame(function() {
                        _this.setState({
                            afterOpen: true
                        });
                        if (_this.props.isOpen && _this.props.onAfterOpen) _this.props.onAfterOpen({
                            overlayEl: _this.overlay,
                            contentEl: _this.content
                        });
                    });
                });
            }
        };
        _this.close = function() {
            if (_this.props.closeTimeoutMS > 0) _this.closeWithTimeout();
            else _this.closeWithoutTimeout();
        };
        _this.focusContent = function() {
            return _this.content && !_this.contentHasFocus() && _this.content.focus({
                preventScroll: true
            });
        };
        _this.closeWithTimeout = function() {
            var closesAt = Date.now() + _this.props.closeTimeoutMS;
            _this.setState({
                beforeClose: true,
                closesAt: closesAt
            }, function() {
                _this.closeTimer = setTimeout(_this.closeWithoutTimeout, _this.state.closesAt - Date.now());
            });
        };
        _this.closeWithoutTimeout = function() {
            _this.setState({
                beforeClose: false,
                isOpen: false,
                afterOpen: false,
                closesAt: null
            }, _this.afterClose);
        };
        _this.handleKeyDown = function(event) {
            if (event.keyCode === $219700feadff1a24$var$TAB_KEY) (0, $219700feadff1a24$var$_scopeTab2.default)(_this.content, event);
            if (_this.props.shouldCloseOnEsc && event.keyCode === $219700feadff1a24$var$ESC_KEY) {
                event.stopPropagation();
                _this.requestClose(event);
            }
        };
        _this.handleOverlayOnClick = function(event) {
            if (_this.shouldClose === null) _this.shouldClose = true;
            if (_this.shouldClose && _this.props.shouldCloseOnOverlayClick) {
                if (_this.ownerHandlesClose()) _this.requestClose(event);
                else _this.focusContent();
            }
            _this.shouldClose = null;
        };
        _this.handleContentOnMouseUp = function() {
            _this.shouldClose = false;
        };
        _this.handleOverlayOnMouseDown = function(event) {
            if (!_this.props.shouldCloseOnOverlayClick && event.target == _this.overlay) event.preventDefault();
        };
        _this.handleContentOnClick = function() {
            _this.shouldClose = false;
        };
        _this.handleContentOnMouseDown = function() {
            _this.shouldClose = false;
        };
        _this.requestClose = function(event) {
            return _this.ownerHandlesClose() && _this.props.onRequestClose(event);
        };
        _this.ownerHandlesClose = function() {
            return _this.props.onRequestClose;
        };
        _this.shouldBeClosed = function() {
            return !_this.state.isOpen && !_this.state.beforeClose;
        };
        _this.contentHasFocus = function() {
            return document.activeElement === _this.content || _this.content.contains(document.activeElement);
        };
        _this.buildClassName = function(which, additional) {
            var classNames = (typeof additional === "undefined" ? "undefined" : $219700feadff1a24$var$_typeof(additional)) === "object" ? additional : {
                base: $219700feadff1a24$var$CLASS_NAMES[which],
                afterOpen: $219700feadff1a24$var$CLASS_NAMES[which] + "--after-open",
                beforeClose: $219700feadff1a24$var$CLASS_NAMES[which] + "--before-close"
            };
            var className = classNames.base;
            if (_this.state.afterOpen) className = className + " " + classNames.afterOpen;
            if (_this.state.beforeClose) className = className + " " + classNames.beforeClose;
            return typeof additional === "string" && additional ? className + " " + additional : className;
        };
        _this.attributesFromObject = function(prefix, items) {
            return Object.keys(items).reduce(function(acc, name) {
                acc[prefix + "-" + name] = items[name];
                return acc;
            }, {});
        };
        _this.state = {
            afterOpen: false,
            beforeClose: false
        };
        _this.shouldClose = null;
        _this.moveFromContentToOverlay = null;
        return _this;
    }
    $219700feadff1a24$var$_createClass(ModalPortal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.isOpen) this.open();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.isOpen && !prevProps.isOpen) this.open();
                else if (!this.props.isOpen && prevProps.isOpen) this.close();
                // Focus only needs to be set once when the modal is being opened
                if (this.props.shouldFocusAfterRender && this.state.isOpen && !prevState.isOpen) this.focusContent();
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.state.isOpen) this.afterClose();
                clearTimeout(this.closeTimer);
                cancelAnimationFrame(this.openAnimationFrame);
            }
        },
        {
            key: "beforeOpen",
            value: function beforeOpen() {
                var _props = this.props, appElement = _props.appElement, ariaHideApp = _props.ariaHideApp, htmlOpenClassName = _props.htmlOpenClassName, bodyOpenClassName = _props.bodyOpenClassName;
                // Add classes.
                bodyOpenClassName && $219700feadff1a24$var$classList.add(document.body, bodyOpenClassName);
                htmlOpenClassName && $219700feadff1a24$var$classList.add(document.getElementsByTagName("html")[0], htmlOpenClassName);
                if (ariaHideApp) {
                    $219700feadff1a24$var$ariaHiddenInstances += 1;
                    $219700feadff1a24$var$ariaAppHider.hide(appElement);
                }
                $219700feadff1a24$var$_portalOpenInstances2.default.register(this);
            }
        },
        {
            key: "render",
            value: function render() {
                var _props2 = this.props, id = _props2.id, className = _props2.className, overlayClassName = _props2.overlayClassName, defaultStyles = _props2.defaultStyles, children = _props2.children;
                var contentStyles = className ? {} : defaultStyles.content;
                var overlayStyles = overlayClassName ? {} : defaultStyles.overlay;
                if (this.shouldBeClosed()) return null;
                var overlayProps = {
                    ref: this.setOverlayRef,
                    className: this.buildClassName("overlay", overlayClassName),
                    style: $219700feadff1a24$var$_extends({}, overlayStyles, this.props.style.overlay),
                    onClick: this.handleOverlayOnClick,
                    onMouseDown: this.handleOverlayOnMouseDown
                };
                var contentProps = $219700feadff1a24$var$_extends({
                    id: id,
                    ref: this.setContentRef,
                    style: $219700feadff1a24$var$_extends({}, contentStyles, this.props.style.content),
                    className: this.buildClassName("content", className),
                    tabIndex: "-1",
                    onKeyDown: this.handleKeyDown,
                    onMouseDown: this.handleContentOnMouseDown,
                    onMouseUp: this.handleContentOnMouseUp,
                    onClick: this.handleContentOnClick,
                    role: this.props.role,
                    "aria-label": this.props.contentLabel
                }, this.attributesFromObject("aria", $219700feadff1a24$var$_extends({
                    modal: true
                }, this.props.aria)), this.attributesFromObject("data", this.props.data || {}), {
                    "data-testid": this.props.testId
                });
                var contentElement = this.props.contentElement(contentProps, children);
                return this.props.overlayElement(overlayProps, contentElement);
            }
        }
    ]);
    return ModalPortal;
}($eCoWV.Component);
$219700feadff1a24$var$ModalPortal.defaultProps = {
    style: {
        overlay: {},
        content: {}
    },
    defaultStyles: {}
};
$219700feadff1a24$var$ModalPortal.propTypes = {
    isOpen: $219700feadff1a24$var$_propTypes2.default.bool.isRequired,
    defaultStyles: $219700feadff1a24$var$_propTypes2.default.shape({
        content: $219700feadff1a24$var$_propTypes2.default.object,
        overlay: $219700feadff1a24$var$_propTypes2.default.object
    }),
    style: $219700feadff1a24$var$_propTypes2.default.shape({
        content: $219700feadff1a24$var$_propTypes2.default.object,
        overlay: $219700feadff1a24$var$_propTypes2.default.object
    }),
    className: $219700feadff1a24$var$_propTypes2.default.oneOfType([
        $219700feadff1a24$var$_propTypes2.default.string,
        $219700feadff1a24$var$_propTypes2.default.object
    ]),
    overlayClassName: $219700feadff1a24$var$_propTypes2.default.oneOfType([
        $219700feadff1a24$var$_propTypes2.default.string,
        $219700feadff1a24$var$_propTypes2.default.object
    ]),
    bodyOpenClassName: $219700feadff1a24$var$_propTypes2.default.string,
    htmlOpenClassName: $219700feadff1a24$var$_propTypes2.default.string,
    ariaHideApp: $219700feadff1a24$var$_propTypes2.default.bool,
    appElement: $219700feadff1a24$var$_propTypes2.default.oneOfType([
        $219700feadff1a24$var$_propTypes2.default.instanceOf($219700feadff1a24$var$_safeHTMLElement2.default),
        $219700feadff1a24$var$_propTypes2.default.instanceOf($2715L.SafeHTMLCollection),
        $219700feadff1a24$var$_propTypes2.default.instanceOf($2715L.SafeNodeList),
        $219700feadff1a24$var$_propTypes2.default.arrayOf($219700feadff1a24$var$_propTypes2.default.instanceOf($219700feadff1a24$var$_safeHTMLElement2.default))
    ]),
    onAfterOpen: $219700feadff1a24$var$_propTypes2.default.func,
    onAfterClose: $219700feadff1a24$var$_propTypes2.default.func,
    onRequestClose: $219700feadff1a24$var$_propTypes2.default.func,
    closeTimeoutMS: $219700feadff1a24$var$_propTypes2.default.number,
    shouldFocusAfterRender: $219700feadff1a24$var$_propTypes2.default.bool,
    shouldCloseOnOverlayClick: $219700feadff1a24$var$_propTypes2.default.bool,
    shouldReturnFocusAfterClose: $219700feadff1a24$var$_propTypes2.default.bool,
    preventScroll: $219700feadff1a24$var$_propTypes2.default.bool,
    role: $219700feadff1a24$var$_propTypes2.default.string,
    contentLabel: $219700feadff1a24$var$_propTypes2.default.string,
    aria: $219700feadff1a24$var$_propTypes2.default.object,
    data: $219700feadff1a24$var$_propTypes2.default.object,
    children: $219700feadff1a24$var$_propTypes2.default.node,
    shouldCloseOnEsc: $219700feadff1a24$var$_propTypes2.default.bool,
    overlayRef: $219700feadff1a24$var$_propTypes2.default.func,
    contentRef: $219700feadff1a24$var$_propTypes2.default.func,
    id: $219700feadff1a24$var$_propTypes2.default.string,
    overlayElement: $219700feadff1a24$var$_propTypes2.default.func,
    contentElement: $219700feadff1a24$var$_propTypes2.default.func,
    testId: $219700feadff1a24$var$_propTypes2.default.string
};
module.exports.default = $219700feadff1a24$var$ModalPortal;
module.exports = module.exports["default"];

});
parcelRequire.register("JRYjT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $089e11c7687c341c$var$resetState;
module.exports.log = $089e11c7687c341c$var$log;
module.exports.handleBlur = $089e11c7687c341c$var$handleBlur;
module.exports.handleFocus = $089e11c7687c341c$var$handleFocus;
module.exports.markForFocusLater = $089e11c7687c341c$var$markForFocusLater;
module.exports.returnFocus = $089e11c7687c341c$var$returnFocus;
module.exports.popWithoutFocus = $089e11c7687c341c$var$popWithoutFocus;
module.exports.setupScopedFocus = $089e11c7687c341c$var$setupScopedFocus;
module.exports.teardownScopedFocus = $089e11c7687c341c$var$teardownScopedFocus;

var $kBKjR = parcelRequire("kBKjR");
var $089e11c7687c341c$var$_tabbable2 = $089e11c7687c341c$var$_interopRequireDefault($kBKjR);
function $089e11c7687c341c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $089e11c7687c341c$var$focusLaterElements = [];
var $089e11c7687c341c$var$modalElement = null;
var $089e11c7687c341c$var$needToFocus = false;
/* eslint-disable no-console */ /* istanbul ignore next */ function $089e11c7687c341c$var$resetState() {
    $089e11c7687c341c$var$focusLaterElements = [];
}
/* istanbul ignore next */ function $089e11c7687c341c$var$log() {}
/* eslint-enable no-console */ function $089e11c7687c341c$var$handleBlur() {
    $089e11c7687c341c$var$needToFocus = true;
}
function $089e11c7687c341c$var$handleFocus() {
    if ($089e11c7687c341c$var$needToFocus) {
        $089e11c7687c341c$var$needToFocus = false;
        if (!$089e11c7687c341c$var$modalElement) return;
        // need to see how jQuery shims document.on('focusin') so we don't need the
        // setTimeout, firefox doesn't support focusin, if it did, we could focus
        // the element outside of a setTimeout. Side-effect of this implementation
        // is that the document.body gets focus, and then we focus our element right
        // after, seems fine.
        setTimeout(function() {
            if ($089e11c7687c341c$var$modalElement.contains(document.activeElement)) return;
            var el = (0, $089e11c7687c341c$var$_tabbable2.default)($089e11c7687c341c$var$modalElement)[0] || $089e11c7687c341c$var$modalElement;
            el.focus();
        }, 0);
    }
}
function $089e11c7687c341c$var$markForFocusLater() {
    $089e11c7687c341c$var$focusLaterElements.push(document.activeElement);
}
/* eslint-disable no-console */ function $089e11c7687c341c$var$returnFocus() {
    var preventScroll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var toFocus = null;
    try {
        if ($089e11c7687c341c$var$focusLaterElements.length !== 0) {
            toFocus = $089e11c7687c341c$var$focusLaterElements.pop();
            toFocus.focus({
                preventScroll: preventScroll
            });
        }
        return;
    } catch (e) {
        console.warn([
            "You tried to return focus to",
            toFocus,
            "but it is not in the DOM anymore"
        ].join(" "));
    }
}
/* eslint-enable no-console */ function $089e11c7687c341c$var$popWithoutFocus() {
    $089e11c7687c341c$var$focusLaterElements.length > 0 && $089e11c7687c341c$var$focusLaterElements.pop();
}
function $089e11c7687c341c$var$setupScopedFocus(element) {
    $089e11c7687c341c$var$modalElement = element;
    if (window.addEventListener) {
        window.addEventListener("blur", $089e11c7687c341c$var$handleBlur, false);
        document.addEventListener("focus", $089e11c7687c341c$var$handleFocus, true);
    } else {
        window.attachEvent("onBlur", $089e11c7687c341c$var$handleBlur);
        document.attachEvent("onFocus", $089e11c7687c341c$var$handleFocus);
    }
}
function $089e11c7687c341c$var$teardownScopedFocus() {
    $089e11c7687c341c$var$modalElement = null;
    if (window.addEventListener) {
        window.removeEventListener("blur", $089e11c7687c341c$var$handleBlur);
        document.removeEventListener("focus", $089e11c7687c341c$var$handleFocus);
    } else {
        window.detachEvent("onBlur", $089e11c7687c341c$var$handleBlur);
        document.detachEvent("onFocus", $089e11c7687c341c$var$handleFocus);
    }
}

});
parcelRequire.register("kBKjR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $f00b31660755de41$var$findTabbableDescendants;
/*!
 * Adapted from jQuery UI core
 *
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/category/ui-core/
 */ var $f00b31660755de41$var$tabbableNode = /input|select|textarea|button|object|iframe/;
function $f00b31660755de41$var$hidesContents(element) {
    var zeroSize = element.offsetWidth <= 0 && element.offsetHeight <= 0;
    // If the node is empty, this is good enough
    if (zeroSize && !element.innerHTML) return true;
    try {
        // Otherwise we need to check some styles
        var style = window.getComputedStyle(element);
        return zeroSize ? style.getPropertyValue("overflow") !== "visible" || // if 'overflow: visible' set, check if there is actually any overflow
        element.scrollWidth <= 0 && element.scrollHeight <= 0 : style.getPropertyValue("display") == "none";
    } catch (exception) {
        // eslint-disable-next-line no-console
        console.warn("Failed to inspect element style");
        return false;
    }
}
function $f00b31660755de41$var$visible(element) {
    var parentElement = element;
    var rootNode = element.getRootNode && element.getRootNode();
    while(parentElement){
        if (parentElement === document.body) break;
        // if we are not hidden yet, skip to checking outside the Web Component
        if (rootNode && parentElement === rootNode) parentElement = rootNode.host.parentNode;
        if ($f00b31660755de41$var$hidesContents(parentElement)) return false;
        parentElement = parentElement.parentNode;
    }
    return true;
}
function $f00b31660755de41$var$focusable(element, isTabIndexNotNaN) {
    var nodeName = element.nodeName.toLowerCase();
    var res = $f00b31660755de41$var$tabbableNode.test(nodeName) && !element.disabled || (nodeName === "a" ? element.href || isTabIndexNotNaN : isTabIndexNotNaN);
    return res && $f00b31660755de41$var$visible(element);
}
function $f00b31660755de41$var$tabbable(element) {
    var tabIndex = element.getAttribute("tabindex");
    if (tabIndex === null) tabIndex = undefined;
    var isTabIndexNaN = isNaN(tabIndex);
    return (isTabIndexNaN || tabIndex >= 0) && $f00b31660755de41$var$focusable(element, !isTabIndexNaN);
}
function $f00b31660755de41$var$findTabbableDescendants(element) {
    var descendants = [].slice.call(element.querySelectorAll("*"), 0).reduce(function(finished, el) {
        return finished.concat(!el.shadowRoot ? [
            el
        ] : $f00b31660755de41$var$findTabbableDescendants(el.shadowRoot));
    }, []);
    return descendants.filter($f00b31660755de41$var$tabbable);
}
module.exports = module.exports["default"];

});


parcelRequire.register("776s4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = $52de3102083cba96$var$scopeTab;

var $kBKjR = parcelRequire("kBKjR");
var $52de3102083cba96$var$_tabbable2 = $52de3102083cba96$var$_interopRequireDefault($kBKjR);
function $52de3102083cba96$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $52de3102083cba96$var$getActiveElement() {
    var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
    return el.activeElement.shadowRoot ? $52de3102083cba96$var$getActiveElement(el.activeElement.shadowRoot) : el.activeElement;
}
function $52de3102083cba96$var$scopeTab(node, event) {
    var tabbable = (0, $52de3102083cba96$var$_tabbable2.default)(node);
    if (!tabbable.length) {
        // Do nothing, since there are no elements that can receive focus.
        event.preventDefault();
        return;
    }
    var target = void 0;
    var shiftKey = event.shiftKey;
    var head = tabbable[0];
    var tail = tabbable[tabbable.length - 1];
    var activeElement = $52de3102083cba96$var$getActiveElement();
    // proceed with default browser behavior on tab.
    // Focus on last element on shift + tab.
    if (node === activeElement) {
        if (!shiftKey) return;
        target = tail;
    }
    if (tail === activeElement && !shiftKey) target = head;
    if (head === activeElement && shiftKey) target = tail;
    if (target) {
        event.preventDefault();
        target.focus();
        return;
    }
    // Safari radio issue.
    //
    // Safari does not move the focus to the radio button,
    // so we need to force it to really walk through all elements.
    //
    // This is very error prone, since we are trying to guess
    // if it is a safari browser from the first occurence between
    // chrome or safari.
    //
    // The chrome user agent contains the first ocurrence
    // as the 'chrome/version' and later the 'safari/version'.
    var checkSafari = /(\bChrome\b|\bSafari\b)\//.exec(navigator.userAgent);
    var isSafariDesktop = checkSafari != null && checkSafari[1] != "Chrome" && /\biPod\b|\biPad\b/g.exec(navigator.userAgent) == null;
    // If we are not in safari desktop, let the browser control
    // the focus
    if (!isSafariDesktop) return;
    var x = tabbable.indexOf(activeElement);
    if (x > -1) x += shiftKey ? -1 : 1;
    target = tabbable[x];
    // If the tabbable element does not exist,
    // focus head/tail based on shiftKey
    if (typeof target === "undefined") {
        event.preventDefault();
        target = shiftKey ? tail : head;
        target.focus();
        return;
    }
    event.preventDefault();
    target.focus();
}
module.exports = module.exports["default"];

});

parcelRequire.register("9bgNd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $6af22ad6bb0eb441$var$resetState;
module.exports.log = $6af22ad6bb0eb441$var$log;
module.exports.assertNodeList = $6af22ad6bb0eb441$var$assertNodeList;
module.exports.setElement = $6af22ad6bb0eb441$var$setElement;
module.exports.validateElement = $6af22ad6bb0eb441$var$validateElement;
module.exports.hide = $6af22ad6bb0eb441$var$hide;
module.exports.show = $6af22ad6bb0eb441$var$show;
module.exports.documentNotReadyOrSSRTesting = $6af22ad6bb0eb441$var$documentNotReadyOrSSRTesting;

var $jCrXM = parcelRequire("jCrXM");
var $6af22ad6bb0eb441$var$_warning2 = $6af22ad6bb0eb441$var$_interopRequireDefault($jCrXM);

var $2715L = parcelRequire("2715L");
function $6af22ad6bb0eb441$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $6af22ad6bb0eb441$var$globalElement = null;
/* eslint-disable no-console */ /* istanbul ignore next */ function $6af22ad6bb0eb441$var$resetState() {
    if ($6af22ad6bb0eb441$var$globalElement) {
        if ($6af22ad6bb0eb441$var$globalElement.removeAttribute) $6af22ad6bb0eb441$var$globalElement.removeAttribute("aria-hidden");
        else if ($6af22ad6bb0eb441$var$globalElement.length != null) $6af22ad6bb0eb441$var$globalElement.forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
        else document.querySelectorAll($6af22ad6bb0eb441$var$globalElement).forEach(function(element) {
            return element.removeAttribute("aria-hidden");
        });
    }
    $6af22ad6bb0eb441$var$globalElement = null;
}
/* istanbul ignore next */ function $6af22ad6bb0eb441$var$log() {
    var check;
}
/* eslint-enable no-console */ function $6af22ad6bb0eb441$var$assertNodeList(nodeList, selector) {
    if (!nodeList || !nodeList.length) throw new Error("react-modal: No elements were found for selector " + selector + ".");
}
function $6af22ad6bb0eb441$var$setElement(element) {
    var useElement = element;
    if (typeof useElement === "string" && $2715L.canUseDOM) {
        var el = document.querySelectorAll(useElement);
        $6af22ad6bb0eb441$var$assertNodeList(el, useElement);
        useElement = el;
    }
    $6af22ad6bb0eb441$var$globalElement = useElement || $6af22ad6bb0eb441$var$globalElement;
    return $6af22ad6bb0eb441$var$globalElement;
}
function $6af22ad6bb0eb441$var$validateElement(appElement) {
    var el = appElement || $6af22ad6bb0eb441$var$globalElement;
    if (el) return Array.isArray(el) || el instanceof HTMLCollection || el instanceof NodeList ? el : [
        el
    ];
    else {
        (0, $6af22ad6bb0eb441$var$_warning2.default)(false, [
            "react-modal: App element is not defined.",
            "Please use `Modal.setAppElement(el)` or set `appElement={el}`.",
            "This is needed so screen readers don't see main content",
            "when modal is opened. It is not recommended, but you can opt-out",
            "by setting `ariaHideApp={false}`."
        ].join(" "));
        return [];
    }
}
function $6af22ad6bb0eb441$var$hide(appElement) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;
    try {
        for(var _iterator = $6af22ad6bb0eb441$var$validateElement(appElement)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var el = _step.value;
            el.setAttribute("aria-hidden", "true");
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
        } finally{
            if (_didIteratorError) throw _iteratorError;
        }
    }
}
function $6af22ad6bb0eb441$var$show(appElement) {
    var _iteratorNormalCompletion2 = true;
    var _didIteratorError2 = false;
    var _iteratorError2 = undefined;
    try {
        for(var _iterator2 = $6af22ad6bb0eb441$var$validateElement(appElement)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
            var el = _step2.value;
            el.removeAttribute("aria-hidden");
        }
    } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) _iterator2.return();
        } finally{
            if (_didIteratorError2) throw _iteratorError2;
        }
    }
}
function $6af22ad6bb0eb441$var$documentNotReadyOrSSRTesting() {
    $6af22ad6bb0eb441$var$globalElement = null;
}

});
parcelRequire.register("jCrXM", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $e48741d4d926030d$var$__DEV__ = false;
var $e48741d4d926030d$var$warning = function() {};
if ($e48741d4d926030d$var$__DEV__) {
    var $e48741d4d926030d$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = "Warning: " + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== "undefined") console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $e48741d4d926030d$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $e48741d4d926030d$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
module.exports = $e48741d4d926030d$var$warning;

});

parcelRequire.register("2715L", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.canUseDOM = module.exports.SafeNodeList = module.exports.SafeHTMLCollection = undefined;

var $3DU2T = parcelRequire("3DU2T");
var $189d150af8530bda$var$_exenv2 = $189d150af8530bda$var$_interopRequireDefault($3DU2T);
function $189d150af8530bda$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $189d150af8530bda$var$EE = $189d150af8530bda$var$_exenv2.default;
var $189d150af8530bda$var$SafeHTMLElement = $189d150af8530bda$var$EE.canUseDOM ? window.HTMLElement : {};
var $189d150af8530bda$var$SafeHTMLCollection = module.exports.SafeHTMLCollection = $189d150af8530bda$var$EE.canUseDOM ? window.HTMLCollection : {};
var $189d150af8530bda$var$SafeNodeList = module.exports.SafeNodeList = $189d150af8530bda$var$EE.canUseDOM ? window.NodeList : {};
var $189d150af8530bda$var$canUseDOM = module.exports.canUseDOM = $189d150af8530bda$var$EE.canUseDOM;
module.exports.default = $189d150af8530bda$var$SafeHTMLElement;

});
parcelRequire.register("3DU2T", function(module, exports) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/ /* global define */ (function() {
    "use strict";
    var canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
    var ExecutionEnvironment = {
        canUseDOM: canUseDOM,
        canUseWorkers: typeof Worker !== "undefined",
        canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
        canUseViewport: canUseDOM && !!window.screen
    };
    if (typeof define === "function" && typeof define.amd === "object" && define.amd) define(function() {
        return ExecutionEnvironment;
    });
    else if (0, module.exports) module.exports = ExecutionEnvironment;
    else window.ExecutionEnvironment = ExecutionEnvironment;
})();

});



parcelRequire.register("j1jC2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $dd8d52f48454723a$var$resetState;
module.exports.log = $dd8d52f48454723a$var$log;
var $dd8d52f48454723a$var$htmlClassList = {};
var $dd8d52f48454723a$var$docBodyClassList = {};
/* eslint-disable no-console */ /* istanbul ignore next */ function $dd8d52f48454723a$var$removeClass(at, cls) {
    at.classList.remove(cls);
}
/* istanbul ignore next */ function $dd8d52f48454723a$var$resetState() {
    var htmlElement = document.getElementsByTagName("html")[0];
    for(var cls in $dd8d52f48454723a$var$htmlClassList)$dd8d52f48454723a$var$removeClass(htmlElement, $dd8d52f48454723a$var$htmlClassList[cls]);
    var body = document.body;
    for(var _cls in $dd8d52f48454723a$var$docBodyClassList)$dd8d52f48454723a$var$removeClass(body, $dd8d52f48454723a$var$docBodyClassList[_cls]);
    $dd8d52f48454723a$var$htmlClassList = {};
    $dd8d52f48454723a$var$docBodyClassList = {};
}
/* istanbul ignore next */ function $dd8d52f48454723a$var$log() {
    var classes, buffer, x, _x;
}
/* eslint-enable no-console */ /**
 * Track the number of reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $dd8d52f48454723a$var$incrementReference = function incrementReference(poll, className) {
    if (!poll[className]) poll[className] = 0;
    poll[className] += 1;
    return className;
};
/**
 * Drop the reference of a class.
 * @param {object} poll The poll to receive the reference.
 * @param {string} className The class name.
 * @return {string}
 */ var $dd8d52f48454723a$var$decrementReference = function decrementReference(poll, className) {
    if (poll[className]) poll[className] -= 1;
    return className;
};
/**
 * Track a class and add to the given class list.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be tracked.
 */ var $dd8d52f48454723a$var$trackClass = function trackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $dd8d52f48454723a$var$incrementReference(poll, className);
        classListRef.add(className);
    });
};
/**
 * Untrack a class and remove from the given class list if the reference
 * reaches 0.
 * @param {Object} classListRef A class list of an element.
 * @param {Object} poll         The poll to be used.
 * @param {Array}  classes      The list of classes to be untracked.
 */ var $dd8d52f48454723a$var$untrackClass = function untrackClass(classListRef, poll, classes) {
    classes.forEach(function(className) {
        $dd8d52f48454723a$var$decrementReference(poll, className);
        poll[className] === 0 && classListRef.remove(className);
    });
};
/**
 * Public inferface to add classes to the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $dd8d52f48454723a$var$add = module.exports.add = function add(element, classString) {
    return $dd8d52f48454723a$var$trackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $dd8d52f48454723a$var$htmlClassList : $dd8d52f48454723a$var$docBodyClassList, classString.split(" "));
};
/**
 * Public inferface to remove classes from the document.body.
 * @param {string} bodyClass The class string to be added.
 *                           It may contain more then one class
 *                           with ' ' as separator.
 */ var $dd8d52f48454723a$var$remove = module.exports.remove = function remove(element, classString) {
    return $dd8d52f48454723a$var$untrackClass(element.classList, element.nodeName.toLowerCase() == "html" ? $dd8d52f48454723a$var$htmlClassList : $dd8d52f48454723a$var$docBodyClassList, classString.split(" "));
};

});

parcelRequire.register("dMgIx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.log = $a07cb9c188044eb6$var$log;
module.exports.resetState = $a07cb9c188044eb6$var$resetState;
function $a07cb9c188044eb6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
// Tracks portals that are open and emits events to subscribers
var $a07cb9c188044eb6$var$PortalOpenInstances = function PortalOpenInstances() {
    var _this = this;
    $a07cb9c188044eb6$var$_classCallCheck(this, PortalOpenInstances);
    this.register = function(openInstance) {
        if (_this.openInstances.indexOf(openInstance) !== -1) return;
        _this.openInstances.push(openInstance);
        _this.emit("register");
    };
    this.deregister = function(openInstance) {
        var index = _this.openInstances.indexOf(openInstance);
        if (index === -1) return;
        _this.openInstances.splice(index, 1);
        _this.emit("deregister");
    };
    this.subscribe = function(callback) {
        _this.subscribers.push(callback);
    };
    this.emit = function(eventType) {
        _this.subscribers.forEach(function(subscriber) {
            return subscriber(eventType, // shallow copy to avoid accidental mutation
            _this.openInstances.slice());
        });
    };
    this.openInstances = [];
    this.subscribers = [];
};
var $a07cb9c188044eb6$var$portalOpenInstances = new $a07cb9c188044eb6$var$PortalOpenInstances();
/* eslint-disable no-console */ /* istanbul ignore next */ function $a07cb9c188044eb6$var$log() {
    console.log("portalOpenInstances ----------");
    console.log($a07cb9c188044eb6$var$portalOpenInstances.openInstances.length);
    $a07cb9c188044eb6$var$portalOpenInstances.openInstances.forEach(function(p) {
        return console.log(p);
    });
    console.log("end portalOpenInstances ----------");
}
/* istanbul ignore next */ function $a07cb9c188044eb6$var$resetState() {
    $a07cb9c188044eb6$var$portalOpenInstances = new $a07cb9c188044eb6$var$PortalOpenInstances();
}
/* eslint-enable no-console */ module.exports.default = $a07cb9c188044eb6$var$portalOpenInstances;

});

parcelRequire.register("jpfAT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resetState = $e20c72c452ac947f$var$resetState;
module.exports.log = $e20c72c452ac947f$var$log;

var $dMgIx = parcelRequire("dMgIx");
var $e20c72c452ac947f$var$_portalOpenInstances2 = $e20c72c452ac947f$var$_interopRequireDefault($dMgIx);
function $e20c72c452ac947f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// Body focus trap see Issue #742
var $e20c72c452ac947f$var$before = void 0, $e20c72c452ac947f$var$after = void 0, $e20c72c452ac947f$var$instances = [];
/* eslint-disable no-console */ /* istanbul ignore next */ function $e20c72c452ac947f$var$resetState() {
    var _arr = [
        $e20c72c452ac947f$var$before,
        $e20c72c452ac947f$var$after
    ];
    for(var _i = 0; _i < _arr.length; _i++){
        var item = _arr[_i];
        if (!item) continue;
        item.parentNode && item.parentNode.removeChild(item);
    }
    $e20c72c452ac947f$var$before = $e20c72c452ac947f$var$after = null;
    $e20c72c452ac947f$var$instances = [];
}
/* istanbul ignore next */ function $e20c72c452ac947f$var$log() {
    console.log("bodyTrap ----------");
    console.log($e20c72c452ac947f$var$instances.length);
    var _arr2 = [
        $e20c72c452ac947f$var$before,
        $e20c72c452ac947f$var$after
    ];
    for(var _i2 = 0; _i2 < _arr2.length; _i2++){
        var item = _arr2[_i2];
        var check = item || {};
        console.log(check.nodeName, check.className, check.id);
    }
    console.log("edn bodyTrap ----------");
}
/* eslint-enable no-console */ function $e20c72c452ac947f$var$focusContent() {
    if ($e20c72c452ac947f$var$instances.length === 0) return;
    $e20c72c452ac947f$var$instances[$e20c72c452ac947f$var$instances.length - 1].focusContent();
}
function $e20c72c452ac947f$var$bodyTrap(eventType, openInstances) {
    if (!$e20c72c452ac947f$var$before && !$e20c72c452ac947f$var$after) {
        $e20c72c452ac947f$var$before = document.createElement("div");
        $e20c72c452ac947f$var$before.setAttribute("data-react-modal-body-trap", "");
        $e20c72c452ac947f$var$before.style.position = "absolute";
        $e20c72c452ac947f$var$before.style.opacity = "0";
        $e20c72c452ac947f$var$before.setAttribute("tabindex", "0");
        $e20c72c452ac947f$var$before.addEventListener("focus", $e20c72c452ac947f$var$focusContent);
        $e20c72c452ac947f$var$after = $e20c72c452ac947f$var$before.cloneNode();
        $e20c72c452ac947f$var$after.addEventListener("focus", $e20c72c452ac947f$var$focusContent);
    }
    $e20c72c452ac947f$var$instances = openInstances;
    if ($e20c72c452ac947f$var$instances.length > 0) {
        // Add focus trap
        if (document.body.firstChild !== $e20c72c452ac947f$var$before) document.body.insertBefore($e20c72c452ac947f$var$before, document.body.firstChild);
        if (document.body.lastChild !== $e20c72c452ac947f$var$after) document.body.appendChild($e20c72c452ac947f$var$after);
    } else {
        // Remove focus trap
        if ($e20c72c452ac947f$var$before.parentElement) $e20c72c452ac947f$var$before.parentElement.removeChild($e20c72c452ac947f$var$before);
        if ($e20c72c452ac947f$var$after.parentElement) $e20c72c452ac947f$var$after.parentElement.removeChild($e20c72c452ac947f$var$after);
    }
}
$e20c72c452ac947f$var$_portalOpenInstances2.default.subscribe($e20c72c452ac947f$var$bodyTrap);

});


parcelRequire.register("aUKHN", function(module, exports) {

$parcel$export(module.exports, "polyfill", function () { return $7f235d101bf60758$export$cea1c58a6db52bca; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $7f235d101bf60758$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $7f235d101bf60758$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $7f235d101bf60758$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$7f235d101bf60758$var$componentWillMount.__suppressDeprecationWarning = true;
$7f235d101bf60758$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$7f235d101bf60758$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $7f235d101bf60758$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error("Can only polyfill class components");
    if (typeof Component.getDerivedStateFromProps !== "function" && typeof prototype.getSnapshotBeforeUpdate !== "function") return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === "function") foundWillMountName = "componentWillMount";
    else if (typeof prototype.UNSAFE_componentWillMount === "function") foundWillMountName = "UNSAFE_componentWillMount";
    if (typeof prototype.componentWillReceiveProps === "function") foundWillReceivePropsName = "componentWillReceiveProps";
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === "function") foundWillReceivePropsName = "UNSAFE_componentWillReceiveProps";
    if (typeof prototype.componentWillUpdate === "function") foundWillUpdateName = "componentWillUpdate";
    else if (typeof prototype.UNSAFE_componentWillUpdate === "function") foundWillUpdateName = "UNSAFE_componentWillUpdate";
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === "function" ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
        throw Error("Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n" + componentName + " uses " + newApiName + " but also contains the following legacy lifecycles:" + (foundWillMountName !== null ? "\n  " + foundWillMountName : "") + (foundWillReceivePropsName !== null ? "\n  " + foundWillReceivePropsName : "") + (foundWillUpdateName !== null ? "\n  " + foundWillUpdateName : "") + "\n\nThe above lifecycles should be removed. Learn more about this warning here:\n" + "https://fb.me/react-async-component-lifecycle-hooks");
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === "function") {
        prototype.componentWillMount = $7f235d101bf60758$var$componentWillMount;
        prototype.componentWillReceiveProps = $7f235d101bf60758$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === "function") {
        if (typeof prototype.componentDidUpdate !== "function") throw new Error("Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype");
        prototype.componentWillUpdate = $7f235d101bf60758$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}

});



parcelRequire.register("kcPww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ebc7904b17e2ae04$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "LinkButton", function () { return $ebc7904b17e2ae04$export$29d11c0fe2fc51d8; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $8pPfi = parcelRequire("8pPfi");

var $6jNMj = parcelRequire("6jNMj");

var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");

var $fbeQ6 = parcelRequire("fbeQ6");

var $16kD2 = parcelRequire("16kD2");
function $ebc7904b17e2ae04$var$Button({ htmlType: htmlType = "button", type: type = "default", size: size = "medium", title: title, icon: icon, className: className, isLoading: isLoading = false, loadingDelay: loadingDelay = 500, trailingIcon: trailingIcon, disabled: disabled, ...rest }) {
    const [showSpinner, setShowSpinner] = (0, $eCoWV.useState)(false);
    const timerRef = (0, $eCoWV.useRef)();
    (0, $eCoWV.useEffect)(()=>{
        // Delay showing the spinner after 'loadingDelay' milliseconds
        if (isLoading) // eslint-disable-next-line @silverhand/fp/no-mutation
        timerRef.current = window.setTimeout(()=>{
            setShowSpinner(true);
        }, loadingDelay);
        return ()=>{
            clearTimeout(timerRef.current);
            setShowSpinner(false);
        };
    }, [
        isLoading,
        loadingDelay
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("button", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($16kD2.button, $16kD2[type], $16kD2[size], icon && $16kD2.withIcon, isLoading && $16kD2.loading, className),
        type: htmlType,
        disabled: isLoading || disabled,
        ...rest,
        children: [
            showSpinner && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {
                className: $16kD2.spinner
            }),
            icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $16kD2.icon,
                children: icon
            }),
            title && (typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                })
            }) : title),
            trailingIcon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $16kD2.trailingIcon,
                children: trailingIcon
            })
        ]
    });
}
var $ebc7904b17e2ae04$export$2e2bcd8739ae039 = $ebc7904b17e2ae04$var$Button;
function $ebc7904b17e2ae04$export$29d11c0fe2fc51d8({ title: title, type: type = "default", size: size = "medium", className: className, href: href, targetBlank: targetBlank, ...rest }) {
    const { getTo: getTo } = (0, $4W0F0.default)();
    const props = (0, $eCoWV.useMemo)(()=>({
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($16kD2.button, $16kD2[type], $16kD2[size], className),
            ...Boolean(targetBlank) && {
                rel: typeof targetBlank === "string" ? targetBlank : "noopener noreferrer",
                target: "_blank"
            }
        }), [
        className,
        rest,
        size,
        targetBlank,
        type
    ]);
    const innerElement = (0, $eCoWV.useMemo)(()=>typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: title
            })
        }) : title, [
        title
    ]);
    return !href || (0, $h7VLF.isAbsoluteUrl)(href) ? /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
        ...props,
        href: href,
        children: innerElement
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
        ...props,
        to: getTo(href),
        children: innerElement
    });
}

});
parcelRequire.register("6jNMj", function(module, exports) {

$parcel$export(module.exports, "Ring", function () { return $600a4ec07fa275f3$export$a6e3577650b6d6d7; });
$parcel$export(module.exports, "Daisy", function () { return $600a4ec07fa275f3$export$9a60c84efaf62b31; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $a8Vkt = parcelRequire("a8Vkt");
function $600a4ec07fa275f3$export$a6e3577650b6d6d7({ className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($a8Vkt.ring, className),
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M9.33566 14.8714C9.44104 15.4135 9.08652 15.9451 8.53547 15.9821C7.4048 16.0579 6.2669 15.8929 5.19834 15.4934C3.81639 14.9767 2.60425 14.0879 1.69591 12.9253C0.78758 11.7627 0.218443 10.3715 0.0514252 8.90563C-0.115592 7.43973 0.126015 5.9562 0.749537 4.61905C1.37306 3.28191 2.35421 2.14323 3.5845 1.32891C4.8148 0.514598 6.24632 0.0563637 7.7208 0.00487344C9.19528 -0.0466168 10.6553 0.310643 11.9394 1.03715C12.9323 1.59891 13.7901 2.36452 14.4588 3.27942C14.7847 3.72531 14.6054 4.33858 14.1223 4.60633C13.6393 4.87408 13.0366 4.69278 12.6924 4.26086C12.2154 3.66218 11.6262 3.15785 10.9545 2.77787C9.99146 2.23298 8.89646 1.96504 7.7906 2.00366C6.68474 2.04227 5.6111 2.38595 4.68838 2.99669C3.76565 3.60742 3.02979 4.46143 2.56215 5.46429C2.09451 6.46715 1.91331 7.5798 2.03857 8.67922C2.16383 9.77864 2.59069 10.822 3.27194 11.694C3.95319 12.5659 4.8623 13.2325 5.89876 13.62C6.62154 13.8903 7.38663 14.0175 8.15188 13.9981C8.70399 13.9841 9.23028 14.3293 9.33566 14.8714Z",
            fill: "currentColor"
        })
    });
}
function $600a4ec07fa275f3$export$9a60c84efaf62b31({ className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($a8Vkt.daisy, className),
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.48",
                x: "15",
                width: "2",
                height: "8",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.96",
                x: "15",
                y: "24",
                width: "2",
                height: "8",
                rx: "1",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.72",
                y: "17",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-90 0 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.24",
                x: "24",
                y: "17",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-90 24 17)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.32",
                x: "29.3564",
                y: "7.13403",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(60 29.3564 7.13403)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.8",
                x: "8.57227",
                y: "19.134",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(60 8.57227 19.134)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.64",
                x: "1.64355",
                y: "8.86597",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-60 1.64355 8.86597)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.16",
                x: "22.4277",
                y: "20.866",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-60 22.4277 20.866)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.4",
                x: "23.1338",
                y: "1.64355",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(30 23.1338 1.64355)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.88",
                x: "11.1338",
                y: "22.4282",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(30 11.1338 22.4282)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.56",
                x: "7.13379",
                y: "2.64355",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-30 7.13379 2.64355)",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: "0.08",
                x: "19.1338",
                y: "23.4282",
                width: "2",
                height: "8",
                rx: "1",
                transform: "rotate(-30 19.1338 23.4282)",
                fill: "currentColor"
            })
        ]
    });
}

});
parcelRequire.register("a8Vkt", function(module, exports) {

$parcel$export(module.exports, "daisy", function () { return $76271f1bb325b113$export$7a08098a941a19df; }, function (v) { return $76271f1bb325b113$export$7a08098a941a19df = v; });
$parcel$export(module.exports, "ring", function () { return $76271f1bb325b113$export$e7d0da6968da5dd; }, function (v) { return $76271f1bb325b113$export$e7d0da6968da5dd = v; });
$parcel$export(module.exports, "rotating", function () { return $76271f1bb325b113$export$bfd64c937657f93a; }, function (v) { return $76271f1bb325b113$export$bfd64c937657f93a = v; });
var $76271f1bb325b113$export$7a08098a941a19df;
var $76271f1bb325b113$export$e7d0da6968da5dd;
var $76271f1bb325b113$export$bfd64c937657f93a;
var $76271f1bb325b113$export$4a6dd88bada4e7d2;
$76271f1bb325b113$export$7a08098a941a19df = `pXtXgq_daisy`;
$76271f1bb325b113$export$e7d0da6968da5dd = `pXtXgq_ring`;
$76271f1bb325b113$export$bfd64c937657f93a = `pXtXgq_rotating`;
$76271f1bb325b113$export$bfd64c937657f93a;
$76271f1bb325b113$export$4a6dd88bada4e7d2 = `pXtXgq_shimmer`;

});


parcelRequire.register("4W0F0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2e7e33b29440b99f$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $ceK0K = parcelRequire("ceK0K");
parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("9X5Bp");
var $gaxbO = parcelRequire("gaxbO");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");
/**
 * Returns a `TenantPathname` object that contains utilities for matching
 * and generating tenant-specific pathnames.
 *
 * @see {@link TenantPathname}
 */ function $2e7e33b29440b99f$var$useTenantPathname() {
    const location = (0, $9X5Bp.useLocation)();
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const tenantSegment = (0, $eCoWV.useMemo)(()=>(0, $V1X8c.isCloud) ? currentTenantId : (0, $ceK0K.ossConsolePath).slice(1), [
        currentTenantId
    ]);
    const navigate = (0, $9X5Bp.useNavigate)();
    const href = (0, $9X5Bp.useHref)("/");
    const match = (0, $eCoWV.useCallback)((pathname, exact = false)=>{
        // Match relative pathnames directly
        if (!pathname.startsWith("/")) return (0, $gaxbO.matchPath)((0, $b9zrd.joinPath)(location.pathname, pathname, exact ? "" : "*"), location.pathname) !== null;
        // Match absolute pathnames with the tenant segment
        return (0, $gaxbO.matchPath)((0, $b9zrd.joinPath)(":tenantId", pathname, exact ? "" : "*"), location.pathname) !== null;
    }, [
        location.pathname
    ]);
    /** Returns the pathname with the current tenant ID prepended. */ const getPathname = (0, $eCoWV.useCallback)((pathname)=>{
        if (pathname.startsWith("/") && !pathname.startsWith(`/${tenantSegment}`)) return (0, $b9zrd.joinPath)(tenantSegment, pathname);
        // Directly return the pathname if it's a relative pathname
        return pathname;
    }, [
        tenantSegment
    ]);
    const getTo = (0, $eCoWV.useCallback)((to)=>{
        if (typeof to === "string") return getPathname(to);
        return {
            ...to,
            pathname: getPathname(to.pathname ?? "")
        };
    }, [
        getPathname
    ]);
    const getUrl = (0, $eCoWV.useCallback)((pathname = "/")=>(0, $b9zrd.appendPath)(new URL(window.location.origin), href, tenantSegment, pathname), [
        href,
        tenantSegment
    ]);
    const data = (0, $eCoWV.useMemo)(()=>({
            match: match,
            navigate: (to, options)=>{
                navigate(getTo(to), options);
            },
            getPathname: getPathname,
            getTo: getTo,
            getUrl: getUrl
        }), [
        match,
        getPathname,
        getTo,
        navigate,
        getUrl
    ]);
    return data;
}
var $2e7e33b29440b99f$export$2e2bcd8739ae039 = $2e7e33b29440b99f$var$useTenantPathname;

});

parcelRequire.register("fbeQ6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $29d85bf545ecb12e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
function $29d85bf545ecb12e$export$2e2bcd8739ae039({ forKey: forKey, interpolation: interpolation }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    /**
   * The default return of `t()` is already string even if the given key is not a leaf key.
   * For example:
   *
   * ```ts
   * const translation = { foo: { bar: 'baz' } };
   *
   * t('foo.bar') // 'baz'
   * t('foo') // 'key 'foo (en)' returned an object instead of string.'
   * ```
   *
   * So actually there's no need to check key validity to make sure `t()` returns a string.
   * But it seems the type definition is not correct for the function in `i18next`. Use this trick to
   * bypass for now.
   */ return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: t(forKey, interpolation ?? {})
    });
}

});

parcelRequire.register("16kD2", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "branding", function () { return $0cd65a630bdb8047$export$aa1c855dc9a4ab00; }, function (v) { return $0cd65a630bdb8047$export$aa1c855dc9a4ab00 = v; });
$parcel$export(module.exports, "button", function () { return $0cd65a630bdb8047$export$2ba01fb71ed41cb6; }, function (v) { return $0cd65a630bdb8047$export$2ba01fb71ed41cb6 = v; });
$parcel$export(module.exports, "danger", function () { return $0cd65a630bdb8047$export$7c4df8d735fa2705; }, function (v) { return $0cd65a630bdb8047$export$7c4df8d735fa2705 = v; });
$parcel$export(module.exports, "default", function () { return $0cd65a630bdb8047$export$2e2bcd8739ae039; }, function (v) { return $0cd65a630bdb8047$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "icon", function () { return $0cd65a630bdb8047$export$1ca1ec8b29a4ce27; }, function (v) { return $0cd65a630bdb8047$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "large", function () { return $0cd65a630bdb8047$export$f09585a853dddd32; }, function (v) { return $0cd65a630bdb8047$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "loading", function () { return $0cd65a630bdb8047$export$46c1c92549715335; }, function (v) { return $0cd65a630bdb8047$export$46c1c92549715335 = v; });
$parcel$export(module.exports, "medium", function () { return $0cd65a630bdb8047$export$649ecc744817b5c7; }, function (v) { return $0cd65a630bdb8047$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "outline", function () { return $0cd65a630bdb8047$export$f9258c55612cbed7; }, function (v) { return $0cd65a630bdb8047$export$f9258c55612cbed7 = v; });
$parcel$export(module.exports, "primary", function () { return $0cd65a630bdb8047$export$9ad721cf3b3debe0; }, function (v) { return $0cd65a630bdb8047$export$9ad721cf3b3debe0 = v; });
$parcel$export(module.exports, "rotating", function () { return $0cd65a630bdb8047$export$bfd64c937657f93a; }, function (v) { return $0cd65a630bdb8047$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $0cd65a630bdb8047$export$4a6dd88bada4e7d2; }, function (v) { return $0cd65a630bdb8047$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $0cd65a630bdb8047$export$3c17b0e969a90510; }, function (v) { return $0cd65a630bdb8047$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "spinner", function () { return $0cd65a630bdb8047$export$641374ffb95bc399; }, function (v) { return $0cd65a630bdb8047$export$641374ffb95bc399 = v; });
$parcel$export(module.exports, "text", function () { return $0cd65a630bdb8047$export$6f093cfa640b7166; }, function (v) { return $0cd65a630bdb8047$export$6f093cfa640b7166 = v; });
$parcel$export(module.exports, "trailingIcon", function () { return $0cd65a630bdb8047$export$74dc5dd4e622afa8; }, function (v) { return $0cd65a630bdb8047$export$74dc5dd4e622afa8 = v; });
$parcel$export(module.exports, "violet", function () { return $0cd65a630bdb8047$export$8241b7126941c403; }, function (v) { return $0cd65a630bdb8047$export$8241b7126941c403 = v; });
$parcel$export(module.exports, "withIcon", function () { return $0cd65a630bdb8047$export$5146850fc0ce88d1; }, function (v) { return $0cd65a630bdb8047$export$5146850fc0ce88d1 = v; });
var $0cd65a630bdb8047$export$aa1c855dc9a4ab00;
var $0cd65a630bdb8047$export$2ba01fb71ed41cb6;
var $0cd65a630bdb8047$export$7c4df8d735fa2705;
var $0cd65a630bdb8047$export$2e2bcd8739ae039;
var $0cd65a630bdb8047$export$1ca1ec8b29a4ce27;
var $0cd65a630bdb8047$export$f09585a853dddd32;
var $0cd65a630bdb8047$export$46c1c92549715335;
var $0cd65a630bdb8047$export$649ecc744817b5c7;
var $0cd65a630bdb8047$export$f9258c55612cbed7;
var $0cd65a630bdb8047$export$9ad721cf3b3debe0;
var $0cd65a630bdb8047$export$bfd64c937657f93a;
var $0cd65a630bdb8047$export$4a6dd88bada4e7d2;
var $0cd65a630bdb8047$export$3c17b0e969a90510;
var $0cd65a630bdb8047$export$641374ffb95bc399;
var $0cd65a630bdb8047$export$6f093cfa640b7166;
var $0cd65a630bdb8047$export$74dc5dd4e622afa8;
var $0cd65a630bdb8047$export$8241b7126941c403;
var $0cd65a630bdb8047$export$5146850fc0ce88d1;
$0cd65a630bdb8047$export$aa1c855dc9a4ab00 = `jrMu9W_branding`;
$0cd65a630bdb8047$export$2ba01fb71ed41cb6 = `jrMu9W_button`;
$0cd65a630bdb8047$export$7c4df8d735fa2705 = `jrMu9W_danger`;
$0cd65a630bdb8047$export$2e2bcd8739ae039 = `jrMu9W_default`;
$0cd65a630bdb8047$export$1ca1ec8b29a4ce27 = `jrMu9W_icon`;
$0cd65a630bdb8047$export$f09585a853dddd32 = `jrMu9W_large`;
$0cd65a630bdb8047$export$46c1c92549715335 = `jrMu9W_loading`;
$0cd65a630bdb8047$export$649ecc744817b5c7 = `jrMu9W_medium`;
$0cd65a630bdb8047$export$f9258c55612cbed7 = `jrMu9W_outline`;
$0cd65a630bdb8047$export$9ad721cf3b3debe0 = `jrMu9W_primary`;
$0cd65a630bdb8047$export$bfd64c937657f93a = `jrMu9W_rotating`;
$0cd65a630bdb8047$export$4a6dd88bada4e7d2 = `jrMu9W_shimmer`;
$0cd65a630bdb8047$export$3c17b0e969a90510 = `jrMu9W_small`;
$0cd65a630bdb8047$export$641374ffb95bc399 = `jrMu9W_spinner`;
$0cd65a630bdb8047$export$6f093cfa640b7166 = `jrMu9W_text`;
$0cd65a630bdb8047$export$74dc5dd4e622afa8 = `jrMu9W_trailingIcon`;
$0cd65a630bdb8047$export$8241b7126941c403 = `jrMu9W_violet`;
$0cd65a630bdb8047$export$5146850fc0ce88d1 = `jrMu9W_withIcon`;

});


parcelRequire.register("7iZsu", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $5519e33c4bb1a8cf$export$a7db06668cad9adb; }, function (v) { return $5519e33c4bb1a8cf$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "fullScreen", function () { return $5519e33c4bb1a8cf$export$708e76f13b8a286c; }, function (v) { return $5519e33c4bb1a8cf$export$708e76f13b8a286c = v; });
$parcel$export(module.exports, "overlay", function () { return $5519e33c4bb1a8cf$export$29dd17c7f3c81c36; }, function (v) { return $5519e33c4bb1a8cf$export$29dd17c7f3c81c36 = v; });
var $5519e33c4bb1a8cf$export$a7db06668cad9adb;
var $5519e33c4bb1a8cf$export$708e76f13b8a286c;
var $5519e33c4bb1a8cf$export$29dd17c7f3c81c36;
var $5519e33c4bb1a8cf$export$bfd64c937657f93a;
var $5519e33c4bb1a8cf$export$4a6dd88bada4e7d2;
$5519e33c4bb1a8cf$export$a7db06668cad9adb = `uLSymG_content`;
$5519e33c4bb1a8cf$export$708e76f13b8a286c = `uLSymG_fullScreen`;
$5519e33c4bb1a8cf$export$29dd17c7f3c81c36 = `uLSymG_overlay`;
$5519e33c4bb1a8cf$export$bfd64c937657f93a = `uLSymG_rotating`;
$5519e33c4bb1a8cf$export$4a6dd88bada4e7d2 = `uLSymG_shimmer`;

});

parcelRequire.register("bNHoO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $400928f1da9290cd$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $iHViS = parcelRequire("iHViS");

var $1UQTm = parcelRequire("1UQTm");

var $lSA0o = parcelRequire("lSA0o");

var $9bgsA = parcelRequire("9bgsA");

var $jibF8 = parcelRequire("jibF8");
function $400928f1da9290cd$var$ModalLayout({ children: children, footer: footer, onClose: onClose, className: className, size: size = "medium", headerIcon: headerIcon, ...cardTitleProps }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($jibF8.container, $jibF8[size]),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $jibF8.header,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $jibF8.iconAndTitle,
                        children: [
                            headerIcon,
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                                isWordWrapEnabled: true,
                                ...cardTitleProps
                            })
                        ]
                    }),
                    onClose && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        onClick: ()=>{
                            onClose();
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                            className: $jibF8.closeIcon
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: className,
                children: children
            }),
            footer && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $jibF8.footer,
                children: footer
            })
        ]
    });
}
var $400928f1da9290cd$export$2e2bcd8739ae039 = $400928f1da9290cd$var$ModalLayout;

});
parcelRequire.register("iHViS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ee02b3babde1aa7f$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ee02b3babde1aa7f$var$SvgClose = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m13.41 12 6.3-6.29a1.004 1.004 0 0 0-1.42-1.42L12 10.59l-6.29-6.3a1.004 1.004 0 1 0-1.42 1.42l6.3 6.29-6.3 6.29a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.42 0l6.29-6.3 6.29 6.3a1.001 1.001 0 0 0 1.639-.325 1 1 0 0 0-.22-1.095L13.41 12Z",
            fill: "currentColor"
        })
    });
var $ee02b3babde1aa7f$export$2e2bcd8739ae039 = $ee02b3babde1aa7f$var$SvgClose;

});

parcelRequire.register("1UQTm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d6c4486b131ca0f1$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $3O5p4 = parcelRequire("3O5p4");
function $d6c4486b131ca0f1$var$Card(props, reference) {
    const { children: children, className: className } = props;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ref: reference,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3O5p4.card, className),
        children: children
    });
}
var $d6c4486b131ca0f1$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($d6c4486b131ca0f1$var$Card);

});
parcelRequire.register("3O5p4", function(module, exports) {

$parcel$export(module.exports, "card", function () { return $2c5a3b9a0b1f43a6$export$aa3e815946b80764; }, function (v) { return $2c5a3b9a0b1f43a6$export$aa3e815946b80764 = v; });
var $2c5a3b9a0b1f43a6$export$aa3e815946b80764;
var $2c5a3b9a0b1f43a6$export$bfd64c937657f93a;
var $2c5a3b9a0b1f43a6$export$4a6dd88bada4e7d2;
$2c5a3b9a0b1f43a6$export$aa3e815946b80764 = `_lxpOa_card`;
$2c5a3b9a0b1f43a6$export$bfd64c937657f93a = `_lxpOa_rotating`;
$2c5a3b9a0b1f43a6$export$4a6dd88bada4e7d2 = `_lxpOa_shimmer`;

});


parcelRequire.register("lSA0o", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6dee38aae38fa2cd$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $aHzBK = parcelRequire("aHzBK");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");

var $3GWvi = parcelRequire("3GWvi");
/**
 * Always use this component to render CardTitle, with built-in i18n support.
 */ function $6dee38aae38fa2cd$var$CardTitle({ title: title, subtitle: subtitle, size: size = "large", isWordWrapEnabled: isWordWrapEnabled = false, learnMoreLink: learnMoreLink, className: className, isBeta: isBeta, paywall: paywall }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3GWvi.container, $3GWvi[size], className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3GWvi.title, !isWordWrapEnabled && $3GWvi.titleEllipsis),
                children: [
                    typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: title
                    }) : title,
                    paywall && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                        isVisible: true,
                        for: "upsell",
                        plan: paywall
                    }),
                    isBeta && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                        for: "beta"
                    })
                ]
            }),
            Boolean(subtitle ?? learnMoreLink) && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $3GWvi.subtitle,
                children: [
                    subtitle && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        children: typeof subtitle === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: subtitle
                        }) : subtitle
                    }),
                    learnMoreLink?.href && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        href: learnMoreLink.href,
                        targetBlank: learnMoreLink.targetBlank,
                        className: $3GWvi.learnMore,
                        children: t("general.learn_more")
                    })
                ]
            })
        ]
    });
}
var $6dee38aae38fa2cd$export$2e2bcd8739ae039 = $6dee38aae38fa2cd$var$CardTitle;

});
parcelRequire.register("aHzBK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $80ee809f58e2ebf7$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $2wPYZ = parcelRequire("2wPYZ");

var $5TR1F = parcelRequire("5TR1F");
/**
 * A tag that indicates whether a feature is in beta or requires a paid plan.
 *
 * - **For beta tags**: The tag will always be visible.
 * - **For paid plan tags**: The tag will be visible if `isVisible` is `true`, which means that
 * the tenant's subscription plan has no access to the feature (paywall). However, it will always
 * be visible for dev tenants since they have access to almost all features, and it's useful for
 * developers to know which features need to be paid for in production.
 *
 * CAUTION: You should only render this component when the feature has a paywall.
 *
 * @example
 * Use as a beta tag:
 *
 * ```tsx
 * <FeatureTag for="beta" />
 * ```
 *
 * Use as a paid plan tag:
 *
 * ```tsx
 * // In a production tenant, the tag will be visible when there's no access to the feature
 * <FeatureTag for="upsell" isVisible={noAccessToFeature} plan={ReservedPlanId.Pro} />
 *
 * // In a dev tenant, the tag will always be visible even if `isVisible` is `false`
 * <FeatureTag for="upsell" isVisible={false} plan={ReservedPlanId.Pro} />
 *
 * // For conditionally rendering the tag, usually in an iteration on a list which contains
 * // both free and paid features
 * {features.map((feature) => (
 *   hasPaywall(feature) &&
 *     <FeatureTag for="upsell" isVisible={hasAccess(feature)} plan={ReservedPlanId.Hobby} />
 * ))}
 * ```
 */ function $80ee809f58e2ebf7$var$FeatureTag(props) {
    const { className: className, for: forType } = props;
    const { isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    // Beta tag should always be visible.
    if (forType === "beta") return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5TR1F.tag, $5TR1F.beta, className),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
            children: "Beta"
        })
    });
    const { isVisible: isVisible, plan: plan } = props;
    // Dev tenant should always see the tag since they have access to almost all features, and it's
    // useful for developers to know which features need to be paid for in production.
    if (!isDevTenant && !isVisible) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5TR1F.tag, className),
        children: plan
    });
}
var $80ee809f58e2ebf7$export$2e2bcd8739ae039 = $80ee809f58e2ebf7$var$FeatureTag;

});
parcelRequire.register("5TR1F", function(module, exports) {

$parcel$export(module.exports, "beta", function () { return $44bb38a172dc4b28$export$7dc96fe8e7fc9104; }, function (v) { return $44bb38a172dc4b28$export$7dc96fe8e7fc9104 = v; });
$parcel$export(module.exports, "tag", function () { return $44bb38a172dc4b28$export$2b067c6666111485; }, function (v) { return $44bb38a172dc4b28$export$2b067c6666111485 = v; });
var $44bb38a172dc4b28$export$7dc96fe8e7fc9104;
var $44bb38a172dc4b28$export$bfd64c937657f93a;
var $44bb38a172dc4b28$export$4a6dd88bada4e7d2;
var $44bb38a172dc4b28$export$2b067c6666111485;
$44bb38a172dc4b28$export$7dc96fe8e7fc9104 = `XEcPNG_beta`;
$44bb38a172dc4b28$export$bfd64c937657f93a = `XEcPNG_rotating`;
$44bb38a172dc4b28$export$4a6dd88bada4e7d2 = `XEcPNG_shimmer`;
$44bb38a172dc4b28$export$2b067c6666111485 = `XEcPNG_tag`;

});


parcelRequire.register("1Iq4D", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37b20c534b52a779$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $8pPfi = parcelRequire("8pPfi");

var $4W0F0 = parcelRequire("4W0F0");

var $iFoQE = parcelRequire("iFoQE");
function $37b20c534b52a779$var$TextLink({ to: to, children: children, icon: icon, isTrailingIcon: isTrailingIcon = false, className: className, targetBlank: targetBlank, ...rest }) {
    const { getTo: getTo } = (0, $4W0F0.default)();
    const props = (0, $eCoWV.useMemo)(()=>({
            ...rest,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($iFoQE.link, isTrailingIcon && $iFoQE.trailingIcon, className),
            ...Boolean(targetBlank) && {
                rel: typeof targetBlank === "string" ? targetBlank : "noopener noreferrer",
                target: "_blank"
            }
        }), [
        className,
        isTrailingIcon,
        rest,
        targetBlank
    ]);
    if (to) return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $8pPfi.Link), {
        to: getTo(to),
        ...props,
        children: [
            icon,
            children
        ]
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("a", {
        ...props,
        children: [
            icon,
            children
        ]
    });
}
var $37b20c534b52a779$export$2e2bcd8739ae039 = $37b20c534b52a779$var$TextLink;

});
parcelRequire.register("iFoQE", function(module, exports) {

$parcel$export(module.exports, "link", function () { return $d96f54a53e5d353a$export$9c30223ca0a664fb; }, function (v) { return $d96f54a53e5d353a$export$9c30223ca0a664fb = v; });
$parcel$export(module.exports, "trailingIcon", function () { return $d96f54a53e5d353a$export$74dc5dd4e622afa8; }, function (v) { return $d96f54a53e5d353a$export$74dc5dd4e622afa8 = v; });
var $d96f54a53e5d353a$export$9c30223ca0a664fb;
var $d96f54a53e5d353a$export$bfd64c937657f93a;
var $d96f54a53e5d353a$export$4a6dd88bada4e7d2;
var $d96f54a53e5d353a$export$74dc5dd4e622afa8;
$d96f54a53e5d353a$export$9c30223ca0a664fb = `gty49a_link`;
$d96f54a53e5d353a$export$bfd64c937657f93a = `gty49a_rotating`;
$d96f54a53e5d353a$export$4a6dd88bada4e7d2 = `gty49a_shimmer`;
$d96f54a53e5d353a$export$74dc5dd4e622afa8 = `gty49a_trailingIcon`;

});


parcelRequire.register("3GWvi", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $2b02acfe8ad918f6$export$34e0f9847d4c02dd; }, function (v) { return $2b02acfe8ad918f6$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "large", function () { return $2b02acfe8ad918f6$export$f09585a853dddd32; }, function (v) { return $2b02acfe8ad918f6$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "learnMore", function () { return $2b02acfe8ad918f6$export$a9312d74524025b4; }, function (v) { return $2b02acfe8ad918f6$export$a9312d74524025b4 = v; });
$parcel$export(module.exports, "medium", function () { return $2b02acfe8ad918f6$export$649ecc744817b5c7; }, function (v) { return $2b02acfe8ad918f6$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $2b02acfe8ad918f6$export$bfd64c937657f93a; }, function (v) { return $2b02acfe8ad918f6$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $2b02acfe8ad918f6$export$4a6dd88bada4e7d2; }, function (v) { return $2b02acfe8ad918f6$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $2b02acfe8ad918f6$export$3c17b0e969a90510; }, function (v) { return $2b02acfe8ad918f6$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "subtitle", function () { return $2b02acfe8ad918f6$export$c96745152eb2740f; }, function (v) { return $2b02acfe8ad918f6$export$c96745152eb2740f = v; });
$parcel$export(module.exports, "title", function () { return $2b02acfe8ad918f6$export$fb184b623420d9be; }, function (v) { return $2b02acfe8ad918f6$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "titleEllipsis", function () { return $2b02acfe8ad918f6$export$4cb77ab59beb2e4f; }, function (v) { return $2b02acfe8ad918f6$export$4cb77ab59beb2e4f = v; });
var $2b02acfe8ad918f6$export$34e0f9847d4c02dd;
var $2b02acfe8ad918f6$export$f09585a853dddd32;
var $2b02acfe8ad918f6$export$a9312d74524025b4;
var $2b02acfe8ad918f6$export$649ecc744817b5c7;
var $2b02acfe8ad918f6$export$bfd64c937657f93a;
var $2b02acfe8ad918f6$export$4a6dd88bada4e7d2;
var $2b02acfe8ad918f6$export$3c17b0e969a90510;
var $2b02acfe8ad918f6$export$c96745152eb2740f;
var $2b02acfe8ad918f6$export$fb184b623420d9be;
var $2b02acfe8ad918f6$export$4cb77ab59beb2e4f;
$2b02acfe8ad918f6$export$34e0f9847d4c02dd = `u3lpsW_container`;
$2b02acfe8ad918f6$export$f09585a853dddd32 = `u3lpsW_large`;
$2b02acfe8ad918f6$export$a9312d74524025b4 = `u3lpsW_learnMore`;
$2b02acfe8ad918f6$export$649ecc744817b5c7 = `u3lpsW_medium`;
$2b02acfe8ad918f6$export$bfd64c937657f93a = `u3lpsW_rotating`;
$2b02acfe8ad918f6$export$4a6dd88bada4e7d2 = `u3lpsW_shimmer`;
$2b02acfe8ad918f6$export$3c17b0e969a90510 = `u3lpsW_small`;
$2b02acfe8ad918f6$export$c96745152eb2740f = `u3lpsW_subtitle`;
$2b02acfe8ad918f6$export$fb184b623420d9be = `u3lpsW_title`;
$2b02acfe8ad918f6$export$4cb77ab59beb2e4f = `u3lpsW_titleEllipsis`;

});


parcelRequire.register("9bgsA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e3920889c3da7d36$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $2qj4N = parcelRequire("2qj4N");
function $e3920889c3da7d36$var$IconButton({ size: size = "medium", children: children, className: className, iconClassName: iconClassName, ...rest }, reference) {
    const tipRef = (0, $eCoWV.useRef)(null);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("button", {
        ref: reference,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2qj4N.button, $2qj4N[size], className),
        ...rest,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            ref: tipRef,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2qj4N.icon, iconClassName),
            children: children
        })
    });
}
var $e3920889c3da7d36$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($e3920889c3da7d36$var$IconButton);

});
parcelRequire.register("2qj4N", function(module, exports) {

$parcel$export(module.exports, "button", function () { return $1c3ccea541b88a2f$export$2ba01fb71ed41cb6; }, function (v) { return $1c3ccea541b88a2f$export$2ba01fb71ed41cb6 = v; });
$parcel$export(module.exports, "icon", function () { return $1c3ccea541b88a2f$export$1ca1ec8b29a4ce27; }, function (v) { return $1c3ccea541b88a2f$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "large", function () { return $1c3ccea541b88a2f$export$f09585a853dddd32; }, function (v) { return $1c3ccea541b88a2f$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "medium", function () { return $1c3ccea541b88a2f$export$649ecc744817b5c7; }, function (v) { return $1c3ccea541b88a2f$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $1c3ccea541b88a2f$export$bfd64c937657f93a; }, function (v) { return $1c3ccea541b88a2f$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $1c3ccea541b88a2f$export$4a6dd88bada4e7d2; }, function (v) { return $1c3ccea541b88a2f$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $1c3ccea541b88a2f$export$3c17b0e969a90510; }, function (v) { return $1c3ccea541b88a2f$export$3c17b0e969a90510 = v; });
var $1c3ccea541b88a2f$export$2ba01fb71ed41cb6;
var $1c3ccea541b88a2f$export$1ca1ec8b29a4ce27;
var $1c3ccea541b88a2f$export$f09585a853dddd32;
var $1c3ccea541b88a2f$export$649ecc744817b5c7;
var $1c3ccea541b88a2f$export$bfd64c937657f93a;
var $1c3ccea541b88a2f$export$4a6dd88bada4e7d2;
var $1c3ccea541b88a2f$export$3c17b0e969a90510;
$1c3ccea541b88a2f$export$2ba01fb71ed41cb6 = `nDPQTW_button`;
$1c3ccea541b88a2f$export$1ca1ec8b29a4ce27 = `nDPQTW_icon`;
$1c3ccea541b88a2f$export$f09585a853dddd32 = `nDPQTW_large`;
$1c3ccea541b88a2f$export$649ecc744817b5c7 = `nDPQTW_medium`;
$1c3ccea541b88a2f$export$bfd64c937657f93a = `nDPQTW_rotating`;
$1c3ccea541b88a2f$export$4a6dd88bada4e7d2 = `nDPQTW_shimmer`;
$1c3ccea541b88a2f$export$3c17b0e969a90510 = `nDPQTW_small`;

});


parcelRequire.register("jibF8", function(module, exports) {

$parcel$export(module.exports, "closeIcon", function () { return $e0b8beb367a254fa$export$64a53ecd158b85c4; }, function (v) { return $e0b8beb367a254fa$export$64a53ecd158b85c4 = v; });
$parcel$export(module.exports, "container", function () { return $e0b8beb367a254fa$export$34e0f9847d4c02dd; }, function (v) { return $e0b8beb367a254fa$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "footer", function () { return $e0b8beb367a254fa$export$adb608be33961c98; }, function (v) { return $e0b8beb367a254fa$export$adb608be33961c98 = v; });
$parcel$export(module.exports, "header", function () { return $e0b8beb367a254fa$export$38e42c68cf43b5d4; }, function (v) { return $e0b8beb367a254fa$export$38e42c68cf43b5d4 = v; });
$parcel$export(module.exports, "iconAndTitle", function () { return $e0b8beb367a254fa$export$92e105a06b80aeff; }, function (v) { return $e0b8beb367a254fa$export$92e105a06b80aeff = v; });
$parcel$export(module.exports, "large", function () { return $e0b8beb367a254fa$export$f09585a853dddd32; }, function (v) { return $e0b8beb367a254fa$export$f09585a853dddd32 = v; });
$parcel$export(module.exports, "medium", function () { return $e0b8beb367a254fa$export$649ecc744817b5c7; }, function (v) { return $e0b8beb367a254fa$export$649ecc744817b5c7 = v; });
$parcel$export(module.exports, "rotating", function () { return $e0b8beb367a254fa$export$bfd64c937657f93a; }, function (v) { return $e0b8beb367a254fa$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $e0b8beb367a254fa$export$4a6dd88bada4e7d2; }, function (v) { return $e0b8beb367a254fa$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "xlarge", function () { return $e0b8beb367a254fa$export$bb57e550b957ab; }, function (v) { return $e0b8beb367a254fa$export$bb57e550b957ab = v; });
var $e0b8beb367a254fa$export$64a53ecd158b85c4;
var $e0b8beb367a254fa$export$34e0f9847d4c02dd;
var $e0b8beb367a254fa$export$adb608be33961c98;
var $e0b8beb367a254fa$export$38e42c68cf43b5d4;
var $e0b8beb367a254fa$export$92e105a06b80aeff;
var $e0b8beb367a254fa$export$f09585a853dddd32;
var $e0b8beb367a254fa$export$649ecc744817b5c7;
var $e0b8beb367a254fa$export$bfd64c937657f93a;
var $e0b8beb367a254fa$export$4a6dd88bada4e7d2;
var $e0b8beb367a254fa$export$bb57e550b957ab;
$e0b8beb367a254fa$export$64a53ecd158b85c4 = `tG7Whq_closeIcon`;
$e0b8beb367a254fa$export$34e0f9847d4c02dd = `tG7Whq_container`;
$e0b8beb367a254fa$export$adb608be33961c98 = `tG7Whq_footer`;
$e0b8beb367a254fa$export$38e42c68cf43b5d4 = `tG7Whq_header`;
$e0b8beb367a254fa$export$92e105a06b80aeff = `tG7Whq_iconAndTitle`;
$e0b8beb367a254fa$export$f09585a853dddd32 = `tG7Whq_large`;
$e0b8beb367a254fa$export$649ecc744817b5c7 = `tG7Whq_medium`;
$e0b8beb367a254fa$export$bfd64c937657f93a = `tG7Whq_rotating`;
$e0b8beb367a254fa$export$4a6dd88bada4e7d2 = `tG7Whq_shimmer`;
$e0b8beb367a254fa$export$bb57e550b957ab = `tG7Whq_xlarge`;

});


parcelRequire.register("gsHBE", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $bfc11623ebb6ad72$export$a7db06668cad9adb; }, function (v) { return $bfc11623ebb6ad72$export$a7db06668cad9adb = v; });
var $bfc11623ebb6ad72$export$a7db06668cad9adb;
var $bfc11623ebb6ad72$export$bfd64c937657f93a;
var $bfc11623ebb6ad72$export$4a6dd88bada4e7d2;
$bfc11623ebb6ad72$export$a7db06668cad9adb = `neT2BG_content`;
$bfc11623ebb6ad72$export$bfd64c937657f93a = `neT2BG_rotating`;
$bfc11623ebb6ad72$export$4a6dd88bada4e7d2 = `neT2BG_shimmer`;

});




parcelRequire.register("iYZTa", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $258241547dcc874b$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $ceK0K = parcelRequire("ceK0K");
parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $V1X8c = parcelRequire("V1X8c");
/**
 * The hook that returns the absolute URL for the sign-in or sign-out callback.
 * The path is not related to react-router, which means the path will also include
 * the basename of react-router if it's set.
 */ const $258241547dcc874b$var$useRedirectUri = (flow = "signIn")=>{
    const path = (0, $9X5Bp.useHref)((0, $b9zrd.joinPath)(...(0, $5CQIb.conditionalArray)(!(0, $V1X8c.isCloud) && (0, $ceK0K.ossConsolePath), flow === "signIn" ? "/callback" : "/")));
    const url = (0, $eCoWV.useMemo)(()=>new URL(path, window.location.origin), [
        path
    ]);
    return url;
};
var $258241547dcc874b$export$2e2bcd8739ae039 = $258241547dcc874b$var$useRedirectUri;

});


parcelRequire.register("3MzPh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cab414694ba4555$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $2jyuI = parcelRequire("2jyuI");
function $4cab414694ba4555$var$Spacer() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $2jyuI.spacer
    });
}
var $4cab414694ba4555$export$2e2bcd8739ae039 = $4cab414694ba4555$var$Spacer;

});
parcelRequire.register("2jyuI", function(module, exports) {

$parcel$export(module.exports, "spacer", function () { return $1af81cfd36084d1f$export$8cc075c801fd6817; }, function (v) { return $1af81cfd36084d1f$export$8cc075c801fd6817 = v; });
var $1af81cfd36084d1f$export$8cc075c801fd6817;
$1af81cfd36084d1f$export$8cc075c801fd6817 = `O3Avlq_spacer`;

});


parcelRequire.register("6PcpQ", function(module, exports) {

$parcel$export(module.exports, "onKeyDownHandler", function () { return $ebcd3624a3728305$export$c2c388d6a668999e; });
const $ebcd3624a3728305$export$c2c388d6a668999e = (callback)=>(event)=>{
        const { key: key } = event;
        if (typeof callback === "function" && [
            " ",
            "Enter"
        ].includes(key)) {
            callback(event);
            event.preventDefault();
        }
        if (typeof callback === "object") {
            const handler = callback[key];
            if (handler) {
                handler(event);
                event.preventDefault();
            }
        }
    };

});

parcelRequire.register("c3LX9", function(module, exports) {

$parcel$export(module.exports, "useFormContext", function () { return $400d82646811fc28$export$4d957a5e1be13b03; });
$parcel$export(module.exports, "FormProvider", function () { return $400d82646811fc28$export$8ce1ff4f94d08846; });
$parcel$export(module.exports, "useController", function () { return $400d82646811fc28$export$e8c786024a2b0a79; });
$parcel$export(module.exports, "Controller", function () { return $400d82646811fc28$export$bd0bf19f25da8474; });
$parcel$export(module.exports, "useFieldArray", function () { return $400d82646811fc28$export$310131896651d559; });
$parcel$export(module.exports, "useForm", function () { return $400d82646811fc28$export$87c0cf8eb5a167e0; });

var $eCoWV = parcelRequire("eCoWV");
var $400d82646811fc28$var$isCheckBoxInput = (element)=>element.type === "checkbox";
var $400d82646811fc28$var$isDateObject = (value1)=>value1 instanceof Date;
var $400d82646811fc28$var$isNullOrUndefined = (value1)=>value1 == null;
const $400d82646811fc28$var$isObjectType = (value1)=>typeof value1 === "object";
var $400d82646811fc28$var$isObject = (value1)=>!$400d82646811fc28$var$isNullOrUndefined(value1) && !Array.isArray(value1) && $400d82646811fc28$var$isObjectType(value1) && !$400d82646811fc28$var$isDateObject(value1);
var $400d82646811fc28$var$getEventValue = (event)=>$400d82646811fc28$var$isObject(event) && event.target ? $400d82646811fc28$var$isCheckBoxInput(event.target) ? event.target.checked : event.target.value : event;
var $400d82646811fc28$var$getNodeParentName = (name)=>name.substring(0, name.search(/\.\d+(\.|$)/)) || name;
var $400d82646811fc28$var$isNameInFieldArray = (names, name)=>names.has($400d82646811fc28$var$getNodeParentName(name));
var $400d82646811fc28$var$isPlainObject = (tempObject)=>{
    const prototypeCopy = tempObject.constructor && tempObject.constructor.prototype;
    return $400d82646811fc28$var$isObject(prototypeCopy) && prototypeCopy.hasOwnProperty("isPrototypeOf");
};
var $400d82646811fc28$var$isWeb = typeof window !== "undefined" && typeof window.HTMLElement !== "undefined" && typeof document !== "undefined";
function $400d82646811fc28$var$cloneObject(data) {
    let copy;
    const isArray = Array.isArray(data);
    if (data instanceof Date) copy = new Date(data);
    else if (data instanceof Set) copy = new Set(data);
    else if (!($400d82646811fc28$var$isWeb && (data instanceof Blob || data instanceof FileList)) && (isArray || $400d82646811fc28$var$isObject(data))) {
        copy = isArray ? [] : {};
        if (!Array.isArray(data) && !$400d82646811fc28$var$isPlainObject(data)) copy = data;
        else for(const key in data)copy[key] = $400d82646811fc28$var$cloneObject(data[key]);
    } else return data;
    return copy;
}
var $400d82646811fc28$var$compact = (value1)=>Array.isArray(value1) ? value1.filter(Boolean) : [];
var $400d82646811fc28$var$isUndefined = (val)=>val === undefined;
var $400d82646811fc28$export$3988ae62b71be9a3 = (obj, path, defaultValue)=>{
    if (!path || !$400d82646811fc28$var$isObject(obj)) return defaultValue;
    const result = $400d82646811fc28$var$compact(path.split(/[,[\].]+?/)).reduce((result, key)=>$400d82646811fc28$var$isNullOrUndefined(result) ? result : result[key], obj);
    return $400d82646811fc28$var$isUndefined(result) || result === obj ? $400d82646811fc28$var$isUndefined(obj[path]) ? defaultValue : obj[path] : result;
};
const $400d82646811fc28$var$EVENTS = {
    BLUR: "blur",
    FOCUS_OUT: "focusout",
    CHANGE: "change"
};
const $400d82646811fc28$var$VALIDATION_MODE = {
    onBlur: "onBlur",
    onChange: "onChange",
    onSubmit: "onSubmit",
    onTouched: "onTouched",
    all: "all"
};
const $400d82646811fc28$var$INPUT_VALIDATION_RULES = {
    max: "max",
    min: "min",
    maxLength: "maxLength",
    minLength: "minLength",
    pattern: "pattern",
    required: "required",
    validate: "validate"
};
const $400d82646811fc28$var$HookFormContext = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createContext(null);
/**
 * This custom hook allows you to access the form context. useFormContext is intended to be used in deeply nested structures, where it would become inconvenient to pass the context as a prop. To be used with {@link FormProvider}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @returns return all useForm methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $400d82646811fc28$export$4d957a5e1be13b03 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useContext($400d82646811fc28$var$HookFormContext);
/**
 * A provider component that propagates the `useForm` methods to all children components via [React Context](https://reactjs.org/docs/context.html) API. To be used with {@link useFormContext}.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformcontext) • [Demo](https://codesandbox.io/s/react-hook-form-v7-form-context-ytudi)
 *
 * @param props - all useFrom methods
 *
 * @example
 * ```tsx
 * function App() {
 *   const methods = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   return (
 *     <FormProvider {...methods} >
 *       <form onSubmit={methods.handleSubmit(onSubmit)}>
 *         <NestedInput />
 *         <input type="submit" />
 *       </form>
 *     </FormProvider>
 *   );
 * }
 *
 *  function NestedInput() {
 *   const { register } = useFormContext(); // retrieve all hook methods
 *   return <input {...register("test")} />;
 * }
 * ```
 */ const $400d82646811fc28$export$8ce1ff4f94d08846 = (props)=>{
    const { children: children, ...data } = props;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($400d82646811fc28$var$HookFormContext.Provider, {
        value: data
    }, children);
};
var $400d82646811fc28$var$getProxyFormState = (formState, control, localProxyFormState, isRoot = true)=>{
    const result = {
        defaultValues: control._defaultValues
    };
    for(const key in formState)Object.defineProperty(result, key, {
        get: ()=>{
            const _key = key;
            if (control._proxyFormState[_key] !== $400d82646811fc28$var$VALIDATION_MODE.all) control._proxyFormState[_key] = !isRoot || $400d82646811fc28$var$VALIDATION_MODE.all;
            localProxyFormState && (localProxyFormState[_key] = true);
            return formState[_key];
        }
    });
    return result;
};
var $400d82646811fc28$var$isEmptyObject = (value1)=>$400d82646811fc28$var$isObject(value1) && !Object.keys(value1).length;
var $400d82646811fc28$var$shouldRenderFormState = (formStateData, _proxyFormState, updateFormState, isRoot)=>{
    updateFormState(formStateData);
    const { name: name, ...formState } = formStateData;
    return $400d82646811fc28$var$isEmptyObject(formState) || Object.keys(formState).length >= Object.keys(_proxyFormState).length || Object.keys(formState).find((key)=>_proxyFormState[key] === (!isRoot || $400d82646811fc28$var$VALIDATION_MODE.all));
};
var $400d82646811fc28$var$convertToArrayPayload = (value1)=>Array.isArray(value1) ? value1 : [
        value1
    ];
var $400d82646811fc28$var$shouldSubscribeByName = (name, signalName, exact)=>exact && signalName ? name === signalName : !name || !signalName || name === signalName || $400d82646811fc28$var$convertToArrayPayload(name).some((currentName)=>currentName && (currentName.startsWith(signalName) || signalName.startsWith(currentName)));
function $400d82646811fc28$var$useSubscribe(props) {
    const _props = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(props);
    _props.current = props;
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        const subscription = !props.disabled && _props.current.subject && _props.current.subject.subscribe({
            next: _props.current.next
        });
        return ()=>{
            subscription && subscription.unsubscribe();
        };
    }, [
        props.disabled
    ]);
}
/**
 * This custom hook allows you to subscribe to each form state, and isolate the re-render at the custom hook level. It has its scope in terms of form state subscription, so it would not affect other useFormState and useForm. Using this hook can reduce the re-render impact on large and complex form application.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useformstate) • [Demo](https://codesandbox.io/s/useformstate-75xly)
 *
 * @param props - include options on specify fields to subscribe. {@link UseFormStateReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, control } = useForm({
 *     defaultValues: {
 *     firstName: "firstName"
 *   }});
 *   const { dirtyFields } = useFormState({
 *     control
 *   });
 *   const onSubmit = (data) => console.log(data);
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input {...register("firstName")} placeholder="First Name" />
 *       {dirtyFields.firstName && <p>Field is dirty.</p>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $400d82646811fc28$export$606f11b2eb45ecc6(props) {
    const methods = $400d82646811fc28$export$4d957a5e1be13b03();
    const { control: control = methods.control, disabled: disabled, name: name, exact: exact } = props || {};
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useState(control._formState);
    const _mounted = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(true);
    const _localProxyFormState = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef({
        isDirty: false,
        isLoading: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    });
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(name);
    _name.current = name;
    $400d82646811fc28$var$useSubscribe({
        disabled: disabled,
        next: (value1)=>_mounted.current && $400d82646811fc28$var$shouldSubscribeByName(_name.current, value1.name, exact) && $400d82646811fc28$var$shouldRenderFormState(value1, _localProxyFormState.current, control._updateFormState) && updateFormState({
                ...control._formState,
                ...value1
            }),
        subject: control._subjects.state
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        _mounted.current = true;
        _localProxyFormState.current.isValid && control._updateValid(true);
        return ()=>{
            _mounted.current = false;
        };
    }, [
        control
    ]);
    return $400d82646811fc28$var$getProxyFormState(formState, control, _localProxyFormState.current, false);
}
var $400d82646811fc28$var$isString = (value1)=>typeof value1 === "string";
var $400d82646811fc28$var$generateWatchOutput = (names, _names, formValues, isGlobal, defaultValue)=>{
    if ($400d82646811fc28$var$isString(names)) {
        isGlobal && _names.watch.add(names);
        return $400d82646811fc28$export$3988ae62b71be9a3(formValues, names, defaultValue);
    }
    if (Array.isArray(names)) return names.map((fieldName)=>(isGlobal && _names.watch.add(fieldName), $400d82646811fc28$export$3988ae62b71be9a3(formValues, fieldName)));
    isGlobal && (_names.watchAll = true);
    return formValues;
};
/**
 * Custom hook to subscribe to field change and isolate re-rendering at the component level.
 *
 * @remarks
 *
 * [API](https://react-hook-form.com/api/usewatch) • [Demo](https://codesandbox.io/s/react-hook-form-v7-ts-usewatch-h9i5e)
 *
 * @example
 * ```tsx
 * const { watch } = useForm();
 * const values = useWatch({
 *   name: "fieldName"
 *   control,
 * })
 * ```
 */ function $400d82646811fc28$export$3c773aa2b84f29e0(props) {
    const methods = $400d82646811fc28$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, defaultValue: defaultValue, disabled: disabled, exact: exact } = props || {};
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(name);
    _name.current = name;
    $400d82646811fc28$var$useSubscribe({
        disabled: disabled,
        subject: control._subjects.values,
        next: (formState)=>{
            if ($400d82646811fc28$var$shouldSubscribeByName(_name.current, formState.name, exact)) updateValue($400d82646811fc28$var$cloneObject($400d82646811fc28$var$generateWatchOutput(_name.current, control._names, formState.values || control._formValues, false, defaultValue)));
        }
    });
    const [value1, updateValue] = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useState(control._getWatch(name, defaultValue));
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>control._removeUnmounted());
    return value1;
}
var $400d82646811fc28$var$isKey = (value1)=>/^\w*$/.test(value1);
var $400d82646811fc28$var$stringToPath = (input)=>$400d82646811fc28$var$compact(input.replace(/["|']|\]/g, "").split(/\.|\[/));
function $400d82646811fc28$export$adaa4cf7ef1b65be(object, path, value1) {
    let index = -1;
    const tempPath = $400d82646811fc28$var$isKey(path) ? [
        path
    ] : $400d82646811fc28$var$stringToPath(path);
    const length = tempPath.length;
    const lastIndex = length - 1;
    while(++index < length){
        const key = tempPath[index];
        let newValue = value1;
        if (index !== lastIndex) {
            const objValue = object[key];
            newValue = $400d82646811fc28$var$isObject(objValue) || Array.isArray(objValue) ? objValue : !isNaN(+tempPath[index + 1]) ? [] : {};
        }
        object[key] = newValue;
        object = object[key];
    }
    return object;
}
/**
 * Custom hook to work with controlled component, this function provide you with both form and field level state. Re-render is isolated at the hook level.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller) • [Demo](https://codesandbox.io/s/usecontroller-0o8px)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns field properties, field and form state. {@link UseControllerReturn}
 *
 * @example
 * ```tsx
 * function Input(props) {
 *   const { field, fieldState, formState } = useController(props);
 *   return (
 *     <div>
 *       <input {...field} placeholder={props.name} />
 *       <p>{fieldState.isTouched && "Touched"}</p>
 *       <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *     </div>
 *   );
 * }
 * ```
 */ function $400d82646811fc28$export$e8c786024a2b0a79(props) {
    const methods = $400d82646811fc28$export$4d957a5e1be13b03();
    const { name: name, control: control = methods.control, shouldUnregister: shouldUnregister } = props;
    const isArrayField = $400d82646811fc28$var$isNameInFieldArray(control._names.array, name);
    const value1 = $400d82646811fc28$export$3c773aa2b84f29e0({
        control: control,
        name: name,
        defaultValue: $400d82646811fc28$export$3988ae62b71be9a3(control._formValues, name, $400d82646811fc28$export$3988ae62b71be9a3(control._defaultValues, name, props.defaultValue)),
        exact: true
    });
    const formState = $400d82646811fc28$export$606f11b2eb45ecc6({
        control: control,
        name: name
    });
    const _registerProps = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(control.register(name, {
        ...props.rules,
        value: value1
    }));
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        const _shouldUnregisterField = control._options.shouldUnregister || shouldUnregister;
        const updateMounted = (name, value1)=>{
            const field = $400d82646811fc28$export$3988ae62b71be9a3(control._fields, name);
            if (field) field._f.mount = value1;
        };
        updateMounted(name, true);
        if (_shouldUnregisterField) {
            const value1 = $400d82646811fc28$var$cloneObject($400d82646811fc28$export$3988ae62b71be9a3(control._options.defaultValues, name));
            $400d82646811fc28$export$adaa4cf7ef1b65be(control._defaultValues, name, value1);
            if ($400d82646811fc28$var$isUndefined($400d82646811fc28$export$3988ae62b71be9a3(control._formValues, name))) $400d82646811fc28$export$adaa4cf7ef1b65be(control._formValues, name, value1);
        }
        return ()=>{
            (isArrayField ? _shouldUnregisterField && !control._state.action : _shouldUnregisterField) ? control.unregister(name) : updateMounted(name, false);
        };
    }, [
        name,
        control,
        isArrayField,
        shouldUnregister
    ]);
    return {
        field: {
            name: name,
            value: value1,
            onChange: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback((event)=>_registerProps.current.onChange({
                    target: {
                        value: $400d82646811fc28$var$getEventValue(event),
                        name: name
                    },
                    type: $400d82646811fc28$var$EVENTS.CHANGE
                }), [
                name
            ]),
            onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(()=>_registerProps.current.onBlur({
                    target: {
                        value: $400d82646811fc28$export$3988ae62b71be9a3(control._formValues, name),
                        name: name
                    },
                    type: $400d82646811fc28$var$EVENTS.BLUR
                }), [
                name,
                control
            ]),
            ref: (elm)=>{
                const field = $400d82646811fc28$export$3988ae62b71be9a3(control._fields, name);
                if (field && elm) field._f.ref = {
                    focus: ()=>elm.focus(),
                    select: ()=>elm.select(),
                    setCustomValidity: (message)=>elm.setCustomValidity(message),
                    reportValidity: ()=>elm.reportValidity()
                };
            }
        },
        formState: formState,
        fieldState: Object.defineProperties({}, {
            invalid: {
                enumerable: true,
                get: ()=>!!$400d82646811fc28$export$3988ae62b71be9a3(formState.errors, name)
            },
            isDirty: {
                enumerable: true,
                get: ()=>!!$400d82646811fc28$export$3988ae62b71be9a3(formState.dirtyFields, name)
            },
            isTouched: {
                enumerable: true,
                get: ()=>!!$400d82646811fc28$export$3988ae62b71be9a3(formState.touchedFields, name)
            },
            error: {
                enumerable: true,
                get: ()=>$400d82646811fc28$export$3988ae62b71be9a3(formState.errors, name)
            }
        })
    };
}
/**
 * Component based on `useController` hook to work with controlled component.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usecontroller/controller) • [Demo](https://codesandbox.io/s/react-hook-form-v6-controller-ts-jwyzw) • [Video](https://www.youtube.com/watch?v=N2UNk_UCVyA)
 *
 * @param props - the path name to the form field value, and validation rules.
 *
 * @returns provide field handler functions, field and form state.
 *
 * @example
 * ```tsx
 * function App() {
 *   const { control } = useForm<FormValues>({
 *     defaultValues: {
 *       test: ""
 *     }
 *   });
 *
 *   return (
 *     <form>
 *       <Controller
 *         control={control}
 *         name="test"
 *         render={({ field: { onChange, onBlur, value, ref }, formState, fieldState }) => (
 *           <>
 *             <input
 *               onChange={onChange} // send value to hook form
 *               onBlur={onBlur} // notify when input is touched
 *               value={value} // return updated value
 *               ref={ref} // set ref for focus management
 *             />
 *             <p>{formState.isSubmitted ? "submitted" : ""}</p>
 *             <p>{fieldState.isTouched ? "touched" : ""}</p>
 *           </>
 *         )}
 *       />
 *     </form>
 *   );
 * }
 * ```
 */ const $400d82646811fc28$export$bd0bf19f25da8474 = (props)=>props.render($400d82646811fc28$export$e8c786024a2b0a79(props));
var $400d82646811fc28$export$b196c2a4f765bd30 = (name, validateAllFieldCriteria, errors, type, message)=>validateAllFieldCriteria ? {
        ...errors[name],
        types: {
            ...errors[name] && errors[name].types ? errors[name].types : {},
            [type]: message || true
        }
    } : {};
const $400d82646811fc28$var$focusFieldBy = (fields, callback, fieldsNames)=>{
    for (const key of fieldsNames || Object.keys(fields)){
        const field = $400d82646811fc28$export$3988ae62b71be9a3(fields, key);
        if (field) {
            const { _f: _f, ...currentField } = field;
            if (_f && callback(_f.name)) {
                if (_f.ref.focus) {
                    _f.ref.focus();
                    break;
                } else if (_f.refs && _f.refs[0].focus) {
                    _f.refs[0].focus();
                    break;
                }
            } else if ($400d82646811fc28$var$isObject(currentField)) $400d82646811fc28$var$focusFieldBy(currentField, callback);
        }
    }
};
var $400d82646811fc28$var$generateId = ()=>{
    const d = typeof performance === "undefined" ? Date.now() : performance.now() * 1000;
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
        const r = (Math.random() * 16 + d) % 16 | 0;
        return (c == "x" ? r : r & 0x3 | 0x8).toString(16);
    });
};
var $400d82646811fc28$var$getFocusFieldName = (name, index, options = {})=>options.shouldFocus || $400d82646811fc28$var$isUndefined(options.shouldFocus) ? options.focusName || `${name}.${$400d82646811fc28$var$isUndefined(options.focusIndex) ? index : options.focusIndex}.` : "";
var $400d82646811fc28$var$getValidationModes = (mode)=>({
        isOnSubmit: !mode || mode === $400d82646811fc28$var$VALIDATION_MODE.onSubmit,
        isOnBlur: mode === $400d82646811fc28$var$VALIDATION_MODE.onBlur,
        isOnChange: mode === $400d82646811fc28$var$VALIDATION_MODE.onChange,
        isOnAll: mode === $400d82646811fc28$var$VALIDATION_MODE.all,
        isOnTouch: mode === $400d82646811fc28$var$VALIDATION_MODE.onTouched
    });
var $400d82646811fc28$var$isWatched = (name, _names, isBlurEvent)=>!isBlurEvent && (_names.watchAll || _names.watch.has(name) || [
        ..._names.watch
    ].some((watchName)=>name.startsWith(watchName) && /^\.\w+/.test(name.slice(watchName.length))));
var $400d82646811fc28$var$updateFieldArrayRootError = (errors, error, name)=>{
    const fieldArrayErrors = $400d82646811fc28$var$compact($400d82646811fc28$export$3988ae62b71be9a3(errors, name));
    $400d82646811fc28$export$adaa4cf7ef1b65be(fieldArrayErrors, "root", error[name]);
    $400d82646811fc28$export$adaa4cf7ef1b65be(errors, name, fieldArrayErrors);
    return errors;
};
var $400d82646811fc28$var$isBoolean = (value1)=>typeof value1 === "boolean";
var $400d82646811fc28$var$isFileInput = (element)=>element.type === "file";
var $400d82646811fc28$var$isFunction = (value1)=>typeof value1 === "function";
var $400d82646811fc28$var$isHTMLElement = (value1)=>{
    if (!$400d82646811fc28$var$isWeb) return false;
    const owner = value1 ? value1.ownerDocument : 0;
    return value1 instanceof (owner && owner.defaultView ? owner.defaultView.HTMLElement : HTMLElement);
};
var $400d82646811fc28$var$isMessage = (value1)=>$400d82646811fc28$var$isString(value1);
var $400d82646811fc28$var$isRadioInput = (element)=>element.type === "radio";
var $400d82646811fc28$var$isRegex = (value1)=>value1 instanceof RegExp;
const $400d82646811fc28$var$defaultResult = {
    value: false,
    isValid: false
};
const $400d82646811fc28$var$validResult = {
    value: true,
    isValid: true
};
var $400d82646811fc28$var$getCheckboxValue = (options)=>{
    if (Array.isArray(options)) {
        if (options.length > 1) {
            const values = options.filter((option)=>option && option.checked && !option.disabled).map((option)=>option.value);
            return {
                value: values,
                isValid: !!values.length
            };
        }
        return options[0].checked && !options[0].disabled ? options[0].attributes && !$400d82646811fc28$var$isUndefined(options[0].attributes.value) ? $400d82646811fc28$var$isUndefined(options[0].value) || options[0].value === "" ? $400d82646811fc28$var$validResult : {
            value: options[0].value,
            isValid: true
        } : $400d82646811fc28$var$validResult : $400d82646811fc28$var$defaultResult;
    }
    return $400d82646811fc28$var$defaultResult;
};
const $400d82646811fc28$var$defaultReturn = {
    isValid: false,
    value: null
};
var $400d82646811fc28$var$getRadioValue = (options)=>Array.isArray(options) ? options.reduce((previous, option)=>option && option.checked && !option.disabled ? {
            isValid: true,
            value: option.value
        } : previous, $400d82646811fc28$var$defaultReturn) : $400d82646811fc28$var$defaultReturn;
function $400d82646811fc28$var$getValidateError(result, ref, type = "validate") {
    if ($400d82646811fc28$var$isMessage(result) || Array.isArray(result) && result.every($400d82646811fc28$var$isMessage) || $400d82646811fc28$var$isBoolean(result) && !result) return {
        type: type,
        message: $400d82646811fc28$var$isMessage(result) ? result : "",
        ref: ref
    };
}
var $400d82646811fc28$var$getValueAndMessage = (validationData)=>$400d82646811fc28$var$isObject(validationData) && !$400d82646811fc28$var$isRegex(validationData) ? validationData : {
        value: validationData,
        message: ""
    };
var $400d82646811fc28$var$validateField = async (field, formValues, validateAllFieldCriteria, shouldUseNativeValidation, isFieldArray)=>{
    const { ref: ref, refs: refs, required: required, maxLength: maxLength, minLength: minLength, min: min, max: max, pattern: pattern, validate: validate, name: name, valueAsNumber: valueAsNumber, mount: mount, disabled: disabled } = field._f;
    const inputValue = $400d82646811fc28$export$3988ae62b71be9a3(formValues, name);
    if (!mount || disabled) return {};
    const inputRef = refs ? refs[0] : ref;
    const setCustomValidity = (message)=>{
        if (shouldUseNativeValidation && inputRef.reportValidity) {
            inputRef.setCustomValidity($400d82646811fc28$var$isBoolean(message) ? "" : message || "");
            inputRef.reportValidity();
        }
    };
    const error = {};
    const isRadio = $400d82646811fc28$var$isRadioInput(ref);
    const isCheckBox = $400d82646811fc28$var$isCheckBoxInput(ref);
    const isRadioOrCheckbox = isRadio || isCheckBox;
    const isEmpty = (valueAsNumber || $400d82646811fc28$var$isFileInput(ref)) && $400d82646811fc28$var$isUndefined(ref.value) && $400d82646811fc28$var$isUndefined(inputValue) || $400d82646811fc28$var$isHTMLElement(ref) && ref.value === "" || inputValue === "" || Array.isArray(inputValue) && !inputValue.length;
    const appendErrorsCurry = $400d82646811fc28$export$b196c2a4f765bd30.bind(null, name, validateAllFieldCriteria, error);
    const getMinMaxMessage = (exceedMax, maxLengthMessage, minLengthMessage, maxType = $400d82646811fc28$var$INPUT_VALIDATION_RULES.maxLength, minType = $400d82646811fc28$var$INPUT_VALIDATION_RULES.minLength)=>{
        const message = exceedMax ? maxLengthMessage : minLengthMessage;
        error[name] = {
            type: exceedMax ? maxType : minType,
            message: message,
            ref: ref,
            ...appendErrorsCurry(exceedMax ? maxType : minType, message)
        };
    };
    if (isFieldArray ? !Array.isArray(inputValue) || !inputValue.length : required && (!isRadioOrCheckbox && (isEmpty || $400d82646811fc28$var$isNullOrUndefined(inputValue)) || $400d82646811fc28$var$isBoolean(inputValue) && !inputValue || isCheckBox && !$400d82646811fc28$var$getCheckboxValue(refs).isValid || isRadio && !$400d82646811fc28$var$getRadioValue(refs).isValid)) {
        const { value: value1, message: message } = $400d82646811fc28$var$isMessage(required) ? {
            value: !!required,
            message: required
        } : $400d82646811fc28$var$getValueAndMessage(required);
        if (value1) {
            error[name] = {
                type: $400d82646811fc28$var$INPUT_VALIDATION_RULES.required,
                message: message,
                ref: inputRef,
                ...appendErrorsCurry($400d82646811fc28$var$INPUT_VALIDATION_RULES.required, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (!isEmpty && (!$400d82646811fc28$var$isNullOrUndefined(min) || !$400d82646811fc28$var$isNullOrUndefined(max))) {
        let exceedMax;
        let exceedMin;
        const maxOutput = $400d82646811fc28$var$getValueAndMessage(max);
        const minOutput = $400d82646811fc28$var$getValueAndMessage(min);
        if (!$400d82646811fc28$var$isNullOrUndefined(inputValue) && !isNaN(inputValue)) {
            const valueNumber = ref.valueAsNumber || (inputValue ? +inputValue : inputValue);
            if (!$400d82646811fc28$var$isNullOrUndefined(maxOutput.value)) exceedMax = valueNumber > maxOutput.value;
            if (!$400d82646811fc28$var$isNullOrUndefined(minOutput.value)) exceedMin = valueNumber < minOutput.value;
        } else {
            const valueDate = ref.valueAsDate || new Date(inputValue);
            const convertTimeToDate = (time)=>new Date(new Date().toDateString() + " " + time);
            const isTime = ref.type == "time";
            const isWeek = ref.type == "week";
            if ($400d82646811fc28$var$isString(maxOutput.value) && inputValue) exceedMax = isTime ? convertTimeToDate(inputValue) > convertTimeToDate(maxOutput.value) : isWeek ? inputValue > maxOutput.value : valueDate > new Date(maxOutput.value);
            if ($400d82646811fc28$var$isString(minOutput.value) && inputValue) exceedMin = isTime ? convertTimeToDate(inputValue) < convertTimeToDate(minOutput.value) : isWeek ? inputValue < minOutput.value : valueDate < new Date(minOutput.value);
        }
        if (exceedMax || exceedMin) {
            getMinMaxMessage(!!exceedMax, maxOutput.message, minOutput.message, $400d82646811fc28$var$INPUT_VALIDATION_RULES.max, $400d82646811fc28$var$INPUT_VALIDATION_RULES.min);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if ((maxLength || minLength) && !isEmpty && ($400d82646811fc28$var$isString(inputValue) || isFieldArray && Array.isArray(inputValue))) {
        const maxLengthOutput = $400d82646811fc28$var$getValueAndMessage(maxLength);
        const minLengthOutput = $400d82646811fc28$var$getValueAndMessage(minLength);
        const exceedMax = !$400d82646811fc28$var$isNullOrUndefined(maxLengthOutput.value) && inputValue.length > +maxLengthOutput.value;
        const exceedMin = !$400d82646811fc28$var$isNullOrUndefined(minLengthOutput.value) && inputValue.length < +minLengthOutput.value;
        if (exceedMax || exceedMin) {
            getMinMaxMessage(exceedMax, maxLengthOutput.message, minLengthOutput.message);
            if (!validateAllFieldCriteria) {
                setCustomValidity(error[name].message);
                return error;
            }
        }
    }
    if (pattern && !isEmpty && $400d82646811fc28$var$isString(inputValue)) {
        const { value: patternValue, message: message } = $400d82646811fc28$var$getValueAndMessage(pattern);
        if ($400d82646811fc28$var$isRegex(patternValue) && !inputValue.match(patternValue)) {
            error[name] = {
                type: $400d82646811fc28$var$INPUT_VALIDATION_RULES.pattern,
                message: message,
                ref: ref,
                ...appendErrorsCurry($400d82646811fc28$var$INPUT_VALIDATION_RULES.pattern, message)
            };
            if (!validateAllFieldCriteria) {
                setCustomValidity(message);
                return error;
            }
        }
    }
    if (validate) {
        if ($400d82646811fc28$var$isFunction(validate)) {
            const result = await validate(inputValue, formValues);
            const validateError = $400d82646811fc28$var$getValidateError(result, inputRef);
            if (validateError) {
                error[name] = {
                    ...validateError,
                    ...appendErrorsCurry($400d82646811fc28$var$INPUT_VALIDATION_RULES.validate, validateError.message)
                };
                if (!validateAllFieldCriteria) {
                    setCustomValidity(validateError.message);
                    return error;
                }
            }
        } else if ($400d82646811fc28$var$isObject(validate)) {
            let validationResult = {};
            for(const key in validate){
                if (!$400d82646811fc28$var$isEmptyObject(validationResult) && !validateAllFieldCriteria) break;
                const validateError = $400d82646811fc28$var$getValidateError(await validate[key](inputValue, formValues), inputRef, key);
                if (validateError) {
                    validationResult = {
                        ...validateError,
                        ...appendErrorsCurry(key, validateError.message)
                    };
                    setCustomValidity(validateError.message);
                    if (validateAllFieldCriteria) error[name] = validationResult;
                }
            }
            if (!$400d82646811fc28$var$isEmptyObject(validationResult)) {
                error[name] = {
                    ref: inputRef,
                    ...validationResult
                };
                if (!validateAllFieldCriteria) return error;
            }
        }
    }
    setCustomValidity(true);
    return error;
};
function $400d82646811fc28$var$append(data, value1) {
    return [
        ...data,
        ...$400d82646811fc28$var$convertToArrayPayload(value1)
    ];
}
var $400d82646811fc28$var$fillEmptyArray = (value1)=>Array.isArray(value1) ? value1.map(()=>undefined) : undefined;
function $400d82646811fc28$var$insert(data, index, value1) {
    return [
        ...data.slice(0, index),
        ...$400d82646811fc28$var$convertToArrayPayload(value1),
        ...data.slice(index)
    ];
}
var $400d82646811fc28$var$moveArrayAt = (data, from, to)=>{
    if (!Array.isArray(data)) return [];
    if ($400d82646811fc28$var$isUndefined(data[to])) data[to] = undefined;
    data.splice(to, 0, data.splice(from, 1)[0]);
    return data;
};
function $400d82646811fc28$var$prepend(data, value1) {
    return [
        ...$400d82646811fc28$var$convertToArrayPayload(value1),
        ...$400d82646811fc28$var$convertToArrayPayload(data)
    ];
}
function $400d82646811fc28$var$removeAtIndexes(data, indexes) {
    let i = 0;
    const temp = [
        ...data
    ];
    for (const index of indexes){
        temp.splice(index - i, 1);
        i++;
    }
    return $400d82646811fc28$var$compact(temp).length ? temp : [];
}
var $400d82646811fc28$var$removeArrayAt = (data, index)=>$400d82646811fc28$var$isUndefined(index) ? [] : $400d82646811fc28$var$removeAtIndexes(data, $400d82646811fc28$var$convertToArrayPayload(index).sort((a, b)=>a - b));
var $400d82646811fc28$var$swapArrayAt = (data, indexA, indexB)=>{
    data[indexA] = [
        data[indexB],
        data[indexB] = data[indexA]
    ][0];
};
function $400d82646811fc28$var$baseGet(object, updatePath) {
    const length = updatePath.slice(0, -1).length;
    let index = 0;
    while(index < length)object = $400d82646811fc28$var$isUndefined(object) ? index++ : object[updatePath[index++]];
    return object;
}
function $400d82646811fc28$var$isEmptyArray(obj) {
    for(const key in obj){
        if (!$400d82646811fc28$var$isUndefined(obj[key])) return false;
    }
    return true;
}
function $400d82646811fc28$var$unset(object, path) {
    const paths = Array.isArray(path) ? path : $400d82646811fc28$var$isKey(path) ? [
        path
    ] : $400d82646811fc28$var$stringToPath(path);
    const childObject = paths.length === 1 ? object : $400d82646811fc28$var$baseGet(object, paths);
    const index = paths.length - 1;
    const key = paths[index];
    if (childObject) delete childObject[key];
    if (index !== 0 && ($400d82646811fc28$var$isObject(childObject) && $400d82646811fc28$var$isEmptyObject(childObject) || Array.isArray(childObject) && $400d82646811fc28$var$isEmptyArray(childObject))) $400d82646811fc28$var$unset(object, paths.slice(0, -1));
    return object;
}
var $400d82646811fc28$var$updateAt = (fieldValues, index, value1)=>{
    fieldValues[index] = value1;
    return fieldValues;
};
/**
 * A custom hook that exposes convenient methods to perform operations with a list of dynamic inputs that need to be appended, updated, removed etc. • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn) • [Video](https://youtu.be/4MrbfGSFY2A)
 *
 * @remarks
 * [API](https://react-hook-form.com/api/usefieldarray) • [Demo](https://codesandbox.io/s/react-hook-form-usefieldarray-ssugn)
 *
 * @param props - useFieldArray props
 *
 * @returns methods - functions to manipulate with the Field Arrays (dynamic inputs) {@link UseFieldArrayReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, control, handleSubmit, reset, trigger, setError } = useForm({
 *     defaultValues: {
 *       test: []
 *     }
 *   });
 *   const { fields, append } = useFieldArray({
 *     control,
 *     name: "test"
 *   });
 *
 *   return (
 *     <form onSubmit={handleSubmit(data => console.log(data))}>
 *       {fields.map((item, index) => (
 *          <input key={item.id} {...register(`test.${index}.firstName`)}  />
 *       ))}
 *       <button type="button" onClick={() => append({ firstName: "bill" })}>
 *         append
 *       </button>
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $400d82646811fc28$export$310131896651d559(props) {
    const methods = $400d82646811fc28$export$4d957a5e1be13b03();
    const { control: control = methods.control, name: name, keyName: keyName = "id", shouldUnregister: shouldUnregister } = props;
    const [fields, setFields] = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useState(control._getFieldArray(name));
    const ids = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(control._getFieldArray(name).map($400d82646811fc28$var$generateId));
    const _fieldIds = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(fields);
    const _name = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(name);
    const _actioned = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef(false);
    _name.current = name;
    _fieldIds.current = fields;
    control._names.array.add(name);
    props.rules && control.register(name, props.rules);
    $400d82646811fc28$var$useSubscribe({
        next: ({ values: values, name: fieldArrayName })=>{
            if (fieldArrayName === _name.current || !fieldArrayName) {
                const fieldValues = $400d82646811fc28$export$3988ae62b71be9a3(values, _name.current);
                if (Array.isArray(fieldValues)) {
                    setFields(fieldValues);
                    ids.current = fieldValues.map($400d82646811fc28$var$generateId);
                }
            }
        },
        subject: control._subjects.array
    });
    const updateValues = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback((updatedFieldArrayValues)=>{
        _actioned.current = true;
        control._updateFieldArray(name, updatedFieldArrayValues);
    }, [
        control,
        name
    ]);
    const append$1 = (value1, options)=>{
        const appendValue = $400d82646811fc28$var$convertToArrayPayload($400d82646811fc28$var$cloneObject(value1));
        const updatedFieldArrayValues = $400d82646811fc28$var$append(control._getFieldArray(name), appendValue);
        control._names.focus = $400d82646811fc28$var$getFocusFieldName(name, updatedFieldArrayValues.length - 1, options);
        ids.current = $400d82646811fc28$var$append(ids.current, appendValue.map($400d82646811fc28$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$append, {
            argA: $400d82646811fc28$var$fillEmptyArray(value1)
        });
    };
    const prepend$1 = (value1, options)=>{
        const prependValue = $400d82646811fc28$var$convertToArrayPayload($400d82646811fc28$var$cloneObject(value1));
        const updatedFieldArrayValues = $400d82646811fc28$var$prepend(control._getFieldArray(name), prependValue);
        control._names.focus = $400d82646811fc28$var$getFocusFieldName(name, 0, options);
        ids.current = $400d82646811fc28$var$prepend(ids.current, prependValue.map($400d82646811fc28$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$prepend, {
            argA: $400d82646811fc28$var$fillEmptyArray(value1)
        });
    };
    const remove = (index)=>{
        const updatedFieldArrayValues = $400d82646811fc28$var$removeArrayAt(control._getFieldArray(name), index);
        ids.current = $400d82646811fc28$var$removeArrayAt(ids.current, index);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$removeArrayAt, {
            argA: index
        });
    };
    const insert$1 = (index, value1, options)=>{
        const insertValue = $400d82646811fc28$var$convertToArrayPayload($400d82646811fc28$var$cloneObject(value1));
        const updatedFieldArrayValues = $400d82646811fc28$var$insert(control._getFieldArray(name), index, insertValue);
        control._names.focus = $400d82646811fc28$var$getFocusFieldName(name, index, options);
        ids.current = $400d82646811fc28$var$insert(ids.current, index, insertValue.map($400d82646811fc28$var$generateId));
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$insert, {
            argA: index,
            argB: $400d82646811fc28$var$fillEmptyArray(value1)
        });
    };
    const swap = (indexA, indexB)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $400d82646811fc28$var$swapArrayAt(updatedFieldArrayValues, indexA, indexB);
        $400d82646811fc28$var$swapArrayAt(ids.current, indexA, indexB);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$swapArrayAt, {
            argA: indexA,
            argB: indexB
        }, false);
    };
    const move = (from, to)=>{
        const updatedFieldArrayValues = control._getFieldArray(name);
        $400d82646811fc28$var$moveArrayAt(updatedFieldArrayValues, from, to);
        $400d82646811fc28$var$moveArrayAt(ids.current, from, to);
        updateValues(updatedFieldArrayValues);
        setFields(updatedFieldArrayValues);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$moveArrayAt, {
            argA: from,
            argB: to
        }, false);
    };
    const update = (index, value1)=>{
        const updateValue = $400d82646811fc28$var$cloneObject(value1);
        const updatedFieldArrayValues = $400d82646811fc28$var$updateAt(control._getFieldArray(name), index, updateValue);
        ids.current = [
            ...updatedFieldArrayValues
        ].map((item, i)=>!item || i === index ? $400d82646811fc28$var$generateId() : ids.current[i]);
        updateValues(updatedFieldArrayValues);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, updatedFieldArrayValues, $400d82646811fc28$var$updateAt, {
            argA: index,
            argB: updateValue
        }, true, false);
    };
    const replace = (value1)=>{
        const updatedFieldArrayValues = $400d82646811fc28$var$convertToArrayPayload($400d82646811fc28$var$cloneObject(value1));
        ids.current = updatedFieldArrayValues.map($400d82646811fc28$var$generateId);
        updateValues([
            ...updatedFieldArrayValues
        ]);
        setFields([
            ...updatedFieldArrayValues
        ]);
        control._updateFieldArray(name, [
            ...updatedFieldArrayValues
        ], (data)=>data, {}, true, false);
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        control._state.action = false;
        $400d82646811fc28$var$isWatched(name, control._names) && control._subjects.state.next({
            ...control._formState
        });
        if (_actioned.current && (!$400d82646811fc28$var$getValidationModes(control._options.mode).isOnSubmit || control._formState.isSubmitted)) {
            if (control._options.resolver) control._executeSchema([
                name
            ]).then((result)=>{
                const error = $400d82646811fc28$export$3988ae62b71be9a3(result.errors, name);
                const existingError = $400d82646811fc28$export$3988ae62b71be9a3(control._formState.errors, name);
                if (existingError ? !error && existingError.type : error && error.type) {
                    error ? $400d82646811fc28$export$adaa4cf7ef1b65be(control._formState.errors, name, error) : $400d82646811fc28$var$unset(control._formState.errors, name);
                    control._subjects.state.next({
                        errors: control._formState.errors
                    });
                }
            });
            else {
                const field = $400d82646811fc28$export$3988ae62b71be9a3(control._fields, name);
                if (field && field._f) $400d82646811fc28$var$validateField(field, control._formValues, control._options.criteriaMode === $400d82646811fc28$var$VALIDATION_MODE.all, control._options.shouldUseNativeValidation, true).then((error)=>!$400d82646811fc28$var$isEmptyObject(error) && control._subjects.state.next({
                        errors: $400d82646811fc28$var$updateFieldArrayRootError(control._formState.errors, error, name)
                    }));
            }
        }
        control._subjects.values.next({
            name: name,
            values: {
                ...control._formValues
            }
        });
        control._names.focus && $400d82646811fc28$var$focusFieldBy(control._fields, (key)=>!!key && key.startsWith(control._names.focus || ""));
        control._names.focus = "";
        control._updateValid();
    }, [
        fields,
        name,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        !$400d82646811fc28$export$3988ae62b71be9a3(control._formValues, name) && control._updateFieldArray(name);
        return ()=>{
            (control._options.shouldUnregister || shouldUnregister) && control.unregister(name);
        };
    }, [
        name,
        control,
        keyName,
        shouldUnregister
    ]);
    return {
        swap: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(swap, [
            updateValues,
            name,
            control
        ]),
        move: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(move, [
            updateValues,
            name,
            control
        ]),
        prepend: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(prepend$1, [
            updateValues,
            name,
            control
        ]),
        append: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(append$1, [
            updateValues,
            name,
            control
        ]),
        remove: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(remove, [
            updateValues,
            name,
            control
        ]),
        insert: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(insert$1, [
            updateValues,
            name,
            control
        ]),
        update: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(update, [
            updateValues,
            name,
            control
        ]),
        replace: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useCallback(replace, [
            updateValues,
            name,
            control
        ]),
        fields: (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useMemo(()=>fields.map((field, index)=>({
                    ...field,
                    [keyName]: ids.current[index] || $400d82646811fc28$var$generateId()
                })), [
            fields,
            keyName
        ])
    };
}
function $400d82646811fc28$var$createSubject() {
    let _observers = [];
    const next = (value1)=>{
        for (const observer of _observers)observer.next && observer.next(value1);
    };
    const subscribe = (observer)=>{
        _observers.push(observer);
        return {
            unsubscribe: ()=>{
                _observers = _observers.filter((o)=>o !== observer);
            }
        };
    };
    const unsubscribe = ()=>{
        _observers = [];
    };
    return {
        get observers () {
            return _observers;
        },
        next: next,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
}
var $400d82646811fc28$var$isPrimitive = (value1)=>$400d82646811fc28$var$isNullOrUndefined(value1) || !$400d82646811fc28$var$isObjectType(value1);
function $400d82646811fc28$var$deepEqual(object1, object2) {
    if ($400d82646811fc28$var$isPrimitive(object1) || $400d82646811fc28$var$isPrimitive(object2)) return object1 === object2;
    if ($400d82646811fc28$var$isDateObject(object1) && $400d82646811fc28$var$isDateObject(object2)) return object1.getTime() === object2.getTime();
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);
    if (keys1.length !== keys2.length) return false;
    for (const key of keys1){
        const val1 = object1[key];
        if (!keys2.includes(key)) return false;
        if (key !== "ref") {
            const val2 = object2[key];
            if ($400d82646811fc28$var$isDateObject(val1) && $400d82646811fc28$var$isDateObject(val2) || $400d82646811fc28$var$isObject(val1) && $400d82646811fc28$var$isObject(val2) || Array.isArray(val1) && Array.isArray(val2) ? !$400d82646811fc28$var$deepEqual(val1, val2) : val1 !== val2) return false;
        }
    }
    return true;
}
var $400d82646811fc28$var$isMultipleSelect = (element)=>element.type === `select-multiple`;
var $400d82646811fc28$var$isRadioOrCheckbox = (ref)=>$400d82646811fc28$var$isRadioInput(ref) || $400d82646811fc28$var$isCheckBoxInput(ref);
var $400d82646811fc28$var$live = (ref)=>$400d82646811fc28$var$isHTMLElement(ref) && ref.isConnected;
var $400d82646811fc28$var$objectHasFunction = (data)=>{
    for(const key in data){
        if ($400d82646811fc28$var$isFunction(data[key])) return true;
    }
    return false;
};
function $400d82646811fc28$var$markFieldsDirty(data, fields = {}) {
    const isParentNodeArray = Array.isArray(data);
    if ($400d82646811fc28$var$isObject(data) || isParentNodeArray) for(const key in data){
        if (Array.isArray(data[key]) || $400d82646811fc28$var$isObject(data[key]) && !$400d82646811fc28$var$objectHasFunction(data[key])) {
            fields[key] = Array.isArray(data[key]) ? [] : {};
            $400d82646811fc28$var$markFieldsDirty(data[key], fields[key]);
        } else if (!$400d82646811fc28$var$isNullOrUndefined(data[key])) fields[key] = true;
    }
    return fields;
}
function $400d82646811fc28$var$getDirtyFieldsFromDefaultValues(data, formValues, dirtyFieldsFromValues) {
    const isParentNodeArray = Array.isArray(data);
    if ($400d82646811fc28$var$isObject(data) || isParentNodeArray) {
        for(const key in data)if (Array.isArray(data[key]) || $400d82646811fc28$var$isObject(data[key]) && !$400d82646811fc28$var$objectHasFunction(data[key])) {
            if ($400d82646811fc28$var$isUndefined(formValues) || $400d82646811fc28$var$isPrimitive(dirtyFieldsFromValues[key])) dirtyFieldsFromValues[key] = Array.isArray(data[key]) ? $400d82646811fc28$var$markFieldsDirty(data[key], []) : {
                ...$400d82646811fc28$var$markFieldsDirty(data[key])
            };
            else $400d82646811fc28$var$getDirtyFieldsFromDefaultValues(data[key], $400d82646811fc28$var$isNullOrUndefined(formValues) ? {} : formValues[key], dirtyFieldsFromValues[key]);
        } else dirtyFieldsFromValues[key] = !$400d82646811fc28$var$deepEqual(data[key], formValues[key]);
    }
    return dirtyFieldsFromValues;
}
var $400d82646811fc28$var$getDirtyFields = (defaultValues, formValues)=>$400d82646811fc28$var$getDirtyFieldsFromDefaultValues(defaultValues, formValues, $400d82646811fc28$var$markFieldsDirty(formValues));
var $400d82646811fc28$var$getFieldValueAs = (value1, { valueAsNumber: valueAsNumber, valueAsDate: valueAsDate, setValueAs: setValueAs })=>$400d82646811fc28$var$isUndefined(value1) ? value1 : valueAsNumber ? value1 === "" ? NaN : value1 ? +value1 : value1 : valueAsDate && $400d82646811fc28$var$isString(value1) ? new Date(value1) : setValueAs ? setValueAs(value1) : value1;
function $400d82646811fc28$var$getFieldValue(_f) {
    const ref = _f.ref;
    if (_f.refs ? _f.refs.every((ref)=>ref.disabled) : ref.disabled) return;
    if ($400d82646811fc28$var$isFileInput(ref)) return ref.files;
    if ($400d82646811fc28$var$isRadioInput(ref)) return $400d82646811fc28$var$getRadioValue(_f.refs).value;
    if ($400d82646811fc28$var$isMultipleSelect(ref)) return [
        ...ref.selectedOptions
    ].map(({ value: value1 })=>value1);
    if ($400d82646811fc28$var$isCheckBoxInput(ref)) return $400d82646811fc28$var$getCheckboxValue(_f.refs).value;
    return $400d82646811fc28$var$getFieldValueAs($400d82646811fc28$var$isUndefined(ref.value) ? _f.ref.value : ref.value, _f);
}
var $400d82646811fc28$var$getResolverOptions = (fieldsNames, _fields, criteriaMode, shouldUseNativeValidation)=>{
    const fields = {};
    for (const name of fieldsNames){
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        field && $400d82646811fc28$export$adaa4cf7ef1b65be(fields, name, field._f);
    }
    return {
        criteriaMode: criteriaMode,
        names: [
            ...fieldsNames
        ],
        fields: fields,
        shouldUseNativeValidation: shouldUseNativeValidation
    };
};
var $400d82646811fc28$var$getRuleValue = (rule)=>$400d82646811fc28$var$isUndefined(rule) ? rule : $400d82646811fc28$var$isRegex(rule) ? rule.source : $400d82646811fc28$var$isObject(rule) ? $400d82646811fc28$var$isRegex(rule.value) ? rule.value.source : rule.value : rule;
var $400d82646811fc28$var$hasValidation = (options)=>options.mount && (options.required || options.min || options.max || options.maxLength || options.minLength || options.pattern || options.validate);
function $400d82646811fc28$var$schemaErrorLookup(errors, _fields, name) {
    const error = $400d82646811fc28$export$3988ae62b71be9a3(errors, name);
    if (error || $400d82646811fc28$var$isKey(name)) return {
        error: error,
        name: name
    };
    const names = name.split(".");
    while(names.length){
        const fieldName = names.join(".");
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, fieldName);
        const foundError = $400d82646811fc28$export$3988ae62b71be9a3(errors, fieldName);
        if (field && !Array.isArray(field) && name !== fieldName) return {
            name: name
        };
        if (foundError && foundError.type) return {
            name: fieldName,
            error: foundError
        };
        names.pop();
    }
    return {
        name: name
    };
}
var $400d82646811fc28$var$skipValidation = (isBlurEvent, isTouched, isSubmitted, reValidateMode, mode)=>{
    if (mode.isOnAll) return false;
    else if (!isSubmitted && mode.isOnTouch) return !(isTouched || isBlurEvent);
    else if (isSubmitted ? reValidateMode.isOnBlur : mode.isOnBlur) return !isBlurEvent;
    else if (isSubmitted ? reValidateMode.isOnChange : mode.isOnChange) return isBlurEvent;
    return true;
};
var $400d82646811fc28$var$unsetEmptyArray = (ref, name)=>!$400d82646811fc28$var$compact($400d82646811fc28$export$3988ae62b71be9a3(ref, name)).length && $400d82646811fc28$var$unset(ref, name);
const $400d82646811fc28$var$defaultOptions = {
    mode: $400d82646811fc28$var$VALIDATION_MODE.onSubmit,
    reValidateMode: $400d82646811fc28$var$VALIDATION_MODE.onChange,
    shouldFocusError: true
};
function $400d82646811fc28$var$createFormControl(props = {}, flushRootRender) {
    let _options = {
        ...$400d82646811fc28$var$defaultOptions,
        ...props
    };
    let _formState = {
        submitCount: 0,
        isDirty: false,
        isLoading: $400d82646811fc28$var$isFunction(_options.defaultValues),
        isValidating: false,
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        touchedFields: {},
        dirtyFields: {},
        errors: {}
    };
    let _fields = {};
    let _defaultValues = $400d82646811fc28$var$isObject(_options.defaultValues) || $400d82646811fc28$var$isObject(_options.values) ? $400d82646811fc28$var$cloneObject(_options.defaultValues || _options.values) || {} : {};
    let _formValues = _options.shouldUnregister ? {} : $400d82646811fc28$var$cloneObject(_defaultValues);
    let _state = {
        action: false,
        mount: false,
        watch: false
    };
    let _names = {
        mount: new Set(),
        unMount: new Set(),
        array: new Set(),
        watch: new Set()
    };
    let delayErrorCallback;
    let timer = 0;
    const _proxyFormState = {
        isDirty: false,
        dirtyFields: false,
        touchedFields: false,
        isValidating: false,
        isValid: false,
        errors: false
    };
    const _subjects = {
        values: $400d82646811fc28$var$createSubject(),
        array: $400d82646811fc28$var$createSubject(),
        state: $400d82646811fc28$var$createSubject()
    };
    const shouldCaptureDirtyFields = props.resetOptions && props.resetOptions.keepDirtyValues;
    const validationModeBeforeSubmit = $400d82646811fc28$var$getValidationModes(_options.mode);
    const validationModeAfterSubmit = $400d82646811fc28$var$getValidationModes(_options.reValidateMode);
    const shouldDisplayAllAssociatedErrors = _options.criteriaMode === $400d82646811fc28$var$VALIDATION_MODE.all;
    const debounce = (callback)=>(wait)=>{
            clearTimeout(timer);
            timer = setTimeout(callback, wait);
        };
    const _updateValid = async (shouldUpdateValid)=>{
        if (_proxyFormState.isValid || shouldUpdateValid) {
            const isValid = _options.resolver ? $400d82646811fc28$var$isEmptyObject((await _executeSchema()).errors) : await executeBuiltInValidation(_fields, true);
            if (isValid !== _formState.isValid) _subjects.state.next({
                isValid: isValid
            });
        }
    };
    const _updateIsValidating = (value1)=>_proxyFormState.isValidating && _subjects.state.next({
            isValidating: value1
        });
    const _updateFieldArray = (name, values = [], method, args, shouldSetValues = true, shouldUpdateFieldsAndState = true)=>{
        if (args && method) {
            _state.action = true;
            if (shouldUpdateFieldsAndState && Array.isArray($400d82646811fc28$export$3988ae62b71be9a3(_fields, name))) {
                const fieldValues = method($400d82646811fc28$export$3988ae62b71be9a3(_fields, name), args.argA, args.argB);
                shouldSetValues && $400d82646811fc28$export$adaa4cf7ef1b65be(_fields, name, fieldValues);
            }
            if (shouldUpdateFieldsAndState && Array.isArray($400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, name))) {
                const errors = method($400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, name), args.argA, args.argB);
                shouldSetValues && $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, name, errors);
                $400d82646811fc28$var$unsetEmptyArray(_formState.errors, name);
            }
            if (_proxyFormState.touchedFields && shouldUpdateFieldsAndState && Array.isArray($400d82646811fc28$export$3988ae62b71be9a3(_formState.touchedFields, name))) {
                const touchedFields = method($400d82646811fc28$export$3988ae62b71be9a3(_formState.touchedFields, name), args.argA, args.argB);
                shouldSetValues && $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.touchedFields, name, touchedFields);
            }
            if (_proxyFormState.dirtyFields) _formState.dirtyFields = $400d82646811fc28$var$getDirtyFields(_defaultValues, _formValues);
            _subjects.state.next({
                name: name,
                isDirty: _getDirty(name, values),
                dirtyFields: _formState.dirtyFields,
                errors: _formState.errors,
                isValid: _formState.isValid
            });
        } else $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, values);
    };
    const updateErrors = (name, error)=>{
        $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, name, error);
        _subjects.state.next({
            errors: _formState.errors
        });
    };
    const updateValidAndValue = (name, shouldSkipSetValueAs, value1, ref)=>{
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        if (field) {
            const defaultValue = $400d82646811fc28$export$3988ae62b71be9a3(_formValues, name, $400d82646811fc28$var$isUndefined(value1) ? $400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name) : value1);
            $400d82646811fc28$var$isUndefined(defaultValue) || ref && ref.defaultChecked || shouldSkipSetValueAs ? $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, shouldSkipSetValueAs ? defaultValue : $400d82646811fc28$var$getFieldValue(field._f)) : setFieldValue(name, defaultValue);
            _state.mount && _updateValid();
        }
    };
    const updateTouchAndDirty = (name, fieldValue, isBlurEvent, shouldDirty, shouldRender)=>{
        let shouldUpdateField = false;
        let isPreviousDirty = false;
        const output = {
            name: name
        };
        if (!isBlurEvent || shouldDirty) {
            if (_proxyFormState.isDirty) {
                isPreviousDirty = _formState.isDirty;
                _formState.isDirty = output.isDirty = _getDirty();
                shouldUpdateField = isPreviousDirty !== output.isDirty;
            }
            const isCurrentFieldPristine = $400d82646811fc28$var$deepEqual($400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name), fieldValue);
            isPreviousDirty = $400d82646811fc28$export$3988ae62b71be9a3(_formState.dirtyFields, name);
            isCurrentFieldPristine ? $400d82646811fc28$var$unset(_formState.dirtyFields, name) : $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.dirtyFields, name, true);
            output.dirtyFields = _formState.dirtyFields;
            shouldUpdateField = shouldUpdateField || _proxyFormState.dirtyFields && isPreviousDirty !== !isCurrentFieldPristine;
        }
        if (isBlurEvent) {
            const isPreviousFieldTouched = $400d82646811fc28$export$3988ae62b71be9a3(_formState.touchedFields, name);
            if (!isPreviousFieldTouched) {
                $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.touchedFields, name, isBlurEvent);
                output.touchedFields = _formState.touchedFields;
                shouldUpdateField = shouldUpdateField || _proxyFormState.touchedFields && isPreviousFieldTouched !== isBlurEvent;
            }
        }
        shouldUpdateField && shouldRender && _subjects.state.next(output);
        return shouldUpdateField ? output : {};
    };
    const shouldRenderByError = (name, isValid, error, fieldState)=>{
        const previousFieldError = $400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, name);
        const shouldUpdateValid = _proxyFormState.isValid && $400d82646811fc28$var$isBoolean(isValid) && _formState.isValid !== isValid;
        if (props.delayError && error) {
            delayErrorCallback = debounce(()=>updateErrors(name, error));
            delayErrorCallback(props.delayError);
        } else {
            clearTimeout(timer);
            delayErrorCallback = null;
            error ? $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $400d82646811fc28$var$unset(_formState.errors, name);
        }
        if ((error ? !$400d82646811fc28$var$deepEqual(previousFieldError, error) : previousFieldError) || !$400d82646811fc28$var$isEmptyObject(fieldState) || shouldUpdateValid) {
            const updatedFormState = {
                ...fieldState,
                ...shouldUpdateValid && $400d82646811fc28$var$isBoolean(isValid) ? {
                    isValid: isValid
                } : {},
                errors: _formState.errors,
                name: name
            };
            _formState = {
                ..._formState,
                ...updatedFormState
            };
            _subjects.state.next(updatedFormState);
        }
        _updateIsValidating(false);
    };
    const _executeSchema = async (name)=>_options.resolver(_formValues, _options.context, $400d82646811fc28$var$getResolverOptions(name || _names.mount, _fields, _options.criteriaMode, _options.shouldUseNativeValidation));
    const executeSchemaAndUpdateState = async (names)=>{
        const { errors: errors } = await _executeSchema();
        if (names) for (const name of names){
            const error = $400d82646811fc28$export$3988ae62b71be9a3(errors, name);
            error ? $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, name, error) : $400d82646811fc28$var$unset(_formState.errors, name);
        }
        else _formState.errors = errors;
        return errors;
    };
    const executeBuiltInValidation = async (fields, shouldOnlyCheckValid, context = {
        valid: true
    })=>{
        for(const name in fields){
            const field = fields[name];
            if (field) {
                const { _f: _f, ...fieldValue } = field;
                if (_f) {
                    const isFieldArrayRoot = _names.array.has(_f.name);
                    const fieldError = await $400d82646811fc28$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation && !shouldOnlyCheckValid, isFieldArrayRoot);
                    if (fieldError[_f.name]) {
                        context.valid = false;
                        if (shouldOnlyCheckValid) break;
                    }
                    !shouldOnlyCheckValid && ($400d82646811fc28$export$3988ae62b71be9a3(fieldError, _f.name) ? isFieldArrayRoot ? $400d82646811fc28$var$updateFieldArrayRootError(_formState.errors, fieldError, _f.name) : $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, _f.name, fieldError[_f.name]) : $400d82646811fc28$var$unset(_formState.errors, _f.name));
                }
                fieldValue && await executeBuiltInValidation(fieldValue, shouldOnlyCheckValid, context);
            }
        }
        return context.valid;
    };
    const _removeUnmounted = ()=>{
        for (const name of _names.unMount){
            const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
            field && (field._f.refs ? field._f.refs.every((ref)=>!$400d82646811fc28$var$live(ref)) : !$400d82646811fc28$var$live(field._f.ref)) && unregister(name);
        }
        _names.unMount = new Set();
    };
    const _getDirty = (name, data)=>(name && data && $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, data), !$400d82646811fc28$var$deepEqual(getValues(), _defaultValues));
    const _getWatch = (names, defaultValue, isGlobal)=>$400d82646811fc28$var$generateWatchOutput(names, _names, {
            ..._state.mount ? _formValues : $400d82646811fc28$var$isUndefined(defaultValue) ? _defaultValues : $400d82646811fc28$var$isString(names) ? {
                [names]: defaultValue
            } : defaultValue
        }, isGlobal, defaultValue);
    const _getFieldArray = (name)=>$400d82646811fc28$var$compact($400d82646811fc28$export$3988ae62b71be9a3(_state.mount ? _formValues : _defaultValues, name, props.shouldUnregister ? $400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name, []) : []));
    const setFieldValue = (name, value1, options = {})=>{
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        let fieldValue = value1;
        if (field) {
            const fieldReference = field._f;
            if (fieldReference) {
                !fieldReference.disabled && $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, $400d82646811fc28$var$getFieldValueAs(value1, fieldReference));
                fieldValue = $400d82646811fc28$var$isHTMLElement(fieldReference.ref) && $400d82646811fc28$var$isNullOrUndefined(value1) ? "" : value1;
                if ($400d82646811fc28$var$isMultipleSelect(fieldReference.ref)) [
                    ...fieldReference.ref.options
                ].forEach((optionRef)=>optionRef.selected = fieldValue.includes(optionRef.value));
                else if (fieldReference.refs) {
                    if ($400d82646811fc28$var$isCheckBoxInput(fieldReference.ref)) fieldReference.refs.length > 1 ? fieldReference.refs.forEach((checkboxRef)=>(!checkboxRef.defaultChecked || !checkboxRef.disabled) && (checkboxRef.checked = Array.isArray(fieldValue) ? !!fieldValue.find((data)=>data === checkboxRef.value) : fieldValue === checkboxRef.value)) : fieldReference.refs[0] && (fieldReference.refs[0].checked = !!fieldValue);
                    else fieldReference.refs.forEach((radioRef)=>radioRef.checked = radioRef.value === fieldValue);
                } else if ($400d82646811fc28$var$isFileInput(fieldReference.ref)) fieldReference.ref.value = "";
                else {
                    fieldReference.ref.value = fieldValue;
                    if (!fieldReference.ref.type) _subjects.values.next({
                        name: name,
                        values: {
                            ..._formValues
                        }
                    });
                }
            }
        }
        (options.shouldDirty || options.shouldTouch) && updateTouchAndDirty(name, fieldValue, options.shouldTouch, options.shouldDirty, true);
        options.shouldValidate && trigger(name);
    };
    const setValues = (name, value1, options)=>{
        for(const fieldKey in value1){
            const fieldValue = value1[fieldKey];
            const fieldName = `${name}.${fieldKey}`;
            const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, fieldName);
            (_names.array.has(name) || !$400d82646811fc28$var$isPrimitive(fieldValue) || field && !field._f) && !$400d82646811fc28$var$isDateObject(fieldValue) ? setValues(fieldName, fieldValue, options) : setFieldValue(fieldName, fieldValue, options);
        }
    };
    const setValue = (name, value1, options = {})=>{
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        const isFieldArray = _names.array.has(name);
        const cloneValue = $400d82646811fc28$var$cloneObject(value1);
        $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, cloneValue);
        if (isFieldArray) {
            _subjects.array.next({
                name: name,
                values: {
                    ..._formValues
                }
            });
            if ((_proxyFormState.isDirty || _proxyFormState.dirtyFields) && options.shouldDirty) _subjects.state.next({
                name: name,
                dirtyFields: $400d82646811fc28$var$getDirtyFields(_defaultValues, _formValues),
                isDirty: _getDirty(name, cloneValue)
            });
        } else field && !field._f && !$400d82646811fc28$var$isNullOrUndefined(cloneValue) ? setValues(name, cloneValue, options) : setFieldValue(name, cloneValue, options);
        $400d82646811fc28$var$isWatched(name, _names) && _subjects.state.next({
            ..._formState
        });
        _subjects.values.next({
            name: name,
            values: {
                ..._formValues
            }
        });
        !_state.mount && flushRootRender();
    };
    const onChange = async (event)=>{
        const target = event.target;
        let name = target.name;
        let isFieldValueUpdated = true;
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        const getCurrentFieldValue = ()=>target.type ? $400d82646811fc28$var$getFieldValue(field._f) : $400d82646811fc28$var$getEventValue(event);
        if (field) {
            let error;
            let isValid;
            const fieldValue = getCurrentFieldValue();
            const isBlurEvent = event.type === $400d82646811fc28$var$EVENTS.BLUR || event.type === $400d82646811fc28$var$EVENTS.FOCUS_OUT;
            const shouldSkipValidation = !$400d82646811fc28$var$hasValidation(field._f) && !_options.resolver && !$400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, name) && !field._f.deps || $400d82646811fc28$var$skipValidation(isBlurEvent, $400d82646811fc28$export$3988ae62b71be9a3(_formState.touchedFields, name), _formState.isSubmitted, validationModeAfterSubmit, validationModeBeforeSubmit);
            const watched = $400d82646811fc28$var$isWatched(name, _names, isBlurEvent);
            $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, fieldValue);
            if (isBlurEvent) {
                field._f.onBlur && field._f.onBlur(event);
                delayErrorCallback && delayErrorCallback(0);
            } else if (field._f.onChange) field._f.onChange(event);
            const fieldState = updateTouchAndDirty(name, fieldValue, isBlurEvent, false);
            const shouldRender = !$400d82646811fc28$var$isEmptyObject(fieldState) || watched;
            !isBlurEvent && _subjects.values.next({
                name: name,
                type: event.type,
                values: {
                    ..._formValues
                }
            });
            if (shouldSkipValidation) {
                _proxyFormState.isValid && _updateValid();
                return shouldRender && _subjects.state.next({
                    name: name,
                    ...watched ? {} : fieldState
                });
            }
            !isBlurEvent && watched && _subjects.state.next({
                ..._formState
            });
            _updateIsValidating(true);
            if (_options.resolver) {
                const { errors: errors } = await _executeSchema([
                    name
                ]);
                const previousErrorLookupResult = $400d82646811fc28$var$schemaErrorLookup(_formState.errors, _fields, name);
                const errorLookupResult = $400d82646811fc28$var$schemaErrorLookup(errors, _fields, previousErrorLookupResult.name || name);
                error = errorLookupResult.error;
                name = errorLookupResult.name;
                isValid = $400d82646811fc28$var$isEmptyObject(errors);
            } else {
                error = (await $400d82646811fc28$var$validateField(field, _formValues, shouldDisplayAllAssociatedErrors, _options.shouldUseNativeValidation))[name];
                isFieldValueUpdated = isNaN(fieldValue) || fieldValue === $400d82646811fc28$export$3988ae62b71be9a3(_formValues, name, fieldValue);
                if (isFieldValueUpdated) {
                    if (error) isValid = false;
                    else if (_proxyFormState.isValid) isValid = await executeBuiltInValidation(_fields, true);
                }
            }
            if (isFieldValueUpdated) {
                field._f.deps && trigger(field._f.deps);
                shouldRenderByError(name, isValid, error, fieldState);
            }
        }
    };
    const trigger = async (name, options = {})=>{
        let isValid;
        let validationResult;
        const fieldNames = $400d82646811fc28$var$convertToArrayPayload(name);
        _updateIsValidating(true);
        if (_options.resolver) {
            const errors = await executeSchemaAndUpdateState($400d82646811fc28$var$isUndefined(name) ? name : fieldNames);
            isValid = $400d82646811fc28$var$isEmptyObject(errors);
            validationResult = name ? !fieldNames.some((name)=>$400d82646811fc28$export$3988ae62b71be9a3(errors, name)) : isValid;
        } else if (name) {
            validationResult = (await Promise.all(fieldNames.map(async (fieldName)=>{
                const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, fieldName);
                return await executeBuiltInValidation(field && field._f ? {
                    [fieldName]: field
                } : field);
            }))).every(Boolean);
            !(!validationResult && !_formState.isValid) && _updateValid();
        } else validationResult = isValid = await executeBuiltInValidation(_fields);
        _subjects.state.next({
            ...!$400d82646811fc28$var$isString(name) || _proxyFormState.isValid && isValid !== _formState.isValid ? {} : {
                name: name
            },
            ..._options.resolver || !name ? {
                isValid: isValid
            } : {},
            errors: _formState.errors,
            isValidating: false
        });
        options.shouldFocus && !validationResult && $400d82646811fc28$var$focusFieldBy(_fields, (key)=>key && $400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, key), name ? fieldNames : _names.mount);
        return validationResult;
    };
    const getValues = (fieldNames)=>{
        const values = {
            ..._defaultValues,
            ..._state.mount ? _formValues : {}
        };
        return $400d82646811fc28$var$isUndefined(fieldNames) ? values : $400d82646811fc28$var$isString(fieldNames) ? $400d82646811fc28$export$3988ae62b71be9a3(values, fieldNames) : fieldNames.map((name)=>$400d82646811fc28$export$3988ae62b71be9a3(values, name));
    };
    const getFieldState = (name, formState)=>({
            invalid: !!$400d82646811fc28$export$3988ae62b71be9a3((formState || _formState).errors, name),
            isDirty: !!$400d82646811fc28$export$3988ae62b71be9a3((formState || _formState).dirtyFields, name),
            isTouched: !!$400d82646811fc28$export$3988ae62b71be9a3((formState || _formState).touchedFields, name),
            error: $400d82646811fc28$export$3988ae62b71be9a3((formState || _formState).errors, name)
        });
    const clearErrors = (name)=>{
        name && $400d82646811fc28$var$convertToArrayPayload(name).forEach((inputName)=>$400d82646811fc28$var$unset(_formState.errors, inputName));
        _subjects.state.next({
            errors: name ? _formState.errors : {}
        });
    };
    const setError = (name, error, options)=>{
        const ref = ($400d82646811fc28$export$3988ae62b71be9a3(_fields, name, {
            _f: {}
        })._f || {}).ref;
        $400d82646811fc28$export$adaa4cf7ef1b65be(_formState.errors, name, {
            ...error,
            ref: ref
        });
        _subjects.state.next({
            name: name,
            errors: _formState.errors,
            isValid: false
        });
        options && options.shouldFocus && ref && ref.focus && ref.focus();
    };
    const watch = (name, defaultValue)=>$400d82646811fc28$var$isFunction(name) ? _subjects.values.subscribe({
            next: (payload)=>name(_getWatch(undefined, defaultValue), payload)
        }) : _getWatch(name, defaultValue, true);
    const unregister = (name, options = {})=>{
        for (const fieldName of name ? $400d82646811fc28$var$convertToArrayPayload(name) : _names.mount){
            _names.mount.delete(fieldName);
            _names.array.delete(fieldName);
            if (!options.keepValue) {
                $400d82646811fc28$var$unset(_fields, fieldName);
                $400d82646811fc28$var$unset(_formValues, fieldName);
            }
            !options.keepError && $400d82646811fc28$var$unset(_formState.errors, fieldName);
            !options.keepDirty && $400d82646811fc28$var$unset(_formState.dirtyFields, fieldName);
            !options.keepTouched && $400d82646811fc28$var$unset(_formState.touchedFields, fieldName);
            !_options.shouldUnregister && !options.keepDefaultValue && $400d82646811fc28$var$unset(_defaultValues, fieldName);
        }
        _subjects.values.next({
            values: {
                ..._formValues
            }
        });
        _subjects.state.next({
            ..._formState,
            ...!options.keepDirty ? {} : {
                isDirty: _getDirty()
            }
        });
        !options.keepIsValid && _updateValid();
    };
    const register = (name, options = {})=>{
        let field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        const disabledIsDefined = $400d82646811fc28$var$isBoolean(options.disabled);
        $400d82646811fc28$export$adaa4cf7ef1b65be(_fields, name, {
            ...field || {},
            _f: {
                ...field && field._f ? field._f : {
                    ref: {
                        name: name
                    }
                },
                name: name,
                mount: true,
                ...options
            }
        });
        _names.mount.add(name);
        field ? disabledIsDefined && $400d82646811fc28$export$adaa4cf7ef1b65be(_formValues, name, options.disabled ? undefined : $400d82646811fc28$export$3988ae62b71be9a3(_formValues, name, $400d82646811fc28$var$getFieldValue(field._f))) : updateValidAndValue(name, true, options.value);
        return {
            ...disabledIsDefined ? {
                disabled: options.disabled
            } : {},
            ..._options.shouldUseNativeValidation ? {
                required: !!options.required,
                min: $400d82646811fc28$var$getRuleValue(options.min),
                max: $400d82646811fc28$var$getRuleValue(options.max),
                minLength: $400d82646811fc28$var$getRuleValue(options.minLength),
                maxLength: $400d82646811fc28$var$getRuleValue(options.maxLength),
                pattern: $400d82646811fc28$var$getRuleValue(options.pattern)
            } : {},
            name: name,
            onChange: onChange,
            onBlur: onChange,
            ref: (ref)=>{
                if (ref) {
                    register(name, options);
                    field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
                    const fieldRef = $400d82646811fc28$var$isUndefined(ref.value) ? ref.querySelectorAll ? ref.querySelectorAll("input,select,textarea")[0] || ref : ref : ref;
                    const radioOrCheckbox = $400d82646811fc28$var$isRadioOrCheckbox(fieldRef);
                    const refs = field._f.refs || [];
                    if (radioOrCheckbox ? refs.find((option)=>option === fieldRef) : fieldRef === field._f.ref) return;
                    $400d82646811fc28$export$adaa4cf7ef1b65be(_fields, name, {
                        _f: {
                            ...field._f,
                            ...radioOrCheckbox ? {
                                refs: [
                                    ...refs.filter($400d82646811fc28$var$live),
                                    fieldRef,
                                    ...Array.isArray($400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name)) ? [
                                        {}
                                    ] : []
                                ],
                                ref: {
                                    type: fieldRef.type,
                                    name: name
                                }
                            } : {
                                ref: fieldRef
                            }
                        }
                    });
                    updateValidAndValue(name, false, undefined, fieldRef);
                } else {
                    field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name, {});
                    if (field._f) field._f.mount = false;
                    (_options.shouldUnregister || options.shouldUnregister) && !($400d82646811fc28$var$isNameInFieldArray(_names.array, name) && _state.action) && _names.unMount.add(name);
                }
            }
        };
    };
    const _focusError = ()=>_options.shouldFocusError && $400d82646811fc28$var$focusFieldBy(_fields, (key)=>key && $400d82646811fc28$export$3988ae62b71be9a3(_formState.errors, key), _names.mount);
    const handleSubmit = (onValid, onInvalid)=>async (e)=>{
            if (e) {
                e.preventDefault && e.preventDefault();
                e.persist && e.persist();
            }
            let fieldValues = $400d82646811fc28$var$cloneObject(_formValues);
            _subjects.state.next({
                isSubmitting: true
            });
            if (_options.resolver) {
                const { errors: errors, values: values } = await _executeSchema();
                _formState.errors = errors;
                fieldValues = values;
            } else await executeBuiltInValidation(_fields);
            $400d82646811fc28$var$unset(_formState.errors, "root");
            if ($400d82646811fc28$var$isEmptyObject(_formState.errors)) {
                _subjects.state.next({
                    errors: {}
                });
                await onValid(fieldValues, e);
            } else {
                if (onInvalid) await onInvalid({
                    ..._formState.errors
                }, e);
                _focusError();
                setTimeout(_focusError);
            }
            _subjects.state.next({
                isSubmitted: true,
                isSubmitting: false,
                isSubmitSuccessful: $400d82646811fc28$var$isEmptyObject(_formState.errors),
                submitCount: _formState.submitCount + 1,
                errors: _formState.errors
            });
        };
    const resetField = (name, options = {})=>{
        if ($400d82646811fc28$export$3988ae62b71be9a3(_fields, name)) {
            if ($400d82646811fc28$var$isUndefined(options.defaultValue)) setValue(name, $400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name));
            else {
                setValue(name, options.defaultValue);
                $400d82646811fc28$export$adaa4cf7ef1b65be(_defaultValues, name, options.defaultValue);
            }
            if (!options.keepTouched) $400d82646811fc28$var$unset(_formState.touchedFields, name);
            if (!options.keepDirty) {
                $400d82646811fc28$var$unset(_formState.dirtyFields, name);
                _formState.isDirty = options.defaultValue ? _getDirty(name, $400d82646811fc28$export$3988ae62b71be9a3(_defaultValues, name)) : _getDirty();
            }
            if (!options.keepError) {
                $400d82646811fc28$var$unset(_formState.errors, name);
                _proxyFormState.isValid && _updateValid();
            }
            _subjects.state.next({
                ..._formState
            });
        }
    };
    const _reset = (formValues, keepStateOptions = {})=>{
        const updatedValues = formValues || _defaultValues;
        const cloneUpdatedValues = $400d82646811fc28$var$cloneObject(updatedValues);
        const values = formValues && !$400d82646811fc28$var$isEmptyObject(formValues) ? cloneUpdatedValues : _defaultValues;
        if (!keepStateOptions.keepDefaultValues) _defaultValues = updatedValues;
        if (!keepStateOptions.keepValues) {
            if (keepStateOptions.keepDirtyValues || shouldCaptureDirtyFields) for (const fieldName of _names.mount)$400d82646811fc28$export$3988ae62b71be9a3(_formState.dirtyFields, fieldName) ? $400d82646811fc28$export$adaa4cf7ef1b65be(values, fieldName, $400d82646811fc28$export$3988ae62b71be9a3(_formValues, fieldName)) : setValue(fieldName, $400d82646811fc28$export$3988ae62b71be9a3(values, fieldName));
            else {
                if ($400d82646811fc28$var$isWeb && $400d82646811fc28$var$isUndefined(formValues)) for (const name of _names.mount){
                    const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
                    if (field && field._f) {
                        const fieldReference = Array.isArray(field._f.refs) ? field._f.refs[0] : field._f.ref;
                        if ($400d82646811fc28$var$isHTMLElement(fieldReference)) {
                            const form = fieldReference.closest("form");
                            if (form) {
                                form.reset();
                                break;
                            }
                        }
                    }
                }
                _fields = {};
            }
            _formValues = props.shouldUnregister ? keepStateOptions.keepDefaultValues ? $400d82646811fc28$var$cloneObject(_defaultValues) : {} : cloneUpdatedValues;
            _subjects.array.next({
                values: {
                    ...values
                }
            });
            _subjects.values.next({
                values: {
                    ...values
                }
            });
        }
        _names = {
            mount: new Set(),
            unMount: new Set(),
            array: new Set(),
            watch: new Set(),
            watchAll: false,
            focus: ""
        };
        !_state.mount && flushRootRender();
        _state.mount = !_proxyFormState.isValid || !!keepStateOptions.keepIsValid;
        _state.watch = !!props.shouldUnregister;
        _subjects.state.next({
            submitCount: keepStateOptions.keepSubmitCount ? _formState.submitCount : 0,
            isDirty: keepStateOptions.keepDirty ? _formState.isDirty : !!(keepStateOptions.keepDefaultValues && !$400d82646811fc28$var$deepEqual(formValues, _defaultValues)),
            isSubmitted: keepStateOptions.keepIsSubmitted ? _formState.isSubmitted : false,
            dirtyFields: keepStateOptions.keepDirtyValues ? _formState.dirtyFields : keepStateOptions.keepDefaultValues && formValues ? $400d82646811fc28$var$getDirtyFields(_defaultValues, formValues) : {},
            touchedFields: keepStateOptions.keepTouched ? _formState.touchedFields : {},
            errors: keepStateOptions.keepErrors ? _formState.errors : {},
            isSubmitting: false,
            isSubmitSuccessful: false
        });
    };
    const reset = (formValues, keepStateOptions)=>_reset($400d82646811fc28$var$isFunction(formValues) ? formValues(_formValues) : formValues, keepStateOptions);
    const setFocus = (name, options = {})=>{
        const field = $400d82646811fc28$export$3988ae62b71be9a3(_fields, name);
        const fieldReference = field && field._f;
        if (fieldReference) {
            const fieldRef = fieldReference.refs ? fieldReference.refs[0] : fieldReference.ref;
            if (fieldRef.focus) {
                fieldRef.focus();
                options.shouldSelect && fieldRef.select();
            }
        }
    };
    const _updateFormState = (updatedFormState)=>{
        _formState = {
            ..._formState,
            ...updatedFormState
        };
    };
    const _resetDefaultValues = ()=>$400d82646811fc28$var$isFunction(_options.defaultValues) && _options.defaultValues().then((values)=>{
            reset(values, _options.resetOptions);
            _subjects.state.next({
                isLoading: false
            });
        });
    return {
        control: {
            register: register,
            unregister: unregister,
            getFieldState: getFieldState,
            _executeSchema: _executeSchema,
            _getWatch: _getWatch,
            _getDirty: _getDirty,
            _updateValid: _updateValid,
            _removeUnmounted: _removeUnmounted,
            _updateFieldArray: _updateFieldArray,
            _getFieldArray: _getFieldArray,
            _reset: _reset,
            _resetDefaultValues: _resetDefaultValues,
            _updateFormState: _updateFormState,
            _subjects: _subjects,
            _proxyFormState: _proxyFormState,
            get _fields () {
                return _fields;
            },
            get _formValues () {
                return _formValues;
            },
            get _state () {
                return _state;
            },
            set _state (value){
                _state = value;
            },
            get _defaultValues () {
                return _defaultValues;
            },
            get _names () {
                return _names;
            },
            set _names (value){
                _names = value;
            },
            get _formState () {
                return _formState;
            },
            set _formState (value){
                _formState = value;
            },
            get _options () {
                return _options;
            },
            set _options (value){
                _options = {
                    ..._options,
                    ...value
                };
            }
        },
        trigger: trigger,
        register: register,
        handleSubmit: handleSubmit,
        watch: watch,
        setValue: setValue,
        getValues: getValues,
        reset: reset,
        resetField: resetField,
        clearErrors: clearErrors,
        unregister: unregister,
        setError: setError,
        setFocus: setFocus,
        getFieldState: getFieldState
    };
}
/**
 * Custom hook to manage the entire form.
 *
 * @remarks
 * [API](https://react-hook-form.com/api/useform) • [Demo](https://codesandbox.io/s/react-hook-form-get-started-ts-5ksmm) • [Video](https://www.youtube.com/watch?v=RkXv4AXXC_4)
 *
 * @param props - form configuration and validation parameters.
 *
 * @returns methods - individual functions to manage the form state. {@link UseFormReturn}
 *
 * @example
 * ```tsx
 * function App() {
 *   const { register, handleSubmit, watch, formState: { errors } } = useForm();
 *   const onSubmit = data => console.log(data);
 *
 *   console.log(watch("example"));
 *
 *   return (
 *     <form onSubmit={handleSubmit(onSubmit)}>
 *       <input defaultValue="test" {...register("example")} />
 *       <input {...register("exampleRequired", { required: true })} />
 *       {errors.exampleRequired && <span>This field is required</span>}
 *       <input type="submit" />
 *     </form>
 *   );
 * }
 * ```
 */ function $400d82646811fc28$export$87c0cf8eb5a167e0(props = {}) {
    const _formControl = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useRef();
    const [formState, updateFormState] = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useState({
        isDirty: false,
        isValidating: false,
        isLoading: $400d82646811fc28$var$isFunction(props.defaultValues),
        isSubmitted: false,
        isSubmitting: false,
        isSubmitSuccessful: false,
        isValid: false,
        submitCount: 0,
        dirtyFields: {},
        touchedFields: {},
        errors: {},
        defaultValues: $400d82646811fc28$var$isFunction(props.defaultValues) ? undefined : props.defaultValues
    });
    if (!_formControl.current) _formControl.current = {
        ...$400d82646811fc28$var$createFormControl(props, ()=>updateFormState((formState)=>({
                    ...formState
                }))),
        formState: formState
    };
    const control = _formControl.current.control;
    control._options = props;
    $400d82646811fc28$var$useSubscribe({
        subject: control._subjects.state,
        next: (value1)=>{
            if ($400d82646811fc28$var$shouldRenderFormState(value1, control._proxyFormState, control._updateFormState, true)) updateFormState({
                ...control._formState
            });
        }
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        if (props.values && !$400d82646811fc28$var$deepEqual(props.values, control._defaultValues)) control._reset(props.values, control._options.resetOptions);
        else control._resetDefaultValues();
    }, [
        props.values,
        control
    ]);
    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useEffect(()=>{
        if (!control._state.mount) {
            control._updateValid();
            control._state.mount = true;
        }
        if (control._state.watch) {
            control._state.watch = false;
            control._subjects.state.next({
                ...control._formState
            });
        }
        control._removeUnmounted();
    });
    _formControl.current.formState = $400d82646811fc28$var$getProxyFormState(formState, control);
    return _formControl.current;
}

});

parcelRequire.register("5Yzj4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d5a48649f6fb0dfc$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
/**
 * The component to render a raw component when a single translate key is not enough.
 *
 * It is not dangerous for rendering, but it may cause unexpected behavior if the content
 * is intended to be translated.
 */ function $d5a48649f6fb0dfc$var$DangerousRaw({ children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: children
    });
}
var $d5a48649f6fb0dfc$export$2e2bcd8739ae039 = $d5a48649f6fb0dfc$var$DangerousRaw;

});

parcelRequire.register("dADBR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $415dff0ec3043603$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $ds4Cq = parcelRequire("ds4Cq");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");

var $3MzPh = parcelRequire("3MzPh");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");

var $6ReZL = parcelRequire("6ReZL");
function $415dff0ec3043603$var$FormField({ title: title, children: children, isRequired: isRequired, isMultiple: isMultiple, className: className, headlineSpacing: headlineSpacing = "default", tip: tip, headlineClassName: headlineClassName }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($6ReZL.field, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($6ReZL.headline, headlineSpacing === "large" && $6ReZL.withLargeSpacing, headlineClassName),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $6ReZL.title,
                        children: [
                            typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: title
                            }) : title,
                            isMultiple && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                className: $6ReZL.multiple,
                                children: t("general.multiple_form_field")
                            })
                        ]
                    }),
                    tip && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                        anchorClassName: $6ReZL.toggleTipButton,
                        content: tip,
                        horizontalAlign: "start",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                    isRequired && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $6ReZL.required,
                        children: t("general.required")
                    })
                ]
            }),
            children
        ]
    });
}
var $415dff0ec3043603$export$2e2bcd8739ae039 = $415dff0ec3043603$var$FormField;

});
parcelRequire.register("ds4Cq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $18032e9936bab475$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $18032e9936bab475$var$SvgTip = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8 7.333A.667.667 0 0 0 7.333 8v2.667a.667.667 0 1 0 1.334 0V8A.667.667 0 0 0 8 7.333Zm.253-2.613a.667.667 0 0 0-.506 0 .667.667 0 0 0-.22.14.767.767 0 0 0-.14.22.667.667 0 0 0 .14.727c.064.059.139.106.22.14a.667.667 0 0 0 .92-.614.7.7 0 0 0-.194-.473.667.667 0 0 0-.22-.14ZM8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.334 5.334 0 1 1 8 2.666a5.334 5.334 0 0 1 0 10.667Z",
            fill: "currentColor"
        })
    });
var $18032e9936bab475$export$2e2bcd8739ae039 = $18032e9936bab475$var$SvgTip;

});

parcelRequire.register("hA6MC", function(module, exports) {

$parcel$export(module.exports, "Tooltip", function () { return (parcelRequire("4v6om")).default; });
$parcel$export(module.exports, "ToggleTip", function () { return (parcelRequire("bf05n")).default; });

var $4v6om = parcelRequire("4v6om");

var $bf05n = parcelRequire("bf05n");

});
parcelRequire.register("4v6om", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $34489a24d076bb70$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $iVz18 = parcelRequire("iVz18");

var $1pqtO = parcelRequire("1pqtO");

var $lydCh = parcelRequire("lydCh");

var $kz136 = parcelRequire("kz136");

var $dSFEk = parcelRequire("dSFEk");
function $34489a24d076bb70$var$Tooltip({ className: className, isKeepOpen: isKeepOpen = false, isSuccessful: isSuccessful = false, placement: placement = "top", horizontalAlign: horizontalAlign = "center", anchorClassName: anchorClassName, children: children, content: content }) {
    const [tooltipDom, setTooltipDom] = (0, $eCoWV.useState)();
    const anchorRef = (0, $eCoWV.useRef)(null);
    const tooltipRef = (0, $eCoWV.useRef)(null);
    const { position: position, positionState: positionState, mutate: mutate } = (0, $1pqtO.default)({
        verticalAlign: (0, $kz136.getVerticalAlignment)(placement),
        horizontalAlign: (0, $kz136.getHorizontalAlignment)(placement, horizontalAlign),
        offset: {
            vertical: (0, $kz136.getVerticalOffset)(placement),
            horizontal: (0, $kz136.getHorizontalOffset)(placement, horizontalAlign)
        },
        anchorRef: anchorRef,
        overlayRef: tooltipRef
    });
    const [isVisible, setIsVisible] = (0, $eCoWV.useState)(false);
    (0, $eCoWV.useEffect)(()=>{
        if (!isVisible) return;
        const mutateAnimationFrame = requestAnimationFrame(()=>{
            mutate();
        });
        return ()=>{
            cancelAnimationFrame(mutateAnimationFrame);
        };
    }, [
        isVisible,
        mutate
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!anchorRef.current) return;
        if (isKeepOpen) {
            setIsVisible(true);
            return;
        }
        const dom = anchorRef.current;
        const enterHandler = ()=>{
            if (!isVisible) setIsVisible(true);
        };
        const leaveHandler = ()=>{
            setIsVisible(false);
        };
        dom.addEventListener("mouseenter", enterHandler);
        dom.addEventListener("mouseleave", leaveHandler);
        return ()=>{
            dom.removeEventListener("mouseenter", enterHandler);
            dom.removeEventListener("mouseleave", leaveHandler);
        };
    }, [
        anchorRef,
        isVisible,
        isKeepOpen
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!isVisible) {
            if (tooltipDom) {
                tooltipDom.remove();
                setTooltipDom(undefined);
            }
            return;
        }
        if (!tooltipDom) {
            const dom = document.createElement("div");
            document.body.append(dom);
            setTooltipDom(dom);
        }
        return ()=>tooltipDom?.remove();
    }, [
        isVisible,
        tooltipDom
    ]);
    (0, $eCoWV.useLayoutEffect)(()=>{
        mutate();
    }, [
        mutate,
        content
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                ref: anchorRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($dSFEk.anchor, anchorClassName),
                children: children
            }),
            tooltipDom && content && /*#__PURE__*/ (0, $iVz18.createPortal)(/*#__PURE__*/ (0, $9zeGj.jsx)((0, $lydCh.default), {
                ref: tooltipRef,
                anchorRef: anchorRef,
                className: className,
                position: position,
                placement: placement,
                horizontalAlignment: positionState.horizontalAlign,
                isSuccessful: isSuccessful,
                children: content
            }), tooltipDom)
        ]
    });
}
var $34489a24d076bb70$export$2e2bcd8739ae039 = $34489a24d076bb70$var$Tooltip;

});
parcelRequire.register("1pqtO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0aa9f5f7c7daa932$export$2e2bcd8739ae039; });

var $eCoWV = parcelRequire("eCoWV");
// Leave space for box-shadow effect.
const $0aa9f5f7c7daa932$var$windowSafePadding = 12;
const $0aa9f5f7c7daa932$var$selectVerticalAlignment = ({ verticalAlign: verticalAlign, verticalTop: verticalTop, verticalMiddle: verticalMiddle, verticalBottom: verticalBottom, overlayHeight: overlayHeight })=>{
    const minY = $0aa9f5f7c7daa932$var$windowSafePadding;
    const maxY = window.innerHeight - $0aa9f5f7c7daa932$var$windowSafePadding;
    const isTopAllowed = verticalTop >= minY;
    const isCenterAllowed = verticalMiddle - overlayHeight / 2 >= minY && verticalMiddle + overlayHeight / 2 <= maxY;
    const isBottomAllowed = verticalBottom + overlayHeight <= maxY;
    switch(verticalAlign){
        case "top":
            if (isTopAllowed) return "top";
            if (isBottomAllowed) return "bottom";
            if (isCenterAllowed) return "middle";
            return verticalAlign;
        case "middle":
            if (isCenterAllowed) return "middle";
            if (isTopAllowed) return "top";
            if (isBottomAllowed) return "bottom";
            return verticalAlign;
        case "bottom":
            if (isBottomAllowed) return "bottom";
            if (isTopAllowed) return "top";
            if (isCenterAllowed) return "middle";
            return verticalAlign;
        default:
            return verticalAlign;
    }
};
const $0aa9f5f7c7daa932$var$selectHorizontalAlignment = ({ horizontalAlign: horizontalAlign, horizontalStart: horizontalStart, horizontalCenter: horizontalCenter, horizontalEnd: horizontalEnd, overlayWidth: overlayWidth })=>{
    const minX = $0aa9f5f7c7daa932$var$windowSafePadding;
    const maxX = window.innerWidth - $0aa9f5f7c7daa932$var$windowSafePadding;
    const isStartAllowed = horizontalStart + overlayWidth <= maxX;
    const isCenterAllowed = horizontalCenter - overlayWidth / 2 >= minX && horizontalCenter + overlayWidth / 2 <= maxX;
    const isEndAllowed = horizontalEnd >= minX;
    switch(horizontalAlign){
        case "start":
            if (isStartAllowed) return "start";
            if (isEndAllowed) return "end";
            if (isCenterAllowed) return "center";
            return horizontalAlign;
        case "center":
            if (isCenterAllowed) return "center";
            if (isStartAllowed) return "start";
            if (isEndAllowed) return "end";
            return horizontalAlign;
        case "end":
            if (isEndAllowed) return "end";
            if (isStartAllowed) return "start";
            if (isCenterAllowed) return "center";
            return horizontalAlign;
        default:
            return horizontalAlign;
    }
};
function $0aa9f5f7c7daa932$export$2e2bcd8739ae039({ verticalAlign: verticalAlign, horizontalAlign: horizontalAlign, offset: offset, anchorRef: anchorRef, overlayRef: overlayRef }) {
    const [position, setPosition] = (0, $eCoWV.useState)();
    const [currentVerticalAlign, setCurrentVerticalAlign] = (0, $eCoWV.useState)(verticalAlign);
    const [currentHorizontalAlign, setCurrentHorizontalAlign] = (0, $eCoWV.useState)(horizontalAlign);
    const updatePosition = (0, $eCoWV.useCallback)(()=>{
        if (!anchorRef.current || !overlayRef.current) return;
        const anchorRect = anchorRef.current.getBoundingClientRect();
        const overlayRect = overlayRef.current.getBoundingClientRect();
        const verticalTop = anchorRect.y - overlayRect.height + offset.vertical;
        const verticalMiddle = anchorRect.y + anchorRect.height / 2 - overlayRect.height / 2 + offset.vertical;
        const verticalBottom = anchorRect.y + anchorRect.height + offset.vertical;
        const verticalPositionMap = {
            top: verticalTop,
            middle: verticalMiddle,
            bottom: verticalBottom
        };
        const horizontalStart = anchorRect.x + offset.horizontal;
        const horizontalCenter = anchorRect.x + anchorRect.width / 2 - overlayRect.width / 2 + offset.horizontal;
        const horizontalEnd = anchorRect.x + anchorRect.width - overlayRect.width + offset.horizontal;
        const horizontalPositionMap = {
            start: horizontalStart,
            center: horizontalCenter,
            end: horizontalEnd
        };
        const selectedVerticalAlign = $0aa9f5f7c7daa932$var$selectVerticalAlignment({
            verticalAlign: verticalAlign,
            verticalTop: verticalTop,
            verticalMiddle: verticalMiddle,
            verticalBottom: verticalBottom,
            overlayHeight: overlayRect.height
        });
        const selectedHorizontalAlign = $0aa9f5f7c7daa932$var$selectHorizontalAlignment({
            horizontalAlign: horizontalAlign,
            horizontalStart: horizontalStart,
            horizontalCenter: horizontalCenter,
            horizontalEnd: horizontalEnd,
            overlayWidth: overlayRect.width
        });
        setCurrentVerticalAlign(selectedVerticalAlign);
        setCurrentHorizontalAlign(selectedHorizontalAlign);
        setPosition({
            top: verticalPositionMap[selectedVerticalAlign],
            left: horizontalPositionMap[selectedHorizontalAlign]
        });
    }, [
        anchorRef,
        horizontalAlign,
        offset.vertical,
        offset.horizontal,
        overlayRef,
        verticalAlign
    ]);
    (0, $eCoWV.useEffect)(()=>{
        updatePosition();
        window.addEventListener("resize", updatePosition);
        window.addEventListener("scroll", updatePosition);
        return ()=>{
            window.removeEventListener("resize", updatePosition);
            window.removeEventListener("scroll", updatePosition);
        };
    }, [
        updatePosition
    ]);
    return {
        position: position,
        mutate: updatePosition,
        positionState: {
            verticalAlign: currentVerticalAlign,
            horizontalAlign: currentHorizontalAlign
        }
    };
}

});

parcelRequire.register("lydCh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2f0f08438ff6d105$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $6PqcF = parcelRequire("6PqcF");
const $2f0f08438ff6d105$var$supportHorizontalAlignmentPlacements = new Set([
    "top",
    "bottom"
]);
function $2f0f08438ff6d105$var$TipBubble({ children: children, position: position, placement: placement = "bottom", horizontalAlignment: horizontalAlignment = "center", className: className, anchorRef: anchorRef, isSuccessful: isSuccessful, ...rest }, reference) {
    if (!anchorRef.current) return null;
    const anchorRect = anchorRef.current.getBoundingClientRect();
    const arrowPosition = (0, $5CQIb.conditional)($2f0f08438ff6d105$var$supportHorizontalAlignmentPlacements.has(placement) && position && {
        left: anchorRect.x + anchorRect.width / 2 - Number(position.left)
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ...rest,
        ref: reference,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($6PqcF.tipBubble, $6PqcF[placement], !position && $6PqcF.invisible, isSuccessful && $6PqcF.successful, className),
        style: {
            ...position
        },
        children: [
            children,
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6PqcF.arrow,
                style: {
                    ...arrowPosition
                }
            })
        ]
    });
}
var $2f0f08438ff6d105$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($2f0f08438ff6d105$var$TipBubble);

});
parcelRequire.register("6PqcF", function(module, exports) {

$parcel$export(module.exports, "arrow", function () { return $4f8bd4ec3366f433$export$f2120bbfa5450bd2; }, function (v) { return $4f8bd4ec3366f433$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "bottom", function () { return $4f8bd4ec3366f433$export$40e543e69a8b3fbb; }, function (v) { return $4f8bd4ec3366f433$export$40e543e69a8b3fbb = v; });
$parcel$export(module.exports, "invisible", function () { return $4f8bd4ec3366f433$export$c99df9cf5e6bee9b; }, function (v) { return $4f8bd4ec3366f433$export$c99df9cf5e6bee9b = v; });
$parcel$export(module.exports, "left", function () { return $4f8bd4ec3366f433$export$eabcd2c8791e7bf4; }, function (v) { return $4f8bd4ec3366f433$export$eabcd2c8791e7bf4 = v; });
$parcel$export(module.exports, "right", function () { return $4f8bd4ec3366f433$export$79ffe56a765070d2; }, function (v) { return $4f8bd4ec3366f433$export$79ffe56a765070d2 = v; });
$parcel$export(module.exports, "rotating", function () { return $4f8bd4ec3366f433$export$bfd64c937657f93a; }, function (v) { return $4f8bd4ec3366f433$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shimmer", function () { return $4f8bd4ec3366f433$export$4a6dd88bada4e7d2; }, function (v) { return $4f8bd4ec3366f433$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "successful", function () { return $4f8bd4ec3366f433$export$62fcf40e4d1fffb5; }, function (v) { return $4f8bd4ec3366f433$export$62fcf40e4d1fffb5 = v; });
$parcel$export(module.exports, "tipBubble", function () { return $4f8bd4ec3366f433$export$d03cc62ddab7bcdd; }, function (v) { return $4f8bd4ec3366f433$export$d03cc62ddab7bcdd = v; });
$parcel$export(module.exports, "top", function () { return $4f8bd4ec3366f433$export$1e95b668f3b82d; }, function (v) { return $4f8bd4ec3366f433$export$1e95b668f3b82d = v; });
var $4f8bd4ec3366f433$export$f2120bbfa5450bd2;
var $4f8bd4ec3366f433$export$40e543e69a8b3fbb;
var $4f8bd4ec3366f433$export$c99df9cf5e6bee9b;
var $4f8bd4ec3366f433$export$eabcd2c8791e7bf4;
var $4f8bd4ec3366f433$export$79ffe56a765070d2;
var $4f8bd4ec3366f433$export$bfd64c937657f93a;
var $4f8bd4ec3366f433$export$4a6dd88bada4e7d2;
var $4f8bd4ec3366f433$export$62fcf40e4d1fffb5;
var $4f8bd4ec3366f433$export$d03cc62ddab7bcdd;
var $4f8bd4ec3366f433$export$1e95b668f3b82d;
$4f8bd4ec3366f433$export$f2120bbfa5450bd2 = `_1_sVWW_arrow`;
$4f8bd4ec3366f433$export$40e543e69a8b3fbb = `_1_sVWW_bottom`;
$4f8bd4ec3366f433$export$c99df9cf5e6bee9b = `_1_sVWW_invisible`;
$4f8bd4ec3366f433$export$eabcd2c8791e7bf4 = `_1_sVWW_left`;
$4f8bd4ec3366f433$export$79ffe56a765070d2 = `_1_sVWW_right`;
$4f8bd4ec3366f433$export$bfd64c937657f93a = `_1_sVWW_rotating`;
$4f8bd4ec3366f433$export$4a6dd88bada4e7d2 = `_1_sVWW_shimmer`;
$4f8bd4ec3366f433$export$62fcf40e4d1fffb5 = `_1_sVWW_successful`;
$4f8bd4ec3366f433$export$d03cc62ddab7bcdd = `_1_sVWW_tipBubble`;
$4f8bd4ec3366f433$export$1e95b668f3b82d = `_1_sVWW_top`;

});


parcelRequire.register("kz136", function(module, exports) {

$parcel$export(module.exports, "getVerticalOffset", function () { return $9fd2d692a695fa7f$export$c7ca8986ba140884; });
$parcel$export(module.exports, "getHorizontalOffset", function () { return $9fd2d692a695fa7f$export$f425d04b8b775845; });
$parcel$export(module.exports, "getVerticalAlignment", function () { return $9fd2d692a695fa7f$export$7cf35ab7c148e889; });
$parcel$export(module.exports, "getHorizontalAlignment", function () { return $9fd2d692a695fa7f$export$57b9fac71d74bea1; });
const $9fd2d692a695fa7f$export$c7ca8986ba140884 = (placement)=>{
    switch(placement){
        case "top":
            return -16;
        case "bottom":
            return 16;
        default:
            return 0;
    }
};
const $9fd2d692a695fa7f$export$f425d04b8b775845 = (placement, horizontalAlignment)=>{
    if (placement === "top" || placement === "bottom") switch(horizontalAlignment){
        case "start":
            return -32;
        case "end":
            return 32;
        default:
            return 0;
    }
    else return placement === "left" ? -32 : 32;
};
const $9fd2d692a695fa7f$export$7cf35ab7c148e889 = (placement)=>{
    switch(placement){
        case "top":
            return "top";
        case "bottom":
            return "bottom";
        default:
            return "middle";
    }
};
const $9fd2d692a695fa7f$export$57b9fac71d74bea1 = (placement, fallback)=>{
    switch(placement){
        case "right":
            return "start";
        case "left":
            return "end";
        default:
            return fallback;
    }
};

});

parcelRequire.register("dSFEk", function(module, exports) {

$parcel$export(module.exports, "anchor", function () { return $a1b0a0328ba9ed99$export$2e2992790a6f69a8; }, function (v) { return $a1b0a0328ba9ed99$export$2e2992790a6f69a8 = v; });
var $a1b0a0328ba9ed99$export$2e2992790a6f69a8;
var $a1b0a0328ba9ed99$export$bfd64c937657f93a;
var $a1b0a0328ba9ed99$export$4a6dd88bada4e7d2;
$a1b0a0328ba9ed99$export$2e2992790a6f69a8 = `_9uLVAW_anchor`;
$a1b0a0328ba9ed99$export$bfd64c937657f93a = `_9uLVAW_rotating`;
$a1b0a0328ba9ed99$export$4a6dd88bada4e7d2 = `_9uLVAW_shimmer`;

});


parcelRequire.register("bf05n", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $63445424af860a24$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");

var $1pqtO = parcelRequire("1pqtO");

var $7iZsu = parcelRequire("7iZsu");

var $6PcpQ = parcelRequire("6PcpQ");

var $lydCh = parcelRequire("lydCh");

var $kz136 = parcelRequire("kz136");

var $31TZw = parcelRequire("31TZw");
function $63445424af860a24$var$ToggleTip({ children: children, className: className, anchorClassName: anchorClassName, placement: placement = "top", horizontalAlign: horizontalAlign = "center", content: content }) {
    const tipBubbleRef = (0, $eCoWV.useRef)(null);
    const anchorRef = (0, $eCoWV.useRef)(null);
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    const onClose = (0, $eCoWV.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const { position: layoutPosition, positionState: positionState, mutate: mutate } = (0, $1pqtO.default)({
        verticalAlign: (0, $kz136.getVerticalAlignment)(placement),
        horizontalAlign: (0, $kz136.getHorizontalAlignment)(placement, horizontalAlign),
        offset: {
            vertical: (0, $kz136.getVerticalOffset)(placement),
            horizontal: (0, $kz136.getHorizontalOffset)(placement, horizontalAlign)
        },
        anchorRef: anchorRef,
        overlayRef: tipBubbleRef
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                ref: anchorRef,
                role: "tab",
                tabIndex: 0,
                className: anchorClassName,
                onClick: ()=>{
                    setIsOpen(true);
                },
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    setIsOpen(true);
                }),
                children: children
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
                shouldCloseOnOverlayClick: true,
                shouldCloseOnEsc: true,
                isOpen: isOpen,
                className: $31TZw.content,
                overlayClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7iZsu.overlay, $31TZw.overlay),
                onRequestClose: onClose,
                onAfterOpen: mutate,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lydCh.default), {
                    ref: tipBubbleRef,
                    anchorRef: anchorRef,
                    position: layoutPosition,
                    placement: placement,
                    className: className,
                    horizontalAlignment: positionState.horizontalAlign,
                    children: typeof content === "function" ? content(onClose) : content
                })
            })
        ]
    });
}
var $63445424af860a24$export$2e2bcd8739ae039 = $63445424af860a24$var$ToggleTip;

});
parcelRequire.register("31TZw", function(module, exports) {

$parcel$export(module.exports, "content", function () { return $234ce5c93871cafd$export$a7db06668cad9adb; }, function (v) { return $234ce5c93871cafd$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "overlay", function () { return $234ce5c93871cafd$export$29dd17c7f3c81c36; }, function (v) { return $234ce5c93871cafd$export$29dd17c7f3c81c36 = v; });
var $234ce5c93871cafd$export$a7db06668cad9adb;
var $234ce5c93871cafd$export$29dd17c7f3c81c36;
var $234ce5c93871cafd$export$bfd64c937657f93a;
var $234ce5c93871cafd$export$4a6dd88bada4e7d2;
$234ce5c93871cafd$export$a7db06668cad9adb = `-rGTfG_content`;
$234ce5c93871cafd$export$29dd17c7f3c81c36 = `-rGTfG_overlay`;
$234ce5c93871cafd$export$bfd64c937657f93a = `-rGTfG_rotating`;
$234ce5c93871cafd$export$4a6dd88bada4e7d2 = `-rGTfG_shimmer`;

});



parcelRequire.register("6ReZL", function(module, exports) {

$parcel$export(module.exports, "field", function () { return $4fe353092762f247$export$e0f35d825088c098; }, function (v) { return $4fe353092762f247$export$e0f35d825088c098 = v; });
$parcel$export(module.exports, "headline", function () { return $4fe353092762f247$export$516dd90aeaaabcf0; }, function (v) { return $4fe353092762f247$export$516dd90aeaaabcf0 = v; });
$parcel$export(module.exports, "multiple", function () { return $4fe353092762f247$export$939ddaa3205df08e; }, function (v) { return $4fe353092762f247$export$939ddaa3205df08e = v; });
$parcel$export(module.exports, "required", function () { return $4fe353092762f247$export$a7a0278c004aac3f; }, function (v) { return $4fe353092762f247$export$a7a0278c004aac3f = v; });
$parcel$export(module.exports, "title", function () { return $4fe353092762f247$export$fb184b623420d9be; }, function (v) { return $4fe353092762f247$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "toggleTipButton", function () { return $4fe353092762f247$export$d7648c09dd2d912c; }, function (v) { return $4fe353092762f247$export$d7648c09dd2d912c = v; });
$parcel$export(module.exports, "withLargeSpacing", function () { return $4fe353092762f247$export$feea9e02112d2b92; }, function (v) { return $4fe353092762f247$export$feea9e02112d2b92 = v; });
var $4fe353092762f247$export$e0f35d825088c098;
var $4fe353092762f247$export$516dd90aeaaabcf0;
var $4fe353092762f247$export$939ddaa3205df08e;
var $4fe353092762f247$export$a7a0278c004aac3f;
var $4fe353092762f247$export$bfd64c937657f93a;
var $4fe353092762f247$export$4a6dd88bada4e7d2;
var $4fe353092762f247$export$fb184b623420d9be;
var $4fe353092762f247$export$d7648c09dd2d912c;
var $4fe353092762f247$export$feea9e02112d2b92;
$4fe353092762f247$export$e0f35d825088c098 = `KtdR-q_field`;
$4fe353092762f247$export$516dd90aeaaabcf0 = `KtdR-q_headline`;
$4fe353092762f247$export$939ddaa3205df08e = `KtdR-q_multiple`;
$4fe353092762f247$export$a7a0278c004aac3f = `KtdR-q_required`;
$4fe353092762f247$export$bfd64c937657f93a = `KtdR-q_rotating`;
$4fe353092762f247$export$4a6dd88bada4e7d2 = `KtdR-q_shimmer`;
$4fe353092762f247$export$fb184b623420d9be = `KtdR-q_title`;
$4fe353092762f247$export$d7648c09dd2d912c = `KtdR-q_toggleTipButton`;
$4fe353092762f247$export$feea9e02112d2b92 = `KtdR-q_withLargeSpacing`;

});


parcelRequire.register("307Eo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aec7d80a4eb60739$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $aec7d80a4eb60739$var$SvgTick = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M15.592 6.008a.833.833 0 0 0-1.184 0L8.2 12.225 5.592 9.608a.852.852 0 0 0-1.184 1.225l3.2 3.2a.833.833 0 0 0 1.184 0l6.8-6.8a.834.834 0 0 0 0-1.225Z",
            fill: "currentColor"
        })
    });
var $aec7d80a4eb60739$export$2e2bcd8739ae039 = $aec7d80a4eb60739$var$SvgTick;

});

parcelRequire.register("jrO3d", function(module, exports) {

var $jVTpz = parcelRequire("jVTpz");

var $7FYlK = parcelRequire("7FYlK");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jVTpz.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || $7FYlK;
module.exports = isBuffer;

});
parcelRequire.register("jVTpz", function(module, exports) {

var $nT3o2 = parcelRequire("nT3o2");
/** Detect free variable `self`. */ var $e82e52bd24a9a357$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $e82e52bd24a9a357$var$root = $nT3o2 || $e82e52bd24a9a357$var$freeSelf || Function("return this")();
module.exports = $e82e52bd24a9a357$var$root;

});
parcelRequire.register("nT3o2", function(module, exports) {
/** Detect free variable `global` from Node.js. */ var $047cda99ab495b41$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
module.exports = $047cda99ab495b41$var$freeGlobal;

});


parcelRequire.register("7FYlK", function(module, exports) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $596b2cf11f6feeeb$var$stubFalse() {
    return false;
}
module.exports = $596b2cf11f6feeeb$var$stubFalse;

});


parcelRequire.register("faAj2", function(module, exports) {

var $nT3o2 = parcelRequire("nT3o2");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && $nT3o2.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
module.exports = nodeUtil;

});

parcelRequire.register("6JIe0", function(module, exports) {

var $jVTpz = parcelRequire("jVTpz");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? $jVTpz.Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
module.exports = cloneBuffer;

});

parcelRequire.register("344vn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23b53d6c8bc2d2cc$export$2e2bcd8739ae039; });

var $etFod = parcelRequire("etFod");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $etFod.default).Buffer : undefined, allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */ function cloneBuffer(buffer, isDeep) {
    if (isDeep) return buffer.slice();
    var length = buffer.length, result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
    buffer.copy(result);
    return result;
}
var $23b53d6c8bc2d2cc$export$2e2bcd8739ae039 = cloneBuffer;

});
parcelRequire.register("etFod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8a3e134d33ca3f6$export$2e2bcd8739ae039; });

var $kFsrN = parcelRequire("kFsrN");
/** Detect free variable `self`. */ var $a8a3e134d33ca3f6$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $a8a3e134d33ca3f6$var$root = (0, $kFsrN.default) || $a8a3e134d33ca3f6$var$freeSelf || Function("return this")();
var $a8a3e134d33ca3f6$export$2e2bcd8739ae039 = $a8a3e134d33ca3f6$var$root;

});
parcelRequire.register("kFsrN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f0bdb403f3b59bf7$export$2e2bcd8739ae039; });
/** Detect free variable `global` from Node.js. */ var $f0bdb403f3b59bf7$var$freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $f0bdb403f3b59bf7$export$2e2bcd8739ae039 = $f0bdb403f3b59bf7$var$freeGlobal;

});



parcelRequire.register("1nmna", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $10094b2cf2334ed8$export$2e2bcd8739ae039; });

var $etFod = parcelRequire("etFod");

var $aznpD = parcelRequire("aznpD");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? (0, $etFod.default).Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || (0, $aznpD.default);
var $10094b2cf2334ed8$export$2e2bcd8739ae039 = isBuffer;

});
parcelRequire.register("aznpD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7b1f55810d3e8d40$export$2e2bcd8739ae039; });
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function $7b1f55810d3e8d40$var$stubFalse() {
    return false;
}
var $7b1f55810d3e8d40$export$2e2bcd8739ae039 = $7b1f55810d3e8d40$var$stubFalse;

});


parcelRequire.register("bZVQC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8bc2438e43cbb960$export$2e2bcd8739ae039; });

var $kFsrN = parcelRequire("kFsrN");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && (0, $kFsrN.default).process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require("util").types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding("util");
    } catch (e) {}
}();
var $8bc2438e43cbb960$export$2e2bcd8739ae039 = nodeUtil;

});

parcelRequire.register("bSFEw", function(module, exports) {

$parcel$export(module.exports, "trySubmitSafe", function () { return $aecb9ea1fec86634$export$71d68564151b8269; });

var $d2Ivz = parcelRequire("d2Ivz");
const $aecb9ea1fec86634$export$71d68564151b8269 = (handler)=>async (formData, event)=>{
        try {
            await handler(formData, event);
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError) && error.response.status !== 401) return;
            throw error;
        }
    };

});

parcelRequire.register("4ytKy", function(module, exports) {

$parcel$export(module.exports, "uriValidator", function () { return $ccbf2ce986cbc485$export$36d0ae2aa57c858b; });
$parcel$export(module.exports, "jsonValidator", function () { return $ccbf2ce986cbc485$export$9d5afbcb5ee0ae5; });
const $ccbf2ce986cbc485$export$36d0ae2aa57c858b = (value)=>{
    try {
        // eslint-disable-next-line no-new
        new URL(value);
    } catch  {
        return false;
    }
    return true;
};
const $ccbf2ce986cbc485$export$9d5afbcb5ee0ae5 = (value)=>{
    try {
        JSON.parse(value);
    } catch  {
        return false;
    }
    return true;
};

});

parcelRequire.register("gbU1S", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ce00e276cfdc6b5$export$2e2bcd8739ae039; });

var $eCoWV = parcelRequire("eCoWV");
const $7ce00e276cfdc6b5$var$useScroll = (contentRef)=>{
    const [scrollTop, setScrollTop] = (0, $eCoWV.useState)(0);
    const [scrollLeft, setScrollLeft] = (0, $eCoWV.useState)(0);
    const handleScroll = (0, $eCoWV.useCallback)(()=>{
        if (!contentRef) return;
        const { scrollTop: scrollTop, scrollLeft: scrollLeft } = contentRef;
        setScrollTop(scrollTop);
        setScrollLeft(scrollLeft);
    }, [
        contentRef
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!contentRef) return;
        contentRef.addEventListener("scroll", handleScroll);
        return ()=>{
            contentRef.removeEventListener("scroll", handleScroll);
        };
    }, [
        handleScroll,
        contentRef
    ]);
    return {
        scrollTop: scrollTop,
        scrollLeft: scrollLeft
    };
};
var $7ce00e276cfdc6b5$export$2e2bcd8739ae039 = $7ce00e276cfdc6b5$var$useScroll;

});

parcelRequire.register("9XAkT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3696e9805723955d$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $dB50T = parcelRequire("dB50T");

var $hEugJ = parcelRequire("hEugJ");

var $4KvY2 = parcelRequire("4KvY2");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");

var $701qu = parcelRequire("701qu");
function $3696e9805723955d$var$NotificationIcon({ severity: severity }) {
    switch(severity){
        case "info":
        case "alert":
            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dB50T.default), {});
        case "success":
            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4KvY2.default), {});
        case "error":
            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hEugJ.default), {});
        default:
            return null;
    }
}
function $3696e9805723955d$var$InlineNotification({ children: children, action: action, href: href, hrefTargetBlank: hrefTargetBlank, onClick: onClick, severity: severity = "info", variant: variant = "plain", hasIcon: hasIcon = true, isActionLoading: isActionLoading = false, className: className }, ref) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($701qu.inlineNotification, $701qu[severity], $701qu[variant], className),
        children: [
            hasIcon && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $701qu.icon,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)($3696e9805723955d$var$NotificationIcon, {
                    severity: severity
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $701qu.content,
                children: children
            }),
            action && href && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                to: href,
                targetBlank: hrefTargetBlank,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: action
                })
            }),
            action && onClick && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $701qu.action,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: action,
                    type: "text",
                    size: "small",
                    isLoading: isActionLoading,
                    onClick: onClick
                })
            })
        ]
    });
}
var $3696e9805723955d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($3696e9805723955d$var$InlineNotification);

});
parcelRequire.register("dB50T", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77080a31b3064251$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $77080a31b3064251$var$SvgInfo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.41 9.41a.833.833 0 0 1 1.423.59v3.333a.833.833 0 1 1-1.666 0V10c0-.221.088-.433.244-.59ZM9.683 5.9a.833.833 0 0 1 .634 0c.102.04.195.1.275.175.152.16.238.37.241.592a.834.834 0 0 1-1.15.766.958.958 0 0 1-.275-.175.833.833 0 0 1-.175-.908.958.958 0 0 1 .175-.275.834.834 0 0 1 .275-.175Z",
                fill: "#fff"
            })
        ]
    });
var $77080a31b3064251$export$2e2bcd8739ae039 = $77080a31b3064251$var$SvgInfo;

});

parcelRequire.register("hEugJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cca2defad4778ad2$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $cca2defad4778ad2$var$SvgToastError = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m11.732 3.165.002.002 6.742 11.653c.15.303.253.597.197.931l-.006.041v.041c0 1.068-.87 2-2 2H3.25c-.344 0-.668-.067-.993-.262l-.009-.005c-.922-.527-1.263-1.802-.731-2.733v-.002l6.75-11.664.007-.013.007-.014c.112-.225.365-.493.722-.708.93-.529 2.203-.188 2.73.733ZM8.668 14.167c0 .363.123.705.375.957.252.253.594.376.958.376s.706-.123.958-.376c.252-.252.375-.594.375-.957 0-.364-.123-.706-.375-.958a1.332 1.332 0 0 0-.958-.376c-.364 0-.706.124-.958.376a1.332 1.332 0 0 0-.375.958Zm1.333-2c.364 0 .706-.124.958-.376s.375-.594.375-.958V7.5c0-.364-.123-.705-.375-.958A1.332 1.332 0 0 0 10 6.167c-.364 0-.706.123-.958.375a1.332 1.332 0 0 0-.375.958v3.333c0 .364.123.706.375.958s.594.376.958.376Z",
            fill: "#DD3730",
            stroke: "#DD3730"
        })
    });
var $cca2defad4778ad2$export$2e2bcd8739ae039 = $cca2defad4778ad2$var$SvgToastError;

});

parcelRequire.register("4KvY2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86652826867e7dc9$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $86652826867e7dc9$var$SvgToastSuccess = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M2.167 10c0-4.307 3.526-7.833 7.833-7.833S17.833 5.693 17.833 10 14.307 17.833 10 17.833 2.167 14.307 2.167 10Zm7.687 2.937 4-4a1.305 1.305 0 0 0 0-1.874 1.305 1.305 0 0 0-1.874 0l-3.063 3.063-.897-.896a1.305 1.305 0 0 0-1.873 0 1.305 1.305 0 0 0 0 1.874l1.833 1.833a1.305 1.305 0 0 0 1.874 0Z",
            fill: "#32873D",
            stroke: "#32873D"
        })
    });
var $86652826867e7dc9$export$2e2bcd8739ae039 = $86652826867e7dc9$var$SvgToastSuccess;

});

parcelRequire.register("701qu", function(module, exports) {

$parcel$export(module.exports, "alert", function () { return $5189a3bb0488d28b$export$5ea928c9faf85bd3; }, function (v) { return $5189a3bb0488d28b$export$5ea928c9faf85bd3 = v; });
$parcel$export(module.exports, "content", function () { return $5189a3bb0488d28b$export$a7db06668cad9adb; }, function (v) { return $5189a3bb0488d28b$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "error", function () { return $5189a3bb0488d28b$export$a3bc9b8ed74fc; }, function (v) { return $5189a3bb0488d28b$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "icon", function () { return $5189a3bb0488d28b$export$1ca1ec8b29a4ce27; }, function (v) { return $5189a3bb0488d28b$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "info", function () { return $5189a3bb0488d28b$export$a80b3bd66acc52ff; }, function (v) { return $5189a3bb0488d28b$export$a80b3bd66acc52ff = v; });
$parcel$export(module.exports, "inlineNotification", function () { return $5189a3bb0488d28b$export$9e9024ab31cc2703; }, function (v) { return $5189a3bb0488d28b$export$9e9024ab31cc2703 = v; });
$parcel$export(module.exports, "rotating", function () { return $5189a3bb0488d28b$export$bfd64c937657f93a; }, function (v) { return $5189a3bb0488d28b$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "shadow", function () { return $5189a3bb0488d28b$export$b8972b998723d602; }, function (v) { return $5189a3bb0488d28b$export$b8972b998723d602 = v; });
$parcel$export(module.exports, "shimmer", function () { return $5189a3bb0488d28b$export$4a6dd88bada4e7d2; }, function (v) { return $5189a3bb0488d28b$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "success", function () { return $5189a3bb0488d28b$export$fe7c49d056ea1d88; }, function (v) { return $5189a3bb0488d28b$export$fe7c49d056ea1d88 = v; });
var $5189a3bb0488d28b$export$5ea928c9faf85bd3;
var $5189a3bb0488d28b$export$a7db06668cad9adb;
var $5189a3bb0488d28b$export$a3bc9b8ed74fc;
var $5189a3bb0488d28b$export$1ca1ec8b29a4ce27;
var $5189a3bb0488d28b$export$a80b3bd66acc52ff;
var $5189a3bb0488d28b$export$9e9024ab31cc2703;
var $5189a3bb0488d28b$export$bfd64c937657f93a;
var $5189a3bb0488d28b$export$b8972b998723d602;
var $5189a3bb0488d28b$export$4a6dd88bada4e7d2;
var $5189a3bb0488d28b$export$fe7c49d056ea1d88;
$5189a3bb0488d28b$export$5ea928c9faf85bd3 = `_p8-jq_alert`;
$5189a3bb0488d28b$export$a7db06668cad9adb = `_p8-jq_content`;
$5189a3bb0488d28b$export$a3bc9b8ed74fc = `_p8-jq_error`;
$5189a3bb0488d28b$export$1ca1ec8b29a4ce27 = `_p8-jq_icon`;
$5189a3bb0488d28b$export$a80b3bd66acc52ff = `_p8-jq_info`;
$5189a3bb0488d28b$export$9e9024ab31cc2703 = `_p8-jq_inlineNotification`;
$5189a3bb0488d28b$export$bfd64c937657f93a = `_p8-jq_rotating`;
$5189a3bb0488d28b$export$b8972b998723d602 = `_p8-jq_shadow`;
$5189a3bb0488d28b$export$4a6dd88bada4e7d2 = `_p8-jq_shimmer`;
$5189a3bb0488d28b$export$fe7c49d056ea1d88 = `_p8-jq_success`;

});


parcelRequire.register("47yah", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $79b42026d46d3864$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $k2jGU = parcelRequire("k2jGU");

var $40c6p = parcelRequire("40c6p");

var $kzmMx = parcelRequire("kzmMx");

var $6PcpQ = parcelRequire("6PcpQ");

var $9bgsA = parcelRequire("9bgsA");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $4d767 = parcelRequire("4d767");
function $79b42026d46d3864$var$CopyToClipboard({ value: value, className: className, style: style, valueStyle: valueStyle, hasVisibilityToggle: hasVisibilityToggle, variant: variant = "contained", size: size = "default", isWordWrapAllowed: isWordWrapAllowed = false }, ref) {
    const copyIconReference = (0, $eCoWV.useRef)(null);
    const [copyState, setCopyState] = (0, $eCoWV.useState)("copy");
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.general"
    });
    const [showHiddenContent, setShowHiddenContent] = (0, $eCoWV.useState)(false);
    const displayValue = (0, $eCoWV.useMemo)(()=>{
        if (!hasVisibilityToggle || showHiddenContent) return value;
        return "•".repeat(value.length);
    }, [
        hasVisibilityToggle,
        showHiddenContent,
        value
    ]);
    (0, $eCoWV.useEffect)(()=>{
        copyIconReference.current?.addEventListener("mouseleave", ()=>{
            setCopyState("copy");
        });
    }, []);
    const copy = async ()=>{
        setCopyState("copying");
        await navigator.clipboard.writeText(value);
        setCopyState("copied");
    };
    const toggleHiddenContent = ()=>{
        setShowHiddenContent((previous)=>!previous);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($4d767.container, $4d767[variant], $4d767[size], className),
        role: "button",
        tabIndex: 0,
        style: style,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)((event)=>{
            event.stopPropagation();
        }),
        onClick: (event)=>{
            event.stopPropagation();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $4d767.row,
            children: [
                variant !== "icon" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($4d767.content, isWordWrapAllowed && $4d767.wrapContent),
                    style: valueStyle,
                    children: displayValue
                }),
                hasVisibilityToggle && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                    content: t(showHiddenContent ? "hide" : "view"),
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        className: $4d767.iconButton,
                        iconClassName: $4d767.icon,
                        size: "small",
                        onClick: toggleHiddenContent,
                        children: showHiddenContent ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $40c6p.default), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kzmMx.default), {})
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                    isSuccessful: copyState === "copied",
                    anchorClassName: $4d767.copyToolTipAnchor,
                    content: t(copyState),
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        ref: copyIconReference,
                        className: $4d767.iconButton,
                        iconClassName: $4d767.icon,
                        size: "small",
                        onClick: copy,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $k2jGU.default), {})
                    })
                })
            ]
        })
    });
}
var $79b42026d46d3864$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($79b42026d46d3864$var$CopyToClipboard);

});
parcelRequire.register("k2jGU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3f14dd7ef5885492$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $3f14dd7ef5885492$var$SvgCopy = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M9.333 14.667H2.667a1.29 1.29 0 0 1-1.334-1.334V6.667a1.29 1.29 0 0 1 1.334-1.334h2.666V2.667a1.29 1.29 0 0 1 1.334-1.334h6.666a1.29 1.29 0 0 1 1.334 1.334v6.666a1.29 1.29 0 0 1-1.334 1.334h-2.666v2.666a1.29 1.29 0 0 1-1.334 1.334Zm-6.666-8v6.666h6.666v-2.666H6.667a1.29 1.29 0 0 1-1.334-1.334V6.667H2.667Zm4-4v6.666h6.666V2.667H6.667Z",
            fill: "currentColor"
        })
    });
var $3f14dd7ef5885492$export$2e2bcd8739ae039 = $3f14dd7ef5885492$var$SvgCopy;

});

parcelRequire.register("40c6p", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $177316772a152619$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $177316772a152619$var$SvgEyeClosed = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M3.09 1.91A.833.833 0 0 0 1.91 3.09L4.33 5.507C2.834 6.729 1.815 8.165 1.313 8.959l-.02.032c-.098.155-.226.356-.29.636a1.799 1.799 0 0 0 0 .745c.064.281.191.481.29.636l.02.031c.493.782 1.48 2.17 2.918 3.371 1.44 1.203 3.385 2.257 5.77 2.257 1.642 0 3.078-.501 4.282-1.206l2.628 2.628a.833.833 0 1 0 1.179-1.178l-3.022-3.022a.827.827 0 0 0-.153-.153l-8.66-8.66a.83.83 0 0 0-.133-.133L3.09 1.911Zm-.368 7.94c.473-.75 1.427-2.078 2.793-3.157L7.13 8.307a3.333 3.333 0 0 0 4.565 4.565l1.362 1.362c-.908.467-1.928.766-3.056.766-1.87 0-3.448-.823-4.701-1.87-1.255-1.047-2.134-2.278-2.578-2.98a7.144 7.144 0 0 1-.09-.149v-.002c.004-.01.012-.022.024-.041l.067-.109Zm5.612.15c0-.15.02-.294.056-.432l2.042 2.042A1.67 1.67 0 0 1 8.334 10Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.074 5.068C9.374 5.024 9.682 5 10 5c1.87 0 3.448.823 4.702 1.869 1.255 1.048 2.133 2.279 2.577 2.982a7.93 7.93 0 0 1 .091.148V10l-.024.043-.068.108c-.234.371-.594.896-1.07 1.464a.833.833 0 1 0 1.278 1.07c.533-.637.936-1.224 1.201-1.644l.02-.032c.099-.155.227-.356.291-.636a1.8 1.8 0 0 0 0-.745c-.064-.281-.191-.481-.29-.636l-.02-.031c-.493-.782-1.48-2.17-2.918-3.372-1.44-1.202-3.385-2.256-5.77-2.256-.401 0-.791.03-1.17.086a.833.833 0 1 0 .244 1.649Z",
                fill: "#747778"
            })
        ]
    });
var $177316772a152619$export$2e2bcd8739ae039 = $177316772a152619$var$SvgEyeClosed;

});

parcelRequire.register("kzmMx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $95478f5cb313f453$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $95478f5cb313f453$var$SvgEye = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 18,
        height: 12,
        viewBox: "0 0 18 12",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.5 6a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M17.246 5.627C15.447 2.03 12.253.167 9 .167 5.748.167 2.553 2.03.755 5.627a.833.833 0 0 0 0 .746C2.553 9.97 5.748 11.833 9 11.833c3.253 0 6.447-1.863 8.246-5.46a.833.833 0 0 0 0-.746ZM9 10.167C6.526 10.167 4 8.816 2.442 6 3.999 3.184 6.526 1.833 9 1.833S14.002 3.183 15.56 6C14.002 8.816 11.474 10.167 9 10.167Z",
                fill: "currentColor"
            })
        ]
    });
var $95478f5cb313f453$export$2e2bcd8739ae039 = $95478f5cb313f453$var$SvgEye;

});

parcelRequire.register("4d767", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "border", function () { return $310de1c4bbac64d2$export$1edee58a52776cd9; }, function (v) { return $310de1c4bbac64d2$export$1edee58a52776cd9 = v; });
$parcel$export(module.exports, "contained", function () { return $310de1c4bbac64d2$export$98e6239189c28b84; }, function (v) { return $310de1c4bbac64d2$export$98e6239189c28b84 = v; });
$parcel$export(module.exports, "container", function () { return $310de1c4bbac64d2$export$34e0f9847d4c02dd; }, function (v) { return $310de1c4bbac64d2$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "content", function () { return $310de1c4bbac64d2$export$a7db06668cad9adb; }, function (v) { return $310de1c4bbac64d2$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "copyToolTipAnchor", function () { return $310de1c4bbac64d2$export$56668e8595601db0; }, function (v) { return $310de1c4bbac64d2$export$56668e8595601db0 = v; });
$parcel$export(module.exports, "default", function () { return $310de1c4bbac64d2$export$2e2bcd8739ae039; }, function (v) { return $310de1c4bbac64d2$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "icon", function () { return $310de1c4bbac64d2$export$1ca1ec8b29a4ce27; }, function (v) { return $310de1c4bbac64d2$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "iconButton", function () { return $310de1c4bbac64d2$export$60bb6c1f29b8a8cc; }, function (v) { return $310de1c4bbac64d2$export$60bb6c1f29b8a8cc = v; });
$parcel$export(module.exports, "rotating", function () { return $310de1c4bbac64d2$export$bfd64c937657f93a; }, function (v) { return $310de1c4bbac64d2$export$bfd64c937657f93a = v; });
$parcel$export(module.exports, "row", function () { return $310de1c4bbac64d2$export$120ff0929b202a6d; }, function (v) { return $310de1c4bbac64d2$export$120ff0929b202a6d = v; });
$parcel$export(module.exports, "shimmer", function () { return $310de1c4bbac64d2$export$4a6dd88bada4e7d2; }, function (v) { return $310de1c4bbac64d2$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "small", function () { return $310de1c4bbac64d2$export$3c17b0e969a90510; }, function (v) { return $310de1c4bbac64d2$export$3c17b0e969a90510 = v; });
$parcel$export(module.exports, "wrapContent", function () { return $310de1c4bbac64d2$export$7e3af17b76ad5e5f; }, function (v) { return $310de1c4bbac64d2$export$7e3af17b76ad5e5f = v; });
var $310de1c4bbac64d2$export$1edee58a52776cd9;
var $310de1c4bbac64d2$export$98e6239189c28b84;
var $310de1c4bbac64d2$export$34e0f9847d4c02dd;
var $310de1c4bbac64d2$export$a7db06668cad9adb;
var $310de1c4bbac64d2$export$56668e8595601db0;
var $310de1c4bbac64d2$export$2e2bcd8739ae039;
var $310de1c4bbac64d2$export$1ca1ec8b29a4ce27;
var $310de1c4bbac64d2$export$60bb6c1f29b8a8cc;
var $310de1c4bbac64d2$export$bfd64c937657f93a;
var $310de1c4bbac64d2$export$120ff0929b202a6d;
var $310de1c4bbac64d2$export$4a6dd88bada4e7d2;
var $310de1c4bbac64d2$export$3c17b0e969a90510;
var $310de1c4bbac64d2$export$7e3af17b76ad5e5f;
$310de1c4bbac64d2$export$1edee58a52776cd9 = `UyyloG_border`;
$310de1c4bbac64d2$export$98e6239189c28b84 = `UyyloG_contained`;
$310de1c4bbac64d2$export$34e0f9847d4c02dd = `UyyloG_container`;
$310de1c4bbac64d2$export$a7db06668cad9adb = `UyyloG_content`;
$310de1c4bbac64d2$export$56668e8595601db0 = `UyyloG_copyToolTipAnchor`;
$310de1c4bbac64d2$export$2e2bcd8739ae039 = `UyyloG_default`;
$310de1c4bbac64d2$export$1ca1ec8b29a4ce27 = `UyyloG_icon`;
$310de1c4bbac64d2$export$60bb6c1f29b8a8cc = `UyyloG_iconButton`;
$310de1c4bbac64d2$export$bfd64c937657f93a = `UyyloG_rotating`;
$310de1c4bbac64d2$export$120ff0929b202a6d = `UyyloG_row`;
$310de1c4bbac64d2$export$4a6dd88bada4e7d2 = `UyyloG_shimmer`;
$310de1c4bbac64d2$export$3c17b0e969a90510 = `UyyloG_small`;
$310de1c4bbac64d2$export$7e3af17b76ad5e5f = `UyyloG_wrapContent`;

});


parcelRequire.register("6bI12", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("dIYjH")).then(()=>parcelRequire("aUx7n"));

});

parcelRequire.register("lXV8L", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("2R2gj"))
]).then(()=>parcelRequire("9KAyJ"));

});
parcelRequire.register("kcGWx", function(module, exports) {
"use strict";

var $dkBnK = parcelRequire("dkBnK");
module.exports = $dkBnK(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName("link");
        if ([].concat(existingLinks).some(function isCurrentBundle(link) {
            return link.href === bundle && link.rel.indexOf("stylesheet") > -1;
        })) {
            resolve();
            return;
        }
        var link = document.createElement("link");
        link.rel = "stylesheet";
        link.href = bundle;
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName("head")[0].appendChild(link);
    });
});

});
parcelRequire.register("dkBnK", function(module, exports) {
"use strict";
var $9b4a23e330080025$var$cachedBundles = {};
var $9b4a23e330080025$var$cachedPreloads = {};
var $9b4a23e330080025$var$cachedPrefetches = {};
function $9b4a23e330080025$var$getCache(type) {
    switch(type){
        case "preload":
            return $9b4a23e330080025$var$cachedPreloads;
        case "prefetch":
            return $9b4a23e330080025$var$cachedPrefetches;
        default:
            return $9b4a23e330080025$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $9b4a23e330080025$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRequire.register("cnrey", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fv96j")).then(()=>parcelRequire("1rkQ0"));

});

parcelRequire.register("knFbF", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("98vBd"))
]).then(()=>parcelRequire("cuSLY"));

});

parcelRequire.register("1QDy2", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5wzE0")).then(()=>parcelRequire("4WMVT"));

});

parcelRequire.register("eSv6H", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("1cxAy"))
]).then(()=>parcelRequire("jGHfn"));

});

parcelRequire.register("74v4K", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("euwY9")).then(()=>parcelRequire("c82qm"));

});

parcelRequire.register("6wvrC", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("fmUdJ"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("eMRS0"))
]).then(()=>parcelRequire("aPItS"));

});

parcelRequire.register("kScQ8", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jDg2j")).then(()=>parcelRequire("e4bjV"));

});

parcelRequire.register("cmUFr", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("gyRdx"))
]).then(()=>parcelRequire("gmM1U"));

});

parcelRequire.register("ahwHs", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2FQkT")).then(()=>parcelRequire("1lNkf"));

});

parcelRequire.register("6vQTP", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("2aUOL"))
]).then(()=>parcelRequire("d0SVL"));

});

parcelRequire.register("4zeZD", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("55moc")).then(()=>parcelRequire("1rEas"));

});

parcelRequire.register("beINB", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("4EAK2"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("kFwsU"))
]).then(()=>parcelRequire("9p18a"));

});

parcelRequire.register("7J8ER", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5o83I")).then(()=>parcelRequire("5k08d"));

});

parcelRequire.register("8TO2E", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("bYsws"))
]).then(()=>parcelRequire("bUoTo"));

});

parcelRequire.register("1omaq", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6doFn")).then(()=>parcelRequire("lJ7kC"));

});

parcelRequire.register("dMrK3", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("iEpid"))
]).then(()=>parcelRequire("imc5Z"));

});

parcelRequire.register("ihXGl", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cdWXM")).then(()=>parcelRequire("cRdow"));

});

parcelRequire.register("fWbtZ", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("lBy7t"))
]).then(()=>parcelRequire("btBSp"));

});

parcelRequire.register("ejQur", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cv5Of")).then(()=>parcelRequire("J81ax"));

});

parcelRequire.register("5zgPf", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("lrvQe"))
]).then(()=>parcelRequire("atmvP"));

});

parcelRequire.register("66fM3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kCQrO")).then(()=>parcelRequire("aHS9A"));

});

parcelRequire.register("80It5", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("ckjav"))
]).then(()=>parcelRequire("8rjGd"));

});

parcelRequire.register("L8wRN", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8UiND")).then(()=>parcelRequire("7dlqi"));

});

parcelRequire.register("KzTbb", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("6uZt7"))
]).then(()=>parcelRequire("9YnOM"));

});

parcelRequire.register("6vdnx", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kypDo")).then(()=>parcelRequire("igyVg"));

});

parcelRequire.register("77p7H", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("itVWg"))
]).then(()=>parcelRequire("7NbR6"));

});

parcelRequire.register("lrgQt", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("aRTwC")).then(()=>parcelRequire("6yUHq"));

});

parcelRequire.register("1qei0", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("dGcZd"))
]).then(()=>parcelRequire("aNuhu"));

});

parcelRequire.register("j94dN", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4lQWb")).then(()=>parcelRequire("6UmbC"));

});

parcelRequire.register("9umua", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("3rFbi"))
]).then(()=>parcelRequire("aQbHq"));

});

parcelRequire.register("5Gdm3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fDJlF")).then(()=>parcelRequire("lSA6o"));

});

parcelRequire.register("iMRjY", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("1UBZB"))
]).then(()=>parcelRequire("bbfQC"));

});

parcelRequire.register("261jk", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fwkzD")).then(()=>parcelRequire("ePrpN"));

});

parcelRequire.register("3VSZS", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("2IkdZ"))
]).then(()=>parcelRequire("1sH4m"));

});

parcelRequire.register("jqdKb", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bejoi")).then(()=>parcelRequire("kgGoq"));

});

parcelRequire.register("6JhXg", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("6OKzY"))
]).then(()=>parcelRequire("hfGKy"));

});

parcelRequire.register("fDQSP", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1MCRo")).then(()=>parcelRequire("cleT7"));

});

parcelRequire.register("aOs7H", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("6eClN"))
]).then(()=>parcelRequire("9dAdM"));

});

parcelRequire.register("gDX8i", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4sv1e")).then(()=>parcelRequire("lKFIY"));

});

parcelRequire.register("2VFDo", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("babCu"))
]).then(()=>parcelRequire("k7pyt"));

});

parcelRequire.register("lymUc", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("21Kq3")).then(()=>parcelRequire("kYXSd"));

});

parcelRequire.register("9KaO0", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("117Sh"))
]).then(()=>parcelRequire("2iLR6"));

});

parcelRequire.register("kuPrU", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("9NFxO")).then(()=>parcelRequire("8Hw43"));

});

parcelRequire.register("fUHZ9", function(module, exports) {



module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("hOTfZ"))
]).then(()=>parcelRequire("1OsNM"));

});

parcelRequire.register("7fydw", function(module, exports) {

$parcel$export(module.exports, "GuideContext", function () { return $f5c421a7410d2629$export$b3f904f25eabb807; });
$parcel$export(module.exports, "default", function () { return $f5c421a7410d2629$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $d871A = parcelRequire("d871A");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $ac8G1 = parcelRequire("ac8G1");

var $kcPww = parcelRequire("kcPww");

var $5irU4 = parcelRequire("5irU4");

var $d0Zvy = parcelRequire("d0Zvy");

var $1Iq4D = parcelRequire("1Iq4D");

var $iYDAL = parcelRequire("iYDAL");

var $djktV = parcelRequire("djktV");

var $9VcRN = parcelRequire("9VcRN");

var $e86H6 = parcelRequire("e86H6");
const $f5c421a7410d2629$export$b3f904f25eabb807 = /*#__PURE__*/ (0, $eCoWV.createContext)({
    // The following `as` is for context initialization, they won't be used in production except for
    // HMR.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-restricted-syntax
    metadata: {},
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, no-restricted-syntax
    app: {},
    endpoint: "",
    redirectUris: [],
    postLogoutRedirectUris: [],
    isCompact: false,
    sampleUrls: {
        origin: "",
        callback: ""
    },
    audience: ""
});
function $f5c421a7410d2629$var$Guide({ className: className, guideId: guideId, isEmpty: isEmpty, isLoading: isLoading, onClose: onClose }) {
    const guide = (0, $ac8G1.default).find(({ id: id })=>id === guideId);
    const GuideComponent = guide?.Component;
    const isApiResourceGuide = guide?.metadata.target === "API";
    const context = (0, $eCoWV.useContext)($f5c421a7410d2629$export$b3f904f25eabb807);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $d0Zvy.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($e86H6.content, className),
                children: [
                    isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9VcRN.default), {}),
                    isEmpty && !guide && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $djktV.default), {
                        className: $e86H6.notFound
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d871A.MDXProvider), {
                        components: {
                            code: ({ className: className, children: children })=>{
                                const [, language] = /language-(\w+)/.exec(String(className ?? "")) ?? [];
                                return language ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                                    isReadonly: true,
                                    // We need to transform `ts` to `typescript` for prismjs, and
                                    // it's weird since it worked in the original Guide component.
                                    // To be investigated.
                                    language: language === "ts" ? "typescript" : language,
                                    value: String(children).trimEnd()
                                }) : /*#__PURE__*/ (0, $9zeGj.jsx)("code", {
                                    children: String(children).trimEnd()
                                });
                            },
                            a: ({ children: children, ...props })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                    ...props,
                                    targetBlank: true,
                                    children: children
                                }),
                            details: (0, $iYDAL.default)
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eCoWV.Suspense), {
                            fallback: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9VcRN.default), {}),
                            children: GuideComponent && /*#__PURE__*/ (0, $9zeGj.jsx)(GuideComponent, {
                                ...context
                            })
                        })
                    })
                ]
            }),
            !isApiResourceGuide && /*#__PURE__*/ (0, $9zeGj.jsx)("nav", {
                className: $e86H6.actionBar,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $e86H6.layout,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        size: "large",
                        title: "guide.finish_and_done",
                        type: "primary",
                        onClick: onClose
                    })
                })
            })
        ]
    });
}
var $f5c421a7410d2629$export$2e2bcd8739ae039 = $f5c421a7410d2629$var$Guide;

});
parcelRequire.register("d871A", function(module, exports) {

$parcel$export(module.exports, "MDXProvider", function () { return $98f178ac1fc75d53$export$1cf78dad7550a52b; });
$parcel$export(module.exports, "mdx", function () { return $98f178ac1fc75d53$export$5beccd7059e5fba5; });

var $eCoWV = parcelRequire("eCoWV");
function $98f178ac1fc75d53$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $98f178ac1fc75d53$var$_extends() {
    $98f178ac1fc75d53$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $98f178ac1fc75d53$var$_extends.apply(this, arguments);
}
function $98f178ac1fc75d53$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $98f178ac1fc75d53$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $98f178ac1fc75d53$var$ownKeys(Object(source), true).forEach(function(key) {
            $98f178ac1fc75d53$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $98f178ac1fc75d53$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $98f178ac1fc75d53$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $98f178ac1fc75d53$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $98f178ac1fc75d53$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
var $98f178ac1fc75d53$var$isFunction = function isFunction(obj) {
    return typeof obj === "function";
};
var $98f178ac1fc75d53$export$d7de0f1cab697634 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createContext({});
var $98f178ac1fc75d53$export$aae81db1754c1e05 = function withMDXComponents(Component) {
    return function(props) {
        var allComponents = $98f178ac1fc75d53$export$ba49c9ffd2310961(props.components);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Component, $98f178ac1fc75d53$var$_extends({}, props, {
            components: allComponents
        }));
    };
};
var $98f178ac1fc75d53$export$ba49c9ffd2310961 = function useMDXComponents(components) {
    var contextComponents = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).useContext($98f178ac1fc75d53$export$d7de0f1cab697634);
    var allComponents = contextComponents;
    if (components) allComponents = $98f178ac1fc75d53$var$isFunction(components) ? components(contextComponents) : $98f178ac1fc75d53$var$_objectSpread2($98f178ac1fc75d53$var$_objectSpread2({}, contextComponents), components);
    return allComponents;
};
var $98f178ac1fc75d53$export$1cf78dad7550a52b = function MDXProvider(props) {
    var allComponents = $98f178ac1fc75d53$export$ba49c9ffd2310961(props.components);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($98f178ac1fc75d53$export$d7de0f1cab697634.Provider, {
        value: allComponents
    }, props.children);
};
var $98f178ac1fc75d53$var$TYPE_PROP_NAME = "mdxType";
var $98f178ac1fc75d53$var$DEFAULTS = {
    inlineCode: "code",
    wrapper: function wrapper(_ref) {
        var children = _ref.children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Fragment, {}, children);
    }
};
var $98f178ac1fc75d53$var$MDXCreateElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).forwardRef(function(props, ref) {
    var propComponents = props.components, mdxType = props.mdxType, originalType = props.originalType, parentName = props.parentName, etc = $98f178ac1fc75d53$var$_objectWithoutProperties(props, [
        "components",
        "mdxType",
        "originalType",
        "parentName"
    ]);
    var components = $98f178ac1fc75d53$export$ba49c9ffd2310961(propComponents);
    var type = mdxType;
    var Component = components["".concat(parentName, ".").concat(type)] || components[type] || $98f178ac1fc75d53$var$DEFAULTS[type] || originalType;
    if (propComponents) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Component, $98f178ac1fc75d53$var$_objectSpread2($98f178ac1fc75d53$var$_objectSpread2({
        ref: ref
    }, etc), {}, {
        components: propComponents
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Component, $98f178ac1fc75d53$var$_objectSpread2({
        ref: ref
    }, etc));
});
$98f178ac1fc75d53$var$MDXCreateElement.displayName = "MDXCreateElement";
function $98f178ac1fc75d53$export$5beccd7059e5fba5(type, props) {
    var args = arguments;
    var mdxType = props && props.mdxType;
    if (typeof type === "string" || mdxType) {
        var argsLength = args.length;
        var createElementArgArray = new Array(argsLength);
        createElementArgArray[0] = $98f178ac1fc75d53$var$MDXCreateElement;
        var newProps = {};
        for(var key in props)if (hasOwnProperty.call(props, key)) newProps[key] = props[key];
        newProps.originalType = type;
        newProps[$98f178ac1fc75d53$var$TYPE_PROP_NAME] = typeof type === "string" ? type : mdxType;
        createElementArgArray[1] = newProps;
        for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement.apply(null, createElementArgArray);
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement.apply(null, args);
}

});

parcelRequire.register("ac8G1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b41c46fba7ec7e01$export$2e2bcd8739ae039; });
// This is a generated file, don't update manually.

var $eCoWV = parcelRequire("eCoWV");

var $3CE4O = parcelRequire("3CE4O");

var $6Znfm = parcelRequire("6Znfm");

var $9X7pk = parcelRequire("9X7pk");

var $gKqxN = parcelRequire("gKqxN");

var $kaNUw = parcelRequire("kaNUw");

var $huONi = parcelRequire("huONi");

var $d8NDE = parcelRequire("d8NDE");

var $2cdOo = parcelRequire("2cdOo");

var $7aUdL = parcelRequire("7aUdL");

var $lWsPD = parcelRequire("lWsPD");

var $2Bwe2 = parcelRequire("2Bwe2");

var $7LDur = parcelRequire("7LDur");

var $bg8Jn = parcelRequire("bg8Jn");

var $h7bpM = parcelRequire("h7bpM");

var $bVlxq = parcelRequire("bVlxq");

var $e90Pg = parcelRequire("e90Pg");

var $aO5QA = parcelRequire("aO5QA");

var $81GkM = parcelRequire("81GkM");

var $cHDXI = parcelRequire("cHDXI");

var $jSHrN = parcelRequire("jSHrN");

var $8mLxV = parcelRequire("8mLxV");

var $lEgaC = parcelRequire("lEgaC");

var $6CNks = parcelRequire("6CNks");














































const $b41c46fba7ec7e01$var$guides = Object.freeze([
    {
        order: 1,
        id: "web-next",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("6bI12"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("lXV8L"))),
        metadata: (0, $81GkM.default)
    },
    {
        order: 1.1,
        id: "spa-react",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("cnrey"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("knFbF"))),
        metadata: (0, $lWsPD.default)
    },
    {
        order: 1.1,
        id: "web-next-app-router",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("1QDy2"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("eSv6H"))),
        metadata: (0, $cHDXI.default)
    },
    {
        order: 1.2,
        id: "m2m-general",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("74v4K"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("6wvrC"))),
        metadata: (0, $gKqxN.default)
    },
    {
        order: 1.2,
        id: "web-express",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("kScQ8"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("cmUFr"))),
        metadata: (0, $bVlxq.default)
    },
    {
        order: 1.3,
        id: "web-go",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("ahwHs"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("6vQTP"))),
        metadata: (0, $e90Pg.default)
    },
    {
        order: 1.5,
        id: "web-gpt-plugin",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("4zeZD"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("beINB"))),
        metadata: (0, $aO5QA.default)
    },
    {
        order: 1.6,
        id: "spa-vue",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("7J8ER"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("8TO2E"))),
        metadata: (0, $7LDur.default)
    },
    {
        order: 1.7,
        id: "native-ios-swift",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("1omaq"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("dMrK3"))),
        metadata: (0, $7aUdL.default)
    },
    {
        order: 2,
        id: "native-android-kt",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("ihXGl"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("fWbtZ"))),
        metadata: (0, $huONi.default)
    },
    {
        order: 2,
        id: "spa-vanilla",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("ejQur"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("5zgPf"))),
        metadata: (0, $2Bwe2.default)
    },
    {
        order: 2,
        id: "web-php",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("66fM3"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("80It5"))),
        metadata: (0, $8mLxV.default)
    },
    {
        order: 3,
        id: "native-android-java",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("L8wRN"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("KzTbb"))),
        metadata: (0, $kaNUw.default)
    },
    {
        order: 3,
        id: "web-python",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("6vdnx"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("77p7H"))),
        metadata: (0, $lEgaC.default)
    },
    {
        order: 4,
        id: "native-capacitor",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("lrgQt"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("1qei0"))),
        metadata: (0, $d8NDE.default)
    },
    {
        order: 4,
        id: "web-remix",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("j94dN"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("9umua"))),
        metadata: (0, $6CNks.default)
    },
    {
        order: 5,
        id: "native-flutter",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("5Gdm3"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("iMRjY"))),
        metadata: (0, $2cdOo.default)
    },
    {
        order: 5,
        id: "web-asp-net-core",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("261jk"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("3VSZS"))),
        metadata: (0, $bg8Jn.default)
    },
    {
        order: 5.1,
        id: "web-asp-net-core-mvc",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("jqdKb"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("6JhXg"))),
        metadata: (0, $h7bpM.default)
    },
    {
        order: 6,
        id: "web-outline",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("fDQSP"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("aOs7H"))),
        metadata: (0, $jSHrN.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-express",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("gDX8i"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("2VFDo"))),
        metadata: (0, $3CE4O.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-python",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("lymUc"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("9KaO0"))),
        metadata: (0, $6Znfm.default)
    },
    {
        order: Number.POSITIVE_INFINITY,
        id: "api-spring-boot",
        Logo: (0, $eCoWV.lazy)(async ()=>(parcelRequire("kuPrU"))),
        Component: (0, $eCoWV.lazy)(async ()=>(parcelRequire("fUHZ9"))),
        metadata: (0, $9X7pk.default)
    }
]);
var $b41c46fba7ec7e01$export$2e2bcd8739ae039 = $b41c46fba7ec7e01$var$guides;

});
parcelRequire.register("3CE4O", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f592ac3b6a48f5b3$export$2e2bcd8739ae039; });
const $f592ac3b6a48f5b3$var$metadata = Object.freeze({
    name: "Express",
    description: "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    target: "API"
});
var $f592ac3b6a48f5b3$export$2e2bcd8739ae039 = $f592ac3b6a48f5b3$var$metadata;

});

parcelRequire.register("6Znfm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6560dab564605f5b$export$2e2bcd8739ae039; });
const $6560dab564605f5b$var$metadata = Object.freeze({
    name: "Python",
    description: "Integrate Logto into your Python web app, such as Django and Flask.",
    target: "API"
});
var $6560dab564605f5b$export$2e2bcd8739ae039 = $6560dab564605f5b$var$metadata;

});

parcelRequire.register("9X7pk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $32d010aa16793668$export$2e2bcd8739ae039; });
const $32d010aa16793668$var$metadata = Object.freeze({
    name: "Spring Boot",
    description: "Spring Boot is an open source Java-based framework used to create a micro Service.",
    target: "API"
});
var $32d010aa16793668$export$2e2bcd8739ae039 = $32d010aa16793668$var$metadata;

});

parcelRequire.register("gKqxN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $319051e61242ea74$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $319051e61242ea74$var$metadata = Object.freeze({
    name: "Machine-to-machine",
    description: "Enables direct communication between machines.",
    target: (0, $3kVX5.ApplicationType).MachineToMachine,
    isFeatured: true
});
var $319051e61242ea74$export$2e2bcd8739ae039 = $319051e61242ea74$var$metadata;

});

parcelRequire.register("kaNUw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba27d44b5276aeb5$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $ba27d44b5276aeb5$var$metadata = Object.freeze({
    name: "Android (Java)",
    description: "Android integration for Java.",
    target: (0, $3kVX5.ApplicationType).Native,
    sample: {
        repo: "kotlin",
        path: "android-sample-java"
    }
});
var $ba27d44b5276aeb5$export$2e2bcd8739ae039 = $ba27d44b5276aeb5$var$metadata;

});

parcelRequire.register("huONi", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c1216938d61e6467$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $c1216938d61e6467$var$metadata = Object.freeze({
    name: "Android (Kotlin)",
    description: "Android integration for Kotlin.",
    target: (0, $3kVX5.ApplicationType).Native,
    sample: {
        repo: "kotlin",
        path: "android-sample-kotlin"
    }
});
var $c1216938d61e6467$export$2e2bcd8739ae039 = $c1216938d61e6467$var$metadata;

});

parcelRequire.register("d8NDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a065b37967794a8$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $6a065b37967794a8$var$metadata = Object.freeze({
    name: "Capacitor JS",
    description: "Capacitor JS is a framework for building hybrid mobile apps.",
    target: (0, $3kVX5.ApplicationType).Native
});
var $6a065b37967794a8$export$2e2bcd8739ae039 = $6a065b37967794a8$var$metadata;

});

parcelRequire.register("2cdOo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5d48022487b545c5$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $5d48022487b545c5$var$metadata = Object.freeze({
    name: "Flutter",
    description: "Flutter is a framework for building hybrid mobile apps.",
    target: (0, $3kVX5.ApplicationType).Native
});
var $5d48022487b545c5$export$2e2bcd8739ae039 = $5d48022487b545c5$var$metadata;

});

parcelRequire.register("7aUdL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4eb6d0b68ff8ae4e$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $4eb6d0b68ff8ae4e$var$metadata = Object.freeze({
    name: "iOS (Swift)",
    description: "iOS (Swift) application integration guide.",
    target: (0, $3kVX5.ApplicationType).Native,
    sample: {
        repo: "swift",
        path: "Demos/SwiftUI%20Demo"
    },
    isFeatured: true
});
var $4eb6d0b68ff8ae4e$export$2e2bcd8739ae039 = $4eb6d0b68ff8ae4e$var$metadata;

});

parcelRequire.register("lWsPD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f165953a81dffce7$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $f165953a81dffce7$var$metadata = Object.freeze({
    name: "React",
    description: "React is a JavaScript library for building user interfaces.",
    target: (0, $3kVX5.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/react-sample"
    },
    isFeatured: true
});
var $f165953a81dffce7$export$2e2bcd8739ae039 = $f165953a81dffce7$var$metadata;

});

parcelRequire.register("2Bwe2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4c07792a1743b131$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $4c07792a1743b131$var$metadata = Object.freeze({
    name: "Vanilla JS",
    description: "The framework-agnostic JavaScript integration.",
    target: (0, $3kVX5.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/browser-sample"
    }
});
var $4c07792a1743b131$export$2e2bcd8739ae039 = $4c07792a1743b131$var$metadata;

});

parcelRequire.register("7LDur", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2c3892ca78af3f77$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $2c3892ca78af3f77$var$metadata = Object.freeze({
    name: "Vue",
    description: "Vue.js is a progressive, incrementally-adoptable JavaScript framework for building UI on the web.",
    target: (0, $3kVX5.ApplicationType).SPA,
    sample: {
        repo: "js",
        path: "packages/vue-sample"
    },
    isFeatured: true
});
var $2c3892ca78af3f77$export$2e2bcd8739ae039 = $2c3892ca78af3f77$var$metadata;

});

parcelRequire.register("bg8Jn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41717095019ea5c4$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $41717095019ea5c4$var$metadata = Object.freeze({
    name: "ASP.NET Core",
    description: "ASP.NET Core is a cross-platform framework for building modern apps.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "csharp",
        path: "sample"
    }
});
var $41717095019ea5c4$export$2e2bcd8739ae039 = $41717095019ea5c4$var$metadata;

});

parcelRequire.register("h7bpM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3303d40992a6cf46$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $3303d40992a6cf46$var$metadata = Object.freeze({
    name: "ASP.NET Core (MVC)",
    description: "ASP.NET Core is a cross-platform framework for building modern apps.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "csharp",
        path: "sample-mvc"
    }
});
var $3303d40992a6cf46$export$2e2bcd8739ae039 = $3303d40992a6cf46$var$metadata;

});

parcelRequire.register("bVlxq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b7eb64942ec798f1$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $b7eb64942ec798f1$var$metadata = Object.freeze({
    name: "Express",
    description: "Express is a minimal and flexible Node.js web application framework that provides a robust set of features for web and mobile applications.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/express-sample"
    }
});
var $b7eb64942ec798f1$export$2e2bcd8739ae039 = $b7eb64942ec798f1$var$metadata;

});

parcelRequire.register("e90Pg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b9a35854c7729d15$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $b9a35854c7729d15$var$metadata = Object.freeze({
    name: "Go",
    description: "Go is an efficient, concurrent, statically typed programming language for web applications ",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "go",
        path: "gin-sample"
    }
});
var $b9a35854c7729d15$export$2e2bcd8739ae039 = $b9a35854c7729d15$var$metadata;

});

parcelRequire.register("aO5QA", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3d83c3358d54afa$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $a3d83c3358d54afa$var$metadata = Object.freeze({
    name: "ChatGPT plugin",
    description: "Use Logto as an OAuth identity provider for ChatGPT plugins.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    isFeatured: true
});
var $a3d83c3358d54afa$export$2e2bcd8739ae039 = $a3d83c3358d54afa$var$metadata;

});

parcelRequire.register("81GkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d27a2a518a006bba$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $d27a2a518a006bba$var$metadata = Object.freeze({
    name: "Next.js",
    description: "Next.js is a React framework for production - it makes building fullstack React apps a breeze and ships with built-in SSR.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/next-sample"
    },
    isFeatured: true
});
var $d27a2a518a006bba$export$2e2bcd8739ae039 = $d27a2a518a006bba$var$metadata;

});

parcelRequire.register("cHDXI", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $23cdba2a3c677505$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $23cdba2a3c677505$var$metadata = Object.freeze({
    name: "Next.js (App Router)",
    description: "Next.js App Router is a new paradigm for building applications using React's latest features.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "js",
        path: "packages/next-app-dir-sample"
    }
});
var $23cdba2a3c677505$export$2e2bcd8739ae039 = $23cdba2a3c677505$var$metadata;

});

parcelRequire.register("jSHrN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d24203999b3509d4$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $d24203999b3509d4$var$metadata = Object.freeze({
    name: "Outline",
    description: "Use Logto as an identity provider for Outline",
    target: (0, $3kVX5.ApplicationType).Traditional
});
var $d24203999b3509d4$export$2e2bcd8739ae039 = $d24203999b3509d4$var$metadata;

});

parcelRequire.register("8mLxV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0b73a61edfa8a9ff$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $0b73a61edfa8a9ff$var$metadata = Object.freeze({
    name: "PHP",
    description: "Integrate Logto into your PHP web app, such as Lavarel.",
    target: (0, $3kVX5.ApplicationType).Traditional
});
var $0b73a61edfa8a9ff$export$2e2bcd8739ae039 = $0b73a61edfa8a9ff$var$metadata;

});

parcelRequire.register("lEgaC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $97e5ef328ae58566$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $97e5ef328ae58566$var$metadata = Object.freeze({
    name: "Python",
    description: "Integrate Logto into your Python web app, such as Django and Flask.",
    target: (0, $3kVX5.ApplicationType).Traditional,
    sample: {
        repo: "python",
        path: "samples"
    }
});
var $97e5ef328ae58566$export$2e2bcd8739ae039 = $97e5ef328ae58566$var$metadata;

});

parcelRequire.register("6CNks", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6210fa0f819cf565$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $6210fa0f819cf565$var$metadata = Object.freeze({
    name: "Remix",
    description: "Remix is a modern SSR full stack web framework that lets you focus on the user interface and work back through web standards.",
    target: (0, $3kVX5.ApplicationType).Traditional
});
var $6210fa0f819cf565$export$2e2bcd8739ae039 = $6210fa0f819cf565$var$metadata;

});


parcelRequire.register("5irU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4e20bfa40951e0ff$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $dQFyo = parcelRequire("dQFyo");

var $ahYyJ = parcelRequire("ahYyJ");

var $47yah = parcelRequire("47yah");

var $29QHn = parcelRequire("29QHn");

var $gypP4 = parcelRequire("gypP4");
function $4e20bfa40951e0ff$var$CodeEditor({ className: className, language: language, isReadonly: isReadonly = false, value: value, onChange: onChange, tabSize: tabSize = 2, error: error, placeholder: placeholder }) {
    const textareaRef = (0, $eCoWV.useRef)(null);
    const editorRef = (0, $eCoWV.useRef)(null);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    (0, $eCoWV.useLayoutEffect)(()=>{
        // Update textarea width according to its scroll width
        const { current: current } = textareaRef;
        if (current && current.style.width !== `${current.scrollWidth}px`) // eslint-disable-next-line @silverhand/fp/no-mutation
        current.style.width = `${current.scrollWidth}px`;
    }, [
        value
    ]);
    const handleChange = (event)=>{
        const { value: value } = event.currentTarget;
        onChange?.(value);
    };
    const handleKeydown = (event)=>{
        if (event.key === "Tab") {
            const { value: value, selectionStart: selectionStart } = event.currentTarget;
            event.preventDefault();
            const newText = value.slice(0, selectionStart) + " ".repeat(tabSize) + value.slice(selectionStart);
            // Need to update value to set selection without useEffect
            // eslint-disable-next-line @silverhand/fp/no-mutation
            event.currentTarget.value = newText;
            event.currentTarget.setSelectionRange(selectionStart + tabSize, selectionStart + tabSize);
            onChange?.(newText);
        }
        /**
     * Since lineNumber container could cover leftmost part of the editor,
     * when user is clicking on "Enter", should manually scroll to the leftmost.
     */ if (event.key === "Enter" && editorRef.current && editorRef.current.scrollLeft !== 0) // eslint-disable-next-line @silverhand/fp/no-mutation
        editorRef.current.scrollLeft = 0;
    };
    // TODO @sijie temp solution for required error (the errorMessage is an empty string)
    const finalErrorMessage = typeof error === "string" ? error : t("general.required");
    const maxLineNumberDigits = (value ?? "").split("\n").length.toString().length;
    const isShowingPlaceholder = !value;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($29QHn.container, className),
                children: [
                    isShowingPlaceholder && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $29QHn.placeholder,
                        children: placeholder
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        value: value ?? "",
                        variant: "icon",
                        className: $29QHn.copy
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        ref: editorRef,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($29QHn.editor, isReadonly && $29QHn.readonly),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("textarea", {
                                ref: textareaRef,
                                autoCapitalize: "off",
                                autoComplete: "off",
                                autoCorrect: "off",
                                "data-gramm": "false",
                                wrap: "false",
                                readOnly: isReadonly,
                                spellCheck: "false",
                                value: value,
                                style: isShowingPlaceholder ? {
                                    marginLeft: "8px",
                                    width: "calc(100% - 8px)"
                                } : {
                                    marginLeft: `calc(${maxLineNumberDigits}ch + 20px)`,
                                    width: `calc(100% - ${maxLineNumberDigits}ch - 20px)`
                                },
                                onChange: handleChange,
                                onKeyDown: handleKeydown
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dQFyo.default), {
                                showInlineLineNumbers: true,
                                showLineNumbers: !isShowingPlaceholder,
                                width: textareaRef.current?.scrollWidth ?? 0,
                                lineNumberContainerStyle: (0, $gypP4.lineNumberContainerStyle)(),
                                lineNumberStyle: (0, $gypP4.lineNumberStyle)(maxLineNumberDigits),
                                codeTagProps: {
                                    style: {
                                        fontFamily: "'Roboto Mono', monospace"
                                    }
                                },
                                customStyle: (0, $gypP4.customStyle)(textareaRef.current?.scrollWidth),
                                language: language,
                                style: (0, $ahYyJ.default),
                                children: value ?? ""
                            })
                        ]
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $29QHn.errorMessage,
                children: finalErrorMessage
            })
        ]
    });
}
var $4e20bfa40951e0ff$export$2e2bcd8739ae039 = $4e20bfa40951e0ff$var$CodeEditor;

});
parcelRequire.register("dQFyo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1505d634b4e7730$export$2e2bcd8739ae039; });

var $5hujn = parcelRequire("5hujn");

var $65cmd = parcelRequire("65cmd");

var $a1505d634b4e7730$export$2e2bcd8739ae039 = (0, $5hujn.default)({
    loader: function loader() {
        return (parcelRequire("5wBOu")).then(function(module) {
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module["default"] || module;
        });
    },
    isLanguageRegistered: function isLanguageRegistered(instance, language) {
        return instance.registered(language);
    },
    languageLoaders: (0, $65cmd.default),
    registerLanguage: function registerLanguage(instance, name, language) {
        return instance.register(language);
    }
});

});
parcelRequire.register("5hujn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3d860d87fa374842$export$2e2bcd8739ae039; });

var $a1Cyq = parcelRequire("a1Cyq");

var $6ga92 = parcelRequire("6ga92");

var $ecir3 = parcelRequire("ecir3");

var $kmsID = parcelRequire("kmsID");

var $hGlR2 = parcelRequire("hGlR2");

var $18Stz = parcelRequire("18Stz");

var $N0GxW = parcelRequire("N0GxW");

var $3boID = parcelRequire("3boID");

var $1JWDA = parcelRequire("1JWDA");

var $eCoWV = parcelRequire("eCoWV");

var $hEUp3 = parcelRequire("hEUp3");
function $3d860d87fa374842$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3d860d87fa374842$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $N0GxW.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $N0GxW.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $18Stz.default)(this, result);
    };
}
function $3d860d87fa374842$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $3d860d87fa374842$export$2e2bcd8739ae039 = function(options) {
    var loader = options.loader, isLanguageRegistered = options.isLanguageRegistered, registerLanguage = options.registerLanguage, languageLoaders = options.languageLoaders, noAsyncLoadingLanguages = options.noAsyncLoadingLanguages;
    var ReactAsyncHighlighter = /*#__PURE__*/ function(_React$PureComponent) {
        (0, $hGlR2.default)(ReactAsyncHighlighter, _React$PureComponent);
        var _super = $3d860d87fa374842$var$_createSuper(ReactAsyncHighlighter);
        function ReactAsyncHighlighter() {
            (0, $ecir3.default)(this, ReactAsyncHighlighter);
            return _super.apply(this, arguments);
        }
        (0, $kmsID.default)(ReactAsyncHighlighter, [
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate() {
                    if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) this.loadLanguage();
                }
            },
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    var _this = this;
                    if (!ReactAsyncHighlighter.astGeneratorPromise) ReactAsyncHighlighter.loadAstGenerator();
                    if (!ReactAsyncHighlighter.astGenerator) ReactAsyncHighlighter.astGeneratorPromise.then(function() {
                        _this.forceUpdate();
                    });
                    if (!ReactAsyncHighlighter.isRegistered(this.props.language) && languageLoaders) this.loadLanguage();
                }
            },
            {
                key: "loadLanguage",
                value: function loadLanguage() {
                    var _this2 = this;
                    var language = this.props.language;
                    if (language === "text") return;
                    ReactAsyncHighlighter.loadLanguage(language).then(function() {
                        return _this2.forceUpdate();
                    })["catch"](function() {});
                }
            },
            {
                key: "normalizeLanguage",
                value: function normalizeLanguage(language) {
                    return ReactAsyncHighlighter.isSupportedLanguage(language) ? language : "text";
                }
            },
            {
                key: "render",
                value: function render() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(ReactAsyncHighlighter.highlightInstance, (0, $6ga92.default)({}, this.props, {
                        language: this.normalizeLanguage(this.props.language),
                        astGenerator: ReactAsyncHighlighter.astGenerator
                    }));
                }
            }
        ], [
            {
                key: "preload",
                value: function preload() {
                    return ReactAsyncHighlighter.loadAstGenerator();
                }
            },
            {
                key: "loadLanguage",
                value: function() {
                    var _loadLanguage = (0, $a1Cyq.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1JWDA))).mark(function _callee(language) {
                        var languageLoader;
                        return (0, (/*@__PURE__*/$parcel$interopDefault($1JWDA))).wrap(function _callee$(_context) {
                            while(true)switch(_context.prev = _context.next){
                                case 0:
                                    languageLoader = languageLoaders[language];
                                    if (!(typeof languageLoader === "function")) {
                                        _context.next = 5;
                                        break;
                                    }
                                    return _context.abrupt("return", languageLoader(ReactAsyncHighlighter.registerLanguage));
                                case 5:
                                    throw new Error("Language ".concat(language, " not supported"));
                                case 6:
                                case "end":
                                    return _context.stop();
                            }
                        }, _callee);
                    }));
                    function loadLanguage(_x) {
                        return _loadLanguage.apply(this, arguments);
                    }
                    return loadLanguage;
                }()
            },
            {
                key: "isSupportedLanguage",
                value: function isSupportedLanguage(language) {
                    return ReactAsyncHighlighter.isRegistered(language) || typeof languageLoaders[language] === "function";
                }
            },
            {
                key: "loadAstGenerator",
                value: function loadAstGenerator() {
                    ReactAsyncHighlighter.astGeneratorPromise = loader().then(function(astGenerator) {
                        ReactAsyncHighlighter.astGenerator = astGenerator;
                        if (registerLanguage) ReactAsyncHighlighter.languages.forEach(function(language, name) {
                            return registerLanguage(astGenerator, name, language);
                        });
                    });
                    return ReactAsyncHighlighter.astGeneratorPromise;
                }
            }
        ]);
        return ReactAsyncHighlighter;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).PureComponent);
    (0, $3boID.default)(ReactAsyncHighlighter, "astGenerator", null);
    (0, $3boID.default)(ReactAsyncHighlighter, "highlightInstance", (0, $hEUp3.default)(null, {}));
    (0, $3boID.default)(ReactAsyncHighlighter, "astGeneratorPromise", null);
    (0, $3boID.default)(ReactAsyncHighlighter, "languages", new Map());
    (0, $3boID.default)(ReactAsyncHighlighter, "supportedLanguages", options.supportedLanguages || Object.keys(languageLoaders || {}));
    (0, $3boID.default)(ReactAsyncHighlighter, "isRegistered", function(language) {
        if (noAsyncLoadingLanguages) return true;
        if (!registerLanguage) throw new Error("Current syntax highlighter doesn't support registration of languages");
        if (!ReactAsyncHighlighter.astGenerator) // Ast generator not available yet, but language will be registered once it is.
        return ReactAsyncHighlighter.languages.has(language);
        return isLanguageRegistered(ReactAsyncHighlighter.astGenerator, language);
    });
    (0, $3boID.default)(ReactAsyncHighlighter, "registerLanguage", function(name, language) {
        if (!registerLanguage) throw new Error("Current syntax highlighter doesn't support registration of languages");
        if (ReactAsyncHighlighter.astGenerator) return registerLanguage(ReactAsyncHighlighter.astGenerator, name, language);
        else ReactAsyncHighlighter.languages.set(name, language);
    });
    return ReactAsyncHighlighter;
};

});
parcelRequire.register("a1Cyq", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74c7e779685ab31d$export$2e2bcd8739ae039; });
function $74c7e779685ab31d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $74c7e779685ab31d$export$2e2bcd8739ae039(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $74c7e779685ab31d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $74c7e779685ab31d$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRequire.register("6ga92", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $48ec1b3d85f72820$export$2e2bcd8739ae039; });
function $48ec1b3d85f72820$export$2e2bcd8739ae039() {
    $48ec1b3d85f72820$export$2e2bcd8739ae039 = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $48ec1b3d85f72820$export$2e2bcd8739ae039.apply(this, arguments);
}

});

parcelRequire.register("ecir3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5607c88ad2b13a2$export$2e2bcd8739ae039; });
function $a5607c88ad2b13a2$export$2e2bcd8739ae039(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("kmsID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ed2c23ade1ceac6b$export$2e2bcd8739ae039; });
function $ed2c23ade1ceac6b$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ed2c23ade1ceac6b$export$2e2bcd8739ae039(Constructor, protoProps, staticProps) {
    if (protoProps) $ed2c23ade1ceac6b$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ed2c23ade1ceac6b$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}

});

parcelRequire.register("hGlR2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdf74fbd5007dceb$export$2e2bcd8739ae039; });

var $9BldM = parcelRequire("9BldM");
function $cdf74fbd5007dceb$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $9BldM.default)(subClass, superClass);
}

});
parcelRequire.register("9BldM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6fd807d94574d29f$export$2e2bcd8739ae039; });
function $6fd807d94574d29f$export$2e2bcd8739ae039(o, p) {
    $6fd807d94574d29f$export$2e2bcd8739ae039 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6fd807d94574d29f$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("18Stz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0d50cb9a307b65ac$export$2e2bcd8739ae039; });

var $dBo1v = parcelRequire("dBo1v");

var $fEwfO = parcelRequire("fEwfO");
function $0d50cb9a307b65ac$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $dBo1v.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $fEwfO.default)(self);
}

});
parcelRequire.register("dBo1v", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9e715d9bf1151102$export$2e2bcd8739ae039; });
function $9e715d9bf1151102$export$2e2bcd8739ae039(obj) {
    "@babel/helpers - typeof";
    return $9e715d9bf1151102$export$2e2bcd8739ae039 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9e715d9bf1151102$export$2e2bcd8739ae039(obj);
}

});

parcelRequire.register("fEwfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b6539c6a3347bea6$export$2e2bcd8739ae039; });
function $b6539c6a3347bea6$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});


parcelRequire.register("N0GxW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $09351bca65b15b53$export$2e2bcd8739ae039; });
function $09351bca65b15b53$export$2e2bcd8739ae039(o) {
    $09351bca65b15b53$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $09351bca65b15b53$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("3boID", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $251592dc5cf34a49$export$2e2bcd8739ae039; });
function $251592dc5cf34a49$export$2e2bcd8739ae039(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRequire.register("1JWDA", function(module, exports) {

module.exports = (parcelRequire("eFL2c"));

});
parcelRequire.register("eFL2c", function(module, exports) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $aae9611cfc5c88f2$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && typeof value === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per 25.3.3.3.3 of the spec:
                // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next mehtod, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        // Return an iterator with no values.
        return {
            next: doneResult
        };
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, module.exports));
try {
    regeneratorRuntime = $aae9611cfc5c88f2$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if (typeof globalThis === "object") globalThis.regeneratorRuntime = $aae9611cfc5c88f2$var$runtime;
    else Function("r", "regeneratorRuntime = r")($aae9611cfc5c88f2$var$runtime);
}

});


parcelRequire.register("hEUp3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $cdb1ec97e7c7db94$export$2e2bcd8739ae039; });

var $axRDW = parcelRequire("axRDW");

var $chyHL = parcelRequire("chyHL");

var $3boID = parcelRequire("3boID");

var $eCoWV = parcelRequire("eCoWV");

var $2YtfS = parcelRequire("2YtfS");

var $dwXN8 = parcelRequire("dwXN8");
var $cdb1ec97e7c7db94$var$_excluded = [
    "language",
    "children",
    "style",
    "customStyle",
    "codeTagProps",
    "useInlineStyles",
    "showLineNumbers",
    "showInlineLineNumbers",
    "startingLineNumber",
    "lineNumberContainerStyle",
    "lineNumberStyle",
    "wrapLines",
    "wrapLongLines",
    "lineProps",
    "renderer",
    "PreTag",
    "CodeTag",
    "code",
    "astGenerator"
];
function $cdb1ec97e7c7db94$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cdb1ec97e7c7db94$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cdb1ec97e7c7db94$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $3boID.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cdb1ec97e7c7db94$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $cdb1ec97e7c7db94$var$newLineRegex = /\n/g;
function $cdb1ec97e7c7db94$var$getNewLines(str) {
    return str.match($cdb1ec97e7c7db94$var$newLineRegex);
}
function $cdb1ec97e7c7db94$var$getAllLineNumbers(_ref) {
    var lines = _ref.lines, startingLineNumber = _ref.startingLineNumber, style = _ref.style;
    return lines.map(function(_, i) {
        var number = i + startingLineNumber;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
            key: "line-".concat(i),
            className: "react-syntax-highlighter-line-number",
            style: typeof style === "function" ? style(number) : style
        }, "".concat(number, "\n"));
    });
}
function $cdb1ec97e7c7db94$var$AllLineNumbers(_ref2) {
    var codeString = _ref2.codeString, codeStyle = _ref2.codeStyle, _ref2$containerStyle = _ref2.containerStyle, containerStyle = _ref2$containerStyle === void 0 ? {
        "float": "left",
        paddingRight: "10px"
    } : _ref2$containerStyle, _ref2$numberStyle = _ref2.numberStyle, numberStyle = _ref2$numberStyle === void 0 ? {} : _ref2$numberStyle, startingLineNumber = _ref2.startingLineNumber;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("code", {
        style: Object.assign({}, codeStyle, containerStyle)
    }, $cdb1ec97e7c7db94$var$getAllLineNumbers({
        lines: codeString.replace(/\n$/, "").split("\n"),
        style: numberStyle,
        startingLineNumber: startingLineNumber
    }));
}
function $cdb1ec97e7c7db94$var$getEmWidthOfNumber(num) {
    return "".concat(num.toString().length, ".25em");
}
function $cdb1ec97e7c7db94$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle) {
    return {
        type: "element",
        tagName: "span",
        properties: {
            key: "line-number--".concat(lineNumber),
            className: [
                "comment",
                "linenumber",
                "react-syntax-highlighter-line-number"
            ],
            style: inlineLineNumberStyle
        },
        children: [
            {
                type: "text",
                value: lineNumber
            }
        ]
    };
}
function $cdb1ec97e7c7db94$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber) {
    // minimally necessary styling for line numbers
    var defaultLineNumberStyle = {
        display: "inline-block",
        minWidth: $cdb1ec97e7c7db94$var$getEmWidthOfNumber(largestLineNumber),
        paddingRight: "1em",
        textAlign: "right",
        userSelect: "none"
    }; // prep custom styling
    var customLineNumberStyle = typeof lineNumberStyle === "function" ? lineNumberStyle(lineNumber) : lineNumberStyle; // combine
    var assembledStyle = $cdb1ec97e7c7db94$var$_objectSpread($cdb1ec97e7c7db94$var$_objectSpread({}, defaultLineNumberStyle), customLineNumberStyle);
    return assembledStyle;
}
function $cdb1ec97e7c7db94$var$createLineElement(_ref3) {
    var children = _ref3.children, lineNumber = _ref3.lineNumber, lineNumberStyle = _ref3.lineNumberStyle, largestLineNumber = _ref3.largestLineNumber, showInlineLineNumbers = _ref3.showInlineLineNumbers, _ref3$lineProps = _ref3.lineProps, lineProps = _ref3$lineProps === void 0 ? {} : _ref3$lineProps, _ref3$className = _ref3.className, className = _ref3$className === void 0 ? [] : _ref3$className, showLineNumbers = _ref3.showLineNumbers, wrapLongLines = _ref3.wrapLongLines;
    var properties = typeof lineProps === "function" ? lineProps(lineNumber) : lineProps;
    properties["className"] = className;
    if (lineNumber && showInlineLineNumbers) {
        var inlineLineNumberStyle = $cdb1ec97e7c7db94$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
        children.unshift($cdb1ec97e7c7db94$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
    }
    if (wrapLongLines & showLineNumbers) properties.style = $cdb1ec97e7c7db94$var$_objectSpread($cdb1ec97e7c7db94$var$_objectSpread({}, properties.style), {}, {
        display: "flex"
    });
    return {
        type: "element",
        tagName: "span",
        properties: properties,
        children: children
    };
}
function $cdb1ec97e7c7db94$var$flattenCodeTree(tree) {
    var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var newTree = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    for(var i = 0; i < tree.length; i++){
        var node = tree[i];
        if (node.type === "text") newTree.push($cdb1ec97e7c7db94$var$createLineElement({
            children: [
                node
            ],
            className: (0, $chyHL.default)(new Set(className))
        }));
        else if (node.children) {
            var classNames = className.concat(node.properties.className);
            $cdb1ec97e7c7db94$var$flattenCodeTree(node.children, classNames).forEach(function(i) {
                return newTree.push(i);
            });
        }
    }
    return newTree;
}
function $cdb1ec97e7c7db94$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines) {
    var _ref4;
    var tree = $cdb1ec97e7c7db94$var$flattenCodeTree(codeTree.value);
    var newTree = [];
    var lastLineBreakIndex = -1;
    var index = 0;
    function createWrappedLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return $cdb1ec97e7c7db94$var$createLineElement({
            children: children,
            lineNumber: lineNumber,
            lineNumberStyle: lineNumberStyle,
            largestLineNumber: largestLineNumber,
            showInlineLineNumbers: showInlineLineNumbers,
            lineProps: lineProps,
            className: className,
            showLineNumbers: showLineNumbers,
            wrapLongLines: wrapLongLines
        });
    }
    function createUnwrappedLine(children, lineNumber) {
        if (showLineNumbers && lineNumber && showInlineLineNumbers) {
            var inlineLineNumberStyle = $cdb1ec97e7c7db94$var$assembleLineNumberStyles(lineNumberStyle, lineNumber, largestLineNumber);
            children.unshift($cdb1ec97e7c7db94$var$getInlineLineNumber(lineNumber, inlineLineNumberStyle));
        }
        return children;
    }
    function createLine(children, lineNumber) {
        var className = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
        return wrapLines || className.length > 0 ? createWrappedLine(children, lineNumber, className) : createUnwrappedLine(children, lineNumber);
    }
    var _loop = function _loop() {
        var node = tree[index];
        var value = node.children[0].value;
        var newLines = $cdb1ec97e7c7db94$var$getNewLines(value);
        if (newLines) {
            var splitValue = value.split("\n");
            splitValue.forEach(function(text, i) {
                var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
                var newChild = {
                    type: "text",
                    value: "".concat(text, "\n")
                }; // if it's the first line
                if (i === 0) {
                    var _children = tree.slice(lastLineBreakIndex + 1, index).concat($cdb1ec97e7c7db94$var$createLineElement({
                        children: [
                            newChild
                        ],
                        className: node.properties.className
                    }));
                    var _line = createLine(_children, lineNumber);
                    newTree.push(_line); // if it's the last line
                } else if (i === splitValue.length - 1) {
                    var stringChild = tree[index + 1] && tree[index + 1].children && tree[index + 1].children[0];
                    var lastLineInPreviousSpan = {
                        type: "text",
                        value: "".concat(text)
                    };
                    if (stringChild) {
                        var newElem = $cdb1ec97e7c7db94$var$createLineElement({
                            children: [
                                lastLineInPreviousSpan
                            ],
                            className: node.properties.className
                        });
                        tree.splice(index + 1, 0, newElem);
                    } else {
                        var _children2 = [
                            lastLineInPreviousSpan
                        ];
                        var _line2 = createLine(_children2, lineNumber, node.properties.className);
                        newTree.push(_line2);
                    } // if it's neither the first nor the last line
                } else {
                    var _children3 = [
                        newChild
                    ];
                    var _line3 = createLine(_children3, lineNumber, node.properties.className);
                    newTree.push(_line3);
                }
            });
            lastLineBreakIndex = index;
        }
        index++;
    };
    while(index < tree.length)_loop();
    if (lastLineBreakIndex !== tree.length - 1) {
        var children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            var lineNumber = showLineNumbers && newTree.length + startingLineNumber;
            var line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    return wrapLines ? newTree : (_ref4 = []).concat.apply(_ref4, newTree);
}
function $cdb1ec97e7c7db94$var$defaultRenderer(_ref5) {
    var rows = _ref5.rows, stylesheet = _ref5.stylesheet, useInlineStyles = _ref5.useInlineStyles;
    return rows.map(function(node, i) {
        return (0, $2YtfS.default)({
            node: node,
            stylesheet: stylesheet,
            useInlineStyles: useInlineStyles,
            key: "code-segement".concat(i)
        });
    });
} // only highlight.js has the highlightAuto method
function $cdb1ec97e7c7db94$var$isHighlightJs(astGenerator) {
    return astGenerator && typeof astGenerator.highlightAuto !== "undefined";
}
function $cdb1ec97e7c7db94$var$getCodeTree(_ref6) {
    var astGenerator = _ref6.astGenerator, language = _ref6.language, code = _ref6.code, defaultCodeValue = _ref6.defaultCodeValue;
    // figure out whether we're using lowlight/highlight or refractor/prism
    // then attempt highlighting accordingly
    // lowlight/highlight?
    if ($cdb1ec97e7c7db94$var$isHighlightJs(astGenerator)) {
        var hasLanguage = (0, $dwXN8.default)(astGenerator, language);
        if (language === "text") return {
            value: defaultCodeValue,
            language: "text"
        };
        else if (hasLanguage) return astGenerator.highlight(language, code);
        else return astGenerator.highlightAuto(code);
    } // must be refractor/prism, then
    try {
        return language && language !== "text" ? {
            value: astGenerator.highlight(code, language)
        } : {
            value: defaultCodeValue
        };
    } catch (e) {
        return {
            value: defaultCodeValue
        };
    }
}
function $cdb1ec97e7c7db94$export$2e2bcd8739ae039(defaultAstGenerator, defaultStyle) {
    return function SyntaxHighlighter(_ref7) {
        var language = _ref7.language, children = _ref7.children, _ref7$style = _ref7.style, style = _ref7$style === void 0 ? defaultStyle : _ref7$style, _ref7$customStyle = _ref7.customStyle, customStyle = _ref7$customStyle === void 0 ? {} : _ref7$customStyle, _ref7$codeTagProps = _ref7.codeTagProps, codeTagProps = _ref7$codeTagProps === void 0 ? {
            className: language ? "language-".concat(language) : undefined,
            style: $cdb1ec97e7c7db94$var$_objectSpread($cdb1ec97e7c7db94$var$_objectSpread({}, style['code[class*="language-"]']), style['code[class*="language-'.concat(language, '"]')])
        } : _ref7$codeTagProps, _ref7$useInlineStyles = _ref7.useInlineStyles, useInlineStyles = _ref7$useInlineStyles === void 0 ? true : _ref7$useInlineStyles, _ref7$showLineNumbers = _ref7.showLineNumbers, showLineNumbers = _ref7$showLineNumbers === void 0 ? false : _ref7$showLineNumbers, _ref7$showInlineLineN = _ref7.showInlineLineNumbers, showInlineLineNumbers = _ref7$showInlineLineN === void 0 ? true : _ref7$showInlineLineN, _ref7$startingLineNum = _ref7.startingLineNumber, startingLineNumber = _ref7$startingLineNum === void 0 ? 1 : _ref7$startingLineNum, lineNumberContainerStyle = _ref7.lineNumberContainerStyle, _ref7$lineNumberStyle = _ref7.lineNumberStyle, lineNumberStyle = _ref7$lineNumberStyle === void 0 ? {} : _ref7$lineNumberStyle, wrapLines = _ref7.wrapLines, _ref7$wrapLongLines = _ref7.wrapLongLines, wrapLongLines = _ref7$wrapLongLines === void 0 ? false : _ref7$wrapLongLines, _ref7$lineProps = _ref7.lineProps, lineProps = _ref7$lineProps === void 0 ? {} : _ref7$lineProps, renderer = _ref7.renderer, _ref7$PreTag = _ref7.PreTag, PreTag = _ref7$PreTag === void 0 ? "pre" : _ref7$PreTag, _ref7$CodeTag = _ref7.CodeTag, CodeTag = _ref7$CodeTag === void 0 ? "code" : _ref7$CodeTag, _ref7$code = _ref7.code, code = _ref7$code === void 0 ? (Array.isArray(children) ? children[0] : children) || "" : _ref7$code, astGenerator = _ref7.astGenerator, rest = (0, $axRDW.default)(_ref7, $cdb1ec97e7c7db94$var$_excluded);
        astGenerator = astGenerator || defaultAstGenerator;
        var allLineNumbers = showLineNumbers ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($cdb1ec97e7c7db94$var$AllLineNumbers, {
            containerStyle: lineNumberContainerStyle,
            codeStyle: codeTagProps.style || {},
            numberStyle: lineNumberStyle,
            startingLineNumber: startingLineNumber,
            codeString: code
        }) : null;
        var defaultPreStyle = style.hljs || style['pre[class*="language-"]'] || {
            backgroundColor: "#fff"
        };
        var generatorClassName = $cdb1ec97e7c7db94$var$isHighlightJs(astGenerator) ? "hljs" : "prismjs";
        var preProps = useInlineStyles ? Object.assign({}, rest, {
            style: Object.assign({}, defaultPreStyle, customStyle)
        }) : Object.assign({}, rest, {
            className: rest.className ? "".concat(generatorClassName, " ").concat(rest.className) : generatorClassName,
            style: Object.assign({}, customStyle)
        });
        if (wrapLongLines) codeTagProps.style = $cdb1ec97e7c7db94$var$_objectSpread($cdb1ec97e7c7db94$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre-wrap"
        });
        else codeTagProps.style = $cdb1ec97e7c7db94$var$_objectSpread($cdb1ec97e7c7db94$var$_objectSpread({}, codeTagProps.style), {}, {
            whiteSpace: "pre"
        });
        if (!astGenerator) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(PreTag, preProps, allLineNumbers, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(CodeTag, codeTagProps, code));
        /*
     * Some custom renderers rely on individual row elements so we need to turn wrapLines on
     * if renderer is provided and wrapLines is undefined.
     */ if (wrapLines === undefined && renderer || wrapLongLines) wrapLines = true;
        renderer = renderer || $cdb1ec97e7c7db94$var$defaultRenderer;
        var defaultCodeValue = [
            {
                type: "text",
                value: code
            }
        ];
        var codeTree = $cdb1ec97e7c7db94$var$getCodeTree({
            astGenerator: astGenerator,
            language: language,
            code: code,
            defaultCodeValue: defaultCodeValue
        });
        if (codeTree.language === null) codeTree.value = defaultCodeValue;
         // determine largest line number so that we can force minWidth on all linenumber elements
        var largestLineNumber = codeTree.value.length + startingLineNumber;
        var rows = $cdb1ec97e7c7db94$var$processLines(codeTree, wrapLines, lineProps, showLineNumbers, showInlineLineNumbers, startingLineNumber, largestLineNumber, lineNumberStyle, wrapLongLines);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(PreTag, preProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(CodeTag, codeTagProps, !showInlineLineNumbers && allLineNumbers, renderer({
            rows: rows,
            stylesheet: style,
            useInlineStyles: useInlineStyles
        })));
    };
}

});
parcelRequire.register("axRDW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7ad698e16bb4dc98$export$2e2bcd8739ae039; });

var $5xm06 = parcelRequire("5xm06");
function $7ad698e16bb4dc98$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = (0, $5xm06.default)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

});
parcelRequire.register("5xm06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $408119b633eafc1a$export$2e2bcd8739ae039; });
function $408119b633eafc1a$export$2e2bcd8739ae039(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

});


parcelRequire.register("chyHL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8f11fe37aa2339fd$export$2e2bcd8739ae039; });

var $2EDeS = parcelRequire("2EDeS");

var $4eSww = parcelRequire("4eSww");

var $4NGiu = parcelRequire("4NGiu");

var $ae7x5 = parcelRequire("ae7x5");
function $8f11fe37aa2339fd$export$2e2bcd8739ae039(arr) {
    return (0, $2EDeS.default)(arr) || (0, $4eSww.default)(arr) || (0, $4NGiu.default)(arr) || (0, $ae7x5.default)();
}

});
parcelRequire.register("2EDeS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1eedc142345bd782$export$2e2bcd8739ae039; });

var $byrSk = parcelRequire("byrSk");
function $1eedc142345bd782$export$2e2bcd8739ae039(arr) {
    if (Array.isArray(arr)) return (0, $byrSk.default)(arr);
}

});
parcelRequire.register("byrSk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86987e2335c57e60$export$2e2bcd8739ae039; });
function $86987e2335c57e60$export$2e2bcd8739ae039(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});


parcelRequire.register("4eSww", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3162c37d435bde89$export$2e2bcd8739ae039; });
function $3162c37d435bde89$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("4NGiu", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $37ec8c5f7cabea2f$export$2e2bcd8739ae039; });

var $byrSk = parcelRequire("byrSk");
function $37ec8c5f7cabea2f$export$2e2bcd8739ae039(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $byrSk.default)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $byrSk.default)(o, minLen);
}

});

parcelRequire.register("ae7x5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77210e0775aa744a$export$2e2bcd8739ae039; });
function $77210e0775aa744a$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRequire.register("2YtfS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $22a7e0cfff84ff41$export$2e2bcd8739ae039; });

var $6ga92 = parcelRequire("6ga92");

var $3boID = parcelRequire("3boID");

var $eCoWV = parcelRequire("eCoWV");
function $22a7e0cfff84ff41$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $22a7e0cfff84ff41$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $22a7e0cfff84ff41$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $3boID.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $22a7e0cfff84ff41$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
//
// Super simple, non-algorithmic solution since the
// number of class names will not be greater than 4
function $22a7e0cfff84ff41$var$powerSetPermutations(arr) {
    var arrLength = arr.length;
    if (arrLength === 0 || arrLength === 1) return arr;
    if (arrLength === 2) // prettier-ignore
    return [
        arr[0],
        arr[1],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength === 3) return [
        arr[0],
        arr[1],
        arr[2],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
    if (arrLength >= 4) // Currently does not support more than 4 extra
    // class names (after `.token` has been removed)
    return [
        arr[0],
        arr[1],
        arr[2],
        arr[3],
        "".concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[0], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[0], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[1], ".").concat(arr[2], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[1], ".").concat(arr[3], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[0], ".").concat(arr[3], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[3]),
        "".concat(arr[2], ".").concat(arr[1], ".").concat(arr[3], ".").concat(arr[0]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[2], ".").concat(arr[3], ".").concat(arr[1], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[1], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[0], ".").concat(arr[2], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[0], ".").concat(arr[2]),
        "".concat(arr[3], ".").concat(arr[1], ".").concat(arr[2], ".").concat(arr[0]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[0], ".").concat(arr[1]),
        "".concat(arr[3], ".").concat(arr[2], ".").concat(arr[1], ".").concat(arr[0])
    ];
}
var $22a7e0cfff84ff41$var$classNameCombinations = {};
function $22a7e0cfff84ff41$var$getClassNameCombinations(classNames) {
    if (classNames.length === 0 || classNames.length === 1) return classNames;
    var key = classNames.join(".");
    if (!$22a7e0cfff84ff41$var$classNameCombinations[key]) $22a7e0cfff84ff41$var$classNameCombinations[key] = $22a7e0cfff84ff41$var$powerSetPermutations(classNames);
    return $22a7e0cfff84ff41$var$classNameCombinations[key];
}
function $22a7e0cfff84ff41$export$28a8c6cb018dfadc(classNames) {
    var elementStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var stylesheet = arguments.length > 2 ? arguments[2] : undefined;
    var nonTokenClassNames = classNames.filter(function(className) {
        return className !== "token";
    });
    var classNamesCombinations = $22a7e0cfff84ff41$var$getClassNameCombinations(nonTokenClassNames);
    return classNamesCombinations.reduce(function(styleObject, className) {
        return $22a7e0cfff84ff41$var$_objectSpread($22a7e0cfff84ff41$var$_objectSpread({}, styleObject), stylesheet[className]);
    }, elementStyle);
}
function $22a7e0cfff84ff41$export$d0f1f443a3b7b5(classNames) {
    return classNames.join(" ");
}
function $22a7e0cfff84ff41$export$86fb3c3a621e8db6(stylesheet, useInlineStyles) {
    var childrenCount = 0;
    return function(children) {
        childrenCount += 1;
        return children.map(function(child, i) {
            return $22a7e0cfff84ff41$export$2e2bcd8739ae039({
                node: child,
                stylesheet: stylesheet,
                useInlineStyles: useInlineStyles,
                key: "code-segment-".concat(childrenCount, "-").concat(i)
            });
        });
    };
}
function $22a7e0cfff84ff41$export$2e2bcd8739ae039(_ref) {
    var node = _ref.node, stylesheet = _ref.stylesheet, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, useInlineStyles = _ref.useInlineStyles, key = _ref.key;
    var properties = node.properties, type = node.type, TagName = node.tagName, value = node.value;
    if (type === "text") return value;
    else if (TagName) {
        var childrenCreator = $22a7e0cfff84ff41$export$86fb3c3a621e8db6(stylesheet, useInlineStyles);
        var props;
        if (!useInlineStyles) props = $22a7e0cfff84ff41$var$_objectSpread($22a7e0cfff84ff41$var$_objectSpread({}, properties), {}, {
            className: $22a7e0cfff84ff41$export$d0f1f443a3b7b5(properties.className)
        });
        else {
            var allStylesheetSelectors = Object.keys(stylesheet).reduce(function(classes, selector) {
                selector.split(".").forEach(function(className) {
                    if (!classes.includes(className)) classes.push(className);
                });
                return classes;
            }, []); // For compatibility with older versions of react-syntax-highlighter
            var startingClassName = properties.className && properties.className.includes("token") ? [
                "token"
            ] : [];
            var className = properties.className && startingClassName.concat(properties.className.filter(function(className) {
                return !allStylesheetSelectors.includes(className);
            }));
            props = $22a7e0cfff84ff41$var$_objectSpread($22a7e0cfff84ff41$var$_objectSpread({}, properties), {}, {
                className: $22a7e0cfff84ff41$export$d0f1f443a3b7b5(className) || undefined,
                style: $22a7e0cfff84ff41$export$28a8c6cb018dfadc(properties.className, Object.assign({}, properties.style, style), stylesheet)
            });
        }
        var children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(TagName, (0, $6ga92.default)({
            key: key
        }, props), children);
    }
}

});

parcelRequire.register("dwXN8", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $9d9ca4db7c42324d$export$2e2bcd8739ae039; });
var $9d9ca4db7c42324d$export$2e2bcd8739ae039 = function(astGenerator, language) {
    var langs = astGenerator.listLanguages();
    return langs.indexOf(language) !== -1;
};

});



parcelRequire.register("65cmd", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $46dccb9fbec47303$export$2e2bcd8739ae039; });

var $3hJU4 = parcelRequire("3hJU4");





















































































































































































































































































var $46dccb9fbec47303$export$2e2bcd8739ae039 = {
    abap: (0, $3hJU4.default)("abap", function() {
        return (parcelRequire("VQhXe"));
    }),
    abnf: (0, $3hJU4.default)("abnf", function() {
        return (parcelRequire("fAA5B"));
    }),
    actionscript: (0, $3hJU4.default)("actionscript", function() {
        return (parcelRequire("cQv3p"));
    }),
    ada: (0, $3hJU4.default)("ada", function() {
        return (parcelRequire("l2oyu"));
    }),
    agda: (0, $3hJU4.default)("agda", function() {
        return (parcelRequire("G8tiW"));
    }),
    al: (0, $3hJU4.default)("al", function() {
        return (parcelRequire("k2w5O"));
    }),
    antlr4: (0, $3hJU4.default)("antlr4", function() {
        return (parcelRequire("bCSSY"));
    }),
    apacheconf: (0, $3hJU4.default)("apacheconf", function() {
        return (parcelRequire("f26u9"));
    }),
    apex: (0, $3hJU4.default)("apex", function() {
        return (parcelRequire("1of6S"));
    }),
    apl: (0, $3hJU4.default)("apl", function() {
        return (parcelRequire("1uhHG"));
    }),
    applescript: (0, $3hJU4.default)("applescript", function() {
        return (parcelRequire("fFbeB"));
    }),
    aql: (0, $3hJU4.default)("aql", function() {
        return (parcelRequire("2FSY0"));
    }),
    arduino: (0, $3hJU4.default)("arduino", function() {
        return (parcelRequire("eBIxp"));
    }),
    arff: (0, $3hJU4.default)("arff", function() {
        return (parcelRequire("djjDt"));
    }),
    asciidoc: (0, $3hJU4.default)("asciidoc", function() {
        return (parcelRequire("5zsb1"));
    }),
    asm6502: (0, $3hJU4.default)("asm6502", function() {
        return (parcelRequire("htBhT"));
    }),
    asmatmel: (0, $3hJU4.default)("asmatmel", function() {
        return (parcelRequire("89qx3"));
    }),
    aspnet: (0, $3hJU4.default)("aspnet", function() {
        return (parcelRequire("jeg6x"));
    }),
    autohotkey: (0, $3hJU4.default)("autohotkey", function() {
        return (parcelRequire("a5vZ6"));
    }),
    autoit: (0, $3hJU4.default)("autoit", function() {
        return (parcelRequire("7K6Hd"));
    }),
    avisynth: (0, $3hJU4.default)("avisynth", function() {
        return (parcelRequire("bkJG5"));
    }),
    avroIdl: (0, $3hJU4.default)("avroIdl", function() {
        return (parcelRequire("lPKKo"));
    }),
    bash: (0, $3hJU4.default)("bash", function() {
        return (parcelRequire("lKDJ7"));
    }),
    basic: (0, $3hJU4.default)("basic", function() {
        return (parcelRequire("fvWrT"));
    }),
    batch: (0, $3hJU4.default)("batch", function() {
        return (parcelRequire("dPPZE"));
    }),
    bbcode: (0, $3hJU4.default)("bbcode", function() {
        return (parcelRequire("9pQQP"));
    }),
    bicep: (0, $3hJU4.default)("bicep", function() {
        return (parcelRequire("46m47"));
    }),
    birb: (0, $3hJU4.default)("birb", function() {
        return (parcelRequire("84FtO"));
    }),
    bison: (0, $3hJU4.default)("bison", function() {
        return (parcelRequire("1MCGo"));
    }),
    bnf: (0, $3hJU4.default)("bnf", function() {
        return (parcelRequire("9Uvgg"));
    }),
    brainfuck: (0, $3hJU4.default)("brainfuck", function() {
        return (parcelRequire("1B2vZ"));
    }),
    brightscript: (0, $3hJU4.default)("brightscript", function() {
        return (parcelRequire("anRqW"));
    }),
    bro: (0, $3hJU4.default)("bro", function() {
        return (parcelRequire("dCmWf"));
    }),
    bsl: (0, $3hJU4.default)("bsl", function() {
        return (parcelRequire("bHncu"));
    }),
    c: (0, $3hJU4.default)("c", function() {
        return (parcelRequire("jdgFF"));
    }),
    cfscript: (0, $3hJU4.default)("cfscript", function() {
        return (parcelRequire("4FQiT"));
    }),
    chaiscript: (0, $3hJU4.default)("chaiscript", function() {
        return (parcelRequire("6TuUS"));
    }),
    cil: (0, $3hJU4.default)("cil", function() {
        return (parcelRequire("7aclN"));
    }),
    clike: (0, $3hJU4.default)("clike", function() {
        return (parcelRequire("i9vXA"));
    }),
    clojure: (0, $3hJU4.default)("clojure", function() {
        return (parcelRequire("bgldz"));
    }),
    cmake: (0, $3hJU4.default)("cmake", function() {
        return (parcelRequire("i44uF"));
    }),
    cobol: (0, $3hJU4.default)("cobol", function() {
        return (parcelRequire("fnKoi"));
    }),
    coffeescript: (0, $3hJU4.default)("coffeescript", function() {
        return (parcelRequire("cDU5U"));
    }),
    concurnas: (0, $3hJU4.default)("concurnas", function() {
        return (parcelRequire("fe8X7"));
    }),
    coq: (0, $3hJU4.default)("coq", function() {
        return (parcelRequire("8nuOQ"));
    }),
    cpp: (0, $3hJU4.default)("cpp", function() {
        return (parcelRequire("hhInQ"));
    }),
    crystal: (0, $3hJU4.default)("crystal", function() {
        return (parcelRequire("kWG6x"));
    }),
    csharp: (0, $3hJU4.default)("csharp", function() {
        return (parcelRequire("agR5w"));
    }),
    cshtml: (0, $3hJU4.default)("cshtml", function() {
        return (parcelRequire("9mSbL"));
    }),
    csp: (0, $3hJU4.default)("csp", function() {
        return (parcelRequire("l1Baa"));
    }),
    cssExtras: (0, $3hJU4.default)("cssExtras", function() {
        return (parcelRequire("2IX1F"));
    }),
    css: (0, $3hJU4.default)("css", function() {
        return (parcelRequire("8pXhk"));
    }),
    csv: (0, $3hJU4.default)("csv", function() {
        return (parcelRequire("aqNYl"));
    }),
    cypher: (0, $3hJU4.default)("cypher", function() {
        return (parcelRequire("1y3mT"));
    }),
    d: (0, $3hJU4.default)("d", function() {
        return (parcelRequire("im0e2"));
    }),
    dart: (0, $3hJU4.default)("dart", function() {
        return (parcelRequire("6AFX4"));
    }),
    dataweave: (0, $3hJU4.default)("dataweave", function() {
        return (parcelRequire("39PsL"));
    }),
    dax: (0, $3hJU4.default)("dax", function() {
        return (parcelRequire("accYg"));
    }),
    dhall: (0, $3hJU4.default)("dhall", function() {
        return (parcelRequire("74Sfk"));
    }),
    diff: (0, $3hJU4.default)("diff", function() {
        return (parcelRequire("dIUsQ"));
    }),
    django: (0, $3hJU4.default)("django", function() {
        return (parcelRequire("beYGA"));
    }),
    dnsZoneFile: (0, $3hJU4.default)("dnsZoneFile", function() {
        return (parcelRequire("b9O80"));
    }),
    docker: (0, $3hJU4.default)("docker", function() {
        return (parcelRequire("1WlcT"));
    }),
    dot: (0, $3hJU4.default)("dot", function() {
        return (parcelRequire("8rNFv"));
    }),
    ebnf: (0, $3hJU4.default)("ebnf", function() {
        return (parcelRequire("eTUqo"));
    }),
    editorconfig: (0, $3hJU4.default)("editorconfig", function() {
        return (parcelRequire("hWaeS"));
    }),
    eiffel: (0, $3hJU4.default)("eiffel", function() {
        return (parcelRequire("dU5sp"));
    }),
    ejs: (0, $3hJU4.default)("ejs", function() {
        return (parcelRequire("axSCC"));
    }),
    elixir: (0, $3hJU4.default)("elixir", function() {
        return (parcelRequire("bptOA"));
    }),
    elm: (0, $3hJU4.default)("elm", function() {
        return (parcelRequire("8c4P6"));
    }),
    erb: (0, $3hJU4.default)("erb", function() {
        return (parcelRequire("jFXYB"));
    }),
    erlang: (0, $3hJU4.default)("erlang", function() {
        return (parcelRequire("9EBGX"));
    }),
    etlua: (0, $3hJU4.default)("etlua", function() {
        return (parcelRequire("1i76r"));
    }),
    excelFormula: (0, $3hJU4.default)("excelFormula", function() {
        return (parcelRequire("ckvYK"));
    }),
    factor: (0, $3hJU4.default)("factor", function() {
        return (parcelRequire("7kVpg"));
    }),
    falselang: (0, $3hJU4.default)("falselang", function() {
        return (parcelRequire("9DW7S"));
    }),
    firestoreSecurityRules: (0, $3hJU4.default)("firestoreSecurityRules", function() {
        return (parcelRequire("3kbSb"));
    }),
    flow: (0, $3hJU4.default)("flow", function() {
        return (parcelRequire("3jaFL"));
    }),
    fortran: (0, $3hJU4.default)("fortran", function() {
        return (parcelRequire("eRjuN"));
    }),
    fsharp: (0, $3hJU4.default)("fsharp", function() {
        return (parcelRequire("iUsKN"));
    }),
    ftl: (0, $3hJU4.default)("ftl", function() {
        return (parcelRequire("dgdP1"));
    }),
    gap: (0, $3hJU4.default)("gap", function() {
        return (parcelRequire("erTtS"));
    }),
    gcode: (0, $3hJU4.default)("gcode", function() {
        return (parcelRequire("dtpGK"));
    }),
    gdscript: (0, $3hJU4.default)("gdscript", function() {
        return (parcelRequire("62A7h"));
    }),
    gedcom: (0, $3hJU4.default)("gedcom", function() {
        return (parcelRequire("7Q20B"));
    }),
    gherkin: (0, $3hJU4.default)("gherkin", function() {
        return (parcelRequire("6jJPW"));
    }),
    git: (0, $3hJU4.default)("git", function() {
        return (parcelRequire("62UCV"));
    }),
    glsl: (0, $3hJU4.default)("glsl", function() {
        return (parcelRequire("i3vZQ"));
    }),
    gml: (0, $3hJU4.default)("gml", function() {
        return (parcelRequire("cLBxM"));
    }),
    gn: (0, $3hJU4.default)("gn", function() {
        return (parcelRequire("98CIX"));
    }),
    goModule: (0, $3hJU4.default)("goModule", function() {
        return (parcelRequire("lNToK"));
    }),
    go: (0, $3hJU4.default)("go", function() {
        return (parcelRequire("bxFp3"));
    }),
    graphql: (0, $3hJU4.default)("graphql", function() {
        return (parcelRequire("1FUeM"));
    }),
    groovy: (0, $3hJU4.default)("groovy", function() {
        return (parcelRequire("9glNH"));
    }),
    haml: (0, $3hJU4.default)("haml", function() {
        return (parcelRequire("15xoa"));
    }),
    handlebars: (0, $3hJU4.default)("handlebars", function() {
        return (parcelRequire("1q2ha"));
    }),
    haskell: (0, $3hJU4.default)("haskell", function() {
        return (parcelRequire("19aTD"));
    }),
    haxe: (0, $3hJU4.default)("haxe", function() {
        return (parcelRequire("8CkFG"));
    }),
    hcl: (0, $3hJU4.default)("hcl", function() {
        return (parcelRequire("rwaEV"));
    }),
    hlsl: (0, $3hJU4.default)("hlsl", function() {
        return (parcelRequire("3wJ0W"));
    }),
    hoon: (0, $3hJU4.default)("hoon", function() {
        return (parcelRequire("i3aLv"));
    }),
    hpkp: (0, $3hJU4.default)("hpkp", function() {
        return (parcelRequire("joH9K"));
    }),
    hsts: (0, $3hJU4.default)("hsts", function() {
        return (parcelRequire("c0AJ6"));
    }),
    http: (0, $3hJU4.default)("http", function() {
        return (parcelRequire("bCB8r"));
    }),
    ichigojam: (0, $3hJU4.default)("ichigojam", function() {
        return (parcelRequire("6HYJ5"));
    }),
    icon: (0, $3hJU4.default)("icon", function() {
        return (parcelRequire("kXWSz"));
    }),
    icuMessageFormat: (0, $3hJU4.default)("icuMessageFormat", function() {
        return (parcelRequire("8BM2W"));
    }),
    idris: (0, $3hJU4.default)("idris", function() {
        return (parcelRequire("kj5gP"));
    }),
    iecst: (0, $3hJU4.default)("iecst", function() {
        return (parcelRequire("2Hxf3"));
    }),
    ignore: (0, $3hJU4.default)("ignore", function() {
        return (parcelRequire("lLy2M"));
    }),
    inform7: (0, $3hJU4.default)("inform7", function() {
        return (parcelRequire("YT9iw"));
    }),
    ini: (0, $3hJU4.default)("ini", function() {
        return (parcelRequire("9If2w"));
    }),
    io: (0, $3hJU4.default)("io", function() {
        return (parcelRequire("kuJOe"));
    }),
    j: (0, $3hJU4.default)("j", function() {
        return (parcelRequire("5jkNl"));
    }),
    java: (0, $3hJU4.default)("java", function() {
        return (parcelRequire("efHKp"));
    }),
    javadoc: (0, $3hJU4.default)("javadoc", function() {
        return (parcelRequire("jZv8v"));
    }),
    javadoclike: (0, $3hJU4.default)("javadoclike", function() {
        return (parcelRequire("idTUW"));
    }),
    javascript: (0, $3hJU4.default)("javascript", function() {
        return (parcelRequire("aBCE9"));
    }),
    javastacktrace: (0, $3hJU4.default)("javastacktrace", function() {
        return (parcelRequire("82zIn"));
    }),
    jexl: (0, $3hJU4.default)("jexl", function() {
        return (parcelRequire("fh0bZ"));
    }),
    jolie: (0, $3hJU4.default)("jolie", function() {
        return (parcelRequire("c3nEy"));
    }),
    jq: (0, $3hJU4.default)("jq", function() {
        return (parcelRequire("k2qrE"));
    }),
    jsExtras: (0, $3hJU4.default)("jsExtras", function() {
        return (parcelRequire("5SYeM"));
    }),
    jsTemplates: (0, $3hJU4.default)("jsTemplates", function() {
        return (parcelRequire("cFAKZ"));
    }),
    jsdoc: (0, $3hJU4.default)("jsdoc", function() {
        return (parcelRequire("BR03b"));
    }),
    json: (0, $3hJU4.default)("json", function() {
        return (parcelRequire("2Lfmo"));
    }),
    json5: (0, $3hJU4.default)("json5", function() {
        return (parcelRequire("1gAhA"));
    }),
    jsonp: (0, $3hJU4.default)("jsonp", function() {
        return (parcelRequire("bL86P"));
    }),
    jsstacktrace: (0, $3hJU4.default)("jsstacktrace", function() {
        return (parcelRequire("jQD98"));
    }),
    jsx: (0, $3hJU4.default)("jsx", function() {
        return (parcelRequire("ii0XJ"));
    }),
    julia: (0, $3hJU4.default)("julia", function() {
        return (parcelRequire("bqvaZ"));
    }),
    keepalived: (0, $3hJU4.default)("keepalived", function() {
        return (parcelRequire("21RFR"));
    }),
    keyman: (0, $3hJU4.default)("keyman", function() {
        return (parcelRequire("gHnwx"));
    }),
    kotlin: (0, $3hJU4.default)("kotlin", function() {
        return (parcelRequire("bc4rn"));
    }),
    kumir: (0, $3hJU4.default)("kumir", function() {
        return (parcelRequire("jnGOz"));
    }),
    kusto: (0, $3hJU4.default)("kusto", function() {
        return (parcelRequire("1gf1o"));
    }),
    latex: (0, $3hJU4.default)("latex", function() {
        return (parcelRequire("kzB6o"));
    }),
    latte: (0, $3hJU4.default)("latte", function() {
        return (parcelRequire("jv371"));
    }),
    less: (0, $3hJU4.default)("less", function() {
        return (parcelRequire("fFH7K"));
    }),
    lilypond: (0, $3hJU4.default)("lilypond", function() {
        return (parcelRequire("7eZxE"));
    }),
    liquid: (0, $3hJU4.default)("liquid", function() {
        return (parcelRequire("1s7Et"));
    }),
    lisp: (0, $3hJU4.default)("lisp", function() {
        return (parcelRequire("aoc5C"));
    }),
    livescript: (0, $3hJU4.default)("livescript", function() {
        return (parcelRequire("bjXvJ"));
    }),
    llvm: (0, $3hJU4.default)("llvm", function() {
        return (parcelRequire("l1w7o"));
    }),
    log: (0, $3hJU4.default)("log", function() {
        return (parcelRequire("6rRXq"));
    }),
    lolcode: (0, $3hJU4.default)("lolcode", function() {
        return (parcelRequire("02YK2"));
    }),
    lua: (0, $3hJU4.default)("lua", function() {
        return (parcelRequire("jeZZv"));
    }),
    magma: (0, $3hJU4.default)("magma", function() {
        return (parcelRequire("806j1"));
    }),
    makefile: (0, $3hJU4.default)("makefile", function() {
        return (parcelRequire("i6Tmd"));
    }),
    markdown: (0, $3hJU4.default)("markdown", function() {
        return (parcelRequire("ij3wI"));
    }),
    markupTemplating: (0, $3hJU4.default)("markupTemplating", function() {
        return (parcelRequire("1s2Jl"));
    }),
    markup: (0, $3hJU4.default)("markup", function() {
        return (parcelRequire("OL5Je"));
    }),
    matlab: (0, $3hJU4.default)("matlab", function() {
        return (parcelRequire("lr1aG"));
    }),
    maxscript: (0, $3hJU4.default)("maxscript", function() {
        return (parcelRequire("hknA9"));
    }),
    mel: (0, $3hJU4.default)("mel", function() {
        return (parcelRequire("e1nQl"));
    }),
    mermaid: (0, $3hJU4.default)("mermaid", function() {
        return (parcelRequire("2szdX"));
    }),
    mizar: (0, $3hJU4.default)("mizar", function() {
        return (parcelRequire("2gIxG"));
    }),
    mongodb: (0, $3hJU4.default)("mongodb", function() {
        return (parcelRequire("67RJf"));
    }),
    monkey: (0, $3hJU4.default)("monkey", function() {
        return (parcelRequire("2n42U"));
    }),
    moonscript: (0, $3hJU4.default)("moonscript", function() {
        return (parcelRequire("8S3gx"));
    }),
    n1ql: (0, $3hJU4.default)("n1ql", function() {
        return (parcelRequire("jjvCr"));
    }),
    n4js: (0, $3hJU4.default)("n4js", function() {
        return (parcelRequire("ds31D"));
    }),
    nand2tetrisHdl: (0, $3hJU4.default)("nand2tetrisHdl", function() {
        return (parcelRequire("kT1K4"));
    }),
    naniscript: (0, $3hJU4.default)("naniscript", function() {
        return (parcelRequire("cdMfC"));
    }),
    nasm: (0, $3hJU4.default)("nasm", function() {
        return (parcelRequire("enPYR"));
    }),
    neon: (0, $3hJU4.default)("neon", function() {
        return (parcelRequire("8sZvQ"));
    }),
    nevod: (0, $3hJU4.default)("nevod", function() {
        return (parcelRequire("9OZl6"));
    }),
    nginx: (0, $3hJU4.default)("nginx", function() {
        return (parcelRequire("e3dSR"));
    }),
    nim: (0, $3hJU4.default)("nim", function() {
        return (parcelRequire("jJmhR"));
    }),
    nix: (0, $3hJU4.default)("nix", function() {
        return (parcelRequire("2joyv"));
    }),
    nsis: (0, $3hJU4.default)("nsis", function() {
        return (parcelRequire("fURUO"));
    }),
    objectivec: (0, $3hJU4.default)("objectivec", function() {
        return (parcelRequire("RgQAb"));
    }),
    ocaml: (0, $3hJU4.default)("ocaml", function() {
        return (parcelRequire("4Csbb"));
    }),
    opencl: (0, $3hJU4.default)("opencl", function() {
        return (parcelRequire("5RzEM"));
    }),
    openqasm: (0, $3hJU4.default)("openqasm", function() {
        return (parcelRequire("jWoDe"));
    }),
    oz: (0, $3hJU4.default)("oz", function() {
        return (parcelRequire("cVw2f"));
    }),
    parigp: (0, $3hJU4.default)("parigp", function() {
        return (parcelRequire("aw6wj"));
    }),
    parser: (0, $3hJU4.default)("parser", function() {
        return (parcelRequire("kwi9r"));
    }),
    pascal: (0, $3hJU4.default)("pascal", function() {
        return (parcelRequire("hLe9n"));
    }),
    pascaligo: (0, $3hJU4.default)("pascaligo", function() {
        return (parcelRequire("4EZIw"));
    }),
    pcaxis: (0, $3hJU4.default)("pcaxis", function() {
        return (parcelRequire("1Ij7P"));
    }),
    peoplecode: (0, $3hJU4.default)("peoplecode", function() {
        return (parcelRequire("k3zYf"));
    }),
    perl: (0, $3hJU4.default)("perl", function() {
        return (parcelRequire("cmcpt"));
    }),
    phpExtras: (0, $3hJU4.default)("phpExtras", function() {
        return (parcelRequire("5nKBE"));
    }),
    php: (0, $3hJU4.default)("php", function() {
        return (parcelRequire("jvtlM"));
    }),
    phpdoc: (0, $3hJU4.default)("phpdoc", function() {
        return (parcelRequire("d1axh"));
    }),
    plsql: (0, $3hJU4.default)("plsql", function() {
        return (parcelRequire("4J3RW"));
    }),
    powerquery: (0, $3hJU4.default)("powerquery", function() {
        return (parcelRequire("3lOhQ"));
    }),
    powershell: (0, $3hJU4.default)("powershell", function() {
        return (parcelRequire("9KEt6"));
    }),
    processing: (0, $3hJU4.default)("processing", function() {
        return (parcelRequire("jWYNu"));
    }),
    prolog: (0, $3hJU4.default)("prolog", function() {
        return (parcelRequire("ceonZ"));
    }),
    promql: (0, $3hJU4.default)("promql", function() {
        return (parcelRequire("56Vhv"));
    }),
    properties: (0, $3hJU4.default)("properties", function() {
        return (parcelRequire("fyNtZ"));
    }),
    protobuf: (0, $3hJU4.default)("protobuf", function() {
        return (parcelRequire("bJE3Z"));
    }),
    psl: (0, $3hJU4.default)("psl", function() {
        return (parcelRequire("bxZIv"));
    }),
    pug: (0, $3hJU4.default)("pug", function() {
        return (parcelRequire("inYQH"));
    }),
    puppet: (0, $3hJU4.default)("puppet", function() {
        return (parcelRequire("efiIk"));
    }),
    pure: (0, $3hJU4.default)("pure", function() {
        return (parcelRequire("kHZxV"));
    }),
    purebasic: (0, $3hJU4.default)("purebasic", function() {
        return (parcelRequire("9MspV"));
    }),
    purescript: (0, $3hJU4.default)("purescript", function() {
        return (parcelRequire("aKJrT"));
    }),
    python: (0, $3hJU4.default)("python", function() {
        return (parcelRequire("giD2m"));
    }),
    q: (0, $3hJU4.default)("q", function() {
        return (parcelRequire("rH17d"));
    }),
    qml: (0, $3hJU4.default)("qml", function() {
        return (parcelRequire("aLgm9"));
    }),
    qore: (0, $3hJU4.default)("qore", function() {
        return (parcelRequire("lAXz7"));
    }),
    qsharp: (0, $3hJU4.default)("qsharp", function() {
        return (parcelRequire("ahxPH"));
    }),
    r: (0, $3hJU4.default)("r", function() {
        return (parcelRequire("63AJK"));
    }),
    racket: (0, $3hJU4.default)("racket", function() {
        return (parcelRequire("cIyHm"));
    }),
    reason: (0, $3hJU4.default)("reason", function() {
        return (parcelRequire("dxuFG"));
    }),
    regex: (0, $3hJU4.default)("regex", function() {
        return (parcelRequire("1nOx5"));
    }),
    rego: (0, $3hJU4.default)("rego", function() {
        return (parcelRequire("3o6gr"));
    }),
    renpy: (0, $3hJU4.default)("renpy", function() {
        return (parcelRequire("5S62X"));
    }),
    rest: (0, $3hJU4.default)("rest", function() {
        return (parcelRequire("8xWsj"));
    }),
    rip: (0, $3hJU4.default)("rip", function() {
        return (parcelRequire("dlZxL"));
    }),
    roboconf: (0, $3hJU4.default)("roboconf", function() {
        return (parcelRequire("cktZS"));
    }),
    robotframework: (0, $3hJU4.default)("robotframework", function() {
        return (parcelRequire("iF9po"));
    }),
    ruby: (0, $3hJU4.default)("ruby", function() {
        return (parcelRequire("jK2Bj"));
    }),
    rust: (0, $3hJU4.default)("rust", function() {
        return (parcelRequire("5SoN1"));
    }),
    sas: (0, $3hJU4.default)("sas", function() {
        return (parcelRequire("6y1Bu"));
    }),
    sass: (0, $3hJU4.default)("sass", function() {
        return (parcelRequire("i8Wvm"));
    }),
    scala: (0, $3hJU4.default)("scala", function() {
        return (parcelRequire("9Vmca"));
    }),
    scheme: (0, $3hJU4.default)("scheme", function() {
        return (parcelRequire("cNMhA"));
    }),
    scss: (0, $3hJU4.default)("scss", function() {
        return (parcelRequire("1qKUH"));
    }),
    shellSession: (0, $3hJU4.default)("shellSession", function() {
        return (parcelRequire("bimBe"));
    }),
    smali: (0, $3hJU4.default)("smali", function() {
        return (parcelRequire("c24o5"));
    }),
    smalltalk: (0, $3hJU4.default)("smalltalk", function() {
        return (parcelRequire("Q1Muo"));
    }),
    smarty: (0, $3hJU4.default)("smarty", function() {
        return (parcelRequire("3OZRD"));
    }),
    sml: (0, $3hJU4.default)("sml", function() {
        return (parcelRequire("j6EzP"));
    }),
    solidity: (0, $3hJU4.default)("solidity", function() {
        return (parcelRequire("cM6Su"));
    }),
    solutionFile: (0, $3hJU4.default)("solutionFile", function() {
        return (parcelRequire("04L2G"));
    }),
    soy: (0, $3hJU4.default)("soy", function() {
        return (parcelRequire("koMkR"));
    }),
    sparql: (0, $3hJU4.default)("sparql", function() {
        return (parcelRequire("kIQNg"));
    }),
    splunkSpl: (0, $3hJU4.default)("splunkSpl", function() {
        return (parcelRequire("3Ly74"));
    }),
    sqf: (0, $3hJU4.default)("sqf", function() {
        return (parcelRequire("grqj0"));
    }),
    sql: (0, $3hJU4.default)("sql", function() {
        return (parcelRequire("2PG2p"));
    }),
    squirrel: (0, $3hJU4.default)("squirrel", function() {
        return (parcelRequire("8QL9m"));
    }),
    stan: (0, $3hJU4.default)("stan", function() {
        return (parcelRequire("kjfPW"));
    }),
    stylus: (0, $3hJU4.default)("stylus", function() {
        return (parcelRequire("5Dd2v"));
    }),
    swift: (0, $3hJU4.default)("swift", function() {
        return (parcelRequire("1Iqc3"));
    }),
    systemd: (0, $3hJU4.default)("systemd", function() {
        return (parcelRequire("j3qWj"));
    }),
    t4Cs: (0, $3hJU4.default)("t4Cs", function() {
        return (parcelRequire("ijFuh"));
    }),
    t4Templating: (0, $3hJU4.default)("t4Templating", function() {
        return (parcelRequire("gCx7S"));
    }),
    t4Vb: (0, $3hJU4.default)("t4Vb", function() {
        return (parcelRequire("j3LkN"));
    }),
    tap: (0, $3hJU4.default)("tap", function() {
        return (parcelRequire("dK0gI"));
    }),
    tcl: (0, $3hJU4.default)("tcl", function() {
        return (parcelRequire("aDp9h"));
    }),
    textile: (0, $3hJU4.default)("textile", function() {
        return (parcelRequire("aIhP4"));
    }),
    toml: (0, $3hJU4.default)("toml", function() {
        return (parcelRequire("2Ke7A"));
    }),
    tremor: (0, $3hJU4.default)("tremor", function() {
        return (parcelRequire("h49zP"));
    }),
    tsx: (0, $3hJU4.default)("tsx", function() {
        return (parcelRequire("4Buvv"));
    }),
    tt2: (0, $3hJU4.default)("tt2", function() {
        return (parcelRequire("b9rbN"));
    }),
    turtle: (0, $3hJU4.default)("turtle", function() {
        return (parcelRequire("2Mxqs"));
    }),
    twig: (0, $3hJU4.default)("twig", function() {
        return (parcelRequire("2HnsA"));
    }),
    typescript: (0, $3hJU4.default)("typescript", function() {
        return (parcelRequire("epI2P"));
    }),
    typoscript: (0, $3hJU4.default)("typoscript", function() {
        return (parcelRequire("kwEJM"));
    }),
    unrealscript: (0, $3hJU4.default)("unrealscript", function() {
        return (parcelRequire("6mol1"));
    }),
    uorazor: (0, $3hJU4.default)("uorazor", function() {
        return (parcelRequire("g3IBY"));
    }),
    uri: (0, $3hJU4.default)("uri", function() {
        return (parcelRequire("hn2Or"));
    }),
    v: (0, $3hJU4.default)("v", function() {
        return (parcelRequire("hhdQe"));
    }),
    vala: (0, $3hJU4.default)("vala", function() {
        return (parcelRequire("d4nTI"));
    }),
    vbnet: (0, $3hJU4.default)("vbnet", function() {
        return (parcelRequire("2IZqT"));
    }),
    velocity: (0, $3hJU4.default)("velocity", function() {
        return (parcelRequire("7Afbe"));
    }),
    verilog: (0, $3hJU4.default)("verilog", function() {
        return (parcelRequire("n6ETd"));
    }),
    vhdl: (0, $3hJU4.default)("vhdl", function() {
        return (parcelRequire("918Kg"));
    }),
    vim: (0, $3hJU4.default)("vim", function() {
        return (parcelRequire("fvzyF"));
    }),
    visualBasic: (0, $3hJU4.default)("visualBasic", function() {
        return (parcelRequire("6j55v"));
    }),
    warpscript: (0, $3hJU4.default)("warpscript", function() {
        return (parcelRequire("kjBIb"));
    }),
    wasm: (0, $3hJU4.default)("wasm", function() {
        return (parcelRequire("5q79a"));
    }),
    webIdl: (0, $3hJU4.default)("webIdl", function() {
        return (parcelRequire("bGZko"));
    }),
    wiki: (0, $3hJU4.default)("wiki", function() {
        return (parcelRequire("e3vOa"));
    }),
    wolfram: (0, $3hJU4.default)("wolfram", function() {
        return (parcelRequire("ifrDm"));
    }),
    wren: (0, $3hJU4.default)("wren", function() {
        return (parcelRequire("9rCWC"));
    }),
    xeora: (0, $3hJU4.default)("xeora", function() {
        return (parcelRequire("jguA9"));
    }),
    xmlDoc: (0, $3hJU4.default)("xmlDoc", function() {
        return (parcelRequire("lHxjZ"));
    }),
    xojo: (0, $3hJU4.default)("xojo", function() {
        return (parcelRequire("6wyau"));
    }),
    xquery: (0, $3hJU4.default)("xquery", function() {
        return (parcelRequire("eKB41"));
    }),
    yaml: (0, $3hJU4.default)("yaml", function() {
        return (parcelRequire("bYIRn"));
    }),
    yang: (0, $3hJU4.default)("yang", function() {
        return (parcelRequire("6Jwmg"));
    }),
    zig: (0, $3hJU4.default)("zig", function() {
        return (parcelRequire("ccEo8"));
    })
};

});
parcelRequire.register("3hJU4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $264691130bf02645$export$2e2bcd8739ae039; });

var $a1Cyq = parcelRequire("a1Cyq");

var $1JWDA = parcelRequire("1JWDA");
var $264691130bf02645$export$2e2bcd8739ae039 = function(name, loader) {
    return /*#__PURE__*/ function() {
        var _ref = (0, $a1Cyq.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1JWDA))).mark(function _callee(registerLanguage) {
            var module;
            return (0, (/*@__PURE__*/$parcel$interopDefault($1JWDA))).wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        _context.next = 2;
                        return loader();
                    case 2:
                        module = _context.sent;
                        registerLanguage(name, module["default"] || module);
                    case 4:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }));
        return function(_x) {
            return _ref.apply(this, arguments);
        };
    }();
};

});

parcelRequire.register("VQhXe", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1oe6x")).then(()=>parcelRequire("1767t"));

});

parcelRequire.register("fAA5B", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bq2OV")).then(()=>parcelRequire("etSlS"));

});

parcelRequire.register("cQv3p", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("flMtV")).then(()=>parcelRequire("8FCRL"));

});

parcelRequire.register("l2oyu", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jXHmI")).then(()=>parcelRequire("gYm84"));

});

parcelRequire.register("G8tiW", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h5SIW")).then(()=>parcelRequire("aL0gY"));

});

parcelRequire.register("k2w5O", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("c7qSc")).then(()=>parcelRequire("j3eJI"));

});

parcelRequire.register("bCSSY", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("liIDN")).then(()=>parcelRequire("7i6TW"));

});

parcelRequire.register("f26u9", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("aIf7G")).then(()=>parcelRequire("i2wGx"));

});

parcelRequire.register("1of6S", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kVrOh")),
    import("./" + (parcelRequire("kucSS")).resolve("gpD1k"))
]).then(()=>parcelRequire("3KRhf"));

});

parcelRequire.register("1uhHG", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4Ohnr")).then(()=>parcelRequire("z2YOS"));

});

parcelRequire.register("fFbeB", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cVXVG")).then(()=>parcelRequire("eBcHC"));

});

parcelRequire.register("2FSY0", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jIqMz")).then(()=>parcelRequire("gbFLF"));

});

parcelRequire.register("eBIxp", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("lB9j1")),
    import("./" + (parcelRequire("kucSS")).resolve("6oE4J"))
]).then(()=>parcelRequire("kRPoj"));

});

parcelRequire.register("djjDt", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5CM95")).then(()=>parcelRequire("6NztI"));

});

parcelRequire.register("5zsb1", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("sYHEh")).then(()=>parcelRequire("gbQiM"));

});

parcelRequire.register("htBhT", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8uvc4")).then(()=>parcelRequire("gYXJD"));

});

parcelRequire.register("89qx3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("e0iRr")).then(()=>parcelRequire("hHnv9"));

});

parcelRequire.register("jeg6x", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jfvjG")),
    import("./" + (parcelRequire("kucSS")).resolve("3oQLy"))
]).then(()=>parcelRequire("1jG9C"));

});

parcelRequire.register("a5vZ6", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bJHQe")).then(()=>parcelRequire("gdczI"));

});

parcelRequire.register("7K6Hd", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7fsXk")).then(()=>parcelRequire("icurM"));

});

parcelRequire.register("bkJG5", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("l2WLu")).then(()=>parcelRequire("5lkLB"));

});

parcelRequire.register("lPKKo", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("XIagy")).then(()=>parcelRequire("htyf4"));

});

parcelRequire.register("lKDJ7", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lmuko")).then(()=>parcelRequire("fmryD"));

});

parcelRequire.register("fvWrT", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iy6py")).then(()=>parcelRequire("fZvLv"));

});

parcelRequire.register("dPPZE", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1Qkyl")).then(()=>parcelRequire("7mxlx"));

});

parcelRequire.register("9pQQP", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eedEN")).then(()=>parcelRequire("dVQG2"));

});

parcelRequire.register("46m47", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8t9N1")).then(()=>parcelRequire("80g8F"));

});

parcelRequire.register("84FtO", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5TgpL")).then(()=>parcelRequire("3r1h7"));

});

parcelRequire.register("1MCGo", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("eRugU"))
]).then(()=>parcelRequire("hSkIh"));

});

parcelRequire.register("9Uvgg", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3Ywsg")).then(()=>parcelRequire("k49zH"));

});

parcelRequire.register("1B2vZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6rzJm")).then(()=>parcelRequire("kKLAn"));

});

parcelRequire.register("anRqW", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("015XD")).then(()=>parcelRequire("bXSlF"));

});

parcelRequire.register("dCmWf", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2zYVN")).then(()=>parcelRequire("dUYF5"));

});

parcelRequire.register("bHncu", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("d43vd")).then(()=>parcelRequire("lQWz7"));

});

parcelRequire.register("jdgFF", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jvicW")).then(()=>parcelRequire("1A6DQ"));

});

parcelRequire.register("4FQiT", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eR7e1")).then(()=>parcelRequire("32TCH"));

});

parcelRequire.register("6TuUS", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("lB9j1")),
    import("./" + (parcelRequire("kucSS")).resolve("8VADW"))
]).then(()=>parcelRequire("h0Fs5"));

});

parcelRequire.register("7aclN", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("auLeR")).then(()=>parcelRequire("awTfj"));

});

parcelRequire.register("i9vXA", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2FTS0")).then(()=>parcelRequire("b3XgG"));

});

parcelRequire.register("bgldz", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eatZX")).then(()=>parcelRequire("fUuaV"));

});

parcelRequire.register("i44uF", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("a65hP")).then(()=>parcelRequire("lQj26"));

});

parcelRequire.register("fnKoi", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("e8QTU")).then(()=>parcelRequire("aCx8w"));

});

parcelRequire.register("cDU5U", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("rEVnD")).then(()=>parcelRequire("1gbP6"));

});

parcelRequire.register("fe8X7", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("23NMz")).then(()=>parcelRequire("4al2b"));

});

parcelRequire.register("8nuOQ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fIQgj")).then(()=>parcelRequire("29EFA"));

});

parcelRequire.register("hhInQ", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("lB9j1"))
]).then(()=>parcelRequire("a5Bm8"));

});

parcelRequire.register("kWG6x", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("1mlUW")),
    import("./" + (parcelRequire("kucSS")).resolve("bm0BN"))
]).then(()=>parcelRequire("4Rvtg"));

});

parcelRequire.register("agR5w", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jfvjG")).then(()=>parcelRequire("5ViEN"));

});

parcelRequire.register("9mSbL", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jfvjG")),
    import("./" + (parcelRequire("kucSS")).resolve("8oiV4"))
]).then(()=>parcelRequire("95Ni5"));

});

parcelRequire.register("l1Baa", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jAVZG")).then(()=>parcelRequire("hQ1LQ"));

});

parcelRequire.register("2IX1F", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2UEJ2")).then(()=>parcelRequire("l4ZZM"));

});

parcelRequire.register("8pXhk", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("imAw7")).then(()=>parcelRequire("9rBkv"));

});

parcelRequire.register("aqNYl", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("l06gU")).then(()=>parcelRequire("2ykEH"));

});

parcelRequire.register("1y3mT", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jDcZs")).then(()=>parcelRequire("bxYfu"));

});

parcelRequire.register("im0e2", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("84oik")).then(()=>parcelRequire("hh8On"));

});

parcelRequire.register("6AFX4", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("94n6B")).then(()=>parcelRequire("kqYyj"));

});

parcelRequire.register("39PsL", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iN6Cw")).then(()=>parcelRequire("cI0vu"));

});

parcelRequire.register("accYg", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("duKOn")).then(()=>parcelRequire("cWIqE"));

});

parcelRequire.register("74Sfk", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("xYKrs")).then(()=>parcelRequire("7nHSf"));

});

parcelRequire.register("dIUsQ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("b7nin")).then(()=>parcelRequire("2WGj5"));

});

parcelRequire.register("beYGA", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("7HLXA"))
]).then(()=>parcelRequire("96TUD"));

});

parcelRequire.register("b9O80", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fbXxr")).then(()=>parcelRequire("2aGrW"));

});

parcelRequire.register("1WlcT", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3nKSi")).then(()=>parcelRequire("lld8G"));

});

parcelRequire.register("8rNFv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7WgWf")).then(()=>parcelRequire("kvgpk"));

});

parcelRequire.register("eTUqo", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lxxM2")).then(()=>parcelRequire("2mk5N"));

});

parcelRequire.register("hWaeS", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("b1OAj")).then(()=>parcelRequire("5XqlK"));

});

parcelRequire.register("dU5sp", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3xnHD")).then(()=>parcelRequire("bRYjd"));

});

parcelRequire.register("axSCC", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("amJjG"))
]).then(()=>parcelRequire("ddY3R"));

});

parcelRequire.register("bptOA", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hP7JI")).then(()=>parcelRequire("3gGr2"));

});

parcelRequire.register("8c4P6", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fzXLF")).then(()=>parcelRequire("lEPCx"));

});

parcelRequire.register("jFXYB", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("1mlUW")),
    import("./" + (parcelRequire("kucSS")).resolve("76j9K"))
]).then(()=>parcelRequire("lHvAq"));

});

parcelRequire.register("9EBGX", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4sJX9")).then(()=>parcelRequire("2NtBO"));

});

parcelRequire.register("1i76r", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("1hmU2")),
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("14sX0"))
]).then(()=>parcelRequire("jIUhN"));

});

parcelRequire.register("ckvYK", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ajhzd")).then(()=>parcelRequire("cr4BK"));

});

parcelRequire.register("7kVpg", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kydci")).then(()=>parcelRequire("82WPS"));

});

parcelRequire.register("9DW7S", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lF09r")).then(()=>parcelRequire("jFJxG"));

});

parcelRequire.register("3kbSb", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hJhtm")).then(()=>parcelRequire("jMMpK"));

});

parcelRequire.register("3jaFL", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cXJeb")).then(()=>parcelRequire("cIxwb"));

});

parcelRequire.register("eRjuN", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2m7ei")).then(()=>parcelRequire("03QCv"));

});

parcelRequire.register("iUsKN", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fdH4A")).then(()=>parcelRequire("jf7iv"));

});

parcelRequire.register("dgdP1", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("5mkyN"))
]).then(()=>parcelRequire("b5qwC"));

});

parcelRequire.register("erTtS", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7gmCM")).then(()=>parcelRequire("bZD3J"));

});

parcelRequire.register("dtpGK", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jAbKc")).then(()=>parcelRequire("ai4ku"));

});

parcelRequire.register("62A7h", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iwpV9")).then(()=>parcelRequire("fVYeA"));

});

parcelRequire.register("7Q20B", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("goiM2")).then(()=>parcelRequire("45n2Y"));

});

parcelRequire.register("6jJPW", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2neQ6")).then(()=>parcelRequire("byaof"));

});

parcelRequire.register("62UCV", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8yVWS")).then(()=>parcelRequire("5Ov6e"));

});

parcelRequire.register("i3vZQ", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("68VWG"))
]).then(()=>parcelRequire("89yiX"));

});

parcelRequire.register("cLBxM", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1e7QC")).then(()=>parcelRequire("4hqQO"));

});

parcelRequire.register("98CIX", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("46j1K")).then(()=>parcelRequire("4uZy3"));

});

parcelRequire.register("lNToK", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("gqUgr")).then(()=>parcelRequire("h6vLP"));

});

parcelRequire.register("bxFp3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bKfkY")).then(()=>parcelRequire("95mPw"));

});

parcelRequire.register("1FUeM", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iAikD")).then(()=>parcelRequire("g5yfy"));

});

parcelRequire.register("9glNH", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2oYMK")).then(()=>parcelRequire("5nbcv"));

});

parcelRequire.register("15xoa", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("1mlUW")),
    import("./" + (parcelRequire("kucSS")).resolve("loqDe"))
]).then(()=>parcelRequire("fcHPy"));

});

parcelRequire.register("1q2ha", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("7ziQQ"))
]).then(()=>parcelRequire("ekzHe"));

});

parcelRequire.register("19aTD", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fwhVo")).then(()=>parcelRequire("7ZUCw"));

});

parcelRequire.register("8CkFG", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3eezj")).then(()=>parcelRequire("eV24C"));

});

parcelRequire.register("rwaEV", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5u9Ss")).then(()=>parcelRequire("2UHfo"));

});

parcelRequire.register("3wJ0W", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("bm8Pb"))
]).then(()=>parcelRequire("2bSbu"));

});

parcelRequire.register("i3aLv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5uZpB")).then(()=>parcelRequire("gWDqI"));

});

parcelRequire.register("joH9K", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bIYP1")).then(()=>parcelRequire("jRQA7"));

});

parcelRequire.register("c0AJ6", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("avc0d")).then(()=>parcelRequire("bHWTz"));

});

parcelRequire.register("bCB8r", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6njks")).then(()=>parcelRequire("5Hn8m"));

});

parcelRequire.register("6HYJ5", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4KTyR")).then(()=>parcelRequire("3wYhq"));

});

parcelRequire.register("kXWSz", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jYmZ7")).then(()=>parcelRequire("gtYvB"));

});

parcelRequire.register("8BM2W", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1n5l2")).then(()=>parcelRequire("dA0RJ"));

});

parcelRequire.register("kj5gP", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("fwhVo")),
    import("./" + (parcelRequire("kucSS")).resolve("UwRW4"))
]).then(()=>parcelRequire("d5GL4"));

});

parcelRequire.register("2Hxf3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3pnqz")).then(()=>parcelRequire("bGpZ1"));

});

parcelRequire.register("lLy2M", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7HH4z")).then(()=>parcelRequire("8wSp7"));

});

parcelRequire.register("YT9iw", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("9dyO1")).then(()=>parcelRequire("5wuRr"));

});

parcelRequire.register("9If2w", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("86atf")).then(()=>parcelRequire("bMnDi"));

});

parcelRequire.register("kuJOe", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hppQg")).then(()=>parcelRequire("20Kym"));

});

parcelRequire.register("5jkNl", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hKxfB")).then(()=>parcelRequire("8v1t4"));

});

parcelRequire.register("efHKp", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4dOmx")).then(()=>parcelRequire("a1XcU"));

});

parcelRequire.register("jZv8v", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("7OX6Q")),
    import("./" + (parcelRequire("kucSS")).resolve("4dOmx")),
    import("./" + (parcelRequire("kucSS")).resolve("4HGci"))
]).then(()=>parcelRequire("japM7"));

});

parcelRequire.register("idTUW", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7OX6Q")).then(()=>parcelRequire("8ijKG"));

});

parcelRequire.register("aBCE9", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("47uWo")).then(()=>parcelRequire("guj8I"));

});

parcelRequire.register("82zIn", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cWx5I")).then(()=>parcelRequire("bhN8v"));

});

parcelRequire.register("fh0bZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2UJQ4")).then(()=>parcelRequire("i2BKs"));

});

parcelRequire.register("c3nEy", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hMqyM")).then(()=>parcelRequire("9JnHy"));

});

parcelRequire.register("k2qrE", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kPQoB")).then(()=>parcelRequire("B6Ds1"));

});

parcelRequire.register("5SYeM", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fhtNv")).then(()=>parcelRequire("hMt3x"));

});

parcelRequire.register("cFAKZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kPrg5")).then(()=>parcelRequire("fDCeI"));

});

parcelRequire.register("BR03b", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("MypD3")),
    import("./" + (parcelRequire("kucSS")).resolve("7OX6Q")),
    import("./" + (parcelRequire("kucSS")).resolve("lyyTH"))
]).then(()=>parcelRequire("eyJXq"));

});

parcelRequire.register("2Lfmo", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ewBYx")).then(()=>parcelRequire("2Hzpq"));

});

parcelRequire.register("1gAhA", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("ewBYx")),
    import("./" + (parcelRequire("kucSS")).resolve("l3WNA"))
]).then(()=>parcelRequire("c075i"));

});

parcelRequire.register("bL86P", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("ewBYx")),
    import("./" + (parcelRequire("kucSS")).resolve("3Lxq5"))
]).then(()=>parcelRequire("5Rco9"));

});

parcelRequire.register("jQD98", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("Y04Nq")).then(()=>parcelRequire("p6TbZ"));

});

parcelRequire.register("ii0XJ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("dc0xg")).then(()=>parcelRequire("9D8Rr"));

});

parcelRequire.register("bqvaZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fkCsX")).then(()=>parcelRequire("6GeOZ"));

});

parcelRequire.register("21RFR", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ydGFi")).then(()=>parcelRequire("jBXNT"));

});

parcelRequire.register("gHnwx", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iqbFm")).then(()=>parcelRequire("3rxuA"));

});

parcelRequire.register("bc4rn", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("26yzO")).then(()=>parcelRequire("dyu39"));

});

parcelRequire.register("jnGOz", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("duEWh")).then(()=>parcelRequire("9vZBI"));

});

parcelRequire.register("1gf1o", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("liib3")).then(()=>parcelRequire("jBiAv"));

});

parcelRequire.register("kzB6o", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4JrFg")).then(()=>parcelRequire("jUkZW"));

});

parcelRequire.register("jv371", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kgjve")),
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("6lyR4"))
]).then(()=>parcelRequire("5AKf5"));

});

parcelRequire.register("fFH7K", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bBYe9")).then(()=>parcelRequire("hAVGl"));

});

parcelRequire.register("7eZxE", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("grJE4")),
    import("./" + (parcelRequire("kucSS")).resolve("QAL56"))
]).then(()=>parcelRequire("i7wLr"));

});

parcelRequire.register("1s7Et", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("lMjsN"))
]).then(()=>parcelRequire("j8iFG"));

});

parcelRequire.register("aoc5C", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("gqY7E")).then(()=>parcelRequire("ih8oo"));

});

parcelRequire.register("bjXvJ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8Mo8O")).then(()=>parcelRequire("3vatn"));

});

parcelRequire.register("l1w7o", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4EdAo")).then(()=>parcelRequire("cRAVI"));

});

parcelRequire.register("6rRXq", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3TYXe")).then(()=>parcelRequire("lX9JU"));

});

parcelRequire.register("02YK2", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iNB4Y")).then(()=>parcelRequire("7Pj50"));

});

parcelRequire.register("jeZZv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1hmU2")).then(()=>parcelRequire("2hqEi"));

});

parcelRequire.register("806j1", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4d8bw")).then(()=>parcelRequire("3PWvK"));

});

parcelRequire.register("i6Tmd", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h7RB3")).then(()=>parcelRequire("lH3Yk"));

});

parcelRequire.register("ij3wI", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4OxBY")).then(()=>parcelRequire("5TJG8"));

});

parcelRequire.register("1s2Jl", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5JDPT")).then(()=>parcelRequire("2MzQV"));

});

parcelRequire.register("OL5Je", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kr4tt")).then(()=>parcelRequire("7vAnL"));

});

parcelRequire.register("lr1aG", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iFPgA")).then(()=>parcelRequire("2XKAn"));

});

parcelRequire.register("hknA9", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bFatI")).then(()=>parcelRequire("9VSrp"));

});

parcelRequire.register("e1nQl", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iVXIk")).then(()=>parcelRequire("4PceT"));

});

parcelRequire.register("2szdX", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("4IUwH")).then(()=>parcelRequire("fVDCx"));

});

parcelRequire.register("2gIxG", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hvfip")).then(()=>parcelRequire("by6dy"));

});

parcelRequire.register("67RJf", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ku6aW")).then(()=>parcelRequire("6gu9K"));

});

parcelRequire.register("2n42U", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("coIfi")).then(()=>parcelRequire("1SwnB"));

});

parcelRequire.register("8S3gx", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ldVrU")).then(()=>parcelRequire("cslYT"));

});

parcelRequire.register("jjvCr", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2EGB5")).then(()=>parcelRequire("bKYBq"));

});

parcelRequire.register("ds31D", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("auY0m")).then(()=>parcelRequire("4Rv2v"));

});

parcelRequire.register("kT1K4", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5LBSb")).then(()=>parcelRequire("a4RJG"));

});

parcelRequire.register("cdMfC", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1Hj2H")).then(()=>parcelRequire("feYAT"));

});

parcelRequire.register("enPYR", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("diVFV")).then(()=>parcelRequire("ktNfQ"));

});

parcelRequire.register("8sZvQ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5mYno")).then(()=>parcelRequire("9PhkP"));

});

parcelRequire.register("9OZl6", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("9DZI4")).then(()=>parcelRequire("1KH2s"));

});

parcelRequire.register("e3dSR", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bwd1Y")).then(()=>parcelRequire("jNSBK"));

});

parcelRequire.register("jJmhR", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5OMpB")).then(()=>parcelRequire("aF4qx"));

});

parcelRequire.register("2joyv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6WcMb")).then(()=>parcelRequire("bJRvi"));

});

parcelRequire.register("fURUO", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("d0qNO")).then(()=>parcelRequire("7GiOP"));

});

parcelRequire.register("RgQAb", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("hJYsu"))
]).then(()=>parcelRequire("96DKb"));

});

parcelRequire.register("4Csbb", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h9Lzc")).then(()=>parcelRequire("fetNw"));

});

parcelRequire.register("5RzEM", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jvicW")),
    import("./" + (parcelRequire("kucSS")).resolve("jQgza"))
]).then(()=>parcelRequire("kxBwy"));

});

parcelRequire.register("jWoDe", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bsgNP")).then(()=>parcelRequire("hi56I"));

});

parcelRequire.register("cVw2f", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iJx7t")).then(()=>parcelRequire("jiF0x"));

});

parcelRequire.register("aw6wj", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lYFQz")).then(()=>parcelRequire("3Qcbn"));

});

parcelRequire.register("kwi9r", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bGTju")).then(()=>parcelRequire("9HeA2"));

});

parcelRequire.register("hLe9n", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lp3PY")).then(()=>parcelRequire("55jry"));

});

parcelRequire.register("4EZIw", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1jpE1")).then(()=>parcelRequire("izYeX"));

});

parcelRequire.register("1Ij7P", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6P279")).then(()=>parcelRequire("5k0nW"));

});

parcelRequire.register("k3zYf", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eGja1")).then(()=>parcelRequire("biO3A"));

});

parcelRequire.register("cmcpt", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hxLL1")).then(()=>parcelRequire("iCSwk"));

});

parcelRequire.register("5nKBE", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kgjve")),
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("kacjx"))
]).then(()=>parcelRequire("jMiJl"));

});

parcelRequire.register("jvtlM", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("kgjve"))
]).then(()=>parcelRequire("ceCYe"));

});

parcelRequire.register("d1axh", function(module, exports) {




module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kgjve")),
    import("./" + (parcelRequire("kucSS")).resolve("7OX6Q")),
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("coWDp"))
]).then(()=>parcelRequire("8zhQA"));

});

parcelRequire.register("4J3RW", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kVrOh")),
    import("./" + (parcelRequire("kucSS")).resolve("8FXXN"))
]).then(()=>parcelRequire("lVg0k"));

});

parcelRequire.register("3lOhQ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fpzf8")).then(()=>parcelRequire("c8MHN"));

});

parcelRequire.register("9KEt6", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("2veg9")).then(()=>parcelRequire("77ov0"));

});

parcelRequire.register("jWYNu", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6I3jw")).then(()=>parcelRequire("lzrfw"));

});

parcelRequire.register("ceonZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("tB5wh")).then(()=>parcelRequire("4u4QA"));

});

parcelRequire.register("56Vhv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("dQI56")).then(()=>parcelRequire("fKfCm"));

});

parcelRequire.register("fyNtZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("839oY")).then(()=>parcelRequire("aUCVw"));

});

parcelRequire.register("bJE3Z", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("9kHDH")).then(()=>parcelRequire("9Ooox"));

});

parcelRequire.register("bxZIv", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kwElk")).then(()=>parcelRequire("62YeZ"));

});

parcelRequire.register("inYQH", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eCOvl")).then(()=>parcelRequire("awk01"));

});

parcelRequire.register("efiIk", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hVBLa")).then(()=>parcelRequire("T5gDj"));

});

parcelRequire.register("kHZxV", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("Yv6qH")).then(()=>parcelRequire("a0zic"));

});

parcelRequire.register("9MspV", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("96iLM")).then(()=>parcelRequire("hEteg"));

});

parcelRequire.register("aKJrT", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("fwhVo")),
    import("./" + (parcelRequire("kucSS")).resolve("EVX7N"))
]).then(()=>parcelRequire("3hJBQ"));

});

parcelRequire.register("giD2m", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("exOEN")).then(()=>parcelRequire("hPbMG"));

});

parcelRequire.register("rH17d", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ga9K1")).then(()=>parcelRequire("deEID"));

});

parcelRequire.register("aLgm9", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5FVnY")).then(()=>parcelRequire("pDVzB"));

});

parcelRequire.register("lAXz7", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kPFol")).then(()=>parcelRequire("5lLjS"));

});

parcelRequire.register("ahxPH", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lTaT5")).then(()=>parcelRequire("efv63"));

});

parcelRequire.register("63AJK", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("g86Yw")).then(()=>parcelRequire("1ExQd"));

});

parcelRequire.register("cIyHm", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("grJE4")),
    import("./" + (parcelRequire("kucSS")).resolve("8G65V"))
]).then(()=>parcelRequire("e8PHe"));

});

parcelRequire.register("dxuFG", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("b5yCN")).then(()=>parcelRequire("35yhj"));

});

parcelRequire.register("1nOx5", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h3idY")).then(()=>parcelRequire("OfiAZ"));

});

parcelRequire.register("3o6gr", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6Zzgs")).then(()=>parcelRequire("8KJjm"));

});

parcelRequire.register("5S62X", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("6UWrd")).then(()=>parcelRequire("cVG58"));

});

parcelRequire.register("8xWsj", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("f05XD")).then(()=>parcelRequire("6AOeX"));

});

parcelRequire.register("dlZxL", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ethUK")).then(()=>parcelRequire("7TqeU"));

});

parcelRequire.register("cktZS", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7Dcz7")).then(()=>parcelRequire("gU4qx"));

});

parcelRequire.register("iF9po", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7vFvS")).then(()=>parcelRequire("75vDA"));

});

parcelRequire.register("jK2Bj", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1mlUW")).then(()=>parcelRequire("2C6Rc"));

});

parcelRequire.register("5SoN1", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("j4gwb")).then(()=>parcelRequire("9njhH"));

});

parcelRequire.register("6y1Bu", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h0fAI")).then(()=>parcelRequire("gBD77"));

});

parcelRequire.register("i8Wvm", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5a4Oj")).then(()=>parcelRequire("n4k3b"));

});

parcelRequire.register("9Vmca", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("4dOmx")),
    import("./" + (parcelRequire("kucSS")).resolve("82DL1"))
]).then(()=>parcelRequire("8fjZS"));

});

parcelRequire.register("cNMhA", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("grJE4")).then(()=>parcelRequire("3cfvI"));

});

parcelRequire.register("1qKUH", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5May8")).then(()=>parcelRequire("8dbKT"));

});

parcelRequire.register("bimBe", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("lmuko")),
    import("./" + (parcelRequire("kucSS")).resolve("5D6PU"))
]).then(()=>parcelRequire("efKeV"));

});

parcelRequire.register("c24o5", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("j556r")).then(()=>parcelRequire("9ABKx"));

});

parcelRequire.register("Q1Muo", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cyLmc")).then(()=>parcelRequire("5rrZH"));

});

parcelRequire.register("3OZRD", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("gf45H"))
]).then(()=>parcelRequire("jwSh3"));

});

parcelRequire.register("j6EzP", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("rpW1a")).then(()=>parcelRequire("hKlNG"));

});

parcelRequire.register("cM6Su", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7U0Ix")).then(()=>parcelRequire("khoeV"));

});

parcelRequire.register("04L2G", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1CDrW")).then(()=>parcelRequire("dpyj5"));

});

parcelRequire.register("koMkR", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("jbjne"))
]).then(()=>parcelRequire("dbObo"));

});

parcelRequire.register("kIQNg", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("jFNPB")),
    import("./" + (parcelRequire("kucSS")).resolve("d9WP1"))
]).then(()=>parcelRequire("5ogwH"));

});

parcelRequire.register("3Ly74", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fdwdv")).then(()=>parcelRequire("jkTmd"));

});

parcelRequire.register("grqj0", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("8tV8k")).then(()=>parcelRequire("jEjfZ"));

});

parcelRequire.register("2PG2p", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kVrOh")).then(()=>parcelRequire("e1zrO"));

});

parcelRequire.register("8QL9m", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("arSVJ")).then(()=>parcelRequire("cJktu"));

});

parcelRequire.register("kjfPW", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lF9yI")).then(()=>parcelRequire("705Zr"));

});

parcelRequire.register("5Dd2v", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iPxIz")).then(()=>parcelRequire("68Kvj"));

});

parcelRequire.register("1Iqc3", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("l2FA8")).then(()=>parcelRequire("gDYXe"));

});

parcelRequire.register("j3qWj", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("eHlfh")).then(()=>parcelRequire("7T3N4"));

});

parcelRequire.register("ijFuh", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("3ElTf")),
    import("./" + (parcelRequire("kucSS")).resolve("jfvjG")),
    import("./" + (parcelRequire("kucSS")).resolve("kPBq5"))
]).then(()=>parcelRequire("aCjqZ"));

});

parcelRequire.register("gCx7S", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3ElTf")).then(()=>parcelRequire("54ZhX"));

});

parcelRequire.register("j3LkN", function(module, exports) {




module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("pE2gm")),
    import("./" + (parcelRequire("kucSS")).resolve("3ElTf")),
    import("./" + (parcelRequire("kucSS")).resolve("iy6py")),
    import("./" + (parcelRequire("kucSS")).resolve("h5Tlt"))
]).then(()=>parcelRequire("cifVw"));

});

parcelRequire.register("dK0gI", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("dOBp3")),
    import("./" + (parcelRequire("kucSS")).resolve("fL5Je"))
]).then(()=>parcelRequire("9IjwL"));

});

parcelRequire.register("aDp9h", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("9WnPS")).then(()=>parcelRequire("jEUFG"));

});

parcelRequire.register("aIhP4", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("aZmNO")).then(()=>parcelRequire("ivSSt"));

});

parcelRequire.register("2Ke7A", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("h97a3")).then(()=>parcelRequire("2LBm0"));

});

parcelRequire.register("h49zP", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("782Og")).then(()=>parcelRequire("jw0Km"));

});

parcelRequire.register("4Buvv", function(module, exports) {



module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("dc0xg")),
    import("./" + (parcelRequire("kucSS")).resolve("MypD3")),
    import("./" + (parcelRequire("kucSS")).resolve("1Yeva"))
]).then(()=>parcelRequire("2lZ3p"));

});

parcelRequire.register("b9rbN", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("6LNXZ"))
]).then(()=>parcelRequire("aZYHJ"));

});

parcelRequire.register("2Mxqs", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jFNPB")).then(()=>parcelRequire("aQdKE"));

});

parcelRequire.register("2HnsA", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("5JDPT")),
    import("./" + (parcelRequire("kucSS")).resolve("15Roq"))
]).then(()=>parcelRequire("3jEiL"));

});

parcelRequire.register("epI2P", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("MypD3")).then(()=>parcelRequire("dCcRi"));

});

parcelRequire.register("kwEJM", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("k1I4c")).then(()=>parcelRequire("cjwGx"));

});

parcelRequire.register("6mol1", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7QNNG")).then(()=>parcelRequire("1fnDH"));

});

parcelRequire.register("g3IBY", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jKxIX")).then(()=>parcelRequire("63Lku"));

});

parcelRequire.register("hn2Or", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1BEyU")).then(()=>parcelRequire("9Q0Sk"));

});

parcelRequire.register("hhdQe", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("jpuE3")).then(()=>parcelRequire("dgXT8"));

});

parcelRequire.register("d4nTI", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("ivIlZ")).then(()=>parcelRequire("aQZDe"));

});

parcelRequire.register("2IZqT", function(module, exports) {


module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("iy6py")),
    import("./" + (parcelRequire("kucSS")).resolve("pE2gm"))
]).then(()=>parcelRequire("dhVcq"));

});

parcelRequire.register("7Afbe", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("atjmw")).then(()=>parcelRequire("bjjto"));

});

parcelRequire.register("n6ETd", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("1t98d")).then(()=>parcelRequire("9q2wt"));

});

parcelRequire.register("918Kg", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("f1uCd")).then(()=>parcelRequire("hgTnE"));

});

parcelRequire.register("fvzyF", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("bFop0")).then(()=>parcelRequire("7LeZr"));

});

parcelRequire.register("6j55v", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lSQhT")).then(()=>parcelRequire("aeudq"));

});

parcelRequire.register("kjBIb", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("hyFaQ")).then(()=>parcelRequire("kwunk"));

});

parcelRequire.register("5q79a", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3Pskm")).then(()=>parcelRequire("dWO8R"));

});

parcelRequire.register("bGZko", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("fvc0W")).then(()=>parcelRequire("1Ia09"));

});

parcelRequire.register("e3vOa", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("cUZtL")).then(()=>parcelRequire("4XYeX"));

});

parcelRequire.register("ifrDm", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("39cws")).then(()=>parcelRequire("8CM8J"));

});

parcelRequire.register("9rCWC", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("7hZ5P")).then(()=>parcelRequire("5hvcT"));

});

parcelRequire.register("jguA9", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("3KGdL")).then(()=>parcelRequire("j1lA4"));

});

parcelRequire.register("lHxjZ", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iniBd")).then(()=>parcelRequire("bTbrU"));

});

parcelRequire.register("6wyau", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("iL51X")).then(()=>parcelRequire("axj7M"));

});

parcelRequire.register("eKB41", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("5awfA")).then(()=>parcelRequire("l15ye"));

});

parcelRequire.register("bYIRn", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("dOBp3")).then(()=>parcelRequire("iWuKC"));

});

parcelRequire.register("6Jwmg", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("kCHRy")).then(()=>parcelRequire("4KNv6"));

});

parcelRequire.register("ccEo8", function(module, exports) {

module.exports = import("./" + (parcelRequire("kucSS")).resolve("lflEI")).then(()=>parcelRequire("ly29O"));

});


parcelRequire.register("5wBOu", function(module, exports) {





module.exports = Promise.all([
    import("./" + (parcelRequire("kucSS")).resolve("kr4tt")),
    import("./" + (parcelRequire("kucSS")).resolve("47uWo")),
    import("./" + (parcelRequire("kucSS")).resolve("imAw7")),
    import("./" + (parcelRequire("kucSS")).resolve("2FTS0")),
    import("./" + (parcelRequire("kucSS")).resolve("jAtvL"))
]).then(()=>parcelRequire("885Tf"));

});


parcelRequire.register("ahYyJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $77da77baeaca3f8a$export$2e2bcd8739ae039; });
var $77da77baeaca3f8a$export$2e2bcd8739ae039 = {
    'code[class*="language-"]': {
        "color": "#f8f8f2",
        "background": "none",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none"
    },
    'pre[class*="language-"]': {
        "color": "#f8f8f2",
        "background": "#2b2b2b",
        "fontFamily": "Consolas, Monaco, 'Andale Mono', 'Ubuntu Mono', monospace",
        "textAlign": "left",
        "whiteSpace": "pre",
        "wordSpacing": "normal",
        "wordBreak": "normal",
        "wordWrap": "normal",
        "lineHeight": "1.5",
        "MozTabSize": "4",
        "OTabSize": "4",
        "tabSize": "4",
        "WebkitHyphens": "none",
        "MozHyphens": "none",
        "msHyphens": "none",
        "hyphens": "none",
        "padding": "1em",
        "margin": "0.5em 0",
        "overflow": "auto",
        "borderRadius": "0.3em"
    },
    ':not(pre) > code[class*="language-"]': {
        "background": "#2b2b2b",
        "padding": "0.1em",
        "borderRadius": "0.3em",
        "whiteSpace": "normal"
    },
    "comment": {
        "color": "#d4d0ab"
    },
    "prolog": {
        "color": "#d4d0ab"
    },
    "doctype": {
        "color": "#d4d0ab"
    },
    "cdata": {
        "color": "#d4d0ab"
    },
    "punctuation": {
        "color": "#fefefe"
    },
    "property": {
        "color": "#ffa07a"
    },
    "tag": {
        "color": "#ffa07a"
    },
    "constant": {
        "color": "#ffa07a"
    },
    "symbol": {
        "color": "#ffa07a"
    },
    "deleted": {
        "color": "#ffa07a"
    },
    "boolean": {
        "color": "#00e0e0"
    },
    "number": {
        "color": "#00e0e0"
    },
    "selector": {
        "color": "#abe338"
    },
    "attr-name": {
        "color": "#abe338"
    },
    "string": {
        "color": "#abe338"
    },
    "char": {
        "color": "#abe338"
    },
    "builtin": {
        "color": "#abe338"
    },
    "inserted": {
        "color": "#abe338"
    },
    "operator": {
        "color": "#00e0e0"
    },
    "entity": {
        "color": "#00e0e0",
        "cursor": "help"
    },
    "url": {
        "color": "#00e0e0"
    },
    ".language-css .token.string": {
        "color": "#00e0e0"
    },
    ".style .token.string": {
        "color": "#00e0e0"
    },
    "variable": {
        "color": "#00e0e0"
    },
    "atrule": {
        "color": "#ffd700"
    },
    "attr-value": {
        "color": "#ffd700"
    },
    "function": {
        "color": "#ffd700"
    },
    "keyword": {
        "color": "#00e0e0"
    },
    "regex": {
        "color": "#ffd700"
    },
    "important": {
        "color": "#ffd700",
        "fontWeight": "bold"
    },
    "bold": {
        "fontWeight": "bold"
    },
    "italic": {
        "fontStyle": "italic"
    }
};

});

parcelRequire.register("29QHn", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $19254ce78af39892$export$34e0f9847d4c02dd; }, function (v) { return $19254ce78af39892$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "copy", function () { return $19254ce78af39892$export$784d13d8ee351f07; }, function (v) { return $19254ce78af39892$export$784d13d8ee351f07 = v; });
$parcel$export(module.exports, "editor", function () { return $19254ce78af39892$export$b5d042d2b680aed6; }, function (v) { return $19254ce78af39892$export$b5d042d2b680aed6 = v; });
$parcel$export(module.exports, "errorMessage", function () { return $19254ce78af39892$export$493b5823483d2c4e; }, function (v) { return $19254ce78af39892$export$493b5823483d2c4e = v; });
$parcel$export(module.exports, "placeholder", function () { return $19254ce78af39892$export$c7187bbd1a7a9244; }, function (v) { return $19254ce78af39892$export$c7187bbd1a7a9244 = v; });
$parcel$export(module.exports, "readonly", function () { return $19254ce78af39892$export$6ec456bd5b7b3c51; }, function (v) { return $19254ce78af39892$export$6ec456bd5b7b3c51 = v; });
var $19254ce78af39892$export$34e0f9847d4c02dd;
var $19254ce78af39892$export$784d13d8ee351f07;
var $19254ce78af39892$export$b5d042d2b680aed6;
var $19254ce78af39892$export$493b5823483d2c4e;
var $19254ce78af39892$export$c7187bbd1a7a9244;
var $19254ce78af39892$export$6ec456bd5b7b3c51;
var $19254ce78af39892$export$bfd64c937657f93a;
var $19254ce78af39892$export$4a6dd88bada4e7d2;
$19254ce78af39892$export$34e0f9847d4c02dd = `Nd8Kjq_container`;
$19254ce78af39892$export$784d13d8ee351f07 = `Nd8Kjq_copy`;
$19254ce78af39892$export$b5d042d2b680aed6 = `Nd8Kjq_editor`;
$19254ce78af39892$export$493b5823483d2c4e = `Nd8Kjq_errorMessage`;
$19254ce78af39892$export$c7187bbd1a7a9244 = `Nd8Kjq_placeholder`;
$19254ce78af39892$export$6ec456bd5b7b3c51 = `Nd8Kjq_readonly`;
$19254ce78af39892$export$bfd64c937657f93a = `Nd8Kjq_rotating`;
$19254ce78af39892$export$4a6dd88bada4e7d2 = `Nd8Kjq_shimmer`;

});

parcelRequire.register("gypP4", function(module, exports) {

$parcel$export(module.exports, "lineNumberContainerStyle", function () { return $0142f41d1c077c68$export$5d6f61bfcedf3be5; });
$parcel$export(module.exports, "lineNumberStyle", function () { return $0142f41d1c077c68$export$cc7b563314bb7222; });
$parcel$export(module.exports, "customStyle", function () { return $0142f41d1c077c68$export$f87aef060aea76c7; });
const $0142f41d1c077c68$export$5d6f61bfcedf3be5 = ()=>{
    return {
        display: "flex",
        flexDirection: "column",
        textAlign: "right",
        paddingLeft: "0px",
        paddingRight: "0px"
    };
};
const $0142f41d1c077c68$export$cc7b563314bb7222 = (numberOfLines)=>{
    return {
        minWidth: `calc(${numberOfLines}ch + 20px)`,
        marginLeft: "0px",
        paddingRight: "20px",
        paddingLeft: "0px",
        display: "inline-flex",
        justifyContent: "flex-end",
        counterIncrement: "line",
        lineHeight: "1.5",
        flexShrink: 0,
        fontFamily: "'Roboto Mono', monospace",
        fontSize: "14px",
        position: "sticky",
        background: "#34353f",
        left: 0
    };
};
const $0142f41d1c077c68$export$f87aef060aea76c7 = (width)=>{
    return {
        width: `${width ?? 0}px`,
        background: "transparent",
        fontSize: "14px",
        margin: "0",
        padding: "0",
        borderRadius: "0",
        wordBreak: "break-all",
        overflow: "unset",
        fontFamily: "'Roboto Mono', monospace"
    };
};

});


parcelRequire.register("d0Zvy", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1ba2784fd3d19114$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $l9nTS = parcelRequire("l9nTS");
function $1ba2784fd3d19114$var$OverlayScrollbar(props) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $l9nTS.OverlayScrollbarsComponent), {
        options: {
            scrollbars: {
                autoHide: "leave",
                autoHideDelay: 0
            }
        },
        ...props
    });
}
var $1ba2784fd3d19114$export$2e2bcd8739ae039 = $1ba2784fd3d19114$var$OverlayScrollbar;

});
parcelRequire.register("l9nTS", function(module, exports) {

$parcel$export(module.exports, "OverlayScrollbarsComponent", function () { return $f65cfa584e6a7509$export$5c3912403b9b36ce; });

var $eCoWV = parcelRequire("eCoWV");

var $4CX0V = parcelRequire("4CX0V");
const $f65cfa584e6a7509$var$O = ()=>{
    if (typeof window > "u") {
        const n = ()=>{};
        return [
            n,
            n
        ];
    }
    let l, c;
    const t = window, o = typeof t.requestIdleCallback == "function", a = t.requestAnimationFrame, i = t.cancelAnimationFrame, r = o ? t.requestIdleCallback : a, u = o ? t.cancelIdleCallback : i, s = ()=>{
        u(l), i(c);
    };
    return [
        (n, e)=>{
            s(), l = r(o ? ()=>{
                s(), c = a(n);
            } : n, typeof e == "object" ? e : {
                timeout: 2233
            });
        },
        s
    ];
}, $f65cfa584e6a7509$export$98c834f87b3a8a6f = (l)=>{
    const { options: c, events: t, defer: o } = l || {}, [a, i] = (0, $eCoWV.useMemo)($f65cfa584e6a7509$var$O, []), r = (0, $eCoWV.useRef)(null), u = (0, $eCoWV.useRef)(o), s = (0, $eCoWV.useRef)(c), n = (0, $eCoWV.useRef)(t);
    return (0, $eCoWV.useEffect)(()=>{
        u.current = o;
    }, [
        o
    ]), (0, $eCoWV.useEffect)(()=>{
        const { current: e } = r;
        s.current = c, (0, $4CX0V.OverlayScrollbars).valid(e) && e.options(c || {}, !0);
    }, [
        c
    ]), (0, $eCoWV.useEffect)(()=>{
        const { current: e } = r;
        n.current = t, (0, $4CX0V.OverlayScrollbars).valid(e) && e.on(t || {}, !0);
    }, [
        t
    ]), (0, $eCoWV.useEffect)(()=>()=>{
            var e;
            i(), (e = r.current) == null || e.destroy();
        }, []), (0, $eCoWV.useMemo)(()=>[
            (e)=>{
                const y = r.current;
                if ((0, $4CX0V.OverlayScrollbars).valid(y)) return;
                const d = u.current, I = s.current || {}, m = n.current || {}, p = ()=>r.current = (0, $4CX0V.OverlayScrollbars)(e, I, m);
                d ? a(p, d) : p();
            },
            ()=>r.current
        ], []);
}, $f65cfa584e6a7509$var$F = (l, c)=>{
    const { element: t = "div", options: o, events: a, defer: i, children: r, ...u } = l, s = t, n = (0, $eCoWV.useRef)(null), e = (0, $eCoWV.useRef)(null), [y, d] = $f65cfa584e6a7509$export$98c834f87b3a8a6f({
        options: o,
        events: a,
        defer: i
    });
    return (0, $eCoWV.useEffect)(()=>{
        const { current: I } = n, { current: m } = e;
        return I && m && y({
            target: I,
            elements: {
                viewport: m,
                content: m
            }
        }), ()=>{
            var p;
            return (p = d()) == null ? void 0 : p.destroy();
        };
    }, [
        y,
        t
    ]), (0, $eCoWV.useImperativeHandle)(c, ()=>({
            osInstance: d,
            getElement: ()=>n.current
        }), []), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(s, {
        "data-overlayscrollbars-initialize": "",
        ref: n,
        ...u
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        ref: e
    }, r));
}, $f65cfa584e6a7509$export$5c3912403b9b36ce = (0, $eCoWV.forwardRef)($f65cfa584e6a7509$var$F);

});
parcelRequire.register("4CX0V", function(module, exports) {

$parcel$export(module.exports, "OverlayScrollbars", function () { return $01a3030b6b7b975b$export$d08ab3fe303a3356; });
/*!
 * OverlayScrollbars
 * Version: 2.0.3
 *
 * Copyright (c) Rene Haas | KingSora.
 * https://github.com/KingSora
 *
 * Released under the MIT license.
 */ function $01a3030b6b7b975b$var$each(t, n) {
    if ($01a3030b6b7b975b$var$isArrayLike(t)) for(let o = 0; o < t.length; o++){
        if (false === n(t[o], o, t)) break;
    }
    else if (t) $01a3030b6b7b975b$var$each(Object.keys(t), (o)=>n(t[o], o, t));
    return t;
}
function $01a3030b6b7b975b$var$style(t, n) {
    const o = $01a3030b6b7b975b$var$isString(n);
    const s = $01a3030b6b7b975b$var$isArray(n) || o;
    if (s) {
        let s = o ? "" : {};
        if (t) {
            const e = window.getComputedStyle(t, null);
            s = o ? $01a3030b6b7b975b$var$getCSSVal(t, e, n) : n.reduce((n, o)=>{
                n[o] = $01a3030b6b7b975b$var$getCSSVal(t, e, o);
                return n;
            }, s);
        }
        return s;
    }
    t && $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$keys(n), (o)=>$01a3030b6b7b975b$var$setCSSVal(t, o, n[o]));
}
const $01a3030b6b7b975b$var$createCache = (t, n)=>{
    const { o: o, u: s, _: e } = t;
    let c = o;
    let r;
    const cacheUpdateContextual = (t, n)=>{
        const o = c;
        const i = t;
        const l = n || (s ? !s(o, i) : o !== i);
        if (l || e) {
            c = i;
            r = o;
        }
        return [
            c,
            l,
            r
        ];
    };
    const cacheUpdateIsolated = (t)=>cacheUpdateContextual(n(c, r), t);
    const getCurrentCache = (t)=>[
            c,
            !!t,
            r
        ];
    return [
        n ? cacheUpdateIsolated : cacheUpdateContextual,
        getCurrentCache
    ];
};
const $01a3030b6b7b975b$var$isClient = ()=>"undefined" !== typeof window;
const $01a3030b6b7b975b$var$t = $01a3030b6b7b975b$var$isClient() && Node.ELEMENT_NODE;
const { toString: $01a3030b6b7b975b$var$n, hasOwnProperty: $01a3030b6b7b975b$var$o } = Object.prototype;
const $01a3030b6b7b975b$var$isUndefined = (t)=>void 0 === t;
const $01a3030b6b7b975b$var$isNull = (t)=>null === t;
const $01a3030b6b7b975b$var$type = (t)=>$01a3030b6b7b975b$var$isUndefined(t) || $01a3030b6b7b975b$var$isNull(t) ? `${t}` : $01a3030b6b7b975b$var$n.call(t).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
const $01a3030b6b7b975b$var$isNumber = (t)=>"number" === typeof t;
const $01a3030b6b7b975b$var$isString = (t)=>"string" === typeof t;
const $01a3030b6b7b975b$var$isBoolean = (t)=>"boolean" === typeof t;
const $01a3030b6b7b975b$var$isFunction = (t)=>"function" === typeof t;
const $01a3030b6b7b975b$var$isArray = (t)=>Array.isArray(t);
const $01a3030b6b7b975b$var$isObject = (t)=>"object" === typeof t && !$01a3030b6b7b975b$var$isArray(t) && !$01a3030b6b7b975b$var$isNull(t);
const $01a3030b6b7b975b$var$isArrayLike = (t)=>{
    const n = !!t && t.length;
    const o = $01a3030b6b7b975b$var$isNumber(n) && n > -1 && n % 1 == 0;
    return $01a3030b6b7b975b$var$isArray(t) || !$01a3030b6b7b975b$var$isFunction(t) && o ? n > 0 && $01a3030b6b7b975b$var$isObject(t) ? n - 1 in t : true : false;
};
const $01a3030b6b7b975b$var$isPlainObject = (t)=>{
    if (!t || !$01a3030b6b7b975b$var$isObject(t) || "object" !== $01a3030b6b7b975b$var$type(t)) return false;
    let n;
    const s = "constructor";
    const e = t[s];
    const c = e && e.prototype;
    const r = $01a3030b6b7b975b$var$o.call(t, s);
    const i = c && $01a3030b6b7b975b$var$o.call(c, "isPrototypeOf");
    if (e && !r && !i) return false;
    for(n in t);
    return $01a3030b6b7b975b$var$isUndefined(n) || $01a3030b6b7b975b$var$o.call(t, n);
};
const $01a3030b6b7b975b$var$isHTMLElement = (n)=>{
    const o = HTMLElement;
    return n ? o ? n instanceof o : n.nodeType === $01a3030b6b7b975b$var$t : false;
};
const $01a3030b6b7b975b$var$isElement = (n)=>{
    const o = Element;
    return n ? o ? n instanceof o : n.nodeType === $01a3030b6b7b975b$var$t : false;
};
const $01a3030b6b7b975b$var$indexOf = (t, n, o)=>t.indexOf(n, o);
const $01a3030b6b7b975b$var$push = (t, n, o)=>{
    !o && !$01a3030b6b7b975b$var$isString(n) && $01a3030b6b7b975b$var$isArrayLike(n) ? Array.prototype.push.apply(t, n) : t.push(n);
    return t;
};
const $01a3030b6b7b975b$var$from = (t)=>{
    const n = Array.from;
    const o = [];
    if (n && t) return n(t);
    if (t instanceof Set) t.forEach((t)=>{
        $01a3030b6b7b975b$var$push(o, t);
    });
    else $01a3030b6b7b975b$var$each(t, (t)=>{
        $01a3030b6b7b975b$var$push(o, t);
    });
    return o;
};
const $01a3030b6b7b975b$var$isEmptyArray = (t)=>!!t && 0 === t.length;
const $01a3030b6b7b975b$var$runEachAndClear = (t, n, o)=>{
    const runFn = (t)=>t && t.apply(void 0, n || []);
    $01a3030b6b7b975b$var$each(t, runFn);
    !o && (t.length = 0);
};
const $01a3030b6b7b975b$var$hasOwnProperty = (t, n)=>Object.prototype.hasOwnProperty.call(t, n);
const $01a3030b6b7b975b$var$keys = (t)=>t ? Object.keys(t) : [];
const $01a3030b6b7b975b$var$assignDeep = (t, n, o, s, e, c, r)=>{
    const i = [
        n,
        o,
        s,
        e,
        c,
        r
    ];
    if (("object" !== typeof t || $01a3030b6b7b975b$var$isNull(t)) && !$01a3030b6b7b975b$var$isFunction(t)) t = {};
    $01a3030b6b7b975b$var$each(i, (n)=>{
        $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$keys(n), (o)=>{
            const s = n[o];
            if (t === s) return true;
            const e = $01a3030b6b7b975b$var$isArray(s);
            if (s && ($01a3030b6b7b975b$var$isPlainObject(s) || e)) {
                const n = t[o];
                let c = n;
                if (e && !$01a3030b6b7b975b$var$isArray(n)) c = [];
                else if (!e && !$01a3030b6b7b975b$var$isPlainObject(n)) c = {};
                t[o] = $01a3030b6b7b975b$var$assignDeep(c, s);
            } else t[o] = s;
        });
    });
    return t;
};
const $01a3030b6b7b975b$var$isEmptyObject = (t)=>{
    for(const n in t)return false;
    return true;
};
const $01a3030b6b7b975b$var$getSetProp = (t, n, o, s)=>{
    if ($01a3030b6b7b975b$var$isUndefined(s)) return o ? o[t] : n;
    o && ($01a3030b6b7b975b$var$isString(s) || $01a3030b6b7b975b$var$isNumber(s)) && (o[t] = s);
};
const $01a3030b6b7b975b$var$attr = (t, n, o)=>{
    if ($01a3030b6b7b975b$var$isUndefined(o)) return t ? t.getAttribute(n) : null;
    t && t.setAttribute(n, o);
};
const $01a3030b6b7b975b$var$attrClass = (t, n, o, s)=>{
    if (o) {
        const e = $01a3030b6b7b975b$var$attr(t, n) || "";
        const c = new Set(e.split(" "));
        c[s ? "add" : "delete"](o);
        $01a3030b6b7b975b$var$attr(t, n, $01a3030b6b7b975b$var$from(c).join(" ").trim());
    }
};
const $01a3030b6b7b975b$var$hasAttrClass = (t, n, o)=>{
    const s = $01a3030b6b7b975b$var$attr(t, n) || "";
    const e = new Set(s.split(" "));
    return e.has(o);
};
const $01a3030b6b7b975b$var$removeAttr = (t, n)=>{
    t && t.removeAttribute(n);
};
const $01a3030b6b7b975b$var$scrollLeft = (t, n)=>$01a3030b6b7b975b$var$getSetProp("scrollLeft", 0, t, n);
const $01a3030b6b7b975b$var$scrollTop = (t, n)=>$01a3030b6b7b975b$var$getSetProp("scrollTop", 0, t, n);
const $01a3030b6b7b975b$var$s = $01a3030b6b7b975b$var$isClient() && Element.prototype;
const $01a3030b6b7b975b$var$find = (t, n)=>{
    const o = [];
    const s = n ? $01a3030b6b7b975b$var$isElement(n) ? n : null : document;
    return s ? $01a3030b6b7b975b$var$push(o, s.querySelectorAll(t)) : o;
};
const $01a3030b6b7b975b$var$findFirst = (t, n)=>{
    const o = n ? $01a3030b6b7b975b$var$isElement(n) ? n : null : document;
    return o ? o.querySelector(t) : null;
};
const $01a3030b6b7b975b$var$is = (t, n)=>{
    if ($01a3030b6b7b975b$var$isElement(t)) {
        const o = $01a3030b6b7b975b$var$s.matches || $01a3030b6b7b975b$var$s.msMatchesSelector;
        return o.call(t, n);
    }
    return false;
};
const $01a3030b6b7b975b$var$contents = (t)=>t ? $01a3030b6b7b975b$var$from(t.childNodes) : [];
const $01a3030b6b7b975b$var$parent = (t)=>t ? t.parentElement : null;
const $01a3030b6b7b975b$var$closest = (t, n)=>{
    if ($01a3030b6b7b975b$var$isElement(t)) {
        const o = $01a3030b6b7b975b$var$s.closest;
        if (o) return o.call(t, n);
        do {
            if ($01a3030b6b7b975b$var$is(t, n)) return t;
            t = $01a3030b6b7b975b$var$parent(t);
        }while (t);
    }
    return null;
};
const $01a3030b6b7b975b$var$liesBetween = (t, n, o)=>{
    const s = t && $01a3030b6b7b975b$var$closest(t, n);
    const e = t && $01a3030b6b7b975b$var$findFirst(o, s);
    const c = $01a3030b6b7b975b$var$closest(e, n) === s;
    return s && e ? s === t || e === t || c && $01a3030b6b7b975b$var$closest($01a3030b6b7b975b$var$closest(t, o), n) !== s : false;
};
const $01a3030b6b7b975b$var$before = (t, n, o)=>{
    if (o && t) {
        let s = n;
        let e;
        if ($01a3030b6b7b975b$var$isArrayLike(o)) {
            e = document.createDocumentFragment();
            $01a3030b6b7b975b$var$each(o, (t)=>{
                if (t === s) s = t.previousSibling;
                e.appendChild(t);
            });
        } else e = o;
        if (n) {
            if (!s) s = t.firstChild;
            else if (s !== n) s = s.nextSibling;
        }
        t.insertBefore(e, s || null);
    }
};
const $01a3030b6b7b975b$var$appendChildren = (t, n)=>{
    $01a3030b6b7b975b$var$before(t, null, n);
};
const $01a3030b6b7b975b$var$insertBefore = (t, n)=>{
    $01a3030b6b7b975b$var$before($01a3030b6b7b975b$var$parent(t), t, n);
};
const $01a3030b6b7b975b$var$insertAfter = (t, n)=>{
    $01a3030b6b7b975b$var$before($01a3030b6b7b975b$var$parent(t), t && t.nextSibling, n);
};
const $01a3030b6b7b975b$var$removeElements = (t)=>{
    if ($01a3030b6b7b975b$var$isArrayLike(t)) $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$from(t), (t)=>$01a3030b6b7b975b$var$removeElements(t));
    else if (t) {
        const n = $01a3030b6b7b975b$var$parent(t);
        if (n) n.removeChild(t);
    }
};
const $01a3030b6b7b975b$var$createDiv = (t)=>{
    const n = document.createElement("div");
    if (t) $01a3030b6b7b975b$var$attr(n, "class", t);
    return n;
};
const $01a3030b6b7b975b$var$createDOM = (t)=>{
    const n = $01a3030b6b7b975b$var$createDiv();
    n.innerHTML = t.trim();
    return $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$contents(n), (t)=>$01a3030b6b7b975b$var$removeElements(t));
};
const $01a3030b6b7b975b$var$firstLetterToUpper = (t)=>t.charAt(0).toUpperCase() + t.slice(1);
const $01a3030b6b7b975b$var$getDummyStyle = ()=>$01a3030b6b7b975b$var$createDiv().style;
const $01a3030b6b7b975b$var$e = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
const $01a3030b6b7b975b$var$c = [
    "WebKit",
    "Moz",
    "O",
    "MS",
    "webkit",
    "moz",
    "o",
    "ms"
];
const $01a3030b6b7b975b$var$r = {};
const $01a3030b6b7b975b$var$i = {};
const $01a3030b6b7b975b$var$cssProperty = (t)=>{
    let n = $01a3030b6b7b975b$var$i[t];
    if ($01a3030b6b7b975b$var$hasOwnProperty($01a3030b6b7b975b$var$i, t)) return n;
    const o = $01a3030b6b7b975b$var$firstLetterToUpper(t);
    const s = $01a3030b6b7b975b$var$getDummyStyle();
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$e, (e)=>{
        const c = e.replace(/-/g, "");
        const r = [
            t,
            e + t,
            c + o,
            $01a3030b6b7b975b$var$firstLetterToUpper(c) + o
        ];
        return !(n = r.find((t)=>void 0 !== s[t]));
    });
    return $01a3030b6b7b975b$var$i[t] = n || "";
};
const $01a3030b6b7b975b$var$jsAPI = (t)=>{
    if ($01a3030b6b7b975b$var$isClient()) {
        let n = $01a3030b6b7b975b$var$r[t] || window[t];
        if ($01a3030b6b7b975b$var$hasOwnProperty($01a3030b6b7b975b$var$r, t)) return n;
        $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$c, (o)=>{
            n = n || window[o + $01a3030b6b7b975b$var$firstLetterToUpper(t)];
            return !n;
        });
        $01a3030b6b7b975b$var$r[t] = n;
        return n;
    }
};
const $01a3030b6b7b975b$var$l = $01a3030b6b7b975b$var$jsAPI("MutationObserver");
const $01a3030b6b7b975b$var$a = $01a3030b6b7b975b$var$jsAPI("IntersectionObserver");
const $01a3030b6b7b975b$var$u = $01a3030b6b7b975b$var$jsAPI("ResizeObserver");
const $01a3030b6b7b975b$var$d = $01a3030b6b7b975b$var$jsAPI("cancelAnimationFrame");
const $01a3030b6b7b975b$var$f = $01a3030b6b7b975b$var$jsAPI("requestAnimationFrame");
const $01a3030b6b7b975b$var$_ = $01a3030b6b7b975b$var$isClient() && window.setTimeout;
const $01a3030b6b7b975b$var$h = $01a3030b6b7b975b$var$isClient() && window.clearTimeout;
const $01a3030b6b7b975b$var$equal = (t, n, o, s)=>{
    if (t && n) {
        let e = true;
        $01a3030b6b7b975b$var$each(o, (o)=>{
            const c = s ? s(t[o]) : t[o];
            const r = s ? s(n[o]) : n[o];
            if (c !== r) e = false;
        });
        return e;
    }
    return false;
};
const $01a3030b6b7b975b$var$equalWH = (t, n)=>$01a3030b6b7b975b$var$equal(t, n, [
        "w",
        "h"
    ]);
const $01a3030b6b7b975b$var$equalXY = (t, n)=>$01a3030b6b7b975b$var$equal(t, n, [
        "x",
        "y"
    ]);
const $01a3030b6b7b975b$var$equalTRBL = (t, n)=>$01a3030b6b7b975b$var$equal(t, n, [
        "t",
        "r",
        "b",
        "l"
    ]);
const $01a3030b6b7b975b$var$equalBCRWH = (t, n, o)=>$01a3030b6b7b975b$var$equal(t, n, [
        "width",
        "height"
    ], o && ((t)=>Math.round(t)));
const $01a3030b6b7b975b$var$noop = ()=>{};
const $01a3030b6b7b975b$var$selfClearTimeout = (t)=>{
    let n;
    const o = t ? $01a3030b6b7b975b$var$_ : $01a3030b6b7b975b$var$f;
    const s = t ? $01a3030b6b7b975b$var$h : $01a3030b6b7b975b$var$d;
    return [
        (e)=>{
            s(n);
            n = o(e, $01a3030b6b7b975b$var$isFunction(t) ? t() : t);
        },
        ()=>s(n)
    ];
};
const $01a3030b6b7b975b$var$debounce = (t, n)=>{
    let o;
    let s;
    let e;
    let c = $01a3030b6b7b975b$var$noop;
    const { g: r, v: i, p: l } = n || {};
    const a = function invokeFunctionToDebounce(n) {
        c();
        $01a3030b6b7b975b$var$h(o);
        o = s = void 0;
        c = $01a3030b6b7b975b$var$noop;
        t.apply(this, n);
    };
    const mergeParms = (t)=>l && s ? l(s, t) : t;
    const flush = ()=>{
        if (c !== $01a3030b6b7b975b$var$noop) a(mergeParms(e) || e);
    };
    const u = function debouncedFn() {
        const t = $01a3030b6b7b975b$var$from(arguments);
        const n = $01a3030b6b7b975b$var$isFunction(r) ? r() : r;
        const l = $01a3030b6b7b975b$var$isNumber(n) && n >= 0;
        if (l) {
            const r = $01a3030b6b7b975b$var$isFunction(i) ? i() : i;
            const l = $01a3030b6b7b975b$var$isNumber(r) && r >= 0;
            const u = n > 0 ? $01a3030b6b7b975b$var$_ : $01a3030b6b7b975b$var$f;
            const g = n > 0 ? $01a3030b6b7b975b$var$h : $01a3030b6b7b975b$var$d;
            const v = mergeParms(t);
            const w = v || t;
            const p = a.bind(0, w);
            c();
            const b = u(p, n);
            c = ()=>g(b);
            if (l && !o) o = $01a3030b6b7b975b$var$_(flush, r);
            s = e = w;
        } else a(t);
    };
    u.m = flush;
    return u;
};
const { max: $01a3030b6b7b975b$var$g } = Math;
const $01a3030b6b7b975b$var$animationCurrentTime = ()=>performance.now();
const $01a3030b6b7b975b$var$animateNumber = (t, n, o, s, e)=>{
    let c = 0;
    const r = $01a3030b6b7b975b$var$animationCurrentTime();
    const i = Math.max(0, o);
    const frame = (o)=>{
        const l = $01a3030b6b7b975b$var$animationCurrentTime();
        const a = l - r;
        const u = a >= i;
        const d = o ? 1 : 1 - ($01a3030b6b7b975b$var$g(0, r + i - l) / i || 0);
        const _ = (n - t) * ($01a3030b6b7b975b$var$isFunction(e) ? e(d, d * i, 0, 1, i) : d) + t;
        const h = u || 1 === d;
        s && s(_, d, h);
        c = h ? 0 : $01a3030b6b7b975b$var$f(()=>frame());
    };
    frame();
    return (t)=>{
        $01a3030b6b7b975b$var$d(c);
        t && frame(t);
    };
};
const $01a3030b6b7b975b$var$v = /[^\x20\t\r\n\f]+/g;
const $01a3030b6b7b975b$var$classListAction = (t, n, o)=>{
    const s = t && t.classList;
    let e;
    let c = 0;
    let r = false;
    if (s && n && $01a3030b6b7b975b$var$isString(n)) {
        const t = n.match($01a3030b6b7b975b$var$v) || [];
        r = t.length > 0;
        while(e = t[c++])r = !!o(s, e) && r;
    }
    return r;
};
const $01a3030b6b7b975b$var$hasClass = (t, n)=>$01a3030b6b7b975b$var$classListAction(t, n, (t, n)=>t.contains(n));
const $01a3030b6b7b975b$var$removeClass = (t, n)=>{
    $01a3030b6b7b975b$var$classListAction(t, n, (t, n)=>t.remove(n));
};
const $01a3030b6b7b975b$var$addClass = (t, n)=>{
    $01a3030b6b7b975b$var$classListAction(t, n, (t, n)=>t.add(n));
    return $01a3030b6b7b975b$var$removeClass.bind(0, t, n);
};
const $01a3030b6b7b975b$var$w = {
    opacity: 1,
    zindex: 1
};
const $01a3030b6b7b975b$var$parseToZeroOrNumber = (t, n)=>{
    const o = n ? parseFloat(t) : parseInt(t, 10);
    return o === o ? o : 0;
};
const $01a3030b6b7b975b$var$adaptCSSVal = (t, n)=>!$01a3030b6b7b975b$var$w[t.toLowerCase()] && $01a3030b6b7b975b$var$isNumber(n) ? `${n}px` : n;
const $01a3030b6b7b975b$var$getCSSVal = (t, n, o)=>null != n ? n[o] || n.getPropertyValue(o) : t.style[o];
const $01a3030b6b7b975b$var$setCSSVal = (t, n, o)=>{
    try {
        const { style: s } = t;
        if (!$01a3030b6b7b975b$var$isUndefined(s[n])) s[n] = $01a3030b6b7b975b$var$adaptCSSVal(n, o);
        else s.setProperty(n, o);
    } catch (s) {}
};
const $01a3030b6b7b975b$var$directionIsRTL = (t)=>"rtl" === $01a3030b6b7b975b$var$style(t, "direction");
const $01a3030b6b7b975b$var$topRightBottomLeft = (t, n, o)=>{
    const s = n ? `${n}-` : "";
    const e = o ? `-${o}` : "";
    const c = `${s}top${e}`;
    const r = `${s}right${e}`;
    const i = `${s}bottom${e}`;
    const l = `${s}left${e}`;
    const a = $01a3030b6b7b975b$var$style(t, [
        c,
        r,
        i,
        l
    ]);
    return {
        t: $01a3030b6b7b975b$var$parseToZeroOrNumber(a[c], true),
        r: $01a3030b6b7b975b$var$parseToZeroOrNumber(a[r], true),
        b: $01a3030b6b7b975b$var$parseToZeroOrNumber(a[i], true),
        l: $01a3030b6b7b975b$var$parseToZeroOrNumber(a[l], true)
    };
};
const { round: $01a3030b6b7b975b$var$p } = Math;
const $01a3030b6b7b975b$var$b = {
    w: 0,
    h: 0
};
const $01a3030b6b7b975b$var$windowSize = ()=>({
        w: window.innerWidth,
        h: window.innerHeight
    });
const $01a3030b6b7b975b$var$offsetSize = (t)=>t ? {
        w: t.offsetWidth,
        h: t.offsetHeight
    } : $01a3030b6b7b975b$var$b;
const $01a3030b6b7b975b$var$clientSize = (t)=>t ? {
        w: t.clientWidth,
        h: t.clientHeight
    } : $01a3030b6b7b975b$var$b;
const $01a3030b6b7b975b$var$scrollSize = (t)=>t ? {
        w: t.scrollWidth,
        h: t.scrollHeight
    } : $01a3030b6b7b975b$var$b;
const $01a3030b6b7b975b$var$fractionalSize = (t)=>{
    const n = parseFloat($01a3030b6b7b975b$var$style(t, "height")) || 0;
    const o = parseFloat($01a3030b6b7b975b$var$style(t, "width")) || 0;
    return {
        w: o - $01a3030b6b7b975b$var$p(o),
        h: n - $01a3030b6b7b975b$var$p(n)
    };
};
const $01a3030b6b7b975b$var$getBoundingClientRect = (t)=>t.getBoundingClientRect();
let $01a3030b6b7b975b$var$m;
const $01a3030b6b7b975b$var$supportPassiveEvents = ()=>{
    if ($01a3030b6b7b975b$var$isUndefined($01a3030b6b7b975b$var$m)) {
        $01a3030b6b7b975b$var$m = false;
        try {
            window.addEventListener("test", null, Object.defineProperty({}, "passive", {
                get () {
                    $01a3030b6b7b975b$var$m = true;
                }
            }));
        } catch (t) {}
    }
    return $01a3030b6b7b975b$var$m;
};
const $01a3030b6b7b975b$var$splitEventNames = (t)=>t.split(" ");
const $01a3030b6b7b975b$var$off = (t, n, o, s)=>{
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$splitEventNames(n), (n)=>{
        t.removeEventListener(n, o, s);
    });
};
const $01a3030b6b7b975b$var$on = (t, n, o, s)=>{
    var e;
    const c = $01a3030b6b7b975b$var$supportPassiveEvents();
    const r = null != (e = c && s && s.S) ? e : c;
    const i = s && s.$ || false;
    const l = s && s.C || false;
    const a = [];
    const u = c ? {
        passive: r,
        capture: i
    } : i;
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$splitEventNames(n), (n)=>{
        const s = l ? (e)=>{
            t.removeEventListener(n, s, i);
            o && o(e);
        } : o;
        $01a3030b6b7b975b$var$push(a, $01a3030b6b7b975b$var$off.bind(null, t, n, s, i));
        t.addEventListener(n, s, u);
    });
    return $01a3030b6b7b975b$var$runEachAndClear.bind(0, a);
};
const $01a3030b6b7b975b$var$stopPropagation = (t)=>t.stopPropagation();
const $01a3030b6b7b975b$var$preventDefault = (t)=>t.preventDefault();
const $01a3030b6b7b975b$var$y = {
    x: 0,
    y: 0
};
const $01a3030b6b7b975b$var$absoluteCoordinates = (t)=>{
    const n = t ? $01a3030b6b7b975b$var$getBoundingClientRect(t) : 0;
    return n ? {
        x: n.left + window.pageYOffset,
        y: n.top + window.pageXOffset
    } : $01a3030b6b7b975b$var$y;
};
const $01a3030b6b7b975b$var$manageListener = (t, n)=>{
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$isArray(n) ? n : [
        n
    ], t);
};
const $01a3030b6b7b975b$var$createEventListenerHub = (t)=>{
    const n = new Map;
    const removeEvent = (t, o)=>{
        if (t) {
            const s = n.get(t);
            $01a3030b6b7b975b$var$manageListener((t)=>{
                if (s) s[t ? "delete" : "clear"](t);
            }, o);
        } else {
            n.forEach((t)=>{
                t.clear();
            });
            n.clear();
        }
    };
    const addEvent = (t, o)=>{
        if ($01a3030b6b7b975b$var$isString(t)) {
            const s = n.get(t) || new Set;
            n.set(t, s);
            $01a3030b6b7b975b$var$manageListener((t)=>{
                $01a3030b6b7b975b$var$isFunction(t) && s.add(t);
            }, o);
            return removeEvent.bind(0, t, o);
        }
        if ($01a3030b6b7b975b$var$isBoolean(o) && o) removeEvent();
        const s = $01a3030b6b7b975b$var$keys(t);
        const e = [];
        $01a3030b6b7b975b$var$each(s, (n)=>{
            const o = t[n];
            o && $01a3030b6b7b975b$var$push(e, addEvent(n, o));
        });
        return $01a3030b6b7b975b$var$runEachAndClear.bind(0, e);
    };
    const triggerEvent = (t, o)=>{
        const s = n.get(t);
        $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$from(s), (t)=>{
            if (o && !$01a3030b6b7b975b$var$isEmptyArray(o)) t.apply(0, o);
            else t();
        });
    };
    addEvent(t || {});
    return [
        addEvent,
        removeEvent,
        triggerEvent
    ];
};
const $01a3030b6b7b975b$var$opsStringify = (t)=>JSON.stringify(t, (t, n)=>{
        if ($01a3030b6b7b975b$var$isFunction(n)) throw new Error;
        return n;
    });
const $01a3030b6b7b975b$var$S = {
    paddingAbsolute: false,
    showNativeOverlaidScrollbars: false,
    update: {
        elementEvents: [
            [
                "img",
                "load"
            ]
        ],
        debounce: [
            0,
            33
        ],
        attributes: null,
        ignoreMutation: null
    },
    overflow: {
        x: "scroll",
        y: "scroll"
    },
    scrollbars: {
        theme: "os-theme-dark",
        visibility: "auto",
        autoHide: "never",
        autoHideDelay: 1300,
        dragScroll: true,
        clickScroll: false,
        pointers: [
            "mouse",
            "touch",
            "pen"
        ]
    }
};
const $01a3030b6b7b975b$var$getOptionsDiff = (t, n)=>{
    const o = {};
    const s = $01a3030b6b7b975b$var$keys(n).concat($01a3030b6b7b975b$var$keys(t));
    $01a3030b6b7b975b$var$each(s, (s)=>{
        const e = t[s];
        const c = n[s];
        if ($01a3030b6b7b975b$var$isObject(e) && $01a3030b6b7b975b$var$isObject(c)) {
            $01a3030b6b7b975b$var$assignDeep(o[s] = {}, $01a3030b6b7b975b$var$getOptionsDiff(e, c));
            if ($01a3030b6b7b975b$var$isEmptyObject(o[s])) delete o[s];
        } else if ($01a3030b6b7b975b$var$hasOwnProperty(n, s) && c !== e) {
            let t = true;
            if ($01a3030b6b7b975b$var$isArray(e) || $01a3030b6b7b975b$var$isArray(c)) try {
                if ($01a3030b6b7b975b$var$opsStringify(e) === $01a3030b6b7b975b$var$opsStringify(c)) t = false;
            } catch (r) {}
            if (t) o[s] = c;
        }
    });
    return o;
};
const $01a3030b6b7b975b$var$x = "os-environment";
const $01a3030b6b7b975b$var$$ = `${$01a3030b6b7b975b$var$x}-flexbox-glue`;
const $01a3030b6b7b975b$var$C = `${$01a3030b6b7b975b$var$$}-max`;
const $01a3030b6b7b975b$var$O = "data-overlayscrollbars";
const $01a3030b6b7b975b$var$z = "data-overlayscrollbars-initialize";
const $01a3030b6b7b975b$var$T = `${$01a3030b6b7b975b$var$O}-overflow-x`;
const $01a3030b6b7b975b$var$E = `${$01a3030b6b7b975b$var$O}-overflow-y`;
const $01a3030b6b7b975b$var$I = "overflowVisible";
const $01a3030b6b7b975b$var$A = "scrollbarHidden";
const $01a3030b6b7b975b$var$L = "updating";
const $01a3030b6b7b975b$var$H = "os-padding";
const $01a3030b6b7b975b$var$M = "os-viewport";
const $01a3030b6b7b975b$var$P = `${$01a3030b6b7b975b$var$M}-arrange`;
const $01a3030b6b7b975b$var$D = "os-content";
const $01a3030b6b7b975b$var$R = `${$01a3030b6b7b975b$var$M}-scrollbar-hidden`;
const $01a3030b6b7b975b$var$k = `os-overflow-visible`;
const $01a3030b6b7b975b$var$B = "os-size-observer";
const $01a3030b6b7b975b$var$V = `${$01a3030b6b7b975b$var$B}-appear`;
const $01a3030b6b7b975b$var$Y = `${$01a3030b6b7b975b$var$B}-listener`;
const $01a3030b6b7b975b$var$j = `${$01a3030b6b7b975b$var$Y}-scroll`;
const $01a3030b6b7b975b$var$N = `${$01a3030b6b7b975b$var$Y}-item`;
const $01a3030b6b7b975b$var$q = `${$01a3030b6b7b975b$var$N}-final`;
const $01a3030b6b7b975b$var$F = "os-trinsic-observer";
const $01a3030b6b7b975b$var$G = "os-theme-none";
const $01a3030b6b7b975b$var$X = "os-scrollbar";
const $01a3030b6b7b975b$var$U = `${$01a3030b6b7b975b$var$X}-rtl`;
const $01a3030b6b7b975b$var$W = `${$01a3030b6b7b975b$var$X}-horizontal`;
const $01a3030b6b7b975b$var$Z = `${$01a3030b6b7b975b$var$X}-vertical`;
const $01a3030b6b7b975b$var$J = `${$01a3030b6b7b975b$var$X}-track`;
const $01a3030b6b7b975b$var$K = `${$01a3030b6b7b975b$var$X}-handle`;
const $01a3030b6b7b975b$var$Q = `${$01a3030b6b7b975b$var$X}-visible`;
const $01a3030b6b7b975b$var$tt = `${$01a3030b6b7b975b$var$X}-cornerless`;
const $01a3030b6b7b975b$var$nt = `${$01a3030b6b7b975b$var$X}-transitionless`;
const $01a3030b6b7b975b$var$ot = `${$01a3030b6b7b975b$var$X}-interaction`;
const $01a3030b6b7b975b$var$st = `${$01a3030b6b7b975b$var$X}-unusable`;
const $01a3030b6b7b975b$var$et = `${$01a3030b6b7b975b$var$X}-auto-hidden`;
const $01a3030b6b7b975b$var$ct = `${$01a3030b6b7b975b$var$X}-wheel`;
const $01a3030b6b7b975b$var$rt = `${$01a3030b6b7b975b$var$J}-interactive`;
const $01a3030b6b7b975b$var$it = `${$01a3030b6b7b975b$var$K}-interactive`;
const $01a3030b6b7b975b$var$lt = {};
const $01a3030b6b7b975b$var$getPlugins = ()=>$01a3030b6b7b975b$var$lt;
const $01a3030b6b7b975b$var$addPlugin = (t)=>{
    const n = [];
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$isArray(t) ? t : [
        t
    ], (t)=>{
        const o = $01a3030b6b7b975b$var$keys(t);
        $01a3030b6b7b975b$var$each(o, (o)=>{
            $01a3030b6b7b975b$var$push(n, $01a3030b6b7b975b$var$lt[o] = t[o]);
        });
    });
    return n;
};
const $01a3030b6b7b975b$var$at = {
    boolean: "__TPL_boolean_TYPE__",
    number: "__TPL_number_TYPE__",
    string: "__TPL_string_TYPE__",
    array: "__TPL_array_TYPE__",
    object: "__TPL_object_TYPE__",
    function: "__TPL_function_TYPE__",
    null: "__TPL_null_TYPE__"
};
const $01a3030b6b7b975b$var$ut = $01a3030b6b7b975b$var$at.number;
const $01a3030b6b7b975b$var$dt = $01a3030b6b7b975b$var$at.boolean;
const $01a3030b6b7b975b$var$ft = [
    $01a3030b6b7b975b$var$at.array,
    $01a3030b6b7b975b$var$at.null
];
const $01a3030b6b7b975b$var$_t = "hidden scroll visible visible-hidden";
const $01a3030b6b7b975b$var$ht = "visible hidden auto";
const $01a3030b6b7b975b$var$gt = "never scroll leavemove";
$01a3030b6b7b975b$var$at.number, $01a3030b6b7b975b$var$at.array, $01a3030b6b7b975b$var$at.null, $01a3030b6b7b975b$var$at.function, $01a3030b6b7b975b$var$at.null, $01a3030b6b7b975b$var$at.string, $01a3030b6b7b975b$var$at.null, $01a3030b6b7b975b$var$at.array, $01a3030b6b7b975b$var$at.null;
const $01a3030b6b7b975b$var$vt = "__osOptionsValidationPlugin";
const $01a3030b6b7b975b$var$wt = 3333333;
const $01a3030b6b7b975b$var$pt = "scroll";
const $01a3030b6b7b975b$var$bt = "__osSizeObserverPlugin";
const $01a3030b6b7b975b$export$c327021fb99a6481 = /* @__PURE__ */ (()=>({
        [$01a3030b6b7b975b$var$bt]: {
            O: (t, n, o)=>{
                const s = $01a3030b6b7b975b$var$createDOM(`<div class="${$01a3030b6b7b975b$var$N}" dir="ltr"><div class="${$01a3030b6b7b975b$var$N}"><div class="${$01a3030b6b7b975b$var$q}"></div></div><div class="${$01a3030b6b7b975b$var$N}"><div class="${$01a3030b6b7b975b$var$q}" style="width: 200%; height: 200%"></div></div></div>`);
                $01a3030b6b7b975b$var$appendChildren(t, s);
                $01a3030b6b7b975b$var$addClass(t, $01a3030b6b7b975b$var$j);
                const e = s[0];
                const c = e.lastChild;
                const r = e.firstChild;
                const i = null == r ? void 0 : r.firstChild;
                let l = $01a3030b6b7b975b$var$offsetSize(e);
                let a = l;
                let u = false;
                let _;
                const reset = ()=>{
                    $01a3030b6b7b975b$var$scrollLeft(r, $01a3030b6b7b975b$var$wt);
                    $01a3030b6b7b975b$var$scrollTop(r, $01a3030b6b7b975b$var$wt);
                    $01a3030b6b7b975b$var$scrollLeft(c, $01a3030b6b7b975b$var$wt);
                    $01a3030b6b7b975b$var$scrollTop(c, $01a3030b6b7b975b$var$wt);
                };
                const onResized = (t)=>{
                    _ = 0;
                    if (u) {
                        l = a;
                        n(true === t);
                    }
                };
                const onScroll = (t)=>{
                    a = $01a3030b6b7b975b$var$offsetSize(e);
                    u = !t || !$01a3030b6b7b975b$var$equalWH(a, l);
                    if (t) {
                        $01a3030b6b7b975b$var$stopPropagation(t);
                        if (u && !_) {
                            $01a3030b6b7b975b$var$d(_);
                            _ = $01a3030b6b7b975b$var$f(onResized);
                        }
                    } else onResized(false === t);
                    reset();
                };
                const h = $01a3030b6b7b975b$var$push([], [
                    $01a3030b6b7b975b$var$on(r, $01a3030b6b7b975b$var$pt, onScroll),
                    $01a3030b6b7b975b$var$on(c, $01a3030b6b7b975b$var$pt, onScroll)
                ]);
                $01a3030b6b7b975b$var$style(i, {
                    width: $01a3030b6b7b975b$var$wt,
                    height: $01a3030b6b7b975b$var$wt
                });
                $01a3030b6b7b975b$var$f(reset);
                return [
                    o ? onScroll.bind(0, false) : reset,
                    h
                ];
            }
        }
    }))();
let $01a3030b6b7b975b$var$yt = 0;
const { round: $01a3030b6b7b975b$var$St, abs: $01a3030b6b7b975b$var$xt } = Math;
const $01a3030b6b7b975b$var$getWindowDPR = ()=>{
    const t = window.screen.deviceXDPI || 0;
    const n = window.screen.logicalXDPI || 1;
    return window.devicePixelRatio || t / n;
};
const $01a3030b6b7b975b$var$diffBiggerThanOne = (t, n)=>{
    const o = $01a3030b6b7b975b$var$xt(t);
    const s = $01a3030b6b7b975b$var$xt(n);
    return !(o === s || o + 1 === s || o - 1 === s);
};
const $01a3030b6b7b975b$var$$t = "__osScrollbarsHidingPlugin";
const $01a3030b6b7b975b$export$8c9a9f9ae72a1689 = /* @__PURE__ */ (()=>({
        [$01a3030b6b7b975b$var$$t]: {
            T: (t)=>{
                const { I: n, A: o, L: s } = t;
                const e = !s && !n && (o.x || o.y);
                const c = e ? document.createElement("style") : false;
                if (c) {
                    $01a3030b6b7b975b$var$attr(c, "id", `${$01a3030b6b7b975b$var$P}-${$01a3030b6b7b975b$var$yt}`);
                    $01a3030b6b7b975b$var$yt++;
                }
                return c;
            },
            H: (t, n, o, s, e, c, r)=>{
                const arrangeViewport = (n, c, r, i)=>{
                    if (t) {
                        const { M: t } = e();
                        const { P: l, D: a } = n;
                        const { x: u, y: d } = a;
                        const { x: f, y: _ } = l;
                        const h = i ? "paddingRight" : "paddingLeft";
                        const g = t[h];
                        const v = t.paddingTop;
                        const w = c.w + r.w;
                        const p = c.h + r.h;
                        const b = {
                            w: _ && d ? `${_ + w - g}px` : "",
                            h: f && u ? `${f + p - v}px` : ""
                        };
                        if (s) {
                            const { sheet: t } = s;
                            if (t) {
                                const { cssRules: n } = t;
                                if (n) {
                                    if (!n.length) t.insertRule(`#${$01a3030b6b7b975b$var$attr(s, "id")} + .${$01a3030b6b7b975b$var$P}::before {}`, 0);
                                    const o = n[0].style;
                                    o.width = b.w;
                                    o.height = b.h;
                                }
                            }
                        } else $01a3030b6b7b975b$var$style(o, {
                            "--os-vaw": b.w,
                            "--os-vah": b.h
                        });
                    }
                    return t;
                };
                const undoViewportArrange = (s, i, l)=>{
                    if (t) {
                        const a = l || c(s);
                        const { M: u } = e();
                        const { D: d } = a;
                        const { x: f, y: _ } = d;
                        const h = {};
                        const assignProps = (t)=>$01a3030b6b7b975b$var$each(t.split(" "), (t)=>{
                                h[t] = u[t];
                            });
                        if (f) assignProps("marginBottom paddingTop paddingBottom");
                        if (_) assignProps("marginLeft marginRight paddingLeft paddingRight");
                        const g = $01a3030b6b7b975b$var$style(o, $01a3030b6b7b975b$var$keys(h));
                        $01a3030b6b7b975b$var$removeClass(o, $01a3030b6b7b975b$var$P);
                        if (!n) h.height = "";
                        $01a3030b6b7b975b$var$style(o, h);
                        return [
                            ()=>{
                                r(a, i, t, g);
                                $01a3030b6b7b975b$var$style(o, g);
                                $01a3030b6b7b975b$var$addClass(o, $01a3030b6b7b975b$var$P);
                            },
                            a
                        ];
                    }
                    return [
                        $01a3030b6b7b975b$var$noop
                    ];
                };
                return [
                    arrangeViewport,
                    undoViewportArrange
                ];
            },
            R: ()=>{
                let t = {
                    w: 0,
                    h: 0
                };
                let n = 0;
                return (o, s, e)=>{
                    const c = $01a3030b6b7b975b$var$windowSize();
                    const r = {
                        w: c.w - t.w,
                        h: c.h - t.h
                    };
                    if (0 === r.w && 0 === r.h) return;
                    const i = {
                        w: $01a3030b6b7b975b$var$xt(r.w),
                        h: $01a3030b6b7b975b$var$xt(r.h)
                    };
                    const l = {
                        w: $01a3030b6b7b975b$var$xt($01a3030b6b7b975b$var$St(c.w / (t.w / 100))),
                        h: $01a3030b6b7b975b$var$xt($01a3030b6b7b975b$var$St(c.h / (t.h / 100)))
                    };
                    const a = $01a3030b6b7b975b$var$getWindowDPR();
                    const u = i.w > 2 && i.h > 2;
                    const d = !$01a3030b6b7b975b$var$diffBiggerThanOne(l.w, l.h);
                    const f = a !== n && a > 0;
                    const _ = u && d && f;
                    if (_) {
                        const [t, n] = s();
                        $01a3030b6b7b975b$var$assignDeep(o.k, t);
                        if (n) e();
                    }
                    t = c;
                    n = a;
                };
            }
        }
    }))();
const $01a3030b6b7b975b$var$Ot = "__osClickScrollPlugin";
const $01a3030b6b7b975b$export$1a35b83948406b62 = /* @__PURE__ */ (()=>({
        [$01a3030b6b7b975b$var$Ot]: {
            O: (t, n, o, s, e)=>{
                let c = 0;
                let r = $01a3030b6b7b975b$var$noop;
                const animateClickScroll = (i)=>{
                    r = $01a3030b6b7b975b$var$animateNumber(i, i + s * Math.sign(o), 133, (o, i, l)=>{
                        t(o);
                        const a = n();
                        const u = a + s;
                        const d = e >= a && e <= u;
                        if (l && !d) {
                            if (c) animateClickScroll(o);
                            else {
                                const t = setTimeout(()=>{
                                    animateClickScroll(o);
                                }, 222);
                                r = ()=>{
                                    clearTimeout(t);
                                };
                            }
                            c++;
                        }
                    });
                };
                animateClickScroll(0);
                return ()=>r();
            }
        }
    }))();
let $01a3030b6b7b975b$var$Tt;
const $01a3030b6b7b975b$var$getNativeScrollbarSize = (t, n, o, s)=>{
    $01a3030b6b7b975b$var$appendChildren(t, n);
    const e = $01a3030b6b7b975b$var$clientSize(n);
    const c = $01a3030b6b7b975b$var$offsetSize(n);
    const r = $01a3030b6b7b975b$var$fractionalSize(o);
    s && $01a3030b6b7b975b$var$removeElements(n);
    return {
        x: c.h - e.h + r.h,
        y: c.w - e.w + r.w
    };
};
const $01a3030b6b7b975b$var$getNativeScrollbarsHiding = (t)=>{
    let n = false;
    const o = $01a3030b6b7b975b$var$addClass(t, $01a3030b6b7b975b$var$R);
    try {
        n = "none" === $01a3030b6b7b975b$var$style(t, $01a3030b6b7b975b$var$cssProperty("scrollbar-width")) || "none" === window.getComputedStyle(t, "::-webkit-scrollbar").getPropertyValue("display");
    } catch (s) {}
    o();
    return n;
};
const $01a3030b6b7b975b$var$getRtlScrollBehavior = (t, n)=>{
    const o = "hidden";
    $01a3030b6b7b975b$var$style(t, {
        overflowX: o,
        overflowY: o,
        direction: "rtl"
    });
    $01a3030b6b7b975b$var$scrollLeft(t, 0);
    const s = $01a3030b6b7b975b$var$absoluteCoordinates(t);
    const e = $01a3030b6b7b975b$var$absoluteCoordinates(n);
    $01a3030b6b7b975b$var$scrollLeft(t, -999);
    const c = $01a3030b6b7b975b$var$absoluteCoordinates(n);
    return {
        i: s.x === e.x,
        n: e.x !== c.x
    };
};
const $01a3030b6b7b975b$var$getFlexboxGlue = (t, n)=>{
    const o = $01a3030b6b7b975b$var$addClass(t, $01a3030b6b7b975b$var$$);
    const s = $01a3030b6b7b975b$var$getBoundingClientRect(t);
    const e = $01a3030b6b7b975b$var$getBoundingClientRect(n);
    const c = $01a3030b6b7b975b$var$equalBCRWH(e, s, true);
    const r = $01a3030b6b7b975b$var$addClass(t, $01a3030b6b7b975b$var$C);
    const i = $01a3030b6b7b975b$var$getBoundingClientRect(t);
    const l = $01a3030b6b7b975b$var$getBoundingClientRect(n);
    const a = $01a3030b6b7b975b$var$equalBCRWH(l, i, true);
    o();
    r();
    return c && a;
};
const $01a3030b6b7b975b$var$createEnvironment = ()=>{
    const { body: t } = document;
    const n = $01a3030b6b7b975b$var$createDOM(`<div class="${$01a3030b6b7b975b$var$x}"><div></div></div>`);
    const o = n[0];
    const s = o.firstChild;
    const [e, , c] = $01a3030b6b7b975b$var$createEventListenerHub();
    const [r, i] = $01a3030b6b7b975b$var$createCache({
        o: $01a3030b6b7b975b$var$getNativeScrollbarSize(t, o, s),
        u: $01a3030b6b7b975b$var$equalXY
    }, $01a3030b6b7b975b$var$getNativeScrollbarSize.bind(0, t, o, s, true));
    const [l] = i();
    const a = $01a3030b6b7b975b$var$getNativeScrollbarsHiding(o);
    const u = {
        x: 0 === l.x,
        y: 0 === l.y
    };
    const d = {
        elements: {
            host: null,
            padding: !a,
            viewport: (t)=>a && t === t.ownerDocument.body && t,
            content: false
        },
        scrollbars: {
            slot: true
        },
        cancel: {
            nativeScrollbarsOverlaid: false,
            body: null
        }
    };
    const f = $01a3030b6b7b975b$var$assignDeep({}, $01a3030b6b7b975b$var$S);
    const _ = $01a3030b6b7b975b$var$assignDeep.bind(0, {}, f);
    const h = $01a3030b6b7b975b$var$assignDeep.bind(0, {}, d);
    const g = {
        k: l,
        A: u,
        I: a,
        L: "-1" === $01a3030b6b7b975b$var$style(o, "zIndex"),
        B: $01a3030b6b7b975b$var$getRtlScrollBehavior(o, s),
        V: $01a3030b6b7b975b$var$getFlexboxGlue(o, s),
        Y: e.bind(0, "z"),
        j: e.bind(0, "r"),
        N: h,
        q: (t)=>$01a3030b6b7b975b$var$assignDeep(d, t) && h(),
        F: _,
        G: (t)=>$01a3030b6b7b975b$var$assignDeep(f, t) && _(),
        X: $01a3030b6b7b975b$var$assignDeep({}, d),
        U: $01a3030b6b7b975b$var$assignDeep({}, f)
    };
    const v = window.addEventListener;
    const w = $01a3030b6b7b975b$var$debounce((t)=>c(t ? "z" : "r"), {
        g: 33,
        v: 99
    });
    $01a3030b6b7b975b$var$removeAttr(o, "style");
    $01a3030b6b7b975b$var$removeElements(o);
    v("resize", w.bind(0, false));
    if (!a && (!u.x || !u.y)) {
        let t;
        v("resize", ()=>{
            const n = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$$t];
            t = t || n && n.R();
            t && t(g, r, w.bind(0, true));
        });
    }
    return g;
};
const $01a3030b6b7b975b$var$getEnvironment = ()=>{
    if (!$01a3030b6b7b975b$var$Tt) $01a3030b6b7b975b$var$Tt = $01a3030b6b7b975b$var$createEnvironment();
    return $01a3030b6b7b975b$var$Tt;
};
const $01a3030b6b7b975b$var$resolveInitialization = (t, n)=>$01a3030b6b7b975b$var$isFunction(n) ? n.apply(0, t) : n;
const $01a3030b6b7b975b$var$staticInitializationElement = (t, n, o, s)=>{
    const e = $01a3030b6b7b975b$var$isUndefined(s) ? o : s;
    const c = $01a3030b6b7b975b$var$resolveInitialization(t, e);
    return c || n.apply(0, t);
};
const $01a3030b6b7b975b$var$dynamicInitializationElement = (t, n, o, s)=>{
    const e = $01a3030b6b7b975b$var$isUndefined(s) ? o : s;
    const c = $01a3030b6b7b975b$var$resolveInitialization(t, e);
    return !!c && ($01a3030b6b7b975b$var$isHTMLElement(c) ? c : n.apply(0, t));
};
const $01a3030b6b7b975b$var$cancelInitialization = (t, n, o)=>{
    const { nativeScrollbarsOverlaid: s, body: e } = o || {};
    const { A: c, I: r } = $01a3030b6b7b975b$var$getEnvironment();
    const { nativeScrollbarsOverlaid: i, body: l } = n;
    const a = null != s ? s : i;
    const u = $01a3030b6b7b975b$var$isUndefined(e) ? l : e;
    const d = (c.x || c.y) && a;
    const f = t && ($01a3030b6b7b975b$var$isNull(u) ? !r : u);
    return !!d || !!f;
};
const $01a3030b6b7b975b$var$Et = new WeakMap;
const $01a3030b6b7b975b$var$addInstance = (t, n)=>{
    $01a3030b6b7b975b$var$Et.set(t, n);
};
const $01a3030b6b7b975b$var$removeInstance = (t)=>{
    $01a3030b6b7b975b$var$Et.delete(t);
};
const $01a3030b6b7b975b$var$getInstance = (t)=>$01a3030b6b7b975b$var$Et.get(t);
const $01a3030b6b7b975b$var$getPropByPath = (t, n)=>t ? n.split(".").reduce((t, n)=>t && $01a3030b6b7b975b$var$hasOwnProperty(t, n) ? t[n] : void 0, t) : void 0;
const $01a3030b6b7b975b$var$createOptionCheck = (t, n, o)=>(s)=>[
            $01a3030b6b7b975b$var$getPropByPath(t, s),
            o || void 0 !== $01a3030b6b7b975b$var$getPropByPath(n, s)
        ];
const $01a3030b6b7b975b$var$createState = (t)=>{
    let n = t;
    return [
        ()=>n,
        (t)=>{
            n = $01a3030b6b7b975b$var$assignDeep({}, n, t);
        }
    ];
};
const $01a3030b6b7b975b$var$It = "tabindex";
const $01a3030b6b7b975b$var$At = $01a3030b6b7b975b$var$createDiv.bind(0, "");
const $01a3030b6b7b975b$var$unwrap = (t)=>{
    $01a3030b6b7b975b$var$appendChildren($01a3030b6b7b975b$var$parent(t), $01a3030b6b7b975b$var$contents(t));
    $01a3030b6b7b975b$var$removeElements(t);
};
const $01a3030b6b7b975b$var$createStructureSetupElements = (t)=>{
    const n = $01a3030b6b7b975b$var$getEnvironment();
    const { N: o, I: s } = n;
    const e = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$$t];
    const c = e && e.T;
    const { elements: r } = o();
    const { host: i, padding: l, viewport: a, content: u } = r;
    const d = $01a3030b6b7b975b$var$isHTMLElement(t);
    const f = d ? {} : t;
    const { elements: _ } = f;
    const { host: h, padding: g, viewport: v, content: w } = _ || {};
    const p = d ? t : f.target;
    const b = $01a3030b6b7b975b$var$is(p, "textarea");
    const m = p.ownerDocument;
    const y = m.documentElement;
    const S = p === m.body;
    const x = m.defaultView;
    const $ = $01a3030b6b7b975b$var$staticInitializationElement.bind(0, [
        p
    ]);
    const C = $01a3030b6b7b975b$var$dynamicInitializationElement.bind(0, [
        p
    ]);
    const I = $01a3030b6b7b975b$var$resolveInitialization.bind(0, [
        p
    ]);
    const A = $.bind(0, $01a3030b6b7b975b$var$At, a);
    const L = C.bind(0, $01a3030b6b7b975b$var$At, u);
    const P = A(v);
    const k = P === p;
    const B = k && S;
    const V = !k && L(w);
    const Y = !k && $01a3030b6b7b975b$var$isHTMLElement(P) && P === V;
    const j = Y && !!I(u);
    const N = j ? A() : P;
    const q = j ? V : L();
    const F = Y ? N : P;
    const G = B ? y : F;
    const X = b ? $($01a3030b6b7b975b$var$At, i, h) : p;
    const U = B ? G : X;
    const W = Y ? q : V;
    const Z = m.activeElement;
    const J = !k && x.top === x && Z === p;
    const K = {
        W: p,
        Z: U,
        J: G,
        K: !k && C($01a3030b6b7b975b$var$At, l, g),
        tt: W,
        nt: !k && !s && c && c(n),
        ot: B ? y : G,
        st: B ? m : G,
        et: x,
        ct: m,
        rt: b,
        it: S,
        lt: d,
        ut: k,
        dt: Y,
        ft: (t, n)=>k ? $01a3030b6b7b975b$var$hasAttrClass(G, $01a3030b6b7b975b$var$O, n) : $01a3030b6b7b975b$var$hasClass(G, t),
        _t: (t, n, o)=>k ? $01a3030b6b7b975b$var$attrClass(G, $01a3030b6b7b975b$var$O, n, o) : (o ? $01a3030b6b7b975b$var$addClass : $01a3030b6b7b975b$var$removeClass)(G, t)
    };
    const Q = $01a3030b6b7b975b$var$keys(K).reduce((t, n)=>{
        const o = K[n];
        return $01a3030b6b7b975b$var$push(t, o && !$01a3030b6b7b975b$var$parent(o) ? o : false);
    }, []);
    const elementIsGenerated = (t)=>t ? $01a3030b6b7b975b$var$indexOf(Q, t) > -1 : null;
    const { W: tt, Z: nt, K: ot, J: st, tt: et, nt: ct } = K;
    const rt = [
        ()=>{
            $01a3030b6b7b975b$var$removeAttr(nt, $01a3030b6b7b975b$var$O);
            $01a3030b6b7b975b$var$removeAttr(nt, $01a3030b6b7b975b$var$z);
            $01a3030b6b7b975b$var$removeAttr(tt, $01a3030b6b7b975b$var$z);
            if (S) {
                $01a3030b6b7b975b$var$removeAttr(y, $01a3030b6b7b975b$var$O);
                $01a3030b6b7b975b$var$removeAttr(y, $01a3030b6b7b975b$var$z);
            }
        }
    ];
    const it = b && elementIsGenerated(nt);
    let lt = b ? tt : $01a3030b6b7b975b$var$contents([
        et,
        st,
        ot,
        nt,
        tt
    ].find((t)=>false === elementIsGenerated(t)));
    const at = B ? tt : et || st;
    const appendElements = ()=>{
        $01a3030b6b7b975b$var$attr(nt, $01a3030b6b7b975b$var$O, k ? "viewport" : "host");
        const t = $01a3030b6b7b975b$var$addClass(ot, $01a3030b6b7b975b$var$H);
        const n = $01a3030b6b7b975b$var$addClass(st, !k && $01a3030b6b7b975b$var$M);
        const o = $01a3030b6b7b975b$var$addClass(et, $01a3030b6b7b975b$var$D);
        const e = S && !k ? $01a3030b6b7b975b$var$addClass($01a3030b6b7b975b$var$parent(p), $01a3030b6b7b975b$var$R) : $01a3030b6b7b975b$var$noop;
        if (it) {
            $01a3030b6b7b975b$var$insertAfter(tt, nt);
            $01a3030b6b7b975b$var$push(rt, ()=>{
                $01a3030b6b7b975b$var$insertAfter(nt, tt);
                $01a3030b6b7b975b$var$removeElements(nt);
            });
        }
        $01a3030b6b7b975b$var$appendChildren(at, lt);
        $01a3030b6b7b975b$var$appendChildren(nt, ot);
        $01a3030b6b7b975b$var$appendChildren(ot || nt, !k && st);
        $01a3030b6b7b975b$var$appendChildren(st, et);
        $01a3030b6b7b975b$var$push(rt, ()=>{
            e();
            $01a3030b6b7b975b$var$removeAttr(st, $01a3030b6b7b975b$var$T);
            $01a3030b6b7b975b$var$removeAttr(st, $01a3030b6b7b975b$var$E);
            if (elementIsGenerated(et)) $01a3030b6b7b975b$var$unwrap(et);
            if (elementIsGenerated(st)) $01a3030b6b7b975b$var$unwrap(st);
            if (elementIsGenerated(ot)) $01a3030b6b7b975b$var$unwrap(ot);
            t();
            n();
            o();
        });
        if (s && !k) $01a3030b6b7b975b$var$push(rt, $01a3030b6b7b975b$var$removeClass.bind(0, st, $01a3030b6b7b975b$var$R));
        if (ct) {
            $01a3030b6b7b975b$var$insertBefore(st, ct);
            $01a3030b6b7b975b$var$push(rt, $01a3030b6b7b975b$var$removeElements.bind(0, ct));
        }
        if (J) {
            const t = $01a3030b6b7b975b$var$attr(st, $01a3030b6b7b975b$var$It);
            $01a3030b6b7b975b$var$attr(st, $01a3030b6b7b975b$var$It, "-1");
            st.focus();
            const revertViewportTabIndex = ()=>t ? $01a3030b6b7b975b$var$attr(st, $01a3030b6b7b975b$var$It, t) : $01a3030b6b7b975b$var$removeAttr(st, $01a3030b6b7b975b$var$It);
            const n = $01a3030b6b7b975b$var$on(m, "pointerdown keydown", ()=>{
                revertViewportTabIndex();
                n();
            });
            $01a3030b6b7b975b$var$push(rt, [
                revertViewportTabIndex,
                n
            ]);
        } else if (Z && Z.focus) Z.focus();
        lt = 0;
    };
    return [
        K,
        appendElements,
        $01a3030b6b7b975b$var$runEachAndClear.bind(0, rt)
    ];
};
const $01a3030b6b7b975b$var$createTrinsicUpdateSegment = (t, n)=>{
    const { tt: o } = t;
    const [s] = n;
    return (t)=>{
        const { V: n } = $01a3030b6b7b975b$var$getEnvironment();
        const { ht: e } = s();
        const { gt: c } = t;
        const r = (o || !n) && c;
        if (r) $01a3030b6b7b975b$var$style(o, {
            height: e ? "" : "100%"
        });
        return {
            vt: r,
            wt: r
        };
    };
};
const $01a3030b6b7b975b$var$createPaddingUpdateSegment = (t, n)=>{
    const [o, s] = n;
    const { Z: e, K: c, J: r, ut: i } = t;
    const [l, a] = $01a3030b6b7b975b$var$createCache({
        u: $01a3030b6b7b975b$var$equalTRBL,
        o: $01a3030b6b7b975b$var$topRightBottomLeft()
    }, $01a3030b6b7b975b$var$topRightBottomLeft.bind(0, e, "padding", ""));
    return (t, n, e)=>{
        let [u, d] = a(e);
        const { I: f, V: _ } = $01a3030b6b7b975b$var$getEnvironment();
        const { bt: h } = o();
        const { vt: g, wt: v, yt: w } = t;
        const [p, b] = n("paddingAbsolute");
        const m = !_ && v;
        if (g || d || m) [u, d] = l(e);
        const y = !i && (b || w || d);
        if (y) {
            const t = !p || !c && !f;
            const n = u.r + u.l;
            const o = u.t + u.b;
            const e = {
                marginRight: t && !h ? -n : 0,
                marginBottom: t ? -o : 0,
                marginLeft: t && h ? -n : 0,
                top: t ? -u.t : 0,
                right: t ? h ? -u.r : "auto" : 0,
                left: t ? h ? "auto" : -u.l : 0,
                width: t ? `calc(100% + ${n}px)` : ""
            };
            const i = {
                paddingTop: t ? u.t : 0,
                paddingRight: t ? u.r : 0,
                paddingBottom: t ? u.b : 0,
                paddingLeft: t ? u.l : 0
            };
            $01a3030b6b7b975b$var$style(c || r, e);
            $01a3030b6b7b975b$var$style(r, i);
            s({
                K: u,
                St: !t,
                M: c ? i : $01a3030b6b7b975b$var$assignDeep({}, e, i)
            });
        }
        return {
            xt: y
        };
    };
};
const { max: $01a3030b6b7b975b$var$Lt } = Math;
const $01a3030b6b7b975b$var$Ht = $01a3030b6b7b975b$var$Lt.bind(0, 0);
const $01a3030b6b7b975b$var$Mt = "visible";
const $01a3030b6b7b975b$var$Pt = "hidden";
const $01a3030b6b7b975b$var$Dt = 42;
const $01a3030b6b7b975b$var$Rt = {
    u: $01a3030b6b7b975b$var$equalWH,
    o: {
        w: 0,
        h: 0
    }
};
const $01a3030b6b7b975b$var$kt = {
    u: $01a3030b6b7b975b$var$equalXY,
    o: {
        x: $01a3030b6b7b975b$var$Pt,
        y: $01a3030b6b7b975b$var$Pt
    }
};
const $01a3030b6b7b975b$var$getOverflowAmount = (t, n)=>{
    const o = window.devicePixelRatio % 1 !== 0 ? 1 : 0;
    const s = {
        w: $01a3030b6b7b975b$var$Ht(t.w - n.w),
        h: $01a3030b6b7b975b$var$Ht(t.h - n.h)
    };
    return {
        w: s.w > o ? s.w : 0,
        h: s.h > o ? s.h : 0
    };
};
const $01a3030b6b7b975b$var$conditionalClass = (t, n, o)=>o ? $01a3030b6b7b975b$var$addClass(t, n) : $01a3030b6b7b975b$var$removeClass(t, n);
const $01a3030b6b7b975b$var$overflowIsVisible = (t)=>0 === t.indexOf($01a3030b6b7b975b$var$Mt);
const $01a3030b6b7b975b$var$createOverflowUpdateSegment = (t, n)=>{
    const [o, s] = n;
    const { Z: e, K: c, J: r, nt: i, ut: l, _t: a, it: u, et: d } = t;
    const { k: f, V: _, I: h, A: g } = $01a3030b6b7b975b$var$getEnvironment();
    const v = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$$t];
    const w = !l && !h && (g.x || g.y);
    const p = u && l;
    const [b, m] = $01a3030b6b7b975b$var$createCache($01a3030b6b7b975b$var$Rt, $01a3030b6b7b975b$var$fractionalSize.bind(0, r));
    const [y, S] = $01a3030b6b7b975b$var$createCache($01a3030b6b7b975b$var$Rt, $01a3030b6b7b975b$var$scrollSize.bind(0, r));
    const [x, $] = $01a3030b6b7b975b$var$createCache($01a3030b6b7b975b$var$Rt);
    const [C, z] = $01a3030b6b7b975b$var$createCache($01a3030b6b7b975b$var$Rt);
    const [L] = $01a3030b6b7b975b$var$createCache($01a3030b6b7b975b$var$kt);
    const fixFlexboxGlue = (t, n)=>{
        $01a3030b6b7b975b$var$style(r, {
            height: ""
        });
        if (n) {
            const { St: n, K: s } = o();
            const { $t: c, P: i } = t;
            const l = $01a3030b6b7b975b$var$fractionalSize(e);
            const a = $01a3030b6b7b975b$var$clientSize(e);
            const u = "content-box" === $01a3030b6b7b975b$var$style(r, "boxSizing");
            const d = n || u ? s.b + s.t : 0;
            const f = !(g.x && u);
            $01a3030b6b7b975b$var$style(r, {
                height: a.h + l.h + (c.x && f ? i.x : 0) - d
            });
        }
    };
    const getViewportOverflowState = (t, n)=>{
        const o = !h && !t ? $01a3030b6b7b975b$var$Dt : 0;
        const getStatePerAxis = (t, s, e)=>{
            const c = $01a3030b6b7b975b$var$style(r, t);
            const i = n ? n[t] : c;
            const l = "scroll" === i;
            const a = s ? o : e;
            const u = l && !h ? a : 0;
            const d = s && !!o;
            return [
                c,
                l,
                u,
                d
            ];
        };
        const [s, e, c, i] = getStatePerAxis("overflowX", g.x, f.x);
        const [l, a, u, d] = getStatePerAxis("overflowY", g.y, f.y);
        return {
            Ct: {
                x: s,
                y: l
            },
            $t: {
                x: e,
                y: a
            },
            P: {
                x: c,
                y: u
            },
            D: {
                x: i,
                y: d
            }
        };
    };
    const setViewportOverflowState = (t, n, o, s)=>{
        const setAxisOverflowStyle = (t, n)=>{
            const o = $01a3030b6b7b975b$var$overflowIsVisible(t);
            const s = n && o && t.replace(`${$01a3030b6b7b975b$var$Mt}-`, "") || "";
            return [
                n && !o ? t : "",
                $01a3030b6b7b975b$var$overflowIsVisible(s) ? "hidden" : s
            ];
        };
        const [e, c] = setAxisOverflowStyle(o.x, n.x);
        const [r, i] = setAxisOverflowStyle(o.y, n.y);
        s.overflowX = c && r ? c : e;
        s.overflowY = i && e ? i : r;
        return getViewportOverflowState(t, s);
    };
    const hideNativeScrollbars = (t, n, s, e)=>{
        const { P: c, D: r } = t;
        const { x: i, y: l } = r;
        const { x: a, y: u } = c;
        const { M: d } = o();
        const f = n ? "marginLeft" : "marginRight";
        const _ = n ? "paddingLeft" : "paddingRight";
        const h = d[f];
        const g = d.marginBottom;
        const v = d[_];
        const w = d.paddingBottom;
        e.width = `calc(100% + ${u + -1 * h}px)`;
        e[f] = -u + h;
        e.marginBottom = -a + g;
        if (s) {
            e[_] = v + (l ? u : 0);
            e.paddingBottom = w + (i ? a : 0);
        }
    };
    const [H, M] = v ? v.H(w, _, r, i, o, getViewportOverflowState, hideNativeScrollbars) : [
        ()=>w,
        ()=>[
                $01a3030b6b7b975b$var$noop
            ]
    ];
    return (t, n, i)=>{
        const { vt: u, Ot: f, wt: v, xt: w, gt: P, yt: D } = t;
        const { ht: B, bt: V } = o();
        const [Y, j] = n("showNativeOverlaidScrollbars");
        const [N, q] = n("overflow");
        const F = Y && g.x && g.y;
        const G = !l && !_ && (u || v || f || j || P);
        const X = $01a3030b6b7b975b$var$overflowIsVisible(N.x);
        const U = $01a3030b6b7b975b$var$overflowIsVisible(N.y);
        const W = X || U;
        let Z = m(i);
        let J = S(i);
        let K = $(i);
        let Q = z(i);
        let tt;
        if (j && h) a($01a3030b6b7b975b$var$R, $01a3030b6b7b975b$var$A, !F);
        if (G) {
            tt = getViewportOverflowState(F);
            fixFlexboxGlue(tt, B);
        }
        if (u || w || v || D || j) {
            if (W) a($01a3030b6b7b975b$var$k, $01a3030b6b7b975b$var$I, false);
            const [t, n] = M(F, V, tt);
            const [o, s] = Z = b(i);
            const [e, c] = J = y(i);
            const l = $01a3030b6b7b975b$var$clientSize(r);
            let u = e;
            let f = l;
            t();
            if ((c || s || j) && n && !F && H(n, e, o, V)) {
                f = $01a3030b6b7b975b$var$clientSize(r);
                u = $01a3030b6b7b975b$var$scrollSize(r);
            }
            const _ = {
                w: $01a3030b6b7b975b$var$Ht($01a3030b6b7b975b$var$Lt(e.w, u.w) + o.w),
                h: $01a3030b6b7b975b$var$Ht($01a3030b6b7b975b$var$Lt(e.h, u.h) + o.h)
            };
            const h = {
                w: $01a3030b6b7b975b$var$Ht((p ? d.innerWidth : f.w + $01a3030b6b7b975b$var$Ht(l.w - e.w)) + o.w),
                h: $01a3030b6b7b975b$var$Ht((p ? d.innerHeight + o.h : f.h + $01a3030b6b7b975b$var$Ht(l.h - e.h)) + o.h)
            };
            Q = C(h);
            K = x($01a3030b6b7b975b$var$getOverflowAmount(_, h), i);
        }
        const [nt, ot] = Q;
        const [st, et] = K;
        const [ct, rt] = J;
        const [it, lt] = Z;
        const at = {
            x: st.w > 0,
            y: st.h > 0
        };
        const ut = X && U && (at.x || at.y) || X && at.x && !at.y || U && at.y && !at.x;
        if (w || D || lt || rt || ot || et || q || j || G) {
            const t = {
                marginRight: 0,
                marginBottom: 0,
                marginLeft: 0,
                width: "",
                overflowY: "",
                overflowX: ""
            };
            const n = setViewportOverflowState(F, at, N, t);
            const o = H(n, ct, it, V);
            if (!l) hideNativeScrollbars(n, V, o, t);
            if (G) fixFlexboxGlue(n, B);
            if (l) {
                $01a3030b6b7b975b$var$attr(e, $01a3030b6b7b975b$var$T, t.overflowX);
                $01a3030b6b7b975b$var$attr(e, $01a3030b6b7b975b$var$E, t.overflowY);
            } else $01a3030b6b7b975b$var$style(r, t);
        }
        $01a3030b6b7b975b$var$attrClass(e, $01a3030b6b7b975b$var$O, $01a3030b6b7b975b$var$I, ut);
        $01a3030b6b7b975b$var$conditionalClass(c, $01a3030b6b7b975b$var$k, ut);
        !l && $01a3030b6b7b975b$var$conditionalClass(r, $01a3030b6b7b975b$var$k, W);
        const [dt, ft] = L(getViewportOverflowState(F).Ct);
        s({
            Ct: dt,
            zt: {
                x: nt.w,
                y: nt.h
            },
            Tt: {
                x: st.w,
                y: st.h
            },
            Et: at
        });
        return {
            It: ft,
            At: ot,
            Lt: et
        };
    };
};
const $01a3030b6b7b975b$var$prepareUpdateHints = (t, n, o)=>{
    const s = {};
    const e = n || {};
    const c = $01a3030b6b7b975b$var$keys(t).concat($01a3030b6b7b975b$var$keys(e));
    $01a3030b6b7b975b$var$each(c, (n)=>{
        const c = t[n];
        const r = e[n];
        s[n] = !!(o || c || r);
    });
    return s;
};
const $01a3030b6b7b975b$var$createStructureSetupUpdate = (t, n)=>{
    const { W: o, J: s, _t: e, ut: c } = t;
    const { I: r, A: i, V: l } = $01a3030b6b7b975b$var$getEnvironment();
    const a = !r && (i.x || i.y);
    const u = [
        $01a3030b6b7b975b$var$createTrinsicUpdateSegment(t, n),
        $01a3030b6b7b975b$var$createPaddingUpdateSegment(t, n),
        $01a3030b6b7b975b$var$createOverflowUpdateSegment(t, n)
    ];
    return (t, n, r)=>{
        const i = $01a3030b6b7b975b$var$prepareUpdateHints($01a3030b6b7b975b$var$assignDeep({
            vt: false,
            xt: false,
            yt: false,
            gt: false,
            At: false,
            Lt: false,
            It: false,
            Ot: false,
            wt: false
        }, n), {}, r);
        const d = a || !l;
        const f = d && $01a3030b6b7b975b$var$scrollLeft(s);
        const _ = d && $01a3030b6b7b975b$var$scrollTop(s);
        e("", $01a3030b6b7b975b$var$L, true);
        let h = i;
        $01a3030b6b7b975b$var$each(u, (n)=>{
            h = $01a3030b6b7b975b$var$prepareUpdateHints(h, n(h, t, !!r) || {}, r);
        });
        $01a3030b6b7b975b$var$scrollLeft(s, f);
        $01a3030b6b7b975b$var$scrollTop(s, _);
        e("", $01a3030b6b7b975b$var$L);
        if (!c) {
            $01a3030b6b7b975b$var$scrollLeft(o, 0);
            $01a3030b6b7b975b$var$scrollTop(o, 0);
        }
        return h;
    };
};
const $01a3030b6b7b975b$var$createEventContentChange = (t, n, o)=>{
    let s;
    let e = false;
    const destroy = ()=>{
        e = true;
    };
    const updateElements = (c)=>{
        if (o) {
            const r = o.reduce((n, o)=>{
                if (o) {
                    const [s, e] = o;
                    const r = e && s && (c ? c(s) : $01a3030b6b7b975b$var$find(s, t));
                    if (r && r.length && e && $01a3030b6b7b975b$var$isString(e)) $01a3030b6b7b975b$var$push(n, [
                        r,
                        e.trim()
                    ], true);
                }
                return n;
            }, []);
            $01a3030b6b7b975b$var$each(r, (o)=>$01a3030b6b7b975b$var$each(o[0], (c)=>{
                    const r = o[1];
                    const i = s.get(c) || [];
                    const l = t.contains(c);
                    if (l) {
                        const t = $01a3030b6b7b975b$var$on(c, r, (o)=>{
                            if (e) {
                                t();
                                s.delete(c);
                            } else n(o);
                        });
                        s.set(c, $01a3030b6b7b975b$var$push(i, t));
                    } else {
                        $01a3030b6b7b975b$var$runEachAndClear(i);
                        s.delete(c);
                    }
                }));
        }
    };
    if (o) {
        s = new WeakMap;
        updateElements();
    }
    return [
        destroy,
        updateElements
    ];
};
const $01a3030b6b7b975b$var$createDOMObserver = (t, n, o, s)=>{
    let e = false;
    const { Ht: c, Mt: r, Pt: i, Dt: a, Rt: u, kt: d } = s || {};
    const f = $01a3030b6b7b975b$var$debounce(()=>{
        if (e) o(true);
    }, {
        g: 33,
        v: 99
    });
    const [_, h] = $01a3030b6b7b975b$var$createEventContentChange(t, f, i);
    const g = c || [];
    const v = r || [];
    const w = g.concat(v);
    const observerCallback = (e, c)=>{
        const r = u || $01a3030b6b7b975b$var$noop;
        const i = d || $01a3030b6b7b975b$var$noop;
        const l = new Set;
        const f = new Set;
        let _ = false;
        let g = false;
        $01a3030b6b7b975b$var$each(e, (o)=>{
            const { attributeName: e, target: c, type: u, oldValue: d, addedNodes: h, removedNodes: w } = o;
            const p = "attributes" === u;
            const b = "childList" === u;
            const m = t === c;
            const y = p && $01a3030b6b7b975b$var$isString(e) ? $01a3030b6b7b975b$var$attr(c, e) : 0;
            const S = 0 !== y && d !== y;
            const x = $01a3030b6b7b975b$var$indexOf(v, e) > -1 && S;
            if (n && (b || !m)) {
                const n = !p;
                const u = p && S;
                const f = u && a && $01a3030b6b7b975b$var$is(c, a);
                const _ = f ? !r(c, e, d, y) : n || u;
                const v = _ && !i(o, !!f, t, s);
                $01a3030b6b7b975b$var$each(h, (t)=>l.add(t));
                $01a3030b6b7b975b$var$each(w, (t)=>l.add(t));
                g = g || v;
            }
            if (!n && m && S && !r(c, e, d, y)) {
                f.add(e);
                _ = _ || x;
            }
        });
        if (l.size > 0) h((t)=>$01a3030b6b7b975b$var$from(l).reduce((n, o)=>{
                $01a3030b6b7b975b$var$push(n, $01a3030b6b7b975b$var$find(t, o));
                return $01a3030b6b7b975b$var$is(o, t) ? $01a3030b6b7b975b$var$push(n, o) : n;
            }, []));
        if (n) {
            !c && g && o(false);
            return [
                false
            ];
        }
        if (f.size > 0 || _) {
            const t = [
                $01a3030b6b7b975b$var$from(f),
                _
            ];
            !c && o.apply(0, t);
            return t;
        }
    };
    const p = new $01a3030b6b7b975b$var$l((t)=>observerCallback(t));
    p.observe(t, {
        attributes: true,
        attributeOldValue: true,
        attributeFilter: w,
        subtree: n,
        childList: n,
        characterData: n
    });
    e = true;
    return [
        ()=>{
            if (e) {
                _();
                p.disconnect();
                e = false;
            }
        },
        ()=>{
            if (e) {
                f.m();
                const t = p.takeRecords();
                return !$01a3030b6b7b975b$var$isEmptyArray(t) && observerCallback(t, true);
            }
        }
    ];
};
const $01a3030b6b7b975b$var$Bt = 3333333;
const $01a3030b6b7b975b$var$domRectHasDimensions = (t)=>t && (t.height || t.width);
const $01a3030b6b7b975b$var$createSizeObserver = (t, n, o)=>{
    const { Bt: s = false, Vt: e = false } = o || {};
    const c = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$bt];
    const { B: r } = $01a3030b6b7b975b$var$getEnvironment();
    const i = $01a3030b6b7b975b$var$createDOM(`<div class="${$01a3030b6b7b975b$var$B}"><div class="${$01a3030b6b7b975b$var$Y}"></div></div>`);
    const l = i[0];
    const a = l.firstChild;
    const d = $01a3030b6b7b975b$var$directionIsRTL.bind(0, t);
    const [f] = $01a3030b6b7b975b$var$createCache({
        o: void 0,
        _: true,
        u: (t, n)=>!(!t || !$01a3030b6b7b975b$var$domRectHasDimensions(t) && $01a3030b6b7b975b$var$domRectHasDimensions(n))
    });
    const onSizeChangedCallbackProxy = (t)=>{
        const o = $01a3030b6b7b975b$var$isArray(t) && t.length > 0 && $01a3030b6b7b975b$var$isObject(t[0]);
        const e = !o && $01a3030b6b7b975b$var$isBoolean(t[0]);
        let c = false;
        let i = false;
        let a = true;
        if (o) {
            const [n, , o] = f(t.pop().contentRect);
            const s = $01a3030b6b7b975b$var$domRectHasDimensions(n);
            const e = $01a3030b6b7b975b$var$domRectHasDimensions(o);
            c = !o || !s;
            i = !e && s;
            a = !c;
        } else if (e) [, a] = t;
        else i = true === t;
        if (s && a) {
            const n = e ? t[0] : $01a3030b6b7b975b$var$directionIsRTL(l);
            $01a3030b6b7b975b$var$scrollLeft(l, n ? r.n ? -$01a3030b6b7b975b$var$Bt : r.i ? 0 : $01a3030b6b7b975b$var$Bt : $01a3030b6b7b975b$var$Bt);
            $01a3030b6b7b975b$var$scrollTop(l, $01a3030b6b7b975b$var$Bt);
        }
        if (!c) n({
            vt: !e,
            Yt: e ? t : void 0,
            Vt: !!i
        });
    };
    const _ = [];
    let h = e ? onSizeChangedCallbackProxy : false;
    return [
        ()=>{
            $01a3030b6b7b975b$var$runEachAndClear(_);
            $01a3030b6b7b975b$var$removeElements(l);
        },
        ()=>{
            if ($01a3030b6b7b975b$var$u) {
                const t = new $01a3030b6b7b975b$var$u(onSizeChangedCallbackProxy);
                t.observe(a);
                $01a3030b6b7b975b$var$push(_, ()=>{
                    t.disconnect();
                });
            } else if (c) {
                const [t, n] = c.O(a, onSizeChangedCallbackProxy, e);
                h = t;
                $01a3030b6b7b975b$var$push(_, n);
            }
            if (s) {
                const [t] = $01a3030b6b7b975b$var$createCache({
                    o: !d()
                }, d);
                $01a3030b6b7b975b$var$push(_, $01a3030b6b7b975b$var$on(l, "scroll", (n)=>{
                    const o = t();
                    const [s, e] = o;
                    if (e) {
                        $01a3030b6b7b975b$var$removeClass(a, "ltr rtl");
                        if (s) $01a3030b6b7b975b$var$addClass(a, "rtl");
                        else $01a3030b6b7b975b$var$addClass(a, "ltr");
                        onSizeChangedCallbackProxy(o);
                    }
                    $01a3030b6b7b975b$var$stopPropagation(n);
                }));
            }
            if (h) {
                $01a3030b6b7b975b$var$addClass(l, $01a3030b6b7b975b$var$V);
                $01a3030b6b7b975b$var$push(_, $01a3030b6b7b975b$var$on(l, "animationstart", h, {
                    C: !!$01a3030b6b7b975b$var$u
                }));
            }
            if ($01a3030b6b7b975b$var$u || c) $01a3030b6b7b975b$var$appendChildren(t, l);
        }
    ];
};
const $01a3030b6b7b975b$var$isHeightIntrinsic = (t)=>0 === t.h || t.isIntersecting || t.intersectionRatio > 0;
const $01a3030b6b7b975b$var$createTrinsicObserver = (t, n)=>{
    let o;
    const s = $01a3030b6b7b975b$var$createDiv($01a3030b6b7b975b$var$F);
    const e = [];
    const [c] = $01a3030b6b7b975b$var$createCache({
        o: false
    });
    const triggerOnTrinsicChangedCallback = (t, o)=>{
        if (t) {
            const s = c($01a3030b6b7b975b$var$isHeightIntrinsic(t));
            const [, e] = s;
            if (e) {
                !o && n(s);
                return [
                    s
                ];
            }
        }
    };
    const intersectionObserverCallback = (t, n)=>{
        if (t && t.length > 0) return triggerOnTrinsicChangedCallback(t.pop(), n);
    };
    return [
        ()=>{
            $01a3030b6b7b975b$var$runEachAndClear(e);
            $01a3030b6b7b975b$var$removeElements(s);
        },
        ()=>{
            if ($01a3030b6b7b975b$var$a) {
                o = new $01a3030b6b7b975b$var$a((t)=>intersectionObserverCallback(t), {
                    root: t
                });
                o.observe(s);
                $01a3030b6b7b975b$var$push(e, ()=>{
                    o.disconnect();
                });
            } else {
                const onSizeChanged = ()=>{
                    const t = $01a3030b6b7b975b$var$offsetSize(s);
                    triggerOnTrinsicChangedCallback(t);
                };
                const [t, n] = $01a3030b6b7b975b$var$createSizeObserver(s, onSizeChanged);
                $01a3030b6b7b975b$var$push(e, t);
                n();
                onSizeChanged();
            }
            $01a3030b6b7b975b$var$appendChildren(t, s);
        },
        ()=>{
            if (o) return intersectionObserverCallback(o.takeRecords(), true);
        }
    ];
};
const $01a3030b6b7b975b$var$Vt = `[${$01a3030b6b7b975b$var$O}]`;
const $01a3030b6b7b975b$var$Yt = `.${$01a3030b6b7b975b$var$M}`;
const $01a3030b6b7b975b$var$jt = [
    "tabindex"
];
const $01a3030b6b7b975b$var$Nt = [
    "wrap",
    "cols",
    "rows"
];
const $01a3030b6b7b975b$var$qt = [
    "id",
    "class",
    "style",
    "open"
];
const $01a3030b6b7b975b$var$createStructureSetupObservers = (t, n, o)=>{
    let s;
    let e;
    let c;
    const { Z: r, J: i, tt: l, rt: a, ut: d, ft: f, _t: _ } = t;
    const { V: h } = $01a3030b6b7b975b$var$getEnvironment();
    const [g] = $01a3030b6b7b975b$var$createCache({
        u: $01a3030b6b7b975b$var$equalWH,
        o: {
            w: 0,
            h: 0
        }
    }, ()=>{
        const t = f($01a3030b6b7b975b$var$k, $01a3030b6b7b975b$var$I);
        const n = f($01a3030b6b7b975b$var$P, "");
        const o = n && $01a3030b6b7b975b$var$scrollLeft(i);
        const s = n && $01a3030b6b7b975b$var$scrollTop(i);
        _($01a3030b6b7b975b$var$k, $01a3030b6b7b975b$var$I);
        _($01a3030b6b7b975b$var$P, "");
        _("", $01a3030b6b7b975b$var$L, true);
        const e = $01a3030b6b7b975b$var$scrollSize(l);
        const c = $01a3030b6b7b975b$var$scrollSize(i);
        const r = $01a3030b6b7b975b$var$fractionalSize(i);
        _($01a3030b6b7b975b$var$k, $01a3030b6b7b975b$var$I, t);
        _($01a3030b6b7b975b$var$P, "", n);
        _("", $01a3030b6b7b975b$var$L);
        $01a3030b6b7b975b$var$scrollLeft(i, o);
        $01a3030b6b7b975b$var$scrollTop(i, s);
        return {
            w: c.w + e.w + r.w,
            h: c.h + e.h + r.h
        };
    });
    const v = a ? $01a3030b6b7b975b$var$Nt : $01a3030b6b7b975b$var$qt.concat($01a3030b6b7b975b$var$Nt);
    const w = $01a3030b6b7b975b$var$debounce(o, {
        g: ()=>s,
        v: ()=>e,
        p (t, n) {
            const [o] = t;
            const [s] = n;
            return [
                $01a3030b6b7b975b$var$keys(o).concat($01a3030b6b7b975b$var$keys(s)).reduce((t, n)=>{
                    t[n] = o[n] || s[n];
                    return t;
                }, {})
            ];
        }
    });
    const updateViewportAttrsFromHost = (t)=>{
        $01a3030b6b7b975b$var$each(t || $01a3030b6b7b975b$var$jt, (t)=>{
            if ($01a3030b6b7b975b$var$indexOf($01a3030b6b7b975b$var$jt, t) > -1) {
                const n = $01a3030b6b7b975b$var$attr(r, t);
                if ($01a3030b6b7b975b$var$isString(n)) $01a3030b6b7b975b$var$attr(i, t, n);
                else $01a3030b6b7b975b$var$removeAttr(i, t);
            }
        });
    };
    const onTrinsicChanged = (t, s)=>{
        const [e, c] = t;
        const r = {
            gt: c
        };
        n({
            ht: e
        });
        !s && o(r);
        return r;
    };
    const onSizeChanged = ({ vt: t, Yt: s, Vt: e })=>{
        const c = !t || e ? o : w;
        let r = false;
        if (s) {
            const [t, o] = s;
            r = o;
            n({
                bt: t
            });
        }
        c({
            vt: t,
            yt: r
        });
    };
    const onContentMutation = (t, n)=>{
        const [, s] = g();
        const e = {
            wt: s
        };
        const c = t ? o : w;
        if (s) !n && c(e);
        return e;
    };
    const onHostMutation = (t, n, o)=>{
        const s = {
            Ot: n
        };
        if (n) !o && w(s);
        else if (!d) updateViewportAttrsFromHost(t);
        return s;
    };
    const [p, b, m] = l || !h ? $01a3030b6b7b975b$var$createTrinsicObserver(r, onTrinsicChanged) : [
        $01a3030b6b7b975b$var$noop,
        $01a3030b6b7b975b$var$noop,
        $01a3030b6b7b975b$var$noop
    ];
    const [y, S] = !d ? $01a3030b6b7b975b$var$createSizeObserver(r, onSizeChanged, {
        Vt: true,
        Bt: true
    }) : [
        $01a3030b6b7b975b$var$noop,
        $01a3030b6b7b975b$var$noop
    ];
    const [x, $] = $01a3030b6b7b975b$var$createDOMObserver(r, false, onHostMutation, {
        Mt: $01a3030b6b7b975b$var$qt,
        Ht: $01a3030b6b7b975b$var$qt.concat($01a3030b6b7b975b$var$jt)
    });
    const C = d && $01a3030b6b7b975b$var$u && new $01a3030b6b7b975b$var$u(onSizeChanged.bind(0, {
        vt: true
    }));
    C && C.observe(r);
    updateViewportAttrsFromHost();
    return [
        ()=>{
            p();
            y();
            c && c[0]();
            C && C.disconnect();
            x();
        },
        ()=>{
            S();
            b();
        },
        ()=>{
            const t = {};
            const n = $();
            const o = m();
            const s = c && c[1]();
            if (n) $01a3030b6b7b975b$var$assignDeep(t, onHostMutation.apply(0, $01a3030b6b7b975b$var$push(n, true)));
            if (o) $01a3030b6b7b975b$var$assignDeep(t, onTrinsicChanged.apply(0, $01a3030b6b7b975b$var$push(o, true)));
            if (s) $01a3030b6b7b975b$var$assignDeep(t, onContentMutation.apply(0, $01a3030b6b7b975b$var$push(s, true)));
            return t;
        },
        (t)=>{
            const [n] = t("update.ignoreMutation");
            const [o, r] = t("update.attributes");
            const [a, u] = t("update.elementEvents");
            const [f, _] = t("update.debounce");
            const h = u || r;
            const ignoreMutationFromOptions = (t)=>$01a3030b6b7b975b$var$isFunction(n) && n(t);
            if (h) {
                if (c) {
                    c[1]();
                    c[0]();
                }
                c = $01a3030b6b7b975b$var$createDOMObserver(l || i, true, onContentMutation, {
                    Ht: v.concat(o || []),
                    Pt: a,
                    Dt: $01a3030b6b7b975b$var$Vt,
                    kt: (t, n)=>{
                        const { target: o, attributeName: s } = t;
                        const e = !n && s && !d ? $01a3030b6b7b975b$var$liesBetween(o, $01a3030b6b7b975b$var$Vt, $01a3030b6b7b975b$var$Yt) : false;
                        return e || !!$01a3030b6b7b975b$var$closest(o, `.${$01a3030b6b7b975b$var$X}`) || !!ignoreMutationFromOptions(t);
                    }
                });
            }
            if (_) {
                w.m();
                if ($01a3030b6b7b975b$var$isArray(f)) {
                    const t = f[0];
                    const n = f[1];
                    s = $01a3030b6b7b975b$var$isNumber(t) && t;
                    e = $01a3030b6b7b975b$var$isNumber(n) && n;
                } else if ($01a3030b6b7b975b$var$isNumber(f)) {
                    s = f;
                    e = false;
                } else {
                    s = false;
                    e = false;
                }
            }
        }
    ];
};
const $01a3030b6b7b975b$var$Ft = {
    x: 0,
    y: 0
};
const $01a3030b6b7b975b$var$Gt = {
    K: {
        t: 0,
        r: 0,
        b: 0,
        l: 0
    },
    St: false,
    M: {
        marginRight: 0,
        marginBottom: 0,
        marginLeft: 0,
        paddingTop: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingLeft: 0
    },
    zt: $01a3030b6b7b975b$var$Ft,
    Tt: $01a3030b6b7b975b$var$Ft,
    Ct: {
        x: "hidden",
        y: "hidden"
    },
    Et: {
        x: false,
        y: false
    },
    ht: false,
    bt: false
};
const $01a3030b6b7b975b$var$createStructureSetup = (t, n)=>{
    const o = $01a3030b6b7b975b$var$createOptionCheck(n, {});
    const s = $01a3030b6b7b975b$var$createState($01a3030b6b7b975b$var$Gt);
    const [e, c, r] = $01a3030b6b7b975b$var$createEventListenerHub();
    const [i, l] = s;
    const [a, u, d] = $01a3030b6b7b975b$var$createStructureSetupElements(t);
    const f = $01a3030b6b7b975b$var$createStructureSetupUpdate(a, s);
    const triggerUpdateEvent = (t, n, o)=>{
        const s = $01a3030b6b7b975b$var$keys(t).some((n)=>t[n]);
        const e = s || !$01a3030b6b7b975b$var$isEmptyObject(n) || o;
        if (e) r("u", [
            t,
            n,
            o
        ]);
        return e;
    };
    const [_, h, g, v] = $01a3030b6b7b975b$var$createStructureSetupObservers(a, l, (t)=>triggerUpdateEvent(f(o, t), {}, false));
    const w = i.bind(0);
    w.jt = (t)=>e("u", t);
    w.Nt = ()=>{
        const { W: t, J: n } = a;
        const o = $01a3030b6b7b975b$var$scrollLeft(t);
        const s = $01a3030b6b7b975b$var$scrollTop(t);
        h();
        u();
        $01a3030b6b7b975b$var$scrollLeft(n, o);
        $01a3030b6b7b975b$var$scrollTop(n, s);
    };
    w.qt = a;
    return [
        (t, o)=>{
            const s = $01a3030b6b7b975b$var$createOptionCheck(n, t, o);
            v(s);
            return triggerUpdateEvent(f(s, g(), o), t, !!o);
        },
        w,
        ()=>{
            c();
            _();
            d();
        }
    ];
};
const { round: $01a3030b6b7b975b$var$Xt } = Math;
const $01a3030b6b7b975b$var$getScale = (t)=>{
    const { width: n, height: o } = $01a3030b6b7b975b$var$getBoundingClientRect(t);
    const { w: s, h: e } = $01a3030b6b7b975b$var$offsetSize(t);
    return {
        x: $01a3030b6b7b975b$var$Xt(n) / s || 1,
        y: $01a3030b6b7b975b$var$Xt(o) / e || 1
    };
};
const $01a3030b6b7b975b$var$continuePointerDown = (t, n, o)=>{
    const s = n.scrollbars;
    const { button: e, isPrimary: c, pointerType: r } = t;
    const { pointers: i } = s;
    return 0 === e && c && s[o ? "dragScroll" : "clickScroll"] && (i || []).includes(r);
};
const $01a3030b6b7b975b$var$createRootClickStopPropagationEvents = (t, n)=>$01a3030b6b7b975b$var$on(t, "mousedown", $01a3030b6b7b975b$var$on.bind(0, n, "click", $01a3030b6b7b975b$var$stopPropagation, {
        C: true,
        $: true
    }), {
        $: true
    });
const $01a3030b6b7b975b$var$createInteractiveScrollEvents = (t, n, o, s, e, c)=>{
    const { B: r } = $01a3030b6b7b975b$var$getEnvironment();
    const { Ft: i, Gt: l, Xt: a } = o;
    const u = `scroll${c ? "Left" : "Top"}`;
    const d = `client${c ? "X" : "Y"}`;
    const f = c ? "width" : "height";
    const _ = c ? "left" : "top";
    const h = c ? "w" : "h";
    const g = c ? "x" : "y";
    const createRelativeHandleMove = (t, n)=>(o)=>{
            const { Tt: d } = e();
            const f = $01a3030b6b7b975b$var$offsetSize(l)[h] - $01a3030b6b7b975b$var$offsetSize(i)[h];
            const _ = n * o / f;
            const v = _ * d[g];
            const w = $01a3030b6b7b975b$var$directionIsRTL(a);
            const p = w && c ? r.n || r.i ? 1 : -1 : 1;
            s[u] = t + v * p;
        };
    return $01a3030b6b7b975b$var$on(l, "pointerdown", (o)=>{
        const e = $01a3030b6b7b975b$var$closest(o.target, `.${$01a3030b6b7b975b$var$K}`) === i;
        if ($01a3030b6b7b975b$var$continuePointerDown(o, t, e)) {
            const t = !e && o.shiftKey;
            const getHandleRect = ()=>$01a3030b6b7b975b$var$getBoundingClientRect(i);
            const getTrackRect = ()=>$01a3030b6b7b975b$var$getBoundingClientRect(l);
            const getHandleOffset = (t, n)=>(t || getHandleRect())[_] - (n || getTrackRect())[_];
            const c = createRelativeHandleMove(s[u] || 0, 1 / $01a3030b6b7b975b$var$getScale(s)[g]);
            const r = o[d];
            const a = getHandleRect();
            const h = getTrackRect();
            const v = a[f];
            const w = getHandleOffset(a, h) + v / 2;
            const p = r - h[_];
            const b = e ? 0 : p - w;
            const m = [
                $01a3030b6b7b975b$var$on(n, "selectstart", (t)=>$01a3030b6b7b975b$var$preventDefault(t), {
                    S: false
                }),
                $01a3030b6b7b975b$var$on(l, "pointermove", (n)=>{
                    const o = n[d] - r;
                    if (e || t) c(b + o);
                })
            ];
            if (t) c(b);
            else if (!e) {
                const t = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$Ot];
                if (t) $01a3030b6b7b975b$var$push(m, t.O(c, getHandleOffset, b, v, p));
            }
            $01a3030b6b7b975b$var$on(l, "pointerup", (t)=>{
                $01a3030b6b7b975b$var$runEachAndClear(m);
                l.releasePointerCapture(t.pointerId);
            }, {
                C: true
            });
            l.setPointerCapture(o.pointerId);
        }
    });
};
const $01a3030b6b7b975b$var$createScrollbarsSetupEvents = (t, n)=>(o, s, e, c, r, i)=>{
        const { Xt: l } = o;
        const [a, u] = $01a3030b6b7b975b$var$selfClearTimeout(333);
        const d = !!r.scrollBy;
        let f = true;
        return $01a3030b6b7b975b$var$runEachAndClear.bind(0, [
            $01a3030b6b7b975b$var$on(l, "pointerenter", ()=>{
                s($01a3030b6b7b975b$var$ot, true);
            }),
            $01a3030b6b7b975b$var$on(l, "pointerleave pointercancel", ()=>{
                s($01a3030b6b7b975b$var$ot);
            }),
            $01a3030b6b7b975b$var$on(l, "wheel", (t)=>{
                const { deltaX: n, deltaY: o, deltaMode: e } = t;
                if (d && f && 0 === e && $01a3030b6b7b975b$var$parent(l) === c) r.scrollBy({
                    left: n,
                    top: o,
                    behavior: "smooth"
                });
                f = false;
                s($01a3030b6b7b975b$var$ct, true);
                a(()=>{
                    f = true;
                    s($01a3030b6b7b975b$var$ct);
                });
                $01a3030b6b7b975b$var$preventDefault(t);
            }, {
                S: false,
                $: true
            }),
            $01a3030b6b7b975b$var$createRootClickStopPropagationEvents(l, e),
            $01a3030b6b7b975b$var$createInteractiveScrollEvents(t, e, o, r, n, i),
            u
        ]);
    };
const { min: $01a3030b6b7b975b$var$Ut, max: $01a3030b6b7b975b$var$Wt, abs: $01a3030b6b7b975b$var$Zt, round: $01a3030b6b7b975b$var$Jt } = Math;
const $01a3030b6b7b975b$var$getScrollbarHandleLengthRatio = (t, n, o, s)=>{
    if (s) {
        const t = o ? "x" : "y";
        const { Tt: n, zt: e } = s;
        const c = e[t];
        const r = n[t];
        return $01a3030b6b7b975b$var$Wt(0, $01a3030b6b7b975b$var$Ut(1, c / (c + r)));
    }
    const e = o ? "w" : "h";
    const c = $01a3030b6b7b975b$var$offsetSize(t)[e];
    const r = $01a3030b6b7b975b$var$offsetSize(n)[e];
    return $01a3030b6b7b975b$var$Wt(0, $01a3030b6b7b975b$var$Ut(1, c / r));
};
const $01a3030b6b7b975b$var$getScrollbarHandleOffsetRatio = (t, n, o, s, e, c)=>{
    const { B: r } = $01a3030b6b7b975b$var$getEnvironment();
    const i = c ? "x" : "y";
    const l = c ? "Left" : "Top";
    const { Tt: a } = s;
    const u = $01a3030b6b7b975b$var$Jt(a[i]);
    const d = $01a3030b6b7b975b$var$Zt(o[`scroll${l}`]);
    const f = c && e;
    const _ = r.i ? d : u - d;
    const h = f ? _ : d;
    const g = $01a3030b6b7b975b$var$Ut(1, h / u);
    const v = $01a3030b6b7b975b$var$getScrollbarHandleLengthRatio(t, n, c);
    return 1 / v * (1 - v) * g;
};
const $01a3030b6b7b975b$var$createScrollbarsSetupElements = (t, n, o)=>{
    const { N: s } = $01a3030b6b7b975b$var$getEnvironment();
    const { scrollbars: e } = s();
    const { slot: c } = e;
    const { ct: r, W: i, Z: l, J: a, lt: u, ot: d, it: f, ut: h } = n;
    const { scrollbars: g } = u ? {} : t;
    const { slot: v } = g || {};
    const w = $01a3030b6b7b975b$var$dynamicInitializationElement([
        i,
        l,
        a
    ], ()=>h && f ? i : l, c, v);
    const scrollbarStructureAddRemoveClass = (t, n, o)=>{
        const s = o ? $01a3030b6b7b975b$var$addClass : $01a3030b6b7b975b$var$removeClass;
        $01a3030b6b7b975b$var$each(t, (t)=>{
            s(t.Xt, n);
        });
    };
    const scrollbarsHandleStyle = (t, n)=>{
        $01a3030b6b7b975b$var$each(t, (t)=>{
            const [o, s] = n(t);
            $01a3030b6b7b975b$var$style(o, s);
        });
    };
    const scrollbarStructureRefreshHandleLength = (t, n, o)=>{
        scrollbarsHandleStyle(t, (t)=>{
            const { Ft: s, Gt: e } = t;
            return [
                s,
                {
                    [o ? "width" : "height"]: `${(100 * $01a3030b6b7b975b$var$getScrollbarHandleLengthRatio(s, e, o, n)).toFixed(3)}%`
                }
            ];
        });
    };
    const scrollbarStructureRefreshHandleOffset = (t, n, o)=>{
        const s = o ? "X" : "Y";
        scrollbarsHandleStyle(t, (t)=>{
            const { Ft: e, Gt: c, Xt: r } = t;
            const i = $01a3030b6b7b975b$var$getScrollbarHandleOffsetRatio(e, c, d, n, $01a3030b6b7b975b$var$directionIsRTL(r), o);
            const l = i === i;
            return [
                e,
                {
                    transform: l ? `translate${s}(${(100 * i).toFixed(3)}%)` : ""
                }
            ];
        });
    };
    const p = [];
    const b = [];
    const m = [];
    const scrollbarsAddRemoveClass = (t, n, o)=>{
        const s = $01a3030b6b7b975b$var$isBoolean(o);
        const e = s ? o : true;
        const c = s ? !o : true;
        e && scrollbarStructureAddRemoveClass(b, t, n);
        c && scrollbarStructureAddRemoveClass(m, t, n);
    };
    const refreshScrollbarsHandleLength = (t)=>{
        scrollbarStructureRefreshHandleLength(b, t, true);
        scrollbarStructureRefreshHandleLength(m, t);
    };
    const refreshScrollbarsHandleOffset = (t)=>{
        scrollbarStructureRefreshHandleOffset(b, t, true);
        scrollbarStructureRefreshHandleOffset(m, t);
    };
    const generateScrollbarDOM = (t)=>{
        const n = t ? $01a3030b6b7b975b$var$W : $01a3030b6b7b975b$var$Z;
        const s = t ? b : m;
        const e = $01a3030b6b7b975b$var$isEmptyArray(s) ? $01a3030b6b7b975b$var$nt : "";
        const c = $01a3030b6b7b975b$var$createDiv(`${$01a3030b6b7b975b$var$X} ${n} ${e}`);
        const i = $01a3030b6b7b975b$var$createDiv($01a3030b6b7b975b$var$J);
        const a = $01a3030b6b7b975b$var$createDiv($01a3030b6b7b975b$var$K);
        const u = {
            Xt: c,
            Gt: i,
            Ft: a
        };
        $01a3030b6b7b975b$var$appendChildren(c, i);
        $01a3030b6b7b975b$var$appendChildren(i, a);
        $01a3030b6b7b975b$var$push(s, u);
        $01a3030b6b7b975b$var$push(p, [
            $01a3030b6b7b975b$var$removeElements.bind(0, c),
            o(u, scrollbarsAddRemoveClass, r, l, d, t)
        ]);
        return u;
    };
    const y = generateScrollbarDOM.bind(0, true);
    const S = generateScrollbarDOM.bind(0, false);
    const appendElements = ()=>{
        $01a3030b6b7b975b$var$appendChildren(w, b[0].Xt);
        $01a3030b6b7b975b$var$appendChildren(w, m[0].Xt);
        $01a3030b6b7b975b$var$_(()=>{
            scrollbarsAddRemoveClass($01a3030b6b7b975b$var$nt);
        }, 300);
    };
    y();
    S();
    return [
        {
            Ut: refreshScrollbarsHandleLength,
            Wt: refreshScrollbarsHandleOffset,
            Zt: scrollbarsAddRemoveClass,
            Jt: {
                Kt: b,
                Qt: y,
                tn: scrollbarsHandleStyle.bind(0, b)
            },
            nn: {
                Kt: m,
                Qt: S,
                tn: scrollbarsHandleStyle.bind(0, m)
            }
        },
        appendElements,
        $01a3030b6b7b975b$var$runEachAndClear.bind(0, p)
    ];
};
const $01a3030b6b7b975b$var$createScrollbarsSetup = (t, n, o, s)=>{
    let e;
    let c;
    let r;
    let i;
    let l;
    let a = 0;
    const u = $01a3030b6b7b975b$var$createState({});
    const [d] = u;
    const [f, _] = $01a3030b6b7b975b$var$selfClearTimeout();
    const [h, g] = $01a3030b6b7b975b$var$selfClearTimeout();
    const [v, w] = $01a3030b6b7b975b$var$selfClearTimeout(100);
    const [p, b] = $01a3030b6b7b975b$var$selfClearTimeout(100);
    const [m, y] = $01a3030b6b7b975b$var$selfClearTimeout(()=>a);
    const [S, x, $] = $01a3030b6b7b975b$var$createScrollbarsSetupElements(t, o.qt, $01a3030b6b7b975b$var$createScrollbarsSetupEvents(n, o));
    const { Z: C, J: O, ot: z, st: T, ut: E, it: I } = o.qt;
    const { Jt: A, nn: L, Zt: H, Ut: M, Wt: P } = S;
    const { tn: D } = A;
    const { tn: R } = L;
    const styleScrollbarPosition = (t)=>{
        const { Xt: n } = t;
        const o = E && !I && $01a3030b6b7b975b$var$parent(n) === O && n;
        return [
            o,
            {
                transform: o ? `translate(${$01a3030b6b7b975b$var$scrollLeft(z)}px, ${$01a3030b6b7b975b$var$scrollTop(z)}px)` : ""
            }
        ];
    };
    const manageScrollbarsAutoHide = (t, n)=>{
        y();
        if (t) H($01a3030b6b7b975b$var$et);
        else {
            const hide = ()=>H($01a3030b6b7b975b$var$et, true);
            if (a > 0 && !n) m(hide);
            else hide();
        }
    };
    const onHostMouseEnter = ()=>{
        i = c;
        i && manageScrollbarsAutoHide(true);
    };
    const k = [
        w,
        y,
        b,
        g,
        _,
        $,
        $01a3030b6b7b975b$var$on(C, "pointerover", onHostMouseEnter, {
            C: true
        }),
        $01a3030b6b7b975b$var$on(C, "pointerenter", onHostMouseEnter),
        $01a3030b6b7b975b$var$on(C, "pointerleave", ()=>{
            i = false;
            c && manageScrollbarsAutoHide(false);
        }),
        $01a3030b6b7b975b$var$on(C, "pointermove", ()=>{
            e && f(()=>{
                w();
                manageScrollbarsAutoHide(true);
                p(()=>{
                    e && manageScrollbarsAutoHide(false);
                });
            });
        }),
        $01a3030b6b7b975b$var$on(T, "scroll", (t)=>{
            h(()=>{
                P(o());
                r && manageScrollbarsAutoHide(true);
                v(()=>{
                    r && !i && manageScrollbarsAutoHide(false);
                });
            });
            s(t);
            E && D(styleScrollbarPosition);
            E && R(styleScrollbarPosition);
        })
    ];
    const B = d.bind(0);
    B.qt = S;
    B.Nt = x;
    return [
        (t, s, i)=>{
            const { At: u, Lt: d, It: f, yt: _ } = i;
            const { A: h } = $01a3030b6b7b975b$var$getEnvironment();
            const g = $01a3030b6b7b975b$var$createOptionCheck(n, t, s);
            const v = o();
            const { Tt: w, Ct: p, bt: b } = v;
            const [m, y] = g("showNativeOverlaidScrollbars");
            const [S, x] = g("scrollbars.theme");
            const [$, C] = g("scrollbars.visibility");
            const [O, z] = g("scrollbars.autoHide");
            const [T] = g("scrollbars.autoHideDelay");
            const [E, A] = g("scrollbars.dragScroll");
            const [L, D] = g("scrollbars.clickScroll");
            const R = u || d || _;
            const k = f || C;
            const B = m && h.x && h.y;
            const setScrollbarVisibility = (t, n)=>{
                const o = "visible" === $ || "auto" === $ && "scroll" === t;
                H($01a3030b6b7b975b$var$Q, o, n);
                return o;
            };
            a = T;
            if (y) H($01a3030b6b7b975b$var$G, B);
            if (x) {
                H(l);
                H(S, true);
                l = S;
            }
            if (z) {
                e = "move" === O;
                c = "leave" === O;
                r = "never" !== O;
                manageScrollbarsAutoHide(!r, true);
            }
            if (A) H($01a3030b6b7b975b$var$it, E);
            if (D) H($01a3030b6b7b975b$var$rt, L);
            if (k) {
                const t = setScrollbarVisibility(p.x, true);
                const n = setScrollbarVisibility(p.y, false);
                const o = t && n;
                H($01a3030b6b7b975b$var$tt, !o);
            }
            if (R) {
                M(v);
                P(v);
                H($01a3030b6b7b975b$var$st, !w.x, true);
                H($01a3030b6b7b975b$var$st, !w.y, false);
                H($01a3030b6b7b975b$var$U, b && !I);
            }
        },
        B,
        $01a3030b6b7b975b$var$runEachAndClear.bind(0, k)
    ];
};
const $01a3030b6b7b975b$var$invokePluginInstance = (t, n, o)=>{
    if ($01a3030b6b7b975b$var$isFunction(t)) t(n || void 0, o || void 0);
};
const $01a3030b6b7b975b$export$d08ab3fe303a3356 = (t, n, o)=>{
    const { F: s, N: e, Y: c, j: r } = $01a3030b6b7b975b$var$getEnvironment();
    const i = $01a3030b6b7b975b$var$getPlugins();
    const l = $01a3030b6b7b975b$var$isHTMLElement(t);
    const a = l ? t : t.target;
    const u = $01a3030b6b7b975b$var$getInstance(a);
    if (n && !u) {
        let u = false;
        const validateOptions = (t)=>{
            const n = $01a3030b6b7b975b$var$getPlugins()[$01a3030b6b7b975b$var$vt];
            const o = n && n.O;
            return o ? o(t, true) : t;
        };
        const d = $01a3030b6b7b975b$var$assignDeep({}, s(), validateOptions(n));
        const [f, _, h] = $01a3030b6b7b975b$var$createEventListenerHub(o);
        const [g, v, w] = $01a3030b6b7b975b$var$createStructureSetup(t, d);
        const [p, b, m] = $01a3030b6b7b975b$var$createScrollbarsSetup(t, d, v, (t)=>h("scroll", [
                $,
                t
            ]));
        const update = (t, n)=>g(t, !!n);
        const y = update.bind(0, {}, true);
        const S = c(y);
        const x = r(y);
        const destroy = (t)=>{
            $01a3030b6b7b975b$var$removeInstance(a);
            S();
            x();
            m();
            w();
            u = true;
            h("destroyed", [
                $,
                !!t
            ]);
            _();
        };
        const $ = {
            options (t, n) {
                if (t) {
                    const o = n ? s() : {};
                    const e = $01a3030b6b7b975b$var$getOptionsDiff(d, $01a3030b6b7b975b$var$assignDeep(o, validateOptions(t)));
                    if (!$01a3030b6b7b975b$var$isEmptyObject(e)) {
                        $01a3030b6b7b975b$var$assignDeep(d, e);
                        update(e);
                    }
                }
                return $01a3030b6b7b975b$var$assignDeep({}, d);
            },
            on: f,
            off: (t, n)=>{
                t && n && _(t, n);
            },
            state () {
                const { zt: t, Tt: n, Ct: o, Et: s, K: e, St: c, bt: r } = v();
                return $01a3030b6b7b975b$var$assignDeep({}, {
                    overflowEdge: t,
                    overflowAmount: n,
                    overflowStyle: o,
                    hasOverflow: s,
                    padding: e,
                    paddingAbsolute: c,
                    directionRTL: r,
                    destroyed: u
                });
            },
            elements () {
                const { W: t, Z: n, K: o, J: s, tt: e, ot: c, st: r } = v.qt;
                const { Jt: i, nn: l } = b.qt;
                const translateScrollbarStructure = (t)=>{
                    const { Ft: n, Gt: o, Xt: s } = t;
                    return {
                        scrollbar: s,
                        track: o,
                        handle: n
                    };
                };
                const translateScrollbarsSetupElement = (t)=>{
                    const { Kt: n, Qt: o } = t;
                    const s = translateScrollbarStructure(n[0]);
                    return $01a3030b6b7b975b$var$assignDeep({}, s, {
                        clone: ()=>{
                            const t = translateScrollbarStructure(o());
                            p({}, true, {});
                            return t;
                        }
                    });
                };
                return $01a3030b6b7b975b$var$assignDeep({}, {
                    target: t,
                    host: n,
                    padding: o || s,
                    viewport: s,
                    content: e || s,
                    scrollOffsetElement: c,
                    scrollEventElement: r,
                    scrollbarHorizontal: translateScrollbarsSetupElement(i),
                    scrollbarVertical: translateScrollbarsSetupElement(l)
                });
            },
            update: (t)=>update({}, t),
            destroy: destroy.bind(0)
        };
        v.jt((t, n, o)=>{
            p(n, o, t);
        });
        $01a3030b6b7b975b$var$addInstance(a, $);
        $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$keys(i), (t)=>$01a3030b6b7b975b$var$invokePluginInstance(i[t], 0, $));
        if ($01a3030b6b7b975b$var$cancelInitialization(v.qt.it, e().cancel, !l && t.cancel)) {
            destroy(true);
            return $;
        }
        v.Nt();
        b.Nt();
        h("initialized", [
            $
        ]);
        v.jt((t, n, o)=>{
            const { vt: s, yt: e, gt: c, At: r, Lt: i, It: l, wt: a, Ot: u } = t;
            h("updated", [
                $,
                {
                    updateHints: {
                        sizeChanged: s,
                        directionChanged: e,
                        heightIntrinsicChanged: c,
                        overflowEdgeChanged: r,
                        overflowAmountChanged: i,
                        overflowStyleChanged: l,
                        contentMutation: a,
                        hostMutation: u
                    },
                    changedOptions: n,
                    force: o
                }
            ]);
        });
        $.update(true);
        return $;
    }
    return u;
};
$01a3030b6b7b975b$export$d08ab3fe303a3356.plugin = (t)=>{
    $01a3030b6b7b975b$var$each($01a3030b6b7b975b$var$addPlugin(t), (t)=>$01a3030b6b7b975b$var$invokePluginInstance(t, $01a3030b6b7b975b$export$d08ab3fe303a3356));
};
$01a3030b6b7b975b$export$d08ab3fe303a3356.valid = (t)=>{
    const n = t && t.elements;
    const o = $01a3030b6b7b975b$var$isFunction(n) && n();
    return $01a3030b6b7b975b$var$isPlainObject(o) && !!$01a3030b6b7b975b$var$getInstance(o.target);
};
$01a3030b6b7b975b$export$d08ab3fe303a3356.env = ()=>{
    const { k: t, A: n, I: o, B: s, V: e, L: c, X: r, U: i, N: l, q: a, F: u, G: d } = $01a3030b6b7b975b$var$getEnvironment();
    return $01a3030b6b7b975b$var$assignDeep({}, {
        scrollbarsSize: t,
        scrollbarsOverlaid: n,
        scrollbarsHiding: o,
        rtlScrollBehavior: s,
        flexboxGlue: e,
        cssCustomProperties: c,
        staticDefaultInitialization: r,
        staticDefaultOptions: i,
        getDefaultInitialization: l,
        setDefaultInitialization: a,
        getDefaultOptions: u,
        setDefaultOptions: d
    });
};

});



parcelRequire.register("iYDAL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58149caaaffc1a19$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $3QwDE = parcelRequire("3QwDE");

var $6dWr0 = parcelRequire("6dWr0");

var $6PcpQ = parcelRequire("6PcpQ");

var $8gTeD = parcelRequire("8gTeD");
function $58149caaaffc1a19$var$DetailsSummary({ children: children }) {
    const [summary, details] = Array.isArray(children) ? children : [
        children
    ];
    const [isExpanded, setIsExpanded] = (0, $eCoWV.useState)(false);
    const [height, setHeight] = (0, $eCoWV.useState)(0);
    const onClickHandler = (0, $eCoWV.useCallback)(()=>{
        setIsExpanded(!isExpanded);
        setHeight(height === 0 ? "auto" : 0);
    }, [
        height,
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8gTeD.container, isExpanded && $8gTeD.expanded),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                role: "button",
                tabIndex: 0,
                className: $8gTeD.summary,
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)({
                    Esc: ()=>{
                        setIsExpanded(false);
                        setHeight(0);
                    },
                    Enter: onClickHandler,
                    " ": onClickHandler
                }),
                onClick: onClickHandler,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6dWr0.default), {
                        className: $8gTeD.arrow
                    }),
                    summary
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3QwDE.default), {
                animateOpacity: true,
                duration: 300,
                height: height,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $8gTeD.details,
                    children: details
                })
            })
        ]
    });
}
var $58149caaaffc1a19$export$2e2bcd8739ae039 = $58149caaaffc1a19$var$DetailsSummary;

});
parcelRequire.register("3QwDE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2ccf8bc2f657609a$export$2e2bcd8739ae039; });

var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");
var $2ccf8bc2f657609a$var$__rest = undefined && undefined.__rest || function(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};
// ------------------ Helpers
function $2ccf8bc2f657609a$var$isNumber(n) {
    const number = parseFloat(n);
    return !isNaN(number) && isFinite(number);
}
function $2ccf8bc2f657609a$var$isPercentage(height) {
    // Percentage height
    return typeof height === "string" && height[height.length - 1] === "%" && $2ccf8bc2f657609a$var$isNumber(height.substring(0, height.length - 1));
}
function $2ccf8bc2f657609a$var$hideContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) element.style.display = "none";
}
function $2ccf8bc2f657609a$var$showContent(element, height) {
    // Check for element?.style is added cause this would fail in tests (react-test-renderer)
    // Read more here: https://github.com/Stanko/react-animate-height/issues/17
    if (height === 0 && (element === null || element === void 0 ? void 0 : element.style)) element.style.display = "";
}
const $2ccf8bc2f657609a$var$ANIMATION_STATE_CLASSES = {
    animating: "rah-animating",
    animatingUp: "rah-animating--up",
    animatingDown: "rah-animating--down",
    animatingToHeightZero: "rah-animating--to-height-zero",
    animatingToHeightAuto: "rah-animating--to-height-auto",
    animatingToHeightSpecific: "rah-animating--to-height-specific",
    static: "rah-static",
    staticHeightZero: "rah-static--height-zero",
    staticHeightAuto: "rah-static--height-auto",
    staticHeightSpecific: "rah-static--height-specific"
};
function $2ccf8bc2f657609a$var$getStaticStateClasses(animationStateClasses, height) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))({
        [animationStateClasses.static]: true,
        [animationStateClasses.staticHeightZero]: height === 0,
        [animationStateClasses.staticHeightSpecific]: height > 0,
        [animationStateClasses.staticHeightAuto]: height === "auto"
    });
}
const $2ccf8bc2f657609a$var$AnimateHeight = (_a)=>{
    var { animateOpacity: animateOpacity = false, animationStateClasses: animationStateClasses = {}, applyInlineTransitions: applyInlineTransitions = true, children: children, className: className = "", contentClassName: contentClassName, delay: userDelay = 0, duration: userDuration = 500, easing: easing = "ease", height: height, onHeightAnimationEnd: onHeightAnimationEnd, onHeightAnimationStart: onHeightAnimationStart, style: style } = _a, props = $2ccf8bc2f657609a$var$__rest(_a, [
        "animateOpacity",
        "animationStateClasses",
        "applyInlineTransitions",
        "children",
        "className",
        "contentClassName",
        "delay",
        "duration",
        "easing",
        "height",
        "onHeightAnimationEnd",
        "onHeightAnimationStart",
        "style"
    ]);
    // ------------------ Initialization
    const prevHeight = (0, $eCoWV.useRef)(height);
    const contentElement = (0, $eCoWV.useRef)(null);
    const animationClassesTimeoutID = (0, $eCoWV.useRef)();
    const timeoutID = (0, $eCoWV.useRef)();
    const stateClasses = (0, $eCoWV.useRef)(Object.assign(Object.assign({}, $2ccf8bc2f657609a$var$ANIMATION_STATE_CLASSES), animationStateClasses));
    const isBrowser = typeof window !== "undefined";
    const prefersReducedMotion = (0, $eCoWV.useRef)(isBrowser && window.matchMedia ? window.matchMedia("(prefers-reduced-motion)").matches : false);
    const delay = prefersReducedMotion.current ? 0 : userDelay;
    const duration = prefersReducedMotion.current ? 0 : userDuration;
    let initHeight = height;
    let initOverflow = "visible";
    if (typeof initHeight === "number") {
        // Reset negative height to 0
        initHeight = height < 0 ? 0 : height;
        initOverflow = "hidden";
    } else if ($2ccf8bc2f657609a$var$isPercentage(initHeight)) {
        // If value is string "0%" make sure we convert it to number 0
        initHeight = height === "0%" ? 0 : height;
        initOverflow = "hidden";
    }
    const [currentHeight, setCurrentHeight] = (0, $eCoWV.useState)(initHeight);
    const [overflow, setOverflow] = (0, $eCoWV.useState)(initOverflow);
    const [useTransitions, setUseTransitions] = (0, $eCoWV.useState)(false);
    const [animationStateClassNames, setAnimationStateClassNames] = (0, $eCoWV.useState)($2ccf8bc2f657609a$var$getStaticStateClasses(stateClasses.current, height));
    // ------------------ Did mount
    (0, $eCoWV.useEffect)(()=>{
        // Hide content if height is 0 (to prevent tabbing into it)
        $2ccf8bc2f657609a$var$hideContent(contentElement.current, currentHeight);
    // This should be explicitly run only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // ------------------ Height update
    (0, $eCoWV.useEffect)(()=>{
        if (height !== prevHeight.current && contentElement.current) {
            $2ccf8bc2f657609a$var$showContent(contentElement.current, prevHeight.current);
            // Cache content height
            contentElement.current.style.overflow = "hidden";
            const contentHeight = contentElement.current.offsetHeight;
            contentElement.current.style.overflow = "";
            // set total animation time
            const totalDuration = duration + delay;
            let newHeight;
            let timeoutHeight;
            let timeoutOverflow = "hidden";
            let timeoutUseTransitions;
            const isCurrentHeightAuto = prevHeight.current === "auto";
            if (typeof height === "number") {
                // Reset negative height to 0
                newHeight = height < 0 ? 0 : height;
                timeoutHeight = newHeight;
            } else if ($2ccf8bc2f657609a$var$isPercentage(height)) {
                // If value is string "0%" make sure we convert it to number 0
                newHeight = height === "0%" ? 0 : height;
                timeoutHeight = newHeight;
            } else {
                // If not, animate to content height
                // and then reset to auto
                newHeight = contentHeight; // TODO solve contentHeight = 0
                timeoutHeight = "auto";
                timeoutOverflow = undefined;
            }
            if (isCurrentHeightAuto) {
                // This is the height to be animated to
                timeoutHeight = newHeight;
                // If previous height was 'auto'
                // set starting height explicitly to be able to use transition
                newHeight = contentHeight;
            }
            // Animation classes
            const newAnimationStateClassNames = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))({
                [stateClasses.current.animating]: true,
                [stateClasses.current.animatingUp]: prevHeight.current === "auto" || height < prevHeight.current,
                [stateClasses.current.animatingDown]: height === "auto" || height > prevHeight.current,
                [stateClasses.current.animatingToHeightZero]: timeoutHeight === 0,
                [stateClasses.current.animatingToHeightAuto]: timeoutHeight === "auto",
                [stateClasses.current.animatingToHeightSpecific]: timeoutHeight > 0
            });
            // Animation classes to be put after animation is complete
            const timeoutAnimationStateClasses = $2ccf8bc2f657609a$var$getStaticStateClasses(stateClasses.current, timeoutHeight);
            // Set starting height and animating classes
            // When animating from 'auto' we first need to set fixed height
            // that change should be animated
            setCurrentHeight(newHeight);
            setOverflow("hidden");
            setUseTransitions(!isCurrentHeightAuto);
            setAnimationStateClassNames(newAnimationStateClassNames);
            // Clear timeouts
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
            if (isCurrentHeightAuto) {
                // When animating from 'auto' we use a short timeout to start animation
                // after setting fixed height above
                timeoutUseTransitions = true;
                // Short timeout to allow rendering of the initial animation state first
                timeoutID.current = setTimeout(()=>{
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(timeoutUseTransitions);
                    // ANIMATION STARTS, run a callback if it exists
                    onHeightAnimationStart === null || onHeightAnimationStart === void 0 || onHeightAnimationStart(timeoutHeight);
                }, 50);
                // Set static classes and remove transitions when animation ends
                animationClassesTimeoutID.current = setTimeout(()=>{
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // Hide content if height is 0 (to prevent tabbing into it)
                    $2ccf8bc2f657609a$var$hideContent(contentElement.current, timeoutHeight);
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 || onHeightAnimationEnd(timeoutHeight);
                }, totalDuration);
            } else {
                // ANIMATION STARTS, run a callback if it exists
                onHeightAnimationStart === null || onHeightAnimationStart === void 0 || onHeightAnimationStart(newHeight);
                // Set end height, classes and remove transitions when animation is complete
                timeoutID.current = setTimeout(()=>{
                    setCurrentHeight(timeoutHeight);
                    setOverflow(timeoutOverflow);
                    setUseTransitions(false);
                    setAnimationStateClassNames(timeoutAnimationStateClasses);
                    // ANIMATION ENDS
                    // If height is auto, don't hide the content
                    // (case when element is empty, therefore height is 0)
                    if (height !== "auto") // Hide content if height is 0 (to prevent tabbing into it)
                    $2ccf8bc2f657609a$var$hideContent(contentElement.current, newHeight); // TODO solve newHeight = 0
                    // Run a callback if it exists
                    onHeightAnimationEnd === null || onHeightAnimationEnd === void 0 || onHeightAnimationEnd(newHeight);
                }, totalDuration);
            }
        }
        prevHeight.current = height;
        return ()=>{
            clearTimeout(timeoutID.current);
            clearTimeout(animationClassesTimeoutID.current);
        };
    // This should be explicitly run only on height change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        height
    ]);
    // ------------------ Render
    const componentStyle = Object.assign(Object.assign({}, style), {
        height: currentHeight,
        overflow: overflow || (style === null || style === void 0 ? void 0 : style.overflow)
    });
    if (useTransitions && applyInlineTransitions) {
        componentStyle.transition = `height ${duration}ms ${easing} ${delay}ms`;
        // Include transition passed through styles
        if (style === null || style === void 0 ? void 0 : style.transition) componentStyle.transition = `${style.transition}, ${componentStyle.transition}`;
        // Add webkit vendor prefix still used by opera, blackberry...
        componentStyle.WebkitTransition = componentStyle.transition;
    }
    const contentStyle = {};
    if (animateOpacity) {
        contentStyle.transition = `opacity ${duration}ms ${easing} ${delay}ms`;
        // Add webkit vendor prefix still used by opera, blackberry...
        contentStyle.WebkitTransition = contentStyle.transition;
        if (currentHeight === 0) contentStyle.opacity = 0;
    }
    // Check if user passed aria-hidden prop
    const hasAriaHiddenProp = typeof props["aria-hidden"] !== "undefined";
    const ariaHidden = hasAriaHiddenProp ? props["aria-hidden"] : height === 0;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", Object.assign({}, props, {
        "aria-hidden": ariaHidden,
        className: `${animationStateClassNames} ${className}`,
        style: componentStyle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        className: contentClassName,
        style: contentStyle,
        ref: contentElement
    }, children));
};
var $2ccf8bc2f657609a$export$2e2bcd8739ae039 = $2ccf8bc2f657609a$var$AnimateHeight;

});

parcelRequire.register("6dWr0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3ae45ab91277c21$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a3ae45ab91277c21$var$SvgTriangleRight = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10.512 7.61a.5.5 0 0 1 0 .78l-3.7 2.96A.5.5 0 0 1 6 10.96V5.04a.5.5 0 0 1 .812-.39l3.7 2.96Z",
            fill: "currentColor"
        })
    });
var $a3ae45ab91277c21$export$2e2bcd8739ae039 = $a3ae45ab91277c21$var$SvgTriangleRight;

});

parcelRequire.register("8gTeD", function(module, exports) {

$parcel$export(module.exports, "arrow", function () { return $605aa9e4f86bc3fb$export$f2120bbfa5450bd2; }, function (v) { return $605aa9e4f86bc3fb$export$f2120bbfa5450bd2 = v; });
$parcel$export(module.exports, "container", function () { return $605aa9e4f86bc3fb$export$34e0f9847d4c02dd; }, function (v) { return $605aa9e4f86bc3fb$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "details", function () { return $605aa9e4f86bc3fb$export$41ee12f6f6f05843; }, function (v) { return $605aa9e4f86bc3fb$export$41ee12f6f6f05843 = v; });
$parcel$export(module.exports, "expanded", function () { return $605aa9e4f86bc3fb$export$52105d146316f63c; }, function (v) { return $605aa9e4f86bc3fb$export$52105d146316f63c = v; });
$parcel$export(module.exports, "summary", function () { return $605aa9e4f86bc3fb$export$9a2dbef7a17e2e58; }, function (v) { return $605aa9e4f86bc3fb$export$9a2dbef7a17e2e58 = v; });
var $605aa9e4f86bc3fb$export$f2120bbfa5450bd2;
var $605aa9e4f86bc3fb$export$34e0f9847d4c02dd;
var $605aa9e4f86bc3fb$export$41ee12f6f6f05843;
var $605aa9e4f86bc3fb$export$52105d146316f63c;
var $605aa9e4f86bc3fb$export$bfd64c937657f93a;
var $605aa9e4f86bc3fb$export$4a6dd88bada4e7d2;
var $605aa9e4f86bc3fb$export$9a2dbef7a17e2e58;
$605aa9e4f86bc3fb$export$f2120bbfa5450bd2 = `PkjlTG_arrow`;
$605aa9e4f86bc3fb$export$34e0f9847d4c02dd = `PkjlTG_container`;
$605aa9e4f86bc3fb$export$41ee12f6f6f05843 = `PkjlTG_details`;
$605aa9e4f86bc3fb$export$52105d146316f63c = `PkjlTG_expanded`;
$605aa9e4f86bc3fb$export$bfd64c937657f93a = `PkjlTG_rotating`;
$605aa9e4f86bc3fb$export$4a6dd88bada4e7d2 = `PkjlTG_shimmer`;
$605aa9e4f86bc3fb$export$9a2dbef7a17e2e58 = `PkjlTG_summary`;

});


parcelRequire.register("djktV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c089bfa79fedbf1b$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $d3H7B = parcelRequire("d3H7B");

var $2EEQD = parcelRequire("2EEQD");

var $a0Ubj = parcelRequire("a0Ubj");

var $1UQTm = parcelRequire("1UQTm");

var $93h5F = parcelRequire("93h5F");

var $lKXyD = parcelRequire("lKXyD");
function $c089bfa79fedbf1b$var$NotFound({ className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const location = (0, $9X5Bp.useLocation)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($lKXyD.container, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "errors.page_not_found",
                trackPageView: location.pathname !== "/"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $lKXyD.content,
                children: [
                    theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2EEQD.default), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3H7B.default), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $lKXyD.message,
                        children: t("errors.page_not_found")
                    })
                ]
            })
        ]
    });
}
var $c089bfa79fedbf1b$export$2e2bcd8739ae039 = $c089bfa79fedbf1b$var$NotFound;

});
parcelRequire.register("d3H7B", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $51fc3207bb126fc1$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $51fc3207bb126fc1$var$SvgNotFoundDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_274_17728",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#7964C4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.687 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.657 5.657a4 4 0 0 0 5.657 5.657l5.656-5.657 5.657 5.657a4 4 0 0 0 5.657-5.657L118.657 136l5.657-5.657a4 4 0 0 0-5.657-5.657L113 130.343l-5.656-5.657a4 4 0 0 0-5.657 0ZM149.687 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.657 5.657a4 4 0 0 0 5.657 5.657l5.656-5.657 5.657 5.657a4 4 0 0 0 5.657-5.657L166.657 136l5.657-5.657a4 4 0 0 0-5.657-5.657L161 130.343l-5.656-5.657a4 4 0 0 0-5.657 0Z",
                fill: "#8167EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 74,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 74,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 172,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 146,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 159,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask1_274_17728",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 25,
                y: 94,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M116 98.5V94H25.5v97.5H63c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask1_274_17728)",
                stroke: "#947DFF",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "m-4 94 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.028 9.028 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 94M-4 98l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.971 8.971 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.695 8.695 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.979 8.979 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 98M-4 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 102M-4 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 106M-4 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 110M-4 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 114M-4 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 118M-4 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 122M-4 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 126M-4 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 130M-4 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 134M-4 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 138M-4 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 142M-4 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 146M-4 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 150M-4 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 154M-4 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 158M-4 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 162M-4 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 166M-4 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 170M-4 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 174M-4 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 178M-4 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 182M-4 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 186M-4 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.695 8.695 0 0 0 7.86.043l.086-.044a8.915 8.915 0 0 1 7.96.007 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.922 8.922 0 0 1 7.991-.002 8.92 8.92 0 0 0 7.985 0L124 190"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 203.134,
                y: 214.277,
                width: 8,
                height: 8,
                rx: 4,
                transform: "rotate(-35.523 203.134 214.277)",
                fill: "#D194D5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167.452,
                y: 52,
                width: 24,
                height: 24,
                rx: 2,
                transform: "rotate(50.249 167.452 52)",
                fill: "#D89BDC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M205.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#636685"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M95.914 193.209c0-.116.094-.209.209-.209h3.755c.115 0 .209.093.209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.208.208 0 0 1-.209.208h-3.755a.208.208 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.209.209 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.877-3.252a.209.209 0 0 1 .285-.076l5.724 3.305v-6.609Z",
                fill: "#626685"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#6F6C83"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M194 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M74.003 47.362a.16.16 0 0 1 .177-.213l17.662 3.035a.16.16 0 0 1 .096.26l-11.46 13.778a.16.16 0 0 1-.273-.046l-6.202-16.814Z",
                fill: "#86BE89"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#839999",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M43.867 218.692a.07.07 0 0 1 .113-.04l5.913 5.025a.07.07 0 0 1-.021.118l-7.308 2.609a.07.07 0 0 1-.092-.078l1.395-7.634Z",
                fill: "#86BE89"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#4E4F75"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#4E4F75"
            })
        ]
    });
var $51fc3207bb126fc1$export$2e2bcd8739ae039 = $51fc3207bb126fc1$var$SvgNotFoundDark;

});

parcelRequire.register("2EEQD", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e6a75f055abfcb$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $c4e6a75f055abfcb$var$SvgNotFound = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 230,
        height: 230,
        viewBox: "0 0 230 230",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "error",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 0h230v230H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 52.109,
                y: 66.484,
                width: 125.781,
                height: 97.031,
                rx: 10.952,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_300_6026",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 52,
                y: 66,
                width: 126,
                height: 98,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 52.109,
                    y: 66.484,
                    width: 125.781,
                    height: 97.031,
                    rx: 10.952,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52.11 77.266c0-5.955 4.826-10.782 10.78-10.782H167.11c5.955 0 10.782 4.827 10.782 10.782v7.187H52.109v-7.187Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M91.36 112.023a3.593 3.593 0 0 0 0 5.082l5.082 5.082-5.082 5.083a3.593 3.593 0 1 0 5.082 5.082l5.083-5.082 5.082 5.082a3.594 3.594 0 0 0 5.082-5.083l-5.082-5.082 5.082-5.082a3.592 3.592 0 0 0 0-5.082 3.592 3.592 0 0 0-5.082 0l-5.082 5.082-5.083-5.082a3.593 3.593 0 0 0-5.082 0ZM134.485 112.023a3.592 3.592 0 0 0 0 5.082l5.082 5.082-5.082 5.083a3.594 3.594 0 0 0 5.082 5.082l5.083-5.082 5.082 5.082a3.594 3.594 0 0 0 5.082-5.083l-5.082-5.082 5.082-5.082a3.592 3.592 0 0 0 0-5.082 3.592 3.592 0 0 0-5.082 0l-5.082 5.082-5.083-5.082a3.592 3.592 0 0 0-5.082 0Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 69.18,
                cy: 75.469,
                r: 2.695,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 78.164,
                cy: 75.469,
                r: 2.695,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87.148,
                cy: 75.469,
                r: 2.695,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 66.484,
                y: 91.641,
                width: 57.5,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 66.484,
                y: 97.93,
                width: 12.578,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 154.531,
                y: 97.93,
                width: 8.984,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 82.656,
                y: 97.93,
                width: 66.484,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 131.172,
                y: 91.641,
                width: 8.984,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142.852,
                y: 91.641,
                width: 20.664,
                height: 3.594,
                rx: 1.797,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask1_300_6026",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 22,
                y: 84,
                width: 83,
                height: 89,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M104.219 88.496v-4.043H22.91v87.598h33.692c11.908 0 21.562-9.654 21.562-21.563v-35.937c0-7.195 5.833-13.028 13.027-13.028 7.195 0 13.028-5.832 13.028-13.027Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask1_300_6026)",
                stroke: "#947DFF",
                strokeWidth: 0.719,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M-3.594 84.453 0 86.25a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.06 8.06 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.04a8.007 8.007 0 0 1 7.15.007 8.067 8.067 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.004 8.073 8.073 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.798M-3.594 88.047 0 89.844a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.061 8.061 0 0 1 7.199.006 8.113 8.113 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.074 7.81 7.81 0 0 0 7.06.039l.079-.04a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.003 8.072 8.072 0 0 0 7.187 0 8.013 8.013 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 91.64 0 93.439a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.06 8.06 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.067 8.067 0 0 0 7.203.004 8.11 8.11 0 0 1 7.211.004 8.073 8.073 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 95.234 0 97.031a8.036 8.036 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.036 8.036 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.036 8.036 0 0 0 7.188 0 8.061 8.061 0 0 1 7.199.006 8.113 8.113 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.075 7.81 7.81 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.11 8.11 0 0 1 7.211.004 8.072 8.072 0 0 0 7.187 0 8.013 8.013 0 0 1 7.179-.002 8.01 8.01 0 0 0 7.174 0l3.59-1.797M-3.594 98.828 0 100.625a8.037 8.037 0 0 0 7.187 0 8.036 8.036 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.036 8.036 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.81 7.81 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 102.422 0 104.219a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 106.016 0 107.813a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 109.61 0 111.406a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 113.203 0 115a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 116.797 0 118.594a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 120.391 0 122.188a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 123.985 0 125.781a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 127.578 0 129.375a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 131.172 0 132.969a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 134.766 0 136.563a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 138.36 0 140.156a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 141.953 0 143.75a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 145.547 0 147.344a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 149.141 0 150.938a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 152.735 0 154.531a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 156.328 0 158.125a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 159.922 0 161.719a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.808 7.808 0 0 1 6.988.074 7.811 7.811 0 0 0 7.06.039l.079-.039a8.004 8.004 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.112 8.112 0 0 1 7.211.003 8.071 8.071 0 0 0 7.187.001 8.01 8.01 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798M-3.594 163.516 0 165.313a8.037 8.037 0 0 0 7.187 0 8.03 8.03 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.03 8.03 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.059 8.059 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.136a7.811 7.811 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.007 8.007 0 0 1 7.15.007 8.068 8.068 0 0 0 7.203.004 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187.001 8.012 8.012 0 0 1 7.179-.003 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 167.11 0 168.906a8.03 8.03 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.03 8.03 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.03 8.03 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.044l.278-.136a7.808 7.808 0 0 1 6.988.075 7.808 7.808 0 0 0 7.06.038l.079-.039a8.01 8.01 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.071 8.071 0 0 0 7.187 0 8.016 8.016 0 0 1 7.179-.002 8.008 8.008 0 0 0 7.174 0l3.59-1.797M-3.594 170.703 0 172.5a8.037 8.037 0 0 0 7.187 0 8.037 8.037 0 0 1 7.188 0 8.037 8.037 0 0 0 7.188 0 8.037 8.037 0 0 1 7.187 0 8.037 8.037 0 0 0 7.188 0 8.062 8.062 0 0 1 7.199.006 8.114 8.114 0 0 0 7.17.043l.278-.135a7.811 7.811 0 0 1 6.988.074 7.808 7.808 0 0 0 7.06.039l.079-.039a8.007 8.007 0 0 1 7.15.006 8.068 8.068 0 0 0 7.203.005 8.109 8.109 0 0 1 7.211.004 8.074 8.074 0 0 0 7.187 0 8.012 8.012 0 0 1 7.179-.002 8.015 8.015 0 0 0 7.174 0l3.59-1.798"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                transform: "rotate(-35.523 182.503 192.514)",
                fill: "#C4C4C4",
                d: "M182.503 192.514h7.188v7.188h-7.188z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                transform: "rotate(50.249 150.445 46.719)",
                fill: "#FAABFF",
                d: "M150.445 46.719h21.563v21.563h-21.563z",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M185.001 25.344c0-.104.084-.188.187-.188h3.374c.103 0 .187.084.187.188v5.938l5.143-2.97a.187.187 0 0 1 .256.069l1.687 2.922a.187.187 0 0 1-.069.256l-5.142 2.969 5.142 2.968c.089.052.12.167.068.256l-1.687 2.922a.187.187 0 0 1-.256.069l-5.142-2.97v5.938a.187.187 0 0 1-.187.188h-3.374a.187.187 0 0 1-.187-.188v-5.937l-5.142 2.969a.188.188 0 0 1-.256-.069l-1.687-2.922a.188.188 0 0 1 .069-.256l5.142-2.968-5.143-2.97a.188.188 0 0 1-.068-.255l1.687-2.922a.187.187 0 0 1 .256-.069l5.142 2.97v-5.938Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M86.173 173.586c0-.104.084-.188.187-.188h3.374c.103 0 .187.084.187.188v5.938l5.143-2.969a.188.188 0 0 1 .256.068l1.687 2.922a.187.187 0 0 1-.069.256l-5.142 2.969 5.141 2.969c.09.051.12.166.07.256l-1.688 2.921a.187.187 0 0 1-.256.069l-5.142-2.969v5.938a.187.187 0 0 1-.187.187H86.36a.187.187 0 0 1-.187-.187v-5.938l-5.142 2.969a.187.187 0 0 1-.256-.069l-1.687-2.921a.187.187 0 0 1 .069-.256l5.142-2.969-5.143-2.969a.187.187 0 0 1-.068-.256l1.687-2.922a.188.188 0 0 1 .255-.068l5.143 2.968v-5.937Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28.75 47.617a7.188 7.188 0 1 0 0-14.375 7.188 7.188 0 0 0 0 14.375Zm0-3.594a3.594 3.594 0 1 0 0-7.187 3.594 3.594 0 0 0 0 7.187Z",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M174.297 170.703c5.954 0 10.781-4.827 10.781-10.781 0-5.954-4.827-10.781-10.781-10.781-5.954 0-10.781 4.827-10.781 10.781 0 5.954 4.827 10.781 10.781 10.781Zm0-5.391a5.39 5.39 0 1 0 0-10.781 5.39 5.39 0 0 0 0 10.781Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M66.487 42.552a.144.144 0 0 1 .16-.191l15.867 2.727a.144.144 0 0 1 .087.233L72.305 57.7a.144.144 0 0 1-.246-.042l-5.572-15.106Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#F7F8F8",
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m105.853 53.498 1.893-3.598a4.066 4.066 0 0 0-1.703-5.492v0a4.066 4.066 0 0 1-1.704-5.491v0a4.066 4.066 0 0 0-1.704-5.492v0a4.066 4.066 0 0 1-1.704-5.492l1.894-3.598",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 2.875,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M39.411 196.482a.063.063 0 0 1 .102-.037l5.313 4.515a.062.062 0 0 1-.02.106l-6.566 2.344a.062.062 0 0 1-.082-.07l1.253-6.858Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 67.383,
                y: 197.656,
                width: 71.875,
                height: 3.594,
                rx: 1.797,
                fill: "#747778"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 150.039,
                y: 197.656,
                width: 17.07,
                height: 3.594,
                rx: 1.797,
                fill: "#747778"
            })
        ]
    });
var $c4e6a75f055abfcb$export$2e2bcd8739ae039 = $c4e6a75f055abfcb$var$SvgNotFound;

});

parcelRequire.register("a0Ubj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6c07428cd07ac25f$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $dnZfV = parcelRequire("dnZfV");

var $eCoWV = parcelRequire("eCoWV");

var $a7rB2 = parcelRequire("a7rB2");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
function $6c07428cd07ac25f$var$PageMeta({ titleKey: titleKey, trackPageView: trackPageView = true }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isSetupFinished: isSetupFinished, appInsights: appInsights } = (0, $eCoWV.useContext)((0, $dnZfV.AppInsightsContext));
    const [pageViewTracked, setPageViewTracked] = (0, $eCoWV.useState)(false);
    const keys = typeof titleKey === "string" ? [
        titleKey
    ] : titleKey;
    const rawTitle = keys.map((key)=>t(key, {
            lng: "en"
        })).join(" - ");
    const title = keys.map((key)=>t(key)).join(" - ");
    (0, $eCoWV.useEffect)(()=>{
        // Only track once for the same page
        if (isSetupFinished && trackPageView && !pageViewTracked) {
            appInsights.trackPageView?.({
                name: `Console: ${rawTitle}`
            });
            setPageViewTracked(true);
        }
    }, [
        appInsights,
        isSetupFinished,
        pageViewTracked,
        rawTitle,
        trackPageView
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a7rB2.Helmet), {
        title: title
    });
}
var $6c07428cd07ac25f$export$2e2bcd8739ae039 = $6c07428cd07ac25f$var$PageMeta;

});
parcelRequire.register("jZDWq", function(module, exports) {
$parcel$export(module.exports, "AppInsightsContext", function () { return (parcelRequire("dnZfV")).AppInsightsContext; });

$parcel$export(module.exports, "withAppInsights", function () { return (parcelRequire("gvHPO")).withAppInsights; });
$parcel$export(module.exports, "AppInsightsBoundary", function () { return (parcelRequire("ek0ZU")).default; });
$parcel$export(module.exports, "TrackOnce", function () { return (parcelRequire("iuOAe")).default; });

var $gvHPO = parcelRequire("gvHPO");
parcelRequire("dnZfV");
parcelRequire("bIAwo");

var $ek0ZU = parcelRequire("ek0ZU");

var $iuOAe = parcelRequire("iuOAe");

});
parcelRequire.register("gvHPO", function(module, exports) {

$parcel$export(module.exports, "appInsightsReact", function () { return $c0518b3bce51218b$export$97a4640d2ef590c2; });
$parcel$export(module.exports, "withAppInsights", function () { return $c0518b3bce51218b$export$e0392879325cfa36; });
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");



class $c0518b3bce51218b$export$538b9cc6200b0efa {
    constructor(){
        /**
         * URL search parameters that start with `utm_`. It is an empty object until you call `.setup()`,
         * which will read the URL search string and store parameters in this property.
         */ this.utmParameters = {};
    }
    get instance() {
        return this.appInsights;
    }
    get trackPageView() {
        return this.appInsights?.trackPageView.bind(this.appInsights);
    }
    async setup(cloudRole, config) {
        const connectionStringFromConfig = typeof config === "string" ? config : config?.connectionString;
        // The string needs to be normalized since it may contain '"'
        const connectionString = (connectionStringFromConfig ?? "")?.replace(/^"?(.*)"?$/g, "$1");
        if (!connectionString) return false;
        if (this.appInsights?.config.connectionString === connectionString) return true;
        try {
            // Lazy load ApplicationInsights modules
            const { ReactPlugin: ReactPlugin, withAITracking: withAITracking } = await (parcelRequire("3p6UC"));
            const { ApplicationInsights: ApplicationInsights } = await (parcelRequire("8Uxne"));
            // Conditionally load ClickAnalytics plugin
            const configObject = (0, $5CQIb.conditional)(typeof config === "object" && config) ?? {};
            const { cookieDomain: cookieDomain, clickPlugin: clickPlugin } = configObject;
            const initClickAnalyticsPlugin = async ()=>{
                const { ClickAnalyticsPlugin: ClickAnalyticsPlugin } = await (parcelRequire("lkbZ6"));
                return new ClickAnalyticsPlugin();
            };
            // Assign React props
            // https://github.com/microsoft/applicationinsights-react-js#readme
            this.withAITracking = withAITracking;
            this.reactPlugin = new ReactPlugin();
            // Assign ClickAnalytics prop
            this.clickAnalyticsPlugin = (0, $5CQIb.conditional)(clickPlugin && await initClickAnalyticsPlugin());
            // Init ApplicationInsights instance
            this.appInsights = new ApplicationInsights({
                config: {
                    cookieDomain: cookieDomain,
                    connectionString: connectionString,
                    enableAutoRouteTracking: false,
                    extensions: (0, $5CQIb.conditionalArray)(this.reactPlugin, this.clickAnalyticsPlugin),
                    extensionConfig: (0, $5CQIb.conditional)(this.clickAnalyticsPlugin && {
                        [this.clickAnalyticsPlugin.identifier]: clickPlugin
                    })
                }
            });
            // Extract UTM parameters
            const searchParams = [
                ...new URLSearchParams(window.location.search).entries()
            ];
            this.utmParameters = Object.fromEntries(searchParams.filter(([key])=>key.startsWith("utm_")));
            this.appInsights.addTelemetryInitializer((item)=>{
                // @see https://github.com/microsoft/ApplicationInsights-JS#example-setting-cloud-role-name
                // @see https://github.com/microsoft/ApplicationInsights-node.js/blob/a573e40fc66981c6a3106bdc5b783d1d94f64231/Schema/PublicSchema/ContextTagKeys.bond#L83
                /* eslint-disable @silverhand/fp/no-mutation */ item.tags = [
                    ...item.tags ?? [],
                    {
                        "ai.cloud.role": cloudRole
                    }
                ];
            /* eslint-enable @silverhand/fp/no-mutation */ });
            this.appInsights.loadAppInsights();
        } catch (error) {
            console.error("Unable to init ApplicationInsights:");
            console.error(error);
            return false;
        }
        return true;
    }
    withAppInsights(Component) {
        if (!this.reactPlugin || !this.withAITracking) return Component;
        return this.withAITracking(this.reactPlugin, Component, undefined, "appInsightsWrapper");
    }
}
const $c0518b3bce51218b$export$97a4640d2ef590c2 = new $c0518b3bce51218b$export$538b9cc6200b0efa();
const $c0518b3bce51218b$export$e0392879325cfa36 = $c0518b3bce51218b$export$97a4640d2ef590c2.withAppInsights.bind($c0518b3bce51218b$export$97a4640d2ef590c2);

});

parcelRequire.register("dnZfV", function(module, exports) {

$parcel$export(module.exports, "AppInsightsContext", function () { return $9becf08053f14eb3$export$c17a2d427d600cd; });
$parcel$export(module.exports, "AppInsightsProvider", function () { return $9becf08053f14eb3$export$41d5ed2e6aeb716a; });

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $gvHPO = parcelRequire("gvHPO");
const $9becf08053f14eb3$var$notImplemented = ()=>{
    throw new Error("Not implemented");
};
const $9becf08053f14eb3$export$c17a2d427d600cd = /*#__PURE__*/ (0, $eCoWV.createContext)({
    needsSetup: true,
    isSetupFinished: false,
    setup: $9becf08053f14eb3$var$notImplemented,
    appInsights: $gvHPO.appInsightsReact
});
const $9becf08053f14eb3$export$41d5ed2e6aeb716a = ({ children: children })=>{
    const [setupStatus, setSetupStatus] = (0, $eCoWV.useState)("none");
    const setup = (0, $eCoWV.useCallback)(async (...args)=>{
        if (setupStatus !== "none") return;
        setSetupStatus("loading");
        const result = await (0, $gvHPO.appInsightsReact).setup(...args);
        if (result) {
            console.debug("Initialized ApplicationInsights");
            setSetupStatus("initialized");
        } else setSetupStatus("failed");
    }, [
        setupStatus
    ]);
    const context = (0, $eCoWV.useMemo)(()=>({
            needsSetup: setupStatus === "none",
            isSetupFinished: setupStatus === "initialized" || setupStatus === "failed",
            setup: setup,
            appInsights: $gvHPO.appInsightsReact
        }), [
        setup,
        setupStatus
    ]);
    return (0, $9zeGj.jsx)($9becf08053f14eb3$export$c17a2d427d600cd.Provider, {
        value: context,
        children: children
    });
};

});

parcelRequire.register("bIAwo", function(module, exports) {

$parcel$export(module.exports, "getPrimaryDomain", function () { return $8880222608a22afd$export$6006c55f71b07ab6; });
/**
 * **CAUTION:** This function takes the last two parts of the hostname which may cause issues for
 * some second-level domains, e.g. `.co.uk`.
 */ const $8880222608a22afd$export$6006c55f71b07ab6 = ()=>window.location.hostname.split(".").slice(-2).join(".");

});

parcelRequire.register("ek0ZU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a6d3b503e141902a$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $dnZfV = parcelRequire("dnZfV");

var $bIAwo = parcelRequire("bIAwo");
const $a6d3b503e141902a$var$AppInsights = ({ cloudRole: cloudRole })=>{
    const { needsSetup: needsSetup, setup: setup } = (0, $eCoWV.useContext)((0, $dnZfV.AppInsightsContext));
    (0, $eCoWV.useEffect)(()=>{
        const run = async ()=>{
            await setup(cloudRole, {
                cookieDomain: (0, $bIAwo.getPrimaryDomain)()
            });
        };
        if (needsSetup) run();
    }, [
        cloudRole,
        needsSetup,
        setup
    ]);
    return null;
};
/**
 * **CAUTION:** Make sure to put this component inside `<LogtoProvider />` or any other
 * context providers that are render-sensitive, since we are lazy loading ApplicationInsights SDKs
 * for better user experience.
 *
 * This component will trigger a render after the ApplicationInsights SDK is loaded which may
 * cause issues for some context providers. For example, `useHandleSignInCallback` will be
 * called twice if you use this component to wrap a `<LogtoProvider />`.
 */ const $a6d3b503e141902a$var$AppInsightsBoundary = ({ children: children, ...rest })=>{
    return (0, $9zeGj.jsxs)((0, $dnZfV.AppInsightsProvider), {
        children: [
            (0, $9zeGj.jsx)($a6d3b503e141902a$var$AppInsights, {
                ...rest
            }),
            children
        ]
    });
};
var $a6d3b503e141902a$export$2e2bcd8739ae039 = $a6d3b503e141902a$var$AppInsightsBoundary;

});

parcelRequire.register("iuOAe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d77244215b458a49$export$2e2bcd8739ae039; });
parcelRequire("bGN6i");
var $vZyB0 = parcelRequire("vZyB0");

var $eCoWV = parcelRequire("eCoWV");

var $dusqy = parcelRequire("dusqy");

var $dnZfV = parcelRequire("dnZfV");
const $d77244215b458a49$var$storageKeyPrefix = "logto:insights:";
/** Track an event after AppInsights SDK is setup, but only once during the current session.  */ const $d77244215b458a49$var$TrackOnce = ({ component: component, event: event, customProperties: customProperties })=>{
    const { isSetupFinished: isSetupFinished, appInsights: appInsights } = (0, $eCoWV.useContext)((0, $dnZfV.AppInsightsContext));
    (0, $eCoWV.useEffect)(()=>{
        const eventName = (0, $dusqy.getEventName)(component, event);
        const storageKey = `${$d77244215b458a49$var$storageKeyPrefix}${eventName}`;
        const tracked = (0, $vZyB0.yes)(sessionStorage.getItem(storageKey));
        if (isSetupFinished && !tracked) {
            appInsights.instance?.trackEvent({
                name: (0, $dusqy.getEventName)(component, event)
            }, {
                ...appInsights.utmParameters,
                ...customProperties
            });
            sessionStorage.setItem(storageKey, "1");
        }
    }, [
        appInsights.instance,
        appInsights.utmParameters,
        component,
        customProperties,
        event,
        isSetupFinished
    ]);
    return null;
};
var $d77244215b458a49$export$2e2bcd8739ae039 = $d77244215b458a49$var$TrackOnce;

});
parcelRequire.register("dusqy", function(module, exports) {

$parcel$export(module.exports, "Component", function () { return $9d2420c2835bca34$export$16fa2f45be04daa8; });
$parcel$export(module.exports, "GeneralEvent", function () { return $9d2420c2835bca34$export$b8cbc268a2e6b94; });
$parcel$export(module.exports, "ConsoleEvent", function () { return $9d2420c2835bca34$export$25b0c984d112f523; });
$parcel$export(module.exports, "getEventName", function () { return $9d2420c2835bca34$export$a13decb7c9026980; });
/** The app (either frontend or backend) for a bunch of events. */ var $9d2420c2835bca34$export$16fa2f45be04daa8;
(function(Component) {
    /** Logto core service. */ Component["Core"] = "core";
    /** Logto Console. */ Component["Console"] = "console";
    /** Logto blog. */ Component["Blog"] = "blog";
    /** Logto official website. */ Component["Website"] = "website";
})($9d2420c2835bca34$export$16fa2f45be04daa8 || ($9d2420c2835bca34$export$16fa2f45be04daa8 = {}));
var $9d2420c2835bca34$export$b8cbc268a2e6b94;
(function(GeneralEvent) {
    /** A user visited the current app, it should be recorded once per session. */ GeneralEvent["Visit"] = "visit";
})($9d2420c2835bca34$export$b8cbc268a2e6b94 || ($9d2420c2835bca34$export$b8cbc268a2e6b94 = {}));
var $9d2420c2835bca34$export$989616d0f60dd871;
(function(CoreEvent) {
    /** An existing user signed in via an interaction. */ CoreEvent["SignIn"] = "sign_in";
    /** A new user has created in an interaction. */ CoreEvent["Register"] = "register";
})($9d2420c2835bca34$export$989616d0f60dd871 || ($9d2420c2835bca34$export$989616d0f60dd871 = {}));
var $9d2420c2835bca34$export$25b0c984d112f523;
(function(ConsoleEvent) {
    /** A user started the onboarding process. */ ConsoleEvent["Onboard"] = "onboard";
})($9d2420c2835bca34$export$25b0c984d112f523 || ($9d2420c2835bca34$export$25b0c984d112f523 = {}));
var $9d2420c2835bca34$export$3a08a98571ac8e3e;
(function(BlogEvent) {
    /** A user viewed a blog post. */ BlogEvent["ViewPost"] = "view_post";
})($9d2420c2835bca34$export$3a08a98571ac8e3e || ($9d2420c2835bca34$export$3a08a98571ac8e3e = {}));
const $9d2420c2835bca34$export$70fb2d88ab3fc3a6 = Object.freeze({
    [$9d2420c2835bca34$export$16fa2f45be04daa8.Core]: $9d2420c2835bca34$export$989616d0f60dd871,
    [$9d2420c2835bca34$export$16fa2f45be04daa8.Console]: {
        ...$9d2420c2835bca34$export$25b0c984d112f523,
        ...$9d2420c2835bca34$export$b8cbc268a2e6b94
    },
    [$9d2420c2835bca34$export$16fa2f45be04daa8.Blog]: {
        ...$9d2420c2835bca34$export$3a08a98571ac8e3e,
        ...$9d2420c2835bca34$export$b8cbc268a2e6b94
    },
    [$9d2420c2835bca34$export$16fa2f45be04daa8.Website]: $9d2420c2835bca34$export$b8cbc268a2e6b94
});
function $9d2420c2835bca34$export$a13decb7c9026980(component, event, data) {
    return [
        component,
        event,
        data
    ].filter(Boolean).join("/");
}

});



parcelRequire.register("a7rB2", function(module, exports) {

$parcel$export(module.exports, "Helmet", function () { return $75dff6e231aa6411$export$dcef8f9bb9a41431; });

var $hqomP = parcelRequire("hqomP");

var $63abK = parcelRequire("63abK");

var $9nZWq = parcelRequire("9nZWq");

var $eCoWV = parcelRequire("eCoWV");

var $ikiL7 = parcelRequire("ikiL7");
var $75dff6e231aa6411$var$ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};
var $75dff6e231aa6411$var$TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};
var $75dff6e231aa6411$var$VALID_TAG_NAMES = Object.keys($75dff6e231aa6411$var$TAG_NAMES).map(function(name) {
    return $75dff6e231aa6411$var$TAG_NAMES[name];
});
var $75dff6e231aa6411$var$TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};
var $75dff6e231aa6411$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $75dff6e231aa6411$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};
var $75dff6e231aa6411$var$HTML_TAG_MAP = Object.keys($75dff6e231aa6411$var$REACT_TAG_MAP).reduce(function(obj, key) {
    obj[$75dff6e231aa6411$var$REACT_TAG_MAP[key]] = key;
    return obj;
}, {});
var $75dff6e231aa6411$var$SELF_CLOSING_TAGS = [
    $75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT,
    $75dff6e231aa6411$var$TAG_NAMES.SCRIPT,
    $75dff6e231aa6411$var$TAG_NAMES.STYLE
];
var $75dff6e231aa6411$var$HELMET_ATTRIBUTE = "data-react-helmet";
var $75dff6e231aa6411$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $75dff6e231aa6411$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $75dff6e231aa6411$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $75dff6e231aa6411$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $75dff6e231aa6411$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $75dff6e231aa6411$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $75dff6e231aa6411$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $75dff6e231aa6411$var$encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $75dff6e231aa6411$var$getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$TAG_NAMES.TITLE);
    var innermostTemplate = $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (innermostTemplate && innermostTitle) // use function arg to avoid need to escape $ characters
    return innermostTemplate.replace(/%s/g, function() {
        return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
    });
    var innermostDefaultTitle = $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || undefined;
};
var $75dff6e231aa6411$var$getOnChangeClientState = function getOnChangeClientState(propsList) {
    return $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function() {};
};
var $75dff6e231aa6411$var$getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function(props) {
        return typeof props[tagType] !== "undefined";
    }).map(function(props) {
        return props[tagType];
    }).reduce(function(tagAttrs, current) {
        return $75dff6e231aa6411$var$_extends({}, tagAttrs, current);
    }, {});
};
var $75dff6e231aa6411$var$getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function(props) {
        return typeof props[$75dff6e231aa6411$var$TAG_NAMES.BASE] !== "undefined";
    }).map(function(props) {
        return props[$75dff6e231aa6411$var$TAG_NAMES.BASE];
    }).reverse().reduce(function(innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
};
var $75dff6e231aa6411$var$getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};
    return propsList.filter(function(props) {
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $75dff6e231aa6411$var$warn("Helmet: " + tagName + ' should be of type "Array". Instead found type "' + $75dff6e231aa6411$var$_typeof(props[tagName]) + '"');
        return false;
    }).map(function(props) {
        return props[tagName];
    }).reverse().reduce(function(approvedTags, instanceTags) {
        var instanceSeenTags = {};
        instanceTags.filter(function(tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for(var i = 0; i < keys.length; i++){
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();
                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === $75dff6e231aa6411$var$TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === $75dff6e231aa6411$var$TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML || attributeKey === $75dff6e231aa6411$var$TAG_PROPERTIES.CSS_TEXT || attributeKey === $75dff6e231aa6411$var$TAG_PROPERTIES.ITEM_PROP)) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            var value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach(function(tag) {
            return approvedTags.push(tag);
        });
        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for(var i = 0; i < keys.length; i++){
            var attributeKey = keys[i];
            var tagUnion = (0, (/*@__PURE__*/$parcel$interopDefault($ikiL7)))({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $75dff6e231aa6411$var$getInnermostProperty = function getInnermostProperty(propsList, property) {
    for(var i = propsList.length - 1; i >= 0; i--){
        var props = propsList[i];
        if (props.hasOwnProperty(property)) return props[property];
    }
    return null;
};
var $75dff6e231aa6411$var$reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: $75dff6e231aa6411$var$getBaseTagFromPropsList([
            $75dff6e231aa6411$var$TAG_PROPERTIES.HREF,
            $75dff6e231aa6411$var$TAG_PROPERTIES.TARGET
        ], propsList),
        bodyAttributes: $75dff6e231aa6411$var$getAttributesFromPropsList($75dff6e231aa6411$var$ATTRIBUTE_NAMES.BODY, propsList),
        defer: $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$HELMET_PROPS.DEFER),
        encode: $75dff6e231aa6411$var$getInnermostProperty(propsList, $75dff6e231aa6411$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $75dff6e231aa6411$var$getAttributesFromPropsList($75dff6e231aa6411$var$ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: $75dff6e231aa6411$var$getTagsFromPropsList($75dff6e231aa6411$var$TAG_NAMES.LINK, [
            $75dff6e231aa6411$var$TAG_PROPERTIES.REL,
            $75dff6e231aa6411$var$TAG_PROPERTIES.HREF
        ], propsList),
        metaTags: $75dff6e231aa6411$var$getTagsFromPropsList($75dff6e231aa6411$var$TAG_NAMES.META, [
            $75dff6e231aa6411$var$TAG_PROPERTIES.NAME,
            $75dff6e231aa6411$var$TAG_PROPERTIES.CHARSET,
            $75dff6e231aa6411$var$TAG_PROPERTIES.HTTPEQUIV,
            $75dff6e231aa6411$var$TAG_PROPERTIES.PROPERTY,
            $75dff6e231aa6411$var$TAG_PROPERTIES.ITEM_PROP
        ], propsList),
        noscriptTags: $75dff6e231aa6411$var$getTagsFromPropsList($75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT, [
            $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        onChangeClientState: $75dff6e231aa6411$var$getOnChangeClientState(propsList),
        scriptTags: $75dff6e231aa6411$var$getTagsFromPropsList($75dff6e231aa6411$var$TAG_NAMES.SCRIPT, [
            $75dff6e231aa6411$var$TAG_PROPERTIES.SRC,
            $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML
        ], propsList),
        styleTags: $75dff6e231aa6411$var$getTagsFromPropsList($75dff6e231aa6411$var$TAG_NAMES.STYLE, [
            $75dff6e231aa6411$var$TAG_PROPERTIES.CSS_TEXT
        ], propsList),
        title: $75dff6e231aa6411$var$getTitleFromPropsList(propsList),
        titleAttributes: $75dff6e231aa6411$var$getAttributesFromPropsList($75dff6e231aa6411$var$ATTRIBUTE_NAMES.TITLE, propsList)
    };
};
var $75dff6e231aa6411$var$rafPolyfill = function() {
    var clock = Date.now();
    return function(callback) {
        var currentTime = Date.now();
        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else setTimeout(function() {
            $75dff6e231aa6411$var$rafPolyfill(callback);
        }, 0);
    };
}();
var $75dff6e231aa6411$var$cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};
var $75dff6e231aa6411$var$requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || $75dff6e231aa6411$var$rafPolyfill : $parcel$global.requestAnimationFrame || $75dff6e231aa6411$var$rafPolyfill;
var $75dff6e231aa6411$var$cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || $75dff6e231aa6411$var$cafPolyfill : $parcel$global.cancelAnimationFrame || $75dff6e231aa6411$var$cafPolyfill;
var $75dff6e231aa6411$var$warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};
var $75dff6e231aa6411$var$_helmetCallback = null;
var $75dff6e231aa6411$var$handleClientStateChange = function handleClientStateChange(newState) {
    if ($75dff6e231aa6411$var$_helmetCallback) $75dff6e231aa6411$var$cancelAnimationFrame($75dff6e231aa6411$var$_helmetCallback);
    if (newState.defer) $75dff6e231aa6411$var$_helmetCallback = $75dff6e231aa6411$var$requestAnimationFrame(function() {
        $75dff6e231aa6411$var$commitTagChanges(newState, function() {
            $75dff6e231aa6411$var$_helmetCallback = null;
        });
    });
    else {
        $75dff6e231aa6411$var$commitTagChanges(newState);
        $75dff6e231aa6411$var$_helmetCallback = null;
    }
};
var $75dff6e231aa6411$var$commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag, bodyAttributes = newState.bodyAttributes, htmlAttributes = newState.htmlAttributes, linkTags = newState.linkTags, metaTags = newState.metaTags, noscriptTags = newState.noscriptTags, onChangeClientState = newState.onChangeClientState, scriptTags = newState.scriptTags, styleTags = newState.styleTags, title = newState.title, titleAttributes = newState.titleAttributes;
    $75dff6e231aa6411$var$updateAttributes($75dff6e231aa6411$var$TAG_NAMES.BODY, bodyAttributes);
    $75dff6e231aa6411$var$updateAttributes($75dff6e231aa6411$var$TAG_NAMES.HTML, htmlAttributes);
    $75dff6e231aa6411$var$updateTitle(title, titleAttributes);
    var tagUpdates = {
        baseTag: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.BASE, baseTag),
        linkTags: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.LINK, linkTags),
        metaTags: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.META, metaTags),
        noscriptTags: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.SCRIPT, scriptTags),
        styleTags: $75dff6e231aa6411$var$updateTags($75dff6e231aa6411$var$TAG_NAMES.STYLE, styleTags)
    };
    var addedTags = {};
    var removedTags = {};
    Object.keys(tagUpdates).forEach(function(tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType], newTags = _tagUpdates$tagType.newTags, oldTags = _tagUpdates$tagType.oldTags;
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    cb && cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $75dff6e231aa6411$var$flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};
var $75dff6e231aa6411$var$updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) document.title = $75dff6e231aa6411$var$flattenArray(title);
    $75dff6e231aa6411$var$updateAttributes($75dff6e231aa6411$var$TAG_NAMES.TITLE, attributes);
};
var $75dff6e231aa6411$var$updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    var helmetAttributeString = elementTag.getAttribute($75dff6e231aa6411$var$HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);
    for(var i = 0; i < attributeKeys.length; i++){
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(var _i = attributesToRemove.length - 1; _i >= 0; _i--)elementTag.removeAttribute(attributesToRemove[_i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($75dff6e231aa6411$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($75dff6e231aa6411$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($75dff6e231aa6411$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $75dff6e231aa6411$var$updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector($75dff6e231aa6411$var$TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + $75dff6e231aa6411$var$HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;
    if (tags && tags.length) tags.forEach(function(tag) {
        var newElement = document.createElement(type);
        for(var attribute in tag)if (tag.hasOwnProperty(attribute)) {
            if (attribute === $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML) newElement.innerHTML = tag.innerHTML;
            else if (attribute === $75dff6e231aa6411$var$TAG_PROPERTIES.CSS_TEXT) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($75dff6e231aa6411$var$HELMET_ATTRIBUTE, "true");
        // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
        if (oldTags.some(function(existingTag, index) {
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach(function(tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function(tag) {
        return headElement.appendChild(tag);
    });
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $75dff6e231aa6411$var$generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function(str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + '="' + attributes[key] + '"' : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};
var $75dff6e231aa6411$var$generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = $75dff6e231aa6411$var$generateElementAttributesAsString(attributes);
    var flattenedTitle = $75dff6e231aa6411$var$flattenArray(title);
    return attributeString ? "<" + type + " " + $75dff6e231aa6411$var$HELMET_ATTRIBUTE + '="true" ' + attributeString + ">" + $75dff6e231aa6411$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + $75dff6e231aa6411$var$HELMET_ATTRIBUTE + '="true">' + $75dff6e231aa6411$var$encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};
var $75dff6e231aa6411$var$generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function(str, tag) {
        var attributeHtml = Object.keys(tag).filter(function(attribute) {
            return !(attribute === $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML || attribute === $75dff6e231aa6411$var$TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function(string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + '="' + $75dff6e231aa6411$var$encodeSpecialCharacters(tag[attribute], encode) + '"';
            return string ? string + " " + attr : attr;
        }, "");
        var tagContent = tag.innerHTML || tag.cssText || "";
        var isSelfClosing = $75dff6e231aa6411$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return str + "<" + type + " " + $75dff6e231aa6411$var$HELMET_ATTRIBUTE + '="true" ' + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};
var $75dff6e231aa6411$var$convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(attributes).reduce(function(obj, key) {
        obj[$75dff6e231aa6411$var$REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};
var $75dff6e231aa6411$var$convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.keys(props).reduce(function(obj, key) {
        obj[$75dff6e231aa6411$var$HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};
var $75dff6e231aa6411$var$generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;
    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[$75dff6e231aa6411$var$HELMET_ATTRIBUTE] = true, _initProps);
    var props = $75dff6e231aa6411$var$convertElementAttributestoReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($75dff6e231aa6411$var$TAG_NAMES.TITLE, props, title)
    ];
};
var $75dff6e231aa6411$var$generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function(tag, i) {
        var _mappedTag;
        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[$75dff6e231aa6411$var$HELMET_ATTRIBUTE] = true, _mappedTag);
        Object.keys(tag).forEach(function(attribute) {
            var mappedAttribute = $75dff6e231aa6411$var$REACT_TAG_MAP[attribute] || attribute;
            if (mappedAttribute === $75dff6e231aa6411$var$TAG_PROPERTIES.INNER_HTML || mappedAttribute === $75dff6e231aa6411$var$TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(type, mappedTag);
    });
};
var $75dff6e231aa6411$var$getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch(type){
        case $75dff6e231aa6411$var$TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return $75dff6e231aa6411$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return $75dff6e231aa6411$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case $75dff6e231aa6411$var$ATTRIBUTE_NAMES.BODY:
        case $75dff6e231aa6411$var$ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return $75dff6e231aa6411$var$convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return $75dff6e231aa6411$var$generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return $75dff6e231aa6411$var$generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return $75dff6e231aa6411$var$generateTagsAsString(type, tags, encode);
                }
            };
    }
};
var $75dff6e231aa6411$var$mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag, bodyAttributes = _ref.bodyAttributes, encode = _ref.encode, htmlAttributes = _ref.htmlAttributes, linkTags = _ref.linkTags, metaTags = _ref.metaTags, noscriptTags = _ref.noscriptTags, scriptTags = _ref.scriptTags, styleTags = _ref.styleTags, _ref$title = _ref.title, title = _ref$title === undefined ? "" : _ref$title, titleAttributes = _ref.titleAttributes;
    return {
        base: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.LINK, linkTags, encode),
        meta: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.META, metaTags, encode),
        noscript: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.SCRIPT, scriptTags, encode),
        style: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.STYLE, styleTags, encode),
        title: $75dff6e231aa6411$var$getMethodsForTag($75dff6e231aa6411$var$TAG_NAMES.TITLE, {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $75dff6e231aa6411$var$Helmet = function Helmet(Component) {
    var _class, _temp;
    return _temp = _class = function(_React$Component) {
        $75dff6e231aa6411$var$inherits(HelmetWrapper, _React$Component);
        function HelmetWrapper() {
            $75dff6e231aa6411$var$classCallCheck(this, HelmetWrapper);
            return $75dff6e231aa6411$var$possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }
        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, (/*@__PURE__*/$parcel$interopDefault($9nZWq)))(this.props, nextProps);
        };
        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) return null;
            switch(child.type){
                case $75dff6e231aa6411$var$TAG_NAMES.SCRIPT:
                case $75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };
                case $75dff6e231aa6411$var$TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }
            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };
        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;
            var child = _ref.child, arrayTypeChildren = _ref.arrayTypeChildren, newChildProps = _ref.newChildProps, nestedChildren = _ref.nestedChildren;
            return $75dff6e231aa6411$var$_extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [
                $75dff6e231aa6411$var$_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))
            ]), _babelHelpers$extends));
        };
        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;
            var child = _ref2.child, newProps = _ref2.newProps, newChildProps = _ref2.newChildProps, nestedChildren = _ref2.nestedChildren;
            switch(child.type){
                case $75dff6e231aa6411$var$TAG_NAMES.TITLE:
                    return $75dff6e231aa6411$var$_extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = $75dff6e231aa6411$var$_extends({}, newChildProps), _babelHelpers$extends2));
                case $75dff6e231aa6411$var$TAG_NAMES.BODY:
                    return $75dff6e231aa6411$var$_extends({}, newProps, {
                        bodyAttributes: $75dff6e231aa6411$var$_extends({}, newChildProps)
                    });
                case $75dff6e231aa6411$var$TAG_NAMES.HTML:
                    return $75dff6e231aa6411$var$_extends({}, newProps, {
                        htmlAttributes: $75dff6e231aa6411$var$_extends({}, newChildProps)
                    });
            }
            return $75dff6e231aa6411$var$_extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = $75dff6e231aa6411$var$_extends({}, newChildProps), _babelHelpers$extends3));
        };
        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = $75dff6e231aa6411$var$_extends({}, newProps);
            Object.keys(arrayTypeChildren).forEach(function(arrayChildName) {
                var _babelHelpers$extends4;
                newFlattenedProps = $75dff6e231aa6411$var$_extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });
            return newFlattenedProps;
        };
        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            return true;
        };
        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;
            var arrayTypeChildren = {};
            (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Children.forEach(children, function(child) {
                if (!child || !child.props) return;
                var _child$props = child.props, nestedChildren = _child$props.children, childProps = $75dff6e231aa6411$var$objectWithoutProperties(_child$props, [
                    "children"
                ]);
                var newChildProps = $75dff6e231aa6411$var$convertReactPropstoHtmlAttributes(childProps);
                _this2.warnOnInvalidChildren(child, nestedChildren);
                switch(child.type){
                    case $75dff6e231aa6411$var$TAG_NAMES.LINK:
                    case $75dff6e231aa6411$var$TAG_NAMES.META:
                    case $75dff6e231aa6411$var$TAG_NAMES.NOSCRIPT:
                    case $75dff6e231aa6411$var$TAG_NAMES.SCRIPT:
                    case $75dff6e231aa6411$var$TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });
            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };
        HelmetWrapper.prototype.render = function render() {
            var _props = this.props, children = _props.children, props = $75dff6e231aa6411$var$objectWithoutProperties(_props, [
                "children"
            ]);
            var newProps = $75dff6e231aa6411$var$_extends({}, props);
            if (children) newProps = this.mapChildrenToProps(children, newProps);
            return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Component, newProps);
        };
        $75dff6e231aa6411$var$createClass(HelmetWrapper, null, [
            {
                key: "canUseDOM",
                // Component.peek comes from react-side-effect:
                // For testing, you may use a static peek() method available on the returned component.
                // It lets you get the current state without resetting the mounted instance stack.
                // Don’t use it for anything other than testing.
                /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */ set: function set$$1(canUseDOM) {
                    Component.canUseDOM = canUseDOM;
                }
            }
        ]);
        return HelmetWrapper;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Component), _class.propTypes = {
        base: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        bodyAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).node),
            (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).node
        ]),
        defaultTitle: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        defer: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
        encodeSpecialCharacters: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
        htmlAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        link: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object),
        meta: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object),
        noscript: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object),
        onChangeClientState: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
        script: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object),
        style: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object),
        title: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        titleAttributes: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        titleTemplate: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function() {
        var mappedState = Component.rewind();
        if (!mappedState) // provide fallback if mappedState is undefined
        mappedState = $75dff6e231aa6411$var$mapStateOnServer({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
        return mappedState;
    }, _temp;
};
var $75dff6e231aa6411$var$NullComponent = function NullComponent() {
    return null;
};
var $75dff6e231aa6411$var$HelmetSideEffects = (0, (/*@__PURE__*/$parcel$interopDefault($63abK)))($75dff6e231aa6411$var$reducePropsToState, $75dff6e231aa6411$var$handleClientStateChange, $75dff6e231aa6411$var$mapStateOnServer)($75dff6e231aa6411$var$NullComponent);
var $75dff6e231aa6411$export$dcef8f9bb9a41431 = $75dff6e231aa6411$var$Helmet($75dff6e231aa6411$var$HelmetSideEffects);
$75dff6e231aa6411$export$dcef8f9bb9a41431.renderStatic = $75dff6e231aa6411$export$dcef8f9bb9a41431.rewind;
var $75dff6e231aa6411$export$2e2bcd8739ae039 = $75dff6e231aa6411$export$dcef8f9bb9a41431;

});
parcelRequire.register("63abK", function(module, exports) {
"use strict";
function $467aed1fd2df2322$var$_interopDefault(ex) {
    return ex && typeof ex === "object" && "default" in ex ? ex["default"] : ex;
}

var $eCoWV = parcelRequire("eCoWV");
var $467aed1fd2df2322$var$React__default = $467aed1fd2df2322$var$_interopDefault($eCoWV);
function $467aed1fd2df2322$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $467aed1fd2df2322$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $467aed1fd2df2322$var$canUseDOM = !!(typeof window !== "undefined" && window.document && window.document.createElement);
function $467aed1fd2df2322$var$withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
    if (typeof reducePropsToState !== "function") throw new Error("Expected reducePropsToState to be a function.");
    if (typeof handleStateChangeOnClient !== "function") throw new Error("Expected handleStateChangeOnClient to be a function.");
    if (typeof mapStateOnServer !== "undefined" && typeof mapStateOnServer !== "function") throw new Error("Expected mapStateOnServer to either be undefined or a function.");
    function getDisplayName(WrappedComponent) {
        return WrappedComponent.displayName || WrappedComponent.name || "Component";
    }
    return function wrap(WrappedComponent) {
        if (typeof WrappedComponent !== "function") throw new Error("Expected WrappedComponent to be a React component.");
        var mountedInstances = [];
        var state;
        function emitChange() {
            state = reducePropsToState(mountedInstances.map(function(instance) {
                return instance.props;
            }));
            if (SideEffect.canUseDOM) handleStateChangeOnClient(state);
            else if (mapStateOnServer) state = mapStateOnServer(state);
        }
        var SideEffect = /*#__PURE__*/ function(_PureComponent) {
            $467aed1fd2df2322$var$_inheritsLoose(SideEffect, _PureComponent);
            function SideEffect() {
                return _PureComponent.apply(this, arguments) || this;
            }
            // Try to use displayName of wrapped component
            // Expose canUseDOM so tests can monkeypatch it
            SideEffect.peek = function peek() {
                return state;
            };
            SideEffect.rewind = function rewind() {
                if (SideEffect.canUseDOM) throw new Error("You may only call rewind() on the server. Call peek() to read the current state.");
                var recordedState = state;
                state = undefined;
                mountedInstances = [];
                return recordedState;
            };
            var _proto = SideEffect.prototype;
            _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
                mountedInstances.push(this);
                emitChange();
            };
            _proto.componentDidUpdate = function componentDidUpdate() {
                emitChange();
            };
            _proto.componentWillUnmount = function componentWillUnmount() {
                var index = mountedInstances.indexOf(this);
                mountedInstances.splice(index, 1);
                emitChange();
            };
            _proto.render = function render() {
                return $467aed1fd2df2322$var$React__default.createElement(WrappedComponent, this.props);
            };
            return SideEffect;
        }($eCoWV.PureComponent);
        $467aed1fd2df2322$var$_defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
        $467aed1fd2df2322$var$_defineProperty(SideEffect, "canUseDOM", $467aed1fd2df2322$var$canUseDOM);
        return SideEffect;
    };
}
module.exports = $467aed1fd2df2322$var$withSideEffect;

});

parcelRequire.register("9nZWq", function(module, exports) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $6d564f492673a5b7$var$hasElementType = typeof Element !== "undefined";
var $6d564f492673a5b7$var$hasMap = typeof Map === "function";
var $6d564f492673a5b7$var$hasSet = typeof Set === "function";
var $6d564f492673a5b7$var$hasArrayBuffer = typeof ArrayBuffer === "function" && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $6d564f492673a5b7$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$6d564f492673a5b7$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($6d564f492673a5b7$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$6d564f492673a5b7$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($6d564f492673a5b7$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($6d564f492673a5b7$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === "function" && typeof b.valueOf === "function") return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === "function" && typeof b.toString === "function") return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($6d564f492673a5b7$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === "_owner" || keys[i] === "__v" || keys[i] === "__o") && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$6d564f492673a5b7$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return $6d564f492673a5b7$var$equal(a, b);
    } catch (error) {
        if ((error.message || "").match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn("react-fast-compare cannot handle circular refs");
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

});

parcelRequire.register("ikiL7", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ "use strict";
/* eslint-disable no-unused-vars */ var $d578a5610cf7243a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $d578a5610cf7243a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $d578a5610cf7243a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $d578a5610cf7243a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(val);
}
function $d578a5610cf7243a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String("abc"); // eslint-disable-line no-new-wrappers
        test1[5] = "de";
        if (Object.getOwnPropertyNames(test1)[0] === "5") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2["_" + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join("") !== "0123456789") return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        "abcdefghijklmnopqrst".split("").forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join("") !== "abcdefghijklmnopqrst") return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $d578a5610cf7243a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $d578a5610cf7243a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($d578a5610cf7243a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($d578a5610cf7243a$var$getOwnPropertySymbols) {
            symbols = $d578a5610cf7243a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($d578a5610cf7243a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});



parcelRequire.register("93h5F", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bab8e7bf3dbbc72d$export$2e2bcd8739ae039; });

var $eCoWV = parcelRequire("eCoWV");

var $1iAqo = parcelRequire("1iAqo");
const $bab8e7bf3dbbc72d$var$useTheme = ()=>{
    const { theme: theme } = (0, $eCoWV.useContext)((0, $1iAqo.AppThemeContext));
    return theme;
};
var $bab8e7bf3dbbc72d$export$2e2bcd8739ae039 = $bab8e7bf3dbbc72d$var$useTheme;

});
parcelRequire.register("1iAqo", function(module, exports) {

$parcel$export(module.exports, "buildDefaultAppearanceMode", function () { return $42c7cfade8104a95$export$a68e920650595f8e; });
$parcel$export(module.exports, "AppThemeContext", function () { return $42c7cfade8104a95$export$d671dde48af37475; });
$parcel$export(module.exports, "AppThemeProvider", function () { return $42c7cfade8104a95$export$5dde40e32fe2bf0; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("6ZMK7");
var $mbOAD = parcelRequire("mbOAD");

var $cQ96m = parcelRequire("cQ96m");

var $bvXFE = parcelRequire("bvXFE");
const $42c7cfade8104a95$var$darkThemeWatchMedia = window.matchMedia("(prefers-color-scheme: dark)");
const $42c7cfade8104a95$var$getThemeBySystemConfiguration = ()=>$42c7cfade8104a95$var$darkThemeWatchMedia.matches ? (0, $bhvxB.Theme).Dark : (0, $bhvxB.Theme).Light;
const $42c7cfade8104a95$export$a68e920650595f8e = ()=>(0, $aWIy6.trySafe)(()=>(0, $cQ96m.appearanceModeGuard).parse(localStorage.getItem((0, $mbOAD.storageKeys).appearanceMode))) ?? (0, $cQ96m.DynamicAppearanceMode).System;
const $42c7cfade8104a95$var$defaultAppearanceMode = $42c7cfade8104a95$export$a68e920650595f8e();
const $42c7cfade8104a95$var$defaultTheme = $42c7cfade8104a95$var$defaultAppearanceMode === (0, $cQ96m.DynamicAppearanceMode).System ? $42c7cfade8104a95$var$getThemeBySystemConfiguration() : $42c7cfade8104a95$var$defaultAppearanceMode;
const $42c7cfade8104a95$export$d671dde48af37475 = /*#__PURE__*/ (0, $eCoWV.createContext)({
    theme: $42c7cfade8104a95$var$defaultTheme,
    setAppearanceMode: (0, $aWIy6.noop),
    setThemeOverride: (0, $aWIy6.noop)
});
function $42c7cfade8104a95$export$5dde40e32fe2bf0({ children: children }) {
    const [theme, setTheme] = (0, $eCoWV.useState)($42c7cfade8104a95$var$defaultTheme);
    const [themeOverride, setThemeOverride] = (0, $eCoWV.useState)();
    const [mode, setMode] = (0, $eCoWV.useState)($42c7cfade8104a95$var$defaultAppearanceMode);
    const setAppearanceMode = (mode)=>{
        setMode(mode);
        localStorage.setItem((0, $mbOAD.storageKeys).appearanceMode, mode);
    };
    (0, $eCoWV.useEffect)(()=>{
        if (themeOverride) {
            setTheme(themeOverride);
            return;
        }
        if (mode !== (0, $cQ96m.DynamicAppearanceMode).System) {
            setTheme(mode);
            return;
        }
        const changeTheme = ()=>{
            setTheme($42c7cfade8104a95$var$getThemeBySystemConfiguration());
        };
        changeTheme();
        $42c7cfade8104a95$var$darkThemeWatchMedia.addEventListener("change", changeTheme);
        return ()=>{
            $42c7cfade8104a95$var$darkThemeWatchMedia.removeEventListener("change", changeTheme);
        };
    }, [
        mode,
        themeOverride
    ]);
    // Set Theme Mode
    (0, $eCoWV.useEffect)(()=>{
        document.body.classList.remove((0, $5CQIb.conditionalString)($bvXFE.light), (0, $5CQIb.conditionalString)($bvXFE.dark));
        document.body.classList.add((0, $5CQIb.conditionalString)($bvXFE[theme]));
    }, [
        theme
    ]);
    const context = (0, $eCoWV.useMemo)(()=>({
            theme: theme,
            setAppearanceMode: setAppearanceMode,
            setThemeOverride: setThemeOverride
        }), [
        theme
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)($42c7cfade8104a95$export$d671dde48af37475.Provider, {
        value: context,
        children: children
    });
}

});
parcelRequire.register("cQ96m", function(module, exports) {

$parcel$export(module.exports, "DynamicAppearanceMode", function () { return $7aa8dd0090f74c01$export$203ffecb5d2b1434; });
$parcel$export(module.exports, "appearanceModeGuard", function () { return $7aa8dd0090f74c01$export$d3dadba663a5ce54; });
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $2CYkO = parcelRequire("2CYkO");
var $7aa8dd0090f74c01$export$203ffecb5d2b1434;
(function(DynamicAppearanceMode) {
    DynamicAppearanceMode["System"] = "system";
})($7aa8dd0090f74c01$export$203ffecb5d2b1434 || ($7aa8dd0090f74c01$export$203ffecb5d2b1434 = {}));
const $7aa8dd0090f74c01$export$d3dadba663a5ce54 = (0, $2CYkO.z).nativeEnum((0, $bhvxB.Theme)).or((0, $2CYkO.z).nativeEnum($7aa8dd0090f74c01$export$203ffecb5d2b1434));

});

parcelRequire.register("bvXFE", function(module, exports) {

$parcel$export(module.exports, "dark", function () { return $8620e0525d18f88c$export$55ce6f3a06c59543; }, function (v) { return $8620e0525d18f88c$export$55ce6f3a06c59543 = v; });
$parcel$export(module.exports, "light", function () { return $8620e0525d18f88c$export$a43af521ac8c3202; }, function (v) { return $8620e0525d18f88c$export$a43af521ac8c3202 = v; });
var $8620e0525d18f88c$export$55ce6f3a06c59543;
var $8620e0525d18f88c$export$a43af521ac8c3202;
$8620e0525d18f88c$export$55ce6f3a06c59543 = `_2eodma_dark`;
$8620e0525d18f88c$export$a43af521ac8c3202 = `_2eodma_light`;

});



parcelRequire.register("lKXyD", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $fd6c17c2ce72bfa9$export$34e0f9847d4c02dd; }, function (v) { return $fd6c17c2ce72bfa9$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "content", function () { return $fd6c17c2ce72bfa9$export$a7db06668cad9adb; }, function (v) { return $fd6c17c2ce72bfa9$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "message", function () { return $fd6c17c2ce72bfa9$export$a8ecead220dd38a6; }, function (v) { return $fd6c17c2ce72bfa9$export$a8ecead220dd38a6 = v; });
var $fd6c17c2ce72bfa9$export$34e0f9847d4c02dd;
var $fd6c17c2ce72bfa9$export$a7db06668cad9adb;
var $fd6c17c2ce72bfa9$export$a8ecead220dd38a6;
var $fd6c17c2ce72bfa9$export$bfd64c937657f93a;
var $fd6c17c2ce72bfa9$export$4a6dd88bada4e7d2;
$fd6c17c2ce72bfa9$export$34e0f9847d4c02dd = `_8LEt0W_container`;
$fd6c17c2ce72bfa9$export$a7db06668cad9adb = `_8LEt0W_content`;
$fd6c17c2ce72bfa9$export$a8ecead220dd38a6 = `_8LEt0W_message`;
$fd6c17c2ce72bfa9$export$bfd64c937657f93a = `_8LEt0W_rotating`;
$fd6c17c2ce72bfa9$export$4a6dd88bada4e7d2 = `_8LEt0W_shimmer`;

});


parcelRequire.register("9VcRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8ce7de9ea19da18e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $4zN7p = parcelRequire("4zN7p");
function $8ce7de9ea19da18e$var$StepsSkeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: Array.from({
            length: 5
        }).map((_, stepIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $4zN7p.step,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $4zN7p.index
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $4zN7p.wrapper,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $4zN7p.title
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $4zN7p.subtitle
                            })
                        ]
                    })
                ]
            }, stepIndex))
    });
}
var $8ce7de9ea19da18e$export$2e2bcd8739ae039 = $8ce7de9ea19da18e$var$StepsSkeleton;

});
parcelRequire.register("4zN7p", function(module, exports) {

$parcel$export(module.exports, "index", function () { return $35508836b62de2f2$export$b610b8812bbcded9; }, function (v) { return $35508836b62de2f2$export$b610b8812bbcded9 = v; });
$parcel$export(module.exports, "shimmer", function () { return $35508836b62de2f2$export$4a6dd88bada4e7d2; }, function (v) { return $35508836b62de2f2$export$4a6dd88bada4e7d2 = v; });
$parcel$export(module.exports, "step", function () { return $35508836b62de2f2$export$35d34bc0ed591a92; }, function (v) { return $35508836b62de2f2$export$35d34bc0ed591a92 = v; });
$parcel$export(module.exports, "subtitle", function () { return $35508836b62de2f2$export$c96745152eb2740f; }, function (v) { return $35508836b62de2f2$export$c96745152eb2740f = v; });
$parcel$export(module.exports, "title", function () { return $35508836b62de2f2$export$fb184b623420d9be; }, function (v) { return $35508836b62de2f2$export$fb184b623420d9be = v; });
$parcel$export(module.exports, "wrapper", function () { return $35508836b62de2f2$export$cc74dcc53cfce4eb; }, function (v) { return $35508836b62de2f2$export$cc74dcc53cfce4eb = v; });
var $35508836b62de2f2$export$b610b8812bbcded9;
var $35508836b62de2f2$export$bfd64c937657f93a;
var $35508836b62de2f2$export$4a6dd88bada4e7d2;
var $35508836b62de2f2$export$35d34bc0ed591a92;
var $35508836b62de2f2$export$c96745152eb2740f;
var $35508836b62de2f2$export$fb184b623420d9be;
var $35508836b62de2f2$export$cc74dcc53cfce4eb;
$35508836b62de2f2$export$b610b8812bbcded9 = `PpHBxa_index`;
$35508836b62de2f2$export$bfd64c937657f93a = `PpHBxa_rotating`;
$35508836b62de2f2$export$4a6dd88bada4e7d2 = `PpHBxa_shimmer`;
$35508836b62de2f2$export$4a6dd88bada4e7d2;
$35508836b62de2f2$export$35d34bc0ed591a92 = `PpHBxa_step`;
$35508836b62de2f2$export$c96745152eb2740f = `PpHBxa_subtitle`;
$35508836b62de2f2$export$fb184b623420d9be = `PpHBxa_title`;
$35508836b62de2f2$export$cc74dcc53cfce4eb = `PpHBxa_wrapper`;

});


parcelRequire.register("e86H6", function(module, exports) {

$parcel$export(module.exports, "actionBar", function () { return $a497015f87c923c2$export$795623e8105ba10a; }, function (v) { return $a497015f87c923c2$export$795623e8105ba10a = v; });
$parcel$export(module.exports, "content", function () { return $a497015f87c923c2$export$a7db06668cad9adb; }, function (v) { return $a497015f87c923c2$export$a7db06668cad9adb = v; });
$parcel$export(module.exports, "layout", function () { return $a497015f87c923c2$export$b3219800bda33a1f; }, function (v) { return $a497015f87c923c2$export$b3219800bda33a1f = v; });
$parcel$export(module.exports, "notFound", function () { return $a497015f87c923c2$export$a33e918cb4258370; }, function (v) { return $a497015f87c923c2$export$a33e918cb4258370 = v; });
var $a497015f87c923c2$export$795623e8105ba10a;
var $a497015f87c923c2$export$a7db06668cad9adb;
var $a497015f87c923c2$export$b3219800bda33a1f;
var $a497015f87c923c2$export$a33e918cb4258370;
var $a497015f87c923c2$export$bfd64c937657f93a;
var $a497015f87c923c2$export$4a6dd88bada4e7d2;
$a497015f87c923c2$export$795623e8105ba10a = `j1GCcq_actionBar`;
$a497015f87c923c2$export$a7db06668cad9adb = `j1GCcq_content`;
$a497015f87c923c2$export$b3219800bda33a1f = `j1GCcq_layout`;
$a497015f87c923c2$export$a33e918cb4258370 = `j1GCcq_notFound`;
$a497015f87c923c2$export$bfd64c937657f93a = `j1GCcq_rotating`;
$a497015f87c923c2$export$4a6dd88bada4e7d2 = `j1GCcq_shimmer`;

});


parcelRequire.register("itzs0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f96f4243ef42ece7$export$2e2bcd8739ae039; });
parcelRequire("j6dBR");
var $1EA0k = parcelRequire("1EA0k");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");

var $it2CQ = parcelRequire("it2CQ");

var $V1X8c = parcelRequire("V1X8c");

var $h7VLF = parcelRequire("h7VLF");
const $f96f4243ef42ece7$var$useCustomDomain = (autoSync = false)=>{
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)((0, $V1X8c.isCloud) && "api/domains", (0, $5CQIb.conditional)(autoSync && {
        refreshInterval: (0, $it2CQ.customDomainSyncInterval) * 1000
    }));
    const isLoading = !data && !error;
    /**
   * Note: we can only create a custom domain, and we don't have a default id for it, so the first element of the array is the custom domain.
   */ const customDomain = (0, $eCoWV.useMemo)(()=>data?.[0], [
        data
    ]);
    const mutateDomain = (0, $eCoWV.useCallback)((domain)=>{
        mutate(domain ? [
            domain
        ] : undefined);
    }, [
        mutate
    ]);
    const applyDomain = (0, $eCoWV.useCallback)((url)=>{
        if (customDomain?.status !== (0, $1EA0k.DomainStatus).Active || !(0, $h7VLF.isAbsoluteUrl)(url)) return url;
        return url.replace(new URL(url).host, customDomain.domain);
    }, [
        customDomain
    ]);
    return {
        data: customDomain,
        isLoading: isLoading,
        mutate: mutateDomain,
        applyDomain: applyDomain
    };
};
var $f96f4243ef42ece7$export$2e2bcd8739ae039 = $f96f4243ef42ece7$var$useCustomDomain;

});
parcelRequire.register("it2CQ", function(module, exports) {

$parcel$export(module.exports, "customDomainSyncInterval", function () { return $341ce350e4d1192b$export$6358f99c73b6b14e; });
const $341ce350e4d1192b$export$6358f99c73b6b14e = 10; // In seconds

});


parcelRequire.register("cwrCy", function(module, exports) {

!function(e11, t11) {
    module.exports = t11((parcelRequire("eCoWV")));
}(this, function(__WEBPACK_EXTERNAL_MODULE__98__) {
    return (()=>{
        var __webpack_modules__ = {
            759: (e11, t11, a11)=>{
                "use strict";
                a11.d(t11, {
                    Z: ()=>c11
                });
                var r11, o11 = a11(98), _11 = a11.n(o11), n11 = a11(697), i11 = a11.n(n11);
                function s11() {
                    return s11 = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, s11.apply(this, arguments);
                }
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var l11 = function(e11) {
                    var t11 = e11.breakLabel, a11 = e11.breakClassName, r11 = e11.breakLinkClassName, o11 = e11.breakHandler, n11 = e11.getEventListener, i11 = a11 || "break";
                    return _11().createElement("li", {
                        className: i11
                    }, _11().createElement("a", s11({
                        className: r11,
                        role: "button",
                        tabIndex: "0",
                        onKeyPress: o11
                    }, n11(o11)), t11));
                };
                l11.propTypes = {
                    breakLabel: i11().oneOfType([
                        i11().string,
                        i11().node
                    ]),
                    breakClassName: i11().string,
                    breakLinkClassName: i11().string,
                    breakHandler: i11().func.isRequired,
                    getEventListener: i11().func.isRequired
                };
                var p11 = l11;
                const c11 = p11;
                var d11, u11;
                (d11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d11.register(l11, "BreakView", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js"), d11.register(p11, "default", "/home/yoan/work/oss/react-paginate/react_components/BreakView.js")), (u11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u11(e11);
            },
            770: (e11, t11, a11)=>{
                "use strict";
                a11.d(t11, {
                    Z: ()=>c11
                });
                var r11, o11 = a11(98), _11 = a11.n(o11), n11 = a11(697), i11 = a11.n(n11);
                function s11() {
                    return s11 = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, s11.apply(this, arguments);
                }
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var l11 = function(e11) {
                    var t11 = e11.pageClassName, a11 = e11.pageLinkClassName, r11 = e11.page, o11 = e11.selected, n11 = e11.activeClassName, i11 = e11.activeLinkClassName, l11 = e11.getEventListener, p11 = e11.pageSelectedHandler, c11 = e11.href, d11 = e11.extraAriaContext, u11 = e11.pageLabelBuilder, f11 = e11.rel, g11 = e11.ariaLabel || "Page " + r11 + (d11 ? " " + d11 : ""), P11 = null;
                    return o11 && (P11 = "page", g11 = e11.ariaLabel || "Page " + r11 + " is your current page", t11 = void 0 !== t11 ? t11 + " " + n11 : n11, void 0 !== a11 ? void 0 !== i11 && (a11 = a11 + " " + i11) : a11 = i11), _11().createElement("li", {
                        className: t11
                    }, _11().createElement("a", s11({
                        rel: f11,
                        role: c11 ? void 0 : "button",
                        className: a11,
                        href: c11,
                        tabIndex: o11 ? "-1" : "0",
                        "aria-label": g11,
                        "aria-current": P11,
                        onKeyPress: p11
                    }, l11(p11)), u11(r11)));
                };
                l11.propTypes = {
                    pageSelectedHandler: i11().func.isRequired,
                    selected: i11().bool.isRequired,
                    pageClassName: i11().string,
                    pageLinkClassName: i11().string,
                    activeClassName: i11().string,
                    activeLinkClassName: i11().string,
                    extraAriaContext: i11().string,
                    href: i11().string,
                    ariaLabel: i11().string,
                    page: i11().number.isRequired,
                    getEventListener: i11().func.isRequired,
                    pageLabelBuilder: i11().func.isRequired,
                    rel: i11().string
                };
                var p11 = l11;
                const c11 = p11;
                var d11, u11;
                (d11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && (d11.register(l11, "PageView", "/home/yoan/work/oss/react-paginate/react_components/PageView.js"), d11.register(p11, "default", "/home/yoan/work/oss/react-paginate/react_components/PageView.js")), (u11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && u11(e11);
            },
            214: (module, __webpack_exports__, __webpack_require__)=>{
                "use strict";
                __webpack_require__.d(__webpack_exports__, {
                    Z: ()=>PaginationBoxView
                });
                var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98), react__WEBPACK_IMPORTED_MODULE_0___default = __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__), prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(697), prop_types__WEBPACK_IMPORTED_MODULE_1___default = __webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__), _PageView__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(770), _BreakView__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(759), _utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(923), enterModule;
                function _typeof(e11) {
                    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e11) {
                        return typeof e11;
                    } : function(e11) {
                        return e11 && "function" == typeof Symbol && e11.constructor === Symbol && e11 !== Symbol.prototype ? "symbol" : typeof e11;
                    }, _typeof(e11);
                }
                function _extends() {
                    return _extends = Object.assign || function(e11) {
                        for(var t11 = 1; t11 < arguments.length; t11++){
                            var a11 = arguments[t11];
                            for(var r11 in a11)Object.prototype.hasOwnProperty.call(a11, r11) && (e11[r11] = a11[r11]);
                        }
                        return e11;
                    }, _extends.apply(this, arguments);
                }
                function _classCallCheck(e11, t11) {
                    if (!(e11 instanceof t11)) throw new TypeError("Cannot call a class as a function");
                }
                function _defineProperties(e11, t11) {
                    for(var a11 = 0; a11 < t11.length; a11++){
                        var r11 = t11[a11];
                        r11.enumerable = r11.enumerable || !1, r11.configurable = !0, "value" in r11 && (r11.writable = !0), Object.defineProperty(e11, r11.key, r11);
                    }
                }
                function _createClass(e11, t11, a11) {
                    return t11 && _defineProperties(e11.prototype, t11), a11 && _defineProperties(e11, a11), e11;
                }
                function _inherits(e11, t11) {
                    if ("function" != typeof t11 && null !== t11) throw new TypeError("Super expression must either be null or a function");
                    e11.prototype = Object.create(t11 && t11.prototype, {
                        constructor: {
                            value: e11,
                            writable: !0,
                            configurable: !0
                        }
                    }), t11 && _setPrototypeOf(e11, t11);
                }
                function _setPrototypeOf(e11, t11) {
                    return _setPrototypeOf = Object.setPrototypeOf || function(e11, t11) {
                        return e11.__proto__ = t11, e11;
                    }, _setPrototypeOf(e11, t11);
                }
                function _createSuper(e11) {
                    var t11 = _isNativeReflectConstruct();
                    return function() {
                        var a11, r11 = _getPrototypeOf(e11);
                        if (t11) {
                            var o11 = _getPrototypeOf(this).constructor;
                            a11 = Reflect.construct(r11, arguments, o11);
                        } else a11 = r11.apply(this, arguments);
                        return _possibleConstructorReturn(this, a11);
                    };
                }
                function _possibleConstructorReturn(e11, t11) {
                    if (t11 && ("object" === _typeof(t11) || "function" == typeof t11)) return t11;
                    if (void 0 !== t11) throw new TypeError("Derived constructors may only return object or undefined");
                    return _assertThisInitialized(e11);
                }
                function _assertThisInitialized(e11) {
                    if (void 0 === e11) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e11;
                }
                function _isNativeReflectConstruct() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                    } catch (e11) {
                        return !1;
                    }
                }
                function _getPrototypeOf(e11) {
                    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function(e11) {
                        return e11.__proto__ || Object.getPrototypeOf(e11);
                    }, _getPrototypeOf(e11);
                }
                function _defineProperty(e11, t11, a11) {
                    return t11 in e11 ? Object.defineProperty(e11, t11, {
                        value: a11,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : e11[t11] = a11, e11;
                }
                module = __webpack_require__.hmd(module), enterModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0, enterModule && enterModule(module);
                var __signature__ = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default.signature : function(e11) {
                    return e11;
                }, PaginationBoxView = function(_Component) {
                    _inherits(PaginationBoxView, _Component);
                    var _super = _createSuper(PaginationBoxView);
                    function PaginationBoxView(e11) {
                        var t11, a11;
                        return _classCallCheck(this, PaginationBoxView), _defineProperty(_assertThisInitialized(t11 = _super.call(this, e11)), "handlePreviousPage", function(e11) {
                            var a11 = t11.state.selected;
                            t11.handleClick(e11, null, a11 > 0 ? a11 - 1 : void 0, {
                                isPrevious: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "handleNextPage", function(e11) {
                            var a11 = t11.state.selected, r11 = t11.props.pageCount;
                            t11.handleClick(e11, null, a11 < r11 - 1 ? a11 + 1 : void 0, {
                                isNext: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "handlePageSelected", function(e11, a11) {
                            if (t11.state.selected === e11) return t11.callActiveCallback(e11), void t11.handleClick(a11, null, void 0, {
                                isActive: !0
                            });
                            t11.handleClick(a11, null, e11);
                        }), _defineProperty(_assertThisInitialized(t11), "handlePageChange", function(e11) {
                            t11.state.selected !== e11 && (t11.setState({
                                selected: e11
                            }), t11.callCallback(e11));
                        }), _defineProperty(_assertThisInitialized(t11), "getEventListener", function(e11) {
                            return _defineProperty({}, t11.props.eventListener, e11);
                        }), _defineProperty(_assertThisInitialized(t11), "handleClick", function(e11, a11, r11) {
                            var o11 = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}, _11 = o11.isPrevious, n11 = void 0 !== _11 && _11, i11 = o11.isNext, s11 = void 0 !== i11 && i11, l11 = o11.isBreak, p11 = void 0 !== l11 && l11, c11 = o11.isActive, d11 = void 0 !== c11 && c11;
                            e11.preventDefault ? e11.preventDefault() : e11.returnValue = !1;
                            var u11 = t11.state.selected, f11 = t11.props.onClick, g11 = r11;
                            if (f11) {
                                var P11 = f11({
                                    index: a11,
                                    selected: u11,
                                    nextSelectedPage: r11,
                                    event: e11,
                                    isPrevious: n11,
                                    isNext: s11,
                                    isBreak: p11,
                                    isActive: d11
                                });
                                if (!1 === P11) return;
                                Number.isInteger(P11) && (g11 = P11);
                            }
                            void 0 !== g11 && t11.handlePageChange(g11);
                        }), _defineProperty(_assertThisInitialized(t11), "handleBreakClick", function(e11, a11) {
                            var r11 = t11.state.selected;
                            t11.handleClick(a11, e11, r11 < e11 ? t11.getForwardJump() : t11.getBackwardJump(), {
                                isBreak: !0
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "callCallback", function(e11) {
                            void 0 !== t11.props.onPageChange && "function" == typeof t11.props.onPageChange && t11.props.onPageChange({
                                selected: e11
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "callActiveCallback", function(e11) {
                            void 0 !== t11.props.onPageActive && "function" == typeof t11.props.onPageActive && t11.props.onPageActive({
                                selected: e11
                            });
                        }), _defineProperty(_assertThisInitialized(t11), "getElementPageRel", function(e11) {
                            var a11 = t11.state.selected, r11 = t11.props, o11 = r11.nextPageRel, _11 = r11.prevPageRel, n11 = r11.selectedPageRel;
                            return a11 - 1 === e11 ? _11 : a11 === e11 ? n11 : a11 + 1 === e11 ? o11 : void 0;
                        }), _defineProperty(_assertThisInitialized(t11), "pagination", function() {
                            var e11 = [], a11 = t11.props, r11 = a11.pageRangeDisplayed, o11 = a11.pageCount, _11 = a11.marginPagesDisplayed, n11 = a11.breakLabel, i11 = a11.breakClassName, s11 = a11.breakLinkClassName, l11 = t11.state.selected;
                            if (o11 <= r11) for(var p11 = 0; p11 < o11; p11++)e11.push(t11.getPageElement(p11));
                            else {
                                var c11 = r11 / 2, d11 = r11 - c11;
                                l11 > o11 - r11 / 2 ? c11 = r11 - (d11 = o11 - l11) : l11 < r11 / 2 && (d11 = r11 - (c11 = l11));
                                var u11, f11, g11 = function(e11) {
                                    return t11.getPageElement(e11);
                                }, P11 = [];
                                for(u11 = 0; u11 < o11; u11++){
                                    var E11 = u11 + 1;
                                    E11 <= _11 || E11 > o11 - _11 || u11 >= l11 - c11 && u11 <= l11 + (0 === l11 && r11 > 1 ? d11 - 1 : d11) ? P11.push({
                                        type: "page",
                                        index: u11,
                                        display: g11(u11)
                                    }) : n11 && P11.length > 0 && P11[P11.length - 1].display !== f11 && (r11 > 0 || _11 > 0) && (f11 = react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_BreakView__WEBPACK_IMPORTED_MODULE_3__.Z, {
                                        key: u11,
                                        breakLabel: n11,
                                        breakClassName: i11,
                                        breakLinkClassName: s11,
                                        breakHandler: t11.handleBreakClick.bind(null, u11),
                                        getEventListener: t11.getEventListener
                                    }), P11.push({
                                        type: "break",
                                        index: u11,
                                        display: f11
                                    }));
                                }
                                P11.forEach(function(t11, a11) {
                                    var r11 = t11;
                                    "break" === t11.type && P11[a11 - 1] && "page" === P11[a11 - 1].type && P11[a11 + 1] && "page" === P11[a11 + 1].type && P11[a11 + 1].index - P11[a11 - 1].index <= 2 && (r11 = {
                                        type: "page",
                                        index: t11.index,
                                        display: g11(t11.index)
                                    }), e11.push(r11.display);
                                });
                            }
                            return e11;
                        }), void 0 !== e11.initialPage && void 0 !== e11.forcePage && console.warn("(react-paginate): Both initialPage (".concat(e11.initialPage, ") and forcePage (").concat(e11.forcePage, ") props are provided, which is discouraged.") + " Use exclusively forcePage prop for a controlled component.\nSee https://reactjs.org/docs/forms.html#controlled-components"), a11 = e11.initialPage ? e11.initialPage : e11.forcePage ? e11.forcePage : 0, t11.state = {
                            selected: a11
                        }, t11;
                    }
                    return _createClass(PaginationBoxView, [
                        {
                            key: "componentDidMount",
                            value: function() {
                                var e11 = this.props, t11 = e11.initialPage, a11 = e11.disableInitialCallback, r11 = e11.extraAriaContext, o11 = e11.pageCount, _11 = e11.forcePage;
                                void 0 === t11 || a11 || this.callCallback(t11), r11 && console.warn("DEPRECATED (react-paginate): The extraAriaContext prop is deprecated. You should now use the ariaLabelBuilder instead."), Number.isInteger(o11) || console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(o11, "). Did you forget a Math.ceil()?")), void 0 !== t11 && t11 > o11 - 1 && console.warn("(react-paginate): The initialPage prop provided is greater than the maximum page index from pageCount prop (".concat(t11, " > ").concat(o11 - 1, ").")), void 0 !== _11 && _11 > o11 - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(_11, " > ").concat(o11 - 1, ")."));
                            }
                        },
                        {
                            key: "componentDidUpdate",
                            value: function(e11) {
                                void 0 !== this.props.forcePage && this.props.forcePage !== e11.forcePage && (this.props.forcePage > this.props.pageCount - 1 && console.warn("(react-paginate): The forcePage prop provided is greater than the maximum page index from pageCount prop (".concat(this.props.forcePage, " > ").concat(this.props.pageCount - 1, ").")), this.setState({
                                    selected: this.props.forcePage
                                })), Number.isInteger(e11.pageCount) && !Number.isInteger(this.props.pageCount) && console.warn("(react-paginate): The pageCount prop value provided is not an integer (".concat(this.props.pageCount, "). Did you forget a Math.ceil()?"));
                            }
                        },
                        {
                            key: "getForwardJump",
                            value: function() {
                                var e11 = this.state.selected, t11 = this.props, a11 = t11.pageCount, r11 = e11 + t11.pageRangeDisplayed;
                                return r11 >= a11 ? a11 - 1 : r11;
                            }
                        },
                        {
                            key: "getBackwardJump",
                            value: function() {
                                var e11 = this.state.selected - this.props.pageRangeDisplayed;
                                return e11 < 0 ? 0 : e11;
                            }
                        },
                        {
                            key: "getElementHref",
                            value: function(e11) {
                                var t11 = this.props, a11 = t11.hrefBuilder, r11 = t11.pageCount, o11 = t11.hrefAllControls;
                                if (a11) return o11 || e11 >= 0 && e11 < r11 ? a11(e11 + 1, r11, this.state.selected) : void 0;
                            }
                        },
                        {
                            key: "ariaLabelBuilder",
                            value: function(e11) {
                                var t11 = e11 === this.state.selected;
                                if (this.props.ariaLabelBuilder && e11 >= 0 && e11 < this.props.pageCount) {
                                    var a11 = this.props.ariaLabelBuilder(e11 + 1, t11);
                                    return this.props.extraAriaContext && !t11 && (a11 = a11 + " " + this.props.extraAriaContext), a11;
                                }
                            }
                        },
                        {
                            key: "getPageElement",
                            value: function(e11) {
                                var t11 = this.state.selected, a11 = this.props, r11 = a11.pageClassName, o11 = a11.pageLinkClassName, _11 = a11.activeClassName, n11 = a11.activeLinkClassName, i11 = a11.extraAriaContext, s11 = a11.pageLabelBuilder;
                                return react__WEBPACK_IMPORTED_MODULE_0___default().createElement(_PageView__WEBPACK_IMPORTED_MODULE_2__.Z, {
                                    key: e11,
                                    pageSelectedHandler: this.handlePageSelected.bind(null, e11),
                                    selected: t11 === e11,
                                    rel: this.getElementPageRel(e11),
                                    pageClassName: r11,
                                    pageLinkClassName: o11,
                                    activeClassName: _11,
                                    activeLinkClassName: n11,
                                    extraAriaContext: i11,
                                    href: this.getElementHref(e11),
                                    ariaLabel: this.ariaLabelBuilder(e11),
                                    page: e11 + 1,
                                    pageLabelBuilder: s11,
                                    getEventListener: this.getEventListener
                                });
                            }
                        },
                        {
                            key: "render",
                            value: function() {
                                var e11 = this.props.renderOnZeroPageCount;
                                if (0 === this.props.pageCount && void 0 !== e11) return e11 ? e11(this.props) : e11;
                                var t11 = this.props, a11 = t11.disabledClassName, r11 = t11.disabledLinkClassName, o11 = t11.pageCount, _11 = t11.className, n11 = t11.containerClassName, i11 = t11.previousLabel, s11 = t11.previousClassName, l11 = t11.previousLinkClassName, p11 = t11.previousAriaLabel, c11 = t11.prevRel, d11 = t11.nextLabel, u11 = t11.nextClassName, f11 = t11.nextLinkClassName, g11 = t11.nextAriaLabel, P11 = t11.nextRel, E11 = this.state.selected, b11 = 0 === E11, y11 = E11 === o11 - 1, v11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(s11)).concat(b11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a11)) : ""), C11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(u11)).concat(y11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(a11)) : ""), O11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(l11)).concat(b11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r11)) : ""), m11 = "".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(f11)).concat(y11 ? " ".concat((0, _utils__WEBPACK_IMPORTED_MODULE_4__.m)(r11)) : ""), L11 = b11 ? "true" : "false", h11 = y11 ? "true" : "false";
                                return react__WEBPACK_IMPORTED_MODULE_0___default().createElement("ul", {
                                    className: _11 || n11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                                    className: v11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                                    className: O11,
                                    href: this.getElementHref(E11 - 1),
                                    tabIndex: b11 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handlePreviousPage,
                                    "aria-disabled": L11,
                                    "aria-label": p11,
                                    rel: c11
                                }, this.getEventListener(this.handlePreviousPage)), i11)), this.pagination(), react__WEBPACK_IMPORTED_MODULE_0___default().createElement("li", {
                                    className: C11
                                }, react__WEBPACK_IMPORTED_MODULE_0___default().createElement("a", _extends({
                                    className: m11,
                                    href: this.getElementHref(E11 + 1),
                                    tabIndex: y11 ? "-1" : "0",
                                    role: "button",
                                    onKeyPress: this.handleNextPage,
                                    "aria-disabled": h11,
                                    "aria-label": g11,
                                    rel: P11
                                }, this.getEventListener(this.handleNextPage)), d11)));
                            }
                        },
                        {
                            key: "__reactstandin__regenerateByEval",
                            value: function __reactstandin__regenerateByEval(key, code) {
                                this[key] = eval(code);
                            }
                        }
                    ]), PaginationBoxView;
                }(react__WEBPACK_IMPORTED_MODULE_0__.Component), reactHotLoader, leaveModule;
                _defineProperty(PaginationBoxView, "propTypes", {
                    pageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number.isRequired,
                    pageRangeDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    marginPagesDisplayed: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    previousLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
                    previousAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    prevPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    prevRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().node,
                    nextAriaLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakLabel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().oneOfType([
                        prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                        prop_types__WEBPACK_IMPORTED_MODULE_1___default().node
                    ]),
                    hrefBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    hrefAllControls: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
                    onPageChange: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    onPageActive: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    onClick: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    initialPage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    forcePage: prop_types__WEBPACK_IMPORTED_MODULE_1___default().number,
                    disableInitialCallback: prop_types__WEBPACK_IMPORTED_MODULE_1___default().bool,
                    containerClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    className: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    pageLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    activeClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    activeLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    previousClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    previousLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    nextLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    disabledClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    disabledLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    breakLinkClassName: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    extraAriaContext: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    ariaLabelBuilder: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    eventListener: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string,
                    renderOnZeroPageCount: prop_types__WEBPACK_IMPORTED_MODULE_1___default().func,
                    selectedPageRel: prop_types__WEBPACK_IMPORTED_MODULE_1___default().string
                }), _defineProperty(PaginationBoxView, "defaultProps", {
                    pageRangeDisplayed: 2,
                    marginPagesDisplayed: 3,
                    activeClassName: "selected",
                    previousLabel: "Previous",
                    previousClassName: "previous",
                    previousAriaLabel: "Previous page",
                    prevPageRel: "prev",
                    prevRel: "prev",
                    nextLabel: "Next",
                    nextClassName: "next",
                    nextAriaLabel: "Next page",
                    nextPageRel: "next",
                    nextRel: "next",
                    breakLabel: "...",
                    disabledClassName: "disabled",
                    disableInitialCallback: !1,
                    pageLabelBuilder: function(e11) {
                        return e11;
                    },
                    eventListener: "onClick",
                    renderOnZeroPageCount: void 0,
                    selectedPageRel: "canonical",
                    hrefAllControls: !1
                }), reactHotLoader = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0, reactHotLoader && reactHotLoader.register(PaginationBoxView, "PaginationBoxView", "/home/yoan/work/oss/react-paginate/react_components/PaginationBoxView.js"), leaveModule = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0, leaveModule && leaveModule(module);
            },
            351: (e11, t11, a11)=>{
                "use strict";
                a11.r(t11), a11.d(t11, {
                    default: ()=>n11
                });
                var r11, o11 = a11(214);
                e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature;
                var _11 = o11.Z;
                const n11 = _11;
                var i11, s11;
                (i11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && i11.register(_11, "default", "/home/yoan/work/oss/react-paginate/react_components/index.js"), (s11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && s11(e11);
            },
            923: (e11, t11, a11)=>{
                "use strict";
                var r11, o11, _11;
                function n11(e11) {
                    var t11 = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
                    return null != e11 ? e11 : t11;
                }
                a11.d(t11, {
                    m: ()=>n11
                }), e11 = a11.hmd(e11), (r11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.enterModule : void 0) && r11(e11), "undefined" != typeof reactHotLoaderGlobal && reactHotLoaderGlobal.default.signature, (o11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.default : void 0) && o11.register(n11, "classNameIfDefined", "/home/yoan/work/oss/react-paginate/react_components/utils.js"), (_11 = "undefined" != typeof reactHotLoaderGlobal ? reactHotLoaderGlobal.leaveModule : void 0) && _11(e11);
            },
            703: (e11, t11, a11)=>{
                "use strict";
                var r11 = a11(414);
                function o11() {}
                function _11() {}
                _11.resetWarningCache = o11, e11.exports = function() {
                    function e11(e11, t11, a11, o11, _11, n11) {
                        if (n11 !== r11) {
                            var i11 = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                            throw i11.name = "Invariant Violation", i11;
                        }
                    }
                    function t11() {
                        return e11;
                    }
                    e11.isRequired = e11;
                    var a11 = {
                        array: e11,
                        bool: e11,
                        func: e11,
                        number: e11,
                        object: e11,
                        string: e11,
                        symbol: e11,
                        any: e11,
                        arrayOf: t11,
                        element: e11,
                        elementType: e11,
                        instanceOf: t11,
                        node: e11,
                        objectOf: t11,
                        oneOf: t11,
                        oneOfType: t11,
                        shape: t11,
                        exact: t11,
                        checkPropTypes: _11,
                        resetWarningCache: o11
                    };
                    return a11.PropTypes = a11, a11;
                };
            },
            697: (e11, t11, a11)=>{
                e11.exports = a11(703)();
            },
            414: (e11)=>{
                "use strict";
                e11.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
            },
            98: (e11)=>{
                "use strict";
                e11.exports = __WEBPACK_EXTERNAL_MODULE__98__;
            }
        }, __webpack_module_cache__ = {};
        function __webpack_require__(e11) {
            var t11 = __webpack_module_cache__[e11];
            if (void 0 !== t11) return t11.exports;
            var a11 = __webpack_module_cache__[e11] = {
                id: e11,
                loaded: !1,
                exports: {}
            };
            return __webpack_modules__[e11](a11, a11.exports, __webpack_require__), a11.loaded = !0, a11.exports;
        }
        __webpack_require__.n = (e11)=>{
            var t11 = e11 && e11.__esModule ? ()=>e11.default : ()=>e11;
            return __webpack_require__.d(t11, {
                a: t11
            }), t11;
        }, __webpack_require__.d = (e11, t11)=>{
            for(var a11 in t11)__webpack_require__.o(t11, a11) && !__webpack_require__.o(e11, a11) && Object.defineProperty(e11, a11, {
                enumerable: !0,
                get: t11[a11]
            });
        }, __webpack_require__.hmd = (e11)=>((e11 = Object.create(e11)).children || (e11.children = []), Object.defineProperty(e11, "exports", {
                enumerable: !0,
                set: ()=>{
                    throw new Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + e11.id);
                }
            }), e11), __webpack_require__.o = (e11, t11)=>Object.prototype.hasOwnProperty.call(e11, t11), __webpack_require__.r = (e11)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e11, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e11, "__esModule", {
                value: !0
            });
        };
        var __webpack_exports__ = __webpack_require__(351);
        return __webpack_exports__;
    })();
});

});

parcelRequire.register("5P1O9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2779918e6847dbd7$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $NIlA2 = parcelRequire("NIlA2");
function $2779918e6847dbd7$var$Switch({ label: label, hasError: hasError, ...rest }, ref) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($NIlA2.wrapper, hasError && $NIlA2.error),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $NIlA2.label,
                children: label
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("label", {
                className: $NIlA2.switch,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                        type: "checkbox",
                        ...rest,
                        ref: ref
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $NIlA2.slider
                    })
                ]
            })
        ]
    });
}
var $2779918e6847dbd7$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($2779918e6847dbd7$var$Switch);

});
parcelRequire.register("NIlA2", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $0956fa1f307ae8e9$export$a3bc9b8ed74fc; }, function (v) { return $0956fa1f307ae8e9$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "label", function () { return $0956fa1f307ae8e9$export$1237798dc640739a; }, function (v) { return $0956fa1f307ae8e9$export$1237798dc640739a = v; });
$parcel$export(module.exports, "slider", function () { return $0956fa1f307ae8e9$export$b38bf4f33e9e4c25; }, function (v) { return $0956fa1f307ae8e9$export$b38bf4f33e9e4c25 = v; });
$parcel$export(module.exports, "switch", function () { return $0956fa1f307ae8e9$export$52002a3975269b5d; }, function (v) { return $0956fa1f307ae8e9$export$52002a3975269b5d = v; });
$parcel$export(module.exports, "wrapper", function () { return $0956fa1f307ae8e9$export$cc74dcc53cfce4eb; }, function (v) { return $0956fa1f307ae8e9$export$cc74dcc53cfce4eb = v; });
var $0956fa1f307ae8e9$export$a3bc9b8ed74fc;
var $0956fa1f307ae8e9$export$1237798dc640739a;
var $0956fa1f307ae8e9$export$bfd64c937657f93a;
var $0956fa1f307ae8e9$export$4a6dd88bada4e7d2;
var $0956fa1f307ae8e9$export$b38bf4f33e9e4c25;
var $0956fa1f307ae8e9$export$52002a3975269b5d;
var $0956fa1f307ae8e9$export$cc74dcc53cfce4eb;
$0956fa1f307ae8e9$export$a3bc9b8ed74fc = `zyS_Na_error`;
$0956fa1f307ae8e9$export$1237798dc640739a = `zyS_Na_label`;
$0956fa1f307ae8e9$export$bfd64c937657f93a = `zyS_Na_rotating`;
$0956fa1f307ae8e9$export$4a6dd88bada4e7d2 = `zyS_Na_shimmer`;
$0956fa1f307ae8e9$export$b38bf4f33e9e4c25 = `zyS_Na_slider`;
$0956fa1f307ae8e9$export$52002a3975269b5d = `zyS_Na_switch`;
$0956fa1f307ae8e9$export$cc74dcc53cfce4eb = `zyS_Na_wrapper`;

});


parcelRequire.register("iiBsj", function(module, exports) {

$parcel$export(module.exports, "openIdProviderConfigPath", function () { return $8cc3f3b698e23e2a$export$e42f7220a2289cdf; });
const $8cc3f3b698e23e2a$export$e42f7220a2289cdf = "oidc/.well-known/openid-configuration";

});

parcelRequire.register("1r8cJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $718e02a1aed28c8e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $dADBR = parcelRequire("dADBR");

var $clyod = parcelRequire("clyod");

var $476a8 = parcelRequire("476a8");
function $718e02a1aed28c8e$var$MultiTextInputField({ title: title, isRequired: isRequired, tip: tip, formFieldClassName: formFieldClassName, value: value, ...rest }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
        title: title,
        isRequired: isRequired,
        tip: tip,
        className: formFieldClassName,
        headlineClassName: (0, $5CQIb.conditional)(value && value.length > 1 && $476a8.headlineWithMultiInputs),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $clyod.default), {
            title: title,
            value: value,
            ...rest
        })
    });
}
var $718e02a1aed28c8e$export$2e2bcd8739ae039 = $718e02a1aed28c8e$var$MultiTextInputField;

});
parcelRequire.register("clyod", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e22ed7b513a8af0e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $ecDp6 = parcelRequire("ecDp6");

var $gCKnS = parcelRequire("gCKnS");

var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");

var $hdJkM = parcelRequire("hdJkM");

var $7jAvm = parcelRequire("7jAvm");
function $e22ed7b513a8af0e$var$MultiTextInput({ title: title, value: value, onChange: onChange, onKeyPress: onKeyPress, error: error, placeholder: placeholder, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [deleteFieldIndex, setDeleteFieldIndex] = (0, $eCoWV.useState)();
    const fields = (0, $eCoWV.useMemo)(()=>{
        if (!value?.length) return [
            ""
        ];
        return value;
    }, [
        value
    ]);
    const handleAdd = ()=>{
        onChange([
            ...fields,
            ""
        ]);
    };
    const handleRemove = (index)=>{
        onChange(fields.filter((_, i)=>i !== index));
    };
    const handleInputChange = (inputValue, index)=>{
        onChange(fields.map((fieldValue, i)=>i === index ? inputValue : fieldValue));
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7jAvm.multilineInput, className),
        children: [
            fields.map((fieldValue, fieldIndex)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: (0, $5CQIb.conditional)(fields.length > 1 && fieldIndex === 0 && $7jAvm.firstFieldWithMultiInputs),
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $7jAvm.deletableInput,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    error: Boolean(error?.inputs?.[fieldIndex] ?? (fieldIndex === 0 && error?.required)),
                                    value: fieldValue,
                                    placeholder: placeholder,
                                    onChange: ({ currentTarget: { value: value } })=>{
                                        handleInputChange(value, fieldIndex);
                                    },
                                    onKeyPress: onKeyPress
                                }),
                                fieldIndex > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        if (fieldValue.trim().length === 0) handleRemove(fieldIndex);
                                        else setDeleteFieldIndex(fieldIndex);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $gCKnS.default), {
                                        className: $7jAvm.minusIcon
                                    })
                                })
                            ]
                        }),
                        fieldIndex === 0 && error?.required && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $7jAvm.error,
                            children: error.required
                        }),
                        error?.inputs?.[fieldIndex] && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $7jAvm.error,
                            children: error.inputs[fieldIndex]
                        })
                    ]
                }, fieldIndex)),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "small",
                type: "text",
                title: "general.add_another",
                className: $7jAvm.addAnother,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {}),
                onClick: handleAdd
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: deleteFieldIndex !== undefined,
                confirmButtonText: "general.delete",
                onCancel: ()=>{
                    setDeleteFieldIndex(undefined);
                },
                onConfirm: ()=>{
                    if (deleteFieldIndex !== undefined) {
                        handleRemove(deleteFieldIndex);
                        setDeleteFieldIndex(undefined);
                    }
                },
                children: t("general.deletion_confirmation", {
                    title: t(title)
                })
            })
        ]
    });
}
var $e22ed7b513a8af0e$export$2e2bcd8739ae039 = $e22ed7b513a8af0e$var$MultiTextInput;

});
parcelRequire.register("ecDp6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a1214296d75c6f7e$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a1214296d75c6f7e$var$SvgCirclePlus = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8 1.333a6.667 6.667 0 1 0 0 13.334A6.667 6.667 0 0 0 8 1.333Zm0 12A5.333 5.333 0 1 1 8 2.668a5.333 5.333 0 0 1 0 10.665Zm2.667-6h-2v-2a.667.667 0 0 0-1.334 0v2h-2a.667.667 0 0 0 0 1.334h2v2a.667.667 0 1 0 1.334 0v-2h2a.667.667 0 1 0 0-1.334Z",
            fill: "currentColor"
        })
    });
var $a1214296d75c6f7e$export$2e2bcd8739ae039 = $a1214296d75c6f7e$var$SvgCirclePlus;

});

parcelRequire.register("gCKnS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $691e179966812c90$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $691e179966812c90$var$SvgMinus = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15a6.666 6.666 0 1 1 0-13.333 6.666 6.666 0 0 1 0 13.333Zm3.333-7.5H6.667a.833.833 0 1 0 0 1.666h6.666a.834.834 0 0 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $691e179966812c90$export$2e2bcd8739ae039 = $691e179966812c90$var$SvgMinus;

});

parcelRequire.register("hdJkM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $708fb06dfab964d9$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $40c6p = parcelRequire("40c6p");

var $kzmMx = parcelRequire("kzmMx");

var $9bgsA = parcelRequire("9bgsA");

var $iucdC = parcelRequire("iucdC");
function $708fb06dfab964d9$var$TextInput({ error: error, icon: icon, suffix: suffix, alwaysShowSuffix: alwaysShowSuffix = false, disabled: disabled, className: className, readOnly: readOnly, type: type = "text", isConfidential: isConfidential = false, ...rest }, reference) {
    const innerRef = (0, $eCoWV.useRef)(null);
    const [isContentHidden, setIsContentHidden] = (0, $eCoWV.useState)(true);
    const toggleHiddenContent = ()=>{
        setIsContentHidden((previous)=>!previous);
    };
    const suffixIcon = isConfidential && type === "text" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
        onClick: toggleHiddenContent,
        children: isContentHidden ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $40c6p.default), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kzmMx.default), {})
    }) : suffix;
    (0, $eCoWV.useImperativeHandle)(reference, ()=>innerRef.current);
    (0, $eCoWV.useEffect)(()=>{
        if (type !== "number") return;
        const input = innerRef.current;
        if (!input) return;
        const handleWheel = (event)=>{
            event.preventDefault();
        };
        input.addEventListener("wheel", handleWheel, {
            passive: false
        });
        return ()=>{
            input.removeEventListener("wheel", handleWheel);
        };
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($iucdC.container, Boolean(error) && $iucdC.error, isConfidential && isContentHidden && type === "text" && $iucdC.hideTextContainerContent, icon && $iucdC.withIcon, disabled && $iucdC.disabled, readOnly && $iucdC.readOnly),
                children: [
                    icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $iucdC.icon,
                        children: icon
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                        type: type,
                        ...rest,
                        ref: innerRef,
                        disabled: disabled,
                        readOnly: readOnly
                    }),
                    suffixIcon && /*#__PURE__*/ (0, $eCoWV.cloneElement)(suffixIcon, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(// Handle by classNames
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        suffixIcon.props.className, $iucdC.suffix, alwaysShowSuffix && $iucdC.visible)
                    })
                ]
            }),
            Boolean(error) && typeof error === "string" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $iucdC.errorMessage,
                children: error
            })
        ]
    });
}
var $708fb06dfab964d9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($708fb06dfab964d9$var$TextInput);

});
parcelRequire.register("iucdC", function(module, exports) {

$parcel$export(module.exports, "container", function () { return $d75481b585a984fb$export$34e0f9847d4c02dd; }, function (v) { return $d75481b585a984fb$export$34e0f9847d4c02dd = v; });
$parcel$export(module.exports, "disabled", function () { return $d75481b585a984fb$export$683472f6198a076e; }, function (v) { return $d75481b585a984fb$export$683472f6198a076e = v; });
$parcel$export(module.exports, "error", function () { return $d75481b585a984fb$export$a3bc9b8ed74fc; }, function (v) { return $d75481b585a984fb$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "errorMessage", function () { return $d75481b585a984fb$export$493b5823483d2c4e; }, function (v) { return $d75481b585a984fb$export$493b5823483d2c4e = v; });
$parcel$export(module.exports, "hideTextContainerContent", function () { return $d75481b585a984fb$export$acecdc67b371cf39; }, function (v) { return $d75481b585a984fb$export$acecdc67b371cf39 = v; });
$parcel$export(module.exports, "icon", function () { return $d75481b585a984fb$export$1ca1ec8b29a4ce27; }, function (v) { return $d75481b585a984fb$export$1ca1ec8b29a4ce27 = v; });
$parcel$export(module.exports, "readOnly", function () { return $d75481b585a984fb$export$b2cbc93d4da94977; }, function (v) { return $d75481b585a984fb$export$b2cbc93d4da94977 = v; });
$parcel$export(module.exports, "suffix", function () { return $d75481b585a984fb$export$559d1204393b53b9; }, function (v) { return $d75481b585a984fb$export$559d1204393b53b9 = v; });
$parcel$export(module.exports, "visible", function () { return $d75481b585a984fb$export$664c6d24e3175067; }, function (v) { return $d75481b585a984fb$export$664c6d24e3175067 = v; });
$parcel$export(module.exports, "withIcon", function () { return $d75481b585a984fb$export$5146850fc0ce88d1; }, function (v) { return $d75481b585a984fb$export$5146850fc0ce88d1 = v; });
var $d75481b585a984fb$export$34e0f9847d4c02dd;
var $d75481b585a984fb$export$683472f6198a076e;
var $d75481b585a984fb$export$a3bc9b8ed74fc;
var $d75481b585a984fb$export$493b5823483d2c4e;
var $d75481b585a984fb$export$acecdc67b371cf39;
var $d75481b585a984fb$export$1ca1ec8b29a4ce27;
var $d75481b585a984fb$export$b2cbc93d4da94977;
var $d75481b585a984fb$export$bfd64c937657f93a;
var $d75481b585a984fb$export$4a6dd88bada4e7d2;
var $d75481b585a984fb$export$559d1204393b53b9;
var $d75481b585a984fb$export$664c6d24e3175067;
var $d75481b585a984fb$export$5146850fc0ce88d1;
$d75481b585a984fb$export$34e0f9847d4c02dd = `NBDOhG_container`;
$d75481b585a984fb$export$683472f6198a076e = `NBDOhG_disabled`;
$d75481b585a984fb$export$a3bc9b8ed74fc = `NBDOhG_error`;
$d75481b585a984fb$export$493b5823483d2c4e = `NBDOhG_errorMessage`;
$d75481b585a984fb$export$acecdc67b371cf39 = `NBDOhG_hideTextContainerContent`;
$d75481b585a984fb$export$1ca1ec8b29a4ce27 = `NBDOhG_icon`;
$d75481b585a984fb$export$b2cbc93d4da94977 = `NBDOhG_readOnly`;
$d75481b585a984fb$export$bfd64c937657f93a = `NBDOhG_rotating`;
$d75481b585a984fb$export$4a6dd88bada4e7d2 = `NBDOhG_shimmer`;
$d75481b585a984fb$export$559d1204393b53b9 = `NBDOhG_suffix`;
$d75481b585a984fb$export$664c6d24e3175067 = `NBDOhG_visible`;
$d75481b585a984fb$export$5146850fc0ce88d1 = `NBDOhG_withIcon`;

});


parcelRequire.register("7jAvm", function(module, exports) {

$parcel$export(module.exports, "addAnother", function () { return $55369fda87ac0b9b$export$ae5f3242c350d062; }, function (v) { return $55369fda87ac0b9b$export$ae5f3242c350d062 = v; });
$parcel$export(module.exports, "deletableInput", function () { return $55369fda87ac0b9b$export$3713a8a23d31e5bc; }, function (v) { return $55369fda87ac0b9b$export$3713a8a23d31e5bc = v; });
$parcel$export(module.exports, "error", function () { return $55369fda87ac0b9b$export$a3bc9b8ed74fc; }, function (v) { return $55369fda87ac0b9b$export$a3bc9b8ed74fc = v; });
$parcel$export(module.exports, "firstFieldWithMultiInputs", function () { return $55369fda87ac0b9b$export$79c35e03af0143d8; }, function (v) { return $55369fda87ac0b9b$export$79c35e03af0143d8 = v; });
$parcel$export(module.exports, "minusIcon", function () { return $55369fda87ac0b9b$export$d46bbadf149c347; }, function (v) { return $55369fda87ac0b9b$export$d46bbadf149c347 = v; });
$parcel$export(module.exports, "multilineInput", function () { return $55369fda87ac0b9b$export$d3195581be2dd5a6; }, function (v) { return $55369fda87ac0b9b$export$d3195581be2dd5a6 = v; });
var $55369fda87ac0b9b$export$ae5f3242c350d062;
var $55369fda87ac0b9b$export$3713a8a23d31e5bc;
var $55369fda87ac0b9b$export$a3bc9b8ed74fc;
var $55369fda87ac0b9b$export$79c35e03af0143d8;
var $55369fda87ac0b9b$export$d46bbadf149c347;
var $55369fda87ac0b9b$export$d3195581be2dd5a6;
var $55369fda87ac0b9b$export$bfd64c937657f93a;
var $55369fda87ac0b9b$export$4a6dd88bada4e7d2;
$55369fda87ac0b9b$export$ae5f3242c350d062 = `SGS0fW_addAnother`;
$55369fda87ac0b9b$export$3713a8a23d31e5bc = `SGS0fW_deletableInput`;
$55369fda87ac0b9b$export$a3bc9b8ed74fc = `SGS0fW_error`;
$55369fda87ac0b9b$export$79c35e03af0143d8 = `SGS0fW_firstFieldWithMultiInputs`;
$55369fda87ac0b9b$export$d46bbadf149c347 = `SGS0fW_minusIcon`;
$55369fda87ac0b9b$export$d3195581be2dd5a6 = `SGS0fW_multilineInput`;
$55369fda87ac0b9b$export$bfd64c937657f93a = `SGS0fW_rotating`;
$55369fda87ac0b9b$export$4a6dd88bada4e7d2 = `SGS0fW_shimmer`;

});


parcelRequire.register("476a8", function(module, exports) {

$parcel$export(module.exports, "headlineWithMultiInputs", function () { return $2fec98982006d209$export$798dd543c49d0534; }, function (v) { return $2fec98982006d209$export$798dd543c49d0534 = v; });
var $2fec98982006d209$export$798dd543c49d0534;
var $2fec98982006d209$export$bfd64c937657f93a;
var $2fec98982006d209$export$4a6dd88bada4e7d2;
$2fec98982006d209$export$798dd543c49d0534 = `_5hpe_G_headlineWithMultiInputs`;
$2fec98982006d209$export$bfd64c937657f93a = `_5hpe_G_rotating`;
$2fec98982006d209$export$4a6dd88bada4e7d2 = `_5hpe_G_shimmer`;

});


parcelRequire.register("9e9DZ", function(module, exports) {

$parcel$export(module.exports, "createValidatorForRhf", function () { return $6577d266e9e257b5$export$92194fc0a16d24c0; });
$parcel$export(module.exports, "convertRhfErrorMessage", function () { return $6577d266e9e257b5$export$be179235d87a3746; });

var $awn06 = parcelRequire("awn06");

var $5a1Rp = parcelRequire("5a1Rp");

var $aomPH = parcelRequire("aomPH");
const $6577d266e9e257b5$var$validate = (value, rule)=>{
    if (!rule) return;
    if (!value?.filter(Boolean).length) {
        if (!rule.required) return;
        return {
            required: rule.required
        };
    }
    if (rule.pattern) {
        const { verify: verify, message: message } = rule.pattern;
        const inputErrors = Object.fromEntries(value.map((element, index)=>{
            return [
                index,
                verify(element) ? undefined : message
            ];
        }));
        if (Object.values(inputErrors).some(Boolean)) return {
            inputs: inputErrors
        };
    }
};
const $6577d266e9e257b5$export$92194fc0a16d24c0 = (rule)=>(value)=>{
        const error = $6577d266e9e257b5$var$validate(value, rule);
        if (error) return JSON.stringify(error);
        return true;
    };
const $6577d266e9e257b5$export$be179235d87a3746 = (errorMessage)=>{
    if (!errorMessage) return;
    const jsonParseResult = (0, $5a1Rp.safeParseJson)(errorMessage);
    if (!jsonParseResult.success) throw new Error((0, $awn06.t)("admin_console.errors.invalid_error_message_format"));
    const result = (0, $aomPH.multiTextInputErrorGuard).safeParse(jsonParseResult.data);
    if (!result.success) throw new Error((0, $awn06.t)("admin_console.errors.invalid_error_message_format"));
    return result.data;
};

});
parcelRequire.register("awn06", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7a8ebbf8c1ca7490$export$2e2bcd8739ae039; });
$parcel$export(module.exports, "t", function () { return $7a8ebbf8c1ca7490$export$625550452a3fa3ec; });

var $f6w4m = parcelRequire("f6w4m");

var $gfYX1 = parcelRequire("gfYX1");

var $gvD6c = parcelRequire("gvD6c");

var $3HF2X = parcelRequire("3HF2X");

var $e4x4Z = parcelRequire("e4x4Z");

var $7bpic = parcelRequire("7bpic");

var $33hvv = parcelRequire("33hvv");

var $cAQCs = parcelRequire("cAQCs");

var $dUY9h = parcelRequire("dUY9h");
function $7a8ebbf8c1ca7490$var$ownKeys$6(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$6(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$6(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$6(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $7a8ebbf8c1ca7490$var$consoleLogger = {
    type: "logger",
    log: function log(args) {
        this.output("log", args);
    },
    warn: function warn(args) {
        this.output("warn", args);
    },
    error: function error(args) {
        this.output("error", args);
    },
    output: function output(type, args) {
        if (console && console[type]) console[type].apply(console, args);
    }
};
var $7a8ebbf8c1ca7490$var$Logger = function() {
    function Logger(concreteLogger) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $gfYX1.default)(this, Logger);
        this.init(concreteLogger, options);
    }
    (0, $gvD6c.default)(Logger, [
        {
            key: "init",
            value: function init(concreteLogger) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                this.prefix = options.prefix || "i18next:";
                this.logger = concreteLogger || $7a8ebbf8c1ca7490$var$consoleLogger;
                this.options = options;
                this.debug = options.debug;
            }
        },
        {
            key: "setDebug",
            value: function setDebug(bool) {
                this.debug = bool;
            }
        },
        {
            key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return this.forward(args, "log", "", true);
            }
        },
        {
            key: "warn",
            value: function warn() {
                for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
                return this.forward(args, "warn", "", true);
            }
        },
        {
            key: "error",
            value: function error() {
                for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
                return this.forward(args, "error", "");
            }
        },
        {
            key: "deprecate",
            value: function deprecate() {
                for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
                return this.forward(args, "warn", "WARNING DEPRECATED: ", true);
            }
        },
        {
            key: "forward",
            value: function forward(args, lvl, prefix, debugOnly) {
                if (debugOnly && !this.debug) return null;
                if (typeof args[0] === "string") args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
                return this.logger[lvl](args);
            }
        },
        {
            key: "create",
            value: function create(moduleName) {
                return new Logger(this.logger, $7a8ebbf8c1ca7490$var$_objectSpread$6($7a8ebbf8c1ca7490$var$_objectSpread$6({}, {
                    prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
                }), this.options));
            }
        },
        {
            key: "clone",
            value: function clone(options) {
                options = options || this.options;
                options.prefix = options.prefix || this.prefix;
                return new Logger(this.logger, options);
            }
        }
    ]);
    return Logger;
}();
var $7a8ebbf8c1ca7490$var$baseLogger = new $7a8ebbf8c1ca7490$var$Logger();
var $7a8ebbf8c1ca7490$var$EventEmitter = function() {
    function EventEmitter() {
        (0, $gfYX1.default)(this, EventEmitter);
        this.observers = {};
    }
    (0, $gvD6c.default)(EventEmitter, [
        {
            key: "on",
            value: function on(events, listener) {
                var _this = this;
                events.split(" ").forEach(function(event) {
                    _this.observers[event] = _this.observers[event] || [];
                    _this.observers[event].push(listener);
                });
                return this;
            }
        },
        {
            key: "off",
            value: function off(event, listener) {
                if (!this.observers[event]) return;
                if (!listener) {
                    delete this.observers[event];
                    return;
                }
                this.observers[event] = this.observers[event].filter(function(l) {
                    return l !== listener;
                });
            }
        },
        {
            key: "emit",
            value: function emit(event) {
                for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                if (this.observers[event]) {
                    var cloned = [].concat(this.observers[event]);
                    cloned.forEach(function(observer) {
                        observer.apply(void 0, args);
                    });
                }
                if (this.observers["*"]) {
                    var _cloned = [].concat(this.observers["*"]);
                    _cloned.forEach(function(observer) {
                        observer.apply(observer, [
                            event
                        ].concat(args));
                    });
                }
            }
        }
    ]);
    return EventEmitter;
}();
function $7a8ebbf8c1ca7490$var$defer() {
    var res;
    var rej;
    var promise = new Promise(function(resolve, reject) {
        res = resolve;
        rej = reject;
    });
    promise.resolve = res;
    promise.reject = rej;
    return promise;
}
function $7a8ebbf8c1ca7490$var$makeString(object) {
    if (object == null) return "";
    return "" + object;
}
function $7a8ebbf8c1ca7490$var$copy(a, s, t) {
    a.forEach(function(m) {
        if (s[m]) t[m] = s[m];
    });
}
function $7a8ebbf8c1ca7490$var$getLastOfPath(object, path, Empty) {
    function cleanKey(key) {
        return key && key.indexOf("###") > -1 ? key.replace(/###/g, ".") : key;
    }
    function canNotTraverseDeeper() {
        return !object || typeof object === "string";
    }
    var stack = typeof path !== "string" ? [].concat(path) : path.split(".");
    while(stack.length > 1){
        if (canNotTraverseDeeper()) return {};
        var key = cleanKey(stack.shift());
        if (!object[key] && Empty) object[key] = new Empty();
        if (Object.prototype.hasOwnProperty.call(object, key)) object = object[key];
        else object = {};
    }
    if (canNotTraverseDeeper()) return {};
    return {
        obj: object,
        k: cleanKey(stack.shift())
    };
}
function $7a8ebbf8c1ca7490$var$setPath(object, path, newValue) {
    var _getLastOfPath = $7a8ebbf8c1ca7490$var$getLastOfPath(object, path, Object), obj = _getLastOfPath.obj, k = _getLastOfPath.k;
    obj[k] = newValue;
}
function $7a8ebbf8c1ca7490$var$pushPath(object, path, newValue, concat) {
    var _getLastOfPath2 = $7a8ebbf8c1ca7490$var$getLastOfPath(object, path, Object), obj = _getLastOfPath2.obj, k = _getLastOfPath2.k;
    obj[k] = obj[k] || [];
    if (concat) obj[k] = obj[k].concat(newValue);
    if (!concat) obj[k].push(newValue);
}
function $7a8ebbf8c1ca7490$var$getPath(object, path) {
    var _getLastOfPath3 = $7a8ebbf8c1ca7490$var$getLastOfPath(object, path), obj = _getLastOfPath3.obj, k = _getLastOfPath3.k;
    if (!obj) return undefined;
    return obj[k];
}
function $7a8ebbf8c1ca7490$var$getPathWithDefaults(data, defaultData, key) {
    var value = $7a8ebbf8c1ca7490$var$getPath(data, key);
    if (value !== undefined) return value;
    return $7a8ebbf8c1ca7490$var$getPath(defaultData, key);
}
function $7a8ebbf8c1ca7490$var$deepExtend(target, source, overwrite) {
    for(var prop in source)if (prop !== "__proto__" && prop !== "constructor") {
        if (prop in target) {
            if (typeof target[prop] === "string" || target[prop] instanceof String || typeof source[prop] === "string" || source[prop] instanceof String) {
                if (overwrite) target[prop] = source[prop];
            } else $7a8ebbf8c1ca7490$var$deepExtend(target[prop], source[prop], overwrite);
        } else target[prop] = source[prop];
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$regexEscape(str) {
    return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
}
var $7a8ebbf8c1ca7490$var$_entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
};
function $7a8ebbf8c1ca7490$var$escape(data) {
    if (typeof data === "string") return data.replace(/[&<>"'\/]/g, function(s) {
        return $7a8ebbf8c1ca7490$var$_entityMap[s];
    });
    return data;
}
var $7a8ebbf8c1ca7490$var$isIE10 = typeof window !== "undefined" && window.navigator && typeof window.navigator.userAgentData === "undefined" && window.navigator.userAgent && window.navigator.userAgent.indexOf("MSIE") > -1;
var $7a8ebbf8c1ca7490$var$chars = [
    " ",
    ",",
    "?",
    "!",
    ";"
];
function $7a8ebbf8c1ca7490$var$looksLikeObjectPath(key, nsSeparator, keySeparator) {
    nsSeparator = nsSeparator || "";
    keySeparator = keySeparator || "";
    var possibleChars = $7a8ebbf8c1ca7490$var$chars.filter(function(c) {
        return nsSeparator.indexOf(c) < 0 && keySeparator.indexOf(c) < 0;
    });
    if (possibleChars.length === 0) return true;
    var r = new RegExp("(".concat(possibleChars.map(function(c) {
        return c === "?" ? "\\?" : c;
    }).join("|"), ")"));
    var matched = !r.test(key);
    if (!matched) {
        var ki = key.indexOf(keySeparator);
        if (ki > 0 && !r.test(key.substring(0, ki))) matched = true;
    }
    return matched;
}
function $7a8ebbf8c1ca7490$var$deepFind(obj, path) {
    var keySeparator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ".";
    if (!obj) return undefined;
    if (obj[path]) return obj[path];
    var paths = path.split(keySeparator);
    var current = obj;
    for(var i = 0; i < paths.length; ++i){
        if (!current) return undefined;
        if (typeof current[paths[i]] === "string" && i + 1 < paths.length) return undefined;
        if (current[paths[i]] === undefined) {
            var j = 2;
            var p = paths.slice(i, i + j).join(keySeparator);
            var mix = current[p];
            while(mix === undefined && paths.length > i + j){
                j++;
                p = paths.slice(i, i + j).join(keySeparator);
                mix = current[p];
            }
            if (mix === undefined) return undefined;
            if (mix === null) return null;
            if (path.endsWith(p)) {
                if (typeof mix === "string") return mix;
                if (p && typeof mix[p] === "string") return mix[p];
            }
            var joinedPath = paths.slice(i + j).join(keySeparator);
            if (joinedPath) return $7a8ebbf8c1ca7490$var$deepFind(mix, joinedPath, keySeparator);
            return undefined;
        }
        current = current[paths[i]];
    }
    return current;
}
function $7a8ebbf8c1ca7490$var$ownKeys$5(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$5(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$5(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$5(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$_createSuper$3(Derived) {
    var hasNativeReflectConstruct = $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$3();
    return function _createSuperInternal() {
        var Super = (0, $33hvv.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $33hvv.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $7bpic.default)(this, result);
    };
}
function $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$3() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $7a8ebbf8c1ca7490$var$ResourceStore = function(_EventEmitter) {
    (0, $e4x4Z.default)(ResourceStore, _EventEmitter);
    var _super = $7a8ebbf8c1ca7490$var$_createSuper$3(ResourceStore);
    function ResourceStore(data) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
            ns: [
                "translation"
            ],
            defaultNS: "translation"
        };
        (0, $gfYX1.default)(this, ResourceStore);
        _this = _super.call(this);
        if ($7a8ebbf8c1ca7490$var$isIE10) $7a8ebbf8c1ca7490$var$EventEmitter.call((0, $3HF2X.default)(_this));
        _this.data = data || {};
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        if (_this.options.ignoreJSONStructure === undefined) _this.options.ignoreJSONStructure = true;
        return _this;
    }
    (0, $gvD6c.default)(ResourceStore, [
        {
            key: "addNamespaces",
            value: function addNamespaces(ns) {
                if (this.options.ns.indexOf(ns) < 0) this.options.ns.push(ns);
            }
        },
        {
            key: "removeNamespaces",
            value: function removeNamespaces(ns) {
                var index = this.options.ns.indexOf(ns);
                if (index > -1) this.options.ns.splice(index, 1);
            }
        },
        {
            key: "getResource",
            value: function getResource(lng, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var ignoreJSONStructure = options.ignoreJSONStructure !== undefined ? options.ignoreJSONStructure : this.options.ignoreJSONStructure;
                var path = [
                    lng,
                    ns
                ];
                if (key && typeof key !== "string") path = path.concat(key);
                if (key && typeof key === "string") path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) path = lng.split(".");
                var result = $7a8ebbf8c1ca7490$var$getPath(this.data, path);
                if (result || !ignoreJSONStructure || typeof key !== "string") return result;
                return $7a8ebbf8c1ca7490$var$deepFind(this.data && this.data[lng] && this.data[lng][ns], key, keySeparator);
            }
        },
        {
            key: "addResource",
            value: function addResource(lng, ns, key, value) {
                var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
                    silent: false
                };
                var keySeparator = this.options.keySeparator;
                if (keySeparator === undefined) keySeparator = ".";
                var path = [
                    lng,
                    ns
                ];
                if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    value = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                $7a8ebbf8c1ca7490$var$setPath(this.data, path, value);
                if (!options.silent) this.emit("added", lng, ns, key, value);
            }
        },
        {
            key: "addResources",
            value: function addResources(lng, ns, resources) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
                    silent: false
                };
                for(var m in resources)if (typeof resources[m] === "string" || Object.prototype.toString.apply(resources[m]) === "[object Array]") this.addResource(lng, ns, m, resources[m], {
                    silent: true
                });
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "addResourceBundle",
            value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
                    silent: false
                };
                var path = [
                    lng,
                    ns
                ];
                if (lng.indexOf(".") > -1) {
                    path = lng.split(".");
                    deep = resources;
                    resources = ns;
                    ns = path[1];
                }
                this.addNamespaces(ns);
                var pack = $7a8ebbf8c1ca7490$var$getPath(this.data, path) || {};
                if (deep) $7a8ebbf8c1ca7490$var$deepExtend(pack, resources, overwrite);
                else pack = $7a8ebbf8c1ca7490$var$_objectSpread$5($7a8ebbf8c1ca7490$var$_objectSpread$5({}, pack), resources);
                $7a8ebbf8c1ca7490$var$setPath(this.data, path, pack);
                if (!options.silent) this.emit("added", lng, ns, resources);
            }
        },
        {
            key: "removeResourceBundle",
            value: function removeResourceBundle(lng, ns) {
                if (this.hasResourceBundle(lng, ns)) delete this.data[lng][ns];
                this.removeNamespaces(ns);
                this.emit("removed", lng, ns);
            }
        },
        {
            key: "hasResourceBundle",
            value: function hasResourceBundle(lng, ns) {
                return this.getResource(lng, ns) !== undefined;
            }
        },
        {
            key: "getResourceBundle",
            value: function getResourceBundle(lng, ns) {
                if (!ns) ns = this.options.defaultNS;
                if (this.options.compatibilityAPI === "v1") return $7a8ebbf8c1ca7490$var$_objectSpread$5($7a8ebbf8c1ca7490$var$_objectSpread$5({}, {}), this.getResource(lng, ns));
                return this.getResource(lng, ns);
            }
        },
        {
            key: "getDataByLanguage",
            value: function getDataByLanguage(lng) {
                return this.data[lng];
            }
        },
        {
            key: "hasLanguageSomeTranslations",
            value: function hasLanguageSomeTranslations(lng) {
                var data = this.getDataByLanguage(lng);
                var n = data && Object.keys(data) || [];
                return !!n.find(function(v) {
                    return data[v] && Object.keys(data[v]).length > 0;
                });
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return this.data;
            }
        }
    ]);
    return ResourceStore;
}($7a8ebbf8c1ca7490$var$EventEmitter);
var $7a8ebbf8c1ca7490$var$postProcessor = {
    processors: {},
    addPostProcessor: function addPostProcessor(module) {
        this.processors[module.name] = module;
    },
    handle: function handle(processors, value, key, options, translator) {
        var _this = this;
        processors.forEach(function(processor) {
            if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
        });
        return value;
    }
};
function $7a8ebbf8c1ca7490$var$ownKeys$4(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$4(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$4(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$4(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$_createSuper$2(Derived) {
    var hasNativeReflectConstruct = $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$2();
    return function _createSuperInternal() {
        var Super = (0, $33hvv.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $33hvv.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $7bpic.default)(this, result);
    };
}
function $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$2() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
var $7a8ebbf8c1ca7490$var$checkedLoadedFor = {};
var $7a8ebbf8c1ca7490$var$Translator = function(_EventEmitter) {
    (0, $e4x4Z.default)(Translator, _EventEmitter);
    var _super = $7a8ebbf8c1ca7490$var$_createSuper$2(Translator);
    function Translator(services) {
        var _this;
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $gfYX1.default)(this, Translator);
        _this = _super.call(this);
        if ($7a8ebbf8c1ca7490$var$isIE10) $7a8ebbf8c1ca7490$var$EventEmitter.call((0, $3HF2X.default)(_this));
        $7a8ebbf8c1ca7490$var$copy([
            "resourceStore",
            "languageUtils",
            "pluralResolver",
            "interpolator",
            "backendConnector",
            "i18nFormat",
            "utils"
        ], services, (0, $3HF2X.default)(_this));
        _this.options = options;
        if (_this.options.keySeparator === undefined) _this.options.keySeparator = ".";
        _this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("translator");
        return _this;
    }
    (0, $gvD6c.default)(Translator, [
        {
            key: "changeLanguage",
            value: function changeLanguage(lng) {
                if (lng) this.language = lng;
            }
        },
        {
            key: "exists",
            value: function exists(key) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                if (key === undefined || key === null) return false;
                var resolved = this.resolve(key, options);
                return resolved && resolved.res !== undefined;
            }
        },
        {
            key: "extractFromKey",
            value: function extractFromKey(key, options) {
                var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
                if (nsSeparator === undefined) nsSeparator = ":";
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var namespaces = options.ns || this.options.defaultNS || [];
                var wouldCheckForNsInKey = nsSeparator && key.indexOf(nsSeparator) > -1;
                var seemsNaturalLanguage = !this.options.userDefinedKeySeparator && !options.keySeparator && !this.options.userDefinedNsSeparator && !options.nsSeparator && !$7a8ebbf8c1ca7490$var$looksLikeObjectPath(key, nsSeparator, keySeparator);
                if (wouldCheckForNsInKey && !seemsNaturalLanguage) {
                    var m = key.match(this.interpolator.nestingRegexp);
                    if (m && m.length > 0) return {
                        key: key,
                        namespaces: namespaces
                    };
                    var parts = key.split(nsSeparator);
                    if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
                    key = parts.join(keySeparator);
                }
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                return {
                    key: key,
                    namespaces: namespaces
                };
            }
        },
        {
            key: "translate",
            value: function translate(keys, options, lastKey) {
                var _this2 = this;
                if ((0, $f6w4m.default)(options) !== "object" && this.options.overloadTranslationOptionHandler) options = this.options.overloadTranslationOptionHandler(arguments);
                if ((0, $f6w4m.default)(options) === "object") options = $7a8ebbf8c1ca7490$var$_objectSpread$4({}, options);
                if (!options) options = {};
                if (keys === undefined || keys === null) return "";
                if (!Array.isArray(keys)) keys = [
                    String(keys)
                ];
                var returnDetails = options.returnDetails !== undefined ? options.returnDetails : this.options.returnDetails;
                var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
                var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options), key = _this$extractFromKey.key, namespaces = _this$extractFromKey.namespaces;
                var namespace = namespaces[namespaces.length - 1];
                var lng = options.lng || this.language;
                var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
                if (lng && lng.toLowerCase() === "cimode") {
                    if (appendNamespaceToCIMode) {
                        var nsSeparator = options.nsSeparator || this.options.nsSeparator;
                        if (returnDetails) return {
                            res: "".concat(namespace).concat(nsSeparator).concat(key),
                            usedKey: key,
                            exactUsedKey: key,
                            usedLng: lng,
                            usedNS: namespace
                        };
                        return "".concat(namespace).concat(nsSeparator).concat(key);
                    }
                    if (returnDetails) return {
                        res: key,
                        usedKey: key,
                        exactUsedKey: key,
                        usedLng: lng,
                        usedNS: namespace
                    };
                    return key;
                }
                var resolved = this.resolve(keys, options);
                var res = resolved && resolved.res;
                var resUsedKey = resolved && resolved.usedKey || key;
                var resExactUsedKey = resolved && resolved.exactUsedKey || key;
                var resType = Object.prototype.toString.apply(res);
                var noObject = [
                    "[object Number]",
                    "[object Function]",
                    "[object RegExp]"
                ];
                var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
                var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
                var handleAsObject = typeof res !== "string" && typeof res !== "boolean" && typeof res !== "number";
                if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === "string" && resType === "[object Array]")) {
                    if (!options.returnObjects && !this.options.returnObjects) {
                        if (!this.options.returnedObjectHandler) this.logger.warn("accessing an object - but returnObjects options is not enabled!");
                        var r = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, options), {}, {
                            ns: namespaces
                        })) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
                        if (returnDetails) {
                            resolved.res = r;
                            return resolved;
                        }
                        return r;
                    }
                    if (keySeparator) {
                        var resTypeIsArray = resType === "[object Array]";
                        var copy = resTypeIsArray ? [] : {};
                        var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;
                        for(var m in res)if (Object.prototype.hasOwnProperty.call(res, m)) {
                            var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
                            copy[m] = this.translate(deepKey, $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, options), {
                                joinArrays: false,
                                ns: namespaces
                            }));
                            if (copy[m] === deepKey) copy[m] = res[m];
                        }
                        res = copy;
                    }
                } else if (handleAsObjectInI18nFormat && typeof joinArrays === "string" && resType === "[object Array]") {
                    res = res.join(joinArrays);
                    if (res) res = this.extendTranslation(res, keys, options, lastKey);
                } else {
                    var usedDefault = false;
                    var usedKey = false;
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var hasDefaultValue = Translator.hasDefaultValue(options);
                    var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count, options) : "";
                    var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;
                    if (!this.isValidLookup(res) && hasDefaultValue) {
                        usedDefault = true;
                        res = defaultValue;
                    }
                    if (!this.isValidLookup(res)) {
                        usedKey = true;
                        res = key;
                    }
                    var missingKeyNoValueFallbackToKey = options.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey;
                    var resForMissing = missingKeyNoValueFallbackToKey && usedKey ? undefined : res;
                    var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;
                    if (usedKey || usedDefault || updateMissing) {
                        this.logger.log(updateMissing ? "updateKey" : "missingKey", lng, namespace, key, updateMissing ? defaultValue : res);
                        if (keySeparator) {
                            var fk = this.resolve(key, $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, options), {}, {
                                keySeparator: false
                            }));
                            if (fk && fk.res) this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
                        }
                        var lngs = [];
                        var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);
                        if (this.options.saveMissingTo === "fallback" && fallbackLngs && fallbackLngs[0]) for(var i = 0; i < fallbackLngs.length; i++)lngs.push(fallbackLngs[i]);
                        else if (this.options.saveMissingTo === "all") lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
                        else lngs.push(options.lng || this.language);
                        var send = function send(l, k, specificDefaultValue) {
                            var defaultForMissing = hasDefaultValue && specificDefaultValue !== res ? specificDefaultValue : resForMissing;
                            if (_this2.options.missingKeyHandler) _this2.options.missingKeyHandler(l, namespace, k, defaultForMissing, updateMissing, options);
                            else if (_this2.backendConnector && _this2.backendConnector.saveMissing) _this2.backendConnector.saveMissing(l, namespace, k, defaultForMissing, updateMissing, options);
                            _this2.emit("missingKey", l, namespace, k, res);
                        };
                        if (this.options.saveMissing) {
                            if (this.options.saveMissingPlurals && needsPluralHandling) lngs.forEach(function(language) {
                                _this2.pluralResolver.getSuffixes(language, options).forEach(function(suffix) {
                                    send([
                                        language
                                    ], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                                });
                            });
                            else send(lngs, key, defaultValue);
                        }
                    }
                    res = this.extendTranslation(res, keys, options, resolved, lastKey);
                    if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
                    if ((usedKey || usedDefault) && this.options.parseMissingKeyHandler) {
                        if (this.options.compatibilityAPI !== "v1") res = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? "".concat(namespace, ":").concat(key) : key, usedDefault ? res : undefined);
                        else res = this.options.parseMissingKeyHandler(res);
                    }
                }
                if (returnDetails) {
                    resolved.res = res;
                    return resolved;
                }
                return res;
            }
        },
        {
            key: "extendTranslation",
            value: function extendTranslation(res, key, options, resolved, lastKey) {
                var _this3 = this;
                if (this.i18nFormat && this.i18nFormat.parse) res = this.i18nFormat.parse(res, $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), options), resolved.usedLng, resolved.usedNS, resolved.usedKey, {
                    resolved: resolved
                });
                else if (!options.skipInterpolation) {
                    if (options.interpolation) this.interpolator.init($7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, options), {
                        interpolation: $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, this.options.interpolation), options.interpolation)
                    }));
                    var skipOnVariables = typeof res === "string" && (options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
                    var nestBef;
                    if (skipOnVariables) {
                        var nb = res.match(this.interpolator.nestingRegexp);
                        nestBef = nb && nb.length;
                    }
                    var data = options.replace && typeof options.replace !== "string" ? options.replace : options;
                    if (this.options.interpolation.defaultVariables) data = $7a8ebbf8c1ca7490$var$_objectSpread$4($7a8ebbf8c1ca7490$var$_objectSpread$4({}, this.options.interpolation.defaultVariables), data);
                    res = this.interpolator.interpolate(res, data, options.lng || this.language, options);
                    if (skipOnVariables) {
                        var na = res.match(this.interpolator.nestingRegexp);
                        var nestAft = na && na.length;
                        if (nestBef < nestAft) options.nest = false;
                    }
                    if (!options.lng && this.options.compatibilityAPI !== "v1" && resolved && resolved.res) options.lng = resolved.usedLng;
                    if (options.nest !== false) res = this.interpolator.nest(res, function() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                        if (lastKey && lastKey[0] === args[0] && !options.context) {
                            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));
                            return null;
                        }
                        return _this3.translate.apply(_this3, args.concat([
                            key
                        ]));
                    }, options);
                    if (options.interpolation) this.interpolator.reset();
                }
                var postProcess = options.postProcess || this.options.postProcess;
                var postProcessorNames = typeof postProcess === "string" ? [
                    postProcess
                ] : postProcess;
                if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) res = $7a8ebbf8c1ca7490$var$postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? $7a8ebbf8c1ca7490$var$_objectSpread$4({
                    i18nResolved: resolved
                }, options) : options, this);
                return res;
            }
        },
        {
            key: "resolve",
            value: function resolve(keys) {
                var _this4 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var found;
                var usedKey;
                var exactUsedKey;
                var usedLng;
                var usedNS;
                if (typeof keys === "string") keys = [
                    keys
                ];
                keys.forEach(function(k) {
                    if (_this4.isValidLookup(found)) return;
                    var extracted = _this4.extractFromKey(k, options);
                    var key = extracted.key;
                    usedKey = key;
                    var namespaces = extracted.namespaces;
                    if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
                    var needsPluralHandling = options.count !== undefined && typeof options.count !== "string";
                    var needsZeroSuffixLookup = needsPluralHandling && !options.ordinal && options.count === 0 && _this4.pluralResolver.shouldUseIntlApi();
                    var needsContextHandling = options.context !== undefined && (typeof options.context === "string" || typeof options.context === "number") && options.context !== "";
                    var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
                    namespaces.forEach(function(ns) {
                        if (_this4.isValidLookup(found)) return;
                        usedNS = ns;
                        if (!$7a8ebbf8c1ca7490$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
                            $7a8ebbf8c1ca7490$var$checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;
                            _this4.logger.warn('key "'.concat(usedKey, '" for languages "').concat(codes.join(", "), '" won\'t get resolved as namespace "').concat(usedNS, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                        }
                        codes.forEach(function(code) {
                            if (_this4.isValidLookup(found)) return;
                            usedLng = code;
                            var finalKeys = [
                                key
                            ];
                            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
                            else {
                                var pluralSuffix;
                                if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count, options);
                                var zeroSuffix = "".concat(_this4.options.pluralSeparator, "zero");
                                if (needsPluralHandling) {
                                    finalKeys.push(key + pluralSuffix);
                                    if (needsZeroSuffixLookup) finalKeys.push(key + zeroSuffix);
                                }
                                if (needsContextHandling) {
                                    var contextKey = "".concat(key).concat(_this4.options.contextSeparator).concat(options.context);
                                    finalKeys.push(contextKey);
                                    if (needsPluralHandling) {
                                        finalKeys.push(contextKey + pluralSuffix);
                                        if (needsZeroSuffixLookup) finalKeys.push(contextKey + zeroSuffix);
                                    }
                                }
                            }
                            var possibleKey;
                            while(possibleKey = finalKeys.pop())if (!_this4.isValidLookup(found)) {
                                exactUsedKey = possibleKey;
                                found = _this4.getResource(code, ns, possibleKey, options);
                            }
                        });
                    });
                });
                return {
                    res: found,
                    usedKey: usedKey,
                    exactUsedKey: exactUsedKey,
                    usedLng: usedLng,
                    usedNS: usedNS
                };
            }
        },
        {
            key: "isValidLookup",
            value: function isValidLookup(res) {
                return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === "");
            }
        },
        {
            key: "getResource",
            value: function getResource(code, ns, key) {
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
                return this.resourceStore.getResource(code, ns, key, options);
            }
        }
    ], [
        {
            key: "hasDefaultValue",
            value: function hasDefaultValue(options) {
                var prefix = "defaultValue";
                for(var option in options){
                    if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) return true;
                }
                return false;
            }
        }
    ]);
    return Translator;
}($7a8ebbf8c1ca7490$var$EventEmitter);
function $7a8ebbf8c1ca7490$var$capitalize(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}
var $7a8ebbf8c1ca7490$var$LanguageUtil = function() {
    function LanguageUtil(options) {
        (0, $gfYX1.default)(this, LanguageUtil);
        this.options = options;
        this.supportedLngs = this.options.supportedLngs || false;
        this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("languageUtils");
    }
    (0, $gvD6c.default)(LanguageUtil, [
        {
            key: "getScriptPartFromCode",
            value: function getScriptPartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return null;
                var p = code.split("-");
                if (p.length === 2) return null;
                p.pop();
                if (p[p.length - 1].toLowerCase() === "x") return null;
                return this.formatLanguageCode(p.join("-"));
            }
        },
        {
            key: "getLanguagePartFromCode",
            value: function getLanguagePartFromCode(code) {
                if (!code || code.indexOf("-") < 0) return code;
                var p = code.split("-");
                return this.formatLanguageCode(p[0]);
            }
        },
        {
            key: "formatLanguageCode",
            value: function formatLanguageCode(code) {
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    var specialCases = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab"
                    ];
                    var p = code.split("-");
                    if (this.options.lowerCaseLng) p = p.map(function(part) {
                        return part.toLowerCase();
                    });
                    else if (p.length === 2) {
                        p[0] = p[0].toLowerCase();
                        p[1] = p[1].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $7a8ebbf8c1ca7490$var$capitalize(p[1].toLowerCase());
                    } else if (p.length === 3) {
                        p[0] = p[0].toLowerCase();
                        if (p[1].length === 2) p[1] = p[1].toUpperCase();
                        if (p[0] !== "sgn" && p[2].length === 2) p[2] = p[2].toUpperCase();
                        if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = $7a8ebbf8c1ca7490$var$capitalize(p[1].toLowerCase());
                        if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = $7a8ebbf8c1ca7490$var$capitalize(p[2].toLowerCase());
                    }
                    return p.join("-");
                }
                return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
            }
        },
        {
            key: "isSupportedCode",
            value: function isSupportedCode(code) {
                if (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) code = this.getLanguagePartFromCode(code);
                return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
            }
        },
        {
            key: "getBestMatchFromCodes",
            value: function getBestMatchFromCodes(codes) {
                var _this = this;
                if (!codes) return null;
                var found;
                codes.forEach(function(code) {
                    if (found) return;
                    var cleanedLng = _this.formatLanguageCode(code);
                    if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
                });
                if (!found && this.options.supportedLngs) codes.forEach(function(code) {
                    if (found) return;
                    var lngOnly = _this.getLanguagePartFromCode(code);
                    if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
                    found = _this.options.supportedLngs.find(function(supportedLng) {
                        if (supportedLng === lngOnly) return supportedLng;
                        if (supportedLng.indexOf("-") < 0 && lngOnly.indexOf("-") < 0) return;
                        if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
                    });
                });
                if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
                return found;
            }
        },
        {
            key: "getFallbackCodes",
            value: function getFallbackCodes(fallbacks, code) {
                if (!fallbacks) return [];
                if (typeof fallbacks === "function") fallbacks = fallbacks(code);
                if (typeof fallbacks === "string") fallbacks = [
                    fallbacks
                ];
                if (Object.prototype.toString.apply(fallbacks) === "[object Array]") return fallbacks;
                if (!code) return fallbacks["default"] || [];
                var found = fallbacks[code];
                if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
                if (!found) found = fallbacks[this.formatLanguageCode(code)];
                if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
                if (!found) found = fallbacks["default"];
                return found || [];
            }
        },
        {
            key: "toResolveHierarchy",
            value: function toResolveHierarchy(code, fallbackCode) {
                var _this2 = this;
                var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
                var codes = [];
                var addCode = function addCode(c) {
                    if (!c) return;
                    if (_this2.isSupportedCode(c)) codes.push(c);
                    else _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
                };
                if (typeof code === "string" && code.indexOf("-") > -1) {
                    if (this.options.load !== "languageOnly") addCode(this.formatLanguageCode(code));
                    if (this.options.load !== "languageOnly" && this.options.load !== "currentOnly") addCode(this.getScriptPartFromCode(code));
                    if (this.options.load !== "currentOnly") addCode(this.getLanguagePartFromCode(code));
                } else if (typeof code === "string") addCode(this.formatLanguageCode(code));
                fallbackCodes.forEach(function(fc) {
                    if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
                });
                return codes;
            }
        }
    ]);
    return LanguageUtil;
}();
var $7a8ebbf8c1ca7490$var$sets = [
    {
        lngs: [
            "ach",
            "ak",
            "am",
            "arn",
            "br",
            "fil",
            "gun",
            "ln",
            "mfe",
            "mg",
            "mi",
            "oc",
            "pt",
            "pt-BR",
            "tg",
            "tl",
            "ti",
            "tr",
            "uz",
            "wa"
        ],
        nr: [
            1,
            2
        ],
        fc: 1
    },
    {
        lngs: [
            "af",
            "an",
            "ast",
            "az",
            "bg",
            "bn",
            "ca",
            "da",
            "de",
            "dev",
            "el",
            "en",
            "eo",
            "es",
            "et",
            "eu",
            "fi",
            "fo",
            "fur",
            "fy",
            "gl",
            "gu",
            "ha",
            "hi",
            "hu",
            "hy",
            "ia",
            "it",
            "kk",
            "kn",
            "ku",
            "lb",
            "mai",
            "ml",
            "mn",
            "mr",
            "nah",
            "nap",
            "nb",
            "ne",
            "nl",
            "nn",
            "no",
            "nso",
            "pa",
            "pap",
            "pms",
            "ps",
            "pt-PT",
            "rm",
            "sco",
            "se",
            "si",
            "so",
            "son",
            "sq",
            "sv",
            "sw",
            "ta",
            "te",
            "tk",
            "ur",
            "yo"
        ],
        nr: [
            1,
            2
        ],
        fc: 2
    },
    {
        lngs: [
            "ay",
            "bo",
            "cgg",
            "fa",
            "ht",
            "id",
            "ja",
            "jbo",
            "ka",
            "km",
            "ko",
            "ky",
            "lo",
            "ms",
            "sah",
            "su",
            "th",
            "tt",
            "ug",
            "vi",
            "wo",
            "zh"
        ],
        nr: [
            1
        ],
        fc: 3
    },
    {
        lngs: [
            "be",
            "bs",
            "cnr",
            "dz",
            "hr",
            "ru",
            "sr",
            "uk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 4
    },
    {
        lngs: [
            "ar"
        ],
        nr: [
            0,
            1,
            2,
            3,
            11,
            100
        ],
        fc: 5
    },
    {
        lngs: [
            "cs",
            "sk"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 6
    },
    {
        lngs: [
            "csb",
            "pl"
        ],
        nr: [
            1,
            2,
            5
        ],
        fc: 7
    },
    {
        lngs: [
            "cy"
        ],
        nr: [
            1,
            2,
            3,
            8
        ],
        fc: 8
    },
    {
        lngs: [
            "fr"
        ],
        nr: [
            1,
            2
        ],
        fc: 9
    },
    {
        lngs: [
            "ga"
        ],
        nr: [
            1,
            2,
            3,
            7,
            11
        ],
        fc: 10
    },
    {
        lngs: [
            "gd"
        ],
        nr: [
            1,
            2,
            3,
            20
        ],
        fc: 11
    },
    {
        lngs: [
            "is"
        ],
        nr: [
            1,
            2
        ],
        fc: 12
    },
    {
        lngs: [
            "jv"
        ],
        nr: [
            0,
            1
        ],
        fc: 13
    },
    {
        lngs: [
            "kw"
        ],
        nr: [
            1,
            2,
            3,
            4
        ],
        fc: 14
    },
    {
        lngs: [
            "lt"
        ],
        nr: [
            1,
            2,
            10
        ],
        fc: 15
    },
    {
        lngs: [
            "lv"
        ],
        nr: [
            1,
            2,
            0
        ],
        fc: 16
    },
    {
        lngs: [
            "mk"
        ],
        nr: [
            1,
            2
        ],
        fc: 17
    },
    {
        lngs: [
            "mnk"
        ],
        nr: [
            0,
            1,
            2
        ],
        fc: 18
    },
    {
        lngs: [
            "mt"
        ],
        nr: [
            1,
            2,
            11,
            20
        ],
        fc: 19
    },
    {
        lngs: [
            "or"
        ],
        nr: [
            2,
            1
        ],
        fc: 2
    },
    {
        lngs: [
            "ro"
        ],
        nr: [
            1,
            2,
            20
        ],
        fc: 20
    },
    {
        lngs: [
            "sl"
        ],
        nr: [
            5,
            1,
            2,
            3
        ],
        fc: 21
    },
    {
        lngs: [
            "he",
            "iw"
        ],
        nr: [
            1,
            2,
            20,
            21
        ],
        fc: 22
    }
];
var $7a8ebbf8c1ca7490$var$_rulesPluralsTypes = {
    1: function _(n) {
        return Number(n > 1);
    },
    2: function _(n) {
        return Number(n != 1);
    },
    3: function _(n) {
        return 0;
    },
    4: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    5: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
    },
    6: function _(n) {
        return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
    },
    7: function _(n) {
        return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    8: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
    },
    9: function _(n) {
        return Number(n >= 2);
    },
    10: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
    },
    11: function _(n) {
        return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
    },
    12: function _(n) {
        return Number(n % 10 != 1 || n % 100 == 11);
    },
    13: function _(n) {
        return Number(n !== 0);
    },
    14: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
    },
    15: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
    },
    16: function _(n) {
        return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
    },
    17: function _(n) {
        return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
    },
    18: function _(n) {
        return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
    },
    19: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
    },
    20: function _(n) {
        return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
    },
    21: function _(n) {
        return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
    },
    22: function _(n) {
        return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
    }
};
var $7a8ebbf8c1ca7490$var$deprecatedJsonVersions = [
    "v1",
    "v2",
    "v3"
];
var $7a8ebbf8c1ca7490$var$suffixesOrder = {
    zero: 0,
    one: 1,
    two: 2,
    few: 3,
    many: 4,
    other: 5
};
function $7a8ebbf8c1ca7490$var$createRules() {
    var rules = {};
    $7a8ebbf8c1ca7490$var$sets.forEach(function(set) {
        set.lngs.forEach(function(l) {
            rules[l] = {
                numbers: set.nr,
                plurals: $7a8ebbf8c1ca7490$var$_rulesPluralsTypes[set.fc]
            };
        });
    });
    return rules;
}
var $7a8ebbf8c1ca7490$var$PluralResolver = function() {
    function PluralResolver(languageUtils) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $gfYX1.default)(this, PluralResolver);
        this.languageUtils = languageUtils;
        this.options = options;
        this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("pluralResolver");
        if ((!this.options.compatibilityJSON || this.options.compatibilityJSON === "v4") && (typeof Intl === "undefined" || !Intl.PluralRules)) {
            this.options.compatibilityJSON = "v3";
            this.logger.error("Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling.");
        }
        this.rules = $7a8ebbf8c1ca7490$var$createRules();
    }
    (0, $gvD6c.default)(PluralResolver, [
        {
            key: "addRule",
            value: function addRule(lng, obj) {
                this.rules[lng] = obj;
            }
        },
        {
            key: "getRule",
            value: function getRule(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (this.shouldUseIntlApi()) try {
                    return new Intl.PluralRules(code, {
                        type: options.ordinal ? "ordinal" : "cardinal"
                    });
                } catch (_unused) {
                    return;
                }
                return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
            }
        },
        {
            key: "needsPlural",
            value: function needsPlural(code) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (this.shouldUseIntlApi()) return rule && rule.resolvedOptions().pluralCategories.length > 1;
                return rule && rule.numbers.length > 1;
            }
        },
        {
            key: "getPluralFormsOfKey",
            value: function getPluralFormsOfKey(code, key) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                return this.getSuffixes(code, options).map(function(suffix) {
                    return "".concat(key).concat(suffix);
                });
            }
        },
        {
            key: "getSuffixes",
            value: function getSuffixes(code) {
                var _this = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var rule = this.getRule(code, options);
                if (!rule) return [];
                if (this.shouldUseIntlApi()) return rule.resolvedOptions().pluralCategories.sort(function(pluralCategory1, pluralCategory2) {
                    return $7a8ebbf8c1ca7490$var$suffixesOrder[pluralCategory1] - $7a8ebbf8c1ca7490$var$suffixesOrder[pluralCategory2];
                }).map(function(pluralCategory) {
                    return "".concat(_this.options.prepend).concat(pluralCategory);
                });
                return rule.numbers.map(function(number) {
                    return _this.getSuffix(code, number, options);
                });
            }
        },
        {
            key: "getSuffix",
            value: function getSuffix(code, count) {
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var rule = this.getRule(code, options);
                if (rule) {
                    if (this.shouldUseIntlApi()) return "".concat(this.options.prepend).concat(rule.select(count));
                    return this.getSuffixRetroCompatible(rule, count);
                }
                this.logger.warn("no plural rule found for: ".concat(code));
                return "";
            }
        },
        {
            key: "getSuffixRetroCompatible",
            value: function getSuffixRetroCompatible(rule, count) {
                var _this2 = this;
                var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
                var suffix = rule.numbers[idx];
                if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
                    if (suffix === 2) suffix = "plural";
                    else if (suffix === 1) suffix = "";
                }
                var returnSuffix = function returnSuffix() {
                    return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
                };
                if (this.options.compatibilityJSON === "v1") {
                    if (suffix === 1) return "";
                    if (typeof suffix === "number") return "_plural_".concat(suffix.toString());
                    return returnSuffix();
                } else if (this.options.compatibilityJSON === "v2") return returnSuffix();
                else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) return returnSuffix();
                return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
            }
        },
        {
            key: "shouldUseIntlApi",
            value: function shouldUseIntlApi() {
                return !$7a8ebbf8c1ca7490$var$deprecatedJsonVersions.includes(this.options.compatibilityJSON);
            }
        }
    ]);
    return PluralResolver;
}();
function $7a8ebbf8c1ca7490$var$ownKeys$3(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$3(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$3(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$3(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$deepFindWithDefaults(data, defaultData, key) {
    var keySeparator = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ".";
    var ignoreJSONStructure = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
    var path = $7a8ebbf8c1ca7490$var$getPathWithDefaults(data, defaultData, key);
    if (!path && ignoreJSONStructure && typeof key === "string") {
        path = $7a8ebbf8c1ca7490$var$deepFind(data, key, keySeparator);
        if (path === undefined) path = $7a8ebbf8c1ca7490$var$deepFind(defaultData, key, keySeparator);
    }
    return path;
}
var $7a8ebbf8c1ca7490$var$Interpolator = function() {
    function Interpolator() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $gfYX1.default)(this, Interpolator);
        this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("interpolator");
        this.options = options;
        this.format = options.interpolation && options.interpolation.format || function(value) {
            return value;
        };
        this.init(options);
    }
    (0, $gvD6c.default)(Interpolator, [
        {
            key: "init",
            value: function init() {
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                if (!options.interpolation) options.interpolation = {
                    escapeValue: true
                };
                var iOpts = options.interpolation;
                this.escape = iOpts.escape !== undefined ? iOpts.escape : $7a8ebbf8c1ca7490$var$escape;
                this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
                this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
                this.prefix = iOpts.prefix ? $7a8ebbf8c1ca7490$var$regexEscape(iOpts.prefix) : iOpts.prefixEscaped || "{{";
                this.suffix = iOpts.suffix ? $7a8ebbf8c1ca7490$var$regexEscape(iOpts.suffix) : iOpts.suffixEscaped || "}}";
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
                this.unescapePrefix = iOpts.unescapeSuffix ? "" : iOpts.unescapePrefix || "-";
                this.unescapeSuffix = this.unescapePrefix ? "" : iOpts.unescapeSuffix || "";
                this.nestingPrefix = iOpts.nestingPrefix ? $7a8ebbf8c1ca7490$var$regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || $7a8ebbf8c1ca7490$var$regexEscape("$t(");
                this.nestingSuffix = iOpts.nestingSuffix ? $7a8ebbf8c1ca7490$var$regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || $7a8ebbf8c1ca7490$var$regexEscape(")");
                this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ",";
                this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
                this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
                this.resetRegExp();
            }
        },
        {
            key: "reset",
            value: function reset() {
                if (this.options) this.init(this.options);
            }
        },
        {
            key: "resetRegExp",
            value: function resetRegExp() {
                var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(regexpStr, "g");
                var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
                this.regexpUnescape = new RegExp(regexpUnescapeStr, "g");
                var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(nestingRegexpStr, "g");
            }
        },
        {
            key: "interpolate",
            value: function interpolate(str, data, lng, options) {
                var _this = this;
                var match;
                var value;
                var replaces;
                var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};
                function regexSafe(val) {
                    return val.replace(/\$/g, "$$$$");
                }
                var handleFormat = function handleFormat(key) {
                    if (key.indexOf(_this.formatSeparator) < 0) {
                        var path = $7a8ebbf8c1ca7490$var$deepFindWithDefaults(data, defaultData, key, _this.options.keySeparator, _this.options.ignoreJSONStructure);
                        return _this.alwaysFormat ? _this.format(path, undefined, lng, $7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3({}, options), data), {}, {
                            interpolationkey: key
                        })) : path;
                    }
                    var p = key.split(_this.formatSeparator);
                    var k = p.shift().trim();
                    var f = p.join(_this.formatSeparator).trim();
                    return _this.format($7a8ebbf8c1ca7490$var$deepFindWithDefaults(data, defaultData, k, _this.options.keySeparator, _this.options.ignoreJSONStructure), f, lng, $7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3({}, options), data), {}, {
                        interpolationkey: k
                    }));
                };
                this.resetRegExp();
                var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
                var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables !== undefined ? options.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
                var todos = [
                    {
                        regex: this.regexpUnescape,
                        safeValue: function safeValue(val) {
                            return regexSafe(val);
                        }
                    },
                    {
                        regex: this.regexp,
                        safeValue: function safeValue(val) {
                            return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
                        }
                    }
                ];
                todos.forEach(function(todo) {
                    replaces = 0;
                    while(match = todo.regex.exec(str)){
                        var matchedVar = match[1].trim();
                        value = handleFormat(matchedVar);
                        if (value === undefined) {
                            if (typeof missingInterpolationHandler === "function") {
                                var temp = missingInterpolationHandler(str, match, options);
                                value = typeof temp === "string" ? temp : "";
                            } else if (options && Object.prototype.hasOwnProperty.call(options, matchedVar)) value = "";
                            else if (skipOnVariables) {
                                value = match[0];
                                continue;
                            } else {
                                _this.logger.warn("missed to pass in variable ".concat(matchedVar, " for interpolating ").concat(str));
                                value = "";
                            }
                        } else if (typeof value !== "string" && !_this.useRawValueToEscape) value = $7a8ebbf8c1ca7490$var$makeString(value);
                        var safeValue = todo.safeValue(value);
                        str = str.replace(match[0], safeValue);
                        if (skipOnVariables) {
                            todo.regex.lastIndex += value.length;
                            todo.regex.lastIndex -= match[0].length;
                        } else todo.regex.lastIndex = 0;
                        replaces++;
                        if (replaces >= _this.maxReplaces) break;
                    }
                });
                return str;
            }
        },
        {
            key: "nest",
            value: function nest(str, fc) {
                var _this2 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var match;
                var value;
                var clonedOptions;
                function handleHasOptions(key, inheritedOptions) {
                    var sep = this.nestingOptionsSeparator;
                    if (key.indexOf(sep) < 0) return key;
                    var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
                    var optionsString = "{".concat(c[1]);
                    key = c[0];
                    optionsString = this.interpolate(optionsString, clonedOptions);
                    var matchedSingleQuotes = optionsString.match(/'/g);
                    var matchedDoubleQuotes = optionsString.match(/"/g);
                    if (matchedSingleQuotes && matchedSingleQuotes.length % 2 === 0 && !matchedDoubleQuotes || matchedDoubleQuotes.length % 2 !== 0) optionsString = optionsString.replace(/'/g, '"');
                    try {
                        clonedOptions = JSON.parse(optionsString);
                        if (inheritedOptions) clonedOptions = $7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3({}, inheritedOptions), clonedOptions);
                    } catch (e) {
                        this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
                        return "".concat(key).concat(sep).concat(optionsString);
                    }
                    delete clonedOptions.defaultValue;
                    return key;
                }
                while(match = this.nestingRegexp.exec(str)){
                    var formatters = [];
                    clonedOptions = $7a8ebbf8c1ca7490$var$_objectSpread$3({}, options);
                    clonedOptions = clonedOptions.replace && typeof clonedOptions.replace !== "string" ? clonedOptions.replace : clonedOptions;
                    clonedOptions.applyPostProcessor = false;
                    delete clonedOptions.defaultValue;
                    var doReduce = false;
                    if (match[0].indexOf(this.formatSeparator) !== -1 && !/{.*}/.test(match[1])) {
                        var r = match[1].split(this.formatSeparator).map(function(elem) {
                            return elem.trim();
                        });
                        match[1] = r.shift();
                        formatters = r;
                        doReduce = true;
                    }
                    value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
                    if (value && match[0] === str && typeof value !== "string") return value;
                    if (typeof value !== "string") value = $7a8ebbf8c1ca7490$var$makeString(value);
                    if (!value) {
                        this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
                        value = "";
                    }
                    if (doReduce) value = formatters.reduce(function(v, f) {
                        return _this2.format(v, f, options.lng, $7a8ebbf8c1ca7490$var$_objectSpread$3($7a8ebbf8c1ca7490$var$_objectSpread$3({}, options), {}, {
                            interpolationkey: match[1].trim()
                        }));
                    }, value.trim());
                    str = str.replace(match[0], value);
                    this.regexp.lastIndex = 0;
                }
                return str;
            }
        }
    ]);
    return Interpolator;
}();
function $7a8ebbf8c1ca7490$var$ownKeys$2(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$2(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$2(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$parseFormatStr(formatStr) {
    var formatName = formatStr.toLowerCase().trim();
    var formatOptions = {};
    if (formatStr.indexOf("(") > -1) {
        var p = formatStr.split("(");
        formatName = p[0].toLowerCase().trim();
        var optStr = p[1].substring(0, p[1].length - 1);
        if (formatName === "currency" && optStr.indexOf(":") < 0) {
            if (!formatOptions.currency) formatOptions.currency = optStr.trim();
        } else if (formatName === "relativetime" && optStr.indexOf(":") < 0) {
            if (!formatOptions.range) formatOptions.range = optStr.trim();
        } else {
            var opts = optStr.split(";");
            opts.forEach(function(opt) {
                if (!opt) return;
                var _opt$split = opt.split(":"), _opt$split2 = (0, $dUY9h.default)(_opt$split), key = _opt$split2[0], rest = _opt$split2.slice(1);
                var val = rest.join(":").trim().replace(/^'+|'+$/g, "");
                if (!formatOptions[key.trim()]) formatOptions[key.trim()] = val;
                if (val === "false") formatOptions[key.trim()] = false;
                if (val === "true") formatOptions[key.trim()] = true;
                if (!isNaN(val)) formatOptions[key.trim()] = parseInt(val, 10);
            });
        }
    }
    return {
        formatName: formatName,
        formatOptions: formatOptions
    };
}
function $7a8ebbf8c1ca7490$var$createCachedFormatter(fn) {
    var cache = {};
    return function invokeFormatter(val, lng, options) {
        var key = lng + JSON.stringify(options);
        var formatter = cache[key];
        if (!formatter) {
            formatter = fn(lng, options);
            cache[key] = formatter;
        }
        return formatter(val);
    };
}
var $7a8ebbf8c1ca7490$var$Formatter = function() {
    function Formatter() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        (0, $gfYX1.default)(this, Formatter);
        this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("formatter");
        this.options = options;
        this.formats = {
            number: $7a8ebbf8c1ca7490$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $7a8ebbf8c1ca7490$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            currency: $7a8ebbf8c1ca7490$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.NumberFormat(lng, $7a8ebbf8c1ca7490$var$_objectSpread$2($7a8ebbf8c1ca7490$var$_objectSpread$2({}, opt), {}, {
                    style: "currency"
                }));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            datetime: $7a8ebbf8c1ca7490$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.DateTimeFormat(lng, $7a8ebbf8c1ca7490$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            }),
            relativetime: $7a8ebbf8c1ca7490$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.RelativeTimeFormat(lng, $7a8ebbf8c1ca7490$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val, opt.range || "day");
                };
            }),
            list: $7a8ebbf8c1ca7490$var$createCachedFormatter(function(lng, opt) {
                var formatter = new Intl.ListFormat(lng, $7a8ebbf8c1ca7490$var$_objectSpread$2({}, opt));
                return function(val) {
                    return formatter.format(val);
                };
            })
        };
        this.init(options);
    }
    (0, $gvD6c.default)(Formatter, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
                    interpolation: {}
                };
                var iOpts = options.interpolation;
                this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ",";
            }
        },
        {
            key: "add",
            value: function add(name, fc) {
                this.formats[name.toLowerCase().trim()] = fc;
            }
        },
        {
            key: "addCached",
            value: function addCached(name, fc) {
                this.formats[name.toLowerCase().trim()] = $7a8ebbf8c1ca7490$var$createCachedFormatter(fc);
            }
        },
        {
            key: "format",
            value: function format(value, _format, lng) {
                var _this = this;
                var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
                var formats = _format.split(this.formatSeparator);
                var result = formats.reduce(function(mem, f) {
                    var _parseFormatStr = $7a8ebbf8c1ca7490$var$parseFormatStr(f), formatName = _parseFormatStr.formatName, formatOptions = _parseFormatStr.formatOptions;
                    if (_this.formats[formatName]) {
                        var formatted = mem;
                        try {
                            var valOptions = options && options.formatParams && options.formatParams[options.interpolationkey] || {};
                            var l = valOptions.locale || valOptions.lng || options.locale || options.lng || lng;
                            formatted = _this.formats[formatName](mem, l, $7a8ebbf8c1ca7490$var$_objectSpread$2($7a8ebbf8c1ca7490$var$_objectSpread$2($7a8ebbf8c1ca7490$var$_objectSpread$2({}, formatOptions), options), valOptions));
                        } catch (error) {
                            _this.logger.warn(error);
                        }
                        return formatted;
                    } else _this.logger.warn("there was no format function for ".concat(formatName));
                    return mem;
                }, value);
                return result;
            }
        }
    ]);
    return Formatter;
}();
function $7a8ebbf8c1ca7490$var$ownKeys$1(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread$1(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys$1(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys$1(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$_createSuper$1(Derived) {
    var hasNativeReflectConstruct = $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$1();
    return function _createSuperInternal() {
        var Super = (0, $33hvv.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $33hvv.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $7bpic.default)(this, result);
    };
}
function $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct$1() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7a8ebbf8c1ca7490$var$removePending(q, name) {
    if (q.pending[name] !== undefined) {
        delete q.pending[name];
        q.pendingCount--;
    }
}
var $7a8ebbf8c1ca7490$var$Connector = function(_EventEmitter) {
    (0, $e4x4Z.default)(Connector, _EventEmitter);
    var _super = $7a8ebbf8c1ca7490$var$_createSuper$1(Connector);
    function Connector(backend, store, services) {
        var _this;
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        (0, $gfYX1.default)(this, Connector);
        _this = _super.call(this);
        if ($7a8ebbf8c1ca7490$var$isIE10) $7a8ebbf8c1ca7490$var$EventEmitter.call((0, $3HF2X.default)(_this));
        _this.backend = backend;
        _this.store = store;
        _this.services = services;
        _this.languageUtils = services.languageUtils;
        _this.options = options;
        _this.logger = $7a8ebbf8c1ca7490$var$baseLogger.create("backendConnector");
        _this.waitingReads = [];
        _this.maxParallelReads = options.maxParallelReads || 10;
        _this.readingCalls = 0;
        _this.maxRetries = options.maxRetries >= 0 ? options.maxRetries : 5;
        _this.retryTimeout = options.retryTimeout >= 1 ? options.retryTimeout : 350;
        _this.state = {};
        _this.queue = [];
        if (_this.backend && _this.backend.init) _this.backend.init(services, options.backend, options);
        return _this;
    }
    (0, $gvD6c.default)(Connector, [
        {
            key: "queueLoad",
            value: function queueLoad(languages, namespaces, options, callback) {
                var _this2 = this;
                var toLoad = {};
                var pending = {};
                var toLoadLanguages = {};
                var toLoadNamespaces = {};
                languages.forEach(function(lng) {
                    var hasAllNamespaces = true;
                    namespaces.forEach(function(ns) {
                        var name = "".concat(lng, "|").concat(ns);
                        if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) _this2.state[name] = 2;
                        else if (_this2.state[name] < 0) ;
                        else if (_this2.state[name] === 1) {
                            if (pending[name] === undefined) pending[name] = true;
                        } else {
                            _this2.state[name] = 1;
                            hasAllNamespaces = false;
                            if (pending[name] === undefined) pending[name] = true;
                            if (toLoad[name] === undefined) toLoad[name] = true;
                            if (toLoadNamespaces[ns] === undefined) toLoadNamespaces[ns] = true;
                        }
                    });
                    if (!hasAllNamespaces) toLoadLanguages[lng] = true;
                });
                if (Object.keys(toLoad).length || Object.keys(pending).length) this.queue.push({
                    pending: pending,
                    pendingCount: Object.keys(pending).length,
                    loaded: {},
                    errors: [],
                    callback: callback
                });
                return {
                    toLoad: Object.keys(toLoad),
                    pending: Object.keys(pending),
                    toLoadLanguages: Object.keys(toLoadLanguages),
                    toLoadNamespaces: Object.keys(toLoadNamespaces)
                };
            }
        },
        {
            key: "loaded",
            value: function loaded(name, err, data) {
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                if (err) this.emit("failedLoading", lng, ns, err);
                if (data) this.store.addResourceBundle(lng, ns, data);
                this.state[name] = err ? -1 : 2;
                var loaded = {};
                this.queue.forEach(function(q) {
                    $7a8ebbf8c1ca7490$var$pushPath(q.loaded, [
                        lng
                    ], ns);
                    $7a8ebbf8c1ca7490$var$removePending(q, name);
                    if (err) q.errors.push(err);
                    if (q.pendingCount === 0 && !q.done) {
                        Object.keys(q.loaded).forEach(function(l) {
                            if (!loaded[l]) loaded[l] = {};
                            var loadedKeys = q.loaded[l];
                            if (loadedKeys.length) loadedKeys.forEach(function(n) {
                                if (loaded[l][n] === undefined) loaded[l][n] = true;
                            });
                        });
                        q.done = true;
                        if (q.errors.length) q.callback(q.errors);
                        else q.callback();
                    }
                });
                this.emit("loaded", loaded);
                this.queue = this.queue.filter(function(q) {
                    return !q.done;
                });
            }
        },
        {
            key: "read",
            value: function read(lng, ns, fcName) {
                var _this3 = this;
                var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
                var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : this.retryTimeout;
                var callback = arguments.length > 5 ? arguments[5] : undefined;
                if (!lng.length) return callback(null, {});
                if (this.readingCalls >= this.maxParallelReads) {
                    this.waitingReads.push({
                        lng: lng,
                        ns: ns,
                        fcName: fcName,
                        tried: tried,
                        wait: wait,
                        callback: callback
                    });
                    return;
                }
                this.readingCalls++;
                var resolver = function resolver(err, data) {
                    _this3.readingCalls--;
                    if (_this3.waitingReads.length > 0) {
                        var next = _this3.waitingReads.shift();
                        _this3.read(next.lng, next.ns, next.fcName, next.tried, next.wait, next.callback);
                    }
                    if (err && data && tried < _this3.maxRetries) {
                        setTimeout(function() {
                            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
                        }, wait);
                        return;
                    }
                    callback(err, data);
                };
                var fc = this.backend[fcName].bind(this.backend);
                if (fc.length === 2) {
                    try {
                        var r = fc(lng, ns);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return resolver(null, data);
                        })["catch"](resolver);
                        else resolver(null, r);
                    } catch (err) {
                        resolver(err);
                    }
                    return;
                }
                return fc(lng, ns, resolver);
            }
        },
        {
            key: "prepareLoading",
            value: function prepareLoading(languages, namespaces) {
                var _this4 = this;
                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                var callback = arguments.length > 3 ? arguments[3] : undefined;
                if (!this.backend) {
                    this.logger.warn("No backend was added via i18next.use. Will not load resources.");
                    return callback && callback();
                }
                if (typeof languages === "string") languages = this.languageUtils.toResolveHierarchy(languages);
                if (typeof namespaces === "string") namespaces = [
                    namespaces
                ];
                var toLoad = this.queueLoad(languages, namespaces, options, callback);
                if (!toLoad.toLoad.length) {
                    if (!toLoad.pending.length) callback();
                    return null;
                }
                toLoad.toLoad.forEach(function(name) {
                    _this4.loadOne(name);
                });
            }
        },
        {
            key: "load",
            value: function load(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {}, callback);
            }
        },
        {
            key: "reload",
            value: function reload(languages, namespaces, callback) {
                this.prepareLoading(languages, namespaces, {
                    reload: true
                }, callback);
            }
        },
        {
            key: "loadOne",
            value: function loadOne(name) {
                var _this5 = this;
                var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
                var s = name.split("|");
                var lng = s[0];
                var ns = s[1];
                this.read(lng, ns, "read", undefined, undefined, function(err, data) {
                    if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
                    if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);
                    _this5.loaded(name, err, data);
                });
            }
        },
        {
            key: "saveMissing",
            value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
                var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};
                var clb = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : function() {};
                if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
                    this.logger.warn('did not save key "'.concat(key, '" as the namespace "').concat(namespace, '" was not yet loaded'), "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
                    return;
                }
                if (key === undefined || key === null || key === "") return;
                if (this.backend && this.backend.create) {
                    var opts = $7a8ebbf8c1ca7490$var$_objectSpread$1($7a8ebbf8c1ca7490$var$_objectSpread$1({}, options), {}, {
                        isUpdate: isUpdate
                    });
                    var fc = this.backend.create.bind(this.backend);
                    if (fc.length < 6) try {
                        var r;
                        if (fc.length === 5) r = fc(languages, namespace, key, fallbackValue, opts);
                        else r = fc(languages, namespace, key, fallbackValue);
                        if (r && typeof r.then === "function") r.then(function(data) {
                            return clb(null, data);
                        })["catch"](clb);
                        else clb(null, r);
                    } catch (err) {
                        clb(err);
                    }
                    else fc(languages, namespace, key, fallbackValue, clb, opts);
                }
                if (!languages || !languages[0]) return;
                this.store.addResource(languages[0], namespace, key, fallbackValue);
            }
        }
    ]);
    return Connector;
}($7a8ebbf8c1ca7490$var$EventEmitter);
function $7a8ebbf8c1ca7490$var$get() {
    return {
        debug: false,
        initImmediate: true,
        ns: [
            "translation"
        ],
        defaultNS: [
            "translation"
        ],
        fallbackLng: [
            "dev"
        ],
        fallbackNS: false,
        supportedLngs: false,
        nonExplicitSupportedLngs: false,
        load: "all",
        preload: false,
        simplifyPluralSuffix: true,
        keySeparator: ".",
        nsSeparator: ":",
        pluralSeparator: "_",
        contextSeparator: "_",
        partialBundledLanguages: false,
        saveMissing: false,
        updateMissing: false,
        saveMissingTo: "fallback",
        saveMissingPlurals: true,
        missingKeyHandler: false,
        missingInterpolationHandler: false,
        postProcess: false,
        postProcessPassResolved: false,
        returnNull: true,
        returnEmptyString: true,
        returnObjects: false,
        joinArrays: false,
        returnedObjectHandler: false,
        parseMissingKeyHandler: false,
        appendNamespaceToMissingKey: false,
        appendNamespaceToCIMode: false,
        overloadTranslationOptionHandler: function handle(args) {
            var ret = {};
            if ((0, $f6w4m.default)(args[1]) === "object") ret = args[1];
            if (typeof args[1] === "string") ret.defaultValue = args[1];
            if (typeof args[2] === "string") ret.tDescription = args[2];
            if ((0, $f6w4m.default)(args[2]) === "object" || (0, $f6w4m.default)(args[3]) === "object") {
                var options = args[3] || args[2];
                Object.keys(options).forEach(function(key) {
                    ret[key] = options[key];
                });
            }
            return ret;
        },
        interpolation: {
            escapeValue: true,
            format: function format(value, _format, lng, options) {
                return value;
            },
            prefix: "{{",
            suffix: "}}",
            formatSeparator: ",",
            unescapePrefix: "-",
            nestingPrefix: "$t(",
            nestingSuffix: ")",
            nestingOptionsSeparator: ",",
            maxReplaces: 1000,
            skipOnVariables: true
        }
    };
}
function $7a8ebbf8c1ca7490$var$transformOptions(options) {
    if (typeof options.ns === "string") options.ns = [
        options.ns
    ];
    if (typeof options.fallbackLng === "string") options.fallbackLng = [
        options.fallbackLng
    ];
    if (typeof options.fallbackNS === "string") options.fallbackNS = [
        options.fallbackNS
    ];
    if (options.supportedLngs && options.supportedLngs.indexOf("cimode") < 0) options.supportedLngs = options.supportedLngs.concat([
        "cimode"
    ]);
    return options;
}
function $7a8ebbf8c1ca7490$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7a8ebbf8c1ca7490$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7a8ebbf8c1ca7490$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7a8ebbf8c1ca7490$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7a8ebbf8c1ca7490$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, $33hvv.default)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $33hvv.default)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $7bpic.default)(this, result);
    };
}
function $7a8ebbf8c1ca7490$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $7a8ebbf8c1ca7490$var$noop() {}
function $7a8ebbf8c1ca7490$var$bindMemberFunctions(inst) {
    var mems = Object.getOwnPropertyNames(Object.getPrototypeOf(inst));
    mems.forEach(function(mem) {
        if (typeof inst[mem] === "function") inst[mem] = inst[mem].bind(inst);
    });
}
var $7a8ebbf8c1ca7490$var$I18n = function(_EventEmitter) {
    (0, $e4x4Z.default)(I18n, _EventEmitter);
    var _super = $7a8ebbf8c1ca7490$var$_createSuper(I18n);
    function I18n() {
        var _this;
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var callback = arguments.length > 1 ? arguments[1] : undefined;
        (0, $gfYX1.default)(this, I18n);
        _this = _super.call(this);
        if ($7a8ebbf8c1ca7490$var$isIE10) $7a8ebbf8c1ca7490$var$EventEmitter.call((0, $3HF2X.default)(_this));
        _this.options = $7a8ebbf8c1ca7490$var$transformOptions(options);
        _this.services = {};
        _this.logger = $7a8ebbf8c1ca7490$var$baseLogger;
        _this.modules = {
            external: []
        };
        $7a8ebbf8c1ca7490$var$bindMemberFunctions((0, $3HF2X.default)(_this));
        if (callback && !_this.isInitialized && !options.isClone) {
            if (!_this.options.initImmediate) {
                _this.init(options, callback);
                return (0, $7bpic.default)(_this, (0, $3HF2X.default)(_this));
            }
            setTimeout(function() {
                _this.init(options, callback);
            }, 0);
        }
        return _this;
    }
    (0, $gvD6c.default)(I18n, [
        {
            key: "init",
            value: function init() {
                var _this2 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 ? arguments[1] : undefined;
                if (typeof options === "function") {
                    callback = options;
                    options = {};
                }
                if (!options.defaultNS && options.defaultNS !== false && options.ns) {
                    if (typeof options.ns === "string") options.defaultNS = options.ns;
                    else if (options.ns.indexOf("translation") < 0) options.defaultNS = options.ns[0];
                }
                var defOpts = $7a8ebbf8c1ca7490$var$get();
                this.options = $7a8ebbf8c1ca7490$var$_objectSpread($7a8ebbf8c1ca7490$var$_objectSpread($7a8ebbf8c1ca7490$var$_objectSpread({}, defOpts), this.options), $7a8ebbf8c1ca7490$var$transformOptions(options));
                if (this.options.compatibilityAPI !== "v1") this.options.interpolation = $7a8ebbf8c1ca7490$var$_objectSpread($7a8ebbf8c1ca7490$var$_objectSpread({}, defOpts.interpolation), this.options.interpolation);
                if (options.keySeparator !== undefined) this.options.userDefinedKeySeparator = options.keySeparator;
                if (options.nsSeparator !== undefined) this.options.userDefinedNsSeparator = options.nsSeparator;
                function createClassOnDemand(ClassOrObject) {
                    if (!ClassOrObject) return null;
                    if (typeof ClassOrObject === "function") return new ClassOrObject();
                    return ClassOrObject;
                }
                if (!this.options.isClone) {
                    if (this.modules.logger) $7a8ebbf8c1ca7490$var$baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
                    else $7a8ebbf8c1ca7490$var$baseLogger.init(null, this.options);
                    var formatter;
                    if (this.modules.formatter) formatter = this.modules.formatter;
                    else if (typeof Intl !== "undefined") formatter = $7a8ebbf8c1ca7490$var$Formatter;
                    var lu = new $7a8ebbf8c1ca7490$var$LanguageUtil(this.options);
                    this.store = new $7a8ebbf8c1ca7490$var$ResourceStore(this.options.resources, this.options);
                    var s = this.services;
                    s.logger = $7a8ebbf8c1ca7490$var$baseLogger;
                    s.resourceStore = this.store;
                    s.languageUtils = lu;
                    s.pluralResolver = new $7a8ebbf8c1ca7490$var$PluralResolver(lu, {
                        prepend: this.options.pluralSeparator,
                        compatibilityJSON: this.options.compatibilityJSON,
                        simplifyPluralSuffix: this.options.simplifyPluralSuffix
                    });
                    if (formatter && (!this.options.interpolation.format || this.options.interpolation.format === defOpts.interpolation.format)) {
                        s.formatter = createClassOnDemand(formatter);
                        s.formatter.init(s, this.options);
                        this.options.interpolation.format = s.formatter.format.bind(s.formatter);
                    }
                    s.interpolator = new $7a8ebbf8c1ca7490$var$Interpolator(this.options);
                    s.utils = {
                        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
                    };
                    s.backendConnector = new $7a8ebbf8c1ca7490$var$Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
                    s.backendConnector.on("*", function(event) {
                        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    if (this.modules.languageDetector) {
                        s.languageDetector = createClassOnDemand(this.modules.languageDetector);
                        if (s.languageDetector.init) s.languageDetector.init(s, this.options.detection, this.options);
                    }
                    if (this.modules.i18nFormat) {
                        s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
                        if (s.i18nFormat.init) s.i18nFormat.init(this);
                    }
                    this.translator = new $7a8ebbf8c1ca7490$var$Translator(this.services, this.options);
                    this.translator.on("*", function(event) {
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        _this2.emit.apply(_this2, [
                            event
                        ].concat(args));
                    });
                    this.modules.external.forEach(function(m) {
                        if (m.init) m.init(_this2);
                    });
                }
                this.format = this.options.interpolation.format;
                if (!callback) callback = $7a8ebbf8c1ca7490$var$noop;
                if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
                    var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                    if (codes.length > 0 && codes[0] !== "dev") this.options.lng = codes[0];
                }
                if (!this.services.languageDetector && !this.options.lng) this.logger.warn("init: no languageDetector is used and no lng is defined");
                var storeApi = [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage"
                ];
                storeApi.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store;
                        return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
                    };
                });
                var storeApiChained = [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle"
                ];
                storeApiChained.forEach(function(fcName) {
                    _this2[fcName] = function() {
                        var _this2$store2;
                        (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);
                        return _this2;
                    };
                });
                var deferred = $7a8ebbf8c1ca7490$var$defer();
                var load = function load() {
                    var finish = function finish(err, t) {
                        if (_this2.isInitialized && !_this2.initializedStoreOnce) _this2.logger.warn("init: i18next is already initialized. You should call init just once!");
                        _this2.isInitialized = true;
                        if (!_this2.options.isClone) _this2.logger.log("initialized", _this2.options);
                        _this2.emit("initialized", _this2.options);
                        deferred.resolve(t);
                        callback(err, t);
                    };
                    if (_this2.languages && _this2.options.compatibilityAPI !== "v1" && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));
                    _this2.changeLanguage(_this2.options.lng, finish);
                };
                if (this.options.resources || !this.options.initImmediate) load();
                else setTimeout(load, 0);
                return deferred;
            }
        },
        {
            key: "loadResources",
            value: function loadResources(language) {
                var _this3 = this;
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7a8ebbf8c1ca7490$var$noop;
                var usedCallback = callback;
                var usedLng = typeof language === "string" ? language : this.language;
                if (typeof language === "function") usedCallback = language;
                if (!this.options.resources || this.options.partialBundledLanguages) {
                    if (usedLng && usedLng.toLowerCase() === "cimode") return usedCallback();
                    var toLoad = [];
                    var append = function append(lng) {
                        if (!lng) return;
                        var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);
                        lngs.forEach(function(l) {
                            if (toLoad.indexOf(l) < 0) toLoad.push(l);
                        });
                    };
                    if (!usedLng) {
                        var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
                        fallbacks.forEach(function(l) {
                            return append(l);
                        });
                    } else append(usedLng);
                    if (this.options.preload) this.options.preload.forEach(function(l) {
                        return append(l);
                    });
                    this.services.backendConnector.load(toLoad, this.options.ns, function(e) {
                        if (!e && !_this3.resolvedLanguage && _this3.language) _this3.setResolvedLanguage(_this3.language);
                        usedCallback(e);
                    });
                } else usedCallback(null);
            }
        },
        {
            key: "reloadResources",
            value: function reloadResources(lngs, ns, callback) {
                var deferred = $7a8ebbf8c1ca7490$var$defer();
                if (!lngs) lngs = this.languages;
                if (!ns) ns = this.options.ns;
                if (!callback) callback = $7a8ebbf8c1ca7490$var$noop;
                this.services.backendConnector.reload(lngs, ns, function(err) {
                    deferred.resolve();
                    callback(err);
                });
                return deferred;
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (!module) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
                if (!module.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
                if (module.type === "backend") this.modules.backend = module;
                if (module.type === "logger" || module.log && module.warn && module.error) this.modules.logger = module;
                if (module.type === "languageDetector") this.modules.languageDetector = module;
                if (module.type === "i18nFormat") this.modules.i18nFormat = module;
                if (module.type === "postProcessor") $7a8ebbf8c1ca7490$var$postProcessor.addPostProcessor(module);
                if (module.type === "formatter") this.modules.formatter = module;
                if (module.type === "3rdParty") this.modules.external.push(module);
                return this;
            }
        },
        {
            key: "setResolvedLanguage",
            value: function setResolvedLanguage(l) {
                if (!l || !this.languages) return;
                if ([
                    "cimode",
                    "dev"
                ].indexOf(l) > -1) return;
                for(var li = 0; li < this.languages.length; li++){
                    var lngInLngs = this.languages[li];
                    if ([
                        "cimode",
                        "dev"
                    ].indexOf(lngInLngs) > -1) continue;
                    if (this.store.hasLanguageSomeTranslations(lngInLngs)) {
                        this.resolvedLanguage = lngInLngs;
                        break;
                    }
                }
            }
        },
        {
            key: "changeLanguage",
            value: function changeLanguage(lng, callback) {
                var _this4 = this;
                this.isLanguageChangingTo = lng;
                var deferred = $7a8ebbf8c1ca7490$var$defer();
                this.emit("languageChanging", lng);
                var setLngProps = function setLngProps(l) {
                    _this4.language = l;
                    _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
                    _this4.resolvedLanguage = undefined;
                    _this4.setResolvedLanguage(l);
                };
                var done = function done(err, l) {
                    if (l) {
                        setLngProps(l);
                        _this4.translator.changeLanguage(l);
                        _this4.isLanguageChangingTo = undefined;
                        _this4.emit("languageChanged", l);
                        _this4.logger.log("languageChanged", l);
                    } else _this4.isLanguageChangingTo = undefined;
                    deferred.resolve(function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                    if (callback) callback(err, function() {
                        return _this4.t.apply(_this4, arguments);
                    });
                };
                var setLng = function setLng(lngs) {
                    if (!lng && !lngs && _this4.services.languageDetector) lngs = [];
                    var l = typeof lngs === "string" ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);
                    if (l) {
                        if (!_this4.language) setLngProps(l);
                        if (!_this4.translator.language) _this4.translator.changeLanguage(l);
                        if (_this4.services.languageDetector && _this4.services.languageDetector.cacheUserLanguage) _this4.services.languageDetector.cacheUserLanguage(l);
                    }
                    _this4.loadResources(l, function(err) {
                        done(err, l);
                    });
                };
                if (!lng && this.services.languageDetector && !this.services.languageDetector.async) setLng(this.services.languageDetector.detect());
                else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
                    if (this.services.languageDetector.detect.length === 0) this.services.languageDetector.detect().then(setLng);
                    else this.services.languageDetector.detect(setLng);
                } else setLng(lng);
                return deferred;
            }
        },
        {
            key: "getFixedT",
            value: function getFixedT(lng, ns, keyPrefix) {
                var _this5 = this;
                var fixedT = function fixedT(key, opts) {
                    var options;
                    if ((0, $f6w4m.default)(opts) !== "object") {
                        for(var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++)rest[_key3 - 2] = arguments[_key3];
                        options = _this5.options.overloadTranslationOptionHandler([
                            key,
                            opts
                        ].concat(rest));
                    } else options = $7a8ebbf8c1ca7490$var$_objectSpread({}, opts);
                    options.lng = options.lng || fixedT.lng;
                    options.lngs = options.lngs || fixedT.lngs;
                    options.ns = options.ns || fixedT.ns;
                    options.keyPrefix = options.keyPrefix || keyPrefix || fixedT.keyPrefix;
                    var keySeparator = _this5.options.keySeparator || ".";
                    var resultKey;
                    if (options.keyPrefix && Array.isArray(key)) resultKey = key.map(function(k) {
                        return "".concat(options.keyPrefix).concat(keySeparator).concat(k);
                    });
                    else resultKey = options.keyPrefix ? "".concat(options.keyPrefix).concat(keySeparator).concat(key) : key;
                    return _this5.t(resultKey, options);
                };
                if (typeof lng === "string") fixedT.lng = lng;
                else fixedT.lngs = lng;
                fixedT.ns = ns;
                fixedT.keyPrefix = keyPrefix;
                return fixedT;
            }
        },
        {
            key: "t",
            value: function t() {
                var _this$translator;
                return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
            }
        },
        {
            key: "exists",
            value: function exists() {
                var _this$translator2;
                return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
            }
        },
        {
            key: "setDefaultNamespace",
            value: function setDefaultNamespace(ns) {
                this.options.defaultNS = ns;
            }
        },
        {
            key: "hasLoadedNamespace",
            value: function hasLoadedNamespace(ns) {
                var _this6 = this;
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                if (!this.isInitialized) {
                    this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages);
                    return false;
                }
                if (!this.languages || !this.languages.length) {
                    this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages);
                    return false;
                }
                var lng = this.resolvedLanguage || this.languages[0];
                var fallbackLng = this.options ? this.options.fallbackLng : false;
                var lastLng = this.languages[this.languages.length - 1];
                if (lng.toLowerCase() === "cimode") return true;
                var loadNotPending = function loadNotPending(l, n) {
                    var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];
                    return loadState === -1 || loadState === 2;
                };
                if (options.precheck) {
                    var preResult = options.precheck(this, loadNotPending);
                    if (preResult !== undefined) return preResult;
                }
                if (this.hasResourceBundle(lng, ns)) return true;
                if (!this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages) return true;
                if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
                return false;
            }
        },
        {
            key: "loadNamespaces",
            value: function loadNamespaces(ns, callback) {
                var _this7 = this;
                var deferred = $7a8ebbf8c1ca7490$var$defer();
                if (!this.options.ns) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                if (typeof ns === "string") ns = [
                    ns
                ];
                ns.forEach(function(n) {
                    if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
                });
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "loadLanguages",
            value: function loadLanguages(lngs, callback) {
                var deferred = $7a8ebbf8c1ca7490$var$defer();
                if (typeof lngs === "string") lngs = [
                    lngs
                ];
                var preloaded = this.options.preload || [];
                var newLngs = lngs.filter(function(lng) {
                    return preloaded.indexOf(lng) < 0;
                });
                if (!newLngs.length) {
                    if (callback) callback();
                    return Promise.resolve();
                }
                this.options.preload = preloaded.concat(newLngs);
                this.loadResources(function(err) {
                    deferred.resolve();
                    if (callback) callback(err);
                });
                return deferred;
            }
        },
        {
            key: "dir",
            value: function dir(lng) {
                if (!lng) lng = this.resolvedLanguage || (this.languages && this.languages.length > 0 ? this.languages[0] : this.language);
                if (!lng) return "rtl";
                var rtlLngs = [
                    "ar",
                    "shu",
                    "sqr",
                    "ssh",
                    "xaa",
                    "yhd",
                    "yud",
                    "aao",
                    "abh",
                    "abv",
                    "acm",
                    "acq",
                    "acw",
                    "acx",
                    "acy",
                    "adf",
                    "ads",
                    "aeb",
                    "aec",
                    "afb",
                    "ajp",
                    "apc",
                    "apd",
                    "arb",
                    "arq",
                    "ars",
                    "ary",
                    "arz",
                    "auz",
                    "avl",
                    "ayh",
                    "ayl",
                    "ayn",
                    "ayp",
                    "bbz",
                    "pga",
                    "he",
                    "iw",
                    "ps",
                    "pbt",
                    "pbu",
                    "pst",
                    "prp",
                    "prd",
                    "ug",
                    "ur",
                    "ydd",
                    "yds",
                    "yih",
                    "ji",
                    "yi",
                    "hbo",
                    "men",
                    "xmn",
                    "fa",
                    "jpr",
                    "peo",
                    "pes",
                    "prs",
                    "dv",
                    "sam",
                    "ckb"
                ];
                var languageUtils = this.services && this.services.languageUtils || new $7a8ebbf8c1ca7490$var$LanguageUtil($7a8ebbf8c1ca7490$var$get());
                return rtlLngs.indexOf(languageUtils.getLanguagePartFromCode(lng)) > -1 || lng.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
            }
        },
        {
            key: "cloneInstance",
            value: function cloneInstance() {
                var _this8 = this;
                var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
                var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7a8ebbf8c1ca7490$var$noop;
                var mergedOptions = $7a8ebbf8c1ca7490$var$_objectSpread($7a8ebbf8c1ca7490$var$_objectSpread($7a8ebbf8c1ca7490$var$_objectSpread({}, this.options), options), {
                    isClone: true
                });
                var clone = new I18n(mergedOptions);
                if (options.debug !== undefined || options.prefix !== undefined) clone.logger = clone.logger.clone(options);
                var membersToCopy = [
                    "store",
                    "services",
                    "language"
                ];
                membersToCopy.forEach(function(m) {
                    clone[m] = _this8[m];
                });
                clone.services = $7a8ebbf8c1ca7490$var$_objectSpread({}, this.services);
                clone.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                clone.translator = new $7a8ebbf8c1ca7490$var$Translator(clone.services, clone.options);
                clone.translator.on("*", function(event) {
                    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
                    clone.emit.apply(clone, [
                        event
                    ].concat(args));
                });
                clone.init(mergedOptions, callback);
                clone.translator.options = clone.options;
                clone.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
                };
                return clone;
            }
        },
        {
            key: "toJSON",
            value: function toJSON() {
                return {
                    options: this.options,
                    store: this.store,
                    language: this.language,
                    languages: this.languages,
                    resolvedLanguage: this.resolvedLanguage
                };
            }
        }
    ]);
    return I18n;
}($7a8ebbf8c1ca7490$var$EventEmitter);
(0, $cAQCs.default)($7a8ebbf8c1ca7490$var$I18n, "createInstance", function() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;
    return new $7a8ebbf8c1ca7490$var$I18n(options, callback);
});
var $7a8ebbf8c1ca7490$export$2e2bcd8739ae039 = $7a8ebbf8c1ca7490$var$I18n.createInstance();
$7a8ebbf8c1ca7490$export$2e2bcd8739ae039.createInstance = $7a8ebbf8c1ca7490$var$I18n.createInstance;
var $7a8ebbf8c1ca7490$export$99152e8d49ca4e7d = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.createInstance;
var $7a8ebbf8c1ca7490$export$147ec2801e896265 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.dir;
var $7a8ebbf8c1ca7490$export$2cd8252107eb640b = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.init;
var $7a8ebbf8c1ca7490$export$d3d08d944062d7e = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.loadResources;
var $7a8ebbf8c1ca7490$export$a5d9bf5d83fcab09 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.reloadResources;
var $7a8ebbf8c1ca7490$export$1f96ae73734a86cc = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.use;
var $7a8ebbf8c1ca7490$export$61465194746e7fd2 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.changeLanguage;
var $7a8ebbf8c1ca7490$export$f90d180fc7da3b3b = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.getFixedT;
var $7a8ebbf8c1ca7490$export$625550452a3fa3ec = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.t;
var $7a8ebbf8c1ca7490$export$f7e9f41ea797a17 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.exists;
var $7a8ebbf8c1ca7490$export$2b4b218e406d2d00 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.setDefaultNamespace;
var $7a8ebbf8c1ca7490$export$93d9ee97c1ad3f31 = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.hasLoadedNamespace;
var $7a8ebbf8c1ca7490$export$83be934b53fff43b = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.loadNamespaces;
var $7a8ebbf8c1ca7490$export$8cd7e7a54fa865bc = $7a8ebbf8c1ca7490$export$2e2bcd8739ae039.loadLanguages;

});
parcelRequire.register("3HF2X", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2b253a4591812e0f$export$2e2bcd8739ae039; });
function $2b253a4591812e0f$export$2e2bcd8739ae039(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("e4x4Z", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a3eb194a511a82d7$export$2e2bcd8739ae039; });

var $lOGDV = parcelRequire("lOGDV");
function $a3eb194a511a82d7$export$2e2bcd8739ae039(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) (0, $lOGDV.default)(subClass, superClass);
}

});
parcelRequire.register("lOGDV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fe1f587a606fe427$export$2e2bcd8739ae039; });
function $fe1f587a606fe427$export$2e2bcd8739ae039(o, p) {
    $fe1f587a606fe427$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fe1f587a606fe427$export$2e2bcd8739ae039(o, p);
}

});


parcelRequire.register("7bpic", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $53ad2e0b4659a4c6$export$2e2bcd8739ae039; });

var $f6w4m = parcelRequire("f6w4m");

var $3HF2X = parcelRequire("3HF2X");
function $53ad2e0b4659a4c6$export$2e2bcd8739ae039(self, call) {
    if (call && ((0, $f6w4m.default)(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $3HF2X.default)(self);
}

});

parcelRequire.register("33hvv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $238f3b7811016d59$export$2e2bcd8739ae039; });
function $238f3b7811016d59$export$2e2bcd8739ae039(o) {
    $238f3b7811016d59$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $238f3b7811016d59$export$2e2bcd8739ae039(o);
}

});

parcelRequire.register("dUY9h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a21f2997e20cd0fa$export$2e2bcd8739ae039; });

var $d9aks = parcelRequire("d9aks");

var $9ov68 = parcelRequire("9ov68");

var $jxBKF = parcelRequire("jxBKF");

var $7FpJP = parcelRequire("7FpJP");
function $a21f2997e20cd0fa$export$2e2bcd8739ae039(arr) {
    return (0, $d9aks.default)(arr) || (0, $9ov68.default)(arr) || (0, $jxBKF.default)(arr) || (0, $7FpJP.default)();
}

});
parcelRequire.register("9ov68", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6d6e7a601ccdedb9$export$2e2bcd8739ae039; });
function $6d6e7a601ccdedb9$export$2e2bcd8739ae039(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});



parcelRequire.register("5a1Rp", function(module, exports) {

$parcel$export(module.exports, "safeParseJson", function () { return $41011ba3768c1ae5$export$212f7b749ec4b6d2; });
$parcel$export(module.exports, "safeParseJsonObject", function () { return $41011ba3768c1ae5$export$c6c96a2b375defd2; });
parcelRequire("j6dBR");
var $123dJ = parcelRequire("123dJ");

var $awn06 = parcelRequire("awn06");
const $41011ba3768c1ae5$export$212f7b749ec4b6d2 = (jsonString)=>{
    try {
        const data = (0, $123dJ.jsonGuard).parse(JSON.parse(jsonString));
        return {
            success: true,
            data: data
        };
    } catch  {
        return {
            success: false,
            error: (0, $awn06.t)("admin_console.errors.invalid_json_format")
        };
    }
};
const $41011ba3768c1ae5$export$c6c96a2b375defd2 = (jsonString)=>{
    try {
        const data = (0, $123dJ.jsonObjectGuard).parse(JSON.parse(jsonString));
        return {
            success: true,
            data: data
        };
    } catch  {
        return {
            success: false,
            error: (0, $awn06.t)("admin_console.errors.invalid_json_format")
        };
    }
};

});

parcelRequire.register("aomPH", function(module, exports) {

$parcel$export(module.exports, "multiTextInputErrorGuard", function () { return $4423654a8576f101$export$afc2be86ec14084c; });

var $2CYkO = parcelRequire("2CYkO");
const $4423654a8576f101$export$afc2be86ec14084c = (0, $2CYkO.z).object({
    required: (0, $2CYkO.z).string().optional(),
    inputs: (0, $2CYkO.z).record((0, $2CYkO.z).number().or((0, $2CYkO.z).string()), (0, $2CYkO.z).string().optional()).optional()
});

});


parcelRequire.register("daYMR", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $997b5c99955c95e5$var$PropTypes = $997b5c99955c95e5$var$_interopRequireWildcard((parcelRequire("hqomP")));

var $997b5c99955c95e5$var$_addClass = $997b5c99955c95e5$var$_interopRequireDefault((parcelRequire("cliyN")));

var $997b5c99955c95e5$var$_removeClass = $997b5c99955c95e5$var$_interopRequireDefault((parcelRequire("aWMoV")));

var $997b5c99955c95e5$var$_react = $997b5c99955c95e5$var$_interopRequireDefault((parcelRequire("eCoWV")));

var $997b5c99955c95e5$var$_Transition = $997b5c99955c95e5$var$_interopRequireDefault((parcelRequire("cvGLH")));

function $997b5c99955c95e5$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $997b5c99955c95e5$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $997b5c99955c95e5$var$_extends() {
    $997b5c99955c95e5$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $997b5c99955c95e5$var$_extends.apply(this, arguments);
}
function $997b5c99955c95e5$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $997b5c99955c95e5$var$addClass = function addClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $997b5c99955c95e5$var$_addClass.default)(node, c);
    });
};
var $997b5c99955c95e5$var$removeClass = function removeClass(node, classes) {
    return node && classes && classes.split(" ").forEach(function(c) {
        return (0, $997b5c99955c95e5$var$_removeClass.default)(node, c);
    });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity: 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 */ var $997b5c99955c95e5$var$CSSTransition = /*#__PURE__*/ function(_React$Component) {
    $997b5c99955c95e5$var$_inheritsLoose(CSSTransition, _React$Component);
    function CSSTransition() {
        var _this;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(args)) || this;
        _this.onEnter = function(node, appearing) {
            var _this$getClassNames = _this.getClassNames(appearing ? "appear" : "enter"), className = _this$getClassNames.className;
            _this.removeClasses(node, "exit");
            $997b5c99955c95e5$var$addClass(node, className);
            if (_this.props.onEnter) _this.props.onEnter(node, appearing);
        };
        _this.onEntering = function(node, appearing) {
            var _this$getClassNames2 = _this.getClassNames(appearing ? "appear" : "enter"), activeClassName = _this$getClassNames2.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onEntering) _this.props.onEntering(node, appearing);
        };
        _this.onEntered = function(node, appearing) {
            var appearClassName = _this.getClassNames("appear").doneClassName;
            var enterClassName = _this.getClassNames("enter").doneClassName;
            var doneClassName = appearing ? appearClassName + " " + enterClassName : enterClassName;
            _this.removeClasses(node, appearing ? "appear" : "enter");
            $997b5c99955c95e5$var$addClass(node, doneClassName);
            if (_this.props.onEntered) _this.props.onEntered(node, appearing);
        };
        _this.onExit = function(node) {
            var _this$getClassNames3 = _this.getClassNames("exit"), className = _this$getClassNames3.className;
            _this.removeClasses(node, "appear");
            _this.removeClasses(node, "enter");
            $997b5c99955c95e5$var$addClass(node, className);
            if (_this.props.onExit) _this.props.onExit(node);
        };
        _this.onExiting = function(node) {
            var _this$getClassNames4 = _this.getClassNames("exit"), activeClassName = _this$getClassNames4.activeClassName;
            _this.reflowAndAddClass(node, activeClassName);
            if (_this.props.onExiting) _this.props.onExiting(node);
        };
        _this.onExited = function(node) {
            var _this$getClassNames5 = _this.getClassNames("exit"), doneClassName = _this$getClassNames5.doneClassName;
            _this.removeClasses(node, "exit");
            $997b5c99955c95e5$var$addClass(node, doneClassName);
            if (_this.props.onExited) _this.props.onExited(node);
        };
        _this.getClassNames = function(type) {
            var classNames = _this.props.classNames;
            var isStringClassNames = typeof classNames === "string";
            var prefix = isStringClassNames && classNames ? classNames + "-" : "";
            var className = isStringClassNames ? prefix + type : classNames[type];
            var activeClassName = isStringClassNames ? className + "-active" : classNames[type + "Active"];
            var doneClassName = isStringClassNames ? className + "-done" : classNames[type + "Done"];
            return {
                className: className,
                activeClassName: activeClassName,
                doneClassName: doneClassName
            };
        };
        return _this;
    }
    var _proto = CSSTransition.prototype;
    _proto.removeClasses = function removeClasses(node, type) {
        var _this$getClassNames6 = this.getClassNames(type), className = _this$getClassNames6.className, activeClassName = _this$getClassNames6.activeClassName, doneClassName = _this$getClassNames6.doneClassName;
        className && $997b5c99955c95e5$var$removeClass(node, className);
        activeClassName && $997b5c99955c95e5$var$removeClass(node, activeClassName);
        doneClassName && $997b5c99955c95e5$var$removeClass(node, doneClassName);
    };
    _proto.reflowAndAddClass = function reflowAndAddClass(node, className) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        if (className) {
            /* eslint-disable no-unused-expressions */ node && node.scrollTop;
            /* eslint-enable no-unused-expressions */ $997b5c99955c95e5$var$addClass(node, className);
        }
    };
    _proto.render = function render() {
        var props = $997b5c99955c95e5$var$_extends({}, this.props);
        delete props.classNames;
        return $997b5c99955c95e5$var$_react.default.createElement($997b5c99955c95e5$var$_Transition.default, $997b5c99955c95e5$var$_extends({}, props, {
            onEnter: this.onEnter,
            onEntered: this.onEntered,
            onEntering: this.onEntering,
            onExit: this.onExit,
            onExiting: this.onExiting,
            onExited: this.onExited
        }));
    };
    return CSSTransition;
}($997b5c99955c95e5$var$_react.default.Component);
$997b5c99955c95e5$var$CSSTransition.defaultProps = {
    classNames: ""
};
$997b5c99955c95e5$var$CSSTransition.propTypes = {};
var $997b5c99955c95e5$var$_default = $997b5c99955c95e5$var$CSSTransition;
module.exports.default = $997b5c99955c95e5$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("cliyN", function(module, exports) {
"use strict";

var $j6QqC = parcelRequire("j6QqC");
module.exports.__esModule = true;
module.exports.default = $8fc5d7e1bce75cad$var$addClass;

var $8fc5d7e1bce75cad$var$_hasClass = $j6QqC((parcelRequire("f52lN")));
function $8fc5d7e1bce75cad$var$addClass(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $8fc5d7e1bce75cad$var$_hasClass.default)(element, className)) {
        if (typeof element.className === "string") element.className = element.className + " " + className;
        else element.setAttribute("class", (element.className && element.className.baseVal || "") + " " + className);
    }
}
module.exports = module.exports["default"];

});
parcelRequire.register("j6QqC", function(module, exports) {
function $de973f0599ed5458$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        "default": obj
    };
}
module.exports = $de973f0599ed5458$var$_interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

});

parcelRequire.register("f52lN", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = $afa9256e5625a0ff$var$hasClass;
function $afa9256e5625a0ff$var$hasClass(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}
module.exports = module.exports["default"];

});


parcelRequire.register("aWMoV", function(module, exports) {
"use strict";
function $7f84dd98dee387d4$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
module.exports = function removeClass(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === "string") element.className = $7f84dd98dee387d4$var$replaceClassName(element.className, className);
    else element.setAttribute("class", $7f84dd98dee387d4$var$replaceClassName(element.className && element.className.baseVal || "", className));
};

});

parcelRequire.register("cvGLH", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "__esModule", function () { return $91b98e3377e0853b$export$1e511d4a378977f5; }, function (v) { return $91b98e3377e0853b$export$1e511d4a378977f5 = v; });
$parcel$export(module.exports, "default", function () { return $91b98e3377e0853b$export$2e2bcd8739ae039; }, function (v) { return $91b98e3377e0853b$export$2e2bcd8739ae039 = v; });
$parcel$export(module.exports, "EXITING", function () { return $91b98e3377e0853b$export$4aacc83d4d59139f; }, function (v) { return $91b98e3377e0853b$export$4aacc83d4d59139f = v; });
$parcel$export(module.exports, "ENTERED", function () { return $91b98e3377e0853b$export$78e9e6e3e014d60a; }, function (v) { return $91b98e3377e0853b$export$78e9e6e3e014d60a = v; });
$parcel$export(module.exports, "ENTERING", function () { return $91b98e3377e0853b$export$df38205c966be359; }, function (v) { return $91b98e3377e0853b$export$df38205c966be359 = v; });
$parcel$export(module.exports, "EXITED", function () { return $91b98e3377e0853b$export$84cbff306f539230; }, function (v) { return $91b98e3377e0853b$export$84cbff306f539230 = v; });
$parcel$export(module.exports, "UNMOUNTED", function () { return $91b98e3377e0853b$export$bb38bb9a1161268; }, function (v) { return $91b98e3377e0853b$export$bb38bb9a1161268 = v; });
var $91b98e3377e0853b$export$1e511d4a378977f5;
var $91b98e3377e0853b$export$2e2bcd8739ae039;
var $91b98e3377e0853b$export$4aacc83d4d59139f;
var $91b98e3377e0853b$export$78e9e6e3e014d60a;
var $91b98e3377e0853b$export$df38205c966be359;
var $91b98e3377e0853b$export$84cbff306f539230;
var $91b98e3377e0853b$export$bb38bb9a1161268;
"use strict";
$91b98e3377e0853b$export$1e511d4a378977f5 = true;
$91b98e3377e0853b$export$2e2bcd8739ae039 = $91b98e3377e0853b$export$4aacc83d4d59139f = $91b98e3377e0853b$export$78e9e6e3e014d60a = $91b98e3377e0853b$export$df38205c966be359 = $91b98e3377e0853b$export$84cbff306f539230 = $91b98e3377e0853b$export$bb38bb9a1161268 = void 0;

var $91b98e3377e0853b$var$PropTypes = $91b98e3377e0853b$var$_interopRequireWildcard((parcelRequire("hqomP")));

var $91b98e3377e0853b$var$_react = $91b98e3377e0853b$var$_interopRequireDefault((parcelRequire("eCoWV")));

var $91b98e3377e0853b$var$_reactDom = $91b98e3377e0853b$var$_interopRequireDefault((parcelRequire("iVz18")));

var $aUKHN = parcelRequire("aUKHN");

function $91b98e3377e0853b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91b98e3377e0853b$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $91b98e3377e0853b$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $91b98e3377e0853b$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $91b98e3377e0853b$var$UNMOUNTED = "unmounted";
$91b98e3377e0853b$export$bb38bb9a1161268 = $91b98e3377e0853b$var$UNMOUNTED;
var $91b98e3377e0853b$var$EXITED = "exited";
$91b98e3377e0853b$export$84cbff306f539230 = $91b98e3377e0853b$var$EXITED;
var $91b98e3377e0853b$var$ENTERING = "entering";
$91b98e3377e0853b$export$df38205c966be359 = $91b98e3377e0853b$var$ENTERING;
var $91b98e3377e0853b$var$ENTERED = "entered";
$91b98e3377e0853b$export$78e9e6e3e014d60a = $91b98e3377e0853b$var$ENTERED;
var $91b98e3377e0853b$var$EXITING = "exiting";
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ $91b98e3377e0853b$export$4aacc83d4d59139f = $91b98e3377e0853b$var$EXITING;
var $91b98e3377e0853b$var$Transition = /*#__PURE__*/ function(_React$Component) {
    $91b98e3377e0853b$var$_inheritsLoose(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $91b98e3377e0853b$var$EXITED;
                _this.appearStatus = $91b98e3377e0853b$var$ENTERING;
            } else initialStatus = $91b98e3377e0853b$var$ENTERED;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $91b98e3377e0853b$var$UNMOUNTED;
        else initialStatus = $91b98e3377e0853b$var$EXITED;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    var _proto = Transition.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: null // allows for nested Transitions
        };
    };
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $91b98e3377e0853b$var$UNMOUNTED) return {
            status: $91b98e3377e0853b$var$EXITED
        };
        return null;
    }; // getSnapshotBeforeUpdate(prevProps) {
    //   let nextStatus = null
    //   if (prevProps !== this.props) {
    //     const { status } = this.state
    //     if (this.props.in) {
    //       if (status !== ENTERING && status !== ENTERED) {
    //         nextStatus = ENTERING
    //       }
    //     } else {
    //       if (status === ENTERING || status === ENTERED) {
    //         nextStatus = EXITING
    //       }
    //     }
    //   }
    //   return { nextStatus }
    // }
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $91b98e3377e0853b$var$ENTERING && status !== $91b98e3377e0853b$var$ENTERED) nextStatus = $91b98e3377e0853b$var$ENTERING;
            } else if (status === $91b98e3377e0853b$var$ENTERING || status === $91b98e3377e0853b$var$ENTERED) nextStatus = $91b98e3377e0853b$var$EXITING;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== "number") {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            var node = $91b98e3377e0853b$var$_reactDom.default.findDOMNode(this);
            if (nextStatus === $91b98e3377e0853b$var$ENTERING) this.performEnter(node, mounting);
            else this.performExit(node);
        } else if (this.props.unmountOnExit && this.state.status === $91b98e3377e0853b$var$EXITED) this.setState({
            status: $91b98e3377e0853b$var$UNMOUNTED
        });
    };
    _proto.performEnter = function performEnter(node, mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter) {
            this.safeSetState({
                status: $91b98e3377e0853b$var$ENTERED
            }, function() {
                _this2.props.onEntered(node);
            });
            return;
        }
        this.props.onEnter(node, appearing);
        this.safeSetState({
            status: $91b98e3377e0853b$var$ENTERING
        }, function() {
            _this2.props.onEntering(node, appearing);
            _this2.onTransitionEnd(node, enterTimeout, function() {
                _this2.safeSetState({
                    status: $91b98e3377e0853b$var$ENTERED
                }, function() {
                    _this2.props.onEntered(node, appearing);
                });
            });
        });
    };
    _proto.performExit = function performExit(node) {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
        if (!exit) {
            this.safeSetState({
                status: $91b98e3377e0853b$var$EXITED
            }, function() {
                _this3.props.onExited(node);
            });
            return;
        }
        this.props.onExit(node);
        this.safeSetState({
            status: $91b98e3377e0853b$var$EXITING
        }, function() {
            _this3.props.onExiting(node);
            _this3.onTransitionEnd(node, timeouts.exit, function() {
                _this3.safeSetState({
                    status: $91b98e3377e0853b$var$EXITED
                }, function() {
                    _this3.props.onExited(node);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
        this.setNextCallback(handler);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) this.props.addEndListener(node, this.nextCallback);
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $91b98e3377e0853b$var$UNMOUNTED) return null;
        var _this$props = this.props, children = _this$props.children, childProps = $91b98e3377e0853b$var$_objectWithoutPropertiesLoose(_this$props, [
            "children"
        ]); // filter props for Transtition
        delete childProps.in;
        delete childProps.mountOnEnter;
        delete childProps.unmountOnExit;
        delete childProps.appear;
        delete childProps.enter;
        delete childProps.exit;
        delete childProps.timeout;
        delete childProps.addEndListener;
        delete childProps.onEnter;
        delete childProps.onEntering;
        delete childProps.onEntered;
        delete childProps.onExit;
        delete childProps.onExiting;
        delete childProps.onExited;
        if (typeof children === "function") return children(status, childProps);
        var child = $91b98e3377e0853b$var$_react.default.Children.only(children);
        return $91b98e3377e0853b$var$_react.default.cloneElement(child, childProps);
    };
    return Transition;
}($91b98e3377e0853b$var$_react.default.Component);
$91b98e3377e0853b$var$Transition.contextTypes = {
    transitionGroup: $91b98e3377e0853b$var$PropTypes.object
};
$91b98e3377e0853b$var$Transition.childContextTypes = {
    transitionGroup: function transitionGroup() {}
};
$91b98e3377e0853b$var$Transition.propTypes = {};
function $91b98e3377e0853b$var$noop() {}
$91b98e3377e0853b$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $91b98e3377e0853b$var$noop,
    onEntering: $91b98e3377e0853b$var$noop,
    onEntered: $91b98e3377e0853b$var$noop,
    onExit: $91b98e3377e0853b$var$noop,
    onExiting: $91b98e3377e0853b$var$noop,
    onExited: $91b98e3377e0853b$var$noop
};
$91b98e3377e0853b$var$Transition.UNMOUNTED = 0;
$91b98e3377e0853b$var$Transition.EXITED = 1;
$91b98e3377e0853b$var$Transition.ENTERING = 2;
$91b98e3377e0853b$var$Transition.ENTERED = 3;
$91b98e3377e0853b$var$Transition.EXITING = 4;
var $91b98e3377e0853b$var$_default = (0, $aUKHN.polyfill)($91b98e3377e0853b$var$Transition);
$91b98e3377e0853b$export$2e2bcd8739ae039 = $91b98e3377e0853b$var$_default;

});


parcelRequire.register("buvfY", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $85dabdf5f383669c$var$_propTypes = $85dabdf5f383669c$var$_interopRequireDefault((parcelRequire("hqomP")));

var $85dabdf5f383669c$var$_react = $85dabdf5f383669c$var$_interopRequireDefault((parcelRequire("eCoWV")));

var $iVz18 = parcelRequire("iVz18");

var $85dabdf5f383669c$var$_TransitionGroup = $85dabdf5f383669c$var$_interopRequireDefault((parcelRequire("g8KCq")));
function $85dabdf5f383669c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $85dabdf5f383669c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $85dabdf5f383669c$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */ var $85dabdf5f383669c$var$ReplaceTransition = /*#__PURE__*/ function(_React$Component) {
    $85dabdf5f383669c$var$_inheritsLoose(ReplaceTransition, _React$Component);
    function ReplaceTransition() {
        var _this;
        for(var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++)_args[_key] = arguments[_key];
        _this = _React$Component.call.apply(_React$Component, [
            this
        ].concat(_args)) || this;
        _this.handleEnter = function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return _this.handleLifecycle("onEnter", 0, args);
        };
        _this.handleEntering = function() {
            for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
            return _this.handleLifecycle("onEntering", 0, args);
        };
        _this.handleEntered = function() {
            for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
            return _this.handleLifecycle("onEntered", 0, args);
        };
        _this.handleExit = function() {
            for(var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)args[_key5] = arguments[_key5];
            return _this.handleLifecycle("onExit", 1, args);
        };
        _this.handleExiting = function() {
            for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
            return _this.handleLifecycle("onExiting", 1, args);
        };
        _this.handleExited = function() {
            for(var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)args[_key7] = arguments[_key7];
            return _this.handleLifecycle("onExited", 1, args);
        };
        return _this;
    }
    var _proto = ReplaceTransition.prototype;
    _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
        var _child$props;
        var children = this.props.children;
        var child = $85dabdf5f383669c$var$_react.default.Children.toArray(children)[idx];
        if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
        if (this.props[handler]) this.props[handler]((0, $iVz18.findDOMNode)(this));
    };
    _proto.render = function render() {
        var _this$props = this.props, children = _this$props.children, inProp = _this$props.in, props = $85dabdf5f383669c$var$_objectWithoutPropertiesLoose(_this$props, [
            "children",
            "in"
        ]);
        var _React$Children$toArr = $85dabdf5f383669c$var$_react.default.Children.toArray(children), first = _React$Children$toArr[0], second = _React$Children$toArr[1];
        delete props.onEnter;
        delete props.onEntering;
        delete props.onEntered;
        delete props.onExit;
        delete props.onExiting;
        delete props.onExited;
        return $85dabdf5f383669c$var$_react.default.createElement($85dabdf5f383669c$var$_TransitionGroup.default, props, inProp ? $85dabdf5f383669c$var$_react.default.cloneElement(first, {
            key: "first",
            onEnter: this.handleEnter,
            onEntering: this.handleEntering,
            onEntered: this.handleEntered
        }) : $85dabdf5f383669c$var$_react.default.cloneElement(second, {
            key: "second",
            onEnter: this.handleExit,
            onEntering: this.handleExiting,
            onEntered: this.handleExited
        }));
    };
    return ReplaceTransition;
}($85dabdf5f383669c$var$_react.default.Component);
$85dabdf5f383669c$var$ReplaceTransition.propTypes = {};
var $85dabdf5f383669c$var$_default = $85dabdf5f383669c$var$ReplaceTransition;
module.exports.default = $85dabdf5f383669c$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("g8KCq", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports.default = void 0;

var $bc018e3bcebe3709$var$_propTypes = $bc018e3bcebe3709$var$_interopRequireDefault((parcelRequire("hqomP")));

var $bc018e3bcebe3709$var$_react = $bc018e3bcebe3709$var$_interopRequireDefault((parcelRequire("eCoWV")));

var $aUKHN = parcelRequire("aUKHN");

var $2N2PW = parcelRequire("2N2PW");
function $bc018e3bcebe3709$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bc018e3bcebe3709$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $bc018e3bcebe3709$var$_extends() {
    $bc018e3bcebe3709$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $bc018e3bcebe3709$var$_extends.apply(this, arguments);
}
function $bc018e3bcebe3709$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $bc018e3bcebe3709$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
var $bc018e3bcebe3709$var$values = Object.values || function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $bc018e3bcebe3709$var$defaultProps = {
    component: "div",
    childFactory: function childFactory(child) {
        return child;
    }
};
var $bc018e3bcebe3709$var$TransitionGroup = /*#__PURE__*/ function(_React$Component) {
    $bc018e3bcebe3709$var$_inheritsLoose(TransitionGroup, _React$Component);
    function TransitionGroup(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var handleExited = _this.handleExited.bind($bc018e3bcebe3709$var$_assertThisInitialized($bc018e3bcebe3709$var$_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
        _this.state = {
            handleExited: handleExited,
            firstRender: true
        };
        return _this;
    }
    var _proto = TransitionGroup.prototype;
    _proto.getChildContext = function getChildContext() {
        return {
            transitionGroup: {
                isMounting: !this.appeared
            }
        };
    };
    _proto.componentDidMount = function componentDidMount() {
        this.appeared = true;
        this.mounted = true;
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.mounted = false;
    };
    TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
        var prevChildMapping = _ref.children, handleExited = _ref.handleExited, firstRender = _ref.firstRender;
        return {
            children: firstRender ? (0, $2N2PW.getInitialChildMapping)(nextProps, handleExited) : (0, $2N2PW.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
            firstRender: false
        };
    };
    _proto.handleExited = function handleExited(child, node) {
        var currentChildMapping = (0, $2N2PW.getChildMapping)(this.props.children);
        if (child.key in currentChildMapping) return;
        if (child.props.onExited) child.props.onExited(node);
        if (this.mounted) this.setState(function(state) {
            var children = $bc018e3bcebe3709$var$_extends({}, state.children);
            delete children[child.key];
            return {
                children: children
            };
        });
    };
    _proto.render = function render() {
        var _this$props = this.props, Component = _this$props.component, childFactory = _this$props.childFactory, props = $bc018e3bcebe3709$var$_objectWithoutPropertiesLoose(_this$props, [
            "component",
            "childFactory"
        ]);
        var children = $bc018e3bcebe3709$var$values(this.state.children).map(childFactory);
        delete props.appear;
        delete props.enter;
        delete props.exit;
        if (Component === null) return children;
        return $bc018e3bcebe3709$var$_react.default.createElement(Component, props, children);
    };
    return TransitionGroup;
}($bc018e3bcebe3709$var$_react.default.Component);
$bc018e3bcebe3709$var$TransitionGroup.childContextTypes = {
    transitionGroup: $bc018e3bcebe3709$var$_propTypes.default.object.isRequired
};
$bc018e3bcebe3709$var$TransitionGroup.propTypes = {};
$bc018e3bcebe3709$var$TransitionGroup.defaultProps = $bc018e3bcebe3709$var$defaultProps;
var $bc018e3bcebe3709$var$_default = (0, $aUKHN.polyfill)($bc018e3bcebe3709$var$TransitionGroup);
module.exports.default = $bc018e3bcebe3709$var$_default;
module.exports = module.exports["default"];

});
parcelRequire.register("2N2PW", function(module, exports) {

$parcel$export(module.exports, "getChildMapping", function () { return $20825bae6c5bf7b1$export$bbc8a025727ea824; }, function (v) { return $20825bae6c5bf7b1$export$bbc8a025727ea824 = v; });
$parcel$export(module.exports, "getInitialChildMapping", function () { return $20825bae6c5bf7b1$export$fa71e2345c31d7a2; }, function (v) { return $20825bae6c5bf7b1$export$fa71e2345c31d7a2 = v; });
$parcel$export(module.exports, "getNextChildMapping", function () { return $20825bae6c5bf7b1$export$36fd1af28d383ec0; }, function (v) { return $20825bae6c5bf7b1$export$36fd1af28d383ec0 = v; });
var $20825bae6c5bf7b1$export$1e511d4a378977f5;
var $20825bae6c5bf7b1$export$bbc8a025727ea824;
var $20825bae6c5bf7b1$export$7a874f95ccf533dd;
var $20825bae6c5bf7b1$export$fa71e2345c31d7a2;
var $20825bae6c5bf7b1$export$36fd1af28d383ec0;
"use strict";
$20825bae6c5bf7b1$export$1e511d4a378977f5 = true;
$20825bae6c5bf7b1$export$bbc8a025727ea824 = $20825bae6c5bf7b1$var$getChildMapping;
$20825bae6c5bf7b1$export$7a874f95ccf533dd = $20825bae6c5bf7b1$var$mergeChildMappings;
$20825bae6c5bf7b1$export$fa71e2345c31d7a2 = $20825bae6c5bf7b1$var$getInitialChildMapping;
$20825bae6c5bf7b1$export$36fd1af28d383ec0 = $20825bae6c5bf7b1$var$getNextChildMapping;

var $eCoWV = parcelRequire("eCoWV");
/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */ function $20825bae6c5bf7b1$var$getChildMapping(children, mapFn) {
    var mapper = function mapper(child) {
        return mapFn && (0, $eCoWV.isValidElement)(child) ? mapFn(child) : child;
    };
    var result = Object.create(null);
    if (children) $eCoWV.Children.map(children, function(c) {
        return c;
    }).forEach(function(child) {
        // run the map function here instead so that the key is the computed one
        result[child.key] = mapper(child);
    });
    return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */ function $20825bae6c5bf7b1$var$mergeChildMappings(prev, next) {
    prev = prev || {};
    next = next || {};
    function getValueForKey(key) {
        return key in next ? next[key] : prev[key];
    } // For each key of `next`, the list of keys to insert before that key in
    // the combined list
    var nextKeysPending = Object.create(null);
    var pendingKeys = [];
    for(var prevKey in prev){
        if (prevKey in next) {
            if (pendingKeys.length) {
                nextKeysPending[prevKey] = pendingKeys;
                pendingKeys = [];
            }
        } else pendingKeys.push(prevKey);
    }
    var i;
    var childMapping = {};
    for(var nextKey in next){
        if (nextKeysPending[nextKey]) for(i = 0; i < nextKeysPending[nextKey].length; i++){
            var pendingNextKey = nextKeysPending[nextKey][i];
            childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
        }
        childMapping[nextKey] = getValueForKey(nextKey);
    } // Finally, add the keys which didn't appear before any key in `next`
    for(i = 0; i < pendingKeys.length; i++)childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
    return childMapping;
}
function $20825bae6c5bf7b1$var$getProp(child, prop, props) {
    return props[prop] != null ? props[prop] : child.props[prop];
}
function $20825bae6c5bf7b1$var$getInitialChildMapping(props, onExited) {
    return $20825bae6c5bf7b1$var$getChildMapping(props.children, function(child) {
        return (0, $eCoWV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            appear: $20825bae6c5bf7b1$var$getProp(child, "appear", props),
            enter: $20825bae6c5bf7b1$var$getProp(child, "enter", props),
            exit: $20825bae6c5bf7b1$var$getProp(child, "exit", props)
        });
    });
}
function $20825bae6c5bf7b1$var$getNextChildMapping(nextProps, prevChildMapping, onExited) {
    var nextChildMapping = $20825bae6c5bf7b1$var$getChildMapping(nextProps.children);
    var children = $20825bae6c5bf7b1$var$mergeChildMappings(prevChildMapping, nextChildMapping);
    Object.keys(children).forEach(function(key) {
        var child = children[key];
        if (!(0, $eCoWV.isValidElement)(child)) return;
        var hasPrev = key in prevChildMapping;
        var hasNext = key in nextChildMapping;
        var prevChild = prevChildMapping[key];
        var isLeaving = (0, $eCoWV.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
        if (hasNext && (!hasPrev || isLeaving)) // console.log('entering', key)
        children[key] = (0, $eCoWV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: true,
            exit: $20825bae6c5bf7b1$var$getProp(child, "exit", nextProps),
            enter: $20825bae6c5bf7b1$var$getProp(child, "enter", nextProps)
        });
        else if (!hasNext && hasPrev && !isLeaving) // item is old (exiting)
        // console.log('leaving', key)
        children[key] = (0, $eCoWV.cloneElement)(child, {
            in: false
        });
        else if (hasNext && hasPrev && (0, $eCoWV.isValidElement)(prevChild)) // item hasn't changed transition states
        // copy over the last transition props;
        // console.log('unchanged', key)
        children[key] = (0, $eCoWV.cloneElement)(child, {
            onExited: onExited.bind(null, child),
            in: prevChild.props.in,
            exit: $20825bae6c5bf7b1$var$getProp(child, "exit", nextProps),
            enter: $20825bae6c5bf7b1$var$getProp(child, "enter", nextProps)
        });
    });
    return children;
}

});



parcelRequire.register("jP5zR", function(module, exports) {
var $e6e71b512fb263d6$var$minus = "-".charCodeAt(0);
var $e6e71b512fb263d6$var$plus = "+".charCodeAt(0);
var $e6e71b512fb263d6$var$dot = ".".charCodeAt(0);
var $e6e71b512fb263d6$var$exp = "e".charCodeAt(0);
var $e6e71b512fb263d6$var$EXP = "E".charCodeAt(0);
module.exports = function(value) {
    var pos = 0;
    var length = value.length;
    var dotted = false;
    var sciPos = -1;
    var containsNumber = false;
    var code;
    while(pos < length){
        code = value.charCodeAt(pos);
        if (code >= 48 && code <= 57) containsNumber = true;
        else if (code === $e6e71b512fb263d6$var$exp || code === $e6e71b512fb263d6$var$EXP) {
            if (sciPos > -1) break;
            sciPos = pos;
        } else if (code === $e6e71b512fb263d6$var$dot) {
            if (dotted) break;
            dotted = true;
        } else if (code === $e6e71b512fb263d6$var$plus || code === $e6e71b512fb263d6$var$minus) {
            if (pos !== 0) break;
        } else break;
        pos += 1;
    }
    if (sciPos + 1 === pos) pos--;
    return containsNumber ? {
        number: value.slice(0, pos),
        unit: value.slice(pos)
    } : false;
};

});

parcelRequire.register("dqSKp", function(module, exports) {

$parcel$export(module.exports, "AsyncMode", function () { return $9c782bcc5804b81e$export$2b8d127b894957b9; }, function (v) { return $9c782bcc5804b81e$export$2b8d127b894957b9 = v; });
$parcel$export(module.exports, "ConcurrentMode", function () { return $9c782bcc5804b81e$export$cea3a54a6425200c; }, function (v) { return $9c782bcc5804b81e$export$cea3a54a6425200c = v; });
$parcel$export(module.exports, "ContextConsumer", function () { return $9c782bcc5804b81e$export$a7c73072b1a182ae; }, function (v) { return $9c782bcc5804b81e$export$a7c73072b1a182ae = v; });
$parcel$export(module.exports, "ContextProvider", function () { return $9c782bcc5804b81e$export$9f27bc3417b4524d; }, function (v) { return $9c782bcc5804b81e$export$9f27bc3417b4524d = v; });
$parcel$export(module.exports, "Element", function () { return $9c782bcc5804b81e$export$db77ccec0bb4ccac; }, function (v) { return $9c782bcc5804b81e$export$db77ccec0bb4ccac = v; });
$parcel$export(module.exports, "ForwardRef", function () { return $9c782bcc5804b81e$export$8392c0c9d3dcbd35; }, function (v) { return $9c782bcc5804b81e$export$8392c0c9d3dcbd35 = v; });
$parcel$export(module.exports, "Fragment", function () { return $9c782bcc5804b81e$export$ffb0004e005737fa; }, function (v) { return $9c782bcc5804b81e$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Lazy", function () { return $9c782bcc5804b81e$export$b624eff549462981; }, function (v) { return $9c782bcc5804b81e$export$b624eff549462981 = v; });
$parcel$export(module.exports, "Memo", function () { return $9c782bcc5804b81e$export$7897aa7841a5380c; }, function (v) { return $9c782bcc5804b81e$export$7897aa7841a5380c = v; });
$parcel$export(module.exports, "Portal", function () { return $9c782bcc5804b81e$export$602eac185826482c; }, function (v) { return $9c782bcc5804b81e$export$602eac185826482c = v; });
$parcel$export(module.exports, "Profiler", function () { return $9c782bcc5804b81e$export$e2c29f18771995cb; }, function (v) { return $9c782bcc5804b81e$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "StrictMode", function () { return $9c782bcc5804b81e$export$5f8d39834fd61797; }, function (v) { return $9c782bcc5804b81e$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $9c782bcc5804b81e$export$74bf444e3cd11ea5; }, function (v) { return $9c782bcc5804b81e$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "isAsyncMode", function () { return $9c782bcc5804b81e$export$92387174baf9b227; }, function (v) { return $9c782bcc5804b81e$export$92387174baf9b227 = v; });
$parcel$export(module.exports, "isConcurrentMode", function () { return $9c782bcc5804b81e$export$ec112efeb987d9c6; }, function (v) { return $9c782bcc5804b81e$export$ec112efeb987d9c6 = v; });
$parcel$export(module.exports, "isContextConsumer", function () { return $9c782bcc5804b81e$export$b706b080d889d2c9; }, function (v) { return $9c782bcc5804b81e$export$b706b080d889d2c9 = v; });
$parcel$export(module.exports, "isContextProvider", function () { return $9c782bcc5804b81e$export$5be5a87408f70ddc; }, function (v) { return $9c782bcc5804b81e$export$5be5a87408f70ddc = v; });
$parcel$export(module.exports, "isElement", function () { return $9c782bcc5804b81e$export$45a5e7f76e0caa8d; }, function (v) { return $9c782bcc5804b81e$export$45a5e7f76e0caa8d = v; });
$parcel$export(module.exports, "isForwardRef", function () { return $9c782bcc5804b81e$export$455c2e768291efa6; }, function (v) { return $9c782bcc5804b81e$export$455c2e768291efa6 = v; });
$parcel$export(module.exports, "isFragment", function () { return $9c782bcc5804b81e$export$9522e17588c12572; }, function (v) { return $9c782bcc5804b81e$export$9522e17588c12572 = v; });
$parcel$export(module.exports, "isLazy", function () { return $9c782bcc5804b81e$export$2110ac352bb060b9; }, function (v) { return $9c782bcc5804b81e$export$2110ac352bb060b9 = v; });
$parcel$export(module.exports, "isMemo", function () { return $9c782bcc5804b81e$export$56885ab8b9c456ab; }, function (v) { return $9c782bcc5804b81e$export$56885ab8b9c456ab = v; });
$parcel$export(module.exports, "isPortal", function () { return $9c782bcc5804b81e$export$d927fcb6adf8f9de; }, function (v) { return $9c782bcc5804b81e$export$d927fcb6adf8f9de = v; });
$parcel$export(module.exports, "isProfiler", function () { return $9c782bcc5804b81e$export$b82d16f27459e05a; }, function (v) { return $9c782bcc5804b81e$export$b82d16f27459e05a = v; });
$parcel$export(module.exports, "isStrictMode", function () { return $9c782bcc5804b81e$export$522c17b4f5e123e8; }, function (v) { return $9c782bcc5804b81e$export$522c17b4f5e123e8 = v; });
$parcel$export(module.exports, "isSuspense", function () { return $9c782bcc5804b81e$export$1aabd8a0274ecfd6; }, function (v) { return $9c782bcc5804b81e$export$1aabd8a0274ecfd6 = v; });
$parcel$export(module.exports, "isValidElementType", function () { return $9c782bcc5804b81e$export$9b621391a187a31a; }, function (v) { return $9c782bcc5804b81e$export$9b621391a187a31a = v; });
$parcel$export(module.exports, "typeOf", function () { return $9c782bcc5804b81e$export$f5bbd400c2f4426f; }, function (v) { return $9c782bcc5804b81e$export$f5bbd400c2f4426f = v; });
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $9c782bcc5804b81e$export$2b8d127b894957b9;
var $9c782bcc5804b81e$export$cea3a54a6425200c;
var $9c782bcc5804b81e$export$a7c73072b1a182ae;
var $9c782bcc5804b81e$export$9f27bc3417b4524d;
var $9c782bcc5804b81e$export$db77ccec0bb4ccac;
var $9c782bcc5804b81e$export$8392c0c9d3dcbd35;
var $9c782bcc5804b81e$export$ffb0004e005737fa;
var $9c782bcc5804b81e$export$b624eff549462981;
var $9c782bcc5804b81e$export$7897aa7841a5380c;
var $9c782bcc5804b81e$export$602eac185826482c;
var $9c782bcc5804b81e$export$e2c29f18771995cb;
var $9c782bcc5804b81e$export$5f8d39834fd61797;
var $9c782bcc5804b81e$export$74bf444e3cd11ea5;
var $9c782bcc5804b81e$export$92387174baf9b227;
var $9c782bcc5804b81e$export$ec112efeb987d9c6;
var $9c782bcc5804b81e$export$b706b080d889d2c9;
var $9c782bcc5804b81e$export$5be5a87408f70ddc;
var $9c782bcc5804b81e$export$45a5e7f76e0caa8d;
var $9c782bcc5804b81e$export$455c2e768291efa6;
var $9c782bcc5804b81e$export$9522e17588c12572;
var $9c782bcc5804b81e$export$2110ac352bb060b9;
var $9c782bcc5804b81e$export$56885ab8b9c456ab;
var $9c782bcc5804b81e$export$d927fcb6adf8f9de;
var $9c782bcc5804b81e$export$b82d16f27459e05a;
var $9c782bcc5804b81e$export$522c17b4f5e123e8;
var $9c782bcc5804b81e$export$1aabd8a0274ecfd6;
var $9c782bcc5804b81e$export$9b621391a187a31a;
var $9c782bcc5804b81e$export$f5bbd400c2f4426f;
"use strict";
var $9c782bcc5804b81e$var$b = "function" === typeof Symbol && Symbol.for, $9c782bcc5804b81e$var$c = $9c782bcc5804b81e$var$b ? Symbol.for("react.element") : 60103, $9c782bcc5804b81e$var$d = $9c782bcc5804b81e$var$b ? Symbol.for("react.portal") : 60106, $9c782bcc5804b81e$var$e = $9c782bcc5804b81e$var$b ? Symbol.for("react.fragment") : 60107, $9c782bcc5804b81e$var$f = $9c782bcc5804b81e$var$b ? Symbol.for("react.strict_mode") : 60108, $9c782bcc5804b81e$var$g = $9c782bcc5804b81e$var$b ? Symbol.for("react.profiler") : 60114, $9c782bcc5804b81e$var$h = $9c782bcc5804b81e$var$b ? Symbol.for("react.provider") : 60109, $9c782bcc5804b81e$var$k = $9c782bcc5804b81e$var$b ? Symbol.for("react.context") : 60110, $9c782bcc5804b81e$var$l = $9c782bcc5804b81e$var$b ? Symbol.for("react.async_mode") : 60111, $9c782bcc5804b81e$var$m = $9c782bcc5804b81e$var$b ? Symbol.for("react.concurrent_mode") : 60111, $9c782bcc5804b81e$var$n = $9c782bcc5804b81e$var$b ? Symbol.for("react.forward_ref") : 60112, $9c782bcc5804b81e$var$p = $9c782bcc5804b81e$var$b ? Symbol.for("react.suspense") : 60113, $9c782bcc5804b81e$var$q = $9c782bcc5804b81e$var$b ? Symbol.for("react.suspense_list") : 60120, $9c782bcc5804b81e$var$r = $9c782bcc5804b81e$var$b ? Symbol.for("react.memo") : 60115, $9c782bcc5804b81e$var$t = $9c782bcc5804b81e$var$b ? Symbol.for("react.lazy") : 60116, $9c782bcc5804b81e$var$v = $9c782bcc5804b81e$var$b ? Symbol.for("react.block") : 60121, $9c782bcc5804b81e$var$w = $9c782bcc5804b81e$var$b ? Symbol.for("react.fundamental") : 60117, $9c782bcc5804b81e$var$x = $9c782bcc5804b81e$var$b ? Symbol.for("react.responder") : 60118, $9c782bcc5804b81e$var$y = $9c782bcc5804b81e$var$b ? Symbol.for("react.scope") : 60119;
function $9c782bcc5804b81e$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $9c782bcc5804b81e$var$c:
                switch(a = a.type, a){
                    case $9c782bcc5804b81e$var$l:
                    case $9c782bcc5804b81e$var$m:
                    case $9c782bcc5804b81e$var$e:
                    case $9c782bcc5804b81e$var$g:
                    case $9c782bcc5804b81e$var$f:
                    case $9c782bcc5804b81e$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $9c782bcc5804b81e$var$k:
                            case $9c782bcc5804b81e$var$n:
                            case $9c782bcc5804b81e$var$t:
                            case $9c782bcc5804b81e$var$r:
                            case $9c782bcc5804b81e$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $9c782bcc5804b81e$var$d:
                return u;
        }
    }
}
function $9c782bcc5804b81e$var$A(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$m;
}
$9c782bcc5804b81e$export$2b8d127b894957b9 = $9c782bcc5804b81e$var$l;
$9c782bcc5804b81e$export$cea3a54a6425200c = $9c782bcc5804b81e$var$m;
$9c782bcc5804b81e$export$a7c73072b1a182ae = $9c782bcc5804b81e$var$k;
$9c782bcc5804b81e$export$9f27bc3417b4524d = $9c782bcc5804b81e$var$h;
$9c782bcc5804b81e$export$db77ccec0bb4ccac = $9c782bcc5804b81e$var$c;
$9c782bcc5804b81e$export$8392c0c9d3dcbd35 = $9c782bcc5804b81e$var$n;
$9c782bcc5804b81e$export$ffb0004e005737fa = $9c782bcc5804b81e$var$e;
$9c782bcc5804b81e$export$b624eff549462981 = $9c782bcc5804b81e$var$t;
$9c782bcc5804b81e$export$7897aa7841a5380c = $9c782bcc5804b81e$var$r;
$9c782bcc5804b81e$export$602eac185826482c = $9c782bcc5804b81e$var$d;
$9c782bcc5804b81e$export$e2c29f18771995cb = $9c782bcc5804b81e$var$g;
$9c782bcc5804b81e$export$5f8d39834fd61797 = $9c782bcc5804b81e$var$f;
$9c782bcc5804b81e$export$74bf444e3cd11ea5 = $9c782bcc5804b81e$var$p;
$9c782bcc5804b81e$export$92387174baf9b227 = function(a) {
    return $9c782bcc5804b81e$var$A(a) || $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$l;
};
$9c782bcc5804b81e$export$ec112efeb987d9c6 = $9c782bcc5804b81e$var$A;
$9c782bcc5804b81e$export$b706b080d889d2c9 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$k;
};
$9c782bcc5804b81e$export$5be5a87408f70ddc = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$h;
};
$9c782bcc5804b81e$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $9c782bcc5804b81e$var$c;
};
$9c782bcc5804b81e$export$455c2e768291efa6 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$n;
};
$9c782bcc5804b81e$export$9522e17588c12572 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$e;
};
$9c782bcc5804b81e$export$2110ac352bb060b9 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$t;
};
$9c782bcc5804b81e$export$56885ab8b9c456ab = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$r;
};
$9c782bcc5804b81e$export$d927fcb6adf8f9de = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$d;
};
$9c782bcc5804b81e$export$b82d16f27459e05a = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$g;
};
$9c782bcc5804b81e$export$522c17b4f5e123e8 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$f;
};
$9c782bcc5804b81e$export$1aabd8a0274ecfd6 = function(a) {
    return $9c782bcc5804b81e$var$z(a) === $9c782bcc5804b81e$var$p;
};
$9c782bcc5804b81e$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $9c782bcc5804b81e$var$e || a === $9c782bcc5804b81e$var$m || a === $9c782bcc5804b81e$var$g || a === $9c782bcc5804b81e$var$f || a === $9c782bcc5804b81e$var$p || a === $9c782bcc5804b81e$var$q || "object" === typeof a && null !== a && (a.$$typeof === $9c782bcc5804b81e$var$t || a.$$typeof === $9c782bcc5804b81e$var$r || a.$$typeof === $9c782bcc5804b81e$var$h || a.$$typeof === $9c782bcc5804b81e$var$k || a.$$typeof === $9c782bcc5804b81e$var$n || a.$$typeof === $9c782bcc5804b81e$var$w || a.$$typeof === $9c782bcc5804b81e$var$x || a.$$typeof === $9c782bcc5804b81e$var$y || a.$$typeof === $9c782bcc5804b81e$var$v);
};
$9c782bcc5804b81e$export$f5bbd400c2f4426f = $9c782bcc5804b81e$var$z;

});

parcelRequire.register("eoBgQ", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", objectTag = "[object Object]", promiseTag = "[object Promise]", setTag = "[object Set]", weakMapTag = "[object WeakMap]";
var dataViewTag = "[object DataView]";
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined, propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined, nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap");
/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */ var nonEnumShadows = !propertyIsEnumerable.call({
    "valueOf": 1
}, "valueOf");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */ function isEmpty(value) {
    if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isArguments(value))) return !value.length;
    var tag = getTag(value);
    if (tag == mapTag || tag == setTag) return !value.size;
    if (nonEnumShadows || isPrototype(value)) return !nativeKeys(value).length;
    for(var key in value){
        if (hasOwnProperty.call(value, key)) return false;
    }
    return true;
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = isEmpty;

});

parcelRequire.register("euBJa", function(module, exports) {
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/** Used as the `TypeError` message for "Functions" methods. */ var FUNC_ERROR_TEXT = "Expected a function";
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used to compose bitmasks for comparison styles. */ var UNORDERED_COMPARE_FLAG = 1, PARTIAL_COMPARE_FLAG = 2;
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991;
/** `Object#toString` result references. */ var argsTag = "[object Arguments]", arrayTag = "[object Array]", boolTag = "[object Boolean]", dateTag = "[object Date]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", objectTag = "[object Object]", promiseTag = "[object Promise]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", weakMapTag = "[object WeakMap]";
var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, reLeadingDot = /^\./, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/** Detect free variable `global` from Node.js. */ var freeGlobal = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function("return this")();
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        return freeProcess && freeProcess.binding("util");
    } catch (e) {}
}();
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function arrayEach(array, iteratee) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array ? array.length : 0;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
/** Used for built-in method references. */ var arrayProto = Array.prototype, funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to detect overreaching core-js shims. */ var coreJsData = root["__core-js_shared__"];
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var objectToString = objectProto.toString;
/** Used to detect if a method is native. */ var reIsNative = RegExp("^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/** Built-in value references. */ var Symbol = root.Symbol, Uint8Array = root.Uint8Array, getPrototype = overArg(Object.getPrototypeOf, Object), objectCreate = Object.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, "DataView"), Map = getNative(root, "Map"), Promise = getNative(root, "Promise"), Set = getNative(root, "Set"), WeakMap = getNative(root, "WeakMap"), nativeCreate = getNative(Object, "create");
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
}
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    return this.has(key) && delete this.__data__[key];
}
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype["delete"] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
}
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    return true;
}
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) data.push([
        key,
        value
    ]);
    else data[index][1] = value;
    return this;
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype["delete"] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries ? entries.length : 0;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.__data__ = {
        "hash": new Hash,
        "map": new (Map || ListCache),
        "string": new Hash
    };
}
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    return getMapData(this, key)["delete"](key);
}
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    getMapData(this, key).set(key, value);
    return this;
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype["delete"] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values ? values.length : 0;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    this.__data__ = new ListCache(entries);
}
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
}
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    return this.__data__["delete"](key);
}
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var cache = this.__data__;
    if (cache instanceof ListCache) {
        var pairs = cache.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            return this;
        }
        cache = this.__data__ = new MapCache(pairs);
    }
    cache.set(key, value);
    return this;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype["delete"] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    // Safari 9 makes `arguments.length` enumerable in strict mode.
    var result = isArray(value) || isArguments(value) ? baseTimes(value.length, String) : [];
    var length = result.length, skipIndexes = !!length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == "length" || isIndex(key, length)))) result.push(key);
    return result;
}
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */ function baseCreate(proto) {
    return isObject(proto) ? objectCreate(proto) : {};
}
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    return objectToString.call(value);
}
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {boolean} [bitmask] The bitmask of comparison flags.
 *  The bitmask may be composed of the following flags:
 *     1 - Unordered comparison
 *     2 - Partial comparison
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, customizer, bitmask, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObject(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
}
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = arrayTag, othTag = arrayTag;
    if (!objIsArr) {
        objTag = getTag(object);
        objTag = objTag == argsTag ? objectTag : objTag;
    }
    if (!othIsArr) {
        othTag = getTag(other);
        othTag = othTag == argsTag ? objectTag : othTag;
    }
    var objIsObj = objTag == objectTag && !isHostObject(object), othIsObj = othTag == objectTag && !isHostObject(other), isSameTag = objTag == othTag;
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, equalFunc, customizer, bitmask, stack) : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
    }
    if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
}
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack) : result)) return false;
        }
    }
    return true;
}
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) || isHostObject(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
}
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return identity;
    if (typeof value == "object") return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
    };
}
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value) {
    return isArray(value) ? value : stringToPath(value);
}
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Assume cyclic values are equal.
    var stacked = stack.get(array);
    if (stacked && stack.get(other)) return stacked == other;
    var index = -1, result = true, seen = bitmask & UNORDERED_COMPARE_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!seen.has(othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) return seen.add(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= UNORDERED_COMPARE_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
            stack["delete"](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Function} customizer The function to customize comparisons.
 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
 *  for more details.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
    var isPartial = bitmask & PARTIAL_COMPARE_FLAG, objProps = keys(object), objLength = objProps.length, othProps = keys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Assume cyclic values are equal.
    var stacked = stack.get(object);
    if (stacked && stack.get(other)) return stacked == other;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = objectToString.call(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : undefined;
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = isKey(path, object) ? [
        path
    ] : castPath(path);
    var result, index = -1, length = path.length;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result) return result;
    var length = object ? object.length : 0;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (typeof value == "number" || reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
    return value === proto;
}
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoize(function(string) {
    string = toString(string);
    var result = [];
    if (reLeadingDot.test(string)) result.push("");
    string.replace(rePropName, function(match, number, quote, string) {
        result.push(quote ? string.replace(reEscapeChar, "$1") : number || match);
    });
    return result;
});
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == "string" || isSymbol(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -INFINITY ? "-0" : result;
}
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != "function" || resolver && typeof resolver != "function") throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result);
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Assign cache to `_.memoize`.
memoize.Cache = MapCache;
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ function isArguments(value) {
    // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
    return isArrayLikeObject(value) && hasOwnProperty.call(value, "callee") && (!propertyIsEnumerable.call(value, "callee") || objectToString.call(value) == argsTag);
}
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function isArrayLikeObject(value) {
    return isObjectLike(value) && isArrayLike(value);
}
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 8-9 which returns 'object' for typed array and other constructors.
    var tag = isObject(value) ? objectToString.call(value) : "";
    return tag == funcTag || tag == genTag;
}
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return !!value && (type == "object" || type == "function");
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == "symbol" || isObjectLike(value) && objectToString.call(value) == symbolTag;
}
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? "" : baseToString(value);
}
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
/**
 * An alternative to `_.reduce`; this method transforms `object` to a new
 * `accumulator` object which is the result of running each of its own
 * enumerable string keyed properties thru `iteratee`, with each invocation
 * potentially mutating the `accumulator` object. If `accumulator` is not
 * provided, a new object with the same `[[Prototype]]` will be used. The
 * iteratee is invoked with four arguments: (accumulator, value, key, object).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The custom accumulator value.
 * @returns {*} Returns the accumulated value.
 * @example
 *
 * _.transform([2, 3, 4], function(result, n) {
 *   result.push(n *= n);
 *   return n % 2 == 0;
 * }, []);
 * // => [4, 9]
 *
 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] }
 */ function transform(object, iteratee, accumulator) {
    var isArr = isArray(object) || isTypedArray(object);
    iteratee = baseIteratee(iteratee, 4);
    if (accumulator == null) {
        if (isArr || isObject(object)) {
            var Ctor = object.constructor;
            if (isArr) accumulator = isArray(object) ? new Ctor : [];
            else accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        } else accumulator = {};
    }
    (isArr ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
    });
    return accumulator;
}
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = transform;

});

parcelRequire.register("hdMZc", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("4IKga"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("hzsdQ"))
]).then(()=>parcelRequire("fMIvf"));

});

parcelRequire.register("ds8sa", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("IYsSq"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("1I1QO"))
]).then(()=>parcelRequire("1bn9P"));

});

parcelRequire.register("lrnE2", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("4IKga"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("e5ww2"))
]).then(()=>parcelRequire("hUupG"));

});

parcelRequire.register("jCYzn", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("IYsSq"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("7XDNH"))
]).then(()=>parcelRequire("2HNU1"));

});

parcelRequire.register("clonT", function(module, exports) {





module.exports = Promise.all([
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("IYsSq"), import.meta.url).toString()),
    (parcelRequire("kcGWx"))(new URL((parcelRequire("kucSS")).resolve("bjNKO"), import.meta.url).toString()),
    import("./" + (parcelRequire("kucSS")).resolve("b1Y3M"))
]).then(()=>parcelRequire("9d7BG"));

});

parcelRequire.register("aMkCU", function(module, exports) {

$parcel$export(module.exports, "SsoConnectorContext", function () { return $8e0baf12f7215c6b$export$166167b5bcb4b320; });
$parcel$export(module.exports, "default", function () { return $8e0baf12f7215c6b$export$2e2bcd8739ae039; });

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
const $8e0baf12f7215c6b$export$166167b5bcb4b320 = /*#__PURE__*/ (0, $eCoWV.createContext)({});
function $8e0baf12f7215c6b$var$SsoConnectorContextProvider({ children: children, ssoConnector: ssoConnector }) {
    const contextValue = (0, $eCoWV.useMemo)(()=>({
            ssoConnector: ssoConnector
        }), [
        ssoConnector
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)($8e0baf12f7215c6b$export$166167b5bcb4b320.Provider, {
        value: contextValue,
        children: children
    });
}
var $8e0baf12f7215c6b$export$2e2bcd8739ae039 = $8e0baf12f7215c6b$var$SsoConnectorContextProvider;

});


var $9zeGj = parcelRequire("9zeGj");
var $1ac549a22f572cc5$export$882461b6382ed46c;
var $1ac549a22f572cc5$export$757ceba2d55c277e;
"use strict";

var $iVz18 = parcelRequire("iVz18");
var $1ac549a22f572cc5$var$i;
$1ac549a22f572cc5$export$882461b6382ed46c = $iVz18.createRoot;
$1ac549a22f572cc5$export$757ceba2d55c277e = $iVz18.hydrateRoot;



var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $ek0ZU = parcelRequire("ek0ZU");
parcelRequire("8Hfh4");
var $lvEG3 = parcelRequire("lvEG3");
parcelRequire("cDiVA");
var $dbZ39 = parcelRequire("dbZ39");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("j6dBR");
var $az3ON = parcelRequire("az3ON");
var $faCyI = parcelRequire("faCyI");
parcelRequire("bGN6i");
var $5t2HV = parcelRequire("5t2HV");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $a7rB2 = parcelRequire("a7rB2");

var $8pPfi = parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");





var $9zeGj = parcelRequire("9zeGj");

var $9X5Bp = parcelRequire("9X5Bp");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("bGN6i");
var $vZyB0 = parcelRequire("vZyB0");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");
var $8pPfi = parcelRequire("8pPfi");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");
var $5CQIb = parcelRequire("5CQIb");
var $89710c80ff89456c$export$8695620d48fe67d;
(function(RequestMethod) {
    RequestMethod["GET"] = "GET";
    RequestMethod["POST"] = "POST";
    RequestMethod["PUT"] = "PUT";
    RequestMethod["PATCH"] = "PATCH";
    RequestMethod["DELETE"] = "DELETE";
    RequestMethod["COPY"] = "COPY";
    RequestMethod["HEAD"] = "HEAD";
    RequestMethod["OPTIONS"] = "OPTIONS";
})($89710c80ff89456c$export$8695620d48fe67d || ($89710c80ff89456c$export$8695620d48fe67d = {}));


const $362d461d087751ae$export$fb003dbd6df95edb = Object.freeze(Object.values((0, $89710c80ff89456c$export$8695620d48fe67d)));
const $362d461d087751ae$export$e960dff2dfff73b8 = Object.freeze($362d461d087751ae$export$fb003dbd6df95edb.map(// Cannot change the return type of `.toLowerCase()`
// eslint-disable-next-line no-restricted-syntax
(value)=>value.toLowerCase()));
const $362d461d087751ae$export$b55ee587147d9da1 = Object.freeze({
    json: "application/json"
});



var $f9dfJ = parcelRequire("f9dfJ");
const $fbc8f7e1b287a18f$export$8793edee2d425525 = async ()=>{
// Let it go
};
const $fbc8f7e1b287a18f$export$8f45430ccf837300 = Object.freeze({
    reset: "\x1b[0m",
    bright: "\x1b[1m",
    dim: "\x1b[2m",
    black: "\x1b[30m",
    red: "\x1b[31m",
    green: "\x1b[32m",
    blue: "\x1b[34m",
    magenta: "\x1b[35m",
    cyan: "\x1b[36m",
    yellow: "\x1b[33m"
});
const $fbc8f7e1b287a18f$export$35e9368ef982300f = (string, color)=>$f9dfJ.stdout.isTTY ? $fbc8f7e1b287a18f$export$8f45430ccf837300[color] + (string ?? "undefined") + $fbc8f7e1b287a18f$export$8f45430ccf837300.reset : string ?? "undefined";
const $fbc8f7e1b287a18f$export$bef1f36f5486a6a3 = {
    debug: (...args)=>{
        if ([
            "1",
            "true",
            "y",
            "yes"
        ].includes(undefined ?? "")) console.debug($fbc8f7e1b287a18f$export$35e9368ef982300f("dbg", "dim"), ...args);
    },
    warn: (...args)=>{
        console.warn($fbc8f7e1b287a18f$export$35e9368ef982300f("warn", "yellow"), ...args);
    }
};
const $fbc8f7e1b287a18f$export$a5c6d149b50c1d86 = (pathname)=>"/" + pathname.split("/").filter(Boolean).join("/");
const $fbc8f7e1b287a18f$export$66bfc51dbade9a33 = (raw)=>raw.toLowerCase().replaceAll("\n", " ").trim().replaceAll(/ {2,}/g, " ");





const $3247bd45f9d11f4a$export$767cbc91845890d3 = (record)=>{
    const parameters = new URLSearchParams();
    for (const [key, value] of Object.entries(record ?? {})){
        if (Array.isArray(value)) for (const element of value)parameters.append(key, element);
        else parameters.append(key, value);
    }
    return parameters;
};
const $3247bd45f9d11f4a$export$4369c812aac99591 = (value)=>value !== null && (typeof value === "object" || typeof value === "function") && "then" in value && typeof value.then === "function";





class $a819ec4606730a84$export$286baf652d0b1206 extends Error {
    constructor(response){
        super(`Response error ${response.status}: ${response.statusText}`);
        this.response = response;
    }
    get status() {
        return this.response.status;
    }
}
class $a819ec4606730a84$export$2e2bcd8739ae039 {
    constructor(value){
        this.get = this.buildHandler("get");
        this.post = this.buildHandler("post");
        this.put = this.buildHandler("put");
        this.patch = this.buildHandler("patch");
        this.delete = this.buildHandler("delete");
        this.copy = this.buildHandler("copy");
        this.head = this.buildHandler("head");
        this.options = this.buildHandler("options");
        if (typeof value === "string" || value instanceof URL) this.config = Object.freeze({
            baseUrl: new URL(value),
            keepAlive: true
        });
        else {
            const { baseUrl: baseUrl, ...rest } = value;
            this.config = Object.freeze({
                baseUrl: new URL(baseUrl),
                keepAlive: true,
                ...rest
            });
        }
        (0, $fbc8f7e1b287a18f$export$bef1f36f5486a6a3).debug(this.config);
    }
    buildUrl(pathname, search) {
        const { baseUrl: baseUrl } = this.config;
        const url = new URL((0, $fbc8f7e1b287a18f$export$a5c6d149b50c1d86)(baseUrl.pathname + pathname), baseUrl.origin);
        // Reassign to search to avoid unexpected `?`
        // eslint-disable-next-line @silverhand/fp/no-mutation
        url.search = (0, $3247bd45f9d11f4a$export$767cbc91845890d3)(search).toString();
        return url;
    }
    buildPathname(path, parameters) {
        return path.split("/").map((value)=>{
            if (!value.startsWith(":")) return value;
            const key = value.slice(1);
            const parameter = parameters?.[key];
            if (!parameter) throw new TypeError(`URL parameter \`${key}\` not found`);
            return parameter;
        }).join("/");
    }
    async buildHeaders(url, method, body) {
        const { headers: headers } = this.config;
        const needsJson = ![
            (0, $89710c80ff89456c$export$8695620d48fe67d).GET,
            (0, $89710c80ff89456c$export$8695620d48fe67d).OPTIONS,
            (0, $89710c80ff89456c$export$8695620d48fe67d).HEAD
        ].map((value)=>value.toLowerCase()).includes(method) && body !== undefined && body !== null;
        const unwrappedHeaders = typeof headers === "function" ? headers(url, method) : headers;
        return {
            host: url.host,
            accept: (0, $362d461d087751ae$export$b55ee587147d9da1).json,
            ...needsJson && {
                "content-type": (0, $362d461d087751ae$export$b55ee587147d9da1).json
            },
            ...(0, $3247bd45f9d11f4a$export$4369c812aac99591)(unwrappedHeaders) ? await unwrappedHeaders : unwrappedHeaders
        };
    }
    buildHandler(method) {
        const handler = async (path, payload)=>{
            if (typeof path !== "string") throw new TypeError("Path is not string");
            // We treat payload general and use code to make it works as expected
            // Type inference will always fall into the empty object result
            // eslint-disable-next-line no-restricted-syntax
            const { params: params, search: search, body: body } = payload ?? {};
            const pathname = this.buildPathname(path, params);
            const url = this.buildUrl(pathname, search);
            (0, $fbc8f7e1b287a18f$export$bef1f36f5486a6a3).debug(method.toUpperCase(), url.href);
            const response = await fetch(url, {
                method: method.toUpperCase(),
                headers: await this.buildHeaders(url, method, body),
                body: typeof body === "string" || body === undefined || body === null ? body : JSON.stringify(body)
            });
            if (!response.ok) throw new $a819ec4606730a84$export$286baf652d0b1206(response);
            if (response.status === 204) // The return type should be `undefined` here since the response code is 204
            // Trust backend since it's a HTTP standard
            // eslint-disable-next-line no-restricted-syntax
            return undefined;
            // Trust backend since it has been guarded
            // eslint-disable-next-line no-restricted-syntax
            return await response.json();
        };
        const withHook = async (...args)=>{
            try {
                return await handler(...args);
            } catch (error) {
                const hook = this.config.before?.error;
                if (!hook) throw error;
                const unwrapped = hook(error);
                const result = (0, $3247bd45f9d11f4a$export$4369c812aac99591)(unwrapped) ? await unwrapped : unwrapped;
                if (result instanceof Error) throw result;
                throw error;
            }
        };
        return withHook;
    }
}



var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("6ZMK7");
var $5Q2pm = parcelRequire("5Q2pm");
const $3978b41c434b0156$var$responseErrorBodyGuard = (0, $2CYkO.z).object({
    message: (0, $2CYkO.z).string()
});
const $3978b41c434b0156$export$5c32b0b3061e00c4 = async (error)=>(0, $aWIy6.trySafe)(async ()=>{
        // Clone the response to avoid blocking later usage since the response body can only be read once
        const responseBody = await error.response.clone().json();
        return $3978b41c434b0156$var$responseErrorBodyGuard.parse(responseBody);
    });
const $3978b41c434b0156$export$10abc8714a7caf54 = async (error)=>{
    if (error instanceof (0, $a819ec4606730a84$export$286baf652d0b1206)) {
        const responseBody = await $3978b41c434b0156$export$5c32b0b3061e00c4(error);
        if (responseBody) {
            (0, $horhC.toast).error(responseBody.message);
            return;
        }
    }
    (0, $horhC.toast)(error instanceof Error ? error.message : String(error));
};
const $3978b41c434b0156$export$7a5c900790855d66 = ({ hideErrorToast: hideErrorToast = false } = {})=>{
    const { isAuthenticated: isAuthenticated, getAccessToken: getAccessToken } = (0, $dtOpc.useLogto)();
    const api = (0, $eCoWV.useMemo)(()=>new (0, $a819ec4606730a84$export$2e2bcd8739ae039)({
            baseUrl: window.location.origin,
            headers: async ()=>{
                if (isAuthenticated) return {
                    Authorization: `Bearer ${await getAccessToken((0, $5Q2pm.cloudApi).indicator) ?? ""}`
                };
            },
            before: {
                ...(0, $5CQIb.conditional)(!hideErrorToast && {
                    error: $3978b41c434b0156$export$10abc8714a7caf54
                })
            }
        }), [
        getAccessToken,
        hideErrorToast,
        isAuthenticated
    ]);
    return api;
};



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $78149c015b6cf817$var$SvgLoadingIllustrationDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 124,
                r: 78,
                stroke: "#3D3C5A",
                strokeWidth: 60
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M218.66 54a2 2 0 1 0-4 0v176a2 2 0 0 0 4 0V54Z",
                fill: "#545B8C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 4,
                height: 140,
                rx: 2,
                transform: "scale(-1 1) rotate(60 -94.286 -97.309)",
                fill: "#545B8C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M231.038 223.732a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v8h40v-8Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                r: 8,
                transform: "matrix(-1 0 0 1 216.66 84)",
                fill: "#9F9EC8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                r: 4,
                transform: "matrix(-1 0 0 1 216.66 84)",
                fill: "#545B8C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                r: 12,
                transform: "scale(-1 1) rotate(-45 9.532 183.712)",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M103.778 38.627a690552.708 690552.708 0 0 0 45.255 45.255c12.497-12.497 12.497-32.758 0-45.255-12.497-12.496-32.758-12.496-45.255 0Z",
                fill: "url(#paint0_linear_503_14537)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 134a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v100H40V134Z",
                fill: "#9388C1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M44 134a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v96H44v-96Z",
                fill: "#3D3B47"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 228h192v2a4 4 0 0 1-4 4H40v-6Z",
                fill: "#8870E9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M102 130h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#1F1E25"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 84,
                y: 157,
                width: 80,
                height: 48,
                rx: 4,
                fill: "#585469"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M84 161a4 4 0 0 1 4-4h72a4 4 0 0 1 4 4v2H84v-2Z",
                fill: "#6F6988"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 89,
                cy: 160,
                r: 1,
                fill: "#CB777C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 93,
                cy: 160,
                r: 1,
                fill: "#D1AA75"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 97,
                cy: 160,
                r: 1,
                fill: "#86A988"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 171,
                width: 20,
                height: 4,
                rx: 2,
                fill: "#6F6988"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 128,
                y: 171,
                width: 28,
                height: 26,
                rx: 2,
                fill: "#6F6988"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 179,
                width: 28,
                height: 4,
                rx: 2,
                fill: "#6E678B"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 193,
                width: 8,
                height: 4,
                rx: 2,
                fill: "#6F6988"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M21 162h48l-5.389 64.664c-.29 3.482-.435 5.223-1.583 6.28C60.88 234 59.133 234 55.638 234H34.362c-3.494 0-5.24 0-6.389-1.056-1.148-1.057-1.293-2.798-1.583-6.28L21 162Z",
                fill: "#8F8BB8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M69 152h-8l-6 72h.639c3.494 0 5.24 0 6.389-1.056 1.148-1.057 1.293-2.798 1.583-6.28L69 152Z",
                fill: "#000",
                style: {
                    mixBlendMode: "soft-light"
                },
                opacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M69 152H21l.167 2h47.666l.167-2Z",
                fill: "#000",
                fillOpacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.68 210c-1.746 0-2.62 0-3.194-.528-.574-.528-.646-1.399-.792-3.14l-2.333-28c-.169-2.027-.253-3.04.34-3.686.595-.646 1.612-.646 3.646-.646h41.306c2.034 0 3.051 0 3.645.646.594.646.51 1.659.341 3.686l-2.333 28c-.145 1.741-.218 2.612-.792 3.14-.574.528-1.448.528-3.194.528H26.68Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                style: {
                    mixBlendMode: "soft-light"
                },
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M63 210h.32c1.746 0 2.62 0 3.194-.528.574-.528.647-1.399.792-3.14l2.333-28c.169-2.027.253-3.04-.34-3.686-.56-.608-1.494-.644-3.299-.646l-3 36Z",
                fill: "#000",
                fillOpacity: 0.4
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28 184a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm4 0a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Z",
                fill: "#7D6FBD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23.177 147.47c.88-2.64 1.32-3.96 2.367-4.715 1.048-.755 2.44-.755 5.222-.755h28.468c2.783 0 4.174 0 5.222.755 1.047.755 1.487 2.075 2.367 4.715L69 154H21l2.177-6.53Z",
                fill: "#C9C2DE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M61 154h8l-2.177-6.53c-.88-2.64-1.32-3.96-2.367-4.715-1.048-.755-2.44-.755-5.222-.755H57l4 12Z",
                fill: "#000",
                style: {
                    mixBlendMode: "soft-light"
                },
                opacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 154,
                width: 60,
                height: 8,
                rx: 2,
                fill: "#C9C2DE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M67 154h4c1.886 0 2.828 0 3.414.586.586.586.586 1.528.586 3.414 0 1.886 0 2.828-.586 3.414-.586.586-1.528.586-3.414.586h-4v-8Z",
                fill: "#000",
                style: {
                    mixBlendMode: "soft-light"
                },
                opacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M151 221h63v7h-59a4 4 0 0 1-4-4v-3Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M207 221h33v3a4 4 0 0 1-4 4h-25a4 4 0 0 1-4-4v-3Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M211.5 223a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm-5.5-2.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM230.5 223a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm-3-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 224,
                y: 224,
                width: 4,
                height: 2,
                rx: 1,
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#5F6387",
                d: "m71.36 8.571 6.069-5.211 5.211 6.07-6.07 5.21z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#CABEFF",
                d: "m233.613 107.516 6.87 4.098-4.097 6.87-6.87-4.097z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M214.957 18.104c0-.057.047-.104.104-.104h1.878c.058 0 .104.047.104.104v3.305l2.862-1.652a.104.104 0 0 1 .142.038l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.652c.05.03.067.093.038.143l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.143l2.862-1.652-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.104.104 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#8881AA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M160.957 97a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#757CA4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m12.29 104.696 1.193 2.564a2.828 2.828 0 0 0 3.758 1.37v0A2.829 2.829 0 0 1 21 110v0a2.829 2.829 0 0 0 3.758 1.37v0a2.828 2.828 0 0 1 3.758 1.37l1.194 2.564",
                stroke: "#8183AA",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_503_14537",
                    x1: 148.16,
                    y1: 35,
                    x2: 151.66,
                    y2: 86.5,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#7958FF"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FD8EFF"
                        })
                    ]
                })
            })
        ]
    });
var $78149c015b6cf817$export$2e2bcd8739ae039 = $78149c015b6cf817$var$SvgLoadingIllustrationDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $0b1f360d2f6f7946$var$SvgLoadingIllustration = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 124,
                r: 78,
                stroke: "#5D34F2",
                strokeOpacity: 0.06,
                strokeWidth: 60
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M218.66 54a2 2 0 0 0-4 0v176a2 2 0 1 0 4 0V54Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 4,
                height: 140,
                rx: 2,
                transform: "scale(-1 1) rotate(60 -94.286 -97.308)",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M231.037 223.732a8 8 0 0 0-8-8h-24a8 8 0 0 0-8 8v8h40v-8Z",
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8,
                transform: "matrix(-1 0 0 1 224.66 76)",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 4,
                cy: 4,
                r: 4,
                transform: "matrix(-1 0 0 1 220.66 80)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 12,
                transform: "scale(-1 1) rotate(-45 1.047 204.196)",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m103.778 38.627 22.627 22.628 22.628 22.627c12.497-12.497 12.497-32.758 0-45.255-12.497-12.496-32.758-12.496-45.255 0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 134a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v100H40V134Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M44 134a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v96H44v-96Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 228h192v2a4 4 0 0 1-4 4H40v-6Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M102 130h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 84,
                y: 157,
                width: 80,
                height: 48,
                rx: 4,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 89,
                cy: 160,
                r: 1,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 93,
                cy: 160,
                r: 1,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 97,
                cy: 160,
                r: 1,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 167,
                width: 20,
                height: 4,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 130,
                y: 167,
                width: 20,
                height: 32,
                rx: 4,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 175,
                width: 28,
                height: 4,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 189,
                width: 8,
                height: 4,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M21 162h48l-5.389 64.664c-.29 3.482-.435 5.223-1.583 6.28C60.88 234 59.133 234 55.64 234H34.361c-3.494 0-5.24 0-6.389-1.056-1.148-1.057-1.293-2.798-1.583-6.28L21 162Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M69 152H21l.167 2h47.667l.166-2Z",
                fill: "#000",
                fillOpacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.68 210c-1.746 0-2.62 0-3.194-.528-.574-.528-.646-1.399-.791-3.14l-2.334-28c-.169-2.027-.253-3.04.341-3.686.594-.646 1.611-.646 3.645-.646h41.306c2.034 0 3.051 0 3.645.646.595.646.51 1.659.341 3.686l-2.333 28c-.145 1.741-.218 2.612-.792 3.14-.574.528-1.447.528-3.194.528H26.68Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                style: {
                    mixBlendMode: "soft-light"
                },
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m63 210 3-36c1.805.002 2.739.038 3.298.646.595.646.51 1.659.341 3.686l-2.333 28c-.145 1.741-.218 2.612-.792 3.14-.538.495-1.34.526-2.876.528H63Z",
                fill: "#000",
                fillOpacity: 0.4
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M28 184a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm4 0a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Zm3 1a1 1 0 0 1 2 0v16a1 1 0 0 1-2 0v-16Zm5-1a1 1 0 0 0-1 1v16a1 1 0 0 0 2 0v-16a1 1 0 0 0-1-1Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23.177 147.47c.88-2.64 1.32-3.96 2.367-4.715 1.048-.755 2.44-.755 5.222-.755h28.468c2.783 0 4.174 0 5.222.755s1.488 2.075 2.368 4.715L69 154H21l2.177-6.53Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M61 154h8l-2.176-6.53c-.88-2.64-1.32-3.96-2.368-4.715-1.048-.755-2.439-.755-5.222-.755H57l4 12Z",
                fill: "#000",
                style: {
                    mixBlendMode: "soft-light"
                },
                opacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 15,
                y: 154,
                width: 60,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M67 154h4c1.886 0 2.829 0 3.415.586.585.586.585 1.528.585 3.414 0 1.886 0 2.828-.585 3.414-.586.586-1.53.586-3.415.586h-4v-8Z",
                fill: "#000",
                style: {
                    mixBlendMode: "soft-light"
                },
                opacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M151 221h63v7h-59a4 4 0 0 1-4-4v-3Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M207 221h33v3a4 4 0 0 1-4 4h-25a4 4 0 0 1-4-4v-3Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M211.5 223a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm-5.5-2.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1ZM230.5 223a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm0 2a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm3 0a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Zm2.5.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm-3-2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5Zm3.5-.5a.5.5 0 0 0 0 1h1a.5.5 0 0 0 0-1h-1Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 224,
                y: 224,
                width: 4,
                height: 2,
                rx: 1,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 71.36,
                y: 8.571,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(-40.65 71.36 8.571)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 233.613,
                y: 107.516,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 233.613 107.516)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M214.957 18.104c0-.057.047-.104.105-.104h1.877c.058 0 .104.047.104.104v3.305l2.862-1.652a.104.104 0 0 1 .142.038l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.652c.05.03.067.093.038.143l-.938 1.626a.105.105 0 0 1-.143.038l-2.862-1.652v3.304a.104.104 0 0 1-.104.105h-1.877a.105.105 0 0 1-.105-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.143l2.862-1.652-2.862-1.652a.106.106 0 0 1-.038-.142l.939-1.626a.105.105 0 0 1 .143-.039l2.861 1.653v-3.305Z",
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m12.29 104.696 1.194 2.564a2.828 2.828 0 0 0 3.758 1.37v0A2.829 2.829 0 0 1 21 110v0a2.829 2.829 0 0 0 3.758 1.37v0a2.828 2.828 0 0 1 3.758 1.37l1.194 2.564",
                stroke: "#FFD5FF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $0b1f360d2f6f7946$export$2e2bcd8739ae039 = $0b1f360d2f6f7946$var$SvgLoadingIllustration;



var $6jNMj = parcelRequire("6jNMj");

var $93h5F = parcelRequire("93h5F");
var $75192cd91630341d$export$34e0f9847d4c02dd;
var $75192cd91630341d$export$bfd64c937657f93a;
var $75192cd91630341d$export$4a6dd88bada4e7d2;
$75192cd91630341d$export$34e0f9847d4c02dd = `FA5ZUG_container`;
$75192cd91630341d$export$bfd64c937657f93a = `FA5ZUG_rotating`;
$75192cd91630341d$export$4a6dd88bada4e7d2 = `FA5ZUG_shimmer`;


function $fa8a07d79ef6bb6a$var$AppLoading() {
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $75192cd91630341d$export$34e0f9847d4c02dd,
        children: [
            theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0b1f360d2f6f7946$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $78149c015b6cf817$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Daisy), {})
        ]
    });
}
var $fa8a07d79ef6bb6a$export$2e2bcd8739ae039 = $fa8a07d79ef6bb6a$var$AppLoading;



var $6ZMK7 = parcelRequire("6ZMK7");

var $2wPYZ = parcelRequire("2wPYZ");

var $iYZTa = parcelRequire("iYZTa");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("6ZMK7");
var $mbOAD = parcelRequire("mbOAD");
const $dcd2d6b398a9e20d$export$5027ce2731efc4b9 = ()=>{
    const { pathname: pathname, search: search, hash: hash } = window.location;
    sessionStorage.setItem((0, $mbOAD.storageKeys).redirectAfterSignIn, JSON.stringify({
        pathname: pathname,
        search: search,
        hash: hash
    }));
};
const $dcd2d6b398a9e20d$var$partialPathGuard = (0, $2CYkO.z).object({
    pathname: (0, $2CYkO.z).string(),
    search: (0, $2CYkO.z).string(),
    hash: (0, $2CYkO.z).string()
}).partial();
const $dcd2d6b398a9e20d$export$51826bb55f5be139 = ()=>{
    const saved = (0, $aWIy6.trySafe)(()=>$dcd2d6b398a9e20d$var$partialPathGuard.parse(JSON.parse(sessionStorage.getItem((0, $mbOAD.storageKeys).redirectAfterSignIn) ?? "")));
    if (saved) sessionStorage.removeItem((0, $mbOAD.storageKeys).redirectAfterSignIn);
    return saved;
};


function $a56066727231a650$export$2e2bcd8739ae039() {
    const api = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const [searchParameters] = (0, $8pPfi.useSearchParams)();
    const { isAuthenticated: isAuthenticated, isLoading: isLoading, signIn: signIn } = (0, $dtOpc.useLogto)();
    const { isInitComplete: isInitComplete, resetTenants: resetTenants } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const redirectUri = (0, $iYZTa.default)();
    (0, $eCoWV.useEffect)(()=>{
        if (!isLoading && !isAuthenticated) {
            (0, $dcd2d6b398a9e20d$export$5027ce2731efc4b9)();
            const isSignUpMode = (0, $vZyB0.yes)(searchParameters.get((0, $6ZMK7.searchKeys).signUp));
            signIn(redirectUri.href, (0, $5CQIb.conditional)(isSignUpMode && "signUp"));
        }
    }, [
        redirectUri,
        isAuthenticated,
        isLoading,
        searchParameters,
        signIn
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (isAuthenticated && !isInitComplete) {
            const loadTenants = async ()=>{
                const data = await api.get("/api/tenants");
                resetTenants(data);
            };
            loadTenants();
        }
    }, [
        api,
        isAuthenticated,
        isInitComplete,
        resetTenants
    ]);
    if (!isInitComplete || !isAuthenticated) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {});
}



var $2wPYZ = parcelRequire("2wPYZ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");


var $4W0F0 = parcelRequire("4W0F0");

/** The global callback page for all sign-in redirects from Logto main flow. */ function $ba8f7455b3577687$var$Callback() {
    const { getTo: getTo } = (0, $4W0F0.default)();
    const navigate = (0, $9X5Bp.useNavigate)();
    (0, $dtOpc.useHandleSignInCallback)(()=>{
        const saved = (0, $dcd2d6b398a9e20d$export$51826bb55f5be139)();
        if (saved) {
            // Saved redirect is full pathname, no need to use `getTo`.
            navigate(saved, {
                replace: true
            });
            return;
        }
        navigate("/", {
            replace: true
        });
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}
var $ba8f7455b3577687$export$2e2bcd8739ae039 = $ba8f7455b3577687$var$Callback;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $bNFMZ = parcelRequire("bNFMZ");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");
var $a0a31230e6397188$exports = {};

!function(e, t) {
    $a0a31230e6397188$exports = t((parcelRequire("eCoWV")));
}("undefined" != typeof self ? self : $a0a31230e6397188$exports, function(e) {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var o = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var o in e)r.d(n, o, (function(t) {
                return e[t];
            }).bind(null, o));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 3);
    }([
        function(t, r) {
            t.exports = e;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.Validate = t.Time = void 0;
            var n = u(r(5)), o = u(r(6));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.Time = n.default, t.Validate = o.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useInterval = void 0;
            var n = function(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }(r(7));
            t.useInterval = n.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.useTime = t.useStopwatch = t.useTimer = void 0;
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            };
            t.default = function(e) {
                if ((0, o.useEffect)(function() {
                    console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead");
                }, []), e.expiryTimestamp) {
                    var t = (0, u.default)(e);
                    return n({}, t, {
                        startTimer: t.start,
                        stopTimer: t.pause,
                        resetTimer: function() {}
                    });
                }
                var r = (0, i.default)(e);
                return n({}, r, {
                    startTimer: r.start,
                    stopTimer: r.pause,
                    resetTimer: r.reset
                });
            };
            var o = r(0), u = c(r(4)), i = c(r(8)), a = c(r(9));
            function c(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            t.useTimer = u.default, t.useStopwatch = i.default, t.useTime = a.default;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.expiryTimestamp, r = e.onExpire, s = e.autoStart, l = void 0 === s || s, d = (0, u.useState)(t), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(i.Time.getSecondsFromExpiry(v)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(l), S = o(h, 2), w = S[0], O = S[1], j = (0, u.useState)(l), x = o(j, 2), _ = x[0], M = x[1], P = (0, u.useState)(f(v)), F = o(P, 2), E = F[0], k = F[1];
                function I(e) {
                    var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    k(f(e)), M(t), O(t), p(e), b(i.Time.getSecondsFromExpiry(e));
                }
                function D() {
                    var e = new Date;
                    e.setMilliseconds(e.getMilliseconds() + 1e3 * g), I(e);
                }
                return (0, a.useInterval)(function() {
                    E !== c && k(c);
                    var e = i.Time.getSecondsFromExpiry(v);
                    b(e), e <= 0 && (i.Validate.onExpire(r) && r(), O(!1), k(null));
                }, w ? E : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        _ ? (b(i.Time.getSecondsFromExpiry(v)), O(!0)) : D();
                    },
                    pause: function() {
                        O(!1);
                    },
                    resume: D,
                    restart: I,
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2), c = 1e3;
            function f(e) {
                if (!i.Validate.expiryTimestamp(e)) return null;
                var t = i.Time.getSecondsFromExpiry(e), r = Math.floor(1e3 * (t - Math.floor(t)));
                return r > 0 ? r : c;
            }
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "getTimeFromSeconds",
                        value: function(e) {
                            var t = Math.ceil(e), r = Math.floor(t / 86400), n = Math.floor(t % 86400 / 3600), o = Math.floor(t % 3600 / 60);
                            return {
                                seconds: Math.floor(t % 60),
                                minutes: o,
                                hours: n,
                                days: r
                            };
                        }
                    },
                    {
                        key: "getSecondsFromExpiry",
                        value: function(e, t) {
                            var r = e - (new Date).getTime();
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromPrevTime",
                        value: function(e, t) {
                            var r = (new Date).getTime() - e;
                            if (r > 0) {
                                var n = r / 1e3;
                                return t ? Math.round(n) : n;
                            }
                            return 0;
                        }
                    },
                    {
                        key: "getSecondsFromTimeNow",
                        value: function() {
                            var e = new Date;
                            return e.getTime() / 1e3 - 60 * e.getTimezoneOffset();
                        }
                    },
                    {
                        key: "getFormattedTimeFromSeconds",
                        value: function(t, r) {
                            var n = e.getTimeFromSeconds(t), o = n.seconds, u = n.minutes, i = n.hours, a = "", c = i;
                            return "12-hour" === r && (a = i >= 12 ? "pm" : "am", c = i % 12), {
                                seconds: o,
                                minutes: u,
                                hours: c,
                                ampm: a
                            };
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = function() {
                function e(e, t) {
                    for(var r = 0; r < t.length; r++){
                        var n = t[r];
                        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                    }
                }
                return function(t, r, n) {
                    return r && e(t.prototype, r), n && e(t, n), t;
                };
            }();
            var o = function() {
                function e() {
                    !function(e, t) {
                        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                    }(this, e);
                }
                return n(e, null, [
                    {
                        key: "expiryTimestamp",
                        value: function(e) {
                            var t = new Date(e).getTime() > 0;
                            return t || console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings", e), t;
                        }
                    },
                    {
                        key: "onExpire",
                        value: function(e) {
                            var t = e && "function" == typeof e;
                            return e && !t && console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function", e), t;
                        }
                    }
                ]), e;
            }();
            t.default = o;
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            }), t.default = function(e, t) {
                var r = (0, n.useRef)();
                (0, n.useEffect)(function() {
                    r.current = e;
                }), (0, n.useEffect)(function() {
                    if (!t) return function() {};
                    var e = setInterval(function() {
                        r.current && r.current();
                    }, t);
                    return function() {
                        return clearInterval(e);
                    };
                }, [
                    t
                ]);
            };
            var n = r(0);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.autoStart, r = e.offsetTimestamp, c = (0, u.useState)(i.Time.getSecondsFromExpiry(r, !0) || 0), f = o(c, 2), s = f[0], l = f[1], d = (0, u.useState)(new Date), m = o(d, 2), v = m[0], p = m[1], y = (0, u.useState)(s + i.Time.getSecondsFromPrevTime(v || 0, !0)), T = o(y, 2), g = T[0], b = T[1], h = (0, u.useState)(t), S = o(h, 2), w = S[0], O = S[1];
                return (0, a.useInterval)(function() {
                    b(s + i.Time.getSecondsFromPrevTime(v, !0));
                }, w ? 1e3 : null), n({}, i.Time.getTimeFromSeconds(g), {
                    start: function() {
                        var e = new Date;
                        p(e), O(!0), b(s + i.Time.getSecondsFromPrevTime(e, !0));
                    },
                    pause: function() {
                        l(g), O(!1);
                    },
                    reset: function() {
                        var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : 0, t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], r = i.Time.getSecondsFromExpiry(e, !0) || 0, n = new Date;
                        p(n), l(r), O(t), b(r + i.Time.getSecondsFromPrevTime(n, !0));
                    },
                    isRunning: w
                });
            };
            var u = r(0), i = r(1), a = r(2);
        },
        function(e, t, r) {
            "use strict";
            Object.defineProperty(t, "__esModule", {
                value: !0
            });
            var n = Object.assign || function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var r = arguments[t];
                    for(var n in r)Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
                }
                return e;
            }, o = function() {
                return function(e, t) {
                    if (Array.isArray(e)) return e;
                    if (Symbol.iterator in Object(e)) return function(e, t) {
                        var r = [], n = !0, o = !1, u = void 0;
                        try {
                            for(var i, a = e[Symbol.iterator](); !(n = (i = a.next()).done) && (r.push(i.value), !t || r.length !== t); n = !0);
                        } catch (e) {
                            o = !0, u = e;
                        } finally{
                            try {
                                !n && a.return && a.return();
                            } finally{
                                if (o) throw u;
                            }
                        }
                        return r;
                    }(e, t);
                    throw new TypeError("Invalid attempt to destructure non-iterable instance");
                };
            }();
            t.default = function(e) {
                var t = e.format, r = (0, u.useState)(i.Time.getSecondsFromTimeNow()), c = o(r, 2), f = c[0], s = c[1];
                return (0, a.useInterval)(function() {
                    s(i.Time.getSecondsFromTimeNow());
                }, 1e3), n({}, i.Time.getFormattedTimeFromSeconds(f, t));
            };
            var u = r(0), i = r(1), a = r(2);
        }
    ]);
});



var $2mi28 = parcelRequire("2mi28");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
function $d04c4b0a9c4b34f2$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    return string.toLowerCase().replaceAll(/(?:^|\s|-)\S/g, (x)=>x.toUpperCase());
}



var $2CYkO = parcelRequire("2CYkO");
var $4b7ab4566c750149$export$e88bde3ace5c7bbf;
(function(ReservedPlanName) {
    ReservedPlanName["Free"] = "Free";
    ReservedPlanName["Hobby"] = "Hobby";
    ReservedPlanName["Pro"] = "Pro";
    ReservedPlanName["Enterprise"] = "Enterprise";
})($4b7ab4566c750149$export$e88bde3ace5c7bbf || ($4b7ab4566c750149$export$e88bde3ace5c7bbf = {}));
var $4b7ab4566c750149$export$65033dd04f7aee7d;
(function(SubscriptionPlanTableGroupKey) {
    SubscriptionPlanTableGroupKey["base"] = "base";
    SubscriptionPlanTableGroupKey["applications"] = "applications";
    SubscriptionPlanTableGroupKey["resources"] = "resources";
    SubscriptionPlanTableGroupKey["branding"] = "branding";
    SubscriptionPlanTableGroupKey["userAuthentication"] = "userAuthentication";
    SubscriptionPlanTableGroupKey["roles"] = "roles";
    SubscriptionPlanTableGroupKey["auditLogs"] = "auditLogs";
    SubscriptionPlanTableGroupKey["hooks"] = "hooks";
    SubscriptionPlanTableGroupKey["organizations"] = "organizations";
    SubscriptionPlanTableGroupKey["support"] = "support";
})($4b7ab4566c750149$export$65033dd04f7aee7d || ($4b7ab4566c750149$export$65033dd04f7aee7d = {}));
const $4b7ab4566c750149$export$474ca7aa7445cdae = (0, $2CYkO.z).object({
    state: (0, $2CYkO.z).string(),
    sessionId: (0, $2CYkO.z).string(),
    callbackPage: (0, $2CYkO.z).string().optional(),
    isDowngrade: (0, $2CYkO.z).boolean().optional()
});


const $ec0d8eaa8ea67c57$var$registeredPlanNamePhraseMap = {
    quotaKey: undefined,
    [(0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Free]: "free_plan",
    [(0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Hobby]: "hobby_plan",
    [(0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Pro]: "pro_plan",
    [(0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Enterprise]: "enterprise"
};
function $ec0d8eaa8ea67c57$var$PlanName({ name: name, isTitleCase: isTitleCase = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const planNamePhrase = $ec0d8eaa8ea67c57$var$registeredPlanNamePhraseMap[name];
    /**
   * Note: fallback to the plan name if the phrase is not registered.
   */ const planName = planNamePhrase ? String(t(planNamePhrase)) : name;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: isTitleCase ? (0, $d04c4b0a9c4b34f2$export$2e2bcd8739ae039)(planName) : planName
    });
}
var $ec0d8eaa8ea67c57$export$2e2bcd8739ae039 = $ec0d8eaa8ea67c57$var$PlanName;


parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
const $c96317af8597c55a$export$1d205931921a7a70 = [
    (0, $ckJfF.ReservedPlanId).Free,
    (0, $ckJfF.ReservedPlanId).Hobby,
    (0, $ckJfF.ReservedPlanId).Pro
];
const $c96317af8597c55a$export$d3db8605a7f752d9 = [
    (0, $ckJfF.ReservedPlanId).Free,
    (0, $ckJfF.ReservedPlanId).Hobby,
    (0, $ckJfF.ReservedPlanId).Pro
];
const $c96317af8597c55a$export$bc242540c43bf946 = "checkout-state";



var $2wPYZ = parcelRequire("2wPYZ");

var $eCoWV = parcelRequire("eCoWV");

var $iwEyX = parcelRequire("iwEyX");


var $V1X8c = parcelRequire("V1X8c");

const $65a670f1c344d535$export$b035e44d7bb4278f = (order)=>{
    return (previous, next)=>{
        const preIndex = order.indexOf(previous);
        const nextIndex = order.indexOf(next);
        // Note: If both items not present in the order array, sort them in default order
        if (preIndex === -1 && nextIndex === -1) return 0;
        // Note: If only the previous item is not present in the order array, move it to the end
        if (preIndex === -1) return 1;
        // Note: If only the next item is not present in the order array, keep it in the end
        if (nextIndex === -1) return -1;
        // Note: Compare them based on the index in the order array
        return preIndex - nextIndex;
    };
};


parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $aWIy6 = parcelRequire("aWIy6");


var $bNFMZ = parcelRequire("bNFMZ");

parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

const $22b72719037fdeab$export$b3650eb261ff6f3 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$c61300bd74c09979 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$efacd6af85652202 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$3cb42d554c876baf = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$aecc0a4adaffa522 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$67f5d6f8d5cefc45 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$e6a3866b2ed99278 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$84203c51b0d4c7a8 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$84644eb2e3da3d30 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$4e90a6e134d806c6 = {
    [(0, $ckJfF.ReservedPlanId).Free]: true,
    [(0, $ckJfF.ReservedPlanId).Hobby]: true,
    [(0, $ckJfF.ReservedPlanId).Pro]: true
};
const $22b72719037fdeab$export$5a61f5d940231afb = {
    [(0, $ckJfF.ReservedPlanId).Free]: 0,
    [(0, $ckJfF.ReservedPlanId).Hobby]: 72,
    [(0, $ckJfF.ReservedPlanId).Pro]: 48
};
/**
 * Note: this is only for display purpose.
 *
 * `null` => Unlimited
 * `undefined` => Contact
 */ const $22b72719037fdeab$var$enterprisePlanTable = {
    basePrice: undefined,
    mauUnitPrice: undefined,
    mauLimit: undefined,
    applicationsLimit: undefined,
    machineToMachineLimit: undefined,
    resourcesLimit: undefined,
    scopesPerResourceLimit: undefined,
    customDomainEnabled: true,
    customCssEnabled: true,
    appLogoAndFaviconEnabled: true,
    darkModeEnabled: true,
    i18nEnabled: true,
    mfaEnabled: true,
    omniSignInEnabled: true,
    passwordSignInEnabled: true,
    passwordlessSignInEnabled: true,
    emailConnectorsEnabled: true,
    smsConnectorsEnabled: true,
    socialConnectorsLimit: undefined,
    standardConnectorsLimit: undefined,
    userManagementEnabled: true,
    rolesLimit: undefined,
    scopesPerRoleLimit: undefined,
    auditLogsRetentionDays: undefined,
    hooksLimit: undefined,
    communitySupportEnabled: true,
    ticketSupportResponseTime: undefined,
    organizationsEnabled: true,
    ssoEnabled: true
};
const $22b72719037fdeab$export$70a69047fe35dc2e = {
    id: "enterprise",
    name: (0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Enterprise,
    table: $22b72719037fdeab$var$enterprisePlanTable
};
const $22b72719037fdeab$export$c7328c7d01ec967d = Object.freeze({
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).base]: [
        "basePrice",
        "mauUnitPrice",
        "mauLimit"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).applications]: [
        "applicationsLimit",
        "machineToMachineLimit"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).resources]: [
        "resourcesLimit",
        "scopesPerResourceLimit"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).branding]: [
        "customDomainEnabled",
        "customCssEnabled",
        "appLogoAndFaviconEnabled",
        "darkModeEnabled",
        "i18nEnabled"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).userAuthentication]: [
        "mfaEnabled",
        "omniSignInEnabled",
        "passwordSignInEnabled",
        "passwordlessSignInEnabled",
        "emailConnectorsEnabled",
        "smsConnectorsEnabled",
        "socialConnectorsLimit",
        "standardConnectorsLimit",
        "ssoEnabled"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).roles]: [
        "userManagementEnabled",
        "rolesLimit",
        "scopesPerRoleLimit"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).organizations]: [
        "organizationsEnabled"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).auditLogs]: [
        "auditLogsRetentionDays"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).hooks]: [
        "hooksLimit"
    ],
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).support]: [
        "communitySupportEnabled",
        "ticketSupportResponseTime"
    ]
});
const $22b72719037fdeab$export$103450479c8ed1e3 = Object.values($22b72719037fdeab$export$c7328c7d01ec967d).flat();
const $22b72719037fdeab$export$69143de3c73b76af = [];



const $f11d0f720bf4029b$export$e0876f9cbc4219ca = (subscriptionPlanResponse)=>{
    const { id: id, quota: quota } = subscriptionPlanResponse;
    return {
        ...subscriptionPlanResponse,
        quota: {
            ...quota,
            communitySupportEnabled: (0, $22b72719037fdeab$export$4e90a6e134d806c6)[id] ?? false,
            ticketSupportResponseTime: (0, $22b72719037fdeab$export$5a61f5d940231afb)[id] ?? 0
        }
    };
};
const $f11d0f720bf4029b$var$getSubscriptionPlanOrderById = (id)=>{
    const index = (0, $c96317af8597c55a$export$d3db8605a7f752d9).indexOf(id);
    // Note: if the plan id is not in the featuredPlanIdOrder, it will be treated as the highest priority
    return index === -1 ? Number.POSITIVE_INFINITY : index;
};
const $f11d0f720bf4029b$export$64dac4cdd03b50e1 = (fromPlanId, toPlanId)=>$f11d0f720bf4029b$var$getSubscriptionPlanOrderById(fromPlanId) > $f11d0f720bf4029b$var$getSubscriptionPlanOrderById(toPlanId);
const $f11d0f720bf4029b$export$b971ca6f7de66f44 = ({ periodStart: periodStart, periodEnd: periodEnd, displayYear: displayYear })=>{
    const format = displayYear ? "MMM D, YYYY" : "MMM D";
    const formattedStart = (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))(periodStart).format(format);
    const formattedEnd = (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))(periodEnd).format(format);
    return `${formattedStart} - ${formattedEnd}`;
};
const $f11d0f720bf4029b$export$c0ed1fa5d8f3e3a5 = async (error)=>{
    if (!(error instanceof (0, $a819ec4606730a84$export$286baf652d0b1206))) return [
        false
    ];
    const { message: message } = await (0, $3978b41c434b0156$export$5c32b0b3061e00c4)(error) ?? {};
    const match = message?.match(/Status exception: Exceeded quota limit\. (.+)$/);
    if (!match) return [
        false
    ];
    const data = match[1];
    const exceededQuota = (0, $5CQIb.conditional)(// eslint-disable-next-line no-restricted-syntax -- trust the type from the server if error message matches
    data && (0, $aWIy6.trySafe)(()=>JSON.parse(data)));
    if (!exceededQuota) return [
        false
    ];
    // eslint-disable-next-line no-restricted-syntax
    return [
        true,
        Object.keys(exceededQuota)
    ];
};
const $f11d0f720bf4029b$export$1673a249ab23858e = (plans)=>plans.filter(({ id: id })=>(0, $c96317af8597c55a$export$1d205931921a7a70).includes(id));


const $066887fd7bfc3383$var$useSubscriptionPlans = ()=>{
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const useSwrResponse = (0, $iwEyX.default)((0, $V1X8c.isCloud) && "/api/subscription-plans", async ()=>cloudApi.get("/api/subscription-plans"));
    const { data: subscriptionPlansResponse } = useSwrResponse;
    const subscriptionPlans = (0, $eCoWV.useMemo)(()=>{
        if (!subscriptionPlansResponse) return;
        return subscriptionPlansResponse.map((plan)=>(0, $f11d0f720bf4029b$export$e0876f9cbc4219ca)(plan)).slice().sort(({ id: previousId }, { id: nextId })=>(0, $65a670f1c344d535$export$b035e44d7bb4278f)((0, $c96317af8597c55a$export$d3db8605a7f752d9))(previousId, nextId));
    }, [
        subscriptionPlansResponse
    ]);
    return {
        ...useSwrResponse,
        data: subscriptionPlans
    };
};
var $066887fd7bfc3383$export$2e2bcd8739ae039 = $066887fd7bfc3383$var$useSubscriptionPlans;



var $4W0F0 = parcelRequire("4W0F0");
parcelRequire("6ZMK7");
var $mbOAD = parcelRequire("mbOAD");


var $5a1Rp = parcelRequire("5a1Rp");
const $872d085a872e06c4$export$c162b38bc26bbdbf = (session)=>{
    sessionStorage.setItem((0, $mbOAD.storageKeys).checkoutSession, JSON.stringify(session));
};
const $872d085a872e06c4$export$5cb86149c23fcebb = ()=>{
    const sessionValue = sessionStorage.getItem((0, $mbOAD.storageKeys).checkoutSession);
    if (!sessionValue) return;
    const sessionJson = (0, $5a1Rp.safeParseJson)(sessionValue);
    if (!sessionJson.success) return;
    const parsedSession = (0, $4b7ab4566c750149$export$474ca7aa7445cdae).safeParse(sessionJson.data);
    if (!parsedSession.success) return;
    return parsedSession.data;
};
const $872d085a872e06c4$export$ab08d6a6b54bf937 = ()=>{
    sessionStorage.removeItem((0, $mbOAD.storageKeys).checkoutSession);
};


const $dfc4f3fe135b4f83$var$consoleHomePage = "/";
const $dfc4f3fe135b4f83$var$subscriptionCheckingInterval = 1000;
const $dfc4f3fe135b4f83$var$subscriptionCheckingTimeout = 10000;
function $dfc4f3fe135b4f83$var$CheckoutSuccessCallback() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const { currentTenantId: currentTenantId, navigateTenant: navigateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { search: search } = (0, $9X5Bp.useLocation)();
    const checkoutState = new URLSearchParams(search).get((0, $c96317af8597c55a$export$bc242540c43bf946));
    const { state: state, sessionId: sessionId, callbackPage: callbackPage, isDowngrade: isDowngrade } = (0, $872d085a872e06c4$export$5cb86149c23fcebb)() ?? {};
    const { data: subscriptionPlans, error: fetchPlansError } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const isLoadingPlans = !subscriptionPlans && !fetchPlansError;
    // Note: if we can't get the subscription results in 10 seconds, we will redirect to the console home page
    (0, $a0a31230e6397188$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))().add($dfc4f3fe135b4f83$var$subscriptionCheckingTimeout, "millisecond").toDate(),
        onExpire: ()=>{
            (0, $horhC.toast).error(t("subscription_check_timeout"));
            (0, $872d085a872e06c4$export$ab08d6a6b54bf937)();
            navigate($dfc4f3fe135b4f83$var$consoleHomePage, {
                replace: true
            });
        }
    });
    // Note: only handle the callback comes from the stripe success callback url
    const isValidSession = state && state === checkoutState;
    const { data: stripeCheckoutSession } = (0, $2mi28.default)(isValidSession && sessionId && `/api/checkout-session/${sessionId}`, async ()=>cloudApi.get("/api/checkout-session/:id", {
            params: {
                id: (0, $5CQIb.conditionalString)(sessionId)
            }
        }), {
        refreshInterval: $dfc4f3fe135b4f83$var$subscriptionCheckingInterval
    });
    const checkoutTenantId = stripeCheckoutSession?.tenantId;
    const checkoutPlanId = stripeCheckoutSession?.planId;
    const { data: tenantSubscription } = (0, $2mi28.default)(checkoutTenantId && `/api/tenants/${checkoutTenantId}/subscription`, async ()=>cloudApi.get("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: (0, $5CQIb.conditionalString)(checkoutTenantId)
            }
        }), {
        refreshInterval: $dfc4f3fe135b4f83$var$subscriptionCheckingInterval
    });
    const isCheckoutSuccessful = !isLoadingPlans && checkoutTenantId && stripeCheckoutSession.status === "complete" && checkoutPlanId === tenantSubscription?.planId;
    (0, $eCoWV.useEffect)(()=>{
        if (isCheckoutSuccessful) {
            (0, $872d085a872e06c4$export$ab08d6a6b54bf937)();
            const checkoutPlan = subscriptionPlans?.find((plan)=>plan.id === checkoutPlanId);
            if (checkoutPlan) (0, $horhC.toast).success(/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: checkoutPlan.name
                    })
                },
                children: t(isDowngrade ? "downgrade_success" : "upgrade_success")
            }));
            if (checkoutTenantId === currentTenantId) {
                navigate((0, $5CQIb.conditional)(callbackPage) ?? $dfc4f3fe135b4f83$var$consoleHomePage, {
                    replace: true
                });
                return;
            }
            // Note: the tenant is created after checkout.
            navigateTenant(checkoutTenantId);
        }
    }, [
        callbackPage,
        checkoutPlanId,
        checkoutTenantId,
        currentTenantId,
        isCheckoutSuccessful,
        isDowngrade,
        navigate,
        navigateTenant,
        subscriptionPlans,
        t
    ]);
    if (!isValidSession && !isLoadingPlans) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
        replace: true,
        to: $dfc4f3fe135b4f83$var$consoleHomePage
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}
var $dfc4f3fe135b4f83$export$2e2bcd8739ae039 = $dfc4f3fe135b4f83$var$CheckoutSuccessCallback;


var $b2c3a31f968292bb$export$729c8b7179294ba;
$b2c3a31f968292bb$export$729c8b7179294ba = `mKruhW_app`;



var $9zeGj = parcelRequire("9zeGj");


var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");

var $2mi28 = parcelRequire("2mi28");
parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $2ANSb = parcelRequire("2ANSb");

var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2ANSb = parcelRequire("2ANSb");
const $9c44974c18641844$var$useSwrFetcher = (api)=>{
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const fetcher = (0, $eCoWV.useCallback)(async (resource)=>{
        try {
            const response = await api.get(resource);
            const data = await response.json();
            if (typeof resource === "string" && resource.includes("?")) {
                const parameters = new URLSearchParams(resource.split("?")[1]);
                if (parameters.get("page") && parameters.get("page_size")) {
                    const number = response.headers.get("Total-Number");
                    if (!number) throw new Error(t("errors.missing_total_number"));
                    return [
                        data,
                        Number(number)
                    ];
                }
            }
            return data;
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                const { response: response } = error;
                // See https://stackoverflow.com/questions/53511974/javascript-fetch-failed-to-execute-json-on-response-body-stream-is-locked
                // for why `.clone()` is needed
                throw new (0, $2ANSb.RequestError)(response.status, await response.clone().json());
            }
            throw error;
        }
    }, [
        api,
        t
    ]);
    return fetcher;
};
var $9c44974c18641844$export$2e2bcd8739ae039 = $9c44974c18641844$var$useSwrFetcher;


const $475a856ff8d4300b$var$useCurrentUser = ()=>{
    const { isAuthenticated: isAuthenticated } = (0, $dtOpc.useLogto)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator
    });
    const fetcher = (0, $9c44974c18641844$export$2e2bcd8739ae039)(api);
    const { data: user, error: error, mutate: mutate } = (0, $2mi28.default)(isAuthenticated && "me", fetcher);
    const isLoading = !user && !error;
    return {
        user: user,
        isLoading: isLoading,
        error: error,
        reload: mutate,
        api: api
    };
};
var $475a856ff8d4300b$export$2e2bcd8739ae039 = $475a856ff8d4300b$var$useCurrentUser;


const $dbaffd50cd7c731f$var$useMeCustomData = ()=>{
    const { user: user, isLoading: isLoading, error: error, reload: reload, api: api } = (0, $475a856ff8d4300b$export$2e2bcd8739ae039)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const update = (0, $eCoWV.useCallback)(async (customData)=>{
        if (!user) {
            (0, $horhC.toast).error(t("errors.unexpected_error"));
            return;
        }
        await reload({
            ...user,
            customData: await api.patch(`me/custom-data`, {
                json: customData
            }).json()
        });
    }, [
        api,
        reload,
        t,
        user
    ]);
    return {
        data: user?.customData,
        error: error,
        isLoading: isLoading,
        isLoaded: !isLoading && !error,
        update: /** Patch (shallow merge) the custom data of the current user. */ update
    };
};
var $dbaffd50cd7c731f$export$2e2bcd8739ae039 = $dbaffd50cd7c731f$var$useMeCustomData;


parcelRequire("j6dBR");
var $8zpKJ = parcelRequire("8zpKJ");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $eCoWV = parcelRequire("eCoWV");

var $2CYkO = parcelRequire("2CYkO");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

const $04fdf6fb7d151380$var$key = "defaultTenantId";
/**
 * A hook that gets the default tenant ID for the current user from user's `customData`.
 *
 * - By default, the default tenant ID is empty, which means the first tenant is the default tenant.
 * - If the default tenant ID is not available to the user anymore, it semantically equals to the first tenant ID.
 */ const $04fdf6fb7d151380$var$useUserDefaultTenantId = ()=>{
    const { data: data, update: updateMeCustomData } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const { tenants: tenants, currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    /** The current stored default tenant ID in the user's `customData`. */ const storedId = (0, $eCoWV.useMemo)(()=>(0, $aWIy6.trySafe)(()=>(0, $2CYkO.z).object({
                [$04fdf6fb7d151380$var$key]: (0, $2CYkO.z).string()
            }).parse(data)[$04fdf6fb7d151380$var$key]), [
        data
    ]);
    const defaultTenantId = (0, $eCoWV.useMemo)(()=>{
        // Directly return the default tenant ID for OSS because it's single tenant.
        if (!(0, $V1X8c.isCloud)) return 0, $8zpKJ.defaultTenantId;
        // Ensure the stored ID is still available to the user.
        if (storedId && tenants.some(({ id: id })=>id === storedId)) return storedId;
        // Fall back to the first tenant ID.
        return tenants[0]?.id;
    }, [
        storedId,
        tenants
    ]);
    const updateDefaultTenantId = (0, $eCoWV.useCallback)(async (tenantId)=>{
        // No need for updating for OSS because it's single tenant.
        if (!(0, $V1X8c.isCloud)) return;
        await updateMeCustomData({
            [$04fdf6fb7d151380$var$key]: tenantId
        });
    }, [
        updateMeCustomData
    ]);
    return (0, $eCoWV.useMemo)(()=>({
            defaultTenantId: defaultTenantId,
            updateDefaultTenantId: updateDefaultTenantId
        }), [
        defaultTenantId,
        updateDefaultTenantId
    ]);
};
var $04fdf6fb7d151380$export$2e2bcd8739ae039 = $04fdf6fb7d151380$var$useUserDefaultTenantId;


parcelRequire("j6dBR");
var $8zpKJ = parcelRequire("8zpKJ");

var $eCoWV = parcelRequire("eCoWV");

var $2CYkO = parcelRequire("2CYkO");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");


var $2CYkO = parcelRequire("2CYkO");
var $49a3cd5201e05816$export$329ee42b27a3306e;
(function(OnboardingRoute) {
    OnboardingRoute["Onboarding"] = "onboarding";
})($49a3cd5201e05816$export$329ee42b27a3306e || ($49a3cd5201e05816$export$329ee42b27a3306e = {}));
var $49a3cd5201e05816$export$1572a1adf9290869;
(function(OnboardingPage) {
    OnboardingPage["Welcome"] = "welcome";
    OnboardingPage[/** @deprecated Merged `about-user` to `welcome` page. */ "AboutUser"] = "about-user";
    OnboardingPage["SignInExperience"] = "sign-in-experience";
    OnboardingPage[/** @deprecated Remove this to shorten onboarding process. */ "Congrats"] = "congrats";
})($49a3cd5201e05816$export$1572a1adf9290869 || ($49a3cd5201e05816$export$1572a1adf9290869 = {}));
var $49a3cd5201e05816$export$b6032183171af19f;
(function(Project) {
    Project["Personal"] = "personal";
    Project["Company"] = "company";
})($49a3cd5201e05816$export$b6032183171af19f || ($49a3cd5201e05816$export$b6032183171af19f = {}));
var /** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ $49a3cd5201e05816$var$DeploymentType;
(function(DeploymentType) {
    DeploymentType["OpenSource"] = "open-source";
    DeploymentType["Cloud"] = "cloud";
})($49a3cd5201e05816$var$DeploymentType || ($49a3cd5201e05816$var$DeploymentType = {}));
var $49a3cd5201e05816$export$f99233281efd08a0;
(function(Title) {
    Title["Developer"] = "developer";
    Title["TeamLead"] = "team-lead";
    Title["Ceo"] = "ceo";
    Title["Cto"] = "cto";
    Title["Product"] = "product";
    Title["Others"] = "others";
})($49a3cd5201e05816$export$f99233281efd08a0 || ($49a3cd5201e05816$export$f99233281efd08a0 = {}));
var $49a3cd5201e05816$export$41cc48adf872ce3b;
(function(CompanySize) {
    CompanySize["Scale1"] = "1";
    CompanySize["Scale2"] = "2-49";
    CompanySize["Scale3"] = "50-199";
    CompanySize["Scale4"] = "200-999";
    CompanySize["Scale5"] = "1000+";
})($49a3cd5201e05816$export$41cc48adf872ce3b || ($49a3cd5201e05816$export$41cc48adf872ce3b = {}));
var $49a3cd5201e05816$export$fe867595c4640fb1;
(function(Reason) {
    Reason["Passwordless"] = "passwordless";
    Reason["Efficiency"] = "efficiency";
    Reason["AccessControl"] = "access-control";
    Reason["MultiTenancy"] = "multi-tenancy";
    Reason["Enterprise"] = "enterprise";
    Reason["Others"] = "others";
})($49a3cd5201e05816$export$fe867595c4640fb1 || ($49a3cd5201e05816$export$fe867595c4640fb1 = {}));
const $49a3cd5201e05816$var$questionnaireGuard = (0, $2CYkO.z).object({
    project: (0, $2CYkO.z).nativeEnum($49a3cd5201e05816$export$b6032183171af19f).optional(),
    /** @deprecated Open-source options was for cloud preview use, no longer needed. Use default `Cloud` value for placeholder. */ deploymentType: (0, $2CYkO.z).nativeEnum($49a3cd5201e05816$var$DeploymentType).optional().default($49a3cd5201e05816$var$DeploymentType.Cloud),
    titles: (0, $2CYkO.z).array((0, $2CYkO.z).nativeEnum($49a3cd5201e05816$export$f99233281efd08a0)).optional(),
    companyName: (0, $2CYkO.z).string().optional(),
    companySize: (0, $2CYkO.z).nativeEnum($49a3cd5201e05816$export$41cc48adf872ce3b).optional(),
    reasons: (0, $2CYkO.z).array((0, $2CYkO.z).nativeEnum($49a3cd5201e05816$export$fe867595c4640fb1)).optional()
});
const $49a3cd5201e05816$export$a9c4e6d214c76225 = (0, $2CYkO.z).object({
    questionnaire: $49a3cd5201e05816$var$questionnaireGuard.optional(),
    isOnboardingDone: (0, $2CYkO.z).boolean().optional()
});
var $49a3cd5201e05816$export$d9e3c9dc7eaad0c3;
(function(Authentication) {
    Authentication["Password"] = "password";
    Authentication["VerificationCode"] = "verificationCode";
})($49a3cd5201e05816$export$d9e3c9dc7eaad0c3 || ($49a3cd5201e05816$export$d9e3c9dc7eaad0c3 = {}));


const $abb531754ca753b0$var$userOnboardingDataKey = "onboarding";
const $abb531754ca753b0$var$useUserOnboardingData = ()=>{
    const { data: data, error: error, isLoading: isLoading, isLoaded: isLoaded, update: updateMeCustomData } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const userOnboardingData = (0, $eCoWV.useMemo)(()=>{
        const parsed = (0, $2CYkO.z).object({
            [$abb531754ca753b0$var$userOnboardingDataKey]: (0, $49a3cd5201e05816$export$a9c4e6d214c76225)
        }).safeParse(data);
        return parsed.success ? parsed.data[$abb531754ca753b0$var$userOnboardingDataKey] : {};
    }, [
        data
    ]);
    const isOnboarding = (0, $eCoWV.useMemo)(()=>{
        if (!(0, $V1X8c.isCloud)) return false;
        if (currentTenantId === (0, $8zpKJ.adminTenantId)) return false;
        return !userOnboardingData.isOnboardingDone;
    }, [
        currentTenantId,
        userOnboardingData.isOnboardingDone
    ]);
    const isBusinessPlan = (0, $eCoWV.useMemo)(()=>{
        if (!(0, $V1X8c.isCloud)) return false;
        if (currentTenantId === (0, $8zpKJ.adminTenantId)) return true;
        return userOnboardingData.questionnaire?.project === (0, $49a3cd5201e05816$export$b6032183171af19f).Company;
    }, [
        currentTenantId,
        userOnboardingData.questionnaire?.project
    ]);
    const update = (0, $eCoWV.useCallback)(async (data)=>{
        await updateMeCustomData({
            [$abb531754ca753b0$var$userOnboardingDataKey]: {
                ...userOnboardingData,
                ...data
            }
        });
    }, [
        updateMeCustomData,
        userOnboardingData
    ]);
    return {
        data: userOnboardingData,
        error: error,
        isLoading: isLoading,
        isLoaded: isLoaded,
        isOnboarding: isOnboarding,
        isBusinessPlan: isBusinessPlan,
        update: update
    };
};
var $abb531754ca753b0$export$2e2bcd8739ae039 = $abb531754ca753b0$var$useUserOnboardingData;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");



var $2wPYZ = parcelRequire("2wPYZ");
function $274536d386802fb9$export$2e2bcd8739ae039() {
    const api = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const { prependTenant: prependTenant, tenants: tenants } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    (0, $eCoWV.useEffect)(()=>{
        const createTenant = async ()=>{
            const newTenant = await api.post("/api/tenants", {
                body: {}
            });
            prependTenant(newTenant);
        };
        if (tenants.length === 0) createTenant();
    }, [
        api,
        prependTenant,
        tenants.length
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");


var $2wPYZ = parcelRequire("2wPYZ");
function $3115c8d2e23a015a$var$Redirect({ toTenantId: toTenantId }) {
    const { navigateTenant: navigateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    (0, $eCoWV.useEffect)(()=>{
        navigateTenant(toTenantId);
    }, [
        navigateTenant,
        toTenantId
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}
var $3115c8d2e23a015a$export$2e2bcd8739ae039 = $3115c8d2e23a015a$var$Redirect;



var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $4c269f96590333ef$var$SvgCloudLogo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 90,
        height: 28,
        viewBox: "0 0 90 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M1.167 4.372c0-.804 0-1.207.156-1.53.137-.286.358-.528.637-.697.316-.192.735-.25 1.575-.364L15.515.153c1.087-.148 1.63-.222 2.053-.066.37.137.68.391.876.72.223.374.223.895.223 1.936v22.514c0 1.041 0 1.562-.223 1.936a1.702 1.702 0 0 1-.876.72c-.423.156-.966.082-2.054-.066L3.535 26.22c-.84-.114-1.26-.172-1.575-.364-.279-.17-.5-.411-.637-.697-.156-.323-.156-.726-.156-1.53V4.372ZM14 11.962c0-.244 0-.367.041-.463a.459.459 0 0 1 .167-.205c.082-.055.191-.066.41-.088l.975-.1c.257-.025.385-.038.484.01.087.042.16.115.205.209.051.106.051.25.051.539v4.272c0 .289 0 .433-.051.54a.446.446 0 0 1-.205.209c-.099.047-.227.034-.484.008l-.976-.1c-.218-.021-.327-.032-.409-.087a.459.459 0 0 1-.167-.205C14 16.405 14 16.282 14 16.037v-4.074Zm7.96-9.045h-1.543v22.75h1.542c.89 0 1.334 0 1.674-.174a1.59 1.59 0 0 0 .694-.696c.173-.34.173-.786.173-1.678V5.465c0-.892 0-1.338-.173-1.679a1.59 1.59 0 0 0-.694-.696c-.34-.173-.784-.173-1.674-.173Z",
                fill: "url(#paint0_linear_193_5093)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M49.892 21.467c-1.198 0-2.233-.25-3.105-.747a5.063 5.063 0 0 1-2.008-2.078c-.467-.903-.7-1.946-.7-3.13 0-1.214.24-2.264.723-3.152a5.218 5.218 0 0 1 2.032-2.078c.887-.498 1.922-.747 3.105-.747 1.199 0 2.226.249 3.082.747a5.218 5.218 0 0 1 2.032 2.078c.482.888.724 1.93.724 3.13 0 1.182-.25 2.225-.748 3.128a5.18 5.18 0 0 1-2.031 2.102c-.872.482-1.907.731-3.106.747Zm.024-2.265c.654 0 1.214-.164 1.681-.49.467-.327.825-.77 1.074-1.331.265-.56.397-1.191.397-1.892 0-.716-.124-1.354-.374-1.914-.249-.56-.607-.997-1.074-1.308-.467-.327-1.027-.49-1.68-.49-.624 0-1.176.163-1.659.49-.482.327-.856.77-1.12 1.33-.25.561-.382 1.192-.398 1.892 0 .716.125 1.355.374 1.915a3.08 3.08 0 0 0 1.097 1.331c.483.311 1.044.467 1.682.467ZM68.006 9.96a.122.122 0 0 0-.122-.121H65.49a.122.122 0 0 0-.121.121v11.95c0 .794-.296 1.288-.888 1.724-.576.435-1.224.578-2.142.593-.638-.015-1.237-.072-1.766-.243a9.862 9.862 0 0 1-1.607-.644.123.123 0 0 0-.166.057l-.86 1.835a.119.119 0 0 0 .04.15c.262.178.569.338.92.479.39.155.787.28 1.191.373.42.11.855.2 1.228.247.39.047.757.053.99.053 1.184 0 2.196-.187 3.036-.56.856-.374 1.51-.903 1.962-1.588.467-.685.7-1.502.7-2.452V9.96ZM66.1 17.695a.125.125 0 0 0-.209-.032c-.458.527-.923.9-1.364 1.142-.467.265-1.004.397-1.611.397-.623 0-1.168-.156-1.635-.467a3.047 3.047 0 0 1-1.027-1.331c-.234-.56-.35-1.206-.35-1.938 0-.7.116-1.323.35-1.868a3.047 3.047 0 0 1 1.027-1.331c.467-.327 1.02-.49 1.658-.49.592 0 1.059.124 1.541.373.45.226.93.74 1.343 1.277.057.075.175.061.212-.026l.662-1.563a.12.12 0 0 0-.011-.116c-.836-1.2-2.25-2.187-3.86-2.187-1.168 0-2.09.249-2.946.747a5.105 5.105 0 0 0-1.985 2.078c-.451.888-.677 1.923-.677 3.106 0 1.214.226 2.273.677 3.176a4.996 4.996 0 0 0 1.938 2.078c.857.498 1.869.747 3.036.747.436 0 .887-.086 1.354-.257.483-.156.95-.39 1.401-.7a5.414 5.414 0 0 0 1.147-1.065.12.12 0 0 0 .016-.122l-.687-1.628ZM77.036 10.054a.122.122 0 0 0-.122-.122h-2.605a.122.122 0 0 1-.122-.122V6.625a.122.122 0 0 0-.122-.122h-2.371a.122.122 0 0 0-.122.122V9.81a.122.122 0 0 1-.122.122h-1.587a.122.122 0 0 0-.121.123l.02 1.975c.001.066.055.12.122.12h1.566c.067 0 .122.055.122.122v5.506c0 .825.163 1.525.49 2.101.343.56.81.989 1.401 1.284.592.296 1.308.444 2.148.444.234 0 .483-.031.748-.093.28-.063.55-.128.784-.222a7.28 7.28 0 0 0 .822-.402.115.115 0 0 0 .04-.157l-.963-1.698a.125.125 0 0 0-.154-.055 3.67 3.67 0 0 1-.483.147c-.202.047-.405.07-.607.07-.545 0-.95-.057-1.214-.415-.265-.374-.397-.849-.397-1.425v-5.085c0-.067.054-.122.122-.122h2.605a.122.122 0 0 0 .122-.122v-1.974ZM83.95 21.461c-1.2 0-2.235-.249-3.106-.747a5.063 5.063 0 0 1-2.009-2.078c-.467-.903-.7-1.946-.7-3.13 0-1.213.241-2.264.724-3.152a5.218 5.218 0 0 1 2.031-2.078c.888-.498 1.923-.747 3.106-.747 1.198 0 2.226.25 3.082.747a5.219 5.219 0 0 1 2.031 2.079c.483.887.724 1.93.724 3.128 0 1.183-.249 2.226-.747 3.13a5.18 5.18 0 0 1-2.031 2.1c-.872.483-1.907.733-3.106.748Zm.022-2.265c.654 0 1.215-.163 1.682-.49.467-.327.825-.77 1.074-1.331.264-.56.397-1.191.397-1.892 0-.716-.125-1.354-.374-1.914-.249-.56-.607-.997-1.074-1.308-.467-.327-1.027-.49-1.681-.49-.623 0-1.175.163-1.658.49a3.24 3.24 0 0 0-1.12 1.331c-.25.56-.382 1.191-.398 1.891 0 .716.125 1.355.374 1.915a3.08 3.08 0 0 0 1.097 1.331c.483.312 1.043.467 1.681.467ZM42.97 19.109a.122.122 0 0 0-.121-.122h-6.302a.122.122 0 0 1-.122-.122V6.599a.122.122 0 0 0-.122-.121h-2.348a.122.122 0 0 0-.122.121v14.746c0 .067.055.122.122.122h8.894a.122.122 0 0 0 .121-.122V19.11Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_193_5093",
                    x1: -6.056,
                    y1: 19.364,
                    x2: 22.686,
                    y2: 7.615,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#4B2EFB"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#E65FFC"
                        })
                    ]
                })
            })
        ]
    });
var $4c269f96590333ef$export$2e2bcd8739ae039 = $4c269f96590333ef$var$SvgCloudLogo;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d4e42755ce7365a4$var$SvgLogo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 154,
        height: 48,
        viewBox: "0 0 154 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2 7.495c0-1.38 0-2.069.267-2.624.236-.489.615-.903 1.092-1.194.542-.33 1.262-.428 2.702-.623L26.596.262c1.864-.254 2.796-.38 3.52-.113.636.235 1.166.67 1.502 1.234.382.642.382 1.535.382 3.32v38.594c0 1.785 0 2.678-.382 3.32-.336.563-.866 1-1.502 1.234-.724.267-1.656.14-3.52-.113L6.06 44.946c-1.44-.195-2.16-.293-2.702-.623a2.854 2.854 0 0 1-1.092-1.194C2 42.574 2 41.884 2 40.505V7.495Zm22 13.013c0-.42 0-.63.07-.796a.788.788 0 0 1 .287-.35c.14-.095.328-.114.701-.152l1.673-.17c.44-.045.66-.067.83.015.15.072.273.198.35.358.089.182.089.43.089.925v7.324c0 .495 0 .743-.088.925a.764.764 0 0 1-.35.358c-.17.082-.39.06-.831.015l-1.673-.17c-.373-.038-.56-.057-.701-.151a.788.788 0 0 1-.287-.35c-.07-.167-.07-.377-.07-.797v-6.984ZM37.644 5H35v39h2.644c1.525 0 2.287 0 2.87-.298.512-.261.928-.679 1.19-1.193.296-.584.296-1.348.296-2.877V9.368c0-1.529 0-2.293-.297-2.877a2.726 2.726 0 0 0-1.19-1.193C39.932 5 39.17 5 37.645 5Z",
                fill: "url(#paint0_linear_1123_6803)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M85.53 36.8c-2.055 0-3.83-.426-5.324-1.28a8.68 8.68 0 0 1-3.443-3.563c-.8-1.548-1.2-3.335-1.2-5.364 0-2.081.413-3.883 1.24-5.404a8.946 8.946 0 0 1 3.483-3.562c1.521-.854 3.296-1.281 5.324-1.281 2.055 0 3.816.427 5.284 1.28a8.947 8.947 0 0 1 3.482 3.563c.828 1.521 1.241 3.31 1.241 5.364 0 2.028-.427 3.816-1.28 5.364-.828 1.548-1.989 2.749-3.483 3.603-1.495.827-3.27 1.254-5.324 1.28Zm.04-3.882c1.12 0 2.081-.28 2.882-.84.8-.561 1.414-1.322 1.841-2.282.454-.961.68-2.042.68-3.243 0-1.227-.213-2.321-.64-3.282-.427-.96-1.04-1.708-1.841-2.242-.8-.56-1.761-.84-2.882-.84-1.067 0-2.015.28-2.842.84-.827.56-1.468 1.321-1.921 2.282-.427.96-.654 2.041-.681 3.242 0 1.228.213 2.322.64 3.283.427.96 1.055 1.72 1.882 2.281.827.534 1.788.8 2.882.8ZM116.582 17.075a.21.21 0 0 0-.209-.209h-4.105a.209.209 0 0 0-.209.21V37.56c0 1.361-.507 2.206-1.521 2.954-.988.747-2.098.991-3.673 1.018-1.094-.027-2.121-.124-3.028-.418a16.907 16.907 0 0 1-2.753-1.103.21.21 0 0 0-.285.098l-1.476 3.146c-.043.09-.015.2.068.256.45.306.977.58 1.58.821a13.9 13.9 0 0 0 2.041.64c.721.187 1.465.343 2.106.423.667.08 1.297.091 1.697.091 2.028 0 3.763-.32 5.204-.96 1.467-.641 2.588-1.549 3.362-2.723.801-1.174 1.201-2.575 1.201-4.203V17.075Zm-3.268 13.259a.214.214 0 0 0-.358-.054c-.785.903-1.583 1.543-2.338 1.957-.801.454-1.722.68-2.762.68-1.068 0-2.002-.266-2.802-.8-.774-.56-1.361-1.32-1.762-2.281-.4-.961-.6-2.069-.6-3.323 0-1.2.2-2.268.6-3.202.401-.96.988-1.721 1.762-2.282.8-.56 1.748-.84 2.842-.84 1.014 0 1.814.213 2.642.64.772.386 1.594 1.268 2.301 2.19.099.127.3.104.363-.045l1.136-2.68a.206.206 0 0 0-.019-.199c-1.434-2.057-3.858-3.75-6.619-3.75-2.001 0-3.58.428-5.048 1.282a8.752 8.752 0 0 0-3.403 3.562c-.773 1.521-1.16 3.296-1.16 5.324 0 2.082.386 3.896 1.16 5.444.774 1.521 1.882 2.709 3.323 3.563 1.468.854 3.202 1.28 5.204 1.28.747 0 1.521-.146 2.321-.44a9.194 9.194 0 0 0 2.402-1.2 9.31 9.31 0 0 0 1.965-1.825.21.21 0 0 0 .029-.21l-1.179-2.791ZM132.061 17.235a.209.209 0 0 0-.209-.209h-4.466a.208.208 0 0 1-.208-.208v-5.46a.21.21 0 0 0-.209-.21h-4.066a.21.21 0 0 0-.209.21v5.46a.208.208 0 0 1-.208.208h-2.72a.21.21 0 0 0-.209.211l.036 3.386a.208.208 0 0 0 .208.206h2.685c.115 0 .208.094.208.209v9.438c0 1.415.281 2.615.841 3.603a5.797 5.797 0 0 0 2.402 2.201c1.014.507 2.241.76 3.682.76.401 0 .828-.053 1.281-.16.481-.106.945-.218 1.345-.379.357-.133 1.054-.483 1.409-.689a.198.198 0 0 0 .07-.269l-1.652-2.912a.215.215 0 0 0-.264-.093 6.283 6.283 0 0 1-.828.251c-.347.08-.694.12-1.04.12-.934 0-1.628-.098-2.082-.712-.454-.64-.68-1.454-.68-2.441v-8.718c0-.115.093-.209.208-.209h4.466a.209.209 0 0 0 .209-.209v-3.385ZM143.913 36.79c-2.055 0-3.83-.426-5.324-1.28a8.68 8.68 0 0 1-3.443-3.563c-.8-1.548-1.201-3.335-1.201-5.364 0-2.081.414-3.882 1.241-5.404a8.949 8.949 0 0 1 3.483-3.562c1.521-.854 3.296-1.281 5.324-1.281 2.055 0 3.816.427 5.284 1.28a8.946 8.946 0 0 1 3.482 3.563c.827 1.522 1.241 3.31 1.241 5.364 0 2.029-.427 3.816-1.281 5.364-.827 1.548-1.988 2.749-3.482 3.603-1.495.827-3.269 1.254-5.324 1.28Zm.04-3.882c1.121 0 2.081-.28 2.882-.84.8-.561 1.414-1.322 1.841-2.282.454-.961.681-2.042.681-3.243 0-1.227-.214-2.321-.641-3.282-.427-.96-1.041-1.708-1.841-2.242-.801-.56-1.761-.84-2.882-.84-1.068 0-2.015.28-2.842.84-.828.56-1.468 1.321-1.922 2.282-.427.96-.654 2.041-.68 3.242 0 1.228.213 2.322.64 3.283.427.96 1.054 1.72 1.882 2.281.827.534 1.788.8 2.882.8ZM73.663 32.758a.209.209 0 0 0-.208-.209H62.652a.209.209 0 0 1-.209-.209V11.314a.209.209 0 0 0-.209-.21H58.21a.209.209 0 0 0-.209.21v25.278c0 .115.093.209.209.209h15.246a.209.209 0 0 0 .208-.21v-3.833Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1123_6803",
                    x1: -10.381,
                    y1: 33.195,
                    x2: 38.89,
                    y2: 13.054,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#4B2EFB"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#E65FFC"
                        })
                    ]
                })
            })
        ]
    });
var $d4e42755ce7365a4$export$2e2bcd8739ae039 = $d4e42755ce7365a4$var$SvgLogo;



var $V1X8c = parcelRequire("V1X8c");

var $3MzPh = parcelRequire("3MzPh");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $24ba721d04d6d938$var$SvgContactUs = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8.408 11.742a1.31 1.31 0 0 0-.1.125.632.632 0 0 0-.075.15.533.533 0 0 0-.05.15 1.133 1.133 0 0 0 0 .166.7.7 0 0 0 .067.317.75.75 0 0 0 .45.45.783.783 0 0 0 .633 0 .75.75 0 0 0 .45-.45.834.834 0 0 0 .05-.317.833.833 0 0 0-1.425-.591ZM9 .667a8.333 8.333 0 1 0 0 16.666A8.333 8.333 0 0 0 9 .667Zm0 15A6.666 6.666 0 1 1 9 2.334a6.666 6.666 0 0 1 0 13.333ZM9 4.833a2.5 2.5 0 0 0-2.167 1.25.833.833 0 1 0 1.442.834.833.833 0 0 1 1.314-.173A.833.833 0 0 1 9 8.167.833.833 0 0 0 8.167 9v.833a.833.833 0 0 0 1.666 0v-.15A2.5 2.5 0 0 0 9 4.833Z",
            fill: "#47464E"
        })
    });
var $24ba721d04d6d938$export$2e2bcd8739ae039 = $24ba721d04d6d938$var$SvgContactUs;



var $fbeQ6 = parcelRequire("fbeQ6");

var $6PcpQ = parcelRequire("6PcpQ");

var $9zeGj = parcelRequire("9zeGj");

var $bFFWx = parcelRequire("bFFWx");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $bNHoO = parcelRequire("bNHoO");

var $7iZsu = parcelRequire("7iZsu");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $dd2ca041c9106490$var$SvgCalendar = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 16,
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M33.613 11.556h1.775v.888h-1.775v-.888Z",
                fill: "#66757F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.778 16v18.519c0 2.045 1.592 3.703 3.555 3.703h21.334c1.963 0 3.555-1.658 3.555-3.703V16H9.778Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M34.667 9.778H13.333c-1.963 0-3.555 1.238-3.555 2.765V16h28.444v-3.457c0-1.527-1.592-2.765-3.555-2.765Z",
                fill: "#DD3730"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M17.778 19.556c0-.491.398-.89.889-.89h1.777c.491 0 .89.399.89.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.777Zm4.444 0c0-.491.398-.89.89-.89h1.777c.49 0 .889.399.889.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.889-.89v-1.777Zm4.445 0c0-.491.398-.89.888-.89h1.778c.491 0 .89.399.89.89v1.777a.889.889 0 0 1-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.777Zm4.444 0c0-.491.398-.89.889-.89h1.778c.49 0 .889.399.889.89v1.777a.889.889 0 0 1-.89.89H32a.889.889 0 0 1-.889-.89v-1.777ZM13.333 24c0-.49.398-.889.89-.889H16c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.889.889h-1.778a.889.889 0 0 1-.889-.89V24Zm4.445 0c0-.49.398-.889.889-.889h1.777c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V24Zm4.444 0c0-.49.398-.889.89-.889h1.777c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889h-1.777a.889.889 0 0 1-.889-.89V24Zm4.445 0c0-.49.398-.889.888-.889h1.778c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V24Zm4.444 0c0-.49.398-.889.889-.889h1.778c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889H32a.889.889 0 0 1-.889-.89V24Zm-17.778 4.444c0-.49.398-.888.89-.888H16c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.889.89h-1.778a.889.889 0 0 1-.889-.89v-1.778Zm4.445 0c0-.49.398-.888.889-.888h1.777c.491 0 .89.397.89.888v1.778c0 .491-.399.89-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.778Zm4.444 0c0-.49.398-.888.89-.888h1.777c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.89.89h-1.777a.889.889 0 0 1-.889-.89v-1.778Zm4.445 0c0-.49.398-.888.888-.888h1.778c.491 0 .89.397.89.888v1.778c0 .491-.399.89-.89.89h-1.777a.889.889 0 0 1-.89-.89v-1.778Zm4.444 0c0-.49.398-.888.889-.888h1.778c.49 0 .889.397.889.888v1.778c0 .491-.398.89-.89.89H32a.889.889 0 0 1-.889-.89v-1.778ZM13.333 32.89c0-.491.398-.889.89-.889H16c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.889.889h-1.778a.889.889 0 0 1-.889-.89V32.89Zm4.445 0c0-.491.398-.889.889-.889h1.777c.491 0 .89.398.89.889v1.778c0 .49-.399.889-.89.889h-1.777a.889.889 0 0 1-.89-.89V32.89Zm4.444 0c0-.491.398-.889.89-.889h1.777c.49 0 .889.398.889.889v1.778c0 .49-.398.889-.89.889h-1.777a.889.889 0 0 1-.889-.89V32.89Z",
                fill: "#fff"
            })
        ]
    });
var $dd2ca041c9106490$export$2e2bcd8739ae039 = $dd2ca041c9106490$var$SvgCalendar;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $474fdc32381b6879$var$SvgDiscordDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M35.09 14.022a26.388 26.388 0 0 0-6.514-2.02.099.099 0 0 0-.105.05c-.281.5-.593 1.152-.81 1.665a24.363 24.363 0 0 0-7.317 0 16.862 16.862 0 0 0-.823-1.666.103.103 0 0 0-.105-.05 26.312 26.312 0 0 0-6.513 2.02.093.093 0 0 0-.043.038C8.71 20.256 7.575 26.302 8.132 32.272a.11.11 0 0 0 .042.075 26.534 26.534 0 0 0 7.99 4.04.103.103 0 0 0 .113-.037 18.955 18.955 0 0 0 1.634-2.66.101.101 0 0 0-.055-.14c-.87-.33-1.7-.733-2.496-1.19a.103.103 0 0 1-.01-.17c.167-.126.335-.256.495-.389a.099.099 0 0 1 .104-.014c5.237 2.392 10.906 2.392 16.082 0a.099.099 0 0 1 .104.013c.16.132.328.264.497.39a.103.103 0 0 1-.008.17 16.39 16.39 0 0 1-2.498 1.189.102.102 0 0 0-.054.142c.48.93 1.029 1.817 1.633 2.657.025.036.07.051.113.039a26.447 26.447 0 0 0 8.003-4.04.102.102 0 0 0 .041-.073c.667-6.903-1.117-12.899-4.731-18.214a.082.082 0 0 0-.042-.038ZM18.692 28.637c-1.576 0-2.876-1.447-2.876-3.225s1.274-3.225 2.876-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.274 3.225-2.876 3.225Zm10.633 0c-1.576 0-2.875-1.447-2.875-3.225s1.273-3.225 2.875-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.261 3.225-2.876 3.225Z",
                fill: "#5865F2"
            })
        ]
    });
var $474fdc32381b6879$export$2e2bcd8739ae039 = $474fdc32381b6879$var$SvgDiscordDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $c5418abd4b023afe$var$SvgDiscord = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 12C0 5.373 5.373 0 12 0h24c6.627 0 12 5.373 12 12v24c0 6.627-5.373 12-12 12H12C5.373 48 0 42.627 0 36V12Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M35.09 14.022a26.388 26.388 0 0 0-6.514-2.02.099.099 0 0 0-.105.05c-.281.5-.593 1.152-.81 1.665a24.363 24.363 0 0 0-7.317 0 16.862 16.862 0 0 0-.823-1.666.103.103 0 0 0-.105-.05 26.312 26.312 0 0 0-6.513 2.02.093.093 0 0 0-.043.038C8.71 20.256 7.575 26.302 8.132 32.272a.11.11 0 0 0 .042.075 26.534 26.534 0 0 0 7.99 4.04.103.103 0 0 0 .113-.037 18.955 18.955 0 0 0 1.634-2.66.101.101 0 0 0-.055-.14c-.87-.33-1.7-.733-2.496-1.19a.103.103 0 0 1-.01-.17c.167-.126.335-.256.495-.389a.099.099 0 0 1 .104-.014c5.237 2.392 10.906 2.392 16.082 0a.099.099 0 0 1 .104.013c.16.132.328.264.497.39a.103.103 0 0 1-.008.17 16.39 16.39 0 0 1-2.498 1.189.102.102 0 0 0-.054.142c.48.93 1.029 1.817 1.633 2.657.025.036.07.051.113.039a26.447 26.447 0 0 0 8.003-4.04.102.102 0 0 0 .041-.073c.667-6.903-1.117-12.899-4.731-18.214a.082.082 0 0 0-.042-.038ZM18.692 28.637c-1.576 0-2.876-1.447-2.876-3.225s1.274-3.225 2.876-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.274 3.225-2.876 3.225Zm10.633 0c-1.576 0-2.875-1.447-2.875-3.225s1.273-3.225 2.875-3.225c1.615 0 2.901 1.46 2.876 3.225 0 1.778-1.261 3.225-2.876 3.225Z",
                fill: "#5865F2"
            })
        ]
    });
var $c5418abd4b023afe$export$2e2bcd8739ae039 = $c5418abd4b023afe$var$SvgDiscord;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d1d3362924ba6b0a$var$SvgEmailDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm6-24c.475 0 .93.083 1.353.235L24 23.585l-7.352-7.352A3.992 3.992 0 0 1 18 16h12Zm-5.241 9.657a.997.997 0 0 1-.758.291.998.998 0 0 1-.758-.291l-8.27-8.271A3.985 3.985 0 0 0 14 20v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8c0-.999-.366-1.912-.971-2.613l-8.27 8.27Z",
                fill: "#8ECF8E"
            })
        ]
    });
var $d1d3362924ba6b0a$export$2e2bcd8739ae039 = $d1d3362924ba6b0a$var$SvgEmailDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8339925f4611b50d$var$SvgEmail = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 16C0 7.163 7.163 0 16 0h16c8.837 0 16 7.163 16 16v16c0 8.837-7.163 16-16 16H16C7.163 48 0 40.837 0 32V16Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24 40c8.837 0 16-7.163 16-16S32.837 8 24 8 8 15.163 8 24s7.163 16 16 16Zm6-24c.475 0 .93.083 1.353.235L24 23.585l-7.352-7.352A3.992 3.992 0 0 1 18 16h12Zm-5.241 9.657a.997.997 0 0 1-.758.291.998.998 0 0 1-.758-.291l-8.27-8.271A3.985 3.985 0 0 0 14 20v8a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8c0-.999-.366-1.912-.971-2.613l-8.27 8.27Z",
                fill: "#4EA254"
            })
        ]
    });
var $8339925f4611b50d$export$2e2bcd8739ae039 = $8339925f4611b50d$var$SvgEmail;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b56075260a12c3e7$var$SvgGithubDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#C4C7C7",
                fillOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 12,
                fill: "#CABEFF",
                fillOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24 8c-3.8 0-7.474 1.386-10.368 3.91-2.894 2.525-4.817 6.022-5.425 9.867a16.752 16.752 0 0 0 2.103 11.12c1.967 3.333 5.026 5.84 8.63 7.072.8.143 1.1-.349 1.1-.78 0-.39-.02-1.681-.02-3.055-4.02.759-5.06-1.005-5.38-1.928A5.962 5.962 0 0 0 13 31.89c-.56-.307-1.36-1.066-.02-1.087.512.058 1.002.24 1.43.533.429.292.782.687 1.03 1.149.219.403.513.758.866 1.044a3.39 3.39 0 0 0 1.19.624 3.34 3.34 0 0 0 2.604-.315 3.487 3.487 0 0 1 1.02-2.194c-3.56-.41-7.28-1.825-7.28-8.1a6.477 6.477 0 0 1 1.64-4.408 6.033 6.033 0 0 1 .16-4.348s1.34-.43 4.4 1.682a14.724 14.724 0 0 1 8 0c3.06-2.133 4.4-1.682 4.4-1.682.592 1.376.65 2.93.16 4.348a6.439 6.439 0 0 1 1.64 4.409c0 6.295-3.74 7.69-7.3 8.1a3.9 3.9 0 0 1 .862 1.396c.186.524.26 1.083.218 1.638 0 2.194-.02 3.958-.02 4.511 0 .431.3.944 1.1.78 3.598-1.242 6.648-3.755 8.606-7.09a16.762 16.762 0 0 0 2.084-11.115c-.613-3.841-2.537-7.334-5.43-9.856A15.775 15.775 0 0 0 24 8Z",
                fill: "#fff"
            })
        ]
    });
var $b56075260a12c3e7$export$2e2bcd8739ae039 = $b56075260a12c3e7$var$SvgGithubDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $632da0a7cc8e86e4$var$SvgGithub = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 16C0 7.163 7.163 0 16 0h16c8.837 0 16 7.163 16 16v16c0 8.837-7.163 16-16 16H16C7.163 48 0 40.837 0 32V16Z",
                fill: "#EFF1F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24 8c-3.8 0-7.474 1.386-10.368 3.91-2.894 2.525-4.817 6.022-5.425 9.867a16.752 16.752 0 0 0 2.103 11.12c1.967 3.333 5.026 5.84 8.63 7.072.8.143 1.1-.349 1.1-.78 0-.39-.02-1.681-.02-3.055-4.02.759-5.06-1.005-5.38-1.928A5.962 5.962 0 0 0 13 31.89c-.56-.307-1.36-1.066-.02-1.087.512.058 1.002.24 1.43.533.429.292.782.687 1.03 1.149.219.403.513.758.866 1.044a3.39 3.39 0 0 0 1.19.624 3.34 3.34 0 0 0 2.604-.315 3.487 3.487 0 0 1 1.02-2.194c-3.56-.41-7.28-1.825-7.28-8.1a6.477 6.477 0 0 1 1.64-4.408 6.033 6.033 0 0 1 .16-4.348s1.34-.43 4.4 1.682a14.724 14.724 0 0 1 8 0c3.06-2.133 4.4-1.682 4.4-1.682.592 1.376.65 2.93.16 4.348a6.439 6.439 0 0 1 1.64 4.409c0 6.295-3.74 7.69-7.3 8.1a3.9 3.9 0 0 1 .862 1.396c.186.524.26 1.083.218 1.638 0 2.194-.02 3.958-.02 4.511 0 .431.3.944 1.1.78 3.598-1.242 6.648-3.755 8.606-7.09a16.762 16.762 0 0 0 2.084-11.115c-.613-3.841-2.537-7.334-5.43-9.856A15.775 15.775 0 0 0 24 8Z",
                fill: "#000"
            })
        ]
    });
var $632da0a7cc8e86e4$export$2e2bcd8739ae039 = $632da0a7cc8e86e4$var$SvgGithub;


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $93h5F = parcelRequire("93h5F");
const $332dfd9401c6e8d4$export$287a4b3663fb9f55 = ()=>{
    const theme = (0, $93h5F.default)();
    const isLightMode = theme === (0, $bhvxB.Theme).Light;
    return [
        {
            title: "contact.discord.title",
            icon: isLightMode ? (0, $c5418abd4b023afe$export$2e2bcd8739ae039) : (0, $474fdc32381b6879$export$2e2bcd8739ae039),
            description: "contact.discord.description",
            label: "contact.discord.button",
            link: (0, $o53Y2.discordLink)
        },
        {
            title: "contact.github.title",
            icon: isLightMode ? (0, $632da0a7cc8e86e4$export$2e2bcd8739ae039) : (0, $b56075260a12c3e7$export$2e2bcd8739ae039),
            description: "contact.github.description",
            label: "contact.github.button",
            link: (0, $o53Y2.githubIssuesLink)
        },
        {
            title: "contact.email.title",
            icon: isLightMode ? (0, $8339925f4611b50d$export$2e2bcd8739ae039) : (0, $d1d3362924ba6b0a$export$2e2bcd8739ae039),
            description: "contact.email.description",
            label: "contact.email.button",
            link: (0, $o53Y2.contactEmailLink)
        },
        {
            title: "contact.reserve.title",
            icon: (0, $dd2ca041c9106490$export$2e2bcd8739ae039),
            description: "contact.reserve.description",
            label: "contact.reserve.button",
            link: (0, $o53Y2.reservationLink)
        }
    ];
};


var $5afa72f9ee50441d$export$2ba01fb71ed41cb6;
var $5afa72f9ee50441d$export$6d59db4903f20f7d;
var $5afa72f9ee50441d$export$1ca1ec8b29a4ce27;
var $5afa72f9ee50441d$export$9c30223ca0a664fb;
var $5afa72f9ee50441d$export$f22da7240b7add18;
var $5afa72f9ee50441d$export$bfd64c937657f93a;
var $5afa72f9ee50441d$export$120ff0929b202a6d;
var $5afa72f9ee50441d$export$4a6dd88bada4e7d2;
var $5afa72f9ee50441d$export$6f093cfa640b7166;
var $5afa72f9ee50441d$export$fb184b623420d9be;
$5afa72f9ee50441d$export$2ba01fb71ed41cb6 = `P2Jj4a_button`;
$5afa72f9ee50441d$export$6d59db4903f20f7d = `P2Jj4a_description`;
$5afa72f9ee50441d$export$1ca1ec8b29a4ce27 = `P2Jj4a_icon`;
$5afa72f9ee50441d$export$9c30223ca0a664fb = `P2Jj4a_link`;
$5afa72f9ee50441d$export$f22da7240b7add18 = `P2Jj4a_main`;
$5afa72f9ee50441d$export$bfd64c937657f93a = `P2Jj4a_rotating`;
$5afa72f9ee50441d$export$120ff0929b202a6d = `P2Jj4a_row`;
$5afa72f9ee50441d$export$4a6dd88bada4e7d2 = `P2Jj4a_shimmer`;
$5afa72f9ee50441d$export$6f093cfa640b7166 = `P2Jj4a_text`;
$5afa72f9ee50441d$export$fb184b623420d9be = `P2Jj4a_title`;


function $5ae747cc1e78d1e8$var$ContactModal({ isOpen: isOpen, onCancel: onCancel }) {
    const contacts = (0, $332dfd9401c6e8d4$export$287a4b3663fb9f55)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onCancel,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "contact.title",
            subtitle: "contact.description",
            onClose: onCancel,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $5afa72f9ee50441d$export$f22da7240b7add18,
                children: contacts.map(({ title: title, icon: ContactIcon, description: description, label: label, link: link })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $5afa72f9ee50441d$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $5afa72f9ee50441d$export$1ca1ec8b29a4ce27,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)(ContactIcon, {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $5afa72f9ee50441d$export$6f093cfa640b7166,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $5afa72f9ee50441d$export$fb184b623420d9be,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                            forKey: title
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $5afa72f9ee50441d$export$6d59db4903f20f7d,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                            forKey: description
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                                href: link,
                                target: "_blank",
                                className: $5afa72f9ee50441d$export$9c30223ca0a664fb,
                                rel: "noopener",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                    type: "outline",
                                    title: label,
                                    className: $5afa72f9ee50441d$export$2ba01fb71ed41cb6
                                })
                            })
                        ]
                    }, title))
            })
        })
    });
}
var $5ae747cc1e78d1e8$export$2e2bcd8739ae039 = $5ae747cc1e78d1e8$var$ContactModal;


var $7a97cf147643a669$export$89da14300d534261;
var $7a97cf147643a669$export$f2c12b114d1afda;
var $7a97cf147643a669$export$1ca1ec8b29a4ce27;
var $7a97cf147643a669$export$bfd64c937657f93a;
var $7a97cf147643a669$export$4a6dd88bada4e7d2;
$7a97cf147643a669$export$89da14300d534261 = `BYjgpa_active`;
$7a97cf147643a669$export$f2c12b114d1afda = `BYjgpa_helpButton`;
$7a97cf147643a669$export$1ca1ec8b29a4ce27 = `BYjgpa_icon`;
$7a97cf147643a669$export$bfd64c937657f93a = `BYjgpa_rotating`;
$7a97cf147643a669$export$4a6dd88bada4e7d2 = `BYjgpa_shimmer`;


function $897cbc3d0aaa83bd$var$Contact() {
    const [isContactOpen, setIsContactOpen] = (0, $eCoWV.useState)(false);
    const anchorRef = (0, $eCoWV.useRef)(null);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                ref: anchorRef,
                tabIndex: 0,
                className: $7a97cf147643a669$export$f2c12b114d1afda,
                role: "button",
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    setIsContactOpen(true);
                }),
                onClick: ()=>{
                    setIsContactOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $24ba721d04d6d938$export$2e2bcd8739ae039), {
                        className: $7a97cf147643a669$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "topbar.help"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5ae747cc1e78d1e8$export$2e2bcd8739ae039), {
                isOpen: isContactOpen,
                onCancel: ()=>{
                    setIsContactOpen(false);
                }
            })
        ]
    });
}
var $897cbc3d0aaa83bd$export$2e2bcd8739ae039 = $897cbc3d0aaa83bd$var$Contact;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b1e23ffe41e2170d$var$SvgDocumentNavButton = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 14,
        height: 18,
        viewBox: "0 0 14 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M13.667 6.45a1.097 1.097 0 0 0-.05-.225V6.15a.89.89 0 0 0-.159-.233l-5-5a.892.892 0 0 0-.233-.159H8.15L7.883.667h-5.05a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V6.45Zm-5-2.942 2.158 2.159H8.667V3.508ZM12 14.833a.833.833 0 0 1-.833.834H2.833A.833.833 0 0 1 2 14.833V3.167a.833.833 0 0 1 .833-.834H7V6.5a.833.833 0 0 0 .833.833H12v7.5Z",
            fill: "#47464E"
        })
    });
var $b1e23ffe41e2170d$export$2e2bcd8739ae039 = $b1e23ffe41e2170d$var$SvgDocumentNavButton;



var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var /**
 * Supported languages on https://docs.logto.io
 */ $a3e24a6a68727733$var$DocumentationLanguage;
(function(DocumentationLanguage) {
    DocumentationLanguage["English"] = "en";
})($a3e24a6a68727733$var$DocumentationLanguage || ($a3e24a6a68727733$var$DocumentationLanguage = {}));
const $a3e24a6a68727733$var$documentationSiteRoot = "https://docs.logto.io";
const $a3e24a6a68727733$var$useDocumentationUrl = ()=>{
    const { i18n: { language: language } } = (0, $2A6IJ.useTranslation)();
    const documentationSiteUrl = Object.values($a3e24a6a68727733$var$DocumentationLanguage).filter((language)=>language !== $a3e24a6a68727733$var$DocumentationLanguage.English).includes(language) ? `${$a3e24a6a68727733$var$documentationSiteRoot}/${language.toLocaleLowerCase()}` : $a3e24a6a68727733$var$documentationSiteRoot;
    return {
        documentationSiteUrl: documentationSiteUrl,
        getDocumentationUrl: (pagePath)=>(0, $b9zrd.appendPath)(new URL(documentationSiteUrl), pagePath).toString()
    };
};
var $a3e24a6a68727733$export$2e2bcd8739ae039 = $a3e24a6a68727733$var$useDocumentationUrl;


var $dd6cbe9023b14bd4$export$89da14300d534261;
var $dd6cbe9023b14bd4$export$ecb96286c6f58b3b;
var $dd6cbe9023b14bd4$export$1ca1ec8b29a4ce27;
var $dd6cbe9023b14bd4$export$bfd64c937657f93a;
var $dd6cbe9023b14bd4$export$4a6dd88bada4e7d2;
var $dd6cbe9023b14bd4$export$aa99a51fa6e62ef3;
$dd6cbe9023b14bd4$export$89da14300d534261 = `xIgafW_active`;
$dd6cbe9023b14bd4$export$ecb96286c6f58b3b = `xIgafW_documentNavButton`;
$dd6cbe9023b14bd4$export$1ca1ec8b29a4ce27 = `xIgafW_icon`;
$dd6cbe9023b14bd4$export$bfd64c937657f93a = `xIgafW_rotating`;
$dd6cbe9023b14bd4$export$4a6dd88bada4e7d2 = `xIgafW_shimmer`;
$dd6cbe9023b14bd4$export$aa99a51fa6e62ef3 = `xIgafW_textLink`;


function $0e1773aa1a1d43ac$var$DocumentNavButton() {
    const { documentationSiteUrl: documentationSiteUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
        href: documentationSiteUrl,
        targetBlank: "noopener",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($dd6cbe9023b14bd4$export$aa99a51fa6e62ef3, $dd6cbe9023b14bd4$export$ecb96286c6f58b3b),
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b1e23ffe41e2170d$export$2e2bcd8739ae039), {
            className: $dd6cbe9023b14bd4$export$1ca1ec8b29a4ce27
        }),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: "topbar.docs"
            })
        })
    });
}
var $0e1773aa1a1d43ac$export$2e2bcd8739ae039 = $0e1773aa1a1d43ac$var$DocumentNavButton;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $46ab19a7423faf73$var$SvgKeyboardArrowDown = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m12.71 15.54 5.65-5.66a1.001 1.001 0 1 0-1.41-1.42l-5 4.95L7 8.46a1 1 0 0 0-1.41 0 1 1 0 0 0-.3.71 1 1 0 0 0 .3.71l5.65 5.66a1 1 0 0 0 1.47 0Z",
            fill: "currentColor"
        })
    });
var $46ab19a7423faf73$export$2e2bcd8739ae039 = $46ab19a7423faf73$var$SvgKeyboardArrowDown;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a9045f0908bf76b8$var$SvgPlus = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M15.834 9.167h-5v-5a.833.833 0 1 0-1.667 0v5h-5a.833.833 0 1 0 0 1.666h5v5a.833.833 0 0 0 1.667 0v-5h5a.833.833 0 0 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $a9045f0908bf76b8$export$2e2bcd8739ae039 = $a9045f0908bf76b8$var$SvgPlus;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $32e815d98d7a83b1$var$SvgCreateTenantHeaderDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 5,
                cy: 15,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.707,
                y: 7.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 37.707 7.828)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 32,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "#F7ACCF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "url(#paint0_linear_8217_107638)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.174 9.679a3 3 0 0 0-3.907-.007L6.652 23.023a2 2 0 0 0-.108 2.942l.747.74a2 2 0 0 0 2.707.099l12.863-10.997a2 2 0 0 1 2.6 0L38 26.529a2 2 0 0 0 2.708-.099l.752-.745a2 2 0 0 0-.103-2.937L26.174 9.678Z",
                fill: "url(#paint1_linear_8217_107638)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                filter: "url(#filter0_i_8217_107638)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "#5E35F3"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "url(#paint2_linear_8217_107638)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8217_107638",
                        x1: 21.396,
                        y1: 12.2,
                        x2: 16.152,
                        y2: 38.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FDA8BF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8217_107638",
                        x1: 12.357,
                        y1: 24.511,
                        x2: 23.593,
                        y2: 2.781,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_8217_107638",
                        x1: 20,
                        y1: 33.107,
                        x2: 33.232,
                        y2: 32.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_i_8217_107638",
                        x: 20,
                        y: 20,
                        width: 8,
                        height: 18,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_8217_107638"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $32e815d98d7a83b1$export$2e2bcd8739ae039 = $32e815d98d7a83b1$var$SvgCreateTenantHeaderDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $31b566756c795e64$var$SvgCreateTenantHeader = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 5,
                cy: 15,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.707,
                y: 7.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 37.707 7.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 32,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "#F7ACCF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11 24.674 21.996 14.8a3 3 0 0 1 4.008 0l10 8.98A3 3 0 0 1 37 26.011V36a3 3 0 0 1-3 3H14a3 3 0 0 1-3-3V24.674Z",
                fill: "url(#paint0_linear_480_32283)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M26.174 9.679a3 3 0 0 0-3.907-.007L6.652 23.023a2 2 0 0 0-.108 2.942l.747.74a2 2 0 0 0 2.707.099l12.863-10.997a2 2 0 0 1 2.6 0L38 26.529a2 2 0 0 0 2.708-.099l.752-.745a2 2 0 0 0-.103-2.937L26.174 9.678Z",
                fill: "url(#paint1_linear_480_32283)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                filter: "url(#filter0_i_480_32283)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "#5E35F3"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M24 25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4-1a4.001 4.001 0 0 1-2.5 3.71V30h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-.5v1.5a1.5 1.5 0 0 1-3 0v-6.79A4.001 4.001 0 1 1 28 24Z",
                        fill: "url(#paint2_linear_480_32283)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_480_32283",
                        x1: 21.396,
                        y1: 12.2,
                        x2: 16.152,
                        y2: 38.805,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FDA8BF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_480_32283",
                        x1: 12.357,
                        y1: 24.511,
                        x2: 23.593,
                        y2: 2.781,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_480_32283",
                        x1: 20,
                        y1: 33.107,
                        x2: 33.232,
                        y2: 32.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_i_480_32283",
                        x: 20,
                        y: 20,
                        width: 8,
                        height: 18,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_480_32283"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $31b566756c795e64$export$2e2bcd8739ae039 = $31b566756c795e64$var$SvgCreateTenantHeader;




var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $fbeQ6 = parcelRequire("fbeQ6");
var $af868e3755c03b8c$exports = {};

$parcel$export($af868e3755c03b8c$exports, "card", function () { return $af868e3755c03b8c$export$aa3e815946b80764; }, function (v) { return $af868e3755c03b8c$export$aa3e815946b80764 = v; });
$parcel$export($af868e3755c03b8c$exports, "checked", function () { return $af868e3755c03b8c$export$b96bb35bc88d6fa; }, function (v) { return $af868e3755c03b8c$export$b96bb35bc88d6fa = v; });
$parcel$export($af868e3755c03b8c$exports, "compact", function () { return $af868e3755c03b8c$export$8e16b83750b44988; }, function (v) { return $af868e3755c03b8c$export$8e16b83750b44988 = v; });
$parcel$export($af868e3755c03b8c$exports, "content", function () { return $af868e3755c03b8c$export$a7db06668cad9adb; }, function (v) { return $af868e3755c03b8c$export$a7db06668cad9adb = v; });
$parcel$export($af868e3755c03b8c$exports, "disabled", function () { return $af868e3755c03b8c$export$683472f6198a076e; }, function (v) { return $af868e3755c03b8c$export$683472f6198a076e = v; });
$parcel$export($af868e3755c03b8c$exports, "disabledLabel", function () { return $af868e3755c03b8c$export$75ab0831e3bea081; }, function (v) { return $af868e3755c03b8c$export$75ab0831e3bea081 = v; });
$parcel$export($af868e3755c03b8c$exports, "icon", function () { return $af868e3755c03b8c$export$1ca1ec8b29a4ce27; }, function (v) { return $af868e3755c03b8c$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($af868e3755c03b8c$exports, "indicator", function () { return $af868e3755c03b8c$export$e897cab68364f2de; }, function (v) { return $af868e3755c03b8c$export$e897cab68364f2de = v; });
$parcel$export($af868e3755c03b8c$exports, "plain", function () { return $af868e3755c03b8c$export$58d971314ad6cab; }, function (v) { return $af868e3755c03b8c$export$58d971314ad6cab = v; });
$parcel$export($af868e3755c03b8c$exports, "radio", function () { return $af868e3755c03b8c$export$b56dc0f160585b86; }, function (v) { return $af868e3755c03b8c$export$b56dc0f160585b86 = v; });
$parcel$export($af868e3755c03b8c$exports, "rotating", function () { return $af868e3755c03b8c$export$bfd64c937657f93a; }, function (v) { return $af868e3755c03b8c$export$bfd64c937657f93a = v; });
$parcel$export($af868e3755c03b8c$exports, "shimmer", function () { return $af868e3755c03b8c$export$4a6dd88bada4e7d2; }, function (v) { return $af868e3755c03b8c$export$4a6dd88bada4e7d2 = v; });
$parcel$export($af868e3755c03b8c$exports, "small", function () { return $af868e3755c03b8c$export$3c17b0e969a90510; }, function (v) { return $af868e3755c03b8c$export$3c17b0e969a90510 = v; });
$parcel$export($af868e3755c03b8c$exports, "trailingIcon", function () { return $af868e3755c03b8c$export$74dc5dd4e622afa8; }, function (v) { return $af868e3755c03b8c$export$74dc5dd4e622afa8 = v; });
var $af868e3755c03b8c$export$aa3e815946b80764;
var $af868e3755c03b8c$export$b96bb35bc88d6fa;
var $af868e3755c03b8c$export$8e16b83750b44988;
var $af868e3755c03b8c$export$a7db06668cad9adb;
var $af868e3755c03b8c$export$683472f6198a076e;
var $af868e3755c03b8c$export$75ab0831e3bea081;
var $af868e3755c03b8c$export$1ca1ec8b29a4ce27;
var $af868e3755c03b8c$export$e897cab68364f2de;
var $af868e3755c03b8c$export$58d971314ad6cab;
var $af868e3755c03b8c$export$b56dc0f160585b86;
var $af868e3755c03b8c$export$bfd64c937657f93a;
var $af868e3755c03b8c$export$4a6dd88bada4e7d2;
var $af868e3755c03b8c$export$3c17b0e969a90510;
var $af868e3755c03b8c$export$74dc5dd4e622afa8;
$af868e3755c03b8c$export$aa3e815946b80764 = `-PZGtG_card`;
$af868e3755c03b8c$export$b96bb35bc88d6fa = `-PZGtG_checked`;
$af868e3755c03b8c$export$8e16b83750b44988 = `-PZGtG_compact`;
$af868e3755c03b8c$export$a7db06668cad9adb = `-PZGtG_content`;
$af868e3755c03b8c$export$683472f6198a076e = `-PZGtG_disabled`;
$af868e3755c03b8c$export$75ab0831e3bea081 = `-PZGtG_disabledLabel`;
$af868e3755c03b8c$export$1ca1ec8b29a4ce27 = `-PZGtG_icon`;
$af868e3755c03b8c$export$e897cab68364f2de = `-PZGtG_indicator`;
$af868e3755c03b8c$export$58d971314ad6cab = `-PZGtG_plain`;
$af868e3755c03b8c$export$b56dc0f160585b86 = `-PZGtG_radio`;
$af868e3755c03b8c$export$bfd64c937657f93a = `-PZGtG_rotating`;
$af868e3755c03b8c$export$4a6dd88bada4e7d2 = `-PZGtG_shimmer`;
$af868e3755c03b8c$export$3c17b0e969a90510 = `-PZGtG_small`;
$af868e3755c03b8c$export$74dc5dd4e622afa8 = `-PZGtG_trailingIcon`;


function $7d902807ff7d72f9$var$Check() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: "17",
        height: "16",
        viewBox: "0 0 17 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8.66666 1.33334C4.99999 1.33334 1.99999 4.33334 1.99999 8.00001C1.99999 11.6667 4.99999 14.6667 8.66666 14.6667C12.3333 14.6667 15.3333 11.6667 15.3333 8.00001C15.3333 4.33334 12.3333 1.33334 8.66666 1.33334ZM11.4667 6.86668L8.26666 10.0667C7.99999 10.3333 7.59999 10.3333 7.33333 10.0667L5.86666 8.60001C5.59999 8.33334 5.59999 7.93334 5.86666 7.66668C6.13333 7.40001 6.53333 7.40001 6.79999 7.66668L7.79999 8.66668L10.5333 5.93334C10.8 5.66668 11.2 5.66668 11.4667 5.93334C11.7333 6.20001 11.7333 6.60001 11.4667 6.86668Z",
            fill: "#5D34F2"
        })
    });
}
function $7d902807ff7d72f9$var$Radio({ className: className, value: value, title: title, name: name, children: children, isChecked: isChecked, onClick: onClick, tabIndex: tabIndex, type: type = "plain", isDisabled: isDisabled, disabledLabel: disabledLabel, icon: icon, trailingIcon: trailingIcon, hasCheckIconForCard: hasCheckIconForCard = true }) {
    const handleKeyPress = (0, $eCoWV.useCallback)((event)=>{
        if (isDisabled) return;
        if ([
            " ",
            "Enter"
        ].includes(event.key)) {
            onClick?.();
            event.preventDefault();
        }
    }, [
        isDisabled,
        onClick
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($af868e3755c03b8c$exports.radio, $af868e3755c03b8c$exports[type], isChecked && $af868e3755c03b8c$exports.checked, isDisabled && $af868e3755c03b8c$exports.disabled, className),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "radio",
        tabIndex: tabIndex,
        onClick: isDisabled ? undefined : onClick,
        onKeyPress: handleKeyPress,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $af868e3755c03b8c$exports.content,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                    readOnly: true,
                    disabled: true,
                    type: "radio",
                    name: name,
                    value: value,
                    checked: isChecked
                }),
                type === "card" && hasCheckIconForCard && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $af868e3755c03b8c$exports.indicator,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)($7d902807ff7d72f9$var$Check, {})
                }),
                children,
                type === "plain" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $af868e3755c03b8c$exports.indicator
                }),
                icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $af868e3755c03b8c$exports.icon,
                    children: icon
                }),
                title && (typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                }) : title),
                trailingIcon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $af868e3755c03b8c$exports.trailingIcon,
                    children: trailingIcon
                }),
                isDisabled && disabledLabel && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($af868e3755c03b8c$exports.indicator, $af868e3755c03b8c$exports.disabledLabel),
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: disabledLabel
                    })
                })
            ]
        })
    });
}
var $7d902807ff7d72f9$export$2e2bcd8739ae039 = $7d902807ff7d72f9$var$Radio;


var $c81e76ee51f4c3cf$exports = {};

$parcel$export($c81e76ee51f4c3cf$exports, "compact", function () { return $c81e76ee51f4c3cf$export$8e16b83750b44988; }, function (v) { return $c81e76ee51f4c3cf$export$8e16b83750b44988 = v; });
$parcel$export($c81e76ee51f4c3cf$exports, "radioGroup", function () { return $c81e76ee51f4c3cf$export$7246d22ab0922ede; }, function (v) { return $c81e76ee51f4c3cf$export$7246d22ab0922ede = v; });
$parcel$export($c81e76ee51f4c3cf$exports, "rotating", function () { return $c81e76ee51f4c3cf$export$bfd64c937657f93a; }, function (v) { return $c81e76ee51f4c3cf$export$bfd64c937657f93a = v; });
$parcel$export($c81e76ee51f4c3cf$exports, "shimmer", function () { return $c81e76ee51f4c3cf$export$4a6dd88bada4e7d2; }, function (v) { return $c81e76ee51f4c3cf$export$4a6dd88bada4e7d2 = v; });
$parcel$export($c81e76ee51f4c3cf$exports, "small", function () { return $c81e76ee51f4c3cf$export$3c17b0e969a90510; }, function (v) { return $c81e76ee51f4c3cf$export$3c17b0e969a90510 = v; });
var $c81e76ee51f4c3cf$export$8e16b83750b44988;
var $c81e76ee51f4c3cf$export$7246d22ab0922ede;
var $c81e76ee51f4c3cf$export$bfd64c937657f93a;
var $c81e76ee51f4c3cf$export$4a6dd88bada4e7d2;
var $c81e76ee51f4c3cf$export$3c17b0e969a90510;
$c81e76ee51f4c3cf$export$8e16b83750b44988 = `ewusyq_compact`;
$c81e76ee51f4c3cf$export$7246d22ab0922ede = `ewusyq_radioGroup`;
$c81e76ee51f4c3cf$export$bfd64c937657f93a = `ewusyq_rotating`;
$c81e76ee51f4c3cf$export$4a6dd88bada4e7d2 = `ewusyq_shimmer`;
$c81e76ee51f4c3cf$export$3c17b0e969a90510 = `ewusyq_small`;


function $b900c904fd017e6e$var$RadioGroup({ name: name, children: children, value: value, className: className, onChange: onChange, type: type = "plain" }, ref) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c81e76ee51f4c3cf$exports.radioGroup, $c81e76ee51f4c3cf$exports[type], className),
        children: (0, $eCoWV.Children).map(children, (child)=>{
            if (!child || !/*#__PURE__*/ (0, $eCoWV.isValidElement)(child) || child.type !== (0, $7d902807ff7d72f9$export$2e2bcd8739ae039)) {
                // As typescript still cannot restrict React children to specific component types, we need to alert the error in runtime.
                // Reference: https://github.com/microsoft/TypeScript/issues/21699
                console.error("Invalid child type for RadioGroup:", child ? child.type : child, ". Expecting Radio components.");
                // Do not render child if not a valid Radio component
                return null;
            }
            return /*#__PURE__*/ (0, $eCoWV.cloneElement)(child, {
                name: name,
                isChecked: value === child.props.value,
                onClick: ()=>{
                    onChange?.(child.props.value);
                },
                tabIndex: 0,
                type: type
            });
        })
    });
}
var $b900c904fd017e6e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($b900c904fd017e6e$var$RadioGroup);



var $hdJkM = parcelRequire("hdJkM");

var $93h5F = parcelRequire("93h5F");

var $7iZsu = parcelRequire("7iZsu");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");

var $iyeK6 = parcelRequire("iyeK6");

var $fbeQ6 = parcelRequire("fbeQ6");
var $5ce8812d80787d76$exports = {};

$parcel$export($5ce8812d80787d76$exports, "development", function () { return $5ce8812d80787d76$export$7f52bbed0c1a13ff; }, function (v) { return $5ce8812d80787d76$export$7f52bbed0c1a13ff = v; });
$parcel$export($5ce8812d80787d76$exports, "large", function () { return $5ce8812d80787d76$export$f09585a853dddd32; }, function (v) { return $5ce8812d80787d76$export$f09585a853dddd32 = v; });
$parcel$export($5ce8812d80787d76$exports, "production", function () { return $5ce8812d80787d76$export$d71d1489bc353e92; }, function (v) { return $5ce8812d80787d76$export$d71d1489bc353e92 = v; });
$parcel$export($5ce8812d80787d76$exports, "rotating", function () { return $5ce8812d80787d76$export$bfd64c937657f93a; }, function (v) { return $5ce8812d80787d76$export$bfd64c937657f93a = v; });
$parcel$export($5ce8812d80787d76$exports, "shimmer", function () { return $5ce8812d80787d76$export$4a6dd88bada4e7d2; }, function (v) { return $5ce8812d80787d76$export$4a6dd88bada4e7d2 = v; });
$parcel$export($5ce8812d80787d76$exports, "staging", function () { return $5ce8812d80787d76$export$e9c7a10224a19f02; }, function (v) { return $5ce8812d80787d76$export$e9c7a10224a19f02 = v; });
$parcel$export($5ce8812d80787d76$exports, "tag", function () { return $5ce8812d80787d76$export$2b067c6666111485; }, function (v) { return $5ce8812d80787d76$export$2b067c6666111485 = v; });
var $5ce8812d80787d76$export$7f52bbed0c1a13ff;
var $5ce8812d80787d76$export$f09585a853dddd32;
var $5ce8812d80787d76$export$d71d1489bc353e92;
var $5ce8812d80787d76$export$bfd64c937657f93a;
var $5ce8812d80787d76$export$4a6dd88bada4e7d2;
var $5ce8812d80787d76$export$e9c7a10224a19f02;
var $5ce8812d80787d76$export$2b067c6666111485;
$5ce8812d80787d76$export$7f52bbed0c1a13ff = `uZxRxa_development`;
$5ce8812d80787d76$export$f09585a853dddd32 = `uZxRxa_large`;
$5ce8812d80787d76$export$d71d1489bc353e92 = `uZxRxa_production`;
$5ce8812d80787d76$export$bfd64c937657f93a = `uZxRxa_rotating`;
$5ce8812d80787d76$export$4a6dd88bada4e7d2 = `uZxRxa_shimmer`;
$5ce8812d80787d76$export$e9c7a10224a19f02 = `uZxRxa_staging`;
$5ce8812d80787d76$export$2b067c6666111485 = `uZxRxa_tag`;


const $1789cada9ae21d95$export$ae9becdfc4a807ab = Object.freeze({
    [(0, $3GN9E.TenantTag).Development]: "tenants.settings.environment_tag_development",
    // Todo @xiaoyijun Remove staging tag before release
    [(0, $3GN9E.TenantTag).Staging]: "tenants.settings.environment_tag_staging",
    [(0, $3GN9E.TenantTag).Production]: "tenants.settings.environment_tag_production"
});
const $1789cada9ae21d95$var$tenantTagNameMap = Object.freeze({
    [(0, $3GN9E.TenantTag).Development]: "tenants.full_env_tag.development",
    // Todo @xiaoyijun Remove staging tag before release
    [(0, $3GN9E.TenantTag).Staging]: "tenants.settings.environment_tag_staging",
    [(0, $3GN9E.TenantTag).Production]: "tenants.full_env_tag.production"
});
function $1789cada9ae21d95$var$TenantEnvTag({ tag: tag, className: className, isAbbreviated: isAbbreviated = true, size: size = "default" }) {
    const phrasesMap = isAbbreviated ? $1789cada9ae21d95$export$ae9becdfc4a807ab : $1789cada9ae21d95$var$tenantTagNameMap;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5ce8812d80787d76$exports.tag, $5ce8812d80787d76$exports[tag], $5ce8812d80787d76$exports[size], className),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: phrasesMap[tag]
        })
    });
}
var $1789cada9ae21d95$export$2e2bcd8739ae039 = $1789cada9ae21d95$var$TenantEnvTag;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $f0b8e8d7dd237cbb$export$e8c9778bf415dd08;
$f0b8e8d7dd237cbb$export$e8c9778bf415dd08 = `iMcnjq_divider`;


function $90d2b44b795c16b0$var$Divider({ className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f0b8e8d7dd237cbb$export$e8c9778bf415dd08, className)
    });
}
var $90d2b44b795c16b0$export$2e2bcd8739ae039 = $90d2b44b795c16b0$var$Divider;



var $fbeQ6 = parcelRequire("fbeQ6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $7739235756d87309$var$SvgFailed = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m14.266 11.994 5.266-5.266a1.598 1.598 0 1 0-2.26-2.26l-5.265 5.265L6.74 4.468a1.598 1.598 0 1 0-2.26 2.26l5.265 5.266-5.278 5.278a1.598 1.598 0 0 0 2.26 2.26l5.278-5.278 5.265 5.265a1.593 1.593 0 0 0 2.26 0 1.597 1.597 0 0 0 0-2.26l-5.265-5.265Z",
            fill: "currentColor"
        })
    });
var $7739235756d87309$export$2e2bcd8739ae039 = $7739235756d87309$var$SvgFailed;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $98c485b7de5371d8$var$SvgSuccess = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M19.677 4.222a1.375 1.375 0 0 0-1.902.405l-7.707 11.88-3.759-3.476a1.375 1.375 0 1 0-1.867 2.02l4.935 4.562s.141.122.207.165a1.375 1.375 0 0 0 1.903-.405l8.595-13.249a1.375 1.375 0 0 0-.405-1.902Z",
            fill: "currentColor"
        })
    });
var $98c485b7de5371d8$export$2e2bcd8739ae039 = $98c485b7de5371d8$var$SvgSuccess;


var $aa92584c2d34d58a$exports = {};

$parcel$export($aa92584c2d34d58a$exports, "alert", function () { return $aa92584c2d34d58a$export$5ea928c9faf85bd3; }, function (v) { return $aa92584c2d34d58a$export$5ea928c9faf85bd3 = v; });
$parcel$export($aa92584c2d34d58a$exports, "cell", function () { return $aa92584c2d34d58a$export$e2e1361cdc35271d; }, function (v) { return $aa92584c2d34d58a$export$e2e1361cdc35271d = v; });
$parcel$export($aa92584c2d34d58a$exports, "error", function () { return $aa92584c2d34d58a$export$a3bc9b8ed74fc; }, function (v) { return $aa92584c2d34d58a$export$a3bc9b8ed74fc = v; });
$parcel$export($aa92584c2d34d58a$exports, "icon", function () { return $aa92584c2d34d58a$export$1ca1ec8b29a4ce27; }, function (v) { return $aa92584c2d34d58a$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($aa92584c2d34d58a$exports, "info", function () { return $aa92584c2d34d58a$export$a80b3bd66acc52ff; }, function (v) { return $aa92584c2d34d58a$export$a80b3bd66acc52ff = v; });
$parcel$export($aa92584c2d34d58a$exports, "outlined", function () { return $aa92584c2d34d58a$export$fd128913e5eb5cb1; }, function (v) { return $aa92584c2d34d58a$export$fd128913e5eb5cb1 = v; });
$parcel$export($aa92584c2d34d58a$exports, "resultIcon", function () { return $aa92584c2d34d58a$export$1c9d9b61ae557bde; }, function (v) { return $aa92584c2d34d58a$export$1c9d9b61ae557bde = v; });
$parcel$export($aa92584c2d34d58a$exports, "rotating", function () { return $aa92584c2d34d58a$export$bfd64c937657f93a; }, function (v) { return $aa92584c2d34d58a$export$bfd64c937657f93a = v; });
$parcel$export($aa92584c2d34d58a$exports, "shimmer", function () { return $aa92584c2d34d58a$export$4a6dd88bada4e7d2; }, function (v) { return $aa92584c2d34d58a$export$4a6dd88bada4e7d2 = v; });
$parcel$export($aa92584c2d34d58a$exports, "small", function () { return $aa92584c2d34d58a$export$3c17b0e969a90510; }, function (v) { return $aa92584c2d34d58a$export$3c17b0e969a90510 = v; });
$parcel$export($aa92584c2d34d58a$exports, "tag", function () { return $aa92584c2d34d58a$export$2b067c6666111485; }, function (v) { return $aa92584c2d34d58a$export$2b067c6666111485 = v; });
var $aa92584c2d34d58a$export$5ea928c9faf85bd3;
var $aa92584c2d34d58a$export$e2e1361cdc35271d;
var $aa92584c2d34d58a$export$a3bc9b8ed74fc;
var $aa92584c2d34d58a$export$1ca1ec8b29a4ce27;
var $aa92584c2d34d58a$export$a80b3bd66acc52ff;
var $aa92584c2d34d58a$export$fd128913e5eb5cb1;
var $aa92584c2d34d58a$export$1c9d9b61ae557bde;
var $aa92584c2d34d58a$export$bfd64c937657f93a;
var $aa92584c2d34d58a$export$4a6dd88bada4e7d2;
var $aa92584c2d34d58a$export$3c17b0e969a90510;
var $aa92584c2d34d58a$export$2b067c6666111485;
$aa92584c2d34d58a$export$5ea928c9faf85bd3 = `RLtn4W_alert`;
$aa92584c2d34d58a$export$e2e1361cdc35271d = `RLtn4W_cell`;
$aa92584c2d34d58a$export$a3bc9b8ed74fc = `RLtn4W_error`;
$aa92584c2d34d58a$export$1ca1ec8b29a4ce27 = `RLtn4W_icon`;
$aa92584c2d34d58a$export$a80b3bd66acc52ff = `RLtn4W_info`;
$aa92584c2d34d58a$export$fd128913e5eb5cb1 = `RLtn4W_outlined`;
$aa92584c2d34d58a$export$1c9d9b61ae557bde = `RLtn4W_resultIcon`;
$aa92584c2d34d58a$export$bfd64c937657f93a = `RLtn4W_rotating`;
$aa92584c2d34d58a$export$4a6dd88bada4e7d2 = `RLtn4W_shimmer`;
$aa92584c2d34d58a$export$3c17b0e969a90510 = `RLtn4W_small`;
$aa92584c2d34d58a$export$2b067c6666111485 = `RLtn4W_tag`;


const $148d05f92bf3ea30$var$ResultIconMap = {
    success: (0, $98c485b7de5371d8$export$2e2bcd8739ae039),
    error: (0, $7739235756d87309$export$2e2bcd8739ae039)
};
function $148d05f92bf3ea30$var$Tag({ type: type = "property", status: status = "info", variant: variant = "outlined", size: size = "medium", className: className, children: children, ...rest }) {
    const ResultIcon = (0, $5CQIb.conditional)(type === "result" && $148d05f92bf3ea30$var$ResultIconMap[status]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($aa92584c2d34d58a$exports.tag, $aa92584c2d34d58a$exports[status], $aa92584c2d34d58a$exports[variant], $aa92584c2d34d58a$exports[size], className),
        ...rest,
        children: [
            type === "state" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $aa92584c2d34d58a$exports.icon
            }),
            ResultIcon && /*#__PURE__*/ (0, $9zeGj.jsx)(ResultIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($aa92584c2d34d58a$exports.icon, $aa92584c2d34d58a$exports.resultIcon)
            }),
            children
        ]
    });
}
var $148d05f92bf3ea30$export$2e2bcd8739ae039 = $148d05f92bf3ea30$var$Tag;



var $e83d497bbda92c61$export$34e0f9847d4c02dd;
var $e83d497bbda92c61$export$6d59db4903f20f7d;
var $e83d497bbda92c61$export$464c821cd4347539;
var $e83d497bbda92c61$export$b54cf5587cb9457;
var $e83d497bbda92c61$export$bfd64c937657f93a;
var $e83d497bbda92c61$export$4a6dd88bada4e7d2;
var $e83d497bbda92c61$export$2b067c6666111485;
$e83d497bbda92c61$export$34e0f9847d4c02dd = `rO9d9G_container`;
$e83d497bbda92c61$export$6d59db4903f20f7d = `rO9d9G_description`;
$e83d497bbda92c61$export$464c821cd4347539 = `rO9d9G_hint`;
$e83d497bbda92c61$export$b54cf5587cb9457 = `rO9d9G_planNameTag`;
$e83d497bbda92c61$export$bfd64c937657f93a = `rO9d9G_rotating`;
$e83d497bbda92c61$export$4a6dd88bada4e7d2 = `rO9d9G_shimmer`;
$e83d497bbda92c61$export$2b067c6666111485 = `rO9d9G_tag`;


const $732991d0c8c58be4$var$descriptionMap = {
    [(0, $3GN9E.TenantTag).Development]: "tenants.create_modal.development_description",
    [(0, $3GN9E.TenantTag).Production]: "tenants.create_modal.production_description",
    // Todo @xiaoyijun Remove deprecated tag
    [(0, $3GN9E.TenantTag).Staging]: "tenants.create_modal.production_description"
};
const $732991d0c8c58be4$var$availableProductionPlanNames = [
    (0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Free,
    (0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Hobby,
    (0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Pro
];
function $732991d0c8c58be4$var$EnvTagOptionContent({ tag: tag }) {
    // Todo @xiaoyijun Deprecated tag
    if (tag === (0, $3GN9E.TenantTag).Staging) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $e83d497bbda92c61$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1789cada9ae21d95$export$2e2bcd8739ae039), {
                isAbbreviated: false,
                tag: tag,
                size: "large",
                className: $e83d497bbda92c61$export$2b067c6666111485
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $e83d497bbda92c61$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: $732991d0c8c58be4$var$descriptionMap[tag]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90d2b44b795c16b0$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $e83d497bbda92c61$export$464c821cd4347539,
                children: [
                    tag === (0, $3GN9E.TenantTag).Development && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "tenants.create_modal.development_hint"
                    }),
                    tag === (0, $3GN9E.TenantTag).Production && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "tenants.create_modal.available_plan"
                            }),
                            $732991d0c8c58be4$var$availableProductionPlanNames.map((planName)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    size: "small",
                                    className: $e83d497bbda92c61$export$b54cf5587cb9457,
                                    children: planName
                                }, planName))
                        ]
                    })
                ]
            })
        ]
    });
}
var $732991d0c8c58be4$export$2e2bcd8739ae039 = $732991d0c8c58be4$var$EnvTagOptionContent;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");

parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $5Yzj4 = parcelRequire("5Yzj4");

var $bNHoO = parcelRequire("bNHoO");

var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

var $bNFMZ = parcelRequire("bNFMZ");

var $3iNy0 = parcelRequire("3iNy0");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $2wPYZ = parcelRequire("2wPYZ");


var $h7VLF = parcelRequire("h7VLF");

var $4W0F0 = parcelRequire("4W0F0");
const $25d8bd01c3ca39b7$var$useSubscribe = ()=>{
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const { updateTenant: updateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { getUrl: getUrl } = (0, $4W0F0.default)();
    const subscribe = async ({ planId: planId, callbackPage: callbackPage, tenantId: tenantId, tenantData: tenantData, isDowngrade: isDowngrade = false })=>{
        const state = (0, $3iNy0.nanoid)(6);
        const successSearchParam = new URLSearchParams({
            [(0, $c96317af8597c55a$export$bc242540c43bf946)]: state
        });
        const successCallbackUrl = getUrl(`${(0, $h7VLF.dropLeadingSlash)((0, $2wPYZ.GlobalRoute).CheckoutSuccessCallback)}?${successSearchParam.toString()}`).href;
        const { redirectUri: redirectUri, sessionId: sessionId } = await cloudApi.post("/api/checkout-session", {
            body: {
                planId: planId,
                successCallbackUrl: successCallbackUrl,
                tenantId: tenantId,
                tenantName: tenantData?.name,
                tenantTag: tenantData?.tag
            }
        });
        if (!redirectUri) {
            (0, $horhC.toast).error(t("general.unknown_error"));
            return;
        }
        (0, $872d085a872e06c4$export$c162b38bc26bbdbf)({
            state: state,
            sessionId: sessionId,
            callbackPage: callbackPage,
            isDowngrade: isDowngrade
        });
        window.location.assign(redirectUri);
    };
    const cancelSubscription = async (tenantId)=>{
        await cloudApi.delete("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: tenantId
            }
        });
        /**
     * Note: need to update the tenant's subscription cache data,
     * since the cancel subscription flow will not redirect to the stripe payment page.
     */ updateTenant(tenantId, {
            planId: (0, $ckJfF.ReservedPlanId).Free,
            subscription: {
                status: "active",
                planId: (0, $ckJfF.ReservedPlanId).Free,
                currentPeriodStart: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))().toDate(),
                currentPeriodEnd: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))().add(1, "month").toDate()
            }
        });
    };
    const visitManagePaymentPage = async (tenantId)=>{
        try {
            const { redirectUri: redirectUri } = await cloudApi.post("/api/tenants/:tenantId/stripe-customer-portal", {
                params: {
                    tenantId: tenantId
                },
                body: {
                    callbackUrl: window.location.href
                }
            });
            window.location.assign(redirectUri);
        } catch (error) {
            (0, $3978b41c434b0156$export$10abc8714a7caf54)(error);
        }
    };
    return {
        subscribe: subscribe,
        cancelSubscription: cancelSubscription,
        visitManagePaymentPage: visitManagePaymentPage
    };
};
var $25d8bd01c3ca39b7$export$2e2bcd8739ae039 = $25d8bd01c3ca39b7$var$useSubscribe;




var $7iZsu = parcelRequire("7iZsu");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
var $8zpKJ = parcelRequire("8zpKJ");
var $6iE6O = parcelRequire("6iE6O");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $3795a55c0fdb05fc$var$SvgArrowRight = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.95 9.408 8.233 4.7A.834.834 0 1 0 7.05 5.875l4.125 4.166-4.125 4.125a.833.833 0 0 0 .27 1.36.834.834 0 0 0 .913-.184l4.717-4.709a.835.835 0 0 0 0-1.225Z",
            fill: "currentColor"
        })
    });
var $3795a55c0fdb05fc$export$2e2bcd8739ae039 = $3795a55c0fdb05fc$var$SvgArrowRight;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

var $fbeQ6 = parcelRequire("fbeQ6");
const $47dfccd1e63aea94$var$registeredPlanDescriptionPhrasesMap = {
    [(0, $ckJfF.ReservedPlanId).Free]: "free_plan_description",
    [(0, $ckJfF.ReservedPlanId).Hobby]: "hobby_plan_description",
    [(0, $ckJfF.ReservedPlanId).Pro]: "pro_plan_description"
};
function $47dfccd1e63aea94$var$PlanDescription({ planId: planId }) {
    const description = $47dfccd1e63aea94$var$registeredPlanDescriptionPhrasesMap[planId];
    if (!description) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
        forKey: `subscription.${description}`
    });
}
var $47dfccd1e63aea94$export$2e2bcd8739ae039 = $47dfccd1e63aea94$var$PlanDescription;




var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d0bfc4528cc4034b$var$SvgDescendArrow = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14 7.333a.666.666 0 0 0-.667.667v1.727l-4.193-4.2a.667.667 0 0 0-.947 0L6 7.727 2.473 4.193a.67.67 0 1 0-.946.947l4 4a.667.667 0 0 0 .946 0l2.194-2.2 3.726 3.727h-1.726a.667.667 0 1 0 0 1.333H14a.667.667 0 0 0 .667-.667V8A.667.667 0 0 0 14 7.333Z",
            fill: "#EB9918"
        })
    });
var $d0bfc4528cc4034b$export$2e2bcd8739ae039 = $d0bfc4528cc4034b$var$SvgDescendArrow;




const $2c4922a130b7773f$export$5fe02dd94d8940f2 = {
    mauLimit: "mau_limit.name",
    applicationsLimit: "applications_limit.name",
    machineToMachineLimit: "machine_to_machine_limit.name",
    resourcesLimit: "resources_limit.name",
    scopesPerResourceLimit: "scopes_per_resource_limit.name",
    customDomainEnabled: "custom_domain_enabled.name",
    omniSignInEnabled: "omni_sign_in_enabled.name",
    socialConnectorsLimit: "social_connectors_limit.name",
    standardConnectorsLimit: "standard_connectors_limit.name",
    rolesLimit: "roles_limit.name",
    scopesPerRoleLimit: "scopes_per_role_limit.name",
    hooksLimit: "hooks_limit.name",
    auditLogsRetentionDays: "audit_logs_retention_days.name",
    communitySupportEnabled: "community_support_enabled.name",
    ticketSupportResponseTime: "customer_ticket_support.name",
    mfaEnabled: "mfa_enabled.name",
    organizationsEnabled: "organizations_enabled.name",
    ssoEnabled: "sso_enabled.name"
};
const $2c4922a130b7773f$export$835723acfb933c0e = {
    mauLimit: "mau_limit.unlimited",
    applicationsLimit: "applications_limit.unlimited",
    machineToMachineLimit: "machine_to_machine_limit.unlimited",
    resourcesLimit: "resources_limit.unlimited",
    scopesPerResourceLimit: "scopes_per_resource_limit.unlimited",
    customDomainEnabled: "custom_domain_enabled.unlimited",
    omniSignInEnabled: "omni_sign_in_enabled.unlimited",
    socialConnectorsLimit: "social_connectors_limit.unlimited",
    standardConnectorsLimit: "standard_connectors_limit.unlimited",
    rolesLimit: "roles_limit.unlimited",
    scopesPerRoleLimit: "scopes_per_role_limit.unlimited",
    hooksLimit: "hooks_limit.unlimited",
    auditLogsRetentionDays: "audit_logs_retention_days.unlimited",
    communitySupportEnabled: "community_support_enabled.unlimited",
    ticketSupportResponseTime: "customer_ticket_support.unlimited",
    mfaEnabled: "mfa_enabled.unlimited",
    organizationsEnabled: "organizations_enabled.unlimited",
    ssoEnabled: "sso_enabled.unlimited"
};
const $2c4922a130b7773f$export$90b7c469260db368 = {
    mauLimit: "mau_limit.limited",
    applicationsLimit: "applications_limit.limited",
    machineToMachineLimit: "machine_to_machine_limit.limited",
    resourcesLimit: "resources_limit.limited",
    scopesPerResourceLimit: "scopes_per_resource_limit.limited",
    customDomainEnabled: "custom_domain_enabled.limited",
    omniSignInEnabled: "omni_sign_in_enabled.limited",
    socialConnectorsLimit: "social_connectors_limit.limited",
    standardConnectorsLimit: "standard_connectors_limit.limited",
    rolesLimit: "roles_limit.limited",
    scopesPerRoleLimit: "scopes_per_role_limit.limited",
    hooksLimit: "hooks_limit.limited",
    auditLogsRetentionDays: "audit_logs_retention_days.limited",
    communitySupportEnabled: "community_support_enabled.limited",
    ticketSupportResponseTime: "customer_ticket_support.limited",
    mfaEnabled: "mfa_enabled.limited",
    organizationsEnabled: "organizations_enabled.limited",
    ssoEnabled: "sso_enabled.limited"
};
const $2c4922a130b7773f$export$fc0debfec7b2b60b = {
    mauLimit: "mau_limit.not_eligible",
    applicationsLimit: "applications_limit.not_eligible",
    machineToMachineLimit: "machine_to_machine_limit.not_eligible",
    resourcesLimit: "resources_limit.not_eligible",
    scopesPerResourceLimit: "scopes_per_resource_limit.not_eligible",
    customDomainEnabled: "custom_domain_enabled.not_eligible",
    omniSignInEnabled: "omni_sign_in_enabled.not_eligible",
    socialConnectorsLimit: "social_connectors_limit.not_eligible",
    standardConnectorsLimit: "standard_connectors_limit.not_eligible",
    rolesLimit: "roles_limit.not_eligible",
    scopesPerRoleLimit: "scopes_per_role_limit.not_eligible",
    hooksLimit: "hooks_limit.not_eligible",
    auditLogsRetentionDays: "audit_logs_retention_days.not_eligible",
    communitySupportEnabled: "community_support_enabled.not_eligible",
    ticketSupportResponseTime: "customer_ticket_support.not_eligible",
    mfaEnabled: "mfa_enabled.not_eligible",
    organizationsEnabled: "organizations_enabled.not_eligible",
    ssoEnabled: "sso_enabled.not_eligible"
};



var $fbeQ6 = parcelRequire("fbeQ6");

var $7a1051a9d12394ed$export$2ad4c2a7b6032cbd;
var $7a1051a9d12394ed$export$1ca1ec8b29a4ce27;
var $7a1051a9d12394ed$export$7061c75fc5af8b7e;
var $7a1051a9d12394ed$export$f8739a5f2ddf37fe;
var $7a1051a9d12394ed$export$720b8f44838407cf;
var $7a1051a9d12394ed$export$6f6aa1b1ff781f2c;
var $7a1051a9d12394ed$export$bfd64c937657f93a;
var $7a1051a9d12394ed$export$4a6dd88bada4e7d2;
var $7a1051a9d12394ed$export$5146850fc0ce88d1;
$7a1051a9d12394ed$export$2ad4c2a7b6032cbd = `rE9l_G_capable`;
$7a1051a9d12394ed$export$1ca1ec8b29a4ce27 = `rE9l_G_icon`;
$7a1051a9d12394ed$export$7061c75fc5af8b7e = `rE9l_G_item`;
$7a1051a9d12394ed$export$f8739a5f2ddf37fe = `rE9l_G_itemContent`;
$7a1051a9d12394ed$export$720b8f44838407cf = `rE9l_G_lineThrough`;
$7a1051a9d12394ed$export$6f6aa1b1ff781f2c = `rE9l_G_notCapable`;
$7a1051a9d12394ed$export$bfd64c937657f93a = `rE9l_G_rotating`;
$7a1051a9d12394ed$export$4a6dd88bada4e7d2 = `rE9l_G_shimmer`;
$7a1051a9d12394ed$export$5146850fc0ce88d1 = `rE9l_G_withIcon`;


function $4c24d90b683a47ef$var$QuotaItem({ hasIcon: hasIcon, quotaKey: quotaKey, quotaValue: quotaValue, isDiffItem: isDiffItem, isComingSoonTagVisible: isComingSoonTagVisible }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription.quota_item"
    });
    const isUnlimited = quotaValue === null;
    const isNotCapable = quotaValue === 0 || quotaValue === false;
    const isLimited = Boolean(quotaValue);
    const Icon = isNotCapable ? (0, $7739235756d87309$export$2e2bcd8739ae039) : isDiffItem ? (0, $d0bfc4528cc4034b$export$2e2bcd8739ae039) : (0, $98c485b7de5371d8$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7a1051a9d12394ed$export$7061c75fc5af8b7e, hasIcon && $7a1051a9d12394ed$export$5146850fc0ce88d1),
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
            className: $7a1051a9d12394ed$export$f8739a5f2ddf37fe,
            children: [
                hasIcon && /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7a1051a9d12394ed$export$1ca1ec8b29a4ce27, isNotCapable ? $7a1051a9d12394ed$export$6f6aa1b1ff781f2c : $7a1051a9d12394ed$export$2ad4c2a7b6032cbd)
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isDiffItem && isNotCapable && $7a1051a9d12394ed$export$720b8f44838407cf),
                    children: [
                        isUnlimited && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                            children: t((0, $2c4922a130b7773f$export$835723acfb933c0e)[quotaKey])
                        }),
                        isNotCapable && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                            children: t((0, $2c4922a130b7773f$export$5fe02dd94d8940f2)[quotaKey])
                        }),
                        isLimited && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                            children: t((0, $2c4922a130b7773f$export$90b7c469260db368)[quotaKey], (0, $5CQIb.conditional)(typeof quotaValue === "number" && {
                                count: quotaValue
                            }) ?? {})
                        })
                    ]
                }),
                isComingSoonTagVisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "general.coming_soon"
                    })
                })
            ]
        })
    });
}
var $4c24d90b683a47ef$export$2e2bcd8739ae039 = $4c24d90b683a47ef$var$QuotaItem;


var $9918f762ac0fb018$export$8837f4fc672e936d;
var $9918f762ac0fb018$export$bfd64c937657f93a;
var $9918f762ac0fb018$export$4a6dd88bada4e7d2;
$9918f762ac0fb018$export$8837f4fc672e936d = `O6eWFG_list`;
$9918f762ac0fb018$export$bfd64c937657f93a = `O6eWFG_rotating`;
$9918f762ac0fb018$export$4a6dd88bada4e7d2 = `O6eWFG_shimmer`;


function $f04630148650accd$var$PlanQuotaList({ quota: quota, featuredQuotaKeys: featuredQuotaKeys, comingSoonQuotaKeys: comingSoonQuotaKeys, isDiff: isDiff, hasIcon: hasIcon, className: className }) {
    const items = (0, $eCoWV.useMemo)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        const entries = Object.entries(quota);
        const featuredEntries = featuredQuotaKeys ? entries.filter(([key])=>featuredQuotaKeys.includes(key)) : entries;
        return featuredEntries.slice().sort(([preQuotaKey], [nextQuotaKey])=>(0, $65a670f1c344d535$export$b035e44d7bb4278f)((0, $22b72719037fdeab$export$103450479c8ed1e3))(preQuotaKey, nextQuotaKey));
    }, [
        quota,
        featuredQuotaKeys
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($9918f762ac0fb018$export$8837f4fc672e936d, className),
        children: items.map(([quotaKey, quotaValue])=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $4c24d90b683a47ef$export$2e2bcd8739ae039), {
                isDiffItem: isDiff,
                quotaKey: quotaKey,
                quotaValue: quotaValue,
                hasIcon: hasIcon,
                isComingSoonTagVisible: (quotaValue === null || Boolean(quotaValue)) && comingSoonQuotaKeys?.includes(quotaKey)
            }, quotaKey))
    });
}
var $f04630148650accd$export$2e2bcd8739ae039 = $f04630148650accd$var$PlanQuotaList;


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");


var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");
var $c05bf2407dbc57cb$export$34e0f9847d4c02dd;
var $c05bf2407dbc57cb$export$a7db06668cad9adb;
var $c05bf2407dbc57cb$export$6d59db4903f20f7d;
var $c05bf2407dbc57cb$export$3e36595b0b3ff9e8;
var $c05bf2407dbc57cb$export$9c30223ca0a664fb;
var $c05bf2407dbc57cb$export$ebcd2be1028c1c9c;
var $c05bf2407dbc57cb$export$8837f4fc672e936d;
var $c05bf2407dbc57cb$export$3034042b810d1d6d;
var $c05bf2407dbc57cb$export$7507ac6a8989448c;
var $c05bf2407dbc57cb$export$321c0b1a406de31f;
var $c05bf2407dbc57cb$export$48b652c98657f00b;
var $c05bf2407dbc57cb$export$a957e91ae9ff14e3;
var $c05bf2407dbc57cb$export$bfd64c937657f93a;
var $c05bf2407dbc57cb$export$4a6dd88bada4e7d2;
var $c05bf2407dbc57cb$export$5e5b4df997cb5eaa;
var $c05bf2407dbc57cb$export$fb184b623420d9be;
var $c05bf2407dbc57cb$export$284e4f5d00a21b9b;
$c05bf2407dbc57cb$export$34e0f9847d4c02dd = `t4YtMW_container`;
$c05bf2407dbc57cb$export$a7db06668cad9adb = `t4YtMW_content`;
$c05bf2407dbc57cb$export$6d59db4903f20f7d = `t4YtMW_description`;
$c05bf2407dbc57cb$export$3e36595b0b3ff9e8 = `t4YtMW_exceedFreeTenantsTip`;
$c05bf2407dbc57cb$export$9c30223ca0a664fb = `t4YtMW_link`;
$c05bf2407dbc57cb$export$ebcd2be1028c1c9c = `t4YtMW_linkIcon`;
$c05bf2407dbc57cb$export$8837f4fc672e936d = `t4YtMW_list`;
$c05bf2407dbc57cb$export$3034042b810d1d6d = `t4YtMW_mostPopularTag`;
$c05bf2407dbc57cb$export$7507ac6a8989448c = `t4YtMW_planInfo`;
$c05bf2407dbc57cb$export$321c0b1a406de31f = `t4YtMW_price`;
$c05bf2407dbc57cb$export$48b652c98657f00b = `t4YtMW_priceInfo`;
$c05bf2407dbc57cb$export$a957e91ae9ff14e3 = `t4YtMW_priceLabel`;
$c05bf2407dbc57cb$export$bfd64c937657f93a = `t4YtMW_rotating`;
$c05bf2407dbc57cb$export$4a6dd88bada4e7d2 = `t4YtMW_shimmer`;
$c05bf2407dbc57cb$export$5e5b4df997cb5eaa = `t4YtMW_tip`;
$c05bf2407dbc57cb$export$fb184b623420d9be = `t4YtMW_title`;
$c05bf2407dbc57cb$export$284e4f5d00a21b9b = `t4YtMW_unitPrices`;


const $a86fffdf8326a8ba$var$featuredQuotaKeys = [
    "mauLimit",
    "machineToMachineLimit",
    "standardConnectorsLimit",
    "rolesLimit",
    "scopesPerRoleLimit",
    "mfaEnabled",
    "ssoEnabled",
    "organizationsEnabled",
    "auditLogsRetentionDays"
];
function $a86fffdf8326a8ba$var$PlanCardItem({ plan: plan, onSelect: onSelect }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.create_tenant"
    });
    const { tenants: tenants } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { stripeProducts: stripeProducts, id: planId, name: planName, quota: quota } = plan;
    const basePrice = (0, $eCoWV.useMemo)(()=>stripeProducts.find(({ type: type })=>type === "flat")?.price.unitAmountDecimal ?? 0, [
        stripeProducts
    ]);
    const tierPrices = (0, $eCoWV.useMemo)(()=>{
        const prices = stripeProducts.filter(({ type: type })=>type !== "flat").map(({ price: { unitAmountDecimal: unitAmountDecimal } })=>`$${(Number(unitAmountDecimal) / 100).toFixed(3)}`);
        return prices.length > 0 ? prices.join(" ") : "$0.00";
    }, [
        stripeProducts
    ]);
    const isFreePlan = planId === (0, $ckJfF.ReservedPlanId).Free;
    const isFreeTenantExceeded = (0, $eCoWV.useMemo)(()=>/** Should not block admin tenant owners from creating more than three tenants */ !tenants.some(({ id: id })=>id === (0, $8zpKJ.adminTenantId)) && tenants.filter(({ planId: planId })=>planId === (0, $ckJfF.ReservedPlanId).Free).length >= (0, $6iE6O.maxFreeTenantLimit), [
        tenants
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $c05bf2407dbc57cb$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c05bf2407dbc57cb$export$7507ac6a8989448c,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c05bf2407dbc57cb$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: planName
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $c05bf2407dbc57cb$export$48b652c98657f00b,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $c05bf2407dbc57cb$export$a957e91ae9ff14e3,
                                children: t("base_price")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $c05bf2407dbc57cb$export$321c0b1a406de31f,
                                children: [
                                    "$",
                                    t("monthly_price", {
                                        value: Number(basePrice) / 100
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $c05bf2407dbc57cb$export$a957e91ae9ff14e3,
                                children: [
                                    t("mau_unit_price"),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        className: $c05bf2407dbc57cb$export$284e4f5d00a21b9b,
                                        children: tierPrices
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c05bf2407dbc57cb$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47dfccd1e63aea94$export$2e2bcd8739ae039), {
                            planId: planId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c05bf2407dbc57cb$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f04630148650accd$export$2e2bcd8739ae039), {
                        hasIcon: true,
                        quota: quota,
                        featuredQuotaKeys: $a86fffdf8326a8ba$var$featuredQuotaKeys,
                        comingSoonQuotaKeys: (0, $22b72719037fdeab$export$69143de3c73b76af),
                        className: $c05bf2407dbc57cb$export$8837f4fc672e936d
                    }),
                    isFreePlan && isFreeTenantExceeded && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c05bf2407dbc57cb$export$5e5b4df997cb5eaa, $c05bf2407dbc57cb$export$3e36595b0b3ff9e8),
                        children: t("free_tenants_limit", {
                            count: (0, $6iE6O.maxFreeTenantLimit)
                        })
                    }),
                    !isFreePlan && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c05bf2407dbc57cb$export$5e5b4df997cb5eaa,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            isTrailingIcon: true,
                            href: (0, $o53Y2.pricingLink),
                            targetBlank: "noopener",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3795a55c0fdb05fc$export$2e2bcd8739ae039), {
                                className: $c05bf2407dbc57cb$export$ebcd2be1028c1c9c
                            }),
                            className: $c05bf2407dbc57cb$export$9c30223ca0a664fb,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "upsell.create_tenant.view_all_features"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                                        isTitleCase: true,
                                        name: planName
                                    })
                                },
                                children: t("select_plan")
                            })
                        }),
                        disabled: isFreePlan && isFreeTenantExceeded,
                        type: isFreePlan ? "outline" : "primary",
                        size: "large",
                        onClick: onSelect
                    })
                ]
            }),
            planId === (0, $ckJfF.ReservedPlanId).Pro && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $c05bf2407dbc57cb$export$3034042b810d1d6d,
                children: t("most_popular")
            })
        ]
    });
}
var $a86fffdf8326a8ba$export$2e2bcd8739ae039 = $a86fffdf8326a8ba$var$PlanCardItem;


var $8071a10651742d83$export$34e0f9847d4c02dd;
var $8071a10651742d83$export$bfd64c937657f93a;
var $8071a10651742d83$export$4a6dd88bada4e7d2;
$8071a10651742d83$export$34e0f9847d4c02dd = `_93AYIq_container`;
$8071a10651742d83$export$bfd64c937657f93a = `_93AYIq_rotating`;
$8071a10651742d83$export$4a6dd88bada4e7d2 = `_93AYIq_shimmer`;


function $c89ccfe769da236a$var$SelectTenantPlanModal({ tenantData: tenantData, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: subscriptionPlans } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const { subscribe: subscribe } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)({
        hideErrorToast: true
    });
    const reservedPlans = (0, $5CQIb.conditional)(subscriptionPlans && (0, $f11d0f720bf4029b$export$1673a249ab23858e)(subscriptionPlans));
    if (!reservedPlans || !tenantData) return null;
    const handleSelectPlan = async (plan)=>{
        const { id: planId } = plan;
        try {
            if (planId === (0, $ckJfF.ReservedPlanId).Free) {
                const { name: name, tag: tag } = tenantData;
                const newTenant = await cloudApi.post("/api/tenants", {
                    body: {
                        name: name,
                        tag: tag
                    }
                });
                onClose(newTenant);
                return;
            }
            await subscribe({
                planId: planId,
                tenantData: tenantData
            });
        } catch (error) {
            (0, $3978b41c434b0156$export$10abc8714a7caf54)(error);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: Boolean(tenantData),
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "upsell.create_tenant.title",
            subtitle: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            href: (0, $o53Y2.pricingLink),
                            targetBlank: "noopener"
                        })
                    },
                    children: t("upsell.create_tenant.description")
                })
            }),
            size: "xlarge",
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8071a10651742d83$export$34e0f9847d4c02dd,
                children: reservedPlans.map((plan)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $a86fffdf8326a8ba$export$2e2bcd8739ae039), {
                        plan: plan,
                        onSelect: ()=>{
                            handleSelectPlan(plan);
                        }
                    }, plan.id))
            })
        })
    });
}
var $c89ccfe769da236a$export$2e2bcd8739ae039 = $c89ccfe769da236a$var$SelectTenantPlanModal;


var $626d92be6af776c7$export$d16dae6e9710581;
var $626d92be6af776c7$export$6d59db4903f20f7d;
var $626d92be6af776c7$export$f156efb5cf077f10;
var $626d92be6af776c7$export$9d159a0da2dc7531;
var $626d92be6af776c7$export$bfd64c937657f93a;
var $626d92be6af776c7$export$4a6dd88bada4e7d2;
$626d92be6af776c7$export$d16dae6e9710581 = `_0EJwoa_comingSoon`;
$626d92be6af776c7$export$6d59db4903f20f7d = `_0EJwoa_description`;
$626d92be6af776c7$export$f156efb5cf077f10 = `_0EJwoa_envTagRadioGroup`;
$626d92be6af776c7$export$9d159a0da2dc7531 = `_0EJwoa_regionOptions`;
$626d92be6af776c7$export$bfd64c937657f93a = `_0EJwoa_rotating`;
$626d92be6af776c7$export$4a6dd88bada4e7d2 = `_0EJwoa_shimmer`;


const $708876a8f61ed096$var$availableTags = [
    (0, $3GN9E.TenantTag).Development,
    (0, $3GN9E.TenantTag).Production
];
function $708876a8f61ed096$var$CreateTenantModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [tenantData, setTenantData] = (0, $eCoWV.useState)();
    const theme = (0, $93h5F.default)();
    const defaultValues = {
        tag: (0, $3GN9E.TenantTag).Development
    };
    const methods = (0, $c3LX9.useForm)({
        defaultValues: defaultValues
    });
    const { reset: reset, control: control, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting }, register: register } = methods;
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const createTenant = async (data)=>{
        const { name: name, tag: tag } = data;
        const newTenant = await cloudApi.post("/api/tenants", {
            body: {
                name: name,
                tag: tag
            }
        });
        onClose(newTenant);
    };
    const onCreateClick = handleSubmit(async (data)=>{
        const { tag: tag } = data;
        if (tag === (0, $3GN9E.TenantTag).Development) {
            await createTenant(data);
            return;
        }
        setTenantData(data);
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onAfterClose: ()=>{
            reset(defaultValues);
        },
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: "tenants.create_modal.title",
            subtitle: "tenants.create_modal.subtitle",
            headerIcon: theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $31b566756c795e64$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $32e815d98d7a83b1$export$2e2bcd8739ae039), {}),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                disabled: isSubmitting,
                htmlType: "submit",
                title: "tenants.create_modal.create_button",
                size: "large",
                type: "primary",
                onClick: onCreateClick
            }),
            size: "large",
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c3LX9.FormProvider), {
                    ...methods,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            isRequired: true,
                            title: "tenants.settings.tenant_name",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                // eslint-disable-next-line jsx-a11y/no-autofocus
                                autoFocus: true,
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name)
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "tenants.settings.tenant_region",
                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                type: "small",
                                value: "eu",
                                name: "region",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                className: $626d92be6af776c7$export$9d159a0da2dc7531,
                                                children: "\uD83C\uDDEA\uD83C\uDDFA EU"
                                            })
                                        }),
                                        value: "eu"
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                        isDisabled: true,
                                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                                                className: $626d92be6af776c7$export$9d159a0da2dc7531,
                                                children: [
                                                    "\uD83C\uDDFA\uD83C\uDDF8 US",
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                        className: $626d92be6af776c7$export$d16dae6e9710581,
                                                        children: `(${t("general.coming_soon")})`
                                                    })
                                                ]
                                            })
                                        }),
                                        value: "us"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "tenants.create_modal.tenant_usage_purpose",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                control: control,
                                name: "tag",
                                rules: {
                                    required: true
                                },
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                        type: "card",
                                        className: $626d92be6af776c7$export$f156efb5cf077f10,
                                        value: value,
                                        name: name,
                                        onChange: onChange,
                                        children: $708876a8f61ed096$var$availableTags.map((tag)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                                value: tag,
                                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $732991d0c8c58be4$export$2e2bcd8739ae039), {
                                                    tag: tag
                                                })
                                            }, tag))
                                    })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c89ccfe769da236a$export$2e2bcd8739ae039), {
                    tenantData: tenantData,
                    onClose: (tenant)=>{
                        setTenantData(undefined);
                        if (tenant) /**
               * Note: only close the create tenant modal when tenant is created successfully
               */ onClose(tenant);
                    }
                })
            ]
        })
    });
}
var $708876a8f61ed096$export$2e2bcd8739ae039 = $708876a8f61ed096$var$CreateTenantModal;




var $2wPYZ = parcelRequire("2wPYZ");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");

var $1pqtO = parcelRequire("1pqtO");

var $6PcpQ = parcelRequire("6PcpQ");

var $d0Zvy = parcelRequire("d0Zvy");
var $184b52ac153e950b$export$a7db06668cad9adb;
var $184b52ac153e950b$export$a3681dba3470c8c4;
var $184b52ac153e950b$export$5c0b849e0a083a5;
var $184b52ac153e950b$export$29dd17c7f3c81c36;
var $184b52ac153e950b$export$bfd64c937657f93a;
var $184b52ac153e950b$export$4a6dd88bada4e7d2;
var $184b52ac153e950b$export$fb184b623420d9be;
$184b52ac153e950b$export$a7db06668cad9adb = `zAZJ6a_content`;
$184b52ac153e950b$export$a3681dba3470c8c4 = `zAZJ6a_dropdownContainer`;
$184b52ac153e950b$export$5c0b849e0a083a5 = `zAZJ6a_onTop`;
$184b52ac153e950b$export$29dd17c7f3c81c36 = `zAZJ6a_overlay`;
$184b52ac153e950b$export$bfd64c937657f93a = `zAZJ6a_rotating`;
$184b52ac153e950b$export$4a6dd88bada4e7d2 = `zAZJ6a_shimmer`;
$184b52ac153e950b$export$fb184b623420d9be = `zAZJ6a_title`;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $6PcpQ = parcelRequire("6PcpQ");
var $5d7ee56fbf26ebec$exports = {};

$parcel$export($5d7ee56fbf26ebec$exports, "danger", function () { return $5d7ee56fbf26ebec$export$7c4df8d735fa2705; }, function (v) { return $5d7ee56fbf26ebec$export$7c4df8d735fa2705 = v; });
$parcel$export($5d7ee56fbf26ebec$exports, "icon", function () { return $5d7ee56fbf26ebec$export$1ca1ec8b29a4ce27; }, function (v) { return $5d7ee56fbf26ebec$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($5d7ee56fbf26ebec$exports, "item", function () { return $5d7ee56fbf26ebec$export$7061c75fc5af8b7e; }, function (v) { return $5d7ee56fbf26ebec$export$7061c75fc5af8b7e = v; });
$parcel$export($5d7ee56fbf26ebec$exports, "rotating", function () { return $5d7ee56fbf26ebec$export$bfd64c937657f93a; }, function (v) { return $5d7ee56fbf26ebec$export$bfd64c937657f93a = v; });
$parcel$export($5d7ee56fbf26ebec$exports, "shimmer", function () { return $5d7ee56fbf26ebec$export$4a6dd88bada4e7d2; }, function (v) { return $5d7ee56fbf26ebec$export$4a6dd88bada4e7d2 = v; });
var $5d7ee56fbf26ebec$export$7c4df8d735fa2705;
var $5d7ee56fbf26ebec$export$1ca1ec8b29a4ce27;
var $5d7ee56fbf26ebec$export$7061c75fc5af8b7e;
var $5d7ee56fbf26ebec$export$bfd64c937657f93a;
var $5d7ee56fbf26ebec$export$4a6dd88bada4e7d2;
$5d7ee56fbf26ebec$export$7c4df8d735fa2705 = `_Mz4GG_danger`;
$5d7ee56fbf26ebec$export$1ca1ec8b29a4ce27 = `_Mz4GG_icon`;
$5d7ee56fbf26ebec$export$7061c75fc5af8b7e = `_Mz4GG_item`;
$5d7ee56fbf26ebec$export$bfd64c937657f93a = `_Mz4GG_rotating`;
$5d7ee56fbf26ebec$export$4a6dd88bada4e7d2 = `_Mz4GG_shimmer`;


function $cebb3b53f6828066$var$DropdownItem({ onClick: onClick, className: className, children: children, icon: icon, iconClassName: iconClassName, type: type = "default" }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5d7ee56fbf26ebec$exports.item, $5d7ee56fbf26ebec$exports[type], className),
        role: "menuitem",
        tabIndex: 0,
        onMouseDown: (event)=>{
            event.preventDefault();
        },
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(onClick),
        onClick: onClick,
        children: [
            icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5d7ee56fbf26ebec$exports.icon, iconClassName),
                children: icon
            }),
            children
        ]
    });
}
var $cebb3b53f6828066$export$2e2bcd8739ae039 = $cebb3b53f6828066$var$DropdownItem;


function $2b49de81819d0209$var$Div({ children: children, ...rest }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ...rest,
        children: children
    });
}
function $2b49de81819d0209$var$Dropdown({ children: children, title: title, isOpen: isOpen, onClose: onClose, anchorRef: anchorRef, isFullWidth: isFullWidth, className: className, titleClassName: titleClassName, horizontalAlign: horizontalAlign = "end", hasOverflowContent: hasOverflowContent, noOverlay: noOverlay }) {
    const overlayRef = (0, $eCoWV.useRef)(null);
    const { position: position, positionState: positionState, mutate: mutate } = (0, $1pqtO.default)({
        verticalAlign: "bottom",
        horizontalAlign: horizontalAlign,
        offset: {
            vertical: 4,
            horizontal: 0
        },
        anchorRef: anchorRef,
        overlayRef: overlayRef
    });
    const WrapperComponent = hasOverflowContent ? $2b49de81819d0209$var$Div : (0, $d0Zvy.default);
    return(// Using `ReactModal` will cause accessibility issues for multi-select since the dropdown is
    // not a child or sibling of the input element. Thus the tab order will be broken. Consider
    // using something else instead.
    /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnOverlayClick: true,
        isOpen: isOpen,
        style: {
            content: {
                zIndex: 103,
                width: isFullWidth && anchorRef.current ? anchorRef.current.getBoundingClientRect().width : undefined,
                ...!position && {
                    opacity: 0
                },
                ...position
            }
        },
        shouldFocusAfterRender: false,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($184b52ac153e950b$export$a7db06668cad9adb, positionState.verticalAlign === "top" && $184b52ac153e950b$export$5c0b849e0a083a5),
        overlayClassName: $184b52ac153e950b$export$29dd17c7f3c81c36,
        overlayElement: noOverlay && ((_, contentElement)=>contentElement),
        onRequestClose: (event)=>{
            /**
         * Note:
         * we should stop propagation to prevent the event from bubbling up when we click on the overlay to close the dropdown.
         */ event.stopPropagation();
            onClose?.();
        },
        onAfterOpen: mutate,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            ref: overlayRef,
            className: $184b52ac153e950b$export$a3681dba3470c8c4,
            children: [
                title && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($184b52ac153e950b$export$fb184b623420d9be, titleClassName),
                    children: title
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)(WrapperComponent, {
                    className: className,
                    role: "menu",
                    tabIndex: 0,
                    onClick: onClose,
                    onKeyDown: (0, $6PcpQ.onKeyDownHandler)({
                        Enter: onClose,
                        Esc: onClose
                    }),
                    children: children
                })
            ]
        })
    }));
}
var $2b49de81819d0209$export$2e2bcd8739ae039 = $2b49de81819d0209$var$Dropdown;



var $d0Zvy = parcelRequire("d0Zvy");


var $6PcpQ = parcelRequire("6PcpQ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $307Eo = parcelRequire("307Eo");




var $fbeQ6 = parcelRequire("fbeQ6");


var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");

function $c9c24d5d9376b2cf$var$TenantStatusTag({ tenantData: tenantData, tenantPlan: tenantPlan, className: className }) {
    const { usage: usage, openInvoices: openInvoices, isSuspended: isSuspended } = tenantData;
    /**
   * Tenant status priority:
   * 1. suspend
   * 2. overdue
   * 3. mau exceeded
   */ if (isSuspended) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "user_details.suspended"
        })
    });
    if (openInvoices.length > 0) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "tenants.status.overdue"
        })
    });
    const { activeUsers: activeUsers } = usage;
    const { quota: { mauLimit: mauLimit } } = tenantPlan;
    const isMauExceeded = mauLimit !== null && activeUsers >= mauLimit;
    if (isMauExceeded) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        className: className,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "tenants.status.mau_exceeded"
        })
    });
    return null;
}
var $c9c24d5d9376b2cf$export$2e2bcd8739ae039 = $c9c24d5d9376b2cf$var$TenantStatusTag;


var $36c54161df755d1e$export$1d8a03084661a191;
var $36c54161df755d1e$export$a80b3bd66acc52ff;
var $36c54161df755d1e$export$7061c75fc5af8b7e;
var $36c54161df755d1e$export$6990040ee07315;
var $36c54161df755d1e$export$a8ff84c12d48cfa6;
var $36c54161df755d1e$export$9fc7da2585cefa14;
var $36c54161df755d1e$export$bfd64c937657f93a;
var $36c54161df755d1e$export$4a6dd88bada4e7d2;
var $36c54161df755d1e$export$384817691e7c7e7d;
var $36c54161df755d1e$export$664c6d24e3175067;
$36c54161df755d1e$export$1d8a03084661a191 = `_8mkO2q_checkIcon`;
$36c54161df755d1e$export$a80b3bd66acc52ff = `_8mkO2q_info`;
$36c54161df755d1e$export$7061c75fc5af8b7e = `_8mkO2q_item`;
$36c54161df755d1e$export$6990040ee07315 = `_8mkO2q_meta`;
$36c54161df755d1e$export$a8ff84c12d48cfa6 = `_8mkO2q_name`;
$36c54161df755d1e$export$9fc7da2585cefa14 = `_8mkO2q_planName`;
$36c54161df755d1e$export$bfd64c937657f93a = `_8mkO2q_rotating`;
$36c54161df755d1e$export$4a6dd88bada4e7d2 = `_8mkO2q_shimmer`;
$36c54161df755d1e$export$384817691e7c7e7d = `_8mkO2q_statusTag`;
$36c54161df755d1e$export$664c6d24e3175067 = `_8mkO2q_visible`;


function $b3f167a7bfbb4e96$var$TenantDropdownItem({ tenantData: tenantData, isSelected: isSelected, onClick: onClick }) {
    const { name: name, tag: tag, subscription: { planId: planId } } = tenantData;
    const { data: plans } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const tenantPlan = (0, $eCoWV.useMemo)(()=>plans?.find((plan)=>plan.id === planId), [
        plans,
        planId
    ]);
    if (!tenantPlan) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
        className: $36c54161df755d1e$export$7061c75fc5af8b7e,
        onClick: onClick,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $36c54161df755d1e$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $36c54161df755d1e$export$6990040ee07315,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $36c54161df755d1e$export$a8ff84c12d48cfa6,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1789cada9ae21d95$export$2e2bcd8739ae039), {
                                tag: tag
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c9c24d5d9376b2cf$export$2e2bcd8739ae039), {
                                tenantData: tenantData,
                                tenantPlan: tenantPlan,
                                className: $36c54161df755d1e$export$384817691e7c7e7d
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $36c54161df755d1e$export$9fc7da2585cefa14,
                        children: tag === (0, $3GN9E.TenantTag).Development ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "subscription.no_subscription"
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: tenantPlan.name
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $307Eo.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($36c54161df755d1e$export$1d8a03084661a191, isSelected && $36c54161df755d1e$export$664c6d24e3175067)
            })
        ]
    });
}
var $b3f167a7bfbb4e96$export$2e2bcd8739ae039 = $b3f167a7bfbb4e96$var$TenantDropdownItem;


var $c3a22ab712a51949$export$fb9188ad99e3f6b;
var $c3a22ab712a51949$export$718bc6d3654bffd4;
var $c3a22ab712a51949$export$c6a3c2629453bb7;
var $c3a22ab712a51949$export$81207e5cc4186890;
var $c3a22ab712a51949$export$a8ff84c12d48cfa6;
var $c3a22ab712a51949$export$bfd64c937657f93a;
var $c3a22ab712a51949$export$4c3df62464552999;
var $c3a22ab712a51949$export$4a6dd88bada4e7d2;
var $c3a22ab712a51949$export$2b067c6666111485;
$c3a22ab712a51949$export$fb9188ad99e3f6b = `_8z7V1W_arrowIcon`;
$c3a22ab712a51949$export$718bc6d3654bffd4 = `_8z7V1W_createTenantButton`;
$c3a22ab712a51949$export$c6a3c2629453bb7 = `_8z7V1W_currentTenantCard`;
$c3a22ab712a51949$export$81207e5cc4186890 = `_8z7V1W_dropdown`;
$c3a22ab712a51949$export$a8ff84c12d48cfa6 = `_8z7V1W_name`;
$c3a22ab712a51949$export$bfd64c937657f93a = `_8z7V1W_rotating`;
$c3a22ab712a51949$export$4c3df62464552999 = `_8z7V1W_scrollableContent`;
$c3a22ab712a51949$export$4a6dd88bada4e7d2 = `_8z7V1W_shimmer`;
$c3a22ab712a51949$export$2b067c6666111485 = `_8z7V1W_tag`;


function $86d01f597b8a43ff$export$2e2bcd8739ae039() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { tenants: tenants, prependTenant: prependTenant, currentTenant: currentTenantInfo, currentTenantId: currentTenantId, navigateTenant: navigateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const anchorRef = (0, $eCoWV.useRef)(null);
    const [showDropdown, setShowDropdown] = (0, $eCoWV.useState)(false);
    const [showCreateTenantModal, setShowCreateTenantModal] = (0, $eCoWV.useState)(false);
    const { updateDefaultTenantId: updateDefaultTenantId } = (0, $04fdf6fb7d151380$export$2e2bcd8739ae039)();
    if (tenants.length === 0 || !currentTenantInfo) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                ref: anchorRef,
                tabIndex: 0,
                className: $c3a22ab712a51949$export$c6a3c2629453bb7,
                role: "button",
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    setShowDropdown(true);
                }),
                onClick: ()=>{
                    setShowDropdown(true);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c3a22ab712a51949$export$a8ff84c12d48cfa6,
                        children: currentTenantInfo.name
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1789cada9ae21d95$export$2e2bcd8739ae039), {
                        className: $c3a22ab712a51949$export$2b067c6666111485,
                        tag: currentTenantInfo.tag
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $46ab19a7423faf73$export$2e2bcd8739ae039), {
                        className: $c3a22ab712a51949$export$fb9188ad99e3f6b
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                hasOverflowContent: true,
                className: $c3a22ab712a51949$export$81207e5cc4186890,
                anchorRef: anchorRef,
                isOpen: showDropdown,
                horizontalAlign: "start",
                onClose: ()=>{
                    setShowDropdown(false);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                        className: $c3a22ab712a51949$export$4c3df62464552999,
                        children: tenants.map((tenantData)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $b3f167a7bfbb4e96$export$2e2bcd8739ae039), {
                                tenantData: tenantData,
                                isSelected: tenantData.id === currentTenantId,
                                onClick: ()=>{
                                    navigateTenant(tenantData.id);
                                    updateDefaultTenantId(tenantData.id);
                                    setShowDropdown(false);
                                }
                            }, tenantData.id))
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90d2b44b795c16b0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("button", {
                        tabIndex: 0,
                        className: $c3a22ab712a51949$export$718bc6d3654bffd4,
                        onClick: ()=>{
                            setShowCreateTenantModal(true);
                        },
                        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                            setShowCreateTenantModal(true);
                        }),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                children: t("cloud.tenant.create_tenant")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $708876a8f61ed096$export$2e2bcd8739ae039), {
                isOpen: showCreateTenantModal,
                onClose: async (tenant)=>{
                    if (tenant) {
                        prependTenant(tenant);
                        navigateTenant(tenant.id);
                    }
                    setShowCreateTenantModal(false);
                }
            })
        ]
    });
}



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");
var $dMkQh = parcelRequire("dMkQh");

var $2CYkO = parcelRequire("2CYkO");
const $e85f4e623a60f103$var$application = {
    invalid_type: "Nur Maschinen-zu-Maschinen-Anwendungen k\xf6nnen Rollen haben.",
    role_exists: "Die Rolle mit der ID {{roleId}} wurde bereits dieser Anwendung hinzugef\xfcgt.",
    invalid_role_type: "Es ist nicht m\xf6glich, einer Maschinen-zu-Maschinen-Anwendung eine Benutzertyp-Rolle zuzuweisen."
};
var $e85f4e623a60f103$export$2e2bcd8739ae039 = Object.freeze($e85f4e623a60f103$var$application);


const $f0c32653fbe9da2b$var$auth = {
    authorization_header_missing: "Autorisierungs-Header fehlt.",
    authorization_token_type_not_supported: "Autorisierungs-Typ wird nicht unterst\xfctzt.",
    unauthorized: "Unautorisiert. Bitte \xfcberpr\xfcfe deine Zugangsdaten.",
    forbidden: "Verboten. Bitte \xfcberpr\xfcfe deine Rollen und Berechtigungen.",
    expected_role_not_found: "Erwartete Rolle nicht gefunden. Bitte \xfcberpr\xfcfe deine Rollen und Berechtigungen.",
    jwt_sub_missing: "`sub` fehlt in JWT.",
    require_re_authentication: "Zur Durchf\xfchrung einer gesch\xfctzten Aktion ist eine erneute Authentifizierung erforderlich."
};
var $f0c32653fbe9da2b$export$2e2bcd8739ae039 = Object.freeze($f0c32653fbe9da2b$var$auth);


const $a329365edce71ed8$var$connector = {
    general: "Fehler aufgetreten im Connector: {{errorDescription}}",
    not_found: "Kein verf\xfcgbarer Connector f\xfcr Typ {{type}} gefunden.",
    not_enabled: "Der Connector ist nicht aktiviert.",
    invalid_metadata: "Die Metadaten des Connectors sind ung\xfcltig.",
    invalid_config_guard: "Die Konfiguration des Connectors ist ung\xfcltig.",
    unexpected_type: "Der Typ des Connectors ist unerwartet.",
    invalid_request_parameters: "Die Anfrage enth\xe4lt falsche Eingabeparameter.",
    insufficient_request_parameters: "Die Anfrage enth\xe4lt m\xf6glicherweise nicht alle erforderlichen Eingabeparameter.",
    invalid_config: "Die Konfiguration des Connectors ist ung\xfcltig.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "Die Antwort des Connectors ist ung\xfcltig.",
    template_not_found: "Die richtige Vorlage in der Connector-Konfiguration konnte nicht gefunden werden.",
    template_not_supported: "Der Connector unterst\xfctzt diesen Vorlagentyp nicht.",
    rate_limit_exceeded: "Ausl\xf6ser-Rate-Limit. Bitte versuchen Sie es sp\xe4ter erneut.",
    not_implemented: "{{method}}: wurde noch nicht implementiert.",
    social_invalid_access_token: "Der Access Token des Connectors ist ung\xfcltig.",
    invalid_auth_code: "Der Authentifizierungscode des Connectors ist ung\xfcltig.",
    social_invalid_id_token: "Der ID-Token des Connectors ist ung\xfcltig.",
    authorization_failed: "Der Autorisierungsprozess des Benutzers war erfolglos.",
    social_auth_code_invalid: "Es konnte kein Access Token abgerufen werden. Bitte pr\xfcfen Sie den Autorisierungscode.",
    more_than_one_sms: "Die Anzahl der SMS-Connectors ist gr\xf6\xdfer als 1.",
    more_than_one_email: "Die Anzahl der E-Mail-Connectors ist gr\xf6\xdfer als 1.",
    more_than_one_connector_factory: "Mehrere Connector-Fabriken gefunden (mit ID {{connectorIds}}). Sie k\xf6nnen unn\xf6tige Fabriken deinstallieren.",
    db_connector_type_mismatch: "Es gibt einen Connector in der Datenbank, der nicht dem Typ entspricht.",
    not_found_with_connector_id: "Connector mit der angegebenen Standard-Connector-ID konnte nicht gefunden werden.",
    multiple_instances_not_supported: "Es k\xf6nnen keine mehreren Instanzen mit dem ausgew\xe4hlten Standard-Connector erstellt werden.",
    invalid_type_for_syncing_profile: "Sie k\xf6nnen nur Benutzerprofile mit sozialen Connectors synchronisieren.",
    can_not_modify_target: "Der 'target'-Connector kann nicht ge\xe4ndert werden.",
    should_specify_target: "Sie sollten den 'target' angeben.",
    multiple_target_with_same_platform: "Sie k\xf6nnen keine mehreren sozialen Connectors haben, die das gleiche Ziel und die gleiche Plattform haben.",
    cannot_overwrite_metadata_for_non_standard_connector: "Die 'Metadaten' dieses Connectors k\xf6nnen nicht \xfcberschrieben werden."
};
var $a329365edce71ed8$export$2e2bcd8739ae039 = Object.freeze($a329365edce71ed8$var$connector);


const $83bdc1e0aeaf6b71$var$domain = {
    not_configured: "Der Domain-Hostname-Anbieter ist nicht konfiguriert.",
    cloudflare_data_missing: "cloudflare_data fehlt, bitte \xfcberpr\xfcfen Sie es.",
    cloudflare_unknown_error: "Beim Anfordern der Cloudflare-API ist ein unbekannter Fehler aufgetreten",
    cloudflare_response_error: "Vom Cloudflare wurde eine unerwartete Antwort erhalten.",
    limit_to_one_domain: "Sie k\xf6nnen nur eine benutzerdefinierte Domain haben.",
    hostname_already_exists: "Diese Domain existiert bereits auf unserem Server.",
    cloudflare_not_found: "Hostname in Cloudflare nicht gefunden"
};
var $83bdc1e0aeaf6b71$export$2e2bcd8739ae039 = Object.freeze($83bdc1e0aeaf6b71$var$domain);


const $9dbfda2bf04b8af3$var$entity = {
    invalid_input: "Ung\xfcltige Eingabe. Wertliste darf nicht leer sein.",
    create_failed: "Fehler beim Erstellen von {{name}}.",
    db_constraint_violated: "Datenbankbeschr\xe4nkung verletzt.",
    not_exists: "{{name}} existiert nicht.",
    not_exists_with_id: "{{name}} mit ID `{{id}}` existiert nicht.",
    not_found: "Die Ressource wurde nicht gefunden.",
    relation_foreign_key_not_found: "Ein oder mehrere Fremdschl\xfcssel konnten nicht gefunden werden. Bitte \xfcberpr\xfcfen Sie die Eingabe und stellen Sie sicher, dass alle referenzierten Eintr\xe4ge vorhanden sind.",
    unique_integrity_violation: "Die Entit\xe4t besteht bereits. Bitte \xfcberpr\xfcfen Sie die Eingabe und versuchen Sie es erneut."
};
var $9dbfda2bf04b8af3$export$2e2bcd8739ae039 = Object.freeze($9dbfda2bf04b8af3$var$entity);


const $7011cae1b423ac93$var$guard = {
    invalid_input: "Die Anfrage {{type}} ist ung\xfcltig.",
    invalid_pagination: "Die Paginierung der Anfrage ist ung\xfcltig.",
    can_not_get_tenant_id: "Die tenant_id konnte nicht aus der Anfrage abgerufen werden.",
    file_size_exceeded: "Dateigr\xf6\xdfe \xfcberschritten.",
    mime_type_not_allowed: "Der MIME-Typ ist nicht erlaubt."
};
var $7011cae1b423ac93$export$2e2bcd8739ae039 = Object.freeze($7011cae1b423ac93$var$guard);


const $2e09fc4c0088dcde$var$hook = {
    missing_events: "Sie m\xfcssen mindestens ein Ereignis angeben.",
    send_test_payload_failed: "Fehler beim Senden des Testpayloads: {{message}}",
    endpoint_responded_with_error: "Endpunkt antwortete mit Fehler."
};
var $2e09fc4c0088dcde$export$2e2bcd8739ae039 = Object.freeze($2e09fc4c0088dcde$var$hook);


const $6f9e77200f1d0c84$var$localization = {
    cannot_delete_default_language: "{{languageTag}} ist die Standard-Sprache und kann nicht gel\xf6scht werden.",
    invalid_translation_structure: "Ung\xfcltige \xdcbersetzungsstruktur. Bitte \xfcberpr\xfcfe deine Eingabe."
};
var $6f9e77200f1d0c84$export$2e2bcd8739ae039 = Object.freeze($6f9e77200f1d0c84$var$localization);


const $621090080f5079b0$var$log = {
    invalid_type: "Der Log Typ ist ung\xfcltig."
};
var $621090080f5079b0$export$2e2bcd8739ae039 = Object.freeze($621090080f5079b0$var$log);


const $4ce62630e98e6763$var$oidc = {
    aborted: "Der Endnutzer hat die Interaktion abgebrochen.",
    invalid_scope: "Ung\xfcltiger Anwendungsbereich: {{error_description}}.",
    invalid_token: "Ung\xfcltiger Token \xfcbermittelt.",
    invalid_client_metadata: "Ung\xfcltige Client Metadaten \xfcbermittelt.",
    insufficient_scope: "Token fehlt den Anwendungsbereich `{{scope}}`.",
    invalid_request: "Anfrage ist ung\xfcltig.",
    invalid_grant: "Grant Anfrage ist ung\xfcltig.",
    invalid_redirect_uri: "`redirect_uri` stimmt nicht mit den registrierten `redirect_uris` des Clients \xfcberein.",
    access_denied: "Zugang verweigert.",
    invalid_target: "Ung\xfcltiger Ressourcenindikator.",
    unsupported_grant_type: "Nicht unterst\xfctzter `grant_type` angefragt.",
    unsupported_response_mode: "Nicht unterst\xfctzter `response_mode` angefragt.",
    unsupported_response_type: "Nicht unterst\xfctzter `response_type` angefragt.",
    provider_error: "OIDC interner Fehler: {{message}}.",
    server_error: "Ein unbekannter OIDC Fehler ist aufgetreten. Bitte versuchen Sie es sp\xe4ter erneut.",
    provider_error_fallback: "Ein OIDC Fehler ist aufgetreten: {{code}}.",
    key_required: "Mindestens ein Schl\xfcssel ist erforderlich.",
    key_not_found: "Der Schl\xfcssel mit der ID {{id}} wurde nicht gefunden."
};
var $4ce62630e98e6763$export$2e2bcd8739ae039 = Object.freeze($4ce62630e98e6763$var$oidc);


const $b5616606d54d24fb$var$organization = {
    require_membership: "Der Benutzer muss Mitglied der Organisation sein, um fortzufahren."
};
var $b5616606d54d24fb$export$2e2bcd8739ae039 = Object.freeze($b5616606d54d24fb$var$organization);


const $60db2257aa431857$var$password = {
    unsupported_encryption_method: "Die Verschl\xfcsselungsmethode {{name}} wird nicht unterst\xfctzt.",
    pepper_not_found: "Password pepper not found. Please check your core envs.",
    rejected: "Das Passwort wurde abgelehnt. Bitte \xfcberpr\xfcfen Sie, ob Ihr Passwort den Anforderungen entspricht."
};
var $60db2257aa431857$export$2e2bcd8739ae039 = Object.freeze($60db2257aa431857$var$password);


const $1d3c281960f06fa3$var$request = {
    invalid_input: "Eingabe ist ung\xfcltig. {{details}}",
    general: "Es ist ein Fehler bei der Anfrage aufgetreten."
};
var $1d3c281960f06fa3$export$2e2bcd8739ae039 = Object.freeze($1d3c281960f06fa3$var$request);


const $56bd9d17a086dc1e$var$resource = {
    resource_identifier_in_use: "Die API-Kennung {{indicator}} wird bereits verwendet"
};
var $56bd9d17a086dc1e$export$2e2bcd8739ae039 = Object.freeze($56bd9d17a086dc1e$var$resource);


const $5f2baf0b9c069faa$var$role = {
    name_in_use: "Dieser Rollenname {{name}} wird bereits verwendet.",
    scope_exists: "Die Scope-ID {{scopeId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    user_exists: "Die Benutzer-ID {{userId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    application_exists: "Die Anwendungs-ID {{applicationId}} wurde bereits zu dieser Rolle hinzugef\xfcgt.",
    default_role_missing: "Einige der Standardrollennamen sind in der Datenbank nicht vorhanden. Bitte stellen Sie sicher, dass Sie zuerst Rollen erstellen.",
    internal_role_violation: 'Sie versuchen m\xf6glicherweise, eine interne Rolle zu aktualisieren oder zu l\xf6schen, was von Logto verboten ist. Wenn Sie eine neue Rolle erstellen, versuchen Sie es mit einem anderen Namen, der nicht mit "#internal:" beginnt.'
};
var $5f2baf0b9c069faa$export$2e2bcd8739ae039 = Object.freeze($5f2baf0b9c069faa$var$role);


const $6b45e1d28b81abac$var$scope = {
    name_exists: "Der Scope-Name {{name}} ist bereits in Verwendung",
    name_with_space: "Der Name des Scopes darf keine Leerzeichen enthalten."
};
var $6b45e1d28b81abac$export$2e2bcd8739ae039 = Object.freeze($6b45e1d28b81abac$var$scope);


const $7ffa41adc1cec4b2$var$session = {
    not_found: "Sitzung nicht gefunden. Bitte melde dich erneut an.",
    invalid_credentials: "Ung\xfcltige Zugangsdaten. \xdcberpr\xfcfe deine Eingaben.",
    invalid_sign_in_method: "Aktuelle Anmeldemethode ist ung\xfcltig.",
    invalid_connector_id: "Connector mit ID {{connectorId}} wurde nicht gefunden.",
    insufficient_info: "Unzureichende Informationen f\xfcr die Anmeldung.",
    connector_id_mismatch: "Connector ID stimmt nicht mit Sitzung \xfcberein.",
    connector_session_not_found: "Connector Sitzung nicht gefunden. Bitte melde dich erneut an.",
    verification_session_not_found: "Die Verifizierung war nicht erfolgreich. Starte die Verifizierung neu und versuche es erneut.",
    verification_expired: "Die Verbindung wurde unterbrochen. Verifiziere erneut, um die Sicherheit deines Kontos zu gew\xe4hrleisten.",
    verification_blocked_too_many_attempts: "Zu viele Versuche in kurzer Zeit. Bitte versuche es erneut {{relativeTime}}.",
    unauthorized: "Bitte melde dich erst an.",
    unsupported_prompt_name: "Nicht unterst\xfctzter prompt Name.",
    forgot_password_not_enabled: "Passwort vergessen ist nicht aktiviert.",
    verification_failed: "Die Verifizierung war nicht erfolgreich. Starte die Verifizierung neu und versuche es erneut.",
    connector_validation_session_not_found: "Die Connector-Sitzung zur Token-Validierung wurde nicht gefunden.",
    identifier_not_found: "Benutzerkennung nicht gefunden. Bitte gehen Sie zur\xfcck und melden Sie sich erneut an.",
    interaction_not_found: "Interaktionssitzung nicht gefunden. Bitte gehen Sie zur\xfcck und starten Sie die Sitzung erneut.",
    not_supported_for_forgot_password: "Diese Operation wird f\xfcr das vergessene Passwort nicht unterst\xfctzt.",
    mfa: {
        require_mfa_verification: "MFA-Verifizierung ist erforderlich, um sich anzumelden.",
        mfa_sign_in_only: "MFA ist nur f\xfcr die Anmeldeinteraktion verf\xfcgbar.",
        pending_info_not_found: "Ausstehende MFA-Informationen nicht gefunden. Bitte initiieren Sie zuerst MFA.",
        invalid_totp_code: "Ung\xfcltiger TOTP-Code.",
        webauthn_verification_failed: "WebAuthn-Verifizierung fehlgeschlagen.",
        webauthn_verification_not_found: "WebAuthn-Verifizierung nicht gefunden.",
        bind_mfa_existed: "MFA ist bereits vorhanden.",
        backup_code_can_not_be_alone: "Backup-Code kann nicht die einzige MFA sein.",
        backup_code_required: "Backup-Code ist erforderlich.",
        invalid_backup_code: "Ung\xfcltiger Backup-Code.",
        mfa_policy_not_user_controlled: "MFA-Richtlinie wird nicht vom Benutzer gesteuert."
    },
    sso_enabled: "Einmaliges Anmelden ist f\xfcr diese gegebene E-Mail aktiviert. Bitte melden Sie sich mit SSO an."
};
var $7ffa41adc1cec4b2$export$2e2bcd8739ae039 = Object.freeze($7ffa41adc1cec4b2$var$session);


const $2683eee430709992$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Leere "Nutzungsbedingungen" URL. Bitte f\xfcge die URL hinzu, wenn "Nutzungsbedingungen" aktiviert ist.',
    empty_social_connectors: "Leere Social Connectors. Bitte f\xfcge aktivierte Social Connectoren hinzu, wenn Social Anmeldung aktiviert ist.",
    enabled_connector_not_found: "Aktivierter {{type}} Connector nicht gefunden.",
    not_one_and_only_one_primary_sign_in_method: "Es darf nur eine prim\xe4re Anmeldemethode geben. Bitte \xfcberpr\xfcfe deine Eingabe.",
    username_requires_password: "Muss ein Passwort f\xfcr den Benutzernamen zur Registrierung aktivieren.",
    passwordless_requires_verify: "Muss die Verifizierung f\xfcr die Registrierung per E-Mail/Telefon aktivieren.",
    miss_sign_up_identifier_in_sign_in: "Anmeldeverfahren m\xfcssen den Registrierungs-Identifier enthalten.",
    password_sign_in_must_be_enabled: "Die Passwort-Anmeldung muss aktiviert sein, wenn bei der Registrierung ein Passwort festgelegt wird.",
    code_sign_in_must_be_enabled: "Die Anmeldung mit Best\xe4tigungscode muss aktiviert sein, wenn bei der Registrierung kein Passwort festgelegt wird.",
    unsupported_default_language: "Die Sprache - {{language}} wird momentan nicht unterst\xfctzt.",
    at_least_one_authentication_factor: "Sie m\xfcssen mindestens einen Authentifizierungsfaktor ausw\xe4hlen.",
    backup_code_cannot_be_enabled_alone: "Backup-Code kann nicht alleine aktiviert werden.",
    duplicated_mfa_factors: "Duplizierte MFA-Faktoren."
};
var $2683eee430709992$export$2e2bcd8739ae039 = Object.freeze($2683eee430709992$var$sign_in_experiences);


const $325d3d94465974a0$var$single_sign_on = {
    forbidden_domains: "\xd6ffentliche E-Mail-Dom\xe4nen sind nicht erlaubt.",
    duplicated_domains: "Es gibt doppelte Dom\xe4nen.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $325d3d94465974a0$export$2e2bcd8739ae039 = Object.freeze($325d3d94465974a0$var$single_sign_on);


const $c127091232564a04$var$storage = {
    not_configured: "Der Storage-Anbieter ist nicht konfiguriert.",
    missing_parameter: "Fehlender Parameter {{parameter}} f\xfcr den Storage-Anbieter.",
    upload_error: "Das Hochladen der Datei zum Storage-Anbieter ist fehlgeschlagen."
};
var $c127091232564a04$export$2e2bcd8739ae039 = Object.freeze($c127091232564a04$var$storage);


const $c1e402730d22c632$var$subscription = {
    limit_exceeded: "Sie haben das Limit Ihres Abonnementplans erreicht.",
    get_plan_failed: "Fehler beim Abrufen des Abonnementplans f\xfcr den Mandanten.",
    tenant_suspended: "Mandant ist gesperrt. Bitte kontaktieren Sie Ihren Administrator."
};
var $c1e402730d22c632$export$2e2bcd8739ae039 = Object.freeze($c1e402730d22c632$var$subscription);


const $d7e25e1fa2a67a64$var$swagger = {
    invalid_zod_type: "Ung\xfcltiger Zod Typ. \xdcberpr\xfcfe deine route guard Konfiguration.",
    not_supported_zod_type_for_params: "Nicht unterst\xfctzter Zod Typ f\xfcr diese Parameter. \xdcberpr\xfcfe deine route guard Konfiguration."
};
var $d7e25e1fa2a67a64$export$2e2bcd8739ae039 = Object.freeze($d7e25e1fa2a67a64$var$swagger);


const $971056ce20285748$var$user = {
    username_already_in_use: "Dieser Benutzername wird bereits verwendet.",
    email_already_in_use: "Diese E-Mail-Adresse ist mit einem vorhandenen Konto verkn\xfcpft.",
    phone_already_in_use: "Diese Telefonnummer ist mit einem vorhandenen Konto verkn\xfcpft.",
    invalid_email: "Ung\xfcltige E-Mail.",
    invalid_phone: "Ung\xfcltige Telefonnummer.",
    email_not_exist: "Die E-Mail wurde noch nicht registriert.",
    phone_not_exist: "Die Telefonnummer wurde noch nicht registriert.",
    identity_not_exist: "Die Identit\xe4t wurde noch nicht registriert.",
    identity_already_in_use: "Die Identit\xe4t wurde registriert.",
    social_account_exists_in_profile: "Sie haben diesen Social-Media-Account bereits verkn\xfcpft.",
    cannot_delete_self: "Du kannst dich nicht selbst l\xf6schen.",
    sign_up_method_not_enabled: "Diese Anmeldeart ist nicht aktiviert.",
    sign_in_method_not_enabled: "Diese Anmeldemethode ist nicht aktiviert.",
    same_password: "Das neue Passwort muss sich vom alten unterscheiden.",
    password_required_in_profile: "Sie m\xfcssen ein Passwort festlegen, bevor Sie sich anmelden k\xf6nnen.",
    new_password_required_in_profile: "Sie m\xfcssen ein neues Passwort festlegen.",
    password_exists_in_profile: "Das Passwort ist bereits in Ihrem Profil vorhanden.",
    username_required_in_profile: "Sie m\xfcssen einen Benutzernamen festlegen, bevor Sie sich anmelden k\xf6nnen.",
    username_exists_in_profile: "Der Benutzername ist bereits in Ihrem Profil vorhanden.",
    email_required_in_profile: "Sie m\xfcssen eine E-Mail-Adresse hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    email_exists_in_profile: "Ihr Profil ist bereits mit einer E-Mail-Adresse verkn\xfcpft.",
    phone_required_in_profile: "Sie m\xfcssen eine Telefonnummer hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    phone_exists_in_profile: "Ihr Profil ist bereits mit einer Telefonnummer verkn\xfcpft.",
    email_or_phone_required_in_profile: "Sie m\xfcssen eine E-Mail-Adresse oder eine Telefonnummer hinzuf\xfcgen, bevor Sie sich anmelden k\xf6nnen.",
    suspended: "Dieses Konto wurde gesperrt.",
    user_not_exist: "Der Benutzer mit {{ identifier }} existiert nicht.",
    missing_profile: "Sie m\xfcssen zus\xe4tzliche Informationen angeben, bevor Sie sich anmelden k\xf6nnen.",
    role_exists: "Die Rollen-ID {{roleId}} wurde diesem Benutzer bereits hinzugef\xfcgt.",
    invalid_role_type: "Ung\xfcltiger Rollentyp, kann keine Maschinen-zu-Maschinen-Rolle einem Benutzer zuweisen.",
    missing_mfa: "Sie m\xfcssen zus\xe4tzliches MFA verbinden, bevor Sie sich anmelden k\xf6nnen.",
    totp_already_in_use: "TOTP wird bereits verwendet.",
    backup_code_already_in_use: "Backup-Code wird bereits verwendet."
};
var $971056ce20285748$export$2e2bcd8739ae039 = Object.freeze($971056ce20285748$var$user);


const $8b838b942df08ef8$var$verification_code = {
    phone_email_empty: "Sowohl Telefon als auch E-Mail sind leer.",
    not_found: "Best\xe4tigungscode nicht gefunden. Bitte senden Sie zuerst den Best\xe4tigungscode.",
    phone_mismatch: "Telefonnummer stimmt nicht \xfcberein. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    email_mismatch: "E-Mail stimmt nicht \xfcberein. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    code_mismatch: "Ung\xfcltiger Best\xe4tigungscode.",
    expired: "Best\xe4tigungscode ist abgelaufen. Bitte fordern Sie einen neuen Best\xe4tigungscode an.",
    exceed_max_try: "Die Begrenzung f\xfcr die Anzahl der Best\xe4tigungscode-Wiederholungen wurde \xfcberschritten. Bitte fordern Sie einen neuen Best\xe4tigungscode an."
};
var $8b838b942df08ef8$export$2e2bcd8739ae039 = Object.freeze($8b838b942df08ef8$var$verification_code);


const $f8fe8b732c674d9b$var$errors = {
    request: $1d3c281960f06fa3$export$2e2bcd8739ae039,
    auth: $f0c32653fbe9da2b$export$2e2bcd8739ae039,
    guard: $7011cae1b423ac93$export$2e2bcd8739ae039,
    oidc: $4ce62630e98e6763$export$2e2bcd8739ae039,
    user: $971056ce20285748$export$2e2bcd8739ae039,
    password: $60db2257aa431857$export$2e2bcd8739ae039,
    session: $7ffa41adc1cec4b2$export$2e2bcd8739ae039,
    connector: $a329365edce71ed8$export$2e2bcd8739ae039,
    verification_code: $8b838b942df08ef8$export$2e2bcd8739ae039,
    sign_in_experiences: $2683eee430709992$export$2e2bcd8739ae039,
    localization: $6f9e77200f1d0c84$export$2e2bcd8739ae039,
    swagger: $d7e25e1fa2a67a64$export$2e2bcd8739ae039,
    entity: $9dbfda2bf04b8af3$export$2e2bcd8739ae039,
    log: $621090080f5079b0$export$2e2bcd8739ae039,
    role: $5f2baf0b9c069faa$export$2e2bcd8739ae039,
    scope: $6b45e1d28b81abac$export$2e2bcd8739ae039,
    storage: $c127091232564a04$export$2e2bcd8739ae039,
    resource: $56bd9d17a086dc1e$export$2e2bcd8739ae039,
    hook: $2e09fc4c0088dcde$export$2e2bcd8739ae039,
    domain: $83bdc1e0aeaf6b71$export$2e2bcd8739ae039,
    subscription: $c1e402730d22c632$export$2e2bcd8739ae039,
    application: $e85f4e623a60f103$export$2e2bcd8739ae039,
    organization: $b5616606d54d24fb$export$2e2bcd8739ae039,
    single_sign_on: $325d3d94465974a0$export$2e2bcd8739ae039
};
var $f8fe8b732c674d9b$export$2e2bcd8739ae039 = Object.freeze($f8fe8b732c674d9b$var$errors);


const $c7dca8b8b565eb2a$var$api_resource_details = {
    page_title: "API Ressourcendetails",
    back_to_api_resources: "Zur\xfcck zu API Ressourcen",
    settings_tab: "Einstellungen",
    permissions_tab: "Berechtigungen",
    settings: "Einstellungen",
    settings_description: "API-Ressourcen, auch Ressourcenindikatoren genannt, geben die Ziel-Dienste oder Ressourcen an, die angefordert werden sollen. H\xe4ufig handelt es sich um eine URI-Formatvariable, die die Identit\xe4t der Ressource darstellt.",
    management_api_settings_description: "Die Logto Management-API ist eine umfassende Sammlung von APIs, die Administratoren bef\xe4higen, eine Vielzahl von Aufgaben im Zusammenhang mit Identit\xe4ten zu verwalten, Sicherheitsrichtlinien durchzusetzen und Vorschriften und Standards einzuhalten.",
    management_api_notice: "Diese API repr\xe4sentiert die Logto-Entit\xe4t und kann nicht ge\xe4ndert oder gel\xf6scht werden. Sie k\xf6nnen die Management-API f\xfcr eine Vielzahl von identit\xe4tsbezogenen Aufgaben verwenden. <a>Informieren Sie sich</a>",
    token_expiration_time_in_seconds: "Token-Ablaufzeit (in Sekunden)",
    token_expiration_time_in_seconds_placeholder: "Geben Sie die Ablaufzeit des Tokens ein",
    delete_description: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Die API-Ressource wird permanent gel\xf6scht. Bitte geben Sie den API-Ressourcennamen <span>{{name}}</span> zur Best\xe4tigung ein.",
    enter_your_api_resource_name: "Geben Sie einen API-Ressourcennamen ein",
    api_resource_deleted: "Die API-Ressource {{name}} wurde erfolgreich gel\xf6scht",
    permission: {
        create_button: "Berechtigung erstellen",
        create_title: "Berechtigung erstellen",
        create_subtitle: "Definieren Sie die ben\xf6tigten Berechtigungen (Bereiche) f\xfcr diese API.",
        confirm_create: "Berechtigung erstellen",
        name: "Berechtigungsname",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "Der Berechtigungsname darf keine Leerzeichen enthalten.",
        description: "Beschreibung",
        description_placeholder: "Zugriff auf Ressourcen lesen",
        permission_created: "Die Berechtigung {{name}} wurde erfolgreich erstellt",
        delete_description: "Wenn diese Berechtigung gel\xf6scht wird, verliert der Benutzer, der diese Berechtigung hatte, den dadurch gew\xe4hrten Zugriff.",
        deleted: 'Die Berechtigung "{{name}}" wurde erfolgreich gel\xf6scht.'
    }
};
var $c7dca8b8b565eb2a$export$2e2bcd8739ae039 = Object.freeze($c7dca8b8b565eb2a$var$api_resource_details);


const $e485cd46f017ecaa$var$api_resources = {
    page_title: "API Ressourcen",
    title: "API Ressourcen",
    subtitle: "Lege APIs an, die du in deinen autorisierten Anwendungen verwenden kannst",
    create: "API Ressource erstellen",
    api_name: "API-Name",
    api_name_placeholder: "Gib einen API-Namen ein",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Der eindeutige Identifikator der API-Ressource muss eine absolute URI ohne Fragmentbezeichner (#) sein. Entspricht dem <a>Ressourcenparameter</a> in OAuth 2.0.",
    default_api: "Standard-API",
    default_api_label: "Pro Mandant kann nur eine Standard-API festgelegt werden. Wenn eine Standard-API festgelegt ist, kann der Ressourcenparameter in der Authentifizierungsanfrage weggelassen werden. Folgende Token-Austauschvorg\xe4nge verwenden standardm\xe4\xdfig die API als Publikum, was zur Ausgabe von JWTs f\xfchrt. <a>Erfahren Sie mehr</a>",
    api_resource_created: "Die API-Ressource {{name}} wurde erfolgreich erstellt"
};
var $e485cd46f017ecaa$export$2e2bcd8739ae039 = Object.freeze($e485cd46f017ecaa$var$api_resources);


const $5a87a3db767e5a5c$var$application_details = {
    page_title: "Anwendungsdaten",
    back_to_applications: "Zur\xfcck zu Anwendungen",
    check_guide: "Zur Anleitung",
    settings: "Einstellungen",
    settings_description: "Anwendungen werden verwendet, um Ihre Anwendungen in Logto f\xfcr OIDC, Anmeldeerfahrung, Audit-Logs usw. zu identifizieren.",
    advanced_settings: "Erweiterte Einstellungen",
    advanced_settings_description: "Erweiterte Einstellungen beinhalten OIDC-bezogene Begriffe. Sie k\xf6nnen den Token-Endpunkt f\xfcr weitere Informationen \xfcberpr\xfcfen.",
    application_roles: "Rollen",
    machine_logs: "Maschinenprotokolle",
    application_name: "Anwendungsname",
    application_name_placeholder: "Meine App",
    description: "Beschreibung",
    description_placeholder: "Gib eine Beschreibung ein",
    config_endpoint: "OpenID Provider Konfigurations-Endpunkt",
    authorization_endpoint: "Autorisierungs-Endpoint",
    authorization_endpoint_tip: "Der Endpoint, der f\xfcr die Authentifizierung und <a>Authorisierung</a> via OpenID Connect verwendet wird.",
    logto_endpoint: "Logto-Endpunkt",
    application_id: "App-ID",
    application_id_tip: 'Die eindeutige Anwendungs-ID, die normalerweise von Logto generiert wird. Es steht auch f\xfcr "<a>client_id</a>" in OpenID Connect.',
    application_secret: "App-Geheimnis",
    redirect_uri: "Umleitungs-URI",
    redirect_uris: "Umleitungs-URIs",
    redirect_uri_placeholder: "https://deine.website.de/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "URI, zu der der Benutzer nach der Anmeldung (egal ob erfolgreich oder nicht) weitergeleitet wird. Siehe OpenID Connect <a>AuthRequest</a> f\xfcr weitere Informationen.",
    post_sign_out_redirect_uri: "Post Sign-out Umleitungs-URI",
    post_sign_out_redirect_uris: "Post Sign-out Umleitungs-URIs",
    post_sign_out_redirect_uri_placeholder: "https://deine.website.de/home",
    post_sign_out_redirect_uri_tip: "URI, zu der der Benutzer nach dem Abmelden weitergeleitet wird (optional). Hat bei einigen Anwendungstypen keine Auswirkungen.",
    cors_allowed_origins: "CORS zugelassene Urspr\xfcnge",
    cors_allowed_origins_placeholder: "https://your.website.de",
    cors_allowed_origins_tip: "Standardm\xe4\xdfig sind alle Umleitungs-URI-Urspr\xfcnge zul\xe4ssig. Normalerweise ist dieses Feld nicht erforderlich. Siehe die <a>MDN-Dokumentation<a>f\xfcr detaillierte Informationen.",
    token_endpoint: "Token-Endpunkt",
    user_info_endpoint: "Benutzerinformations-Endpunkt",
    enable_admin_access: "Admin-Zugang aktivieren",
    enable_admin_access_label: "Zugang zur Management API aktivieren oder deaktivieren. Wenn aktiviert, k\xf6nnen Access Tokens verwendet werden, um die Management API im Namen der Anwendung aufzurufen.",
    always_issue_refresh_token: "Immer den Refresh Token ausgeben",
    always_issue_refresh_token_label: 'Durch Aktivieren dieser Konfiguration kann Logto immer Refresh Tokens ausgeben, unabh\xe4ngig davon, ob in der Authentifizierungsanforderung "prompt=consent" angegeben ist. Diese Praxis wird jedoch nur dann empfohlen, wenn es notwendig ist, da sie nicht mit OpenID Connect kompatibel ist und m\xf6glicherweise Probleme verursacht.',
    refresh_token_ttl: "Ablaufzeit des Refresh Tokens in Tagen",
    refresh_token_ttl_tip: "Die Dauer, f\xfcr die ein Refresh Token verwendet werden kann, um neue Zugriffstoken anzufordern, bevor es abl\xe4uft und ung\xfcltig wird. Token-Anfragen erweitern die Verfallszeit des Refresh Tokens auf diesen Wert.",
    rotate_refresh_token: "Refresh Token drehen",
    rotate_refresh_token_label: "Wenn diese Option aktiviert ist, wird Logto f\xfcr Tokenanfragen ein neues Refresh Token ausgeben, wenn 70% der urspr\xfcnglichen Zeit bis zur Ausf\xfchrung (TTL) verstrichen sind oder bestimmte Bedingungen erf\xfcllt sind. <a>Erfahren Sie mehr</a>",
    delete_description: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Die Anwendung wird permanent gel\xf6scht. Bitte gib den Anwendungsnamen <span>{{name}}</span> zur Best\xe4tigung ein.",
    enter_your_application_name: "Gib einen Anwendungsnamen ein",
    application_deleted: "Anwendung {{name}} wurde erfolgreich gel\xf6scht",
    redirect_uri_required: "Gib mindestens eine Umleitungs-URI an",
    roles: {
        name_column: "Rolle",
        description_column: "Beschreibung",
        assign_button: "Rollen zuweisen",
        delete_description: "Diese Aktion entfernt diese Rolle von dieser Maschinen-zu-Maschinen-App. Die Rolle selbst existiert weiterhin, ist aber nicht mehr mit dieser Maschinen-zu-Maschinen-App verkn\xfcpft.",
        deleted: "{{name}} wurde erfolgreich von diesem Benutzer entfernt.",
        assign_title: "Rollen an {{name}} zuweisen",
        assign_subtitle: "Autorisiere {{name}} mit einer oder mehreren Rollen",
        assign_role_field: "Rollen zuweisen",
        role_search_placeholder: "Nach Rollennamen suchen",
        added_text: "{{value, number}} hinzugef\xfcgt",
        assigned_app_count: "{{value, number}} Anwendungen",
        confirm_assign: "Rollen zuweisen",
        role_assigned: "Rolle(n) erfolgreich zugewiesen",
        search: "Nach Rollennamen, Beschreibung oder ID suchen",
        empty: "Keine Rollen verf\xfcgbar"
    }
};
var $5a87a3db767e5a5c$export$2e2bcd8739ae039 = Object.freeze($5a87a3db767e5a5c$var$application_details);


const $aa148b16b42310c7$var$applications = {
    page_title: "Anwendungen",
    title: "Anwendungen",
    subtitle: "Richte eine native, single page, machine to machine oder herk\xf6mmliche Anwendung ein, die Logto zur Authentifizierung nutzt.",
    subtitle_with_app_type: "Richte Logto-Authentifizierung f\xfcr deine {{name}}-Anwendung ein",
    create: "Anwendung erstellen",
    application_name: "Anwendungsname",
    application_name_placeholder: "Meine App",
    application_description: "Anwendungsbeschreibung",
    application_description_placeholder: "Gib eine Beschreibung ein",
    select_application_type: "W\xe4hle einen Anwendungstyp",
    no_application_type_selected: "Du hast noch keinen Anwendungstyp ausgew\xe4hlt",
    application_created: "Die Anwendung wurde erfolgreich erstellt.",
    app_id: "App ID",
    type: {
        native: {
            title: "Native App",
            subtitle: "Eine Anwendung, die in einer nativen Umgebung l\xe4uft",
            description: "z.B. iOS app, Android app"
        },
        spa: {
            title: "Single Page App",
            subtitle: "Eine Anwendung, die in einem Webbrowser ausgef\xfchrt wird und Daten dynamisch an Ort und Stelle aktualisiert",
            description: "z.B. React DOM app, Vue app"
        },
        traditional: {
            title: "Herk\xf6mmliche Website",
            subtitle: "Eine Anwendung, die Seiten allein durch den Webserver rendert und aktualisiert",
            description: "z.B. Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Eine Anwendung (normalerweise ein Dienst), die direkt mit Ressourcen kommuniziert",
            description: "z.B. Backend Dienst"
        }
    },
    placeholder_title: "W\xe4hle einen Anwendungstyp, um fortzufahren",
    placeholder_description: "Logto verwendet eine Anwendungs-Entit\xe4t f\xfcr OIDC, um Aufgaben wie die Identifizierung Ihrer Apps, die Verwaltung der Anmeldung und die Erstellung von Pr\xfcfprotokollen zu erleichtern."
};
var $aa148b16b42310c7$export$2e2bcd8739ae039 = Object.freeze($aa148b16b42310c7$var$applications);


const $7a49350fa2c30d49$var$cloud = {
    general: {
        onboarding: "Einf\xfchrung"
    },
    welcome: {
        page_title: "Willkommen",
        title: "Willkommen bei Logto Cloud! Wir m\xf6chten gerne ein bisschen mehr \xfcber Sie erfahren.",
        description: "Machen Sie Ihre Logto-Erfahrung einzigartig, indem Sie uns besser kennenlernen. Ihre Informationen sind bei uns sicher.",
        project_field: "Ich verwende Logto f\xfcr",
        project_options: {
            personal: "Pers\xf6nliches Projekt",
            company: "Unternehmensprojekt"
        },
        title_field: "W\xe4hlen Sie anwendbare Titel aus",
        title_options: {
            developer: "Entwickler",
            team_lead: "Teamleiter",
            ceo: "CEO",
            cto: "CTO",
            product: "Produkt",
            others: "Andere"
        },
        company_name_field: "Firmenname",
        company_name_placeholder: "Acme.co",
        company_size_field: "Wie gro\xdf ist Ihre Firma?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Ich melde mich an, weil",
        reason_options: {
            passwordless: "Auf der Suche nach passwortloser Authentifizierung und UI-Kit",
            efficiency: "Auf der Suche nach out-of-the-box Identit\xe4tsinfrastruktur",
            access_control: "Benutzerzugriff auf Rolle und Verantwortung kontrollieren",
            multi_tenancy: "Auf der Suche nach Strategien f\xfcr ein Multi-Tenancy-Produkt",
            enterprise: "Suche nach SSO-L\xf6sungen f\xfcr Enterprise-Readiness",
            others: "Andere"
        }
    },
    sie: {
        page_title: "Meldeeinrichtung anpassen",
        title: "Passen Sie zuerst Ihre Anmeldungserfahrung mit Leichtigkeit an",
        inspire: {
            title: "Erstellen Sie \xfcberzeugende Beispiele",
            description: 'F\xfchlen Sie sich unsicher bei der Anmeldeerfahrung? Klicken Sie einfach auf "Inspire me" und lassen Sie die Magie geschehen!',
            inspire_me: "Inspirieren Sie mich"
        },
        logo_field: "App-Logo",
        color_field: "Markenfarbe",
        identifier_field: "Identifikator",
        identifier_options: {
            email: "E-Mail",
            phone: "Telefon",
            user_name: "Benutzername"
        },
        authn_field: "Authentifizierung",
        authn_options: {
            password: "Passwort",
            verification_code: "Verifizierungscode"
        },
        social_field: "Soziale Anmeldung",
        finish_and_done: "Fertig und erledigt",
        preview: {
            mobile_tab: "Mobil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Sp\xe4ter entsperrt",
            unlocked_later_tip: "Sobald Sie den Onboarding-Prozess abgeschlossen und das Produkt betreten haben, haben Sie Zugriff auf noch mehr soziale Anmeldeverfahren.",
            notice: "Bitte verwenden Sie den Demo-Connector nicht f\xfcr Produktionszwecke. Sobald Sie mit dem Testen fertig sind, l\xf6schen Sie bitte den Demo-Connector und richten Sie Ihren eigenen Connector mit Ihren Anmeldeinformationen ein."
        }
    },
    socialCallback: {
        title: "Sie haben sich erfolgreich angemeldet",
        description: "Sie haben sich erfolgreich mit Ihrem Social-Account angemeldet. Um eine nahtlose Integration und den Zugriff auf alle Funktionen von Logto zu gew\xe4hrleisten, empfehlen wir Ihnen, Ihren eigenen Social-Connector zu konfigurieren."
    },
    tenant: {
        create_tenant: "Tenant erstellen"
    }
};
var $7a49350fa2c30d49$export$2e2bcd8739ae039 = Object.freeze($7a49350fa2c30d49$var$cloud);


const $e829e127e1641034$var$components = {
    uploader: {
        action_description: "Ziehen und Ablegen oder Datei ausw\xe4hlen",
        uploading: "Wird hochgeladen...",
        image_limit: "Lade ein Bild unter {{size, number}}KB hoch, nur {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Etwas ist schiefgelaufen. Dateiupload fehlgeschlagen.",
        error_file_size: "Dateigr\xf6\xdfe ist zu gro\xdf. Bitte lade eine Datei unter {{size, number}}KB hoch.",
        error_file_type: "Dateityp wird nicht unterst\xfctzt. Nur {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Sie k\xf6nnen nur 1 Datei hochladen."
    }
};
var $e829e127e1641034$export$2e2bcd8739ae039 = Object.freeze($e829e127e1641034$var$components);


const $69df924f5631d054$var$connector_details = {
    page_title: "Verbindungsdetails",
    back_to_connectors: "Zur\xfcck zu Connectoren",
    check_readme: "Zur README",
    settings: "Allgemeine Einstellungen",
    settings_description: "Connectoren spielen eine wichtige Rolle in Logto. Mit ihrer Hilfe erm\xf6glicht Logto Endbenutzern eine passwortlose Registrierung oder Anmeldung sowie die M\xf6glichkeit, sich mit Social Accounts anzumelden.",
    parameter_configuration: "Parameter-Konfiguration",
    test_connection: "Testen",
    save_error_empty_config: "Bitte f\xfclle die Konfiguration aus",
    send: "Senden",
    send_error_invalid_format: "Ung\xfcltige Eingabe",
    edit_config_label: "Gib deine JSON-Konfiguration ein",
    test_email_sender: "Teste den E-Mail Connector",
    test_sms_sender: "Teste den SMS Connector",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+49 151 12345678",
    test_message_sent: "Testnachricht wurde gesendet",
    test_sender_description: 'Logto verwendet die "Generic"-Vorlage zum Testen. Du erh\xe4ltst eine Nachricht, wenn dein Connector richtig konfiguriert ist.',
    options_change_email: "E-Mail Connector bearbeiten",
    options_change_sms: "SMS Connector bearbeiten",
    connector_deleted: "Der Connector wurde erfolgreich gel\xf6scht",
    type_email: "E-Mail Connector",
    type_sms: "SMS Connector",
    type_social: "Social Connector",
    in_used_social_deletion_description: "Dieser Connector wird in Ihrem Anmeldeerlebnis verwendet. Durch das L\xf6schen wird das Anmeldeerlebnis in den Anmeldeerlebniseinstellungen gel\xf6scht. Wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten, m\xfcssen Sie ihn erneut konfigurieren.",
    in_used_passwordless_deletion_description: "Dieser {{name}} wird in Ihrem Anmeldeerlebnis verwendet. Wenn Sie ihn l\xf6schen, funktioniert Ihr Anmeldeerlebnis nicht ordnungsgem\xe4\xdf, bis Sie das Problem gel\xf6st haben. Wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten, m\xfcssen Sie ihn erneut konfigurieren.",
    deletion_description: "Sie entfernen diesen Connector. Dies kann nicht r\xfcckg\xe4ngig gemacht werden, und Sie m\xfcssen ihn erneut konfigurieren, wenn Sie ihn wieder hinzuf\xfcgen m\xf6chten.",
    logto_email: {
        total_email_sent: "Gesamtanzahl gesendeter E-Mails: {{value, number}}",
        total_email_sent_tip: "Logto verwendet SendGrid f\xfcr sicheren und stabilen integrierten E-Mail-Versand. Es ist komplett kostenlos. <a>Weitere Informationen</a>",
        email_template_title: "E-Mail-Vorlage",
        template_description: "Der integrierte E-Mail-Versand verwendet Standardvorlagen f\xfcr eine nahtlose Zustellung von Verifizierungs-E-Mails. Es ist keine Konfiguration erforderlich, und Sie k\xf6nnen grundlegende Markeninformationen anpassen.",
        template_description_link_text: "Vorlagen anzeigen",
        description_action_text: "Vorlagen anzeigen",
        from_email_field: "Absender-E-Mail",
        sender_name_field: "Sender name",
        sender_name_tip: 'Passen Sie den Absendernamen f\xfcr E-Mails an. Wenn es leer gelassen wird, wird "Verification" als Standardname verwendet.',
        sender_name_placeholder: "Ihr Absendername",
        company_information_field: "Firmeninformationen",
        company_information_description: "Zeigen Sie den Firmennamen, die Adresse oder die Postleitzahl am Ende der E-Mails an, um die Authentizit\xe4t zu erh\xf6hen.",
        company_information_placeholder: "Die grundlegenden Informationen Ihres Unternehmens",
        app_logo_field: "App-Logo",
        app_logo_tip: "Zeigen Sie Ihr Markenlogo oben in E-Mails an. Verwenden Sie dasselbe Bild f\xfcr den hellen und den dunklen Modus.",
        urls_not_allowed: "URLs sind nicht erlaubt",
        test_notes: 'Logto verwendet die "Generic"-Vorlage zum Testen.'
    }
};
var $69df924f5631d054$export$2e2bcd8739ae039 = Object.freeze($69df924f5631d054$var$connector_details);


const $c04087584632d166$var$connectors = {
    page_title: "Connectoren",
    title: "Connectoren",
    subtitle: "Richte Connectoren ein um passwortlose und Social Anmeldung zu aktivieren",
    create: "Social Connector erstellen",
    config_sie_notice: "Sie haben Connectoren eingerichtet. Stellen Sie sicher, dass Sie ihn in <a>{{link}}</a> konfigurieren.",
    config_sie_link_text: "Anmeldeerfahrung",
    tab_email_sms: "E-Mail und SMS Connectoren",
    tab_social: "Social Connectoren",
    connector_name: "Connectorname",
    demo_tip: "Die maximale Anzahl von Nachrichten f\xfcr diesen Demo-Connector ist auf 100 begrenzt und wird nicht f\xfcr den Einsatz in einer Produktionsumgebung empfohlen.",
    social_demo_tip: "Der Demo-Connector ist ausschlie\xdflich f\xfcr Demonstrationszwecke konzipiert und wird nicht f\xfcr den Einsatz in einer Produktionsumgebung empfohlen.",
    connector_type: "Typ",
    connector_status: "Anmeldeoberfl\xe4che",
    connector_status_in_use: "In Benutzung",
    connector_status_not_in_use: "Nicht in Benutzung",
    not_in_use_tip: {
        content: "Nicht in Benutzung bedeutet, dass Ihre Anmeldeerfahrung diese Anmeldeoption nicht verwendet hat. <a>{{link}}</a>, um diese Anmeldeoption hinzuzuf\xfcgen. ",
        go_to_sie: "Zur Anmeldeerfahrung gehen"
    },
    placeholder_title: "Social connector",
    placeholder_description: "Logto hat viele weit verbreitete Social-Sign-In-Connectors bereitgestellt. Inzwischen k\xf6nnen Sie mit Standardprotokollen Ihre eigenen erstellen.",
    save_and_done: "Speichern und fertigstellen",
    type: {
        email: "E-Mail Connector",
        sms: "SMS Connector",
        social: "Social Connector"
    },
    setup_title: {
        email: "E-Mail Connector einrichten",
        sms: "SMS Connector einrichten",
        social: "Social Connector erstellen"
    },
    guide: {
        subtitle: "Eine Schritt-f\xfcr-Schritt-Anleitung zur Konfiguration deines Connectors",
        general_setting: "Allgemeine Einstellungen",
        parameter_configuration: "Parameterkonfiguration",
        test_connection: "Verbindungstest",
        name: "Name f\xfcr Social-Sign-In-Button",
        name_placeholder: "Geben Sie den Namen f\xfcr den Social-Sign-In-Button ein",
        name_tip: 'Der Name des Connector-Buttons wird als "Weiter mit {{name}}" angezeigt. Achten Sie darauf, dass der Name nicht zu lang wird.',
        logo: "Logo-URL f\xfcr Social-Sign-In-Button",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Das Logobild wird auf dem Connector angezeigt. Holen Sie sich einen \xf6ffentlich zug\xe4nglichen Bildlink und f\xfcgen Sie den Link hier ein.",
        logo_dark: "Logo-URL f\xfcr Social-Sign-In-Button (Dark mode)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Legen Sie das Logo Ihres Connectors f\xfcr den Dark-Modus fest, nachdem Sie ihn in der Anmeldeerfahrung der Admin Console aktiviert haben.",
        logo_dark_collapse: "Zusammenklappen",
        logo_dark_show: "Logo-Einstellung f\xfcr Dark-Modus anzeigen",
        target: "Identity Provider Name",
        target_placeholder: "Geben Sie den Connector Identity Provider Namen ein",
        target_tip: 'Der Wert von "IdP-Name" kann eine eindeutige Kennung sein, um Ihre Social-Identit\xe4ten zu unterscheiden.',
        target_tip_standard: 'Der Wert von "IdP-Name" kann eine eindeutige Kennung sein, um Ihre Social-Identit\xe4ten zu unterscheiden. Diese Einstellung kann nach der Erstellung des Connectors nicht mehr ge\xe4ndert werden.',
        target_tooltip: "„Target“ in Logto-Social-Connectors bezieht sich auf die „Quelle“ Ihrer Social-Identit\xe4ten. Im Logto-Design akzeptieren wir nicht dasselbe „Target“ einer bestimmten Plattform, um Konflikte zu vermeiden. Sie sollten sehr vorsichtig sein, bevor Sie einen Connector hinzuf\xfcgen, da Sie seinen Wert NICHT \xe4ndern k\xf6nnen, sobald Sie ihn erstellt haben. <a>Erfahren Sie mehr</a>",
        target_conflict: "Der eingegebene IdP-Name stimmt mit dem vorhandenen <span>Namen</span> \xfcberein. Die Verwendung desselben IdP-Namens kann ein unerwartetes Anmeldeverhalten verursachen, bei dem Benutzer \xfcber zwei verschiedene Connectoren auf dasselbe Konto zugreifen k\xf6nnen.",
        target_conflict_line2: 'Wenn Sie den aktuellen Connector durch denselben Identity Provider ersetzen und fr\xfcheren Benutzern erm\xf6glichen m\xf6chten, sich ohne erneute Registrierung anzumelden, l\xf6schen Sie bitte den <span>Namen</span>-Connector und erstellen Sie einen neuen mit dem gleichen "IdP-Namen".',
        target_conflict_line3: 'Wenn Sie sich mit einem anderen Identity Provider verbinden m\xf6chten, \xe4ndern Sie bitte den "IdP-Name" und fahren Sie fort.',
        config: "Geben Sie Ihre Konfigurations-JSON ein",
        sync_profile: "Profilinformationen synchronisieren",
        sync_profile_only_at_sign_up: "Nur bei der Anmeldung synchronisieren",
        sync_profile_each_sign_in: "Bei jeder Anmeldung immer synchronisieren",
        sync_profile_tip: "Synchronisieren Sie das Grundprofil vom Social-Provider, z. B. die Namen der Benutzer und ihre Avatare.",
        callback_uri: "Callback-URI",
        callback_uri_description: "Auch als Redirect-URI bezeichnet, ist die URI in Logto, zu der Benutzer nach der Social-Autorisierung zur\xfcckgesendet werden. Kopieren und f\xfcgen Sie sie in die Konfigurationsseite des Social Providers ein."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativ"
    },
    add_multi_platform: " unterst\xfctzt mehrere Plattformen, w\xe4hle eine Plattform aus, um fortzufahren",
    drawer_title: "Connector Anleitung",
    drawer_subtitle: "Folge den Anweisungen, um deinen Connector zu integrieren",
    unknown: "Unbekannter Connector",
    standard_connectors: "Standard-Connectoren"
};
var $c04087584632d166$export$2e2bcd8739ae039 = Object.freeze($c04087584632d166$var$connectors);


const $7c18db81143887ee$var$contact = {
    title: "Hilfe erhalten",
    description: "F\xfcr Hilfsanfragen oder Produktfeedback wenden Sie sich bitte \xfcber die folgenden Methoden an uns.",
    discord: {
        title: "Discord community beitreten",
        description: "Mit anderen Entwicklern vernetzen, um L\xf6sungen zu finden",
        button: "Beitreten"
    },
    github: {
        title: "Kommunikation auf GitHub",
        description: "Erstellen Sie ein Problem und reichen Sie es bei GitHub ein",
        button: "\xd6ffnen"
    },
    email: {
        title: "Unterst\xfctzung per E-Mail kontaktieren",
        description: "Senden Sie uns eine E-Mail f\xfcr weitere Informationen und Hilfe",
        button: "Senden"
    },
    reserve: {
        title: "Reservieren Sie Ihre Zeit beim Logto-Team",
        description: "Buchen Sie eine Sitzung f\xfcr einen Live-Chat",
        button: "Buch"
    }
};
var $7c18db81143887ee$export$2e2bcd8739ae039 = Object.freeze($7c18db81143887ee$var$contact);


const $88322544688b1096$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Verschaffe dir einen \xdcberblick \xfcber die Leistung deiner App",
    total_users: "Gesamtzahl der Benutzer",
    total_users_tip: "Gesamtzahl der Benutzer",
    new_users_today: "Neue Benutzer heute",
    new_users_today_tip: "Neue Benutzer, die sich heute in deinen Anwendungen registriert haben",
    new_users_7_days: "Neue Benutzer in den letzten 7 Tagen",
    new_users_7_days_tip: "Neue Benutzer, die sich in den letzten 7 Tagen in deinen Anwendungen registriert haben",
    daily_active_users: "T\xe4glich aktive Benutzer",
    daily_active_users_tip: "Die Anzahl der einzelnen Benutzer, die heute Token in deinen Anwendungen ausgetauscht haben",
    weekly_active_users: "W\xf6chentlich aktive Benutzer",
    weekly_active_users_tip: "Die Anzahl der einzelnen Benutzer, die in den letzten 7 Tagen Token in deinen Anwendungen ausgetauscht haben",
    monthly_active_users: "Monatlich aktive Benutzer",
    monthly_active_users_tip: "Die Anzahl der einzelnen Benutzer, die in den letzten 30 Tagen Token in deinen Anwendungen ausgetauscht haben"
};
var $88322544688b1096$export$2e2bcd8739ae039 = Object.freeze($88322544688b1096$var$dashboard);


const $eaabd3a0aa77f511$var$domain = {
    status: {
        connecting: "Verbindung wird hergestellt",
        in_used: "In Benutzung",
        failed_to_connect: "Verbindung fehlgeschlagen"
    },
    update_endpoint_notice: "Vergessen Sie nicht, die Domain f\xfcr die Social-Connector-Callback-URI und den Logto-Endpunkt in Ihrer Anwendung zu aktualisieren, wenn Sie eine benutzerdefinierte Domain f\xfcr die Funktionen verwenden m\xf6chten. <a>{{link}}</a>",
    error_hint: "Stellen Sie sicher, dass Sie Ihre DNS-Eintr\xe4ge aktualisiert haben. Wir werden alle {{value}} Sekunden weiter \xfcberpr\xfcfen.",
    custom: {
        custom_domain: "Benutzerdefinierte Domain",
        custom_domain_description: "Verbessern Sie Ihre Markenbildung durch die Verwendung einer benutzerdefinierten Domain. Diese Domain wird in Ihrem Anmeldeerlebnis verwendet.",
        custom_domain_field: "Benutzerdefinierte Domain",
        custom_domain_placeholder: "ihre.domain.com",
        add_domain: "Domain hinzuf\xfcgen",
        invalid_domain_format: "Ung\xfcltiges Subdom\xe4nen-Format. Bitte geben Sie eine Subdom\xe4ne mit mindestens drei Teilen ein.",
        verify_domain: "Domain \xfcberpr\xfcfen",
        enable_ssl: "SSL aktivieren",
        checking_dns_tip: "Nachdem Sie die DNS-Eintr\xe4ge konfiguriert haben, wird der Prozess automatisch ausgef\xfchrt und kann bis zu 24 Stunden dauern. Sie k\xf6nnen diese Oberfl\xe4che verlassen w\xe4hrend er l\xe4uft.",
        enable_ssl_tip: "SSL aktivieren wird automatisch ausgef\xfchrt und kann bis zu 24 Stunden dauern. Sie k\xf6nnen diese Oberfl\xe4che verlassen w\xe4hrend er l\xe4uft.",
        generating_dns_records: "DNS-Eintr\xe4ge werden generiert...",
        add_dns_records: "Bitte f\xfcgen Sie diese DNS-Eintr\xe4ge Ihrem DNS-Provider hinzu.",
        dns_table: {
            type_field: "Typ",
            name_field: "Name",
            value_field: "Wert"
        },
        deletion: {
            delete_domain: "Domain l\xf6schen",
            reminder: "Benutzerdefinierte Domain l\xf6schen",
            description: "Sind Sie sicher, dass Sie diese benutzerdefinierte Domain l\xf6schen m\xf6chten?",
            in_used_description: 'Sind Sie sicher, dass Sie diese benutzerdefinierte Domain "<span>{{domain}}</span>" l\xf6schen m\xf6chten?',
            in_used_tip: 'Wenn Sie diese benutzerdefinierte Domain bereits in Ihrem Social-Connector-Provider oder Anwendungs-Endpunkt eingerichtet haben, m\xfcssen Sie die URI zur Logto-Standarddomain "<span>{{domain}}</span>" \xe4ndern. Dies ist notwendig, damit die Social-Sign-In-Schaltfl\xe4che ordnungsgem\xe4\xdf funktioniert.',
            deleted: "Benutzerdefinierte Domain wurde erfolgreich gel\xf6scht!"
        }
    },
    default: {
        default_domain: "Standarddomain",
        default_domain_description: "Logto bietet eine vorkonfigurierte Standarddomain, die ohne zus\xe4tzliche Einrichtung verwendet werden kann. Diese Standarddomain dient als Backup-Option, auch wenn Sie eine benutzerdefinierte Domain aktiviert haben.",
        default_domain_field: "Logto Standard-Domain"
    },
    custom_endpoint_note: 'Sie k\xf6nnen den Domainnamen dieser Endpunkte anpassen, wie Sie m\xf6chten. W\xe4hlen Sie entweder "{{custom}}" oder "{{default}}".',
    custom_social_callback_url_note: 'Sie k\xf6nnen den Domainnamen dieser URI anpassen, um mit dem Endpunkt Ihrer Anwendung \xfcbereinzustimmen. W\xe4hlen Sie entweder "{{custom}}" oder "{{default}}".'
};
var $eaabd3a0aa77f511$export$2e2bcd8739ae039 = Object.freeze($eaabd3a0aa77f511$var$domain);


const $d3111d1c930911c5$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $d3111d1c930911c5$export$2e2bcd8739ae039 = Object.freeze($d3111d1c930911c5$var$enterprise_sso_details);


const $3f9d43973e08cd61$var$enterprise_sso = {
    page_title: "Enterprise SSO",
    title: "Enterprise SSO",
    subtitle: "Verbinden Sie den Unternehmensidentit\xe4tsanbieter und aktivieren Sie das SP-gesteuerte Single Sign-On.",
    create: "Unternehmensconnector hinzuf\xfcgen",
    col_connector_name: "Connector-Name",
    col_type: "Typ",
    col_email_domain: "E-Mail-Domain",
    placeholder_title: "Unternehmensconnector",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Unternehmensconnector hinzuf\xfcgen",
        text_divider: "Oder Sie k\xf6nnen Ihren Connector mit einem Standardprotokoll anpassen.",
        connector_name_field_title: "Connector-Name",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Connector erstellen"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $3f9d43973e08cd61$export$2e2bcd8739ae039 = Object.freeze($3f9d43973e08cd61$var$enterprise_sso);


const $c3564b25ce4806ff$var$errors = {
    something_went_wrong: "Ups, da ist etwas schief gelaufen.",
    page_not_found: "Seite nicht gefunden",
    unknown_server_error: "Unbekannter Serverfehler",
    empty: "Keine Daten verf\xfcgbar",
    missing_total_number: "Total-Number wurde nicht in Response Headern gefunden",
    invalid_uri_format: "Ung\xfcltiges URI-Format",
    invalid_origin_format: "Ung\xfcltiges URI Origin-Format",
    invalid_json_format: "Ung\xfcltiges JSON-Format",
    invalid_error_message_format: "Ung\xfcltiges Fehlermeldung-Format.",
    required_field_missing: "Bitte f\xfclle {{field}} aus",
    required_field_missing_plural: "Mindestens ein {{field}} muss ausgef\xfcllt sein",
    more_details: "Mehr Details",
    username_pattern_error: "Der Benutzername sollte nur Buchstaben, Zahlen oder Unterstriche enthalten und nicht mit einer Zahl beginnen.",
    email_pattern_error: "Die E-Mail-Adresse ist ung\xfcltig.",
    phone_pattern_error: "Die Telefonnummer ist ung\xfcltig.",
    insecure_contexts: "Unsichere Kontexte (nicht-HTTPS) werden nicht unterst\xfctzt.",
    unexpected_error: "Ein unerwarteter Fehler ist aufgetreten",
    not_found: "404 not found",
    create_internal_role_violation: 'Sie erstellen eine neue interne Rolle, die von Logto verboten ist. Versuchen Sie einen anderen Namen, der nicht mit "#internal:" beginnt.',
    should_be_an_integer: "Sollte eine Ganzzahl sein.",
    number_should_be_between_inclusive: "Die Zahl sollte zwischen {{min}} und {{max}} (beide inklusive) liegen."
};
var $c3564b25ce4806ff$export$2e2bcd8739ae039 = Object.freeze($c3564b25ce4806ff$var$errors);


const $3bf70810c44a1cc4$var$general = {
    placeholder: "Platzhalter",
    submit: "Senden",
    skip: "\xdcberspringen",
    next: "Weiter",
    back: "Zur\xfcck",
    retry: "Erneut versuchen",
    done: "Fertig",
    search: "Suche",
    search_placeholder: "Suchen",
    clear_result: "Ergebnisse l\xf6schen",
    save: "Speichern",
    save_changes: "\xc4nderungen speichern",
    saved: "Gespeichert",
    discard: "Verwerfen",
    loading: "Lade...",
    redirecting: "Weiterleiten...",
    add: "Hinzuf\xfcgen",
    added: "Hinzugef\xfcgt",
    cancel: "Abbrechen",
    confirm: "Best\xe4tigen",
    check_out: "Ansehen",
    create: "Erstellen",
    set_up: "Einrichten",
    customize: "Anpassen",
    enable: "Aktivieren",
    reminder: "Erinnerung",
    delete: "L\xf6schen",
    more_options: "MEHR OPTIONEN",
    close: "Schlie\xdfen",
    copy: "Kopieren",
    copying: "Kopiere",
    copied: "Kopiert",
    required: "Erforderlich",
    add_another: "Weitere hinzuf\xfcgen",
    create_another: "Erstellen Sie ein anderes",
    deletion_confirmation: "Willst du {{title}} wirklich l\xf6schen?",
    settings_nav: "Einstellungen",
    unsaved_changes_warning: "Du hast ungespeicherte \xc4nderungen. Willst du diese Seite wirklich verlassen?",
    leave_page: "Seite verlassen",
    stay_on_page: "Auf Seite bleiben",
    type_to_search: "Tippe um zu suchen",
    got_it: "Alles klar",
    continue: "Fortsetzen",
    page_info: "{{min, number}}-{{max, number}} von {{total, number}}",
    learn_more: "Mehr erfahren",
    tab_errors: "{{count, number}} Fehler",
    skip_for_now: "Jetzt \xfcberspringen",
    remove: "Entfernen",
    visit: "Besuchen",
    join: "Beitreten",
    try_now: "Jetzt ausprobieren",
    multiple_form_field: "(Mehrere)",
    demo: "Demo",
    unnamed: "Unbenannt",
    view: "Anzeigen",
    hide: "Verbergen",
    unknown_error: "Unbekannter Fehler, bitte versuchen Sie es sp\xe4ter erneut.",
    select: "Ausw\xe4hlen",
    contact_us_action: "Kontaktiere uns",
    description: "Beschreibung",
    name: "Name",
    add_field: "F\xfcge {{field}} hinzu",
    create_field: "Erstelle {{field}}",
    edit_field: "Bearbeite {{field}}",
    delete_field: "L\xf6sche {{field}}",
    coming_soon: "Demn\xe4chst verf\xfcgbar",
    beta_notice: "\uD83C\uDF89  {{feature}} befindet sich derzeit in der Beta-Phase. Willkommen, es zu erkunden und <ContactLink>Geben Sie Ihr Feedback</ContactLink>."
};
var $3bf70810c44a1cc4$export$2e2bcd8739ae039 = Object.freeze($3bf70810c44a1cc4$var$general);


const $c169e04f579e7127$var$get_started = {
    page_title: "Loslegen",
    title: "Etwas zum Erkunden, um dir zu helfen, erfolgreich zu sein",
    subtitle: "Einige Dinge, die Sie tun k\xf6nnen, um schnell den Wert von Logto zu erhalten",
    develop: {
        title: "Entwicklung: Nehmen Sie sich 5 Minuten Zeit, um Ihre App zu integrieren"
    },
    customize: {
        title: "Anpassen: Liefern Sie ein gro\xdfartiges Anmeldeerlebnis",
        preview: {
            title: "\xdcberpr\xfcfen Sie die Live-Vorschau des gerade angepassten Anmeldeerlebnisses",
            subtitle: "Testen Sie jetzt das Logto-Anmeldeerlebnis, um zu sehen, wie es funktioniert"
        },
        connector: {
            title: "F\xfcgen Sie weitere Connectors hinzu, um weitere soziale Anmeldeverfahren zu unterst\xfctzen",
            subtitle: "Probieren Sie die passwortlose Anmeldung aus und erm\xf6glichen Sie Ihren Kunden ein sicheres und reibungsloses Erlebnis"
        },
        continue_customizing: "Mit der Anpassung fortfahren",
        try_now: "Jetzt ausprobieren",
        add_more: "Mehr hinzuf\xfcgen"
    },
    secure: {
        title: "Sichern: Sch\xfctzen Sie Ihre Ressourcen"
    },
    manage: {
        title: "Verwalten: Definieren Sie Zugriffssteuerung f\xfcr Ihr Produkt und Ihre Benutzer",
        rbac: {
            title: "F\xfcgen Sie rollenbasierte Zugriffssteuerung hinzu, um Ihre Ressourcen zu sch\xfctzen",
            subtitle: "Steuern Sie Ihre Ressource durch skalierbare Rollenautorisierung f\xfcr verschiedene Anwendungsf\xe4lle."
        },
        create_roles: "Rollen erstellen"
    },
    view_all: "Alle anzeigen →"
};
var $c169e04f579e7127$export$2e2bcd8739ae039 = Object.freeze($c169e04f579e7127$var$get_started);


const $e1ca4323abae6523$var$guide = {
    start_building: "Start building",
    get_started: "Beginnen Sie",
    categories: {
        featured: "Beliebt und f\xfcr dich",
        Traditional: "Traditionelle Webanwendung",
        SPA: "Single-Page-Anwendung",
        Native: "Native",
        MachineToMachine: "Maschinen-zu-Maschinen"
    },
    filter: {
        title: "Filter framework",
        placeholder: "Nach Framework suchen"
    },
    checkout_tutorial: "Tutorial von {{name}} anzeigen",
    do_not_need_tutorial: "Wenn Sie kein Tutorial ben\xf6tigen, k\xf6nnen Sie ohne Anleitung fortfahren",
    finish_and_done: "Fertig und erledigt",
    cannot_find_guide: "Guide nicht gefunden?",
    describe_guide_looking_for: "Beschreiben Sie den Guide, den Sie suchen",
    request_guide_successfully: "Ihre Anfrage wurde erfolgreich \xfcbermittelt. Danke!",
    app: {
        select_framework_or_tutorial: "W\xe4hlen Sie ein Framework oder Tutorial aus",
        guide_modal_title: "Starten Sie mit dem SDK und den Guides",
        modal_subtitle: "Beschleunigen Sie Ihre App-Entwicklung mit unserem vorgefertigten SDK und Tutorials.",
        select_a_framework: "W\xe4hlen Sie ein Framework aus",
        continue_without_framework: "App ohne Framework erstellen",
        describe_guide_looking_for_placeholder: "Zum Beispiel: Ich m\xf6chte Logto in meine Angular-App integrieren."
    },
    api: {
        modal_title: "Starten Sie mit Tutorials",
        modal_subtitle: "Beschleunigen Sie Ihre App-Entwicklung mit unseren vorgefertigten Tutorials.",
        select_a_tutorial: "W\xe4hlen Sie ein Tutorial aus",
        continue_without_tutorial: "Ohne Tutorial fortfahren",
        describe_guide_looking_for_placeholder: "Zum Beispiel: Ich m\xf6chte meine API mit Deno sch\xfctzen."
    }
};
var $e1ca4323abae6523$export$2e2bcd8739ae039 = Object.freeze($e1ca4323abae6523$var$guide);


const $893d4c1a9e87d2a3$var$log_details = {
    page_title: "Audit Log Details",
    back_to_logs: "Zur\xfcck zu audit logs",
    back_to: "Zur\xfcck zu {{name}}",
    success: "Erfolgreich",
    failed: "Fehlgeschlagen",
    event_key: "Event Schl\xfcssel",
    application: "Anwendung",
    ip_address: "IP-Adresse",
    user: "Benutzer",
    log_id: "Log-ID",
    time: "Zeit",
    user_agent: "User-Agent",
    tab_details: "Details",
    raw_data: "Rohe Daten"
};
var $893d4c1a9e87d2a3$export$2e2bcd8739ae039 = Object.freeze($893d4c1a9e87d2a3$var$log_details);


const $0bddba092f2bbf5a$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "Anzeige der Log Daten von Authentifizierungsereignissen, die von Admins und Benutzern stammen",
    event: "Event",
    user: "Benutzer",
    application: "Anwendung",
    time: "Zeit",
    filter_by: "Filter nach"
};
var $0bddba092f2bbf5a$export$2e2bcd8739ae039 = Object.freeze($0bddba092f2bbf5a$var$logs);


const $33503b720c773151$var$menu = {
    profile: "Profil",
    language: "Sprache",
    appearance: {
        label: "Darstellung",
        light: "Hell",
        dark: "Dunkel",
        system: "Synchonisiere mit Systemeinstellungen"
    },
    sign_out: "Abmelden"
};
var $33503b720c773151$export$2e2bcd8739ae039 = Object.freeze($33503b720c773151$var$menu);


const $f756a901d79eaa7a$var$mfa = {
    title: "Zwei-Faktor-Authentifizierung",
    description: "F\xfcgen Sie der Sicherheit Ihrer Anmeldeerfahrung die Zwei-Faktor-Authentifizierung hinzu.",
    factors: "Faktoren",
    multi_factors: "Multi-Faktoren",
    multi_factors_description: "Benutzer m\xfcssen einen der aktivierten Faktoren f\xfcr die Zwei-Schritt-Verifizierung \xfcberpr\xfcfen.",
    totp: "Authenticator-App OTP",
    otp_description: "Verkn\xfcpfen Sie Google Authenticator usw., um Einmalpassw\xf6rter zu \xfcberpr\xfcfen.",
    webauthn: "WebAuthn (Passwort)",
    webauthn_description: "\xdcberpr\xfcfen Sie \xfcber browserunterst\xfctzte Methoden: Biometrie, Handy-Scan oder Sicherheitsschl\xfcssel usw.",
    webauthn_native_tip: "WebAuthn wird f\xfcr native Anwendungen nicht unterst\xfctzt.",
    webauthn_domain_tip: "WebAuthn bindet \xf6ffentliche Schl\xfcssel an die spezifische Domain. Das \xc4ndern Ihrer Servicedomain blockiert Benutzer daran, sich \xfcber vorhandene Passw\xf6rter zu authentifizieren.",
    backup_code: "Backup-Code",
    backup_code_description: "Generieren Sie nach Einrichtung einer beliebigen MFA-Methode 10 einmalige Backup-Codes.",
    backup_code_setup_hint: "Wenn Benutzer die obigen MFA-Faktoren nicht \xfcberpr\xfcfen k\xf6nnen, verwenden Sie die Backup-Option.",
    backup_code_error_hint: "Um einen Backup-Code zu verwenden, ben\xf6tigen Sie mindestens eine weitere MFA-Methode f\xfcr eine erfolgreiche Benutzerauthentifizierung.",
    policy: "Richtlinie",
    policy_description: "Legen Sie die MFA-Richtlinie f\xfcr Anmelde- und Anmeldevorg\xe4nge fest.",
    two_step_sign_in_policy: "Zwei-Schritt-Verifizierungspolitik bei der Anmeldung",
    user_controlled: "Benutzer k\xf6nnen MFA selbst aktivieren oder deaktivieren",
    user_controlled_tip: "Benutzer k\xf6nnen die MFA-Einrichtung beim ersten Mal bei der Anmeldung oder Anmeldung \xfcberspringen oder sie in den Kontoeinstellungen aktivieren/deaktivieren.",
    mandatory: "Benutzer m\xfcssen immer MFA bei der Anmeldung verwenden",
    mandatory_tip: "Benutzer m\xfcssen MFA beim ersten Mal bei der Anmeldung oder Anmeldung einrichten und es f\xfcr alle zuk\xfcnftigen Anmeldungen verwenden."
};
var $f756a901d79eaa7a$export$2e2bcd8739ae039 = Object.freeze($f756a901d79eaa7a$var$mfa);


const $ea30cc6fdbc57a68$var$organization_details = {
    page_title: "Organisationsdetails",
    delete_confirmation: "Wenn gel\xf6scht, verlieren alle Mitglieder ihre Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
    organization_id: "Organisations-ID",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Der Name der Organisation, muss nicht eindeutig sein.",
    description_placeholder: "Eine Beschreibung der Organisation.",
    member: "Mitglied",
    member_other: "Mitglieder",
    add_members_to_organization: "Mitglieder zur Organisation {{name}} hinzuf\xfcgen",
    add_members_to_organization_description: "Suchen Sie nach geeigneten Benutzern, indem Sie nach Name, E-Mail, Telefon oder Benutzer-ID suchen. In den Suchergebnissen werden keine bereits vorhandenen Mitglieder angezeigt.",
    add_with_organization_role: "Mit Organisation Rollen hinzuf\xfcgen",
    user: "Benutzer",
    authorize_to_roles: "Berechtige {{name}} auf die folgenden Rollen zuzugreifen:",
    edit_organization_roles: "Organisationsrollen bearbeiten",
    edit_organization_roles_of_user: "Organisationsrollen von {{name}} bearbeiten",
    remove_user_from_organization: "Benutzer von der Organisation entfernen",
    remove_user_from_organization_description: "Wenn entfernt, verliert der Benutzer seine Mitgliedschaft und Rollen in dieser Organisation. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
    search_user_placeholder: "Nach Name, E-Mail, Telefon oder Benutzer-ID suchen",
    at_least_one_user: "Mindestens ein Benutzer ist erforderlich."
};
var $ea30cc6fdbc57a68$export$2e2bcd8739ae039 = Object.freeze($ea30cc6fdbc57a68$var$organization_details);


const $6f83374c4b0d2a6c$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organisationen",
    title: "Organisationen",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "Organisations-ID",
    members: "Mitglieder",
    create_organization: "Organisation erstellen",
    setup_organization: "Richten Sie Ihre Organisation ein",
    organization_list_placeholder_title: "Organisation",
    organization_list_placeholder_text: 'Organisation wird normalerweise in SaaS- oder SaaS-\xe4hnlichen Multi-Tenancy-Anwendungen verwendet. Die Funktion "Organisationen" erm\xf6glicht es Ihren B2B-Kunden, ihre Partner und Kunden besser zu verwalten und die Art und Weise anzupassen, wie Endbenutzer auf ihre Anwendungen zugreifen.',
    organization_name_placeholder: "Meine Organisation",
    organization_description_placeholder: "Eine kurze Beschreibung der Organisation",
    organization_permission: "Organisationsberechtigung",
    organization_permission_other: "Organisationsberechtigungen",
    organization_permission_description: "Eine Organisationsberechtigung bezieht sich auf die Autorisierung zum Zugriff auf eine Ressource im Kontext der Organisation. Eine Organisationsberechtigung sollte als aussagekr\xe4ftiger String repr\xe4sentiert werden, der auch als Name und eindeutiger Bezeichner dient.",
    organization_permission_delete_confirm: "Wenn diese Berechtigung gel\xf6scht wird, verlieren alle Organisationsrollen, einschlie\xdflich dieser Berechtigung, diese Berechtigung. Benutzer, die diese Berechtigung hatten, verlieren den Zugriff, der durch sie gew\xe4hrt wurde.",
    create_permission_placeholder: "Terminkalenderverlauf lesen",
    permission: "Berechtigung",
    permission_other: "Berechtigungen",
    organization_role: "Organisationsrolle",
    organization_role_other: "Organisationsrollen",
    organization_role_description: "Eine Organisationsrolle ist eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Die Berechtigungen m\xfcssen aus den vordefinierten Organisationsberechtigungen stammen.",
    organization_role_delete_confirm: "Dadurch werden die mit dieser Rolle verbundenen Berechtigungen von den betroffenen Benutzern entfernt und die Beziehungen zwischen Organisationsrollen, Mitgliedern in der Organisation und Organisationsberechtigungen gel\xf6scht.",
    role: "Rolle",
    create_role_placeholder: "Benutzer mit nur Lesezugriff",
    search_placeholder: "Nach Organisation suchen",
    search_permission_placeholder: "Geben Sie zum Suchen und Ausw\xe4hlen von Berechtigungen ein",
    search_role_placeholder: "Geben Sie zum Suchen und Ausw\xe4hlen von Rollen ein",
    empty_placeholder: "\uD83E\uDD14 Sie haben noch keine {{entity}} eingerichtet.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Starten Sie mit Anleitungen",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interagieren Sie mit der Abbildung, um zu sehen, wie alles zusammenh\xe4ngt",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Schritt 1: Organisationsberechtigungen definieren",
        step_2: "Schritt 2: Organisationsrollen definieren",
        step_3: "Schritt 3: Erstellen Sie Ihre erste Organisation",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        more_next_steps: "Weitere Schritte",
        add_members: "F\xfcgen Sie Mitglieder zu Ihrer Organisation hinzu",
        add_members_action: "Massenhafte Mitglieder hinzuf\xfcgen und Rollen zuweisen",
        organization_permissions: "Organisationsberechtigungen",
        permission_name: "Berechtigungsname",
        permissions: "Berechtigungen",
        organization_roles: "Organisationsrollen",
        role_name: "Rollenname",
        organization_name: "Organisationsname",
        admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $6f83374c4b0d2a6c$export$2e2bcd8739ae039 = Object.freeze($6f83374c4b0d2a6c$var$organizations);


const $4463d1b252d66cb8$var$permissions = {
    search_placeholder: "Nach API oder Berechtigungsname suchen",
    search_placeholder_without_api: "Nach Berechtigungsname suchen",
    name_column: "Berechtigung",
    description_column: "Beschreibung",
    api_column: "API",
    placeholder_title: "Berechtigung",
    placeholder_description: "Berechtigung bezieht sich auf die Autorisierung zum Zugriff auf eine Ressource (wir nennen sie API-Ressource)."
};
var $4463d1b252d66cb8$export$2e2bcd8739ae039 = Object.freeze($4463d1b252d66cb8$var$permissions);


const $d3816325bb4734f6$var$profile = {
    page_title: "Account-Einstellungen",
    title: "Account-Einstellungen",
    description: "\xc4ndern Sie hier Ihre Kontoeinstellungen und verwalten Sie Ihre pers\xf6nlichen Informationen, um die Sicherheit Ihres Kontos zu gew\xe4hrleisten.",
    settings: {
        title: "PROFIL-EINSTELLUNGEN",
        profile_information: "Profil-Informationen",
        avatar: "Avatar",
        name: "Name",
        username: "Benutzername"
    },
    link_account: {
        title: "KONTO VERKN\xdcPFEN",
        email_sign_in: "E-Mail-Anmeldung",
        email: "Email",
        social_sign_in: "Social-Log-in",
        link_email: "E-Mail verkn\xfcpfen",
        link_email_subtitle: "Verkn\xfcpfen Sie Ihre E-Mail-Adresse, um sich anzumelden oder bei der Wiederherstellung Ihres Kontos zu helfen.",
        email_required: "Email ist erforderlich",
        invalid_email: "Ung\xfcltige E-Mail-Adresse",
        identical_email_address: "Die eingegebene E-Mail-Adresse ist identisch mit der aktuellen.",
        anonymous: "Anonym"
    },
    password: {
        title: "PASSWORT & SICHERHEIT",
        password: "Passwort",
        password_setting: "Passworteinstellungen",
        new_password: "Neues Passwort",
        confirm_password: "Passwort best\xe4tigen",
        enter_password: "Geben Sie das aktuelle Passwort ein",
        enter_password_subtitle: "\xdcberpr\xfcfen Sie, dass es sich um Sie handelt, um die Sicherheit Ihres Kontos zu sch\xfctzen. Bitte geben Sie Ihr aktuelles Passwort ein, bevor Sie es \xe4ndern.",
        set_password: "Passwort festlegen",
        verify_via_password: "\xdcberpr\xfcfen per Passwort",
        show_password: "Passwort zeigen",
        required: "Passwort ist erforderlich",
        do_not_match: "Die Passw\xf6rter stimmen nicht \xfcberein. Bitte versuchen Sie es erneut."
    },
    code: {
        enter_verification_code: "Best\xe4tigungscode eingeben",
        enter_verification_code_subtitle: "Der Best\xe4tigungscode wurde an <strong>{{target}}</strong> gesendet",
        verify_via_code: "\xdcberpr\xfcfen per Best\xe4tigungscode",
        resend: "Best\xe4tigungscode erneut senden",
        resend_countdown: "Erneut senden in {{countdown}} Sekunden"
    },
    delete_account: {
        title: "KONTO L\xd6SCHEN",
        label: "Konto l\xf6schen",
        description: "Wenn Sie Ihr Konto l\xf6schen, werden alle Ihre pers\xf6nlichen Informationen, Benutzerdaten und Konfigurationen entfernt. Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden.",
        button: "Konto l\xf6schen",
        dialog_paragraph_1: "Wir bedauern, dass Sie Ihr Konto l\xf6schen m\xf6chten. Das L\xf6schen Ihres Kontos entfernt dauerhaft alle Daten, einschlie\xdflich Benutzerinformationen, Protokolle und Einstellungen, und diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Stellen Sie also sicher, dass Sie wichtige Daten sichern, bevor Sie fortfahren.",
        dialog_paragraph_2: 'Um mit dem Konto-L\xf6schvorgang fortzufahren, senden Sie bitte eine E-Mail an unser Support-Team unter <a>mail</a> mit dem Betreff "Anforderung zur Kontol\xf6schung". Wir werden Ihnen helfen und sicherstellen, dass all Ihre Daten ordnungsgem\xe4\xdf aus unserem System gel\xf6scht werden.',
        dialog_paragraph_3: "Vielen Dank, dass Sie sich f\xfcr Logto Cloud entschieden haben. Wenn Sie weitere Fragen oder Bedenken haben, z\xf6gern Sie bitte nicht, uns zu kontaktieren."
    },
    set: "Festlegen",
    change: "\xc4ndern",
    link: "Verkn\xfcpfen",
    unlink: "Verkn\xfcpfung aufheben",
    not_set: "Nicht festgelegt",
    change_avatar: "Avatar \xe4ndern",
    change_name: "Name \xe4ndern",
    change_username: "Benutzernamen \xe4ndern",
    set_name: "Name festlegen",
    email_changed: "E-Mail ge\xe4ndert.",
    password_changed: "Passwort ge\xe4ndert.",
    updated: "{{target}} aktualisiert.",
    linked: "{{target}} verkn\xfcpft.",
    unlinked: "{{target}} Verkn\xfcpfung aufgehoben.",
    email_exists_reminder: "Diese E-Mail {{email}} ist mit einem bestehenden Konto verkn\xfcpft. Verkn\xfcpfen Sie hier eine andere E-Mail-Adresse.",
    unlink_confirm_text: "Ja, Verkn\xfcpfung aufheben",
    unlink_reminder: "Benutzer k\xf6nnen sich nicht mehr mit dem <span></span>-Konto anmelden, wenn Sie es trennen. M\xf6chten Sie fortfahren?"
};
var $d3816325bb4734f6$export$2e2bcd8739ae039 = Object.freeze($d3816325bb4734f6$var$profile);


const $37b338a90d6e4ad6$var$role_details = {
    back_to_roles: "Zur\xfcck zu Rollen",
    identifier: "Identifikator",
    delete_description: "Dadurch werden die mit dieser Rolle verbundenen Berechtigungen von den betroffenen Benutzern entfernt und die Zuordnung zwischen Rollen, Benutzern und Berechtigungen gel\xf6scht.",
    role_deleted: "{{name}} wurde erfolgreich gel\xf6scht.",
    settings_tab: "Einstellungen",
    users_tab: "Benutzer",
    m2m_apps_tab: "Maschinen-zu-Maschinen-Apps",
    permissions_tab: "Berechtigungen",
    settings: "Einstellungen",
    settings_description: "Rollen sind eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Sie erm\xf6glichen auch eine Zusammenfassung von Berechtigungen, die f\xfcr verschiedene APIs definiert wurden, was es effizienter macht, Berechtigungen im Vergleich zur individuellen Zuweisung an Benutzer hinzuzuf\xfcgen, zu entfernen oder zu \xe4ndern.",
    field_name: "Name",
    field_description: "Beschreibung",
    type_m2m_role_tag: "Maschinen-zu-Maschinen-App-Rolle",
    type_user_role_tag: "Benutzerrolle",
    permission: {
        assign_button: "Berechtigungen zuweisen",
        assign_title: "Berechtigungen zuweisen",
        assign_subtitle: "Weisen Sie dieser Rolle Berechtigungen zu. Die Rolle erh\xe4lt die hinzugef\xfcgten Berechtigungen, und Benutzer mit dieser Rolle erben diese Berechtigungen.",
        assign_form_field: "Berechtigungen zuweisen",
        added_text_one: "{{count, number}} Berechtigung hinzugef\xfcgt",
        added_text_other: "{{count, number}} Berechtigungen hinzugef\xfcgt",
        api_permission_count_one: "{{count, number}} Berechtigung",
        api_permission_count_other: "{{count, number}} Berechtigungen",
        confirm_assign: "Berechtigungen zuweisen",
        permission_assigned: "Die ausgew\xe4hlten Berechtigungen wurden dieser Rolle erfolgreich zugewiesen",
        deletion_description: "Wenn diese Berechtigung entfernt wird, verliert der betroffene Benutzer mit dieser Rolle den Zugriff, der durch diese Berechtigung gew\xe4hrt wurde.",
        permission_deleted: 'Die Berechtigung "{{name}}" wurde erfolgreich von dieser Rolle entfernt',
        empty: "Keine Berechtigung verf\xfcgbar"
    },
    users: {
        assign_button: "Benutzer zuweisen",
        name_column: "Benutzer",
        app_column: "App",
        latest_sign_in_column: "Letzte Anmeldung",
        delete_description: "Es bleibt in Ihrer Benutzergruppe, aber verliert die Autorisierung f\xfcr diese Rolle.",
        deleted: "{{name}} wurde erfolgreich von dieser Rolle entfernt",
        assign_title: "Benutzer zuweisen",
        assign_subtitle: "Weisen Sie Benutzer dieser Rolle zu. Finden Sie geeignete Benutzer, indem Sie nach Name, E-Mail, Telefon oder Benutzer-ID suchen.",
        assign_field: "Benutzer zuweisen",
        confirm_assign: "Benutzer zuweisen",
        assigned_toast_text: "Die ausgew\xe4hlten Benutzer wurden erfolgreich dieser Rolle zugewiesen",
        empty: "Kein Benutzer verf\xfcgbar"
    },
    applications: {
        assign_button: "Apps zuweisen",
        name_column: "Anwendung",
        app_column: "Apps",
        description_column: "Beschreibung",
        delete_description: "Es bleibt in Ihrem Anwendungspool, verliert jedoch die Autorisierung f\xfcr diese Rolle.",
        deleted: "{{name}} wurde erfolgreich aus dieser Rolle entfernt",
        assign_title: "Apps zuweisen",
        assign_subtitle: "Weisen Sie dieser Rolle Anwendungen zu. Finden Sie geeignete Anwendungen, indem Sie nach Name, Beschreibung oder App-ID suchen.",
        assign_field: "Apps zuweisen",
        confirm_assign: "Apps zuweisen",
        assigned_toast_text: "Die ausgew\xe4hlten Anwendungen wurden erfolgreich dieser Rolle zugewiesen",
        empty: "Keine Anwendung verf\xfcgbar"
    }
};
var $37b338a90d6e4ad6$export$2e2bcd8739ae039 = Object.freeze($37b338a90d6e4ad6$var$role_details);


const $ca63b7c8f6acaf76$var$roles = {
    page_title: "Rollen",
    title: "Rollen",
    subtitle: "Rollen beinhalten Berechtigungen, die bestimmen, was ein Benutzer tun kann. RBAC verwendet Rollen, um Benutzern Zugriff auf Ressourcen f\xfcr bestimmte Aktionen zu geben.",
    create: "Rolle erstellen",
    role_name: "Rollenname",
    role_type: "Rollenart",
    show_role_type_button_text: "Weitere Optionen anzeigen",
    hide_role_type_button_text: "Weitere Optionen ausblenden",
    type_user: "Benutzerrolle",
    type_machine_to_machine: "Maschinen-zu-Maschinen-App-Rolle",
    role_description: "Beschreibung",
    role_name_placeholder: "Geben Sie Ihren Rollennamen ein",
    role_description_placeholder: "Geben Sie Ihre Rollenbeschreibung ein",
    col_roles: "Rollen",
    col_type: "Art",
    col_description: "Beschreibung",
    col_assigned_entities: "Zugewiesen",
    user_counts: "{{count}} Benutzer",
    application_counts: "{{count}} Apps",
    user_count: "{{count}} Benutzer",
    application_count: "{{count}} App",
    assign_permissions: "Berechtigungen zuweisen",
    create_role_title: "Rolle erstellen",
    create_role_description: "Erstellen und verwalten Sie Rollen f\xfcr Ihre Anwendungen. Rollen enthalten Sammlungen von Berechtigungen und k\xf6nnen Benutzern zugewiesen werden.",
    create_role_button: "Rolle erstellen",
    role_created: "Die Rolle {{name}} wurde erfolgreich erstellt.",
    search: "Nach Rollennamen, Beschreibung oder ID suchen",
    placeholder_title: "Rollen",
    placeholder_description: "Rollen sind eine Gruppierung von Berechtigungen, die Benutzern zugewiesen werden k\xf6nnen. Stellen Sie sicher, dass Sie zuerst Berechtigungen hinzuf\xfcgen, bevor Sie Rollen erstellen."
};
var $ca63b7c8f6acaf76$export$2e2bcd8739ae039 = Object.freeze($ca63b7c8f6acaf76$var$roles);


const $8a1622ae65aa6e89$var$session_expired = {
    title: "Sitzung abgelaufen",
    subtitle: "Deine Sitzung ist m\xf6glicherweise abgelaufen und deine Verbindung wurde unterbrochen. Klicke auf die Schaltfl\xe4che unten, um dich erneut an der Admin Konsole anzumelden.",
    button: "Erneut anmelden"
};
var $8a1622ae65aa6e89$export$2e2bcd8739ae039 = Object.freeze($8a1622ae65aa6e89$var$session_expired);


const $9e689688488fc4c5$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $9e689688488fc4c5$export$2e2bcd8739ae039 = Object.freeze($9e689688488fc4c5$var$content);


const $fb71e6e78b954b7f$var$password_policy = {
    password_requirements: "Passwortanforderungen",
    minimum_length: "Mindestl\xe4nge",
    minimum_length_description: "NIST schl\xe4gt vor, <a>mindestens 8 Zeichen</a> f\xfcr Webprodukte zu verwenden.",
    minimum_length_error: "Die Mindestl\xe4nge muss zwischen {{min}} und {{max}} (einschlie\xdflich) sein.",
    minimum_required_char_types: "Mindestanzahl erforderlicher Zeichentypen",
    minimum_required_char_types_description: "Zeichentypen: Gro\xdfbuchstaben (A-Z), Kleinbuchstaben (a-z), Zahlen (0-9) und Sonderzeichen ({{symbols}}).",
    password_rejection: "Passwortablehnung",
    compromised_passwords: "Abgelehnte Passw\xf6rter",
    breached_passwords: "Verletzte Passw\xf6rter",
    breached_passwords_description: "Ablehnung von zuvor in den Verletzungsdatenbanken gefundenen Passw\xf6rtern.",
    restricted_phrases: "Einschr\xe4nkung niedrigsicherer Phrasen",
    restricted_phrases_tooltip: "Ihr Passwort sollte diese Phrasen vermeiden, es sei denn, Sie kombinieren sie mit 3 oder mehr zus\xe4tzlichen Zeichen.",
    repetitive_or_sequential_characters: "Wiederholte oder aufeinanderfolgende Zeichen",
    repetitive_or_sequential_characters_description: 'Zum Beispiel "AAAA", "1234" und "abcd".',
    user_information: "Benutzerinformationen",
    user_information_description: "Zum Beispiel E-Mail-Adresse, Telefonnummer, Benutzername, etc.",
    custom_words: "Benutzerdefinierte W\xf6rter",
    custom_words_description: "Personalisierte kontextspezifische W\xf6rter, Gro\xdf-/Kleinschreibung wird nicht beachtet, ein Wort pro Zeile.",
    custom_words_placeholder: "Name Ihres Dienstes, Firmenname, etc."
};
var $fb71e6e78b954b7f$export$2e2bcd8739ae039 = Object.freeze($fb71e6e78b954b7f$var$password_policy);


const $7a8ca54843ac19e1$var$sign_up_and_sign_in = {
    identifiers_email: "E-Mail Adresse",
    identifiers_phone: "Telefonnummer",
    identifiers_username: "Benutzername",
    identifiers_email_or_sms: "E-Mail Adresse oder Telefonnummer",
    identifiers_none: "Nicht zutreffend",
    and: "und",
    or: "oder",
    sign_up: {
        title: "ANMELDEN",
        sign_up_identifier: "Anmeldeidentifier",
        identifier_description: "Der Anmeldeidentifier ist erforderlich f\xfcr die Kontoerstellung und muss in Ihrem Anmeldefenster enthalten sein.",
        sign_up_authentication: "Authentifizierungseinstellung f\xfcr die Anmeldung",
        authentication_description: "Alle ausgew\xe4hlten Aktionen sind f\xfcr Benutzer verpflichtend, um den Vorgang abzuschlie\xdfen.",
        set_a_password_option: "Erstellen Sie Ihr Passwort",
        verify_at_sign_up_option: "Bei Anmeldung \xfcberpr\xfcfen",
        social_only_creation_description: "(Dies gilt nur f\xfcr die Erstellung von Social-Accounts)"
    },
    sign_in: {
        title: "ANMELDEN",
        sign_in_identifier_and_auth: "Anmeldeidentifier und Authentifizierungseinstellungen",
        description: "Benutzer k\xf6nnen sich \xfcber jede der verf\xfcgbaren Optionen anmelden. Passen Sie das Layout an, indem Sie die folgenden Optionen per Drag & Drop anordnen.",
        add_sign_in_method: "Anmeldemethode hinzuf\xfcgen",
        password_auth: "Passwort",
        verification_code_auth: "Verifizierungscode",
        auth_swap_tip: "Tauschen Sie die untenstehenden Optionen aus, um zu bestimmen, welche zuerst im Vorgang angezeigt wird.",
        require_auth_factor: "Sie m\xfcssen mindestens einen Authentifizierungsfaktor ausw\xe4hlen."
    },
    social_sign_in: {
        title: "ANMELDEN MIT SOCIAL MEDIA",
        social_sign_in: "Anmelden mit Social Media",
        description: "Abh\xe4ngig von der obligatorischen Identifizierung, die Sie eingerichtet haben, wird Ihr Benutzer m\xf6glicherweise aufgefordert, bei der Anmeldung \xfcber den Social Connector eine Identifizierung bereitzustellen.",
        add_social_connector: "Sozialen Connector hinzuf\xfcgen",
        set_up_hint: {
            not_in_list: "Nicht in der Liste?",
            set_up_more: "Einrichten",
            go_to: "andere Social Connectors jetzt."
        }
    },
    tip: {
        set_a_password: "Ein einmaliges Passwort f\xfcr Ihren Benutzernamen ist ein Muss.",
        verify_at_sign_up: "Wir unterst\xfctzen derzeit nur \xfcberpr\xfcfte E-Mails. Ihre Benutzerbasis kann eine gro\xdfe Anzahl von E-Mail-Adressen von schlechter Qualit\xe4t enthalten, wenn keine Validierung vorliegt.",
        password_auth: "Dies ist unerl\xe4sslich, da Sie die Option zum Setzen eines Passworts w\xe4hrend des Anmeldeprozesses aktiviert haben.",
        verification_code_auth: "Dies ist unerl\xe4sslich, da Sie nur die M\xf6glichkeit aktiviert haben, einen Verifizierungscode bei der Anmeldung bereitzustellen. Sie k\xf6nnen das Kontrollk\xe4stchen deaktivieren, wenn die Passworteinrichtung im Anmeldeprozess erlaubt ist.",
        delete_sign_in_method: "Dies ist unerl\xe4sslich, da Sie {{identifier}} als obligatorischen Identifier ausgew\xe4hlt haben."
    },
    advanced_options: {
        title: "ERWEITERTE OPTIONEN",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Benutzerregistrierung aktivieren",
        enable_user_registration_description: "Aktivieren oder deaktivieren Sie die Benutzerregistrierung. Sobald deaktiviert, k\xf6nnen Benutzer immer noch \xfcber die Admin-Konsole hinzugef\xfcgt werden, aber Benutzer k\xf6nnen keine Konten mehr \xfcber die Anmelde-Benutzeroberfl\xe4che einrichten."
    }
};
var $7a8ca54843ac19e1$export$2e2bcd8739ae039 = Object.freeze($7a8ca54843ac19e1$var$sign_up_and_sign_in);


const $5bca57cf73facfdd$var$sign_in_exp = {
    page_title: "Anmeldeoberfl\xe4che",
    title: "Anmeldeoberfl\xe4che",
    description: "Passe die Benutzeroberfl\xe4che f\xfcr die Anmeldung an deine Marke an und zeige eine Vorschau in Echtzeit an",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Anmeldung und Registrierung",
        content: "Inhalt",
        password_policy: "Passwortrichtlinie"
    },
    welcome: {
        title: "Anmeldungs-Erlebnis anpassen",
        description: "Setze schnell deine erste Anmeldung ein. Dieser Leitfaden f\xfchrt dich durch alle notwendigen Einstellungen.",
        get_started: "Erste Schritte",
        apply_remind: "Bitte beachte, dass die Anmeldeoberfl\xe4che f\xfcr alle Anwendungen unter diesem Konto gilt."
    },
    color: {
        title: "FARBE",
        primary_color: "Markenfarbe",
        dark_primary_color: "Markenfarbe (Dunkler Modus)",
        dark_mode: "Aktiviere Dunklen Modus",
        dark_mode_description: "Deine App erh\xe4lt einen automatisch generierten Dunklen Modus, der auf deiner Markenfarbe und dem Logto-Algorithmus basiert. Du kannst diesen nach Belieben anpassen.",
        dark_mode_reset_tip: "Neuberechnung der Farbe des dunklen Modus basierend auf der Markenfarbe.",
        reset: "Neuberechnen"
    },
    branding: {
        title: "BRANDING",
        ui_style: "Stil",
        favicon: "Favicon",
        logo_image_url: "App Logo-URL",
        logo_image_url_placeholder: "https://dein.cdn.domain/logo.png",
        dark_logo_image_url: "App Logo-URL (Dunkler Modus)",
        dark_logo_image_url_placeholder: "https://dein.cdn.domain/logo-dark.png",
        logo_image: "App-Logo",
        dark_logo_image: "App-Logo (Dunkler Modus)",
        logo_image_error: "App-Logo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Benutzerdefiniertes CSS",
        css_code_editor_title: "Personalisiere dein UI mit Benutzerdefiniertem CSS",
        css_code_editor_description1: "Beispiele f\xfcr benutzerdefiniertes CSS anzeigen.",
        css_code_editor_description2: "<a>{{link}}</a>.",
        css_code_editor_description_link_content: "Erfahre mehr",
        css_code_editor_content_placeholder: "Gib dein benutzerdefiniertes CSS ein, um den Stil von allem genau nach deinen Vorgaben zu gestalten. Gib deiner Kreativit\xe4t Ausdruck und hebe dein UI hervor."
    },
    sign_up_and_sign_in: $7a8ca54843ac19e1$export$2e2bcd8739ae039,
    content: $9e689688488fc4c5$export$2e2bcd8739ae039,
    password_policy: $fb71e6e78b954b7f$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Es wurde noch kein SMS-Konnektor eingerichtet. Bevor die Konfiguration abgeschlossen werden kann, k\xf6nnen sich Benutzer nicht mit dieser Methode anmelden. <a>{{link}}</a> in "Verbindungen".',
        no_connector_email: 'Es wurde noch kein E-Mail-Konnektor eingerichtet. Bevor die Konfiguration abgeschlossen werden kann, k\xf6nnen sich Benutzer nicht mit dieser Methode anmelden. <a>{{link}}</a> in "Verbindungen".',
        no_connector_social: 'Sie haben noch keine soziale Verbindung eingerichtet. F\xfcgen Sie zuerst Verbindungen hinzu, um soziale Anmeldeverfahren anzuwenden. <a>{{link}}</a> in "Verbindungen".',
        setup_link: "Einrichtung"
    },
    save_alert: {
        description: "Du implementierst neue Anmelde- und Registrierungsverfahren. Alle deine Benutzer k\xf6nnen von der neuen Einrichtung betroffen sein. Bist du sicher, dass du die \xc4nderung abschlie\xdfen m\xf6chtest?",
        before: "Vorher",
        after: "Nachher",
        sign_up: "Registrierung",
        sign_in: "Anmeldung",
        social: "Sozial"
    },
    preview: {
        title: "Vorschau",
        live_preview: "Live-Vorschau",
        live_preview_tip: "Speichern, um \xc4nderungen anzuzeigen",
        native: "Native",
        desktop_web: "Desktop-Web",
        mobile_web: "Mobile-Web",
        desktop: "Desktop",
        mobile: "Mobilger\xe4t"
    }
};
var $5bca57cf73facfdd$export$2e2bcd8739ae039 = Object.freeze($5bca57cf73facfdd$var$sign_in_exp);


const $48949802929fd20e$var$quota_item = {
    tenant_limit: {
        name: "Mandanten",
        limited: "{{count, number}} Mandant",
        limited_other: "{{count, number}} Mandanten",
        unlimited: "Unbegrenzte Mandanten",
        not_eligible: "Entferne deine Mandanten"
    },
    mau_limit: {
        name: "Monatlich aktive Benutzer",
        limited: "{{count, number}} MAU",
        unlimited: "Unbegrenzte MAU",
        not_eligible: "Entferne alle Benutzer"
    },
    applications_limit: {
        name: "Anwendungen",
        limited: "{{count, number}} Anwendung",
        limited_other: "{{count, number}} Anwendungen",
        unlimited: "Unbegrenzte Anwendungen",
        not_eligible: "Entferne deine Anwendungen"
    },
    machine_to_machine_limit: {
        name: "Maschine-zu-Maschine",
        limited: "{{count, number}} Maschine-zu-Maschine-App",
        limited_other: "{{count, number}} Maschine-zu-Maschine-Apps",
        unlimited: "Unbegrenzte Maschine-zu-Maschine-Apps",
        not_eligible: "Entferne deine Maschine-zu-Maschine-Apps"
    },
    resources_limit: {
        name: "API-Ressourcen",
        limited: "{{count, number}} API-Ressource",
        limited_other: "{{count, number}} API-Ressourcen",
        unlimited: "Unbegrenzte API-Ressourcen",
        not_eligible: "Entferne deine API-Ressourcen"
    },
    scopes_per_resource_limit: {
        name: "Berechtigungen pro Ressource",
        limited: "{{count, number}} Berechtigung pro Ressource",
        limited_other: "{{count, number}} Berechtigungen pro Ressource",
        unlimited: "Unbegrenzte Berechtigung pro Ressource",
        not_eligible: "Entferne deine Ressourcenberechtigungen"
    },
    custom_domain_enabled: {
        name: "Benutzerdefinierte Domain",
        limited: "Benutzerdefinierte Domain",
        unlimited: "Benutzerdefinierte Domain",
        not_eligible: "Entferne deine benutzerdefinierte Domain"
    },
    omni_sign_in_enabled: {
        name: "Omni-Anmeldung",
        limited: "Omni-Anmeldung",
        unlimited: "Omni-Anmeldung",
        not_eligible: "Deaktiviere deine Omni-Anmeldung"
    },
    built_in_email_connector_enabled: {
        name: "Integrierter E-Mail-Connector",
        limited: "Integrierter E-Mail-Connector",
        unlimited: "Integrierter E-Mail-Connector",
        not_eligible: "Entferne deinen integrierten E-Mail-Connector"
    },
    social_connectors_limit: {
        name: "Soziale Connectoren",
        limited: "{{count, number}} sozialer Connector",
        limited_other: "{{count, number}} soziale Connectoren",
        unlimited: "Unbegrenzte soziale Connectoren",
        not_eligible: "Entferne deine sozialen Connectoren"
    },
    standard_connectors_limit: {
        name: "Kostenlose Standard-Connectoren",
        limited: "{{count, number}} kostenloser Standard-Connector",
        limited_other: "{{count, number}} kostenlose Standard-Connectoren",
        unlimited: "Unbegrenzte Standard-Connectoren",
        not_eligible: "Entferne deine Standard-Connectoren"
    },
    roles_limit: {
        name: "Rollen",
        limited: "{{count, number}} Rolle",
        limited_other: "{{count, number}} Rollen",
        unlimited: "Unbegrenzte Rollen",
        not_eligible: "Entferne deine Rollen"
    },
    scopes_per_role_limit: {
        name: "Berechtigungen pro Rolle",
        limited: "{{count, number}} Berechtigung pro Rolle",
        limited_other: "{{count, number}} Berechtigungen pro Rolle",
        unlimited: "Unbegrenzte Berechtigung pro Rolle",
        not_eligible: "Entferne deine Rollenberechtigungen"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} Webhook",
        limited_other: "{{count, number}} Webhooks",
        unlimited: "Unbegrenzte Webhooks",
        not_eligible: "Entferne deine Webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Audit-Log-Retention",
        limited: "Audit-Log-Retention: {{count, number}} Tag",
        limited_other: "Audit-Log-Retention: {{count, number}} Tage",
        unlimited: "Unbegrenzte Tage",
        not_eligible: "Keine Audit-Logs"
    },
    community_support_enabled: {
        name: "Community-Support",
        limited: "Community-Support",
        unlimited: "Community-Support",
        not_eligible: "Kein Community-Support"
    },
    customer_ticket_support: {
        name: "Kundenticketsupport",
        limited: "{{count, number}} Stunde Kundenticketsupport",
        limited_other: "{{count, number}} Stunden Kundenticketsupport",
        unlimited: "Kundenticketsupport",
        not_eligible: "Kein Kundenticketsupport"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Deaktivieren Sie Ihre MFA"
    },
    sso_enabled: {
        name: "Enterprise SSO",
        limited: "Enterprise SSO",
        unlimited: "Enterprise SSO",
        not_eligible: "Deaktivieren Sie Ihr Enterprise SSO"
    }
};
var $48949802929fd20e$export$2e2bcd8739ae039 = Object.freeze($48949802929fd20e$var$quota_item);


const $30fb74b5ad68a3fd$var$quota_table = {
    quota: {
        title: "Kontingent",
        tenant_limit: "Tenant-Limit",
        base_price: "Grundpreis",
        mau_unit_price: "* MAU-Einheitspreis",
        mau_limit: "MAU-Limit"
    },
    application: {
        title: "Anwendungen",
        total: "Gesamtzahl der Anwendungen",
        m2m: "Maschine-zu-Maschine"
    },
    resource: {
        title: "API-Ressourcen",
        resource_count: "Ressourcenanzahl",
        scopes_per_resource: "Berechtigungen pro Ressource"
    },
    branding: {
        title: "Benutzeroberfl\xe4che und Branding",
        custom_domain: "Benutzerdefinierte Domain",
        custom_css: "Benutzerdefiniertes CSS",
        app_logo_and_favicon: "App-Logo und Favicon",
        dark_mode: "Dunkler Modus",
        i18n: "Internationalisierung"
    },
    user_authn: {
        title: "Benutzerauthentifizierung",
        omni_sign_in: "Omni-Anmeldung",
        password: "Passwort",
        passwordless: "Passwortlos - E-Mail und SMS",
        email_connector: "E-Mail-Connector",
        sms_connector: "SMS-Connector",
        social_connectors: "Social-Connectors",
        standard_connectors: "Standard-Connectors",
        built_in_email_connector: "Integrierter E-Mail-Connector",
        mfa: "MFA",
        sso: "Unternehmens-SSO"
    },
    user_management: {
        title: "Benutzerverwaltung",
        user_management: "Benutzerverwaltung",
        roles: "Rollen",
        scopes_per_role: "Berechtigungen pro Rolle"
    },
    audit_logs: {
        title: "Pr\xfcfprotokolle",
        retention: "Aufbewahrungsdauer"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organisation",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Support",
        community: "Community",
        customer_ticket: "Support-Ticket",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Ihre monatlich aktiven Benutzer (MAU) werden in 3 Stufen unterteilt, basierend darauf, wie oft sie sich w\xe4hrend des Abrechnungszeitraums anmelden. Jede Stufe hat einen anderen Preis pro MAU-Einheit.",
    unlimited: "Unbegrenzt",
    contact: "Kontakt",
    monthly_price: "${{value, number}}/mo",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} Tag",
    days_other: "{{count, number}} Tage",
    add_on: "Zusatzleistung",
    tier: "Stufe{{value, number}}: "
};
var $30fb74b5ad68a3fd$export$2e2bcd8739ae039 = Object.freeze($30fb74b5ad68a3fd$var$quota_table);


const $bb9900e107dbb283$var$subscription = {
    free_plan: "Kostenloser Plan",
    free_plan_description: "F\xfcr Nebenprojekte und erste Logto-Tests. Keine Kreditkarte erforderlich.",
    hobby_plan: "Hobby Plan",
    hobby_plan_description: "F\xfcr einzelne Entwickler oder kleine Ingenieurteams.",
    pro_plan: "Pro Plan",
    pro_plan_description: "F\xfcr Unternehmen, die sorgenfrei von Logto profitieren m\xf6chten.",
    enterprise: "Unternehmen",
    current_plan: "Aktueller Plan",
    current_plan_description: "Hier ist dein aktueller Tarif. Du kannst einfach deinen Tarifverbrauch einsehen, deine anstehende Rechnung \xfcberpr\xfcfen und bei Bedarf \xc4nderungen an deinem Tarif vornehmen.",
    plan_usage: "Plan-Nutzung",
    plan_cycle: "Plan-Zyklus: {{period}}. Die Nutzung wird am {{renewDate}} erneuert.",
    next_bill: "Ihre n\xe4chste Rechnung",
    next_bill_hint: "Weitere Informationen zur Berechnung finden Sie in diesem <a>Artikel</a>.",
    next_bill_tip: "Ihre bevorstehende Rechnung enth\xe4lt den Grundpreis Ihres Plans f\xfcr den n\xe4chsten Monat sowie die Kosten f\xfcr Ihre Nutzung multipliziert mit dem MAU-Einheitspreis in verschiedenen Stufen.",
    manage_payment: "Zahlung verwalten",
    overfill_quota_warning: "Sie haben Ihr Quotenlimit erreicht. Um Probleme zu vermeiden, upgraden Sie den Plan.",
    upgrade_pro: "Pro upgraden",
    update_payment: "Zahlung aktualisieren",
    payment_error: "Es wurde ein Zahlungsproblem festgestellt. Der Betrag von ${{price, number}} f\xfcr den vorherigen Zyklus kann nicht verarbeitet werden. Aktualisieren Sie die Zahlung, um eine Aussetzung des Logto-Dienstes zu vermeiden.",
    downgrade: "Herabstufen",
    current: "Aktuell",
    upgrade: "Upgrade",
    quota_table: $30fb74b5ad68a3fd$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Rechnungen",
        status_column: "Status",
        amount_column: "Betrag",
        invoice_created_date_column: "Rechnungsdatum",
        invoice_status: {
            void: "Storniert",
            paid: "Bezahlt",
            open: "Offen",
            uncollectible: "\xdcberf\xe4llig"
        }
    },
    quota_item: $48949802929fd20e$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Sind Sie sicher, dass Sie herabstufen m\xf6chten?",
        description: "Wenn Sie sich f\xfcr den Wechsel zum <targetName/> entscheiden, beachten Sie bitte, dass Sie keinen Zugriff mehr auf die Quote und die Funktionen haben, die zuvor in <currentName/> enthalten waren.",
        before: "Vorher: <name/>",
        after: "Nachher: <name />",
        downgrade: "Herabstufen"
    },
    not_eligible_modal: {
        downgrade_title: "Downgrade nicht m\xf6glich",
        downgrade_description: "Stellen Sie sicher, dass Sie die folgenden Kriterien erf\xfcllen, bevor Sie auf <name/> downgraden.",
        downgrade_help_tip: "Hilfe beim Downgrade ben\xf6tigt? <a>Kontaktieren Sie uns</a>.",
        upgrade_title: "Freundliche Erinnerung f\xfcr unsere gesch\xe4tzten Early Adopters",
        upgrade_description: "Sie nutzen derzeit mehr als das, was <name /> erlaubt. Logto ist nun offiziell und bietet Funktionen, die auf jeden Tarif zugeschnitten sind. Bevor Sie ein Upgrade auf den <name /> in Betracht ziehen, stellen Sie sicher, dass Sie die folgenden Kriterien f\xfcr das Upgrade erf\xfcllen.",
        upgrade_pro_tip: " Oder erw\xe4gen Sie ein Upgrade auf den Pro Plan.",
        upgrade_help_tip: "Hilfe beim Upgrade ben\xf6tigt? <a>Kontaktieren Sie uns</a>.",
        a_maximum_of: "Maximal <item/>"
    },
    upgrade_success: "Erfolgreich auf <name/> hochgestuft",
    downgrade_success: "Erfolgreich auf <name/> herabgestuft",
    subscription_check_timeout: "Abo-\xdcberpr\xfcfung ist abgelaufen. Bitte sp\xe4ter aktualisieren.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $bb9900e107dbb283$export$2e2bcd8739ae039 = Object.freeze($bb9900e107dbb283$var$subscription);


const $41b382d32cf3fb69$var$tab_sections = {
    overview: "\xdcbersicht",
    resources: "Ressourcen",
    users: "Benutzer",
    access_control: "Zugriffskontrolle",
    help_and_support: "Hilfe und Support",
    tenant: "Mieter",
    automation: "Automatisierung"
};
var $41b382d32cf3fb69$export$2e2bcd8739ae039 = Object.freeze($41b382d32cf3fb69$var$tab_sections);


const $4624b39f62c3fec6$var$tabs = {
    get_started: "Erste Schritte",
    dashboard: "Dashboard",
    applications: "Anwendungen",
    api_resources: "API Ressourcen",
    sign_in_experience: "Anmeldeoberfl\xe4che",
    connectors: "Connectoren",
    enterprise_sso: "Unternehmens-SSO",
    webhooks: "Webhooks",
    organizations: "Organisationen",
    users: "Benutzerverwaltung",
    audit_logs: "Audit-Logs",
    roles: "Rollen",
    docs: "Dokumentation",
    tenant_settings: "Einstellungen",
    mfa: "Multi-Faktor-Authentifizierung"
};
var $4624b39f62c3fec6$export$2e2bcd8739ae039 = Object.freeze($4624b39f62c3fec6$var$tabs);


const $1cffde913488c3ad$var$tenants = {
    title: "Einstellungen",
    description: "Effizientes Verwalten von Mandanteneinstellungen und Anpassen Ihrer Domain.",
    tabs: {
        settings: "Einstellungen",
        domains: "Dom\xe4nen",
        subscription: "Plan und Abrechnung",
        billing_history: "Abrechnungshistorie"
    },
    settings: {
        title: "EINSTELLUNGEN",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "Mieter-ID",
        tenant_name: "Mietername",
        tenant_region: "Gehostete Region der Daten",
        tenant_region_tip: "Ihre Mandantenressourcen werden in {{region}} gehostet. <a>Mehr erfahren</a>",
        environment_tag_development: "Entw",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Mieterinformationen erfolgreich gespeichert."
    },
    full_env_tag: {
        development: "Entwicklung",
        production: "Produktion"
    },
    deletion_card: {
        title: "L\xd6SCHEN",
        tenant_deletion: "Mieter l\xf6schen",
        tenant_deletion_description: "Das L\xf6schen des Mandanten f\xfchrt zur dauerhaften Entfernung aller zugeh\xf6rigen Benutzerdaten und Konfigurationen. Bitte gehen Sie vorsichtig vor.",
        tenant_deletion_button: "Mieter l\xf6schen"
    },
    create_modal: {
        title: "Mieter erstellen",
        subtitle: "Erstellen Sie einen neuen Mandanten mit isolierten Ressourcen und Benutzern. Die gehosteten Datenregionen und Mandantentypen k\xf6nnen nach der Erstellung nicht ge\xe4ndert werden.",
        tenant_usage_purpose: "Wof\xfcr m\xf6chten Sie diesen Mieter verwenden?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Verf\xfcgbare Pl\xe4ne:",
        create_button: "Mieter erstellen",
        tenant_name_placeholder: "Mein Mieter"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Mieter l\xf6schen",
        description_line1: 'M\xf6chten Sie wirklich Ihren Mandanten "<span>{{name}}</span>" mit Umgebungssuffix-Tag "<span>{{tag}}</span>" l\xf6schen? Dieser Vorgang kann nicht r\xfcckg\xe4ngig gemacht werden und f\xfchrt zur dauerhaften L\xf6schung aller Ihrer Daten und Kontoinformationen.',
        description_line2: "Bevor Sie Ihren Mieter l\xf6schen, k\xf6nnen wir Ihnen vielleicht helfen. <span><a>Kontaktieren Sie uns per E-Mail</a></span>",
        description_line3: 'Wenn Sie fortfahren m\xf6chten, geben Sie bitte den Mieter-Namen "<span>{{name}}</span>" zur Best\xe4tigung ein.',
        delete_button: "Dauerhaft l\xf6schen",
        cannot_delete_title: "Diesen Mandanten kann nicht gel\xf6scht werden",
        cannot_delete_description: "Entschuldigung, Sie k\xf6nnen diesen Mandanten momentan nicht l\xf6schen. Stellen Sie sicher, dass Sie sich im kostenlosen Tarif befinden und alle ausstehenden Rechnungen bezahlt haben."
    },
    tenant_landing_page: {
        title: "Du hast noch keinen Mandanten erstellt",
        description: "Um Ihr Projekt mit Logto zu konfigurieren, erstellen Sie bitte einen neuen Mandanten. Wenn Sie sich abmelden oder Ihr Konto l\xf6schen m\xf6chten, klicken Sie einfach auf die Avatar-Taste in der oberen rechten Ecke.",
        create_tenant_button: "Mandanten erstellen"
    },
    status: {
        mau_exceeded: "MAU \xfcberschritten",
        suspended: "Gesperrt",
        overdue: "\xdcberf\xe4llig"
    },
    tenant_suspended_page: {
        title: "Mieter gesperrt. Kontaktieren Sie uns, um den Zugriff wiederherzustellen.",
        description_1: "Es tut uns leid, Ihnen mitteilen zu m\xfcssen, dass Ihr Mieterkonto vor\xfcbergehend gesperrt wurde, da es unsachgem\xe4\xdf genutzt wurde. Dies umfasst die \xdcberschreitung der MAU-Grenzen, \xfcberf\xe4llige Zahlungen oder andere unbefugte Aktionen.",
        description_2: "Wenn Sie weitere Informationen w\xfcnschen, Bedenken haben oder die volle Funktionalit\xe4t wiederherstellen und Ihre Mieter entsperren m\xf6chten, z\xf6gern Sie nicht, uns umgehend zu kontaktieren."
    },
    signing_keys: {
        title: "SIGNIERUNGSSCHL\xdcSSEL",
        description: "Sicherer Umgang mit Signierungsschl\xfcsseln in Ihrem Mandanten.",
        type: {
            private_key: "OIDC-Private Keys",
            cookie_key: "OIDC-Cookie-Keys"
        },
        private_keys_in_use: "Verwendete private Schl\xfcssel",
        cookie_keys_in_use: "Verwendete Cookie-Schl\xfcssel",
        rotate_private_keys: "Private Schl\xfcssel rotieren",
        rotate_cookie_keys: "Cookie-Schl\xfcssel rotieren",
        rotate_private_keys_description: "Diese Aktion erstellt einen neuen privaten Signierungsschl\xfcssel, rotiert den aktuellen Schl\xfcssel und entfernt Ihren vorherigen Schl\xfcssel. Ihre JWT-Token, die mit dem aktuellen Schl\xfcssel signiert sind, bleiben g\xfcltig, bis sie gel\xf6scht oder erneut rotiert werden.",
        rotate_cookie_keys_description: "Diese Aktion erstellt einen neuen Cookie-Schl\xfcssel, rotiert den aktuellen Schl\xfcssel und entfernt Ihren vorherigen Schl\xfcssel. Ihre Cookies mit dem aktuellen Schl\xfcssel bleiben g\xfcltig, bis sie gel\xf6scht oder erneut rotiert werden.",
        select_private_key_algorithm: "Signierungsalgorithmus f\xfcr den neuen privaten Schl\xfcssel ausw\xe4hlen",
        rotate_button: "Rotieren",
        table_column: {
            id: "ID",
            status: "Status",
            algorithm: "Signierungsschl\xfcssel Algorithmus"
        },
        status: {
            current: "Aktuell",
            previous: "Vorherige"
        },
        reminder: {
            rotate_private_key: "Sind Sie sicher, dass Sie die <strong>OIDC-Private Keys</strong> rotieren m\xf6chten? Neue ausgestellte JWT-Token werden vom neuen Schl\xfcssel signiert. Bestehende JWT-Token bleiben g\xfcltig, bis Sie sie erneut rotieren.",
            rotate_cookie_key: "Sind Sie sicher, dass Sie die <strong>OIDC-Cookie-Keys</strong> rotieren m\xf6chten? Neue Cookies, die in Anmelde-Sitzungen generiert werden, werden mit dem neuen Cookie-Schl\xfcssel signiert. Bestehende Cookies bleiben g\xfcltig, bis Sie sie erneut rotieren.",
            delete_private_key: "Sind Sie sicher, dass Sie den <strong>OIDC-Privaten Schl\xfcssel</strong> l\xf6schen m\xf6chten? Bestehende JWT-Token, die mit diesem privaten Signierungsschl\xfcssel signiert wurden, sind nicht mehr g\xfcltig.",
            delete_cookie_key: "Sind Sie sicher, dass Sie den <strong>OIDC-Cookie-Schl\xfcssel</strong> l\xf6schen m\xf6chten? \xc4ltere Anmelde-Sitzungen mit Cookies, die mit diesem Cookie-Schl\xfcssel signiert wurden, sind nicht mehr g\xfcltig. Eine erneute Authentifizierung ist f\xfcr diese Benutzer erforderlich."
        },
        messages: {
            rotate_key_success: "Signierungsschl\xfcssel erfolgreich rotieren.",
            delete_key_success: "Schl\xfcssel erfolgreich gel\xf6scht."
        }
    }
};
var $1cffde913488c3ad$export$2e2bcd8739ae039 = Object.freeze($1cffde913488c3ad$var$tenants);


const $7c182e2b1c8201e9$var$topbar = {
    docs: "Dokumente",
    help: "Hilfe"
};
var $7c182e2b1c8201e9$export$2e2bcd8739ae039 = Object.freeze($7c182e2b1c8201e9$var$topbar);


const $9d94c2a986ee19a4$var$paywall = {
    applications: "{{count, number}} Anwendung von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    applications_other: "{{count, number}} Anwendungen von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    machine_to_machine_feature: "Upgrade auf den <strong>Hobby</strong>-Plan, um 1 Maschine-zu-Maschine-Anwendung freizuschalten, oder w\xe4hlen Sie den <strong>Pro</strong>-Plan f\xfcr eine unbegrenzte Nutzung. F\xfcr jegliche Hilfe k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    machine_to_machine: "{{count, number}} Maschine-zu-Maschine-Anwendung von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    machine_to_machine_other: "{{count, number}} Maschine-zu-Maschine-Anwendungen von <planName/> erreicht. Plan upgraden, um den Bed\xfcrfnissen Ihres Teams gerecht zu werden. F\xfcr Unterst\xfctzung k\xf6nnen Sie uns gerne <a>kontaktieren</a>.",
    resources: "Sie haben das Limit von {{count, number}} <planName/>-API-Ressourcen erreicht. Upgraden Sie Ihren Plan, um den Anforderungen Ihres Teams gerecht zu werden. <a>Kontaktieren Sie uns</a> bei Bedarf.",
    resources_other: "Sie haben das Limit von {{count, number}} <planName/>-API-Ressourcen erreicht. Upgraden Sie Ihren Plan, um den Anforderungen Ihres Teams gerecht zu werden. <a>Kontaktieren Sie uns</a> bei Bedarf.",
    scopes_per_resource: "Sie haben das Limit von {{count, number}} Berechtigungen pro API-Ressource von <planName/> erreicht. Upgraden Sie jetzt, um zu erweitern. <a>Kontaktieren Sie uns</a> bei Bedarf.",
    scopes_per_resource_other: "Sie haben das Limit von {{count, number}} Berechtigungen pro API-Ressource von <planName/> erreicht. Upgraden Sie jetzt, um zu erweitern. <a>Kontaktieren Sie uns</a> bei Bedarf.",
    custom_domain: "Freischalten Sie die Funktion f\xfcr benutzerdefinierte Domains, indem Sie auf den <strong>Hobby</strong>- oder <strong>Pro</strong>-Plan upgraden. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    social_connectors: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    social_connectors_other: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_feature: "Upgrade auf den <strong>Hobby</strong>- oder <strong>Pro</strong>-Plan, um eigene Connectoren unter Verwendung von OIDC, OAuth 2.0 und SAML-Protokollen zu erstellen, sowie unbegrenzte Sozialconnectoren und alle Premium-Funktionen. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_other: "Sie haben das Limit von {{count, number}} <planName/>-Sozialconnectoren erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_pro: "Sie haben das Limit von {{count, number}} <planName/>-Standardconnectoren erreicht. Upgraden Sie auf den Enterprise-Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    standard_connectors_pro_other: "Sie haben das Limit von {{count, number}} <planName/>-Standardconnectoren erreicht. Upgraden Sie auf den Enterprise-Plan, um zus\xe4tzliche Sozialconnectoren und die M\xf6glichkeit zur Erstellung eigener Connectoren mit OIDC, OAuth 2.0 und SAML-Protokollen zu erhalten. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    roles: "Sie haben das Limit von {{count, number}} <planName/>-Rollen erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    roles_other: "Sie haben das Limit von {{count, number}} <planName/>-Rollen erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    scopes_per_role: "Sie haben das Limit von {{count, number}} Berechtigungen pro Rolle von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Bei Fragen stehen wir Ihnen gerne zur Verf\xfcgung. <a>Kontaktieren Sie uns</a>.",
    scopes_per_role_other: "Sie haben das Limit von {{count, number}} Berechtigungen pro Rolle von <planName/> erreicht. Upgraden Sie Ihren Plan, um zus\xe4tzliche Rollen und Berechtigungen hinzuzuf\xfcgen. Bei Fragen stehen wir Ihnen gerne zur Verf\xfcgung. <a>Kontaktieren Sie uns</a>.",
    hooks: "Sie haben das Limit von {{count, number}} <planName/>-Webhooks erreicht. Upgraden Sie Ihren Plan, um mehr Webhooks zu erstellen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    hooks_other: "Sie haben das Limit von {{count, number}} <planName/>-Webhooks erreicht. Upgraden Sie Ihren Plan, um mehr Webhooks zu erstellen. Z\xf6gern Sie nicht, <a>Kontaktieren Sie uns</a>, wenn Sie Hilfe ben\xf6tigen.",
    mfa: "Schalten Sie MFA zur Sicherheits\xfcberpr\xfcfung frei, indem Sie auf einen kostenpflichtigen Plan aktualisieren. Z\xf6gern Sie nicht, uns zu <a>kontaktieren</a>, wenn Sie Unterst\xfctzung ben\xf6tigen.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $9d94c2a986ee19a4$export$2e2bcd8739ae039 = Object.freeze($9d94c2a986ee19a4$var$paywall);


const $7b2464f55c8c8d3e$var$upsell = {
    upgrade_plan: "Upgrade plan",
    compare_plans: "Pl\xe4ne vergleichen",
    view_plans: "Pl\xe4ne anzeigen",
    create_tenant: {
        title: "W\xe4hlen Sie Ihren Tenant-Plan aus",
        description: "Logto bietet wettbewerbsf\xe4hige Planoptionen mit innovativer und erschwinglicher Preisgestaltung, die f\xfcr wachsende Unternehmen entwickelt wurden. <a>Erfahren Sie mehr</a>",
        base_price: "Grundpreis",
        monthly_price: "{{value, number}}/Monat",
        mau_unit_price: "MAU-Einheitspreis",
        view_all_features: "Alle Funktionen anzeigen",
        select_plan: "<name/> ausw\xe4hlen",
        free_tenants_limit: "Bis zu {{count, number}} kostenlose Tenant",
        free_tenants_limit_other: "Bis zu {{count, number}} kostenlose Tenants",
        most_popular: "Am beliebtesten",
        upgrade_success: "Erfolgreich auf <name/> upgegradet"
    },
    mau_exceeded_modal: {
        title: "MAU-Limit \xfcberschritten. Upgraden Sie Ihren Plan.",
        notification: "Ihr aktueller MAU hat das Limit von <planName/> \xfcberschritten. Bitte upgraden Sie umgehend auf den Premium-Plan, um die Aussetzung des Logto-Dienstes zu vermeiden.",
        update_plan: "Plan aktualisieren"
    },
    payment_overdue_modal: {
        title: "Zahlungsr\xfcckstand f\xfcr Rechnung",
        notification: "Hoppla! Die Zahlung f\xfcr die Rechnung des Mieters <span>{{name}}</span> ist fehlgeschlagen. Bitte zahlen Sie die Rechnung umgehend, um eine Sperrung des Logto-Dienstes zu vermeiden.",
        unpaid_bills: "Ausstehende Rechnungen",
        update_payment: "Zahlung aktualisieren"
    },
    paywall: $9d94c2a986ee19a4$export$2e2bcd8739ae039
};
var $7b2464f55c8c8d3e$export$2e2bcd8739ae039 = Object.freeze($7b2464f55c8c8d3e$var$upsell);


const $2c3492bc8c144063$var$user_details = {
    page_title: "Benutzerdetails",
    back_to_users: "Zur\xfcck zur Benutzerverwaltung",
    created_title: "Der Benutzer wurde erfolgreich erstellt",
    created_guide: "Hier sind die Informationen, um dem Benutzer bei der Anmeldung zu helfen.",
    created_email: "E-Mail-Adresse:",
    created_phone: "Telefonnummer:",
    created_username: "Benutzername:",
    created_password: "Passwort:",
    menu_delete: "L\xf6schen",
    delete_description: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Der Benutzer wird permanent gel\xf6scht.",
    deleted: "Der Benutzer wurde erfolgreich gel\xf6scht",
    reset_password: {
        reset_password: "Passwort zur\xfccksetzen",
        title: "Willst du das Passwort wirklich zur\xfccksetzen?",
        content: "Diese Aktion kann nicht r\xfcckg\xe4ngig gemacht werden. Das Anmeldeinformationen werden zur\xfcckgesetzt.",
        congratulations: "Der Benutzer wurde erfolgreich zur\xfcckgesetzt",
        new_password: "Neues Passwort:"
    },
    tab_settings: "Einstellungen",
    tab_roles: "Rollen",
    tab_logs: "Benutzer-Logs",
    tab_organizations: "Organisationen",
    authentication: "Authentifizierung",
    authentication_description: "Jeder Benutzer hat ein Profil mit allen Benutzerinformationen. Es besteht aus Basisdaten, sozialen Identit\xe4ten und benutzerdefinierten Daten.",
    user_profile: "Benutzerprofil",
    field_email: "E-Mail-Adresse",
    field_phone: "Telefonnummer",
    field_username: "Benutzername",
    field_name: "Name",
    field_avatar: "Profilbild URL",
    field_avatar_placeholder: "https://dein.cdn.domain/profilbild.png",
    field_custom_data: "Benutzerdefinierte Daten",
    field_custom_data_tip: "Zus\xe4tzliche Benutzerinformationen, die nicht in den vordefinierten Benutzereigenschaften aufgef\xfchrt sind, wie z. B. die vom Benutzer bevorzugte Farbe und Sprache.",
    field_connectors: "Soziale Verbindungen",
    field_sso_connectors: "Unternehmensverbindungen",
    custom_data_invalid: "Benutzerdefinierte Daten m\xfcssen ein g\xfcltiges JSON-Objekt sein.",
    connectors: {
        connectors: "Verbindungen",
        user_id: "Benutzer ID",
        remove: "L\xf6schen",
        connected: "Dieser Benutzer ist mit mehreren sozialen Verbindern verbunden.",
        not_connected: "Der Benutzer ist nicht mit einem sozialen Verbindungsger\xe4t verbunden",
        deletion_confirmation: "Sie entfernen die bestehende Identit\xe4t <name/>. M\xf6chten Sie den Vorgang wirklich fortsetzen?"
    },
    sso_connectors: {
        connectors: "Verbindungen",
        enterprise_id: "Unternehmens-ID",
        connected: "Dieser Benutzer ist mit mehreren Enterprise-Identit\xe4tsanbietern f\xfcr Single Sign-On verbunden.",
        not_connected: "Der Benutzer ist nicht mit einem Unternehmensidentit\xe4tsanbieter f\xfcr Single Sign-On verbunden."
    },
    mfa: {
        field_name: "Zwei-Faktor-Authentifizierung",
        field_description: "Dieser Benutzer hat 2-Stufen-Authentifizierungsfaktoren aktiviert.",
        name_column: "Zwei-Faktor",
        field_description_empty: "Dieser Benutzer hat keine zweistufigen Authentifizierungsfaktoren aktiviert.",
        deletion_confirmation: "Sie entfernen die bestehende <name/> f\xfcr die Zwei-Faktor-Authentifizierung. Sind Sie sicher, dass Sie fortfahren m\xf6chten?"
    },
    suspended: "Gesperrt",
    suspend_user: "Benutzer sperren",
    suspend_user_reminder: "Sind Sie sicher, dass Sie diesen Benutzer sperren m\xf6chten? Der Benutzer kann sich nicht bei Ihrer App anmelden und kann nach Ablauf des aktuellen Tokens kein neues Zugriffstoken mehr erhalten. Au\xdferdem schlagen alle API-Anforderungen von diesem Benutzer fehl.",
    suspend_action: "Sperren",
    user_suspended: "Benutzer wurde gesperrt.",
    reactivate_user: "Benutzer entsperren",
    reactivate_user_reminder: "Sind Sie sicher, dass Sie diesen Benutzer wieder aktivieren m\xf6chten? Dadurch werden alle Anmeldeversuche f\xfcr diesen Benutzer erm\xf6glicht.",
    reactivate_action: "Aktivieren",
    user_reactivated: "Benutzer wurde aktiviert.",
    roles: {
        name_column: "Rolle",
        description_column: "Beschreibung",
        assign_button: "Rollen zuweisen",
        delete_description: "Diese Aktion entfernt diese Rolle von diesem Benutzer. Die Rolle selbst bleibt erhalten, aber sie wird nicht mehr mit diesem Benutzer verkn\xfcpft sein.",
        deleted: "{{name}} wurde erfolgreich von diesem Benutzer entfernt.",
        assign_title: "Rollen an {{name}} zuweisen",
        assign_subtitle: "{{name}} eine oder mehrere Rollen zuweisen",
        assign_role_field: "Rollen zuweisen",
        role_search_placeholder: "Nach Rollennamen suchen",
        added_text: "{{value, number}} hinzugef\xfcgt",
        assigned_user_count: "{{value, number}} Benutzer",
        confirm_assign: "Rollen zuweisen",
        role_assigned: "Rolle(n) erfolgreich zugewiesen",
        search: "Nach Rollennamen, Beschreibung oder ID suchen",
        empty: "Keine Rolle verf\xfcgbar"
    },
    warning_no_sign_in_identifier: "Der Benutzer muss mindestens einen der Anmelde-Identifikatoren (Benutzername, E-Mail, Telefonnummer oder soziales Konto) haben, um sich anzumelden. Sind Sie sicher, dass Sie fortfahren m\xf6chten?",
    organization_roles_tooltip: "Die dem Benutzer innerhalb dieser Organisation zugewiesenen Rollen."
};
var $2c3492bc8c144063$export$2e2bcd8739ae039 = Object.freeze($2c3492bc8c144063$var$user_details);


const $d9da82b638c267a0$var$users = {
    page_title: "Benutzerverwaltung",
    title: "Benutzerverwaltung",
    subtitle: "Verwalten von Benutzeridentit\xe4ten, einschlie\xdflich des Anlegens von Benutzern, Bearbeiten von Benutzerinformationen, Anzeigen von Benutzer-Logs, Zur\xfccksetzen von Passw\xf6rtern und L\xf6schen von Benutzern",
    create: "Benutzer hinzuf\xfcgen",
    create_subtitle: "Um fortzufahren, geben Sie bitte mindestens eines der folgenden Felder an.",
    error_missing_identifier: "Sie m\xfcssen mindestens einen Identifikator eingeben, um einen Benutzer anzulegen",
    user_name: "Benutzername",
    application_name: "Anwendungsname",
    latest_sign_in: "Letzte Anmeldung",
    create_form_username: "Benutzername",
    create_form_password: "Passwort",
    create_form_name: "Name",
    placeholder_name: "Max Mustermann",
    placeholder_email: "max@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+49 (0)123 456789",
    unnamed: "Unbenannt",
    search: "Suche nach Name, E-Mail, Telefon oder Benutzername",
    check_user_detail: "Benutzerdetails \xfcberpr\xfcfen",
    placeholder_title: "Benutzerverwaltung",
    placeholder_description: "Jeder Benutzer hat ein Profil mit allen Benutzerinformationen. Es besteht aus grundlegenden Daten, sozialen Identit\xe4ten und benutzerdefinierten Daten."
};
var $d9da82b638c267a0$export$2e2bcd8739ae039 = Object.freeze($d9da82b638c267a0$var$users);


const $521a77a60eee48cd$var$webhook_details = {
    page_title: "Webhook-Details",
    back_to_webhooks: "Zur\xfcck zu Webhooks",
    not_in_use: "Nicht in Nutzung",
    success_rate: "Erfolgsrate",
    requests: "{{value, number}} Requests in 24 Stunden",
    disable_webhook: "Webhook deaktivieren",
    disable_reminder: "Sind Sie sicher, dass Sie diesen Webhook reaktivieren m\xf6chten? Wenn Sie das tun, wird keine HTTP-Anforderung an die Endpunkt-URL gesendet.",
    webhook_disabled: "Der Webhook wurde deaktiviert.",
    webhook_reactivated: "Der Webhook wurde reaktiviert.",
    reactivate_webhook: "Webhook reaktivieren",
    delete_webhook: "Webhook l\xf6schen",
    deletion_reminder: "Sie entfernen diesen Webhook. Nach dem L\xf6schen wird keine HTTP-Anforderung an die Endpunkt-URL gesendet.",
    deleted: "Der Webhook wurde erfolgreich gel\xf6scht.",
    settings_tab: "Einstellungen",
    recent_requests_tab: "Letzte Anforderungen (24h)",
    settings: {
        settings: "Einstellungen",
        settings_description: "Webhooks erm\xf6glichen es Ihnen, Echtzeit-Updates zu bestimmten Ereignissen zu erhalten, indem sie eine POST-Anforderung an Ihre Endpunkt-URL senden. Dies erm\xf6glicht es Ihnen, sofortige Ma\xdfnahmen aufgrund der neuen Informationen zu ergreifen, die Sie erhalten.",
        events: "Ereignisse",
        events_description: "W\xe4hlen Sie die Ausl\xf6serereignisse aus, die Logto die POST-Anforderung senden wird.",
        name: "Name",
        endpoint_url: "Endpunkt-URL",
        signing_key: "Signing Key",
        signing_key_tip: "F\xfcgen Sie den von Logto bereitgestellten geheimen Schl\xfcssel als Anforderungsheader zu Ihrem Endpunkt hinzu, um die Echtheit der Nutzlast des Webhooks sicherzustellen.",
        regenerate: "Neu generieren",
        regenerate_key_title: "Signing Key neu generieren",
        regenerate_key_reminder: "Sind Sie sicher, dass Sie den Signing Key \xe4ndern m\xf6chten? Die Regeneration wird sofort wirksam. Bitte denken Sie daran, den Signing Key synchron in Ihrem Endpunkt zu \xe4ndern.",
        regenerated: "Der Signing Key wurde neu generiert.",
        custom_headers: "Benutzerdefinierte Header",
        custom_headers_tip: "Sie k\xf6nnen optional benutzerdefinierte Header zur Nutzlast des Webhooks hinzuf\xfcgen, um zus\xe4tzlichen Kontext oder Metadaten zum Ereignis bereitzustellen.",
        key_duplicated_error: "Schl\xfcssel k\xf6nnen nicht wiederholt werden.",
        key_missing_error: "Key ist erforderlich.",
        value_missing_error: "Eine Eingabe ist erforderlich.",
        invalid_key_error: "Schl\xfcssel ist ung\xfcltig",
        invalid_value_error: "Wert ist ung\xfcltig",
        test: "Test",
        test_webhook: "Testen Sie Ihren Webhook",
        test_webhook_description: "Konfigurieren Sie den Webhook und testen Sie ihn mit Beispieldaten f\xfcr jede ausgew\xe4hlte Ereigniskategorie, um eine korrekte Empfangs- und Verarbeitungsfunktion zu \xfcberpr\xfcfen.",
        send_test_payload: "Testnutzlast senden",
        test_result: {
            endpoint_url: "Endpunkt-URL: {{url}}",
            message: "Nachricht: {{message}}",
            response_status: "Antwortstatus: {{status, number}}",
            response_body: "Antwortk\xf6rper: {{body}}",
            request_time: "Anforderungszeit: {{time}}",
            test_success: "Der Webhook-Test zum Endpunkt war erfolgreich."
        }
    }
};
var $521a77a60eee48cd$export$2e2bcd8739ae039 = Object.freeze($521a77a60eee48cd$var$webhook_details);


const $890c708befcd8bcb$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Erstellen Sie Webhooks, um m\xfchelos Echtzeit-Updates zu bestimmten Ereignissen zu empfangen.",
    create: "Webhook erstellen",
    events: {
        post_register: "Neuen Account anlegen",
        post_sign_in: "Anmelden",
        post_reset_password: "Passwort zur\xfccksetzen"
    },
    table: {
        name: "Name",
        events: "Ereignisse",
        success_rate: "Erfolgsrate (24h)",
        requests: "Anfragen (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Erstellen Sie einen Webhook, um Echtzeit-Updates \xfcber POST-Anfragen an Ihre Endpunkt-URL zu empfangen. Bleiben Sie \xfcber Ereignisse wie "Account erstellen", "Anmelden" und "Passwort zur\xfccksetzen" informiert und ergreifen Sie sofort Ma\xdfnahmen.',
        create_webhook: "Webhook erstellen"
    },
    create_form: {
        title: "Webhook erstellen",
        subtitle: "F\xfcgen Sie den Webhook hinzu, um eine POST-Anfrage an die Endpunkt-URL mit Details zu Ereignissen der Benutzer zu senden.",
        events: "Ereignisse",
        events_description: "W\xe4hlen Sie die Trigger-Ereignisse aus, bei welchen Logto die POST-Anfrage senden soll.",
        name: "Name",
        name_placeholder: "Webhook-Namen eingeben",
        endpoint_url: "Endpunkt-URL",
        endpoint_url_placeholder: "https://Ihre.webhook.endpunkt.url",
        endpoint_url_tip: "Geben Sie die URL Ihres Endpunkts ein, an die ein Payload Ihres Webooks gesendet wird, wenn das Ereignis eintritt.",
        create_webhook: "Webhook erstellen",
        missing_event_error: "Sie m\xfcssen mindestens ein Ereignis ausw\xe4hlen."
    },
    webhook_created: "Der Webhook {{name}} wurde erfolgreich erstellt."
};
var $890c708befcd8bcb$export$2e2bcd8739ae039 = Object.freeze($890c708befcd8bcb$var$webhooks);


const $e51eb75481e5e8f9$var$welcome = {
    title: "Willkommen in der Admin Konsole",
    description: "Die Admin-Konsole ist eine Web-App, mit der du Logto verwalten kannst, ohne programmieren zu m\xfcssen. Legen wir zun\xe4chst ein Konto an. Mit diesem Konto kannst du Logto selbst oder im Namen deines Unternehmens verwalten.",
    create_account: "Konto erstellen"
};
var $e51eb75481e5e8f9$export$2e2bcd8739ae039 = Object.freeze($e51eb75481e5e8f9$var$welcome);


const $c3b9a4eb73115768$var$admin_console = {
    title: "Admin Konsole",
    admin_user: "Admin",
    system_app: "System",
    menu: $33503b720c773151$export$2e2bcd8739ae039,
    general: $3bf70810c44a1cc4$export$2e2bcd8739ae039,
    errors: $c3564b25ce4806ff$export$2e2bcd8739ae039,
    tab_sections: $41b382d32cf3fb69$export$2e2bcd8739ae039,
    tabs: $4624b39f62c3fec6$export$2e2bcd8739ae039,
    applications: $aa148b16b42310c7$export$2e2bcd8739ae039,
    application_details: $5a87a3db767e5a5c$export$2e2bcd8739ae039,
    api_resources: $e485cd46f017ecaa$export$2e2bcd8739ae039,
    api_resource_details: $c7dca8b8b565eb2a$export$2e2bcd8739ae039,
    connectors: $c04087584632d166$export$2e2bcd8739ae039,
    connector_details: $69df924f5631d054$export$2e2bcd8739ae039,
    enterprise_sso: $3f9d43973e08cd61$export$2e2bcd8739ae039,
    enterprise_sso_details: $d3111d1c930911c5$export$2e2bcd8739ae039,
    get_started: $c169e04f579e7127$export$2e2bcd8739ae039,
    users: $d9da82b638c267a0$export$2e2bcd8739ae039,
    user_details: $2c3492bc8c144063$export$2e2bcd8739ae039,
    contact: $7c18db81143887ee$export$2e2bcd8739ae039,
    sign_in_exp: $5bca57cf73facfdd$export$2e2bcd8739ae039,
    dashboard: $88322544688b1096$export$2e2bcd8739ae039,
    logs: $0bddba092f2bbf5a$export$2e2bcd8739ae039,
    log_details: $893d4c1a9e87d2a3$export$2e2bcd8739ae039,
    session_expired: $8a1622ae65aa6e89$export$2e2bcd8739ae039,
    welcome: $e51eb75481e5e8f9$export$2e2bcd8739ae039,
    roles: $ca63b7c8f6acaf76$export$2e2bcd8739ae039,
    role_details: $37b338a90d6e4ad6$export$2e2bcd8739ae039,
    permissions: $4463d1b252d66cb8$export$2e2bcd8739ae039,
    cloud: $7a49350fa2c30d49$export$2e2bcd8739ae039,
    profile: $d3816325bb4734f6$export$2e2bcd8739ae039,
    components: $e829e127e1641034$export$2e2bcd8739ae039,
    webhooks: $890c708befcd8bcb$export$2e2bcd8739ae039,
    webhook_details: $521a77a60eee48cd$export$2e2bcd8739ae039,
    domain: $eaabd3a0aa77f511$export$2e2bcd8739ae039,
    tenants: $1cffde913488c3ad$export$2e2bcd8739ae039,
    topbar: $7c182e2b1c8201e9$export$2e2bcd8739ae039,
    subscription: $bb9900e107dbb283$export$2e2bcd8739ae039,
    upsell: $7b2464f55c8c8d3e$export$2e2bcd8739ae039,
    guide: $e1ca4323abae6523$export$2e2bcd8739ae039,
    mfa: $f756a901d79eaa7a$export$2e2bcd8739ae039,
    organizations: $6f83374c4b0d2a6c$export$2e2bcd8739ae039,
    organization_details: $ea30cc6fdbc57a68$export$2e2bcd8739ae039
};
var $c3b9a4eb73115768$export$2e2bcd8739ae039 = Object.freeze($c3b9a4eb73115768$var$admin_console);


const $d1b8c5184292ec24$var$demo_app = {
    title: "Sie haben sich erfolgreich bei der Live-Vorschau angemeldet!",
    subtitle: "Hier sind Ihre Anmeldeinformationen:",
    username: "Benutzername: ",
    user_id: "Benutzer ID: ",
    sign_out: "Abmeldung von der Live-Vorschau",
    continue_explore: "Oder weiter zum Entdecken",
    customize_sign_in_experience: "Anmeldeoberfl\xe4che anpassen",
    enable_passwordless: "Passwordless einschalten",
    add_social_connector: "Social Connector hinzuf\xfcgen"
};
var $d1b8c5184292ec24$export$2e2bcd8739ae039 = Object.freeze($d1b8c5184292ec24$var$demo_app);


const $7b8d1d8fd60c7722$var$oidc = {
    logout_success: "Sie haben sich erfolgreich abgemeldet."
};
var $7b8d1d8fd60c7722$export$2e2bcd8739ae039 = Object.freeze($7b8d1d8fd60c7722$var$oidc);


const $2427da822448bf68$var$translation = {
    admin_console: $c3b9a4eb73115768$export$2e2bcd8739ae039,
    demo_app: $d1b8c5184292ec24$export$2e2bcd8739ae039,
    oidc: $7b8d1d8fd60c7722$export$2e2bcd8739ae039
};
var $2427da822448bf68$export$2e2bcd8739ae039 = Object.freeze($2427da822448bf68$var$translation);


const $2863eb1380c8c184$var$de = {
    translation: $2427da822448bf68$export$2e2bcd8739ae039,
    errors: $f8fe8b732c674d9b$export$2e2bcd8739ae039
};
var $2863eb1380c8c184$export$2e2bcd8739ae039 = Object.freeze($2863eb1380c8c184$var$de);


const $9071432f21c0aa34$var$application = {
    invalid_type: "Only machine to machine applications can have associated roles.",
    role_exists: "The role id {{roleId}} is already been added to this application.",
    invalid_role_type: "Can not assign user type role to machine to machine application."
};
var $9071432f21c0aa34$export$2e2bcd8739ae039 = Object.freeze($9071432f21c0aa34$var$application);


const $683bf9c7ac291a32$var$auth = {
    authorization_header_missing: "Authorization header is missing.",
    authorization_token_type_not_supported: "Authorization type is not supported.",
    unauthorized: "Unauthorized. Please check credentials and its scope.",
    forbidden: "Forbidden. Please check your user roles and permissions.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "Missing `sub` in JWT.",
    require_re_authentication: "Re-authentication is required to perform a protected action."
};
var $683bf9c7ac291a32$export$2e2bcd8739ae039 = Object.freeze($683bf9c7ac291a32$var$auth);


const $363134a16f41f777$var$connector = {
    general: "Error occurred in connector: {{errorDescription}}",
    not_found: "Cannot find any available connector for type: {{type}}.",
    not_enabled: "The connector is not enabled.",
    invalid_metadata: "The connector's metadata is invalid.",
    invalid_config_guard: "The connector's config guard is invalid.",
    unexpected_type: "The connector's type is unexpected.",
    invalid_request_parameters: "The request is with wrong input parameter(s).",
    insufficient_request_parameters: "The request might miss some input parameters.",
    invalid_config: "The connector's config is invalid.",
    invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "The connector's response is invalid.",
    template_not_found: "Unable to find correct template in connector config.",
    template_not_supported: "The connector does not support this template type.",
    rate_limit_exceeded: "Trigger rate limit. Please try again later.",
    not_implemented: "{{method}}: has not been implemented yet.",
    social_invalid_access_token: "The connector's access token is invalid.",
    invalid_auth_code: "The connector's auth code is invalid.",
    social_invalid_id_token: "The connector's id token is invalid.",
    authorization_failed: "The user's authorization process is unsuccessful.",
    social_auth_code_invalid: "Unable to get access token, please check authorization code.",
    more_than_one_sms: "The number of SMS connectors is larger then 1.",
    more_than_one_email: "The number of Email connectors is larger then 1.",
    more_than_one_connector_factory: "Found multiple connector factories (with id {{connectorIds}}), you may uninstall unnecessary ones.",
    db_connector_type_mismatch: "There is a connector in the DB that does not match the type.",
    not_found_with_connector_id: "Can not find connector with given standard connector id.",
    multiple_instances_not_supported: "Can not create multiple instance with picked standard connector.",
    invalid_type_for_syncing_profile: "You can only sync user profile with social connectors.",
    can_not_modify_target: "The connector 'target' can not be modified.",
    should_specify_target: "You should specify 'target'.",
    multiple_target_with_same_platform: "You can not have multiple social connectors that have same target and platform.",
    cannot_overwrite_metadata_for_non_standard_connector: "This connector's 'metadata' cannot be overwritten."
};
var $363134a16f41f777$export$2e2bcd8739ae039 = Object.freeze($363134a16f41f777$var$connector);


const $b2051313762d74c9$var$domain = {
    not_configured: "Domain hostname provider is not configured.",
    cloudflare_data_missing: "cloudflare_data is missing, please check.",
    cloudflare_unknown_error: "Got unknown error when requesting Cloudflare API",
    cloudflare_response_error: "Got unexpected response from Cloudflare.",
    limit_to_one_domain: "You can only have one custom domain.",
    hostname_already_exists: "This domain already exists in our server.",
    cloudflare_not_found: "Can not find hostname in Cloudflare"
};
var $b2051313762d74c9$export$2e2bcd8739ae039 = Object.freeze($b2051313762d74c9$var$domain);


const $ff315ec0cd384f48$var$entity = {
    invalid_input: "Invalid input. Value list must not be empty.",
    create_failed: "Failed to create {{name}}.",
    db_constraint_violated: "Database constraint violated.",
    not_exists: "The {{name}} does not exist.",
    not_exists_with_id: "The {{name}} with ID `{{id}}` does not exist.",
    not_found: "The resource does not exist.",
    relation_foreign_key_not_found: "Cannot find one or more foreign keys. Please check the input and ensure that all referenced entities exist.",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $ff315ec0cd384f48$export$2e2bcd8739ae039 = Object.freeze($ff315ec0cd384f48$var$entity);


const $c0d090e29ecd35b2$var$guard = {
    invalid_input: "The request {{type}} is invalid.",
    invalid_pagination: "The request pagination value is invalid.",
    can_not_get_tenant_id: "Unable to get tenant id from request.",
    file_size_exceeded: "File size exceeded.",
    mime_type_not_allowed: "MIME type is not allowed."
};
var $c0d090e29ecd35b2$export$2e2bcd8739ae039 = Object.freeze($c0d090e29ecd35b2$var$guard);


const $e729bed8d726bad0$var$hook = {
    missing_events: "You need to provide at least one event.",
    send_test_payload_failed: "Failed to send test payload: {{message}}",
    endpoint_responded_with_error: "Endpoint responded with error."
};
var $e729bed8d726bad0$export$2e2bcd8739ae039 = Object.freeze($e729bed8d726bad0$var$hook);


const $f1a9b9a7af0644a6$var$localization = {
    cannot_delete_default_language: "{{languageTag}} is set as your default language and can’t be deleted.",
    invalid_translation_structure: "Invalid data schemas. Please check your input and try again."
};
var $f1a9b9a7af0644a6$export$2e2bcd8739ae039 = Object.freeze($f1a9b9a7af0644a6$var$localization);


const $085988bf644666a2$var$log = {
    invalid_type: "The log type is invalid."
};
var $085988bf644666a2$export$2e2bcd8739ae039 = Object.freeze($085988bf644666a2$var$log);


const $9c70a4274f90961e$var$oidc = {
    aborted: "The end-user aborted interaction.",
    invalid_scope: "Invalid scope: {{error_description}}.",
    invalid_token: "Invalid token provided.",
    invalid_client_metadata: "Invalid client metadata provided.",
    insufficient_scope: "Token missing scope `{{scope}}`.",
    invalid_request: "Request is invalid.",
    invalid_grant: "Grant request is invalid.",
    invalid_redirect_uri: "`redirect_uri` did not match any of the client's registered `redirect_uris`.",
    access_denied: "Access denied.",
    invalid_target: "Invalid resource indicator.",
    unsupported_grant_type: "Unsupported `grant_type` requested.",
    unsupported_response_mode: "Unsupported `response_mode` requested.",
    unsupported_response_type: "Unsupported `response_type` requested.",
    /** @deprecated Use {@link oidc.server_error} or {@link oidc.provider_error_fallback} instead. */ provider_error: "OIDC Internal Error: {{message}}.",
    server_error: "An unknown OIDC error occurred. Please try again later.",
    provider_error_fallback: "An OIDC error occurred: {{code}}.",
    key_required: "At least one key is required.",
    key_not_found: "Key with ID {{id}} is not found."
};
var $9c70a4274f90961e$export$2e2bcd8739ae039 = Object.freeze($9c70a4274f90961e$var$oidc);


const $8c2e58a64cc52bbc$var$organizations = {
    require_membership: "The user must be a member of the organization to proceed."
};
var $8c2e58a64cc52bbc$export$2e2bcd8739ae039 = Object.freeze($8c2e58a64cc52bbc$var$organizations);


const $e5fea938ff0ab058$var$password = {
    unsupported_encryption_method: "The encryption method {{name}} is not supported.",
    pepper_not_found: "Password pepper not found. Please check your core envs.",
    rejected: "Password rejected. Please check if your password meets the requirements."
};
var $e5fea938ff0ab058$export$2e2bcd8739ae039 = Object.freeze($e5fea938ff0ab058$var$password);


const $2a02db940e06c9ab$var$request = {
    invalid_input: "Input is invalid. {{details}}",
    general: "Request error occurred."
};
var $2a02db940e06c9ab$export$2e2bcd8739ae039 = Object.freeze($2a02db940e06c9ab$var$request);


const $6d421495b169e25c$var$resource = {
    resource_identifier_in_use: "The API identifier {{indicator}} is already in use"
};
var $6d421495b169e25c$export$2e2bcd8739ae039 = Object.freeze($6d421495b169e25c$var$resource);


const $0bbfd40fd61ecd10$var$role = {
    name_in_use: "This role name {{name}} is already in use",
    scope_exists: "The scope id {{scopeId}} has already been added to this role",
    user_exists: "The user id {{userId}} is already been added to this role",
    application_exists: "The application id {{applicationId}} is already been added to this role",
    default_role_missing: "Some of the default roleNames does not exist in database, please ensure to create roles first",
    internal_role_violation: 'You may be trying to update or delete an internal role which is forbidden by Logto. If you are creating a new role, try another name that does not start with "#internal:".'
};
var $0bbfd40fd61ecd10$export$2e2bcd8739ae039 = Object.freeze($0bbfd40fd61ecd10$var$role);


const $41a24aab6fe4955e$var$scope = {
    name_exists: "The scope name {{name}} is already in use",
    name_with_space: "The name of the scope cannot contain any spaces."
};
var $41a24aab6fe4955e$export$2e2bcd8739ae039 = Object.freeze($41a24aab6fe4955e$var$scope);


const $35582f383a89f4cb$var$session = {
    not_found: "Session not found. Please go back and sign in again.",
    invalid_credentials: "Incorrect account or password. Please check your input.",
    invalid_sign_in_method: "Current sign-in method is not available.",
    invalid_connector_id: "Unable to find available connector with id {{connectorId}}.",
    insufficient_info: "Insufficient sign-in info.",
    connector_id_mismatch: "The connectorId is mismatched with session record.",
    connector_session_not_found: "Connector session not found. Please go back and sign in again.",
    verification_session_not_found: "The verification was not successful. Restart the verification flow and try again.",
    verification_expired: "The connection has timed out. Verify again to ensure your account safety.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "Please sign in first.",
    unsupported_prompt_name: "Unsupported prompt name.",
    forgot_password_not_enabled: "Forgot password is not enabled.",
    verification_failed: "The verification was not successful. Restart the verification flow and try again.",
    connector_validation_session_not_found: "The connector session for token validation is not found.",
    identifier_not_found: "User identifier not found. Please go back and sign in again.",
    interaction_not_found: "Interaction session not found. Please go back and start the session again.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "Single sign on is enabled for this given email. Please sign in with SSO."
};
var $35582f383a89f4cb$export$2e2bcd8739ae039 = Object.freeze($35582f383a89f4cb$var$session);


const $6298a41d490f5259$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Empty "Terms of use" content URL. Please add the content URL if "Terms of use" is enabled.',
    empty_social_connectors: "Empty social connectors. Please add enabled social connectors when the social sign-in method is enabled.",
    enabled_connector_not_found: "Enabled {{type}} connector not found.",
    not_one_and_only_one_primary_sign_in_method: "There must be one and only one primary sign-in method. Please check your input.",
    username_requires_password: "Must enable set a password for username sign up identifier.",
    passwordless_requires_verify: "Must enable verify for email/phone sign up identifier.",
    miss_sign_up_identifier_in_sign_in: "Sign in methods must contain the sign up identifier.",
    password_sign_in_must_be_enabled: "Password sign in must be enabled when set a password is required in sign up.",
    code_sign_in_must_be_enabled: "Verification code sign in must be enabled when set a password is not required in sign up.",
    unsupported_default_language: "This language - {{language}} is not supported at the moment.",
    at_least_one_authentication_factor: "You have to select at least one authentication factor.",
    backup_code_cannot_be_enabled_alone: "Backup code cannot be enabled alone.",
    duplicated_mfa_factors: "Duplicated MFA factors."
};
var $6298a41d490f5259$export$2e2bcd8739ae039 = Object.freeze($6298a41d490f5259$var$sign_in_experiences);


const $e163676a94fc10a7$var$single_sign_on = {
    forbidden_domains: "Public email domains are not allowed.",
    duplicated_domains: "There are duplicate domains.",
    invalid_domain_format: "Invalid domain format.",
    duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $e163676a94fc10a7$export$2e2bcd8739ae039 = Object.freeze($e163676a94fc10a7$var$single_sign_on);


const $65a837b388630988$var$storage = {
    not_configured: "Storage provider is not configured.",
    missing_parameter: "Missing parameter {{parameter}} for storage provider.",
    upload_error: "Failed to upload file to the storage provider."
};
var $65a837b388630988$export$2e2bcd8739ae039 = Object.freeze($65a837b388630988$var$storage);


const $2870fd343fa681fe$var$subscription = {
    limit_exceeded: "You have reached the limit of your subscription plan.",
    get_plan_failed: "Unable to get subscription plan for tenant.",
    tenant_suspended: "Tenant is suspended. Please contact your administrator."
};
var $2870fd343fa681fe$export$2e2bcd8739ae039 = Object.freeze($2870fd343fa681fe$var$subscription);


const $1238ed6d42f2486d$var$swagger = {
    invalid_zod_type: "Invalid Zod type. Please check route guard config.",
    not_supported_zod_type_for_params: "Not supported Zod type for the parameters. Please check route guard config."
};
var $1238ed6d42f2486d$export$2e2bcd8739ae039 = Object.freeze($1238ed6d42f2486d$var$swagger);


const $dfa1092cd613cb10$var$user = {
    username_already_in_use: "This username is already in use.",
    email_already_in_use: "This email is associated with an existing account.",
    phone_already_in_use: "This phone number is associated with an existing account.",
    invalid_email: "Invalid email address.",
    invalid_phone: "Invalid phone number.",
    email_not_exist: "The email address has not been registered yet.",
    phone_not_exist: "The phone number has not been registered yet.",
    identity_not_exist: "The social account has not been registered yet.",
    identity_already_in_use: "The social account has been associated with an existing account.",
    social_account_exists_in_profile: "You have already associated this social account.",
    cannot_delete_self: "You cannot delete yourself.",
    sign_up_method_not_enabled: "This sign-up method is not enabled.",
    sign_in_method_not_enabled: "This sign-in method is not enabled.",
    same_password: "New password cannot be the same as your old password.",
    password_required_in_profile: "You need to set a password before signing-in.",
    new_password_required_in_profile: "You need to set a new password.",
    password_exists_in_profile: "Password already exists in your profile.",
    username_required_in_profile: "You need to set a username before signing-in.",
    username_exists_in_profile: "Username already exists in your profile.",
    email_required_in_profile: "You need to add an email address before signing-in.",
    email_exists_in_profile: "Your profile has already associated with an email address.",
    phone_required_in_profile: "You need to add a phone number before signing-in.",
    phone_exists_in_profile: "Your profile has already associated with a phone number.",
    email_or_phone_required_in_profile: "You need to add an email address or phone number before signing-in.",
    suspended: "This account is suspended.",
    user_not_exist: "User with {{ identifier }} does not exist.",
    missing_profile: "You need to provide additional info before signing-in.",
    role_exists: "The role id {{roleId}} is already been added to this user",
    invalid_role_type: "Invalid role type, can not assign machine-to-machine role to user.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $dfa1092cd613cb10$export$2e2bcd8739ae039 = Object.freeze($dfa1092cd613cb10$var$user);


const $3b482d2c9b22efe6$var$verification_code = {
    phone_email_empty: "Both phone and email are empty.",
    not_found: "Verification code not found. Please send verification code first.",
    phone_mismatch: "Phone mismatch. Please request a new verification code.",
    email_mismatch: "Email mismatch. Please request a new verification code.",
    code_mismatch: "Invalid verification code.",
    expired: "Verification code has expired. Please request a new verification code.",
    exceed_max_try: "Verification code retries limitation exceeded. Please request a new verification code."
};
var $3b482d2c9b22efe6$export$2e2bcd8739ae039 = Object.freeze($3b482d2c9b22efe6$var$verification_code);


const $9ad6ab3b50abfbd8$var$errors = {
    request: $2a02db940e06c9ab$export$2e2bcd8739ae039,
    auth: $683bf9c7ac291a32$export$2e2bcd8739ae039,
    guard: $c0d090e29ecd35b2$export$2e2bcd8739ae039,
    oidc: $9c70a4274f90961e$export$2e2bcd8739ae039,
    user: $dfa1092cd613cb10$export$2e2bcd8739ae039,
    password: $e5fea938ff0ab058$export$2e2bcd8739ae039,
    session: $35582f383a89f4cb$export$2e2bcd8739ae039,
    connector: $363134a16f41f777$export$2e2bcd8739ae039,
    verification_code: $3b482d2c9b22efe6$export$2e2bcd8739ae039,
    sign_in_experiences: $6298a41d490f5259$export$2e2bcd8739ae039,
    localization: $f1a9b9a7af0644a6$export$2e2bcd8739ae039,
    swagger: $1238ed6d42f2486d$export$2e2bcd8739ae039,
    entity: $ff315ec0cd384f48$export$2e2bcd8739ae039,
    log: $085988bf644666a2$export$2e2bcd8739ae039,
    role: $0bbfd40fd61ecd10$export$2e2bcd8739ae039,
    scope: $41a24aab6fe4955e$export$2e2bcd8739ae039,
    storage: $65a837b388630988$export$2e2bcd8739ae039,
    resource: $6d421495b169e25c$export$2e2bcd8739ae039,
    hook: $e729bed8d726bad0$export$2e2bcd8739ae039,
    domain: $b2051313762d74c9$export$2e2bcd8739ae039,
    subscription: $2870fd343fa681fe$export$2e2bcd8739ae039,
    application: $9071432f21c0aa34$export$2e2bcd8739ae039,
    organization: $8c2e58a64cc52bbc$export$2e2bcd8739ae039,
    single_sign_on: $e163676a94fc10a7$export$2e2bcd8739ae039
};
var $9ad6ab3b50abfbd8$export$2e2bcd8739ae039 = Object.freeze($9ad6ab3b50abfbd8$var$errors);


const $f760eb43ac49093f$var$api_resource_details = {
    page_title: "API resource details",
    back_to_api_resources: "Back to API resources",
    settings_tab: "Settings",
    permissions_tab: "Permissions",
    settings: "Settings",
    settings_description: "API resources, a.k.a. Resource Indicators, indicate the target services or resources to be requested, usually, a URI format variable representing the resource‘s identity.",
    management_api_settings_description: "The Logto Management API is a comprehensive collection of APIs that empower administrators to manage a wide range of identity-related tasks, enforce security policies, and comply with regulations and standards.",
    management_api_notice: "This API represents Logto entity and cannot be modified or deleted. You can use management API for a wide range of identity related tasks. <a>Learn more</a>",
    token_expiration_time_in_seconds: "Token expiration time (in seconds)",
    token_expiration_time_in_seconds_placeholder: "Enter your token expiration time",
    delete_description: "This action cannot be undone. It will permanently delete the API resource. Please enter the api resource name <span>{{name}}</span> to confirm.",
    enter_your_api_resource_name: "Enter your API resource name",
    api_resource_deleted: "The API resource {{name}} has been successfully deleted",
    permission: {
        create_button: "Create permission",
        create_title: "Create permission",
        create_subtitle: "Define the permissions (scopes) needed by this API.",
        confirm_create: "Create permission",
        name: "Permission name",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "The permission name must not contain any spaces.",
        description: "Description",
        description_placeholder: "Able to read the resources",
        permission_created: "The permission {{name}} has been successfully created",
        delete_description: "If this permission is deleted, the user who had this permission will lose the access granted by it.",
        deleted: 'The permission "{{name}}" was successfully deleted.'
    }
};
var $f760eb43ac49093f$export$2e2bcd8739ae039 = Object.freeze($f760eb43ac49093f$var$api_resource_details);


const $091a987284e983bc$var$api_resources = {
    page_title: "API resources",
    title: "API resources",
    subtitle: "Define APIs that your authorized applications can utilize",
    create: "Create API resource",
    api_name: "API name",
    api_name_placeholder: "Enter your API name",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "The unique identifier to the API resource. It must be an absolute URI and has no fragment (#) component. Equals to the <a>resource parameter</a> in OAuth 2.0.",
    default_api: "Default API",
    default_api_label: "Only zero or one default API can be set per tenant.\nWhen a default API is designated, the resource parameter can be omitted in the auth request. Subsequent token exchanges will use that API as the audience by default, resulting in the issuance of JWTs. <a>Learn more</a>",
    api_resource_created: "The API resource {{name}} has been successfully created"
};
var $091a987284e983bc$export$2e2bcd8739ae039 = Object.freeze($091a987284e983bc$var$api_resources);


const $933af3cae54c125d$var$application_details = {
    page_title: "Application details",
    back_to_applications: "Back to applications",
    check_guide: "Check guide",
    settings: "Settings",
    settings_description: "Applications are used to identify your applications in Logto for OIDC, sign-in experience, audit logs, etc.",
    advanced_settings: "Advanced settings",
    advanced_settings_description: "Advanced settings include OIDC related terms. You can check out the Token Endpoint for more information.",
    application_roles: "Roles",
    machine_logs: "Machine logs",
    application_name: "Application name",
    application_name_placeholder: "My App",
    description: "Description",
    description_placeholder: "Enter your application description",
    config_endpoint: "OpenID Provider configuration endpoint",
    authorization_endpoint: "Authorization Endpoint",
    authorization_endpoint_tip: "The endpoint to perform authentication and authorization. It's used for OpenID Connect <a>Authentication</a>.",
    logto_endpoint: "Logto endpoint",
    application_id: "App ID",
    application_id_tip: "The unique application identifier normally generated by Logto. It also stands for “<a>client_id</a>” in OpenID Connect.",
    application_secret: "App Secret",
    redirect_uri: "Redirect URI",
    redirect_uris: "Redirect URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "The URI redirects after a user sign-in (whether successful or not). See OpenID Connect <a>AuthRequest</a> for more info.",
    post_sign_out_redirect_uri: "Post Sign-out Redirect URI",
    post_sign_out_redirect_uris: "Post Sign-out Redirect URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "The URI redirects after a user sign-out (optional). It may have no practical effect in some app types.",
    cors_allowed_origins: "CORS allowed origins",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "By default, all the origins of Redirect URIs will be allowed. Usually no action is required for this field. See the <a>MDN doc</a> for detailed info.",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "Userinfo Endpoint",
    enable_admin_access: "Enable admin access",
    enable_admin_access_label: "Enable or disable the access to Management API. Once enabled, you can use access tokens to call Management API on behalf on this application.",
    always_issue_refresh_token: "Always issue Refresh Token",
    always_issue_refresh_token_label: "When enabled, Logto will always issue Refresh Tokens, regardless of whether `prompt=consent` is presented in the authentication request. However, this practice is discouraged unless necessary, as it is not compatible with OpenID Connect and may potentially cause issues.",
    refresh_token_ttl: "Refresh Token Time to Live (TTL) in days",
    refresh_token_ttl_tip: "The duration for which a Refresh Token can be used to request new access tokens before it expires and becomes invalid. Token requests will extend the TTL of the Refresh Token to this value.",
    rotate_refresh_token: "Rotate Refresh Token",
    rotate_refresh_token_label: "When enabled, Logto will issue a new Refresh Token for token requests when 70% of the original Time to Live (TTL) has passed or certain conditions are met. <a>Learn more</a>",
    delete_description: "This action cannot be undone. It will permanently delete the application. Please enter the application name <span>{{name}}</span> to confirm.",
    enter_your_application_name: "Enter your application name",
    application_deleted: "Application {{name}} has been successfully deleted",
    redirect_uri_required: "You must enter at least one redirect URI",
    roles: {
        name_column: "Role",
        description_column: "Description",
        assign_button: "Assign roles",
        delete_description: "This action will remove this role from this machine-to-machine app. The role itself will still exist, but it will no longer be associated with this machine-to-machine app.",
        deleted: "{{name}} was successfully removed from this user.",
        assign_title: "Assign roles to {{name}}",
        assign_subtitle: "Authorize {{name}} one or more roles",
        assign_role_field: "Assign roles",
        role_search_placeholder: "Search by role name",
        added_text: "{{value, number}} added",
        assigned_app_count: "{{value, number}} applications",
        confirm_assign: "Assign roles",
        role_assigned: "Successfully assigned role(s)",
        search: "Search by role name, description or ID",
        empty: "No role available"
    }
};
var $933af3cae54c125d$export$2e2bcd8739ae039 = Object.freeze($933af3cae54c125d$var$application_details);


const $faf013916162b710$var$applications = {
    page_title: "Applications",
    title: "Applications",
    subtitle: "Set up Logto authentication for your native, single page, machine to machine, or traditional application",
    subtitle_with_app_type: "Set up Logto authentication for your {{name}} application",
    create: "Create application",
    application_name: "Application name",
    application_name_placeholder: "My App",
    application_description: "Application description",
    application_description_placeholder: "Enter your application description",
    select_application_type: "Select an application type",
    no_application_type_selected: "You haven’t selected any application type yet",
    application_created: "Application created successfully.",
    app_id: "App ID",
    type: {
        native: {
            title: "Native App",
            subtitle: "An app that runs in a native environment",
            description: "E.g., iOS app, Android app"
        },
        spa: {
            title: "Single Page App",
            subtitle: "An app that runs in a web browser and dynamically updates data in place",
            description: "E.g., React DOM app, Vue app"
        },
        traditional: {
            title: "Traditional Web",
            subtitle: "An app that renders and updates pages by the web server alone",
            description: "E.g., Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "An app (usually a service) that directly talks to resources",
            description: "E.g., Backend service"
        }
    },
    placeholder_title: "Select an application type to continue",
    placeholder_description: "Logto uses an application entity for OIDC to help with tasks such as identifying your apps, managing sign-in, and creating audit logs."
};
var $faf013916162b710$export$2e2bcd8739ae039 = Object.freeze($faf013916162b710$var$applications);


const $31a3d3e3594de50c$var$cloud = {
    general: {
        onboarding: "Onboarding"
    },
    welcome: {
        page_title: "Welcome",
        title: "Welcome to Logto Cloud! We'd love to learn a bit about you.",
        description: "Let‘s make your Logto experience unique to you by getting to know you better. Your information is safe with us.",
        project_field: "I’m using Logto for",
        project_options: {
            personal: "Personal project",
            company: "Company project"
        },
        title_field: "Select applicable title(s)",
        title_options: {
            developer: "Developer",
            team_lead: "Team Lead",
            ceo: "CEO",
            cto: "CTO",
            product: "Product",
            others: "Others"
        },
        company_name_field: "Company name",
        company_name_placeholder: "Acme.co",
        company_size_field: "How’s your company size?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "I’m signing up because",
        reason_options: {
            passwordless: "Finding passwordless authentication and UI kit",
            efficiency: "Finding out-of-the-box identity infrastructure",
            access_control: "Controlling user access based on roles and responsibilities",
            multi_tenancy: "Seeking strategies for a multi-tenancy product",
            enterprise: "Finding SSO solutions for enterprise readiness",
            others: "Others"
        }
    },
    sie: {
        page_title: "Customize sign-in experience",
        title: "Let’s first customize your sign-in experience with ease",
        inspire: {
            title: "Create compelling examples",
            description: 'Feeling unsure about sign in experience? Just click the "Inspire Me" and let the magic happen!',
            inspire_me: "Inspire me"
        },
        logo_field: "App Logo",
        color_field: "Brand color",
        identifier_field: "Identifier",
        identifier_options: {
            email: "Email",
            phone: "Phone",
            user_name: "Username"
        },
        authn_field: "Authentication",
        authn_options: {
            password: "Password",
            verification_code: "Verification code"
        },
        social_field: "Social sign in",
        finish_and_done: "Finish and done",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Unlocked later",
            unlocked_later_tip: "Once you have completed the onboarding process and entered the product, you will have access to even more social sign-in methods.",
            notice: "Please avoid using the demo connector for production purposes. Once you’ve completed testing, kindly delete the demo connector and set up your own connector with your credentials."
        }
    },
    socialCallback: {
        title: "You've successfully signed in",
        description: "You have successfully signed in using your social account. To ensure seamless integration and access to all the features of Logto, we recommend that you proceed to configure your own social connector."
    },
    tenant: {
        create_tenant: "Create tenant"
    }
};
var $31a3d3e3594de50c$export$2e2bcd8739ae039 = Object.freeze($31a3d3e3594de50c$var$cloud);


const $88b3f4545724b997$var$components = {
    uploader: {
        action_description: "Drag and drop or browse",
        uploading: "Uploading...",
        image_limit: "Upload image under {{size, number}}KB, {{extensions, list(style: narrow; type: conjunction;)}} only.",
        error_upload: "Something went wrong. File upload failed.",
        error_file_size: "File size is too large. Please upload a file under {{size, number}}KB.",
        error_file_type: "File type is not supported. {{extensions, list(style: narrow; type: conjunction;)}} only.",
        error_file_count: "You can only upload 1 file."
    }
};
var $88b3f4545724b997$export$2e2bcd8739ae039 = Object.freeze($88b3f4545724b997$var$components);


const $a35589b0c8601b6b$var$connector_details = {
    page_title: "Connector details",
    back_to_connectors: "Back to connectors",
    check_readme: "Check README",
    settings: "General settings",
    settings_description: "Connectors play a critical role in Logto. With their help, Logto enables end-users to use passwordless registration or sign-in and the capabilities of signing in with social accounts.",
    parameter_configuration: "Parameter configuration",
    test_connection: "Test",
    save_error_empty_config: "Please enter config",
    send: "Send",
    send_error_invalid_format: "Invalid input",
    edit_config_label: "Enter your JSON here",
    test_email_sender: "Test your email connector",
    test_sms_sender: "Test your SMS connector",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Test message sent",
    test_sender_description: 'Logto uses the "Generic" template for testing. You will receive a message if your connector is rightly configured.',
    options_change_email: "Change email connector",
    options_change_sms: "Change SMS connector",
    connector_deleted: "The connector has been successfully deleted",
    type_email: "Email connector",
    type_sms: "SMS connector",
    type_social: "Social connector",
    in_used_social_deletion_description: "This connector is in-use in your sign in experience. By deleting, <name/> sign in experience will be deleted in sign in experience settings. You will need to reconfigure it if you decide to add it back.",
    in_used_passwordless_deletion_description: "This {{name}} is in-use in your sign-in experience. By deleting, your sign-in experience will not work properly until you resolve the conflict. You will need to reconfigure it if you decide to add it back.",
    deletion_description: "You are removing this connector. It cannot be undone, and you will need to reconfigure it if you decide to add it back.",
    logto_email: {
        total_email_sent: "Total email sent: {{value, number}}",
        total_email_sent_tip: "Logto utilizes SendGrid for secure and stable built-in email. It’s completely free to use. <a>Learn more</a>",
        email_template_title: "Email Template",
        template_description: "Built-in email uses default templates for seamless delivery of verification emails. No configuration is required, and you can customize basic brand information.",
        template_description_link_text: "View templates",
        description_action_text: "View templates",
        from_email_field: "From email",
        sender_name_field: "Sender name",
        sender_name_tip: 'Customize the sender name for emails. If left empty, "Verification" will be used as the default name.',
        sender_name_placeholder: "Your sender name",
        company_information_field: "Company information",
        company_information_description: "Display your company name, address, or zip code in the bottom of emails to enhance authenticity.",
        company_information_placeholder: "Your company's basic information",
        app_logo_field: "App Logo",
        app_logo_tip: "Display your brand logo in the top of emails. Use the same image for both light mode and dark mode.",
        urls_not_allowed: "URLs are not allowed",
        test_notes: "Logto uses the “Generic” template for testing."
    }
};
var $a35589b0c8601b6b$export$2e2bcd8739ae039 = Object.freeze($a35589b0c8601b6b$var$connector_details);


const $f8b6937bb1831367$var$connectors = {
    page_title: "Connectors",
    title: "Connectors",
    subtitle: "Set up connectors to enable passwordless and social sign in experience",
    create: "Add Social Connector",
    config_sie_notice: "You’ve set up connectors. Make sure to configure it in <a>{{link}}</a>.",
    config_sie_link_text: "sign in experience",
    tab_email_sms: "Email and SMS connectors",
    tab_social: "Social connectors",
    connector_name: "Connector name",
    demo_tip: "The maximum number of messages allowed for this demo connector is limited to 100 and is not recommended for deployment in a production environment.",
    social_demo_tip: "The demo connector is designed exclusively for demonstration purposes and is not recommended for deployment in a production environment.",
    connector_type: "Type",
    connector_status: "Sign in Experience",
    connector_status_in_use: "In use",
    connector_status_not_in_use: "Not in use",
    not_in_use_tip: {
        content: "Not in use means your sign in experience hasn’t used this sign in method. <a>{{link}}</a> to add this sign in method. ",
        go_to_sie: "Go to sign in experience"
    },
    placeholder_title: "Social connector",
    placeholder_description: "Logto has provided many widely used social sign-in connectors meantime you can create your own with standard protocols.",
    save_and_done: "Save and Done",
    type: {
        email: "Email connector",
        sms: "SMS connector",
        social: "Social connector"
    },
    setup_title: {
        email: "Set up email connector",
        sms: "Set up SMS connector",
        social: "Add Social Connector"
    },
    guide: {
        subtitle: "A step by step guide to configure your connector",
        general_setting: "General settings",
        parameter_configuration: "Parameter configuration",
        test_connection: "Test connection",
        name: "Name for social sign-in button",
        name_placeholder: "Enter name for social sign-in button",
        name_tip: 'The name of the connector button will be displayed as "Continue with {{name}}." Be mindful of the length of the naming in case it gets too long.',
        logo: "Logo URL for social sign-in button",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Logo image will show on the connector. Get a publicly accessible image link and insert the link here.",
        logo_dark: "Logo URL for social sign-in button (Dark mode)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Set your connector’s logo for dark mode after enabling it in the sign-in experience.",
        logo_dark_collapse: "Collapse",
        logo_dark_show: "Show logo setting for dark mode",
        target: "Identity provider name",
        target_placeholder: "Enter connector identity provider name",
        target_tip: "The value of “IdP name” can be a unique identifier string to distinguish your social identifies.",
        target_tip_standard: "The value of “IdP name” can be a unique identifier string to distinguish your social identifies. This setting cannot be changed after the connector is built.",
        target_tooltip: '"IdP name" in Logto social connectors refers to the "source" of your social identities. In Logto design, we do not accept the same "IdP name" of a specific platform to avoid conflicts. You should be very careful before you add a connector since you CAN NOT change its value once you create it. <a>Learn more</a>',
        target_conflict: "The IdP name entered matches the existing <span>name</span> connector. Using the same idp name may cause unexpected sign-in behavior where users may access the same account through two different connectors.",
        target_conflict_line2: 'If you\'d like to replace the current connector with the same identity provider and allow previous users to sign in without registering again, please delete the <span>name</span> connector and create a new one with the same "IdP name".',
        target_conflict_line3: 'If you\'d like to connect to a different identity provider, please modify the "IdP name" and proceed.',
        config: "Enter your config JSON",
        sync_profile: "Sync profile information",
        sync_profile_only_at_sign_up: "Only sync at sign-up",
        sync_profile_each_sign_in: "Always do a sync at each sign-in",
        sync_profile_tip: "Sync the basic profile from the social provider, such as users' names and their avatars.",
        callback_uri: "Callback URI",
        callback_uri_description: "Also called redirect URI, is the URI in Logto where users will be sent back after social authorization, copy and paste to the social provider's config page."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: " supports multiple platform, select a platform to continue",
    drawer_title: "Connector Guide",
    drawer_subtitle: "Follow the instructions to integrate your connector",
    unknown: "Unknown Connector",
    standard_connectors: "Standard connectors"
};
var $f8b6937bb1831367$export$2e2bcd8739ae039 = Object.freeze($f8b6937bb1831367$var$connectors);


const $efe5e5a2a751301d$var$contact = {
    title: "Get help",
    description: "For help requests or product feedback, please contact us through the following methods.",
    discord: {
        title: "Join Discord community",
        description: "Connect with other developers to find solutions",
        button: "Join"
    },
    github: {
        title: "Communicate on GitHub",
        description: "Create an issue and submit at GitHub",
        button: "Open"
    },
    email: {
        title: "Contact support via email",
        description: "Send us an email for further information and help",
        button: "Send"
    },
    reserve: {
        title: "Reserve your time with Logto team",
        description: "Quickly book a session for a live chat",
        button: "Book"
    }
};
var $efe5e5a2a751301d$export$2e2bcd8739ae039 = Object.freeze($efe5e5a2a751301d$var$contact);


const $bf974927c465f55b$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Get an overview about your app performance",
    total_users: "Total users",
    total_users_tip: "Total users",
    new_users_today: "New users today",
    new_users_today_tip: "The number of new users registered on your apps today",
    new_users_7_days: "New users past 7 days",
    new_users_7_days_tip: "The number of new users registered on your apps in the past 7 days",
    daily_active_users: "Daily active users",
    daily_active_users_tip: "The number of unique users exchanged tokens on your apps today",
    weekly_active_users: "Weekly active users",
    weekly_active_users_tip: "The number of unique users exchanged tokens on your apps in the past 7 days",
    monthly_active_users: "Monthly active users",
    monthly_active_users_tip: "The number of unique users exchanged tokens on your apps in the past 30 days"
};
var $bf974927c465f55b$export$2e2bcd8739ae039 = Object.freeze($bf974927c465f55b$var$dashboard);


const $6bab07fe1fdbb89f$var$domain = {
    status: {
        connecting: "Connecting",
        in_used: "In use",
        failed_to_connect: "Failed to connect"
    },
    update_endpoint_notice: "Don’t forget to update the domain for the Social connector callback URI and Logto endpoint in your application if you want to use a custom domain for the features. <a>{{link}}</a>",
    error_hint: "Make sure to update your DNS records. We will continue to check every {{value}} seconds.",
    custom: {
        custom_domain: "Custom Domain",
        custom_domain_description: "Improve your branding by utilizing a custom domain. This domain will be used in your sign-in experience.",
        custom_domain_field: "Custom domain",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "Add domain",
        invalid_domain_format: "Invalid subdomain format. Please enter a subdomain with at least three parts.",
        verify_domain: "Verify domain",
        enable_ssl: "Enable SSL",
        checking_dns_tip: "After you configuring the DNS records, the process will run automatically and may take up to 24 hours. You can leave this interface while it’s running.",
        enable_ssl_tip: "Enable SSL will run automatically and may take up to 24 hours. You can leave this interface while it’s running.",
        generating_dns_records: "Generating the DNS records...",
        add_dns_records: "Please add these DNS records to your DNS provider.",
        dns_table: {
            type_field: "Type",
            name_field: "Name",
            value_field: "Value"
        },
        deletion: {
            delete_domain: "Delete domain",
            reminder: "Delete custom domain",
            description: "Are you sure you want to delete this custom domain?",
            in_used_description: 'Are you sure you want to delete this custom domain "<span>{{domain}}</span>"?',
            in_used_tip: 'If you’ve set up this custom domain in your social connector provider or application endpoint before, you’ll need to modify the URI to the Logto default domain "<span>{{domain}}</span>" first. This is necessary for the social sign-in button to work properly.',
            deleted: "Delete custom domain successfully!"
        }
    },
    default: {
        default_domain: "Default domain",
        default_domain_description: "Logto offers a pre-configured default domain, ready to use without any additional setup. This default domain serves as a backup option even if you enabled a custom domain.",
        default_domain_field: "Logto default domain"
    },
    custom_endpoint_note: 'You can customize the domain name of these endpoints as your required. Choose either "{{custom}}" or "{{default}}".',
    custom_social_callback_url_note: 'You can customize the domain name of this URI to match your application’s endpoint. Choose either "{{custom}}" or "{{default}}".'
};
var $6bab07fe1fdbb89f$export$2e2bcd8739ae039 = Object.freeze($6bab07fe1fdbb89f$var$domain);


const $081d095a394cb948$var$enterprise_sso_details = {
    back_to_sso_connectors: "Back to enterprise SSO",
    page_title: "Enterprise SSO connector details",
    readme_drawer_title: "Enterprise SSO",
    readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    tab_experience: "SSO Experience",
    tab_connection: "Connection",
    general_settings_title: "General",
    custom_branding_title: "Display",
    custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    email_domain_field_name: "Enterprise email domain",
    email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    email_domain_field_placeholder: "Email domain",
    sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        register_only: "Only sync at first sign-in",
        each_sign_in: "Always sync at each sign-in"
    },
    connector_name_field_name: "Connector name",
    display_name_field_name: "Display name",
    connector_logo_field_name: "Display logo",
    connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    branding_logo_context: "Upload logo",
    branding_logo_error: "Upload logo error: {{error}}",
    branding_light_logo_context: "Upload light mode logo",
    branding_light_logo_error: "Upload light mode logo error: {{error}}",
    branding_logo_field_name: "Logo",
    branding_logo_field_placeholder: "https://your.domain/logo.png",
    branding_dark_logo_context: "Upload dark mode logo",
    branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    branding_dark_logo_field_name: "Logo (dark mode)",
    branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    check_connection_guide: "Connection guide",
    enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    delete_confirm_modal_title: "Delete enterprise SSO connector",
    delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    upload_idp_metadata_title_saml: "Upload the metadata",
    upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    upload_idp_metadata_title_oidc: "Upload the credentials",
    upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    upload_idp_metadata_button_text: "Upload metadata XML file",
    upload_signing_certificate_button_text: "Upload signing certificate file",
    configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    service_provider_property_title: "Configure in the IdP",
    service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    attribute_mapping_title: "Attribute mappings",
    attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        sign_on_url: "Sign on URL",
        entity_id: "Issuer",
        x509_certificate: "Signing certificate",
        certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        authorization_endpoint: "Authorization endpoint",
        token_endpoint: "Token endpoint",
        userinfo_endpoint: "User information endpoint",
        jwks_uri: "JSON web key set endpoint",
        issuer: "Issuer"
    }
};
var $081d095a394cb948$export$2e2bcd8739ae039 = Object.freeze($081d095a394cb948$var$enterprise_sso_details);


const $c5d96846aa224802$var$enterprise_sso = {
    page_title: "Enterprise SSO",
    title: "Enterprise SSO",
    subtitle: "Connect the enterprise identity provider and enable SP-initiated Single Sign-On.",
    create: "Add enterprise connector",
    col_connector_name: "Connector name",
    col_type: "Type",
    col_email_domain: "Email domain",
    placeholder_title: "Enterprise connector",
    placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Add enterprise connector",
        text_divider: "Or you can customize your connector by a standard protocol.",
        connector_name_field_title: "Connector name",
        connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Create connector"
    },
    guide: {
        subtitle: "A step by step guide to connect the enterprise identity provider.",
        finish_button_text: "Continue"
    },
    basic_info: {
        title: "Configure your service in the IdP",
        description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        title: "Attribute mappings",
        description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        col_sp_claims: "Value of service provider (Logto)",
        col_idp_claims: "Claim name of identity provider",
        idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        title: "Configure the IdP metadata",
        description: "Configure the metadata from the identity provider",
        dropdown_trigger_text: "Use another configuration method",
        dropdown_title: "select your configuration method",
        metadata_format_url: "Enter the metadata URL",
        metadata_format_xml: "Upload the metadata XML file",
        metadata_format_manual: "Enter metadata details manually",
        saml: {
            metadata_url_field_name: "Metadata URL",
            metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            metadata_xml_field_name: "IdP metadata XML file",
            metadata_xml_uploader_text: "Upload metadata XML file",
            sign_in_endpoint_field_name: "Sign on URL",
            idp_entity_id_field_name: "IdP entity ID (Issuer)",
            certificate_field_name: "Signing certificate",
            certificate_placeholder: "Copy and paste the x509 certificate",
            certificate_required: "Signing certificate is required."
        },
        oidc: {
            client_id_field_name: "Client ID",
            client_secret_field_name: "Client secret",
            issuer_field_name: "Issuer",
            scope_field_name: "Scope"
        }
    }
};
var $c5d96846aa224802$export$2e2bcd8739ae039 = Object.freeze($c5d96846aa224802$var$enterprise_sso);


const $40578e457ba25d7d$var$errors = {
    something_went_wrong: "Oops! Something went wrong.",
    page_not_found: "Page not found",
    unknown_server_error: "Unknown server error occurred",
    empty: "No data",
    missing_total_number: "Unable to find Total-Number in response headers",
    invalid_uri_format: "Invalid URI format",
    invalid_origin_format: "Invalid URI origin format",
    invalid_json_format: "Invalid JSON format",
    invalid_error_message_format: "The error message format is invalid.",
    required_field_missing: "Please enter {{field}}",
    required_field_missing_plural: "You have to enter at least one {{field}}",
    more_details: "More details",
    username_pattern_error: "Username should only contain letters, numbers, or underscore and should not start with a number.",
    email_pattern_error: "The email address is invalid.",
    phone_pattern_error: "The phone number is invalid.",
    insecure_contexts: "Insecure contexts (non-HTTPS) are not supported.",
    unexpected_error: "An unexpected error occurred.",
    not_found: "404 not found",
    create_internal_role_violation: 'You are creating a new internal role which is forbidden by Logto. Try another name that does not start with "#internal:".',
    should_be_an_integer: "Should be an integer.",
    number_should_be_between_inclusive: "Then number should be between {{min}} and {{max}} (both inclusive)."
};
var $40578e457ba25d7d$export$2e2bcd8739ae039 = Object.freeze($40578e457ba25d7d$var$errors);


const $220fae253a8b0423$var$general = {
    placeholder: "Placeholder",
    submit: "Submit",
    skip: "Skip",
    next: "Next",
    back: "Back",
    retry: "Try again",
    done: "Done",
    search: "Search",
    search_placeholder: "Search",
    clear_result: "Clear results",
    save: "Save",
    save_changes: "Save changes",
    saved: "Saved",
    discard: "Discard",
    loading: "Loading...",
    redirecting: "Redirecting...",
    add: "Add",
    added: "Added",
    cancel: "Cancel",
    confirm: "Confirm",
    check_out: "Check out",
    create: "Create",
    set_up: "Set up",
    customize: "Customize",
    enable: "Enable",
    reminder: "Reminder",
    delete: "Delete",
    more_options: "MORE OPTIONS",
    close: "Close",
    copy: "Copy",
    copying: "Copying",
    copied: "Copied",
    required: "Required",
    add_another: "Add another",
    create_another: "Create another",
    deletion_confirmation: "Are you sure you want to delete this {{title}}?",
    settings_nav: "Settings",
    unsaved_changes_warning: "You have made some changes. Are you sure you want to leave this page?",
    leave_page: "Leave page",
    stay_on_page: "Stay on page",
    type_to_search: "Type to search",
    got_it: "Got it",
    continue: "Continue",
    page_info: "{{min, number}}-{{max, number}} of {{total, number}}",
    learn_more: "Learn more",
    tab_errors: "{{count, number}} errors",
    skip_for_now: "Skip for now",
    remove: "Remove",
    visit: "Visit",
    join: "Join",
    try_now: "Try now",
    multiple_form_field: "(Multiple)",
    demo: "Demo",
    unnamed: "Unnamed",
    view: "View",
    hide: "Hide",
    unknown_error: "Unknown error, please try again later.",
    select: "Select",
    contact_us_action: "Contact us",
    description: "Description",
    name: "Name",
    add_field: "Add {{field}}",
    create_field: "Create {{field}}",
    edit_field: "Edit {{field}}",
    delete_field: "Delete {{field}}",
    coming_soon: "Coming soon",
    beta_notice: "\uD83C\uDF89  {{feature}} is currently in beta. Welcome to explore it and <ContactLink>share your feedback</ContactLink>."
};
var $220fae253a8b0423$export$2e2bcd8739ae039 = Object.freeze($220fae253a8b0423$var$general);


const $b3b20a0b1efe3305$var$get_started = {
    page_title: "Get started",
    title: "Something to help you succeed",
    subtitle: "A few things you can do to quickly get value of Logto",
    develop: {
        title: "Develop: Take 5 minutes to integrate your app"
    },
    customize: {
        title: "Customize: Deliver a great sign-in experience",
        preview: {
            title: "Check the live preview of the sign-in experience you just customized",
            subtitle: "Try Logto sign-in experience now to see how it works"
        },
        connector: {
            title: "Add more connectors to support more social sign-in methods",
            subtitle: "Try passwordless sign in and enable a secure and frictionless experience for your customers"
        },
        continue_customizing: "Continue customizing",
        try_now: "Try now",
        add_more: "Add more"
    },
    secure: {
        title: "Secure: Protect your resources"
    },
    manage: {
        title: "Manage: Define access control for your product and users",
        rbac: {
            title: "Add role-based access control to protect your resources",
            subtitle: "Control your resource through scalable role authorization for diverse use cases."
        },
        create_roles: "Create roles"
    },
    view_all: "View all →"
};
var $b3b20a0b1efe3305$export$2e2bcd8739ae039 = Object.freeze($b3b20a0b1efe3305$var$get_started);


const $83c15cbad3bb7a64$var$guide = {
    start_building: "Start building",
    get_started: "Get started",
    categories: {
        featured: "Popular and for you",
        Traditional: "Traditional web app",
        SPA: "Single page app",
        Native: "Native",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "Filter framework",
        placeholder: "Search for framework"
    },
    checkout_tutorial: "Checkout {{name}} tutorial",
    do_not_need_tutorial: "If you don't need a tutorial, you can continue without a framework guide",
    finish_and_done: "Finish and done",
    cannot_find_guide: "Can't find your guide?",
    describe_guide_looking_for: "Describe the guide you are looking for",
    request_guide_successfully: "Your request has been successfully submitted. Thank you!",
    app: {
        select_framework_or_tutorial: "Select a framework or tutorial",
        guide_modal_title: "Start with SDK and guides",
        modal_subtitle: "Jumpstart your app development process with our pre-built SDK and tutorials.",
        select_a_framework: "Select a framework",
        continue_without_framework: "Create app without framework",
        describe_guide_looking_for_placeholder: "E.g., I want to integrate Logto into my Angular app."
    },
    api: {
        modal_title: "Start with tutorials",
        modal_subtitle: "Jumpstart your app development process with our pre-built tutorials.",
        select_a_tutorial: "Select a tutorial",
        continue_without_tutorial: "Continue without tutorial",
        describe_guide_looking_for_placeholder: "E.g., I want to protect my API using deno."
    }
};
var $83c15cbad3bb7a64$export$2e2bcd8739ae039 = Object.freeze($83c15cbad3bb7a64$var$guide);


const $2623f8e70d6346ba$var$log_details = {
    page_title: "Audit log details",
    back_to_logs: "Back to audit logs",
    back_to: "Back to {{name}}",
    success: "Success",
    failed: "Failed",
    event_key: "Event key",
    application: "Application",
    ip_address: "IP address",
    user: "User",
    log_id: "Log ID",
    time: "Time",
    user_agent: "User agent",
    tab_details: "Details",
    raw_data: "Raw data"
};
var $2623f8e70d6346ba$export$2e2bcd8739ae039 = Object.freeze($2623f8e70d6346ba$var$log_details);


const $a5ea856c0c1bf5ef$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "View log data of authentication events made by your users",
    event: "Event",
    user: "User",
    application: "Application",
    time: "Time",
    filter_by: "Filter by"
};
var $a5ea856c0c1bf5ef$export$2e2bcd8739ae039 = Object.freeze($a5ea856c0c1bf5ef$var$logs);


const $16da0791b566b3c2$var$menu = {
    profile: "Profile",
    language: "Language",
    appearance: {
        label: "Appearance",
        light: "Light mode",
        dark: "Dark mode",
        system: "Sync with system"
    },
    sign_out: "Sign Out"
};
var $16da0791b566b3c2$export$2e2bcd8739ae039 = Object.freeze($16da0791b566b3c2$var$menu);


const $639859ce6092ecf5$var$mfa = {
    title: "Multi-factor authentication",
    description: "Add multi-factor authentication to elevate the security of your sign-in experience.",
    factors: "Factors",
    multi_factors: "Multi-factors",
    multi_factors_description: "Users need to verify one of the enabled factors for 2-step verification.",
    totp: "Authenticator app OTP",
    otp_description: "Link Google Authenticator, etc., to verify one-time passwords.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "Verify via browser-supported method: biometrics, phone scanning, or security key, etc.",
    webauthn_native_tip: "WebAuthn is not supported for Native applications.",
    webauthn_domain_tip: "WebAuthn binds public keys to the specific domain. Modifying your service domain will block users from authenticating via existing passkeys.",
    backup_code: "Backup code",
    backup_code_description: "Generate 10 one-time backup codes after users set up any MFA method.",
    backup_code_setup_hint: "When users can't verify the above MFA factors, use the backup option.",
    backup_code_error_hint: "To use a backup code, you need at least one more MFA method for successful user authentication.",
    policy: "Policy",
    policy_description: "Set the MFA policy for sign-in and sign-up flows.",
    two_step_sign_in_policy: "2-step verification policy at sign-in",
    user_controlled: "Users can enable or disable MFA on their own",
    user_controlled_tip: "Users can skip the MFA set-up the first time at sign-in or sign-up, or enable/disable it in account settings.",
    mandatory: "Users are always required to use MFA at sign-in",
    mandatory_tip: "Users must set up MFA the first time at sign-in or sign-up, and use it for all future sign-ins."
};
var $639859ce6092ecf5$export$2e2bcd8739ae039 = Object.freeze($639859ce6092ecf5$var$mfa);


const $7ec15209c86438de$var$organization_details = {
    page_title: "Organization details",
    delete_confirmation: "Once deleted, all members will lose their membership and roles in this organization. This action cannot be undone.",
    organization_id: "Organization ID",
    settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "The name of the organization, not required to be unique.",
    description_placeholder: "A description of the organization.",
    member: "Member",
    member_other: "Members",
    add_members_to_organization: "Add members to organization {{name}}",
    add_members_to_organization_description: "Find appropriate users by searching name, email, phone, or user ID. Existing members are not shown in the search results.",
    add_with_organization_role: "Add with organization role(s)",
    user: "User",
    authorize_to_roles: "Authorize {{name}} to access the following roles:",
    edit_organization_roles: "Edit organization roles",
    edit_organization_roles_of_user: "Edit organization roles of {{name}}",
    remove_user_from_organization: "Remove user from organization",
    remove_user_from_organization_description: "Once removed, the user will lose their membership and roles in this organization. This action cannot be undone.",
    search_user_placeholder: "Search by name, email, phone or user ID",
    at_least_one_user: "At least one user is required."
};
var $7ec15209c86438de$export$2e2bcd8739ae039 = Object.freeze($7ec15209c86438de$var$organization_details);


const $05d31e3f485f3e09$var$organizations = {
    organization: "Organization",
    page_title: "Organizations",
    title: "Organizations",
    subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    organization_template: "Organization template",
    organization_id: "Organization ID",
    members: "Members",
    create_organization: "Create organization",
    setup_organization: "Set up your organization",
    organization_list_placeholder_title: "Organization",
    organization_list_placeholder_text: "Organization is usually used in SaaS or SaaS-like multi-tenancy apps. The Organizations feature allows your B2B customers to better manage their partners and customers, and to customize the ways that end-users access their applications.",
    organization_name_placeholder: "My organization",
    organization_description_placeholder: "A brief description of the organization",
    organization_permission: "Organization permission",
    organization_permission_other: "Organization permissions",
    organization_permission_description: "Organization permission refers to the authorization to access a resource in the context of organization. An organization permission should be represented as a meaningful string, also serving as the name and unique identifier.",
    organization_permission_delete_confirm: "If this permission is deleted, all organization roles including this permission will lose this permission, and users who had this permission will lose the access granted by it.",
    create_permission_placeholder: "Read appointment history",
    permission: "Permission",
    permission_other: "Permissions",
    organization_role: "Organization role",
    organization_role_other: "Organization roles",
    organization_role_description: "Organization role is a grouping of permissions that can be assigned to users. The permissions must come from the predefined organization permissions.",
    organization_role_delete_confirm: "Doing so will remove the permissions associated with this role from the affected users and delete the relations among organization roles, members in the organization, and organization permissions.",
    role: "Role",
    create_role_placeholder: "Users with view-only permissions",
    search_placeholder: "Search by organization name or ID",
    search_permission_placeholder: "Type to search and select permissions",
    search_role_placeholder: "Type to search and select roles",
    empty_placeholder: "\uD83E\uDD14 You don’t have any {{entity}} set up yet.",
    organization_and_member: "Organization and member",
    organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Start with guides",
        subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            title: "Let's understand how organization works in Logto",
            section_1: {
                title: "An organization is a group of users (identities)"
            },
            section_2: {
                title: "Organization template is designed for multi-tenant apps access control",
                description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interact with the illustration to see how everything connects",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Step 1: Define organization permissions",
        step_2: "Step 2: Define organization roles",
        step_3: "Step 3: Create your first organization",
        step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        more_next_steps: "More next steps",
        add_members: "Add members to your organization",
        add_members_action: "Bulk add members and assign roles",
        organization_permissions: "Organization permissions",
        permission_name: "Permission name",
        permissions: "Permissions",
        organization_roles: "Organization roles",
        role_name: "Role name",
        organization_name: "Organization name",
        admin: "Admin",
        member: "Member",
        guest: "Guest",
        role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        john: "John",
        john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        sarah: "Sarah",
        sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $05d31e3f485f3e09$export$2e2bcd8739ae039 = Object.freeze($05d31e3f485f3e09$var$organizations);


const $52bc5557ae369b52$var$permissions = {
    search_placeholder: "Search by API or permission name",
    search_placeholder_without_api: "Search by permission name",
    name_column: "Permission",
    description_column: "Description",
    api_column: "API",
    placeholder_title: "Permission",
    placeholder_description: "Permission refers to the authorization to access a resource (we call it API resource)."
};
var $52bc5557ae369b52$export$2e2bcd8739ae039 = Object.freeze($52bc5557ae369b52$var$permissions);


const $78c84cd8ac574bba$var$profile = {
    page_title: "Account settings",
    title: "Account settings",
    description: "Change your account settings and manage your personal information here to ensure your account security.",
    settings: {
        title: "PROFILE SETTINGS",
        profile_information: "Profile information",
        avatar: "Avatar",
        name: "Name",
        username: "Username"
    },
    link_account: {
        title: "LINK ACCOUNT",
        email_sign_in: "Email sign-In",
        email: "Email",
        social_sign_in: "Social sign-In",
        link_email: "Link email",
        link_email_subtitle: "Link your email to sign in or help with account recovery.",
        email_required: "Email is required",
        invalid_email: "Invalid email address",
        identical_email_address: "The input email address is identical to the current one",
        anonymous: "Anonymous"
    },
    password: {
        title: "PASSWORD & SECURITY",
        password: "Password",
        password_setting: "Password setting",
        new_password: "New password",
        confirm_password: "Confirm password",
        enter_password: "Enter current password",
        enter_password_subtitle: "Verify it's you to protect your account security. Please enter your current password before changing it.",
        set_password: "Set password",
        verify_via_password: "Verify via password",
        show_password: "Show password",
        required: "Password is required",
        do_not_match: "Passwords do not match. Please try again."
    },
    code: {
        enter_verification_code: "Enter verification code",
        enter_verification_code_subtitle: "The verification code has been sent to <strong>{{target}}</strong>",
        verify_via_code: "Verify via verification code",
        resend: "Resend verification code",
        resend_countdown: "Resend in {{countdown}} seconds"
    },
    delete_account: {
        title: "DELETE ACCOUNT",
        label: "Delete account",
        description: "Deleting your account will remove all of your personal information, user data, and configuration. This action cannot be undone.",
        button: "Delete account",
        dialog_paragraph_1: "We're sorry to hear that you want to delete your account. Deleting your account will permanently remove all data, including user information, logs, and settings, and this action cannot be undone. So please make sure to backup any important data before proceeding.",
        dialog_paragraph_2: "To proceed with the account deletion process, please email our support team at <a>{{mail}}</a> with the subject “Account Deletion Request”. We will assist you and ensure that all of your data is properly deleted from our system.",
        dialog_paragraph_3: "Thank you for choosing Logto Cloud. If you have any further questions or concerns, please do not hesitate to reach out to us."
    },
    set: "Set",
    change: "Change",
    link: "Link",
    unlink: "Unlink",
    not_set: "Not set",
    change_avatar: "Change avatar",
    change_name: "Change name",
    change_username: "Change username",
    set_name: "Set name",
    email_changed: "Email changed.",
    password_changed: "Password changed.",
    updated: "{{target}} updated.",
    linked: "{{target}} linked.",
    unlinked: "{{target}} unlinked.",
    email_exists_reminder: "This email {{email}} is associated with an existing account. Link another email here.",
    unlink_confirm_text: "Yes, unlink",
    unlink_reminder: "Users will not be able to sign in with the <span></span> account if you unlink it. Are you sure to proceed?"
};
var $78c84cd8ac574bba$export$2e2bcd8739ae039 = Object.freeze($78c84cd8ac574bba$var$profile);


const $7c429f6e9fd81451$var$role_details = {
    back_to_roles: "Back to roles",
    identifier: "Identifier",
    delete_description: "Doing so will remove the permissions associated with this role from the affected users and delete the mapping between roles, users, and permissions.",
    role_deleted: "{{name}} was successfully deleted.",
    settings_tab: "Settings",
    users_tab: "Users",
    m2m_apps_tab: "Machine-to-machine apps",
    permissions_tab: "Permissions",
    settings: "Settings",
    settings_description: "Roles are a grouping of permissions that can be assigned to users. They also provide a way to aggregate permissions defined for different APIs, making it more efficient to add, remove, or adjust permissions compared to assigning them individually to users.",
    field_name: "Name",
    field_description: "Description",
    type_m2m_role_tag: "Machine-to-machine app role",
    type_user_role_tag: "User role",
    permission: {
        assign_button: "Assign permissions",
        assign_title: "Assign permissions",
        assign_subtitle: "Assign permissions to this role. The role will gain the added permissions, and users with this role will inherit these permissions.",
        assign_form_field: "Assign permissions",
        added_text_one: "{{count, number}} permission added",
        added_text_other: "{{count, number}} permissions added",
        api_permission_count_one: "{{count, number}} permission",
        api_permission_count_other: "{{count, number}} permissions",
        confirm_assign: "Assign permissions",
        permission_assigned: "The selected permissions were successfully assigned to this role",
        deletion_description: "If this permission is removed, the affected user with this role will lose the access granted by this permission.",
        permission_deleted: 'The permission "{{name}}" was successfully removed from this role',
        empty: "No permission available"
    },
    users: {
        assign_button: "Assign users",
        name_column: "User",
        app_column: "App",
        latest_sign_in_column: "Latest sign in",
        delete_description: "It will remain in your user pool but lose the authorization for this role.",
        deleted: "{{name}} was successfully removed from this role",
        assign_title: "Assign users",
        assign_subtitle: "Assign users to this role. Find appropriate users by searching name, email, phone, or user ID.",
        assign_field: "Assign users",
        confirm_assign: "Assign users",
        assigned_toast_text: "The selected users were successfully assigned to this role",
        empty: "No user available"
    },
    applications: {
        assign_button: "Assign applications",
        name_column: "Application",
        app_column: "Apps",
        description_column: "Description",
        delete_description: "It will remain in your application pool but lose the authorization for this role.",
        deleted: "{{name}} was successfully removed from this role",
        assign_title: "Assign apps",
        assign_subtitle: "Assign applications to this role. Find appropriate applications by searching name, description or app ID.",
        assign_field: "Assign applications",
        confirm_assign: "Assign applications",
        assigned_toast_text: "The selected applications were successfully assigned to this role",
        empty: "No application available"
    }
};
var $7c429f6e9fd81451$export$2e2bcd8739ae039 = Object.freeze($7c429f6e9fd81451$var$role_details);


const $ab4d3f6b6497c357$var$roles = {
    page_title: "Roles",
    title: "Roles",
    subtitle: "Roles include permissions that determine what a user can do. RBAC uses roles to give users access to resources for specific actions.",
    create: "Create role",
    role_name: "Role name",
    role_type: "Role type",
    show_role_type_button_text: "Show more options",
    hide_role_type_button_text: "Hide more options",
    type_user: "User role",
    type_machine_to_machine: "Machine-to-machine app role",
    role_description: "Description",
    role_name_placeholder: "Enter your role name",
    role_description_placeholder: "Enter your role description",
    col_roles: "Roles",
    col_type: "Type",
    col_description: "Description",
    col_assigned_entities: "Assigned",
    user_counts: "{{count}} users",
    application_counts: "{{count}} apps",
    user_count: "{{count}} user",
    application_count: "{{count}} app",
    assign_permissions: "Assign permissions",
    create_role_title: "Create role",
    create_role_description: "Create and manage roles for your applications. Roles contain collections of permissions and can be assigned to users.",
    create_role_button: "Create role",
    role_created: "The role {{name}} has been successfully created.",
    search: "Search by role name, description or ID",
    placeholder_title: "Roles",
    placeholder_description: "Roles are a grouping of permissions that can be assigned to users. Be sure to add permission first before create roles."
};
var $ab4d3f6b6497c357$export$2e2bcd8739ae039 = Object.freeze($ab4d3f6b6497c357$var$roles);


const $700cee405a1a2537$var$session_expired = {
    title: "Session expired",
    subtitle: "Your session might have expired and you have been disconnected. Click the button below to sign in to admin console again.",
    button: "Sign in again"
};
var $700cee405a1a2537$export$2e2bcd8739ae039 = Object.freeze($700cee405a1a2537$var$session_expired);


const $a726c3668d45876b$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $a726c3668d45876b$export$2e2bcd8739ae039 = Object.freeze($a726c3668d45876b$var$content);


const $035628aa2c73e210$var$password_policy = {
    password_requirements: "Password requirements",
    minimum_length: "Minimum length",
    minimum_length_description: "NIST suggests using <a>at least 8 characters</a> for web products.",
    minimum_length_error: "Minimum length must be between {{min}} and {{max}} (inclusive).",
    minimum_required_char_types: "Minimum required character types",
    minimum_required_char_types_description: "Character types: uppercase (A-Z), lowercase (a-z), numbers (0-9), and special symbols ({{symbols}}).",
    password_rejection: "Password rejection",
    compromised_passwords: "Reject compromised password",
    breached_passwords: "Breached passwords",
    breached_passwords_description: "Reject passwords previously found in breach databases.",
    restricted_phrases: "Restrict low-security phrases",
    restricted_phrases_tooltip: "Your password should avoid these phrases unless you combine with 3 or more extra characters.",
    repetitive_or_sequential_characters: "Repetitive or sequential characters",
    repetitive_or_sequential_characters_description: 'E.g., "AAAA", "1234", and "abcd".',
    user_information: "User information",
    user_information_description: "E.g., email address, phone number, username, etc.",
    custom_words: "Custom words",
    custom_words_description: "Personalize context-specific words, case-insensitive, and one per line.",
    custom_words_placeholder: "Your service name, company name, etc."
};
var $035628aa2c73e210$export$2e2bcd8739ae039 = Object.freeze($035628aa2c73e210$var$password_policy);


const $114b539ee876a757$var$sign_up_and_sign_in = {
    identifiers_email: "Email address",
    identifiers_phone: "Phone number",
    identifiers_username: "Username",
    identifiers_email_or_sms: "Email address or phone number",
    identifiers_none: "Not applicable",
    and: "and",
    or: "or",
    sign_up: {
        title: "SIGN UP",
        sign_up_identifier: "Sign-up identifier",
        identifier_description: "The sign-up identifier is required for account creation and must be included in your sign-in screen.",
        sign_up_authentication: "Authentication setting for sign-up",
        authentication_description: "All selected actions will be obligatory for users to complete the flow.",
        set_a_password_option: "Create your password",
        verify_at_sign_up_option: "Verify at sign-up",
        social_only_creation_description: "(This apply to social only account creation)"
    },
    sign_in: {
        title: "SIGN IN",
        sign_in_identifier_and_auth: "Identifier and authentication settings for sign-in",
        description: "Users can sign in using any of the options available. Adjust the layout by drag and dropping below options.",
        add_sign_in_method: "Add sign-in method",
        password_auth: "Password",
        verification_code_auth: "Verification code",
        auth_swap_tip: "Swap the options below to determine which appears first in the flow.",
        require_auth_factor: "You have to select at least one authentication factor."
    },
    social_sign_in: {
        title: "SOCIAL SIGN-IN",
        social_sign_in: "Social sign-in",
        description: "Depending on the mandatory identifier you set up, your user may be asked to provide an identifier when signing up via social connector.",
        add_social_connector: "Add Social Connector",
        set_up_hint: {
            not_in_list: "Not in the list?",
            set_up_more: "Set up",
            go_to: "other social connectors now."
        }
    },
    tip: {
        set_a_password: "A unique set of a password to your username is a must.",
        verify_at_sign_up: "We currently only support verified email. Your user base may contain a large number of poor-quality email addresses if no validation.",
        password_auth: "This is essential as you have enabled the option to set a password during the sign-up process.",
        verification_code_auth: "This is essential as you have only enabled the option to provide verification code when signing up. You’re free to uncheck the box when password set-up is allowed at the sign-up process.",
        delete_sign_in_method: "This is essential as you have selected {{identifier}} as a required identifier."
    },
    advanced_options: {
        title: "ADVANCED OPTIONS",
        enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            prefix: "Go to ",
            link: '"Enterprise SSO"',
            suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Enable user registration",
        enable_user_registration_description: "Enable or disallow user registration. Once disabled, users can still be added in the admin console but users can no longer establish accounts through the sign-in UI."
    }
};
var $114b539ee876a757$export$2e2bcd8739ae039 = Object.freeze($114b539ee876a757$var$sign_up_and_sign_in);


const $a4750467137ed51b$var$sign_in_exp = {
    page_title: "Sign-in experience",
    title: "Sign-in experience",
    description: "Customize the sign in UI to match your brand and view in real time",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Sign-up and sign-in",
        content: "Content",
        password_policy: "Password policy"
    },
    welcome: {
        title: "Customize sign-in experience",
        description: "Get started fast with your first sign-in setup. This guide walks you through all the necessary settings.",
        get_started: "Get started",
        apply_remind: "Please note that sign-in experience will apply to all applications under this account."
    },
    color: {
        title: "COLOR",
        primary_color: "Brand color",
        dark_primary_color: "Brand color (Dark)",
        dark_mode: "Enable dark mode",
        dark_mode_description: "Your app will have an auto-generated dark mode theme based on your brand color and Logto algorithm. You are free to customize.",
        dark_mode_reset_tip: "Recalculate dark mode color based on brand color.",
        reset: "Recalculate"
    },
    branding: {
        title: "BRANDING AREA",
        ui_style: "Style",
        favicon: "Favicon",
        logo_image_url: "App logo image URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "App logo image URL (Dark)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "App logo",
        dark_logo_image: "App logo (Dark)",
        logo_image_error: "App logo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Custom CSS",
        css_code_editor_title: "Personalize your UI with custom CSS",
        css_code_editor_description1: "See the example of custom CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Learn more",
        css_code_editor_content_placeholder: "Enter your custom CSS to tailor the styles of anything to your exact specifications. Express your creativity and make your UI stand out."
    },
    sign_up_and_sign_in: $114b539ee876a757$export$2e2bcd8739ae039,
    content: $a726c3668d45876b$export$2e2bcd8739ae039,
    password_policy: $035628aa2c73e210$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'No SMS connector set-up yet. Before completing the configuration, users will not be able to sign in with this method. <a>{{link}}</a> in "Connectors"',
        no_connector_email: 'No email connector set-up yet. Before completing the configuration, users will not be able to sign in with this method. <a>{{link}}</a> in "Connectors"',
        no_connector_social: "You haven’t set up any social connector yet. Add connectors first to apply social sign in methods. <a>{{link}}</a> in “Connectors”.",
        setup_link: "Set up"
    },
    save_alert: {
        description: "You are implementing new sign-in and sign-up procedures. All of your users may be affected by the new set-up. Are you sure to commit to the change?",
        before: "Before",
        after: "After",
        sign_up: "Sign-up",
        sign_in: "Sign-in",
        social: "Social"
    },
    preview: {
        title: "Sign-in preview",
        live_preview: "Live preview",
        live_preview_tip: "Save to preview changes",
        native: "Native",
        desktop_web: "Desktop Web",
        mobile_web: "Mobile Web",
        desktop: "Desktop",
        mobile: "Mobile"
    }
};
var $a4750467137ed51b$export$2e2bcd8739ae039 = Object.freeze($a4750467137ed51b$var$sign_in_exp);


const $436c72fb4a332de9$var$quota_item = {
    tenant_limit: {
        name: "Tenants",
        limited: "{{count, number}} tenant",
        limited_other: "{{count, number}} tenants",
        unlimited: "Unlimited tenants",
        not_eligible: "Remove your tenants"
    },
    mau_limit: {
        name: "Monthly active users",
        limited: "{{count, number}} MAU",
        unlimited: "Unlimited MAU",
        not_eligible: "Remove your all users"
    },
    applications_limit: {
        name: "Applications",
        limited: "{{count, number}} application",
        limited_other: "{{count, number}} applications",
        unlimited: "Unlimited applications",
        not_eligible: "Remove your applications"
    },
    machine_to_machine_limit: {
        name: "Machine to machine",
        limited: "{{count, number}} machine to machine app",
        limited_other: "{{count, number}} machine to machine apps",
        unlimited: "Unlimited machine to machine apps",
        not_eligible: "Remove your machine to machine apps"
    },
    resources_limit: {
        name: "API resources",
        limited: "{{count, number}} API resource",
        limited_other: "{{count, number}} API resources",
        unlimited: "Unlimited API resources",
        not_eligible: "Remove your API resources"
    },
    scopes_per_resource_limit: {
        name: "Resource permissions",
        limited: "{{count, number}} permission per resource",
        limited_other: "{{count, number}} permissions per resource",
        unlimited: "Unlimited permission per resource",
        not_eligible: "Remove your resource permissions"
    },
    custom_domain_enabled: {
        name: "Custom domain",
        limited: "Custom domain",
        unlimited: "Custom domain",
        not_eligible: "Remove your custom domain"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Disable your omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Built-in email connector",
        limited: "Built-in email connector",
        unlimited: "Built-in email connector",
        not_eligible: "Remove your built-in email connector"
    },
    social_connectors_limit: {
        name: "Social connectors",
        limited: "{{count, number}} social connector",
        limited_other: "{{count, number}} social connectors",
        unlimited: "Unlimited Social connectors",
        not_eligible: "Remove your social connectors"
    },
    standard_connectors_limit: {
        name: "Free standard connectors",
        limited: "{{count, number}} free standard connector",
        limited_other: "{{count, number}} free standard connectors",
        unlimited: "Unlimited standard connectors",
        not_eligible: "Remove your standard connectors"
    },
    roles_limit: {
        name: "Roles",
        limited: "{{count, number}} role",
        limited_other: "{{count, number}} roles",
        unlimited: "Unlimited roles",
        not_eligible: "Remove your roles"
    },
    scopes_per_role_limit: {
        name: "Role permissions",
        limited: "{{count, number}} permission per role",
        limited_other: "{{count, number}} permissions per role",
        unlimited: "Unlimited permission per role",
        not_eligible: "Remove your role permissions"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Unlimited webhooks",
        not_eligible: "Remove your webhooks"
    },
    organizations_enabled: {
        name: "Organizations",
        limited: "Organizations",
        unlimited: "Organizations",
        not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Audit logs retention",
        limited: "Audit logs retention: {{count, number}} day",
        limited_other: "Audit logs retention: {{count, number}} days",
        unlimited: "Unlimited days",
        not_eligible: "No audit logs"
    },
    community_support_enabled: {
        name: "Community support",
        limited: "Community support",
        unlimited: "Community support",
        not_eligible: "No community support"
    },
    customer_ticket_support: {
        name: "Customer ticket support",
        limited: "{{count, number}} hour customer ticket support",
        limited_other: "{{count, number}} hours customer ticket support",
        unlimited: "Customer ticket support",
        not_eligible: "No customer ticket support"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Disable your MFA"
    },
    sso_enabled: {
        name: "Enterprise SSO",
        limited: "Enterprise SSO",
        unlimited: "Enterprise SSO",
        not_eligible: "Disable your Enterprise SSO"
    }
};
var $436c72fb4a332de9$export$2e2bcd8739ae039 = Object.freeze($436c72fb4a332de9$var$quota_item);


const $62e13eadd824356b$var$quota_table = {
    quota: {
        title: "Quota",
        tenant_limit: "Tenant limit",
        base_price: "Base price",
        mau_unit_price: "* MAU unit price",
        mau_limit: "MAU limit"
    },
    application: {
        title: "Applications",
        total: "Total applications",
        m2m: "Machine-to-machine"
    },
    resource: {
        title: "API resources",
        resource_count: "Resource count",
        scopes_per_resource: "Permissions per resource"
    },
    branding: {
        title: "UI and branding",
        custom_domain: "Custom domain",
        custom_css: "Custom CSS",
        app_logo_and_favicon: "App logo and favicon",
        dark_mode: "Dark mode",
        i18n: "Internationalization"
    },
    user_authn: {
        title: "User authentication",
        omni_sign_in: "Omni sign-in",
        password: "Password",
        passwordless: "Passwordless - Email and SMS",
        email_connector: "Email connector",
        sms_connector: "SMS connector",
        social_connectors: "Social connectors",
        standard_connectors: "Standard connectors",
        built_in_email_connector: "Built-in email connector",
        mfa: "MFA",
        sso: "Enterprise SSO"
    },
    user_management: {
        title: "User management",
        user_management: "User management",
        roles: "Roles",
        scopes_per_role: "Permissions per role"
    },
    audit_logs: {
        title: "Audit logs",
        retention: "Retention"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organizations",
        organizations: "Organizations"
    },
    support: {
        title: "Support",
        community: "Community",
        customer_ticket: "Ticket support",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Your monthly active users (MAU) are divided into 3 tiers based on how often they log in during the billing cycle. Each tier has a different price per MAU unit.",
    unlimited: "Unlimited",
    contact: "Contact",
    monthly_price: "${{value, number}}/mo",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} day",
    days_other: "{{count, number}} days",
    add_on: "Add-on",
    tier: "Tier{{value, number}}: "
};
var $62e13eadd824356b$export$2e2bcd8739ae039 = Object.freeze($62e13eadd824356b$var$quota_table);


const $7e899226b543a216$var$subscription = {
    free_plan: "Free plan",
    free_plan_description: "For side projects and initial Logto trials. No credit card.",
    hobby_plan: "Hobby plan",
    hobby_plan_description: "For individual developers or small engineering teams.",
    pro_plan: "Pro plan",
    pro_plan_description: "For businesses benefit worry-free with Logto.",
    enterprise: "Enterprise",
    current_plan: "Current Plan",
    current_plan_description: "Here’s your current plan. You can easily see your plan usage, check your upcoming bill, and make changes to your plan as needed.",
    plan_usage: "Plan usage",
    plan_cycle: "Plan cycle: {{period}}. Usage renews on {{renewDate}}.",
    next_bill: "Your next bill",
    next_bill_hint: "To learn more about the calculation, please refer to this <a>article</a>.",
    next_bill_tip: "Your upcoming bill includes the base price of your plan for the next month, as well as the cost of your usage multiplied by the MAU unit price in various tiers.",
    manage_payment: "Manage Payment",
    overfill_quota_warning: "You have reached your quota limit. To prevent any issues, upgrade the plan.",
    upgrade_pro: "Upgrade pro",
    update_payment: "Update payment",
    payment_error: "Payment issue detected. Unable to process ${{price, number}} for previous cycle. Update payment to avoid Logto service suspension.",
    downgrade: "Downgrade",
    current: "Current",
    upgrade: "Upgrade",
    quota_table: $62e13eadd824356b$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Invoices",
        status_column: "Status",
        amount_column: "Amount",
        invoice_created_date_column: "Invoice created date",
        invoice_status: {
            void: "Canceled",
            paid: "Paid",
            open: "Open",
            uncollectible: "Overdue"
        }
    },
    quota_item: $436c72fb4a332de9$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Are you sure you want to downgrade?",
        description: "If you choose to switch to the <targetName/>, please note that you will no longer have access to the quota and features that were previously in <currentName/>.",
        before: "Before: <name/>",
        after: "After: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "You are not eligible for downgrade",
        downgrade_description: "Make sure you meet the following criteria before downgrading to the <name/>.",
        downgrade_help_tip: "Need help downgrading? <a>Contact us</a>.",
        upgrade_title: "Friendly reminder for our honoured early adopters",
        upgrade_description: "You’re currently using more than what the <name /> allows. Logto is now official, including features tailored to each plan. Before you consider upgrading to the <name />, make sure you meet the following criteria before upgrading.",
        upgrade_pro_tip: " Or considering upgrading to Pro Plan.",
        upgrade_help_tip: "Need help upgrading? <a>Contact us</a>.",
        a_maximum_of: "A maximum of <item/>"
    },
    upgrade_success: "Successfully upgraded to <name/>",
    downgrade_success: "Successfully downgraded to <name/>",
    subscription_check_timeout: "Subscription check timed out. Please refresh later.",
    no_subscription: "No subscription"
};
var $7e899226b543a216$export$2e2bcd8739ae039 = Object.freeze($7e899226b543a216$var$subscription);


const $2e6d53bbe1ab3da3$var$tab_sections = {
    overview: "Overview",
    resources: "Resources",
    users: "Users",
    access_control: "Access Control",
    help_and_support: "Help and Support",
    tenant: "Tenant",
    automation: "Automation"
};
var $2e6d53bbe1ab3da3$export$2e2bcd8739ae039 = Object.freeze($2e6d53bbe1ab3da3$var$tab_sections);


const $73616e1f58c351a2$var$tabs = {
    get_started: "Get started",
    dashboard: "Dashboard",
    applications: "Applications",
    api_resources: "API resources",
    sign_in_experience: "Sign-in experience",
    connectors: "Connectors",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "Organizations",
    users: "User management",
    audit_logs: "Audit logs",
    roles: "Roles",
    docs: "Docs",
    tenant_settings: "Settings",
    mfa: "Multi-factor auth"
};
var $73616e1f58c351a2$export$2e2bcd8739ae039 = Object.freeze($73616e1f58c351a2$var$tabs);


const $5ee817679dc8479d$var$tenants = {
    title: "Settings",
    description: "Efficiently manage tenant settings and customize your domain.",
    tabs: {
        settings: "Settings",
        domains: "Domains",
        subscription: "Plan and billing",
        billing_history: "Billing history"
    },
    settings: {
        title: "SETTINGS",
        description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "Tenant ID",
        tenant_name: "Tenant Name",
        tenant_region: "Data hosted region",
        tenant_region_tip: "Your tenant resources are hosted in {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        tenant_type: "Tenant type",
        development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Tenant information saved successfully."
    },
    full_env_tag: {
        development: "Development",
        production: "Production"
    },
    deletion_card: {
        title: "DELETE",
        tenant_deletion: "Delete tenant",
        tenant_deletion_description: "Deleting the tenant will result in the permanent removal of all associated user data and configuration. Please proceed with caution.",
        tenant_deletion_button: "Delete tenant"
    },
    create_modal: {
        title: "Create tenant",
        subtitle: "Create a new tenant that has isolated resources and users. Data hosted region and tenant types can’t be modified after creation.",
        tenant_usage_purpose: "What do you want to use this tenant for?",
        development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Available plan:",
        create_button: "Create tenant",
        tenant_name_placeholder: "My tenant"
    },
    dev_tenant_migration: {
        title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        affect_title: "How does this affect you?",
        hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        hint_3: "Don't worry, all your other settings will remain the same.",
        about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Delete tenant",
        description_line1: 'Are you sure you want to delete your tenant "<span>{{name}}</span>" with environment suffix tag "<span>{{tag}}</span>"? This action cannot be undo, and will result in the permanent deletion of all your data and account information.',
        description_line2: "Before deleting account, maybe we can help you. <span><a>Contact us via Email</a></span>",
        description_line3: 'If you would like to proceed, please enter the tenant name "<span>{{name}}</span>" to confirm.',
        delete_button: "Permanently delete",
        cannot_delete_title: "Cannot delete this tenant",
        cannot_delete_description: "Sorry, you can't delete this tenant right now. Please make sure you're on the Free Plan and have paid all outstanding billings."
    },
    tenant_landing_page: {
        title: "You haven't created a tenant yet",
        description: "To start configuring your project with Logto, please create a new tenant. If you need to log out or delete your account, just click on the avatar button in the top right corner.",
        create_tenant_button: "Create tenant"
    },
    status: {
        mau_exceeded: "MAU Exceeded",
        suspended: "Suspended",
        overdue: "Overdue"
    },
    tenant_suspended_page: {
        title: "Tenant suspended. Contact us to restore access.",
        description_1: "We deeply regret to inform you that your tenant account has been temporarily suspended due to improper use, including exceeding MAU limits, overdue payments, or other unauthorized actions.",
        description_2: "If you require further clarification, have any concerns, or wish to restore full functionality and unblock your tenants, please do not hesitate to contact us immediately."
    },
    signing_keys: {
        title: "SIGNING KEYS",
        description: "Securely manage signing keys in your tenant.",
        type: {
            private_key: "OIDC private keys",
            cookie_key: "OIDC cookie keys"
        },
        private_keys_in_use: "Private keys in use",
        cookie_keys_in_use: "Cookie keys in use",
        rotate_private_keys: "Rotate private keys",
        rotate_cookie_keys: "Rotate cookie keys",
        rotate_private_keys_description: "This action will create a new private signing key, rotate the current key, and remove your previous key. Your JWT tokens signed with the current key will remain valid until deletion or another round of rotation.",
        rotate_cookie_keys_description: "This action will create a new cookie key, rotate the current key, and remove your previous key. Your cookies with the current key will remain valid until deletion or another round of rotation.",
        select_private_key_algorithm: "Select signing key algorithm for the new private key",
        rotate_button: "Rotate",
        table_column: {
            id: "ID",
            status: "Status",
            algorithm: "Signing key algorithm"
        },
        status: {
            current: "Current",
            previous: "Previous"
        },
        reminder: {
            rotate_private_key: "Are you sure you want to rotate the <strong>OIDC private keys</strong>? New issued JWT tokens will be signed by the new key. Existing JWT tokens stay valid until you rotate again.",
            rotate_cookie_key: "Are you sure you want to rotate the <strong>OIDC cookie keys</strong>? New cookies generated in sign-in sessions will be signed by the new cookie key. Existing cookies stay valid until you rotate again.",
            delete_private_key: "Are you sure you want to delete the <strong>OIDC private key</strong>? Existing JWT tokens signed with this private signing key will no longer be valid.",
            delete_cookie_key: "Are you sure you want to delete the <strong>OIDC cookie key</strong>? Older sign-in sessions with cookies signed with this cookie key will no longer be valid. A re-authentication is required for these users."
        },
        messages: {
            rotate_key_success: "Signing keys rotated successfully.",
            delete_key_success: "Key deleted successfully."
        }
    }
};
var $5ee817679dc8479d$export$2e2bcd8739ae039 = Object.freeze($5ee817679dc8479d$var$tenants);


const $a107dffefe75e6aa$var$topbar = {
    docs: "Docs",
    help: "Help"
};
var $a107dffefe75e6aa$export$2e2bcd8739ae039 = Object.freeze($a107dffefe75e6aa$var$topbar);


const $a7896206eb998b4b$var$paywall = {
    applications: "{{count, number}} application of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    applications_other: "{{count, number}} applications of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine_feature: "Upgrade to the <strong>Hobby</strong> plan to unlock 1 machine-to-machine application, or choose the <strong>Pro</strong> plan for unlimited usage. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine: "{{count, number}} machine-to-machine application of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine_other: "{{count, number}} machine-to-machine applications of <planName/> limit reached. Upgrade plan to meet your team’s needs. For any assistance, feel free to <a>contact us</a>.",
    resources: "{{count, number}} API resource of <planName/> limit reached. Upgrade plan to meet your team’s needs. <a>Contact us</a> for any assistant.",
    resources_other: "{{count, number}} API resources of <planName/> limit reached. Upgrade plan to meet your team’s needs. <a>Contact us</a> for any assistant.",
    scopes_per_resource: "{{count, number}} permission per API resource of <planName/> limit reached. Upgrade now to expand. <a>Contact us</a> for any assistant.",
    scopes_per_resource_other: "{{count, number}} permissions per API resource of <planName/> limit reached. Upgrade now to expand. <a>Contact us</a> for any assistant.",
    custom_domain: "Unlock custom domain functionality by upgrading to <strong>Hobby</strong> or <strong>Pro</strong> plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    social_connectors: "{{count, number}} social connector of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    social_connectors_other: "{{count, number}} social connectors of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_feature: "Upgrade to the <strong>Hobby</strong> or <strong>Pro</strong> plan to create your own connectors using OIDC, OAuth 2.0, and SAML protocols, plus unlimited social connectors and all the premium features. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors: "{{count, number}} social connector of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_other: "{{count, number}} social connectors of <planName/> limit reached. To meet your team’s needs, upgrade plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_pro: "{{count, number}} standard connector of <planName/> limit reached. To meet your team’s needs, upgrade to the Enterprise plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors_pro_other: "{{count, number}} standard connectors of <planName/> limit reached. To meet your team’s needs, upgrade to the Enterprise plan for additional social connectors and the ability to create your own connectors using OIDC, OAuth 2.0, and SAML protocols. Feel free to <a>contact us</a> if you need any assistance.",
    roles: "{{count, number}} role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    roles_other: "{{count, number}} roles of <planName/> limit reached. Upgrade plan to add additional roles and permissions. Feel free to <a>contact us</a> if you need any assistance.",
    scopes_per_role: "{{count, number}} permission per role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. For any assistance, feel free to <a>contact us</a>.",
    scopes_per_role_other: "{{count, number}} permissions per role of <planName/> limit reached. Upgrade plan to add additional roles and permissions. For any assistance, feel free to <a>contact us</a>.",
    hooks: "{{count, number}} webhook of <planName/> limit reached. Upgrade plan to create more webhooks. Feel free to <a>contact us</a> if you need any assistance.",
    hooks_other: "{{count, number}} webhooks of <planName/> limit reached. Upgrade plan to create more webhooks. Feel free to <a>contact us</a> if you need any assistance.",
    mfa: "Unlock MFA to verification security by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $a7896206eb998b4b$export$2e2bcd8739ae039 = Object.freeze($a7896206eb998b4b$var$paywall);


const $f50a3b1b01189890$var$upsell = {
    upgrade_plan: "Upgrade plan",
    compare_plans: "Compare plans",
    view_plans: "View plans",
    create_tenant: {
        title: "Select your tenant plan",
        description: "Logto provides competitive plan options with innovative and affordable pricing designed for growing companies. <a>Learn more</a>",
        base_price: "Base price",
        monthly_price: "{{value, number}}/mo",
        mau_unit_price: "MAU unit price",
        view_all_features: "View all features",
        select_plan: "Select <name/>",
        free_tenants_limit: "Up to {{count, number}} free tenant",
        free_tenants_limit_other: "Up to {{count, number}} free tenants",
        most_popular: "Most popular",
        upgrade_success: "Successfully upgraded to <name/>"
    },
    mau_exceeded_modal: {
        title: "MAU has exceeded the limit. Upgrade your plan.",
        notification: "Your current MAU has exceeded the limit of <planName/>. Please upgrade your plan to premium promptly to avoid suspension of Logto service. ",
        update_plan: "Update Plan"
    },
    payment_overdue_modal: {
        title: "Bill payment overdue",
        notification: "Oops! Payment for tenant <span>{{name}}</span> bill failed. Please pay the bill promptly to avoid suspension of Logto service.",
        unpaid_bills: "Unpaid bills",
        update_payment: "Update Payment"
    },
    paywall: $a7896206eb998b4b$export$2e2bcd8739ae039
};
var $f50a3b1b01189890$export$2e2bcd8739ae039 = Object.freeze($f50a3b1b01189890$var$upsell);


const $dd0d9dc71c0e3278$var$user_details = {
    page_title: "User details",
    back_to_users: "Back to user management",
    created_title: "This user has been successfully created",
    created_guide: "Here’s the information to assist the user with their sign-in process.",
    created_email: "Email address:",
    created_phone: "Phone number:",
    created_username: "Username:",
    created_password: "Password:",
    menu_delete: "Delete",
    delete_description: "This action cannot be undone. It will permanently delete the user.",
    deleted: "The user has been successfully deleted",
    reset_password: {
        reset_password: "Reset password",
        title: "Are you sure you want to reset the password?",
        content: "This action cannot be undone. This will reset the user's log in information.",
        congratulations: "This user has been reset",
        new_password: "New password:"
    },
    tab_settings: "Settings",
    tab_roles: "Roles",
    tab_logs: "User logs",
    tab_organizations: "Organizations",
    authentication: "Authentication",
    authentication_description: "Each user has a profile containing all user information. It consists of basic data, social identities, and custom data.",
    user_profile: "User profile",
    field_email: "Email address",
    field_phone: "Phone number",
    field_username: "Username",
    field_name: "Name",
    field_avatar: "Avatar image URL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Custom data",
    field_custom_data_tip: "Additional user info not listed in the pre-defined user properties, such as user-preferred color and language.",
    field_connectors: "Social connections",
    field_sso_connectors: "Enterprise connections",
    custom_data_invalid: "Custom data must be a valid JSON object",
    connectors: {
        connectors: "Connectors",
        user_id: "User ID",
        remove: "Remove",
        connected: "This user is connected with multiple social connectors.",
        not_connected: "The user is not connected to any social connector",
        deletion_confirmation: "You are removing the existing <name/> identity. Are you sure you want to continue?"
    },
    sso_connectors: {
        connectors: "Connectors",
        enterprise_id: "Enterprise ID",
        connected: "This user is connected to multiple enterprise identity providers for Single Sign-On.",
        not_connected: "The user is not connected to any enterprise identity providers for Single Sign-On."
    },
    mfa: {
        field_name: "Multi-factor authentication",
        field_description: "This user has enabled 2-step verification factors.",
        name_column: "Multi-Factor",
        field_description_empty: "This user has not enabled 2-step verification factors.",
        deletion_confirmation: "You are removing the existing <name/> for the 2-step verification. Are you sure you want to continue?"
    },
    suspended: "Suspended",
    suspend_user: "Suspend user",
    suspend_user_reminder: "Are you sure you want to suspend this user? The user will be unable to sign in to your app and won’t be able to obtain a new access token after the current one expires. Additionally, any API requests made by this user will fail.",
    suspend_action: "Suspend",
    user_suspended: "User has been suspended.",
    reactivate_user: "Reactivate user",
    reactivate_user_reminder: "Are you sure you want to reactivate this user? Doing so will permit any sign-in attempts for this user.",
    reactivate_action: "Reactivate",
    user_reactivated: "User has been reactivated.",
    roles: {
        name_column: "Role",
        description_column: "Description",
        assign_button: "Assign roles",
        delete_description: "This action will remove this role from this user. The role itself will still exist, but it will no longer be associated with this user.",
        deleted: "{{name}} was successfully removed from this user.",
        assign_title: "Assign roles to {{name}}",
        assign_subtitle: "Authorize {{name}} one or more roles",
        assign_role_field: "Assign roles",
        role_search_placeholder: "Search by role name",
        added_text: "{{value, number}} added",
        assigned_user_count: "{{value, number}} users",
        confirm_assign: "Assign roles",
        role_assigned: "Successfully assigned role(s)",
        search: "Search by role name, description or ID",
        empty: "No role available"
    },
    warning_no_sign_in_identifier: "User needs to have at least one of the sign-in identifiers (username, email, phone number or social) to sign in. Are you sure you want to continue?",
    organization_roles_tooltip: "The roles assigned to the user within this organization."
};
var $dd0d9dc71c0e3278$export$2e2bcd8739ae039 = Object.freeze($dd0d9dc71c0e3278$var$user_details);


const $ea339f311b3a70fe$var$users = {
    page_title: "User management",
    title: "User management",
    subtitle: "Manage user identities including creating users, editing user information, viewing user logs, password resets and deleting users",
    create: "Add user",
    create_subtitle: "Provide at least one of the following fields to proceed.",
    error_missing_identifier: "You must provide at least one identifier to create a user.",
    user_name: "User",
    application_name: "From application",
    latest_sign_in: "Latest sign in",
    create_form_username: "Username",
    create_form_password: "Password",
    create_form_name: "Full name",
    placeholder_name: "John/Jane Doe",
    placeholder_email: "jdoe@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+1 (555) 555-5555",
    unnamed: "Unnamed",
    search: "Search by name, email, phone or username",
    check_user_detail: "Check user detail",
    placeholder_title: "User management",
    placeholder_description: "Each user has a profile containing all user information. It consists of basic data, social identities, and custom data."
};
var $ea339f311b3a70fe$export$2e2bcd8739ae039 = Object.freeze($ea339f311b3a70fe$var$users);


const $79467adc0453da5f$var$webhook_details = {
    page_title: "Webhook details",
    back_to_webhooks: "Back to webhooks",
    not_in_use: "Not in use",
    success_rate: "success rate",
    requests: "{{value, number}} requests in 24h",
    disable_webhook: "Disable webhook",
    disable_reminder: "Are you sure you want to reactivate this webhook? Doing so will not send HTTP request to endpoint URL.",
    webhook_disabled: "The webhook has been disabled.",
    webhook_reactivated: "The webhook has been reactivated.",
    reactivate_webhook: "Reactivate webhook",
    delete_webhook: "Delete webhook",
    deletion_reminder: "You are removing this webhook. After deleting it will not send HTTP request to endpoint URL.",
    deleted: "The webhook has been successfully deleted.",
    settings_tab: "Settings",
    recent_requests_tab: "Recent requests (24h)",
    settings: {
        settings: "Settings",
        settings_description: "Webhooks allow you to receive real-time updates on specific events as they happen, by sending a POST request to your endpoint URL. This enables you to take immediate actions based on the new information received.",
        events: "Events",
        events_description: "Select the trigger events which Logto will send the POST request.",
        name: "Name",
        endpoint_url: "Endpoint URL",
        signing_key: "Signing key",
        signing_key_tip: "Add the secret key provided by Logto to your endpoint as a request header to ensure the authenticity of the webhook’s payload.",
        regenerate: "Regenerate",
        regenerate_key_title: "Regenerate signing key",
        regenerate_key_reminder: "Are you sure you want to modify the signing key? Regenerating it will take effect immediately. Please remember to modify the signing key synchronously in your endpoint.",
        regenerated: "Signing key has been regenerated.",
        custom_headers: "Custom headers",
        custom_headers_tip: "Optionally, you can add custom headers to the webhook’s payload to provide additional context or metadata about the event.",
        key_duplicated_error: "Key cannot be repeated.",
        key_missing_error: "Key is required.",
        value_missing_error: "Value is required.",
        invalid_key_error: "Key is invalid",
        invalid_value_error: "Value is invalid",
        test: "Test",
        test_webhook: "Test your webhook",
        test_webhook_description: "Configure the webhook, and test it with payload examples for each selected event to verify correct reception and processing.",
        send_test_payload: "Send test payload",
        test_result: {
            endpoint_url: "Endpoint URL: {{url}}",
            message: "Message: {{message}}",
            response_status: "Response status: {{status, number}}",
            response_body: "Response body: {{body}}",
            request_time: "Request time: {{time}}",
            test_success: "The webhook test to the endpoint was successful."
        }
    }
};
var $79467adc0453da5f$export$2e2bcd8739ae039 = Object.freeze($79467adc0453da5f$var$webhook_details);


const $6b59b0126dd7fbcf$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Create webhooks to effortlessly receive real-time updates regarding specific events.",
    create: "Create Webhook",
    events: {
        post_register: "Create new account",
        post_sign_in: "Sign in",
        post_reset_password: "Reset password"
    },
    table: {
        name: "Name",
        events: "Events",
        success_rate: "Success rate (24h)",
        requests: "Requests (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Create a webhook to receive real-time updates through POST requests to your endpoint URL. Stay informed and take immediate action on events like "Create account", "Sign in", and "Reset password".',
        create_webhook: "Create Webhook"
    },
    create_form: {
        title: "Create Webhook",
        subtitle: "Add the Webhook to send a POST request to the endpoint URL with details of any users events.",
        events: "Events",
        events_description: "Select the trigger events which Logto will send the POST request.",
        name: "Name",
        name_placeholder: "Enter webhook name",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Create webhook",
        missing_event_error: "You have to select at least one event."
    },
    webhook_created: "The webhook {{name}} has been successfully created."
};
var $6b59b0126dd7fbcf$export$2e2bcd8739ae039 = Object.freeze($6b59b0126dd7fbcf$var$webhooks);


const $3152b7afde30b2e2$var$welcome = {
    title: "Welcome to Admin Console",
    description: "Admin console is a web app to manage Logto without coding requirements. Let’s first create an account. With this account, you can manage Logto by yourself or on behalf of your company.",
    create_account: "Create account"
};
var $3152b7afde30b2e2$export$2e2bcd8739ae039 = Object.freeze($3152b7afde30b2e2$var$welcome);


const $5a883105b606a6d6$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $16da0791b566b3c2$export$2e2bcd8739ae039,
    general: $220fae253a8b0423$export$2e2bcd8739ae039,
    errors: $40578e457ba25d7d$export$2e2bcd8739ae039,
    tab_sections: $2e6d53bbe1ab3da3$export$2e2bcd8739ae039,
    tabs: $73616e1f58c351a2$export$2e2bcd8739ae039,
    applications: $faf013916162b710$export$2e2bcd8739ae039,
    application_details: $933af3cae54c125d$export$2e2bcd8739ae039,
    api_resources: $091a987284e983bc$export$2e2bcd8739ae039,
    api_resource_details: $f760eb43ac49093f$export$2e2bcd8739ae039,
    connectors: $f8b6937bb1831367$export$2e2bcd8739ae039,
    connector_details: $a35589b0c8601b6b$export$2e2bcd8739ae039,
    enterprise_sso: $c5d96846aa224802$export$2e2bcd8739ae039,
    enterprise_sso_details: $081d095a394cb948$export$2e2bcd8739ae039,
    get_started: $b3b20a0b1efe3305$export$2e2bcd8739ae039,
    users: $ea339f311b3a70fe$export$2e2bcd8739ae039,
    user_details: $dd0d9dc71c0e3278$export$2e2bcd8739ae039,
    contact: $efe5e5a2a751301d$export$2e2bcd8739ae039,
    sign_in_exp: $a4750467137ed51b$export$2e2bcd8739ae039,
    dashboard: $bf974927c465f55b$export$2e2bcd8739ae039,
    logs: $a5ea856c0c1bf5ef$export$2e2bcd8739ae039,
    log_details: $2623f8e70d6346ba$export$2e2bcd8739ae039,
    session_expired: $700cee405a1a2537$export$2e2bcd8739ae039,
    welcome: $3152b7afde30b2e2$export$2e2bcd8739ae039,
    roles: $ab4d3f6b6497c357$export$2e2bcd8739ae039,
    role_details: $7c429f6e9fd81451$export$2e2bcd8739ae039,
    permissions: $52bc5557ae369b52$export$2e2bcd8739ae039,
    cloud: $31a3d3e3594de50c$export$2e2bcd8739ae039,
    profile: $78c84cd8ac574bba$export$2e2bcd8739ae039,
    components: $88b3f4545724b997$export$2e2bcd8739ae039,
    webhooks: $6b59b0126dd7fbcf$export$2e2bcd8739ae039,
    webhook_details: $79467adc0453da5f$export$2e2bcd8739ae039,
    domain: $6bab07fe1fdbb89f$export$2e2bcd8739ae039,
    tenants: $5ee817679dc8479d$export$2e2bcd8739ae039,
    topbar: $a107dffefe75e6aa$export$2e2bcd8739ae039,
    subscription: $7e899226b543a216$export$2e2bcd8739ae039,
    upsell: $f50a3b1b01189890$export$2e2bcd8739ae039,
    guide: $83c15cbad3bb7a64$export$2e2bcd8739ae039,
    mfa: $639859ce6092ecf5$export$2e2bcd8739ae039,
    organizations: $05d31e3f485f3e09$export$2e2bcd8739ae039,
    organization_details: $7ec15209c86438de$export$2e2bcd8739ae039
};
var $5a883105b606a6d6$export$2e2bcd8739ae039 = Object.freeze($5a883105b606a6d6$var$admin_console);


const $f0918f85f248c7c3$var$demo_app = {
    title: "You've successfully signed in the live preview!",
    subtitle: "Here is your log in information:",
    username: "Username: ",
    user_id: "User ID: ",
    sign_out: "Sign out the live preview",
    continue_explore: "Or continue to explore",
    customize_sign_in_experience: "Customize sign-in experience",
    enable_passwordless: "Enable passwordless",
    add_social_connector: "Add social connector"
};
var $f0918f85f248c7c3$export$2e2bcd8739ae039 = Object.freeze($f0918f85f248c7c3$var$demo_app);


const $2bc9c2822eda7905$var$oidc = {
    logout_success: "You have successfully signed out."
};
var $2bc9c2822eda7905$export$2e2bcd8739ae039 = Object.freeze($2bc9c2822eda7905$var$oidc);


const $23f1b07460d4e7e8$var$translation = {
    admin_console: $5a883105b606a6d6$export$2e2bcd8739ae039,
    demo_app: $f0918f85f248c7c3$export$2e2bcd8739ae039,
    oidc: $2bc9c2822eda7905$export$2e2bcd8739ae039
};
var $23f1b07460d4e7e8$export$2e2bcd8739ae039 = Object.freeze($23f1b07460d4e7e8$var$translation);


const $e0185af096ff629c$var$en = {
    translation: $23f1b07460d4e7e8$export$2e2bcd8739ae039,
    errors: $9ad6ab3b50abfbd8$export$2e2bcd8739ae039
};
var $e0185af096ff629c$export$2e2bcd8739ae039 = Object.freeze($e0185af096ff629c$var$en);


const $3f1a59fc14bb1c4d$var$application = {
    invalid_type: "Solo las aplicaciones de m\xe1quina a m\xe1quina pueden tener roles asociados.",
    role_exists: "La identificaci\xf3n del rol {{roleId}} ya se ha agregado a esta aplicaci\xf3n.",
    invalid_role_type: "No se puede asignar un rol de tipo usuario a una aplicaci\xf3n de m\xe1quina a m\xe1quina."
};
var $3f1a59fc14bb1c4d$export$2e2bcd8739ae039 = Object.freeze($3f1a59fc14bb1c4d$var$application);


const $8d31ea9d72f67859$var$auth = {
    authorization_header_missing: "Falta encabezado de autorizaci\xf3n.",
    authorization_token_type_not_supported: "Tipo de autorizaci\xf3n no admitido.",
    unauthorized: "No autorizado. Por favor, revise las credenciales y su alcance.",
    forbidden: "Prohibido. Por favor, revise sus roles y permisos de usuario.",
    expected_role_not_found: "Rol esperado no encontrado. Por favor, revise sus roles y permisos de usuario.",
    jwt_sub_missing: "Falta `sub` en JWT.",
    require_re_authentication: "Se requiere una nueva autenticaci\xf3n para realizar una acci\xf3n protegida."
};
var $8d31ea9d72f67859$export$2e2bcd8739ae039 = Object.freeze($8d31ea9d72f67859$var$auth);


const $387562de842b5931$var$connector = {
    general: "Se produjo un error en el conector: {{errorDescription}}",
    not_found: "No se puede encontrar ning\xfan conector disponible para el tipo: {{type}}.",
    not_enabled: "El conector no est\xe1 habilitado.",
    invalid_metadata: "Los metadatos del conector son inv\xe1lidos.",
    invalid_config_guard: "El guardia de configuraci\xf3n del conector es inv\xe1lido.",
    unexpected_type: "El tipo del conector es inesperado.",
    invalid_request_parameters: "La solicitud contiene par\xe1metros de entrada incorrectos.",
    insufficient_request_parameters: "La solicitud puede faltar algunos par\xe1metros de entrada.",
    invalid_config: "La configuraci\xf3n del conector es inv\xe1lida.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "La respuesta del conector es inv\xe1lida.",
    template_not_found: "No se puede encontrar la plantilla correcta en la configuraci\xf3n del conector.",
    template_not_supported: "El conector no admite este tipo de plantilla.",
    rate_limit_exceeded: "L\xedmite de frecuencia activado. Por favor, int\xe9ntalo de nuevo m\xe1s tarde.",
    not_implemented: "{{method}}: a\xfan no se ha implementado.",
    social_invalid_access_token: "El token de acceso del conector es inv\xe1lido.",
    invalid_auth_code: "El c\xf3digo de autenticaci\xf3n del conector es inv\xe1lido.",
    social_invalid_id_token: "El token de identificaci\xf3n del conector es inv\xe1lido.",
    authorization_failed: "El proceso de autorizaci\xf3n del usuario no tuvo \xe9xito.",
    social_auth_code_invalid: "No se puede obtener el token de acceso, por favor revise el c\xf3digo de autorizaci\xf3n.",
    more_than_one_sms: "El n\xfamero de conectores de SMS es mayor que 1.",
    more_than_one_email: "El n\xfamero de conectores de correo electr\xf3nico es mayor que 1.",
    more_than_one_connector_factory: "Se encontraron m\xfaltiples f\xe1bricas de conectores (con ID {{connectorIds}}), puede desinstalar las innecesarias.",
    db_connector_type_mismatch: "Hay un conector en la base de datos que no coincide con el tipo.",
    not_found_with_connector_id: "No se puede encontrar el conector con el ID est\xe1ndar de conector proporcionado.",
    multiple_instances_not_supported: "No se pueden crear m\xfaltiples instancias con el conector est\xe1ndar seleccionado.",
    invalid_type_for_syncing_profile: "Solo puede sincronizar el perfil de usuario con conectores sociales.",
    can_not_modify_target: "No se puede modificar el 'objetivo' del conector.",
    should_specify_target: "Debe especificar el 'objetivo'.",
    multiple_target_with_same_platform: "No puede tener m\xfaltiples conectores sociales que tengan el mismo objetivo y plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Los 'metadatos' de este conector no se pueden sobrescribir."
};
var $387562de842b5931$export$2e2bcd8739ae039 = Object.freeze($387562de842b5931$var$connector);


const $ab19d39c9173e40d$var$domain = {
    not_configured: "El proveedor de nombres de dominio del host no est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data falta, por favor revise.",
    cloudflare_unknown_error: "Se produjo un error desconocido al solicitar la API de Cloudflare",
    cloudflare_response_error: "Recibi\xf3 una respuesta inesperada de Cloudflare.",
    limit_to_one_domain: "Solo puedes tener un dominio personalizado.",
    hostname_already_exists: "Este dominio ya existe en nuestro servidor.",
    cloudflare_not_found: "No se puede encontrar el nombre de host en Cloudflare"
};
var $ab19d39c9173e40d$export$2e2bcd8739ae039 = Object.freeze($ab19d39c9173e40d$var$domain);


const $67cd865cbeaa10b2$var$entity = {
    invalid_input: "Entrada no v\xe1lida. La lista de valores no debe estar vac\xeda.",
    create_failed: "Fallo al crear {{name}}.",
    db_constraint_violated: "Violaci\xf3n de restricci\xf3n de base de datos.",
    not_exists: "El {{name}} no existe.",
    not_exists_with_id: "El {{name}} con ID `{{id}}` no existe.",
    not_found: "El recurso no existe.",
    relation_foreign_key_not_found: "No se pueden encontrar una o m\xe1s claves for\xe1neas. Por favor, verifique la entrada y aseg\xfarese de que todas las entidades referenciadas existan.",
    unique_integrity_violation: "La entidad ya existe. Por favor, verifique la entrada e intente\\lo de nuevo."
};
var $67cd865cbeaa10b2$export$2e2bcd8739ae039 = Object.freeze($67cd865cbeaa10b2$var$entity);


const $4d75c6e7e248af89$var$guard = {
    invalid_input: "La solicitud {{type}} es inv\xe1lida.",
    invalid_pagination: "El valor de paginaci\xf3n de la solicitud es inv\xe1lido.",
    can_not_get_tenant_id: "No se puede obtener el ID del inquilino de la solicitud.",
    file_size_exceeded: "Se excedi\xf3 el tama\xf1o del archivo.",
    mime_type_not_allowed: "El tipo MIME no est\xe1 permitido."
};
var $4d75c6e7e248af89$export$2e2bcd8739ae039 = Object.freeze($4d75c6e7e248af89$var$guard);


const $532f80f78aafe75d$var$hook = {
    missing_events: "Necesita proporcionar al menos un evento.",
    send_test_payload_failed: "Error al enviar carga \xfatil de prueba: {{message}}",
    endpoint_responded_with_error: "El punto de enlace respondi\xf3 con un error."
};
var $532f80f78aafe75d$export$2e2bcd8739ae039 = Object.freeze($532f80f78aafe75d$var$hook);


const $971fae4a9961972d$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est\xe1 establecido como tu idioma predeterminado y no se puede eliminar.",
    invalid_translation_structure: "Estructuras de datos no v\xe1lidas. Por favor, verifica tu entrada e intenta de nuevo."
};
var $971fae4a9961972d$export$2e2bcd8739ae039 = Object.freeze($971fae4a9961972d$var$localization);


const $2a91010e7997b97e$var$log = {
    invalid_type: "El tipo de registro es inv\xe1lido."
};
var $2a91010e7997b97e$export$2e2bcd8739ae039 = Object.freeze($2a91010e7997b97e$var$log);


const $98ebb1689e193183$var$oidc = {
    aborted: "El usuario final abort\xf3 la interacci\xf3n.",
    invalid_scope: "\xc1mbito no v\xe1lido: {{error_description}}.",
    invalid_token: "Se proporcion\xf3 un token no v\xe1lido.",
    invalid_client_metadata: "Se proporcionaron metadatos de cliente no v\xe1lidos.",
    insufficient_scope: "Falta el \xe1mbito del token `{{scope}}`.",
    invalid_request: "La solicitud no es v\xe1lida.",
    invalid_grant: "La concesi\xf3n no es v\xe1lida.",
    invalid_redirect_uri: "La `redirect_uri` no coincide con ninguna de las `redirect_uris` registradas del cliente.",
    access_denied: "Acceso denegado.",
    invalid_target: "Indicador de recurso no v\xe1lido.",
    unsupported_grant_type: "Se solicit\xf3 un tipo de concesi\xf3n no admitido.",
    unsupported_response_mode: "Se solicit\xf3 un modo de respuesta no compatible.",
    unsupported_response_type: "Se solicit\xf3 un tipo de respuesta no admitido.",
    provider_error: "Error interno de OIDC: {{message}}.",
    server_error: "Ocurri\xf3 un error desconocido de OIDC. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    provider_error_fallback: "Ocurri\xf3 un error de OIDC: {{code}}.",
    key_required: "Se requiere al menos una clave.",
    key_not_found: "No se encuentra la clave con ID {{id}}."
};
var $98ebb1689e193183$export$2e2bcd8739ae039 = Object.freeze($98ebb1689e193183$var$oidc);


const $0cedc9d12b37e8a5$var$organization = {
    require_membership: "El usuario debe ser miembro de la organizaci\xf3n para continuar."
};
var $0cedc9d12b37e8a5$export$2e2bcd8739ae039 = Object.freeze($0cedc9d12b37e8a5$var$organization);


const $74f160f609b24679$var$password = {
    unsupported_encryption_method: "El m\xe9todo de encriptaci\xf3n {{name}} no es compatible.",
    pepper_not_found: "No se encontr\xf3 el password pepper. Por favor revisa tus variables de entorno.",
    rejected: "Contrase\xf1a rechazada. Por favor verifica que tu contrase\xf1a cumpla con los requisitos."
};
var $74f160f609b24679$export$2e2bcd8739ae039 = Object.freeze($74f160f609b24679$var$password);


const $c91a78c42ad69223$var$request = {
    invalid_input: "La entrada no es v\xe1lida. {{detalles}}",
    general: "Ocurri\xf3 un error en la solicitud."
};
var $c91a78c42ad69223$export$2e2bcd8739ae039 = Object.freeze($c91a78c42ad69223$var$request);


const $cea155ea899b4ac9$var$resource = {
    resource_identifier_in_use: '"El identificador de API {{indicator}} ya est\xe1 en uso'
};
var $cea155ea899b4ac9$export$2e2bcd8739ae039 = Object.freeze($cea155ea899b4ac9$var$resource);


const $6e5112a468272ec9$var$role = {
    name_in_use: "Este nombre de rol {{name}} ya est\xe1 en uso",
    scope_exists: "El id de alcance {{scopeId}} ya ha sido agregado a este rol",
    user_exists: "El id de usuario {{userId}} ya ha sido agregado a este rol",
    application_exists: "El id de aplicaci\xf3n {{applicationId}} ya ha sido agregado a este rol",
    default_role_missing: "Algunos de los nombres de roles predeterminados no existen en la base de datos, por favor aseg\xfarese de crear los roles primero",
    internal_role_violation: 'Tal vez est\xe9 intentando actualizar o eliminar un rol interno lo cual es prohibido por Logto. Si est\xe1 creando un nuevo rol, intente con otro nombre que no empiece con "#internal:".'
};
var $6e5112a468272ec9$export$2e2bcd8739ae039 = Object.freeze($6e5112a468272ec9$var$role);


const $b140178e3f2624dc$var$scope = {
    name_exists: "El nombre del \xe1mbito {{name}} ya est\xe1 en uso",
    name_with_space: "El nombre del \xe1mbito no puede contener espacios."
};
var $b140178e3f2624dc$export$2e2bcd8739ae039 = Object.freeze($b140178e3f2624dc$var$scope);


const $d2616530237c75cb$var$session = {
    not_found: "Sesi\xf3n no encontrada. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    invalid_credentials: "Cuenta o contrase\xf1a incorrecta. Verifique su entrada.",
    invalid_sign_in_method: "El m\xe9todo de inicio de sesi\xf3n actual no est\xe1 disponible.",
    invalid_connector_id: "No se puede encontrar un conector disponible con el id {{connectorId}}.",
    insufficient_info: "Informaci\xf3n de inicio de sesi\xf3n insuficiente.",
    connector_id_mismatch: "El identificador del conector no coincide con el registro de la sesi\xf3n.",
    connector_session_not_found: "No se encuentra la sesi\xf3n del conector. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    verification_session_not_found: "La verificaci\xf3n no se complet\xf3 correctamente. Reinicie el flujo de verificaci\xf3n e intente de nuevo.",
    verification_expired: "La conexi\xf3n ha expirado. Verifique de nuevo para garantizar la seguridad de su cuenta.",
    verification_blocked_too_many_attempts: "Demasiados intentos en poco tiempo. Por favor, int\xe9ntelo de nuevo {{relativeTime}}.",
    unauthorized: "Inicie sesi\xf3n primero, por favor.",
    unsupported_prompt_name: "Nombre de indicaci\xf3n no compatible.",
    forgot_password_not_enabled: "Olvid\xe9 la contrase\xf1a no est\xe1 habilitada.",
    verification_failed: "La verificaci\xf3n no se complet\xf3 correctamente. Reinicie el flujo de verificaci\xf3n e intente de nuevo.",
    connector_validation_session_not_found: "No se encuentra la sesi\xf3n del conector para la validaci\xf3n del token.",
    identifier_not_found: "Identificador de usuario no encontrado. Vuelva atr\xe1s e inicie sesi\xf3n nuevamente.",
    interaction_not_found: "No se encuentra la sesi\xf3n de interacci\xf3n. Vuelva atr\xe1s y vuelva a iniciar la sesi\xf3n.",
    not_supported_for_forgot_password: "Esta operaci\xf3n no es compatible para restablecer la contrase\xf1a.",
    mfa: {
        require_mfa_verification: "Se requiere verificaci\xf3n de MFA para iniciar sesi\xf3n.",
        mfa_sign_in_only: "MFA solo est\xe1 disponible para la interacci\xf3n de inicio de sesi\xf3n.",
        pending_info_not_found: "Informaci\xf3n de MFA pendiente no encontrada, por favor inicie MFA primero.",
        invalid_totp_code: "C\xf3digo TOTP no v\xe1lido.",
        webauthn_verification_failed: "Fallo en la verificaci\xf3n de WebAuthn.",
        webauthn_verification_not_found: "Verificaci\xf3n de WebAuthn no encontrada.",
        bind_mfa_existed: "MFA ya existe.",
        backup_code_can_not_be_alone: "El c\xf3digo de respaldo no puede ser el \xfanico MFA.",
        backup_code_required: "Se requiere el c\xf3digo de respaldo.",
        invalid_backup_code: "C\xf3digo de respaldo no v\xe1lido.",
        mfa_policy_not_user_controlled: "La pol\xedtica de MFA no est\xe1 controlada por el usuario."
    },
    sso_enabled: "El inicio de sesi\xf3n \xfanico est\xe1 habilitado para este correo electr\xf3nico dado. Inicie sesi\xf3n con SSO, por favor."
};
var $d2616530237c75cb$export$2e2bcd8739ae039 = Object.freeze($d2616530237c75cb$var$session);


const $434b628582c2721b$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de contenido vac\xedo de "T\xe9rminos de uso". Por favor, agregue la URL de contenido si "T\xe9rminos de uso" est\xe1 habilitado.',
    empty_social_connectors: "Conectores sociales vac\xedos. Por favor, agregue conectores sociales habilitados cuando se habilita el m\xe9todo de inicio de sesi\xf3n social.",
    enabled_connector_not_found: "No se encontr\xf3 el conector {{type}} habilitado.",
    not_one_and_only_one_primary_sign_in_method: "Debe haber un \xfanico m\xe9todo de inicio de sesi\xf3n primario. Por favor revise su entrada.",
    username_requires_password: "Debe habilitar la configuraci\xf3n de contrase\xf1a para el identificador de registro de nombre de usuario.",
    passwordless_requires_verify: "Debe habilitar la verificaci\xf3n para el identificador de registro de correo electr\xf3nico/n\xfamero de tel\xe9fono.",
    miss_sign_up_identifier_in_sign_in: "Los m\xe9todos de inicio de sesi\xf3n deben contener el identificador de registro.",
    password_sign_in_must_be_enabled: "La firma de contrase\xf1a debe estar habilitada cuando se requiere una contrase\xf1a en el registro.",
    code_sign_in_must_be_enabled: "La firma de c\xf3digo de verificaci\xf3n debe estar habilitada cuando no se requiere contrase\xf1a en el registro.",
    unsupported_default_language: "Este lenguaje - {{language}} no es compatible en este momento.",
    at_least_one_authentication_factor: "Debe seleccionar al menos un factor de autenticaci\xf3n.",
    backup_code_cannot_be_enabled_alone: "El c\xf3digo de respaldo no se puede habilitar solo.",
    duplicated_mfa_factors: "Factores MFA duplicados."
};
var $434b628582c2721b$export$2e2bcd8739ae039 = Object.freeze($434b628582c2721b$var$sign_in_experiences);


const $0f918e8151955173$var$single_sign_on = {
    forbidden_domains: "Los dominios de correo electr\xf3nico p\xfablico no est\xe1n permitidos.",
    duplicated_domains: "Hay dominios duplicados.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $0f918e8151955173$export$2e2bcd8739ae039 = Object.freeze($0f918e8151955173$var$single_sign_on);


const $eedd0a9f9a4a34f4$var$storage = {
    not_configured: "Proveedor de almacenamiento no est\xe1 configurado.",
    missing_parameter: "Falta el par\xe1metro {{parameter}} para el proveedor de almacenamiento.",
    upload_error: "Error al cargar el archivo al proveedor de almacenamiento."
};
var $eedd0a9f9a4a34f4$export$2e2bcd8739ae039 = Object.freeze($eedd0a9f9a4a34f4$var$storage);


const $d2acac94f2472ec2$var$subscription = {
    limit_exceeded: "Has alcanzado el l\xedmite de tu plan de suscripci\xf3n.",
    get_plan_failed: "No se pudo obtener el plan de suscripci\xf3n para el inquilino.",
    tenant_suspended: "El inquilino est\xe1 suspendido. Por favor, contacta con tu administrador."
};
var $d2acac94f2472ec2$export$2e2bcd8739ae039 = Object.freeze($d2acac94f2472ec2$var$subscription);


const $8d279bf868747276$var$swagger = {
    invalid_zod_type: "Tipo Zod inv\xe1lido. Por favor, verifique la configuraci\xf3n del guardia de ruta.",
    not_supported_zod_type_for_params: "Tipo Zod no soportado para los par\xe1metros. Por favor, verifique la configuraci\xf3n del guardia de ruta."
};
var $8d279bf868747276$export$2e2bcd8739ae039 = Object.freeze($8d279bf868747276$var$swagger);


const $23c1176ad847bd34$var$user = {
    username_already_in_use: "Este nombre de usuario ya est\xe1 en uso.",
    email_already_in_use: "Este correo electr\xf3nico est\xe1 asociado a una cuenta existente.",
    phone_already_in_use: "Este n\xfamero de tel\xe9fono est\xe1 asociado a una cuenta existente.",
    invalid_email: "Direcci\xf3n de correo electr\xf3nico inv\xe1lida.",
    invalid_phone: "N\xfamero de tel\xe9fono inv\xe1lido.",
    email_not_exist: "La direcci\xf3n de correo electr\xf3nico no ha sido registrada a\xfan.",
    phone_not_exist: "El n\xfamero de tel\xe9fono no ha sido registrado a\xfan.",
    identity_not_exist: "La cuenta social no ha sido registrada a\xfan.",
    identity_already_in_use: "La cuenta social ha sido asociada a una cuenta existente.",
    social_account_exists_in_profile: "Ya has asociado esta cuenta social.",
    cannot_delete_self: "No puedes eliminarte a ti mismo.",
    sign_up_method_not_enabled: "Este m\xe9todo de registro no est\xe1 habilitado.",
    sign_in_method_not_enabled: "Este m\xe9todo de inicio de sesi\xf3n no est\xe1 habilitado.",
    same_password: "La nueva contrase\xf1a no puede ser igual a la anterior.",
    password_required_in_profile: "Debes establecer una contrase\xf1a antes de iniciar sesi\xf3n.",
    new_password_required_in_profile: "Debes establecer una nueva contrase\xf1a.",
    password_exists_in_profile: "La contrase\xf1a ya existe en tu perfil.",
    username_required_in_profile: "Debes establecer un nombre de usuario antes de iniciar sesi\xf3n.",
    username_exists_in_profile: "El nombre de usuario ya existe en tu perfil.",
    email_required_in_profile: "Debes agregar una direcci\xf3n de correo electr\xf3nico antes de iniciar sesi\xf3n.",
    email_exists_in_profile: "Tu perfil ya est\xe1 asociado a una direcci\xf3n de correo electr\xf3nico.",
    phone_required_in_profile: "Debes agregar un n\xfamero de tel\xe9fono antes de iniciar sesi\xf3n.",
    phone_exists_in_profile: "Tu perfil ya est\xe1 asociado a un n\xfamero de tel\xe9fono.",
    email_or_phone_required_in_profile: "Debes agregar una direcci\xf3n de correo electr\xf3nico o un n\xfamero de tel\xe9fono antes de iniciar sesi\xf3n.",
    suspended: "Esta cuenta ha sido suspendida.",
    user_not_exist: "No existe un usuario con {{ identifier }}.",
    missing_profile: "Debes proporcionar informaci\xf3n adicional antes de iniciar sesi\xf3n.",
    role_exists: "El id de rol {{roleId}} ya ha sido agregado a este usuario",
    invalid_role_type: "Tipo de rol no v\xe1lido, no se puede asignar un rol de m\xe1quina a m\xe1quina a un usuario.",
    missing_mfa: "Debes vincular un MFA adicional antes de iniciar sesi\xf3n.",
    totp_already_in_use: "TOTP ya est\xe1 en uso.",
    backup_code_already_in_use: "El c\xf3digo de respaldo ya est\xe1 en uso."
};
var $23c1176ad847bd34$export$2e2bcd8739ae039 = Object.freeze($23c1176ad847bd34$var$user);


const $7c6721f5c7e623f1$var$verification_code = {
    phone_email_empty: "Tanto el tel\xe9fono como el correo electr\xf3nico est\xe1n vac\xedos.",
    not_found: "No se encontr\xf3 el c\xf3digo de verificaci\xf3n. Por favor enviar primero el c\xf3digo de verificaci\xf3n.",
    phone_mismatch: "Tel\xe9fono no coincide. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    email_mismatch: "Correo electr\xf3nico no coincide. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    code_mismatch: "C\xf3digo de verificaci\xf3n inv\xe1lido.",
    expired: "El c\xf3digo de verificaci\xf3n ha caducado. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n.",
    exceed_max_try: "Se ha superado el l\xedmite de intentos de verificaci\xf3n de c\xf3digo. Por favor solicite un nuevo c\xf3digo de verificaci\xf3n."
};
var $7c6721f5c7e623f1$export$2e2bcd8739ae039 = Object.freeze($7c6721f5c7e623f1$var$verification_code);


const $b2c922d570d2d6ad$var$errors = {
    request: $c91a78c42ad69223$export$2e2bcd8739ae039,
    auth: $8d31ea9d72f67859$export$2e2bcd8739ae039,
    guard: $4d75c6e7e248af89$export$2e2bcd8739ae039,
    oidc: $98ebb1689e193183$export$2e2bcd8739ae039,
    user: $23c1176ad847bd34$export$2e2bcd8739ae039,
    password: $74f160f609b24679$export$2e2bcd8739ae039,
    session: $d2616530237c75cb$export$2e2bcd8739ae039,
    connector: $387562de842b5931$export$2e2bcd8739ae039,
    verification_code: $7c6721f5c7e623f1$export$2e2bcd8739ae039,
    sign_in_experiences: $434b628582c2721b$export$2e2bcd8739ae039,
    localization: $971fae4a9961972d$export$2e2bcd8739ae039,
    swagger: $8d279bf868747276$export$2e2bcd8739ae039,
    entity: $67cd865cbeaa10b2$export$2e2bcd8739ae039,
    log: $2a91010e7997b97e$export$2e2bcd8739ae039,
    role: $6e5112a468272ec9$export$2e2bcd8739ae039,
    scope: $b140178e3f2624dc$export$2e2bcd8739ae039,
    storage: $eedd0a9f9a4a34f4$export$2e2bcd8739ae039,
    resource: $cea155ea899b4ac9$export$2e2bcd8739ae039,
    hook: $532f80f78aafe75d$export$2e2bcd8739ae039,
    domain: $ab19d39c9173e40d$export$2e2bcd8739ae039,
    subscription: $d2acac94f2472ec2$export$2e2bcd8739ae039,
    application: $3f1a59fc14bb1c4d$export$2e2bcd8739ae039,
    organization: $0cedc9d12b37e8a5$export$2e2bcd8739ae039,
    single_sign_on: $0f918e8151955173$export$2e2bcd8739ae039
};
var $b2c922d570d2d6ad$export$2e2bcd8739ae039 = Object.freeze($b2c922d570d2d6ad$var$errors);


const $3c295fc3ab984b89$var$api_resource_details = {
    page_title: "Detalles del recurso de la API",
    back_to_api_resources: "Volver a los recursos de la API",
    settings_tab: "Configuraci\xf3n",
    permissions_tab: "Permisos",
    settings: "Configuraci\xf3n",
    settings_description: "Los recursos de la API, tambi\xe9n conocidos como indicadores de recurso, indican los servicios o recursos de destino que se solicitar\xe1n, generalmente, una variable de formato URI que representa la identidad del recurso.",
    management_api_settings_description: "La API de administraci\xf3n de Logto es una colecci\xf3n completa de API que permiten a los administradores administrar una amplia gama de tareas relacionadas con la identidad, hacer cumplir pol\xedticas de seguridad y cumplir con regulaciones y est\xe1ndares.",
    management_api_notice: "Esta API representa una entidad de Logto y no se puede modificar ni eliminar. Puede utilizar la API de administraci\xf3n para una amplia gama de tareas relacionadas con la identidad. <a>Obtener m\xe1s informaci\xf3n</a>",
    token_expiration_time_in_seconds: "Tiempo de expiraci\xf3n del token (en segundos)",
    token_expiration_time_in_seconds_placeholder: "Ingrese el tiempo de expiraci\xf3n de su token",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente el recurso de la API. Por favor, ingrese el nombre del recurso de la API <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Ingrese el nombre de su recurso de API",
    api_resource_deleted: "El recurso de API {{name}} ha sido eliminado exitosamente",
    permission: {
        create_button: "Crear permiso",
        create_title: "Crear permiso",
        create_subtitle: "Define los permisos (scopes) necesarios para esta API.",
        confirm_create: "Crear permiso",
        name: "Nombre del permiso",
        name_placeholder: "leer:recurso",
        forbidden_space_in_name: "El nombre del permiso no debe contener espacios.",
        description: "Descripci\xf3n",
        description_placeholder: "Capacidad para leer los recursos",
        permission_created: "El permiso {{name}} se ha creado correctamente",
        delete_description: "Si se elimina este permiso, el usuario que ten\xeda este permiso perder\xe1 el acceso otorgado por \xe9l.",
        deleted: '\xa1El permiso "{{name}}" se elimin\xf3 con \xe9xito.'
    }
};
var $3c295fc3ab984b89$export$2e2bcd8739ae039 = Object.freeze($3c295fc3ab984b89$var$api_resource_details);


const $c016f14036243b84$var$api_resources = {
    page_title: "Recursos de API",
    title: "Recursos de API",
    subtitle: "Define APIs que las aplicaciones autorizadas pueden utilizar",
    create: "Crear recurso de API",
    api_name: "Nombre de la API",
    api_name_placeholder: "Ingrese el nombre de su API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "El identificador \xfanico para el recurso de API. Debe ser una URI absoluta y no tiene componente de fragmento (#). Es igual al <a>par\xe1metro de recurso</a> en OAuth 2.0.",
    default_api: "API por defecto",
    default_api_label: "S\xf3lo se puede establecer cero o una API por defecto por inquilino. Cuando se designa una API por defecto, el par\xe1metro de recurso se puede omitir en la solicitud de autenticaci\xf3n. Las posteriores intercambios de tokens utilizar\xe1n esa API como audiencia por defecto, lo que dar\xe1 lugar a la emisi\xf3n de JWTs. <a>Obtener m\xe1s informaci\xf3n</a>",
    api_resource_created: "El recurso de API {{name}} se ha creado correctamente"
};
var $c016f14036243b84$export$2e2bcd8739ae039 = Object.freeze($c016f14036243b84$var$api_resources);


const $1a8f819cd53b0fa3$var$application_details = {
    page_title: "Detalles de la aplicaci\xf3n",
    back_to_applications: "Volver a Aplicaciones",
    check_guide: "Revisar Gu\xeda",
    settings: "Configuraciones",
    settings_description: "Las aplicaciones se utilizan para identificar tus aplicaciones en Logto para OIDC, experiencia de inicio de sesi\xf3n, registros de auditor\xeda, etc.",
    advanced_settings: "Configuraciones avanzadas",
    advanced_settings_description: "Las configuraciones avanzadas incluyen t\xe9rminos relacionados con OIDC. Puedes revisar el Endpoint del Token para obtener m\xe1s informaci\xf3n.",
    application_roles: "Roles de Aplicaci\xf3n",
    machine_logs: "Registros de M\xe1quina",
    application_name: "Nombre de Aplicaci\xf3n",
    application_name_placeholder: "Mi App",
    description: "Descripci\xf3n",
    description_placeholder: "Ingresa la descripci\xf3n de tu aplicaci\xf3n",
    config_endpoint: "Endpoint de configuraci\xf3n del proveedor OpenID",
    authorization_endpoint: "Endpoint de Autorizaci\xf3n",
    authorization_endpoint_tip: "El endpoint para la autenticaci\xf3n y autorizaci\xf3n. Se utiliza para OpenID Connect <a>Autenticaci\xf3n</a>.",
    logto_endpoint: "Endpoint de Logto",
    application_id: "ID de Aplicaci\xf3n",
    application_id_tip: "El identificador de aplicaci\xf3n \xfanico normalmente generado por Logto. Tambi\xe9n se conoce como “<a>client_id</a>” en OpenID Connect.",
    application_secret: "Aplicaci\xf3n Secreta",
    redirect_uri: "URI de Redireccionamiento",
    redirect_uris: "URIs de Redireccionamiento",
    redirect_uri_placeholder: "https://tu.pagina.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "El URI hacia donde se redirecciona despu\xe9s de que un usuario inicie sesi\xf3n (correctamente o no). Consulta OpenID Connect <a>AuthRequest</a> para m\xe1s informaci\xf3n.",
    post_sign_out_redirect_uri: "Post Sign-out URI de Redireccionamiento",
    post_sign_out_redirect_uris: "Post Sign-out URIs de Redireccionamiento",
    post_sign_out_redirect_uri_placeholder: "https://tu.pagina.com/home",
    post_sign_out_redirect_uri_tip: "El URI hacia donde se redirecciona despu\xe9s de que un usuario cierre sesi\xf3n (opcional). Puede que no tenga efecto para algunos tipos de aplicaciones.",
    cors_allowed_origins: "Or\xedgenes permitidos CORS",
    cors_allowed_origins_placeholder: "https://tu.pagina.com",
    cors_allowed_origins_tip: "Por defecto, se permitir\xe1n todos los or\xedgenes de los URIs de Redireccionamiento. Normalmente no es necesario hacer nada en este campo. Consulta la <a>documentaci\xf3n de MDN</a> para obtener informaci\xf3n detallada.",
    token_endpoint: "Endpoint del Token",
    user_info_endpoint: "Endpoint del Usuario",
    enable_admin_access: "Habilitar acceso de administrador",
    enable_admin_access_label: "Habilita o deshabilita el acceso a la API de Gesti\xf3n. Una vez habilitado, puedes utilizar tokens de acceso para llamar a la API de Gesti\xf3n en nombre de esta aplicaci\xf3n.",
    always_issue_refresh_token: "Siempre emitir Token de Refresco",
    always_issue_refresh_token_label: "Al habilitar esta configuraci\xf3n, Logto siempre emitir\xe1 Tokens de Refresco, independientemente de si se presenta o no “prompt=consent” en la solicitud de autenticaci\xf3n. Sin embargo, esta pr\xe1ctica no est\xe1 recomendada a menos que sea necesario, ya que no es compatible con OpenID Connect y puede causar problemas potenciales.",
    refresh_token_ttl: "Tiempo de vida \xfatil del Token de refresco (TTL) en d\xedas",
    refresh_token_ttl_tip: "La duraci\xf3n durante la cual un token de refresco puede ser utilizado para solicitar nuevos tokens de acceso antes de que expire y se vuelva inv\xe1lido. Las solicitudes de tokens extender\xe1n el TTL del token de refresco a este valor.",
    rotate_refresh_token: "Rotar el token de refresco",
    rotate_refresh_token_label: "Cuando est\xe1 habilitado, Logto emitir\xe1 un nuevo token de refresco para las solicitudes de token cuando ha pasado el 70 % del tiempo de vida \xfatil (TTL) original o se cumplen ciertas condiciones. <a>M\xe1s informaci\xf3n</a>",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente la aplicaci\xf3n. Ingresa el nombre de la aplicaci\xf3n <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Ingresa el nombre de tu aplicaci\xf3n",
    application_deleted: "Se ha eliminado exitosamente la aplicaci\xf3n {{name}}",
    redirect_uri_required: "Debes ingresar al menos un URI de Redireccionamiento",
    roles: {
        name_column: "Rol",
        description_column: "Descripci\xf3n",
        assign_button: "Asignar roles",
        delete_description: "Esta acci\xf3n eliminar\xe1 este rol de esta aplicaci\xf3n de m\xe1quina a m\xe1quina. El rol seguir\xe1 existiendo, pero ya no estar\xe1 asociado con esta aplicaci\xf3n de m\xe1quina a m\xe1quina.",
        deleted: "Se ha eliminado correctamente {{name}} de este usuario.",
        assign_title: "Asignar roles a {{name}}",
        assign_subtitle: "Autorizar {{name}} uno o m\xe1s roles",
        assign_role_field: "Asignar roles",
        role_search_placeholder: "Buscar por nombre de rol",
        added_text: "{{value, number}} a\xf1adido",
        assigned_app_count: "{{value, number}} aplicaciones",
        confirm_assign: "Asignar roles",
        role_assigned: "Rol(es) asignado(s) correctamente",
        search: "Buscar por nombre de rol, descripci\xf3n o ID",
        empty: "No hay roles disponibles"
    }
};
var $1a8f819cd53b0fa3$export$2e2bcd8739ae039 = Object.freeze($1a8f819cd53b0fa3$var$application_details);


const $f47ee1131606869a$var$applications = {
    page_title: "Aplicaciones",
    title: "Aplicaciones",
    subtitle: "Configura la autenticaci\xf3n de Logto para tu aplicaci\xf3n nativa, de p\xe1gina \xfanica, de m\xe1quina a m\xe1quina o tradicional",
    subtitle_with_app_type: "Configura la autenticaci\xf3n de Logto para tu aplicaci\xf3n {{name}}",
    create: "Crear aplicaci\xf3n",
    application_name: "Nombre de la aplicaci\xf3n",
    application_name_placeholder: "Mi App",
    application_description: "Descripci\xf3n de la aplicaci\xf3n",
    application_description_placeholder: "Introduce la descripci\xf3n de tu aplicaci\xf3n",
    select_application_type: "Seleccionar un tipo de aplicaci\xf3n",
    no_application_type_selected: "A\xfan no has seleccionado ning\xfan tipo de aplicaci\xf3n",
    application_created: "\xa1La aplicaci\xf3n se ha creado correctamente.",
    app_id: "App ID",
    type: {
        native: {
            title: "App nativa",
            subtitle: "Una aplicaci\xf3n que se ejecuta en un entorno nativo",
            description: "Por ejemplo, una app de iOS, una app de Android"
        },
        spa: {
            title: "App de p\xe1gina \xfanica",
            subtitle: "Una aplicaci\xf3n que se ejecuta en un navegador web y actualiza din\xe1micamente los datos en su lugar",
            description: "Por ejemplo, una app de React DOM, una app de Vue"
        },
        traditional: {
            title: "Web tradicional",
            subtitle: "Una aplicaci\xf3n que renderiza y actualiza p\xe1ginas solo por el servidor web",
            description: "Por ejemplo, Next.js, PHP"
        },
        machine_to_machine: {
            title: "M\xe1quina a m\xe1quina",
            subtitle: "Una aplicaci\xf3n (generalmente un servicio) que habla directamente con recursos",
            description: "Por ejemplo, servicio backend"
        }
    },
    placeholder_title: "Selecciona un tipo de aplicaci\xf3n para continuar",
    placeholder_description: "Logto utiliza una entidad de aplicaci\xf3n para OIDC para ayudar con tareas como la identificaci\xf3n de tus aplicaciones, la gesti\xf3n de inicio de sesi\xf3n y la creaci\xf3n de registros de auditor\xeda."
};
var $f47ee1131606869a$export$2e2bcd8739ae039 = Object.freeze($f47ee1131606869a$var$applications);


const $17d2f03cb4b396bb$var$cloud = {
    general: {
        onboarding: "Integraci\xf3n"
    },
    welcome: {
        page_title: "Bienvenida",
        title: "\xa1Bienvenido a Logto Cloud! Nos encantar\xeda saber un poco m\xe1s sobre ti.",
        description: "Hagamos que su experiencia de Logto sea \xfanica para usted al conocerlo mejor. Su informaci\xf3n est\xe1 segura con nosotros.",
        project_field: "Estoy usando Logto para:",
        project_options: {
            personal: "Proyecto personal",
            company: "Proyecto empresarial"
        },
        title_field: "Seleccione el/los t\xedtulo(s) aplicable(s)",
        title_options: {
            developer: "Desarrollador",
            team_lead: "L\xedder de equipo",
            ceo: "CEO",
            cto: "CTO",
            product: "Producto",
            others: "Otros"
        },
        company_name_field: "Nombre de la empresa",
        company_name_placeholder: "Acme.co",
        company_size_field: "\xbfC\xf3mo es el tama\xf1o de su empresa?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Me registro porque",
        reason_options: {
            passwordless: "Buscando autenticaci\xf3n sin contrase\xf1a y kit de IU",
            efficiency: "Encontrar una infraestructura de identidad lista para usar",
            access_control: "Controlar el acceso del usuario en funci\xf3n de roles y responsabilidades",
            multi_tenancy: "Buscando estrategias para un producto de multipropiedad",
            enterprise: "Encontrar soluciones SSO para la preparaci\xf3n empresarial",
            others: "Otros"
        }
    },
    sie: {
        page_title: "Personalizaci\xf3n de la experiencia de inicio de sesi\xf3n",
        title: "Primero personalicemos su experiencia de inicio de sesi\xf3n con facilidad",
        inspire: {
            title: "Crear ejemplos convincentes",
            description: '\xbfSe siente inseguro acerca de la experiencia de inicio de sesi\xf3n? \xa1Simplemente haga clic en "Insp\xedreme" y deje que suceda la magia!',
            inspire_me: "Insp\xedrame"
        },
        logo_field: "Logotipo de la aplicaci\xf3n",
        color_field: "Color de marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "Correo electr\xf3nico",
            phone: "Tel\xe9fono",
            user_name: "Nombre de usuario"
        },
        authn_field: "Autenticaci\xf3n",
        authn_options: {
            password: "Contrase\xf1a",
            verification_code: "C\xf3digo de verificaci\xf3n"
        },
        social_field: "Inicio de sesi\xf3n social",
        finish_and_done: "Terminar y listo",
        preview: {
            mobile_tab: "M\xf3vil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Desbloqueado m\xe1s adelante",
            unlocked_later_tip: "Una vez que haya completado el proceso de incorporaci\xf3n y haya ingresado al producto, tendr\xe1 acceso a una mayor cantidad de m\xe9todos de inicio de sesi\xf3n social.",
            notice: "Evite utilizar el conector de demostraci\xf3n con fines de producci\xf3n. Una vez que haya completado las pruebas, elimine amablemente el conector de demostraci\xf3n y configure su propio conector con sus credenciales."
        }
    },
    socialCallback: {
        title: "Ha iniciado sesi\xf3n correctamente",
        description: "Ha iniciado sesi\xf3n correctamente utilizando su cuenta social. Para garantizar una integraci\xf3n perfecta y el acceso a todas las funciones de Logto, recomendamos que proceda a configurar su propio conector social."
    },
    tenant: {
        create_tenant: "Crear inquilino"
    }
};
var $17d2f03cb4b396bb$export$2e2bcd8739ae039 = Object.freeze($17d2f03cb4b396bb$var$cloud);


const $279bbafe905d5185$var$components = {
    uploader: {
        action_description: "Arrastra y suelta o busca",
        uploading: "Subiendo...",
        image_limit: "Sube im\xe1genes de menos de {{size, number}}KB, solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo sali\xf3 mal. La subida de archivos fall\xf3.",
        error_file_size: "El archivo es demasiado grande. Por favor, sube un archivo de menos de {{size, number}}KB.",
        error_file_type: "El tipo de archivo no es compatible. Solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Solo puedes subir 1 archivo."
    }
};
var $279bbafe905d5185$export$2e2bcd8739ae039 = Object.freeze($279bbafe905d5185$var$components);


const $eb5e76ada61c9c4e$var$connector_details = {
    page_title: "Detalles del conector",
    back_to_connectors: "Volver a conectores",
    check_readme: "Ver el archivo README",
    settings: "Configuraciones generales",
    settings_description: "Los conectores desempe\xf1an un papel fundamental en Logto. Con su ayuda, Logto permite que los usuarios finales utilicen el registro o inicio de sesi\xf3n sin contrase\xf1a y las capacidades para iniciar sesi\xf3n con cuentas sociales.",
    parameter_configuration: "Configuraci\xf3n de par\xe1metros",
    test_connection: "Prueba",
    save_error_empty_config: "Por favor, ingrese la configuraci\xf3n",
    send: "Enviar",
    send_error_invalid_format: "Entrada no v\xe1lida",
    edit_config_label: "Ingrese su JSON aqu\xed",
    test_email_sender: "Probar su conector de correo electr\xf3nico",
    test_sms_sender: "Probar su conector de SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Mensaje de prueba enviado",
    test_sender_description: 'Logto utiliza la plantilla "Generic" para realizar pruebas. Recibir\xe1 un mensaje si su conector est\xe1 configurado correctamente.',
    options_change_email: "Cambiar conector de correo electr\xf3nico",
    options_change_sms: "Cambiar conector de SMS",
    connector_deleted: "El conector ha sido eliminado con \xe9xito",
    type_email: "Conector de correo electr\xf3nico",
    type_sms: "Conector de SMS",
    type_social: "Conector social",
    in_used_social_deletion_description: "Este conector se utiliza en su experiencia de inicio de sesi\xf3n. Al eliminarlo, la experiencia de inicio de sesi\xf3n de <name/> se eliminar\xe1 en la configuraci\xf3n de la experiencia de inicio de sesi\xf3n. Deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    in_used_passwordless_deletion_description: "Este {{name}} se utiliza en su experiencia de inicio de sesi\xf3n. Al eliminarlo, su experiencia de inicio de sesi\xf3n no funcionar\xe1 correctamente hasta que resuelva el conflicto. Deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    deletion_description: "Est\xe1 eliminando este conector. No se puede deshacer, y deber\xe1 reconfigurarlo si decide agregarlo nuevamente.",
    logto_email: {
        total_email_sent: "Total de correos electr\xf3nicos enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza SendGrid para correo electr\xf3nico integrado seguro y estable. Es completamente gratuito de usar. <a>M\xe1s informaci\xf3n</a>",
        email_template_title: "Plantilla de correo electr\xf3nico",
        template_description: "El correo electr\xf3nico integrado utiliza plantillas predeterminadas para la entrega sin problemas de correos electr\xf3nicos de verificaci\xf3n. No se requiere configuraci\xf3n, y puede personalizar la informaci\xf3n b\xe1sica de la marca.",
        template_description_link_text: "Ver plantillas",
        description_action_text: "Ver plantillas",
        from_email_field: "Correo electr\xf3nico de origen",
        sender_name_field: "Nombre del remitente",
        sender_name_tip: 'Personalice el nombre del remitente para los correos electr\xf3nicos. Si se deja en blanco, se utilizar\xe1 "Verification" como nombre predeterminado.',
        sender_name_placeholder: "Su nombre de remitente",
        company_information_field: "Informaci\xf3n de la empresa",
        company_information_description: "Muestre el nombre de su empresa, direcci\xf3n o c\xf3digo postal en la parte inferior de los correos electr\xf3nicos para mejorar la autenticidad.",
        company_information_placeholder: "Informaci\xf3n b\xe1sica de su empresa",
        app_logo_field: "Logotipo de la aplicaci\xf3n",
        app_logo_tip: "Muestre el logotipo de su marca en la parte superior de los correos electr\xf3nicos. Utilice la misma imagen para el modo claro y oscuro.",
        urls_not_allowed: "Las URL no est\xe1n permitidas",
        test_notes: 'Logto utiliza la plantilla "Generic" para realizar pruebas.'
    }
};
var $eb5e76ada61c9c4e$export$2e2bcd8739ae039 = Object.freeze($eb5e76ada61c9c4e$var$connector_details);


const $7396c56fb4fb07e9$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar la experiencia de inicio de sesi\xf3n sin contrase\xf1a y con redes sociales",
    create: "Agregar conector social",
    config_sie_notice: "Has configurado conectores. Aseg\xfarate de configurarlo en <a>{{link}}</a>.",
    config_sie_link_text: "experiencia de inicio de sesi\xf3n",
    tab_email_sms: "Conectores de correo electr\xf3nico y SMS",
    tab_social: "Conectores sociales",
    connector_name: "Nombre del conector",
    demo_tip: "El n\xfamero m\xe1ximo de mensajes permitidos para este conector de demostraci\xf3n est\xe1 limitado a 100 y no se recomienda para implementaci\xf3n en un entorno de producci\xf3n.",
    social_demo_tip: "El conector de demostraci\xf3n est\xe1 dise\xf1ado exclusivamente para fines de demostraci\xf3n y no se recomienda para implementaci\xf3n en un entorno de producci\xf3n.",
    connector_type: "Tipo",
    connector_status: "Experiencia de inicio de sesi\xf3n",
    connector_status_in_use: "En uso",
    connector_status_not_in_use: "No en uso",
    not_in_use_tip: {
        content: "No en uso significa que tu experiencia de inicio de sesi\xf3n no ha utilizado este m\xe9todo de inicio de sesi\xf3n. <a>{{link}}</a> para agregar este m\xe9todo de inicio de sesi\xf3n. ",
        go_to_sie: "Ir a la experiencia de inicio de sesi\xf3n"
    },
    placeholder_title: "Conector social",
    placeholder_description: "Logto ha proporcionado muchos conectores de inicio de sesi\xf3n social ampliamente utilizados, mientras tanto, puede crear el suyo con protocolos est\xe1ndar.",
    save_and_done: "Guardar y finalizar",
    type: {
        email: "Conector de correo electr\xf3nico",
        sms: "Conector SMS",
        social: "Conector social"
    },
    setup_title: {
        email: "Configure el conector de correo electr\xf3nico",
        sms: "Configure el conector SMS",
        social: "Agregar conector social"
    },
    guide: {
        subtitle: "Una gu\xeda paso a paso para configurar su conector",
        general_setting: "Configuraciones generales",
        parameter_configuration: "Configuraci\xf3n de par\xe1metros",
        test_connection: "Prueba de conexi\xf3n",
        name: "Nombre para el bot\xf3n de inicio de sesi\xf3n social",
        name_placeholder: "Ingrese el nombre para el bot\xf3n de inicio de sesi\xf3n social",
        name_tip: 'El nombre del bot\xf3n del conector se mostrar\xe1 como "Continuar con {{name}}". Siempre tenga en cuenta la longitud del nombre en caso de que sea demasiado largo.',
        logo: "URL del logotipo para el bot\xf3n de inicio de sesi\xf3n social",
        logo_placeholder: "https://tudominio.cdn/logo.png",
        logo_tip: "La imagen del logotipo se mostrar\xe1 en el conector. Obtenga un enlace de imagen accesible p\xfablicamente e ins\xe9rtelo aqu\xed.",
        logo_dark: "URL del logotipo para el bot\xf3n de inicio de sesi\xf3n social (modo oscuro)",
        logo_dark_placeholder: "https://tudominio.cdn/logo.png",
        logo_dark_tip: "Configure el logotipo de su conector para el modo oscuro despu\xe9s de activarlo en la Experiencia de inicio de sesi\xf3n del Panel de administrador.",
        logo_dark_collapse: "Colapso",
        logo_dark_show: "Mostrar configuraci\xf3n de logotipo para modo oscuro",
        target: "Nombre del proveedor de identidad",
        target_placeholder: "Ingrese el nombre del proveedor de identidad del conector",
        target_tip: 'El valor de "nombre del IdP" puede ser una cadena de identificador \xfanica para distinguir sus identificadores sociales.',
        target_tip_standard: 'El valor de "nombre del IdP" puede ser una cadena de identificador \xfanica para distinguir sus identificadores sociales. Esta configuraci\xf3n no se puede cambiar despu\xe9s de crear el conector.',
        target_tooltip: 'El "nombre del IdP" en los conectores sociales de Logto se refiere a la "fuente" de sus identidades sociales. En el dise\xf1o de Logto, no aceptamos el mismo "nombre del IdP" de una plataforma espec\xedfica para evitar conflictos. Debe ser muy cuidadoso antes de agregar un conector ya que NO PUEDE cambiar su valor una vez que lo crea. <a>Obtener m\xe1s informaci\xf3n</a>',
        target_conflict: "El nombre del IdP ingresado coincide con el conector de nombre <span></span>. Utilizar el mismo nombre del IdP puede provocar un comportamiento de inicio de sesi\xf3n inesperado donde los usuarios pueden acceder a la misma cuenta a trav\xe9s de dos conectores diferentes.",
        target_conflict_line2: 'Si desea reemplazar el conector actual con el mismo proveedor de identidad y permitir que los usuarios anteriores inicien sesi\xf3n sin registrarse nuevamente, elimine el conector <span></span> y cree uno nuevo con el mismo "nombre de IdP".',
        target_conflict_line3: 'Si desea conectarse a un proveedor de identidad diferente, modifique el "nombre del IdP" y contin\xfae.',
        config: "Ingrese su JSON de configuraci\xf3n",
        sync_profile: "Sincronizar informaci\xf3n del perfil",
        sync_profile_only_at_sign_up: "Sincronice solo en el registro",
        sync_profile_each_sign_in: "Siempre sincronice en cada inicio de sesi\xf3n",
        sync_profile_tip: "Sincronice el perfil b\xe1sico del proveedor social, como los nombres de los usuarios y sus avatares.",
        callback_uri: "URI de devoluci\xf3n de llamada",
        callback_uri_description: "Tambi\xe9n llamado URI de redireccionamiento, es la URI en Logto a la que se enviar\xe1n los usuarios despu\xe9s de la autorizaci\xf3n social, copie y pegue en la p\xe1gina de configuraci\xf3n del proveedor social."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativo"
    },
    add_multi_platform: "admite m\xfaltiples plataformas, seleccione una plataforma para continuar",
    drawer_title: "Gu\xeda del conector",
    drawer_subtitle: "Siga las instrucciones para integrar su conector",
    unknown: "Conector desconocido",
    standard_connectors: "Conectores est\xe1ndar"
};
var $7396c56fb4fb07e9$export$2e2bcd8739ae039 = Object.freeze($7396c56fb4fb07e9$var$connectors);


const $d4e0c7ef8132a0a8$var$contact = {
    title: "Obtener ayuda",
    description: "Para solicitudes de ayuda o comentarios sobre el producto, cont\xe1ctenos a trav\xe9s de los siguientes m\xe9todos.",
    discord: {
        title: "\xdanete a la comunidad de Discord",
        description: "Con\xe9ctate con otros desarrolladores para encontrar soluciones",
        button: "\xdanete"
    },
    github: {
        title: "Comunicarse en GitHub",
        description: "Crea un problema y env\xedalo en GitHub",
        button: "Abrir"
    },
    email: {
        title: "Contacta con soporte por correo electr\xf3nico",
        description: "Env\xedanos un correo electr\xf3nico para obtener m\xe1s informaci\xf3n y ayuda.",
        button: "Enviar"
    },
    reserve: {
        title: "Reserve su tiempo con el equipo de Logto",
        description: "Reserve r\xe1pidamente una sesi\xf3n para un chat en vivo",
        button: "Reservar"
    }
};
var $d4e0c7ef8132a0a8$export$2e2bcd8739ae039 = Object.freeze($d4e0c7ef8132a0a8$var$contact);


const $03b8297eb034e7b4$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Obt\xe9n una vista general sobre el rendimiento de tu aplicaci\xf3n",
    total_users: "Usuarios totales",
    total_users_tip: "Usuarios totales",
    new_users_today: "Nuevos usuarios hoy",
    new_users_today_tip: "N\xfamero de nuevos usuarios registrados en tu aplicaci\xf3n hoy",
    new_users_7_days: "Nuevos usuarios \xfaltimos 7 d\xedas",
    new_users_7_days_tip: "N\xfamero de nuevos usuarios registrados en tu aplicaci\xf3n en los \xfaltimos 7 d\xedas",
    daily_active_users: "Usuarios activos diarios",
    daily_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n hoy",
    weekly_active_users: "Usuarios activos semanales",
    weekly_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n en los \xfaltimos 7 d\xedas",
    monthly_active_users: "Usuarios activos mensuales",
    monthly_active_users_tip: "N\xfamero de usuarios \xfanicos que intercambiaron tokens en tu aplicaci\xf3n en los \xfaltimos 30 d\xedas"
};
var $03b8297eb034e7b4$export$2e2bcd8739ae039 = Object.freeze($03b8297eb034e7b4$var$dashboard);


const $11782ced2c7f7b84$var$domain = {
    status: {
        connecting: "Conectando",
        in_used: "En uso",
        failed_to_connect: "Error de conexi\xf3n"
    },
    update_endpoint_notice: "No olvide actualizar el dominio para el URI de devoluci\xf3n de llamada del conector social y el punto final de Logto en su aplicaci\xf3n si desea utilizar un dominio personalizado para las funciones. <a>{{link}}</a>",
    error_hint: "Aseg\xfarese de actualizar sus registros DNS. Continuaremos verificando cada {{value}} segundos.",
    custom: {
        custom_domain: "Dominio personalizado",
        custom_domain_description: "Mejore su marca utilizando un dominio personalizado. Este dominio se utilizar\xe1 en su experiencia de inicio de sesi\xf3n.",
        custom_domain_field: "Dominio personalizado",
        custom_domain_placeholder: "tu.dominio.com",
        add_domain: "Agregar dominio",
        invalid_domain_format: "Formato de subdominio no v\xe1lido. Por favor ingrese un subdominio con al menos tres partes.",
        verify_domain: "Verificar dominio",
        enable_ssl: "Habilitar SSL",
        checking_dns_tip: "Despu\xe9s de configurar los registros DNS, el proceso se ejecutar\xe1 autom\xe1ticamente y puede tardar hasta 24 horas. Puede dejar esta interfaz mientras se est\xe1 ejecutando.",
        enable_ssl_tip: "Habilitar SSL se ejecutar\xe1 autom\xe1ticamente y puede tardar hasta 24 horas. Puede dejar esta interfaz mientras se est\xe1 ejecutando.",
        generating_dns_records: "Generando los registros DNS...",
        add_dns_records: "Agregue estos registros DNS a su proveedor de DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nombre",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Eliminar dominio",
            reminder: "Eliminar dominio personalizado",
            description: "\xbfEst\xe1 seguro de que desea eliminar este dominio personalizado?",
            in_used_description: '\xbfEst\xe1 seguro de que desea eliminar este dominio personalizado "<span>{{domain}}</span>"?',
            in_used_tip: 'Si hab\xeda configurado este dominio personalizado en su proveedor de conector social o punto final de aplicaci\xf3n antes, deber\xe1 modificar la URI al dominio predeterminado de Logto "<span>{{dominio}}</span>" primero. Esto es necesario para que el bot\xf3n de inicio de sesi\xf3n social funcione correctamente.',
            deleted: "\xa1Dominio personalizado eliminado con \xe9xito!"
        }
    },
    default: {
        default_domain: "Dominio predeterminado",
        default_domain_description: "Logto ofrece un dominio predeterminado preconfigurado, listo para usar sin ninguna configuraci\xf3n adicional. Este dominio predeterminado sirve como opci\xf3n de respaldo incluso si habilit\xf3 un dominio personalizado.",
        default_domain_field: "Dominio predeterminado de Logto"
    },
    custom_endpoint_note: 'Puede personalizar el nombre de dominio de estos puntos finales seg\xfan sea necesario. Elija "{{custom}}" o "{{default}}".',
    custom_social_callback_url_note: 'Puede personalizar el nombre de dominio de esta URI para que coincida con el punto final de su aplicaci\xf3n. Elija "{{custom}}" o "{{default}}".'
};
var $11782ced2c7f7b84$export$2e2bcd8739ae039 = Object.freeze($11782ced2c7f7b84$var$domain);


const $6aa8d2a5dd29a8ed$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $6aa8d2a5dd29a8ed$export$2e2bcd8739ae039 = Object.freeze($6aa8d2a5dd29a8ed$var$enterprise_sso_details);


const $19628f9f0b25ce41$var$enterprise_sso = {
    page_title: "SSO de la empresa",
    title: "SSO de la empresa",
    subtitle: "Conecta el proveedor de identidad de la empresa y habilita el inicio de sesi\xf3n \xfanico iniciado por el proveedor de servicios.",
    create: "Agregar conector de la empresa",
    col_connector_name: "Nombre del conector",
    col_type: "Tipo",
    col_email_domain: "Dominio de correo electr\xf3nico",
    placeholder_title: "Conector de la empresa",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Agregar conector de la empresa",
        text_divider: "O puedes personalizar tu conector con un protocolo est\xe1ndar.",
        connector_name_field_title: "Nombre del conector",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Crear conector"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $19628f9f0b25ce41$export$2e2bcd8739ae039 = Object.freeze($19628f9f0b25ce41$var$enterprise_sso);


const $38a8d408ddd5e47a$var$errors = {
    something_went_wrong: "\xa1Oops! Algo sali\xf3 mal.",
    page_not_found: "P\xe1gina no encontrada",
    unknown_server_error: "Ocurri\xf3 un error desconocido en el servidor",
    empty: "Sin datos",
    missing_total_number: "No se puede encontrar Total-Number en los encabezados de respuesta",
    invalid_uri_format: "Formato de URI no v\xe1lido",
    invalid_origin_format: "Formato de origen de URI no v\xe1lido",
    invalid_json_format: "Formato JSON no v\xe1lido",
    invalid_error_message_format: "El formato del mensaje de error es inv\xe1lido.",
    required_field_missing: "Por favor ingrese {{field}}",
    required_field_missing_plural: "Tienes que ingresar al menos un {{field}}",
    more_details: "M\xe1s detalles",
    username_pattern_error: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos y no debe comenzar con un n\xfamero.",
    email_pattern_error: "La direcci\xf3n de correo electr\xf3nico no es v\xe1lida.",
    phone_pattern_error: "El n\xfamero de tel\xe9fono no es v\xe1lido.",
    insecure_contexts: "Los contextos inseguros (no HTTPS) no son compatibles.",
    unexpected_error: "Ocurri\xf3 un error inesperado.",
    not_found: "404 no encontrado",
    create_internal_role_violation: 'Est\xe1s creando un nuevo rol interno que est\xe1 prohibido por Logto. Prueba con otro nombre que no comience con "#intern:".',
    should_be_an_integer: "Debe ser un n\xfamero entero.",
    number_should_be_between_inclusive: "Entonces el n\xfamero debe estar entre {{min}} y {{max}} (ambos inclusive)."
};
var $38a8d408ddd5e47a$export$2e2bcd8739ae039 = Object.freeze($38a8d408ddd5e47a$var$errors);


const $b1a9f5b9a42c79a5$var$general = {
    placeholder: "Marcador de posici\xf3n",
    submit: "Enviar",
    skip: "Omitir",
    next: "Siguiente",
    back: "Atr\xe1s",
    retry: "Intentar de Nuevo",
    done: "Hecho",
    search: "Buscar",
    search_placeholder: "Buscar",
    clear_result: "Borrar Resultados",
    save: "Guardar",
    save_changes: "Guardar Cambios",
    saved: "Guardado",
    discard: "Descartar",
    loading: "Cargando...",
    redirecting: "Redirigiendo...",
    add: "Agregar",
    added: "Agregado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Comprar",
    create: "Crear",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Habilitar",
    reminder: "Recordatorio",
    delete: "Eliminar",
    more_options: "M\xc1S OPCIONES",
    close: "Cerrar",
    copy: "Copiar",
    copying: "Copiando",
    copied: "Copiado",
    required: "Requerido",
    add_another: "Agregar Otro",
    create_another: "Crear otro",
    deletion_confirmation: "\xbfEst\xe1 seguro que desea eliminar este {{title}}?",
    settings_nav: "Configuraci\xf3n",
    unsaved_changes_warning: "Ha realizado algunos cambios. \xbfEst\xe1 seguro que desea salir de esta p\xe1gina?",
    leave_page: "Salir de la P\xe1gina",
    stay_on_page: "Permanecer en la P\xe1gina",
    type_to_search: "Escriba para buscar",
    got_it: "Entendido",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saber m\xe1s",
    tab_errors: "{{count, number}} errores",
    skip_for_now: "Omitir por ahora",
    remove: "Eliminar",
    visit: "Visitar",
    join: "Unirse",
    try_now: "Probar Ahora",
    multiple_form_field: "(M\xfaltiple)",
    demo: "Demostraci\xf3n",
    unnamed: "Sin nombre",
    view: "Ver",
    hide: "Ocultar",
    unknown_error: "Error desconocido, por favor int\xe9ntalo de nuevo m\xe1s tarde.",
    select: "Seleccionar",
    contact_us_action: "Cont\xe1ctanos",
    description: "Descripci\xf3n",
    name: "Nombre",
    add_field: "Agregar {{field}}",
    create_field: "Crear {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Eliminar {{field}}",
    coming_soon: "Pr\xf3ximamente",
    beta_notice: "\uD83C\uDF89  {{feature}} actualmente est\xe1 en beta. Bienvenido a explorarlo y <ContactLink>compartir tus comentarios</ContactLink>."
};
var $b1a9f5b9a42c79a5$export$2e2bcd8739ae039 = Object.freeze($b1a9f5b9a42c79a5$var$general);


const $1e50ea2cbebf969c$var$get_started = {
    page_title: "Comenzar",
    title: "Algo para explorar que te ayudar\xe1 a tener \xe9xito",
    subtitle: "Algunas cosas que puedes hacer para obtener r\xe1pidamente el valor de Logto",
    develop: {
        title: "Develop: Dedica 5 minutos para integrar tu aplicaci\xf3n"
    },
    customize: {
        title: "Customize: Ofrece una excelente experiencia de inicio de sesi\xf3n",
        preview: {
            title: "Ver la vista previa en directo de la experiencia de inicio de sesi\xf3n que acabas de personalizar",
            subtitle: "Prueba la experiencia de inicio de sesi\xf3n de Logto ahora y ve c\xf3mo funciona"
        },
        connector: {
            title: "Agregar m\xe1s conectores para admitir m\xe1s m\xe9todos de inicio de sesi\xf3n sociales",
            subtitle: "Prueba el inicio de sesi\xf3n sin contrase\xf1a y habilita una experiencia segura y sin fricciones para tus clientes"
        },
        continue_customizing: "Contin\xfaa personalizando",
        try_now: "Pru\xe9balo ahora",
        add_more: "Agregar m\xe1s"
    },
    secure: {
        title: "Secure: Protege tus recursos"
    },
    manage: {
        title: "Manage: Define control de acceso para tu producto y usuarios",
        rbac: {
            title: "Agregar control de acceso basado en roles para proteger tus recursos",
            subtitle: "Controla tus recursos mediante una autorizaci\xf3n de roles escalable para diversos casos de uso"
        },
        create_roles: "Crear roles"
    },
    view_all: "Ver todo →"
};
var $1e50ea2cbebf969c$export$2e2bcd8739ae039 = Object.freeze($1e50ea2cbebf969c$var$get_started);


const $b46740eb5dfec083$var$guide = {
    start_building: "Empezar a construir",
    get_started: "Comenzar",
    categories: {
        featured: "Popular y para ti",
        Traditional: "Aplicaci\xf3n web tradicional",
        SPA: "Aplicaci\xf3n de una sola p\xe1gina",
        Native: "Nativa",
        MachineToMachine: "M\xe1quina a m\xe1quina"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Buscar un framework"
    },
    checkout_tutorial: "Ver el tutorial de {{name}}",
    do_not_need_tutorial: "Si no necesitas un tutorial, puedes continuar sin una gu\xeda de framework",
    finish_and_done: "Finalizar y terminar",
    cannot_find_guide: "\xbfNo puedes encontrar tu gu\xeda?",
    describe_guide_looking_for: "Describe la gu\xeda que est\xe1s buscando",
    request_guide_successfully: "Tu solicitud ha sido enviada correctamente. \xa1Gracias!",
    app: {
        select_framework_or_tutorial: "Seleccionar un framework o tutorial",
        guide_modal_title: "Comenzar con el SDK y las gu\xedas",
        modal_subtitle: "Agiliza el proceso de desarrollo de tu aplicaci\xf3n con nuestro SDK preconstruido y tutoriales.",
        select_a_framework: "Seleccionar un framework",
        continue_without_framework: "Crear una aplicaci\xf3n sin framework",
        describe_guide_looking_for_placeholder: "Ej.: Quiero integrar Logto en mi aplicaci\xf3n de Angular."
    },
    api: {
        modal_title: "Comenzar con tutoriales",
        modal_subtitle: "Agiliza el proceso de desarrollo de tu aplicaci\xf3n con nuestros tutoriales preconstruidos.",
        select_a_tutorial: "Seleccionar un tutorial",
        continue_without_tutorial: "Continuar sin tutorial",
        describe_guide_looking_for_placeholder: "Ej.: Quiero proteger mi API utilizando deno."
    }
};
var $b46740eb5dfec083$export$2e2bcd8739ae039 = Object.freeze($b46740eb5dfec083$var$guide);


const $7bbff72bf985d79a$var$log_details = {
    page_title: "Detalle del registro de auditor\xeda",
    back_to_logs: "Volver a los registros de auditor\xeda",
    back_to: "Volver a {{name}}",
    success: "\xc9xito",
    failed: "Fallido",
    event_key: "Clave del evento",
    application: "Aplicaci\xf3n",
    ip_address: "Direcci\xf3n IP",
    user: "Usuario",
    log_id: "ID de registro",
    time: "Tiempo",
    user_agent: "Agente de usuario",
    tab_details: "Detalles",
    raw_data: "Datos sin procesar"
};
var $7bbff72bf985d79a$export$2e2bcd8739ae039 = Object.freeze($7bbff72bf985d79a$var$log_details);


const $2f0681e9a8492f02$var$logs = {
    page_title: "Registros de auditor\xeda",
    title: "Registros de auditor\xeda",
    subtitle: "Ver datos de registro de eventos de autenticaci\xf3n realizados por sus usuarios.",
    event: "Evento",
    user: "Usuario",
    application: "Aplicaci\xf3n",
    time: "Tiempo",
    filter_by: "Filtrar por"
};
var $2f0681e9a8492f02$export$2e2bcd8739ae039 = Object.freeze($2f0681e9a8492f02$var$logs);


const $ff6fd0028f794cd9$var$menu = {
    profile: "Perfil",
    language: "Idioma",
    appearance: {
        label: "Apariencia",
        light: "Modo Claro",
        dark: "Modo Oscuro",
        system: "Sincronizar con el sistema"
    },
    sign_out: "Cerrar sesi\xf3n"
};
var $ff6fd0028f794cd9$export$2e2bcd8739ae039 = Object.freeze($ff6fd0028f794cd9$var$menu);


const $9649b15006c03c53$var$mfa = {
    title: "Autenticaci\xf3n de m\xfaltiples factores",
    description: "Agrega autenticaci\xf3n de m\xfaltiples factores para elevar la seguridad de tu experiencia de inicio de sesi\xf3n.",
    factors: "Factores",
    multi_factors: "M\xfaltiples factores",
    multi_factors_description: "Los usuarios deben verificar uno de los factores habilitados para la verificaci\xf3n de dos pasos.",
    totp: "OTP de la aplicaci\xf3n autenticadora",
    otp_description: "Vincula Google Authenticator, etc., para verificar contrase\xf1as de un solo uso.",
    webauthn: "WebAuthn (Clave de paso)",
    webauthn_description: "Verifica a trav\xe9s de un m\xe9todo compatible con el navegador: biometr\xeda, escaneo de tel\xe9fono o clave de seguridad, etc.",
    webauthn_native_tip: "WebAuthn no es compatible con aplicaciones nativas.",
    webauthn_domain_tip: "WebAuthn vincula claves p\xfablicas al dominio espec\xedfico. Modificar el dominio del servicio bloquear\xe1 a los usuarios para autenticarse mediante claves de paso existentes.",
    backup_code: "C\xf3digo de respaldo",
    backup_code_description: "Genera 10 c\xf3digos de respaldo de un solo uso despu\xe9s de que los usuarios configuren cualquier m\xe9todo de MFA.",
    backup_code_setup_hint: "Cuando los usuarios no pueden verificar los factores de MFA anteriores, utiliza la opci\xf3n de respaldo.",
    backup_code_error_hint: "Para usar un c\xf3digo de respaldo, necesitas al menos un m\xe9todo de MFA adicional para una autenticaci\xf3n exitosa del usuario.",
    policy: "Pol\xedtica",
    policy_description: "Establece la pol\xedtica de MFA para los flujos de inicio de sesi\xf3n y registro.",
    two_step_sign_in_policy: "Pol\xedtica de verificaci\xf3n de dos pasos al iniciar sesi\xf3n",
    user_controlled: "Los usuarios pueden habilitar o deshabilitar MFA por s\xed mismos",
    user_controlled_tip: "Los usuarios pueden omitir la configuraci\xf3n de MFA la primera vez al iniciar sesi\xf3n o registrarse, o habilitar/deshabilitarla en la configuraci\xf3n de la cuenta.",
    mandatory: "Siempre se requiere que los usuarios usen MFA al iniciar sesi\xf3n",
    mandatory_tip: "Los usuarios deben configurar MFA la primera vez al iniciar sesi\xf3n o registrarse, y usarlo en todas las futuras sesiones de inicio de sesi\xf3n."
};
var $9649b15006c03c53$export$2e2bcd8739ae039 = Object.freeze($9649b15006c03c53$var$mfa);


const $5f78f052ad0bf8ed$var$organization_details = {
    page_title: "Detalles de la organizaci\xf3n",
    delete_confirmation: "Una vez eliminada, todos los miembros perder\xe1n su membres\xeda y roles en esta organizaci\xf3n. Esta acci\xf3n no se puede deshacer.",
    organization_id: "ID de la organizaci\xf3n",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "El nombre de la organizaci\xf3n, no es necesario que sea \xfanico.",
    description_placeholder: "Una descripci\xf3n de la organizaci\xf3n.",
    member: "Miembro",
    member_other: "Miembros",
    add_members_to_organization: "Agregar miembros a la organizaci\xf3n {{name}}",
    add_members_to_organization_description: "Encuentra usuarios apropiados buscando nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario. Los miembros existentes no se muestran en los resultados de b\xfasqueda.",
    add_with_organization_role: "Agregar con rol(es) de organizaci\xf3n",
    user: "Usuario",
    authorize_to_roles: "Autorizar a {{name}} para acceder a los siguientes roles:",
    edit_organization_roles: "Editar roles de organizaci\xf3n",
    edit_organization_roles_of_user: "Editar roles de organizaci\xf3n de {{name}}",
    remove_user_from_organization: "Eliminar usuario de la organizaci\xf3n",
    remove_user_from_organization_description: "Una vez eliminado, el usuario perder\xe1 su membres\xeda y roles en esta organizaci\xf3n. Esta acci\xf3n no se puede deshacer.",
    search_user_placeholder: "Buscar por nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario",
    at_least_one_user: "Se requiere al menos un usuario."
};
var $5f78f052ad0bf8ed$export$2e2bcd8739ae039 = Object.freeze($5f78f052ad0bf8ed$var$organization_details);


const $cde291122da2c35a$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organizaciones",
    title: "Organizaciones",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID de la organizaci\xf3n",
    members: "Miembros",
    create_organization: "Crear organizaci\xf3n",
    setup_organization: "Configurar su organizaci\xf3n",
    organization_list_placeholder_title: "Organizaci\xf3n",
    organization_list_placeholder_text: "La organizaci\xf3n se utiliza generalmente en aplicaciones multiinquilino de SaaS o similares al SaaS. La funci\xf3n de Organizaciones permite a sus clientes B2B gestionar mejor a sus socios y clientes, y personalizar las formas en que los usuarios finales acceden a sus aplicaciones.",
    organization_name_placeholder: "Mi organizaci\xf3n",
    organization_description_placeholder: "Una breve descripci\xf3n de la organizaci\xf3n",
    organization_permission: "Permiso de la organizaci\xf3n",
    organization_permission_other: "Permisos de la organizaci\xf3n",
    organization_permission_description: "El permiso de la organizaci\xf3n se refiere a la autorizaci\xf3n para acceder a un recurso en el contexto de la organizaci\xf3n. Un permiso de organizaci\xf3n debe representarse como una cadena significativa, que tambi\xe9n sirve como el nombre y el identificador \xfanico.",
    organization_permission_delete_confirm: "Si se elimina este permiso, todos los roles de la organizaci\xf3n, incluido este permiso, perder\xe1n este permiso, y los usuarios que ten\xedan este permiso perder\xe1n el acceso otorgado por \xe9l.",
    create_permission_placeholder: "Leer historial de citas",
    permission: "Permiso",
    permission_other: "Permisos",
    organization_role: "Rol de la organizaci\xf3n",
    organization_role_other: "Roles de la organizaci\xf3n",
    organization_role_description: "El rol de la organizaci\xf3n es un agrupamiento de permisos que se pueden asignar a los usuarios. Los permisos deben provenir de los permisos de organizaci\xf3n predefinidos.",
    organization_role_delete_confirm: "Hacer esto eliminar\xe1 los permisos asociados con este rol de los usuarios afectados y eliminar\xe1 las relaciones entre roles de organizaci\xf3n, miembros de la organizaci\xf3n y permisos de organizaci\xf3n.",
    role: "Rol",
    create_role_placeholder: "Usuarios con permisos de solo lectura",
    search_placeholder: "Buscar por nombre de organizaci\xf3n o ID",
    search_permission_placeholder: "Escribe para buscar y seleccionar permisos",
    search_role_placeholder: "Escribe para buscar y seleccionar roles",
    empty_placeholder: "\uD83E\uDD14 No has configurado ning\xfan {{entity}} todav\xeda.",
    organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Comience con gu\xedas",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interact\xfaa con la ilustraci\xf3n para ver c\xf3mo se conecta todo",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Paso 1: Definir permisos de organizaci\xf3n",
        step_2: "Paso 2: Definir roles de organizaci\xf3n",
        step_3: "Paso 3: Cree su primera organizaci\xf3n",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $cde291122da2c35a$export$2e2bcd8739ae039 = Object.freeze($cde291122da2c35a$var$organizations);


const $97ed8697ffbf018a$var$permissions = {
    search_placeholder: "Buscar por API o nombre de permiso",
    search_placeholder_without_api: "Buscar por nombre de permiso",
    name_column: "Permiso",
    description_column: "Descripci\xf3n",
    api_column: "API",
    placeholder_title: "Permiso",
    placeholder_description: "Permiso se refiere a la autorizaci\xf3n para acceder a un recurso (lo llamamos recurso de API)."
};
var $97ed8697ffbf018a$export$2e2bcd8739ae039 = Object.freeze($97ed8697ffbf018a$var$permissions);


const $ce054c4ea80a342a$var$profile = {
    page_title: "Configuraci\xf3n de cuenta",
    title: "Configuraci\xf3n de cuenta",
    description: "Cambie su configuraci\xf3n de cuenta y administre su informaci\xf3n personal aqu\xed para garantizar la seguridad de su cuenta.",
    settings: {
        title: "AJUSTES DE PERFIL",
        profile_information: "Informaci\xf3n del perfil",
        avatar: "Avatar",
        name: "Nombre",
        username: "Nombre de usuario"
    },
    link_account: {
        title: "ENLAZAR CUENTA",
        email_sign_in: "Inicio de sesi\xf3n por correo electr\xf3nico",
        email: "Correo electr\xf3nico",
        social_sign_in: "Inicio de sesi\xf3n social",
        link_email: "Vincular correo electr\xf3nico",
        link_email_subtitle: "Vincule su correo electr\xf3nico para iniciar sesi\xf3n o ayudar con la recuperaci\xf3n de la cuenta.",
        email_required: "Se requiere correo electr\xf3nico",
        invalid_email: "Direcci\xf3n de correo electr\xf3nico no v\xe1lida",
        identical_email_address: "La direcci\xf3n de correo electr\xf3nico de entrada es id\xe9ntica a la actual",
        anonymous: "An\xf3nimo"
    },
    password: {
        title: "CONTRASE\xd1A Y SEGURIDAD",
        password: "Contrase\xf1a",
        password_setting: "Configuraci\xf3n de contrase\xf1a",
        new_password: "Nueva contrase\xf1a",
        confirm_password: "Confirmar contrase\xf1a",
        enter_password: "Ingrese la contrase\xf1a actual",
        enter_password_subtitle: "Verifica que eres t\xfa para proteger la seguridad de tu cuenta. Por favor, ingresa tu contrase\xf1a actual antes de cambiarla.",
        set_password: "Establecer contrase\xf1a",
        verify_via_password: "Verificar mediante contrase\xf1a",
        show_password: "Mostrar contrase\xf1a",
        required: "Se requiere contrase\xf1a",
        do_not_match: "Las contrase\xf1as no coinciden. Int\xe9ntelo de nuevo."
    },
    code: {
        enter_verification_code: "Ingrese el c\xf3digo de verificaci\xf3n",
        enter_verification_code_subtitle: "El c\xf3digo de verificaci\xf3n se ha enviado a <strong>{{target}}</strong>",
        verify_via_code: "Verificar mediante el c\xf3digo de verificaci\xf3n",
        resend: "Reenviar c\xf3digo de verificaci\xf3n",
        resend_countdown: "Reenviar en {{countdown}} segundos"
    },
    delete_account: {
        title: "ELIMINAR CUENTA",
        label: "Eliminar cuenta",
        description: "La eliminaci\xf3n de su cuenta eliminar\xe1 toda su informaci\xf3n personal, datos de usuario y configuraci\xf3n. Esta acci\xf3n no se puede deshacer.",
        button: "Eliminar cuenta",
        dialog_paragraph_1: "Lamentamos mucho que quiera eliminar su cuenta. La eliminaci\xf3n de su cuenta eliminar\xe1 permanentemente todos los datos, incluida la informaci\xf3n del usuario, los registros y la configuraci\xf3n, y esta acci\xf3n no se puede deshacer. Por lo tanto, aseg\xfarese de realizar una copia de seguridad de cualquier dato importante antes de continuar.",
        dialog_paragraph_2: 'Para iniciar el proceso de eliminaci\xf3n de la cuenta, env\xede un correo electr\xf3nico a nuestro equipo de soporte en <a>{{mail}}</a> con el asunto "Solicitud de eliminaci\xf3n de cuenta". Le ayudaremos y nos aseguraremos de que todos sus datos se eliminen correctamente de nuestro sistema.',
        dialog_paragraph_3: "Gracias por elegir Logto Cloud. Si tiene m\xe1s preguntas o inquietudes, no dude en comunicarse con nosotros."
    },
    set: "Establecer",
    change: "Cambiar",
    link: "Vincular",
    unlink: "Desvincular",
    not_set: "No configurado",
    change_avatar: "Cambiar avatar",
    change_name: "Cambiar nombre",
    change_username: "Cambiar nombre de usuario",
    set_name: "Establecer nombre",
    email_changed: "\xa1Se cambi\xf3 el correo electr\xf3nico.",
    password_changed: "\xa1Se cambi\xf3 la contrase\xf1a.",
    updated: "\xa1{{target}} actualizado.",
    linked: "\xa1{{target}} vinculado.",
    unlinked: "\xa1{{target}} desvinculado.",
    email_exists_reminder: "Este correo electr\xf3nico {{email}} est\xe1 asociado con una cuenta existente. Vincule otro correo electr\xf3nico aqu\xed.",
    unlink_confirm_text: "S\xed, desvincular",
    unlink_reminder: "Los usuarios no podr\xe1n iniciar sesi\xf3n con la cuenta <span></span> si la desvincula. \xbfEst\xe1s seguro de que quieres continuar?"
};
var $ce054c4ea80a342a$export$2e2bcd8739ae039 = Object.freeze($ce054c4ea80a342a$var$profile);


const $efe1d8005ce38ec7$var$role_details = {
    back_to_roles: "Volver a roles",
    identifier: "Identificador",
    delete_description: "Al hacerlo, se eliminar\xe1n los permisos asociados con este rol de los usuarios afectados y se eliminar\xe1 la asignaci\xf3n entre roles, usuarios y permisos.",
    role_deleted: "{{name}} fue eliminado correctamente.",
    settings_tab: "Configuraci\xf3n",
    users_tab: "Usuarios",
    m2m_apps_tab: "Aplicaciones de m\xe1quina a m\xe1quina",
    permissions_tab: "Permisos",
    settings: "Configuraci\xf3n",
    settings_description: "Los roles son un agrupamiento de permisos que se pueden asignar a los usuarios. Tambi\xe9n proporcionan una manera de agregar permisos definidos para diferentes APIs, lo que hace m\xe1s eficiente agregar, eliminar o ajustar permisos en comparaci\xf3n con asignarlos individualmente a los usuarios.",
    field_name: "Nombre",
    field_description: "Descripci\xf3n",
    type_m2m_role_tag: "Rol de aplicaci\xf3n de m\xe1quina a m\xe1quina",
    type_user_role_tag: "Rol de usuario",
    permission: {
        assign_button: "Asignar permisos",
        assign_title: "Asignar permisos",
        assign_subtitle: "Asigne permisos a este rol. El rol adquirir\xe1 los permisos agregados y los usuarios con este rol heredar\xe1n estos permisos.",
        assign_form_field: "Asignar permisos",
        added_text_one: "{{count, number}} permiso agregado",
        added_text_other: "{{count, number}} permisos agregados",
        api_permission_count_one: "{{count, number}} permiso",
        api_permission_count_other: "{{count, number}} permisos",
        confirm_assign: "Asignar permisos",
        permission_assigned: "Los permisos seleccionados se asignaron correctamente a este rol",
        deletion_description: "Si se elimina este permiso, el usuario afectado con este rol perder\xe1 el acceso otorgado por este permiso.",
        permission_deleted: 'El permiso "{{name}}" fue eliminado correctamente de este rol',
        empty: "No hay permisos disponibles"
    },
    users: {
        assign_button: "Asignar usuarios",
        name_column: "Usuario",
        app_column: "Aplicaci\xf3n",
        latest_sign_in_column: "\xdaltimo inicio de sesi\xf3n",
        delete_description: "Permanecer\xe1 en su conjunto de usuarios, pero perder\xe1 la autorizaci\xf3n para este rol.",
        deleted: "{{name}} fue eliminado correctamente de este rol",
        assign_title: "Asignar usuarios",
        assign_subtitle: "Asignar usuarios a este rol. Encuentre usuarios apropiados buscando nombre, correo electr\xf3nico, tel\xe9fono o ID de usuario.",
        assign_field: "Asignar usuarios",
        confirm_assign: "Asignar usuarios",
        assigned_toast_text: "Los usuarios seleccionados se asignaron correctamente a este rol",
        empty: "No hay usuarios disponibles"
    },
    applications: {
        assign_button: "Asignar aplicaciones",
        name_column: "Aplicaci\xf3n",
        app_column: "Aplicaciones",
        description_column: "Descripci\xf3n",
        delete_description: "Permanecer\xe1 en su conjunto de aplicaciones, pero perder\xe1 la autorizaci\xf3n para este rol.",
        deleted: "{{name}} se elimin\xf3 correctamente de este rol",
        assign_title: "Asignar aplicaciones",
        assign_subtitle: "Asignar aplicaciones a este rol. Encuentre las aplicaciones adecuadas buscando el nombre, la descripci\xf3n o el ID de la aplicaci\xf3n.",
        assign_field: "Asignar aplicaciones",
        confirm_assign: "Asignar aplicaciones",
        assigned_toast_text: "Las aplicaciones seleccionadas se asignaron correctamente a este rol",
        empty: "No hay aplicaciones disponibles"
    }
};
var $efe1d8005ce38ec7$export$2e2bcd8739ae039 = Object.freeze($efe1d8005ce38ec7$var$role_details);


const $5458c5696b8ce88f$var$roles = {
    page_title: "Roles",
    title: "Roles",
    subtitle: "Los roles incluyen permisos que determinan lo que un usuario puede hacer. RBAC utiliza roles para dar acceso a recursos a los usuarios para acciones espec\xedficas.",
    create: "Crear Rol",
    role_name: "Nombre de rol",
    role_type: "Tipo de rol",
    show_role_type_button_text: "Mostrar m\xe1s opciones",
    hide_role_type_button_text: "Ocultar m\xe1s opciones",
    type_user: "Rol de usuario",
    type_machine_to_machine: "Rol de aplicaci\xf3n de m\xe1quina a m\xe1quina",
    role_description: "Descripci\xf3n",
    role_name_placeholder: "Ingrese el nombre de su rol",
    role_description_placeholder: "Ingrese la descripci\xf3n de su rol",
    col_roles: "Roles",
    col_type: "Tipo",
    col_description: "Descripci\xf3n",
    col_assigned_entities: "Asignados",
    user_counts: "{{count}} usuarios",
    application_counts: "{{count}} aplicaciones",
    user_count: "{{count}} usuario",
    application_count: "{{count}} aplicaci\xf3n",
    assign_permissions: "Asignar permisos",
    create_role_title: "Crear Rol",
    create_role_description: "Cree y administre roles para sus aplicaciones. Los roles contienen colecciones de permisos y pueden asignarse a los usuarios.",
    create_role_button: "Crear Rol",
    role_created: "El rol {{name}} se ha creado satisfactoriamente.",
    search: "Buscar por nombre de rol, descripci\xf3n o ID",
    placeholder_title: "Roles",
    placeholder_description: "Los roles son un grupo de permisos que se pueden asignar a los usuarios. Aseg\xfarese de agregar permisos antes de crear roles."
};
var $5458c5696b8ce88f$export$2e2bcd8739ae039 = Object.freeze($5458c5696b8ce88f$var$roles);


const $c3c80b5558edd31a$var$session_expired = {
    title: "Sesi\xf3n expirada",
    subtitle: "Es posible que su sesi\xf3n haya expirado y se haya desconectado. Haga clic en el bot\xf3n de abajo para iniciar sesi\xf3n en la consola de administraci\xf3n nuevamente.",
    button: "Iniciar sesi\xf3n de nuevo"
};
var $c3c80b5558edd31a$export$2e2bcd8739ae039 = Object.freeze($c3c80b5558edd31a$var$session_expired);


const $c82f707800cd73e4$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $c82f707800cd73e4$export$2e2bcd8739ae039 = Object.freeze($c82f707800cd73e4$var$content);


const $89f82ff6a5b7a6a6$var$password_policy = {
    password_requirements: "Requisitos de contrase\xf1a",
    minimum_length: "Longitud m\xednima",
    minimum_length_description: "NIST sugiere usar <a>al menos 8 caracteres</a> para productos web.",
    minimum_length_error: "La longitud m\xednima debe estar entre {{min}} y {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres requeridos m\xednimos",
    minimum_required_char_types_description: "Tipos de caracteres: may\xfasculas (A-Z), min\xfasculas (a-z), n\xfameros (0-9) y s\xedmbolos especiales ({{symbols}}).",
    password_rejection: "Rechazo de contrase\xf1a",
    compromised_passwords: "Contrase\xf1as comprometidas",
    breached_passwords: "Contrase\xf1as vulneradas",
    breached_passwords_description: "Rechazar contrase\xf1as encontradas previamente en bases de datos de vulnerabilidad.",
    restricted_phrases: "Restringir frases de baja seguridad",
    restricted_phrases_tooltip: "Su contrase\xf1a debe evitar estas frases a menos que combine con 3 o m\xe1s caracteres adicionales.",
    repetitive_or_sequential_characters: "Caracteres repetitivos o secuenciales",
    repetitive_or_sequential_characters_description: 'Por ejemplo, "AAAA", "1234" y "abcd".',
    user_information: "Informaci\xf3n de usuario",
    user_information_description: "Por ejemplo, direcci\xf3n de correo electr\xf3nico, n\xfamero de tel\xe9fono, nombre de usuario, etc.",
    custom_words: "Palabras personalizadas",
    custom_words_description: "Personaliza las palabras espec\xedficas del contexto, sin importar las may\xfasculas y min\xfasculas, y una por l\xednea.",
    custom_words_placeholder: "Nombre de su servicio, nombre de la empresa, etc."
};
var $89f82ff6a5b7a6a6$export$2e2bcd8739ae039 = Object.freeze($89f82ff6a5b7a6a6$var$password_policy);


const $9508861801036b79$var$sign_up_and_sign_in = {
    identifiers_email: "Direcci\xf3n de correo electr\xf3nico",
    identifiers_phone: "N\xfamero de tel\xe9fono",
    identifiers_username: "Nombre de usuario",
    identifiers_email_or_sms: "Direcci\xf3n de correo electr\xf3nico o n\xfamero de tel\xe9fono",
    identifiers_none: "No aplicable",
    and: "y",
    or: "o",
    sign_up: {
        title: "REGISTRARSE",
        sign_up_identifier: "Identificador de registro",
        identifier_description: "El identificador de registro es necesario para la creaci\xf3n de la cuenta y debe incluirse en la pantalla de inicio de sesi\xf3n.",
        sign_up_authentication: "Configuraci\xf3n de autenticaci\xf3n para el registro",
        authentication_description: "Todas las acciones seleccionadas ser\xe1n obligatorias para que los usuarios completen el proceso.",
        set_a_password_option: "Crear una contrase\xf1a",
        verify_at_sign_up_option: "Verificar al registrarse",
        social_only_creation_description: "(Esto se aplica solo a la creaci\xf3n de cuentas mediante redes sociales)"
    },
    sign_in: {
        title: "INICIAR SESI\xd3N",
        sign_in_identifier_and_auth: "Identificador y configuraci\xf3n de autenticaci\xf3n para iniciar sesi\xf3n",
        description: "Los usuarios pueden iniciar sesi\xf3n usando cualquiera de las opciones disponibles. Ajusta el dise\xf1o arrastrando y soltando las opciones a continuaci\xf3n.",
        add_sign_in_method: "Agregar m\xe9todo de inicio de sesi\xf3n",
        password_auth: "Contrase\xf1a",
        verification_code_auth: "C\xf3digo de verificaci\xf3n",
        auth_swap_tip: "Intercambia las opciones a continuaci\xf3n para determinar cu\xe1l aparece primero en el proceso.",
        require_auth_factor: "Debes seleccionar al menos un factor de autenticaci\xf3n."
    },
    social_sign_in: {
        title: "INICIO DE SESI\xd3N SOCIAL",
        social_sign_in: "Inicio de sesi\xf3n social",
        description: "Dependiendo del identificador obligatorio que hayas establecido, se puede solicitar al usuario que proporcione un identificador al registrarse mediante un conector social.",
        add_social_connector: "Agregar conector social",
        set_up_hint: {
            not_in_list: "\xbfNo est\xe1 en la lista?",
            set_up_more: "Configura",
            go_to: "otros conectores sociales ahora."
        }
    },
    tip: {
        set_a_password: "Es esencial que se establezca una contrase\xf1a \xfanica para que coincida con tu nombre de usuario.",
        verify_at_sign_up: "Actualmente solo admitimos correo electr\xf3nico verificado. Tu base de usuarios puede contener un gran n\xfamero de direcciones de correo electr\xf3nico de baja calidad si no se valida.",
        password_auth: "Es esencial ya que has habilitado la opci\xf3n de establecer una contrase\xf1a durante el proceso de registro.",
        verification_code_auth: "Es esencial ya que solo has habilitado la opci\xf3n de proporcionar un c\xf3digo de verificaci\xf3n al registrarse. Se puede desactivar la opci\xf3n si se permite la configuraci\xf3n de contrase\xf1a durante el proceso de registro.",
        delete_sign_in_method: "Es esencial ya que has seleccionado {{identifier}} como identificador obligatorio."
    },
    advanced_options: {
        title: "OPCIONES AVANZADAS",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Habilitar registro de usuario",
        enable_user_registration_description: "Habilitar o deshabilitar el registro de usuarios. Una vez deshabilitado, los usuarios a\xfan se pueden agregar en la consola de administraci\xf3n, pero los usuarios ya no pueden establecer cuentas a trav\xe9s de la interfaz de inicio de sesi\xf3n."
    }
};
var $9508861801036b79$export$2e2bcd8739ae039 = Object.freeze($9508861801036b79$var$sign_up_and_sign_in);


const $9b9c9e89ef4d47b3$var$sign_in_exp = {
    page_title: "Experiencia de inicio de sesi\xf3n",
    title: "Experiencia de inicio de sesi\xf3n",
    description: "Personalice la interfaz de inicio de sesi\xf3n para que se adapte a su marca y visualice en tiempo real",
    tabs: {
        branding: "Branding",
        sign_up_and_sign_in: "Registro e inicio de sesi\xf3n",
        content: "Contenido",
        password_policy: "Pol\xedtica de contrase\xf1a"
    },
    welcome: {
        title: "Personalice la experiencia de inicio de sesi\xf3n",
        description: "Comience r\xe1pidamente con su primera configuraci\xf3n de inicio de sesi\xf3n. Esta gu\xeda lo guiar\xe1 a trav\xe9s de todas las configuraciones necesarias.",
        get_started: "Comenzar",
        apply_remind: "Tenga en cuenta que la experiencia de inicio de sesi\xf3n se aplicar\xe1 a todas las aplicaciones de esta cuenta."
    },
    color: {
        title: "COLOR",
        primary_color: "Color de la marca",
        dark_primary_color: "Color de la marca (oscuro)",
        dark_mode: "Habilitar modo oscuro",
        dark_mode_description: "Su aplicaci\xf3n tendr\xe1 un tema de modo oscuro generado autom\xe1ticamente en funci\xf3n del color de su marca y el algoritmo de Logto. Puede personalizarlo libremente.",
        dark_mode_reset_tip: "Vuelva a calcular el color del modo oscuro en funci\xf3n del color de la marca.",
        reset: "Volver a calcular"
    },
    branding: {
        title: "\xc1REA DE BRANDING",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL de imagen del logotipo de la aplicaci\xf3n",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL de imagen del logotipo de la aplicaci\xf3n (oscuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logotipo de la aplicaci\xf3n",
        dark_logo_image: "Logotipo de la aplicaci\xf3n (oscuro)",
        logo_image_error: "Logotipo de la aplicaci\xf3n: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizado",
        css_code_editor_title: "Personalice su IU con CSS personalizado",
        css_code_editor_description1: "Vea el ejemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "M\xe1s informaci\xf3n",
        css_code_editor_content_placeholder: "Ingrese su CSS personalizado para adaptar los estilos de cualquier cosa a sus especificaciones exactas. Expresa tu creatividad y haz que tu IU se destaque."
    },
    sign_up_and_sign_in: $9508861801036b79$export$2e2bcd8739ae039,
    content: $c82f707800cd73e4$export$2e2bcd8739ae039,
    password_policy: $89f82ff6a5b7a6a6$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'A\xfan no se ha configurado el conector SMS. Antes de completar la configuraci\xf3n, los usuarios no podr\xe1n iniciar sesi\xf3n con este m\xe9todo. <a>{{link}}</a> en "Conectores"',
        no_connector_email: 'A\xfan no se ha configurado el conector de correo electr\xf3nico. Antes de completar la configuraci\xf3n, los usuarios no podr\xe1n iniciar sesi\xf3n con este m\xe9todo. <a>{{link}}</a> en "Conectores"',
        no_connector_social: 'Todav\xeda no ha configurado ning\xfan conector social. Agregue conectores primero para aplicar m\xe9todos de inicio de sesi\xf3n social. <a>{{link}}</a> en "Conectores".',
        setup_link: "Configuraci\xf3n"
    },
    save_alert: {
        description: "Est\xe1 implementando nuevos procedimientos de inicio de sesi\xf3n y registro. Todos sus usuarios pueden verse afectados por la nueva configuraci\xf3n. \xbfEst\xe1s seguro de comprometerte con el cambio?",
        before: "Antes",
        after: "Despu\xe9s",
        sign_up: "Registro",
        sign_in: "Inicio de sesi\xf3n",
        social: "Social"
    },
    preview: {
        title: "Previsualizaci\xf3n del inicio de sesi\xf3n",
        live_preview: "Vista previa en vivo",
        live_preview_tip: "Guarde para previsualizar los cambios",
        native: "Nativo",
        desktop_web: "Web de escritorio",
        mobile_web: "Web m\xf3vil",
        desktop: "Escritorio",
        mobile: "M\xf3vil"
    }
};
var $9b9c9e89ef4d47b3$export$2e2bcd8739ae039 = Object.freeze($9b9c9e89ef4d47b3$var$sign_in_exp);


const $e28517bc25a134e8$var$quota_item = {
    tenant_limit: {
        name: "Inquilinos",
        limited: "{{count, number}} inquilino",
        limited_other: "{{count, number}} inquilinos",
        unlimited: "Inquilinos ilimitados",
        not_eligible: "Elimine sus inquilinos"
    },
    mau_limit: {
        name: "Usuarios activos mensuales",
        limited: "{{count, number}} UAM",
        unlimited: "UAM ilimitados",
        not_eligible: "Elimine a todos sus usuarios"
    },
    applications_limit: {
        name: "Aplicaciones",
        limited: "{{count, number}} aplicaci\xf3n",
        limited_other: "{{count, number}} aplicaciones",
        unlimited: "Aplicaciones ilimitadas",
        not_eligible: "Elimine sus aplicaciones"
    },
    machine_to_machine_limit: {
        name: "Aplicaciones de dispositivo a dispositivo",
        limited: "{{count, number}} aplicaci\xf3n de dispositivo a dispositivo",
        limited_other: "{{count, number}} aplicaciones de dispositivo a dispositivo",
        unlimited: "Aplicaciones de dispositivo a dispositivo ilimitadas",
        not_eligible: "Elimine sus aplicaciones de dispositivo a dispositivo"
    },
    resources_limit: {
        name: "Recursos de API",
        limited: "{{count, number}} recurso de API",
        limited_other: "{{count, number}} recursos de API",
        unlimited: "Recursos de API ilimitados",
        not_eligible: "Elimine sus recursos de API"
    },
    scopes_per_resource_limit: {
        name: "Permisos de recursos",
        limited: "{{count, number}} permiso por recurso",
        limited_other: "{{count, number}} permisos por recurso",
        unlimited: "Permiso por recurso ilimitado",
        not_eligible: "Elimine sus permisos de recursos"
    },
    custom_domain_enabled: {
        name: "Dominio personalizado",
        limited: "Dominio personalizado",
        unlimited: "Dominio personalizado",
        not_eligible: "Elimine su dominio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Inicio de sesi\xf3n Omni",
        limited: "Inicio de sesi\xf3n Omni",
        unlimited: "Inicio de sesi\xf3n Omni",
        not_eligible: "Deshabilite su inicio de sesi\xf3n Omni"
    },
    built_in_email_connector_enabled: {
        name: "Conector de correo electr\xf3nico integrado",
        limited: "Conector de correo electr\xf3nico integrado",
        unlimited: "Conector de correo electr\xf3nico integrado",
        not_eligible: "Elimine su conector de correo electr\xf3nico integrado"
    },
    social_connectors_limit: {
        name: "Conectores sociales",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociales",
        unlimited: "Conectores sociales ilimitados",
        not_eligible: "Elimine sus conectores sociales"
    },
    standard_connectors_limit: {
        name: "Conectores est\xe1ndar gratuitos",
        limited: "{{count, number}} conector est\xe1ndar gratuito",
        limited_other: "{{count, number}} conectores est\xe1ndar gratuitos",
        unlimited: "Conectores est\xe1ndar ilimitados",
        not_eligible: "Elimine sus conectores est\xe1ndar"
    },
    roles_limit: {
        name: "Roles",
        limited: "{{count, number}} rol",
        limited_other: "{{count, number}} roles",
        unlimited: "Roles ilimitados",
        not_eligible: "Elimine sus roles"
    },
    scopes_per_role_limit: {
        name: "Permisos de roles",
        limited: "{{count, number}} permiso por rol",
        limited_other: "{{count, number}} permisos por rol",
        unlimited: "Permiso por rol ilimitado",
        not_eligible: "Elimine sus permisos de roles"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Elimina tus webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Conservaci\xf3n de registros de auditor\xeda",
        limited: "Conservaci\xf3n de registros de auditor\xeda: {{count, number}} d\xeda",
        limited_other: "Conservaci\xf3n de registros de auditor\xeda: {{count, number}} d\xedas",
        unlimited: "D\xedas ilimitados",
        not_eligible: "Sin registros de auditor\xeda"
    },
    community_support_enabled: {
        name: "Soporte de la comunidad",
        limited: "Soporte de la comunidad",
        unlimited: "Soporte de la comunidad",
        not_eligible: "Sin soporte de la comunidad"
    },
    customer_ticket_support: {
        name: "Soporte de tickets de clientes",
        limited: "{{count, number}} hora de soporte de tickets de clientes",
        limited_other: "{{count, number}} horas de soporte de tickets de clientes",
        unlimited: "Soporte de tickets de clientes",
        not_eligible: "Sin soporte de tickets de clientes"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Desactiva tu MFA"
    },
    sso_enabled: {
        name: "SSO empresarial",
        limited: "SSO empresarial",
        unlimited: "SSO empresarial",
        not_eligible: "Desactiva tu SSO empresarial"
    }
};
var $e28517bc25a134e8$export$2e2bcd8739ae039 = Object.freeze($e28517bc25a134e8$var$quota_item);


const $f56ca52e72de4f0e$var$quota_table = {
    quota: {
        title: "Cuota",
        tenant_limit: "L\xedmite de inquilinos",
        base_price: "Precio base",
        mau_unit_price: "* Precio unitario de MAU",
        mau_limit: "L\xedmite de MAU"
    },
    application: {
        title: "Aplicaciones",
        total: "Total de aplicaciones",
        m2m: "Aplicaci\xf3n machine-to-machine"
    },
    resource: {
        title: "Recursos de API",
        resource_count: "Cantidad de recursos",
        scopes_per_resource: "Permisos por recurso"
    },
    branding: {
        title: "Interfaz de usuario y branding",
        custom_domain: "Dominio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Logo de la aplicaci\xf3n y favicon",
        dark_mode: "Modo oscuro",
        i18n: "Internacionalizaci\xf3n"
    },
    user_authn: {
        title: "Autenticaci\xf3n de usuario",
        omni_sign_in: "Inicio de sesi\xf3n omnicanal",
        password: "Contrase\xf1a",
        passwordless: "Sin contrase\xf1a - Correo electr\xf3nico y SMS",
        email_connector: "Conector de correo electr\xf3nico",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociales",
        standard_connectors: "Conectores est\xe1ndar",
        built_in_email_connector: "Conector de correo electr\xf3nico incorporado",
        mfa: "MFA",
        sso: "SSO empresarial"
    },
    user_management: {
        title: "Gesti\xf3n de usuarios",
        user_management: "Gesti\xf3n de usuarios",
        roles: "Roles",
        scopes_per_role: "Permisos por rol"
    },
    audit_logs: {
        title: "Registros de auditor\xeda",
        retention: "Retenci\xf3n"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organizaci\xf3n",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Soporte",
        community: "Comunidad",
        customer_ticket: "Ticket de soporte",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Sus usuarios activos mensuales (MAU) se dividen en 3 niveles seg\xfan la frecuencia con la que inician sesi\xf3n durante el ciclo de facturaci\xf3n. Cada nivel tiene un precio diferente por unidad de MAU.",
    unlimited: "Ilimitado",
    contact: "Contacto",
    monthly_price: "${{value, number}}/mes",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} d\xeda",
    days_other: "{{count, number}} d\xedas",
    add_on: "Complemento",
    tier: "Nivel{{value, number}}: "
};
var $f56ca52e72de4f0e$export$2e2bcd8739ae039 = Object.freeze($f56ca52e72de4f0e$var$quota_table);


const $1c3a6bd21dfd7b78$var$subscription = {
    free_plan: "Plan Gratuito",
    free_plan_description: "Para proyectos secundarios y pruebas iniciales de Logto. No se requiere tarjeta de cr\xe9dito.",
    hobby_plan: "Plan de Hobby",
    hobby_plan_description: "Para desarrolladores individuales o peque\xf1os equipos de ingenier\xeda.",
    pro_plan: "Plan Pro",
    pro_plan_description: "Benef\xedciese sin preocupaciones con Logto para empresas.",
    enterprise: "Empresa",
    current_plan: "Plan Actual",
    current_plan_description: "Aqu\xed est\xe1 tu plan actual. Puedes ver f\xe1cilmente el uso de tu plan, revisar tu pr\xf3xima factura y hacer cambios en tu plan seg\xfan sea necesario.",
    plan_usage: "Uso del plan",
    plan_cycle: "Ciclo del plan: {{period}}. La renovaci\xf3n del uso se realiza en {{renewDate}}.",
    next_bill: "Su pr\xf3xima factura",
    next_bill_hint: "Para obtener m\xe1s informaci\xf3n sobre el c\xe1lculo, consulte este <a>art\xedculo</a>.",
    next_bill_tip: "Su pr\xf3xima factura incluye el precio base de su plan para el pr\xf3ximo mes, as\xed como el costo de su uso multiplicado por el precio de la unidad MAU en varios niveles.",
    manage_payment: "Gestionar el pago",
    overfill_quota_warning: "Ha alcanzado el l\xedmite de su cuota. Para evitar problemas, actualice el plan.",
    upgrade_pro: "Actualizar a Pro",
    update_payment: "Actualizar pago",
    payment_error: "Se ha detectado un problema de pago. No se puede procesar ${ {price, number}} para el ciclo anterior. Actualice el pago para evitar la suspensi\xf3n del servicio Logto.",
    downgrade: "Degradar",
    current: "Actual",
    upgrade: "Actualizar",
    quota_table: $f56ca52e72de4f0e$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "factura",
        status_column: "estado",
        amount_column: "monto",
        invoice_created_date_column: "Fecha de creaci\xf3n de la factura",
        invoice_status: {
            void: "Cancelada",
            paid: "Pagada",
            open: "Abierta",
            uncollectible: "Vencida"
        }
    },
    quota_item: $e28517bc25a134e8$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "\xbfEst\xe1 seguro de que desea degradar?",
        description: "Si elige cambiar a <targetName/>, tenga en cuenta que ya no tendr\xe1 acceso a la cuota y las funciones que ten\xeda anteriormente en <currentName/>.",
        before: "Antes: <name/>",
        after: "Despu\xe9s: <name/>",
        downgrade: "Degradar"
    },
    not_eligible_modal: {
        downgrade_title: "No es posible el cambio a un plan inferior",
        downgrade_description: "Aseg\xfarese de cumplir con los siguientes criterios antes de cambiar al plan <name/>.",
        downgrade_help_tip: "\xbfNecesitas ayuda para cambiar de plan? <a>Cont\xe1ctenos</a>.",
        upgrade_title: "Recordatorio amistoso para nuestros apreciados early adopters",
        upgrade_description: "Actualmente est\xe1s usando m\xe1s de lo permitido por <name />. Logto es ahora oficial e incluye caracter\xedsticas adaptadas a cada plan. Antes de considerar la actualizaci\xf3n al <name />, aseg\xfarate de cumplir con los siguientes criterios antes de hacer el upgrade.",
        upgrade_pro_tip: " O considera actualizar al Plan Pro.",
        upgrade_help_tip: "\xbfNecesitas ayuda para cambiar de plan? <a>Cont\xe1ctenos</a>.",
        a_maximum_of: "Un m\xe1ximo de <item/>"
    },
    upgrade_success: "Actualizado con \xe9xito a <name/>",
    downgrade_success: "Degradado con \xe9xito a <name/>",
    subscription_check_timeout: "La comprobaci\xf3n de suscripci\xf3n expir\xf3. Por favor, actualiza m\xe1s tarde.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $1c3a6bd21dfd7b78$export$2e2bcd8739ae039 = Object.freeze($1c3a6bd21dfd7b78$var$subscription);


const $47b2a511bb465b13$var$tab_sections = {
    overview: "Visi\xf3n general",
    resources: "Recursos",
    users: "Usuarios",
    access_control: "Control de acceso",
    help_and_support: "Ayuda y soporte",
    tenant: "Inquilino",
    automation: "Automatizaci\xf3n"
};
var $47b2a511bb465b13$export$2e2bcd8739ae039 = Object.freeze($47b2a511bb465b13$var$tab_sections);


const $ea5ad10a68b0665b$var$tabs = {
    get_started: "Empezar",
    dashboard: "Tablero",
    applications: "Aplicaciones",
    api_resources: "Recursos de API",
    sign_in_experience: "Experiencia de inicio de sesi\xf3n",
    connectors: "Conectores",
    enterprise_sso: "SSO empresarial",
    webhooks: "Webhooks",
    organizations: "Organizaciones",
    users: "Gesti\xf3n de usuarios",
    audit_logs: "Registros de auditor\xeda",
    roles: "Roles",
    docs: "Documentos",
    tenant_settings: "Configuraciones del inquilino",
    mfa: "Autenticaci\xf3n multifactor"
};
var $ea5ad10a68b0665b$export$2e2bcd8739ae039 = Object.freeze($ea5ad10a68b0665b$var$tabs);


const $ebb70d1f85eacceb$var$tenants = {
    title: "Configuraciones",
    description: "Administre eficientemente la configuraci\xf3n del inquilino y personalice su dominio.",
    tabs: {
        settings: "Configuraciones",
        domains: "Dominios",
        subscription: "Plan y facturaci\xf3n",
        billing_history: "Historial de facturaci\xf3n"
    },
    settings: {
        title: "CONFIGURACIONES",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID del inquilino",
        tenant_name: "Nombre del inquilino",
        tenant_region: "Regi\xf3n de alojamiento de datos",
        tenant_region_tip: "Sus recursos de inquilino se alojan en {{region}}. <a>Obtener m\xe1s informaci\xf3n</a>",
        environment_tag_development: "Desarrollo",
        environment_tag_staging: "Pruebas",
        environment_tag_production: "Producci\xf3n",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Informaci\xf3n del inquilino guardada correctamente."
    },
    full_env_tag: {
        development: "Desarrollo",
        production: "Producci\xf3n"
    },
    deletion_card: {
        title: "ELIMINAR",
        tenant_deletion: "Eliminar inquilino",
        tenant_deletion_description: "Eliminar el inquilino resultar\xe1 en la eliminaci\xf3n permanente de todos los datos de usuario y configuraciones asociadas. Por favor, proceda con precauci\xf3n.",
        tenant_deletion_button: "Eliminar inquilino"
    },
    create_modal: {
        title: "Crear inquilino",
        subtitle: "Cree un nuevo inquilino que tenga recursos y usuarios aislados. La regi\xf3n de datos alojados y los tipos de inquilinos no se pueden modificar despu\xe9s de la creaci\xf3n.",
        tenant_usage_purpose: "\xbfPara qu\xe9 desea usar este inquilino?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Plan disponible:",
        create_button: "Crear inquilino",
        tenant_name_placeholder: "Mi inquilino"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Eliminar inquilino",
        description_line1: '\xbfEst\xe1 seguro de que desea eliminar su inquilino "<span>{{name}}</span>" con etiqueta de sufijo de entorno"<span>{{tag}}</span>"? Esta acci\xf3n no se puede deshacer y resultar\xe1 en la eliminaci\xf3n permanente de todos sus datos e informaci\xf3n de cuenta.',
        description_line2: "Antes de eliminar la cuenta, quiz\xe1s podamos ayudarlo. <span><a>Cont\xe1ctenos por correo electr\xf3nico</a></span>",
        description_line3: 'Si desea continuar, ingrese el nombre del inquilino "<span>{{name}}</span>" para confirmar.',
        delete_button: "Eliminar permanentemente",
        cannot_delete_title: "No se puede eliminar este inquilino",
        cannot_delete_description: "Lo siento, no puedes eliminar este inquilino en este momento. Aseg\xfarate de estar en el Plan Gratuito y haber pagado todas las facturas pendientes."
    },
    tenant_landing_page: {
        title: "Todav\xeda no has creado un tenant",
        description: "Para empezar a configurar tu proyecto con Logto, por favor crea un nuevo tenant. Si necesitas cerrar la sesi\xf3n o eliminar tu cuenta, simplemente haz clic en el bot\xf3n de avatar en la esquina superior derecha.",
        create_tenant_button: "Crear tenant"
    },
    status: {
        mau_exceeded: "L\xedmite MAU excedido",
        suspended: "Suspendido",
        overdue: "Vencido"
    },
    tenant_suspended_page: {
        title: "Inquilino suspendido. Cont\xe1ctenos para restaurar el acceso.",
        description_1: "Lamentamos informarle que su cuenta de inquilino ha sido suspendida temporalmente debido a un uso indebido, que incluye exceder los l\xedmites de MAU, pagos atrasados ​​u otras acciones no autorizadas.",
        description_2: "Si necesita aclaraciones adicionales, tiene alguna inquietud o desea restaurar la funcionalidad completa y desbloquear sus inquilinos, no dude en contactarnos de inmediato."
    },
    signing_keys: {
        title: "CLAVES DE FIRMA",
        description: "Administre de forma segura las claves de firma en su inquilino.",
        type: {
            private_key: "Claves privadas OIDC",
            cookie_key: "Claves de cookies OIDC"
        },
        private_keys_in_use: "Claves privadas en uso",
        cookie_keys_in_use: "Claves de cookies en uso",
        rotate_private_keys: "Rotar claves privadas",
        rotate_cookie_keys: "Rotar claves de cookies",
        rotate_private_keys_description: "Esta acci\xf3n crear\xe1 una nueva clave de firma privada, rotar\xe1 la clave actual y eliminar\xe1 su clave anterior. Sus tokens JWT firmados con la clave actual seguir\xe1n siendo v\xe1lidos hasta su eliminaci\xf3n o otra rotaci\xf3n.",
        rotate_cookie_keys_description: "Esta acci\xf3n crear\xe1 una nueva clave de cookie, rotar\xe1 la clave actual y eliminar\xe1 su clave anterior. Sus cookies con la clave actual seguir\xe1n siendo v\xe1lidos hasta su eliminaci\xf3n o otra rotaci\xf3n.",
        select_private_key_algorithm: "Seleccione el algoritmo de firma de la nueva clave privada",
        rotate_button: "Rotar",
        table_column: {
            id: "ID",
            status: "Estado",
            algorithm: "Algoritmo de clave de firma"
        },
        status: {
            current: "Actual",
            previous: "Anterior"
        },
        reminder: {
            rotate_private_key: "\xbfEst\xe1s seguro de que deseas rotar las <strong>claves privadas OIDC</strong>? Los nuevos tokens JWT emitidos ser\xe1n firmados por la nueva clave. Los tokens JWT existentes seguir\xe1n siendo v\xe1lidos hasta que los vuelvas a rotar.",
            rotate_cookie_key: "\xbfEst\xe1s seguro de que deseas rotar las <strong>claves de cookies OIDC</strong>? Las nuevas cookies generadas en sesiones de inicio de sesi\xf3n ser\xe1n firmadas por la nueva clave de cookie. Las cookies existentes seguir\xe1n siendo v\xe1lidas hasta que las vuelvas a rotar.",
            delete_private_key: "\xbfEst\xe1s seguro de que deseas eliminar la <strong>clave privada OIDC</strong>? Los tokens JWT existentes firmados con esta clave de firma privada ya no ser\xe1n v\xe1lidos.",
            delete_cookie_key: "\xbfEst\xe1s seguro de que deseas eliminar la <strong>clave de cookies OIDC</strong>? Las sesiones de inicio de sesi\xf3n antiguas con cookies firmadas con esta clave de cookie ya no ser\xe1n v\xe1lidas. Se requiere una reautenticaci\xf3n para estos usuarios."
        },
        messages: {
            rotate_key_success: "Claves de firma rotadas con \xe9xito.",
            delete_key_success: "Clave eliminada con \xe9xito."
        }
    }
};
var $ebb70d1f85eacceb$export$2e2bcd8739ae039 = Object.freeze($ebb70d1f85eacceb$var$tenants);


const $3ad21b00da3fef7a$var$topbar = {
    docs: "Documentos",
    help: "Ayuda"
};
var $3ad21b00da3fef7a$export$2e2bcd8739ae039 = Object.freeze($3ad21b00da3fef7a$var$topbar);


const $901d5fe09850f0b5$var$paywall = {
    applications: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaci\xf3n de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    applications_other: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaciones de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_feature: "Actualiza al plan <strong>Hobby</strong> para desbloquear 1 aplicaci\xf3n de m\xe1quina a m\xe1quina, o elige el plan <strong>Pro</strong> para uso ilimitado. Para cualquier asistencia, no dudes en <a>contactarnos</a>.",
    machine_to_machine: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaci\xf3n de m\xe1quina a m\xe1quina de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    machine_to_machine_other: "Se ha alcanzado el l\xedmite de {{count, number}} aplicaciones de m\xe1quina a m\xe1quina de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. Para cualquier ayuda, no dudes en <a>contactarnos</a>.",
    resources: "Has alcanzado el l\xedmite de {{count, number}} recursos de API de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    resources_other: "Has alcanzado el l\xedmite de {{count, number}} recursos de API de <planName/>. Actualiza el plan para satisfacer las necesidades de tu equipo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    scopes_per_resource: "Has alcanzado el l\xedmite de {{count, number}} permisos por recurso de API de <planName/>. Actualiza ahora para expandirlo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    scopes_per_resource_other: "Has alcanzado el l\xedmite de {{count, number}} permisos por recurso de API de <planName/>. Actualiza ahora para expandirlo. <a>Cont\xe1ctanos</a> si necesitas asistencia.",
    custom_domain: "Desbloquea la funcionalidad de dominio personalizado al actualizar al plan <strong>Hobby</strong> o <strong>Pro</strong>. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    social_connectors: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    social_connectors_other: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_feature: "Actualiza al plan <strong>Hobby</strong> o <strong>Pro</strong> para crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML, adem\xe1s de conectores sociales ilimitados y todas las funciones premium. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    standard_connectors: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_other: "Has alcanzado el l\xedmite de {{count, number}} conectores sociales de <planName/>. Actualiza el plan para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_pro: "Has alcanzado el l\xedmite de {{count, number}} conectores est\xe1ndar de <planName/>. Actualiza al plan Enterprise para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    standard_connectors_pro_other: "Has alcanzado el l\xedmite de {{count, number}} conectores est\xe1ndar de <planName/>. Actualiza al plan Enterprise para obtener conectores sociales adicionales y la capacidad de crear tus propios conectores usando los protocolos OIDC, OAuth 2.0 y SAML. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    roles: "Has alcanzado el l\xedmite de {{count, number}} roles de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    roles_other: "Has alcanzado el l\xedmite de {{count, number}} roles de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    scopes_per_role: "Has alcanzado el l\xedmite de {{count, number}} permisos por rol de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    scopes_per_role_other: "Has alcanzado el l\xedmite de {{count, number}} permisos por rol de <planName/>. Actualiza el plan para agregar roles y permisos adicionales. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    hooks: "Has alcanzado el l\xedmite de {{count, number}} webhooks de <planName/>. Actualiza el plan para crear m\xe1s webhooks. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    hooks_other: "Has alcanzado el l\xedmite de {{count, number}} webhooks de <planName/>. Actualiza el plan para crear m\xe1s webhooks. Si necesitas ayuda, no dudes en <a>contactarnos</a>.",
    mfa: "Desbloquea MFA para verificar la seguridad al actualizar a un plan pago. No dudes en <a>contactarnos</a> si necesitas ayuda.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $901d5fe09850f0b5$export$2e2bcd8739ae039 = Object.freeze($901d5fe09850f0b5$var$paywall);


const $73dd07cea675c33d$var$upsell = {
    upgrade_plan: "Plan de actualizaci\xf3n",
    compare_plans: "Comparar planes",
    view_plans: "Ver planes",
    create_tenant: {
        title: "Selecciona tu plan de tenant",
        description: "Logto ofrece opciones de planes competitivos con una innovadora y asequible estructura de precios dise\xf1ada para empresas en crecimiento. <a>M\xe1s informaci\xf3n</a>",
        base_price: "Precio base",
        monthly_price: "{{value, number}}/mes",
        mau_unit_price: "Precio unitario de MAU",
        view_all_features: "Ver todas las caracter\xedsticas",
        select_plan: "Seleccionar <name/>",
        free_tenants_limit: "Hasta {{count, number}} tenant gratuito",
        free_tenants_limit_other: "Hasta {{count, number}} tenants gratuitos",
        most_popular: "M\xe1s popular",
        upgrade_success: "Actualizaci\xf3n a <name/> realizada con \xe9xito"
    },
    mau_exceeded_modal: {
        title: "Se ha superado el l\xedmite de MAU. Actualiza tu plan.",
        notification: "Tu MAU actual ha superado el l\xedmite de <planName/>. Por favor, actualiza tu plan a premium a tiempo para evitar la suspensi\xf3n del servicio de Logto.",
        update_plan: "Actualizar plan"
    },
    payment_overdue_modal: {
        title: "Factura con pagos atrasados",
        notification: "\xa1Ups! El pago de la factura del inquilino <span>{{name}}</span> ha fallado. Por favor, pague la factura a tiempo para evitar la suspensi\xf3n del servicio de Logto.",
        unpaid_bills: "Facturas impagas",
        update_payment: "Actualizar pago"
    },
    paywall: $901d5fe09850f0b5$export$2e2bcd8739ae039
};
var $73dd07cea675c33d$export$2e2bcd8739ae039 = Object.freeze($73dd07cea675c33d$var$upsell);


const $2a0ff1c4e81b3b53$var$user_details = {
    page_title: "Detalles de usuario",
    back_to_users: "Volver a la gesti\xf3n de usuarios",
    created_title: "Usuario creado con \xe9xito",
    created_guide: "Aqu\xed est\xe1 la informaci\xf3n para ayudar al usuario con su proceso de inicio de sesi\xf3n.",
    created_email: "Direcci\xf3n de correo electr\xf3nico:",
    created_phone: "N\xfamero de tel\xe9fono:",
    created_username: "Nombre de usuario:",
    created_password: "Contrase\xf1a:",
    menu_delete: "Eliminar",
    delete_description: "Esta acci\xf3n no se puede deshacer. Eliminar\xe1 permanentemente al usuario.",
    deleted: "Usuario eliminado con \xe9xito",
    reset_password: {
        reset_password: "Restablecer contrase\xf1a",
        title: "\xbfEst\xe1 seguro de que desea restablecer la contrase\xf1a?",
        content: "Esta acci\xf3n no se puede deshacer. Esto restablecer\xe1 la informaci\xf3n de inicio de sesi\xf3n del usuario.",
        congratulations: "Se ha restablecido la informaci\xf3n de inicio de sesi\xf3n del usuario",
        new_password: "Nueva contrase\xf1a:"
    },
    tab_settings: "Configuraci\xf3n",
    tab_roles: "Roles",
    tab_logs: "Registros de usuario",
    tab_organizations: "Organizaciones",
    authentication: "Autenticaci\xf3n",
    authentication_description: "Cada usuario tiene un perfil que contiene toda la informaci\xf3n del usuario. Consta de datos b\xe1sicos, identidades sociales y datos personalizados.",
    user_profile: "Perfil de usuario",
    field_email: "Direcci\xf3n de correo electr\xf3nico",
    field_phone: "N\xfamero de tel\xe9fono",
    field_username: "Nombre de usuario",
    field_name: "Nombre",
    field_avatar: "URL de imagen de avatar",
    field_avatar_placeholder: "https://tu.dominio.cdn/avatar.png",
    field_custom_data: "Datos personalizados",
    field_custom_data_tip: "Informaci\xf3n adicional del usuario no incluida en las propiedades de usuario predefinidas, como el color y el idioma preferidos del usuario.",
    field_connectors: "Conexiones sociales",
    field_sso_connectors: "Conexiones empresariales",
    custom_data_invalid: "Los datos personalizados deben ser un objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID de usuario",
        remove: "Eliminar",
        connected: "Este usuario est\xe1 conectado con varios conectores sociales.",
        not_connected: "El usuario no est\xe1 conectado a ning\xfan conector social",
        deletion_confirmation: "Est\xe1s eliminando la identidad existente <name/>. \xbfSeguro que quieres continuar?"
    },
    sso_connectors: {
        connectors: "Conectores",
        enterprise_id: "ID de empresa",
        connected: "Este usuario est\xe1 conectado a varios proveedores de identidad empresarial para inicio de sesi\xf3n \xfanico.",
        not_connected: "El usuario no est\xe1 conectado a ninguno de los proveedores de identidad empresarial para inicio de sesi\xf3n \xfanico."
    },
    mfa: {
        field_name: "Autenticaci\xf3n de dos factores",
        field_description: "Este usuario ha habilitado factores de autenticaci\xf3n de 2 pasos.",
        name_column: "Autenticaci\xf3n de dos factores",
        field_description_empty: "Este usuario no ha habilitado factores de autenticaci\xf3n de 2 pasos.",
        deletion_confirmation: "Est\xe1s eliminando la existente <name/> para la verificaci\xf3n en dos pasos. \xbfEst\xe1s seguro/a de que deseas continuar?"
    },
    suspended: "Suspendido",
    suspend_user: "Suspender usuario",
    suspend_user_reminder: "\xbfEst\xe1 seguro de que desea suspender a este usuario? El usuario no podr\xe1 iniciar sesi\xf3n en su aplicaci\xf3n y no podr\xe1 obtener un nuevo token de acceso despu\xe9s de que expire el actual. Adem\xe1s, todas las solicitudes de API realizadas por este usuario fallar\xe1n.",
    suspend_action: "Suspender",
    user_suspended: "El usuario ha sido suspendido.",
    reactivate_user: "Reactivar usuario",
    reactivate_user_reminder: "\xbfEst\xe1 seguro de que desea reactivar a este usuario? Al hacerlo, permitir\xe1 cualquier intento de inicio de sesi\xf3n para este usuario.",
    reactivate_action: "Reactivar",
    user_reactivated: "El usuario ha sido reactivado.",
    roles: {
        name_column: "Rol",
        description_column: "Descripci\xf3n",
        assign_button: "Asignar roles",
        delete_description: "Esta acci\xf3n eliminar\xe1 este rol de este usuario. El rol en s\xed seguir\xe1 existiendo, pero ya no estar\xe1 asociado con este usuario.",
        deleted: 'Se elimin\xf3 "{{name}}" correctamente de este usuario.',
        assign_title: "Asigne roles a {{name}}",
        assign_subtitle: "Autorice {{name}} uno o m\xe1s roles",
        assign_role_field: "Asignar roles",
        role_search_placeholder: "Buscar por nombre de rol",
        added_text: "{{value, number}} agregados",
        assigned_user_count: "{{value, number}} usuarios",
        confirm_assign: "Asignar roles",
        role_assigned: "Rol(es) asignado(s) con \xe9xito",
        search: "Buscar por nombre de rol, descripci\xf3n o ID",
        empty: "No hay roles disponibles"
    },
    warning_no_sign_in_identifier: "El usuario necesita tener al menos uno de los identificadores de inicio de sesi\xf3n (nombre de usuario, correo electr\xf3nico, n\xfamero de tel\xe9fono o red social) para iniciar sesi\xf3n. \xbfEst\xe1s seguro/a de que quieres continuar?",
    organization_roles_tooltip: "Los roles asignados al usuario dentro de esta organizaci\xf3n."
};
var $2a0ff1c4e81b3b53$export$2e2bcd8739ae039 = Object.freeze($2a0ff1c4e81b3b53$var$user_details);


const $0c3bb42345084fc4$var$users = {
    page_title: "Gesti\xf3n de usuarios",
    title: "Gesti\xf3n de usuarios",
    subtitle: "Administrar identidades de usuario, incluyendo la creaci\xf3n de usuarios, la edici\xf3n de informaci\xf3n de usuario, la visualizaci\xf3n de registros de usuario, la restablecimiento de contrase\xf1a y la eliminaci\xf3n de usuarios",
    create: "Agregar usuario",
    create_subtitle: "Proporcione al menos uno de los siguientes campos para continuar.",
    error_missing_identifier: "Debe proporcionar al menos un identificador para crear un usuario.",
    user_name: "Usuario",
    application_name: "De la aplicaci\xf3n",
    latest_sign_in: "\xdaltimo inicio de sesi\xf3n",
    create_form_username: "Nombre de usuario",
    create_form_password: "Contrase\xf1a",
    create_form_name: "Nombre completo",
    placeholder_name: "Fulano de Tal",
    placeholder_email: "fulano@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+34 123 456 789",
    unnamed: "Sin nombre",
    search: "Buscar por nombre, correo electr\xf3nico, tel\xe9fono o nombre de usuario",
    check_user_detail: "Ver detalles del usuario",
    placeholder_title: "Gesti\xf3n de usuarios",
    placeholder_description: "Cada usuario tiene un perfil que contiene toda su informaci\xf3n. Consta de datos b\xe1sicos, identidades sociales y datos personalizados."
};
var $0c3bb42345084fc4$export$2e2bcd8739ae039 = Object.freeze($0c3bb42345084fc4$var$users);


const $db9a1aa261de3771$var$webhook_details = {
    page_title: "Detalles de Webhook",
    back_to_webhooks: "Volver a Webhooks",
    not_in_use: "No se est\xe1 usando",
    success_rate: "Tasa de \xe9xito",
    requests: "Solicitudes en 24h: {{value, number}}",
    disable_webhook: "Desactivar webhook",
    disable_reminder: "\xbfEst\xe1 seguro de que desea reactivar este webhook? Al hacerlo, no se enviar\xe1 ninguna solicitud HTTP a la URL de extremo.",
    webhook_disabled: "El webhook se ha desactivado.",
    webhook_reactivated: "El webhook ha sido reactivado.",
    reactivate_webhook: "Reactivar webhook",
    delete_webhook: "Eliminar webhook",
    deletion_reminder: "Est\xe1 eliminando este webhook. Despu\xe9s de eliminarlo, no se enviar\xe1 ninguna solicitud HTTP a la URL de extremo.",
    deleted: "El webhook se ha eliminado correctamente.",
    settings_tab: "Configuraci\xf3n",
    recent_requests_tab: "Solicitudes recientes (24 h)",
    settings: {
        settings: "Configuraci\xf3n",
        settings_description: "Los webhooks le permiten recibir actualizaciones en tiempo real sobre eventos espec\xedficos, enviando una solicitud POST a la URL de su extremo. Esto le permite tomar medidas inmediatas en funci\xf3n de la nueva informaci\xf3n recibida.",
        events: "Eventos",
        events_description: "Seleccione los eventos desencadenantes que Logto enviar\xe1 como solicitud POST.",
        name: "Nombre",
        endpoint_url: "URL del Extremo",
        signing_key: "Clave de firma",
        signing_key_tip: "Agregue la clave secreta proporcionada por Logto a su extremo como encabezado de solicitud para garantizar la autenticidad del payload del webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar clave de firma",
        regenerate_key_reminder: "\xbfEst\xe1 seguro de que desea modificar la clave de firma? Regenerar tendr\xe1 efecto de inmediato. Recuerde modificar la clave de firma de forma s\xedncrona en su endpoint.",
        regenerated: "La clave de firma ha sido regenerada.",
        custom_headers: "Encabezados Personalizados",
        custom_headers_tip: "De manera opcional, puede agregar encabezados personalizados al payload del webhook para proporcionar m\xe1s contexto o metadatos sobre el evento.",
        key_duplicated_error: "Las claves no pueden repetirse.",
        key_missing_error: "Se requiere clave.",
        value_missing_error: "Se requiere valor.",
        invalid_key_error: "La clave no es v\xe1lida",
        invalid_value_error: "El valor no es v\xe1lido",
        test: "Prueba",
        test_webhook: "Probar su webhook",
        test_webhook_description: "Configure el webhook y pru\xe9belo con ejemplos de carga \xfatil para cada evento seleccionado para verificar la recepci\xf3n y el procesamiento correcto.",
        send_test_payload: "Enviar carga \xfatil de prueba",
        test_result: {
            endpoint_url: "URL del punto final: {{url}}",
            message: "Mensaje: {{message}}",
            response_status: "Estado de la respuesta: {{status, number}}",
            response_body: "Cuerpo de la respuesta: {{body}}",
            request_time: "Tiempo de solicitud: {{time}}",
            test_success: "La prueba del webhook en el punto final fue exitosa."
        }
    }
};
var $db9a1aa261de3771$export$2e2bcd8739ae039 = Object.freeze($db9a1aa261de3771$var$webhook_details);


const $bbf588e3dc44f442$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crea webhooks para recibir de manera f\xe1cil actualizaciones en tiempo real sobre eventos espec\xedficos.",
    create: "Crear Webhook",
    events: {
        post_register: "Crear nueva cuenta",
        post_sign_in: "Iniciar sesi\xf3n",
        post_reset_password: "Restablecer contrase\xf1a"
    },
    table: {
        name: "Nombre",
        events: "Eventos",
        success_rate: "Tasa de \xe9xito (24 h)",
        requests: "Solicitudes (24 h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crea un webhook para recibir actualizaciones en tiempo real a trav\xe9s de solicitudes POST a tu URL de punto final. Mantente informado y toma medidas inmediatas en eventos como "Crear cuenta", "Iniciar sesi\xf3n" y "Restablecer contrase\xf1a".',
        create_webhook: "Crear Webhook"
    },
    create_form: {
        title: "Crear Webhook",
        subtitle: "Agregue el Webhook para enviar una solicitud POST a la URL de punto final con detalles de cualquier evento de usuario.",
        events: "Eventos",
        events_description: "Seleccione los eventos desencadenantes que Logto enviar\xe1 la solicitud POST.",
        name: "Nombre",
        name_placeholder: "Ingrese el nombre del webhook",
        endpoint_url: "URL de punto final",
        endpoint_url_placeholder: "https://su.webhook.endpoint.url",
        endpoint_url_tip: "Ingrese la URL de su punto final a donde se env\xeda la carga \xfatil del webhook cuando ocurre el evento.",
        create_webhook: "Crear webhook",
        missing_event_error: "Debe seleccionar al menos un evento."
    },
    webhook_created: "El webhook {{name}} se ha creado correctamente."
};
var $bbf588e3dc44f442$export$2e2bcd8739ae039 = Object.freeze($bbf588e3dc44f442$var$webhooks);


const $68ffbc70e1e29415$var$welcome = {
    title: "Bienvenido a la Consola de Administraci\xf3n",
    description: "La consola de administraci\xf3n es una aplicaci\xf3n web para administrar Logto sin necesidad de conocimientos de programaci\xf3n. Primero creamos una cuenta. Con esta cuenta, puedes administrar Logto por ti mismo o en nombre de tu empresa.",
    create_account: "Crear cuenta"
};
var $68ffbc70e1e29415$export$2e2bcd8739ae039 = Object.freeze($68ffbc70e1e29415$var$welcome);


const $d58636ff2c737a54$var$admin_console = {
    title: "Consola de administraci\xf3n",
    admin_user: "Admin",
    system_app: "Sistema",
    menu: $ff6fd0028f794cd9$export$2e2bcd8739ae039,
    general: $b1a9f5b9a42c79a5$export$2e2bcd8739ae039,
    errors: $38a8d408ddd5e47a$export$2e2bcd8739ae039,
    tab_sections: $47b2a511bb465b13$export$2e2bcd8739ae039,
    tabs: $ea5ad10a68b0665b$export$2e2bcd8739ae039,
    applications: $f47ee1131606869a$export$2e2bcd8739ae039,
    application_details: $1a8f819cd53b0fa3$export$2e2bcd8739ae039,
    api_resources: $c016f14036243b84$export$2e2bcd8739ae039,
    api_resource_details: $3c295fc3ab984b89$export$2e2bcd8739ae039,
    connectors: $7396c56fb4fb07e9$export$2e2bcd8739ae039,
    connector_details: $eb5e76ada61c9c4e$export$2e2bcd8739ae039,
    enterprise_sso: $19628f9f0b25ce41$export$2e2bcd8739ae039,
    enterprise_sso_details: $6aa8d2a5dd29a8ed$export$2e2bcd8739ae039,
    get_started: $1e50ea2cbebf969c$export$2e2bcd8739ae039,
    users: $0c3bb42345084fc4$export$2e2bcd8739ae039,
    user_details: $2a0ff1c4e81b3b53$export$2e2bcd8739ae039,
    contact: $d4e0c7ef8132a0a8$export$2e2bcd8739ae039,
    sign_in_exp: $9b9c9e89ef4d47b3$export$2e2bcd8739ae039,
    dashboard: $03b8297eb034e7b4$export$2e2bcd8739ae039,
    logs: $2f0681e9a8492f02$export$2e2bcd8739ae039,
    log_details: $7bbff72bf985d79a$export$2e2bcd8739ae039,
    session_expired: $c3c80b5558edd31a$export$2e2bcd8739ae039,
    welcome: $68ffbc70e1e29415$export$2e2bcd8739ae039,
    roles: $5458c5696b8ce88f$export$2e2bcd8739ae039,
    role_details: $efe1d8005ce38ec7$export$2e2bcd8739ae039,
    permissions: $97ed8697ffbf018a$export$2e2bcd8739ae039,
    cloud: $17d2f03cb4b396bb$export$2e2bcd8739ae039,
    profile: $ce054c4ea80a342a$export$2e2bcd8739ae039,
    components: $279bbafe905d5185$export$2e2bcd8739ae039,
    webhooks: $bbf588e3dc44f442$export$2e2bcd8739ae039,
    webhook_details: $db9a1aa261de3771$export$2e2bcd8739ae039,
    domain: $11782ced2c7f7b84$export$2e2bcd8739ae039,
    tenants: $ebb70d1f85eacceb$export$2e2bcd8739ae039,
    topbar: $3ad21b00da3fef7a$export$2e2bcd8739ae039,
    subscription: $1c3a6bd21dfd7b78$export$2e2bcd8739ae039,
    upsell: $73dd07cea675c33d$export$2e2bcd8739ae039,
    guide: $b46740eb5dfec083$export$2e2bcd8739ae039,
    mfa: $9649b15006c03c53$export$2e2bcd8739ae039,
    organizations: $cde291122da2c35a$export$2e2bcd8739ae039,
    organization_details: $5f78f052ad0bf8ed$export$2e2bcd8739ae039
};
var $d58636ff2c737a54$export$2e2bcd8739ae039 = Object.freeze($d58636ff2c737a54$var$admin_console);


const $57cd7b3d996a5458$var$demo_app = {
    title: "\xa1Ha iniciado sesi\xf3n correctamente en la vista previa en vivo!",
    subtitle: "Aqu\xed est\xe1 su informaci\xf3n de inicio de sesi\xf3n:",
    username: "Nombre de usuario: ",
    user_id: "ID de usuario: ",
    sign_out: "Cerrar sesi\xf3n en la vista previa en vivo",
    continue_explore: "O contin\xfae explorando",
    customize_sign_in_experience: "Personalice la experiencia de inicio de sesi\xf3n",
    enable_passwordless: "Habilitar sin contrase\xf1a",
    add_social_connector: "Agregar conector social"
};
var $57cd7b3d996a5458$export$2e2bcd8739ae039 = Object.freeze($57cd7b3d996a5458$var$demo_app);


const $57684673365f3cf4$var$oidc = {
    logout_success: "Ha cerrado sesi\xf3n con \xe9xito."
};
var $57684673365f3cf4$export$2e2bcd8739ae039 = Object.freeze($57684673365f3cf4$var$oidc);


const $8ce1f7bda281dd87$var$translation = {
    admin_console: $d58636ff2c737a54$export$2e2bcd8739ae039,
    demo_app: $57cd7b3d996a5458$export$2e2bcd8739ae039,
    oidc: $57684673365f3cf4$export$2e2bcd8739ae039
};
var $8ce1f7bda281dd87$export$2e2bcd8739ae039 = Object.freeze($8ce1f7bda281dd87$var$translation);


const $d07d03ea0fa5ba44$var$es = {
    translation: $8ce1f7bda281dd87$export$2e2bcd8739ae039,
    errors: $b2c922d570d2d6ad$export$2e2bcd8739ae039
};
var $d07d03ea0fa5ba44$export$2e2bcd8739ae039 = Object.freeze($d07d03ea0fa5ba44$var$es);


const $871524c229764fa4$var$application = {
    invalid_type: "Seules les applications machine \xe0 machine peuvent avoir des r\xf4les associ\xe9s.",
    role_exists: "Le r\xf4le d'identifiant {{roleId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 cette application.",
    invalid_role_type: "Impossible d'assigner un r\xf4le de type utilisateur \xe0 une application machine \xe0 machine."
};
var $871524c229764fa4$export$2e2bcd8739ae039 = Object.freeze($871524c229764fa4$var$application);


const $e56c4154583da7d5$var$auth = {
    authorization_header_missing: "L'en-t\xeate d'autorisation est manquant.",
    authorization_token_type_not_supported: "Le type d'autorisation n'est pas pris en charge.",
    unauthorized: "Non autoris\xe9. Veuillez v\xe9rifier les informations d'identification et son champ d'application.",
    forbidden: "Interdit. Veuillez v\xe9rifier vos r\xf4les et autorisations d'utilisateur.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "`sub` manquant dans JWT.",
    require_re_authentication: "La r\xe9-authentification est requise pour effectuer une action prot\xe9g\xe9e."
};
var $e56c4154583da7d5$export$2e2bcd8739ae039 = Object.freeze($e56c4154583da7d5$var$auth);


const $b3d0f2740220fba5$var$connector = {
    general: "Une erreur s'est produite dans le connecteur: {{errorDescription}}",
    not_found: "Impossible de trouver un connecteur disponible pour le type : {{type}}.",
    not_enabled: "Le connecteur n'est pas activ\xe9.",
    invalid_metadata: "Les m\xe9tadonn\xe9es du connecteur sont invalides.",
    invalid_config_guard: "La configuration du connecteur est invalide.",
    unexpected_type: "Le type de connecteur est inattendu.",
    invalid_request_parameters: "La requ\xeate contient des param\xe8tres d'entr\xe9e incorrects.",
    insufficient_request_parameters: "Certains param\xe8tres peuvent manquer dans la requ\xeate.",
    invalid_config: "La configuration du connecteur n'est pas valide.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "La r\xe9ponse du connecteur n'est pas valide.",
    template_not_found: "Impossible de trouver le bon mod\xe8le dans la configuration du connecteur.",
    template_not_supported: "Le connecteur ne prend pas en charge ce type de mod\xe8le.",
    rate_limit_exceeded: "Limite de taux d\xe9clench\xe9e. Veuillez r\xe9essayer plus tard.",
    not_implemented: "{{method}} : n'a pas encore \xe9t\xe9 mis en œuvre.",
    social_invalid_access_token: "Le jeton d'acc\xe8s du connecteur n'est pas valide.",
    invalid_auth_code: "Le code d'authentification du connecteur n'est pas valide.",
    social_invalid_id_token: "Le jeton d'identification du connecteur n'est pas valide.",
    authorization_failed: "Le processus d'autorisation de l'utilisateur n'a pas abouti.",
    social_auth_code_invalid: "Impossible d'obtenir le jeton d'acc\xe8s, veuillez v\xe9rifier le code d'autorisation.",
    more_than_one_sms: "Le nombre de connecteurs SMS est sup\xe9rieur \xe0 1.",
    more_than_one_email: "Le nombre de connecteurs Email est sup\xe9rieur \xe0 1.",
    more_than_one_connector_factory: "Plusieurs fabriques de connecteurs ont \xe9t\xe9 trouv\xe9es (avec les identifiants {{connectorIds}}), vous pouvez d\xe9sinstaller ceux qui ne sont pas n\xe9cessaires.",
    db_connector_type_mismatch: "Il y a un connecteur dans la base de donn\xe9e qui ne correspond pas au type.",
    not_found_with_connector_id: "Impossible de trouver le connecteur avec l'identifiant de connecteur standard fourni.",
    multiple_instances_not_supported: "Impossible de cr\xe9er plusieurs instances avec le connecteur standard s\xe9lectionn\xe9.",
    invalid_type_for_syncing_profile: "Vous ne pouvez synchroniser le profil utilisateur qu'avec les connecteurs sociaux.",
    can_not_modify_target: 'Le "target" du connecteur ne peut pas \xeatre modifi\xe9.',
    should_specify_target: 'Vous devez sp\xe9cifier le "target".',
    multiple_target_with_same_platform: 'Vous ne pouvez pas avoir plusieurs connecteurs sociaux ayant la m\xeame "target" et la m\xeame plateforme.',
    cannot_overwrite_metadata_for_non_standard_connector: 'Les "metadata" de ce connecteur ne peuvent pas \xeatre modifi\xe9s.'
};
var $b3d0f2740220fba5$export$2e2bcd8739ae039 = Object.freeze($b3d0f2740220fba5$var$connector);


const $f3749b16d23265c8$var$domain = {
    not_configured: "Le fournisseur de nom de domaine de l'h\xf4te n'est pas configur\xe9.",
    cloudflare_data_missing: "les donn\xe9es de cloudflare sont manquantes, veuillez v\xe9rifier.",
    cloudflare_unknown_error: "Erreur inconnue lors de la requ\xeate de l'API Cloudflare",
    cloudflare_response_error: "R\xe9ponse inattendue de Cloudflare",
    limit_to_one_domain: "Vous ne pouvez avoir qu'un seul domaine personnalis\xe9",
    hostname_already_exists: "Ce domaine existe d\xe9j\xe0 sur notre serveur.",
    cloudflare_not_found: "Impossible de trouver le nom d'h\xf4te dans Cloudflare"
};
var $f3749b16d23265c8$export$2e2bcd8739ae039 = Object.freeze($f3749b16d23265c8$var$domain);


const $c8c6c6f260abf31d$var$entity = {
    invalid_input: "Saisie invalide. La liste des valeurs ne doit pas \xeatre vide.",
    create_failed: "\xc9chec de la cr\xe9ation de {{name}}.",
    db_constraint_violated: "Violations de contraintes de base de donn\xe9es.",
    not_exists: "Le {{name}} n'existe pas.",
    not_exists_with_id: "Le {{name}} avec l'ID `{{id}}` n'existe pas.",
    not_found: "La ressource n'existe pas.",
    relation_foreign_key_not_found: "Impossible de trouver une ou plusieurs cl\xe9s \xe9trang\xe8res. Veuillez v\xe9rifier la saisie et vous assurer que toutes les entit\xe9s r\xe9f\xe9renc\xe9es existent.",
    unique_integrity_violation: "L'entit\xe9 existe d\xe9j\xe0. Veuillez v\xe9rifier la saisie et r\xe9essayer."
};
var $c8c6c6f260abf31d$export$2e2bcd8739ae039 = Object.freeze($c8c6c6f260abf31d$var$entity);


const $d12d073a178f57f8$var$guard = {
    invalid_input: "La requ\xeate {{type}} n'est pas valide.",
    invalid_pagination: "La valeur de la pagination de la requ\xeate n'est pas valide.",
    can_not_get_tenant_id: "Impossible de r\xe9cup\xe9rer l'identifiant du locataire \xe0 partir de la demande.",
    file_size_exceeded: "Taille du fichier d\xe9pass\xe9e.",
    mime_type_not_allowed: "Le type MIME n'est pas autoris\xe9."
};
var $d12d073a178f57f8$export$2e2bcd8739ae039 = Object.freeze($d12d073a178f57f8$var$guard);


const $9568a6ba1c526cfe$var$hook = {
    missing_events: "Vous devez fournir au moins un \xe9v\xe9nement.",
    send_test_payload_failed: "\xc9chec de l'envoi de la charge utile de test : {{message}}",
    endpoint_responded_with_error: "Le point de terminaison a r\xe9pondu avec une erreur."
};
var $9568a6ba1c526cfe$export$2e2bcd8739ae039 = Object.freeze($9568a6ba1c526cfe$var$hook);


const $bf70d14df189372a$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est d\xe9fini comme votre langue par d\xe9faut et ne peut pas \xeatre supprim\xe9.",
    invalid_translation_structure: "Sch\xe9mas de donn\xe9es invalides. Veuillez v\xe9rifier votre entr\xe9e et r\xe9essayer."
};
var $bf70d14df189372a$export$2e2bcd8739ae039 = Object.freeze($bf70d14df189372a$var$localization);


const $49e5e2898494eb1a$var$log = {
    invalid_type: "Type de journalisation invalide."
};
var $49e5e2898494eb1a$export$2e2bcd8739ae039 = Object.freeze($49e5e2898494eb1a$var$log);


const $b5d34d4fb0f32ee5$var$oidc = {
    aborted: "L'utilisateur a abandonn\xe9 l'interaction.",
    invalid_scope: "Scope invalide : {{error_description}}.",
    invalid_token: "Jeton fourni invalide.",
    invalid_client_metadata: "Les m\xe9tadonn\xe9es du client fournies sont invalides.",
    insufficient_scope: "Manque de champ `{{scope}}` dans le jeton.",
    invalid_request: "La requ\xeate est invalide.",
    invalid_grant: "La requ\xeate de consentement est invalide.",
    invalid_redirect_uri: "`redirect_uri` ne correspond \xe0 aucun des `redirect_uris` enregistr\xe9s par le client.",
    access_denied: "Acc\xe8s refus\xe9.",
    invalid_target: "Indicateur de ressource invalide.",
    unsupported_grant_type: "Le `grant_type` demand\xe9 n'est pas support\xe9.",
    unsupported_response_mode: "Le `response_mode` demand\xe9 n'est pas support\xe9.",
    unsupported_response_type: "Le `response_type` demand\xe9 n'est pas support\xe9.",
    provider_error: "Erreur interne de l'OIDC : {{message}}.",
    server_error: "Une erreur OIDC inconnue s'est produite. Veuillez r\xe9essayer plus tard.",
    provider_error_fallback: "Une erreur OIDC s'est produite : {{code}}.",
    key_required: "Au moins une cl\xe9 est requise.",
    key_not_found: "La cl\xe9 avec l'ID {{id}} n'est pas trouv\xe9e."
};
var $b5d34d4fb0f32ee5$export$2e2bcd8739ae039 = Object.freeze($b5d34d4fb0f32ee5$var$oidc);


const $cb8d687ab12a64e1$var$organization = {
    require_membership: "L'utilisateur doit \xeatre membre de l'organisation pour continuer."
};
var $cb8d687ab12a64e1$export$2e2bcd8739ae039 = Object.freeze($cb8d687ab12a64e1$var$organization);


const $23f1d0f3d5ea4694$var$password = {
    unsupported_encryption_method: "La m\xe9thode de cryptage {{name}} n'est pas prise en charge.",
    pepper_not_found: "Mot de passe pepper non trouv\xe9. Veuillez v\xe9rifier votre environnement de base.",
    rejected: "Mot de passe rejet\xe9. Veuillez v\xe9rifier si votre mot de passe r\xe9pond aux exigences."
};
var $23f1d0f3d5ea4694$export$2e2bcd8739ae039 = Object.freeze($23f1d0f3d5ea4694$var$password);


const $cd176fd57c4bc598$var$request = {
    invalid_input: "L'entr\xe9e est invalide. {{details}}",
    general: "Une erreur de requ\xeate s'est produite."
};
var $cd176fd57c4bc598$export$2e2bcd8739ae039 = Object.freeze($cd176fd57c4bc598$var$request);


const $f587ec9815e9ad32$var$resource = {
    resource_identifier_in_use: "L'identifiant d'API {{indicator}} est d\xe9j\xe0 utilis\xe9"
};
var $f587ec9815e9ad32$export$2e2bcd8739ae039 = Object.freeze($f587ec9815e9ad32$var$resource);


const $7624097f7bfc7287$var$role = {
    name_in_use: "Ce nom de r\xf4le {{name}} est d\xe9j\xe0 utilis\xe9",
    scope_exists: "L'identifiant de port\xe9e {{scopeId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    user_exists: "L'identifiant d'utilisateur {{userId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    application_exists: "L'identifiant d'application {{applicationId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 ce r\xf4le",
    default_role_missing: "Certains noms de r\xf4les par d\xe9faut n'existent pas dans la base de donn\xe9es, veuillez vous assurer de cr\xe9er d'abord des r\xf4les",
    internal_role_violation: 'Vous essayez peut-\xeatre de mettre \xe0 jour ou de supprimer un r\xf4le interne, ce qui est interdit par Logto. Si vous cr\xe9ez un nouveau r\xf4le, essayez un autre nom qui ne commence pas par "#internal:".'
};
var $7624097f7bfc7287$export$2e2bcd8739ae039 = Object.freeze($7624097f7bfc7287$var$role);


const $6ec8ea3cfe0ff289$var$scope = {
    name_exists: "Le nom de port\xe9e {{name}} est d\xe9j\xe0 utilis\xe9",
    name_with_space: "Le nom de la port\xe9e ne peut pas contenir d'espace."
};
var $6ec8ea3cfe0ff289$export$2e2bcd8739ae039 = Object.freeze($6ec8ea3cfe0ff289$var$scope);


const $1be01144d1134a45$var$session = {
    not_found: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    invalid_credentials: "Informations d'identification non valides. Veuillez v\xe9rifier votre saisie.",
    invalid_sign_in_method: "La m\xe9thode de connexion actuelle n'est pas disponible.",
    invalid_connector_id: "Impossible de trouver un connecteur disponible avec l'id {{connectorId}}.",
    insufficient_info: "Informations d'identification insuffisantes",
    connector_id_mismatch: "Le connectorId ne correspond pas \xe0 l'enregistrement de la session.",
    connector_session_not_found: "La session du connecteur n'a pas \xe9t\xe9 trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    verification_session_not_found: "La v\xe9rification n'a pas abouti. Red\xe9marrez le processus de v\xe9rification et r\xe9essayez.",
    verification_expired: "La connexion a expir\xe9. V\xe9rifiez \xe0 nouveau pour assurer la s\xe9curit\xe9 de votre compte.",
    verification_blocked_too_many_attempts: "Trop de tentatives en peu de temps. Veuillez r\xe9essayer {{relativeTime}}.",
    unauthorized: "Veuillez vous enregistrer d'abord.",
    unsupported_prompt_name: "Nom d'invite non support\xe9.",
    forgot_password_not_enabled: "La fonctionnalit\xe9 de r\xe9initialisation de mot de passe n'est pas activ\xe9e.",
    verification_failed: "La v\xe9rification n'a pas r\xe9ussi. Veuillez recommencer le processus de v\xe9rification.",
    connector_validation_session_not_found: "La session de validation de jeton de connecteur est introuvable.",
    identifier_not_found: "Identifiant utilisateur introuvable. Veuillez retourner en arri\xe8re et vous connecter \xe0 nouveau.",
    interaction_not_found: "Session d'interaction introuvable. Veuillez retourner en arri\xe8re et recommencer la session.",
    not_supported_for_forgot_password: "Cette op\xe9ration n'est pas prise en charge pour la r\xe9initialisation du mot de passe.",
    mfa: {
        require_mfa_verification: "La v\xe9rification MFA est requise pour vous connecter.",
        mfa_sign_in_only: "MFA est uniquement disponible pour l'interaction de connexion.",
        pending_info_not_found: "Informations MFA en attente introuvables, veuillez initier d'abord la MFA.",
        invalid_totp_code: "Code TOTP non valide.",
        webauthn_verification_failed: "\xc9chec de la v\xe9rification WebAuthn.",
        webauthn_verification_not_found: "V\xe9rification WebAuthn introuvable.",
        bind_mfa_existed: "MFA existe d\xe9j\xe0.",
        backup_code_can_not_be_alone: "Le code de sauvegarde ne peut pas \xeatre le seul MFA.",
        backup_code_required: "Le code de sauvegarde est requis.",
        invalid_backup_code: "Code de sauvegarde non valide.",
        mfa_policy_not_user_controlled: "La politique MFA n'est pas contr\xf4l\xe9e par l'utilisateur."
    },
    sso_enabled: "La connexion unique est activ\xe9e pour cet e-mail donn\xe9. Veuillez vous connecter avec SSO."
};
var $1be01144d1134a45$export$2e2bcd8739ae039 = Object.freeze($1be01144d1134a45$var$session);


const $061b4f13c74c6f8a$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de contenu "Conditions d\'utilisation" vide. Veuillez ajouter l\'URL du contenu si les "Conditions d\'utilisation" sont activ\xe9es.',
    empty_social_connectors: "Connecteurs sociaux vides. Veuillez ajouter des connecteurs sociaux activ\xe9s lorsque la m\xe9thode de connexion sociale est activ\xe9e.",
    enabled_connector_not_found: "Le connecteur {{type}} activ\xe9 est introuvable.",
    not_one_and_only_one_primary_sign_in_method: "Il doit y avoir une et une seule m\xe9thode de connexion primaire. Veuillez v\xe9rifier votre saisie.",
    username_requires_password: "Vous devez activer la d\xe9finition d'un mot de passe pour l'identifiant d'inscription de nom d'utilisateur.",
    passwordless_requires_verify: "Vous devez activer la v\xe9rification pour l'identifiant d'inscription par e-mail/num\xe9ro de t\xe9l\xe9phone.",
    miss_sign_up_identifier_in_sign_in: "Les m\xe9thodes de connexion doivent contenir l'identifiant d'inscription.",
    password_sign_in_must_be_enabled: "La connexion par mot de passe doit \xeatre activ\xe9e lorsque la d\xe9finition d'un mot de passe est requise lors de l'inscription.",
    code_sign_in_must_be_enabled: "La connexion par code de v\xe9rification doit \xeatre activ\xe9e lorsque la d\xe9finition d'un mot de passe n'est pas requise lors de l'inscription.",
    unsupported_default_language: "Cette langue - {{language}} n'est pas prise en charge pour le moment.",
    at_least_one_authentication_factor: "Vous devez s\xe9lectionner au moins un facteur d'authentification.",
    backup_code_cannot_be_enabled_alone: "Le code de sauvegarde ne peut \xeatre activ\xe9 seul.",
    duplicated_mfa_factors: "Facteurs de MFA en double."
};
var $061b4f13c74c6f8a$export$2e2bcd8739ae039 = Object.freeze($061b4f13c74c6f8a$var$sign_in_experiences);


const $fada400549c19360$var$single_sign_on = {
    forbidden_domains: "Les domaines de messagerie publique ne sont pas autoris\xe9s.",
    duplicated_domains: "Il existe des domaines en double.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $fada400549c19360$export$2e2bcd8739ae039 = Object.freeze($fada400549c19360$var$single_sign_on);


const $f22d7130e9e8e71d$var$storage = {
    not_configured: "Le fournisseur de stockage n'est pas configur\xe9.",
    missing_parameter: "Param\xe8tre manquant {{parameter}} pour le fournisseur de stockage.",
    upload_error: "\xc9chec de l'envoi du fichier au fournisseur de stockage."
};
var $f22d7130e9e8e71d$export$2e2bcd8739ae039 = Object.freeze($f22d7130e9e8e71d$var$storage);


const $2d7085d7c3fb787d$var$subscription = {
    limit_exceeded: "Vous avez atteint la limite de votre plan d'abonnement.",
    get_plan_failed: "\xc9chec de l'obtention du plan d'abonnement pour le locataire.",
    tenant_suspended: "Le locataire est suspendu. Veuillez contacter votre administrateur."
};
var $2d7085d7c3fb787d$export$2e2bcd8739ae039 = Object.freeze($2d7085d7c3fb787d$var$subscription);


const $dfd94c3cb28b23ce$var$swagger = {
    invalid_zod_type: "Type Zod non valide. Veuillez v\xe9rifier la configuration du garde-route.",
    not_supported_zod_type_for_params: "Type Zod non support\xe9 pour les param\xe8tres. Veuillez v\xe9rifier la configuration du garde-route."
};
var $dfd94c3cb28b23ce$export$2e2bcd8739ae039 = Object.freeze($dfd94c3cb28b23ce$var$swagger);


const $a8e135d086bd8fef$var$user = {
    username_already_in_use: "Ce nom d'utilisateur est d\xe9j\xe0 utilis\xe9.",
    email_already_in_use: "Cet e-mail est associ\xe9 \xe0 un compte existant.",
    phone_already_in_use: "Ce num\xe9ro de t\xe9l\xe9phone est associ\xe9 \xe0 un compte existant.",
    invalid_email: "Addresse email incorrecte.",
    invalid_phone: "Num\xe9ro de t\xe9l\xe9phone incorrect.",
    email_not_exist: "L'adresse e-mail n'a pas encore \xe9t\xe9 enregistr\xe9e.",
    phone_not_exist: "Le num\xe9ro de t\xe9l\xe9phone n'a pas encore \xe9t\xe9 enregistr\xe9.",
    identity_not_exist: "Le compte social n'a pas encore \xe9t\xe9 enregistr\xe9.",
    identity_already_in_use: "Le compte social a \xe9t\xe9 enregistr\xe9.",
    social_account_exists_in_profile: "Vous avez d\xe9j\xe0 associ\xe9 ce compte social.",
    cannot_delete_self: "Vous ne pouvez pas vous supprimer vous-m\xeame.",
    sign_up_method_not_enabled: "Cette m\xe9thode d'inscription n'est pas activ\xe9e.",
    sign_in_method_not_enabled: "Cette m\xe9thode de connexion n'est pas activ\xe9e.",
    same_password: "Le nouveau mot de passe ne peut pas \xeatre identique \xe0 l'ancien.",
    password_required_in_profile: "Vous devez d\xe9finir un mot de passe avant de vous connecter.",
    new_password_required_in_profile: "Vous devez d\xe9finir un nouveau mot de passe.",
    password_exists_in_profile: "Le mot de passe existe d\xe9j\xe0 dans votre profil.",
    username_required_in_profile: "Vous devez d\xe9finir un nom d'utilisateur avant de vous connecter.",
    username_exists_in_profile: "Le nom d'utilisateur existe d\xe9j\xe0 dans votre profil.",
    email_required_in_profile: "Vous devez ajouter une adresse e-mail avant de vous connecter.",
    email_exists_in_profile: "Votre profil est d\xe9j\xe0 associ\xe9 \xe0 une adresse e-mail.",
    phone_required_in_profile: "Vous devez ajouter un num\xe9ro de t\xe9l\xe9phone avant de vous connecter.",
    phone_exists_in_profile: "Votre profil est d\xe9j\xe0 associ\xe9 \xe0 un num\xe9ro de t\xe9l\xe9phone.",
    email_or_phone_required_in_profile: "Vous devez ajouter une adresse e-mail ou un num\xe9ro de t\xe9l\xe9phone avant de vous connecter.",
    suspended: "Ce compte est suspendu.",
    user_not_exist: "L'utilisateur avec {{ identifier }} n'existe pas.",
    missing_profile: "Vous devez fournir des informations suppl\xe9mentaires avant de vous connecter.",
    role_exists: "L'ID de r\xf4le {{roleId}} a d\xe9j\xe0 \xe9t\xe9 ajout\xe9 \xe0 cet utilisateur",
    invalid_role_type: 'Le type de r\xf4le est invalide, il est impossible d\'assigner un r\xf4le "machine-to-machine" \xe0 un utilisateur.',
    missing_mfa: "Vous devez lier un MFA suppl\xe9mentaire avant de vous connecter.",
    totp_already_in_use: "TOTP est d\xe9j\xe0 utilis\xe9.",
    backup_code_already_in_use: "Le code de sauvegarde est d\xe9j\xe0 utilis\xe9."
};
var $a8e135d086bd8fef$export$2e2bcd8739ae039 = Object.freeze($a8e135d086bd8fef$var$user);


const $7870de1f932d0d42$var$verification_code = {
    phone_email_empty: "Les deux le t\xe9l\xe9phone et l'email sont vides.",
    not_found: "Le code de v\xe9rification n'a pas \xe9t\xe9 trouv\xe9. Veuillez d'abord envoyer le code de v\xe9rification.",
    phone_mismatch: "T\xe9l\xe9phone ne correspond pas. Veuillez demander un nouveau code de v\xe9rification.",
    email_mismatch: "Email ne correspond pas. Veuillez demander un nouveau code de v\xe9rification.",
    code_mismatch: "Code de v\xe9rification invalide.",
    expired: "Le code de v\xe9rification a expir\xe9. Veuillez demander un nouveau code de v\xe9rification.",
    exceed_max_try: "La limite de tentatives de code de v\xe9rification a \xe9t\xe9 d\xe9pass\xe9e. Veuillez demander un nouveau code de v\xe9rification."
};
var $7870de1f932d0d42$export$2e2bcd8739ae039 = Object.freeze($7870de1f932d0d42$var$verification_code);


const $8129039b642ada78$var$errors = {
    request: $cd176fd57c4bc598$export$2e2bcd8739ae039,
    auth: $e56c4154583da7d5$export$2e2bcd8739ae039,
    guard: $d12d073a178f57f8$export$2e2bcd8739ae039,
    oidc: $b5d34d4fb0f32ee5$export$2e2bcd8739ae039,
    user: $a8e135d086bd8fef$export$2e2bcd8739ae039,
    password: $23f1d0f3d5ea4694$export$2e2bcd8739ae039,
    session: $1be01144d1134a45$export$2e2bcd8739ae039,
    connector: $b3d0f2740220fba5$export$2e2bcd8739ae039,
    verification_code: $7870de1f932d0d42$export$2e2bcd8739ae039,
    sign_in_experiences: $061b4f13c74c6f8a$export$2e2bcd8739ae039,
    localization: $bf70d14df189372a$export$2e2bcd8739ae039,
    swagger: $dfd94c3cb28b23ce$export$2e2bcd8739ae039,
    entity: $c8c6c6f260abf31d$export$2e2bcd8739ae039,
    log: $49e5e2898494eb1a$export$2e2bcd8739ae039,
    role: $7624097f7bfc7287$export$2e2bcd8739ae039,
    scope: $6ec8ea3cfe0ff289$export$2e2bcd8739ae039,
    storage: $f22d7130e9e8e71d$export$2e2bcd8739ae039,
    resource: $f587ec9815e9ad32$export$2e2bcd8739ae039,
    hook: $9568a6ba1c526cfe$export$2e2bcd8739ae039,
    domain: $f3749b16d23265c8$export$2e2bcd8739ae039,
    subscription: $2d7085d7c3fb787d$export$2e2bcd8739ae039,
    application: $871524c229764fa4$export$2e2bcd8739ae039,
    organization: $cb8d687ab12a64e1$export$2e2bcd8739ae039,
    single_sign_on: $fada400549c19360$export$2e2bcd8739ae039
};
var $8129039b642ada78$export$2e2bcd8739ae039 = Object.freeze($8129039b642ada78$var$errors);


const $e3d8a53e4f32ffe7$var$api_resource_details = {
    page_title: "D\xe9tails de la ressource API",
    back_to_api_resources: "Retour aux ressources API",
    settings_tab: "Param\xe8tres",
    permissions_tab: "Autorisations",
    settings: "Param\xe8tres",
    settings_description: "Les ressources API, \xe9galement connues sous le nom d'indicateurs de ressource, indiquent les services ou les ressources cibles \xe0 demander, g\xe9n\xe9ralement une variable de format d'URI repr\xe9sentant l'identit\xe9 de la ressource.",
    management_api_settings_description: "La Logto Management API est une collection compl\xe8te d'API qui permettent aux administrateurs de g\xe9rer une large gamme de t\xe2ches li\xe9es \xe0 l'identit\xe9, d'appliquer des politiques de s\xe9curit\xe9 et de se conformer aux r\xe9glementations et normes.",
    management_api_notice: "Cette API repr\xe9sente l'entit\xe9 Logto et ne peut pas \xeatre modifi\xe9e ou supprim\xe9e. Vous pouvez utiliser l'API de gestion pour effectuer une large gamme de t\xe2ches li\xe9es \xe0 l'identit\xe9. <a>En savoir plus</a>",
    token_expiration_time_in_seconds: "Temps d'expiration du jeton (en secondes)",
    token_expiration_time_in_seconds_placeholder: "Entrez le d\xe9lai d'expiration de votre jeton",
    delete_description: "Cette action ne peut pas \xeatre annul\xe9e. Elle supprimera d\xe9finitivement la ressource API. Veuillez entrer le nom de la ressource API <span>{{name}}</span> pour confirmer.",
    enter_your_api_resource_name: "Entrez le nom de votre ressource API",
    api_resource_deleted: "La ressource API {{name}} a \xe9t\xe9 supprim\xe9e avec succ\xe8s",
    permission: {
        create_button: "Cr\xe9er une autorisation",
        create_title: "Cr\xe9er une autorisation",
        create_subtitle: "D\xe9finir les autorisations (scopes) requises pour cette API.",
        confirm_create: "Cr\xe9er une autorisation",
        name: "Nom de l'autorisation",
        name_placeholder: "lecture:ressource",
        forbidden_space_in_name: "Le nom de l'autorisation ne doit pas contenir d'espaces.",
        description: "Description",
        description_placeholder: "Capable de lire les ressources",
        permission_created: "L'autorisation {{name}} a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s",
        delete_description: "Si cette autorisation est supprim\xe9e, l'utilisateur qui avait cette autorisation perdra l'acc\xe8s qui lui a \xe9t\xe9 accord\xe9.",
        deleted: 'L\'autorisation "{{name}}" a \xe9t\xe9 supprim\xe9e avec succ\xe8s.'
    }
};
var $e3d8a53e4f32ffe7$export$2e2bcd8739ae039 = Object.freeze($e3d8a53e4f32ffe7$var$api_resource_details);


const $d6275fd7f980a28a$var$api_resources = {
    page_title: "Ressources API",
    title: "Ressources API",
    subtitle: "D\xe9finir les API que vous pouvez consommer \xe0 partir de vos applications autoris\xe9es",
    create: "Cr\xe9er une ressource API",
    api_name: "Nom de l'API",
    api_name_placeholder: "Entrez votre nom d'API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "L'identifiant unique de la ressource API. Il doit s'agir d'un URI absolu et ne doit pas comporter de fragment (#). \xc9quivaut au <a>param\xe8tre de ressource</> dans OAuth 2.0.",
    default_api: "API par d\xe9faut",
    default_api_label: "Seulement z\xe9ro ou une API par d\xe9faut peut \xeatre d\xe9finie par tenant. Lorsqu'une API par d\xe9faut est d\xe9sign\xe9e, le param\xe8tre \"resource\" peut \xeatre omis dans la demande d'authentification. Les \xe9changes de jetons ult\xe9rieurs utiliseront cette API comme public cible par d\xe9faut, ce qui entra\xeenera la d\xe9livrance de JWT. <a>En savoir plus</a>",
    api_resource_created: "La ressource API {{name}} a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s."
};
var $d6275fd7f980a28a$export$2e2bcd8739ae039 = Object.freeze($d6275fd7f980a28a$var$api_resources);


const $c6be8e712959bde1$var$application_details = {
    page_title: "D\xe9tails de l'application",
    back_to_applications: "Retour aux applications",
    check_guide: "Consulter le guide",
    settings: "Param\xe8tres",
    settings_description: "Les applications sont utilis\xe9es pour identifier vos applications dans Logto pour OIDC, l'exp\xe9rience de connexion, les journaux d'audit, etc.",
    advanced_settings: "Param\xe8tres avanc\xe9s",
    advanced_settings_description: "Les param\xe8tres avanc\xe9s comprennent des termes li\xe9s \xe0 OIDC. Vous pouvez consulter le point de terminaison de jeton pour plus d'informations.",
    application_roles: "R\xf4les",
    machine_logs: "Journaux de machine",
    application_name: "Nom de l'application",
    application_name_placeholder: "Mon App",
    description: "Description",
    description_placeholder: "Entrez la description de votre application",
    config_endpoint: "Point de configuration du fournisseur OpenID",
    authorization_endpoint: "Point de terminaison d'autorisation",
    authorization_endpoint_tip: "Le point de terminaison pour effectuer l'authentification et l'autorisation. Il est utilis\xe9 pour <a>l'authentification</a> OpenID Connect.",
    logto_endpoint: "Endpoint Logto",
    application_id: "ID de l'application",
    application_id_tip: "L'identifiant d'application unique g\xe9n\xe9ralement g\xe9n\xe9r\xe9 par Logto. Il signifie \xe9galement <a>client_id</a> dans OpenID Connect.",
    application_secret: "Secret de l'application",
    redirect_uri: "URI de redirection",
    redirect_uris: "URIs de redirection",
    redirect_uri_placeholder: "https://votre.site.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "L'URI de redirection apr\xe8s la connexion d'un utilisateur (qu'elle soit r\xe9ussie ou non). Voir OpenID Connect <a>AuthRequest</a> pour plus d'informations.",
    post_sign_out_redirect_uri: "URI de redirection post-d\xe9connexion",
    post_sign_out_redirect_uris: "URI de redirection apr\xe8s la d\xe9connexion",
    post_sign_out_redirect_uri_placeholder: "https://votre.site.com/home",
    post_sign_out_redirect_uri_tip: "L'URI de redirection apr\xe8s la d\xe9connexion de l'utilisateur (facultatif). Cela peut n'avoir aucun effet pratique dans certains types d'applications.",
    cors_allowed_origins: "Origines CORS autoris\xe9es",
    cors_allowed_origins_placeholder: "https://votre.site.com",
    cors_allowed_origins_tip: "Par d\xe9faut, toutes les origines des URI de redirection seront autoris\xe9es. En g\xe9n\xe9ral, aucune action n'est requise pour ce champ. Consultez la documentation <a>MDN</a> pour des informations d\xe9taill\xe9es.",
    token_endpoint: "Point de terminaison du jeton",
    user_info_endpoint: "Point de terminaison de l'utilisateur",
    enable_admin_access: "Activer l'acc\xe8s administrateur",
    enable_admin_access_label: "Activer ou d\xe9sactiver l'acc\xe8s \xe0 l'API de gestion. Une fois activ\xe9, vous pouvez utiliser des jetons d'acc\xe8s pour appeler l'API de gestion au nom de cette application.",
    always_issue_refresh_token: "Toujours \xe9mettre le Refresh Token.",
    always_issue_refresh_token_label: "En activant cette configuration, Logto pourra toujours \xe9mettre des Refresh Tokens, ind\xe9pendamment de la pr\xe9sentation ou non de la demande d'authentification `prompt=consent`. Cependant, cette pratique est d\xe9courag\xe9e sauf si n\xe9cessaire, car elle n'est pas compatible avec OpenID Connect et peut potentiellement causer des probl\xe8mes.",
    refresh_token_ttl: "Dur\xe9e de vie du Refresh Token en jours",
    refresh_token_ttl_tip: "La dur\xe9e pendant laquelle un Refresh Token peut \xeatre utilis\xe9 pour demander de nouveaux jetons d'acc\xe8s avant qu'il n'expire et devienne invalide. Les demandes de jeton \xe9tendront la dur\xe9e de vie du Refresh Token \xe0 cette valeur.",
    rotate_refresh_token: "Tourner le Refresh Token",
    rotate_refresh_token_label: "Lorsqu'elle est activ\xe9e, Logto \xe9mettra un nouveau Refresh Token pour les demandes de jeton lorsque 70% de la dur\xe9e de vie (TTL) d'origine est \xe9coul\xe9e ou que certaines conditions sont remplies. <a>En savoir plus</a>",
    delete_description: "Cette action ne peut \xeatre annul\xe9e. Elle supprimera d\xe9finitivement l'application. Veuillez entrer le nom de l'application <span>{{nom}}</span> pour confirmer.",
    enter_your_application_name: "Entrez le nom de votre application",
    application_deleted: "L'application {{name}} a \xe9t\xe9 supprim\xe9e avec succ\xe8s.",
    redirect_uri_required: "Vous devez entrer au moins un URI de redirection.",
    roles: {
        name_column: "R\xf4le",
        description_column: "Description",
        assign_button: "Attribuer des r\xf4les",
        delete_description: "Cette action supprimera ce r\xf4le de cette application machine-to-machine. Le r\xf4le lui-m\xeame existera toujours, mais il ne sera plus associ\xe9 \xe0 cette application machine-to-machine.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9(e) avec succ\xe8s de cet utilisateur.",
        assign_title: "Attribuer des r\xf4les \xe0 {{name}}",
        assign_subtitle: "Autoriser {{name}} \xe0 un ou plusieurs r\xf4les",
        assign_role_field: "Attribuer des r\xf4les",
        role_search_placeholder: "Rechercher par nom de r\xf4le",
        added_text: "{{value, number}} ajout\xe9(s)",
        assigned_app_count: "{{value, number}} applications",
        confirm_assign: "Assigner des r\xf4les",
        role_assigned: "R\xf4le(s) attribu\xe9(e)s avec succ\xe8s",
        search: "Rechercher par nom de r\xf4le, description ou ID",
        empty: "Aucun r\xf4le disponible"
    }
};
var $c6be8e712959bde1$export$2e2bcd8739ae039 = Object.freeze($c6be8e712959bde1$var$application_details);


const $7d9dc4fa0e95e474$var$applications = {
    page_title: "Applications",
    title: "Applications",
    subtitle: "Configurez une application mobile, une page unique, machine to machine ou une application traditionnelle pour utiliser Logto pour l'authentification.",
    subtitle_with_app_type: "Configurez l'authentification Logto pour votre application {{name}}",
    create: "Cr\xe9er une application",
    application_name: "Nom de l'application",
    application_name_placeholder: "Mon app",
    application_description: "Description de l'application",
    application_description_placeholder: "Entrer la description de votre application",
    select_application_type: "S\xe9lectionner un type d'application",
    no_application_type_selected: "Vous n'avez pas encore s\xe9lectionn\xe9 de type d'application",
    application_created: "L'application a \xe9t\xe9 cr\xe9\xe9e avec succ\xe8s.",
    app_id: "App ID",
    type: {
        native: {
            title: "Application native",
            subtitle: "Une application qui fonctionne dans un environnement natif",
            description: "Exemple: application iOS, application Android"
        },
        spa: {
            title: "Application \xe0 page unique",
            subtitle: "Une application qui s'ex\xe9cute dans un navigateur web et met dynamiquement \xe0 jour les donn\xe9es sur place.",
            description: "Exemple: application React, application Vue"
        },
        traditional: {
            title: "Web traditionnel",
            subtitle: "Une application qui met \xe0 jour les pages par le seul serveur web.",
            description: "Exemple: Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Une application (g\xe9n\xe9ralement un service) qui communique directement avec les ressources",
            description: "Par exemple, un service backend"
        }
    },
    placeholder_title: "S\xe9lectionnez un type d'application pour continuer",
    placeholder_description: "Logto utilise une entit\xe9 d'application pour OIDC pour aider aux t\xe2ches telles que l'identification de vos applications, la gestion de la connexion et la cr\xe9ation de journaux d'audit."
};
var $7d9dc4fa0e95e474$export$2e2bcd8739ae039 = Object.freeze($7d9dc4fa0e95e474$var$applications);


const $8627726e7afcb100$var$cloud = {
    general: {
        onboarding: "Int\xe9gration"
    },
    welcome: {
        page_title: "Bienvenue",
        title: "Bienvenue dans Logto Cloud ! Nous aimerions en savoir un peu plus sur vous.",
        description: "Personnalisons votre exp\xe9rience Logto en vous connaissant mieux. Vos informations sont en s\xe9curit\xe9 avec nous.",
        project_field: "J'utilise Logto pour",
        project_options: {
            personal: "Projet personnel",
            company: "Projet d'entreprise"
        },
        title_field: "S\xe9lectionnez le(s) titre(s) applicable(s)",
        title_options: {
            developer: "D\xe9veloppeur",
            team_lead: "Chef d'\xe9quipe",
            ceo: "PDG",
            cto: "CTO",
            product: "Produit",
            others: "Autres"
        },
        company_name_field: "Nom de l'entreprise",
        company_name_placeholder: "Acme.co",
        company_size_field: "Taille de votre entreprise",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Je m'inscris parce que",
        reason_options: {
            passwordless: "Je cherche une authentification sans mot de passe et une trousse d'interface utilisateur",
            efficiency: "Je cherche une infrastructure d'identit\xe9 cl\xe9 en main",
            access_control: "Je cherche \xe0 contr\xf4ler l'acc\xe8s utilisateur en fonction des r\xf4les et des responsabilit\xe9s",
            multi_tenancy: "Je cherche des strat\xe9gies pour un produit multi-tenant",
            enterprise: "Je cherche des solutions SSO pour une gestion de l'entreprise",
            others: "Autres"
        }
    },
    sie: {
        page_title: "Personnalisez l'exp\xe9rience de connexion",
        title: "Personnalisons d'abord votre exp\xe9rience de connexion en toute simplicit\xe9",
        inspire: {
            title: "Cr\xe9ez des exemples convaincants",
            description: 'Vous vous sentez incertain de l\'exp\xe9rience de connexion? Cliquez simplement sur "Inspirez-moi" et laissez la magie op\xe9rer!',
            inspire_me: "Inspirez-moi"
        },
        logo_field: "Logo de l'application",
        color_field: "Couleur de la marque",
        identifier_field: "Identifiant",
        identifier_options: {
            email: "Email",
            phone: "T\xe9l\xe9phone",
            user_name: "Nom d'utilisateur"
        },
        authn_field: "Authentification",
        authn_options: {
            password: "Mot de passe",
            verification_code: "Code de v\xe9rification"
        },
        social_field: "Connexion sociale",
        finish_and_done: "Terminer et termin\xe9",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "D\xe9bloqu\xe9 ult\xe9rieurement",
            unlocked_later_tip: "Une fois que vous avez termin\xe9 le processus d'inscription et que vous \xeates entr\xe9 dans le produit, vous aurez acc\xe8s \xe0 encore plus de m\xe9thodes de connexion sociale.",
            notice: "Veuillez \xe9viter d'utiliser le connecteur de d\xe9monstration \xe0 des fins de production. Lorsque vous avez termin\xe9 les tests, veuillez supprimer le connecteur de d\xe9monstration et mettre en place votre propre connecteur avec vos informations d'identification."
        }
    },
    socialCallback: {
        title: "Connexion r\xe9ussie",
        description: "Vous vous \xeates connect\xe9 avec succ\xe8s en utilisant votre compte social. Pour assurer une int\xe9gration fluide et acc\xe9der \xe0 toutes les fonctionnalit\xe9s de Logto, nous vous recommandons de configurer votre propre connecteur social."
    },
    tenant: {
        create_tenant: "Cr\xe9er un locataire"
    }
};
var $8627726e7afcb100$export$2e2bcd8739ae039 = Object.freeze($8627726e7afcb100$var$cloud);


const $c525ec7e710d036a$var$components = {
    uploader: {
        action_description: "Glissez-d\xe9posez ou parcourez",
        uploading: "T\xe9l\xe9chargement...",
        image_limit: "T\xe9l\xe9chargez une image de moins de {{size, number}} Ko, uniquement {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Quelque chose s'est mal pass\xe9. La t\xe9l\xe9chargement de fichier a \xe9chou\xe9.",
        error_file_size: "La taille du fichier est trop grande. Veuillez t\xe9l\xe9charger un fichier de moins de {{size, number}}Ko.",
        error_file_type: "Le type de fichier n'est pas pris en charge. Uniquement {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Vous ne pouvez t\xe9l\xe9charger qu’un seul fichier."
    }
};
var $c525ec7e710d036a$export$2e2bcd8739ae039 = Object.freeze($c525ec7e710d036a$var$components);


const $1ab163289efd9414$var$connector_details = {
    page_title: "D\xe9tails du connecteur",
    back_to_connectors: "Retour \xe0 Connecteurs",
    check_readme: "V\xe9rifier le README",
    settings: "Param\xe8tres g\xe9n\xe9raux",
    settings_description: "Les connecteurs jouent un r\xf4le essentiel dans Logto. Avec leur aide, Logto permet aux utilisateurs finaux d'utiliser une inscription ou une connexion sans mot de passe et les capacit\xe9s de connexion avec des comptes sociaux.",
    parameter_configuration: "Configuration des param\xe8tres",
    test_connection: "Test",
    save_error_empty_config: "Veuillez entrer la configuration",
    send: "Envoyer",
    send_error_invalid_format: "Entr\xe9e non valide",
    edit_config_label: "Entrez votre json ici",
    test_email_sender: "Testez votre connecteur Email",
    test_sms_sender: "Testez votre connecteur SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+33 6 12 34 56 78",
    test_message_sent: "Message de test envoy\xe9",
    test_sender_description: 'Logto utilise le mod\xe8le "Generic" pour les tests. Tu recevras un message si ton connecteur est correctement configur\xe9.',
    options_change_email: "Modifier le connecteur Email",
    options_change_sms: "Changer le connecteur SMS",
    connector_deleted: "Le connecteur a \xe9t\xe9 supprim\xe9 avec succ\xe8s",
    type_email: "Connecteur Email",
    type_sms: "Connecteur SMS",
    type_social: "Connecteur Social",
    in_used_social_deletion_description: "Ce connecteur est utilis\xe9 dans votre exp\xe9rience de connexion. En le supprimant, l’exp\xe9rience de connexion de <name/> sera supprim\xe9e dans les param\xe8tres de l’exp\xe9rience de connexion. Vous devrez le reconfigurer si vous d\xe9cidez de l’ajouter \xe0 nouveau.",
    in_used_passwordless_deletion_description: "Cet {{name}} est utilis\xe9 dans votre exp\xe9rience de connexion. En le supprimant, votre exp\xe9rience de connexion ne fonctionnera pas correctement tant que vous n’aurez pas r\xe9solu le conflit. Vous devrez le reconfigurer si vous d\xe9cidez de l’ajouter \xe0 nouveau.",
    deletion_description: "Vous supprimez ce connecteur. Il ne peut pas \xeatre annul\xe9 et vous devrez le reconfigurer si vous d\xe9cidez de l'ajouter \xe0 nouveau.",
    logto_email: {
        total_email_sent: "Total email envoy\xe9: {{value, number}}",
        total_email_sent_tip: "Logto utilise SendGrid pour une livraison s\xe9curis\xe9e et stable des emails int\xe9gr\xe9s. C'est totalement gratuit. <a>En savoir plus</a>",
        email_template_title: "Mod\xe8le d’email",
        template_description: "L’email int\xe9gr\xe9 utilise des mod\xe8les par d\xe9faut pour une livraison transparente des emails de v\xe9rification. Aucune configuration n’est requise et vous pouvez personnaliser les informations de base de la marque.",
        template_description_link_text: "Voir les mod\xe8les",
        description_action_text: "Voir les mod\xe8les",
        from_email_field: "Email de l’exp\xe9diteur",
        sender_name_field: "Nom de l'exp\xe9diteur",
        sender_name_tip: 'Personnalisez le nom de l’exp\xe9diteur pour les emails. Si vous le laissez vide, "Verification" sera utilis\xe9 comme nom par d\xe9faut.',
        sender_name_placeholder: "Votre nom d’exp\xe9diteur",
        company_information_field: "Informations sur la soci\xe9t\xe9",
        company_information_description: "Affichez le nom de votre entreprise, votre adresse ou votre code postal en bas des emails pour renforcer l'authenticit\xe9.",
        company_information_placeholder: "Les informations de base de votre entreprise",
        app_logo_field: "Logo de l’application",
        app_logo_tip: "Affichez le logo de votre marque en haut des emails. Utilisez la m\xeame image pour le mode clair et le mode sombre.",
        urls_not_allowed: "Les URLs ne sont pas autoris\xe9es",
        test_notes: 'Logto utilise le mod\xe8le "Generic" pour les tests.'
    }
};
var $1ab163289efd9414$export$2e2bcd8739ae039 = Object.freeze($1ab163289efd9414$var$connector_details);


const $b7dfc5fe65bc5321$var$connectors = {
    page_title: "Connecteurs",
    title: "Connecteurs",
    subtitle: "Configurez des connecteurs pour permettre une exp\xe9rience de connexion sans mot de passe et sociale.",
    create: "Ajouter un connecteur social",
    config_sie_notice: "Vous avez configur\xe9 des connecteurs. Assurez-vous de le configurer dans <a>{{link}}</a>.",
    config_sie_link_text: "exp\xe9rience de connexion",
    tab_email_sms: "Connecteurs Email et SMS",
    tab_social: "Connecteurs sociaux",
    connector_name: "Nom du connecteur",
    demo_tip: "Le nombre maximum de messages autoris\xe9s pour ce connecteur de d\xe9monstration est limit\xe9 \xe0 100 et n'est pas recommand\xe9 pour le d\xe9ploiement dans un environnement de production.",
    social_demo_tip: "Le connecteur de d\xe9monstration est con\xe7u exclusivement \xe0 des fins de d\xe9monstration et n'est pas recommand\xe9 pour le d\xe9ploiement dans un environnement de production.",
    connector_type: "Type",
    connector_status: "Exp\xe9rience de connexion",
    connector_status_in_use: "En cours d'utilisation",
    connector_status_not_in_use: "Non utilis\xe9",
    not_in_use_tip: {
        content: "L'option Non utilis\xe9 signifie que votre exp\xe9rience de connexion n'a pas utilis\xe9 cette m\xe9thode de connexion. <a>{{link}}</a> pour ajouter cette m\xe9thode de connexion.",
        go_to_sie: "Aller \xe0 l'exp\xe9rience de connexion"
    },
    placeholder_title: "Connecteur social",
    placeholder_description: "Logto propose de nombreux connecteurs de connexion sociale couramment utilis\xe9s, mais vous pouvez \xe9galement cr\xe9er le v\xf4tre \xe0 l'aide des protocoles standard.",
    save_and_done: "Sauvegarder et Finis",
    type: {
        email: "Connecteur Email",
        sms: "Connecteur SMS",
        social: "Connecteur Social"
    },
    setup_title: {
        email: "Configurer le connecteur Email",
        sms: "Configurer le connecteur SMS",
        social: "Ajouter un connecteur Social"
    },
    guide: {
        subtitle: "Un guide \xe9tape par \xe9tape pour configurer votre connecteur",
        general_setting: "Param\xe8tres g\xe9n\xe9raux",
        parameter_configuration: "Configuration des param\xe8tres",
        test_connection: "Test de connexion",
        name: "Nom du bouton de connexion sociale",
        name_placeholder: "Entrez un nom pour le bouton de connexion sociale",
        name_tip: 'Le nom du bouton de connexion s\'affichera comme "Continuer avec {{name}}". Tenez compte de la longueur du nom si celui-ci devient trop long.',
        logo: "URL du logo pour le bouton de connexion sociale",
        logo_placeholder: "https://votre.domaine.cdn/logo.png",
        logo_tip: "L'image du logo s'affichera sur le connecteur. Obtenez un lien d'image accessible au public et ins\xe9rez le lien ici.",
        logo_dark: "URL du logo pour le bouton de connexion sociale (mode sombre)",
        logo_dark_placeholder: "https://votre.domaine.cdn/logo.png",
        logo_dark_tip: "D\xe9finissez le logo de votre connecteur pour le mode sombre apr\xe8s l'avoir activ\xe9 dans l'exp\xe9rience de connexion de la console d'administration.",
        logo_dark_collapse: "R\xe9duire",
        logo_dark_show: "Afficher l'option du logo pour le mode sombre",
        target: "Nom du fournisseur d'identit\xe9",
        target_placeholder: "Entrez le nom du fournisseur d'identit\xe9 du connecteur",
        target_tip: "La valeur de \"nom de l'IdP\" peut \xeatre une cha\xeene d'identificateur unique pour distinguer vos identifiants sociaux.",
        target_tip_standard: "La valeur de \"nom de l'IdP\" peut \xeatre une cha\xeene d'identificateur unique pour distinguer vos identifiants sociaux. Ce param\xe8tre ne peut pas \xeatre modifi\xe9 une fois que le connecteur est cr\xe9\xe9.",
        target_tooltip: "\xabCible\xbb dans les connecteurs sociaux de Logto fait r\xe9f\xe9rence \xe0 la \xabsource\xbb de vos identit\xe9s sociales. Dans la conception de Logto, nous n'acceptons pas la m\xeame \xabcible\xbb d'une plateforme sp\xe9cifique pour \xe9viter les conflits. Vous devriez \xeatre tr\xe8s attentif avant d'ajouter un connecteur car vous NE POUVEZ PAS changer sa valeur une fois que vous l'avez cr\xe9\xe9. <a>En savoir plus</a>",
        target_conflict: "Le nom de l'IdP saisi correspond au nom existant <span>nom</span>. Utiliser le m\xeame nom d'IdP peut entra\xeener un comportement de connexion inattendu o\xf9 les utilisateurs peuvent acc\xe9der au m\xeame compte via deux connecteurs diff\xe9rents.",
        target_conflict_line2: "Si vous souhaitez remplacer le connecteur actuel par le m\xeame fournisseur d'identit\xe9 et permettre aux utilisateurs pr\xe9c\xe9dents de se connecter sans s'inscrire \xe0 nouveau, veuillez supprimer le connecteur <span>nom</span> et cr\xe9er un nouveau connecteur avec le m\xeame nom \"IdP\".",
        target_conflict_line3: "Si vous souhaitez vous connecter \xe0 un fournisseur d'identit\xe9 diff\xe9rent, modifiez le \"nom de l'IdP\" et poursuivez.",
        config: "Entrez votre JSON de configuration",
        sync_profile: "Synchroniser les informations de profil",
        sync_profile_only_at_sign_up: "Synchroniser uniquement \xe0 l'inscription",
        sync_profile_each_sign_in: "Toujours effectuer une synchronisation \xe0 chaque connexion",
        sync_profile_tip: "Synchronisez le profil de base du fournisseur social, tel que les noms des utilisateurs et leurs avatars.",
        callback_uri: "URI de rappel",
        callback_uri_description: "\xc9galement appel\xe9e URI de redirection, c'est l'URI dans Logto o\xf9 les utilisateurs seront renvoy\xe9s apr\xe8s l'autorisation sociale, copiez et collez sur la page de configuration du fournisseur social."
    },
    platform: {
        universal: "Universel",
        web: "Web",
        native: "Natifs"
    },
    add_multi_platform: " prend en charge plusieurs plateformes, s\xe9lectionnez une plateforme pour continuer",
    drawer_title: "Guide des connecteurs",
    drawer_subtitle: "Suivez les instructions pour int\xe9grer votre connecteur",
    unknown: "Connecteur inconnu",
    standard_connectors: "Connecteurs standard"
};
var $b7dfc5fe65bc5321$export$2e2bcd8739ae039 = Object.freeze($b7dfc5fe65bc5321$var$connectors);


const $b075caddcc09bd33$var$contact = {
    title: "Obtenir de l'aide",
    description: "Pour les demandes d'aide ou les commentaires sur le produit, veuillez nous contacter par l'un des moyens suivants.",
    discord: {
        title: "Rejoignez la communaut\xe9 Discord",
        description: "Connectez-vous avec d'autres d\xe9veloppeurs pour trouver des solutions",
        button: "Rejoindre"
    },
    github: {
        title: "Communiquez sur GitHub",
        description: "Cr\xe9ez un probl\xe8me et soumettez-le sur GitHub",
        button: "Ouvrir"
    },
    email: {
        title: "Contacter le support par e-mail",
        description: "Envoyez-nous un e-mail pour obtenir des informations compl\xe9mentaires et de l'aide",
        button: "Envoyer"
    },
    reserve: {
        title: "R\xe9servez votre temps avec l'\xe9quipe Logto",
        description: "R\xe9servez rapidement une session pour un chat en direct",
        button: "R\xe9server"
    }
};
var $b075caddcc09bd33$export$2e2bcd8739ae039 = Object.freeze($b075caddcc09bd33$var$contact);


const $2f7d022b62b12639$var$dashboard = {
    page_title: "Tableau de bord",
    title: "Tableau de bord",
    description: "Obtenez une vue d'ensemble des performances de votre application",
    total_users: "Utilisateurs totaux",
    total_users_tip: "Utilisateurs totaux",
    new_users_today: "Nouveaux utilisateurs aujourd'hui",
    new_users_today_tip: "Le nombre de nouveaux utilisateurs enregistr\xe9s sur vos applications aujourd'hui",
    new_users_7_days: "Nouveaux utilisateurs des 7 derniers jours",
    new_users_7_days_tip: "Le nombre de nouveaux utilisateurs enregistr\xe9s sur vos applications au cours des 7 derniers jours.",
    daily_active_users: "Utilisateurs actifs quotidiens",
    daily_active_users_tip: "Le nombre d'utilisateurs uniques qui ont \xe9chang\xe9 des jetons sur vos applications aujourd'hui.",
    weekly_active_users: "Utilisateurs actifs hebdomadaires",
    weekly_active_users_tip: "Le nombre d'utilisateurs uniques ayant \xe9chang\xe9 des jetons sur vos applications au cours des 7 derniers jours.",
    monthly_active_users: "Utilisateurs actifs mensuels",
    monthly_active_users_tip: "Le nombre d'utilisateurs uniques ayant \xe9chang\xe9 des jetons sur vos applications au cours des 30 derniers jours."
};
var $2f7d022b62b12639$export$2e2bcd8739ae039 = Object.freeze($2f7d022b62b12639$var$dashboard);


const $86234e256521fe2f$var$domain = {
    status: {
        connecting: "Connexion",
        in_used: "Utilis\xe9",
        failed_to_connect: "\xc9chec de la connexion"
    },
    update_endpoint_notice: "N’oubliez pas de mettre \xe0 jour le domaine pour l’URI de rappel du connecteur social et le point de terminaison Logto dans votre application si vous souhaitez utiliser un domaine personnalis\xe9 pour les fonctionnalit\xe9s. <a>{{link}}</a>",
    error_hint: "Assurez-vous de mettre \xe0 jour vos enregistrements DNS. Nous continuerons \xe0 v\xe9rifier toutes les {{value}} secondes.",
    custom: {
        custom_domain: "Domaine personnalis\xe9",
        custom_domain_description: "Am\xe9liorez votre image de marque en utilisant un domaine personnalis\xe9. Ce domaine sera utilis\xe9 dans votre exp\xe9rience de connexion.",
        custom_domain_field: "Domaine personnalis\xe9",
        custom_domain_placeholder: "votre.domaine.com",
        add_domain: "Ajouter un domaine",
        invalid_domain_format: "Format de sous-domaine invalide. Veuillez entrer un sous-domaine d’au moins trois parties.",
        verify_domain: "V\xe9rifier le domaine",
        enable_ssl: "Activer SSL",
        checking_dns_tip: "Apr\xe8s avoir configur\xe9 les enregistrements DNS, le processus s'ex\xe9cutera automatiquement et peut prendre jusqu'\xe0 24 heures. Vous pouvez quitter cette interface pendant son ex\xe9cution.",
        enable_ssl_tip: "Activer SSL s’ex\xe9cutera automatiquement et peut prendre jusqu’\xe0 24 heures. Vous pouvez quitter cette interface pendant son ex\xe9cution.",
        generating_dns_records: "G\xe9n\xe9ration des enregistrements DNS...",
        add_dns_records: "Veuillez ajouter ces enregistrements DNS \xe0 votre fournisseur DNS.",
        dns_table: {
            type_field: "Type",
            name_field: "Nom",
            value_field: "Valeur"
        },
        deletion: {
            delete_domain: "Supprimer le domaine",
            reminder: "Supprimer le domaine personnalis\xe9",
            description: "\xcates-vous s\xfbr de vouloir supprimer ce domaine personnalis\xe9 ?",
            in_used_description: '\xcates-vous s\xfbr de vouloir supprimer ce domaine personnalis\xe9 "<span>{{domain}}</span>" ?',
            in_used_tip: 'Si vous avez configur\xe9 ce domaine personnalis\xe9 dans votre fournisseur de connecteur social ou le point de terminaison de l’application avant, vous devrez d’abord modifier l’URI vers le domaine Logto par d\xe9faut "<span>{{domain}}</span>". Ceci est n\xe9cessaire pour que le bouton de connexion sociale fonctionne correctement.',
            deleted: "Suppression du domaine personnalis\xe9 r\xe9ussie !"
        }
    },
    default: {
        default_domain: "Domaine par d\xe9faut",
        default_domain_description: "Logto offre un domaine par d\xe9faut pr\xe9configur\xe9, pr\xeat \xe0 \xeatre utilis\xe9 sans aucune configuration suppl\xe9mentaire. Ce domaine par d\xe9faut sert de solution de secours m\xeame si vous avez activ\xe9 un domaine personnalis\xe9.",
        default_domain_field: "Domaine par d\xe9faut de Logto"
    },
    custom_endpoint_note: 'Vous pouvez personnaliser le nom de domaine de ces points de terminaison selon vos besoins. Choisissez soit "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Vous pouvez personnaliser le nom de domaine de cette URI pour correspondre au point de terminaison de votre application. Choisissez soit "{{custom}}" ou "{{default}}".'
};
var $86234e256521fe2f$export$2e2bcd8739ae039 = Object.freeze($86234e256521fe2f$var$domain);


const $4c9222d6f23cc6cf$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $4c9222d6f23cc6cf$export$2e2bcd8739ae039 = Object.freeze($4c9222d6f23cc6cf$var$enterprise_sso_details);


const $5d05dff1c0545568$var$enterprise_sso = {
    page_title: "SSO d'entreprise",
    title: "SSO d'entreprise",
    subtitle: "Connectez le fournisseur d'identit\xe9 de l'entreprise et activez la connexion unique initi\xe9e par le fournisseur de services.",
    create: "Ajouter un connecteur d'entreprise",
    col_connector_name: "Nom du connecteur",
    /** UNTRANSLATED */ col_type: "Type",
    col_email_domain: "Domaine de messagerie",
    placeholder_title: "Connecteur d'entreprise",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Ajouter un connecteur d'entreprise",
        text_divider: "Ou vous pouvez personnaliser votre connecteur avec un protocole standard.",
        connector_name_field_title: "Nom du connecteur",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Cr\xe9er un connecteur"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $5d05dff1c0545568$export$2e2bcd8739ae039 = Object.freeze($5d05dff1c0545568$var$enterprise_sso);


const $652c1f8be71ef158$var$errors = {
    something_went_wrong: "Oups ! Quelque chose a mal tourn\xe9.",
    page_not_found: "Page non trouv\xe9e",
    unknown_server_error: "Une erreur de serveur inconnu s'est produite",
    empty: "Pas de donn\xe9es",
    missing_total_number: "Impossible de trouver le nombre total dans les en-t\xeates de r\xe9ponse",
    invalid_uri_format: "Format d'URI non valide",
    invalid_origin_format: "Format d'origine URI non valide",
    invalid_json_format: "Format JSON non valide",
    invalid_error_message_format: "Le format du message d'erreur n'est pas valide.",
    required_field_missing: "Veuillez saisir {{field}}",
    required_field_missing_plural: "Vous devez entrer au moins un {{field}}.",
    more_details: "Plus de d\xe9tails",
    username_pattern_error: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des traits de soulignement et ne doit pas commencer par un chiffre.",
    email_pattern_error: "L'adresse e-mail n'est pas valide.",
    phone_pattern_error: "Le num\xe9ro de t\xe9l\xe9phone n’est pas valide.",
    insecure_contexts: "Les contextes non s\xe9curis\xe9s (non HTTPS) ne sont pas pris en charge.",
    unexpected_error: "Une erreur inattendue s'est produite",
    not_found: "404 non trouv\xe9",
    create_internal_role_violation: 'Vous cr\xe9ez un nouveau r\xf4le interne qui est interdit par Logto. Essayez un autre nom qui ne commence pas par "#internal:".',
    should_be_an_integer: "Doit \xeatre un entier.",
    number_should_be_between_inclusive: "Le nombre doit \xeatre compris entre {{min}} et {{max}} (inclusivement)."
};
var $652c1f8be71ef158$export$2e2bcd8739ae039 = Object.freeze($652c1f8be71ef158$var$errors);


const $9337b88bb951506c$var$general = {
    placeholder: "Emplacement",
    submit: "Soumettre",
    skip: "Passer",
    next: "Suivant",
    back: "Retourner",
    retry: "Essayez \xe0 nouveau",
    done: "Termin\xe9",
    search: "Recherche",
    search_placeholder: "Recherche...",
    clear_result: "Effacer les r\xe9sultats",
    save: "Sauvegarder",
    save_changes: "Sauvegarder les modifications",
    saved: "Sauvegard\xe9",
    discard: "Abandonner",
    loading: "Chargement...",
    redirecting: "Redirection...",
    add: "Ajouter",
    added: "Ajout\xe9",
    cancel: "Annuler",
    confirm: "Confirmer",
    check_out: "V\xe9rifier",
    create: "Cr\xe9er",
    set_up: "Configurer",
    customize: "Personnaliser",
    enable: "Activer",
    reminder: "Rappel",
    delete: "Supprimer",
    more_options: "PLUS D'OPTIONS",
    close: "Fermer",
    copy: "Copier",
    copying: "Copie",
    copied: "Copi\xe9",
    required: "Requis",
    add_another: "Ajouter un autre",
    create_another: "Cr\xe9er un autre",
    deletion_confirmation: "\xcates-vous s\xfbr de vouloir supprimer ce {{title}} ?",
    settings_nav: "Param\xe8tres",
    unsaved_changes_warning: "Vous avez effectu\xe9 des changements. \xcates-vous s\xfbr de vouloir quitter cette page ?",
    leave_page: "Quittez la page",
    stay_on_page: "Rester sur la page",
    type_to_search: "Tapez pour rechercher",
    got_it: "Compris.",
    continue: "Continuez",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "En savoir plus",
    tab_errors: "{{count, number}} erreurs",
    skip_for_now: "Passer pour l`instant",
    remove: "Supprimer",
    visit: "Visiter",
    join: "Rejoindre",
    try_now: "Essayez maintenant",
    multiple_form_field: "(Multiple)",
    demo: "D\xe9mo",
    unnamed: "Sans nom",
    view: "Vue",
    hide: "Cacher",
    unknown_error: "Erreur inconnue, veuillez r\xe9essayer ult\xe9rieurement.",
    select: "S\xe9lectionner",
    contact_us_action: "Nous contacter",
    description: "Description",
    name: "Nom",
    add_field: "Ajouter {{field}}",
    create_field: "Cr\xe9er {{field}}",
    edit_field: "Modifier {{field}}",
    delete_field: "Supprimer {{field}}",
    coming_soon: "Bient\xf4t disponible",
    beta_notice: "\uD83C\uDF89  {{feature}} est actuellement en version b\xeata. Bienvenue pour l`explorer et <ContactLink>partager vos commentaires</ContactLink>."
};
var $9337b88bb951506c$export$2e2bcd8739ae039 = Object.freeze($9337b88bb951506c$var$general);


const $0a0b38956272cc74$var$get_started = {
    page_title: "Commencer",
    title: "Quelque chose \xe0 explorer pour vous aider \xe0 r\xe9ussir",
    subtitle: "Quelques choses que vous pouvez faire pour obtenir rapidement de la valeur de Logto",
    develop: {
        title: "D\xe9velopper: Prenez 5 minutes pour int\xe9grer votre application"
    },
    customize: {
        title: "Personnaliser: Offrez une excellente exp\xe9rience de connexion",
        preview: {
            title: "V\xe9rifiez l'aper\xe7u en direct de l'exp\xe9rience de connexion que vous venez de personnaliser",
            subtitle: "Essayez d\xe8s maintenant l'exp\xe9rience de connexion de Logto pour voir comment cela fonctionne"
        },
        connector: {
            title: "Ajoutez plus de connecteurs pour prendre en charge plus de m\xe9thodes de connexion social",
            subtitle: "Essayez la connexion sans mot de passe et activez une exp\xe9rience s\xe9curis\xe9e et sans friction pour vos clients"
        },
        continue_customizing: "Continuer la personnalisation",
        try_now: "Essayez maintenant",
        add_more: "Ajouter plus"
    },
    secure: {
        title: "S\xe9curit\xe9: Prot\xe9gez vos ressources"
    },
    manage: {
        title: "G\xe9rer: D\xe9finir le contr\xf4le d'acc\xe8s pour votre produit et vos utilisateurs",
        rbac: {
            title: "Ajoutez un contr\xf4le d'acc\xe8s bas\xe9 sur les r\xf4les pour prot\xe9ger vos ressources",
            subtitle: "Contr\xf4lez vos ressources gr\xe2ce \xe0 une autorisation de r\xf4le \xe9volutive pour des cas d'utilisation divers"
        },
        create_roles: "Cr\xe9er des r\xf4les"
    },
    view_all: "Tout afficher →"
};
var $0a0b38956272cc74$export$2e2bcd8739ae039 = Object.freeze($0a0b38956272cc74$var$get_started);


const $ccdfeb1b66537c94$var$guide = {
    start_building: "Commencer \xe0 construire",
    get_started: "D\xe9marrer",
    categories: {
        featured: "Populaire et pour vous",
        Traditional: "Application web traditionnelle",
        SPA: "Application sur une seule page",
        Native: "Natif",
        MachineToMachine: "Machine-\xe0-machine"
    },
    filter: {
        title: "Filtrer le framework",
        placeholder: "Rechercher un framework"
    },
    checkout_tutorial: "Voir le tutoriel {{name}}",
    do_not_need_tutorial: "Si vous n'avez pas besoin d'un tutoriel, vous pouvez continuer sans guide de framework",
    finish_and_done: "Terminer et termin\xe9",
    cannot_find_guide: "Impossible de trouver votre guide ?",
    describe_guide_looking_for: "D\xe9crivez le guide que vous recherchez",
    request_guide_successfully: "Votre demande a \xe9t\xe9 soumise avec succ\xe8s. Merci !",
    app: {
        select_framework_or_tutorial: "S\xe9lectionnez un framework ou un tutoriel",
        guide_modal_title: "Commencez avec le SDK et les guides",
        modal_subtitle: "D\xe9marrez le processus de d\xe9veloppement de votre application avec notre SDK et nos tutoriels pr\xe9-construits.",
        select_a_framework: "S\xe9lectionnez un framework",
        continue_without_framework: "Cr\xe9ez une application sans framework",
        describe_guide_looking_for_placeholder: "Par exemple, je veux int\xe9grer Logto dans mon application Angular."
    },
    api: {
        modal_title: "Commencez avec les tutoriels",
        modal_subtitle: "D\xe9marrez le processus de d\xe9veloppement de votre application avec nos tutoriels pr\xe9-construits.",
        select_a_tutorial: "S\xe9lectionnez un tutoriel",
        continue_without_tutorial: "Continuer sans tutoriel",
        describe_guide_looking_for_placeholder: "Par exemple, je veux prot\xe9ger mon API en utilisant deno."
    }
};
var $ccdfeb1b66537c94$export$2e2bcd8739ae039 = Object.freeze($ccdfeb1b66537c94$var$guide);


const $e0237a95edf65515$var$log_details = {
    page_title: "D\xe9tails du journal d'audit",
    back_to_logs: "Retour aux journaux d'audit",
    back_to: "Retour \xe0 {{name}}",
    success: "Succ\xe8s",
    failed: "\xc9chou\xe9",
    event_key: "Cl\xe9 d'\xe9v\xe9nement",
    application: "Application",
    ip_address: "Addresse IP",
    user: "Utilisateur",
    log_id: "ID du journal",
    time: "Temps",
    user_agent: "Agent de l'utilisateur",
    tab_details: "D\xe9tails",
    raw_data: "Donn\xe9es brutes"
};
var $e0237a95edf65515$export$2e2bcd8739ae039 = Object.freeze($e0237a95edf65515$var$log_details);


const $9853e561c010d94b$var$logs = {
    page_title: "Journaux d'audit",
    title: "Journaux d'audit",
    subtitle: "Visualisez les donn\xe9es du journal des \xe9v\xe9nements d'authentification effectu\xe9s par votre administrateur et vos utilisateurs.",
    event: "\xc9v\xe9nement",
    user: "Utilisateur",
    application: "Application",
    time: "Temps",
    filter_by: "Filtrer par"
};
var $9853e561c010d94b$export$2e2bcd8739ae039 = Object.freeze($9853e561c010d94b$var$logs);


const $7884006d210c1b37$var$menu = {
    profile: "Profile",
    language: "Langue",
    appearance: {
        label: "Apparence",
        light: "Mode clair",
        dark: "Mode sombre",
        system: "Synchronisation avec le syst\xe8me"
    },
    sign_out: "Sign Out"
};
var $7884006d210c1b37$export$2e2bcd8739ae039 = Object.freeze($7884006d210c1b37$var$menu);


const $f35b80bef8cb569c$var$mfa = {
    title: "Authentification \xe0 plusieurs facteurs",
    description: "Ajoutez une authentification \xe0 plusieurs facteurs pour renforcer la s\xe9curit\xe9 de votre exp\xe9rience de connexion.",
    factors: "Facteurs",
    multi_factors: "Multi-facteurs",
    multi_factors_description: "Les utilisateurs doivent v\xe9rifier l'un des facteurs activ\xe9s pour la v\xe9rification en deux \xe9tapes.",
    totp: "OTP de l'application authentificatrice",
    otp_description: "Liez Google Authenticator, etc., pour v\xe9rifier les mots de passe \xe0 usage unique.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "V\xe9rifiez via une m\xe9thode prise en charge par le navigateur : biom\xe9trie, scan de t\xe9l\xe9phone ou cl\xe9 de s\xe9curit\xe9, etc.",
    webauthn_native_tip: "WebAuthn n'est pas pris en charge pour les applications natives.",
    webauthn_domain_tip: "WebAuthn lie les cl\xe9s publiques au domaine sp\xe9cifique. Modifier votre domaine de service bloquera les utilisateurs pour l'authentification via les passkeys existantes.",
    backup_code: "Code de secours",
    backup_code_description: "G\xe9n\xe9rez 10 codes de secours \xe0 usage unique apr\xe8s que les utilisateurs aient configur\xe9 une m\xe9thode de MFA.",
    backup_code_setup_hint: "Quand les utilisateurs ne peuvent pas v\xe9rifier les facteurs MFA ci-dessus, utilisez l'option de secours.",
    backup_code_error_hint: "Pour utiliser un code de secours, vous avez besoin d'au moins une autre m\xe9thode de MFA pour une authentification r\xe9ussie de l'utilisateur.",
    policy: "Politique",
    policy_description: "D\xe9finissez la politique de MFA pour les flux de connexion et d'inscription.",
    two_step_sign_in_policy: "Politique de v\xe9rification en deux \xe9tapes \xe0 la connexion",
    user_controlled: "Les utilisateurs peuvent activer ou d\xe9sactiver MFA eux-m\xeames",
    user_controlled_tip: "Les utilisateurs peuvent ignorer la configuration MFA la premi\xe8re fois \xe0 la connexion ou \xe0 l'inscription, ou l'activer/d\xe9sactiver dans les param\xe8tres du compte.",
    mandatory: "Les utilisateurs doivent toujours utiliser MFA \xe0 la connexion",
    mandatory_tip: "Les utilisateurs doivent configurer MFA la premi\xe8re fois \xe0 la connexion ou \xe0 l'inscription, et l'utiliser pour toutes les connexions futures."
};
var $f35b80bef8cb569c$export$2e2bcd8739ae039 = Object.freeze($f35b80bef8cb569c$var$mfa);


const $225ccb879b57ba88$var$organization_details = {
    page_title: "D\xe9tails de l'organisation",
    delete_confirmation: "Une fois supprim\xe9e, tous les membres perdront leur adh\xe9sion et leurs r\xf4les dans cette organisation. Cette action ne peut pas \xeatre annul\xe9e.",
    organization_id: "Identifiant de l'organisation",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Le nom de l'organisation, pas n\xe9cessairement unique.",
    description_placeholder: "Une description de l'organisation.",
    member: "Membre",
    member_other: "Membres",
    add_members_to_organization: "Ajouter des membres \xe0 l'organisation {{name}}",
    add_members_to_organization_description: "Trouvez les utilisateurs appropri\xe9s en recherchant leur nom, e-mail, t\xe9l\xe9phone ou identifiant d'utilisateur. Les membres existants ne sont pas affich\xe9s dans les r\xe9sultats de la recherche.",
    add_with_organization_role: "Ajouter avec le(s) r\xf4le(s) dans l'organisation",
    user: "Utilisateur",
    authorize_to_roles: "Autoriser {{name}} \xe0 acc\xe9der aux r\xf4les suivants :",
    edit_organization_roles: "Modifier les r\xf4les de l'organisation",
    edit_organization_roles_of_user: "Modifier les r\xf4les de l'organisation de {{name}}",
    remove_user_from_organization: "Retirer l'utilisateur de l'organisation",
    remove_user_from_organization_description: "Une fois retir\xe9, l'utilisateur perdra son adh\xe9sion et ses r\xf4les dans cette organisation. Cette action ne peut pas \xeatre annul\xe9e.",
    search_user_placeholder: "Rechercher par nom, e-mail, t\xe9l\xe9phone ou identifiant d'utilisateur",
    at_least_one_user: "Au moins un utilisateur est requis."
};
var $225ccb879b57ba88$export$2e2bcd8739ae039 = Object.freeze($225ccb879b57ba88$var$organization_details);


const $16879836bc979bef$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organisations",
    title: "Organisations",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID de l'organisation",
    members: "Membres",
    create_organization: "Cr\xe9er une organisation",
    setup_organization: "Configurer votre organisation",
    organization_list_placeholder_title: "Organisation",
    organization_list_placeholder_text: "L'organisation est g\xe9n\xe9ralement utilis\xe9e dans les applications multi-locataires SaaS ou de type SaaS. La fonctionnalit\xe9 Organisations permet \xe0 vos clients B2B de mieux g\xe9rer leurs partenaires et clients, et de personnaliser les fa\xe7ons dont les utilisateurs finaux acc\xe8dent \xe0 leurs applications.",
    organization_name_placeholder: "Mon organisation",
    organization_description_placeholder: "Une br\xe8ve description de l'organisation",
    organization_permission: "Autorisation de l'organisation",
    organization_permission_other: "Autorisations de l'organisation",
    organization_permission_description: "L'autorisation d'organisation se r\xe9f\xe8re \xe0 l'autorisation d'acc\xe9der \xe0 une ressource dans le contexte de l'organisation. Une autorisation d'organisation doit \xeatre repr\xe9sent\xe9e par une cha\xeene significative, servant \xe9galement de nom et d'identifiant unique.",
    organization_permission_delete_confirm: "Si cette autorisation est supprim\xe9e, tous les r\xf4les d'organisation incluant cette autorisation perdront cette autorisation, et les utilisateurs ayant cette autorisation perdront l'acc\xe8s qui en d\xe9coule.",
    create_permission_placeholder: "Lire l'historique des rendez-vous",
    permission: "Autorisation",
    permission_other: "Autorisations",
    organization_role: "R\xf4le de l'organisation",
    organization_role_other: "R\xf4les de l'organisation",
    organization_role_description: "Le r\xf4le d'organisation est un regroupement d'autorisations pouvant \xeatre attribu\xe9es aux utilisateurs. Les autorisations doivent provenir des autorisations d'organisation pr\xe9d\xe9finies.",
    organization_role_delete_confirm: "Si cette autorisation est supprim\xe9e, tous les r\xf4les d'organisation incluant cette autorisation perdront cette autorisation, et les utilisateurs ayant cette autorisation perdront l'acc\xe8s qui en d\xe9coule.",
    role: "R\xf4le",
    create_role_placeholder: "Utilisateurs avec des autorisations en lecture seule",
    search_placeholder: "Rechercher par nom ou ID de l'organisation",
    search_permission_placeholder: "Tapez pour rechercher et s\xe9lectionner des autorisations",
    search_role_placeholder: "Tapez pour rechercher et s\xe9lectionner des r\xf4les",
    empty_placeholder: "\uD83E\uDD14 Vous n'avez pas encore configur\xe9 {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Commencez avec les guides",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interagissez avec l'illustration pour voir comment tout est connect\xe9",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "\xc9tape 1 : D\xe9finir les autorisations d'organisation",
        step_2: "\xc9tape 2 : D\xe9finir les r\xf4les d'organisation",
        step_3: "\xc9tape 3 : Cr\xe9er votre premi\xe8re organisation",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $16879836bc979bef$export$2e2bcd8739ae039 = Object.freeze($16879836bc979bef$var$organizations);


const $00f7dbb6771d90dc$var$permissions = {
    search_placeholder: "Rechercher par nom d'API ou de permission",
    search_placeholder_without_api: "Rechercher par nom de permission",
    name_column: "Permission",
    description_column: "Description",
    api_column: "API",
    placeholder_title: "Permission",
    placeholder_description: "La permission fait r\xe9f\xe9rence \xe0 l'autorisation d'acc\xe9der \xe0 une ressource (nous l'appelons ressource d'API)."
};
var $00f7dbb6771d90dc$export$2e2bcd8739ae039 = Object.freeze($00f7dbb6771d90dc$var$permissions);


const $9b6981005c13ffd3$var$profile = {
    page_title: "Param\xe8tres du compte",
    title: "Param\xe8tres du compte",
    description: "Modifiez les param\xe8tres de votre compte et g\xe9rez vos informations personnelles ici pour garantir la s\xe9curit\xe9 de votre compte.",
    settings: {
        title: "Param\xe8tres du profil",
        profile_information: "Informations du profil",
        avatar: "Avatar",
        name: "Nom",
        username: "Nom d'utilisateur"
    },
    link_account: {
        title: "Lien de compte",
        email_sign_in: "Connexion par e-mail",
        email: "Email",
        social_sign_in: "Connexion sociale",
        link_email: "Lier le courriel",
        link_email_subtitle: "Liez votre e-mail pour vous connecter ou pour vous aider \xe0 r\xe9cup\xe9rer votre compte.",
        email_required: "L'email est obligatoire",
        invalid_email: "Adresse e-mail invalide",
        identical_email_address: "L'adresse e-mail saisie est identique \xe0 celle en cours",
        anonymous: "Anonyme"
    },
    password: {
        title: "Mot de passe et s\xe9curit\xe9",
        password: "Mot de passe",
        password_setting: "Param\xe8tres de mot de passe",
        new_password: "Nouveau mot de passe",
        confirm_password: "Confirmer le mot de passe",
        enter_password: "Entrez le mot de passe actuel",
        enter_password_subtitle: "V\xe9rifiez que c'est vous pour prot\xe9ger la s\xe9curit\xe9 de votre compte. Veuillez saisir votre mot de passe actuel avant de le changer.",
        set_password: "D\xe9finir le mot de passe",
        verify_via_password: "V\xe9rifier via mot de passe",
        show_password: "Afficher le mot de passe",
        required: "Le mot de passe est obligatoire",
        do_not_match: "Les mots de passe ne correspondent pas. Veuillez r\xe9essayer."
    },
    code: {
        enter_verification_code: "Entrez le code de v\xe9rification",
        enter_verification_code_subtitle: "Le code de v\xe9rification a \xe9t\xe9 envoy\xe9 \xe0 <strong>{{target}}</strong>",
        verify_via_code: "V\xe9rifier via code de v\xe9rification",
        resend: "Renvoyer le code de v\xe9rification",
        resend_countdown: "Renvojer dans {{countdown}} secondes"
    },
    delete_account: {
        title: "Supprimer le compte",
        label: "Supprimer le compte",
        description: "La suppression de votre compte supprimera toutes vos informations personnelles, vos donn\xe9es d'utilisateur et votre configuration. Cette action ne peut pas \xeatre annul\xe9e.",
        button: "Supprimer le compte",
        dialog_paragraph_1: "Nous sommes d\xe9sol\xe9s d'entendre que vous souhaitez supprimer votre compte. La suppression de votre compte supprimera d\xe9finitivement toutes les donn\xe9es, y compris les informations d'utilisateur, les journaux et les param\xe8tres, et cette action ne peut pas \xeatre annul\xe9e. Veuillez donc vous assurer de sauvegarder toutes les donn\xe9es importantes avant de continuer.",
        dialog_paragraph_2: "Pour poursuivre le processus de suppression de compte, veuillez envoyer un e-mail \xe0 notre \xe9quipe de support \xe0 l'adresse <a>mail</a> avec l'objet \xab Demande de suppression de compte \xbb. Nous vous aiderons et nous assurerons que toutes vos donn\xe9es sont correctement supprim\xe9es de notre syst\xe8me.",
        dialog_paragraph_3: "Merci d'avoir choisi Logto Cloud. Si vous avez des questions ou des pr\xe9occupations suppl\xe9mentaires, n'h\xe9sitez pas \xe0 nous contacter."
    },
    set: "D\xe9finir",
    change: "Modifier",
    link: "Lier",
    unlink: "D\xe9tacher",
    not_set: "Pas d\xe9fini",
    change_avatar: "Modifier l'avatar",
    change_name: "Modifier le nom",
    change_username: "Modifier le nom d'utilisateur",
    set_name: "D\xe9finir le nom",
    email_changed: "Email modifi\xe9.",
    password_changed: "Mot de passe modifi\xe9.",
    updated: "{{target}} mis \xe0 jour.",
    linked: "{{target}} li\xe9.",
    unlinked: "{{target}} d\xe9tach\xe9.",
    email_exists_reminder: "Cet e-mail {{email}} est associ\xe9 \xe0 un compte existant. Liez un autre e-mail ici.",
    unlink_confirm_text: "Oui, d\xe9tacher",
    unlink_reminder: "Les utilisateurs ne pourront plus se connecter avec le compte <span></span> si vous le d\xe9tachez. \xcates-vous s\xfbr de vouloir continuer ?"
};
var $9b6981005c13ffd3$export$2e2bcd8739ae039 = Object.freeze($9b6981005c13ffd3$var$profile);


const $51175e17b49d0679$var$role_details = {
    back_to_roles: "Retour aux r\xf4les",
    identifier: "Identificateur",
    delete_description: "Cela supprimera les autorisations associ\xe9es \xe0 ce r\xf4le des utilisateurs concern\xe9s et supprimera la correspondance entre les r\xf4les, les utilisateurs et les autorisations.",
    role_deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s.",
    settings_tab: "Param\xe8tres",
    users_tab: "Utilisateurs",
    m2m_apps_tab: "Applications machine-\xe0-machine",
    permissions_tab: "Autorisations",
    settings: "Param\xe8tres",
    settings_description: "Les r\xf4les sont un regroupement d'autorisations qui peuvent \xeatre attribu\xe9es aux utilisateurs. Ils fournissent \xe9galement un moyen d'agr\xe9ger les autorisations d\xe9finies pour diff\xe9rentes API, ce qui rend plus efficace l'ajout, la suppression ou l'ajustement des autorisations par rapport \xe0 leur attribution individuelle aux utilisateurs.",
    field_name: "Nom",
    field_description: "Description",
    type_m2m_role_tag: "R\xf4le de l'application machine-\xe0-machine",
    type_user_role_tag: "R\xf4le d'utilisateur",
    permission: {
        assign_button: "Attribuer des autorisations",
        assign_title: "Attribuer des autorisations",
        assign_subtitle: "Attribuez des autorisations \xe0 ce r\xf4le. Le r\xf4le acquerra les autorisations ajout\xe9es, et les utilisateurs avec ce r\xf4le h\xe9riteront de ces autorisations.",
        assign_form_field: "Attribuer des autorisations",
        added_text_one: "{{count, number}} autorisation ajout\xe9e",
        added_text_other: "{{count, number}} autorisations ajout\xe9es",
        api_permission_count_one: "{{count, number}} autorisation",
        api_permission_count_other: "{{count, number}} autorisations",
        confirm_assign: "Attribuer des autorisations",
        permission_assigned: "Les autorisations s\xe9lectionn\xe9es ont \xe9t\xe9 attribu\xe9es avec succ\xe8s \xe0 ce r\xf4le",
        deletion_description: "Si cette autorisation est supprim\xe9e, l'utilisateur concern\xe9 ayant ce r\xf4le perdra l'acc\xe8s accord\xe9 par cette autorisation.",
        permission_deleted: 'L\'autorisation "{{name}}" a \xe9t\xe9 supprim\xe9e avec succ\xe8s de ce r\xf4le',
        empty: "Aucune autorisation disponible"
    },
    users: {
        assign_button: "Attribuer des utilisateurs",
        name_column: "Utilisateur",
        app_column: "Application",
        latest_sign_in_column: "Derni\xe8re connexion",
        delete_description: "Il restera dans votre r\xe9pertoire d'utilisateurs mais perdra l'autorisation pour ce r\xf4le.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s de ce r\xf4le",
        assign_title: "Attribuer des utilisateurs",
        assign_subtitle: "Attribuez des utilisateurs \xe0 ce r\xf4le. Trouvez les utilisateurs appropri\xe9s en recherchant leur nom, leur e-mail, leur num\xe9ro de t\xe9l\xe9phone ou leur ID utilisateur.",
        assign_field: "Assigner des utilisateurs",
        confirm_assign: "Attribuer des utilisateurs",
        assigned_toast_text: "Les utilisateurs s\xe9lectionn\xe9s ont \xe9t\xe9 attribu\xe9s avec succ\xe8s \xe0 ce r\xf4le",
        empty: "Aucun utilisateur disponible"
    },
    applications: {
        assign_button: "Assigner des applications",
        name_column: "Application",
        app_column: "Applications",
        description_column: "Description",
        delete_description: "Elle restera dans votre pool d'applications mais perdra l'autorisation pour ce r\xf4le.",
        deleted: "{{name}} a \xe9t\xe9 supprim\xe9 avec succ\xe8s de ce r\xf4le",
        assign_title: "Assigner des applications",
        assign_subtitle: "Assignez des applications \xe0 ce r\xf4le. Trouvez les applications appropri\xe9es en recherchant par nom, description ou ID de l'application.",
        assign_field: "Assigner des applications",
        confirm_assign: "Assigner des applications",
        assigned_toast_text: "Les applications s\xe9lectionn\xe9es ont \xe9t\xe9 attribu\xe9es avec succ\xe8s \xe0 ce r\xf4le",
        empty: "Aucune application disponible"
    }
};
var $51175e17b49d0679$export$2e2bcd8739ae039 = Object.freeze($51175e17b49d0679$var$role_details);


const $50f2375183879097$var$roles = {
    page_title: "R\xf4les",
    title: "R\xf4les",
    subtitle: "Les r\xf4les incluent des autorisations qui d\xe9terminent ce qu'un utilisateur peut faire. RBAC utilise des r\xf4les pour donner aux utilisateurs acc\xe8s \xe0 des ressources pour des actions sp\xe9cifiques.",
    create: "Cr\xe9er un r\xf4le",
    role_name: "Nom du r\xf4le",
    role_type: "Type de r\xf4le",
    show_role_type_button_text: "Afficher plus d'options",
    hide_role_type_button_text: "Masquer plus d'options",
    type_user: "R\xf4le utilisateur",
    type_machine_to_machine: "R\xf4le d'application machine-\xe0-machine",
    role_description: "Description",
    role_name_placeholder: "Entrez le nom de votre r\xf4le",
    role_description_placeholder: "Entrez la description de votre r\xf4le",
    col_roles: "R\xf4les",
    col_type: "Type",
    col_description: "Description",
    col_assigned_entities: "Assign\xe9",
    user_counts: "{{count}} utilisateurs",
    application_counts: "{{count}} applications",
    user_count: "{{count}} utilisateur",
    application_count: "{{count}} application",
    assign_permissions: "Assigner des autorisations",
    create_role_title: "Cr\xe9er un r\xf4le",
    create_role_description: "Cr\xe9ez et g\xe9rez des r\xf4les pour vos applications. Les r\xf4les contiennent des collections d'autorisations et peuvent \xeatre assign\xe9s aux utilisateurs.",
    create_role_button: "Cr\xe9er un r\xf4le",
    role_created: "Le r\xf4le {{name}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s.",
    search: "Rechercher par nom de r\xf4le, description ou ID",
    placeholder_title: "R\xf4les",
    placeholder_description: "Les r\xf4les sont un regroupement d'autorisations qui peuvent \xeatre assign\xe9es aux utilisateurs. Assurez-vous d'ajouter d'abord des autorisations avant de cr\xe9er des r\xf4les."
};
var $50f2375183879097$export$2e2bcd8739ae039 = Object.freeze($50f2375183879097$var$roles);


const $9176c1042728af82$var$session_expired = {
    title: "Session expir\xe9e",
    subtitle: "Votre session a peut-\xeatre expir\xe9 et vous avez \xe9t\xe9 d\xe9connect\xe9. Cliquez sur le bouton ci-dessous pour vous reconnecter \xe0 la console d'administration.",
    button: "Se reconnecter"
};
var $9176c1042728af82$export$2e2bcd8739ae039 = Object.freeze($9176c1042728af82$var$session_expired);


const $4abba468baf735dd$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $4abba468baf735dd$export$2e2bcd8739ae039 = Object.freeze($4abba468baf735dd$var$content);


const $6b3ac1e3ef40d750$var$password_policy = {
    password_requirements: "Exigences relatives au mot de passe",
    minimum_length: "Longueur minimale",
    minimum_length_description: "NIST sugg\xe8re d'utiliser <a>au moins 8 caract\xe8res</a> pour les produits web.",
    minimum_length_error: "La longueur minimale doit \xeatre comprise entre {{min}} et {{max}} (inclus).",
    minimum_required_char_types: "Nombre minimum de types de caract\xe8res requis",
    minimum_required_char_types_description: "Types de caract\xe8res : majuscules (A-Z), minuscules (a-z), chiffres (0-9) et symboles sp\xe9ciaux ({{symbols}}).",
    password_rejection: "Rejet du mot de passe",
    compromised_passwords: "Mots de passe compromis",
    breached_passwords: "Mots de passe compromis",
    breached_passwords_description: "Rejeter les mots de passe pr\xe9c\xe9demment trouv\xe9s dans les bases de donn\xe9es de violation.",
    restricted_phrases: "Restreindre les phrases \xe0 faible s\xe9curit\xe9",
    restricted_phrases_tooltip: "Votre mot de passe devrait \xe9viter ces phrases \xe0 moins que vous ne les combiniez avec 3 caract\xe8res suppl\xe9mentaires ou plus.",
    repetitive_or_sequential_characters: "Caract\xe8res r\xe9p\xe9titifs ou s\xe9quentiels",
    repetitive_or_sequential_characters_description: 'Par exemple, "AAAA", "1234" et "abcd".',
    user_information: "Informations utilisateur",
    user_information_description: "Par exemple, adresse e-mail, num\xe9ro de t\xe9l\xe9phone, nom d'utilisateur, etc.",
    custom_words: "Mots personnalis\xe9s",
    custom_words_description: "Personnalisez les mots sp\xe9cifiques au contexte, sans distinction de casse, un par ligne.",
    custom_words_placeholder: "Nom de votre service, nom de votre entreprise, etc."
};
var $6b3ac1e3ef40d750$export$2e2bcd8739ae039 = Object.freeze($6b3ac1e3ef40d750$var$password_policy);


const $8a3d12d0b839d9b2$var$sign_up_and_sign_in = {
    identifiers_email: "Adresse e-mail",
    identifiers_phone: "Num\xe9ro de t\xe9l\xe9phone",
    identifiers_username: "Nom d’utilisateur",
    identifiers_email_or_sms: "Adresse e-mail ou num\xe9ro de t\xe9l\xe9phone",
    identifiers_none: "Non applicable",
    and: "et",
    or: "ou",
    sign_up: {
        title: "INSCRIPTION",
        sign_up_identifier: "Identificateur d'inscription",
        identifier_description: "L'identificateur d'inscription est n\xe9cessaire pour la cr\xe9ation de compte et doit \xeatre inclus dans vote \xe9cran de connexion.",
        sign_up_authentication: "Param\xe8tres d'authentification pour l'inscription",
        authentication_description: "Toutes les actions s\xe9lectionn\xe9es seront obligatoires pour que les utilisateurs terminent le processus d'inscription.",
        set_a_password_option: "Cr\xe9er votre mot de passe",
        verify_at_sign_up_option: "V\xe9rifier lors de l'inscription",
        social_only_creation_description: "(Ceci s'applique \xe0 la cr\xe9ation de compte uniquement via un r\xe9seau social)"
    },
    sign_in: {
        title: "CONNEXION",
        sign_in_identifier_and_auth: "Identificateurs et param\xe8tres d'authentification pour la connexion",
        description: "Les utilisateurs peuvent se connecter en utilisant n'importe quelle option disponible. Ajustez la mise en page en faisant glisser et en d\xe9posant les options ci-dessous.",
        add_sign_in_method: "Ajouter une m\xe9thode de connexion",
        password_auth: "Mot de passe",
        verification_code_auth: "Code de v\xe9rification",
        auth_swap_tip: "Echangez les options ci-dessous pour d\xe9terminer celle qui apparait en premier dans le processus.",
        require_auth_factor: "Vous devez s\xe9lectionner au moins un \xe9l\xe9ment d'authentification."
    },
    social_sign_in: {
        title: "CONNEXION VIA R\xc9SEAU SOCIAL",
        social_sign_in: "Connexion via r\xe9seau social",
        description: "Selon l'identificateur obligatoire que vous avez mis en place, votre utilisateur peut \xeatre invit\xe9 \xe0 fournir un identificateur lors de l'inscription via un r\xe9seau social.",
        add_social_connector: "Ajouter un connecteur social",
        set_up_hint: {
            not_in_list: "Pas dans la liste?",
            set_up_more: "Configurer",
            go_to: "d'autres connecteurs sociaux maintenant."
        }
    },
    tip: {
        set_a_password: "Un ensemble unique de mot de passe pour votre nom d'utilisateur est essentiel.",
        verify_at_sign_up: "Nous ne prenons actuellement en charge que les adresses e-mail v\xe9rifi\xe9e. Votre base utilisateur peut contenir un grand nombre d'adresses e-mail de mauvaise qualit\xe9 s'il n'y a pas de validation.",
        password_auth: "Ceci est essentiel car vous avez activ\xe9 l'option de configuration d'un mot de passe au cours du processus d'inscription.",
        verification_code_auth: "Ceci est essentiel car vous avez uniquement activ\xe9 l'option de fourniture d'un code de v\xe9rification lors de l'inscription. Vous pouvez d\xe9cocher la case lorsque la configuration d'un mot de passe est autoris\xe9e lors du processus d'inscription.",
        delete_sign_in_method: "Ceci est essentiel car vous avez s\xe9lectionn\xe9 {{identifier}} comme identificateur requis."
    },
    advanced_options: {
        title: "OPTIONS AVANC\xc9ES",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Activer l'inscription des utilisateurs",
        enable_user_registration_description: "Activer ou interdire l'inscription des utilisateurs. Une fois d\xe9sactiv\xe9e, les utilisateurs peuvent toujours \xeatre ajout\xe9s \xe0 la console d'administration mais ne peuvent plus cr\xe9er de compte via l'interface de connexion."
    }
};
var $8a3d12d0b839d9b2$export$2e2bcd8739ae039 = Object.freeze($8a3d12d0b839d9b2$var$sign_up_and_sign_in);


const $8e91be09d42322db$var$sign_in_exp = {
    page_title: "Exp\xe9rience de connexion",
    title: "Exp\xe9rience de connexion",
    description: "Personnalisez l'interface utilisateur pour qu'elle corresponde \xe0 votre marque et consultez-la en temps r\xe9el.",
    tabs: {
        branding: "Image de marque",
        sign_up_and_sign_in: "Inscription et connexion",
        content: "Contenu",
        password_policy: "Politique de mot de passe"
    },
    welcome: {
        title: "Personnaliser l'exp\xe9rience de connexion",
        description: "D\xe9marrez rapidement avec la premi\xe8re configuration de connexion. Ce guide vous guide \xe0 travers tous les param\xe8tres n\xe9cessaires",
        get_started: "Commencer",
        apply_remind: "Veuillez noter que l'exp\xe9rience de connexion s'appliquera \xe0 toutes les applications sous ce compte."
    },
    color: {
        title: "COULEUR",
        primary_color: "Couleur de la marque",
        dark_primary_color: "Couleur de la marque (Sombre)",
        dark_mode: "Activer le mode sombre",
        dark_mode_description: "Votre application aura un th\xe8me en mode sombre g\xe9n\xe9r\xe9 automatiquement en fonction de la couleur de votre marque et de l'algorithme de Logto. Vous \xeates libre de le personnaliser.",
        dark_mode_reset_tip: "Recalculer la couleur du mode sombre en fonction de la couleur de la marque.",
        reset: "Recalculer"
    },
    branding: {
        title: "ZONE DE MARQUE",
        ui_style: "Style",
        favicon: "Favicon",
        logo_image_url: "URL de l'image du logo de l'application",
        logo_image_url_placeholder: "https://votre.domaine.cdn/logo.png",
        dark_logo_image_url: "URL de l'image du logo de l'application (Sombre)",
        dark_logo_image_url_placeholder: "https://votre.domaine.cdn/logo-dark.png",
        logo_image: "Logo de l'application",
        dark_logo_image: "Logo de l'application (sombre)",
        logo_image_error: "Logo de l'application : {{error}}",
        favicon_error: "Favicon : {{error}}"
    },
    custom_css: {
        title: "CSS personnalis\xe9",
        css_code_editor_title: "Personnalisez votre interface utilisateur avec CSS personnalis\xe9",
        css_code_editor_description1: "Voici un exemple de CSS personnalis\xe9.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "En savoir plus",
        css_code_editor_content_placeholder: "Entrez votre propre CSS pour adapter les styles de tout \xe9l\xe9ment \xe0 vos sp\xe9cifications exactes. Exprimez votre cr\xe9ativit\xe9 et faites sortir votre interface utilisateur."
    },
    sign_up_and_sign_in: $8a3d12d0b839d9b2$export$2e2bcd8739ae039,
    content: $4abba468baf735dd$export$2e2bcd8739ae039,
    password_policy: $6b3ac1e3ef40d750$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Aucun connecteur SMS n\'a \xe9t\xe9 configur\xe9. Avant de terminer la configuration, les utilisateurs ne pourront pas se connecter avec cette m\xe9thode. <a>{{link}}</a> dans "Connecteurs"',
        no_connector_email: "Aucun connecteur d'email n'a \xe9t\xe9 configur\xe9. Avant de terminer la configuration, les utilisateurs ne pourront pas se connecter avec cette m\xe9thode. <a>{{link}}</a> dans \"Connecteurs\"",
        no_connector_social: 'Vous n’avez pas encore configur\xe9 de connecteur social. Ajoutez d’abord des connecteurs pour appliquer des m\xe9thodes de connexion sociale. <a>{{link}}</a> dans "Connecteurs".',
        setup_link: "Configurer"
    },
    save_alert: {
        description: "Vous impl\xe9mentez de nouvelles proc\xe9dures d'inscription et de connexion. Tous vos utilisateurs peuvent \xeatre affect\xe9s par la nouvelle configuration. Voulez-vous vous engager dans le changement?",
        before: "Avant",
        after: "Apr\xe8s",
        sign_up: "Inscription",
        sign_in: "Connexion",
        social: "Social"
    },
    preview: {
        title: "Aper\xe7u de l'exp\xe9rience de connexion",
        live_preview: "Aper\xe7u en direct",
        live_preview_tip: "Enregistrez pour pr\xe9visualiser les modifications",
        native: "Natif",
        desktop_web: "Site web pour ordinateur de bureau",
        mobile_web: "Site web mobile",
        desktop: "Bureau",
        mobile: "Mobile"
    }
};
var $8e91be09d42322db$export$2e2bcd8739ae039 = Object.freeze($8e91be09d42322db$var$sign_in_exp);


const $15cdd60b1b8e59b6$var$quota_item = {
    tenant_limit: {
        name: "Locataires",
        limited: "{{count, number}} locataire",
        limited_other: "{{count, number}} locataires",
        unlimited: "Illimit\xe9 locataires",
        not_eligible: "Supprimez vos locataires"
    },
    mau_limit: {
        name: "Utilisateurs actifs mensuels",
        limited: "{{count, number}} MAU",
        unlimited: "Illimit\xe9 MAU",
        not_eligible: "Supprimez tous vos utilisateurs"
    },
    applications_limit: {
        name: "Applications",
        limited: "{{count, number}} application",
        limited_other: "{{count, number}} applications",
        unlimited: "Illimit\xe9 applications",
        not_eligible: "Supprimez vos applications"
    },
    machine_to_machine_limit: {
        name: "Machine to machine",
        limited: "{{count, number}} application machine \xe0 machine",
        limited_other: "{{count, number}} applications machine \xe0 machine",
        unlimited: "Illimit\xe9 applications machine \xe0 machine",
        not_eligible: "Supprimez vos applications machine \xe0 machine"
    },
    resources_limit: {
        name: "Ressources API",
        limited: "{{count, number}} ressource API",
        limited_other: "{{count, number}} ressources API",
        unlimited: "Illimit\xe9 ressources API",
        not_eligible: "Supprimez vos ressources API"
    },
    scopes_per_resource_limit: {
        name: "Permissions de ressource",
        limited: "{{count, number}} autorisation par ressource",
        limited_other: "{{count, number}} autorisations par ressource",
        unlimited: "Illimit\xe9 autorisation par ressource",
        not_eligible: "Supprimez vos permissions de ressource"
    },
    custom_domain_enabled: {
        name: "Domaine personnalis\xe9",
        limited: "Domaine personnalis\xe9",
        unlimited: "Domaine personnalis\xe9",
        not_eligible: "Supprimez votre domaine personnalis\xe9"
    },
    omni_sign_in_enabled: {
        name: "Connexion omni",
        limited: "Connexion omni",
        unlimited: "Connexion omni",
        not_eligible: "D\xe9sactivez votre connexion omni"
    },
    built_in_email_connector_enabled: {
        name: "Connecteur de messagerie int\xe9gr\xe9",
        limited: "Connecteur de messagerie int\xe9gr\xe9",
        unlimited: "Connecteur de messagerie int\xe9gr\xe9",
        not_eligible: "Supprimez votre connecteur de messagerie int\xe9gr\xe9"
    },
    social_connectors_limit: {
        name: "Connecteurs sociaux",
        limited: "{{count, number}} connecteur social",
        limited_other: "{{count, number}} connecteurs sociaux",
        unlimited: "Illimit\xe9 connecteurs sociaux",
        not_eligible: "Supprimez vos connecteurs sociaux"
    },
    standard_connectors_limit: {
        name: "Connecteurs standards gratuits",
        limited: "{{count, number}} connecteur standard gratuit",
        limited_other: "{{count, number}} connecteurs standards gratuits",
        unlimited: "Illimit\xe9 connecteurs standards",
        not_eligible: "Supprimez vos connecteurs standards"
    },
    roles_limit: {
        name: "R\xf4les",
        limited: "{{count, number}} r\xf4le",
        limited_other: "{{count, number}} r\xf4les",
        unlimited: "Illimit\xe9 r\xf4les",
        not_eligible: "Supprimez vos r\xf4les"
    },
    scopes_per_role_limit: {
        name: "Permissions de r\xf4le",
        limited: "{{count, number}} permission par r\xf4le",
        limited_other: "{{count, number}} permissions par r\xf4le",
        unlimited: "Illimit\xe9 permission par r\xf4le",
        not_eligible: "Supprimez vos permissions de r\xf4le"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks illimit\xe9s",
        not_eligible: "Supprimez vos webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Conservation des journaux d'audit",
        limited: "Conservation des journaux d'audit: {{count, number}} jour",
        limited_other: "Conservation des journaux d'audit: {{count, number}} jours",
        unlimited: "Jours illimit\xe9s",
        not_eligible: "Pas de journalisation d'audit"
    },
    community_support_enabled: {
        name: "Support de la communaut\xe9",
        limited: "Support de la communaut\xe9",
        unlimited: "Support de la communaut\xe9",
        not_eligible: "Pas de support de la communaut\xe9"
    },
    customer_ticket_support: {
        name: "Support client de ticket",
        limited: "{{count, number}} heure de support client de ticket",
        limited_other: "{{count, number}} heures de support client de ticket",
        unlimited: "Support client de ticket",
        not_eligible: "Pas de support client de ticket"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "D\xe9sactivez votre MFA"
    },
    sso_enabled: {
        name: "SSO Entreprise",
        limited: "SSO Entreprise",
        unlimited: "SSO Entreprise",
        not_eligible: "D\xe9sactivez votre SSO Entreprise"
    }
};
var $15cdd60b1b8e59b6$export$2e2bcd8739ae039 = Object.freeze($15cdd60b1b8e59b6$var$quota_item);


const $ee0b9dd94d8579c8$var$quota_table = {
    quota: {
        title: "Quota",
        tenant_limit: "Limite de locataire",
        base_price: "Prix de base",
        mau_unit_price: "* Prix unitaire MAU",
        mau_limit: "Limite MAU"
    },
    application: {
        title: "Applications",
        total: "Total des applications",
        m2m: "Machine-\xe0-machine"
    },
    resource: {
        title: "Ressources API",
        resource_count: "Nombre de ressources",
        scopes_per_resource: "Autorisations par ressource"
    },
    branding: {
        title: "Interface utilisateur et branding",
        custom_domain: "Domaine personnalis\xe9",
        custom_css: "CSS personnalis\xe9",
        app_logo_and_favicon: "Logo et favicon de l'application",
        dark_mode: "Mode sombre",
        i18n: "Internationalisation"
    },
    user_authn: {
        title: "Authentification des utilisateurs",
        omni_sign_in: "Connexion omnicanale",
        password: "Mot de passe",
        passwordless: "Sans mot de passe - Email et SMS",
        email_connector: "Connecteur email",
        sms_connector: "Connecteur SMS",
        social_connectors: "Connecteurs sociaux",
        standard_connectors: "Connecteurs standards",
        built_in_email_connector: "Connecteur email int\xe9gr\xe9",
        mfa: "MFA",
        sso: "SSO entreprise"
    },
    user_management: {
        title: "Gestion des utilisateurs",
        user_management: "Gestion des utilisateurs",
        roles: "R\xf4les",
        scopes_per_role: "Autorisations par r\xf4le"
    },
    audit_logs: {
        title: "Journaux d'audit",
        retention: "Conservation"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organisation",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Support",
        community: "Communaut\xe9",
        customer_ticket: "Ticket de support",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Vos utilisateurs actifs mensuels (MAU) sont r\xe9partis en 3 niveaux en fonction de la fr\xe9quence \xe0 laquelle ils se connectent pendant le cycle de facturation. Chaque niveau a un prix diff\xe9rent par unit\xe9 MAU.",
    unlimited: "Illimit\xe9",
    contact: "Contact",
    monthly_price: "${{value, number}}/mo",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} jour",
    days_other: "{{count, number}} jours",
    add_on: "Module compl\xe9mentaire",
    tier: "Niveau{{value, number}}: "
};
var $ee0b9dd94d8579c8$export$2e2bcd8739ae039 = Object.freeze($ee0b9dd94d8579c8$var$quota_table);


const $0b79d3399c5cf982$var$subscription = {
    free_plan: "Plan Gratuit",
    free_plan_description: "Pour les projets secondaires et les premiers essais de Logto. Aucune carte de cr\xe9dit.",
    hobby_plan: "Plan Hobby",
    hobby_plan_description: "Pour les d\xe9veloppeurs individuels ou les petites \xe9quipes d'ing\xe9nierie.",
    pro_plan: "Plan Professionnel",
    pro_plan_description: "Pour les entreprises qui b\xe9n\xe9ficient de Logto sans soucis.",
    enterprise: "Entreprise",
    current_plan: "Plan Actuel",
    current_plan_description: "Voici votre plan actuel. Vous pouvez facilement consulter l'utilisation de votre plan, v\xe9rifier votre prochaine facture et apporter des modifications \xe0 votre plan si n\xe9cessaire.",
    plan_usage: "Utilisation du plan",
    plan_cycle: "Cycle du plan: {{period}}. L'utilisation est renouvel\xe9e le {{renewDate}}.",
    next_bill: "Votre prochaine facture",
    next_bill_hint: "Pour en savoir plus sur le calcul, veuillez vous r\xe9f\xe9rer \xe0 cet <a>article</a>.",
    next_bill_tip: "Votre prochaine facture comprend le prix de base de votre plan pour le mois prochain, ainsi que le co\xfbt de votre utilisation multipli\xe9 par le prix unitaire MAU dans les diff\xe9rentes cat\xe9gories.",
    manage_payment: "G\xe9rer le Paiement",
    overfill_quota_warning: "Vous avez atteint votre limite de quota. Pour \xe9viter tout probl\xe8me, passez \xe0 un plan sup\xe9rieur.",
    upgrade_pro: "Passer au Plan Professionnel",
    update_payment: "Mettre \xe0 jour le paiement",
    payment_error: "Probl\xe8me de paiement d\xe9tect\xe9. Impossible de traiter ${{price, number}} pour le cycle pr\xe9c\xe9dent. Mettez \xe0 jour le paiement pour \xe9viter la suspension du service Logto.",
    downgrade: "Passer \xe0 un Plan Inf\xe9rieur",
    current: "Actuel",
    upgrade: "Mettre \xe0 niveau",
    quota_table: $ee0b9dd94d8579c8$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Factures",
        status_column: "Statut",
        amount_column: "Montant",
        invoice_created_date_column: "Date de cr\xe9ation de la facture",
        invoice_status: {
            void: "Annul\xe9e",
            paid: "Pay\xe9e",
            open: "Ouverte",
            uncollectible: "En souffrance"
        }
    },
    quota_item: $15cdd60b1b8e59b6$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "\xcates-vous s\xfbr de vouloir passer \xe0 un Plan Inf\xe9rieur?",
        description: "Si vous choisissez de passer au <targetName/> , notez que vous n'aurez plus acc\xe8s aux quotas et fonctionnalit\xe9s qui se trouvaient auparavant dans <currentName/>. ",
        before: "Avant: <name/>",
        after: "Apr\xe8s: <name />",
        downgrade: "Passer \xe0 un Plan Inf\xe9rieur"
    },
    not_eligible_modal: {
        downgrade_title: "Vous n'\xeates pas \xe9ligible pour une r\xe9trogradation",
        downgrade_description: "Assurez-vous de remplir les crit\xe8res suivants avant de r\xe9trograder vers le plan <name/>.",
        downgrade_help_tip: "Besoin d'aide pour r\xe9trograder ? <a>Contactez-nous</a>.",
        upgrade_title: "Rappel amical pour nos pr\xe9cieux early adopters",
        upgrade_description: "Vous utilisez actuellement plus que ce que <name /> autorise. Logto est d\xe9sormais officiel, avec des fonctionnalit\xe9s adapt\xe9es \xe0 chaque plan. Avant de envisager une mise \xe0 niveau vers <name />, assurez-vous de remplir les crit\xe8res suivants avant de faire la mise \xe0 niveau.",
        upgrade_pro_tip: " Ou envisagez de passer au Plan Pro.",
        upgrade_help_tip: "Besoin d'aide pour la mise \xe0 niveau ? <a>Contactez-nous</a>.",
        a_maximum_of: "Un maximum de <item/>"
    },
    upgrade_success: "Pass\xe9 avec succ\xe8s \xe0 <name/>",
    downgrade_success: "R\xe9trograd\xe9 avec succ\xe8s \xe0 <name/>",
    subscription_check_timeout: "La v\xe9rification d'abonnement a expir\xe9. Veuillez actualiser ult\xe9rieurement.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $0b79d3399c5cf982$export$2e2bcd8739ae039 = Object.freeze($0b79d3399c5cf982$var$subscription);


const $7f7c46f4598c4e91$var$tab_sections = {
    overview: "Vue d'ensemble",
    resources: "Ressources",
    users: "Utilisateurs",
    access_control: "Contr\xf4le d'acc\xe8s",
    help_and_support: "Aide et support",
    tenant: "Locataire",
    automation: "Automatisation"
};
var $7f7c46f4598c4e91$export$2e2bcd8739ae039 = Object.freeze($7f7c46f4598c4e91$var$tab_sections);


const $014e4e2d09d9f98d$var$tabs = {
    get_started: "Commencez",
    dashboard: "Tableau de bord",
    applications: "Applications",
    api_resources: "Ressources API",
    sign_in_experience: "Exp\xe9rience de connexion",
    connectors: "Connecteurs",
    enterprise_sso: "SSO d'entreprise",
    webhooks: "Webhooks",
    organizations: "Organisations",
    users: "Gestion des utilisateurs",
    audit_logs: "Journaux d'audit",
    roles: "R\xf4les",
    docs: "Documentation",
    tenant_settings: "Param\xe8tres du locataire",
    mfa: "Authentification multi-facteur"
};
var $014e4e2d09d9f98d$export$2e2bcd8739ae039 = Object.freeze($014e4e2d09d9f98d$var$tabs);


const $128980e8e63a1173$var$tenants = {
    title: "Param\xe8tres",
    description: "G\xe9rez efficacement les param\xe8tres du locataire et personnalisez votre domaine.",
    tabs: {
        settings: "Param\xe8tres",
        domains: "Domaines",
        subscription: "Plan et facturation",
        billing_history: "Historique de facturation"
    },
    settings: {
        title: "PARAM\xc8TRES",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID du locataire",
        tenant_name: "Nom du locataire",
        tenant_region: "R\xe9gion d'h\xe9bergement des donn\xe9es",
        tenant_region_tip: "Vos ressources de locataire sont h\xe9berg\xe9es dans {{region}}. <a>En savoir plus</a>",
        environment_tag_development: "Dev",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Les informations du locataire ont \xe9t\xe9 enregistr\xe9es avec succ\xe8s."
    },
    full_env_tag: {
        development: "D\xe9veloppement",
        production: "Production"
    },
    deletion_card: {
        title: "SUPPRIMER",
        tenant_deletion: "Supprimer le locataire",
        tenant_deletion_description: "La suppression du locataire entra\xeenera la suppression permanente de toutes les donn\xe9es utilisateur et configurations associ\xe9es. Veuillez proc\xe9der avec prudence.",
        tenant_deletion_button: "Supprimer le locataire"
    },
    create_modal: {
        title: "Cr\xe9er un locataire",
        subtitle: "Cr\xe9ez un nouveau locataire disposant de ressources et d'utilisateurs isol\xe9s. Les r\xe9gions de donn\xe9es h\xe9berg\xe9es et les types de locataires ne peuvent pas \xeatre modifi\xe9s apr\xe8s la cr\xe9ation.",
        tenant_usage_purpose: "Dans quel but souhaitez-vous utiliser ce locataire?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Plan disponible :",
        create_button: "Cr\xe9er un locataire",
        tenant_name_placeholder: "Mon locataire"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Supprimer le locataire",
        description_line1: 'Voulez-vous vraiment supprimer votre locataire "<span>{{name}}</span>" avec le tag de suffixe d\'environnement "<span>{{tag}}</span>" ? Cette action est irr\xe9versible et entra\xeenera la suppression permanente de toutes vos donn\xe9es et informations de compte.',
        description_line2: "Avant de supprimer le compte, peut-\xeatre pouvons-nous vous aider. <span><a>Contactez-nous par e-mail</a></span>",
        description_line3: 'Si vous souhaitez continuer, veuillez entrer le nom du locataire "<span>{{name}}</span>" pour confirmer.',
        delete_button: "Supprimer d\xe9finitivement",
        cannot_delete_title: "Impossible de supprimer ce locataire",
        cannot_delete_description: "D\xe9sol\xe9, vous ne pouvez pas supprimer ce locataire pour le moment. Assurez-vous d'\xeatre sur le Plan Gratuit et d'avoir pay\xe9 toutes les factures en cours."
    },
    tenant_landing_page: {
        title: "Vous n'avez pas encore cr\xe9\xe9 de locataire",
        description: "Pour commencer \xe0 configurer votre projet avec Logto, veuillez cr\xe9er un nouveau locataire. Si vous devez vous d\xe9connecter ou supprimer votre compte, cliquez simplement sur le bouton d'avatar dans le coin sup\xe9rieur droit.",
        create_tenant_button: "Cr\xe9er un locataire"
    },
    status: {
        mau_exceeded: "MAU d\xe9pass\xe9",
        suspended: "Suspendu",
        overdue: "En retard"
    },
    tenant_suspended_page: {
        title: "Locataire suspendu. Contactez-nous pour restaurer l'acc\xe8s.",
        description_1: "Nous regrettons profond\xe9ment de vous informer que votre compte de locataire a \xe9t\xe9 temporairement suspendu en raison d'une utilisation abusive, y compris le d\xe9passement des limites MAU, des paiements en retard ou d'autres actions non autoris\xe9es.",
        description_2: "Si vous avez besoin de clarifications suppl\xe9mentaires, si vous avez des pr\xe9occupations ou si vous souhaitez restaurer la fonctionnalit\xe9 compl\xe8te et d\xe9bloquer vos locataires, n'h\xe9sitez pas \xe0 nous contacter imm\xe9diatement."
    },
    signing_keys: {
        title: "CL\xc9S DE SIGNATURE",
        description: "G\xe9rez en toute s\xe9curit\xe9 les cl\xe9s de signature dans votre locataire.",
        type: {
            private_key: "Cl\xe9s priv\xe9es OIDC",
            cookie_key: "Cl\xe9s de cookies OIDC"
        },
        private_keys_in_use: "Cl\xe9s priv\xe9es en cours d'utilisation",
        cookie_keys_in_use: "Cl\xe9s de cookies en cours d'utilisation",
        rotate_private_keys: "Faire tourner les cl\xe9s priv\xe9es",
        rotate_cookie_keys: "Faire tourner les cl\xe9s de cookies",
        rotate_private_keys_description: "Cette action cr\xe9era une nouvelle cl\xe9 de signature priv\xe9e, fera tourner la cl\xe9 actuelle et supprimera votre cl\xe9 pr\xe9c\xe9dente. Vos jetons JWT sign\xe9s avec la cl\xe9 actuelle resteront valides jusqu'\xe0 leur suppression ou une nouvelle rotation.",
        rotate_cookie_keys_description: "Cette action cr\xe9era une nouvelle cl\xe9 de cookie, fera tourner la cl\xe9 actuelle et supprimera votre cl\xe9 pr\xe9c\xe9dente. Vos cookies avec la cl\xe9 actuelle resteront valides jusqu'\xe0 leur suppression ou une nouvelle rotation.",
        select_private_key_algorithm: "S\xe9lectionnez l'algorithme de cl\xe9 de signature pour la nouvelle cl\xe9 priv\xe9e",
        rotate_button: "Faire tourner",
        table_column: {
            id: "ID",
            status: "Statut",
            algorithm: "Algorithme de cl\xe9 de signature"
        },
        status: {
            current: "Actuel",
            previous: "Pr\xe9c\xe9dent"
        },
        reminder: {
            rotate_private_key: "\xcates-vous s\xfbr de vouloir faire tourner les <strong>cl\xe9s priv\xe9es OIDC</strong>? Les nouveaux jetons JWT \xe9mis seront sign\xe9s par la nouvelle cl\xe9. Les jetons JWT existants resteront valides jusqu'\xe0 votre prochaine rotation.",
            rotate_cookie_key: "\xcates-vous s\xfbr de vouloir faire tourner les <strong>cl\xe9s de cookies OIDC</strong>? Les nouveaux cookies g\xe9n\xe9r\xe9s dans les sessions de connexion seront sign\xe9s par la nouvelle cl\xe9 de cookie. Les cookies existants resteront valides jusqu'\xe0 votre prochaine rotation.",
            delete_private_key: "\xcates-vous s\xfbr de vouloir supprimer la <strong>cl\xe9 priv\xe9e OIDC</strong>? Les jetons JWT existants sign\xe9s avec cette cl\xe9 de signature priv\xe9e ne seront plus valides.",
            delete_cookie_key: "\xcates-vous s\xfbr de vouloir supprimer la <strong>cl\xe9 de cookie OIDC</strong>? Les anciennes sessions de connexion avec des cookies sign\xe9s avec cette cl\xe9 de cookie ne seront plus valides. Une r\xe9-authentification est requise pour ces utilisateurs."
        },
        messages: {
            rotate_key_success: "Rotation des cl\xe9s de signature effectu\xe9e avec succ\xe8s.",
            delete_key_success: "Cl\xe9 supprim\xe9e avec succ\xe8s."
        }
    }
};
var $128980e8e63a1173$export$2e2bcd8739ae039 = Object.freeze($128980e8e63a1173$var$tenants);


const $3a5c96b01517a0b9$var$topbar = {
    docs: "Docs",
    help: "Aide"
};
var $3a5c96b01517a0b9$export$2e2bcd8739ae039 = Object.freeze($3a5c96b01517a0b9$var$topbar);


const $27d70d860f343784$var$paywall = {
    applications: "Limite de {{count, number}} application de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    applications_other: "Limite de {{count, number}} applications de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    machine_to_machine_feature: "Mettez \xe0 niveau vers le plan <strong>Hobby</strong> pour d\xe9bloquer 1 application machine \xe0 machine, ou choisissez le plan <strong>Pro</strong> pour une utilisation illimit\xe9e. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    machine_to_machine: "Limite de {{count, number}} application de machine \xe0 machine de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    machine_to_machine_other: "Limite de {{count, number}} applications de machine \xe0 machine de <planName/> atteinte. Mettez \xe0 niveau le plan pour r\xe9pondre aux besoins de votre \xe9quipe. Pour toute assistance, n'h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    resources: "Vous avez atteint la limite de {{count, number}} ressource API de <planName/>. Mettez \xe0 niveau votre plan pour r\xe9pondre aux besoins de votre \xe9quipe. <a>Contactez-nous</a> pour toute assistance.",
    resources_other: "Vous avez atteint la limite de {{count, number}} ressources API de <planName/>. Mettez \xe0 niveau votre plan pour r\xe9pondre aux besoins de votre \xe9quipe. <a>Contactez-nous</a> pour toute assistance.",
    scopes_per_resource: "Vous avez atteint la limite de {{count, number}} permission par ressource API de <planName/>. Mettez \xe0 niveau maintenant pour \xe9tendre. <a>Contactez-nous</a> pour toute assistance.",
    scopes_per_resource_other: "Vous avez atteint la limite de {{count, number}} permissions par ressource API de <planName/>. Mettez \xe0 niveau maintenant pour \xe9tendre. <a>Contactez-nous</a> pour toute assistance.",
    custom_domain: "D\xe9bloquez la fonctionnalit\xe9 de domaine personnalis\xe9 en mettant \xe0 niveau vers les plans <strong>Hobby</strong> ou <strong>Pro</strong>. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'assistance.",
    social_connectors: "Vous avez atteint la limite de {{count, number}} connecteur social de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    social_connectors_other: "Vous avez atteint la limite de {{count, number}} connecteurs sociaux de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_feature: "Mettez \xe0 niveau vers les plans <strong>Hobby</strong> ou <strong>Pro</strong> pour cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML, plus des connecteurs sociaux illimit\xe9s et toutes les fonctionnalit\xe9s premium. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors: "Vous avez atteint la limite de {{count, number}} connecteur social de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_other: "Vous avez atteint la limite de {{count, number}} connecteurs sociaux de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez \xe0 un plan sup\xe9rieur pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_pro: "Vous avez atteint la limite de {{count, number}} connecteur standard de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez au plan Entreprise pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    standard_connectors_pro_other: "Vous avez atteint la limite de {{count, number}} connecteurs standard de <planName/>. Pour r\xe9pondre aux besoins de votre \xe9quipe, passez au plan Entreprise pour obtenir des connecteurs sociaux suppl\xe9mentaires et la possibilit\xe9 de cr\xe9er vos propres connecteurs en utilisant les protocoles OIDC, OAuth 2.0 et SAML. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    roles: "Vous avez atteint la limite de {{count, number}} r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    roles_other: "Vous avez atteint la limite de {{count, number}} r\xf4les de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    scopes_per_role: "Vous avez atteint la limite de {{count, number}} permission par r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. Pour toute assistance, n’h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    scopes_per_role_other: "Vous avez atteint la limite de {{count, number}} permissions par r\xf4le de <planName/>. Mettez \xe0 niveau votre plan pour ajouter des r\xf4les et des permissions suppl\xe9mentaires. Pour toute assistance, n’h\xe9sitez pas \xe0 <a>nous contacter</a>.",
    hooks: "Vous avez atteint la limite de {{count, number}} webhook de <planName/>. Mettez \xe0 niveau votre plan pour cr\xe9er plus de webhooks. N’h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    hooks_other: "Vous avez atteint la limite de {{count, number}} webhooks de <planName/>. Mettez \xe0 niveau votre plan pour cr\xe9er plus de webhooks. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    mfa: "D\xe9verrouillez MFA pour v\xe9rifier la s\xe9curit\xe9 en passant \xe0 un plan payant. N'h\xe9sitez pas \xe0 <a>nous contacter</a> si vous avez besoin d'aide.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $27d70d860f343784$export$2e2bcd8739ae039 = Object.freeze($27d70d860f343784$var$paywall);


const $7a49881200461f1e$var$upsell = {
    upgrade_plan: "Mettre \xe0 niveau le plan",
    compare_plans: "Comparer les plans",
    view_plans: "Voir les plans",
    create_tenant: {
        title: "S\xe9lectionnez votre plan pour le locataire",
        description: "Logto propose des options de plan comp\xe9titives avec une tarification innovante et abordable con\xe7ue pour les entreprises en croissance. <a>En savoir plus</a>",
        base_price: "Prix de base",
        monthly_price: "{{value, number}}/mois",
        mau_unit_price: "Prix unitaire MAU",
        view_all_features: "Voir toutes les fonctionnalit\xe9s",
        select_plan: "S\xe9lectionnez <name/>",
        free_tenants_limit: "Jusqu'\xe0 {{count, number}} locataire gratuit",
        free_tenants_limit_other: "Jusqu'\xe0 {{count, number}} locataires gratuits",
        most_popular: "Le plus populaire",
        upgrade_success: "Passage r\xe9ussi \xe0 <name/>"
    },
    mau_exceeded_modal: {
        title: "La limite de MAU a \xe9t\xe9 d\xe9pass\xe9e. Mettez \xe0 niveau votre plan.",
        notification: "Votre MAU actuel a d\xe9pass\xe9 la limite de <planName/>. Veuillez mettre \xe0 niveau votre plan pour passer \xe0 la version premium rapidement et \xe9viter la suspension du service Logto.",
        update_plan: "Mettre \xe0 jour le plan"
    },
    payment_overdue_modal: {
        title: "Paiement de facture en retard",
        notification: "Oups ! Le paiement de la facture du locataire <span>{{name}}</span> a \xe9chou\xe9. Veuillez payer la facture rapidement pour \xe9viter la suspension du service Logto.",
        unpaid_bills: "Factures impay\xe9es",
        update_payment: "Mettre \xe0 jour le paiement"
    },
    paywall: $27d70d860f343784$export$2e2bcd8739ae039
};
var $7a49881200461f1e$export$2e2bcd8739ae039 = Object.freeze($7a49881200461f1e$var$upsell);


const $55c1b479e513d547$var$user_details = {
    page_title: "D\xe9tails de l'utilisateur",
    back_to_users: "Retour \xe0 la gestion des utilisateurs",
    created_title: "Cet utilisateur a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s",
    created_guide: "Voici les informations pour aider l'utilisateur \xe0 se connecter.",
    created_email: "Adresse email :",
    created_phone: "Num\xe9ro de t\xe9l\xe9phone :",
    created_username: "Nom d'utilisateur :",
    created_password: "Mot de passe :",
    menu_delete: "Supprimer",
    delete_description: "Cette action ne peut \xeatre annul\xe9e. Elle supprimera d\xe9finitivement l'utilisateur.",
    deleted: "L'utilisateur a \xe9t\xe9 supprim\xe9 avec succ\xe8s",
    reset_password: {
        reset_password: "R\xe9initialiser le mot de passe",
        title: "\xcates-vous s\xfbr de vouloir r\xe9initialiser le mot de passe ?",
        content: "Cette action ne peut \xeatre annul\xe9e. Cette action r\xe9initialisera les informations de connexion de l'utilisateur.",
        congratulations: "Cet utilisateur a \xe9t\xe9 r\xe9initialis\xe9",
        new_password: "Nouveau mot de passe :"
    },
    tab_settings: "Param\xe8tres",
    tab_roles: "R\xf4les",
    tab_logs: "Journaux de l'utilisateur",
    tab_organizations: "Organisations",
    authentication: "Authentification",
    authentication_description: "Chaque utilisateur poss\xe8de un profil contenant toutes les informations le concernant. Il se compose de donn\xe9es de base, d'identit\xe9s sociales et de donn\xe9es personnalis\xe9es.",
    user_profile: "Profil utilisateur",
    field_email: "Adresse e-mail",
    field_phone: "Num\xe9ro de t\xe9l\xe9phone",
    field_username: "Nom d'utilisateur",
    field_name: "Nom",
    field_avatar: "URL de l'image avatar",
    field_avatar_placeholder: "https://votre.domaine.cdn/avatar.png",
    field_custom_data: "Donn\xe9es personnalis\xe9es",
    field_custom_data_tip: "Informations suppl\xe9mentaires sur l'utilisateur qui ne figurent pas dans les propri\xe9t\xe9s pr\xe9d\xe9finies de l'utilisateur, telles que la couleur et la langue pr\xe9f\xe9r\xe9es de l'utilisateur.",
    field_connectors: "Connecteurs sociaux",
    field_sso_connectors: "Connexions d'entreprise",
    custom_data_invalid: "Les donn\xe9es personnalis\xe9es doivent \xeatre un objet JSON valide.",
    connectors: {
        connectors: "Connecteurs",
        user_id: "ID utilisateur",
        remove: "Supprimer",
        connected: "Cet utilisateur est connect\xe9 \xe0 plusieurs connecteurs sociaux.",
        not_connected: "L'utilisateur n'est connect\xe9 \xe0 aucun connecteur social.",
        deletion_confirmation: "Vous supprimez l'identit\xe9 existante <name/>. \xcates-vous s\xfbr de vouloir continuer ?"
    },
    sso_connectors: {
        connectors: "Connecteurs",
        enterprise_id: "ID de l'entreprise",
        connected: "Cet utilisateur est connect\xe9 \xe0 plusieurs fournisseurs d'identit\xe9 d'entreprise pour l'authentification unique.",
        not_connected: "L'utilisateur n'est connect\xe9 \xe0 aucun fournisseur d'identit\xe9 d'entreprise pour l'authentification unique."
    },
    mfa: {
        field_name: "Authentification \xe0 deux facteurs",
        field_description: "Cet utilisateur a activ\xe9 des facteurs d'authentification \xe0 2 \xe9tapes.",
        name_column: "Authentification \xe0 deux facteurs",
        field_description_empty: "Cet utilisateur n'a pas activ\xe9 les facteurs d'authentification \xe0 deux \xe9tapes.",
        deletion_confirmation: "Vous supprimez l'existence actuelle de <name/> pour la v\xe9rification en deux \xe9tapes. \xcates-vous s\xfbr(e) de vouloir continuer?"
    },
    suspended: "Suspendu",
    suspend_user: "Suspendre l'utilisateur",
    suspend_user_reminder: "\xcates-vous s\xfbr de vouloir suspendre cet utilisateur ? L'utilisateur ne pourra pas se connecter \xe0 votre application et ne pourra pas obtenir de nouveau jeton d'acc\xe8s apr\xe8s l'expiration de celui en cours. En outre, toutes les demandes d'API effectu\xe9es par cet utilisateur \xe9choueront.",
    suspend_action: "Suspendre",
    user_suspended: "L'utilisateur a \xe9t\xe9 suspendu.",
    reactivate_user: "R\xe9activer l'utilisateur",
    reactivate_user_reminder: "\xcates-vous s\xfbr de vouloir r\xe9activer cet utilisateur ? Cela permettra toute tentative de connexion pour cet utilisateur.",
    reactivate_action: "R\xe9activer",
    user_reactivated: "L'utilisateur a \xe9t\xe9 r\xe9activ\xe9.",
    roles: {
        name_column: "R\xf4le",
        description_column: "Description",
        assign_button: "Attribuer des r\xf4les",
        delete_description: "Cette action supprimera ce r\xf4le de cet utilisateur. Le r\xf4le lui-m\xeame existera toujours, mais il ne sera plus associ\xe9 \xe0 cet utilisateur.",
        deleted: "{{name}} a \xe9t\xe9 retir\xe9 de cet utilisateur.",
        assign_title: "Attribuer des r\xf4les \xe0 {{name}}",
        assign_subtitle: "Autoriser {{name}} un ou plusieurs r\xf4les",
        assign_role_field: "Attribuer des r\xf4les",
        role_search_placeholder: "Recherche par nom de r\xf4le",
        added_text: "{{value, number}} ajout\xe9",
        assigned_user_count: "{{value, number}} utilisateurs",
        confirm_assign: "Attribuer des r\xf4les",
        role_assigned: "R\xf4le(s) attribu\xe9(s) avec succ\xe8s",
        search: "Recherche par nom de r\xf4le, description ou ID",
        empty: "Aucun r\xf4le disponible"
    },
    warning_no_sign_in_identifier: "L'utilisateur doit avoir au moins l'un des identifiants de connexion (nom d'utilisateur, e-mail, num\xe9ro de t\xe9l\xe9phone ou compte social) pour se connecter. \xcates-vous s\xfbr(e) de vouloir continuer?",
    organization_roles_tooltip: "Les r\xf4les attribu\xe9s \xe0 l'utilisateur au sein de cette organisation."
};
var $55c1b479e513d547$export$2e2bcd8739ae039 = Object.freeze($55c1b479e513d547$var$user_details);


const $8cadeed27523d29c$var$users = {
    page_title: "Gestion des utilisateurs",
    title: "Gestion des utilisateurs",
    subtitle: "G\xe9rer les identit\xe9s des utilisateurs, y compris la cr\xe9ation d'utilisateurs, la modification des informations sur les utilisateurs, la consultation des journaux des utilisateurs, la r\xe9initialisation des mots de passe et la suppression des utilisateurs.",
    create: "Ajouter un utilisateur",
    create_subtitle: "Fournir au moins l'un des champs suivants pour continuer.",
    error_missing_identifier: "Vous devez saisir au moins un identifiant pour cr\xe9er un utilisateur.",
    user_name: "Utilisateur",
    application_name: "De l'application",
    latest_sign_in: "Derni\xe8re connexion",
    create_form_username: "Nom d'utilisateur",
    create_form_password: "Mot de passe",
    create_form_name: "Nom complet",
    placeholder_name: "Monsieur/Madame Dupont",
    placeholder_email: "mdupont@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+33 1 23 45 67 89",
    unnamed: "Sans nom",
    search: "Rechercher par nom, email, t\xe9l\xe9phone ou nom d'utilisateur",
    check_user_detail: "V\xe9rifier les d\xe9tails de l'utilisateur",
    placeholder_title: "Gestion des utilisateurs",
    placeholder_description: "Chaque utilisateur a un profil contenant toutes les informations sur l'utilisateur. Il est compos\xe9 de donn\xe9es de base, d'identit\xe9s sociales et de donn\xe9es personnalis\xe9es."
};
var $8cadeed27523d29c$export$2e2bcd8739ae039 = Object.freeze($8cadeed27523d29c$var$users);


const $9275313e4a8ffd95$var$webhook_details = {
    page_title: "D\xe9tails du webhook",
    back_to_webhooks: "Retour aux webhooks",
    not_in_use: "Pas en cours d'utilisation",
    success_rate: "Taux de r\xe9ussite",
    requests: "{{value, number}} requ\xeates en 24h",
    disable_webhook: "D\xe9sactiver le webhook",
    disable_reminder: "\xcates-vous s\xfbr de vouloir r\xe9activer ce webhook? Ceci n'enverra pas de requ\xeate HTTP \xe0 l'URL de l'endpoint.",
    webhook_disabled: "Le webhook a \xe9t\xe9 d\xe9sactiv\xe9.",
    webhook_reactivated: "Le webhook a \xe9t\xe9 r\xe9activ\xe9.",
    reactivate_webhook: "R\xe9activer le webhook",
    delete_webhook: "Supprimer le webhook",
    deletion_reminder: "Vous \xeates en train de supprimer ce webhook. Apr\xe8s suppression, il n'enverra plus de requ\xeate HTTP \xe0 l'endpoint URL.",
    deleted: "Le webhook a \xe9t\xe9 supprim\xe9 avec succ\xe8s.",
    settings_tab: "Param\xe8tres",
    recent_requests_tab: "Demandes r\xe9centes (24 h)",
    settings: {
        settings: "Param\xe8tres",
        settings_description: "Les webhooks vous permettent de recevoir des mises \xe0 jour en temps r\xe9el sur des \xe9v\xe9nements sp\xe9cifiques, en envoyant une requ\xeate POST \xe0 l'URL de votre endpoint. Cela vous permet de prendre des actions imm\xe9diatement en fonction des nouvelles informations re\xe7ues.",
        events: "\xc9v\xe9nements",
        events_description: "S\xe9lectionnez les \xe9v\xe9nements d\xe9clencheurs que Logto enverra la requ\xeate POST.",
        name: "Nom",
        endpoint_url: "URL de l'endpoint",
        signing_key: "Cl\xe9 de signature",
        signing_key_tip: "Ajoutez la cl\xe9 secr\xe8te fournie par Logto \xe0 votre endpoint en tant qu'en-t\xeate de requ\xeate pour garantir l'authenticit\xe9 de la charge utile du webhook.",
        regenerate: "R\xe9g\xe9n\xe9rer",
        regenerate_key_title: "R\xe9g\xe9n\xe9rer la cl\xe9 de signature",
        regenerate_key_reminder: "\xcates-vous s\xfbr de vouloir modifier la cl\xe9 de signature? La r\xe9g\xe9n\xe9ration sera effective imm\xe9diatement. N'oubliez pas de modifier la cl\xe9 de signature synchroniquement dans votre endpoint.",
        regenerated: "La cl\xe9 de signature a \xe9t\xe9 r\xe9g\xe9n\xe9r\xe9e.",
        custom_headers: "En-t\xeates personnalis\xe9s",
        custom_headers_tip: "Optionnellement, vous pouvez ajouter des en-t\xeates personnalis\xe9s \xe0 la charge utile du webhook pour fournir un contexte ou des m\xe9tadonn\xe9es suppl\xe9mentaires sur l'\xe9v\xe9nement.",
        key_duplicated_error: "Les cl\xe9s ne peuvent pas se r\xe9p\xe9ter.",
        key_missing_error: "La cl\xe9 est requise.",
        value_missing_error: "La valeur est requise.",
        invalid_key_error: "Cl\xe9 invalide",
        invalid_value_error: "La valeur est invalide",
        test: "Tester",
        test_webhook: "Tester votre webhook",
        test_webhook_description: "Configurez le webhook, et testez-le avec des exemples de payload pour chaque \xe9v\xe9nement s\xe9lectionn\xe9 pour v\xe9rifier la r\xe9ception et le traitement corrects.",
        send_test_payload: "Envoyer une charge utile de test",
        test_result: {
            endpoint_url: "URL du point de terminaison : {{url}}",
            message: "Message : {{message}}",
            response_status: "Statut de la r\xe9ponse : {{status, number}}",
            response_body: "Corps de la r\xe9ponse : {{body}}",
            request_time: "Temps de la demande : {{time}}",
            test_success: "Le test du webhook vers le point de terminaison a r\xe9ussi."
        }
    }
};
var $9275313e4a8ffd95$export$2e2bcd8739ae039 = Object.freeze($9275313e4a8ffd95$var$webhook_details);


const $256c079cae7e359c$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Cr\xe9ez des webhooks pour recevoir sans effort des mises \xe0 jour en temps r\xe9el concernant des \xe9v\xe9nements sp\xe9cifiques.",
    create: "Cr\xe9er un webhook",
    events: {
        post_register: "Nouveau compte cr\xe9\xe9",
        post_sign_in: "Connectez-vous",
        post_reset_password: "R\xe9initialiser le mot de passe"
    },
    table: {
        name: "Nom",
        events: "\xc9v\xe9nements",
        success_rate: "Taux de r\xe9ussite (24 h)",
        requests: "Demandes (24 h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Cr\xe9ez un webhook pour recevoir des mises \xe0 jour en temps r\xe9el via des demandes POST vers l\'URL de votre point de terminaison. Restez inform\xe9 et agissez imm\xe9diatement sur des \xe9v\xe9nements tels que "Cr\xe9er un compte", "Se connecter" et "R\xe9initialiser le mot de passe".',
        create_webhook: "Cr\xe9er un webhook"
    },
    create_form: {
        title: "Cr\xe9er un webhook",
        subtitle: "Ajoutez le webhook pour envoyer une demande POST \xe0 l'URL de point de terminaison avec les d\xe9tails de tous les \xe9v\xe9nements des utilisateurs.",
        events: "\xc9v\xe9nements",
        events_description: "S\xe9lectionnez les \xe9v\xe9nements de d\xe9clenchement que Logto enverra la demande POST.",
        name: "Nom",
        name_placeholder: "Entrez le nom du webhook",
        endpoint_url: "URL du point d'extr\xe9mit\xe9",
        endpoint_url_placeholder: "https://votre.url.de.webhook.point.de.terminaison",
        endpoint_url_tip: "Entrez l'URL de votre point de terminaison o\xf9 la charge utile d'un webhook est envoy\xe9e lorsque l'\xe9v\xe9nement se produit.",
        create_webhook: "Cr\xe9er un webhook",
        missing_event_error: "Vous devez s\xe9lectionner au moins un \xe9v\xe9nement."
    },
    webhook_created: "Le webhook {{name}} a \xe9t\xe9 cr\xe9\xe9 avec succ\xe8s."
};
var $256c079cae7e359c$export$2e2bcd8739ae039 = Object.freeze($256c079cae7e359c$var$webhooks);


const $bfee1568e494e94d$var$welcome = {
    title: "Bienvenue dans la console d'administration",
    description: "La console d'administration est une application web qui permet de g\xe9rer Logto sans avoir \xe0 coder. Commen\xe7ons par cr\xe9er un compte. Avec ce compte, vous pouvez g\xe9rer Logto par vous-m\xeame ou au nom de votre entreprise.",
    create_account: "Cr\xe9er un compte"
};
var $bfee1568e494e94d$export$2e2bcd8739ae039 = Object.freeze($bfee1568e494e94d$var$welcome);


const $7ae7136ca0b03aa8$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $7884006d210c1b37$export$2e2bcd8739ae039,
    general: $9337b88bb951506c$export$2e2bcd8739ae039,
    errors: $652c1f8be71ef158$export$2e2bcd8739ae039,
    tab_sections: $7f7c46f4598c4e91$export$2e2bcd8739ae039,
    tabs: $014e4e2d09d9f98d$export$2e2bcd8739ae039,
    applications: $7d9dc4fa0e95e474$export$2e2bcd8739ae039,
    application_details: $c6be8e712959bde1$export$2e2bcd8739ae039,
    api_resources: $d6275fd7f980a28a$export$2e2bcd8739ae039,
    api_resource_details: $e3d8a53e4f32ffe7$export$2e2bcd8739ae039,
    connectors: $b7dfc5fe65bc5321$export$2e2bcd8739ae039,
    connector_details: $1ab163289efd9414$export$2e2bcd8739ae039,
    enterprise_sso: $5d05dff1c0545568$export$2e2bcd8739ae039,
    enterprise_sso_details: $4c9222d6f23cc6cf$export$2e2bcd8739ae039,
    get_started: $0a0b38956272cc74$export$2e2bcd8739ae039,
    users: $8cadeed27523d29c$export$2e2bcd8739ae039,
    user_details: $55c1b479e513d547$export$2e2bcd8739ae039,
    contact: $b075caddcc09bd33$export$2e2bcd8739ae039,
    sign_in_exp: $8e91be09d42322db$export$2e2bcd8739ae039,
    dashboard: $2f7d022b62b12639$export$2e2bcd8739ae039,
    logs: $9853e561c010d94b$export$2e2bcd8739ae039,
    log_details: $e0237a95edf65515$export$2e2bcd8739ae039,
    session_expired: $9176c1042728af82$export$2e2bcd8739ae039,
    welcome: $bfee1568e494e94d$export$2e2bcd8739ae039,
    roles: $50f2375183879097$export$2e2bcd8739ae039,
    role_details: $51175e17b49d0679$export$2e2bcd8739ae039,
    permissions: $00f7dbb6771d90dc$export$2e2bcd8739ae039,
    cloud: $8627726e7afcb100$export$2e2bcd8739ae039,
    profile: $9b6981005c13ffd3$export$2e2bcd8739ae039,
    components: $c525ec7e710d036a$export$2e2bcd8739ae039,
    webhooks: $256c079cae7e359c$export$2e2bcd8739ae039,
    webhook_details: $9275313e4a8ffd95$export$2e2bcd8739ae039,
    domain: $86234e256521fe2f$export$2e2bcd8739ae039,
    tenants: $128980e8e63a1173$export$2e2bcd8739ae039,
    topbar: $3a5c96b01517a0b9$export$2e2bcd8739ae039,
    subscription: $0b79d3399c5cf982$export$2e2bcd8739ae039,
    upsell: $7a49881200461f1e$export$2e2bcd8739ae039,
    guide: $ccdfeb1b66537c94$export$2e2bcd8739ae039,
    mfa: $f35b80bef8cb569c$export$2e2bcd8739ae039,
    organizations: $16879836bc979bef$export$2e2bcd8739ae039,
    organization_details: $225ccb879b57ba88$export$2e2bcd8739ae039
};
var $7ae7136ca0b03aa8$export$2e2bcd8739ae039 = Object.freeze($7ae7136ca0b03aa8$var$admin_console);


const $f699d603ec3a34b1$var$demo_app = {
    title: "Vous vous \xeates connect\xe9 avec succ\xe8s \xe0 l'aper\xe7u en direct !",
    subtitle: "Voici vos informations de connexion :",
    username: "Nom d'utilisateur :",
    user_id: "ID de l'utilisateur :",
    sign_out: "Se d\xe9connecter de l'aper\xe7u en direct",
    continue_explore: "Ou continuer \xe0 explorer",
    customize_sign_in_experience: "Personnaliser l'exp\xe9rience de connexion",
    enable_passwordless: "Activer la connexion sans mot de passe",
    add_social_connector: "Ajouter un connecteur social"
};
var $f699d603ec3a34b1$export$2e2bcd8739ae039 = Object.freeze($f699d603ec3a34b1$var$demo_app);


const $52899ea5f7764972$var$oidc = {
    logout_success: "Vous vous \xeates d\xe9connect\xe9 avec succ\xe8s."
};
var $52899ea5f7764972$export$2e2bcd8739ae039 = Object.freeze($52899ea5f7764972$var$oidc);


const $0db831216032e3a1$var$translation = {
    admin_console: $7ae7136ca0b03aa8$export$2e2bcd8739ae039,
    demo_app: $f699d603ec3a34b1$export$2e2bcd8739ae039,
    oidc: $52899ea5f7764972$export$2e2bcd8739ae039
};
var $0db831216032e3a1$export$2e2bcd8739ae039 = Object.freeze($0db831216032e3a1$var$translation);


const $0103c56b907ff28f$var$fr = {
    translation: $0db831216032e3a1$export$2e2bcd8739ae039,
    errors: $8129039b642ada78$export$2e2bcd8739ae039
};
var $0103c56b907ff28f$export$2e2bcd8739ae039 = Object.freeze($0103c56b907ff28f$var$fr);


const $dcad96cb8b56c7ba$var$application = {
    invalid_type: "Solo le applicazioni da macchina a macchina possono avere ruoli associati.",
    role_exists: "L'ID ruolo {{roleId}} \xe8 gi\xe0 stato aggiunto a questa applicazione.",
    invalid_role_type: "Impossibile assegnare un ruolo di tipo utente all'applicazione da macchina a macchina."
};
var $dcad96cb8b56c7ba$export$2e2bcd8739ae039 = Object.freeze($dcad96cb8b56c7ba$var$application);


const $f2a07ae1ae456669$var$auth = {
    authorization_header_missing: "Header Autorizzazione mancante.",
    authorization_token_type_not_supported: "Tipo di autorizzazione non supportato.",
    unauthorized: "Non autorizzato. Controlla le credenziali e il loro ambito.",
    forbidden: "Vietato. Controlla i ruoli e le autorizzazioni dell'utente.",
    expected_role_not_found: "Ruolo atteso non trovato. Controlla i ruoli e le autorizzazioni dell'utente.",
    jwt_sub_missing: "Manca il valore `sub` in JWT.",
    require_re_authentication: "\xc8 necessaria una nuova autenticazione per eseguire un'azione protetta."
};
var $f2a07ae1ae456669$export$2e2bcd8739ae039 = Object.freeze($f2a07ae1ae456669$var$auth);


const $518a8c6eb9ce6679$var$connector = {
    general: "Si \xe8 verificato un errore nel connettore: {{errorDescription}}",
    not_found: "Impossibile trovare un connettore disponibile per il tipo: {{type}}.",
    not_enabled: "Il connettore non \xe8 abilitato.",
    invalid_metadata: "I metadati del connettore non sono validi.",
    invalid_config_guard: "La guardia di configurazione del connettore non \xe8 valida.",
    unexpected_type: "Il tipo di connettore \xe8 inaspettato.",
    invalid_request_parameters: "La richiesta contiene parametri di input errati.",
    insufficient_request_parameters: "La richiesta potrebbe mancare di alcuni parametri di input.",
    invalid_config: "La configurazione del connettore non \xe8 valida.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "La risposta del connettore non \xe8 valida.",
    template_not_found: "Impossibile trovare il modello corretto nella configurazione del connettore.",
    template_not_supported: "Il connettore non supporta questo tipo di modello.",
    rate_limit_exceeded: "Limite di frequenza attivata. Riprova pi\xf9 tardi.",
    not_implemented: "{{method}}: non \xe8 stato ancora implementato.",
    social_invalid_access_token: "Il token di accesso del connettore non \xe8 valido.",
    invalid_auth_code: "Il codice di autenticazione del connettore non \xe8 valido.",
    social_invalid_id_token: "Il token ID del connettore non \xe8 valido.",
    authorization_failed: "Il processo di autorizzazione dell'utente non \xe8 riuscito.",
    social_auth_code_invalid: "Impossibile ottenere il token di accesso, controllare il codice di autorizzazione.",
    more_than_one_sms: "Il numero di connettori SMS \xe8 maggiore di 1.",
    more_than_one_email: "Il numero di connettori email \xe8 maggiore di 1.",
    more_than_one_connector_factory: "Trovate pi\xf9 fabbriche di connettori (con id {{connectorIds}}), \xe8 possibile disinstallare quelle non necessarie.",
    db_connector_type_mismatch: "C'\xe8 un connettore nel DB che non corrisponde al tipo.",
    not_found_with_connector_id: "Impossibile trovare il connettore con l'id connettore standard fornito.",
    multiple_instances_not_supported: "Non \xe8 possibile creare pi\xf9 di un'istanza con il connettore standard selezionato.",
    invalid_type_for_syncing_profile: "\xc8 possibile sincronizzare solo il profilo utente con i connettori social.",
    can_not_modify_target: "Non \xe8 possibile modificare il 'target' del connettore.",
    should_specify_target: "Si dovrebbe specificare il 'target'.",
    multiple_target_with_same_platform: "Non \xe8 possibile avere pi\xf9 connettori social con lo stesso target e piattaforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "I 'metadati' di questo connettore non possono essere sovrascritti."
};
var $518a8c6eb9ce6679$export$2e2bcd8739ae039 = Object.freeze($518a8c6eb9ce6679$var$connector);


const $85d24e49314ee781$var$domain = {
    not_configured: "Il fornitore del nome di dominio dell'host non \xe8 configurato.",
    cloudflare_data_missing: "Dati cloudflare mancanti, per favore verificare.",
    cloudflare_unknown_error: "Errore sconosciuto durante la richiesta di API Cloudflare",
    cloudflare_response_error: "Ricevuta una risposta non prevista da Cloudflare.",
    limit_to_one_domain: "Puoi avere solo un dominio personalizzato.",
    hostname_already_exists: "Questo dominio esiste gi\xe0 nel nostro server.",
    cloudflare_not_found: "Impossibile trovare il nome host in Cloudflare."
};
var $85d24e49314ee781$export$2e2bcd8739ae039 = Object.freeze($85d24e49314ee781$var$domain);


const $7046d7b2712e68a3$var$entity = {
    invalid_input: "Input non valido. La lista dei valori non deve essere vuota.",
    create_failed: "Impossibile creare {{name}}.",
    db_constraint_violated: "Vincolo del database violato.",
    not_exists: "{{name}} non esiste.",
    not_exists_with_id: "{{name}} con ID `{{id}}` non esiste.",
    not_found: "La risorsa non esiste.",
    relation_foreign_key_not_found: "Impossibile trovare una o pi\xf9 chiavi esterne. Si prega di controllare l'input e assicurarsi che tutte le entit\xe0 referenziate esistano.",
    unique_integrity_violation: "L'entit\xe0 esiste gi\xe0. Si prega di controllare l'input e riprovare."
};
var $7046d7b2712e68a3$export$2e2bcd8739ae039 = Object.freeze($7046d7b2712e68a3$var$entity);


const $923a551990ab82f3$var$guard = {
    invalid_input: "La richiesta {{type}} non \xe8 valida.",
    invalid_pagination: "Il valore di paginazione della richiesta non \xe8 valido.",
    can_not_get_tenant_id: "Impossibile ottenere l'ID dell'inquilino dalla richiesta.",
    file_size_exceeded: "Dimensione del file superata.",
    mime_type_not_allowed: "Il tipo MIME non \xe8 consentito."
};
var $923a551990ab82f3$export$2e2bcd8739ae039 = Object.freeze($923a551990ab82f3$var$guard);


const $439bb85fdb01977d$var$hook = {
    missing_events: "\xc8 necessario fornire almeno un evento.",
    send_test_payload_failed: "Impossibile inviare il payload di prova: {{message}}",
    endpoint_responded_with_error: "Il punto di accesso ha risposto con un errore."
};
var $439bb85fdb01977d$export$2e2bcd8739ae039 = Object.freeze($439bb85fdb01977d$var$hook);


const $8b6ceb39361228c3$var$localization = {
    cannot_delete_default_language: "{{languageTag}} \xe8 impostato come la tua lingua predefinita e non pu\xf2 essere eliminato.",
    invalid_translation_structure: "Schemi di dati non validi. Controlla l'input e riprova."
};
var $8b6ceb39361228c3$export$2e2bcd8739ae039 = Object.freeze($8b6ceb39361228c3$var$localization);


const $b7cab17d87a2785b$var$log = {
    invalid_type: "Il tipo di registro non \xe8 valido."
};
var $b7cab17d87a2785b$export$2e2bcd8739ae039 = Object.freeze($b7cab17d87a2785b$var$log);


const $43dddfa38367fd32$var$oidc = {
    aborted: "L'utente finale ha annullato l'interazione.",
    invalid_scope: "Ambito non valido: {{error_description}}.",
    invalid_token: "Token non valido fornito.",
    invalid_client_metadata: "Metadata client non valide fornite.",
    insufficient_scope: "Token mancante dell'ambito `{{scope}}`.",
    invalid_request: "La richiesta non \xe8 valida.",
    invalid_grant: "La richiesta di concessione non \xe8 valida.",
    invalid_redirect_uri: "`redirect_uri` non corrisponde a nessuno dei `redirect_uris` registrati dal client.",
    access_denied: "Accesso negato.",
    invalid_target: "Indicatore di risorsa non valido.",
    unsupported_grant_type: "Tipo di `grant_type` richiesto non supportato.",
    unsupported_response_mode: "Modalit\xe0 di risposta `response_mode` richiesta non supportata.",
    unsupported_response_type: "Tipo di risposta `response_type` richiesto non supportato.",
    provider_error: "Errore interno OIDC: {{message}}.",
    server_error: "Si \xe8 verificato un errore OIDC sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    provider_error_fallback: "Si \xe8 verificato un errore OIDC: {{code}}.",
    key_required: "\xc8 richiesta almeno una chiave.",
    key_not_found: "Chiave con ID {{id}} non trovata."
};
var $43dddfa38367fd32$export$2e2bcd8739ae039 = Object.freeze($43dddfa38367fd32$var$oidc);


const $f9a7b5955ced72a5$var$organization = {
    require_membership: "L'utente deve essere un membro dell'organizzazione per procedere."
};
var $f9a7b5955ced72a5$export$2e2bcd8739ae039 = Object.freeze($f9a7b5955ced72a5$var$organization);


const $730cd3597181714b$var$password = {
    unsupported_encryption_method: "Il metodo di crittografia {{name}} non \xe8 supportato.",
    pepper_not_found: "Pepper password non trovato. Per favore controlla le tue env di core.",
    rejected: "La password \xe8 stata rifiutata. Per favore verifica se la tua password soddisfa i requisiti."
};
var $730cd3597181714b$export$2e2bcd8739ae039 = Object.freeze($730cd3597181714b$var$password);


const $eddcd180f3cb8bb7$var$request = {
    invalid_input: "L'input non \xe8 valido. {{details}}",
    general: "Si \xe8 verificato un errore nella richiesta."
};
var $eddcd180f3cb8bb7$export$2e2bcd8739ae039 = Object.freeze($eddcd180f3cb8bb7$var$request);


const $f86ed9b18d91f398$var$resource = {
    resource_identifier_in_use: "L'identificatore API {{indicator}} \xe8 gi\xe0 in uso"
};
var $f86ed9b18d91f398$export$2e2bcd8739ae039 = Object.freeze($f86ed9b18d91f398$var$resource);


const $f3d80c7761656410$var$role = {
    name_in_use: "Il nome di ruolo {{name}} \xe8 gi\xe0 in uso",
    scope_exists: "L'identificatore di ambito {{scopeId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    user_exists: "L'identificatore di utente {{userId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    application_exists: "L'ID dell'applicazione {{applicationId}} \xe8 gi\xe0 stato aggiunto a questo ruolo",
    default_role_missing: "Alcuni dei nomi di ruolo predefiniti non esistono nel database, assicurati di creare prima i ruoli",
    internal_role_violation: 'Potresti cercare di aggiornare o eliminare un ruolo interno che \xe8 vietato da Logto. Se stai creando un nuovo ruolo, prova un altro nome che non inizi con "#internal:". '
};
var $f3d80c7761656410$export$2e2bcd8739ae039 = Object.freeze($f3d80c7761656410$var$role);


const $d6d37810da6448d7$var$scope = {
    name_exists: "Il nome dello scope {{name}} \xe8 gi\xe0 in uso",
    name_with_space: "Il nome dello scope non pu\xf2 contenere spazi."
};
var $d6d37810da6448d7$export$2e2bcd8739ae039 = Object.freeze($d6d37810da6448d7$var$scope);


const $5ecdd2464ef73665$var$session = {
    not_found: "Sessione non trovata. Torna indietro e accedi nuovamente.",
    invalid_credentials: "Account o password non corretti. Controlla le tue credenziali.",
    invalid_sign_in_method: "Metodo di accesso corrente non disponibile.",
    invalid_connector_id: "Impossibile trovare un connettore disponibile con ID {{connectorId}}.",
    insufficient_info: "Informazioni di accesso insufficienti.",
    connector_id_mismatch: "L'ID del connettore non corrisponde con il record della sessione.",
    connector_session_not_found: "Sessione del connettore non trovata. Torna indietro e accedi nuovamente.",
    verification_session_not_found: "La verifica non \xe8 stata completata con successo. Riavvia il processo di verifica e riprova.",
    verification_expired: "La connessione \xe8 scaduta. Verifica di nuovo per garantire la sicurezza del tuo account.",
    verification_blocked_too_many_attempts: "Troppi tentativi in poco tempo. Si prega di riprovare {{relativeTime}}.",
    unauthorized: "Accedi prima di procedere.",
    unsupported_prompt_name: "Nome del prompt non supportato.",
    forgot_password_not_enabled: "Recupero password non abilitato.",
    verification_failed: "La verifica non \xe8 stata completata con successo. Riavvia il processo di verifica e riprova.",
    connector_validation_session_not_found: "Sessione del connettore per la convalida del token non trovata.",
    identifier_not_found: "Identificativo utente non trovato. Torna indietro e accedi nuovamente.",
    interaction_not_found: "Sessione di interazione non trovata. Torna indietro e avvia la sessione nuovamente.",
    not_supported_for_forgot_password: "Questa operazione non \xe8 supportata per il recupero password.",
    mfa: {
        require_mfa_verification: "La verifica MFA \xe8 richiesta per accedere.",
        mfa_sign_in_only: "MFA \xe8 disponibile solo per l'interazione di accesso.",
        pending_info_not_found: "Informazioni MFA in sospeso non trovate, si prega di avviare prima MFA.",
        invalid_totp_code: "Codice TOTP non valido.",
        webauthn_verification_failed: "Verifica WebAuthn non riuscita.",
        webauthn_verification_not_found: "Verifica WebAuthn non trovata.",
        bind_mfa_existed: "MFA esiste gi\xe0.",
        backup_code_can_not_be_alone: "Il codice di backup non pu\xf2 essere l'unica MFA.",
        backup_code_required: "Il codice di backup \xe8 richiesto.",
        invalid_backup_code: "Codice di backup non valido.",
        mfa_policy_not_user_controlled: "La politica MFA non \xe8 controllata dall'utente."
    },
    sso_enabled: "L'accesso singolo \xe8 abilitato per questa email. Accedi con SSO."
};
var $5ecdd2464ef73665$export$2e2bcd8739ae039 = Object.freeze($5ecdd2464ef73665$var$session);


const $45a9f8496bc5b4b8$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL di contenuto "Termini di utilizzo" vuoto. Si prega di aggiungere l\'URL del contenuto se "Termini di utilizzo" \xe8 abilitato.',
    empty_social_connectors: "Connettori social vuoti. Si prega di aggiungere connettori social abilitati quando il metodo di accesso social \xe8 abilitato.",
    enabled_connector_not_found: "{{type}} conettore abilitato non trovato.",
    not_one_and_only_one_primary_sign_in_method: "Deve esserci un solo metodo di accesso principale. Si prega di verificare l'input.",
    username_requires_password: "Deve abilitare impostazione di una password per l'identificatore di registrazione dell'username.",
    passwordless_requires_verify: "Deve abilitare la verifica per l'identificatore di registrazione tramite email/telefono.",
    miss_sign_up_identifier_in_sign_in: "I metodi di accesso devono contenere l'identificatore di registrazione.",
    password_sign_in_must_be_enabled: "Il metodo di accesso con password deve essere abilitato quando \xe8 richiesta la creazione di una password nella registrazione.",
    code_sign_in_must_be_enabled: "Il metodo di accesso con codice di verifica deve essere abilitato quando non \xe8 richiesta una password nella registrazione.",
    unsupported_default_language: "Questa lingua - {{language}} non \xe8 supportata al momento.",
    at_least_one_authentication_factor: "Devi selezionare almeno un fattore di autenticazione.",
    backup_code_cannot_be_enabled_alone: "Il codice di backup non pu\xf2 essere abilitato da solo.",
    duplicated_mfa_factors: "Fattori MFA duplicati."
};
var $45a9f8496bc5b4b8$export$2e2bcd8739ae039 = Object.freeze($45a9f8496bc5b4b8$var$sign_in_experiences);


const $1ad59ef51b20e951$var$single_sign_on = {
    forbidden_domains: "I domini di posta elettronica pubblica non sono consentiti.",
    duplicated_domains: "Ci sono domini duplicati.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $1ad59ef51b20e951$export$2e2bcd8739ae039 = Object.freeze($1ad59ef51b20e951$var$single_sign_on);


const $afe8d6af2f0876bc$var$storage = {
    not_configured: "Provider di archiviazione non configurato.",
    missing_parameter: "Parametro mancante {{parameter}} per il provider di archiviazione.",
    upload_error: "Impossibile caricare il file sul provider di archiviazione."
};
var $afe8d6af2f0876bc$export$2e2bcd8739ae039 = Object.freeze($afe8d6af2f0876bc$var$storage);


const $8aee0e94e7ff7f13$var$subscription = {
    limit_exceeded: "Hai raggiunto il limite del tuo piano di abbonamento.",
    get_plan_failed: "Impossibile ottenere il piano di abbonamento per l'inquilino.",
    tenant_suspended: "L'inquilino \xe8 sospeso. Si prega di contattare l'amministratore."
};
var $8aee0e94e7ff7f13$export$2e2bcd8739ae039 = Object.freeze($8aee0e94e7ff7f13$var$subscription);


const $8aab06642bbfa548$var$swagger = {
    invalid_zod_type: "Tipo Zod non valido. Controllare la configurazione di guardia del percorso.",
    not_supported_zod_type_for_params: "Tipo Zod non supportato per i parametri. Controllare la configurazione di guardia del percorso."
};
var $8aab06642bbfa548$export$2e2bcd8739ae039 = Object.freeze($8aab06642bbfa548$var$swagger);


const $a65725d39755f719$var$user = {
    username_already_in_use: "Questo nome utente \xe8 gi\xe0 in uso.",
    email_already_in_use: "Questa email \xe8 associata ad un account esistente.",
    phone_already_in_use: "Questo numero di telefono \xe8 associato ad un account esistente.",
    invalid_email: "Indirizzo email non valido.",
    invalid_phone: "Numero di telefono non valido.",
    email_not_exist: "L'indirizzo email non \xe8 stato ancora registrato.",
    phone_not_exist: "Il numero di telefono non \xe8 stato ancora registrato.",
    identity_not_exist: "L'account social non \xe8 stato ancora registrato.",
    identity_already_in_use: "L'account social \xe8 stato associato ad un account esistente.",
    social_account_exists_in_profile: "Hai gi\xe0 associato questo account social.",
    cannot_delete_self: "Non puoi eliminarti da solo.",
    sign_up_method_not_enabled: "Questo metodo di registrazione non \xe8 abilitato.",
    sign_in_method_not_enabled: "Questo metodo di accesso non \xe8 abilitato.",
    same_password: "La nuova password non pu\xf2 essere uguale alla vecchia password.",
    password_required_in_profile: "\xc8 necessario impostare una password prima di accedere.",
    new_password_required_in_profile: "\xc8 necessario impostare una nuova password.",
    password_exists_in_profile: "La password esiste gi\xe0 nel tuo profilo.",
    username_required_in_profile: "\xc8 necessario impostare un nome utente prima di accedere.",
    username_exists_in_profile: "Il nome utente esiste gi\xe0 nel tuo profilo.",
    email_required_in_profile: "\xc8 necessario aggiungere un'indirizzo email prima di accedere.",
    email_exists_in_profile: "Il tuo profilo \xe8 gi\xe0 associato ad un indirizzo email.",
    phone_required_in_profile: "\xc8 necessario aggiungere un numero di telefono prima di accedere.",
    phone_exists_in_profile: "Il tuo profilo \xe8 gi\xe0 associato ad un numero di telefono.",
    email_or_phone_required_in_profile: "\xc8 necessario aggiungere un indirizzo email o un numero di telefono prima di accedere.",
    suspended: "Questo account \xe8 stato sospeso.",
    user_not_exist: "L'utente con {{ identifier }} non esiste.",
    missing_profile: "\xc8 necessario fornire informazioni aggiuntive prima di accedere.",
    role_exists: "L'ID ruolo {{roleId}} \xe8 gi\xe0 stato aggiunto a questo utente",
    invalid_role_type: "Tipo di ruolo non valido, non \xe8 possibile assegnare un ruolo da macchina a utente.",
    missing_mfa: "Devi legare un'ulteriore MFA prima di accedere.",
    totp_already_in_use: "TOTP \xe8 gi\xe0 in uso.",
    backup_code_already_in_use: "Il codice di backup \xe8 gi\xe0 in uso."
};
var $a65725d39755f719$export$2e2bcd8739ae039 = Object.freeze($a65725d39755f719$var$user);


const $b2b885dc1f61ed7d$var$verification_code = {
    phone_email_empty: "Entrambi il telefono e l'e-mail sono vuoti.",
    not_found: "Codice di verifica non trovato. Si prega di inviare il codice di verifica per primo.",
    phone_mismatch: "Telefono non corrispondente. Si prega di richiedere un nuovo codice di verifica.",
    email_mismatch: "Email non corrispondente. Si prega di richiedere un nuovo codice di verifica.",
    code_mismatch: "Codice di verifica non valido.",
    expired: "Il codice di verifica \xe8 scaduto. Si prega di richiedere un nuovo codice di verifica.",
    exceed_max_try: "Superata la limitazione dei tentativi di codice di verifica. Si prega di richiedere un nuovo codice di verifica."
};
var $b2b885dc1f61ed7d$export$2e2bcd8739ae039 = Object.freeze($b2b885dc1f61ed7d$var$verification_code);


const $dfae08e084420d69$var$errors = {
    request: $eddcd180f3cb8bb7$export$2e2bcd8739ae039,
    auth: $f2a07ae1ae456669$export$2e2bcd8739ae039,
    guard: $923a551990ab82f3$export$2e2bcd8739ae039,
    oidc: $43dddfa38367fd32$export$2e2bcd8739ae039,
    user: $a65725d39755f719$export$2e2bcd8739ae039,
    password: $730cd3597181714b$export$2e2bcd8739ae039,
    session: $5ecdd2464ef73665$export$2e2bcd8739ae039,
    connector: $518a8c6eb9ce6679$export$2e2bcd8739ae039,
    verification_code: $b2b885dc1f61ed7d$export$2e2bcd8739ae039,
    sign_in_experiences: $45a9f8496bc5b4b8$export$2e2bcd8739ae039,
    localization: $8b6ceb39361228c3$export$2e2bcd8739ae039,
    swagger: $8aab06642bbfa548$export$2e2bcd8739ae039,
    entity: $7046d7b2712e68a3$export$2e2bcd8739ae039,
    log: $b7cab17d87a2785b$export$2e2bcd8739ae039,
    role: $f3d80c7761656410$export$2e2bcd8739ae039,
    scope: $d6d37810da6448d7$export$2e2bcd8739ae039,
    storage: $afe8d6af2f0876bc$export$2e2bcd8739ae039,
    resource: $f86ed9b18d91f398$export$2e2bcd8739ae039,
    hook: $439bb85fdb01977d$export$2e2bcd8739ae039,
    domain: $85d24e49314ee781$export$2e2bcd8739ae039,
    subscription: $8aee0e94e7ff7f13$export$2e2bcd8739ae039,
    application: $dcad96cb8b56c7ba$export$2e2bcd8739ae039,
    organization: $f9a7b5955ced72a5$export$2e2bcd8739ae039,
    single_sign_on: $1ad59ef51b20e951$export$2e2bcd8739ae039
};
var $dfae08e084420d69$export$2e2bcd8739ae039 = Object.freeze($dfae08e084420d69$var$errors);


const $ddcbe6775979aa76$var$api_resource_details = {
    page_title: "Dettagli delle risorse API",
    back_to_api_resources: "Torna alle risorse API",
    settings_tab: "Impostazioni",
    permissions_tab: "Autorizzazioni",
    settings: "Impostazioni",
    settings_description: "Le risorse API, anche note come Indicatori di Risorse, indicano i servizi o le risorse di destinazione da richiedere, di solito una variabile di formato URI che rappresenta l'identit\xe0 della risorsa.",
    management_api_settings_description: "La Logto Management API \xe8 una raccolta completa di API che consentono agli amministratori di gestire una vasta gamma di attivit\xe0 relative all'identit\xe0, far rispettare le politiche di sicurezza e conformarsi a regolamenti e standard.",
    management_api_notice: "Questa API rappresenta l'entit\xe0 Logto e non pu\xf2 essere modificata o eliminata. Puoi utilizzare la management API per un'ampia gamma di attivit\xe0 relative all'identit\xe0. <a>Scopri di pi\xf9</a>",
    token_expiration_time_in_seconds: "Tempo di scadenza del token (in secondi)",
    token_expiration_time_in_seconds_placeholder: "Inserisci il tempo di scadenza del tuo token",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminer\xe0 definitivamente la risorsa API. Per favore, inserisci il nome della risorsa api <span>{{name}}</span> per confermare.",
    enter_your_api_resource_name: "Inserisci il nome della tua risorsa API",
    api_resource_deleted: "La risorsa API {{name}} \xe8 stata eliminata con successo",
    permission: {
        create_button: "Crea autorizzazione",
        create_title: "crea autorizzazione",
        create_subtitle: "Definire le autorizzazioni (ambiti) necessarie per questa API.",
        confirm_create: "Crea autorizzazione",
        name: "Nome autorizzazione",
        name_placeholder: "lettura:risorsa",
        forbidden_space_in_name: "Il nome dell'autorizzazione non deve contenere spazi.",
        description: "Descrizione",
        description_placeholder: "In grado di leggere le risorse",
        permission_created: "L'autorizzazione {{name}} \xe8 stata creata con successo",
        delete_description: "Se questa autorizzazione viene eliminata, l'utente che aveva questa autorizzazione perder\xe0 l'accesso concessogli tramite di essa.",
        deleted: 'L\'autorizzazione "{{name}}" \xe8 stata eliminata con successo.'
    }
};
var $ddcbe6775979aa76$export$2e2bcd8739ae039 = Object.freeze($ddcbe6775979aa76$var$api_resource_details);


const $2510f374327a4ac5$var$api_resources = {
    page_title: "Risorse API",
    title: "Risorse API",
    subtitle: "Definisci API che le tue applicazioni autorizzate possono utilizzare",
    create: "Crea risorsa API",
    api_name: "Nome API",
    api_name_placeholder: "Inserisci il nome dell'API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "L'identificatore univoco della risorsa API. Deve essere un URI assoluto e non ha componenti di frammento (#). Corrisponde al parametro <a>risorsa</a> in OAuth 2.0.",
    default_api: "API predefinita",
    default_api_label: "Solo zero o una API predefinita possono essere impostate per tenant. Quando viene designata una API predefinita, il parametro di risorsa pu\xf2 essere omesso nella richiesta di autorizzazione. Gli scambi di token successivi utilizzeranno quell API come destinatario per impostazione predefinita, con conseguente rilascio di JWT. <a>Scopri di pi\xf9</a>",
    api_resource_created: "La risorsa API {{name}} \xe8 stata creata con successo"
};
var $2510f374327a4ac5$export$2e2bcd8739ae039 = Object.freeze($2510f374327a4ac5$var$api_resources);


const $7c60798e3cec3958$var$application_details = {
    page_title: "Dettagli dell'applicazione",
    back_to_applications: "Torna alle applicazioni",
    check_guide: "Verifica guida",
    settings: "Impostazioni",
    settings_description: "Le applicazioni vengono utilizzate per identificare le tue applicazioni in Logto per OIDC, esperienza di accesso, registri di controllo, ecc.",
    advanced_settings: "Impostazioni avanzate",
    advanced_settings_description: "Le impostazioni avanzate includono termini correlati all'OIDC. Puoi consultare il Endpoint Token per ulteriori informazioni.",
    application_roles: "Ruoli",
    machine_logs: "Log delle macchine",
    application_name: "Nome dell'applicazione",
    application_name_placeholder: "La mia app",
    description: "Descrizione",
    description_placeholder: "Inserisci la descrizione della tua applicazione",
    config_endpoint: "Endpoint di configurazione OpenID Provider",
    authorization_endpoint: "Endpoint di autorizzazione",
    authorization_endpoint_tip: "L'endpoint per effettuare l'autenticazione e l'autorizzazione. Viene utilizzato per la connessione OpenID <a>autenticazione</a>.",
    logto_endpoint: "Endpoint Logto",
    application_id: "ID App",
    application_id_tip: "L'identificatore univoco dell'applicazione generato normalmente da Logto. Sta anche per \"<a>client_id</a>\" in OpenID Connect.",
    application_secret: "Secret App",
    redirect_uri: "URI di reindirizzamento",
    redirect_uris: "URI di reindirizzamento",
    redirect_uri_placeholder: "https://il-tuo-sito-web.com/la-tua-app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "Il URI di reindirizzamento dopo il login di un utente (sia riuscito che non). Vedi OpenID Connect autenticazione richiesta per ulteriori informazioni.",
    post_sign_out_redirect_uri: "URI di reindirizzamento post disconnessione",
    post_sign_out_redirect_uris: "URI di reindirizzamento post disconnessione",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "Il URI di reindirizzamento dopo la disconnessione dell'utente (facoltativo). Potrebbe non avere alcun effetto pratico in alcuni tipi di app.",
    cors_allowed_origins: "Origini consentite CORS",
    cors_allowed_origins_placeholder: "https://il-tuo-sito-web.com",
    cors_allowed_origins_tip: "Per impostazione predefinita, saranno consentite tutte le origini degli URI di reindirizzamento. Di solito non \xe8 richiesta alcuna azione per questo campo. Vedi la documentazione MDN per informazioni dettagliate.",
    token_endpoint: "Endpoint token",
    user_info_endpoint: "Endpoint informazioni utente",
    enable_admin_access: "Abilita l'accesso amministratore",
    enable_admin_access_label: "Abilita o disabilita l'accesso all'API di gestione. Una volta abilitato, puoi utilizzare i token di accesso per chiamare l'API di gestione a nome di questa applicazione.",
    always_issue_refresh_token: "Rilascia sempre il token di aggiornamento",
    always_issue_refresh_token_label: "Abilitando questa configurazione, Logto potr\xe0 rilasciare sempre token di aggiornamento, anche se `prompt=consent` non viene presentata nella richiesta di autenticazione. Tuttavia, questa pratica \xe8 scoraggiata a meno che non sia necessaria, in quanto non \xe8 compatibile con OpenID Connect e potrebbe potenzialmente causare problemi.",
    refresh_token_ttl: "Tempo di vita del token di aggiornamento in giorni",
    refresh_token_ttl_tip: "La durata per cui un token di aggiornamento pu\xf2 essere utilizzato per richiedere nuovi access token prima che scada e diventa non valido, le richieste di token estenderanno il TTL del token di aggiornamento a questo valore.",
    rotate_refresh_token: "Ruota token di aggiornamento",
    rotate_refresh_token_label: "Quando abilitato, Logto emetter\xe0 un nuovo token di aggiornamento per le richieste di token quando \xe8 passato il 70% del Tempo di vita (TTL) originale o sono soddisfatte determinate condizioni. <a>Ulteriori informazioni</a>",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminer\xe0 definitivamente l'applicazione. Inserisci il nome dell'applicazione <span>{{name}}</span> per confermare.",
    enter_your_application_name: "Inserisci il nome della tua applicazione",
    application_deleted: "L'applicazione {{name}} \xe8 stata eliminata con successo",
    redirect_uri_required: "Devi inserire almeno un URI di reindirizzamento",
    roles: {
        name_column: "Ruolo",
        description_column: "Descrizione",
        assign_button: "Assegna ruoli",
        delete_description: "Questa azione rimuover\xe0 questo ruolo da questa applicazione tra macchine. Il ruolo stesso esister\xe0 ancora, ma non sar\xe0 pi\xf9 associato a questa applicazione tra macchine.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo utente.",
        assign_title: "Assegna ruoli a {{name}}",
        assign_subtitle: "Autorizza {{name}} uno o pi\xf9 ruoli",
        assign_role_field: "Assegna ruoli",
        role_search_placeholder: "Cerca per nome ruolo",
        added_text: "{{value, number}} aggiunti",
        assigned_app_count: "{{value, number}} applicazioni",
        confirm_assign: "Assegna ruoli",
        role_assigned: "Ruolo(i) assegnato con successo",
        search: "Cerca per nome ruolo, descrizione o ID",
        empty: "Nessun ruolo disponibile"
    }
};
var $7c60798e3cec3958$export$2e2bcd8739ae039 = Object.freeze($7c60798e3cec3958$var$application_details);


const $796bed8c08c179e0$var$applications = {
    page_title: "Applicazioni",
    title: "Applicazioni",
    subtitle: "Configura l'autenticazione Logto per la tua applicazione nativa, a singola pagina, macchina-to-macchina o tradizionale",
    subtitle_with_app_type: "Configura l'autenticazione Logto per la tua applicazione {{name}}",
    create: "Crea Applicazione",
    application_name: "Nome applicazione",
    application_name_placeholder: "La mia App",
    application_description: "Descrizione applicazione",
    application_description_placeholder: "Inserisci la descrizione della tua applicazione",
    select_application_type: "Seleziona un tipo di applicazione",
    no_application_type_selected: "Non hai ancora selezionato alcun tipo di applicazione",
    application_created: "L'applicazione \xe8 stata creata con successo.",
    app_id: "App ID",
    type: {
        native: {
            title: "App Nativa",
            subtitle: "Un'applicazione che viene eseguita in un ambiente nativo",
            description: "E.g., applicazione iOS, applicazione Android"
        },
        spa: {
            title: "Applicazione a Singola Pagina",
            subtitle: "Un'applicazione che viene eseguita in un browser web e aggiorna dinamicamente i dati in maniera localizzata",
            description: "E.g., applicazione React DOM, applicazione Vue"
        },
        traditional: {
            title: "Web Tradizionale",
            subtitle: "Un'applicazione che renderizza e aggiorna le pagine solo attraverso il server web",
            description: "E.g., Next.js, PHP"
        },
        machine_to_machine: {
            title: "Macchina-to-Macchina",
            subtitle: "Un'app (solitamente un servizio) che comunica direttamente con le risorse",
            description: "E.g., servizio backend"
        }
    },
    placeholder_title: "Seleziona un tipo di applicazione per continuare",
    placeholder_description: "Logto utilizza un'entit\xe0 applicazione per OIDC per aiutarti in compiti come l'identificazione delle tue app, la gestione dell'accesso e la creazione di registri di audit."
};
var $796bed8c08c179e0$export$2e2bcd8739ae039 = Object.freeze($796bed8c08c179e0$var$applications);


const $52f1ce94db734a11$var$cloud = {
    general: {
        onboarding: "Inizio"
    },
    welcome: {
        page_title: "Benvenuto",
        title: "Benvenuto in Logto Cloud! Ci piacerebbe conoscere un po' di te.",
        description: "Facciamo diventare la tua esperienza Logto unica conoscendoti meglio. Le tue informazioni sono al sicuro con noi.",
        project_field: "Sto usando Logto per",
        project_options: {
            personal: "Progetto personale",
            company: "Progetto aziendale"
        },
        title_field: "Seleziona i titoli applicabili",
        title_options: {
            developer: "Sviluppatore",
            team_lead: "Responsabile del team",
            ceo: "CEO",
            cto: "CTO",
            product: "Prodotto",
            others: "Altro"
        },
        company_name_field: "Nome dell'azienda",
        company_name_placeholder: "Acme.co",
        company_size_field: "Dimensione dell'azienda",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Mi sto iscrivendo perch\xe9",
        reason_options: {
            passwordless: "Ricerca di autenticazione senza password e UI kit",
            efficiency: "Scoperta di infrastrutture di identit\xe0 preconfezionate",
            access_control: "Controllo dell'accesso degli utenti in base ai ruoli e alle responsabilit\xe0",
            multi_tenancy: "Ricerca di strategie per un prodotto multi-tenancy",
            enterprise: "Ricerca di soluzioni SSO per la preparazione aziendale",
            others: "Altro"
        }
    },
    sie: {
        page_title: "Personalizza l'esperienza di accesso",
        title: "Personalizziamo insieme la tua esperienza di accesso",
        inspire: {
            title: "Crea esempi coinvolgenti",
            description: 'Ti senti incerto riguardo l\'esperienza di accesso? Fai clic su "Ispirami" e lascia che la magia accada!',
            inspire_me: "Ispirami"
        },
        logo_field: "Logo dell'app",
        color_field: "Colore del brand",
        identifier_field: "Identificativo",
        identifier_options: {
            email: "Email",
            phone: "Telefono",
            user_name: "Nome utente"
        },
        authn_field: "Autenticazione",
        authn_options: {
            password: "Password",
            verification_code: "Codice di verifica"
        },
        social_field: "Accesso tramite social",
        finish_and_done: "Termina e completato",
        preview: {
            mobile_tab: "Mobile",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Sbloccato in seguito",
            unlocked_later_tip: "Una volta completato il processo di onboarding e inserito il prodotto, avrai accesso a ancora pi\xf9 metodi di accesso tramite social.",
            notice: "Si prega di evitare di utilizzare il connettore demo per scopi di produzione. Una volta completati i test, cancellare gentilmente il connettore demo e configurare il proprio connettore con le proprie credenziali."
        }
    },
    socialCallback: {
        title: "Accesso effettuato con successo",
        description: "Hai effettuato l'accesso con successo utilizzando il tuo account social. Per garantire integrazione senza problemi e accesso a tutte le funzionalit\xe0 di Logto, ti consigliamo di procedere alla configurazione del tuo connettore social."
    },
    tenant: {
        create_tenant: "Crea tenant"
    }
};
var $52f1ce94db734a11$export$2e2bcd8739ae039 = Object.freeze($52f1ce94db734a11$var$cloud);


const $2ff16f333ad29a69$var$components = {
    uploader: {
        action_description: "Trascina e rilascia o cerca",
        uploading: "Caricamento in corso...",
        image_limit: "Carica immagini sotto i {{size, number}}KB, solo {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Qualcosa \xe8 andato storto. Caricamento fallito.",
        error_file_size: "Il file \xe8 troppo grande. Carica un file sotto i {{size, number}}KB.",
        error_file_type: "Formato file non supportato. Sono accettati solo formati {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Puoi caricare solo 1 file."
    }
};
var $2ff16f333ad29a69$export$2e2bcd8739ae039 = Object.freeze($2ff16f333ad29a69$var$components);


const $21db683bdd201ec9$var$connector_details = {
    page_title: "Dettagli del connettore",
    back_to_connectors: "Torna ai connettori",
    check_readme: "Verifica README",
    settings: "Impostazioni generali",
    settings_description: "I connettori svolgono un ruolo critico in Logto. Grazie al loro aiuto, Logto consente agli utenti finali di utilizzare la registrazione o l'accesso senza password e le capacit\xe0 di accedere tramite account social.",
    parameter_configuration: "Configurazione dei parametri",
    test_connection: "Test",
    save_error_empty_config: "Inserisci la configurazione",
    send: "Invia",
    send_error_invalid_format: "Input non valido",
    edit_config_label: "Inserisci il tuo JSON qui",
    test_email_sender: "Prova il tuo connettore per email",
    test_sms_sender: "Prova il tuo connettore per SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Messaggio di prova inviato",
    test_sender_description: 'Logto utilizza il modello "Generico" per i test. Riceverai un messaggio se il tuo connettore \xe8 correttamente configurato.',
    options_change_email: "Cambia connettore per email",
    options_change_sms: "Cambia connettore per SMS",
    connector_deleted: "Il connettore \xe8 stato eliminato con successo",
    type_email: "Connettore per email",
    type_sms: "Connettore per SMS",
    type_social: "Connettore social",
    in_used_social_deletion_description: "Questo connettore \xe8 in uso nella tua esperienza di accesso. Eliminandolo, l'esperienza di accesso di <name/> verr\xe0 eliminata nelle impostazioni dell'esperienza di accesso. Dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    in_used_passwordless_deletion_description: "Questo {{name}} \xe8 in uso nella tua esperienza di accesso. Eliminandolo, la tua esperienza di accesso non funzioner\xe0 correttamente fino a quando non risolverai il conflitto. Dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    deletion_description: "Stai rimuovendo questo connettore. Non pu\xf2 essere annullato e dovrai riconfigurarlo se decidi di aggiungerlo di nuovo.",
    logto_email: {
        total_email_sent: "Totale email inviate: {{value, number}}",
        total_email_sent_tip: "Logto utilizza SendGrid per l'invio sicuro ed affidabile delle email integrate. \xc8 completamente gratuito da utilizzare. <a>Scopri di pi\xf9</a>",
        email_template_title: "Modello email",
        template_description: "L'email integrata utilizza modelli predefiniti per la consegna senza soluzione di continuit\xe0 delle email di verifica. Non \xe8 richiesta alcuna configurazione e puoi personalizzare le informazioni di base del marchio.",
        template_description_link_text: "Visualizza modelli",
        description_action_text: "Visualizza i modelli",
        from_email_field: "Email mittente",
        sender_name_field: "Nome mittente",
        sender_name_tip: 'Personalizza il nome del mittente per le email. Se lasciato vuoto, verr\xe0 utilizzato "Verification" come nome predefinito.',
        sender_name_placeholder: "Il tuo nome mittente",
        company_information_field: "Informazioni aziendali",
        company_information_description: "Mostra il nome dell'azienda, l'indirizzo o il codice postale in fondo alle email per migliorare l'autenticit\xe0.",
        company_information_placeholder: "Le informazioni di base della tua azienda",
        app_logo_field: "Logo dell'app",
        app_logo_tip: "Mostra il logo del tuo marchio in cima alle email. Utilizza la stessa immagine per la modalit\xe0 chiara e scura.",
        urls_not_allowed: "URL non sono ammessi",
        test_notes: 'Logto utilizza il modello "Generico" per i test.'
    }
};
var $21db683bdd201ec9$export$2e2bcd8739ae039 = Object.freeze($21db683bdd201ec9$var$connector_details);


const $7fddcea7dc3bb0c8$var$connectors = {
    page_title: "Connettori",
    title: "Connettori",
    subtitle: "Imposta i connettori per abilitare una esperienza di accesso senza password e tramite social media",
    create: "Aggiungi connettore sociale",
    config_sie_notice: "Hai impostato i connettori. Assicurati di configurarli in <a>{{link}}</a>.",
    config_sie_link_text: "esperienza di accesso",
    tab_email_sms: "Connettori email e SMS",
    tab_social: "Connettori social",
    connector_name: "Nome del connettore",
    demo_tip: "Il numero massimo di messaggi consentiti per questo connettore demo \xe8 limitato a 100 e non \xe8 consigliato per il deployment in un ambiente di produzione.",
    social_demo_tip: "Il connettore demo \xe8 progettato esclusivamente per scopi di dimostrazione e non \xe8 consigliato per il deployment in un ambiente di produzione.",
    connector_type: "Tipo",
    connector_status: "Esperienza di accesso",
    connector_status_in_use: "In uso",
    connector_status_not_in_use: "Non in uso",
    not_in_use_tip: {
        content: "Non in uso significa che la tua esperienza di accesso non ha utilizzato questo metodo di accesso. <a>{{link}}</a> per aggiungere questo metodo di accesso. ",
        go_to_sie: "Vai all’esperienza di accesso"
    },
    placeholder_title: "Connettore sociale",
    placeholder_description: "Logto ha fornito molti connettori di accesso condivisi tramite i social media, frattanto puoi creare il tuo usando i protocolli standard.",
    save_and_done: "Salva e Completa",
    type: {
        email: "Connettore email",
        sms: "Connettore SMS",
        social: "Connettore sociale"
    },
    setup_title: {
        email: "Imposta connettore email",
        sms: "Imposta connettore SMS",
        social: "Aggiungi connettore sociale"
    },
    guide: {
        subtitle: "Una guida passo passo per configurare il tuo connettore",
        general_setting: "Impostazioni generali",
        parameter_configuration: "Configurazione dei parametri",
        test_connection: "Prova la connessione",
        name: "Nome per il pulsante di accesso tramite social media",
        name_placeholder: "Inserisci il nome per il pulsante di accesso tramite social media",
        name_tip: 'Il nome del pulsante del connettore verr\xe0 visualizzato come "Continua con {{name}}." Presta attenzione alla lunghezza del nome in caso risulti troppo lungo.',
        logo: "URL del logo per il pulsante di accesso tramite social media",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "L'immagine del logo verr\xe0 mostrata sul connettore. Otteni un link di immagine pubblicamente accessibile e inserisci qui il link.",
        logo_dark: "URL del logo per il pulsante di accesso tramite social media (modalit\xe0 scura)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Imposta il logo del tuo connettore per la modalit\xe0 scura dopo averla abilitata nell’esperienza di accesso nel Console dell’Amministratore.",
        logo_dark_collapse: "Comprimi",
        logo_dark_show: "Mostra le impostazioni del logo per la modalit\xe0 scura",
        target: "Nome del provider di identit\xe0",
        target_placeholder: "Inserisci il nome del provider di identit\xe0 del connettore",
        target_tip: 'Il valore del "Nome IdP" pu\xf2 essere una stringa di identificatore univoco per distinguere le identit\xe0 social.',
        target_tip_standard: 'Il valore del "Nome IdP" pu\xf2 essere una stringa di identificatore univoco per distinguere le identit\xe0 social. Questa impostazione non pu\xf2 essere cambiata dopo la costruzione del connettore.',
        target_tooltip: "'Nome IdP' nei connettori social di Logto si riferisce alla 'fonte' delle tue identit\xe0 social media. Nel design di Logto, non accettiamo lo stesso 'Nome IdP' di una piattaforma specifica per evitare conflitti. Devi fare molta attenzione prima di aggiungere un connettore, poich\xe9 NON PUOI cambiarne il valore una volta creato. <a>Scopri di pi\xf9</a>",
        target_conflict: "Il nome IdP inserito corrisponde al connettore <span>nome</span> esistente. L’utilizzo dello stesso nome IdP potrebbe causare un comportamento di accesso imprevisto in cui gli utenti possono accedere allo stesso account tramite due connettori diversi.",
        target_conflict_line2: 'Se desideri sostituire il connettore corrente con lo stesso provider di identit\xe0 e consentire agli utenti precedenti di accedere senza registrarsi nuovamente, elimina il connettore <span>nome</span> e crea un nuovo connettore con lo stesso "Nome IdP".',
        target_conflict_line3: 'Se desideri connetterti a un provider di identit\xe0 diverso, modifica il "Nome IdP" e procedi.',
        config: "Inserisci il tuo JSON di configurazione",
        sync_profile: "Sincronizza le informazioni del profilo",
        sync_profile_only_at_sign_up: "Sincronizza solo al momento della registrazione",
        sync_profile_each_sign_in: "Effettua sempre una sincronizzazione ad ogni accesso",
        sync_profile_tip: "Sincronizza il profilo di base dal provider social, ad esempio i nomi degli utenti e le loro immagini del profilo.",
        callback_uri: "URI di callback",
        callback_uri_description: "Anche chiamato URI di reindirizzamento, \xe8 l'URI in Logto dove gli utenti verranno rimandati dopo l'autorizzazione tramite social media, copia e incollalo nella pagina di configurazione del provider social media."
    },
    platform: {
        universal: "Universale",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: "supporta pi\xf9 piattaforme, seleziona una piattaforma per continuare",
    drawer_title: "Guida per il connettore",
    drawer_subtitle: "Segui le istruzioni per integrare il tuo connettore",
    unknown: "Connettore sconosciuto",
    standard_connectors: "Connettori standard"
};
var $7fddcea7dc3bb0c8$export$2e2bcd8739ae039 = Object.freeze($7fddcea7dc3bb0c8$var$connectors);


const $f6b50d9a70a2be76$var$contact = {
    title: "Ottieni Aiuto",
    description: "Per richieste di assistenza o commenti sui prodotti, contattaci tramite i seguenti metodi.",
    discord: {
        title: "Unisciti alla community di Discord",
        description: "Connettiti con altri sviluppatori per trovare soluzioni",
        button: "Unisciti"
    },
    github: {
        title: "Comunica su GitHub",
        description: "Crea un problema e invialo su GitHub",
        button: "Apri"
    },
    email: {
        title: "Contattare il supporto tramite e-mail",
        description: "Invia una e-mail per ulteriori informazioni e assistenza",
        button: "Invia"
    },
    reserve: {
        title: "Prenota il tuo tempo con il team Logto",
        description: "Prenota rapidamente una sessione per una chat dal vivo",
        button: "Prenota"
    }
};
var $f6b50d9a70a2be76$export$2e2bcd8739ae039 = Object.freeze($f6b50d9a70a2be76$var$contact);


const $62df3d796ec9f9f8$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Ottieni una panoramica sulle prestazioni della tua app",
    total_users: "Totale utenti",
    total_users_tip: "Totale utenti",
    new_users_today: "Nuovi utenti oggi",
    new_users_today_tip: "Il numero di nuovi utenti registrati sulle tue app oggi",
    new_users_7_days: "Nuovi utenti negli ultimi 7 giorni",
    new_users_7_days_tip: "Il numero di nuovi utenti registrati sulle tue app negli ultimi 7 giorni",
    daily_active_users: "Utenti attivi giornalieri",
    daily_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app oggi",
    weekly_active_users: "Utenti attivi settimanali",
    weekly_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app negli ultimi 7 giorni",
    monthly_active_users: "Utenti attivi mensili",
    monthly_active_users_tip: "Il numero di utenti unici che hanno scambiato token sulle tue app negli ultimi 30 giorni"
};
var $62df3d796ec9f9f8$export$2e2bcd8739ae039 = Object.freeze($62df3d796ec9f9f8$var$dashboard);


const $13dc6375d305f881$var$domain = {
    status: {
        connecting: "Connessione in corso",
        in_used: "In uso",
        failed_to_connect: "Connessione fallita"
    },
    update_endpoint_notice: "Non dimenticare di aggiornare il dominio per l'URI di callback del connettore social e l'endpoint Logto nella tua applicazione se vuoi utilizzare un dominio personalizzato per le funzionalit\xe0. <a>{{link}}</a>",
    error_hint: "Assicurati di aggiornare i tuoi record DNS. Continueremo a controllarli ogni {{value}} secondi.",
    custom: {
        custom_domain: "Dominio personalizzato",
        custom_domain_description: "Migliora il tuo branding utilizzando un dominio personalizzato. Questo dominio verr\xe0 utilizzato nella tua esperienza di accesso.",
        custom_domain_field: "Dominio personalizzato",
        custom_domain_placeholder: "il-tuo-dominio.com",
        add_domain: "Aggiungi dominio",
        invalid_domain_format: "Formato del sottodominio non valido. Inserisci un sottodominio con almeno tre parti.",
        verify_domain: "Verifica dominio",
        enable_ssl: "Abilita SSL",
        checking_dns_tip: "Dopo aver configurato i record DNS, il processo verr\xe0 eseguito automaticamente e potrebbe richiedere fino a 24 ore. Puoi lasciare questa interfaccia durante l'esecuzione.",
        enable_ssl_tip: "Abilitare SSL verr\xe0 eseguito automaticamente e potrebbe richiedere fino a 24 ore. Puoi lasciare questa interfaccia durante l'esecuzione.",
        generating_dns_records: "Generazione dei record DNS in corso...",
        add_dns_records: "Inserisci questi record DNS nel tuo provider DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valore"
        },
        deletion: {
            delete_domain: "Elimina dominio",
            reminder: "Elimina dominio personalizzato",
            description: "Sei sicuro di voler eliminare questo dominio personalizzato?",
            in_used_description: 'Sei sicuro di voler eliminare questo dominio personalizzato "<span>{{domain}}</span>"?',
            in_used_tip: "Se hai configurato in precedenza questo dominio personalizzato nel tuo provider di connettore social o endpoint dell'applicazione, dovrai modificare l'URI nel dominio Logto predefinito \"<span>{{domain}}</span>\". \xc8 necessario per il corretto funzionamento del pulsante di accesso social.",
            deleted: "Dominio personalizzato eliminato con successo!"
        }
    },
    default: {
        default_domain: "Dominio predefinito",
        default_domain_description: "Logto offre un dominio preconfigurato predefinito, pronto all'uso senza alcuna configurazione aggiuntiva. Questo dominio predefinito serve come opzione di backup anche se hai abilitato un dominio personalizzato.",
        default_domain_field: "Dominio predefinito Logto"
    },
    custom_endpoint_note: 'Puoi personalizzare il nome di dominio di questi endpoint come richiesto. Scegli "{{custom}}" o "{{default}}".',
    custom_social_callback_url_note: 'Puoi personalizzare il nome di dominio di questo URI per corrispondere all\'endpoint della tua applicazione. Scegli "{{custom}}" o "{{default}}".'
};
var $13dc6375d305f881$export$2e2bcd8739ae039 = Object.freeze($13dc6375d305f881$var$domain);


const $56b2e472d437c546$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $56b2e472d437c546$export$2e2bcd8739ae039 = Object.freeze($56b2e472d437c546$var$enterprise_sso_details);


const $250344a073047451$var$enterprise_sso = {
    page_title: "SSO aziendale",
    title: "SSO aziendale",
    subtitle: "Collega il provider di identit\xe0 aziendale e abilita l'accesso unico inizializzato dal fornitore di servizi.",
    create: "Aggiungi connettore aziendale",
    col_connector_name: "Nome connettore",
    col_type: "Tipo",
    col_email_domain: "Dominio email",
    placeholder_title: "Connettore aziendale",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Aggiungi connettore aziendale",
        text_divider: "Oppure puoi personalizzare il tuo connettore con un protocollo standard.",
        connector_name_field_title: "Nome connettore",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Crea connettore"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $250344a073047451$export$2e2bcd8739ae039 = Object.freeze($250344a073047451$var$enterprise_sso);


const $949f63e1a1b94282$var$errors = {
    something_went_wrong: "Oops! Si \xe8 verificato un errore.",
    page_not_found: "Pagina non trovata",
    unknown_server_error: "Si \xe8 verificato un errore del server sconosciuto",
    empty: "Nessun dato",
    missing_total_number: "Impossibile trovare Total-Number negli header di risposta",
    invalid_uri_format: "Formato URI non valido",
    invalid_origin_format: "Formato origine URI non valido",
    invalid_json_format: "Formato JSON non valido",
    invalid_error_message_format: "Il formato del messaggio di errore non \xe8 valido.",
    required_field_missing: "Inserisci {{field}}",
    required_field_missing_plural: "Devi inserire almeno un {{field}}",
    more_details: "Ulteriori dettagli",
    username_pattern_error: "Il nome utente dovrebbe contenere solo lettere, numeri, o trattini bassi e non dovrebbe iniziare con un numero.",
    email_pattern_error: "L'indirizzo email non \xe8 valido.",
    phone_pattern_error: "Il numero di telefono non \xe8 valido.",
    insecure_contexts: "I contesti non sicuri (non HTTPS) non sono supportati.",
    unexpected_error: "Si \xe8 verificato un errore inaspettato.",
    not_found: "404 non trovato",
    create_internal_role_violation: "Stai creando un nuovo ruolo interno che \xe8 proibito da Logto. Prova un altro nome che non inizi con '#internal:'.",
    should_be_an_integer: "Deve essere un numero intero.",
    number_should_be_between_inclusive: "Il numero deve essere compreso tra {{min}} e {{max}} (inclusi)."
};
var $949f63e1a1b94282$export$2e2bcd8739ae039 = Object.freeze($949f63e1a1b94282$var$errors);


const $32e9789624e8c261$var$general = {
    placeholder: "Segnaposto",
    submit: "Invia",
    skip: "Salta",
    next: "Avanti",
    back: "Indietro",
    retry: "Riprova",
    done: "Fatto",
    search: "Cerca",
    search_placeholder: "Cerca",
    clear_result: "Cancella risultati",
    save: "Salva",
    save_changes: "Salva modifiche",
    saved: "Salvato",
    discard: "Elimina",
    loading: "Caricamento...",
    redirecting: "Redirezione...",
    add: "Aggiungi",
    added: "Aggiunto",
    cancel: "Annulla",
    confirm: "Conferma",
    check_out: "Checkout",
    create: "Crea",
    set_up: "Imposta",
    customize: "Personalizza",
    enable: "Abilita",
    reminder: "Promemoria",
    delete: "Elimina",
    more_options: "PI\xd9 OPZIONI",
    close: "Chiudi",
    copy: "Copia",
    copying: "Copiare",
    copied: "Copiato",
    required: "Obbligatorio",
    add_another: "Aggiungi un altro",
    create_another: "Crea un altro",
    deletion_confirmation: "Sei sicuro di voler eliminare questo {{title}}?",
    settings_nav: "Impostazioni",
    unsaved_changes_warning: "Hai apportato alcune modifiche. Sei sicuro di voler lasciare questa pagina?",
    leave_page: "Lascia pagina",
    stay_on_page: "Rimani sulla pagina",
    type_to_search: "Digita per cercare",
    got_it: "Capito",
    continue: "Continua",
    page_info: "{{min, number}}-{{max, number}} di {{total, number}}",
    learn_more: "Scopri di pi\xf9",
    tab_errors: "{{count, number}} errori",
    skip_for_now: "Salta per ora",
    remove: "Rimuovi",
    visit: "Visita",
    join: "Unisciti",
    try_now: "Prova ora",
    multiple_form_field: "(Multiplo)",
    demo: "Demo",
    unnamed: "Senza nome",
    view: "Vista",
    hide: "Nascondi",
    unknown_error: "Errore sconosciuto, riprova pi\xf9 tardi.",
    select: "Seleziona",
    contact_us_action: "Contattaci",
    description: "Descrizione",
    name: "Nome",
    add_field: "Aggiungi {{field}}",
    create_field: "Crea {{field}}",
    edit_field: "Modifica {{field}}",
    delete_field: "Elimina {{field}}",
    coming_soon: "Prossimamente",
    beta_notice: "\uD83C\uDF89  {{feature}} \xe8 attualmente in versione beta. Benvenuto a esplorarlo e <ContactLink>condividi il tuo feedback</ContactLink>."
};
var $32e9789624e8c261$export$2e2bcd8739ae039 = Object.freeze($32e9789624e8c261$var$general);


const $af10c3478f1c6cca$var$get_started = {
    page_title: "Inizia",
    title: "Esplora per avere successo",
    subtitle: "Alcune cose che puoi fare per ottenere rapidamente il valore di Logto",
    develop: {
        title: "Sviluppa: Dedica 5 minuti per integrare la tua app"
    },
    customize: {
        title: "Personalizza: Offri un'ottima esperienza di accesso",
        preview: {
            title: "Controlla l'anteprima in tempo reale dell'esperienza di accesso appena personalizzata",
            subtitle: "Prova subito l'esperienza di accesso a Logto per vedere come funziona"
        },
        connector: {
            title: "Aggiungi pi\xf9 connettori per supportare pi\xf9 metodi di accesso sociali",
            subtitle: "Prova l'accesso senza password e abilita un'esperienza sicura e senza attriti per i tuoi clienti"
        },
        continue_customizing: "Continua la personalizzazione",
        try_now: "Prova ora",
        add_more: "Aggiungi altro"
    },
    secure: {
        title: "Sicurezza: Proteggi le tue risorse"
    },
    manage: {
        title: "Gestisci: Definisci il controllo di accesso per il tuo prodotto e gli utenti",
        rbac: {
            title: "Aggiungi il controllo degli accessi basato sui ruoli per proteggere le tue risorse",
            subtitle: "Controlla le tue risorse attraverso l'autorizzazione basata sui ruoli scalabile per casi d'uso diversi."
        },
        create_roles: "Crea ruoli"
    },
    view_all: "Visualizza tutto →"
};
var $af10c3478f1c6cca$export$2e2bcd8739ae039 = Object.freeze($af10c3478f1c6cca$var$get_started);


const $9e034f4266dbfdbd$var$guide = {
    start_building: "Inizia a costruire",
    get_started: "Inizia",
    categories: {
        featured: "Popolare e per te",
        Traditional: "Applicazione Web Tradizionale",
        SPA: "App a pagina singola",
        Native: "Nativo",
        MachineToMachine: "Dalla macchina alla macchina"
    },
    filter: {
        title: "Filtra framework",
        placeholder: "Cerca framework"
    },
    checkout_tutorial: "Vedi il tutorial di {{name}}",
    do_not_need_tutorial: "Se non hai bisogno di un tutorial, puoi continuare senza una guida al framework",
    finish_and_done: "Termina e fine",
    cannot_find_guide: "Non riesci a trovare la tua guida?",
    describe_guide_looking_for: "Descrivi la guida che stai cercando",
    request_guide_successfully: "Il tuo richiesta \xe8 stata inviata con successo. Grazie!",
    app: {
        select_framework_or_tutorial: "Seleziona un framework o tutorial",
        guide_modal_title: "Inizia con l'SDK e le guide",
        modal_subtitle: "Sblocca il tuo processo di sviluppo dell'app con il nostro SDK e tutorial predefiniti.",
        select_a_framework: "Seleziona un framework",
        continue_without_framework: "Crea un'app senza framework",
        describe_guide_looking_for_placeholder: "Esempio: Voglio integrare Logto nella mia app Angular."
    },
    api: {
        modal_title: "Inizia con i tutorial",
        modal_subtitle: "Sblocca il tuo processo di sviluppo dell'app con i nostri tutorial predefiniti.",
        select_a_tutorial: "Seleziona un tutorial",
        continue_without_tutorial: "Continua senza tutorial",
        describe_guide_looking_for_placeholder: "Esempio: Voglio proteggere la mia API usando deno."
    }
};
var $9e034f4266dbfdbd$export$2e2bcd8739ae039 = Object.freeze($9e034f4266dbfdbd$var$guide);


const $cb30ddf156112e8f$var$log_details = {
    page_title: "Dettagli registro di verifica",
    back_to_logs: "Torna ai log di verifica",
    back_to: "Torna a {{name}}",
    success: "Successo",
    failed: "Fallito",
    event_key: "Chiave evento",
    application: "Applicazione",
    ip_address: "Indirizzo IP",
    user: "Utente",
    log_id: "ID registro",
    time: "Tempo",
    user_agent: "User agent",
    tab_details: "Dettagli",
    raw_data: "Dati grezzi"
};
var $cb30ddf156112e8f$export$2e2bcd8739ae039 = Object.freeze($cb30ddf156112e8f$var$log_details);


const $a5ed89930c667bb7$var$logs = {
    page_title: "Log di Audit",
    title: "Log di Audit",
    subtitle: "Visualizza i dati di registro degli eventi di autenticazione effettuati dai tuoi utenti",
    event: "Evento",
    user: "Utente",
    application: "Applicazione",
    time: "Tempo",
    filter_by: "Filtra per"
};
var $a5ed89930c667bb7$export$2e2bcd8739ae039 = Object.freeze($a5ed89930c667bb7$var$logs);


const $e04e988a63edb07e$var$menu = {
    profile: "Profilo",
    language: "Lingua",
    appearance: {
        label: "Aspetto",
        light: "Modalit\xe0 chiaro",
        dark: "Modalit\xe0 scuro",
        system: "Sincronizza con sistema"
    },
    sign_out: "Esci"
};
var $e04e988a63edb07e$export$2e2bcd8739ae039 = Object.freeze($e04e988a63edb07e$var$menu);


const $18dfe9443ee747c0$var$mfa = {
    title: "Autenticazione a pi\xf9 fattori",
    description: "Aggiungi l'autenticazione a pi\xf9 fattori per elevare la sicurezza della tua esperienza di accesso.",
    factors: "Fattori",
    multi_factors: "Multi-fattori",
    multi_factors_description: "Gli utenti devono verificare uno dei fattori abilitati per la verifica a due passaggi.",
    totp: "OTP dell'app autenticatore",
    otp_description: "Collega Google Authenticator, ecc., per verificare le password monouso.",
    webauthn: "WebAuthn (Passkey)",
    webauthn_description: "Verifica tramite un metodo supportato dal browser: biometria, scansione del telefono o chiave di sicurezza, ecc.",
    webauthn_native_tip: "WebAuthn non \xe8 supportato per le applicazioni native.",
    webauthn_domain_tip: "WebAuthn lega le chiavi pubbliche al dominio specifico. Modificare il dominio del servizio impedir\xe0 agli utenti di autenticarsi tramite le passkey esistenti.",
    backup_code: "Codice di backup",
    backup_code_description: "Genera 10 codici di backup monouso dopo che gli utenti hanno configurato qualsiasi metodo MFA.",
    backup_code_setup_hint: "Quando gli utenti non possono verificare i suddetti fattori MFA, utilizzare l'opzione di backup.",
    backup_code_error_hint: "Per utilizzare un codice di backup, \xe8 necessario almeno un altro metodo MFA per un'autenticazione utente riuscita.",
    policy: "Politica",
    policy_description: "Imposta la politica MFA per i flussi di accesso e registrazione.",
    two_step_sign_in_policy: "Politica di verifica a due passaggi all'accesso",
    user_controlled: "Gli utenti possono abilitare o disabilitare MFA autonomamente",
    user_controlled_tip: "Gli utenti possono saltare la configurazione MFA la prima volta all'accesso o alla registrazione, o abilitarla/disabilitarla nelle impostazioni dell'account.",
    mandatory: "Gli utenti devono sempre utilizzare MFA all'accesso",
    mandatory_tip: "Gli utenti devono configurare MFA la prima volta all'accesso o alla registrazione, e usarlo per tutti gli accessi futuri."
};
var $18dfe9443ee747c0$export$2e2bcd8739ae039 = Object.freeze($18dfe9443ee747c0$var$mfa);


const $da70c2f26c7f79d4$var$organization_details = {
    page_title: "Dettagli dell'organizzazione",
    delete_confirmation: "Una volta eliminato, tutti i membri perderanno la loro iscrizione e ruoli in questa organizzazione. Quest\\'azione non pu\xf2 essere annullata.",
    organization_id: "ID organizzazione",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Il nome dell'organizzazione, non \xe8 necessario che sia univoco.",
    description_placeholder: "Una descrizione dell'organizzazione.",
    member: "Membro",
    member_other: "Membri",
    add_members_to_organization: "Aggiungi membri all'organizzazione {{name}}",
    add_members_to_organization_description: "Trova gli utenti appropriati cercando per nome, email, telefono o ID utente. Gli utenti gi\xe0 esistenti non vengono mostrati nei risultati della ricerca.",
    add_with_organization_role: "Aggiungi con ruolo(i) dell'organizzazione",
    user: "Utente",
    authorize_to_roles: "Autorizza {{name}} ad accedere ai seguenti ruoli:",
    edit_organization_roles: "Modifica ruoli dell'organizzazione",
    edit_organization_roles_of_user: "Modifica ruoli dell'organizzazione di {{name}}",
    remove_user_from_organization: "Rimuovi utente dall'organizzazione",
    remove_user_from_organization_description: "Una volta rimosso, l'utente perder\xe0 la sua iscrizione e i ruoli in questa organizzazione. Quest\\'azione non pu\xf2 essere annullata.",
    search_user_placeholder: "Cerca per nome, email, telefono o ID utente",
    at_least_one_user: "\xc8 richiesto almeno un utente."
};
var $da70c2f26c7f79d4$export$2e2bcd8739ae039 = Object.freeze($da70c2f26c7f79d4$var$organization_details);


const $6077996ac1b7f01f$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organizzazioni",
    title: "Organizzazioni",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID organizzazione",
    members: "Membri",
    create_organization: "Crea organizzazione",
    setup_organization: "Configura la tua organizzazione",
    organization_list_placeholder_title: "Organizzazione",
    organization_list_placeholder_text: "L'organizzazione \xe8 di solito utilizzata in app multi-inquilino SaaS o simili a SaaS. La funzione Organizzazioni consente ai tuoi clienti B2B di gestire meglio i loro partner e clienti, e di personalizzare i modi in cui gli utenti finali accedono alle loro applicazioni.",
    organization_name_placeholder: "La mia organizzazione",
    organization_description_placeholder: "Una breve descrizione dell'organizzazione",
    organization_permission: "Permessi organizzazione",
    organization_permission_other: "Permessi organizzazione",
    organization_permission_description: "Il permesso organizzativo si riferisce all'autorizzazione per accedere a una risorsa nel contesto dell'organizzazione. Un permesso organizzativo dovrebbe essere rappresentato come una stringa significativa, servendo anche come nome e identificatore univoco.",
    organization_permission_delete_confirm: "Se questo permesso viene eliminato, tutti i ruoli dell'organizzazione che includono questo permesso perderanno tale permesso, e gli utenti che avevano questo permesso perderanno l'accesso garantito da esso.",
    create_permission_placeholder: "Leggi la cronologia degli appuntamenti",
    permission: "Permesso",
    permission_other: "Permessi",
    organization_role: "Ruolo organizzazione",
    organization_role_other: "Ruoli organizzazione",
    organization_role_description: "Il ruolo organizzativo \xe8 un raggruppamento di permessi che possono essere assegnati agli utenti. I permessi devono provenire dai permessi organizzativi predefiniti.",
    organization_role_delete_confirm: "Fare ci\xf2 rimuover\xe0 i permessi associati a questo ruolo dagli utenti interessati ed eliminer\xe0 le relazioni tra i ruoli dell'organizzazione, i membri dell'organizzazione e i permessi dell'organizzazione.",
    role: "Ruolo",
    create_role_placeholder: "Utenti con solo permessi di visualizzazione",
    search_placeholder: "Cerca per nome o ID dell'organizzazione",
    search_permission_placeholder: "Digita per cercare e selezionare i permessi",
    search_role_placeholder: "Digita per cercare e selezionare i ruoli",
    empty_placeholder: "\uD83E\uDD14 Non hai ancora impostato nessun {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Inizia con le guide",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interagisci con l'illustrazione per vedere come tutto si collega",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Passo 1: Definire i permessi dell'organizzazione",
        step_2: "Passo 2: Definire i ruoli dell'organizzazione",
        step_3: "Passo 3: Crea la tua prima organizzazione",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $6077996ac1b7f01f$export$2e2bcd8739ae039 = Object.freeze($6077996ac1b7f01f$var$organizations);


const $96dc1c01bc0b69ea$var$permissions = {
    search_placeholder: "Cerca per nome API o permesso",
    search_placeholder_without_api: "Cerca per nome permesso",
    name_column: "Permesso",
    description_column: "Descrizione",
    api_column: "API",
    placeholder_title: "Permesso",
    placeholder_description: "Il permesso si riferisce all'autorizzazione per accedere ad una risorsa (la chiamiamo risorsa API)."
};
var $96dc1c01bc0b69ea$export$2e2bcd8739ae039 = Object.freeze($96dc1c01bc0b69ea$var$permissions);


const $0ea156d775965e17$var$profile = {
    page_title: "Impostazioni Account",
    title: "Impostazioni Account",
    description: "Cambia le tue impostazioni account e gestisci le tue informazioni personali qui per garantire la sicurezza del tuo account.",
    settings: {
        title: "IMPOSTAZIONI PROFILO",
        profile_information: "Informazioni profilo",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome utente"
    },
    link_account: {
        title: "COLLEGA ACCOUNT",
        email_sign_in: "Accesso con email",
        email: "Email",
        social_sign_in: "Accesso con social media",
        link_email: "Collega email",
        link_email_subtitle: "Collega la tua email per accedere o per recuperare l'account.",
        email_required: "L'email \xe8 obbligatoria",
        invalid_email: "Indirizzo email non valido",
        identical_email_address: "L'indirizzo email inserito \xe8 identico a quello corrente",
        anonymous: "Anonimo"
    },
    password: {
        title: "PASSWORD E SICUREZZA",
        password: "Password",
        password_setting: "Impostazione password",
        new_password: "Nuova password",
        confirm_password: "Conferma password",
        enter_password: "Inserisci la password attuale",
        enter_password_subtitle: "Verifica che sei tu per proteggere la sicurezza del tuo account. Inserisci la tua password attuale prima di cambiarla.",
        set_password: "Imposta password",
        verify_via_password: "Verifica tramite password",
        show_password: "Mostra password",
        required: "La password \xe8 obbligatoria",
        do_not_match: "Le password non corrispondono. Riprova."
    },
    code: {
        enter_verification_code: "Inserisci il codice di verifica",
        enter_verification_code_subtitle: "Il codice di verifica \xe8 stato inviato a <strong>{{target}}</strong>",
        verify_via_code: "Verifica tramite codice di verifica",
        resend: "Invia nuovamente il codice di verifica",
        resend_countdown: "Invia nuovamente in {{countdown}} secondi"
    },
    delete_account: {
        title: "ELIMINA ACCOUNT",
        label: "Elimina account",
        description: "Eliminando il tuo account, verranno rimossi tutti i tuoi dati personali, le informazioni utente, la configurazione. Questa operazione non pu\xf2 essere annullata.",
        button: "Elimina account",
        dialog_paragraph_1: "Ci dispiace sapere che desideri eliminare il tuo account. L'eliminazione dell'account rimuover\xe0 permanentemente tutti i dati, inclusi le informazioni utente, i log e le impostazioni, e questa azione non pu\xf2 essere annullata. Quindi assicurati di eseguire il backup di eventuali dati importanti prima di procedere.",
        dialog_paragraph_2: "Per procedere con il processo di eliminazione dell'account, invia un'email al nostro team di supporto all'indirizzo <a>{{mail}}</a> con l'oggetto \"Richiesta di eliminazione account\". Ti assisteremo e ci assicureremo che tutti i tuoi dati siano correttamente eliminati dal nostro sistema.",
        dialog_paragraph_3: "Grazie per aver scelto Logto Cloud. Se hai ulteriori domande o dubbi, non esitare a contattarci."
    },
    set: "Imposta",
    change: "Cambia",
    link: "Collega",
    unlink: "Scollega",
    not_set: "Non impostato",
    change_avatar: "Cambia avatar",
    change_name: "Cambia nome",
    change_username: "Cambia nome utente",
    set_name: "Imposta nome",
    email_changed: "Email modificata.",
    password_changed: "Password modificata.",
    updated: "{{target}} aggiornato.",
    linked: "{{target}} collegato.",
    unlinked: "{{target}} scollegato.",
    email_exists_reminder: "Questa email {{email}} \xe8 associata a un account esistente. Collega un'altra email qui.",
    unlink_confirm_text: "S\xec, scollega",
    unlink_reminder: "Gli utenti non potranno pi\xf9 accedere tramite l'account <span></span> se lo scolleghi. Sicuro di procedere?"
};
var $0ea156d775965e17$export$2e2bcd8739ae039 = Object.freeze($0ea156d775965e17$var$profile);


const $d2f5f2e79c85ae6f$var$role_details = {
    back_to_roles: "Torna ai Ruoli",
    identifier: "Identificatore",
    delete_description: "Ci\xf2 canceller\xe0 anche i permessi associati a questo ruolo dagli utenti coinvolti e canceller\xe0 la corrispondenza tra ruoli, utenti e permessi.",
    role_deleted: "{{name}} \xe8 stato cancellato con successo.",
    settings_tab: "Impostazioni",
    users_tab: "Utenti",
    m2m_apps_tab: "App macchina-to-macchina",
    permissions_tab: "Permessi",
    settings: "Impostazioni",
    settings_description: "I ruoli sono un raggruppamento di autorizzazioni che possono essere assegnate agli utenti. Forniscono anche un modo per aggregare le autorizzazioni definite per diverse API, rendendo pi\xf9 efficiente l'aggiunta, la rimozione o la regolazione delle autorizzazioni rispetto all'assegnazione individuale agli utenti.",
    field_name: "Nome",
    field_description: "Descrizione",
    type_m2m_role_tag: "Ruolo app macchina-to-macchina",
    type_user_role_tag: "Ruolo utente",
    permission: {
        assign_button: "Assegna permessi",
        assign_title: "Assegna permessi",
        assign_subtitle: "Assegna autorizzazioni a questo ruolo. Il ruolo acquisir\xe0 le autorizzazioni aggiunte e gli utenti con questo ruolo erediteranno queste autorizzazioni.",
        assign_form_field: "Assegna permessi",
        added_text_one: "{{count, number}} permesso aggiunto",
        added_text_other: "{{count, number}} autorizzazioni aggiunte",
        api_permission_count_one: "{{count, number}} permesso",
        api_permission_count_other: "{{count, number}} autorizzazioni",
        confirm_assign: "Assegna permessi",
        permission_assigned: "Le autorizzazioni selezionate sono state assegnate con successo a questo ruolo",
        deletion_description: "Se questa autorizzazione viene rimossa, l'utente interessato con questo ruolo perder\xe0 l'accesso garantito da questa autorizzazione.",
        permission_deleted: 'La permissione "{{name}}" \xe8 stata rimossa con successo da questo ruolo',
        empty: "Nessuna autorizzazione disponibile"
    },
    users: {
        assign_button: "Assegna utenti",
        name_column: "Utente",
        app_column: "App",
        latest_sign_in_column: "Ultimo accesso",
        delete_description: "Rester\xe0 nella tua raccolta di utenti ma perder\xe0 l'autorizzazione per questo ruolo.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo ruolo",
        assign_title: "Assegna utenti",
        assign_subtitle: "Assegna utenti a questo ruolo. Trova utenti appropriati cercando nome, email, telefono o ID utente.",
        assign_field: "Assegna utenti",
        confirm_assign: "Assegna utenti",
        assigned_toast_text: "Gli utenti selezionati sono stati assegnati con successo a questo ruolo",
        empty: "Nessun utente disponibile"
    },
    applications: {
        assign_button: "Assegna applicazioni",
        name_column: "Applicazione",
        app_column: "App",
        description_column: "Descrizione",
        delete_description: "Rimarr\xe0 nel pool delle tue applicazioni ma perder\xe0 l'autorizzazione per questo ruolo.",
        deleted: "{{name}} \xe8 stato rimosso con successo da questo ruolo",
        assign_title: "Assegna applicazioni",
        assign_subtitle: "Assegna applicazioni a questo ruolo. Trova le applicazioni appropriate cercando nome, descrizione o ID app.",
        assign_field: "Assegna applicazioni",
        confirm_assign: "Assegna applicazioni",
        assigned_toast_text: "Le applicazioni selezionate sono state assegnate con successo a questo ruolo",
        empty: "Nessuna applicazione disponibile"
    }
};
var $d2f5f2e79c85ae6f$export$2e2bcd8739ae039 = Object.freeze($d2f5f2e79c85ae6f$var$role_details);


const $a09d561e9082cfb1$var$roles = {
    page_title: "Ruoli",
    title: "Ruoli",
    subtitle: "I ruoli includono le autorizzazioni che determinano ci\xf2 che un utente pu\xf2 fare. RBAC utilizza i ruoli per dare agli utenti l'accesso alle risorse necessarie per specifiche azioni.",
    create: "Crea Ruolo",
    role_name: "Nome ruolo",
    role_type: "Tipo ruolo",
    show_role_type_button_text: "Mostra altre opzioni",
    hide_role_type_button_text: "Nascondi altre opzioni",
    type_user: "Ruolo utente",
    type_machine_to_machine: "Ruolo app M2M",
    role_description: "Descrizione",
    role_name_placeholder: "Inserisci il nome del tuo ruolo",
    role_description_placeholder: "Inserisci la descrizione del tuo ruolo",
    col_roles: "Ruoli",
    col_type: "Tipo",
    col_description: "Descrizione",
    col_assigned_entities: "Assegnati",
    user_counts: "{{count}} utenti",
    application_counts: "{{count}} app",
    user_count: "{{count}} utente",
    application_count: "{{count}} app",
    assign_permissions: "Assegna autorizzazioni",
    create_role_title: "Crea Ruolo",
    create_role_description: "Crea e gestisci ruoli per le tue applicazioni. I ruoli contengono collezioni di autorizzazioni e possono essere assegnati agli utenti.",
    create_role_button: "Crea Ruolo",
    role_created: "Il ruolo {{name}} \xe8 stato creato con successo.",
    search: "Cerca per nome, descrizione o ID del ruolo",
    placeholder_title: "Ruoli",
    placeholder_description: "I ruoli sono un raggruppamento di autorizzazioni che possono essere assegnati agli utenti. Assicurati di aggiungere le autorizzazioni prima di creare i ruoli."
};
var $a09d561e9082cfb1$export$2e2bcd8739ae039 = Object.freeze($a09d561e9082cfb1$var$roles);


const $7c0a6b08beb67848$var$session_expired = {
    title: "La sessione \xe8 scaduta",
    subtitle: "La tua sessione potrebbe essere scaduta e sei stato disconnesso. Clicca il pulsante qui sotto per accedere di nuovo alla console di amministrazione.",
    button: "Accedi di nuovo"
};
var $7c0a6b08beb67848$export$2e2bcd8739ae039 = Object.freeze($7c0a6b08beb67848$var$session_expired);


const $a914b9facb495752$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $a914b9facb495752$export$2e2bcd8739ae039 = Object.freeze($a914b9facb495752$var$content);


const $d8a57b0c5f42e9d7$var$password_policy = {
    password_requirements: "Requisiti per la password",
    minimum_length: "Lunghezza minima",
    minimum_length_description: "NIST consiglia di utilizzare almeno 8 caratteri per i prodotti web.",
    minimum_length_error: "La lunghezza minima deve essere compresa tra {{min}} e {{max}} (inclusi).",
    minimum_required_char_types: "Tipi di caratteri minimi richiesti",
    minimum_required_char_types_description: "Tipi di caratteri: maiuscole (A-Z), minuscole (a-z), numeri (0-9) e simboli speciali ({{symbols}}).",
    password_rejection: "Rifiuto password",
    compromised_passwords: "Rifiuta password compromesse",
    breached_passwords: "Password violate",
    breached_passwords_description: "Rifiuta password trovate in precedenza nei database delle violazioni.",
    restricted_phrases: "Limita frasi poco sicure",
    restricted_phrases_tooltip: "La tua password dovrebbe evitare queste frasi a meno che non le combiniate con 3 o pi\xf9 caratteri extra.",
    repetitive_or_sequential_characters: "Caratteri ripetitivi o sequenziali",
    repetitive_or_sequential_characters_description: 'Ad esempio, "AAAA", "1234" e "abcd".',
    user_information: "Informazioni utente",
    user_information_description: "Ad esempio, indirizzo email, numero di telefono, nome utente, ecc.",
    custom_words: "Parole personalizzate",
    custom_words_description: "Personalizza parole specifiche del contesto, non case-sensitive, una per riga.",
    custom_words_placeholder: "Nome del tuo servizio, nome dell'azienda, ecc."
};
var $d8a57b0c5f42e9d7$export$2e2bcd8739ae039 = Object.freeze($d8a57b0c5f42e9d7$var$password_policy);


const $2b6bf2740e645330$var$sign_up_and_sign_in = {
    identifiers_email: "Indirizzo email",
    identifiers_phone: "Numero di telefono",
    identifiers_username: "Nome utente",
    identifiers_email_or_sms: "Indirizzo email o numero di telefono",
    identifiers_none: "Non applicabile",
    and: "e",
    or: "o",
    sign_up: {
        title: "REGISTRATI",
        sign_up_identifier: "Identificatore di registrazione",
        identifier_description: "L'identificatore di registrazione \xe8 necessario per la creazione dell'account e deve essere incluso nella schermata di accesso.",
        sign_up_authentication: "Impostazione dell'autenticazione per la registrazione",
        authentication_description: "Tutte le azioni selezionate saranno obbligatorie per gli utenti per completare il flusso.",
        set_a_password_option: "Crea la tua password",
        verify_at_sign_up_option: "Verifica all'atto della registrazione",
        social_only_creation_description: "(Questo si applica solo alla creazione di account con i social)"
    },
    sign_in: {
        title: "ACCEDI",
        sign_in_identifier_and_auth: "Identificatore e impostazioni di autenticazione per l'accesso",
        description: "Gli utenti possono accedere utilizzando una qualsiasi delle opzioni disponibili. Regola il layout trascinando e rilasciando le opzioni sottostanti.",
        add_sign_in_method: "Aggiungi metodo di accesso",
        password_auth: "Password",
        verification_code_auth: "Codice di verifica",
        auth_swap_tip: "Scambia le opzioni sottostanti per determinare quale appare prima nel flusso.",
        require_auth_factor: "Devi selezionare almeno un fattore di autenticazione."
    },
    social_sign_in: {
        title: "ACCESSO CON I SOCIAL",
        social_sign_in: "Accesso ai social",
        description: "A seconda dell'identificatore obbligatorio che hai impostato, all'utente potrebbe essere chiesto di fornire un identificatore durante la registrazione tramite il connettore social.",
        add_social_connector: "Aggiungi connettore social",
        set_up_hint: {
            not_in_list: "Non in lista?",
            set_up_more: "Imposta",
            go_to: "altri connettori social ora."
        }
    },
    tip: {
        set_a_password: "Un set unico di password per il tuo nome utente \xe8 un must.",
        verify_at_sign_up: "Attualmente supportiamo solo la posta elettronica verificata. La tua base utenti potrebbe contenere un gran numero di indirizzi email di bassa qualit\xe0 se non effettui la convalida.",
        password_auth: "Questo \xe8 essenziale poich\xe9 hai abilitato l'opzione di impostazione della password durante il processo di registrazione.",
        verification_code_auth: "Questo \xe8 essenziale poich\xe9 hai abilitato solo l'opzione di fornire un codice di verifica durante la registrazione. Se consenti l'impostazione della password durante il processo di registrazione, puoi deselezionare la casella.",
        delete_sign_in_method: "Questo \xe8 essenziale in quanto hai selezionato {{identifier}} come identificatore obbligatorio."
    },
    advanced_options: {
        title: "OPZIONI AVANZATE",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Abilita registrazione utente",
        enable_user_registration_description: "Abilita o disabilita la registrazione degli utenti. Una volta disabilitata, gli utenti possono comunque essere aggiunti nella console di amministrazione, ma gli utenti non possono pi\xf9 creare account tramite l'interfaccia di accesso."
    }
};
var $2b6bf2740e645330$export$2e2bcd8739ae039 = Object.freeze($2b6bf2740e645330$var$sign_up_and_sign_in);


const $eeaac80d59a40e8e$var$sign_in_exp = {
    page_title: "Esperienza di accesso",
    title: "Esperienza di accesso",
    description: "Personalizza l'interfaccia di accesso per abbinarla al tuo marchio e visualizzala in tempo reale",
    tabs: {
        branding: "Marchio",
        sign_up_and_sign_in: "Registrazione e accesso",
        content: "Contenuto",
        password_policy: "Politica sulla password"
    },
    welcome: {
        title: "Personalizza l'esperienza di accesso",
        description: "Inizia subito con la configurazione del tuo primo accesso. Questa guida ti guider\xe0 attraverso tutte le impostazioni necessarie.",
        get_started: "Inizia",
        apply_remind: "Si prega di notare che l'esperienza di accesso verr\xe0 applicata a tutte le applicazioni in questo account."
    },
    color: {
        title: "COLORE",
        primary_color: "Colore del marchio",
        dark_primary_color: "Colore del marchio (scuro)",
        dark_mode: "Abilita modalit\xe0 scura",
        dark_mode_description: "La tua app avr\xe0 un tema modalit\xe0 scura generato automaticamente in base al tuo colore del marchio e all'algoritmo Logto. Sei libero di personalizzare.",
        dark_mode_reset_tip: "Ricalcola il colore della modalit\xe0 scura in base al colore del marchio.",
        reset: "Ricalcola"
    },
    branding: {
        title: "AREA DI BRANDIZZO",
        ui_style: "Stile",
        favicon: "Favicon",
        logo_image_url: "URL dell'immagine del logo dell'app",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL dell'immagine del logo dell'app (scuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo dell'app",
        dark_logo_image: "Logo dell'app (scuro)",
        logo_image_error: "Logo dell'app: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizzato",
        css_code_editor_title: "Personalizza la tua interfaccia utente con CSS personalizzato",
        css_code_editor_description1: "Guarda l'esempio di CSS personalizzato.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Ulteriori informazioni",
        css_code_editor_content_placeholder: "Inserisci il tuo CSS personalizzato per adattare lo stile di qualsiasi cosa alle tue specifiche. Esprimi la tua creativit\xe0 e fai risaltare la tua interfaccia utente."
    },
    sign_up_and_sign_in: $2b6bf2740e645330$export$2e2bcd8739ae039,
    content: $a914b9facb495752$export$2e2bcd8739ae039,
    password_policy: $d8a57b0c5f42e9d7$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Nessun connettore SMS ancora configurato. Prima di completare la configurazione, gli utenti non saranno in grado di accedere con questo metodo. <a>{{link}}</a> in "Connettori"',
        no_connector_email: 'Nessun connettore email ancora configurato. Prima di completare la configurazione, gli utenti non saranno in grado di accedere con questo metodo. <a>{{link}}</a> in "Connettori"',
        no_connector_social: 'Non hai ancora configurato nessun connettore sociale. Aggiungi prima i connettori per applicare i metodi di accesso sociale. <a>{{link}}</a> in "Connettori".',
        setup_link: "Configura"
    },
    save_alert: {
        description: "Stai implementando nuove procedure di accesso e registrazione. Tutti i tuoi utenti potrebbero essere influenzati dalla nuova configurazione. Sei sicuro di voler procedere con il cambiamento?",
        before: "Prima",
        after: "Dopo",
        sign_up: "Registrazione",
        sign_in: "Accesso",
        social: "Sociale"
    },
    preview: {
        title: "Anteprima di accesso",
        live_preview: "Anteprima in diretta",
        live_preview_tip: "Salva per visualizzare le modifiche",
        native: "Nat",
        desktop_web: "Web desktop",
        mobile_web: "Web mobile",
        desktop: "Desktop",
        mobile: "Mobile"
    }
};
var $eeaac80d59a40e8e$export$2e2bcd8739ae039 = Object.freeze($eeaac80d59a40e8e$var$sign_in_exp);


const $1514747668a6859f$var$quota_item = {
    tenant_limit: {
        name: "Tenanti",
        limited: "{{count, number}} affittuario",
        limited_other: "{{count, number}} affittuari",
        unlimited: "Affittuari illimitati",
        not_eligible: "Rimuovi i tuoi affittuari"
    },
    mau_limit: {
        name: "Utenti attivi mensili",
        limited: "{{count, number}} MAU",
        unlimited: "Utenti attivi mensili illimitati",
        not_eligible: "Rimuovi tutti i tuoi utenti"
    },
    applications_limit: {
        name: "Applicazioni",
        limited: "{{count, number}} applicazione",
        limited_other: "{{count, number}} applicazioni",
        unlimited: "Applicazioni illimitate",
        not_eligible: "Rimuovi le tue applicazioni"
    },
    machine_to_machine_limit: {
        name: "Applicazioni Machine-to-Machine",
        limited: "{{count, number}} applicazione Machine-to-Machine",
        limited_other: "{{count, number}} applicazioni Machine-to-Machine",
        unlimited: "Applicazioni Machine-to-Machine illimitate",
        not_eligible: "Rimuovi le tue applicazioni Machine-to-Machine"
    },
    resources_limit: {
        name: "Risorse API",
        limited: "{{count, number}} risorsa API",
        limited_other: "{{count, number}} risorse API",
        unlimited: "Risorse API illimitate",
        not_eligible: "Rimuovi le tue risorse API"
    },
    scopes_per_resource_limit: {
        name: "Permessi risorsa",
        limited: "{{count, number}} permesso per risorsa",
        limited_other: "{{count, number}} permessi per risorsa",
        unlimited: "Permesso per risorsa illimitato",
        not_eligible: "Rimuovi i permessi risorsa"
    },
    custom_domain_enabled: {
        name: "Dominio personalizzato",
        limited: "Dominio personalizzato",
        unlimited: "Dominio personalizzato",
        not_eligible: "Rimuovi il tuo dominio personalizzato"
    },
    omni_sign_in_enabled: {
        name: "Omnisign-in",
        limited: "Omnisign-in",
        unlimited: "Omnisign-in",
        not_eligible: "Disabilita il tuo Omnisign-in"
    },
    built_in_email_connector_enabled: {
        name: "Connettore email incorporato",
        limited: "Connettore email incorporato",
        unlimited: "Connettore email incorporato",
        not_eligible: "Rimuovi il tuo connettore email incorporato"
    },
    social_connectors_limit: {
        name: "Connettori sociali",
        limited: "{{count, number}} connettore sociale",
        limited_other: "{{count, number}} connettori sociali",
        unlimited: "Connettori sociali illimitati",
        not_eligible: "Rimuovi i tuoi connettori sociali"
    },
    standard_connectors_limit: {
        name: "Connettori standard gratuiti",
        limited: "{{count, number}} connettore standard gratuito",
        limited_other: "{{count, number}} connettori standard gratuiti",
        unlimited: "Connettori standard illimitati",
        not_eligible: "Rimuovi i tuoi connettori standard"
    },
    roles_limit: {
        name: "Ruoli",
        limited: "{{count, number}} ruolo",
        limited_other: "{{count, number}} ruoli",
        unlimited: "Ruoli illimitati",
        not_eligible: "Rimuovi i tuoi ruoli"
    },
    scopes_per_role_limit: {
        name: "Permessi ruolo",
        limited: "{{count, number}} permesso per ruolo",
        limited_other: "{{count, number}} permessi per ruolo",
        unlimited: "Permesso per ruolo illimitato",
        not_eligible: "Rimuovi i permessi ruolo"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhook illimitati",
        not_eligible: "Rimuovi i tuoi webhook"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Conservazione log di audit",
        limited: "Conservazione log di audit: {{count, number}} giorno",
        limited_other: "Conservaizone log di audit: {{count, number}} giorni",
        unlimited: "Giorni illimitati",
        not_eligible: "Nessun log di audit"
    },
    community_support_enabled: {
        name: "Supporto della comunit\xe0",
        limited: "Supporto della comunit\xe0",
        unlimited: "Supporto della comunit\xe0",
        not_eligible: "Nessun supporto della comunit\xe0"
    },
    customer_ticket_support: {
        name: "Supporto tramite ticket clienti",
        limited: "{{count, number}} ore di supporto tramite ticket clienti",
        limited_other: "{{count, number}} ore di supporto tramite ticket clienti",
        unlimited: "Supporto tramite ticket clienti",
        not_eligible: "Nessun supporto tramite ticket clienti"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Disabilita il tuo MFA"
    },
    sso_enabled: {
        name: "SSO aziendale",
        limited: "SSO aziendale",
        unlimited: "SSO aziendale",
        not_eligible: "Disabilita il tuo SSO aziendale"
    }
};
var $1514747668a6859f$export$2e2bcd8739ae039 = Object.freeze($1514747668a6859f$var$quota_item);


const $d62771c587cbb900$var$quota_table = {
    quota: {
        title: "Quota",
        tenant_limit: "Limite tenant",
        base_price: "Prezzo base",
        mau_unit_price: "* Prezzo unitario MAU",
        mau_limit: "Limite MAU"
    },
    application: {
        title: "Applicazioni",
        total: "Totale applicazioni",
        m2m: "Machine-to-machine"
    },
    resource: {
        title: "Risorse API",
        resource_count: "Numero di risorse",
        scopes_per_resource: "Permessi per risorsa"
    },
    branding: {
        title: "UI e branding",
        custom_domain: "Dominio personalizzato",
        custom_css: "CSS personalizzato",
        app_logo_and_favicon: "Logo e favicon dell'applicazione",
        dark_mode: "Modalit\xe0 scura",
        i18n: "Internazionalizzazione"
    },
    user_authn: {
        title: "Autenticazione utente",
        omni_sign_in: "Accesso onnicomprensivo",
        password: "Password",
        passwordless: "Senza password - E-mail e SMS",
        email_connector: "Connettore e-mail",
        sms_connector: "Connettore SMS",
        social_connectors: "Connettori sociali",
        standard_connectors: "Connettori standard",
        built_in_email_connector: "Connettore e-mail integrato",
        mfa: "MFA",
        sso: "SSO aziendale"
    },
    user_management: {
        title: "Gestione utenti",
        user_management: "Gestione utenti",
        roles: "Ruoli",
        scopes_per_role: "Permessi per ruolo"
    },
    audit_logs: {
        title: "Log di audit",
        retention: "Conservazione"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organizzazione",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Assistenza",
        community: "Community",
        customer_ticket: "Ticket di assistenza",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* I vostri utenti attivi mensili (MAU) sono divisi in 3 livelli in base a quante volte effettuano l'accesso durante il ciclo di fatturazione. Ogni livello ha un prezzo diverso per unit\xe0 MAU.",
    unlimited: "Illimitato",
    contact: "Contatta",
    monthly_price: "${{value, number}}/mese",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} giorno",
    days_other: "{{count, number}} giorni",
    add_on: "Aggiuntiva",
    tier: "Livello{{value, number}}: "
};
var $d62771c587cbb900$export$2e2bcd8739ae039 = Object.freeze($d62771c587cbb900$var$quota_table);


const $fcb89f24c7c1e5ef$var$subscription = {
    free_plan: "Piano gratuito",
    free_plan_description: "Per progetti secondari e prove iniziali di Logto. Nessuna carta di credito.",
    hobby_plan: "Piano Hobby",
    hobby_plan_description: "Per sviluppatori individuali o piccoli team di ingegneria.",
    pro_plan: "Piano Pro",
    pro_plan_description: "Per aziende che beneficiano di Logto senza preoccupazioni.",
    enterprise: "Enterprise",
    current_plan: "Piano attuale",
    current_plan_description: "Ecco il tuo piano attuale. Puoi facilmente visualizzare l'utilizzo del tuo piano, controllare la tua prossima fattura e apportare modifiche al piano, se necessario.",
    plan_usage: "Utilizzo del piano",
    plan_cycle: "Ciclo del piano: {{period}}. L'utilizzo si rinnova il {{renewDate}}.",
    next_bill: "La tua prossima fattura",
    next_bill_hint: "Per saperne di pi\xf9 sul calcolo, consulta questo <a>articolo</a>.",
    next_bill_tip: "La tua prossima fattura include il prezzo base del tuo piano per il mese successivo, oltre al costo del tuo utilizzo moltiplicato per il prezzo unitario MAU in diverse fasce.",
    manage_payment: "Gestisci pagamento",
    overfill_quota_warning: "Hai raggiunto il limite del tuo contingente. Per evitare eventuali problemi, esegui l'upgrade del piano.",
    upgrade_pro: "Esegui l'upgrade a Pro",
    update_payment: "Aggiorna pagamento",
    payment_error: "Rilevato un problema di pagamento. Impossibile elaborare ${{price, number}} per il ciclo precedente. Aggiorna il pagamento per evitare la sospensione del servizio Logto.",
    downgrade: "Degrado",
    current: "Attuale",
    upgrade: "Aggiornamento",
    quota_table: $d62771c587cbb900$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Fatture",
        status_column: "Stato",
        amount_column: "Importo",
        invoice_created_date_column: "Data di creazione fattura",
        invoice_status: {
            void: "Annullata",
            paid: "Pagata",
            open: "Aperta",
            uncollectible: "Scaduta"
        }
    },
    quota_item: $1514747668a6859f$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Sei sicuro di voler effettuare il degrado?",
        description: "Se scegli di passare a <targetName/>, tieni presente che non avrai pi\xf9 accesso al contingente e alle funzionalit\xe0 che erano presenti in <currentName/>.",
        before: "Prima: <name/>",
        after: "Dopo: <name />",
        downgrade: "Degrado"
    },
    not_eligible_modal: {
        downgrade_title: "Non sei idoneo per il downgrade",
        downgrade_description: "Assicurati di soddisfare i seguenti criteri prima di eseguire il downgrade al piano <name/>.",
        downgrade_help_tip: "Hai bisogno di aiuto per il downgrade? <a>Contattaci</a>.",
        upgrade_title: "Promemoria amichevole per i nostri apprezzati early adopter",
        upgrade_description: "Attualmente stai utilizzando pi\xf9 di quanto consentito da <name />. Logto \xe8 ora ufficiale, con funzionalit\xe0 personalizzate per ciascun piano. Prima di considerare l'aggiornamento al <name />, assicurati di soddisfare i seguenti criteri prima dell'aggiornamento.",
        upgrade_pro_tip: " Oppure valuta l'aggiornamento al Piano Pro.",
        upgrade_help_tip: "Hai bisogno di aiuto per l'upgrade? <a>Contattaci</a>.",
        a_maximum_of: "Un massimo di <item/>"
    },
    upgrade_success: "Aggiornamento effettuato con successo a <name/>",
    downgrade_success: "Degrado effettuato con successo a <name/>",
    subscription_check_timeout: "Il controllo dell'abbonamento \xe8 scaduto. Si prega di riprovare pi\xf9 tardi.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $fcb89f24c7c1e5ef$export$2e2bcd8739ae039 = Object.freeze($fcb89f24c7c1e5ef$var$subscription);


const $28315f9663026ae3$var$tab_sections = {
    overview: "Panoramica",
    resources: "Risorse",
    users: "Utenti",
    access_control: "Controllo Accessi",
    help_and_support: "Aiuto e Supporto",
    tenant: "Locatario",
    automation: "Automazione"
};
var $28315f9663026ae3$export$2e2bcd8739ae039 = Object.freeze($28315f9663026ae3$var$tab_sections);


const $6be82cfef064c420$var$tabs = {
    get_started: "Iniziare",
    dashboard: "Dashboard",
    applications: "Applicazioni",
    api_resources: "Risorse API",
    sign_in_experience: "Esperienza di accesso",
    connectors: "Connettori",
    enterprise_sso: "SSO Enterprise",
    webhooks: "Webhooks",
    organizations: "Organizzazioni",
    users: "Gestione utenti",
    audit_logs: "Registri di verifica",
    roles: "Ruoli",
    docs: "Documenti",
    tenant_settings: "Impostazioni",
    mfa: "Autenticazione multi-fattore"
};
var $6be82cfef064c420$export$2e2bcd8739ae039 = Object.freeze($6be82cfef064c420$var$tabs);


const $6887b76660433215$var$tenants = {
    title: "Impostazioni",
    description: "Gestisci efficacemente le impostazioni dell'inquilino e personalizza il tuo dominio.",
    tabs: {
        settings: "Impostazioni",
        domains: "Domini",
        subscription: "Piano e fatturazione",
        billing_history: "Storico fatturazione"
    },
    settings: {
        title: "IMPOSTAZIONI",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID Tenant",
        tenant_name: "Nome Tenant",
        tenant_region: "Regione di hosting",
        tenant_region_tip: "I tuoi risorse inquilino sono ospitate in {{region}}. <a>Scopri di pi\xf9</a>",
        environment_tag_development: "Svil",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Le informazioni dell'inquilino sono state salvate correttamente."
    },
    full_env_tag: {
        development: "Sviluppo",
        production: "Produzione"
    },
    deletion_card: {
        title: "ELIMINA",
        tenant_deletion: "Elimina tenant",
        tenant_deletion_description: "L'eliminazione del tenant comporter\xe0 la rimozione permanente di tutti i dati utente e le configurazioni associate. Procedere con cautela.",
        tenant_deletion_button: "Elimina tenant"
    },
    create_modal: {
        title: "Crea nuovo tenant",
        subtitle: "Crea un nuovo inquilino con risorse e utenti isolati. Le regioni dei dati ospitati e i tipi di inquilino non possono essere modificati dopo la creazione.",
        tenant_usage_purpose: "Per cosa desideri utilizzare questo tenant?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Piano disponibile:",
        create_button: "Crea tenant",
        tenant_name_placeholder: "Il mio tenant"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Elimina tenant",
        description_line1: "Sei sicuro di voler eliminare il tuo tenant \"<span>{{name}}</span>\" con l'etichetta di suffisso dell'ambiente \"<span>{{tag}}</span>\"? Questa azione non pu\xf2 essere annullata e comporter\xe0 l'eliminazione permanente di tutti i tuoi dati e le informazioni dell'account.",
        description_line2: "Prima di eliminare l'account, forse possiamo aiutarti. <span><a>Contattaci via e-mail</a></span>",
        description_line3: 'Se vuoi procedere, inserisci il nome del tenant "<span>{{name}}</span>" per confermare.',
        delete_button: "Elimina definitivamente",
        cannot_delete_title: "Impossibile eliminare questo locatario",
        cannot_delete_description: "Spiacente, al momento non \xe8 possibile eliminare questo locatario. Verifica di essere nel Piano Gratuito e di aver saldato tutte le fatture pendenti."
    },
    tenant_landing_page: {
        title: "Non hai ancora creato un tenant",
        description: "Per iniziare a configurare il tuo progetto con Logto, crea un nuovo tenant. Se hai bisogno di uscire o eliminare il tuo account, clicca sul pulsante avatar in alto a destra.",
        create_tenant_button: "Crea tenant"
    },
    status: {
        mau_exceeded: "MAU Superato",
        suspended: "Sospeso",
        overdue: "Scaduto"
    },
    tenant_suspended_page: {
        title: "Tenant sospeso. Contattaci per ripristinare l'accesso.",
        description_1: "Ci dispiace molto informarti che il tuo account tenant \xe8 stato temporaneamente sospeso a causa di un utilizzo improprio, inclusi superamenti dei limiti di MAU, pagamenti in ritardo o altre azioni non autorizzate.",
        description_2: "Se necessiti ulteriori chiarimenti, hai qualche preoccupazione o desideri ripristinare la funzionalit\xe0 completa e sbloccare i tuoi tenant, ti preghiamo di contattarci immediatamente."
    },
    signing_keys: {
        title: "CHIAVI DI FIRMA",
        description: "Gestisci in modo sicuro le chiavi di firma nel tuo inquilino.",
        type: {
            private_key: "Chiavi private OIDC",
            cookie_key: "Chiavi dei cookie OIDC"
        },
        private_keys_in_use: "Chiavi private in uso",
        cookie_keys_in_use: "Chiavi dei cookie in uso",
        rotate_private_keys: "Ruota le chiavi private",
        rotate_cookie_keys: "Ruota le chiavi dei cookie",
        rotate_private_keys_description: "Questa azione creer\xe0 una nuova chiave di firma privata, ruoter\xe0 la chiave attuale e rimuover\xe0 la chiave precedente. I tuoi token JWT firmati con la chiave attuale rimarranno validi fino alla cancellazione o a un altro ciclo di rotazione.",
        rotate_cookie_keys_description: "Questa azione creer\xe0 una nuova chiave dei cookie, ruoter\xe0 la chiave attuale e rimuover\xe0 la chiave precedente. I tuoi cookie con la chiave attuale rimarranno validi fino alla cancellazione o a un altro ciclo di rotazione.",
        select_private_key_algorithm: "Seleziona l'algoritmo di firma per la nuova chiave privata",
        rotate_button: "Ruota",
        table_column: {
            id: "ID",
            status: "Stato",
            algorithm: "Algoritmo di firma della chiave"
        },
        status: {
            current: "Attuale",
            previous: "Precedente"
        },
        reminder: {
            rotate_private_key: "Sei sicuro di voler ruotare le <strong>chiavi private OIDC</strong>? I nuovi token JWT emessi saranno firmati dalla nuova chiave. I token JWT esistenti rimarranno validi finch\xe9 non ruoti nuovamente.",
            rotate_cookie_key: "Sei sicuro di voler ruotare le <strong>chiavi dei cookie OIDC</strong>? I nuovi cookie generati nelle sessioni di accesso saranno firmati dalla nuova chiave dei cookie. I cookie esistenti rimarranno validi finch\xe9 non ruoti nuovamente.",
            delete_private_key: "Sei sicuro di voler eliminare la <strong>chiave privata OIDC</strong>? I token JWT esistenti firmati con questa chiave privata non saranno pi\xf9 validi.",
            delete_cookie_key: "Sei sicuro di voler eliminare la <strong>chiave dei cookie OIDC</strong>? Le sessioni di accesso precedenti con i cookie firmati con questa chiave dei cookie non saranno pi\xf9 valide. \xc8 richiesta una nuova autenticazione per questi utenti."
        },
        messages: {
            rotate_key_success: "Chiavi di firma ruotate con successo.",
            delete_key_success: "Chiave eliminata con successo."
        }
    }
};
var $6887b76660433215$export$2e2bcd8739ae039 = Object.freeze($6887b76660433215$var$tenants);


const $c052da8ee242c47f$var$topbar = {
    docs: "Documentazione",
    help: "Aiuto"
};
var $c052da8ee242c47f$export$2e2bcd8739ae039 = Object.freeze($c052da8ee242c47f$var$topbar);


const $e992a89d896041f5$var$paywall = {
    applications: "Limite di {{count, number}} applicazione di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    applications_other: "Limite di {{count, number}} applicazioni di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    machine_to_machine_feature: "Aggiorna al piano <strong>Hobby</strong> per sbloccare 1 applicazione machine-to-machine, oppure scegli il piano <strong>Pro</strong> per l'utilizzo illimitato. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    machine_to_machine: "Limite di {{count, number}} applicazione machine-to-machine di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    machine_to_machine_other: "Limite di {{count, number}} applicazioni machine-to-machine di <planName/> raggiunto. Aggiorna il piano per soddisfare le esigenze del tuo team. Per qualsiasi assistenza, non esitare a <a>contattarci</a>.",
    resources: "Hai raggiunto il limite di {{count, number}} risorse API di <planName/>. Aggiorna il piano per soddisfare le esigenze del tuo team. <a>Contattaci</a> per qualsiasi assistenza.",
    resources_other: "Hai raggiunto il limite di {{count, number}} risorse API di <planName/>. Aggiorna il piano per soddisfare le esigenze del tuo team. <a>Contattaci</a> per qualsiasi assistenza.",
    scopes_per_resource: "Hai raggiunto il limite di {{count, number}} autorizzazioni per risorsa API di <planName/>. Aggiorna ora per espanderlo. <a>Contattaci</a> per qualsiasi assistenza.",
    scopes_per_resource_other: "Hai raggiunto il limite di {{count, number}} autorizzazioni per risorsa API di <planName/>. Aggiorna ora per espanderlo. <a>Contattaci</a> per qualsiasi assistenza.",
    custom_domain: "Sblocca la funzionalit\xe0 del dominio personalizzato passando al piano <strong>Hobby</strong> o <strong>Pro</strong>. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    social_connectors: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    social_connectors_other: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_feature: "Aggiorna al piano <strong>Hobby</strong> o <strong>Pro</strong> per creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML, oltre a connettori sociali illimitati e tutte le funzionalit\xe0 premium. Sentiti libero di <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_other: "Hai raggiunto il limite di {{count, number}} connettori sociali di <planName/>. Passa al piano per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_pro: "Hai raggiunto il limite di {{count, number}} connettori standard di <planName/>. Passa al piano Enterprise per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    standard_connectors_pro_other: "Hai raggiunto il limite di {{count, number}} connettori standard di <planName/>. Passa al piano Enterprise per ottenere connettori sociali aggiuntivi e la possibilit\xe0 di creare i tuoi connettori utilizzando i protocolli OIDC, OAuth 2.0 e SAML. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    roles: "Hai raggiunto il limite di {{count, number}} ruoli di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    roles_other: "Hai raggiunto il limite di {{count, number}} ruoli di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    scopes_per_role: "Hai raggiunto il limite di {{count, number}} autorizzazioni per ruolo di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    scopes_per_role_other: "Hai raggiunto il limite di {{count, number}} autorizzazioni per ruolo di <planName/>. Aggiorna il piano per aggiungere ruoli e autorizzazioni aggiuntive. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    hooks: "Hai raggiunto il limite di {{count, number}} webhook di <planName/>. Aggiorna il piano per creare altri webhook. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    hooks_other: "Hai raggiunto il limite di {{count, number}} webhook di <planName/>. Aggiorna il piano per creare altri webhook. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    mfa: "Sblocca MFA per verificare la sicurezza passando a un piano a pagamento. Non esitare a <a>contattarci</a> se hai bisogno di assistenza.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $e992a89d896041f5$export$2e2bcd8739ae039 = Object.freeze($e992a89d896041f5$var$paywall);


const $d4f488e793273b85$var$upsell = {
    upgrade_plan: "Aggiorna piano",
    compare_plans: "Confronta i piani",
    view_plans: "Visualizza piani",
    create_tenant: {
        title: "Seleziona il piano del tenant",
        description: "Logto offre opzioni competitive di piani con una struttura dei prezzi innovativa e conveniente progettata per le aziende in crescita. <a>Scopri di pi\xf9</a>",
        base_price: "Prezzo base",
        monthly_price: "{{value, number}}/mese",
        mau_unit_price: "Prezzo unitario MAU",
        view_all_features: "Visualizza tutte le funzionalit\xe0",
        select_plan: "Seleziona <name/>",
        free_tenants_limit: "Fino a {{count, number}} tenant gratuito",
        free_tenants_limit_other: "Fino a {{count, number}} tenant gratuiti",
        most_popular: "Pi\xf9 popolare",
        upgrade_success: "Aggiornamento a <name/> effettuato con successo"
    },
    mau_exceeded_modal: {
        title: "MAU ha superato il limite. Aggiorna il tuo piano.",
        notification: "Il tuo MAU attuale ha superato il limite di <planName/>. Aggiorna al piano premium tempestivamente per evitare la sospensione del servizio Logto.",
        update_plan: "Aggiorna piano"
    },
    payment_overdue_modal: {
        title: "Pagamento della fattura in ritardo",
        notification: "Oops! Il pagamento della fattura dell'affittuario <span>{{name}}</span> \xe8 fallito. Si prega di pagare tempestivamente la fattura per evitare la sospensione del servizio Logto.",
        unpaid_bills: "Fatture non pagate",
        update_payment: "Aggiorna pagamento"
    },
    paywall: $e992a89d896041f5$export$2e2bcd8739ae039
};
var $d4f488e793273b85$export$2e2bcd8739ae039 = Object.freeze($d4f488e793273b85$var$upsell);


const $2606f8f3399664af$var$user_details = {
    page_title: "Dettagli utente",
    back_to_users: "Torna alla gestione utenti",
    created_title: "Questo utente \xe8 stato creato con successo",
    created_guide: "Ecco le informazioni per aiutare l'utente con il processo di accesso.",
    created_email: "Indirizzo email:",
    created_phone: "Numero di telefono:",
    created_username: "Nome utente:",
    created_password: "Password:",
    menu_delete: "Elimina",
    delete_description: "Questa azione non pu\xf2 essere annullata. Eliminerai l'utente in modo permanente.",
    deleted: "L'utente \xe8 stato eliminato con successo",
    reset_password: {
        reset_password: "Resetta la password",
        title: "Sei sicuro di voler reimpostare la password?",
        content: "Questa azione non pu\xf2 essere annullata. Questo reimposter\xe0 le informazioni di accesso dell'utente.",
        congratulations: "L'utente \xe8 stato reimpostato",
        new_password: "Nuova password:"
    },
    tab_settings: "Impostazioni",
    tab_roles: "Ruoli",
    tab_logs: "Log utente",
    tab_organizations: "Organizzazioni",
    authentication: "Autenticazione",
    authentication_description: "Ogni utente ha un profilo contenente tutte le informazioni dell'utente. \xc8 composto da dati di base, identit\xe0 sociali e dati personalizzati.",
    user_profile: "Profilo utente",
    field_email: "Indirizzo email",
    field_phone: "Numero di telefono",
    field_username: "Nome utente",
    field_name: "Nome",
    field_avatar: "URL dell'immagine dell'avatar",
    field_avatar_placeholder: "https://il-tuo-dominio.cdn/avatar.png",
    field_custom_data: "Dati personalizzati",
    field_custom_data_tip: "Ulteriori informazioni sull'utente non elencate nelle propriet\xe0 utente predefinite, come il colore e la lingua preferiti dall'utente.",
    field_connectors: "Connessioni sociali",
    field_sso_connectors: "Connessioni enterprise",
    custom_data_invalid: "I dati personalizzati devono essere un oggetto JSON valido",
    connectors: {
        connectors: "Connettori",
        user_id: "ID utente",
        remove: "Rimuovi",
        connected: "Questo utente \xe8 connesso con pi\xf9 connettori sociali.",
        not_connected: "L'utente non \xe8 connesso a nessun connettore sociale",
        deletion_confirmation: "Stai rimuovendo l'identit\xe0 esistente <name/>. Sei sicuro di voler continuare?"
    },
    sso_connectors: {
        connectors: "Connettori",
        enterprise_id: "ID enterprise",
        connected: "Questo utente \xe8 connesso a pi\xf9 fornitori di identit\xe0 enterprise per il Single Sign-On.",
        not_connected: "L'utente non \xe8 connesso a nessun fornitore di identit\xe0 enterprise per il Single Sign-On."
    },
    mfa: {
        field_name: "Autenticazione a due fattori",
        field_description: "Questo utente ha abilitato fattori di autenticazione a 2 passaggi.",
        name_column: "Autenticazione a due fattori",
        field_description_empty: "Questo utente non ha abilitato fattori di autenticazione a due fattori.",
        deletion_confirmation: "Stai rimuovendo l'esistente <name/> per la verifica in due passaggi. Sei sicuro di voler continuare?"
    },
    suspended: "Sospeso",
    suspend_user: "Sospendi utente",
    suspend_user_reminder: "Sei sicuro di voler sospendere questo utente? L'utente non potr\xe0 accedere alla tua app e non sar\xe0 in grado di ottenere un nuovo token di accesso dopo la scadenza di quello corrente. Inoltre, qualsiasi richiesta API effettuata da questo utente non avr\xe0 esito.",
    suspend_action: "Sospendi",
    user_suspended: "L'utente \xe8 stato sospeso.",
    reactivate_user: "Riattiva l’utente",
    reactivate_user_reminder: "Sei sicuro di voler riattivare questo utente? Ci\xf2 consentir\xe0 eventuali tentativi di accesso per questo utente.",
    reactivate_action: "Riattiva",
    user_reactivated: "L'utente \xe8 stato riattivato.",
    roles: {
        name_column: "Ruolo",
        description_column: "Descrizione",
        assign_button: "Assegna ruoli",
        delete_description: "Questa azione rimuover\xe0 questo ruolo da questo utente. Il ruolo stesso esister\xe0 ancora, ma non sar\xe0 pi\xf9 associato a questo utente.",
        deleted: "{{nome}} \xe8 stato rimosso con successo da questo utente.",
        assign_title: "Assegna ruoli a {{nome}}",
        assign_subtitle: "Autorizza {{nome}} uno o pi\xf9 ruoli",
        assign_role_field: "Assegna ruoli",
        role_search_placeholder: "Cerca per nome ruolo",
        added_text: "{{value, number}} aggiunti",
        assigned_user_count: "{{value, number}} utenti",
        confirm_assign: "Assegna ruoli",
        role_assigned: "Ruolo(ruoli) assegnati con successo",
        search: "Cerca per nome ruolo, descrizione o ID",
        empty: "Nessun ruolo disponibile"
    },
    warning_no_sign_in_identifier: "L'utente deve avere almeno uno degli identificatori di accesso (nome utente, email, numero di telefono, o social) per accedere. Sei sicuro di voler continuare?",
    organization_roles_tooltip: "I ruoli assegnati all'utente all'interno di questa organizzazione."
};
var $2606f8f3399664af$export$2e2bcd8739ae039 = Object.freeze($2606f8f3399664af$var$user_details);


const $98b664d6204ae513$var$users = {
    page_title: "Gestione utenti",
    title: "Gestione utenti",
    subtitle: "Gestisci le identit\xe0 degli utenti, inclusa la creazione di utenti, la modifica delle informazioni degli utenti, la visualizzazione dei log degli utenti, il ripristino delle password e l'eliminazione degli utenti",
    create: "Aggiungi utente",
    create_subtitle: "Fornire almeno uno dei seguenti campi per procedere.",
    error_missing_identifier: "Devi fornire almeno un identificatore per creare un utente.",
    user_name: "Utente",
    application_name: "Dall'applicazione",
    latest_sign_in: "Ultimo accesso",
    create_form_username: "Nome utente",
    create_form_password: "Password",
    create_form_name: "Nome completo",
    placeholder_name: "Mario Rossi",
    placeholder_email: "mario@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+39 02 1234567",
    unnamed: "Senza nome",
    search: "Cerca per nome, email, telefono o nome utente",
    check_user_detail: "Controlla i dettagli dell'utente",
    placeholder_title: "Gestione utenti",
    placeholder_description: "Ogni utente ha un profilo contenente tutte le informazioni dell'utente. \xc8 composto da dati di base, identit\xe0 sociali e dati personalizzati."
};
var $98b664d6204ae513$export$2e2bcd8739ae039 = Object.freeze($98b664d6204ae513$var$users);


const $020a04f3ad8f056b$var$webhook_details = {
    page_title: "Dettagli webhook",
    back_to_webhooks: "Torna ai Webhook",
    not_in_use: "Non in uso",
    success_rate: "Tasso di successo",
    requests: "{{value, number}} richieste in 24h",
    disable_webhook: "Disabilita webhook",
    disable_reminder: "Sei sicuro di voler riattivare questo webhook? Farlo non invier\xe0 una richiesta HTTP all'URL dell'endpoint.",
    webhook_disabled: "Il webhook \xe8 stato disattivato.",
    webhook_reactivated: "Il webhook \xe8 stato riattivato.",
    reactivate_webhook: "Riattiva webhook",
    delete_webhook: "Elimina webhook",
    deletion_reminder: "Stai rimuovendo questo webhook. Dopo la cancellazione non invier\xe0 una richiesta HTTP all'URL dell'endpoint.",
    deleted: "Il webhook \xe8 stato eliminato con successo.",
    settings_tab: "Impostazioni",
    recent_requests_tab: "Richieste recenti (24h)",
    settings: {
        settings: "Impostazioni",
        settings_description: "I webhook ti consentono di ricevere aggiornamenti in tempo reale su eventi specifici non appena avvengono, inviando una richiesta POST all'URL dell'endpoint. Ci\xf2 ti consente di agire immediatamente in base alle nuove informazioni ricevute.",
        events: "Eventi",
        events_description: "Seleziona gli eventi trigger che Logto invier\xe0 la richiesta POST.",
        name: "Nome",
        endpoint_url: "Endpoint URL",
        signing_key: "Chiave di firma",
        signing_key_tip: "Aggiungi la chiave segreta fornita da Logto al tuo endpoint come header richiesta per garantire l'autenticit\xe0 del payload del webhook.",
        regenerate: "Rigenera",
        regenerate_key_title: "Rigenera chiave di firma",
        regenerate_key_reminder: "Sei sicuro di voler modificare la chiave di firma? Rigenerandola avr\xe0 immediatamente effetto. Ricorda di modificare in modo sincrono la chiave di firma nel tuo endpoint.",
        regenerated: "La chiave di firma \xe8 stata rigenerata.",
        custom_headers: "Intestazioni personalizzate",
        custom_headers_tip: "Opzionalmente, puoi aggiungere intestazioni personalizzate al payload del webhook per fornire contesto o metadati aggiuntivi sull'evento.",
        key_duplicated_error: "Le chiavi non possono essere ripetute.",
        key_missing_error: "La chiave \xe8 necessaria.",
        value_missing_error: "Il valore \xe8 obbligatorio.",
        invalid_key_error: "Chiave non valida",
        invalid_value_error: "Valore non valido",
        test: "Test",
        test_webhook: "Testa il tuo webhook",
        test_webhook_description: "Configurare il webhook e testarlo con esempi di payload per ciascun evento selezionato al fine di verificare la corretta ricezione e elaborazione.",
        send_test_payload: "Invia Payload di Test",
        test_result: {
            endpoint_url: "URL del punto di arrivo: {{url}}",
            message: "Messaggio: {{message}}",
            response_status: "Stato della risposta: {{status, number}}",
            response_body: "Corpo della risposta: {{body}}",
            request_time: "Tempo di richiesta: {{time}}",
            test_success: "Il test del webhook al punto di arrivo \xe8 stato eseguito con successo."
        }
    }
};
var $020a04f3ad8f056b$export$2e2bcd8739ae039 = Object.freeze($020a04f3ad8f056b$var$webhook_details);


const $b2cfcb09bb2242aa$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crea webhook per ricevere facilmente aggiornamenti in tempo reale relativi a eventi specifici.",
    create: "Crea Webhook",
    events: {
        post_register: "Crea nuovo account",
        post_sign_in: "Accedi",
        post_reset_password: "Reimposta password"
    },
    table: {
        name: "Nome",
        events: "Eventi",
        success_rate: "Tasso di successo (24h)",
        requests: "Richieste (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crea un webhook per ricevere aggiornamenti in tempo reale tramite richieste POST al tuo URL di destinazione. Rimani informato e agisci immediatamente su eventi come "Creazione account", "Accesso" e "Reimposta password".',
        create_webhook: "Crea Webhook"
    },
    create_form: {
        title: "Crea Webhook",
        subtitle: "Aggiungi il Webhook per inviare una richiesta POST all'endpoint URL con i dettagli degli eventi degli utenti.",
        events: "Eventi",
        events_description: "Selezionare gli eventi trigger che Logto invier\xe0 alla richiesta POST.",
        name: "Nome",
        name_placeholder: "Inserisci nome webhook",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Inserisci l'URL del tuo endpoint dove il payload del webhook viene inviato quando si verifica l'evento.",
        create_webhook: "Crea webhook",
        missing_event_error: "Devi selezionare almeno un evento."
    },
    webhook_created: "Il webhook {{name}} \xe8 stato creato con successo."
};
var $b2cfcb09bb2242aa$export$2e2bcd8739ae039 = Object.freeze($b2cfcb09bb2242aa$var$webhooks);


const $34aa1cc0d64d4e38$var$welcome = {
    title: "Benvenuti alla Console di Amministrazione",
    description: "La console di amministrazione \xe8 un'app web per gestire Logto senza alcuna conoscenza di programmazione. Iniziamo creando un account. Con questo account, puoi gestire Logto da solo o per conto della tua azienda.",
    create_account: "Crea account"
};
var $34aa1cc0d64d4e38$export$2e2bcd8739ae039 = Object.freeze($34aa1cc0d64d4e38$var$welcome);


const $e8c263f6a2a1235c$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $e04e988a63edb07e$export$2e2bcd8739ae039,
    general: $32e9789624e8c261$export$2e2bcd8739ae039,
    errors: $949f63e1a1b94282$export$2e2bcd8739ae039,
    tab_sections: $28315f9663026ae3$export$2e2bcd8739ae039,
    tabs: $6be82cfef064c420$export$2e2bcd8739ae039,
    applications: $796bed8c08c179e0$export$2e2bcd8739ae039,
    application_details: $7c60798e3cec3958$export$2e2bcd8739ae039,
    api_resources: $2510f374327a4ac5$export$2e2bcd8739ae039,
    api_resource_details: $ddcbe6775979aa76$export$2e2bcd8739ae039,
    connectors: $7fddcea7dc3bb0c8$export$2e2bcd8739ae039,
    connector_details: $21db683bdd201ec9$export$2e2bcd8739ae039,
    enterprise_sso: $250344a073047451$export$2e2bcd8739ae039,
    enterprise_sso_details: $56b2e472d437c546$export$2e2bcd8739ae039,
    get_started: $af10c3478f1c6cca$export$2e2bcd8739ae039,
    users: $98b664d6204ae513$export$2e2bcd8739ae039,
    user_details: $2606f8f3399664af$export$2e2bcd8739ae039,
    contact: $f6b50d9a70a2be76$export$2e2bcd8739ae039,
    sign_in_exp: $eeaac80d59a40e8e$export$2e2bcd8739ae039,
    dashboard: $62df3d796ec9f9f8$export$2e2bcd8739ae039,
    logs: $a5ed89930c667bb7$export$2e2bcd8739ae039,
    log_details: $cb30ddf156112e8f$export$2e2bcd8739ae039,
    session_expired: $7c0a6b08beb67848$export$2e2bcd8739ae039,
    welcome: $34aa1cc0d64d4e38$export$2e2bcd8739ae039,
    roles: $a09d561e9082cfb1$export$2e2bcd8739ae039,
    role_details: $d2f5f2e79c85ae6f$export$2e2bcd8739ae039,
    permissions: $96dc1c01bc0b69ea$export$2e2bcd8739ae039,
    cloud: $52f1ce94db734a11$export$2e2bcd8739ae039,
    profile: $0ea156d775965e17$export$2e2bcd8739ae039,
    components: $2ff16f333ad29a69$export$2e2bcd8739ae039,
    webhooks: $b2cfcb09bb2242aa$export$2e2bcd8739ae039,
    webhook_details: $020a04f3ad8f056b$export$2e2bcd8739ae039,
    domain: $13dc6375d305f881$export$2e2bcd8739ae039,
    tenants: $6887b76660433215$export$2e2bcd8739ae039,
    topbar: $c052da8ee242c47f$export$2e2bcd8739ae039,
    subscription: $fcb89f24c7c1e5ef$export$2e2bcd8739ae039,
    upsell: $d4f488e793273b85$export$2e2bcd8739ae039,
    guide: $9e034f4266dbfdbd$export$2e2bcd8739ae039,
    mfa: $18dfe9443ee747c0$export$2e2bcd8739ae039,
    organizations: $6077996ac1b7f01f$export$2e2bcd8739ae039,
    organization_details: $da70c2f26c7f79d4$export$2e2bcd8739ae039
};
var $e8c263f6a2a1235c$export$2e2bcd8739ae039 = Object.freeze($e8c263f6a2a1235c$var$admin_console);


const $685d73b1cd2f0666$var$demo_app = {
    title: "Hai effettuato l'accesso anteprima live con successo!",
    subtitle: "Ecco le tue informazioni di accesso:",
    username: "Nome utente: ",
    user_id: "ID utente: ",
    sign_out: "Esci dall'anteprima live",
    continue_explore: "O continua ad esplorare",
    customize_sign_in_experience: "Personalizza l'esperienza di accesso",
    enable_passwordless: "Abilita l'accesso senza password",
    add_social_connector: "Aggiungi connettore social"
};
var $685d73b1cd2f0666$export$2e2bcd8739ae039 = Object.freeze($685d73b1cd2f0666$var$demo_app);


const $35995a4b1fcb9485$var$oidc = {
    logout_success: "Hai effettuato il logout correttamente."
};
var $35995a4b1fcb9485$export$2e2bcd8739ae039 = Object.freeze($35995a4b1fcb9485$var$oidc);


const $2815d0b98133b381$var$translation = {
    admin_console: $e8c263f6a2a1235c$export$2e2bcd8739ae039,
    demo_app: $685d73b1cd2f0666$export$2e2bcd8739ae039,
    oidc: $35995a4b1fcb9485$export$2e2bcd8739ae039
};
var $2815d0b98133b381$export$2e2bcd8739ae039 = Object.freeze($2815d0b98133b381$var$translation);


const $46491d2d6475a3d2$var$it = {
    translation: $2815d0b98133b381$export$2e2bcd8739ae039,
    errors: $dfae08e084420d69$export$2e2bcd8739ae039
};
var $46491d2d6475a3d2$export$2e2bcd8739ae039 = Object.freeze($46491d2d6475a3d2$var$it);


const $6a5d5a8246458322$var$application = {
    invalid_type: "関連するロールを持つことができるのは、マシン間アプリケーションのみです。",
    role_exists: "ロールID {{roleId}} は、すでにこのアプリケーションに追加されています。",
    invalid_role_type: "ユーザータイプのロールをマシン間アプリケーションに割り当てることはできません。"
};
var $6a5d5a8246458322$export$2e2bcd8739ae039 = Object.freeze($6a5d5a8246458322$var$application);


const $5fadd1e14a43600e$var$auth = {
    authorization_header_missing: "Authorizationヘッダーがありません。",
    authorization_token_type_not_supported: "認証タイプはサポートされていません。",
    unauthorized: "未承認です。資格情報とそのスコープを確認してください。",
    forbidden: "アクセスが拒否されました。ユーザーの役割と権限を確認してください。",
    expected_role_not_found: "期待される役割が見つかりませんでした。ユーザーの役割と権限を確認してください。",
    jwt_sub_missing: "JWT内に`sub`がありません。",
    require_re_authentication: "保護されたアクションを実行するには再認証が必要です。"
};
var $5fadd1e14a43600e$export$2e2bcd8739ae039 = Object.freeze($5fadd1e14a43600e$var$auth);


const $d53bcaac6b9e207f$var$connector = {
    general: "コネクタでエラーが発生しました：{{errorDescription}}",
    not_found: "タイプ：{{type}}に利用可能なコネクタが見つかりません。",
    not_enabled: "コネクタが有効ではありません。",
    invalid_metadata: "コネクタのメタデータが無効です。",
    invalid_config_guard: "コネクタの設定ガードが無効です。",
    unexpected_type: "コネクタのタイプが予期しないものです。 ",
    invalid_request_parameters: "リクエストに誤った入力パラメータが含まれています。",
    insufficient_request_parameters: "リクエストには、入力パラメータが不足している可能性があります。",
    invalid_config: "コネクタの設定が無効です。",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "コネクタのレスポンスが無効です。",
    template_not_found: "コネクタ構成から正しいテンプレートを見つけることができませんでした。",
    template_not_supported: "コネクタはこのテンプレートタイプをサポートしていません。",
    rate_limit_exceeded: "トリガーレート制限。後でもう一度お試しください。",
    not_implemented: "{{method}}：まだ実装されていません。",
    social_invalid_access_token: "コネクタのアクセストークンが無効です。",
    invalid_auth_code: "コネクタの認証コードが無効です。",
    social_invalid_id_token: "コネクタのIDトークンが無効です。",
    authorization_failed: "ユーザーの認証プロセスが失敗しました。",
    social_auth_code_invalid: "アクセストークンを取得できません。承認コードを確認してください。",
    more_than_one_sms: "SMSコネクタの数が1より大きいです。",
    more_than_one_email: "電子メールコネクタの数が1より大きいです。",
    more_than_one_connector_factory: "複数のコネクタファクトリ（ID：{{connectorIds}}）が見つかりました。必要のないものはアンインストールできます。",
    db_connector_type_mismatch: "DBには、タイプに一致しないコネクタがあります。",
    not_found_with_connector_id: "指定された標準コネクタIDでコネクタを見つけることができません。",
    multiple_instances_not_supported: "選択した標準コネクタで複数のインスタンスを作成できません。",
    invalid_type_for_syncing_profile: "ソーシャルコネクタを使用してユーザープロファイルを同期できます。",
    can_not_modify_target: "コネクタの「ターゲット」を変更できません。",
    should_specify_target: "'target'を指定する必要があります。",
    multiple_target_with_same_platform: "同じターゲットとプラットフォームを持つ複数のソーシャルコネクタを持つことはできません。",
    cannot_overwrite_metadata_for_non_standard_connector: "このコネクタの「メタデータ」は上書きできません。"
};
var $d53bcaac6b9e207f$export$2e2bcd8739ae039 = Object.freeze($d53bcaac6b9e207f$var$connector);


const $923ecf249b2ae179$var$domain = {
    not_configured: "Domain hostname provider が設定されていません。",
    cloudflare_data_missing: "cloudflare_data が見つかりませんでした。確認してください。",
    cloudflare_unknown_error: "Cloudflare API のリクエスト中に未知のエラーが発生しました。",
    cloudflare_response_error: "Cloudflare から予期しない応答がありました。",
    limit_to_one_domain: "カスタムドメインは1つしか持てません。",
    hostname_already_exists: "サーバーには既にこのドメインが存在しています。",
    cloudflare_not_found: "Cloudflare からホスト名が見つかりませんでした。"
};
var $923ecf249b2ae179$export$2e2bcd8739ae039 = Object.freeze($923ecf249b2ae179$var$domain);


const $f73b04bf329e4233$var$entity = {
    invalid_input: "入力が無効です。値のリストは空であってはなりません。",
    create_failed: "{{name}}の作成に失敗しました。",
    db_constraint_violated: "データベースの制約が違反しました。",
    not_exists: "{{name}}は存在しません。",
    not_exists_with_id: "IDが`{{id}}`の{{name}}は存在しません。",
    not_found: "リソースが存在しません。",
    relation_foreign_key_not_found: "外部キーが1つ以上見つかりません。入力を確認し、すべての参照先エンティティが存在することを確認してください。",
    unique_integrity_violation: "エンティティは既に存在します。入力を確認してもう一度お試しください。"
};
var $f73b04bf329e4233$export$2e2bcd8739ae039 = Object.freeze($f73b04bf329e4233$var$entity);


const $83f2c0a91650d148$var$guard = {
    invalid_input: "リクエスト{{type}}が無効です。",
    invalid_pagination: "リクエストのページネーション値が無効です。",
    can_not_get_tenant_id: "リクエストからテナントIDを取得できません。",
    file_size_exceeded: "ファイルサイズが超過しました。",
    mime_type_not_allowed: "MIMEタイプが許可されていません。"
};
var $83f2c0a91650d148$export$2e2bcd8739ae039 = Object.freeze($83f2c0a91650d148$var$guard);


const $a9f732d8e17aafb4$var$hook = {
    missing_events: "少なくとも1つのイベントを提供する必要があります。",
    send_test_payload_failed: "テストペイロードの送信に失敗しました：{{message}}",
    endpoint_responded_with_error: "エンドポイントがエラーで応答しました：{{message}}。"
};
var $a9f732d8e17aafb4$export$2e2bcd8739ae039 = Object.freeze($a9f732d8e17aafb4$var$hook);


const $dcc6133a14371c9e$var$localization = {
    cannot_delete_default_language: "{{languageTag}}はデフォルト言語として設定されており、削除できません。",
    invalid_translation_structure: "データスキーマが無効です。入力を確認して、もう一度お試しください。"
};
var $dcc6133a14371c9e$export$2e2bcd8739ae039 = Object.freeze($dcc6133a14371c9e$var$localization);


const $7090d8145c078e73$var$log = {
    invalid_type: "ログタイプが無効です。"
};
var $7090d8145c078e73$export$2e2bcd8739ae039 = Object.freeze($7090d8145c078e73$var$log);


const $22129503a0179c4d$var$oidc = {
    aborted: "エンドユーザが操作を中止しました。",
    invalid_scope: "スコープが無効です: {{error_description}}。",
    invalid_token: "提供されたトークンが無効です。",
    invalid_client_metadata: "提供されたクライアントメタデータが無効です。",
    insufficient_scope: "トークンにスコープ `{{scope}}` が含まれていません。",
    invalid_request: "リクエストが無効です。",
    invalid_grant: "付与リクエストが無効です。",
    invalid_redirect_uri: "`` `redirect_uri`` `は、クライアントが登録したいずれのものとも一致しませんでした```redirect_uris`。",
    access_denied: "アクセスが拒否されました。",
    invalid_target: "無効なリソース指示子です。",
    unsupported_grant_type: "要求された`grant_type`はサポートされていません。",
    unsupported_response_mode: "要求された`response_mode`はサポートされていません。",
    unsupported_response_type: "要求された`response_type`はサポートされていません。",
    provider_error: "OIDC内部エラー:{{message}}。",
    server_error: "不明なOIDCエラーが発生しました。後でもう一度お試しください。",
    provider_error_fallback: "OIDCエラーが発生しました: {{code}}。",
    key_required: "少なくとも1つのキーが必要です。",
    key_not_found: "IDが{{id}}のキーが見つかりません。"
};
var $22129503a0179c4d$export$2e2bcd8739ae039 = Object.freeze($22129503a0179c4d$var$oidc);


const $96691f253a41329a$var$organization = {
    require_membership: "ユーザーは組織のメンバーである必要があります。"
};
var $96691f253a41329a$export$2e2bcd8739ae039 = Object.freeze($96691f253a41329a$var$organization);


const $a0bc5107265a8084$var$password = {
    unsupported_encryption_method: "暗号化方式 {{name}} はサポートされていません。",
    pepper_not_found: "パスワードペッパーが見つかりません。コアの環境を確認してください。",
    rejected: "パスワードが拒否されました。パスワードが要件を満たしているか確認してください。"
};
var $a0bc5107265a8084$export$2e2bcd8739ae039 = Object.freeze($a0bc5107265a8084$var$password);


const $a1117f3cfcde5510$var$request = {
    invalid_input: "入力が無効です。 {{details}}",
    general: "リクエストエラーが発生しました。"
};
var $a1117f3cfcde5510$export$2e2bcd8739ae039 = Object.freeze($a1117f3cfcde5510$var$request);


const $b36d434cad05394a$var$resource = {
    resource_identifier_in_use: "API識別子 {{indicator}} はすでに使用されています"
};
var $b36d434cad05394a$export$2e2bcd8739ae039 = Object.freeze($b36d434cad05394a$var$resource);


const $2c6eaf8b04decc33$var$role = {
    name_in_use: "このロール名{{name}}はすでに使用されています",
    scope_exists: "スコープID {{scopeId}}はすでにこのロールに追加されています",
    user_exists: "ユーザーID{{userId}}はすでにこのロールに追加されています",
    application_exists: "アプリケーション ID {{applicationId}} はすでにこのロールに追加されています",
    default_role_missing: "データベースにデフォルトロール名が存在しないものがあります。ロールを作成してください",
    internal_role_violation: "Logtoによって許可されていない内部ロールの更新または削除を試みている可能性があります。新しいロールを作成する場合は、「#internal：」で始まる別の名前を試してください。"
};
var $2c6eaf8b04decc33$export$2e2bcd8739ae039 = Object.freeze($2c6eaf8b04decc33$var$role);


const $2731431161e2d24f$var$scope = {
    name_exists: "スコープ名 {{name}} は既に使用されています",
    name_with_space: "スコープの名前にはスペースを含めることはできません。"
};
var $2731431161e2d24f$export$2e2bcd8739ae039 = Object.freeze($2731431161e2d24f$var$scope);


const $665dc1252e4f376e$var$session = {
    not_found: "セッションが見つかりません。戻って再度サインインしてください。",
    invalid_credentials: "アカウントまたはパスワードが正しくありません。入力内容を確認してください。",
    invalid_sign_in_method: "現在のサインイン方法は利用できません。",
    invalid_connector_id: "利用可能なid {{connectorId}} のコネクタが見つかりません。",
    insufficient_info: "十分なサインイン情報がありません。",
    connector_id_mismatch: "コネクタIDがセッションレコードと一致しません。",
    connector_session_not_found: "コネクタセッションが見つかりません。戻って再度サインインしてください。",
    verification_session_not_found: "検証が成功しませんでした。検証フローを再開してもう一度やり直してください。",
    verification_expired: "接続がタイムアウトしました。アカウントの安全性を確保するために再度検証してください。",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "最初にサインインしてください。",
    unsupported_prompt_name: "サポートされていないプロンプト名です。",
    forgot_password_not_enabled: "パスワードを忘れた場合の対処が有効になっていません。",
    verification_failed: "検証が成功しませんでした。検証フローを再開してもう一度やり直してください。",
    connector_validation_session_not_found: "トークン検証用のコネクタセッションが見つかりません。",
    identifier_not_found: "ユーザーIDが見つかりません。戻って再度サインインしてください。",
    interaction_not_found: "インタラクションセッションが見つかりません。戻ってセッションを開始してください。",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "このメールアドレスではシングルサインオンが有効になっています。SSOでサインインしてください。"
};
var $665dc1252e4f376e$export$2e2bcd8739ae039 = Object.freeze($665dc1252e4f376e$var$session);


const $93791e4d6920449f$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "「利用規約」のコンテンツURLが空です。「利用規約」が有効になっている場合は、コンテンツURLを追加してください。",
    empty_social_connectors: "「ソーシャルサインイン」方式が有効な場合は、有効なソーシャルコネクタを追加してください。",
    enabled_connector_not_found: "{{type}}コネクタが見つかりません。",
    not_one_and_only_one_primary_sign_in_method: "主要なサインイン方式は1つだけにしてください。入力内容を確認してください。",
    username_requires_password: "ユーザー名のサインアップ識別子にはパスワードを設定する必要があります。",
    passwordless_requires_verify: "Eメール/電話番号サインアップ識別子には、検証を有効にする必要があります。",
    miss_sign_up_identifier_in_sign_in: "サインイン方式にはサインアップ識別子を含める必要があります。",
    password_sign_in_must_be_enabled: "サインアップ時にパスワードが必要な場合、パスワードサインインを有効にする必要があります。",
    code_sign_in_must_be_enabled: "サインアップ時にパスワードが不要な場合、検証コードサインインを有効にする必要があります。",
    unsupported_default_language: "この言語- {{language}} は、現時点ではサポートされていません。",
    at_least_one_authentication_factor: "認証ファクタを1つ以上選択する必要があります。",
    backup_code_cannot_be_enabled_alone: "バックアップコードは単独で有効にできません。",
    duplicated_mfa_factors: "重複したMFAファクタです。"
};
var $93791e4d6920449f$export$2e2bcd8739ae039 = Object.freeze($93791e4d6920449f$var$sign_in_experiences);


const $8bb8f26a37fb29c6$var$single_sign_on = {
    forbidden_domains: "パブリックメールドメインは許可されていません。",
    duplicated_domains: "重複するドメインがあります。",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $8bb8f26a37fb29c6$export$2e2bcd8739ae039 = Object.freeze($8bb8f26a37fb29c6$var$single_sign_on);


const $c4417bdf203e6eeb$var$storage = {
    not_configured: "ストレージプロバイダが設定されていません。",
    missing_parameter: "ストレージプロバイダの{{parameter}}が欠落しています。",
    upload_error: "ファイルのアップロードに失敗しました。"
};
var $c4417bdf203e6eeb$export$2e2bcd8739ae039 = Object.freeze($c4417bdf203e6eeb$var$storage);


const $0b93fe152abdf698$var$subscription = {
    limit_exceeded: "定めた定期プランの上限に達しました。",
    get_plan_failed: "テナントのサブスクリプションプランを取得できませんでした。",
    tenant_suspended: "テナントが停止されています。管理者に連絡してください。"
};
var $0b93fe152abdf698$export$2e2bcd8739ae039 = Object.freeze($0b93fe152abdf698$var$subscription);


const $54034bcf84a2d1f8$var$swagger = {
    invalid_zod_type: "Zodのタイプが無効です。ルートガード構成を確認してください。",
    not_supported_zod_type_for_params: "パラメータにサポートされていないZodタイプがあります。ルートガード構成を確認してください。"
};
var $54034bcf84a2d1f8$export$2e2bcd8739ae039 = Object.freeze($54034bcf84a2d1f8$var$swagger);


const $bb5a7a205b482451$var$user = {
    username_already_in_use: "このユーザー名はすでに使用されています。",
    email_already_in_use: "このメールアドレスは既に別のアカウントに関連付けされています。",
    phone_already_in_use: "この電話番号は既に別のアカウントに関連付けされています。",
    invalid_email: "無効なメールアドレスです。",
    invalid_phone: "無効な電話番号です。",
    email_not_exist: "このメールアドレスは登録されていません。",
    phone_not_exist: "この電話番号は登録されていません。",
    identity_not_exist: "このソーシャルアカウントは登録されていません。",
    identity_already_in_use: "このソーシャルアカウントはすでに別のアカウントに関連付けされています。",
    social_account_exists_in_profile: "このソーシャルアカウントはすでに関連付けられています。",
    cannot_delete_self: "自分自身を削除することはできません。",
    sign_up_method_not_enabled: "このサインアップ方法は有効化されていません。",
    sign_in_method_not_enabled: "このサインイン方法は有効化されていません。",
    same_password: "新しいパスワードは、古いパスワードと同じであってはなりません。",
    password_required_in_profile: "サインインする前にパスワードを設定する必要があります。",
    new_password_required_in_profile: "新しいパスワードを設定する必要があります。",
    password_exists_in_profile: "すでにパスワードがプロフィールに存在しています。",
    username_required_in_profile: "サインインする前にユーザー名を設定する必要があります。",
    username_exists_in_profile: "すでにユーザー名がプロフィールに存在しています。",
    email_required_in_profile: "サインインする前にメールアドレスを追加する必要があります。",
    email_exists_in_profile: "すでにメールアドレスがプロフィールに関連付けられています。",
    phone_required_in_profile: "サインインする前に電話番号を追加する必要があります。",
    phone_exists_in_profile: "すでに電話番号がプロフィールに関連付けられています。",
    email_or_phone_required_in_profile: "サインインする前にメールアドレスまたは電話番号を追加する必要があります。",
    suspended: "このアカウントは停止されています。",
    user_not_exist: "{{ identifier }}を持つユーザーは存在しません。",
    missing_profile: "サインインする前に追加情報を提供する必要があります。",
    role_exists: "このユーザーには既に役割ID {{roleId}}が追加されています。",
    invalid_role_type: "役割タイプが無効です。ユーザーにはマシン対マシンの役割を割り当てることはできません。",
    missing_mfa: "MFAを追加してからサインインしてください。",
    totp_already_in_use: "TOTPはすでに使用されています。",
    backup_code_already_in_use: "バックアップコードはすでに使用されています。"
};
var $bb5a7a205b482451$export$2e2bcd8739ae039 = Object.freeze($bb5a7a205b482451$var$user);


const $5eb439240b2bf843$var$verification_code = {
    phone_email_empty: "電話番号とEメールの両方が空です。",
    not_found: "検証コードが見つかりません。先に検証コードを送信してください。",
    phone_mismatch: "電話番号が一致しません。新しい検証コードをリクエストしてください。",
    email_mismatch: "Eメールが一致しません。新しい検証コードをリクエストしてください。",
    code_mismatch: "無効な検証コードです。",
    expired: "検証コードの有効期限が切れました。新しい検証コードをリクエストしてください。",
    exceed_max_try: "検証コードのリトライ上限を超えました。新しい検証コードをリクエストしてください。"
};
var $5eb439240b2bf843$export$2e2bcd8739ae039 = Object.freeze($5eb439240b2bf843$var$verification_code);


const $b72762504e1db61c$var$errors = {
    request: $a1117f3cfcde5510$export$2e2bcd8739ae039,
    auth: $5fadd1e14a43600e$export$2e2bcd8739ae039,
    guard: $83f2c0a91650d148$export$2e2bcd8739ae039,
    oidc: $22129503a0179c4d$export$2e2bcd8739ae039,
    user: $bb5a7a205b482451$export$2e2bcd8739ae039,
    password: $a0bc5107265a8084$export$2e2bcd8739ae039,
    session: $665dc1252e4f376e$export$2e2bcd8739ae039,
    connector: $d53bcaac6b9e207f$export$2e2bcd8739ae039,
    verification_code: $5eb439240b2bf843$export$2e2bcd8739ae039,
    sign_in_experiences: $93791e4d6920449f$export$2e2bcd8739ae039,
    localization: $dcc6133a14371c9e$export$2e2bcd8739ae039,
    swagger: $54034bcf84a2d1f8$export$2e2bcd8739ae039,
    entity: $f73b04bf329e4233$export$2e2bcd8739ae039,
    log: $7090d8145c078e73$export$2e2bcd8739ae039,
    role: $2c6eaf8b04decc33$export$2e2bcd8739ae039,
    scope: $2731431161e2d24f$export$2e2bcd8739ae039,
    storage: $c4417bdf203e6eeb$export$2e2bcd8739ae039,
    resource: $b36d434cad05394a$export$2e2bcd8739ae039,
    hook: $a9f732d8e17aafb4$export$2e2bcd8739ae039,
    domain: $923ecf249b2ae179$export$2e2bcd8739ae039,
    subscription: $0b93fe152abdf698$export$2e2bcd8739ae039,
    application: $6a5d5a8246458322$export$2e2bcd8739ae039,
    organization: $96691f253a41329a$export$2e2bcd8739ae039,
    single_sign_on: $8bb8f26a37fb29c6$export$2e2bcd8739ae039
};
var $b72762504e1db61c$export$2e2bcd8739ae039 = Object.freeze($b72762504e1db61c$var$errors);


const $999af6fe79e10e19$var$api_resource_details = {
    page_title: "APIリソースの詳細 ",
    back_to_api_resources: "APIリソースに戻る",
    settings_tab: "設定",
    permissions_tab: "権限",
    settings: "設定",
    settings_description: "APIリソース、またはリソースインジケータは、通常、リソースの識別子を表すURI形式の変数を表します。",
    management_api_settings_description: "Logto管理APIは、管理者が幅広いID関連タスクを管理し、セキュリティポリシーを強制し、規制や標準に準拠するための包括的なAPIのコレクションです。",
    management_api_notice: "このAPIはLogtoエンティティを表し、変更または削除することはできません。管理APIを使用して、幅広いID関連タスクを実行できます。 <a>詳細</a>",
    token_expiration_time_in_seconds: "トークンの有効期限（秒単位）",
    token_expiration_time_in_seconds_placeholder: "トークンの有効期限を入力してください",
    delete_description: "この操作は元に戻すことはできません。APIリソースを完全に削除します。削除を確認するために、APIリソース名を入力してください。 <span>{{name}}</span>",
    enter_your_api_resource_name: "APIリソース名を入力してください",
    api_resource_deleted: "APIリソース {{name}} が正常に削除されました",
    permission: {
        create_button: "権限を作成",
        create_title: "権限の作成",
        create_subtitle: "このAPIで必要な権限（スコープ）を定義します。",
        confirm_create: "権限を作成",
        name: "権限名",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "権限名にはスペースを含めることはできません。",
        description: "説明",
        description_placeholder: "リソースを読み込むことができます",
        permission_created: "権限 {{name}} が正常に作成されました",
        delete_description: "この権限が削除されると、この権限を持っていたユーザーはそれによって与えられたアクセスを失います。",
        deleted: '権限 "{{name}}" が正常に削除されました。'
    }
};
var $999af6fe79e10e19$export$2e2bcd8739ae039 = Object.freeze($999af6fe79e10e19$var$api_resource_details);


const $7a08643d4a7e4d96$var$api_resources = {
    page_title: "API リソース",
    title: "API リソース",
    subtitle: "承認されたアプリケーションが利用できるAPIを定義",
    create: "API リソースを作成",
    api_name: "API 名",
    api_name_placeholder: "API 名を入力してください",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "API リソースの一意の識別子です。絶対URIで、フラグメント(#)コンポーネントはありません。OAuth 2.0での<a>resource parameter</a>に等しいです。",
    default_api: "デフォルトのAPI",
    default_api_label: "テナントごとにデフォルトのAPIを0または1つだけ設定できます。デフォルトのAPIが指定されている場合、認証リクエストでリソースパラメータを省略できます。その後のトークン交換は、デフォルトのAPIを対象として行われます。それにより、JWTが発行されます。<a>詳細を見る</a>",
    api_resource_created: "APIリソース{{name}}が正常に作成されました"
};
var $7a08643d4a7e4d96$export$2e2bcd8739ae039 = Object.freeze($7a08643d4a7e4d96$var$api_resources);


const $8acbf54c5f767300$var$application_details = {
    page_title: "アプリケーションの詳細",
    back_to_applications: "アプリケーションに戻る",
    check_guide: "ガイドを確認",
    settings: "設定",
    settings_description: "アプリケーションは、Logto for OIDC、サインインエクスペリエンス、監査ログなどでアプリケーションを識別するために使用されます。",
    advanced_settings: "高度な設定",
    advanced_settings_description: "高度な設定にはOIDC関連用語が含まれます。詳細については、トークンエンドポイントを確認してください。",
    application_roles: "役割",
    machine_logs: "マシンログ",
    application_name: "アプリケーション名",
    application_name_placeholder: "私のアプリ",
    description: "説明",
    description_placeholder: "アプリケーションの説明を入力してください",
    config_endpoint: "OpenID Providerの構成エンドポイント",
    authorization_endpoint: "認可エンドポイント",
    authorization_endpoint_tip: "認証と認可を実行するエンドポイントです。OpenID Connectの<a>認証</a>に使用されます。",
    logto_endpoint: "Logto エンドポイント",
    application_id: "アプリID",
    application_id_tip: "通常Logtoによって生成される一意のアプリケーション識別子です。OpenID Connectでは「<a>client_id</a>」とも呼ばれます。",
    application_secret: "アプリのシークレット",
    redirect_uri: "リダイレクトURI",
    redirect_uris: "リダイレクトURI",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "ユーザーがサインイン（成功した場合も失敗した場合も）した後にリダイレクトされるURIです。詳細については、OpenID Connectの<a>AuthRequest</a>を参照してください。",
    post_sign_out_redirect_uri: "サインアウト後のリダイレクトURI",
    post_sign_out_redirect_uris: "サインアウト後のリダイレクトURI",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "ユーザーのサインアウト後にリダイレクトされるURIです（オプション）。一部のアプリケーションタイプでは実質的な効果がない可能性があります。",
    cors_allowed_origins: "CORS許可されたオリジン",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "デフォルトでは、リダイレクトURIのすべてのオリジンが許可されます。通常、このフィールドでは何も行動を必要としません。これについての詳細情報は<a>MDN doc</a>を参照してください。",
    token_endpoint: "トークンエンドポイント",
    user_info_endpoint: "ユーザー情報エンドポイント",
    enable_admin_access: "管理者アクセスを有効にする",
    enable_admin_access_label: "管理APIへのアクセスを有効または無効にします。有効にすると、アクセストークンを使用してこのアプリケーションを代表して管理APIを呼び出すことができます。",
    always_issue_refresh_token: "常にRefresh Tokenを発行する",
    always_issue_refresh_token_label: "この設定を有効にすると、Logtoは、認証要求に「prompt = consent」が提示されたかどうかにかかわらず、常にRefresh Tokenを発行することができます。ただし、OpenID Connectと互換性がないため、必要でない限りこのプラクティスは推奨されず、問題が発生する可能性があります。",
    refresh_token_ttl: "リフレッシュトークンの有効期限（日単位）",
    refresh_token_ttl_tip: "リフレッシュトークンが期限切れになるまでの期間です。トークンリクエストは、リフレッシュトークンのTTLをこの値に延長します。",
    rotate_refresh_token: "Refresh Tokenを切り替える",
    rotate_refresh_token_label: "有効にすると、Logtoは、元のTTLの70％が経過したときまたは特定の条件が満たされた場合、トークン要求で新しいRefresh Tokenを発行します。<a>詳細を見る</a>",
    delete_description: "この操作は元に戻すことはできません。アプリケーション名「<span>{{name}}</span>」を入力して確認してください。",
    enter_your_application_name: "アプリケーション名を入力してください",
    application_deleted: "アプリケーション{{name}}が正常に削除されました",
    redirect_uri_required: "リダイレクトURIを少なくとも1つ入力する必要があります",
    roles: {
        name_column: "役割",
        description_column: "説明",
        assign_button: "役割を割り当てる",
        delete_description: "この操作は、このマシン対マシンアプリからこの役割を削除します。役割自体はまだ存在しますが、もはやマシン対マシンアプリに関連付けられていません。",
        deleted: "{{name}} がこのユーザーから正常に削除されました。",
        assign_title: "{{name}} に役割を割り当てる",
        assign_subtitle: "{{name}} に1つ以上の役割を承認する",
        assign_role_field: "役割を割り当てる",
        role_search_placeholder: "役割名で検索",
        added_text: "{{value, number}} 件追加",
        assigned_app_count: "{{value, number}} 個のアプリケーション",
        confirm_assign: "役割を割り当てる",
        role_assigned: "役割の割り当てに成功しました。",
        search: "役割名、説明、または ID で検索",
        empty: "利用可能な役割はありません"
    }
};
var $8acbf54c5f767300$export$2e2bcd8739ae039 = Object.freeze($8acbf54c5f767300$var$application_details);


const $e982febaa819fe5c$var$applications = {
    page_title: "アプリケーション ",
    title: "アプリケーション ",
    subtitle: "ネイティブ、シングルページ、マシン・トゥ・マシン、または従来のアプリケーションにLogto認証を設定する",
    subtitle_with_app_type: "あなたの {{name}} アプリケーションに Logto 認証を設定する",
    create: "アプリケーションを作成する",
    application_name: "アプリケーション名",
    application_name_placeholder: "私のアプリ",
    application_description: "アプリケーションの説明",
    application_description_placeholder: "アプリケーションの説明を入力してください",
    select_application_type: "アプリケーションタイプを選択してください",
    no_application_type_selected: "まだアプリケーションタイプが選択されていません",
    application_created: "アプリケーションが正常に作成されました。",
    app_id: "App ID",
    type: {
        native: {
            title: "ネイティブアプリ",
            subtitle: "ネイティブ環境で実行されるアプリケーション",
            description: "例：iOSアプリ、Androidアプリ"
        },
        spa: {
            title: "シングルページアプリ",
            subtitle: "Webブラウザで実行され、データを動的に更新するアプリケーション",
            description: "例：React DOMアプリ、Vueアプリ"
        },
        traditional: {
            title: "従来的なWeb",
            subtitle: "Webサーバーのみでページをレンダリングおよび更新するアプリケーション",
            description: "例：Next.js、PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "リソースに直接アクセスするアプリケーション（通常はサービス）",
            description: "例：バックエンドサービス"
        }
    },
    placeholder_title: "続行するにはアプリケーションタイプを選択してください",
    placeholder_description: "LogtoはOIDCのためにアプリケーションエンティティを使用して、アプリケーションの識別、サインインの管理、監査ログの作成などのタスクをサポートします。"
};
var $e982febaa819fe5c$export$2e2bcd8739ae039 = Object.freeze($e982febaa819fe5c$var$applications);


const $ce0fe1d5db9a0af7$var$cloud = {
    general: {
        onboarding: "オンボーディング"
    },
    welcome: {
        page_title: "ようこそ",
        title: "Logto Cloud へようこそ！あなたについて少し学びたいです。",
        description: "あなたの情報を知ることで、あなたにユニークなLogtoエクスペリエンスを提供します。あなたの情報は安全に保管されます。",
        project_field: "ログトを使用しています",
        project_options: {
            personal: "個人プロジェクト",
            company: "会社プロジェクト"
        },
        title_field: "適用可能なタイトルを選択してください",
        title_options: {
            developer: "開発者",
            team_lead: "チームリード",
            ceo: "CEO",
            cto: "CTO",
            product: "プロダクト",
            others: "その他"
        },
        company_name_field: "会社名",
        company_name_placeholder: "Acme.co",
        company_size_field: "会社の規模は？",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "サインアップの理由は？",
        reason_options: {
            passwordless: "パスワードレス認証と UI キットを探したい",
            efficiency: "即時利用可能な ID インフラを探したい",
            access_control: "役割と責任に基づくユーザーアクセスを制御したい",
            multi_tenancy: "マルチテナント製品の戦略を探しています",
            enterprise: "企業規模に向けた SSO ソリューションを探しています",
            others: "その他"
        }
    },
    sie: {
        page_title: "サインインエクスペリエンスのカスタマイズ",
        title: "まずは簡単にサインインエクスペリエンスをカスタマイズしましょう",
        inspire: {
            title: "魅力的な例を作成",
            description: "サインインエクスペリエンスに自信がない場合は、「Inspire Me」をクリックして、マジックが行われるのを待ちましょう！",
            inspire_me: "インスパイア"
        },
        logo_field: "アプリのロゴ",
        color_field: "ブランドカラー",
        identifier_field: "識別子",
        identifier_options: {
            email: "メール",
            phone: "電話",
            user_name: "ユーザー名"
        },
        authn_field: "認証",
        authn_options: {
            password: "パスワード",
            verification_code: "検証コード"
        },
        social_field: "ソーシャルサインイン",
        finish_and_done: "完了",
        preview: {
            mobile_tab: "モバイル",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "後でロックを解除",
            unlocked_later_tip: "オンボーディングプロセスを完了してプロダクトに入った後、より多くのソーシャルサインイン方法にアクセスできるようになります。",
            notice: "本番目的でのデモコネクタの使用は避けてください。テストを完了したら、デモコネクタを削除し、自分のクレデンシャルを使用して独自のコネクタを設定してください。"
        }
    },
    socialCallback: {
        title: "ログインが成功しました",
        description: "ソーシャルアカウントを使用して正常にサインインしました。Logtoのすべての機能にシームレスにアクセスできるようにするために、独自のソーシャルコネクタを設定することをお勧めします。"
    },
    tenant: {
        create_tenant: "テナントを作成する"
    }
};
var $ce0fe1d5db9a0af7$export$2e2bcd8739ae039 = Object.freeze($ce0fe1d5db9a0af7$var$cloud);


const $376529b5b46d0965$var$components = {
    uploader: {
        action_description: "ドラッグアンドドロップまたはブラウズ",
        uploading: "アップロード中...",
        image_limit: "{{size, number}}KB以下のイメージをアップロードし、{{extensions, list(style: narrow; type: conjunction;)}}のみ許可します。",
        error_upload: "エラーが発生しました。ファイルのアップロードに失敗しました。",
        error_file_size: "{{size, number}}KB以下のファイルをアップロードしてください。",
        error_file_type: "{{extensions, list(style: narrow; type: conjunction;)}}のみサポートされます。",
        error_file_count: "1つのファイルしかアップロードできません。"
    }
};
var $376529b5b46d0965$export$2e2bcd8739ae039 = Object.freeze($376529b5b46d0965$var$components);


const $ed18013c30921694$var$connector_details = {
    page_title: "コネクターの詳細",
    back_to_connectors: "コネクタに戻る",
    check_readme: "READMEを確認する",
    settings: "一般設定",
    settings_description: "コネクタはLogtoに不可欠です。Logtoはコネクタのおかげでエンドユーザーがパスワードレス登録またはサインインを利用し、ソーシャルアカウントでサインインすることができる機能を提供することができます。",
    parameter_configuration: "パラメーター設定",
    test_connection: "テスト",
    save_error_empty_config: "設定を入力してください",
    send: "送信",
    send_error_invalid_format: "入力が無効です",
    edit_config_label: "JSONを入力してください",
    test_email_sender: "メールコネクタのテスト",
    test_sms_sender: "SMSコネクタのテスト",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "テストメッセージが送信されました",
    test_sender_description: "Logtoはテストのために「共通」テンプレートを使用しています。コネクタが正しく構成されている場合、メッセージを受信します。",
    options_change_email: "メールコネクタの変更",
    options_change_sms: "SMSコネクタの変更",
    connector_deleted: "コネクタが正常に削除されました",
    type_email: "メールコネクタ",
    type_sms: "SMSコネクタ",
    type_social: "ソーシャルコネクタ",
    in_used_social_deletion_description: "このコネクタはあなたのサインイン体験で使用されています。削除すると、サインイン体験設定のサインイン体験が削除されます。再追加する場合は再設定する必要があります。",
    in_used_passwordless_deletion_description: "この{{name}}はあなたのサインイン体験で使用されています。削除すると、競合が解決されるまでサインイン体験が正常に機能しません。再追加する場合は再設定する必要があります。",
    deletion_description: "このコネクタを削除します。元に戻すことはできず、再追加する場合は再設定する必要があります。",
    logto_email: {
        total_email_sent: "総送信数: {{value, number}}",
        total_email_sent_tip: "Logto はセキュアかつ安定した組み込みメールのために SendGrid を利用しています。完全に無料です。<a>詳細を見る</a>",
        email_template_title: "メールテンプレート",
        template_description: "組み込みのメールは、シームレスな認証メールの配信のためにデフォルトのテンプレートを使用します。設定は必要ありません。基本的なブランド情報をカスタマイズできます。",
        template_description_link_text: "テンプレートを表示",
        description_action_text: "テンプレートを表示",
        from_email_field: "送信元メールアドレス",
        sender_name_field: "送信元名",
        sender_name_tip: "メールの送信元名をカスタマイズします。空白の場合、「Verification」がデフォールト名として使用されます。",
        sender_name_placeholder: "送信元の名前を入力してください",
        company_information_field: "企業情報",
        company_information_description: "メールの下部に会社名、住所、郵便番号などを表示して、真正性を高めます。",
        company_information_placeholder: "会社の基本情報を入力してください",
        app_logo_field: "アプリのロゴ",
        app_logo_tip: "メールの上部にブランドロゴを表示します。ライトモードとダークモードの両方で同じ画像を使用してください。",
        urls_not_allowed: "URLは許可されません",
        test_notes: "Logtoはテストのために「共通」テンプレートを使用しています。"
    }
};
var $ed18013c30921694$export$2e2bcd8739ae039 = Object.freeze($ed18013c30921694$var$connector_details);


const $41521a13b3eaf386$var$connectors = {
    page_title: "コネクタ",
    title: "コネクタ",
    subtitle: "コネクタを設定して、パスワードレスおよびソーシャルサインイン体験を有効にします",
    create: "ソーシャルコネクタを追加",
    config_sie_notice: "コネクタを設定しました。<a>{{link}}</a>で設定を確認してください。",
    config_sie_link_text: "サインイン体験",
    tab_email_sms: "メールとSMSのコネクタ",
    tab_social: "ソーシャルコネクタ",
    connector_name: "コネクタ名",
    demo_tip: "このデモコネクタの許容される最大メッセージ数は100件に限定されており、本番環境での展開は推奨されません。",
    social_demo_tip: "このデモコネクタは実演目的にのみ使用するように設計されており、本番環境での展開は推奨されません。",
    connector_type: "タイプ",
    connector_status: "サインイン体験",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用は、サインイン体験でこのサインイン方法が使用されていないことを意味します。<a>{{link}}</a>でこのサインイン方法を追加してください。",
        go_to_sie: "サインイン体験に進む"
    },
    placeholder_title: "ソーシャルコネクタ",
    placeholder_description: "Logtoは、標準プロトコルを使用して独自のソーシャルサインインコネクタを作成できるとともに、多くの一般的に使用されているソーシャルサインインコネクタを提供しています。",
    save_and_done: "保存して完了",
    type: {
        email: "メールコネクタ",
        sms: "SMSコネクタ",
        social: "ソーシャルコネクタ"
    },
    setup_title: {
        email: "メールコネクタの設定",
        sms: "SMSコネクタの設定",
        social: "ソーシャルコネクタを追加"
    },
    guide: {
        subtitle: "コネクタの設定手順",
        general_setting: "全般設定",
        parameter_configuration: "パラメータ設定",
        test_connection: "接続テスト",
        name: "ソーシャルサインインボタンの名前",
        name_placeholder: "ソーシャルサインインボタンの名前を入力",
        name_tip: "コネクタボタンの名前は「{{name}}で続ける」で表示されます。名前が長くなりすぎないように注意してください。",
        logo: "ソーシャルサインインボタンのロゴURL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "ロゴ画像はコネクタに表示されます。一般的にアバターやトンマークなどを使用します。公開アクセス可能な画像リンクを取得し、リンクをここに挿入してください。",
        logo_dark: "ソーシャルサインインボタンのロゴURL（ダークモード）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "ダークモードでコネクタのロゴを設定してください。",
        logo_dark_collapse: "折りたたむ",
        logo_dark_show: "ダークモード用のロゴ設定を表示",
        target: "Identity Providerの名前",
        target_placeholder: "コネクタIdentity Providerの名前を入力",
        target_tip: "「IdP名」として、ソーシャルIDを識別するための一意の識別子文字列を指定します。",
        target_tip_standard: "「IdP名」として、ソーシャルIDを識別するための一意の識別子文字列を指定します。この設定は、コネクタが作成された後に変更できません。",
        target_tooltip: "Logtoのソーシャルコネクタでの「IdP名」とは、ソーシャルIDの「ソース」を指します。「IdP名」は、Plat formごとに一意でなければならず、同じ名前は許可されません。「IdP名」は一度作成されたコネクタで変更することはできません。<a>詳細を見る</a>",
        target_conflict: "入力されたIdP名は、既存の<span>name</span>コネクタと一致します。同じIdP名を使用すると、ユーザーが2つの異なるコネクタを通じて同じアカウントにアクセスする予期しないサインイン動作が発生する可能性があります。",
        target_conflict_line2: '以前のユーザーが再登録せずにサインインできるように、同じIdentity Providerを持つ現在のコネクタを削除し、新しいコネクタを "IdP名" と同じで作成する場合は、前のユーザーが再登録せずにサインインできるように、同じIdentity Providerを持つ現在のコネクタを削除し、新しいコネクタを "IdP名" で作成してください。',
        target_conflict_line3: "別のIdentity Providerに接続する場合は、「IdP名」を変更して続行してください。",
        config: "構成JSONを入力してください",
        sync_profile: "プロファイル情報の同期",
        sync_profile_only_at_sign_up: "サインアップ時にのみ同期する",
        sync_profile_each_sign_in: "サインインごとに同期する",
        sync_profile_tip: "基本プロファイル（ユーザーの名前やアバターなど）をソーシャルプロバイダから同期します。",
        callback_uri: "Callback URI",
        callback_uri_description: "Redirect URIもしくはコールバックURIとも呼ばれ、Logtoに戻るURIです。コピーしてソーシャルプロバイダの構成ページに貼り付けてください。"
    },
    platform: {
        universal: "ユニバーサル",
        web: "Web",
        native: "ネイティブ"
    },
    add_multi_platform: "は複数のプラットフォームをサポートしています。続行するプラットフォームを選択してください。",
    drawer_title: "コネクターガイド",
    drawer_subtitle: "インテグレーションの手順に従ってください",
    unknown: "不明なコネクタ",
    standard_connectors: "標準コネクタ"
};
var $41521a13b3eaf386$export$2e2bcd8739ae039 = Object.freeze($41521a13b3eaf386$var$connectors);


const $7fbda3de6b4efa0c$var$contact = {
    title: "ヘルプを得る",
    description: "ヘルプ要求または製品フィードバックについては、次の方法を使用してお問い合わせください。",
    discord: {
        title: "Discord コミュニティに参加する",
        description: "他の開発者と連携して解決策を見つける",
        button: "参加する"
    },
    github: {
        title: "GitHub 上でコミュニケーションする",
        description: "GitHubで問題を作成して提案する",
        button: "開く"
    },
    email: {
        title: "メールでサポートに連絡する",
        description: "詳細情報やヘルプをご希望の場合は、私たちにメッセージを送ってください",
        button: "送信する"
    },
    reserve: {
        title: "Logto チームとの会議を予約",
        description: "ライブチャットのためにすぐにセッションを予約する",
        button: "予約する"
    }
};
var $7fbda3de6b4efa0c$export$2e2bcd8739ae039 = Object.freeze($7fbda3de6b4efa0c$var$contact);


const $b14661bc4465f152$var$dashboard = {
    page_title: "ダッシュボード",
    title: "ダッシュボード",
    description: "アプリのパフォーマンスについての概要を取得",
    total_users: "合計ユーザー数",
    total_users_tip: "合計ユーザー数",
    new_users_today: "本日の新規ユーザー",
    new_users_today_tip: "アプリに本日登録された新規ユーザーの数",
    new_users_7_days: "過去7日間の新規ユーザー",
    new_users_7_days_tip: "アプリに過去7日間に登録された新規ユーザーの数",
    daily_active_users: "1日あたりのアクティブユーザー",
    daily_active_users_tip: "アプリでトークンを交換したユニークユーザーの数",
    weekly_active_users: "週間アクティブユーザー",
    weekly_active_users_tip: "アプリで過去7日間にトークンを交換したユニークユーザーの数",
    monthly_active_users: "月間アクティブユーザー",
    monthly_active_users_tip: "アプリで過去30日間にトークンを交換したユニークユーザーの数"
};
var $b14661bc4465f152$export$2e2bcd8739ae039 = Object.freeze($b14661bc4465f152$var$dashboard);


const $e7dd1a76b3f5bdd4$var$domain = {
    status: {
        connecting: "接続中",
        in_used: "使用中",
        failed_to_connect: "接続に失敗しました"
    },
    update_endpoint_notice: "カスタムドメインを使用する場合は、アプリケーションのソーシャルコネクタコールバックURIとLogtoエンドポイントのドメインを更新することを忘れないでください。 <a>{{link}}</a>",
    error_hint: "{{value}} 秒後にもう一度確認するようにDNSレコードを更新してください。",
    custom: {
        custom_domain: "カスタムドメイン",
        custom_domain_description: "ブランディングを向上させるために、カスタムドメインを利用してください。このドメインは、サインインエクスペリエンスで使用されます。",
        custom_domain_field: "カスタムドメイン",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "ドメインを追加",
        invalid_domain_format: "無効なドメイン形式または少なくとも3つのサブドメインを含む有効なドメインを入力してください。",
        verify_domain: "ドメインを検証",
        enable_ssl: "SSLを有効にする",
        checking_dns_tip: "DNSレコードを設定したら、最大で24時間かかる自動プロセスを待つ必要があります。移動中や一時的に中断することができますが、この動作を削除しないでください。",
        enable_ssl_tip: "SSLを有効にするには、自動的に実行され、最大で24時間かかる場合があります。このインターフェースを実行中のままにしておくことができます。",
        generating_dns_records: "DNSレコードを生成しています...",
        add_dns_records: "DNSプロバイダに次のDNSレコードを追加してください。",
        dns_table: {
            type_field: "タイプ",
            name_field: "名前",
            value_field: "値"
        },
        deletion: {
            delete_domain: "ドメインを削除",
            reminder: "カスタムドメインの削除",
            description: "このカスタムドメインを削除してもよろしいですか？",
            in_used_description: "このカスタムドメイン「<span>{{domain}}</span>」を削除してもよろしいですか？",
            in_used_tip: "以前にソーシャルコネクタプロバイダまたはアプリ終了ポイントでこのカスタムドメインを使用して設定した場合、それらのURIをLogtoデフォルトドメイン「<span>{{domain}}</span>」に変更する必要があります。これは、ソーシャルサインインボタンを機能させるために必要です。",
            deleted: "カスタムドメインを正常に削除しました！"
        }
    },
    default: {
        default_domain: "デフォルトドメイン",
        default_domain_description: "Logtoは、追加のセットアップなしで使用できる事前に構成されたデフォルトドメインを提供しています。このデフォルトドメインは、カスタムドメインを有効にしていない場合でもバックアップオプションとして機能します。",
        default_domain_field: "Logtoデフォルトドメイン"
    },
    custom_endpoint_note: 'これらのエンドポイントのドメイン名を必要に応じてカスタマイズできます。 "{{custom}}" または "{{default}}" のいずれかを選択してください。',
    custom_social_callback_url_note: 'このURIのドメイン名をアプリケーションのエンドポイントに合わせてカスタマイズできます。 "{{custom}}" または "{{default}}" のいずれかを選択してください。'
};
var $e7dd1a76b3f5bdd4$export$2e2bcd8739ae039 = Object.freeze($e7dd1a76b3f5bdd4$var$domain);


const $8daa2bfc6a7d9a4b$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $8daa2bfc6a7d9a4b$export$2e2bcd8739ae039 = Object.freeze($8daa2bfc6a7d9a4b$var$enterprise_sso_details);


const $08d8343cea7fcaf7$var$enterprise_sso = {
    page_title: "エンタープライズSSO",
    title: "エンタープライズSSO",
    subtitle: "企業のアイデンティティプロバイダーとの接続を可能にし、SP主導のシングルサインオンを有効にします。",
    create: "エンタープライズコネクターを追加",
    col_connector_name: "コネクター名",
    col_type: "タイプ",
    col_email_domain: "メールドメイン",
    placeholder_title: "エンタープライズコネクター",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "エンタープライズコネクターを追加",
        text_divider: "または、標準プロトコルによってカスタマイズされたコネクターを作成できます。",
        connector_name_field_title: "コネクター名",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "コネクターを作成"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $08d8343cea7fcaf7$export$2e2bcd8739ae039 = Object.freeze($08d8343cea7fcaf7$var$enterprise_sso);


const $13b8c4682829fb31$var$errors = {
    something_went_wrong: "Oops！何か問題が発生しました。",
    page_not_found: "ページが見つかりません",
    unknown_server_error: "不明なサーバーエラーが発生しました",
    empty: "データなし",
    missing_total_number: "レスポンスヘッダーでTotal-Numberが見つかりません",
    invalid_uri_format: "無効なURI形式",
    invalid_origin_format: "無効なURIの起源の形式",
    invalid_json_format: "無効なJSON形式",
    invalid_error_message_format: "エラーメッセージの形式が無効です。",
    required_field_missing: "{{field}}を入力してください",
    required_field_missing_plural: "少なくとも1つの{{field}}を入力する必要があります",
    more_details: "詳細を見る",
    username_pattern_error: "ユーザー名には、文字、数字、またはアンダースコアしか含めることができず、数字で始めることはできません。",
    email_pattern_error: "メールアドレスが無効です。",
    phone_pattern_error: "電話番号が無効です。",
    insecure_contexts: "安全でないコンテキスト（ノンHTTP）はサポートされていません。",
    unexpected_error: "予期しないエラーが発生しました。",
    not_found: "404が見つかりません",
    create_internal_role_violation: "新しい内部ロールを作成しているため、Logtoによって禁止されています。 「#internal：」で始まらない別の名前を試してください。",
    should_be_an_integer: "整数である必要があります。",
    number_should_be_between_inclusive: "{{min}}から{{max}}（両方含む）までの数値である必要があります。"
};
var $13b8c4682829fb31$export$2e2bcd8739ae039 = Object.freeze($13b8c4682829fb31$var$errors);


const $143b4b46f881bc37$var$general = {
    placeholder: "プレースホルダー",
    submit: "送信",
    skip: "スキップ",
    next: "次へ",
    back: "戻る",
    retry: "もう一度試す",
    done: "完了",
    search: "検索",
    search_placeholder: "検索",
    clear_result: "検索結果をクリアする",
    save: "保存",
    save_changes: "変更を保存する",
    saved: "保存しました",
    discard: "破棄する",
    loading: "読み込み中...",
    redirecting: "リダイレクト中...",
    add: "追加",
    added: "追加されました",
    cancel: "キャンセル",
    confirm: "確認",
    check_out: "チェックアウト",
    create: "作成する",
    set_up: "設定する",
    customize: "カスタマイズする",
    enable: "有効にする",
    reminder: "リマインダー",
    delete: "削除",
    more_options: "その他のオプション",
    close: "閉じる",
    copy: "コピーする",
    copying: "コピー中",
    copied: "コピーされました",
    required: "必須",
    add_another: "もう一つ追加",
    create_another: "もう一つ作成する",
    deletion_confirmation: "{{title}}を削除してよろしいですか？",
    settings_nav: "設定",
    unsaved_changes_warning: "変更を加えました。このページを離れてもよろしいですか？",
    leave_page: "ページを離れる",
    stay_on_page: "ページにとどまる",
    type_to_search: "検索する",
    got_it: "了解",
    continue: "続ける",
    page_info: "{{total}}件中{{min}}件〜{{max}}件を表示",
    learn_more: "詳しく見る",
    tab_errors: "{{count}}件のエラーがあります",
    skip_for_now: "今回はスキップする",
    remove: "削除する",
    visit: "訪問する",
    join: "参加する",
    try_now: "今すぐ試す",
    multiple_form_field: "(複数)",
    demo: "デモ",
    unnamed: "名前がありません",
    view: "表示",
    hide: "非表示",
    unknown_error: "不明なエラーが発生しました。後で再試行してください。",
    select: "選択する",
    contact_us_action: "お問い合わせ",
    description: "説明",
    name: "名前",
    add_field: "{{field}}を追加",
    create_field: "{{field}}を作成",
    edit_field: "{{field}}を編集",
    delete_field: "{{field}}を削除",
    coming_soon: "近日公開予定",
    beta_notice: "\uD83C\uDF89  {{feature}} は現在ベータ版です。お試しいただき、<ContactLink>フィードバックを共有</ContactLink>してください。"
};
var $143b4b46f881bc37$export$2e2bcd8739ae039 = Object.freeze($143b4b46f881bc37$var$general);


const $929fa0806c26a61c$var$get_started = {
    page_title: "はじめに",
    title: "あなたの成功を手助けする探索",
    subtitle: "Logtoの価値を迅速に把握するための数つの方法",
    develop: {
        title: "Develop: 5分の時間を使ってアプリを統合してみましょう"
    },
    customize: {
        title: "Customize: 素晴らしいサインイン体験を提供する",
        preview: {
            title: "あなたがカスタマイズしたサインイン体験のライブプレビューをチェックしましょう",
            subtitle: "Logtoのサインイン体験を試して、その使い方を確認してください"
        },
        connector: {
            title: "さらなるコネクタを追加して、さまざまなソーシャルサインイン方式をサポートしましょう",
            subtitle: "パスワードレスサインインを試して、顧客に安全かつ摩擦のない体験を提供しましょう"
        },
        continue_customizing: "カスタマイズを続ける",
        try_now: "今すぐ試す",
        add_more: "もっと追加する"
    },
    secure: {
        title: "Secure: リソースを保護する"
    },
    manage: {
        title: "Manage: 製品とユーザーのアクセス制御を定義する",
        rbac: {
            title: "ロールベースのアクセス制御を追加して、リソースを保護する",
            subtitle: "多様なユースケースに対してスケーラブルなロールの認可によりリソースを制御します"
        },
        create_roles: "ロールを作成する"
    },
    view_all: "すべての内容を表示 →"
};
var $929fa0806c26a61c$export$2e2bcd8739ae039 = Object.freeze($929fa0806c26a61c$var$get_started);


const $6e744d320636719e$var$guide = {
    start_building: "プロジェクトを開始",
    get_started: "はじめる",
    categories: {
        featured: "人気でおすすめ",
        Traditional: "伝統的な Web アプリ",
        SPA: "シングルページアプリ",
        Native: "ネイティブ",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "フレームワークを絞り込む",
        placeholder: "フレームワークを検索"
    },
    checkout_tutorial: "チュートリアルを確認: {{name}}",
    do_not_need_tutorial: "もしチュートリアルが必要なければ、フレームワークガイドなしで続行できます",
    finish_and_done: "完了",
    cannot_find_guide: "ガイドが見つかりません",
    describe_guide_looking_for: "お探しのガイドの詳細を説明してください",
    request_guide_successfully: "リクエストが送信されました。ありがとうございます！",
    app: {
        select_framework_or_tutorial: "フレームワークまたはチュートリアルを選択",
        guide_modal_title: "SDK とガイドで開始",
        modal_subtitle: "私たちの事前ビルドされた SDK とチュートリアルを使用してアプリ開発プロセスをスタートさせます。",
        select_a_framework: "フレームワークを選択",
        continue_without_framework: "フレームワークなしで作成",
        describe_guide_looking_for_placeholder: "例: Logto を Angular アプリに統合したい"
    },
    api: {
        modal_title: "チュートリアルで開始",
        modal_subtitle: "前もってビルドされたチュートリアルでアプリ開発を加速します",
        select_a_tutorial: "チュートリアルを選択",
        continue_without_tutorial: "チュートリアルなしで続行",
        describe_guide_looking_for_placeholder: "例: API を deno で保護したい"
    }
};
var $6e744d320636719e$export$2e2bcd8739ae039 = Object.freeze($6e744d320636719e$var$guide);


const $602ff41821c8dfbc$var$log_details = {
    page_title: "監査ログの詳細",
    back_to_logs: "監査ログに戻る",
    back_to: "{{name}}に戻る",
    success: "成功",
    failed: "失敗",
    event_key: "イベントキー",
    application: "アプリケーション",
    ip_address: "IPアドレス",
    user: "ユーザー",
    log_id: "ログID",
    time: "時間",
    user_agent: "ユーザーエージェント",
    tab_details: "詳細",
    raw_data: "生データ"
};
var $602ff41821c8dfbc$export$2e2bcd8739ae039 = Object.freeze($602ff41821c8dfbc$var$log_details);


const $843588991176ce2c$var$logs = {
    page_title: "監査ログ",
    title: "監査ログ",
    subtitle: "ユーザーによって行われた認証イベントのログデータを表示します",
    event: "イベント",
    user: "ユーザー",
    application: "アプリケーション",
    time: "時間",
    filter_by: "フィルター"
};
var $843588991176ce2c$export$2e2bcd8739ae039 = Object.freeze($843588991176ce2c$var$logs);


const $1d22e23efbe845fb$var$menu = {
    profile: "プロフィール",
    language: "言語",
    appearance: {
        label: "外観",
        light: "ライトモード",
        dark: "ダークモード",
        system: "システムと同期"
    },
    sign_out: "ログアウト"
};
var $1d22e23efbe845fb$export$2e2bcd8739ae039 = Object.freeze($1d22e23efbe845fb$var$menu);


const $86d0d07d36bd2053$var$mfa = {
    title: "マルチファクタ認証",
    description: "サインインエクスペリエンスのセキュリティを向上させるためにマルチファクタ認証を追加します。",
    factors: "要因",
    multi_factors: "マルチファクタ",
    multi_factors_description: "ユーザーは2段階認証のために有効になっている要因のうちの1つを検証する必要があります。",
    totp: "認証アプリ OTP",
    otp_description: "Google Authenticatorなどをリンクしてワンタイムパスワードを検証します。",
    webauthn: "WebAuthn（パスキー）",
    webauthn_description: "ブラウザでサポートされている方法を使用して検証します：生体認証、電話のスキャン、またはセキュリティキーなど。",
    webauthn_native_tip: "WebAuthnはネイティブアプリケーションではサポートされていません。",
    webauthn_domain_tip: "WebAuthnは公開鍵を特定のドメインにバインドします。サービスのドメインを変更すると、既存のパスキーを使用したユーザーの認証がブロックされます。",
    backup_code: "バックアップコード",
    backup_code_description: "ユーザーが任意のMFAメソッドを設定した後に10個のワンタイムバックアップコードを生成します。",
    backup_code_setup_hint: "上記のMFA要因を検証できない場合は、バックアップオプションを使用します。",
    backup_code_error_hint: "バックアップコードを使用するには、成功したユーザー認証のために少なくとも1つ以上のMFAメソッドが必要です。",
    policy: "ポリシー",
    policy_description: "サインインおよびサインアップフローのためのMFAポリシーを設定します。",
    two_step_sign_in_policy: "サインイン時の2段階認証ポリシー",
    user_controlled: "ユーザーは自分でMFAを有効または無効にできます",
    user_controlled_tip: "ユーザーは最初のサインインまたはサインアップ時にMFAのセットアップをスキップしたり、アカウント設定で有効/無効にしたりできます。",
    mandatory: "ユーザーは常にサインイン時にMFAの使用が必要です",
    mandatory_tip: "ユーザーは最初のサインインまたはサインアップ時にMFAを設定し、将来のすべてのサインインでそれを使用する必要があります。"
};
var $86d0d07d36bd2053$export$2e2bcd8739ae039 = Object.freeze($86d0d07d36bd2053$var$mfa);


const $66f035958e903930$var$organization_details = {
    page_title: "組織の詳細",
    delete_confirmation: "削除すると、すべてのメンバーが組織内のメンバーシップとロールを失います。この操作は元に戻せません。",
    organization_id: "組織ID",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "組織の名前。一意である必要はありません。",
    description_placeholder: "組織の説明。",
    member: "メンバー",
    member_other: "メンバー",
    add_members_to_organization: "組織 {{name}} にメンバーを追加",
    add_members_to_organization_description: "名前、メール、電話、またはユーザーIDで検索して適切なユーザーを見つけます。検索結果には既存のメンバーは表示されません。",
    add_with_organization_role: "組織の役割付きで追加",
    user: "ユーザー",
    authorize_to_roles: "{{name}} に以下の役割へのアクセスを許可",
    edit_organization_roles: "組織の役割を編集",
    edit_organization_roles_of_user: "{{name}} の組織の役割を編集",
    remove_user_from_organization: "組織からユーザーを削除",
    remove_user_from_organization_description: "削除すると、ユーザーは組織内のメンバーシップとロールを失います。この操作は元に戻せません。",
    search_user_placeholder: "名前、メール、電話番号、またはユーザーIDで検索",
    at_least_one_user: "少なくとも1人のユーザーが必要です。"
};
var $66f035958e903930$export$2e2bcd8739ae039 = Object.freeze($66f035958e903930$var$organization_details);


const $96f1ee97eb4d5104$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "組織",
    title: "組織",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "組織ID",
    members: "メンバー",
    create_organization: "組織を作成",
    setup_organization: "組織を設定",
    organization_list_placeholder_title: "組織",
    organization_list_placeholder_text: "組織は、通常、SaaSまたはSaaSのようなマルチテナントアプリで使用されます。組織機能により、B2B顧客はパートナーや顧客をよりよく管理し、エンドユーザーがアプリケーションにアクセスする方法をカスタマイズできます。",
    organization_name_placeholder: "私の組織",
    organization_description_placeholder: "組織の簡単な説明",
    organization_permission: "組織権限",
    organization_permission_other: "組織権限",
    organization_permission_description: "組織権限とは、組織のコンテキストでリソースにアクセスするための承認を指します。組織権限は、意味のある文字列として表され、また名前および一意の識別子としても機能します。",
    organization_permission_delete_confirm: "この権限を削除すると、この権限を含むすべての組織ロールがこの権限を失い、この権限を持っていたユーザーはそのアクセスを失います。",
    create_permission_placeholder: "任命履歴を読む",
    permission: "権限",
    permission_other: "権限",
    organization_role: "組織役割",
    organization_role_other: "組織役割",
    organization_role_description: "組織役割は、ユーザーに割り当てることができる権限のグループ化です。権限は事前に定義された組織権限から取得する必要があります。",
    organization_role_delete_confirm: "これを行うと、影響を受けるユーザーからこの役割に関連する権限が削除され、組織ロール、組織のメンバー、および組織権限の関係が削除されます。",
    role: "役割",
    create_role_placeholder: "閲覧のみの権限を持つユーザー",
    search_placeholder: "組織名またはIDで検索",
    search_permission_placeholder: "検索して権限を選択",
    search_role_placeholder: "検索して役割を選択",
    empty_placeholder: "\uD83E\uDD14 You don’t have any {{entity}} set up yet.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "ガイドで始める",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "イラストを操作して、接続方法を確認してください",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "ステップ1：組織権限を定義する",
        step_2: "ステップ2：組織役割を定義する",
        step_3: "ステップ3：最初の組織を作成する",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $96f1ee97eb4d5104$export$2e2bcd8739ae039 = Object.freeze($96f1ee97eb4d5104$var$organizations);


const $3c7461abff72f631$var$permissions = {
    search_placeholder: "APIまたは権限名で検索",
    search_placeholder_without_api: "権限名で検索",
    name_column: "権限",
    description_column: "説明",
    api_column: "API",
    placeholder_title: "権限",
    placeholder_description: "権限はリソース（APIリソースと呼んでいます）にアクセスするための承認を指します。"
};
var $3c7461abff72f631$export$2e2bcd8739ae039 = Object.freeze($3c7461abff72f631$var$permissions);


const $4dc863138f4141a2$var$profile = {
    page_title: "アカウント設定",
    title: "アカウント設定",
    description: "アカウントのセキュリティを確保するため、ここでアカウント設定と個人情報の管理を変更できます。",
    settings: {
        title: "プロファイル設定",
        profile_information: "プロファイル情報",
        avatar: "アバター",
        name: "名前",
        username: "ユーザー名"
    },
    link_account: {
        title: "アカウントをリンク",
        email_sign_in: "Email sign-In",
        email: "Eメール",
        social_sign_in: "ソーシャルサインイン",
        link_email: "Eメールのリンク",
        link_email_subtitle: "ログインにEメールをリンクするか、アカウントの回復をお手伝いします。",
        email_required: "Eメールが必要です",
        invalid_email: "無効なEメールアドレス",
        identical_email_address: "入力したEメールアドレスは現在のものと同じです",
        anonymous: "匿名"
    },
    password: {
        title: "パスワードとセキュリティ",
        password: "パスワード",
        password_setting: "パスワード設定",
        new_password: "新しいパスワード",
        confirm_password: "パスワードの確認",
        enter_password: "現在のパスワードを入力してください",
        enter_password_subtitle: "アカウントのセキュリティを保護するためにあなたが本人であることを確認してください。変更する前に現在のパスワードを入力してください。",
        set_password: "パスワードを設定する",
        verify_via_password: "パスワードを使って確認する",
        show_password: "パスワードを表示する",
        required: "パスワードが必要です",
        do_not_match: "パスワードが一致しません。もう一度お試しください。"
    },
    code: {
        enter_verification_code: "検証コードを入力してください",
        enter_verification_code_subtitle: "検証コードは <strong>{{target}}</strong> に送信されました。",
        verify_via_code: "検証コードを使用して確認する",
        resend: "検証コードを再送信する",
        resend_countdown: "{{countdown}} 秒後に再送信する"
    },
    delete_account: {
        title: "アカウントを削除",
        label: "アカウントを削除",
        description: "アカウントの削除は、すべての個人情報、ユーザーデータ、および設定が削除されます。このアクションは元に戻せません。",
        button: "アカウントを削除",
        dialog_paragraph_1: "アカウントを削除したいというお知らせを受け取りましたこと、残念に思います。 アカウントを削除すると、ユーザー情報、ログ、設定を含むすべてのデータが永久に削除されます。そのため、手続きを進める前に、重要なデータをバックアップすることを必ずお願いします。",
        dialog_paragraph_2: "アカウント削除プロセスを進めるには、「アカウント削除リクエスト」という件名で<a>{{mail}}</a>にメールを送信して、当社のサポートチームにお問い合わせください。私たちはあなたをサポートし、すべてのデータが正しくシステムから削除されるようにします。",
        dialog_paragraph_3: "Logto Cloudをご利用いただきありがとうございます。ご質問やご不明な点がある場合は、お気軽にお問い合わせください。"
    },
    set: "設定する",
    change: "変更する",
    link: "リンクする",
    unlink: "リンクを解除する",
    not_set: "設定されていません",
    change_avatar: "アバターを変更する",
    change_name: "名前を変更する",
    change_username: "ユーザー名を変更する",
    set_name: "名前を設定する",
    email_changed: "Eメールが変更されました。",
    password_changed: "パスワードが変更されました。",
    updated: "{{target}} が更新されました。",
    linked: "{{target}} がリンクされました。",
    unlinked: "{{target}} のリンクが解除されました。",
    email_exists_reminder: "このEメール{{email}}は、既存のアカウントに関連付けられています。ここで別のEメールをリンクしてください。",
    unlink_confirm_text: "はい、リンクを解除します",
    unlink_reminder: "リンクを解除すると、ユーザーは<span></span>アカウントでサインインできなくなります。本当に進めますか？"
};
var $4dc863138f4141a2$export$2e2bcd8739ae039 = Object.freeze($4dc863138f4141a2$var$profile);


const $c447906bd5a33d89$var$role_details = {
    back_to_roles: "ロールに戻る",
    identifier: "識別子",
    delete_description: "これを行うと、このロールに関連付けられた許可が影響を受けるユーザーから削除され、ロール、ユーザー、および許可のマッピングが削除されます。",
    role_deleted: "{{name}} は正常に削除されました。",
    settings_tab: "設定",
    users_tab: "ユーザー",
    m2m_apps_tab: "機械対機械のアプリ",
    permissions_tab: "許可",
    settings: "設定",
    settings_description: "ロールは、ユーザーに割り当てることができる許可のグループ化です。また、異なるAPIに対して定義された許可を集約する方法を提供し、ユーザーに個別に割り当てるよりも許可を追加、削除、または調整するのに効率的です。",
    field_name: "名前",
    field_description: "説明",
    type_m2m_role_tag: "機械対機械のアプリのロール",
    type_user_role_tag: "ユーザーロール",
    permission: {
        assign_button: "許可を割り当てる",
        assign_title: "許可の割り当て",
        assign_subtitle: "このロールに許可を割り当てます。ロールには追加された許可が追加され、このロールを持つユーザーはこれらの許可を継承します。",
        assign_form_field: "許可を割り当てる",
        added_text_one: "{{count, number}} 個の許可が追加されました",
        added_text_other: "{{count, number}} 個の許可が追加されました",
        api_permission_count_one: "{{count, number}} 個の許可",
        api_permission_count_other: "{{count, number}} 個の許可",
        confirm_assign: "許可を割り当てる",
        permission_assigned: "選択した許可は、このロールに正常に割り当てられました",
        deletion_description: "この許可が削除されると、このロールの影響を受けるユーザーは、この許可によって付与されたアクセス権を失います。",
        permission_deleted: '許可 "{{name}}" がこのロールから正常に削除されました',
        empty: "使用可能な許可はありません"
    },
    users: {
        assign_button: "ユーザーを割り当てる",
        name_column: "ユーザー",
        app_column: "アプリ",
        latest_sign_in_column: "最新サインイン",
        delete_description: "ユーザープールには残りますが、このロールに対する認可を失います。",
        deleted: "{{name}} はこのロールから正常に削除されました",
        assign_title: "ユーザーを割り当てる",
        assign_subtitle: "ユーザーをこのロールに割り当てます。名前、電子メール、電話、またはユーザーIDで検索して適切なユーザーを見つけます。",
        assign_field: "ユーザーを割り当てる",
        confirm_assign: "ユーザーを割り当てる",
        assigned_toast_text: "選択したユーザーがこのロールに正常に割り当てられました",
        empty: "使用可能なユーザーはありません"
    },
    applications: {
        assign_button: "アプリケーションを割り当てる",
        name_column: "アプリケーション",
        app_column: "アプリ",
        description_column: "説明",
        delete_description: "アプリケーションプールには残りますが、このロールに対する認可を失います。",
        deleted: "{{name}} はこのロールから正常に削除されました",
        assign_title: "アプリケーションを割り当てる",
        assign_subtitle: "このロールにアプリケーションを割り当てます。名前、説明、またはアプリIDで検索して適切なアプリケーションを見つけます。",
        assign_field: "アプリケーションを割り当てる",
        confirm_assign: "アプリケーションを割り当てる",
        assigned_toast_text: "選択したアプリケーションがこのロールに正常に割り当てられました",
        empty: "利用可能なアプリケーションはありません"
    }
};
var $c447906bd5a33d89$export$2e2bcd8739ae039 = Object.freeze($c447906bd5a33d89$var$role_details);


const $8c6e5b58e568cd36$var$roles = {
    page_title: "ロール",
    title: "ロール",
    subtitle: "ロールには、ユーザーが実行できるアクションを決定する権限が含まれます。RBACは、特定のアクションのためにリソースにアクセスするためにユーザーに権限を付与するために、ロールを使用します。",
    create: "ロールを作成する",
    role_name: "役割名",
    role_type: "役割タイプ",
    show_role_type_button_text: "さらにオプションを表示",
    hide_role_type_button_text: "さらにオプションを非表示",
    type_user: "ユーザーの役割",
    type_machine_to_machine: "マシン対マシンアプリの役割",
    role_description: "説明",
    role_name_placeholder: "ロールの名前を入力してください",
    role_description_placeholder: "ロールの説明を入力してください",
    col_roles: "ロール",
    col_type: "タイプ",
    col_description: "説明",
    col_assigned_entities: "割り当てられました",
    user_counts: "{{count}} ユーザー",
    application_counts: "{{count}} アプリ",
    user_count: "{{count}} ユーザー",
    application_count: "{{count}} アプリ",
    assign_permissions: "権限の割り当て",
    create_role_title: "ロールを作成する",
    create_role_description: "アプリケーションのロールを作成して管理します。ロールには権限のコレクションが含まれ、ユーザーに割り当てることができます。",
    create_role_button: "ロールを作成する",
    role_created: "{{name}}ロールが正常に作成されました。",
    search: "ロール名、説明、またはIDで検索",
    placeholder_title: "ロール",
    placeholder_description: "ロールは、ユーザーに割り当てられる権限のグループです。ロールを作成する前に、まず権限を追加してください。"
};
var $8c6e5b58e568cd36$export$2e2bcd8739ae039 = Object.freeze($8c6e5b58e568cd36$var$roles);


const $a34771c81ffe02d2$var$session_expired = {
    title: "セッションの有効期限が切れました",
    subtitle: "セッションの有効期限が切れ、切断されました。以下のボタンをクリックして再度管理コンソールにサインインしてください。",
    button: "再度サインイン"
};
var $a34771c81ffe02d2$export$2e2bcd8739ae039 = Object.freeze($a34771c81ffe02d2$var$session_expired);


const $0ea8e51261370e09$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $0ea8e51261370e09$export$2e2bcd8739ae039 = Object.freeze($0ea8e51261370e09$var$content);


const $a20a40d0a4a6bfb5$var$password_policy = {
    password_requirements: "パスワードの要件",
    minimum_length: "最小の長さ",
    minimum_length_description: "NISTは、Web製品に対して少なくとも8文字を使用することを提案しています。",
    minimum_length_error: "最小の長さは {{min}} から {{max}}（両方含む）の間でなければなりません。",
    minimum_required_char_types: "必要な文字の種類の最小数",
    minimum_required_char_types_description: "文字の種類：大文字（A-Z）、小文字（a-z）、数字（0-9）、特殊記号（{{symbols}}）。",
    password_rejection: "パスワードの拒否",
    compromised_passwords: "危険なパスワードの拒否",
    breached_passwords: "漏洩したパスワードの拒否",
    breached_passwords_description: "以前に漏洩したデータベースで見つかったパスワードを拒否します。",
    restricted_phrases: "低セキュリティフレーズの制限",
    restricted_phrases_tooltip: "パスワードにこれらのフレーズを使用しないでください。ただし、追加の文字を3文字以上組み合わせる場合は例外です。",
    repetitive_or_sequential_characters: "繰り返しまたは連続する文字",
    repetitive_or_sequential_characters_description: "「AAAA」、「1234」、「abcd」などです。",
    user_information: "ユーザー情報",
    user_information_description: "例: メールアドレス、電話番号、ユーザー名など。",
    custom_words: "カスタムワード",
    custom_words_description: "特定の文脈に関連するワードを、大文字小文字を区別せずに、1つの行に1つずつ追加します。",
    custom_words_placeholder: "サービス名、会社名など"
};
var $a20a40d0a4a6bfb5$export$2e2bcd8739ae039 = Object.freeze($a20a40d0a4a6bfb5$var$password_policy);


const $38d31d98117737d2$var$sign_up_and_sign_in = {
    identifiers_email: "メールアドレス",
    identifiers_phone: "電話番号",
    identifiers_username: "ユーザー名",
    identifiers_email_or_sms: "メールアドレスまたは電話番号",
    identifiers_none: "該当なし",
    and: "および",
    or: "または",
    sign_up: {
        title: "サインアップ",
        sign_up_identifier: "サインアップ識別子",
        identifier_description: "サインアップ識別子はアカウント作成に必要で、サインイン画面に含める必要があります。",
        sign_up_authentication: "サインアップの認証設定",
        authentication_description: "選択したすべてのアクションは、ユーザーがフローを完了するために必須です。",
        set_a_password_option: "パスワードの設定",
        verify_at_sign_up_option: "サインアップ時に確認する",
        social_only_creation_description: "（これはソーシャルアカウント作成に適用されます）"
    },
    sign_in: {
        title: "サインイン",
        sign_in_identifier_and_auth: "サインインの識別子と認証設定",
        description: "ユーザーは利用可能なすべてのオプションを使用してサインインできます。下のオプションをドラッグ&ドロップしてレイアウトを調整してください。",
        add_sign_in_method: "サインイン方法を追加",
        password_auth: "パスワード",
        verification_code_auth: "確認コード",
        auth_swap_tip: "以下のオプションを交換して、フローで最初に表示されるオプションを決定します。",
        require_auth_factor: "少なくとも1つの認証要素を選択する必要があります。"
    },
    social_sign_in: {
        title: "ソーシャルサインイン",
        social_sign_in: "ソーシャルサインイン",
        description: "設定した必須識別子に応じて、ユーザーはソーシャルコネクタを介してサインアップする際に識別子を提供するよう求められる場合があります。",
        add_social_connector: "ソーシャルコネクタを追加",
        set_up_hint: {
            not_in_list: "一覧にない場合は?",
            set_up_more: "設定",
            go_to: "他のソーシャルコネクタに移動します。"
        }
    },
    tip: {
        set_a_password: "ユーザー名にユニークなパスワードを設定することが重要です。",
        verify_at_sign_up: "現在、検証されたメールアドレスのみをサポートしています。検証がない場合、ユーザーベースには低品質のメールアドレスが多数含まれる場合があります。",
        password_auth: "これは、サインアッププロセス中にパスワードを設定するオプションを有効にした場合に必要です。",
        verification_code_auth: "これは、サインアップ時に確認コードの提供オプションのみを有効にした場合に必要です。サインアッププロセスでパスワード設定を許可する場合は、ボックスのチェックを外してもかまいません。",
        delete_sign_in_method: "これは{{identifier}}を必須の識別子として選択した場合に必要です。"
    },
    advanced_options: {
        title: "高度なオプション",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "ユーザー登録を有効にする",
        enable_user_registration_description: "ユーザー登録を有効にするか無効にすることができます。無効にした場合、ユーザーは管理コンソールで追加することはできますが、サインイン画面を介してアカウントを作成することはできなくなります。"
    }
};
var $38d31d98117737d2$export$2e2bcd8739ae039 = Object.freeze($38d31d98117737d2$var$sign_up_and_sign_in);


const $776ec44883c4ae9a$var$sign_in_exp = {
    page_title: "サインインエクスペリエンス",
    title: "サインインエクスペリエンス",
    description: "ブランドに合わせてサインインUIをカスタマイズし、リアルタイムで表示できます。",
    tabs: {
        branding: "ブランディング",
        sign_up_and_sign_in: "サインアップとサインイン",
        content: "内容",
        password_policy: "パスワードポリシー"
    },
    welcome: {
        title: "サインインエクスペリエンスをカスタマイズ",
        description: "最初のサインイン設定をスムーズに始めましょう。このガイドでは、必要なすべての設定を説明します。",
        get_started: "開始",
        apply_remind: "サインインエクスペリエンスは、このアカウントのすべてのアプリケーションに適用されます。"
    },
    color: {
        title: "カラー",
        primary_color: "ブランドカラー",
        dark_primary_color: "ブランドカラー（ダーク）",
        dark_mode: "ダークモードを有効にする",
        dark_mode_description: "あなたのアプリは、ブランドカラーとLogtoアルゴリズムに基づいて自動生成されたダークモードのテーマを持っています。自由にカスタマイズしてください。",
        dark_mode_reset_tip: "ブランドカラーに基づいてダークモードの色を再計算します。",
        reset: "リセット"
    },
    branding: {
        title: "ブランディングエリア",
        ui_style: "スタイル",
        favicon: "ファビコン",
        logo_image_url: "アプリのロゴ画像URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "アプリのロゴ画像URL（ダーク）",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "アプリのロゴ",
        dark_logo_image: "アプリのロゴ（ダーク）",
        logo_image_error: "アプリのロゴ：{{error}}",
        favicon_error: "ファビコン：{{error}}"
    },
    custom_css: {
        title: "カスタムCSS",
        css_code_editor_title: "カスタムCSSでUIをパーソナライズ",
        css_code_editor_description1: "カスタムCSSの例を見てください。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "さらに詳しく",
        css_code_editor_content_placeholder: "カスタムCSSを入力して、すべてのスタイルをあなたの仕様に合わせて調整します。クリエイティビティを発揮して、UIを際立たせましょう。"
    },
    sign_up_and_sign_in: $38d31d98117737d2$export$2e2bcd8739ae039,
    content: $0ea8e51261370e09$export$2e2bcd8739ae039,
    password_policy: $a20a40d0a4a6bfb5$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "まだSMSコネクタが設定されていません。構成を完了する前に、この方法でのサインインはできません。<a>{{link}}</a>「コネクタ」に移動してください",
        no_connector_email: "まだメールコネクタが設定されていません。構成を完了する前に、この方法でのサインインはできません。<a>{{link}}</a>「コネクタ」に移動してください",
        no_connector_social: "まだソーシャルコネクタを設定していません。ソーシャルサインインの方法を適用するには、まずコネクタを追加してください。<a>{{link}}</a> の中で「コネクタ」をご覧ください。",
        setup_link: "設定"
    },
    save_alert: {
        description: "新しいサインイン方法やサインアップ手順を導入しています。すべてのユーザーに影響がある可能性があります。変更を実行する場合は、よろしいですか？",
        before: "変更前",
        after: "変更後",
        sign_up: "サインアップ",
        sign_in: "サインイン",
        social: "ソーシャル"
    },
    preview: {
        title: "サインインプレビュー",
        live_preview: "ライブプレビュー",
        live_preview_tip: "変更を保存してプレビュー",
        native: "ネイティブ",
        desktop_web: "デスクトップWeb",
        mobile_web: "モバイルWeb",
        desktop: "デスクトップ",
        mobile: "モバイル"
    }
};
var $776ec44883c4ae9a$export$2e2bcd8739ae039 = Object.freeze($776ec44883c4ae9a$var$sign_in_exp);


const $d5294e9d046864da$var$quota_item = {
    tenant_limit: {
        name: "テナント",
        limited: "{{count, number}} テナント",
        limited_other: "{{count, number}} テナント",
        unlimited: "無制限のテナント",
        not_eligible: "テナントを削除してください"
    },
    mau_limit: {
        name: "月間アクティブユーザー数",
        limited: "{{count, number}} MAU",
        unlimited: "無制限のMAU",
        not_eligible: "全てのユーザーを削除してください"
    },
    applications_limit: {
        name: "アプリケーション",
        limited: "{{count, number}} アプリケーション",
        limited_other: "{{count, number}} アプリケーション",
        unlimited: "無制限のアプリケーション",
        not_eligible: "アプリケーションを削除してください"
    },
    machine_to_machine_limit: {
        name: "マシン間アプリケーション",
        limited: "{{count, number}} マシン間アプリケーション",
        limited_other: "{{count, number}} マシン間アプリケーション",
        unlimited: "無制限のマシン間アプリケーション",
        not_eligible: "マシン間アプリケーションを削除してください"
    },
    resources_limit: {
        name: "APIリソース",
        limited: "{{count, number}} APIリソース",
        limited_other: "{{count, number}} APIリソース",
        unlimited: "無制限のAPIリソース",
        not_eligible: "APIリソースを削除してください"
    },
    scopes_per_resource_limit: {
        name: "リソースの権限",
        limited: "{{count, number}} リソースごとの権限",
        limited_other: "{{count, number}} リソースごとの権限",
        unlimited: "無制限のリソースごとの権限",
        not_eligible: "リソースの権限を削除してください"
    },
    custom_domain_enabled: {
        name: "カスタムドメイン",
        limited: "カスタムドメイン",
        unlimited: "カスタムドメイン",
        not_eligible: "カスタムドメインを削除してください"
    },
    omni_sign_in_enabled: {
        name: "Omniサインイン",
        limited: "Omniサインイン",
        unlimited: "Omniサインイン",
        not_eligible: "Omniサインインを無効にしてください"
    },
    built_in_email_connector_enabled: {
        name: "組込みメールコネクタ",
        limited: "組込みメールコネクタ",
        unlimited: "組込みメールコネクタ",
        not_eligible: "組込みメールコネクタを削除してください"
    },
    social_connectors_limit: {
        name: "ソーシャルコネクタ",
        limited: "{{count, number}} ソーシャルコネクタ",
        limited_other: "{{count, number}} ソーシャルコネクタ",
        unlimited: "無制限のソーシャルコネクタ",
        not_eligible: "ソーシャルコネクタを削除してください"
    },
    standard_connectors_limit: {
        name: "無料の標準コネクタ",
        limited: "{{count, number}} 無料の標準コネクタ",
        limited_other: "{{count, number}} 無料の標準コネクタ",
        unlimited: "無制限の標準コネクタ",
        not_eligible: "標準コネクタを削除してください"
    },
    roles_limit: {
        name: "ロール",
        limited: "{{count, number}} ロール",
        limited_other: "{{count, number}} ロール",
        unlimited: "無制限のロール",
        not_eligible: "ロールを削除してください"
    },
    scopes_per_role_limit: {
        name: "ロールの権限",
        limited: "{{count, number}} ロールごとの権限",
        limited_other: "{{count, number}} ロールごとの権限",
        unlimited: "無制限のロールごとの権限",
        not_eligible: "ロールの権限を削除してください"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}}個のWebhook",
        limited_other: "{{count, number}}個のWebhooks",
        unlimited: "無制限のWebhooks",
        not_eligible: "Webhookを削除してください"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "監査ログの保持期間",
        limited: "監査ログの保持期間: {{count, number}} 日",
        limited_other: "監査ログの保持期間: {{count, number}} 日",
        unlimited: "無制限の日数",
        not_eligible: "監査ログがありません"
    },
    community_support_enabled: {
        name: "コミュニティサポート",
        limited: "コミュニティサポート",
        unlimited: "コミュニティサポート",
        not_eligible: "コミュニティサポートなし"
    },
    customer_ticket_support: {
        name: "顧客チケットサポート",
        limited: "{{count, number}} 時間の顧客チケットサポート",
        limited_other: "{{count, number}} 時間の顧客チケットサポート",
        unlimited: "顧客チケットサポート",
        not_eligible: "顧客チケットサポートなし"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "MFAを無効にする"
    },
    sso_enabled: {
        name: "エンタープライズSSO",
        limited: "エンタープライズSSO",
        unlimited: "エンタープライズSSO",
        not_eligible: "エンタープライズSSOを無効にする"
    }
};
var $d5294e9d046864da$export$2e2bcd8739ae039 = Object.freeze($d5294e9d046864da$var$quota_item);


const $3d3b2d663001d50d$var$quota_table = {
    quota: {
        title: "クォータ",
        tenant_limit: "テナント制限",
        base_price: "基本価格",
        mau_unit_price: "* MAU単価",
        mau_limit: "MAU制限"
    },
    application: {
        title: "アプリケーション",
        total: "総アプリケーション数",
        m2m: "マシン・ツー・マシン"
    },
    resource: {
        title: "APIリソース",
        resource_count: "リソース数",
        scopes_per_resource: "リソースごとの権限"
    },
    branding: {
        title: "UIとブランディング",
        custom_domain: "カスタムドメイン",
        custom_css: "カスタムCSS",
        app_logo_and_favicon: "アプリロゴとFavicon",
        dark_mode: "ダークモード",
        i18n: "国際化"
    },
    user_authn: {
        title: "ユーザー認証",
        omni_sign_in: "オムニサインイン",
        password: "パスワード",
        passwordless: "パスワードレス - E-mailとSMS",
        email_connector: "E-mailコネクタ",
        sms_connector: "SMSコネクタ",
        social_connectors: "ソーシャルコネクタ",
        standard_connectors: "スタンダードコネクタ",
        built_in_email_connector: "組み込みE-mailコネクタ",
        mfa: "MFA",
        sso: "エンタープライズ SSO"
    },
    user_management: {
        title: "ユーザー管理",
        user_management: "ユーザー管理",
        roles: "ロール",
        scopes_per_role: "ロールごとの権限"
    },
    audit_logs: {
        title: "監査ログ",
        retention: "保持期間"
    },
    hooks: {
        title: "ウェブフック",
        hooks: "ウェブフック"
    },
    organizations: {
        title: "組織",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "サポート",
        community: "コミュニティ",
        customer_ticket: "サポートチケット",
        premium: "プレミアム"
    },
    mau_unit_price_footnote: "* 月間アクティブユーザー（MAU）は、請求サイクル中のログイン頻度に基づいて3つの階層に分かれます。各階層ごとに異なるMAU単価が適用されます。",
    unlimited: "無制限",
    contact: "お問い合わせ",
    monthly_price: "${{value, number}}/mo",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}}日",
    days_other: "{{count, number}}日",
    add_on: "アドオン",
    tier: "レベル{{value, number}}: "
};
var $3d3b2d663001d50d$export$2e2bcd8739ae039 = Object.freeze($3d3b2d663001d50d$var$quota_table);


const $1044e179de8eebb8$var$subscription = {
    free_plan: "フリープラン",
    free_plan_description: "サイドプロジェクトや最初のLogtoのトライアルに適しています。クレジットカードは必要ありません。",
    hobby_plan: "ホビープラン",
    hobby_plan_description: "個人の開発者または小規模なエンジニアリングチーム向け。",
    pro_plan: "プロプラン",
    pro_plan_description: "ビジネスが安心してLogtoを利用できるプランです。",
    enterprise: "エンタープライズ",
    current_plan: "現在のプラン",
    current_plan_description: "現在のプランはこちらです。プランの使用状況を簡単に確認したり、次回の請求を確認したり、必要に応じてプランを変更したりできます。",
    plan_usage: "利用状況",
    plan_cycle: "プランサイクル: {{period}}。更新日: {{renewDate}}。",
    next_bill: "次の請求書",
    next_bill_hint: "計算方法については、次の<a>記事</a>を参照してください。",
    next_bill_tip: "次の請求書には、次の月のプランのベース価格と、各ティアのMAU単価での使用料金が含まれます。",
    manage_payment: "支払い方法の管理",
    overfill_quota_warning: "クォータ制限に到達しました。問題を防ぐために、プランをアップグレードしてください。",
    upgrade_pro: "プロプランにアップグレード",
    update_payment: "支払いを更新する",
    payment_error: "支払いに問題が発生しました。前回のサイクルで ${{price, number}} を処理できませんでした。Logtoのサービス停止を回避するために支払いを更新してください。",
    downgrade: "ダウングレード",
    current: "現在",
    upgrade: "アップグレード",
    quota_table: $3d3b2d663001d50d$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "請求書",
        status_column: "ステータス",
        amount_column: "金額",
        invoice_created_date_column: "請求書作成日",
        invoice_status: {
            void: "キャンセル済み",
            paid: "支払済み",
            open: "未処理",
            uncollectible: "延滞"
        }
    },
    quota_item: $d5294e9d046864da$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "ダウングレードしますか？",
        description: "<targetName/>に切り替える場合、以前の<currentName/>で使用できたクオータや機能は使用できなくなりますので注意してください。",
        before: "前: <name/>",
        after: "後: <name/>",
        downgrade: "ダウングレード"
    },
    not_eligible_modal: {
        downgrade_title: "ダウングレードの対象外です",
        downgrade_description: "<name/>へダウングレードする前に、以下の条件を満たしていることを確認してください。",
        downgrade_help_tip: "ダウングレードのヘルプが必要ですか？<a>お問い合わせください</a>。",
        upgrade_title: "当社の尊敬されるアーリーアダプターの皆様へのフレンドリーなリマインダー",
        upgrade_description: "現在、<name /> の許容範囲を超えて使用しています。Logto は正式にリリースされ、各プランに合わせた機能が提供されています。 <name /> へのアップグレードを検討する前に、アップグレードする前提条件を満たしていることを確認してください。",
        upgrade_pro_tip: " または Pro プランへのアップグレードを検討してください。",
        upgrade_help_tip: "アップグレードのヘルプが必要ですか？<a>お問い合わせください</a>。",
        a_maximum_of: "<item/>の最大数"
    },
    upgrade_success: "正常に<name/>にアップグレードされました",
    downgrade_success: "正常に<name/>にダウングレードされました",
    subscription_check_timeout: "サブスクリプションのチェックがタイムアウトしました。後でもう一度更新してください。",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $1044e179de8eebb8$export$2e2bcd8739ae039 = Object.freeze($1044e179de8eebb8$var$subscription);


const $75b813881e0e43d7$var$tab_sections = {
    overview: "概要",
    resources: "リソース",
    users: "ユーザー",
    access_control: "アクセス制御",
    help_and_support: "ヘルプとサポート",
    tenant: "テナント",
    automation: "オートメーション"
};
var $75b813881e0e43d7$export$2e2bcd8739ae039 = Object.freeze($75b813881e0e43d7$var$tab_sections);


const $18415b8c76f6fbc8$var$tabs = {
    get_started: "はじめに",
    dashboard: "ダッシュボード",
    applications: "アプリケーション",
    api_resources: "API リソース",
    sign_in_experience: "サインイン",
    connectors: "コネクタ",
    enterprise_sso: "エンタープライズSSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "ユーザー管理",
    audit_logs: "監査ログ",
    roles: "役割",
    docs: "ドキュメント",
    tenant_settings: "設定",
    mfa: "Multi-factor auth"
};
var $18415b8c76f6fbc8$export$2e2bcd8739ae039 = Object.freeze($18415b8c76f6fbc8$var$tabs);


const $64806e9b9ce3b212$var$tenants = {
    title: "設定",
    description: "テナントの設定を効率的に管理し、ドメインをカスタマイズします。",
    tabs: {
        settings: "設定",
        domains: "ドメイン",
        subscription: "プランと請求",
        billing_history: "請求履歴"
    },
    settings: {
        title: "設定",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "テナントID",
        tenant_name: "テナント名",
        tenant_region: "データがホストされている地域",
        tenant_region_tip: "Your tenant resources are hosted in {{region}}. <a>Learn more</a>",
        environment_tag_development: "開発",
        environment_tag_staging: "ステージング",
        environment_tag_production: "本番",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "テナント情報は正常に保存されました。"
    },
    full_env_tag: {
        development: "開発",
        production: "本番"
    },
    deletion_card: {
        title: "削除",
        tenant_deletion: "テナントの削除",
        tenant_deletion_description: "テナントの削除は、関連するすべてのユーザーデータと設定の永久的な削除につながります。十分に注意して操作してください。",
        tenant_deletion_button: "テナントを削除する"
    },
    create_modal: {
        title: "テナントを作成する",
        subtitle: "分離されたリソースとユーザーを持つ新しいテナントを作成します。データがホストされる地域とテナントの種類は作成後に変更できません。",
        tenant_usage_purpose: "What do you want to use this tenant for?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Available plan:",
        create_button: "テナントを作成する",
        tenant_name_placeholder: "私のテナント"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "テナントを削除します",
        description_line1: '"<span>{{name}}</span>" というテナント ("<span>{{tag}}</span>" の環境タグを持つ) を削除してもよろしいですか？ このアクションは元に戻せません。これにより、すべてのデータとアカウント情報が永久に削除されます。',
        description_line2: "アカウントの削除前に、お手伝いできるかもしれません。 <span><a>メールでお問い合わせください</a></span>。",
        description_line3: '続行する場合は、テナント名 "<span>{{name}}</span>" を入力して確認してください。',
        delete_button: "完全に削除する",
        cannot_delete_title: "このテナントは削除できません",
        cannot_delete_description: "申し訳ありませんが、現時点ではこのテナントを削除できません。無料プランに登録しており、未払いの請求がないことを確認してください。"
    },
    tenant_landing_page: {
        title: "まだテナントを作成していません",
        description: "Logto でプロジェクトを設定するには、新しいテナントを作成してください。ログアウトまたはアカウントを削除する必要がある場合は、右上隅のアバターボタンをクリックしてください。",
        create_tenant_button: "テナントを作成"
    },
    status: {
        mau_exceeded: "MAUの制限を超えました",
        suspended: "一時停止中",
        overdue: "期限切れ"
    },
    tenant_suspended_page: {
        title: "テナントが一時停止されました。アクセスを復元するにはお問い合わせください。",
        description_1: "誠に申し訳ありませんが、ご利用のテナントアカウントが一時的に停止されました。MAU制限を超えた、支払いの遅延、その他の不正な操作などが原因です。",
        description_2: "詳細な説明や懸念事項がある場合、または機能を完全に復元しテナントをアンブロックする場合は、直ちにお問い合わせください。"
    },
    signing_keys: {
        title: "SIGNING KEYS",
        description: "Securely manage signing keys in your tenant.",
        type: {
            private_key: "OIDC private keys",
            cookie_key: "OIDC cookie keys"
        },
        private_keys_in_use: "Private keys in use",
        cookie_keys_in_use: "Cookie keys in use",
        rotate_private_keys: "Rotate private keys",
        rotate_cookie_keys: "Rotate cookie keys",
        rotate_private_keys_description: "This action will create a new private signing key, rotate the current key, and remove your previous key. Your JWT tokens signed with the current key will remain valid until deletion or another round of rotation.",
        rotate_cookie_keys_description: "This action will create a new cookie key, rotate the current key, and remove your previous key. Your cookies with the current key will remain valid until deletion or another round of rotation.",
        select_private_key_algorithm: "Select signing key algorithm for the new private key",
        rotate_button: "Rotate",
        table_column: {
            id: "ID",
            status: "Status",
            algorithm: "Signing key algorithm"
        },
        status: {
            current: "Current",
            previous: "Previous"
        },
        reminder: {
            rotate_private_key: "Are you sure you want to rotate the <strong>OIDC private keys</strong>? New issued JWT tokens will be signed by the new key. Existing JWT tokens stay valid until you rotate again.",
            rotate_cookie_key: "Are you sure you want to rotate the <strong>OIDC cookie keys</strong>? New cookies generated in sign-in sessions will be signed by the new cookie key. Existing cookies stay valid until you rotate again.",
            delete_private_key: "Are you sure you want to delete the <strong>OIDC private key</strong>? Existing JWT tokens signed with this private signing key will no longer be valid.",
            delete_cookie_key: "Are you sure you want to delete the <strong>OIDC cookie key</strong>? Older sign-in sessions with cookies signed with this cookie key will no longer be valid. A re-authentication is required for these users."
        },
        messages: {
            rotate_key_success: "Signing keys rotated successfully.",
            delete_key_success: "Key deleted successfully."
        }
    }
};
var $64806e9b9ce3b212$export$2e2bcd8739ae039 = Object.freeze($64806e9b9ce3b212$var$tenants);


const $b6d6bea474566d1b$var$topbar = {
    docs: "ドキュメント",
    help: "ヘルプ"
};
var $b6d6bea474566d1b$export$2e2bcd8739ae039 = Object.freeze($b6d6bea474566d1b$var$topbar);


const $39bccf5325f26fb1$var$paywall = {
    applications: "{{count, number}}個の<planName/>アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    applications_other: "{{count, number}}個の<planName/>アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    machine_to_machine_feature: "アップグレードして、<strong>Hobby</strong>プランで1つのマシン間アプリケーションを解除するか、無制限の使用が可能な<strong>Pro</strong>プランを選択してください。どんなお手伝いが必要でも、お気軽に<a>お問い合わせ</a>ください。",
    machine_to_machine: "{{count, number}}個の<planName/>マシン間アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    machine_to_machine_other: "{{count, number}}個の<planName/>マシン間アプリケーション制限に達しました。チームのニーズに対応するため、プランをアップグレードしてください。サポートが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    resources: "{{count, number}}の<planName/> APIリソース制限に達しました。チームのニーズに合わせてプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    resources_other: "{{count, number}}の<planName/> APIリソース制限に達しました。チームのニーズに合わせてプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_resource: "{{count, number}}の<planName/> APIリソースあたりの許可制限に達しました。拡張するには今すぐアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_resource_other: "{{count, number}}の<planName/> APIリソースあたりの許可制限に達しました。拡張するには今すぐアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    custom_domain: "カスタムドメインの機能を解除するには、<strong>Hobby</strong>または<strong>Pro</strong>プランにアップグレードしてください。何かお手伝いが必要な場合は、お気軽に<a>お問い合わせ</a>ください。",
    social_connectors: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    social_connectors_other: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_feature: "OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成し、無制限のソーシャルコネクタとすべてのプレミアム機能を利用するには、<strong>Hobby</strong>プランまたは<strong>Pro</strong>プランにアップグレードしてください。どんなお手伝いが必要でも、お気軽に<a>お問い合わせ</a>ください。",
    standard_connectors: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_other: "{{count, number}}の<planName/>ソーシャルコネクタ制限に達しました。チームのニーズに合わせて有料プランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_pro: "{{count, number}}の<planName/>スタンダードコネクタ制限に達しました。チームのニーズに合わせてエンタープライズプランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    standard_connectors_pro_other: "{{count, number}}の<planName/>スタンダードコネクタ制限に達しました。チームのニーズに合わせてエンタープライズプランにアップグレードして、OIDC、OAuth 2.0、およびSAMLプロトコルを使用して独自のコネクタを作成できるようにしましょう。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    roles: "{{count, number}}の<planName/>ロール制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    roles_other: "{{count, number}}の<planName/>ロール制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_role: "{{count, number}}の<planName/>ロールあたりの許可制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    scopes_per_role_other: "{{count, number}}の<planName/>ロールあたりの許可制限に達しました。追加のロールと権限を追加するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    hooks: "{{count, number}}の<planName/>ウェブフック制限に達しました。追加のウェブフックを作成するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    hooks_other: "{{count, number}}の<planName/>ウェブフック制限に達しました。追加のウェブフックを作成するにはプランをアップグレードしてください。<a>お問い合わせ</a>は何かお手伝いが必要な場合はお気軽にどうぞ。",
    mfa: "セキュリティを確認するためにMFAを解除して有料プランにアップグレードしてください。ご質問があれば、<a>お問い合わせください</a>。",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $39bccf5325f26fb1$export$2e2bcd8739ae039 = Object.freeze($39bccf5325f26fb1$var$paywall);


const $498468fe56e19e86$var$upsell = {
    upgrade_plan: "プランをアップグレード",
    compare_plans: "プラン比較",
    view_plans: "プランを見る",
    create_tenant: {
        title: "テナントプランを選択",
        description: "成長中の企業向けに革新的かつ手頃な価格で設計された競争力のあるプランオプションを提供しています。<a>詳細を見る</a>",
        base_price: "基本価格",
        monthly_price: "{{value, number}}/mo",
        mau_unit_price: "MAU単価",
        view_all_features: "すべての機能を見る",
        select_plan: "<name/>を選択",
        free_tenants_limit: "最大{{count, number}}テナント無料",
        free_tenants_limit_other: "最大{{count, number}}テナント無料",
        most_popular: "最も人気",
        upgrade_success: "<name/>にアップグレードしました"
    },
    mau_exceeded_modal: {
        title: "MAUが制限を超えました。プランをアップグレードしてください。",
        notification: "現在のMAUが<planName/>の制限を超えています。サービスの停止を回避するために、迅速にプレミアムプランにアップグレードしてください。",
        update_plan: "プランを更新"
    },
    payment_overdue_modal: {
        title: "請求書の支払いが期限切れです",
        notification: "おっと！テナント<span>{{name}}</span>の請求書の支払いが失敗しました。Logtoサービスの停止を避けるために、すみやかに請求書をお支払いください。",
        unpaid_bills: "未払いの請求書",
        update_payment: "支払いを更新"
    },
    paywall: $39bccf5325f26fb1$export$2e2bcd8739ae039
};
var $498468fe56e19e86$export$2e2bcd8739ae039 = Object.freeze($498468fe56e19e86$var$upsell);


const $d4a741b439d3b02e$var$user_details = {
    page_title: "ユーザーの詳細",
    back_to_users: "ユーザー管理に戻る",
    created_title: "このユーザーは正常に作成されました",
    created_guide: "ユーザーがサインインプロセスを支援するための情報です。",
    created_email: "メールアドレス：",
    created_phone: "電話番号：",
    created_username: "ユーザー名：",
    created_password: "パスワード：",
    menu_delete: "削除",
    delete_description: "この操作は取り消せません。ユーザーが永久に削除されます。",
    deleted: "ユーザーは正常に削除されました",
    reset_password: {
        reset_password: "パスワードをリセット",
        title: "本当にパスワードをリセットしますか？",
        content: "この操作は取り消せません。ユーザーのログイン情報がリセットされます。",
        congratulations: "このユーザーはリセットされました",
        new_password: "新しいパスワード："
    },
    tab_settings: "設定",
    tab_roles: "役割",
    tab_logs: "ユーザーログ",
    tab_organizations: "組織",
    authentication: "認証",
    authentication_description: "各ユーザーには、すべてのユーザー情報が含まれるプロファイルがあります。基本データ、ソーシャルアイデンティティ、およびカスタムデータで構成されています。",
    user_profile: "ユーザープロファイル",
    field_email: "メールアドレス",
    field_phone: "電話番号",
    field_username: "ユーザー名",
    field_name: "名前",
    field_avatar: "アバター画像のURL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "カスタムデータ",
    field_custom_data_tip: "プリディフィンドされたユーザープロパティにリストされていない、追加のユーザー情報（ユーザーが好みの色や言語など）。",
    field_connectors: "ソーシャル接続",
    field_sso_connectors: "エンタープライズ接続",
    custom_data_invalid: "カスタムデータは有効なJSONオブジェクトである必要があります",
    connectors: {
        connectors: "コネクタ",
        user_id: "ユーザーID",
        remove: "削除",
        connected: "このユーザーは複数のソーシャルコネクタに接続しています。",
        not_connected: "ユーザーはソーシャルコネクタに接続していません",
        deletion_confirmation: "既存の<name/>アイデンティティを削除しています。本当に続行しますか？"
    },
    sso_connectors: {
        connectors: "接続",
        enterprise_id: "エンタープライズID",
        connected: "このユーザーはシングルサインオンのために複数のエンタープライズアイデンティティプロバイダに接続しています。",
        not_connected: "ユーザーはシングルサインオンのためにいかなるエンタープライズアイデンティティプロバイダにも接続していません。"
    },
    mfa: {
        field_name: "多要素認証",
        field_description: "このユーザーは2段階認証要素を有効にしました。",
        name_column: "多要素認証",
        field_description_empty: "このユーザーは2段階認証の要因を有効にしていません。",
        deletion_confirmation: "2段階認証の既存の<name/>を削除しています。本当に続行しますか？"
    },
    suspended: "停止中",
    suspend_user: "ユーザーを一時停止",
    suspend_user_reminder: "ユーザーを一時停止してよろしいですか？この操作を行うと、ユーザーはアプリにサインインできなくなり、現在のアクセストークンが期限切れになった後、新しいアクセストークンを取得できなくなります。さらに、このユーザーによって行われたすべての API リクエストは失敗します。",
    suspend_action: "一時停止",
    user_suspended: "ユーザーが停止されました。",
    reactivate_user: "ユーザーをリアクティブ化",
    reactivate_user_reminder: "このユーザーをリアクティブ化することを確認しますか？それにより、このユーザーのサインイン試行が許可されます。",
    reactivate_action: "活性化",
    user_reactivated: "ユーザーが再活性化されました。",
    roles: {
        name_column: "役割",
        description_column: "説明",
        assign_button: "役割を割り当てる",
        delete_description: "この操作により、このユーザーからこの役割が削除されます。役割自体はまだ存在しますが、このユーザーに関連付けられなくなります。",
        deleted: "役割 {{name}} はこのユーザーから正常に削除されました。",
        assign_title: "{{name}} に役割を割り当てる",
        assign_subtitle: "{{name}} に1つ以上の役割を承認します",
        assign_role_field: "役割を割り当てる",
        role_search_placeholder: "役割名で検索",
        added_text: "{{value, number}} 追加しました",
        assigned_user_count: "{{value, number}} ユーザー",
        confirm_assign: "役割を割り当てる",
        role_assigned: "役割が正常に割り当てられました",
        search: "ロール名、説明、または ID で検索",
        empty: "利用可能な役割はありません"
    },
    warning_no_sign_in_identifier: "ユーザーは、サインインに少なくとも1つの識別子（ユーザー名、メールアドレス、電話番号、またはソーシャル）を持っている必要があります。続行してよろしいですか？",
    organization_roles_tooltip: "この組織内のユーザーに割り当てられた役割。"
};
var $d4a741b439d3b02e$export$2e2bcd8739ae039 = Object.freeze($d4a741b439d3b02e$var$user_details);


const $692b817c2cf774f6$var$users = {
    page_title: "ユーザー管理",
    title: "ユーザー管理",
    subtitle: "ユーザーのアイデンティティを管理する、ユーザーの作成、情報の編集、ユーザーログの表示、パスワードのリセットおよびユーザーの削除を含む",
    create: "ユーザーを追加する",
    create_subtitle: "少なくとも1つの以下のフィールドを提供してください。",
    error_missing_identifier: "ユーザーを作成するには、少なくとも1つの識別子を指定する必要があります。",
    user_name: "ユーザー名",
    application_name: "アプリケーションから",
    latest_sign_in: "最新のサインイン",
    create_form_username: "ユーザー名",
    create_form_password: "パスワード",
    create_form_name: "フルネーム",
    placeholder_name: "山田 太郎",
    placeholder_email: "taroyamada@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+81 3-1234-5678",
    unnamed: "名前がありません",
    search: "名前、メール、電話、またはユーザー名で検索",
    check_user_detail: "ユーザー詳細を確認する",
    placeholder_title: "ユーザー管理",
    placeholder_description: "各ユーザーには、基本データ、ソーシャルアイデンティティ、およびカスタムデータが含まれるプロフィールがあります。"
};
var $692b817c2cf774f6$export$2e2bcd8739ae039 = Object.freeze($692b817c2cf774f6$var$users);


const $a5fb1a47b05a863e$var$webhook_details = {
    page_title: "Webhookの詳細",
    back_to_webhooks: "Webhooksに戻る",
    not_in_use: "使用されていない",
    success_rate: "成功率",
    requests: "24時間に{{value, number}}件のリクエスト",
    disable_webhook: "Webhookを無効にする",
    disable_reminder: "本当にこのWebhookを再度アクティブにしますか？これを行うとエンドポイントURLにHTTPリクエストが送信されなくなります。",
    webhook_disabled: "Webhookは無効になりました。",
    webhook_reactivated: "Webhookが再度有効になりました。",
    reactivate_webhook: "Webhookを再度アクティブにする",
    delete_webhook: "Webhookを削除する",
    deletion_reminder: "このWebhookを削除しています。削除した後はエンドポイントURLにHTTPリクエストが送信されなくなります。",
    deleted: "Webhookは削除されました。",
    settings_tab: "設定",
    recent_requests_tab: "最近のリクエスト（24時間）",
    settings: {
        settings: "設定",
        settings_description: "Webhookは、特定のイベントが発生すると、POSTリクエストをエンドポイントURLに送信することで、リアルタイムのアップデートを受信できるようにするものです。これにより、新しい情報を受信した後、直ちにアクションを起こすことができます。",
        events: "イベント",
        events_description: "LogtoがPOSTリクエストを送信するトリガーイベントを選択します。",
        name: "名前",
        endpoint_url: "エンドポイントURL",
        signing_key: "署名キー",
        signing_key_tip: "ログトから提供されたシークレットキーをエンドポイントにリクエストヘッダーとして追加して、Webhookのペイロードの正当性を保証します。",
        regenerate: "再生成する",
        regenerate_key_title: "署名キーの再生成",
        regenerate_key_reminder: "署名キーを変更してもよろしいですか？再生成すると、すぐに有効になります。エンドポイントに同期して署名キーを変更することを忘れないでください。",
        regenerated: "署名キーが再生成されました。",
        custom_headers: "カスタムヘッダー",
        custom_headers_tip: "オプションで、Webhookのペイロードに追加のコンテキストまたはメタデータを提供するために、カスタムヘッダーを追加できます。",
        key_duplicated_error: "キーは繰り返すことはできません。",
        key_missing_error: "キーは必須です。",
        value_missing_error: "値が必要です。",
        invalid_key_error: "キーが無効です",
        invalid_value_error: "値が無効です",
        test: "テスト",
        test_webhook: "Webhookをテストする",
        test_webhook_description: "Webhookを設定し、各選択したイベントのペイロード例を使用してテストして、正しい受信と処理を確認してください。",
        send_test_payload: "テストペイロードを送信する",
        test_result: {
            endpoint_url: "エンドポイントURL：{{url}}",
            message: "メッセージ：{{message}}",
            response_status: "レスポンスステータス：{{status, number}}",
            response_body: "レスポンスボディ：{{body}}",
            request_time: "リクエスト時間：{{time}}",
            test_success: "エンドポイントへのWebhookテストは成功しました。"
        }
    }
};
var $a5fb1a47b05a863e$export$2e2bcd8739ae039 = Object.freeze($a5fb1a47b05a863e$var$webhook_details);


const $262936b5454855d9$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "特定のイベントに関するリアルタイムの更新を手軽に受け取るためにWebhookを作成します。",
    create: "Webhookを作成する",
    events: {
        post_register: "新しいアカウントを作成する",
        post_sign_in: "サインインする",
        post_reset_password: "パスワードをリセットする"
    },
    table: {
        name: "名前",
        events: "イベント",
        success_rate: "成功率（24時間）",
        requests: "リクエスト（24時間）"
    },
    placeholder: {
        title: "Webhook",
        description: 'POSTリクエストをエンドポイントURLに送信して、リアルタイムのアップデートを受け取るWebhookを作成します。 "アカウントを作成する"、"サインインする"、"パスワードをリセットする"などのイベントを受け取って、常に最新情報を把握しましょう。',
        create_webhook: "Webhookを作成する"
    },
    create_form: {
        title: "Webhookを作成する",
        subtitle: "Webhookを追加して、エンドポイントURLにPOSTリクエストを送信し、ユーザーイベントの詳細を送信します。",
        events: "イベント",
        events_description: "LogtoがPOSTリクエストを送信するトリガーイベントを選択します。",
        name: "名前",
        name_placeholder: "Webhook名を入力してください",
        endpoint_url: "エンドポイントURL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Webhookを作成する",
        missing_event_error: "少なくとも1つのイベントを選択する必要があります。"
    },
    webhook_created: "Webhook {{name}}が正常に作成されました。"
};
var $262936b5454855d9$export$2e2bcd8739ae039 = Object.freeze($262936b5454855d9$var$webhooks);


const $b5667dfa68177445$var$welcome = {
    title: "管理者コンソールへようこそ",
    description: "管理者コンソールは、コーディングの必要がないLogtoを管理するためのWebアプリです。まずはアカウントを作成しましょう。このアカウントで自分自身または会社の代表者としてLogtoを管理することができます。",
    create_account: "アカウントを作成する"
};
var $b5667dfa68177445$export$2e2bcd8739ae039 = Object.freeze($b5667dfa68177445$var$welcome);


const $8d271ebf6ae8d71f$var$admin_console = {
    title: "Admin Console",
    admin_user: "Admin",
    system_app: "System",
    menu: $1d22e23efbe845fb$export$2e2bcd8739ae039,
    general: $143b4b46f881bc37$export$2e2bcd8739ae039,
    errors: $13b8c4682829fb31$export$2e2bcd8739ae039,
    tab_sections: $75b813881e0e43d7$export$2e2bcd8739ae039,
    tabs: $18415b8c76f6fbc8$export$2e2bcd8739ae039,
    applications: $e982febaa819fe5c$export$2e2bcd8739ae039,
    application_details: $8acbf54c5f767300$export$2e2bcd8739ae039,
    api_resources: $7a08643d4a7e4d96$export$2e2bcd8739ae039,
    api_resource_details: $999af6fe79e10e19$export$2e2bcd8739ae039,
    connectors: $41521a13b3eaf386$export$2e2bcd8739ae039,
    connector_details: $ed18013c30921694$export$2e2bcd8739ae039,
    enterprise_sso: $08d8343cea7fcaf7$export$2e2bcd8739ae039,
    enterprise_sso_details: $8daa2bfc6a7d9a4b$export$2e2bcd8739ae039,
    get_started: $929fa0806c26a61c$export$2e2bcd8739ae039,
    users: $692b817c2cf774f6$export$2e2bcd8739ae039,
    user_details: $d4a741b439d3b02e$export$2e2bcd8739ae039,
    contact: $7fbda3de6b4efa0c$export$2e2bcd8739ae039,
    sign_in_exp: $776ec44883c4ae9a$export$2e2bcd8739ae039,
    dashboard: $b14661bc4465f152$export$2e2bcd8739ae039,
    logs: $843588991176ce2c$export$2e2bcd8739ae039,
    log_details: $602ff41821c8dfbc$export$2e2bcd8739ae039,
    session_expired: $a34771c81ffe02d2$export$2e2bcd8739ae039,
    welcome: $b5667dfa68177445$export$2e2bcd8739ae039,
    roles: $8c6e5b58e568cd36$export$2e2bcd8739ae039,
    role_details: $c447906bd5a33d89$export$2e2bcd8739ae039,
    permissions: $3c7461abff72f631$export$2e2bcd8739ae039,
    cloud: $ce0fe1d5db9a0af7$export$2e2bcd8739ae039,
    profile: $4dc863138f4141a2$export$2e2bcd8739ae039,
    components: $376529b5b46d0965$export$2e2bcd8739ae039,
    webhooks: $262936b5454855d9$export$2e2bcd8739ae039,
    webhook_details: $a5fb1a47b05a863e$export$2e2bcd8739ae039,
    domain: $e7dd1a76b3f5bdd4$export$2e2bcd8739ae039,
    tenants: $64806e9b9ce3b212$export$2e2bcd8739ae039,
    topbar: $b6d6bea474566d1b$export$2e2bcd8739ae039,
    subscription: $1044e179de8eebb8$export$2e2bcd8739ae039,
    upsell: $498468fe56e19e86$export$2e2bcd8739ae039,
    guide: $6e744d320636719e$export$2e2bcd8739ae039,
    mfa: $86d0d07d36bd2053$export$2e2bcd8739ae039,
    organizations: $96f1ee97eb4d5104$export$2e2bcd8739ae039,
    organization_details: $66f035958e903930$export$2e2bcd8739ae039
};
var $8d271ebf6ae8d71f$export$2e2bcd8739ae039 = Object.freeze($8d271ebf6ae8d71f$var$admin_console);


const $afef1b619c382141$var$demo_app = {
    title: "ライブプレビューへのサインインに成功しました！",
    subtitle: "あなたのログイン情報は以下の通りです：",
    username: "ユーザー名：",
    user_id: "ユーザーID：",
    sign_out: "ライブプレビューからサインアウトする",
    continue_explore: "または続けて探索する",
    customize_sign_in_experience: "サインイン体験のカスタマイズ",
    enable_passwordless: "パスワードレスを有効にする",
    add_social_connector: "ソーシャルコネクターを追加する"
};
var $afef1b619c382141$export$2e2bcd8739ae039 = Object.freeze($afef1b619c382141$var$demo_app);


const $f7611158b86d692f$var$oidc = {
    logout_success: "正常にログアウトしました。"
};
var $f7611158b86d692f$export$2e2bcd8739ae039 = Object.freeze($f7611158b86d692f$var$oidc);


const $936a1de39b991208$var$translation = {
    admin_console: $8d271ebf6ae8d71f$export$2e2bcd8739ae039,
    demo_app: $afef1b619c382141$export$2e2bcd8739ae039,
    oidc: $f7611158b86d692f$export$2e2bcd8739ae039
};
var $936a1de39b991208$export$2e2bcd8739ae039 = Object.freeze($936a1de39b991208$var$translation);


const $99146a10d7fe038c$var$ja = {
    translation: $936a1de39b991208$export$2e2bcd8739ae039,
    errors: $b72762504e1db61c$export$2e2bcd8739ae039
};
var $99146a10d7fe038c$export$2e2bcd8739ae039 = Object.freeze($99146a10d7fe038c$var$ja);


const $cb6fae3e45da5ae1$var$application = {
    invalid_type: "관련 역할을 가질 수 있는 것은 기계 대 기계 응용 프로그램만 가능합니다.",
    role_exists: "역할 ID {{roleId}} 가 이미이 응용 프로그램에 추가되었습니다.",
    invalid_role_type: "사용자 유형 역할을 기계 대 기계 응용 프로그램에 할당할 수 없습니다."
};
var $cb6fae3e45da5ae1$export$2e2bcd8739ae039 = Object.freeze($cb6fae3e45da5ae1$var$application);


const $7a5029cc3ae036c0$var$auth = {
    authorization_header_missing: "인증 헤더가 존재하지 않아요.",
    authorization_token_type_not_supported: "해당 인증 방법을 지원하지 않아요.",
    unauthorized: "인증되지 않았어요. 로그인 정보와 범위를 확인해 주세요.",
    forbidden: "접근이 금지되었어요. 로그인 권한과 역할을 확인해 주세요.",
    expected_role_not_found: "예상되는 역할을 찾을 수 없어요. 해당 사용자의 권한 또는 역할을 확인해 주세요.",
    jwt_sub_missing: "JWT에서 `sub`를 찾을 수 없어요.",
    require_re_authentication: "보호된 작업을 수행하려면 재인증이 필요해요."
};
var $7a5029cc3ae036c0$export$2e2bcd8739ae039 = Object.freeze($7a5029cc3ae036c0$var$auth);


const $7efe7711a0abd7c4$var$connector = {
    general: "커넥터에서 오류가 발생했습니다: {{errorDescription}}",
    not_found: "{{type}} 값을 가진 연동 종류를 찾을 수 없어요.",
    not_enabled: "연동이 활성화되지 않았어요.",
    invalid_metadata: "연동 메타데이터가 유효하지 않아요.",
    invalid_config_guard: "연동 설정 데이터가 유효하지 않아요.",
    unexpected_type: "예상하지 않은 연동 종류에요.",
    invalid_request_parameters: "잘못된 요청 파라미터가 있어요.",
    insufficient_request_parameters: "요청 데이터에서 일부 정보가 없어요.",
    invalid_config: "연동 설정이 유효하지 않아요.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "연동 응답이 유효하지 않아요.",
    template_not_found: "연동 예제 설정을 찾을 수 없어요.",
    template_not_supported: "연동이 이 템플릿 타입을 지원하지 않아요.",
    rate_limit_exceeded: "트리거 주기 제한. 나중에 다시 시도하세요.",
    not_implemented: "{{method}}은 아직 구현되지 않았어요.",
    social_invalid_access_token: "연동 서비스의 Access 토큰이 유효하지 않아요.",
    invalid_auth_code: "연동 서비스의 Auth 코드가 유효하지 않아요.",
    social_invalid_id_token: "연동 서비스의 ID 토큰이 유효하지 않아요.",
    authorization_failed: "사용자의 인증 과정이 성공적으로 마무리되지 않았어요.",
    social_auth_code_invalid: "Access 토큰을 가져올 수 없어요. Authorization 코드를 확인해 주세요.",
    more_than_one_sms: "SMS 서비스는 1개만 연동되어야 해요.",
    more_than_one_email: "이메일 서비스는 1개만 연동되어야 해요.",
    more_than_one_connector_factory: "다수의 커넥터 팩토리가 발견되었습니다 (ID {{connectorIds}}). 불필요한 팩토리는 제거해주세요.",
    db_connector_type_mismatch: "종류가 일치하지 않은 연동 서비스가 DB에 존재해요.",
    not_found_with_connector_id: "주어진 연동 ID로 연동 설정을 찾을 수 없어요.",
    multiple_instances_not_supported: "선택된 연동 기준으로 여러 인스턴스를 생성할 수 없어요.",
    invalid_type_for_syncing_profile: "소셜 연동만 사용자 프로파일을 동기화 할 수 있어요.",
    can_not_modify_target: "연동 목표를 수정할 수 없어요.",
    should_specify_target: "'목표'를 반드시 지정해야 해요.",
    multiple_target_with_same_platform: "같은 목표와 플랫폼에 여러 소셜 연동을 가질 수 없어요.",
    cannot_overwrite_metadata_for_non_standard_connector: "이 연동의 메타데이터를 덮어쓸 수 없어요."
};
var $7efe7711a0abd7c4$export$2e2bcd8739ae039 = Object.freeze($7efe7711a0abd7c4$var$connector);


const $f56c446aeb06d6c5$var$domain = {
    not_configured: "도메인 호스트 이름 공급 업체가 구성되어 있지 않습니다.",
    cloudflare_data_missing: "cloudflare_data 가 없습니다. 확인하십시오.",
    cloudflare_unknown_error: "Cloudflare API 요청시 알 수 없는 오류 발생",
    cloudflare_response_error: "Cloudflare 로부터 예상치 못한 응답을 받았습니다.",
    limit_to_one_domain: "하나의 맞춤 도메인만 사용할 수 있습니다.",
    hostname_already_exists: "이 도메인은 이미 서버에 존재합니다.",
    cloudflare_not_found: "Cloudflare에서 호스트 이름을 찾을 수 없습니다."
};
var $f56c446aeb06d6c5$export$2e2bcd8739ae039 = Object.freeze($f56c446aeb06d6c5$var$domain);


const $d38115e059c730e0$var$entity = {
    invalid_input: "입력이 잘못되었습니다. 값 목록은 비어 있을 수 없습니다.",
    create_failed: "{{name}} 생성을 실패하였어요.",
    db_constraint_violated: "데이터베이스 제약 조건 위반.",
    not_exists: "{{name}}는 존재하지 않아요.",
    not_exists_with_id: "{{id}} ID를 가진 {{name}}는 존재하지 않아요.",
    not_found: "리소스가 존재하지 않아요.",
    relation_foreign_key_not_found: "하나 이상의 외래 키를 찾을 수 없어요. 입력을 확인하고 참조된 모든 엔티티가 있는지 확인해주세요.",
    unique_integrity_violation: "엔티티가 이미 존재해요. 입력을 확인하고 다시 시도해주세요."
};
var $d38115e059c730e0$export$2e2bcd8739ae039 = Object.freeze($d38115e059c730e0$var$entity);


const $60a621d53be6c526$var$guard = {
    invalid_input: "{{type}} 요청 타입은 유효하지 않아요.",
    invalid_pagination: "요청의 Pagination 값이 유효하지 않아요.",
    can_not_get_tenant_id: "요청에서 테넌트 ID를 가져올 수 없습니다.",
    file_size_exceeded: "파일 크기가 초과되었습니다.",
    mime_type_not_allowed: "MIME 타입이 허용되지 않습니다."
};
var $60a621d53be6c526$export$2e2bcd8739ae039 = Object.freeze($60a621d53be6c526$var$guard);


const $7b6f213fd77aed76$var$hook = {
    missing_events: "최소한 하나의 이벤트를 제공해야 합니다.",
    send_test_payload_failed: "테스트 페이로드 보내기 실패: {{message}}",
    endpoint_responded_with_error: "엔드포인트가 오류로 응답했습니다."
};
var $7b6f213fd77aed76$export$2e2bcd8739ae039 = Object.freeze($7b6f213fd77aed76$var$hook);


const $81cff14481891494$var$localization = {
    cannot_delete_default_language: "{{languageTag}} 언어는 기본 언어이므로 삭제할 수 없어요.",
    invalid_translation_structure: "유효하지 않은 데이터 스키마예요. 입력된 값을 다시 확인해 주세요."
};
var $81cff14481891494$export$2e2bcd8739ae039 = Object.freeze($81cff14481891494$var$localization);


const $81b2d97c4938b2b4$var$log = {
    invalid_type: "로그 종류가 유효하지 않아요."
};
var $81b2d97c4938b2b4$export$2e2bcd8739ae039 = Object.freeze($81b2d97c4938b2b4$var$log);


const $5e606826487ef60c$var$oidc = {
    aborted: "End 사용자가 상호 작용을 중단했어요.",
    invalid_scope: "허용되지 않은 범위: {{error_description}}.",
    invalid_token: "유효하지 않은 토큰이 제공되었어요.",
    invalid_client_metadata: "유효하지 않은 클라이언트 메타데이터가 제공되었어요.",
    insufficient_scope: "토큰에 `{{scope}}` 범위가 누락되었어요.",
    invalid_request: "요청이 유효하지 않아요.",
    invalid_grant: "승인 요청이 유효하지 않아요.",
    invalid_redirect_uri: "`redirect_uri`가 등록된 클라이언트의 `redirect_uris`와 일치하지 않아요.",
    access_denied: "접근이 금지되었어요.",
    invalid_target: "유효하지 않은 리소스 표시예요.",
    unsupported_grant_type: "지원하지 않는 `grant_type` 요청이에요.",
    unsupported_response_mode: "지원하지 않는 `response_mode` 요청이에요.",
    unsupported_response_type: "지원하지 않은 `response_type` 요청이에요.",
    provider_error: "OIDC 내부 오류: {{message}}.",
    server_error: "알 수 없는 OIDC 오류가 발생했어요. 나중에 다시 시도해주세요.",
    provider_error_fallback: "OIDC 오류가 발생했어요: {{code}}.",
    key_required: "최소한 하나의 키가 필요해요.",
    key_not_found: "ID가 {{id}}인 키를 찾을 수 없어요."
};
var $5e606826487ef60c$export$2e2bcd8739ae039 = Object.freeze($5e606826487ef60c$var$oidc);


const $51e65e3d5252a940$var$organization = {
    require_membership: "사용자는 조직의 구성원이어야 합니다."
};
var $51e65e3d5252a940$export$2e2bcd8739ae039 = Object.freeze($51e65e3d5252a940$var$organization);


const $c81913222eca19b7$var$password = {
    unsupported_encryption_method: "{{name}} 암호화 방법을 지원하지 않아요.",
    pepper_not_found: "비밀번호 Pepper를 찾을 수 없어요. Core 환경설정을 확인해 주세요.",
    rejected: "비밀번호가 거부되었습니다. 비밀번호가 요구 사항을 충족하는지 확인해 주세요."
};
var $c81913222eca19b7$export$2e2bcd8739ae039 = Object.freeze($c81913222eca19b7$var$password);


const $1374ba61daf574a5$var$request = {
    invalid_input: "입력된 값이 유효하지 않아요. {{details}}",
    general: "요청 중에 오류가 발생했어요."
};
var $1374ba61daf574a5$export$2e2bcd8739ae039 = Object.freeze($1374ba61daf574a5$var$request);


const $a147d63c5e1a2fb8$var$resource = {
    resource_identifier_in_use: "API 식별자 {{indicator}}가 이미 사용 중입니다"
};
var $a147d63c5e1a2fb8$export$2e2bcd8739ae039 = Object.freeze($a147d63c5e1a2fb8$var$resource);


const $d8dfa8a691242e7a$var$role = {
    name_in_use: "역할 이름 {{name}}이/가 이미 사용 중이에요.",
    scope_exists: "범위 ID {{scopeId}}이/가 이미 이 역할에 추가되어 있어요.",
    user_exists: "사용자 ID {{userId}}이/가 이미 이 역할에 추가되어 있어요.",
    application_exists: "애플리케이션 ID {{applicationId}} 가 이미 이 역할에 추가되어 있어요.",
    default_role_missing: "기본 역할 이름의 일부가 데이터베이스에 존재하지 않아요. 먼저 역할을 생성해 주세요.",
    internal_role_violation: '내부 역할 위반: Logto에서 금지되는 내부 역할을 업데이트하거나 삭제하려고 할 수 있습니다. 새 역할을 만드는 경우 "#internal:"으로 시작하지 않는 다른 이름을 시도해보세요.'
};
var $d8dfa8a691242e7a$export$2e2bcd8739ae039 = Object.freeze($d8dfa8a691242e7a$var$role);


const $2d56d4d07a20e904$var$scope = {
    name_exists: "범위 이름 {{name}}이/가 이미 사용 중이에요.",
    name_with_space: "범위 이름에 공백을 포함할 수 없어요."
};
var $2d56d4d07a20e904$export$2e2bcd8739ae039 = Object.freeze($2d56d4d07a20e904$var$scope);


const $e84da81f61f65347$var$session = {
    not_found: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    invalid_credentials: "유효하지 않은 로그인 정보예요. 입력된 값을 다시 확인해 주세요.",
    invalid_sign_in_method: "현재 로그인 방법을 지원하지 않아요.",
    invalid_connector_id: "소셜 ID {{connectorId}}를 찾을 수 없어요.",
    insufficient_info: "로그인 정보가 충분하지 않아요.",
    connector_id_mismatch: "연동 ID가 세션 정보와 일치하지 않아요.",
    connector_session_not_found: "연동 세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    verification_session_not_found: "검증을 실패했어요. 검증 과정을 다시 시작하고 다시 시도해 주세요.",
    verification_expired: "연결 시간이 초과되었어요. 검증을 다시 시작하고, 계정이 안전한지 확인해 주세요.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "로그인을 먼저 해 주세요.",
    unsupported_prompt_name: "지원하지 않는 Prompt 이름이에요.",
    forgot_password_not_enabled: "비밀번호 찾기가 활성화되어있지 않아요.",
    verification_failed: "인증이 성공적으로 완료되지 않았어요. 처음부터 다시 인증 과정을 거쳐 주세요.",
    connector_validation_session_not_found: "연동 세션 유효성 검증을 위한 토큰을 찾을 수 없어요.",
    identifier_not_found: "사용자 식별자를 찾을 수 없어요. 처음부터 다시 로그인을 시도해 주세요.",
    interaction_not_found: "인터랙션 세션을 찾을 수 없어요. 처음부터 다시 세션을 시작해 주세요.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "이 이메일로는 SSO가 활성화되어 있어요. SSO로 로그인해 주세요."
};
var $e84da81f61f65347$export$2e2bcd8739ae039 = Object.freeze($e84da81f61f65347$var$session);


const $0eeeddcd146e3c08$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "이용 약관 URL이 비어 있어요. 이용 약관이 활성화되어 있다면, 이용 약관 URL를 설정해 주세요.",
    empty_social_connectors: "연동된 소셜이 없어요. 소셜 로그인을 사용한다면, 연동해 주세요.",
    enabled_connector_not_found: "활성된 {{type}} 연동을 찾을 수 없어요.",
    not_one_and_only_one_primary_sign_in_method: "반드시 하나의 메인 로그인 방법이 설정되어야 해요. 입력된 값을 확인해주세요.",
    username_requires_password: "회원가입 식별자에 대한 비밀번호 설정을 사용하도록 설정해야 해요.",
    passwordless_requires_verify: "이메일/휴대전화번호 가입 식별자에 대해 확인을 사용하도록 설정해야 해요.",
    miss_sign_up_identifier_in_sign_in: "로그인 방법에는 회원가입 ID가 포함되어야 해요.",
    password_sign_in_must_be_enabled: "회원가입 시 비밀번호를 설정해야 할 경우 비밀번호 로그인을 사용하도록 설정해야 해요.",
    code_sign_in_must_be_enabled: "비밀번호를 설정할 필요가 없을 때는 인증 코드 로그인을 활성화해야 해요.",
    unsupported_default_language: "{{language}} 언어는 아직 지원하지 않아요.",
    at_least_one_authentication_factor: "최소한 하나의 인증 방법을 선택해야 해요.",
    backup_code_cannot_be_enabled_alone: "백업 코드는 단독으로 활성화할 수 없습니다.",
    duplicated_mfa_factors: "중복된 MFA 인증 요소입니다."
};
var $0eeeddcd146e3c08$export$2e2bcd8739ae039 = Object.freeze($0eeeddcd146e3c08$var$sign_in_experiences);


const $fbc6424e5753519d$var$single_sign_on = {
    forbidden_domains: "공개 이메일 도메인은 허용되지 않습니다.",
    duplicated_domains: "중복된 도메인이 있습니다.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $fbc6424e5753519d$export$2e2bcd8739ae039 = Object.freeze($fbc6424e5753519d$var$single_sign_on);


const $3ce70217abb0899b$var$storage = {
    not_configured: "저장소 공급자가 구성되지 않았습니다.",
    missing_parameter: "저장소 공급자에 대한 누락된 매개변수 {{parameter}}.",
    upload_error: "파일을 저장소 공급자에 업로드하지 못했습니다."
};
var $3ce70217abb0899b$export$2e2bcd8739ae039 = Object.freeze($3ce70217abb0899b$var$storage);


const $25775bccf5dfda58$var$subscription = {
    limit_exceeded: "당신은 구독 플랜 한도에 도달하였습니다.",
    get_plan_failed: "임차인에 대한 구독 플랜을 가져올 수 없습니다.",
    tenant_suspended: "임차인이 정지되었습니다. 관리자에게 문의하십시오."
};
var $25775bccf5dfda58$export$2e2bcd8739ae039 = Object.freeze($25775bccf5dfda58$var$subscription);


const $7154f6bbb7250f04$var$swagger = {
    invalid_zod_type: "유효하지 않은 Zod 종류에요. Route Guard 설정을 확인해 주세요.",
    not_supported_zod_type_for_params: "지원되지 않는 Zod 종류예요. Route Guard 설정을 확인해 주세요."
};
var $7154f6bbb7250f04$export$2e2bcd8739ae039 = Object.freeze($7154f6bbb7250f04$var$swagger);


const $3c85a5838c632b4c$var$user = {
    username_already_in_use: "이 사용자 이름은 다른 사람이 이미 사용 중이에요.",
    email_already_in_use: "이 이메일은 다른 계정에서 이미 사용 중이에요.",
    phone_already_in_use: "이 휴대전화번호는 다른 계정에서 이미 사용 중이에요.",
    invalid_email: "유효하지 않은 이메일이에요.",
    invalid_phone: "유효하지 않은 휴대전화번호예요.",
    email_not_exist: "이메일 주소가 아직 등록되지 않았어요.",
    phone_not_exist: "휴대전화번호가 아직 등록되지 않았어요.",
    identity_not_exist: "소셜 계정이 아직 등록되지 않았어요.",
    identity_already_in_use: "소셜 계정이 이미 등록되어 있어요.",
    social_account_exists_in_profile: "이 소셜 계정은 이미 연동되어 있습니다.",
    cannot_delete_self: "자기 자신을 삭제할 수 없어요.",
    sign_up_method_not_enabled: "이 회원가입 방법은 활성화되어있지 않아요.",
    sign_in_method_not_enabled: "이 로그인 방법은 활성화되어있지 않아요.",
    same_password: "새로운 비밀번호는 이전 비밀번호와 같으면 안 돼요.",
    password_required_in_profile: "로그인 전에 비밀번호를 설정해야 해요.",
    new_password_required_in_profile: "새로운 비밀번호를 설정해야 해요.",
    password_exists_in_profile: "이미 비밀번호가 설정되어 있어요.",
    username_required_in_profile: "로그인 전에 사용자 이름을 설정해야 해요.",
    username_exists_in_profile: "이미 사용자 이름이 설정되어 있어요.",
    email_required_in_profile: "로그인 전에 이메일 주소를 설정해야 해요.",
    email_exists_in_profile: "이미 이메일 주소가 설정되어 있어요.",
    phone_required_in_profile: "로그인 전에 휴대전화번호를 설정해야 해요.",
    phone_exists_in_profile: "이미 휴대전화번호가 설정되어 있어요.",
    email_or_phone_required_in_profile: "로그인 전에 이메일 주소 또는 휴대전화번호를 설정해야 해요.",
    suspended: "이 계정은 일시 정지되었어요.",
    user_not_exist: "{{identifier}}의 사용자가 아직 등록되지 않았어요.",
    missing_profile: "로그인 전에 추가 정보를 제공해야 해요.",
    role_exists: "역할 ID {{roleId}}은/는 이미 이 사용자에게 할당되어 있어요.",
    invalid_role_type: "유효하지 않은 역할 유형입니다. 사용자에게 기계 대 기계 역할을 할당할 수 없습니다.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $3c85a5838c632b4c$export$2e2bcd8739ae039 = Object.freeze($3c85a5838c632b4c$var$user);


const $32a982b9a61f7a64$var$verification_code = {
    phone_email_empty: "전화번호와 이메일이 모두 비어 있어요.",
    not_found: "인증 코드를 찾을 수 없어요. 인증 코드를 먼저 요청하세요.",
    phone_mismatch: "전화번호가 맞지 않아요. 새 인증 코드를 요청해 주세요.",
    email_mismatch: "이메일이 맞지 않아요. 새 인증 코드를 요청해 주세요.",
    code_mismatch: "인증 코드가 일치하지 않아요.",
    expired: "인증 코드가 만료되었어요. 새 인증 코드를 요청해 주세요.",
    exceed_max_try: "인증 코드 재시도 한도에 도달했어요. 새 인증 코드를 요청해 주세요."
};
var $32a982b9a61f7a64$export$2e2bcd8739ae039 = Object.freeze($32a982b9a61f7a64$var$verification_code);


const $b42187c14e5daa03$var$errors = {
    request: $1374ba61daf574a5$export$2e2bcd8739ae039,
    auth: $7a5029cc3ae036c0$export$2e2bcd8739ae039,
    guard: $60a621d53be6c526$export$2e2bcd8739ae039,
    oidc: $5e606826487ef60c$export$2e2bcd8739ae039,
    user: $3c85a5838c632b4c$export$2e2bcd8739ae039,
    password: $c81913222eca19b7$export$2e2bcd8739ae039,
    session: $e84da81f61f65347$export$2e2bcd8739ae039,
    connector: $7efe7711a0abd7c4$export$2e2bcd8739ae039,
    verification_code: $32a982b9a61f7a64$export$2e2bcd8739ae039,
    sign_in_experiences: $0eeeddcd146e3c08$export$2e2bcd8739ae039,
    localization: $81cff14481891494$export$2e2bcd8739ae039,
    swagger: $7154f6bbb7250f04$export$2e2bcd8739ae039,
    entity: $d38115e059c730e0$export$2e2bcd8739ae039,
    log: $81b2d97c4938b2b4$export$2e2bcd8739ae039,
    role: $d8dfa8a691242e7a$export$2e2bcd8739ae039,
    scope: $2d56d4d07a20e904$export$2e2bcd8739ae039,
    storage: $3ce70217abb0899b$export$2e2bcd8739ae039,
    resource: $a147d63c5e1a2fb8$export$2e2bcd8739ae039,
    hook: $7b6f213fd77aed76$export$2e2bcd8739ae039,
    domain: $f56c446aeb06d6c5$export$2e2bcd8739ae039,
    subscription: $25775bccf5dfda58$export$2e2bcd8739ae039,
    application: $cb6fae3e45da5ae1$export$2e2bcd8739ae039,
    organization: $51e65e3d5252a940$export$2e2bcd8739ae039,
    single_sign_on: $fbc6424e5753519d$export$2e2bcd8739ae039
};
var $b42187c14e5daa03$export$2e2bcd8739ae039 = Object.freeze($b42187c14e5daa03$var$errors);


const $b71c7cf5029cd908$var$api_resource_details = {
    page_title: "API 리소스 세부 정보",
    back_to_api_resources: "API 리소스로 돌아가기",
    settings_tab: "설정",
    permissions_tab: "권한",
    settings: "설정",
    settings_description: "API 리소스(리소스 표시기) - 요청할 대상 서비스 또는 리소스(일반적으로 리소스의 ID를 나타내는 URI 형식 변수)를 나타냅니다.",
    management_api_settings_description: "Logto 관리 API는 관리자가 다양한 ID 관련 작업을 관리하고 보안 정책을 시행하며 규정 및 표준을 준수할 수 있도록 하는 포괄적인 API 컬렉션입니다.",
    management_api_notice: "이 API는 Logto 엔터티를 나타내며 수정 또는 삭제할 수 없습니다. 다양한 ID 관련 작업에 대해 관리 API를 사용할 수 있습니다. <a>더 알아보기</a>",
    token_expiration_time_in_seconds: "토큰 만료 시간 (초)",
    token_expiration_time_in_seconds_placeholder: "토큰 만료 시간을 입력해주세요",
    delete_description: '이 동작은 취소할 수 없습니다. 해당 API 리소스는 영원히 삭제됩니다. 삭제를 위해 API 리소스 이름 "<span>{{name}}</span>"을 입력해주세요.',
    enter_your_api_resource_name: "API 리소스 이름을 입력해주세요.",
    api_resource_deleted: "{{name}} API 리소스가 성공적으로 삭제되었습니다.",
    permission: {
        create_button: "권한 생성",
        create_title: "권한 생성",
        create_subtitle: "이 API에 필요한 권한을 정의합니다.",
        confirm_create: "권한 생성",
        name: "권한 이름",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "권한 이름에는 공백을 포함할 수 없습니다.",
        description: "설명",
        description_placeholder: "리소스를 볼 수 있는 권한",
        permission_created: "권한 {{name}}이 성공적으로 생성되었습니다.",
        delete_description: "이 권한이 삭제되면, 해당 권한을 가진 사용자는 해당 권한으로 인해 부여받은 접근 권한을 상실하게 됩니다.",
        deleted: '권한 "{{name}}"이 성공적으로 삭제되었습니다.'
    }
};
var $b71c7cf5029cd908$export$2e2bcd8739ae039 = Object.freeze($b71c7cf5029cd908$var$api_resource_details);


const $09678806de6033db$var$api_resources = {
    page_title: "API 리소스",
    title: "API 리소스",
    subtitle: "인증된 어플리케이션에서 사용될 API를 정의해주세요.",
    create: "API 리소스 생성",
    api_name: "API 이름",
    api_name_placeholder: "API 이름 입력",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "API 리소스에 대한 고유한 식별자예요. 절대 URI여야 하며 조각 (#) 컴포넌트가 없어야 해요. OAuth 2.0의 <a>resource parameter</a>와 같아요.",
    default_api: "Default API",
    default_api_label: "테넌트 당 기본 API는 0개 또는 1개만 지정 할 수 있어요. 기본 API가 지정되면 인증 요청에서 리소스 매개 변수를 생략할 수 있어요. 이후 토큰 교환이 기본적으로 대상에 해당하는 API를 사용하여 수행되어 JWT가 발급되어요. <a>자세히 알아보기</a>",
    api_resource_created: "{{name}} API 리소스가 성공적으로 생성되었어요."
};
var $09678806de6033db$export$2e2bcd8739ae039 = Object.freeze($09678806de6033db$var$api_resources);


const $9965abb006b4c3f6$var$application_details = {
    page_title: "애플리케이션 세부 정보",
    back_to_applications: "어플리케이션으로 돌아가기",
    check_guide: "가이드 확인",
    settings: "설정",
    settings_description: "애플리케이션은 Logto for OIDC, 로그인 환경, 감사 로그 등에서 애플리케이션을 식별하는 데 사용돼요.",
    advanced_settings: "고급 설정",
    advanced_settings_description: "고급 설정에는 OIDC 관련 용어가 포함돼요. 자세한 내용은 토큰 엔드포인트에서 확인할 수 있어요.",
    application_roles: "역할",
    machine_logs: "기계 로그",
    application_name: "어플리케이션 이름",
    application_name_placeholder: "나의 앱",
    description: "설명",
    description_placeholder: "어플리케이션 설명을 적어주세요.",
    config_endpoint: "OpenID Provider 구성 endpoint",
    authorization_endpoint: "인증 Endpoint",
    authorization_endpoint_tip: "인증 및 권한 부여를 진행할 End-Point예요. OpenID Connect <a>인증</a>에서 사용되던 값이에요.",
    logto_endpoint: "Logto endpoint",
    application_id: "앱 ID",
    application_id_tip: '일반적으로 Logto에서 생성되는 고유한 응용 프로그램 식별자예요. OpenID Connect에서 "<a>client_id</a>"의 약자이기도 해요.',
    application_secret: "앱 시크릿",
    redirect_uri: "Redirect URI",
    redirect_uris: "Redirect URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "사용자 로그인 이후, 리다이렉트될 URI 경로예요. 더욱 자세한 정보는 OpenID Connect <a>AuthRequest</a>를 참고해주세요.",
    post_sign_out_redirect_uri: "로그아웃 이후 Redirect URI",
    post_sign_out_redirect_uris: "로그아웃 이후 Redirect URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "로그아웃 이후, 리다이렉트될 URI 경로예요 (선택). 일부 앱에서는 실제 효과가 없을 수 있어요.",
    cors_allowed_origins: "CORS Allow Origins",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "기본으로 모든 리다이렉트의 오리진들은 허용돼요. 대체적으로 이 값을 건들 필요는 없어요. 더욱 자세한 정보는 <a>MDN doc</a>를 확인해주세요.",
    token_endpoint: "토큰 End-Point",
    user_info_endpoint: "사용자 정보 End-Point",
    enable_admin_access: "관리자 접근 활성화",
    enable_admin_access_label: "관리 API에 대한 접근을 활성화, 비활성화할 수 있어요. 활성화한다면, 이 어플리케이션에서 Access 토큰을 통해 관리 API를 사용할 수 있어요.",
    always_issue_refresh_token: "항상 Refresh Token을 발급하세요",
    always_issue_refresh_token_label: "다음 구성을 활성화하면 Logto 가 인증 요청에 `prompt=consent` 가 제시되었는지 여부와 상관없이 항상 Refresh Token 을 발급할 수 있게 됩니다. 그러나 OpenID Connect 와 호환되지 않으며 문제가 발생할 수 있으므로 필요하지 않은 경우에는 이러한 방법을 권장하지 않습니다. ",
    refresh_token_ttl: "Refresh Token Time to Live (TTL) (일)",
    refresh_token_ttl_tip: "Refresh Token이 새로운 엑세스 토큰을 요청할 수 있는 기간입니다. 토큰 요청이 이루어지면 Refresh Token 의 TTL 이 이 값으로 연장됩니다.",
    rotate_refresh_token: "Refresh Token 회전",
    rotate_refresh_token_label: "활성화하면, 원래의 TTL 중 70% 가 지난 후 또는 특정 조건이 충족되면 Refresh Token 요청에 대해 새로운 Refresh Token 을 발행합니다. <a>자세히 보기</a>",
    delete_description: "이 행동은 취소될 수 없어요. 어플리케이션을 영원히 삭제할 거에요. 삭제를 진행하기 위해 <span>{{name}}</span> 를 입력해주세요.",
    enter_your_application_name: "어플리케이션 이름을 입력해 주세요.",
    application_deleted: "{{name}} 어플리케이션이 성공적으로 삭제되었어요.",
    redirect_uri_required: "반드시 최소 하나의 Redirect URI 를 입력해야 해요.",
    roles: {
        name_column: "역할",
        description_column: "설명",
        assign_button: "역할 할당",
        delete_description: "이 행동은 이 장치 간 앱에서 이 역할을 제거합니다. 역할 자체는 여전히 존재하지만 이 장치 간 앱과 연계되지 않게 됩니다.",
        deleted: "{{name}} 가 성공적으로 삭제되었습니다.",
        assign_title: "{{name}} 에 역할 할당",
        assign_subtitle: "{{name}} 에게 하나 이상의 역할을 승인",
        assign_role_field: "역할 할당",
        role_search_placeholder: "역할 이름으로 검색",
        added_text: "{{value, number}} 추가됨",
        assigned_app_count: "{{value, number}} 개의 어플리케이션",
        confirm_assign: "역할 할당",
        role_assigned: "역할이 성공적으로 할당되었습니다.",
        search: "역할 이름, 설명 또는 ID로 검색",
        empty: "사용 가능한 역할이 없습니다."
    }
};
var $9965abb006b4c3f6$export$2e2bcd8739ae039 = Object.freeze($9965abb006b4c3f6$var$application_details);


const $cee3ba867b8a571e$var$applications = {
    page_title: "어플리케이션",
    title: "어플리케이션",
    subtitle: "인증에 Logto를 사용할 모바일, 단일 페이지, Machine-to-Machine 또는 기존 어플리케이션을 설정할 수 있어요.",
    subtitle_with_app_type: "Set up Logto authentication for your {{name}} application",
    create: "어플리케이션 생성",
    application_name: "어플리케이션 이름",
    application_name_placeholder: "나의 앱",
    application_description: "어플리케이션 설명",
    application_description_placeholder: "어플리케이션 설명을 적어주세요.",
    select_application_type: "어플리케이션 종류 선택",
    no_application_type_selected: "어플리케이션 종류를 선택하지 않았어요.",
    application_created: "어플리케이션이 성공적으로 생성되었어요.",
    app_id: "App ID",
    type: {
        native: {
            title: "Native App",
            subtitle: "Native 환경에서 작동하는 어플리케이션",
            description: "예) iOS, Android 앱"
        },
        spa: {
            title: "Single Page App",
            subtitle: "웹 브라우저에서 작동하며, 한 페이지에서 유동적으로 업데이트 되는 웹",
            description: "예) React DOM, Vue 앱"
        },
        traditional: {
            title: "Traditional Web",
            subtitle: "서버를 통하여 웹 페이지가 업데이트 되는 앱",
            description: "예) JSP, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "직접 리소스에 접근하는 엡(서비스)",
            description: "예) 백엔드 서비스"
        }
    },
    placeholder_title: "애플리케이션 유형을 선택하여 계속하세요",
    placeholder_description: "Logto는 OIDC용 애플리케이션 엔티티를 사용하여 앱 식별, 로그인 관리 및 감사 로그 생성과 같은 작업을 지원합니다."
};
var $cee3ba867b8a571e$export$2e2bcd8739ae039 = Object.freeze($cee3ba867b8a571e$var$applications);


const $7b3ad2f38b7e0642$var$cloud = {
    general: {
        onboarding: "온보딩"
    },
    welcome: {
        page_title: "환영합니다",
        title: "Logto Cloud 에 오신 것을 환영합니다! 조금 더 알고 싶어요.",
        description: "당신에 대해 더 잘 파악하여 Logto 경험을 특별하게 만들어 드릴게요. 정보는 저희가 안전하게 관리해요.",
        project_field: "Logto 를 아래의 목적으로 사용해요",
        project_options: {
            personal: "개인 프로젝트",
            company: "기업 프로젝트"
        },
        title_field: "해당 제목을 선택하세요",
        title_options: {
            developer: "개발자",
            team_lead: "팀 리더",
            ceo: "CEO",
            cto: "CTO",
            product: "상품",
            others: "기타"
        },
        company_name_field: "회사 이름",
        company_name_placeholder: "Acme.co",
        company_size_field: "회사의 규모가 어느 정도인가요?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "저는 이것 때문에 가입하려고 해요",
        reason_options: {
            passwordless: "비밀번호 없는 인증 및 UI를 위한 도구를 찾고 있어요",
            efficiency: "즉시 사용 가능한 인증 인프라를 찾고 있어요",
            access_control: "역할 및 책임에 따라 사용자의 접근을 제어하고 싶어요",
            multi_tenancy: "멀티 테넌시 제품을 위한 대응 방법을 찾고 있어요",
            enterprise: "기업 준비성을 위한 SSO 솔루션을 찾고 있어요",
            others: "기타"
        }
    },
    sie: {
        page_title: "로그인 환경 변경하기",
        title: "먼저 로그인 환경을 간편하게 사용자화해 보세요.",
        inspire: {
            title: "흥미로운 예시 만들기",
            description: '로그인 환경에 대해 확신이 서지 않으시나요? "영감을 주세요"를 클릭하고 마법을 일으켜 보세요!',
            inspire_me: "영감을 주세요"
        },
        logo_field: "앱 로고",
        color_field: "브랜드 색상",
        identifier_field: "식별자",
        identifier_options: {
            email: "이메일",
            phone: "휴대전화",
            user_name: "사용자 이름"
        },
        authn_field: "인증",
        authn_options: {
            password: "비밀번호",
            verification_code: "인증 코드"
        },
        social_field: "소셜 로그인",
        finish_and_done: "완료하고 넘어가기",
        preview: {
            mobile_tab: "모바일",
            web_tab: "웹"
        },
        connectors: {
            unlocked_later: "나중에 잠금 해제",
            unlocked_later_tip: "등록 절차를 완료하고 제품에 가입하면 더 많은 소셜 로그인 방법에 액세스할 수 있습니다.",
            notice: "데모 연동을 실제 운영 목적으로 사용하지 마세요. 테스트를 완료한 후에는 데모 연동을 삭제하고 자격 증명을 사용하여 고유한 연동을 설정하세요."
        }
    },
    socialCallback: {
        title: "성공적으로 로그인했어요",
        description: "소셜 계정을 사용하여 로그인에 성공했어요. Logto의 모든 기능을 원활하게 통합하고 접근하려면 당신의 소셜 연동을 구성하는 것이 좋습니다."
    },
    tenant: {
        create_tenant: "테넌트 생성하기"
    }
};
var $7b3ad2f38b7e0642$export$2e2bcd8739ae039 = Object.freeze($7b3ad2f38b7e0642$var$cloud);


const $72d0c264ead9f52e$var$components = {
    uploader: {
        action_description: "드래그 앤 드롭 또는 탐색하기",
        uploading: "업로드 중...",
        image_limit: "{{size, number}}KB 미만의 {{extensions, list(style: narrow; type: conjunction;)}} 파일만 업로드하세요.",
        error_upload: "오류가 발생했습니다. 파일 업로드에 실패하였습니다.",
        error_file_size: "파일 크기가 너무 커요. {{size, number}}KB 미만의 파일을 업로드해 주세요.",
        error_file_type: "지원되지 않는 파일 유형이에요. {{extensions, list(style: narrow; type: conjunction;)}} 파일만 사용 가능해요.",
        error_file_count: "파일은 1개만 업로드 가능합니다."
    }
};
var $72d0c264ead9f52e$export$2e2bcd8739ae039 = Object.freeze($72d0c264ead9f52e$var$components);


const $6ddeefe6f7ddc8c4$var$connector_details = {
    page_title: "커넥터 세부 정보",
    back_to_connectors: "연동으로 돌아가기",
    check_readme: "README 확인",
    settings: "일반 설정",
    settings_description: "Logto에서 연동은 중요한 역할을 해요. 연동 시스템을 통하여, 사용자들에게 비밀번호 없이 회원 가입을 하고 로그인을 할 수 있게 하거나, 소셜 계정을 통하여 로그인을 할 수 있게 도와줘요.",
    parameter_configuration: "매개변수 설정",
    test_connection: "테스트",
    save_error_empty_config: "설정을 입력해 주세요.",
    send: "보내기",
    send_error_invalid_format: "유효하지 않은 입력",
    edit_config_label: "여기에 JSON을 입력해 주세요.",
    test_email_sender: "이메일 연동 테스트",
    test_sms_sender: "SMS 연동 테스트",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+82 10-1234-5678",
    test_message_sent: "테스트 메세지 전송 완료",
    test_sender_description: 'Logto는 "Generic" 템플릿을 사용하여 테스트합니다. 커넥터가 올바르게 구성되면 메시지를 받게 됩니다.',
    options_change_email: "이메일 연동 수정",
    options_change_sms: "SMS 연동 수정",
    connector_deleted: "연동이 성공적으로 제거되었어요.",
    type_email: "이메일 연동",
    type_sms: "SMS 연동",
    type_social: "소셜 연동",
    in_used_social_deletion_description: "이 연동은 로그인 경험에서 사용 중이에요. 삭제하면 로그인 경험 설정에서 <name/> 로그인 경험이 삭제됩니다. 나중에 되돌리려면 다시 구성해야 해요.",
    in_used_passwordless_deletion_description: "{name}}은/는 로그인 경험에서 사용 중이에요. 삭제하면 충돌을 해결할 때까지 로그인 환경이 제대로 작동하지 않을 거예요. 나중에 되돌리려면 다시 구성해야 해요.",
    deletion_description: "이 연동을 삭제하려고 하고 있어요. 이 작업은 돌이킬 수 없으며, 나중에 되돌리려면 다시 구성해야 해요.",
    logto_email: {
        total_email_sent: "전체 이메일 발송: {{value, number}}",
        total_email_sent_tip: "Logto 에서 안전하고 안정적인 내장형 이메일을 위해 SendGrid 를 사용합니다. 완전 무료로 사용할 수 있습니다. <a>자세히 알아보기</a>",
        email_template_title: "이메일 템플릿",
        template_description: "내장형 이메일은 기본 템플릿을 사용하여 검증 이메일을 원활하게 전달합니다. 구성이 필요하지 않으며, 기본 브랜드 정보를 사용자 정의할 수 있습니다.",
        template_description_link_text: "템플릿 보기",
        description_action_text: "템플릿 보기",
        from_email_field: "보내는 이메일",
        sender_name_field: "보내는 사람 이름",
        sender_name_tip: '이메일의 보내는 사람 이름을 사용자 정의합니다. 비워 두면 기본 이름으로 "Verification" 이 사용됩니다.',
        sender_name_placeholder: "보내는 사람 이름을 입력해주세요.",
        company_information_field: "회사 정보",
        company_information_description: "이메일 하단에 회사 이름, 주소 또는 우편번호를 표시하여 신뢰성을 높입니다.",
        company_information_placeholder: "회사의 기본 정보",
        app_logo_field: "앱 로고",
        app_logo_tip: "이메일 상단에 브랜드 로고를 표시합니다. 라이트 모드와 다크 모드에 모두 동일한 이미지를 사용합니다.",
        urls_not_allowed: "URL은 허용되지 않습니다.",
        test_notes: 'Logto는 "Generic" 템플릿을 사용하여 테스트합니다.'
    }
};
var $6ddeefe6f7ddc8c4$export$2e2bcd8739ae039 = Object.freeze($6ddeefe6f7ddc8c4$var$connector_details);


const $700493dd896af5a2$var$connectors = {
    page_title: "연동",
    title: "연동",
    subtitle: "연동을 통해 비밀번호 없는 로그인이나 소셜 로그인을 제공해 보세요.",
    create: "소셜 연동 추가",
    config_sie_notice: "새로운 연동이 설정되었어요. 다음 링크에서 설정을 마무리해 주세요. <a>{{link}}</a>.",
    config_sie_link_text: "로그인 경험",
    tab_email_sms: "이메일/SMS 연동",
    tab_social: "소셜 연동",
    connector_name: "연동 이름",
    demo_tip: "이 데모 연동에 허용되는 최대 메시지 수는 100개로 제한되며 실제 운영 환경에서의 배포에는 권장되지 않아요.",
    social_demo_tip: "데모 연동은 데모 전용으로 설계되었으며 실제 운영 환경에 배포하는 것은 권장되지 않습니다.",
    connector_type: "종류",
    connector_status: "로그인 경험",
    connector_status_in_use: "사용 중",
    connector_status_not_in_use: "사용 중이 아님",
    not_in_use_tip: {
        content: "사용 중이 아님은 로그인 환경에서 이 로그인 방법을 사용하지 않았음을 의미해요. <a>{{link}}</a> 이 로그인 방법을 추가해주세요.",
        go_to_sie: "로그인 경험으로 가서"
    },
    placeholder_title: "소셜 연동",
    placeholder_description: "Logto는 널리 사용되는 다양한 소셜 로그인 커넥터를 제공하고 있으며, 표준 프로토콜을 사용하여 자신만의 커넥터를 만들 수도 있어요.",
    save_and_done: "저장 및 완료",
    type: {
        email: "이메일 연동",
        sms: "SMS 연동",
        social: "소셜 연동"
    },
    setup_title: {
        email: "이메일 연동 설정",
        sms: "SMS 연동 설정",
        social: "소셜 연동 추가 및 설정"
    },
    guide: {
        subtitle: "단계별 가이드를 따라 연동해 주세요.",
        general_setting: "일반 설정",
        parameter_configuration: "매개변수 설정",
        test_connection: "연결 테스트",
        name: "소셜 로그인 버튼 이름",
        name_placeholder: "소셜 로그인 버튼 이름을 입력하세요",
        name_tip: '다음과 같이 연동 이름이 출력돼요. "{{name}}으로 계속하기".',
        logo: "연동 로고 URL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "이 이미지는 연동 버튼에 보여질 거에요.",
        logo_dark: "소셜 로그인에 사용될 로고 URL (다크 모드)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "관리자 콘솔의 로그인 경험에서 다크 모드를 위한 로고를 활성화한 후 다크 모드용 연동 로고를 설정해 주세요.",
        logo_dark_collapse: "최소화",
        logo_dark_show: "다크 모드를 위한 로고 설정 보이기",
        target: "연동 ID 공급자",
        target_placeholder: "연동 ID 공급자 이름을 입력하세요",
        target_tip: '"IdP 이름"의 값은 소셜 식별자를 구분하기 위한 고유 식별자 문자열이 될 수 있어요.',
        target_tip_standard: '"IdP 이름"의 값은 소셜 식별자를 구분하기 위한 고유 식별자 문자열이 될 수 있어요. 이 설정은 연동이 만들어진 후에는 변경할 수 없어요.',
        target_tooltip: 'Logto의 소셜 연동에서의 "공급자"는 소셜 정보의 원천을 뜻해요. Logto의 디자인은 충돌을 피하기 위해서 같은 "공급자"를 허용하지 않아요. 연동을 추가한 후에는 값을 변경할 수 없으므로 주의해주세요. <a>자세히 알아보기</a>',
        target_conflict: "입력한 IdP 이름이 기존 <span>name</span>과 일치해요. 동일한 IdP 이름을 사용하면 사용자가 두 개의 다른 커넥터를 통해 동일한 계정에 액세스할 수 있는 예기치 않은 로그인 동작이 발생할 수 있어요.",
        target_conflict_line2: '현재 연동을 동일한 ID 공급자로 바꾸고 이전 사용자가 다시 등록하지 않고도 로그인할 수 있도록 하려면 <span>name</span> 커넥터를 삭제하고 동일한 "IdP 이름"으로 새 커넥터를 만드세요.',
        target_conflict_line3: '다른 ID 공급자에 연결하려면 "IdP 이름"을 수정한 후 계속 진행하세요.',
        config: "여기에 JSON을 입력",
        sync_profile: "프로필 정보 동기화",
        sync_profile_only_at_sign_up: "회원가입할 때 동기화",
        sync_profile_each_sign_in: "로그인할 때마다 동기화",
        sync_profile_tip: "이름과 아바타와 같은 기본적인 사용자 프로필을 동기화해요.",
        callback_uri: "Callback URI",
        callback_uri_description: "리다이렉트 URI라고도 불려요. 사용자의 소셜 인증 이후 되돌아올 Logto URI예요. 소셜 공급자의 설정 페이지에 붙여넣으세요."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: " 다양한 플랫폼 지원, 플랫폼을 선택해주세요.",
    drawer_title: "연동 가이드",
    drawer_subtitle: "연동하기 위해 가이드를 따라 주세요.",
    unknown: "알 수 없는 연동",
    standard_connectors: "기본 커넥터"
};
var $700493dd896af5a2$export$2e2bcd8739ae039 = Object.freeze($700493dd896af5a2$var$connectors);


const $a145154b0f1b5033$var$contact = {
    title: "지원 받기",
    description: "도움 요청 또는 제품 피드백을 위해서, 아래의 방법을 통해 저희에게 문의해주세요.",
    discord: {
        title: "디스코드 커뮤니티 가입하기",
        description: "다른 개발자들과 솔루션을 찾기 위해 연결하세요.",
        button: "가입하기"
    },
    github: {
        title: "GitHub 에서 소통하기",
        description: "이슈를 작성하고 GitHub에 제출하세요.",
        button: "열기"
    },
    email: {
        title: "이메일로 지원팀과 연락하기",
        description: "더 많은 정보나 도움을 위해 이메일을 보내주세요.",
        button: "보내기"
    },
    reserve: {
        title: "Logto 팀과의 시간을 예약하세요",
        description: "빠르게 대화를 위해 세션 예약",
        button: "예약하기"
    }
};
var $a145154b0f1b5033$export$2e2bcd8739ae039 = Object.freeze($a145154b0f1b5033$var$contact);


const $61e20bfe07384ac3$var$dashboard = {
    page_title: "대시보드",
    title: "대시보드",
    description: "앱 사용자에 대한 개요를 볼 수 있어요.",
    total_users: "전체 사용자",
    total_users_tip: "전체 사용자",
    new_users_today: "새로운 사용자 (오늘)",
    new_users_today_tip: "오늘 앱에 새로 가입한 사용자",
    new_users_7_days: "새로운 사용자 (최근 7일)",
    new_users_7_days_tip: "최근 7일 동안 앱에 새로 가입한 사용자",
    daily_active_users: "활성화 사용자 (오늘)",
    daily_active_users_tip: "오늘 앱을 통하여 Token을 가져간 사용자 수",
    weekly_active_users: "활성화 사용자 (최근 7일)",
    weekly_active_users_tip: "최근 7일 동안 앱을 통하여 Token을 가져간 사용자 수",
    monthly_active_users: "활성화 사용자 (최근 30일)",
    monthly_active_users_tip: "최근 30일 동안 앱을 통하여 Token을 가져간 사용자 수"
};
var $61e20bfe07384ac3$export$2e2bcd8739ae039 = Object.freeze($61e20bfe07384ac3$var$dashboard);


const $7fd3b2c0b53065f8$var$domain = {
    status: {
        connecting: "연결 중",
        in_used: "사용 중",
        failed_to_connect: "연결 실패"
    },
    update_endpoint_notice: "사용자 지정 도메인을 사용하려면 애플리케이션에서 소셜 커넥터 콜백 URI 및 Logto 엔드포인트의 도메인을 업데이트해야합니다. <a>{{link}}</a>",
    error_hint: "DNS 레코드를 업데이트해야합니다. {{value}}초마다 체크하도록 계속합니다.",
    custom: {
        custom_domain: "사용자 지정 도메인",
        custom_domain_description: "브랜딩을 개선하고 사용자 지정 도메인을 활용하세요. 이 도메인은 로그인 경험에서 사용됩니다.",
        custom_domain_field: "사용자 지정 도메인",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "도메인 추가",
        invalid_domain_format: "잘못된 하위 도메인 형식입니다. 하위 도메인은 적어도 3부분으로 구성돼야 합니다.",
        verify_domain: "도메인 확인",
        enable_ssl: "SSL 사용",
        checking_dns_tip: "DNS 레코드를 구성한 후 자동 프로세스가 실행되며 최대 24시간이 걸릴 수 있습니다. 인터페이스에서 이 작업을 나갈 수 있습니다.",
        enable_ssl_tip: "SSL 사용은 자동으로 실행되며 최대 24시간이 걸릴 수 있습니다. 이 인터페이스를 나갈 수 있습니다.",
        generating_dns_records: "DNS 레코드 생성 중...",
        add_dns_records: "이 DNS 레코드를 DNS 공급자에 추가하세요.",
        dns_table: {
            type_field: "유형",
            name_field: "이름",
            value_field: "값"
        },
        deletion: {
            delete_domain: "도메인 삭제",
            reminder: "사용자 지정 도메인 삭제",
            description: "이 사용자 지정 도메인을 삭제하시겠습니까?",
            in_used_description: '이 사용자 지정 도메인 "<span>{{domain}}</span>"이 현재 사용 중입니다. 삭제하시겠습니까?',
            in_used_tip: '이전에 소셜 커넥터 공급자나 애플리케이션 엔드포인트에 이 사용자 지정 도메인을 설정한 경우 로그인 버튼이 작동하도록 먼저 Logto 기본 도메인의 "<span>{{domain}}</span>" URI를 수정해야합니다.',
            deleted: "사용자 지정 도메인을 성공적으로 삭제했습니다!"
        }
    },
    default: {
        default_domain: "기본 도메인",
        default_domain_description: "Logto는 추가 구성 없이 사용할 수 있는 미리 구성된 기본 도메인을 제공합니다. 이 기본 도메인은 사용자 지정 도메인을 사용하지 않더라도 백업 옵션으로 사용됩니다.",
        default_domain_field: "Logto 기본 도메인"
    },
    custom_endpoint_note: '이 엔드포인트의 도메인 이름을 필요에 따라 사용자 정의할 수 있습니다. "{{custom}}" 또는 "{{default}}" 중 하나를 선택하세요.',
    custom_social_callback_url_note: '이 URI의 도메인 이름을 애플리케이션 엔드포인트와 일치하도록 사용자 정의할 수 있습니다. "{{custom}}" 또는 "{{default}}" 중 하나를 선택하세요.'
};
var $7fd3b2c0b53065f8$export$2e2bcd8739ae039 = Object.freeze($7fd3b2c0b53065f8$var$domain);


const $b86b3205e0be1365$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $b86b3205e0be1365$export$2e2bcd8739ae039 = Object.freeze($b86b3205e0be1365$var$enterprise_sso_details);


const $448f4f315b4b61f4$var$enterprise_sso = {
    page_title: "기업 SSO",
    title: "기업 SSO",
    subtitle: "기업 신원 공급자를 연결하고 SP-initiated 단일 로그인을 활성화합니다.",
    create: "기업 커넥터 추가",
    col_connector_name: "커넥터 이름",
    col_type: "유형",
    col_email_domain: "이메일 도메인",
    placeholder_title: "기업 커넥터",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "기업 커넥터 추가",
        text_divider: "또는 표준 프로토콜을 사용하여 커넥터를 사용자 정의할 수 있습니다.",
        connector_name_field_title: "커넥터 이름",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "커넥터 생성"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $448f4f315b4b61f4$export$2e2bcd8739ae039 = Object.freeze($448f4f315b4b61f4$var$enterprise_sso);


const $c35b7d126e912a41$var$errors = {
    something_went_wrong: "알 수 없는 오류가 발생했어요.",
    page_not_found: "페이지를 찾을 수 없어요.",
    unknown_server_error: "서버에서 알 수 없는 오류가 발생했어요.",
    empty: "데이터 없음",
    missing_total_number: "Total-Number를 응답 해더에서 찾을 수 없어요.",
    invalid_uri_format: "URI 형식이 유효하지 않음",
    invalid_origin_format: "URI origin 형식이 유효하지 않음",
    invalid_json_format: "JSON 형식이 유효하지 않음",
    invalid_error_message_format: "오류 메세지 형식이 유효하지 않아요.",
    required_field_missing: "{{field}}을/를 입력해 주세요.",
    required_field_missing_plural: "최소 1개의 {{field}}을/를 입력해야 해요.",
    more_details: "자세히",
    username_pattern_error: "아이디는 반드시 문자, 숫자, _ 만으로 이루어져야 하며, 숫자로 시작하면 안 돼요.",
    email_pattern_error: "이메일 형식이 유효하지 않아요.",
    phone_pattern_error: "전화번호 형식이 유효하지 않아요.",
    insecure_contexts: "비보안 연결(non-HTTPS)는 지원하지 않아요.",
    unexpected_error: "알 수 없는 오류가 발생했어요.",
    not_found: "404 찾을 수 없음",
    create_internal_role_violation: 'Logto에 의해 금지된 내부 역할을 생성하려고 하고 있어요. "#internal:"로 시작하지 않는 다른 이름을 사용하세요.',
    should_be_an_integer: "정수이어야 합니다.",
    number_should_be_between_inclusive: "숫자는 {{min}} 이상 {{max}} 이하이어야 합니다."
};
var $c35b7d126e912a41$export$2e2bcd8739ae039 = Object.freeze($c35b7d126e912a41$var$errors);


const $a7b64b6a31ae956d$var$general = {
    placeholder: "플레이스홀더",
    submit: "제출",
    skip: "건너뛰기",
    next: "다음",
    back: "뒤로",
    retry: "재시도",
    done: "완료",
    search: "검색",
    search_placeholder: "검색",
    clear_result: "결과 지우기",
    save: "저장",
    save_changes: "변경 내용 저장",
    saved: "저장됨",
    discard: "취소",
    loading: "로딩 중...",
    redirecting: "리다이렉트 중...",
    add: "추가",
    added: "추가됨",
    cancel: "취소",
    confirm: "확인",
    check_out: "확인하기",
    create: "생성",
    set_up: "설정",
    customize: "사용자화",
    enable: "활성화",
    reminder: "리마인더",
    delete: "삭제",
    more_options: "더 많은 설정",
    close: "닫기",
    copy: "복사",
    copying: "복사 중",
    copied: "복사됨",
    required: "필수",
    add_another: "새로 추가",
    create_another: "또 다른 것 만들기",
    deletion_confirmation: "정말로 {{title}}을/를 삭제할까요?",
    settings_nav: "설정",
    unsaved_changes_warning: "수정된 내용이 있어요. 정말로 현재 페이지를 벗어날까요?",
    leave_page: "페이지 나가기",
    stay_on_page: "페이지 유지하기",
    type_to_search: "검색어 입력",
    got_it: "알겠어요",
    continue: "계속하기",
    page_info: "{{min, number}}-{{max, number}} / {{total, number}}",
    learn_more: "더 알아보기",
    tab_errors: "{{count, number}} 오류",
    skip_for_now: "지금은 건너뛰기",
    remove: "삭제",
    visit: "방문하기",
    join: "참여하기",
    try_now: "지금 시도하기",
    multiple_form_field: "(복수 선택)",
    demo: "데모",
    unnamed: "이름없음",
    view: "보기",
    hide: "숨기기",
    unknown_error: "알 수 없는 오류가 발생했습니다. 나중에 다시 시도해주세요.",
    select: "선택",
    contact_us_action: "문의하기",
    description: "설명",
    name: "이름",
    add_field: "{{field}} 추가",
    create_field: "{{field}} 만들기",
    edit_field: "{{field}} 편집",
    delete_field: "{{field}} 삭제",
    coming_soon: "곧 출시 예정",
    beta_notice: "\uD83C\uDF89  {{feature}}는 현재 베타 버전입니다. 탐색하고 <ContactLink>피드백을 공유</ContactLink>해주세요."
};
var $a7b64b6a31ae956d$export$2e2bcd8739ae039 = Object.freeze($a7b64b6a31ae956d$var$general);


const $6bdec7b3d68c1ed2$var$get_started = {
    page_title: "시작하기",
    title: "성공하는 데 도움이 될 탐색 항목",
    subtitle: "Logto의 가치를 빠르게 얻을 수 있는 몇 가지 방법",
    develop: {
        title: "개발: 앱을 통합하는 데 5분이면 충분합니다"
    },
    customize: {
        title: "사용자 정의: 훌륭한 로그인 경험 전달하기",
        preview: {
            title: "방금 사용자 정의한 로그인 경험의 실시간 미리보기 확인하기",
            subtitle: "작동 방식을 확인하려면 지금 Logto 로그인 경험을 시도해보세요"
        },
        connector: {
            title: "더 많은 커넥터 추가하여 더 많은 소셜 로그인 방식 지원하기",
            subtitle: "비밀번호 없는 로그인을 시도하고 고객에게 안전하고 원활한 경험을 제공하세요"
        },
        continue_customizing: "사용자 정의 계속하기",
        try_now: "지금 시도해보세요",
        add_more: "더 추가하기"
    },
    secure: {
        title: "보안: 리소스 보호"
    },
    manage: {
        title: "관리: 제품 및 사용자에 대한 액세스 제어 정의",
        rbac: {
            title: "롤 기반 액세스 제어 추가하여 리소스 보호",
            subtitle: "다양한 사용 사례에 대해 확장 가능한 역할 권한부여를 통해 리소스 제어"
        },
        create_roles: "역할 생성"
    },
    view_all: "모두 보기 →"
};
var $6bdec7b3d68c1ed2$export$2e2bcd8739ae039 = Object.freeze($6bdec7b3d68c1ed2$var$get_started);


const $440619938a89d99c$var$guide = {
    start_building: "시작하기",
    get_started: "시작하기",
    categories: {
        featured: "인기와 당신을 위한",
        Traditional: "전통적인 웹 앱",
        SPA: "싱글 페이지 앱",
        Native: "네이티브",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "프레임워크 필터",
        placeholder: "프레임워크 검색하기"
    },
    checkout_tutorial: "튜토리얼 {{name}} 확인하기",
    do_not_need_tutorial: "튜토리얼이 필요하지 않다면, 프레임워크 가이드 없이 계속할 수 있습니다.",
    finish_and_done: "완료",
    cannot_find_guide: "가이드를 찾을 수 없습니다.",
    describe_guide_looking_for: "찾고 계신 가이드에 대해 설명해주세요.",
    request_guide_successfully: "요청이 성공적으로 제출되었습니다. 감사합니다!",
    app: {
        select_framework_or_tutorial: "프레임워크 또는 튜토리얼 선택",
        guide_modal_title: "SDK 및 가이드로 시작하기",
        modal_subtitle: "사전 빌드된 SDK와 튜토리얼로 앱 개발 프로세스를 바로 시작하세요.",
        select_a_framework: "프레임워크 선택하기",
        continue_without_framework: "프레임워크 없이 앱 만들기",
        describe_guide_looking_for_placeholder: "예시: Angular 앱에 Logto 통합하고 싶습니다."
    },
    api: {
        modal_title: "튜토리얼로 시작하기",
        modal_subtitle: "사전 빌드된 튜토리얼로 앱 개발 프로세스를 바로 시작하세요.",
        select_a_tutorial: "튜토리얼 선택하기",
        continue_without_tutorial: "튜토리얼 없이 계속하기",
        describe_guide_looking_for_placeholder: "예시: Deno를 사용하여 API 보호하기"
    }
};
var $440619938a89d99c$export$2e2bcd8739ae039 = Object.freeze($440619938a89d99c$var$guide);


const $f68720ecc4ed6862$var$log_details = {
    page_title: "감사 로그 세부 정보",
    back_to_logs: "감사 기록으로 돌아가기",
    back_to: "{{name}}으로 돌아가기",
    success: "성공",
    failed: "실패",
    event_key: "이벤트 키",
    application: "어플리케이션",
    ip_address: "IP 주소",
    user: "사용자",
    log_id: "기록 ID",
    time: "시간",
    user_agent: "사용자 Agent",
    tab_details: "상세",
    raw_data: "상세 데이터"
};
var $f68720ecc4ed6862$export$2e2bcd8739ae039 = Object.freeze($f68720ecc4ed6862$var$log_details);


const $5984508b9dcd8793$var$logs = {
    page_title: "감사 기록",
    title: "감사 기록",
    subtitle: "관리자나 사용자의 인증 기록을 확인해 보세요.",
    event: "활동",
    user: "사용자",
    application: "어플리케이션",
    time: "시간",
    filter_by: "필터"
};
var $5984508b9dcd8793$export$2e2bcd8739ae039 = Object.freeze($5984508b9dcd8793$var$logs);


const $e514d48755dacdaf$var$menu = {
    profile: "프로필",
    language: "언어",
    appearance: {
        label: "모습",
        light: "라이트 모드",
        dark: "다크 모드",
        system: "시스템과 동기화"
    },
    sign_out: "로그아웃"
};
var $e514d48755dacdaf$export$2e2bcd8739ae039 = Object.freeze($e514d48755dacdaf$var$menu);


const $5ef3d0ad5c5b6ffd$var$mfa = {
    title: "다중 인증",
    description: "다중 인증을 추가하여 로그인 경험의 보안을 강화하세요.",
    factors: "요소",
    multi_factors: "다중 요소",
    multi_factors_description: "사용자는 2단계 인증을 위해 활성화된 요소 중 하나를 확인해야 합니다.",
    totp: "인증기 앱 OTP",
    otp_description: "Google Authenticator 등을 연결하여 일회용 암호를 확인합니다.",
    webauthn: "WebAuthn(패스키)",
    webauthn_description: "브라우저에서 지원하는 방법으로 확인합니다: 생체 인식, 휴대폰 스캔 또는 보안 키 등.",
    webauthn_native_tip: "네이티브 애플리케이션에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_domain_tip: "WebAuthn은 공개 키를 특정 도메인에 바인딩합니다. 서비스 도메인을 수정하면 기존 패스키를 사용한 사용자의 인증이 차단됩니다.",
    backup_code: "백업 코드",
    backup_code_description: "사용자가 어떤 MFA 방법을 설정한 후에 10개의 일회용 백업 코드를 생성합니다.",
    backup_code_setup_hint: "사용자가 위의 MFA 요소를 확인할 수 없는 경우 백업 옵션을 사용하세요.",
    backup_code_error_hint: "백업 코드를 사용하려면 성공적인 사용자 인증을 위해 적어도 하나 이상의 MFA 방법이 필요합니다.",
    policy: "정책",
    policy_description: "로그인 및 가입 플로우에 대한 MFA 정책을 설정합니다.",
    two_step_sign_in_policy: "로그인 시 2단계 인증 정책",
    user_controlled: "사용자는 자체적으로 MFA를 활성화 또는 비활성화할 수 있습니다",
    user_controlled_tip: "사용자는 처음 로그인 또는 가입 시에 MFA 설정을 건너 뛰거나 계정 설정에서 활성화/비활성화할 수 있습니다.",
    mandatory: "사용자는 항상 로그인 시 MFA 사용이 필요합니다",
    mandatory_tip: "사용자는 처음 로그인 또는 가입 시에 MFA를 설정하고 모든 향후 로그인에서 그것을 사용해야 합니다."
};
var $5ef3d0ad5c5b6ffd$export$2e2bcd8739ae039 = Object.freeze($5ef3d0ad5c5b6ffd$var$mfa);


const $95adc621154f7837$var$organization_details = {
    page_title: "조직 세부 정보",
    delete_confirmation: "삭제하면 모든 회원이 이 조직에서 멤버십과 역할을 잃게 됩니다. 이 작업은 취소할 수 없습니다.",
    organization_id: "조직 ID",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "조직의 이름, 고유할 필요는 없습니다.",
    description_placeholder: "조직에 대한 설명입니다.",
    member: "멤버",
    member_other: "멤버",
    add_members_to_organization: "조직 {{name}}에 멤버 추가",
    add_members_to_organization_description: "이름, 이메일, 전화 또는 사용자 ID를 검색하여 적절한 사용자를 찾습니다. 기존 멤버는 검색 결과에 표시되지 않습니다.",
    add_with_organization_role: "조직 역할로 추가",
    user: "사용자",
    authorize_to_roles: "{{name}}에게 다음 역할에 대한 액세스 권한 부여:",
    edit_organization_roles: "조직 역할 편집",
    edit_organization_roles_of_user: "{{name}}의 조직 역할 편집",
    remove_user_from_organization: "사용자를 조직에서 제거",
    remove_user_from_organization_description: "제거하면 사용자가 이 조직에서 멤버십과 역할을 잃습니다. 이 작업은 취소할 수 없습니다.",
    search_user_placeholder: "이름, 이메일, 전화 또는 사용자 ID로 검색",
    at_least_one_user: "최소한 한 명의 사용자가 필요합니다."
};
var $95adc621154f7837$export$2e2bcd8739ae039 = Object.freeze($95adc621154f7837$var$organization_details);


const $a43b3a55d381a7cc$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "조직",
    title: "조직",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "조직 ID",
    members: "회원",
    create_organization: "조직 만들기",
    setup_organization: "조직 설정",
    organization_list_placeholder_title: "조직",
    organization_list_placeholder_text: "조직은 일반적으로 SaaS 또는 SaaS와 유사한 멀티 테넌시 앱에서 사용됩니다. 조직 기능을 사용하면 B2B 고객이 파트너 및 고객을 효과적으로 관리하고 최종 사용자가 응용 프로그램에 액세스하는 방식을 사용자 정의할 수 있게 됩니다.",
    organization_name_placeholder: "내 조직",
    organization_description_placeholder: "조직에 대한 간략한 설명",
    organization_permission: "조직 권한",
    organization_permission_other: "조직 권한",
    organization_permission_description: "조직 권한은 조직 컨텍스트에서 리소스에 액세스하기 위한 권한을 나타냅니다. 조직 권한은 의미 있는 문자열로 표현되어야 하며 이름 및 고유 식별자로도 작동해야 합니다.",
    organization_permission_delete_confirm: "이 권한이 삭제되면 이 권한을 포함하는 모든 조직 역할은 이 권한을 상실하고 이 권한이 부여한 액세스도 상실합니다.",
    create_permission_placeholder: "약속 내역 읽기",
    permission: "권한",
    permission_other: "권한",
    organization_role: "조직 역할",
    organization_role_other: "조직 역할",
    organization_role_description: "조직 역할은 사용자에 할당할 수 있는 권한의 그룹화입니다. 권한은 미리 정의된 조직 권한에서 가져와야 합니다.",
    organization_role_delete_confirm: "이렇게 하면 영향을 받는 사용자에서 이 역할과 관련된 권한이 제거되고 조직 역할, 조직 구성원 및 조직 권한 간의 관계가 삭제됩니다.",
    role: "역할",
    create_role_placeholder: "보기 전용 권한을 가진 사용자",
    search_placeholder: "조직 이름 또는 ID로 검색",
    search_permission_placeholder: "검색하여 권한 선택",
    search_role_placeholder: "검색하여 역할 선택",
    empty_placeholder: "\uD83E\uDD14 You don’t have any {{entity}} set up yet.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "가이드로 시작",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "일러스트를 상호 작용하여 연결되는 방식 확인",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "단계 1: 조직 권한 정의",
        step_2: "단계 2: 조직 역할 정의",
        step_3: "단계 3: 첫 번째 조직 생성하기",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $a43b3a55d381a7cc$export$2e2bcd8739ae039 = Object.freeze($a43b3a55d381a7cc$var$organizations);


const $7bb863b7df5e7074$var$permissions = {
    search_placeholder: "API 또는 권한 이름으로 검색",
    search_placeholder_without_api: "권한 이름으로 검색",
    name_column: "권한",
    description_column: "설명",
    api_column: "API",
    placeholder_title: "권한",
    placeholder_description: "권한은 리소스(API 리소스라고 함)에 액세스할 수 있는 권한을 의미해요."
};
var $7bb863b7df5e7074$export$2e2bcd8739ae039 = Object.freeze($7bb863b7df5e7074$var$permissions);


const $2360129708d153db$var$profile = {
    page_title: "계정 설정",
    title: "계정 설정",
    description: "계정 보안을 위해 여기에서 계정 설정을 변경하고 개인 정보를 관리하세요.",
    settings: {
        title: "프로필 설정",
        profile_information: "프로필 정보",
        avatar: "아바타",
        name: "이름",
        username: "사용자 이름"
    },
    link_account: {
        title: "계정 연동",
        email_sign_in: "이메일 로그인",
        email: "이메일",
        social_sign_in: "소셜 로그인",
        link_email: "이메일 연동",
        link_email_subtitle: "이메일을 연결하여 로그인하거나 계정을 복구할 때 도움을 받으세요.",
        email_required: "이메일 입력 필요",
        invalid_email: "잘못된 이메일 주소",
        identical_email_address: "입력한 이메일 주소가 현재 이메일 주소와 동일해요.",
        anonymous: "익명"
    },
    password: {
        title: "비밀번호 및 보안",
        password: "비밀번호",
        password_setting: "비밀번호 설정",
        new_password: "새 비밀번호",
        confirm_password: "비밀번호 확인",
        enter_password: "현재 비밀번호를 입력하세요",
        enter_password_subtitle: "계정 보안을 위해 본인 확인을 해주세요. 변경하기 전에 현재 비밀번호를 입력해주세요.",
        set_password: "비밀번호 설정",
        verify_via_password: "비밀번호로 인증",
        show_password: "비밀번호 보이기",
        required: "비밀번호 필요",
        do_not_match: "비밀번호가 일치하지 않아요. 다시 시도해 주세요."
    },
    code: {
        enter_verification_code: "인증 코드 입력",
        enter_verification_code_subtitle: "인증 코드가 <strong>{{target}}</strong>(으)로 발송되었어요.",
        verify_via_code: "인증 코드로 인증하기",
        resend: "인증 코드 재전송",
        resend_countdown: "{{countdown}}초 후 재전송"
    },
    delete_account: {
        title: "계정 삭제",
        label: "계정 삭제",
        description: "계정을 삭제하면 모든 개인 정보, 사용자 데이터 및 설정이 삭제돼요. 이 작업은 되돌릴 수 없어요.",
        button: "계정 삭제",
        dialog_paragraph_1: "계정을 삭제하시게 되어 유감입니다. 계정을 삭제하면 사용자 정보, 로그, 설정을 포함한 모든 데이터가 영구적으로 삭제되며, 이 작업은 되돌릴 수 없어요. 따라서 계속 진행하기 전에 중요한 데이터를 백업해 두세요.",
        dialog_paragraph_2: '계정 삭제 절차를 진행하려면 "Account Deletion Request"라는 제목으로 지원팀에 <a>메일</a>을 보내주세요. 당신의 모든 데이터가 시스템에서 올바르게 삭제될 수 있도록 도와드릴게요.',
        dialog_paragraph_3: "Logto Cloud를 선택해 주셔서 감사합니다. 추가 질문이나 우려 사항이 있으시면 언제든지 문의해 주세요."
    },
    set: "설정",
    change: "변경",
    link: "연결",
    unlink: "연결 해제",
    not_set: "설정 안 됨",
    change_avatar: "아바타 변경",
    change_name: "이름 변경",
    change_username: "사용자 이름 변경",
    set_name: "이름 설정",
    email_changed: "이메일이 변경되었어요.",
    password_changed: "비밀번호가 변경되었어요.",
    updated: "{{target}}이/가 수정되었어요.",
    linked: "{{target}}이/가 연결되었어요.",
    unlinked: "{{target}}이/가 연결 해제되었어요.",
    email_exists_reminder: "이메일 {{email}}은/는 이미 존재하는 계정에 연결되어 있어요. 다른 이메일을 연결하세요.",
    unlink_confirm_text: "연결 해제",
    unlink_reminder: "연결을 해제하면 사용자들이 <span></span> 계정으로 로그인하지 못할 거예요. 정말로 진행할까요?"
};
var $2360129708d153db$export$2e2bcd8739ae039 = Object.freeze($2360129708d153db$var$profile);


const $35d4f519ed8f73c5$var$role_details = {
    back_to_roles: "역할로 돌아가기",
    identifier: "식별자",
    delete_description: "이렇게 하면 영향을 받는 사용자에게서 이 역할과 관련된 권한이 제거되고 역할, 사용자 및 권한 간의 매핑이 삭제될 걈에요.",
    role_deleted: "{{name}}이 성공적으로 삭제되었어요.",
    settings_tab: "설정",
    users_tab: "사용자",
    m2m_apps_tab: "기계 대 기계 앱",
    permissions_tab: "권한",
    settings: "설정",
    settings_description: "역할은 사용자에게 할당된 권한들의 모음이에요. 역할은 다양한 API에 정의된 권한들을 통합하는 방법을 제공하기 때문에, 사용자에게 개별적으로 할당하는 것보다 효율적으로 권한을 추가, 제거, 조정할 수 있어요.",
    field_name: "이름",
    field_description: "설명",
    type_m2m_role_tag: "기계 대 기계 앱 역할",
    type_user_role_tag: "사용자 역할",
    permission: {
        assign_button: "권한 할당",
        assign_title: "권한 할당",
        assign_subtitle: "이 역할에 권한을 할당해요. 이 역할은 추가된 권한을 할당받고, 이 역할을 가진 이용자들은 이 권한들을 상속받을 거예요.",
        assign_form_field: "권한 할당",
        added_text_one: "권한 {{count, number}}개 추가됨",
        added_text_other: "권한 {{count, number}}개 추가됨",
        api_permission_count_one: "권한 {{count, number}}개",
        api_permission_count_other: "권한 {{count, number}}개",
        confirm_assign: "권한 할당",
        permission_assigned: "선택된 권한들이 이 역할에 성공적으로 할당되었어요.",
        deletion_description: "이 권한이 삭제되면, 이 역할에 영향을 받는 사용자가 이 권한에 의해 부여된 접근 권한을 잃게 돼요.",
        permission_deleted: '권한 "{{name}}"이 이 역할에서 성공적으로 삭제되었어요.',
        empty: "권한 없음"
    },
    users: {
        assign_button: "사용자 할당",
        name_column: "사용자",
        app_column: "앱",
        latest_sign_in_column: "최근 로그인 시각",
        delete_description: "사용자는 사용자 목록에 남지만 이 역할에 대한 접근 권한을 잃어버릴 거예요.",
        deleted: "{{name}}이 이 역할에서 성공적으로 삭제되었어요.",
        assign_title: "사용자 할당",
        assign_subtitle: "사용자를 이 역할에 할당해요. 이름, 이메일, 전화번호, 사용자 ID 등을 이용하여 적절한 사용자를 찾아 보세요.",
        assign_field: "사용자 할당",
        confirm_assign: "사용자 할당",
        assigned_toast_text: "선택된 사용자가 이 역할에 성공적으로 할당되었어요",
        empty: "사용자 없음"
    },
    applications: {
        assign_button: "앱 할당",
        name_column: "앱",
        app_column: "앱",
        description_column: "설명",
        delete_description: "이 앱은 앱 모음에 남아 있지만 이 역할에 대한 권한을 상실하게 됩니다.",
        deleted: "{{name}} 이(가) 이 역할에서 성공적으로 제거되었습니다.",
        assign_title: "앱 할당",
        assign_subtitle: "이 역할에 앱 할당 적절한 앱을 이름, 설명 또는 앱 ID로 검색하여 찾아보세요.",
        assign_field: "앱 할당",
        confirm_assign: "앱 할당",
        assigned_toast_text: "선택된 앱이 이 역할에 성공적으로 할당되었습니다",
        empty: "사용 가능한 앱 없음"
    }
};
var $35d4f519ed8f73c5$export$2e2bcd8739ae039 = Object.freeze($35d4f519ed8f73c5$var$role_details);


const $9646697db9649ca2$var$roles = {
    page_title: "역할",
    title: "역할",
    subtitle: "역할은 사용자가 무엇을 할 수 있는지를 결정하는 권한을 포함해요. RBAC는 사용자에게 특정 행동에 대한 접근 권한을 부여하기 위해 역할을 사용해요.",
    create: "역할 생성",
    role_name: "역할 이름",
    role_type: "역할 유형",
    show_role_type_button_text: "더 많은 옵션 표시",
    hide_role_type_button_text: "더 많은 옵션 숨기기",
    type_user: "사용자 역할",
    type_machine_to_machine: "기계 간 앱 역할",
    role_description: "설명",
    role_name_placeholder: "역할 이름을 입력하세요",
    role_description_placeholder: "역할 설명을 입력하세요",
    col_roles: "역할들",
    col_type: "유형",
    col_description: "설명",
    col_assigned_entities: "할당됨",
    user_counts: "{{count}} 명의 사용자",
    application_counts: "{{count}} 개의 앱",
    user_count: "{{count}} 명의 사용자",
    application_count: "{{count}} 개의 앱",
    assign_permissions: "권한 할당",
    create_role_title: "역할 생성",
    create_role_description: "당신의 애플리케이션을 위한 역할을 생성하고 관리해요. 역할은 권한들의 모음을 포함하며 사용자에게 할당될 수 있어요.",
    create_role_button: "역할 생성",
    role_created: "역할 {{name}}이 성공적으로 생성되었어요.",
    search: "역할 이름, 설명, ID로 검색",
    placeholder_title: "역할",
    placeholder_description: "역할은 사용자에게 할당할 수 있는 권한의 모임이에요. 역할을 만들기 전에 먼저 권한을 추가해야 해요."
};
var $9646697db9649ca2$export$2e2bcd8739ae039 = Object.freeze($9646697db9649ca2$var$roles);


const $7559ca7778735c43$var$session_expired = {
    title: "세션 만료",
    subtitle: "세션이 만료되었거나, 끊겼어요. 다시 로그인해 주세요.",
    button: "다시 로그인하기"
};
var $7559ca7778735c43$export$2e2bcd8739ae039 = Object.freeze($7559ca7778735c43$var$session_expired);


const $6f6238c845a12754$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $6f6238c845a12754$export$2e2bcd8739ae039 = Object.freeze($6f6238c845a12754$var$content);


const $578f905f5fba1d6c$var$password_policy = {
    password_requirements: "비밀번호 요구사항",
    minimum_length: "최소 길이",
    minimum_length_description: "NIST는 <a>최소 8자리</a>를 권장합니다.",
    minimum_length_error: "최소 길이는 {{min}} ~ {{max}}(포함) 사이여야 합니다.",
    minimum_required_char_types: "최소 필요 문자 유형",
    minimum_required_char_types_description: "문자 유형: 대문자(A-Z), 소문자(a-z), 숫자(0-9), 특수 기호({{symbols}}).",
    password_rejection: "비밀번호 거부",
    compromised_passwords: "위험한 비밀번호",
    breached_passwords: "유출된 비밀번호",
    breached_passwords_description: "이전에 유출된 비밀번호를 거부합니다.",
    restricted_phrases: "보안속에 좋지 않은 구구절",
    restricted_phrases_tooltip: "3글자 이상의 다른 글자와 함께 조합하지 않는 한 이러한 구문을 피하세요.",
    repetitive_or_sequential_characters: "반복된 혹은 순차적인 문자",
    repetitive_or_sequential_characters_description: '예: "AAAA", "1234", "abcd" 등.',
    user_information: "사용자 정보",
    user_information_description: "예: 이메일 주소, 전화 번호, 사용자 이름 등.",
    custom_words: "사용자 정의 단어",
    custom_words_description: "컨텍스트에 따라 맞춤형 단어입니다. 대소문자를 구분하지 않으며, 한 줄에 하나씩 작성하세요.",
    custom_words_placeholder: "서비스 이름, 회사 이름 등."
};
var $578f905f5fba1d6c$export$2e2bcd8739ae039 = Object.freeze($578f905f5fba1d6c$var$password_policy);


const $6576a275b4376a25$var$sign_up_and_sign_in = {
    identifiers_email: "이메일 주소",
    identifiers_phone: "휴대전화번호",
    identifiers_username: "사용자 이름",
    identifiers_email_or_sms: "이메일 주소 또는 휴대전화번호",
    identifiers_none: "해당 없음",
    and: "그리고",
    or: "또는",
    sign_up: {
        title: "회원가입",
        sign_up_identifier: "회원가입 ID",
        identifier_description: "회원가입 ID는 계정을 생성하기 위해 필수이며, 회원가입 화면에서 반드시 포함되어야 해요.",
        sign_up_authentication: "회원가입 인증 설정",
        authentication_description: "선택된 모든 작업들은 사용자가 모두 마무리해야 해요.",
        set_a_password_option: "비밀번호 생성",
        verify_at_sign_up_option: "회원가입 인증",
        social_only_creation_description: "(이것은 소셜 전용 계정 생성에 적용돼요.)"
    },
    sign_in: {
        title: "로그인",
        sign_in_identifier_and_auth: "로그인을 위한 ID 그리고 인증 설정",
        description: "사용자는 주어진 옵션 중에 아무 방법으로 로그인할 수 있어요. 주어진 옵션을 드래그하여 조절해 주세요.",
        add_sign_in_method: "로그인 방법 추가",
        password_auth: "비밀번호",
        verification_code_auth: "인증 코드",
        auth_swap_tip: "아래 옵션을 변경하여 흐름에 가장 먼저 나타나는 옵션을 설정할 수 있어요.",
        require_auth_factor: "반드시 최소 하나의 인증 방법을 선택해야 해요."
    },
    social_sign_in: {
        title: "소셜 로그인",
        social_sign_in: "소셜 로그인",
        description: "설정된 필수 ID에 따라서 사용자가 소셜 연동을 통해 회원가입, 로그인을 할 수 있어요.",
        add_social_connector: "소셜 연동으로",
        set_up_hint: {
            not_in_list: "리스트에 없나요?",
            set_up_more: "다른 소셜 연동",
            go_to: "을 설정해 보세요."
        }
    },
    tip: {
        set_a_password: "사용자 이름에 대한 고유한 암호 집합은 필수예요.",
        verify_at_sign_up: "현재 확인된 이메일만 지원해요. 유효성 검사가 없는 경우 사용자 기반에 품질이 낮은 전자 메일 주소가 많이 포함되어 있을 수 있어요.",
        password_auth: "회원가입 중에 비밀번호를 설정하는 옵션을 사용으로 설정했기 때문에 이 옵션은 필수예요.",
        verification_code_auth: "가입 시 인증 코드를 제공하는 옵션만 활성화했기 때문에 이것은 필수예요. 회원가입에서 비밀번호 설정이 허용되면 이 옵션을 취소할 수 있어요.",
        delete_sign_in_method: "{{identifier}}를 필수 ID로 설정했기 때문에 이 옵션은 필수예요."
    },
    advanced_options: {
        title: "고급 옵션",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "사용자 등록 활성화",
        enable_user_registration_description: "사용자 등록을 활성화하거나 비활성화합니다. 비활성화된 경우 사용자는 관리 콘솔에서는 추가할 수 있지만 사용자는 더 이상 로그인 UI를 통해 계정을 설정할 수 없습니다."
    }
};
var $6576a275b4376a25$export$2e2bcd8739ae039 = Object.freeze($6576a275b4376a25$var$sign_up_and_sign_in);


const $b23dcb32713afdb9$var$sign_in_exp = {
    page_title: "로그인 경험",
    title: "로그인 경험",
    description: "로그인 화면을 브랜드에 맞게 사용자화하고 실시간으로 확인해 보세요.",
    tabs: {
        branding: "브랜딩",
        sign_up_and_sign_in: "회원가입/로그인",
        content: "내용",
        password_policy: "암호 정책"
    },
    welcome: {
        title: "로그인 경험 사용자화",
        description: "첫 로그인 설정으로 빠르게 시작하세요. 이 가이드가 필요한 모든 설정에 대해 안내할 거예요.",
        get_started: "시작하기",
        apply_remind: "이 계정이 관리하는 모든 앱의 로그인 경험이 수정되는 것을 주의해 주세요."
    },
    color: {
        title: "색상",
        primary_color: "브랜드 색상",
        dark_primary_color: "브랜드 색상 (다크 모드)",
        dark_mode: "다크 모드 활성화",
        dark_mode_description: "Logto가 브랜드 색상에 알맞게 자동으로 다크 모드 테마를 생성해요.",
        dark_mode_reset_tip: "브랜드 색상에 알맞게 다크 모드 색상",
        reset: "재생성"
    },
    branding: {
        title: "브랜딩 영역",
        ui_style: "스타일",
        favicon: "파비콘",
        logo_image_url: "앱 로고 이미지 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "앱 로고 이미지 URL (다크 모드)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "앱 로고",
        dark_logo_image: "앱 로고 (다크 모드)",
        logo_image_error: "앱 로고: {{error}}",
        favicon_error: "파비콘: {{error}}"
    },
    custom_css: {
        title: "사용자 정의 CSS",
        css_code_editor_title: "사용자 정의 CSS로 UI 개인화",
        css_code_editor_description1: "사용자 정의 CSS의 예시를 확인하세요.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "더 알아보기",
        css_code_editor_content_placeholder: "사용자 정의 CSS를 입력하여 원하는 대로 스타일을 조정할 수 있어요. 창의성을 표현하고 UI를 돋보이게 만드세요."
    },
    sign_up_and_sign_in: $6576a275b4376a25$export$2e2bcd8739ae039,
    content: $6f6238c845a12754$export$2e2bcd8739ae039,
    password_policy: $578f905f5fba1d6c$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'SMS 연동 설정이 아직 없어요. 이 구성을 완료하기 전에는 사용자가 이 로그인 방식으로 로그인 할 수 없어요. "연동 설정"에서 <a>{{link}}</a>하세요.',
        no_connector_email: '이메일 연동 설정이 아직 없어요. 이 구성을 완료하기 전에는 사용자가 이 로그인 방식으로 로그인 할 수 없어요. "연동 설정"에서 <a>{{link}}</a>하세요.',
        no_connector_social: '아직 소셜 커넥터를 설정하지 않았습니다. 소셜 로그인 방법을 적용하려면 먼저 커넥터를 추가하십시오. "커넥터"에서 <a>{{link}}</a>을(를) 확인하십시오.',
        setup_link: "설정"
    },
    save_alert: {
        description: "새 로그인 및 회원가입 방법을 추가하고 있어요. 모든 사용자가 새 설정의 영향을 받을 수 있어요. 정말로 추가할까요?",
        before: "이전",
        after: "이후",
        sign_up: "회원가입",
        sign_in: "로그인",
        social: "소셜"
    },
    preview: {
        title: "로그인 화면 미리보기",
        live_preview: "실시간 미리보기",
        live_preview_tip: "저장하여 변경 사항 미리보기",
        native: "네이티브",
        desktop_web: "데스크톱 웹",
        mobile_web: "모바일 웹",
        desktop: "데스크톱",
        mobile: "모바일"
    }
};
var $b23dcb32713afdb9$export$2e2bcd8739ae039 = Object.freeze($b23dcb32713afdb9$var$sign_in_exp);


const $7a068ee008e7d15d$var$quota_item = {
    tenant_limit: {
        name: "성주",
        limited: "{{count, number}} 성주",
        limited_other: "{{count, number}} 성주",
        unlimited: "제한 없는 성주",
        not_eligible: "성주를 제거하십시오"
    },
    mau_limit: {
        name: "월간 활성 사용자",
        limited: "{{count, number}} 월간 활성 사용자",
        unlimited: "제한 없는 월간 활성 사용자",
        not_eligible: "모든 사용자를 제거하십시오"
    },
    applications_limit: {
        name: "애플리케이션",
        limited: "{{count, number}} 애플리케이션",
        limited_other: "{{count, number}} 애플리케이션",
        unlimited: "제한 없는 애플리케이션",
        not_eligible: "애플리케이션을 제거하십시오"
    },
    machine_to_machine_limit: {
        name: "기계 간 통신",
        limited: "{{count, number}} 기계 간 앱",
        limited_other: "{{count, number}} 기계 간 앱",
        unlimited: "제한 없는 기계 간 앱",
        not_eligible: "기계 간 앱을 제거하십시오"
    },
    resources_limit: {
        name: "API 리소스",
        limited: "{{count, number}} API 리소스",
        limited_other: "{{count, number}} API 리소스",
        unlimited: "제한 없는 API 리소스",
        not_eligible: "API 리소스를 제거하십시오"
    },
    scopes_per_resource_limit: {
        name: "리소스 권한",
        limited: "{{count, number}} 리소스당 권한",
        limited_other: "{{count, number}} 리소스당 권한",
        unlimited: "제한 없는 리소스당 권한",
        not_eligible: "리소스 권한을 제거하십시오"
    },
    custom_domain_enabled: {
        name: "사용자 정의 도메인",
        limited: "사용자 정의 도메인",
        unlimited: "사용자 정의 도메인",
        not_eligible: "사용자 정의 도메인을 제거하십시오"
    },
    omni_sign_in_enabled: {
        name: "Omin 사인인",
        limited: "Omin 사인인",
        unlimited: "Omin 사인인",
        not_eligible: "Omin 사인인을 비활성화하세요"
    },
    built_in_email_connector_enabled: {
        name: "내장된 이메일 커넥터",
        limited: "내장된 이메일 커넥터",
        unlimited: "내장된 이메일 커넥터",
        not_eligible: "내장된 이메일 커넥터를 제거하십시오"
    },
    social_connectors_limit: {
        name: "소셜 커넥터",
        limited: "{{count, number}} 소셜 커넥터",
        limited_other: "{{count, number}} 소셜 커넥터",
        unlimited: "제한 없는 소셜 커넥터",
        not_eligible: "소셜 커넥터를 제거하십시오"
    },
    standard_connectors_limit: {
        name: "무료 표준 커넥터",
        limited: "{{count, number}} 무료 표준 커넥터",
        limited_other: "{{count, number}} 무료 표준 커넥터",
        unlimited: "제한 없는 표준 커넥터",
        not_eligible: "표준 커넥터를 제거하십시오"
    },
    roles_limit: {
        name: "역할",
        limited: "{{count, number}} 역할",
        limited_other: "{{count, number}} 역할",
        unlimited: "제한 없는 역할",
        not_eligible: "역할을 제거하십시오"
    },
    scopes_per_role_limit: {
        name: "역할 권한",
        limited: "{{count, number}} 역할당 권한",
        limited_other: "{{count, number}} 역할당 권한",
        unlimited: "제한 없는 역할당 권한",
        not_eligible: "역할 권한을 제거하십시오"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}}개의 Webhook",
        limited_other: "{{count, number}}개의 Webhooks",
        unlimited: "무제한 Webhooks",
        not_eligible: "웹훅을 삭제하세요"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "감사 로그 보존 기간",
        limited: "감사 로그 보존 기간: {{count, number}} 일",
        limited_other: "감사 로그 보존 기간: {{count, number}} 일",
        unlimited: "제한 없는 기간",
        not_eligible: "감사 로그 없음"
    },
    community_support_enabled: {
        name: "커뮤니티 지원",
        limited: "커뮤니티 지원",
        unlimited: "커뮤니티 지원",
        not_eligible: "커뮤니티 지원 없음"
    },
    customer_ticket_support: {
        name: "고객 지원 티켓",
        limited: "{{count, number}} 시간 고객 지원 티켓",
        limited_other: "{{count, number}} 시간 고객 지원 티켓",
        unlimited: "고객 지원 티켓",
        not_eligible: "고객 지원 티켓 없음"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "MFA 비활성화"
    },
    sso_enabled: {
        name: "기업 SSO",
        limited: "기업 SSO",
        unlimited: "기업 SSO",
        not_eligible: "기업 SSO 비활성화"
    }
};
var $7a068ee008e7d15d$export$2e2bcd8739ae039 = Object.freeze($7a068ee008e7d15d$var$quota_item);


const $86f24af977705808$var$quota_table = {
    quota: {
        title: "할당량",
        tenant_limit: "테넌트 제한",
        base_price: "기본 가격",
        mau_unit_price: "* MAU 단가",
        mau_limit: "MAU 제한"
    },
    application: {
        title: "애플리케이션",
        total: "총 애플리케이션 수",
        m2m: "머신 투 머신"
    },
    resource: {
        title: "API 리소스",
        resource_count: "리소스 수",
        scopes_per_resource: "리소스 당 권한"
    },
    branding: {
        title: "UI 및 브랜딩",
        custom_domain: "사용자 정의 도메인",
        custom_css: "사용자 정의 CSS",
        app_logo_and_favicon: "앱 로고와 파비콘",
        dark_mode: "다크 모드",
        i18n: "국제화"
    },
    user_authn: {
        title: "사용자 인증",
        omni_sign_in: "옴니 사인인",
        password: "비밀번호",
        passwordless: "비밀번호 없음 - 이메일과 SMS",
        email_connector: "이메일 커넥터",
        sms_connector: "SMS 커넥터",
        social_connectors: "소셜 커넥터",
        standard_connectors: "표준 커넥터",
        built_in_email_connector: "내장 이메일 커넥터",
        mfa: "MFA",
        sso: "기업 SSO"
    },
    user_management: {
        title: "사용자 관리",
        user_management: "사용자 관리",
        roles: "역할",
        scopes_per_role: "역할 당 권한"
    },
    audit_logs: {
        title: "감사 로그",
        retention: "보존 기간"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "조직",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "지원",
        community: "커뮤니티",
        customer_ticket: "지원 티켓",
        premium: "프리미엄"
    },
    mau_unit_price_footnote: "* 월간 활성 사용자(MAU)는 청구 주기 동안 로그인 빈도에 따라 3단계로 나뉩니다. 각 단계마다 달리 책정되는 MAU 단가가 있습니다.",
    unlimited: "무제한",
    contact: "문의",
    monthly_price: "${{value, number}}/월",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} 일",
    days_other: "{{count, number}} 일",
    add_on: "부가 기능",
    tier: "레벨{{value, number}}: "
};
var $86f24af977705808$export$2e2bcd8739ae039 = Object.freeze($86f24af977705808$var$quota_table);


const $5f77d686687fd65d$var$subscription = {
    free_plan: "무료 요금제",
    free_plan_description: "사이드 프로젝트 및 초기 Logto 시험용. 신용 카드 없음.",
    hobby_plan: "취미 요금제",
    hobby_plan_description: "개인 개발자 또는 소규모 엔지니어링 팀을 위한 플랜입니다.",
    pro_plan: "프로 요금제",
    pro_plan_description: "Logto와 함께 걱정 없이 비즈니스 혜택을 받으세요.",
    enterprise: "기업용",
    current_plan: "현재 요금제",
    current_plan_description: "현재 사용중인 요금제 정보입니다. 요금제 사용 내역을 쉽게 확인하고, 다가오는 청구서를 확인하며 필요에 따라 요금제를 변경할 수 있습니다.",
    plan_usage: "요금제 사용량",
    plan_cycle: "Plan cycle: {{period}}. 사용량은 {{renewDate}}에 갱신됩니다.",
    next_bill: "다음 청구서",
    next_bill_hint: "계산에 대해 자세히 알아보려면 이 <a>게시물</a>을 참조하세요.",
    next_bill_tip: "다음 청구서에는 다음 달을 위한 요금제 기본 가격 및 다양한 티어의 MAU 단가에 따른 사용량 비용이 포함됩니다.",
    manage_payment: "결제 관리",
    overfill_quota_warning: "할당량 한도에 도달했습니다. 문제를 방지하기 위해 요금제를 업그레이드하세요.",
    upgrade_pro: "프로 업그레이드",
    update_payment: "결제 정보 업데이트",
    payment_error: "결제 문제가 발생했습니다. 이전 주기에 ${{price, number}}을(를) 처리할 수 없습니다. Logto 서비스 중단을 피하기 위해 결제를 업데이트하세요.",
    downgrade: "다운그레이드",
    current: "현재",
    upgrade: "업그레이드",
    quota_table: $86f24af977705808$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "송장",
        status_column: "상태",
        amount_column: "금액",
        invoice_created_date_column: "송장 생성 날짜",
        invoice_status: {
            void: "취소됨",
            paid: "지불 완료",
            open: "미결제",
            uncollectible: "연체"
        }
    },
    quota_item: $7a068ee008e7d15d$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "다운그레이드하시겠습니까?",
        description: "<targetName />으로 전환하는 경우 이전에 <currentName />에 있던 할당량과 기능에 더 이상 액세스할 수 없음을 알려드립니다.",
        before: "이전: <name />",
        after: "이후: <name />",
        downgrade: "다운그레이드"
    },
    not_eligible_modal: {
        downgrade_title: "다운그레이드할 수 없습니다",
        downgrade_description: "<name/>로 다운그레이드하기 전에 다음 기준을 충족하는지 확인하세요.",
        downgrade_help_tip: "다운그레이드 도움이 필요하세요? <a>문의하세요</a>.",
        upgrade_title: "우리의 존경받는 초기 사용자를 위한 친절한 리마인더",
        upgrade_description: "현재 <name />이 허용하는 양보다 더 많이 사용하고 있습니다. 로그토는 이제 공식적으로 출시되었으며 각 플랜에 맞게 설계된 기능을 제공합니다. <name />로 업그레이드를 고려하기 전에, 업그레이드하기 전에 다음 기준을 충족하는지 확인하세요.",
        upgrade_pro_tip: " 또는 프로 플랜으로 업그레이드를 고려하세요.",
        upgrade_help_tip: "업그레이드 도움이 필요하세요? <a>문의하세요</a>.",
        a_maximum_of: "<item/> 최대 한도"
    },
    upgrade_success: "성공적으로 <name/>으로 업그레이드되었습니다.",
    downgrade_success: "성공적으로 <name/>으로 다운그레이드되었습니다.",
    subscription_check_timeout: "구독 확인이 타임아웃되었습니다. 나중에 다시 확인해주세요.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $5f77d686687fd65d$export$2e2bcd8739ae039 = Object.freeze($5f77d686687fd65d$var$subscription);


const $e46577576ff49fd6$var$tab_sections = {
    overview: "살펴보기",
    resources: "자원",
    users: "사용자",
    access_control: "접근 제어",
    help_and_support: "고객센터",
    tenant: "세입자",
    automation: "자동화"
};
var $e46577576ff49fd6$export$2e2bcd8739ae039 = Object.freeze($e46577576ff49fd6$var$tab_sections);


const $57e8c1c64d668828$var$tabs = {
    get_started: "시작하기",
    dashboard: "대시보드",
    applications: "어플리케이션",
    api_resources: "API 리소스",
    sign_in_experience: "로그인 경험",
    connectors: "연동",
    enterprise_sso: "기업 SSO",
    webhooks: "웹훅",
    organizations: "조직",
    users: "사용자 관리",
    audit_logs: "감사 기록",
    roles: "역할",
    docs: "문서",
    tenant_settings: "테넌트 설정",
    mfa: "다중 요소 인증"
};
var $57e8c1c64d668828$export$2e2bcd8739ae039 = Object.freeze($57e8c1c64d668828$var$tabs);


const $a4d4fcb3d277cb30$var$tenants = {
    title: "설정",
    description: "테넌트 설정을 효율적으로 관리하고 도메인을 사용자 정의합니다.",
    tabs: {
        settings: "설정",
        domains: "도메인",
        subscription: "구독 및 청구",
        billing_history: "청구 내역"
    },
    settings: {
        title: "설정",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "테넌트 ID",
        tenant_name: "테넌트 이름",
        tenant_region: "데이터 호스팅 영역",
        tenant_region_tip: "당신의 테넌트 자원은 {{region}}에 호스팅됩니다. <a>자세히 알아보기</a>",
        environment_tag_development: "개발",
        environment_tag_staging: "스테이징",
        environment_tag_production: "프로드",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "테넌트 정보가 성공적으로 저장되었습니다."
    },
    full_env_tag: {
        development: "개발",
        production: "프로드"
    },
    deletion_card: {
        title: "삭제",
        tenant_deletion: "테넌트 삭제",
        tenant_deletion_description: "테넌트를 삭제하면 관련된 모든 사용자 데이터와 설정이 영구적으로 삭제됩니다. 신중하게 진행해주십시오.",
        tenant_deletion_button: "테넌트 삭제"
    },
    create_modal: {
        title: "테넌트 만들기",
        subtitle: "분리된 리소스와 사용자를 가진 새 테넌트를 만듭니다. 데이터가 호스팅되는 지역 및 테넌트 유형은 생성 후에 수정할 수 없습니다.",
        tenant_usage_purpose: "이 테넌트를 사용하는 목적은 무엇입니까?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "사용 가능한 요금제:",
        create_button: "테넌트 만들기",
        tenant_name_placeholder: "내 테넌트"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "테넌트 삭제",
        description_line1: '환경 접미사 "<span>{{tag}}</span>"이(가) 붙은 "<span>{{name}}</span>" 테넌트를 삭제하시겠습니까? 이 작업은 실행 취소할 수 없으며, 모든 데이터 및 계정 정보가 영구적으로 삭제됩니다.',
        description_line2: "계정을 삭제하기 전에 도움이 필요할 수 있습니다. <span><a>이메일로 연락</a></span>해주시면 도움을 드리겠습니다.",
        description_line3: '삭제하려는 테넌트 이름 "<span>{{name}}</span>"을(를) 입력하여 확인하십시오.',
        delete_button: "영구 삭제",
        cannot_delete_title: "이 테넌트를 삭제할 수 없습니다",
        cannot_delete_description: "죄송합니다. 현재이 테넌트를 삭제할 수 없습니다. 무료 플랜에 있고 미결제 청구서가 없는지 확인하십시오."
    },
    tenant_landing_page: {
        title: "아직 테넌트를 만들지 않았습니다.",
        description: "Logto 를 사용하여 프로젝트를 구성하려면 새 테넌트를 만드세요. 로그아웃하거나 계정을 삭제하려면 오른쪽 상단 모서리에있는 아바타 버튼을 클릭하세요.",
        create_tenant_button: "테넌트 만들기"
    },
    status: {
        mau_exceeded: "MAU 초과",
        suspended: "정지됨",
        overdue: "만료됨"
    },
    tenant_suspended_page: {
        title: "테넌트 정지. 접근을 복구하려면 문의하세요.",
        description_1: "매우 유감스럽게도 테넌트 계정이 일시적으로 정지되었으며, MAU 한도 초과, 연체된 결제 또는 다른 무단 조치 등 부적절한 사용으로 인한 것입니다.",
        description_2: "자세한 설명이 필요한 경우, 우려 사항이 있거나 기능을 완전히 복원하고 테넌트를 차단 해제하려면 바로 연락 주시기 바랍니다."
    },
    signing_keys: {
        title: "서명 키",
        description: "테넌트 내의 서명 키를 안전하게 관리합니다.",
        type: {
            private_key: "OIDC 개인 키",
            cookie_key: "OIDC 쿠키 키"
        },
        private_keys_in_use: "사용 중인 개인 키",
        cookie_keys_in_use: "사용 중인 쿠키 키",
        rotate_private_keys: "개인 키 회전",
        rotate_cookie_keys: "쿠키 키 회전",
        rotate_private_keys_description: "이 작업은 새로운 개인 서명 키를 생성하고 현재 키를 회전시키고 이전 키를 삭제합니다. 현재 키로 서명 된 JWT 토큰은 삭제하거나 다른 회전할 때까지 유효합니다.",
        rotate_cookie_keys_description: "이 작업은 새 쿠키 키를 생성하고 현재 키를 회전하며 이전 키를 삭제합니다. 현재 키로 서명 된 쿠키는 삭제하거나 다른 회전할 때까지 유효합니다.",
        select_private_key_algorithm: "새 개인 키의 서명 키 알고리즘 선택",
        rotate_button: "회전",
        table_column: {
            id: "ID",
            status: "상태",
            algorithm: "서명 키 알고리즘"
        },
        status: {
            current: "현재",
            previous: "이전"
        },
        reminder: {
            rotate_private_key: "정말 <strong>OIDC 개인 키</strong>를 회전하시겠습니까? 새로 발급 된 JWT 토큰은 새 키로 서명됩니다. 기존 JWT 토큰은 회전할 때까지 유효합니다.",
            rotate_cookie_key: "정말 <strong>OIDC 쿠키 키</strong>를 회전하시겠습니까? 로그인 세션에서 생성 된 새로운 쿠키는 새 쿠키 키로 서명됩니다. 기존 쿠키는 회전할 때까지 유효합니다.",
            delete_private_key: "정말 <strong>OIDC 개인 키</strong>를 삭제하시겠습니까? 이전에 개인 서명 키로 서명 된 기존 JWT 토큰은 더 이상 유효하지 않게 됩니다.",
            delete_cookie_key: "정말 <strong>OIDC 쿠키 키</strong>를 삭제하시겠습니까? 이전에 이 쿠키 키로 서명 된 로그인 세션은 더 이상 유효하지 않게 될 것입니다. 이 사용자들에게는 다시 인증이 필요합니다."
        },
        messages: {
            rotate_key_success: "서명 키가 성공적으로 회전되었습니다.",
            delete_key_success: "키가 성공적으로 삭제되었습니다."
        }
    }
};
var $a4d4fcb3d277cb30$export$2e2bcd8739ae039 = Object.freeze($a4d4fcb3d277cb30$var$tenants);


const $26f2f19230b02837$var$topbar = {
    docs: "문서",
    help: "도움말"
};
var $26f2f19230b02837$export$2e2bcd8739ae039 = Object.freeze($26f2f19230b02837$var$topbar);


const $867ac7489e162614$var$paywall = {
    applications: "<planName/>의 {{count, number}}개 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    applications_other: "<planName/>의 {{count, number}}개 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    machine_to_machine_feature: "<strong>Hobby</strong> 플랜으로 업그레이드하여 1대의 기계 간 애플리케이션을 잠금 해제하거나 무제한 사용을 위해 <strong>Pro</strong> 플랜을 선택하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    machine_to_machine: "<planName/>의 {{count, number}}개 기계 간 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    machine_to_machine_other: "<planName/>의 {{count, number}}개 기계 간 애플리케이션 제한에 도달했습니다. 팀의 요구를 충족하기 위해 플랜을 업그레이드하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    resources: "<planName/>의 {{count, number}}개 API 리소스 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    resources_other: "<planName/>의 {{count, number}}개 API 리소스 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_resource: "<planName/>의 {{count, number}}개 API 리소스 당 권한 한도에 도달했습니다. 확장을 위해 지금 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_resource_other: "<planName/>의 {{count, number}}개 API 리소스 당 권한 한도에 도달했습니다. 확장을 위해 지금 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    custom_domain: "사용자 정의 도메인 기능을 잠금 해제하려면 <strong>Hobby</strong> 또는 <strong>Pro</strong> 플랜으로 업그레이드하세요. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    social_connectors: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    social_connectors_other: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_feature: "<strong>Hobby</strong> 또는 <strong>Pro</strong> 플랜으로 업그레이드하여 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성하고 모든 프리미엄 기능과 무제한 소셜 커넥터를 사용하십시오. 도움이 필요하면 <a>문의</a>해 주시기 바랍니다.",
    standard_connectors: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_other: "<planName/>의 {{count, number}}개 소셜 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 플랜을 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_pro: "<planName/>의 {{count, number}}개 표준 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 엔터프라이즈 플랜으로 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    standard_connectors_pro_other: "<planName/>의 {{count, number}}개 표준 커넥터 한도에 도달했습니다. 팀의 요구를 충족시키기 위해 엔터프라이즈 플랜으로 업그레이드하고 OIDC, OAuth 2.0, SAML 프로토콜을 사용하여 고유한 커넥터를 생성할 수 있도록 하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    roles: "<planName/>의 {{count, number}}개 역할 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    roles_other: "<planName/>의 {{count, number}}개 역할 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_role: "<planName/>의 {{count, number}}개 역할 당 권한 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    scopes_per_role_other: "<planName/>의 {{count, number}}개 역할 당 권한 한도에 도달했습니다. 플랜을 업그레이드하여 추가 역할과 권한을 추가하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    hooks: "<planName/>의 {{count, number}}개 웹훅 한도에 도달했습니다. 더 많은 웹훅을 생성하려면 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    hooks_other: "<planName/>의 {{count, number}}개 웹훅 한도에 도달했습니다. 더 많은 웹훅을 생성하려면 플랜을 업그레이드하세요. 도움이 필요하면 <a>문의하기</a>로 연락 주세요.",
    mfa: "보안을 확인하기 위해 MFA를 잠금 해제하여 유료 플랜으로 업그레이드하세요. 궁금한 점이 있으면 <a>문의하세요</a>.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $867ac7489e162614$export$2e2bcd8739ae039 = Object.freeze($867ac7489e162614$var$paywall);


const $4335cc321f4fde60$var$upsell = {
    upgrade_plan: "플랜 업그레이드",
    compare_plans: "플랜 비교",
    view_plans: "플랜 보기",
    create_tenant: {
        title: "테넌트 플랜 선택하기",
        description: "Logto는 성장 중인 기업을 위해 혁신적이고 저렴한 가격으로 디자인된 경쟁력 있는 플랜 옵션을 제공합니다. <a>더 알아보기</a>",
        base_price: "기본 가격",
        monthly_price: "{{value, number}}/월",
        mau_unit_price: "MAU 단가",
        view_all_features: "모든 기능 보기",
        select_plan: "<name/> 선택",
        free_tenants_limit: "최대 {{count, number}}개 무료 테넌트",
        free_tenants_limit_other: "최대 {{count, number}}개 무료 테넌트",
        most_popular: "가장 인기 있는 플랜",
        upgrade_success: "<name/>으로 업그레이드 성공!"
    },
    mau_exceeded_modal: {
        title: "MAU 한도를 초과했습니다. 플랜을 업그레이드하세요.",
        notification: "현재 MAU가 <planName/>의 한도를 초과했습니다. 로그토 서비스 중단을 피하기 위해 프리미엄으로 플랜을 업그레이드하세요.",
        update_plan: "플랜 업데이트"
    },
    payment_overdue_modal: {
        title: "청구서 지불 연체",
        notification: "이런! 테넌트 <span>{{name}}</span>의 청구서 결제에 실패했습니다. Logto 서비스 중단을 피하기 위해 즉시 청구서를 지불하십시오.",
        unpaid_bills: "미납 청구서",
        update_payment: "지불 업데이트"
    },
    paywall: $867ac7489e162614$export$2e2bcd8739ae039
};
var $4335cc321f4fde60$export$2e2bcd8739ae039 = Object.freeze($4335cc321f4fde60$var$upsell);


const $1c488ba953cf7179$var$user_details = {
    page_title: "사용자 세부 정보",
    back_to_users: "사용자 관리로 돌아가기",
    created_title: "새로운 사용자가 생성되었어요.",
    created_guide: "사용자가 로그인하는데 도움이 되는 정보를 확인해보세요.",
    created_email: "이메일 주소:",
    created_phone: "휴대전화 번호:",
    created_username: "사용자 이름:",
    created_password: "비밀번호:",
    menu_delete: "삭제",
    delete_description: "이 사용자를 영원히 삭제할까요? 이 행동은 취소될 수 없어요.",
    deleted: "해당 사용자가 성공적으로 삭제되었어요.",
    reset_password: {
        reset_password: "비밀번호 초기화",
        title: "정말로 비밀번호를 초기화 할까요?",
        content: "정말로 비밀번호를 초기화 할까요? 이 행동은 취소될 수 없어요.",
        congratulations: "해당 사용자의 비밀번호가 성공적으로 초기화 되었어요.",
        new_password: "새로운 비밀번호:"
    },
    tab_settings: "설정",
    tab_roles: "역할",
    tab_logs: "사용자 기록",
    tab_organizations: "조직",
    authentication: "인증",
    authentication_description: "각 사용자는 모든 사용자 정보를 포함하는 프로파일을 가지고 있어요. 프로파일은 기본 데이터, 소셜 ID, 사용자 정의 데이터로 구성되어 있어요.",
    user_profile: "사용자 프로필",
    field_email: "이메일 주소",
    field_phone: "휴대전화 번호",
    field_username: "사용자 이름",
    field_name: "이름",
    field_avatar: "아바타 이미지 URL",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "사용자 정의 데이터",
    field_custom_data_tip: "사용자 정의 색상 및 언어와 같은 미리 정의되지 않은 추가적인 사용자의 정보를 의미해요.",
    field_connectors: "연동된 소셜",
    field_sso_connectors: "기업 연결",
    custom_data_invalid: "사용자 정의 데이터는 반드시 유효한 JSON 객체여야 해요.",
    connectors: {
        connectors: "연동",
        user_id: "사용자 ID",
        remove: "삭제",
        connected: "이 사용자는 여러 소셜 연동에 연결되어 있어요.",
        not_connected: "이 사용자는 아직 소셜에 연동되지 않았아요.",
        deletion_confirmation: "기존 <name/> 신원을 제거하고 있습니다. 계속 진행하시겠습니까?"
    },
    sso_connectors: {
        connectors: "연결",
        enterprise_id: "기업 ID",
        connected: "이 사용자는 단일 로그인을 위한 여러 기업 신원 제공자에 연결되어 있어요.",
        not_connected: "이 사용자는 단일 로그인을 위한 어떤 기업 신원 제공자에도 연결되어 있지 않아요."
    },
    mfa: {
        field_name: "다단계 인증",
        field_description: "이 사용자는 2단계 인증 요소를 활성화했습니다.",
        name_column: "다단계 인증",
        field_description_empty: "이 사용자는 2단계 인증 요소를 활성화하지 않았습니다.",
        deletion_confirmation: "기존의 2단계 인증에서 <name/>을(를) 제거하고 있습니다. 계속 진행하시겠습니까?"
    },
    suspended: "정지됨",
    suspend_user: "사용자 정지",
    suspend_user_reminder: "이 사용자를 정지하시겠습니까? 사용자는 앱에 로그인할 수 없으며 현재 액세스 토큰이 만료된 후 새 액세스 토큰을 얻을 수 없게 됩니다. 또한 이 사용자가 수행한 모든 API 요청이 실패합니다.",
    suspend_action: "정지",
    user_suspended: "사용자가 정지되었습니다.",
    reactivate_user: "사용자 재활성화",
    reactivate_user_reminder: "이 사용자를 다시 활성화하시겠습니까? 이렇게 하면이 사용자에 대한 로그인 시도가 허용됩니다.",
    reactivate_action: "재활성화",
    user_reactivated: "사용자가 재활성화되었습니다.",
    roles: {
        name_column: "역할",
        description_column: "설명",
        assign_button: "역할 할당",
        delete_description: "이 행동은 사용자에게서 이 역할을 삭제할 거예요. 역할은 그대로 존재하지만, 이 사용자에게 더 이상 할당되지 않아요.",
        deleted: "{{name}}이/가 성공적으로 이 사용자에게서 제거되었어요.",
        assign_title: "{{name}}에게 역할 할당",
        assign_subtitle: "{{name}}에게 하나 이상의 역할을 할당하세요",
        assign_role_field: "역할 할당",
        role_search_placeholder: "역할 이름으로 검색",
        added_text: "{{value, number}}이/가 추가되었어요",
        assigned_user_count: "사용자 {{value, number}}명",
        confirm_assign: "역할 할당",
        role_assigned: "역할을 성공적으로 할당했어요",
        search: "역할 이름, 설명, ID로 검색",
        empty: "역할 없음"
    },
    warning_no_sign_in_identifier: "사용자는 로그인 식별자(사용자 이름, 이메일, 전화 번호 또는 소셜) 중 적어도 하나를 갖고 로그인해야 합니다. 계속 하시겠습니까?",
    organization_roles_tooltip: "조직 내에서 사용자에게 할당된 역할."
};
var $1c488ba953cf7179$export$2e2bcd8739ae039 = Object.freeze($1c488ba953cf7179$var$user_details);


const $7b0c436f2b378f16$var$users = {
    page_title: "사용자 관리",
    title: "사용자 관리",
    subtitle: "사용자의 신원을 추가, 삭제, 수정, 조회하여 관리해보세요.",
    create: "사용자 추가",
    create_subtitle: "다음 중 적어도 하나의 필드를 제공해주세요.",
    error_missing_identifier: "사용자를 생성하려면 적어도 하나의 식별자를 제공해야 합니다.",
    user_name: "사용자",
    application_name: "어플리케이션으로부터",
    latest_sign_in: "최근 로그인 시각",
    create_form_username: "사용자 이름",
    create_form_password: "비밀번호",
    create_form_name: "이름",
    placeholder_name: "홍길동",
    placeholder_email: "honggildong@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+82 2-1234-5678",
    unnamed: "이름없음",
    search: "이름, 이메일, 전화번호, ID로 검색",
    check_user_detail: "사용자 상세정보 확인",
    placeholder_title: "사용자 관리",
    placeholder_description: "각 사용자에게는 모든 사용자 정보가 포함된 프로필이 있어요. 프로필은 기본 데이터, 소셜 인증, 사용자 지정 데이터로 구성돼요."
};
var $7b0c436f2b378f16$export$2e2bcd8739ae039 = Object.freeze($7b0c436f2b378f16$var$users);


const $cc94c3efd1fc8b83$var$webhook_details = {
    page_title: "Webhook 담당자",
    back_to_webhooks: "Webhooks로 돌아가기",
    not_in_use: "사용 중이 아님",
    success_rate: "성공율",
    requests: "24시간 동안 {{value, number}}개의 요청",
    disable_webhook: "Webhook 비활성화",
    disable_reminder: "이 webhook을 재활성화 하시겠습니까? 그렇게 한다면 엔드포인트 URL에 HTTP request를 보내지 않습니다.",
    webhook_disabled: "Webhook이 비활성화 되었습니다.",
    webhook_reactivated: "Webhook이 다시 활성화되었습니다.",
    reactivate_webhook: "Webhook 재활성화",
    delete_webhook: "Webhook 삭제",
    deletion_reminder: "이 webhook을 삭제하고 있습니다. 삭제 후, 엔드포인트 URL에 HTTP request를 보내지 않습니다.",
    deleted: "Webhook이 성공적으로 삭제되었습니다.",
    settings_tab: "설정",
    recent_requests_tab: "최근 요청 (24시간)",
    settings: {
        settings: "설정",
        settings_description: "Webhooks를 통해 이벤트가 발생할 때마다 POST request를 내 엔드포인트 URL로 보내 변경 실시간으로 확인 할 수 있습니다.",
        events: "이벤트",
        events_description: "Logto에서 POST request를 보낼 이벤트를 선택하세요.",
        name: "이름",
        endpoint_url: "엔드포인트 URL",
        signing_key: "Signing key",
        signing_key_tip: "Logto에서 제공된 시크릿 키를 사용하여 엔드포인트에 요청 헤더로 추가하여 웹훅 페이로드의 진위성 보장",
        regenerate: "재생성",
        regenerate_key_title: "Signing key 재생성",
        regenerate_key_reminder: "Signing key를 수정하시겠습니까? 재생성하면 즉시 적용됩니다. 엔드포인트에서 Signing key를 동기화 하시기 바랍니다.",
        regenerated: "Signing key가 재생성되었습니다.",
        custom_headers: "사용자 지정 헤더",
        custom_headers_tip: "이벤트에 대한 컨텍스트 또는 메타데이터를 제공하기 위해 webhook 페이로드에 사용자 지정 헤더를 추가할 수 있습니다.",
        key_duplicated_error: "키는 반복될 수 없습니다.",
        key_missing_error: "키는 필수 값입니다.",
        value_missing_error: "값은 필수 값입니다.",
        invalid_key_error: "키가 유효하지 않습니다",
        invalid_value_error: "값이 유효하지 않습니다",
        test: "테스트",
        test_webhook: "Webhook 테스트",
        test_webhook_description: "웹훅을 구성하고 각 선택한 이벤트의 페이로드 예제로 검증하여 올바른 수신 및 처리를 확인하세요.",
        send_test_payload: "테스트 페이로드 보내기",
        test_result: {
            endpoint_url: "엔드포인트 URL: {{url}}",
            message: "메시지: {{message}}",
            response_status: "응답 상태: {{status, number}}",
            response_body: "응답 본문: {{body}}",
            request_time: "요청 시간: {{time}}",
            test_success: "엔드포인트로의 웹훅 테스트가 성공했습니다."
        }
    }
};
var $cc94c3efd1fc8b83$export$2e2bcd8739ae039 = Object.freeze($cc94c3efd1fc8b83$var$webhook_details);


const $4ce87dc1fed046aa$var$webhooks = {
    page_title: "웹훅",
    title: "웹훅",
    subtitle: "특정 이벤트에 대한 실시간 업데이트를 쉽게 수신할 수 있는 웹훅을 생성하세요.",
    create: "웹훅 생성",
    events: {
        post_register: "새 계정 만들기",
        post_sign_in: "로그인",
        post_reset_password: "비밀번호 재설정"
    },
    table: {
        name: "이름",
        events: "이벤트",
        success_rate: "성공률 (24시간)",
        requests: "요청 (24시간)"
    },
    placeholder: {
        title: "웹훅",
        description: 'POST 요청을 통해 엔드포인트 URL로 실시간 업데이트를 수신할 수 있는 웹훅을 생성하세요. "계정 만들기", "로그인" 및 "비밀번호 재설정"과 같은 이벤트에서 정보를 받고 즉시 조치하세요.',
        create_webhook: "웹훅 생성"
    },
    create_form: {
        title: "웹훅 생성",
        subtitle: "사용자 이벤트에 대한 세부 정보가 포함된 POST 요청을 엔드포인트 URL로 보내는 Webhook을 추가합니다.",
        events: "이벤트",
        events_description: "Logto가 POST 요청을 보낼 트리거 이벤트를 선택합니다.",
        name: "이름",
        name_placeholder: "웹훅 이름 입력",
        endpoint_url: "엔드포인트 URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "이벤트가 발생할 때 웹훅의 페이로드가 전송되는 엔드포인트 URL을 입력하세요.",
        create_webhook: "웹훅 생성",
        missing_event_error: "하나 이상의 이벤트를 선택해야 합니다."
    },
    webhook_created: "웹훅 {{name}} 가 성공적으로 생성되었습니다."
};
var $4ce87dc1fed046aa$export$2e2bcd8739ae039 = Object.freeze($4ce87dc1fed046aa$var$webhooks);


const $5f0d660fc9b0f3a3$var$welcome = {
    title: "관리자 콘솔에 오신 것을 환영해요",
    description: "관리자 콘솔를 통해 프로그래밍 없이 Logto를 관리할 수 있어요. 새로 계정을 생성하고, Logto를 당신의 회사에 알맞게 수정해 보세요.",
    create_account: "계정 생성"
};
var $5f0d660fc9b0f3a3$export$2e2bcd8739ae039 = Object.freeze($5f0d660fc9b0f3a3$var$welcome);


const $88707c05252a579f$var$admin_console = {
    title: "관리자 콘솔",
    admin_user: "관리자",
    system_app: "시스템",
    menu: $e514d48755dacdaf$export$2e2bcd8739ae039,
    general: $a7b64b6a31ae956d$export$2e2bcd8739ae039,
    errors: $c35b7d126e912a41$export$2e2bcd8739ae039,
    tab_sections: $e46577576ff49fd6$export$2e2bcd8739ae039,
    tabs: $57e8c1c64d668828$export$2e2bcd8739ae039,
    applications: $cee3ba867b8a571e$export$2e2bcd8739ae039,
    application_details: $9965abb006b4c3f6$export$2e2bcd8739ae039,
    api_resources: $09678806de6033db$export$2e2bcd8739ae039,
    api_resource_details: $b71c7cf5029cd908$export$2e2bcd8739ae039,
    connectors: $700493dd896af5a2$export$2e2bcd8739ae039,
    connector_details: $6ddeefe6f7ddc8c4$export$2e2bcd8739ae039,
    enterprise_sso: $448f4f315b4b61f4$export$2e2bcd8739ae039,
    enterprise_sso_details: $b86b3205e0be1365$export$2e2bcd8739ae039,
    get_started: $6bdec7b3d68c1ed2$export$2e2bcd8739ae039,
    users: $7b0c436f2b378f16$export$2e2bcd8739ae039,
    user_details: $1c488ba953cf7179$export$2e2bcd8739ae039,
    contact: $a145154b0f1b5033$export$2e2bcd8739ae039,
    sign_in_exp: $b23dcb32713afdb9$export$2e2bcd8739ae039,
    dashboard: $61e20bfe07384ac3$export$2e2bcd8739ae039,
    logs: $5984508b9dcd8793$export$2e2bcd8739ae039,
    log_details: $f68720ecc4ed6862$export$2e2bcd8739ae039,
    session_expired: $7559ca7778735c43$export$2e2bcd8739ae039,
    welcome: $5f0d660fc9b0f3a3$export$2e2bcd8739ae039,
    roles: $9646697db9649ca2$export$2e2bcd8739ae039,
    role_details: $35d4f519ed8f73c5$export$2e2bcd8739ae039,
    permissions: $7bb863b7df5e7074$export$2e2bcd8739ae039,
    cloud: $7b3ad2f38b7e0642$export$2e2bcd8739ae039,
    profile: $2360129708d153db$export$2e2bcd8739ae039,
    components: $72d0c264ead9f52e$export$2e2bcd8739ae039,
    webhooks: $4ce87dc1fed046aa$export$2e2bcd8739ae039,
    webhook_details: $cc94c3efd1fc8b83$export$2e2bcd8739ae039,
    domain: $7fd3b2c0b53065f8$export$2e2bcd8739ae039,
    tenants: $a4d4fcb3d277cb30$export$2e2bcd8739ae039,
    topbar: $26f2f19230b02837$export$2e2bcd8739ae039,
    subscription: $5f77d686687fd65d$export$2e2bcd8739ae039,
    upsell: $4335cc321f4fde60$export$2e2bcd8739ae039,
    guide: $440619938a89d99c$export$2e2bcd8739ae039,
    mfa: $5ef3d0ad5c5b6ffd$export$2e2bcd8739ae039,
    organizations: $a43b3a55d381a7cc$export$2e2bcd8739ae039,
    organization_details: $95adc621154f7837$export$2e2bcd8739ae039
};
var $88707c05252a579f$export$2e2bcd8739ae039 = Object.freeze($88707c05252a579f$var$admin_console);


const $7bbf76fe1e0ac100$var$demo_app = {
    title: "Live Preview에 성공적으로 로그인했습니다!",
    subtitle: "여기 로그인 정보가 있어요:",
    username: "사용자 이름: ",
    user_id: "사용자 ID: ",
    sign_out: "Live Preview에서 로그아웃",
    continue_explore: "또는 계속해서 살펴보기",
    customize_sign_in_experience: "로그인 경험 커스터마이징",
    enable_passwordless: "비밀번호 없는 로그인 활성화",
    add_social_connector: "소셜 연동 추가"
};
var $7bbf76fe1e0ac100$export$2e2bcd8739ae039 = Object.freeze($7bbf76fe1e0ac100$var$demo_app);


const $b1c5179dc6f4cc45$var$oidc = {
    logout_success: "성공적으로 로그아웃했습니다."
};
var $b1c5179dc6f4cc45$export$2e2bcd8739ae039 = Object.freeze($b1c5179dc6f4cc45$var$oidc);


const $575ee07ca5e5c00a$var$translation = {
    admin_console: $88707c05252a579f$export$2e2bcd8739ae039,
    demo_app: $7bbf76fe1e0ac100$export$2e2bcd8739ae039,
    oidc: $b1c5179dc6f4cc45$export$2e2bcd8739ae039
};
var $575ee07ca5e5c00a$export$2e2bcd8739ae039 = Object.freeze($575ee07ca5e5c00a$var$translation);


const $b8d35715a740d472$var$ko = {
    translation: $575ee07ca5e5c00a$export$2e2bcd8739ae039,
    errors: $b42187c14e5daa03$export$2e2bcd8739ae039
};
var $b8d35715a740d472$export$2e2bcd8739ae039 = Object.freeze($b8d35715a740d472$var$ko);


const $8bda3844c2111c10$var$application = {
    invalid_type: "Tylko aplikacje maszyna-do-maszyny mogą mieć przypisane role.",
    role_exists: "Rola o identyfikatorze {{roleId}} została już dodana do tej aplikacji.",
    invalid_role_type: "Nie można przypisać roli typu użytkownika do aplikacji maszyna-do-maszyny."
};
var $8bda3844c2111c10$export$2e2bcd8739ae039 = Object.freeze($8bda3844c2111c10$var$application);


const $ececb1b73f220cd2$var$auth = {
    authorization_header_missing: "Brak nagł\xf3wka autoryzacji",
    authorization_token_type_not_supported: "Nieobsługiwany typ autoryzacji",
    unauthorized: "Brak autoryzacji. Sprawdź swoje dane logowania i ich zakres.",
    forbidden: "Brak dostępu. Sprawdź swoje role użytkownika oraz uprawnienia.",
    expected_role_not_found: "Nie znaleziono oczekiwanej roli. Sprawdź swoje role użytkownika oraz uprawnienia.",
    jwt_sub_missing: "Brak `sub` w JWT.",
    require_re_authentication: "Wymagane ponowne uwierzytelnienie, aby wykonać chronione działanie."
};
var $ececb1b73f220cd2$export$2e2bcd8739ae039 = Object.freeze($ececb1b73f220cd2$var$auth);


const $9a059741cf12150c$var$connector = {
    general: "Wystąpił błąd włącznika: {{errorDescription}}",
    not_found: "Nie można znaleźć dostępnego łącznika dla typu: {{type}}.",
    not_enabled: "Łącznik nie jest włączony.",
    invalid_metadata: "Metadane łącznika są nieprawidłowe.",
    invalid_config_guard: "Ochrona konfiguracji łącznika jest nieprawidłowa.",
    unexpected_type: "Typ łącznika jest nieoczekiwany.",
    invalid_request_parameters: "Żądanie jest z nieprawidłowym parametrem wejściowym/lub parametrami wejściowymi.",
    insufficient_request_parameters: "Żądanie może nie zawierać niekt\xf3rych parametr\xf3w wejściowych.",
    invalid_config: "Konfiguracja łącznika jest nieprawidłowa.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "Odpowiedź łącznika jest nieprawidłowa.",
    template_not_found: "Nie można znaleźć poprawnego szablonu w konfiguracji łącznika.",
    template_not_supported: "Łącznik nie obsługuje tego typu szablonu.",
    rate_limit_exceeded: "Ograniczenie szybkości wywołań. Spr\xf3buj ponownie p\xf3źniej.",
    not_implemented: "{{method}}: jeszcze nie zaimplementowano.",
    social_invalid_access_token: "Token dostępu łącznika jest nieprawidłowy.",
    invalid_auth_code: "Kod autoryzacji łącznika jest nieprawidłowy.",
    social_invalid_id_token: "Token ID łącznika jest nieprawidłowy.",
    authorization_failed: "Proces autoryzacji użytkownika zakończył się niepowodzeniem.",
    social_auth_code_invalid: "Nie udało się uzyskać tokenu dostępu, proszę sprawdzić kod autoryzacji.",
    more_than_one_sms: "Ilość łącznik\xf3w SMS jest większa niż 1.",
    more_than_one_email: "Ilość łącznik\xf3w e-mail jest większa niż 1.",
    more_than_one_connector_factory: "Znaleziono wiele fabryk łącznik\xf3w (z id {{connectorIds}}), możesz odinstalować niepotrzebne.",
    db_connector_type_mismatch: "W bazie danych znajduje się łącznik, kt\xf3ry nie pasuje do typu.",
    not_found_with_connector_id: "Nie można odnaleźć łącznika o podanym standardowym identyfikatorze łącznika.",
    multiple_instances_not_supported: "Nie można utworzyć wielu instancji z wybranym standardowym łącznikiem.",
    invalid_type_for_syncing_profile: "Możesz tylko synchronizować profil użytkownika z łącznikami społecznościowymi.",
    can_not_modify_target: "Nie można modyfikować 'target' łącznika.",
    should_specify_target: "Powinieneś/nna/lno określić 'target'.",
    multiple_target_with_same_platform: "Nie można mieć wielu łącznik\xf3w społecznościowych z takim samym 'platforma i target'.",
    cannot_overwrite_metadata_for_non_standard_connector: 'Nie można nadpisać "metadata" tego łącznika, kt\xf3ry nie należy do standardu.'
};
var $9a059741cf12150c$export$2e2bcd8739ae039 = Object.freeze($9a059741cf12150c$var$connector);


const $0a17be3774bb84b7$var$domain = {
    not_configured: "Dostawca nazw domen dla hosta nie jest skonfigurowany.",
    cloudflare_data_missing: "brak danych cloudflare, proszę sprawdzić.",
    cloudflare_unknown_error: "Otrzymano nieznany błąd podczas żądania API Cloudflare",
    cloudflare_response_error: "Otrzymano nieoczekiwaną odpowiedź od Cloudflare.",
    limit_to_one_domain: "Możesz mieć tylko jedną niestandardową domenę.",
    hostname_already_exists: "Ta domena już istnieje na naszym serwerze.",
    cloudflare_not_found: "Nie można znaleźć nazwy hosta w Cloudflare"
};
var $0a17be3774bb84b7$export$2e2bcd8739ae039 = Object.freeze($0a17be3774bb84b7$var$domain);


const $7c20e0724efec8ef$var$entity = {
    invalid_input: "Nieprawidłowe dane. Lista wartości nie może być pusta.",
    create_failed: "Nie udało się utworzyć {{name}}.",
    db_constraint_violated: "Constraint naruszenie bazy danych.",
    not_exists: "{{name}} nie istnieje.",
    not_exists_with_id: "{{name}} o identyfikatorze `{{id}}` nie istnieje.",
    not_found: "Zas\xf3b nie istnieje.",
    relation_foreign_key_not_found: "Nie można odnaleźć jednego lub więcej kluczy obcych. Proszę sprawdzić dane wejściowe i upewnić się, że wszystkie odwołane encje istnieją.",
    unique_integrity_violation: "Encja już istnieje. Proszę sprawdzić dane wejściowe i spr\xf3bować ponownie."
};
var $7c20e0724efec8ef$export$2e2bcd8739ae039 = Object.freeze($7c20e0724efec8ef$var$entity);


const $a0a35d0b8d99a1f6$var$guard = {
    invalid_input: "Żądanie {{type}} jest nieprawidłowe.",
    invalid_pagination: "Nieprawidłowa wartość paginacji żądania.",
    can_not_get_tenant_id: "Nie można pobrać identyfikatora najemcy z żądania.",
    file_size_exceeded: "Przekroczono rozmiar pliku.",
    mime_type_not_allowed: "Nie dozwolony typ MIME."
};
var $a0a35d0b8d99a1f6$export$2e2bcd8739ae039 = Object.freeze($a0a35d0b8d99a1f6$var$guard);


const $3058f5122cba2d22$var$hook = {
    missing_events: "Musisz podać przynajmniej jedno zdarzenie.",
    send_test_payload_failed: "Błąd podczas wysyłania testowego ładunku: {{message}}",
    endpoint_responded_with_error: "Punkt końcowy odpowiedział błędem."
};
var $3058f5122cba2d22$export$2e2bcd8739ae039 = Object.freeze($3058f5122cba2d22$var$hook);


const $9177db889d34bfe9$var$localization = {
    cannot_delete_default_language: "{{languageTag}} jest ustawiony jako Tw\xf3j język domyślny i nie można go usunąć.",
    invalid_translation_structure: "Nieprawidłowe schematy danych. Sprawdź swoje dane wejściowe i spr\xf3buj ponownie."
};
var $9177db889d34bfe9$export$2e2bcd8739ae039 = Object.freeze($9177db889d34bfe9$var$localization);


const $9c7ac129d2578498$var$log = {
    invalid_type: "Typ dziennika jest nieprawidłowy."
};
var $9c7ac129d2578498$export$2e2bcd8739ae039 = Object.freeze($9c7ac129d2578498$var$log);


const $bf1f0ebe6bb3ace9$var$oidc = {
    aborted: "Koniec interakcji z użytkownikiem.",
    invalid_scope: "Nieprawidłowy zakres: {{error_description}}.",
    invalid_token: "Podano nieprawidłowy token.",
    invalid_client_metadata: "Podano nieprawidłowe metadane klienta.",
    insufficient_scope: "Token nie zawiera zakresu `{{scope}}`.",
    invalid_request: "Żądanie jest nieprawidłowe.",
    invalid_grant: "Żądanie przyznania jest nieprawidłowe.",
    invalid_redirect_uri: "Adres URL `redirect_uri` nie pasuje do zarejestrowanych przez klienta `redirect_uris`.",
    access_denied: "Odmowa dostępu.",
    invalid_target: "Nieprawidłowy wskaźnik zasob\xf3w.",
    unsupported_grant_type: "Żądany typ `grant_type` nie jest obsługiwany.",
    unsupported_response_mode: "Żądany tryb `response_mode` nie jest obsługiwany.",
    unsupported_response_type: "Żądany typ `response_type` nie jest obsługiwany.",
    provider_error: "Wewnętrzny błąd OIDC: {{message}}.",
    server_error: "Wystąpił nieznany błąd OIDC. Spr\xf3buj ponownie p\xf3źniej.",
    provider_error_fallback: "Wystąpił błąd OIDC: {{code}}.",
    key_required: "Wymagany jest co najmniej jeden klucz.",
    key_not_found: "Nie znaleziono klucza o ID {{id}}."
};
var $bf1f0ebe6bb3ace9$export$2e2bcd8739ae039 = Object.freeze($bf1f0ebe6bb3ace9$var$oidc);


const $d8c3723934fa0f7c$var$organization = {
    require_membership: "Użytkownik musi być członkiem organizacji, aby kontynuować."
};
var $d8c3723934fa0f7c$export$2e2bcd8739ae039 = Object.freeze($d8c3723934fa0f7c$var$organization);


const $d24d2f63e1134e6b$var$password = {
    unsupported_encryption_method: "Metoda szyfrowania {{name}} nie jest obsługiwana.",
    pepper_not_found: "Nie znaleziono wartości pepper dla hasła. Sprawdź swoje zmienne środowiskowe.",
    rejected: "Odrzucono hasło. Sprawdź, czy spełnia ono wymagania."
};
var $d24d2f63e1134e6b$export$2e2bcd8739ae039 = Object.freeze($d24d2f63e1134e6b$var$password);


const $08620c2c5388a8af$var$request = {
    invalid_input: "Nieprawidłowe dane wejściowe. {{details}}",
    general: "Wystąpił błąd żądania."
};
var $08620c2c5388a8af$export$2e2bcd8739ae039 = Object.freeze($08620c2c5388a8af$var$request);


const $8d9710545465a05b$var$resource = {
    resource_identifier_in_use: "Identyfikator API {{indicator}} jest już używany"
};
var $8d9710545465a05b$export$2e2bcd8739ae039 = Object.freeze($8d9710545465a05b$var$resource);


const $5bdc0ad39d90350f$var$role = {
    name_in_use: "Ta nazwa roli {{name}} jest już w użyciu",
    scope_exists: "Identyfikator zakresu {{scopeId}} został już dodany do tej roli",
    user_exists: "Identyfikator użytkownika {{userId}} został już dodany do tej roli",
    application_exists: "Identyfikator aplikacji {{applicationId}} został już dodany do tej roli",
    default_role_missing: "Niekt\xf3re z domyślnych nazw r\xf3l nie istnieją w bazie danych, upewnij się, że najpierw utworzysz role",
    internal_role_violation: 'Możesz pr\xf3bować zaktualizować lub usunąć rolę wewnętrzną, co jest zabronione przez Logto. Jeśli tworzysz nową rolę, spr\xf3buj innej nazwy, kt\xf3ra nie zaczyna się od "#internal:".\uFEFF'
};
var $5bdc0ad39d90350f$export$2e2bcd8739ae039 = Object.freeze($5bdc0ad39d90350f$var$role);


const $2945ec5f4b027c2f$var$scope = {
    name_exists: "Nazwa zakresu {{name}} jest już używana",
    name_with_space: "Nazwa zakresu nie może zawierać spacji."
};
var $2945ec5f4b027c2f$export$2e2bcd8739ae039 = Object.freeze($2945ec5f4b027c2f$var$scope);


const $aa961d37c6b3bc98$var$session = {
    not_found: "Nie znaleziono sesji. Proszę wr\xf3cić i zalogować się ponownie.",
    invalid_credentials: "Niepoprawne konto lub hasło. Sprawdź swoje dane wejściowe.",
    invalid_sign_in_method: "Aktualna metoda logowania jest niedostępna.",
    invalid_connector_id: "Nie można znaleźć dostępnego łącznika o id {{connectorId}}.",
    insufficient_info: "Niewystarczające informacje do zalogowania.",
    connector_id_mismatch: "Id łącznika nie pasuje do rekordu sesji.",
    connector_session_not_found: "Nie znaleziono sesji łącznika. Proszę wr\xf3ć i zaloguj ponownie.",
    verification_session_not_found: "Weryfikacja nie powiodła się. Uruchom proces weryfikacji ponownie i spr\xf3buj ponownie.",
    verification_expired: "Połączenie wygasło. Zweryfikuj ponownie, aby zapewnić bezpieczeństwo Twojego konta.",
    verification_blocked_too_many_attempts: "Zbyt wiele pr\xf3b w kr\xf3tkim czasie. Proszę spr\xf3buj ponownie {{relativeTime}}.",
    unauthorized: "Proszę się najpierw zalogować.",
    unsupported_prompt_name: "Nieobsługiwana nazwa podpowiedzi.",
    forgot_password_not_enabled: "Odzyskiwanie hasła nie jest włączone.",
    verification_failed: "Weryfikacja nie powiodła się. Uruchom proces weryfikacji ponownie i spr\xf3buj ponownie.",
    connector_validation_session_not_found: "Nie znaleziono sesji łącznika dla weryfikacji tokena.",
    identifier_not_found: "Nie znaleziono identyfikatora użytkownika. Proszę wr\xf3ć i zaloguj się ponownie.",
    interaction_not_found: "Nie znaleziono sesji interakcji. Proszę wr\xf3ć i rozpocznij sesję ponownie.",
    not_supported_for_forgot_password: "Ta operacja nie jest obsługiwana dla zapomnienia hasła.",
    mfa: {
        require_mfa_verification: "Wymagana jest weryfikacja MFA, aby się zalogować.",
        mfa_sign_in_only: "MFA jest dostępne tylko dla interakcji logowania.",
        pending_info_not_found: "Nie znaleziono oczekujących informacji MFA, proszę najpierw zainicjować MFA.",
        invalid_totp_code: "Nieprawidłowy kod TOTP.",
        webauthn_verification_failed: "Weryfikacja WebAuthn nie powiodła się.",
        webauthn_verification_not_found: "Nie znaleziono weryfikacji WebAuthn.",
        bind_mfa_existed: "MFA już istnieje.",
        backup_code_can_not_be_alone: "Kod zapasowy nie może być jedyną MFA.",
        backup_code_required: "Kod zapasowy jest wymagany.",
        invalid_backup_code: "Nieprawidłowy kod zapasowy.",
        mfa_policy_not_user_controlled: "Polityka MFA nie jest kontrolowana przez użytkownika."
    },
    sso_enabled: "Single sign on jest włączony dla tego adresu e-mail. Zaloguj się za pomocą SSO."
};
var $aa961d37c6b3bc98$export$2e2bcd8739ae039 = Object.freeze($aa961d37c6b3bc98$var$session);


const $0e39ad996386d3fb$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Pusty adres URL zawartości "Regulaminu". Proszę dodać adres URL zawartości, jeśli funkcja "Regulamin" jest włączona.',
    empty_social_connectors: "Brak skojarzonych kont społecznościowych. Proszę dodać skojarzone konta społecznościowe, gdy metoda logowania za pomocą sieci społecznościowej jest włączona.",
    enabled_connector_not_found: "Nie znaleziono aktywowanego łącznika typu {{type}}.",
    not_one_and_only_one_primary_sign_in_method: "Musi istnieć jedna i tylko jedna podstawowa metoda logowania. Proszę sprawdzić swoje dane wejściowe.",
    username_requires_password: "Należy włączyć ustawienie hasła dla identyfikatora rejestracji nazwy użytkownika.",
    passwordless_requires_verify: "Należy włączyć weryfikację dla identyfikatora rejestracji adresu e-mail/telefonu.",
    miss_sign_up_identifier_in_sign_in: "Metody logowania muszą zawierać identyfikator rejestracji.",
    password_sign_in_must_be_enabled: "Logowanie za pomocą hasła musi być włączone, gdy w rejestracji wymagane jest ustawienie hasła.",
    code_sign_in_must_be_enabled: "Logowanie za pomocą kodu weryfikacyjnego musi być włączone, gdy w rejestracji nie jest wymagane ustawienie hasła.",
    unsupported_default_language: "Ten język - {{language}} nie jest obecnie obsługiwany.",
    at_least_one_authentication_factor: "Musisz wybrać co najmniej jeden czynnik uwierzytelniający.",
    backup_code_cannot_be_enabled_alone: "Kod zapasowy nie może być włączony samodzielnie.",
    duplicated_mfa_factors: "Powielone czynniki MFA."
};
var $0e39ad996386d3fb$export$2e2bcd8739ae039 = Object.freeze($0e39ad996386d3fb$var$sign_in_experiences);


const $9ba0786dd1b18414$var$single_sign_on = {
    forbidden_domains: "Nie są dozwolone publiczne domeny e-mail.",
    duplicated_domains: "Istnieją zduplikowane domeny.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $9ba0786dd1b18414$export$2e2bcd8739ae039 = Object.freeze($9ba0786dd1b18414$var$single_sign_on);


const $c8b8529ca6910b11$var$storage = {
    not_configured: "Nie skonfigurowano dostawcy magazynu.",
    missing_parameter: "Brak parametru {{parameter}} dla dostawcy magazynu.",
    upload_error: "Nie udało się przesłać pliku do dostawcy magazynu."
};
var $c8b8529ca6910b11$export$2e2bcd8739ae039 = Object.freeze($c8b8529ca6910b11$var$storage);


const $6ce16d2208cc09c7$var$subscription = {
    limit_exceeded: "Osiągnąłeś limit swojego planu subskrypcji.",
    get_plan_failed: "Nie można pobrać planu subskrypcji dla najemcy.",
    tenant_suspended: "Najemca jest zawieszony. Skontaktuj się z administratorem."
};
var $6ce16d2208cc09c7$export$2e2bcd8739ae039 = Object.freeze($6ce16d2208cc09c7$var$subscription);


const $8eb3bcdbf113e27c$var$swagger = {
    invalid_zod_type: "Nieprawidłowy typ Zod. Sprawdź konfigurację straży routy.",
    not_supported_zod_type_for_params: "Nieobsługiwany typ Zod dla parametr\xf3w. Sprawdź konfigurację straży routy."
};
var $8eb3bcdbf113e27c$export$2e2bcd8739ae039 = Object.freeze($8eb3bcdbf113e27c$var$swagger);


const $7cb0f9566ef91342$var$user = {
    username_already_in_use: "Nazwa użytkownika jest już zajęta.",
    email_already_in_use: "Ten email jest już powiązany z istniejącym kontem.",
    phone_already_in_use: "Ten numer telefonu jest już powiązany z istniejącym kontem.",
    invalid_email: "Nieprawidłowy adres email.",
    invalid_phone: "Nieprawidłowy numer telefonu.",
    email_not_exist: "Podany adres email nie został jeszcze zarejestrowany.",
    phone_not_exist: "Podany numer telefonu nie został jeszcze zarejestrowany.",
    identity_not_exist: "Konto społecznościowe nie zostało jeszcze zarejestrowane.",
    identity_already_in_use: "Konto społecznościowe zostało już powiązane z istniejącym kontem.",
    social_account_exists_in_profile: "To konto społecznościowe zostało już powiązane z Twoim profilem.",
    cannot_delete_self: "Nie możesz usunąć swojego konta.",
    sign_up_method_not_enabled: "Rejestracja tym sposobem jest wyłączona.",
    sign_in_method_not_enabled: "Logowanie tym sposobem jest wyłączone.",
    same_password: "Nowe hasło nie może być takie samo jak stare hasło.",
    password_required_in_profile: "Musisz ustawić hasło przed zalogowaniem.",
    new_password_required_in_profile: "Musisz ustawić nowe hasło.",
    password_exists_in_profile: "Hasło już istnieje w Twoim profilu.",
    username_required_in_profile: "Musisz ustawić nazwę użytkownika przed zalogowaniem.",
    username_exists_in_profile: "Nazwa użytkownika już istnieje w Twoim profilu.",
    email_required_in_profile: "Musisz dodać adres email przed zalogowaniem.",
    email_exists_in_profile: "Tw\xf3j profil jest już powiązany z adresem email.",
    phone_required_in_profile: "Musisz dodać numer telefonu przed zalogowaniem.",
    phone_exists_in_profile: "Tw\xf3j profil jest już powiązany z numerem telefonu.",
    email_or_phone_required_in_profile: "Musisz dodać adres email lub numer telefonu przed zalogowaniem.",
    suspended: "To konto jest zawieszone.",
    user_not_exist: "Użytkownik z identyfikatorem {{ identifier }} nie istnieje.",
    missing_profile: "Musisz podać dodatkowe informacje przed zalogowaniem.",
    role_exists: "Identyfikator roli {{roleId}} jest już dodany do tego użytkownika",
    invalid_role_type: "Nieprawidłowy typ roli, nie można przypisać roli maszynowej do użytkownika.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $7cb0f9566ef91342$export$2e2bcd8739ae039 = Object.freeze($7cb0f9566ef91342$var$user);


const $c11c95b449067be3$var$verification_code = {
    phone_email_empty: "Oba pola telefonu i emaila są puste.",
    not_found: "Nie znaleziono kodu weryfikacyjnego. Proszę najpierw wysłać kod weryfikacyjny.",
    phone_mismatch: "Niepoprawny numer telefonu. Proszę poprosić o nowy kod weryfikacyjny.",
    email_mismatch: "Niepoprawny adres email. Proszę poprosić o nowy kod weryfikacyjny.",
    code_mismatch: "Nieprawidłowy kod weryfikacyjny.",
    expired: "Kod weryfikacyjny wygasł. Proszę poprosić o nowy kod weryfikacyjny.",
    exceed_max_try: "Osiągnięto limit pr\xf3b kodu weryfikacyjnego. Proszę poprosić o nowy kod weryfikacyjny."
};
var $c11c95b449067be3$export$2e2bcd8739ae039 = Object.freeze($c11c95b449067be3$var$verification_code);


const $86a2b23e45cb712d$var$errors = {
    request: $08620c2c5388a8af$export$2e2bcd8739ae039,
    auth: $ececb1b73f220cd2$export$2e2bcd8739ae039,
    guard: $a0a35d0b8d99a1f6$export$2e2bcd8739ae039,
    oidc: $bf1f0ebe6bb3ace9$export$2e2bcd8739ae039,
    user: $7cb0f9566ef91342$export$2e2bcd8739ae039,
    password: $d24d2f63e1134e6b$export$2e2bcd8739ae039,
    session: $aa961d37c6b3bc98$export$2e2bcd8739ae039,
    connector: $9a059741cf12150c$export$2e2bcd8739ae039,
    verification_code: $c11c95b449067be3$export$2e2bcd8739ae039,
    sign_in_experiences: $0e39ad996386d3fb$export$2e2bcd8739ae039,
    localization: $9177db889d34bfe9$export$2e2bcd8739ae039,
    swagger: $8eb3bcdbf113e27c$export$2e2bcd8739ae039,
    entity: $7c20e0724efec8ef$export$2e2bcd8739ae039,
    log: $9c7ac129d2578498$export$2e2bcd8739ae039,
    role: $5bdc0ad39d90350f$export$2e2bcd8739ae039,
    scope: $2945ec5f4b027c2f$export$2e2bcd8739ae039,
    storage: $c8b8529ca6910b11$export$2e2bcd8739ae039,
    resource: $8d9710545465a05b$export$2e2bcd8739ae039,
    hook: $3058f5122cba2d22$export$2e2bcd8739ae039,
    domain: $0a17be3774bb84b7$export$2e2bcd8739ae039,
    subscription: $6ce16d2208cc09c7$export$2e2bcd8739ae039,
    application: $8bda3844c2111c10$export$2e2bcd8739ae039,
    organization: $d8c3723934fa0f7c$export$2e2bcd8739ae039,
    single_sign_on: $9ba0786dd1b18414$export$2e2bcd8739ae039
};
var $86a2b23e45cb712d$export$2e2bcd8739ae039 = Object.freeze($86a2b23e45cb712d$var$errors);


const $ce3f12dc3b1e6e0f$var$api_resource_details = {
    page_title: "Szczeg\xf3ły zasob\xf3w API",
    back_to_api_resources: "Powr\xf3ć do zasob\xf3w API",
    settings_tab: "Ustawienia",
    permissions_tab: "Uprawnienia",
    settings: "Ustawienia",
    settings_description: "Zasoby API, tzw. wskaźniki zasob\xf3w, wskazują na usługi lub zasoby docelowe, kt\xf3re mają być żądane, zwykle w zmiennej formatu URI reprezentującej tożsamość zasobu.",
    management_api_settings_description: "Logto Management API to kompleksowa kolekcja interfejs\xf3w API, kt\xf3re umożliwiają administratorom zarządzanie szerokim zakresem zadań związanych z tożsamością, egzekwowanie polityk bezpieczeństwa oraz przestrzeganie przepis\xf3w i standard\xf3w.",
    management_api_notice: "To API reprezentuje jednostkę Logto i nie można go modyfikować ani usuwać. Możesz użyć API zarządzania do szerokiego zakresu zadań związanych z tożsamością. <a>Więcej informacji</a>",
    token_expiration_time_in_seconds: "Czas wygaśnięcia tokenu (w sekundach)",
    token_expiration_time_in_seconds_placeholder: "Wprowadź czas wygaśnięcia tokenu",
    delete_description: "Tej akcji nie można cofnąć. Spowoduje to trwałe usunięcie zasobu API. Wpisz nazwę zasobu API <span>{{name}}</span>, aby potwierdzić.",
    enter_your_api_resource_name: "Wprowadź nazwę swojego zasobu API",
    api_resource_deleted: "Zas\xf3b API {{name}} został pomyślnie usunięty",
    permission: {
        create_button: "Utw\xf3rz uprawnienie",
        create_title: "Utw\xf3rz uprawnienie",
        create_subtitle: "Zdefiniuj uprawnienia (zakresy) wymagane przez to API.",
        confirm_create: "Utw\xf3rz uprawnienie",
        name: "Nazwa uprawnienia",
        name_placeholder: "ready:resource",
        forbidden_space_in_name: "Nazwa uprawnienia nie może zawierać spacji.",
        description: "Opis",
        description_placeholder: "Możliwość odczytu zasob\xf3w",
        permission_created: "Uprawnienie {{name}} zostało pomyślnie utworzone",
        delete_description: "Jeśli to uprawnienie zostanie usunięte, użytkownik, kt\xf3ry miał to uprawnienie, straci dostęp przyznany przez nie.",
        deleted: 'Uprawnienie "{{name}}" zostało pomyślnie usunięte.'
    }
};
var $ce3f12dc3b1e6e0f$export$2e2bcd8739ae039 = Object.freeze($ce3f12dc3b1e6e0f$var$api_resource_details);


const $a4292bcf6bb5055f$var$api_resources = {
    page_title: "Zasoby API",
    title: "Zasoby API",
    subtitle: "Definiuj API, z kt\xf3rych korzystać mogą twoje autoryzowane aplikacje",
    create: "Utw\xf3rz zas\xf3b API",
    api_name: "Nazwa API",
    api_name_placeholder: "Wprowadź nazwę swojego API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Unikalny identyfikator zasobu API. Musi to być bezwzględny adres URI bez składnika fragmentu (#). Jest r\xf3wny <a>parametrowi zasobu</a> w standardzie OAuth 2.0.",
    default_api: "Domyślne API",
    default_api_label: "Tylko jedno API domyślne może być ustawione na jeden najem. Kiedy określone zostanie API domyślne, parametr zasobu może zostać pominięty w żądaniu autoryzacji. Następujące procesy wymiany tokenu będą domyślnie korzystać z tego API, co umożliwi wydanie JWT. <a>Dowiedz się więcej</a>",
    api_resource_created: "Zas\xf3b API {{name}} został pomyślnie utworzony"
};
var $a4292bcf6bb5055f$export$2e2bcd8739ae039 = Object.freeze($a4292bcf6bb5055f$var$api_resources);


const $6e7b9b235a528ff4$var$application_details = {
    page_title: "Szczeg\xf3ły aplikacji",
    back_to_applications: "Powr\xf3t do aplikacji",
    check_guide: "Sprawdź przewodnik",
    settings: "Ustawienia",
    settings_description: "Aplikacje są używane do identyfikowania Twoich aplikacji w Logto dla OIDC, doświadczenia logowania, dziennik\xf3w audytowych itp.",
    advanced_settings: "Zaawansowane ustawienia",
    advanced_settings_description: "Zaawansowane ustawienia obejmują związane z OIDC terminy. Możesz sprawdzić punkt końcowy Token dla bardziej szczeg\xf3łowych informacji.",
    application_roles: "Role",
    machine_logs: "Dzienniki maszynowe",
    application_name: "Nazwa aplikacji",
    application_name_placeholder: "Moja aplikacja",
    description: "Opis",
    description_placeholder: "Wpisz opis swojej aplikacji",
    config_endpoint: "Konfiguracja punktu końcowego OpenID Provider",
    authorization_endpoint: "Endpoint autoryzacji",
    authorization_endpoint_tip: "Endpoint wykorzystywany do autentykacji i autoryzacji. Używany jest dla OpenID Connect <a>Autentykacji</a>.",
    logto_endpoint: "Logto endpoint",
    application_id: "ID aplikacji",
    application_id_tip: "Unikalny identyfikator aplikacji, kt\xf3ry jest zwykle generowany przez Logto. Oznacza r\xf3wnież „<a>client_id</a>” w OpenID Connect.",
    application_secret: "Tajny kod aplikacji",
    redirect_uri: "Adres URL przekierowania",
    redirect_uris: "Adresy URL przekierowania",
    redirect_uri_placeholder: "https://twoja.strona.com/aplikacja",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "Adres URL, na kt\xf3ry użytkownik jest przekierowywany po zalogowaniu się (zar\xf3wno pozytywnym, jak i negatywnym). Zobacz OpenID Connect <a>AuthRequest</a> po więcej informacji.",
    post_sign_out_redirect_uri: "Adres URL przekierowania po wylogowaniu",
    post_sign_out_redirect_uris: "Adresy URL przekierowania po wylogowaniu",
    post_sign_out_redirect_uri_placeholder: "https://twoja.strona.com/strona-startowa",
    post_sign_out_redirect_uri_tip: "Adres URL, na kt\xf3ry użytkownik jest przekierowywany po wylogowaniu (opcjonalnie). W niekt\xf3rych rodzajach aplikacji może nie mieć to praktycznego wpływu.",
    cors_allowed_origins: "Dozwolone źr\xf3dła CORS",
    cors_allowed_origins_placeholder: "https://twoja.strona.com",
    cors_allowed_origins_tip: "Domyślnie dozwolone będą wszystkie źr\xf3dła z adres\xf3w URL przekierowania. Zazwyczaj nie wymaga to żadnych działań. Zobacz dokumentację <a>MDN</a> dla szczeg\xf3łowych informacji.",
    token_endpoint: "Endpoint Tokena",
    user_info_endpoint: "Endpoint Informacji o użytkowniku",
    enable_admin_access: "Włącz dostęp administratora",
    enable_admin_access_label: "Włącz lub wyłącz dostęp do interfejsu API zarządzania. Po włączeniu możesz używać token\xf3w dostępu do wywoływania interfejsu API zarządzania w imieniu tej aplikacji.",
    always_issue_refresh_token: "Zawsze wydawaj Refresh Token",
    always_issue_refresh_token_label: "Rozwiazanie tej konfiguracji pozwoli Logto zawsze wydawac cwiecze tokeny, bez wzgledu na to, czy w zadaniu autoryzacji zostal przedstawiony `prompt=consent`. Jednak ta praktyka jest odstraszana, chyba ze konieczne, jak nie jest w pelni kompatybilna z OpenID Connect i moze potencjalnie powodowac problemy.",
    refresh_token_ttl: "Czas życia tokena odświeżania w dniach",
    refresh_token_ttl_tip: "Okres, przez kt\xf3ry Token odświeżania można używać do żądania nowych token\xf3w dostępu, zanim wygaśnie i zostanie unieważniony. Wymaga to przedłużenia czasu życia token\xf3w żądania. ",
    rotate_refresh_token: "Obr\xf3ć token odświeżania",
    rotate_refresh_token_label: "Po włączeniu tej opcji Logto wydaje nowy Token odświeżania dla żądań token\xf3w, gdy upłynęło 70% oryginalnego czasu życia (TTL) lub spełnione są pewne warunki. <a>Dowiedz się więcej</a>",
    delete_description: "Ta operacja nie może zostać cofnięta. Skutkuje ona trwałym usunięciem aplikacji. Aby potwierdzić, wpisz nazwę aplikacji <span>{{name}}</span>.",
    enter_your_application_name: "Wpisz nazwę swojej aplikacji",
    application_deleted: "Aplikacja {{name}} została pomyślnie usunięta",
    redirect_uri_required: "Musisz wpisać co najmniej jeden adres URL przekierowania",
    roles: {
        name_column: "Role",
        description_column: "Opis",
        assign_button: "Przypisz role",
        delete_description: "Ta akcja usunie tę rolę z tej aplikacji machine-to-machine. Rola ta nadal będzie istnieć, ale nie będzie już powiązana z tą aplikacją machine-to-machine.",
        deleted: "{{name}} został(a) pomyślnie usunięty(ą) z tego użytkownika.",
        assign_title: "Przypisz role dla {{name}}",
        assign_subtitle: "Autoryzuj {{name}} jedną lub więcej r\xf3l",
        assign_role_field: "Przypisz role",
        role_search_placeholder: "Wyszukaj według nazwy roli",
        added_text: "{{value, number}} dodane",
        assigned_app_count: "{{value, number}} aplikacje",
        confirm_assign: "Przypisz role",
        role_assigned: "Pomyślnie przypisano rolę(y)",
        search: "Wyszukaj według nazwy roli, opisu lub ID",
        empty: "Brak dostępnych r\xf3l"
    }
};
var $6e7b9b235a528ff4$export$2e2bcd8739ae039 = Object.freeze($6e7b9b235a528ff4$var$application_details);


const $46b64f26cf979496$var$applications = {
    page_title: "Aplikacje",
    title: "Aplikacje",
    subtitle: "Skonfiguruj uwierzytelnianie Logto dla Twojej aplikacji natywnej, jednostronicowej, komunikującej się bezpośrednio z zasobami lub tradycyjnej",
    subtitle_with_app_type: "Skonfiguruj uwierzytelnianie Logto dla twojej aplikacji {{name}}",
    create: "Utw\xf3rz aplikację",
    application_name: "Nazwa aplikacji",
    application_name_placeholder: "Moja aplikacja",
    application_description: "Opis aplikacji",
    application_description_placeholder: "Wprowadź opis swojej aplikacji",
    select_application_type: "Wybierz typ aplikacji",
    no_application_type_selected: "Nie wybrałeś jeszcze żadnego typu aplikacji",
    application_created: "Aplikacja ostała pomyślnie utworzona.",
    app_id: "App ID",
    type: {
        native: {
            title: "Aplikacja natywna",
            subtitle: "Aplikacja uruchamiana w środowisku natywnym",
            description: "Na przykład aplikacja na iOS, aplikacja na Androida"
        },
        spa: {
            title: "Aplikacja jednostronicowa",
            subtitle: "Aplikacja uruchamiana w przeglądarce internetowej i dynamicznie aktualizująca dane na miejscu",
            description: "Na przykład aplikacja React DOM, aplikacja Vue"
        },
        traditional: {
            title: "Tradycyjna strona internetowa",
            subtitle: "Aplikacja, kt\xf3ra renderuje i aktualizuje strony tylko przez serwer internetowy",
            description: "Na przykład Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Aplikacja (zazwyczaj usługa), kt\xf3ra bezpośrednio komunikuje się z zasobami",
            description: "Na przykład usługa backendowa"
        }
    },
    placeholder_title: "Wybierz typ aplikacji, aby kontynuować",
    placeholder_description: "Logto używa jednostki aplikacji dla OIDC, aby pom\xf3c w takich zadaniach jak identyfikowanie Twoich aplikacji, zarządzanie logowaniem i tworzenie dziennik\xf3w audytu."
};
var $46b64f26cf979496$export$2e2bcd8739ae039 = Object.freeze($46b64f26cf979496$var$applications);


const $10680b30dee8834b$var$cloud = {
    general: {
        onboarding: "Wdrażanie"
    },
    welcome: {
        page_title: "Witamy",
        title: "Witaj w chmurze Logto! Chcielibyśmy dowiedzieć się trochę o Tobie.",
        description: "Stw\xf3rz indywidualne wrażenia z Logto dzięki naszej wiedzy na temat Ciebie. Twoje informacje są bezpieczne u nas.",
        project_field: "Używam Logto do",
        project_options: {
            personal: "Projektu osobistego",
            company: "Projektu firmowego"
        },
        title_field: "Wybierz odpowiednie tytuły",
        title_options: {
            developer: "Developer",
            team_lead: "Team Lead",
            ceo: "CEO",
            cto: "CTO",
            product: "Product",
            others: "Inne"
        },
        company_name_field: "Nazwa firmy",
        company_name_placeholder: "Acme.co",
        company_size_field: "Jak wielka jest Twoja firma?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Rejestruję się, ponieważ",
        reason_options: {
            passwordless: "Szukam uwierzytelnienia bez hasła i zestawu interfejs\xf3w użytkownika",
            efficiency: "Szukam infrastruktury tożsamości out-of-the-box",
            access_control: "Kontroluj dostęp użytkownik\xf3w na podstawie r\xf3l i odpowiedzialności",
            multi_tenancy: "Szukam strategii dla produktu multi-mandantowego",
            enterprise: "Szukam rozwiązań SSO dla gotowości przedsiębiorstwa",
            others: "Inne"
        }
    },
    sie: {
        page_title: "Dostosuj doświadczenie logowania",
        title: "Najpierw dostosuj swoje doświadczenie logowania",
        inspire: {
            title: "Stw\xf3rz przykłady",
            description: 'Nie jesteś pewien swojego doświadczenia logowania? Kliknij "Zainspiruj mnie" i pozw\xf3l, żeby magia się stała!',
            inspire_me: "Zainspiruj mnie"
        },
        logo_field: "Logo aplikacji",
        color_field: "Kolor marki",
        identifier_field: "Identyfikator",
        identifier_options: {
            email: "E-mail",
            phone: "Telefon",
            user_name: "Nazwa użytkownika"
        },
        authn_field: "Uwierzytelnianie",
        authn_options: {
            password: "Hasło",
            verification_code: "Kod weryfikacyjny"
        },
        social_field: "Logowanie społecznościowe",
        finish_and_done: "Skończone i gotowe",
        preview: {
            mobile_tab: "Mobilny",
            web_tab: "Sieć"
        },
        connectors: {
            unlocked_later: "Zostanie odblokowane p\xf3źniej",
            unlocked_later_tip: "Po ukończeniu procesu wprowadzenia do użytku i wejściu do produktu będziesz mieć dostęp do jeszcze większej liczby metod logowania społecznościowego.",
            notice: "Prosimy, unikaj korzystania z demo konektora do cel\xf3w produkcyjnych. Po zakończeniu test\xf3w, uprzejmie usuń demokonwerter i skonfiguruj sw\xf3j własny konektor z własnymi poświadczeniami."
        }
    },
    socialCallback: {
        title: "Zalogowałeś się pomyślnie",
        description: "Zalogowałeś się pomyślnie używając swojego konta społecznościowego. Aby zapewnić bezproblemową integrację i dostęp do wszystkich funkcji Logto, zalecamy przejście do konfiguracji własnego konektora społecznościowego."
    },
    tenant: {
        create_tenant: "Stw\xf3rz najemcę"
    }
};
var $10680b30dee8834b$export$2e2bcd8739ae039 = Object.freeze($10680b30dee8834b$var$cloud);


const $ba5e35ee485ec228$var$components = {
    uploader: {
        action_description: "Przeciągnij i upuść lub przeszukaj",
        uploading: "Wysyłanie...",
        image_limit: "Wyślij obraz o rozmiarze mniejszym niż {{size, number}}KB, tylko w formacie {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Coś poszło nie tak. Nie udało się wysłać pliku.",
        error_file_size: "Plik jest zbyt duży. Wyślij plik o rozmiarze mniejszym niż {{size, number}}KB.",
        error_file_type: "Ten typ pliku nie jest obsługiwany. Obsługiwane formaty to {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Możesz przesłać tylko 1 plik."
    }
};
var $ba5e35ee485ec228$export$2e2bcd8739ae039 = Object.freeze($ba5e35ee485ec228$var$components);


const $00e2e8ddd4e7f9a1$var$connector_details = {
    page_title: "Szczeg\xf3ły konektora",
    back_to_connectors: "Powr\xf3t do konektor\xf3w",
    check_readme: "Sprawdź README",
    settings: "Ustawienia og\xf3lne",
    settings_description: "Konektory odgrywają kluczową rolę w Logto. Dzięki nim, Logto umożliwia użytkownikom końcowym korzystanie z rejestracji lub logowania bez hasła oraz możliwości logowania się za pomocą kont społecznościowych.",
    parameter_configuration: "Konfiguracja parametru",
    test_connection: "Test",
    save_error_empty_config: "Proszę wprowadzić konfigurację",
    send: "Wyślij",
    send_error_invalid_format: "Nieprawidłowy format danych wejściowych",
    edit_config_label: "Wprowadź swoje dane JSON tutaj",
    test_email_sender: "Wypr\xf3buj konektor e-mail",
    test_sms_sender: "Wypr\xf3buj konektor SMS",
    test_email_placeholder: "jan.kowalski@example.com",
    test_sms_placeholder: "+48 123-456-789",
    test_message_sent: "Wiadomość testowa została wysłana",
    test_sender_description: 'Logto używa szablonu "Og\xf3lny" do test\xf3w. Otrzymasz wiadomość, jeśli tw\xf3j konektor jest prawidłowo skonfigurowany.',
    options_change_email: "Zmień konektor e-mail",
    options_change_sms: "Zmień konektor SMS",
    connector_deleted: "Konektor został pomyślnie usunięty",
    type_email: "Konektor e-mail",
    type_sms: "Konektor SMS",
    type_social: "Konektor społecznościowy",
    in_used_social_deletion_description: "Ten konektor jest używany w Twoim procesie logowania. Usunięcie spowoduje usunięcie doświadczenia logowania <name/> w ustawieniach doświadczenia logowania. Będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go dodać z powrotem.",
    in_used_passwordless_deletion_description: "Ten {{name}} jest używany w Twoim procesie logowania. Usunięcie spowoduje, że Twoje doświadczenie logowania nie będzie działać poprawnie, dop\xf3ki nie rozwiążesz konfliktu. Będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go dodać z powrotem.",
    deletion_description: "Usuwasz ten konektor. Nie można tego cofnąć, będziesz musiał go ponownie skonfigurować, jeśli zdecydujesz się go ponownie dodać.",
    logto_email: {
        total_email_sent: "Wysłano łącznie emaili: {{value, number}}",
        total_email_sent_tip: "Logto wykorzystuje SendGrid do bezpiecznej i stabilnej wysyłki wbudowanych wiadomości e-mail. Jest to całkowicie darmowe do użytku. <a>Więcej informacji</a>",
        email_template_title: "Szablon e-maila",
        template_description: "Wbudowany e-mail używa domyślnych szablon\xf3w dla bezproblemowej dostawy wiadomości weryfikacyjnych. Nie wymaga to konfiguracji, a podstawowe informacje o marce można dostosować.",
        template_description_link_text: "Wyświetl szablony",
        description_action_text: "Wyświetl szablony",
        from_email_field: "Adres e-mail nadawcy",
        sender_name_field: "Nazwa nadawcy",
        sender_name_tip: 'Dostosuj nazwę nadawcy dla wiadomości e-mail. Jeśli pozostawisz to pole puste, domyślnie użyta zostanie nazwa "Verification".',
        sender_name_placeholder: "Nazwa nadawcy",
        company_information_field: "Informacje o firmie",
        company_information_description: "Wyświetlaj nazwę firmy, adres lub kod pocztowy na dole wiadomości e-mail, aby zwiększyć autentyczność.",
        company_information_placeholder: "Podstawowe informacje o Twojej firmie",
        app_logo_field: "Logo aplikacji",
        app_logo_tip: "Wyświetlaj logo marki na g\xf3rze wiadomości e-mail. Użyj tego samego obrazu zar\xf3wno dla trybu jasnego, jak i ciemnego.",
        urls_not_allowed: "Nie dozwolone adresy URL",
        test_notes: 'Logto używa szablonu "Og\xf3lny" do test\xf3w.'
    }
};
var $00e2e8ddd4e7f9a1$export$2e2bcd8739ae039 = Object.freeze($00e2e8ddd4e7f9a1$var$connector_details);


const $d0664f13764eff09$var$connectors = {
    page_title: "Łączniki",
    title: "Łączniki",
    subtitle: "Skonfiguruj łączniki, aby umożliwić bezhasłowe i społecznościowe logowanie",
    create: "Dodaj łącznik społecznościowy",
    config_sie_notice: "Ustawiono łączniki. Upewnij się, że skonfigurowałeś to w <a>{{link}}</a>.",
    config_sie_link_text: "doświadczenie logowania",
    tab_email_sms: "Łączniki e-mail i SMS",
    tab_social: "Łączniki społecznościowe",
    connector_name: "Nazwa łącznika",
    demo_tip: "Maksymalna liczba wiadomości dozwolona dla tego Łącznika demonstracyjnego wynosi 100 i nie jest zalecana do wdrożenia w środowisku produkcyjnym.",
    social_demo_tip: "Łącznik demonstracyjny został zaprojektowany wyłącznie dla cel\xf3w demonstracyjnych i nie jest zalecany do wdrożenia w środowisku produkcyjnym.",
    connector_type: "Typ",
    connector_status: "Doświadczenie logowania",
    connector_status_in_use: "W użyciu",
    connector_status_not_in_use: "Nie w użyciu",
    not_in_use_tip: {
        content: "Nie w użyciu oznacza, że Twoje doświadczenie logowania nie użyło tej metody logowania. <a>{{link}}</a> aby dodać tę metodę logowania.",
        go_to_sie: "Przejdź do doświadczenia logowania"
    },
    placeholder_title: "Łącznik społecznościowy",
    placeholder_description: "Logto dostarczył wiele powszechnie używanych łącznik\xf3w społecznościowych, tymczasem możesz utworzyć własne z wykorzystaniem standardowych protokoł\xf3w.",
    save_and_done: "Zapisz i zakończ",
    type: {
        email: "Łącznik e-mail",
        sms: "Łącznik SMS",
        social: "Łącznik społecznościowy"
    },
    setup_title: {
        email: "Skonfiguruj łącznik e-mail",
        sms: "Skonfiguruj łącznik SMS",
        social: "Dodaj łącznik społecznościowy"
    },
    guide: {
        subtitle: "Przewodnik krok po kroku do konfiguracji Twojego łącznika",
        general_setting: "Ustawienia og\xf3lne",
        parameter_configuration: "Konfiguracja parametr\xf3w",
        test_connection: "Testuj połączenie",
        name: "Nazwa przycisku logowania społecznościowego",
        name_placeholder: "Wpisz nazwę przycisku logowania społecznościowego",
        name_tip: 'Nazwa przycisku łącznika będzie wyświetlana jako "Kontynuuj z {{name}}." Uwzględnij długość nazwy, gdyż może stać się zbyt długa.',
        logo: "Logo URL łącznika społecznościowego",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Obraz logo zostanie wyświetlony na łączniku. Uzyskaj publicznie dostępny link do obrazu i wklej tutaj link.",
        logo_dark: "Logo URL łącznika społecznościowego (tryb ciemny)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Ustaw logo łącznika dla trybu ciemnego po jego włączeniu w Doświadczeniu logowania w Konsoli Admina.",
        logo_dark_collapse: "Zwiń",
        logo_dark_show: "Pokaż ustawienia logo dla trybu ciemnego",
        target: "Nazwa dostawcy tożsamości",
        target_placeholder: "Wpisz nazwę dostawcy tożsamości łącznika",
        target_tip: "Wartość „Nazwy dostawcy tożsamości” może być unikalnym ciągiem identyfikującym, kt\xf3ry odr\xf3żnia Twoje tożsamości społecznościowe.",
        target_tip_standard: "Wartość „Nazwy dostawcy tożsamości” może być unikalnym ciągiem identyfikującym, kt\xf3ry odr\xf3żnia Twoje tożsamości społecznościowe. Po utworzeniu łącznika nie możesz go zmienić.",
        target_tooltip: '„Nazwa dostawcy tożsamości” w łącznikach społecznościowych Logto odnosi się do "źr\xf3dła" Twoich tożsamości społecznościowych. W projektowaniu Logto nie akceptujemy tych samych „Nazw dostawc\xf3w tożsamości” konkretnej platformy, aby uniknąć konflikt\xf3w. Powinieneś bardzo uważać przed dodaniem łącznika, ponieważ NIE MOŻESZ zmienić jego wartości po utworzeniu. <a>Dowiedz się więcej</a>',
        target_conflict: "Wprowadzona nazwa IdP pasuje do istniejącego łącznika <span>nazwa</span>. Użycie tej samej nazwy IdP może spowodować nieoczekiwane zachowanie logowania, gdzie użytkownicy mogą uzyskać dostęp do tego samego konta za pośrednictwem dw\xf3ch r\xf3żnych łącznik\xf3w.",
        target_conflict_line2: "Jeśli chcesz zastąpić aktualny łącznik tym samym dostawcą tożsamości i umożliwić poprzednim użytkownikom logowanie bez rejestracji ponownie, usuń łącznik <span>nazwa</span> i utw\xf3rz nowy z tą samą „Nazwą dostawcy tożsamości”.",
        target_conflict_line3: "Jeśli chcesz połączyć się z innym dostawcą tożsamości, zmodyfikuj „Nazwę dostawcy tożsamości” i kontynuuj.",
        config: "Wprowadź sw\xf3j JSON konfiguracji",
        sync_profile: "Synchronizuj informacje profilowe",
        sync_profile_only_at_sign_up: "Synchronizuj tylko podczas rejestracji",
        sync_profile_each_sign_in: "Zawsze wykonaj synchronizację przy każdym logowaniu",
        sync_profile_tip: "Synchronizuje podstawowy profil z dostawcy usług społecznościowych, takie jak nazwy użytkownik\xf3w i ich awatary.",
        callback_uri: "URI zwrotu (Callback)",
        callback_uri_description: "Nazywany także URI przekierowania, to URI w Logto, do kt\xf3rego użytkownicy zostaną przesłani po autoryzacji społecznej; skopiuj i wklej na stronie konfiguracyjnej dostawcy usług społecznościowych."
    },
    platform: {
        universal: "Uniwersalny",
        web: "Web",
        native: "Natywny"
    },
    add_multi_platform: "obsługuje wiele platform, wybierz platformę, aby kontynuować",
    drawer_title: "Poradnik łącznika",
    drawer_subtitle: "Postępuj zgodnie z instrukcjami, aby zintegrować sw\xf3j łącznik",
    unknown: "Nieznany Łącznik",
    standard_connectors: "Standardowe łączniki"
};
var $d0664f13764eff09$export$2e2bcd8739ae039 = Object.freeze($d0664f13764eff09$var$connectors);


const $ac3f9edd3de74e76$var$contact = {
    title: "Zdobądź pomoc",
    description: "W przypadku żądań pomocy lub opinii na temat produktu, skontaktuj się z nami za pomocą następujących metod.",
    discord: {
        title: "Dołącz do społeczności Discord",
        description: "Połącz się z innymi deweloperami, aby znaleźć rozwiązania",
        button: "Dołącz"
    },
    github: {
        title: "Komunikuj się na GitHub",
        description: "Utw\xf3rz zgłoszenie i opublikuj na GitHub",
        button: "Otw\xf3rz"
    },
    email: {
        title: "Skontaktuj się z pomocą techniczną przez e-mail",
        description: "Wyślij do nas e-maila w celu uzyskania dalszych informacji i pomocy",
        button: "Wyślij"
    },
    reserve: {
        title: "Zarezerwuj sw\xf3j czas z zespołem Logto",
        description: "Szybko zarezerwuj sesję czatu na żywo",
        button: "Rezerwuj"
    }
};
var $ac3f9edd3de74e76$export$2e2bcd8739ae039 = Object.freeze($ac3f9edd3de74e76$var$contact);


const $49fd02d73eb60558$var$dashboard = {
    page_title: "Panel",
    title: "Panel",
    description: "Przegląd wydajności Twojej aplikacji",
    total_users: "Wszyscy użytkownicy",
    total_users_tip: "Wszyscy użytkownicy",
    new_users_today: "Nowi użytkownicy dzisiaj",
    new_users_today_tip: "Liczba nowych użytkownik\xf3w zarejestrowanych dzisiaj",
    new_users_7_days: "Nowi użytkownicy w ciągu ostatnich 7 dni",
    new_users_7_days_tip: "Liczba nowych użytkownik\xf3w zarejestrowanych w ciągu ostatnich 7 dni",
    daily_active_users: "Dziennie aktywni użytkownicy",
    daily_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji dziś",
    weekly_active_users: "Tygodniowo aktywni użytkownicy",
    weekly_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji w ciągu ostatnich 7 dni",
    monthly_active_users: "Miesięcznie aktywni użytkownicy",
    monthly_active_users_tip: "Liczba unikalnych użytkownik\xf3w wymieniających tokeny na Twojej aplikacji w ciągu ostatnich 30 dni"
};
var $49fd02d73eb60558$export$2e2bcd8739ae039 = Object.freeze($49fd02d73eb60558$var$dashboard);


const $b6a0e6c20eae40d2$var$domain = {
    status: {
        connecting: "Łączenie",
        in_used: "W użyciu",
        failed_to_connect: "Nieudane połączenie"
    },
    update_endpoint_notice: "Nie zapomnij zaktualizować domeny dla URI wywołania łącznika społecznego i punktu końcowego Logto w swojej aplikacji, jeśli chcesz używać niestandardowej domeny dla funkcji. <a>{{link}}</a>",
    error_hint: "Upewnij się, że zaktualizowałeś swoje rekordy DNS. Będziemy nadal sprawdzać co {{value}} sekund.",
    custom: {
        custom_domain: "Niestandardowa domena",
        custom_domain_description: "Ulepsz swoją markę, wykorzystując niestandardową domenę. Ta domena będzie używana w Twoim procesie logowania.",
        custom_domain_field: "Niestandardowa domena",
        custom_domain_placeholder: "twoja.domena.com",
        add_domain: "Dodaj domenę",
        invalid_domain_format: "Nieprawidłowy format poddomeny. Wprowadź poddomenę z co najmniej trzema elementami.",
        verify_domain: "Zweryfikuj domenę",
        enable_ssl: "Włącz SSL",
        checking_dns_tip: "Po skonfigurowaniu rekord\xf3w DNS proces zostanie uruchomiony automatycznie i może potrwać do 24 godzin. Możesz opuścić ten interfejs podczas jego działania.",
        enable_ssl_tip: "Włączenie SSL zostanie uruchomione automatycznie i może potrwać do 24 godzin. Możesz opuścić ten interfejs podczas jego działania.",
        generating_dns_records: "Generowanie rekord\xf3w DNS...",
        add_dns_records: "Dodaj te rekordy DNS do swojego dostawcy DNS.",
        dns_table: {
            type_field: "Typ",
            name_field: "Nazwa",
            value_field: "Wartość"
        },
        deletion: {
            delete_domain: "Usuń domenę",
            reminder: "Usuń niestandardową domenę",
            description: "Czy na pewno chcesz usunąć tę niestandardową domenę?",
            in_used_description: 'Czy na pewno chcesz usunąć tę niestandardową domenę "<span>{{domain}}</span>"?',
            in_used_tip: 'Jeśli wcześniej skonfigurowałeś tę niestandardową domenę w dostawcy łącznik\xf3w społecznościowych lub zakończeniu aplikacji, musisz najpierw zmodyfikować adres URI na domyślną domenę Logto "<span>{{domain}}</span>". Jest to niezbędne do poprawnego działania przycisku logowania społecznego.',
            deleted: "Niestandardowa domena została pomyślnie usunięta!"
        }
    },
    default: {
        default_domain: "Domyślna domena",
        default_domain_description: "Logto oferuje prekonfigurowaną domenę domyślną, gotową do użycia bez dodatkowej konfiguracji. Ta domyślna domena służy jako opcja zapasowa, nawet jeśli włączyłeś niestandardową domenę.",
        default_domain_field: "Domyślna domena Logto"
    },
    custom_endpoint_note: 'Możesz dostosować nazwę domeny tych punkt\xf3w końcowych według swoich wymagań. Wybierz "{{custom}}" lub "{{default}}".',
    custom_social_callback_url_note: 'Możesz dostosować nazwę domeny tego adresu URI, aby dopasować ją do punktu końcowego Twojej aplikacji. Wybierz "{{custom}}" lub "{{default}}".'
};
var $b6a0e6c20eae40d2$export$2e2bcd8739ae039 = Object.freeze($b6a0e6c20eae40d2$var$domain);


const $7df413902315b0c5$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $7df413902315b0c5$export$2e2bcd8739ae039 = Object.freeze($7df413902315b0c5$var$enterprise_sso_details);


const $f872d91bc67b04ad$var$enterprise_sso = {
    page_title: "Jednolite logowanie dla przedsiębiorstw",
    title: "Jednolite logowanie dla przedsiębiorstw",
    subtitle: "Połącz dostawcę tożsamości przedsiębiorstwa i włącz jednostronne logowanie jednolitego.",
    create: "Dodaj łącznik przedsiębiorstwa",
    col_connector_name: "Nazwa łącznika",
    col_type: "Typ",
    col_email_domain: "Domena e-mail",
    placeholder_title: "Łącznik przedsiębiorstwa",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Dodaj łącznik przedsiębiorstwa",
        text_divider: "Albo możesz dostosować sw\xf3j łącznik za pomocą standardowego protokołu.",
        connector_name_field_title: "Nazwa łącznika",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Stw\xf3rz łącznik"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $f872d91bc67b04ad$export$2e2bcd8739ae039 = Object.freeze($f872d91bc67b04ad$var$enterprise_sso);


const $6eba7727f9de19f9$var$errors = {
    something_went_wrong: "Ups! Coś poszło nie tak.",
    page_not_found: "Nie znaleziono strony",
    unknown_server_error: "Wystąpił nieznany błąd serwera",
    empty: "Brak danych",
    missing_total_number: "Nie można znaleźć wartości Total-Number w nagł\xf3wkach odpowiedzi",
    invalid_uri_format: "Nieprawidłowy format URI",
    invalid_origin_format: "Nieprawidłowy format pochodzenia URI",
    invalid_json_format: "Nieprawidłowy format JSON",
    invalid_error_message_format: "Nieprawidłowy format komunikatu błędu.",
    required_field_missing: "Wpisz {{field}}",
    required_field_missing_plural: "Musisz wprowadzić przynajmniej jeden {{field}}",
    more_details: "Więcej szczeg\xf3ł\xf3w",
    username_pattern_error: "Nazwa użytkownika powinna zawierać tylko litery, cyfry lub znak podkreślenia i nie powinna zaczynać się od cyfry.",
    email_pattern_error: "Adres e-mail jest nieprawidłowy.",
    phone_pattern_error: "Numer telefonu jest nieprawidłowy.",
    insecure_contexts: "Nieobsługiwane są niebezpieczne konteksty (non-HTTPS).",
    unexpected_error: "Wystąpił nieoczekiwany błąd.",
    not_found: "404 nie znaleziono",
    create_internal_role_violation: 'Tworzysz nową wewnętrzną rolę, co jest zabronione przez Logto. Spr\xf3buj użyć innego nazwy, kt\xf3ra nie zaczyna się od "#internal:".',
    should_be_an_integer: "Powinno być liczbą całkowitą.",
    number_should_be_between_inclusive: "Następnie liczba powinna być między {{min}} a {{max}} (włącznie)."
};
var $6eba7727f9de19f9$export$2e2bcd8739ae039 = Object.freeze($6eba7727f9de19f9$var$errors);


const $b57ca0ef90643653$var$general = {
    placeholder: "Miejsce na tekst",
    submit: "Wyślij",
    skip: "Pomiń",
    next: "Dalej",
    back: "Wstecz",
    retry: "Spr\xf3buj ponownie",
    done: "Gotowe",
    search: "Szukaj",
    search_placeholder: "Szukaj",
    clear_result: "Wyczyść Wyniki",
    save: "Zapisz",
    save_changes: "Zapisz zmiany",
    saved: "Zapisane",
    discard: "Porzuć",
    loading: "Trwa ładowanie...",
    redirecting: "Przekierowywanie...",
    add: "Dodaj",
    added: "Dodano",
    cancel: "Anuluj",
    confirm: "Potwierdź",
    check_out: "Zapłać i wyjdź",
    create: "Stw\xf3rz",
    set_up: "Skonfiguruj",
    customize: "Dostosuj",
    enable: "Włącz",
    reminder: "Przypomnienie",
    delete: "Usuń",
    more_options: "WIĘCEJ OPCJI",
    close: "Zamknij",
    copy: "Kopiuj",
    copying: "Kopiowanie",
    copied: "Skopiowano",
    required: "Wymagane",
    add_another: "Dodaj kolejny",
    create_another: "Stw\xf3rz kolejny",
    deletion_confirmation: "Czy na pewno chcesz usunąć {{title}}?",
    settings_nav: "Ustawienia",
    unsaved_changes_warning: "Wprowadzono zmiany. Czy na pewno chcesz opuścić tę stronę?",
    leave_page: "Opuść stronę",
    stay_on_page: "Pozostań na stronie",
    type_to_search: "Szukaj",
    got_it: "Zrozumiałe(a)m",
    continue: "Kontynuuj",
    page_info: "{{min, number}}-{{max, number}} z {{total, number}}",
    learn_more: "Dowiedz się więcej",
    tab_errors: "{{count, number}} błęd\xf3w",
    skip_for_now: "Pomiń na teraz",
    remove: "Usuń",
    visit: "Odwiedź",
    join: "Dołącz",
    try_now: "Wypr\xf3buj teraz",
    multiple_form_field: "(Wiele)",
    demo: "Demo",
    unnamed: "Bez nazwy",
    view: "Pokaż",
    hide: "Ukryj",
    unknown_error: "Nieznany błąd, spr\xf3buj ponownie p\xf3źniej.",
    select: "Wybierz",
    contact_us_action: "Skontaktuj się z nami",
    description: "Opis",
    name: "Nazwa",
    add_field: "Dodaj {{field}}",
    create_field: "Utw\xf3rz {{field}}",
    edit_field: "Edytuj {{field}}",
    delete_field: "Usuń {{field}}",
    coming_soon: "Wkr\xf3tce dostępne",
    beta_notice: "\uD83C\uDF89  {{feature}} znajduje się obecnie w fazie beta. Zapraszamy do jego eksploracji i <ContactLink>podzielenia się opinią</ContactLink>."
};
var $b57ca0ef90643653$export$2e2bcd8739ae039 = Object.freeze($b57ca0ef90643653$var$general);


const $167c33e080d57f9b$var$get_started = {
    page_title: "Rozpocznij",
    title: "Coś do odkrycia, aby pom\xf3c ci odnieść sukces",
    subtitle: "Kilka rzeczy, kt\xf3re możesz zrobić, aby szybko uzyskać wartość Logto",
    develop: {
        title: "Develop: Zajmie to 5 minut, aby zintegrować swoją aplikację"
    },
    customize: {
        title: "Customize: Dostarcz świetne doświadczenie logowania",
        preview: {
            title: "Sprawdź podgląd na żywo doświadczenia logowania, kt\xf3re właśnie spersonalizowałeś",
            subtitle: "Wypr\xf3buj teraz Logto, aby zobaczyć, jak działa"
        },
        connector: {
            title: "Dodaj więcej konektor\xf3w, aby obsługiwać r\xf3żne metody logowania społecznego",
            subtitle: "Wypr\xf3buj logowanie bez hasła i włącz bezpieczne i bezproblemowe doświadczenie dla swoich klient\xf3w"
        },
        continue_customizing: "Kontynuuj dostosowywanie",
        try_now: "Wypr\xf3buj teraz",
        add_more: "Dodaj więcej"
    },
    secure: {
        title: "Zabezpiecz: Chron swoje zasoby"
    },
    manage: {
        title: "Zarządzaj: Określ kontrolę dostępu do swojego produktu i użytkownik\xf3w",
        rbac: {
            title: "Dodaj oparte na rolach zarządzanie dostępem, aby chronić swoje zasoby",
            subtitle: "Kontroluj swoje zasoby za pomocą skalowalnej autoryzacji opartej na rolach dla r\xf3żnych przypadk\xf3w użycia"
        },
        create_roles: "Tw\xf3rz role"
    },
    view_all: "Zobacz wszystkie →"
};
var $167c33e080d57f9b$export$2e2bcd8739ae039 = Object.freeze($167c33e080d57f9b$var$get_started);


const $3620e2c1b4cedef0$var$guide = {
    start_building: "Rozpocznij budowanie",
    get_started: "Zacznij teraz",
    categories: {
        featured: "Popularne i dla Ciebie",
        Traditional: "Tradycyjna aplikacja internetowa",
        SPA: "Aplikacja na jednej stronie",
        Native: "Natywna",
        MachineToMachine: "Maszyna-do-maszyny"
    },
    filter: {
        title: "Filtr Framework",
        placeholder: "Szukaj framework"
    },
    checkout_tutorial: "Sprawdź samouczek {{name}}",
    do_not_need_tutorial: "Jeśli nie potrzebujesz samouczka, możesz kontynuować bez przewodnika frameworku",
    finish_and_done: "Zakończ i zrobione",
    cannot_find_guide: "Nie mogę znaleźć przewodnika?",
    describe_guide_looking_for: "Opisz przewodnik, kt\xf3rego szukasz",
    request_guide_successfully: "Twoje zgłoszenie zostało pomyślnie przesłane. Dziękujemy!",
    app: {
        select_framework_or_tutorial: "Wybierz framework lub samouczek",
        guide_modal_title: "Zacznij z SDK i przewodnikami",
        modal_subtitle: "Przyspiesz sw\xf3j proces rozwoju aplikacji za pomocą naszych prezentacji SDK i samouczk\xf3w.",
        select_a_framework: "Wybierz framework",
        continue_without_framework: "Utw\xf3rz aplikację bez frameworku",
        describe_guide_looking_for_placeholder: "Na przykład, chcę zintegrować Logto z moją aplikacją Angular."
    },
    api: {
        modal_title: "Zacznij od samouczk\xf3w",
        modal_subtitle: "Przyspiesz sw\xf3j proces rozwoju aplikacji za pomocą naszych prezentacji samouczk\xf3w.",
        select_a_tutorial: "Wybierz samouczek",
        continue_without_tutorial: "Kontynuuj bez samouczka",
        describe_guide_looking_for_placeholder: "Na przykład, chcę chronić moje API przy użyciu deno."
    }
};
var $3620e2c1b4cedef0$export$2e2bcd8739ae039 = Object.freeze($3620e2c1b4cedef0$var$guide);


const $8b2f5f8d64a6e55c$var$log_details = {
    page_title: "Szczeg\xf3ły dziennika audytu",
    back_to_logs: "Powr\xf3ć do dziennika audytu",
    back_to: "Powr\xf3ć do {{name}}",
    success: "Sukces",
    failed: "Niepowodzenie",
    event_key: "Klucz zdarzenia",
    application: "Aplikacja",
    ip_address: "Adres IP",
    user: "Użytkownik",
    log_id: "ID dziennika",
    time: "Czas",
    user_agent: "Użytkownik agent",
    tab_details: "Szczeg\xf3ły",
    raw_data: "Surowe dane"
};
var $8b2f5f8d64a6e55c$export$2e2bcd8739ae039 = Object.freeze($8b2f5f8d64a6e55c$var$log_details);


const $9d76a0e4c8b81b24$var$logs = {
    page_title: "Dziennik audytu",
    title: "Dziennik audytu",
    subtitle: "Wyświetl dane dziennika dotyczące zdarzeń uwierzytelnienia dokonywanych przez Twoich użytkownik\xf3w",
    event: "Zdarzenie",
    user: "Użytkownik",
    application: "Aplikacja",
    time: "Czas",
    filter_by: "Filtruj według"
};
var $9d76a0e4c8b81b24$export$2e2bcd8739ae039 = Object.freeze($9d76a0e4c8b81b24$var$logs);


const $3798973e49af3b2e$var$menu = {
    profile: "Profil",
    language: "Język",
    appearance: {
        label: "Wygląd",
        light: "Tryb jasny",
        dark: "Tryb ciemny",
        system: "Synchronizuj z systemem"
    },
    sign_out: "Wyloguj się"
};
var $3798973e49af3b2e$export$2e2bcd8739ae039 = Object.freeze($3798973e49af3b2e$var$menu);


const $4e3a88741cb834cc$var$mfa = {
    title: "Wielopoziomowe uwierzytelnianie",
    description: "Dodaj wielopoziomowe uwierzytelnianie, aby zwiększyć bezpieczeństwo swojego doświadczenia z logowaniem.",
    factors: "Czynniki",
    multi_factors: "Wieloczynniki",
    multi_factors_description: "Użytkownicy muszą zweryfikować jeden z włączonych czynnik\xf3w podczas dwustopniowej weryfikacji.",
    totp: "Aplikacja autentykacyjna OTP",
    otp_description: "Połącz Google Authenticator itp., aby zweryfikować jednorazowe hasła.",
    webauthn: "WebAuthn (Klucz przechodni)",
    webauthn_description: "Zweryfikuj za pomocą metody obsługiwanej przez przeglądarkę: biometria, skanowanie telefonem lub klucz zabezpieczeń, itp.",
    webauthn_native_tip: "WebAuthn nie jest obsługiwane dla aplikacji natywnych.",
    webauthn_domain_tip: "WebAuthn łączy klucze publiczne z konkretną domeną. Modyfikacja domeny usługi zablokuje użytkownik\xf3w przed uwierzytelnianiem za pomocą istniejących kluczy przechodnich.",
    backup_code: "Kod zapasowy",
    backup_code_description: "Generuj 10 jednorazowych kod\xf3w zapasowych po skonfigurowaniu dowolnej metody MFA przez użytkownik\xf3w.",
    backup_code_setup_hint: "Gdy użytkownicy nie mogą zweryfikować powyższych czynnik\xf3w MFA, skorzystaj z opcji kopii zapasowej.",
    backup_code_error_hint: "Aby użyć kodu zapasowego, potrzebujesz co najmniej jednej kolejnej metody MFA do pomyślnego uwierzytelniania użytkownika.",
    policy: "Polityka",
    policy_description: "Ustaw politykę MFA dla proces\xf3w logowania i rejestracji.",
    two_step_sign_in_policy: "Polityka weryfikacji dwuetapowej podczas logowania",
    user_controlled: "Użytkownicy mogą samodzielnie włączać lub wyłączać MFA",
    user_controlled_tip: "Użytkownicy mogą pominąć konfigurację MFA podczas pierwszego logowania lub rejestracji lub włączyć/wyłączyć ją w ustawieniach konta.",
    mandatory: "Użytkownicy zawsze muszą korzystać z MFA podczas logowania",
    mandatory_tip: "Użytkownicy muszą skonfigurować MFA podczas pierwszego logowania lub rejestracji i używać go przy każdym kolejnym logowaniu."
};
var $4e3a88741cb834cc$export$2e2bcd8739ae039 = Object.freeze($4e3a88741cb834cc$var$mfa);


const $de6a14a0c480b424$var$organization_details = {
    page_title: "Szczeg\xf3ły organizacji",
    delete_confirmation: "Po usunięciu wszyscy członkowie stracą swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.",
    organization_id: "ID organizacji",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Nazwa organizacji, nie musi być unikalna.",
    description_placeholder: "Opis organizacji.",
    member: "Członek",
    member_other: "Członkowie",
    add_members_to_organization: "Dodaj członk\xf3w do organizacji {{name}}",
    add_members_to_organization_description: "Znajdź odpowiednich użytkownik\xf3w, wyszukując nazwę, adres e-mail, numer telefonu lub identyfikator użytkownika. Istniejący członkowie nie są wyświetlani w wynikach wyszukiwania.",
    add_with_organization_role: "Dodaj z rolą(ami) organizacji",
    user: "Użytkownik",
    authorize_to_roles: "Autoryzuj {{name}} dostęp do następujących r\xf3l:",
    edit_organization_roles: "Edytuj role organizacji",
    edit_organization_roles_of_user: "Edytuj role organizacji użytkownika {{name}}",
    remove_user_from_organization: "Usuń użytkownika z organizacji",
    remove_user_from_organization_description: "Po usunięciu użytkownik straci swoje członkostwo i role w tej organizacji. Tego działania nie można cofnąć.",
    search_user_placeholder: "Wyszukaj według nazwy, adresu e-mail, numeru telefonu lub identyfikatora użytkownika",
    at_least_one_user: "Wymagany jest co najmniej jeden użytkownik."
};
var $de6a14a0c480b424$export$2e2bcd8739ae039 = Object.freeze($de6a14a0c480b424$var$organization_details);


const $b625cb742774fcac$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organizacje",
    title: "Organizacje",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID organizacji",
    members: "Członkowie",
    create_organization: "Utw\xf3rz organizację",
    setup_organization: "Skonfiguruj swoją organizację",
    organization_list_placeholder_title: "Organizacja",
    organization_list_placeholder_text: "Organizacja jest zazwyczaj stosowana w aplikacjach wielomandantowych typu SaaS lub podobnych. Funkcja organizacji umożliwia klientom B2B lepsze zarządzanie swoimi partnerami i klientami oraz dostosowywanie sposob\xf3w, w jakie końcowi użytkownicy mają dostęp do ich aplikacji.",
    organization_name_placeholder: "Moja organizacja",
    organization_description_placeholder: "Kr\xf3tki opis organizacji",
    organization_permission: "Uprawnienie organizacji",
    organization_permission_other: "Uprawnienia organizacji",
    organization_permission_description: "Uprawnienie organizacji odnosi się do autoryzacji dostępu do zasobu w kontekście organizacji. Uprawnienie organizacji powinno być reprezentowane jako znaczący ciąg znak\xf3w, stanowiący także nazwę i unikalny identyfikator.",
    organization_permission_delete_confirm: "Jeśli to uprawnienie zostanie usunięte, wszystkie role organizacji, w tym to uprawnienie, stracą to uprawnienie, a użytkownicy, kt\xf3rzy mieli to uprawnienie, stracą dostęp do niego.",
    create_permission_placeholder: "Odczyt historii spotkań",
    permission: "Uprawnienie",
    permission_other: "Uprawnienia",
    organization_role: "Rola organizacji",
    organization_role_other: "Role organizacji",
    organization_role_description: "Rola organizacji to grupowanie uprawnień, kt\xf3re można przypisać użytkownikom. Uprawnienia muszą pochodzić z wcześniej zdefiniowanych uprawnień organizacji.",
    organization_role_delete_confirm: "Spowoduje to usunięcie uprawnień związanych z tą rolą od dotkniętych użytkownik\xf3w oraz usunięcie relacji między rolami organizacji, członkami organizacji i uprawnieniami organizacji.",
    role: "Rola",
    create_role_placeholder: "Użytkownicy z uprawnieniami tylko do odczytu",
    search_placeholder: "Wyszukaj według nazwy lub ID organizacji",
    search_permission_placeholder: "Wpisz, aby wyszukać i wybrać uprawnienia",
    search_role_placeholder: "Wpisz, aby wyszukać i wybrać role",
    empty_placeholder: "\uD83E\uDD14 Nie masz jeszcze ustawionego żadnego {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Zacznij od przewodnik\xf3w",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Wejdź w interakcję z ilustracją, aby zobaczyć, jak wszystko się łączy",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Krok 1: Zdefiniuj uprawnienia organizacji",
        step_2: "Krok 2: Zdefiniuj role organizacji",
        step_3: "Krok 3: Utw\xf3rz swoją pierwszą organizację",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $b625cb742774fcac$export$2e2bcd8739ae039 = Object.freeze($b625cb742774fcac$var$organizations);


const $6aac581287e25907$var$permissions = {
    search_placeholder: "Szukaj według API lub nazwy uprawnienia",
    search_placeholder_without_api: "Szukaj według nazwy uprawnienia",
    name_column: "Uprawnienie",
    description_column: "Opis",
    api_column: "API",
    placeholder_title: "Uprawnienie",
    placeholder_description: "Uprawnienie odnosi się do autoryzacji dostępu do zasobu (nazywamy go zasobem API)."
};
var $6aac581287e25907$export$2e2bcd8739ae039 = Object.freeze($6aac581287e25907$var$permissions);


const $fd17f9146bd0dff8$var$profile = {
    page_title: "Ustawienia konta",
    title: "Ustawienia konta",
    description: "Zmień swoje ustawienia konta i zarządzaj swoimi danymi osobistymi tutaj, aby zapewnić bezpieczeństwo Twojego konta.",
    settings: {
        title: "USTAWIENIA PROFILU",
        profile_information: "Informacje o profilu",
        avatar: "Awatar",
        name: "Nazwa",
        username: "Nazwa użytkownika"
    },
    link_account: {
        title: "POŁĄCZ KONTO",
        email_sign_in: "Zaloguj się przez e-mail",
        email: "Email",
        social_sign_in: "Zaloguj się przez media społecznościowe",
        link_email: "Połącz email",
        link_email_subtitle: "Połącz sw\xf3j email, aby się zalogować lub pom\xf3c w odzyskiwaniu konta.",
        email_required: "Email jest wymagany",
        invalid_email: "Nieprawidłowy adres email",
        identical_email_address: "Adres email jest taki sam jak obecny",
        anonymous: "Anonimowy"
    },
    password: {
        title: "HASŁO I BEZPIECZEŃSTWO",
        password: "Hasło",
        password_setting: "Ustawienia hasła",
        new_password: "Nowe hasło",
        confirm_password: "Potwierdź hasło",
        enter_password: "Wprowadź obecne hasło",
        enter_password_subtitle: "Zweryfikuj swoją tożsamość, aby chronić bezpieczeństwo swojego konta. Przed zmianą proszę wprowadzić swoje aktualne hasło.",
        set_password: "Ustaw hasło",
        verify_via_password: "Zweryfikuj za pomocą hasła",
        show_password: "Pokaż hasło",
        required: "Hasło jest wymagane",
        do_not_match: "Hasła nie pasują do siebie. Spr\xf3buj ponownie."
    },
    code: {
        enter_verification_code: "Wprowadź kod weryfikacyjny",
        enter_verification_code_subtitle: "Kod weryfikacyjny został wysłany na adres <strong>{{target}}</strong>",
        verify_via_code: "Zweryfikuj za pomocą kodu weryfikacyjnego",
        resend: "Wyślij ponownie kod weryfikacyjny",
        resend_countdown: "Wyślij ponownie za {{countdown}} sekund"
    },
    delete_account: {
        title: "USUŃ KONTO",
        label: "Usuń konto",
        description: "Usunięcie twojego konta spowoduje usunięcie wszystkich twoich danych osobistych, danych użytkownika i konfiguracji. Ta operacja nie może być cofnięta.",
        button: "Usuń konto",
        dialog_paragraph_1: "Żałujemy, że chcesz usunąć swoje konto. Usunięcie twojego konta spowoduje trwałe usunięcie wszystkich danych, w tym informacji o użytkowniku, log\xf3w i ustawień, i ta operacja nie może być cofnięta. Przed dokonaniem tej operacji zalecamy wykonanie kopii zapasowych ważnych danych.",
        dialog_paragraph_2: 'Aby przejść do procesu usuwania konta, wyślij email do naszego zespołu wsparcia na adres <a>{{mail}}</a> z tematem "Żądanie usunięcia konta". Pomożemy Ci i zapewnimy, że wszystkie twoje dane zostaną poprawnie usunięte z naszego systemu.',
        dialog_paragraph_3: "Dziękujemy za wybranie chmury Logto. Jeśli masz jakieś dodatkowe pytania lub wątpliwości, skontaktuj się z nami."
    },
    set: "Ustaw",
    change: "Zmień",
    link: "Połącz",
    unlink: "Odłącz",
    not_set: "Nie ustawione",
    change_avatar: "Zmień awatar",
    change_name: "Zmień nazwę",
    change_username: "Zmień nazwę użytkownika",
    set_name: "Ustaw nazwę",
    email_changed: "Adres email został zmieniony.",
    password_changed: "Hasło zostało zmienione.",
    updated: "{{target}} zaktualizowane.",
    linked: "{{target}} połączone.",
    unlinked: "{{target}} rozłączone.",
    email_exists_reminder: "Ten adres e-mail {{email}} jest powiązany z istniejącym kontem. Połącz inny e-mail tutaj.",
    unlink_confirm_text: "Tak, odłącz",
    unlink_reminder: "Użytkownicy nie będą mogli się zalogować z kontem <span></span>, jeśli je odłączysz. Czy na pewno chcesz kontynuować?"
};
var $fd17f9146bd0dff8$export$2e2bcd8739ae039 = Object.freeze($fd17f9146bd0dff8$var$profile);


const $a81f0447034f6fc4$var$role_details = {
    back_to_roles: "Powr\xf3t do r\xf3l",
    identifier: "Identyfikator",
    delete_description: "Usunięcie tej roli usunie uprawnienia z nią związane od użytkownik\xf3w i usunie odwzorowanie między rolami, użytkownikami i uprawnieniami.",
    role_deleted: "{{name}} został pomyślnie usunięty.",
    settings_tab: "Ustawienia",
    users_tab: "Użytkownicy",
    m2m_apps_tab: "Maszyny do maszyn",
    permissions_tab: "Uprawnienia",
    settings: "Ustawienia",
    settings_description: "Role to grupowanie uprawnień, kt\xf3re mogą być przypisywane do użytkownik\xf3w. Zapewniają r\xf3wnież spos\xf3b agregacji uprawnień zdefiniowanych dla r\xf3żnych interfejs\xf3w API, co umożliwia bardziej efektywne dodawanie, usuwanie lub modyfikowanie uprawnień w por\xf3wnaniu z przypisywaniem ich do użytkownik\xf3w indywidualnie.",
    field_name: "Nazwa",
    field_description: "Opis",
    type_m2m_role_tag: "Rola aplikacji maszynowych",
    type_user_role_tag: "Rola użytkownika",
    permission: {
        assign_button: "Przypisz uprawnienia",
        assign_title: "Przypisz uprawnienia",
        assign_subtitle: "Przypisz uprawnienia do tej roli. Rola zyska dodane uprawnienia, a użytkownicy z tą rolą odziedziczą te uprawnienia.",
        assign_form_field: "Przypisz uprawnienia",
        added_text_one: "{{count, number}} uprawnienie dodane",
        added_text_other: "{{count, number}} uprawnień dodanych",
        api_permission_count_one: "{{count, number}} uprawnienie",
        api_permission_count_other: "{{count, number}} uprawnień",
        confirm_assign: "Przypisz uprawnienia",
        permission_assigned: "Wybrane uprawnienia zostały pomyślnie przypisane do tej roli",
        deletion_description: "Jeśli to uprawnienie zostanie usunięte, dotknięty użytkownik z tą rolą straci dostęp przyznany przez to uprawnienie.",
        permission_deleted: 'Uprawnienie "{{name}}" zostało pomyślnie usunięte z tej roli',
        empty: "Brak dostępnych uprawnień"
    },
    users: {
        assign_button: "Przydziel użytkownik\xf3w",
        name_column: "Użytkownik",
        app_column: "Aplikacja",
        latest_sign_in_column: "Ostatnie logowanie",
        delete_description: "Osoba pozostanie w bazie użytkownik\xf3w, ale straci autoryzację dla tej roli.",
        deleted: "{{name}} został pomyślnie usunięty z tej roli",
        assign_title: "Przydziel użytkownik\xf3w",
        assign_subtitle: "Przydziel użytkownik\xf3w do tej roli. Znajdź odpowiednich użytkownik\xf3w, wyszukując po nazwie, adresie e-mail, numerze telefonu lub identyfikatorze użytkownika.",
        assign_field: "Przydziel użytkownik\xf3w",
        confirm_assign: "Przydziel użytkownik\xf3w",
        assigned_toast_text: "Wybrani użytkownicy zostali pomyślnie przydzieleni do tej roli",
        empty: "Brak dostępnych użytkownik\xf3w"
    },
    applications: {
        assign_button: "Przypisz aplikacje",
        name_column: "Aplikacja",
        app_column: "Aplikacje",
        description_column: "Opis",
        delete_description: "Aplikacja pozostanie w puli Twoich aplikacji, ale utraci autoryzację dla tej roli.",
        deleted: "{{name}} został pomyślnie usunięty z tej roli",
        assign_title: "Przypisz aplikacje",
        assign_subtitle: "Przypisz aplikacje do tej roli. Znajdź odpowiednie aplikacje, wyszukując po nazwie, opisie lub identyfikatorze aplikacji.",
        assign_field: "Przypisz aplikacje",
        confirm_assign: "Przypisz aplikacje",
        assigned_toast_text: "Wybrane aplikacje zostały pomyślnie przypisane do tej roli",
        empty: "Brak dostępnych aplikacji"
    }
};
var $a81f0447034f6fc4$export$2e2bcd8739ae039 = Object.freeze($a81f0447034f6fc4$var$role_details);


const $7b3867ca8a653f47$var$roles = {
    page_title: "Rola",
    title: "Rola",
    subtitle: "Rola zawiera uprawnienia określające, co użytkownik może robić. RBAC wykorzystuje role do udostępniania użytkownikom zasob\xf3w do określonych działań.",
    create: "Utw\xf3rz rolę",
    role_name: "Nazwa roli",
    role_type: "Typ roli",
    show_role_type_button_text: "Pokaż więcej opcji",
    hide_role_type_button_text: "Ukryj więcej opcji",
    type_user: "Rola użytkownika",
    type_machine_to_machine: "Rola aplikacji Machine-to-Machine",
    role_description: "Opis",
    role_name_placeholder: "Wprowadź nazwę swojej roli",
    role_description_placeholder: "Wprowadź opis swojej roli",
    col_roles: "Role",
    col_type: "Typ",
    col_description: "Opis",
    col_assigned_entities: "Przypisane",
    user_counts: "{{count}} użytkownicy",
    application_counts: "{{count}} aplikacje",
    user_count: "{{count}} użytkownik",
    application_count: "{{count}} aplikacja",
    assign_permissions: "Przypisz uprawnienia",
    create_role_title: "Utw\xf3rz rolę",
    create_role_description: "Utw\xf3rz i zarządzaj rolami dla swoich aplikacji. Role zawierają zbiory uprawnień i mogą być przypisywane użytkownikom.",
    create_role_button: "Utw\xf3rz rolę",
    role_created: "Rola {{name}} została pomyślnie utworzona.",
    search: "Wyszukaj po nazwie roli, opisie lub identyfikatorze",
    placeholder_title: "Role",
    placeholder_description: "Role są grupowaniem uprawnień, kt\xf3re mogą być przypisywane użytkownikom. Upewnij się, że najpierw dodasz uprawnienie, zanim utworzysz role."
};
var $7b3867ca8a653f47$export$2e2bcd8739ae039 = Object.freeze($7b3867ca8a653f47$var$roles);


const $42ba5ab84dd52ddd$var$session_expired = {
    title: "Sesja wygasła",
    subtitle: "Twoja sesja mogła wygasnąć i zostałeś odłączony. Kliknij poniższy przycisk, aby ponownie się zalogować do konsoli administracyjnej.",
    button: "Zaloguj się ponownie"
};
var $42ba5ab84dd52ddd$export$2e2bcd8739ae039 = Object.freeze($42ba5ab84dd52ddd$var$session_expired);


const $31a9d24291085f92$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $31a9d24291085f92$export$2e2bcd8739ae039 = Object.freeze($31a9d24291085f92$var$content);


const $f08372735b3a9a5e$var$password_policy = {
    password_requirements: "Wymagania dotyczące hasła",
    minimum_length: "Minimalna długość",
    minimum_length_description: "NIST sugeruje użycie <a>co najmniej 8 znak\xf3w</a> dla produkt\xf3w internetowych.",
    minimum_length_error: "Minimalna długość musi wynosić od {{min}} do {{max}} (włącznie).",
    minimum_required_char_types: "Minimalna liczba wymaganych typ\xf3w znak\xf3w",
    minimum_required_char_types_description: "Typy znak\xf3w: wielkie litery (A-Z), małe litery (a-z), cyfry (0-9) i znaki specjalne ({{symbols}}).",
    password_rejection: "Odrzucanie hasła",
    compromised_passwords: "Odrzucaj skompromitowane hasła",
    breached_passwords: "Odrzucaj naruszone hasła",
    breached_passwords_description: "Odrzucaj hasła, kt\xf3re wcześniej zostały znalezione w bazach naruszeń.",
    restricted_phrases: "Ogranicz niskie zabezpieczenia",
    restricted_phrases_tooltip: "Twoje hasło powinno omijać te frazy, chyba że zestawisz je z 3 lub więcej dodatkowymi znakami.",
    repetitive_or_sequential_characters: "Powtarzające się lub sekwencyjne znaki",
    repetitive_or_sequential_characters_description: 'Na przykład "AAAA", "1234" i "abcd".',
    user_information: "Informacje użytkownika",
    user_information_description: "Na przykład adres e-mail, numer telefonu, nazwa użytkownika itp.",
    custom_words: "Niestandardowe słowa",
    custom_words_description: "Słowa kontekstowe, niezależne od wielkości liter, jeden na linię.",
    custom_words_placeholder: "Nazwa twojej usługi, nazwa firmy itp."
};
var $f08372735b3a9a5e$export$2e2bcd8739ae039 = Object.freeze($f08372735b3a9a5e$var$password_policy);


const $d909de95c4d33480$var$sign_up_and_sign_in = {
    identifiers_email: "Adres e-mail",
    identifiers_phone: "Numer telefonu",
    identifiers_username: "Nazwa użytkownika",
    identifiers_email_or_sms: "Adres e-mail lub numer telefonu",
    identifiers_none: "Nie dotyczy",
    and: "i",
    or: "lub",
    sign_up: {
        title: "REJESTRACJA",
        sign_up_identifier: "Identyfikator rejestracji",
        identifier_description: "Identyfikator rejestracji jest wymagany do utworzenia konta i musi być uwzględniony na ekranie logowania.",
        sign_up_authentication: "Ustawienia uwierzytelniania dla rejestracji",
        authentication_description: "Wszystkie wybrane czynności będą obowiązkowe dla użytkownik\xf3w, aby ukończyć proces rejestracji.",
        set_a_password_option: "Utw\xf3rz hasło",
        verify_at_sign_up_option: "Weryfikuj podczas rejestracji",
        social_only_creation_description: "(Stosuje się tylko do tworzenia kont społecznościowych)"
    },
    sign_in: {
        title: "LOGOWANIE",
        sign_in_identifier_and_auth: "Identyfikator i ustawienia uwierzytelniania dla logowania",
        description: "Użytkownicy mogą się zalogować za pomocą dowolnej dostępnej opcji. Dostosuj układ, przeciągając i upuszczając poniżej opcji.",
        add_sign_in_method: "Dodaj metodę logowania",
        password_auth: "Hasło",
        verification_code_auth: "Kod weryfikacyjny",
        auth_swap_tip: "Zamień poniższe opcje, aby określić, kt\xf3ra pojawia się jako pierwsza w procesie.",
        require_auth_factor: "Musisz wybrać co najmniej jeden czynnik uwierzytelniający."
    },
    social_sign_in: {
        title: "LOGOWANIE SPOŁECZNOŚCIOWE",
        social_sign_in: "Logowanie społecznościowe",
        description: "W zależności od obowiązkowego identyfikatora, kt\xf3rego ustawisz, użytkownik może zostać poproszony o podanie identyfikatora podczas rejestracji za pośrednictwem łącznika społecznościowego.",
        add_social_connector: "Dodaj łącznik społecznościowy",
        set_up_hint: {
            not_in_list: "Nie ma na liście?",
            set_up_more: "Ustaw",
            go_to: "inne łączniki społecznościowe teraz."
        }
    },
    tip: {
        set_a_password: "Unikatowe hasło dla nazwy użytkownika jest konieczne.",
        verify_at_sign_up: "Obecnie obsługujemy tylko weryfikowany adres e-mail. Twoja baza użytkownik\xf3w może zawierać dużą liczbę adres\xf3w e-mail niskiej jakości, jeśli nie dokonasz walidacji.",
        password_auth: "Jest to istotne, ponieważ umożliwiłeś opcję tworzenia hasła podczas procesu rejestracji.",
        verification_code_auth: "Jest to istotne, ponieważ umożliwiłeś wyłącznie opcję podania kodu weryfikacyjnego podczas rejestracji. Możesz odznaczyć pole wyboru, gdy dozwolone jest ustawienie hasła podczas procesu rejestracji.",
        delete_sign_in_method: "Jest to istotne, ponieważ wybrałeś {{identifier}} jako wymagany identyfikator."
    },
    advanced_options: {
        title: "USTAWIENIA ZAAWANSOWANE",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Włącz rejestrację użytkownik\xf3w",
        enable_user_registration_description: "Włącz lub wyłącz rejestrację użytkownik\xf3w. Po wyłączeniu użytkownicy nadal mogą być dodawani w konsoli administratora, ale nie mogą już zakładać kont za pomocą interfejsu logowania."
    }
};
var $d909de95c4d33480$export$2e2bcd8739ae039 = Object.freeze($d909de95c4d33480$var$sign_up_and_sign_in);


const $190567da0a2cdc03$var$sign_in_exp = {
    page_title: "Doświadczenie logowania",
    title: "Doświadczenie logowania",
    description: "Dostosuj interfejs logowania, aby pasował do Twojej marki i wyświetlaj w czasie rzeczywistym",
    tabs: {
        branding: "Marka",
        sign_up_and_sign_in: "Rejestracja i logowanie",
        content: "Treść",
        password_policy: "Polityka hasła"
    },
    welcome: {
        title: "Dostosuj swoje doświadczenie logowania",
        description: "Szybkie uruchomienie Twojego pierwszego logowania. Ten przewodnik po krokach przeprowadzi Cię przez wszystkie niezbędne ustawienia.",
        get_started: "Rozpocznij",
        apply_remind: "Należy pamiętać, że doświadczenie logowania będzie stosowane do wszystkich aplikacji w tej sekcji."
    },
    color: {
        title: "KOLOR",
        primary_color: "Kolor marki",
        dark_primary_color: "Kolor marki (ciemny)",
        dark_mode: "Włącz tryb ciemny",
        dark_mode_description: "Twoja aplikacja będzie miała automatycznie wygenerowany szablon trybu ciemnego na podstawie koloru marki i algorytmu Logto. Możesz go swobodnie dostosować.",
        dark_mode_reset_tip: "Przelicz kolor trybu ciemnego na podstawie koloru marki.",
        reset: "Przelicz"
    },
    branding: {
        title: "OPCJE BRANDINGU",
        ui_style: "Styl",
        favicon: "Favicon",
        logo_image_url: "Adres URL obrazka logo aplikacji",
        logo_image_url_placeholder: "https://twoja.domena.cdn/logo.png",
        dark_logo_image_url: "Adres URL obrazka logo aplikacji (Ciemny)",
        dark_logo_image_url_placeholder: "https://twoja.domena.cdn/logo-ciemny.png",
        logo_image: "Logo aplikacji",
        dark_logo_image: "Logo aplikacji (Ciemny)",
        logo_image_error: "Logo aplikacji: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "Niestandardowe CSS",
        css_code_editor_title: "Dostosuj sw\xf3j interfejs użytkownika niestandardowym CSS",
        css_code_editor_description1: "Zobacz przykład niestandardowego CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Dowiedz się więcej",
        css_code_editor_content_placeholder: "Wprowadź swoje niestandardowe CSS, aby dostosować style czegokolwiek do swoich dokładnych specyfikacji. Wyraź swoją kreatywność i wyr\xf3żnij sw\xf3j interfejs użytkownika."
    },
    sign_up_and_sign_in: $d909de95c4d33480$export$2e2bcd8739ae039,
    content: $31a9d24291085f92$export$2e2bcd8739ae039,
    password_policy: $f08372735b3a9a5e$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "Nie ustawiono jeszcze łącznika SMS. Przed zakończeniem konfiguracji użytkownicy nie będą mogli się zalogować przy użyciu tej metody. <a>{{link}}</a> w sekcji „Łączniki“",
        no_connector_email: "Nie ustawiono jeszcze łącznika e-mail. Przed zakończeniem konfiguracji użytkownicy nie będą mogli się zalogować przy użyciu tej metody. <a>{{link}}</a> w sekcji „Łączniki“",
        no_connector_social: 'Nie skonfigurowałeś jeszcze żadnego konektora społecznościowego. Najpierw dodaj konektory, aby zastosować metody logowania społecznościowego. <a>{{link}}</a> w "Konektory".',
        setup_link: "Konfiguracja"
    },
    save_alert: {
        description: "Wdrażasz nowe procedury logowania i rejestracji. Wszyscy Twoi użytkownicy mogą być dotknięci nową konfiguracją. Czy na pewno zdecydowałeś się na zmiany?",
        before: "Przed",
        after: "Po",
        sign_up: "Rejestracja",
        sign_in: "Logowanie",
        social: "Społecznościowy"
    },
    preview: {
        title: "Podgląd logowania",
        live_preview: "Podgląd na żywo",
        live_preview_tip: "Zapisz, aby obejrzeć zmiany",
        native: "Aplikacja natywna",
        desktop_web: "Wersja desktopowa",
        mobile_web: "Wersja mobilna",
        desktop: "Komputer",
        mobile: "Telefon"
    }
};
var $190567da0a2cdc03$export$2e2bcd8739ae039 = Object.freeze($190567da0a2cdc03$var$sign_in_exp);


const $22897cfbb677e742$var$quota_item = {
    tenant_limit: {
        name: "Liczba Najemc\xf3w",
        limited: "{{count, number}} najemca",
        limited_other: "{{count, number}} najemcy",
        unlimited: "Nieograniczona liczba najemc\xf3w",
        not_eligible: "Usuń swoich najemc\xf3w"
    },
    mau_limit: {
        name: "Miesięczna liczba aktywnych użytkownik\xf3w",
        limited: "{{count, number}} MAU",
        unlimited: "Nieograniczona liczba MAU",
        not_eligible: "Usuń wszystkich użytkownik\xf3w"
    },
    applications_limit: {
        name: "Liczba aplikacji",
        limited: "{{count, number}} aplikacja",
        limited_other: "{{count, number}} aplikacje",
        unlimited: "Nieograniczona liczba aplikacji",
        not_eligible: "Usuń swoje aplikacje"
    },
    machine_to_machine_limit: {
        name: "Machine to machine",
        limited: "{{count, number}} aplikacja machine to machine",
        limited_other: "{{count, number}} aplikacje machine to machine",
        unlimited: "Nieograniczona liczba aplikacji machine to machine",
        not_eligible: "Usuń swoje aplikacje machine to machine"
    },
    resources_limit: {
        name: "Zasoby API",
        limited: "{{count, number}} zas\xf3b API",
        limited_other: "{{count, number}} zasoby API",
        unlimited: "Nieograniczona liczba zasob\xf3w API",
        not_eligible: "Usuń swoje zasoby API"
    },
    scopes_per_resource_limit: {
        name: "Uprawnienia zasobu",
        limited: "{{count, number}} uprawnienie na zas\xf3b",
        limited_other: "{{count, number}} uprawnienia na zas\xf3b",
        unlimited: "Nieograniczone uprawnienie na zas\xf3b",
        not_eligible: "Usuń swoje uprawnienia zasobu"
    },
    custom_domain_enabled: {
        name: "Niestandardowy domena",
        limited: "Niestandardowy domena",
        unlimited: "Niestandardowy domena",
        not_eligible: "Usuń swoją niestandardową domenę"
    },
    omni_sign_in_enabled: {
        name: "Omni logowanie",
        limited: "Omni logowanie",
        unlimited: "Omni logowanie",
        not_eligible: "Wyłącz swoje omni logowanie"
    },
    built_in_email_connector_enabled: {
        name: "Wbudowany konektor e-mail",
        limited: "Wbudowany konektor e-mail",
        unlimited: "Wbudowany konektor e-mail",
        not_eligible: "Usuń sw\xf3j wbudowany konektor e-mail"
    },
    social_connectors_limit: {
        name: "Konektory społecznościowe",
        limited: "{{count, number}} konektor społecznościowy",
        limited_other: "{{count, number}} konektory społecznościowe",
        unlimited: "Nieograniczone konektory społecznościowe",
        not_eligible: "Usuń swoje konektory społecznościowe"
    },
    standard_connectors_limit: {
        name: "Darmowe standardowe konektory",
        limited: "{{count, number}} darmowy standardowy konektor",
        limited_other: "{{count, number}} darmowe standardowe konektory",
        unlimited: "Nieograniczone standardowe konektory",
        not_eligible: "Usuń swoje standardowe konektory"
    },
    roles_limit: {
        name: "Role",
        limited: "{{count, number}} rola",
        limited_other: "{{count, number}} role",
        unlimited: "Nieograniczona liczba r\xf3l",
        not_eligible: "Usuń swoje role"
    },
    scopes_per_role_limit: {
        name: "Uprawnienia roli",
        limited: "{{count, number}} uprawnienie na rolę",
        limited_other: "{{count, number}} uprawnienia na rolę",
        unlimited: "Nieograniczone uprawnienie na rolę",
        not_eligible: "Usuń swoje uprawnienia roli"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooki",
        unlimited: "Nieograniczona liczba webhook\xf3w",
        not_eligible: "Usuń swoje webhooki"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Przechowywanie dziennik\xf3w audytowych",
        limited: "Przechowywanie dziennik\xf3w audytowych: {{count, number}} dzień",
        limited_other: "Przechowywanie dziennik\xf3w audytowych: {{count, number}} dni",
        unlimited: "Nieograniczona liczba dni",
        not_eligible: "Brak dziennik\xf3w audytowych"
    },
    community_support_enabled: {
        name: "Wsparcie społeczności",
        limited: "Wsparcie społeczności",
        unlimited: "Wsparcie społeczności",
        not_eligible: "Brak wsparcia społecznościowego"
    },
    customer_ticket_support: {
        name: "Wsparcie biletowe dla klienta",
        limited: "{{count, number}} godzina wsparcia biletowego dla klienta",
        limited_other: "{{count, number}} godziny wsparcia biletowego dla klienta",
        unlimited: "Wsparcie biletowe dla klienta",
        not_eligible: "Brak wsparcia biletowego dla klienta"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Dezaktywuj MFA"
    },
    sso_enabled: {
        name: "SSO przedsiębiorstwa",
        limited: "SSO przedsiębiorstwa",
        unlimited: "SSO przedsiębiorstwa",
        not_eligible: "Dezaktywuj swoje SSO przedsiębiorstwa"
    }
};
var $22897cfbb677e742$export$2e2bcd8739ae039 = Object.freeze($22897cfbb677e742$var$quota_item);


const $7887f3ce87f52902$var$quota_table = {
    quota: {
        title: "Limit",
        tenant_limit: "Limit lokatora",
        base_price: "Cena podstawowa",
        mau_unit_price: "* Cena za MAU",
        mau_limit: "Limit MAU"
    },
    application: {
        title: "Aplikacje",
        total: "Liczba aplikacji",
        m2m: "Aplikacja typu maszyna-maszyna"
    },
    resource: {
        title: "Zasoby API",
        resource_count: "Liczba zasob\xf3w",
        scopes_per_resource: "Uprawnienia na zas\xf3b"
    },
    branding: {
        title: "Interfejs użytkownika i branding",
        custom_domain: "Domena niestandardowa",
        custom_css: "Niestandardowy CSS",
        app_logo_and_favicon: "Logo aplikacji i ikona",
        dark_mode: "Tryb ciemny",
        i18n: "Internacjonalizacja"
    },
    user_authn: {
        title: "Uwierzytelnianie użytkownik\xf3w",
        omni_sign_in: "Omni logowanie",
        password: "Hasło",
        passwordless: "Logowanie bez hasła - E-mail i SMS",
        email_connector: "Podłączenie e-mail",
        sms_connector: "Podłączenie SMS",
        social_connectors: "Podłączenia społecznościowe",
        standard_connectors: "Standardowe podłączenia",
        built_in_email_connector: "Wbudowane podłączenie e-mail",
        mfa: "MFA",
        sso: "SSO przedsiębiorstwowe"
    },
    user_management: {
        title: "Zarządzanie użytkownikami",
        user_management: "Zarządzanie użytkownikami",
        roles: "Role",
        scopes_per_role: "Uprawnienia na rolę"
    },
    audit_logs: {
        title: "Logi audytu",
        retention: "Okres przechowywania"
    },
    hooks: {
        title: "Webhooki",
        hooks: "Webhooki"
    },
    organizations: {
        title: "Organizacja",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Wsparcie",
        community: "Społeczność",
        customer_ticket: "Zgłoszenie wsparcia",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Aktywni użytkownicy miesięcznie (MAU) są podzieleni na 3 poziomy w zależności od częstotliwości logowania się w okresie rozliczeniowym. Każdy poziom ma inną cenę za jednostkę MAU.",
    unlimited: "Nieograniczone",
    contact: "Kontakt",
    monthly_price: "${{value, number}}/mies.",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} dzień",
    days_other: "{{count, number}} dni",
    add_on: "Dodatkowy",
    tier: "Poziom{{value, number}}: "
};
var $7887f3ce87f52902$export$2e2bcd8739ae039 = Object.freeze($7887f3ce87f52902$var$quota_table);


const $12d3b4f551a53c33$var$subscription = {
    free_plan: "Darmowy plan",
    free_plan_description: "Dla projekt\xf3w pobocznych i początkowych pr\xf3b Logto. Brak wymaganej karty kredytowej.",
    hobby_plan: "Plan hobbystyczny",
    hobby_plan_description: "Dla indywidualnych programist\xf3w lub małych zespoł\xf3w inżynierskich.",
    pro_plan: "Plan Pro",
    pro_plan_description: "Dla firm, ciesz się bezstresową obsługą Logto.",
    enterprise: "Enterprise",
    current_plan: "Obecny plan",
    current_plan_description: "Oto Tw\xf3j obecny plan. Łatwo możesz sprawdzić wykorzystanie swojego planu, sprawdzić nadchodzący rachunek i dokonać zmian w planie, jeśli jest to konieczne.",
    plan_usage: "Wykorzystanie planu",
    plan_cycle: "Cykl planu: {{period}}. Użycie odnawiane w dniu {{renewDate}}.",
    next_bill: "Twoje następne rozliczenie",
    next_bill_hint: "Aby dowiedzieć się więcej o obliczeniach, zapoznaj się z tym <a>artykułem</a>.",
    next_bill_tip: "Twoje nadchodzące rozliczenie zawiera cenę podstawowego planu na kolejny miesiąc oraz koszt korzystania pomnożony przez cenę jednostkową MAU w r\xf3żnych poziomach.",
    manage_payment: "Zarządzanie płatnościami",
    overfill_quota_warning: "Osiągnąłeś limit swojej puli. Aby uniknąć problem\xf3w, zaktualizuj sw\xf3j plan.",
    upgrade_pro: "Uaktualnij do Pro",
    update_payment: "Zaktualizuj płatność",
    payment_error: "Wykryto problem z płatnością. Nie można przetworzyć ${{price, number}} za poprzedni cykl. Zaktualizuj płatność, aby uniknąć zawieszenia usługi Logto.",
    downgrade: "Zdegradować",
    current: "Obecnie",
    upgrade: "Aktualizacja",
    quota_table: $7887f3ce87f52902$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faktury",
        status_column: "Status",
        amount_column: "Kwota",
        invoice_created_date_column: "Data utworzenia faktury",
        invoice_status: {
            void: "Anulowana",
            paid: "Opłacona",
            open: "Otwarta",
            uncollectible: "Zaległa"
        }
    },
    quota_item: $22897cfbb677e742$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Czy na pewno chcesz zdegradować?",
        description: "Jeśli zdecydujesz się przełączyć na <targetName/>, pamiętaj, że nie będziesz już mieć dostępu do przyznanych wcześniej limit\xf3w i funkcji w <currentName/>. ",
        before: "Przed: <name/>",
        after: "Po: <name />",
        downgrade: "Zdegradować"
    },
    not_eligible_modal: {
        downgrade_title: "Nie spełniasz warunk\xf3w do zmniejszenia",
        downgrade_description: "Upewnij się, że spełniasz następujące kryteria przed zmniejszeniem do <name/>.",
        downgrade_help_tip: "Potrzebna pomoc przy zmniejszaniu? <a>Skontaktuj się z nami</a>.",
        upgrade_title: "Przyjazne przypomnienie dla naszych szanowanych wczesnych użytkownik\xf3w",
        upgrade_description: "Obecnie używasz więcej niż to, co pozwala <name />. Logto jest teraz oficjalne, z funkcjami dostosowanymi do każdego planu. Zanim rozważysz aktualizację do <name />, upewnij się, że spełniasz poniższe kryteria przed dokonaniem aktualizacji.",
        upgrade_pro_tip: " Lub rozważ aktualizację do Planu Pro.",
        upgrade_help_tip: "Potrzebna pomoc przy zwiększaniu? <a>Skontaktuj się z nami</a>.",
        a_maximum_of: "Maksymalnie <item/>"
    },
    upgrade_success: "Pomyślnie uaktualniono do <name/>",
    downgrade_success: "Pomyślnie zdegradowano do <name/>",
    subscription_check_timeout: "Czas sprawdzenia subskrypcji wygasł. Proszę odświeżyć p\xf3źniej.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $12d3b4f551a53c33$export$2e2bcd8739ae039 = Object.freeze($12d3b4f551a53c33$var$subscription);


const $1d4ec224d7b303fa$var$tab_sections = {
    overview: "Przegląd",
    resources: "Zasoby",
    users: "Użytkownicy",
    access_control: "Kontrola dostępu",
    help_and_support: "Pomoc i wsparcie",
    tenant: "Najemca",
    automation: "Automatyzacja"
};
var $1d4ec224d7b303fa$export$2e2bcd8739ae039 = Object.freeze($1d4ec224d7b303fa$var$tab_sections);


const $84d67a0d556b8fbc$var$tabs = {
    get_started: "Rozpocznij",
    dashboard: "Panel",
    applications: "Aplikacje",
    api_resources: "Zasoby API",
    sign_in_experience: "Doświadczenie przy logowaniu",
    connectors: "Konnektory",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooki",
    organizations: "Organizacje",
    users: "Zarządzanie użytkownikami",
    audit_logs: "Dzienniki audytu",
    roles: "Role",
    docs: "Dokumentacja",
    tenant_settings: "Ustawienia",
    mfa: "Multi-factor auth"
};
var $84d67a0d556b8fbc$export$2e2bcd8739ae039 = Object.freeze($84d67a0d556b8fbc$var$tabs);


const $bf467b9d36cc7088$var$tenants = {
    title: "Ustawienia",
    description: "Skuteczne zarządzanie ustawieniami najemcy i dostosowywanie domeny.",
    tabs: {
        settings: "Ustawienia",
        domains: "Domeny",
        subscription: "Plan i rozliczenia",
        billing_history: "Historia rozliczeń"
    },
    settings: {
        title: "USTAWIENIA",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID Najemcy",
        tenant_name: "Nazwa Najemcy",
        tenant_region: "Data hosted region",
        tenant_region_tip: "Your tenant resources are hosted in {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Informacje o najemcy zostały pomyślnie zapisane."
    },
    full_env_tag: {
        development: "Development",
        production: "Production"
    },
    deletion_card: {
        title: "USUWANIE",
        tenant_deletion: "Usuń najemcę",
        tenant_deletion_description: "Usunięcie najemcy spowoduje trwałe usunięcie wszystkich powiązanych danych użytkownik\xf3w i konfiguracji. Proszę postępować ostrożnie.",
        tenant_deletion_button: "Usuń najemcę"
    },
    create_modal: {
        title: "Utw\xf3rz nowego najemcę",
        subtitle: "Utw\xf3rz nowego najemcę, kt\xf3ry ma izolowane zasoby i użytkownik\xf3w. Dane hostowanej regionu i typy najemc\xf3w nie mogą być modyfikowane po utworzeniu.",
        tenant_usage_purpose: "Co chcesz zrobić z tym najemcą?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Dostępny plan:",
        create_button: "Utw\xf3rz najemcę",
        tenant_name_placeholder: "M\xf3j najemca"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Usuń najemcę",
        description_line1: 'Czy na pewno chcesz usunąć najemcę "<span>{{name}}</span>" z tagiem sufiksu środowiska "<span>{{tag}}</span>"? Ta operacja jest nieodwracalna i spowoduje trwałe usunięcie wszystkich twoich danych i informacji konta.',
        description_line2: "Przed usunięciem konta, może chcemy Ci pom\xf3c. <span><a>Skontaktuj się z nami przez e-mail</a></span>",
        description_line3: 'Jeśli chcesz kontynuować, wprowadź nazwę najemcy "<span>{{name}}</span>" w celu potwierdzenia.',
        delete_button: "Usuń na stałe",
        cannot_delete_title: "Nie można usunąć tego najemcy",
        cannot_delete_description: "Przepraszam, nie możesz teraz usunąć tego najemcy. Upewnij się, że korzystasz z planu darmowego i uregulowałeś wszystkie zaległe płatności."
    },
    tenant_landing_page: {
        title: "Nie utworzyłeś jeszcze najemcy",
        description: "Aby rozpocząć konfigurowanie projektu z Logto, utw\xf3rz nowego najemcę. Jeśli musisz się wylogować lub usunąć swoje konto, wystarczy kliknąć przycisk awatara w prawym g\xf3rnym rogu.",
        create_tenant_button: "Utw\xf3rz najemcę"
    },
    status: {
        mau_exceeded: "Przekroczono limit MAU",
        suspended: "Zawieszony",
        overdue: "Op\xf3źnienie w płatnościach"
    },
    tenant_suspended_page: {
        title: "Konto najemcy zawieszone. Skontaktuj się z nami, aby przywr\xf3cić dostęp.",
        description_1: "Z głębokim żalem informujemy, że twoje konto najemcy zostało tymczasowo zawieszone z powodu nieprawidłowego korzystania, w tym przekroczenia limit\xf3w MAU, op\xf3źnionych płatności lub innych nieautoryzowanych działań.",
        description_2: "Jeśli potrzebujesz dalszych wyjaśnień, masz jakiekolwiek obawy lub chcesz przywr\xf3cić pełną funkcjonalność i odblokować swoje najemce, nie wahaj się skontaktować z nami natychmiast."
    },
    signing_keys: {
        title: "ZARZĄDZANIE KLUCZAMI PODPISUJĄCYMI",
        description: "Bezpieczne zarządzanie kluczami podpisującymi w Twoim najemcy.",
        type: {
            private_key: "Klucze prywatne OIDC",
            cookie_key: "Klucze ciasteczek OIDC"
        },
        private_keys_in_use: "Używane klucze prywatne",
        cookie_keys_in_use: "Używane klucze ciasteczek",
        rotate_private_keys: "Obr\xf3ć klucze prywatne",
        rotate_cookie_keys: "Obr\xf3ć klucze ciasteczek",
        rotate_private_keys_description: "Ta akcja spowoduje utworzenie nowego klucza prywatnego do podpisywania, obr\xf3cenie bieżącego klucza i usunięcie poprzedniego klucza. Twoje tokeny JWT podpisane aktualnym kluczem pozostaną ważne do czasu usunięcia lub kolejnego obrotu.",
        rotate_cookie_keys_description: "Ta akcja spowoduje utworzenie nowego klucza ciasteczka, obr\xf3cenie bieżącego klucza i usunięcie poprzedniego klucza. Twoje ciasteczka z aktualnym kluczem pozostaną ważne do czasu usunięcia lub kolejnego obrotu.",
        select_private_key_algorithm: "Wybierz algorytm podpisywania klucza dla nowego klucza prywatnego",
        rotate_button: "Obr\xf3ć",
        table_column: {
            id: "ID",
            status: "Status",
            algorithm: "Algorytm podpisywania klucza"
        },
        status: {
            current: "Bieżący",
            previous: "Poprzedni"
        },
        reminder: {
            rotate_private_key: "Czy na pewno chcesz obr\xf3cić <strong>Klucze prywatne OIDC</strong>? Nowo wydane tokeny JWT będą podpisywane nowym kluczem. Istniejące tokeny JWT pozostają ważne do czasu ponownego obrotu.",
            rotate_cookie_key: "Czy na pewno chcesz obr\xf3cić <strong>Klucze ciasteczek OIDC</strong>? Nowo generowane ciasteczka w sesjach logowania będą podpisywane nowym kluczem ciasteczka. Istniejące ciasteczka pozostają ważne do czasu ponownego obrotu.",
            delete_private_key: "Czy na pewno chcesz usunąć <strong>Klucz prywatny OIDC</strong>? Istniejące tokeny JWT podpisane tym kluczem prywatnym przestaną być ważne.",
            delete_cookie_key: "Czy na pewno chcesz usunąć <strong>Klucz ciasteczka OIDC</strong>? Starsze sesje logowania z ciasteczkami podpisanymi tym kluczem ciasteczka przestaną być ważne. Wymagane będzie ponowne uwierzytelnienie tych użytkownik\xf3w."
        },
        messages: {
            rotate_key_success: "Klucze podpisu obr\xf3cone pomyślnie.",
            delete_key_success: "Klucz usunięty pomyślnie."
        }
    }
};
var $bf467b9d36cc7088$export$2e2bcd8739ae039 = Object.freeze($bf467b9d36cc7088$var$tenants);


const $74c4ae47345b2950$var$topbar = {
    docs: "Dokumentacja",
    help: "Pomoc"
};
var $74c4ae47345b2950$export$2e2bcd8739ae039 = Object.freeze($74c4ae47345b2950$var$topbar);


const $e7ece952790bde08$var$paywall = {
    applications: "Osiągnięto limit {{count, number}} aplikacji dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    applications_other: "Osiągnięto limit {{count, number}} aplikacji dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    machine_to_machine_feature: "Ulepsz do planu <strong>Hobby</strong>, aby odblokować 1 aplikację maszynową, lub wybierz plan <strong>Pro</strong> dla nieograniczonego użytku. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    machine_to_machine: "Osiągnięto limit {{count, number}} aplikacji maszynowych dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    machine_to_machine_other: "Osiągnięto limit {{count, number}} aplikacji maszynowych dla <planName/>. Zaktualizuj plan, aby sprostać potrzebom zespołu. W razie potrzeby pomocy, proszę <a>skontaktuj się z nami</a>.",
    resources: "Osiągnięto limit {{count, number}} zasob\xf3w API w planie <planName/>. Ulepsz plan, aby sprostać potrzebom twojego zespołu. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    resources_other: "Osiągnięto limit {{count, number}} zasob\xf3w API w planie <planName/>. Ulepsz plan, aby sprostać potrzebom twojego zespołu. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    scopes_per_resource: "Osiągnięto limit {{count, number}} uprawnień na zas\xf3b API w planie <planName/>. Zaktualizuj plan, aby rozszerzyć. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    scopes_per_resource_other: "Osiągnięto limit {{count, number}} uprawnień na zas\xf3b API w planie <planName/>. Zaktualizuj plan, aby rozszerzyć. Skontaktuj się z nami <a>tutaj</a>, jeśli potrzebujesz pomocy.",
    custom_domain: "Odblokuj funkcję niestandardowej domeny, ulepszając do planu <strong>Hobby</strong> lub <strong>Pro</strong>. Nie wahaj się <a>skontaktować z nami</a>, jeśli potrzebujesz pomocy.",
    social_connectors: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    social_connectors_other: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_feature: "Ulepsz do planu <strong>Hobby</strong> lub <strong>Pro</strong>, aby tworzyć własne konektory za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML, plus nieograniczone konektory społecznościowe i wszystkie funkcje premium. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_other: "Osiągnięto limit {{count, number}} konektor\xf3w społecznościowych w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz plan, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_pro: "Osiągnięto limit {{count, number}} standardowych konektor\xf3w w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz do planu Enterprise, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    standard_connectors_pro_other: "Osiągnięto limit {{count, number}} standardowych konektor\xf3w w planie <planName/>. Aby sprostać potrzebom twojego zespołu, ulepsz do planu Enterprise, aby uzyskać dodatkowe konektory społecznościowe oraz możliwość tworzenia własnych konektor\xf3w za pomocą protokoł\xf3w OIDC, OAuth 2.0 i SAML. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    roles: "Osiągnięto limit {{count, number}} r\xf3l w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    roles_other: "Osiągnięto limit {{count, number}} r\xf3l w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    scopes_per_role: "Osiągnięto limit {{count, number}} uprawnień na rolę w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. W razie potrzeb, skontaktuj się z nami <a>tutaj</a>.",
    scopes_per_role_other: "Osiągnięto limit {{count, number}} uprawnień na rolę w planie <planName/>. Ulepsz plan, aby dodać dodatkowe role i uprawnienia. W razie potrzeb, skontaktuj się z nami <a>tutaj</a>.",
    hooks: "Osiągnięto limit {{count, number}} webhook\xf3w w planie <planName/>. Ulepsz plan, aby tworzyć więcej webhook\xf3w. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    hooks_other: "Osiągnięto limit {{count, number}} webhook\xf3w w planie <planName/>. Ulepsz plan, aby tworzyć więcej webhook\xf3w. Jeśli potrzebujesz pomocy, nie wahaj się <a>skontaktować z nami</a>.",
    mfa: "Odblokuj MFA, aby zweryfikować bezpieczeństwo, przechodząc na płatny plan. Nie wahaj się <a>skontaktować z nami</a>, jeśli potrzebujesz pomocy.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $e7ece952790bde08$export$2e2bcd8739ae039 = Object.freeze($e7ece952790bde08$var$paywall);


const $28e6e283ebb79d94$var$upsell = {
    upgrade_plan: "Ulepsz plan",
    compare_plans: "Por\xf3wnaj plany",
    view_plans: "Zobacz plany",
    create_tenant: {
        title: "Wybierz sw\xf3j plan najemcy",
        description: "Logto oferuje konkurencyjne opcje plan\xf3w z innowacyjnym i przystępnym cenowo modelu dla rozwijających się firm. <a>Dowiedz się więcej</a>",
        base_price: "Cena podstawowa",
        monthly_price: "{{value, number}}/mies.",
        mau_unit_price: "Cena jednostkowa MAU",
        view_all_features: "Zobacz wszystkie funkcje",
        select_plan: "Wybierz <name/>",
        free_tenants_limit: "Do {{count, number}} bezpłatnego najemcy",
        free_tenants_limit_other: "Do {{count, number}} bezpłatnych najemc\xf3w",
        most_popular: "Najpopularniejszy",
        upgrade_success: "Pomyślnie ulepszono do <name/>"
    },
    mau_exceeded_modal: {
        title: "MAU przekroczyło limit. Ulepsz sw\xf3j plan.",
        notification: "Obecna liczba MAU przekroczyła limit planu <planName/>. Proszę natychmiast zaktualizować sw\xf3j plan na wersję premium, aby uniknąć zawieszenia usługi Logto.",
        update_plan: "Zaktualizuj plan"
    },
    payment_overdue_modal: {
        title: "Opłata za fakturę zaległa",
        notification: "Ups! Płatność za fakturę najemcy <span>{{name}}</span> nie powiodła się. Proszę zapłacić fakturę w odpowiednim terminie, aby uniknąć zawieszenia usługi Logto.",
        unpaid_bills: "Nieuregulowane faktury",
        update_payment: "Zaktualizuj płatność"
    },
    paywall: $e7ece952790bde08$export$2e2bcd8739ae039
};
var $28e6e283ebb79d94$export$2e2bcd8739ae039 = Object.freeze($28e6e283ebb79d94$var$upsell);


const $009833110e11ab62$var$user_details = {
    page_title: "Szczeg\xf3ły użytkownika",
    back_to_users: "Powr\xf3t do zarządzania użytkownikami",
    created_title: "Ten użytkownik został pomyślnie utworzony",
    created_guide: "Oto informacje, kt\xf3re pomogą użytkownikowi w procesie logowania.",
    created_email: "Adres email:",
    created_phone: "Numer telefonu:",
    created_username: "Nazwa użytkownika:",
    created_password: "Hasło:",
    menu_delete: "Usuń",
    delete_description: "Tej akcji nie można cofnąć. Usunie to użytkownika na stałe.",
    deleted: "Użytkownik został pomyślnie usunięty",
    reset_password: {
        reset_password: "Zresetuj hasło",
        title: "Czy na pewno chcesz zresetować hasło?",
        content: "Tej akcji nie można cofnąć. To zresetuje informacje o logowaniu użytkownika.",
        congratulations: "Ten użytkownik został zresetowany",
        new_password: "Nowe hasło:"
    },
    tab_settings: "Ustawienia",
    tab_roles: "Role",
    tab_logs: "Logi użytkownika",
    tab_organizations: "Organizacje",
    authentication: "Autoryzacja",
    authentication_description: "Każdy użytkownik ma profil zawierający wszystkie informacje o użytkowniku. Składa się on z podstawowych danych, tożsamości społecznościowych i niestandardowych danych.",
    user_profile: "Profil użytkownika",
    field_email: "Adres e-mail",
    field_phone: "Numer telefonu",
    field_username: "Nazwa użytkownika",
    field_name: "Imię i nazwisko",
    field_avatar: "Adres URL obrazka awatara",
    field_avatar_placeholder: "https://twoja.domena/cdn/avatar.png",
    field_custom_data: "Dane niestandardowe",
    field_custom_data_tip: "Dodatkowe informacje o użytkowniku niewymienione jako właściwości predefiniowane, takie jak preferowany przez użytkownika kolor i język.",
    field_connectors: "Połączenia społecznościowe",
    field_sso_connectors: "Połączenia przedsiębiorstwa",
    custom_data_invalid: "Nieprawidłowe dane niestandardowe JSON",
    connectors: {
        connectors: "Połączenia",
        user_id: "Identyfikator użytkownika",
        remove: "Usuń",
        connected: "Ten użytkownik jest połączony z wieloma społecznymi konektorami.",
        not_connected: "Użytkownik nie jest połączony z żadnym społecznym konektorem",
        deletion_confirmation: "Usuwasz istniejącą tożsamość <name/>. Czy na pewno chcesz kontynuować?"
    },
    sso_connectors: {
        connectors: "Konektory",
        enterprise_id: "ID przedsiębiorstwa",
        connected: "Ten użytkownik jest połączony z kilkoma dostawcami tożsamości przedsiębiorstwa do jednokrotnego uwierzytelniania.",
        not_connected: "Użytkownik nie jest połączony z żadnym dostawcą tożsamości przedsiębiorstwa do jednokrotnego uwierzytelniania."
    },
    mfa: {
        field_name: "Wieloetapowa autoryzacja",
        field_description: "Ten użytkownik włączył autoryzację dwuetapową.",
        name_column: "Wieloetapowa autoryzacja",
        field_description_empty: "Ten użytkownik nie włączył autoryzacji dwuetapowej.",
        deletion_confirmation: "Usuwasz istniejące <name/> w celu weryfikacji dwuetapowej. Czy na pewno chcesz kontynuować?"
    },
    suspended: "Zawieszony",
    suspend_user: "Zawieś użytkownika",
    suspend_user_reminder: "Czy na pewno chcesz zawiesić tego użytkownika? Użytkownik nie będzie m\xf3gł zalogować się do Twojej aplikacji i nie uzyska nowego tokena dostępu po wygaśnięciu obecnego. Ponadto jakiekolwiek żądania API złożone przez tego użytkownika będą nieudane.",
    suspend_action: "Zawieś",
    user_suspended: "Użytkownik został zawieszony.",
    reactivate_user: "Aktywuj użytkownika",
    reactivate_user_reminder: "Czy na pewno chcesz aktywować tego użytkownika? Umożliwi to wszystkie pr\xf3by logowania dla tego użytkownika.",
    reactivate_action: "Aktywuj",
    user_reactivated: "Użytkownik został aktywowany.",
    roles: {
        name_column: "Rola",
        description_column: "Opis",
        assign_button: "Przypisz rolę",
        delete_description: "Ta akcja usunie tę rolę z tego użytkownika. Rola nadal będzie istnieć, ale nie będzie już przypisana do tego użytkownika.",
        deleted: "{{name}} została usunięta z tego użytkownika.",
        assign_title: "Przypisz rolę dla {{name}}",
        assign_subtitle: "Przypisz {{name}} jedną lub wiele r\xf3l",
        assign_role_field: "Przypisz rolę",
        role_search_placeholder: "Szukaj po nazwie roli",
        added_text: "{{value, number}} dodanych",
        assigned_user_count: "{{value, number}} użytkownik\xf3w",
        confirm_assign: "Przypisz rolę",
        role_assigned: "Pomyślnie przypisano rolę(y)",
        search: "Szukaj po nazwie roli, opisie lub ID",
        empty: "Brak dostępnej roli"
    },
    warning_no_sign_in_identifier: "Aby się zalogować, użytkownik musi mieć co najmniej jeden identyfikator logowania (nazwa użytkownika, e-mail, numer telefonu lub konto społecznościowe). Czy na pewno chcesz kontynuować?",
    organization_roles_tooltip: "Role przypisane użytkownikowi w ramach tej organizacji."
};
var $009833110e11ab62$export$2e2bcd8739ae039 = Object.freeze($009833110e11ab62$var$user_details);


const $b3ffd1c5466fba66$var$users = {
    page_title: "Zarządzanie użytkownikami",
    title: "Zarządzanie użytkownikami",
    subtitle: "Zarządzaj tożsamościami użytkownik\xf3w, w tym tworzeniem użytkownik\xf3w, edycją informacji o użytkownikach, przeglądaniem dziennik\xf3w użytkownik\xf3w, resetowaniem hasła i usuwaniem użytkownik\xf3w.",
    create: "Dodaj użytkownika",
    create_subtitle: "Podaj co najmniej jedno z poniższych p\xf3l, aby kontynuować.",
    error_missing_identifier: "Aby utworzyć użytkownika, musisz podać co najmniej jeden identyfikator.",
    user_name: "Użytkownik",
    application_name: "Z aplikacji",
    latest_sign_in: "Najnowsze logowanie",
    create_form_username: "Nazwa użytkownika",
    create_form_password: "Hasło",
    create_form_name: "Imię i nazwisko",
    placeholder_name: "Jan Kowalski",
    placeholder_email: "jkowalski@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+48 123 456 789",
    unnamed: "Bez nazwy",
    search: "Wyszukaj według nazwy, e-maila, numeru telefonu lub nazwy użytkownika",
    check_user_detail: "Sprawdź szczeg\xf3ły użytkownika",
    placeholder_title: "Zarządzanie użytkownikami",
    placeholder_description: "Każdy użytkownik ma profil zawierający wszystkie informacje o użytkowniku. Składa się z podstawowych danych, tożsamości społecznych i niestandardowych danych."
};
var $b3ffd1c5466fba66$export$2e2bcd8739ae039 = Object.freeze($b3ffd1c5466fba66$var$users);


const $fa9509de99e295b3$var$webhook_details = {
    page_title: "Szczeg\xf3ły webhooka",
    back_to_webhooks: "Wr\xf3ć do Webhooks",
    not_in_use: "Nieaktywne",
    success_rate: "Stosunek sukces\xf3w",
    requests: "{{value, number}} żądań w ciągu 24h",
    disable_webhook: "Wyłącz webhook",
    disable_reminder: "Czy na pewno chcesz przestać wyłączać ten webhook? Taki postęp nie będzie wysyłał żądania HTTP do adresu URL końcowego.",
    webhook_disabled: "Webhook został wyłączony.",
    webhook_reactivated: "Webhook został ponownie aktywowany.",
    reactivate_webhook: "Aktywuj ponownie webhooka",
    delete_webhook: "Usuń webhook",
    deletion_reminder: "Usuwasz ten webhook. Po jego usunięciu nie będzie wysyłany żaden żądanie HTTP do adresu URL końcowego.",
    deleted: "Webhook został pomyślnie usunięty.",
    settings_tab: "Ustawienia",
    recent_requests_tab: "Najnowsze żądania (24h)",
    settings: {
        settings: "Ustawienia",
        settings_description: "Webhootsy pozwalają na otrzymywanie aktualizacji w czasie rzeczywistym z określonych zdarzeń, wysyłając żądanie POST na Tw\xf3j adres URL końcowy. Dzięki temu możesz natychmiast podjąć działania na podstawie otrzymanych nowych informacji.",
        events: "Zdarzenia",
        events_description: "Wybierz zdarzenia wywołujące, kt\xf3re Logto wyśle żądanie POST.",
        name: "Nazwa",
        endpoint_url: "Adres URL końcowego",
        signing_key: "Klucz podpisu",
        signing_key_tip: "Dodaj klucz sekretny dostarczony przez Logto do swojego endpointu jako nagł\xf3wek żądania, aby zapewnić autentyczność ładunku webhooka.",
        regenerate: "Przebuduj",
        regenerate_key_title: "Wygeneruj ponownie klucz podpisu",
        regenerate_key_reminder: "Czy na pewno chcesz zmodyfikować klucz podpisu? Regenerowanie spowoduje natychmiastowe wprowadzenie zmian. Pamiętaj, aby synchronicznie zmienić klucz podpisu w swoim endpointcie.",
        regenerated: "Klucz podpisu został przebudowany.",
        custom_headers: "Niestandardowe nagł\xf3wki",
        custom_headers_tip: "Opcjonalnie możesz dodać niestandardowe nagł\xf3wki w ładunku webhooka, aby dostarczyć dodatkowy kontekst lub metadane na temat zdarzenia.",
        key_duplicated_error: "Klucze nie mogą się powtarzać.",
        key_missing_error: "Klucz jest wymagany.",
        value_missing_error: "Wartość jest wymagana.",
        invalid_key_error: "Klucz jest nieprawidłowy",
        invalid_value_error: "Wartość jest nieprawidłowa",
        test: "Test",
        test_webhook: "Wypr\xf3buj sw\xf3j webhook",
        test_webhook_description: "Skonfiguruj webhooka i przetestuj go przy użyciu przykład\xf3w ładunku dla każdego wybranego zdarzenia, aby sprawdzić poprawne odbieranie i przetwarzanie.",
        send_test_payload: "Wyślij testowy ładunek",
        test_result: {
            endpoint_url: "URL punktu końcowego: {{url}}",
            message: "Wiadomość: {{message}}",
            response_status: "Status odpowiedzi: {{status, number}}",
            response_body: "Treść odpowiedzi: {{body}}",
            request_time: "Czas żądania: {{time}}",
            test_success: "Test webhooka do punktu końcowego zakończył się powodzeniem."
        }
    }
};
var $fa9509de99e295b3$export$2e2bcd8739ae039 = Object.freeze($fa9509de99e295b3$var$webhook_details);


const $19eee420d56d91c1$var$webhooks = {
    page_title: "Wejścia",
    title: "Webhooki",
    subtitle: "Utw\xf3rz webhooki, aby bez wysiłku otrzymywać aktualizacje w czasie rzeczywistym dotyczące określonych zdarzeń.",
    create: "Utw\xf3rz webhook",
    events: {
        post_register: "Utw\xf3rz nowe konto",
        post_sign_in: "Zaloguj się",
        post_reset_password: "Zresetuj hasło"
    },
    table: {
        name: "Nazwa",
        events: "Zdarzenia",
        success_rate: "Wskaźnik sukcesu (24h)",
        requests: "Żądania (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Utw\xf3rz webhook, aby otrzymywać aktualizacje w czasie rzeczywistym za pomocą żądań POST na adres URL punktu końcowego. Bądź informowany i podejmuj natychmiastowe działania w przypadku zdarzeń takich jak "Utw\xf3rz konto", "Zaloguj się" i "Zresetuj hasło".',
        create_webhook: "Utw\xf3rz webhook"
    },
    create_form: {
        title: "Utw\xf3rz Webhook",
        subtitle: "Dodaj Webhook aby wysyłać żądania POST na endpoint URL z detalami o zdarzeniach użytkownik\xf3w.",
        events: "Zdarzenia",
        events_description: "Wybierz zdarzenia wyzwalające kt\xf3re Logto wykorzysta do wysłania żądania POST.",
        name: "Nazwa",
        name_placeholder: "Wprowadź nazwę webhooka",
        endpoint_url: "URL punktu końcowego",
        endpoint_url_placeholder: "https://twoj.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Utw\xf3rz webhook",
        missing_event_error: "Musisz wybrać przynajmniej jedno zdarzenie."
    },
    webhook_created: "Webhook {{name}} został pomyślnie utworzony."
};
var $19eee420d56d91c1$export$2e2bcd8739ae039 = Object.freeze($19eee420d56d91c1$var$webhooks);


const $d381417226f0465e$var$welcome = {
    title: "Witaj w konsoli administracyjnej",
    description: "Konsola administracyjna to aplikacja internetowa umożliwiająca zarządzanie Logto bez wymagania znajomości kodowania. Najpierw zał\xf3ż konto. Dzięki temu kontu możesz zarządzać Logto samodzielnie lub w imieniu swojej firmy.",
    create_account: "Zał\xf3ż konto"
};
var $d381417226f0465e$export$2e2bcd8739ae039 = Object.freeze($d381417226f0465e$var$welcome);


const $d1cee65fd5633b89$var$admin_console = {
    title: "관리자 콘솔",
    admin_user: "관리자",
    system_app: "시스템",
    menu: $3798973e49af3b2e$export$2e2bcd8739ae039,
    general: $b57ca0ef90643653$export$2e2bcd8739ae039,
    errors: $6eba7727f9de19f9$export$2e2bcd8739ae039,
    tab_sections: $1d4ec224d7b303fa$export$2e2bcd8739ae039,
    tabs: $84d67a0d556b8fbc$export$2e2bcd8739ae039,
    applications: $46b64f26cf979496$export$2e2bcd8739ae039,
    application_details: $6e7b9b235a528ff4$export$2e2bcd8739ae039,
    api_resources: $a4292bcf6bb5055f$export$2e2bcd8739ae039,
    api_resource_details: $ce3f12dc3b1e6e0f$export$2e2bcd8739ae039,
    connectors: $d0664f13764eff09$export$2e2bcd8739ae039,
    connector_details: $00e2e8ddd4e7f9a1$export$2e2bcd8739ae039,
    enterprise_sso: $f872d91bc67b04ad$export$2e2bcd8739ae039,
    enterprise_sso_details: $7df413902315b0c5$export$2e2bcd8739ae039,
    get_started: $167c33e080d57f9b$export$2e2bcd8739ae039,
    users: $b3ffd1c5466fba66$export$2e2bcd8739ae039,
    user_details: $009833110e11ab62$export$2e2bcd8739ae039,
    contact: $ac3f9edd3de74e76$export$2e2bcd8739ae039,
    sign_in_exp: $190567da0a2cdc03$export$2e2bcd8739ae039,
    dashboard: $49fd02d73eb60558$export$2e2bcd8739ae039,
    logs: $9d76a0e4c8b81b24$export$2e2bcd8739ae039,
    log_details: $8b2f5f8d64a6e55c$export$2e2bcd8739ae039,
    session_expired: $42ba5ab84dd52ddd$export$2e2bcd8739ae039,
    welcome: $d381417226f0465e$export$2e2bcd8739ae039,
    roles: $7b3867ca8a653f47$export$2e2bcd8739ae039,
    role_details: $a81f0447034f6fc4$export$2e2bcd8739ae039,
    permissions: $6aac581287e25907$export$2e2bcd8739ae039,
    cloud: $10680b30dee8834b$export$2e2bcd8739ae039,
    profile: $fd17f9146bd0dff8$export$2e2bcd8739ae039,
    components: $ba5e35ee485ec228$export$2e2bcd8739ae039,
    webhooks: $19eee420d56d91c1$export$2e2bcd8739ae039,
    webhook_details: $fa9509de99e295b3$export$2e2bcd8739ae039,
    domain: $b6a0e6c20eae40d2$export$2e2bcd8739ae039,
    tenants: $bf467b9d36cc7088$export$2e2bcd8739ae039,
    topbar: $74c4ae47345b2950$export$2e2bcd8739ae039,
    subscription: $12d3b4f551a53c33$export$2e2bcd8739ae039,
    upsell: $28e6e283ebb79d94$export$2e2bcd8739ae039,
    guide: $3620e2c1b4cedef0$export$2e2bcd8739ae039,
    mfa: $4e3a88741cb834cc$export$2e2bcd8739ae039,
    organizations: $b625cb742774fcac$export$2e2bcd8739ae039,
    organization_details: $de6a14a0c480b424$export$2e2bcd8739ae039
};
var $d1cee65fd5633b89$export$2e2bcd8739ae039 = Object.freeze($d1cee65fd5633b89$var$admin_console);


const $a0133f51c5cee50e$var$demo_app = {
    title: "Pomyślnie zalogowałeś się do podglądu na żywo!",
    subtitle: "Oto twoje informacje logowania:",
    username: "Nazwa użytkownika: ",
    user_id: "ID użytkownika: ",
    sign_out: "Wyloguj się z podglądu na żywo",
    continue_explore: "Lub kontynuuj przeglądanie",
    customize_sign_in_experience: "Dostosuj wrażenia z logowania",
    enable_passwordless: "Włącz logowanie bez hasła",
    add_social_connector: "Dodaj złącze społecznościowe"
};
var $a0133f51c5cee50e$export$2e2bcd8739ae039 = Object.freeze($a0133f51c5cee50e$var$demo_app);


const $1d52fd45ff616aa9$var$oidc = {
    logout_success: "Pomyślnie zostałeś wylogowany."
};
var $1d52fd45ff616aa9$export$2e2bcd8739ae039 = Object.freeze($1d52fd45ff616aa9$var$oidc);


const $d5839e84310106a5$var$translation = {
    admin_console: $d1cee65fd5633b89$export$2e2bcd8739ae039,
    demo_app: $a0133f51c5cee50e$export$2e2bcd8739ae039,
    oidc: $1d52fd45ff616aa9$export$2e2bcd8739ae039
};
var $d5839e84310106a5$export$2e2bcd8739ae039 = Object.freeze($d5839e84310106a5$var$translation);


const $84936ac2cfcfe408$var$pl_pl = {
    translation: $d5839e84310106a5$export$2e2bcd8739ae039,
    errors: $86a2b23e45cb712d$export$2e2bcd8739ae039
};
var $84936ac2cfcfe408$export$2e2bcd8739ae039 = Object.freeze($84936ac2cfcfe408$var$pl_pl);


const $67d053e31f4639ed$var$application = {
    invalid_type: "Apenas aplica\xe7\xf5es de m\xe1quina para m\xe1quina podem ter fun\xe7\xf5es associadas.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este aplicativo.",
    invalid_role_type: "N\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o de tipo de usu\xe1rio a um aplicativo de m\xe1quina para m\xe1quina."
};
var $67d053e31f4639ed$export$2e2bcd8739ae039 = Object.freeze($67d053e31f4639ed$var$application);


const $b76aaaf3226b8911$var$auth = {
    authorization_header_missing: "O cabe\xe7alho de autoriza\xe7\xe3o est\xe1 ausente.",
    authorization_token_type_not_supported: "O tipo de autoriza\xe7\xe3o n\xe3o \xe9 suportado.",
    unauthorized: "N\xe3o autorizado. Verifique as credenciais e seu escopo.",
    forbidden: "Proibido. Verifique suas fun\xe7\xf5es e permiss\xf5es de usu\xe1rio.",
    expected_role_not_found: "Regra esperada n\xe3o encontrada. Verifique suas regras e permiss\xf5es de usu\xe1rio.",
    jwt_sub_missing: "`sub` ausente no JWT.",
    require_re_authentication: "A reautentica\xe7\xe3o \xe9 necess\xe1ria para executar uma a\xe7\xe3o protegida."
};
var $b76aaaf3226b8911$export$2e2bcd8739ae039 = Object.freeze($b76aaaf3226b8911$var$auth);


const $0e33610310c47e86$var$connector = {
    general: "Ocorreu um erro no conector: {{errorDescription}}",
    not_found: "N\xe3o foi poss\xedvel encontrar nenhum conector dispon\xedvel para o tipo: {{type}}.",
    not_enabled: "O conector n\xe3o est\xe1 ativado.",
    invalid_metadata: "Os metadados do conector s\xe3o inv\xe1lidos.",
    invalid_config_guard: "A prote\xe7\xe3o de configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    unexpected_type: "O tipo do conector \xe9 inesperado.",
    invalid_request_parameters: "A solicita\xe7\xe3o est\xe1 com par\xe2metro(s) de entrada incorreto(s).",
    insufficient_request_parameters: "A solicita\xe7\xe3o pode perder alguns par\xe2metros de entrada.",
    invalid_config: "A configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "A resposta do conector \xe9 inv\xe1lida.",
    template_not_found: "N\xe3o foi poss\xedvel encontrar o modelo correto na configura\xe7\xe3o do conector.",
    template_not_supported: "O conector n\xe3o suporta esse tipo de modelo.",
    rate_limit_exceeded: "Limite de taxa de acionamento. Tente novamente mais tarde.",
    not_implemented: "{{method}}: ainda n\xe3o foi implementado.",
    social_invalid_access_token: "O token de acesso do conector \xe9 inv\xe1lido.",
    invalid_auth_code: "O c\xf3digo de autentica\xe7\xe3o do conector \xe9 inv\xe1lido.",
    social_invalid_id_token: "O token de id do conector \xe9 inv\xe1lido.",
    authorization_failed: "O processo de autoriza\xe7\xe3o do usu\xe1rio n\xe3o foi bem-sucedido.",
    social_auth_code_invalid: "N\xe3o foi poss\xedvel obter o token de acesso, verifique o c\xf3digo de autoriza\xe7\xe3o.",
    more_than_one_sms: "O n\xfamero de conectores SMS \xe9 maior que 1.",
    more_than_one_email: "O n\xfamero de conectores de e-mail \xe9 maior que 1.",
    more_than_one_connector_factory: "Foram encontradas v\xe1rias f\xe1bricas de conectores (com os ids {{connectorIds}}), voc\xea pode desinstalar as desnecess\xe1rias.",
    db_connector_type_mismatch: "Existe um conector no banco de dados que n\xe3o corresponde ao tipo.",
    not_found_with_connector_id: "N\xe3o \xe9 poss\xedvel encontrar o conector com o ID de conector padr\xe3o fornecido.",
    multiple_instances_not_supported: "N\xe3o \xe9 poss\xedvel criar v\xe1rias inst\xe2ncias com conector padr\xe3o escolhido.",
    invalid_type_for_syncing_profile: "Voc\xea s\xf3 pode sincronizar o perfil do usu\xe1rio com conectores sociais.",
    can_not_modify_target: "O destino do conector n\xe3o pode ser modificado.",
    should_specify_target: "Voc\xea deve especificar o 'destino'.",
    multiple_target_with_same_platform: "Voc\xea n\xe3o pode ter v\xe1rios conectores sociais com o mesmo destino e plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Esta 'metadata' do conector n\xe3o pode ser sobrescrita."
};
var $0e33610310c47e86$export$2e2bcd8739ae039 = Object.freeze($0e33610310c47e86$var$connector);


const $a6ff6b43db3f3a8b$var$domain = {
    not_configured: "O provedor de nome de dom\xednio do host n\xe3o est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data est\xe1 faltando, por favor verifique.",
    cloudflare_unknown_error: "Recebido erro desconhecido ao solicitar API do Cloudflare",
    cloudflare_response_error: "Recebido resposta inesperada do Cloudflare.",
    limit_to_one_domain: "Voc\xea s\xf3 pode ter um dom\xednio personalizado.",
    hostname_already_exists: "Este dom\xednio j\xe1 existe em nosso servidor.",
    cloudflare_not_found: "N\xe3o \xe9 poss\xedvel encontrar o nome do host no Cloudflare"
};
var $a6ff6b43db3f3a8b$export$2e2bcd8739ae039 = Object.freeze($a6ff6b43db3f3a8b$var$domain);


const $858cc4ef477611a7$var$entity = {
    invalid_input: "Entrada inv\xe1lida. A lista de valores n\xe3o deve estar vazia.",
    create_failed: "Falha ao criar {{name}}.",
    db_constraint_violated: "Viola\xe7\xe3o de restri\xe7\xe3o do banco de dados.",
    not_exists: "O {{name}} n\xe3o existe.",
    not_exists_with_id: "O {{name}} com ID `{{id}}` n\xe3o existe.",
    not_found: "O recurso n\xe3o existe.",
    relation_foreign_key_not_found: "N\xe3o \xe9 poss\xedvel encontrar uma ou mais chaves estrangeiras. Por favor, verifique a entrada e garanta que todas as entidades referenciadas existam.",
    unique_integrity_violation: "A entidade j\xe1 existe. Por favor, verifique a entrada e tente novamente."
};
var $858cc4ef477611a7$export$2e2bcd8739ae039 = Object.freeze($858cc4ef477611a7$var$entity);


const $ae9a2193b739f7db$var$guard = {
    invalid_input: "A solicita\xe7\xe3o {{type}} \xe9 inv\xe1lida.",
    invalid_pagination: "O valor de pagina\xe7\xe3o da solicita\xe7\xe3o \xe9 inv\xe1lido.",
    can_not_get_tenant_id: "N\xe3o foi poss\xedvel obter o ID do inquilino na solicita\xe7\xe3o.",
    file_size_exceeded: "Tamanho do arquivo excedido.",
    mime_type_not_allowed: "Tipo MIME n\xe3o permitido."
};
var $ae9a2193b739f7db$export$2e2bcd8739ae039 = Object.freeze($ae9a2193b739f7db$var$guard);


const $6068d4798743589b$var$hook = {
    missing_events: "Voc\xea precisa fornecer pelo menos um evento.",
    send_test_payload_failed: "Falha ao enviar uma carga de teste: {{message}}",
    endpoint_responded_with_error: "O ponto de extremidade respondeu com erro."
};
var $6068d4798743589b$export$2e2bcd8739ae039 = Object.freeze($6068d4798743589b$var$hook);


const $695ff9b99b97a89b$var$localization = {
    cannot_delete_default_language: "{{languageTag}} est\xe1 definido como seu idioma padr\xe3o e n\xe3o pode ser exclu\xeddo.",
    invalid_translation_structure: "Esquemas de dados inv\xe1lidos. Verifique sua entrada e tente novamente."
};
var $695ff9b99b97a89b$export$2e2bcd8739ae039 = Object.freeze($695ff9b99b97a89b$var$localization);


const $3b0d2e0846751c60$var$log = {
    invalid_type: "O tipo de registro \xe9 inv\xe1lido."
};
var $3b0d2e0846751c60$export$2e2bcd8739ae039 = Object.freeze($3b0d2e0846751c60$var$log);


const $e1f56e178b513745$var$oidc = {
    aborted: "A intera\xe7\xe3o foi abortada pelo usu\xe1rio final",
    invalid_scope: "Escopo inv\xe1lido: {{error_description}}.",
    invalid_token: "Token inv\xe1lido.",
    invalid_client_metadata: "Metadados do cliente inv\xe1lidos.",
    insufficient_scope: "Token sem escopo `{{scope}}`.",
    invalid_request: "A solicita\xe7\xe3o \xe9 inv\xe1lida.",
    invalid_grant: "A concess\xe3o \xe9 inv\xe1lida.",
    invalid_redirect_uri: "`redirect_uri` n\xe3o corresponde a nenhum `redirect_uris` registrado do cliente.",
    access_denied: "Acesso negado.",
    invalid_target: "Indicador de recurso inv\xe1lido.",
    unsupported_grant_type: "`grant_type` n\xe3o suportado.",
    unsupported_response_mode: "`response_mode` n\xe3o suportado.",
    unsupported_response_type: "`response_type` n\xe3o suportado.",
    provider_error: "Erro interno OIDC: {{message}}.",
    server_error: "Ocorreu um erro OIDC desconhecido. Por favor, tente novamente mais tarde.",
    provider_error_fallback: "Ocorreu um erro OIDC: {{code}}.",
    key_required: "Pelo menos uma chave \xe9 necess\xe1ria.",
    key_not_found: "Chave com ID {{id}} n\xe3o encontrada."
};
var $e1f56e178b513745$export$2e2bcd8739ae039 = Object.freeze($e1f56e178b513745$var$oidc);


const $f64e5c9e6630da02$var$organization = {
    require_membership: "O usu\xe1rio deve ser um membro da organiza\xe7\xe3o para continuar."
};
var $f64e5c9e6630da02$export$2e2bcd8739ae039 = Object.freeze($f64e5c9e6630da02$var$organization);


const $e323584056730bbc$var$password = {
    unsupported_encryption_method: "O m\xe9todo de criptografia {{name}} n\xe3o \xe9 suportado.",
    pepper_not_found: "Password pepper n\xe3o encontrada. Por favor, verifique seus envs principais.",
    rejected: "Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos."
};
var $e323584056730bbc$export$2e2bcd8739ae039 = Object.freeze($e323584056730bbc$var$password);


const $4b29fdae204da3e1$var$request = {
    invalid_input: "Entrada inv\xe1lida. {{details}}",
    general: "Ocorreu um erro no pedido."
};
var $4b29fdae204da3e1$export$2e2bcd8739ae039 = Object.freeze($4b29fdae204da3e1$var$request);


const $742b6a695e045f49$var$resource = {
    resource_identifier_in_use: "O identificador de API {{indicator}} j\xe1 est\xe1 em uso"
};
var $742b6a695e045f49$export$2e2bcd8739ae039 = Object.freeze($742b6a695e045f49$var$resource);


const $6f7e316bf2c6f74a$var$role = {
    name_in_use: "Este nome de papel {{name}} j\xe1 est\xe1 em uso",
    scope_exists: "O id de escopo {{scopeId}} j\xe1 foi adicionado a este papel",
    user_exists: "O id de usu\xe1rio {{userId}} j\xe1 foi adicionado a este papel",
    application_exists: "O id do aplicativo {{applicationId}} j\xe1 foi adicionado a este papel",
    default_role_missing: "Alguns dos nomes de fun\xe7\xe3o padr\xe3o n\xe3o existem no banco de dados, certifique-se de criar fun\xe7\xf5es primeiro",
    internal_role_violation: 'Voc\xea pode estar tentando atualizar ou excluir uma fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Se voc\xea estiver criando uma nova fun\xe7\xe3o, tente outro nome que n\xe3o comece com "#internal:".'
};
var $6f7e316bf2c6f74a$export$2e2bcd8739ae039 = Object.freeze($6f7e316bf2c6f74a$var$role);


const $250d0e10926f5683$var$scope = {
    name_exists: "O nome do escopo {{name}} j\xe1 est\xe1 em uso",
    name_with_space: "O nome do escopo n\xe3o pode conter espa\xe7os."
};
var $250d0e10926f5683$export$2e2bcd8739ae039 = Object.freeze($250d0e10926f5683$var$scope);


const $e1e5686e7a041443$var$session = {
    not_found: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    invalid_credentials: "Credenciais inv\xe1lidas. Verifique sua entrada.",
    invalid_sign_in_method: "O m\xe9todo de login atual n\xe3o est\xe1 dispon\xedvel.",
    invalid_connector_id: "N\xe3o foi poss\xedvel encontrar o conector dispon\xedvel com id {{connectorId}}.",
    insufficient_info: "Informa\xe7\xf5es de login insuficientes.",
    connector_id_mismatch: "O connectorId \xe9 incompat\xedvel com o registro da sess\xe3o.",
    connector_session_not_found: "Sess\xe3o do conector n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    verification_session_not_found: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o fluxo de verifica\xe7\xe3o e tente novamente.",
    verification_expired: "A conex\xe3o expirou. Verifique novamente para garantir a seguran\xe7a da sua conta.",
    verification_blocked_too_many_attempts: "Muitas tentativas em um curto per\xedodo de tempo. Por favor, tente novamente {{relativeTime}}.",
    unauthorized: "Fa\xe7a login primeiro.",
    unsupported_prompt_name: "Nome do prompt incompat\xedvel.",
    forgot_password_not_enabled: "Esqueceu a senha n\xe3o est\xe1 ativado.",
    verification_failed: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o fluxo de verifica\xe7\xe3o e tente novamente.",
    connector_validation_session_not_found: "A sess\xe3o de valida\xe7\xe3o do token do conector n\xe3o foi encontrada.",
    identifier_not_found: "Identificador de usu\xe1rio n\xe3o encontrado. Por favor, volte e fa\xe7a o login novamente.",
    interaction_not_found: "Sess\xe3o de intera\xe7\xe3o n\xe3o encontrada. Por favor, volte e inicie a sess\xe3o novamente.",
    not_supported_for_forgot_password: "Esta opera\xe7\xe3o n\xe3o \xe9 suportada para recupera\xe7\xe3o de senha.",
    mfa: {
        require_mfa_verification: "Verifica\xe7\xe3o MFA \xe9 necess\xe1ria para fazer login.",
        mfa_sign_in_only: "MFA est\xe1 dispon\xedvel apenas para intera\xe7\xe3o de login.",
        pending_info_not_found: "Informa\xe7\xf5es MFA pendentes n\xe3o encontradas, por favor inicie MFA primeiro.",
        invalid_totp_code: "C\xf3digo TOTP inv\xe1lido.",
        webauthn_verification_failed: "Falha na verifica\xe7\xe3o do WebAuthn.",
        webauthn_verification_not_found: "Verifica\xe7\xe3o WebAuthn n\xe3o encontrada.",
        bind_mfa_existed: "MFA j\xe1 existe.",
        backup_code_can_not_be_alone: "O c\xf3digo de backup n\xe3o pode ser o \xfanico MFA.",
        backup_code_required: "O c\xf3digo de backup \xe9 obrigat\xf3rio.",
        invalid_backup_code: "C\xf3digo de backup inv\xe1lido.",
        mfa_policy_not_user_controlled: "A pol\xedtica de MFA n\xe3o \xe9 controlada pelo usu\xe1rio."
    },
    sso_enabled: "O login \xfanico est\xe1 habilitado para este e-mail fornecido. Fa\xe7a login com SSO, por favor."
};
var $e1e5686e7a041443$export$2e2bcd8739ae039 = Object.freeze($e1e5686e7a041443$var$session);


const $a35af3c02cf1c32e$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL de conte\xfado "Termos de uso" vazia. Adicione o URL do conte\xfado se "Termos de uso" estiver ativado.',
    empty_social_connectors: "Conectores sociais vazios. Adicione conectores sociais ativados quando o m\xe9todo de login social estiver ativado.",
    enabled_connector_not_found: "Conector {{type}} ativado n\xe3o encontrado.",
    not_one_and_only_one_primary_sign_in_method: "Deve haver um m\xe9todo de login principal. Verifique sua entrada.",
    username_requires_password: "Deve permitir definir uma senha para o identificador de inscri\xe7\xe3o do nome de usu\xe1rio.",
    passwordless_requires_verify: "Deve ativar a verifica\xe7\xe3o do identificador de inscri\xe7\xe3o de e-mail/telefone.",
    miss_sign_up_identifier_in_sign_in: "Os m\xe9todos de login devem conter o identificador de inscri\xe7\xe3o.",
    password_sign_in_must_be_enabled: "O login com senha deve ser ativado quando definir uma senha \xe9 necess\xe1ria na inscri\xe7\xe3o.",
    code_sign_in_must_be_enabled: "O login do c\xf3digo de verifica\xe7\xe3o deve ser ativado quando definir uma senha n\xe3o \xe9 necess\xe1ria na inscri\xe7\xe3o.",
    unsupported_default_language: "Este idioma - {{language}} n\xe3o \xe9 suportado no momento.",
    at_least_one_authentication_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o.",
    backup_code_cannot_be_enabled_alone: "C\xf3digo de backup n\xe3o pode ser ativado sozinho.",
    duplicated_mfa_factors: "Fatores MFA duplicados."
};
var $a35af3c02cf1c32e$export$2e2bcd8739ae039 = Object.freeze($a35af3c02cf1c32e$var$sign_in_experiences);


const $389dc59606b7ce34$var$single_sign_on = {
    forbidden_domains: "Dom\xednios de e-mail p\xfablico n\xe3o s\xe3o permitidos.",
    duplicated_domains: "Existem dom\xednios duplicados.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $389dc59606b7ce34$export$2e2bcd8739ae039 = Object.freeze($389dc59606b7ce34$var$single_sign_on);


const $66c0b552176f660e$var$storage = {
    not_configured: "O provedor de armazenamento n\xe3o est\xe1 configurado.",
    missing_parameter: "Par\xe2metro {{parameter}} ausente para o provedor de armazenamento.",
    upload_error: "Falha ao fazer upload do arquivo para o provedor de armazenamento."
};
var $66c0b552176f660e$export$2e2bcd8739ae039 = Object.freeze($66c0b552176f660e$var$storage);


const $c77567e95e79cf7f$var$subscription = {
    limit_exceeded: "Voc\xea atingiu o limite do seu plano de assinatura.",
    get_plan_failed: "N\xe3o foi poss\xedvel obter o plano de assinatura para o inquilino.",
    tenant_suspended: "O inquilino est\xe1 suspenso. Por favor, entre em contato com o administrador."
};
var $c77567e95e79cf7f$export$2e2bcd8739ae039 = Object.freeze($c77567e95e79cf7f$var$subscription);


const $2e64e93d406ca338$var$swagger = {
    invalid_zod_type: "Zod type inv\xe1lido. Verifique a configura\xe7\xe3o do protetor de rota.",
    not_supported_zod_type_for_params: "Zod type n\xe3o suportado para os par\xe2metros. Verifique a configura\xe7\xe3o do protetor de rota."
};
var $2e64e93d406ca338$export$2e2bcd8739ae039 = Object.freeze($2e64e93d406ca338$var$swagger);


const $3bf7833122156795$var$user = {
    username_already_in_use: "Este nome de usu\xe1rio j\xe1 est\xe1 em uso.",
    email_already_in_use: "Este e-mail est\xe1 associado a uma conta existente.",
    phone_already_in_use: "Este n\xfamero de telefone est\xe1 associado a uma conta existente.",
    invalid_email: "Endere\xe7o de e-mail inv\xe1lido.",
    invalid_phone: "N\xfamero de telefone inv\xe1lido.",
    email_not_exist: "O endere\xe7o de e-mail ainda n\xe3o foi registrado.",
    phone_not_exist: "O n\xfamero de telefone ainda n\xe3o foi registrado.",
    identity_not_exist: "A conta social ainda n\xe3o foi registrada.",
    identity_already_in_use: "A conta social foi associada a uma conta existente.",
    social_account_exists_in_profile: "A conta social j\xe1 est\xe1 associada ao seu perfil.",
    cannot_delete_self: "Voc\xea n\xe3o pode excluir a si mesmo.",
    sign_up_method_not_enabled: "Este m\xe9todo de inscri\xe7\xe3o n\xe3o est\xe1 ativado",
    sign_in_method_not_enabled: "Este m\xe9todo de login n\xe3o est\xe1 habilitado.",
    same_password: "A nova senha n\xe3o pode ser igual \xe0 senha antiga.",
    password_required_in_profile: "Voc\xea precisa definir uma senha antes de entrar.",
    new_password_required_in_profile: "Voc\xea precisa definir uma nova senha.",
    password_exists_in_profile: "A senha j\xe1 existe em seu perfil.",
    username_required_in_profile: "Voc\xea precisa definir um nome de usu\xe1rio antes de entrar.",
    username_exists_in_profile: "O nome de usu\xe1rio j\xe1 existe em seu perfil.",
    email_required_in_profile: "Voc\xea precisa adicionar um endere\xe7o de e-mail antes de fazer login.",
    email_exists_in_profile: "Seu perfil j\xe1 foi associado a um endere\xe7o de e-mail.",
    phone_required_in_profile: "Voc\xea precisa adicionar um n\xfamero de telefone antes de fazer login.",
    phone_exists_in_profile: "Seu perfil j\xe1 foi associado a um n\xfamero de telefone.",
    email_or_phone_required_in_profile: "Voc\xea precisa adicionar um endere\xe7o de e-mail ou n\xfamero de telefone antes de fazer login.",
    suspended: "Esta conta est\xe1 suspensa.",
    user_not_exist: "O usu\xe1rio com {{ identifier }} n\xe3o existe",
    missing_profile: "Voc\xea precisa fornecer informa\xe7\xf5es adicionais antes de fazer login.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este usu\xe1rio",
    invalid_role_type: "Tipo de fun\xe7\xe3o inv\xe1lido, n\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o m\xe1quina a usu\xe1rio.",
    missing_mfa: "Voc\xea precisa vincular MFA adicional antes de fazer login.",
    totp_already_in_use: "TOTP j\xe1 est\xe1 em uso.",
    backup_code_already_in_use: "O c\xf3digo de backup j\xe1 est\xe1 em uso."
};
var $3bf7833122156795$export$2e2bcd8739ae039 = Object.freeze($3bf7833122156795$var$user);


const $d78f8f422b0567de$var$verification_code = {
    phone_email_empty: "Tanto o telefone quanto o e-mail est\xe3o vazios.",
    not_found: "C\xf3digo de verifica\xe7\xe3o n\xe3o encontrado. Por favor, envie um c\xf3digo de verifica\xe7\xe3o primeiro.",
    phone_mismatch: "Telefone n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    email_mismatch: "E-mail n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    code_mismatch: "C\xf3digo de verifica\xe7\xe3o inv\xe1lido.",
    expired: "O c\xf3digo de verifica\xe7\xe3o expirou. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    exceed_max_try: "Excedido o limite de tentativas de c\xf3digo de verifica\xe7\xe3o. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o."
};
var $d78f8f422b0567de$export$2e2bcd8739ae039 = Object.freeze($d78f8f422b0567de$var$verification_code);


const $fbcead12bb6fa025$var$errors = {
    request: $4b29fdae204da3e1$export$2e2bcd8739ae039,
    auth: $b76aaaf3226b8911$export$2e2bcd8739ae039,
    guard: $ae9a2193b739f7db$export$2e2bcd8739ae039,
    oidc: $e1f56e178b513745$export$2e2bcd8739ae039,
    user: $3bf7833122156795$export$2e2bcd8739ae039,
    password: $e323584056730bbc$export$2e2bcd8739ae039,
    session: $e1e5686e7a041443$export$2e2bcd8739ae039,
    connector: $0e33610310c47e86$export$2e2bcd8739ae039,
    verification_code: $d78f8f422b0567de$export$2e2bcd8739ae039,
    sign_in_experiences: $a35af3c02cf1c32e$export$2e2bcd8739ae039,
    localization: $695ff9b99b97a89b$export$2e2bcd8739ae039,
    swagger: $2e64e93d406ca338$export$2e2bcd8739ae039,
    entity: $858cc4ef477611a7$export$2e2bcd8739ae039,
    log: $3b0d2e0846751c60$export$2e2bcd8739ae039,
    role: $6f7e316bf2c6f74a$export$2e2bcd8739ae039,
    scope: $250d0e10926f5683$export$2e2bcd8739ae039,
    storage: $66c0b552176f660e$export$2e2bcd8739ae039,
    resource: $742b6a695e045f49$export$2e2bcd8739ae039,
    hook: $6068d4798743589b$export$2e2bcd8739ae039,
    domain: $a6ff6b43db3f3a8b$export$2e2bcd8739ae039,
    subscription: $c77567e95e79cf7f$export$2e2bcd8739ae039,
    application: $67d053e31f4639ed$export$2e2bcd8739ae039,
    organization: $f64e5c9e6630da02$export$2e2bcd8739ae039,
    single_sign_on: $389dc59606b7ce34$export$2e2bcd8739ae039
};
var $fbcead12bb6fa025$export$2e2bcd8739ae039 = Object.freeze($fbcead12bb6fa025$var$errors);


const $7fce9b2a22590be3$var$api_resource_details = {
    page_title: "Detalhes do Recurso da API",
    back_to_api_resources: "Voltar para os recursos da API",
    settings_tab: "Configura\xe7\xf5es",
    permissions_tab: "Permiss\xf5es",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os recursos da API, tamb\xe9m conhecidos como Indicadores de recursos, indicam os servi\xe7os ou recursos de destino a serem solicitados, geralmente uma vari\xe1vel de formato de URI que representa a identidade do recurso.",
    management_api_settings_description: "A API de Gerenciamento do Logto \xe9 uma cole\xe7\xe3o abrangente de APIs que capacitam os administradores a gerenciar uma ampla gama de tarefas relacionadas \xe0 identidade, aplicar pol\xedticas de seguran\xe7a e cumprir regulamentos e padr\xf5es.",
    management_api_notice: "Esta API representa a entidade Logto e n\xe3o pode ser modificada ou exclu\xedda. Voc\xea pode usar a API de gerenciamento para uma ampla gama de tarefas relacionadas \xe0 identidade. <a>Aprenda mais</a>",
    token_expiration_time_in_seconds: "Tempo de expira\xe7\xe3o do token (em segundos)",
    token_expiration_time_in_seconds_placeholder: "Digite o tempo de expira\xe7\xe3o do seu token",
    delete_description: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o recurso da API. Insira o nome do recurso da API <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Digite o nome do recurso da API",
    api_resource_deleted: "O recurso da API {{name}} foi exclu\xeddo com sucesso",
    permission: {
        create_button: "Criar Permiss\xe3o",
        create_title: "Criar permiss\xe3o",
        create_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rias para esta API.",
        confirm_create: "Criar permiss\xe3o",
        name: "Nome da permiss\xe3o",
        name_placeholder: "ler:recurso",
        forbidden_space_in_name: "O nome da permiss\xe3o n\xe3o deve conter espa\xe7os.",
        description: "Descri\xe7\xe3o",
        description_placeholder: "Capaz de ler os recursos",
        permission_created: "A permiss\xe3o {{name}} foi criada com sucesso",
        delete_description: "Se essa permiss\xe3o for exclu\xedda, o usu\xe1rio que tinha essa permiss\xe3o perder\xe1 o acesso concedido por ela.",
        deleted: 'A permiss\xe3o "{{name}}" foi exclu\xedda com sucesso.'
    }
};
var $7fce9b2a22590be3$export$2e2bcd8739ae039 = Object.freeze($7fce9b2a22590be3$var$api_resource_details);


const $440b3ca5e3eca9c3$var$api_resources = {
    page_title: "Recursos da API",
    title: "Recursos da API",
    subtitle: "Defina APIs que voc\xea pode consumir de seus aplicativos autorizados",
    create: "Criar recurso de API",
    api_name: "Nome da API",
    api_name_placeholder: "Digite o nome da sua API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "O identificador exclusivo para o recurso da API. Deve ser um URI absoluto e n\xe3o tem nenhum componente de fragmento (#). Igual ao <a>par\xe2metro de recurso</a> em OAuth 2.0.",
    default_api: "API padr\xe3o",
    default_api_label: "Apenas uma API padr\xe3o pode ser definida por locat\xe1rio. Quando uma API padr\xe3o \xe9 definida, o par\xe2metro de recurso pode ser omitido na solicita\xe7\xe3o de autentica\xe7\xe3o. As trocas de token subsequentes usar\xe3o essa API como audi\xeancia por padr\xe3o, resultando na emiss\xe3o de JWTs. <a>Saiba mais</a>",
    api_resource_created: "O recurso API {{name}} foi criado com sucesso"
};
var $440b3ca5e3eca9c3$export$2e2bcd8739ae039 = Object.freeze($440b3ca5e3eca9c3$var$api_resources);


const $685061a5164cd0f4$var$application_details = {
    page_title: "Detalhes da aplica\xe7\xe3o",
    back_to_applications: "Voltar para Aplicativos",
    check_guide: "Visualizar o guia",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os aplicativos s\xe3o usados para identificar seus aplicativos no Logto para OIDC, experi\xeancia de login, logs de auditoria, etc.",
    advanced_settings: "Configura\xe7\xf5es avan\xe7adas",
    advanced_settings_description: "As configura\xe7\xf5es avan\xe7adas incluem termos relacionados ao OIDC. Voc\xea pode conferir o Token Endpoint para obter mais informa\xe7\xf5es.",
    application_roles: "Fun\xe7\xf5es do aplicativo",
    machine_logs: "Logs da m\xe1quina",
    application_name: "Nome do aplicativo",
    application_name_placeholder: "Meu aplicativo",
    description: "Descri\xe7\xe3o",
    description_placeholder: "Digite a descri\xe7\xe3o do seu aplicativo",
    config_endpoint: "Endpoint de configura\xe7\xe3o do OpenID Provider",
    authorization_endpoint: "Endpoint de autoriza\xe7\xe3o",
    authorization_endpoint_tip: "O endpoint para executar autentica\xe7\xe3o e autoriza\xe7\xe3o. \xc9 usado para <a>autentica\xe7\xe3o</a> OpenID Connect.",
    logto_endpoint: "Endpoint do Logto",
    application_id: "ID do aplicativo",
    application_id_tip: "O identificador exclusivo do aplicativo normalmente gerado pela Logto. Tamb\xe9m \xe9 conhecido como “<a>client_id</a>” em OpenID Connect.",
    application_secret: "Segredo do aplicativo",
    redirect_uri: "URI de redirecionamento",
    redirect_uris: "URIs de redirecionamento",
    redirect_uri_placeholder: "https://seusite.com.br/app",
    redirect_uri_placeholder_native: "io.logto://retorno",
    redirect_uri_tip: "O URI \xe9 redirecionado ap\xf3s o login do usu\xe1rio (seja bem-sucedido ou n\xe3o). Consulte OpenID Connect <a>AuthRequest</a> para obter mais informa\xe7\xf5es.",
    post_sign_out_redirect_uri: "URI de redirecionamento ap\xf3s sa\xedda",
    post_sign_out_redirect_uris: "URIs de redirecionamento ap\xf3s sa\xedda",
    post_sign_out_redirect_uri_placeholder: "https://seusite.com.br/home",
    post_sign_out_redirect_uri_tip: "O URI \xe9 redirecionado ap\xf3s a sa\xedda do usu\xe1rio (opcional). Pode n\xe3o ter efeito pr\xe1tico em alguns tipos de aplicativos.",
    cors_allowed_origins: "Origens permitidas pelo CORS",
    cors_allowed_origins_placeholder: "https://seusite.com.br",
    cors_allowed_origins_tip: "Por padr\xe3o, todas as origens de URIs de redirecionamento ser\xe3o permitidas. Normalmente, nenhuma a\xe7\xe3o \xe9 necess\xe1ria para este campo. Confira o <a>doc MDN</a> para informa\xe7\xf5es detalhadas.",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "Userinfo Endpoint",
    enable_admin_access: "Ativar acesso de administrador",
    enable_admin_access_label: "Ative ou desative o acesso \xe0 API de gerenciamento. Uma vez ativado, voc\xea pode usar tokens de acesso para chamar a API de gerenciamento em nome deste aplicativo.",
    always_issue_refresh_token: "Emitir sempre o token de refresh",
    always_issue_refresh_token_label: 'Ativar esta configura\xe7\xe3o permitir\xe1 que a Logto emita sempre tokens de Refresh, independentemente de "prompt=consent" ser apresentado na solicita\xe7\xe3o de autentica\xe7\xe3o. No entanto, essa pr\xe1tica \xe9 desencorajada, a menos que seja necess\xe1ria, pois n\xe3o \xe9 compat\xedvel com o OpenID Connect e pode potencialmente causar problemas.',
    refresh_token_ttl: "Tempo de vida do Refresh Token em dias",
    refresh_token_ttl_tip: "A dura\xe7\xe3o para a qual um Refresh Token pode ser usado para solicitar novos tokens de acesso antes que expire e se torne inv\xe1lido. As solicita\xe7\xf5es de token estender\xe3o o TTL do Refresh Token para este valor.",
    rotate_refresh_token: "Rotacionar Refresh Token",
    rotate_refresh_token_label: "Quando ativado, a Logto emitir\xe1 um novo Refresh Token para solicita\xe7\xf5es de token quando 70% do tempo de vida original (TTL) tenha passado ou certas condi\xe7\xf5es sejam atendidas. <a>Saiba mais</a>",
    delete_description: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o aplicativo. Insira o nome do aplicativo <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Digite o nome do seu aplicativo",
    application_deleted: "O aplicativo {{name}} foi exclu\xeddo com sucesso",
    redirect_uri_required: "Voc\xea deve inserir pelo menos um URI de redirecionamento",
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o remover\xe1 esta fun\xe7\xe3o deste aplicativo m\xe1quina-a-m\xe1quina. A fun\xe7\xe3o ainda existir\xe1, mas n\xe3o ser\xe1 mais associada a este aplicativo m\xe1quina-a-m\xe1quina.",
        deleted: "{{name}} foi removido com sucesso deste usu\xe1rio.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar pelo nome da fun\xe7\xe3o",
        added_text: "{{value, number}} adicionados",
        assigned_app_count: "{{value, number}} aplicativos",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(s) atribu\xedda(s) com sucesso",
        search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    }
};
var $685061a5164cd0f4$export$2e2bcd8739ae039 = Object.freeze($685061a5164cd0f4$var$application_details);


const $5260c9fe39bfcc36$var$applications = {
    page_title: "Aplicativos",
    title: "Aplicativos",
    subtitle: "Configure um aplicativo m\xf3vel, single page, machine to machine ou tradicional para usar o Logto para autentica\xe7\xe3o",
    subtitle_with_app_type: "Configure a autentica\xe7\xe3o Logto para o seu aplicativo {{name}}",
    create: "Criar aplicativo",
    application_name: "Nome do Aplicativo",
    application_name_placeholder: "Meu aplicativo",
    application_description: "Descri\xe7\xe3o do aplicativo",
    application_description_placeholder: "Digite a descri\xe7\xe3o do seu aplicativo",
    select_application_type: "Selecione um tipo de aplicativo",
    no_application_type_selected: "Voc\xea ainda n\xe3o selecionou nenhum tipo de aplicativo",
    application_created: "O aplicativo foi criado com sucesso.",
    app_id: "App ID",
    type: {
        native: {
            title: "Aplicativo Nativo",
            subtitle: "Um aplicativo executado em um ambiente nativo",
            description: "Ex: aplicativo iOS, aplicativo Android"
        },
        spa: {
            title: "Aplicativo de P\xe1gina \xdanica",
            subtitle: "Um aplicativo que \xe9 executado em um navegador da Web e atualiza dinamicamente os dados no local",
            description: "Ex: aplicativo React DOM, aplicativo Vue"
        },
        traditional: {
            title: "Web Tradicional",
            subtitle: "Um aplicativo que renderiza e atualiza p\xe1ginas apenas pelo servidor da web",
            description: "Ex: aplicativo Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Um aplicativo (geralmente um servi\xe7o) que fala diretamente com os recursos",
            description: "Ex: servi\xe7o de backend"
        }
    },
    placeholder_title: "Selecione um tipo de aplicativo para continuar",
    placeholder_description: "O Logto usa uma entidade de aplicativo para OIDC para ajudar nas tarefas, como identificar seus aplicativos, gerenciar o login e criar logs de auditoria."
};
var $5260c9fe39bfcc36$export$2e2bcd8739ae039 = Object.freeze($5260c9fe39bfcc36$var$applications);


const $64549226245b8ac7$var$cloud = {
    general: {
        onboarding: "Integra\xe7\xe3o"
    },
    welcome: {
        page_title: "Bem-vindo",
        title: "Bem-vindo ao Logto Cloud! Gostar\xedamos de conhecer um pouco sobre voc\xea.",
        description: "Vamos tornar sua experi\xeancia Logto \xfanica, conhecendo voc\xea melhor. Suas informa\xe7\xf5es est\xe3o seguras conosco.",
        project_field: "Estou usando o Logto para",
        project_options: {
            personal: "Projeto pessoal",
            company: "Projeto da empresa"
        },
        title_field: "Selecione o(s) t\xedtulo(s) aplic\xe1vel(eis)",
        title_options: {
            developer: "Desenvolvedor",
            team_lead: "L\xedder de equipe",
            ceo: "CEO",
            cto: "CTO",
            product: "Produto",
            others: "Outros"
        },
        company_name_field: "Nome da empresa",
        company_name_placeholder: "Acme.co",
        company_size_field: "Qual o tamanho da sua empresa?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Estou me inscrevendo porque",
        reason_options: {
            passwordless: "Procurando autentica\xe7\xe3o sem senha e kit de IU",
            efficiency: "Encontrando infraestrutura de identidade pronta para uso",
            access_control: "Controlando o acesso do usu\xe1rio com base em fun\xe7\xf5es e responsabilidades",
            multi_tenancy: "Buscando estrat\xe9gias para um produto multi-inquilino",
            enterprise: "Encontrando solu\xe7\xf5es SSO para prontid\xe3o corporativa",
            others: "Outros"
        }
    },
    sie: {
        page_title: "Personalize a experi\xeancia de logon",
        title: "Vamos personalizar sua experi\xeancia de logon facilmente",
        inspire: {
            title: "Crie exemplos convincentes",
            description: 'Sentindo-se inseguro sobre a experi\xeancia de login? Basta clicar em "Inspirar-me" e deixar a m\xe1gica acontecer!',
            inspire_me: "Inspirar-me"
        },
        logo_field: "Logotipo do aplicativo",
        color_field: "Cor da marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "E-mail",
            phone: "Telefone",
            user_name: "Nome de usu\xe1rio"
        },
        authn_field: "Autentica\xe7\xe3o",
        authn_options: {
            password: "Senha",
            verification_code: "C\xf3digo de verifica\xe7\xe3o"
        },
        social_field: "Login social",
        finish_and_done: "Finalizar e feito",
        preview: {
            mobile_tab: "Celular",
            web_tab: "Internet"
        },
        connectors: {
            unlocked_later: "Desbloqueado mais tarde",
            unlocked_later_tip: "Assim que voc\xea concluir o processo de integra\xe7\xe3o e entrar no produto, ter\xe1 acesso a ainda mais m\xe9todos de login social.",
            notice: "Evite usar o conector de demonstra\xe7\xe3o para fins de produ\xe7\xe3o. Depois de conclu\xeddos os testes, exclua gentilmente o conector de demonstra\xe7\xe3o e configure seu pr\xf3prio conector com suas credenciais."
        }
    },
    socialCallback: {
        title: "Voc\xea entrou com sucesso",
        description: "Voc\xea entrou com sucesso usando sua conta social. Para garantir a integra\xe7\xe3o perfeita e o acesso a todos os recursos do Logto, recomendamos que voc\xea prossiga para configurar seu pr\xf3prio conector social."
    },
    tenant: {
        create_tenant: "Criar inquilino"
    }
};
var $64549226245b8ac7$export$2e2bcd8739ae039 = Object.freeze($64549226245b8ac7$var$cloud);


const $63545e196cb052a7$var$components = {
    uploader: {
        action_description: "Arraste e solte ou procure",
        uploading: "Enviando...",
        image_limit: "Carregue imagens abaixo de {{size, number}}KB, apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo deu errado. Falha ao enviar arquivo.",
        error_file_size: "Tamanho do arquivo \xe9 muito grande. Por favor, envie um arquivo abaixo de {{size, number}}KB.",
        error_file_type: "Tipo de arquivo n\xe3o \xe9 suportado. Apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Voc\xea s\xf3 pode enviar 1 arquivo."
    }
};
var $63545e196cb052a7$export$2e2bcd8739ae039 = Object.freeze($63545e196cb052a7$var$components);


const $57508cb64fdcf14b$var$connector_details = {
    page_title: "Detalhes do conector",
    back_to_connectors: "Voltar para Conectores",
    check_readme: "Visualize o README",
    settings: "Configura\xe7\xf5es gerais",
    settings_description: "Os conectores desempenham um papel cr\xedtico no Logto. Com a ajuda deles, a Logto permite que os usu\xe1rios finais usem o registro ou login sem senha e os recursos de login com contas sociais.",
    parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
    test_connection: "Testar conex\xe3o",
    save_error_empty_config: "Por favor insira a configura\xe7\xe3o",
    send: "Enviar",
    send_error_invalid_format: "Campo inv\xe1lido",
    edit_config_label: "Digite seu json aqui",
    test_email_sender: "Testar conex\xe3o de e-mail",
    test_sms_sender: "Testar conex\xe3o SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+55 11 9 1234-5678",
    test_message_sent: "Mensagem de teste enviada",
    test_sender_description: 'O Logto utiliza o modelo "Generic" para testes. Voc\xea receber\xe1 uma mensagem se o seu conector estiver configurado corretamente.',
    options_change_email: "Alterar conector de e-mail",
    options_change_sms: "Alterar conector de SMS",
    connector_deleted: "O conector foi exclu\xeddo com sucesso",
    type_email: "Conector de e-mail",
    type_sms: "Conector de SMS",
    type_social: "Conector social",
    in_used_social_deletion_description: "Este conector est\xe1 em uso em sua experi\xeancia de login. Ao exclu\xed-lo, a experi\xeancia de login <name/> ser\xe1 exclu\xedda nas configura\xe7\xf5es de experi\xeancia de login. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    in_used_passwordless_deletion_description: "Este {{name}} est\xe1 em uso em sua experi\xeancia de login. Ao exclu\xed-lo, sua experi\xeancia de login n\xe3o funcionar\xe1 corretamente at\xe9 que voc\xea resolva o conflito. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    deletion_description: "Voc\xea est\xe1 removendo este conector. Isso n\xe3o pode ser desfeito e voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo novamente.",
    logto_email: {
        total_email_sent: "Total de e-mails enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza SendGrid para envio seguro e est\xe1vel de e-mails integrados. \xc9 completamente gratuito para uso. <a>Saiba mais</a>",
        email_template_title: "Modelo de e-mail",
        template_description: "O e-mail integrado usa modelos padr\xe3o para entrega perfeita de e-mails de verifica\xe7\xe3o. Nenhuma configura\xe7\xe3o \xe9 necess\xe1ria e voc\xea pode personalizar informa\xe7\xf5es b\xe1sicas da marca.",
        template_description_link_text: "Visualizar modelos",
        description_action_text: "Ver modelos",
        from_email_field: "E-mail do remetente",
        sender_name_field: "Nome do remetente",
        sender_name_tip: 'Personalize o nome do remetente para e-mails. Se deixado em branco, "Verification" ser\xe1 usado como nome padr\xe3o.',
        sender_name_placeholder: "Seu nome de remetente",
        company_information_field: "Informa\xe7\xf5es da empresa",
        company_information_description: "Exiba o nome da sua empresa, endere\xe7o ou c\xf3digo postal no final dos e-mails para melhorar a autenticidade.",
        company_information_placeholder: "Informa\xe7\xf5es b\xe1sicas da sua empresa",
        app_logo_field: "Logotipo do aplicativo",
        app_logo_tip: "Exiba o logotipo da sua marca no topo dos e-mails. Use a mesma imagem para o modo claro e escuro.",
        urls_not_allowed: "URLs n\xe3o permitidas",
        test_notes: 'Logto utiliza o modelo "Gen\xe9rico" para testes.'
    }
};
var $57508cb64fdcf14b$export$2e2bcd8739ae039 = Object.freeze($57508cb64fdcf14b$var$connector_details);


const $478533596fc51c12$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar a experi\xeancia de login social e sem senha",
    create: "Adicionar conector social",
    config_sie_notice: "Voc\xea configurou os conectores. Certifique-se de configur\xe1-lo em <a>{{link}}</a>.",
    config_sie_link_text: "experi\xeancia de login",
    tab_email_sms: "Conectores de Email e SMS",
    tab_social: "Conectores sociais",
    connector_name: "Nome do conector",
    demo_tip: "O n\xfamero m\xe1ximo de mensagens permitidas para este conector de demonstra\xe7\xe3o \xe9 limitado a 100 e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    social_demo_tip: "O conector de demonstra\xe7\xe3o \xe9 projetado exclusivamente para fins de demonstra\xe7\xe3o e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    connector_type: "Tipo",
    connector_status: "Experi\xeancia de login",
    connector_status_in_use: "Em uso",
    connector_status_not_in_use: "Fora de uso",
    not_in_use_tip: {
        content: "Fora de uso significa que sua experi\xeancia de login n\xe3o usou esse m\xe9todo de login. <a>{{link}}</a> para adicionar este m\xe9todo de login. ",
        go_to_sie: "V\xe1 para a experi\xeancia de login"
    },
    placeholder_title: "Conector social",
    placeholder_description: "Logto tem fornecido muitos conectores de login social amplamente utilizados enquanto voc\xea pode criar o seu pr\xf3prio com padr\xf5es padr\xe3o.",
    save_and_done: "Salvar e completar",
    type: {
        email: "Conector de e-mail",
        sms: "Conector de SMS",
        social: "Conector social"
    },
    setup_title: {
        email: "Configurar conector de e-mail",
        sms: "Configurar conector SMS",
        social: "Adicionar conector social"
    },
    guide: {
        subtitle: "Um guia passo a passo para configurar seu conector",
        general_setting: "Configura\xe7\xf5es gerais",
        parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
        test_connection: "Teste de conex\xe3o",
        name: "Nome do bot\xe3o de login social",
        name_placeholder: "Insira o nome do bot\xe3o de login social",
        name_tip: 'O nome do bot\xe3o do conector ser\xe1 exibido como "Continuar com {{Nome do Conector}}".',
        logo: "URL do logo para o bot\xe3o de login social",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "A imagem do logotipo tamb\xe9m ser\xe1 exibida no bot\xe3o do conector.",
        logo_dark: "URL do logo para o bot\xe3o de login social (modo escuro)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Defina o logotipo do seu conector para o modo escuro depois de ativ\xe1-lo na Experi\xeancia de login do Console de Administra\xe7\xe3o.",
        logo_dark_collapse: "Expandir",
        logo_dark_show: "Mostrar configura\xe7\xe3o de logotipo para modo escuro",
        target: "Nome do fornecedor de identidade",
        target_placeholder: "Insira o nome do fornecedor de identidade do conector",
        target_tip: 'O valor de "Nome do fornecedor de identidade" pode ser uma string de identificador exclusiva para distinguir suas identidades sociais.',
        target_tip_standard: 'O valor de "Nome do fornecedor de identidade" pode ser uma string de identificador exclusiva para distinguir suas identidades sociais. Essa configura\xe7\xe3o n\xe3o pode ser alterada ap\xf3s a cria\xe7\xe3o do conector.',
        target_tooltip: '"Target" nos conectores sociais Logto refere-se \xe0 "origem" de suas identidades sociais. No design do Logto, n\xe3o aceitamos o mesmo "target" de uma plataforma espec\xedfica para evitar conflitos. Voc\xea deve tomar muito cuidado antes de adicionar um conector, pois N\xc3O PODE mudar seu valor depois de cri\xe1-lo. <a>Saiba mais</a>',
        target_conflict: "O nome de IdP inserido corresponde ao <span>nome</span> existente. Usar o mesmo nome do IDP pode causar comportamento inesperado ao entrar onde os usu\xe1rios podem acessar a mesma conta por meio de dois conectores diferentes.",
        target_conflict_line2: 'Se voc\xea deseja substituir o conector atual pelo mesmo fornecedor de identidade e permitir que usu\xe1rios antigos fa\xe7am login sem se registrar novamente, exclua o conector <span>nome</span> e crie um novo com o mesmo "Nome do fornecedor de identidade".',
        target_conflict_line3: 'Se voc\xea deseja se conectar a um provedor de identidade diferente, modifique o "Nome do fornecedor de identidade" e prossiga.',
        config: "Digite seu JSON aqui",
        sync_profile: "Sincronizar informa\xe7\xf5es de perfil",
        sync_profile_only_at_sign_up: "Sincronizar apenas no registro",
        sync_profile_each_sign_in: "Sempre sincronizar a cada login",
        sync_profile_tip: "Sincronize o perfil b\xe1sico do provedor social, como os nomes dos usu\xe1rios e seus avatares.",
        callback_uri: "URI de retorno do chamado",
        callback_uri_description: "Tamb\xe9m chamado de URI de redirecionamento, \xe9 a URI no Logto para a qual os usu\xe1rios ser\xe3o enviados de volta ap\xf3s a autoriza\xe7\xe3o social; copie e cole na p\xe1gina de configura\xe7\xe3o do provedor social."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nat"
    },
    add_multi_platform: "suporta v\xe1rias plataformas, selecione uma plataforma para continuar",
    drawer_title: "Guia do Conector",
    drawer_subtitle: "Siga as instru\xe7\xf5es para integrar seu conector",
    unknown: "Conector desconhecido",
    standard_connectors: "Conectores padr\xe3o"
};
var $478533596fc51c12$export$2e2bcd8739ae039 = Object.freeze($478533596fc51c12$var$connectors);


const $6904d12f56f6bbee$var$contact = {
    title: "Obter ajuda",
    description: "Para solicita\xe7\xf5es de ajuda ou feedback do produto, entre em contato conosco pelos seguintes m\xe9todos.",
    discord: {
        title: "Participe da comunidade Discord",
        description: "Conecte-se com outros desenvolvedores para encontrar solu\xe7\xf5es",
        button: "Participar"
    },
    github: {
        title: "Comunique-se no GitHub",
        description: "Crie um problema e envie-o no GitHub",
        button: "Abrir"
    },
    email: {
        title: "Entre em contato com o suporte via email",
        description: "Envie um email para obter mais informa\xe7\xf5es e ajuda",
        button: "Enviar"
    },
    reserve: {
        title: "Reserve seu hor\xe1rio com a equipe da Logto",
        description: "Agende uma sess\xe3o para um bate-papo ao vivo",
        button: "Agendar"
    }
};
var $6904d12f56f6bbee$export$2e2bcd8739ae039 = Object.freeze($6904d12f56f6bbee$var$contact);


const $a02125e7fe8612c2$var$dashboard = {
    page_title: "Painel",
    title: "Painel",
    description: "Obtenha uma vis\xe3o geral sobre o desempenho do seu aplicativo",
    total_users: "Total de usu\xe1rios",
    total_users_tip: "Total de usu\xe1rios",
    new_users_today: "Novos usu\xe1rios hoje",
    new_users_today_tip: "O n\xfamero de novos usu\xe1rios registrados em seus aplicativos hoje",
    new_users_7_days: "Novos usu\xe1rios nos \xfaltimos 7 dias",
    new_users_7_days_tip: "O n\xfamero de novos usu\xe1rios registrados em seus aplicativos nos \xfaltimos 7 dias",
    daily_active_users: "Usu\xe1rios ativos diariamente",
    daily_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos hoje",
    weekly_active_users: "Usu\xe1rios ativos semanalmente",
    weekly_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos nos \xfaltimos 7 dias",
    monthly_active_users: "Usu\xe1rios ativos mensais",
    monthly_active_users_tip: "O n\xfamero de tokens trocados por usu\xe1rios \xfanicos em seus aplicativos nos \xfaltimos 30 dias"
};
var $a02125e7fe8612c2$export$2e2bcd8739ae039 = Object.freeze($a02125e7fe8612c2$var$dashboard);


const $d8979efed83ddc06$var$domain = {
    status: {
        connecting: "Conectando",
        in_used: "Em uso",
        failed_to_connect: "Falha na conex\xe3o"
    },
    update_endpoint_notice: "N\xe3o se esque\xe7a de atualizar o dom\xednio para o URI de retorno do conector social e o ponto de extremidade de logto em seu aplicativo se voc\xea quiser usar um dom\xednio personalizado para os recursos. <a>{{link}}</a>",
    error_hint: "Certifique-se de atualizar seus registros DNS. N\xf3s continuaremos a verifica\xe7\xe3o a cada {{value}} segundos.",
    custom: {
        custom_domain: "Dom\xednio personalizado",
        custom_domain_description: "Melhore sua marca utilizando um dom\xednio personalizado. Este dom\xednio ser\xe1 utilizado em sua experi\xeancia de login.",
        custom_domain_field: "Dom\xednio personalizado",
        custom_domain_placeholder: "seu.dom\xednio.com",
        add_domain: "Adicionar dom\xednio",
        invalid_domain_format: "Formato de subdom\xednio inv\xe1lido. Insira um subdom\xednio com pelo menos tr\xeas partes.",
        verify_domain: "Verificar dom\xednio",
        enable_ssl: "Habilitar SSL",
        checking_dns_tip: "Ap\xf3s configurar os registros DNS, o processo ser\xe1 iniciado automaticamente e pode levar at\xe9 24 horas. Voc\xea pode deixar esta interface enquanto o processo \xe9 executado.",
        enable_ssl_tip: "Habilitar SSL ser\xe1 executado automaticamente e pode levar at\xe9 24 horas. Voc\xea pode deixar esta interface enquanto o processo \xe9 executado.",
        generating_dns_records: "Gerando os registros DNS...",
        add_dns_records: "Por favor, adicione estes registros DNS ao seu provedor DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Excluir dom\xednio",
            reminder: "Excluir dom\xednio personalizado",
            description: "Tem certeza de que deseja excluir este dom\xednio personalizado?",
            in_used_description: 'Tem certeza de que deseja excluir este dom\xednio personalizado "<span>{{domain}}</span>"?',
            in_used_tip: 'Se voc\xea configurou este dom\xednio personalizado em seu provedor de conex\xe3o social ou ponto de extremidade de aplicativo antes, voc\xea precisar\xe1 modificar a URI para o dom\xednio padr\xe3o do Logto "<span>{{domain}}</span>" primeiro. Isso \xe9 necess\xe1rio para que o bot\xe3o de login social funcione corretamente.',
            deleted: "Dom\xednio personalizado exclu\xeddo com sucesso!"
        }
    },
    default: {
        default_domain: "Dom\xednio padr\xe3o",
        default_domain_description: "Logto oferece um dom\xednio padr\xe3o pr\xe9-configurado, pronto para uso sem nenhuma configura\xe7\xe3o adicional. Este dom\xednio padr\xe3o serve como uma op\xe7\xe3o de backup mesmo se voc\xea habilitou um dom\xednio personalizado.",
        default_domain_field: "Dom\xednio padr\xe3o do Logto"
    },
    custom_endpoint_note: 'Voc\xea pode personalizar o nome de dom\xednio desses endpoints conforme necess\xe1rio. Escolha "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Voc\xea pode personalizar o nome de dom\xednio desta URI para corresponder ao endpoint de seu aplicativo. Escolha "{{custom}}" ou "{{default}}".'
};
var $d8979efed83ddc06$export$2e2bcd8739ae039 = Object.freeze($d8979efed83ddc06$var$domain);


const $636cd33e8076db0a$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $636cd33e8076db0a$export$2e2bcd8739ae039 = Object.freeze($636cd33e8076db0a$var$enterprise_sso_details);


const $921d4766163924fc$var$enterprise_sso = {
    page_title: "SSO Empresarial",
    title: "SSO Empresarial",
    subtitle: "Conecte-se ao provedor de identidade empresarial e habilite o Logon \xdanico iniciado pelo provedor de servi\xe7o (SP).",
    create: "Adicionar conector empresarial",
    col_connector_name: "Nome do conector",
    col_type: "Tipo",
    col_email_domain: "Dom\xednio de e-mail",
    placeholder_title: "Conector empresarial",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Adicionar conector empresarial",
        text_divider: "Ou voc\xea pode personalizar seu conector usando um protocolo padr\xe3o.",
        connector_name_field_title: "Nome do conector",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Criar conector"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $921d4766163924fc$export$2e2bcd8739ae039 = Object.freeze($921d4766163924fc$var$enterprise_sso);


const $600a311aa5c074c5$var$errors = {
    something_went_wrong: "Ops! Algo deu errado.",
    page_not_found: "P\xe1gina n\xe3o encontrada",
    unknown_server_error: "Ocorreu um erro desconhecido no servidor",
    empty: "Sem dados",
    missing_total_number: "N\xe3o foi poss\xedvel encontrar Total-Number nos cabe\xe7alhos de resposta",
    invalid_uri_format: "Formato de URI inv\xe1lido",
    invalid_origin_format: "Formato de origem de URI inv\xe1lido",
    invalid_json_format: "Formato JSON inv\xe1lido",
    invalid_error_message_format: "O formato da mensagem de erro \xe9 inv\xe1lido.",
    required_field_missing: "Por favor, insira {{field}}",
    required_field_missing_plural: "Voc\xea deve inserir pelo menos um {{field}}",
    more_details: "Mais detalhes",
    username_pattern_error: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhado e n\xe3o deve come\xe7ar com um n\xfamero.",
    email_pattern_error: "O endere\xe7o de e-mail \xe9 inv\xe1lido.",
    phone_pattern_error: "O n\xfamero de telefone \xe9 inv\xe1lido.",
    insecure_contexts: "Contextos inseguros (n\xe3o-HTTPS) n\xe3o s\xe3o suportados.",
    unexpected_error: "Um erro inesperado ocorreu",
    not_found: "404 n\xe3o encontrado",
    create_internal_role_violation: 'Voc\xea est\xe1 criando uma nova fun\xe7\xe3o interna que \xe9 proibida pela Logto. Tente outro nome que n\xe3o comece com "#internal:".',
    should_be_an_integer: "Deveria ser um inteiro.",
    number_should_be_between_inclusive: "Ent\xe3o o n\xfamero deve estar entre {{min}} e {{max}} (ambos inclusive)."
};
var $600a311aa5c074c5$export$2e2bcd8739ae039 = Object.freeze($600a311aa5c074c5$var$errors);


const $c402f0ddaf320a56$var$general = {
    placeholder: "Espa\xe7o reservado",
    submit: "Enviar",
    skip: "Pular",
    next: "Pr\xf3ximo",
    back: "Voltar",
    retry: "Tentar novamente",
    done: "Feito",
    search: "Buscar",
    search_placeholder: "Buscar",
    clear_result: "Limpar resultados",
    save: "Salvar",
    save_changes: "Salvar altera\xe7\xf5es",
    saved: "Salvo",
    discard: "Descartar",
    loading: "Carregando...",
    redirecting: "Redirecionando...",
    add: "Adicionar",
    added: "Adicionado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Finalizar compra",
    create: "Criar",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Habilitar",
    reminder: "Lembrete",
    delete: "Excluir",
    more_options: "MAIS OP\xc7\xd5ES",
    close: "Fechar",
    copy: "Copiar",
    copying: "Copiando",
    copied: "Copiado",
    required: "Obrigat\xf3rio",
    add_another: "Adicionar outro",
    create_another: "Criar outro",
    deletion_confirmation: "Tem certeza de que deseja excluir este {{title}}?",
    settings_nav: "Configura\xe7\xf5es",
    unsaved_changes_warning: "Voc\xea fez algumas altera\xe7\xf5es. Tem certeza de que deseja sair desta p\xe1gina?",
    leave_page: "Sair da p\xe1gina",
    stay_on_page: "Permanecer na p\xe1gina",
    type_to_search: "Digite para pesquisar",
    got_it: "Entendi",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saiba mais",
    tab_errors: "{{count, number}} erros",
    skip_for_now: "Pular por agora",
    remove: "Remover",
    visit: "Visitar",
    join: "Entrar",
    try_now: "Experimentar agora",
    multiple_form_field: "(M\xfaltiplo)",
    demo: "Demo",
    unnamed: "Sem nome",
    view: "Ver",
    hide: "Ocultar",
    unknown_error: "Erro desconhecido, por favor tente novamente mais tarde.",
    select: "Selecionar",
    contact_us_action: "Contate-nos",
    description: "Descri\xe7\xe3o",
    name: "Nome",
    add_field: "Adicionar {{field}}",
    create_field: "Criar {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Excluir {{field}}",
    coming_soon: "Em breve",
    beta_notice: "\uD83C\uDF89  {{feature}} est\xe1 atualmente em beta. Bem-vindo para explor\xe1-lo e <ContactLink>compartilhar seu feedback</ContactLink>."
};
var $c402f0ddaf320a56$export$2e2bcd8739ae039 = Object.freeze($c402f0ddaf320a56$var$general);


const $96f5bc184f6d7d39$var$get_started = {
    page_title: "Come\xe7ar",
    title: "Algo para explorar para ajud\xe1-lo a ter sucesso",
    subtitle: "Algumas coisas que voc\xea pode fazer para obter rapidamente valor do Logto",
    develop: {
        title: "Desenvolva: Dedique 5 minutos para integrar o seu aplicativo"
    },
    customize: {
        title: "Personalize: Ofere\xe7a uma \xf3tima experi\xeancia de login",
        preview: {
            title: "Verifique a visualiza\xe7\xe3o ao vivo da experi\xeancia de login que voc\xea acabou de personalizar",
            subtitle: "Experimente agora a experi\xeancia de login do Logto para ver como ela funciona"
        },
        connector: {
            title: "Adicione mais conectores para oferecer mais m\xe9todos de login social",
            subtitle: "Experimente o login sem senha e habilite uma experi\xeancia segura e sem atritos para seus clientes"
        },
        continue_customizing: "Continuar personalizando",
        try_now: "Experimente agora",
        add_more: "Adicionar mais"
    },
    secure: {
        title: "Seguran\xe7a: Proteja seus recursos"
    },
    manage: {
        title: "Gerencie: Defina o controle de acesso para seu produto e usu\xe1rios",
        rbac: {
            title: "Adicione controle de acesso baseado em fun\xe7\xf5es para proteger seus recursos",
            subtitle: "Controle seus recursos por meio de autoriza\xe7\xe3o baseada em fun\xe7\xe3o escal\xe1vel para diversos casos de uso."
        },
        create_roles: "Criar fun\xe7\xf5es"
    },
    view_all: "Ver todos →"
};
var $96f5bc184f6d7d39$export$2e2bcd8739ae039 = Object.freeze($96f5bc184f6d7d39$var$get_started);


const $a354c9010aa5f1fa$var$guide = {
    start_building: "Come\xe7ar a construir",
    get_started: "Iniciar",
    categories: {
        featured: "Popular e para voc\xea",
        Traditional: "Aplicativo web tradicional",
        SPA: "Aplicativo de p\xe1gina \xfanica",
        Native: "Nativo",
        MachineToMachine: "M\xe1quina a m\xe1quina"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Pesquisar framework"
    },
    checkout_tutorial: "Verificar tutorial {{name}}",
    do_not_need_tutorial: "Se voc\xea n\xe3o precisa de um tutorial, voc\xea pode continuar sem um guia de framework",
    finish_and_done: "Concluir e finalizado",
    cannot_find_guide: "N\xe3o \xe9 poss\xedvel encontrar seu guia?",
    describe_guide_looking_for: "Descreva o guia que voc\xea est\xe1 procurando",
    request_guide_successfully: "Sua solicita\xe7\xe3o foi enviada com sucesso. Obrigado!",
    app: {
        select_framework_or_tutorial: "Selecionar um framework ou tutorial",
        guide_modal_title: "Iniciar com SDK e guias",
        modal_subtitle: "Inicie seu processo de desenvolvimento de aplicativo com nosso SDK pr\xe9-constru\xeddo e tutoriais.",
        select_a_framework: "Selecionar um framework",
        continue_without_framework: "Criar aplicativo sem framework",
        describe_guide_looking_for_placeholder: "Por exemplo, eu quero integrar o Logto ao meu aplicativo Angular."
    },
    api: {
        modal_title: "Iniciar com tutoriais",
        modal_subtitle: "Inicie seu processo de desenvolvimento de aplicativo com nossos tutoriais pr\xe9-constru\xeddos.",
        select_a_tutorial: "Selecionar um tutorial",
        continue_without_tutorial: "Continuar sem tutorial",
        describe_guide_looking_for_placeholder: "Por exemplo, eu quero proteger minha API usando Deno."
    }
};
var $a354c9010aa5f1fa$export$2e2bcd8739ae039 = Object.freeze($a354c9010aa5f1fa$var$guide);


const $1a6238832b2a2618$var$log_details = {
    page_title: "Detalhes do registro de auditoria",
    back_to_logs: "Voltar para registros",
    back_to: "Voltar para {{name}}",
    success: "Sucesso",
    failed: "Falhou",
    event_key: "Chave do evento",
    application: "Aplicativo",
    ip_address: "Endere\xe7o de IP",
    user: "Usu\xe1rio",
    log_id: "ID do registro",
    time: "Tempo",
    user_agent: "Agente do usu\xe1rio",
    tab_details: "Detalhes",
    raw_data: "Dados completos"
};
var $1a6238832b2a2618$export$2e2bcd8739ae039 = Object.freeze($1a6238832b2a2618$var$log_details);


const $5a54e4e80c860220$var$logs = {
    page_title: "Audit logs",
    title: "Audit logs",
    subtitle: "Visualize os dados de log dos eventos de autentica\xe7\xe3o feitos por seu administrador e usu\xe1rios",
    event: "Evento",
    user: "Usu\xe1rio",
    application: "Aplicativo",
    time: "Tempo",
    filter_by: "Filtrar por"
};
var $5a54e4e80c860220$export$2e2bcd8739ae039 = Object.freeze($5a54e4e80c860220$var$logs);


const $46b821ff82268d07$var$menu = {
    profile: "Perfil",
    language: "Idioma",
    appearance: {
        label: "Apar\xeancia",
        light: "Modo claro",
        dark: "Modo escuro",
        system: "Sincronizar com o sistema"
    },
    sign_out: "Sair"
};
var $46b821ff82268d07$export$2e2bcd8739ae039 = Object.freeze($46b821ff82268d07$var$menu);


const $a8ea0ef213699452$var$mfa = {
    title: "Autentica\xe7\xe3o de m\xfaltipiplos fatores",
    description: "Adicione autentica\xe7\xe3o de m\xfaltiplos fatores para aumentar a seguran\xe7a da sua experi\xeancia de login.",
    factors: "Fatores",
    multi_factors: "M\xfaltiplos fatores",
    multi_factors_description: "Os usu\xe1rios precisam verificar um dos fatores habilitados para verifica\xe7\xe3o em duas etapas.",
    totp: "OTP do aplicativo autenticador",
    otp_description: "Vincule o Google Authenticator, etc., para verificar senhas de uso \xfanico.",
    webauthn: "WebAuthn (Senha)",
    webauthn_description: "Verifique via m\xe9todo suportado pelo navegador: biometria, digitaliza\xe7\xe3o de telefone ou chave de seguran\xe7a, etc.",
    webauthn_native_tip: "O WebAuthn n\xe3o \xe9 suportado para aplicativos nativos.",
    webauthn_domain_tip: "O WebAuthn vincula chaves p\xfablicas ao dom\xednio espec\xedfico. Modificar o dom\xednio do servi\xe7o bloquear\xe1 os usu\xe1rios de autenticar atrav\xe9s das senhas existentes.",
    backup_code: "C\xf3digo de backup",
    backup_code_description: "Gere 10 c\xf3digos de backup \xfanicos ap\xf3s os usu\xe1rios configurarem qualquer m\xe9todo MFA.",
    backup_code_setup_hint: "Quando os usu\xe1rios n\xe3o puderem verificar os fatores MFA acima, use a op\xe7\xe3o de backup.",
    backup_code_error_hint: "Para usar um c\xf3digo de backup, voc\xea precisa de pelo menos mais um m\xe9todo MFA para autentica\xe7\xe3o bem-sucedida do usu\xe1rio.",
    policy: "Pol\xedtica",
    policy_description: "Defina a pol\xedtica MFA para fluxos de login e inscri\xe7\xe3o.",
    two_step_sign_in_policy: "Pol\xedtica de verifica\xe7\xe3o em duas etapas no login",
    user_controlled: "Os usu\xe1rios podem habilitar ou desabilitar o MFA por conta pr\xf3pria",
    user_controlled_tip: "Os usu\xe1rios podem pular a configura\xe7\xe3o do MFA na primeira vez do login ou inscri\xe7\xe3o, ou habilitar/desabilitar nas configura\xe7\xf5es da conta.",
    mandatory: "Os usu\xe1rios sempre precisam usar o MFA no login",
    mandatory_tip: "Os usu\xe1rios devem configurar o MFA na primeira vez do login ou inscri\xe7\xe3o e us\xe1-lo em todos os logins futuros."
};
var $a8ea0ef213699452$export$2e2bcd8739ae039 = Object.freeze($a8ea0ef213699452$var$mfa);


const $793f32eb294f8ca7$var$organization_details = {
    page_title: "Detalhes da organiza\xe7\xe3o",
    delete_confirmation: "Uma vez exclu\xedda, todos os membros perder\xe3o sua associa\xe7\xe3o e cargos nesta organiza\xe7\xe3o. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
    organization_id: "ID da organiza\xe7\xe3o",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "O nome da organiza\xe7\xe3o, n\xe3o \xe9 necess\xe1rio ser \xfanico.",
    description_placeholder: "Uma descri\xe7\xe3o da organiza\xe7\xe3o.",
    member: "Membro",
    member_other: "Membros",
    add_members_to_organization: "Adicionar membros \xe0 organiza\xe7\xe3o {{name}}",
    add_members_to_organization_description: "Encontre usu\xe1rios apropriados pesquisando nome, e-mail, telefone ou ID do usu\xe1rio. Membros existentes n\xe3o s\xe3o mostrados nos resultados da pesquisa.",
    add_with_organization_role: "Adicionar com fun\xe7\xe3o(\xf5es) na organiza\xe7\xe3o",
    user: "Usu\xe1rio",
    authorize_to_roles: "Autorizar {{name}} a acessar os seguintes cargos:",
    edit_organization_roles: "Editar cargos da organiza\xe7\xe3o",
    edit_organization_roles_of_user: "Editar cargos da organiza\xe7\xe3o de {{name}}",
    remove_user_from_organization: "Remover usu\xe1rio da organiza\xe7\xe3o",
    remove_user_from_organization_description: "Uma vez removido, o usu\xe1rio perder\xe1 sua associa\xe7\xe3o e cargos nesta organiza\xe7\xe3o. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
    search_user_placeholder: "Pesquisar por nome, e-mail, telefone ou ID do usu\xe1rio",
    at_least_one_user: "Pelo menos um usu\xe1rio \xe9 necess\xe1rio."
};
var $793f32eb294f8ca7$export$2e2bcd8739ae039 = Object.freeze($793f32eb294f8ca7$var$organization_details);


const $d781a89d7feb1e57$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organiza\xe7\xf5es",
    title: "Organiza\xe7\xf5es",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID da organiza\xe7\xe3o",
    members: "Membros",
    create_organization: "Criar organiza\xe7\xe3o",
    setup_organization: "Configurar sua organiza\xe7\xe3o",
    organization_list_placeholder_title: "Organiza\xe7\xe3o",
    organization_list_placeholder_text: "A organiza\xe7\xe3o \xe9 geralmente usada em aplicativos de multi-inquilinato SaaS ou semelhantes a SaaS. A funcionalidade de Organiza\xe7\xf5es permite que seus clientes B2B gerenciem melhor seus parceiros e clientes, e personalizem as formas como os usu\xe1rios finais acessam suas aplica\xe7\xf5es.",
    organization_name_placeholder: "Minha organiza\xe7\xe3o",
    organization_description_placeholder: "Uma breve descri\xe7\xe3o da organiza\xe7\xe3o",
    organization_permission: "Permiss\xe3o da organiza\xe7\xe3o",
    organization_permission_other: "Permiss\xf5es da organiza\xe7\xe3o",
    organization_permission_description: "A permiss\xe3o da organiza\xe7\xe3o se refere \xe0 autoriza\xe7\xe3o para acessar um recurso no contexto da organiza\xe7\xe3o. Uma permiss\xe3o de organiza\xe7\xe3o deve ser representada como uma string significativa, servindo tamb\xe9m como nome e identificador exclusivo.",
    organization_permission_delete_confirm: "Se esta permiss\xe3o for exclu\xedda, todos os pap\xe9is de organiza\xe7\xe3o, incluindo esta permiss\xe3o, perder\xe3o esta permiss\xe3o, e os usu\xe1rios que tinham esta permiss\xe3o perder\xe3o o acesso concedido por ela.",
    create_permission_placeholder: "Ler hist\xf3rico de compromissos",
    permission: "Permiss\xe3o",
    permission_other: "Permiss\xf5es",
    organization_role: "Papel da organiza\xe7\xe3o",
    organization_role_other: "Pap\xe9is da organiza\xe7\xe3o",
    organization_role_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos usu\xe1rios. As permiss\xf5es devem vir das permiss\xf5es de organiza\xe7\xe3o predefinidas.",
    organization_role_delete_confirm: "Faz\xea-lo remover\xe1 as permiss\xf5es associadas a este papel dos usu\xe1rios afetados e excluir\xe1 as rela\xe7\xf5es entre os pap\xe9is da organiza\xe7\xe3o, os membros da organiza\xe7\xe3o e as permiss\xf5es da organiza\xe7\xe3o.",
    role: "Fun\xe7\xe3o",
    create_role_placeholder: "Usu\xe1rios com permiss\xf5es somente leitura",
    search_placeholder: "Pesquisar por nome ou ID da organiza\xe7\xe3o",
    search_permission_placeholder: "Digite para pesquisar e selecionar permiss\xf5es",
    search_role_placeholder: "Digite para pesquisar e selecionar fun\xe7\xf5es",
    empty_placeholder: "\uD83E\uDD14 Voc\xea ainda n\xe3o configurou nenhum {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Comece com guias",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interaja com a ilustra\xe7\xe3o para ver como tudo se conecta",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Etapa 1: Definir permiss\xf5es da organiza\xe7\xe3o",
        step_2: "Etapa 2: Definir pap\xe9is da organiza\xe7\xe3o",
        step_3: "Etapa 3: Criar sua primeira organiza\xe7\xe3o",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $d781a89d7feb1e57$export$2e2bcd8739ae039 = Object.freeze($d781a89d7feb1e57$var$organizations);


const $2c0fe01ae5330895$var$permissions = {
    search_placeholder: "Procurar por nome de API ou permiss\xe3o",
    search_placeholder_without_api: "Procurar por nome de permiss\xe3o",
    name_column: "Permiss\xe3o",
    description_column: "Descri\xe7\xe3o",
    api_column: "API",
    placeholder_title: "Permiss\xe3o",
    placeholder_description: "Permiss\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso (chamamos de recurso de API)."
};
var $2c0fe01ae5330895$export$2e2bcd8739ae039 = Object.freeze($2c0fe01ae5330895$var$permissions);


const $5d5cf5617cb2e905$var$profile = {
    page_title: "Configura\xe7\xf5es da conta",
    title: "Configura\xe7\xf5es da conta",
    description: "Altere suas configura\xe7\xf5es de conta e gerencie suas informa\xe7\xf5es pessoais aqui para garantir a seguran\xe7a da sua conta.",
    settings: {
        title: "CONFIGURA\xc7\xd5ES DO PERFIL",
        profile_information: "Informa\xe7\xf5es do perfil",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome de usu\xe1rio"
    },
    link_account: {
        title: "LINKAR CONTA",
        email_sign_in: "Login por e-mail",
        email: "E-mail",
        social_sign_in: "Login social",
        link_email: "Vincular e-mail",
        link_email_subtitle: "Vincule seu e-mail para fazer login ou ajudar na recupera\xe7\xe3o da conta.",
        email_required: "E-mail obrigat\xf3rio",
        invalid_email: "Endere\xe7o de e-mail inv\xe1lido",
        identical_email_address: "O endere\xe7o de e-mail inserido \xe9 id\xeantico ao atual",
        anonymous: "An\xf4nimo"
    },
    password: {
        title: "SENHA E SEGURAN\xc7A",
        password: "Senha",
        password_setting: "Configura\xe7\xe3o de senha",
        new_password: "Nova senha",
        confirm_password: "Confirme a senha",
        enter_password: "Digite a senha atual",
        enter_password_subtitle: "Verifique se \xe9 voc\xea para proteger a seguran\xe7a da sua conta. Por favor, digite sua senha atual antes de alter\xe1-la.",
        set_password: "Definir senha",
        verify_via_password: "Verificar via senha",
        show_password: "Mostrar senha",
        required: "Senha obrigat\xf3ria",
        do_not_match: "As senhas n\xe3o coincidem. Tente novamente."
    },
    code: {
        enter_verification_code: "Digite o c\xf3digo de verifica\xe7\xe3o",
        enter_verification_code_subtitle: "O c\xf3digo de verifica\xe7\xe3o foi enviado para <strong>{{target}}</strong>",
        verify_via_code: "Verificar via c\xf3digo de verifica\xe7\xe3o",
        resend: "Reenviar c\xf3digo de verifica\xe7\xe3o",
        resend_countdown: "Reenviar em {{countdown}} segundos"
    },
    delete_account: {
        title: "EXCLUIR CONTA",
        label: "Excluir conta",
        description: "Excluir sua conta remover\xe1 todas as suas informa\xe7\xf5es pessoais, dados do usu\xe1rio e configura\xe7\xf5es. Essa a\xe7\xe3o n\xe3o pode ser desfeita.",
        button: "Excluir conta",
        dialog_paragraph_1: "Lamentamos saber que voc\xea deseja excluir sua conta. A exclus\xe3o de sua conta remover\xe1 permanentemente todos os dados, incluindo informa\xe7\xf5es do usu\xe1rio, logs e configura\xe7\xf5es, e essa a\xe7\xe3o n\xe3o pode ser desfeita. Portanto, certifique-se de fazer backup de qualquer dado importante antes de prosseguir.",
        dialog_paragraph_2: 'Para prosseguir com o processo de exclus\xe3o de conta, envie um e-mail para nossa equipe de suporte em <a>mail</a> com o assunto "Pedido de exclus\xe3o de conta". N\xf3s o ajudaremos e garantiremos que todos os seus dados sejam exclu\xeddos corretamente de nosso sistema.',
        dialog_paragraph_3: "Agradecemos por escolher o Logto Cloud. Se voc\xea tiver outras d\xfavidas ou preocupa\xe7\xf5es, n\xe3o hesite em nos contatar."
    },
    set: "Configurar",
    change: "Alterar",
    link: "Linkar",
    unlink: "Deslinkar",
    not_set: "N\xe3o definido",
    change_avatar: "Alterar avatar",
    change_name: "Alterar nome",
    change_username: "Alterar nome de usu\xe1rio",
    set_name: "Definir nome",
    email_changed: "E-mail alterado.",
    password_changed: "Senha alterada.",
    updated: "{{target}} atualizado.",
    linked: "{{target}} conectada.",
    unlinked: "{{target}} desconectada.",
    email_exists_reminder: "Este e-mail {{email}} est\xe1 associado a uma conta existente. Vincule outro e-mail aqui.",
    unlink_confirm_text: "Sim, deslinkar",
    unlink_reminder: "Os usu\xe1rios n\xe3o poder\xe3o fazer login com a conta <span></span> se voc\xea deslink\xe1-la. Tem certeza de que deseja prosseguir?"
};
var $5d5cf5617cb2e905$export$2e2bcd8739ae039 = Object.freeze($5d5cf5617cb2e905$var$profile);


const $27b8e699498914b5$var$role_details = {
    back_to_roles: "Voltar para os Pap\xe9is",
    identifier: "Identificador",
    delete_description: "Faz\xea-lo remover\xe1 as permiss\xf5es associadas a este papel dos usu\xe1rios afetados e excluir\xe1 o mapeamento entre pap\xe9is, usu\xe1rios e permiss\xf5es.",
    role_deleted: "{{name}} foi exclu\xeddo com sucesso.",
    settings_tab: "Configura\xe7\xf5es",
    users_tab: "Usu\xe1rios",
    m2m_apps_tab: "Aplicativos m\xe1quina-a-m\xe1quina",
    permissions_tab: "Permiss\xf5es",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os pap\xe9is s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a usu\xe1rios. Eles tamb\xe9m fornecem uma maneira de agregar permiss\xf5es definidas para diferentes APIs, tornando mais eficiente a adi\xe7\xe3o, remo\xe7\xe3o ou ajuste de permiss\xf5es em compara\xe7\xe3o com a atribui\xe7\xe3o individual a usu\xe1rios.",
    field_name: "Nome",
    field_description: "Descri\xe7\xe3o",
    type_m2m_role_tag: "Fun\xe7\xe3o de aplicativo m\xe1quina-a-m\xe1quina",
    type_user_role_tag: "Fun\xe7\xe3o de usu\xe1rio",
    permission: {
        assign_button: "Atribuir permiss\xf5es",
        assign_title: "Atribuir permiss\xf5es",
        assign_subtitle: "Atribua permiss\xf5es a este papel. O papel adquirir\xe1 as permiss\xf5es adicionadas e os usu\xe1rios com este papel herdar\xe3o essas permiss\xf5es.",
        assign_form_field: "Atribuir permiss\xf5es",
        added_text_one: "{{count, number}} permiss\xe3o adicionada",
        added_text_other: "{{count, number}} permiss\xf5es adicionadas",
        api_permission_count_one: "{{count, number}} permiss\xe3o",
        api_permission_count_other: "{{count, number}} permiss\xf5es",
        confirm_assign: "Atribuir permiss\xf5es",
        permission_assigned: "As permiss\xf5es selecionadas foram atribu\xeddas com sucesso a este papel",
        deletion_description: "Se esta permiss\xe3o for removida, o usu\xe1rio afetado com este papel perder\xe1 o acesso concedido por esta permiss\xe3o.",
        permission_deleted: 'A permiss\xe3o "{{name}}" foi removida com sucesso deste papel',
        empty: "Nenhuma permiss\xe3o dispon\xedvel"
    },
    users: {
        assign_button: "Atribuir usu\xe1rios",
        name_column: "Usu\xe1rio",
        app_column: "Aplicativo",
        latest_sign_in_column: "\xdaltimo acesso",
        delete_description: "Ele permanecer\xe1 no seu pool de usu\xe1rios, mas perder\xe1 a autoriza\xe7\xe3o para este papel.",
        deleted: "{{name}} foi removido com sucesso deste papel",
        assign_title: "Atribuir usu\xe1rios",
        assign_subtitle: "Atribuir usu\xe1rios a este papel. Encontre usu\xe1rios adequados pesquisando nome, e-mail, telefone ou ID do usu\xe1rio.",
        assign_field: "Atribuir usu\xe1rios",
        confirm_assign: "Atribuir usu\xe1rios",
        assigned_toast_text: "Os usu\xe1rios selecionados foram atribu\xeddos com sucesso a este papel",
        empty: "Nenhum usu\xe1rio dispon\xedvel"
    },
    applications: {
        assign_button: "Atribuir aplicativos",
        name_column: "Aplicativo",
        app_column: "Aplicativos",
        description_column: "Descri\xe7\xe3o",
        delete_description: "Ele permanecer\xe1 em seu pool de aplicativos, mas perder\xe1 a autoriza\xe7\xe3o para este papel.",
        deleted: "{{name}} foi removido com sucesso deste papel",
        assign_title: "Atribuir aplicativos",
        assign_subtitle: "Atribuir aplicativos a este papel. Encontre os aplicativos adequados pesquisando por nome, descri\xe7\xe3o ou ID do aplicativo.",
        assign_field: "Atribuir aplicativos",
        confirm_assign: "Atribuir aplicativos",
        assigned_toast_text: "Os aplicativos selecionados foram atribu\xeddos com sucesso a este papel",
        empty: "Nenhum aplicativo dispon\xedvel"
    }
};
var $27b8e699498914b5$export$2e2bcd8739ae039 = Object.freeze($27b8e699498914b5$var$role_details);


const $474a549525a946de$var$roles = {
    page_title: "T\xedtulos das fun\xe7\xf5es",
    title: "Fun\xe7\xf5es",
    subtitle: "As fun\xe7\xf5es incluem permiss\xf5es que determinam o que um usu\xe1rio pode fazer. O RBAC usa fun\xe7\xf5es para dar aos usu\xe1rios acesso a recursos para a\xe7\xf5es espec\xedficas.",
    create: "Criar fun\xe7\xe3o",
    role_name: "Nome da fun\xe7\xe3o",
    role_type: "Tipo de fun\xe7\xe3o",
    show_role_type_button_text: "Mostrar mais op\xe7\xf5es",
    hide_role_type_button_text: "Esconder mais op\xe7\xf5es",
    type_user: "Fun\xe7\xe3o do usu\xe1rio",
    type_machine_to_machine: "Fun\xe7\xe3o de aplicativo de m\xe1quina para m\xe1quina",
    role_description: "Descri\xe7\xe3o",
    role_name_placeholder: "Insira o nome da sua fun\xe7\xe3o",
    role_description_placeholder: "Insira a descri\xe7\xe3o da sua fun\xe7\xe3o",
    col_roles: "Fun\xe7\xf5es",
    col_type: "Tipo",
    col_description: "Descri\xe7\xe3o",
    col_assigned_entities: "Atribu\xeddo",
    user_counts: "{{count}} usu\xe1rios",
    application_counts: "{{count}} aplicativos",
    user_count: "{{count}} usu\xe1rio",
    application_count: "{{count}} aplicativo",
    assign_permissions: "Atribuir permiss\xf5es",
    create_role_title: "Criar fun\xe7\xe3o",
    create_role_description: "Crie e gerencie fun\xe7\xf5es para suas aplica\xe7\xf5es. As fun\xe7\xf5es cont\xeam cole\xe7\xf5es de permiss\xf5es e podem ser atribu\xeddas a usu\xe1rios.",
    create_role_button: "Criar fun\xe7\xe3o",
    role_created: "A fun\xe7\xe3o {{name}} foi criada com sucesso.",
    search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
    placeholder_title: "Fun\xe7\xf5es",
    placeholder_description: "As fun\xe7\xf5es s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a usu\xe1rios. Certifique-se de adicionar as permiss\xf5es antes de criar fun\xe7\xf5es."
};
var $474a549525a946de$export$2e2bcd8739ae039 = Object.freeze($474a549525a946de$var$roles);


const $0955535770d9dd08$var$session_expired = {
    title: "Sess\xe3o expirada",
    subtitle: "Sua sess\xe3o pode ter expirado e voc\xea foi desconectado. Clique no bot\xe3o abaixo para fazer login no Admin Console novamente.",
    button: "Entrar novamente"
};
var $0955535770d9dd08$export$2e2bcd8739ae039 = Object.freeze($0955535770d9dd08$var$session_expired);


const $efa5c2b77f278c0f$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $efa5c2b77f278c0f$export$2e2bcd8739ae039 = Object.freeze($efa5c2b77f278c0f$var$content);


const $6859dbe397505a94$var$password_policy = {
    password_requirements: "Requisitos de senha",
    minimum_length: "Comprimento m\xednimo",
    minimum_length_description: "O NIST sugere o uso de <a>pelo menos 8 caracteres</a> para produtos na web.",
    minimum_length_error: "O comprimento m\xednimo deve estar entre {{min}} e {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres m\xednimos necess\xe1rios",
    minimum_required_char_types_description: "Tipos de caracteres: mai\xfasculas (A-Z), min\xfasculas (a-z), n\xfameros (0-9) e s\xedmbolos especiais ({{symbols}}).",
    password_rejection: "Rejei\xe7\xe3o de senha",
    compromised_passwords: "Senhas comprometidas",
    breached_passwords: "Senhas comprometidas",
    breached_passwords_description: "Rejeitar senhas encontradas em bancos de dados de viola\xe7\xf5es anteriores.",
    restricted_phrases: "Restringir frases de baixa seguran\xe7a",
    restricted_phrases_tooltip: "Sua senha deve evitar essas frases, a menos que voc\xea combine com 3 ou mais caracteres extras.",
    repetitive_or_sequential_characters: "Caracteres repetitivos ou sequenciais",
    repetitive_or_sequential_characters_description: 'Por exemplo, "AAAA", "1234" e "abcd".',
    user_information: "Informa\xe7\xf5es do usu\xe1rio",
    user_information_description: "Por exemplo, endere\xe7o de e-mail, n\xfamero de telefone, nome de usu\xe1rio, etc.",
    custom_words: "Palavras personalizadas",
    custom_words_description: "Personalize palavras espec\xedficas do contexto, sem diferencia\xe7\xe3o de mai\xfasculas e min\xfasculas, e uma por linha.",
    custom_words_placeholder: "Nome do seu servi\xe7o, nome da empresa, etc."
};
var $6859dbe397505a94$export$2e2bcd8739ae039 = Object.freeze($6859dbe397505a94$var$password_policy);


const $49fa846251ca4bc6$var$sign_up_and_sign_in = {
    identifiers_email: "Endere\xe7o de e-mail",
    identifiers_phone: "N\xfamero de telefone",
    identifiers_username: "Nome de usu\xe1rio",
    identifiers_email_or_sms: "Endere\xe7o de e-mail ou n\xfamero de telefone",
    identifiers_none: "N\xe3o aplic\xe1vel",
    and: "e",
    or: "ou",
    sign_up: {
        title: "INSCREVER-SE",
        sign_up_identifier: "Identificador de inscri\xe7\xe3o",
        identifier_description: "O identificador de inscri\xe7\xe3o \xe9 necess\xe1rio para a cria\xe7\xe3o da conta e deve ser inclu\xeddo na tela de login.",
        sign_up_authentication: "Configura\xe7\xe3o de autentica\xe7\xe3o para inscri\xe7\xe3o",
        authentication_description: "Todas as a\xe7\xf5es selecionadas ser\xe3o obrigat\xf3rias para os usu\xe1rios completarem o fluxo.",
        set_a_password_option: "Crie sua senha",
        verify_at_sign_up_option: "Visualize na inscri\xe7\xe3o",
        social_only_creation_description: "(Isso se aplica apenas \xe0 cria\xe7\xe3o de contas sociais)"
    },
    sign_in: {
        title: "ENTRAR",
        sign_in_identifier_and_auth: "Configura\xe7\xf5es de identificador e autentica\xe7\xe3o para login",
        description: "Os usu\xe1rios podem entrar usando qualquer uma das op\xe7\xf5es dispon\xedveis. Ajuste o layout arrastando e soltando as op\xe7\xf5es abaixo.",
        add_sign_in_method: "Adicionar m\xe9todo de login",
        password_auth: "Senha",
        verification_code_auth: "C\xf3digo de verifica\xe7\xe3o",
        auth_swap_tip: "Troque as op\xe7\xf5es abaixo para determinar qual aparece primeiro no fluxo.",
        require_auth_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o."
    },
    social_sign_in: {
        title: "LOGIN SOCIAL",
        social_sign_in: "Login social",
        description: "Dependendo do identificador obrigat\xf3rio que voc\xea configurou, seu usu\xe1rio pode ser solicitado a fornecer um identificador ao se inscrever via conector social.",
        add_social_connector: "Adicionar Conector Social",
        set_up_hint: {
            not_in_list: "N\xe3o est\xe1 na lista?",
            set_up_more: "Configurar",
            go_to: "outros conectores sociais agora."
        }
    },
    tip: {
        set_a_password: "Um conjunto exclusivo de uma senha para o seu nome de usu\xe1rio \xe9 obrigat\xf3rio.",
        verify_at_sign_up: "No momento, suportamos apenas e-mail verificado. Sua base de usu\xe1rios pode conter um grande n\xfamero de endere\xe7os de e-mail de baixa qualidade se n\xe3o houver valida\xe7\xe3o.",
        password_auth: "Isso \xe9 essencial, pois voc\xea habilitou a op\xe7\xe3o de definir uma senha durante o processo de inscri\xe7\xe3o.",
        verification_code_auth: "Isso \xe9 essencial, pois voc\xea habilitou apenas a op\xe7\xe3o de fornecer o c\xf3digo de verifica\xe7\xe3o ao se inscrever. Voc\xea pode desmarcar a caixa quando a configura\xe7\xe3o de senha for permitida no processo de inscri\xe7\xe3o.",
        delete_sign_in_method: "Isso \xe9 essencial, pois voc\xea selecionou {{identifier}} como um identificador obrigat\xf3rio."
    },
    advanced_options: {
        title: "OP\xc7\xd5ES AVAN\xc7ADAS",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Habilitar registro de usu\xe1rio",
        enable_user_registration_description: "Habilitar ou desabilitar o registro de usu\xe1rios. Depois de desabilitado, os usu\xe1rios ainda podem ser adicionados no console de administra\xe7\xe3o, mas os usu\xe1rios n\xe3o poder\xe3o mais criar contas atrav\xe9s da interface de login."
    }
};
var $49fa846251ca4bc6$export$2e2bcd8739ae039 = Object.freeze($49fa846251ca4bc6$var$sign_up_and_sign_in);


const $f8dc6a5b87808204$var$sign_in_exp = {
    page_title: "Experi\xeancia de login",
    title: "Experi\xeancia de login",
    description: "Personalize a interface do usu\xe1rio de login para corresponder \xe0 sua marca e visualize em tempo real",
    tabs: {
        branding: "Marca",
        sign_up_and_sign_in: "Inscreva-se e fa\xe7a login",
        content: "Conte\xfado",
        password_policy: "Pol\xedtica de senhas"
    },
    welcome: {
        title: "Personalize a experi\xeancia de login",
        description: "Comece rapidamente com a configura\xe7\xe3o do seu primeiro login. Este guia o acompanhar\xe1 em todas as configura\xe7\xf5es necess\xe1rias.",
        get_started: "Come\xe7ar",
        apply_remind: "Observe que a experi\xeancia de login ser\xe1 aplicada a todos os aplicativos nesta conta."
    },
    color: {
        title: "COR",
        primary_color: "Cor da marca",
        dark_primary_color: "Cor da marca (Escuro)",
        dark_mode: "Ativar modo escuro",
        dark_mode_description: "Seu aplicativo ter\xe1 um tema de modo escuro gerado automaticamente com base na cor da sua marca e no algoritmo Logto. Voc\xea \xe9 livre para personalizar.",
        dark_mode_reset_tip: "Recalcule a cor do modo escuro com base na cor da marca.",
        reset: "Recalcular"
    },
    branding: {
        title: "\xc1REA DE MARCA",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL da imagem do logotipo do aplicativo",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL da imagem do logotipo do aplicativo (Escuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logotipo do aplicativo",
        dark_logo_image: "Logotipo do aplicativo (Escuro)",
        logo_image_error: "Logotipo do aplicativo: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS personalizado",
        css_code_editor_title: "Personalize sua UI com CSS personalizado",
        css_code_editor_description1: "Veja o exemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Saiba mais",
        css_code_editor_content_placeholder: "Digite seu CSS personalizado para personalizar os estilos de qualquer coisa de acordo com suas especifica\xe7\xf5es exatas. Expresse sua criatividade e fa\xe7a sua IU se destacar."
    },
    sign_up_and_sign_in: $49fa846251ca4bc6$export$2e2bcd8739ae039,
    content: $efa5c2b77f278c0f$export$2e2bcd8739ae039,
    password_policy: $6859dbe397505a94$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Nenhum conector SMS configurado ainda. At\xe9 terminar de configurar seu conector SMS, seus usu\xe1rios n\xe3o poder\xe3o fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_email: 'Nenhum conector de e-mail configurado ainda. At\xe9 terminar de configurar seu conector de e-mail, seus usu\xe1rios n\xe3o poder\xe3o fazer login. <a>{{link}}</a> em "Conectores"',
        no_connector_social: 'Voc\xea ainda n\xe3o configurou nenhum conector social. Adicione conectores primeiro para aplicar m\xe9todos de login social. <a>{{link}}</a> em "Conectores".',
        setup_link: "Configurar"
    },
    save_alert: {
        description: "Voc\xea est\xe1 implementando novos procedimentos de entrada e inscri\xe7\xe3o. Todos os seus usu\xe1rios podem ser afetados pela nova configura\xe7\xe3o. Tem certeza de se comprometer com a mudan\xe7a?",
        before: "Antes",
        after: "Depois",
        sign_up: "Inscrever-se",
        sign_in: "Entrar",
        social: "Social"
    },
    preview: {
        title: "Visualiza\xe7\xe3o de login",
        live_preview: "Visualiza\xe7\xe3o em tempo real",
        live_preview_tip: "Salve para visualizar as altera\xe7\xf5es",
        native: "Nativo",
        desktop_web: "Web Desktop",
        mobile_web: "Web Mobile",
        desktop: "\xc1rea de trabalho",
        mobile: "M\xf3vel"
    }
};
var $f8dc6a5b87808204$export$2e2bcd8739ae039 = Object.freeze($f8dc6a5b87808204$var$sign_in_exp);


const $3b4a8ab6db4cab55$var$quota_item = {
    tenant_limit: {
        name: "Locat\xe1rios",
        limited: "{{count, number}} locat\xe1rio",
        limited_other: "{{count, number}} locat\xe1rios",
        unlimited: "Locat\xe1rios ilimitados",
        not_eligible: "Remova seus locat\xe1rios"
    },
    mau_limit: {
        name: "Usu\xe1rios ativos mensais",
        limited: "{{count, number}} UAM",
        unlimited: "UAM ilimitados",
        not_eligible: "Remova todos seus usu\xe1rios"
    },
    applications_limit: {
        name: "Aplica\xe7\xf5es",
        limited: "{{count, number}} aplica\xe7\xe3o",
        limited_other: "{{count, number}} aplica\xe7\xf5es",
        unlimited: "Aplica\xe7\xf5es ilimitadas",
        not_eligible: "Remova suas aplica\xe7\xf5es"
    },
    machine_to_machine_limit: {
        name: "Aplica\xe7\xf5es de m\xe1quina a m\xe1quina",
        limited: "{{count, number}} aplica\xe7\xe3o de m\xe1quina a m\xe1quina",
        limited_other: "{{count, number}} aplica\xe7\xf5es de m\xe1quina a m\xe1quina",
        unlimited: "Aplica\xe7\xf5es de m\xe1quina a m\xe1quina ilimitadas",
        not_eligible: "Remova suas aplica\xe7\xf5es de m\xe1quina a m\xe1quina"
    },
    resources_limit: {
        name: "Recursos da API",
        limited: "{{count, number}} recurso da API",
        limited_other: "{{count, number}} recursos da API",
        unlimited: "Recursos da API ilimitados",
        not_eligible: "Remova seus recursos da API"
    },
    scopes_per_resource_limit: {
        name: "Permiss\xf5es de recursos",
        limited: "{{count, number}} permiss\xe3o por recurso",
        limited_other: "{{count, number}} permiss\xf5es por recurso",
        unlimited: "Permiss\xe3o por recurso ilimitada",
        not_eligible: "Remova suas permiss\xf5es de recursos"
    },
    custom_domain_enabled: {
        name: "Dom\xednio personalizado",
        limited: "Dom\xednio personalizado",
        unlimited: "Dom\xednio personalizado",
        not_eligible: "Remova seu dom\xednio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Desabilite seu omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Conector de email incorporado",
        limited: "Conector de email incorporado",
        unlimited: "Conector de email incorporado",
        not_eligible: "Remova seu conector de email incorporado"
    },
    social_connectors_limit: {
        name: "Conectores sociais",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociais",
        unlimited: "Conectores sociais ilimitados",
        not_eligible: "Remova seus conectores sociais"
    },
    standard_connectors_limit: {
        name: "Conectores padr\xe3o gratuitos",
        limited: "{{count, number}} conector padr\xe3o gratuito",
        limited_other: "{{count, number}} conectores padr\xe3o gratuitos",
        unlimited: "Conectores padr\xe3o ilimitados",
        not_eligible: "Remova seus conectores padr\xe3o"
    },
    roles_limit: {
        name: "Fun\xe7\xf5es",
        limited: "{{count, number}} fun\xe7\xe3o",
        limited_other: "{{count, number}} fun\xe7\xf5es",
        unlimited: "Fun\xe7\xf5es ilimitadas",
        not_eligible: "Remova suas fun\xe7\xf5es"
    },
    scopes_per_role_limit: {
        name: "Permiss\xf5es de fun\xe7\xf5es",
        limited: "{{count, number}} permiss\xe3o por fun\xe7\xe3o",
        limited_other: "{{count, number}} permiss\xf5es por fun\xe7\xe3o",
        unlimited: "Permiss\xe3o por fun\xe7\xe3o ilimitada",
        not_eligible: "Remova suas permiss\xf5es de fun\xe7\xe3o"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Remova seus webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Perman\xeancia de registros de auditoria",
        limited: "Perman\xeancia de registros de auditoria: {{count, number}} dia",
        limited_other: "Perman\xeancia de registros de auditoria: {{count, number}} dias",
        unlimited: "Dias ilimitados",
        not_eligible: "Nenhum registro de auditoria"
    },
    community_support_enabled: {
        name: "Suporte da comunidade",
        limited: "Suporte da comunidade",
        unlimited: "Suporte da comunidade",
        not_eligible: "Nenhum suporte da comunidade"
    },
    customer_ticket_support: {
        name: "Suporte de tickets de cliente",
        limited: "{{count, number}} hora de suporte de ticket de cliente",
        limited_other: "{{count, number}} horas de suporte de ticket de cliente",
        unlimited: "Suporte de ticket de cliente",
        not_eligible: "Nenhum suporte de ticket de cliente"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Desative sua MFA"
    },
    sso_enabled: {
        name: "SSO Empresarial",
        limited: "SSO Empresarial",
        unlimited: "SSO Empresarial",
        not_eligible: "Desative seu SSO Empresarial"
    }
};
var $3b4a8ab6db4cab55$export$2e2bcd8739ae039 = Object.freeze($3b4a8ab6db4cab55$var$quota_item);


const $4b678ed5c02e6cfa$var$quota_table = {
    quota: {
        title: "Cota",
        tenant_limit: "Limite de inquilino",
        base_price: "Pre\xe7o base",
        mau_unit_price: "* Pre\xe7o unit\xe1rio de MAU",
        mau_limit: "Limite de MAU"
    },
    application: {
        title: "Aplica\xe7\xf5es",
        total: "Total de aplica\xe7\xf5es",
        m2m: "Aplica\xe7\xe3o m\xe1quina-a-m\xe1quina"
    },
    resource: {
        title: "Recursos de API",
        resource_count: "Contagem de recursos",
        scopes_per_resource: "Permiss\xf5es por recurso"
    },
    branding: {
        title: "Interface de usu\xe1rio e branding",
        custom_domain: "Dom\xednio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Logotipo da aplica\xe7\xe3o e favicon",
        dark_mode: "Modo escuro",
        i18n: "Internacionaliza\xe7\xe3o"
    },
    user_authn: {
        title: "Autentica\xe7\xe3o de usu\xe1rio",
        omni_sign_in: "Entrada Omni",
        password: "Senha",
        passwordless: "Sem senha - E-mail e SMS",
        email_connector: "Conector de e-mail",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociais",
        standard_connectors: "Conectores padr\xe3o",
        built_in_email_connector: "Conector de e-mail integrado",
        mfa: "MFA",
        sso: "SSO Empresarial"
    },
    user_management: {
        title: "Gerenciamento de usu\xe1rios",
        user_management: "Gerenciamento de usu\xe1rios",
        roles: "Fun\xe7\xf5es",
        scopes_per_role: "Permiss\xf5es por fun\xe7\xe3o"
    },
    audit_logs: {
        title: "Registros de auditoria",
        retention: "Reten\xe7\xe3o"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "Organiza\xe7\xe3o",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Suporte",
        community: "Comunidade",
        customer_ticket: "Ticket de suporte",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Seus usu\xe1rios ativos mensais (MAU) s\xe3o divididos em 3 n\xedveis com base em quantas vezes eles fazem login durante o ciclo de faturamento. Cada n\xedvel tem um pre\xe7o diferente por unidade de MAU.",
    unlimited: "Ilimitado",
    contact: "Contato",
    monthly_price: "${ { value, number } }/m\xeas",
    mau_price: "${ { value, number } }/MAU",
    days_one: "${ { count, number } } dia",
    days_other: "${ { count, number } } dias",
    add_on: "Adicional",
    tier: "N\xedvel${ { value, number } }: "
};
var $4b678ed5c02e6cfa$export$2e2bcd8739ae039 = Object.freeze($4b678ed5c02e6cfa$var$quota_table);


const $03a5118f823c3eca$var$subscription = {
    free_plan: "Plano Gratuito",
    free_plan_description: "Para projetos pessoais e avalia\xe7\xf5es iniciais do Logto. Sem cart\xe3o de cr\xe9dito.",
    hobby_plan: "Plano Hobby",
    hobby_plan_description: "Para desenvolvedores individuais ou pequenas equipes de engenharia.",
    pro_plan: "Plano Pro",
    pro_plan_description: "Para empresas se beneficiarem tranquilo com o Logto.",
    enterprise: "Empresa",
    current_plan: "Plano Atual",
    current_plan_description: "Aqui est\xe1 o seu plano atual. Voc\xea pode facilmente ver o uso do seu plano, verificar a sua pr\xf3xima fatura e fazer altera\xe7\xf5es no plano, conforme necess\xe1rio.",
    plan_usage: "Uso do plano",
    plan_cycle: "Ciclo do plano: {{period}}. O uso \xe9 renovado em {{renewDate}}.",
    next_bill: "Sua pr\xf3xima fatura",
    next_bill_hint: "Para saber mais sobre o c\xe1lculo, consulte este <a>artigo</a>.",
    next_bill_tip: "Sua pr\xf3xima fatura inclui o pre\xe7o base do seu plano para o pr\xf3ximo m\xeas, al\xe9m do custo do uso multiplicado pelo pre\xe7o da unidade MAU em v\xe1rios n\xedveis.",
    manage_payment: "Gerenciar pagamento",
    overfill_quota_warning: "Voc\xea atingiu o limite de cota. Para evitar problemas, fa\xe7a upgrade do plano.",
    upgrade_pro: "Upgrade Pro",
    update_payment: "Atualizar pagamento",
    payment_error: "Detectado um problema de pagamento. N\xe3o \xe9 poss\xedvel processar $ {{price, number}} para o ciclo anterior. Atualize o pagamento para evitar a suspens\xe3o do servi\xe7o Logto.",
    downgrade: "Downgrade",
    current: "Atual",
    upgrade: "Atualizar",
    quota_table: $4b678ed5c02e6cfa$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturas",
        status_column: "Status",
        amount_column: "Valor",
        invoice_created_date_column: "Data de cria\xe7\xe3o da fatura",
        invoice_status: {
            void: "Cancelada",
            paid: "Paga",
            open: "Em aberto",
            uncollectible: "Vencida"
        }
    },
    quota_item: $3b4a8ab6db4cab55$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Tem certeza de que deseja fazer downgrade?",
        description: "Se voc\xea escolher mudar para o <targetName/>, observe que voc\xea n\xe3o ter\xe1 mais acesso \xe0 cota e aos recursos que estavam anteriormente no <currentName/>.",
        before: "Antes: <name/>",
        after: "Depois: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "Voc\xea n\xe3o \xe9 eleg\xedvel para fazer downgrade",
        downgrade_description: "Certifique-se de atender aos seguintes crit\xe9rios antes de fazer o downgrade para o plano <name/>.",
        downgrade_help_tip: "Precisa de ajuda com o downgrade? <a>Contate-nos</a>.",
        upgrade_title: "Lembrete amig\xe1vel para nossos honrados early adopters",
        upgrade_description: "Voc\xea est\xe1 usando atualmente mais do que o permitido pelo <name />. O Logto agora \xe9 oficial, incluindo recursos adaptados a cada plano. Antes de considerar a atualiza\xe7\xe3o para o <name />, verifique se voc\xea atende aos seguintes crit\xe9rios antes de fazer o upgrade.",
        upgrade_pro_tip: " Ou considere fazer o upgrade para o Plano Pro.",
        upgrade_help_tip: "Precisa de ajuda com o upgrade? <a>Contate-nos</a>.",
        a_maximum_of: "Um m\xe1ximo de <item/>"
    },
    upgrade_success: "Atualizado com sucesso para <name/>",
    downgrade_success: "Downgrade realizado com sucesso para <name/>",
    subscription_check_timeout: "A verifica\xe7\xe3o de assinatura expirou. Por favor, atualize mais tarde.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $03a5118f823c3eca$export$2e2bcd8739ae039 = Object.freeze($03a5118f823c3eca$var$subscription);


const $6964a765eac50994$var$tab_sections = {
    overview: "Vis\xe3o geral",
    resources: "Recursos",
    users: "Usu\xe1rios",
    access_control: "Controle de acesso",
    help_and_support: "Ajuda e suporte",
    tenant: "Locat\xe1rio",
    automation: "Automa\xe7\xe3o"
};
var $6964a765eac50994$export$2e2bcd8739ae039 = Object.freeze($6964a765eac50994$var$tab_sections);


const $8aba1d43895ca0c1$var$tabs = {
    get_started: "Primeiros passos",
    dashboard: "Painel",
    applications: "Aplicativos",
    api_resources: "Recursos da API",
    sign_in_experience: "Experi\xeancia de login",
    connectors: "Conectores",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "Organiza\xe7\xf5es",
    users: "Usu\xe1rios",
    audit_logs: "Logs",
    roles: "Registros",
    docs: "Documenta\xe7\xe3o",
    tenant_settings: "Configura\xe7\xf5es",
    mfa: "Autentica\xe7\xe3o de multi-fator"
};
var $8aba1d43895ca0c1$export$2e2bcd8739ae039 = Object.freeze($8aba1d43895ca0c1$var$tabs);


const $0c969c621135342d$var$tenants = {
    title: "Configura\xe7\xf5es",
    description: "Gerencie eficientemente as configura\xe7\xf5es do locat\xe1rio e personalize seu dom\xednio.",
    tabs: {
        settings: "Configura\xe7\xf5es",
        domains: "Dom\xednios",
        subscription: "Plano e faturamento",
        billing_history: "Hist\xf3rico de faturamento"
    },
    settings: {
        title: "CONFIGURA\xc7\xd5ES",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID do Locat\xe1rio",
        tenant_name: "Nome do Locat\xe1rio",
        tenant_region: "Regi\xe3o de hospedagem",
        tenant_region_tip: "Seus recursos do locat\xe1rio est\xe3o hospedados na regi\xe3o {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_staging: "Homol",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "As informa\xe7\xf5es do locat\xe1rio foram salvas com sucesso."
    },
    full_env_tag: {
        development: "Desenvolvimento",
        production: "Produ\xe7\xe3o"
    },
    deletion_card: {
        title: "EXCLUIR",
        tenant_deletion: "Excluir locat\xe1rio",
        tenant_deletion_description: "A exclus\xe3o do locat\xe1rio resultar\xe1 na remo\xe7\xe3o permanente de todos os dados de usu\xe1rio e configura\xe7\xe3o associados. Por favor, prossiga com cuidado.",
        tenant_deletion_button: "Excluir locat\xe1rio"
    },
    create_modal: {
        title: "Criar inquilino",
        subtitle: "Crie um novo locat\xe1rio que tenha recursos e usu\xe1rios isolados. As regi\xf5es de dados hospedados e os tipos de locat\xe1rio n\xe3o podem ser modificados ap\xf3s a cria\xe7\xe3o.",
        tenant_usage_purpose: "Para que voc\xea deseja usar este locat\xe1rio?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Plano dispon\xedvel:",
        create_button: "Criar inquilino",
        tenant_name_placeholder: "Meu inquilino"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Excluir locat\xe1rio",
        description_line1: 'Tem certeza que deseja excluir seu locat\xe1rio "<span>{{name}}</span>" com a etiqueta de sufixo de ambiente "<span>{{tag}}</span>"? Esta a\xe7\xe3o n\xe3o pode ser desfeita e resultar\xe1 na exclus\xe3o permanente de todos os seus dados e informa\xe7\xf5es de conta.',
        description_line2: "Antes de excluir a conta, podemos ajud\xe1-lo. <span><a>Entre em contato conosco por e-mail</a></span>",
        description_line3: 'Se voc\xea deseja continuar, digite o nome do locat\xe1rio "<span>{{name}}</span>" para confirmar.',
        delete_button: "Excluir permanentemente",
        cannot_delete_title: "N\xe3o \xe9 poss\xedvel excluir este inquilino",
        cannot_delete_description: "Desculpe, voc\xea n\xe3o pode excluir este locat\xe1rio no momento. Certifique-se de estar no Plano Gratuito e ter pago todas as faturas pendentes."
    },
    tenant_landing_page: {
        title: "Voc\xea ainda n\xe3o criou um inquilino",
        description: "Para come\xe7ar a configurar seu projeto com o Logto, crie um novo inquilino. Se voc\xea precisar fazer logout ou excluir sua conta, basta clicar no bot\xe3o de avatar no canto superior direito.",
        create_tenant_button: "Criar inquilino"
    },
    status: {
        mau_exceeded: "MAU Excedido",
        suspended: "Suspenso",
        overdue: "Atrasado"
    },
    tenant_suspended_page: {
        title: "Locat\xe1rio suspenso. Entre em contato para restaurar o acesso.",
        description_1: "Lamentamos profundamente informar que sua conta de locat\xe1rio foi temporariamente suspensa devido a uso impr\xf3prio, incluindo exceder os limites de MAU, pagamentos atrasados ou outras a\xe7\xf5es n\xe3o autorizadas.",
        description_2: "Se voc\xea precisa de mais esclarecimentos, tem alguma preocupa\xe7\xe3o ou deseja restaurar a funcionalidade total e desbloquear seus locat\xe1rios, n\xe3o hesite em entrar em contato conosco imediatamente."
    },
    signing_keys: {
        title: "CHAVES DE ASSINATURA",
        description: "Gerencie de forma segura as chaves de assinatura em seu locat\xe1rio.",
        type: {
            private_key: "Chaves privadas do OIDC",
            cookie_key: "Chaves de cookie do OIDC"
        },
        private_keys_in_use: "Chaves privadas em uso",
        cookie_keys_in_use: "Chaves de cookie em uso",
        rotate_private_keys: "Girar chaves privadas",
        rotate_cookie_keys: "Girar chaves de cookie",
        rotate_private_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave privada de assinatura, girar\xe1 a chave atual e remover\xe1 sua chave anterior. Seus tokens JWT assinados com a chave atual permanecer\xe3o v\xe1lidos at\xe9 a exclus\xe3o ou outra rodada de rota\xe7\xe3o.",
        rotate_cookie_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave de cookie, girar\xe1 a chave atual e remover\xe1 sua chave anterior. Seus cookies com a chave atual permanecer\xe3o v\xe1lidos at\xe9 a exclus\xe3o ou outra rodada de rota\xe7\xe3o.",
        select_private_key_algorithm: "Selecione o algoritmo de assinatura para a nova chave privada",
        rotate_button: "Girar",
        table_column: {
            id: "ID",
            status: "Status",
            algorithm: "Algoritmo de assinatura"
        },
        status: {
            current: "Atual",
            previous: "Anterior"
        },
        reminder: {
            rotate_private_key: "Tem certeza de que deseja girar as <strong>chaves privadas do OIDC</strong>? Os novos tokens JWT emitidos ser\xe3o assinados pela nova chave. Os tokens JWT existentes permanecem v\xe1lidos at\xe9 voc\xea girar novamente.",
            rotate_cookie_key: "Tem certeza de que deseja girar as <strong>chaves de cookie do OIDC</strong>? Novos cookies gerados em sess\xf5es de login ser\xe3o assinados pela nova chave de cookie. Os cookies existentes permanecem v\xe1lidos at\xe9 voc\xea girar novamente.",
            delete_private_key: "Tem certeza de que deseja excluir a <strong>chave privada do OIDC</strong>? Tokens JWT existentes assinados com esta chave privada de assinatura n\xe3o ser\xe3o mais v\xe1lidos.",
            delete_cookie_key: "Tem certeza de que deseja excluir a <strong>chave de cookie do OIDC</strong>? As sess\xf5es de login mais antigas com cookies assinados com esta chave de cookie n\xe3o ser\xe3o mais v\xe1lidas. Ser\xe1 necess\xe1ria uma nova autentica\xe7\xe3o para esses usu\xe1rios."
        },
        messages: {
            rotate_key_success: "Chaves de assinatura giradas com sucesso.",
            delete_key_success: "Chave exclu\xedda com sucesso."
        }
    }
};
var $0c969c621135342d$export$2e2bcd8739ae039 = Object.freeze($0c969c621135342d$var$tenants);


const $b88fadc561c793d8$var$topbar = {
    docs: "Documenta\xe7\xe3o",
    help: "Ajuda"
};
var $b88fadc561c793d8$export$2e2bcd8739ae039 = Object.freeze($b88fadc561c793d8$var$topbar);


const $a3f941d7109f1442$var$paywall = {
    applications: "Limite de {{count, number}} aplica\xe7\xe3o do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    applications_other: "Limite de {{count, number}} aplica\xe7\xf5es do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_feature: "Atualize para o plano <strong>Hobby</strong> para desbloquear 1 aplica\xe7\xe3o de m\xe1quina para m\xe1quina, ou escolha o plano <strong>Pro</strong> para uso ilimitado. Para qualquer assist\xeancia, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine: "Limite de {{count, number}} aplica\xe7\xe3o de m\xe1quina para m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_other: "Limite de {{count, number}} aplica\xe7\xf5es de m\xe1quina para m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    resources: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipe. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    resources_other: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipe. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource_other: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    custom_domain: "Desbloqueie a funcionalidade de dom\xednio personalizado ao atualizar para o plano <strong>Hobby</strong> ou <strong>Pro</strong>. N\xe3o hesite em <a>entrar em contato conosco</a> se precisar de alguma ajuda.",
    social_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    social_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_feature: "Atualize para o plano <strong>Hobby</strong> ou <strong>Pro</strong> para criar seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML, al\xe9m de conectores sociais ilimitados e todos os recursos premium. Sinta-se \xe0 vontade para <a>entrar em contato conosco</a> se precisar de qualquer ajuda.",
    standard_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro_other: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles_other: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    scopes_per_role: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    scopes_per_role_other: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks_other: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    mfa: "Desbloqueie o MFA para verificar a seguran\xe7a, fazendo upgrade para um plano pago. N\xe3o hesite em <a>nos contatar</a> se precisar de alguma assist\xeancia.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $a3f941d7109f1442$export$2e2bcd8739ae039 = Object.freeze($a3f941d7109f1442$var$paywall);


const $955504c3e8efb865$var$upsell = {
    upgrade_plan: "Atualizar plano",
    compare_plans: "Comparar planos",
    view_plans: "Ver planos",
    create_tenant: {
        title: "Selecione o seu plano de inquilino",
        description: "O Logto oferece op\xe7\xf5es competitivas de planos com pre\xe7os inovadores e acess\xedveis, especialmente concebidos para empresas em crescimento. <a>Saiba mais</a>",
        base_price: "Pre\xe7o base",
        monthly_price: "{{value, number}}/m\xeas",
        mau_unit_price: "Pre\xe7o unit\xe1rio do MAU",
        view_all_features: "Ver todas as funcionalidades",
        select_plan: "Selecionar <name/>",
        free_tenants_limit: "At\xe9 {{count, number}} inquilino gratuito",
        free_tenants_limit_other: "At\xe9 {{count, number}} inquilinos gratuitos",
        most_popular: "Mais popular",
        upgrade_success: "Atualiza\xe7\xe3o para <name/> bem-sucedida"
    },
    mau_exceeded_modal: {
        title: "MAU excedeu o limite. Atualize o seu plano.",
        notification: "O seu MAU atual excedeu o limite de <planName/>. Por favor, atualize para o plano premium a tempo para evitar a suspens\xe3o do servi\xe7o do Logto.",
        update_plan: "Atualizar plano"
    },
    payment_overdue_modal: {
        title: "Pagamento da fatura em atraso",
        notification: "Oops! O pagamento da fatura do inquilino <span>{{name}}</span> falhou. Por favor, pague a fatura prontamente para evitar a suspens\xe3o do servi\xe7o Logto.",
        unpaid_bills: "Faturas n\xe3o pagas",
        update_payment: "Atualizar pagamento"
    },
    paywall: $a3f941d7109f1442$export$2e2bcd8739ae039
};
var $955504c3e8efb865$export$2e2bcd8739ae039 = Object.freeze($955504c3e8efb865$var$upsell);


const $a340109596f6946c$var$user_details = {
    page_title: "Detalhes do usu\xe1rio",
    back_to_users: "Voltar para gerenciamento de usu\xe1rios",
    created_title: "Este usu\xe1rio foi criado com sucesso",
    created_guide: "Aqui est\xe1 a informa\xe7\xe3o para ajudar o usu\xe1rio com o processo de login.",
    created_email: "Endere\xe7o de e-mail:",
    created_phone: "N\xfamero de telefone:",
    created_username: "Nome de usu\xe1rio:",
    created_password: "Senha:",
    menu_delete: "Excluir",
    delete_description: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso excluir\xe1 permanentemente o usu\xe1rio.",
    deleted: "O usu\xe1rio foi exclu\xeddo com sucesso",
    reset_password: {
        reset_password: "Redefinir senha",
        title: "Tem certeza de que deseja redefinir a senha?",
        content: "Essa a\xe7\xe3o n\xe3o pode ser desfeita. Isso redefinir\xe1 as informa\xe7\xf5es de login do usu\xe1rio.",
        congratulations: "Este usu\xe1rio foi redefinido",
        new_password: "Nova senha:"
    },
    tab_settings: "Configura\xe7\xf5es",
    tab_roles: "Fun\xe7\xf5es",
    tab_logs: "Registros",
    tab_organizations: "Organiza\xe7\xf5es",
    authentication: "Autentica\xe7\xe3o",
    authentication_description: "Cada usu\xe1rio tem um perfil contendo todas as informa\xe7\xf5es do usu\xe1rio. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados.",
    user_profile: "Perfil do usu\xe1rio",
    field_email: "Endere\xe7o de e-mail",
    field_phone: "N\xfamero de telefone",
    field_username: "Nome de usu\xe1rio",
    field_name: "Nome",
    field_avatar: "URL da imagem do avatar",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Dados personalizados",
    field_custom_data_tip: "Informa\xe7\xf5es adicionais do usu\xe1rio n\xe3o listadas nas propriedades de usu\xe1rio predefinidas, como cor e idioma preferidos do usu\xe1rio.",
    field_connectors: "Conectores de login sociais",
    field_sso_connectors: "Conex\xf5es empresariais",
    custom_data_invalid: "Os dados personalizados devem ser um objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID do usu\xe1rio",
        remove: "Remover",
        connected: "Este usu\xe1rio est\xe1 conectado com v\xe1rios conectores sociais.",
        not_connected: "O usu\xe1rio n\xe3o est\xe1 conectado a nenhum conector social",
        deletion_confirmation: "Voc\xea est\xe1 removendo a identidade existente <name/>. Tem certeza de que deseja continuar?"
    },
    sso_connectors: {
        connectors: "Conectores",
        enterprise_id: "ID da empresa",
        connected: "Este usu\xe1rio est\xe1 conectado a v\xe1rios fornecedores de identidade empresarial para Entrada \xdanica.",
        not_connected: "O usu\xe1rio n\xe3o est\xe1 conectado a nenhum provedor de identidade empresarial para Entrada \xdanica."
    },
    mfa: {
        field_name: "Autentica\xe7\xe3o de dois fatores",
        field_description: "Este usu\xe1rio habilitou fatores de autentica\xe7\xe3o de 2 etapas.",
        name_column: "Autentica\xe7\xe3o de dois fatores",
        field_description_empty: "Este usu\xe1rio n\xe3o habilitou fatores de autentica\xe7\xe3o em duas etapas.",
        deletion_confirmation: "Voc\xea est\xe1 removendo o existente <name/> para a verifica\xe7\xe3o em duas etapas. Tem certeza de que deseja continuar?"
    },
    suspended: "Suspenso",
    suspend_user: "Suspender usu\xe1rio",
    suspend_user_reminder: "Tem certeza de que deseja suspender este usu\xe1rio? O usu\xe1rio n\xe3o poder\xe1 entrar em seu aplicativo e n\xe3o poder\xe1 obter um novo token de acesso ap\xf3s a expira\xe7\xe3o do atual. Al\xe9m disso, qualquer solicita\xe7\xe3o de API feita por este usu\xe1rio falhar\xe1.",
    suspend_action: "Suspender",
    user_suspended: "O usu\xe1rio foi suspenso",
    reactivate_user: "Reativar usu\xe1rio",
    reactivate_user_reminder: "Tem certeza de que deseja reativar este usu\xe1rio? Fazendo isso permitir\xe1 quaisquer tentativas de login para este usu\xe1rio.",
    reactivate_action: "Reativar",
    user_reactivated: "O usu\xe1rio foi reativado",
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o remover\xe1 esta fun\xe7\xe3o deste usu\xe1rio. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o estar\xe1 mais associada a este usu\xe1rio.",
        deleted: "{{name}} foi removido com sucesso deste usu\xe1rio.",
        assign_title: "Atribuir fun\xe7\xf5es para {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar por nome de fun\xe7\xe3o",
        added_text: "{{value, number}} adicionado(s)",
        assigned_user_count: "{{value, number}} usu\xe1rios",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(\xf5es) atribu\xedda(s) com sucesso",
        search: "Pesquisar por nome de fun\xe7\xe3o, descri\xe7\xe3o ou ID",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    },
    warning_no_sign_in_identifier: "O usu\xe1rio precisa ter pelo menos um dos identificadores de login (nome de usu\xe1rio, e-mail, n\xfamero de telefone ou social) para fazer login. Tem certeza de que deseja continuar?",
    organization_roles_tooltip: "As fun\xe7\xf5es atribu\xeddas ao usu\xe1rio dentro desta organiza\xe7\xe3o."
};
var $a340109596f6946c$export$2e2bcd8739ae039 = Object.freeze($a340109596f6946c$var$user_details);


const $d6442d570168429e$var$users = {
    page_title: "Gerenciamento de usu\xe1rios",
    title: "Gerenciamento de usu\xe1rios",
    subtitle: "Gerenciar identidades de usu\xe1rios, visualiza\xe7\xe3o de logs de usu\xe1rios, redefini\xe7\xf5es de senha e exclus\xe3o de usu\xe1rios",
    create: "Adicionar usu\xe1rio",
    create_subtitle: "Fornecer pelo menos um dos seguintes campos para prosseguir.",
    error_missing_identifier: "Voc\xea deve fornecer pelo menos um identificador para criar um usu\xe1rio.",
    user_name: "Nome de usu\xe1rio",
    application_name: "Aplicativo",
    latest_sign_in: "\xdaltimo login",
    create_form_username: "Nome de usu\xe1rio",
    create_form_password: "Senha",
    create_form_name: "Nome completo",
    placeholder_name: "Jo\xe3o da Silva",
    placeholder_email: "jsilva@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+55 (11) 1234-5678",
    unnamed: "Sem nome",
    search: "Busca por nome, e-mail, telefone ou nome de usu\xe1rio",
    check_user_detail: "Detalhes do usu\xe1rio",
    placeholder_title: "Gerenciamento de usu\xe1rios",
    placeholder_description: "Cada usu\xe1rio possui um perfil contendo todas as informa\xe7\xf5es do usu\xe1rio. Ele \xe9 composto por dados b\xe1sicos, identidades sociais e dados personalizados."
};
var $d6442d570168429e$export$2e2bcd8739ae039 = Object.freeze($d6442d570168429e$var$users);


const $5ffdc5f7e66cca04$var$webhook_details = {
    page_title: "Detalhes do webhook",
    back_to_webhooks: "Voltar para Webhooks",
    not_in_use: "N\xe3o em uso",
    success_rate: "Taxa de sucesso",
    requests: "{{value, number}} requisi\xe7\xf5es em 24h",
    disable_webhook: "Desativar webhook",
    disable_reminder: "Tem certeza de que deseja reativar este webhook? Isso n\xe3o enviar\xe1 uma solicita\xe7\xe3o HTTP para o URL do endpoint.",
    webhook_disabled: "O webhook foi desativado.",
    webhook_reactivated: "O webhook foi reativado.",
    reactivate_webhook: "Reativar webhook",
    delete_webhook: "Excluir webhook",
    deletion_reminder: "Voc\xea est\xe1 removendo este webhook. Depois de exclu\xed-lo, n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    deleted: "O webhook foi exclu\xeddo com sucesso.",
    settings_tab: "Configura\xe7\xf5es",
    recent_requests_tab: "Solicita\xe7\xf5es recentes (24h)",
    settings: {
        settings: "Configura\xe7\xf5es",
        settings_description: "Os webhooks permitem que voc\xea receba atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos conforme eles ocorrem, enviando uma solicita\xe7\xe3o POST para o URL do seu endpoint. Isso permite que voc\xea tome a\xe7\xf5es imediatas com base nas novas informa\xe7\xf5es recebidas.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        endpoint_url: "URL do Endpoint",
        signing_key: "Chave de assinatura",
        signing_key_tip: "Adicione a chave secreta fornecida pelo Logto ao seu endpoint como um cabe\xe7alho de solicita\xe7\xe3o para garantir a autenticidade do payload do webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar chave de assinatura",
        regenerate_key_reminder: "Tem certeza de que deseja modificar a chave de assinatura? A regenera\xe7\xe3o ter\xe1 efeito imediato. Lembre-se de modificar a chave de assinatura de forma s\xedncrona em seu endpoint.",
        regenerated: "A chave de assinatura foi regenerada.",
        custom_headers: "Cabe\xe7alhos personalizados",
        custom_headers_tip: "Opcionalmente, voc\xea pode adicionar cabe\xe7alhos personalizados ao payload do webhook para fornecer contexto ou metadados adicionais sobre o evento.",
        key_duplicated_error: "As chaves n\xe3o podem ser repetidas.",
        key_missing_error: "A chave \xe9 obrigat\xf3ria.",
        value_missing_error: "O valor \xe9 obrigat\xf3rio.",
        invalid_key_error: "Chave inv\xe1lida",
        invalid_value_error: "O valor \xe9 inv\xe1lido",
        test: "Testar",
        test_webhook: "Teste seu webhook",
        test_webhook_description: "Configure o webhook e teste-o com exemplos de carga para cada evento selecionado para verifica\xe7\xe3o da recep\xe7\xe3o e processamento corretos.",
        send_test_payload: "Enviar carga de teste",
        test_result: {
            endpoint_url: "URL do ponto de extremidade: {{url}}",
            message: "Mensagem: {{message}}",
            response_status: "Status da resposta: {{status, number}}",
            response_body: "Corpo da resposta: {{body}}",
            request_time: "Tempo da solicita\xe7\xe3o: {{time}}",
            test_success: "O teste de webhook para o ponto de extremidade foi bem-sucedido."
        }
    }
};
var $5ffdc5f7e66cca04$export$2e2bcd8739ae039 = Object.freeze($5ffdc5f7e66cca04$var$webhook_details);


const $7653ac8153b53e66$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crie ganchos da web para receber atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos sem esfor\xe7o.",
    create: "Criar Webhook",
    events: {
        post_register: "Criar nova conta",
        post_sign_in: "Entrar",
        post_reset_password: "Redefinir senha"
    },
    table: {
        name: "Nome",
        events: "Eventos",
        success_rate: "Taxa de sucesso (24h)",
        requests: "Requisi\xe7\xf5es (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crie um webhook para receber atualiza\xe7\xf5es em tempo real por meio de solicita\xe7\xf5es POST para o URL do seu ponto de extremidade. Fique informado e tome medidas imediatas em eventos como "Criar conta", "Entrar" e "Redefinir senha".',
        create_webhook: "Criar Webhook"
    },
    create_form: {
        title: "Criar Webhook",
        subtitle: "Adicione o Webhook para enviar uma solicita\xe7\xe3o POST para o URL do endpoint com detalhes de quaisquer eventos de usu\xe1rios.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        name_placeholder: "Digite o nome do webhook",
        endpoint_url: "URL de endpoint",
        endpoint_url_placeholder: "https://seu.url.endpoint.do.webhook",
        endpoint_url_tip: "Insira o URL do seu ponto de extremidade para o qual a carga \xfatil de um webhook \xe9 enviada quando o evento ocorre.",
        create_webhook: "Criar webhook",
        missing_event_error: "Voc\xea precisa selecionar pelo menos um evento."
    },
    webhook_created: "O webhook {{name}} foi criado com sucesso."
};
var $7653ac8153b53e66$export$2e2bcd8739ae039 = Object.freeze($7653ac8153b53e66$var$webhooks);


const $1c6e9522a14f1b06$var$welcome = {
    title: "Bem-vindo ao Admin Console",
    description: "O Admin Console \xe9 um aplicativo da web para gerenciar o Logto sem requisitos de codifica\xe7\xe3o. Vamos primeiro criar uma conta. Com esta conta, voc\xea pode gerenciar o Logto sozinho ou em nome de sua empresa.",
    create_account: "Criar uma conta"
};
var $1c6e9522a14f1b06$export$2e2bcd8739ae039 = Object.freeze($1c6e9522a14f1b06$var$welcome);


const $da47332ce4ffe6c2$var$admin_console = {
    title: "Admin Console",
    admin_user: "Administrador",
    system_app: "Sistema",
    menu: $46b821ff82268d07$export$2e2bcd8739ae039,
    general: $c402f0ddaf320a56$export$2e2bcd8739ae039,
    errors: $600a311aa5c074c5$export$2e2bcd8739ae039,
    tab_sections: $6964a765eac50994$export$2e2bcd8739ae039,
    tabs: $8aba1d43895ca0c1$export$2e2bcd8739ae039,
    applications: $5260c9fe39bfcc36$export$2e2bcd8739ae039,
    application_details: $685061a5164cd0f4$export$2e2bcd8739ae039,
    api_resources: $440b3ca5e3eca9c3$export$2e2bcd8739ae039,
    api_resource_details: $7fce9b2a22590be3$export$2e2bcd8739ae039,
    connectors: $478533596fc51c12$export$2e2bcd8739ae039,
    connector_details: $57508cb64fdcf14b$export$2e2bcd8739ae039,
    enterprise_sso: $921d4766163924fc$export$2e2bcd8739ae039,
    enterprise_sso_details: $636cd33e8076db0a$export$2e2bcd8739ae039,
    get_started: $96f5bc184f6d7d39$export$2e2bcd8739ae039,
    users: $d6442d570168429e$export$2e2bcd8739ae039,
    user_details: $a340109596f6946c$export$2e2bcd8739ae039,
    contact: $6904d12f56f6bbee$export$2e2bcd8739ae039,
    sign_in_exp: $f8dc6a5b87808204$export$2e2bcd8739ae039,
    dashboard: $a02125e7fe8612c2$export$2e2bcd8739ae039,
    logs: $5a54e4e80c860220$export$2e2bcd8739ae039,
    log_details: $1a6238832b2a2618$export$2e2bcd8739ae039,
    session_expired: $0955535770d9dd08$export$2e2bcd8739ae039,
    welcome: $1c6e9522a14f1b06$export$2e2bcd8739ae039,
    roles: $474a549525a946de$export$2e2bcd8739ae039,
    role_details: $27b8e699498914b5$export$2e2bcd8739ae039,
    permissions: $2c0fe01ae5330895$export$2e2bcd8739ae039,
    cloud: $64549226245b8ac7$export$2e2bcd8739ae039,
    profile: $5d5cf5617cb2e905$export$2e2bcd8739ae039,
    components: $63545e196cb052a7$export$2e2bcd8739ae039,
    webhooks: $7653ac8153b53e66$export$2e2bcd8739ae039,
    webhook_details: $5ffdc5f7e66cca04$export$2e2bcd8739ae039,
    domain: $d8979efed83ddc06$export$2e2bcd8739ae039,
    tenants: $0c969c621135342d$export$2e2bcd8739ae039,
    topbar: $b88fadc561c793d8$export$2e2bcd8739ae039,
    subscription: $03a5118f823c3eca$export$2e2bcd8739ae039,
    upsell: $955504c3e8efb865$export$2e2bcd8739ae039,
    guide: $a354c9010aa5f1fa$export$2e2bcd8739ae039,
    mfa: $a8ea0ef213699452$export$2e2bcd8739ae039,
    organizations: $d781a89d7feb1e57$export$2e2bcd8739ae039,
    organization_details: $793f32eb294f8ca7$export$2e2bcd8739ae039
};
var $da47332ce4ffe6c2$export$2e2bcd8739ae039 = Object.freeze($da47332ce4ffe6c2$var$admin_console);


const $c7d1245ff3875d10$var$demo_app = {
    title: "You've successfully signed in the live preview!",
    subtitle: "Aqui est\xe3o suas informa\xe7\xf5es de login:",
    username: "Nome de usu\xe1rio: ",
    user_id: "ID do usu\xe1rio: ",
    sign_out: "Sair da Visualiza\xe7\xe3o ao Vivo",
    continue_explore: "Ou continuar a navega\xe7\xe3o",
    customize_sign_in_experience: "Personalize a experi\xeancia de login",
    enable_passwordless: "Ativar acesso livre",
    add_social_connector: "Adicionar conector social"
};
var $c7d1245ff3875d10$export$2e2bcd8739ae039 = Object.freeze($c7d1245ff3875d10$var$demo_app);


const $4ad31338491de8cc$var$oidc = {
    logout_success: "Voc\xea saiu com sucesso."
};
var $4ad31338491de8cc$export$2e2bcd8739ae039 = Object.freeze($4ad31338491de8cc$var$oidc);


const $3cec1c6258d8fadb$var$translation = {
    admin_console: $da47332ce4ffe6c2$export$2e2bcd8739ae039,
    demo_app: $c7d1245ff3875d10$export$2e2bcd8739ae039,
    oidc: $4ad31338491de8cc$export$2e2bcd8739ae039
};
var $3cec1c6258d8fadb$export$2e2bcd8739ae039 = Object.freeze($3cec1c6258d8fadb$var$translation);


const $6cc6e133a8f40dd5$var$pt_br = {
    translation: $3cec1c6258d8fadb$export$2e2bcd8739ae039,
    errors: $fbcead12bb6fa025$export$2e2bcd8739ae039
};
var $6cc6e133a8f40dd5$export$2e2bcd8739ae039 = Object.freeze($6cc6e133a8f40dd5$var$pt_br);


const $b0c1afc78047253f$var$application = {
    invalid_type: "Apenas aplica\xe7\xf5es m\xe1quina a m\xe1quina podem ter fun\xe7\xf5es associadas.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a esta aplica\xe7\xe3o.",
    invalid_role_type: "N\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o de tipo de utilizador a uma aplica\xe7\xe3o m\xe1quina a m\xe1quina."
};
var $b0c1afc78047253f$export$2e2bcd8739ae039 = Object.freeze($b0c1afc78047253f$var$application);


const $058175f7e1cb65ea$var$auth = {
    authorization_header_missing: "O cabe\xe7alho de autoriza\xe7\xe3o est\xe1 ausente.",
    authorization_token_type_not_supported: "O tipo de autoriza\xe7\xe3o n\xe3o \xe9 suportado.",
    unauthorized: "N\xe3o autorizado. Verifique as credenciais e o scope.",
    forbidden: "Proibido. Verifique os seus cargos e permiss\xf5es.",
    expected_role_not_found: "Role esperado n\xe3o encontrado. Verifique os seus cargos e permiss\xf5es.",
    jwt_sub_missing: "Campo `sub` est\xe1 ausente no JWT.",
    require_re_authentication: "\xc9 necess\xe1ria uma nova autentica\xe7\xe3o para executar uma a\xe7\xe3o protegida."
};
var $058175f7e1cb65ea$export$2e2bcd8739ae039 = Object.freeze($058175f7e1cb65ea$var$auth);


const $408684fa86d4e328$var$connector = {
    general: "Ocorreu um erro no conector: {{errorDescription}}",
    not_found: "N\xe3o \xe9 poss\xedvel encontrar nenhum conector dispon\xedvel para o tipo: {{type}}.",
    not_enabled: "O conector n\xe3o est\xe1 ativo.",
    invalid_metadata: "Os metadados do conector s\xe3o inv\xe1lidos.",
    invalid_config_guard: "A configura\xe7\xe3o de prote\xe7\xe3o do conector \xe9 inv\xe1lida.",
    unexpected_type: "O tipo do conector \xe9 inesperado.",
    invalid_request_parameters: "O pedido tem par\xe2metros de entrada inv\xe1lidos.",
    insufficient_request_parameters: "A solicita\xe7\xe3o pode perder alguns par\xe2metros de entrada.",
    invalid_config: "A configura\xe7\xe3o do conector \xe9 inv\xe1lida.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "A resposta do conector \xe9 inv\xe1lida.",
    template_not_found: "N\xe3o foi poss\xedvel encontrar o modelo correto na configura\xe7\xe3o do conector.",
    template_not_supported: "O conector n\xe3o suporta este tipo de modelo.",
    rate_limit_exceeded: "Limite de taxa de ativa\xe7\xe3o. Por favor, tente novamente mais tarde.",
    not_implemented: "{{method}}: ainda n\xe3o foi implementado.",
    social_invalid_access_token: "O token de acesso do conector \xe9 inv\xe1lido.",
    invalid_auth_code: "O c\xf3digo de autentica\xe7\xe3o do conector \xe9 inv\xe1lido.",
    social_invalid_id_token: "O token de ID do conector \xe9 inv\xe1lido.",
    authorization_failed: "O processo de autoriza\xe7\xe3o do usu\xe1rio n\xe3o foi bem-sucedido.",
    social_auth_code_invalid: "N\xe3o foi poss\xedvel obter o token de acesso, verifique o c\xf3digo de autoriza\xe7\xe3o.",
    more_than_one_sms: "O n\xfamero de conectores SMS \xe9 maior que 1.",
    more_than_one_email: "O n\xfamero de conectores de e-mail \xe9 maior que 1.",
    more_than_one_connector_factory: "Foram encontradas v\xe1rias f\xe1bricas de conectores (com id {{connectorIds}}), pode desinstalar as desnecess\xe1rias.",
    db_connector_type_mismatch: "H\xe1 um conector no banco de dados que n\xe3o corresponde ao tipo.",
    not_found_with_connector_id: "N\xe3o foi poss\xedvel encontrar o conector com o id do conector padr\xe3o fornecido.",
    multiple_instances_not_supported: "N\xe3o \xe9 poss\xedvel criar v\xe1rias inst\xe2ncias com o conector padr\xe3o selecionado.",
    invalid_type_for_syncing_profile: "Voc\xea s\xf3 pode sincronizar o perfil do usu\xe1rio com conectores sociais.",
    can_not_modify_target: "O 'target' do conector n\xe3o pode ser modificado.",
    should_specify_target: "Voc\xea deve especificar o alvo (target).",
    multiple_target_with_same_platform: "N\xe3o \xe9 poss\xedvel ter v\xe1rios conectores sociais com o mesmo alvo e plataforma.",
    cannot_overwrite_metadata_for_non_standard_connector: "Os metadados deste conector n\xe3o podem ser sobrescritos."
};
var $408684fa86d4e328$export$2e2bcd8739ae039 = Object.freeze($408684fa86d4e328$var$connector);


const $7e2bec4186826ea8$var$domain = {
    not_configured: "O provedor de nome de host de dom\xednio n\xe3o est\xe1 configurado.",
    cloudflare_data_missing: "cloudflare_data est\xe1 faltando, por favor verifique.",
    cloudflare_unknown_error: "Obteve um erro desconhecido ao solicitar a API Cloudflare",
    cloudflare_response_error: "Obteve uma resposta inesperada da Cloudflare.",
    limit_to_one_domain: "Voc\xea s\xf3 pode ter um dom\xednio personalizado.",
    hostname_already_exists: "Este dom\xednio j\xe1 existe em nosso servidor.",
    cloudflare_not_found: "N\xe3o \xe9 poss\xedvel encontrar o nome de host no Cloudflare"
};
var $7e2bec4186826ea8$export$2e2bcd8739ae039 = Object.freeze($7e2bec4186826ea8$var$domain);


const $1d32e61eddb315e3$var$entity = {
    invalid_input: "Entrada inv\xe1lida. A lista de valores n\xe3o deve estar vazia.",
    create_failed: "Falha ao criar {{name}}.",
    db_constraint_violated: "Restri\xe7\xe3o do banco de dados violada.",
    not_exists: "{{name}} n\xe3o existe.",
    not_exists_with_id: "{{name}} com o ID '{{id}}' n\xe3o existe.",
    not_found: "O recurso n\xe3o existe.",
    relation_foreign_key_not_found: "N\xe3o \xe9 poss\xedvel encontrar uma ou mais chaves estrangeiras. Por favor, verifique a entrada e certifique-se de que todas as entidades referenciadas existam.",
    unique_integrity_violation: "A entidade j\xe1 existe. Por favor, verifique a entrada e tente novamente."
};
var $1d32e61eddb315e3$export$2e2bcd8739ae039 = Object.freeze($1d32e61eddb315e3$var$entity);


const $11f5156d932d1a4f$var$guard = {
    invalid_input: "O pedido {{type}} \xe9 inv\xe1lido.",
    invalid_pagination: "O valor de pagina\xe7\xe3o enviado \xe9 inv\xe1lido.",
    can_not_get_tenant_id: "N\xe3o \xe9 poss\xedvel obter o ID do inquilino a partir do pedido.",
    file_size_exceeded: "Tamanho do ficheiro excedido.",
    mime_type_not_allowed: "Tipo MIME n\xe3o permitido."
};
var $11f5156d932d1a4f$export$2e2bcd8739ae039 = Object.freeze($11f5156d932d1a4f$var$guard);


const $4e112b87d1d5ee91$var$hook = {
    missing_events: "Voc\xea precisa fornecer pelo menos um evento.",
    send_test_payload_failed: "Falha ao enviar carga de teste: {{message}}",
    endpoint_responded_with_error: "O ponto de extremidade respondeu com erro."
};
var $4e112b87d1d5ee91$export$2e2bcd8739ae039 = Object.freeze($4e112b87d1d5ee91$var$hook);


const $13d172991d006af5$var$localization = {
    cannot_delete_default_language: "{{languageTag}} \xe9 o seu idioma padr\xe3o e n\xe3o pode ser exclu\xeddo.",
    invalid_translation_structure: "Estrutura de dados inv\xe1lida. Verifique sua entrada e tente novamente."
};
var $13d172991d006af5$export$2e2bcd8739ae039 = Object.freeze($13d172991d006af5$var$localization);


const $5925447271189b49$var$log = {
    invalid_type: "O tipo de registro \xe9 inv\xe1lido."
};
var $5925447271189b49$export$2e2bcd8739ae039 = Object.freeze($5925447271189b49$var$log);


const $f2375196c9afa3f5$var$oidc = {
    aborted: "O utilizador final abortou a intera\xe7\xe3o.",
    invalid_scope: "\xc2mbito inv\xe1lido: {{error_description}}.",
    invalid_token: "O Token fornecido \xe9 inv\xe1lido.",
    invalid_client_metadata: "Metadados de cliente inv\xe1lidos fornecidos.",
    insufficient_scope: "Token em falta com \xe2mbito `{{scope}}`.",
    invalid_request: "Pedido inv\xe1lido.",
    invalid_grant: "Pedido Grant inv\xe1lido.",
    invalid_redirect_uri: "`redirect_uri` n\xe3o correspondeu a nenhum dos `redirect_uris` registados.",
    access_denied: "Acesso negado.",
    invalid_target: "Indicador de recurso inv\xe1lido.",
    unsupported_grant_type: "`grant_type` solicitado n\xe3o \xe9 suportado.",
    unsupported_response_mode: "`response_mode` solicitado n\xe3o \xe9 suportado.",
    unsupported_response_type: "`response_type` solicitado n\xe3o \xe9 suportado.",
    provider_error: "Erro interno OIDC: {{message}}.",
    server_error: "Ocorreu um erro OIDC desconhecido. Por favor, tente novamente mais tarde.",
    provider_error_fallback: "Ocorreu um erro OIDC: {{code}}.",
    key_required: "Pelo menos uma chave \xe9 necess\xe1ria.",
    key_not_found: "A chave com ID {{id}} n\xe3o foi encontrada."
};
var $f2375196c9afa3f5$export$2e2bcd8739ae039 = Object.freeze($f2375196c9afa3f5$var$oidc);


const $ec554bf3d649b64c$var$organization = {
    require_membership: "O utilizador deve ser membro da organiza\xe7\xe3o para avan\xe7ar."
};
var $ec554bf3d649b64c$export$2e2bcd8739ae039 = Object.freeze($ec554bf3d649b64c$var$organization);


const $37a21f390cd3cf98$var$password = {
    unsupported_encryption_method: "O m\xe9todo de encripta\xe7\xe3o {{name}} n\xe3o \xe9 suportado.",
    pepper_not_found: "pepper da Password n\xe3o encontrada. Por favor, verifique os envs.",
    rejected: "Senha rejeitada. Por favor, verifique se sua senha atende aos requisitos."
};
var $37a21f390cd3cf98$export$2e2bcd8739ae039 = Object.freeze($37a21f390cd3cf98$var$password);


const $3d058df5473534b5$var$request = {
    invalid_input: "Input inv\xe1lido. {{details}}",
    general: "Ocorreu um erro no pedido."
};
var $3d058df5473534b5$export$2e2bcd8739ae039 = Object.freeze($3d058df5473534b5$var$request);


const $5daf03372c6df644$var$resource = {
    resource_identifier_in_use: "O identificador da API {{indicator}} j\xe1 est\xe1 em uso"
};
var $5daf03372c6df644$export$2e2bcd8739ae039 = Object.freeze($5daf03372c6df644$var$resource);


const $6af39ad4c6bf21c5$var$role = {
    name_in_use: "Este nome de fun\xe7\xe3o {{name}} j\xe1 est\xe1 em uso",
    scope_exists: "O id do escopo {{scopeId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    user_exists: "O id do usu\xe1rio {{userId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    application_exists: "O id de aplica\xe7\xe3o {{applicationId}} j\xe1 foi adicionado a esta fun\xe7\xe3o",
    default_role_missing: "Alguns dos nomes de fun\xe7\xe3o padr\xe3o n\xe3o existem no banco de dados, por favor, certifique-se de criar as fun\xe7\xf5es primeiro",
    internal_role_violation: 'Voc\xea pode estar tentando atualizar ou excluir uma fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Se voc\xea estiver criando uma nova fun\xe7\xe3o, tente outro nome que n\xe3o comece com "#internal:". '
};
var $6af39ad4c6bf21c5$export$2e2bcd8739ae039 = Object.freeze($6af39ad4c6bf21c5$var$role);


const $c2db124608e68d9b$var$scope = {
    name_exists: "O nome do escopo {{name}} j\xe1 est\xe1 em uso",
    name_with_space: "O nome do escopo n\xe3o pode conter espa\xe7os."
};
var $c2db124608e68d9b$export$2e2bcd8739ae039 = Object.freeze($c2db124608e68d9b$var$scope);


const $061eb8388e529a0a$var$session = {
    not_found: "Sess\xe3o n\xe3o encontrada. Por favor, volte e fa\xe7a login novamente.",
    invalid_credentials: "Credenciais inv\xe1lidas. Por favor, verifique os dados.",
    invalid_sign_in_method: "O m\xe9todo de login atual n\xe3o est\xe1 dispon\xedvel.",
    invalid_connector_id: "N\xe3o foi poss\xedvel encontrar um conector dispon\xedvel com o id {{connectorId}}.",
    insufficient_info: "Informa\xe7\xf5es de login insuficientes.",
    connector_id_mismatch: "O connectorId n\xe3o corresponde ao registado na sess\xe3o.",
    connector_session_not_found: "Sess\xe3o do conector n\xe3o encontrada. Por favor, volte e fa\xe7a login novamente.",
    verification_session_not_found: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o processo de verifica\xe7\xe3o e tente novamente.",
    verification_expired: "A conex\xe3o expirou. Verifique novamente para garantir a seguran\xe7a de sua conta.",
    verification_blocked_too_many_attempts: "Muitas tentativas em um curto per\xedodo de tempo. Por favor, tente novamente {{relativeTime}}.",
    unauthorized: "Fa\xe7a login primeiro.",
    unsupported_prompt_name: "Nome de prompt n\xe3o suportado.",
    forgot_password_not_enabled: "Recupera\xe7\xe3o de senha n\xe3o est\xe1 habilitada.",
    verification_failed: "A verifica\xe7\xe3o n\xe3o foi bem-sucedida. Reinicie o processo de verifica\xe7\xe3o e tente novamente.",
    connector_validation_session_not_found: "A sess\xe3o do conector para valida\xe7\xe3o do token n\xe3o foi encontrada.",
    identifier_not_found: "Identificador do usu\xe1rio n\xe3o encontrado. Por favor, volte e fa\xe7a login novamente.",
    interaction_not_found: "Sess\xe3o de intera\xe7\xe3o n\xe3o encontrada. Por favor, volte e inicie a sess\xe3o novamente.",
    not_supported_for_forgot_password: "Esta opera\xe7\xe3o n\xe3o \xe9 suportada para recupera\xe7\xe3o de senha.",
    mfa: {
        require_mfa_verification: "Verifica\xe7\xe3o MFA \xe9 necess\xe1ria para efetuar login.",
        mfa_sign_in_only: "MFA est\xe1 dispon\xedvel apenas para intera\xe7\xe3o de login.",
        pending_info_not_found: "Informa\xe7\xf5es de MFA pendentes n\xe3o encontradas, por favor, inicie o MFA primeiro.",
        invalid_totp_code: "C\xf3digo TOTP inv\xe1lido.",
        webauthn_verification_failed: "A verifica\xe7\xe3o WebAuthn falhou.",
        webauthn_verification_not_found: "Verifica\xe7\xe3o WebAuthn n\xe3o encontrada.",
        bind_mfa_existed: "MFA j\xe1 existe.",
        backup_code_can_not_be_alone: "O c\xf3digo de backup n\xe3o pode ser o \xfanico MFA.",
        backup_code_required: "O c\xf3digo de backup \xe9 necess\xe1rio.",
        invalid_backup_code: "C\xf3digo de backup inv\xe1lido.",
        mfa_policy_not_user_controlled: "A pol\xedtica MFA n\xe3o \xe9 controlada pelo usu\xe1rio."
    },
    sso_enabled: "O login \xfanico est\xe1 habilitado para este e-mail fornecido. Fa\xe7a login com SSO, por favor."
};
var $061eb8388e529a0a$export$2e2bcd8739ae039 = Object.freeze($061eb8388e529a0a$var$session);


const $618117f83339c70d$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'URL dos "Termos de uso" vazio. Adicione o URL se os "Termos de uso" estiverem ativados.',
    empty_social_connectors: "Conectores sociais vazios. Adicione conectores sociais e ative os quando o m\xe9todo de login social estiver ativado.",
    enabled_connector_not_found: "Conector {{type}} ativado n\xe3o encontrado.",
    not_one_and_only_one_primary_sign_in_method: "Deve haver um e apenas um m\xe9todo de login principal. Por favor, verifique sua entrada.",
    username_requires_password: "\xc9 necess\xe1rio habilitar a configura\xe7\xe3o de uma senha para o identificador de inscri\xe7\xe3o por nome de usu\xe1rio.",
    passwordless_requires_verify: "\xc9 necess\xe1rio habilitar a verifica\xe7\xe3o para o identificador de inscri\xe7\xe3o por e-mail/telefone.",
    miss_sign_up_identifier_in_sign_in: "Os m\xe9todos de login devem conter o identificador de inscri\xe7\xe3o.",
    password_sign_in_must_be_enabled: "O login com senha deve ser habilitado quando \xe9 requerido configurar uma senha na inscri\xe7\xe3o.",
    code_sign_in_must_be_enabled: "O login com c\xf3digo de verifica\xe7\xe3o deve ser habilitado quando n\xe3o \xe9 requerido configurar uma senha na inscri\xe7\xe3o.",
    unsupported_default_language: "Este idioma - {{language}} n\xe3o \xe9 suportado no momento.",
    at_least_one_authentication_factor: "Voc\xea deve selecionar pelo menos um fator de autentica\xe7\xe3o.",
    backup_code_cannot_be_enabled_alone: "O c\xf3digo de backup n\xe3o pode ser ativado sozinho.",
    duplicated_mfa_factors: "Fatores MFA duplicados."
};
var $618117f83339c70d$export$2e2bcd8739ae039 = Object.freeze($618117f83339c70d$var$sign_in_experiences);


const $4cabf5983c709fa5$var$single_sign_on = {
    forbidden_domains: "Os dom\xednios de email p\xfablico n\xe3o s\xe3o permitidos.",
    duplicated_domains: "Existem dom\xednios duplicados.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $4cabf5983c709fa5$export$2e2bcd8739ae039 = Object.freeze($4cabf5983c709fa5$var$single_sign_on);


const $d5141c001588eefa$var$storage = {
    not_configured: "O provedor de armazenamento n\xe3o est\xe1 configurado.",
    missing_parameter: "Faltando o par\xe2metro {{parameter}} para o provedor de armazenamento.",
    upload_error: "Falha ao enviar o arquivo para o provedor de armazenamento."
};
var $d5141c001588eefa$export$2e2bcd8739ae039 = Object.freeze($d5141c001588eefa$var$storage);


const $c941406d018c9a06$var$subscription = {
    limit_exceeded: "Voc\xea atingiu o limite do seu plano de assinatura.",
    get_plan_failed: "N\xe3o foi poss\xedvel obter o plano de assinatura para o inquilino.",
    tenant_suspended: "O inquilino est\xe1 suspenso. Por favor, entre em contato com o administrador."
};
var $c941406d018c9a06$export$2e2bcd8739ae039 = Object.freeze($c941406d018c9a06$var$subscription);


const $2ed302f73d96b3b9$var$swagger = {
    invalid_zod_type: "Tipo de Zod inv\xe1lido. Verifique a configura\xe7\xe3o do protetor de rota.",
    not_supported_zod_type_for_params: "Tipo Zod n\xe3o suportado para os par\xe2metros. Verifique a configura\xe7\xe3o do protetor de rota."
};
var $2ed302f73d96b3b9$export$2e2bcd8739ae039 = Object.freeze($2ed302f73d96b3b9$var$swagger);


const $363125cb5abd9cba$var$user = {
    username_already_in_use: "Este nome de utilizador j\xe1 est\xe1 em uso.",
    email_already_in_use: "Este email j\xe1 est\xe1 associado a uma conta existente.",
    phone_already_in_use: "Este n\xfamero de telefone j\xe1 est\xe1 associado a uma conta existente.",
    invalid_email: "Endere\xe7o de email inv\xe1lido.",
    invalid_phone: "N\xfamero de telefone inv\xe1lido.",
    email_not_exist: "O endere\xe7o de email ainda n\xe3o foi registado.",
    phone_not_exist: "O n\xfamero de telefone ainda n\xe3o foi registado.",
    identity_not_exist: "A conta social ainda n\xe3o foi registada.",
    identity_already_in_use: "A conta social foi registada.",
    social_account_exists_in_profile: "A conta social j\xe1 foi associada a este perfil.",
    cannot_delete_self: "N\xe3o se pode remover a si mesmo.",
    sign_up_method_not_enabled: "Este m\xe9todo de registo n\xe3o est\xe1 ativo.",
    sign_in_method_not_enabled: "Este m\xe9todo de in\xedcio de sess\xe3o n\xe3o est\xe1 ativo.",
    same_password: "A nova palavra-passe n\xe3o pode ser igual \xe0 antiga.",
    password_required_in_profile: "Precisa de definir uma palavra-passe antes de iniciar sess\xe3o.",
    new_password_required_in_profile: "Precisa de definir uma nova palavra-passe.",
    password_exists_in_profile: "A palavra-passe j\xe1 existe no seu perfil.",
    username_required_in_profile: "Precisa de definir um nome de utilizador antes de iniciar sess\xe3o.",
    username_exists_in_profile: "O nome de utilizador j\xe1 existe no seu perfil.",
    email_required_in_profile: "Precisa de adicionar um endere\xe7o de email antes de iniciar sess\xe3o.",
    email_exists_in_profile: "O seu perfil j\xe1 est\xe1 associado a um endere\xe7o de email.",
    phone_required_in_profile: "Precisa de adicionar um n\xfamero de telefone antes de iniciar sess\xe3o.",
    phone_exists_in_profile: "O seu perfil j\xe1 est\xe1 associado a um n\xfamero de telefone.",
    email_or_phone_required_in_profile: "Precisa de adicionar um endere\xe7o de email ou um n\xfamero de telefone antes de iniciar sess\xe3o.",
    suspended: "Esta conta est\xe1 suspensa.",
    user_not_exist: "O utilizador com {{ identifier }} n\xe3o existe.",
    missing_profile: "Precisa de fornecer informa\xe7\xf5es adicionais antes de iniciar sess\xe3o.",
    role_exists: "O id da fun\xe7\xe3o {{roleId}} j\xe1 foi adicionado a este utilizador.",
    invalid_role_type: "Tipo de fun\xe7\xe3o inv\xe1lido, n\xe3o \xe9 poss\xedvel atribuir uma fun\xe7\xe3o m\xe1quina a m\xe1quina ao utilizador.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $363125cb5abd9cba$export$2e2bcd8739ae039 = Object.freeze($363125cb5abd9cba$var$user);


const $23a124062f46d80c$var$verification_code = {
    phone_email_empty: "Tanto o telefone como o e-mail est\xe3o vazios.",
    not_found: "C\xf3digo de verifica\xe7\xe3o n\xe3o encontrado. Por favor, envie primeiro o c\xf3digo de verifica\xe7\xe3o.",
    phone_mismatch: "Telefone n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    email_mismatch: "E-mail n\xe3o corresponde. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    code_mismatch: "C\xf3digo de verifica\xe7\xe3o inv\xe1lido.",
    expired: "O c\xf3digo de verifica\xe7\xe3o expirou. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o.",
    exceed_max_try: "Limite m\xe1ximo de tentativas de verifica\xe7\xe3o excedido. Por favor, solicite um novo c\xf3digo de verifica\xe7\xe3o."
};
var $23a124062f46d80c$export$2e2bcd8739ae039 = Object.freeze($23a124062f46d80c$var$verification_code);


const $007704ca147ac61e$var$errors = {
    request: $3d058df5473534b5$export$2e2bcd8739ae039,
    auth: $058175f7e1cb65ea$export$2e2bcd8739ae039,
    guard: $11f5156d932d1a4f$export$2e2bcd8739ae039,
    oidc: $f2375196c9afa3f5$export$2e2bcd8739ae039,
    user: $363125cb5abd9cba$export$2e2bcd8739ae039,
    password: $37a21f390cd3cf98$export$2e2bcd8739ae039,
    session: $061eb8388e529a0a$export$2e2bcd8739ae039,
    connector: $408684fa86d4e328$export$2e2bcd8739ae039,
    verification_code: $23a124062f46d80c$export$2e2bcd8739ae039,
    sign_in_experiences: $618117f83339c70d$export$2e2bcd8739ae039,
    localization: $13d172991d006af5$export$2e2bcd8739ae039,
    swagger: $2ed302f73d96b3b9$export$2e2bcd8739ae039,
    entity: $1d32e61eddb315e3$export$2e2bcd8739ae039,
    log: $5925447271189b49$export$2e2bcd8739ae039,
    role: $6af39ad4c6bf21c5$export$2e2bcd8739ae039,
    scope: $c2db124608e68d9b$export$2e2bcd8739ae039,
    storage: $d5141c001588eefa$export$2e2bcd8739ae039,
    resource: $5daf03372c6df644$export$2e2bcd8739ae039,
    hook: $4e112b87d1d5ee91$export$2e2bcd8739ae039,
    domain: $7e2bec4186826ea8$export$2e2bcd8739ae039,
    subscription: $c941406d018c9a06$export$2e2bcd8739ae039,
    application: $b0c1afc78047253f$export$2e2bcd8739ae039,
    organization: $ec554bf3d649b64c$export$2e2bcd8739ae039,
    single_sign_on: $4cabf5983c709fa5$export$2e2bcd8739ae039
};
var $007704ca147ac61e$export$2e2bcd8739ae039 = Object.freeze($007704ca147ac61e$var$errors);


const $4df7152055ff2d20$var$api_resource_details = {
    page_title: "Detalhes do recurso da API",
    back_to_api_resources: "Voltar aos recursos da API",
    settings_tab: "Configura\xe7\xf5es",
    permissions_tab: "Permiss\xf5es",
    settings: "Configura\xe7\xf5es",
    settings_description: "Os recursos da API, tamb\xe9m conhecidos como indicadores de recursos, indicam os servi\xe7os ou recursos de destino a serem solicitados, geralmente uma vari\xe1vel no formato URI que representa a identidade do recurso.",
    management_api_settings_description: "A API de Gerenciamento do Logto \xe9 uma cole\xe7\xe3o abrangente de APIs que capacitam os administradores a gerenciar uma ampla gama de tarefas relacionadas \xe0 identidade, aplicar pol\xedticas de seguran\xe7a e cumprir regulamentos e padr\xf5es.",
    management_api_notice: "Esta API representa a entidade Logto e n\xe3o pode ser modificada ou eliminada. Voc\xea pode usar a API de gerenciamento para uma ampla gama de tarefas relacionadas \xe0 identidade. <a>Saiba mais</a>",
    token_expiration_time_in_seconds: "Tempo de expira\xe7\xe3o do token (em segundos)",
    token_expiration_time_in_seconds_placeholder: "Insira o tempo de expira\xe7\xe3o do token",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 eliminar permanentemente o recurso da API. Insira o nome do recurso <span>{{name}}</span> para confirmar.",
    enter_your_api_resource_name: "Digite o nome do recurso da API",
    api_resource_deleted: "O recurso da API {{name}} foi eliminado com sucesso",
    permission: {
        create_button: "Criar permiss\xe3o",
        create_title: "Criar permiss\xe3o",
        create_subtitle: "Define as permiss\xf5es (escopos) necess\xe1rios para essa API.",
        confirm_create: "Criar permiss\xe3o",
        name: "Nome da permiss\xe3o",
        name_placeholder: "leitura:recurso",
        forbidden_space_in_name: "O nome da permiss\xe3o n\xe3o pode conter espa\xe7os.",
        description: "Descri\xe7\xe3o",
        description_placeholder: "Capaz de ler os recursos",
        permission_created: "A permiss\xe3o {{name}} foi criada com sucesso",
        delete_description: "Se esta permiss\xe3o for exclu\xedda, o usu\xe1rio que tinha esta permiss\xe3o perder\xe1 o acesso concedido por ela.",
        deleted: 'A permiss\xe3o "{{name}}" foi exclu\xedda com sucesso.'
    }
};
var $4df7152055ff2d20$export$2e2bcd8739ae039 = Object.freeze($4df7152055ff2d20$var$api_resource_details);


const $1cf528d35ada3d47$var$api_resources = {
    page_title: "Recursos de API",
    title: "Recursos de API",
    subtitle: "Defina as APIs que podem ser consumidas ​​pelas aplica\xe7\xf5es autorizadas",
    create: "Criar recurso de API",
    api_name: "Nome da API",
    api_name_placeholder: "Insira o nome da sua API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "O identificador exclusivo para o recurso de API. Deve ser um URI absoluto e n\xe3o ter um componente de fragmento (#). Igual ao <a>par\xe2metro resource</a> no OAuth 2.0.",
    default_api: "API padr\xe3o",
    default_api_label: "Somente uma API padr\xe3o pode ser definida por inquilino. Quando uma API padr\xe3o \xe9 definida, o par\xe2metro de recurso pode ser omitido na solicita\xe7\xe3o de autoriza\xe7\xe3o. Subsequentes trocas de token usar\xe3o essa API como audi\xeancia por padr\xe3o, resultando na emiss\xe3o de JWTs. <a>Saiba mais</a>",
    api_resource_created: "O recurso de API {{name}} foi criado com sucesso"
};
var $1cf528d35ada3d47$export$2e2bcd8739ae039 = Object.freeze($1cf528d35ada3d47$var$api_resources);


const $4e327f63038cf33d$var$application_details = {
    page_title: "Detalhes da aplica\xe7\xe3o",
    back_to_applications: "Voltar para aplica\xe7\xf5es",
    check_guide: "Guia de verifica\xe7\xe3o",
    settings: "Defini\xe7\xf5es",
    settings_description: "As aplica\xe7\xf5es s\xe3o utilizadas para identificar as suas aplica\xe7\xf5es no Logto para OIDC, experi\xeancia de in\xedcio de sess\xe3o, registos de auditoria, etc.",
    advanced_settings: "Defini\xe7\xf5es avan\xe7adas",
    advanced_settings_description: "As configura\xe7\xf5es avan\xe7adas incluem termos relacionados com OIDC. Pode consultar o Endpoint do Token para obter mais informa\xe7\xf5es.",
    application_roles: "Fun\xe7\xf5es da aplica\xe7\xe3o",
    machine_logs: "Registos da m\xe1quina",
    application_name: "Nome da aplica\xe7\xe3o",
    application_name_placeholder: "Ex: Site da Empresa",
    description: "Descri\xe7\xe3o",
    description_placeholder: "Insira a descri\xe7\xe3o da sua aplica\xe7\xe3o",
    config_endpoint: "Endpoint de configura\xe7\xe3o do Provedor de ID Aberto",
    authorization_endpoint: "Endpoint de autoriza\xe7\xe3o",
    authorization_endpoint_tip: "O endpoint para realizar a autentica\xe7\xe3o e autoriza\xe7\xe3o. \xc9 usado para <a>autentica\xe7\xe3o</a> OpenID Connect.",
    logto_endpoint: "Endpoint Logto",
    application_id: "ID da aplica\xe7\xe3o",
    application_id_tip: "O identificador exclusivo da aplica\xe7\xe3o normalmente gerado pelo Logto. Tamb\xe9m representa “<a>client_id</a>” no OpenID Connect.",
    application_secret: "Segredo da aplica\xe7\xe3o",
    redirect_uri: "URI de redirecionamento",
    redirect_uris: "URIs de redirecionamento",
    redirect_uri_placeholder: "https://seusite.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "O URI para redirecionar ap\xf3s o in\xedcio de sess\xe3o de um utilizador (com sucesso ou insucesso). Consulte a <a>AuthRequest</a> do OpenID Connect para obter mais informa\xe7\xf5es.",
    post_sign_out_redirect_uri: "URI de redirecionamento p\xf3s-sa\xedda",
    post_sign_out_redirect_uris: "URIs de redirecionamento p\xf3s-sa\xedda",
    post_sign_out_redirect_uri_placeholder: "https://seusite.com/home",
    post_sign_out_redirect_uri_tip: "O URI para redirecionar ap\xf3s a sa\xedda de um utilizador (opcional). Pode n\xe3o ter efeito pr\xe1tico em alguns tipos de aplica\xe7\xf5es.",
    cors_allowed_origins: "Origens permitidas pelo CORS",
    cors_allowed_origins_placeholder: "https://seusite.com",
    cors_allowed_origins_tip: "Por padr\xe3o, todas as origens de redirecionamento s\xe3o permitidas. Recomenda-se restringi-las. Consulte a <a>documenta\xe7\xe3o MDN</a> para obter informa\xe7\xf5es detalhadas.",
    token_endpoint: "Endpoint do token",
    user_info_endpoint: "Endpoint do Userinfo",
    enable_admin_access: "Ativar o acesso de administrador",
    enable_admin_access_label: "Ativar ou desativar o acesso \xe0 API de gest\xe3o. Uma vez ativado, pode utilizar tokens de acesso para chamar a API de gest\xe3o em nome desta aplica\xe7\xe3o.",
    always_issue_refresh_token: "Sempre emitir token de atualiza\xe7\xe3o",
    always_issue_refresh_token_label: "Ao ativar essa configura\xe7\xe3o, a Logto sempre emitir\xe1 tokens de atualiza\xe7\xe3o, independentemente de `prompt = consent` ser apresentado na solicita\xe7\xe3o de autentica\xe7\xe3o. No entanto, essa pr\xe1tica \xe9 desencorajada, a menos que seja necess\xe1ria, pois n\xe3o \xe9 compat\xedvel com OpenID Connect e pode causar problemas.",
    refresh_token_ttl: "Tempo de vida do token de atualiza\xe7\xe3o em dias",
    refresh_token_ttl_tip: "O tempo pelo qual um token de atualiza\xe7\xe3o pode ser usado para solicitar novos tokens de acesso antes de expirar e se tornar inv\xe1lido. As solicita\xe7\xf5es de token estender\xe3o o TTL do token de atualiza\xe7\xe3o para esse valor.",
    rotate_refresh_token: "Rotacionar o token de atualiza\xe7\xe3o",
    rotate_refresh_token_label: "Quando ativado, o Logto emitir\xe1 um novo token de atualiza\xe7\xe3o para solicita\xe7\xf5es de token quando 70% do tempo de vida original (TTL) tiver passado ou certas condi\xe7\xf5es forem atendidas. <a>Saiba mais</a>",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser revertida. Esta a\xe7\xe3o ir\xe1 eliminar permanentemente a aplica\xe7\xe3o. Insira o nome da aplica\xe7\xe3o <span>{{name}}</span> para confirmar.",
    enter_your_application_name: "Insira o nome da aplica\xe7\xe3o",
    application_deleted: "Aplica\xe7\xe3o {{name}} eliminada com sucesso",
    redirect_uri_required: "Deve inserir pelo menos um URI de redirecionamento",
    roles: {
        name_column: "Nome da fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o ir\xe1 remover esta fun\xe7\xe3o desta aplica\xe7\xe3o entre m\xe1quinas. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o ser\xe1 mais associada a esta aplica\xe7\xe3o entre as m\xe1quinas.",
        deleted: "{{name}} foi removido com sucesso deste utilizador.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorizar {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar por nome de fun\xe7\xe3o",
        added_text: "{{value, number}} adicionado",
        assigned_app_count: "{{value, number}} aplica\xe7\xf5es",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(s) atribu\xedda(s) com sucesso",
        search: "Pesquisar por nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    }
};
var $4e327f63038cf33d$export$2e2bcd8739ae039 = Object.freeze($4e327f63038cf33d$var$application_details);


const $6e7c2d8ac0f1c5e4$var$applications = {
    page_title: "Aplica\xe7\xf5es",
    title: "Aplica\xe7\xf5es",
    subtitle: "Configure um aplicativo m\xf3vel, de p\xe1gina \xfanica, machine to machine ou tradicional para usar o Logto para autentica\xe7\xe3o",
    subtitle_with_app_type: "Configurar autentica\xe7\xe3o Logto para a aplica\xe7\xe3o {{name}}",
    create: "Criar aplica\xe7\xe3o",
    application_name: "Nome da aplica\xe7\xe3o",
    application_name_placeholder: "Ex: Site Empresa",
    application_description: "Descri\xe7\xe3o da aplica\xe7\xe3o",
    application_description_placeholder: "Insira a descri\xe7\xe3o da sua aplica\xe7\xe3o",
    select_application_type: "Selecione o tipo de aplica\xe7\xe3o",
    no_application_type_selected: "Ainda n\xe3o selecionou nenhum tipo de aplica\xe7\xe3o",
    application_created: "A aplica\xe7\xe3o foi criada com sucesso.",
    app_id: "App ID",
    type: {
        native: {
            title: "Nativo",
            subtitle: "Uma aplica\xe7\xe3o que \xe9 executada em um ambiente nativo",
            description: "Ex., App iOS, App Android"
        },
        spa: {
            title: "P\xe1gina \xfanica (SPAs)",
            subtitle: "Uma aplica\xe7\xe3o que \xe9 executada num navegador e atualiza dinamicamente os dados",
            description: "Ex., App React, App VueJS"
        },
        traditional: {
            title: "Web tradicional",
            subtitle: "Uma aplica\xe7\xe3o que renderiza e atualiza p\xe1ginas apenas pelo servidor web",
            description: "Ex., Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Uma aplica\xe7\xe3o (normalmente um servi\xe7o) que se comunica diretamente com recursos",
            description: "Ex., servi\xe7o back-end"
        }
    },
    placeholder_title: "Selecione um tipo de aplica\xe7\xe3o para continuar",
    placeholder_description: "O Logto usa uma entidade de aplicativo para OIDC para ajudar em tarefas como identificar seus aplicativos, gerenciar o registro e criar registros de auditoria."
};
var $6e7c2d8ac0f1c5e4$export$2e2bcd8739ae039 = Object.freeze($6e7c2d8ac0f1c5e4$var$applications);


const $931fbb7f4906ead5$var$cloud = {
    general: {
        onboarding: "Introdu\xe7\xe3o"
    },
    welcome: {
        page_title: "Bem-vindo",
        title: "Bem-vindo ao Logto Cloud! Gostar\xedamos de aprender um pouco sobre voc\xea.",
        description: "Vamos tornar a experi\xeancia da Logto \xfanica para voc\xea conhecendo voc\xea melhor. Suas informa\xe7\xf5es est\xe3o seguras conosco.",
        project_field: "Estou usando a Logto para",
        project_options: {
            personal: "Projeto pessoal",
            company: "Projeto da empresa"
        },
        title_field: "Selecione o(s) t\xedtulo(s) aplic\xe1vel(veis)",
        title_options: {
            developer: "Desenvolvedor/a",
            team_lead: "L\xedder de equipe",
            ceo: "CEO",
            cto: "CTO",
            product: "Produto",
            others: "Outros"
        },
        company_name_field: "Nome da empresa",
        company_name_placeholder: "Acme.co",
        company_size_field: "Qual \xe9 o tamanho da sua empresa?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Estou me registrando porque",
        reason_options: {
            passwordless: "Busco autentica\xe7\xe3o sem senha e kit de UI",
            efficiency: "Busco infraestrutura de identidade out-of-the-box",
            access_control: "Controlar o acesso do usu\xe1rio com base em fun\xe7\xf5es e responsabilidades",
            multi_tenancy: "Procurando estrat\xe9gias para um produto com m\xfaltiplos locat\xe1rios",
            enterprise: "Buscando solu\xe7\xf5es SSO para produtividade empresarial",
            others: "Outros"
        }
    },
    sie: {
        page_title: "Personalize a experi\xeancia de login",
        title: "Vamos personalizar a sua experi\xeancia de login com facilidade",
        inspire: {
            title: "Crie exemplos convincentes",
            description: 'Sentindo-se inseguro/a sobre a experi\xeancia de login? Basta clicar em "Me inspire" e deixar a m\xe1gica acontecer!',
            inspire_me: "Me inspire"
        },
        logo_field: "Logotipo do aplicativo",
        color_field: "Cor da marca",
        identifier_field: "Identificador",
        identifier_options: {
            email: "E-mail",
            phone: "Telefone",
            user_name: "Nome de usu\xe1rio"
        },
        authn_field: "Autentica\xe7\xe3o",
        authn_options: {
            password: "Senha",
            verification_code: "C\xf3digo de verifica\xe7\xe3o"
        },
        social_field: "Login social",
        finish_and_done: "Terminar e pronto",
        preview: {
            mobile_tab: "Celular",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Desbloqueado mais tarde",
            unlocked_later_tip: "Depois de concluir o processo de integra\xe7\xe3o e entrar no produto, voc\xea ter\xe1 acesso a ainda mais m\xe9todos de login social.",
            notice: "Evite usar o conector de demonstra\xe7\xe3o para fins de produ\xe7\xe3o. Depois de conclu\xeddo o teste, exclua gentilmente o conector de demonstra\xe7\xe3o e configure o seu pr\xf3prio conector com suas credenciais."
        }
    },
    socialCallback: {
        title: "Voc\xea entrou com sucesso",
        description: "Voc\xea entrou com sucesso usando sua conta social. Para garantir uma integra\xe7\xe3o perfeita e acesso a todos os recursos do Logto, recomendamos que voc\xea prossiga para configurar seu pr\xf3prio conector social."
    },
    tenant: {
        create_tenant: "Criar novo inquilino"
    }
};
var $931fbb7f4906ead5$export$2e2bcd8739ae039 = Object.freeze($931fbb7f4906ead5$var$cloud);


const $1a888447f6d5e1aa$var$components = {
    uploader: {
        action_description: "Arraste e solte ou navegue",
        uploading: "A enviar...",
        image_limit: "Carregue imagens com menos de {{size, number}}KB, s\xf3 {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Algo correu mal. O carregamento do ficheiro falhou.",
        error_file_size: "O ficheiro \xe9 demasiado grande. Por favor carregue um ficheiro com menos de {{size, number}}KB.",
        error_file_type: "O tipo de ficheiro n\xe3o \xe9 suportado. Apenas {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "S\xf3 \xe9 poss\xedvel carregar 1 ficheiro."
    }
};
var $1a888447f6d5e1aa$export$2e2bcd8739ae039 = Object.freeze($1a888447f6d5e1aa$var$components);


const $b4365ee8e53812ef$var$connector_details = {
    page_title: "Detalhes do conector",
    back_to_connectors: "Voltar para Conectores",
    check_readme: "Verifique o README",
    settings: "Configura\xe7\xf5es gerais",
    settings_description: "Os conectores desempenham um papel cr\xedtico no Logto. Com a sua ajuda, o Logto permite aos utilizadores finais utilizar o registo ou o in\xedcio de sess\xe3o sem palavra-passe e as capacidades de iniciar sess\xe3o com contas sociais.",
    parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
    test_connection: "Testar",
    save_error_empty_config: "Por favor, insira a configura\xe7\xe3o",
    send: "Enviar",
    send_error_invalid_format: "Entrada inv\xe1lida",
    edit_config_label: "Introduza o JSON aqui",
    test_email_sender: "Testar o conector de e-mail",
    test_sms_sender: "Testar o conector de SMS",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+351 912 345 678",
    test_message_sent: "Mensagem de teste enviada",
    test_sender_description: 'O Logto utiliza o modelo "Gen\xe9rico" para os testes. Voc\xea receber\xe1 uma mensagem se o seu conector estiver configurado corretamente.',
    options_change_email: "Alterar conector de e-mail",
    options_change_sms: "Alterar conector de SMS",
    connector_deleted: "O conector foi removido com sucesso",
    type_email: "Conector de E-mail",
    type_sms: "Conector de SMS",
    type_social: "Conector Social",
    in_used_social_deletion_description: "Este conector est\xe1 em uso na sua experi\xeancia de in\xedcio de sess\xe3o. Ao excluir, a experi\xeancia de in\xedcio de sess\xe3o <name/> ser\xe1 exclu\xedda nas configura\xe7\xf5es da experi\xeancia de in\xedcio de sess\xe3o. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    in_used_passwordless_deletion_description: "Este {{name}} est\xe1 em uso na sua experi\xeancia de in\xedcio de sess\xe3o. Ao excluir, sua experi\xeancia de in\xedcio de sess\xe3o n\xe3o funcionar\xe1 corretamente at\xe9 que voc\xea resolva o conflito. Voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    deletion_description: "Voc\xea est\xe1 removendo este conector. Isso n\xe3o pode ser desfeito, e voc\xea precisar\xe1 reconfigur\xe1-lo se decidir adicion\xe1-lo de volta.",
    logto_email: {
        total_email_sent: "Total de emails enviados: {{value, number}}",
        total_email_sent_tip: "Logto utiliza o SendGrid para e-mail interno seguro e est\xe1vel. \xc9 completamente gratuito para usar. <a>Saiba mais</a>",
        email_template_title: "Modelo de e-mail",
        template_description: "O e-mail integrado usa modelos padr\xe3o para entrega perfeita de e-mails de verifica\xe7\xe3o. Nenhuma configura\xe7\xe3o \xe9 necess\xe1ria e voc\xea pode personalizar informa\xe7\xf5es b\xe1sicas da marca.",
        template_description_link_text: "Ver modelos",
        description_action_text: "Ver modelos",
        from_email_field: "De e-mail",
        sender_name_field: "Nome do remetente",
        sender_name_tip: 'Personalize o nome do remetente para e-mails. Se deixado em branco, "Verification" ser\xe1 usado como nome padr\xe3o.',
        sender_name_placeholder: "Seu nome do remetente",
        company_information_field: "Informa\xe7\xe3o da empresa",
        company_information_description: "Exiba o nome da sua empresa, endere\xe7o ou c\xf3digo postal no rodap\xe9 dos e-mails para aumentar a autenticidade.",
        company_information_placeholder: "Informa\xe7\xe3o b\xe1sica da empresa",
        app_logo_field: "Logotipo do aplicativo",
        app_logo_tip: "Exiba o logotipo da sua marca no topo dos e-mails. Utilize a mesma imagem para o modo claro e escuro.",
        urls_not_allowed: "Os URLs n\xe3o s\xe3o permitidos",
        test_notes: 'O Logto utiliza o modelo "Gen\xe9rico" para os testes.'
    }
};
var $b4365ee8e53812ef$export$2e2bcd8739ae039 = Object.freeze($b4365ee8e53812ef$var$connector_details);


const $5334937af0a93153$var$connectors = {
    page_title: "Conectores",
    title: "Conectores",
    subtitle: "Configure conectores para habilitar a experi\xeancia de login social e sem senha",
    create: "Adicionar conector social",
    config_sie_notice: "Voc\xea configurou conectores. Certifique-se de configur\xe1-lo em <a>{{link}}</a>.",
    config_sie_link_text: "experi\xeancia de login",
    tab_email_sms: "Conectores de Email e SMS",
    tab_social: "Conectores sociais",
    connector_name: "Nome do conector",
    demo_tip: "O n\xfamero m\xe1ximo de mensagens permitido para este conector de demonstra\xe7\xe3o \xe9 limitado a 100 e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    social_demo_tip: "O conector de demonstra\xe7\xe3o \xe9 projetado exclusivamente para fins de demonstra\xe7\xe3o e n\xe3o \xe9 recomendado para implanta\xe7\xe3o em um ambiente de produ\xe7\xe3o.",
    connector_type: "Tipo",
    connector_status: "Experi\xeancia de login",
    connector_status_in_use: "Em uso",
    connector_status_not_in_use: "Fora de uso",
    not_in_use_tip: {
        content: "N\xe3o em uso significa que sua experi\xeancia de login n\xe3o usou esse m\xe9todo de login. <a>{{link}}</a> para adicionar este m\xe9todo de login.",
        go_to_sie: "Ir para experi\xeancia de login"
    },
    placeholder_title: "Conector social",
    placeholder_description: "O Logto forneceu muitos conectores de login social amplamente usados, enquanto isso, voc\xea pode criar o seu pr\xf3prio com protocolos padr\xe3o.",
    save_and_done: "Guardar",
    type: {
        email: "Email",
        sms: "SMS",
        social: "Social"
    },
    setup_title: {
        email: "Configurar o conector de email",
        sms: "Configurar o conector de SMS",
        social: "Adicionar conector social"
    },
    guide: {
        subtitle: "Um guia passo a passo para configurar o conector",
        general_setting: "Configura\xe7\xf5es gerais",
        parameter_configuration: "Configura\xe7\xe3o de par\xe2metros",
        test_connection: "Teste de conex\xe3o",
        name: "Nome do bot\xe3o de login social",
        name_placeholder: "Insira o nome do bot\xe3o de login social",
        name_tip: 'O nome do bot\xe3o do conector ser\xe1 exibido como "Continuar com {{name}}." Esteja atento ao comprimento da nomenclatura caso ela fique muito longa.',
        logo: "URL do logo para o bot\xe3o de login social",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "A imagem do logo ser\xe1 exibida no conector. Obtenha um link de imagem publicamente acess\xedvel e insira o link aqui.",
        logo_dark: "URL do logo para o bot\xe3o de login social (modo escuro)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Defina o logo do seu conector para o modo escuro depois de ativ\xe1-lo na Experi\xeancia de login no Console do administrador.",
        logo_dark_collapse: "Fechar",
        logo_dark_show: "Exibir configura\xe7\xf5es de logo para o modo escuro",
        target: "Nome do provedor de identidade",
        target_placeholder: "Insira o nome do provedor de identidade do conector",
        target_tip: 'O valor do "nome do IdP" pode ser uma string de identificador exclusivo para distinguir suas identidades sociais.',
        target_tip_standard: 'O valor do "nome do IdP" pode ser uma string de identificador exclusivo para distinguir suas identidades sociais. Esta configura\xe7\xe3o n\xe3o pode ser alterada depois que o conector for criado.',
        target_tooltip: '"Target" nos conectores sociais do Logto refere-se \xe0 "origem" de suas identidades sociais. No design do Logto, n\xe3o aceitamos o mesmo "alvo" de uma plataforma espec\xedfica para evitar conflitos. Voc\xea deve ter muito cuidado antes de adicionar um conector, pois N\xc3O PODE alterar seu valor depois de cri\xe1-lo. <a>Saiba mais</a>',
        target_conflict: "O nome do IdP inserido corresponde ao <span>nome</span> existente. Usar o mesmo nome de idp pode causar um comportamento de login inesperado em que os usu\xe1rios podem acessar a mesma conta por meio de dois conectores diferentes.",
        target_conflict_line2: 'Se voc\xea deseja substituir o conector atual pelo mesmo provedor de identidade e permitir que os usu\xe1rios anteriores fa\xe7am login sem se registrar novamente, exclua o conector <span>nome</span> e crie um novo com o mesmo "nome do IdP".',
        target_conflict_line3: 'Se voc\xea deseja se conectar a um provedor de identidade diferente, modifique o "nome do IdP" e prossiga.',
        config: "Insira o seu JSON de configura\xe7\xe3o",
        sync_profile: "Sincronizar informa\xe7\xf5es do perfil",
        sync_profile_only_at_sign_up: "Sincronizar apenas no registro",
        sync_profile_each_sign_in: "Sempre sincronizar em cada login",
        sync_profile_tip: "Sincronize o perfil b\xe1sico do provedor social, como os nomes dos usu\xe1rios e seus avatares.",
        callback_uri: "URI de retorno",
        callback_uri_description: "Tamb\xe9m chamado de URI de redirecionamento, \xe9 a URI no Logto para onde os usu\xe1rios ser\xe3o enviados ap\xf3s a autoriza\xe7\xe3o social, copie e cole na p\xe1gina de configura\xe7\xe3o do provedor social."
    },
    platform: {
        universal: "Universal",
        web: "Web",
        native: "Nativo"
    },
    add_multi_platform: "suporta v\xe1rias plataformas, selecione uma plataforma para continuar",
    drawer_title: "Guia do conector",
    drawer_subtitle: "Siga as instru\xe7\xf5es para integrar o conector",
    unknown: "Conector desconhecido",
    standard_connectors: "Conectores padr\xe3o"
};
var $5334937af0a93153$export$2e2bcd8739ae039 = Object.freeze($5334937af0a93153$var$connectors);


const $23a6d5de37913b34$var$contact = {
    title: "Obter ajuda",
    description: "Para solicita\xe7\xf5es de ajuda ou feedback do produto, entre em contato conosco atrav\xe9s dos seguintes m\xe9todos.",
    discord: {
        title: "Participe da comunidade Discord",
        description: "Conecte-se com outros desenvolvedores para encontrar solu\xe7\xf5es",
        button: "Entrar"
    },
    github: {
        title: "Comunique-se no GitHub",
        description: "Crie uma issue e envie no GitHub",
        button: "Abrir"
    },
    email: {
        title: "Contato com suporte via e-mail",
        description: "Envie-nos um e-mail para obter mais informa\xe7\xf5es e ajuda",
        button: "Enviar"
    },
    reserve: {
        title: "Agende seu hor\xe1rio com a equipe Logto",
        description: "Agende uma sess\xe3o para um chat ao vivo",
        button: "Agendar"
    }
};
var $23a6d5de37913b34$export$2e2bcd8739ae039 = Object.freeze($23a6d5de37913b34$var$contact);


const $c3fd889ba0c55bad$var$dashboard = {
    page_title: "Painel",
    title: "Painel",
    description: "Obtenha uma vis\xe3o geral sobre o desempenho da sua aplica\xe7\xe3o",
    total_users: "Utilizadores totais",
    total_users_tip: "N\xba de Utilizadores registados",
    new_users_today: "Novos utilizadores hoje",
    new_users_today_tip: "O n\xfamero de novos utilizadores registados nas suas aplica\xe7\xf5es hoje",
    new_users_7_days: "Novos utilizadores nos \xfaltimos 7 dias",
    new_users_7_days_tip: "O n\xfamero de novos utilizadores registados nas suas aplica\xe7\xf5es nos \xfaltimos sete dias",
    daily_active_users: "Utilizadores ativos diariamente",
    daily_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es hoje",
    weekly_active_users: "Utilizadores ativos semanalmente",
    weekly_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es nos \xfaltimos sete dias",
    monthly_active_users: "Utilizadores ativos mensais",
    monthly_active_users_tip: "O n\xfamero de utilizadores \xfanicos que efetuaram login nas suas aplica\xe7\xf5es nos \xfaltimos 30 dias"
};
var $c3fd889ba0c55bad$export$2e2bcd8739ae039 = Object.freeze($c3fd889ba0c55bad$var$dashboard);


const $fb2ec5a319517a89$var$domain = {
    status: {
        connecting: "A conectar",
        in_used: "Em uso",
        failed_to_connect: "Falha ao conectar"
    },
    update_endpoint_notice: "N\xe3o se esque\xe7a de atualizar o dom\xednio para o URI de retorno do conector social e o endpoint de Logto na sua aplica\xe7\xe3o se quiser usar um dom\xednio personalizado para as funcionalidades. <a>{{link}}</a>",
    error_hint: "Certifique-se de atualizar os seus registos DNS. Continuaremos a verificar a cada {{value}} segundos.",
    custom: {
        custom_domain: "Dom\xednio personalizado",
        custom_domain_description: "Melhore a sua marca utilizando um dom\xednio personalizado. Este dom\xednio ser\xe1 utilizado na sua experi\xeancia de in\xedcio de sess\xe3o.",
        custom_domain_field: "Dom\xednio personalizado",
        custom_domain_placeholder: "seu.dominio.com",
        add_domain: "Adicionar dom\xednio",
        invalid_domain_format: "Formato de subdom\xednio inv\xe1lido. Introduza um subdom\xednio com pelo menos tr\xeas partes.",
        verify_domain: "Verificar dom\xednio",
        enable_ssl: "Ativar SSL",
        checking_dns_tip: "Ap\xf3s a configura\xe7\xe3o dos registos DNS, o processo ser\xe1 executado automaticamente e pode demorar at\xe9 24 horas. Pode sair desta interface enquanto o processo estiver em execu\xe7\xe3o.",
        enable_ssl_tip: "Ativar SSL ser\xe1 executado automaticamente e pode demorar at\xe9 24 horas. Pode sair desta interface enquanto o processo estiver em execu\xe7\xe3o.",
        generating_dns_records: "Gerando os registos DNS...",
        add_dns_records: "Adicione estes registos DNS ao seu provedor de DNS.",
        dns_table: {
            type_field: "Tipo",
            name_field: "Nome",
            value_field: "Valor"
        },
        deletion: {
            delete_domain: "Eliminar dom\xednio",
            reminder: "Eliminar dom\xednio personalizado",
            description: "Tem a certeza de que pretende eliminar este dom\xednio personalizado?",
            in_used_description: 'Tem a certeza de que pretende eliminar este dom\xednio personalizado "<span>{{domain}}</span>"?',
            in_used_tip: 'Se j\xe1 configurou este dom\xednio personalizado no seu fornecedor de conector social ou extremidade de aplica\xe7\xe3o antes, ter\xe1 de modificar a URI para o dom\xednio padr\xe3o do Logto "<span>{{domain}}</span>" primeiro. Isto \xe9 necess\xe1rio para que o bot\xe3o de in\xedcio de sess\xe3o social funcione corretamente.',
            deleted: "Dom\xednio personalizado eliminado com sucesso!"
        }
    },
    default: {
        default_domain: "Dom\xednio predefinido",
        default_domain_description: "Logto oferece um dom\xednio predefinido pr\xe9-configurado, pronto para usar sem qualquer configura\xe7\xe3o adicional. Este dom\xednio predefinido serve como op\xe7\xe3o de backup mesmo que tenha ativado um dom\xednio personalizado.",
        default_domain_field: "Dom\xednio predefinido da Logto"
    },
    custom_endpoint_note: 'Pode personalizar o nome de dom\xednio desses endpoints conforme necess\xe1rio. Escolha "{{custom}}" ou "{{default}}".',
    custom_social_callback_url_note: 'Pode personalizar o nome de dom\xednio deste URI para corresponder ao endpoint da sua aplica\xe7\xe3o. Escolha "{{custom}}" ou "{{default}}".'
};
var $fb2ec5a319517a89$export$2e2bcd8739ae039 = Object.freeze($fb2ec5a319517a89$var$domain);


const $92a5e3c17e3231cb$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $92a5e3c17e3231cb$export$2e2bcd8739ae039 = Object.freeze($92a5e3c17e3231cb$var$enterprise_sso_details);


const $d37a50eb904ed3e4$var$enterprise_sso = {
    page_title: "SSO Empresarial",
    title: "SSO Empresarial",
    subtitle: "Conecte o fornecedor de identidade empresarial e ative o Logon \xdanico iniciado pelo SP.",
    create: "Adicionar conector empresarial",
    col_connector_name: "Nome do conector",
    col_type: "Tipo",
    col_email_domain: "Dom\xednio do email",
    placeholder_title: "Conector empresarial",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Adicionar conector empresarial",
        text_divider: "Ou voc\xea pode personalizar seu conector por um protocolo padr\xe3o.",
        connector_name_field_title: "Nome do conector",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Criar conector"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $d37a50eb904ed3e4$export$2e2bcd8739ae039 = Object.freeze($d37a50eb904ed3e4$var$enterprise_sso);


const $00ec4053a5188396$var$errors = {
    something_went_wrong: "Ops! Algo deu errado.",
    page_not_found: "P\xe1gina n\xe3o encontrada",
    unknown_server_error: "Ocorreu um erro de servidor desconhecido",
    empty: "Sem dados",
    missing_total_number: "N\xe3o foi poss\xedvel encontrar `Total-Number` nos cabe\xe7alhos da resposta",
    invalid_uri_format: "Formato de URI inv\xe1lido",
    invalid_origin_format: "Formato de origem de URI inv\xe1lido",
    invalid_json_format: "Formato JSON inv\xe1lido",
    invalid_error_message_format: "O formato da mensagem de erro \xe9 inv\xe1lido.",
    required_field_missing: "Por favor, introduza {{field}}",
    required_field_missing_plural: "Deve inserir pelo menos um {{field}}",
    more_details: "Mais detalhes",
    username_pattern_error: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores e n\xe3o deve come\xe7ar com um n\xfamero.",
    email_pattern_error: "O endere\xe7o de e-mail \xe9 inv\xe1lido.",
    phone_pattern_error: "O n\xfamero de telefone \xe9 inv\xe1lido.",
    insecure_contexts: "Contextos inseguros (n\xe3o HTTPS) n\xe3o s\xe3o compat\xedveis.",
    unexpected_error: "Ocorreu um erro inesperado",
    not_found: "404 not found",
    create_internal_role_violation: 'Est\xe1 a criar uma nova fun\xe7\xe3o interna que \xe9 proibida pelo Logto. Tente outro nome que n\xe3o comece com "#internal:".',
    should_be_an_integer: "Deve ser um inteiro.",
    number_should_be_between_inclusive: "Ent\xe3o o n\xfamero deve estar entre {{min}} e {{max}} (ambos inclusivos)."
};
var $00ec4053a5188396$export$2e2bcd8739ae039 = Object.freeze($00ec4053a5188396$var$errors);


const $043c37565054d343$var$general = {
    placeholder: "Espa\xe7o reservado",
    submit: "Submeter",
    skip: "Saltar",
    next: "Seguinte",
    back: "Voltar",
    retry: "Tentar novamente",
    done: "Conclu\xeddo",
    search: "Pesquisar",
    search_placeholder: "Pesquisar",
    clear_result: "Limpar resultados",
    save: "Guardar",
    save_changes: "Guardar altera\xe7\xf5es",
    saved: "Guardado",
    discard: "Descartar",
    loading: "A carregar...",
    redirecting: "A redirecionar...",
    add: "Adicionar",
    added: "Adicionado",
    cancel: "Cancelar",
    confirm: "Confirmar",
    check_out: "Finalizar",
    create: "Criar",
    set_up: "Configurar",
    customize: "Personalizar",
    enable: "Ativar",
    reminder: "Lembrete",
    delete: "Eliminar",
    more_options: "MAIS OP\xc7\xd5ES",
    close: "Fechar",
    copy: "Copiar",
    copying: "A copiar",
    copied: "Copiado",
    required: "Obrigat\xf3rio",
    add_another: "Adicionar outro",
    create_another: "Criar outro",
    deletion_confirmation: "Tem a certeza que deseja eliminar isso {{title}}?",
    settings_nav: "Defini\xe7\xf5es",
    unsaved_changes_warning: "Fez algumas altera\xe7\xf5es. Tem a certeza que deseja sair desta p\xe1gina?",
    leave_page: "Sair da p\xe1gina",
    stay_on_page: "Permanecer na p\xe1gina",
    type_to_search: "Digite para pesquisar",
    got_it: "Entendi",
    continue: "Continuar",
    page_info: "{{min, number}}-{{max, number}} de {{total, number}}",
    learn_more: "Saber mais",
    tab_errors: "{{count, number}} erros",
    skip_for_now: "Saltar por agora",
    remove: "Remover",
    visit: "Visitar",
    join: "Participar",
    try_now: "Experimente agora",
    multiple_form_field: "(M\xfaltiplo)",
    demo: "Demonstra\xe7\xe3o",
    unnamed: "Sem nome",
    view: "Ver",
    hide: "Esconder",
    unknown_error: "Erro desconhecido, por favor tente novamente mais tarde.",
    select: "Selecionar",
    contact_us_action: "Contacte-nos",
    description: "Descri\xe7\xe3o",
    name: "Nome",
    add_field: "Adicionar {{field}}",
    create_field: "Criar {{field}}",
    edit_field: "Editar {{field}}",
    delete_field: "Eliminar {{field}}",
    coming_soon: "Em breve",
    beta_notice: "\uD83C\uDF89  {{feature}} est\xe1 atualmente em beta. Bem-vindo para explorar e <ContactLink>partilhar o seu feedback</ContactLink>."
};
var $043c37565054d343$export$2e2bcd8739ae039 = Object.freeze($043c37565054d343$var$general);


const $905e3736d98910de$var$get_started = {
    page_title: "Come\xe7ar",
    title: "Algo para explorar para o ajudar a ter sucesso",
    subtitle: "Algumas coisas que voc\xea pode fazer para obter rapidamente valor do Logto",
    develop: {
        title: "Develop: Dedique 5 minutos para integrar o seu aplicativo"
    },
    customize: {
        title: "Customize: Ofere\xe7a uma \xf3tima experi\xeancia de login",
        preview: {
            title: "Verifique a pr\xe9-visualiza\xe7\xe3o ao vivo da experi\xeancia de login que voc\xea acabou de personalizar",
            subtitle: "Experimente agora a experi\xeancia de login do Logto para ver como funciona"
        },
        connector: {
            title: "Adicione mais conectores para suportar mais m\xe9todos de login social",
            subtitle: "Experimente o login sem senha e ofere\xe7a uma experi\xeancia segura e sem atritos para seus clientes"
        },
        continue_customizing: "Continue personalizando",
        try_now: "Experimente agora",
        add_more: "Adicione mais"
    },
    secure: {
        title: "Secure: Proteja seus recursos"
    },
    manage: {
        title: "Manage: Defina o controle de acesso para seu produto e usu\xe1rios",
        rbac: {
            title: "Adicione controle de acesso baseado em fun\xe7\xe3o para proteger seus recursos",
            subtitle: "Controle seu recurso por meio de autoriza\xe7\xe3o de fun\xe7\xe3o escal\xe1vel para diversos casos de uso."
        },
        create_roles: "Criar fun\xe7\xf5es"
    },
    view_all: "Ver tudo →"
};
var $905e3736d98910de$export$2e2bcd8739ae039 = Object.freeze($905e3736d98910de$var$get_started);


const $c4ef79591767cf19$var$guide = {
    start_building: "Come\xe7ar a construir",
    get_started: "Come\xe7ar",
    categories: {
        featured: "Popular e para ti",
        Traditional: "Aplica\xe7\xe3o web tradicional",
        SPA: "Aplica\xe7\xe3o de p\xe1gina \xfanica",
        Native: "Nativo",
        MachineToMachine: "M\xe1quina-a-m\xe1quina"
    },
    filter: {
        title: "Filtrar framework",
        placeholder: "Procurar framework"
    },
    checkout_tutorial: "Ver tutorial de {{name}}",
    do_not_need_tutorial: "Se n\xe3o precisares de um tutorial, podes continuar sem um guia de framework",
    finish_and_done: "Terminar e concluir",
    cannot_find_guide: "N\xe3o encontras o teu guia?",
    describe_guide_looking_for: "Descreve o guia que procuras",
    request_guide_successfully: "O teu pedido foi enviado com sucesso. Obrigado!",
    app: {
        select_framework_or_tutorial: "Seleciona um framework ou tutorial",
        guide_modal_title: "Come\xe7ar com SDK e guias",
        modal_subtitle: "Inicia o processo de desenvolvimento da tua aplica\xe7\xe3o com o nosso SDK pr\xe9-constru\xeddo e tutoriais.",
        select_a_framework: "Seleciona um framework",
        continue_without_framework: "Criar aplica\xe7\xe3o sem framework",
        describe_guide_looking_for_placeholder: "Por exemplo, quero integrar o Logto na minha aplica\xe7\xe3o Angular."
    },
    api: {
        modal_title: "Come\xe7ar com tutoriais",
        modal_subtitle: "Inicia o processo de desenvolvimento da tua aplica\xe7\xe3o com os nossos tutoriais pr\xe9-constru\xeddos.",
        select_a_tutorial: "Seleciona um tutorial",
        continue_without_tutorial: "Continuar sem tutorial",
        describe_guide_looking_for_placeholder: "Por exemplo, quero proteger a minha API usando Deno."
    }
};
var $c4ef79591767cf19$export$2e2bcd8739ae039 = Object.freeze($c4ef79591767cf19$var$guide);


const $441f492c696fb9ac$var$log_details = {
    page_title: "Detalhes do registo de auditoria",
    back_to_logs: "Voltar aos registos de auditoria",
    back_to: "Voltar para {{name}}",
    success: "Sucesso",
    failed: "Falha",
    event_key: "Chave do Evento",
    application: "Aplica\xe7\xe3o",
    ip_address: "Endere\xe7o IP",
    user: "Utilizador",
    log_id: "ID do registo",
    time: "Hora",
    user_agent: "User agent",
    tab_details: "Detalhes",
    raw_data: "Dados n\xe3o tratados"
};
var $441f492c696fb9ac$export$2e2bcd8739ae039 = Object.freeze($441f492c696fb9ac$var$log_details);


const $902ddf7fd3af446e$var$logs = {
    page_title: "Registos de auditoria",
    title: "Registos de auditoria",
    subtitle: "Visualize logs de autentica\xe7\xe3o feitos por administradores e utilizadores",
    event: "Evento",
    user: "Utilizador",
    application: "Aplica\xe7\xe3o",
    time: "Hora",
    filter_by: "Filtrar pors"
};
var $902ddf7fd3af446e$export$2e2bcd8739ae039 = Object.freeze($902ddf7fd3af446e$var$logs);


const $f1b5261c11bf693d$var$menu = {
    profile: "Perfil",
    language: "Linguagem",
    appearance: {
        label: "Apar\xeancia",
        light: "Claro",
        dark: "Escuro",
        system: "Sincronizar com o sistemam"
    },
    sign_out: "Terminar sess\xe3o"
};
var $f1b5261c11bf693d$export$2e2bcd8739ae039 = Object.freeze($f1b5261c11bf693d$var$menu);


const $f337ecfd376a99db$var$mfa = {
    title: "Autentica\xe7\xe3o de v\xe1rios fatores",
    description: "Adicione autentica\xe7\xe3o de v\xe1rios fatores para aumentar a seguran\xe7a da sua experi\xeancia de login.",
    factors: "Fatores",
    multi_factors: "V\xe1rios fatores",
    multi_factors_description: "Os usu\xe1rios precisam verificar um dos fatores habilitados para a verifica\xe7\xe3o em duas etapas.",
    totp: "OTP do aplicativo autenticador",
    otp_description: "Vincule o Google Authenticator, etc., para verificar senhas \xfanicas.",
    webauthn: "WebAuthn (Senha)",
    webauthn_description: "Verifique por meio de um m\xe9todo suportado pelo navegador: biometria, digitaliza\xe7\xe3o de telefone ou chave de seguran\xe7a, etc.",
    webauthn_native_tip: "O WebAuthn n\xe3o \xe9 suportado para aplicativos nativos.",
    webauthn_domain_tip: "O WebAuthn vincula chaves p\xfablicas ao dom\xednio espec\xedfico. Modificar o dom\xednio do seu servi\xe7o bloquear\xe1 usu\xe1rios de autenticar via senhas existentes.",
    backup_code: "C\xf3digo de backup",
    backup_code_description: "Gere 10 c\xf3digos de backup \xfanicos ap\xf3s os usu\xe1rios configurarem qualquer m\xe9todo MFA.",
    backup_code_setup_hint: "Quando os usu\xe1rios n\xe3o podem verificar os fatores MFA acima, use a op\xe7\xe3o de backup.",
    backup_code_error_hint: "Para usar um c\xf3digo de backup, voc\xea precisa de pelo menos mais um m\xe9todo MFA para autentica\xe7\xe3o bem-sucedida do usu\xe1rio.",
    policy: "Pol\xedtica",
    policy_description: "Defina a pol\xedtica MFA para fluxos de login e inscri\xe7\xe3o.",
    two_step_sign_in_policy: "Pol\xedtica de verifica\xe7\xe3o em duas etapas no login",
    user_controlled: "Os usu\xe1rios podem ativar ou desativar o MFA por conta pr\xf3pria",
    user_controlled_tip: "Os usu\xe1rios podem pular a configura\xe7\xe3o do MFA na primeira vez no login ou inscri\xe7\xe3o, ou ativar/desativar nas configura\xe7\xf5es da conta.",
    mandatory: "Os usu\xe1rios sempre precisam usar o MFA no login",
    mandatory_tip: "Os usu\xe1rios devem configurar o MFA na primeira vez no login ou inscri\xe7\xe3o e us\xe1-lo em todos os logins futuros."
};
var $f337ecfd376a99db$export$2e2bcd8739ae039 = Object.freeze($f337ecfd376a99db$var$mfa);


const $4ec455c86a37f0fa$var$organization_details = {
    page_title: "Detalhes da organiza\xe7\xe3o",
    delete_confirmation: "Uma vez eliminada, todos os membros perder\xe3o a sua ades\xe3o e fun\xe7\xf5es nesta organiza\xe7\xe3o. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
    organization_id: "ID da organiza\xe7\xe3o",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "O nome da organiza\xe7\xe3o, n\xe3o \xe9 necess\xe1rio ser \xfanico.",
    description_placeholder: "Uma descri\xe7\xe3o da organiza\xe7\xe3o.",
    member: "Membro",
    member_other: "Membros",
    add_members_to_organization: "Adicionar membros \xe0 organiza\xe7\xe3o {{name}}",
    add_members_to_organization_description: "Encontre utilizadores adequados pesquisando por nome, email, telefone ou ID de utilizador. Os membros existentes n\xe3o s\xe3o mostrados nos resultados da pesquisa.",
    add_with_organization_role: "Adicionar com fun\xe7\xe3o(\xf5es) de organiza\xe7\xe3o",
    user: "Utilizador",
    authorize_to_roles: "Autorizar {{name}} a aceder \xe0s seguintes fun\xe7\xf5es:",
    edit_organization_roles: "Editar fun\xe7\xf5es da organiza\xe7\xe3o",
    edit_organization_roles_of_user: "Editar fun\xe7\xf5es da organiza\xe7\xe3o de {{name}}",
    remove_user_from_organization: "Remover utilizador da organiza\xe7\xe3o",
    remove_user_from_organization_description: "Uma vez removido, o utilizador perder\xe1 a sua ades\xe3o e fun\xe7\xf5es nesta organiza\xe7\xe3o. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
    search_user_placeholder: "Pesquisar por nome, email, telefone ou ID de utilizador",
    at_least_one_user: "Pelo menos um utilizador \xe9 necess\xe1rio."
};
var $4ec455c86a37f0fa$export$2e2bcd8739ae039 = Object.freeze($4ec455c86a37f0fa$var$organization_details);


const $ba04611337549547$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Organiza\xe7\xf5es",
    title: "Organiza\xe7\xf5es",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "ID da organiza\xe7\xe3o",
    members: "Membros",
    create_organization: "Criar organiza\xe7\xe3o",
    setup_organization: "Configurar a sua organiza\xe7\xe3o",
    organization_list_placeholder_title: "Organiza\xe7\xe3o",
    organization_list_placeholder_text: "A organiza\xe7\xe3o \xe9 normalmente usada em aplica\xe7\xf5es multi-inquilinos de SaaS ou semelhantes a SaaS. A funcionalidade Organiza\xe7\xf5es permite que os seus clientes B2B gerenciem melhor os seus parceiros e clientes, e personalizem as formas como os utilizadores finais acedem \xe0s suas aplica\xe7\xf5es.",
    organization_name_placeholder: "A minha organiza\xe7\xe3o",
    organization_description_placeholder: "Uma breve descri\xe7\xe3o da organiza\xe7\xe3o",
    organization_permission: "Permiss\xe3o da organiza\xe7\xe3o",
    organization_permission_other: "Permiss\xf5es da organiza\xe7\xe3o",
    organization_permission_description: "A permiss\xe3o da organiza\xe7\xe3o refere-se \xe0 autoriza\xe7\xe3o para aceder a um recurso no contexto da organiza\xe7\xe3o. Uma permiss\xe3o da organiza\xe7\xe3o deve ser representada como uma string significativa, servindo tamb\xe9m como nome e identificador \xfanico.",
    organization_permission_delete_confirm: "Se esta permiss\xe3o for eliminada, todas as fun\xe7\xf5es da organiza\xe7\xe3o que incluam esta permiss\xe3o perder\xe3o esta permiss\xe3o, e os utilizadores que tinham esta permiss\xe3o perder\xe3o o acesso concedido por ela.",
    create_permission_placeholder: "Ler hist\xf3rico de compromissos",
    permission: "Permiss\xe3o",
    permission_other: "Permiss\xf5es",
    organization_role: "Papel da organiza\xe7\xe3o",
    organization_role_other: "Fun\xe7\xf5es da organiza\xe7\xe3o",
    organization_role_description: "O papel da organiza\xe7\xe3o \xe9 um agrupamento de permiss\xf5es que podem ser atribu\xeddas a utilizadores. As permiss\xf5es devem provir das permiss\xf5es de organiza\xe7\xe3o predefinidas.",
    organization_role_delete_confirm: "Faz\xea-lo remover\xe1 as permiss\xf5es associadas a este papel dos usu\xe1rios afetados e excluir\xe1 as rela\xe7\xf5es entre os pap\xe9is da organiza\xe7\xe3o, os membros da organiza\xe7\xe3o e as permiss\xf5es da organiza\xe7\xe3o.",
    role: "Fun\xe7\xe3o",
    create_role_placeholder: "Usu\xe1rios com permiss\xf5es somente leitura",
    search_placeholder: "Pesquisar por nome ou ID da organiza\xe7\xe3o",
    search_permission_placeholder: "Digite para pesquisar e selecionar permiss\xf5es",
    search_role_placeholder: "Digite para pesquisar e selecionar fun\xe7\xf5es",
    empty_placeholder: "\uD83E\uDD14 Voc\xea ainda n\xe3o configurou nenhum {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Comece com guias",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Interaja com a ilustra\xe7\xe3o para ver como tudo est\xe1 conectado",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Passo 1: Definir as permiss\xf5es da organiza\xe7\xe3o",
        step_2: "Passo 2: Definir as fun\xe7\xf5es da organiza\xe7\xe3o",
        step_3: "Passo 3: Crie a sua primeira organiza\xe7\xe3o",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $ba04611337549547$export$2e2bcd8739ae039 = Object.freeze($ba04611337549547$var$organizations);


const $071b115d1dc26817$var$permissions = {
    search_placeholder: "Pesquisar por nome de API ou permiss\xe3o",
    search_placeholder_without_api: "Pesquisar por nome de permiss\xe3o",
    name_column: "Permiss\xe3o",
    description_column: "Descri\xe7\xe3o",
    api_column: "API",
    placeholder_title: "Permiss\xe3o",
    placeholder_description: "Permiss\xe3o refere-se \xe0 autoriza\xe7\xe3o para acessar um recurso (que chamamos de recurso da API)."
};
var $071b115d1dc26817$export$2e2bcd8739ae039 = Object.freeze($071b115d1dc26817$var$permissions);


const $88f3449d8c84ff58$var$profile = {
    page_title: "Defini\xe7\xf5es da conta",
    title: "Defini\xe7\xf5es da conta",
    description: "Altere as suas defini\xe7\xf5es de conta e gerencie suas informa\xe7\xf5es pessoais aqui para garantir a seguran\xe7a da sua conta.",
    settings: {
        title: "DEFINI\xc7\xd5ES DO PERFIL",
        profile_information: "Informa\xe7\xe3o do perfil",
        avatar: "Avatar",
        name: "Nome",
        username: "Nome de usu\xe1rio"
    },
    link_account: {
        title: "LIGAR CONTA",
        email_sign_in: "Registo de email",
        email: "Email",
        social_sign_in: "Registo social",
        link_email: "Ligar email",
        link_email_subtitle: "Ligue o seu e-mail para fazer login ou ajudar na recupera\xe7\xe3o da sua conta.",
        email_required: "Email \xe9 obrigat\xf3rio",
        invalid_email: "Endere\xe7o de email inv\xe1lido",
        identical_email_address: "O endere\xe7o de email inserido \xe9 id\xeantico ao atual",
        anonymous: "An\xf3nimo"
    },
    password: {
        title: "PALAVRA-PASSE E SEGURAN\xc7A",
        password: "Palavra-passe",
        password_setting: "Configura\xe7\xe3o da palavra-passe",
        new_password: "Nova palavra-passe",
        confirm_password: "Confirmar palavra-passe",
        enter_password: "Introduza a palavra-passe atual",
        enter_password_subtitle: "Verifique se \xe9 realmente voc\xea para proteger a seguran\xe7a da sua conta. Por favor, introduza a sua palavra-passe atual antes de a alterar.",
        set_password: "Definir palavra-passe",
        verify_via_password: "Verificar atrav\xe9s da palavra-passe",
        show_password: "Mostrar palavra-passe",
        required: "Palavra-passe \xe9 obrigat\xf3ria",
        do_not_match: "As palavras-passe n\xe3o correspondem. Por favor, tente novamente."
    },
    code: {
        enter_verification_code: "Introduzir c\xf3digo de verifica\xe7\xe3o",
        enter_verification_code_subtitle: "O c\xf3digo de verifica\xe7\xe3o foi enviado para <strong>{{target}}</strong>",
        verify_via_code: "Verificar atrav\xe9s do c\xf3digo de verifica\xe7\xe3o",
        resend: "Reenviar c\xf3digo de verifica\xe7\xe3o",
        resend_countdown: "Reenviar em {{countdown}} segundos"
    },
    delete_account: {
        title: "APAGAR CONTA",
        label: "Apagar conta",
        description: "Apagar a sua conta ir\xe1 remover todas as suas informa\xe7\xf5es pessoais, dados de usu\xe1rio e configura\xe7\xf5es. Esta a\xe7\xe3o n\xe3o pode ser desfeita.",
        button: "Apagar conta",
        dialog_paragraph_1: "Lamentamos saber que deseja apagar sua conta. A exclus\xe3o da sua conta ir\xe1 remover permanentemente todos os dados, incluindo informa\xe7\xf5es de usu\xe1rio, logs e configura\xe7\xf5es, e esta a\xe7\xe3o n\xe3o pode ser desfeita. Portanto, por favor, fa\xe7a backup de qualquer dado importante antes de prosseguir.",
        dialog_paragraph_2: "Para prosseguir com o processo de exclus\xe3o de conta, envie um e-mail para nossa equipe de suporte em <a>mail</a> com o assunto “Solicita\xe7\xe3o de exclus\xe3o de conta”. Vamos ajud\xe1-lo e garantir que todos os seus dados sejam devidamente exclu\xeddos do nosso sistema.",
        dialog_paragraph_3: "Obrigado por escolher o Logto Cloud. Se tiver alguma d\xfavida ou preocupa\xe7\xe3o, n\xe3o hesite em entrar em contato connosco."
    },
    set: "Definir",
    change: "Mudar",
    link: "Ligar",
    unlink: "Desligar",
    not_set: "N\xe3o definido",
    change_avatar: "Mudar avatar",
    change_name: "Mudar nome",
    change_username: "Mudar nome de usu\xe1rio",
    set_name: "Definir nome",
    email_changed: "Email alterado.",
    password_changed: "Palavra-passe alterada.",
    updated: "{{target}} atualizado.",
    linked: "{{target}} ligado.",
    unlinked: "{{target}} desligado.",
    email_exists_reminder: "Este email {{email}} est\xe1 associado a uma conta existente. Conecte outro email aqui.",
    unlink_confirm_text: "Sim, desligar",
    unlink_reminder: "Os usu\xe1rios n\xe3o poder\xe3o entrar com a conta <span></span> se voc\xea a desligar. Tem a certeza de que deseja prosseguir?"
};
var $88f3449d8c84ff58$export$2e2bcd8739ae039 = Object.freeze($88f3449d8c84ff58$var$profile);


const $de930e174461f4b5$var$role_details = {
    back_to_roles: "Voltar para Fun\xe7\xf5es",
    identifier: "Identificador",
    delete_description: "Ao faz\xea-lo, ser\xe3o removidas as permiss\xf5es associadas a esta fun\xe7\xe3o dos utilizadores afetados e eliminado o mapeamento entre fun\xe7\xf5es, utilizadores e permiss\xf5es.",
    role_deleted: "{{name}} foi eliminada com sucesso.",
    settings_tab: "Defini\xe7\xf5es",
    users_tab: "Utilizadores",
    m2m_apps_tab: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina",
    permissions_tab: "Permiss\xf5es",
    settings: "Defini\xe7\xf5es",
    settings_description: "As fun\xe7\xf5es s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas aos utilizadores. Elas tamb\xe9m proporcionam uma forma de agregar permiss\xf5es definidas para diferentes APIs, tornando mais eficiente adicionar, remover ou ajustar permiss\xf5es comparativamente \xe0 sua atribui\xe7\xe3o individual a utilizadores.",
    field_name: "Nome",
    field_description: "Descri\xe7\xe3o",
    type_m2m_role_tag: "Fun\xe7\xe3o de aplica\xe7\xe3o de m\xe1quina para m\xe1quina",
    type_user_role_tag: "Fun\xe7\xe3o de utilizador",
    permission: {
        assign_button: "Atribuir Permiss\xf5es",
        assign_title: "Atribuir permiss\xf5es",
        assign_subtitle: "Atribua permiss\xf5es a esta fun\xe7\xe3o. A fun\xe7\xe3o ir\xe1 obter as permiss\xf5es adicionadas e os utilizadores com esta fun\xe7\xe3o herdar\xe3o essas permiss\xf5es.",
        assign_form_field: "Atribuir permiss\xf5es",
        added_text_one: "{{count, number}} permiss\xe3o adicionada",
        added_text_other: "{{count, number}} permiss\xf5es adicionadas",
        api_permission_count_one: "{{count, number}} permiss\xe3o",
        api_permission_count_other: "{{count, number}} permiss\xf5es",
        confirm_assign: "Atribuir Permiss\xf5es",
        permission_assigned: "As permiss\xf5es selecionadas foram atribu\xeddas com sucesso a esta fun\xe7\xe3o",
        deletion_description: "Se esta permiss\xe3o for removida, o utilizador afetado com esta fun\xe7\xe3o perder\xe1 o acesso concedido por esta permiss\xe3o.",
        permission_deleted: 'A permiss\xe3o "{{name}}" foi removida com sucesso desta fun\xe7\xe3o',
        empty: "Nenhuma permiss\xe3o dispon\xedvel"
    },
    users: {
        assign_button: "Atribuir Utilizadores",
        name_column: "Utilizador",
        app_column: "Aplica\xe7\xe3o",
        latest_sign_in_column: "\xdaltima sess\xe3o iniciada",
        delete_description: "Permanecer\xe1 no seu conjunto de utilizadores, mas perder\xe1 a autoriza\xe7\xe3o para esta fun\xe7\xe3o.",
        deleted: "{{name}} foi removido com sucesso desta fun\xe7\xe3o",
        assign_title: "Atribuir utilizadores",
        assign_subtitle: "Atribua utilizadores a esta fun\xe7\xe3o. Encontre utilizadores apropriados pesquisando pelo nome, e-mail, telefone ou ID de utilizador.",
        assign_field: "Atribuir utilizadores",
        confirm_assign: "Atribuir utilizadores",
        assigned_toast_text: "Os utilizadores selecionados foram atribu\xeddos com sucesso a esta fun\xe7\xe3o",
        empty: "Nenhum utilizador dispon\xedvel"
    },
    applications: {
        assign_button: "Atribuir aplica\xe7\xf5es",
        name_column: "Aplica\xe7\xe3o",
        app_column: "Aplica\xe7\xf5es",
        description_column: "Descri\xe7\xe3o",
        delete_description: "Permanecer\xe1 no seu conjunto de aplica\xe7\xf5es, mas perder\xe1 a autoriza\xe7\xe3o para esta fun\xe7\xe3o.",
        deleted: "{{name}} foi removido com sucesso desta fun\xe7\xe3o",
        assign_title: "Atribuir aplica\xe7\xf5es",
        assign_subtitle: "Atribua aplica\xe7\xf5es a esta fun\xe7\xe3o. Encontre aplica\xe7\xf5es apropriadas pesquisando pelo nome, descri\xe7\xe3o ou ID da aplica\xe7\xe3o.",
        assign_field: "Atribuir aplica\xe7\xf5es",
        confirm_assign: "Atribuir aplica\xe7\xf5es",
        assigned_toast_text: "As aplica\xe7\xf5es selecionadas foram atribu\xeddas com sucesso a esta fun\xe7\xe3o",
        empty: "Nenhuma aplica\xe7\xe3o dispon\xedvel"
    }
};
var $de930e174461f4b5$export$2e2bcd8739ae039 = Object.freeze($de930e174461f4b5$var$role_details);


const $ce6b589be41833fd$var$roles = {
    page_title: "Pap\xe9is",
    title: "Pap\xe9is",
    subtitle: "Os pap\xe9is incluem permiss\xf5es que determinam o que um usu\xe1rio pode fazer. RBAC usa pap\xe9is para conceder acesso a recursos para a\xe7\xf5es espec\xedficas.",
    create: "Criar papel",
    role_name: "Nome do papel",
    role_type: "Tipo de papel",
    show_role_type_button_text: "Mostrar mais op\xe7\xf5es",
    hide_role_type_button_text: "Esconder mais op\xe7\xf5es",
    type_user: "Fun\xe7\xe3o de usu\xe1rio",
    type_machine_to_machine: "Fun\xe7\xe3o de aplica\xe7\xe3o m\xe1quina-a-m\xe1quina",
    role_description: "Descri\xe7\xe3o",
    role_name_placeholder: "Digite o nome do papel",
    role_description_placeholder: "Digite a descri\xe7\xe3o do papel",
    col_roles: "Pap\xe9is",
    col_type: "Tipo",
    col_description: "Descri\xe7\xe3o",
    col_assigned_entities: "Atribu\xeddo",
    user_counts: "{{count}} utilizadores",
    application_counts: "{{count}} aplica\xe7\xf5es",
    user_count: "{{count}} utilizador",
    application_count: "{{count}} aplica\xe7\xe3o",
    assign_permissions: "Atribuir permiss\xf5es",
    create_role_title: "Criar papel",
    create_role_description: "Crie e gerencie pap\xe9is para as suas aplica\xe7\xf5es. Os pap\xe9is cont\xeam cole\xe7\xf5es de permiss\xf5es e podem ser atribu\xeddos a utilizadores.",
    create_role_button: "Criar papel",
    role_created: "O papel {{name}} foi criado com sucesso.",
    search: "Pesquisar por nome do papel, descri\xe7\xe3o ou ID",
    placeholder_title: "Pap\xe9is",
    placeholder_description: "Os pap\xe9is s\xe3o um agrupamento de permiss\xf5es que podem ser atribu\xeddas a utilizadores. Certifique-se de adicionar permiss\xf5es antes de criar pap\xe9is."
};
var $ce6b589be41833fd$export$2e2bcd8739ae039 = Object.freeze($ce6b589be41833fd$var$roles);


const $8499bc6149351224$var$session_expired = {
    title: "Sess\xe3o expirada",
    subtitle: "A sua sess\xe3o pode ter expirado  foi desconectado. Clique no bot\xe3o abaixo para fazer login novamente.",
    button: "Entrar novamente"
};
var $8499bc6149351224$export$2e2bcd8739ae039 = Object.freeze($8499bc6149351224$var$session_expired);


const $ae0ada4448fd39b7$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $ae0ada4448fd39b7$export$2e2bcd8739ae039 = Object.freeze($ae0ada4448fd39b7$var$content);


const $cd314f5b2a46ae26$var$password_policy = {
    password_requirements: "Requisitos de password",
    minimum_length: "Comprimento m\xednimo",
    minimum_length_description: "O NIST sugere o uso de <a>pelo menos 8 caracteres</a> para produtos web.",
    minimum_length_error: "O comprimento m\xednimo deve estar entre {{min}} e {{max}} (inclusive).",
    minimum_required_char_types: "Tipos de caracteres m\xednimos necess\xe1rios",
    minimum_required_char_types_description: "Tipos de caracteres: letras mai\xfasculas (A-Z), letras min\xfasculas (a-z), n\xfameros (0-9) e s\xedmbolos especiais ({{symbols}}).",
    password_rejection: "Rejei\xe7\xe3o de password",
    compromised_passwords: "Passwords comprometidos",
    breached_passwords: "Passwords violados",
    breached_passwords_description: "Recusar passwords encontradas anteriormente em bancos de dados de viola\xe7\xe3o.",
    restricted_phrases: "Frases de baixa seguran\xe7a restritas",
    restricted_phrases_tooltip: "Your password should avoid these phrases unless you combine with 3 or more extra characters.",
    repetitive_or_sequential_characters: "Caracteres repetitivos ou sequenciais",
    repetitive_or_sequential_characters_description: 'Ex., "AAAA", "1234" e "abcd".',
    user_information: "Informa\xe7\xf5es do utilizador",
    user_information_description: "Ex., endere\xe7o de email, n\xfamero de telefone, nome de utilizador, etc.",
    custom_words: "Palavras personalizadas",
    custom_words_description: "Personalize palavras espec\xedficas do contexto, n\xe3o diferenciando mai\xfasculas de min\xfasculas e uma por linha.",
    custom_words_placeholder: "Nome de seu servi\xe7o, nome da empresa, etc."
};
var $cd314f5b2a46ae26$export$2e2bcd8739ae039 = Object.freeze($cd314f5b2a46ae26$var$password_policy);


const $94bb5b6b9cc3efe9$var$sign_up_and_sign_in = {
    identifiers_email: "Endere\xe7o de email",
    identifiers_phone: "N\xfamero de telefone",
    identifiers_username: "Nome de utilizador",
    identifiers_email_or_sms: "Endere\xe7o de email ou n\xfamero de telefone",
    identifiers_none: "N\xe3o aplic\xe1vel",
    and: "e",
    or: "ou",
    sign_up: {
        title: "REGISTO",
        sign_up_identifier: "Identificador de registo",
        identifier_description: "O identificador de registo \xe9 necess\xe1rio para a cria\xe7\xe3o de conta e deve ser inclu\xeddo no ecr\xe3 de in\xedcio de sess\xe3o.",
        sign_up_authentication: "Defini\xe7\xe3o de autentica\xe7\xe3o para registo",
        authentication_description: "Todas as a\xe7\xf5es selecionadas ser\xe3o obrigat\xf3rias para os utilizadores concluir o processo de registo.",
        set_a_password_option: "Criar uma senha",
        verify_at_sign_up_option: "Verificar durante o registo",
        social_only_creation_description: "(Aplica-se apenas \xe0 cria\xe7\xe3o de contas sociais)"
    },
    sign_in: {
        title: "INICIAR SESS\xc3O",
        sign_in_identifier_and_auth: "Identificador e defini\xe7\xf5es de autentica\xe7\xe3o para in\xedcio de sess\xe3o",
        description: "Os utilizadores podem iniciar sess\xe3o usando qualquer uma das op\xe7\xf5es dispon\xedveis. Ajuste a disposi\xe7\xe3o arrastando e soltando as op\xe7\xf5es abaixo.",
        add_sign_in_method: "Adicionar M\xe9todo de In\xedcio de Sess\xe3o",
        password_auth: "Senha",
        verification_code_auth: "C\xf3digo de verifica\xe7\xe3o",
        auth_swap_tip: "Alterne as op\xe7\xf5es abaixo para determinar qual aparece primeiro no processo.",
        require_auth_factor: "Tem de selecionar pelo menos um fator de autentica\xe7\xe3o."
    },
    social_sign_in: {
        title: "IN\xcdCIO DE SESS\xc3O SOCIAL",
        social_sign_in: "In\xedcio de sess\xe3o social",
        description: "Dependendo do identificador obrigat\xf3rio que configurou, o utilizador pode ser solicitado a fornecer um identificador ao registar-se atrav\xe9s do conector social.",
        add_social_connector: "Adicionar Conector Social",
        set_up_hint: {
            not_in_list: "N\xe3o est\xe1 na lista?",
            set_up_more: "Configurar",
            go_to: "outros conectores sociais agora."
        }
    },
    tip: {
        set_a_password: "Um conjunto \xfanico de uma senha para o seu nome de utilizador \xe9 obrigat\xf3rio.",
        verify_at_sign_up: "Atualmente, apenas suportamos email verificado. A sua base de utilizadores pode conter um grande n\xfamero de endere\xe7os de email de m\xe1 qualidade se n\xe3o houver valida\xe7\xe3o.",
        password_auth: "Isto \xe9 essencial uma vez que ativou a op\xe7\xe3o de criar uma senha durante o processo de registo.",
        verification_code_auth: "Isto \xe9 essencial uma vez que apenas ativou a op\xe7\xe3o de fornecer um c\xf3digo de verifica\xe7\xe3o ao registar-se. \xc9 livre de desmarcar a caixa quando a configura\xe7\xe3o da senha \xe9 permitida durante o processo de registo.",
        delete_sign_in_method: "Isto \xe9 essencial uma vez que selecionou {{identifier}} como um identificador obrigat\xf3rio."
    },
    advanced_options: {
        title: "OP\xc7\xd5ES AVAN\xc7ADAS",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Ativar registo de utilizadores",
        enable_user_registration_description: "Ativar ou desativar o registo de utilizadores. Uma vez desativado, os utilizadores ainda podem ser adicionados na consola de administra\xe7\xe3o, mas os utilizadores n\xe3o podem mais estabelecer contas atrav\xe9s da interface de in\xedcio de sess\xe3o."
    }
};
var $94bb5b6b9cc3efe9$export$2e2bcd8739ae039 = Object.freeze($94bb5b6b9cc3efe9$var$sign_up_and_sign_in);


const $45ff8ba62ad80a2c$var$sign_in_exp = {
    page_title: "Experi\xeancia de login",
    title: "Experi\xeancia de login",
    description: "Personalize a interface de login para corresponder a sua marca e visualize em tempo real",
    tabs: {
        branding: "Marca",
        sign_up_and_sign_in: "Registo e login",
        content: "Conte\xfado",
        password_policy: "Pol\xedtica de senha"
    },
    welcome: {
        title: "Personalize a experi\xeancia de in\xedcio de sess\xe3o",
        description: "Comece rapidamente com a configura\xe7\xe3o do seu primeiro in\xedcio de sess\xe3o. Este guia orienta-o atrav\xe9s de todas as defini\xe7\xf5es necess\xe1rias.",
        get_started: "Come\xe7ar",
        apply_remind: "Observe que a experi\xeancia de login ser\xe1 aplicada a todos os apps nesta conta."
    },
    color: {
        title: "COR",
        primary_color: "Cor da marca",
        dark_primary_color: "Cor da marca (tema escuro)",
        dark_mode: "Ativar tema escuro",
        dark_mode_description: "O app ter\xe1 um tema escuro gerado automaticamente com base na cor da marca e no algoritmo Logto. contudo \xe9 livre de personalizar.",
        dark_mode_reset_tip: "Recalcular a cor do tema escuro com base na cor da marca.",
        reset: "Recalcular"
    },
    branding: {
        title: "\xc1REA DE MARCA",
        ui_style: "Estilo",
        favicon: "Favicon",
        logo_image_url: "URL do logotipo da app",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL do logotipo da app (tema escuro)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Log\xf3tipo da aplica\xe7\xe3o",
        dark_logo_image: "Log\xf3tipo da aplica\xe7\xe3o (escuro)",
        logo_image_error: "Log\xf3tipo da aplica\xe7\xe3o: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "CSS Personalizado",
        css_code_editor_title: "Personalize a sua IU com CSS personalizado",
        css_code_editor_description1: "Veja o exemplo de CSS personalizado.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Saiba mais",
        css_code_editor_content_placeholder: "Insira o seu CSS personalizado para personalizar os estilos de qualquer elemento para as suas especifica\xe7\xf5es exatas. Expresse a sua criatividade e fa\xe7a a sua interface destacar-se."
    },
    sign_up_and_sign_in: $94bb5b6b9cc3efe9$export$2e2bcd8739ae039,
    content: $ae0ada4448fd39b7$export$2e2bcd8739ae039,
    password_policy: $cd314f5b2a46ae26$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Ainda n\xe3o foi configurado nenhum conector SMS. Antes de concluir a configura\xe7\xe3o, os utilizadores n\xe3o poder\xe3o iniciar sess\xe3o com este m\xe9todo. <a>{{link}}</a> em "Conectores"',
        no_connector_email: 'Ainda n\xe3o foi configurado qualquer conector de email. Antes de concluir a configura\xe7\xe3o, os utilizadores n\xe3o poder\xe3o iniciar sess\xe3o com este m\xe9todo. <a>{{link}}</a> em "Conectores"',
        no_connector_social: 'Voc\xea ainda n\xe3o configurou nenhum conector social. Adicione conectores primeiro para aplicar m\xe9todos de login social. <a>{{link}}</a> em "Conectores".',
        setup_link: "Configurar"
    },
    save_alert: {
        description: "Est\xe1 a implementar novos procedimentos de in\xedcio de sess\xe3o e registo. Todos os seus utilizadores podem ser afetados pela nova configura\xe7\xe3o. Tem a certeza de que quer confirmar a altera\xe7\xe3o?",
        before: "Antes",
        after: "Depois",
        sign_up: "Registo",
        sign_in: "Iniciar sess\xe3o",
        social: "Social"
    },
    preview: {
        title: "Visualiza\xe7\xe3o pr\xe9via do login",
        live_preview: "Visualiza\xe7\xe3o ao vivo",
        live_preview_tip: "Guardar para visualizar as altera\xe7\xf5es",
        native: "App nativa",
        desktop_web: "Web no computador",
        mobile_web: "Web no telem\xf3vel",
        desktop: "Ambiente de trabalho",
        mobile: "M\xf3vel"
    }
};
var $45ff8ba62ad80a2c$export$2e2bcd8739ae039 = Object.freeze($45ff8ba62ad80a2c$var$sign_in_exp);


const $1a69c67be44a3e5a$var$quota_item = {
    tenant_limit: {
        name: "Inquilinos",
        limited: "{{count, number}} inquilino",
        limited_other: "{{count, number}} inquilinos",
        unlimited: "Inquilinos ilimitados",
        not_eligible: "Eliminar tus inquilinos"
    },
    mau_limit: {
        name: "Utilizadores ativos mensais",
        limited: "{{count, number}} MAU",
        unlimited: "Utilizadores ativos mensais ilimitados",
        not_eligible: "Remover todos os utilizadores"
    },
    applications_limit: {
        name: "Aplica\xe7\xf5es",
        limited: "{{count, number}} aplica\xe7\xe3o",
        limited_other: "{{count, number}} aplica\xe7\xf5es",
        unlimited: "Aplica\xe7\xf5es ilimitadas",
        not_eligible: "Remover as tuas aplica\xe7\xf5es"
    },
    machine_to_machine_limit: {
        name: "M\xe1quina para m\xe1quina",
        limited: "{{count, number}} aplica\xe7\xe3o de m\xe1quina para m\xe1quina",
        limited_other: "{{count, number}} aplica\xe7\xf5es de m\xe1quina para m\xe1quina",
        unlimited: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina ilimitadas",
        not_eligible: "Remover as tuas aplica\xe7\xf5es de m\xe1quina para m\xe1quina"
    },
    resources_limit: {
        name: "Recursos de API",
        limited: "{{count, number}} recurso de API",
        limited_other: "{{count, number}} recursos de API",
        unlimited: "Recursos de API ilimitados",
        not_eligible: "Remover os teus recursos de API"
    },
    scopes_per_resource_limit: {
        name: "Permiss\xf5es de recursos",
        limited: "{{count, number}} permiss\xe3o por recurso",
        limited_other: "{{count, number}} permiss\xf5es por recurso",
        unlimited: "Permiss\xe3o por recurso ilimitada",
        not_eligible: "Remover as tuas permiss\xf5es de recurso"
    },
    custom_domain_enabled: {
        name: "Dom\xednio personalizado",
        limited: "Dom\xednio personalizado",
        unlimited: "Dom\xednio personalizado",
        not_eligible: "Remover o teu dom\xednio personalizado"
    },
    omni_sign_in_enabled: {
        name: "Omni sign-in",
        limited: "Omni sign-in",
        unlimited: "Omni sign-in",
        not_eligible: "Desativar o teu omni sign-in"
    },
    built_in_email_connector_enabled: {
        name: "Conector de e-mail incorporado",
        limited: "Conector de e-mail incorporado",
        unlimited: "Conector de e-mail incorporado",
        not_eligible: "Remover o teu conector de e-mail incorporado"
    },
    social_connectors_limit: {
        name: "Conectores sociais",
        limited: "{{count, number}} conector social",
        limited_other: "{{count, number}} conectores sociais",
        unlimited: "Conectores sociais ilimitados",
        not_eligible: "Remover os teus conectores sociais"
    },
    standard_connectors_limit: {
        name: "Conectores padr\xe3o gratuitos",
        limited: "{{count, number}} conector padr\xe3o gratuito",
        limited_other: "{{count, number}} conectores padr\xe3o gratuitos",
        unlimited: "Conectores padr\xe3o ilimitados",
        not_eligible: "Remover os teus conectores padr\xe3o"
    },
    roles_limit: {
        name: "Fun\xe7\xf5es",
        limited: "{{count, number}} fun\xe7\xe3o",
        limited_other: "{{count, number}} fun\xe7\xf5es",
        unlimited: "Fun\xe7\xf5es ilimitadas",
        not_eligible: "Remover as tuas fun\xe7\xf5es"
    },
    scopes_per_role_limit: {
        name: "Permiss\xf5es de fun\xe7\xe3o",
        limited: "{{count, number}} permiss\xe3o por fun\xe7\xe3o",
        limited_other: "{{count, number}} permiss\xf5es por fun\xe7\xe3o",
        unlimited: "Permiss\xe3o por fun\xe7\xe3o ilimitada",
        not_eligible: "Remover as tuas permiss\xf5es de fun\xe7\xe3o"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Webhooks ilimitados",
        not_eligible: "Remova os seus webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Conserva\xe7\xe3o de registos de auditoria",
        limited: "Conserva\xe7\xe3o de registos de auditoria: {{count, number}} dia",
        limited_other: "Conserva\xe7\xe3o de registos de auditoria: {{count, number}} dias",
        unlimited: "Dias ilimitados",
        not_eligible: "Sem registos de auditoria"
    },
    community_support_enabled: {
        name: "Apoio da comunidade",
        limited: "Apoio da comunidade",
        unlimited: "Apoio da comunidade",
        not_eligible: "Sem apoio da comunidade"
    },
    customer_ticket_support: {
        name: "Apoio de bilhetes de cliente",
        limited: "{{count, number}} hora de apoio de bilhetes de cliente",
        limited_other: "{{count, number}} horas de apoio de bilhetes de cliente",
        unlimited: "Apoio de bilhetes de cliente",
        not_eligible: "Sem apoio de bilhetes de cliente"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Desative a sua MFA"
    },
    sso_enabled: {
        name: "SSO Empresarial",
        limited: "SSO Empresarial",
        unlimited: "SSO Empresarial",
        not_eligible: "Desativar o seu SSO Empresarial"
    }
};
var $1a69c67be44a3e5a$export$2e2bcd8739ae039 = Object.freeze($1a69c67be44a3e5a$var$quota_item);


const $fefaa4f9dda6d03c$var$quota_table = {
    quota: {
        title: "Quota",
        tenant_limit: "Limite do inquilino",
        base_price: "Pre\xe7o base",
        mau_unit_price: "* Pre\xe7o unit\xe1rio MAU",
        mau_limit: "Limite MAU"
    },
    application: {
        title: "Aplica\xe7\xf5es",
        total: "Total de aplica\xe7\xf5es",
        m2m: "Aplica\xe7\xf5es de m\xe1quina para m\xe1quina"
    },
    resource: {
        title: "Recursos da API",
        resource_count: "Contagem de recursos",
        scopes_per_resource: "Permiss\xf5es por recurso"
    },
    branding: {
        title: "UI e branding",
        custom_domain: "Dom\xednio personalizado",
        custom_css: "CSS personalizado",
        app_logo_and_favicon: "Log\xf3tipo da aplica\xe7\xe3o e favicon",
        dark_mode: "Modo escuro",
        i18n: "Internacionaliza\xe7\xe3o"
    },
    user_authn: {
        title: "Autentica\xe7\xe3o do utilizador",
        omni_sign_in: "In\xedcio de sess\xe3o Omni",
        password: "Palavra-passe",
        passwordless: "Sem palavra-passe - E-mail e SMS",
        email_connector: "Conector de e-mail",
        sms_connector: "Conector de SMS",
        social_connectors: "Conectores sociais",
        standard_connectors: "Conectores padr\xe3o",
        built_in_email_connector: "Conector de e-mail incorporado",
        mfa: "MFA",
        sso: "SSO Empresarial"
    },
    user_management: {
        title: "Gest\xe3o de utilizadores",
        user_management: "Gest\xe3o de utilizadores",
        roles: "Fun\xe7\xf5es",
        scopes_per_role: "Permiss\xf5es por fun\xe7\xe3o"
    },
    audit_logs: {
        title: "Registos de auditoria",
        retention: "Reten\xe7\xe3o"
    },
    hooks: {
        title: "Hooks",
        hooks: "Hooks"
    },
    organizations: {
        title: "Organiza\xe7\xe3o",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Suporte",
        community: "Comunidade",
        customer_ticket: "Bilhete de suporte",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Os seus utilizadores ativos mensais (MAU) s\xe3o divididos em 3 n\xedveis com base na frequ\xeancia com que iniciam sess\xe3o durante o ciclo de fatura\xe7\xe3o. Cada n\xedvel tem um pre\xe7o diferente por unidade de MAU.",
    unlimited: "Ilimitado",
    contact: "Contactar",
    monthly_price: "${{value, number}}/m\xeas",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} dia",
    days_other: "{{count, number}} dias",
    add_on: "Suplemento",
    tier: "N\xedvel{{value, number}}: "
};
var $fefaa4f9dda6d03c$export$2e2bcd8739ae039 = Object.freeze($fefaa4f9dda6d03c$var$quota_table);


const $b81c304bcc3e27e4$var$subscription = {
    free_plan: "Plano Gratuito",
    free_plan_description: "Para projetos secund\xe1rios e testes iniciais do Logto. Sem cart\xe3o de cr\xe9dito.",
    hobby_plan: "Plano Hobby",
    hobby_plan_description: "Para desenvolvedores individuais ou pequenas equipas de engenharia.",
    pro_plan: "Plano Pro",
    pro_plan_description: "Para empresas que desejam se beneficiar sem preocupa\xe7\xf5es com o Logto.",
    enterprise: "Empresa",
    current_plan: "Plano Atual",
    current_plan_description: "Aqui est\xe1 o seu plano atual. Pode facilmente verificar a utiliza\xe7\xe3o do seu plano, verificar a sua pr\xf3xima fatura e efetuar altera\xe7\xf5es no seu plano, conforme necess\xe1rio.",
    plan_usage: "Uso do plano",
    plan_cycle: "Ciclo do plano: {{period}}. O uso \xe9 renovado em {{renewDate}}.",
    next_bill: "Sua pr\xf3xima fatura",
    next_bill_hint: "Para saber mais sobre o c\xe1lculo, consulte este <a>artigo</a>.",
    next_bill_tip: "Sua pr\xf3xima fatura inclui o pre\xe7o base do seu plano para o pr\xf3ximo m\xeas, bem como o custo do uso multiplicado pelo pre\xe7o da unidade MAU em v\xe1rios n\xedveis.",
    manage_payment: "Gerenciar pagamento",
    overfill_quota_warning: "Voc\xea atingiu o limite da sua cota. Para evitar problemas, fa\xe7a upgrade do plano.",
    upgrade_pro: "Atualizar para Pro",
    update_payment: "Atualizar pagamento",
    payment_error: "Problema de pagamento detectado. N\xe3o \xe9 poss\xedvel processar ${{price, number}} para o ciclo anterior. Atualize o pagamento para evitar a suspens\xe3o do servi\xe7o Logto.",
    downgrade: "Downgrade",
    current: "Atual",
    upgrade: "Atualiza\xe7\xe3o",
    quota_table: $fefaa4f9dda6d03c$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturas",
        status_column: "Status",
        amount_column: "Valor",
        invoice_created_date_column: "Data de cria\xe7\xe3o da fatura",
        invoice_status: {
            void: "Cancelada",
            paid: "Paga",
            open: "Em aberto",
            uncollectible: "Vencida"
        }
    },
    quota_item: $1a69c67be44a3e5a$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Tem certeza de que deseja fazer o downgrade?",
        description: "Se voc\xea escolher mudar para o <targetName/>, observe que voc\xea n\xe3o ter\xe1 mais acesso \xe0 cota e \xe0s funcionalidades que estavam anteriormente no <currentName/>.",
        before: "Antes: <name/>",
        after: "Depois: <name />",
        downgrade: "Downgrade"
    },
    not_eligible_modal: {
        downgrade_title: "N\xe3o \xe9 poss\xedvel fazer downgrade",
        downgrade_description: "Certifique-se de cumprir os seguintes crit\xe9rios antes de efetuar o downgrade para o plano <name/>.",
        downgrade_help_tip: "Precisa de ajuda com o downgrade? <a>Contacte-nos</a>.",
        upgrade_title: "Lembrete amig\xe1vel para os nossos honrados early adopters",
        upgrade_description: "Est\xe1s atualmente a utilizar mais do que o permitido pelo <name />. O Logto \xe9 agora oficial, incluindo funcionalidades adequadas a cada plano. Antes de considerares a atualiza\xe7\xe3o para o <name />, certifica-te de que preenches os seguintes crit\xe9rios antes de proceder \xe0 atualiza\xe7\xe3o.",
        upgrade_pro_tip: " Ou considera a atualiza\xe7\xe3o para o Plano Pro.",
        upgrade_help_tip: "Precisa de ajuda com o upgrade? <a>Contacte-nos</a>.",
        a_maximum_of: "Um m\xe1ximo de <item/>"
    },
    upgrade_success: "Atualizou com sucesso para <name/>",
    downgrade_success: "Downgrade conclu\xeddo com sucesso para <name/>",
    subscription_check_timeout: "A verifica\xe7\xe3o de subscri\xe7\xe3o expirou. Por favor, atualize mais tarde.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $b81c304bcc3e27e4$export$2e2bcd8739ae039 = Object.freeze($b81c304bcc3e27e4$var$subscription);


const $e7981729a3ac077e$var$tab_sections = {
    overview: "Vista geral",
    resources: "Recursos",
    users: "Utilizadores",
    access_control: "Controlo de acesso",
    help_and_support: "Ajuda e suporte",
    tenant: "Arrendat\xe1rio",
    automation: "Automa\xe7\xe3o"
};
var $e7981729a3ac077e$export$2e2bcd8739ae039 = Object.freeze($e7981729a3ac077e$var$tab_sections);


const $9212079ae02ece7a$var$tabs = {
    get_started: "Come\xe7o",
    dashboard: "Painel",
    applications: "Aplica\xe7\xf5es",
    api_resources: "Recursos API",
    sign_in_experience: "Experi\xeancia de login",
    connectors: "Conectores",
    enterprise_sso: "SSO empresarial",
    webhooks: "Webhooks",
    organizations: "Organiza\xe7\xf5es",
    users: "Gest\xe3o de utilizadores",
    audit_logs: "Registos de auditoria",
    roles: "Fun\xe7\xf5es",
    docs: "Documenta\xe7\xe3o",
    tenant_settings: "Defini\xe7\xf5es do inquilino",
    mfa: "Autentica\xe7\xe3o multi-fator"
};
var $9212079ae02ece7a$export$2e2bcd8739ae039 = Object.freeze($9212079ae02ece7a$var$tabs);


const $3a237c6a1cb18116$var$tenants = {
    title: "Defini\xe7\xf5es",
    description: "Gerir eficientemente as configura\xe7\xf5es do inquilino e personalizar o seu dom\xednio.",
    tabs: {
        settings: "Defini\xe7\xf5es",
        domains: "Dom\xednios",
        subscription: "Plano e fatura\xe7\xe3o",
        billing_history: "Hist\xf3rico de fatura\xe7\xe3o"
    },
    settings: {
        title: "DEFINI\xc7\xd5ES",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID do Inquilino",
        tenant_name: "Nome do Inquilino",
        tenant_region: "Regi\xe3o de hospedagem",
        tenant_region_tip: "Os recursos do seu inquilino s\xe3o hospedados na regi\xe3o {{region}}. <a>Learn more</a>",
        environment_tag_development: "Dev",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "A informa\xe7\xe3o do arrendat\xe1rio foi guardada com sucesso."
    },
    full_env_tag: {
        development: "Desenvolvimento",
        production: "Produ\xe7\xe3o"
    },
    deletion_card: {
        title: "ELIMINAR",
        tenant_deletion: "Eliminar inquilino",
        tenant_deletion_description: "A elimina\xe7\xe3o do inquilino resultar\xe1 na remo\xe7\xe3o permanente de todos os dados de utilizador e configura\xe7\xe3o associados. Por favor, proceda com cuidado.",
        tenant_deletion_button: "Eliminar inquilino"
    },
    create_modal: {
        title: "Criar inquilino",
        subtitle: "Crie um novo locat\xe1rio que tenha recursos e utilizadores isolados. As regi\xf5es de dados hospedados e os tipos de locat\xe1rio n\xe3o podem ser modificados ap\xf3s a cria\xe7\xe3o.",
        tenant_usage_purpose: "Para que pretende utilizar este inquilino?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Plano dispon\xedvel:",
        create_button: "Criar inquilino",
        tenant_name_placeholder: "Meu inquilino"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Eliminar inquilino",
        description_line1: 'Tem a certeza de que pretende eliminar o seu inquilino "<span>{{name}}</span>" com a etiqueta de ambiente de sufixo "<span>{{tag}}</span>"? Esta a\xe7\xe3o n\xe3o pode ser desfeita e resultar\xe1 na elimina\xe7\xe3o permanente de todos os seus dados e informa\xe7\xf5es da conta.',
        description_line2: "Antes de eliminar a conta, podemos ajud\xe1-lo. <span><a>Contacte-nos por email</a></span>",
        description_line3: 'Se desejar continuar, introduza o nome do inquilino "<span>{{name}}</span>" para confirmar.',
        delete_button: "Eliminar permanentemente",
        cannot_delete_title: "N\xe3o \xe9 poss\xedvel apagar este inquilino",
        cannot_delete_description: "Desculpe, n\xe3o \xe9 poss\xedvel apagar este inquilino neste momento. Certifique-se de estar no Plano Gratuito e de ter pago todas as faturas em atraso."
    },
    tenant_landing_page: {
        title: "Ainda n\xe3o criou um inquilino",
        description: "Para come\xe7ar a configurar o seu projeto com o Logto, crie um novo inquilino. Se precisar de fazer logout ou excluir a sua conta, basta clicar no bot\xe3o avatar no canto superior direito.",
        create_tenant_button: "Criar inquilino"
    },
    status: {
        mau_exceeded: "Limite MAU Excedido",
        suspended: "Suspenso",
        overdue: "Atrasado"
    },
    tenant_suspended_page: {
        title: "Inquilino suspenso. Contacte-nos para restaurar o acesso.",
        description_1: "Lamentamos informar que a sua conta de inquilino foi temporariamente suspensa devido a uso indevido, incluindo exceder os limites de MAU, pagamentos em atraso ou outras a\xe7\xf5es n\xe3o autorizadas.",
        description_2: "Se precisar de mais esclarecimentos, tiver alguma preocupa\xe7\xe3o ou desejar restaurar a funcionalidade completa e desbloquear os seus inquilinos, n\xe3o hesite em contactar-nos imediatamente."
    },
    signing_keys: {
        title: "CHAVES DE ASSINATURA",
        description: "Gerir de forma segura as chaves de assinatura no seu inquilino.",
        type: {
            private_key: "Chaves privadas OIDC",
            cookie_key: "Chaves de cookies OIDC"
        },
        private_keys_in_use: "Chaves privadas em uso",
        cookie_keys_in_use: "Chaves de cookies em uso",
        rotate_private_keys: "Rodar chaves privadas",
        rotate_cookie_keys: "Rodar chaves de cookies",
        rotate_private_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave privada de assinatura, rodar\xe1 a chave atual e remover\xe1 a chave anterior. Os seus tokens JWT assinados com a chave atual permanecer\xe3o v\xe1lidos at\xe9 \xe0 elimina\xe7\xe3o ou outra rodada de rota\xe7\xe3o.",
        rotate_cookie_keys_description: "Esta a\xe7\xe3o criar\xe1 uma nova chave de cookie, rodar\xe1 a chave atual e remover\xe1 a chave anterior. Os seus cookies com a chave atual permanecer\xe3o v\xe1lidos at\xe9 \xe0 elimina\xe7\xe3o ou outra rodada de rota\xe7\xe3o.",
        select_private_key_algorithm: "Selecionar o algoritmo de assinatura para a nova chave privada",
        rotate_button: "Rodar",
        table_column: {
            id: "ID",
            status: "Estado",
            algorithm: "Algoritmo de assinatura da chave"
        },
        status: {
            current: "Atual",
            previous: "Anterior"
        },
        reminder: {
            rotate_private_key: "Tem a certeza de que pretende rodar as <strong>chaves privadas OIDC</strong>? Os novos tokens JWT emitidos ser\xe3o assinados pela nova chave. Os tokens JWT existentes permanecem v\xe1lidos at\xe9 rodar novamente.",
            rotate_cookie_key: "Tem a certeza de que pretende rodar as <strong>chaves de cookies OIDC</strong>? Os novos cookies gerados em sess\xf5es de login ser\xe3o assinados pela nova chave de cookie. Os cookies existentes permanecem v\xe1lidos at\xe9 rodar novamente.",
            delete_private_key: "Tem a certeza de que pretende eliminar a <strong>chave privada OIDC</strong>? Os tokens JWT existentes assinados com esta chave de assinatura privada deixar\xe3o de ser v\xe1lidos.",
            delete_cookie_key: "Tem a certeza de que pretende eliminar a <strong>chave de cookie OIDC</strong>? As sess\xf5es de login antigas com cookies assinados com esta chave de cookie deixar\xe3o de ser v\xe1lidas. \xc9 necess\xe1ria uma nova autentica\xe7\xe3o para estes utilizadores."
        },
        messages: {
            rotate_key_success: "Chaves de assinatura rodadas com sucesso.",
            delete_key_success: "Chave eliminada com sucesso."
        }
    }
};
var $3a237c6a1cb18116$export$2e2bcd8739ae039 = Object.freeze($3a237c6a1cb18116$var$tenants);


const $d77743d942c94dce$var$topbar = {
    docs: "Documentos",
    help: "Ajuda"
};
var $d77743d942c94dce$export$2e2bcd8739ae039 = Object.freeze($d77743d942c94dce$var$topbar);


const $345e2978ddd4f813$var$paywall = {
    applications: "Limite de {{count, number}} aplica\xe7\xe3o do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    applications_other: "Limite de {{count, number}} aplica\xe7\xf5es do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipa. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_feature: "Upgrade para o plano <strong>Hobby</strong> para desbloquear 1 aplica\xe7\xe3o de m\xe1quina a m\xe1quina, ou escolha o plano <strong>Pro</strong> para uso ilimitado. Para qualquer assist\xeancia, n\xe3o hesite em <a>entrar em contato conosco</a>.",
    machine_to_machine: "Limite de {{count, number}} aplica\xe7\xe3o de m\xe1quina a m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    machine_to_machine_other: "Limite de {{count, number}} aplica\xe7\xf5es de m\xe1quina a m\xe1quina do <planName/> atingido. Atualize o plano para atender \xe0s necessidades da sua equipe. Para obter qualquer ajuda, sinta-se \xe0 vontade para <a>entrar em contato conosco</a>.",
    resources: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipa. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    resources_other: "Atingiu o limite de {{count, number}} recursos de API de <planName/>. Atualize o plano para satisfazer as necessidades da sua equipa. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    scopes_per_resource_other: "Atingiu o limite de {{count, number}} permiss\xf5es por recurso de API de <planName/>. Atualize agora para expandir. <a>Contacte-nos</a> se precisar de assist\xeancia.",
    custom_domain: "Desbloqueie a funcionalidade de dom\xednio personalizado ao atualizar para o plano <strong>Hobby</strong> ou <strong>Pro</strong>. N\xe3o hesite em <a>entrar em contato conosco</a> se precisar de qualquer assist\xeancia.",
    social_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    social_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_feature: "Upgrade para os planos <strong>Hobby</strong> ou <strong>Pro</strong> para criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML, al\xe9m de conectores sociais ilimitados e todos os recursos premium. Sinta-se \xe0 vontade para <a>entrar em contato conosco</a> se precisar de qualquer assist\xeancia.",
    standard_connectors: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_other: "Atingiu o limite de {{count, number}} conectores sociais de <planName/>. Atualize o plano para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    standard_connectors_pro_other: "Atingiu o limite de {{count, number}} conectores padr\xe3o de <planName/>. Atualize para o plano Empresarial para obter conectores sociais adicionais e a capacidade de criar os seus pr\xf3prios conectores usando os protocolos OIDC, OAuth 2.0 e SAML. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    roles_other: "Atingiu o limite de {{count, number}} fun\xe7\xf5es de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    scopes_per_role: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    scopes_per_role_other: "Atingiu o limite de {{count, number}} permiss\xf5es por fun\xe7\xe3o de <planName/>. Atualize o plano para adicionar fun\xe7\xf5es e permiss\xf5es adicionais. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    hooks_other: "Atingiu o limite de {{count, number}} webhooks de <planName/>. Atualize o plano para criar mais webhooks. N\xe3o hesite em <a>Contacte-nos</a> se precisar de ajuda.",
    mfa: "Desbloqueie o MFA para a verifica\xe7\xe3o de seguran\xe7a ao atualizar para um plano pago. N\xe3o hesite em <a>entrar em contato conosco</a> se precisar de assist\xeancia.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $345e2978ddd4f813$export$2e2bcd8739ae039 = Object.freeze($345e2978ddd4f813$var$paywall);


const $727215f85cbf0df4$var$upsell = {
    upgrade_plan: "Atualizar plano",
    compare_plans: "Comparar planos",
    view_plans: "Ver planos",
    create_tenant: {
        title: "Selecione o seu plano de inquilino",
        description: "O Logto oferece op\xe7\xf5es competitivas de planos com pre\xe7os inovadores e acess\xedveis, especialmente concebidos para empresas em crescimento. <a>Saiba mais</a>",
        base_price: "Pre\xe7o base",
        monthly_price: "{{value, number}}/m\xeas",
        mau_unit_price: "Pre\xe7o unit\xe1rio do MAU",
        view_all_features: "Ver todas as funcionalidades",
        select_plan: "Selecionar <name/>",
        free_tenants_limit: "At\xe9 {{count, number}} inquilino gratuito",
        free_tenants_limit_other: "At\xe9 {{count, number}} inquilinos gratuitos",
        most_popular: "Mais popular",
        upgrade_success: "Atualiza\xe7\xe3o para <name/> bem-sucedida"
    },
    mau_exceeded_modal: {
        title: "MAU excedeu o limite. Atualize o seu plano.",
        notification: "O seu MAU atual excedeu o limite de <planName/>. Por favor, atualize para o plano premium a tempo para evitar a suspens\xe3o do servi\xe7o do Logto.",
        update_plan: "Atualizar plano"
    },
    payment_overdue_modal: {
        title: "Pagamento da fatura em atraso",
        notification: "Oops! O pagamento da fatura do inquilino <span>{{name}}</span> falhou. Por favor, pague a fatura prontamente para evitar a suspens\xe3o do servi\xe7o Logto.",
        unpaid_bills: "Faturas n\xe3o pagas",
        update_payment: "Atualizar pagamento"
    },
    paywall: $345e2978ddd4f813$export$2e2bcd8739ae039
};
var $727215f85cbf0df4$export$2e2bcd8739ae039 = Object.freeze($727215f85cbf0df4$var$upsell);


const $b5c05928cb1040ea$var$user_details = {
    page_title: "Detalhes do utilizador",
    back_to_users: "Voltar \xe0 gest\xe3o de utilizadores",
    created_title: "Este utilizador foi criado com sucesso",
    created_guide: "Aqui est\xe1 a informa\xe7\xe3o para ajudar o utilizador no processo de login.",
    created_email: "Endere\xe7o de email:",
    created_phone: "N\xfamero de telefone:",
    created_username: "Nome de utilizador:",
    created_password: "Palavra-passe:",
    menu_delete: "eliminar",
    delete_description: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 eliminar o utilizador permanentemente.",
    deleted: "O utilizador foi eliminado com sucesso",
    reset_password: {
        reset_password: "Redefinir palavra-passe",
        title: "Tem a certeza de que deseja redefinir a palavra-passe?",
        content: "Esta a\xe7\xe3o n\xe3o pode ser desfeita. Isso ir\xe1 redefinir as informa\xe7\xf5es de login do utilizador.",
        congratulations: "Este utilizador foi redefinido",
        new_password: "Nova palavra-passe:"
    },
    tab_settings: "Defini\xe7\xf5es",
    tab_roles: "Fun\xe7\xf5es",
    tab_logs: "Registos do utilizador",
    tab_organizations: "Organiza\xe7\xf5es",
    authentication: "Autentica\xe7\xe3o",
    authentication_description: "Cada utilizador tem um perfil que cont\xe9m todas as informa\xe7\xf5es do utilizador. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados.",
    user_profile: "Perfil de utilizador",
    field_email: "Endere\xe7o de email",
    field_phone: "N\xfamero de telefone",
    field_username: "Nome de utilizador",
    field_name: "Nome",
    field_avatar: "URL da imagem do avatar",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Dados personalizados",
    field_custom_data_tip: "Informa\xe7\xf5es adicionais do utilizador n\xe3o listadas nas propriedades predefinidas, ex: idioma preferido pelo utilizador.",
    field_connectors: "Conex\xf5es sociais",
    field_sso_connectors: "Conex\xf5es empresariais",
    custom_data_invalid: "Os dados personalizados devem ser um objeto JSON v\xe1lido",
    connectors: {
        connectors: "Conectores",
        user_id: "ID do utilizador",
        remove: "Remover",
        connected: "Este utilizador est\xe1 conectado a m\xfaltiplos conectores sociais.",
        not_connected: "O utilizador n\xe3o est\xe1 conectado a nenhum conector social",
        deletion_confirmation: "Est\xe1 a remover a identidade existente <name/>. Tem a certeza de que deseja continuar?"
    },
    sso_connectors: {
        connectors: "Conetores",
        enterprise_id: "ID da empresa",
        connected: "Este utilizador est\xe1 conectado a m\xfaltiplos provedores de identidade empresarial para In\xedcio de Sess\xe3o \xdanico.",
        not_connected: "O utilizador n\xe3o est\xe1 conectado a nenhum provedor de identidade empresarial para In\xedcio de Sess\xe3o \xdanico."
    },
    mfa: {
        field_name: "Autentica\xe7\xe3o de dois fatores",
        field_description: "Este utilizador ativou fatores de autentica\xe7\xe3o de 2 etapas.",
        name_column: "Autentica\xe7\xe3o de dois fatores",
        field_description_empty: "Este utilizador n\xe3o ativou fatores de autentica\xe7\xe3o de 2 passos.",
        deletion_confirmation: "Est\xe1 a remover o existente <name/> para a verifica\xe7\xe3o em duas etapas. Tem a certeza de que deseja continuar?"
    },
    suspended: "suspenso",
    suspend_user: "Suspender utilizador",
    suspend_user_reminder: "Tem a certeza de que deseja suspender este utilizador? O utilizador n\xe3o conseguir\xe1 entrar na sua aplica\xe7\xe3o e n\xe3o ser\xe1 capaz de obter um novo Token de acesso ap\xf3s o termo atual. Al\xe9m disso, qualquer pedido API feito por este utilizador ir\xe1 falhar.",
    suspend_action: "Suspender",
    user_suspended: "O utilizador foi suspenso.",
    reactivate_user: "Reativar utilizador",
    reactivate_user_reminder: "Tem a certeza de que deseja reativar este utilizador? Isso permitir\xe1 tentativas de login para este utilizador.",
    reactivate_action: "Reativar",
    user_reactivated: "O utilizador foi reativado.",
    roles: {
        name_column: "Fun\xe7\xe3o",
        description_column: "Descri\xe7\xe3o",
        assign_button: "Atribuir fun\xe7\xf5es",
        delete_description: "Esta a\xe7\xe3o ir\xe1 remover esta fun\xe7\xe3o deste utilizador. A fun\xe7\xe3o em si ainda existir\xe1, mas n\xe3o estar\xe1 mais associada a este utilizador.",
        deleted: "{{name}} foi removido do utilizador com sucesso.",
        assign_title: "Atribuir fun\xe7\xf5es a {{name}}",
        assign_subtitle: "Autorize {{name}} uma ou mais fun\xe7\xf5es",
        assign_role_field: "Atribuir fun\xe7\xf5es",
        role_search_placeholder: "Pesquisar pelo nome da fun\xe7\xe3o",
        added_text: "{{value, number}} adicionados",
        assigned_user_count: "{{value, number}} utilizador(es)",
        confirm_assign: "Atribuir fun\xe7\xf5es",
        role_assigned: "Fun\xe7\xe3o(\xf5es) atribu\xedda(s) com sucesso",
        search: "Pesquisar pelo nome, descri\xe7\xe3o ou ID da fun\xe7\xe3o",
        empty: "Nenhuma fun\xe7\xe3o dispon\xedvel"
    },
    warning_no_sign_in_identifier: "O utilizador precisa de ter pelo menos um dos identificadores de in\xedcio de sess\xe3o (nome de utilizador, e-mail, n\xfamero de telefone ou redes sociais) para iniciar sess\xe3o. Tem a certeza de que quer continuar?",
    organization_roles_tooltip: "As fun\xe7\xf5es atribu\xeddas ao utilizador dentro desta organiza\xe7\xe3o."
};
var $b5c05928cb1040ea$export$2e2bcd8739ae039 = Object.freeze($b5c05928cb1040ea$var$user_details);


const $7ba7d38d0182dd7f$var$users = {
    page_title: "Gest\xe3o de utilizadores",
    title: "Gest\xe3o de utilizadores",
    subtitle: "Gerencie os utilizadores, incluindo a cria\xe7\xe3o, edi\xe7\xe3o de informa\xe7\xf5es, visualiza\xe7\xe3o de logs, recupera\xe7\xf5es de password e exclus\xf5es",
    create: "Adicionar usu\xe1rio",
    create_subtitle: "Fornecer pelo menos um dos seguintes campos para proceder.",
    error_missing_identifier: "Tem de fornecer pelo menos um identificador para criar um utilizador.",
    user_name: "Utilizador",
    application_name: "Do aplicativo",
    latest_sign_in: "\xdaltimo login",
    create_form_username: "Utilizador",
    create_form_password: "Palavra-passe",
    create_form_name: "Nome completo",
    placeholder_name: "Z\xe9 Ningu\xe9m",
    placeholder_email: "zninguem@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+351 21 234 5678",
    unnamed: "Sem nome",
    search: "Procurar por nome, email, telefone ou nome de utilizador",
    check_user_detail: "Ver detalhes do utilizador",
    placeholder_title: "Gest\xe3o de utilizadores",
    placeholder_description: "Cada utilizador tem um perfil contendo todas as informa\xe7\xf5es do utilizador. Consiste em dados b\xe1sicos, identidades sociais e dados personalizados"
};
var $7ba7d38d0182dd7f$export$2e2bcd8739ae039 = Object.freeze($7ba7d38d0182dd7f$var$users);


const $8cb34095d6a2f654$var$webhook_details = {
    page_title: "Detalhes do webhook",
    back_to_webhooks: "Voltar para Webhooks",
    not_in_use: "N\xe3o est\xe1 em uso",
    success_rate: "Taxa de sucesso",
    requests: "{{value, number}} solicita\xe7\xf5es em 24h",
    disable_webhook: "Desativar o webhook",
    disable_reminder: "Tem certeza de que deseja reativar este webhook? Faz\xea-lo n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    webhook_disabled: "O webhook foi desativado.",
    webhook_reactivated: "O webhook foi reativado.",
    reactivate_webhook: "Reativar webhook",
    delete_webhook: "Excluir webhook",
    deletion_reminder: "Voc\xea est\xe1 removendo este webhook. Depois de exclu\xed-lo, ele n\xe3o enviar\xe1 solicita\xe7\xe3o HTTP para o URL do endpoint.",
    deleted: "O webhook foi exclu\xeddo com sucesso.",
    settings_tab: "Configura\xe7\xf5es",
    recent_requests_tab: "Solicita\xe7\xf5es recentes (24h)",
    settings: {
        settings: "Configura\xe7\xf5es",
        settings_description: "Os webhooks permitem que voc\xea receba atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos conforme eles ocorrem, enviando uma solicita\xe7\xe3o POST para seu URL de endpoint. Isso permite que voc\xea tome a\xe7\xf5es imediatas com base nas novas informa\xe7\xf5es recebidas.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho que o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        endpoint_url: "URL do endpoint",
        signing_key: "Chave de assinatura",
        signing_key_tip: "Adicione a chave secreta fornecida pelo Logto ao seu endpoint como um cabe\xe7alho de solicita\xe7\xe3o para garantir a autenticidade do corpo do webhook.",
        regenerate: "Regenerar",
        regenerate_key_title: "Regenerar a chave de assinatura",
        regenerate_key_reminder: "Voc\xea tem certeza de que deseja modificar a chave de assinatura? A regenera\xe7\xe3o entrar\xe1 em vigor imediatamente. Lembre-se de modificar a chave de assinatura de forma s\xedncrona em seu endpoint.",
        regenerated: "A chave de assinatura foi regenerada.",
        custom_headers: "Cabe\xe7alhos personalizados",
        custom_headers_tip: "Opcionalmente, voc\xea pode adicionar cabe\xe7alhos personalizados ao corpo do webhook para fornecer contexto ou metadados adicionais sobre o evento.",
        key_duplicated_error: "As chaves n\xe3o podem ser repetidas.",
        key_missing_error: "Key \xe9 obrigat\xf3rio.",
        value_missing_error: "O valor \xe9 obrigat\xf3rio.",
        invalid_key_error: "Chave inv\xe1lida",
        invalid_value_error: "Valor inv\xe1lido",
        test: "Teste",
        test_webhook: "Teste seu webhook",
        test_webhook_description: "Configure o webhook e teste-o com exemplos de carga \xfatil para cada evento selecionado para verificar a recep\xe7\xe3o e o processamento corretos.",
        send_test_payload: "Enviar carga de teste",
        test_result: {
            endpoint_url: "URL do ponto de extremidade: {{url}}",
            message: "Mensagem: {{message}}",
            response_status: "Estado da resposta: {{status, number}}",
            response_body: "Corpo da resposta: {{body}}",
            request_time: "Tempo da solicita\xe7\xe3o: {{time}}",
            test_success: "O teste de webhook para o ponto de extremidade foi bem-sucedido."
        }
    }
};
var $8cb34095d6a2f654$export$2e2bcd8739ae039 = Object.freeze($8cb34095d6a2f654$var$webhook_details);


const $9773088a15479b8a$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "Crie webhooks para receber atualiza\xe7\xf5es em tempo real sobre eventos espec\xedficos.",
    create: "Criar Webhook",
    events: {
        post_register: "Criar nova conta",
        post_sign_in: "Entrar",
        post_reset_password: "Redefinir senha"
    },
    table: {
        name: "Nome",
        events: "Eventos",
        success_rate: "Taxa de sucesso (24h)",
        requests: "Solicita\xe7\xf5es (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: 'Crie um webhook para receber atualiza\xe7\xf5es em tempo real por meio de solicita\xe7\xf5es POST para sua URL de endpoint. Fique informado e tome medidas imediatas em eventos como "Criar conta", "Entrar" e "Redefinir senha".',
        create_webhook: "Criar Webhook"
    },
    create_form: {
        title: "Criar Webhook",
        subtitle: "Adicione o Webhook para enviar uma solicita\xe7\xe3o POST para o URL do ponto final com detalhes de quaisquer eventos de usu\xe1rios.",
        events: "Eventos",
        events_description: "Selecione os eventos de gatilho nos quais o Logto enviar\xe1 a solicita\xe7\xe3o POST.",
        name: "Nome",
        name_placeholder: "Digite o nome do webhook",
        endpoint_url: "URL do ponto final",
        endpoint_url_placeholder: "https://seu.url.de.ponto.final/webhook",
        endpoint_url_tip: "Digite o URL do seu ponto final para onde o payload do webhook \xe9 enviado quando o evento ocorre.",
        create_webhook: "Criar webhook",
        missing_event_error: "Voc\xea deve selecionar pelo menos um evento."
    },
    webhook_created: "O webhook {{name}} foi criado com sucesso."
};
var $9773088a15479b8a$export$2e2bcd8739ae039 = Object.freeze($9773088a15479b8a$var$webhooks);


const $2712c64aced7ae5d$var$welcome = {
    title: "Bem-vindo a consola de Administrador",
    description: "A consola de Administrador \xe9 o lugar para gerenciar o Logto sem ter conhecimentos de programa\xe7\xe3o. Vamos primeiro criar uma conta. Com esta conta, pode gerir o Logto por conta pr\xf3pria ou em nome da empresa.",
    create_account: "Criar uma conta"
};
var $2712c64aced7ae5d$export$2e2bcd8739ae039 = Object.freeze($2712c64aced7ae5d$var$welcome);


const $73e42c2e2d7b67ea$var$admin_console = {
    title: "Consola de Administrador",
    admin_user: "Administrador",
    system_app: "Sistema",
    menu: $f1b5261c11bf693d$export$2e2bcd8739ae039,
    general: $043c37565054d343$export$2e2bcd8739ae039,
    errors: $00ec4053a5188396$export$2e2bcd8739ae039,
    tab_sections: $e7981729a3ac077e$export$2e2bcd8739ae039,
    tabs: $9212079ae02ece7a$export$2e2bcd8739ae039,
    applications: $6e7c2d8ac0f1c5e4$export$2e2bcd8739ae039,
    application_details: $4e327f63038cf33d$export$2e2bcd8739ae039,
    api_resources: $1cf528d35ada3d47$export$2e2bcd8739ae039,
    api_resource_details: $4df7152055ff2d20$export$2e2bcd8739ae039,
    connectors: $5334937af0a93153$export$2e2bcd8739ae039,
    connector_details: $b4365ee8e53812ef$export$2e2bcd8739ae039,
    enterprise_sso: $d37a50eb904ed3e4$export$2e2bcd8739ae039,
    enterprise_sso_details: $92a5e3c17e3231cb$export$2e2bcd8739ae039,
    get_started: $905e3736d98910de$export$2e2bcd8739ae039,
    users: $7ba7d38d0182dd7f$export$2e2bcd8739ae039,
    user_details: $b5c05928cb1040ea$export$2e2bcd8739ae039,
    contact: $23a6d5de37913b34$export$2e2bcd8739ae039,
    sign_in_exp: $45ff8ba62ad80a2c$export$2e2bcd8739ae039,
    dashboard: $c3fd889ba0c55bad$export$2e2bcd8739ae039,
    logs: $902ddf7fd3af446e$export$2e2bcd8739ae039,
    log_details: $441f492c696fb9ac$export$2e2bcd8739ae039,
    session_expired: $8499bc6149351224$export$2e2bcd8739ae039,
    welcome: $2712c64aced7ae5d$export$2e2bcd8739ae039,
    roles: $ce6b589be41833fd$export$2e2bcd8739ae039,
    role_details: $de930e174461f4b5$export$2e2bcd8739ae039,
    permissions: $071b115d1dc26817$export$2e2bcd8739ae039,
    cloud: $931fbb7f4906ead5$export$2e2bcd8739ae039,
    profile: $88f3449d8c84ff58$export$2e2bcd8739ae039,
    components: $1a888447f6d5e1aa$export$2e2bcd8739ae039,
    webhooks: $9773088a15479b8a$export$2e2bcd8739ae039,
    webhook_details: $8cb34095d6a2f654$export$2e2bcd8739ae039,
    domain: $fb2ec5a319517a89$export$2e2bcd8739ae039,
    tenants: $3a237c6a1cb18116$export$2e2bcd8739ae039,
    topbar: $d77743d942c94dce$export$2e2bcd8739ae039,
    subscription: $b81c304bcc3e27e4$export$2e2bcd8739ae039,
    upsell: $727215f85cbf0df4$export$2e2bcd8739ae039,
    guide: $c4ef79591767cf19$export$2e2bcd8739ae039,
    mfa: $f337ecfd376a99db$export$2e2bcd8739ae039,
    organizations: $ba04611337549547$export$2e2bcd8739ae039,
    organization_details: $4ec455c86a37f0fa$export$2e2bcd8739ae039
};
var $73e42c2e2d7b67ea$export$2e2bcd8739ae039 = Object.freeze($73e42c2e2d7b67ea$var$admin_console);


const $4c97a3cd2707fe32$var$demo_app = {
    title: "Iniciou sess\xe3o com sucesso na pr\xe9-visualiza\xe7\xe3o ao vivo!",
    subtitle: "Aqui est\xe3o as suas informa\xe7\xf5es de login:",
    username: "Utilizador: ",
    user_id: "ID de utilizador: ",
    sign_out: "Terminar sess\xe3o na visualiza\xe7\xe3o ao vivo",
    continue_explore: "Ou continue a explorar",
    customize_sign_in_experience: "Personalizar a experi\xeancia de login",
    enable_passwordless: "Ativar o login sem password (passwordless)",
    add_social_connector: "Adicionar conector social"
};
var $4c97a3cd2707fe32$export$2e2bcd8739ae039 = Object.freeze($4c97a3cd2707fe32$var$demo_app);


const $ad67388df94ccbf8$var$oidc = {
    logout_success: "Sess\xe3o terminada com sucesso."
};
var $ad67388df94ccbf8$export$2e2bcd8739ae039 = Object.freeze($ad67388df94ccbf8$var$oidc);


const $737f26273f973df7$var$translation = {
    admin_console: $73e42c2e2d7b67ea$export$2e2bcd8739ae039,
    demo_app: $4c97a3cd2707fe32$export$2e2bcd8739ae039,
    oidc: $ad67388df94ccbf8$export$2e2bcd8739ae039
};
var $737f26273f973df7$export$2e2bcd8739ae039 = Object.freeze($737f26273f973df7$var$translation);


const $e8f974b12583d91a$var$pt_pt = {
    translation: $737f26273f973df7$export$2e2bcd8739ae039,
    errors: $007704ca147ac61e$export$2e2bcd8739ae039
};
var $e8f974b12583d91a$export$2e2bcd8739ae039 = Object.freeze($e8f974b12583d91a$var$pt_pt);


const $5d9788dc2eb31743$var$application = {
    invalid_type: 'Только приложения типа "от машины к машине" могут иметь связанные роли.',
    role_exists: "Роль с идентификатором {{roleId}} уже добавлена в это приложение.",
    invalid_role_type: 'Невозможно назначить роль типа "пользователь" для приложения типа "от машины к машине".'
};
var $5d9788dc2eb31743$export$2e2bcd8739ae039 = Object.freeze($5d9788dc2eb31743$var$application);


const $945599e8707c1000$var$auth = {
    authorization_header_missing: "Отсутствует заголовок авторизации.",
    authorization_token_type_not_supported: "Тип авторизации не поддерживается.",
    unauthorized: "Не авторизованы. Пожалуйста, проверьте учетные данные и его область действия.",
    forbidden: "Запрещено. Пожалуйста, проверьте свои роли и разрешения пользователей.",
    expected_role_not_found: "Ожидаемая роль не найдена. Пожалуйста, проверьте свои роли и разрешения пользователей.",
    jwt_sub_missing: "Отсутствует `sub` в JWT.",
    require_re_authentication: "Для выполнения защищенного действия требуется повторная аутентификация."
};
var $945599e8707c1000$export$2e2bcd8739ae039 = Object.freeze($945599e8707c1000$var$auth);


const $7b85d5a0a921d779$var$connector = {
    general: "Ошибка произошла в коннекторе: {{errorDescription}}",
    not_found: "Не найден доступный коннектор для типа: {{type}}.",
    not_enabled: "Коннектор не включен.",
    invalid_metadata: "Метаданные коннектора недействительны.",
    invalid_config_guard: "Защита конфигурации коннектора недействительна.",
    unexpected_type: "Тип коннектора неожиданный.",
    invalid_request_parameters: "Запрос содержит неверный входной параметр (ы).",
    insufficient_request_parameters: "В запросе может не хватать некоторых входных параметров.",
    invalid_config: "Конфигурация коннектора недействительна.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "Ответ коннектора недействителен.",
    template_not_found: "Невозможно найти правильный шаблон в конфигурации коннектора.",
    template_not_supported: "Коннектор не поддерживает этот тип шаблона.",
    rate_limit_exceeded: "Превышен лимит запросов. Пожалуйста, попробуйте позже.",
    not_implemented: "{{method}}: еще не реализован.",
    social_invalid_access_token: "Токен доступа коннектора недействителен.",
    invalid_auth_code: "Код аутентификации коннектора недействителен.",
    social_invalid_id_token: "Токен идентификатора коннектора недействителен.",
    authorization_failed: "Процесс авторизации пользователя неудачный.",
    social_auth_code_invalid: "Не удалось получить токен доступа, проверьте код авторизации.",
    more_than_one_sms: "Количество SMS-коннекторов больше 1.",
    more_than_one_email: "Количество email-коннекторов больше 1.",
    more_than_one_connector_factory: "Обнаружено несколько фабрик коннекторов (с идентификаторами {{connectorIds}}), можно удалить ненужные.",
    db_connector_type_mismatch: "В базе данных есть коннектор, не соответствующий типу.",
    not_found_with_connector_id: "Не удается найти коннектор с заданным стандартным идентификатором коннектора.",
    multiple_instances_not_supported: "Нельзя создавать несколько экземпляров с выбранным стандартным коннектором.",
    invalid_type_for_syncing_profile: "Вы можете синхронизировать профиль пользователя только с социальными коннекторами.",
    can_not_modify_target: "Цель коннектора не может быть изменена.",
    should_specify_target: "Вы должны указать 'target'.",
    multiple_target_with_same_platform: "Вы не можете иметь несколько социальных коннекторов с одной и той же целью и платформой.",
    cannot_overwrite_metadata_for_non_standard_connector: "Метаданные этого коннектора не могут быть перезаписаны."
};
var $7b85d5a0a921d779$export$2e2bcd8739ae039 = Object.freeze($7b85d5a0a921d779$var$connector);


const $e60cf9d6625e5779$var$domain = {
    not_configured: "Провайдер доменных имен хоста не настроен.",
    cloudflare_data_missing: "cloudflare_data отсутствует, проверьте, пожалуйста.",
    cloudflare_unknown_error: "Получена неизвестная ошибка при запросе к API Cloudflare",
    cloudflare_response_error: "Получен неожиданный ответ от Cloudflare.",
    limit_to_one_domain: "Вы можете использовать только один пользовательский домен.",
    hostname_already_exists: "Этот домен уже существует на нашем сервере.",
    cloudflare_not_found: "Не удается найти имя хоста в Cloudflare"
};
var $e60cf9d6625e5779$export$2e2bcd8739ae039 = Object.freeze($e60cf9d6625e5779$var$domain);


const $521b7b2969c963b7$var$entity = {
    invalid_input: "Неверный ввод. Список значений не должен быть пустым.",
    create_failed: "Не удалось создать {{name}}.",
    db_constraint_violated: "Нарушено ограничение базы данных.",
    not_exists: "{{name}} не существует.",
    not_exists_with_id: "{{name}} с ID '{{id}}' не существует.",
    not_found: "Ресурс не существует.",
    relation_foreign_key_not_found: "Не удается найти один или несколько внешних ключей. Пожалуйста, проверьте ввод и убедитесь, что все ссылочные сущности существуют.",
    unique_integrity_violation: "Сущность уже существует. Пожалуйста, проверьте ввод и попробуйте снова."
};
var $521b7b2969c963b7$export$2e2bcd8739ae039 = Object.freeze($521b7b2969c963b7$var$entity);


const $83c4c0a9d033b9e7$var$guard = {
    invalid_input: "Запрос {{type}} неверный.",
    invalid_pagination: "Значение разбиения на страницы неверно.",
    can_not_get_tenant_id: "Невозможно получить идентификатор арендатора из запроса.",
    file_size_exceeded: "Превышен размер файла.",
    mime_type_not_allowed: "MIME-тип не разрешен."
};
var $83c4c0a9d033b9e7$export$2e2bcd8739ae039 = Object.freeze($83c4c0a9d033b9e7$var$guard);


const $c9e4107a0cf3747c$var$hook = {
    missing_events: "Вы должны предоставить как минимум одно событие.",
    send_test_payload_failed: "Не удалось отправить тестовую нагрузку: {{message}}",
    endpoint_responded_with_error: "Конечная точка ответила ошибкой."
};
var $c9e4107a0cf3747c$export$2e2bcd8739ae039 = Object.freeze($c9e4107a0cf3747c$var$hook);


const $51e599b2b814dfc3$var$localization = {
    cannot_delete_default_language: "{{languageTag}} установлен как язык по умолчанию и не может быть удален.",
    invalid_translation_structure: "Неверная структура данных. Пожалуйста, проверьте ввод и повторите попытку."
};
var $51e599b2b814dfc3$export$2e2bcd8739ae039 = Object.freeze($51e599b2b814dfc3$var$localization);


const $1f41eefa92ad1c1b$var$log = {
    invalid_type: "Тип журнала недействительный."
};
var $1f41eefa92ad1c1b$export$2e2bcd8739ae039 = Object.freeze($1f41eefa92ad1c1b$var$log);


const $28bb11972c42f846$var$oidc = {
    aborted: "Конечный пользователь прервал взаимодействие.",
    invalid_scope: "Недопустимая область: {{error_description}}.",
    invalid_token: "Недействительный токен.",
    invalid_client_metadata: "Недопустимые метаданные клиента.",
    insufficient_scope: "Отсутствует область токена `{{scope}}`.",
    invalid_request: "Недопустимый запрос.",
    invalid_grant: "Недопустимый запрос на предоставление прав.",
    invalid_redirect_uri: "redirect_uri не соответствует ни одному зарегистрированному redirect_uris клиента.",
    access_denied: "Доступ запрещен.",
    invalid_target: "Недопустимый указатель ресурса.",
    unsupported_grant_type: "Запрошенный grant_type не поддерживается.",
    unsupported_response_mode: "Запрошенный response_mode не поддерживается.",
    unsupported_response_type: "Запрошенный response_type не поддерживается.",
    provider_error: "Внутренняя ошибка OIDC: {{message}}.",
    server_error: "Произошла неизвестная ошибка OIDC. Пожалуйста, попробуйте снова позже.",
    provider_error_fallback: "Произошла ошибка OIDC: {{code}}.",
    key_required: "Требуется как минимум один ключ.",
    key_not_found: "Ключ с идентификатором {{id}} не найден."
};
var $28bb11972c42f846$export$2e2bcd8739ae039 = Object.freeze($28bb11972c42f846$var$oidc);


const $b9c242502222af11$var$organization = {
    require_membership: "Пользователь должен быть участником организации, чтобы продолжить."
};
var $b9c242502222af11$export$2e2bcd8739ae039 = Object.freeze($b9c242502222af11$var$organization);


const $08c359230aafe519$var$password = {
    unsupported_encryption_method: "Метод шифрования {{name}} не поддерживается.",
    pepper_not_found: "Не найден пепер пароля. Пожалуйста, проверьте ваши основные envs.",
    rejected: "Пароль отклонен. Пожалуйста, проверьте, соответствует ли ваш пароль требованиям."
};
var $08c359230aafe519$export$2e2bcd8739ae039 = Object.freeze($08c359230aafe519$var$password);


const $3b28a598573e03af$var$request = {
    invalid_input: "Неверный ввод. {{details}}",
    general: "Произошла ошибка запроса."
};
var $3b28a598573e03af$export$2e2bcd8739ae039 = Object.freeze($3b28a598573e03af$var$request);


const $d0df2bb6f052449e$var$resource = {
    resource_identifier_in_use: "Идентификатор API {{indicator}} уже используется"
};
var $d0df2bb6f052449e$export$2e2bcd8739ae039 = Object.freeze($d0df2bb6f052449e$var$resource);


const $d34ee24ebefd388d$var$role = {
    name_in_use: "Это имя роли {{name}} уже используется",
    scope_exists: "Идентификатор области действия {{scopeId}} уже был добавлен в эту роль",
    user_exists: "Идентификатор пользователя {{userId}} уже был добавлен в эту роль",
    application_exists: "Идентификатор приложения {{applicationId}} уже был добавлен в эту роль",
    default_role_missing: "Некоторые имена ролей по умолчанию отсутствуют в базе данных, пожалуйста, убедитесь в том, что сначала создали роли",
    internal_role_violation: 'Возможно, вы пытаетесь обновить или удалить внутреннюю роль, что запрещено Logto. Если вы создаете новую роль, попробуйте другое имя, которое не начинается с "#internal:".'
};
var $d34ee24ebefd388d$export$2e2bcd8739ae039 = Object.freeze($d34ee24ebefd388d$var$role);


const $d1ef4bdf1184d0ae$var$scope = {
    name_exists: "Имя области {{name}} уже используется",
    name_with_space: "Имя области не может содержать пробелы."
};
var $d1ef4bdf1184d0ae$export$2e2bcd8739ae039 = Object.freeze($d1ef4bdf1184d0ae$var$scope);


const $e8a6381b3a8054b1$var$session = {
    not_found: "Сессия не найдена. Вернитесь и войдите в систему снова.",
    invalid_credentials: "Неправильный аккаунт или пароль. Проверьте ввод.",
    invalid_sign_in_method: "Текущий метод входа в систему недоступен.",
    invalid_connector_id: "Не удалось найти доступный коннектор с идентификатором {{connectorId}}.",
    insufficient_info: "Недостаточно информации для входа в систему.",
    connector_id_mismatch: "Идентификатор коннектора не соответствует записи сессии.",
    connector_session_not_found: "Сессия коннектора не найдена. Вернитесь и войдите в систему снова.",
    verification_session_not_found: "Верификация не прошла успешно. Перезапустите процесс верификации и попробуйте еще раз.",
    verification_expired: "Соединение истекло. Повторите верификацию, чтобы обеспечить безопасность вашей учетной записи.",
    verification_blocked_too_many_attempts: "Слишком много попыток за короткое время. Пожалуйста, попробуйте снова {{relativeTime}}.",
    unauthorized: "Сначала войдите в систему.",
    unsupported_prompt_name: "Неподдерживаемое имя подсказки.",
    forgot_password_not_enabled: "Забыли пароль не включен.",
    verification_failed: "Верификация не прошла успешно. Перезапустите процесс верификации и попробуйте еще раз.",
    connector_validation_session_not_found: "Сеанс коннектора для проверки токена не найден.",
    identifier_not_found: "Идентификатор пользователя не найден. Вернитесь и войдите в систему снова.",
    interaction_not_found: "Сессия взаимодействия не найдена. Вернитесь и начните сессию заново.",
    not_supported_for_forgot_password: "Эта операция не поддерживается для забытого пароля.",
    mfa: {
        require_mfa_verification: "Требуется проверка MFA для входа в систему.",
        mfa_sign_in_only: "Mfa доступен только для взаимодействия при входе в систему.",
        pending_info_not_found: "Информация о ожидающем MFA не найдена, пожалуйста, сначала инициируйте MFA.",
        invalid_totp_code: "Недействительный код TOTP.",
        webauthn_verification_failed: " Проверка WebAuthn не удалась.",
        webauthn_verification_not_found: "Проверка WebAuthn не найдена.",
        bind_mfa_existed: "MFA уже существует.",
        backup_code_can_not_be_alone: "Резервный код не может быть единственным MFA.",
        backup_code_required: "Требуется резервный код.",
        invalid_backup_code: "Недействительный резервный код.",
        mfa_policy_not_user_controlled: "Политика многофакторной аутентификации не контролируется пользователем."
    },
    sso_enabled: "Единый вход в систему включен для этого указанного адреса электронной почты. Войдите в систему с помощью SSO."
};
var $e8a6381b3a8054b1$export$2e2bcd8739ae039 = Object.freeze($e8a6381b3a8054b1$var$session);


const $67b3330c215a36e6$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: 'Пустой URL-адрес контента "Условия использования". Пожалуйста, добавьте URL-адрес контента, если "Условия использования" включены.',
    empty_social_connectors: "Пустые социальные коннекторы. Пожалуйста, добавьте включенные социальные коннекторы, когда включен метод входа в систему через социальные сети.",
    enabled_connector_not_found: "Включенный коннектор {{type}} не найден.",
    not_one_and_only_one_primary_sign_in_method: "Должен быть один и только один первичный метод входа в систему. Пожалуйста, проверьте свой ввод.",
    username_requires_password: "Необходимо включить установку пароля для идентификатора создания имени пользователя.",
    passwordless_requires_verify: "Необходимо включить проверку для идентификатора создания учетной записи по электронной почте/телефону без пароля.",
    miss_sign_up_identifier_in_sign_in: "Методы входа в систему должны содержать идентификаторы создания учетной записи.",
    password_sign_in_must_be_enabled: "Вход в систему по паролю должен быть включен, когда для создания учетной записи требуется установка пароля.",
    code_sign_in_must_be_enabled: "Вход в систему по коду проверки должен быть включен, когда для создания учетной записи не требуется установка пароля.",
    unsupported_default_language: "Этот язык - {{language}} не поддерживается в данный момент.",
    at_least_one_authentication_factor: "Вы должны выбрать как минимум один фактор аутентификации.",
    backup_code_cannot_be_enabled_alone: "Резервный код не может быть включен самостоятельно.",
    duplicated_mfa_factors: "Факторы MFA не должны повторяться."
};
var $67b3330c215a36e6$export$2e2bcd8739ae039 = Object.freeze($67b3330c215a36e6$var$sign_in_experiences);


const $5fd304f57ed4cef8$var$single_sign_on = {
    forbidden_domains: "Недопустимы публичные домены электронной почты.",
    duplicated_domains: "Есть дублирующиеся домены.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $5fd304f57ed4cef8$export$2e2bcd8739ae039 = Object.freeze($5fd304f57ed4cef8$var$single_sign_on);


const $a353265b81d7e190$var$storage = {
    not_configured: "Провайдер хранилища не настроен.",
    missing_parameter: "Отсутствует параметр {{parameter}} для провайдера хранилища.",
    upload_error: "Не удалось загрузить файл в провайдер хранилища."
};
var $a353265b81d7e190$export$2e2bcd8739ae039 = Object.freeze($a353265b81d7e190$var$storage);


const $ee1fd4478a3aceb9$var$subscription = {
    limit_exceeded: "Вы достигли лимита вашего плана подписки.",
    get_plan_failed: "Не удалось получить план подписки для арендатора.",
    tenant_suspended: "Арендатор приостановлен. Пожалуйста, свяжитесь с администратором."
};
var $ee1fd4478a3aceb9$export$2e2bcd8739ae039 = Object.freeze($ee1fd4478a3aceb9$var$subscription);


const $4a034adc6ad498c2$var$swagger = {
    invalid_zod_type: "Неверный тип Zod. Пожалуйста, проверьте конфигурацию защиты маршрута.",
    not_supported_zod_type_for_params: "Неподдерживаемый тип Zod для параметров. Пожалуйста, проверьте конфигурацию защиты маршрута."
};
var $4a034adc6ad498c2$export$2e2bcd8739ae039 = Object.freeze($4a034adc6ad498c2$var$swagger);


const $764928866ff87690$var$user = {
    username_already_in_use: "Это имя пользователя уже используется.",
    email_already_in_use: "Этот адрес электронной почты связан с существующей учетной записью.",
    phone_already_in_use: "Этот номер телефона связан с существующей учетной записью.",
    invalid_email: "Некорректный адрес электронной почты.",
    invalid_phone: "Некорректный номер телефона.",
    email_not_exist: "Адрес электронной почты не зарегистрирован.",
    phone_not_exist: "Номер телефона не зарегистрирован.",
    identity_not_exist: "Учетная запись социальной сети не зарегистрирована.",
    identity_already_in_use: "Учетная запись в социальной сети связана с существующей учетной записью.",
    social_account_exists_in_profile: "Вы уже связали эту учетную запись с социальной сетью.",
    cannot_delete_self: "Вы не можете удалить свою собственную учетную запись.",
    sign_up_method_not_enabled: "Этот метод регистрации не включен.",
    sign_in_method_not_enabled: "Этот метод входа не включен.",
    same_password: "Новый пароль не может совпадать со старым паролем.",
    password_required_in_profile: "Вы должны установить пароль перед входом в систему.",
    new_password_required_in_profile: "Вы должны установить новый пароль.",
    password_exists_in_profile: "Пароль уже существует в вашем профиле.",
    username_required_in_profile: "Вы должны установить имя пользователя перед входом в систему.",
    username_exists_in_profile: "Имя пользователя уже существует в вашем профиле.",
    email_required_in_profile: "Вы должны добавить адрес электронной почты перед входом в систему.",
    email_exists_in_profile: "Ваш профиль уже связан с адресом электронной почты.",
    phone_required_in_profile: "Вы должны добавить номер телефона перед входом в систему.",
    phone_exists_in_profile: "Ваш профиль уже связан с номером телефона.",
    email_or_phone_required_in_profile: "Вы должны добавить адрес электронной почты или номер телефона перед входом в систему.",
    suspended: "Эта учетная запись приостановлена.",
    user_not_exist: "Пользователя с {{ identifier }} не существует.",
    missing_profile: "Вы должны предоставить дополнительную информацию перед входом в систему.",
    role_exists: "Идентификатор роли {{roleId}} уже добавлен в этого пользователя",
    invalid_role_type: "Недопустимый тип роли, роль машины к машине нельзя назначить пользователю.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $764928866ff87690$export$2e2bcd8739ae039 = Object.freeze($764928866ff87690$var$user);


const $ac15f7a78676af93$var$verification_code = {
    phone_email_empty: 'Оба поля "телефон" и "эл. почта" пустые.',
    not_found: "Код верификации не найден. Пожалуйста, сначала отправьте код верификации.",
    phone_mismatch: "Телефон не соответствует. Пожалуйста, запросите новый код верификации.",
    email_mismatch: "Эл. почта не соответствует. Пожалуйста, запросите новый код верификации.",
    code_mismatch: "Недействительный код верификации.",
    expired: "Срок действия кода верификации истек. Пожалуйста, запросите новый код верификации.",
    exceed_max_try: "Превышено ограничение на количество попыток ввода кода верификации. Пожалуйста, запросите новый код верификации."
};
var $ac15f7a78676af93$export$2e2bcd8739ae039 = Object.freeze($ac15f7a78676af93$var$verification_code);


const $448a66bb8e4ce6dc$var$errors = {
    request: $3b28a598573e03af$export$2e2bcd8739ae039,
    auth: $945599e8707c1000$export$2e2bcd8739ae039,
    guard: $83c4c0a9d033b9e7$export$2e2bcd8739ae039,
    oidc: $28bb11972c42f846$export$2e2bcd8739ae039,
    user: $764928866ff87690$export$2e2bcd8739ae039,
    password: $08c359230aafe519$export$2e2bcd8739ae039,
    session: $e8a6381b3a8054b1$export$2e2bcd8739ae039,
    connector: $7b85d5a0a921d779$export$2e2bcd8739ae039,
    verification_code: $ac15f7a78676af93$export$2e2bcd8739ae039,
    sign_in_experiences: $67b3330c215a36e6$export$2e2bcd8739ae039,
    localization: $51e599b2b814dfc3$export$2e2bcd8739ae039,
    swagger: $4a034adc6ad498c2$export$2e2bcd8739ae039,
    entity: $521b7b2969c963b7$export$2e2bcd8739ae039,
    log: $1f41eefa92ad1c1b$export$2e2bcd8739ae039,
    role: $d34ee24ebefd388d$export$2e2bcd8739ae039,
    scope: $d1ef4bdf1184d0ae$export$2e2bcd8739ae039,
    storage: $a353265b81d7e190$export$2e2bcd8739ae039,
    resource: $d0df2bb6f052449e$export$2e2bcd8739ae039,
    hook: $c9e4107a0cf3747c$export$2e2bcd8739ae039,
    domain: $e60cf9d6625e5779$export$2e2bcd8739ae039,
    subscription: $ee1fd4478a3aceb9$export$2e2bcd8739ae039,
    application: $5d9788dc2eb31743$export$2e2bcd8739ae039,
    organization: $b9c242502222af11$export$2e2bcd8739ae039,
    single_sign_on: $5fd304f57ed4cef8$export$2e2bcd8739ae039
};
var $448a66bb8e4ce6dc$export$2e2bcd8739ae039 = Object.freeze($448a66bb8e4ce6dc$var$errors);


const $42bf930587fa99e3$var$api_resource_details = {
    page_title: "Детали ресурса API",
    back_to_api_resources: "Вернуться к Ресурсам API",
    settings_tab: "Настройки",
    permissions_tab: "Разрешения",
    settings: "Настройки",
    settings_description: "Ресурсы API, также известные как индикаторы ресурсов, указывают целевые службы или ресурсы, запрашиваемые обычно в виде переменной формата URI, представляющей идентификатор ресурса.",
    management_api_settings_description: "Logto Management API - это комплексный набор API, который дает администраторам возможность управлять широким спектром задач, связанных с идентификацией, обеспечивать политику безопасности и соблюдать требования и стандарты.",
    management_api_notice: "Этот API представляет сущность Logto и не может быть изменен или удален. Вы можете использовать управляющий API для широкого спектра задач, связанных с идентификацией. <a>Узнать больше</a>",
    token_expiration_time_in_seconds: "Время истечения токена (в секундах)",
    token_expiration_time_in_seconds_placeholder: "Введите время истечения вашего токена",
    delete_description: "Это действие нельзя отменить. Оно навсегда удалит ресурс API. Пожалуйста, введите имя ресурса API <span> {{имя}} </span>, чтобы подтвердить.",
    enter_your_api_resource_name: "Введите название своего ресурса API",
    api_resource_deleted: "Ресурс API {{name}} был успешно удален",
    permission: {
        create_button: "Создать разрешение",
        create_title: "Создать разрешение",
        create_subtitle: "Определите необходимые разрешения (области) для этого API.",
        confirm_create: "Создать разрешение",
        name: "Название разрешения",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "Название разрешения не должно содержать пробелов.",
        description: "Описание",
        description_placeholder: "Можно читать ресурсы",
        permission_created: "Разрешение {{название}} создано успешно",
        delete_description: "Если это разрешение будет удалено, пользователь, у которого оно было, потеряет доступ, предоставленный им.",
        deleted: 'Разрешение "{{название}}" успешно удалено.'
    }
};
var $42bf930587fa99e3$export$2e2bcd8739ae039 = Object.freeze($42bf930587fa99e3$var$api_resource_details);


const $6d2489cce682df18$var$api_resources = {
    page_title: "Ресурсы API",
    title: "Ресурсы API",
    subtitle: "Определите API, которые могут использовать ваши авторизованные приложения",
    create: "Создать ресурс API",
    api_name: "Название API",
    api_name_placeholder: "Введите название вашего API",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Уникальный идентификатор для ресурса API. Он должен быть абсолютным URI и не иметь фрагмента (#). Равен параметру <a>resource</a> в OAuth 2.0.",
    default_api: "API по умолчанию",
    default_api_label: "В каждом арендаторе может быть только один API по умолчанию. Когда устанавливается API по умолчанию, можно опустить параметр <a>resource</a> в запросе на аутентификацию. Последующие запросы на обмен токенами будут использовать указанное API в качестве аудитории по умолчанию, что приведет к выдаче JWT. <a>Узнать больше</a>",
    api_resource_created: "Ресурс API {{name}} был успешно создан"
};
var $6d2489cce682df18$export$2e2bcd8739ae039 = Object.freeze($6d2489cce682df18$var$api_resources);


const $d9d2a40229c00103$var$application_details = {
    page_title: "Детали приложения",
    back_to_applications: "Вернуться к приложениям",
    check_guide: "Проверить гид",
    settings: "Настройки",
    settings_description: "Приложения используются для идентификации ваших приложений в Logto для OIDC, опыта входа, аудита и т. Д.",
    advanced_settings: "Расширенные настройки",
    advanced_settings_description: "Расширенные настройки включают связанные с OIDC термины. Вы можете проверить конечную точку токена для получения дополнительной информации.",
    application_roles: "Роли",
    machine_logs: "Машинные журналы",
    application_name: "Название приложения",
    application_name_placeholder: "Мое приложение",
    description: "Описание",
    description_placeholder: "Введите описание своего приложения",
    config_endpoint: "Конечная точка конфигурации OpenID Provider",
    authorization_endpoint: "Конечная точка авторизации",
    authorization_endpoint_tip: "Конечная точка для аутентификации и авторизации. Он используется для аутентификации <a>OpenID Connect</a>.",
    logto_endpoint: "Logto endpoint",
    application_id: "ID приложения",
    application_id_tip: "Уникальный идентификатор приложения, обычно генерируемый Logto. Он также означает \xab<a>client_id</a>\xbb в OpenID Connect.",
    application_secret: "Секрет приложения",
    redirect_uri: "URI перенаправления",
    redirect_uris: "URI перенаправления",
    redirect_uri_placeholder: "https://ваш.вебсайт.com/приложение",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "URI перенаправляется после входа пользователя (успешного или нет). См. OpenID Connect <a>AuthRequest</a> для получения дополнительной информации.",
    post_sign_out_redirect_uri: "URI перенаправления после выхода из системы",
    post_sign_out_redirect_uris: "URI перенаправления после выхода из системы",
    post_sign_out_redirect_uri_placeholder: "https://ваш.вебсайт.com/домашняя страница",
    post_sign_out_redirect_uri_tip: "URI перенаправляется после выхода пользователя (необязательно). Это может не иметь практического эффекта в некоторых типах приложений.",
    cors_allowed_origins: "Разрешенные источники CORS",
    cors_allowed_origins_placeholder: "https://ваш.вебсайт.com",
    cors_allowed_origins_tip: "По умолчанию разрешены все источники URI перенаправления. Обычно для этого поля не требуется никаких действий. См. <a>Документацию MDN</a> для получения подробной информации.",
    token_endpoint: "Конечная точка токена",
    user_info_endpoint: "Конечная точка информации о пользователе",
    enable_admin_access: "Включить доступ администратора",
    enable_admin_access_label: "Включить или отключить доступ к API управления. После включения вы можете использовать токены доступа для вызова API управления от имени этого приложения.",
    always_issue_refresh_token: "Всегда выдавать Refresh Token",
    always_issue_refresh_token_label: "Включение этой настройки позволит Logto всегда выдавать Refresh Tokens, независимо от того, была ли в запросе на аутентификацию предложена команда `prompt=consent`. Однако данная практика не рекомендуется, если это необходимо, поскольку она несовместима с OpenID Connect и может вызвать проблемы.",
    refresh_token_ttl: "Time to Live (TTL) Refresh Token в днях",
    refresh_token_ttl_tip: "Продолжительность, на протяжении которой Refresh Token может использоваться для запроса новых токенов доступа, прежде чем он истечет и станет недействительным. Запросы токенов будут продлевать TTL Refresh Token до этого значения.",
    rotate_refresh_token: "Поворот Refresh Token",
    rotate_refresh_token_label: "При включении Logto будет выдавать новый Refresh Token для запросов токенов, когда пройдет 70% изначального Time to Live (TTL) или будут выполнены определенные условия. <a>Узнать больше</a>",
    delete_description: "Это действие нельзя отменить. Оно навсегда удалит приложение. Введите название приложения <span> {{name}} </span>, чтобы подтвердить.",
    enter_your_application_name: "Введите название своего приложения",
    application_deleted: "Приложение {{name}} успешно удалено",
    redirect_uri_required: "Вы должны ввести по крайней мере один URI перенаправления",
    roles: {
        name_column: "Роль",
        description_column: "Описание",
        assign_button: "Назначить роли",
        delete_description: "This action will remove this role from this machine-to-machine app. The role itself will still exist, but it will no longer be associated with this machine-to-machine app.",
        deleted: "{{name}} успешно удалено у этого пользователя.",
        assign_title: "Назначить роли для {{name}}",
        assign_subtitle: "Авторизовать {{name}} одну или несколько ролей",
        assign_role_field: "Назначить роли",
        role_search_placeholder: "Поиск по названию роли",
        added_text: "{{value, number}} добавлено",
        assigned_app_count: "{{value, number}} приложений",
        confirm_assign: "Назначить роли",
        role_assigned: "Роль(и) успешно назначены",
        search: "Поиск по названию роли, описанию или ID",
        empty: "Нет доступных ролей"
    }
};
var $d9d2a40229c00103$export$2e2bcd8739ae039 = Object.freeze($d9d2a40229c00103$var$application_details);


const $a80d8263c523d774$var$applications = {
    page_title: "Заявки",
    title: "Заявки",
    subtitle: "Настроить аутентификацию Logto для вашего нативного, одностраничного, машина-машина или традиционного приложения.",
    subtitle_with_app_type: "Настроить аутентификацию Logto для вашего приложения {{name}}",
    create: "Создать заявку",
    application_name: "Название приложения",
    application_name_placeholder: "Мое приложение",
    application_description: "Описание приложения",
    application_description_placeholder: "Введите описание вашего приложения",
    select_application_type: "Выбрать тип приложения",
    no_application_type_selected: "Вы еще не выбрали тип приложения",
    application_created: "Приложение успешно создано.",
    app_id: "App ID",
    type: {
        native: {
            title: "Нативное приложение",
            subtitle: "Приложение, работающее в нативной среде",
            description: "Например, приложение для iOS, приложение для Android"
        },
        spa: {
            title: "Одностраничное приложение",
            subtitle: "Приложение, работающее в веб-браузере и динамически обновляющее данные на месте",
            description: "Например, приложение React DOM, приложение Vue"
        },
        traditional: {
            title: "Традиционный веб",
            subtitle: "Приложение, которое отображает и обновляет страницы только веб-сервером",
            description: "Например, Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Приложение (обычно сервис), которое напрямую общается с ресурсами",
            description: "Например, backend-сервис"
        }
    },
    placeholder_title: "Выберите тип приложения, чтобы продолжить",
    placeholder_description: "Logto использует сущность приложения для OIDC для выполнения задач, таких как идентификация ваших приложений, управление входом в систему и создание журналов аудита."
};
var $a80d8263c523d774$export$2e2bcd8739ae039 = Object.freeze($a80d8263c523d774$var$applications);


const $5dd037e429574e3d$var$cloud = {
    general: {
        onboarding: "Вводный курс"
    },
    welcome: {
        page_title: "Добро пожаловать",
        title: "Добро пожаловать в облако Logto! Мы хотели бы узнать вас получше.",
        description: "Сделайте свой опыт работы с Logto уникальным для вас, узнав вас получше. Ваша информация надежно защищена.",
        project_field: "Я использую Logto для",
        project_options: {
            personal: "Личного проекта",
            company: "Компании"
        },
        title_field: "Выберите соответствующие должности",
        title_options: {
            developer: "Разработчик",
            team_lead: "Лидер команды",
            ceo: "Генеральный директор",
            cto: "Технический директор",
            product: "Продукт",
            others: "Другие"
        },
        company_name_field: "Название компании",
        company_name_placeholder: "Acme.co",
        company_size_field: "Какой у вас размер компании?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Я подписываюсь потому, что",
        reason_options: {
            passwordless: "Ищу безопасную аутентификацию без пароля и набор компонентов пользовательского интерфейса",
            efficiency: "Пытаюсь найти готовую инфраструктуру идентификации",
            access_control: "Хочу контролировать доступ пользователей на основе ролей и обязанностей",
            multi_tenancy: "Ищу стратегии для продукта с несколькими арендаторами",
            enterprise: "Ищу решения для одиночного входа (SSO) для компаний",
            others: "Другие"
        }
    },
    sie: {
        page_title: "Настройка опыта входа",
        title: "Давайте сначала легко настроим ваш опыт входа",
        inspire: {
            title: "Создайте убедительные примеры",
            description: "Чувствуете неуверенность в опыте входа? Просто нажмите \xabВдохновить меня\xbb и позвольте волшебству совершиться!",
            inspire_me: "Вдохнови меня"
        },
        logo_field: "Логотип приложения",
        color_field: "Цвет бренда",
        identifier_field: "Идентификатор",
        identifier_options: {
            email: "Электронная почта",
            phone: "Номер телефона",
            user_name: "Имя пользователя"
        },
        authn_field: "Аутентификация",
        authn_options: {
            password: "Пароль",
            verification_code: "Код подтверждения"
        },
        social_field: "Вход через социальную сеть",
        finish_and_done: "Готово",
        preview: {
            mobile_tab: "Мобильный",
            web_tab: "Веб"
        },
        connectors: {
            unlocked_later: "Разблокируется позже",
            unlocked_later_tip: "После того, как вы завершите процесс ввода в эксплуатацию и войдете в продукт, вы получите доступ к еще большему количеству методов входа через социальные сети.",
            notice: "Пожалуйста, не используйте демонстрационный коннектор для производственных целей. После тестирования удалите демонстрационный коннектор и настройте свой собственный коннектор с вашими учетными данными."
        }
    },
    socialCallback: {
        title: "Вход выполнен успешно",
        description: "Вы успешно вошли, используя свою учетную запись в социальной сети. Чтобы обеспечить безпроблемную интеграцию и доступ ко всем функциям Logto, рекомендуем настроить свой собственный социальный коннектор."
    },
    tenant: {
        create_tenant: "Создать арендатора"
    }
};
var $5dd037e429574e3d$export$2e2bcd8739ae039 = Object.freeze($5dd037e429574e3d$var$cloud);


const $3e43b0846c4622f9$var$components = {
    uploader: {
        action_description: "Перетащите или выберите файл",
        uploading: "Загрузка...",
        image_limit: "Загрузите изображение размером менее {{size, number}} КБ, только {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_upload: "Что-то пошло не так. Загрузка файла не удалась.",
        error_file_size: "Размер файла слишком большой. Пожалуйста, загрузите файл размером менее {{size, number}} КБ.",
        error_file_type: "Тип файла не поддерживается. Допустимы только файлы типа {{extensions, list(style: narrow; type: conjunction;)}}.",
        error_file_count: "Вы можете загрузить только 1 файл."
    }
};
var $3e43b0846c4622f9$export$2e2bcd8739ae039 = Object.freeze($3e43b0846c4622f9$var$components);


const $bc2f0c9b165b947e$var$connector_details = {
    page_title: "Детали подключения",
    back_to_connectors: "Вернуться к подключениям",
    check_readme: "Проверить README",
    settings: "Общие настройки",
    settings_description: "Коннекторы играют критическую роль в Logto. С их помощью, Logto позволяет конечным пользователям использовать беспарольную регистрацию или вход и возможности входа с социальными аккаунтами.",
    parameter_configuration: "Конфигурация параметра",
    test_connection: "Тестирование",
    save_error_empty_config: "Пожалуйста, введите конфигурацию",
    send: "Отправить",
    send_error_invalid_format: "Неверный ввод",
    edit_config_label: "Введите ваш JSON здесь",
    test_email_sender: "Протестируйте ваш электронный коннектор",
    test_sms_sender: "Протестируйте ваш SMS коннектор",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+1 555-123-4567",
    test_message_sent: "Тестовое сообщение отправлено",
    test_sender_description: 'Logto использует шаблон "Общий" для тестирования. Вы получите сообщение, если ваш коннектор правильно настроен.',
    options_change_email: "Изменить электронный коннектор",
    options_change_sms: "Изменить SMS коннектор",
    connector_deleted: "Коннектор успешно удален",
    type_email: "Электронный коннектор",
    type_sms: "SMS коннектор",
    type_social: "Социальный коннектор",
    in_used_social_deletion_description: "Этот коннектор используется в вашем опыте входа в систему. При удалении опыт входа в систему <name/> будет удален в настройках опыта входа в систему. Вы должны повторно настроить его, если решите добавить его обратно.",
    in_used_passwordless_deletion_description: "Этот {{name}} используется в вашем опыте входа в систему. При удалении опыт входа в систему не будет работать правильно, пока не будет решен конфликт. Вы должны повторно настроить его, если решите добавить его обратно.",
    deletion_description: "Вы удаляете этот коннектор. Он не может быть отменен, и вы должны повторно настроить его, если решите добавить его обратно.",
    logto_email: {
        total_email_sent: "Всего отправлено электронных писем: {{value, number}}",
        total_email_sent_tip: "Logto использует SendGrid для безопасной и стабильной встроенной электронной почты. Полностью бесплатно. <a>Узнать больше</a>",
        email_template_title: "Шаблон электронной почты",
        template_description: "Встроенная электронная почта использует шаблоны по умолчанию для безшовной доставки писем с подтверждением. Никакой дополнительной настройки не требуется, и вы можете настроить базовую информацию о бренде.",
        template_description_link_text: "Просмотреть шаблоны",
        description_action_text: "Просмотреть шаблоны",
        from_email_field: "Отправитель",
        sender_name_field: "Имя отправителя",
        sender_name_tip: 'Настройте имя отправителя для электронных писем. Если оставить пустым, будет использоваться "Verification" в качестве имени по умолчанию.',
        sender_name_placeholder: "Введите имя отправителя здесь",
        company_information_field: "Информация о компании",
        company_information_description: "Отображайте имя вашей компании, адрес или почтовый код внизу электронных писем, чтобы улучшить подлинность.",
        company_information_placeholder: "Основная информация о вашей компании",
        app_logo_field: "Логотип приложения",
        app_logo_tip: "Отобразите логотип вашего бренда в верхней части электронных писем. Используйте одно и то же изображение для светлого и темного режимов.",
        urls_not_allowed: "URL-адреса не разрешены",
        test_notes: 'Logto использует шаблон "Общий" для тестирования.'
    }
};
var $bc2f0c9b165b947e$export$2e2bcd8739ae039 = Object.freeze($bc2f0c9b165b947e$var$connector_details);


const $aa5ed361a97b9217$var$connectors = {
    page_title: "Коннекторы",
    title: "Коннекторы",
    subtitle: "Настройте коннекторы, чтобы включить опыт без пароля и социального входа в систему",
    create: "Добавить социальный коннектор",
    config_sie_notice: "Вы настроили коннекторы. Убедитесь, что вы настроили их в <a>{{link}}</a>.",
    config_sie_link_text: "опыте входа в систему",
    tab_email_sms: "Коннекторы электронной почты и SMS",
    tab_social: "Социальные коннекторы",
    connector_name: "Имя коннектора",
    demo_tip: "Максимальное количество сообщений для этого демонстрационного коннектора ограничено 100 и не рекомендуется для развертывания в производственной среде.",
    social_demo_tip: "Демонстрационный коннектор предназначен исключительно для демонстрационных целей и не рекомендуется для развертывания в производственной среде.",
    connector_type: "Тип",
    connector_status: "Опыт входа в систему",
    connector_status_in_use: "Используется",
    connector_status_not_in_use: "Не используется",
    not_in_use_tip: {
        content: "Не используется означает, что ваш опыт входа в систему не использовал этот метод входа. <a>{{link}}</a>, чтобы добавить этот метод входа.",
        go_to_sie: "Перейти к опыту входа в систему"
    },
    placeholder_title: "Социальный коннектор",
    placeholder_description: "Logto предоставляет множество широко используемых коннекторов для входа через социальные сети, в то время как вы можете создать свой с помощью стандартных протоколов.",
    save_and_done: "Сохранить и завершить",
    type: {
        email: "Коннектор электронной почты",
        sms: "Коннектор SMS",
        social: "Социальный коннектор"
    },
    setup_title: {
        email: "Настройка коннектора электронной почты",
        sms: "Настройка коннектора SMS",
        social: "Добавить социальный коннектор"
    },
    guide: {
        subtitle: "Пошаговое руководство по настройке вашего коннектора",
        general_setting: "Общие настройки",
        parameter_configuration: "Конфигурация параметров",
        test_connection: "Тестовое соединение",
        name: "Имя для кнопки входа через социальные сети",
        name_placeholder: "Введите имя для кнопки входа через социальные сети",
        name_tip: 'Имя кнопки коннектора будет отображаться как "Продолжить с {{name}}". Будьте внимательны к длине названия, в случае, если оно станет слишком длинным.',
        logo: "URL логотипа для кнопки входа через социальные сети",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Логотип будет отображаться на коннекторе. Получите публично доступную ссылку на изображение и вставьте ссылку сюда.",
        logo_dark: "URL логотипа для кнопки входа через социальные сети (Темный режим)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Установите логотип коннектора для темного режима после его включения в опыте входа в систему в Административной консоли.",
        logo_dark_collapse: "Свернуть",
        logo_dark_show: "Показать настройки логотипа для темного режима",
        target: "Имя поставщика идентификации",
        target_placeholder: "Введите имя поставщика идентификации коннектора",
        target_tip: "Значение \xabНазвание поставщика идентификации\xbb может быть строкой уникального идентификатора, чтобы отличать ваших социальных пользователей.",
        target_tip_standard: "Значение \xabНазвание поставщика идентификации\xbb может быть строкой уникального идентификатора, чтобы отличать ваших социальных пользователей. Эта настройка не может быть изменена после создания коннектора.",
        target_tooltip: '"Название поставщика идентификации" в социальных коннекторах Logto относится к "источнику" ваших социальных пользователей. В дизайне Logto мы не принимаем то же самое "название поставщика идентификации" для определенной платформы, чтобы избежать конфликтов. Вы должны быть очень внимательны, прежде чем добавлять коннектор, так как вы НЕ МОЖЕТЕ изменить его значение после создания. <a>Узнать больше</a>',
        target_conflict: "Введенное имя поставщика идентификации совпадает с существующим коннектором <span>name</span>. Использование того же имени поставщика идентификации может вызвать неожиданное поведение входа в систему, когда пользователи могут получить доступ к одной учетной записи через два разных коннектора.",
        target_conflict_line2: "Если вы хотите заменить текущий коннектор на тот же поставщик идентификации и разрешить предыдущим пользователям войти без регистрации заново, удалите коннектор <span>name</span> и создайте новый с тем же \xabНазванием поставщика идентификации\xbb.",
        target_conflict_line3: "Если вы хотите подключиться к другому поставщику идентификации, измените \xabНазвание поставщика идентификации\xbb и продолжайте.",
        config: "Введите свой JSON-конфиг",
        sync_profile: "Синхронизировать информацию профиля",
        sync_profile_only_at_sign_up: "Синхронизировать только при регистрации",
        sync_profile_each_sign_in: "Всегда синхронизировать при каждом входе",
        sync_profile_tip: "Синхронизируйте базовый профиль из социального провайдера, такой как имена пользователей и их аватары.",
        callback_uri: "URI обратного вызова",
        callback_uri_description: "Также называется URI перенаправления, это URI в Logto, на который пользователи будут отправлены после социальной авторизации. Скопируйте и вставьте его на странице настройки социального провайдера."
    },
    platform: {
        universal: "Универсальная",
        web: "Web",
        native: "Мобильное приложение"
    },
    add_multi_platform: "поддерживает несколько платформ, выберите платформу для продолжения",
    drawer_title: "Руководство Коннектора",
    drawer_subtitle: "Следуйте инструкциям, чтобы интегрировать свой коннектор",
    unknown: "Неизвестный коннектор",
    standard_connectors: "стандартные разъемы"
};
var $aa5ed361a97b9217$export$2e2bcd8739ae039 = Object.freeze($aa5ed361a97b9217$var$connectors);


const $88d09b2c32a5f205$var$contact = {
    title: "Получить помощь",
    description: "Для запросов на помощь и отзывов о продукте, свяжитесь с нами через следующие методы.",
    discord: {
        title: "Присоединиться к сообществу Discord",
        description: "Свяжитесь с другими разработчиками, чтобы найти решения",
        button: "Присоединиться"
    },
    github: {
        title: "Общение на GitHub",
        description: "Создайте проблему и отправьте на GitHub",
        button: "Открыть"
    },
    email: {
        title: "Связаться с поддержкой по электронной почте",
        description: "Отправьте нам электронное письмо для получения дополнительной информации и помощи",
        button: "Отправить"
    },
    reserve: {
        title: "Запишитесь на встречу с командой Logto",
        description: "Быстро запишитесь на сессию для онлайн-чата",
        button: "Записаться"
    }
};
var $88d09b2c32a5f205$export$2e2bcd8739ae039 = Object.freeze($88d09b2c32a5f205$var$contact);


const $49b6e3cc2607e8a1$var$dashboard = {
    page_title: "Dashboard",
    title: "Dashboard",
    description: "Получите обзор о производительности вашего приложения",
    total_users: "Всего пользователей",
    total_users_tip: "Всего пользователей",
    new_users_today: "Новые пользователи сегодня",
    new_users_today_tip: "Количество новых пользователей, зарегистрировавшихся сегодня в вашем приложении",
    new_users_7_days: "Новые пользователи за последние 7 дней",
    new_users_7_days_tip: "Количество новых пользователей, зарегистрировавшихся за последние 7 дней в вашем приложении",
    daily_active_users: "Ежедневные активные пользователи",
    daily_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении сегодня",
    weekly_active_users: "Еженедельные активные пользователи",
    weekly_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении за последние 7 дней",
    monthly_active_users: "Ежемесячные активные пользователи",
    monthly_active_users_tip: "Количество уникальных пользователей, обменивающих токены в вашем приложении за последние 30 дней"
};
var $49b6e3cc2607e8a1$export$2e2bcd8739ae039 = Object.freeze($49b6e3cc2607e8a1$var$dashboard);


const $fefd766af01ac721$var$domain = {
    status: {
        connecting: "Соединение",
        in_used: "Используется",
        failed_to_connect: "Не удалось соединиться"
    },
    update_endpoint_notice: "Не забудьте обновить домен для обратного вызова социального коннектора и конечной точки Logto в вашем приложении, если вы хотите использовать пользовательский домен для функций. <a>{{link}}</a>",
    error_hint: "Убедитесь, что вы обновили свои DNS записи. Мы будем проверять каждые {{value}} секунд.",
    custom: {
        custom_domain: "Пользовательский домен",
        custom_domain_description: "Улучшите свой брендинг, используя пользовательский домен. Этот домен будет использоваться в вашем процессе входа.",
        custom_domain_field: "Пользовательский домен",
        custom_domain_placeholder: "Ваш.домен.com",
        add_domain: "Добавить домен",
        invalid_domain_format: "Некорректный формат поддомена. Введите поддомен с минимум 3 секциями.",
        verify_domain: "Проверить домен",
        enable_ssl: "Включить SSL",
        checking_dns_tip: "После настройки DNS, процесс запустится автоматически и может занять до 24-х часов. Вы можете выйти из этого интерфейса во время его работы.",
        enable_ssl_tip: "Включение SSL запустится автоматически и может занять до 24-х часов. Вы можете выйти из этого интерфейса во время его работы.",
        generating_dns_records: "Генерация DNS записей...",
        add_dns_records: "Пожалуйста, добавьте следующие DNS-записи в Ваш DNS-провайдер.",
        dns_table: {
            type_field: "Тип",
            name_field: "Имя",
            value_field: "Значение"
        },
        deletion: {
            delete_domain: "Удалить домен",
            reminder: "Удалить пользовательский домен",
            description: "Вы уверены, что хотите удалить этот пользовательский домен?",
            in_used_description: 'Вы уверены, что хотите удалить этот пользовательский домен "<span>{{domain}}</span>"?',
            in_used_tip: 'Если ранее вы настраивали этот пользовательский домен в своём провайдере социальных коннекторов или конечной точке приложения, вам нужно сначала изменить URI на домен по умолчанию Logto "<span>{{domain}}</span>". Это необходимо для правильной работы кнопки социальной авторизации.',
            deleted: "Пользовательский домен успешно удалён!"
        }
    },
    default: {
        default_domain: "Домен по умолчанию",
        default_domain_description: "Logto предлагает предварительно настроенный домен по умолчанию, готовый к использованию без дополнительной настройки. Этот домен по умолчанию служит как резервный вариант, даже если вы включили пользовательский домен.",
        default_domain_field: "Домен по умолчанию Logto"
    },
    custom_endpoint_note: 'Вы можете настроить имя домена этих конечных точек по своему усмотрению. Выберите "{{custom}}" или "{{default}}".',
    custom_social_callback_url_note: 'Вы можете настроить имя домена этого URI, чтобы соответствовать конечной точке вашего приложения. Выберите "{{custom}}" или "{{default}}".'
};
var $fefd766af01ac721$export$2e2bcd8739ae039 = Object.freeze($fefd766af01ac721$var$domain);


const $7d3ceff92c61f4a1$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $7d3ceff92c61f4a1$export$2e2bcd8739ae039 = Object.freeze($7d3ceff92c61f4a1$var$enterprise_sso_details);


const $025301a0a72bd9ca$var$enterprise_sso = {
    page_title: "Единый вход в предприятие",
    title: "Единый вход в предприятие",
    subtitle: "Подключите поставщика идентификации предприятия и включите одностороннюю аутентификацию с инициацией службы.",
    create: "Добавить предприятий коннектор",
    col_connector_name: "Имя коннектора",
    col_type: "Тип",
    col_email_domain: "Домен электронной почты",
    placeholder_title: "Коннектор предприятия",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Добавить коннектор предприятия",
        text_divider: "Или вы можете настроить свой коннектор по стандартному протоколу.",
        connector_name_field_title: "Имя коннектора",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Создать коннектор"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $025301a0a72bd9ca$export$2e2bcd8739ae039 = Object.freeze($025301a0a72bd9ca$var$enterprise_sso);


const $f8914647627897e5$var$errors = {
    something_went_wrong: "Упс! Что-то пошло не так.",
    page_not_found: "Страница не найдена",
    unknown_server_error: "Произошла неизвестная ошибка сервера",
    empty: "Нет данных",
    missing_total_number: "Не удалось найти Total-Number в заголовках ответа",
    invalid_uri_format: "Неверный формат URI",
    invalid_origin_format: "Неверный формат URI-оригинала",
    invalid_json_format: "Неверный формат JSON",
    invalid_error_message_format: "Неверный формат сообщения об ошибке.",
    required_field_missing: "Пожалуйста, введите {{field}}",
    required_field_missing_plural: "Вы должны ввести хотя бы одно {{field}}",
    more_details: "Больше информации",
    username_pattern_error: "Имя пользователя должно состоять только из букв, цифр или подчеркивания и не должно начинаться с цифры.",
    email_pattern_error: "Адрес электронной почты недействителен.",
    phone_pattern_error: "Номер телефона недействителен.",
    insecure_contexts: "Небезопасные контексты (нет HTTPS) не поддерживаются.",
    unexpected_error: "Произошла непредвиденная ошибка.",
    not_found: "404 не найдено",
    create_internal_role_violation: 'Вы создаете новую внутреннюю роль, что запрещено Logto. Попробуйте другое имя, которое не начинается с "#internal:".',
    should_be_an_integer: "Должно быть целым числом.",
    number_should_be_between_inclusive: "Тогда число должно быть между {{min}} и {{max}} (включительно)."
};
var $f8914647627897e5$export$2e2bcd8739ae039 = Object.freeze($f8914647627897e5$var$errors);


const $34d7f5470b98864b$var$general = {
    placeholder: "Заполнитель",
    submit: "Отправить",
    skip: "Пропустить",
    next: "Следующий",
    back: "Назад",
    retry: "Повторить попытку",
    done: "Готово",
    search: "Поиск",
    search_placeholder: "Поиск",
    clear_result: "Очистить результаты",
    save: "Сохранить",
    save_changes: "Сохранить изменения",
    saved: "Сохранено",
    discard: "Отказаться",
    loading: "Загрузка...",
    redirecting: "Перенаправление...",
    add: "Добавить",
    added: "Добавлено",
    cancel: "Отмена",
    confirm: "Подтвердить",
    check_out: "Оформить заказ",
    create: "Создать",
    set_up: "Настроить",
    customize: "Настроить",
    enable: "Включить",
    reminder: "Напоминание",
    delete: "Удалить",
    more_options: "Дополнительные опции",
    close: "Закрыть",
    copy: "Копировать",
    copying: "Копирование",
    copied: "Скопировано",
    required: "Обязательное",
    add_another: "Добавить ещё",
    create_another: "Создать ещё",
    deletion_confirmation: "Вы действительно хотите удалить этот {{title}}?",
    settings_nav: "Настройки",
    unsaved_changes_warning: "Вы внесли изменения. Вы действительно хотите покинуть эту страницу?",
    leave_page: "Покинуть страницу",
    stay_on_page: "Остаться на странице",
    type_to_search: "Введите для поиска",
    got_it: "Понятно",
    continue: "Продолжить",
    page_info: "{{min, number}}-{{max, number}} из {{total, number}}",
    learn_more: "Узнать больше",
    tab_errors: "{{count, number}} ошибок",
    skip_for_now: "Пропустить",
    remove: "Удалить",
    visit: "Посетить",
    join: "Присоединиться",
    try_now: "Попробуйте сейчас",
    multiple_form_field: "(Несколько)",
    demo: "Демо",
    unnamed: "Без названия",
    view: "Просмотр",
    hide: "Скрыть",
    unknown_error: "Неизвестная ошибка, пожалуйста, попробуйте позже.",
    select: "Выбрать",
    contact_us_action: "Связаться с нами",
    description: "Описание",
    name: "Имя",
    add_field: "Добавить {{field}}",
    create_field: "Создать {{field}}",
    edit_field: "Изменить {{field}}",
    delete_field: "Удалить {{field}}",
    coming_soon: "Скоро",
    beta_notice: "\uD83C\uDF89  {{feature}} сейчас находится в бета-тестировании. Добро пожаловать, чтобы изучить его и <ContactLink>поделиться своими отзывами</ContactLink>."
};
var $34d7f5470b98864b$export$2e2bcd8739ae039 = Object.freeze($34d7f5470b98864b$var$general);


const $1c06f165e95701c5$var$get_started = {
    page_title: "Начало работы",
    title: "Что-то, что поможет вам добиться успеха",
    subtitle: "Несколько вещей, которые вы можете сделать, чтобы быстро получить ценность от Logto",
    develop: {
        title: "Develop: Вам понадобится 5 минут, чтобы интегрировать ваше приложение"
    },
    customize: {
        title: "Customize: Создайте отличный вариант входа в систему",
        preview: {
            title: "Проверьте прямую трансляцию присоединения к системе, которое вы только что настроили",
            subtitle: "Попробуйте пробный вариант входа в систему Logto, чтобы узнать, как это работает"
        },
        connector: {
            title: "Добавьте больше коннекторов, чтобы поддерживать больше способов входа через социальные сети",
            subtitle: "Попробуйте вход без пароля и включите защищенный и плавный опыт для ваших клиентов"
        },
        continue_customizing: "Продолжайте настройку",
        try_now: "Попробуйте сейчас",
        add_more: "Добавьте еще"
    },
    secure: {
        title: "Secure: Защитите свои ресурсы"
    },
    manage: {
        title: "Manage: Определите контроль доступа для вашего продукта и пользователей",
        rbac: {
            title: "Добавьте контроль доступа на основе ролей, чтобы защитить ваши ресурсы",
            subtitle: "Управляйте вашим ресурсом через масштабируемую авторизацию ролей для различных случаев использования"
        },
        create_roles: "Создать роли"
    },
    view_all: "Посмотреть все →"
};
var $1c06f165e95701c5$export$2e2bcd8739ae039 = Object.freeze($1c06f165e95701c5$var$get_started);


const $9b4d121a5b0261d2$var$guide = {
    start_building: "Начать строить",
    get_started: "Начать",
    categories: {
        featured: "Популярные и для вас",
        Traditional: "Традиционное веб-приложение",
        SPA: "Одностраничное приложение",
        Native: "Нативное",
        MachineToMachine: "Машина к машине"
    },
    filter: {
        title: "Фильтры фреймворков",
        placeholder: "Поиск фреймворка"
    },
    checkout_tutorial: "Посмотреть руководство по {{name}}",
    do_not_need_tutorial: "Если вам не нужно руководство, вы можете продолжить без руководства по фреймворку",
    finish_and_done: "Завершить и закончить",
    cannot_find_guide: "Не удается найти ваше руководство?",
    describe_guide_looking_for: "Опишите руководство, которое вы ищете",
    request_guide_successfully: "Ваш запрос был успешно отправлен. Спасибо!",
    app: {
        select_framework_or_tutorial: "Выберите фреймворк или руководство",
        guide_modal_title: "Начните с SDK и руководств",
        modal_subtitle: "Ускорьте процесс разработки приложения с нашими готовыми SDK и руководствами.",
        select_a_framework: "Выберите фреймворк",
        continue_without_framework: "Создайте приложение без фреймворка",
        describe_guide_looking_for_placeholder: "Например, я хочу интегрировать Logto в мое Angular приложение."
    },
    api: {
        modal_title: "Начните с руководств",
        modal_subtitle: "Ускорьте процесс разработки приложения с нашими готовыми руководствами.",
        select_a_tutorial: "Выберите руководство",
        continue_without_tutorial: "Продолжить без руководства",
        describe_guide_looking_for_placeholder: "Например, я хочу защитить мое API с помощью deno."
    }
};
var $9b4d121a5b0261d2$export$2e2bcd8739ae039 = Object.freeze($9b4d121a5b0261d2$var$guide);


const $7da8192d3c82b67a$var$log_details = {
    page_title: "Детали журнала аудита",
    back_to_logs: "Назад к журналу аудита",
    back_to: "Назад к {{name}}",
    success: "Успешно",
    failed: "Не удалось",
    event_key: "Ключ события",
    application: "Приложение",
    ip_address: "IP адрес",
    user: "Пользователь",
    log_id: "ID журнала",
    time: "Время",
    user_agent: "User agent",
    tab_details: "Детали",
    raw_data: "Raw data"
};
var $7da8192d3c82b67a$export$2e2bcd8739ae039 = Object.freeze($7da8192d3c82b67a$var$log_details);


const $cf5d86e9f4feffe0$var$logs = {
    page_title: "Записи аудита",
    title: "Записи аудита",
    subtitle: "Просмотр данных журнала событий аутентификации, сделанных вашими пользователями",
    event: "Событие",
    user: "Пользователь",
    application: "Приложение",
    time: "Время",
    filter_by: "Фильтр по"
};
var $cf5d86e9f4feffe0$export$2e2bcd8739ae039 = Object.freeze($cf5d86e9f4feffe0$var$logs);


const $dbe4c124e03d26fd$var$menu = {
    profile: "Профиль",
    language: "Язык",
    appearance: {
        label: "Внешний вид",
        light: "Светлый режим",
        dark: "Темный режим",
        system: "Синхронизация с системой"
    },
    sign_out: "Выйти"
};
var $dbe4c124e03d26fd$export$2e2bcd8739ae039 = Object.freeze($dbe4c124e03d26fd$var$menu);


const $d3cef5033da689e2$var$mfa = {
    title: "Многократная аутентификация",
    description: "Добавьте многократную аутентификацию, чтобы повысить безопасность вашего опыта входа в систему.",
    factors: "Факторы",
    multi_factors: "Множественные факторы",
    multi_factors_description: "Пользователям необходимо проверить один из включенных факторов для двухэтапной верификации.",
    totp: "OTP приложения аутентификации",
    otp_description: "Привяжите Google Authenticator и др., чтобы проверять одноразовые пароли.",
    webauthn: "WebAuthn (Пароль)",
    webauthn_description: "Проверьте через метод, поддерживаемый браузером: биометрия, сканирование телефона или ключ безопасности и т.д.",
    webauthn_native_tip: "WebAuthn не поддерживается для приложений Native.",
    webauthn_domain_tip: "WebAuthn привязывает открытые ключи к конкретному домену. Изменение домена службы блокирует пользователей от аутентификации через существующие пароли.",
    backup_code: "Резервный код",
    backup_code_description: "Генерируйте 10 одноразовых резервных кодов после настройки любого метода MFA.",
    backup_code_setup_hint: "Когда пользователи не могут проверить вышеупомянутые факторы MFA, используйте резервный вариант.",
    backup_code_error_hint: "Для использования резервного кода вам нужен как минимум еще один метод MFA для успешной аутентификации пользователя.",
    policy: "Политика",
    policy_description: "Установите политику MFA для процессов входа и регистрации.",
    two_step_sign_in_policy: "Политика двухэтапной верификации при входе",
    user_controlled: "Пользователи могут самостоятельно включать или отключать MFA",
    user_controlled_tip: "Пользователи могут пропустить настройку MFA при первом входе или регистрации, либо включить/отключить его в настройках учетной записи.",
    mandatory: "Пользователям всегда нужно использовать MFA при входе",
    mandatory_tip: "Пользователи должны настроить MFA при первом входе или регистрации и использовать его для всех последующих входов."
};
var $d3cef5033da689e2$export$2e2bcd8739ae039 = Object.freeze($d3cef5033da689e2$var$mfa);


const $8f7f7530246cdae6$var$organization_details = {
    page_title: "Детали организации",
    delete_confirmation: "После удаления все участники потеряют свою членство и роли в данной организации. Это действие нельзя отменить.",
    organization_id: "Идентификатор организации",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Название организации, не обязательно должно быть уникальным.",
    description_placeholder: "Описание организации.",
    member: "Участник",
    member_other: "Участники",
    add_members_to_organization: "Добавить участников в организацию {{name}}",
    add_members_to_organization_description: "Найдите подходящих пользователей, выполнив поиск по имени, электронной почте, телефону или идентификатору пользователя. Существующие участники не отображаются в результатах поиска.",
    add_with_organization_role: "Добавить с ролями организации",
    user: "Пользователь",
    authorize_to_roles: "Разрешить {{name}} доступ к следующим ролям:",
    edit_organization_roles: "Редактирование ролей организации",
    edit_organization_roles_of_user: "Редактирование ролей организации для {{name}}",
    remove_user_from_organization: "Удалить пользователя из организации",
    remove_user_from_organization_description: "После удаления пользователь потеряет свое членство и роли в этой организации. Это действие нельзя отменить.",
    search_user_placeholder: "Поиск по имени, электронной почте, телефону или идентификатору пользователя",
    at_least_one_user: "Необходимо указать хотя бы одного пользователя."
};
var $8f7f7530246cdae6$export$2e2bcd8739ae039 = Object.freeze($8f7f7530246cdae6$var$organization_details);


const $fb124789fe0348d1$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Организации",
    title: "Организации",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "Идентификатор организации",
    members: "Участники",
    create_organization: "Создать организацию",
    setup_organization: "Настройка вашей организации",
    organization_list_placeholder_title: "Организация",
    organization_list_placeholder_text: 'Организация обычно используется в приложениях с мультиарендой или похожих на мультиаренду SaaS. Функция "Организации" позволяет вашим B2B-клиентам лучше управлять своими партнерами и клиентами, а также настраивать способы доступа конечных пользователей к их приложениям.',
    organization_name_placeholder: "Моя организация",
    organization_description_placeholder: "Краткое описание организации",
    organization_permission: "Разрешение организации",
    organization_permission_other: "Разрешения организации",
    organization_permission_description: "Разрешение организации относится к разрешению доступа к ресурсу в контексте организации. Разрешение организации должно быть представлено в виде осмысленной строки и также служить именем и уникальным идентификатором.",
    organization_permission_delete_confirm: "Если это разрешение будет удалено, все роли организации, включая это разрешение, потеряют это разрешение, и пользователи, у которых было это разрешение, потеряют предоставленный им доступ к нему.",
    create_permission_placeholder: "Чтение истории назначений",
    permission: "Разрешение",
    permission_other: "Разрешения",
    organization_role: "Роль организации",
    organization_role_other: "Роли организации",
    organization_role_description: "Роль организации - это группировка разрешений, которые могут быть назначены пользователям. Разрешения должны быть взяты из предопределенных разрешений организации.",
    organization_role_delete_confirm: "При этом будут удалены разрешения, связанные с этой ролью, у затронутых пользователей, и будут удалены отношения между ролями организации, участниками в организации и разрешениями организации.",
    role: "Роль",
    create_role_placeholder: "Пользователи с правами только для просмотра",
    search_placeholder: "Поиск по названию организации или ID",
    search_permission_placeholder: "Начните вводить для поиска и выбора разрешений",
    search_role_placeholder: "Начните вводить для поиска и выбора ролей",
    empty_placeholder: "\uD83E\uDD14 У вас пока нет никаких {{entity}}.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Начать с руководств",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Взаимодействие с иллюстрацией для просмотра связей",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Шаг 1: Определите разрешения организаций",
        step_2: "Шаг 2: Определите роли организаций",
        step_3: "Шаг 3: Создайте свою первую организацию",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $fb124789fe0348d1$export$2e2bcd8739ae039 = Object.freeze($fb124789fe0348d1$var$organizations);


const $452ff9555603c24e$var$permissions = {
    search_placeholder: "Поиск по имени API или разрешению",
    search_placeholder_without_api: "Поиск по наименованию разрешения",
    name_column: "Разрешение",
    description_column: "Описание",
    api_column: "API",
    placeholder_title: "Разрешение",
    placeholder_description: "Разрешение относится к авторизации доступа к ресурсу (мы называем это ресурсом API)."
};
var $452ff9555603c24e$export$2e2bcd8739ae039 = Object.freeze($452ff9555603c24e$var$permissions);


const $a8521441abd3111d$var$profile = {
    page_title: "Настройки аккаунта",
    title: "Настройки аккаунта",
    description: "Измените настройки своего аккаунта и управляйте своей личной информацией здесь, чтобы обеспечить безопасность своего аккаунта.",
    settings: {
        title: "Настройки профиля",
        profile_information: "Информация профиля",
        avatar: "Аватар",
        name: "Имя",
        username: "Имя пользователя"
    },
    link_account: {
        title: "СВЯЗАТЬ АККАУНТ",
        email_sign_in: "Войти по электронной почте",
        email: "Электронная почта",
        social_sign_in: "Войти через социальные сети",
        link_email: "Связать адрес электронной почты",
        link_email_subtitle: "Свяжите свою электронную почту для входа или помощи в восстановлении аккаунта.",
        email_required: "Адрес электронной почты обязателен",
        invalid_email: "Неправильный адрес электронной почты",
        identical_email_address: "Введенный адрес электронной почты идентичен текущему",
        anonymous: "Анонимный"
    },
    password: {
        title: "ПАРОЛЬ И БЕЗОПАСНОСТЬ",
        password: "Пароль",
        password_setting: "Настройка пароля",
        new_password: "Новый пароль",
        confirm_password: "Подтвердите пароль",
        enter_password: "Введите текущий пароль",
        enter_password_subtitle: "Для защиты безопасности вашей учетной записи подтвердите, что это вы. Пожалуйста, введите ваш текущий пароль перед изменением.",
        set_password: "Установить пароль",
        verify_via_password: "Проверить через пароль",
        show_password: "Показать пароль",
        required: "Пароль обязателен",
        do_not_match: "Пароли не совпадают. Попробуйте еще раз."
    },
    code: {
        enter_verification_code: "Введите код подтверждения",
        enter_verification_code_subtitle: "Код подтверждения был отправлен на <strong>{{target}}</strong>",
        verify_via_code: "Проверить через код подтверждения",
        resend: "Повторно отправить код подтверждения",
        resend_countdown: "Отправить повторно через {{countdown}} секунд"
    },
    delete_account: {
        title: "УДАЛИТЬ АККАУНТ",
        label: "Удалить аккаунт",
        description: "Удаление вашего аккаунта приведет к удалению всей вашей личной информации, пользовательских данных и конфигураций. Это действие нельзя будет отменить.",
        button: "Удалить аккаунт",
        dialog_paragraph_1: "Мы сожалеем, что вы хотите удалить свой аккаунт. Удаление вашего аккаунта навсегда удалит всю информацию, включая данные пользователя, журналы и настройки, и это действие нельзя будет отменить. Пожалуйста, сделайте резервную копию важных данных перед продолжением.",
        dialog_paragraph_2: "Чтобы продолжить процесс удаления аккаунта, отправьте электронное письмо в нашу службу поддержки на адрес <a>{{mail}}</a> с темой \xabЗапрос на удаление аккаунта\xbb. Мы поможем и убедимся в правильном удалении всех ваших данных из нашей системы.",
        dialog_paragraph_3: "Благодарим вас за выбор облачного сервиса Logto. Если у вас есть какие-либо дополнительные вопросы или проблемы, не стесняйтесь обращаться к нам."
    },
    set: "Установить",
    change: "Изменить",
    link: "Связать",
    unlink: "Разъединить",
    not_set: "Не установлено",
    change_avatar: "Изменить аватар",
    change_name: "Изменить имя",
    change_username: "Изменить имя пользователя",
    set_name: "Установить имя",
    email_changed: "Адрес электронной почты изменен.",
    password_changed: "Пароль изменен.",
    updated: "{{target}} обновлен.",
    linked: "{{target}} связан.",
    unlinked: "{{target}} разъединен.",
    email_exists_reminder: "Этот адрес электронной почты {{email}} связан с существующим аккаунтом. Свяжите другой адрес электронной почты здесь.",
    unlink_confirm_text: "Да, разъединить",
    unlink_reminder: "Пользователи не смогут войти в аккаунт с помощью <span></span> , если вы его отсоедините. Вы уверены, что хотите продолжить?"
};
var $a8521441abd3111d$export$2e2bcd8739ae039 = Object.freeze($a8521441abd3111d$var$profile);


const $8e40a6e6c63fa343$var$role_details = {
    back_to_roles: "Назад к Ролям",
    identifier: "Идентификатор",
    delete_description: "Это действие удалит все соответствующие разрешения данной роли у затронутых пользователей и удалит отображение между ролями, пользователями и разрешениями.",
    role_deleted: "{{name}} был успешно удален.",
    settings_tab: "Настройки",
    users_tab: "Пользователи",
    m2m_apps_tab: "Машинные приложения",
    permissions_tab: "Разрешения",
    settings: "Настройки",
    settings_description: "Роли - это группировка разрешений, которые могут быть назначены пользователям. Они также обеспечивают способ объединения разрешений, определенных для разных API, что делает более эффективным добавление, удаление или корректировку разрешений по сравнению с назначением их отдельно пользователям.",
    field_name: "Имя",
    field_description: "Описание",
    type_m2m_role_tag: "Роль машинного приложения",
    type_user_role_tag: "Роль пользователя",
    permission: {
        assign_button: "Назначить Разрешения",
        assign_title: "Назначить разрешения",
        assign_subtitle: "Назначить разрешения этой роли. Роли будут получать добавленные разрешения, а пользователи с этой ролью будут наследовать эти разрешения.",
        assign_form_field: "Назначить разрешения",
        added_text_one: "{{count, number}} разрешение добавлено",
        added_text_other: "{{count, number}} разрешений добавлено",
        api_permission_count_one: "{{count, number}} разрешение",
        api_permission_count_other: "{{count, number}} разрешений",
        confirm_assign: "Назначить Разрешения",
        permission_assigned: "Выбранные разрешения были успешно назначены этой роли",
        deletion_description: "Если это право будет удалено, затронутый пользователь с этой ролью потеряет доступ, предоставленный этим разрешением.",
        permission_deleted: 'Разрешение "{{name}}" было успешно удалено из этой роли',
        empty: "Нет доступных разрешений"
    },
    users: {
        assign_button: "Назначить Пользователей",
        name_column: "Пользователь",
        app_column: "Приложение",
        latest_sign_in_column: "Последняя авторизация",
        delete_description: "Это действие приведет к потере авторизации на эту роль, но пользователь останется в вашем пуле пользователей.",
        deleted: "{{name}} был успешно удален из этой роли",
        assign_title: "Назначить пользователей",
        assign_subtitle: "Назначить пользователей на эту роль. Найдите подходящих пользователей, используя поиск по имени, электронной почте, номеру телефона или идентификатору пользователя.",
        assign_field: "Назначить пользователей",
        confirm_assign: "Назначить пользователей",
        assigned_toast_text: "The selected users were successfully assigned to this role",
        empty: "Нет доступных пользователей"
    },
    applications: {
        assign_button: "Назначить приложения",
        name_column: "Приложение",
        app_column: "Приложения",
        description_column: "Описание",
        delete_description: "Оно останется в вашем пуле приложений, но потеряет авторизацию для этой роли.",
        deleted: "{{name}} был успешно удален из этой роли",
        assign_title: "Назначить приложения",
        assign_subtitle: "Назначить приложения на эту роль. Найдите подходящие приложения, используя поиск по имени, описанию или идентификатору приложения.",
        assign_field: "Назначить приложения",
        confirm_assign: "Назначить приложения",
        assigned_toast_text: "The selected applications were successfully assigned to this role",
        empty: "Нет доступных приложений"
    }
};
var $8e40a6e6c63fa343$export$2e2bcd8739ae039 = Object.freeze($8e40a6e6c63fa343$var$role_details);


const $38997c8a80a09625$var$roles = {
    page_title: "Роли",
    title: "Роли",
    subtitle: "Роли включают права доступа, которые определяют, что может делать пользователь. RBAC использует роли для предоставления пользователям доступа к ресурсам для конкретных действий.",
    create: "Создать роль",
    role_name: "Имя роли",
    role_type: "Тип роли",
    show_role_type_button_text: "Показать дополнительные варианты",
    hide_role_type_button_text: "Скрыть дополнительные варианты",
    type_user: "Роль пользователя",
    type_machine_to_machine: "Роль приложения между машинами",
    role_description: "Описание",
    role_name_placeholder: "Введите название роли",
    role_description_placeholder: "Введите описание роли",
    col_roles: "Роли",
    col_type: "Тип",
    col_description: "Описание",
    col_assigned_entities: "Назначенные",
    user_counts: "{{count}} пользователей",
    application_counts: "{{count}} приложений",
    user_count: "{{count}} пользователь",
    application_count: "{{count}} приложение",
    assign_permissions: "Назначить права доступа",
    create_role_title: "Создать роль",
    create_role_description: "Создание и управление ролями для ваших приложений. Роли содержат коллекции прав доступа и могут быть назначены пользователям.",
    create_role_button: "Создать роль",
    role_created: 'Роль "{{name}}" успешно создана.',
    search: "Поиск по названию роли, описанию или ID",
    placeholder_title: "Роли",
    placeholder_description: "Роли являются группировкой разрешений, которые могут быть назначены пользователям. Необходимо добавить разрешения, прежде чем создать роли."
};
var $38997c8a80a09625$export$2e2bcd8739ae039 = Object.freeze($38997c8a80a09625$var$roles);


const $b128f638cb0f65b5$var$session_expired = {
    title: "Истекло время сеанса",
    subtitle: "Ваш сеанс, возможно, истек и вы были отключены. Нажмите кнопку ниже, чтобы снова войти в консоль администратора.",
    button: "Войти снова"
};
var $b128f638cb0f65b5$export$2e2bcd8739ae039 = Object.freeze($b128f638cb0f65b5$var$session_expired);


const $bb6d4e760f8415fa$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $bb6d4e760f8415fa$export$2e2bcd8739ae039 = Object.freeze($bb6d4e760f8415fa$var$content);


const $d4ec09e0444829a0$var$password_policy = {
    password_requirements: "Требования к паролю",
    minimum_length: "Минимальная длина",
    minimum_length_description: "NIST предлагает использовать <a>не менее 8 символов</a> для веб-продуктов.",
    minimum_length_error: "Минимальная длина должна быть от {{min}} до {{max}} (включительно).",
    minimum_required_char_types: "Минимальное количество типов символов",
    minimum_required_char_types_description: "Типы символов: прописные (A-Z), строчные (a-z), цифры (0-9) и специальные символы ({{symbols}}).",
    password_rejection: "Отклонение пароля",
    compromised_passwords: "Отклонить скомпрометированный пароль",
    breached_passwords: "Сломанные пароли",
    breached_passwords_description: "Отвергнуть пароли, найденные ранее в базах данных нарушений.",
    restricted_phrases: "Ограничение низкобезопасных фраз",
    restricted_phrases_tooltip: "Ваш пароль должен избегать эти фразы, если не сопровождаются еще 3 или более символами.",
    repetitive_or_sequential_characters: "Повторяющиеся или последовательные символы",
    repetitive_or_sequential_characters_description: 'Например, "AAAA", "1234" и "abcd".',
    user_information: "Информация пользователя",
    user_information_description: "Например, адрес электронной почты, номер телефона, имя пользователя и т.д.",
    custom_words: "Пользовательские слова",
    custom_words_description: "Персонализируйте слова, специфичные для контекста, без учета регистра, одно на строку.",
    custom_words_placeholder: "Имя вашей службы, название компании и т. д."
};
var $d4ec09e0444829a0$export$2e2bcd8739ae039 = Object.freeze($d4ec09e0444829a0$var$password_policy);


const $2048f759da31b01a$var$sign_up_and_sign_in = {
    identifiers_email: "Адрес электронной почты",
    identifiers_phone: "Номер телефона",
    identifiers_username: "Имя пользователя",
    identifiers_email_or_sms: "Адрес электронной почты или номер телефона",
    identifiers_none: "Не применимо",
    and: "и",
    or: "или",
    sign_up: {
        title: "РЕГИСТРАЦИЯ",
        sign_up_identifier: "Идентификатор регистрации",
        identifier_description: "Идентификатор регистрации необходим для создания учетной записи и должен быть включен на экране входа в систему.",
        sign_up_authentication: "Настройки аутентификации для регистрации",
        authentication_description: "Все выбранные действия будут обязательны для выполнения пользователем.",
        set_a_password_option: "Создайте пароль",
        verify_at_sign_up_option: "Подтвердить при регистрации",
        social_only_creation_description: "(Применяется только к созданию учетной записи в социальных сетях)"
    },
    sign_in: {
        title: "ВХОД",
        sign_in_identifier_and_auth: "Идентификатор и настройки аутентификации для входа",
        description: "Пользователи могут войти, используя любой из доступных вариантов. Настройте расположение, перетаскивая ниже указанные опции.",
        add_sign_in_method: "Добавить способ входа",
        password_auth: "Пароль",
        verification_code_auth: "Код подтверждения",
        auth_swap_tip: "Переставьте варианты ниже, чтобы определить, какой появится первым в потоке.",
        require_auth_factor: "Вы должны выбрать хотя бы один фактор аутентификации."
    },
    social_sign_in: {
        title: "ВХОД С ПОМОЩЬЮ СОЦИАЛЬНЫХ СЕТЕЙ",
        social_sign_in: "Вход через социальные сети",
        description: "В зависимости от обязательного идентификатора, который вы настроили, ваш пользователь может быть попрошен предоставить идентификатор при регистрации через социальный коннектор.",
        add_social_connector: "Добавить социальный коннектор",
        set_up_hint: {
            not_in_list: "Не найден в списке?",
            set_up_more: "Настроить",
            go_to: "другие социальные коннекторы."
        }
    },
    tip: {
        set_a_password: "Уникальный пароль для вашего имени пользователя является обязательным.",
        verify_at_sign_up: "В настоящее время мы поддерживаем только подтвержденный электронный адрес. Ваша база пользователей может содержать большое количество адресов электронной почты низкого качества, если не производится проверка.",
        password_auth: "Это необходимо, так как вы включили опцию установки пароля в процессе регистрации.",
        verification_code_auth: "Это необходимо, так как вы включили только опцию предоставления кода подтверждения при регистрации. Вы можете снять флажок, когда установка пароля разрешена в процессе регистрации.",
        delete_sign_in_method: "Это необходимо, так как вы выбрали {{identifier}} в качестве обязательного идентификатора."
    },
    advanced_options: {
        title: "ДОПОЛНИТЕЛЬНЫЕ ОПЦИИ",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Включить регистрацию пользователей",
        enable_user_registration_description: "Включить или запретить регистрацию пользователей. После отключения пользователи все еще могут быть добавлены через консоль администратора, но пользователи больше не могут создавать учетные записи через пользовательский интерфейс регистрации."
    }
};
var $2048f759da31b01a$export$2e2bcd8739ae039 = Object.freeze($2048f759da31b01a$var$sign_up_and_sign_in);


const $89a0e1b121a7f9f2$var$sign_in_exp = {
    page_title: "Опыт входа в систему",
    title: "Опыт входа в систему",
    description: "Настройте пользовательский интерфейс входа в систему в соответствии с вашим брендом и просматривайте в режиме реального времени",
    tabs: {
        branding: "Брендирование",
        sign_up_and_sign_in: "Регистрация и вход в систему",
        content: "Содержание",
        password_policy: "Политика пароля"
    },
    welcome: {
        title: "Настройка входа в систему",
        description: "Начните быстро с настройки первого входа в систему. Это руководство поможет вам пройти все необходимые настройки.",
        get_started: "Начать",
        apply_remind: "Обратите внимание, что опыт входа в систему будет применяться для всех приложений в этой учетной записи."
    },
    color: {
        title: "ЦВЕТ",
        primary_color: "Цвет бренда",
        dark_primary_color: "Цвет бренда (темный)",
        dark_mode: "Включить темный режим",
        dark_mode_description: "Ваше приложение будет иметь автоматически созданную темную тему на основе цвета вашего бренда и алгоритма Logto. Вы можете настроить ее по своему вкусу.",
        dark_mode_reset_tip: "Пересчитать цвет темного режима на основе цвета бренда.",
        reset: "Пересчитать"
    },
    branding: {
        title: "ЗОНА БРЕНДИНГА",
        ui_style: "Стиль",
        favicon: "Фавикон",
        logo_image_url: "URL изображения логотипа приложения",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "URL изображения логотипа приложения (темный)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Логотип приложения",
        dark_logo_image: "Логотип приложения (темный)",
        logo_image_error: "Ошибка логотипа приложения: {{error}}",
        favicon_error: "Ошибка фавикона: {{error}}"
    },
    custom_css: {
        title: "Пользовательский CSS",
        css_code_editor_title: "Настройте ваш пользовательский интерфейс с помощью пользовательского CSS",
        css_code_editor_description1: "Смотрите пример пользовательского CSS.",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "Подробнее",
        css_code_editor_content_placeholder: "Введите ваш пользовательский CSS, чтобы настроить стили для чего-угодно в соответствии с вашими требованиями. Выражайте свою креативность и выделяйте свой пользовательский интерфейс."
    },
    sign_up_and_sign_in: $2048f759da31b01a$export$2e2bcd8739ae039,
    content: $bb6d4e760f8415fa$export$2e2bcd8739ae039,
    password_policy: $d4ec09e0444829a0$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "Еще не настроен коннектор SMS. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в \xabКоннекторах\xbb",
        no_connector_email: "Еще не настроен коннектор по электронной почте. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в \xabКоннекторах\xbb",
        no_connector_social: 'Вы еще не настроили социальный коннектор. Сначала добавьте коннекторы, чтобы применить методы социальной авторизации. <a>{{link}}</a> в разделе "Коннекторы".',
        setup_link: "Настройка"
    },
    save_alert: {
        description: "Вы внедряете новые процедуры входа и регистрации. Все ваши пользователи могут быть затронуты новой настройкой. Вы точно хотите внести изменения?",
        before: "До",
        after: "После",
        sign_up: "Регистрация",
        sign_in: "Вход",
        social: "Социальный"
    },
    preview: {
        title: "Предварительный просмотр входа в систему",
        live_preview: "Прямой эфир",
        live_preview_tip: "Сохранить для просмотра изменений",
        native: "Нативный",
        desktop_web: "Веб на рабочем столе",
        mobile_web: "Мобильный веб",
        desktop: "Рабочий стол",
        mobile: "Мобильный"
    }
};
var $89a0e1b121a7f9f2$export$2e2bcd8739ae039 = Object.freeze($89a0e1b121a7f9f2$var$sign_in_exp);


const $b4872308757e094c$var$quota_item = {
    tenant_limit: {
        name: "Арендаторы",
        limited: "{{count, number}} арендатор",
        limited_other: "{{count, number}} арендаторов",
        unlimited: "Неограниченное количество арендаторов",
        not_eligible: "Удалите свои арендаторы"
    },
    mau_limit: {
        name: "Активные пользователи в месяц",
        limited: "{{count, number}} пользователей в месяц",
        unlimited: "Неограниченное количество пользователей в месяц",
        not_eligible: "Удалите всех своих пользователей"
    },
    applications_limit: {
        name: "Приложения",
        limited: "{{count, number}} приложение",
        limited_other: "{{count, number}} приложений",
        unlimited: "Неограниченное количество приложений",
        not_eligible: "Удалите свои приложения"
    },
    machine_to_machine_limit: {
        name: "Машина ко машине",
        limited: "{{count, number}} приложение для машины ко машине",
        limited_other: "{{count, number}} приложения для машин ко машине",
        unlimited: "Неограниченное количество приложений для машин ко машине",
        not_eligible: "Удалите свои приложения для машин ко машине"
    },
    resources_limit: {
        name: "API ресурсы",
        limited: "{{count, number}} API ресурс",
        limited_other: "{{count, number}} API ресурсов",
        unlimited: "Неограниченное количество API ресурсов",
        not_eligible: "Удалите свои API ресурсы"
    },
    scopes_per_resource_limit: {
        name: "Разрешения ресурса",
        limited: "{{count, number}} разрешение на ресурс",
        limited_other: "{{count, number}} разрешений на ресурс",
        unlimited: "Неограниченное количество разрешений на ресурс",
        not_eligible: "Удалите свои разрешения ресурса"
    },
    custom_domain_enabled: {
        name: "Пользовательский домен",
        limited: "Пользовательский домен",
        unlimited: "Пользовательский домен",
        not_eligible: "Удалите свой пользовательский домен"
    },
    omni_sign_in_enabled: {
        name: "Omni-вход",
        limited: "Omni-вход",
        unlimited: "Omni-вход",
        not_eligible: "Выключите свой Omni-вход"
    },
    built_in_email_connector_enabled: {
        name: "Встроенный электронный коннектор",
        limited: "Встроенный электронный коннектор",
        unlimited: "Встроенный электронный коннектор",
        not_eligible: "Удалите свой встроенный электронный коннектор"
    },
    social_connectors_limit: {
        name: "Социальные коннекторы",
        limited: "{{count, number}} социальный коннектор",
        limited_other: "{{count, number}} социальных коннекторов",
        unlimited: "Неограниченное количество социальных коннекторов",
        not_eligible: "Удалите свои социальные коннекторы"
    },
    standard_connectors_limit: {
        name: "Бесплатные стандартные коннекторы",
        limited: "{{count, number}} бесплатный стандартный коннектор",
        limited_other: "{{count, number}} бесплатных стандартных коннекторов",
        unlimited: "Неограниченное количество стандартных коннекторов",
        not_eligible: "Удалите свои стандартные коннекторы"
    },
    roles_limit: {
        name: "Роли",
        limited: "{{count, number}} роль",
        limited_other: "{{count, number}} ролей",
        unlimited: "Неограниченное количество ролей",
        not_eligible: "Удалите свои роли"
    },
    scopes_per_role_limit: {
        name: "Разрешения роли",
        limited: "{{count, number}} разрешение на роль",
        limited_other: "{{count, number}} разрешений на роль",
        unlimited: "Неограниченное количество разрешений на роль",
        not_eligible: "Удалите свои разрешения роли"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Неограниченное количество вебхуков",
        not_eligible: "Удалите ваши вебхуки"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Время хранения аудит-логов",
        limited: "Время хранения аудит-логов: {{count, number}} день",
        limited_other: "Время хранения аудит-логов: {{count, number}} дней",
        unlimited: "Неограниченное количество дней",
        not_eligible: "Без аудит-логов"
    },
    community_support_enabled: {
        name: "Поддержка сообщества",
        limited: "Поддержка сообщества",
        unlimited: "Поддержка сообщества",
        not_eligible: "Без поддержки сообщества"
    },
    customer_ticket_support: {
        name: "Поддержка клиентов по билетам",
        limited: "{{count, number}} час(ов) поддержки клиентов по билетам",
        limited_other: "{{count, number}} часов поддержки клиентов по билетам",
        unlimited: "Поддержка клиентов по билетам",
        not_eligible: "Без поддержки клиентов по билетам"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "Отключите свой MFA"
    },
    sso_enabled: {
        name: "Ограниченная",
        limited: "Ограниченная",
        unlimited: "Ограниченная",
        not_eligible: "Отключить SSO"
    }
};
var $b4872308757e094c$export$2e2bcd8739ae039 = Object.freeze($b4872308757e094c$var$quota_item);


const $98c218b54444b985$var$quota_table = {
    quota: {
        title: "Квота",
        tenant_limit: "Лимит арендатора",
        base_price: "Базовая цена",
        mau_unit_price: "* Цена за активного пользователя (MAU)",
        mau_limit: "Лимит активных пользователей (MAU)"
    },
    application: {
        title: "Приложения",
        total: "Всего приложений",
        m2m: 'Приложения "машина-машина"'
    },
    resource: {
        title: "Ресурсы API",
        resource_count: "Количество ресурсов",
        scopes_per_resource: "Разрешения на ресурс"
    },
    branding: {
        title: "Интерфейс и брендинг",
        custom_domain: "Пользовательский домен",
        custom_css: "Пользовательский CSS",
        app_logo_and_favicon: "Логотип и фавикон приложения",
        dark_mode: "Темный режим",
        i18n: "Интернационализация"
    },
    user_authn: {
        title: "Проверка подлинности пользователя",
        omni_sign_in: "Многочисленные входы",
        password: "Пароль",
        passwordless: "Без пароля - Электронная почта и SMS",
        email_connector: "Подключение электронной почты",
        sms_connector: "Подключение SMS",
        social_connectors: "Социальные подключения",
        standard_connectors: "Стандартные подключения",
        built_in_email_connector: "Встроенное подключение электронной почты",
        mfa: "MFA",
        sso: "Единый вход в корпоративные системы"
    },
    user_management: {
        title: "Управление пользователями",
        user_management: "Управление пользователями",
        roles: "Роли",
        scopes_per_role: "Разрешения на роль"
    },
    audit_logs: {
        title: "Аудит журналов",
        retention: "Сохранение"
    },
    hooks: {
        title: "Вебхуки",
        hooks: "Вебхуки"
    },
    organizations: {
        title: "Организация",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Поддержка",
        community: "Сообщество",
        customer_ticket: "Техническая поддержка",
        premium: "Премиум"
    },
    mau_unit_price_footnote: "* Ваши активные пользователи в месяц (MAU) разделены на 3 уровня в зависимости от того, как часто они входят в систему в течение биллингового периода. Каждый уровень имеет свою стоимость за единицу MAU.",
    unlimited: "Неограниченно",
    contact: "Связаться",
    monthly_price: "${{value, number}}/мес.",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} день",
    days_other: "{{count, number}} дней",
    add_on: "Дополнительно",
    tier: "Уровень{{value, number}}: "
};
var $98c218b54444b985$export$2e2bcd8739ae039 = Object.freeze($98c218b54444b985$var$quota_table);


const $5f2cc89aa0398700$var$subscription = {
    free_plan: "Бесплатный план",
    free_plan_description: "Для побочных проектов и начальных испытаний Logto. Без кредитной карты.",
    hobby_plan: "Хобби план",
    hobby_plan_description: "Для индивидуальных разработчиков или небольших инженерных команд.",
    pro_plan: "Про план",
    pro_plan_description: "Позволяет бизнесу использовать Logto без забот.",
    enterprise: "Enterprise",
    current_plan: "Текущий план",
    current_plan_description: "Вот ваш текущий тарифный план. Вы можете легко просмотреть использование вашего тарифа, проверить предстоящий счет и вносить изменения в тариф по мере необходимости.",
    plan_usage: "Использование плана",
    plan_cycle: "Цикл плана: {{period}}. Использование обновляется {{renewDate}}.",
    next_bill: "Ваш следующий счет",
    next_bill_hint: "Чтобы узнать больше о расчете, ознакомьтесь с этой <a>статьей</a>.",
    next_bill_tip: "Ваш будущий счет включает основную стоимость вашего плана на следующий месяц, а также стоимость вашего использования, умноженную на цену за единицу MAU в различных уровнях.",
    manage_payment: "Управление платежами",
    overfill_quota_warning: "Вы достигли лимита вашего квоты. Чтобы избежать возможных проблем, повысьте план.",
    upgrade_pro: "Повысить уровень до Pro",
    update_payment: "Обновить платеж",
    payment_error: "Обнаружена ошибка платежа. Невозможно обработать сумму ${{price, number}} за предыдущий цикл. Обновите платежную информацию, чтобы избежать блокировки сервиса Logto.",
    downgrade: "Понизить уровень",
    current: "Текущий",
    upgrade: "Обновить",
    quota_table: $98c218b54444b985$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Счета",
        status_column: "Статус",
        amount_column: "Сумма",
        invoice_created_date_column: "Дата создания счета",
        invoice_status: {
            void: "Отменено",
            paid: "Оплачено",
            open: "Открыто",
            uncollectible: "Просрочено"
        }
    },
    quota_item: $b4872308757e094c$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Вы действительно хотите понизить уровень?",
        description: "Если вы выберете переключиться на <targetName/>, обратите внимание, что у вас больше не будет доступа к квотам и функциям, которые были ранее в <currentName/>.",
        before: "Позднее: <name/>",
        after: "После: <name />",
        downgrade: "Понизить уровень"
    },
    not_eligible_modal: {
        downgrade_title: "Вы не можете понизить уровень тарифа",
        downgrade_description: "Перед понижением до тарифа <name/>, убедитесь, что соответствуете следующим критериям.",
        downgrade_help_tip: "Нужна помощь в понижении? <a>Свяжитесь с нами</a>.",
        upgrade_title: "Дружественное напоминание нашим уважаемым ранним пользователям",
        upgrade_description: "В данный момент вы используете больше, чем позволяет <name />. Logto теперь официально, включая функции, специально разработанные для каждого тарифного плана. Прежде чем рассматривать обновление до <name />, убедитесь, что вы соответствуете следующим критериям перед обновлением.",
        upgrade_pro_tip: " Или рассмотрите обновление до Про-плана.",
        upgrade_help_tip: "Нужна помощь в повышении? <a>Свяжитесь с нами</a>.",
        a_maximum_of: "Максимум <item/>"
    },
    upgrade_success: "Успешно повышен до <name/>",
    downgrade_success: "Успешно понижен до <name/>",
    subscription_check_timeout: "Время проверки подписки истекло. Пожалуйста, обновите позже.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $5f2cc89aa0398700$export$2e2bcd8739ae039 = Object.freeze($5f2cc89aa0398700$var$subscription);


const $d2082abe15119d90$var$tab_sections = {
    overview: "Обзор",
    resources: "Ресурсы",
    users: "Пользователи",
    access_control: "Управление доступом",
    help_and_support: "Помощь и поддержка",
    tenant: "Арендатор",
    automation: "Автоматизация"
};
var $d2082abe15119d90$export$2e2bcd8739ae039 = Object.freeze($d2082abe15119d90$var$tab_sections);


const $0e4c520ef0c57439$var$tabs = {
    get_started: "Начало",
    dashboard: "Панель управления",
    applications: "Приложения",
    api_resources: "Ресурсы API",
    sign_in_experience: "Опыт входа в систему",
    connectors: "Коннекторы",
    enterprise_sso: "Единый вход в систему предприятия",
    webhooks: "Webhooks",
    organizations: "Организации",
    users: "Управление пользователями",
    audit_logs: "Журналы аудита",
    roles: "Роли",
    docs: "Документация",
    tenant_settings: "Настройки",
    mfa: "Multi-factor auth"
};
var $0e4c520ef0c57439$export$2e2bcd8739ae039 = Object.freeze($0e4c520ef0c57439$var$tabs);


const $81da1e5840dc2df4$var$tenants = {
    title: "Настройки",
    description: "Эффективное управление настройками арендатора и настройка вашего домена.",
    tabs: {
        settings: "Настройки",
        domains: "Домены",
        subscription: "План и выставление счетов",
        billing_history: "История выставления счетов"
    },
    settings: {
        title: "НАСТРОЙКИ",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "ID арендатора",
        tenant_name: "Имя арендатора",
        tenant_region: "Регион размещения данных",
        tenant_region_tip: "Ваши ресурсы арендатора размещаются в {{region}}. <a>Узнайте больше</a>",
        environment_tag_development: "Разр",
        environment_tag_staging: "Предпр",
        environment_tag_production: "Прод",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Информация о квартиросъемщике успешно сохранена."
    },
    full_env_tag: {
        development: "Разработка",
        production: "Производство"
    },
    deletion_card: {
        title: "УДАЛИТЬ",
        tenant_deletion: "Удаление арендатора",
        tenant_deletion_description: "Удаление арендатора приведет к окончательному удалению всех связанных пользовательских данных и настроек. Пожалуйста, действуйте осторожно.",
        tenant_deletion_button: "Удалить арендатора"
    },
    create_modal: {
        title: "Создать арендатора",
        subtitle: "Создайте нового арендатора, чтобы разделить ресурсы и пользователей. Данные, размещенные в регионе, и типы арендаторов не могут быть изменены после создания.",
        tenant_usage_purpose: "Для чего вы хотите использовать этот арендатор?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Доступный план:",
        create_button: "Создать арендатора",
        tenant_name_placeholder: "Мой арендатор"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Удалить арендатора",
        description_line1: 'Вы уверены, что хотите удалить своего арендатора "<span>{{name}}</span>" с меткой суффикса окружения "<span>{{tag}}</span>"? Это действие нельзя отменить, и приведет к безвозвратному удалению всех ваших данных и информации об учетной записи.',
        description_line2: "Перед удалением учетной записи мы можем вам помочь. <span><a>Свяжитесь с нами по электронной почте</a></span>",
        description_line3: 'Если вы хотите продолжить, введите название арендатора "<span>{{name}}</span>" для подтверждения.',
        delete_button: "Навсегда удалить",
        cannot_delete_title: "Нельзя удалить этого арендатора",
        cannot_delete_description: "Извините, вы не можете удалить этого арендатора прямо сейчас. Пожалуйста, убедитесь, что вы используете бесплатный план и оплатили все невыполненные счета."
    },
    tenant_landing_page: {
        title: "Вы еще не создали арендатора",
        description: "Чтобы начать настройку вашего проекта с помощью Logto, создайте нового арендатора. Если вам нужно выйти из системы или удалить свою учетную запись, просто нажмите на кнопку аватара в правом верхнем углу.",
        create_tenant_button: "Создать арендатора"
    },
    status: {
        mau_exceeded: "Превышение MAU",
        suspended: "Приостановлен",
        overdue: "Прошлый срок"
    },
    tenant_suspended_page: {
        title: "Приостановленный арендатор. Свяжитесь с нами, чтобы восстановить доступ.",
        description_1: "Очень сожалеем, но ваша учетная запись арендатора временно заблокирована из-за неправильного использования, включая превышение MAU-лимитов, просроченные платежи или другие неавторизованные действия.",
        description_2: "Если вам нужна дополнительная информация или у вас возникли какие-либо вопросы или вы хотите восстановить полную функциональность и разблокировать своих арендаторов, не стесняйтесь немедленно связаться с нами."
    },
    signing_keys: {
        title: "УПРАВЛЕНИЕ КЛЮЧАМИ ПОДПИСИ",
        description: "Безопасное управление ключами подписи в вашем арендаторе.",
        type: {
            private_key: "OIDC закрытые ключи",
            cookie_key: "Ключи cookie OIDC"
        },
        private_keys_in_use: "Используемые закрытые ключи",
        cookie_keys_in_use: "Используемые ключи cookie",
        rotate_private_keys: "Повернуть закрытые ключи",
        rotate_cookie_keys: "Повернуть ключи cookie",
        rotate_private_keys_description: "Это действие создаст новый закрытый ключ подписи, повернет текущий ключ и удалит предыдущий. Ваши JWT-токены, подписанные текущим ключом, останутся действительными до удаления или следующего раунда поворота.",
        rotate_cookie_keys_description: "Это действие создаст новый ключ cookie, повернет текущий ключ и удалит предыдущий. Ваши файлы cookie с текущим ключом останутся действительными до удаления или следующего раунда поворота.",
        select_private_key_algorithm: "Выберите алгоритм подписи ключа для нового закрытого ключа",
        rotate_button: "Повернуть",
        table_column: {
            id: "ID",
            status: "Статус",
            algorithm: "Алгоритм подписи ключа"
        },
        status: {
            current: "Текущий",
            previous: "Предыдущий"
        },
        reminder: {
            rotate_private_key: "Вы уверены, что хотите повернуть <strong>OIDC закрытые ключи</strong>? Новые выданные JWT-токены будут подписаны новым ключом. Существующие JWT-токены останутся действительными до следующего поворота.",
            rotate_cookie_key: "Вы уверены, что хотите повернуть <strong>Ключи cookie OIDC</strong>? Новые файлы cookie, созданные в сеансах входа в систему, будут подписаны новым ключом cookie. Существующие файлы cookie останутся действительными до следующего поворота.",
            delete_private_key: "Вы уверены, что хотите удалить <strong>OIDC закрытый ключ</strong>? Существующие JWT-токены, подписанные этим закрытым ключом, больше не будут действительными.",
            delete_cookie_key: "Вы уверены, что хотите удалить <strong>Ключ cookie OIDC</strong>? Более старые сеансы входа в систему с файлами cookie, подписанными этим ключом cookie, больше не будут действительными. Для этих пользователей требуется повторная авторизация."
        },
        messages: {
            rotate_key_success: "Ключи подписи успешно повернуты.",
            delete_key_success: "Ключ успешно удален."
        }
    }
};
var $81da1e5840dc2df4$export$2e2bcd8739ae039 = Object.freeze($81da1e5840dc2df4$var$tenants);


const $b5e05cb3393e26fd$var$topbar = {
    docs: "Документы",
    help: "Помощь"
};
var $b5e05cb3393e26fd$export$2e2bcd8739ae039 = Object.freeze($b5e05cb3393e26fd$var$topbar);


const $af8491979d92dbc4$var$paywall = {
    applications: "Достигнут лимит {{count, number}} приложения(й) для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    applications_other: "Достигнут лимит {{count, number}} приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine_feature: "Обновите план до <strong>Hobby</strong>, чтобы разблокировать 1 машинное приложение, или выберите план <strong>Pro</strong> для неограниченного использования. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine: "Достигнут лимит {{count, number}} машинных приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    machine_to_machine_other: "Достигнут лимит {{count, number}} машинных приложений для <planName/>. Обновите план, чтобы удовлетворить потребности вашей команды. При необходимости помощи, не стесняйтесь <a>связаться с нами</a>.",
    resources: "Достигнут лимит {{count, number}} ресурсов API в плане <planName/>. Повысьте план, чтобы удовлетворить потребности вашей команды. <a>Свяжитесь с нами</a> для получения помощи.",
    resources_other: "Достигнут лимит {{count, number}} ресурсов API в плане <planName/>. Повысьте план, чтобы удовлетворить потребности вашей команды. <a>Свяжитесь с нами</a> для получения помощи.",
    scopes_per_resource: "Достигнут лимит {{count, number}} разрешений на ресурс API в плане <planName/>. Повысьте план, чтобы увеличить количество разрешений. <a>Свяжитесь с нами</a> для получения помощи.",
    scopes_per_resource_other: "Достигнут лимит {{count, number}} разрешений на ресурс API в плане <planName/>. Повысьте план, чтобы увеличить количество разрешений. <a>Свяжитесь с нами</a> для получения помощи.",
    custom_domain: "Разблокируйте функцию настраиваемого домена, обновив план до <strong>Hobby</strong> или <strong>Pro</strong>. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    social_connectors: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    social_connectors_other: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_feature: "Обновите план до <strong>Hobby</strong> или <strong>Pro</strong>, чтобы создавать собственные коннекторы с использованием протоколов OIDC, OAuth 2.0 и SAML, а также получить неограниченное количество социальных коннекторов и все премиальные функции. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    standard_connectors: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_other: "Достигнут лимит {{count, number}} социальных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_pro: "Достигнут лимит {{count, number}} стандартных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план до Плана предприятия, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    standard_connectors_pro_other: "Достигнут лимит {{count, number}} стандартных коннекторов в плане <planName/>. Для удовлетворения потребностей вашей команды повысьте план до Плана предприятия, чтобы получить дополнительные социальные коннекторы и возможность создания собственных коннекторов с использованием протоколов OIDC, OAuth 2.0 и SAML. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    roles: "Достигнут лимит {{count, number}} ролей в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    roles_other: "Достигнут лимит {{count, number}} ролей в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    scopes_per_role: "Достигнут лимит {{count, number}} разрешений на роль в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    scopes_per_role_other: "Достигнут лимит {{count, number}} разрешений на роль в плане <planName/>. Повысьте план, чтобы добавить дополнительные роли и разрешения. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    hooks: "Достигнут лимит {{count, number}} вебхуков в плане <planName/>. Повысьте план, чтобы создать больше вебхуков. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    hooks_other: "Достигнут лимит {{count, number}} вебхуков в плане <planName/>. Повысьте план, чтобы создать больше вебхуков. Если вам нужна помощь, не стесняйтесь <a>связаться с нами</a>.",
    mfa: "Разблокируйте MFA для повышения безопасности с помощью перехода на платный план. Не стесняйтесь <a>связаться с нами</a>, если вам нужна помощь.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $af8491979d92dbc4$export$2e2bcd8739ae039 = Object.freeze($af8491979d92dbc4$var$paywall);


const $99d9efc8ae516ddd$var$upsell = {
    upgrade_plan: "Повысить план",
    compare_plans: "Сравнить планы",
    view_plans: "Просмотреть планы",
    create_tenant: {
        title: "Выберите план арендатора",
        description: "Logto предоставляет конкурентные варианты планов с инновационной и доступной ценой, специально разработанными для растущих компаний. <a>Узнать больше</a>",
        base_price: "Базовая цена",
        monthly_price: "{{value, number}}/мес.",
        mau_unit_price: "Стоимость единицы MAU",
        view_all_features: "Просмотреть все функции",
        select_plan: "Выбрать <name/>",
        free_tenants_limit: "До {{count, number}} бесплатного арендатора",
        free_tenants_limit_other: "До {{count, number}} бесплатных арендаторов",
        most_popular: "Самый популярный",
        upgrade_success: "Успешно повышен до <name/>"
    },
    mau_exceeded_modal: {
        title: "Превышено количество активных пользователей (MAU). Повысьте свой план.",
        notification: "Текущее количество активных пользователей (MAU) превысило лимит в плане <planName/>. Пожалуйста, незамедлительно обновите свой план до премиум-версии, чтобы избежать приостановки сервиса Logto.",
        update_plan: "Обновить план"
    },
    payment_overdue_modal: {
        title: "Просрочен платеж за счет",
        notification: "Упс! Оплата счета арендатора <span>{{name}}</span> не удалась. Пожалуйста, оплатите счет немедленно, чтобы избежать приостановки сервиса Logto.",
        unpaid_bills: "Неоплаченные счета",
        update_payment: "Обновить платеж"
    },
    paywall: $af8491979d92dbc4$export$2e2bcd8739ae039
};
var $99d9efc8ae516ddd$export$2e2bcd8739ae039 = Object.freeze($99d9efc8ae516ddd$var$upsell);


const $9d8638dafb82d82b$var$user_details = {
    page_title: "Детали пользователя",
    back_to_users: "Вернуться к управлению пользователями",
    created_title: "Пользователь успешно создан",
    created_guide: "Вот информация, которая поможет пользователю в процессе входа в систему.",
    created_email: "Адрес электронной почты:",
    created_phone: "Номер телефона:",
    created_username: "Имя пользователя:",
    created_password: "Пароль:",
    menu_delete: "Удалить",
    delete_description: "Это действие нельзя отменить. Оно окончательно удалит пользователя.",
    deleted: "Пользователь успешно удален",
    reset_password: {
        reset_password: "Сбросить пароль",
        title: "Вы уверены, что хотите сбросить пароль?",
        content: "Это действие нельзя отменить. Это сбросит информацию для входа пользователя.",
        congratulations: "Пользователь был сброшен",
        new_password: "Новый пароль:"
    },
    tab_settings: "Настройки",
    tab_roles: "Роли",
    tab_logs: "Журналы пользователя",
    tab_organizations: "Организации",
    authentication: "Аутентификация",
    authentication_description: "У каждого пользователя есть профиль, содержащий всю информацию о пользователе. Он состоит из основных данных, социальных идентификаторов и пользовательских данных.",
    user_profile: "Профиль пользователя",
    field_email: "Адрес электронной почты",
    field_phone: "Номер телефона",
    field_username: "Имя пользователя",
    field_name: "Имя",
    field_avatar: "URL изображения аватара",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "Пользовательские данные",
    field_custom_data_tip: "Дополнительная информация о пользователе, не указанная в заранее определенных свойствах пользователя, таких как предпочтительный цвет и язык пользователя.",
    field_connectors: "Социальные подключения",
    field_sso_connectors: "Корпоративные подключения",
    custom_data_invalid: "Пользовательские данные должны быть допустимым JSON-объектом",
    connectors: {
        connectors: "Подключения",
        user_id: "ID пользователя",
        remove: "Удалить",
        connected: "Этот пользователь подключен к нескольким социальным подключениям.",
        not_connected: "Пользователь не подключен к социальным подключениям",
        deletion_confirmation: "Вы удаляете существующую личность <name/>. Вы уверены, что хотите продолжить?"
    },
    sso_connectors: {
        connectors: "Подключения",
        enterprise_id: "ID корпорации",
        connected: "Этот пользователь подключен к нескольким поставщикам корпоративной идентификации для однократного входа.",
        not_connected: "Пользователь не подключен к поставщикам корпоративного идентификатора для однократного входа."
    },
    mfa: {
        field_name: "Двухфакторная аутентификация",
        field_description: "Этот пользователь включил двухэтапные факторы аутентификации.",
        name_column: "Двухфакторная аутентификация",
        field_description_empty: "Этот пользователь не включил двухфакторную аутентификацию.",
        deletion_confirmation: "Вы удаляете существующий <name/> для двухэтапной верификации. Вы уверены, что хотите продолжить?"
    },
    suspended: "Приостановлен",
    suspend_user: "Приостановить пользователя",
    suspend_user_reminder: "Вы уверены, что хотите приостановить этого пользователя? Пользователь не сможет войти в ваше приложение, и он не сможет получить новый токен доступа после истечения срока действия текущего токена. Кроме того, любые API-запросы, сделанные этим пользователем, завершатся неудачей.",
    suspend_action: "Приостановить",
    user_suspended: "Пользователь был приостановлен.",
    reactivate_user: "Возобновить пользователя",
    reactivate_user_reminder: "Вы уверены, что хотите возобновить этого пользователя? Это позволит любые попытки входа в систему для этого пользователя.",
    reactivate_action: "Возобновить",
    user_reactivated: "Пользователь был возобновлен.",
    roles: {
        name_column: "Роль",
        description_column: "Описание",
        assign_button: "Назначить роли",
        delete_description: "Это действие удалит эту роль у данного пользователя. Роль все еще будет существовать, но она больше не будет связана с этим пользователем.",
        deleted: "{{name}} был(а) успешно удален(а) из этого пользователя.",
        assign_title: "Назначить роли {{name}}",
        assign_subtitle: "Авторизовать {{name}} в одной или нескольких ролях",
        assign_role_field: "Назначить роли",
        role_search_placeholder: "Поиск по названию роли",
        added_text: "{{value, number}} добавлен(а)",
        assigned_user_count: "{{value, number}} пользователей",
        confirm_assign: "Назначить роли",
        role_assigned: "Роль(и) успешно назначена(ы)",
        search: "Поиск по названию роли, описанию или ID",
        empty: "Нет доступных ролей"
    },
    warning_no_sign_in_identifier: "Пользователь должен иметь хотя бы один из идентификаторов входа (имя пользователя, электронная почта, номер телефона или социальная сеть), чтобы войти. Вы уверены, что хотите продолжить?",
    organization_roles_tooltip: "Роли, назначенные пользователю в этой организации."
};
var $9d8638dafb82d82b$export$2e2bcd8739ae039 = Object.freeze($9d8638dafb82d82b$var$user_details);


const $fb30027e35105d7f$var$users = {
    page_title: "Управление пользователями",
    title: "Управление пользователями",
    subtitle: "Управление идентификацией пользователей, включая создание пользователей, редактирование информации о пользователях, просмотр журналов пользователей, сброс пароля и удаление пользователей",
    create: "Добавить пользователя",
    create_subtitle: "Введите хотя бы одно из следующих полей для продолжения.",
    error_missing_identifier: "Чтобы создать пользователя, вам нужно указать хотя бы один идентификатор.",
    user_name: "Пользователь",
    application_name: "От приложения",
    latest_sign_in: "Последний вход",
    create_form_username: "Имя пользователя",
    create_form_password: "Пароль",
    create_form_name: "Полное имя",
    placeholder_name: "Иван Иванов",
    placeholder_email: "ivan@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+7 (123) 456-78-90",
    unnamed: "Без имени",
    search: "Поиск по имени, электронной почте, телефону или имени пользователя",
    check_user_detail: "Просмотреть информацию о пользователе",
    placeholder_title: "Управление пользователями",
    placeholder_description: "Каждый пользователь имеет профиль, содержащий всю информацию о пользователе. Он состоит из базовых данных, социальных идентификаторов и настраиваемых данных."
};
var $fb30027e35105d7f$export$2e2bcd8739ae039 = Object.freeze($fb30027e35105d7f$var$users);


const $06acbdf14823704d$var$webhook_details = {
    page_title: "Данные вебхука",
    back_to_webhooks: "Вернуться к вебхукам",
    not_in_use: "Не используется",
    success_rate: "Коэффициент успешности",
    requests: "{{value, number}} запросов за 24 часа",
    disable_webhook: "Отключить вебхук",
    disable_reminder: "Вы уверены, что хотите включить этот вебхук? Это не приведет к отправке HTTP-запроса на URL-адрес точки доступа.",
    webhook_disabled: "Вебхук был отключен.",
    webhook_reactivated: "Вебхук был перезапущен.",
    reactivate_webhook: "Перезапустить вебхук",
    delete_webhook: "Удалить вебхук",
    deletion_reminder: "Вы удаляете этот вебхук. После удаления он не будет отправлять HTTP-запрос на URL-адрес точки доступа.",
    deleted: "Вебхук был успешно удален.",
    settings_tab: "Настройки",
    recent_requests_tab: "Недавние запросы (за 24ч)",
    settings: {
        settings: "Настройки",
        settings_description: "Вебхуки позволяют получать обновления в режиме реального времени по конкретным событиям по мере их возникновения, отправляя POST-запрос на ваш URL-адрес точки доступа. Это позволяет вам немедленно выполнять действия на основе новой информации.",
        events: "События",
        events_description: "Выберите события триггеров, которые Logto будет отправлять POST-запрос.",
        name: "Имя",
        endpoint_url: "URL-адрес точки доступа",
        signing_key: "Ключ подписи",
        signing_key_tip: "Добавьте секретный ключ, предоставленный Logto, к своей конечной точке в виде заголовка запроса, чтобы обеспечить подлинность нагрузки вебхука.",
        regenerate: "Регенерировать",
        regenerate_key_title: "Регенерировать ключ подписи",
        regenerate_key_reminder: "Вы уверены, что хотите изменить ключ подписи? Регенерация приведет к немедленному вступлению в силу. Пожалуйста, не забудьте синхронно изменить ключ подписи в своей конечной точке.",
        regenerated: "Ключ подписи был обновлен.",
        custom_headers: "Пользовательские заголовки",
        custom_headers_tip: "При желании вы можете добавлять пользовательские заголовки к нагрузке вебхука, чтобы предоставить дополнительный контекст или метаданные о событии.",
        key_duplicated_error: "Ключи не могут повторяться.",
        key_missing_error: "Ключ обязателен.",
        value_missing_error: "Значение обязательно",
        invalid_key_error: "Ключ недействителен",
        invalid_value_error: "Значение недействительно",
        test: "Тестирование",
        test_webhook: "Протестировать ваш вебхук",
        test_webhook_description: "Настройте вебхук и протестируйте его с примерами нагрузки для каждого выбранного события, чтобы проверить правильный прием и обработку.",
        send_test_payload: "Отправить тестовую нагрузку",
        test_result: {
            endpoint_url: "URL конечной точки: {{url}}",
            message: "Сообщение: {{message}}",
            response_status: "Статус ответа: {{status, number}}",
            response_body: "Тело ответа: {{body}}",
            request_time: "Время запроса: {{time}}",
            test_success: "Тест вебхука на конечную точку прошел успешно."
        }
    }
};
var $06acbdf14823704d$export$2e2bcd8739ae039 = Object.freeze($06acbdf14823704d$var$webhook_details);


const $acd4e8cf664f496c$var$webhooks = {
    page_title: "Вебхуки",
    title: "Вебхуки",
    subtitle: "Создайте вебхуки, чтобы легко получать обновления в реальном времени относительно определенных событий.",
    create: "Создать вебхук",
    events: {
        post_register: "Создать новый аккаунт",
        post_sign_in: "Войти",
        post_reset_password: "Сбросить пароль"
    },
    table: {
        name: "Имя",
        events: "События",
        success_rate: "Коэффициент успешности (за 24ч)",
        requests: "Запросы (за 24ч)"
    },
    placeholder: {
        title: "Вебхук",
        description: 'Создайте вебхук для получения обновлений в реальном времени через POST-запросы на URL-адрес вашей конечной точки. Будьте в курсе событий и мгновенно реагируйте на события, такие как "Создание учетной записи", "Вход" и "Сброс пароля".',
        create_webhook: "Создать вебхук"
    },
    create_form: {
        title: "Создать вебхук",
        subtitle: "Добавьте вебхук, чтобы отправлять запросы POST на URL-адрес конечной точки с деталями любых событий пользователей.",
        events: "События",
        events_description: "Выберите события-триггеры, при которых Logto будет отправлять запросы POST.",
        name: "Имя",
        name_placeholder: "Введите имя вебхука",
        endpoint_url: "URL-адрес конечной точки",
        endpoint_url_placeholder: "https://ваш.url.адрес.вебхука",
        endpoint_url_tip: "Введите URL вашей конечной точки, на который будет отправлено тело вебхука, когда произойдет событие.",
        create_webhook: "Создать вебхук",
        missing_event_error: "Вы должны выбрать как минимум одно событие."
    },
    webhook_created: "Вебхук {{name}} был успешно создан."
};
var $acd4e8cf664f496c$export$2e2bcd8739ae039 = Object.freeze($acd4e8cf664f496c$var$webhooks);


const $fd4842dc7c219a80$var$welcome = {
    title: "Добро пожаловать в административную консоль",
    description: "Административная консоль - это веб-приложение для управления Logto без требований к кодированию. Давайте сначала создадим учетную запись. С этой учетной записью вы можете управлять Logto самостоятельно или от имени вашей компании.",
    create_account: "Создать учетную запись"
};
var $fd4842dc7c219a80$export$2e2bcd8739ae039 = Object.freeze($fd4842dc7c219a80$var$welcome);


const $39a2f02245f874ef$var$admin_console = {
    title: "Консоль администратора",
    admin_user: "Администратор",
    system_app: "Система",
    menu: $dbe4c124e03d26fd$export$2e2bcd8739ae039,
    general: $34d7f5470b98864b$export$2e2bcd8739ae039,
    errors: $f8914647627897e5$export$2e2bcd8739ae039,
    tab_sections: $d2082abe15119d90$export$2e2bcd8739ae039,
    tabs: $0e4c520ef0c57439$export$2e2bcd8739ae039,
    applications: $a80d8263c523d774$export$2e2bcd8739ae039,
    application_details: $d9d2a40229c00103$export$2e2bcd8739ae039,
    api_resources: $6d2489cce682df18$export$2e2bcd8739ae039,
    api_resource_details: $42bf930587fa99e3$export$2e2bcd8739ae039,
    connectors: $aa5ed361a97b9217$export$2e2bcd8739ae039,
    connector_details: $bc2f0c9b165b947e$export$2e2bcd8739ae039,
    enterprise_sso: $025301a0a72bd9ca$export$2e2bcd8739ae039,
    enterprise_sso_details: $7d3ceff92c61f4a1$export$2e2bcd8739ae039,
    get_started: $1c06f165e95701c5$export$2e2bcd8739ae039,
    users: $fb30027e35105d7f$export$2e2bcd8739ae039,
    user_details: $9d8638dafb82d82b$export$2e2bcd8739ae039,
    contact: $88d09b2c32a5f205$export$2e2bcd8739ae039,
    sign_in_exp: $89a0e1b121a7f9f2$export$2e2bcd8739ae039,
    dashboard: $49b6e3cc2607e8a1$export$2e2bcd8739ae039,
    logs: $cf5d86e9f4feffe0$export$2e2bcd8739ae039,
    log_details: $7da8192d3c82b67a$export$2e2bcd8739ae039,
    session_expired: $b128f638cb0f65b5$export$2e2bcd8739ae039,
    welcome: $fd4842dc7c219a80$export$2e2bcd8739ae039,
    roles: $38997c8a80a09625$export$2e2bcd8739ae039,
    role_details: $8e40a6e6c63fa343$export$2e2bcd8739ae039,
    permissions: $452ff9555603c24e$export$2e2bcd8739ae039,
    cloud: $5dd037e429574e3d$export$2e2bcd8739ae039,
    profile: $a8521441abd3111d$export$2e2bcd8739ae039,
    components: $3e43b0846c4622f9$export$2e2bcd8739ae039,
    webhooks: $acd4e8cf664f496c$export$2e2bcd8739ae039,
    webhook_details: $06acbdf14823704d$export$2e2bcd8739ae039,
    domain: $fefd766af01ac721$export$2e2bcd8739ae039,
    tenants: $81da1e5840dc2df4$export$2e2bcd8739ae039,
    topbar: $b5e05cb3393e26fd$export$2e2bcd8739ae039,
    subscription: $5f2cc89aa0398700$export$2e2bcd8739ae039,
    upsell: $99d9efc8ae516ddd$export$2e2bcd8739ae039,
    guide: $9b4d121a5b0261d2$export$2e2bcd8739ae039,
    mfa: $d3cef5033da689e2$export$2e2bcd8739ae039,
    organizations: $fb124789fe0348d1$export$2e2bcd8739ae039,
    organization_details: $8f7f7530246cdae6$export$2e2bcd8739ae039
};
var $39a2f02245f874ef$export$2e2bcd8739ae039 = Object.freeze($39a2f02245f874ef$var$admin_console);


const $f34f8a5693471010$var$demo_app = {
    title: "Вы успешно вошли в живой просмотр!",
    subtitle: "Вот ваши данные для входа:",
    username: "Имя пользователя: ",
    user_id: "Идентификатор пользователя: ",
    sign_out: "Выйти из живого просмотра",
    continue_explore: "Или продолжить исследование",
    customize_sign_in_experience: "Настройте опыт входа в систему",
    enable_passwordless: "Включить безпарольный вход",
    add_social_connector: "Добавить социальный коннектор"
};
var $f34f8a5693471010$export$2e2bcd8739ae039 = Object.freeze($f34f8a5693471010$var$demo_app);


const $2b8bbe52ba8119cd$var$oidc = {
    logout_success: "Вы успешно вышли из системы."
};
var $2b8bbe52ba8119cd$export$2e2bcd8739ae039 = Object.freeze($2b8bbe52ba8119cd$var$oidc);


const $5880e2a37912aa64$var$translation = {
    admin_console: $39a2f02245f874ef$export$2e2bcd8739ae039,
    demo_app: $f34f8a5693471010$export$2e2bcd8739ae039,
    oidc: $2b8bbe52ba8119cd$export$2e2bcd8739ae039
};
var $5880e2a37912aa64$export$2e2bcd8739ae039 = Object.freeze($5880e2a37912aa64$var$translation);


const $10f7714f13e43988$var$ru = {
    translation: $5880e2a37912aa64$export$2e2bcd8739ae039,
    errors: $448a66bb8e4ce6dc$export$2e2bcd8739ae039
};
var $10f7714f13e43988$export$2e2bcd8739ae039 = Object.freeze($10f7714f13e43988$var$ru);


const $69da94c0b15241a8$var$application = {
    invalid_type: "Sadece makine ile makine uygulamaları rollerle ilişkilendirilebilir.",
    role_exists: "Bu uygulamaya zaten {{roleId}} kimlikli bir rol eklenmiş.",
    invalid_role_type: "Kullanıcı tipi rol\xfc makine ile makine uygulamasına atayamaz."
};
var $69da94c0b15241a8$export$2e2bcd8739ae039 = Object.freeze($69da94c0b15241a8$var$application);


const $f168e0f193772e42$var$auth = {
    authorization_header_missing: "Yetkilendirme başlığı eksik.",
    authorization_token_type_not_supported: "Yetkilendirme tipi desteklenmiyor.",
    unauthorized: "Yetki yok. L\xfctfen kimlik bilgilerini ve kapsamını kontrol edin.",
    forbidden: "Yasak. L\xfctfen kullanıcı rollerinizi ve izinlerinizi kontrol edin.",
    expected_role_not_found: "Expected role not found. Please check your user roles and permissions.",
    jwt_sub_missing: "JWTde `sub` eksik.",
    require_re_authentication: "Korumalı bir işlem ger\xe7ekleştirmek i\xe7in yeniden doğrulama gereklidir."
};
var $f168e0f193772e42$export$2e2bcd8739ae039 = Object.freeze($f168e0f193772e42$var$auth);


const $80c2cf34d853b95b$var$connector = {
    general: "Bağdaştırıcıda bir hata oluştu: {{errorDescription}}",
    not_found: "{{type}} tipi icin uygun bağlayıcı bulunamadı.",
    not_enabled: "Bağlayıcı etkin değil.",
    invalid_metadata: "Bağlayıcının meta verileri ge\xe7ersizdir.",
    invalid_config_guard: "Bağlayıcının yapılandırma koruyucusu ge\xe7ersizdir.",
    unexpected_type: "Bağlayıcının t\xfcr\xfc beklenmedik.",
    invalid_request_parameters: "İstek yanlış girdi parametreleri ile g\xf6nderildi.",
    insufficient_request_parameters: "İstek, bazı input parametrelerini atlayabilir.",
    invalid_config: "Bağlayıcının ayarları ge\xe7ersiz.",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "Bağlayıcının yanıtı ge\xe7ersiz.",
    template_not_found: "Bağlayıcı yapılandırmasında doğru şablon bulunamıyor.",
    template_not_supported: "Bağlayıcı bu şablon t\xfcr\xfcn\xfc desteklemiyor.",
    rate_limit_exceeded: "Tetikleyici oran sınırına ulaşıldı. L\xfctfen daha sonra tekrar deneyin.",
    not_implemented: "{{method}}: hen\xfcz uygulanmadı.",
    social_invalid_access_token: "Bağlayıcının erişim tokenı ge\xe7ersiz.",
    invalid_auth_code: "Bağlayıcının yetki kodu ge\xe7ersiz.",
    social_invalid_id_token: "Bağlayıcının idsi ge\xe7ersiz.",
    authorization_failed: "Kullanıcının yetkilendirme işlemi başarısız oldu.",
    social_auth_code_invalid: "Erişim tokenı alınamıyor, l\xfctfen yetkilendirme kodunu kontrol edin.",
    more_than_one_sms: "SMS bağlayıcılarının sayısı 1den fazla.",
    more_than_one_email: "E-posta adresi bağlayıcılarının sayısı 1den fazla.",
    more_than_one_connector_factory: "Birden fazla bağlayıcı fabrikası bulundu ({{connectorIds}} ID numarasıyla), gereksiz olanları kaldırabilirsiniz.",
    db_connector_type_mismatch: "Dbde t\xfcrle eşleşmeyen bir bağlayıcı var.",
    not_found_with_connector_id: "Belirtilen standart bağlayıcı kimliğiyle bağlayıcı bulunamadı.",
    multiple_instances_not_supported: "Se\xe7ilen standart bağlayıcı ile birden fazla \xf6rnek oluşturulamaz.",
    invalid_type_for_syncing_profile: "Kullanıcı profili yalnızca sosyal bağlayıcılarla senkronize edilebilir.",
    can_not_modify_target: "'Hedef' bağlayıcı değiştirilemez.",
    should_specify_target: "'Hedef' belirtilmelidir.",
    multiple_target_with_same_platform: "Aynı hedefe ve platforma sahip birden fazla sosyal bağlayıcıya sahip olamazsınız.",
    cannot_overwrite_metadata_for_non_standard_connector: "Bu bağlayıcının 'metadata'sı \xfczerine yazılamaz."
};
var $80c2cf34d853b95b$export$2e2bcd8739ae039 = Object.freeze($80c2cf34d853b95b$var$connector);


const $cd93659bee6e3734$var$domain = {
    not_configured: "Alan adı ana bilgisayar sağlayıcısı yapılandırılmamış.",
    cloudflare_data_missing: "cloudflare_data eksik, l\xfctfen kontrol edin.",
    cloudflare_unknown_error: "Cloudflare API isteği yapılırken bilinmeyen bir hata oluştu.",
    cloudflare_response_error: "Cloudflare’dan beklenmeyen bir yanıt alındı.",
    limit_to_one_domain: "Sadece bir \xf6zel alan adınız olabilir.",
    hostname_already_exists: "Bu alan adı sunucumuzda zaten mevcut.",
    cloudflare_not_found: "Cloudflare'da alan adı bulunamadı."
};
var $cd93659bee6e3734$export$2e2bcd8739ae039 = Object.freeze($cd93659bee6e3734$var$domain);


const $3e9d18420b1e199d$var$entity = {
    invalid_input: "Ge\xe7ersiz giriş. Değer listesi boş olmamalıdır.",
    create_failed: "{{name}} oluşturulamadı.",
    db_constraint_violated: "Veritabanı kısıtı ihlal edildi.",
    not_exists: "{{name}} mevcut değil.",
    not_exists_with_id: " `{{id}}` id kimliğine sahip {{name}} mevcut değil.",
    not_found: "Kaynak mevcut değil.",
    relation_foreign_key_not_found: "Bir veya daha fazla yabancı anahtar bulunamıyor. L\xfctfen girişi kontrol edin ve t\xfcm referans edilen varlıkların var olduğundan emin olun.",
    unique_integrity_violation: "Varlık zaten mevcut. L\xfctfen girişi kontrol edin ve tekrar deneyin."
};
var $3e9d18420b1e199d$export$2e2bcd8739ae039 = Object.freeze($3e9d18420b1e199d$var$entity);


const $b7cd213a53738302$var$guard = {
    invalid_input: "İstek {{type}} ge\xe7ersiz.",
    invalid_pagination: "İstenen sayfalandırma değeri ge\xe7ersiz.",
    can_not_get_tenant_id: "İstekten kiracı kimliği alınamadı.",
    file_size_exceeded: "Dosya boyutu aşıldı.",
    mime_type_not_allowed: "MIME t\xfcr\xfc izin verilmiyor."
};
var $b7cd213a53738302$export$2e2bcd8739ae039 = Object.freeze($b7cd213a53738302$var$guard);


const $e1b79662cea6a1ed$var$hook = {
    missing_events: "En az bir etkinlik sağlamanız gerekiyor.",
    send_test_payload_failed: "Test y\xfck\xfc g\xf6nderilemedi: {{message}}",
    endpoint_responded_with_error: "Nokta yanıt verdi hatayla."
};
var $e1b79662cea6a1ed$export$2e2bcd8739ae039 = Object.freeze($e1b79662cea6a1ed$var$hook);


const $42c18f84a9473670$var$localization = {
    cannot_delete_default_language: "{{languageTag}} varsayılan dil olarak ayarlanmıştır ve silinemez.",
    invalid_translation_structure: "Ge\xe7ersiz veri şemaları. L\xfctfen girdilerinizi kontrol edin ve tekrar deneyin."
};
var $42c18f84a9473670$export$2e2bcd8739ae039 = Object.freeze($42c18f84a9473670$var$localization);


const $77304f6510a26ffb$var$log = {
    invalid_type: "Ge\xe7ersiz g\xfcnl\xfck t\xfcr\xfc."
};
var $77304f6510a26ffb$export$2e2bcd8739ae039 = Object.freeze($77304f6510a26ffb$var$log);


const $ccd00c5bb028535e$var$oidc = {
    aborted: "Son kullanıcı etkileşimi iptal etti.",
    invalid_scope: "Kapsam ge\xe7ersiz: {{error_description}}.",
    invalid_token: "Sağlanan belirte\xe7 ge\xe7ersiz.",
    invalid_client_metadata: "Sağlanan istemci meta verisi ge\xe7ersiz.",
    insufficient_scope: "Token'ın `{{scope}}` kapsamı eksik.",
    invalid_request: "Ge\xe7ersiz istek.",
    invalid_grant: "Ge\xe7ersiz hibe.",
    invalid_redirect_uri: "Sağlanan `redirect_uri`, istemcilerin kayıtlı `redirect_uris`'lerinden hi\xe7biriyle eşleşmiyor",
    access_denied: "Erişim reddedildi.",
    invalid_target: "Ge\xe7ersiz hedef.",
    unsupported_grant_type: "Desteklenmeyen `grant_type` isteği.",
    unsupported_response_mode: "Desteklenmeyen `response_mode` isteği.",
    unsupported_response_type: "Desteklenmeyen `response_type` isteği.",
    provider_error: "Dahili OIDC Hatası: {{message}}.",
    server_error: "Bilinmeyen bir OIDC hatası oluştu. L\xfctfen daha sonra tekrar deneyin.",
    provider_error_fallback: "Bir OIDC hatası oluştu: {{code}}.",
    key_required: "En az bir anahtar gereklidir.",
    key_not_found: "ID'si {{id}} olan anahtar bulunamadı."
};
var $ccd00c5bb028535e$export$2e2bcd8739ae039 = Object.freeze($ccd00c5bb028535e$var$oidc);


const $44df3c34cdc62b52$var$organization = {
    require_membership: "Kullanıcının devam etmek i\xe7in organizasyonun bir \xfcyesi olması gerekir."
};
var $44df3c34cdc62b52$export$2e2bcd8739ae039 = Object.freeze($44df3c34cdc62b52$var$organization);


const $06ef9fcff3c92434$var$password = {
    unsupported_encryption_method: "{{name}} şifreleme metodu desteklenmiyor.",
    pepper_not_found: "Şifre pepperı bulunamadı. L\xfctfen core envs.i kontrol edin.",
    rejected: "Şifre reddedildi. L\xfctfen şifrenizin gereksinimleri karşıladığından emin olun."
};
var $06ef9fcff3c92434$export$2e2bcd8739ae039 = Object.freeze($06ef9fcff3c92434$var$password);


const $4b7cd511416653e8$var$request = {
    invalid_input: "Girdi ge\xe7ersiz. {{details}}",
    general: "İstek hatası oluştu."
};
var $4b7cd511416653e8$export$2e2bcd8739ae039 = Object.freeze($4b7cd511416653e8$var$request);


const $18cdcf6dc6a066aa$var$resource = {
    resource_identifier_in_use: "API tanımlayıcısı {{indicator}} zaten kullanımda"
};
var $18cdcf6dc6a066aa$export$2e2bcd8739ae039 = Object.freeze($18cdcf6dc6a066aa$var$resource);


const $c1a01bf885c4818c$var$role = {
    name_in_use: "Bu rol adı {{name}} zaten kullanımda",
    scope_exists: "Bu kapsam kimliği {{scopeId}} zaten bu role eklendi",
    user_exists: "Bu kullanıcı kimliği {{userId}} zaten bu role eklendi",
    application_exists: "Bu uygulama kimliği {{applicationId}} zaten bu role eklendi",
    default_role_missing: "Varsayılan rol adlarından bazıları veritabanında mevcut değil, l\xfctfen \xf6nce rolleri oluşturduğunuzdan emin olun",
    internal_role_violation: 'Logto tarafından yasaklanan dahili bir rol\xfc g\xfcncelleme veya silmeye \xe7alışıyor olabilirsiniz. Yeni bir rol oluşturuyorsanız, "#internal:" ile başlamayan başka bir isim deneyin.'
};
var $c1a01bf885c4818c$export$2e2bcd8739ae039 = Object.freeze($c1a01bf885c4818c$var$role);


const $bdbdd50772ee17da$var$scope = {
    name_exists: "Bu kapsam adı {{name}} zaten kullanımda",
    name_with_space: "Kapsam adı boşluk i\xe7eremez."
};
var $bdbdd50772ee17da$export$2e2bcd8739ae039 = Object.freeze($bdbdd50772ee17da$var$scope);


const $48136c4b12252356$var$session = {
    not_found: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp giriş yapınız.",
    invalid_credentials: "Ge\xe7ersiz kimlik bilgileri. L\xfctfen girdinizi kontrol ediniz.",
    invalid_sign_in_method: "Ge\xe7erli oturum a\xe7ma y\xf6ntemi kullanılamıyor.",
    invalid_connector_id: "{{connectorId}} idsi ile kullanılabilir bağlayıcı bulunamıyor.",
    insufficient_info: "Yetersiz oturum a\xe7ma bilgisi.",
    connector_id_mismatch: "connectorId, oturum kaydı ile eşleşmiyor.",
    connector_session_not_found: "Bağlayıcı oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrardan giriş yapınız.",
    verification_session_not_found: "Doğrulama başarısız oldu. L\xfctfen doğrulama işlemini yeniden başlatın ve tekrar deneyin.",
    verification_expired: "Bağlantı zaman aşımına uğradı. Hesap g\xfcvenliğiniz i\xe7in yeniden doğrulama yapın.",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "L\xfctfen \xf6nce oturum a\xe7ın.",
    unsupported_prompt_name: "Desteklenmeyen prompt adı.",
    forgot_password_not_enabled: "Parolamı unuttum \xf6zelliği etkin değil.",
    verification_failed: "Doğrulama başarısız oldu. L\xfctfen doğrulama işlemini yeniden başlatın ve tekrar deneyin.",
    connector_validation_session_not_found: "Token doğrulama i\xe7in bağlayıcı oturumu bulunamadı.",
    identifier_not_found: "Kullanıcı kimliği bulunamadı. L\xfctfen geri gidin ve yeniden giriş yapın.",
    interaction_not_found: "Etkileşim oturumu bulunamadı. L\xfctfen geri gidin ve oturumu yeniden başlatın.",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "Bu e-posta i\xe7in tek oturum a\xe7ma etkin. L\xfctfen SSO ile oturum a\xe7ın."
};
var $48136c4b12252356$export$2e2bcd8739ae039 = Object.freeze($48136c4b12252356$var$session);


const $a981a8a1b6710b3f$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "Kullanım Koşulları İ\xe7erik URL'i yok. L\xfctfen Kullanım Koşulları etkinse i\xe7erik URL'i ekleyiniz.",
    empty_social_connectors: "Sosyal bağlayıcılar yok. Sosyal oturum a\xe7ma y\xf6ntemi etkinleştirildiğinde l\xfctfen etkin sosyal bağlayıcıları ekleyiniz.",
    enabled_connector_not_found: "Etkin {{type}} bağlayıcı bulunamadı.",
    not_one_and_only_one_primary_sign_in_method: "Yalnızca bir tane birincil oturum a\xe7ma y\xf6ntemi olmalıdır. L\xfctfen inputu kontrol ediniz.",
    username_requires_password: "Kullanıcı adı kayıt kimliği i\xe7in bir şifre belirlemek zorunludur.",
    passwordless_requires_verify: "E-posta/telefon kayıt kimliği i\xe7in doğrulama etkinleştirilmelidir.",
    miss_sign_up_identifier_in_sign_in: "Oturum a\xe7ma y\xf6ntemleri, kayıt kimliğini i\xe7ermelidir.",
    password_sign_in_must_be_enabled: "Kayıtta şifre belirleme zorunlu olduğunda şifreyle oturum a\xe7ma etkinleştirilmelidir.",
    code_sign_in_must_be_enabled: "Kayıtta şifre belirleme zorunlu olmadığında doğrulama koduyla oturum a\xe7ma etkinleştirilmelidir.",
    unsupported_default_language: "Bu dil - {{language}}, şu anda desteklenmemektedir.",
    at_least_one_authentication_factor: "En az bir doğrulama fakt\xf6r\xfc se\xe7melisiniz.",
    backup_code_cannot_be_enabled_alone: "Yedek kod yalnız başına etkinleştirilemez.",
    duplicated_mfa_factors: "Yinelenen MFA fakt\xf6rleri."
};
var $a981a8a1b6710b3f$export$2e2bcd8739ae039 = Object.freeze($a981a8a1b6710b3f$var$sign_in_experiences);


const $a4d5ddaf86fe0d4e$var$single_sign_on = {
    forbidden_domains: "Genel e-posta alanı domainleri izin verilmiyor.",
    duplicated_domains: "Yinelenmiş domainler bulunmaktadır.",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $a4d5ddaf86fe0d4e$export$2e2bcd8739ae039 = Object.freeze($a4d5ddaf86fe0d4e$var$single_sign_on);


const $96743c1236ccb2f9$var$storage = {
    not_configured: "Depolama sağlayıcısı yapılandırılmamış.",
    missing_parameter: "Depolama sağlayıcısı i\xe7in eksik parametre {{parameter}}.",
    upload_error: "Dosya y\xfcklenemedi."
};
var $96743c1236ccb2f9$export$2e2bcd8739ae039 = Object.freeze($96743c1236ccb2f9$var$storage);


const $d549f53f2f9886f4$var$subscription = {
    limit_exceeded: "Abonelik planınızın limitine ulaştınız.",
    get_plan_failed: "Abonelik planınızı almak i\xe7in başarısız oldu.",
    tenant_suspended: "Kiracı askıya alındı. L\xfctfen y\xf6neticinize başvurun."
};
var $d549f53f2f9886f4$export$2e2bcd8739ae039 = Object.freeze($d549f53f2f9886f4$var$subscription);


const $65122502b26bae79$var$swagger = {
    invalid_zod_type: "Ge\xe7ersiz Zod tipi. L\xfctfen y\xf6nlendirici koruma yapılandırmasını kontrol ediniz.",
    not_supported_zod_type_for_params: "Parametreler i\xe7in desteklenmeyen Zod tipi. L\xfctfen y\xf6nlendirici koruma yapılandırmasını kontrol ediniz."
};
var $65122502b26bae79$export$2e2bcd8739ae039 = Object.freeze($65122502b26bae79$var$swagger);


const $bfd1fec6f0f4706a$var$user = {
    username_already_in_use: "Bu kullanıcı adı zaten kullanımda.",
    email_already_in_use: "Bu e-posta mevcut bir hesapla ilişkilendirilmiştir.",
    phone_already_in_use: "Bu telefon numarası mevcut bir hesapla ilişkilendirilmiştir.",
    invalid_email: "Ge\xe7ersiz e-posta adresi.",
    invalid_phone: "Ge\xe7ersiz telefon numarası.",
    email_not_exist: "E-posta adresi hen\xfcz kaydedilmedi.",
    phone_not_exist: "Telefon numarası hen\xfcz kaydedilmedi",
    identity_not_exist: "Sosyal platform hesabı hen\xfcz kaydedilmedi.",
    identity_already_in_use: "Sosyal platform hesabı kaydedildi.",
    social_account_exists_in_profile: "Bu sosyal hesap zaten ilişkilendirilmiş.",
    cannot_delete_self: "Kendinizi silemezsiniz.",
    sign_up_method_not_enabled: "Bu kayıt y\xf6ntemi etkin değil.",
    sign_in_method_not_enabled: "Bu oturum a\xe7ma y\xf6ntemi etkin değil.",
    same_password: "Yeni şifre, eski şifrenizle aynı olamaz.",
    password_required_in_profile: "Oturum a\xe7madan \xf6nce bir şifre belirlemeniz gerekiyor.",
    new_password_required_in_profile: "Yeni bir şifre belirlemeniz gerekiyor.",
    password_exists_in_profile: "Şifre profilinizde zaten mevcut.",
    username_required_in_profile: "Oturum a\xe7madan \xf6nce bir kullanıcı adı belirlemeniz gerekiyor.",
    username_exists_in_profile: "Kullanıcı adı profilinizde zaten mevcut.",
    email_required_in_profile: "Oturum a\xe7madan \xf6nce bir e-posta adresi eklemeniz gerekiyor.",
    email_exists_in_profile: "Profiliniz zaten bir e-posta adresi ile ilişkilendirilmiştir.",
    phone_required_in_profile: "Oturum a\xe7madan \xf6nce bir telefon numarası eklemeniz gerekiyor.",
    phone_exists_in_profile: "Profiliniz zaten bir telefon numarası ile ilişkilendirilmiştir.",
    email_or_phone_required_in_profile: "Oturum a\xe7madan \xf6nce bir e-posta adresi veya telefon numarası eklemeniz gerekiyor.",
    suspended: "Bu hesap askıya alındı.",
    user_not_exist: "{{identifier}} kimliğine sahip kullanıcı mevcut değil.",
    missing_profile: "Oturum a\xe7madan \xf6nce ek bilgi sağlamanız gerekiyor.",
    role_exists: "{{roleId}} rol kimliği bu kullanıcıya zaten eklenmiştir.",
    invalid_role_type: "Ge\xe7ersiz rol t\xfcr\xfc, makine-makine rol\xfc kullanıcıya atanamaz.",
    missing_mfa: "You need to bind additional MFA before signing-in.",
    totp_already_in_use: "TOTP is already in use.",
    backup_code_already_in_use: "Backup code is already in use."
};
var $bfd1fec6f0f4706a$export$2e2bcd8739ae039 = Object.freeze($bfd1fec6f0f4706a$var$user);


const $d434f8ac64aa9c8a$var$verification_code = {
    phone_email_empty: "Telefon ve e-posta alanları boş.",
    not_found: "Doğrulama kodu bulunamadı. L\xfctfen \xf6nce doğrulama kodu g\xf6nderin.",
    phone_mismatch: "Telefon eşleşmiyor. L\xfctfen yeni bir doğrulama kodu isteyin.",
    email_mismatch: "E-posta eşleşmiyor. L\xfctfen yeni bir doğrulama kodu isteyin.",
    code_mismatch: "Ge\xe7ersiz doğrulama kodu.",
    expired: "Doğrulama kodu s\xfcresi dolmuştur. L\xfctfen yeni bir doğrulama kodu isteyin.",
    exceed_max_try: "Doğrulama kodu deneme sınırı aşıldı. L\xfctfen yeni bir doğrulama kodu isteyin."
};
var $d434f8ac64aa9c8a$export$2e2bcd8739ae039 = Object.freeze($d434f8ac64aa9c8a$var$verification_code);


const $8a1974111374551f$var$errors = {
    request: $4b7cd511416653e8$export$2e2bcd8739ae039,
    auth: $f168e0f193772e42$export$2e2bcd8739ae039,
    guard: $b7cd213a53738302$export$2e2bcd8739ae039,
    oidc: $ccd00c5bb028535e$export$2e2bcd8739ae039,
    user: $bfd1fec6f0f4706a$export$2e2bcd8739ae039,
    password: $06ef9fcff3c92434$export$2e2bcd8739ae039,
    session: $48136c4b12252356$export$2e2bcd8739ae039,
    connector: $80c2cf34d853b95b$export$2e2bcd8739ae039,
    verification_code: $d434f8ac64aa9c8a$export$2e2bcd8739ae039,
    sign_in_experiences: $a981a8a1b6710b3f$export$2e2bcd8739ae039,
    localization: $42c18f84a9473670$export$2e2bcd8739ae039,
    swagger: $65122502b26bae79$export$2e2bcd8739ae039,
    entity: $3e9d18420b1e199d$export$2e2bcd8739ae039,
    log: $77304f6510a26ffb$export$2e2bcd8739ae039,
    role: $c1a01bf885c4818c$export$2e2bcd8739ae039,
    scope: $bdbdd50772ee17da$export$2e2bcd8739ae039,
    storage: $96743c1236ccb2f9$export$2e2bcd8739ae039,
    resource: $18cdcf6dc6a066aa$export$2e2bcd8739ae039,
    hook: $e1b79662cea6a1ed$export$2e2bcd8739ae039,
    domain: $cd93659bee6e3734$export$2e2bcd8739ae039,
    subscription: $d549f53f2f9886f4$export$2e2bcd8739ae039,
    application: $69da94c0b15241a8$export$2e2bcd8739ae039,
    organization: $44df3c34cdc62b52$export$2e2bcd8739ae039,
    single_sign_on: $a4d5ddaf86fe0d4e$export$2e2bcd8739ae039
};
var $8a1974111374551f$export$2e2bcd8739ae039 = Object.freeze($8a1974111374551f$var$errors);


const $b8e08e9cb2b5e41f$var$api_resource_details = {
    page_title: "API Kaynak detayları",
    back_to_api_resources: "API Kaynaklarına geri d\xf6n",
    settings_tab: "Ayarlar",
    permissions_tab: "İzinler",
    settings: "Ayarlar",
    settings_description: "API kaynakları, Resource g\xf6stergeleri olarak da bilinir. Genellikle, kaynağın kimliğini temsil eden bir URI formatındaki değişkeni i\xe7erir.",
    management_api_settings_description: "Logto Y\xf6netim API'si, y\xf6neticilerin kimlikle ilgili bir\xe7ok g\xf6revi y\xf6netmelerine, g\xfcvenlik politikalarını uygulamalarına ve y\xf6netmeliklere ve standartlara uyum sağlamalarına olanak tanıyan kapsamlı bir API koleksiyonudur.",
    management_api_notice: "Bu API Logto varlığını temsil eder ve değiştirilemez veya silinemez. Geniş bir kimlikle ilgili g\xf6revler yelpazesi i\xe7in y\xf6netim API'sini kullanabilirsiniz. <a>Daha fazla bilgi</a>",
    token_expiration_time_in_seconds: "Token sona erme s\xfcresi (saniye)",
    token_expiration_time_in_seconds_placeholder: "Token zaman aşım s\xfcresini giriniz",
    delete_description: "Bu eylem geri alınamaz. API kaynakları kalıcı olarak silinecektir. L\xfctfen onaylamak i\xe7in API kaynak adını <span>{{name}}</span> giriniz.",
    enter_your_api_resource_name: "API kaynak adını giriniz.",
    api_resource_deleted: "{{name}} API kaynağı başarıyla silindi",
    permission: {
        create_button: "İzin Oluştur",
        create_title: "İzin Oluştur",
        create_subtitle: "Bu API tarafından gerektirilen izinleri (kapsamları) tanımlayın.",
        confirm_create: "İzin Oluştur",
        name: "İzin adı",
        name_placeholder: "read:kaynak",
        forbidden_space_in_name: "İzin adı boşluk i\xe7ermemelidir.",
        description: "A\xe7ıklama",
        description_placeholder: "Kaynakları okuyabilir.",
        permission_created: "{{name}} İzni başarıyla oluşturuldu.",
        delete_description: "Bu izin silinirse, bu iznin sağladığı erişimi alan kullanıcı da erişimi kaybedecektir.",
        deleted: '"{{name}}" izni başarıyla silindi.'
    }
};
var $b8e08e9cb2b5e41f$export$2e2bcd8739ae039 = Object.freeze($b8e08e9cb2b5e41f$var$api_resource_details);


const $60ee4953f71836cd$var$api_resources = {
    page_title: "API Kaynakları",
    title: "API Kaynakları",
    subtitle: "Yetkili uygulamalarınızdan kullanabileceğiniz API'leri tanımlayınız",
    create: "API Kaynağı oluştur",
    api_name: "API Adı",
    api_name_placeholder: "API adını giriniz",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "Api kaynağına \xf6zg\xfcn belirte\xe7. Mutlak URI olmalı ve par\xe7a bileşeni (#) i\xe7ermemeli. OAuth 2.0deki <a>kaynak parametresine</a> eşittir.",
    default_api: "Varsayılan API",
    default_api_label: "Mandant başına sadece sıfır veya bir varsayılan API ayarlanabilir. Varsayılan bir API belirlendiğinde, auth isteğindeki kaynak parametresi \xe7ıkarılabilir. Sonraki token değişimlerinde varsayılan olarak bu API hedef alınarak JWTler oluşturulur. <a>Daha fazla bilgi edinin</a>",
    api_resource_created: "{{name}} API kaynağı başarıyla oluşturuldu"
};
var $60ee4953f71836cd$export$2e2bcd8739ae039 = Object.freeze($60ee4953f71836cd$var$api_resources);


const $cb85ca4be43d756c$var$application_details = {
    page_title: "Uygulama detayları",
    back_to_applications: "Uygulamalara geri d\xf6n",
    check_guide: "Kılavuza G\xf6z At",
    settings: "Ayarlar",
    settings_description: "Uygulamalar, Logto i\xe7in OIDC, oturum a\xe7ma deneyimi, denetim kayıtları vb. alanlarda uygulamalarınızı tanımlamak i\xe7in kullanılır.",
    advanced_settings: "Gelişmiş ayarlar",
    advanced_settings_description: "Gelişmiş ayarlar, OIDC ile ilgili terimleri i\xe7erir. Daha fazla bilgi i\xe7in Token Bitiş Noktasına bakabilirsiniz.",
    application_roles: "Roller",
    machine_logs: "Makine g\xfcnl\xfckleri",
    application_name: "Uygulama Adı",
    application_name_placeholder: "Uygulamam",
    description: "A\xe7ıklama",
    description_placeholder: "Uygulama a\xe7ıklamasını giriniz",
    config_endpoint: "OpenID Provider yapılandırma bitiş noktası",
    authorization_endpoint: "Yetkilendirme bitiş noktası",
    authorization_endpoint_tip: "Kimlik doğrulama ve yetkilendirme ger\xe7ekleştirmek i\xe7in bitiş noktası. OpenID Connect <a>Authentication</a> i\xe7in kullanılır.",
    logto_endpoint: "Logto bitiş noktası",
    application_id: "Uygulama IDsi",
    application_id_tip: 'Logto tarafından normalde oluşturulan benzersiz uygulama tanımlayıcısıdır. Ayrıca OpenID Connect "client_id" anlamına gelir.',
    application_secret: "Uygulama Sırrı",
    redirect_uri: "Y\xf6nlendirme URIı",
    redirect_uris: "Y\xf6nlendirme URIları",
    redirect_uri_placeholder: "https://siteniz.com/uygulama",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "URI, kullanıcının oturum a\xe7ma işlemi tamamlandıktan sonra y\xf6nlendirir (başarılı olsa da olmasa da). Ayrıntılı bilgi i\xe7in OpenID Connect <a>AuthRequesta</a> bakınız.",
    post_sign_out_redirect_uri: "Oturumdan \xc7ıkış sonrası y\xf6nlendirme URIı",
    post_sign_out_redirect_uris: "Oturumdan \xc7ıkış sonrası y\xf6nlendirme URIları",
    post_sign_out_redirect_uri_placeholder: "https://siteniz.com/anasayfa",
    post_sign_out_redirect_uri_tip: "URI, Oturumdan \xc7ıkış sonrası y\xf6nlendirme yapar (isteğe bağlıdır). Bazı uygulama t\xfcrlerinde pratik bir etkisi olmayabilir.",
    cors_allowed_origins: "CORS izinli originler",
    cors_allowed_origins_placeholder: "https://siteniz.com",
    cors_allowed_origins_tip: "Varsayılan olarak, Y\xf6nlendirme URIlerinin t\xfcm originlerine izin verilir. Genellikle bu alan i\xe7in herhangi bir işlem gerekmez. Ayrıntılı bilgi i\xe7in <a>MDN doc</a> sayfasına bakın.",
    token_endpoint: "Token bitiş noktası",
    user_info_endpoint: "Userinfo bitiş noktası",
    enable_admin_access: "Y\xf6netici erişimini etkinleştir",
    enable_admin_access_label: "Y\xf6netim API erişimine izin verme veya engelleme. Etkinleştirildikten sonra, bu uygulama adına y\xf6netim API'sini \xe7ağırmak i\xe7in erişim belirte\xe7leri kullanabilirsiniz.",
    always_issue_refresh_token: "Her zaman Refresh Token ver",
    always_issue_refresh_token_label: "Bu yapılandırmayı etkinleştirmek, Logto'nun OpenID Connect ile uyumlu olmayan ve olası sorunlara neden olabilecek her zaman Refresh Token \xe7ıkarmasına izin verir `prompt=consent` kimlik doğrulama isteğinin sunulup sunulmadığına bakılmaksızın. Ancak, bu uygulama yalnızca zorunlu olduğunda caydırılmayan bir uygulamadır.",
    refresh_token_ttl: "Refresh Token s\xfcresi (g\xfcn cinsinden)",
    refresh_token_ttl_tip: "Yeni erişim belirteği istekleri i\xe7in Refresh Belirteği kullanılabilecek s\xfcre. Belirteğin s\xfcresi dolmadan \xf6nce yapılan talepler belirteğin \xf6mr\xfcn\xfc uzatacaktır.",
    rotate_refresh_token: "Refresh Tokenı değiştir",
    rotate_refresh_token_label: "Bu se\xe7enek etkinleştirildiğinde, Logto Token Bitiş S\xfcresinin %70'i ge\xe7ildiğinde veya belli koşullar sağlandığında yeni bir Refresh Token verecektir. <a>Daha fazlası i\xe7in tıklayın</a>",
    delete_description: "Bu eylem geri alınamaz. Uygulama kalıcı olarak silinecektir. L\xfctfen onaylamak i\xe7in uygulama adı <span>{{name}}</span> girin.",
    enter_your_application_name: "Uygulama adı giriniz",
    application_deleted: "{{name}} Uygulaması başarıyla silindi",
    redirect_uri_required: "En az 1 y\xf6nlendirme URIı girmelisiniz",
    roles: {
        name_column: "Rol",
        description_column: "A\xe7ıklama",
        assign_button: "Rolleri Ata",
        delete_description: "Bu işlem bu role bu makine-makine uygulamasından kaldıracaktır. Rol kendisi hala var olacak, ancak artık makine-makine uygulamasıyla ilişkilendirilmeyecektir.",
        deleted: "{{name}}, bu kullanıcıdan başarıyla kaldırıldı.",
        assign_title: "{{name}}'a rolleri atayın",
        assign_subtitle: "{{name}} i\xe7in bir veya daha fazla rol yetkilendirin",
        assign_role_field: "Rolleri Ata",
        role_search_placeholder: "Rol adıyla arama yapın",
        added_text: "{{value, number}} eklendi",
        assigned_app_count: "{{value, number}} uygulamalar",
        confirm_assign: "Rolleri Ata",
        role_assigned: "Başarıyla rol(ler) atandı",
        search: "Rol adı, a\xe7ıklaması veya ID'si ile arama yapın",
        empty: "Mevcut rol yok"
    }
};
var $cb85ca4be43d756c$export$2e2bcd8739ae039 = Object.freeze($cb85ca4be43d756c$var$application_details);


const $f55bfa9d78640131$var$applications = {
    page_title: "Uygulamalar",
    title: "Uygulamalar",
    subtitle: "Kimlik doğrulaması i\xe7in Logtoyu kullanmak \xfczere mobil, tek sayfa, machine to machine veya geleneksel bir uygulama ayarlayınız",
    subtitle_with_app_type: "Logto Doğrulamasını {{name}} uygulamanız i\xe7in yapılandırın",
    create: "Uygulama oluştur",
    application_name: "Uygulama adı",
    application_name_placeholder: "Uygulamam",
    application_description: "Uygulama a\xe7ıklaması",
    application_description_placeholder: "Uygulama a\xe7ıklaması giriniz",
    select_application_type: "Uygulama tipi se\xe7iniz",
    no_application_type_selected: "Hen\xfcz bir uygulama tipi se\xe7mediniz",
    application_created: "Uygulaması başarıyla oluşturuldu.",
    app_id: "App ID",
    type: {
        native: {
            title: "Native Uygulama",
            subtitle: "Nativede \xe7alışan bir uygulama ",
            description: "\xd6rneğin, iOS uygulaması, Android uygulaması"
        },
        spa: {
            title: "Tek sayfalı uygulama",
            subtitle: "Bir web tarayıcısında \xe7alışan ve verileri yerinde dinamik olarak g\xfcncelleyen bir uygulama",
            description: "\xd6rneğin, React DOM uygulaması, Vue uygulaması"
        },
        traditional: {
            title: "Geleneksel Web",
            subtitle: "Sayfaları yalnızca web sunucusu tarafından işleyen ve g\xfcncelleyen bir uygulama",
            description: "\xd6rneğin, JSP, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "Kaynaklarla doğrudan iletişim kuran bir uygulama (genellikle bir servis)",
            description: "\xd6rneğin, Backend servisi"
        }
    },
    placeholder_title: "Devam etmek i\xe7in bir uygulama tipi se\xe7in",
    placeholder_description: "Logto, uygulamanızı tanımlamaya, oturum a\xe7mayı y\xf6netmeye ve denetim kayıtları oluşturmaya yardımcı olmak i\xe7in OIDC i\xe7in bir uygulama varlığı kullanır."
};
var $f55bfa9d78640131$export$2e2bcd8739ae039 = Object.freeze($f55bfa9d78640131$var$applications);


const $ca309540295c098c$var$cloud = {
    general: {
        onboarding: "Başlatma"
    },
    welcome: {
        page_title: "Hoş geldiniz",
        title: "Logto Cloud'a hoş geldiniz! Sizi biraz tanımak istiyoruz.",
        description: "Sizi daha iyi tanıyarak Logto deneyiminizi size \xf6zel hale getirelim. Bilgileriniz bizimle g\xfcvende.",
        project_field: "Logto'yu kullanıyorum \xe7\xfcnk\xfc",
        project_options: {
            personal: "Kişisel proje",
            company: "Şirket projesi"
        },
        title_field: "Uygun başlığı se\xe7in",
        title_options: {
            developer: "Geliştirici",
            team_lead: "Takım Lideri",
            ceo: "CEO",
            cto: "CTO",
            product: "\xdcr\xfcn",
            others: "Diğerleri"
        },
        company_name_field: "Şirket adı",
        company_name_placeholder: "Acme.co",
        company_size_field: "Şirketinizin boyutu nasıl?",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "Kaydolma nedenim",
        reason_options: {
            passwordless: "Parolasız kimlik doğrulama ve UI kit arayışı",
            efficiency: "Kutudan \xe7ıkan kimlik altyapısı arayışı",
            access_control: "Kullanıcının rollerine ve sorumluluklarına g\xf6re erişim kontrol\xfc",
            multi_tenancy: "\xc7ok kiracılı bir \xfcr\xfcn i\xe7in stratejiler arayışı",
            enterprise: "Enterprize hazır SSO \xe7\xf6z\xfcmleri arayışı",
            others: "Diğerleri"
        }
    },
    sie: {
        page_title: "Oturum a\xe7ma deneyimini \xf6zelleştirin",
        title: "\xd6ncelikle giriş deneyiminizi kolaylıkla \xf6zelleştirin",
        inspire: {
            title: "Etkileyici \xf6rnekler oluşturun",
            description: 'Giriş deneyiminizden emin değilseniz, sadece "Beni İlhamla"ya tıklayın ve sihrin ger\xe7ekleşmesine izin verin!',
            inspire_me: "Beni ilhamla"
        },
        logo_field: "Uygulama Logosu",
        color_field: "Marka rengi",
        identifier_field: "Tanımlayıcı",
        identifier_options: {
            email: "E-posta",
            phone: "Telefon",
            user_name: "Kullanıcı adı"
        },
        authn_field: "Kimlik doğrulama",
        authn_options: {
            password: "Şifre",
            verification_code: "Doğrulama kodu"
        },
        social_field: "Sosyal oturum a\xe7ma",
        finish_and_done: "Bitir ve tamamla",
        preview: {
            mobile_tab: "Mobil",
            web_tab: "Web"
        },
        connectors: {
            unlocked_later: "Daha sonra kilidi a\xe7ılacak",
            unlocked_later_tip: "Onboarding s\xfcrecini tamamladıktan ve \xfcr\xfcne girdikten sonra, daha fazla sosyal oturum a\xe7ma y\xf6ntemine erişiminiz olacaktır.",
            notice: "L\xfctfen \xfcretim ama\xe7lı olarak demo konekt\xf6r\xfcn\xfc kullanmaktan ka\xe7ının. Testi tamamladıktan sonra l\xfctfen demo konekt\xf6r\xfcn\xfc silin ve kendi kimlik bilgilerinizle kendi konekt\xf6r\xfcn\xfcz\xfc ayarlayın."
        }
    },
    socialCallback: {
        title: "Başarıyla giriş yaptınız",
        description: "Sosyal hesabınızı kullanarak başarılı bir şekilde giriş yaptınız. Logto'nun t\xfcm \xf6zelliklerine sorunsuz entegrasyon ve erişim sağlamak i\xe7in kendi sosyal konekt\xf6r\xfcn\xfcz\xfc yapılandırmaya devam etmenizi \xf6neririz."
    },
    tenant: {
        create_tenant: "Kiracı Oluştur"
    }
};
var $ca309540295c098c$export$2e2bcd8739ae039 = Object.freeze($ca309540295c098c$var$cloud);


const $761cbe73064b7485$var$components = {
    uploader: {
        action_description: "S\xfcr\xfckle ve bırak veya g\xf6zat",
        uploading: "Y\xfckleniyor...",
        image_limit: "{{size, number}}KB altındaki resimleri y\xfckleyin, yalnızca {{extensions, list(style: narrow; type: conjunction;)}} dosyaları kabul edilir.",
        error_upload: "Bir şeyler yanlış gitti. Dosya y\xfcklenemedi.",
        error_file_size: "Dosya boyutu \xe7ok b\xfcy\xfck. L\xfctfen {{size, number}}KB altında bir dosya y\xfckleyin.",
        error_file_type: "Dosya t\xfcr\xfc desteklenmiyor. Yalnızca {{extensions, list(style: narrow; type: conjunction;)}} dosyaları kabul edilir.",
        error_file_count: "Sadece 1 dosya y\xfckleyebilirsiniz."
    }
};
var $761cbe73064b7485$export$2e2bcd8739ae039 = Object.freeze($761cbe73064b7485$var$components);


const $e2fefe32e5790d85$var$connector_details = {
    page_title: "Bağdaştırıcı ayrıntıları",
    back_to_connectors: "Bağdaştırıcılara geri d\xf6n",
    check_readme: "READMEye bak",
    settings: "Genel ayarlar",
    settings_description: "Bağdaştırıcılar Logto'da kritik bir rol oynar. Onların yardımıyla, Logto son kullanıcıların şifresiz kayıt veya giriş yapmasını ve sosyal hesaplarla giriş yapabilme \xf6zelliklerini sağlar.",
    parameter_configuration: "Parametre yapılandırması",
    test_connection: "Bağlantıyı test et",
    save_error_empty_config: "L\xfctfen yapılandırmayı girin",
    send: "G\xf6nder",
    send_error_invalid_format: "Ge\xe7ersiz giriş",
    edit_config_label: "Json girin",
    test_email_sender: "Eposta bağdaştırıcınızı test edin",
    test_sms_sender: "SMS bağdaştırıcınızı test edin",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+90 555 123 45 67",
    test_message_sent: "Test mesajı g\xf6nderildi",
    test_sender_description: 'Logto testler i\xe7in "Generic" şablonunu kullanır. Bağlantınız doğru şekilde yapılandırılmışsa bir mesaj alacaksınız.',
    options_change_email: "Eposta bağdaştırıcınızı değiştirin",
    options_change_sms: "SMS bağdaştırıcınızı değiştirin",
    connector_deleted: "Bağdaştırıcı başarıyla silindi",
    type_email: "Eposta bağdaştırıcısı",
    type_sms: "SMS bağdaştırıcısı",
    type_social: "Sosyal bağdaştırıcı",
    in_used_social_deletion_description: "Bu bağdaştırıcı, giriş deneyiminizde kullanımda. Silerek, <name/> giriş deneyiminiz, giriş deneyimi ayarlarında silinecektir. Geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    in_used_passwordless_deletion_description: "Bu {{name}} giriş deneyiminizde kullanımda. Silerek, giriş deneyiminiz \xe7\xf6z\xfcl\xfcnceye kadar doğru \xe7alışmayacaktır. Geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    deletion_description: "Bu bağdaştırıcıyı kaldırıyorsunuz. Geri alınamaz ve geri eklemeye karar verirseniz yeniden yapılandırmanız gerekecektir.",
    logto_email: {
        total_email_sent: "Toplam e-posta g\xf6nderildi: {{value, number}}",
        total_email_sent_tip: "Logto dahili e-posta i\xe7in g\xfcvenli ve stabil SendGrid kullanır. Tamamen \xfccretsizdir. <a>Daha fazla bilgi edinin</a>",
        email_template_title: "E-posta Şablonu",
        template_description: "Yerleşik e-posta, doğrulama e-postalarının sorunsuz teslimi i\xe7in varsayılan şablonları kullanır. Herhangi bir yapılandırma gerektirmez ve temel marka bilgilerini \xf6zelleştirebilirsiniz.",
        template_description_link_text: "Şablonları g\xf6r\xfcnt\xfcle",
        description_action_text: "Şablonları g\xf6r\xfcnt\xfcle",
        from_email_field: "Kimden e-posta",
        sender_name_field: "G\xf6nderen adı",
        sender_name_tip: 'E-postalar i\xe7in g\xf6nderen adını \xf6zelleştirin. Boş bırakılırsa, varsayılan ad olarak "Verification" kullanılacaktır.',
        sender_name_placeholder: "G\xf6nderen adınızı girin",
        company_information_field: "Şirket bilgileri",
        company_information_description: "E-postaların alt kısmında şirket adınızı, adresinizi veya posta kodunuzu g\xf6r\xfcnt\xfcleyin.",
        company_information_placeholder: "Şirketinizin temel bilgileri",
        app_logo_field: "Uygulama Logosu",
        app_logo_tip: "E-postaların \xfcst\xfcnde marka logosunu g\xf6r\xfcnt\xfcleyin. Aynı g\xf6r\xfcnt\xfcy\xfc a\xe7ık mod ve karanlık mod i\xe7in kullanın.",
        urls_not_allowed: "URLler izin verilmez",
        test_notes: 'Logto testler i\xe7in "Generic" şablonunu kullanır.'
    }
};
var $e2fefe32e5790d85$export$2e2bcd8739ae039 = Object.freeze($e2fefe32e5790d85$var$connector_details);


const $712bacdbf96d6d4a$var$connectors = {
    page_title: "Connectorlar",
    title: "Connectorlar",
    subtitle: "Şifresiz ve sosyal oturum a\xe7ma deneyimini etkinleştirmek i\xe7in connectorları ayarlayınız.",
    create: "Sosyal Connector ekle",
    config_sie_notice: "Connectorları ayarladınız. <a>{{link}}</a> i\xe7inde yapılandırmayı yapın.",
    config_sie_link_text: "oturum a\xe7ma deneyimi",
    tab_email_sms: "E-posta ve SMS connectorları",
    tab_social: "Sosyal connectorlar",
    connector_name: "Connector adı",
    demo_tip: "Bu demo connector i\xe7in izin verilen maksimum mesaj sayısı 100 ile sınırlıdır ve \xfcretim ortamında dağıtılması \xf6nerilmez.",
    social_demo_tip: "Demo connector sadece g\xf6sterim ama\xe7lı tasarlanmıştır ve \xfcretim ortamında uygulanması \xf6nerilmez.",
    connector_type: "Tip",
    connector_status: "Oturum a\xe7ma deneyimi",
    connector_status_in_use: "Kullanımda",
    connector_status_not_in_use: "Kullanımda değil",
    not_in_use_tip: {
        content: "Kullanımda değil, oturum a\xe7ma deneyiminiz bu oturum a\xe7ma y\xf6ntemini kullanmamış demektir. <a>{{link}}</a> bağlantısını kullanarak bu oturum a\xe7ma y\xf6ntemini ekleyin.",
        go_to_sie: "Oturum a\xe7ma deneyimine git"
    },
    placeholder_title: "Sosyal connector",
    placeholder_description: "Logto, \xe7ok sayıda kullanılan sosyal oturum a\xe7ma connectorı sağlamıştır. Bu arada, standart protokollerle kendi connectorınızı oluşturabilirsiniz.",
    save_and_done: "Kaydet ve bitir",
    type: {
        email: "Eposta connectorı",
        sms: "SMS connectorı",
        social: "Sosyal connector"
    },
    setup_title: {
        email: "E-posta connectorı ayarla",
        sms: "SMS connectorı ayarla",
        social: "Sosyal Connector ekle"
    },
    guide: {
        subtitle: "Connectorı yapılandırmak i\xe7in adım adım kılavuz",
        general_setting: "Genel ayarlar",
        parameter_configuration: "Parametre konfig\xfcrasyonu",
        test_connection: "Bağlantıyı test et",
        name: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in ad",
        name_placeholder: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in ad girin",
        name_tip: 'Connector d\xfcğmesinin adı "{{name}} ile devam et" olarak g\xf6r\xfcnt\xfclenecektir. İsimlendirmenin uzunluğuna dikkat edin, \xe7ok uzun olursa bir sorun oluşabilir.',
        logo: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in logo URL",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "Logo resmi bağlantısı d\xfcğmede g\xf6r\xfcnt\xfclenecektir. Herkese a\xe7ık bir bağlantı alın ve bağlantıyı buraya yapıştırın.",
        logo_dark: "Sosyal oturum a\xe7ma d\xfcğmesi i\xe7in logo URL (Karanlık mod)",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "Karanlık modu etkinleştirdikten sonra connector logonuzu ayarlayın.",
        logo_dark_collapse: "Daralt",
        logo_dark_show: "Karanlık mod logu ayarını g\xf6ster",
        target: "Kimlik sağlayıcısı adı",
        target_placeholder: "Connector kimlik sağlayıcısı adını girin",
        target_tip: "“IdP adı” değeri, sosyal kimliklerinizi ayırt etmek i\xe7in benzersiz bir tanımlayıcı dize olabilir.",
        target_tip_standard: "“IdP adı” değeri, sosyal kimliklerinizi ayırt etmek i\xe7in benzersiz bir tanımlayıcı dize olabilir. Bu ayar, connector oluşturulduktan sonra değiştirilemez.",
        target_tooltip: 'Logto sosyal connectorlarındaki "Hedef", sosyal kimliklerinizin "kaynağı" na işaret eder. Logto tasarımında, aynı bir platformun "hedef" i kabul edilmez ve \xe7akışmaları \xf6nlemek i\xe7in benzersiz olmalıdır. Bir connector eklemeniz gerektiğinde \xe7ok dikkatli olmalısınız \xe7\xfcnk\xfc oluşturulduktan sonra "hedef" değerini DEĞİŞTİREMEZSİNİZ. <a>Daha fazla bilgi edinin</a>',
        target_conflict: "Kullanılan IdP adı, <span>adı</span> ile eşleşmektedir. Aynı idp adını kullanmak, kullanıcıların iki farklı connector aracılığıyla aynı hesaba erişebileceği şekilde beklenmeyen oturum a\xe7ma davranışına neden olabilir.",
        target_conflict_line2: 'Eski kullanıcıların yeniden kayıt olma olmadan oturum a\xe7masına izin vermek i\xe7in \xf6nceki <span>adı</span> connectorını silerek aynı "IdP adı" ile yeni bir connector oluşturmak isterseniz yapın.',
        target_conflict_line3: 'Farklı bir kimlik sağlayıcıya bağlanmak isterseniz, "IdP adı" nı değiştirin ve devam edin.',
        config: "Konfig\xfcrasyon JSON'ınızı girin",
        sync_profile: "Profil bilgisini senkronize et",
        sync_profile_only_at_sign_up: "Sadece kayıtta senkronize et",
        sync_profile_each_sign_in: "Her oturum a\xe7ma da her zaman senkronize et",
        sync_profile_tip: "Sosyal sağlayıcıdan temel profil (kullanıcıların adları ve avatarları gibi) senkronize edilsin.",
        callback_uri: "Geri d\xf6n\xfcş URI",
        callback_uri_description: "Ayrıca y\xf6nlendirme URI'si olarak adlandırılır, kullanıcıların sosyal yetkilendirmeden sonra Logto'ya geri g\xf6nderilecekleri URI'dir, ve sosyal sağlayıcının yapılandırma sayfasına kopyalayın yapıştırın."
    },
    platform: {
        universal: "Evrensel",
        web: "Web",
        native: "Native"
    },
    add_multi_platform: " birden fazla platformu destekler, devam etmek i\xe7in bir platform se\xe7in",
    drawer_title: "Connector Kılavuzu",
    drawer_subtitle: "Connectorı entegre etmek i\xe7in y\xf6nergeleri izleyin",
    unknown: "Bilinmeyen connector",
    standard_connectors: "Standart connectorlar"
};
var $712bacdbf96d6d4a$export$2e2bcd8739ae039 = Object.freeze($712bacdbf96d6d4a$var$connectors);


const $0205e98bb63dd907$var$contact = {
    title: "Yardım alın",
    description: "Yardım istekleri veya \xfcr\xfcn geribildirimleri i\xe7in l\xfctfen aşağıdaki y\xf6ntemlerle bizimle iletişime ge\xe7in.",
    discord: {
        title: "Discord topluluğuna katıl",
        description: "Diğer geliştiricilerle bağlantı kurup \xe7\xf6z\xfcmler bulun",
        button: "Katıl"
    },
    github: {
        title: "GitHub \xfczerinden iletişim kurun",
        description: "Bir sorun oluşturun ve GitHub'a g\xf6nderin",
        button: "A\xe7ık"
    },
    email: {
        title: "E-posta ile destek iletişimi",
        description: "Daha fazla bilgi ve yardım i\xe7in bize e-posta g\xf6nderin",
        button: "Send"
    },
    reserve: {
        title: "Logto ekibiyle zaman ayırın",
        description: "Hızlı bir g\xf6r\xfcşme i\xe7in oturum ayırın",
        button: "Programa al"
    }
};
var $0205e98bb63dd907$export$2e2bcd8739ae039 = Object.freeze($0205e98bb63dd907$var$contact);


const $6996db480eff8827$var$dashboard = {
    page_title: "G\xf6sterge Paneli",
    title: "G\xf6sterge Paneli",
    description: "Uygulamanızın performansı hakkında genel bir bakış elde edin",
    total_users: "T\xfcm Kullanıcılar",
    total_users_tip: "T\xfcm kullanıcılar",
    new_users_today: "Bug\xfcn katılan kullanıcılar",
    new_users_today_tip: "Uygulamamıza bug\xfcn katılan yeni kullanıcı sayısı",
    new_users_7_days: "Son 7 g\xfcnde katılan kullanıcılar",
    new_users_7_days_tip: "Uygulamamıza son 7 g\xfcnde katılan kullanıcı sayısı",
    daily_active_users: "G\xfcnl\xfck aktif kullanıcılar",
    daily_active_users_tip: "Bug\xfcn uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı",
    weekly_active_users: "Haftalık aktif kullanıcılar",
    weekly_active_users_tip: "Son 7 g\xfcnde uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı",
    monthly_active_users: "Aylık aktif kullanıcılar",
    monthly_active_users_tip: "Son 30 g\xfcnde uygulamalarınızda token değişiminde bulunan \xf6zg\xfcn kullanıcı sayısı"
};
var $6996db480eff8827$export$2e2bcd8739ae039 = Object.freeze($6996db480eff8827$var$dashboard);


const $850add962c790fda$var$domain = {
    status: {
        connecting: "Bağlanıyor",
        in_used: "Kullanımda",
        failed_to_connect: "Bağlantı başarısız oldu"
    },
    update_endpoint_notice: "\xd6zellikleri i\xe7in \xf6zel bir alan adı kullanmak istiyorsanız, uygulamanızda Sosyal bağlayıcı geri \xe7ağrı URI ve Logto u\xe7 noktası i\xe7in alan adını g\xfcncellemeyi unutmayın. <a>{{link}}</a>",
    error_hint: "DNS kayıtlarınızı g\xfcncellediğinizden emin olunuz. {{value}} saniyede bir kontrol edeceğiz.",
    custom: {
        custom_domain: "\xd6zel Alan Adı",
        custom_domain_description: "Markalaşmanızı geliştirin ve \xf6zel bir alan adı kullanın. Bu alan adı oturum a\xe7ma deneyiminizde kullanılacaktır.",
        custom_domain_field: "\xd6zel alan adı",
        custom_domain_placeholder: "alan_adınız.com",
        add_domain: "Alan Adı Ekle",
        invalid_domain_format: "Ge\xe7ersiz alt alan adı bi\xe7imi. L\xfctfen en az \xfc\xe7 par\xe7adan oluşan bir alt alan adı girin.",
        verify_domain: "Alan adınızı doğrulayın",
        enable_ssl: "SSL etkinleştirilsin mi",
        checking_dns_tip: "DNS kayıtlarını yapılandırdıktan sonra, işlem otomatik olarak \xe7alışır ve 24 saate kadar s\xfcrebilir. Bu aray\xfczden ayrılabilirsiniz.",
        enable_ssl_tip: "SSL etkinleştirilsin mi otomatik olarak \xe7alışır ve 24 saate kadar s\xfcrebilir. Bu aray\xfczden ayrılabilirsiniz.",
        generating_dns_records: "DNS kayıtları oluşturuluyor...",
        add_dns_records: "L\xfctfen bu DNS kayıtlarını DNS sağlayıcınıza ekleyin.",
        dns_table: {
            type_field: "Tip",
            name_field: "İsim",
            value_field: "Değer"
        },
        deletion: {
            delete_domain: "Alan Adını Sil",
            reminder: "\xd6zel Alan Adını Sil",
            description: "Bu \xf6zel alan adını silmek istediğinizden emin misiniz?",
            in_used_description: 'Bu "<span>{{domain}}</span>" adlı \xf6zel alan adını silmek istediğinizden emin misiniz?',
            in_used_tip: 'Bu \xf6zel alan adını \xf6nce sosyal bağlantı sağlayıcınızda veya uygulama u\xe7 noktasında yapılandırdıysanız, URI\'yi \xf6nce Logto varsayılan alan adı olan "<span>{{domain}}</span>" olarak değiştirmeniz gerekir. Bu, sosyal giriş d\xfcğmesinin d\xfczg\xfcn \xe7alışması i\xe7in gereklidir.',
            deleted: "\xd6zel alan adı başarıyla silindi!"
        }
    },
    default: {
        default_domain: "Varsayılan Alan Adı",
        default_domain_description: "Logto, ek bir yapılandırma olmadan kullanıma hazır \xf6nceden yapılandırılmış bir varsayılan alan adı sunar. Bu varsayılan alan adı, \xf6zel bir alan adı etkinleştirdiyseniz bile yedek se\xe7eneği olarak hizmet verir.",
        default_domain_field: "Logto varsayılan alan adı"
    },
    custom_endpoint_note: 'Bu u\xe7 noktaların alan adını \xf6zelleştirebilirsiniz. "{{custom}}" veya "{{default}}" se\xe7eneklerinden birini se\xe7in.',
    custom_social_callback_url_note: 'Bu URI\'nin alan adını uygulamanızın u\xe7 noktasıyla eşleştirmek i\xe7in \xf6zelleştirebilirsiniz. "{{custom}}" veya "{{default}}" se\xe7eneklerinden birini se\xe7in.'
};
var $850add962c790fda$export$2e2bcd8739ae039 = Object.freeze($850add962c790fda$var$domain);


const $2a7727f9880d6119$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $2a7727f9880d6119$export$2e2bcd8739ae039 = Object.freeze($2a7727f9880d6119$var$enterprise_sso_details);


const $a8a927b040c434d6$var$enterprise_sso = {
    page_title: "Kurumsal SSO",
    title: "Kurumsal SSO",
    subtitle: "Kurumsal kimlik sağlayıcısını bağlayın ve SP başlatmalı Tek Oturum A\xe7mayı etkinleştirin.",
    create: "Kurumsal bağlayıcı ekle",
    col_connector_name: "Bağlayıcı adı",
    col_type: "T\xfcr",
    col_email_domain: "E-posta etki alanı",
    placeholder_title: "Kurumsal bağlayıcı",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "Kurumsal bağlayıcı ekle",
        text_divider: "Ya da standart bir protokol ile bağlayıcınızı \xf6zelleştirebilirsiniz.",
        connector_name_field_title: "Bağlayıcı adı",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "Bağlayıcı Oluştur"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $a8a927b040c434d6$export$2e2bcd8739ae039 = Object.freeze($a8a927b040c434d6$var$enterprise_sso);


const $dbfbfcc40fbef071$var$errors = {
    something_went_wrong: "Hata! Bir şeyler yanlış gitti.",
    page_not_found: "Sayfa bulunamadı",
    unknown_server_error: "Bilinmeyen sunucu hatası oluştu",
    empty: "Veri yok",
    missing_total_number: "Yanıt başlıklarında Toplam Sayı bulunamadı",
    invalid_uri_format: "Ge\xe7ersiz URI bi\xe7imi",
    invalid_origin_format: "Ge\xe7ersiz URI kaynak bi\xe7imi",
    invalid_json_format: "Ge\xe7ersiz JSON bi\xe7imi",
    invalid_error_message_format: "Hata mesajı bi\xe7imi ge\xe7ersiz.",
    required_field_missing: "L\xfctfen {{field}} giriniz",
    required_field_missing_plural: "En az bir {{field}} girmek zorundasınız.",
    more_details: "Daha \xe7ok detay",
    username_pattern_error: "Kullanıcı adı yalnızca harf, sayı veya alt \xe7izgi i\xe7ermeli ve bir sayı ile başlamamalıdır.",
    email_pattern_error: "E-posta adresi ge\xe7ersiz.",
    phone_pattern_error: "Telefon numarası ge\xe7ersiz.",
    insecure_contexts: "G\xfcvenli olmayan bağlamlar (HTTPS olmayan) desteklenmez.",
    unexpected_error: "Beklenmedik bir hata oluştu",
    not_found: "404 bulunamadı",
    create_internal_role_violation: 'Yeni bir dahili rol oluşturuyorsunuz, bu Logto tarafından yasaklanmıştır. "#internal:" ile başlamayan başka bir ad deneyin.',
    should_be_an_integer: "Tamsayı olmalıdır.",
    number_should_be_between_inclusive: "Sayı {{min}} ve {{max}} arasında (her ikisi de dahil) olmalıdır."
};
var $dbfbfcc40fbef071$export$2e2bcd8739ae039 = Object.freeze($dbfbfcc40fbef071$var$errors);


const $c24485abd64781a2$var$general = {
    placeholder: "Yer tutucu",
    submit: "G\xf6nder",
    skip: "Atla",
    next: "Sonraki",
    back: "Geri",
    retry: "Tekrar Deneyin",
    done: "Bitti",
    search: "Ara",
    search_placeholder: "Ara",
    clear_result: "Sonu\xe7ları Temizle",
    save: "Kaydet",
    save_changes: "Değişiklikleri Kaydet",
    saved: "Kaydedildi",
    discard: "At",
    loading: "Y\xfckleniyor...",
    redirecting: "Y\xf6nlendiriliyor...",
    add: "Ekle",
    added: "Eklendi",
    cancel: "İptal Et",
    confirm: "Onayla",
    check_out: "G\xf6z At",
    create: "Oluştur",
    set_up: "Kur",
    customize: "\xd6zelleştir",
    enable: "Etkinleştir",
    reminder: "Hatırlatıcı",
    delete: "Sil",
    more_options: "DAHA FAZLA SE\xc7ENEK",
    close: "Kapat",
    copy: "Kopyala",
    copying: "Kopyalanıyor",
    copied: "Kopyalandı",
    required: "Gerekli",
    add_another: "Bir tane daha ekle",
    create_another: "Başka bir tane oluştur",
    deletion_confirmation: "Bu dosyayı silmek istediğinize emin misiniz: {{title}}?",
    settings_nav: "Ayarlar",
    unsaved_changes_warning: "Bazı değişiklikler yaptınız. Bu sayfadan ayrılmak istediğine emin misin?",
    leave_page: "Sayfayı terk et",
    stay_on_page: "Bu sayfada kal",
    type_to_search: "Aramak i\xe7in yazın",
    got_it: "Anladım",
    continue: "Devam et",
    page_info: "{{min, number}}-{{max, number}} / {{total, number}}",
    learn_more: "Daha fazla bilgi edinin",
    tab_errors: "{{count, number}} hata",
    skip_for_now: "Şimdilik atla",
    remove: "Kaldır",
    visit: "Ziyaret et",
    join: "Katıl",
    try_now: "Şimdi dene",
    multiple_form_field: "(\xc7oklu)",
    demo: "Demo",
    unnamed: "İsimsiz",
    view: "G\xf6r\xfcn\xfcm",
    hide: "Gizle",
    unknown_error: "Bilinmeyen hata, l\xfctfen daha sonra tekrar deneyin.",
    select: "Se\xe7",
    contact_us_action: "Bizimle İletişime Ge\xe7in",
    description: "A\xe7ıklama",
    name: "Ad",
    add_field: "{{field}} Ekle",
    create_field: "{{field}} Oluştur",
    edit_field: "{{field}} D\xfczenle",
    delete_field: "{{field}} Sil",
    coming_soon: "Yakında",
    beta_notice: "\uD83C\uDF89  {{feature}} şu anda beta s\xfcr\xfcm\xfcnde. Keşfetmeye hoş geldiniz ve <ContactLink>geri bildiriminizi paylaşın</ContactLink>."
};
var $c24485abd64781a2$export$2e2bcd8739ae039 = Object.freeze($c24485abd64781a2$var$general);


const $17ce5480919367cb$var$get_started = {
    page_title: "Başlangıca Başlayın",
    title: "Başarınızı Desteklemek İ\xe7in Keşfedilecek Bir Şey",
    subtitle: "Logto'nun değerini hızla elde etmek i\xe7in yapabileceğiniz birka\xe7 şey",
    develop: {
        title: "Geliştir: Uygulamanızı entegre etmek i\xe7in 5 dakika ayırın"
    },
    customize: {
        title: "\xd6zelleştir: Harika bir oturum a\xe7ma deneyimi sunun",
        preview: {
            title: "Yeni \xf6zelleştirdiğiniz oturum a\xe7ma deneyiminin canlı \xf6nizlemesini kontrol edin",
            subtitle: "Nasıl \xe7alıştığını g\xf6rmek i\xe7in şimdi Logto oturum a\xe7ma deneyimini deneyin"
        },
        connector: {
            title: "Daha fazla bağdaştırıcı ekleyerek daha fazla sosyal oturum a\xe7ma y\xf6ntemini destekleyin",
            subtitle: "Şifresiz oturum a\xe7mayı deneyin ve m\xfcşterileriniz i\xe7in g\xfcvenli ve s\xfcrt\xfcnmesiz bir deneyim sağlayın"
        },
        continue_customizing: "\xd6zelleştirmeye devam et",
        try_now: "Şimdi deneyin",
        add_more: "Daha fazla ekle"
    },
    secure: {
        title: "G\xfcvenli: Kaynaklarınızı koruyun"
    },
    manage: {
        title: "Y\xf6net: \xdcr\xfcn\xfcn\xfcz ve kullanıcılarınız i\xe7in erişim denetimi tanımlayın",
        rbac: {
            title: "Diverse kullanım durumları i\xe7in \xf6l\xe7eklenebilir rol yetkilendirmesi ile kaynaklarınızı koruyun",
            subtitle: "Kaynağınızı kontrol edin"
        },
        create_roles: "Roller oluştur"
    },
    view_all: "Hepsini g\xf6r\xfcnt\xfcle →"
};
var $17ce5480919367cb$export$2e2bcd8739ae039 = Object.freeze($17ce5480919367cb$var$get_started);


const $6cb8e6feb0f358a3$var$guide = {
    start_building: "Yapmaya başla",
    get_started: "Başlarken",
    categories: {
        featured: "Pop\xfcler ve size \xf6zel",
        Traditional: "Geleneksel web uygulaması",
        SPA: "Tek sayfalık uygulama",
        Native: "Doğal",
        MachineToMachine: "Makineden makineye"
    },
    filter: {
        title: "Framework'\xfc filtrele",
        placeholder: "Framework ara"
    },
    checkout_tutorial: "\xd6ğreticiyi kontrol et {{name}}",
    do_not_need_tutorial: "Eğer bir \xf6ğreticiye ihtiyacınız yoksa, \xe7er\xe7eve kılavuzu olmadan devam edebilirsiniz",
    finish_and_done: "Bitir ve tamamla",
    cannot_find_guide: "Kılavuzunuzu bulamıyor musunuz?",
    describe_guide_looking_for: "Aramakta olduğunuz kılavuzu a\xe7ıklayın",
    request_guide_successfully: "Talebiniz başarıyla g\xf6nderildi. Teşekk\xfcr ederim!",
    app: {
        select_framework_or_tutorial: "Bir \xe7er\xe7eve veya \xf6ğretici se\xe7in",
        guide_modal_title: "SDK ve kılavuzlarla başlayın",
        modal_subtitle: "\xd6nceden oluşturulmuş SDK ve \xf6ğreticilerimizle uygulama geliştirme s\xfcrecinize hız kazandırın.",
        select_a_framework: "Bir \xe7er\xe7eve se\xe7in",
        continue_without_framework: "\xc7er\xe7evesiz uygulama oluştur",
        describe_guide_looking_for_placeholder: "\xd6rneğin, Logto'yu Angular uygulamama entegre etmek istiyorum."
    },
    api: {
        modal_title: "\xd6ğreticilerle başlayın",
        modal_subtitle: "\xd6nceden oluşturulmuş \xf6ğreticilerimizle uygulama geliştirme s\xfcrecinize hız kazandırın.",
        select_a_tutorial: "Bir \xf6ğretici se\xe7in",
        continue_without_tutorial: "\xd6ğretici olmadan devam et",
        describe_guide_looking_for_placeholder: "\xd6rneğin, API'mı deno ile korumak istiyorum."
    }
};
var $6cb8e6feb0f358a3$export$2e2bcd8739ae039 = Object.freeze($6cb8e6feb0f358a3$var$guide);


const $4e986214ddc58fca$var$log_details = {
    page_title: "Denetim Kaydı Detayları",
    back_to_logs: "Denetim Kayıtlarına Geri D\xf6n",
    back_to: "{{name}}'in Kayıtlarına Geri D\xf6n",
    success: "Başarılı",
    failed: "Başarısız",
    event_key: "Olay Anahtarı",
    application: "Uygulama",
    ip_address: "IP Adresi",
    user: "Kullanıcı",
    log_id: "Kayıt Kimliği",
    time: "S\xfcre",
    user_agent: "Kullanıcı Aracısı",
    tab_details: "Detaylar",
    raw_data: "Ham Veri"
};
var $4e986214ddc58fca$export$2e2bcd8739ae039 = Object.freeze($4e986214ddc58fca$var$log_details);


const $ca0ba4e73e90edb3$var$logs = {
    page_title: "Denetim Kayıtları",
    title: "Denetim Kayıtları",
    subtitle: "Y\xf6neticiniz ve kullanıcılarınız tarafından yapılan kimlik doğrulama olaylarının kayıt verilerini g\xf6r\xfcnt\xfcleyin",
    event: "Durum",
    user: "Kullanıcı",
    application: "Uygulama",
    time: "S\xfcre",
    filter_by: "G\xf6re filtrele"
};
var $ca0ba4e73e90edb3$export$2e2bcd8739ae039 = Object.freeze($ca0ba4e73e90edb3$var$logs);


const $f9f820502d6de2d4$var$menu = {
    profile: "Profil",
    language: "Dil",
    appearance: {
        label: "G\xf6r\xfcn\xfcm",
        light: "A\xe7ık mod",
        dark: "Koyu mod",
        system: "Sistemle senkronize et"
    },
    sign_out: "\xc7ıkış Yap"
};
var $f9f820502d6de2d4$export$2e2bcd8739ae039 = Object.freeze($f9f820502d6de2d4$var$menu);


const $b28aa478a266376c$var$mfa = {
    title: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
    description: "Kimlik doğrulama deneyiminizin g\xfcvenliğini artırmak i\xe7in \xe7ok fakt\xf6rl\xfc kimlik doğrulamayı ekleyin.",
    factors: "Fakt\xf6rler",
    multi_factors: "\xc7oklu fakt\xf6rler",
    multi_factors_description: "Kullanıcılar, 2 aşamalı doğrulama i\xe7in etkinleştirilmiş fakt\xf6rlerden birini doğrulamalıdır.",
    totp: "Authenticator uygulama OTP",
    otp_description: "Google Authenticator vb. bağlayarak tek kullanımlık şifreleri doğrulamak i\xe7in.",
    webauthn: "WebAuthn (Pas anahtarı)",
    webauthn_description: "Tarayıcı tarafından desteklenen y\xf6ntemle doğrulama yapın: biyometri, telefon tarama veya g\xfcvenlik anahtarı vb.",
    webauthn_native_tip: "WebAuthn, Native uygulamalar i\xe7in desteklenmiyor.",
    webauthn_domain_tip: "WebAuthn, genel anahtarları belirli bir alanla ilişkilendirir. Hizmet alanınızı değiştirmek, kullanıcıların mevcut ge\xe7iş anahtarları aracılığıyla kimlik doğrulamasını engeller.",
    backup_code: "Yedek kod",
    backup_code_description: "Kullanıcılar herhangi bir MFA y\xf6ntemini ayarladıktan sonra 10 tek kullanımlık yedek kod \xfcretir.",
    backup_code_setup_hint: "Kullanıcılar yukarıdaki MFA fakt\xf6rlerini doğrulayamadığında yedek se\xe7eneğini kullanın.",
    backup_code_error_hint: "Bir yedek kodu kullanmak i\xe7in başarılı kullanıcı kimlik doğrulaması i\xe7in en az bir daha fazla MFA y\xf6nteme ihtiyacınız vardır.",
    policy: "Politika",
    policy_description: "Giriş ve kaydolma akışları i\xe7in MFA politikasını belirleyin.",
    two_step_sign_in_policy: "Girişte 2 aşamalı doğrulama politikası",
    user_controlled: "Kullanıcılar MFA'yı kendi başlarına etkinleştirebilir veya devre dışı bırakabilir",
    user_controlled_tip: "Kullanıcılar, giriş veya kayıt sırasında ilk kez MFA kurulumunu atlayabilir veya hesap ayarlarında etkinleştirebilir/devre dışı bırakabilir.",
    mandatory: "Kullanıcılar her zaman girişte MFA kullanmak zorundadır",
    mandatory_tip: "Kullanıcılar, ilk kez giriş veya kayıt sırasında MFA kurmalı ve t\xfcm gelecekteki girişlerde kullanmalıdır."
};
var $b28aa478a266376c$export$2e2bcd8739ae039 = Object.freeze($b28aa478a266376c$var$mfa);


const $88fa17918f2b4fd9$var$organization_details = {
    page_title: "Kuruluş detayları",
    delete_confirmation: "Silindiğinde, t\xfcm \xfcyeler bu kuruluştaki \xfcyeliklerini ve rollerini kaybedecek. Bu işlem geri alınamaz.",
    organization_id: "Kuruluş Kimliği",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "Kuruluşun adı, benzersiz olması gerekli değildir.",
    description_placeholder: "Kuruluşun a\xe7ıklaması.",
    member: "\xdcye",
    member_other: "\xdcyeler",
    add_members_to_organization: '\xdcyeleri "{{name}}" kuruluşuna ekle',
    add_members_to_organization_description: "İsim, e-posta, telefon veya kullanıcı kimliği arayarak uygun kullanıcıları bulun. Var olan \xfcyeler arama sonu\xe7larında g\xf6sterilmez.",
    add_with_organization_role: "Kuruluş rol(ler)i ile ekle",
    user: "Kullanıcı",
    authorize_to_roles: "{{name}}'a aşağıdaki rolleri erişim yetkisi verin:",
    edit_organization_roles: "Kuruluş rollerini d\xfczenle",
    edit_organization_roles_of_user: "{{name}}'ın kuruluş rollerini d\xfczenle",
    remove_user_from_organization: "Kullanıcıyı kuruluştan kaldır",
    remove_user_from_organization_description: "Kaldırıldığında, kullanıcı bu kuruluşta \xfcyeliğini ve rollerini kaybedecek. Bu işlem geri alınamaz.",
    search_user_placeholder: "İsim, e-posta, telefon veya kullanıcı kimliği ile ara",
    at_least_one_user: "En az bir kullanıcı gereklidir."
};
var $88fa17918f2b4fd9$export$2e2bcd8739ae039 = Object.freeze($88fa17918f2b4fd9$var$organization_details);


const $a485784c7935293a$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "Kuruluşlar",
    title: "Kuruluşlar",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "Kuruluş Kimliği",
    members: "\xdcyeler",
    create_organization: "Kuruluş oluştur",
    setup_organization: "Kuruluşunuzu ayarlayın",
    organization_list_placeholder_title: "Kuruluş",
    organization_list_placeholder_text: "Kuruluş genellikle SaaS veya SaaS benzeri \xe7ok kiracılı uygulamalarda kullanılır. Kuruluşlar \xf6zelliği, B2B m\xfcşterilerinizin ortaklarını ve m\xfcşterilerini daha iyi y\xf6netmelerine ve son kullanıcıların uygulamalarına erişim şekillerini \xf6zelleştirmelerine izin verir.",
    organization_name_placeholder: "Benim kuruluşum",
    organization_description_placeholder: "Kuruluşun kısa a\xe7ıklaması",
    organization_permission: "Kuruluş izni",
    organization_permission_other: "Kuruluş izinleri",
    organization_permission_description: "Kuruluş izni, kuruluş bağlamında bir kaynağa erişim izni anlamına gelir. Bir kuruluş izni anlamlı bir dize olarak temsil edilmeli ve aynı zamanda adı ve benzersiz tanımlayıcısı olarak hizmet etmelidir.",
    organization_permission_delete_confirm: "Bu izin silinirse, bu izni i\xe7eren t\xfcm kuruluş rolleri bu izni kaybedecek ve bu izne sahip olan kullanıcılar bu izinle sağlanan erişimi kaybedecek.",
    create_permission_placeholder: "Randevu ge\xe7mişini oku",
    permission: "İzin",
    permission_other: "İzinler",
    organization_role: "Kuruluş rol\xfc",
    organization_role_other: "Kuruluş rolleri",
    organization_role_description: "Kuruluş rol\xfc, kullanıcılara atanabilen izinlerin bir gruplamasıdır. İzinler \xf6nceden tanımlanmış kuruluş izinlerinden gelmelidir.",
    organization_role_delete_confirm: "Bunu yapmak, etkilenen kullanıcılardan bu role ilişkilendirilmiş izinleri kaldıracak ve kuruluş rolleri arasındaki ilişkileri ve kuruluş izinleri arasındaki ilişkileri silecektir.",
    role: "Rol",
    create_role_placeholder: "Yalnızca g\xf6r\xfcn\xfcm izinleri olan kullanıcılar",
    search_placeholder: "Kuruluş adı veya kimliğine g\xf6re ara",
    search_permission_placeholder: "İzinleri arayın ve se\xe7in",
    search_role_placeholder: "Rolleri arayın ve se\xe7in",
    empty_placeholder: "\uD83E\uDD14 Herhangi bir {{entity}} hen\xfcz ayarlanmamış.",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "Kılavuzlarla başlayın",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "Her şeyin nasıl bağlandığını g\xf6rmek i\xe7in ill\xfcstrasyonla etkileşim",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "Adım 1: Kuruluş izinlerini tanımlayın",
        step_2: "Adım 2: Kuruluş rollerini tanımlayın",
        step_3: "Adım 3: İlk kuruluşunuzu oluşturun",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $a485784c7935293a$export$2e2bcd8739ae039 = Object.freeze($a485784c7935293a$var$organizations);


const $d49ab06d6ac16d3d$var$permissions = {
    search_placeholder: "API veya izin adına g\xf6re ara",
    search_placeholder_without_api: "İzin adına g\xf6re ara",
    name_column: "İzin",
    description_column: "A\xe7ıklama",
    api_column: "API",
    placeholder_title: "İzin",
    placeholder_description: "İzin, bir kaynağa erişmek i\xe7in yetki verme durumunu ifade eder (biz buna API kaynağı diyoruz)."
};
var $d49ab06d6ac16d3d$export$2e2bcd8739ae039 = Object.freeze($d49ab06d6ac16d3d$var$permissions);


const $7b5e763b39a79332$var$profile = {
    page_title: "Hesap Ayarları",
    title: "Hesap Ayarları",
    description: "Hesap g\xfcvenliğinizi sağlamak i\xe7in hesap ayarlarınızı değiştirin ve kişisel bilgilerinizi y\xf6netin.",
    settings: {
        title: "PROFİL AYARLARI",
        profile_information: "Profil bilgisi",
        avatar: "Avatar",
        name: "İsim",
        username: "Kullanıcı adı"
    },
    link_account: {
        title: "HESABI BAĞLA",
        email_sign_in: "E-posta ile giriş",
        email: "E-posta",
        social_sign_in: "Sosyal medya hesabıyla giriş",
        link_email: "E-postayı bağla",
        link_email_subtitle: "Giriş yapmak veya hesap kurtarımında yardımcı olmak i\xe7in e-postanızı bağlayın.",
        email_required: "E-posta gerekli",
        invalid_email: "Ge\xe7ersiz e-posta adresi",
        identical_email_address: "Girilen e-posta adresi mevcut olanla aynı",
        anonymous: "Anonim"
    },
    password: {
        title: "ŞİFRE VE G\xdcVENLİK",
        password: "Şifre",
        password_setting: "Şifre ayarları",
        new_password: "Yeni şifre",
        confirm_password: "Şifreyi onayla",
        enter_password: "Ge\xe7erli şifreyi girin",
        enter_password_subtitle: "Hesap g\xfcvenliğinizi korumak i\xe7in kendinizi doğrulayın. Değiştirmeden \xf6nce l\xfctfen mevcut şifrenizi girin.",
        set_password: "Şifre oluştur",
        verify_via_password: "Şifre ile doğrula",
        show_password: "Şifreyi g\xf6ster",
        required: "Şifre gerekli",
        do_not_match: "Şifreler eşleşmiyor. Tekrar deneyin."
    },
    code: {
        enter_verification_code: "Doğrulama kodu girin",
        enter_verification_code_subtitle: "Doğrulama kodu, <strong>{{target}}</strong> adresine g\xf6nderildi.",
        verify_via_code: "Doğrulama kodu ile doğrula",
        resend: "Doğrulama kodunu tekrar g\xf6nder",
        resend_countdown: "{{countdown}} saniye i\xe7inde tekrar g\xf6nder"
    },
    delete_account: {
        title: "HESABI SİL",
        label: "Hesabı sil",
        description: "Hesabınızın t\xfcm kişisel bilgileri, kullanıcı verileri ve yapılandırması silinecektir. Bu işlem geri alınamaz.",
        button: "Hesabı sil",
        dialog_paragraph_1: "Hesabınızı silmek istediğinize \xfczg\xfcn\xfcz. Hesabınız kalıcı olarak t\xfcm verileri, kullanıcı bilgileri, kayıtlar ve ayarlar dahil olmak \xfczere silinecektir ve bu işlem geri alınamaz. Bu nedenle, devam etmeden \xf6nce \xf6nemli verilerinizi yedeklediğinizden emin olun.",
        dialog_paragraph_2: "Hesap silme işlemine devam etmek i\xe7in, l\xfctfen destek ekibimize, <a>mail</a> adresine “Hesap Silme İsteği” konulu e-posta g\xf6nderin. Size yardımcı olacağız ve t\xfcm verilerinizin sistemimizden uygun şekilde silineceğinden emin olacağız.",
        dialog_paragraph_3: "Logto Cloud’u tercih ettiğiniz i\xe7in teşekk\xfcr ederiz. Herhangi bir sorunuz veya endişeniz varsa, bizimle iletişime ge\xe7mekten \xe7ekinmeyin."
    },
    set: "Ayarla",
    change: "Değiştir",
    link: "Bağla",
    unlink: "Bağlantıyı kes",
    not_set: "Belirtilmemiş",
    change_avatar: "Avatarı değiştir",
    change_name: "İsmi değiştir",
    change_username: "Kullanıcı adını değiştir",
    set_name: "İsmi ayarla",
    email_changed: "E-posta değiştirildi.",
    password_changed: "Şifre değiştirildi.",
    updated: "{{target}} g\xfcncellendi.",
    linked: "{{target}} bağlandı.",
    unlinked: "{{target}} bağlantısı kesildi.",
    email_exists_reminder: "Bu e-posta {{email}}, mevcut bir hesapla ilişkilendirilmiştir. Başka bir e-posta bağlayın.",
    unlink_confirm_text: "Evet, bağlantıyı kes",
    unlink_reminder: "Bağlantıyı keserseniz, kullanıcılar <span></span> hesabıyla giriş yapamazlar. Devam etmek istediğinizden emin misiniz?"
};
var $7b5e763b39a79332$export$2e2bcd8739ae039 = Object.freeze($7b5e763b39a79332$var$profile);


const $3e956136d460867e$var$role_details = {
    back_to_roles: "Rollere D\xf6n",
    identifier: "Tanımlayıcı",
    delete_description: "Bunu yapmak, rolle ilişkili izinleri etkilenen kullanıcılardan kaldırır ve roller, kullanıcılar ve izinler arasındaki eşleştirmeyi siler.",
    role_deleted: "{{name}} başarıyla silindi.",
    settings_tab: "Ayarlar",
    users_tab: "Kullanıcılar",
    m2m_apps_tab: "Makine-makine uygulamaları",
    permissions_tab: "İzinler",
    settings: "Ayarlar",
    settings_description: "Roller, kullanıcılara atanabilen izinlerin bir gruplamasıdır. Ayrıca, farklı API'ler i\xe7in tanımlanan izinleri biriktirmek i\xe7in bir yol sağladıkları i\xe7in, izinleri kullanıcılara bireysel olarak atamaktan daha verimli bir şekilde eklemek, kaldırmak veya ayarlamak i\xe7in bir yoldur.",
    field_name: "Adı",
    field_description: "A\xe7ıklama",
    type_m2m_role_tag: "Makine-makine uygulama rol\xfc",
    type_user_role_tag: "Kullanıcı rol\xfc",
    permission: {
        assign_button: "İzinleri Ata",
        assign_title: "İzinleri Ata",
        assign_subtitle: "Bu role izinler atanır. Rol, eklenen izinleri alır ve bu role sahip kullanıcılar bu izinleri devralır.",
        assign_form_field: "İzinleri Ata",
        added_text_one: "{{count, number}} izin eklendi",
        added_text_other: "{{count, number}} izinler eklendi",
        api_permission_count_one: "{{count, number}} izin",
        api_permission_count_other: "{{count, number}} izinler",
        confirm_assign: "İzinleri Ata",
        permission_assigned: "Se\xe7ilen izinler bu role başarıyla atandı",
        deletion_description: "Bu izin kaldırılırsa, bu role sahip etkilenen kullanıcı sahip olduğu erişimi kaybeder.",
        permission_deleted: 'İzin "{{name}}" bu rol i\xe7in başarıyla kaldırıldı',
        empty: "Mevcut izin yok"
    },
    users: {
        assign_button: "Kullanıcıları Ata",
        name_column: "Kullanıcı",
        app_column: "Uygulama",
        latest_sign_in_column: "Son giriş",
        delete_description: "Bu rol i\xe7in yetkilendirme kaybeder ancak kullanıcı havuzunuzda kalır.",
        deleted: "{{name}} bu rolden başarıyla kaldırıldı",
        assign_title: "Kullanıcılar Ata",
        assign_subtitle: "Kullanıcıları bu role atayın. İsim, e-posta, telefon veya kullanıcı kimliği arayarak uygun kullanıcıları bulun.",
        assign_field: "Kullanıcıları Ata",
        confirm_assign: "Kullanıcıları Ata",
        assigned_toast_text: "The selected users were successfully assigned to this role",
        empty: "Mevcut kullanıcı yok"
    },
    applications: {
        assign_button: "Uygulamaları Ata",
        name_column: "Uygulama",
        app_column: "Uygulamalar",
        description_column: "A\xe7ıklama",
        delete_description: "Bunu yaparsanız, uygulama havuzunuzda kalır, ancak bu role ait yetkileri kaybeder.",
        deleted: "{{name}} bu rolden başarıyla kaldırıldı",
        assign_title: "Uygulamaları Ata",
        assign_subtitle: "Bu role uygulamaları atayın. İsim, a\xe7ıklama veya uygulama kimliği arayarak uygun uygulamaları bulun.",
        assign_field: "Uygulamaları Ata",
        confirm_assign: "Uygulamaları Ata",
        assigned_toast_text: "The selected applications were successfully assigned to this role",
        empty: "Mevcut uygulama yok"
    }
};
var $3e956136d460867e$export$2e2bcd8739ae039 = Object.freeze($3e956136d460867e$var$role_details);


const $03cc99fdf3c3704c$var$roles = {
    page_title: "Roller",
    title: "Roller",
    subtitle: "Roller, bir kullanıcının ne yapabileceğini belirleyen izinleri i\xe7erir. RBAC, kullanıcılara belirli işlemler i\xe7in kaynaklara erişim vermek i\xe7in roller kullanır.",
    create: "Rol Oluştur",
    role_name: "Rol adı",
    role_type: "Rol tipi",
    show_role_type_button_text: "Daha fazla se\xe7enek g\xf6ster",
    hide_role_type_button_text: "Daha fazla se\xe7eneği gizle",
    type_user: "Kullanıcı rol\xfc",
    type_machine_to_machine: "Makine-makine uygulama rol\xfc",
    role_description: "A\xe7ıklama",
    role_name_placeholder: "Rol adınızı girin",
    role_description_placeholder: "Rol a\xe7ıklamanızı girin",
    col_roles: "Roller",
    col_type: "T\xfcr",
    col_description: "A\xe7ıklama",
    col_assigned_entities: "Atanan",
    user_counts: "{{count}} kullanıcılar",
    application_counts: "{{count}} uygulamalar",
    user_count: "{{count}} kullanıcı",
    application_count: "{{count}} uygulama",
    assign_permissions: "İzinleri Ata",
    create_role_title: "Rol Oluştur",
    create_role_description: "Uygulamalarınız i\xe7in rolleri oluşturun ve y\xf6netin. Roller, izin koleksiyonlarını i\xe7erir ve kullanıcılara atanabilir.",
    create_role_button: "Rol Oluştur",
    role_created: "{{name}} rol\xfc başarıyla oluşturuldu.",
    search: "Rol adı, a\xe7ıklama veya kimlik numarasına g\xf6re arama yapın",
    placeholder_title: "Roller",
    placeholder_description: "Roller, kullanıcılara atanabilecek izinlerin gruplandırmasıdır. Rolleri oluşturmadan \xf6nce izin eklediğinizden emin olun."
};
var $03cc99fdf3c3704c$export$2e2bcd8739ae039 = Object.freeze($03cc99fdf3c3704c$var$roles);


const $be5f344f0ac31d96$var$session_expired = {
    title: "Oturum S\xfcresi Doldu",
    subtitle: "Oturumunuzun s\xfcresi dolmuş ve bağlantınız kesilmiş olabilir. Y\xf6netici konsolunda tekrar oturum a\xe7mak i\xe7in aşağıdaki butona tıklayınız.",
    button: "Yeniden Giriş Yap"
};
var $be5f344f0ac31d96$export$2e2bcd8739ae039 = Object.freeze($be5f344f0ac31d96$var$session_expired);


const $84aad06f2bb8b904$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $84aad06f2bb8b904$export$2e2bcd8739ae039 = Object.freeze($84aad06f2bb8b904$var$content);


const $51249b62fb0aa9bb$var$password_policy = {
    password_requirements: "Parola gereksinimleri",
    minimum_length: "Minimum uzunluk",
    minimum_length_description: "NIST \xf6nerilerine g\xf6re, web \xfcr\xfcnleri i\xe7in en az <a>8 karakter</a> kullanın.",
    minimum_length_error: "Minimum uzunluk {{min}} ile {{max}} (dahil) arasında olmalıdır.",
    minimum_required_char_types: "Minimum gereken karakter tipleri",
    minimum_required_char_types_description: "Karakter tipleri: b\xfcy\xfck harfler (A-Z), k\xfc\xe7\xfck harfler (a-z), sayılar (0-9) ve \xf6zel semboller ({{symbols}}).",
    password_rejection: "Parola reddi",
    compromised_passwords: "Etkilenen şifreleri reddet",
    breached_passwords: "Veri tabanında yer alan şifreleri reddet",
    breached_passwords_description: "Daha \xf6nceki ihlal veritabanlarında bulunan şifreleri reddet.",
    restricted_phrases: "D\xfcş\xfck g\xfcvenlikli ifadeleri kısıtla",
    restricted_phrases_tooltip: "Parolanız 3 ya da daha fazla karakterle birleştirilmediği s\xfcrece bu ifadelerden ka\xe7ınmalıdır.",
    repetitive_or_sequential_characters: "Tekrarlayan veya ardışık karakterler",
    repetitive_or_sequential_characters_description: '\xd6rn., "AAAA", "1234" ve "abcd".',
    user_information: "Kullanıcı bilgisi",
    user_information_description: "\xd6rn., e-posta adresi, telefon numarası, kullanıcı adı vb.",
    custom_words: "\xd6zel kelimeler",
    custom_words_description: "Bağlamla ilgili kelimeleri kişiselleştirin, k\xfc\xe7\xfck/b\xfcy\xfck harf duyarsız ve satır başına bir kelime olacak şekilde.",
    custom_words_placeholder: "Servis adınız, şirket adınız, vb."
};
var $51249b62fb0aa9bb$export$2e2bcd8739ae039 = Object.freeze($51249b62fb0aa9bb$var$password_policy);


const $3f1e821e2c781896$var$sign_up_and_sign_in = {
    identifiers_email: "E-posta adresi",
    identifiers_phone: "Telefon numarası",
    identifiers_username: "Kullanıcı adı",
    identifiers_email_or_sms: "E-posta adresi veya telefon numarası",
    identifiers_none: "Ge\xe7ersiz",
    and: "ve",
    or: "veya",
    sign_up: {
        title: "KAYDOL",
        sign_up_identifier: "Kayıt tanımlayıcı",
        identifier_description: "Hesap oluşturmak i\xe7in kayıt tanımlayıcı gereklidir ve giriş ekranınıza dahil edilmelidir.",
        sign_up_authentication: "Kaydolma doğrulama ayarları",
        authentication_description: "Se\xe7ilen t\xfcm işlemler, kullanıcıların akışı tamamlamaları zorunlu olacaktır.",
        set_a_password_option: "Şifrenizi oluşturun",
        verify_at_sign_up_option: "Kaydolduğunuzda doğrulayın",
        social_only_creation_description: "(Bu sadece sosyal hesap yaratımı i\xe7in ge\xe7erlidir)"
    },
    sign_in: {
        title: "OTURUM A\xc7IN",
        sign_in_identifier_and_auth: "Oturum a\xe7ma tanımlayıcısı ve doğrulama ayarları",
        description: "Kullanıcılar mevcut se\xe7eneklerden herhangi biriyle oturum a\xe7abilir. Aşağıdaki se\xe7enekleri s\xfcr\xfckleyip bırakarak d\xfczenleyin.",
        add_sign_in_method: "Oturum a\xe7ma y\xf6ntemi ekle",
        password_auth: "Şifre",
        verification_code_auth: "Doğrulama kodu",
        auth_swap_tip: "Akışta ilk olarak hangisinin g\xf6r\xfcnd\xfcğ\xfcn\xfc belirlemek i\xe7in se\xe7eneklerin yerlerini değiştirin.",
        require_auth_factor: "En az bir doğrulama fakt\xf6r\xfc se\xe7meniz gerekiyor."
    },
    social_sign_in: {
        title: "SOSYAL MEDYA İLE OTURUM A\xc7IN",
        social_sign_in: "Sosyal medya ile oturum a\xe7ın",
        description: "Kullanıcı, sosyal bağlantı noktası aracılığıyla kaydolurken belirlediğiniz zorunlu tanımlayıcıya bağlı olarak bir tanımlayıcı sağlaması istenebilir.",
        add_social_connector: "Sosyal Bağlantı Noktası Ekle",
        set_up_hint: {
            not_in_list: "Listede değil mi?",
            set_up_more: "Daha fazlasını kur",
            go_to: "şimdi farklı sosyal bağlantı noktalarına."
        }
    },
    tip: {
        set_a_password: "Kullanıcı adınıza benzersiz bir şifre belirlemek şarttır.",
        verify_at_sign_up: "Şu anda yalnızca doğrulanmış e-postayı destekliyoruz. Doğrulama yapılmazsa kullanıcı kitleniz d\xfcş\xfck kaliteli e-posta adreslerini i\xe7erebilir.",
        password_auth: "Bu, kaydolma işlemi sırasında bir şifre belirleme se\xe7eneğini etkinleştirdiğiniz i\xe7in \xf6nemlidir.",
        verification_code_auth: "Bu, yalnızca doğrulama kodu sağlama se\xe7eneğini etkinleştirdiğiniz i\xe7in \xf6nemlidir. Kayıt işlemi sırasında şifre oluşturma izni verildiğinde kutuyu kaldırabilirsiniz.",
        delete_sign_in_method: "Bu, {{identifier}} gerekliliğini belirlediğiniz i\xe7in \xf6nemlidir."
    },
    advanced_options: {
        title: "GELİŞMİŞ SE\xc7ENEKLER",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "Kullanıcı kaydını etkinleştir",
        enable_user_registration_description: "Kullanıcı kaydını etkinleştir veya devre dışı bırak. Devre dışı bırakıldığında, kullanıcılar y\xf6netici konsolunda hala eklenilebilir, ancak kullanıcılar artık oturum a\xe7ma aray\xfcz\xfc \xfczerinden hesap oluşturamaz."
    }
};
var $3f1e821e2c781896$export$2e2bcd8739ae039 = Object.freeze($3f1e821e2c781896$var$sign_up_and_sign_in);


const $7ba2f624c01f8e88$var$sign_in_exp = {
    page_title: "Oturum A\xe7ma Deneyimi",
    title: "Oturum A\xe7ma Deneyimi",
    description: "Oturum a\xe7ma kullanıcı aray\xfcz\xfcn\xfc markanıza uyacak şekilde \xf6zelleştirin ve ger\xe7ek zamanlı olarak g\xf6r\xfcnt\xfcleyin",
    tabs: {
        branding: "Markalaşma",
        sign_up_and_sign_in: "Kaydol ve Oturum A\xe7",
        content: "İ\xe7erik",
        password_policy: "Şifre politikası"
    },
    welcome: {
        title: "Oturum a\xe7ma deneyimini \xf6zelleştirin",
        description: "İlk oturum a\xe7ma işleminizi hızlı bir şekilde başlatın. Bu kılavuz, t\xfcm gerekli ayarları size anlatır.",
        get_started: "Başla",
        apply_remind: "L\xfctfen unutmayın ki, oturum a\xe7ma deneyimi bu hesap altındaki t\xfcm uygulamalar i\xe7in ge\xe7erli olacaktır."
    },
    color: {
        title: "RENK",
        primary_color: "Marka rengi",
        dark_primary_color: "Marka rengi (Koyu)",
        dark_mode: "Koyu modu etkinleştir",
        dark_mode_description: "Uygulamanız, markanızın rengine ve logo algoritmasına g\xf6re otomatik olarak oluşturulmuş bir koyu mod temasına sahip olacaktır. \xd6zelleştirmekte \xf6zg\xfcrs\xfcn\xfcz.",
        dark_mode_reset_tip: "Marka rengine g\xf6re koyu mod rengini yeniden hesaplayınız.",
        reset: "Yeniden hesapla"
    },
    branding: {
        title: "MARKA ALANI",
        ui_style: "Stil",
        favicon: "Favicon",
        logo_image_url: "Uygulama logosu resim URLi",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Uygulama logosu resim URLi (Koyu)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Uygulama logosu",
        dark_logo_image: "Uygulama logosu (Koyu)",
        logo_image_error: "Uygulama logosu: {{error}}",
        favicon_error: "Favicon: {{error}}"
    },
    custom_css: {
        title: "\xd6zel CSS",
        css_code_editor_title: "UI'ınızı \xd6zel CSS ile kişiselleştirin",
        css_code_editor_description1: "\xd6zel CSS \xf6rneğini g\xf6r\xfcnt\xfcleyin.",
        css_code_editor_description2: "<a>{{link}}</a>.",
        css_code_editor_description_link_content: "Daha fazlası i\xe7in buraya tıklayın",
        css_code_editor_content_placeholder: "Tam olarak istediğiniz gibi o herhangi bir şeyin stilini kişiselleştirmek i\xe7in \xf6zel CSS'nizi girin. Yaratıcılığınızı ifade edin ve UI'ınızın dikkat \xe7ekmesini sağlayın."
    },
    sign_up_and_sign_in: $3f1e821e2c781896$export$2e2bcd8739ae039,
    content: $84aad06f2bb8b904$export$2e2bcd8739ae039,
    password_policy: $51249b62fb0aa9bb$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: 'Hen\xfcz SMS konekt\xf6r\xfc kurulmadı. Yapılandırmayı tamamlamadan \xf6nce, kullanıcılar bu y\xf6ntemle oturum a\xe7amazlar. "Konekt\xf6rler"deki <a>{{link}}</a>',
        no_connector_email: 'Hen\xfcz e-posta konekt\xf6r\xfc kurulmadı. Yapılandırmayı tamamlamadan \xf6nce, kullanıcılar bu y\xf6ntemle oturum a\xe7amazlar. "Konekt\xf6rler"deki <a>{{link}}</a>',
        no_connector_social: 'Hen\xfcz hi\xe7bir sosyal bağlayıcıyı ayarlamadınız. Sosyal giriş y\xf6ntemlerini uygulamak i\xe7in \xf6nce bağlayıcı ekleyin. "Bağlayıcılar" b\xf6l\xfcm\xfcnde <a>{{link}}</a> g\xf6r\xfcnt\xfcleyin.',
        setup_link: "Kurulum yapın"
    },
    save_alert: {
        description: "Yeni oturum a\xe7ma ve kaydolma prosed\xfcrlerini uygulamaktasınız. T\xfcm kullanıcılarınız yeni kurulumdan etkilenebilirler. Değişikliği ger\xe7ekleştirmek istediğinize emin misiniz?",
        before: "\xd6nce",
        after: "Sonra",
        sign_up: "Kaydolma",
        sign_in: "Oturum A\xe7ma",
        social: "Sosyal"
    },
    preview: {
        title: "Oturum A\xe7ma \xd6nizlemesi",
        live_preview: "Canlı \xf6nizleme",
        live_preview_tip: "Değişiklikleri g\xf6rmek i\xe7in kaydedin",
        native: "Doğal",
        desktop_web: "Masa\xfcst\xfc Web",
        mobile_web: "Mobil Web",
        desktop: "Masa\xfcst\xfc",
        mobile: "Mobil"
    }
};
var $7ba2f624c01f8e88$export$2e2bcd8739ae039 = Object.freeze($7ba2f624c01f8e88$var$sign_in_exp);


const $2e04388c7249f659$var$quota_item = {
    tenant_limit: {
        name: "Kiracilar",
        limited: "{{count, number}} kiracı",
        limited_other: "{{count, number}} kiracılar",
        unlimited: "Sınırsız kiracılar",
        not_eligible: "Kiracılarınızı kaldırın"
    },
    mau_limit: {
        name: "Aylık aktif kullanıcılar",
        limited: "{{count, number}} MAU",
        unlimited: "Sınırsız MAU",
        not_eligible: "T\xfcm kullanıcılarınızı kaldırın"
    },
    applications_limit: {
        name: "Uygulamalar",
        limited: "{{count, number}} uygulama",
        limited_other: "{{count, number}} uygulamalar",
        unlimited: "Sınırsız uygulamalar",
        not_eligible: "Uygulamalarınızı kaldırın"
    },
    machine_to_machine_limit: {
        name: "Makineye Makine",
        limited: "{{count, number}} makineye makine uygulama",
        limited_other: "{{count, number}} makineye makine uygulamalar",
        unlimited: "Sınırsız makineye makine uygulamalar",
        not_eligible: "Makineye makine uygulamalarınızı kaldırın"
    },
    resources_limit: {
        name: "API kaynakları",
        limited: "{{count, number}} API kaynak",
        limited_other: "{{count, number}} API kaynakları",
        unlimited: "Sınırsız API kaynakları",
        not_eligible: "API kaynaklarınızı kaldırın"
    },
    scopes_per_resource_limit: {
        name: "Kaynak izinleri",
        limited: "{{count, number}} izin kaynak başına",
        limited_other: "{{count, number}} izinler kaynak başına",
        unlimited: "Sınırsız izin kaynak başına",
        not_eligible: "Kaynak izinlerinizi kaldırın"
    },
    custom_domain_enabled: {
        name: "\xd6zel alan adı",
        limited: "\xd6zel alan adı",
        unlimited: "\xd6zel alan adı",
        not_eligible: "\xd6zel alan adınızı kaldırın"
    },
    omni_sign_in_enabled: {
        name: "Omni oturumu a\xe7",
        limited: "Omni oturumu a\xe7",
        unlimited: "Omni oturumu a\xe7",
        not_eligible: "Omni oturumunu devre dışı bırakın"
    },
    built_in_email_connector_enabled: {
        name: "Dahili e-posta bağlayıcı",
        limited: "Dahili e-posta bağlayıcı",
        unlimited: "Dahili e-posta bağlayıcı",
        not_eligible: "Dahili e-posta bağlayıcınızı kaldırın"
    },
    social_connectors_limit: {
        name: "Sosyal bağlayıcılar",
        limited: "{{count, number}} sosyal bağlayıcı",
        limited_other: "{{count, number}} sosyal bağlayıcılar",
        unlimited: "Sınırsız sosyal bağlayıcılar",
        not_eligible: "Sosyal bağlayıcılarınızı kaldırın"
    },
    standard_connectors_limit: {
        name: "\xdccretsiz standart bağlayıcılar",
        limited: "{{count, number}} \xfccretsiz standart bağlayıcı",
        limited_other: "{{count, number}} \xfccretsiz standart bağlayıcılar",
        unlimited: "Sınırsız standart bağlayıcılar",
        not_eligible: "Standart bağlayıcılarınızı kaldırın"
    },
    roles_limit: {
        name: "Roller",
        limited: "{{count, number}} rol",
        limited_other: "{{count, number}} roller",
        unlimited: "Sınırsız roller",
        not_eligible: "Rollerinizi kaldırın"
    },
    scopes_per_role_limit: {
        name: "Rol izinleri",
        limited: "{{count, number}} izin rol başına",
        limited_other: "{{count, number}} izinler rol başına",
        unlimited: "Sınırsız izin rol başına",
        not_eligible: "Rol izinlerinizi kaldırın"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} webhook",
        limited_other: "{{count, number}} webhooks",
        unlimited: "Sınırsız webhooklar",
        not_eligible: "Webhooklarınızı kaldırın"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "Denetim g\xfcnl\xfckleri saklama s\xfcresi",
        limited: "Denetim g\xfcnl\xfckleri saklama s\xfcresi: {{count, number}} g\xfcn",
        limited_other: "Denetim g\xfcnl\xfckleri saklama s\xfcresi: {{count, number}} g\xfcn",
        unlimited: "Sınırsız g\xfcnler",
        not_eligible: "Denetim g\xfcnl\xfcğ\xfcn\xfcz yok"
    },
    community_support_enabled: {
        name: "Topluluk desteği",
        limited: "Topluluk desteği",
        unlimited: "Topluluk desteği",
        not_eligible: "Topluluk desteği yok"
    },
    customer_ticket_support: {
        name: "M\xfcşteri destek bileti",
        limited: "{{count, number}} saat m\xfcşteri destek bileti",
        limited_other: "{{count, number}} saat m\xfcşteri destek bileti",
        unlimited: "M\xfcşteri destek bileti",
        not_eligible: "M\xfcşteri destek bileti yok"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "MFA'nızı devre dışı bırakın"
    },
    sso_enabled: {
        name: "Kurumsal SSO",
        limited: "Kurumsal SSO",
        unlimited: "Kurumsal SSO",
        not_eligible: "Kurumsal SSO'nuzu devre dışı bırakın"
    }
};
var $2e04388c7249f659$export$2e2bcd8739ae039 = Object.freeze($2e04388c7249f659$var$quota_item);


const $ffbd5cf113050d40$var$quota_table = {
    quota: {
        title: "Kota",
        tenant_limit: "Kiracı limiti",
        base_price: "Temel fiyat",
        mau_unit_price: "* Aylık Etkin Kullanıcı (MAU) birim fiyatı",
        mau_limit: "MAU limiti"
    },
    application: {
        title: "Uygulamalar",
        total: "Toplam uygulama sayısı",
        m2m: "Makine-makine uygulamaları"
    },
    resource: {
        title: "API Kaynakları",
        resource_count: "Kaynak sayısı",
        scopes_per_resource: "Kaynak başına izinler"
    },
    branding: {
        title: "Kullanıcı Aray\xfcz\xfc ve Markalama",
        custom_domain: "\xd6zel alan adı",
        custom_css: "\xd6zel CSS",
        app_logo_and_favicon: "Uygulama logoları ve favicon",
        dark_mode: "Karanlık mod",
        i18n: "Uluslararasılaştırma"
    },
    user_authn: {
        title: "Kullanıcı Kimlik Doğrulama",
        omni_sign_in: "\xc7oklu oturum a\xe7ma",
        password: "Parola",
        passwordless: "Parolasız - E-posta ve SMS",
        email_connector: "E-posta bağlayıcı",
        sms_connector: "SMS bağlayıcı",
        social_connectors: "Sosyal bağlayıcılar",
        standard_connectors: "Standart bağlayıcılar",
        built_in_email_connector: "Dahili e-posta bağlayıcısı",
        mfa: "MFA",
        sso: "Kurumsal SSO"
    },
    user_management: {
        title: "Kullanıcı Y\xf6netimi",
        user_management: "Kullanıcı Y\xf6netimi",
        roles: "Roller",
        scopes_per_role: "Rol başına izinler"
    },
    audit_logs: {
        title: "Denetim G\xfcnl\xfckleri",
        retention: "Saklama"
    },
    hooks: {
        title: "Web Kancaları",
        hooks: "Web Kancaları"
    },
    organizations: {
        title: "Organizasyon",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "Destek",
        community: "Topluluk",
        customer_ticket: "M\xfcşteri destek bileti",
        premium: "Premium"
    },
    mau_unit_price_footnote: "* Aylık etkin kullanıcılarınız (MAU), faturalandırma d\xf6nemi boyunca ne sıklıkla oturum a\xe7tıklarına g\xf6re 3 d\xfczeye ayrılır. Her d\xfczeyin farklı bir MAU birim fiyatı vardır.",
    unlimited: "Sınırsız",
    contact: "İletişim",
    monthly_price: "${{value, number}}/ay",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} g\xfcn",
    days_other: "{{count, number}} g\xfcn",
    add_on: "Ek Hizmet",
    tier: "Seviye{{value, number}}: "
};
var $ffbd5cf113050d40$export$2e2bcd8739ae039 = Object.freeze($ffbd5cf113050d40$var$quota_table);


const $cdc0f0942c9e6afb$var$subscription = {
    free_plan: "\xdccretsiz Plan",
    free_plan_description: "Yan projeler ve başlangı\xe7 Logto denemeleri i\xe7in. Kredi kartı gerektirmez.",
    hobby_plan: "Hobi Planı",
    hobby_plan_description: "Bireysel geliştiriciler veya k\xfc\xe7\xfck m\xfchendislik ekipleri i\xe7in.",
    pro_plan: "Pro Plan",
    pro_plan_description: "Endişesiz bir şekilde Logto'dan faydalanan işletmeler i\xe7in.",
    enterprise: "Kurumsal",
    current_plan: "Mevcut Plan",
    current_plan_description: "İşte mevcut planınız. Plan kullanımınızı kolayca g\xf6rebilir, \xf6n\xfcm\xfczdeki faturanızı kontrol edebilir ve ihtiya\xe7 duyduk\xe7a planınızda değişiklikler yapabilirsiniz.",
    plan_usage: "Plan kullanımı",
    plan_cycle: "Plan d\xf6ng\xfcs\xfc: {{period}}. Kullanım {{renewDate}} tarihinde yenilenir.",
    next_bill: "Bir sonraki faturanız",
    next_bill_hint: "Hesaplama hakkında daha fazla bilgi i\xe7in l\xfctfen bu <a>makaleye</a> başvurun.",
    next_bill_tip: "Yaklaşan faturanız, bir sonraki ay i\xe7in planınızın taban fiyatını ve \xe7eşitli seviyelerde MAU birim fiyatıyla \xe7arpılan kullanımınızın maliyetini i\xe7erir.",
    manage_payment: "\xd6demeleri d\xfczenle",
    overfill_quota_warning: "Kota sınırınıza ulaştınız. Herhangi bir sorunu \xf6nlemek i\xe7in planı y\xfckseltin.",
    upgrade_pro: "Pro'ya y\xfckselt",
    update_payment: "\xd6demeyi G\xfcncelle",
    payment_error: "\xd6deme hatası tespit edildi. \xd6nceki d\xf6ng\xfc i\xe7in ${{price, number}} işlenemedi. Logto hizmeti askıya alınmasını \xf6nlemek i\xe7in \xf6demeleri g\xfcncelleyin.",
    downgrade: "D\xfcş\xfcr",
    current: "Mevcut",
    upgrade: "Y\xfckselt",
    quota_table: $ffbd5cf113050d40$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "Faturalar",
        status_column: "Durum",
        amount_column: "Miktar",
        invoice_created_date_column: "Fatura oluşturma tarihi",
        invoice_status: {
            void: "İptal Edildi",
            paid: "\xd6dendi",
            open: "A\xe7ık",
            uncollectible: "Gecikmiş"
        }
    },
    quota_item: $2e04388c7249f659$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "Emin misiniz, d\xfcş\xfcrmek istediğinize?",
        description: "Eğer <targetName/>'e ge\xe7meyi se\xe7erseniz, \xf6nceki <currentName/> i\xe7indeki kotalara ve \xf6zelliklere artık erişiminiz olmayacağını unutmayın.",
        before: "\xd6nce: <name/>",
        after: "Sonra: <name />",
        downgrade: "D\xfcş\xfcr"
    },
    not_eligible_modal: {
        downgrade_title: "D\xfcş\xfcrme i\xe7in uygun değilsiniz",
        downgrade_description: "<name/> planına d\xfcş\xfcrmeden \xf6nce aşağıdaki kriterleri sağladığınızdan emin olun.",
        downgrade_help_tip: "D\xfcş\xfcrme konusunda yardıma mı ihtiyacınız var? <a>Bizimle iletişime ge\xe7in</a>.",
        upgrade_title: "Saygıdeğer erken benimseyenlerimiz i\xe7in dostane hatırlatma",
        upgrade_description: "Şu anda <name /> tarafından izin verilenden daha fazlasını kullanıyorsunuz. Logto artık resmi olarak kullanılabilir durumda ve her plana \xf6zel \xf6zellikler sunuyor. <name />'e y\xfckseltmeyi d\xfcş\xfcnmeden \xf6nce, y\xfckseltme \xf6ncesinde aşağıdaki kriterleri karşıladığınızdan emin olun.",
        upgrade_pro_tip: " Ya da Pro Plan'a ge\xe7meyi d\xfcş\xfcn\xfcn.",
        upgrade_help_tip: "Y\xfckseltme konusunda yardıma mı ihtiyacınız var? <a>Bizimle iletişime ge\xe7in</a>.",
        a_maximum_of: "<item/> i\xe7in maksimum"
    },
    upgrade_success: "Successfully upgraded to <name/>",
    downgrade_success: "Successfully downgraded to <name/>",
    subscription_check_timeout: "Abonelik kontrol\xfc zaman aşımına uğradı. L\xfctfen daha sonra yenileyin.",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $cdc0f0942c9e6afb$export$2e2bcd8739ae039 = Object.freeze($cdc0f0942c9e6afb$var$subscription);


const $82ea7d482825ac8f$var$tab_sections = {
    overview: "Genel Bakış",
    resources: "Kaynaklar",
    users: "Kullanıcılar",
    access_control: "Erişim Kontrol\xfc",
    help_and_support: "Yardım ve Destek",
    tenant: "Kiracı",
    automation: "Otomasyon"
};
var $82ea7d482825ac8f$export$2e2bcd8739ae039 = Object.freeze($82ea7d482825ac8f$var$tab_sections);


const $0f36c5d97a96e767$var$tabs = {
    get_started: "Başla",
    dashboard: "G\xf6sterge Paneli",
    applications: "Uygulamalar",
    api_resources: "API Kaynakları",
    sign_in_experience: "Oturum A\xe7ma Deneyimi",
    connectors: "Connectors",
    enterprise_sso: "Kurumsal SSO",
    webhooks: "Webhooks",
    organizations: "Organizasyonlar",
    users: "Kullanıcı Y\xf6netimi",
    audit_logs: "Denetim Kayıtları",
    roles: "Roller",
    docs: "D\xf6k\xfcmanlar",
    tenant_settings: "Ayarlar",
    mfa: "\xc7oklu fakt\xf6rl\xfc kimlik doğrulama"
};
var $0f36c5d97a96e767$export$2e2bcd8739ae039 = Object.freeze($0f36c5d97a96e767$var$tabs);


const $d1b29552117c6413$var$tenants = {
    title: "Ayarlar",
    description: "Kiracı ayarlarını verimli bir şekilde y\xf6netin ve alan adınızı \xf6zelleştirin.",
    tabs: {
        settings: "Ayarlar",
        domains: "Alan adları",
        subscription: "Plan ve faturalandırma",
        billing_history: "Fatura ge\xe7mişi"
    },
    settings: {
        title: "AYARLAR",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "Kiracı Kimliği",
        tenant_name: "Kiracı Adı",
        tenant_region: "Veriler barındırılan b\xf6lge",
        tenant_region_tip: "Kiracı kaynaklarınız {{region}} b\xf6lgesinde barındırılır. <a>Daha fazla bilgi</a>",
        environment_tag_development: "Geliş",
        environment_tag_staging: "Staging",
        environment_tag_production: "Prod",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "Kiracı bilgileri başarıyla kaydedildi."
    },
    full_env_tag: {
        development: "Geliştirme",
        production: "Prod"
    },
    deletion_card: {
        title: "SİL",
        tenant_deletion: "Kiracıyı Sil",
        tenant_deletion_description: "Kiracının silinmesi, t\xfcm ilişkili kullanıcı verilerinin ve yapılandırmalarının kalıcı olarak silinmesine neden olur. L\xfctfen dikkatli bir şekilde devam edin.",
        tenant_deletion_button: "Kiracıyı Sil"
    },
    create_modal: {
        title: "Kiracı Oluştur",
        subtitle: "İzole kaynaklara ve kullanıcılara sahip yeni bir kiracı oluşturun. Verilerin barındırıldığı b\xf6lge ve kiracı t\xfcrleri oluşturulduktan sonra değiştirilemez.",
        tenant_usage_purpose: "Bu kiracıyı ne i\xe7in kullanmak istiyorsunuz?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "Mevcut plan:",
        create_button: "Kiracı oluştur",
        tenant_name_placeholder: "Benim kiracım"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "Kiracıyı Sil",
        description_line1: 'Ortam etiketi "{{tag}}" olan "{{name}}" kiracınızı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz ve t\xfcm verilerinizin ve hesap bilgilerinizin kalıcı olarak silinmesine neden olur.',
        description_line2: "Hesabınızı silmeden \xf6nce size yardımcı olabiliriz. <span><a>E-posta yoluyla bize ulaşın</a></span>",
        description_line3: 'Devam etmek isterseniz, "{{name}}" kiracı adını onaylamak i\xe7in yazın.',
        delete_button: "Kalıcı olarak sil",
        cannot_delete_title: "Bu kiracı silinemez",
        cannot_delete_description: "\xdczg\xfcn\xfcm, bu kiracıyı şu anda silemezsiniz. \xdccretsiz Plan \xfczerinde olduğunuzdan ve t\xfcm \xf6denmemiş faturaları \xf6dediğinizden emin olun."
    },
    tenant_landing_page: {
        title: "Hen\xfcz bir kiracı oluşturmadınız",
        description: "Logto ile projenizi yapılandırmaya başlamak i\xe7in l\xfctfen yeni bir kiracı oluşturun. Hesabınızdan \xe7ıkış yapmanız veya hesabınızı silmeniz gerekiyorsa, sağ \xfcst k\xf6şedeki avatar d\xfcğmesine tıklayın.",
        create_tenant_button: "Kiracı oluştur"
    },
    status: {
        mau_exceeded: "MAU Sınırı Aşıldı",
        suspended: "Askıya Alındı",
        overdue: "Ge\xe7mişte"
    },
    tenant_suspended_page: {
        title: "Kiracı Askıya Alındı. Erişimi geri y\xfcklemek i\xe7in bizimle iletişime ge\xe7in.",
        description_1: "\xdcz\xfclerek bildirmekten \xfcz\xfcnt\xfc duyuyoruz, kiracı hesabınız şu anda ge\xe7ici olarak askıya alınmıştır. Bunun nedeni, MAU sınırlarını aşmak, gecikmiş \xf6demeler veya diğer izinsiz işlemler gibi yanlış kullanımdır.",
        description_2: "Daha fazla a\xe7ıklama, endişeleriniz veya işlevselliği tamamen geri y\xfcklemek ve kiracılarınızı engellemek isterseniz, l\xfctfen derhal bizimle iletişime ge\xe7mekten \xe7ekinmeyin."
    },
    signing_keys: {
        title: "İMZALAMA ANAHTARLARI",
        description: "Kiracınızda imzalama anahtarlarını g\xfcvenli bir şekilde y\xf6netin.",
        type: {
            private_key: "OIDC \xf6zel anahtarları",
            cookie_key: "OIDC \xe7erez anahtarları"
        },
        private_keys_in_use: "Kullanılan \xf6zel anahtarlar",
        cookie_keys_in_use: "Kullanılan \xe7erez anahtarları",
        rotate_private_keys: "\xd6zel anahtarları d\xf6nd\xfcr",
        rotate_cookie_keys: "\xc7erez anahtarlarını d\xf6nd\xfcr",
        rotate_private_keys_description: "Bu işlem yeni bir \xf6zel imzalama anahtarı oluşturacak, mevcut anahtarı d\xf6nd\xfcrecek ve \xf6nceki anahtarınızı kaldıracak. G\xfcncel anahtar ile imzalanmış JWT jetonlarınız silinene veya başka bir d\xf6nd\xfcrme turuna kadar ge\xe7erli kalacaktır.",
        rotate_cookie_keys_description: "Bu işlem yeni bir \xe7erez anahtarı oluşturacak, mevcut anahtarı d\xf6nd\xfcrecek ve \xf6nceki anahtarınızı kaldıracak. G\xfcncel anahtar ile imzalanmış \xe7erezleriniz silinene veya başka bir d\xf6nd\xfcrme turuna kadar ge\xe7erli kalacaktır.",
        select_private_key_algorithm: "Yeni \xf6zel anahtar i\xe7in imzalama anahtar algoritmasını se\xe7in",
        rotate_button: "D\xf6nd\xfcr",
        table_column: {
            id: "Kimlik",
            status: "Durum",
            algorithm: "İmzalama anahtar algoritması"
        },
        status: {
            current: "Ge\xe7erli",
            previous: "\xd6nceki"
        },
        reminder: {
            rotate_private_key: "<strong>OIDC \xf6zel anahtarlarını</strong> d\xf6nd\xfcrmek istediğinizden emin misiniz? Yeni verilen JWT jetonları yeni anahtarla imzalanacaktır. Var olan JWT jetonları, tekrar d\xf6nd\xfcr\xfcnceye kadar ge\xe7erli kalacaktır.",
            rotate_cookie_key: "<strong>OIDC \xe7erez anahtarlarını</strong> d\xf6nd\xfcrmek istediğinizden emin misiniz? Oturum a\xe7ma oturumlarında yeni oluşturulan \xe7erezler yeni \xe7erez anahtarıyla imzalanacaktır. Var olan \xe7erezler, tekrar d\xf6nd\xfcr\xfcnceye kadar ge\xe7erli kalacaktır.",
            delete_private_key: "<strong>OIDC \xf6zel anahtarını</strong> silmek istediğinizden emin misiniz? Bu \xf6zel imzalama anahtarı ile imzalanan mevcut JWT jetonları artık ge\xe7erli olmayacaktır.",
            delete_cookie_key: "<strong>OIDC \xe7erez anahtarını</strong> silmek istediğinizden emin misiniz? Bu \xe7erez anahtarı ile imzalanan eski oturum a\xe7ma oturumları artık ge\xe7erli olmayacaktır. Bu kullanıcılar i\xe7in yeniden kimlik doğrulaması gereklidir."
        },
        messages: {
            rotate_key_success: "İmzalama anahtarları başarıyla d\xf6nd\xfc",
            delete_key_success: "Anahtar başarıyla silindi"
        }
    }
};
var $d1b29552117c6413$export$2e2bcd8739ae039 = Object.freeze($d1b29552117c6413$var$tenants);


const $77cafbcbdf2894ac$var$topbar = {
    docs: "Belgeler",
    help: "Yardım"
};
var $77cafbcbdf2894ac$export$2e2bcd8739ae039 = Object.freeze($77cafbcbdf2894ac$var$topbar);


const $e70de7e6205a6c45$var$paywall = {
    applications: "<planName/> limitine ulaşılan {{count, number}} başvuru. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    applications_other: "<planName/> limitine ulaşılan {{count, number}} başvurular. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    machine_to_machine_feature: "Upgrade to the <strong>Hobby</strong> plan to unlock 1 machine-to-machine application, or choose the <strong>Pro</strong> plan for unlimited usage. For any assistance, feel free to <a>contact us</a>.",
    machine_to_machine: "<planName/> limitine ulaşılan {{count, number}} makine-makine başvurusu. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    machine_to_machine_other: "<planName/> limitine ulaşılan {{count, number}} makine-makine başvuruları. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardım i\xe7in l\xfctfen <a>bizimle iletişime ge\xe7in</a>.",
    resources: "{{count, number}} <planName/> API kaynağı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    resources_other: "{{count, number}} <planName/> API kaynağı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_resource: "{{count, number}} <planName/> API kaynağı başına izin sınırına ulaşıldı. Genişletmek i\xe7in şimdi y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_resource_other: "{{count, number}} <planName/> API kaynağı başına izin sınırına ulaşıldı. Genişletmek i\xe7in şimdi y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    custom_domain: "Unlock custom domain functionality by upgrading to <strong>Hobby</strong> or <strong>Pro</strong> plan. Don’t hesitate to <a>contact us</a> if you need any assistance.",
    social_connectors: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    social_connectors_other: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_feature: "Upgrade to the <strong>Hobby</strong> or <strong>Pro</strong> plan to create your own connectors using OIDC, OAuth 2.0, and SAML protocols, plus unlimited social connectors and all the premium features. Feel free to <a>contact us</a> if you need any assistance.",
    standard_connectors: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_other: "{{count, number}} <planName/> sosyal bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in planı y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_pro: "{{count, number}} <planName/> standart bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in Kurumsal plana y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    standard_connectors_pro_other: "{{count, number}} <planName/> standart bağlayıcı sınırına ulaşıldı. Ekibinizin ihtiya\xe7larını karşılamak i\xe7in Kurumsal plana y\xfckseltin ve OIDC, OAuth 2.0 ve SAML protokolleri kullanarak kendi bağlayıcılarınızı oluşturma yeteneğine sahip olun. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    roles: "{{count, number}} <planName/> rol sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    roles_other: "{{count, number}} <planName/> rol sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_role: "{{count, number}} <planName/> rol başına izin sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    scopes_per_role_other: "{{count, number}} <planName/> rol başına izin sınırına ulaşıldı. İlave roller ve izinler eklemek i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    hooks: "{{count, number}} <planName/> webhook sınırına ulaşıldı. Daha fazla webhook oluşturmak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    hooks_other: "{{count, number}} <planName/> webhook sınırına ulaşıldı. Daha fazla webhook oluşturmak i\xe7in planı y\xfckseltin. Yardıma ihtiyacınız olursa, <a>iletişime ge\xe7in</a>.",
    mfa: "G\xfcvenliği kontrol etmek i\xe7in MFA'yı bir \xfccretli plana ge\xe7erek kilidini a\xe7ın. Yardıma ihtiyacınız olursa bize <a>iletişim kurmaktan</a> \xe7ekinmeyin.",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $e70de7e6205a6c45$export$2e2bcd8739ae039 = Object.freeze($e70de7e6205a6c45$var$paywall);


const $44a7e1d97e4151b7$var$upsell = {
    upgrade_plan: "Planı Y\xfckselt",
    compare_plans: "Planları Karşılaştır",
    view_plans: "Planları G\xf6r\xfcnt\xfcle",
    create_tenant: {
        title: "Kiracı planınızı se\xe7in",
        description: "Logto, b\xfcy\xfcyen şirketler i\xe7in tasarlanmış yenilik\xe7i ve uygun fiyatlı fiyatlandırma se\xe7enekleri sunar. <a>Daha fazla bilgi edinin</a>",
        base_price: "Temel Fiyat",
        monthly_price: "{{value, number}}/ay",
        mau_unit_price: "MAU birim fiyatı",
        view_all_features: "T\xfcm \xf6zellikleri g\xf6r\xfcnt\xfcle",
        select_plan: "<name/>'ı Se\xe7in",
        free_tenants_limit: "En fazla {{count, number}} \xfccretsiz kiracı",
        free_tenants_limit_other: "En fazla {{count, number}} \xfccretsiz kiracı",
        most_popular: "En Pop\xfcler",
        upgrade_success: "<name/>'a Başarıyla Y\xfckseltildi"
    },
    mau_exceeded_modal: {
        title: "MAU sınırı aşıldı. Planınızı y\xfckseltin.",
        notification: "Mevcut MAU, <planName/> sınırını aştı. Logto hizmetinin askıya alınmasını \xf6nlemek i\xe7in premium plana hemen y\xfckseltin.",
        update_plan: "Planı G\xfcncelle"
    },
    payment_overdue_modal: {
        title: "Fatura \xf6demesi gecikti",
        notification: "Oops! Kiracı <span>{{name}}</span> faturasının \xf6demesi başarısız oldu. Logto hizmetinin askıya alınmaması i\xe7in faturayı zamanında \xf6deyin.",
        unpaid_bills: "\xd6denmemiş faturalar",
        update_payment: "\xd6demeyi G\xfcncelle"
    },
    paywall: $e70de7e6205a6c45$export$2e2bcd8739ae039
};
var $44a7e1d97e4151b7$export$2e2bcd8739ae039 = Object.freeze($44a7e1d97e4151b7$var$upsell);


const $b7f8b55a2a3bc566$var$user_details = {
    page_title: "Kullanıcı detayları",
    back_to_users: "Kullanıcı Y\xf6netimine Geri D\xf6n",
    created_title: "Bu kullanıcı başarıyla oluşturuldu",
    created_guide: "Kullanıcının oturum a\xe7ma s\xfcrecinde yardımcı olacak bilgiler burada.",
    created_email: "E-posta adresi:",
    created_phone: "Telefon numarası:",
    created_username: "Kullanıcı Adı:",
    created_password: "Şifre:",
    menu_delete: "Sil",
    delete_description: "Bu işlem geri alınamaz. Kullanıcıyı kalıcı olarak siler.",
    deleted: "Kullanıcı başarıyla silindi.",
    reset_password: {
        reset_password: "Şifreyi sıfırla",
        title: "Şifreyi sıfırlamak istediğinizden emin misiniz?",
        content: "Bu işlem geri alınamaz. Bu, kullanıcının oturum a\xe7ma bilgilerini sıfırlayacaktır.",
        congratulations: "Bu kullanıcı sıfırlandı",
        new_password: "Yeni şifre:"
    },
    tab_settings: "Ayarlar",
    tab_roles: "Roller",
    tab_logs: "Kullanıcı kayıtları",
    tab_organizations: "Organizasyonlar",
    authentication: "Kimlik doğrulama",
    authentication_description: "Her kullanıcının, temel veriler, sosyal kimlikler ve \xf6zel verilerden oluşan t\xfcm kullanıcı bilgilerini i\xe7eren bir profil vardır.",
    user_profile: "Kullanıcı profili",
    field_email: "Eposta adresi",
    field_phone: "Telefon numarası",
    field_username: "Kullanıcı Adı",
    field_name: "İsim",
    field_avatar: "Avatar resmi URLi",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "\xd6zel veriler",
    field_custom_data_tip: "Kullanıcı tarafından tercih edilen renk ve dil gibi \xf6nceden tanımlanmış kullanıcı \xf6zelliklerinde listelenmeyen ek kullanıcı bilgileri.",
    field_connectors: "Sosyal bağlayıcılar",
    field_sso_connectors: "İş bağlantıları",
    custom_data_invalid: "\xd6zel veriler ge\xe7erli bir JSON nesnesi olmalıdır",
    connectors: {
        connectors: "Bağlayıcılar",
        user_id: "Kullanıcı IDsi",
        remove: "Kaldır",
        connected: "Bu kullanıcı birden fazla sosyal bağlayıcıya bağlıdır.",
        not_connected: "Kullanıcı herhangi bir sosyal bağlayıcıya bağlı değil",
        deletion_confirmation: "Mevcut <name/> kimliğini kaldırıyorsunuz. Devam etmek istediğinizden emin misiniz?"
    },
    sso_connectors: {
        connectors: "Bağlayıcılar",
        enterprise_id: "Şirket ID",
        connected: "Bu kullanıcı, Tek Oturum Kimliği i\xe7in birden \xe7ok kurumsal kimlik sağlayıcıya bağlıdır.",
        not_connected: "Kullanıcı, Tek Oturum Kimliği i\xe7in herhangi bir kurumsal kimlik sağlayıcıya bağlı değil."
    },
    mfa: {
        field_name: "\xc7ok fakt\xf6rl\xfc kimlik doğrulama",
        field_description: "Bu kullanıcı 2 adımlı kimlik doğrulama fakt\xf6rlerini etkinleştirdi.",
        name_column: "\xc7ok Fakt\xf6rl\xfc Kimlik Doğrulama",
        field_description_empty: "Bu kullanıcı 2 aşamalı kimlik doğrulama fakt\xf6rlerini etkinleştirmedi.",
        deletion_confirmation: "Varolan 2 aşamalı doğrulama i\xe7in <name/> kaldırıyorsunuz. Devam etmek istediğinizden emin misiniz?"
    },
    suspended: "Askıya alınmış",
    suspend_user: "Kullanıcıyı Askıya Al",
    suspend_user_reminder: "Bu kullanıcıyı askıya almak istediğinizden emin misiniz? Kullanıcı uygulamanıza giriş yapamayacak ve mevcut erişim belirteci s\xfcresi dolduktan sonra yeni bir erişim belirteci alamayacak. Ayrıca bu kullanıcı tarafından yapılan herhangi bir API isteği başarısız olacaktır.",
    suspend_action: "Askıya Al",
    user_suspended: "Kullanıcı askıya alındı.",
    reactivate_user: "Kullanıcıyı Yeniden Etkinleştir",
    reactivate_user_reminder: "Bu kullanıcının yeniden etkinleştirmek istediğinizden emin misiniz? B\xf6yle yapmak, bu kullanıcı i\xe7in giriş girişimlerine izin verecektir.",
    reactivate_action: "Yeniden Etkinleştir",
    user_reactivated: "Kullanıcı yeniden etkinleştirildi.",
    roles: {
        name_column: "Rol",
        description_column: "A\xe7ıklama",
        assign_button: "Rolleri Ata",
        delete_description: "Bu işlem, bu rol\xfc bu kullanıcıdan kaldıracaktır. Rol kendisi hala var olacaktır, ancak artık bu kullanıcıyla ilişkili olmayacaktır.",
        deleted: "{{name}} bu kullanıcıdan başarıyla kaldırıldı.",
        assign_title: "{{name}} kullanıcısına roller atayın",
        assign_subtitle: "{{name}} bir veya daha fazla rol\xfc yetkilendirin",
        assign_role_field: "Rolleri ata",
        role_search_placeholder: "Rol adına g\xf6re arama yapın",
        added_text: "{{value, number}} eklendi",
        assigned_user_count: "{{value, number}} kullanıcı",
        confirm_assign: "Rolleri ata",
        role_assigned: "Rol(ler) başarıyla atandı",
        search: "Rol adına, a\xe7ıklamasına veya Kimliğine g\xf6re arama yapın",
        empty: "Uygun rol yok"
    },
    warning_no_sign_in_identifier: "Kullanıcının giriş yapmak i\xe7in en az bir oturum a\xe7ma kimliği (kullanıcı adı, e-posta, telefon numarası, veya sosyal) olması gerekiyor. Devam etmek istediğinizden emin misiniz?",
    organization_roles_tooltip: "Bu organizasyon i\xe7inde kullanıcıya atanan roller."
};
var $b7f8b55a2a3bc566$export$2e2bcd8739ae039 = Object.freeze($b7f8b55a2a3bc566$var$user_details);


const $fb1290dd75723331$var$users = {
    page_title: "Kullanıcı Y\xf6netimi",
    title: "Kullanıcı Y\xf6netimi",
    subtitle: "Kullanıcı oluşturma, kullanıcı bilgilerini d\xfczenleme, kullanıcı kayıtlarını g\xf6r\xfcnt\xfcleme, parola sıfırlama ve kullanıcıları silme dahil olmak \xfczere kullanıcı kimliklerini y\xf6netin",
    create: "Kullanıcı ekle",
    create_subtitle: "Devam etmek i\xe7in en az bir alanı sağlayın.",
    error_missing_identifier: "Bir kullanıcı oluşturmak i\xe7in en az bir tanımlayıcı sağlamanız gerekir.",
    user_name: "Kullanıcı",
    application_name: "Uygulamadan",
    latest_sign_in: "En son oturum a\xe7ma",
    create_form_username: "Kullanıcı Adı",
    create_form_password: "Şifre",
    create_form_name: "Ad Soyad",
    placeholder_name: "Ali Veli",
    placeholder_email: "aveli@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+90 212 345 67 89",
    unnamed: "İsimsiz",
    search: "İsim, email, telefon veya kullanıcı adına g\xf6re arama",
    check_user_detail: "Kullanıcı detaylarını kontrol et",
    placeholder_title: "Kullanıcı y\xf6netimi",
    placeholder_description: "Her kullanıcının temel verileri, sosyal kimlikleri ve \xf6zel verilerini i\xe7eren bir profil vardır."
};
var $fb1290dd75723331$export$2e2bcd8739ae039 = Object.freeze($fb1290dd75723331$var$users);


const $eec115fd42572bc4$var$webhook_details = {
    page_title: "Webhook ayrıntıları",
    back_to_webhooks: "Webhooklara geri d\xf6n",
    not_in_use: "Kullanılmıyor",
    success_rate: "başarı oranı",
    requests: "24 saatte {{value, number}} istek",
    disable_webhook: "Webhooku devre dışı bırak",
    disable_reminder: "Bu webhooku yeniden etkinleştirmek istediğinizden emin misiniz? B\xf6yle yapmak, HTTP isteğini u\xe7 nokta URL’ye g\xf6ndermeyecektir.",
    webhook_disabled: "Webhook devre dışı bırakıldı.",
    webhook_reactivated: "Webhook tekrar etkinleştirildi.",
    reactivate_webhook: "Webhooku yeniden etkinleştir",
    delete_webhook: "Webhooku sil",
    deletion_reminder: "Bu webhook’u kaldırıyorsunuz. Silindikten sonra, HTTP isteği u\xe7 nokta URL’ye g\xf6nderilmeyecektir.",
    deleted: "Webhook başarıyla silindi.",
    settings_tab: "Ayarlar",
    recent_requests_tab: "Son istekler (24s)",
    settings: {
        settings: "Ayarlar",
        settings_description: "Webhooklar, belirli olaylarla ilgili ger\xe7ek zamanlı g\xfcncellemeleri almanızı sağlar, sağladıkları POST isteği Logto’daki u\xe7 nokta URL’nize g\xf6ndererek. Bu, yeni alınan bilgilere dayalı hemen harekete ge\xe7menizi sağlar.",
        events: "Olaylar",
        events_description: "Logto’nun POST isteğini g\xf6ndereceği tetikleyici olayları se\xe7in.",
        name: "İsim",
        endpoint_url: "U\xe7 nokta URL’si",
        signing_key: "İmza anahtarı",
        signing_key_tip: "Webhook’un y\xfck\xfc i\xe7in kimliğinin doğruluğunu sağlamak i\xe7in Logto tarafından sağlanan gizli anahtarın istek başlığı olarak u\xe7 noktanızda ekleyin.",
        regenerate: "Yeniden oluştur",
        regenerate_key_title: "İmza anahtarını yeniden oluştur",
        regenerate_key_reminder: "İmza anahtarını değiştirmek istediğinizden emin misiniz? Yeniden oluşturmak hemen etki edecektir. L\xfctfen u\xe7 noktanızdaki imza anahtarını senkronize olarak değiştirmeyi unutmayın.",
        regenerated: "İmza anahtarı yeniden oluşturuldu.",
        custom_headers: "\xd6zel başlıklar",
        custom_headers_tip: "İsteğin bir par\xe7ası olarak webhook’un y\xfck\xfcne isteğin bağlamı veya meta verileri sağlamak i\xe7in isteğe bağlı olarak \xf6zel başlıklar ekleyebilirsiniz.",
        key_duplicated_error: "Anahtarlar tekrarlanamaz.",
        key_missing_error: "Anahtar gereklidir.",
        value_missing_error: "Değer gereklidir.",
        invalid_key_error: "Anahtar ge\xe7ersiz",
        invalid_value_error: "Değer ge\xe7ersiz",
        test: "Test",
        test_webhook: "Webhook’unuzu test edin",
        test_webhook_description: "Webhook’u yapılandırın ve her se\xe7ilen olay i\xe7in y\xfck \xf6rnekleriyle test ederek doğru alma ve işleme işlemini doğrulayın.",
        send_test_payload: "Test y\xfck\xfcn\xfc g\xf6nder",
        test_result: {
            endpoint_url: "Son nokta URL: {{url}}",
            message: "Mesaj: {{message}}",
            response_status: "Yanıt durumu: {{status, number}}",
            response_body: "Yanıt g\xf6vdesi: {{body}}",
            request_time: "İstek zamanı: {{time}}",
            test_success: "Son noktaya yapılan webhook testi başarılı oldu."
        }
    }
};
var $eec115fd42572bc4$export$2e2bcd8739ae039 = Object.freeze($eec115fd42572bc4$var$webhook_details);


const $fc6320753d4e3c7f$var$webhooks = {
    page_title: "Webhooklar",
    title: "Webhooklar",
    subtitle: "Belirli olaylarla ilgili ger\xe7ek zamanlı g\xfcncellemeler almak i\xe7in webhooklar oluşturun.",
    create: "Webhook Oluştur",
    events: {
        post_register: "Yeni hesap oluştur",
        post_sign_in: "Oturum a\xe7ın",
        post_reset_password: "Parolayı sıfırla"
    },
    table: {
        name: "Adı",
        events: "Olaylar",
        success_rate: "Başarı Oranı (24s)",
        requests: "İstekler (24s)"
    },
    placeholder: {
        title: "Webhook",
        description: 'POST istekleri aracılığıyla u\xe7 nokta URL\'nize ger\xe7ek zamanlı g\xfcncellemeler almak i\xe7in bir webhook oluşturun. "Hesap Oluşturma", "Oturum A\xe7ma" ve "Şifre Sıfırlama" gibi olayların etkinliklerini takip edin ve hemen harekete ge\xe7in.',
        create_webhook: "Webhook Oluştur"
    },
    create_form: {
        title: "Webhook Oluştur",
        subtitle: "Webhook ekleyerek, Logto’nun kullanıcı eylemlerinin ayrıntılarını POST isteğiyle u\xe7 nokta URL’nize g\xf6ndermesini sağlayabilirsiniz.",
        events: "Olaylar",
        events_description: "Logto’nun POST isteğini g\xf6ndermesi i\xe7in tetikleyici olayları se\xe7in.",
        name: "Adı",
        name_placeholder: "Webhook adını girin",
        endpoint_url: "U\xe7 Nokta URL’si",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "Enter the URL of your endpoint where a webhook’s payload is sent to when the event occurs.",
        create_webhook: "Webhook Oluştur",
        missing_event_error: "En az bir olay se\xe7meniz gerekiyor."
    },
    webhook_created: "Webhook {{name}} başarıyla oluşturuldu."
};
var $fc6320753d4e3c7f$export$2e2bcd8739ae039 = Object.freeze($fc6320753d4e3c7f$var$webhooks);


const $44c6f2b29898a12a$var$welcome = {
    title: "Y\xf6netici Paneline Hoş Geldiniz",
    description: "Y\xf6netici paneli, kodlama bilgisi olmadan Logtoyu y\xf6netmek i\xe7in bir web uygulamasıdır. \xd6nce, bir hesap oluşturalım. Bu hesapla Logtoyu kendiniz veya şirketiniz adına y\xf6netebilirsiniz.",
    create_account: "Hesap Oluştur"
};
var $44c6f2b29898a12a$export$2e2bcd8739ae039 = Object.freeze($44c6f2b29898a12a$var$welcome);


const $d03cfb5e4841ee78$var$admin_console = {
    title: "Y\xf6netici Paneli",
    admin_user: "Y\xf6netici",
    system_app: "Sistem",
    menu: $f9f820502d6de2d4$export$2e2bcd8739ae039,
    general: $c24485abd64781a2$export$2e2bcd8739ae039,
    errors: $dbfbfcc40fbef071$export$2e2bcd8739ae039,
    tab_sections: $82ea7d482825ac8f$export$2e2bcd8739ae039,
    tabs: $0f36c5d97a96e767$export$2e2bcd8739ae039,
    applications: $f55bfa9d78640131$export$2e2bcd8739ae039,
    application_details: $cb85ca4be43d756c$export$2e2bcd8739ae039,
    api_resources: $60ee4953f71836cd$export$2e2bcd8739ae039,
    api_resource_details: $b8e08e9cb2b5e41f$export$2e2bcd8739ae039,
    connectors: $712bacdbf96d6d4a$export$2e2bcd8739ae039,
    connector_details: $e2fefe32e5790d85$export$2e2bcd8739ae039,
    enterprise_sso: $a8a927b040c434d6$export$2e2bcd8739ae039,
    enterprise_sso_details: $2a7727f9880d6119$export$2e2bcd8739ae039,
    get_started: $17ce5480919367cb$export$2e2bcd8739ae039,
    users: $fb1290dd75723331$export$2e2bcd8739ae039,
    user_details: $b7f8b55a2a3bc566$export$2e2bcd8739ae039,
    contact: $0205e98bb63dd907$export$2e2bcd8739ae039,
    sign_in_exp: $7ba2f624c01f8e88$export$2e2bcd8739ae039,
    dashboard: $6996db480eff8827$export$2e2bcd8739ae039,
    logs: $ca0ba4e73e90edb3$export$2e2bcd8739ae039,
    log_details: $4e986214ddc58fca$export$2e2bcd8739ae039,
    session_expired: $be5f344f0ac31d96$export$2e2bcd8739ae039,
    welcome: $44c6f2b29898a12a$export$2e2bcd8739ae039,
    roles: $03cc99fdf3c3704c$export$2e2bcd8739ae039,
    role_details: $3e956136d460867e$export$2e2bcd8739ae039,
    permissions: $d49ab06d6ac16d3d$export$2e2bcd8739ae039,
    cloud: $ca309540295c098c$export$2e2bcd8739ae039,
    profile: $7b5e763b39a79332$export$2e2bcd8739ae039,
    components: $761cbe73064b7485$export$2e2bcd8739ae039,
    webhooks: $fc6320753d4e3c7f$export$2e2bcd8739ae039,
    webhook_details: $eec115fd42572bc4$export$2e2bcd8739ae039,
    domain: $850add962c790fda$export$2e2bcd8739ae039,
    tenants: $d1b29552117c6413$export$2e2bcd8739ae039,
    topbar: $77cafbcbdf2894ac$export$2e2bcd8739ae039,
    subscription: $cdc0f0942c9e6afb$export$2e2bcd8739ae039,
    upsell: $44a7e1d97e4151b7$export$2e2bcd8739ae039,
    guide: $6cb8e6feb0f358a3$export$2e2bcd8739ae039,
    mfa: $b28aa478a266376c$export$2e2bcd8739ae039,
    organizations: $a485784c7935293a$export$2e2bcd8739ae039,
    organization_details: $88fa17918f2b4fd9$export$2e2bcd8739ae039
};
var $d03cfb5e4841ee78$export$2e2bcd8739ae039 = Object.freeze($d03cfb5e4841ee78$var$admin_console);


const $af3e2641728520c6$var$demo_app = {
    title: "Canlı \xf6nizlemede başarıyla oturum a\xe7tınız!",
    subtitle: "Sisteme giriş bilgileriniz:",
    username: "Kullanıcı Adı: ",
    user_id: "Kullanıcı Kimliği: ",
    sign_out: "Canlı \xd6nizlemeyi Kapat",
    continue_explore: "Veya keşfetmeye devam et",
    customize_sign_in_experience: "Oturum A\xe7ma Deneyimini \xd6zelleştir",
    enable_passwordless: "Şifresiz Etkinleştir",
    add_social_connector: "Sosyal Bağlantı Ekle"
};
var $af3e2641728520c6$export$2e2bcd8739ae039 = Object.freeze($af3e2641728520c6$var$demo_app);


const $fe4e9b98112f889b$var$oidc = {
    logout_success: "Başarıyla \xe7ıkış yaptınız."
};
var $fe4e9b98112f889b$export$2e2bcd8739ae039 = Object.freeze($fe4e9b98112f889b$var$oidc);


const $f1739967de9a2138$var$translation = {
    admin_console: $d03cfb5e4841ee78$export$2e2bcd8739ae039,
    demo_app: $af3e2641728520c6$export$2e2bcd8739ae039,
    oidc: $fe4e9b98112f889b$export$2e2bcd8739ae039
};
var $f1739967de9a2138$export$2e2bcd8739ae039 = Object.freeze($f1739967de9a2138$var$translation);


const $0f6c0441816902f3$var$tr_tr = {
    translation: $f1739967de9a2138$export$2e2bcd8739ae039,
    errors: $8a1974111374551f$export$2e2bcd8739ae039
};
var $0f6c0441816902f3$export$2e2bcd8739ae039 = Object.freeze($0f6c0441816902f3$var$tr_tr);


const $91050a440e664989$var$application = {
    invalid_type: "只有机器对机器应用程序可以有关联角色。",
    role_exists: "角色 ID {{roleId}} 已添加到此应用程序。",
    invalid_role_type: "无法将用户类型角色分配给机器对机器应用程序。"
};
var $91050a440e664989$export$2e2bcd8739ae039 = Object.freeze($91050a440e664989$var$application);


const $e5e2d9bd026b2878$var$auth = {
    authorization_header_missing: "Authorization 请求头缺失。",
    authorization_token_type_not_supported: "Authorization token 类型不支持",
    unauthorized: "未经授权。请检查凭据及其范围。",
    forbidden: "禁止访问。请检查用户 role 与权限。",
    expected_role_not_found: "未找到期望的 role。请检查用户 role 与权限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新认证以进行受保护操作。"
};
var $e5e2d9bd026b2878$export$2e2bcd8739ae039 = Object.freeze($e5e2d9bd026b2878$var$auth);


const $dbe23ce7f8e7ee18$var$connector = {
    general: "连接器发生错误：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 类型的连接器",
    not_enabled: "连接器尚未启用",
    invalid_metadata: "连接器 metadata 参数错误",
    invalid_config_guard: "连接器配置 guard 错误",
    unexpected_type: "连接器类型错误",
    invalid_request_parameters: "请求参数错误",
    insufficient_request_parameters: "请求参数缺失",
    invalid_config: "连接器配置错误",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "连接器错误响应",
    template_not_found: "无法从连接器配置中找到对应的模板",
    template_not_supported: "连接器不支持此模板类型。",
    rate_limit_exceeded: "触发速率限制。请稍后再试。",
    not_implemented: "方法 {{method}} 尚未实现",
    social_invalid_access_token: "当前连接器的 access_token 无效",
    invalid_auth_code: "当前连接器的授权码无效",
    social_invalid_id_token: "当前连接器的 id_token 无效",
    authorization_failed: "用户授权流程失败",
    social_auth_code_invalid: "无法获取 access_token，请检查授权 code 是否有效",
    more_than_one_sms: "同时存在超过 1 个短信连接器",
    more_than_one_email: "同时存在超过 1 个邮件连接器",
    more_than_one_connector_factory: "找到多个连接器工厂（id 为 {{connectorIds}}），请删除多余项。",
    db_connector_type_mismatch: "数据库中存在一个类型不匹配的连接。",
    not_found_with_connector_id: "找不到所给 connector id 对应的连接器",
    multiple_instances_not_supported: "你选择的连接器不支持创建多实例。",
    invalid_type_for_syncing_profile: "只有社交连接器可以开启用户档案同步。",
    can_not_modify_target: "不可修改连接器 target。",
    should_specify_target: "你需要声明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多个社交连接器不能重复使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆盖该连接器的 metadata 参数。"
};
var $dbe23ce7f8e7ee18$export$2e2bcd8739ae039 = Object.freeze($dbe23ce7f8e7ee18$var$connector);


const $dd553287f39a0351$var$domain = {
    not_configured: "域名主机提供商尚未配置。",
    cloudflare_data_missing: "cloudflare_data 缺失，请检查。",
    cloudflare_unknown_error: "请求 Cloudflare API 时出现未知错误。",
    cloudflare_response_error: "从 Cloudflare 得到意外的响应。",
    limit_to_one_domain: "仅限一个自定义域名。",
    hostname_already_exists: "该域名在我们的服务器中已存在。",
    cloudflare_not_found: "在 Cloudflare 中找不到主机名"
};
var $dd553287f39a0351$export$2e2bcd8739ae039 = Object.freeze($dd553287f39a0351$var$domain);


const $a26ada7c252ce897$var$entity = {
    invalid_input: "无效输入。值列表不能为空。",
    create_failed: "创建 {{name}} 失败。",
    db_constraint_violated: "数据库约束被破坏。",
    not_exists: "该 {{name}} 不存在。",
    not_exists_with_id: "ID 为 `{{id}}` 的 {{name}} 不存在。",
    not_found: "该资源不存在。",
    relation_foreign_key_not_found: "无法找到一个或多个外键。请检查输入，并确保所有引用的实体都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $a26ada7c252ce897$export$2e2bcd8739ae039 = Object.freeze($a26ada7c252ce897$var$entity);


const $4a77c756a41181e4$var$guard = {
    invalid_input: "请求中 {{type}} 无效",
    invalid_pagination: "分页参数无效",
    can_not_get_tenant_id: "无法从请求中获取租户 ID。",
    file_size_exceeded: "文件大小超过限制。",
    mime_type_not_allowed: "不允许使用此 MIME 类型。"
};
var $4a77c756a41181e4$export$2e2bcd8739ae039 = Object.freeze($4a77c756a41181e4$var$guard);


const $96c0e971f0d15b32$var$hook = {
    missing_events: "你需要提供至少一个事件。",
    send_test_payload_failed: "无法发送测试内容：{{message}}",
    endpoint_responded_with_error: "端点返回了错误。"
};
var $96c0e971f0d15b32$export$2e2bcd8739ae039 = Object.freeze($96c0e971f0d15b32$var$hook);


const $36efc604ef062627$var$localization = {
    cannot_delete_default_language: "你已设置 {{languageTag}} 为你的默认语言，你无法删除默认语言。",
    invalid_translation_structure: "无效的数据格式，请检查你的输入并重试。"
};
var $36efc604ef062627$export$2e2bcd8739ae039 = Object.freeze($36efc604ef062627$var$localization);


const $54932a995ab0eecb$var$log = {
    invalid_type: "日志类型无效。"
};
var $54932a995ab0eecb$export$2e2bcd8739ae039 = Object.freeze($54932a995ab0eecb$var$log);


const $b6f3f99f0eff9721$var$oidc = {
    aborted: "用户终止了交互。",
    invalid_scope: "无效的范围: {{error_description}}。",
    invalid_token: "Token 无效",
    invalid_client_metadata: "无效的客户端元数据",
    insufficient_scope: "Token 缺少范围 `{{scope}}`.",
    invalid_request: "请求无效",
    invalid_grant: "授权请求无效",
    invalid_redirect_uri: "无效返回链接, 该 redirect_uri 未被此应用注册。",
    access_denied: "访问被拒绝",
    invalid_target: "请求资源无效",
    unsupported_grant_type: "不支持的 grant_type",
    unsupported_response_mode: "不支持的 response_mode",
    unsupported_response_type: "不支持的 response_type",
    provider_error: "OIDC 内部错误: {{message}}",
    server_error: "发生了未知的 OIDC 错误。请稍后再试。",
    provider_error_fallback: "发生了 OIDC 错误: {{code}}。",
    key_required: "至少需要一个密钥。",
    key_not_found: "未找到 ID 为 {{id}} 的密钥。"
};
var $b6f3f99f0eff9721$export$2e2bcd8739ae039 = Object.freeze($b6f3f99f0eff9721$var$oidc);


const $02676d9db44cdfad$var$organization = {
    require_membership: "用户必须是组织的成员才能继续。"
};
var $02676d9db44cdfad$export$2e2bcd8739ae039 = Object.freeze($02676d9db44cdfad$var$organization);


const $3b3bd209b77345e4$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密码 pepper 未找到。请检查 core 的环境变量。",
    rejected: "密码被拒绝。请检查密码是否符合要求。"
};
var $3b3bd209b77345e4$export$2e2bcd8739ae039 = Object.freeze($3b3bd209b77345e4$var$password);


const $08739a6c7e77e2b8$var$request = {
    invalid_input: "输入无效。{{details}}",
    general: "发生请求错误。"
};
var $08739a6c7e77e2b8$export$2e2bcd8739ae039 = Object.freeze($08739a6c7e77e2b8$var$request);


const $746feafb6660a418$var$resource = {
    resource_identifier_in_use: "API 标识符 {{indicator}} 已被使用"
};
var $746feafb6660a418$export$2e2bcd8739ae039 = Object.freeze($746feafb6660a418$var$resource);


const $28af9eb373dbbe46$var$role = {
    name_in_use: "此角色名称 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    user_exists: "用户 ID {{userId}} 已添加到此角色",
    application_exists: "应用程序 ID {{applicationId}} 已添加到此角色",
    default_role_missing: "某些默认角色名称在数据库中不存在，请确保先创建角色",
    internal_role_violation: "你可能正在尝试更新或删除 Logto 禁止的内部角色。如果你要创建新角色，请尝试使用不以“#internal:”开头的名称。"
};
var $28af9eb373dbbe46$export$2e2bcd8739ae039 = Object.freeze($28af9eb373dbbe46$var$role);


const $07778894723e67d0$var$scope = {
    name_exists: "此作用域名称 {{name}} 已被使用",
    name_with_space: "作用域名称不能包含任何空格。"
};
var $07778894723e67d0$export$2e2bcd8739ae039 = Object.freeze($07778894723e67d0$var$scope);


const $55e545e553ec373d$var$session = {
    not_found: "未找到会话。请返回并重新登录。",
    invalid_credentials: "账号或密码错误，请重新输入。",
    invalid_sign_in_method: "当前登录方式不可用",
    invalid_connector_id: "找不到 ID 为 {{connectorId}} 的可用连接器。",
    insufficient_info: "登录信息缺失，请检查你的输入。",
    connector_id_mismatch: "传入的连接器 ID 与 session 中保存的记录不一致",
    connector_session_not_found: "无法找到连接器登录信息，请尝试重新登录。",
    verification_session_not_found: "验证失败，请重新验证。",
    verification_expired: "当前页面已超时。为确保你的账号安全，请重新验证。",
    verification_blocked_too_many_attempts: "Too many attempts in a short time. Please try again {{relativeTime}}.",
    unauthorized: "请先登录",
    unsupported_prompt_name: "不支持的 prompt name",
    forgot_password_not_enabled: "忘记密码功能没有开启。",
    verification_failed: "验证失败，请重新验证。",
    connector_validation_session_not_found: "找不到连接器用于验证 token 的信息。",
    identifier_not_found: "找不到用户标识符。请返回并重新登录。",
    interaction_not_found: "找不到交互会话。请返回并重新开始会话。",
    not_supported_for_forgot_password: "This operation is not supported for forgot password.",
    mfa: {
        require_mfa_verification: "Mfa verification is required to sign in.",
        mfa_sign_in_only: "Mfa is only available for sign-in interaction.",
        pending_info_not_found: "Pending MFA info not found, please initiate MFA first.",
        invalid_totp_code: "Invalid TOTP code.",
        webauthn_verification_failed: "WebAuthn verification failed.",
        webauthn_verification_not_found: "WebAuthn verification not found.",
        bind_mfa_existed: "MFA already exists.",
        backup_code_can_not_be_alone: "Backup code can not be the only MFA.",
        backup_code_required: "Backup code is required.",
        invalid_backup_code: "Invalid backup code.",
        mfa_policy_not_user_controlled: "MFA policy is not user controlled."
    },
    sso_enabled: "该邮箱已开启单点登录，请使用 SSO 登录。"
};
var $55e545e553ec373d$export$2e2bcd8739ae039 = Object.freeze($55e545e553ec373d$var$session);


const $0b1eb6b6845256b9$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你启用了“使用条款”，请添加使用条款 URL。",
    empty_social_connectors: "你启用了社交登录的方式。请至少选择一个社交连接器。",
    enabled_connector_not_found: "未找到已启用的 {{type}} 连接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登录方式必须有且仅有一个，请检查你的输入。",
    username_requires_password: "必须为用户名注册标识符启用设置密码。",
    passwordless_requires_verify: "必须为电子邮件/电话注册标识符启用验证。",
    miss_sign_up_identifier_in_sign_in: "登录方法必须包含注册标识符。",
    password_sign_in_must_be_enabled: "必须在注册中要求设置密码时启用密码登录。",
    code_sign_in_must_be_enabled: "必须在注册中不要求设置密码时启用验证码登录。",
    unsupported_default_language: "{{language}} 无法选择为默认语言。",
    at_least_one_authentication_factor: "至少要选择一个登录要素",
    backup_code_cannot_be_enabled_alone: "无法仅启用备份代码。",
    duplicated_mfa_factors: "重复的 MFA 要素。"
};
var $0b1eb6b6845256b9$export$2e2bcd8739ae039 = Object.freeze($0b1eb6b6845256b9$var$sign_in_experiences);


const $21e7465445c3bd4e$var$single_sign_on = {
    forbidden_domains: "不允许使用公共电子邮件域名。",
    duplicated_domains: "存在重复的域名。",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $21e7465445c3bd4e$export$2e2bcd8739ae039 = Object.freeze($21e7465445c3bd4e$var$single_sign_on);


const $82344f921ecf56f8$var$storage = {
    not_configured: "未配置存储提供程序。",
    missing_parameter: "存储提供程序缺少参数 {{parameter}}。",
    upload_error: "无法将文件上传到存储提供程序。"
};
var $82344f921ecf56f8$export$2e2bcd8739ae039 = Object.freeze($82344f921ecf56f8$var$storage);


const $dfa8d322f70bdea2$var$subscription = {
    limit_exceeded: "您已达到订阅计划的限制。",
    get_plan_failed: "无法获取租户的订阅计划。",
    tenant_suspended: "租户已被暂停。 请联系您的管理员。"
};
var $dfa8d322f70bdea2$export$2e2bcd8739ae039 = Object.freeze($dfa8d322f70bdea2$var$subscription);


const $63ae55f9cd6c6310$var$swagger = {
    invalid_zod_type: "无效的 Zod 类型，请检查路由 guard 配置。",
    not_supported_zod_type_for_params: "请求参数不支持的 Zod 类型，请检查路由 guard 配置。"
};
var $63ae55f9cd6c6310$export$2e2bcd8739ae039 = Object.freeze($63ae55f9cd6c6310$var$swagger);


const $c324355e889bb160$var$user = {
    username_already_in_use: "该用户名已被使用。",
    email_already_in_use: "该邮箱地址已被使用。",
    phone_already_in_use: "该手机号码已被使用。",
    invalid_email: "邮箱地址不正确。",
    invalid_phone: "手机号码不正确。",
    email_not_exist: "邮箱地址尚未注册。",
    phone_not_exist: "手机号码尚未注册。",
    identity_not_exist: "该社交帐号尚未注册。",
    identity_already_in_use: "该社交帐号已被注册。",
    social_account_exists_in_profile: "你已绑定当前社交账号，无需重复操作。",
    cannot_delete_self: "无法删除自己的账户。",
    sign_up_method_not_enabled: "注册方式尚未启用。",
    sign_in_method_not_enabled: "登录方式尚未启用。",
    same_password: "为确保账户安全，新密码不能与旧密码一致。",
    password_required_in_profile: "请设置登录密码。",
    new_password_required_in_profile: "请设置新密码。",
    password_exists_in_profile: "当前用户已设置密码，无需重复操作。",
    username_required_in_profile: "请设置用户名。",
    username_exists_in_profile: "当前用户已设置用户名，无需重复操作。",
    email_required_in_profile: "请绑定邮箱地址",
    email_exists_in_profile: "当前用户已绑定邮箱，无需重复操作。",
    phone_required_in_profile: "请绑定手机号码。",
    phone_exists_in_profile: "当前用户已绑定手机号，无需重复操作。",
    email_or_phone_required_in_profile: "请绑定邮箱地址或手机号码。",
    suspended: "账号已被禁用。",
    user_not_exist: "未找到与 {{identifier}} 相关联的用户。",
    missing_profile: "请于登录时提供必要的用户补充信息。",
    role_exists: "角色 ID {{roleId}} 已添加到此用户",
    invalid_role_type: "无效的角色类型，无法将机器到机器角色分配给用户。",
    missing_mfa: "你需要在登录之前绑定额外的MFA。",
    totp_already_in_use: "TOTP已在使用中。",
    backup_code_already_in_use: "备用代码已在使用中。"
};
var $c324355e889bb160$export$2e2bcd8739ae039 = Object.freeze($c324355e889bb160$var$user);


const $53f74b6b57166a15$var$verification_code = {
    phone_email_empty: "手机号与邮箱地址均为空",
    not_found: "验证码不存在，请先请求发送验证码",
    phone_mismatch: "手机号码不匹配，请尝试请求新的验证码。",
    email_mismatch: "邮箱地址不匹配，请尝试请求新的验证码。",
    code_mismatch: "验证码不正确",
    expired: "验证码已过期，请尝试请求新的验证码。",
    exceed_max_try: "超过最大验证次数，请尝试请求新的验证码。"
};
var $53f74b6b57166a15$export$2e2bcd8739ae039 = Object.freeze($53f74b6b57166a15$var$verification_code);


const $c296b3eaa0477fd1$var$errors = {
    request: $08739a6c7e77e2b8$export$2e2bcd8739ae039,
    auth: $e5e2d9bd026b2878$export$2e2bcd8739ae039,
    guard: $4a77c756a41181e4$export$2e2bcd8739ae039,
    oidc: $b6f3f99f0eff9721$export$2e2bcd8739ae039,
    user: $c324355e889bb160$export$2e2bcd8739ae039,
    password: $3b3bd209b77345e4$export$2e2bcd8739ae039,
    session: $55e545e553ec373d$export$2e2bcd8739ae039,
    connector: $dbe23ce7f8e7ee18$export$2e2bcd8739ae039,
    verification_code: $53f74b6b57166a15$export$2e2bcd8739ae039,
    sign_in_experiences: $0b1eb6b6845256b9$export$2e2bcd8739ae039,
    localization: $36efc604ef062627$export$2e2bcd8739ae039,
    swagger: $63ae55f9cd6c6310$export$2e2bcd8739ae039,
    entity: $a26ada7c252ce897$export$2e2bcd8739ae039,
    log: $54932a995ab0eecb$export$2e2bcd8739ae039,
    role: $28af9eb373dbbe46$export$2e2bcd8739ae039,
    scope: $07778894723e67d0$export$2e2bcd8739ae039,
    storage: $82344f921ecf56f8$export$2e2bcd8739ae039,
    resource: $746feafb6660a418$export$2e2bcd8739ae039,
    hook: $96c0e971f0d15b32$export$2e2bcd8739ae039,
    domain: $dd553287f39a0351$export$2e2bcd8739ae039,
    subscription: $dfa8d322f70bdea2$export$2e2bcd8739ae039,
    application: $91050a440e664989$export$2e2bcd8739ae039,
    organization: $02676d9db44cdfad$export$2e2bcd8739ae039,
    single_sign_on: $21e7465445c3bd4e$export$2e2bcd8739ae039
};
var $c296b3eaa0477fd1$export$2e2bcd8739ae039 = Object.freeze($c296b3eaa0477fd1$var$errors);


const $680ad7ed0f1b5dc9$var$api_resource_details = {
    page_title: "API 资源详情",
    back_to_api_resources: "返回 API 资源",
    settings_tab: "设置",
    permissions_tab: "权限",
    settings: "设置",
    settings_description: "API 资源，又称资源指示器，表示要请求的目标服务或资源，通常是表示资源身份的 URI 格式变量。",
    management_api_settings_description: "Logto 管理 API 是一组全面的 API，使管理员能够管理各种与身份相关的任务，执行安全策略并遵守法规和标准。",
    management_api_notice: "该 API 代表 Logto 实体，无法修改或删除。你可以使用管理 API 来执行范围广泛的与身份相关的任务。 <a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 过期时间（秒）",
    token_expiration_time_in_seconds_placeholder: "请输入你的 token 过期时间",
    delete_description: "本操作会永久性地删除该 API 资源，且不可撤销。输入 API 资源名称 <span>{{name}}</span> 确认。",
    enter_your_api_resource_name: "输入 API 资源名称",
    api_resource_deleted: " API 资源 {{name}} 已删除.",
    permission: {
        create_button: "创建权限",
        create_title: "创建权限",
        create_subtitle: "定义此 API 所需的权限 (scope)。",
        confirm_create: "创建权限",
        name: "权限名称",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "权限名称不能包含空格。",
        description: "描述",
        description_placeholder: "能够读取资源",
        permission_created: '权限 "{{name}}" 已成功创建',
        delete_description: "如果删除此权限，拥有该权限的用户将失去由此权限授予的访问权限。",
        deleted: '成功删除权限 "{{name}}"。'
    }
};
var $680ad7ed0f1b5dc9$export$2e2bcd8739ae039 = Object.freeze($680ad7ed0f1b5dc9$var$api_resource_details);


const $4a1344931c3a68bb$var$api_resources = {
    page_title: "API 资源",
    title: "API 资源",
    subtitle: "定义可以从已授权的应用程序中使用的 API",
    create: "创建 API 资源",
    api_name: "API 名称",
    api_name_placeholder: "输入API名称",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "对于 API 资源的唯一标识符。它必须是一个绝对 URI 并没有 fragment (#) 组件。等价于 OAuth 2.0 中的 <a>resource parameter</a>。",
    default_api: "默认API",
    default_api_label: "每个租户只能设置零个或一个默认 API。当指定默认 API 时，可以在认证请求中省略资源参数。后续令牌交换将默认使用该 API 作为 Audience，从而签发 JWT。<a>了解更多</a>",
    api_resource_created: " API 资源 {{name}} 已成功创建。"
};
var $4a1344931c3a68bb$export$2e2bcd8739ae039 = Object.freeze($4a1344931c3a68bb$var$api_resources);


const $5bcca92f6c70eb95$var$application_details = {
    page_title: "应用详情",
    back_to_applications: "返回全部应用",
    check_guide: "查看指南",
    settings: "设置",
    settings_description: "应用程序用于在 Logto OIDC、登录体验、审计日志等方面识别你的应用程序。",
    advanced_settings: "高级设置",
    advanced_settings_description: "高级设置包括 OIDC 相关术语。你可以查看 Token Endpoint 以获取更多信息。",
    application_roles: "角色",
    machine_logs: "机器日志",
    application_name: "应用名称",
    application_name_placeholder: "我的应用",
    description: "描述",
    description_placeholder: "请输入应用描述",
    config_endpoint: "OpenID Provider 配置端点",
    authorization_endpoint: "授权端点",
    authorization_endpoint_tip: "进行鉴权与授权的端点。用于 OpenID Connect 中的 <a>鉴权</a> 流程。",
    logto_endpoint: "Logto 端点",
    application_id: "应用 ID",
    application_id_tip: "应用的唯一标识，通常由 Logto 生成。等价于 OpenID Connect 中的 <a>client_id</a>。",
    application_secret: "应用密钥",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在用户登录完成（不论成功与否）后重定向的目标 URI。参见 OpenID Connect <a>AuthRequest</a> 以了解更多。",
    post_sign_out_redirect_uri: "退出登录后重定向 URI",
    post_sign_out_redirect_uris: "退出登录后重定向 URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在用户退出登录后重定向的目标 URI（可选）。在某些应用类型中可能无实质作用。",
    cors_allowed_origins: "CORS 允许的来源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重定向 URI 的来源将默认被允许。通常不需要对此字段进行操作。参见 <a>MDN 文档</a> 以了解更多。",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "用户信息端点",
    enable_admin_access: "启用管理访问",
    enable_admin_access_label: "启用或禁用对管理 API 的访问。启用后，你可以使用访问令牌代表该应用程序调用管理 API。",
    always_issue_refresh_token: "总是颁发 Refresh Token",
    always_issue_refresh_token_label: "启用此配置将允许 Logto 始终颁发 Refresh Token，无论身份验证请求中是否呈现 `prompt=consent`。 然而，除非必要，否则不推荐这样做，因为它与 OpenID Connect 不兼容，可能会导致问题。",
    refresh_token_ttl: "Refresh Token 有效期（天）",
    refresh_token_ttl_tip: "可用于请求新访问令牌的 Refresh Token 在过期之前的时间段。访问令牌请求将把 Refresh Token 的时效延长到此值。",
    rotate_refresh_token: "轮换 Refresh Token",
    rotate_refresh_token_label: "启用后，当原先的 Refresh Token 的时效已经过去 70%，或者满足一定条件时，Logto 将会为访问令牌请求发放新的 Refresh Token。<a>了解更多</a>",
    delete_description: "本操作会永久性地删除该应用，且不可撤销。输入 <span>{{name}}</span> 确认。",
    enter_your_application_name: "输入你的应用名称",
    application_deleted: "应用 {{name}} 成功删除。",
    redirect_uri_required: "至少需要输入一个重定向 URI。",
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作将会从此应用中移除此角色。角色本身仍然存在，但不再与此应用关联。",
        deleted: "成功从此用户中移除 {{name}}。",
        assign_title: "为 {{name}} 分配角色",
        assign_subtitle: "授权 {{name}} 一个或多个角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名称搜索",
        added_text: "{{value, number}}个已添加",
        assigned_app_count: "{{value, number}}个应用",
        confirm_assign: "分配角色",
        role_assigned: "成功分配角色",
        search: "按角色名称、描述或 ID 搜索",
        empty: "没有可用的角色"
    }
};
var $5bcca92f6c70eb95$export$2e2bcd8739ae039 = Object.freeze($5bcca92f6c70eb95$var$application_details);


const $99adaba39edb5636$var$applications = {
    page_title: "全部应用",
    title: "全部应用",
    subtitle: "创建一个移动、单页、machine-to-machine 或传统 web 应用程序，并通过 Logto 进行身份验证",
    subtitle_with_app_type: "为你的 {{name}} 应用程序设置 Logto 身份验证",
    create: "创建应用",
    application_name: "应用名称",
    application_name_placeholder: "我的应用",
    application_description: "应用描述",
    application_description_placeholder: "请输入应用描述",
    select_application_type: "选择应用类型",
    no_application_type_selected: "你还没有选择应用类型",
    application_created: "创建应用成功。",
    app_id: "App ID",
    type: {
        native: {
            title: "原生应用",
            subtitle: "在原生环境中运行的应用程序",
            description: "例如 iOS app，Android app"
        },
        spa: {
            title: "单页应用",
            subtitle: "在浏览器中运行并动态更新数据的应用程序",
            description: "例如 React DOM app，Vue app"
        },
        traditional: {
            title: "传统网页应用",
            subtitle: "仅由 Web 服务器渲染和更新的应用程序",
            description: "例如 Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "直接与资源对话的应用程序（通常是服务）",
            description: "例如，后端服务"
        }
    },
    placeholder_title: "选择应用程序类型以继续",
    placeholder_description: "Logto 使用 OIDC 的应用程序实体来帮助识别你的应用程序、管理登录和创建审计日志等任务。"
};
var $99adaba39edb5636$export$2e2bcd8739ae039 = Object.freeze($99adaba39edb5636$var$applications);


const $ea91e5afd39c9788$var$cloud = {
    general: {
        onboarding: "入门"
    },
    welcome: {
        page_title: "欢迎",
        title: "欢迎来到 Logto Cloud！我们很想了解你。",
        description: "通过更好地了解你，我们可以使你的 Logto 体验更加个性化。你的信息是安全的。",
        project_field: "我使用 Logto 是为了",
        project_options: {
            personal: "个人项目",
            company: "公司项目"
        },
        title_field: "选择适用的职位",
        title_options: {
            developer: "开发人员",
            team_lead: "团队负责人",
            ceo: "CEO",
            cto: "CTO",
            product: "产品",
            others: "其他"
        },
        company_name_field: "公司名称",
        company_name_placeholder: "Acme.co",
        company_size_field: "你的公司规模如何？",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "我注册的原因是",
        reason_options: {
            passwordless: "寻找无需密码身份验证和 UI 工具包",
            efficiency: "寻找即插即用的身份基础架构",
            access_control: "基于角色和责任控制用户访问",
            multi_tenancy: "寻求面向多租户产品的策略",
            enterprise: "为产品更方便企业使用寻找 SSO 解决方案",
            others: "其他"
        }
    },
    sie: {
        page_title: "定制登录体验",
        title: "让我们轻松定制你的登录体验",
        inspire: {
            title: "创建引人入胜的示例",
            description: "对登录体验不确定吗？只需点击“启发我”，让魔法发生！",
            inspire_me: "来点灵感"
        },
        logo_field: "应用商标",
        color_field: "品牌颜色",
        identifier_field: "标识符",
        identifier_options: {
            email: "电子邮件",
            phone: "电话",
            user_name: "用户名"
        },
        authn_field: "身份验证",
        authn_options: {
            password: "密码",
            verification_code: "验证码"
        },
        social_field: "社交登录",
        finish_and_done: "完成并完成",
        preview: {
            mobile_tab: "移动端",
            web_tab: "网页端"
        },
        connectors: {
            unlocked_later: "稍后解锁",
            unlocked_later_tip: "完成入门流程并进入产品后，你将获得访问更多社交登录方式的权限。",
            notice: "请勿将演示连接器用于生产目的。完成测试后，请删除演示连接器并使用你的凭据设置自己的连接器。"
        }
    },
    socialCallback: {
        title: "你已成功登录",
        description: "你已成功使用社交账户登录。为确保与 Logto 的无缝集成并获得所有功能的访问权限，我们建议你继续配置自己的社交连接器。"
    },
    tenant: {
        create_tenant: "创建租户"
    }
};
var $ea91e5afd39c9788$export$2e2bcd8739ae039 = Object.freeze($ea91e5afd39c9788$var$cloud);


const $ad0fb795e2445ef6$var$components = {
    uploader: {
        action_description: "拖放或浏览上传",
        uploading: "上传中...",
        image_limit: "上传图片大小不能超过 {{size, number}}KB，只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_upload: "哎呀，出了些问题。文件上传失败。",
        error_file_size: "文件太大了，请上传小于 {{size, number}}KB 的文件。",
        error_file_type: "不支持该文件类型。只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_file_count: "只能上传一个文件。"
    }
};
var $ad0fb795e2445ef6$export$2e2bcd8739ae039 = Object.freeze($ad0fb795e2445ef6$var$components);


const $6371d6cddddc4d9d$var$connector_details = {
    page_title: "连接器详情",
    back_to_connectors: "返回连接器",
    check_readme: "查看 README",
    settings: "通用设置",
    settings_description: "连接器在 Logto 中扮演着至关重要的角色。借助它们的帮助，Logto 使终端用户能够使用无密码注册或登录的功能以及使用社交帐户登录的功能。",
    parameter_configuration: "参数配置",
    test_connection: "测试",
    save_error_empty_config: "请输入配置内容",
    send: "发送",
    send_error_invalid_format: "无效输入",
    edit_config_label: "请在此输入你的 JSON 配置",
    test_email_sender: "测试你的邮件连接器",
    test_sms_sender: "测试你的短信连接器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "测试信息已发送",
    test_sender_description: 'Logto 使用 "Generic" 模板进行测试。如果你的连接器正确配置，你将收到一条消息。',
    options_change_email: "更换邮件连接器",
    options_change_sms: "更换短信连接器",
    connector_deleted: "成功删除连接器",
    type_email: "邮件连接器",
    type_sms: "短信连接器",
    type_social: "社交连接器",
    in_used_social_deletion_description: "你的登录体验正在使用这个连接器。删除后，<name/> 登录体验将在登录体验设置中被删除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "你的登录体验正在使用 {{name}} 连接器。删除后，你的登录体验将无法正常工作，直到你解决冲突，再次添加需重新配置。",
    deletion_description: "你将删除此连接器。此操作不可撤销，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "已发送邮件总数: {{value, number}}",
        total_email_sent_tip: "Logto 使用 SendGrid 进行安全稳定的内置电子邮件功能。此功能完全免费使用。<a>了解更多</a>",
        email_template_title: "电子邮件模板",
        template_description: "内置电子邮件使用默认模板，无需配置即可无缝发送验证电子邮件。您可以自定义基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "发件人电子邮件",
        sender_name_field: "发件人姓名",
        sender_name_tip: "自定义电子邮件的发件人姓名。如果留空，则默认使用「Verification」作为名称。",
        sender_name_placeholder: "发件人姓名",
        company_information_field: "公司信息",
        company_information_description: "在电子邮件底部显示您公司的名称、地址或邮编，以增强真实性。",
        company_information_placeholder: "你公司的基本信息",
        app_logo_field: "应用程序标志",
        app_logo_tip: "在电子邮件顶部显示您的品牌标志。在浅色模式和深色模式下使用相同的图像。",
        urls_not_allowed: "不允许使用 URL",
        test_notes: 'Logto 使用 "通用" 模板进行测试。'
    }
};
var $6371d6cddddc4d9d$export$2e2bcd8739ae039 = Object.freeze($6371d6cddddc4d9d$var$connector_details);


const $c4a6d11ed8ec9bb8$var$connectors = {
    page_title: "连接器",
    title: "连接器",
    subtitle: "设置连接器，开启无密码和社交登录",
    create: "添加社交连接器",
    config_sie_notice: "你已经配置了社交连接器，记得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登录体验",
    tab_email_sms: "短信和邮件连接器",
    tab_social: "社交连接器",
    connector_name: "连接器名称",
    demo_tip: "演示连接器仅用于演示且最多只能发送 100 条消息，不建议在生产环境中部署。",
    social_demo_tip: "演示连接器仅用于演示目的，不建议在生产环境中部署。",
    connector_type: "类型",
    connector_status: "登录体验",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味着你的登录体验并没有使用这个登录方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登录体验"
    },
    placeholder_title: "社交连接器",
    placeholder_description: "Logto 提供了许多广泛使用的社交登录连接器，同时你还可以使用标准协议创建自己的连接器。",
    save_and_done: "保存并完成",
    type: {
        email: "邮件连接器",
        sms: "短信连接器",
        social: "社交连接器"
    },
    setup_title: {
        email: "设置邮件连接器",
        sms: "设置短信连接器",
        social: "添加社交连接器"
    },
    guide: {
        subtitle: "参考以下步骤完成你的连接器设置",
        general_setting: "通用设置",
        parameter_configuration: "参数配置",
        test_connection: "连接测试",
        name: "社交登录按钮的名称",
        name_placeholder: "输入社交登录按钮的名称",
        name_tip: "按钮上将展示「通过 {{name}} 继续」。名字不宜过长而导致信息无法展示完整。",
        logo: "社交登录按钮的 Logo 图片链接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "该图片将用于连接器的展示。获取图片链接后粘贴在此处。",
        logo_dark: "社交登录按钮的 Logo 图片链接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制台的登录体验中启用“深色模式”后，可设置此连接器 Logo 用于深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展开深色模式 Logo 设置",
        target: "身份提供商名称",
        target_placeholder: "输入身份提供商的名称",
        target_tip: "在“身份供应商名称”字段中输入唯一的标识符字符串，用于区分社交身份来源。",
        target_tip_standard: "在“身份供应商名称”字段中输入唯一的标识符字符串，用于区分社交身份来源。注意，在连接器创建成功后，无法再次修改此设置。",
        target_tooltip: "Logto 社交连接器的「target」指的是社交身份的「来源」。在 Logto 的设计里，我们不允许某一平台的连接器中有相同的「target」以避免身份的冲突。在添加连接器时，你需要格外小心，我们「不允许」用户在创建之后更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供应商名称」值与现有的 <span>name</span> 连接器相同。使用相同的身份供应商名称会导致不符合预期的登录行为，用户可能通过两个不同的连接器访问同一个帐户。",
        target_conflict_line2: "如果你想替换当前的连接器，并连接相同的身份提供商（IdP），以便先前的用户可以直接登录而无需重新注册，请先删除 <span>name</span> 连接器，再创建一个新的连接器并使用相同的「身份供应商名称」值。",
        target_conflict_line3: "如果你想连接一个新的身份验证提供程序，请修改「身份供应商名称」并继续。",
        config: "粘贴你的 JSON 代码",
        sync_profile: "开启用户资料同步",
        sync_profile_only_at_sign_up: "首次注册时同步",
        sync_profile_each_sign_in: "每次登录时同步",
        sync_profile_tip: "同步用户的用户名、头像等个人资料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也称为重定向 URI，在社交授权后，用户将被发送回 Logto 的 URI，复制并粘贴到社交提供者的配置页面中。"
    },
    platform: {
        universal: "通用",
        web: "网页",
        native: "原生"
    },
    add_multi_platform: "支持多平台，选择一个平台继续",
    drawer_title: "连接器配置指南",
    drawer_subtitle: "参考以下步骤完善或修改你的连接器设置",
    unknown: "未知连接器",
    standard_connectors: "标准连接器"
};
var $c4a6d11ed8ec9bb8$export$2e2bcd8739ae039 = Object.freeze($c4a6d11ed8ec9bb8$var$connectors);


const $f3e3feb1b13b0796$var$contact = {
    title: "获取帮助",
    description: "有关帮助请求或产品反馈，请通过以下方式与我们联系。",
    discord: {
        title: "加入 Discord 社区",
        description: "与其他开发人员建立联系以找到解决方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上交流",
        description: "在 GitHub 上创建问题并提交",
        button: "打开"
    },
    email: {
        title: "通过邮件联系支持",
        description: "发送电子邮件以获取更多信息和帮助",
        button: "发送"
    },
    reserve: {
        title: "与 Logto 团队预定时间",
        description: "快速预定一次在线聊天",
        button: "预定"
    }
};
var $f3e3feb1b13b0796$export$2e2bcd8739ae039 = Object.freeze($f3e3feb1b13b0796$var$contact);


const $397069b2bc591a58$var$dashboard = {
    page_title: "仪表盘",
    title: "仪表盘",
    description: "查看所有应用的数据概况",
    total_users: "总用户",
    total_users_tip: "总用户",
    new_users_today: "今日新增",
    new_users_today_tip: "今日注册到你应用上的新用户数",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日注册到你应用上的新用户数",
    daily_active_users: "日活用户",
    daily_active_users_tip: "今日在你的应用上交换过 token 的独立用户数",
    weekly_active_users: "周活用户",
    weekly_active_users_tip: "最近 7 日在你的应用上交换过 token 的独立用户数",
    monthly_active_users: "月活用户",
    monthly_active_users_tip: "最近 30 日在你的应用上交换过 token 的独立用户数"
};
var $397069b2bc591a58$export$2e2bcd8739ae039 = Object.freeze($397069b2bc591a58$var$dashboard);


const $ef94479a0c2558e7$var$domain = {
    status: {
        connecting: "连接中",
        in_used: "使用中",
        failed_to_connect: "连接失败"
    },
    update_endpoint_notice: "如果您想使用自定义域名，请不要忘记在应用程序中更新社交连接器回调 URI 和 Logto 终结点的域名。 <a>{{link}}</a>",
    error_hint: "请确保更新您的 DNS 记录。我们将继续每 {{value}} 秒检查一次。",
    custom: {
        custom_domain: "自定义域名",
        custom_domain_description: "通过使用自定义域名来提高品牌形象。此域名将用于您的登录体验。",
        custom_domain_field: "自定义域名",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "添加域名",
        invalid_domain_format: "无效的子域名格式，请至少输入三个部分的子域名。",
        verify_domain: "验证域名",
        enable_ssl: "启用 SSL",
        checking_dns_tip: "DNS 记录已配置，请等待最长 24 小时，以使变更生效。在域名是否有效期间，您可以离开此界面。",
        enable_ssl_tip: "启用 SSL 将自动运行，可能需要最长 24 小时。在运行期间，您可以离开此界面。",
        generating_dns_records: "正在生成 DNS 记录...",
        add_dns_records: "请将以下 DNS 记录添加到您的 DNS 服务提供商。",
        dns_table: {
            type_field: "类型",
            name_field: "名称",
            value_field: "值"
        },
        deletion: {
            delete_domain: "删除域名",
            reminder: "删除自定义域名",
            description: "您确定要删除此自定义域名吗？",
            in_used_description: '您确定要删除此自定义域名 "<span>{{domain}}</span>" 吗？',
            in_used_tip: '如果您之前已在社交连接器提供商或应用程序终结点中设置了此自定义域名，则需要先将 URI 修改为 Logto 默认域名 "<span>{{domain}}</span>"。 这对于社交登录按钮的正常工作是必要的。',
            deleted: "自定义域名删除成功！"
        }
    },
    default: {
        default_domain: "默认域名",
        default_domain_description: "Logto 提供了一个预配置的默认域名，无需任何其他设置即可使用。即使您启用了自定义域名，此默认域名也可作为备用选项。",
        default_domain_field: "Logto 默认域名"
    },
    custom_endpoint_note: '您可以根据需要自定义这些端点的域名。选择 "{{custom}}" 或 "{{default}}"。',
    custom_social_callback_url_note: '您可以根据需要自定义此 URI 的域名，以匹配您的应用程序端点。选择 "{{custom}}" 或 "{{default}}"。'
};
var $ef94479a0c2558e7$export$2e2bcd8739ae039 = Object.freeze($ef94479a0c2558e7$var$domain);


const $566b35a9e48b2c70$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $566b35a9e48b2c70$export$2e2bcd8739ae039 = Object.freeze($566b35a9e48b2c70$var$enterprise_sso_details);


const $584dd66dd0b52e3c$var$enterprise_sso = {
    page_title: "企业单点登录",
    title: "企业单点登录",
    subtitle: "连接企业身份提供者并启用SP启动的单点登录。",
    create: "添加企业连接器",
    col_connector_name: "连接器名称",
    col_type: "类型",
    col_email_domain: "电子邮件域",
    placeholder_title: "企业连接器",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "添加企业连接器",
        text_divider: "或者您可以通过标准协议自定义您的连接器。",
        connector_name_field_title: "连接器名称",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "创建连接器"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $584dd66dd0b52e3c$export$2e2bcd8739ae039 = Object.freeze($584dd66dd0b52e3c$var$enterprise_sso);


const $0dcd066df2d60937$var$errors = {
    something_went_wrong: "哎呀，出错了！",
    page_not_found: "找不到页面",
    unknown_server_error: "服务器发生未知错误",
    empty: "没有数据",
    missing_total_number: "无法从返回的头部信息中找到 Total-Number",
    invalid_uri_format: "无效的 URI 格式",
    invalid_origin_format: "无效的 URI origin 格式",
    invalid_json_format: "无效的 JSON 格式",
    invalid_error_message_format: "非法的错误信息格式",
    required_field_missing: "请输入{{field}}",
    required_field_missing_plural: "至少需要输入一个{{field}}",
    more_details: "查看详情",
    username_pattern_error: "用户名只能包含英文字母、数字或下划线，且不以数字开头。",
    email_pattern_error: "邮箱地址无效",
    phone_pattern_error: "手机号码无效",
    insecure_contexts: "不支持不安全的上下文（非 HTTPS）。",
    unexpected_error: "发生未知错误",
    not_found: "404 找不到资源",
    create_internal_role_violation: '你正在创建一个被 Logto 禁止内部角色。尝试使用不以 "#internal:" 开头的其他名称。',
    should_be_an_integer: "应该是整数。",
    number_should_be_between_inclusive: "然后数字应该在 {{min}} 到 {{max}} 之间（两端都包括）。"
};
var $0dcd066df2d60937$export$2e2bcd8739ae039 = Object.freeze($0dcd066df2d60937$var$errors);


const $f462b7b2890ab6a2$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳过",
    next: "下一步",
    back: "上一步",
    retry: "重试",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除结果",
    save: "保存",
    save_changes: "保存更改",
    saved: "保存成功",
    discard: "放弃",
    loading: "读取中...",
    redirecting: "页面跳转中...",
    add: "添加",
    added: "已添加",
    cancel: "取消",
    confirm: "确认",
    check_out: "查看",
    create: "创建",
    set_up: "配置",
    customize: "自定义",
    enable: "启用",
    reminder: "提示",
    delete: "删除",
    more_options: "更多选项",
    close: "关闭",
    copy: "复制",
    copying: "复制中",
    copied: "已复制",
    required: "必填",
    add_another: "新增",
    create_another: "创建另一个",
    deletion_confirmation: "你确定要删除这个 {{title}} 吗?",
    settings_nav: "设置",
    unsaved_changes_warning: "还有未保存的变更, 确定要离开吗？",
    leave_page: "离开此页",
    stay_on_page: "留在此页",
    type_to_search: "输入搜索",
    got_it: "知道了",
    continue: "继续",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 条",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 个错误",
    skip_for_now: "先跳过",
    remove: "移除",
    visit: "访问",
    join: "加入",
    try_now: "现在试试",
    multiple_form_field: "（多选）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    hide: "隐藏",
    unknown_error: "未知错误，请稍后重试。",
    select: "选择",
    contact_us_action: "联系我们",
    description: "描述",
    name: "名称",
    add_field: "添加{{field}}",
    create_field: "创建{{field}}",
    edit_field: "编辑{{field}}",
    delete_field: "删除{{field}}",
    coming_soon: "即将上线",
    beta_notice: "\uD83C\uDF89 {{feature}} 目前处于测试阶段。欢迎您去探索并<ContactLink>分享您的反馈</ContactLink>。"
};
var $f462b7b2890ab6a2$export$2e2bcd8739ae039 = Object.freeze($f462b7b2890ab6a2$var$general);


const $d7e21995357fdd91$var$get_started = {
    page_title: "开始上手",
    title: "成功开发身份方案，我们先来探索一番",
    subtitle: "一些你可以做的事情，以快速获取 Logto 的价值",
    develop: {
        title: "开发：花 5 分钟集成你的应用"
    },
    customize: {
        title: "自定义：提供出色的登录体验",
        preview: {
            title: "实时预览定制的登录体验",
            subtitle: "立刻尝试 Logto 登录体验，看看它是如何工作的"
        },
        connector: {
            title: "添加更多连接器来支持更多社交登录方式",
            subtitle: "尝试免密码登录，为您的客户提供安全、无摩擦的体验"
        },
        continue_customizing: "继续定制",
        try_now: "立即尝试",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保护你的资源"
    },
    manage: {
        title: "管理：为你的产品和用户定义访问控制",
        rbac: {
            title: "为你的资源添加基于角色的访问控制",
            subtitle: "通过可扩展的角色授权控制你的资源，应对不同的使用场景。"
        },
        create_roles: "创建角色"
    },
    view_all: "查看全部 →"
};
var $d7e21995357fdd91$export$2e2bcd8739ae039 = Object.freeze($d7e21995357fdd91$var$get_started);


const $49a18f2bff20dc4f$var$guide = {
    start_building: "开始构建",
    get_started: "立即开始",
    categories: {
        featured: "推荐热门开发框架",
        Traditional: "传统网页应用",
        SPA: "单页应用",
        Native: "原生应用",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "筛选框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你现在不需要教程，可以点击右侧按钮继续创建应用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在寻找的教程",
    request_guide_successfully: "请求已成功提交，谢谢！",
    app: {
        select_framework_or_tutorial: "选择一个框架或教程",
        guide_modal_title: "从 SDK 和指南开始",
        modal_subtitle: "使用我们提供的 SDK 和集成教程加速你的应用开发过程。",
        select_a_framework: "选择一个框架",
        continue_without_framework: "跳过教程直接创建应用",
        describe_guide_looking_for_placeholder: "例如：我想将 Logto 集成到我的 Angular 应用程序中。"
    },
    api: {
        modal_title: "首先从教程开始",
        modal_subtitle: "使用我们提供的教程来加速你的应用程序开发过程。",
        select_a_tutorial: "选择一个教程",
        continue_without_tutorial: "跳过教程直接创建 API 资源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架为我的 API 鉴权。"
    }
};
var $49a18f2bff20dc4f$export$2e2bcd8739ae039 = Object.freeze($49a18f2bff20dc4f$var$guide);


const $f610c363f89b6116$var$log_details = {
    page_title: "审计日志详情",
    back_to_logs: "返回审计日志",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失败",
    event_key: "事件 Key",
    application: "应用",
    ip_address: "IP 地址",
    user: "用户",
    log_id: "日志 ID",
    time: "时间",
    user_agent: "用户代理",
    tab_details: "详情",
    raw_data: "原始数据"
};
var $f610c363f89b6116$export$2e2bcd8739ae039 = Object.freeze($f610c363f89b6116$var$log_details);


const $079b21543a745f77$var$logs = {
    page_title: "审计日志",
    title: "审计日志",
    subtitle: "查看用户行为和事件",
    event: "事件",
    user: "用户",
    application: "应用",
    time: "时间",
    filter_by: "过滤"
};
var $079b21543a745f77$export$2e2bcd8739ae039 = Object.freeze($079b21543a745f77$var$logs);


const $4a7907215bc1ca72$var$menu = {
    profile: "帐户管理",
    language: "语言",
    appearance: {
        label: "主题",
        light: "浅色模式",
        dark: "深色模式",
        system: "跟随系统"
    },
    sign_out: "退出登录"
};
var $4a7907215bc1ca72$export$2e2bcd8739ae039 = Object.freeze($4a7907215bc1ca72$var$menu);


const $a3d85a7c229bd267$var$mfa = {
    title: "多因素身份验证",
    description: "添加多因素身份验证以提升您登录体验的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用户需要验证启用的两步验证中的一个因素。",
    totp: "身份验证器应用 OTP",
    otp_description: "将Google Authenticator等链接，以验证一次性密码。",
    webauthn: "WebAuthn（通行证）",
    webauthn_description: "通过浏览器支持的方法进行验证：生物识别、手机扫描或安全密钥等。",
    webauthn_native_tip: "WebAuthn不支持原生应用。",
    webauthn_domain_tip: "WebAuthn将公钥绑定到特定域。修改服务域将阻止用户通过现有的密码进行身份验证。",
    backup_code: "备份代码",
    backup_code_description: "用户设置任何MFA方法后生成10个一次性备份代码。",
    backup_code_setup_hint: "当用户无法验证上述MFA因素时，请使用备份选项。",
    backup_code_error_hint: "要使用备份代码，您需要至少再添加一种MFA方法以成功验证用户。",
    policy: "策略",
    policy_description: "为登录和注册流程设置MFA策略。",
    two_step_sign_in_policy: "登录时的两步验证策略",
    user_controlled: "用户可以自行启用或禁用MFA",
    user_controlled_tip: "用户可以在首次登录或注册时跳过MFA设置，或在账户设置中启用/禁用MFA。",
    mandatory: "用户始终需要在登录时使用MFA",
    mandatory_tip: "用户必须在首次登录或注册时设置MFA，并在所有未来的登录中使用它。"
};
var $a3d85a7c229bd267$export$2e2bcd8739ae039 = Object.freeze($a3d85a7c229bd267$var$mfa);


const $52766ee2559cc633$var$organization_details = {
    page_title: "机构详情",
    delete_confirmation: "一旦删除，所有成员将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。",
    organization_id: "机构编号",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "机构名称，不需要是唯一的。",
    description_placeholder: "机构的描述。",
    member: "成员",
    member_other: "成员",
    add_members_to_organization: "向机构{{name}}添加成员",
    add_members_to_organization_description: "通过姓名、电子邮件、电话或用户ID搜索合适的用户。搜索结果中不显示现有成员。",
    add_with_organization_role: "以机构角色加入",
    user: "用户",
    authorize_to_roles: "授权{{name}}访问以下角色:",
    edit_organization_roles: "编辑机构角色",
    edit_organization_roles_of_user: "编辑{{name}}的机构角色",
    remove_user_from_organization: "从机构中移除用户",
    remove_user_from_organization_description: "一旦移除，用户将失去他们在这个机构中的成员资格和角色。此操作将无法撤销。",
    search_user_placeholder: "按名称、电子邮件、电话或用户ID搜索",
    at_least_one_user: "至少需要一个用户。"
};
var $52766ee2559cc633$export$2e2bcd8739ae039 = Object.freeze($52766ee2559cc633$var$organization_details);


const $527c03cfd945e21f$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "组织",
    title: "组织",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "组织 ID",
    members: "成员",
    create_organization: "创建组织",
    setup_organization: "设置您的组织",
    organization_list_placeholder_title: "组织",
    organization_list_placeholder_text: "组织通常用于SaaS或类SaaS的多租户应用程序。组织功能使您的B2B客户能更好地管理其合作伙伴和客户，并自定义最终用户访问其应用程序的方式。",
    organization_name_placeholder: "我的组织",
    organization_description_placeholder: "组织的简要描述",
    organization_permission: "组织权限",
    organization_permission_other: "组织权限",
    organization_permission_description: "组织权限是指在组织上下文中访问资源的授权。组织权限应该用有意义的字符串表示，同时也作为名称和唯一标识。",
    organization_permission_delete_confirm: "如果删除此权限，所有包含此权限的组织角色将失去此权限以及授予此权限的用户的访问权限。",
    create_permission_placeholder: "读取预约历史",
    permission: "权限",
    permission_other: "权限",
    organization_role: "组织角色",
    organization_role_other: "组织角色",
    organization_role_description: "组织角色是可以分配给用户的权限组。这些权限必须来自预定义的组织权限。",
    organization_role_delete_confirm: "这样做将从受影响的用户那里删除与此角色相关的权限，并删除组织角色、组织成员和组织权限之间的关系。",
    role: "角色",
    create_role_placeholder: "仅查看权限的用户",
    search_placeholder: "按组织名称或ID搜索",
    search_permission_placeholder: "输入以搜索和选择权限",
    search_role_placeholder: "输入以搜索和选择角色",
    empty_placeholder: "\uD83E\uDD14 你还没有设置任何{{entity}}。",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "从指南开始",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "交互插图以查看所有关系",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "步骤1：定义组织权限",
        step_2: "步骤2：定义组织角色",
        step_3: "步骤3：创建您的第一个组织",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $527c03cfd945e21f$export$2e2bcd8739ae039 = Object.freeze($527c03cfd945e21f$var$organizations);


const $0b59051b21e0cdb9$var$permissions = {
    search_placeholder: "通过 API 或权限名称搜索",
    search_placeholder_without_api: "通过权限名称搜索",
    name_column: "权限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "权限",
    placeholder_description: "权限是指访问资源的授权（我们称其为 API 资源）。"
};
var $0b59051b21e0cdb9$export$2e2bcd8739ae039 = Object.freeze($0b59051b21e0cdb9$var$permissions);


const $25322a17af9b2a07$var$profile = {
    page_title: "账户管理",
    title: "账户管理",
    description: "在这里，你可以修改账户设置和管理个人信息，以确保账户安全。",
    settings: {
        title: "账户设置",
        profile_information: "个人信息",
        avatar: "头像",
        name: "姓名",
        username: "用户名"
    },
    link_account: {
        title: "关联账户",
        email_sign_in: "邮件登录",
        email: "邮件",
        social_sign_in: "社交账号登录",
        link_email: "绑定邮箱",
        link_email_subtitle: "绑定邮箱以便登录或帮助恢复账户。",
        email_required: "邮箱不能为空",
        invalid_email: "无效的邮箱地址",
        identical_email_address: "输入的邮箱地址与当前邮箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密码与安全",
        password: "密码",
        password_setting: "密码设置",
        new_password: "新密码",
        confirm_password: "确认密码",
        enter_password: "输入当前密码",
        enter_password_subtitle: "为确保账户安全，在修改密码前，请先输入当前密码以通过身份验证。",
        set_password: "设置密码",
        verify_via_password: "通过密码验证",
        show_password: "显示密码",
        required: "密码不能为空",
        do_not_match: "密码不匹配，请重新输入。"
    },
    code: {
        enter_verification_code: "输入验证码",
        enter_verification_code_subtitle: "验证码已发送至 <strong>{{target}}</strong>",
        verify_via_code: "通过邮箱验证码验证",
        resend: "重新发送验证码",
        resend_countdown: "在 {{countdown}} 秒后重新发送"
    },
    delete_account: {
        title: "删除账户",
        label: "删除账户",
        description: "删除账户将会删除所有个人信息、用户数据和配置。此操作无法撤销。",
        button: "删除账户",
        dialog_paragraph_1: "很抱歉听到你想要删除你的帐户。删除你的帐户将永久删除所有数据，包括用户信息、日志和设置，此操作无法撤销。因此，请确保在继续之前备份任何重要数据。",
        dialog_paragraph_2: "要继续删除帐户的删除过程，请通过 <a>mail</a> 向我们的支持团队发送主题为“帐户删除请求”的邮件。我们将协助你并确保所有数据都已从我们的系统中正确删除。",
        dialog_paragraph_3: "感谢你选择 Logto Cloud。如果你有任何进一步的问题或疑虑，请随时与我们联系。"
    },
    set: "设置",
    change: "修改",
    link: "关联",
    unlink: "取消关联",
    not_set: "未设置",
    change_avatar: "修改头像",
    change_name: "修改姓名",
    change_username: "修改用户名",
    set_name: "设置姓名",
    email_changed: "已成功绑定邮箱。",
    password_changed: "已重置密码。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}账号绑定成功。",
    unlinked: "{{target}}账号解绑成功。",
    email_exists_reminder: "该邮箱 {{email}} 已被其他账号绑定，请更换邮箱。",
    unlink_confirm_text: "确定解绑",
    unlink_reminder: "解绑后，用户将无法使用该 <span></span> 账号进行登录。确定要解绑吗？"
};
var $25322a17af9b2a07$export$2e2bcd8739ae039 = Object.freeze($25322a17af9b2a07$var$profile);


const $5da998973f632530$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "标识符",
    delete_description: "这样做将从受影响的用户中删除与该角色关联的权限，并删除角色、用户和权限之间的映射关系。",
    role_deleted: "{{name}} 已成功删除。",
    settings_tab: "设置",
    users_tab: "用户",
    m2m_apps_tab: "机器对机器应用",
    permissions_tab: "权限",
    settings: "设置",
    settings_description: "角色是一组权限，可以分配给用户。它们还提供了一种聚合不同 API 定义的权限的方法，使得添加、删除或调整权限比将其单独分配给用户更有效率。",
    field_name: "名称",
    field_description: "描述",
    type_m2m_role_tag: "机器对机器应用角色",
    type_user_role_tag: "用户角色",
    permission: {
        assign_button: "分配权限",
        assign_title: "分配权限",
        assign_subtitle: "将权限分配给此角色。角色将获得添加的权限，具有此角色的用户将继承这些权限。",
        assign_form_field: "分配权限",
        added_text_one: "添加了 {{count, number}} 个权限",
        added_text_other: "添加了 {{count, number}} 个权限",
        api_permission_count_one: "{{count, number}} 个权限",
        api_permission_count_other: "{{count, number}} 个权限",
        confirm_assign: "分配权限",
        permission_assigned: "所选的权限已成功分配给此角色",
        deletion_description: "如果删除此权限，则具有此角色的受影响用户将失去此权限授予的访问权限。",
        permission_deleted: "权限 {{name}} 已成功从此角色中删除",
        empty: "无可用权限"
    },
    users: {
        assign_button: "分配用户",
        name_column: "用户",
        app_column: "应用",
        latest_sign_in_column: "最近登录",
        delete_description: "它将保留在你的用户池中，但失去此角色的授权。",
        deleted: "{{name}} 已成功从此角色中删除",
        assign_title: "分配用户",
        assign_subtitle: "将用户分配给此角色。通过搜索名称、电子邮件、电话或用户 ID 查找适当的用户。",
        assign_field: "分配用户",
        confirm_assign: "分配用户",
        assigned_toast_text: "所选的用户已成功分配给此角色",
        empty: "无可用用户"
    },
    applications: {
        assign_button: "分配应用",
        name_column: "应用",
        app_column: "应用",
        description_column: "描述",
        delete_description: "应用将保留在你的应用池中，但将失去此角色的授权。",
        deleted: "{{name}} 已成功从此角色中删除",
        assign_title: "分配应用",
        assign_subtitle: "将应用分配给此角色。通过搜索名称、描述或应用 ID 查找适当的应用。",
        assign_field: "分配应用",
        confirm_assign: "分配应用",
        assigned_toast_text: "所选的应用已成功分配给此角色",
        empty: "无可用应用"
    }
};
var $5da998973f632530$export$2e2bcd8739ae039 = Object.freeze($5da998973f632530$var$role_details);


const $d11e130538cd77c3$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一种访问控制方法，它使用角色来决定用户可以做什么事情，包括授予用户访问特定资源的权限。",
    create: "创建角色",
    role_name: "角色名称",
    role_type: "角色类型",
    show_role_type_button_text: "展示更多选项",
    hide_role_type_button_text: "隐藏更多选项",
    type_user: "用户角色",
    type_machine_to_machine: "机器对机器应用程序角色",
    role_description: "描述",
    role_name_placeholder: "输入你的角色名称",
    role_description_placeholder: "输入你的角色描述",
    col_roles: "角色",
    col_type: "类型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 用户",
    application_counts: "{{count}} 应用",
    user_count: "{{count}} 用户",
    application_count: "{{count}} 应用",
    assign_permissions: "分配权限",
    create_role_title: "创建角色",
    create_role_description: "为你的应用程序创建和管理角色。角色包含权限集合，并可以分配给用户。",
    create_role_button: "创建角色",
    role_created: "角色 {{name}} 已成功创建。",
    search: "按角色名称、描述或 ID 搜索",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配给用户的权限分组。在创建角色之前，请确保先添加权限。"
};
var $d11e130538cd77c3$export$2e2bcd8739ae039 = Object.freeze($d11e130538cd77c3$var$roles);


const $147f800a1a71832a$var$session_expired = {
    title: "会话已过期",
    subtitle: "会话可能已过期，你已被退出登录。请点击下方按钮重新登录到管理控制台。",
    button: "重新登录"
};
var $147f800a1a71832a$export$2e2bcd8739ae039 = Object.freeze($147f800a1a71832a$var$session_expired);


const $5abea3682a8c4b44$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $5abea3682a8c4b44$export$2e2bcd8739ae039 = Object.freeze($5abea3682a8c4b44$var$content);


const $9a401a73833d8a53$var$password_policy = {
    password_requirements: "密码要求",
    minimum_length: "最小长度",
    minimum_length_description: "NIST 建议在 Web 产品中使用至少 8 个字符。",
    minimum_length_error: "最小长度必须在 {{min}} 和 {{max}} 之间（包括 {{min}} 和 {{max}}）。",
    minimum_required_char_types: "最小要求字符类型",
    minimum_required_char_types_description: "字符类型：大写字母（A-Z），小写字母（a-z），数字（0-9）以及特殊字符（{{symbols}}）。",
    password_rejection: "密码拒绝",
    compromised_passwords: "拒绝已泄露的密码",
    breached_passwords: "泄露的密码",
    breached_passwords_description: "拒绝之前在泄露数据库中发现的密码。",
    restricted_phrases: "限制低安全性短语",
    restricted_phrases_tooltip: "密码应避免使用这些短语，除非结合 3 个或更多额外字符。",
    repetitive_or_sequential_characters: "重复或连续字符",
    repetitive_or_sequential_characters_description: "例如，“AAAA”、“1234”和“abcd”。",
    user_information: "用户信息",
    user_information_description: "例如，电子邮件地址，电话号码，用户名等。",
    custom_words: "自定义词汇",
    custom_words_description: "个性化上下文相关的词汇，不区分大小写，每行一个。",
    custom_words_placeholder: "您的服务名称，公司名称等。"
};
var $9a401a73833d8a53$export$2e2bcd8739ae039 = Object.freeze($9a401a73833d8a53$var$password_policy);


const $cc4f898ea436dcff$var$sign_up_and_sign_in = {
    identifiers_email: "邮件地址",
    identifiers_phone: "手机号码",
    identifiers_username: "用户名",
    identifiers_email_or_sms: "邮件地址或手机号码",
    identifiers_none: "无",
    and: "与",
    or: "或",
    sign_up: {
        title: "注册",
        sign_up_identifier: "注册标识",
        identifier_description: "创建账户时你需要设定注册标识。这些信息在用户登录时，属于必选项。",
        sign_up_authentication: "注册身份认证设置",
        authentication_description: "注册时，你的用户将要完成以下所有勾选的任务。",
        set_a_password_option: "创建密码",
        verify_at_sign_up_option: "注册时验证身份",
        social_only_creation_description: "（仅对社交注册用户适用）"
    },
    sign_in: {
        title: "登录",
        sign_in_identifier_and_auth: "登录标识和身份认证设置",
        description: "用户可以使用任何可用的选项进行登录。拖拽选项即可调整页面布局。",
        add_sign_in_method: "添加登录方式",
        password_auth: "密码",
        verification_code_auth: "验证码",
        auth_swap_tip: "交换以下选项的位置即可设定它们在用户登录流程中出现的先后。",
        require_auth_factor: "请至少选择一种认证方式。"
    },
    social_sign_in: {
        title: "社交登录",
        social_sign_in: "社交登录",
        description: "你已设定特定的标识。用户在通过社交连接器注册时可能会被要求提供一个对应的标识。",
        add_social_connector: "添加社交连接器",
        set_up_hint: {
            not_in_list: "没有你想要的连接器？",
            set_up_more: "立即设置",
            go_to: "其他社交连接器。"
        }
    },
    tip: {
        set_a_password: "启用户名注册，必须设置密码。",
        verify_at_sign_up: "我们目前仅支持经过验证的邮件地址登录。如果没有验证，你的用户信息中可能出现大量无效电子邮件地址。",
        password_auth: "因注册设置里你启用了用户名密码标识。这个信息在用户登录时，属于必选项。",
        verification_code_auth: "因注册设置里你启用了验证码标识，验证码属于用户必选项。开启密码注册后，你可以选择关闭验证码登录。",
        delete_sign_in_method: "因注册设置里你启用了{{identifier}}标识。这些信息在用户登录时，属于必选项。"
    },
    advanced_options: {
        title: "高级选项",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "启用用户注册",
        enable_user_registration_description: "启用或禁用用户注册。禁用后，管理员仍然可以添加用户，但用户无法通过登录界面建立账户。"
    }
};
var $cc4f898ea436dcff$export$2e2bcd8739ae039 = Object.freeze($cc4f898ea436dcff$var$sign_up_and_sign_in);


const $20187ab41d25c4de$var$sign_in_exp = {
    page_title: "登录体验",
    title: "登录体验",
    description: "自定义登录界面，并实时预览真实效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "注册与登录",
        content: "内容",
        password_policy: "密码策略"
    },
    welcome: {
        title: "自定义登录体验",
        description: "通过首次登录设置快速入门。本指南将带领你完成所有必要的设置。",
        get_started: "开始",
        apply_remind: "请注意，登录体验将会应用到当前帐户下的所有应用。"
    },
    color: {
        title: "颜色",
        primary_color: "品牌颜色",
        dark_primary_color: "品牌颜色 (深色)",
        dark_mode: "开启深色模式",
        dark_mode_description: "基于品牌颜色和 Logto 的算法，应用将会有一个自动生成的深色模式。当然，你可以自定义和修改。",
        dark_mode_reset_tip: "基于品牌颜色，重新生成深色模式颜色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制区",
        ui_style: "样式",
        favicon: "浏览器地址栏图标",
        logo_image_url: "Logo 图片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 图片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 图片",
        dark_logo_image: "Logo 图片(深色)",
        logo_image_error: "应用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定义 CSS",
        css_code_editor_title: "自定义 CSS 个性化你的用户界面",
        css_code_editor_description1: "查看自定义 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "输入 CSS 代码，修改颜色、字体、组件样式、布局，定制你的登录、注册、忘记密码等页面。充分发挥创造力，让你的用户界面脱颖而出。"
    },
    sign_up_and_sign_in: $cc4f898ea436dcff$export$2e2bcd8739ae039,
    content: $5abea3682a8c4b44$export$2e2bcd8739ae039,
    password_policy: $9a401a73833d8a53$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未设置 SMS 短信连接器。在完成该配置前，用户将无法通过此登录方式登录。<a>{{link}}</a>连接器。",
        no_connector_email: "尚未设置电子邮件连接器。在完成该配置前，用户将无法通过此登录方式登录。<a>{{link}}</a>连接器。",
        no_connector_social: "您还没有设置任何社交连接器。首先添加连接器以应用社交登录方法。<a>{{link}}</a>连接器。",
        setup_link: "立即设置"
    },
    save_alert: {
        description: "你正在进行登录注册设置的变更。当前你的所有用户会受到新设置的影响。确认保存该设置吗？",
        before: "设置前",
        after: "设置后",
        sign_up: "注册",
        sign_in: "登录",
        social: "社交"
    },
    preview: {
        title: "登录预览",
        live_preview: "实时预览",
        live_preview_tip: "保存以预览更改",
        native: "移动原生",
        desktop_web: "桌面网页",
        mobile_web: "移动网页",
        desktop: "桌面网页",
        mobile: "移动设备"
    }
};
var $20187ab41d25c4de$export$2e2bcd8739ae039 = Object.freeze($20187ab41d25c4de$var$sign_in_exp);


const $a1b83cc878e74484$var$quota_item = {
    tenant_limit: {
        name: "租户",
        limited: "{{count, number}} 个租户",
        limited_other: "{{count, number}} 个租户",
        unlimited: "无限制租户",
        not_eligible: "移除你的租户"
    },
    mau_limit: {
        name: "月活跃用户",
        limited: "{{count, number}} MAU",
        unlimited: "无限制 MAU",
        not_eligible: "移除你的所有用户"
    },
    applications_limit: {
        name: "应用",
        limited: "{{count, number}} 个应用",
        limited_other: "{{count, number}} 个应用",
        unlimited: "无限制应用",
        not_eligible: "移除你的应用"
    },
    machine_to_machine_limit: {
        name: "机器到机器",
        limited: "{{count, number}} 个机器到机器应用",
        limited_other: "{{count, number}} 个机器到机器应用",
        unlimited: "无限制机器到机器应用",
        not_eligible: "移除你的机器到机器应用"
    },
    resources_limit: {
        name: "API 资源",
        limited: "{{count, number}} 个 API 资源",
        limited_other: "{{count, number}} 个 API 资源",
        unlimited: "无限制 API 资源",
        not_eligible: "移除你的 API 资源"
    },
    scopes_per_resource_limit: {
        name: "资源权限",
        limited: "{{count, number}} 个权限每个资源",
        limited_other: "{{count, number}} 个权限每个资源",
        unlimited: "无限制权限每个资源",
        not_eligible: "移除你的资源权限"
    },
    custom_domain_enabled: {
        name: "自定义域名",
        limited: "自定义域名",
        unlimited: "自定义域名",
        not_eligible: "移除你的自定义域名"
    },
    omni_sign_in_enabled: {
        name: "全渠道登录",
        limited: "全渠道登录",
        unlimited: "全渠道登录",
        not_eligible: "禁用全渠道登录"
    },
    built_in_email_connector_enabled: {
        name: "内置电子邮件连接器",
        limited: "内置电子邮件连接器",
        unlimited: "内置电子邮件连接器",
        not_eligible: "移除你的内置电子邮件连接器"
    },
    social_connectors_limit: {
        name: "社交连接器",
        limited: "{{count, number}} 个社交连接器",
        limited_other: "{{count, number}} 个社交连接器",
        unlimited: "无限制社交连接器",
        not_eligible: "移除你的社交连接器"
    },
    standard_connectors_limit: {
        name: "免费标准连接器",
        limited: "{{count, number}} 个免费标准连接器",
        limited_other: "{{count, number}} 个免费标准连接器",
        unlimited: "无限制标准连接器",
        not_eligible: "移除你的标准连接器"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 个角色",
        limited_other: "{{count, number}} 个角色",
        unlimited: "无限制角色",
        not_eligible: "移除你的角色"
    },
    scopes_per_role_limit: {
        name: "角色权限",
        limited: "{{count, number}} 个权限每个角色",
        limited_other: "{{count, number}} 个权限每个角色",
        unlimited: "无限制权限每个角色",
        not_eligible: "移除你的角色权限"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} 个 Webhook",
        limited_other: "{{count, number}} 个 Webhooks",
        unlimited: "无限制的 Webhooks",
        not_eligible: "移除你的 Webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "审计日志保留",
        limited: "审计日志保留：{{count, number}} 天",
        limited_other: "审计日志保留：{{count, number}} 天",
        unlimited: "无限制天数",
        not_eligible: "无审计日志"
    },
    community_support_enabled: {
        name: "社区支持",
        limited: "社区支持",
        unlimited: "社区支持",
        not_eligible: "无社区支持"
    },
    customer_ticket_support: {
        name: "客户支持票",
        limited: "{{count, number}} 小时客户支持票",
        limited_other: "{{count, number}} 小时客户支持票",
        unlimited: "客户支持票",
        not_eligible: "无客户支持票"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "禁用你的 MFA"
    },
    sso_enabled: {
        name: "企业SSO",
        limited: "企业SSO",
        unlimited: "企业SSO",
        not_eligible: "禁用你的企业SSO"
    }
};
var $a1b83cc878e74484$export$2e2bcd8739ae039 = Object.freeze($a1b83cc878e74484$var$quota_item);


const $bfb0ab3a63d86612$var$quota_table = {
    quota: {
        title: "配额",
        tenant_limit: "租户限制",
        base_price: "基本价格",
        mau_unit_price: "* 每活跃用户（MAU）单价",
        mau_limit: "MAU 限制"
    },
    application: {
        title: "应用",
        total: "总应用数",
        m2m: "机器对机器"
    },
    resource: {
        title: "API 资源",
        resource_count: "资源数量",
        scopes_per_resource: "每资源权限"
    },
    branding: {
        title: "界面与品牌",
        custom_domain: "自定义域名",
        custom_css: "自定义 CSS",
        app_logo_and_favicon: "应用图标与网站图标",
        dark_mode: "深色模式",
        i18n: "国际化"
    },
    user_authn: {
        title: "用户认证",
        omni_sign_in: "全渠道登录",
        password: "密码",
        passwordless: "免密码登录 - 电子邮件和短信",
        email_connector: "电子邮件连接器",
        sms_connector: "短信连接器",
        social_connectors: "社交连接器",
        standard_connectors: "标准连接器",
        built_in_email_connector: "内置电子邮件连接器",
        mfa: "MFA",
        sso: "企业 SSO"
    },
    user_management: {
        title: "用户管理",
        user_management: "用户管理",
        roles: "角色",
        scopes_per_role: "每角色权限"
    },
    audit_logs: {
        title: "审计日志",
        retention: "保留期限"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "组织",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "支持",
        community: "社区",
        customer_ticket: "客户支持票据",
        premium: "高级版"
    },
    mau_unit_price_footnote: "* 您的每月活跃用户（MAU）根据在结算周期内登录的频率分为3个层级。每个层级的MAU单价不同。",
    unlimited: "无限制",
    contact: "联系",
    monthly_price: "${{value, number}}/月",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}}天",
    days_other: "{{count, number}}天",
    add_on: "附加功能",
    tier: "层级{{value, number}}："
};
var $bfb0ab3a63d86612$export$2e2bcd8739ae039 = Object.freeze($bfb0ab3a63d86612$var$quota_table);


const $9354a627daf8edb5$var$subscription = {
    free_plan: "免费计划",
    free_plan_description: "适用于边项目和初始 Logto 试用，无需信用卡。",
    hobby_plan: "爱好计划",
    hobby_plan_description: "适用于个人开发者或小型工程团队。",
    pro_plan: "专业计划",
    pro_plan_description: "适用于企业付费无忧。",
    enterprise: "企业",
    current_plan: "当前计划",
    current_plan_description: "以下是您当前的计划。您可以轻松查看计划使用情况，检查即将到来的账单，并根据需要对计划进行更改。",
    plan_usage: "计划使用情况",
    plan_cycle: "计划周期：{{period}}，使用情况将于{{renewDate}}续订。",
    next_bill: "您的下一个账单",
    next_bill_hint: "要了解有关计算的更多信息，请参阅此<a>文章</a>。",
    next_bill_tip: "您的即将到期的账单包括下个月的计划基础价格，以及各个层级的 MAU 单价乘以使用量的费用。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已达到配额限制。为防止任何问题，请升级计划。",
    upgrade_pro: "升级专业计划",
    update_payment: "更新付款信息",
    payment_error: "检测到付款问题。无法处理前一周期的{{price, number}}美元。更新付款以避免 Logto 服务中断。",
    downgrade: "降级",
    current: "当前",
    upgrade: "升级",
    quota_table: $bfb0ab3a63d86612$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "发票",
        status_column: "状态",
        amount_column: "金额",
        invoice_created_date_column: "发票创建日期",
        invoice_status: {
            void: "已取消",
            paid: "已支付",
            open: "未完成",
            uncollectible: "逾期未付"
        }
    },
    quota_item: $a1b83cc878e74484$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "确认要降级吗？",
        description: "如果您选择切换到 <targetName/>，请注意您将不再可以使用以前在 <currentName/> 中的配额和功能。",
        before: "之前：<name/>",
        after: "之后：<name />",
        downgrade: "降级"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降级条件",
        downgrade_description: "降级到<name/>前，请确保满足以下条件。",
        downgrade_help_tip: "需要降级帮助？<a>联系我们</a>。",
        upgrade_title: "致尊敬的早期采用者的友善提醒",
        upgrade_description: "您当前的使用量超过了 <name /> 允许的范围。Logto 现已正式发布，包括针对每个计划量身定制的功能。在考虑升级到 <name /> 之前，请确保您满足以下升级条件。",
        upgrade_pro_tip: " 或者考虑升级到专业版计划。",
        upgrade_help_tip: "需要升级帮助？<a>联系我们</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "成功升级到 <name/>",
    downgrade_success: "成功降级到 <name/>",
    subscription_check_timeout: "订阅检查超时，请稍后刷新。",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $9354a627daf8edb5$export$2e2bcd8739ae039 = Object.freeze($9354a627daf8edb5$var$subscription);


const $3dc59b71fb01cf4b$var$tab_sections = {
    overview: "概览",
    resources: "资源",
    users: "用户",
    access_control: "访问控制",
    help_and_support: "帮助与支持",
    tenant: "租户",
    automation: "自动化"
};
var $3dc59b71fb01cf4b$export$2e2bcd8739ae039 = Object.freeze($3dc59b71fb01cf4b$var$tab_sections);


const $98cb6f74e00bd221$var$tabs = {
    get_started: "开始上手",
    dashboard: "仪表盘",
    applications: "全部应用",
    api_resources: "API 资源",
    sign_in_experience: "登录体验",
    connectors: "连接器",
    enterprise_sso: "企业SSO",
    webhooks: "Webhooks",
    organizations: "组织",
    users: "用户管理",
    audit_logs: "审计日志",
    roles: "角色",
    docs: "文档",
    tenant_settings: "租户设置",
    mfa: "多因素认证"
};
var $98cb6f74e00bd221$export$2e2bcd8739ae039 = Object.freeze($98cb6f74e00bd221$var$tabs);


const $be9e3f61c555f199$var$tenants = {
    title: "设置",
    description: "高效管理租户设置并自定义您的域名。",
    tabs: {
        settings: "设置",
        domains: "域名管理",
        subscription: "套餐与计费",
        billing_history: "历史账单"
    },
    settings: {
        title: "设置",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "租户 ID",
        tenant_name: "租户名称",
        tenant_region: "数据托管地区",
        tenant_region_tip: "您的租户资源托管在 {{region}}。 <a>了解更多</a>",
        environment_tag_development: "开发",
        environment_tag_staging: "预发布",
        environment_tag_production: "产品",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "租户信息成功保存。"
    },
    full_env_tag: {
        development: "开发",
        production: "产品"
    },
    deletion_card: {
        title: "删除",
        tenant_deletion: "删除租户",
        tenant_deletion_description: "删除租户将导致永久删除所有相关的用户数据和配置。请谨慎操作。",
        tenant_deletion_button: "删除租户"
    },
    create_modal: {
        title: "创建租户",
        subtitle: "创建一个具有隔离资源和用户的新租户。数据托管的区域和租户类型在创建后无法修改。",
        tenant_usage_purpose: "您想要使用此租户做什么?",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "可用方案：",
        create_button: "创建租户",
        tenant_name_placeholder: "我的租户"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "删除租户",
        description_line1: '您确定要删除 "<span>{{name}}</span>" 的环境标识符为"<span>{{tag}}</span>"的租户吗？ 此操作无法撤消，并将导致永久删除所有数据和帐户信息。',
        description_line2: "在删除帐户之前，也许我们可以帮助您。<span><a>通过电子邮件联系我们</a></span>",
        description_line3: '如果你想继续，请输入租户名 "<span>{{name}}</span>" 确认。',
        delete_button: "永久删除",
        cannot_delete_title: "无法删除此租户",
        cannot_delete_description: "抱歉，您现在无法删除此租户。请确保您处于免费计划并已支付所有未结账单。"
    },
    tenant_landing_page: {
        title: "您还没有创建租户",
        description: "要开始使用Logto配置项目，请创建一个新的租户。如果您需要注销或删除您的帐户，只需单击右上角的头像按钮。",
        create_tenant_button: "创建租户"
    },
    status: {
        mau_exceeded: "超出 MAU 限制",
        suspended: "已暂停",
        overdue: "逾期"
    },
    tenant_suspended_page: {
        title: "租户已暂停，请联系我们以恢复访问。",
        description_1: "我们非常遗憾地通知您，由于不当使用，包括超出MAU限制、逾期付款或其他未经授权的操作，您的租户帐户已被临时停用。",
        description_2: "如果您需要进一步澄清、有任何疑虑或希望恢复全部功能并解锁您的租户，请立即联系我们。"
    },
    signing_keys: {
        title: "签名密钥",
        description: "在您的租户中安全管理签名密钥。",
        type: {
            private_key: "OIDC私钥",
            cookie_key: "OIDC Cookie密钥"
        },
        private_keys_in_use: "正在使用的私钥",
        cookie_keys_in_use: "正在使用的 Cookie 密钥",
        rotate_private_keys: "旋转私钥",
        rotate_cookie_keys: "旋转 Cookie 密钥",
        rotate_private_keys_description: "此操作将创建一个新的私钥，旋转当前密钥，并删除之前的密钥。使用当前密钥签名的JWT令牌将在删除或另一轮旋转之前保持有效。",
        rotate_cookie_keys_description: "此操作将创建一个新的Cookie密钥，旋转当前密钥，并删除之前的密钥。使用当前密钥签名的Cookie将在删除或另一轮旋转之前保持有效。",
        select_private_key_algorithm: "为新的私钥选择签名密钥算法",
        rotate_button: "旋转",
        table_column: {
            id: "ID",
            status: "状态",
            algorithm: "签名密钥算法"
        },
        status: {
            current: "当前",
            previous: "之前"
        },
        reminder: {
            rotate_private_key: "您确定要旋转<strong>OIDC私钥</strong>吗？新发布的JWT令牌将由新密钥签名。使用当前密钥签名的现有JWT令牌将在您再次旋转之前保持有效。",
            rotate_cookie_key: "您确定要旋转<strong>OIDC Cookie密钥</strong>吗？登录会话生成的新Cookie将由新Cookie密钥签名。使用当前密钥签名的现有Cookie将在您再次旋转之前保持有效。",
            delete_private_key: "您确定要删除<strong>OIDC私钥</strong>吗？使用此私有签名密钥签名的现有JWT令牌将不再有效。",
            delete_cookie_key: "您确定要删除<strong>OIDC Cookie密钥</strong>吗？用此Cookie密钥签名的旧登录会话将不再有效。这些用户需要重新验证。"
        },
        messages: {
            rotate_key_success: "签名密钥旋转成功。",
            delete_key_success: "密钥已成功删除。"
        }
    }
};
var $be9e3f61c555f199$export$2e2bcd8739ae039 = Object.freeze($be9e3f61c555f199$var$tenants);


const $1c921a7a28bb7280$var$topbar = {
    docs: "文档",
    help: "帮助"
};
var $1c921a7a28bb7280$export$2e2bcd8739ae039 = Object.freeze($1c921a7a28bb7280$var$topbar);


const $c90b8ff274423a2c$var$paywall = {
    applications: "已达到 <planName/> 的{{count, number}}个应用限制。升级计划以满足团队需求。如需帮助，请随时<a>联系我们</a>。",
    applications_other: "已达到 <planName/> 的{{count, number}}个应用限制。升级计划以满足团队需求。如需帮助，请随时<a>联系我们</a>。",
    machine_to_machine_feature: "升级至<strong>Hobby</strong>套餐，解锁1个机器对机器应用，或选择<strong>Pro</strong>套餐，可享无限使用。需要任何帮助，请随时<a>联系我们</a>。",
    machine_to_machine: "已达到 <planName/> 的{{count, number}}个机器对机器应用限制。升级计划以满足团队需求。如需帮助，请随时<a>联系我们</a>。",
    machine_to_machine_other: "已达到 <planName/> 的{{count, number}}个机器对机器应用限制。升级计划以满足团队需求。如需帮助，请随时<a>联系我们</a>。",
    resources: "已达到<planName/>的{{count, number}}个 API 资源限制。升级计划以满足您团队的需求。<a>联系我们</a>寻求帮助。",
    resources_other: "已达到<planName/>的{{count, number}}个 API 资源限制。升级计划以满足您团队的需求。<a>联系我们</a>寻求帮助。",
    scopes_per_resource: "已达到<planName/>的{{count, number}}个 API 资源每个权限限制。立即升级以扩展。如需任何帮助，请<a>联系我们</a>。",
    scopes_per_resource_other: "已达到<planName/>的{{count, number}}个 API 资源每个权限限制。立即升级以扩展。如需任何帮助，请<a>联系我们</a>。",
    custom_domain: "升级至<strong>Hobby</strong>或<strong>Pro</strong>套餐，解锁自定义域功能。如有任何需要，不要犹豫<a>联系我们</a>。",
    social_connectors: "已达到<planName/>的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    social_connectors_other: "已达到<planName/>的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    standard_connectors_feature: "升级至<strong>Hobby</strong>或<strong>Pro</strong>套餐，创建自己的连接器，可使用OIDC、OAuth 2.0和SAML协议，还可以享受无限社交连接器和所有高级功能。需要任何帮助，请随时<a>联系我们</a>。",
    standard_connectors: "已达到<planName/>的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    standard_connectors_other: "已达到<planName/>的{{count, number}}个社交连接器限制。为满足您团队的需求，请升级计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    standard_connectors_pro: "已达到<planName/>的{{count, number}}个标准连接器限制。为满足您团队的需求，请升级至企业版计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    standard_connectors_pro_other: "已达到<planName/>的{{count, number}}个标准连接器限制。为满足您团队的需求，请升级至企业版计划以获取额外的社交连接器，并可以使用 OIDC、OAuth 2.0 和 SAML 协议创建您自己的连接器。如需任何帮助，请<a>联系我们</a>。",
    roles: "已达到<planName/>的{{count, number}}个角色限制。升级计划以添加额外的角色和权限。如需任何帮助，请<a>联系我们</a>。",
    roles_other: "已达到<planName/>的{{count, number}}个角色限制。升级计划以添加额外的角色和权限。如需任何帮助，请<a>联系我们</a>。",
    scopes_per_role: "已达到<planName/>的{{count, number}}个角色每个权限限制。升级计划以添加额外的角色和权限。如需任何帮助，请<a>联系我们</a>。",
    scopes_per_role_other: "已达到<planName/>的{{count, number}}个角色每个权限限制。升级计划以添加额外的角色和权限。如需任何帮助，请<a>联系我们</a>。",
    hooks: "已达到<planName/>的{{count, number}}个 Webhook 限制。升级计划以创建更多 Webhook。如需任何帮助，请<a>联系我们</a>。",
    hooks_other: "已达到<planName/>的{{count, number}}个 Webhook 限制。升级计划以创建更多 Webhook。如需任何帮助，请<a>联系我们</a>。",
    mfa: "升级到付费计划以解锁MFA进行安全验证。如果需要任何帮助，请随时<a>联系我们</a>。",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $c90b8ff274423a2c$export$2e2bcd8739ae039 = Object.freeze($c90b8ff274423a2c$var$paywall);


const $0f4e45ea0ad0aea1$var$upsell = {
    upgrade_plan: "升级计划",
    compare_plans: "比较计划",
    view_plans: "查看计划",
    create_tenant: {
        title: "选择您的租户计划",
        description: "Logto 提供创新且经济实惠的定价计划，旨在为不断发展的公司提供竞争优势。 <a>了解更多</a>",
        base_price: "基础价格",
        monthly_price: "每月 {{value, number}}",
        mau_unit_price: "MAU 单价",
        view_all_features: "查看所有功能",
        select_plan: "选择<name/>",
        free_tenants_limit: "最多{{count, number}}个免费租户",
        free_tenants_limit_other: "最多{{count, number}}个免费租户",
        most_popular: "最受欢迎",
        upgrade_success: "成功升级至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超过限制，请升级您的计划。",
        notification: "您当前的 MAU 已超过<planName/>的限制。请立即升级到高级计划，以避免 Logto 服务的暂停。",
        update_plan: "更新计划"
    },
    payment_overdue_modal: {
        title: "账单逾期未付",
        notification: "糟糕！租户<span>{{name}}</span>的账单支付失败。请尽快支付账单，以避免Logto服务中止。",
        unpaid_bills: "未付账单",
        update_payment: "更新支付"
    },
    paywall: $c90b8ff274423a2c$export$2e2bcd8739ae039
};
var $0f4e45ea0ad0aea1$export$2e2bcd8739ae039 = Object.freeze($0f4e45ea0ad0aea1$var$upsell);


const $3be24f7e7629a6e9$var$user_details = {
    page_title: "用户详情",
    back_to_users: "返回用户管理",
    created_title: "用户创建成功",
    created_guide: "这是用户登录过程中的信息。",
    created_email: "邮箱地址：",
    created_phone: "手机号码：",
    created_username: "用户名：",
    created_password: "密码：",
    menu_delete: "删除用户",
    delete_description: "本操作将永久删除该用户，且无法撤销。",
    deleted: "用户已成功删除。",
    reset_password: {
        reset_password: "重置密码",
        title: "确定要重置密码？",
        content: "本操作不可撤销，将会重置用户的登录信息。",
        congratulations: "该用户已被重置",
        new_password: "新密码："
    },
    tab_settings: "设置",
    tab_roles: "角色",
    tab_logs: "用户日志",
    tab_organizations: "组织",
    authentication: "认证",
    authentication_description: "每个用户都有一个包含所有用户信息的个人资料。它由基本数据、社交身份和自定义数据组成。",
    user_profile: "用户资料",
    field_email: "邮箱地址",
    field_phone: "手机号码",
    field_username: "用户名",
    field_name: "姓名",
    field_avatar: "头像图片链接",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定义数据",
    field_custom_data_tip: "预定义属性之外的用户信息，例如用户偏好的颜色和语言。",
    field_connectors: "社交帐号",
    field_sso_connectors: "企业连接",
    custom_data_invalid: "自定义数据必须是有效的 JSON 对象",
    connectors: {
        connectors: "连接器",
        user_id: "用户ID",
        remove: "删除",
        connected: "该用户已连接多个社交连接。",
        not_connected: "该用户还没有绑定社交帐号",
        deletion_confirmation: "您正在删除现有的<name/>身份。你确定要继续吗？"
    },
    sso_connectors: {
        connectors: "连接器",
        enterprise_id: "企业ID",
        connected: "该用户已连接多个企业身份提供者进行单点登录。",
        not_connected: "该用户尚未与任何企业身份提供者连接进行单点登录。"
    },
    mfa: {
        field_name: "多因素认证",
        field_description: "该用户已启用2步认证因素。",
        name_column: "多因素认证",
        field_description_empty: "此用户尚未启用两步身份验证因素。",
        deletion_confirmation: "您正在删除现有的两步验证中的 <name/>。你确定要继续吗？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用户",
    suspend_user_reminder: "确定要禁用该用户吗？该用户将无法登录到你的应用程序，并且在当前访问令牌过期后，将无法获取新的访问令牌。此外，此用户发出的任何 API 请求都将失败。",
    suspend_action: "禁用",
    user_suspended: "用户已被停用。",
    reactivate_user: "重新启用用户",
    reactivate_user_reminder: "确定要重新启用该用户吗？这样做将允许该用户的任何登录尝试。",
    reactivate_action: "重新启用",
    user_reactivated: "用户已重新启用。",
    roles: {
        name_column: "角色名称",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作将从此用户中删除此角色。角色本身仍将存在，但不再与此用户相关联。",
        deleted: "已成功将 {{name}} 从此用户中删除。",
        assign_title: "将角色分配给 {{name}}",
        assign_subtitle: "为 {{name}} 授权一个或多个角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名称搜索",
        added_text: "添加了 {{value, number}} 个",
        assigned_user_count: "{{value, number}} 个用户",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名称、描述或 ID 搜索",
        empty: "无可用角色"
    },
    warning_no_sign_in_identifier: "用户需要至少拥有一个登录标识（用户名、邮箱、手机号或社交账户）才能登录。确定要继续吗？",
    organization_roles_tooltip: "用户在该组织内分配的角色。"
};
var $3be24f7e7629a6e9$export$2e2bcd8739ae039 = Object.freeze($3be24f7e7629a6e9$var$user_details);


const $1fba9e7e0d4d8cb0$var$users = {
    page_title: "用户管理",
    title: "用户管理",
    subtitle: "管理你的用户，包括创建新用户，编辑用户资料，查看用户日志，以及重新设置密码和删除用户",
    create: "添加用户",
    create_subtitle: "提供以下至少一项字段才能继续。",
    error_missing_identifier: "你必须提供至少一个注册标识来创建用户。",
    user_name: "用户",
    application_name: "注册应用",
    latest_sign_in: "最后登录",
    create_form_username: "用户名",
    create_form_password: "密码",
    create_form_name: "姓名",
    placeholder_name: "李雷",
    placeholder_email: "lilei@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+86 123 4567 8901",
    unnamed: "未命名",
    search: "按姓名、电子邮件、电话或用户名搜索",
    check_user_detail: "查看用户详情",
    placeholder_title: "用户管理",
    placeholder_description: "每个用户都有一个包含所有用户信息的个人资料。它由基本数据、社交身份和自定义数据组成。"
};
var $1fba9e7e0d4d8cb0$export$2e2bcd8739ae039 = Object.freeze($1fba9e7e0d4d8cb0$var$users);


const $4ed64217f0f3a101$var$webhook_details = {
    page_title: "Webhook 详情",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未使用",
    success_rate: "成功率",
    requests: "24 小时内请求次数：{{value, number}}",
    disable_webhook: "禁用 Webhook",
    disable_reminder: "是否确定重新激活此 Webhook？重新激活后将不会向端点 URL 发送 HTTP 请求。",
    webhook_disabled: "Webhook 已被禁用。",
    webhook_reactivated: "Webhook 已经重新激活。",
    reactivate_webhook: "重新激活 Webhook",
    delete_webhook: "删除 Webhook",
    deletion_reminder: "您正在删除此 Webhook。删除后，将不会向端点 URL 发送 HTTP 请求。",
    deleted: "Webhook 已成功删除。",
    settings_tab: "设置",
    recent_requests_tab: "最近请求（24小时）",
    settings: {
        settings: "设置",
        settings_description: "Webhook 允许您通过向端点 URL 发送 POST 请求，实时接收特定事件的更新。这使您可以根据接收到的新信息立即采取行动。",
        events: "事件",
        events_description: "选择 Logto 将发送 POST 请求的触发事件。",
        name: "名称",
        endpoint_url: "端点 URL",
        signing_key: "签名密钥",
        signing_key_tip: "将由 Logto 提供的密钥作为请求标头添加到您的端点中，以确保 Webhook 负载的真实性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成签名密钥",
        regenerate_key_reminder: "是否确定要修改签名密钥？重新生成后将立即生效。请在您的端点中同步修改签名密钥。",
        regenerated: "签名密钥已重新生成。",
        custom_headers: "自定义标头",
        custom_headers_tip: "选择性地，您可以向 Webhook 负载添加自定义标头，以提供事件的其他上下文或元数据。",
        key_duplicated_error: "Key 不能重复。",
        key_missing_error: "必须填写 Key。",
        value_missing_error: "必须填写值。",
        invalid_key_error: " Key 无效",
        invalid_value_error: "值无效",
        test: "测试",
        test_webhook: "测试您的 Webhook",
        test_webhook_description: "配置 Webhook，并使用每个选定事件的负载示例进行测试，以验证正确的接收和处理。",
        send_test_payload: "发送测试负载",
        test_result: {
            endpoint_url: "端点 URL：{{url}}",
            message: "消息：{{message}}",
            response_status: "响应状态：{{status, number}}",
            response_body: "响应主体：{{body}}",
            request_time: "请求时间：{{time}}",
            test_success: "向端点发起的 webhook 测试成功。"
        }
    }
};
var $4ed64217f0f3a101$export$2e2bcd8739ae039 = Object.freeze($4ed64217f0f3a101$var$webhook_details);


const $5b5b87bd23126ad1$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "创建 Webhooks 以轻松接收有关特定事件的实时更新。",
    create: "创建 Webhook",
    events: {
        post_register: "创建新账户",
        post_sign_in: "登录",
        post_reset_password: "重置密码"
    },
    table: {
        name: "名称",
        events: "事件",
        success_rate: "成功率（24小时）",
        requests: "请求数（24小时）"
    },
    placeholder: {
        title: "Webhook",
        description: "创建一个Webhook以通过POST请求将实时更新发送到您的端点URL。了解并立即采取有关“创建账户”、“登录”和“重置密码”等事件的操作。",
        create_webhook: "创建 Webhook"
    },
    create_form: {
        title: "创建 Webhook",
        subtitle: "添加 Webhook 以将 POST 请求发送到端点 URL，并附带任何用户事件的详细信息。",
        events: "事件",
        events_description: "选择触发事件，Logto 将发送 POST 请求。",
        name: "名称",
        name_placeholder: "输入 Webhook 名称",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "输入您的端点 URL，在事件发生时 Webhook 的数据将被发送到该 URL。",
        create_webhook: "创建 Webhook",
        missing_event_error: "您必须至少选择一个事件。"
    },
    webhook_created: "Webhook {{name}} 已成功创建。"
};
var $5b5b87bd23126ad1$export$2e2bcd8739ae039 = Object.freeze($5b5b87bd23126ad1$var$webhooks);


const $d6f9426343c09762$var$welcome = {
    title: "欢迎来到管理控制台",
    description: "管理控制台是一个无需代码操作的应用。你可以用它来管理登录体验。让我们首先创建一个帐号。你可以用它以个人或公司的身份管理 Logto。",
    create_account: "创建帐号"
};
var $d6f9426343c09762$export$2e2bcd8739ae039 = Object.freeze($d6f9426343c09762$var$welcome);


const $3c73138047196213$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理员",
    system_app: "系统应用",
    menu: $4a7907215bc1ca72$export$2e2bcd8739ae039,
    general: $f462b7b2890ab6a2$export$2e2bcd8739ae039,
    errors: $0dcd066df2d60937$export$2e2bcd8739ae039,
    tab_sections: $3dc59b71fb01cf4b$export$2e2bcd8739ae039,
    tabs: $98cb6f74e00bd221$export$2e2bcd8739ae039,
    applications: $99adaba39edb5636$export$2e2bcd8739ae039,
    application_details: $5bcca92f6c70eb95$export$2e2bcd8739ae039,
    api_resources: $4a1344931c3a68bb$export$2e2bcd8739ae039,
    api_resource_details: $680ad7ed0f1b5dc9$export$2e2bcd8739ae039,
    connectors: $c4a6d11ed8ec9bb8$export$2e2bcd8739ae039,
    connector_details: $6371d6cddddc4d9d$export$2e2bcd8739ae039,
    enterprise_sso: $584dd66dd0b52e3c$export$2e2bcd8739ae039,
    enterprise_sso_details: $566b35a9e48b2c70$export$2e2bcd8739ae039,
    get_started: $d7e21995357fdd91$export$2e2bcd8739ae039,
    users: $1fba9e7e0d4d8cb0$export$2e2bcd8739ae039,
    user_details: $3be24f7e7629a6e9$export$2e2bcd8739ae039,
    contact: $f3e3feb1b13b0796$export$2e2bcd8739ae039,
    sign_in_exp: $20187ab41d25c4de$export$2e2bcd8739ae039,
    dashboard: $397069b2bc591a58$export$2e2bcd8739ae039,
    logs: $079b21543a745f77$export$2e2bcd8739ae039,
    log_details: $f610c363f89b6116$export$2e2bcd8739ae039,
    session_expired: $147f800a1a71832a$export$2e2bcd8739ae039,
    welcome: $d6f9426343c09762$export$2e2bcd8739ae039,
    roles: $d11e130538cd77c3$export$2e2bcd8739ae039,
    role_details: $5da998973f632530$export$2e2bcd8739ae039,
    permissions: $0b59051b21e0cdb9$export$2e2bcd8739ae039,
    cloud: $ea91e5afd39c9788$export$2e2bcd8739ae039,
    profile: $25322a17af9b2a07$export$2e2bcd8739ae039,
    components: $ad0fb795e2445ef6$export$2e2bcd8739ae039,
    webhooks: $5b5b87bd23126ad1$export$2e2bcd8739ae039,
    webhook_details: $4ed64217f0f3a101$export$2e2bcd8739ae039,
    domain: $ef94479a0c2558e7$export$2e2bcd8739ae039,
    tenants: $be9e3f61c555f199$export$2e2bcd8739ae039,
    topbar: $1c921a7a28bb7280$export$2e2bcd8739ae039,
    subscription: $9354a627daf8edb5$export$2e2bcd8739ae039,
    upsell: $0f4e45ea0ad0aea1$export$2e2bcd8739ae039,
    guide: $49a18f2bff20dc4f$export$2e2bcd8739ae039,
    mfa: $a3d85a7c229bd267$export$2e2bcd8739ae039,
    organizations: $527c03cfd945e21f$export$2e2bcd8739ae039,
    organization_details: $52766ee2559cc633$export$2e2bcd8739ae039
};
var $3c73138047196213$export$2e2bcd8739ae039 = Object.freeze($3c73138047196213$var$admin_console);


const $935c780837519d82$var$demo_app = {
    title: "你已成功登录实时预览！",
    subtitle: "以下是本次登录的用户信息：",
    username: "用户名：",
    user_id: "用户 ID：",
    sign_out: "退出实时预览",
    continue_explore: "或继续探索",
    customize_sign_in_experience: "自定义登录体验",
    enable_passwordless: "启用无密码登录",
    add_social_connector: "添加社交连接器"
};
var $935c780837519d82$export$2e2bcd8739ae039 = Object.freeze($935c780837519d82$var$demo_app);


const $254121ef1e5559ac$var$oidc = {
    logout_success: "你已经成功登出。"
};
var $254121ef1e5559ac$export$2e2bcd8739ae039 = Object.freeze($254121ef1e5559ac$var$oidc);


const $6593ef7a4b1b2c39$var$translation = {
    admin_console: $3c73138047196213$export$2e2bcd8739ae039,
    demo_app: $935c780837519d82$export$2e2bcd8739ae039,
    oidc: $254121ef1e5559ac$export$2e2bcd8739ae039
};
var $6593ef7a4b1b2c39$export$2e2bcd8739ae039 = Object.freeze($6593ef7a4b1b2c39$var$translation);


const $b299cd4ef47bec27$var$zh_cn = {
    translation: $6593ef7a4b1b2c39$export$2e2bcd8739ae039,
    errors: $c296b3eaa0477fd1$export$2e2bcd8739ae039
};
var $b299cd4ef47bec27$export$2e2bcd8739ae039 = Object.freeze($b299cd4ef47bec27$var$zh_cn);


const $ba3b8698664c2b94$var$application = {
    invalid_type: "只有機器對機器應用程式才能有相關職能。",
    role_exists: "角色 ID {{roleId}} 已經被添加到此應用程式中。",
    invalid_role_type: "無法將使用者類型的角色分配給機器對機器應用程式。"
};
var $ba3b8698664c2b94$export$2e2bcd8739ae039 = Object.freeze($ba3b8698664c2b94$var$application);


const $059104fe06b11611$var$auth = {
    authorization_header_missing: "Authorization 請求頭缺失。",
    authorization_token_type_not_supported: "Authorization token 類型不支援",
    unauthorized: "未經授權。請檢查憑證及其範圍。",
    forbidden: "禁止訪問。請檢查用戶 role 與權限。",
    expected_role_not_found: "未找到期望的 role。請檢查用戶 role 與權限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新認證以進行受保護操作。"
};
var $059104fe06b11611$export$2e2bcd8739ae039 = Object.freeze($059104fe06b11611$var$auth);


const $150add9f2ba18ba1$var$connector = {
    general: "連接器發生錯誤：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 型別的連接器",
    not_enabled: "連接器尚未啟用",
    invalid_metadata: "連接器 metadata 參數錯誤",
    invalid_config_guard: "連接器配置 guard 錯誤",
    unexpected_type: "連接器型別錯誤",
    invalid_request_parameters: "請求參數錯誤",
    insufficient_request_parameters: "請求參數缺失",
    invalid_config: "連接器配置錯誤",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "連接器錯誤響應",
    template_not_found: "無法從連接器配置中找到對應的模板",
    template_not_supported: "連接器不支援此模板類型。",
    rate_limit_exceeded: "觸發速率限制。請稍後再試。",
    not_implemented: "方法 {{method}} 尚未實現",
    social_invalid_access_token: "當前連接器的 access_token 無效",
    invalid_auth_code: "當前連接器的授權碼無效",
    social_invalid_id_token: "當前連接器的 id_token 無效",
    authorization_failed: "用戶授權流程失敗",
    social_auth_code_invalid: "無法獲取 access_token，請檢查授權 code 是否有效",
    more_than_one_sms: "同時存在超過 1 個短信連接器",
    more_than_one_email: "同時存在超過 1 個郵件連接器",
    more_than_one_connector_factory: "找到多個連接器工廠（id 為 {{connectorIds}}），請刪除多餘項目。",
    db_connector_type_mismatch: "資料庫中存在一個型別不匹配的連接。",
    not_found_with_connector_id: "找不到所給 connector id 對應的連接器",
    multiple_instances_not_supported: "你選擇的連接器不支援創建多實例。",
    invalid_type_for_syncing_profile: "只有社交連接器可以開啟用戶檔案同步。",
    can_not_modify_target: "不可修改連接器 target。",
    should_specify_target: "你需要聲明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多個社交連接器不能重複使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆蓋該連接器的 metadata 參數。"
};
var $150add9f2ba18ba1$export$2e2bcd8739ae039 = Object.freeze($150add9f2ba18ba1$var$connector);


const $ca27e4cd18f8a3ab$var$domain = {
    not_configured: "域名主機供應商未設定。",
    cloudflare_data_missing: "cloudflare_data 缺失，請檢查。",
    cloudflare_unknown_error: "獲取 Cloudflare API 時發生未知錯誤",
    cloudflare_response_error: "從 Cloudflare 獲取到意外的響應",
    limit_to_one_domain: "您只能擁有一個自定義域名。",
    hostname_already_exists: "此域名已存在於我們的伺服器中。",
    cloudflare_not_found: "無法在 Cloudflare 中找到主機名"
};
var $ca27e4cd18f8a3ab$export$2e2bcd8739ae039 = Object.freeze($ca27e4cd18f8a3ab$var$domain);


const $8c47cb899f906fdb$var$entity = {
    invalid_input: "無效輸入。值列表不能為空。",
    create_failed: "創建 {{name}} 失敗。",
    db_constraint_violated: "數據庫約束違反。",
    not_exists: "該 {{name}} 不存在。",
    not_exists_with_id: "ID 為 `{{id}}` 的 {{name}} 不存在。",
    not_found: "該資源不存在。",
    relation_foreign_key_not_found: "找不到一個或多個外鍵。請檢查輸入並確保所有參照的實體都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $8c47cb899f906fdb$export$2e2bcd8739ae039 = Object.freeze($8c47cb899f906fdb$var$entity);


const $88260f65839c8448$var$guard = {
    invalid_input: "請求中 {{type}} 無效",
    invalid_pagination: "分頁參數無效",
    can_not_get_tenant_id: "無法從請求中獲取租戶 ID。",
    file_size_exceeded: "文件大小超過限制。",
    mime_type_not_allowed: "不允許使用此 MIME 類型。"
};
var $88260f65839c8448$export$2e2bcd8739ae039 = Object.freeze($88260f65839c8448$var$guard);


const $ad20d8511a42951a$var$hook = {
    missing_events: "你需要至少提供一個事件。",
    send_test_payload_failed: "無法發送測試内容：{{message}}",
    endpoint_responded_with_error: "端點返回了錯誤。"
};
var $ad20d8511a42951a$export$2e2bcd8739ae039 = Object.freeze($ad20d8511a42951a$var$hook);


const $199370931039ab38$var$localization = {
    cannot_delete_default_language: "你已設置 {{languageTag}} 為你的預設語言，你無法刪除預設語言。",
    invalid_translation_structure: "無效的資料格式，請檢查你的輸入並重試。"
};
var $199370931039ab38$export$2e2bcd8739ae039 = Object.freeze($199370931039ab38$var$localization);


const $6f76da3d68846428$var$log = {
    invalid_type: "日誌類型無效。"
};
var $6f76da3d68846428$export$2e2bcd8739ae039 = Object.freeze($6f76da3d68846428$var$log);


const $d7512fa4083f975f$var$oidc = {
    aborted: "用戶終止了交互。",
    invalid_scope: "無效範圍: {{error_description}}.",
    invalid_token: "Token 無效",
    invalid_client_metadata: "無效的客戶端元數據",
    insufficient_scope: "缺少權限範圍 `{{scope}}`。",
    invalid_request: "請求無效",
    invalid_grant: "授權請求無效",
    invalid_redirect_uri: "無效返回鏈接, 該 redirect_uri 未被此應用注冊。",
    access_denied: "拒絶訪問",
    invalid_target: "請求資源無效",
    unsupported_grant_type: "不支持的 grant_type",
    unsupported_response_mode: "不支持的 response_mode",
    unsupported_response_type: "不支持的 response_type",
    provider_error: "OIDC 內部錯誤: {{message}}",
    server_error: "發生了未知的 OIDC 錯誤。請稍後重試。",
    provider_error_fallback: "發生了 OIDC 錯誤: {{code}}.",
    key_required: "至少需要一個金鑰。",
    key_not_found: "未找到 ID 為 {{id}} 的金鑰。"
};
var $d7512fa4083f975f$export$2e2bcd8739ae039 = Object.freeze($d7512fa4083f975f$var$oidc);


const $6de0949e9bbba721$var$organization = {
    require_membership: "用戶必須是組織的成員才能繼續。"
};
var $6de0949e9bbba721$export$2e2bcd8739ae039 = Object.freeze($6de0949e9bbba721$var$organization);


const $e171eeef042887da$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密碼 pepper 未找到。請檢查 core 的環境變量。",
    rejected: "密碼被拒絕。請檢查您的密碼是否符合要求。"
};
var $e171eeef042887da$export$2e2bcd8739ae039 = Object.freeze($e171eeef042887da$var$password);


const $8f514a57c42b4b9a$var$request = {
    invalid_input: "輸入無效。{{details}}",
    general: "發生請求錯誤。"
};
var $8f514a57c42b4b9a$export$2e2bcd8739ae039 = Object.freeze($8f514a57c42b4b9a$var$request);


const $875682a6ddd4f026$var$resource = {
    resource_identifier_in_use: "API 識別碼 {{indicator}} 已經被使用"
};
var $875682a6ddd4f026$export$2e2bcd8739ae039 = Object.freeze($875682a6ddd4f026$var$resource);


const $04f0f1f346a3ee23$var$role = {
    name_in_use: "此角色名稱 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    user_exists: "用戶 ID {{userId}} 已添加到此角色",
    application_exists: "應用程式 ID {{applicationId}} 已添加到此角色",
    default_role_missing: "某些默認角色名稱在數據庫中不存在，請確保先創建角色",
    internal_role_violation: "你可能正在嘗試更新或刪除 Logto 禁止的內部角色。如果你要創建新角色，請嘗試使用不以“#internal:”開頭的名稱。"
};
var $04f0f1f346a3ee23$export$2e2bcd8739ae039 = Object.freeze($04f0f1f346a3ee23$var$role);


const $24ddca316a1ee88c$var$scope = {
    name_exists: "此作用域名稱 {{name}} 已被使用",
    name_with_space: "作用域名稱不能包含任何空格。"
};
var $24ddca316a1ee88c$export$2e2bcd8739ae039 = Object.freeze($24ddca316a1ee88c$var$scope);


const $adad44c60ac94541$var$session = {
    not_found: "未找到會話。請返回並重新登錄。",
    invalid_credentials: "賬號或密碼錯誤，請重新輸入。",
    invalid_sign_in_method: "當前登錄方式不可用",
    invalid_connector_id: "找不到 ID 為 {{connectorId}} 的可用連接器。",
    insufficient_info: "登錄信息缺失，請檢查你的輸入。",
    connector_id_mismatch: "傳入的連接器 ID 與 session 中保存的記錄不一致",
    connector_session_not_found: "無法找到連接器登錄信息，請嘗試重新登錄。",
    verification_session_not_found: "驗證失敗，請重新驗證。",
    verification_expired: "當前頁面已超時。為確保你的賬號安全，請重新驗證。",
    verification_blocked_too_many_attempts: "短時間內嘗試次數太多。請過一會再試 {{relativeTime}}。",
    unauthorized: "請先登錄",
    unsupported_prompt_name: "不支持的 prompt name",
    forgot_password_not_enabled: "忘記密碼功能沒有開啟。",
    verification_failed: "驗證失敗，請重新驗證。",
    connector_validation_session_not_found: "找不到連接器用於驗證 token 的信息。",
    identifier_not_found: "找不到用戶標識符。請返回並重新登錄。",
    interaction_not_found: "找不到互動會話。請返回並重新開始會話。",
    not_supported_for_forgot_password: "此操作不支援忘記密碼。",
    mfa: {
        require_mfa_verification: "需要 MFA 驗證才能登錄。",
        mfa_sign_in_only: "MFA 只能用於登錄互動。",
        pending_info_not_found: "未找到等待中的 MFA 資訊，請先啟動 MFA。",
        invalid_totp_code: "無效的 TOTP 驗證碼。",
        webauthn_verification_failed: "WebAuthn 驗證失敗。",
        webauthn_verification_not_found: "未找到 WebAuthn 驗證。",
        bind_mfa_existed: "MFA 已存在。",
        backup_code_can_not_be_alone: "備用碼不能作為唯一 MFA。",
        backup_code_required: "備用碼是必需的。",
        invalid_backup_code: "無效的備用碼。",
        mfa_policy_not_user_controlled: "MFA 政策不受使用者控制。"
    },
    sso_enabled: "該郵箱已開啟單點登錄，請使用 SSO 登錄。"
};
var $adad44c60ac94541$export$2e2bcd8739ae039 = Object.freeze($adad44c60ac94541$var$session);


const $ebc38ca752f3025a$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你啟用了「使用條款」，請加入使用條款 URL。",
    empty_social_connectors: "你啟用了社交登錄的方式。請至少選擇一個社交連接器。",
    enabled_connector_not_found: "未找到已啟用的 {{type}} 連接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登錄方式一定要有且只能有一個，請檢查你的輸入。",
    username_requires_password: "必須為用戶名註冊標識符啟用設置密碼。",
    passwordless_requires_verify: "必須為電郵/電話註冊標識符啟用驗證。",
    miss_sign_up_identifier_in_sign_in: "登錄方法一定要包含註冊標識符。",
    password_sign_in_must_be_enabled: "必須在註冊中要求設置密碼時啟用密碼登錄。",
    code_sign_in_must_be_enabled: "必須在註冊中不要求設置密碼時啟用驗證碼登錄。",
    unsupported_default_language: "{{language}} 無法選擇作為默認語言。",
    at_least_one_authentication_factor: "至少要選擇一個登錄要素",
    backup_code_cannot_be_enabled_alone: "Backup code cannot be enabled alone.",
    duplicated_mfa_factors: "Duplicated MFA factors."
};
var $ebc38ca752f3025a$export$2e2bcd8739ae039 = Object.freeze($ebc38ca752f3025a$var$sign_in_experiences);


const $10f95912b954e936$var$single_sign_on = {
    forbidden_domains: "不允許使用公共電郵域名。",
    duplicated_domains: "存在重複的域名。",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $10f95912b954e936$export$2e2bcd8739ae039 = Object.freeze($10f95912b954e936$var$single_sign_on);


const $451cfaf19f34c81a$var$storage = {
    not_configured: "未配置存儲提供程序。",
    missing_parameter: "存儲提供程序缺少參數 {{parameter}}。",
    upload_error: "無法將文件上載到存儲提供程序。"
};
var $451cfaf19f34c81a$export$2e2bcd8739ae039 = Object.freeze($451cfaf19f34c81a$var$storage);


const $c8a5321a37ad2520$var$subscription = {
    limit_exceeded: "您已達到訂閱計劃的限制。",
    get_plan_failed: "無法取得租戶的訂閱計劃。",
    tenant_suspended: "租戶已被暫停。 請聯繫您的管理員。"
};
var $c8a5321a37ad2520$export$2e2bcd8739ae039 = Object.freeze($c8a5321a37ad2520$var$subscription);


const $76d4445c7bf6b087$var$swagger = {
    invalid_zod_type: "無效的 Zod 類型，請檢查路由 guard 配置。",
    not_supported_zod_type_for_params: "請求參數不支援的 Zod 類型，請檢查路由 guard 配置。"
};
var $76d4445c7bf6b087$export$2e2bcd8739ae039 = Object.freeze($76d4445c7bf6b087$var$swagger);


const $9f14c5d8b7ad72a8$var$user = {
    username_already_in_use: "該使用者名稱已被使用。",
    email_already_in_use: "該電子郵件地址已被使用。",
    phone_already_in_use: "該手機號碼已被使用。",
    invalid_email: "電子郵件地址不正確。",
    invalid_phone: "手機號碼不正確。",
    email_not_exist: "電子郵件地址尚未註冊。",
    phone_not_exist: "手機號碼尚未註冊。",
    identity_not_exist: "該社交帳號尚未註冊。",
    identity_already_in_use: "該社交帳號已被註冊。",
    social_account_exists_in_profile: "你已綁定當前社交帳號，無需重複操作。",
    cannot_delete_self: "無法刪除自己的帳戶。",
    sign_up_method_not_enabled: "註冊方式尚未啟用。",
    sign_in_method_not_enabled: "登錄方式尚未啟用。",
    same_password: "為確保帳戶安全，新密碼不能與舊密碼一致。",
    password_required_in_profile: "請設置登錄密碼。",
    new_password_required_in_profile: "請設置新密碼。",
    password_exists_in_profile: "當前使用者已設置密碼，無需重複操作。",
    username_required_in_profile: "請設置使用者名稱。",
    username_exists_in_profile: "當前使用者已設置使用者名稱，無需重複操作。",
    email_required_in_profile: "請綁定電子郵件地址",
    email_exists_in_profile: "當前使用者已綁定電子郵件，無需重複操作。",
    phone_required_in_profile: "請綁定手機號碼。",
    phone_exists_in_profile: "當前使用者已綁定手機號碼，無需重複操作。",
    email_or_phone_required_in_profile: "請綁定電子郵件地址或手機號碼。",
    suspended: "帳戶已被禁用。",
    user_not_exist: "未找到與 {{identifier}} 相關聯的使用者。",
    missing_profile: "請於登錄時提供必要的使用者補充資訊。",
    role_exists: "角色 ID {{roleId}} 已添加到此使用者",
    invalid_role_type: "無法設置機械到機械角色給使用者。",
    missing_mfa: "你需要在登錄前綁定額外的 MFA。",
    totp_already_in_use: "TOTP 已經在使用中。",
    backup_code_already_in_use: "備份代碼已經在使用中。"
};
var $9f14c5d8b7ad72a8$export$2e2bcd8739ae039 = Object.freeze($9f14c5d8b7ad72a8$var$user);


const $8fb874e299afa012$var$verification_code = {
    phone_email_empty: "手機號碼與電子郵件地址均為空",
    not_found: "驗證碼不存在，請先請求發送驗證碼",
    phone_mismatch: "手機號碼不匹配，請嘗試請求新的驗證碼。",
    email_mismatch: "電子郵件地址不匹配，請嘗試請求新的驗證碼。",
    code_mismatch: "驗證碼不正確",
    expired: "驗證碼已過期，請嘗試請求新的驗證碼。",
    exceed_max_try: "超過最大驗證次數，請嘗試請求新的驗證碼。"
};
var $8fb874e299afa012$export$2e2bcd8739ae039 = Object.freeze($8fb874e299afa012$var$verification_code);


const $b9008f55d615ba43$var$errors = {
    request: $8f514a57c42b4b9a$export$2e2bcd8739ae039,
    auth: $059104fe06b11611$export$2e2bcd8739ae039,
    guard: $88260f65839c8448$export$2e2bcd8739ae039,
    oidc: $d7512fa4083f975f$export$2e2bcd8739ae039,
    user: $9f14c5d8b7ad72a8$export$2e2bcd8739ae039,
    password: $e171eeef042887da$export$2e2bcd8739ae039,
    session: $adad44c60ac94541$export$2e2bcd8739ae039,
    connector: $150add9f2ba18ba1$export$2e2bcd8739ae039,
    verification_code: $8fb874e299afa012$export$2e2bcd8739ae039,
    sign_in_experiences: $ebc38ca752f3025a$export$2e2bcd8739ae039,
    localization: $199370931039ab38$export$2e2bcd8739ae039,
    swagger: $76d4445c7bf6b087$export$2e2bcd8739ae039,
    entity: $8c47cb899f906fdb$export$2e2bcd8739ae039,
    log: $6f76da3d68846428$export$2e2bcd8739ae039,
    role: $04f0f1f346a3ee23$export$2e2bcd8739ae039,
    scope: $24ddca316a1ee88c$export$2e2bcd8739ae039,
    storage: $451cfaf19f34c81a$export$2e2bcd8739ae039,
    resource: $875682a6ddd4f026$export$2e2bcd8739ae039,
    hook: $ad20d8511a42951a$export$2e2bcd8739ae039,
    domain: $ca27e4cd18f8a3ab$export$2e2bcd8739ae039,
    subscription: $c8a5321a37ad2520$export$2e2bcd8739ae039,
    application: $ba3b8698664c2b94$export$2e2bcd8739ae039,
    organization: $6de0949e9bbba721$export$2e2bcd8739ae039,
    single_sign_on: $10f95912b954e936$export$2e2bcd8739ae039
};
var $b9008f55d615ba43$export$2e2bcd8739ae039 = Object.freeze($b9008f55d615ba43$var$errors);


const $cf559519739484f8$var$api_resource_details = {
    page_title: "API 資源詳情",
    back_to_api_resources: "返回 API 資源",
    settings_tab: "設置",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "API 資源，又稱資源指示器，表示要請求的目標服務或資源，通常是表示資源身份的 URI 格式變數。",
    management_api_settings_description: "Logto 管理 API 是一個全面的 API 集合，使管理員能夠管理各種與身份有關的任務，執行安全策略，並遵守法規和標準。",
    management_api_notice: "此 API 代表 Logto 實體，不得修改或刪除。你可以使用管理 API 進行各種與身份有關的任務。 <a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 過期時間（秒）",
    token_expiration_time_in_seconds_placeholder: "請輸入你的 token 過期時間",
    delete_description: "本操作會永久性地刪除該 API 資源，且不可撤銷。輸入 API 資源名稱 <span>{{name}}</span> 確認。",
    enter_your_api_resource_name: "輸入 API 資源名稱",
    api_resource_deleted: " API 資源 {{name}} 已刪除.",
    permission: {
        create_button: "創建權限",
        create_title: "創建權限",
        create_subtitle: "定義此 API 所需的權限 (scope)。",
        confirm_create: "創建權限",
        name: "權限名稱",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "權限名稱不能包含空格。",
        description: "描述",
        description_placeholder: "能夠讀取資源",
        permission_created: '權限 "{{name}}" 已成功創建',
        delete_description: "如果刪除此權限，擁有該權限的用戶將失去由此權限授予的訪問權限。",
        deleted: '成功刪除權限 "{{name}}"。'
    }
};
var $cf559519739484f8$export$2e2bcd8739ae039 = Object.freeze($cf559519739484f8$var$api_resource_details);


const $758a4057f61f4d00$var$api_resources = {
    page_title: "API 資源",
    title: "API 資源",
    subtitle: "定義可以從已授權的應用程序中使用的 API",
    create: "創建 API 資源",
    api_name: "API 名稱",
    api_name_placeholder: "輸入 API 名稱",
    api_identifier: "API 描述符",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "對於 API 資源的唯一標識符。它必須是一個絕對 URI 並沒有 fragment (#) 組件。等價於 OAuth 2.0 中的 <a>resource parameter</a>。",
    default_api: "預設的 API",
    default_api_label: "一个租户只能设置零或一个默认 API。当指定默认 API 时，可以在身份验证请求中省略资源参数，还可以使用该 API 作为默认受众方进行令牌交换，从而发放 JWT。<a>了解更多</a>",
    api_resource_created: " API 資源 {{name}} 已成功創建。"
};
var $758a4057f61f4d00$export$2e2bcd8739ae039 = Object.freeze($758a4057f61f4d00$var$api_resources);


const $5d1e57f70e5e41d2$var$application_details = {
    page_title: "應用程式詳情",
    back_to_applications: "返回全部應用程式",
    check_guide: "查看指南",
    settings: "設定",
    settings_description: "應用程式用於在 Logto OIDC、登入體驗、審計日誌等方面識別你的應用程式。",
    advanced_settings: "高級設定",
    advanced_settings_description: "高級設定包括 OIDC 相關術語。你可以查看 Token Endpoint 以獲取更多資訊。",
    application_roles: "角色",
    machine_logs: "機器日誌",
    application_name: "應用程式名稱",
    application_name_placeholder: "我的應用程式",
    description: "描述",
    description_placeholder: "請輸入應用程式描述",
    config_endpoint: "OpenID Provider 配置端點",
    authorization_endpoint: "授權端點",
    authorization_endpoint_tip: "進行驗證和授權的端點。用於 OpenID Connect 中的<a>驗證</a> 流程。",
    logto_endpoint: "Logto endpoint",
    application_id: "應用程式 ID",
    application_id_tip: "應用程式的唯一標識，通常由 Logto 生成。等價於 OpenID Connect 中的<a>client_id</a>。",
    application_secret: "應用程式密鑰",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URI",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在使用者登入完成（不論成功與否）後重定向的目標 URI。參見 OpenID Connect <a>AuthRequest</a> 以瞭解更多。",
    post_sign_out_redirect_uri: "登出後重定向 URI",
    post_sign_out_redirect_uris: "登出後重定向 URI",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在使用者登出後重定向的目標 URI（可選）。在某些應用程式類型中可能無實質作用。",
    cors_allowed_origins: "CORS 允許的來源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重定向 URI 的來源將預設被允許。通常不需要對此欄位進行操作。參見 <a>MDN 文檔</a> 以瞭解更多。",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "用戶信息端點",
    enable_admin_access: "啟用管理訪問",
    enable_admin_access_label: "啟用或禁用對管理 API 的訪問。啟用後，你可以使用訪問權杖代表該應用程式調用管理 API。",
    always_issue_refresh_token: "始終發放 Refresh Token",
    always_issue_refresh_token_label: "啟用此配置將允許 Logto 發行 Refresh Token，無論是否在驗證請求中呈現 `prompt=consent`。但是，除非必要，否則不建議這樣做，因為它不兼容 OpenID Connect，可能會引起問題。",
    refresh_token_ttl: "Refresh Token 的有效期（天）",
    refresh_token_ttl_tip: "Refresh Token 可用來在其過期之前請求新的訪問權杖的持續時間。訪問令牌將將缺省的 TTL 延長到此值。",
    rotate_refresh_token: "旋轉 Refresh Token",
    rotate_refresh_token_label: "啟用後，當原始 TTL 達到 70% 或滿足某些條件時就可以在令牌請求中為 Refresh Token 發行新的 Refresh Token。 <a>瞭解更多。</a>",
    delete_description: "本操作會永久性地刪除該應用，且不可撤銷。輸入 <span>{{name}}</span> 確認。",
    enter_your_application_name: "輸入你的應用程式名稱",
    application_deleted: "應用 {{name}} 成功刪除。",
    redirect_uri_required: "至少需要輸入一個重定向 URL。",
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "指派角色",
        delete_description: "該操作將從此機器對機器應用程式中刪除該角色。該角色本身仍然存在，但不再與此機器對機器應用程式相關聯。",
        deleted: "{{name}} 已成功從此使用者中刪除。",
        assign_title: "為 {{name}} 指派角色",
        assign_subtitle: "授權 {{name}} 至少一個角色",
        assign_role_field: "指派角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "{{value, number}} 已添加",
        assigned_app_count: "{{value, number}} 個應用程式",
        confirm_assign: "指派角色",
        role_assigned: "成功指派角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    }
};
var $5d1e57f70e5e41d2$export$2e2bcd8739ae039 = Object.freeze($5d1e57f70e5e41d2$var$application_details);


const $bf61efe72a31c729$var$applications = {
    page_title: "全部應用",
    title: "全部應用",
    subtitle: "創建一個移動、單頁、machine-to-machine 或傳統 web 應用程序，並通過 Logto 進行身份驗證",
    subtitle_with_app_type: "為你的 {{name}} 應用程序設置 Logto 身份驗證",
    create: "創建應用",
    application_name: "應用名稱",
    application_name_placeholder: "我的應用",
    application_description: "應用描述",
    application_description_placeholder: "請輸入應用描述",
    select_application_type: "選擇應用類型",
    no_application_type_selected: "你還沒有選擇應用類型",
    application_created: "應用創建成功。",
    app_id: "App ID",
    type: {
        native: {
            title: "原生應用",
            subtitle: "在原生環境中運行的應用程序",
            description: "例如 iOS app，Android app"
        },
        spa: {
            title: "單頁應用",
            subtitle: "在瀏覽器中運行並動態更新數據的應用程序",
            description: "例如 React DOM app，Vue app"
        },
        traditional: {
            title: "傳統網頁應用",
            subtitle: "僅由 Web 服務器渲染和更新的應用程序",
            description: "例如 Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "直接與資源對話的應用程序（通常是服務）",
            description: "例如，後端服務"
        }
    },
    placeholder_title: "選擇應用程序類型以繼續",
    placeholder_description: "Logto 使用 OIDC 的應用程序實體來幫助識別您的應用程序、管理登錄和創建審計日誌等任務。"
};
var $bf61efe72a31c729$export$2e2bcd8739ae039 = Object.freeze($bf61efe72a31c729$var$applications);


const $7f7a2f07e25c6bf2$var$cloud = {
    general: {
        onboarding: "入門"
    },
    welcome: {
        page_title: "歡迎",
        title: "歡迎來到 Logto Cloud！我們很想了解你的一些信息。",
        description: "通過更好地了解你，我們可以使你的 Logto 體驗更加個性化。你的信息是安全的。",
        project_field: "我使用 Logto 是為了",
        project_options: {
            personal: "個人專案",
            company: "公司專案"
        },
        title_field: "選擇適用的職稱",
        title_options: {
            developer: "開發人員",
            team_lead: "團隊負責人",
            ceo: "CEO",
            cto: "CTO",
            product: "產品",
            others: "其他"
        },
        company_name_field: "公司名稱",
        company_name_placeholder: "Acme.co",
        company_size_field: "你的公司規模如何？",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "我註冊的原因是",
        reason_options: {
            passwordless: "尋找無需密碼身份驗證和 UI 工具包",
            efficiency: "尋找即插即用的身份基礎架構",
            access_control: "基於角色和責任控制用戶訪問",
            multi_tenancy: "尋求面向多租戶產品的策略",
            enterprise: "為產品更方便企業使用尋找 SSO 解決方案",
            others: "其他"
        }
    },
    sie: {
        page_title: "定制登錄體驗",
        title: "讓我們輕鬆定制你的登錄體驗",
        inspire: {
            title: "創建引人入勝的示例",
            description: "對登錄體驗不確定嗎？只需點擊“啟發我”，讓魔法發生！",
            inspire_me: "來點靈感"
        },
        logo_field: "應用商標",
        color_field: "品牌顏色",
        identifier_field: "標識符",
        identifier_options: {
            email: "電子郵件",
            phone: "電話",
            user_name: "用戶名"
        },
        authn_field: "身份驗證",
        authn_options: {
            password: "密碼",
            verification_code: "驗證碼"
        },
        social_field: "社交登錄",
        finish_and_done: "完成並完成",
        preview: {
            mobile_tab: "移動端",
            web_tab: "網頁端"
        },
        connectors: {
            unlocked_later: "稍後解鎖",
            unlocked_later_tip: "完成入門流程並進入產品後，你將獲得訪問更多社交登錄方式的權限。",
            notice: "請勿將演示連接器用於生產目的。完成測試後，請刪除演示連接器並使用你的憑證設置自己的連接器。"
        }
    },
    socialCallback: {
        title: "你已成功登錄",
        description: "你已成功使用社交帳戶登錄。為確保與 Logto 的無縫集成並獲得所有功能的訪問權限，我們建議你繼續配置自己的社交連接器。"
    },
    tenant: {
        create_tenant: "創建租戶"
    }
};
var $7f7a2f07e25c6bf2$export$2e2bcd8739ae039 = Object.freeze($7f7a2f07e25c6bf2$var$cloud);


const $13e3d05016c3cb84$var$components = {
    uploader: {
        action_description: "拖放或瀏覽上傳",
        uploading: "上傳中...",
        image_limit: "上傳圖片大小不能超過 {{size, number}}KB，只支援 {{extensions, list(style: narrow; type: conjunction;)}} 格式的檔案。",
        error_upload: "哎呀，出了些問題。檔案上傳失敗。",
        error_file_size: "檔案太大了，請上傳小於 {{size, number}}KB 的檔案。",
        error_file_type: "不支援該檔案格式，只支援 {{extensions, list(style: narrow; type: conjunction;)}} 格式的檔案。",
        error_file_count: "你只能上載一個檔案。"
    }
};
var $13e3d05016c3cb84$export$2e2bcd8739ae039 = Object.freeze($13e3d05016c3cb84$var$components);


const $983011aa26dbaa04$var$connector_details = {
    page_title: "連接器詳情",
    back_to_connectors: "返回連接器",
    check_readme: "查看 README",
    settings: "通用設置",
    settings_description: "連接器在 Logto 中扮演著至關重要的角色。借助它們的幫助，Logto 使終端用戶能夠使用無密碼註冊或登錄的功能以及使用社交帳戶登錄的功能。",
    parameter_configuration: "參數配置",
    test_connection: "測試",
    save_error_empty_config: "請輸入配置內容",
    send: "發送",
    send_error_invalid_format: "無效輸入",
    edit_config_label: "請在此輸入你的 JSON 配置",
    test_email_sender: "測試你的郵件連接器",
    test_sms_sender: "測試你的短信連接器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "測試信息已發送",
    test_sender_description: 'Logto 使用 "Generic" 模板進行測試。如果你的連接器正確配置，你將收到一條消息。',
    options_change_email: "更換郵件連接器",
    options_change_sms: "更換短信連接器",
    connector_deleted: "成功刪除連接器",
    type_email: "郵件連接器",
    type_sms: "短信連接器",
    type_social: "社交連接器",
    in_used_social_deletion_description: "你的登錄體驗正在使用這個連接器。刪除後，<name/> 登錄體驗將在登錄體驗設置中被刪除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "你的登錄體驗正在使用 {{name}} 連接器。刪除後，你的登錄體驗將無法正常工作，直到你解決衝突，再次添加需重新配置。",
    deletion_description: "你將刪除此連接器。此操作不可撤銷，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "總發送郵件數：{{value, number}}",
        total_email_sent_tip: "Logto 使用 SendGrid 進行安全穩定的內建電子郵件。完全免費使用。<a>了解更多</a>",
        email_template_title: "郵件模板",
        template_description: "內建郵件使用默認模板實現無縫交付驗證郵件。無需配置，您可以自定義基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "發件人郵箱",
        sender_name_field: "發件人姓名",
        sender_name_tip: "自定義郵件發件人姓名。如果未填寫，將使用「Verification」作為默認姓名。",
        sender_name_placeholder: "您的發送人姓名",
        company_information_field: "公司信息",
        company_information_description: "在郵件底部顯示您的公司名稱、地址或郵政編碼，以增強真實性。",
        company_information_placeholder: "您公司的基本信息",
        app_logo_field: "應用程序標誌",
        app_logo_tip: "在郵件頂部顯示您的品牌標誌。在淺色模式和深色模式下使用相同的圖像。",
        urls_not_allowed: "不允許使用 URL",
        test_notes: 'Logto 使用 "通用" 模板進行測試。'
    }
};
var $983011aa26dbaa04$export$2e2bcd8739ae039 = Object.freeze($983011aa26dbaa04$var$connector_details);


const $1d6f5038ec6f86e7$var$connectors = {
    page_title: "連接器",
    title: "連接器",
    subtitle: "設置連接器，啟動無密碼和社交登錄",
    create: "添加社交連接器",
    config_sie_notice: "你已經配置了社交連接器，記得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登錄體驗",
    tab_email_sms: "短信和郵件連接器",
    tab_social: "社交連接器",
    connector_name: "連接器名稱",
    demo_tip: "演示連接器僅用於演示且最多只能發送 100 條消息，不建議在生產環境中部署。",
    social_demo_tip: "演示連接器僅用於演示目的，不建議在生產環境中部署。",
    connector_type: "類型",
    connector_status: "登錄體驗",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味著你的登錄體驗並沒有使用這個登錄方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登錄體驗"
    },
    placeholder_title: "社交連接器",
    placeholder_description: "Logto 提供了許多廣泛使用的社交登錄連接器，同時你還可以使用標準協議創建自己的連接器。",
    save_and_done: "保存並完成",
    type: {
        email: "郵件連接器",
        sms: "短信連接器",
        social: "社交連接器"
    },
    setup_title: {
        email: "設置郵件連接器",
        sms: "設置短信連接器",
        social: "添加社交連接器"
    },
    guide: {
        subtitle: "參考以下步驟完成你的連接器設置",
        general_setting: "通用設置",
        parameter_configuration: "參數配置",
        test_connection: "連接測試",
        name: "社交登錄按鈕的名稱",
        name_placeholder: "輸入社交登錄按鈕的名稱",
        name_tip: "按鈕上將展示「通過 {{name}} 繼續」。名字不宜過長而導致信息無法展示完整。",
        logo: "社交登錄按鈕的 Logo 圖片鏈接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "該圖片將用於連接器的展示。獲取圖片鏈接後粘貼在此處。",
        logo_dark: "社交登錄按鈕的 Logo 圖片鏈接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制台的登錄體驗中啟用“深色模式”後，可設置此連接器 Logo 用於深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展開深色模式 Logo 設置",
        target: "身份提供商名稱",
        target_placeholder: "輸入身份提供商的名稱",
        target_tip: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。",
        target_tip_standard: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。注意，在連接器創建成功後，無法再次修改此設置。",
        target_tooltip: "Logto 社交連接器的「target」指的是社交身份的「來源」。在 Logto 的設計裡，我們不允許某一平臺的連接器中有相同的「target」以避免身份的衝突。在添加連接器時，你需要格外小心，我們「不允許」用戶在創建之後更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供應商名稱」值與現有的 <span>name</span> 連接器相同。使用相同的身份提供商名稱會導致不符合預期的登錄行為，用戶可能通過兩個不同的連接器訪問同一個帳戶。",
        target_conflict_line2: "如果你想替換當前的連接器，並連接相同的身份提供商（IdP），以便先前的用戶可以直接登錄而無需重新註冊，請先刪除 <span>name</span> 連接器，再創建一個新的連接器並使用相同的「身份供應商名稱」值。",
        target_conflict_line3: "如果你想連接一個新的身份驗證提供程序，請修改「身份供應商名稱」並繼續。",
        config: "粘貼你的 JSON 代碼",
        sync_profile: "開啟用戶資料同步",
        sync_profile_only_at_sign_up: "首次註冊時同步",
        sync_profile_each_sign_in: "每次登錄時同步",
        sync_profile_tip: "同步用戶的用戶名、頭像等個人資料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也稱為重定向 URI，在社交授權後，用戶將被發送回 Logto 的 URI，復制並粘貼到社交提供者的配置頁面中。"
    },
    platform: {
        universal: "通用",
        web: "網頁",
        native: "原生"
    },
    add_multi_platform: "支持多平台，選擇一個平台繼續",
    drawer_title: "連接器配置指南",
    drawer_subtitle: "參考以下步驟完善或修改你的連接器設置",
    unknown: "未知連接器",
    standard_connectors: "標準連接器"
};
var $1d6f5038ec6f86e7$export$2e2bcd8739ae039 = Object.freeze($1d6f5038ec6f86e7$var$connectors);


const $3ed665d3b7d55b66$var$contact = {
    title: "獲得幫助",
    description: "欲查詢幫助或提供產品反饋，請透過以下方式聯絡我們。",
    discord: {
        title: "加入 Discord 社群",
        description: "與其他開發人員交流，尋找解決方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上溝通",
        description: "創建問題並提交到 GitHub",
        button: "打開"
    },
    email: {
        title: "透過電子郵件聯絡客服支援",
        description: "發送電子郵件以獲取進一步信息和幫助",
        button: "發送"
    },
    reserve: {
        title: "與 Logto 團隊預定時間",
        description: "快速預定一個會話內容",
        button: "預定"
    }
};
var $3ed665d3b7d55b66$export$2e2bcd8739ae039 = Object.freeze($3ed665d3b7d55b66$var$contact);


const $9a822f4daef7367c$var$dashboard = {
    page_title: "儀表板",
    title: "儀表板",
    description: "查看所有應用的數據概況",
    total_users: "總用戶",
    total_users_tip: "總用戶",
    new_users_today: "今日新增",
    new_users_today_tip: "今日註冊到你應用上的新用戶數",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日註冊到你應用上的新用戶數",
    daily_active_users: "日活用戶",
    daily_active_users_tip: "今日在你的應用上交換過 token 的獨立用戶數",
    weekly_active_users: "周活用戶",
    weekly_active_users_tip: "最近 7 日在你的應用上交換過 token 的獨立用戶數",
    monthly_active_users: "月活用戶",
    monthly_active_users_tip: "最近 30 日在你的應用上交換過 token 的獨立用戶數"
};
var $9a822f4daef7367c$export$2e2bcd8739ae039 = Object.freeze($9a822f4daef7367c$var$dashboard);


const $5f18b2c1733cc003$var$domain = {
    status: {
        connecting: "正在連接",
        in_used: "使用中",
        failed_to_connect: "連接失敗"
    },
    update_endpoint_notice: "不要忘記在應用程序中更新社交連接器回調URI和Logto端點的域名，如果您想使用自定義域名進行功能。 <a>{{link}}</a>",
    error_hint: "確保更新您的 DNS 記錄。我們將繼續每 {{value}} 秒檢查。",
    custom: {
        custom_domain: "自定義域名",
        custom_domain_description: "提高品牌形象，使用自定義域名。此域名將用於您的登錄體驗。",
        custom_domain_field: "自定義域名",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "添加域名",
        invalid_domain_format: "子域名格式無效，請輸入至少三個子域名部分。",
        verify_domain: "驗證域名",
        enable_ssl: "啟用 SSL",
        checking_dns_tip: "配置 DNS 記錄後，此程序將自動運行，可能需要長達 24 個小時。不影響執行，可離開此界面。",
        enable_ssl_tip: "啟用 SSL 將自動運行，可能需要長達 24 個小時。您可以在運行期間離開此界面。",
        generating_dns_records: "正在生成 DNS 記錄...",
        add_dns_records: "請把以下 DNS 記錄添加到 DNS 提供者。",
        dns_table: {
            type_field: "類型",
            name_field: "名稱",
            value_field: "內容"
        },
        deletion: {
            delete_domain: "刪除域名",
            reminder: "刪除自定義域名",
            description: "確定刪除此自定義域名嗎？",
            in_used_description: '確定刪除此自定義域名"<span>{{domain}}</span>"嗎？',
            in_used_tip: '如果在之前的社交記錄或應用程式終端點中配置此自定義域名,您需要先使用Logto默認域名"<span>{{domain}}</span>"修改URI，使社交組件可以正常使用。',
            deleted: "成功刪除自定義域名！"
        }
    },
    default: {
        default_domain: "默認域名",
        default_domain_description: "Logto提供預配置的默認域名，無需進行任何其他設置即可使用。即使啟用了自定義域名，此默認域名也可作為備用選項。",
        default_domain_field: "Logto 默認域名"
    },
    custom_endpoint_note: "您可以根據需要自定義這些端點的域名。選擇“{{custom}}”或“{{default}}”。",
    custom_social_callback_url_note: "您可以自定義此URI的域名以匹配您的應用程序端點。選擇“{{custom}}”或“{{default}}”。"
};
var $5f18b2c1733cc003$export$2e2bcd8739ae039 = Object.freeze($5f18b2c1733cc003$var$domain);


const $712c80eedf6972cc$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $712c80eedf6972cc$export$2e2bcd8739ae039 = Object.freeze($712c80eedf6972cc$var$enterprise_sso_details);


const $d6b938883daf5c4c$var$enterprise_sso = {
    page_title: "企業單一登入 (SSO)",
    title: "企業單一登入 (SSO)",
    subtitle: "連接企業身份提供者並啟用服務提供者啟動的單一登入。",
    create: "新增企業連接器",
    col_connector_name: "連接器名稱",
    col_type: "類型",
    col_email_domain: "電子郵件域名",
    placeholder_title: "企業連接器",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "新增企業連接器",
        text_divider: "或者您可以通過標準協議自定義您的連接器。",
        connector_name_field_title: "連接器名稱",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "創建連接器"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $d6b938883daf5c4c$export$2e2bcd8739ae039 = Object.freeze($d6b938883daf5c4c$var$enterprise_sso);


const $8ec0c5b929195452$var$errors = {
    something_went_wrong: "哎呀，出錯了！",
    page_not_found: "找不到頁面",
    unknown_server_error: "伺服器發生未知錯誤",
    empty: "沒有數據",
    missing_total_number: "無法從返回的標頭信息中找到 Total-Number",
    invalid_uri_format: "無效的 URI 格式",
    invalid_origin_format: "無效的 URI origin 格式",
    invalid_json_format: "無效的 JSON 格式",
    invalid_error_message_format: "非法的錯誤信息格式",
    required_field_missing: "請輸入{{field}}",
    required_field_missing_plural: "至少需要輸入一個{{field}}",
    more_details: "查看詳情",
    username_pattern_error: "用戶名只能包含英文字母、數字或下劃線，且不以數字開頭。",
    email_pattern_error: "郵箱地址無效",
    phone_pattern_error: "手機號碼無效",
    insecure_contexts: "不支持不安全的上下文（非 HTTPS）。",
    unexpected_error: "發生未知錯誤",
    not_found: "404 找不到資源",
    create_internal_role_violation: '你正在創建一個被 Logto 禁止內部角色。嘗試使用不以 "#internal:" 開頭的其他名稱。',
    should_be_an_integer: "必须为整数。",
    number_should_be_between_inclusive: "数值必须在{{min}}和{{max}}之间（包括{{min}}和{{max}}）。"
};
var $8ec0c5b929195452$export$2e2bcd8739ae039 = Object.freeze($8ec0c5b929195452$var$errors);


const $f80cd8bf5a2b4cd8$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳過",
    next: "下一步",
    back: "上一步",
    retry: "重試",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除結果",
    save: "儲存",
    save_changes: "儲存變更",
    saved: "已儲存",
    discard: "放棄",
    loading: "讀取中...",
    redirecting: "頁面跳轉中...",
    add: "添加",
    added: "已添加",
    cancel: "取消",
    confirm: "確認",
    check_out: "查看",
    create: "創建",
    set_up: "配置",
    customize: "自定義",
    enable: "啟用",
    reminder: "提示",
    delete: "刪除",
    more_options: "更多選項",
    close: "關閉",
    copy: "複製",
    copying: "複製中",
    copied: "已複製",
    required: "必填",
    add_another: "新增",
    create_another: "創建另一個",
    deletion_confirmation: "你確定要刪除這個 {{title}} 嗎?",
    settings_nav: "設置",
    unsaved_changes_warning: "還有未儲存的變更,確定要離開嗎？",
    leave_page: "離開此頁",
    stay_on_page: "留在此頁",
    type_to_search: "輸入搜索",
    got_it: "知道了",
    continue: "繼續",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 條",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 個錯誤",
    skip_for_now: "先跳過",
    remove: "移除",
    visit: "訪問",
    join: "加入",
    try_now: "現在試試",
    multiple_form_field: "（多選）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    hide: "隱藏",
    unknown_error: "未知錯誤，請稍後重試。",
    select: "選擇",
    contact_us_action: "聯絡我們",
    description: "描述",
    name: "名稱",
    add_field: "新增{{field}}",
    create_field: "創建{{field}}",
    edit_field: "編輯{{field}}",
    delete_field: "刪除{{field}}",
    coming_soon: "即將推出",
    beta_notice: "\uD83C\uDF89 {{feature}} 目前處於測試階段。歡迎探索並 <ContactLink>分享您的意見</ContactLink>。"
};
var $f80cd8bf5a2b4cd8$export$2e2bcd8739ae039 = Object.freeze($f80cd8bf5a2b4cd8$var$general);


const $0f4f8fd3473fba1a$var$get_started = {
    page_title: "開始上手",
    title: "成功開發身份方案，我們先來探索一番",
    subtitle: "一些你可以做的事情，以快速獲取 Logto 的價值",
    develop: {
        title: "開發：花 5 分鐘將你的應用集成進來"
    },
    customize: {
        title: "定制：提供出色的登錄體驗",
        preview: {
            title: "查看剛剛定制的登錄體驗的實時預覽",
            subtitle: "現在嘗試 Logto 登錄體驗，看看它如何運作"
        },
        connector: {
            title: "添加更多連接器以支持更多社交登錄方式",
            subtitle: "試一試無密碼登錄，為你的客戶提供安全、無摩擦的體驗"
        },
        continue_customizing: "繼續定制",
        try_now: "立即試用",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保護你的資源"
    },
    manage: {
        title: "管理：為你的產品和用戶定義存取控制",
        rbac: {
            title: "為你的資源添加基於角色的存取控制",
            subtitle: "通過可擴展的角色授權，控制你的資源，滿足不同的使用場景"
        },
        create_roles: "創建角色"
    },
    view_all: "查看全部 →"
};
var $0f4f8fd3473fba1a$export$2e2bcd8739ae039 = Object.freeze($0f4f8fd3473fba1a$var$get_started);


const $415302f3f6f973cc$var$guide = {
    start_building: "開始構建",
    get_started: "立即開始",
    categories: {
        featured: "推薦熱門開發框架",
        Traditional: "傳統網頁應用",
        SPA: "單頁應用",
        Native: "原生應用",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "篩選框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你現在不需要教程，可以點擊右側按鈕繼續創建應用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在尋找的教程",
    request_guide_successfully: "請求已成功提交，謝謝！",
    app: {
        select_framework_or_tutorial: "選擇一個框架或教程",
        guide_modal_title: "從 SDK 和指南開始",
        modal_subtitle: "使用我們提供的 SDK 和集成教程加速你的應用開發過程。",
        select_a_framework: "選擇一個框架",
        continue_without_framework: "跳過教程直接創建應用",
        describe_guide_looking_for_placeholder: "例如：我想將 Logto 集成到我的 Angular 應用程式中。"
    },
    api: {
        modal_title: "首先從教程開始",
        modal_subtitle: "使用我們提供的教程來加速你的應用程式開發過程。",
        select_a_tutorial: "選擇一個教程",
        continue_without_tutorial: "跳過教程直接創建 API 資源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架驗證我的 API。"
    }
};
var $415302f3f6f973cc$export$2e2bcd8739ae039 = Object.freeze($415302f3f6f973cc$var$guide);


const $b6f56b46413e2ea1$var$log_details = {
    page_title: "審計日誌詳情",
    back_to_logs: "返回審計日誌",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失敗",
    event_key: "事件 Key",
    application: "應用",
    ip_address: "IP 地址",
    user: "用戶",
    log_id: "日誌 ID",
    time: "時間",
    user_agent: "用戶代理",
    tab_details: "詳細",
    raw_data: "原始數據"
};
var $b6f56b46413e2ea1$export$2e2bcd8739ae039 = Object.freeze($b6f56b46413e2ea1$var$log_details);


const $60f18d86df0ca7f4$var$logs = {
    page_title: "審計日誌",
    title: "審計日誌",
    subtitle: "查看用戶行為和事件",
    event: "事件",
    user: "用戶",
    application: "應用",
    time: "時間",
    filter_by: "過濾"
};
var $60f18d86df0ca7f4$export$2e2bcd8739ae039 = Object.freeze($60f18d86df0ca7f4$var$logs);


const $69b1c502a1fd2240$var$menu = {
    profile: "帳戶管理",
    language: "語言",
    appearance: {
        label: "主題",
        light: "淺色模式",
        dark: "深色模式",
        system: "跟隨系統"
    },
    sign_out: "退出登錄"
};
var $69b1c502a1fd2240$export$2e2bcd8739ae039 = Object.freeze($69b1c502a1fd2240$var$menu);


const $79c34c235f684789$var$mfa = {
    title: "多因素身份驗證",
    description: "添加多因素身份驗證以提升您登錄體驗的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用戶需要驗證啟用的其中一個因素以進行兩步驗證。",
    totp: "身份驗證應用 OTP",
    otp_description: "將 Google Authenticator 等連接起來，以驗證一次性密碼。",
    webauthn: "WebAuthn（通行證）",
    webauthn_description: "通過瀏覽器支持的方法進行驗證：生物識別、手機掃描或安全密鑰等。",
    webauthn_native_tip: "本地應用不支持 WebAuthn。",
    webauthn_domain_tip: "WebAuthn將公共密鑰綁定到特定域。修改服務域將阻止用戶通過現有通行證進行身份驗證。",
    backup_code: "備份代碼",
    backup_code_description: "在用戶設置任何MFA方法後生成10個一次性備份代碼。",
    backup_code_setup_hint: "當用戶無法驗證上述MFA因素時，使用備份選項。",
    backup_code_error_hint: "要使用備份代碼，您需要至少再添加一種MFA方法以成功進行用戶身份驗證。",
    policy: "策略",
    policy_description: "設置登錄和註冊流程的MFA策略。",
    two_step_sign_in_policy: "登錄時的雙步驗證策略",
    user_controlled: "用戶可以自行啟用或禁用MFA",
    user_controlled_tip: "用戶可以在首次登錄或註冊時跳過MFA設置，或在帳戶設置中啟用/禁用它。",
    mandatory: "用戶總是需要在登錄時使用MFA",
    mandatory_tip: "用戶必須在首次登錄或註冊時設置MFA，並在以後的所有登錄中使用它。"
};
var $79c34c235f684789$export$2e2bcd8739ae039 = Object.freeze($79c34c235f684789$var$mfa);


const $bfe600060780414c$var$organization_details = {
    page_title: "組織詳細資料",
    delete_confirmation: "刪除後，所有成員將失去他們在此組織的成員資格和角色。此操作無法撤銷。",
    organization_id: "組織 ID",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "組織的名稱，不需要是唯一的。",
    description_placeholder: "組織的描述。",
    member: "成員",
    member_other: "成員",
    add_members_to_organization: "將成員新增至組織 {{name}}",
    add_members_to_organization_description: "通過搜索姓名、電子郵件、電話或使用者 ID 尋找合適的使用者。現有成員不會顯示在搜尋結果中。",
    add_with_organization_role: "以組織角色添加",
    user: "使用者",
    authorize_to_roles: "授權 {{name}} 存取以下角色：",
    edit_organization_roles: "編輯組織角色",
    edit_organization_roles_of_user: "編輯 {{name}} 的組織角色",
    remove_user_from_organization: "從組織中移除使用者",
    remove_user_from_organization_description: "移除後，使用者將失去他們在此組織的成員資格和角色。此操作無法撤銷。",
    search_user_placeholder: "按姓名、電子郵件、電話或使用者 ID 搜尋",
    at_least_one_user: "至少需要一名使用者。"
};
var $bfe600060780414c$export$2e2bcd8739ae039 = Object.freeze($bfe600060780414c$var$organization_details);


const $4ecf06c797d8f826$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "組織",
    title: "組織",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "組織 ID",
    members: "成員",
    create_organization: "建立組織",
    setup_organization: "設定您的組織",
    organization_list_placeholder_title: "組織",
    organization_list_placeholder_text: "組織通常在 SaaS 或類似 SaaS 的多租戶應用程式中使用。組織功能使您的 B2B 客戶能夠更好地管理其合作夥伴和客戶，並自定應用程式最終用戶的訪問方式。",
    organization_name_placeholder: "我的組織",
    organization_description_placeholder: "組織的簡要描述",
    organization_permission: "組織權限",
    organization_permission_other: "組織權限",
    organization_permission_description: "組織權限指授權在組織上下文中存取資源的許可。組織權限應該以有意義的字串形式表示，同時作為名稱和唯一標識。",
    organization_permission_delete_confirm: "如果刪除此權限，所有包含此權限的組織角色都將失去此權限，具有此權限的用戶將失去其授予的訪問權限。",
    create_permission_placeholder: "讀取預約歷史",
    permission: "權限",
    permission_other: "權限",
    organization_role: "組織角色",
    organization_role_other: "組織角色",
    organization_role_description: "組織角色是可以分配給用戶的權限的分組。權限必須來自預定義的組織權限。",
    organization_role_delete_confirm: "這樣將從受影響的用戶身上刪除與此角色關聯的權限，並刪除組織角色、組織成員和組織權限之間的關係。",
    role: "角色",
    create_role_placeholder: "僅擁有檢視權限的用戶",
    search_placeholder: "按組織名稱或 ID 搜索",
    search_permission_placeholder: "輸入並搜索選擇權限",
    search_role_placeholder: "輸入並搜索選擇角色",
    empty_placeholder: "\uD83E\uDD14 你尚未設置任何 {{entity}}。",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "開始使用指南",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "交互示意圖，看看它們之間的關係",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "第 1 步：定義組織權限",
        step_2: "第 2 步：定義組織角色",
        step_3: "第 3 步：創建您的第一個組織",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $4ecf06c797d8f826$export$2e2bcd8739ae039 = Object.freeze($4ecf06c797d8f826$var$organizations);


const $be1a8cd10e60357a$var$permissions = {
    search_placeholder: "通過 API 或權限名稱搜索",
    search_placeholder_without_api: "通過權限名稱搜索",
    name_column: "權限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "權限",
    placeholder_description: "權限是指訪問資源的授權（我們稱其為 API 資源）。"
};
var $be1a8cd10e60357a$export$2e2bcd8739ae039 = Object.freeze($be1a8cd10e60357a$var$permissions);


const $d2fda6cb0d8edd39$var$profile = {
    page_title: "賬戶管理",
    title: "賬戶管理",
    description: "在這裡，你可以修改賬戶設置和管理個人信息，以確保賬戶安全。",
    settings: {
        title: "賬戶設置",
        profile_information: "個人信息",
        avatar: "頭像",
        name: "姓名",
        username: "用戶名"
    },
    link_account: {
        title: "關聯賬戶",
        email_sign_in: "郵件登錄",
        email: "郵件",
        social_sign_in: "社交賬號登錄",
        link_email: "綁定郵箱",
        link_email_subtitle: "綁定郵箱以便登錄或幫助恢復賬戶。",
        email_required: "郵箱不能為空",
        invalid_email: "無效的郵箱地址",
        identical_email_address: "輸入的郵箱地址與當前郵箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密碼與安全",
        password: "密碼",
        password_setting: "密碼設置",
        new_password: "新密碼",
        confirm_password: "確認密碼",
        enter_password: "輸入當前密碼",
        enter_password_subtitle: "為確保帳戶安全，在修改密碼前，請先輸入當前密碼以通過身份驗證。",
        set_password: "設置密碼",
        verify_via_password: "通過密碼驗證",
        show_password: "顯示密碼",
        required: "密碼不能為空",
        do_not_match: "密碼不匹配，請重新輸入。"
    },
    code: {
        enter_verification_code: "輸入驗證碼",
        enter_verification_code_subtitle: "驗證碼已發送至 <strong>{{target}}</strong>",
        verify_via_code: "通過郵箱驗證碼驗證",
        resend: "重新發送驗證碼",
        resend_countdown: "在 {{countdown}} 秒後重新發送"
    },
    delete_account: {
        title: "刪除賬戶",
        label: "刪除賬戶",
        description: "刪除賬戶將會刪除所有個人信息、用戶數據和配置。此操作無法撤銷。",
        button: "刪除賬戶",
        dialog_paragraph_1: "很抱歉聽到你想要刪除你的帳戶。刪除你的帳戶將永久刪除所有數據，包括用戶信息、日誌和設置，此操作無法撤銷。因此，請確保在繼續之前備份任何重要數據。",
        dialog_paragraph_2: "要繼續刪除帳戶的刪除過程，請通過 <a>mail</a> 向我們的支持團隊發送主題為“帳戶刪除請求”的郵件。我們將協助你並確保所有數據都已從我們的系統中正確刪除。",
        dialog_paragraph_3: "感謝你選擇 Logto Cloud。如果你有任何進一步的問題或疑慮，請隨時與我們聯繫。"
    },
    set: "設置",
    change: "修改",
    link: "關聯",
    unlink: "取消關聯",
    not_set: "未設置",
    change_avatar: "修改頭像",
    change_name: "修改姓名",
    change_username: "修改用戶名",
    set_name: "設置姓名",
    email_changed: "已成功綁定郵箱。",
    password_changed: "已重置密碼。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}賬號綁定成功。",
    unlinked: "{{target}}賬號解綁成功。",
    email_exists_reminder: "該郵箱 {{email}} 已被其他賬號綁定，請更換郵箱。",
    unlink_confirm_text: "確定解綁",
    unlink_reminder: "解綁後，用戶將無法使用該 <span></span> 賬號進行登錄。確定要解綁嗎？"
};
var $d2fda6cb0d8edd39$export$2e2bcd8739ae039 = Object.freeze($d2fda6cb0d8edd39$var$profile);


const $1fdb38d7c2effcf9$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "標識符",
    delete_description: "這樣做將從受影響的用戶中刪除與該角色關聯的權限，並刪除角色、用戶和權限之間的映射關聯。",
    role_deleted: "{{name}} 已成功刪除。",
    settings_tab: "設置",
    users_tab: "用戶",
    m2m_apps_tab: "機器對機器應用",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "角色是一組權限，可以分配給用戶。它們還提供了一種聚合不同 API 定義的權限的方法，使得添加、刪除或調整權限比將其單獨分配給用戶更有效率。",
    field_name: "名稱",
    field_description: "描述",
    type_m2m_role_tag: "機器對機器應用角色",
    type_user_role_tag: "用戶角色",
    permission: {
        assign_button: "分配權限",
        assign_title: "分配權限",
        assign_subtitle: "將權限分配給此角色。角色將獲得添加的權限，具有此角色的用戶將繼承這些權限。",
        assign_form_field: "分配權限",
        added_text_one: "添加了 {{count, number}} 個權限",
        added_text_other: "添加了 {{count, number}} 個權限",
        api_permission_count_one: "{{count, number}} 個權限",
        api_permission_count_other: "{{count, number}} 個權限",
        confirm_assign: "分配權限",
        permission_assigned: "所選的權限已成功分配給此角色",
        deletion_description: "如果刪除此權限，則具有此角色的受影響用戶將失去此權限授予的訪問權限。",
        permission_deleted: "權限 {{name}} 已成功從此角色中刪除",
        empty: "無可用權限"
    },
    users: {
        assign_button: "分配用戶",
        name_column: "用戶",
        app_column: "應用",
        latest_sign_in_column: "最近登錄",
        delete_description: "它將保留在你的用戶池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配用戶",
        assign_subtitle: "將用戶分配給此角色。通過搜索名稱、電子郵件、電話或用戶 ID 查找適當的用戶。",
        assign_field: "分配用戶",
        confirm_assign: "分配用戶",
        assigned_toast_text: "所選的用戶已成功分配給此角色",
        empty: "無可用用戶"
    },
    applications: {
        assign_button: "分配應用",
        name_column: "應用",
        app_column: "應用",
        description_column: "描述",
        delete_description: "它將保留在您的應用池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配應用",
        assign_subtitle: "將應用分配給此角色。通過搜索名稱、描述或應用 ID 查找適當的應用。",
        assign_field: "分配應用",
        confirm_assign: "分配應用",
        assigned_toast_text: "所選的應用已成功分配給此角色",
        empty: "無可用應用"
    }
};
var $1fdb38d7c2effcf9$export$2e2bcd8739ae039 = Object.freeze($1fdb38d7c2effcf9$var$role_details);


const $f41dc0c2916b85bd$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一種訪問控制方法，它使用角色來決定用戶可以做什麼事情，包括授予用戶訪問特定資源的權限。",
    create: "創建角色",
    role_name: "角色名稱",
    role_type: "角色類型",
    show_role_type_button_text: "顯示更多選項",
    hide_role_type_button_text: "隱藏更多選項",
    type_user: "用戶角色",
    type_machine_to_machine: "機器到機器應用程式角色",
    role_description: "描述",
    role_name_placeholder: "輸入你的角色名稱",
    role_description_placeholder: "輸入你的角色描述",
    col_roles: "角色",
    col_type: "類型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 位用戶",
    application_counts: "{{count}} 個應用程式",
    user_count: "{{count}} 位用戶",
    application_count: "{{count}} 個應用程式",
    assign_permissions: "分配權限",
    create_role_title: "創建角色",
    create_role_description: "為你的應用程式創建和管理角色。角色包含權限集合，並可以分配給用戶。",
    create_role_button: "創建角色",
    role_created: "角色 {{name}} 已成功創建。",
    search: "按角色名稱、描述或 ID 搜索",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配給用戶的權限分組。在創建角色之前，請確保先添加權限。"
};
var $f41dc0c2916b85bd$export$2e2bcd8739ae039 = Object.freeze($f41dc0c2916b85bd$var$roles);


const $16e40d6f3aa37494$var$session_expired = {
    title: "會話已過期",
    subtitle: "會話可能已過期，你已被退出登錄。請點擊下方按鈕重新登錄到管理控制台。",
    button: "重新登錄"
};
var $16e40d6f3aa37494$export$2e2bcd8739ae039 = Object.freeze($16e40d6f3aa37494$var$session_expired);


const $df2383e7241e8f65$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $df2383e7241e8f65$export$2e2bcd8739ae039 = Object.freeze($df2383e7241e8f65$var$content);


const $a0e82eb8e21e8843$var$password_policy = {
    password_requirements: "密碼要求",
    minimum_length: "最小長度",
    minimum_length_description: "NIST 建議在 Web 產品中使用至少 8 個字符。",
    minimum_length_error: "最小長度必須介於{{min}}和{{max}}之間（包括{{min}}和{{max}}）。",
    minimum_required_char_types: "最小所需字符類型",
    minimum_required_char_types_description: "字符類型：大寫字母（A-Z）、小寫字母（a-z）、數字（0-9）和特殊符號（{{symbols}}）。",
    password_rejection: "密碼拒絕設置",
    compromised_passwords: "拒絕被破解的密碼",
    breached_passwords: "洩露的密碼",
    breached_passwords_description: "拒絕之前在洩露數據庫中出現的密碼。",
    restricted_phrases: "限制低安全性短語",
    restricted_phrases_tooltip: "密碼應該避免使用這些短語，除非結合至少 3 個或更多的額外字符。",
    repetitive_or_sequential_characters: "重複或連續字符",
    repetitive_or_sequential_characters_description: '例如："AAAA"、"1234"和"abcd"。',
    user_information: "用戶信息",
    user_information_description: "例如：郵件地址、電話號碼、用戶名等等。",
    custom_words: "自定義詞彙",
    custom_words_description: "個性化上下文特定的詞彙，不區分大小寫，每行一個詞。",
    custom_words_placeholder: "您的服務名稱、公司名稱等等。"
};
var $a0e82eb8e21e8843$export$2e2bcd8739ae039 = Object.freeze($a0e82eb8e21e8843$var$password_policy);


const $60c2f84f0cbf4365$var$sign_up_and_sign_in = {
    identifiers_email: "郵件地址",
    identifiers_phone: "手機號碼",
    identifiers_username: "用戶名",
    identifiers_email_or_sms: "郵件地址或手機號碼",
    identifiers_none: "無",
    and: "與",
    or: "或",
    sign_up: {
        title: "註冊",
        sign_up_identifier: "註冊標識",
        identifier_description: "創建帳戶時你需要設定註冊標識。這些信息在用戶登錄時，屬於必選項。",
        sign_up_authentication: "註冊身份認證設置",
        authentication_description: "註冊時，你的用戶將要完成以下所有勾選的任務。",
        set_a_password_option: "創建密碼",
        verify_at_sign_up_option: "註冊時驗證身份",
        social_only_creation_description: "（僅對社交註冊用戶適用）"
    },
    sign_in: {
        title: "登錄",
        sign_in_identifier_and_auth: "登錄標識和身份認證設置",
        description: "用戶可以使用任何可用的選項進行登錄。拖拽選項即可調整頁面佈局。",
        add_sign_in_method: "添加登錄方式",
        password_auth: "密碼",
        verification_code_auth: "驗證碼",
        auth_swap_tip: "交換以下選項的位置即可設定它們在用戶登錄流程中出現的先後。",
        require_auth_factor: "請至少選擇一種認證方式。"
    },
    social_sign_in: {
        title: "社交登錄",
        social_sign_in: "社交登錄",
        description: "你已設定特定的標識。用戶在通過社交連接器註冊時可能會被要求提供一個對應的標識。",
        add_social_connector: "添加社交連接器",
        set_up_hint: {
            not_in_list: "沒有你想要的連接器？",
            set_up_more: "立即設置",
            go_to: "其他社交連接器。"
        }
    },
    tip: {
        set_a_password: "啟用用戶名註冊，必須設置密碼。",
        verify_at_sign_up: "我們目前僅支持經過驗證的郵件地址登錄。如果沒有驗證，你的用戶信息中可能出現大量無效電子郵件地址。",
        password_auth: "因註冊設置裏你啟用了用戶名密碼標識。這個信息在用戶登錄時，屬於必選項。",
        verification_code_auth: "因註冊設置裏你啟用了驗證碼標識，驗證碼屬於用戶必選項。開啟密碼註冊後，你可以選擇關閉驗證碼登錄。",
        delete_sign_in_method: "因註冊設置裏你啟用了{{identifier}}標識。這些信息在用戶登錄時，屬於必選項。"
    },
    advanced_options: {
        title: "進階選項",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "啟用用戶註冊",
        enable_user_registration_description: "啟用或禁止用戶註冊。禁用後，管理控制台仍然可以添加用戶，但用戶無法通過登錄界面建立帳戶。"
    }
};
var $60c2f84f0cbf4365$export$2e2bcd8739ae039 = Object.freeze($60c2f84f0cbf4365$var$sign_up_and_sign_in);


const $11ec2fcdc10e9906$var$sign_in_exp = {
    page_title: "登錄體驗",
    title: "登錄體驗",
    description: "自定義登錄界面，並實時預覽真實效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "註冊與登錄",
        content: "內容",
        password_policy: "密碼政策"
    },
    welcome: {
        title: "自定義登錄體驗",
        description: "通過首次登錄設置快速入門。本指南將帶領您完成所有必要的設置。",
        get_started: "開始",
        apply_remind: "請注意，登錄體驗將會應用到當前帳戶下的所有應用。"
    },
    color: {
        title: "顏色",
        primary_color: "品牌顏色",
        dark_primary_color: "品牌顏色 (深色)",
        dark_mode: "開啟深色模式",
        dark_mode_description: "基於品牌顏色和 Logto 的算法，應用將會有一個自動生成的深色模式。當然，您可以自定義和修改。",
        dark_mode_reset_tip: "基於品牌顏色，重新生成深色模式顏色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制區",
        ui_style: "樣式",
        favicon: "瀏覽器地址欄圖標",
        logo_image_url: "Logo 圖片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 圖片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 圖片",
        dark_logo_image: "Logo 圖片(深色)",
        logo_image_error: "應用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定義 CSS",
        css_code_editor_title: "自定義 CSS 個性化您的用戶界面",
        css_code_editor_description1: "查看自定義 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "輸入 CSS 代碼，修改顏色、字體、組件樣式、佈局，定制您的登錄、註冊、忘記密碼等頁面。充分發揮創造力，讓您的用戶界面脫穎而出。"
    },
    sign_up_and_sign_in: $60c2f84f0cbf4365$export$2e2bcd8739ae039,
    content: $df2383e7241e8f65$export$2e2bcd8739ae039,
    password_policy: $a0e82eb8e21e8843$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未設置 SMS 短信連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_email: "尚未設置電子郵件連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_social: "您還沒有設置任何社交連接器。首先添加連接器以應用社交登錄方法。<a>{{link}}</a>連接器。",
        setup_link: "立即設置"
    },
    save_alert: {
        description: "您正在進行登錄註冊設置的變更。當前您的所有用戶會受到新設置的影響。確認保存該設置嗎？",
        before: "設置前",
        after: "設置後",
        sign_up: "註冊",
        sign_in: "登錄",
        social: "社交"
    },
    preview: {
        title: "登錄預覽",
        live_preview: "實時預覽",
        live_preview_tip: "保存以預覽更改",
        native: "移動原生",
        desktop_web: "桌面網頁",
        mobile_web: "移動網頁",
        desktop: "桌面網頁",
        mobile: "移動設備"
    }
};
var $11ec2fcdc10e9906$export$2e2bcd8739ae039 = Object.freeze($11ec2fcdc10e9906$var$sign_in_exp);


const $09be8e101cfd4b87$var$quota_item = {
    tenant_limit: {
        name: "租戶",
        limited: "{{count, number}} 個租戶",
        limited_other: "{{count, number}} 個租戶",
        unlimited: "無限租戶",
        not_eligible: "刪除您的租戶"
    },
    mau_limit: {
        name: "月活躍用戶",
        limited: "{{count, number}} 個月活躍用戶",
        unlimited: "無限月活躍用戶",
        not_eligible: "刪除您的所有用戶"
    },
    applications_limit: {
        name: "應用程式",
        limited: "{{count, number}} 個應用程式",
        limited_other: "{{count, number}} 個應用程式",
        unlimited: "無限應用程式",
        not_eligible: "刪除您的應用程式"
    },
    machine_to_machine_limit: {
        name: "機器至機器應用程式",
        limited: "{{count, number}} 個機器至機器應用程式",
        limited_other: "{{count, number}} 個機器至機器應用程式",
        unlimited: "無限機器至機器應用程式",
        not_eligible: "刪除您的機器至機器應用程式"
    },
    resources_limit: {
        name: "API 資源",
        limited: "{{count, number}} 個 API 資源",
        limited_other: "{{count, number}} 個 API 資源",
        unlimited: "無限 API 資源",
        not_eligible: "刪除您的 API 資源"
    },
    scopes_per_resource_limit: {
        name: "資源權限",
        limited: "{{count, number}} 個資源權限",
        limited_other: "{{count, number}} 個資源權限",
        unlimited: "無限資源權限",
        not_eligible: "刪除您的資源權限"
    },
    custom_domain_enabled: {
        name: "自定義網域",
        limited: "自定義網域",
        unlimited: "自定義網域",
        not_eligible: "刪除您的自定義網域"
    },
    omni_sign_in_enabled: {
        name: "全渠道登入",
        limited: "全渠道登入",
        unlimited: "全渠道登入",
        not_eligible: "停用全渠道登入"
    },
    built_in_email_connector_enabled: {
        name: "內建電子郵件連接器",
        limited: "內建電子郵件連接器",
        unlimited: "內建電子郵件連接器",
        not_eligible: "刪除您的內建電子郵件連接器"
    },
    social_connectors_limit: {
        name: "社交連接器",
        limited: "{{count, number}} 個社交連接器",
        limited_other: "{{count, number}} 個社交連接器",
        unlimited: "無限社交連接器",
        not_eligible: "刪除您的社交連接器"
    },
    standard_connectors_limit: {
        name: "免費標準連接器",
        limited: "{{count, number}} 個免費標準連接器",
        limited_other: "{{count, number}} 個免費標準連接器",
        unlimited: "無限標準連接器",
        not_eligible: "刪除您的標準連接器"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 個角色",
        limited_other: "{{count, number}} 個角色",
        unlimited: "無限角色",
        not_eligible: "刪除您的角色"
    },
    scopes_per_role_limit: {
        name: "角色權限",
        limited: "{{count, number}} 個角色權限",
        limited_other: "{{count, number}} 個角色權限",
        unlimited: "無限角色權限",
        not_eligible: "刪除您的角色權限"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}} 個 Webhook",
        limited_other: "{{count, number}} 個 Webhooks",
        unlimited: "無限制的 Webhooks",
        not_eligible: "移除您的 Webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "審計日誌保留",
        limited: "審計日誌保留：{{count, number}} 天",
        limited_other: "審計日誌保留：{{count, number}} 天",
        unlimited: "無限天數",
        not_eligible: "無審計日誌"
    },
    community_support_enabled: {
        name: "社區支援",
        limited: "社區支援",
        unlimited: "社區支援",
        not_eligible: "無社區支援"
    },
    customer_ticket_support: {
        name: "客戶工單支援",
        limited: "{{count, number}} 小時客戶工單支援",
        limited_other: "{{count, number}} 小時客戶工單支援",
        unlimited: "客戶工單支援",
        not_eligible: "無客戶工單支援"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "停用你的 MFA"
    },
    sso_enabled: {
        name: "企業SSO",
        limited: "企業SSO",
        unlimited: "企業SSO",
        not_eligible: "禁用你的企業SSO"
    }
};
var $09be8e101cfd4b87$export$2e2bcd8739ae039 = Object.freeze($09be8e101cfd4b87$var$quota_item);


const $34328e98c7d3abcb$var$quota_table = {
    quota: {
        title: "配額",
        tenant_limit: "租戶限制",
        base_price: "基本價格",
        mau_unit_price: "* 每月活躍用戶（MAU）單價",
        mau_limit: "MAU 限制"
    },
    application: {
        title: "應用程式",
        total: "應用程式總數",
        m2m: "機器到機器"
    },
    resource: {
        title: "API 資源",
        resource_count: "資源數量",
        scopes_per_resource: "每資源權限"
    },
    branding: {
        title: "用戶界面與品牌",
        custom_domain: "自訂網域",
        custom_css: "自訂 CSS",
        app_logo_and_favicon: "應用程式徽標和網站圖示",
        dark_mode: "深色模式",
        i18n: "國際化"
    },
    user_authn: {
        title: "用戶認證",
        omni_sign_in: "全渠道登錄",
        password: "密碼",
        passwordless: "免密碼登錄 - 電子郵件和短信",
        email_connector: "電子郵件連接器",
        sms_connector: "短信連接器",
        social_connectors: "社交連接器",
        standard_connectors: "標準連接器",
        built_in_email_connector: "內置電子郵件連接器",
        mfa: "MFA",
        sso: "企業 SSO"
    },
    user_management: {
        title: "用戶管理",
        user_management: "用戶管理",
        roles: "角色",
        scopes_per_role: "每角色權限"
    },
    audit_logs: {
        title: "審核日誌",
        retention: "保留期限"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "組織",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "支援",
        community: "社群",
        customer_ticket: "客戶支援票據",
        premium: "高級版"
    },
    mau_unit_price_footnote: "* 您的每月活躍用戶（MAU）將根據在結算週期內登錄的頻率分為3個層級。每個層級都有不同的MAU單價。",
    unlimited: "無限制",
    contact: "聯絡",
    monthly_price: "${{value, number}}/月",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}}天",
    days_other: "{{count, number}}天",
    add_on: "附加功能",
    tier: "層級{{value, number}}："
};
var $34328e98c7d3abcb$export$2e2bcd8739ae039 = Object.freeze($34328e98c7d3abcb$var$quota_table);


const $4d9051cab71f5a3a$var$subscription = {
    free_plan: "免費計劃",
    free_plan_description: "用於側建項目和Logto初試。無需信用卡。",
    hobby_plan: "愛好計劃",
    hobby_plan_description: "適用於個人開發者或小型工程團隊。",
    pro_plan: "專業計劃",
    pro_plan_description: "供企業放心使用Logto。",
    enterprise: "企業",
    current_plan: "當前計劃",
    current_plan_description: "以下是您目前的計劃。您可以輕鬆查看計劃使用情況，檢查即將到來的帳單，並根據需要進行變更。",
    plan_usage: "計劃使用情況",
    plan_cycle: "計劃週期：{{period}}。使用情況將在{{renewDate}}重新啟動。",
    next_bill: "您的下個帳單",
    next_bill_hint: "要了解有關計算的更多信息，請參閱這篇<a>文章</a>。",
    next_bill_tip: "您即將到來的帳單包括下個月計劃的基本價格，以及各個層級中MAU單價乘以您使用量的成本。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已達到配額限制。請升級計劃以防止任何問題。",
    upgrade_pro: "升級到專業版",
    update_payment: "更新付款信息",
    payment_error: "檢測到付款問題。無法處理前一個週期的$ {{price, number}}。更新付款以避免Logto服務暫停。",
    downgrade: "降級",
    current: "當前",
    upgrade: "升級",
    quota_table: $34328e98c7d3abcb$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "發票",
        status_column: "狀態",
        amount_column: "金額",
        invoice_created_date_column: "發票創建日期",
        invoice_status: {
            void: "已取消",
            paid: "已付款",
            open: "未結算",
            uncollectible: "逾期未付款"
        }
    },
    quota_item: $09be8e101cfd4b87$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "確定要降級嗎？",
        description: "如果您選擇切換到<targetName/>，請注意您將不再能夠訪問以前在<currentName/>中的配額和功能。",
        before: "之前：<name/>",
        after: "之後：<name/>",
        downgrade: "降級"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降級條件",
        downgrade_description: "降級到<name/>前，請確保符合以下條件。",
        downgrade_help_tip: "需要降級幫助？<a>聯絡我們</a>。",
        upgrade_title: "致尊敬的早期採用者的友善提醒",
        upgrade_description: "您目前的使用量超過了 <name /> 允許的範圍。Logto 現已正式發布，包括針對每個計劃量身定制的功能。在考慮升級到 <name /> 之前，請確保您符合以下升級條件。",
        upgrade_pro_tip: " 或者考慮升級到專業版計劃。",
        upgrade_help_tip: "需要升級幫助？<a>聯絡我們</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "升級成功至<name/>",
    downgrade_success: "成功降級至<name/>",
    subscription_check_timeout: "訂閱檢查已逾時，請稍後重新刷新。",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $4d9051cab71f5a3a$export$2e2bcd8739ae039 = Object.freeze($4d9051cab71f5a3a$var$subscription);


const $311df9d9219d617c$var$tab_sections = {
    overview: "概觀",
    resources: "資源",
    users: "使用者",
    access_control: "訪問控制",
    help_and_support: "幫助與支援",
    tenant: "租戶",
    automation: "自動化"
};
var $311df9d9219d617c$export$2e2bcd8739ae039 = Object.freeze($311df9d9219d617c$var$tab_sections);


const $13c8010b412cf2b3$var$tabs = {
    get_started: "開始上手",
    dashboard: "儀表板",
    applications: "全部應用",
    api_resources: "API 資源",
    sign_in_experience: "登錄體驗",
    connectors: "連接器",
    enterprise_sso: "企業SSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "用戶管理",
    audit_logs: "審計日誌",
    roles: "角色",
    docs: "文檔",
    tenant_settings: "租戶設置",
    mfa: "多重認證"
};
var $13c8010b412cf2b3$export$2e2bcd8739ae039 = Object.freeze($13c8010b412cf2b3$var$tabs);


const $19b59c57aca45c74$var$tenants = {
    title: "設置",
    description: "高效管理租戶設置並自訂您的域名。",
    tabs: {
        settings: "設定",
        domains: "網域",
        subscription: "方案與計費",
        billing_history: "帳單記錄"
    },
    settings: {
        title: "設定",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "租户ID",
        tenant_name: "租户名称",
        tenant_region: "數據托管區域",
        tenant_region_tip: "您的租戶資源托管在{{region}}。 <a>了解更多</a>",
        environment_tag_development: "開發",
        environment_tag_staging: "預備",
        environment_tag_production: "產品",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "租戶信息成功保存。"
    },
    full_env_tag: {
        development: "開發",
        production: "生產"
    },
    deletion_card: {
        title: "刪除",
        tenant_deletion: "刪除租戶",
        tenant_deletion_description: "刪除租戶將導致永久刪除所有相關的用戶數據和配置。請謹慎操作。",
        tenant_deletion_button: "刪除租戶"
    },
    create_modal: {
        title: "創建租戶",
        subtitle: "創建一個具有隔離資源和用戶的新租戶。數據托管的區域和租戶類型在創建後無法修改。",
        tenant_usage_purpose: "您希望使用此租戶做什麼？",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "可用方案：",
        create_button: "創建租戶",
        tenant_name_placeholder: "我的租戶"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "刪除租戶",
        description_line1: '您確定要刪除標有環境標識"<span>{{tag}}</span>"的"<span>{{name}}</span>"租戶嗎？此操作無法撤銷，並會永久刪除您的所有數據和帳戶信息。',
        description_line2: "在刪除帳戶之前，也許我們可以為您提供幫助。<span><a>通過電子郵件與我們聯繫</a></span>",
        description_line3: '如果您確定要繼續，請輸入租戶名稱"<span>{{name}}</span>"以進行確認。',
        delete_button: "永久刪除",
        cannot_delete_title: "無法刪除此租戶",
        cannot_delete_description: "抱歉，您現在無法刪除此租戶。請確保您處於免費計劃並已支付所有未結賬單。"
    },
    tenant_landing_page: {
        title: "您尚未建立租戶",
        description: "要開始使用 Logto 配置您的項目，請創建一個新的租戶。如果您需要退出或刪除您的帳戶，只需單擊右上角的頭像按鈕。",
        create_tenant_button: "創建租戶"
    },
    status: {
        mau_exceeded: "超出 MAU 限制",
        suspended: "已暫停",
        overdue: "逾期未付款"
    },
    tenant_suspended_page: {
        title: "租戶已暫停。請聯繫我們恢復訪問。",
        description_1: "很遺憾地通知您，由於不當使用（包括超出 MAU 限制、逾期付款或其他未經授權的操作等），您的租戶帳戶已被暫時停用。",
        description_2: "如果您需要進一步了解，有任何疑慮或希望恢復完整功能並解鎖您的租戶，請立即與我們聯繫。"
    },
    signing_keys: {
        title: "簽署金鑰",
        description: "在您的租戶中安全地管理簽署金鑰。",
        type: {
            private_key: "OIDC私密金鑰",
            cookie_key: "OIDC Cookie金鑰"
        },
        private_keys_in_use: "正在使用的私密金鑰",
        cookie_keys_in_use: "正在使用的 Cookie 金鑰",
        rotate_private_keys: "旋轉私密金鑰",
        rotate_cookie_keys: "旋轉 Cookie 金鑰",
        rotate_private_keys_description: "此操作將創建一個新的私密簽署金鑰，旋轉當前金鑰並刪除以前的金鑰。您的使用當前金鑰簽署的 JWT 標記將保持有效，直到刪除或再次旋轉。",
        rotate_cookie_keys_description: "此操作將創建一個新的 cookie 金鑰，旋轉當前金鑰並刪除以前的金鑰。使用當前金鑰簽署的 cookie 將保持有效，直到刪除或再次旋轉。",
        select_private_key_algorithm: "選擇新私密金鑰的簽署算法",
        rotate_button: "旋轉",
        table_column: {
            id: "ID",
            status: "狀態",
            algorithm: "簽署金鑰算法"
        },
        status: {
            current: "當前",
            previous: "之前"
        },
        reminder: {
            rotate_private_key: "您確定要旋轉<strong>OIDC私密金鑰</strong>嗎？使用新金鑰發放的 JWT 標記將由新金鑰簽署。使用當前金鑰簽署的 JWT 標記將保持有效，直到您再次旋轉。",
            rotate_cookie_key: "您確定要旋轉<strong>OIDC Cookie金鑰</strong>嗎？在登錄會話中生成的新 cookie 將由新cookie金鑰簽署。使用當前金鑰簽署的 cookie 將保持有效，直到您再次旋轉。",
            delete_private_key: "您確定要刪除<strong>OIDC私密金鑰</strong>嗎？使用此私密簽署金鑰簽署的現有 JWT 標記將不再有效。",
            delete_cookie_key: "您確定要刪除<strong>OIDC Cookie金鑰</strong>嗎？使用此 cookie 金鑰簽署的較舊的登錄會話中的 cookie 不再有效，這些用戶需要重新驗證。"
        },
        messages: {
            rotate_key_success: "簽署金鑰成功旋轉。",
            delete_key_success: "金鑰成功刪除。"
        }
    }
};
var $19b59c57aca45c74$export$2e2bcd8739ae039 = Object.freeze($19b59c57aca45c74$var$tenants);


const $da04452fad57c02e$var$topbar = {
    docs: "文件",
    help: "幫助"
};
var $da04452fad57c02e$export$2e2bcd8739ae039 = Object.freeze($da04452fad57c02e$var$topbar);


const $bcd1f5c05abc5da1$var$paywall = {
    applications: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    applications_other: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_feature: "升級至<strong>Hobby</strong>方案，解鎖 1 個機器對機器應用程式，或選擇<strong>Pro</strong>方案以獲得無限使用。如需要協助，歡迎<a>聯繫我們</a>。",
    machine_to_machine: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_other: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    resources: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    resources_other: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    scopes_per_resource: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_resource_other: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    custom_domain: "升級至<strong>Hobby</strong>或<strong>Pro</strong>方案以解鎖自定義域功能。如需要任何協助，歡迎<a>聯繫我們</a>。",
    social_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    social_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_feature: "升級至<strong>Hobby</strong>或<strong>Pro</strong>計劃，使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器，無限制的社交連接器以及所有高級功能。如需任何協助，歡迎<a>聯繫我們</a>。",
    standard_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_pro: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，歡迎<a>聯繫我們</a>。",
    standard_connectors_pro_other: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何協助，歡迎<a>聯繫我們</a>。",
    roles: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯繫我們</a>。",
    roles_other: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯繫我們</a>。",
    scopes_per_role: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯繫我們</a>。",
    scopes_per_role_other: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何協助，歡迎<a>聯繫我們</a>。",
    hooks: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何協助，歡迎<a>聯繫我們</a>。",
    hooks_other: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯繫我們</a>。",
    mfa: "升級到付費計劃以解鎖MFA以提高安全性。如果需要任何協助，請隨時<a>聯繫我們</a>。",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $bcd1f5c05abc5da1$export$2e2bcd8739ae039 = Object.freeze($bcd1f5c05abc5da1$var$paywall);


const $2e7461650c7a8f09$var$upsell = {
    upgrade_plan: "升級計劃",
    compare_plans: "比較計劃",
    view_plans: "查看計劃",
    create_tenant: {
        title: "選擇您的租戶計劃",
        description: "Logto 提供創新且經濟實惠的定價計劃，旨在為不斷發展的公司提供競爭優勢。 <a>了解更多</a>",
        base_price: "基礎價格",
        monthly_price: "每月 {{value, number}}",
        mau_unit_price: "MAU 單價",
        view_all_features: "查看所有功能",
        select_plan: "選擇<name/>",
        free_tenants_limit: "最多{{count, number}}個免費租戶",
        free_tenants_limit_other: "最多{{count, number}}個免費租戶",
        most_popular: "最受歡迎",
        upgrade_success: "成功升級至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超過限制，請升級您的計劃。",
        notification: "您當前的 MAU 已超過<planName/>的限制。請立即升級到高級計劃，以避免 Logto 服務的暫停。",
        update_plan: "更新計劃"
    },
    payment_overdue_modal: {
        title: "賬單逾期未付",
        notification: "糟糕！租戶<span>{{name}}</span>的賬單支付失敗。請儘快支付賬單，以避免Logto服務中止。",
        unpaid_bills: "未付賬單",
        update_payment: "更新支付"
    },
    paywall: $bcd1f5c05abc5da1$export$2e2bcd8739ae039
};
var $2e7461650c7a8f09$export$2e2bcd8739ae039 = Object.freeze($2e7461650c7a8f09$var$upsell);


const $c6a9c80f76846d2a$var$user_details = {
    page_title: "用戶詳情",
    back_to_users: "返回用戶管理",
    created_title: "用戶創建成功",
    created_guide: "這是用戶登錄過程中的信息。",
    created_email: "電子郵箱地址：",
    created_phone: "手機號碼：",
    created_username: "用戶名：",
    created_password: "密碼：",
    menu_delete: "刪除用戶",
    delete_description: "本操作將永久刪除該用戶，且無法撤銷。",
    deleted: "用戶已成功刪除。",
    reset_password: {
        reset_password: "重置密碼",
        title: "確定要重置密碼？",
        content: "本操作不可撤銷，將會重置用戶的登錄信息。",
        congratulations: "該用戶已被重置",
        new_password: "新密碼："
    },
    tab_settings: "設置",
    tab_roles: "角色",
    tab_logs: "用戶日誌",
    tab_organizations: "組織",
    authentication: "驗證",
    authentication_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。",
    user_profile: "用戶資料",
    field_email: "電子郵箱",
    field_phone: "手機號碼",
    field_username: "用戶名",
    field_name: "姓名",
    field_avatar: "頭像圖片鏈接",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定義數據",
    field_custom_data_tip: "預設屬性之外的用戶信息，例如用戶偏好的顏色和語言。",
    field_connectors: "社交帳號",
    field_sso_connectors: "企業連接",
    custom_data_invalid: "自定義數據必須是有效的 JSON 對象",
    connectors: {
        connectors: "連接器",
        user_id: "用戶 ID",
        remove: "刪除",
        connected: "此用戶已連接多個社交連接器。",
        not_connected: "該用戶還沒有綁定社交帳號",
        deletion_confirmation: "您正在刪除現有的<name/>身份。你確定要繼續嗎？"
    },
    sso_connectors: {
        connectors: "連接器",
        enterprise_id: "企業 ID",
        connected: "此用戶已連接到多個企業身份提供者以進行單點登錄。",
        not_connected: "該用戶未連接到任何企業身份提供者以進行單點登錄。"
    },
    mfa: {
        field_name: "多重因素驗證",
        field_description: "這個使用者已啟用 2 步驗證因素。",
        name_column: "多重因素驗證",
        field_description_empty: "此用戶尚未啟用兩步驟身份驗證因素。",
        deletion_confirmation: "您正在刪除現有的雙步驗證中的 <name/>。你確定要繼續嗎？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用戶",
    suspend_user_reminder: "你確定要禁用該用戶？該用戶將無法登錄您的應用程序，並在當前令牌過期後將無法獲取新的訪問令牌。此外，該用戶發出的任何 API 請求都將失敗。",
    suspend_action: "禁用",
    user_suspended: "用戶已被臨時禁用。",
    reactivate_user: "重新啟用用戶",
    reactivate_user_reminder: "你確定要重新啟用該用戶？這樣做將允許該用戶的任何登錄嘗試。",
    reactivate_action: "重新啟用",
    user_reactivated: "用戶已重新啟用。",
    roles: {
        name_column: "角色名稱",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作將從此用戶中刪除此角色。角色本身仍將存在，但不再與此用戶相關聯。",
        deleted: "已成功從此用戶中刪除 {{name}}。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "為 {{name}} 授權一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "添加了 {{value, number}} 個",
        assigned_user_count: "{{value, number}} 個用戶",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    },
    warning_no_sign_in_identifier: "用戶需要至少擁有一個登錄標識（用戶名、電子郵件、電話號碼或社交帳號）才能登錄。確定要繼續嗎？",
    organization_roles_tooltip: "The roles assigned to the user within this organization."
};
var $c6a9c80f76846d2a$export$2e2bcd8739ae039 = Object.freeze($c6a9c80f76846d2a$var$user_details);


const $c066a92a4e73cfbf$var$users = {
    page_title: "用戶管理",
    title: "用戶管理",
    subtitle: "管理你的用戶，包括創建新用戶，編輯用戶資料，查看用戶日誌，以及重新設置密碼和刪除用戶",
    create: "添加用戶",
    create_subtitle: "至少提供以下其中一個字段以繼續進行。",
    error_missing_identifier: "你必須提供至少一個註冊標識來創建用戶。",
    user_name: "用戶",
    application_name: "註冊應用",
    latest_sign_in: "最後登錄",
    create_form_username: "用戶名",
    create_form_password: "密碼",
    create_form_name: "姓名",
    placeholder_name: "無名氏",
    placeholder_email: "moumingsi@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+852 9123 4567",
    unnamed: "未命名",
    search: "按姓名、電子郵件、電話或用戶名搜索",
    check_user_detail: "查看用戶詳情",
    placeholder_title: "用戶管理",
    placeholder_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。"
};
var $c066a92a4e73cfbf$export$2e2bcd8739ae039 = Object.freeze($c066a92a4e73cfbf$var$users);


const $1f66fadd0b426ec2$var$webhook_details = {
    page_title: "Webhook 詳細資料",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未啟用",
    success_rate: "成功率",
    requests: "24 小時內收到 {{value, number}} 個請求",
    disable_webhook: "停用 webhook",
    disable_reminder: "確定要重新啟用此 webhook？重新啟用後，不會對端點 URL 發送 HTTP 請求。",
    webhook_disabled: "Webhook 已停用。",
    webhook_reactivated: "Webhook 已重新啟用。",
    reactivate_webhook: "重新啟用 webhook",
    delete_webhook: "刪除 webhook",
    deletion_reminder: "您正在刪除此 webhook。刪除後，不會對端點 URL 發送 HTTP 請求。",
    deleted: "Webhook 已成功刪除。",
    settings_tab: "設置",
    recent_requests_tab: "最新請求（24h）",
    settings: {
        settings: "設置",
        settings_description: "Webhooks 允許您即時接收特定事件的更新，通過將 POST 請求發送到您的端點 URL。這使您能夠根據收到的新信息立即採取行動。",
        events: "事件",
        events_description: "選擇 Logto 將發送 POST 請求的觸發事件。",
        name: "名稱",
        endpoint_url: "端點 URL",
        signing_key: "簽名密鑰",
        signing_key_tip: "添加 Logto 提供的秘密金鑰作為請求標題至您的端點，以確保 webhook 負載的真實性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成簽名密鑰",
        regenerate_key_reminder: "是否確定要修改簽名密鑰？重新生成後立即生效。請記得同步在端點中修改簽名密鑰。",
        regenerated: "簽名密鑰已重新生成。",
        custom_headers: "自定義標頭",
        custom_headers_tip: "您可以選擇添加自定義標頭到 webhook 的負載，提供有關事件的更多上下文或元數據。",
        key_duplicated_error: "Key 不能重複。",
        key_missing_error: "必須填寫 Key。",
        value_missing_error: "未填寫值。",
        invalid_key_error: "Key 無效",
        invalid_value_error: "值無效",
        test: "測試",
        test_webhook: "測試您的 webhook",
        test_webhook_description: "配置 webhook，並使用每個選定事件的負載示例進行測試，以驗證正確接收和處理。",
        send_test_payload: "發送測試負載",
        test_result: {
            endpoint_url: "端點URL：{{url}}",
            message: "消息：{{message}}",
            response_status: "響應狀態：{{status, number}}",
            response_body: "響應主體：{{body}}",
            request_time: "請求時間：{{time}}",
            test_success: "向端點發起的 webhook 測試成功。"
        }
    }
};
var $1f66fadd0b426ec2$export$2e2bcd8739ae039 = Object.freeze($1f66fadd0b426ec2$var$webhook_details);


const $1d585706f9e0ffd5$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "創建 Webhooks，輕鬆地接收有關特定事件的實時更新。",
    create: "創建 Webhook",
    events: {
        post_register: "創建新帳戶",
        post_sign_in: "登錄",
        post_reset_password: "重置密碼"
    },
    table: {
        name: "名稱",
        events: "事件",
        success_rate: "成功率（24h）",
        requests: "請求（24h）"
    },
    placeholder: {
        title: "Webhook",
        description: "創建 Webhook 以通過 POST 請求向您的端點 URL 接收實時更新。了解詳情並針對“創建帳戶”、“登錄”和“重置密碼”等事件立即採取行動。",
        create_webhook: "創建 Webhook"
    },
    create_form: {
        title: "創建 Webhook",
        subtitle: "添加 Webhook 以向 endpoint URL 發送 POST 請求，將詳細信息推送到任何用戶事件。",
        events: "事件",
        events_description: "選擇需要 Logto 發送 POST 請求的觸發事件。",
        name: "名稱",
        name_placeholder: "輸入 webhook 名稱",
        endpoint_url: "Endpoint URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "輸入您的端點 URL，當事件發生時向其發送 Webhook 的有效負載。",
        create_webhook: "創建 Webhook",
        missing_event_error: "您必須至少選擇一個事件。"
    },
    webhook_created: "Webhook {{name}} 成功創建。"
};
var $1d585706f9e0ffd5$export$2e2bcd8739ae039 = Object.freeze($1d585706f9e0ffd5$var$webhooks);


const $09d265885b0dc956$var$welcome = {
    title: "歡迎來到管理控制台",
    description: "管理控制台是一個無需代碼操作的應用。你可以用它來管理登錄體驗。讓我們首先創建一個帳號。你可以用它以個人或公司的身份管理 Logto。",
    create_account: "創建帳號"
};
var $09d265885b0dc956$export$2e2bcd8739ae039 = Object.freeze($09d265885b0dc956$var$welcome);


const $4f4be1b6ac7c3e92$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理員",
    system_app: "系統應用",
    menu: $69b1c502a1fd2240$export$2e2bcd8739ae039,
    general: $f80cd8bf5a2b4cd8$export$2e2bcd8739ae039,
    errors: $8ec0c5b929195452$export$2e2bcd8739ae039,
    tab_sections: $311df9d9219d617c$export$2e2bcd8739ae039,
    tabs: $13c8010b412cf2b3$export$2e2bcd8739ae039,
    applications: $bf61efe72a31c729$export$2e2bcd8739ae039,
    application_details: $5d1e57f70e5e41d2$export$2e2bcd8739ae039,
    api_resources: $758a4057f61f4d00$export$2e2bcd8739ae039,
    api_resource_details: $cf559519739484f8$export$2e2bcd8739ae039,
    connectors: $1d6f5038ec6f86e7$export$2e2bcd8739ae039,
    connector_details: $983011aa26dbaa04$export$2e2bcd8739ae039,
    enterprise_sso: $d6b938883daf5c4c$export$2e2bcd8739ae039,
    enterprise_sso_details: $712c80eedf6972cc$export$2e2bcd8739ae039,
    get_started: $0f4f8fd3473fba1a$export$2e2bcd8739ae039,
    users: $c066a92a4e73cfbf$export$2e2bcd8739ae039,
    user_details: $c6a9c80f76846d2a$export$2e2bcd8739ae039,
    contact: $3ed665d3b7d55b66$export$2e2bcd8739ae039,
    sign_in_exp: $11ec2fcdc10e9906$export$2e2bcd8739ae039,
    dashboard: $9a822f4daef7367c$export$2e2bcd8739ae039,
    logs: $60f18d86df0ca7f4$export$2e2bcd8739ae039,
    log_details: $b6f56b46413e2ea1$export$2e2bcd8739ae039,
    session_expired: $16e40d6f3aa37494$export$2e2bcd8739ae039,
    welcome: $09d265885b0dc956$export$2e2bcd8739ae039,
    roles: $f41dc0c2916b85bd$export$2e2bcd8739ae039,
    role_details: $1fdb38d7c2effcf9$export$2e2bcd8739ae039,
    permissions: $be1a8cd10e60357a$export$2e2bcd8739ae039,
    cloud: $7f7a2f07e25c6bf2$export$2e2bcd8739ae039,
    profile: $d2fda6cb0d8edd39$export$2e2bcd8739ae039,
    components: $13e3d05016c3cb84$export$2e2bcd8739ae039,
    webhooks: $1d585706f9e0ffd5$export$2e2bcd8739ae039,
    webhook_details: $1f66fadd0b426ec2$export$2e2bcd8739ae039,
    domain: $5f18b2c1733cc003$export$2e2bcd8739ae039,
    tenants: $19b59c57aca45c74$export$2e2bcd8739ae039,
    topbar: $da04452fad57c02e$export$2e2bcd8739ae039,
    subscription: $4d9051cab71f5a3a$export$2e2bcd8739ae039,
    upsell: $2e7461650c7a8f09$export$2e2bcd8739ae039,
    guide: $415302f3f6f973cc$export$2e2bcd8739ae039,
    mfa: $79c34c235f684789$export$2e2bcd8739ae039,
    organizations: $4ecf06c797d8f826$export$2e2bcd8739ae039,
    organization_details: $bfe600060780414c$export$2e2bcd8739ae039
};
var $4f4be1b6ac7c3e92$export$2e2bcd8739ae039 = Object.freeze($4f4be1b6ac7c3e92$var$admin_console);


const $03c7766a1bfb4e7c$var$demo_app = {
    title: "你已成功登錄實時預覽！",
    subtitle: "以下是本次登錄的用戶信息：",
    username: "用戶名：",
    user_id: "用戶 ID：",
    sign_out: "退出實時預覽",
    continue_explore: "或繼續探索",
    customize_sign_in_experience: "自定義登錄體驗",
    enable_passwordless: "啟用無密碼登錄",
    add_social_connector: "添加社交連接器"
};
var $03c7766a1bfb4e7c$export$2e2bcd8739ae039 = Object.freeze($03c7766a1bfb4e7c$var$demo_app);


const $c100e5a2997082b1$var$oidc = {
    logout_success: "你已經成功登出。"
};
var $c100e5a2997082b1$export$2e2bcd8739ae039 = Object.freeze($c100e5a2997082b1$var$oidc);


const $8325cc9e454cf1c2$var$translation = {
    admin_console: $4f4be1b6ac7c3e92$export$2e2bcd8739ae039,
    demo_app: $03c7766a1bfb4e7c$export$2e2bcd8739ae039,
    oidc: $c100e5a2997082b1$export$2e2bcd8739ae039
};
var $8325cc9e454cf1c2$export$2e2bcd8739ae039 = Object.freeze($8325cc9e454cf1c2$var$translation);


const $77d00b94e0c271c0$var$zh_hk = {
    translation: $8325cc9e454cf1c2$export$2e2bcd8739ae039,
    errors: $b9008f55d615ba43$export$2e2bcd8739ae039
};
var $77d00b94e0c271c0$export$2e2bcd8739ae039 = Object.freeze($77d00b94e0c271c0$var$zh_hk);


const $ee97323da94bc73f$var$application = {
    invalid_type: "僅允許機器對機器應用程式附加角色。",
    role_exists: "該角色 ID {{roleId}} 已被添加至此應用程式。",
    invalid_role_type: "無法將使用者類型的角色指派給機器對機器應用程式。"
};
var $ee97323da94bc73f$export$2e2bcd8739ae039 = Object.freeze($ee97323da94bc73f$var$application);


const $5e3bb043a0fb19da$var$auth = {
    authorization_header_missing: "Authorization 請求頭缺失。",
    authorization_token_type_not_supported: "Authorization token 類型不支持",
    unauthorized: "未經授權。請檢查憑證及其範圍。",
    forbidden: "禁止訪問。請檢查用戶 role 與權限。",
    expected_role_not_found: "未找到期望的 role。請檢查用戶 role 與權限。",
    jwt_sub_missing: "JWT 缺失 `sub`",
    require_re_authentication: "需要重新認證以進行受保護操作。"
};
var $5e3bb043a0fb19da$export$2e2bcd8739ae039 = Object.freeze($5e3bb043a0fb19da$var$auth);


const $e1664afd9382c141$var$connector = {
    general: "連接器發生錯誤：{{errorDescription}}",
    not_found: "找不到可用的 {{type}} 類型的連接器",
    not_enabled: "連接器尚未啟用",
    invalid_metadata: "連接器 metadata 參數錯誤",
    invalid_config_guard: "連接器配置 guard 錯誤",
    unexpected_type: "連接器類型錯誤",
    invalid_request_parameters: "請求參數錯誤",
    insufficient_request_parameters: "請求參數缺失",
    invalid_config: "連接器配置錯誤",
    /** UNTRANSLATED */ invalid_certificate: "The connector's certificate is invalid, please make sure the certificate is in PEM encoding.",
    invalid_response: "連接器錯誤響應",
    template_not_found: "無法從連接器配置中找到對應的模板",
    template_not_supported: "連接器不支援此模板類型",
    rate_limit_exceeded: "觸發速率限制。請稍後再試。",
    not_implemented: "方法 {{method}} 尚未實現",
    social_invalid_access_token: "當前連接器的 access_token 無效",
    invalid_auth_code: "當前連接器的授權碼無效",
    social_invalid_id_token: "當前連接器的 id_token 無效",
    authorization_failed: "用戶授權流程失敗",
    social_auth_code_invalid: "無法獲取 access_token，請檢查授權 code 是否有效",
    more_than_one_sms: "同時存在超過 1 個短信連接器",
    more_than_one_email: "同時存在超過 1 個郵件連接器",
    more_than_one_connector_factory: "找到多個連接器工廠（id 為 {{connectorIds}}），請刪除多餘項。",
    db_connector_type_mismatch: "數據庫中存在一個類型不匹配的連接。",
    not_found_with_connector_id: "找不到所給 connector id 對應的連接器",
    multiple_instances_not_supported: "你選擇的連接器不支持創建多實例。",
    invalid_type_for_syncing_profile: "只有社交連接器可以開啟用戶檔案同步。",
    can_not_modify_target: "不可修改連接器 target。",
    should_specify_target: "你需要聲明 target 的值。",
    multiple_target_with_same_platform: "同一平台上，多個社交連接器不能重複使用相同的 “Target”。",
    cannot_overwrite_metadata_for_non_standard_connector: "不可覆蓋該連接器的 metadata 參數。"
};
var $e1664afd9382c141$export$2e2bcd8739ae039 = Object.freeze($e1664afd9382c141$var$connector);


const $1e84c1bc34b5871e$var$domain = {
    not_configured: "域名主機名稱提供者未配置。",
    cloudflare_data_missing: "cloudflare_data 缺失，請確認。",
    cloudflare_unknown_error: "在請求 Cloudflare API 時出現未知錯誤",
    cloudflare_response_error: "從 Cloudflare 收到意外回應",
    limit_to_one_domain: "您只能擁有一個自訂網域。",
    hostname_already_exists: "此網域名稱已經存在我們的伺服器中。",
    cloudflare_not_found: "無法找到 Cloudflare 中的主機名"
};
var $1e84c1bc34b5871e$export$2e2bcd8739ae039 = Object.freeze($1e84c1bc34b5871e$var$domain);


const $21f9cc641387ed2f$var$entity = {
    invalid_input: "無效的輸入。值列表不能為空。",
    create_failed: "建立 {{name}} 失敗。",
    db_constraint_violated: "數據庫限制違反。",
    not_exists: "{{name}} 不存在。",
    not_exists_with_id: "ID 為 `{{id}}` 的 {{name}} 不存在。",
    not_found: "資源不存在。",
    relation_foreign_key_not_found: "無法找到一個或多個外鍵。請檢查輸入並確保所有參考的實體都存在。",
    unique_integrity_violation: "The entity already exists. Please check the input and try again."
};
var $21f9cc641387ed2f$export$2e2bcd8739ae039 = Object.freeze($21f9cc641387ed2f$var$entity);


const $10dd84cfe1a23a84$var$guard = {
    invalid_input: "請求中 {{type}} 無效",
    invalid_pagination: "分頁參數無效",
    can_not_get_tenant_id: "無法從請求中獲取租戶 ID。",
    file_size_exceeded: "文件大小超過限制。",
    mime_type_not_allowed: "不允許使用此 MIME 類型。"
};
var $10dd84cfe1a23a84$export$2e2bcd8739ae039 = Object.freeze($10dd84cfe1a23a84$var$guard);


const $a2530b089c180bdd$var$hook = {
    missing_events: "你需要至少提供一個事件。",
    send_test_payload_failed: "無法发送測試内容：{{message}}",
    endpoint_responded_with_error: "端點返回了錯誤。"
};
var $a2530b089c180bdd$export$2e2bcd8739ae039 = Object.freeze($a2530b089c180bdd$var$hook);


const $0d76411e7b348547$var$localization = {
    cannot_delete_default_language: "你已設置 {{languageTag}} 為你的預設語言，你無法刪除預設語言。",
    invalid_translation_structure: "無效的數據格式，請檢查你的輸入並重試。"
};
var $0d76411e7b348547$export$2e2bcd8739ae039 = Object.freeze($0d76411e7b348547$var$localization);


const $a97b9fe0f7ec96de$var$log = {
    invalid_type: "日誌類型無效。"
};
var $a97b9fe0f7ec96de$export$2e2bcd8739ae039 = Object.freeze($a97b9fe0f7ec96de$var$log);


const $ab85e65dde79119a$var$oidc = {
    aborted: "使用者終止了互動。",
    invalid_scope: "無效的範圍: {{error_description}}。",
    invalid_token: "Token 無效",
    invalid_client_metadata: "無效的用戶端元數據",
    insufficient_scope: "Token 缺少範圍 `{{scope}}`。",
    invalid_request: "請求無效",
    invalid_grant: "授權請求無效",
    invalid_redirect_uri: "無效返回連結, 该 redirect_uri 未被此應用註冊。",
    access_denied: "拒絕訪問",
    invalid_target: "請求資源無效",
    unsupported_grant_type: "不支援的 grant_type",
    unsupported_response_mode: "不支援的 response_mode",
    unsupported_response_type: "不支援的 response_type",
    provider_error: "OIDC 內部錯誤: {{message}}",
    server_error: "發生未知的 OIDC 錯誤。請稍後再試。",
    provider_error_fallback: "發生了一個 OIDC 錯誤: {{code}}。",
    key_required: "至少需要一個金鑰。",
    key_not_found: "未找到 ID 為 {{id}} 的金鑰。"
};
var $ab85e65dde79119a$export$2e2bcd8739ae039 = Object.freeze($ab85e65dde79119a$var$oidc);


const $c0870404c2e09bf7$var$organization = {
    require_membership: "使用者必須是該組織的成員才能繼續。"
};
var $c0870404c2e09bf7$export$2e2bcd8739ae039 = Object.freeze($c0870404c2e09bf7$var$organization);


const $68b2809135843ccd$var$password = {
    unsupported_encryption_method: "不支持的加密方法 {{name}}",
    pepper_not_found: "密碼 pepper 未找到。請檢查 core 的環境變數。",
    rejected: "密碼被拒絕。請檢查密碼是否符合要求。"
};
var $68b2809135843ccd$export$2e2bcd8739ae039 = Object.freeze($68b2809135843ccd$var$password);


const $3c54cb5411609723$var$request = {
    invalid_input: "輸入無效。{{details}}",
    general: "發生請求錯誤。"
};
var $3c54cb5411609723$export$2e2bcd8739ae039 = Object.freeze($3c54cb5411609723$var$request);


const $6fd68958c8dbd22e$var$resource = {
    resource_identifier_in_use: "API 識別碼 {{indicator}} 已經被使用"
};
var $6fd68958c8dbd22e$export$2e2bcd8739ae039 = Object.freeze($6fd68958c8dbd22e$var$resource);


const $45390c49a31b9f01$var$role = {
    name_in_use: "此角色名稱 {{name}} 已被使用",
    scope_exists: "作用域 ID {{scopeId}} 已添加到此角色",
    user_exists: "用戶 ID {{userId}} 已添加到此角色",
    application_exists: "已經將應用程式 ID {{applicationId}} 添加到此角色",
    default_role_missing: "某些預設角色名稱在資料庫中不存在，請確保先創建角色",
    internal_role_violation: "你可能正在嘗試更新或刪除 Logto 禁止的內部角色。如果你要創建新角色，請嘗試使用不以“#internal:”開頭的名稱。"
};
var $45390c49a31b9f01$export$2e2bcd8739ae039 = Object.freeze($45390c49a31b9f01$var$role);


const $def564b94dd2f08d$var$scope = {
    name_exists: "此作用域名稱 {{name}} 已被使用",
    name_with_space: "作用域名稱不能包含任何空格。"
};
var $def564b94dd2f08d$export$2e2bcd8739ae039 = Object.freeze($def564b94dd2f08d$var$scope);


const $d160366de1339f9d$var$session = {
    not_found: "未找到會話。請返回並重新登錄。",
    invalid_credentials: "帳號或密碼錯誤，請重新輸入。",
    invalid_sign_in_method: "當前登錄方式不可用",
    invalid_connector_id: "找不到 ID 為 {{connectorId}} 的可用連接器。",
    insufficient_info: "登錄信息缺失，請檢查你的輸入。",
    connector_id_mismatch: "傳入的連接器 ID 與 session 中保存的記錄不一致",
    connector_session_not_found: "無法找到連接器登錄信息，請嘗試重新登錄。",
    verification_session_not_found: "驗證失敗，請重新驗證。",
    verification_expired: "當前頁面已超時。為確保你的帳號安全，請重新驗證。",
    verification_blocked_too_many_attempts: "在短時間內嘗試次數過多。請於{{relativeTime}}後再試。",
    unauthorized: "請先登錄",
    unsupported_prompt_name: "不支援的 prompt 名稱",
    forgot_password_not_enabled: "忘記密碼功能沒有開啟。",
    verification_failed: "驗證失敗，請重新驗證。",
    connector_validation_session_not_found: "找不到用於驗證 token 的連接器資訊。",
    identifier_not_found: "找不到使用者識別碼。請返回並重新登錄。",
    interaction_not_found: "找不到交互會話。請返回並重新開始會話。",
    not_supported_for_forgot_password: "該操作不支援忘記密碼。",
    mfa: {
        require_mfa_verification: "需要 MFA 驗證才能登錄。",
        mfa_sign_in_only: "MFA 只能用於登錄交互。",
        pending_info_not_found: "未找到尚未處理的 MFA 資訊，請先初始化 MFA。",
        invalid_totp_code: "無效的 TOTP 驗證碼。",
        webauthn_verification_failed: "WebAuthn 驗證失敗。",
        webauthn_verification_not_found: "找不到 WebAuthn 驗證。",
        bind_mfa_existed: "MFA 已存在。",
        backup_code_can_not_be_alone: "備份碼不能作為唯一的 MFA。",
        backup_code_required: "需要備份碼。",
        invalid_backup_code: "無效的備份碼。",
        mfa_policy_not_user_controlled: "MFA 策略不受用戶控制。"
    },
    sso_enabled: "該郵箱已開啟單點登錄，請使用 SSO 登錄。"
};
var $d160366de1339f9d$export$2e2bcd8739ae039 = Object.freeze($d160366de1339f9d$var$session);


const $8dda755e2db8a9b3$var$sign_in_experiences = {
    empty_content_url_of_terms_of_use: "你啟用了“使用條款”，請添加使用條款 URL。",
    empty_social_connectors: "你啟用了社交登錄的方式。請至少選擇一個社交連接器。",
    enabled_connector_not_found: "未找到已啟用的 {{type}} 連接器",
    not_one_and_only_one_primary_sign_in_method: "主要的登錄方式必須有且僅有一個，請檢查你的輸入。",
    username_requires_password: "必須為用戶名註冊識別符啟用設置密碼。",
    passwordless_requires_verify: "必須為電子郵件/電話註冊識別符啟用驗證。",
    miss_sign_up_identifier_in_sign_in: "登錄方法必須包含註冊識別符。",
    password_sign_in_must_be_enabled: "必須在註冊中要求設置密碼時啟用密碼登錄。",
    code_sign_in_must_be_enabled: "必須在註冊中不要求設置密碼時啟用驗證碼登錄。",
    unsupported_default_language: "{{language}} 無法選擇為默認語言。",
    at_least_one_authentication_factor: "至少要選擇一個登錄要素",
    backup_code_cannot_be_enabled_alone: "備份碼不能單獨啟用。",
    duplicated_mfa_factors: "重複的MFA要素。"
};
var $8dda755e2db8a9b3$export$2e2bcd8739ae039 = Object.freeze($8dda755e2db8a9b3$var$sign_in_experiences);


const $21501e65bd50baeb$var$single_sign_on = {
    forbidden_domains: "不允許使用公共電子郵件域名。",
    duplicated_domains: "存在重複的域名。",
    /** UNTRANSLATED */ invalid_domain_format: "Invalid domain format.",
    /** UNTRANSLATED */ duplicate_connector_name: "Connector name already exists. Please choose a different name."
};
var $21501e65bd50baeb$export$2e2bcd8739ae039 = Object.freeze($21501e65bd50baeb$var$single_sign_on);


const $cb82a2face63fe79$var$storage = {
    not_configured: "未配置存儲提供程序。",
    missing_parameter: "存儲提供程序缺少參數 {{parameter}}。",
    upload_error: "無法將檔案上傳到存儲提供程序。"
};
var $cb82a2face63fe79$export$2e2bcd8739ae039 = Object.freeze($cb82a2face63fe79$var$storage);


const $a2c3ee9456545342$var$subscription = {
    limit_exceeded: "您已達到訂閱計劃的限制。",
    get_plan_failed: "無法為租戶獲取訂閱計劃。",
    tenant_suspended: "租戶已被暫停。 請聯繫您的管理員。"
};
var $a2c3ee9456545342$export$2e2bcd8739ae039 = Object.freeze($a2c3ee9456545342$var$subscription);


const $4e8c7e97252325fb$var$swagger = {
    invalid_zod_type: "無效的 Zod 類型，請檢查路由 guard 配置。",
    not_supported_zod_type_for_params: "請求參數不支持的 Zod 類型，請檢查路由 guard 配置。"
};
var $4e8c7e97252325fb$export$2e2bcd8739ae039 = Object.freeze($4e8c7e97252325fb$var$swagger);


const $ec019f1d10c607af$var$user = {
    username_already_in_use: "該用戶名已被使用。",
    email_already_in_use: "該電子郵件地址已被使用。",
    phone_already_in_use: "該手機號碼已被使用。",
    invalid_email: "電子郵件地址不正確。",
    invalid_phone: "手機號碼不正確。",
    email_not_exist: "電子郵件地址尚未註冊。",
    phone_not_exist: "手機號碼尚未註冊。",
    identity_not_exist: "該社交帳號尚未註冊。",
    identity_already_in_use: "該社交帳號已被註冊。",
    social_account_exists_in_profile: "你已綁定當前社交帳號，無需重複操作。",
    cannot_delete_self: "無法刪除自己的帳戶。",
    sign_up_method_not_enabled: "註冊方式尚未啟用。",
    sign_in_method_not_enabled: "登錄方式尚未啟用。",
    same_password: "為確保帳戶安全，新密碼不能與舊密碼一致。",
    password_required_in_profile: "請設置登錄密碼。",
    new_password_required_in_profile: "請設置新密碼。",
    password_exists_in_profile: "當前用戶已設置密碼，無需重複操作。",
    username_required_in_profile: "請設置用戶名。",
    username_exists_in_profile: "當前用戶已設置用戶名，無需重複操作。",
    email_required_in_profile: "請綁定電子郵件地址",
    email_exists_in_profile: "當前用戶已綁定電子郵件，無需重複操作。",
    phone_required_in_profile: "請綁定手機號碼。",
    phone_exists_in_profile: "當前用戶已綁定手機號碼，無需重複操作。",
    email_or_phone_required_in_profile: "請綁定電子郵件地址或手機號碼。",
    suspended: "帳戶已被禁用。",
    user_not_exist: "未找到與 {{identifier}} 相關聯的用戶。",
    missing_profile: "請於登錄時提供必要的用戶補充信息。",
    role_exists: "角色 ID {{roleId}} 已添加到此用戶",
    invalid_role_type: "無效角色類型，無法將機器對機器角色分配給用戶。",
    missing_mfa: "在登錄前需要綁定額外的多因素驗證。",
    totp_already_in_use: "TOTP 已經在使用中。",
    backup_code_already_in_use: "備份代碼已經在使用中。"
};
var $ec019f1d10c607af$export$2e2bcd8739ae039 = Object.freeze($ec019f1d10c607af$var$user);


const $6e2b7fe3207f6597$var$verification_code = {
    phone_email_empty: "手機號與電子郵件地址均為空",
    not_found: "驗證碼不存在，請先請求發送驗證碼",
    phone_mismatch: "手機號碼不匹配，請嘗試請求新的驗證碼。",
    email_mismatch: "電子郵件地址不匹配，請嘗試請求新的驗證碼。",
    code_mismatch: "驗證碼不正確",
    expired: "驗證碼已過期，請嘗試請求新的驗證碼。",
    exceed_max_try: "超過最大驗證次數，請嘗試請求新的驗證碼。"
};
var $6e2b7fe3207f6597$export$2e2bcd8739ae039 = Object.freeze($6e2b7fe3207f6597$var$verification_code);


const $dcd2cf53636c96f1$var$errors = {
    request: $3c54cb5411609723$export$2e2bcd8739ae039,
    auth: $5e3bb043a0fb19da$export$2e2bcd8739ae039,
    guard: $10dd84cfe1a23a84$export$2e2bcd8739ae039,
    oidc: $ab85e65dde79119a$export$2e2bcd8739ae039,
    user: $ec019f1d10c607af$export$2e2bcd8739ae039,
    password: $68b2809135843ccd$export$2e2bcd8739ae039,
    session: $d160366de1339f9d$export$2e2bcd8739ae039,
    connector: $e1664afd9382c141$export$2e2bcd8739ae039,
    verification_code: $6e2b7fe3207f6597$export$2e2bcd8739ae039,
    sign_in_experiences: $8dda755e2db8a9b3$export$2e2bcd8739ae039,
    localization: $0d76411e7b348547$export$2e2bcd8739ae039,
    swagger: $4e8c7e97252325fb$export$2e2bcd8739ae039,
    entity: $21f9cc641387ed2f$export$2e2bcd8739ae039,
    log: $a97b9fe0f7ec96de$export$2e2bcd8739ae039,
    role: $45390c49a31b9f01$export$2e2bcd8739ae039,
    scope: $def564b94dd2f08d$export$2e2bcd8739ae039,
    storage: $cb82a2face63fe79$export$2e2bcd8739ae039,
    resource: $6fd68958c8dbd22e$export$2e2bcd8739ae039,
    hook: $a2530b089c180bdd$export$2e2bcd8739ae039,
    domain: $1e84c1bc34b5871e$export$2e2bcd8739ae039,
    subscription: $a2c3ee9456545342$export$2e2bcd8739ae039,
    application: $ee97323da94bc73f$export$2e2bcd8739ae039,
    organization: $c0870404c2e09bf7$export$2e2bcd8739ae039,
    single_sign_on: $21501e65bd50baeb$export$2e2bcd8739ae039
};
var $dcd2cf53636c96f1$export$2e2bcd8739ae039 = Object.freeze($dcd2cf53636c96f1$var$errors);


const $094396c86f482a56$var$api_resource_details = {
    page_title: "API 資源詳情",
    back_to_api_resources: "返回 API 資源",
    settings_tab: "設定",
    permissions_tab: "權限",
    settings: "設定",
    settings_description: "API 資源，又稱資源指標，表示要請求的目標服務或資源，通常是表示資源身份的 URI 格式變數。",
    management_api_settings_description: "Logto 管理 API 是一個全面的 API 集合，使管理員能夠管理各種與身份有關的任務，執行安全策略，並遵守法規和標準。",
    management_api_notice: "這個 API 代表 Logto 實體，不能被修改或刪除。你可以使用管理 API 來執行多種與身份相關的任務。 <a>了解更多</a>",
    token_expiration_time_in_seconds: "Token 過期時間（秒）",
    token_expiration_time_in_seconds_placeholder: "請輸入你的 token 過期時間",
    delete_description: "本操作會永久性地刪除該 API 資源，且不可撤銷。輸入 API 資源名稱 <span>{{name}}</span> 確認。",
    enter_your_api_resource_name: "輸入 API 資源名稱",
    api_resource_deleted: " API 資源 {{name}} 已刪除.",
    permission: {
        create_button: "建立權限",
        create_title: "建立權限",
        create_subtitle: "定義此 API 所需的權限 (scope)。",
        confirm_create: "建立權限",
        name: "權限名稱",
        name_placeholder: "read:resource",
        forbidden_space_in_name: "權限名稱不能包含空格。",
        description: "描述",
        description_placeholder: "能夠讀取資源",
        permission_created: '權限 "{{name}}" 已成功建立',
        delete_description: "如果刪除此權限，擁有該權限的使用者將失去由此權限授予的存取權限。",
        deleted: '成功刪除權限 "{{name}}"。'
    }
};
var $094396c86f482a56$export$2e2bcd8739ae039 = Object.freeze($094396c86f482a56$var$api_resource_details);


const $8a009db181f0c993$var$api_resources = {
    page_title: "API 資源",
    title: "API 資源",
    subtitle: "定義可以從已授權的應用程序中使用的 API",
    create: "創建 API 資源",
    api_name: "API 名稱",
    api_name_placeholder: "輸入API名稱",
    api_identifier: "API Identifier",
    api_identifier_placeholder: "https://your-api-identifier/",
    api_identifier_tip: "對於 API 資源的唯一標識符。它必須是一個絕對 URI，並沒有 fragment (#) 組件。等價於 OAuth 2.0 中的 <a>resource parameter</a>。",
    default_api: "預設 API",
    default_api_label: "一個租戶只能設定零個或一個預設 API。當指定了預設 API 後，可以在授權請求中省略 `resource` 參數。隨後的令牌交換將使用該 API 作為默認的 Audience，從而產生 JWT。<a>了解更多</a>",
    api_resource_created: " API 資源 {{name}} 已成功創建。"
};
var $8a009db181f0c993$export$2e2bcd8739ae039 = Object.freeze($8a009db181f0c993$var$api_resources);


const $9e76fbfee01460d6$var$application_details = {
    page_title: "應用詳細資料",
    back_to_applications: "返回全部應用",
    check_guide: "查看指南",
    settings: "設置",
    settings_description: "應用程式用於在 Logto OIDC、登錄體驗、審計日誌等方面識別你的應用程式。",
    advanced_settings: "高級設置",
    advanced_settings_description: "高級設置包括 OIDC 相關術語。你可以查看 Token Endpoint 以獲取更多信息。",
    application_roles: "角色",
    machine_logs: "機器日誌",
    application_name: "應用程式姓名",
    application_name_placeholder: "我的應用程式",
    description: "說明",
    description_placeholder: "請輸入應用程式說明",
    config_endpoint: "OpenID Provider 配置端點",
    authorization_endpoint: "授權端點",
    authorization_endpoint_tip: "進行驗證與授權的端點。用於 OpenID Connect 中的 <a>驗證</a> 流程。",
    logto_endpoint: "Logto endpoint",
    application_id: "應用程式 ID",
    application_id_tip: "應用程式的唯一標識，通常由 Logto 生成。相當於 OpenID Connect 中的 <a>client_id</a>。",
    application_secret: "應用程式秘鑰",
    redirect_uri: "重定向 URI",
    redirect_uris: "重定向 URIs",
    redirect_uri_placeholder: "https://your.website.com/app",
    redirect_uri_placeholder_native: "io.logto://callback",
    redirect_uri_tip: "在用戶登錄完成（不論成功與否）後，重新導向的目標 URI。參見 OpenID Connect <a>AuthRequest</a> 以了解更多。",
    post_sign_out_redirect_uri: "登出後重定向的 URI",
    post_sign_out_redirect_uris: "登出後重定向的 URIs",
    post_sign_out_redirect_uri_placeholder: "https://your.website.com/home",
    post_sign_out_redirect_uri_tip: "在用戶登出後，重新導向的目標 URI（可選）。在某些應用程式類型中可能無實質作用。",
    cors_allowed_origins: "CORS 允許的來源",
    cors_allowed_origins_placeholder: "https://your.website.com",
    cors_allowed_origins_tip: "所有重新導向 URI 的來源都將默認被允許。通常不需要對此欄位進行操作。參見 <a>MDN 文件</a> 以了解更多。",
    token_endpoint: "Token Endpoint",
    user_info_endpoint: "用戶信息端點",
    enable_admin_access: "啟用管理訪問",
    enable_admin_access_label: "啟用或禁用對管理 API 的訪問。啟用後，你可以使用訪問令牌代表該應用程式調用管理 API。",
    always_issue_refresh_token: "始終發放 Refresh Token",
    always_issue_refresh_token_label: "啟用此配置將使 Logto 無論在驗證請求中是否提供 prompt=consent，都能始終發放 Refresh Token。然而，除非必要，否則不鼓勵這種做法，因為它與 OpenID Connect 不相容並可能引起問題。",
    refresh_token_ttl: "Refresh Token 有效期（天數）",
    refresh_token_ttl_tip: "Refresh Token 可用來獲取新的訪問令牌，失效日期之前可用。獲取訪問令牌時，該令牌的期限將被延長至此值。",
    rotate_refresh_token: "旋轉 Refresh Token",
    rotate_refresh_token_label: "啟用此配置將使 Logto 当 Refresh Token 的原始有效期剩下 70% 时或当满足某些条件时，授予新的 Refresh Token 以获取新的 Access Token。<a>了解更多</a>",
    delete_description: "本操作會永久性地刪除該應用程式，且不可撤銷。輸入 <span>{{name}}</span> 確認。",
    enter_your_application_name: "輸入你的應用程式姓名",
    application_deleted: "應用 {{name}} 成功刪除。",
    redirect_uri_required: "至少需要輸入一個重定向 URL。",
    roles: {
        name_column: "角色",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "本操作將從此機器到機器應用程式中刪除此角色。該角色本身仍然存在，但不再與此機器到機器應用程式關聯。",
        deleted: "已成功從此用戶中刪除 {{name}}。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "授權 {{name}} 一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "{{value, number}} 已添加",
        assigned_app_count: "{{value, number}} 應用程式",
        confirm_assign: "分配角色",
        role_assigned: "成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "沒有可用的角色"
    }
};
var $9e76fbfee01460d6$export$2e2bcd8739ae039 = Object.freeze($9e76fbfee01460d6$var$application_details);


const $e20c672de35594bc$var$applications = {
    page_title: "全部應用",
    title: "全部應用",
    subtitle: "創建一個移動、單頁、machine-to-machine 或傳統 web 應用程序，並通過 Logto 進行身份驗證",
    subtitle_with_app_type: "設置 {{name}} 應用程序的 Logto 身份驗證",
    create: "創建應用",
    application_name: "應用名稱",
    application_name_placeholder: "我的應用",
    application_description: "應用描述",
    application_description_placeholder: "請輸入應用描述",
    select_application_type: "選擇應用類型",
    no_application_type_selected: "你還沒有選擇應用類型",
    application_created: "應用創建成功。",
    app_id: "App ID",
    type: {
        native: {
            title: "原生應用",
            subtitle: "在原生環境中運行的應用程序",
            description: "例如 iOS app，Android app"
        },
        spa: {
            title: "單頁應用",
            subtitle: "在瀏覽器中運行並動態更新數據的應用程序",
            description: "例如 React DOM app，Vue app"
        },
        traditional: {
            title: "傳統網頁應用",
            subtitle: "僅由 Web 伺服器渲染和更新的應用程序",
            description: "例如 Next.js, PHP"
        },
        machine_to_machine: {
            title: "Machine-to-Machine",
            subtitle: "直接與資源對話的應用程序（通常是服務）",
            description: "例如，後端服務"
        }
    },
    placeholder_title: "選擇應用程序類型以繼續",
    placeholder_description: "Logto 使用 OIDC 的應用程序實體來幫助識別你的應用程序、管理登入和創建審計日誌等任務。"
};
var $e20c672de35594bc$export$2e2bcd8739ae039 = Object.freeze($e20c672de35594bc$var$applications);


const $b603de13d893e21b$var$cloud = {
    general: {
        onboarding: "入門"
    },
    welcome: {
        page_title: "歡迎",
        title: "歡迎來到 Logto Cloud！我們很想了解一些關於你的資訊。",
        description: "通過更好地了解你，我們可以使你的 Logto 體驗更加個性化。你的信息是安全的。",
        project_field: "我使用 Logto 是為了",
        project_options: {
            personal: "個人專案",
            company: "公司專案"
        },
        title_field: "選擇適用的職稱",
        title_options: {
            developer: "開發人員",
            team_lead: "團隊負責人",
            ceo: "CEO",
            cto: "CTO",
            product: "產品",
            others: "其他"
        },
        company_name_field: "公司名稱",
        company_name_placeholder: "Acme.co",
        company_size_field: "你的公司規模如何？",
        company_options: {
            size_1: "1",
            size_2_49: "2-49",
            size_50_199: "50-199",
            size_200_999: "200-999",
            size_1000_plus: "1000+"
        },
        reason_field: "我註冊的原因是",
        reason_options: {
            passwordless: "尋找無需密碼身份驗證和 UI 工具包",
            efficiency: "尋找即插即用的身份基礎架構",
            access_control: "基於角色和責任控制用戶訪問",
            multi_tenancy: "尋求面向多租戶產品的策略",
            enterprise: "為產品更方便企業使用尋找 SSO 解決方案",
            others: "其他"
        }
    },
    sie: {
        page_title: "定制登錄體驗",
        title: "讓我們輕鬆定制你的登錄體驗",
        inspire: {
            title: "創建引人入勝的示例",
            description: "對登錄體驗不確定嗎？只需點擊“啓發我”，讓魔法發生！",
            inspire_me: "來點靈感"
        },
        logo_field: "應用商標",
        color_field: "品牌顏色",
        identifier_field: "標識符",
        identifier_options: {
            email: "電子郵件",
            phone: "電話",
            user_name: "用戶名"
        },
        authn_field: "身份驗證",
        authn_options: {
            password: "密碼",
            verification_code: "驗證碼"
        },
        social_field: "社交登錄",
        finish_and_done: "完成並完成",
        preview: {
            mobile_tab: "移動端",
            web_tab: "網頁端"
        },
        connectors: {
            unlocked_later: "稍後解鎖",
            unlocked_later_tip: "完成入門流程並進入產品後，你將獲得訪問更多社交登錄方式的權限。",
            notice: "請勿將演示連接器用於生產目的。完成測試後，請刪除演示連接器並使用你的憑證設置自己的連接器。"
        }
    },
    socialCallback: {
        title: "你已成功登錄",
        description: "你已成功使用社交帳戶登錄。為確保與 Logto 的無縫集成並獲得所有功能的訪問權限，我們建議你繼續配置自己的社交連接器。"
    },
    tenant: {
        create_tenant: "新增租戶"
    }
};
var $b603de13d893e21b$export$2e2bcd8739ae039 = Object.freeze($b603de13d893e21b$var$cloud);


const $1423991d3d82042e$var$components = {
    uploader: {
        action_description: "拖放或瀏覽上傳",
        uploading: "上傳中...",
        image_limit: "上傳圖片大小不能超過 {{size, number}}KB，只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_upload: "哎呀，出了些問題。文件上傳失敗。",
        error_file_size: "文件太大了，請上傳小於 {{size, number}}KB 的文件。",
        error_file_type: "不支持該文件類型。只支持 {{extensions, list(style: narrow; type: conjunction;)}} 格式的文件。",
        error_file_count: "您只能上傳一個檔案。"
    }
};
var $1423991d3d82042e$export$2e2bcd8739ae039 = Object.freeze($1423991d3d82042e$var$components);


const $d2986f291cdd315b$var$connector_details = {
    page_title: "連結器詳情",
    back_to_connectors: "返回連結器",
    check_readme: "檢視 README",
    settings: "通用設定",
    settings_description: "連結器在 Logto 中扮演著至關重要的角色。借助它們的幫助，Logto 使終端用戶能夠使用無密碼註冊或登錄的功能以及使用社交帳戶登錄的功能。",
    parameter_configuration: "參數配置",
    test_connection: "測試",
    save_error_empty_config: "請輸入配置內容",
    send: "傳送",
    send_error_invalid_format: "無效輸入",
    edit_config_label: "請在此輸入您的 JSON 配置",
    test_email_sender: "測試您的郵件連結器",
    test_sms_sender: "測試您的短信連結器",
    test_email_placeholder: "john.doe@example.com",
    test_sms_placeholder: "+86 131 1234 5678",
    test_message_sent: "測試訊息已傳送",
    test_sender_description: "Logto 使用「通用」模板進行測試。如果您的連結器正確配置，您將收到一條訊息。",
    options_change_email: "更換郵件連結器",
    options_change_sms: "更換短信連結器",
    connector_deleted: "成功刪除連結器",
    type_email: "郵件連結器",
    type_sms: "短信連結器",
    type_social: "社交連結器",
    in_used_social_deletion_description: "您的登入體驗正在使用這個連結器。刪除後，<name/> 登入體驗將在登入體驗設定中被刪除，再次添加需重新配置。",
    in_used_passwordless_deletion_description: "您的登入體驗正在使用 {{name}} 連結器。刪除後，您的登入體驗將無法正常工作，直到您解決衝突，再次添加需重新配置。",
    deletion_description: "您將刪除此連結器。此操作不可撤銷，再次添加需重新配置。",
    logto_email: {
        total_email_sent: "總發送郵件數：{{value, number}}",
        total_email_sent_tip: "在 Logto 中，使用 SendGrid 進行安全、穩定的內建郵件發送。完全免費使用。<a>了解更多</a>",
        email_template_title: "郵件模板",
        template_description: "內置郵件使用默認模板實現無縫交付驗證郵件。無需配置，您可以自定義基本品牌信息。",
        template_description_link_text: "查看模板",
        description_action_text: "查看模板",
        from_email_field: "發件人郵箱",
        sender_name_field: "寄件人姓名",
        sender_name_tip: "自定義郵件發件人姓名。如果未填寫，將使用「Verification」作為默認姓名。",
        sender_name_placeholder: "您的發件人姓名",
        company_information_field: "公司信息",
        company_information_description: "在郵件底部顯示您的公司名稱、地址或郵編，以提高真實性。",
        company_information_placeholder: "您的公司基本信息",
        app_logo_field: "應用程式標誌",
        app_logo_tip: "在郵件頂部顯示您的品牌標誌。在淺色模式和深色模式下使用相同的圖像。",
        urls_not_allowed: "不允許使用 URL",
        test_notes: "Logto 使用「通用」模板進行測試。"
    }
};
var $d2986f291cdd315b$export$2e2bcd8739ae039 = Object.freeze($d2986f291cdd315b$var$connector_details);


const $3c6ea2d0b813e4fc$var$connectors = {
    page_title: "連接器",
    title: "連接器",
    subtitle: "設置連接器，啟用無密碼和社交登錄",
    create: "添加社交連接器",
    config_sie_notice: "你已經配置了社交連接器，記得在<a>{{link}}</a>上添加使之生效。",
    config_sie_link_text: "登錄體驗",
    tab_email_sms: "短信和郵件連接器",
    tab_social: "社交連接器",
    connector_name: "連接器名稱",
    demo_tip: "演示連接器僅用於演示且最多只能發送 100 條消息，不建議在生產環境中部署。",
    social_demo_tip: "演示連接器僅用於演示目的，不建議在生產環境中部署。",
    connector_type: "類型",
    connector_status: "登錄體驗",
    connector_status_in_use: "使用中",
    connector_status_not_in_use: "未使用",
    not_in_use_tip: {
        content: "未使用意味著你的登錄體驗並沒有使用這個登錄方式。<a>{{link}}</a>去添加。",
        go_to_sie: "前往登錄體驗"
    },
    placeholder_title: "社交連接器",
    placeholder_description: "Logto 提供了許多廣泛使用的社交登錄連接器，同時你還可以使用標準協議創建自己的連接器。",
    save_and_done: "保存並完成",
    type: {
        email: "郵件連接器",
        sms: "短信連接器",
        social: "社交連接器"
    },
    setup_title: {
        email: "設置郵件連接器",
        sms: "設置短信連接器",
        social: "添加社交連接器"
    },
    guide: {
        subtitle: "參考以下步驟完成你的連接器設置",
        general_setting: "通用設置",
        parameter_configuration: "參數配置",
        test_connection: "連接測試",
        name: "社交登錄按鈕的名稱",
        name_placeholder: "輸入社交登錄按鈕的名稱",
        name_tip: "按鈕上將展示「通過 {{name}} 繼續」。名字不宜過長而導致信息無法展示完整。",
        logo: "社交登錄按鈕的 Logo 圖片鏈接",
        logo_placeholder: "https://your.cdn.domain/logo.png",
        logo_tip: "該圖片將用於連接器的展示。獲取圖片鏈接後粘貼在此處。",
        logo_dark: "社交登錄按鈕的 Logo 圖片鏈接（深色模式）",
        logo_dark_placeholder: "https://your.cdn.domain/logo.png",
        logo_dark_tip: "在管理控制台的登錄體驗中啟用“深色模式”後，可設置此連接器 Logo 用於深色模式。",
        logo_dark_collapse: "收起",
        logo_dark_show: "展開深色模式 Logo 設置",
        target: "身份提供商名稱",
        target_placeholder: "輸入身份提供商的名稱",
        target_tip: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。",
        target_tip_standard: "在“身份供應商名稱”字段中輸入唯一的標識符字符串，用於區分社交身份來源。注意，在連接器創建成功後，無法再次修改此設置。",
        target_tooltip: "Logto 社交連接器的「target」指的是社交身份的「來源」。在 Logto 的設計裡，我們不允許某一平台的連接器中有相同的「target」以避免身份的衝突。在添加連接器時，你需要格外小心，我們「不允許」用戶在創建之後更改「target」的值。<a>了解更多</a>",
        target_conflict: "此「身份供應商名稱」值與現有的 <span>name</span> 連接器相同。使用相同的身份供應商名稱會導致不符合預期的登錄行為，用戶可能通過兩個不同的連接器訪問同一個帳戶。",
        target_conflict_line2: "如果你想替換當前的連接器，並連接相同的身份提供商（IdP），以便先前的用戶可以直接登錄而無需重新註冊，請先刪除 <span>name</span> 連接器，再創建一個新的連接器並使用相同的「身份供應商名稱」值。",
        target_conflict_line3: "如果你想連接一個新的身份驗證提供程序，請修改「身份供應商名稱」並繼續。",
        config: "粘貼你的 JSON 代碼",
        sync_profile: "開啟用戶資料同步",
        sync_profile_only_at_sign_up: "首次註冊時同步",
        sync_profile_each_sign_in: "每次登錄時同步",
        sync_profile_tip: "同步用戶的用戶名、頭像等個人資料信息",
        callback_uri: "Callback URI",
        callback_uri_description: "也稱為重定向 URI，在社交授權後，用戶將被發送回 Logto 的 URI，複製並粘貼到社交提供者的配置頁面中。"
    },
    platform: {
        universal: "通用",
        web: "網頁",
        native: "原生"
    },
    add_multi_platform: "支持多平臺，選擇一個平臺繼續",
    drawer_title: "連接器配置指南",
    drawer_subtitle: "參考以下步驟完善或修改你的連接器設置",
    unknown: "未知連接器",
    standard_connectors: "標準連接器"
};
var $3c6ea2d0b813e4fc$export$2e2bcd8739ae039 = Object.freeze($3c6ea2d0b813e4fc$var$connectors);


const $291fb9ca00ae5165$var$contact = {
    title: "取得協助",
    description: "若需協助申請或產品反饋，請透過下列方法與我們聯繫。",
    discord: {
        title: "加入 Discord 社群",
        description: "與其他開發人員一起尋找解決方案",
        button: "加入"
    },
    github: {
        title: "在 GitHub 上溝通",
        description: "在 GitHub 建立一個問題並提交",
        button: "開啟"
    },
    email: {
        title: "透過電子郵件聯繫支援",
        description: "發送電子郵件以獲得更多資訊和協助",
        button: "發送"
    },
    reserve: {
        title: "與 Logto 團隊預定時間",
        description: "快速預定與我們團隊的一對一會話",
        button: "預定"
    }
};
var $291fb9ca00ae5165$export$2e2bcd8739ae039 = Object.freeze($291fb9ca00ae5165$var$contact);


const $5daec76e4f7faea2$var$dashboard = {
    page_title: "儀表板",
    title: "儀表板",
    description: "查看所有應用的數據概況",
    total_users: "總用戶",
    total_users_tip: "總用戶",
    new_users_today: "今日新增",
    new_users_today_tip: "今日註冊到你應用上的新用戶數",
    new_users_7_days: "7 日新增",
    new_users_7_days_tip: "最近 7 日註冊到你應用上的新用戶數",
    daily_active_users: "日活用戶",
    daily_active_users_tip: "今日在你的應用上交換過 token 的獨立用戶數",
    weekly_active_users: "周活用戶",
    weekly_active_users_tip: "最近 7 日在你的應用上交換過 token 的獨立用戶數",
    monthly_active_users: "月活用戶",
    monthly_active_users_tip: "最近 30 日在你的應用上交換過 token 的獨立用戶數"
};
var $5daec76e4f7faea2$export$2e2bcd8739ae039 = Object.freeze($5daec76e4f7faea2$var$dashboard);


const $b5a38a56845553a7$var$domain = {
    status: {
        connecting: "連線中",
        in_used: "使用中",
        failed_to_connect: "連線失敗"
    },
    update_endpoint_notice: "不要忘記在應用程序中更新社交連接器回調 URI 和 Logto 端點的域，如果您想使用自定義域來使用這些功能。<a>{{link}}</a>",
    error_hint: "請確保您更新了您的 DNS 記錄。 我們將繼續每{{value}}秒檢查一次。",
    custom: {
        custom_domain: "自訂網域",
        custom_domain_description: "提高品牌形象，使用自訂網域。此網域將用於您的登錄體驗。",
        custom_domain_field: "自訂網域",
        custom_domain_placeholder: "your.domain.com",
        add_domain: "新增網域",
        invalid_domain_format: "子網域格式無效，請輸入至少三個部分的子網域。",
        verify_domain: "驗證網域",
        enable_ssl: "啟用 SSL",
        checking_dns_tip: "當您配置 DNS 記錄後，這個過程將自動運行，它可能需要長達 24 小時。 您可以在運行期間離開這個介面。",
        enable_ssl_tip: "啟用 SSL 將自動運行，可能需要長達 24 小時。您可以在運行期間離開此介面。",
        generating_dns_records: "正在生成 DNS 記錄...",
        add_dns_records: "請將這些 DNS 記錄添加到您的 DNS 供應商。",
        dns_table: {
            type_field: "類型",
            name_field: "名稱",
            value_field: "值"
        },
        deletion: {
            delete_domain: "刪除網域",
            reminder: "刪除自定義網域",
            description: "您確定要刪除此自定義網域嗎？",
            in_used_description: '您確定要刪除此自定義網域 "<span>{{domain}}</span>" 嗎？',
            in_used_tip: '如果您以前在社交聯繫運營商或應用端點中設置了此自定義網域，則需要先將 URI 更改為 Logto 默認網域"<span>{{domain}}</span>"。 這是社交登錄按鈕正常工作所必需的。',
            deleted: "成功刪除自定義網域！"
        }
    },
    default: {
        default_domain: "預設網域",
        default_domain_description: "Logto 提供預先配置的預設網域，無需進行任何其他設置即可使用。即使啟用了自訂網域，此預設網域也可作為備用選項。",
        default_domain_field: "Logto 默認網域"
    },
    custom_endpoint_note: "您可以根據需要自定義這些端點的域名。選擇“{{custom}}”或“{{default}}”。",
    custom_social_callback_url_note: "您可以自定義此 URI 的域名以匹配您的應用程序端點。選擇“{{custom}}”或“{{default}}”。"
};
var $b5a38a56845553a7$export$2e2bcd8739ae039 = Object.freeze($b5a38a56845553a7$var$domain);


const $495c73ebdc51711e$var$enterprise_sso_details = {
    /** UNTRANSLATED */ back_to_sso_connectors: "Back to enterprise SSO",
    /** UNTRANSLATED */ page_title: "Enterprise SSO connector details",
    /** UNTRANSLATED */ readme_drawer_title: "Enterprise SSO",
    /** UNTRANSLATED */ readme_drawer_subtitle: "Set up enterprise SSO connectors to enable end users SSO",
    /** UNTRANSLATED */ tab_experience: "SSO Experience",
    /** UNTRANSLATED */ tab_connection: "Connection",
    /** UNTRANSLATED */ general_settings_title: "General",
    /** UNTRANSLATED */ custom_branding_title: "Display",
    /** UNTRANSLATED */ custom_branding_description: "Customize the name and logo displayed in the end users' Single Sign-On flow. When empty, defaults are used.",
    /** UNTRANSLATED */ email_domain_field_name: "Enterprise email domain",
    /** UNTRANSLATED */ email_domain_field_description: "Users with this email domain can use SSO for authentication. Please verify the domain belongs to the enterprise.",
    /** UNTRANSLATED */ email_domain_field_placeholder: "Email domain",
    /** UNTRANSLATED */ sync_profile_field_name: "Sync profile information from the identity provider",
    sync_profile_option: {
        /** UNTRANSLATED */ register_only: "Only sync at first sign-in",
        /** UNTRANSLATED */ each_sign_in: "Always sync at each sign-in"
    },
    /** UNTRANSLATED */ connector_name_field_name: "Connector name",
    /** UNTRANSLATED */ display_name_field_name: "Display name",
    /** UNTRANSLATED */ connector_logo_field_name: "Display logo",
    /** UNTRANSLATED */ connector_logo_field_description: "Each image should under 500KB, SVG, PNG, JPG, JPEG only.",
    /** UNTRANSLATED */ branding_logo_context: "Upload logo",
    /** UNTRANSLATED */ branding_logo_error: "Upload logo error: {{error}}",
    /** UNTRANSLATED */ branding_light_logo_context: "Upload light mode logo",
    /** UNTRANSLATED */ branding_light_logo_error: "Upload light mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_logo_field_name: "Logo",
    /** UNTRANSLATED */ branding_logo_field_placeholder: "https://your.domain/logo.png",
    /** UNTRANSLATED */ branding_dark_logo_context: "Upload dark mode logo",
    /** UNTRANSLATED */ branding_dark_logo_error: "Upload dark mode logo error: {{error}}",
    /** UNTRANSLATED */ branding_dark_logo_field_name: "Logo (dark mode)",
    /** UNTRANSLATED */ branding_dark_logo_field_placeholder: "https://your.domain/dark-mode-logo.png",
    /** UNTRANSLATED */ check_connection_guide: "Connection guide",
    /** UNTRANSLATED */ enterprise_sso_deleted: "Enterprise SSO connector has been successfully deleted",
    /** UNTRANSLATED */ delete_confirm_modal_title: "Delete enterprise SSO connector",
    /** UNTRANSLATED */ delete_confirm_modal_content: "Are you sure you want to delete this enterprise connector? Users from identity providers will not utilize Single Sign-On.",
    /** UNTRANSLATED */ upload_idp_metadata_title_saml: "Upload the metadata",
    /** UNTRANSLATED */ upload_idp_metadata_description_saml: "Configure the metadata copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_title_oidc: "Upload the credentials",
    /** UNTRANSLATED */ upload_idp_metadata_description_oidc: "Configure the credentials and OIDC token information copied from the identity provider.",
    /** UNTRANSLATED */ upload_idp_metadata_button_text: "Upload metadata XML file",
    /** UNTRANSLATED */ upload_signing_certificate_button_text: "Upload signing certificate file",
    /** UNTRANSLATED */ configure_domain_field_info_text: "Add email domain to guide enterprise users to their identity provider for Single Sign-on.",
    /** UNTRANSLATED */ email_domain_field_required: "Email domain is required to enable enterprise SSO.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_url: "Paste the metadata URL from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_xml: "Paste the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_saml_idp_metadata_info_text_manual: "Fill in the metadata from the identity provider to connect.",
    /** UNTRANSLATED */ upload_oidc_idp_info_text: "Fill in the information from the identity provider to connect.",
    /** UNTRANSLATED */ service_provider_property_title: "Configure in the IdP",
    /** UNTRANSLATED */ service_provider_property_description: "Set up an application integration using {{protocol}} in your identity provider. Enter the details provided by Logto.",
    /** UNTRANSLATED */ attribute_mapping_title: "Attribute mappings",
    /** UNTRANSLATED */ attribute_mapping_description: "Sync user profiles from the identity provider by configuring user attribute mapping either on the identity provider to Logto side.",
    saml_preview: {
        /** UNTRANSLATED */ sign_on_url: "Sign on URL",
        /** UNTRANSLATED */ entity_id: "Issuer",
        /** UNTRANSLATED */ x509_certificate: "Signing certificate",
        /** UNTRANSLATED */ certificate_content: "Expiring {{date}}"
    },
    oidc_preview: {
        /** UNTRANSLATED */ authorization_endpoint: "Authorization endpoint",
        /** UNTRANSLATED */ token_endpoint: "Token endpoint",
        /** UNTRANSLATED */ userinfo_endpoint: "User information endpoint",
        /** UNTRANSLATED */ jwks_uri: "JSON web key set endpoint",
        /** UNTRANSLATED */ issuer: "Issuer"
    }
};
var $495c73ebdc51711e$export$2e2bcd8739ae039 = Object.freeze($495c73ebdc51711e$var$enterprise_sso_details);


const $bf19b4f50222af74$var$enterprise_sso = {
    page_title: "企業單一登入",
    title: "企業單一登入",
    subtitle: "連接企業身份提供者，啟用 SP 啟動的單一登入。",
    create: "新增企業連接器",
    col_connector_name: "連接器名稱",
    col_type: "類型",
    col_email_domain: "電子郵件域",
    placeholder_title: "企業連接器",
    /** UNTRANSLATED */ placeholder_description: "Logto has provided many built-in enterprise identity providers to connect, meantime you can create your own with SAML and OIDC protocols.",
    create_modal: {
        title: "新增企業連接器",
        text_divider: "或者你可以按照標準協議自定義你的連接器。",
        connector_name_field_title: "連接器名稱",
        /** UNTRANSLATED */ connector_name_field_placeholder: "E.g., {corp. name} - {identity provider name}",
        create_button_text: "創建連接器"
    },
    guide: {
        /** UNTRANSLATED */ subtitle: "A step by step guide to connect the enterprise identity provider.",
        /** UNTRANSLATED */ finish_button_text: "Continue"
    },
    basic_info: {
        /** UNTRANSLATED */ title: "Configure your service in the IdP",
        /** UNTRANSLATED */ description: "Create a new application integration by SAML 2.0 in your {{name}} identity provider. Then paste the following value to it.",
        saml: {
            /** UNTRANSLATED */ acs_url_field_name: "Assertion consumer service URL (Reply URL)",
            /** UNTRANSLATED */ audience_uri_field_name: "Audience URI (SP Entity ID)"
        },
        oidc: {
            /** UNTRANSLATED */ redirect_uri_field_name: "Redirect URI (Callback URL)"
        }
    },
    attribute_mapping: {
        /** UNTRANSLATED */ title: "Attribute mappings",
        /** UNTRANSLATED */ description: "`id` and `email` are required to sync user profile from IdP. Enter the following claim name and value in your IdP.",
        /** UNTRANSLATED */ col_sp_claims: "Value of service provider (Logto)",
        /** UNTRANSLATED */ col_idp_claims: "Claim name of identity provider",
        /** UNTRANSLATED */ idp_claim_tooltip: "The claim name of the identity provider"
    },
    metadata: {
        /** UNTRANSLATED */ title: "Configure the IdP metadata",
        /** UNTRANSLATED */ description: "Configure the metadata from the identity provider",
        /** UNTRANSLATED */ dropdown_trigger_text: "Use another configuration method",
        /** UNTRANSLATED */ dropdown_title: "select your configuration method",
        /** UNTRANSLATED */ metadata_format_url: "Enter the metadata URL",
        /** UNTRANSLATED */ metadata_format_xml: "Upload the metadata XML file",
        /** UNTRANSLATED */ metadata_format_manual: "Enter metadata details manually",
        saml: {
            /** UNTRANSLATED */ metadata_url_field_name: "Metadata URL",
            /** UNTRANSLATED */ metadata_url_description: "Dynamically fetch data from the metadata URL and keep certificate up to date.",
            /** UNTRANSLATED */ metadata_xml_field_name: "IdP metadata XML file",
            /** UNTRANSLATED */ metadata_xml_uploader_text: "Upload metadata XML file",
            /** UNTRANSLATED */ sign_in_endpoint_field_name: "Sign on URL",
            /** UNTRANSLATED */ idp_entity_id_field_name: "IdP entity ID (Issuer)",
            /** UNTRANSLATED */ certificate_field_name: "Signing certificate",
            /** UNTRANSLATED */ certificate_placeholder: "Copy and paste the x509 certificate",
            /** UNTRANSLATED */ certificate_required: "Signing certificate is required."
        },
        oidc: {
            /** UNTRANSLATED */ client_id_field_name: "Client ID",
            /** UNTRANSLATED */ client_secret_field_name: "Client secret",
            /** UNTRANSLATED */ issuer_field_name: "Issuer",
            /** UNTRANSLATED */ scope_field_name: "Scope"
        }
    }
};
var $bf19b4f50222af74$export$2e2bcd8739ae039 = Object.freeze($bf19b4f50222af74$var$enterprise_sso);


const $684ca0aa41880782$var$errors = {
    something_went_wrong: "哎呀，出錯了！",
    page_not_found: "找不到頁面",
    unknown_server_error: "伺服器發生未知錯誤",
    empty: "沒有資料",
    missing_total_number: "無法從返回的頭部訊息中找到 Total-Number",
    invalid_uri_format: "無效的 URI 格式",
    invalid_origin_format: "無效的 URI origin 格式",
    invalid_json_format: "無效的 JSON 格式",
    invalid_error_message_format: "非法的錯誤訊息格式",
    required_field_missing: "請輸入{{field}}",
    required_field_missing_plural: "至少需要輸入一個{{field}}",
    more_details: "查看詳情",
    username_pattern_error: "用戶名只能包含英文字母、數字或下劃線，且不以數字開頭。",
    email_pattern_error: "郵箱地址無效",
    phone_pattern_error: "手機號碼無效",
    insecure_contexts: "不支援不安全的上下文（非 HTTPS）。",
    unexpected_error: "發生未知錯誤",
    not_found: "404 找不到資源",
    create_internal_role_violation: '你正在創建一個被 Logto 禁止的內部角色。嘗試使用不以 "#internal:" 開頭的其他名稱。',
    should_be_an_integer: "應該是整數。",
    number_should_be_between_inclusive: "數字應該在 {{min}} 和 {{max}} 之間（均包含）。"
};
var $684ca0aa41880782$export$2e2bcd8739ae039 = Object.freeze($684ca0aa41880782$var$errors);


const $ce0ff4fa6a87086c$var$general = {
    placeholder: "占位符",
    submit: "提交",
    skip: "跳過",
    next: "下一步",
    back: "上一步",
    retry: "重試",
    done: "完成",
    search: "搜索",
    search_placeholder: "搜索",
    clear_result: "清除結果",
    save: "儲存",
    save_changes: "儲存更改",
    saved: "儲存成功",
    discard: "放棄",
    loading: "讀取中...",
    redirecting: "頁面跳轉中...",
    add: "新增",
    added: "已新增",
    cancel: "取消",
    confirm: "確認",
    check_out: "查看",
    create: "建立",
    set_up: "設置",
    customize: "自定義",
    enable: "啟用",
    reminder: "提示",
    delete: "刪除",
    more_options: "更多選項",
    close: "關閉",
    copy: "複製",
    copying: "複製中",
    copied: "已複製",
    required: "必填",
    add_another: "新增",
    create_another: "創建另一個",
    deletion_confirmation: "你確定要刪除這個 {{title}} 嗎?",
    settings_nav: "設置",
    unsaved_changes_warning: "還有未儲存的變更, 確定要離開嗎？",
    leave_page: "離開此頁",
    stay_on_page: "留在此頁",
    type_to_search: "輸入搜尋",
    got_it: "知道了",
    continue: "繼續",
    page_info: "{{min, number}}-{{max, number}} 共 {{total, number}} 條",
    learn_more: "了解更多",
    tab_errors: "{{count, number}} 個錯誤",
    skip_for_now: "先跳過",
    remove: "移除",
    visit: "訪問",
    join: "加入",
    try_now: "現在試試",
    multiple_form_field: "（多選）",
    demo: "演示",
    unnamed: "未命名",
    view: "查看",
    hide: "隱藏",
    unknown_error: "未知錯誤，請稍後重試。",
    select: "選擇",
    contact_us_action: "聯絡我們",
    description: "描述",
    name: "名稱",
    add_field: "新增{{field}}",
    create_field: "創建{{field}}",
    edit_field: "編輯{{field}}",
    delete_field: "刪除{{field}}",
    coming_soon: "即將上線",
    beta_notice: "\uD83C\uDF89  {{feature}} 目前正處於測試版。歡迎探索並 <ContactLink>分享您的反饋意見</ContactLink>。"
};
var $ce0ff4fa6a87086c$export$2e2bcd8739ae039 = Object.freeze($ce0ff4fa6a87086c$var$general);


const $2ea680ba01895964$var$get_started = {
    page_title: "開始上手",
    title: "成功開發身份方案，我們先來探索一番",
    subtitle: "一些快速獲取 Logto 價值的事情",
    develop: {
        title: "開發：花 5 分鐘集成您的應用程式"
    },
    customize: {
        title: "自訂：提供出色的登錄體驗",
        preview: {
            title: "查看您剛自訂的登錄體驗的實時預覽",
            subtitle: "立即嘗試 Logto 登錄體驗，了解其工作原理"
        },
        connector: {
            title: "添加更多連接器以支持更多社交登錄方式",
            subtitle: "嘗試無密碼登錄，為您的客戶啟用安全、無摩擦的體驗"
        },
        continue_customizing: "繼續自訂",
        try_now: "立即嘗試",
        add_more: "添加更多"
    },
    secure: {
        title: "安全：保護您的資源"
    },
    manage: {
        title: "管理：為您的產品和用戶定義訪問控制",
        rbac: {
            title: "添加基於角色的訪問控制以保護您的資源",
            subtitle: "通過可擴展的角色授權，來控制不同用例的資源"
        },
        create_roles: "創建角色"
    },
    view_all: "查看全部 →"
};
var $2ea680ba01895964$export$2e2bcd8739ae039 = Object.freeze($2ea680ba01895964$var$get_started);


const $1e64a9e6463ec408$var$guide = {
    start_building: "開始構建",
    get_started: "立即開始",
    categories: {
        featured: "推薦熱門開發框架",
        Traditional: "傳統網頁應用",
        SPA: "單頁應用",
        Native: "原生應用",
        MachineToMachine: "Machine-to-machine"
    },
    filter: {
        title: "篩選框架",
        placeholder: "搜索框架"
    },
    checkout_tutorial: "查看 {{name}} 教程",
    do_not_need_tutorial: "如果你現在不需要教程，可以點擊右側按鈕繼續創建應用",
    finish_and_done: "完成",
    cannot_find_guide: "找不到你想要的教程？",
    describe_guide_looking_for: "描述你正在尋找的教程",
    request_guide_successfully: "請求已成功提交，謝謝！",
    app: {
        select_framework_or_tutorial: "選擇一個框架或教程",
        guide_modal_title: "從 SDK 和指南開始",
        modal_subtitle: "使用我們提供的 SDK 和集成教程加速你的應用開發過程。",
        select_a_framework: "選擇一個框架",
        continue_without_framework: "跳過教程直接創建應用",
        describe_guide_looking_for_placeholder: "例如：我想將 Logto 集成到我的 Angular 應用程式中。"
    },
    api: {
        modal_title: "首先從教程開始",
        modal_subtitle: "使用我們提供的教程來加速你的應用程式開發過程。",
        select_a_tutorial: "選擇一個教程",
        continue_without_tutorial: "跳過教程直接創建 API 資源",
        describe_guide_looking_for_placeholder: "例如：我想使用 deno 框架驗證我的 API。"
    }
};
var $1e64a9e6463ec408$export$2e2bcd8739ae039 = Object.freeze($1e64a9e6463ec408$var$guide);


const $5d11e004a17e3909$var$log_details = {
    page_title: "審計日誌詳情",
    back_to_logs: "返回審計日誌",
    back_to: "返回 {{name}}",
    success: "成功",
    failed: "失敗",
    event_key: "事件 Key",
    application: "應用",
    ip_address: "IP 地址",
    user: "使用者",
    log_id: "日誌 ID",
    time: "時間",
    user_agent: "使用者代理",
    tab_details: "詳情",
    raw_data: "原始資料"
};
var $5d11e004a17e3909$export$2e2bcd8739ae039 = Object.freeze($5d11e004a17e3909$var$log_details);


const $b3426bc0f3c02c53$var$logs = {
    page_title: "審計日誌",
    title: "審計日誌",
    subtitle: "查看使用者行為和事件",
    event: "事件",
    user: "使用者",
    application: "應用程式",
    time: "時間",
    filter_by: "過濾"
};
var $b3426bc0f3c02c53$export$2e2bcd8739ae039 = Object.freeze($b3426bc0f3c02c53$var$logs);


const $35319f676cb20684$var$menu = {
    profile: "帳戶管理",
    language: "語言",
    appearance: {
        label: "主題",
        light: "淺色模式",
        dark: "深色模式",
        system: "跟隨系統"
    },
    sign_out: "退出登錄"
};
var $35319f676cb20684$export$2e2bcd8739ae039 = Object.freeze($35319f676cb20684$var$menu);


const $35abaa2903160902$var$mfa = {
    title: "多因素身份驗證",
    description: "添加多因素身份驗證以提升您登錄體驗的安全性。",
    factors: "因素",
    multi_factors: "多因素",
    multi_factors_description: "用戶需要驗證啟用的其中一個因素以進行兩步驗證。",
    totp: "身份驗證應用 OTP",
    otp_description: "將 Google Authenticator 等連接起來，以驗證一次性密碼。",
    webauthn: "WebAuthn（通行證）",
    webauthn_description: "通過瀏覽器支持的方法進行驗證：生物識別、手機掃描或安全密鑰等。",
    webauthn_native_tip: "本地應用不支持 WebAuthn。",
    webauthn_domain_tip: "WebAuthn將公共密鑰綁定到特定域。修改服務域將阻止用戶通過現有通行證進行身份驗證。",
    backup_code: "備份代碼",
    backup_code_description: "在用戶設置任何MFA方法後生成10個一次性備份代碼。",
    backup_code_setup_hint: "當用戶無法驗證上述MFA因素時，使用備份選項。",
    backup_code_error_hint: "要使用備份代碼，您需要至少再添加一種MFA方法以成功進行用戶身份驗證。",
    policy: "策略",
    policy_description: "設置登錄和註冊流程的MFA策略。",
    two_step_sign_in_policy: "登錄時的雙步驗證策略",
    user_controlled: "用戶可以自行啟用或禁用MFA",
    user_controlled_tip: "用戶可以在首次登錄或註冊時跳過MFA設置，或在帳戶設置中啟用/禁用它。",
    mandatory: "用戶總是需要在登錄時使用MFA",
    mandatory_tip: "用戶必須在首次登錄或註冊時設置MFA，並在以後的所有登錄中使用它。"
};
var $35abaa2903160902$export$2e2bcd8739ae039 = Object.freeze($35abaa2903160902$var$mfa);


const $aee2bbca62183f47$var$organization_details = {
    page_title: "組織詳情",
    delete_confirmation: "刪除後，所有成員將失去在這個組織中的成員資格和角色。此操作無法撤銷。",
    organization_id: "組織編號",
    /** UNTRANSLATED */ settings_description: "Organizations represent the teams, business customers, and partner companies that can access your applications.",
    name_placeholder: "組織名稱，不需要是唯一的。",
    description_placeholder: "組織的描述。",
    member: "成員",
    member_other: "成員",
    add_members_to_organization: "將成員添加到 {{name}} 組織",
    add_members_to_organization_description: "通過搜索名稱、電子郵件、電話或用戶ID來查找適合的用戶。現有成員不會顯示在搜索結果中。",
    add_with_organization_role: "添加組織角色",
    user: "用戶",
    authorize_to_roles: "授權 {{name}} 訪問以下角色：",
    edit_organization_roles: "編輯組織角色",
    edit_organization_roles_of_user: "編輯 {{name}} 的組織角色",
    remove_user_from_organization: "從組織中刪除用戶",
    remove_user_from_organization_description: "刪除後，用戶將失去在這個組織中的成員資格和角色。此操作無法撤銷。",
    search_user_placeholder: "按名稱、電子郵件、電話或用戶ID搜尋",
    at_least_one_user: "至少需要一個用戶。"
};
var $aee2bbca62183f47$export$2e2bcd8739ae039 = Object.freeze($aee2bbca62183f47$var$organization_details);


const $51227c338a767999$var$organizations = {
    /** UNTRANSLATED */ organization: "Organization",
    page_title: "組織",
    title: "組織",
    /** UNTRANSLATED */ subtitle: "An organization is a collection of users which includes teams, business clients, and partner firms that use your applications.",
    /** UNTRANSLATED */ organization_template: "Organization template",
    organization_id: "組織 ID",
    members: "成員",
    create_organization: "建立組織",
    setup_organization: "設立您的組織",
    organization_list_placeholder_title: "組織",
    organization_list_placeholder_text: "組織通常用於SaaS或類似SaaS的多租戶應用程式。組織功能允許您的B2B客戶更好地管理其合作夥伴和客戶，並自定義最終用戶訪問其應用程式的方式。",
    organization_name_placeholder: "我的組織",
    organization_description_placeholder: "組繹的簡要描述",
    organization_permission: "組繹權限",
    organization_permission_other: "組繹權限",
    organization_permission_description: "組繹權限是指在組繹上下文中訪問資源的授權。組繹權限應該以有意義的字符串表示，同時作為名稱和唯一標識。",
    organization_permission_delete_confirm: "如果刪除此權限，所有包括此權限的組繹角色將失去此權限，擁有此權限的用戶將失去其授予的訪問。",
    create_permission_placeholder: "瀏覽預約歷史",
    permission: "權限",
    permission_other: "權限",
    organization_role: "組繹角色",
    organization_role_other: "組繹角色",
    organization_role_description: "組繹角色是一組可以分配給用戶的權限。這些權限必須來自預定義的組繹權限。",
    organization_role_delete_confirm: "這將從受影響的用戶中刪除與此角色相關的權限，並刪除組繹角色、組繹成員和組繹權限之間的關係。",
    role: "角色",
    create_role_placeholder: "只擁有查看權限的用戶",
    search_placeholder: "按組繹名稱或ID搜索",
    search_permission_placeholder: "輸入搜索並選擇權限",
    search_role_placeholder: "輸入搜索並選擇角色",
    empty_placeholder: "\uD83E\uDD14 你目前尚未設置任何 {{entity}} 。",
    /** UNTRANSLATED */ organization_and_member: "Organization and member",
    /** UNTRANSLATED */ organization_and_member_description: 'Organization is a group of users and can represent the teams, business customers, and partner companies, with each user being a "Member". Those can be fundamental entities to handle your multi-tenant requirements.',
    guide: {
        title: "從指南開始",
        /** UNTRANSLATED */ subtitle: "Jumpstart your organization settings with our guides",
        introduction: {
            /** UNTRANSLATED */ title: "Let's understand how organization works in Logto",
            section_1: {
                /** UNTRANSLATED */ title: "An organization is a group of users (identities)"
            },
            section_2: {
                /** UNTRANSLATED */ title: "Organization template is designed for multi-tenant apps access control",
                /** UNTRANSLATED */ description: 'In multi-tenant SaaS applications, multiple organizations often share the same access control template, which includes permissions and roles. In Logto, we call it "organization template."',
                /** UNTRANSLATED */ permission_description: "Organization permission refers to the authorization to access a resource in the context of organization.",
                /** UNTRANSLATED */ role_description: "Organization role is a grouping of organization permissions that can be assigned to members."
            },
            section_3: {
                title: "與插圖互動，查看所有連結如何互相連接",
                description: "Let's take an example. John, Sarah are in different organizations with different roles in the context of different organizations. Hover over the different modules and see what happens."
            }
        },
        step_1: "步驟1：定義組繹權限",
        step_2: "步驟2: 定義組繹角色",
        step_3: "步驟3：創建您的第一個組繹",
        /** UNTRANSLATED */ step_3_description: "Let's create your first organization. It comes with a unique ID and serves as a container for handling various more business-toward identities.",
        /** UNTRANSLATED */ more_next_steps: "More next steps",
        /** UNTRANSLATED */ add_members: "Add members to your organization",
        /** UNTRANSLATED */ add_members_action: "Bulk add members and assign roles",
        /** UNTRANSLATED */ organization_permissions: "Organization permissions",
        /** UNTRANSLATED */ permission_name: "Permission name",
        /** UNTRANSLATED */ permissions: "Permissions",
        /** UNTRANSLATED */ organization_roles: "Organization roles",
        /** UNTRANSLATED */ role_name: "Role name",
        /** UNTRANSLATED */ organization_name: "Organization name",
        /** UNTRANSLATED */ admin: "Admin",
        /** UNTRANSLATED */ member: "Member",
        /** UNTRANSLATED */ guest: "Guest",
        /** UNTRANSLATED */ role_description: 'Role "{{role}}" shares the same organization template across different organizations.',
        /** UNTRANSLATED */ john: "John",
        /** UNTRANSLATED */ john_tip: 'John belongs to two organizations with the email "john@email.com" as the single identifier. He is the admin of organization A as well as the guest of organization B.',
        /** UNTRANSLATED */ sarah: "Sarah",
        /** UNTRANSLATED */ sarah_tip: 'Sarah belongs to one organization with the email "sarah@email.com" as the single identifier. She is the admin of organization B.'
    }
};
var $51227c338a767999$export$2e2bcd8739ae039 = Object.freeze($51227c338a767999$var$organizations);


const $8bac72885698a474$var$permissions = {
    search_placeholder: "通過 API 或權限名稱搜索",
    search_placeholder_without_api: "通過權限名稱搜索",
    name_column: "權限",
    description_column: "描述",
    api_column: "API",
    placeholder_title: "權限",
    placeholder_description: "權限是指訪問資源的授權（我們稱其為 API 資源）。"
};
var $8bac72885698a474$export$2e2bcd8739ae039 = Object.freeze($8bac72885698a474$var$permissions);


const $0927d1b8ebebdcf3$var$profile = {
    page_title: "賬戶管理",
    title: "賬戶管理",
    description: "在這裡，你可以修改賬戶設置和管理個人信息，以確保賬戶安全。",
    settings: {
        title: "賬戶設置",
        profile_information: "個人信息",
        avatar: "頭像",
        name: "姓名",
        username: "用戶名"
    },
    link_account: {
        title: "關聯賬戶",
        email_sign_in: "郵件登錄",
        email: "郵件",
        social_sign_in: "社交賬號登錄",
        link_email: "綁定郵箱",
        link_email_subtitle: "綁定郵箱以便登錄或幫助恢復賬戶。",
        email_required: "郵箱不能為空",
        invalid_email: "無效的郵箱地址",
        identical_email_address: "輸入的郵箱地址與當前郵箱地址相同",
        anonymous: "匿名"
    },
    password: {
        title: "密碼與安全",
        password: "密碼",
        password_setting: "密碼設置",
        new_password: "新密碼",
        confirm_password: "確認密碼",
        enter_password: "輸入目前密碼",
        enter_password_subtitle: "為確保帳戶安全，在修改密碼前，請先輸入目前密碼以通過身份驗證。",
        set_password: "設置密碼",
        verify_via_password: "通過密碼驗證",
        show_password: "顯示密碼",
        required: "密碼不能為空",
        do_not_match: "密碼不匹配，請重新輸入。"
    },
    code: {
        enter_verification_code: "輸入驗證碼",
        enter_verification_code_subtitle: "驗證碼已發送至 <strong>{{target}}</strong>",
        verify_via_code: "通過郵箱驗證碼驗證",
        resend: "重新發送驗證碼",
        resend_countdown: "在 {{countdown}} 秒後重新發送"
    },
    delete_account: {
        title: "刪除賬戶",
        label: "刪除賬戶",
        description: "刪除賬戶將會刪除所有個人信息、用戶數據和配置。此操作無法撤銷。",
        button: "刪除賬戶",
        dialog_paragraph_1: "很抱歉聽到你想要刪除你的帳户。刪除你的帳户將永久刪除所有數據，包括用戶信息、日誌和設置，此操作無法撤銷。因此，請確保在繼續之前備份任何重要數據。",
        dialog_paragraph_2: "要繼續刪除帳戶的刪除過程，請通過 <a>電子郵件</a> 向我們的支持團隊發送主題為“帳戶刪除請求”的郵件。我們將協助你並確保所有數據都已從我們的系統中正確刪除。",
        dialog_paragraph_3: "感謝你選擇 Logto Cloud。如果你有任何進一步的問題或疑慮，請隨時與我們聯繫。"
    },
    set: "設置",
    change: "修改",
    link: "關聯",
    unlink: "取消關聯",
    not_set: "未設置",
    change_avatar: "修改頭像",
    change_name: "修改姓名",
    change_username: "修改用戶名",
    set_name: "設置姓名",
    email_changed: "已成功綁定郵箱。",
    password_changed: "已重置密碼。",
    updated: "{{target}}更改成功。",
    linked: "{{target}}賬號綁定成功。",
    unlinked: "{{target}}賬號解綁成功。",
    email_exists_reminder: "該郵箱 {{email}} 已被其他賬號綁定，請更換郵箱。",
    unlink_confirm_text: "確定解綁",
    unlink_reminder: "解綁後，用戶將無法使用該 <span></span> 賬號進行登錄。確定要解綁嗎？"
};
var $0927d1b8ebebdcf3$export$2e2bcd8739ae039 = Object.freeze($0927d1b8ebebdcf3$var$profile);


const $b20d389c08f04cb3$var$role_details = {
    back_to_roles: "返回角色",
    identifier: "識別符",
    delete_description: "這樣做將從受影響的用戶中刪除與該角色關聯的權限，並刪除角色、用戶和權限之間的映射關係。",
    role_deleted: "{{name}} 已成功刪除。",
    settings_tab: "設置",
    users_tab: "用戶",
    m2m_apps_tab: "機器對機器應用",
    permissions_tab: "權限",
    settings: "設置",
    settings_description: "角色是一組權限，可以分配給用戶。它們還提供了一種聚合不同 API 定義的權限的方法，使得添加、刪除或調整權限比將其單獨分配給用戶更有效率。",
    field_name: "名稱",
    field_description: "描述",
    type_m2m_role_tag: "機器對機器應用角色",
    type_user_role_tag: "用戶角色",
    permission: {
        assign_button: "分配權限",
        assign_title: "分配權限",
        assign_subtitle: "將權限分配給此角色。角色將獲得添加的權限，具有此角色的用戶將繼承這些權限。",
        assign_form_field: "分配權限",
        added_text_one: "添加了 {{count, number}} 個權限",
        added_text_other: "添加了 {{count, number}} 個權限",
        api_permission_count_one: "{{count, number}} 個權限",
        api_permission_count_other: "{{count, number}} 個權限",
        confirm_assign: "分配權限",
        permission_assigned: "所選的權限已成功分配給此角色",
        deletion_description: "如果刪除此權限，則具有此角色的受影響用戶將失去此權限授予的訪問權限。",
        permission_deleted: "權限 {{name}} 已成功從此角色中刪除",
        empty: "無可用權限"
    },
    users: {
        assign_button: "分配用戶",
        name_column: "用戶",
        app_column: "應用",
        latest_sign_in_column: "最近登錄",
        delete_description: "它將保留在您的用戶池中，但失去此角色的授權。",
        deleted: "{{name}} 已成功從此角色中刪除",
        assign_title: "分配用戶",
        assign_subtitle: "將用戶分配給此角色。通過搜索名稱、電子郵件、電話或用戶 ID 尋找適當的用戶。",
        assign_field: "分配用戶",
        confirm_assign: "分配用戶",
        assigned_toast_text: "The selected users were successfully assigned to this role",
        empty: "無可用用戶"
    },
    applications: {
        assign_button: "分配應用",
        name_column: "應用",
        app_column: "應用",
        description_column: "描述",
        delete_description: "它將保留在您的應用程式集區中，但喪失此角色的授權。",
        deleted: "{{name}} 已從此角色中成功刪除",
        assign_title: "分配應用",
        assign_subtitle: "將應用程式分配給此角色。通過搜索名稱、描述或應用程式 ID 尋找合適的應用程式。",
        assign_field: "分配應用",
        confirm_assign: "分配應用",
        assigned_toast_text: "The selected applications were successfully assigned to this role",
        empty: "沒有可用的應用程式"
    }
};
var $b20d389c08f04cb3$export$2e2bcd8739ae039 = Object.freeze($b20d389c08f04cb3$var$role_details);


const $6a449469730824c5$var$roles = {
    page_title: "角色",
    title: "角色",
    subtitle: "RBAC 是一種訪問控制方法，它使用角色來決定用戶可以做什麼事情，包括授予用戶訪問特定資源的權限。",
    create: "建立角色",
    role_name: "角色名稱",
    role_type: "角色類型",
    show_role_type_button_text: "顯示更多選項",
    hide_role_type_button_text: "隱藏更多選項",
    type_user: "使用者角色",
    type_machine_to_machine: "機器對機器應用角色",
    role_description: "描述",
    role_name_placeholder: "輸入你的角色名稱",
    role_description_placeholder: "輸入你的角色描述",
    col_roles: "角色",
    col_type: "類型",
    col_description: "描述",
    col_assigned_entities: "已分配",
    user_counts: "{{count}} 個使用者",
    application_counts: "{{count}} 個應用程式",
    user_count: "{{count}} 個使用者",
    application_count: "{{count}} 個應用程式",
    assign_permissions: "分配權限",
    create_role_title: "建立角色",
    create_role_description: "為你的應用程式建立和管理角色。角色包含權限集合，並可以分配給使用者。",
    create_role_button: "建立角色",
    role_created: "角色 {{name}} 已成功建立。",
    search: "按角色名稱、描述或 ID 搜尋",
    placeholder_title: "角色",
    placeholder_description: "角色是可以分配給使用者的權限分組。在建立角色之前，請確保先新增權限。"
};
var $6a449469730824c5$export$2e2bcd8739ae039 = Object.freeze($6a449469730824c5$var$roles);


const $63a98033ddcbce31$var$session_expired = {
    title: "會話已過期",
    subtitle: "會話可能已過期，你已被退出登錄。請點選下方按鈕重新登錄到管理控制臺。",
    button: "重新登錄"
};
var $63a98033ddcbce31$export$2e2bcd8739ae039 = Object.freeze($63a98033ddcbce31$var$session_expired);


const $1d41dfce3927d87f$var$content = {
    terms_of_use: {
        title: "TERMS",
        terms_of_use: "Terms of use URL",
        terms_of_use_placeholder: "https://your.terms.of.use/",
        privacy_policy: "Privacy policy URL",
        privacy_policy_placeholder: "https://your.privacy.policy/"
    },
    languages: {
        title: "LANGUAGES",
        enable_auto_detect: "Enable auto-detect",
        description: "Your software detects the user's locale setting and switches to the local language. You can add new languages by translating UI from English to another language.",
        manage_language: "Manage language",
        default_language: "Default language",
        default_language_description_auto: "The default language will be used when the detected user language isn’t covered in the current language library.",
        default_language_description_fixed: "When auto-detect is off, the default language is the only language your software will show. Turn on auto-detect for language extension."
    },
    manage_language: {
        title: "Manage language",
        subtitle: "Localize the product experience by adding languages and translations. Your contribution can be set as the default language.",
        add_language: "Add Language",
        logto_provided: "Logto provided",
        key: "Key",
        logto_source_values: "Logto source values",
        custom_values: "Custom values",
        clear_all_tip: "Clear all values",
        unsaved_description: "Changes won’t be saved if you leave this page without saving.",
        deletion_tip: "Delete the language",
        deletion_title: "Do you want to delete the added language?",
        deletion_description: "After deletion, your users won’t be able to browse in that language again.",
        default_language_deletion_title: "Default language can’t be deleted.",
        default_language_deletion_description: "{{language}} is set as your default language and can’t be deleted. "
    }
};
var $1d41dfce3927d87f$export$2e2bcd8739ae039 = Object.freeze($1d41dfce3927d87f$var$content);


const $f2642ba7f61bb9c5$var$password_policy = {
    password_requirements: "密碼需求",
    minimum_length: "最小長度",
    minimum_length_description: "美國國家標準與技術研究所 (NIST) 建議網路產品需至少使用 <a>8 個字元</a>。",
    minimum_length_error: "最小長度必須介於 {{min}} 到 {{max}}（包括）之間。",
    minimum_required_char_types: "最低需要的字元類型",
    minimum_required_char_types_description: "字元類型：大寫字母（A-Z）、小寫字母（a-z）、數字（0-9）和特殊符號（{{symbols}}）。",
    password_rejection: "拒絕密碼",
    compromised_passwords: "拒絕已破解的密碼",
    breached_passwords: "遭破解的密碼",
    breached_passwords_description: "拒絕之前在密碼洩漏資料庫中找到的密碼。",
    restricted_phrases: "限制低安全性片語",
    restricted_phrases_tooltip: "除非您結合 3 個或更多的額外字元，否則密碼應避免使用這些片語。",
    repetitive_or_sequential_characters: "重複或連續字元",
    repetitive_or_sequential_characters_description: "例如：“AAAA”，“1234”，和“abcd”。",
    user_information: "用戶資訊",
    user_information_description: "例如，電子郵件地址，電話號碼，用戶名等。",
    custom_words: "自訂字詞",
    custom_words_description: "個性化上下文相關的字詞，不區分大小寫，每行一個。",
    custom_words_placeholder: "您的服務名稱，公司名稱等。"
};
var $f2642ba7f61bb9c5$export$2e2bcd8739ae039 = Object.freeze($f2642ba7f61bb9c5$var$password_policy);


const $0a543a7a7b66534f$var$sign_up_and_sign_in = {
    identifiers_email: "郵件地址",
    identifiers_phone: "手機號碼",
    identifiers_username: "使用者名稱",
    identifiers_email_or_sms: "郵件地址或手機號碼",
    identifiers_none: "無",
    and: "與",
    or: "或",
    sign_up: {
        title: "註冊",
        sign_up_identifier: "註冊標誌",
        identifier_description: "在建立帳戶時，您需要設定註冊標誌。在使用者登錄時，這些資訊是必填的。",
        sign_up_authentication: "註冊身分驗證設置",
        authentication_description: "在註冊時，您的使用者將必須完成所有勾選的任務。",
        set_a_password_option: "建立密碼",
        verify_at_sign_up_option: "驗證身分",
        social_only_creation_description: "（僅適用於社交註冊使用者）"
    },
    sign_in: {
        title: "登入",
        sign_in_identifier_and_auth: "登入標誌和身分驗證設置",
        description: "使用者可以使用任何可用的選項進行登入。拖曳選項即可調整頁面佈局。",
        add_sign_in_method: "新增登入方式",
        password_auth: "密碼",
        verification_code_auth: "驗證碼",
        auth_swap_tip: "交換以下選項的位置即可設定它們在使用者登入流程中出現的先後順序。",
        require_auth_factor: "請至少選擇一種驗證方式。"
    },
    social_sign_in: {
        title: "社交登入",
        social_sign_in: "社交登入",
        description: "您已設定特定的標誌。使用者在通過社交連結器註冊時可能會被要求提供一個對應的標誌。",
        add_social_connector: "新增社交連結器",
        set_up_hint: {
            not_in_list: "沒有你想要的連結器？",
            set_up_more: "立即設定",
            go_to: "參考其他的社交連結器。"
        }
    },
    tip: {
        set_a_password: "啟用使用者名稱註冊，必須設定密碼。",
        verify_at_sign_up: "目前我們僅支持經過驗證的郵件地址登入。如果沒有驗證，你的使用者信息中可能出現大量無效的電子郵件地址。",
        password_auth: "因註冊設置啟用了使用者名稱密碼標誌。在使用者登入時，這個資訊是必填的。",
        verification_code_auth: "因註冊設置啟用了驗證碼標誌，驗證碼屬於使用者必選項，啟用密碼註冊後，你可以選擇關閉驗證碼登入。",
        delete_sign_in_method: "因註冊設置啟用了{{identifier}}標誌。在使用者登入時，這些資訊是必填的。"
    },
    advanced_options: {
        title: "進階選項",
        /** UNTRANSLATED */ enable_single_sign_on: "Enable enterprise Single Sign-On (SSO)",
        /** UNTRANSLATED */ enable_single_sign_on_description: "Enable users to sign-in to the application using Single Sign-On with their enterprise identities.",
        single_sign_on_hint: {
            /** UNTRANSLATED */ prefix: "Go to ",
            /** UNTRANSLATED */ link: '"Enterprise SSO"',
            /** UNTRANSLATED */ suffix: "section to set up more enterprise connectors."
        },
        enable_user_registration: "啟用使用者註冊",
        enable_user_registration_description: "啟用或禁止使用者註冊。禁用後，管理員仍然可以新增使用者，但無法透過登入界面建立帳戶。"
    }
};
var $0a543a7a7b66534f$export$2e2bcd8739ae039 = Object.freeze($0a543a7a7b66534f$var$sign_up_and_sign_in);


const $d1290d1cc40f8804$var$sign_in_exp = {
    page_title: "登錄體驗",
    title: "登錄體驗",
    description: "自定義登錄界面，並實時預覽真實效果",
    tabs: {
        branding: "品牌",
        sign_up_and_sign_in: "註冊與登錄",
        content: "內容",
        password_policy: "密碼規則"
    },
    welcome: {
        title: "自定義登錄體驗",
        description: "通過首次登錄設置快速入門。本指南將帶領你完成所有必要的設置。",
        get_started: "開始",
        apply_remind: "請注意，登錄體驗將會應用到當前帳戶下的所有應用。"
    },
    color: {
        title: "顏色",
        primary_color: "品牌顏色",
        dark_primary_color: "品牌顏色 (深色)",
        dark_mode: "開啟深色模式",
        dark_mode_description: "基於品牌顏色和 Logto 的算法，應用將會有一個自動生成的深色模式。當然，你可以自定義和修改。",
        dark_mode_reset_tip: "基於品牌顏色，重新生成深色模式顏色。",
        reset: "重新生成"
    },
    branding: {
        title: "品牌定制區",
        ui_style: "樣式",
        favicon: "瀏覽器地址欄圖標",
        logo_image_url: "Logo 圖片 URL",
        logo_image_url_placeholder: "https://your.cdn.domain/logo.png",
        dark_logo_image_url: "Logo 圖片 URL (深色)",
        dark_logo_image_url_placeholder: "https://your.cdn.domain/logo-dark.png",
        logo_image: "Logo 圖片",
        dark_logo_image: "Logo 圖片(深色)",
        logo_image_error: "應用 Logo：{{error}}",
        favicon_error: "Favicon：{{error}}"
    },
    custom_css: {
        title: "自定義 CSS",
        css_code_editor_title: "自定義 CSS 個性化你的用戶界面",
        css_code_editor_description1: "查看自定義 CSS 的例子。",
        css_code_editor_description2: "<a>{{link}}</a>",
        css_code_editor_description_link_content: "了解更多",
        css_code_editor_content_placeholder: "輸入 CSS 代碼，修改顏色、字體、組件樣式、布局，定制你的登錄、註冊、忘記密碼等頁面。充分發揮創造力，讓你的用戶界面脫穎而出。"
    },
    sign_up_and_sign_in: $0a543a7a7b66534f$export$2e2bcd8739ae039,
    content: $1d41dfce3927d87f$export$2e2bcd8739ae039,
    password_policy: $f2642ba7f61bb9c5$export$2e2bcd8739ae039,
    setup_warning: {
        no_connector_sms: "尚未設置 SMS 短信連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_email: "尚未設置電子郵件連接器。在完成該配置前，用戶將無法通過此登錄方式登錄。<a>{{link}}</a>連接器。",
        no_connector_social: "您還沒有設置任何社交連接器。首先添加連接器以應用社交登錄方法。<a>{{link}}</a>連接器。",
        setup_link: "立即設置"
    },
    save_alert: {
        description: "你正在進行登錄註冊設置的變更。當前你的所有用戶會受到新設置的影響。確認保存該設置嗎？",
        before: "設置前",
        after: "設置後",
        sign_up: "註冊",
        sign_in: "登錄",
        social: "社交"
    },
    preview: {
        title: "登錄預覽",
        live_preview: "實時預覽",
        live_preview_tip: "保存以預覽更改",
        native: "移動原生",
        desktop_web: "桌面網頁",
        mobile_web: "移動網頁",
        desktop: "桌面網頁",
        mobile: "行動裝置"
    }
};
var $d1290d1cc40f8804$export$2e2bcd8739ae039 = Object.freeze($d1290d1cc40f8804$var$sign_in_exp);


const $b77dfeac37a7da5a$var$quota_item = {
    tenant_limit: {
        name: "租戶",
        limited: "{{count, number}} 租戶",
        limited_other: "{{count, number}} 租戶",
        unlimited: "不限租戶數",
        not_eligible: "移除您的租戶"
    },
    mau_limit: {
        name: "月活用戶",
        limited: "{{count, number}} 月活用戶",
        unlimited: "不限月活用戶數",
        not_eligible: "移除您的所有用戶"
    },
    applications_limit: {
        name: "應用程式",
        limited: "{{count, number}} 應用程式",
        limited_other: "{{count, number}} 應用程式",
        unlimited: "不限應用程式數",
        not_eligible: "移除您的應用程式"
    },
    machine_to_machine_limit: {
        name: "機器對機器應用程式",
        limited: "{{count, number}} 機器對機器應用程式",
        limited_other: "{{count, number}} 機器對機器應用程式",
        unlimited: "不限機器對機器應用程式數",
        not_eligible: "移除您的機器對機器應用程式"
    },
    resources_limit: {
        name: "API 資源",
        limited: "{{count, number}} API 資源",
        limited_other: "{{count, number}} API 資源",
        unlimited: "不限 API 資源數",
        not_eligible: "移除您的 API 資源"
    },
    scopes_per_resource_limit: {
        name: "資源權限",
        limited: "{{count, number}} 權限每資源",
        limited_other: "{{count, number}} 權限每資源",
        unlimited: "不限權限每資源數",
        not_eligible: "移除您的資源權限"
    },
    custom_domain_enabled: {
        name: "自訂網域",
        limited: "自訂網域",
        unlimited: "自訂網域",
        not_eligible: "移除您的自訂網域"
    },
    omni_sign_in_enabled: {
        name: "全渠道登入",
        limited: "全渠道登入",
        unlimited: "全渠道登入",
        not_eligible: "停用全渠道登入"
    },
    built_in_email_connector_enabled: {
        name: "內建電子郵件連接程式",
        limited: "內建電子郵件連接程式",
        unlimited: "內建電子郵件連接程式",
        not_eligible: "移除您的內建電子郵件連接程式"
    },
    social_connectors_limit: {
        name: "社交連接程式",
        limited: "{{count, number}} 社交連接程式",
        limited_other: "{{count, number}} 社交連接程式",
        unlimited: "不限社交連接程式數",
        not_eligible: "移除您的社交連接程式"
    },
    standard_connectors_limit: {
        name: "免費標準連接程式",
        limited: "{{count, number}} 免費標準連接程式",
        limited_other: "{{count, number}} 免費標準連接程式",
        unlimited: "不限標準連接程式數",
        not_eligible: "移除您的標準連接程式"
    },
    roles_limit: {
        name: "角色",
        limited: "{{count, number}} 角色",
        limited_other: "{{count, number}} 角色",
        unlimited: "不限角色數",
        not_eligible: "移除您的角色"
    },
    scopes_per_role_limit: {
        name: "角色權限",
        limited: "{{count, number}} 權限每角色",
        limited_other: "{{count, number}} 權限每角色",
        unlimited: "不限權限每角色數",
        not_eligible: "移除您的角色權限"
    },
    hooks_limit: {
        name: "Webhooks",
        limited: "{{count, number}}個 Webhook",
        limited_other: "{{count, number}}個 Webhooks",
        unlimited: "無限制的 Webhooks",
        not_eligible: "移除您的 Webhooks"
    },
    organizations_enabled: {
        /** UNTRANSLATED */ name: "Organizations",
        /** UNTRANSLATED */ limited: "Organizations",
        /** UNTRANSLATED */ unlimited: "Organizations",
        /** UNTRANSLATED */ not_eligible: "Remove your organizations"
    },
    audit_logs_retention_days: {
        name: "審計記錄保留期限",
        limited: "審計記錄保留期限：{{count, number}} 天",
        limited_other: "審計記錄保留期限：{{count, number}} 天",
        unlimited: "不限天數",
        not_eligible: "無審計記錄"
    },
    community_support_enabled: {
        name: "社群支援",
        limited: "社群支援",
        unlimited: "社群支援",
        not_eligible: "無社群支援"
    },
    customer_ticket_support: {
        name: "客戶票證支援",
        limited: "{{count, number}} 小時客戶票證支援",
        limited_other: "{{count, number}} 小時客戶票證支援",
        unlimited: "客戶票證支援",
        not_eligible: "無客戶票證支援"
    },
    mfa_enabled: {
        name: "MFA",
        limited: "MFA",
        unlimited: "MFA",
        not_eligible: "停用你的 MFA"
    },
    sso_enabled: {
        name: "企業SSO",
        limited: "企業SSO",
        unlimited: "企業SSO",
        not_eligible: "停用你的企業SSO"
    }
};
var $b77dfeac37a7da5a$export$2e2bcd8739ae039 = Object.freeze($b77dfeac37a7da5a$var$quota_item);


const $c0deed75dd3f7b8f$var$quota_table = {
    quota: {
        title: "配額",
        tenant_limit: "租戶限制",
        base_price: "基本價格",
        mau_unit_price: "* 每月活躍使用者（MAU）單價",
        mau_limit: "MAU 限制"
    },
    application: {
        title: "應用程式",
        total: "總應用程式數",
        m2m: "機器對機器"
    },
    resource: {
        title: "API 資源",
        resource_count: "資源數量",
        scopes_per_resource: "每資源權限"
    },
    branding: {
        title: "使用者介面和品牌塑造",
        custom_domain: "自訂網域",
        custom_css: "自訂 CSS",
        app_logo_and_favicon: "應用程式標誌和網站圖示",
        dark_mode: "深色模式",
        i18n: "國際化"
    },
    user_authn: {
        title: "使用者認證",
        omni_sign_in: "全渠道登錄",
        password: "密碼",
        passwordless: "免密碼登入 - 電子郵件和簡訊",
        email_connector: "電子郵件連接器",
        sms_connector: "簡訊連接器",
        social_connectors: "社交連接器",
        standard_connectors: "標準連接器",
        built_in_email_connector: "內建電子郵件連接器",
        mfa: "多因素認證",
        sso: "企業 SSO"
    },
    user_management: {
        title: "使用者管理",
        user_management: "使用者管理",
        roles: "角色",
        scopes_per_role: "每角色權限"
    },
    audit_logs: {
        title: "稽核日誌",
        retention: "保留期限"
    },
    hooks: {
        title: "Webhooks",
        hooks: "Webhooks"
    },
    organizations: {
        title: "組織",
        /** UNTRANSLATED */ organizations: "Organizations"
    },
    support: {
        title: "支援",
        community: "社群",
        customer_ticket: "客戶支援票證",
        premium: "進階版"
    },
    mau_unit_price_footnote: "* 您的每月活躍使用者（MAU）將根據在結算週期內登錄的頻率分為3個層級。每個層級都有不同的MAU單價。",
    unlimited: "無限制",
    contact: "聯絡",
    monthly_price: "${{value, number}}/月",
    mau_price: "${{value, number}}/MAU",
    days_one: "{{count, number}} 天",
    days_other: "{{count, number}} 天",
    add_on: "附加功能",
    tier: "層級{{value, number}}："
};
var $c0deed75dd3f7b8f$export$2e2bcd8739ae039 = Object.freeze($c0deed75dd3f7b8f$var$quota_table);


const $f2a1ad7bd9a3c597$var$subscription = {
    free_plan: "免費方案",
    free_plan_description: "適用於旁邊項目和開始使用 Logto 的試用。無需信用卡。",
    hobby_plan: "業餘方案",
    hobby_plan_description: "適用於個人開發者或小型工程團隊。",
    pro_plan: "專業方案",
    pro_plan_description: "企業無憂享受 Logto 服務。",
    enterprise: "企業版",
    current_plan: "當前方案",
    current_plan_description: "這是您目前的方案。您可以輕鬆查看您的方案使用情況，檢查即將到來的帳單，並根據需要進行變更。",
    plan_usage: "計劃使用情況",
    plan_cycle: "計劃週期：{{period}}。使用情況訂閱日期為{{renewDate}}。",
    next_bill: "您的下一個帳單",
    next_bill_hint: "要了解更多計算方法，請參閱本<a>文章</a>。",
    next_bill_tip: "即將到期的帳單包括您的計劃下個月的基本價格，以及各級別 MAU 單價乘以使用量的費用。",
    manage_payment: "管理付款",
    overfill_quota_warning: "您已達到配額限制。為防止出現問題，請升級計畫。",
    upgrade_pro: "升級專業",
    update_payment: "更新付款信息",
    payment_error: "偵測到付款問題。無法處理以前週期的 {{price, number}}$ 。更新付款以避免 Logto 服務中止。",
    downgrade: "降級",
    current: "當前",
    upgrade: "升級",
    quota_table: $c0deed75dd3f7b8f$export$2e2bcd8739ae039,
    billing_history: {
        invoice_column: "發票",
        status_column: "狀態",
        amount_column: "金額",
        invoice_created_date_column: "發票創建日期",
        invoice_status: {
            void: "已取消",
            paid: "已付款",
            open: "未完成",
            uncollectible: "逾期未付款"
        }
    },
    quota_item: $b77dfeac37a7da5a$export$2e2bcd8739ae039,
    downgrade_modal: {
        title: "您確定要降級嗎？",
        description: "如果您選擇切換到 <targetName/>，請注意您將不再使用之前在 <currentName/> 中的配額和功能。",
        before: "在此之前：<name/>",
        after: "在此之後：<name/>",
        downgrade: "降級"
    },
    not_eligible_modal: {
        downgrade_title: "您不符合降級條件",
        downgrade_description: "降級到<name/>前，請確保符合以下條件。",
        downgrade_help_tip: "需要降級幫助？<a>聯絡我們</a>。",
        upgrade_title: "致尊敬的早期採用者的友善提醒",
        upgrade_description: "您目前的使用量超過了 <name /> 允許的範圍。Logto 現已正式發布，包括針對每個計劃量身定制的功能。在考慮升級到 <name /> 之前，請確保您符合以下升級條件。",
        upgrade_pro_tip: " 或者考慮升級到專業版計劃。",
        upgrade_help_tip: "需要升級幫助？<a>聯絡我們</a>。",
        a_maximum_of: "最多<item/>"
    },
    upgrade_success: "已成功升級到 <name/>",
    downgrade_success: "已成功降級到 <name/>",
    subscription_check_timeout: "訂閱檢查已逾時，請稍後重新刷新。",
    /** UNTRANSLATED */ no_subscription: "No subscription"
};
var $f2a1ad7bd9a3c597$export$2e2bcd8739ae039 = Object.freeze($f2a1ad7bd9a3c597$var$subscription);


const $2e96f8bc6ec72154$var$tab_sections = {
    overview: "概觀",
    resources: "資源",
    users: "使用者",
    access_control: "訪問控制",
    help_and_support: "幫助與支持",
    tenant: "租戶",
    automation: "自動化"
};
var $2e96f8bc6ec72154$export$2e2bcd8739ae039 = Object.freeze($2e96f8bc6ec72154$var$tab_sections);


const $b9efec3459dcc4d9$var$tabs = {
    get_started: "開始上手",
    dashboard: "儀表板",
    applications: "全部應用",
    api_resources: "API 資源",
    sign_in_experience: "登入體驗",
    connectors: "連接器",
    enterprise_sso: "Enterprise SSO",
    webhooks: "Webhooks",
    organizations: "組織",
    users: "使用者管理",
    audit_logs: "稽核日誌",
    roles: "角色",
    docs: "文件",
    tenant_settings: "租戶設定",
    mfa: "多重認證"
};
var $b9efec3459dcc4d9$export$2e2bcd8739ae039 = Object.freeze($b9efec3459dcc4d9$var$tabs);


const $5c86b69d7ac23997$var$tenants = {
    title: "設置",
    description: "高效管理租戶設定並自訂您的網域。",
    tabs: {
        settings: "設置",
        domains: "網域",
        subscription: "方案與計費",
        billing_history: "帳單歷史記錄"
    },
    settings: {
        title: "設定",
        /** UNTRANSLATED */ description: "Set the tenant name and view your data hosted region and tenant type.",
        tenant_id: "租戶 ID",
        tenant_name: "租戶名稱",
        tenant_region: "資料托管地區",
        tenant_region_tip: "您的租戶資源托管於 {{region}}。 <a>了解更多</a>",
        environment_tag_development: "開發",
        environment_tag_staging: "預置",
        environment_tag_production: "產品",
        /** UNTRANSLATED */ tenant_type: "Tenant type",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required. It has all the pro features but has limitations like a sign-in banner. <a>Learn more</a>",
        /** UNTRANSLATED */ production_description: "Intended for apps that are being used by end-users and may require a paid subscription. <a>Learn more</a>",
        tenant_info_saved: "租戶資訊成功儲存。"
    },
    full_env_tag: {
        development: "開發",
        production: "產品"
    },
    deletion_card: {
        title: "刪除",
        tenant_deletion: "刪除租戶",
        tenant_deletion_description: "刪除租戶將導致所有相關的使用者資料和設定永久移除。請謹慎進行。",
        tenant_deletion_button: "刪除租戶"
    },
    create_modal: {
        title: "建立客戶",
        subtitle: "創建一個具有隔離資源和用戶的新租戶。數據托管的區域和租戶類型在創建後無法修改。",
        tenant_usage_purpose: "您希望將此租戶用於什麼目的？",
        /** UNTRANSLATED */ development_description: "For testing only and shouldn't be used in production. No subscription is required.",
        /** UNTRANSLATED */ development_hint: "It has all the pro features but has limitations like a sign-in banner.",
        /** UNTRANSLATED */ production_description: "For use by end-users and may require a paid subscription.",
        available_plan: "可用方案：",
        create_button: "建立租戶",
        tenant_name_placeholder: "我的租戶"
    },
    dev_tenant_migration: {
        /** UNTRANSLATED */ title: 'You can now try our Hobby and Pro features for free by creating a new "Development tenant"!',
        /** UNTRANSLATED */ affect_title: "How does this affect you?",
        /** UNTRANSLATED */ hint_1: "We are replacing the old <strong>environment tags</strong> with two new tenant types: <strong>“Development”</strong> and <strong>“Production”</strong>.",
        /** UNTRANSLATED */ hint_2: "To ensure a seamless transition and uninterrupted functionality, all early-created tenants will be elevated to the <strong>Production</strong> tenant type along with your previous subscription.",
        /** UNTRANSLATED */ hint_3: "Don't worry, all your other settings will remain the same.",
        /** UNTRANSLATED */ about_tenant_type: "About tenant type"
    },
    dev_tenant_notification: {
        /** UNTRANSLATED */ title: "You can now access <a>all features of Logto Hobby and Pro</a> in your development tenant!",
        /** UNTRANSLATED */ description: "It's completely free, with no trial period – forever!"
    },
    delete_modal: {
        title: "刪除租戶",
        description_line1: '您確定要刪除帶有環境標籤 "<span>{{tag}}</span>" 的租戶 "<span>{{name}}</span>"？此操作無法撤銷，並將永久刪除所有您的數據和帳戶信息。',
        description_line2: "在刪除帳戶前，也許我們能提供幫助。<span><a>通過電子郵件與我們聯繫</a></span>",
        description_line3: '如果您確定要繼續，請輸入租戶名稱 "<span>{{name}}</span>" 以確認。',
        delete_button: "永久刪除",
        cannot_delete_title: "無法刪除此租戶",
        cannot_delete_description: "抱歉，您現在無法刪除此租戶。請確保您處於免費方案並已支付所有未結賬單。"
    },
    tenant_landing_page: {
        title: "您尚未建立租戶",
        description: "要開始使用Logto配置您的項目，請創建一個新租戶。如果您需要登出或刪除您的帳戶，只需點擊右上角的頭像按鈕。",
        create_tenant_button: "創建租戶"
    },
    status: {
        mau_exceeded: "超過MAU限制",
        suspended: "暫停",
        overdue: "逾期"
    },
    tenant_suspended_page: {
        title: "租戶暫停。聯繫我們以恢復存取。",
        description_1: "很抱歉通知您，由於不當使用，包括超過 MAU 限制、逾期付款或其他未經授權的操作，您的租戶帳戶已被暫時停用。",
        description_2: "如果您需要進一步的說明、有任何疑慮或希望恢復全部功能並解鎖您的租戶，請立即聯絡我們。"
    },
    signing_keys: {
        title: "签名密钥",
        description: "在您的租戶中安全管理签名密钥。",
        type: {
            private_key: "OIDC 私鑰",
            cookie_key: "OIDC Cookie 密鑰"
        },
        private_keys_in_use: "正在使用的私鑰",
        cookie_keys_in_use: "正在使用的 Cookie 密鑰",
        rotate_private_keys: "輪換私鑰",
        rotate_cookie_keys: "輪換 Cookie 密鑰",
        rotate_private_keys_description: "此操作將創建一個新的私密簽名密鑰，輪換當前密鑰並刪除之前的密鑰。您的使用當前密鑰簽署的 JWT 憑證在刪除或另一輪輪換之前仍然有效。",
        rotate_cookie_keys_description: "此操作將創建一個新的 Cookie 密鑰，輪換當前密鑰並刪除之前的密鑰。使用當前密鑰簽署的 Cookie 將在刪除或另一輪輪換之前仍然有效。",
        select_private_key_algorithm: "選擇新私鑰的簽名演算法",
        rotate_button: "輪換",
        table_column: {
            id: "ID",
            status: "狀態",
            algorithm: "簽名演算法"
        },
        status: {
            current: "當前的",
            previous: "之前的"
        },
        reminder: {
            rotate_private_key: "您確定要輪換<strong>OIDC私鑰</strong>嗎？新發放的 JWT 憑證將由新的密鑰簽署。現有的 JWT 憑證仍然有效，直到下一輪輪換或刪除。",
            rotate_cookie_key: "您確定要輪換<strong>OIDC Cookie 密鑰</strong>嗎？在登入會話中生成的新 Cookie 將由新的 Cookie 密鑰簽署。現有 Cookie 在下一輪輪換或刪除之前仍然有效。",
            delete_private_key: "您確定要刪除<strong>OIDC私鑰</strong>嗎？使用此私密簽名密鑰簽署的現有 JWT 憑證將不再有效。",
            delete_cookie_key: "您確定要刪除<strong>OIDC Cookie 密鑰</strong>嗎？用此 Cookie 密鑰簽署的舊登入會話將不再有效。這些使用者需要重新驗證。"
        },
        messages: {
            rotate_key_success: "密鑰輪換成功。",
            delete_key_success: "密鑰刪除成功。"
        }
    }
};
var $5c86b69d7ac23997$export$2e2bcd8739ae039 = Object.freeze($5c86b69d7ac23997$var$tenants);


const $05a82f9948e22ddd$var$topbar = {
    docs: "文件",
    help: "幫助"
};
var $05a82f9948e22ddd$export$2e2bcd8739ae039 = Object.freeze($05a82f9948e22ddd$var$topbar);


const $58c36ae3c088d037$var$paywall = {
    applications: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    applications_other: "已達到 <planName/> 的{{count, number}}個應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_feature: "升級至 <strong>Hobby</strong> 計劃以解鎖 1 個機器對機器應用程式，或選擇 <strong>Pro</strong> 計劃享有無限使用。如需任何幫助，歡迎<a>聯絡我們</a>。",
    machine_to_machine: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    machine_to_machine_other: "已達到 <planName/> 的{{count, number}}個機器對機器應用程式限制。升級計劃以滿足團隊需求。如需任何協助，歡迎<a>聯絡我們</a>。",
    resources: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    resources_other: "已達到<planName/>的{{count, number}}個 API 資源限制。升級計劃以滿足您團隊的需求。<a>聯繫我們</a>尋求幫助。",
    scopes_per_resource: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_resource_other: "已達到<planName/>的{{count, number}}個 API 資源每個權限限制。立即升級以擴展。如需任何幫助，請<a>聯繫我們</a>。",
    custom_domain: "升級至 <strong>Hobby</strong> 或 <strong>Pro</strong> 計劃以解鎖自訂網域功能。如有任何需要協助，請隨時<a>聯繫我們</a>。",
    social_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    social_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_feature: "升級至 <strong>Hobby</strong> 或 <strong>Pro</strong> 計劃以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器，享有無限社交連接器和所有高級功能。如需任何協助，歡迎<a>聯繫我們</a>。",
    standard_connectors: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_other: "已達到<planName/>的{{count, number}}個社交連接器限制。為滿足您團隊的需求，請升級計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_pro: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    standard_connectors_pro_other: "已達到<planName/>的{{count, number}}個標準連接器限制。為滿足您團隊的需求，請升級至企業版計劃以獲取額外的社交連接器，並可以使用 OIDC、OAuth 2.0 和 SAML 協議創建您自己的連接器。如需任何幫助，請<a>聯繫我們</a>。",
    roles: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    roles_other: "已達到<planName/>的{{count, number}}個角色限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_role: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    scopes_per_role_other: "已達到<planName/>的{{count, number}}個角色每個權限限制。升級計劃以添加額外的角色和權限。如需任何幫助，請<a>聯繫我們</a>。",
    hooks: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯繫我們</a>。",
    hooks_other: "已達到<planName/>的{{count, number}}個 Webhook 限制。升級計劃以創建更多 Webhook。如需任何幫助，請<a>聯繫我們</a>。",
    mfa: "升級到付費計劃以解鎖MFA以提高安全性。如果需要任何協助，請隨時<a>聯繫我們</a>。",
    /** UNTRANSLATED */ organizations: "Unlock organizations by upgrading to a paid plan. Don’t hesitate to <a>contact us</a> if you need any assistance."
};
var $58c36ae3c088d037$export$2e2bcd8739ae039 = Object.freeze($58c36ae3c088d037$var$paywall);


const $9ddc5d6ed775d8d5$var$upsell = {
    upgrade_plan: "升級計劃",
    compare_plans: "比較計劃",
    view_plans: "查看計劃",
    create_tenant: {
        title: "選擇您的租戶計劃",
        description: "Logto 提供創新且經濟實惠的定價計劃，旨在為不斷發展的公司提供競爭優勢。 <a>了解更多</a>",
        base_price: "基礎價格",
        monthly_price: "每月 {{value, number}}",
        mau_unit_price: "MAU 單價",
        view_all_features: "查看所有功能",
        select_plan: "選擇<name/>",
        free_tenants_limit: "最多{{count, number}}個免費租戶",
        free_tenants_limit_other: "最多{{count, number}}個免費租戶",
        most_popular: "最受歡迎",
        upgrade_success: "成功升級至<name/>"
    },
    mau_exceeded_modal: {
        title: "MAU 超過限制，請升級您的計劃。",
        notification: "您當前的 MAU 已超過<planName/>的限制。請立即升級到高級計劃，以避免 Logto 服務的暫停。",
        update_plan: "更新計劃"
    },
    payment_overdue_modal: {
        title: "賬單逾期未付",
        notification: "糟糕！租戶<span>{{name}}</span>的賬單支付失敗。請儘快支付賬單，以避免Logto服務中止。",
        unpaid_bills: "未付賬單",
        update_payment: "更新支付"
    },
    paywall: $58c36ae3c088d037$export$2e2bcd8739ae039
};
var $9ddc5d6ed775d8d5$export$2e2bcd8739ae039 = Object.freeze($9ddc5d6ed775d8d5$var$upsell);


const $90836669aa0014c6$var$user_details = {
    page_title: "用戶詳情",
    back_to_users: "返回用戶管理",
    created_title: "用戶創建成功",
    created_guide: "這是用戶登錄過程中的信息。",
    created_email: "電子郵箱地址：",
    created_phone: "手機號碼：",
    created_username: "用戶名：",
    created_password: "密碼：",
    menu_delete: "刪除用戶",
    delete_description: "本操作將永久刪除該用戶，且無法撤銷。",
    deleted: "用戶已成功刪除。",
    reset_password: {
        reset_password: "重置密碼",
        title: "確定要重置密碼？",
        content: "本操作不可撤銷，將會重置用戶的登入資訊。",
        congratulations: "該用戶已被重置",
        new_password: "新密碼："
    },
    tab_settings: "設定",
    tab_roles: "角色",
    tab_logs: "用戶日誌",
    tab_organizations: "組織",
    authentication: "身份驗證",
    authentication_description: "每個用戶都有一個包含所有用戶資訊的個人資料。它由基本數據、社交身份和自定義數據組成。",
    user_profile: "使用者檔案",
    field_email: "電子郵箱",
    field_phone: "手機號碼",
    field_username: "用戶名",
    field_name: "姓名",
    field_avatar: "頭像圖片連結",
    field_avatar_placeholder: "https://your.cdn.domain/avatar.png",
    field_custom_data: "自定義數據",
    field_custom_data_tip: "預定義屬性之外的用戶資訊，例如用戶偏好的顏色和語言。",
    field_connectors: "社交帳號",
    field_sso_connectors: "企業連接",
    custom_data_invalid: "自定義數據必須是有效的 JSON 對象",
    connectors: {
        connectors: "連接器",
        user_id: "用戶ID",
        remove: "刪除",
        connected: "該用戶已連接多個社交連接器。",
        not_connected: "該用戶還沒有綁定社交帳號",
        deletion_confirmation: "您正在刪除現有的<name/>身份。你確定要繼續嗎？"
    },
    sso_connectors: {
        connectors: "連接器",
        enterprise_id: "企業ID",
        connected: "該用戶已連接至多個企業身份提供者進行單一登錄。",
        not_connected: "該用戶尚未連接到任何企業身份提供者進行單一登錄。"
    },
    mfa: {
        field_name: "多因素驗證",
        field_description: "這個用戶已啟用2步驗證因素。",
        name_column: "多因素驗證",
        field_description_empty: "此使用者尚未啟用兩步驗證因素。",
        deletion_confirmation: "您正在刪除現有的雙步驗證中的 <name/>。你確定要繼續嗎？"
    },
    suspended: "已禁用",
    suspend_user: "禁用用戶",
    suspend_user_reminder: "你確定要禁用這個用戶嗎？用戶將無法登錄你的應用程式，並且在當前令牌過期後將無法獲取新的訪問令牌。此外，此用戶發出的任何 API 請求都將失敗。",
    suspend_action: "禁用",
    user_suspended: "用戶已被禁用。",
    reactivate_user: "啟用用戶",
    reactivate_user_reminder: "你確定要啟用這個用戶嗎？這將允許該用戶的任何登錄嘗試。",
    reactivate_action: "啟用",
    user_reactivated: "用戶已被啟用。",
    roles: {
        name_column: "角色名稱",
        description_column: "描述",
        assign_button: "分配角色",
        delete_description: "此操作將從此用戶中刪除此角色。角色本身仍將存在，但不再與此用戶相關聯。",
        deleted: "已成功將 {{name}} 從此用戶中刪除。",
        assign_title: "將角色分配給 {{name}}",
        assign_subtitle: "為 {{name}} 授權一個或多個角色",
        assign_role_field: "分配角色",
        role_search_placeholder: "按角色名稱搜索",
        added_text: "添加了 {{value, number}} 個",
        assigned_user_count: "{{value, number}} 個用戶",
        confirm_assign: "分配角色",
        role_assigned: "已成功分配角色",
        search: "按角色名稱、描述或 ID 搜索",
        empty: "無可用角色"
    },
    warning_no_sign_in_identifier: "使用者需要至少擁有一個登入標識（使用者名稱、電子郵件、電話號碼或社交帳號）才能登入。確定要繼續嗎？",
    organization_roles_tooltip: "該組織中分配給該用戶的角色。"
};
var $90836669aa0014c6$export$2e2bcd8739ae039 = Object.freeze($90836669aa0014c6$var$user_details);


const $e3f60a7802063be8$var$users = {
    page_title: "用戶管理",
    title: "用戶管理",
    subtitle: "管理你的用戶，包括創建新用戶，編輯用戶資料，查看用戶日誌，以及重新設置密碼和刪除用戶",
    create: "添加用戶",
    create_subtitle: "請至少提供以下其中一個欄位以繼續操作。",
    error_missing_identifier: "你必須提供至少一個註冊標識來創建用戶。",
    user_name: "用戶",
    application_name: "註冊應用",
    latest_sign_in: "最後登錄",
    create_form_username: "用戶名",
    create_form_password: "密碼",
    create_form_name: "姓名",
    placeholder_name: "張三",
    placeholder_email: "example@example.com",
    placeholder_username: "user123",
    placeholder_phone: "+886 2 1234 5678",
    unnamed: "未命名",
    search: "按姓名、電子郵件、電話或用戶名搜索",
    check_user_detail: "查看用戶詳情",
    placeholder_title: "用戶管理",
    placeholder_description: "每個用戶都有一個包含所有用戶信息的個人資料。它由基本數據、社交身份和自定義數據組成。"
};
var $e3f60a7802063be8$export$2e2bcd8739ae039 = Object.freeze($e3f60a7802063be8$var$users);


const $ff7103b4b968f778$var$webhook_details = {
    page_title: "Webhook 詳情",
    back_to_webhooks: "返回 Webhooks",
    not_in_use: "未使用",
    success_rate: "成功率",
    requests: "24 小時內 {{value, number}} 個請求",
    disable_webhook: "停用 Webhook",
    disable_reminder: "確定要重新啟用此 Webhook 嗎？繼續操作後，將不會向端點 URL 發送 HTTP 請求。",
    webhook_disabled: "Webhook 已成功停用。",
    webhook_reactivated: "Webhook 已成功重新啟用。",
    reactivate_webhook: "重新啟用 Webhook",
    delete_webhook: "刪除 Webhook",
    deletion_reminder: "您正在移除此 Webhook。刪除後，將不會向端點 URL 發送 HTTP 請求。",
    deleted: "Webhook 已成功刪除。",
    settings_tab: "設置",
    recent_requests_tab: "最近的請求 (24h)",
    settings: {
        settings: "設置",
        settings_description: "Webhooks 允許您即時接收特定事件的更新，通過向您的端點 URL 發送 POST 請求。這使您能夠根據接收到的新信息立即採取行動。",
        events: "事件",
        events_description: "選擇觸發 Logto 發送 POST 請求的觸發器事件。",
        name: "名稱",
        endpoint_url: "端點 URL",
        signing_key: "簽名密鑰",
        signing_key_tip: "將 Logto 提供的密鑰添加到您的端點作為請求標頭，以確保 Webhook 的有效載荷的真實性。",
        regenerate: "重新生成",
        regenerate_key_title: "重新生成簽名密鑰",
        regenerate_key_reminder: "您確定要修改簽名密鑰嗎？重新生成將立即生效。請記得同步修改端點中的簽名密鑰。",
        regenerated: "簽名密鑰已重新生成。",
        custom_headers: "自定義標頭",
        custom_headers_tip: "您可以選擇將自定義標頭添加到有效載荷中，以提供有關事件的其他上下文或元數據。",
        key_duplicated_error: "Key 不能重複。",
        key_missing_error: "必須填寫 Key。",
        value_missing_error: "未填寫值。",
        invalid_key_error: "Key 無效",
        invalid_value_error: "值無效",
        test: "測試",
        test_webhook: "測試您的 Webhook",
        test_webhook_description: "配置 Webhook，並使用每個選定事件的有效載荷示例進行測試，以驗證正確的接收和處理。",
        send_test_payload: "發送測試有效載荷",
        test_result: {
            endpoint_url: "端點URL：{{url}}",
            message: "訊息：{{message}}",
            response_status: "回應狀態：{{status, number}}",
            response_body: "回應主體：{{body}}",
            request_time: "請求時間：{{time}}",
            test_success: "向端點發起的 webhook 測試成功。"
        }
    }
};
var $ff7103b4b968f778$export$2e2bcd8739ae039 = Object.freeze($ff7103b4b968f778$var$webhook_details);


const $9b2079e77cdde465$var$webhooks = {
    page_title: "Webhooks",
    title: "Webhooks",
    subtitle: "創建 Webhook 以輕鬆收到特定事件的即時更新。",
    create: "創建 Webhook",
    events: {
        post_register: "創建新帳戶",
        post_sign_in: "登錄",
        post_reset_password: "重置密碼"
    },
    table: {
        name: "名稱",
        events: "事件",
        success_rate: "成功率 (24h)",
        requests: "請求數量 (24h)"
    },
    placeholder: {
        title: "Webhook",
        description: "創建 Webhook 以收到通過 POST 請求發送到您的端點 URL 的即時更新。保持資訊，對「創建帳戶」「登錄」和「重置密碼」等事件立即採取行動。",
        create_webhook: "創建 Webhook"
    },
    create_form: {
        title: "創建 Webhook",
        subtitle: "添加 Webhook 以發送 POST 請求到端點 URL，包含任何用戶事件的詳細信息。",
        events: "事件",
        events_description: "選擇 Logto 將發送 POST 請求的觸發事件。",
        name: "名稱",
        name_placeholder: "輸入 webhook 名稱",
        endpoint_url: "端點 URL",
        endpoint_url_placeholder: "https://your.webhook.endpoint.url",
        endpoint_url_tip: "輸入您的端點 URL，當事件發生時會將 Webhook 的載荷發送到該 URL。",
        create_webhook: "創建 webhook",
        missing_event_error: "您需要選擇至少一個事件。"
    },
    webhook_created: "Webhook {{name}} 已成功創建。"
};
var $9b2079e77cdde465$export$2e2bcd8739ae039 = Object.freeze($9b2079e77cdde465$var$webhooks);


const $d695b5ea412823d7$var$welcome = {
    title: "歡迎來到管理控制台",
    description: "管理控制台是一個無需代碼操作的應用。你可以用它來管理登入體驗。讓我們首先創建一個帳號。你可以用它以個人或公司的身份管理 Logto。",
    create_account: "創建帳號"
};
var $d695b5ea412823d7$export$2e2bcd8739ae039 = Object.freeze($d695b5ea412823d7$var$welcome);


const $c7d123bdd9d9eebe$var$admin_console = {
    title: "管理控制台",
    admin_user: "管理員",
    system_app: "系統應用",
    menu: $35319f676cb20684$export$2e2bcd8739ae039,
    general: $ce0ff4fa6a87086c$export$2e2bcd8739ae039,
    errors: $684ca0aa41880782$export$2e2bcd8739ae039,
    tab_sections: $2e96f8bc6ec72154$export$2e2bcd8739ae039,
    tabs: $b9efec3459dcc4d9$export$2e2bcd8739ae039,
    applications: $e20c672de35594bc$export$2e2bcd8739ae039,
    application_details: $9e76fbfee01460d6$export$2e2bcd8739ae039,
    api_resources: $8a009db181f0c993$export$2e2bcd8739ae039,
    api_resource_details: $094396c86f482a56$export$2e2bcd8739ae039,
    connectors: $3c6ea2d0b813e4fc$export$2e2bcd8739ae039,
    connector_details: $d2986f291cdd315b$export$2e2bcd8739ae039,
    enterprise_sso: $bf19b4f50222af74$export$2e2bcd8739ae039,
    enterprise_sso_details: $495c73ebdc51711e$export$2e2bcd8739ae039,
    get_started: $2ea680ba01895964$export$2e2bcd8739ae039,
    users: $e3f60a7802063be8$export$2e2bcd8739ae039,
    user_details: $90836669aa0014c6$export$2e2bcd8739ae039,
    contact: $291fb9ca00ae5165$export$2e2bcd8739ae039,
    sign_in_exp: $d1290d1cc40f8804$export$2e2bcd8739ae039,
    dashboard: $5daec76e4f7faea2$export$2e2bcd8739ae039,
    logs: $b3426bc0f3c02c53$export$2e2bcd8739ae039,
    log_details: $5d11e004a17e3909$export$2e2bcd8739ae039,
    session_expired: $63a98033ddcbce31$export$2e2bcd8739ae039,
    welcome: $d695b5ea412823d7$export$2e2bcd8739ae039,
    roles: $6a449469730824c5$export$2e2bcd8739ae039,
    role_details: $b20d389c08f04cb3$export$2e2bcd8739ae039,
    permissions: $8bac72885698a474$export$2e2bcd8739ae039,
    cloud: $b603de13d893e21b$export$2e2bcd8739ae039,
    profile: $0927d1b8ebebdcf3$export$2e2bcd8739ae039,
    components: $1423991d3d82042e$export$2e2bcd8739ae039,
    webhooks: $9b2079e77cdde465$export$2e2bcd8739ae039,
    webhook_details: $ff7103b4b968f778$export$2e2bcd8739ae039,
    domain: $b5a38a56845553a7$export$2e2bcd8739ae039,
    tenants: $5c86b69d7ac23997$export$2e2bcd8739ae039,
    topbar: $05a82f9948e22ddd$export$2e2bcd8739ae039,
    subscription: $f2a1ad7bd9a3c597$export$2e2bcd8739ae039,
    upsell: $9ddc5d6ed775d8d5$export$2e2bcd8739ae039,
    guide: $1e64a9e6463ec408$export$2e2bcd8739ae039,
    mfa: $35abaa2903160902$export$2e2bcd8739ae039,
    organizations: $51227c338a767999$export$2e2bcd8739ae039,
    organization_details: $aee2bbca62183f47$export$2e2bcd8739ae039
};
var $c7d123bdd9d9eebe$export$2e2bcd8739ae039 = Object.freeze($c7d123bdd9d9eebe$var$admin_console);


const $0041f019c4baa119$var$demo_app = {
    title: "你已成功登錄實時預覽！",
    subtitle: "以下是本次登錄的用戶信息：",
    username: "用戶名：",
    user_id: "用戶 ID：",
    sign_out: "退出實時預覽",
    continue_explore: "或繼續探索",
    customize_sign_in_experience: "自定義登錄體驗",
    enable_passwordless: "啟用無密碼登錄",
    add_social_connector: "添加社交連接器"
};
var $0041f019c4baa119$export$2e2bcd8739ae039 = Object.freeze($0041f019c4baa119$var$demo_app);


const $ae19af1f4f75fde0$var$oidc = {
    logout_success: "你已經成功登出。"
};
var $ae19af1f4f75fde0$export$2e2bcd8739ae039 = Object.freeze($ae19af1f4f75fde0$var$oidc);


const $ca329d3232813122$var$translation = {
    admin_console: $c7d123bdd9d9eebe$export$2e2bcd8739ae039,
    demo_app: $0041f019c4baa119$export$2e2bcd8739ae039,
    oidc: $ae19af1f4f75fde0$export$2e2bcd8739ae039
};
var $ca329d3232813122$export$2e2bcd8739ae039 = Object.freeze($ca329d3232813122$var$translation);


const $2a42b5faed882d4f$var$zh_tw = {
    translation: $ca329d3232813122$export$2e2bcd8739ae039,
    errors: $dcd2cf53636c96f1$export$2e2bcd8739ae039
};
var $2a42b5faed882d4f$export$2e2bcd8739ae039 = Object.freeze($2a42b5faed882d4f$var$zh_tw);


const $824f1ad0d8aba615$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-BR",
    "pt-PT",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
const $824f1ad0d8aba615$export$91d555a17bb93dc7 = $824f1ad0d8aba615$export$651548ae3cf5e245.map((languageTag)=>({
        value: languageTag,
        title: (0, $3nY0n.languages)[languageTag]
    }));
const $824f1ad0d8aba615$export$5ac61cba82e41a23 = (0, $2CYkO.z).enum($824f1ad0d8aba615$export$651548ae3cf5e245);
const $824f1ad0d8aba615$export$559ef0bafb7e082f = (languages)=>$824f1ad0d8aba615$export$5ac61cba82e41a23.or((0, $dMkQh.fallback)("en")).parse(languages);
const $824f1ad0d8aba615$export$562f9b4f03c85f6c = (language)=>$824f1ad0d8aba615$export$5ac61cba82e41a23.safeParse(language).success;
const $824f1ad0d8aba615$var$resource = {
    de: $2863eb1380c8c184$export$2e2bcd8739ae039,
    en: $e0185af096ff629c$export$2e2bcd8739ae039,
    es: $d07d03ea0fa5ba44$export$2e2bcd8739ae039,
    fr: $0103c56b907ff28f$export$2e2bcd8739ae039,
    it: $46491d2d6475a3d2$export$2e2bcd8739ae039,
    ja: $99146a10d7fe038c$export$2e2bcd8739ae039,
    ko: $b8d35715a740d472$export$2e2bcd8739ae039,
    "pl-PL": (0, $84936ac2cfcfe408$export$2e2bcd8739ae039),
    "pt-BR": (0, $6cc6e133a8f40dd5$export$2e2bcd8739ae039),
    "pt-PT": (0, $e8f974b12583d91a$export$2e2bcd8739ae039),
    ru: $10f7714f13e43988$export$2e2bcd8739ae039,
    "tr-TR": (0, $0f6c0441816902f3$export$2e2bcd8739ae039),
    "zh-CN": (0, $b299cd4ef47bec27$export$2e2bcd8739ae039),
    "zh-HK": (0, $77d00b94e0c271c0$export$2e2bcd8739ae039),
    "zh-TW": (0, $2a42b5faed882d4f$export$2e2bcd8739ae039)
};
var $824f1ad0d8aba615$export$2e2bcd8739ae039 = $824f1ad0d8aba615$var$resource;


parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $47fe8f63822b1442$var$SvgGlobe = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M17.842 7.2V7.16a8.334 8.334 0 0 0-15.65 0V7.2a8.217 8.217 0 0 0 0 5.6v.042a8.333 8.333 0 0 0 15.65 0V12.8a8.217 8.217 0 0 0 0-5.6ZM3.55 11.667a6.517 6.517 0 0 1 0-3.333H5.1a13.941 13.941 0 0 0 0 3.333H3.55Zm.684 1.667H5.4c.196.743.475 1.462.834 2.141a6.667 6.667 0 0 1-2-2.141ZM5.4 6.667H4.234a6.667 6.667 0 0 1 1.975-2.142c-.35.681-.621 1.4-.809 2.142Zm3.767 9.75a5.283 5.283 0 0 1-2.025-3.083h2.025v3.083Zm0-4.75H6.784a11.967 11.967 0 0 1 0-3.333h2.383v3.333Zm0-5H7.142a5.283 5.283 0 0 1 2.025-3.083v3.083Zm6.6 0H14.6a10.128 10.128 0 0 0-.833-2.142 6.667 6.667 0 0 1 2 2.142Zm-4.933-3.083a5.284 5.284 0 0 1 2.025 3.083h-2.025V3.584Zm0 12.833v-3.083h2.025a5.284 5.284 0 0 1-2.025 3.083Zm2.383-4.75h-2.383V8.334h2.383a11.967 11.967 0 0 1 0 3.333Zm.575 3.808c.358-.68.638-1.398.833-2.141h1.167a6.668 6.668 0 0 1-2 2.141Zm2.658-3.808H14.9c.068-.553.101-1.11.1-1.667.001-.557-.032-1.113-.1-1.666h1.55a6.516 6.516 0 0 1 0 3.333Z",
            fill: "currentColor"
        })
    });
var $47fe8f63822b1442$export$2e2bcd8739ae039 = $47fe8f63822b1442$var$SvgGlobe;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ab1b82ae66f6442b$var$SvgPalette = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M6.183 12.95a.834.834 0 1 0 1.183 1.176.834.834 0 0 0-1.183-1.175Zm0-7.074A.833.833 0 1 0 7.365 7.05a.833.833 0 0 0-1.182-1.175Zm4.125 8.333a.834.834 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm-5-5a.833.833 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm5-5a.833.833 0 1 0 .834.833.833.833 0 0 0-.834-.875v.042Zm2.95 1.708a.833.833 0 1 0 1.175 0 .833.833 0 0 0-1.175-.041v.041Zm5.25 0a9.167 9.167 0 1 0-6.541 13.117 3.226 3.226 0 0 0 2.083-1.375 3.502 3.502 0 0 0 .508-2.658 4.699 4.699 0 0 1-.083-.834 4.166 4.166 0 0 1 2.5-3.8 3.201 3.201 0 0 0 1.717-1.875 3.333 3.333 0 0 0-.184-2.591v.016Zm-1.416 2.034a1.584 1.584 0 0 1-.834.908 5.834 5.834 0 0 0-3.45 5.308c.002.392.04.783.117 1.167a1.801 1.801 0 0 1-.258 1.375 1.49 1.49 0 0 1-1.009.667 7.5 7.5 0 0 1-8.85-7.608A7.542 7.542 0 0 1 9.875 2.5h.425a7.5 7.5 0 0 1 6.717 4.166c.19.396.218.851.075 1.267v.017Zm-6.784 1.216a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $ab1b82ae66f6442b$export$2e2bcd8739ae039 = $ab1b82ae66f6442b$var$SvgPalette;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $06aaa25160e82e50$var$SvgProfile = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 1.666a8.333 8.333 0 0 0-6.125 13.967 8.334 8.334 0 0 0 12.25 0A8.333 8.333 0 0 0 10 1.666Zm0 15a6.667 6.667 0 0 1-4.625-1.875 5 5 0 0 1 9.25 0A6.667 6.667 0 0 1 10 16.666ZM8.333 8.333a1.667 1.667 0 1 1 3.334 0 1.667 1.667 0 0 1-3.334 0Zm7.425 5a6.666 6.666 0 0 0-3.258-2.817 3.333 3.333 0 1 0-5 0 6.666 6.666 0 0 0-3.258 2.817 6.6 6.6 0 0 1-.909-3.334 6.667 6.667 0 1 1 13.334 0 6.6 6.6 0 0 1-.909 3.334Z",
            fill: "currentColor"
        })
    });
var $06aaa25160e82e50$export$2e2bcd8739ae039 = $06aaa25160e82e50$var$SvgProfile;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $abed159f3a090c88$var$SvgSignOut = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m10.492 10.833-1.917 1.909a.833.833 0 0 0 0 1.183.833.833 0 0 0 1.183 0l3.334-3.333a.832.832 0 0 0 .175-.275.833.833 0 0 0 0-.634.832.832 0 0 0-.175-.275L9.758 6.075a.837.837 0 0 0-1.183 1.183l1.917 1.909H2.5a.833.833 0 0 0 0 1.666h7.992ZM10 1.667a8.333 8.333 0 0 0-7.5 4.625.839.839 0 0 0 1.5.75 6.667 6.667 0 1 1 6 9.625 6.608 6.608 0 0 1-5.967-3.709.838.838 0 1 0-1.5.75A8.334 8.334 0 1 0 10 1.667Z",
            fill: "currentColor"
        })
    });
var $abed159f3a090c88$export$2e2bcd8739ae039 = $abed159f3a090c88$var$SvgSignOut;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $c29803d3d7839d72$var$SvgDefaultAvatar = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#78767F",
                fillOpacity: 0.02,
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#5D34F2",
                fillOpacity: 0.16,
                d: "M0 0h48v48H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.174 10a5.478 5.478 0 0 0-5.478 5.478v1.218a5.478 5.478 0 0 0 10.956 0v-1.218A5.478 5.478 0 0 0 24.174 10Zm0 28c12.174 0 12.174-3.957 12.174-3.957 0-5.133-2.548-9.918-9.13-10.043-.029 0-.219.184-.494.452-.723.704-2.036 1.98-2.55 1.98-.514 0-1.827-1.276-2.55-1.98-.276-.268-.466-.453-.494-.452-6.582.125-9.13 4.91-9.13 10.043 0 0 0 3.957 12.174 3.957Z",
                fill: "#947DFF"
            })
        ]
    });
var $c29803d3d7839d72$export$2e2bcd8739ae039 = $c29803d3d7839d72$var$SvgDefaultAvatar;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $973c85b3106cb155$var$SvgBrokenImageDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 9a4 4 0 0 1 4-4h6.5l1.452 2-1.049 2 2.29 3.5-1.048 2 1.952 2L24.5 19l.903-2.5-1.048-2 1.951-2-1.21-3.5 1.952-2-.548-2H34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H17.454a1 1 0 0 1-.753-.342l-6.454-7.375a1 1 0 0 1-.247-.659V9Z",
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m10 35 7 8v-6a2 2 0 0 0-2-2h-5Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.024 20.025a.5.5 0 0 0 0 .707L17.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L19.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L18.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0ZM27.024 20.025a.5.5 0 0 0 0 .707L28.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L30.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L29.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0Z",
                fill: "#ADAAB4"
            })
        ]
    });
var $973c85b3106cb155$export$2e2bcd8739ae039 = $973c85b3106cb155$var$SvgBrokenImageDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ee098e523c0761b7$var$SvgBrokenImageLight = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 9a4 4 0 0 1 4-4h6.5l1.452 2-1.049 2 2.29 3.5-1.048 2 1.952 2L24.5 19l.903-2.5-1.048-2 1.951-2-1.21-3.5 1.952-2-.548-2H34a4 4 0 0 1 4 4v30a4 4 0 0 1-4 4H17.454a1 1 0 0 1-.753-.342l-6.454-7.375a1 1 0 0 1-.247-.659V9Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m10 35 7 8v-6a2 2 0 0 0-2-2h-5Z",
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.024 20.025a.5.5 0 0 0 0 .707L17.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L19.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L18.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0ZM27.024 20.025a.5.5 0 0 0 0 .707L28.79 22.5l-1.767 1.768a.5.5 0 1 0 .707.707l1.768-1.768 1.767 1.768a.5.5 0 1 0 .708-.707L30.206 22.5l1.767-1.768a.5.5 0 1 0-.707-.707L29.5 21.793l-1.768-1.768a.5.5 0 0 0-.707 0Z",
                fill: "#78767F"
            })
        ]
    });
var $ee098e523c0761b7$export$2e2bcd8739ae039 = $ee098e523c0761b7$var$SvgBrokenImageLight;



var $93h5F = parcelRequire("93h5F");
function $c12cc5efebda5c90$var$ImageWithErrorFallback({ src: src, alt: alt, className: className, containerClassName: containerClassName, fallbackElement: fallbackElement, ...props }) {
    const [hasError, setHasError] = (0, $eCoWV.useState)(false);
    const theme = (0, $93h5F.default)();
    const DefaultFallback = theme === (0, $bhvxB.Theme).Light ? (0, $ee098e523c0761b7$export$2e2bcd8739ae039) : (0, $973c85b3106cb155$export$2e2bcd8739ae039);
    const errorHandler = ()=>{
        setHasError(true);
    };
    if (!src || hasError) return fallbackElement ? /*#__PURE__*/ (0, $eCoWV.cloneElement)(fallbackElement, {
        className: className
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)(DefaultFallback, {
            className: className
        })
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: containerClassName,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("img", {
            className: className,
            src: src,
            alt: alt,
            onError: errorHandler,
            ...props
        })
    });
}
var $c12cc5efebda5c90$export$2e2bcd8739ae039 = $c12cc5efebda5c90$var$ImageWithErrorFallback;


parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");
// Importing from a ".js" file is a workaround for Node.js "ES Modules"
// importing system which is even uncapable of importing "*.json" files.
// This file is a workaround for a bug in web browsers' "native"
// ES6 importing system which is uncapable of importing "*.json" files.
// https://github.com/catamphetamine/libphonenumber-js/issues/239
var $f0d2529331ec0957$export$2e2bcd8739ae039 = {
    "version": 4,
    "country_calling_codes": {
        "1": [
            "US",
            "AG",
            "AI",
            "AS",
            "BB",
            "BM",
            "BS",
            "CA",
            "DM",
            "DO",
            "GD",
            "GU",
            "JM",
            "KN",
            "KY",
            "LC",
            "MP",
            "MS",
            "PR",
            "SX",
            "TC",
            "TT",
            "VC",
            "VG",
            "VI"
        ],
        "7": [
            "RU",
            "KZ"
        ],
        "20": [
            "EG"
        ],
        "27": [
            "ZA"
        ],
        "30": [
            "GR"
        ],
        "31": [
            "NL"
        ],
        "32": [
            "BE"
        ],
        "33": [
            "FR"
        ],
        "34": [
            "ES"
        ],
        "36": [
            "HU"
        ],
        "39": [
            "IT",
            "VA"
        ],
        "40": [
            "RO"
        ],
        "41": [
            "CH"
        ],
        "43": [
            "AT"
        ],
        "44": [
            "GB",
            "GG",
            "IM",
            "JE"
        ],
        "45": [
            "DK"
        ],
        "46": [
            "SE"
        ],
        "47": [
            "NO",
            "SJ"
        ],
        "48": [
            "PL"
        ],
        "49": [
            "DE"
        ],
        "51": [
            "PE"
        ],
        "52": [
            "MX"
        ],
        "53": [
            "CU"
        ],
        "54": [
            "AR"
        ],
        "55": [
            "BR"
        ],
        "56": [
            "CL"
        ],
        "57": [
            "CO"
        ],
        "58": [
            "VE"
        ],
        "60": [
            "MY"
        ],
        "61": [
            "AU",
            "CC",
            "CX"
        ],
        "62": [
            "ID"
        ],
        "63": [
            "PH"
        ],
        "64": [
            "NZ"
        ],
        "65": [
            "SG"
        ],
        "66": [
            "TH"
        ],
        "81": [
            "JP"
        ],
        "82": [
            "KR"
        ],
        "84": [
            "VN"
        ],
        "86": [
            "CN"
        ],
        "90": [
            "TR"
        ],
        "91": [
            "IN"
        ],
        "92": [
            "PK"
        ],
        "93": [
            "AF"
        ],
        "94": [
            "LK"
        ],
        "95": [
            "MM"
        ],
        "98": [
            "IR"
        ],
        "211": [
            "SS"
        ],
        "212": [
            "MA",
            "EH"
        ],
        "213": [
            "DZ"
        ],
        "216": [
            "TN"
        ],
        "218": [
            "LY"
        ],
        "220": [
            "GM"
        ],
        "221": [
            "SN"
        ],
        "222": [
            "MR"
        ],
        "223": [
            "ML"
        ],
        "224": [
            "GN"
        ],
        "225": [
            "CI"
        ],
        "226": [
            "BF"
        ],
        "227": [
            "NE"
        ],
        "228": [
            "TG"
        ],
        "229": [
            "BJ"
        ],
        "230": [
            "MU"
        ],
        "231": [
            "LR"
        ],
        "232": [
            "SL"
        ],
        "233": [
            "GH"
        ],
        "234": [
            "NG"
        ],
        "235": [
            "TD"
        ],
        "236": [
            "CF"
        ],
        "237": [
            "CM"
        ],
        "238": [
            "CV"
        ],
        "239": [
            "ST"
        ],
        "240": [
            "GQ"
        ],
        "241": [
            "GA"
        ],
        "242": [
            "CG"
        ],
        "243": [
            "CD"
        ],
        "244": [
            "AO"
        ],
        "245": [
            "GW"
        ],
        "246": [
            "IO"
        ],
        "247": [
            "AC"
        ],
        "248": [
            "SC"
        ],
        "249": [
            "SD"
        ],
        "250": [
            "RW"
        ],
        "251": [
            "ET"
        ],
        "252": [
            "SO"
        ],
        "253": [
            "DJ"
        ],
        "254": [
            "KE"
        ],
        "255": [
            "TZ"
        ],
        "256": [
            "UG"
        ],
        "257": [
            "BI"
        ],
        "258": [
            "MZ"
        ],
        "260": [
            "ZM"
        ],
        "261": [
            "MG"
        ],
        "262": [
            "RE",
            "YT"
        ],
        "263": [
            "ZW"
        ],
        "264": [
            "NA"
        ],
        "265": [
            "MW"
        ],
        "266": [
            "LS"
        ],
        "267": [
            "BW"
        ],
        "268": [
            "SZ"
        ],
        "269": [
            "KM"
        ],
        "290": [
            "SH",
            "TA"
        ],
        "291": [
            "ER"
        ],
        "297": [
            "AW"
        ],
        "298": [
            "FO"
        ],
        "299": [
            "GL"
        ],
        "350": [
            "GI"
        ],
        "351": [
            "PT"
        ],
        "352": [
            "LU"
        ],
        "353": [
            "IE"
        ],
        "354": [
            "IS"
        ],
        "355": [
            "AL"
        ],
        "356": [
            "MT"
        ],
        "357": [
            "CY"
        ],
        "358": [
            "FI",
            "AX"
        ],
        "359": [
            "BG"
        ],
        "370": [
            "LT"
        ],
        "371": [
            "LV"
        ],
        "372": [
            "EE"
        ],
        "373": [
            "MD"
        ],
        "374": [
            "AM"
        ],
        "375": [
            "BY"
        ],
        "376": [
            "AD"
        ],
        "377": [
            "MC"
        ],
        "378": [
            "SM"
        ],
        "380": [
            "UA"
        ],
        "381": [
            "RS"
        ],
        "382": [
            "ME"
        ],
        "383": [
            "XK"
        ],
        "385": [
            "HR"
        ],
        "386": [
            "SI"
        ],
        "387": [
            "BA"
        ],
        "389": [
            "MK"
        ],
        "420": [
            "CZ"
        ],
        "421": [
            "SK"
        ],
        "423": [
            "LI"
        ],
        "500": [
            "FK"
        ],
        "501": [
            "BZ"
        ],
        "502": [
            "GT"
        ],
        "503": [
            "SV"
        ],
        "504": [
            "HN"
        ],
        "505": [
            "NI"
        ],
        "506": [
            "CR"
        ],
        "507": [
            "PA"
        ],
        "508": [
            "PM"
        ],
        "509": [
            "HT"
        ],
        "590": [
            "GP",
            "BL",
            "MF"
        ],
        "591": [
            "BO"
        ],
        "592": [
            "GY"
        ],
        "593": [
            "EC"
        ],
        "594": [
            "GF"
        ],
        "595": [
            "PY"
        ],
        "596": [
            "MQ"
        ],
        "597": [
            "SR"
        ],
        "598": [
            "UY"
        ],
        "599": [
            "CW",
            "BQ"
        ],
        "670": [
            "TL"
        ],
        "672": [
            "NF"
        ],
        "673": [
            "BN"
        ],
        "674": [
            "NR"
        ],
        "675": [
            "PG"
        ],
        "676": [
            "TO"
        ],
        "677": [
            "SB"
        ],
        "678": [
            "VU"
        ],
        "679": [
            "FJ"
        ],
        "680": [
            "PW"
        ],
        "681": [
            "WF"
        ],
        "682": [
            "CK"
        ],
        "683": [
            "NU"
        ],
        "685": [
            "WS"
        ],
        "686": [
            "KI"
        ],
        "687": [
            "NC"
        ],
        "688": [
            "TV"
        ],
        "689": [
            "PF"
        ],
        "690": [
            "TK"
        ],
        "691": [
            "FM"
        ],
        "692": [
            "MH"
        ],
        "850": [
            "KP"
        ],
        "852": [
            "HK"
        ],
        "853": [
            "MO"
        ],
        "855": [
            "KH"
        ],
        "856": [
            "LA"
        ],
        "880": [
            "BD"
        ],
        "886": [
            "TW"
        ],
        "960": [
            "MV"
        ],
        "961": [
            "LB"
        ],
        "962": [
            "JO"
        ],
        "963": [
            "SY"
        ],
        "964": [
            "IQ"
        ],
        "965": [
            "KW"
        ],
        "966": [
            "SA"
        ],
        "967": [
            "YE"
        ],
        "968": [
            "OM"
        ],
        "970": [
            "PS"
        ],
        "971": [
            "AE"
        ],
        "972": [
            "IL"
        ],
        "973": [
            "BH"
        ],
        "974": [
            "QA"
        ],
        "975": [
            "BT"
        ],
        "976": [
            "MN"
        ],
        "977": [
            "NP"
        ],
        "992": [
            "TJ"
        ],
        "993": [
            "TM"
        ],
        "994": [
            "AZ"
        ],
        "995": [
            "GE"
        ],
        "996": [
            "KG"
        ],
        "998": [
            "UZ"
        ]
    },
    "countries": {
        "AC": [
            "247",
            "00",
            "(?:[01589]\\d|[46])\\d{4}",
            [
                5,
                6
            ]
        ],
        "AD": [
            "376",
            "00",
            "(?:1|6\\d)\\d{7}|[135-9]\\d{5}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "[135-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ]
        ],
        "AE": [
            "971",
            "00",
            "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{2,9})",
                    "$1 $2",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[236]|[479][2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[479]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AF": [
            "93",
            "00",
            "[2-7]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AG": [
            "1",
            "011",
            "(?:268|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([457]\\d{6})$|1",
            "268$1",
            0,
            "268"
        ],
        "AI": [
            "1",
            "011",
            "(?:264|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2457]\\d{6})$|1",
            "264$1",
            0,
            "264"
        ],
        "AL": [
            "355",
            "00",
            "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "80|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2358][2-5]|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AM": [
            "374",
            "00",
            "(?:[1-489]\\d|55|60|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2|3[12]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "1|47"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[3-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AO": [
            "244",
            "00",
            "[29]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "AR": [
            "54",
            "00",
            "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])",
                        "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[23]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d)(\\d{4})(\\d{2})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9(?:2[2-469]|3[3-578])",
                        "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))",
                        "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]",
                        "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "91"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 15-$3-$4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3-$4"
                ]
            ],
            "0",
            0,
            "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?",
            "9$1"
        ],
        "AS": [
            "1",
            "011",
            "(?:[58]\\d\\d|684|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([267]\\d{6})$|1",
            "684$1",
            0,
            "684"
        ],
        "AT": [
            "43",
            "00",
            "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3,12})",
                    "$1 $2",
                    [
                        "1(?:11|[2-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})",
                    "$1 $2",
                    [
                        "517"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "5[079]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,10})",
                    "$1 $2",
                    [
                        "(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,9})",
                    "$1 $2",
                    [
                        "[2-467]|5[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,7})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "AU": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "14|4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2378]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:30|[89])"
                    ]
                ]
            ],
            "0",
            0,
            "(183[12])|0",
            0,
            0,
            0,
            [
                [
                    "(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|3(?:[0-3589]\\d|4[0-578]|6[1-9]|7[0-35-9])|7(?:[013-57-9]\\d|2[0-8]))\\d{3}|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4]))|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "163\\d{2,6}",
                    [
                        5,
                        6,
                        7,
                        8,
                        9
                    ]
                ],
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "AW": [
            "297",
            "00",
            "(?:[25-79]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[25-9]"
                    ]
                ]
            ]
        ],
        "AX": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "18",
            0,
            "00"
        ],
        "AZ": [
            "994",
            "00",
            "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[28]|2|365|46",
                        "1[28]|2|365[45]|46",
                        "1[28]|2|365(?:4|5[02])|46"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BA": [
            "387",
            "00",
            "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[1-3]|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "[3-5]|6[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BB": [
            "1",
            "011",
            "(?:246|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "246$1",
            0,
            "246"
        ],
        "BD": [
            "880",
            "00",
            "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1-$2",
                    [
                        "31[5-8]|[459]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1-$2",
                    [
                        "3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,6})",
                    "$1-$2",
                    [
                        "[13-9]|22"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{7,8})",
                    "$1-$2",
                    [
                        "2"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BE": [
            "32",
            "00",
            "4\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:80|9)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[239]|4[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[15-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BF": [
            "226",
            "00",
            "[025-7]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[025-7]"
                    ]
                ]
            ]
        ],
        "BG": [
            "359",
            "00",
            "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                12
            ],
            [
                [
                    "(\\d)(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "43[1-6]|70[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:70|8)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "43[1-7]|7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[48]|9[08]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "BH": [
            "973",
            "00",
            "[136-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[13679]|8[02-4679]"
                    ]
                ]
            ]
        ],
        "BI": [
            "257",
            "00",
            "(?:[267]\\d|31)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2367]"
                    ]
                ]
            ]
        ],
        "BJ": [
            "229",
            "00",
            "[24-689]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-689]"
                    ]
                ]
            ]
        ],
        "BL": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "BM": [
            "1",
            "011",
            "(?:441|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "441$1",
            0,
            "441"
        ],
        "BN": [
            "673",
            "00",
            "[2-578]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "BO": [
            "591",
            "00(?:1\\d)?",
            "(?:[2-467]\\d\\d|8001)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[23]|4[46]"
                    ]
                ],
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0",
            0,
            "0(1\\d)?"
        ],
        "BQ": [
            "599",
            "00",
            "(?:[34]1|7\\d)\\d{5}",
            [
                7
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[347]"
        ],
        "BR": [
            "55",
            "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)",
            "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "300|4(?:0[02]|37)",
                        "4(?:02|37)0|[34]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:[358]|90)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[16][1-9]|[2-57-9]"
                    ],
                    "($1)"
                ]
            ],
            "0",
            0,
            "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?",
            "$2"
        ],
        "BS": [
            "1",
            "011",
            "(?:242|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([3-8]\\d{6})$|1",
            "242$1",
            0,
            "242"
        ],
        "BT": [
            "975",
            "00",
            "[17]\\d{7}|[2-8]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-68]|7[246]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[67]|7"
                    ]
                ]
            ]
        ],
        "BW": [
            "267",
            "00",
            "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[24-6]|3[15-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "BY": [
            "375",
            "810",
            "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "800"
                    ],
                    "8 $1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{3})",
                    "$1 $2-$3",
                    [
                        "1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])",
                        "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "1(?:[56]|7[467])|2[1-3]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-4]"
                    ],
                    "8 0$1"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            "0|80?",
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "BZ": [
            "501",
            "00",
            "(?:0800\\d|[2-8])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CA": [
            "1",
            "011",
            "(?:[2-8]\\d|90)\\d{8}|3\\d{6}",
            [
                7,
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "",
                    [
                        10
                    ]
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "900[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "310\\d{4}",
                    [
                        7
                    ]
                ],
                0,
                [
                    "600[2-9]\\d{6}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "CC": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CD": [
            "243",
            "00",
            "[189]\\d{8}|[1-68]\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CF": [
            "236",
            "00",
            "(?:[27]\\d{3}|8776)\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[278]"
                    ]
                ]
            ]
        ],
        "CG": [
            "242",
            "00",
            "222\\d{6}|(?:0\\d|80)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[02]"
                    ]
                ]
            ]
        ],
        "CH": [
            "41",
            "00",
            "8\\d{11}|[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8[047]|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]|81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CI": [
            "225",
            "00",
            "[02]\\d{9}",
            [
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d)(\\d{5})",
                    "$1 $2 $3 $4",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ]
        ],
        "CK": [
            "682",
            "00",
            "[2-578]\\d{4}",
            [
                5
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "[2-578]"
                    ]
                ]
            ]
        ],
        "CL": [
            "56",
            "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0",
            "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}",
            [
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "219",
                        "2196"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[1-36]"
                    ],
                    "($1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[2-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "60|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "60"
                    ]
                ]
            ]
        ],
        "CM": [
            "237",
            "00",
            "[26]\\d{8}|88\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "88"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[26]|88"
                    ]
                ]
            ]
        ],
        "CN": [
            "86",
            "00|1(?:[12]\\d|79)\\d\\d00",
            "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5,6})",
                    "$1 $2",
                    [
                        "(?:10|2[0-57-9])[19]",
                        "(?:10|2[0-57-9])(?:10|9[56])",
                        "10(?:10|9[56])|2[0-57-9](?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]",
                        "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]",
                        "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])",
                        "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "(?:4|80)0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10|2(?:[02-57-9]|1[1-9])",
                        "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-578]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[3-9]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "[12]"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0",
            0,
            "(1(?:[12]\\d|79)\\d\\d)|0",
            0,
            0,
            0,
            0,
            "00"
        ],
        "CO": [
            "57",
            "00(?:4(?:[14]4|56)|[579])",
            "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "($1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3[0-357]|91"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{7})",
                    "$1-$2-$3",
                    [
                        "1"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ]
            ],
            "0",
            0,
            "0([3579]|4(?:[14]4|56))?"
        ],
        "CR": [
            "506",
            "00",
            "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[3-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            "(19(?:0[0-2468]|1[09]|20|66|77|99))"
        ],
        "CU": [
            "53",
            "119",
            "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}",
            [
                6,
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "2[1-4]|[34]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{6,7})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "[56]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "CV": [
            "238",
            "0",
            "(?:[2-59]\\d\\d|800)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "CW": [
            "599",
            "00",
            "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[3467]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9[4-8]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[69]"
        ],
        "CX": [
            "61",
            "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011",
            "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}",
            [
                6,
                7,
                8,
                9,
                10,
                12
            ],
            0,
            "0",
            0,
            "([59]\\d{7})$|0",
            "8$1",
            0,
            0,
            [
                [
                    "8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}",
                    [
                        9
                    ]
                ],
                [
                    "4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-26-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}",
                    [
                        9
                    ]
                ],
                [
                    "180(?:0\\d{3}|2)\\d{3}",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "190[0-26]\\d{6}",
                    [
                        10
                    ]
                ],
                0,
                0,
                0,
                0,
                [
                    "14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}",
                    [
                        9
                    ]
                ],
                [
                    "13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}",
                    [
                        6,
                        8,
                        10,
                        12
                    ]
                ]
            ],
            "0011"
        ],
        "CY": [
            "357",
            "00",
            "(?:[279]\\d|[58]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[257-9]"
                    ]
                ]
            ]
        ],
        "CZ": [
            "420",
            "00",
            "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]|9[015-7]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "96"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "DE": [
            "49",
            "00",
            "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15
            ],
            [
                [
                    "(\\d{2})(\\d{3,13})",
                    "$1 $2",
                    [
                        "3[02]|40|[68]9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,12})",
                    "$1 $2",
                    [
                        "2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1",
                        "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2,11})",
                    "$1 $2",
                    [
                        "[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]",
                        "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "138"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{2,10})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,11})",
                    "$1 $2",
                    [
                        "181"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{4,10})",
                    "$1 $2 $3",
                    [
                        "1(?:3|80)|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,8})",
                    "$1 $2",
                    [
                        "1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7,12})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "185",
                        "1850",
                        "18500"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "18[68]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{6})",
                    "$1 $2",
                    [
                        "15[0568]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{7})",
                    "$1 $2",
                    [
                        "15[1279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{8})",
                    "$1 $2",
                    [
                        "18"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{7,8})",
                    "$1 $2 $3",
                    [
                        "1(?:6[023]|7)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{7})",
                    "$1 $2 $3",
                    [
                        "15[279]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{8})",
                    "$1 $2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "DJ": [
            "253",
            "00",
            "(?:2\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[27]"
                    ]
                ]
            ]
        ],
        "DK": [
            "45",
            "00",
            "[2-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "DM": [
            "1",
            "011",
            "(?:[58]\\d\\d|767|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "767$1",
            0,
            "767"
        ],
        "DO": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "8001|8[024]9"
        ],
        "DZ": [
            "213",
            "00",
            "(?:[1-4]|[5-79]\\d|80)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EC": [
            "593",
            "00",
            "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}",
            [
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2-$3",
                    [
                        "[2-7]"
                    ],
                    "(0$1)",
                    0,
                    "$1-$2-$3"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "EE": [
            "372",
            "00",
            "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88",
                        "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[45]|8(?:00|[1-49])",
                        "[45]|8(?:00[1-9]|[1-49])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "EG": [
            "20",
            "00",
            "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{7,8})",
                    "$1 $2",
                    [
                        "[23]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,7})",
                    "$1 $2",
                    [
                        "1[35]|[4-6]|8[2468]|9[235-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "EH": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            "528[89]"
        ],
        "ER": [
            "291",
            "00",
            "[178]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[178]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ES": [
            "34",
            "00",
            "[5-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[89]00"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "ET": [
            "251",
            "00",
            "(?:11|[2-579]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-579]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "FI": [
            "358",
            "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))",
            "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d)(\\d{4,9})",
                    "$1 $2",
                    [
                        "[2568][1-8]|3(?:0[1-9]|[1-9])|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[12]00|[368]|70[07-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,8})",
                    "$1 $2",
                    [
                        "[1245]|7[135]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6,10})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            "1[03-79]|[2-9]",
            0,
            "00"
        ],
        "FJ": [
            "679",
            "0(?:0|52)",
            "45\\d{5}|(?:0800\\d|[235-9])\\d{6}",
            [
                7,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[235-9]|45"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "FK": [
            "500",
            "00",
            "[2-7]\\d{4}",
            [
                5
            ]
        ],
        "FM": [
            "691",
            "00",
            "(?:[39]\\d\\d|820)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[389]"
                    ]
                ]
            ]
        ],
        "FO": [
            "298",
            "00",
            "[2-9]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(10(?:01|[12]0|88))"
        ],
        "FR": [
            "33",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0 $1"
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "[1-79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GA": [
            "241",
            "00",
            "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "11|[67]"
                    ],
                    "0$1"
                ]
            ],
            0,
            0,
            "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})",
            "$1"
        ],
        "GB": [
            "44",
            "00",
            "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}",
            [
                7,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "800",
                        "8001",
                        "80011",
                        "800111",
                        "8001111"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "845",
                        "8454",
                        "84546",
                        "845464"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "1(?:38|5[23]|69|76|94)",
                        "1(?:(?:38|69)7|5(?:24|39)|768|946)",
                        "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "1(?:[2-69][02-9]|[78])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[25]|7(?:0|6[02-9])",
                        "[25]|7(?:0|6(?:[03-9]|2[356]))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1389]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ],
            0,
            " x"
        ],
        "GD": [
            "1",
            "011",
            "(?:473|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "473$1",
            0,
            "473"
        ],
        "GE": [
            "995",
            "00",
            "(?:[3-57]\\d\\d|800)\\d{6}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "32"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[348]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GF": [
            "594",
            "00",
            "[56]94\\d{6}|(?:80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[56]|9[47]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GG": [
            "44",
            "00",
            "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?",
            [
                7,
                9,
                10
            ],
            0,
            "0",
            0,
            "([25-9]\\d{5})$|0",
            "1481$1",
            0,
            0,
            [
                [
                    "1481[25-9]\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "7(?:(?:781|839)\\d|911[17])\\d{5}",
                    [
                        10
                    ]
                ],
                [
                    "80[08]\\d{7}|800\\d{6}|8001111"
                ],
                [
                    "(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d",
                    [
                        7,
                        10
                    ]
                ],
                [
                    "70\\d{8}",
                    [
                        10
                    ]
                ],
                0,
                [
                    "(?:3[0347]|55)\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}",
                    [
                        10
                    ]
                ],
                [
                    "56\\d{8}",
                    [
                        10
                    ]
                ]
            ]
        ],
        "GH": [
            "233",
            "00",
            "(?:[235]\\d{3}|800)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "GI": [
            "350",
            "00",
            "(?:[25]\\d|60)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ]
            ]
        ],
        "GL": [
            "299",
            "00",
            "(?:19|[2-689]\\d|70)\\d{4}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "19|[2-9]"
                    ]
                ]
            ]
        ],
        "GM": [
            "220",
            "00",
            "[2-9]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "GN": [
            "224",
            "00",
            "722\\d{6}|(?:3|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "3"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[67]"
                    ]
                ]
            ]
        ],
        "GP": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "GQ": [
            "240",
            "00",
            "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "GR": [
            "30",
            "00",
            "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}",
            [
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21|7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2689]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "GT": [
            "502",
            "00",
            "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-8]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "GU": [
            "1",
            "011",
            "(?:[58]\\d\\d|671|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "671$1",
            0,
            "671"
        ],
        "GW": [
            "245",
            "00",
            "[49]\\d{8}|4\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "40"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ]
                ]
            ]
        ],
        "GY": [
            "592",
            "001",
            "(?:[2-8]\\d{3}|9008)\\d{3}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "HK": [
            "852",
            "00(?:30|5[09]|[126-9]?)",
            "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}",
            [
                5,
                6,
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{2,5})",
                    "$1 $2",
                    [
                        "900",
                        "9003"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "9"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "HN": [
            "504",
            "00",
            "8\\d{10}|[237-9]\\d{7}",
            [
                8,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[237-9]"
                    ]
                ]
            ]
        ],
        "HR": [
            "385",
            "00",
            "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "6[01]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "HT": [
            "509",
            "00",
            "(?:[2-489]\\d|55)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-589]"
                    ]
                ]
            ]
        ],
        "HU": [
            "36",
            "00",
            "[235-7]\\d{8}|[1-9]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"
                    ],
                    "(06 $1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "06 $1"
                ]
            ],
            "06"
        ],
        "ID": [
            "62",
            "00[89]",
            "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "15"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,9})",
                    "$1 $2",
                    [
                        "2[124]|[36]1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,7})",
                    "$1 $2",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5,8})",
                    "$1 $2",
                    [
                        "[2-79]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "8[1-35-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6,8})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "804"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1-$2-$3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IE": [
            "353",
            "00",
            "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "2[24-9]|47|58|6[237-9]|9[35-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[45]0"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2569]|4[1-69]|7[14]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IL": [
            "972",
            "0(?:0|1[2-9])",
            "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1-$2",
                    [
                        "125"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "121"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[2-489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "12"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1-$2",
                    [
                        "159"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3-$4",
                    [
                        "1[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1-$2 $3-$4",
                    [
                        "15"
                    ]
                ]
            ],
            "0"
        ],
        "IM": [
            "44",
            "00",
            "1624\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([25-8]\\d{5})$|0",
            "1624$1",
            0,
            "74576|(?:16|7[56])24"
        ],
        "IN": [
            "91",
            "00",
            "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}",
            [
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{8})",
                    "$1",
                    [
                        "5(?:0|2[23]|3[03]|[67]1|88)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)",
                        "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{4,5})",
                    "$1 $2",
                    [
                        "180",
                        "1800"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "140"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "11|2[02]|33|4[04]|79[1-7]|80[2-46]",
                        "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])",
                        "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]",
                        "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807",
                        "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]",
                        "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "[6-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{2,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1(?:6|8[06])",
                        "1(?:6|8[06]0)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "18"
                    ],
                    0,
                    1
                ]
            ],
            "0"
        ],
        "IO": [
            "246",
            "00",
            "3\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "3"
                    ]
                ]
            ]
        ],
        "IQ": [
            "964",
            "00",
            "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IR": [
            "98",
            "00",
            "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}",
            [
                4,
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{4,5})",
                    "$1",
                    [
                        "96"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4,5})",
                    "$1 $2",
                    [
                        "(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-8]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "IS": [
            "354",
            "00|1(?:0(?:01|[12]0)|100)",
            "(?:38\\d|[4-9])\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "IT": [
            "39",
            "00",
            "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4,6})",
                    "$1 $2",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "0[13-57-9][0159]|8(?:03|4[17]|9[2-5])",
                        "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"
                    ]
                ],
                [
                    "(\\d{4})(\\d{2,6})",
                    "$1 $2",
                    [
                        "0(?:[13-579][2-46-8]|8[236-8])"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "894"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[26]|5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "1(?:44|[679])|[378]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0[13-57-9][0159]|14"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "0[26]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "3"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"
                ],
                [
                    "3[1-9]\\d{8}|3[2-9]\\d{7}",
                    [
                        9,
                        10
                    ]
                ],
                [
                    "80(?:0\\d{3}|3)\\d{3}",
                    [
                        6,
                        9
                    ]
                ],
                [
                    "(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}",
                    [
                        6,
                        8,
                        9,
                        10
                    ]
                ],
                [
                    "1(?:78\\d|99)\\d{6}",
                    [
                        9,
                        10
                    ]
                ],
                0,
                0,
                0,
                [
                    "55\\d{8}",
                    [
                        10
                    ]
                ],
                [
                    "84(?:[08]\\d{3}|[17])\\d{3}",
                    [
                        6,
                        9
                    ]
                ]
            ]
        ],
        "JE": [
            "44",
            "00",
            "1534\\d{6}|(?:[3578]\\d|90)\\d{8}",
            [
                10
            ],
            0,
            "0",
            0,
            "([0-24-8]\\d{5})$|0",
            "1534$1",
            0,
            0,
            [
                [
                    "1534[0-24-8]\\d{5}"
                ],
                [
                    "7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"
                ],
                [
                    "80(?:07(?:35|81)|8901)\\d{4}"
                ],
                [
                    "(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"
                ],
                [
                    "701511\\d{4}"
                ],
                0,
                [
                    "(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"
                ],
                [
                    "76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"
                ],
                [
                    "56\\d{8}"
                ]
            ]
        ],
        "JM": [
            "1",
            "011",
            "(?:[58]\\d\\d|658|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "658|876"
        ],
        "JO": [
            "962",
            "00",
            "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2356]|87"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "70"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "JP": [
            "81",
            "010",
            "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}",
            [
                8,
                9,
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1-$2-$3",
                    [
                        "(?:12|57|99)0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]",
                        "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[36]|4(?:2[09]|7[01])",
                        "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]",
                        "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[14]|[289][2-9]|5[3-9]|7[2-4679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "800"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[257-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "(000[259]\\d{6})$|(?:(?:003768)0?)|0",
            "$1"
        ],
        "KE": [
            "254",
            "000",
            "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "[24-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[17]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KG": [
            "996",
            "00",
            "8\\d{9}|[235-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3(?:1[346]|[24-79])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[235-79]|88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d)(\\d{2,3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KH": [
            "855",
            "00[14-9]",
            "1\\d{9}|[1-9]\\d{7,8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "KI": [
            "686",
            "00",
            "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}",
            [
                5,
                8
            ],
            0,
            "0"
        ],
        "KM": [
            "269",
            "00",
            "[3478]\\d{6}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[3478]"
                    ]
                ]
            ]
        ],
        "KN": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "869$1",
            0,
            "869"
        ],
        "KP": [
            "850",
            "00|99",
            "85\\d{6}|(?:19\\d|[2-7])\\d{7}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-7]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "KR": [
            "82",
            "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))",
            "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}",
            [
                5,
                6,
                8,
                9,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1-$2",
                    [
                        "(?:3[1-3]|[46][1-4]|5[1-5])1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "60|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[1346]|5[1-5]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "[57]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})(\\d{4})",
                    "$1-$2-$3",
                    [
                        "5"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "0(8(?:[1-46-8]|5\\d\\d))?"
        ],
        "KW": [
            "965",
            "00",
            "18\\d{5}|(?:[2569]\\d|41)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3,4})",
                    "$1 $2",
                    [
                        "[169]|2(?:[235]|4[1-35-9])|52"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[245]"
                    ]
                ]
            ]
        ],
        "KY": [
            "1",
            "011",
            "(?:345|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "345$1",
            0,
            "345"
        ],
        "KZ": [
            "7",
            "810",
            "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}",
            [
                10,
                14
            ],
            0,
            "8",
            0,
            0,
            0,
            0,
            "33|7",
            0,
            "8~10"
        ],
        "LA": [
            "856",
            "00",
            "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2[13]|3[14]|[4-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "30[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LB": [
            "961",
            "00",
            "[27-9]\\d{7}|[13-9]\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[27-9]"
                    ]
                ]
            ],
            "0"
        ],
        "LC": [
            "1",
            "011",
            "(?:[58]\\d\\d|758|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-8]\\d{6})$|1",
            "758$1",
            0,
            "758"
        ],
        "LI": [
            "423",
            "00",
            "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[2379]|8(?:0[09]|7)",
                        "[2379]|8(?:0(?:02|9)|7)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "69"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            "0",
            0,
            "(1001)|0"
        ],
        "LK": [
            "94",
            "00",
            "[1-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[1-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LR": [
            "231",
            "00",
            "(?:[25]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[4-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23578]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "LS": [
            "266",
            "00",
            "(?:[256]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2568]"
                    ]
                ]
            ]
        ],
        "LT": [
            "370",
            "00",
            "(?:[3469]\\d|52|[78]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "52[0-7]"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "8 $1",
                    1
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "37|4(?:[15]|6[1-8])"
                    ],
                    "(8-$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[3-6]"
                    ],
                    "(8-$1)",
                    1
                ]
            ],
            "8",
            0,
            "[08]"
        ],
        "LU": [
            "352",
            "00",
            "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}",
            [
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "20[2-689]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "80[01]|90[015]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "20"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "2(?:[0367]|4[3-8])"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})",
                    "$1 $2 $3 $4",
                    [
                        "[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"
                    ]
                ]
            ],
            0,
            0,
            "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"
        ],
        "LV": [
            "371",
            "00",
            "(?:[268]\\d|90)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[269]|8[01]"
                    ]
                ]
            ]
        ],
        "LY": [
            "218",
            "00",
            "[2-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MA": [
            "212",
            "00",
            "[5-8]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1-$2",
                    [
                        "5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)",
                        "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1-$2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1-$2",
                    [
                        "[5-7]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"
                ],
                [
                    "(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"
                ],
                [
                    "80[0-7]\\d{6}"
                ],
                [
                    "89\\d{7}"
                ],
                0,
                0,
                0,
                0,
                [
                    "(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"
                ]
            ]
        ],
        "MC": [
            "377",
            "00",
            "(?:[3489]|6\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "4"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[389]"
                    ]
                ],
                [
                    "(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4 $5",
                    [
                        "6"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MD": [
            "373",
            "00",
            "(?:[235-7]\\d|[89]0)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "22|3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[25-7]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ME": [
            "382",
            "00",
            "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MF": [
            "590",
            "00",
            "590\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"
                ],
                [
                    "69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"
                ],
                [
                    "80[0-5]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"
                ]
            ]
        ],
        "MG": [
            "261",
            "00",
            "[23]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            "([24-9]\\d{6})$|0",
            "20$1"
        ],
        "MH": [
            "692",
            "011",
            "329\\d{4}|(?:[256]\\d|45)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[2-6]"
                    ]
                ]
            ],
            "1"
        ],
        "MK": [
            "389",
            "00",
            "[2-578]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2|34[47]|4(?:[37]7|5[47]|64)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[347]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[58]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ML": [
            "223",
            "00",
            "[24-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ]
                ]
            ]
        ],
        "MM": [
            "95",
            "00",
            "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[4-7]|8[1-35]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4,6})",
                    "$1 $2 $3",
                    [
                        "9(?:2[0-4]|[35-9]|4[137-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "92"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{5})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MN": [
            "976",
            "001",
            "[12]\\d{7,9}|[5-9]\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[12]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12]2[1-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5,6})",
                    "$1 $2",
                    [
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])",
                        "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{5})(\\d{4,5})",
                    "$1 $2",
                    [
                        "[12]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MO": [
            "853",
            "00",
            "0800\\d{3}|(?:28|[68]\\d)\\d{6}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[268]"
                    ]
                ]
            ]
        ],
        "MP": [
            "1",
            "011",
            "[58]\\d{9}|(?:67|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "670$1",
            0,
            "670"
        ],
        "MQ": [
            "596",
            "00",
            "596\\d{6}|(?:69|80|9\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[569]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MR": [
            "222",
            "00",
            "(?:[2-4]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-48]"
                    ]
                ]
            ]
        ],
        "MS": [
            "1",
            "011",
            "(?:[58]\\d\\d|664|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([34]\\d{6})$|1",
            "664$1",
            0,
            "664"
        ],
        "MT": [
            "356",
            "00",
            "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[2357-9]"
                    ]
                ]
            ]
        ],
        "MU": [
            "230",
            "0(?:0|[24-7]0|3[03])",
            "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}",
            [
                7,
                8,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-46]|8[013]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[57]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "020"
        ],
        "MV": [
            "960",
            "0(?:0|19)",
            "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}",
            [
                7,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[34679]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "MW": [
            "265",
            "00",
            "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}",
            [
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[137-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MX": [
            "52",
            "0[09]",
            "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}",
            [
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "33|5[56]|81"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{2})(\\d{4})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1(?:33|5[56]|81)"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{4})",
                    "$2 $3 $4",
                    [
                        "1"
                    ],
                    0,
                    1
                ]
            ],
            "01",
            0,
            "0(?:[12]|4[45])|1",
            0,
            0,
            0,
            0,
            "00"
        ],
        "MY": [
            "60",
            "00",
            "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "[4-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1-$2 $3",
                    [
                        "1(?:[02469]|[378][1-9]|53)|8",
                        "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{4})",
                    "$1-$2-$3-$4",
                    [
                        "1(?:[367]|80)"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "15"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1-$2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "MZ": [
            "258",
            "00",
            "(?:2|8\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2|8[2-79]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NA": [
            "264",
            "00",
            "[68]\\d{7,8}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "88"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "87"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NC": [
            "687",
            "00",
            "(?:050|[2-57-9]\\d\\d)\\d{3}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1.$2.$3",
                    [
                        "[02-57-9]"
                    ]
                ]
            ]
        ],
        "NE": [
            "227",
            "00",
            "[027-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "08"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[089]|2[013]|7[047]"
                    ]
                ]
            ]
        ],
        "NF": [
            "672",
            "00",
            "[13]\\d{5}",
            [
                6
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "1[0-3]"
                    ]
                ],
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "[13]"
                    ]
                ]
            ],
            0,
            0,
            "([0-258]\\d{4})$",
            "3$1"
        ],
        "NG": [
            "234",
            "009",
            "(?:[124-7]|9\\d{3})\\d{6}|[1-9]\\d{7}|[78]\\d{9,13}",
            [
                7,
                8,
                10,
                11,
                12,
                13,
                14
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "78"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[12]|9(?:0[3-9]|[1-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "[78]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NI": [
            "505",
            "00",
            "(?:1800|[25-8]\\d{3})\\d{4}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[125-8]"
                    ]
                ]
            ]
        ],
        "NL": [
            "31",
            "00",
            "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}",
            [
                5,
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4,7})",
                    "$1 $2",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "66"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{8})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-578]|91"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "NO": [
            "47",
            "00",
            "(?:0|[2-9]\\d{3})\\d{4}",
            [
                5,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2-79]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            "[02-689]|7[0-8]"
        ],
        "NP": [
            "977",
            "00",
            "(?:1\\d|9)\\d{9}|[1-9]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d)(\\d{7})",
                    "$1-$2",
                    [
                        "1[2-6]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1-$2",
                    [
                        "1[01]|[2-8]|9(?:[1-59]|[67][2-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "NR": [
            "674",
            "00",
            "(?:444|(?:55|8\\d)\\d|666)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[4-68]"
                    ]
                ]
            ]
        ],
        "NU": [
            "683",
            "00",
            "(?:[4-7]|888\\d)\\d{3}",
            [
                4,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "NZ": [
            "64",
            "0(?:0|161)",
            "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,8})",
                    "$1 $2",
                    [
                        "8[1-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "50[036-8]|8|90",
                        "50(?:[0367]|88)|8|90"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "24|[346]|7[2-57-9]|9[2-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:10|74)|[589]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1|2[028]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,5})",
                    "$1 $2 $3",
                    [
                        "2(?:[169]|7[0-35-9])|7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "OM": [
            "968",
            "00",
            "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{4,6})",
                    "$1 $2",
                    [
                        "[58]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[179]"
                    ]
                ]
            ]
        ],
        "PA": [
            "507",
            "00",
            "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}",
            [
                7,
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[1-57-9]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1-$2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PE": [
            "51",
            "00|19(?:1[124]|77|90)00",
            "(?:[14-8]|9\\d)\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[4-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " Anexo "
        ],
        "PF": [
            "689",
            "00",
            "4\\d{5}(?:\\d{2})?|8\\d{7,8}",
            [
                6,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "44"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "4|8[7-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PG": [
            "675",
            "00|140[1-3]",
            "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "18|[2-69]|85"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[78]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "PH": [
            "63",
            "00",
            "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}",
            [
                6,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d)(\\d{5})",
                    "$1 $2",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2",
                        "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "346|4(?:27|9[35])|883",
                        "3469|4(?:279|9(?:30|56))|8834"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|8[2-8]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})",
                    "$1 $2 $3 $4",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PK": [
            "92",
            "00",
            "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,7})",
                    "$1 $2 $3",
                    [
                        "[89]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "1"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6,7})",
                    "$1 $2",
                    [
                        "2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])",
                        "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{7,8})",
                    "$1 $2",
                    [
                        "(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{5})(\\d{5})",
                    "$1 $2",
                    [
                        "58"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{7})",
                    "$1 $2",
                    [
                        "3"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[24-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "PL": [
            "48",
            "00",
            "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "11|20|64"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1",
                        "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "64"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "1[2-8]|[2-7]|8[1-79]|9[145]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "PM": [
            "508",
            "00",
            "[45]\\d{5}|(?:708|80\\d)\\d{6}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[45]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "PR": [
            "1",
            "011",
            "(?:[589]\\d\\d|787)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            0,
            0,
            0,
            "787|939"
        ],
        "PS": [
            "970",
            "00",
            "[2489]2\\d{6}|(?:1\\d|5)\\d{8}",
            [
                8,
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[2489]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "PT": [
            "351",
            "00",
            "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[12]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "16|[236-9]"
                    ]
                ]
            ]
        ],
        "PW": [
            "680",
            "01[12]",
            "(?:[24-8]\\d\\d|345|900)\\d{4}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-9]"
                    ]
                ]
            ]
        ],
        "PY": [
            "595",
            "00",
            "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3,6})",
                    "$1 $2",
                    [
                        "[2-9]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{3})(\\d{4,5})",
                    "$1 $2",
                    [
                        "2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "87"
                    ]
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "9(?:[5-79]|8[1-6])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-8]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "9"
                    ]
                ]
            ],
            "0"
        ],
        "QA": [
            "974",
            "00",
            "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}",
            [
                7,
                8,
                9,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "2[16]|8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[3-7]"
                    ]
                ]
            ]
        ],
        "RE": [
            "262",
            "00",
            "(?:26|[689]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2689]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"
                ],
                [
                    "69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                [
                    "89[1-37-9]\\d{6}"
                ],
                0,
                0,
                0,
                0,
                [
                    "9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"
                ],
                [
                    "8(?:1[019]|2[0156]|84|90)\\d{6}"
                ]
            ]
        ],
        "RO": [
            "40",
            "00",
            "(?:[2378]\\d|62|90)\\d{7}|[23]\\d{5}",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})",
                    "$1 $2",
                    [
                        "2[3-6]",
                        "2[3-6]\\d9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "219|31"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23]1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[236-9]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            " int "
        ],
        "RS": [
            "381",
            "00",
            "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3,9})",
                    "$1 $2",
                    [
                        "(?:2[389]|39)0|[7-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{5,10})",
                    "$1 $2",
                    [
                        "[1-36]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "RU": [
            "7",
            "810",
            "8\\d{13}|[347-9]\\d{9}",
            [
                10,
                14
            ],
            [
                [
                    "(\\d{4})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-8]|2[1-9])",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))",
                        "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{5})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "7(?:1[0-68]|2[1-9])",
                        "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))",
                        "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[349]|8(?:[02-7]|1[1-8])"
                    ],
                    "8 ($1)",
                    1
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ],
                    "8 ($1)"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            "3[04-689]|[489]",
            0,
            "8~10"
        ],
        "RW": [
            "250",
            "00",
            "(?:06|[27]\\d\\d|[89]00)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[7-9]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SA": [
            "966",
            "00",
            "92\\d{7}|(?:[15]|8\\d)\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "5"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "81"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ]
            ],
            "0"
        ],
        "SB": [
            "677",
            "0[01]",
            "(?:[1-6]|[7-9]\\d\\d)\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7|8[4-9]|9(?:[1-8]|9[0-8])"
                    ]
                ]
            ]
        ],
        "SC": [
            "248",
            "010|0[0-2]",
            "800\\d{4}|(?:[249]\\d|64)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[246]|9[57]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SD": [
            "249",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SE": [
            "46",
            "00",
            "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}",
            [
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "20"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "9(?:00|39|44|9)"
                    ],
                    "0$1",
                    0,
                    "$1 $2"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "[12][136]|3[356]|4[0246]|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d)(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{2})",
                    "$1-$2 $3",
                    [
                        "1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{3})(\\d{2,3})(\\d{3})",
                    "$1-$2 $3",
                    [
                        "9(?:00|39|44)"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3"
                ],
                [
                    "(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "10|7"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "8"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4",
                    [
                        "[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{3})",
                    "$1-$2 $3 $4",
                    [
                        "9"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4"
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1-$2 $3 $4 $5",
                    [
                        "[26]"
                    ],
                    "0$1",
                    0,
                    "$1 $2 $3 $4 $5"
                ]
            ],
            "0"
        ],
        "SG": [
            "65",
            "0[0-3]\\d",
            "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}",
            [
                8,
                10,
                11
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[369]|8(?:0[1-8]|[1-9])"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ]
        ],
        "SH": [
            "290",
            "00",
            "(?:[256]\\d|8)\\d{3}",
            [
                4,
                5
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "[256]"
        ],
        "SI": [
            "386",
            "00|10(?:22|66|88|99)",
            "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}",
            [
                5,
                6,
                7,
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3,6})",
                    "$1 $2",
                    [
                        "8[09]|9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "59|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[37][01]|4[0139]|51|6"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[1-57]"
                    ],
                    "(0$1)"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "SJ": [
            "47",
            "00",
            "0\\d{4}|(?:[489]\\d|79)\\d{6}",
            [
                5,
                8
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "79"
        ],
        "SK": [
            "421",
            "00",
            "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}",
            [
                6,
                7,
                9
            ],
            [
                [
                    "(\\d)(\\d{2})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "[3-5][1-8]1",
                        "[3-5][1-8]1[67]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{3})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[689]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1/$2 $3 $4",
                    [
                        "[3-5]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "SL": [
            "232",
            "00",
            "(?:[237-9]\\d|66)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "[236-9]"
                    ],
                    "(0$1)"
                ]
            ],
            "0"
        ],
        "SM": [
            "378",
            "00",
            "(?:0549|[5-7]\\d)\\d{6}",
            [
                8,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[5-7]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ]
            ],
            0,
            0,
            "([89]\\d{5})$",
            "0549$1"
        ],
        "SN": [
            "221",
            "00",
            "(?:[378]\\d|93)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[379]"
                    ]
                ]
            ]
        ],
        "SO": [
            "252",
            "00",
            "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}",
            [
                6,
                7,
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "8[125]"
                    ]
                ],
                [
                    "(\\d{6})",
                    "$1",
                    [
                        "[134]"
                    ]
                ],
                [
                    "(\\d)(\\d{6})",
                    "$1 $2",
                    [
                        "[15]|2[0-79]|3[0-46-8]|4[0-7]"
                    ]
                ],
                [
                    "(\\d)(\\d{7})",
                    "$1 $2",
                    [
                        "(?:2|90)4|[67]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[348]|64|79|90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5,7})",
                    "$1 $2",
                    [
                        "1|28|6[0-35-9]|77|9[2-9]"
                    ]
                ]
            ],
            "0"
        ],
        "SR": [
            "597",
            "00",
            "(?:[2-5]|68|[78]\\d)\\d{5}",
            [
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1-$2-$3",
                    [
                        "56"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-5]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "[6-8]"
                    ]
                ]
            ]
        ],
        "SS": [
            "211",
            "00",
            "[19]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[19]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ST": [
            "239",
            "00",
            "(?:22|9\\d)\\d{5}",
            [
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[29]"
                    ]
                ]
            ]
        ],
        "SV": [
            "503",
            "00",
            "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?",
            [
                7,
                8,
                11
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[89]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[267]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ]
                ]
            ]
        ],
        "SX": [
            "1",
            "011",
            "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "(5\\d{6})$|1",
            "721$1",
            0,
            "721"
        ],
        "SY": [
            "963",
            "00",
            "[1-39]\\d{8}|[1-5]\\d{7}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-5]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "SZ": [
            "268",
            "00",
            "0800\\d{4}|(?:[237]\\d|900)\\d{6}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[0237]"
                    ]
                ],
                [
                    "(\\d{5})(\\d{4})",
                    "$1 $2",
                    [
                        "9"
                    ]
                ]
            ]
        ],
        "TA": [
            "290",
            "00",
            "8\\d{3}",
            [
                4
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "8"
        ],
        "TC": [
            "1",
            "011",
            "(?:[58]\\d\\d|649|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-479]\\d{6})$|1",
            "649$1",
            0,
            "649"
        ],
        "TD": [
            "235",
            "00|16",
            "(?:22|[69]\\d|77)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[2679]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "00"
        ],
        "TG": [
            "228",
            "00",
            "[279]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[279]"
                    ]
                ]
            ]
        ],
        "TH": [
            "66",
            "00[1-9]",
            "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}",
            [
                8,
                9,
                10,
                13
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[13-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            "0"
        ],
        "TJ": [
            "992",
            "810",
            "[0-57-9]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d{6})(\\d)(\\d{2})",
                    "$1 $2 $3",
                    [
                        "331",
                        "3317"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "44[02-479]|[34]7"
                    ]
                ],
                [
                    "(\\d{4})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "3[1-5]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[0-57-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TK": [
            "690",
            "00",
            "[2-47]\\d{3,6}",
            [
                4,
                5,
                6,
                7
            ]
        ],
        "TL": [
            "670",
            "00",
            "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}",
            [
                7,
                8
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[2-489]|70"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TM": [
            "993",
            "810",
            "[1-6]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "12"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{3})(\\d)(\\d{2})(\\d{2})",
                    "$1 $2-$3-$4",
                    [
                        "[1-5]"
                    ],
                    "(8 $1)"
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "6"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "TN": [
            "216",
            "00",
            "[2-57-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-57-9]"
                    ]
                ]
            ]
        ],
        "TO": [
            "676",
            "00",
            "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1-$2",
                    [
                        "[2-4]|50|6[09]|7[0-24-69]|8[05]"
                    ]
                ],
                [
                    "(\\d{4})(\\d{3})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[5-9]"
                    ]
                ]
            ]
        ],
        "TR": [
            "90",
            "00",
            "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}",
            [
                7,
                10,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "512|8[01589]|90"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "5(?:[0-59]|61)",
                        "5(?:[0-59]|61[06])",
                        "5(?:[0-59]|61[06]1)"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[24][1-8]|3[1-9]"
                    ],
                    "(0$1)",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{6,7})",
                    "$1 $2 $3",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "TT": [
            "1",
            "011",
            "(?:[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-46-8]\\d{6})$|1",
            "868$1",
            0,
            "868"
        ],
        "TV": [
            "688",
            "00",
            "(?:2|7\\d\\d|90)\\d{4}",
            [
                5,
                6,
                7
            ],
            [
                [
                    "(\\d{2})(\\d{3})",
                    "$1 $2",
                    [
                        "2"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})",
                    "$1 $2",
                    [
                        "90"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "TW": [
            "886",
            "0(?:0[25-79]|19)",
            "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}",
            [
                7,
                8,
                9,
                10,
                11
            ],
            [
                [
                    "(\\d{2})(\\d)(\\d{4})",
                    "$1 $2 $3",
                    [
                        "202"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[258]0"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]",
                        "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4,5})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            "#"
        ],
        "TZ": [
            "255",
            "00[056]",
            "(?:[25-8]\\d|41|90)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[24]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "5"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[67]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "UA": [
            "380",
            "00",
            "[89]\\d{9}|[3-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]",
                        "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])",
                        "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[3-7]|89|9[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[89]"
                    ],
                    "0$1"
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "0~0"
        ],
        "UG": [
            "256",
            "00[057]",
            "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{4})(\\d{5})",
                    "$1 $2",
                    [
                        "202",
                        "2024"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{6})",
                    "$1 $2",
                    [
                        "[27-9]|4(?:6[45]|[7-9])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[34]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "US": [
            "1",
            "011",
            "[2-9]\\d{9}|3\\d{6}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1-$2",
                    [
                        "310"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "($1) $2-$3",
                    [
                        "[2-9]"
                    ],
                    0,
                    1,
                    "$1-$2-$3"
                ]
            ],
            "1",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "(?:5056(?:[0-35-9]\\d|4[468])|73020\\d)\\d{4}|(?:4722|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|[34][016]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"
                ],
                [
                    ""
                ],
                [
                    "8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"
                ],
                [
                    "900[2-9]\\d{6}"
                ],
                [
                    "52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"
                ]
            ]
        ],
        "UY": [
            "598",
            "0(?:0|1[3-9]\\d)",
            "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}",
            [
                6,
                7,
                8,
                9,
                10,
                11,
                12,
                13
            ],
            [
                [
                    "(\\d{3})(\\d{3,4})",
                    "$1 $2",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[49]0|8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "9"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[124]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "0"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})",
                    "$1 $2 $3 $4",
                    [
                        "0"
                    ]
                ]
            ],
            "0",
            0,
            0,
            0,
            0,
            0,
            0,
            "00",
            " int. "
        ],
        "UZ": [
            "998",
            "810",
            "(?:20|33|[5-79]\\d|88)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "[235-9]"
                    ],
                    "8 $1"
                ]
            ],
            "8",
            0,
            0,
            0,
            0,
            0,
            0,
            "8~10"
        ],
        "VA": [
            "39",
            "00",
            "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}",
            [
                6,
                7,
                8,
                9,
                10,
                11
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            "06698"
        ],
        "VC": [
            "1",
            "011",
            "(?:[58]\\d\\d|784|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-7]\\d{6})$|1",
            "784$1",
            0,
            "784"
        ],
        "VE": [
            "58",
            "00",
            "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}",
            [
                10
            ],
            [
                [
                    "(\\d{3})(\\d{7})",
                    "$1-$2",
                    [
                        "[24-689]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "VG": [
            "1",
            "011",
            "(?:284|[58]\\d\\d|900)\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-578]\\d{6})$|1",
            "284$1",
            0,
            "284"
        ],
        "VI": [
            "1",
            "011",
            "[58]\\d{9}|(?:34|90)0\\d{7}",
            [
                10
            ],
            0,
            "1",
            0,
            "([2-9]\\d{6})$|1",
            "340$1",
            0,
            "340"
        ],
        "VN": [
            "84",
            "00",
            "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}",
            [
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{4})(\\d{4,6})",
                    "$1 $2",
                    [
                        "1"
                    ],
                    0,
                    1
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "6"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[357-9]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "2[48]"
                    ],
                    "0$1",
                    1
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "2"
                    ],
                    "0$1",
                    1
                ]
            ],
            "0"
        ],
        "VU": [
            "678",
            "00",
            "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}",
            [
                5,
                7
            ],
            [
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "[57-9]"
                    ]
                ]
            ]
        ],
        "WF": [
            "681",
            "00",
            "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?",
            [
                6,
                9
            ],
            [
                [
                    "(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3",
                    [
                        "[478]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{2})(\\d{2})(\\d{2})",
                    "$1 $2 $3 $4",
                    [
                        "8"
                    ]
                ]
            ]
        ],
        "WS": [
            "685",
            "0",
            "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}",
            [
                5,
                6,
                7,
                10
            ],
            [
                [
                    "(\\d{5})",
                    "$1",
                    [
                        "[2-5]|6[1-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3,7})",
                    "$1 $2",
                    [
                        "[68]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "7"
                    ]
                ]
            ]
        ],
        "XK": [
            "383",
            "00",
            "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}",
            [
                8,
                9
            ],
            [
                [
                    "(\\d{3})(\\d{5})",
                    "$1 $2",
                    [
                        "[89]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[2-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[23]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YE": [
            "967",
            "00",
            "(?:1|7\\d)\\d{7}|[1-7]\\d{6}",
            [
                7,
                8,
                9
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "[1-6]|7(?:[24-6]|8[0-7])"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "YT": [
            "262",
            "00",
            "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}",
            [
                9
            ],
            0,
            "0",
            0,
            0,
            0,
            0,
            0,
            [
                [
                    "269(?:0[0-467]|5[0-4]|6\\d|[78]0)\\d{4}"
                ],
                [
                    "639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"
                ],
                [
                    "80\\d{7}"
                ],
                0,
                0,
                0,
                0,
                0,
                [
                    "9(?:(?:39|47)8[01]|769\\d)\\d{4}"
                ]
            ]
        ],
        "ZA": [
            "27",
            "00",
            "[1-79]\\d{8}|8\\d{4,9}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{2})(\\d{3,4})",
                    "$1 $2",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{2,3})",
                    "$1 $2 $3",
                    [
                        "8[1-4]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "860"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1-9]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "8"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZM": [
            "260",
            "00",
            "800\\d{6}|(?:21|63|[79]\\d)\\d{7}",
            [
                9
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[28]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "[79]"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ],
        "ZW": [
            "263",
            "00",
            "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}",
            [
                5,
                6,
                7,
                8,
                9,
                10
            ],
            [
                [
                    "(\\d{3})(\\d{3,5})",
                    "$1 $2",
                    [
                        "2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d)(\\d{3})(\\d{2,4})",
                    "$1 $2 $3",
                    [
                        "[49]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{4})",
                    "$1 $2",
                    [
                        "80"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{7})",
                    "$1 $2",
                    [
                        "24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2",
                        "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"
                    ],
                    "(0$1)"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "7"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)",
                        "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{6})",
                    "$1 $2",
                    [
                        "8"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3,5})",
                    "$1 $2",
                    [
                        "1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{2})(\\d{3})(\\d{3,4})",
                    "$1 $2 $3",
                    [
                        "29[013-9]|39|54"
                    ],
                    "0$1"
                ],
                [
                    "(\\d{4})(\\d{3,5})",
                    "$1 $2",
                    [
                        "(?:25|54)8",
                        "258|5483"
                    ],
                    "0$1"
                ]
            ],
            "0"
        ]
    },
    "nonGeographic": {
        "800": [
            "800",
            0,
            "(?:00|[1-9]\\d)\\d{6}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "\\d"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                [
                    "(?:00|[1-9]\\d)\\d{6}"
                ]
            ]
        ],
        "808": [
            "808",
            0,
            "[1-9]\\d{7}",
            [
                8
            ],
            [
                [
                    "(\\d{4})(\\d{4})",
                    "$1 $2",
                    [
                        "[1-9]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "[1-9]\\d{7}"
                ]
            ]
        ],
        "870": [
            "870",
            0,
            "7\\d{11}|[35-7]\\d{8}",
            [
                9,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "[35-7]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"
                ]
            ]
        ],
        "878": [
            "878",
            0,
            "10\\d{10}",
            [
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "1"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "10\\d{10}"
                ]
            ]
        ],
        "881": [
            "881",
            0,
            "6\\d{9}|[0-36-9]\\d{8}",
            [
                9,
                10
            ],
            [
                [
                    "(\\d)(\\d{3})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[0-37-9]"
                    ]
                ],
                [
                    "(\\d)(\\d{3})(\\d{5,6})",
                    "$1 $2 $3",
                    [
                        "6"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "6\\d{9}|[0-36-9]\\d{8}"
                ]
            ]
        ],
        "882": [
            "882",
            0,
            "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?",
            [
                7,
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{2})(\\d{5})",
                    "$1 $2",
                    [
                        "16|342"
                    ]
                ],
                [
                    "(\\d{2})(\\d{6})",
                    "$1 $2",
                    [
                        "49"
                    ]
                ],
                [
                    "(\\d{2})(\\d{2})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "1[36]|9"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "3[23]"
                    ]
                ],
                [
                    "(\\d{2})(\\d{3,4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "16"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "10|23|3(?:[15]|4[57])|4|51"
                    ]
                ],
                [
                    "(\\d{3})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "34"
                    ]
                ],
                [
                    "(\\d{2})(\\d{4,5})(\\d{5})",
                    "$1 $2 $3",
                    [
                        "[1-35]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                [
                    "342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}",
                    [
                        7,
                        8,
                        9,
                        10,
                        12
                    ]
                ],
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"
                ]
            ]
        ],
        "883": [
            "883",
            0,
            "(?:[1-4]\\d|51)\\d{6,10}",
            [
                8,
                9,
                10,
                11,
                12
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{2,8})",
                    "$1 $2 $3",
                    [
                        "[14]|2[24-689]|3[02-689]|51[24-9]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3",
                    [
                        "510"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "21"
                    ]
                ],
                [
                    "(\\d{4})(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "51[13]"
                    ]
                ],
                [
                    "(\\d{3})(\\d{3})(\\d{3})(\\d{3})",
                    "$1 $2 $3 $4",
                    [
                        "[235]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"
                ]
            ]
        ],
        "888": [
            "888",
            0,
            "\\d{11}",
            [
                11
            ],
            [
                [
                    "(\\d{3})(\\d{3})(\\d{5})",
                    "$1 $2 $3"
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                0,
                0,
                0,
                [
                    "\\d{11}"
                ]
            ]
        ],
        "979": [
            "979",
            0,
            "[1359]\\d{8}",
            [
                9
            ],
            [
                [
                    "(\\d)(\\d{4})(\\d{4})",
                    "$1 $2 $3",
                    [
                        "[1359]"
                    ]
                ]
            ],
            0,
            0,
            0,
            0,
            0,
            0,
            [
                0,
                0,
                0,
                [
                    "[1359]\\d{8}"
                ]
            ]
        ]
    }
};


function $8bd7a0efdde9e15b$export$2e2bcd8739ae039(func, _arguments) {
    var args = Array.prototype.slice.call(_arguments);
    args.push((0, $f0d2529331ec0957$export$2e2bcd8739ae039));
    return func.apply(this, args);
}


// This is a port of Google Android `libphonenumber`'s
// `phonenumberutil.js` of December 31th, 2018.
//
// https://github.com/googlei18n/libphonenumber/commits/master/javascript/i18n/phonenumbers/phonenumberutil.js
// The minimum length of the national significant number.
var $54824ce66ed242f7$export$cd8355bcbe13154 = 2; // The ITU says the maximum length should be 15,
var $54824ce66ed242f7$export$85ddd8c9b243679b = 17; // The maximum length of the country calling code.
var $54824ce66ed242f7$export$514717690676fb4a = 3; // Digits accepted in phone numbers
var $54824ce66ed242f7$export$852d1d4a47329634 = "0-9０-９٠-٩۰-۹"; // `DASHES` will be right after the opening square bracket of the "character class"
var $54824ce66ed242f7$var$DASHES = "-‐-―−ー－";
var $54824ce66ed242f7$var$SLASHES = "／/";
var $54824ce66ed242f7$var$DOTS = "．.";
var $54824ce66ed242f7$export$20542845033f576e = " \xa0\xad​⁠　";
var $54824ce66ed242f7$var$BRACKETS = "()（）［］\\[\\]"; // export const OPENING_BRACKETS = '(\uFF08\uFF3B\\\['
var $54824ce66ed242f7$var$TILDES = "~⁓∼～"; // Regular expression of acceptable punctuation found in phone numbers. This
var $54824ce66ed242f7$export$7f01587e28f9194 = "".concat($54824ce66ed242f7$var$DASHES).concat($54824ce66ed242f7$var$SLASHES).concat($54824ce66ed242f7$var$DOTS).concat($54824ce66ed242f7$export$20542845033f576e).concat($54824ce66ed242f7$var$BRACKETS).concat($54824ce66ed242f7$var$TILDES);
var $54824ce66ed242f7$export$207c99ccf3902df8 = "+＋"; // const LEADING_PLUS_CHARS_PATTERN = new RegExp('^[' + PLUS_CHARS + ']+')


function $37402b15fa819a93$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $37402b15fa819a93$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $37402b15fa819a93$var$_typeof(obj);
}
function $37402b15fa819a93$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $37402b15fa819a93$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $37402b15fa819a93$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $37402b15fa819a93$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $37402b15fa819a93$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $37402b15fa819a93$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $37402b15fa819a93$var$_setPrototypeOf(subClass, superClass);
}
function $37402b15fa819a93$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $37402b15fa819a93$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $37402b15fa819a93$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $37402b15fa819a93$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $37402b15fa819a93$var$_possibleConstructorReturn(this, result);
    };
}
function $37402b15fa819a93$var$_possibleConstructorReturn(self, call) {
    if (call && ($37402b15fa819a93$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $37402b15fa819a93$var$_assertThisInitialized(self);
}
function $37402b15fa819a93$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $37402b15fa819a93$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $37402b15fa819a93$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$37402b15fa819a93$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $37402b15fa819a93$var$_construct(Class, arguments, $37402b15fa819a93$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $37402b15fa819a93$var$_setPrototypeOf(Wrapper, Class);
    };
    return $37402b15fa819a93$var$_wrapNativeSuper(Class);
}
function $37402b15fa819a93$var$_construct(Parent, args, Class) {
    if ($37402b15fa819a93$var$_isNativeReflectConstruct()) $37402b15fa819a93$var$_construct = Reflect.construct;
    else $37402b15fa819a93$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $37402b15fa819a93$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $37402b15fa819a93$var$_construct.apply(null, arguments);
}
function $37402b15fa819a93$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $37402b15fa819a93$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $37402b15fa819a93$var$_setPrototypeOf(o, p) {
    $37402b15fa819a93$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $37402b15fa819a93$var$_setPrototypeOf(o, p);
}
function $37402b15fa819a93$var$_getPrototypeOf(o) {
    $37402b15fa819a93$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $37402b15fa819a93$var$_getPrototypeOf(o);
}
// https://stackoverflow.com/a/46971044/970769
// "Breaking changes in Typescript 2.1"
// "Extending built-ins like Error, Array, and Map may no longer work."
// "As a recommendation, you can manually adjust the prototype immediately after any super(...) calls."
// https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
var $37402b15fa819a93$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_Error) {
    $37402b15fa819a93$var$_inherits(ParseError, _Error);
    var _super = $37402b15fa819a93$var$_createSuper(ParseError);
    function ParseError(code) {
        var _this;
        $37402b15fa819a93$var$_classCallCheck(this, ParseError);
        _this = _super.call(this, code); // Set the prototype explicitly.
        // Any subclass of FooError will have to manually set the prototype as well.
        Object.setPrototypeOf($37402b15fa819a93$var$_assertThisInitialized(_this), ParseError.prototype);
        _this.name = _this.constructor.name;
        return _this;
    }
    return $37402b15fa819a93$var$_createClass(ParseError);
}(/*#__PURE__*/ $37402b15fa819a93$var$_wrapNativeSuper(Error));


// Copy-pasted from:
// https://github.com/substack/semver-compare/blob/master/index.js
//
// Inlining this function because some users reported issues with
// importing from `semver-compare` in a browser with ES6 "native" modules.
//
// Fixes `semver-compare` not being able to compare versions with alpha/beta/etc "tags".
// https://github.com/catamphetamine/libphonenumber-js/issues/381
function $cd47f20e2ead0ba3$export$2e2bcd8739ae039(a, b) {
    a = a.split("-");
    b = b.split("-");
    var pa = a[0].split(".");
    var pb = b[0].split(".");
    for(var i = 0; i < 3; i++){
        var na = Number(pa[i]);
        var nb = Number(pb[i]);
        if (na > nb) return 1;
        if (nb > na) return -1;
        if (!isNaN(na) && isNaN(nb)) return 1;
        if (isNaN(na) && !isNaN(nb)) return -1;
    }
    if (a[1] && b[1]) return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
    return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}


var $4b3fe5e7e402fbb7$var$objectConstructor = {}.constructor;
function $4b3fe5e7e402fbb7$export$2e2bcd8739ae039(object) {
    return object !== undefined && object !== null && object.constructor === $4b3fe5e7e402fbb7$var$objectConstructor;
}


function $ea90f4b3245f449e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $ea90f4b3245f449e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $ea90f4b3245f449e$var$_typeof(obj);
}
function $ea90f4b3245f449e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ea90f4b3245f449e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ea90f4b3245f449e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ea90f4b3245f449e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ea90f4b3245f449e$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// "country_phone_code_to_countries" to "country_calling_codes".
var $ea90f4b3245f449e$var$V2 = "1.0.18"; // Added "idd_prefix" and "default_idd_prefix".
var $ea90f4b3245f449e$var$V3 = "1.2.0"; // Moved `001` country code to "nonGeographic" section of metadata.
var $ea90f4b3245f449e$var$V4 = "1.7.35";
var $ea90f4b3245f449e$var$DEFAULT_EXT_PREFIX = " ext. ";
var $ea90f4b3245f449e$var$CALLING_CODE_REG_EXP = /^\d+$/;
/**
 * See: https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md
 */ var $ea90f4b3245f449e$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Metadata(metadata) {
        $ea90f4b3245f449e$var$_classCallCheck(this, Metadata);
        $ea90f4b3245f449e$export$a0b100d4662a8795(metadata);
        this.metadata = metadata;
        $ea90f4b3245f449e$var$setVersion.call(this, metadata);
    }
    $ea90f4b3245f449e$var$_createClass(Metadata, [
        {
            key: "getCountries",
            value: function getCountries() {
                return Object.keys(this.metadata.countries).filter(function(_) {
                    return _ !== "001";
                });
            }
        },
        {
            key: "getCountryMetadata",
            value: function getCountryMetadata(countryCode) {
                return this.metadata.countries[countryCode];
            }
        },
        {
            key: "nonGeographic",
            value: function nonGeographic() {
                if (this.v1 || this.v2 || this.v3) return; // `nonGeographical` was a typo.
                // It's present in metadata generated from `1.7.35` to `1.7.37`.
                // The test case could be found by searching for "nonGeographical".
                return this.metadata.nonGeographic || this.metadata.nonGeographical;
            }
        },
        {
            key: "hasCountry",
            value: function hasCountry(country) {
                return this.getCountryMetadata(country) !== undefined;
            }
        },
        {
            key: "hasCallingCode",
            value: function hasCallingCode(callingCode) {
                if (this.getCountryCodesForCallingCode(callingCode)) return true;
                if (this.nonGeographic()) {
                    if (this.nonGeographic()[callingCode]) return true;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return true;
                }
            }
        },
        {
            key: "isNonGeographicCallingCode",
            value: function isNonGeographicCallingCode(callingCode) {
                if (this.nonGeographic()) return this.nonGeographic()[callingCode] ? true : false;
                else return this.getCountryCodesForCallingCode(callingCode) ? false : true;
            } // Deprecated.
        },
        {
            key: "country",
            value: function country(countryCode) {
                return this.selectNumberingPlan(countryCode);
            }
        },
        {
            key: "selectNumberingPlan",
            value: function selectNumberingPlan(countryCode, callingCode) {
                // Supports just passing `callingCode` as the first argument.
                if (countryCode && $ea90f4b3245f449e$var$CALLING_CODE_REG_EXP.test(countryCode)) {
                    callingCode = countryCode;
                    countryCode = null;
                }
                if (countryCode && countryCode !== "001") {
                    if (!this.hasCountry(countryCode)) throw new Error("Unknown country: ".concat(countryCode));
                    this.numberingPlan = new $ea90f4b3245f449e$var$NumberingPlan(this.getCountryMetadata(countryCode), this);
                } else if (callingCode) {
                    if (!this.hasCallingCode(callingCode)) throw new Error("Unknown calling code: ".concat(callingCode));
                    this.numberingPlan = new $ea90f4b3245f449e$var$NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
                } else this.numberingPlan = undefined;
                return this;
            }
        },
        {
            key: "getCountryCodesForCallingCode",
            value: function getCountryCodesForCallingCode(callingCode) {
                var countryCodes = this.countryCallingCodes()[callingCode];
                if (countryCodes) {
                    // Metadata before V4 included "non-geographic entity" calling codes
                    // inside `country_calling_codes` (for example, `"881":["001"]`).
                    // Now the semantics of `country_calling_codes` has changed:
                    // it's specifically for "countries" now.
                    // Older versions of custom metadata will simply skip parsing
                    // "non-geographic entity" phone numbers with new versions
                    // of this library: it's not considered a bug,
                    // because such numbers are extremely rare,
                    // and developers extremely rarely use custom metadata.
                    if (countryCodes.length === 1 && countryCodes[0].length === 3) return;
                    return countryCodes;
                }
            }
        },
        {
            key: "getCountryCodeForCallingCode",
            value: function getCountryCodeForCallingCode(callingCode) {
                var countryCodes = this.getCountryCodesForCallingCode(callingCode);
                if (countryCodes) return countryCodes[0];
            }
        },
        {
            key: "getNumberingPlanMetadata",
            value: function getNumberingPlanMetadata(callingCode) {
                var countryCode = this.getCountryCodeForCallingCode(callingCode);
                if (countryCode) return this.getCountryMetadata(countryCode);
                if (this.nonGeographic()) {
                    var metadata = this.nonGeographic()[callingCode];
                    if (metadata) return metadata;
                } else {
                    // A hacky workaround for old custom metadata (generated before V4).
                    // In that metadata, there was no concept of "non-geographic" metadata
                    // so metadata for `001` country code was stored along with other countries.
                    // The test case can be found by searching for:
                    // "should work around `nonGeographic` metadata not existing".
                    var countryCodes = this.countryCallingCodes()[callingCode];
                    if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") return this.metadata.countries["001"];
                }
            } // Deprecated.
        },
        {
            key: "countryCallingCode",
            value: function countryCallingCode() {
                return this.numberingPlan.callingCode();
            } // Deprecated.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                return this.numberingPlan.IDDPrefix();
            } // Deprecated.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                return this.numberingPlan.defaultIDDPrefix();
            } // Deprecated.
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                return this.numberingPlan.nationalNumberPattern();
            } // Deprecated.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                return this.numberingPlan.possibleLengths();
            } // Deprecated.
        },
        {
            key: "formats",
            value: function formats() {
                return this.numberingPlan.formats();
            } // Deprecated.
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                return this.numberingPlan.nationalPrefixForParsing();
            } // Deprecated.
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.numberingPlan.nationalPrefixTransformRule();
            } // Deprecated.
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.numberingPlan.leadingDigits();
            } // Deprecated.
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                return this.numberingPlan.hasTypes();
            } // Deprecated.
        },
        {
            key: "type",
            value: function type(_type) {
                return this.numberingPlan.type(_type);
            } // Deprecated.
        },
        {
            key: "ext",
            value: function ext() {
                return this.numberingPlan.ext();
            }
        },
        {
            key: "countryCallingCodes",
            value: function countryCallingCodes() {
                if (this.v1) return this.metadata.country_phone_code_to_countries;
                return this.metadata.country_calling_codes;
            } // Deprecated.
        },
        {
            key: "chooseCountryByCountryCallingCode",
            value: function chooseCountryByCountryCallingCode(callingCode) {
                return this.selectNumberingPlan(callingCode);
            }
        },
        {
            key: "hasSelectedNumberingPlan",
            value: function hasSelectedNumberingPlan() {
                return this.numberingPlan !== undefined;
            }
        }
    ]);
    return Metadata;
}();
var $ea90f4b3245f449e$var$NumberingPlan = /*#__PURE__*/ function() {
    function NumberingPlan(metadata, globalMetadataObject) {
        $ea90f4b3245f449e$var$_classCallCheck(this, NumberingPlan);
        this.globalMetadataObject = globalMetadataObject;
        this.metadata = metadata;
        $ea90f4b3245f449e$var$setVersion.call(this, globalMetadataObject.metadata);
    }
    $ea90f4b3245f449e$var$_createClass(NumberingPlan, [
        {
            key: "callingCode",
            value: function callingCode() {
                return this.metadata[0];
            } // Formatting information for regions which share
        },
        {
            key: "getDefaultCountryMetadataForRegion",
            value: function getDefaultCountryMetadataForRegion() {
                return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
            } // Is always present.
        },
        {
            key: "IDDPrefix",
            value: function IDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[1];
            } // Is only present when a country supports multiple IDD prefixes.
        },
        {
            key: "defaultIDDPrefix",
            value: function defaultIDDPrefix() {
                if (this.v1 || this.v2) return;
                return this.metadata[12];
            }
        },
        {
            key: "nationalNumberPattern",
            value: function nationalNumberPattern() {
                if (this.v1 || this.v2) return this.metadata[1];
                return this.metadata[2];
            } // "possible length" data is always present in Google's metadata.
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.v1) return;
                return this.metadata[this.v2 ? 2 : 3];
            }
        },
        {
            key: "_getFormats",
            value: function _getFormats(metadata) {
                return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "formats",
            value: function formats() {
                var _this = this;
                var formats = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
                return formats.map(function(_) {
                    return new $ea90f4b3245f449e$var$Format(_, _this);
                });
            }
        },
        {
            key: "nationalPrefix",
            value: function nationalPrefix() {
                return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
            }
        },
        {
            key: "_getNationalPrefixFormattingRule",
            value: function _getNationalPrefixFormattingRule(metadata) {
                return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "_nationalPrefixForParsing",
            value: function _nationalPrefixForParsing() {
                return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
            }
        },
        {
            key: "nationalPrefixForParsing",
            value: function nationalPrefixForParsing() {
                // If `national_prefix_for_parsing` is not set explicitly,
                // then infer it from `national_prefix` (if any)
                return this._nationalPrefixForParsing() || this.nationalPrefix();
            }
        },
        {
            key: "nationalPrefixTransformRule",
            value: function nationalPrefixTransformRule() {
                return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
            }
        },
        {
            key: "_getNationalPrefixIsOptionalWhenFormatting",
            value: function _getNationalPrefixIsOptionalWhenFormatting() {
                return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
            } // For countries of the same region (e.g. NANPA)
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
            }
        },
        {
            key: "leadingDigits",
            value: function leadingDigits() {
                return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
            }
        },
        {
            key: "types",
            value: function types() {
                return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
            }
        },
        {
            key: "hasTypes",
            value: function hasTypes() {
                // Versions 1.2.0 - 1.2.4: can be `[]`.
                /* istanbul ignore next */ if (this.types() && this.types().length === 0) return false;
                 // Versions <= 1.2.4: can be `undefined`.
                // Version >= 1.2.5: can be `0`.
                return !!this.types();
            }
        },
        {
            key: "type",
            value: function type(_type2) {
                if (this.hasTypes() && $ea90f4b3245f449e$var$getType(this.types(), _type2)) return new $ea90f4b3245f449e$var$Type($ea90f4b3245f449e$var$getType(this.types(), _type2), this);
            }
        },
        {
            key: "ext",
            value: function ext() {
                if (this.v1 || this.v2) return $ea90f4b3245f449e$var$DEFAULT_EXT_PREFIX;
                return this.metadata[13] || $ea90f4b3245f449e$var$DEFAULT_EXT_PREFIX;
            }
        }
    ]);
    return NumberingPlan;
}();
var $ea90f4b3245f449e$var$Format = /*#__PURE__*/ function() {
    function Format(format, metadata) {
        $ea90f4b3245f449e$var$_classCallCheck(this, Format);
        this._format = format;
        this.metadata = metadata;
    }
    $ea90f4b3245f449e$var$_createClass(Format, [
        {
            key: "pattern",
            value: function pattern() {
                return this._format[0];
            }
        },
        {
            key: "format",
            value: function format() {
                return this._format[1];
            }
        },
        {
            key: "leadingDigitsPatterns",
            value: function leadingDigitsPatterns() {
                return this._format[2] || [];
            }
        },
        {
            key: "nationalPrefixFormattingRule",
            value: function nationalPrefixFormattingRule() {
                return this._format[3] || this.metadata.nationalPrefixFormattingRule();
            }
        },
        {
            key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
            value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
                return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            }
        },
        {
            key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
            value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
                // National prefix is omitted if there's no national prefix formatting rule
                // set for this country, or when the national prefix formatting rule
                // contains no national prefix itself, or when this rule is set but
                // national prefix is optional for this phone number format
                // (and it is not enforced explicitly)
                return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
            } // Checks whether national prefix formatting rule contains national prefix.
        },
        {
            key: "usesNationalPrefix",
            value: function usesNationalPrefix() {
                return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
                !$ea90f4b3245f449e$var$FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) // In compressed metadata, `this.nationalPrefixFormattingRule()` is `0`
                 ? true : false;
            }
        },
        {
            key: "internationalFormat",
            value: function internationalFormat() {
                return this._format[5] || this.format();
            }
        }
    ]);
    return Format;
}();
/**
 * A pattern that is used to determine if the national prefix formatting rule
 * has the first group only, i.e., does not start with the national prefix.
 * Note that the pattern explicitly allows for unbalanced parentheses.
 */ var $ea90f4b3245f449e$var$FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var $ea90f4b3245f449e$var$Type = /*#__PURE__*/ function() {
    function Type(type, metadata) {
        $ea90f4b3245f449e$var$_classCallCheck(this, Type);
        this.type = type;
        this.metadata = metadata;
    }
    $ea90f4b3245f449e$var$_createClass(Type, [
        {
            key: "pattern",
            value: function pattern() {
                if (this.metadata.v1) return this.type;
                return this.type[0];
            }
        },
        {
            key: "possibleLengths",
            value: function possibleLengths() {
                if (this.metadata.v1) return;
                return this.type[1] || this.metadata.possibleLengths();
            }
        }
    ]);
    return Type;
}();
function $ea90f4b3245f449e$var$getType(types, type) {
    switch(type){
        case "FIXED_LINE":
            return types[0];
        case "MOBILE":
            return types[1];
        case "TOLL_FREE":
            return types[2];
        case "PREMIUM_RATE":
            return types[3];
        case "PERSONAL_NUMBER":
            return types[4];
        case "VOICEMAIL":
            return types[5];
        case "UAN":
            return types[6];
        case "PAGER":
            return types[7];
        case "VOIP":
            return types[8];
        case "SHARED_COST":
            return types[9];
    }
}
function $ea90f4b3245f449e$export$a0b100d4662a8795(metadata) {
    if (!metadata) throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
     // `country_phone_code_to_countries` was renamed to
    // `country_calling_codes` in `1.0.18`.
    if (!(0, $4b3fe5e7e402fbb7$export$2e2bcd8739ae039)(metadata) || !(0, $4b3fe5e7e402fbb7$export$2e2bcd8739ae039)(metadata.countries)) throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat((0, $4b3fe5e7e402fbb7$export$2e2bcd8739ae039)(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + $ea90f4b3245f449e$var$typeOf(metadata) + ": " + metadata, "."));
} // Babel transforms `typeof` into some "branches"
// so istanbul will show this as "branch not covered".
/* istanbul ignore next */ var $ea90f4b3245f449e$var$typeOf = function typeOf(_) {
    return $ea90f4b3245f449e$var$_typeof(_);
};
function $ea90f4b3245f449e$export$9b48c965eafc2cf6(country, metadata) {
    metadata = new $ea90f4b3245f449e$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).ext();
    return $ea90f4b3245f449e$var$DEFAULT_EXT_PREFIX;
}
function $ea90f4b3245f449e$export$32876ca2f1919cf0(country, metadata) {
    metadata = new $ea90f4b3245f449e$export$2e2bcd8739ae039(metadata);
    if (metadata.hasCountry(country)) return metadata.country(country).countryCallingCode();
    throw new Error("Unknown country: ".concat(country));
}
function $ea90f4b3245f449e$export$bd9e113b8b17202a(country, metadata) {
    // metadata = new Metadata(metadata)
    // return metadata.hasCountry(country)
    return metadata.countries.hasOwnProperty(country);
}
function $ea90f4b3245f449e$var$setVersion(metadata) {
    var version = metadata.version;
    if (typeof version === "number") {
        this.v1 = version === 1;
        this.v2 = version === 2;
        this.v3 = version === 3;
        this.v4 = version === 4;
    } else {
        if (!version) this.v1 = true;
        else if ((0, $cd47f20e2ead0ba3$export$2e2bcd8739ae039)(version, $ea90f4b3245f449e$var$V3) === -1) this.v2 = true;
        else if ((0, $cd47f20e2ead0ba3$export$2e2bcd8739ae039)(version, $ea90f4b3245f449e$var$V4) === -1) this.v3 = true;
        else this.v4 = true;
    }
} // const ISO_COUNTRY_CODE = /^[A-Z]{2}$/
 // function isCountryCode(countryCode) {
 // 	return ISO_COUNTRY_CODE.test(countryCodeOrCountryCallingCode)
 // }




var $55e4abd51ccfcb34$var$RFC3966_EXTN_PREFIX = ";ext=";
/**
 * Helper method for constructing regular expressions for parsing. Creates
 * an expression that captures up to max_length digits.
 * @return {string} RegEx pattern to capture extension digits.
 */ var $55e4abd51ccfcb34$var$getExtensionDigitsPattern = function getExtensionDigitsPattern(maxLength) {
    return "([".concat((0, $54824ce66ed242f7$export$852d1d4a47329634), "]{1,").concat(maxLength, "})");
};
function $55e4abd51ccfcb34$export$2e2bcd8739ae039(purpose) {
    // We cap the maximum length of an extension based on the ambiguity of the way
    // the extension is prefixed. As per ITU, the officially allowed length for
    // extensions is actually 40, but we don't support this since we haven't seen real
    // examples and this introduces many false interpretations as the extension labels
    // are not standardized.
    /** @type {string} */ var extLimitAfterExplicitLabel = "20";
    /** @type {string} */ var extLimitAfterLikelyLabel = "15";
    /** @type {string} */ var extLimitAfterAmbiguousChar = "9";
    /** @type {string} */ var extLimitWhenNotSure = "6";
    /** @type {string} */ var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xa0\\t,]*"; // Optional full stop (.) or colon, followed by zero or more spaces/tabs/commas.
    /** @type {string} */ var possibleCharsAfterExtLabel = "[:\\.．]?[ \xa0\\t,-]*";
    /** @type {string} */ var optionalExtnSuffix = "#?"; // Here the extension is called out in more explicit way, i.e mentioning it obvious
    // patterns like "ext.".
    /** @type {string} */ var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|\xf3))?n?|ｅ?ｘｔｎ?|доб|anexo)"; // One-character symbols that can be used to indicate an extension, and less
    // commonly used or more ambiguous extension labels.
    /** @type {string} */ var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)"; // When extension is not separated clearly.
    /** @type {string} */ var ambiguousSeparator = "[- ]+"; // This is the same as possibleSeparatorsBetweenNumberAndExtLabel, but not matching
    // comma as extension label may have it.
    /** @type {string} */ var possibleSeparatorsNumberExtLabelNoComma = "[ \xa0\\t]*"; // ",," is commonly used for auto dialling the extension when connected. First
    // comma is matched through possibleSeparatorsBetweenNumberAndExtLabel, so we do
    // not repeat it here. Semi-colon works in Iphone and Android also to pop up a
    // button with the extension number following.
    /** @type {string} */ var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
    /** @type {string} */ var rfcExtn = $55e4abd51ccfcb34$var$RFC3966_EXTN_PREFIX + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel);
    /** @type {string} */ var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
    /** @type {string} */ var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
    /** @type {string} */ var americanStyleExtnWithSuffix = ambiguousSeparator + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
    /** @type {string} */ var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
    /** @type {string} */ var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + $55e4abd51ccfcb34$var$getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix; // The first regular expression covers RFC 3966 format, where the extension is added
    // using ";ext=". The second more generic where extension is mentioned with explicit
    // labels like "ext:". In both the above cases we allow more numbers in extension than
    // any other extension labels. The third one captures when single character extension
    // labels or less commonly used labels are used. In such cases we capture fewer
    // extension digits in order to reduce the chance of falsely interpreting two
    // numbers beside each other as a number + extension. The fourth one covers the
    // special case of American numbers where the extension is written with a hash
    // at the end, such as "- 503#". The fifth one is exclusively for extension
    // autodialling formats which are used when dialling and in this case we accept longer
    // extensions. The last one is more liberal on the number of commas that acts as
    // extension labels, so we have a strict cap on the number of digits in such extensions.
    return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}


//  Checks we have at least three leading digits, and only valid punctuation,
//  alpha characters and digits in the phone number. Does not include extension
//  data. The symbol 'x' is allowed here as valid punctuation since it is often
//  used as a placeholder for carrier codes, for example in Brazilian phone
//  numbers. We also allow multiple '+' characters at the start.
//
//  Corresponds to the following:
//  [digits]{minLengthNsn}|
//  plus_sign*
//  (([punctuation]|[star])*[digits]){3,}([punctuation]|[star]|[digits]|[alpha])*
//
//  The first reg-ex is to allow short numbers (two digits long) to be parsed if
//  they are entered as "15" etc, but only if there is no punctuation in them.
//  The second expression restricts the number of digits to three or more, but
//  then allows them to be in international form, and to have alpha-characters
//  and punctuation. We split up the two reg-exes here and combine them when
//  creating the reg-ex VALID_PHONE_NUMBER_PATTERN itself so we can prefix it
//  with ^ and append $ to each branch.
//
//  "Note VALID_PUNCTUATION starts with a -,
//   so must be the first in the range" (c) Google devs.
//  (wtf did they mean by saying that; probably nothing)
//
var $c21ab8fe347a08d1$var$MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]{" + (0, $54824ce66ed242f7$export$cd8355bcbe13154) + "}"; //
var $c21ab8fe347a08d1$export$a77dd7471651eee = "[" + (0, $54824ce66ed242f7$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $54824ce66ed242f7$export$7f01587e28f9194) + "]*" + "[" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]" + "){3,}" + "[" + (0, $54824ce66ed242f7$export$7f01587e28f9194) + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]*"; // This regular expression isn't present in Google's `libphonenumber`
// and is only used to determine whether the phone number being input
// is too short for it to even consider it a "valid" number.
// This is just a way to differentiate between a really invalid phone
// number like "abcde" and a valid phone number that a user has just
// started inputting, like "+1" or "1": both these cases would be
// considered `NOT_A_NUMBER` by Google's `libphonenumber`, but this
// library can provide a more detailed error message — whether it's
// really "not a number", or is it just a start of a valid phone number.
var $c21ab8fe347a08d1$var$VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + (0, $54824ce66ed242f7$export$207c99ccf3902df8) + "]{0,1}" + "(?:" + "[" + (0, $54824ce66ed242f7$export$7f01587e28f9194) + "]*" + "[" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]" + "){1,2}" + "$", "i");
var $c21ab8fe347a08d1$export$a2d12a04749c087d = $c21ab8fe347a08d1$export$a77dd7471651eee + // Phone number extensions
"(?:" + (0, $55e4abd51ccfcb34$export$2e2bcd8739ae039)() + ")?"; // The combined regular expression for valid phone numbers:
//
var $c21ab8fe347a08d1$var$VALID_PHONE_NUMBER_PATTERN = new RegExp("^" + $c21ab8fe347a08d1$var$MIN_LENGTH_PHONE_NUMBER_PATTERN + "$" + "|" + // Or a longer fully parsed phone number (min 3 characters)
"^" + $c21ab8fe347a08d1$export$a2d12a04749c087d + "$", "i"); // Checks to see if the string of characters could possibly be a phone number at
function $c21ab8fe347a08d1$export$2e2bcd8739ae039(number) {
    return number.length >= (0, $54824ce66ed242f7$export$cd8355bcbe13154) && $c21ab8fe347a08d1$var$VALID_PHONE_NUMBER_PATTERN.test(number);
} // This is just a way to differentiate between a really invalid phone
function $c21ab8fe347a08d1$export$4c3f76c95c05197c(number) {
    return $c21ab8fe347a08d1$var$VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}



// 1 or more valid digits, for use when parsing.
var $cf53f85670001ba1$var$EXTN_PATTERN = new RegExp("(?:" + (0, $55e4abd51ccfcb34$export$2e2bcd8739ae039)() + ")$", "i"); // Strips any extension (as in, the part of the number dialled after the call is
function $cf53f85670001ba1$export$2e2bcd8739ae039(number) {
    var start = number.search($cf53f85670001ba1$var$EXTN_PATTERN);
    if (start < 0) return {};
     // If we find a potential extension, and the number preceding this is a viable
    // number, we assume it is an extension.
    var numberWithoutExtension = number.slice(0, start);
    var matches = number.match($cf53f85670001ba1$var$EXTN_PATTERN);
    var i = 1;
    while(i < matches.length){
        if (matches[i]) return {
            number: numberWithoutExtension,
            ext: matches[i]
        };
        i++;
    }
}


function $2494675804eead8f$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $2494675804eead8f$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $2494675804eead8f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $2494675804eead8f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $2494675804eead8f$var$_arrayLikeToArray(o, minLen);
}
function $2494675804eead8f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $2494675804eead8f$export$2848f3d68c08fe69 = {
    "0": "0",
    "1": "1",
    "2": "2",
    "3": "3",
    "4": "4",
    "5": "5",
    "6": "6",
    "7": "7",
    "8": "8",
    "9": "9",
    "０": "0",
    // Fullwidth digit 0
    "１": "1",
    // Fullwidth digit 1
    "２": "2",
    // Fullwidth digit 2
    "３": "3",
    // Fullwidth digit 3
    "４": "4",
    // Fullwidth digit 4
    "５": "5",
    // Fullwidth digit 5
    "６": "6",
    // Fullwidth digit 6
    "７": "7",
    // Fullwidth digit 7
    "８": "8",
    // Fullwidth digit 8
    "９": "9",
    // Fullwidth digit 9
    "٠": "0",
    // Arabic-indic digit 0
    "١": "1",
    // Arabic-indic digit 1
    "٢": "2",
    // Arabic-indic digit 2
    "٣": "3",
    // Arabic-indic digit 3
    "٤": "4",
    // Arabic-indic digit 4
    "٥": "5",
    // Arabic-indic digit 5
    "٦": "6",
    // Arabic-indic digit 6
    "٧": "7",
    // Arabic-indic digit 7
    "٨": "8",
    // Arabic-indic digit 8
    "٩": "9",
    // Arabic-indic digit 9
    "۰": "0",
    // Eastern-Arabic digit 0
    "۱": "1",
    // Eastern-Arabic digit 1
    "۲": "2",
    // Eastern-Arabic digit 2
    "۳": "3",
    // Eastern-Arabic digit 3
    "۴": "4",
    // Eastern-Arabic digit 4
    "۵": "5",
    // Eastern-Arabic digit 5
    "۶": "6",
    // Eastern-Arabic digit 6
    "۷": "7",
    // Eastern-Arabic digit 7
    "۸": "8",
    // Eastern-Arabic digit 8
    "۹": "9" // Eastern-Arabic digit 9
};
function $2494675804eead8f$export$1d16fddea1437169(character) {
    return $2494675804eead8f$export$2848f3d68c08fe69[character];
}
function $2494675804eead8f$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $2494675804eead8f$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        var digit = $2494675804eead8f$export$1d16fddea1437169(character);
        if (digit) result += digit;
    }
    return result;
}


function $9056fe61ffe172a8$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9056fe61ffe172a8$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9056fe61ffe172a8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9056fe61ffe172a8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9056fe61ffe172a8$var$_arrayLikeToArray(o, minLen);
}
function $9056fe61ffe172a8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9056fe61ffe172a8$export$2e2bcd8739ae039(string) {
    var result = ""; // Using `.split('')` here instead of normal `for ... of`
    // because the importing application doesn't neccessarily include an ES6 polyfill.
    // The `.split('')` approach discards "exotic" UTF-8 characters
    // (the ones consisting of four bytes) but digits
    // (including non-European ones) don't fall into that range
    // so such "exotic" characters would be discarded anyway.
    for(var _iterator = $9056fe61ffe172a8$var$_createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done;){
        var character = _step.value;
        result += $9056fe61ffe172a8$export$13d8790d7fb84c28(character, result) || "";
    }
    return result;
}
function $9056fe61ffe172a8$export$13d8790d7fb84c28(character, prevParsedCharacters) {
    // Only allow a leading `+`.
    if (character === "+") {
        // If this `+` is not the first parsed character
        // then discard it.
        if (prevParsedCharacters) return;
        return "+";
    } // Allow digits.
    return (0, $2494675804eead8f$export$1d16fddea1437169)(character);
}




function $d5461c22b7002131$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d5461c22b7002131$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d5461c22b7002131$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d5461c22b7002131$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d5461c22b7002131$var$_arrayLikeToArray(o, minLen);
}
function $d5461c22b7002131$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d5461c22b7002131$export$2e2bcd8739ae039(a, b) {
    var merged = a.slice();
    for(var _iterator = $d5461c22b7002131$var$_createForOfIteratorHelperLoose(b), _step; !(_step = _iterator()).done;){
        var element = _step.value;
        if (a.indexOf(element) < 0) merged.push(element);
    }
    return merged.sort(function(a, b) {
        return a - b;
    }); // ES6 version, requires Set polyfill.
// let merged = new Set(a)
// for (const element of b) {
// 	merged.add(i)
// }
// return Array.from(merged).sort((a, b) => a - b)
}


function $1f997a3a4cbddab9$export$2e2bcd8739ae039(nationalNumber, metadata) {
    return $1f997a3a4cbddab9$export$69333f603c7d5931(nationalNumber, undefined, metadata);
} // Checks whether a number is possible for the country based on its length.
function $1f997a3a4cbddab9$export$69333f603c7d5931(nationalNumber, type, metadata) {
    var type_info = metadata.type(type); // There should always be "<possiblePengths/>" set for every type element.
    // This is declared in the XML schema.
    // For size efficiency, where a sub-description (e.g. fixed-line)
    // has the same "<possiblePengths/>" as the "general description", this is missing,
    // so we fall back to the "general description". Where no numbers of the type
    // exist at all, there is one possible length (-1) which is guaranteed
    // not to match the length of any real phone number.
    var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths(); // let local_lengths    = type_info && type.possibleLengthsLocal() || metadata.possibleLengthsLocal()
    // Metadata before version `1.0.18` didn't contain `possible_lengths`.
    if (!possible_lengths) return "IS_POSSIBLE";
    if (type === "FIXED_LINE_OR_MOBILE") {
        // No such country in metadata.
        /* istanbul ignore next */ if (!metadata.type("FIXED_LINE")) // The rare case has been encountered where no fixedLine data is available
        // (true for some non-geographic entities), so we just check mobile.
        return $1f997a3a4cbddab9$export$69333f603c7d5931(nationalNumber, "MOBILE", metadata);
        var mobile_type = metadata.type("MOBILE");
        if (mobile_type) // Merge the mobile data in if there was any. "Concat" creates a new
        // array, it doesn't edit possible_lengths in place, so we don't need a copy.
        // Note that when adding the possible lengths from mobile, we have
        // to again check they aren't empty since if they are this indicates
        // they are the same as the general desc and should be obtained from there.
        possible_lengths = (0, $d5461c22b7002131$export$2e2bcd8739ae039)(possible_lengths, mobile_type.possibleLengths()); // The current list is sorted; we need to merge in the new list and
    } else if (type && !type_info) return "INVALID_LENGTH";
    var actual_length = nationalNumber.length; // In `libphonenumber-js` all "local-only" formats are dropped for simplicity.
    // // This is safe because there is never an overlap beween the possible lengths
    // // and the local-only lengths; this is checked at build time.
    // if (local_lengths && local_lengths.indexOf(nationalNumber.length) >= 0)
    // {
    // 	return 'IS_POSSIBLE_LOCAL_ONLY'
    // }
    var minimum_length = possible_lengths[0];
    if (minimum_length === actual_length) return "IS_POSSIBLE";
    if (minimum_length > actual_length) return "TOO_SHORT";
    if (possible_lengths[possible_lengths.length - 1] < actual_length) return "TOO_LONG";
     // We skip the first element since we've already checked it.
    return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}


function $6ed5ea9724d699c8$export$2e2bcd8739ae039(input, options, metadata) {
    /* istanbul ignore if */ if (options === undefined) options = {};
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    if (options.v2) {
        if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
        metadata.selectNumberingPlan(input.countryCallingCode);
    } else {
        if (!input.phone) return false;
        if (input.country) {
            if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
            metadata.country(input.country);
        } else {
            if (!input.countryCallingCode) throw new Error("Invalid phone number object passed");
            metadata.selectNumberingPlan(input.countryCallingCode);
        }
    } // Old metadata (< 1.0.18) had no "possible length" data.
    if (metadata.possibleLengths()) return $6ed5ea9724d699c8$export$4f8890cedf1e0497(input.phone || input.nationalNumber, metadata);
    else {
        // There was a bug between `1.7.35` and `1.7.37` where "possible_lengths"
        // were missing for "non-geographical" numbering plans.
        // Just assume the number is possible in such cases:
        // it's unlikely that anyone generated their custom metadata
        // in that short period of time (one day).
        // This code can be removed in some future major version update.
        if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) // "Non-geographic entities" did't have `possibleLengths`
        // due to a bug in metadata generation process.
        return true;
        else throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
}
function $6ed5ea9724d699c8$export$4f8890cedf1e0497(nationalNumber, metadata) {
    //, isInternational) {
    switch((0, $1f997a3a4cbddab9$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "IS_POSSIBLE":
            return true;
        // This library ignores "local-only" phone numbers (for simplicity).
        // See the readme for more info on what are "local-only" phone numbers.
        // case 'IS_POSSIBLE_LOCAL_ONLY':
        // 	return !isInternational
        default:
            return false;
    }
}





/**
 * Checks whether the entire input sequence can be matched
 * against the regular expression.
 * @return {boolean}
 */ function $bc31c17c579d1cd0$export$2e2bcd8739ae039(text, regular_expression) {
    // If assigning the `''` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    text = text || "";
    return new RegExp("^(?:" + regular_expression + ")$").test(text);
}




function $7f841782b054fa72$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $7f841782b054fa72$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $7f841782b054fa72$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $7f841782b054fa72$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $7f841782b054fa72$var$_arrayLikeToArray(o, minLen);
}
function $7f841782b054fa72$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $7f841782b054fa72$var$NON_FIXED_LINE_PHONE_TYPES = [
    "MOBILE",
    "PREMIUM_RATE",
    "TOLL_FREE",
    "SHARED_COST",
    "VOIP",
    "PERSONAL_NUMBER",
    "PAGER",
    "UAN",
    "VOICEMAIL"
]; // Finds out national phone number type (fixed line, mobile, etc)
function $7f841782b054fa72$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {}; // When `parse()` returns an empty object — `{}` —
    // that means that the phone number is malformed,
    // so it can't possibly be valid.
    if (!input.country && !input.countryCallingCode) return;
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    metadata.selectNumberingPlan(input.country, input.countryCallingCode);
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // The following is copy-pasted from the original function:
    // https://github.com/googlei18n/libphonenumber/blob/3ea547d4fbaa2d0b67588904dfa5d3f2557c27ff/javascript/i18n/phonenumbers/phonenumberutil.js#L2835
    // Is this national number even valid for this country
    if (!(0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern())) return;
     // Is it fixed line number
    if ($7f841782b054fa72$export$7bd37b39ade0214d(nationalNumber, "FIXED_LINE", metadata)) {
        // Because duplicate regular expressions are removed
        // to reduce metadata size, if "mobile" pattern is ""
        // then it means it was removed due to being a duplicate of the fixed-line pattern.
        //
        if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") return "FIXED_LINE_OR_MOBILE";
         // `MOBILE` type pattern isn't included if it matched `FIXED_LINE` one.
        // For example, for "US" country.
        // Old metadata (< `1.0.18`) had a specific "types" data structure
        // that happened to be `undefined` for `MOBILE` in that case.
        // Newer metadata (>= `1.0.18`) has another data structure that is
        // not `undefined` for `MOBILE` in that case (it's just an empty array).
        // So this `if` is just for backwards compatibility with old metadata.
        if (!metadata.type("MOBILE")) return "FIXED_LINE_OR_MOBILE";
         // Check if the number happens to qualify as both fixed line and mobile.
        // (no such country in the minimal metadata set)
        /* istanbul ignore if */ if ($7f841782b054fa72$export$7bd37b39ade0214d(nationalNumber, "MOBILE", metadata)) return "FIXED_LINE_OR_MOBILE";
        return "FIXED_LINE";
    }
    for(var _iterator = $7f841782b054fa72$var$_createForOfIteratorHelperLoose($7f841782b054fa72$var$NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done;){
        var type = _step.value;
        if ($7f841782b054fa72$export$7bd37b39ade0214d(nationalNumber, type, metadata)) return type;
    }
}
function $7f841782b054fa72$export$7bd37b39ade0214d(nationalNumber, type, metadata) {
    type = metadata.type(type);
    if (!type || !type.pattern()) return false;
     // Check if any possible number lengths are present;
    // if so, we use them to avoid checking
    // the validation pattern if they don't match.
    // If they are absent, this means they match
    // the general description, which we have
    // already checked before a specific number type.
    if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) return false;
    return (0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumber, type.pattern());
}


function $bd291047da0560b3$export$2e2bcd8739ae039(input, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    /**
   * Checks if a phone number is "possible" (basically just checks its length).
   *
   * @param  {object|PhoneNumber} input — If `options.v2: true` flag is passed, the `input` should be a `PhoneNumber` instance. Otherwise, it should be an object of shape `{ phone: '...', country: '...' }`.
   * @param  {object} [options]
   * @param  {object} metadata
   * @return {string}
   */ metadata.selectNumberingPlan(input.country, input.countryCallingCode); // By default, countries only have type regexps when it's required for
    // distinguishing different countries having the same `countryCallingCode`.
    if (metadata.hasTypes()) return (0, $7f841782b054fa72$export$2e2bcd8739ae039)(input, options, metadata.metadata) !== undefined;
     // If there are no type regexps for this country in metadata then use
    // `nationalNumberPattern` as a "better than nothing" replacement.
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
    return (0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern());
}




function $07d72cd05f732f3a$export$2e2bcd8739ae039(callingCode, nationalNumber, metadata) {
    var _metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return [];
    return possibleCountries.filter(function(country) {
        return $07d72cd05f732f3a$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
    });
}
function $07d72cd05f732f3a$var$couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
    var _metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    _metadata.selectNumberingPlan(country);
    if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) return true;
    return false;
}




function $87cc27a42b707d3a$export$2e2bcd8739ae039(formattedNumber) {
    return formattedNumber.replace(new RegExp("[".concat((0, $54824ce66ed242f7$export$7f01587e28f9194), "]+"), "g"), " ").trim();
}


var $ed5669521f3b6b75$export$4f32ad1c51a7a6be = /(\$\d)/;
function $ed5669521f3b6b75$export$2e2bcd8739ae039(number, format, _ref) {
    var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
    var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace($ed5669521f3b6b75$export$4f32ad1c51a7a6be, format.nationalPrefixFormattingRule()) : format.format());
    if (useInternationalFormat) return (0, $87cc27a42b707d3a$export$2e2bcd8739ae039)(formattedNumber);
    return formattedNumber;
}




/**
 * Pattern that makes it easy to distinguish whether a region has a single
 * international dialing prefix or not. If a region has a single international
 * prefix (e.g. 011 in USA), it will be represented as a string that contains
 * a sequence of ASCII digits, and possibly a tilde, which signals waiting for
 * the tone. If there are multiple available international prefixes in a
 * region, they will be represented as a regex string that always contains one
 * or more characters that are not ASCII digits or a tilde.
 */ var $001a25cec7ad5a8c$var$SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/; // For regions that have multiple IDD prefixes
function $001a25cec7ad5a8c$export$2e2bcd8739ae039(country, callingCode, metadata) {
    var countryMetadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    if (countryMetadata.defaultIDDPrefix()) return countryMetadata.defaultIDDPrefix();
    if ($001a25cec7ad5a8c$var$SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) return countryMetadata.IDDPrefix();
}



function $b61175ac81b2cbfc$var$_slicedToArray(arr, i) {
    return $b61175ac81b2cbfc$var$_arrayWithHoles(arr) || $b61175ac81b2cbfc$var$_iterableToArrayLimit(arr, i) || $b61175ac81b2cbfc$var$_unsupportedIterableToArray(arr, i) || $b61175ac81b2cbfc$var$_nonIterableRest();
}
function $b61175ac81b2cbfc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b61175ac81b2cbfc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $b61175ac81b2cbfc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $b61175ac81b2cbfc$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $b61175ac81b2cbfc$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $b61175ac81b2cbfc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $b61175ac81b2cbfc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $b61175ac81b2cbfc$var$_arrayLikeToArray(o, minLen);
}
function $b61175ac81b2cbfc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $b61175ac81b2cbfc$export$26fe644d7d92bb13(text) {
    var number;
    var ext; // Replace "tel:" with "tel=" for parsing convenience.
    text = text.replace(/^tel:/, "tel=");
    for(var _iterator = $b61175ac81b2cbfc$var$_createForOfIteratorHelperLoose(text.split(";")), _step; !(_step = _iterator()).done;){
        var part = _step.value;
        var _part$split = part.split("="), _part$split2 = $b61175ac81b2cbfc$var$_slicedToArray(_part$split, 2), name = _part$split2[0], value = _part$split2[1];
        switch(name){
            case "tel":
                number = value;
                break;
            case "ext":
                ext = value;
                break;
            case "phone-context":
                // Only "country contexts" are supported.
                // "Domain contexts" are ignored.
                if (value[0] === "+") number = value + number;
                break;
        }
    } // If the phone number is not viable, then abort.
    if (!(0, $c21ab8fe347a08d1$export$2e2bcd8739ae039)(number)) return {};
    var result = {
        number: number
    };
    if (ext) result.ext = ext;
    return result;
}
function $b61175ac81b2cbfc$export$d4f2d2bc1159d115(_ref) {
    var number = _ref.number, ext = _ref.ext;
    if (!number) return "";
    if (number[0] !== "+") throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
    return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}


function $9da02df1d1ec94f4$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $9da02df1d1ec94f4$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9da02df1d1ec94f4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9da02df1d1ec94f4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9da02df1d1ec94f4$var$_arrayLikeToArray(o, minLen);
}
function $9da02df1d1ec94f4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9da02df1d1ec94f4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9da02df1d1ec94f4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9da02df1d1ec94f4$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9da02df1d1ec94f4$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9da02df1d1ec94f4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9da02df1d1ec94f4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $9da02df1d1ec94f4$var$DEFAULT_OPTIONS = {
    formatExtension: function formatExtension(formattedNumber, extension, metadata) {
        return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
    }
};
function $9da02df1d1ec94f4$export$2e2bcd8739ae039(input, format, options, metadata) {
    // Apply default options.
    if (options) options = $9da02df1d1ec94f4$var$_objectSpread($9da02df1d1ec94f4$var$_objectSpread({}, $9da02df1d1ec94f4$var$DEFAULT_OPTIONS), options);
    else options = $9da02df1d1ec94f4$var$DEFAULT_OPTIONS;
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    if (input.country && input.country !== "001") {
        // Validate `input.country`.
        if (!metadata.hasCountry(input.country)) throw new Error("Unknown country: ".concat(input.country));
        metadata.country(input.country);
    } else if (input.countryCallingCode) metadata.selectNumberingPlan(input.countryCallingCode);
    else return input.phone || "";
    var countryCallingCode = metadata.countryCallingCode();
    var nationalNumber = options.v2 ? input.nationalNumber : input.phone; // This variable should have been declared inside `case`s
    // but Babel has a bug and it says "duplicate variable declaration".
    var number;
    switch(format){
        case "NATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "";
            number = $9da02df1d1ec94f4$var$formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
            return $9da02df1d1ec94f4$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "INTERNATIONAL":
            // Legacy argument support.
            // (`{ country: ..., phone: '' }`)
            if (!nationalNumber) return "+".concat(countryCallingCode);
            number = $9da02df1d1ec94f4$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
            number = "+".concat(countryCallingCode, " ").concat(number);
            return $9da02df1d1ec94f4$var$addExtension(number, input.ext, metadata, options.formatExtension);
        case "E.164":
            // `E.164` doesn't define "phone number extensions".
            return "+".concat(countryCallingCode).concat(nationalNumber);
        case "RFC3966":
            return (0, $b61175ac81b2cbfc$export$d4f2d2bc1159d115)({
                number: "+".concat(countryCallingCode).concat(nationalNumber),
                ext: input.ext
            });
        // For reference, here's Google's IDD formatter:
        // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
        // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
        // Who would even need to format phone numbers in IDD format anyway?
        case "IDD":
            if (!options.fromCountry) return; // throw new Error('`fromCountry` option not passed for IDD-prefixed formatting.')
            var formattedNumber = $9da02df1d1ec94f4$var$formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
            return $9da02df1d1ec94f4$var$addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
        default:
            throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
    }
}
function $9da02df1d1ec94f4$var$formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
    var format = $9da02df1d1ec94f4$export$a4ff939d1245121e(metadata.formats(), number);
    if (!format) return number;
    return (0, $ed5669521f3b6b75$export$2e2bcd8739ae039)(number, format, {
        useInternationalFormat: formatAs === "INTERNATIONAL",
        withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
        carrierCode: carrierCode,
        metadata: metadata
    });
}
function $9da02df1d1ec94f4$export$a4ff939d1245121e(availableFormats, nationalNnumber) {
    for(var _iterator = $9da02df1d1ec94f4$var$_createForOfIteratorHelperLoose(availableFormats), _step; !(_step = _iterator()).done;){
        var format = _step.value;
        // Validate leading digits.
        // The test case for "else path" could be found by searching for
        // "format.leadingDigitsPatterns().length === 0".
        if (format.leadingDigitsPatterns().length > 0) {
            // The last leading_digits_pattern is used here, as it is the most detailed
            var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1]; // If leading digits don't match then move on to the next phone number format
            if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) continue;
        } // Check that the national number matches the phone number format regular expression
        if ((0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNnumber, format.pattern())) return format;
    }
}
function $9da02df1d1ec94f4$var$addExtension(formattedNumber, ext, metadata, formatExtension) {
    return ext ? formatExtension(formattedNumber, ext, metadata) : formattedNumber;
}
function $9da02df1d1ec94f4$var$formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
    var fromCountryCallingCode = (0, $ea90f4b3245f449e$export$32876ca2f1919cf0)(fromCountry, metadata.metadata); // When calling within the same country calling code.
    if (fromCountryCallingCode === countryCallingCode) {
        var formattedNumber = $9da02df1d1ec94f4$var$formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata); // For NANPA regions, return the national format for these regions
        // but prefix it with the country calling code.
        if (countryCallingCode === "1") return countryCallingCode + " " + formattedNumber;
         // If regions share a country calling code, the country calling code need
        // not be dialled. This also applies when dialling within a region, so this
        // if clause covers both these cases. Technically this is the case for
        // dialling from La Reunion to other overseas departments of France (French
        // Guiana, Martinique, Guadeloupe), but not vice versa - so we don't cover
        // this edge case for now and for those cases return the version including
        // country calling code. Details here:
        // http://www.petitfute.com/voyage/225-info-pratiques-reunion
        //
        return formattedNumber;
    }
    var iddPrefix = (0, $001a25cec7ad5a8c$export$2e2bcd8739ae039)(fromCountry, undefined, metadata.metadata);
    if (iddPrefix) return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat($9da02df1d1ec94f4$var$formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
}


function $5b0b88132bf7c67c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5b0b88132bf7c67c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5b0b88132bf7c67c$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5b0b88132bf7c67c$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5b0b88132bf7c67c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5b0b88132bf7c67c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5b0b88132bf7c67c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5b0b88132bf7c67c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5b0b88132bf7c67c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5b0b88132bf7c67c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5b0b88132bf7c67c$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
var $5b0b88132bf7c67c$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var $5b0b88132bf7c67c$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    /**
   * @param  {string} countryOrCountryCallingCode
   * @param  {string} nationalNumber
   * @param  {object} metadata — Metadata JSON
   * @return {PhoneNumber}
   */ function PhoneNumber(countryOrCountryCallingCode, nationalNumber, metadata) {
        $5b0b88132bf7c67c$var$_classCallCheck(this, PhoneNumber);
        if (!countryOrCountryCallingCode) throw new TypeError("`country` or `countryCallingCode` not passed");
        if (!nationalNumber) throw new TypeError("`nationalNumber` not passed");
        if (!metadata) throw new TypeError("`metadata` not passed");
        var _getCountryAndCountry = $5b0b88132bf7c67c$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
        this.country = country;
        this.countryCallingCode = countryCallingCode;
        this.nationalNumber = nationalNumber;
        this.number = "+" + this.countryCallingCode + this.nationalNumber; // Exclude `metadata` property output from `PhoneNumber.toString()`
        // so that it doesn't clutter the console output of Node.js.
        // Previously, when Node.js did `console.log(new PhoneNumber(...))`,
        // it would output the whole internal structure of the `metadata` object.
        this.getMetadata = function() {
            return metadata;
        };
    }
    $5b0b88132bf7c67c$var$_createClass(PhoneNumber, [
        {
            key: "setExt",
            value: function setExt(ext) {
                this.ext = ext;
            }
        },
        {
            key: "getPossibleCountries",
            value: function getPossibleCountries() {
                if (this.country) return [
                    this.country
                ];
                return (0, $07d72cd05f732f3a$export$2e2bcd8739ae039)(this.countryCallingCode, this.nationalNumber, this.getMetadata());
            }
        },
        {
            key: "isPossible",
            value: function isPossible() {
                return (0, $6ed5ea9724d699c8$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isValid",
            value: function isValid() {
                return (0, $bd291047da0560b3$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "isNonGeographic",
            value: function isNonGeographic() {
                var metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(this.getMetadata());
                return metadata.isNonGeographicCallingCode(this.countryCallingCode);
            }
        },
        {
            key: "isEqual",
            value: function isEqual(phoneNumber) {
                return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
            } // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
        },
        {
            key: "getType",
            value: function getType() {
                return (0, $7f841782b054fa72$export$2e2bcd8739ae039)(this, {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "format",
            value: function format(_format, options) {
                return (0, $9da02df1d1ec94f4$export$2e2bcd8739ae039)(this, _format, options ? $5b0b88132bf7c67c$var$_objectSpread($5b0b88132bf7c67c$var$_objectSpread({}, options), {}, {
                    v2: true
                }) : {
                    v2: true
                }, this.getMetadata());
            }
        },
        {
            key: "formatNational",
            value: function formatNational(options) {
                return this.format("NATIONAL", options);
            }
        },
        {
            key: "formatInternational",
            value: function formatInternational(options) {
                return this.format("INTERNATIONAL", options);
            }
        },
        {
            key: "getURI",
            value: function getURI(options) {
                return this.format("RFC3966", options);
            }
        }
    ]);
    return PhoneNumber;
}();
var $5b0b88132bf7c67c$var$isCountryCode = function isCountryCode(value) {
    return /^[A-Z]{2}$/.test(value);
};
function $5b0b88132bf7c67c$var$getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
    var country;
    var countryCallingCode;
    var metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadataJson); // If country code is passed then derive `countryCallingCode` from it.
    // Also store the country code as `.country`.
    if ($5b0b88132bf7c67c$var$isCountryCode(countryOrCountryCallingCode)) {
        country = countryOrCountryCallingCode;
        metadata.selectNumberingPlan(country);
        countryCallingCode = metadata.countryCallingCode();
    } else {
        countryCallingCode = countryOrCountryCallingCode;
        /* istanbul ignore if */ if ($5b0b88132bf7c67c$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
            if (metadata.isNonGeographicCallingCode(countryCallingCode)) country = "001";
        }
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode
    };
}





var $e7d72dc220b53279$var$CAPTURING_DIGIT_PATTERN = new RegExp("([" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "])");
function $e7d72dc220b53279$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!country) return;
     // Check if the number is IDD-prefixed.
    var countryMetadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    countryMetadata.selectNumberingPlan(country, callingCode);
    var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
    if (number.search(IDDPrefixPattern) !== 0) return;
     // Strip IDD prefix.
    number = number.slice(number.match(IDDPrefixPattern)[0].length); // If there're any digits after an IDD prefix,
    // then those digits are a country calling code.
    // Since no country code starts with a `0`,
    // the code below validates that the next digit (if present) is not `0`.
    var matchedGroups = number.match($e7d72dc220b53279$var$CAPTURING_DIGIT_PATTERN);
    if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
        if (matchedGroups[1] === "0") return;
    }
    return number;
}




/**
 * Strips any national prefix (such as 0, 1) present in a
 * (possibly incomplete) number provided.
 * "Carrier codes" are only used  in Colombia and Brazil,
 * and only when dialing within those countries from a mobile phone to a fixed line number.
 * Sometimes it won't actually strip national prefix
 * and will instead prepend some digits to the `number`:
 * for example, when number `2345678` is passed with `VI` country selected,
 * it will return `{ number: "3402345678" }`, because `340` area code is prepended.
 * @param {string} number — National number digits.
 * @param {object} metadata — Metadata with country selected.
 * @return {object} `{ nationalNumber: string, nationalPrefix: string? carrierCode: string? }`. Even if a national prefix was extracted, it's not necessarily present in the returned object, so don't rely on its presence in the returned object in order to find out whether a national prefix has been extracted or not.
 */ function $a0892412b31d0236$export$2e2bcd8739ae039(number, metadata) {
    if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
        // See METADATA.md for the description of
        // `national_prefix_for_parsing` and `national_prefix_transform_rule`.
        // Attempt to parse the first digits as a national prefix.
        var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
        var prefixMatch = prefixPattern.exec(number);
        if (prefixMatch) {
            var nationalNumber;
            var carrierCode; // https://gitlab.com/catamphetamine/libphonenumber-js/-/blob/master/METADATA.md#national_prefix_for_parsing--national_prefix_transform_rule
            // If a `national_prefix_for_parsing` has any "capturing groups"
            // then it means that the national (significant) number is equal to
            // those "capturing groups" transformed via `national_prefix_transform_rule`,
            // and nothing could be said about the actual national prefix:
            // what is it and was it even there.
            // If a `national_prefix_for_parsing` doesn't have any "capturing groups",
            // then everything it matches is a national prefix.
            // To determine whether `national_prefix_for_parsing` matched any
            // "capturing groups", the value of the result of calling `.exec()`
            // is looked at, and if it has non-undefined values where there're
            // "capturing groups" in the regular expression, then it means
            // that "capturing groups" have been matched.
            // It's not possible to tell whether there'll be any "capturing gropus"
            // before the matching process, because a `national_prefix_for_parsing`
            // could exhibit both behaviors.
            var capturedGroupsCount = prefixMatch.length - 1;
            var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
            if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
                nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule()); // If there's more than one captured group,
                // then carrier code is the second one.
                if (capturedGroupsCount > 1) carrierCode = prefixMatch[1];
            } else {
                // `prefixBeforeNationalNumber` is the whole substring matched by
                // the `national_prefix_for_parsing` regular expression.
                // There seem to be no guarantees that it's just a national prefix.
                // For example, if there's a carrier code, it's gonna be a
                // part of `prefixBeforeNationalNumber` too.
                var prefixBeforeNationalNumber = prefixMatch[0];
                nationalNumber = number.slice(prefixBeforeNationalNumber.length); // If there's at least one captured group,
                // then carrier code is the first one.
                if (hasCapturedGroups) carrierCode = prefixMatch[1];
            } // Tries to guess whether a national prefix was present in the input.
            // This is not something copy-pasted from Google's library:
            // they don't seem to have an equivalent for that.
            // So this isn't an "officially approved" way of doing something like that.
            // But since there seems no other existing method, this library uses it.
            var nationalPrefix;
            if (hasCapturedGroups) {
                var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
                var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup); // Example: an Argentinian (AR) phone number `0111523456789`.
                // `prefixMatch[0]` is `01115`, and `$1` is `11`,
                // and the rest of the phone number is `23456789`.
                // The national number is transformed via `9$1` to `91123456789`.
                // National prefix `0` is detected being present at the start.
                // if (possibleNationalPrefix.indexOf(metadata.numberingPlan.nationalPrefix()) === 0) {
                if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) nationalPrefix = metadata.numberingPlan.nationalPrefix();
            } else nationalPrefix = prefixMatch[0];
            return {
                nationalNumber: nationalNumber,
                nationalPrefix: nationalPrefix,
                carrierCode: carrierCode
            };
        }
    }
    return {
        nationalNumber: number
    };
}




function $e4976e2e729c5a79$export$2e2bcd8739ae039(number, metadata) {
    // Parsing national prefixes and carrier codes
    // is only required for local phone numbers
    // but some people don't understand that
    // and sometimes write international phone numbers
    // with national prefixes (or maybe even carrier codes).
    // http://ucken.blogspot.ru/2016/03/trunk-prefixes-in-skype4b.html
    // Google's original library forgives such mistakes
    // and so does this library, because it has been requested:
    // https://github.com/catamphetamine/libphonenumber-js/issues/127
    var _extractNationalNumbe = (0, $a0892412b31d0236$export$2e2bcd8739ae039)(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
    if (nationalNumber !== number) {
        if (!$e4976e2e729c5a79$var$shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) // Don't strip the national prefix.
        return {
            nationalNumber: number
        };
         // Check the national (significant) number length after extracting national prefix and carrier code.
        // Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature.
        if (metadata.possibleLengths()) {
            // The number remaining after stripping the national prefix and carrier code
            // should be long enough to have a possible length for the country.
            // Otherwise, don't strip the national prefix and carrier code,
            // since the original number could be a valid number.
            // This check has been copy-pasted "as is" from Google's original library:
            // https://github.com/google/libphonenumber/blob/876268eb1ad6cdc1b7b5bef17fc5e43052702d57/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L3236-L3250
            // It doesn't check for the "possibility" of the original `number`.
            // I guess it's fine not checking that one. It works as is anyway.
            if (!$e4976e2e729c5a79$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata)) // Don't strip the national prefix.
            return {
                nationalNumber: number
            };
        }
    }
    return {
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
} // In some countries, the same digit could be a national prefix
// or a leading digit of a valid phone number.
// For example, in Russia, national prefix is `8`,
// and also `800 555 35 35` is a valid number
// in which `8` is not a national prefix, but the first digit
// of a national (significant) number.
// Same's with Belarus:
// `82004910060` is a valid national (significant) number,
// but `2004910060` is not.
// To support such cases (to prevent the code from always stripping
// national prefix), a condition is imposed: a national prefix
// is not extracted when the original number is "viable" and the
// resultant number is not, a "viable" national number being the one
// that matches `national_number_pattern`.
function $e4976e2e729c5a79$var$shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
    // The equivalent in Google's code is:
    // https://github.com/google/libphonenumber/blob/e326fa1fc4283bb05eb35cb3c15c18f98a31af33/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L2969-L3004
    if ((0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumberBefore, metadata.nationalNumberPattern()) && !(0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumberAfter, metadata.nationalNumberPattern())) return false;
     // This "is possible" national number (length) check has been commented out
    // because it's superceded by the (effectively) same check done in the
    // `extractNationalNumber()` function after it calls `shouldHaveExtractedNationalPrefix()`.
    // In other words, why run the same check twice if it could only be run once.
    // // Check the national (significant) number length after extracting national prefix and carrier code.
    // // Fixes a minor "weird behavior" bug: https://gitlab.com/catamphetamine/libphonenumber-js/-/issues/57
    // // (Legacy generated metadata (before `1.0.18`) didn't support the "possible lengths" feature).
    // if (metadata.possibleLengths()) {
    // 	if (isPossibleIncompleteNationalNumber(nationalNumberBefore, metadata) &&
    // 		!isPossibleIncompleteNationalNumber(nationalNumberAfter, metadata)) {
    // 		return false
    // 	}
    // }
    return true;
}
function $e4976e2e729c5a79$var$isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
    switch((0, $1f997a3a4cbddab9$export$2e2bcd8739ae039)(nationalNumber, metadata)){
        case "TOO_SHORT":
        case "INVALID_LENGTH":
            // This library ignores "local-only" phone numbers (for simplicity).
            // See the readme for more info on what are "local-only" phone numbers.
            // case 'IS_POSSIBLE_LOCAL_ONLY':
            return false;
        default:
            return true;
    }
}




function $e5225820e3281f65$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    var countryCallingCode = country ? (0, $ea90f4b3245f449e$export$32876ca2f1919cf0)(country, metadata) : callingCode;
    if (number.indexOf(countryCallingCode) === 0) {
        metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
        metadata.selectNumberingPlan(country, callingCode);
        var possibleShorterNumber = number.slice(countryCallingCode.length);
        var _extractNationalNumbe = (0, $e4976e2e729c5a79$export$2e2bcd8739ae039)(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
        var _extractNationalNumbe2 = (0, $e4976e2e729c5a79$export$2e2bcd8739ae039)(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber; // If the number was not valid before but is valid now,
        // or if it was too long before, we consider the number
        // with the country calling code stripped to be a better result
        // and keep that instead.
        // For example, in Germany (+49), `49` is a valid area code,
        // so if a number starts with `49`, it could be both a valid
        // national German number or an international number without
        // a leading `+`.
        if (!(0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) && (0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || (0, $1f997a3a4cbddab9$export$2e2bcd8739ae039)(nationalNumber, metadata) === "TOO_LONG") return {
            countryCallingCode: countryCallingCode,
            number: possibleShorterNumber
        };
    }
    return {
        number: number
    };
}




function $5d10e13e24aef5eb$export$2e2bcd8739ae039(number, country, callingCode, metadata) {
    if (!number) return {};
    var isNumberWithIddPrefix; // If this is not an international phone number,
    // then either extract an "IDD" prefix, or extract a
    // country calling code from a number by autocorrecting it
    // by prepending a leading `+` in cases when it starts
    // with the country calling code.
    // https://wikitravel.org/en/International_dialling_prefix
    // https://github.com/catamphetamine/libphonenumber-js/issues/376
    if (number[0] !== "+") {
        // Convert an "out-of-country" dialing phone number
        // to a proper international phone number.
        var numberWithoutIDD = (0, $e7d72dc220b53279$export$2e2bcd8739ae039)(number, country, callingCode, metadata); // If an IDD prefix was stripped then
        // convert the number to international one
        // for subsequent parsing.
        if (numberWithoutIDD && numberWithoutIDD !== number) {
            isNumberWithIddPrefix = true;
            number = "+" + numberWithoutIDD;
        } else {
            // Check to see if the number starts with the country calling code
            // for the default country. If so, we remove the country calling code,
            // and do some checks on the validity of the number before and after.
            // https://github.com/catamphetamine/libphonenumber-js/issues/376
            if (country || callingCode) {
                var _extractCountryCallin = (0, $e5225820e3281f65$export$2e2bcd8739ae039)(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
                if (countryCallingCode) return {
                    countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
                    countryCallingCode: countryCallingCode,
                    number: shorterNumber
                };
            }
            return {
                // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
                // countryCallingCodeSource: 'UNSPECIFIED',
                number: number
            };
        }
    } // Fast abortion: country codes do not begin with a '0'
    if (number[1] === "0") return {};
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata); // The thing with country phone codes
    // is that they are orthogonal to each other
    // i.e. there's no such country phone code A
    // for which country phone code B exists
    // where B starts with A.
    // Therefore, while scanning digits,
    // if a valid country code is found,
    // that means that it is the country code.
    //
    var i = 2;
    while(i - 1 <= (0, $54824ce66ed242f7$export$514717690676fb4a) && i <= number.length){
        var _countryCallingCode = number.slice(1, i);
        if (metadata.hasCallingCode(_countryCallingCode)) {
            metadata.selectNumberingPlan(_countryCallingCode);
            return {
                countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
                countryCallingCode: _countryCallingCode,
                number: number.slice(i)
            };
        }
        i++;
    }
    return {};
} // The possible values for the returned `countryCallingCodeSource` are:
 //
 // Copy-pasted from:
 // https://github.com/google/libphonenumber/blob/master/resources/phonenumber.proto
 //
 // // The source from which the country_code is derived. This is not set in the
 // // general parsing method, but in the method that parses and keeps raw_input.
 // // New fields could be added upon request.
 // enum CountryCodeSource {
 //  // Default value returned if this is not set, because the phone number was
 //  // created using parse, not parseAndKeepRawInput. hasCountryCodeSource will
 //  // return false if this is the case.
 //  UNSPECIFIED = 0;
 //
 //  // The country_code is derived based on a phone number with a leading "+",
 //  // e.g. the French number "+33 1 42 68 53 00".
 //  FROM_NUMBER_WITH_PLUS_SIGN = 1;
 //
 //  // The country_code is derived based on a phone number with a leading IDD,
 //  // e.g. the French number "011 33 1 42 68 53 00", as it is dialled from US.
 //  FROM_NUMBER_WITH_IDD = 5;
 //
 //  // The country_code is derived based on a phone number without a leading
 //  // "+", e.g. the French number "33 1 42 68 53 00" when defaultCountry is
 //  // supplied as France.
 //  FROM_NUMBER_WITHOUT_PLUS_SIGN = 10;
 //
 //  // The country_code is derived NOT based on the phone number itself, but
 //  // from the defaultCountry parameter provided in the parsing function by the
 //  // clients. This happens mostly for numbers written in the national format
 //  // (without country code). For example, this would be set when parsing the
 //  // French number "01 42 68 53 00", when defaultCountry is supplied as
 //  // France.
 //  FROM_DEFAULT_COUNTRY = 20;
 // }






function $d3779c89beaf2365$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $d3779c89beaf2365$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d3779c89beaf2365$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d3779c89beaf2365$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d3779c89beaf2365$var$_arrayLikeToArray(o, minLen);
}
function $d3779c89beaf2365$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d3779c89beaf2365$export$2e2bcd8739ae039(nationalPhoneNumber, _ref) {
    var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    // Re-create `metadata` because it will be selecting a `country`.
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata);
    var matchingCountries = [];
    for(var _iterator = $d3779c89beaf2365$var$_createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done;){
        var country = _step.value;
        metadata.country(country); // "Leading digits" patterns are only defined for about 20% of all countries.
        // By definition, matching "leading digits" is a sufficient but not a necessary
        // condition for a phone number to belong to a country.
        // The point of "leading digits" check is that it's the fastest one to get a match.
        // https://gitlab.com/catamphetamine/libphonenumber-js/blob/master/METADATA.md#leading_digits
        // I'd suppose that "leading digits" patterns are mutually exclusive for different countries
        // because of the intended use of that feature.
        if (metadata.leadingDigits()) {
            if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) return country;
        } else if ((0, $7f841782b054fa72$export$2e2bcd8739ae039)({
            phone: nationalPhoneNumber,
            country: country
        }, undefined, metadata.metadata)) {
            // If the `defaultCountry` is among the `matchingCountries` then return it.
            if (defaultCountry) {
                if (country === defaultCountry) return country;
                matchingCountries.push(country);
            } else return country;
        }
    } // Return the first ("main") one of the `matchingCountries`.
    if (matchingCountries.length > 0) return matchingCountries[0];
}


var $b6dfde26c225eac0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
function $b6dfde26c225eac0$export$2e2bcd8739ae039(callingCode, _ref) {
    var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
    /* istanbul ignore if */ if ($b6dfde26c225eac0$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
        if (metadata.isNonGeographicCallingCode(callingCode)) return "001";
    }
    var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
    if (!possibleCountries) return;
     // If there's just one country corresponding to the country code,
    // then just return it, without further phone number digits validation.
    if (possibleCountries.length === 1) return possibleCountries[0];
    return (0, $d3779c89beaf2365$export$2e2bcd8739ae039)(nationalPhoneNumber, {
        countries: possibleCountries,
        defaultCountry: defaultCountry,
        metadata: metadata.metadata
    });
}


// When phone numbers are written in `RFC3966` format — `"tel:+12133734253"` —
// they can have their "calling code" part written separately in a `phone-context` parameter.
// Example: `"tel:12133734253;phone-context=+1"`.
// This function parses the full phone number from the local number and the `phone-context`
// when the `phone-context` contains a `+` sign.

var $04a5fa33ef2e5578$export$1ddc7eed78155f68 = "+";
var $04a5fa33ef2e5578$var$RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var $04a5fa33ef2e5578$var$RFC3966_PHONE_DIGIT_ = "([" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]" + "|" + $04a5fa33ef2e5578$var$RFC3966_VISUAL_SEPARATOR_ + ")";
var $04a5fa33ef2e5578$var$RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + $04a5fa33ef2e5578$export$1ddc7eed78155f68 + $04a5fa33ef2e5578$var$RFC3966_PHONE_DIGIT_ + "*" + "[" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]" + $04a5fa33ef2e5578$var$RFC3966_PHONE_DIGIT_ + "*" + "$";
/**
 * Regular expression of valid global-number-digits for the phone-context
 * parameter, following the syntax defined in RFC3966.
 */ var $04a5fa33ef2e5578$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp($04a5fa33ef2e5578$var$RFC3966_GLOBAL_NUMBER_DIGITS_, "g"); // In this port of Google's library, we don't accept alpha characters in phone numbers.
// const ALPHANUM_ = VALID_ALPHA_ + VALID_DIGITS
var $04a5fa33ef2e5578$var$ALPHANUM_ = (0, $54824ce66ed242f7$export$852d1d4a47329634);
var $04a5fa33ef2e5578$var$RFC3966_DOMAINLABEL_ = "[" + $04a5fa33ef2e5578$var$ALPHANUM_ + "]+((\\-)*[" + $04a5fa33ef2e5578$var$ALPHANUM_ + "])*";
var $04a5fa33ef2e5578$var$VALID_ALPHA_ = "a-zA-Z";
var $04a5fa33ef2e5578$var$RFC3966_TOPLABEL_ = "[" + $04a5fa33ef2e5578$var$VALID_ALPHA_ + "]+((\\-)*[" + $04a5fa33ef2e5578$var$ALPHANUM_ + "])*";
var $04a5fa33ef2e5578$var$RFC3966_DOMAINNAME_ = "^(" + $04a5fa33ef2e5578$var$RFC3966_DOMAINLABEL_ + "\\.)*" + $04a5fa33ef2e5578$var$RFC3966_TOPLABEL_ + "\\.?$";
/**
 * Regular expression of valid domainname for the phone-context parameter,
 * following the syntax defined in RFC3966.
 */ var $04a5fa33ef2e5578$var$RFC3966_DOMAINNAME_PATTERN_ = new RegExp($04a5fa33ef2e5578$var$RFC3966_DOMAINNAME_, "g");
var $04a5fa33ef2e5578$export$70d485ce3f6de783 = "tel:";
var $04a5fa33ef2e5578$export$f6d5879d582c3a27 = ";phone-context=";
var $04a5fa33ef2e5578$export$9e356e12edb00a81 = ";isub=";
function $04a5fa33ef2e5578$export$2e2bcd8739ae039(numberToExtractFrom) {
    var indexOfPhoneContext = numberToExtractFrom.indexOf($04a5fa33ef2e5578$export$f6d5879d582c3a27); // If no phone-context parameter is present
    if (indexOfPhoneContext < 0) return null;
    var phoneContextStart = indexOfPhoneContext + $04a5fa33ef2e5578$export$f6d5879d582c3a27.length; // If phone-context parameter is empty
    if (phoneContextStart >= numberToExtractFrom.length) return "";
    var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart); // If phone-context is not the last parameter
    if (phoneContextEnd >= 0) return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
    else return numberToExtractFrom.substring(phoneContextStart);
}
function $04a5fa33ef2e5578$export$474a4aa22ad6959a(phoneContext) {
    if (phoneContext === null) return true;
    if (phoneContext.length === 0) return false;
     // Does phone-context value match pattern of global-number-digits or domainname.
    return $04a5fa33ef2e5578$var$RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || $04a5fa33ef2e5578$var$RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}



function $5d199d8c7f4ed918$export$2e2bcd8739ae039(numberToParse, _ref) {
    var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
    var phoneContext = (0, $04a5fa33ef2e5578$export$2e2bcd8739ae039)(numberToParse);
    if (!(0, $04a5fa33ef2e5578$export$474a4aa22ad6959a)(phoneContext)) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("NOT_A_NUMBER");
    var phoneNumberString;
    if (phoneContext === null) // Extract a possible number from the string passed in.
    // (this strips leading characters that could not be the start of a phone number)
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
    else {
        phoneNumberString = ""; // If the phone context contains a phone number prefix, we need to capture
        // it, whereas domains will be ignored.
        if (phoneContext.charAt(0) === (0, $04a5fa33ef2e5578$export$1ddc7eed78155f68)) phoneNumberString += phoneContext;
         // Now append everything between the "tel:" prefix and the phone-context.
        // This should include the national number, an optional extension or
        // isdn-subaddress component. Note we also handle the case when "tel:" is
        // missing, as we have seen in some of the phone number inputs.
        // In that case, we append everything from the beginning.
        var indexOfRfc3966Prefix = numberToParse.indexOf((0, $04a5fa33ef2e5578$export$70d485ce3f6de783));
        var indexOfNationalNumber; // RFC 3966 "tel:" prefix is preset at this stage because
        // `isPhoneContextValid()` requires it to be present.
        /* istanbul ignore else */ if (indexOfRfc3966Prefix >= 0) indexOfNationalNumber = indexOfRfc3966Prefix + (0, $04a5fa33ef2e5578$export$70d485ce3f6de783).length;
        else indexOfNationalNumber = 0;
        var indexOfPhoneContext = numberToParse.indexOf((0, $04a5fa33ef2e5578$export$f6d5879d582c3a27));
        phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
    } // Delete the isdn-subaddress and everything after it if it is present.
    // Note extension won't appear at the same time with isdn-subaddress
    // according to paragraph 5.3 of the RFC3966 spec.
    var indexOfIsdn = phoneNumberString.indexOf((0, $04a5fa33ef2e5578$export$9e356e12edb00a81));
    if (indexOfIsdn > 0) phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
     // If both phone context and isdn-subaddress are absent but other
    // parameters are present, the parameters are left in nationalNumber.
    // This is because we are concerned about deleting content from a potential
    // number string when there is no strong evidence that the number is
    // actually written in RFC3966.
    if (phoneNumberString !== "") return phoneNumberString;
}


// This prevents malicious input from consuming CPU.
var $46a8e3479f660a91$var$MAX_INPUT_STRING_LENGTH = 250; // This consists of the plus symbol, digits, and arabic-indic digits.
var $46a8e3479f660a91$var$PHONE_NUMBER_START_PATTERN = new RegExp("[" + (0, $54824ce66ed242f7$export$207c99ccf3902df8) + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "]"); // Regular expression of trailing characters that we want to remove.
// A trailing `#` is sometimes used when writing phone numbers with extensions in US.
// Example: "+1 (645) 123 1234-910#" number has extension "910".
var $46a8e3479f660a91$var$AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + (0, $54824ce66ed242f7$export$852d1d4a47329634) + "#" + "]+$");
var $46a8e3479f660a91$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE = false; // Examples:
function $46a8e3479f660a91$export$2e2bcd8739ae039(text, options, metadata) {
    // If assigning the `{}` default value is moved to the arguments above,
    // code coverage would decrease for some weird reason.
    options = options || {};
    metadata = new (0, $ea90f4b3245f449e$export$2e2bcd8739ae039)(metadata); // Validate `defaultCountry`.
    if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
        if (options.v2) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        throw new Error("Unknown country: ".concat(options.defaultCountry));
    } // Parse the phone number.
    var _parseInput = $46a8e3479f660a91$var$parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error; // If the phone number is not viable then return nothing.
    if (!formattedPhoneNumber) {
        if (options.v2) {
            if (error === "TOO_SHORT") throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("TOO_SHORT");
            throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("NOT_A_NUMBER");
        }
        return {};
    }
    var _parsePhoneNumber = $46a8e3479f660a91$var$parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
    if (!metadata.hasSelectedNumberingPlan()) {
        if (options.v2) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("INVALID_COUNTRY");
        return {};
    } // Validate national (significant) number length.
    if (!nationalNumber || nationalNumber.length < (0, $54824ce66ed242f7$export$cd8355bcbe13154)) {
        // Won't throw here because the regexp already demands length > 1.
        /* istanbul ignore if */ if (options.v2) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("TOO_SHORT");
         // Google's demo just throws an error in this case.
        return {};
    } // Validate national (significant) number length.
    //
    // A sidenote:
    //
    // They say that sometimes national (significant) numbers
    // can be longer than `MAX_LENGTH_FOR_NSN` (e.g. in Germany).
    // https://github.com/googlei18n/libphonenumber/blob/7e1748645552da39c4e1ba731e47969d97bdb539/resources/phonenumber.proto#L36
    // Such numbers will just be discarded.
    //
    if (nationalNumber.length > (0, $54824ce66ed242f7$export$85ddd8c9b243679b)) {
        if (options.v2) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("TOO_LONG");
         // Google's demo just throws an error in this case.
        return {};
    }
    if (options.v2) {
        var phoneNumber = new (0, $5b0b88132bf7c67c$export$2e2bcd8739ae039)(countryCallingCode, nationalNumber, metadata.metadata);
        if (country) phoneNumber.country = country;
        if (carrierCode) phoneNumber.carrierCode = carrierCode;
        if (ext) phoneNumber.ext = ext;
        phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
        return phoneNumber;
    } // Check if national phone number pattern matches the number.
    // National number pattern is different for each country,
    // even for those ones which are part of the "NANPA" group.
    var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? (0, $bc31c17c579d1cd0$export$2e2bcd8739ae039)(nationalNumber, metadata.nationalNumberPattern()) : false;
    if (!options.extended) return valid ? $46a8e3479f660a91$var$result(country, nationalNumber, ext) : {};
     // isInternational: countryCallingCode !== undefined
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        carrierCode: carrierCode,
        valid: valid,
        possible: valid ? true : options.extended === true && metadata.possibleLengths() && (0, $6ed5ea9724d699c8$export$4f8890cedf1e0497)(nationalNumber, metadata) ? true : false,
        phone: nationalNumber,
        ext: ext
    };
}
/**
 * Extracts a formatted phone number from text.
 * Doesn't guarantee that the extracted phone number
 * is a valid phone number (for example, doesn't validate its length).
 * @param  {string} text
 * @param  {boolean} [extract] — If `false`, then will parse the entire `text` as a phone number.
 * @param  {boolean} [throwOnError] — By default, it won't throw if the text is too long.
 * @return {string}
 * @example
 * // Returns "(213) 373-4253".
 * extractFormattedPhoneNumber("Call (213) 373-4253 for assistance.")
 */ function $46a8e3479f660a91$var$_extractFormattedPhoneNumber(text, extract, throwOnError) {
    if (!text) return;
    if (text.length > $46a8e3479f660a91$var$MAX_INPUT_STRING_LENGTH) {
        if (throwOnError) throw new (0, $37402b15fa819a93$export$2e2bcd8739ae039)("TOO_LONG");
        return;
    }
    if (extract === false) return text;
     // Attempt to extract a possible number from the string passed in
    var startsAt = text.search($46a8e3479f660a91$var$PHONE_NUMBER_START_PATTERN);
    if (startsAt < 0) return;
    return text // Trim everything to the left of the phone number
    .slice(startsAt) // Remove trailing non-numerical characters
    .replace($46a8e3479f660a91$var$AFTER_PHONE_NUMBER_END_PATTERN, "");
}
/**
 * @param  {string} text - Input.
 * @param  {boolean} v2 - Legacy API functions don't pass `v2: true` flag.
 * @param  {boolean} [extract] - Whether to extract a phone number from `text`, or attempt to parse the entire text as a phone number.
 * @return {object} `{ ?number, ?ext }`.
 */ function $46a8e3479f660a91$var$parseInput(text, v2, extract) {
    // // Parse RFC 3966 phone number URI.
    // if (text && text.indexOf('tel:') === 0) {
    // 	return parseRFC3966(text)
    // }
    // let number = extractFormattedPhoneNumber(text, extract, v2)
    var number = (0, $5d199d8c7f4ed918$export$2e2bcd8739ae039)(text, {
        extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text) {
            return $46a8e3479f660a91$var$_extractFormattedPhoneNumber(text, extract, v2);
        }
    }); // If the phone number is not viable, then abort.
    if (!number) return {};
    if (!(0, $c21ab8fe347a08d1$export$2e2bcd8739ae039)(number)) {
        if ((0, $c21ab8fe347a08d1$export$4c3f76c95c05197c)(number)) return {
            error: "TOO_SHORT"
        };
        return {};
    } // Attempt to parse extension first, since it doesn't require region-specific
    // data and we want to have the non-normalised number here.
    var withExtensionStripped = (0, $cf53f85670001ba1$export$2e2bcd8739ae039)(number);
    if (withExtensionStripped.ext) return withExtensionStripped;
    return {
        number: number
    };
}
/**
 * Creates `parse()` result object.
 */ function $46a8e3479f660a91$var$result(country, nationalNumber, ext) {
    var result = {
        country: country,
        phone: nationalNumber
    };
    if (ext) result.ext = ext;
    return result;
}
/**
 * Parses a viable phone number.
 * @param {string} formattedPhoneNumber — Example: "(213) 373-4253".
 * @param {string} [defaultCountry]
 * @param {string} [defaultCallingCode]
 * @param {Metadata} metadata
 * @return {object} Returns `{ country: string?, countryCallingCode: string?, nationalNumber: string? }`.
 */ function $46a8e3479f660a91$var$parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
    // Extract calling code from phone number.
    var _extractCountryCallin = (0, $5d10e13e24aef5eb$export$2e2bcd8739ae039)((0, $9056fe61ffe172a8$export$2e2bcd8739ae039)(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number; // Choose a country by `countryCallingCode`.
    var country;
    if (countryCallingCode) metadata.selectNumberingPlan(countryCallingCode);
    else if (number && (defaultCountry || defaultCallingCode)) {
        metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
        if (defaultCountry) country = defaultCountry;
        else {
            /* istanbul ignore if */ if ($46a8e3479f660a91$var$USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
                if (metadata.isNonGeographicCallingCode(defaultCallingCode)) country = "001";
            }
        }
        countryCallingCode = defaultCallingCode || (0, $ea90f4b3245f449e$export$32876ca2f1919cf0)(defaultCountry, metadata.metadata);
    } else return {};
    if (!number) return {
        countryCallingCodeSource: countryCallingCodeSource,
        countryCallingCode: countryCallingCode
    };
    var _extractNationalNumbe = (0, $e4976e2e729c5a79$export$2e2bcd8739ae039)((0, $9056fe61ffe172a8$export$2e2bcd8739ae039)(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode; // Sometimes there are several countries
    // corresponding to the same country phone code
    // (e.g. NANPA countries all having `1` country phone code).
    // Therefore, to reliably determine the exact country,
    // national (significant) number should have been parsed first.
    //
    // When `metadata.json` is generated, all "ambiguous" country phone codes
    // get their countries populated with the full set of
    // "phone number type" regular expressions.
    //
    var exactCountry = (0, $b6dfde26c225eac0$export$2e2bcd8739ae039)(countryCallingCode, {
        nationalNumber: nationalNumber,
        defaultCountry: defaultCountry,
        metadata: metadata
    });
    if (exactCountry) {
        country = exactCountry;
        /* istanbul ignore if */ if (exactCountry === "001") ;
        else metadata.country(country);
    }
    return {
        country: country,
        countryCallingCode: countryCallingCode,
        countryCallingCodeSource: countryCallingCodeSource,
        nationalNumber: nationalNumber,
        carrierCode: carrierCode
    };
}


function $85aaaaf3e7b7c814$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $85aaaaf3e7b7c814$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $85aaaaf3e7b7c814$var$ownKeys(Object(source), !0).forEach(function(key) {
            $85aaaaf3e7b7c814$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $85aaaaf3e7b7c814$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $85aaaaf3e7b7c814$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $85aaaaf3e7b7c814$export$2e2bcd8739ae039(text, options, metadata) {
    return (0, $46a8e3479f660a91$export$2e2bcd8739ae039)(text, $85aaaaf3e7b7c814$var$_objectSpread($85aaaaf3e7b7c814$var$_objectSpread({}, options), {}, {
        v2: true
    }), metadata);
}



function $4584ce537de381e3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4584ce537de381e3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $4584ce537de381e3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $4584ce537de381e3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $4584ce537de381e3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4584ce537de381e3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4584ce537de381e3$var$_slicedToArray(arr, i) {
    return $4584ce537de381e3$var$_arrayWithHoles(arr) || $4584ce537de381e3$var$_iterableToArrayLimit(arr, i) || $4584ce537de381e3$var$_unsupportedIterableToArray(arr, i) || $4584ce537de381e3$var$_nonIterableRest();
}
function $4584ce537de381e3$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4584ce537de381e3$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4584ce537de381e3$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4584ce537de381e3$var$_arrayLikeToArray(o, minLen);
}
function $4584ce537de381e3$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4584ce537de381e3$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $4584ce537de381e3$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $4584ce537de381e3$export$2e2bcd8739ae039(args) {
    var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = $4584ce537de381e3$var$_slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
    var text;
    var options;
    var metadata; // If the phone number is passed as a string.
    // `parsePhoneNumber('88005553535', ...)`.
    if (typeof arg_1 === "string") text = arg_1;
    else throw new TypeError("A text for parsing must be a string."); // If "default country" argument is being passed then move it to `options`.
    // `parsePhoneNumber('88005553535', 'RU', [options], metadata)`.
    if (!arg_2 || typeof arg_2 === "string") {
        if (arg_4) {
            options = arg_3;
            metadata = arg_4;
        } else {
            options = undefined;
            metadata = arg_3;
        }
        if (arg_2) options = $4584ce537de381e3$var$_objectSpread({
            defaultCountry: arg_2
        }, options);
    } else if ((0, $4b3fe5e7e402fbb7$export$2e2bcd8739ae039)(arg_2)) {
        if (arg_3) {
            options = arg_2;
            metadata = arg_3;
        } else metadata = arg_2;
    } else throw new Error("Invalid second argument: ".concat(arg_2));
    return {
        text: text,
        options: options,
        metadata: metadata
    };
}


function $6a0870214a9c94f3$export$2e2bcd8739ae039() {
    var _normalizeArguments = (0, $4584ce537de381e3$export$2e2bcd8739ae039)(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
    return (0, $85aaaaf3e7b7c814$export$2e2bcd8739ae039)(text, options, metadata);
}


function $53b53cbd69ef2a8a$export$176bb591929cc9a8() {
    return (0, $8bd7a0efdde9e15b$export$2e2bcd8739ae039)((0, $6a0870214a9c94f3$export$2e2bcd8739ae039), arguments);
}


const $75ee91b14347449d$export$da44e4eaa54bc82e = (phone)=>{
    try {
        return (0, $53b53cbd69ef2a8a$export$176bb591929cc9a8)(phone).number.slice(1);
    } catch  {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};
const $75ee91b14347449d$export$d79b62bd58081ca4 = (phone)=>{
    try {
        const phoneNumber = phone.startsWith("+") ? phone : `+${phone}`;
        return (0, $53b53cbd69ef2a8a$export$176bb591929cc9a8)(phoneNumber).formatInternational();
    } catch  {
        console.error(`Invalid phone number: ${phone}`);
        return phone;
    }
};


var $c616dbc62296d18e$exports = {};

$parcel$export($c616dbc62296d18e$exports, "avatar", function () { return $c616dbc62296d18e$export$345c5736c8054f22; }, function (v) { return $c616dbc62296d18e$export$345c5736c8054f22 = v; });
$parcel$export($c616dbc62296d18e$exports, "label", function () { return $c616dbc62296d18e$export$1237798dc640739a; }, function (v) { return $c616dbc62296d18e$export$1237798dc640739a = v; });
$parcel$export($c616dbc62296d18e$exports, "large", function () { return $c616dbc62296d18e$export$f09585a853dddd32; }, function (v) { return $c616dbc62296d18e$export$f09585a853dddd32 = v; });
$parcel$export($c616dbc62296d18e$exports, "medium", function () { return $c616dbc62296d18e$export$649ecc744817b5c7; }, function (v) { return $c616dbc62296d18e$export$649ecc744817b5c7 = v; });
$parcel$export($c616dbc62296d18e$exports, "micro", function () { return $c616dbc62296d18e$export$77bd0ce503b87b26; }, function (v) { return $c616dbc62296d18e$export$77bd0ce503b87b26 = v; });
$parcel$export($c616dbc62296d18e$exports, "rotating", function () { return $c616dbc62296d18e$export$bfd64c937657f93a; }, function (v) { return $c616dbc62296d18e$export$bfd64c937657f93a = v; });
$parcel$export($c616dbc62296d18e$exports, "row", function () { return $c616dbc62296d18e$export$120ff0929b202a6d; }, function (v) { return $c616dbc62296d18e$export$120ff0929b202a6d = v; });
$parcel$export($c616dbc62296d18e$exports, "shimmer", function () { return $c616dbc62296d18e$export$4a6dd88bada4e7d2; }, function (v) { return $c616dbc62296d18e$export$4a6dd88bada4e7d2 = v; });
$parcel$export($c616dbc62296d18e$exports, "small", function () { return $c616dbc62296d18e$export$3c17b0e969a90510; }, function (v) { return $c616dbc62296d18e$export$3c17b0e969a90510 = v; });
$parcel$export($c616dbc62296d18e$exports, "tooltip", function () { return $c616dbc62296d18e$export$4e6f96734dfe12f4; }, function (v) { return $c616dbc62296d18e$export$4e6f96734dfe12f4 = v; });
$parcel$export($c616dbc62296d18e$exports, "value", function () { return $c616dbc62296d18e$export$2ab9a8f9f1186f14; }, function (v) { return $c616dbc62296d18e$export$2ab9a8f9f1186f14 = v; });
$parcel$export($c616dbc62296d18e$exports, "wrapper", function () { return $c616dbc62296d18e$export$cc74dcc53cfce4eb; }, function (v) { return $c616dbc62296d18e$export$cc74dcc53cfce4eb = v; });
$parcel$export($c616dbc62296d18e$exports, "xlarge", function () { return $c616dbc62296d18e$export$bb57e550b957ab; }, function (v) { return $c616dbc62296d18e$export$bb57e550b957ab = v; });
var $c616dbc62296d18e$export$345c5736c8054f22;
var $c616dbc62296d18e$export$1237798dc640739a;
var $c616dbc62296d18e$export$f09585a853dddd32;
var $c616dbc62296d18e$export$649ecc744817b5c7;
var $c616dbc62296d18e$export$77bd0ce503b87b26;
var $c616dbc62296d18e$export$bfd64c937657f93a;
var $c616dbc62296d18e$export$120ff0929b202a6d;
var $c616dbc62296d18e$export$4a6dd88bada4e7d2;
var $c616dbc62296d18e$export$3c17b0e969a90510;
var $c616dbc62296d18e$export$4e6f96734dfe12f4;
var $c616dbc62296d18e$export$2ab9a8f9f1186f14;
var $c616dbc62296d18e$export$cc74dcc53cfce4eb;
var $c616dbc62296d18e$export$bb57e550b957ab;
$c616dbc62296d18e$export$345c5736c8054f22 = `cX_Dda_avatar`;
$c616dbc62296d18e$export$1237798dc640739a = `cX_Dda_label`;
$c616dbc62296d18e$export$f09585a853dddd32 = `cX_Dda_large`;
$c616dbc62296d18e$export$649ecc744817b5c7 = `cX_Dda_medium`;
$c616dbc62296d18e$export$77bd0ce503b87b26 = `cX_Dda_micro`;
$c616dbc62296d18e$export$bfd64c937657f93a = `cX_Dda_rotating`;
$c616dbc62296d18e$export$120ff0929b202a6d = `cX_Dda_row`;
$c616dbc62296d18e$export$4a6dd88bada4e7d2 = `cX_Dda_shimmer`;
$c616dbc62296d18e$export$3c17b0e969a90510 = `cX_Dda_small`;
$c616dbc62296d18e$export$4e6f96734dfe12f4 = `cX_Dda_tooltip`;
$c616dbc62296d18e$export$2ab9a8f9f1186f14 = `cX_Dda_value`;
$c616dbc62296d18e$export$cc74dcc53cfce4eb = `cX_Dda_wrapper`;
$c616dbc62296d18e$export$bb57e550b957ab = `cX_Dda_xlarge`;


function $eeeb5d5d34fbdff9$var$UserInfoTipContent({ user: user }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username } = user;
    const itemsToDisplay = [
        {
            label: t("user_details.field_name"),
            value: name
        },
        {
            label: t("user_details.field_email"),
            value: primaryEmail
        },
        {
            label: t("user_details.field_phone"),
            value: (0, $5CQIb.conditional)(primaryPhone && (0, $75ee91b14347449d$export$d79b62bd58081ca4)(primaryPhone))
        },
        {
            label: t("user_details.field_username"),
            value: username
        }
    ];
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: itemsToDisplay.filter(({ value: value })=>Boolean(value)).map(({ label: label, value: value })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c616dbc62296d18e$exports.row,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                        className: $c616dbc62296d18e$exports.label,
                        children: [
                            label,
                            ":"
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $c616dbc62296d18e$exports.value,
                        children: value
                    })
                ]
            }, label))
    });
}
function $eeeb5d5d34fbdff9$var$UserAvatar({ className: className, size: size = "medium", user: user, hasTooltip: hasTooltip = false }) {
    const avatarClassName = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c616dbc62296d18e$exports.avatar, $c616dbc62296d18e$exports[size]);
    const wrapperClassName = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c616dbc62296d18e$exports.wrapper, $c616dbc62296d18e$exports[size], className);
    const defaultColorPalette = [
        "#E74C3C",
        "#865300",
        "#FF8B64",
        "#FFC651",
        "#4EA254",
        "#2FA0FD",
        "#02C2E4",
        "#41BEA6",
        "#7958FF",
        "#ED73A3",
        "#DF96FA",
        "#ADAAB4"
    ];
    const { name: name, username: username, avatar: avatar, primaryEmail: primaryEmail } = user ?? {};
    if (avatar) return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
            className: avatarClassName,
            src: avatar,
            alt: "avatar",
            /**
           * Some social connectors like Google will block the references to its image resource,
           * without specifying the referrerPolicy attribute. Reference:
           * https://stackoverflow.com/questions/40570117/http403-forbidden-error-when-trying-to-load-img-src-with-google-profile-pic
           */ referrerPolicy: "no-referrer",
            fallbackElement: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c29803d3d7839d72$export$2e2bcd8739ae039), {})
        })
    });
    const nameToDisplay = (name ?? username ?? primaryEmail)?.toLocaleUpperCase();
    const color = (0, $5CQIb.conditional)(nameToDisplay && defaultColorPalette[(nameToDisplay.codePointAt(0) ?? 0) % defaultColorPalette.length]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: wrapperClassName,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
            className: $c616dbc62296d18e$exports.tooltip,
            anchorClassName: $c616dbc62296d18e$exports[size],
            content: (0, $5CQIb.conditional)(hasTooltip && user && /*#__PURE__*/ (0, $9zeGj.jsx)($eeeb5d5d34fbdff9$var$UserInfoTipContent, {
                user: user
            })),
            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: avatarClassName,
                style: {
                    backgroundColor: color
                },
                children: nameToDisplay ? nameToDisplay.charAt(0) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c29803d3d7839d72$export$2e2bcd8739ae039), {})
            })
        })
    });
}
var $eeeb5d5d34fbdff9$export$2e2bcd8739ae039 = $eeeb5d5d34fbdff9$var$UserAvatar;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $e4c426877dd62d2d$export$d290fa47940df19d;
var $e4c426877dd62d2d$export$a8ff84c12d48cfa6;
var $e4c426877dd62d2d$export$d3ff39bcaba9d9ce;
var $e4c426877dd62d2d$export$bfd64c937657f93a;
var $e4c426877dd62d2d$export$4a6dd88bada4e7d2;
var $e4c426877dd62d2d$export$94e4009ecfbf7408;
$e4c426877dd62d2d$export$d290fa47940df19d = `_26bd8a_email`;
$e4c426877dd62d2d$export$a8ff84c12d48cfa6 = `_26bd8a_name`;
$e4c426877dd62d2d$export$d3ff39bcaba9d9ce = `_26bd8a_nameWrapper`;
$e4c426877dd62d2d$export$bfd64c937657f93a = `_26bd8a_rotating`;
$e4c426877dd62d2d$export$4a6dd88bada4e7d2 = `_26bd8a_shimmer`;
$e4c426877dd62d2d$export$94e4009ecfbf7408 = `_26bd8a_userInfo`;


function $61a8dce11d5a3fab$var$UserInfoCard({ className: className, user: user, avatarSize: avatarSize = "medium" }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, username: username, avatar: avatar, picture: picture, primaryEmail: primaryEmail, email: email } = user ?? {};
    const avatarToDisplay = avatar ?? picture;
    const nameToDisplay = name ?? username;
    const emailToDisplay = primaryEmail ?? email;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($e4c426877dd62d2d$export$94e4009ecfbf7408, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                size: avatarSize,
                user: {
                    name: name,
                    username: username,
                    avatar: avatarToDisplay,
                    primaryEmail: emailToDisplay
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $e4c426877dd62d2d$export$d3ff39bcaba9d9ce,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $e4c426877dd62d2d$export$a8ff84c12d48cfa6,
                        children: nameToDisplay
                    }),
                    emailToDisplay && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $e4c426877dd62d2d$export$d290fa47940df19d,
                        children: emailToDisplay
                    }),
                    !nameToDisplay && !emailToDisplay && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $e4c426877dd62d2d$export$d290fa47940df19d,
                        children: [
                            "(",
                            t("profile.link_account.anonymous"),
                            ")"
                        ]
                    })
                ]
            })
        ]
    });
}
var $61a8dce11d5a3fab$export$2e2bcd8739ae039 = $61a8dce11d5a3fab$var$UserInfoCard;





var $3MzPh = parcelRequire("3MzPh");

var $6jNMj = parcelRequire("6jNMj");


var $iYZTa = parcelRequire("iYZTa");

var $4W0F0 = parcelRequire("4W0F0");


var $eCoWV = parcelRequire("eCoWV");

var $2CYkO = parcelRequire("2CYkO");

var $1iAqo = parcelRequire("1iAqo");

var $cQ96m = parcelRequire("cQ96m");

const $cfea97097315f28a$var$adminConsolePreferencesKey = "adminConsolePreferences";
const $cfea97097315f28a$var$userPreferencesGuard = (0, $2CYkO.z).object({
    language: (0, $2CYkO.z).enum((0, $824f1ad0d8aba615$export$651548ae3cf5e245)).optional(),
    appearanceMode: (0, $cQ96m.appearanceModeGuard).optional(),
    experienceNoticeConfirmed: (0, $2CYkO.z).boolean().optional(),
    getStartedHidden: (0, $2CYkO.z).boolean().optional(),
    connectorSieNoticeConfirmed: (0, $2CYkO.z).boolean().optional(),
    managementApiAcknowledged: (0, $2CYkO.z).boolean().optional()
});
const $cfea97097315f28a$var$defaultUserPreferences = {
    appearanceMode: (0, $1iAqo.buildDefaultAppearanceMode)(),
    language: "en"
};
const $cfea97097315f28a$var$useUserPreferences = ()=>{
    const { data: data, error: error, isLoading: isLoading, isLoaded: isLoaded, update: updateMeCustomData } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const { setAppearanceMode: setAppearanceMode } = (0, $eCoWV.useContext)((0, $1iAqo.AppThemeContext));
    const userPreferences = (0, $eCoWV.useMemo)(()=>{
        const parsed = (0, $2CYkO.z).object({
            [$cfea97097315f28a$var$adminConsolePreferencesKey]: $cfea97097315f28a$var$userPreferencesGuard
        }).safeParse(data);
        return parsed.success ? {
            ...$cfea97097315f28a$var$defaultUserPreferences,
            ...parsed.data[$cfea97097315f28a$var$adminConsolePreferencesKey]
        } : $cfea97097315f28a$var$defaultUserPreferences;
    }, [
        data
    ]);
    const update = async (data)=>{
        await updateMeCustomData({
            [$cfea97097315f28a$var$adminConsolePreferencesKey]: {
                ...userPreferences,
                ...data
            }
        });
    };
    (0, $eCoWV.useEffect)(()=>{
        setAppearanceMode(userPreferences.appearanceMode);
    }, [
        setAppearanceMode,
        userPreferences.appearanceMode
    ]);
    return {
        isLoading: isLoading,
        isLoaded: isLoaded,
        data: userPreferences,
        update: update,
        error: error
    };
};
var $cfea97097315f28a$export$2e2bcd8739ae039 = $cfea97097315f28a$var$useUserPreferences;



var $cQ96m = parcelRequire("cQ96m");

var $6PcpQ = parcelRequire("6PcpQ");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");


var $307Eo = parcelRequire("307Eo");


var $fbeQ6 = parcelRequire("fbeQ6");

var $d0Zvy = parcelRequire("d0Zvy");

var $3MzPh = parcelRequire("3MzPh");

var $6PcpQ = parcelRequire("6PcpQ");
var $b89b71a8bf7374d4$export$34e0f9847d4c02dd;
var $b89b71a8bf7374d4$export$1ca1ec8b29a4ce27;
var $b89b71a8bf7374d4$export$b1e5508a851be14d;
var $b89b71a8bf7374d4$export$f0d22739b64d27b3;
var $b89b71a8bf7374d4$export$bfd64c937657f93a;
var $b89b71a8bf7374d4$export$d90250155de6d7e7;
var $b89b71a8bf7374d4$export$4a6dd88bada4e7d2;
var $b89b71a8bf7374d4$export$55d7f61db91b7b70;
var $b89b71a8bf7374d4$export$fb184b623420d9be;
var $b89b71a8bf7374d4$export$664c6d24e3175067;
$b89b71a8bf7374d4$export$34e0f9847d4c02dd = `o057rW_container`;
$b89b71a8bf7374d4$export$1ca1ec8b29a4ce27 = `o057rW_icon`;
$b89b71a8bf7374d4$export$b1e5508a851be14d = `o057rW_menu`;
$b89b71a8bf7374d4$export$f0d22739b64d27b3 = `o057rW_menuOption`;
$b89b71a8bf7374d4$export$bfd64c937657f93a = `o057rW_rotating`;
$b89b71a8bf7374d4$export$d90250155de6d7e7 = `o057rW_selected`;
$b89b71a8bf7374d4$export$4a6dd88bada4e7d2 = `o057rW_shimmer`;
$b89b71a8bf7374d4$export$55d7f61db91b7b70 = `o057rW_tick`;
$b89b71a8bf7374d4$export$fb184b623420d9be = `o057rW_title`;
$b89b71a8bf7374d4$export$664c6d24e3175067 = `o057rW_visible`;


const $a898b0d93285da58$var$menuItemHeight = 40;
const $a898b0d93285da58$var$menuItemMargin = 4;
const $a898b0d93285da58$var$menuBorderSize = 1;
const $a898b0d93285da58$var$menuBottomMargin = 16;
function $a898b0d93285da58$var$SubMenu({ className: className, menuItemClassName: menuItemClassName, icon: icon, title: title, options: options, selectedOption: selectedOption, onItemClick: onItemClick }) {
    const anchorRef = (0, $eCoWV.useRef)(null);
    const [showMenu, setShowMenu] = (0, $eCoWV.useState)(false);
    const mouseEnterTimeoutRef = (0, $eCoWV.useRef)(0);
    const mouseLeaveTimeoutRef = (0, $eCoWV.useRef)(0);
    const [menuHeight, setMenuHeight] = (0, $eCoWV.useState)();
    const calculateDropdownHeight = (0, $eCoWV.useCallback)(()=>{
        if (anchorRef.current) {
            const anchorRect = anchorRef.current.getBoundingClientRect();
            const originalMenuHeight = options.length * $a898b0d93285da58$var$menuItemHeight + (options.length + 1) * $a898b0d93285da58$var$menuItemMargin + 2 * $a898b0d93285da58$var$menuBorderSize;
            const availableHeight = window.innerHeight - anchorRect.top - $a898b0d93285da58$var$menuBottomMargin;
            setMenuHeight(Math.min(originalMenuHeight, availableHeight));
        }
    }, [
        options.length
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: anchorRef,
        role: "button",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b89b71a8bf7374d4$export$34e0f9847d4c02dd, className),
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            setShowMenu(true);
        }),
        onMouseEnter: ()=>{
            window.clearTimeout(mouseLeaveTimeoutRef.current);
            calculateDropdownHeight();
            // eslint-disable-next-line @silverhand/fp/no-mutation
            mouseEnterTimeoutRef.current = window.setTimeout(()=>{
                setShowMenu(true);
            }, 300);
        },
        onMouseLeave: ()=>{
            window.clearTimeout(mouseEnterTimeoutRef.current);
            // eslint-disable-next-line @silverhand/fp/no-mutation
            mouseLeaveTimeoutRef.current = window.setTimeout(()=>{
                setShowMenu(false);
            }, 100);
        },
        onClick: (event)=>{
            event.stopPropagation();
            setShowMenu(true);
        },
        children: [
            icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $b89b71a8bf7374d4$export$1ca1ec8b29a4ce27,
                children: icon
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $b89b71a8bf7374d4$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3795a55c0fdb05fc$export$2e2bcd8739ae039), {
                className: $b89b71a8bf7374d4$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b89b71a8bf7374d4$export$b1e5508a851be14d, showMenu && $b89b71a8bf7374d4$export$664c6d24e3175067),
                style: {
                    maxHeight: menuHeight
                },
                children: options.map(({ value: value, title: title })=>{
                    const selected = value === selectedOption;
                    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b89b71a8bf7374d4$export$f0d22739b64d27b3, selected && $b89b71a8bf7374d4$export$d90250155de6d7e7, menuItemClassName),
                        onClick: ()=>{
                            onItemClick(value);
                        },
                        children: [
                            selected && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $307Eo.default), {
                                className: $b89b71a8bf7374d4$export$55d7f61db91b7b70
                            }),
                            title
                        ]
                    }, value);
                })
            })
        ]
    });
}
var $a898b0d93285da58$export$2e2bcd8739ae039 = $a898b0d93285da58$var$SubMenu;



var $9zeGj = parcelRequire("9zeGj");
var $5b560ee805e9ee0b$export$34e0f9847d4c02dd;
var $5b560ee805e9ee0b$export$5c452ff88e35e47d;
var $5b560ee805e9ee0b$export$a8ff84c12d48cfa6;
var $5b560ee805e9ee0b$export$bfd64c937657f93a;
var $5b560ee805e9ee0b$export$4a6dd88bada4e7d2;
$5b560ee805e9ee0b$export$34e0f9847d4c02dd = `d1KHsG_container`;
$5b560ee805e9ee0b$export$5c452ff88e35e47d = `d1KHsG_image`;
$5b560ee805e9ee0b$export$a8ff84c12d48cfa6 = `d1KHsG_name`;
$5b560ee805e9ee0b$export$bfd64c937657f93a = `d1KHsG_rotating`;
$5b560ee805e9ee0b$export$4a6dd88bada4e7d2 = `d1KHsG_shimmer`;
$5b560ee805e9ee0b$export$4a6dd88bada4e7d2;


function $9f55794d5bce92b9$var$UserInfoSkeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $5b560ee805e9ee0b$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            className: $5b560ee805e9ee0b$export$5c452ff88e35e47d
        })
    });
}
var $9f55794d5bce92b9$export$2e2bcd8739ae039 = $9f55794d5bce92b9$var$UserInfoSkeleton;


var $60f1afd4a38d2777$export$89da14300d534261;
var $60f1afd4a38d2777$export$34e0f9847d4c02dd;
var $60f1afd4a38d2777$export$81207e5cc4186890;
var $60f1afd4a38d2777$export$a8f2ac991e6b7a5;
var $60f1afd4a38d2777$export$1ca1ec8b29a4ce27;
var $60f1afd4a38d2777$export$46c1c92549715335;
var $60f1afd4a38d2777$export$bfd64c937657f93a;
var $60f1afd4a38d2777$export$4a6dd88bada4e7d2;
var $60f1afd4a38d2777$export$641374ffb95bc399;
var $60f1afd4a38d2777$export$94e4009ecfbf7408;
$60f1afd4a38d2777$export$89da14300d534261 = `p7wx2G_active`;
$60f1afd4a38d2777$export$34e0f9847d4c02dd = `p7wx2G_container`;
$60f1afd4a38d2777$export$81207e5cc4186890 = `p7wx2G_dropdown`;
$60f1afd4a38d2777$export$a8f2ac991e6b7a5 = `p7wx2G_dropdownItem`;
$60f1afd4a38d2777$export$1ca1ec8b29a4ce27 = `p7wx2G_icon`;
$60f1afd4a38d2777$export$46c1c92549715335 = `p7wx2G_loading`;
$60f1afd4a38d2777$export$bfd64c937657f93a = `p7wx2G_rotating`;
$60f1afd4a38d2777$export$4a6dd88bada4e7d2 = `p7wx2G_shimmer`;
$60f1afd4a38d2777$export$641374ffb95bc399 = `p7wx2G_spinner`;
$60f1afd4a38d2777$export$94e4009ecfbf7408 = `p7wx2G_userInfo`;


function $bb32554473acde6e$var$UserInfo() {
    const { signOut: signOut } = (0, $dtOpc.useLogto)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { user: user, isLoading: isLoadingUser } = (0, $475a856ff8d4300b$export$2e2bcd8739ae039)();
    const anchorRef = (0, $eCoWV.useRef)(null);
    const [showDropdown, setShowDropdown] = (0, $eCoWV.useState)(false);
    const postSignOutRedirectUri = (0, $iYZTa.default)("signOut");
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const { data: { language: language, appearanceMode: appearanceMode }, update: update } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    if (isLoadingUser) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9f55794d5bce92b9$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                ref: anchorRef,
                role: "button",
                tabIndex: 0,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($60f1afd4a38d2777$export$34e0f9847d4c02dd, showDropdown && $60f1afd4a38d2777$export$89da14300d534261),
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    setShowDropdown(true);
                }),
                onClick: ()=>{
                    setShowDropdown(true);
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                    user: user
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                hasOverflowContent: true,
                anchorRef: anchorRef,
                className: $60f1afd4a38d2777$export$81207e5cc4186890,
                isOpen: showDropdown,
                horizontalAlign: "end",
                onClose: ()=>{
                    setShowDropdown(false);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $61a8dce11d5a3fab$export$2e2bcd8739ae039), {
                        className: $60f1afd4a38d2777$export$94e4009ecfbf7408,
                        user: user,
                        avatarSize: "large"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90d2b44b795c16b0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($60f1afd4a38d2777$export$a8f2ac991e6b7a5, isLoading && $60f1afd4a38d2777$export$46c1c92549715335),
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $06aaa25160e82e50$export$2e2bcd8739ae039), {
                            className: $60f1afd4a38d2777$export$1ca1ec8b29a4ce27
                        }),
                        onClick: ()=>{
                            navigate("/profile");
                        },
                        children: t("menu.profile")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90d2b44b795c16b0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a898b0d93285da58$export$2e2bcd8739ae039), {
                        className: $60f1afd4a38d2777$export$a8f2ac991e6b7a5,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47fe8f63822b1442$export$2e2bcd8739ae039), {
                            className: $60f1afd4a38d2777$export$1ca1ec8b29a4ce27
                        }),
                        title: "menu.language",
                        options: (0, $824f1ad0d8aba615$export$91d555a17bb93dc7),
                        selectedOption: language,
                        onItemClick: (language)=>{
                            update({
                                language: language
                            });
                            setShowDropdown(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a898b0d93285da58$export$2e2bcd8739ae039), {
                        className: $60f1afd4a38d2777$export$a8f2ac991e6b7a5,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ab1b82ae66f6442b$export$2e2bcd8739ae039), {
                            className: $60f1afd4a38d2777$export$1ca1ec8b29a4ce27
                        }),
                        title: "menu.appearance.label",
                        options: [
                            {
                                value: (0, $cQ96m.DynamicAppearanceMode).System,
                                title: t("menu.appearance.system")
                            },
                            {
                                value: (0, $bhvxB.Theme).Light,
                                title: t("menu.appearance.light")
                            },
                            {
                                value: (0, $bhvxB.Theme).Dark,
                                title: t("menu.appearance.dark")
                            }
                        ],
                        selectedOption: appearanceMode,
                        onItemClick: (appearanceMode)=>{
                            update({
                                appearanceMode: appearanceMode
                            });
                            setShowDropdown(false);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90d2b44b795c16b0$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($60f1afd4a38d2777$export$a8f2ac991e6b7a5, isLoading && $60f1afd4a38d2777$export$46c1c92549715335),
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $abed159f3a090c88$export$2e2bcd8739ae039), {
                            className: $60f1afd4a38d2777$export$1ca1ec8b29a4ce27
                        }),
                        onClick: (event)=>{
                            event.stopPropagation();
                            if (isLoading) return;
                            setIsLoading(true);
                            signOut(postSignOutRedirectUri.href);
                        },
                        children: [
                            t("menu.sign_out"),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                            isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {
                                className: $60f1afd4a38d2777$export$641374ffb95bc399
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $bb32554473acde6e$export$2e2bcd8739ae039 = $bb32554473acde6e$var$UserInfo;


var $7a86cac9e115f89f$export$53f1d5ea8de3d7c;
var $7a86cac9e115f89f$export$db3c28d99448dcff;
var $7a86cac9e115f89f$export$bfd64c937657f93a;
var $7a86cac9e115f89f$export$4a6dd88bada4e7d2;
var $7a86cac9e115f89f$export$6f093cfa640b7166;
var $7a86cac9e115f89f$export$42c68d6252221cac;
$7a86cac9e115f89f$export$53f1d5ea8de3d7c = `OfVTMq_line`;
$7a86cac9e115f89f$export$db3c28d99448dcff = `OfVTMq_logo`;
$7a86cac9e115f89f$export$bfd64c937657f93a = `OfVTMq_rotating`;
$7a86cac9e115f89f$export$4a6dd88bada4e7d2 = `OfVTMq_shimmer`;
$7a86cac9e115f89f$export$6f093cfa640b7166 = `OfVTMq_text`;
$7a86cac9e115f89f$export$42c68d6252221cac = `OfVTMq_topbar`;


function $c55ce026a9f50563$var$Topbar({ className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const LogtoLogo = (0, $V1X8c.isCloud) ? (0, $4c269f96590333ef$export$2e2bcd8739ae039) : (0, $d4e42755ce7365a4$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7a86cac9e115f89f$export$42c68d6252221cac, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(LogtoLogo, {
                className: $7a86cac9e115f89f$export$db3c28d99448dcff
            }),
            (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $86d01f597b8a43ff$export$2e2bcd8739ae039), {}),
            !(0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7a86cac9e115f89f$export$53f1d5ea8de3d7c
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7a86cac9e115f89f$export$6f093cfa640b7166,
                        children: t("title")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0e1773aa1a1d43ac$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $897cbc3d0aaa83bd$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bb32554473acde6e$export$2e2bcd8739ae039), {})
        ]
    });
}
var $c55ce026a9f50563$export$2e2bcd8739ae039 = $c55ce026a9f50563$var$Topbar;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $9b697ffbb6ba0ac4$var$SvgTenantLandingPageDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.882 224h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#9485C5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.85,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M178.578 85.035c-17.716.74-32.401 13.21-36.49 29.848-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h15.663C141.577 187.307 121.304 196 99 196c-46.392 0-84-37.608-84-84s37.608-84 84-84c36.96 0 68.344 23.87 79.578 57.035Z",
                fill: "url(#paint0_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M21.67 144.86c-3.23 5.9-3.942 20.305-3.942 37.138 0 2.757.038 5.449.115 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.043.041a3.158 3.158 0 0 0-.035.032v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.732 27.416 4.155-3.285 12.107-7.058 12.107-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188 4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 2.274-2.274 3.931-4.741 4.846-6.846a84.33 84.33 0 0 1-4.484-4.439c-1.426.623-3.016 1.586-4.599 2.849-.098-3.079-.249-6.018-.456-8.768A83.928 83.928 0 0 1 21.67 144.86Z",
                fill: "url(#paint1_linear_1153_42742)",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint2_linear_1153_42742)",
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M128 81h18v32h-18z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 24,
                height: 6,
                rx: 3,
                transform: "matrix(1 0 0 -1 125 82)",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m100 78 68 56H32l68-56Z",
                fill: "url(#paint3_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#7958FF",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "url(#paint4_linear_1153_42742)",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73 170c0-14.912 12.088-27 27-27s27 12.088 27 27v48H73v-48Z",
                fill: "url(#paint5_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M100 151c-9.477 0-17.333 6.938-18.766 16.012C80.975 168.648 82.344 170 84 170h32c1.657 0 3.025-1.352 2.766-2.988C117.333 157.938 109.477 151 100 151Z",
                fill: "url(#paint6_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                filter: "url(#filter0_i_1153_42742)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "#FEDEAC"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint7_linear_1153_42742)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint8_linear_1153_42742)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 81,
                y: 176,
                width: 40,
                height: 34,
                rx: 3,
                fill: "url(#paint9_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 113,
                y: 183,
                width: 4,
                height: 9,
                rx: 2,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M33 224h138v-3a3 3 0 0 0-3-3H36a3 3 0 0 0-3 3v3Z",
                fill: "url(#paint10_linear_1153_42742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M134 156h1.5a2 2 0 0 1 2 2v58a2 2 0 0 1-2 2H88l46-62Z",
                fill: "url(#paint11_linear_1153_42742)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "#7958FF",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "url(#paint12_linear_1153_42742)",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 162,
                y: 203,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 162,
                y: 193,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 172,
                y: 165,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 184,
                cy: 172,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M178 181a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m95.768 71.846 1.056-.866a3 3 0 0 1 3.804 0l1.057.866L171.5 129a3 3 0 0 1 .374 4.275l-1.302 1.516a3 3 0 0 1-4.178.365l-65.766-53.834a3 3 0 0 0-3.804 0l-65.718 53.834a3 3 0 0 1-4.177-.365l-1.302-1.516A3 3 0 0 1 26 129l69.768-57.154Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.345 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.07 0 .125.057.125.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.967-3.442-1.998 3.425a.125.125 0 0 1-.171.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.253c0-.069.056-.124.125-.124l3.965.018-1.967-3.443a.125.125 0 0 1 .047-.171l1.956-1.118a.126.126 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m237.791 81-1.194 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.83 2.83 0 0 1-3.759 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 61.962 61.412)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1153_42742",
                        x1: 34.042,
                        y1: 59.039,
                        x2: 197.175,
                        y2: 112,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFEEDC",
                                stopOpacity: 0.7
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1153_42742",
                        x1: 26.861,
                        y1: 223.869,
                        x2: 41.649,
                        y2: 140.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_1153_42742",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F9F4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_1153_42742",
                        x1: 137,
                        y1: 94.5,
                        x2: 59,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#947DFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AF9EFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_1153_42742",
                        x1: 58,
                        y1: 232,
                        x2: 152,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A896FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7958FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_1153_42742",
                        x1: 86,
                        y1: 145,
                        x2: 131,
                        y2: 247,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C1B3FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#8F77FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_1153_42742",
                        x1: 128.5,
                        y1: 159.382,
                        x2: 81,
                        y2: 159.382,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_1153_42742",
                        x1: 100.535,
                        y1: 114.507,
                        x2: 90.816,
                        y2: 103.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_1153_42742",
                        x1: 103.573,
                        y1: 117.471,
                        x2: 91.971,
                        y2: 104.37,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_1153_42742",
                        x1: 131,
                        y1: 191,
                        x2: 81,
                        y2: 191,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FAD5AB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F9C68B"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_1153_42742",
                        x1: 32,
                        y1: 220.5,
                        x2: 139,
                        y2: 218,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#8366FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A59FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_1153_42742",
                        x1: 139.409,
                        y1: 184.414,
                        x2: 94.106,
                        y2: 215.483,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_1153_42742",
                        x1: 203,
                        y1: 128.5,
                        x2: 141.012,
                        y2: 295.361,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_i_1153_42742",
                        x: 84.138,
                        y: 98.881,
                        width: 23.685,
                        height: 24.005,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_1153_42742"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $9b697ffbb6ba0ac4$export$2e2bcd8739ae039 = $9b697ffbb6ba0ac4$var$SvgTenantLandingPageDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $93d6fded062683d5$var$SvgTenantLandingPage = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M25.814 221.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.732 27.416 4.155-3.285 12.107-7.058 12.107-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint0_linear_1153_42741)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.882 224h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M178.578 85.035c-17.716.74-32.401 13.21-36.49 29.848-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h15.663C141.577 187.307 121.304 196 99 196c-46.392 0-84-37.608-84-84s37.608-84 84-84c36.96 0 68.344 23.87 79.578 57.035Z",
                fill: "url(#paint1_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint2_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M128 81h18v32h-18z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 24,
                height: 6,
                rx: 3,
                transform: "matrix(1 0 0 -1 125 82)",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m100 78 68 56H32l68-56Z",
                fill: "url(#paint3_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#7958FF",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "url(#paint4_linear_1153_42741)",
                d: "M37 134h126v84H37z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M73 170c0-14.912 12.088-27 27-27s27 12.088 27 27v48H73v-48Z",
                fill: "url(#paint5_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M100 151c-9.477 0-17.333 6.938-18.766 16.012C80.975 168.648 82.344 170 84 170h32c1.657 0 3.025-1.352 2.766-2.988C117.333 157.938 109.477 151 100 151Z",
                fill: "url(#paint6_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                filter: "url(#filter0_i_1153_42741)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "#FEDEAC"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M98.576 107.87a3 3 0 1 0 .257-4.235 3 3 0 0 0-.257 4.235Zm6.887 3.252a7.003 7.003 0 0 1-8.338.705l-4.45 3.941.645.729a1 1 0 0 1-.085 1.412l-1.498 1.326a1 1 0 0 1-1.411-.086l-.646-.729-2.216 1.963a2 2 0 1 1-2.652-2.994l9.661-8.556a7 7 0 1 1 10.99 2.289Z",
                        fill: "url(#paint7_linear_1153_42741)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 81,
                y: 176,
                width: 40,
                height: 34,
                rx: 3,
                fill: "url(#paint8_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 113,
                y: 183,
                width: 4,
                height: 9,
                rx: 2,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M33 224h138v-3a3 3 0 0 0-3-3H36a3 3 0 0 0-3 3v3Z",
                fill: "url(#paint9_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M134 156h1.5a2 2 0 0 1 2 2v58a2 2 0 0 1-2 2H88l46-62Z",
                fill: "url(#paint10_linear_1153_42741)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "#7958FF",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 137,
                y: 153,
                width: 94,
                height: 68,
                rx: 5,
                stroke: "url(#paint11_linear_1153_42741)",
                strokeWidth: 6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 162,
                y: 203,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 162,
                y: 193,
                width: 44,
                height: 6,
                rx: 2,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 172,
                y: 165,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 184,
                cy: 172,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M178 181a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "m95.768 71.846 1.056-.866a3 3 0 0 1 3.804 0l1.057.866L171.5 129a3 3 0 0 1 .374 4.275l-1.302 1.516a3 3 0 0 1-4.178.365l-65.766-53.834a3 3 0 0 0-3.804 0l-65.718 53.834a3 3 0 0 1-4.177-.365l-1.302-1.516A3 3 0 0 1 26 129l69.768-57.154Z",
                fill: "url(#paint12_linear_1153_42741)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.345 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.07 0 .125.057.125.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.967-3.442-1.998 3.425a.125.125 0 0 1-.171.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.253c0-.069.056-.124.125-.124l3.965.018-1.967-3.443a.125.125 0 0 1 .047-.171l1.956-1.118a.126.126 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m237.791 81-1.194 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.83 2.83 0 0 1-3.759 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 61.962 61.412)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1153_42741",
                        x1: 26.861,
                        y1: 223.869,
                        x2: 41.649,
                        y2: 140.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1153_42741",
                        x1: 34.042,
                        y1: 59.039,
                        x2: 197.175,
                        y2: 112,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFEEDC",
                                stopOpacity: 0.7
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_1153_42741",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_1153_42741",
                        x1: 137,
                        y1: 94.5,
                        x2: 59,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#947DFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AF9EFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_1153_42741",
                        x1: 58,
                        y1: 232,
                        x2: 152,
                        y2: 134,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A896FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7958FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_1153_42741",
                        x1: 86,
                        y1: 145,
                        x2: 127,
                        y2: 221,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#947DFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_1153_42741",
                        x1: 134.5,
                        y1: 159.382,
                        x2: 81,
                        y2: 159.382,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_1153_42741",
                        x1: 100.535,
                        y1: 114.507,
                        x2: 90.816,
                        y2: 103.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_1153_42741",
                        x1: 131,
                        y1: 191,
                        x2: 81,
                        y2: 191,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFDDB5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFCE94"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_1153_42741",
                        x1: 32,
                        y1: 220.5,
                        x2: 139,
                        y2: 218,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#8366FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7A59FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_1153_42741",
                        x1: 139.409,
                        y1: 184.414,
                        x2: 94.106,
                        y2: 215.483,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_1153_42741",
                        x1: 203,
                        y1: 128.5,
                        x2: 141.012,
                        y2: 295.361,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_1153_42741",
                        x1: 47.404,
                        y1: 102.84,
                        x2: 148.131,
                        y2: 102.84,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#8365FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#6C48FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_i_1153_42741",
                        x: 84.138,
                        y: 98.881,
                        width: 23.685,
                        height: 24.005,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feOffset", {
                                dy: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                stdDeviation: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: -1,
                                k3: 1
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_1153_42741"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $93d6fded062683d5$export$2e2bcd8739ae039 = $93d6fded062683d5$var$SvgTenantLandingPage;




var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $93h5F = parcelRequire("93h5F");
var $f1dddb8cf503cedc$export$2ba01fb71ed41cb6;
var $f1dddb8cf503cedc$export$6d59db4903f20f7d;
var $f1dddb8cf503cedc$export$5c452ff88e35e47d;
var $f1dddb8cf503cedc$export$c7187bbd1a7a9244;
var $f1dddb8cf503cedc$export$bfd64c937657f93a;
var $f1dddb8cf503cedc$export$4a6dd88bada4e7d2;
var $f1dddb8cf503cedc$export$fb184b623420d9be;
$f1dddb8cf503cedc$export$2ba01fb71ed41cb6 = `XR1RoW_button`;
$f1dddb8cf503cedc$export$6d59db4903f20f7d = `XR1RoW_description`;
$f1dddb8cf503cedc$export$5c452ff88e35e47d = `XR1RoW_image`;
$f1dddb8cf503cedc$export$c7187bbd1a7a9244 = `XR1RoW_placeholder`;
$f1dddb8cf503cedc$export$bfd64c937657f93a = `XR1RoW_rotating`;
$f1dddb8cf503cedc$export$4a6dd88bada4e7d2 = `XR1RoW_shimmer`;
$f1dddb8cf503cedc$export$fb184b623420d9be = `XR1RoW_title`;


function $983096dbb3de20c0$var$TenantLandingPageContent({ className: className }) {
    const { tenants: tenants, prependTenant: prependTenant, navigateTenant: navigateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const theme = (0, $93h5F.default)();
    const [isCreateModalOpen, setIsCreateModalOpen] = (0, $eCoWV.useState)(false);
    if (tenants.length > 0) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f1dddb8cf503cedc$export$c7187bbd1a7a9244, className),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $f1dddb8cf503cedc$export$5c452ff88e35e47d,
                        children: theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93d6fded062683d5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9b697ffbb6ba0ac4$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $f1dddb8cf503cedc$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.tenant_landing_page.title"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $f1dddb8cf503cedc$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.tenant_landing_page.description"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "tenants.tenant_landing_page.create_tenant_button",
                        type: "primary",
                        size: "large",
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                        className: $f1dddb8cf503cedc$export$2ba01fb71ed41cb6,
                        onClick: ()=>{
                            setIsCreateModalOpen(true);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $708876a8f61ed096$export$2e2bcd8739ae039), {
                isOpen: isCreateModalOpen,
                onClose: async (tenant)=>{
                    if (tenant) {
                        prependTenant(tenant);
                        navigateTenant(tenant.id);
                    }
                    setIsCreateModalOpen(false);
                }
            })
        ]
    });
}
var $983096dbb3de20c0$export$2e2bcd8739ae039 = $983096dbb3de20c0$var$TenantLandingPageContent;


var $51bd91fc8b8d6f0b$export$2ba01fb71ed41cb6;
var $51bd91fc8b8d6f0b$export$6d59db4903f20f7d;
var $51bd91fc8b8d6f0b$export$5c452ff88e35e47d;
var $51bd91fc8b8d6f0b$export$9bfd64464b8f45a7;
var $51bd91fc8b8d6f0b$export$c7187bbd1a7a9244;
var $51bd91fc8b8d6f0b$export$bfd64c937657f93a;
var $51bd91fc8b8d6f0b$export$4a6dd88bada4e7d2;
var $51bd91fc8b8d6f0b$export$fb184b623420d9be;
$51bd91fc8b8d6f0b$export$2ba01fb71ed41cb6 = `_81FlKG_button`;
$51bd91fc8b8d6f0b$export$6d59db4903f20f7d = `_81FlKG_description`;
$51bd91fc8b8d6f0b$export$5c452ff88e35e47d = `_81FlKG_image`;
$51bd91fc8b8d6f0b$export$9bfd64464b8f45a7 = `_81FlKG_pageContainer`;
$51bd91fc8b8d6f0b$export$c7187bbd1a7a9244 = `_81FlKG_placeholder`;
$51bd91fc8b8d6f0b$export$bfd64c937657f93a = `_81FlKG_rotating`;
$51bd91fc8b8d6f0b$export$4a6dd88bada4e7d2 = `_81FlKG_shimmer`;
$51bd91fc8b8d6f0b$export$fb184b623420d9be = `_81FlKG_title`;


function $56411b3b7f2f65ee$var$TenantLandingPage() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $51bd91fc8b8d6f0b$export$9bfd64464b8f45a7,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c55ce026a9f50563$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $983096dbb3de20c0$export$2e2bcd8739ae039), {
                className: $51bd91fc8b8d6f0b$export$c7187bbd1a7a9244
            })
        ]
    });
}
var $56411b3b7f2f65ee$export$2e2bcd8739ae039 = $56411b3b7f2f65ee$var$TenantLandingPage;


function $07cdbf5492e45cde$export$2e2bcd8739ae039() {
    const { isLoaded: isLoaded } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const { isOnboarding: isOnboarding } = (0, $abb531754ca753b0$export$2e2bcd8739ae039)();
    const { defaultTenantId: defaultTenantId } = (0, $04fdf6fb7d151380$export$2e2bcd8739ae039)();
    if (!isLoaded) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
    // If current tenant ID is not set, but the defaultTenantId is available.
    if (defaultTenantId) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3115c8d2e23a015a$export$2e2bcd8739ae039), {
        toTenantId: defaultTenantId
    });
    // A new user has just signed up and has no tenant, needs to create a new tenant.
    if (isOnboarding) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $274536d386802fb9$export$2e2bcd8739ae039), {});
    // If user has completed onboarding and still has no tenant, redirect to a special landing page.
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $56411b3b7f2f65ee$export$2e2bcd8739ae039), {});
}



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $8pPfi = parcelRequire("8pPfi");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $478091f8c43e559f$var$SvgCongratsDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 208c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Zm0-40c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40Z",
                fill: "#434966"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m71.32 82.22 3.73-4.254a5.657 5.657 0 0 0-.525-7.983v0A5.657 5.657 0 0 1 74 62v0a5.657 5.657 0 0 0-.525-7.983v0a5.657 5.657 0 0 1-.524-7.983l3.729-4.253",
                stroke: "#81A281",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 89,
                y: 44.156,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(-30.649 89 44.156)",
                fill: "#B68FB9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#B6A2B8",
                d: "m217.074 72.576 6.506 4.655-4.654 6.506-6.507-4.655z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#B98EBC",
                d: "M142 128h24v24h-24z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M120.586 58a.16.16 0 0 1 .147-.234l17.91.638a.16.16 0 0 1 .13.244l-9.507 15.192a.16.16 0 0 1-.277-.01L120.586 58Z",
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M172.277 123.132a.208.208 0 0 1 .245-.264l22.691 5.205a.208.208 0 0 1 .106.344l-15.853 17.049a.208.208 0 0 1-.351-.081l-6.838-22.253Z",
                fill: "#85C086"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.663 86.334c0-.185.149-.334.334-.334h6.008c.184 0 .333.15.333.334v10.573l9.157-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.156 5.287c.16.092.215.296.123.456l-3.004 5.203a.335.335 0 0 1-.456.122l-9.157-5.286v10.573a.334.334 0 0 1-.333.334h-6.008a.334.334 0 0 1-.334-.334V108.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.158-5.287a.334.334 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.158 5.287V86.334Z",
                fill: "#7075CB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M152.2 124.399c10.603 0 19.199-8.596 19.199-19.199 0-10.604-8.596-19.2-19.199-19.2-10.604 0-19.2 8.596-19.2 19.2 0 10.603 8.596 19.199 19.2 19.199Zm0-9.6a9.598 9.598 0 0 0 9.599-9.599 9.6 9.6 0 1 0-19.199 0c0 5.302 4.298 9.599 9.6 9.599Z",
                fill: "#EFD2AA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M40 64a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#948E86"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218 41a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#AEA090"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M126.596 48a80.03 80.03 0 0 1 22.5 3.208c18.187 5.32 33.691 16.925 44 32.305m-5.279 95.987a80.4 80.4 0 0 1-23.221 18.916 79.431 79.431 0 0 1-15.5 6.376 80.02 80.02 0 0 1-22.5 3.208c-18.689 0-35.882-6.409-49.5-17.149C62.256 179.148 51.661 162.301 48 143m13.136-61a79.9 79.9 0 0 0-7.438 13 79.406 79.406 0 0 0-4.832 14",
                stroke: "#555D86",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M69.233 218.378c-.326 3.412 3.51 5.626 6.302 3.639l93.475-66.552c2.372-1.689 2.202-5.266-.32-6.722l-82.578-47.677c-2.522-1.456-5.705.185-5.981 3.085L69.233 218.378Z",
                fill: "url(#paint0_linear_277_11257)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_277_11257",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 69,
                y: 100,
                width: 102,
                height: 123,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M69.233 218.378c-.326 3.412 3.51 5.626 6.302 3.639l93.475-66.552c2.372-1.689 2.202-5.266-.32-6.722l-82.578-47.677c-2.522-1.456-5.705.186-5.981 3.085L69.233 218.378Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_277_11257)",
                fill: "#E0A1E9",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 57.255,
                        y: 123.748,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 37.255,
                        y: 158.389,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 17.255,
                        y: 193.03,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m165.054 60.642 4.307-3.668A5.657 5.657 0 0 0 170 49v0a5.657 5.657 0 0 1 .64-7.974l4.306-3.668",
                stroke: "#8288A6",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m169 82.42 5.61.727a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.885v0a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.884l5.61.726",
                stroke: "#B0A7D9",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m122.186 33.626-1.365-5.49a5.657 5.657 0 0 1 4.125-6.855v0a5.656 5.656 0 0 0 4.125-6.854l-1.365-5.49",
                stroke: "#68617E",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m190.03 114.09 3.985-4.015a5.657 5.657 0 0 1 8-.03v0a5.657 5.657 0 0 0 8-.03L214 106",
                stroke: "#958CB2",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_277_11257",
                    x1: 67.5,
                    y1: 223.5,
                    x2: 173.05,
                    y2: 155.153,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5E49DC"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D279FC"
                        })
                    ]
                })
            })
        ]
    });
var $478091f8c43e559f$export$2e2bcd8739ae039 = $478091f8c43e559f$var$SvgCongratsDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $2f1758de09de54a0$var$SvgCongrats = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 208c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80Zm0-40c22.091 0 40-17.909 40-40s-17.909-40-40-40-40 17.909-40 40 17.909 40 40 40Z",
                fill: "#5D34F2",
                fillOpacity: 0.06
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M51.13 109.731a78.572 78.572 0 0 1 11.711-26.39m64.241-34.335c.329-.004.659-.006.989-.006 27.079 0 50.979 13.602 65.229 34.341m-143 58.978C57.042 179.114 89.297 207 128.071 207c23.884 0 45.296-10.582 59.793-27.31",
                stroke: "#5D34F2",
                strokeOpacity: 0.08,
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m71.32 82.22 3.73-4.254a5.657 5.657 0 0 0-.525-7.983v0A5.657 5.657 0 0 1 74 62v0a5.657 5.657 0 0 0-.525-7.982v0a5.657 5.657 0 0 1-.524-7.983l3.729-4.254",
                stroke: "#FFD5FF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 108,
                y: 62.156,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(-30.649 108 62.156)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 217.074,
                y: 72.576,
                width: 8,
                height: 8,
                rx: 4,
                transform: "rotate(35.58 217.074 72.576)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142,
                y: 128,
                width: 24,
                height: 24,
                rx: 4,
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.663 86.334c0-.185.149-.334.334-.334h6.008c.184 0 .333.15.333.334v10.573l9.157-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.156 5.287c.16.092.215.296.123.456l-3.004 5.203a.335.335 0 0 1-.456.122l-9.157-5.287v10.574a.334.334 0 0 1-.333.334h-6.008a.334.334 0 0 1-.334-.334V108.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.158-5.287a.334.334 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.158 5.287V86.334Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M152.2 124.399c10.603 0 19.199-8.596 19.199-19.199 0-10.604-8.596-19.2-19.199-19.2-10.604 0-19.2 8.596-19.2 19.2 0 10.603 8.596 19.199 19.2 19.199Zm0-9.6a9.598 9.598 0 0 0 9.599-9.599 9.6 9.6 0 1 0-19.199 0c0 5.302 4.298 9.599 9.6 9.599ZM40 64a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218 41a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M69.234 218.379c-.326 3.411 3.51 5.626 6.302 3.638l93.475-66.551c2.372-1.69 2.202-5.267-.32-6.723l-82.578-47.676c-2.522-1.456-5.705.185-5.981 3.084L69.234 218.379Z",
                fill: "url(#paint0_linear_8592_115169)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_8592_115169",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 69,
                y: 100,
                width: 102,
                height: 123,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M69.234 218.379c-.325 3.411 3.51 5.626 6.302 3.638l93.475-66.551c2.373-1.69 2.202-5.267-.32-6.723l-82.577-47.676c-2.523-1.456-5.706.185-5.982 3.084L69.234 218.379Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_8592_115169)",
                fill: "#EA9DF4",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 57.256,
                        y: 123.748,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 37.256,
                        y: 158.39,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 17.256,
                        y: 193.03,
                        width: 128,
                        height: 16,
                        rx: 1.28
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m165.055 60.642 4.307-3.668a5.657 5.657 0 0 0 .639-7.974v0a5.658 5.658 0 0 1 .639-7.975l4.307-3.667",
                stroke: "#C4C7C7",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m169 82.42 5.61.727a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.885v0a5.657 5.657 0 0 0 6.336-4.884v0a5.657 5.657 0 0 1 6.336-4.884l5.61.726",
                stroke: "#CABEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m122.186 33.626-1.365-5.49a5.657 5.657 0 0 1 4.125-6.854v0a5.656 5.656 0 0 0 4.125-6.855l-1.365-5.49M192.031 144.091l3.985-4.015a5.656 5.656 0 0 1 8-.03v0a5.657 5.657 0 0 0 8-.03l3.985-4.015",
                stroke: "#E6DEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_8592_115169",
                    x1: 67.501,
                    y1: 223.5,
                    x2: 173.051,
                    y2: 155.154,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $2f1758de09de54a0$export$2e2bcd8739ae039 = $2f1758de09de54a0$var$SvgCongrats;



var $1UQTm = parcelRequire("1UQTm");

var $93h5F = parcelRequire("93h5F");
var $dfacccda4a4da109$export$aa3e815946b80764;
var $dfacccda4a4da109$export$34e0f9847d4c02dd;
var $dfacccda4a4da109$export$a8ecead220dd38a6;
var $dfacccda4a4da109$export$bfd64c937657f93a;
var $dfacccda4a4da109$export$4a6dd88bada4e7d2;
var $dfacccda4a4da109$export$fb184b623420d9be;
$dfacccda4a4da109$export$aa3e815946b80764 = `k1s4KG_card`;
$dfacccda4a4da109$export$34e0f9847d4c02dd = `k1s4KG_container`;
$dfacccda4a4da109$export$a8ecead220dd38a6 = `k1s4KG_message`;
$dfacccda4a4da109$export$bfd64c937657f93a = `k1s4KG_rotating`;
$dfacccda4a4da109$export$4a6dd88bada4e7d2 = `k1s4KG_shimmer`;
$dfacccda4a4da109$export$fb184b623420d9be = `k1s4KG_title`;


function $006969e0dcfc9cfc$var$SocialDemoCallback() {
    const theme = (0, $93h5F.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [searchParams, setSearchParams] = (0, $8pPfi.useSearchParams)();
    (0, $eCoWV.useEffect)(()=>{
        // Social callback will have "code" in query params
        if (searchParams.get("code")) setSearchParams({}, {
            replace: true
        });
    }, [
        searchParams,
        setSearchParams
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $dfacccda4a4da109$export$34e0f9847d4c02dd,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
            className: $dfacccda4a4da109$export$aa3e815946b80764,
            children: [
                theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2f1758de09de54a0$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $478091f8c43e559f$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $dfacccda4a4da109$export$fb184b623420d9be,
                    children: t("cloud.socialCallback.title")
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $dfacccda4a4da109$export$a8ecead220dd38a6,
                    children: t("cloud.socialCallback.description")
                })
            ]
        })
    });
}
var $006969e0dcfc9cfc$export$2e2bcd8739ae039 = $006969e0dcfc9cfc$var$SocialDemoCallback;


/** Renders necessary routes when the user is not in a tenant context. */ function $1239d6b35d459e42$var$AppRoutes() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $b2c3a31f968292bb$export$729c8b7179294ba,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Routes), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                    path: (0, $2wPYZ.GlobalAnonymousRoute).Callback,
                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ba8f7455b3577687$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                    path: (0, $2wPYZ.GlobalAnonymousRoute).SocialDemoCallback,
                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $006969e0dcfc9cfc$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a56066727231a650$export$2e2bcd8739ae039), {}),
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: (0, $2wPYZ.GlobalRoute).CheckoutSuccessCallback,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dfc4f3fe135b4f83$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $07cdbf5492e45cde$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
}
var $1239d6b35d459e42$export$2e2bcd8739ae039 = $1239d6b35d459e42$var$AppRoutes;




var $V1X8c = parcelRequire("V1X8c");

var $5Q2pm = parcelRequire("5Q2pm");

parcelRequire("jZDWq");
var $dnZfV = parcelRequire("dnZfV");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $eCoWV = parcelRequire("eCoWV");
class $b53d2d1f9b4f7a6d$var$NoIdTokenClaimsError extends Error {
    constructor(...args){
        super(...args);
        this.name = "NoIdTokenClaimsError";
        this.message = "Cloud not fetch ID Token claims where user is authenticated.";
    }
}
const $b53d2d1f9b4f7a6d$var$useTrackUserId = ()=>{
    const { isAuthenticated: isAuthenticated, getIdTokenClaims: getIdTokenClaims } = (0, $dtOpc.useLogto)();
    const { isSetupFinished: isSetupFinished, appInsights: appInsights } = (0, $eCoWV.useContext)((0, $dnZfV.AppInsightsContext));
    (0, $eCoWV.useEffect)(()=>{
        const setUserId = async ()=>{
            if (!appInsights.instance) return;
            if (!isAuthenticated) {
                appInsights.instance.clearAuthenticatedUserContext();
                return;
            }
            const claims = await (0, $aWIy6.trySafe)(getIdTokenClaims());
            if (claims) appInsights.instance.setAuthenticatedUserContext(claims.sub, claims.sub, true);
            else appInsights.instance.trackException({
                exception: new $b53d2d1f9b4f7a6d$var$NoIdTokenClaimsError()
            });
        };
        if (isSetupFinished) setUserId();
    }, [
        getIdTokenClaims,
        isSetupFinished,
        isAuthenticated,
        appInsights.instance
    ]);
};
var $b53d2d1f9b4f7a6d$export$2e2bcd8739ae039 = $b53d2d1f9b4f7a6d$var$useTrackUserId;



var $9zeGj = parcelRequire("9zeGj");

var $dusqy = parcelRequire("dusqy");
parcelRequire("jZDWq");
var $iuOAe = parcelRequire("iuOAe");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $a7rB2 = parcelRequire("a7rB2");

parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");
const $ee28be77263e99bc$export$7e9b8aa268c9f6e = "AW-11124811245";
const $ee28be77263e99bc$export$3d9d3c2cf92f99c1 = `AW-11192640559/ZuqUCLvNpasYEK_IiNkp`;
const $ee28be77263e99bc$var$logtoProductionHostname = "logto.io";
const $ee28be77263e99bc$var$linkedInPartnerId = "5096172";
const $ee28be77263e99bc$export$ce2aaa7865a21cd1 = "13374828";
const $ee28be77263e99bc$export$e4409b62080e611 = window.location.hostname.endsWith("." + $ee28be77263e99bc$var$logtoProductionHostname);
function $ee28be77263e99bc$export$43d7ed11b62812a(..._) {
    (0, $aWIy6.trySafe)(()=>{
        // We cannot use rest params here since gtag has some internal logic about `arguments` for data transpiling
        if (!window.dataLayer) window.dataLayer = [];
        window.dataLayer.push(arguments);
    });
}
function $ee28be77263e99bc$export$f35a06dec600ffa(..._) {
    // Init LinkedIn tag if needed
    if (!window._linkedin_data_partner_ids) {
        window._linkedin_data_partner_ids = [];
        window._linkedin_data_partner_ids.push($ee28be77263e99bc$var$linkedInPartnerId);
    }
    (0, $aWIy6.trySafe)(()=>{
        if (!window.lintrk) window.lintrk = {
            q: []
        };
        window.lintrk.q.push(arguments);
    });
}
const $ee28be77263e99bc$export$2cb26a492a43576c = async (email)=>{
    if (!email) return;
    const splitEmail = email.toLocaleLowerCase().trim().split("@");
    const [localPart, domain] = splitEmail;
    if (!localPart || !domain || splitEmail.length > 2) return;
    // eslint-disable-next-line unicorn/prefer-string-replace-all
    const canonicalizedEmail = `${localPart.replace(/\./g, "").replace(/\+.*/, "")}@${domain}`;
    const hash = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(canonicalizedEmail));
    // https://stackoverflow.com/questions/40031688/javascript-arraybuffer-to-hex
    return [
        ...new Uint8Array(hash)
    ].map((value)=>value.toString(16).padStart(2, "0")).join("");
};
const $ee28be77263e99bc$export$1a0493764955a0a9 = "t2_ggt11omdo";
function $ee28be77263e99bc$export$4875eb20400dd795(..._) {
    (0, $aWIy6.trySafe)(()=>{
        if (!window.rdt) window.rdt = {
            callQueue: []
        };
        window.rdt.callQueue.push(arguments);
    });
} /* eslint-enable @silverhand/fp/no-mutation, @silverhand/fp/no-mutating-methods, prefer-rest-params */ 


function $5fb1a9eb989bb9ff$export$2e2bcd8739ae039() {
    const { user: user, isLoading: isLoading } = (0, $475a856ff8d4300b$export$2e2bcd8739ae039)();
    /**
   * Initiate Reddit Pixel and report a sign-up conversion to it when user is loaded.
   * Use user email to prevent duplicate conversion, and it is hashed before sending
   * to protect user privacy.
   */ (0, $eCoWV.useEffect)(()=>{
        const report = async ()=>{
            (0, $ee28be77263e99bc$export$4875eb20400dd795)("init", (0, $ee28be77263e99bc$export$1a0493764955a0a9), {
                optOut: false,
                useDecimalCurrencyValues: true,
                email: await (0, $ee28be77263e99bc$export$2cb26a492a43576c)(user?.primaryEmail ?? undefined)
            });
            (0, $ee28be77263e99bc$export$4875eb20400dd795)("track", "SignUp");
        };
        if ((0, $ee28be77263e99bc$export$e4409b62080e611) && !isLoading) report();
    }, [
        user,
        isLoading
    ]);
    /**
   * This `useEffect()` initiates Google Tag and report a sign-up conversion to it.
   * It may run multiple times (e.g. a user visit multiple times to finish the onboarding process,
   * which rarely happens), but it'll be okay since we've set conversion's "Count" to "One"
   * which means only the first interaction is valuable.
   *
   * Track this conversion in the backend has been considered, but Google does not provide
   * a clear guideline for it and marks the [Node library](https://developers.google.com/tag-platform/tag-manager/api/v2/libraries)
   * as "alpha" which looks unreliable.
   */ (0, $eCoWV.useEffect)(()=>{
        if (0, $ee28be77263e99bc$export$e4409b62080e611) {
            (0, $ee28be77263e99bc$export$43d7ed11b62812a)("js", new Date());
            (0, $ee28be77263e99bc$export$43d7ed11b62812a)("config", (0, $ee28be77263e99bc$export$7e9b8aa268c9f6e));
            (0, $ee28be77263e99bc$export$43d7ed11b62812a)("event", "conversion", {
                send_to: (0, $ee28be77263e99bc$export$3d9d3c2cf92f99c1)
            });
            (0, $ee28be77263e99bc$export$f35a06dec600ffa)("track", {
                conversion_id: (0, $ee28be77263e99bc$export$ce2aaa7865a21cd1)
            });
            console.debug("Have a good day!");
        } else console.debug("Not reporting conversion because it's not production");
    }, []);
    if (0, $ee28be77263e99bc$export$e4409b62080e611) return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $a7rB2.Helmet), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("script", {
                async: true,
                crossOrigin: "anonymous",
                src: `https://www.googletagmanager.com/gtag/js?id=${(0, $ee28be77263e99bc$export$7e9b8aa268c9f6e)}`
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("script", {
                async: true,
                src: "https://snap.licdn.com/li.lms-analytics/insight.min.js"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("script", {
                async: true,
                src: "https://www.redditstatic.com/ads/pixel.js"
            })
        ]
    });
    return null;
}



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

function $82e95263df22bc9e$var$AppBoundary({ children: children }) {
    const { data: { language: language } } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const { i18n: i18n } = (0, $2A6IJ.useTranslation)();
    (0, $eCoWV.useEffect)(()=>{
        i18n.changeLanguage(language);
    }, [
        i18n,
        language
    ]);
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: children
    });
}
var $82e95263df22bc9e$export$2e2bcd8739ae039 = $82e95263df22bc9e$var$AppBoundary;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");


var $2wPYZ = parcelRequire("2wPYZ");
function $5f3e0712aacdcb31$export$2e2bcd8739ae039() {
    const { getAccessToken: getAccessToken, signIn: signIn, isAuthenticated: isAuthenticated } = (0, $dtOpc.useLogto)();
    const { currentTenant: currentTenant, currentTenantId: currentTenantId, currentTenantStatus: currentTenantStatus, setCurrentTenantStatus: setCurrentTenantStatus } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { mutate: mutate } = (0, $4Korf.useSWRConfig)();
    // Clean the cache when the current tenant ID changes. This is required because the
    // SWR cache key is not tenant-aware.
    (0, $eCoWV.useEffect)(()=>{
        mutate((key)=>typeof key !== "string" || key !== "me" && !key.includes("/.well-known/"), undefined, {
            rollbackOnError: false,
            throwOnError: false
        });
    }, [
        mutate,
        currentTenantId
    ]);
    (0, $eCoWV.useEffect)(()=>{
        const validate = async ({ indicator: indicator })=>{
            // Test fetching an access token for the current Tenant ID.
            // If failed, it means the user finishes the first auth, ands still needs to auth again to
            // fetch the full-scoped (with all available tenants) token.
            if (await (0, $aWIy6.trySafe)(getAccessToken(indicator))) setCurrentTenantStatus("validated");
        // If failed, it will be treated as a session expired error, and will be handled by the
        // upper `<ErrorBoundary />`.
        };
        if (isAuthenticated && currentTenantId && currentTenantStatus === "pending") {
            setCurrentTenantStatus("validating");
            // The current tenant is unavailable to the user, maybe a deleted tenant or a tenant that
            // the user has no access to. Fall back to the home page.
            if (!currentTenant) {
                // eslint-disable-next-line @silverhand/fp/no-mutation
                window.location.href = "/";
                return;
            }
            validate(currentTenant);
        }
    }, [
        currentTenant,
        currentTenantId,
        currentTenantStatus,
        getAccessToken,
        isAuthenticated,
        setCurrentTenantStatus,
        signIn
    ]);
    return currentTenantStatus === "validated" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}



var $1iAqo = parcelRequire("1iAqo");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $horhC = parcelRequire("horhC");

var $hEugJ = parcelRequire("hEugJ");

var $4KvY2 = parcelRequire("4KvY2");
var $1c1de16fb03eb20e$export$a3bc9b8ed74fc;
var $1c1de16fb03eb20e$export$5c452ff88e35e47d;
var $1c1de16fb03eb20e$export$a8ecead220dd38a6;
var $1c1de16fb03eb20e$export$bfd64c937657f93a;
var $1c1de16fb03eb20e$export$4a6dd88bada4e7d2;
var $1c1de16fb03eb20e$export$fe7c49d056ea1d88;
var $1c1de16fb03eb20e$export$b410431fab84fa58;
$1c1de16fb03eb20e$export$a3bc9b8ed74fc = `i5jzhG_error`;
$1c1de16fb03eb20e$export$5c452ff88e35e47d = `i5jzhG_image`;
$1c1de16fb03eb20e$export$a8ecead220dd38a6 = `i5jzhG_message`;
$1c1de16fb03eb20e$export$bfd64c937657f93a = `i5jzhG_rotating`;
$1c1de16fb03eb20e$export$4a6dd88bada4e7d2 = `i5jzhG_shimmer`;
$1c1de16fb03eb20e$export$fe7c49d056ea1d88 = `i5jzhG_success`;
$1c1de16fb03eb20e$export$b410431fab84fa58 = `i5jzhG_toast`;


function $600b624765f10fdd$var$Toast() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $horhC.Toaster), {
        toastOptions: {
            className: $1c1de16fb03eb20e$export$b410431fab84fa58,
            success: {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($1c1de16fb03eb20e$export$b410431fab84fa58, $1c1de16fb03eb20e$export$fe7c49d056ea1d88),
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4KvY2.default), {})
            },
            error: {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($1c1de16fb03eb20e$export$b410431fab84fa58, $1c1de16fb03eb20e$export$a3bc9b8ed74fc),
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hEugJ.default), {})
            }
        },
        children: (toastInstance)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: toastInstance.className,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1c1de16fb03eb20e$export$5c452ff88e35e47d,
                        children: toastInstance.icon
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1c1de16fb03eb20e$export$a8ecead220dd38a6,
                        children: (0, $horhC.resolveValue)(toastInstance.message, toastInstance)
                    })
                ]
            })
    });
}
var $600b624765f10fdd$export$2e2bcd8739ae039 = $600b624765f10fdd$var$Toast;



var $eCoWV = parcelRequire("eCoWV");

var $2ANSb = parcelRequire("2ANSb");

const $451ef8ec75a8d7c6$var$useSwrOptions = ()=>{
    const api = (0, $2ANSb.default)();
    const fetcher = (0, $9c44974c18641844$export$2e2bcd8739ae039)(api);
    const config = (0, $eCoWV.useMemo)(()=>({
            fetcher: fetcher,
            shouldRetryOnError: (error)=>{
                if (error instanceof (0, $2ANSb.RequestError)) {
                    const { status: status } = error;
                    return status !== 401 && status !== 403;
                }
                return true;
            }
        }), [
        fetcher
    ]);
    return config;
};
var $451ef8ec75a8d7c6$export$2e2bcd8739ae039 = $451ef8ec75a8d7c6$var$useSwrOptions;



var $4W0F0 = parcelRequire("4W0F0");

var $djktV = parcelRequire("djktV");

var $9zeGj = parcelRequire("9zeGj");

var $9X5Bp = parcelRequire("9X5Bp");

var $9zeGj = parcelRequire("9zeGj");

var $f9b420fc258278f8$export$db3c28d99448dcff;
var $f9b420fc258278f8$export$bfd64c937657f93a;
var $f9b420fc258278f8$export$4a6dd88bada4e7d2;
var $f9b420fc258278f8$export$42c68d6252221cac;
$f9b420fc258278f8$export$db3c28d99448dcff = `LvYW9G_logo`;
$f9b420fc258278f8$export$bfd64c937657f93a = `LvYW9G_rotating`;
$f9b420fc258278f8$export$4a6dd88bada4e7d2 = `LvYW9G_shimmer`;
$f9b420fc258278f8$export$42c68d6252221cac = `LvYW9G_topbar`;


function $8e688988c809f7c7$var$Topbar() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $f9b420fc258278f8$export$42c68d6252221cac,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4c269f96590333ef$export$2e2bcd8739ae039), {
            className: $f9b420fc258278f8$export$db3c28d99448dcff
        })
    });
}
var $8e688988c809f7c7$export$2e2bcd8739ae039 = $8e688988c809f7c7$var$Topbar;


var $26d541c20057791d$export$729c8b7179294ba;
var $26d541c20057791d$export$a7db06668cad9adb;
$26d541c20057791d$export$729c8b7179294ba = `VbL0Mq_app`;
$26d541c20057791d$export$a7db06668cad9adb = `VbL0Mq_content`;


function $903feabdde16c495$var$AppContent() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $26d541c20057791d$export$729c8b7179294ba,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8e688988c809f7c7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $26d541c20057791d$export$a7db06668cad9adb,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {})
            })
        ]
    });
}
var $903feabdde16c495$export$2e2bcd8739ae039 = $903feabdde16c495$var$AppContent;



var $b9701761636dc06f$export$729c8b7179294ba;
var $b9701761636dc06f$export$bfd64c937657f93a;
var $b9701761636dc06f$export$4a6dd88bada4e7d2;
$b9701761636dc06f$export$729c8b7179294ba = `E9EZ-a_app`;
$b9701761636dc06f$export$bfd64c937657f93a = `E9EZ-a_rotating`;
$b9701761636dc06f$export$4a6dd88bada4e7d2 = `E9EZ-a_shimmer`;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j7Jj8");
var $fU2Vo = parcelRequire("fU2Vo");
var $4at8B = parcelRequire("4at8B");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $7aae23f7be89a76b$var$SvgTools = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M12.13 13.1a1 1 0 0 1 1.414-1.414l9.193 9.193-1.414 1.414-9.192-9.193Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M8.596 10.98a2 2 0 1 1 2.828-2.828l2.829 2.827a2 2 0 1 1-2.829 2.828L8.596 10.98Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m17.082 25.122 8.485-8.486 12.728 12.728a6 6 0 0 1-8.485 8.485L17.082 25.122Z",
                fill: "url(#paint0_linear_389_78280)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.031,
                y: 25.829,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(-45 22.031 25.829)",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24.859,
                y: 23,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(-45 24.86 23)",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23.295 16.05a4 4 0 0 1 5.656 0l1.415 1.415a4 4 0 0 1 0 5.657L14.809 38.678a4 4 0 0 1-5.657 0l-1.414-1.414a4 4 0 0 1 0-5.657l15.557-15.556Z",
                fill: "url(#paint1_linear_389_78280)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 21.174,
                y: 23.829,
                width: 2,
                height: 16,
                rx: 1,
                transform: "rotate(45 21.174 23.83)",
                fill: "#B545CA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.64,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M24.002 22.415c3.905 3.905 10.237 3.905 14.142 0a9.976 9.976 0 0 0 2.906-7.754c-.098-1.439-1.808-1.83-2.827-.81l-2.908 2.907a2 2 0 0 1-2.828 0l-2.829-2.828a2 2 0 0 1 0-2.829l2.908-2.907c1.02-1.02.628-2.73-.81-2.827a9.977 9.977 0 0 0-7.754 2.906c-3.906 3.905-3.906 10.237 0 14.142Z",
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#F7F8F8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#78767F",
                strokeOpacity: 0.02
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 27,
                r: 1.5,
                stroke: "#5D34F2",
                strokeOpacity: 0.14
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.879,
                y: 40,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 19.879 40)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_389_78280",
                        x1: 33.213,
                        y1: 38.336,
                        x2: 37.634,
                        y2: 23.745,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_389_78280",
                        x1: 28.793,
                        y1: 16.207,
                        x2: 3.058,
                        y2: 23.267,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $7aae23f7be89a76b$export$2e2bcd8739ae039 = $7aae23f7be89a76b$var$SvgTools;



var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $ac6062b0b2a90ad9$export$89da14300d534261;
var $ac6062b0b2a90ad9$export$9d1298853f0e77f7;
var $ac6062b0b2a90ad9$export$bfd64c937657f93a;
var $ac6062b0b2a90ad9$export$4a6dd88bada4e7d2;
var $ac6062b0b2a90ad9$export$bb815eb3cca9af81;
$ac6062b0b2a90ad9$export$89da14300d534261 = `rhjZ5G_active`;
$ac6062b0b2a90ad9$export$9d1298853f0e77f7 = `rhjZ5G_progressBar`;
$ac6062b0b2a90ad9$export$bfd64c937657f93a = `rhjZ5G_rotating`;
$ac6062b0b2a90ad9$export$4a6dd88bada4e7d2 = `rhjZ5G_shimmer`;
$ac6062b0b2a90ad9$export$bb815eb3cca9af81 = `rhjZ5G_stepIndicator`;


function $de746c4dc43f8d54$var$ProgressBar({ currentStep: currentStep, totalSteps: totalSteps }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $ac6062b0b2a90ad9$export$9d1298853f0e77f7,
        children: Array.from({
            length: totalSteps
        }, (_, i)=>i + 1).map((step)=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($ac6062b0b2a90ad9$export$bb815eb3cca9af81, step <= currentStep && $ac6062b0b2a90ad9$export$89da14300d534261)
            }, step))
    });
}
var $de746c4dc43f8d54$export$2e2bcd8739ae039 = $de746c4dc43f8d54$var$ProgressBar;


var $31a7994ec9049f1d$export$e324594224ef24da;
var $31a7994ec9049f1d$export$34e0f9847d4c02dd;
var $31a7994ec9049f1d$export$bfd64c937657f93a;
var $31a7994ec9049f1d$export$4a6dd88bada4e7d2;
$31a7994ec9049f1d$export$e324594224ef24da = `V_YYMW_actions`;
$31a7994ec9049f1d$export$34e0f9847d4c02dd = `V_YYMW_container`;
$31a7994ec9049f1d$export$bfd64c937657f93a = `V_YYMW_rotating`;
$31a7994ec9049f1d$export$4a6dd88bada4e7d2 = `V_YYMW_shimmer`;


function $de0ac914cb204d1c$var$ActionBar({ step: step, totalSteps: totalSteps, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $31a7994ec9049f1d$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $de746c4dc43f8d54$export$2e2bcd8739ae039), {
                currentStep: step,
                totalSteps: totalSteps
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $31a7994ec9049f1d$export$e324594224ef24da,
                children: children
            })
        ]
    });
}
var $de0ac914cb204d1c$export$2e2bcd8739ae039 = $de0ac914cb204d1c$var$ActionBar;



var $a0Ubj = parcelRequire("a0Ubj");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");
var $30b13a56cd0faccc$exports = {};
"use strict";
Object.defineProperty($30b13a56cd0faccc$exports, "__esModule", {
    value: true
});
$30b13a56cd0faccc$exports.ReactCSS = $30b13a56cd0faccc$exports.loop = $30b13a56cd0faccc$exports.handleActive = $30b13a56cd0faccc$exports.handleHover = $30b13a56cd0faccc$exports.hover = undefined;
var $37fe9c1dabc054d3$exports = {};
"use strict";
Object.defineProperty($37fe9c1dabc054d3$exports, "__esModule", {
    value: true
});
$37fe9c1dabc054d3$exports.flattenNames = undefined;
var $58bed27071520d70$exports = {};
var $8f26fc8d3b90e8ac$exports = {};
var $a26231c658c479a7$exports = {};

var $jVTpz = parcelRequire("jVTpz");
/** Built-in value references. */ var $a26231c658c479a7$var$Symbol = $jVTpz.Symbol;
$a26231c658c479a7$exports = $a26231c658c479a7$var$Symbol;


var $e889b84f48999d32$exports = {};

/** Used for built-in method references. */ var $e889b84f48999d32$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e889b84f48999d32$var$hasOwnProperty = $e889b84f48999d32$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e889b84f48999d32$var$nativeObjectToString = $e889b84f48999d32$var$objectProto.toString;
/** Built-in value references. */ var $e889b84f48999d32$var$symToStringTag = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $e889b84f48999d32$var$getRawTag(value) {
    var isOwn = $e889b84f48999d32$var$hasOwnProperty.call(value, $e889b84f48999d32$var$symToStringTag), tag = value[$e889b84f48999d32$var$symToStringTag];
    try {
        value[$e889b84f48999d32$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $e889b84f48999d32$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$e889b84f48999d32$var$symToStringTag] = tag;
        else delete value[$e889b84f48999d32$var$symToStringTag];
    }
    return result;
}
$e889b84f48999d32$exports = $e889b84f48999d32$var$getRawTag;


var $e008466db1c6be3b$exports = {};
/** Used for built-in method references. */ var $e008466db1c6be3b$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $e008466db1c6be3b$var$nativeObjectToString = $e008466db1c6be3b$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $e008466db1c6be3b$var$objectToString(value) {
    return $e008466db1c6be3b$var$nativeObjectToString.call(value);
}
$e008466db1c6be3b$exports = $e008466db1c6be3b$var$objectToString;


/** `Object#toString` result references. */ var $8f26fc8d3b90e8ac$var$nullTag = "[object Null]", $8f26fc8d3b90e8ac$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $8f26fc8d3b90e8ac$var$symToStringTag = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $8f26fc8d3b90e8ac$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $8f26fc8d3b90e8ac$var$undefinedTag : $8f26fc8d3b90e8ac$var$nullTag;
    return $8f26fc8d3b90e8ac$var$symToStringTag && $8f26fc8d3b90e8ac$var$symToStringTag in Object(value) ? $e889b84f48999d32$exports(value) : $e008466db1c6be3b$exports(value);
}
$8f26fc8d3b90e8ac$exports = $8f26fc8d3b90e8ac$var$baseGetTag;


var $0731a2307bf9d7f9$exports = {};
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $0731a2307bf9d7f9$var$isArray = Array.isArray;
$0731a2307bf9d7f9$exports = $0731a2307bf9d7f9$var$isArray;


var $61068a3203fea8d0$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $61068a3203fea8d0$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
$61068a3203fea8d0$exports = $61068a3203fea8d0$var$isObjectLike;


/** `Object#toString` result references. */ var $58bed27071520d70$var$stringTag = "[object String]";
/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */ function $58bed27071520d70$var$isString(value) {
    return typeof value == "string" || !$0731a2307bf9d7f9$exports(value) && $61068a3203fea8d0$exports(value) && $8f26fc8d3b90e8ac$exports(value) == $58bed27071520d70$var$stringTag;
}
$58bed27071520d70$exports = $58bed27071520d70$var$isString;


var $37fe9c1dabc054d3$var$_isString3 = $37fe9c1dabc054d3$var$_interopRequireDefault($58bed27071520d70$exports);
var $ad6e8de3503db2ef$exports = {};
var $7684658affa33219$exports = {};
var $d7b9d98e4845cdf3$exports = {};
var $292b200439504c0e$exports = {};
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $292b200439504c0e$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
$292b200439504c0e$exports = $292b200439504c0e$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $d7b9d98e4845cdf3$var$baseFor = $292b200439504c0e$exports();
$d7b9d98e4845cdf3$exports = $d7b9d98e4845cdf3$var$baseFor;


var $69c7a2966b4129b5$exports = {};
var $774407bad52f3924$exports = {};
var $552f09a458871e37$exports = {};
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $552f09a458871e37$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
$552f09a458871e37$exports = $552f09a458871e37$var$baseTimes;


var $9f652b1571d8ed7c$exports = {};
var $35bb3729be47e098$exports = {};


/** `Object#toString` result references. */ var $35bb3729be47e098$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $35bb3729be47e098$var$baseIsArguments(value) {
    return $61068a3203fea8d0$exports(value) && $8f26fc8d3b90e8ac$exports(value) == $35bb3729be47e098$var$argsTag;
}
$35bb3729be47e098$exports = $35bb3729be47e098$var$baseIsArguments;



/** Used for built-in method references. */ var $9f652b1571d8ed7c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $9f652b1571d8ed7c$var$hasOwnProperty = $9f652b1571d8ed7c$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $9f652b1571d8ed7c$var$propertyIsEnumerable = $9f652b1571d8ed7c$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $9f652b1571d8ed7c$var$isArguments = $35bb3729be47e098$exports(function() {
    return arguments;
}()) ? $35bb3729be47e098$exports : function(value) {
    return $61068a3203fea8d0$exports(value) && $9f652b1571d8ed7c$var$hasOwnProperty.call(value, "callee") && !$9f652b1571d8ed7c$var$propertyIsEnumerable.call(value, "callee");
};
$9f652b1571d8ed7c$exports = $9f652b1571d8ed7c$var$isArguments;




var $jrO3d = parcelRequire("jrO3d");
var $edcbf53930595f47$exports = {};
/** Used as references for various `Number` constants. */ var $edcbf53930595f47$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $edcbf53930595f47$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $edcbf53930595f47$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $edcbf53930595f47$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $edcbf53930595f47$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
$edcbf53930595f47$exports = $edcbf53930595f47$var$isIndex;


var $0623facb4d8a883e$exports = {};
var $cb564c048f7106d0$exports = {};

var $41671756f2bfb3b6$exports = {};
/** Used as references for various `Number` constants. */ var $41671756f2bfb3b6$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $41671756f2bfb3b6$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $41671756f2bfb3b6$var$MAX_SAFE_INTEGER;
}
$41671756f2bfb3b6$exports = $41671756f2bfb3b6$var$isLength;



/** `Object#toString` result references. */ var $cb564c048f7106d0$var$argsTag = "[object Arguments]", $cb564c048f7106d0$var$arrayTag = "[object Array]", $cb564c048f7106d0$var$boolTag = "[object Boolean]", $cb564c048f7106d0$var$dateTag = "[object Date]", $cb564c048f7106d0$var$errorTag = "[object Error]", $cb564c048f7106d0$var$funcTag = "[object Function]", $cb564c048f7106d0$var$mapTag = "[object Map]", $cb564c048f7106d0$var$numberTag = "[object Number]", $cb564c048f7106d0$var$objectTag = "[object Object]", $cb564c048f7106d0$var$regexpTag = "[object RegExp]", $cb564c048f7106d0$var$setTag = "[object Set]", $cb564c048f7106d0$var$stringTag = "[object String]", $cb564c048f7106d0$var$weakMapTag = "[object WeakMap]";
var $cb564c048f7106d0$var$arrayBufferTag = "[object ArrayBuffer]", $cb564c048f7106d0$var$dataViewTag = "[object DataView]", $cb564c048f7106d0$var$float32Tag = "[object Float32Array]", $cb564c048f7106d0$var$float64Tag = "[object Float64Array]", $cb564c048f7106d0$var$int8Tag = "[object Int8Array]", $cb564c048f7106d0$var$int16Tag = "[object Int16Array]", $cb564c048f7106d0$var$int32Tag = "[object Int32Array]", $cb564c048f7106d0$var$uint8Tag = "[object Uint8Array]", $cb564c048f7106d0$var$uint8ClampedTag = "[object Uint8ClampedArray]", $cb564c048f7106d0$var$uint16Tag = "[object Uint16Array]", $cb564c048f7106d0$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $cb564c048f7106d0$var$typedArrayTags = {};
$cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$float32Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$float64Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$int8Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$int16Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$int32Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$uint8Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$uint8ClampedTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$uint16Tag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$uint32Tag] = true;
$cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$argsTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$arrayTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$arrayBufferTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$boolTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$dataViewTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$dateTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$errorTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$funcTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$mapTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$numberTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$objectTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$regexpTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$setTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$stringTag] = $cb564c048f7106d0$var$typedArrayTags[$cb564c048f7106d0$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $cb564c048f7106d0$var$baseIsTypedArray(value) {
    return $61068a3203fea8d0$exports(value) && $41671756f2bfb3b6$exports(value.length) && !!$cb564c048f7106d0$var$typedArrayTags[$8f26fc8d3b90e8ac$exports(value)];
}
$cb564c048f7106d0$exports = $cb564c048f7106d0$var$baseIsTypedArray;


var $ee9be00b092f853c$exports = {};
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $ee9be00b092f853c$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
$ee9be00b092f853c$exports = $ee9be00b092f853c$var$baseUnary;



var $faAj2 = parcelRequire("faAj2");
/* Node.js helper references. */ var $0623facb4d8a883e$var$nodeIsTypedArray = $faAj2 && $faAj2.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $0623facb4d8a883e$var$isTypedArray = $0623facb4d8a883e$var$nodeIsTypedArray ? $ee9be00b092f853c$exports($0623facb4d8a883e$var$nodeIsTypedArray) : $cb564c048f7106d0$exports;
$0623facb4d8a883e$exports = $0623facb4d8a883e$var$isTypedArray;


/** Used for built-in method references. */ var $774407bad52f3924$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $774407bad52f3924$var$hasOwnProperty = $774407bad52f3924$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $774407bad52f3924$var$arrayLikeKeys(value, inherited) {
    var isArr = $0731a2307bf9d7f9$exports(value), isArg = !isArr && $9f652b1571d8ed7c$exports(value), isBuff = !isArr && !isArg && $jrO3d(value), isType = !isArr && !isArg && !isBuff && $0623facb4d8a883e$exports(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? $552f09a458871e37$exports(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $774407bad52f3924$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    $edcbf53930595f47$exports(key, length)))) result.push(key);
    return result;
}
$774407bad52f3924$exports = $774407bad52f3924$var$arrayLikeKeys;


var $56c0f31dd090554f$exports = {};
var $8c4ee7a33f96b8eb$exports = {};
/** Used for built-in method references. */ var $8c4ee7a33f96b8eb$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $8c4ee7a33f96b8eb$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $8c4ee7a33f96b8eb$var$objectProto;
    return value === proto;
}
$8c4ee7a33f96b8eb$exports = $8c4ee7a33f96b8eb$var$isPrototype;


var $cf849ad14ba8407b$exports = {};
var $2a56745b0d197c0b$exports = {};
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $2a56745b0d197c0b$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
$2a56745b0d197c0b$exports = $2a56745b0d197c0b$var$overArg;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $cf849ad14ba8407b$var$nativeKeys = $2a56745b0d197c0b$exports(Object.keys, Object);
$cf849ad14ba8407b$exports = $cf849ad14ba8407b$var$nativeKeys;


/** Used for built-in method references. */ var $56c0f31dd090554f$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $56c0f31dd090554f$var$hasOwnProperty = $56c0f31dd090554f$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $56c0f31dd090554f$var$baseKeys(object) {
    if (!$8c4ee7a33f96b8eb$exports(object)) return $cf849ad14ba8407b$exports(object);
    var result = [];
    for(var key in Object(object))if ($56c0f31dd090554f$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
$56c0f31dd090554f$exports = $56c0f31dd090554f$var$baseKeys;


var $dd7f3dc0af86f403$exports = {};
var $aceb43529efb4f1a$exports = {};

var $6012f8e4c7891baf$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $6012f8e4c7891baf$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
$6012f8e4c7891baf$exports = $6012f8e4c7891baf$var$isObject;


/** `Object#toString` result references. */ var $aceb43529efb4f1a$var$asyncTag = "[object AsyncFunction]", $aceb43529efb4f1a$var$funcTag = "[object Function]", $aceb43529efb4f1a$var$genTag = "[object GeneratorFunction]", $aceb43529efb4f1a$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $aceb43529efb4f1a$var$isFunction(value) {
    if (!$6012f8e4c7891baf$exports(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = $8f26fc8d3b90e8ac$exports(value);
    return tag == $aceb43529efb4f1a$var$funcTag || tag == $aceb43529efb4f1a$var$genTag || tag == $aceb43529efb4f1a$var$asyncTag || tag == $aceb43529efb4f1a$var$proxyTag;
}
$aceb43529efb4f1a$exports = $aceb43529efb4f1a$var$isFunction;



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $dd7f3dc0af86f403$var$isArrayLike(value) {
    return value != null && $41671756f2bfb3b6$exports(value.length) && !$aceb43529efb4f1a$exports(value);
}
$dd7f3dc0af86f403$exports = $dd7f3dc0af86f403$var$isArrayLike;


/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $69c7a2966b4129b5$var$keys(object) {
    return $dd7f3dc0af86f403$exports(object) ? $774407bad52f3924$exports(object) : $56c0f31dd090554f$exports(object);
}
$69c7a2966b4129b5$exports = $69c7a2966b4129b5$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $7684658affa33219$var$baseForOwn(object, iteratee) {
    return object && $d7b9d98e4845cdf3$exports(object, iteratee, $69c7a2966b4129b5$exports);
}
$7684658affa33219$exports = $7684658affa33219$var$baseForOwn;


var $d3d9f8ab8265cc73$exports = {};
var $d776a9304296f9f7$exports = {};
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $d776a9304296f9f7$var$identity(value) {
    return value;
}
$d776a9304296f9f7$exports = $d776a9304296f9f7$var$identity;


/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $d3d9f8ab8265cc73$var$castFunction(value) {
    return typeof value == "function" ? value : $d776a9304296f9f7$exports;
}
$d3d9f8ab8265cc73$exports = $d3d9f8ab8265cc73$var$castFunction;


/**
 * Iterates over own enumerable string keyed properties of an object and
 * invokes `iteratee` for each property. The iteratee is invoked with three
 * arguments: (value, key, object). Iteratee functions may exit iteration
 * early by explicitly returning `false`.
 *
 * @static
 * @memberOf _
 * @since 0.3.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns `object`.
 * @see _.forOwnRight
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.forOwn(new Foo, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $ad6e8de3503db2ef$var$forOwn(object, iteratee) {
    return object && $7684658affa33219$exports(object, $d3d9f8ab8265cc73$exports(iteratee));
}
$ad6e8de3503db2ef$exports = $ad6e8de3503db2ef$var$forOwn;


var $37fe9c1dabc054d3$var$_forOwn3 = $37fe9c1dabc054d3$var$_interopRequireDefault($ad6e8de3503db2ef$exports);
var $4fc8f980b8d1f547$exports = {};

var $783269c363df86d6$exports = {};

/** Built-in value references. */ var $783269c363df86d6$var$getPrototype = $2a56745b0d197c0b$exports(Object.getPrototypeOf, Object);
$783269c363df86d6$exports = $783269c363df86d6$var$getPrototype;



/** `Object#toString` result references. */ var $4fc8f980b8d1f547$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $4fc8f980b8d1f547$var$funcProto = Function.prototype, $4fc8f980b8d1f547$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $4fc8f980b8d1f547$var$funcToString = $4fc8f980b8d1f547$var$funcProto.toString;
/** Used to check objects for own properties. */ var $4fc8f980b8d1f547$var$hasOwnProperty = $4fc8f980b8d1f547$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $4fc8f980b8d1f547$var$objectCtorString = $4fc8f980b8d1f547$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $4fc8f980b8d1f547$var$isPlainObject(value) {
    if (!$61068a3203fea8d0$exports(value) || $8f26fc8d3b90e8ac$exports(value) != $4fc8f980b8d1f547$var$objectTag) return false;
    var proto = $783269c363df86d6$exports(value);
    if (proto === null) return true;
    var Ctor = $4fc8f980b8d1f547$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $4fc8f980b8d1f547$var$funcToString.call(Ctor) == $4fc8f980b8d1f547$var$objectCtorString;
}
$4fc8f980b8d1f547$exports = $4fc8f980b8d1f547$var$isPlainObject;


var $37fe9c1dabc054d3$var$_isPlainObject3 = $37fe9c1dabc054d3$var$_interopRequireDefault($4fc8f980b8d1f547$exports);
var $e3a5da4e5e795541$exports = {};
var $eeb990c9a870c3fa$exports = {};
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $eeb990c9a870c3fa$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
$eeb990c9a870c3fa$exports = $eeb990c9a870c3fa$var$arrayMap;


var $0ef980bf7dd42cec$exports = {};
var $aa0e401cc09bc413$exports = {};
var $69cee7d21f25926a$exports = {};
var $068ff3c29d5984dd$exports = {};
var $4ce40578e3a36603$exports = {};
var $59aaa949c7b60769$exports = {};
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $59aaa949c7b60769$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
$59aaa949c7b60769$exports = $59aaa949c7b60769$var$listCacheClear;


var $106360552de462fc$exports = {};
var $ad34fa75d31a3100$exports = {};
var $e8a952114a2113aa$exports = {};
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $e8a952114a2113aa$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
$e8a952114a2113aa$exports = $e8a952114a2113aa$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $ad34fa75d31a3100$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ($e8a952114a2113aa$exports(array[length][0], key)) return length;
    }
    return -1;
}
$ad34fa75d31a3100$exports = $ad34fa75d31a3100$var$assocIndexOf;


/** Used for built-in method references. */ var $106360552de462fc$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $106360552de462fc$var$splice = $106360552de462fc$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $106360552de462fc$var$listCacheDelete(key) {
    var data = this.__data__, index = $ad34fa75d31a3100$exports(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $106360552de462fc$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
$106360552de462fc$exports = $106360552de462fc$var$listCacheDelete;


var $995669c94fb21c73$exports = {};

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $995669c94fb21c73$var$listCacheGet(key) {
    var data = this.__data__, index = $ad34fa75d31a3100$exports(data, key);
    return index < 0 ? undefined : data[index][1];
}
$995669c94fb21c73$exports = $995669c94fb21c73$var$listCacheGet;


var $ce7a9a54358bd7cc$exports = {};

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $ce7a9a54358bd7cc$var$listCacheHas(key) {
    return $ad34fa75d31a3100$exports(this.__data__, key) > -1;
}
$ce7a9a54358bd7cc$exports = $ce7a9a54358bd7cc$var$listCacheHas;


var $647696ee49b43f08$exports = {};

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $647696ee49b43f08$var$listCacheSet(key, value) {
    var data = this.__data__, index = $ad34fa75d31a3100$exports(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
$647696ee49b43f08$exports = $647696ee49b43f08$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $4ce40578e3a36603$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$4ce40578e3a36603$var$ListCache.prototype.clear = $59aaa949c7b60769$exports;
$4ce40578e3a36603$var$ListCache.prototype["delete"] = $106360552de462fc$exports;
$4ce40578e3a36603$var$ListCache.prototype.get = $995669c94fb21c73$exports;
$4ce40578e3a36603$var$ListCache.prototype.has = $ce7a9a54358bd7cc$exports;
$4ce40578e3a36603$var$ListCache.prototype.set = $647696ee49b43f08$exports;
$4ce40578e3a36603$exports = $4ce40578e3a36603$var$ListCache;


var $53c825f2e28dbcde$exports = {};

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $53c825f2e28dbcde$var$stackClear() {
    this.__data__ = new $4ce40578e3a36603$exports;
    this.size = 0;
}
$53c825f2e28dbcde$exports = $53c825f2e28dbcde$var$stackClear;


var $5e61590ea076697f$exports = {};
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $5e61590ea076697f$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
$5e61590ea076697f$exports = $5e61590ea076697f$var$stackDelete;


var $4e2fa638457a0afa$exports = {};
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4e2fa638457a0afa$var$stackGet(key) {
    return this.__data__.get(key);
}
$4e2fa638457a0afa$exports = $4e2fa638457a0afa$var$stackGet;


var $a4cce36f2ea14dac$exports = {};
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a4cce36f2ea14dac$var$stackHas(key) {
    return this.__data__.has(key);
}
$a4cce36f2ea14dac$exports = $a4cce36f2ea14dac$var$stackHas;


var $df40fd757129ab80$exports = {};

var $468dd1e2742ba352$exports = {};
var $6f8a018ca632af05$exports = {};
var $6cefda270428d1bc$exports = {};

var $f5ffab7cbfca51cb$exports = {};
var $eaf63063ce5ba20e$exports = {};

var $jVTpz = parcelRequire("jVTpz");
/** Used to detect overreaching core-js shims. */ var $eaf63063ce5ba20e$var$coreJsData = $jVTpz["__core-js_shared__"];
$eaf63063ce5ba20e$exports = $eaf63063ce5ba20e$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $f5ffab7cbfca51cb$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec($eaf63063ce5ba20e$exports && $eaf63063ce5ba20e$exports.keys && $eaf63063ce5ba20e$exports.keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $f5ffab7cbfca51cb$var$isMasked(func) {
    return !!$f5ffab7cbfca51cb$var$maskSrcKey && $f5ffab7cbfca51cb$var$maskSrcKey in func;
}
$f5ffab7cbfca51cb$exports = $f5ffab7cbfca51cb$var$isMasked;



var $459364632d4a54c9$exports = {};
/** Used for built-in method references. */ var $459364632d4a54c9$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $459364632d4a54c9$var$funcToString = $459364632d4a54c9$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $459364632d4a54c9$var$toSource(func) {
    if (func != null) {
        try {
            return $459364632d4a54c9$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
$459364632d4a54c9$exports = $459364632d4a54c9$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $6cefda270428d1bc$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $6cefda270428d1bc$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $6cefda270428d1bc$var$funcProto = Function.prototype, $6cefda270428d1bc$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $6cefda270428d1bc$var$funcToString = $6cefda270428d1bc$var$funcProto.toString;
/** Used to check objects for own properties. */ var $6cefda270428d1bc$var$hasOwnProperty = $6cefda270428d1bc$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $6cefda270428d1bc$var$reIsNative = RegExp("^" + $6cefda270428d1bc$var$funcToString.call($6cefda270428d1bc$var$hasOwnProperty).replace($6cefda270428d1bc$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $6cefda270428d1bc$var$baseIsNative(value) {
    if (!$6012f8e4c7891baf$exports(value) || $f5ffab7cbfca51cb$exports(value)) return false;
    var pattern = $aceb43529efb4f1a$exports(value) ? $6cefda270428d1bc$var$reIsNative : $6cefda270428d1bc$var$reIsHostCtor;
    return pattern.test($459364632d4a54c9$exports(value));
}
$6cefda270428d1bc$exports = $6cefda270428d1bc$var$baseIsNative;


var $262cb907969bcd3a$exports = {};
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $262cb907969bcd3a$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
$262cb907969bcd3a$exports = $262cb907969bcd3a$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $6f8a018ca632af05$var$getNative(object, key) {
    var value = $262cb907969bcd3a$exports(object, key);
    return $6cefda270428d1bc$exports(value) ? value : undefined;
}
$6f8a018ca632af05$exports = $6f8a018ca632af05$var$getNative;



var $jVTpz = parcelRequire("jVTpz");
/* Built-in method references that are verified to be native. */ var $468dd1e2742ba352$var$Map = $6f8a018ca632af05$exports($jVTpz, "Map");
$468dd1e2742ba352$exports = $468dd1e2742ba352$var$Map;


var $174b18e58d802de1$exports = {};
var $0e81c8cbc89e62ce$exports = {};
var $5ae63e8573bd084c$exports = {};
var $f4a35d91a20231fd$exports = {};
var $a6c2d015b80d8e84$exports = {};

/* Built-in method references that are verified to be native. */ var $a6c2d015b80d8e84$var$nativeCreate = $6f8a018ca632af05$exports(Object, "create");
$a6c2d015b80d8e84$exports = $a6c2d015b80d8e84$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $f4a35d91a20231fd$var$hashClear() {
    this.__data__ = $a6c2d015b80d8e84$exports ? $a6c2d015b80d8e84$exports(null) : {};
    this.size = 0;
}
$f4a35d91a20231fd$exports = $f4a35d91a20231fd$var$hashClear;


var $06070974adec9a06$exports = {};
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $06070974adec9a06$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
$06070974adec9a06$exports = $06070974adec9a06$var$hashDelete;


var $469d3d2b269bf9c9$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $469d3d2b269bf9c9$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $469d3d2b269bf9c9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $469d3d2b269bf9c9$var$hasOwnProperty = $469d3d2b269bf9c9$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $469d3d2b269bf9c9$var$hashGet(key) {
    var data = this.__data__;
    if ($a6c2d015b80d8e84$exports) {
        var result = data[key];
        return result === $469d3d2b269bf9c9$var$HASH_UNDEFINED ? undefined : result;
    }
    return $469d3d2b269bf9c9$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
$469d3d2b269bf9c9$exports = $469d3d2b269bf9c9$var$hashGet;


var $d9d9c98c3d570aee$exports = {};

/** Used for built-in method references. */ var $d9d9c98c3d570aee$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d9d9c98c3d570aee$var$hasOwnProperty = $d9d9c98c3d570aee$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $d9d9c98c3d570aee$var$hashHas(key) {
    var data = this.__data__;
    return $a6c2d015b80d8e84$exports ? data[key] !== undefined : $d9d9c98c3d570aee$var$hasOwnProperty.call(data, key);
}
$d9d9c98c3d570aee$exports = $d9d9c98c3d570aee$var$hashHas;


var $29505de41a8a5687$exports = {};

/** Used to stand-in for `undefined` hash values. */ var $29505de41a8a5687$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $29505de41a8a5687$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = $a6c2d015b80d8e84$exports && value === undefined ? $29505de41a8a5687$var$HASH_UNDEFINED : value;
    return this;
}
$29505de41a8a5687$exports = $29505de41a8a5687$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $5ae63e8573bd084c$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$5ae63e8573bd084c$var$Hash.prototype.clear = $f4a35d91a20231fd$exports;
$5ae63e8573bd084c$var$Hash.prototype["delete"] = $06070974adec9a06$exports;
$5ae63e8573bd084c$var$Hash.prototype.get = $469d3d2b269bf9c9$exports;
$5ae63e8573bd084c$var$Hash.prototype.has = $d9d9c98c3d570aee$exports;
$5ae63e8573bd084c$var$Hash.prototype.set = $29505de41a8a5687$exports;
$5ae63e8573bd084c$exports = $5ae63e8573bd084c$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $0e81c8cbc89e62ce$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new $5ae63e8573bd084c$exports,
        "map": new ($468dd1e2742ba352$exports || $4ce40578e3a36603$exports),
        "string": new $5ae63e8573bd084c$exports
    };
}
$0e81c8cbc89e62ce$exports = $0e81c8cbc89e62ce$var$mapCacheClear;


var $0c1d7e10d48e10bb$exports = {};
var $7a0919305b414905$exports = {};
var $c55e29806d35d7ec$exports = {};
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $c55e29806d35d7ec$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
$c55e29806d35d7ec$exports = $c55e29806d35d7ec$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $7a0919305b414905$var$getMapData(map, key) {
    var data = map.__data__;
    return $c55e29806d35d7ec$exports(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
$7a0919305b414905$exports = $7a0919305b414905$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0c1d7e10d48e10bb$var$mapCacheDelete(key) {
    var result = $7a0919305b414905$exports(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
$0c1d7e10d48e10bb$exports = $0c1d7e10d48e10bb$var$mapCacheDelete;


var $fa15e8a50a4c6d08$exports = {};

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $fa15e8a50a4c6d08$var$mapCacheGet(key) {
    return $7a0919305b414905$exports(this, key).get(key);
}
$fa15e8a50a4c6d08$exports = $fa15e8a50a4c6d08$var$mapCacheGet;


var $a6c9b1fff12181d4$exports = {};

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a6c9b1fff12181d4$var$mapCacheHas(key) {
    return $7a0919305b414905$exports(this, key).has(key);
}
$a6c9b1fff12181d4$exports = $a6c9b1fff12181d4$var$mapCacheHas;


var $c974e990aed6cfc9$exports = {};

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $c974e990aed6cfc9$var$mapCacheSet(key, value) {
    var data = $7a0919305b414905$exports(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
$c974e990aed6cfc9$exports = $c974e990aed6cfc9$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $174b18e58d802de1$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$174b18e58d802de1$var$MapCache.prototype.clear = $0e81c8cbc89e62ce$exports;
$174b18e58d802de1$var$MapCache.prototype["delete"] = $0c1d7e10d48e10bb$exports;
$174b18e58d802de1$var$MapCache.prototype.get = $fa15e8a50a4c6d08$exports;
$174b18e58d802de1$var$MapCache.prototype.has = $a6c9b1fff12181d4$exports;
$174b18e58d802de1$var$MapCache.prototype.set = $c974e990aed6cfc9$exports;
$174b18e58d802de1$exports = $174b18e58d802de1$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $df40fd757129ab80$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $df40fd757129ab80$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof $4ce40578e3a36603$exports) {
        var pairs = data.__data__;
        if (!$468dd1e2742ba352$exports || pairs.length < $df40fd757129ab80$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new $174b18e58d802de1$exports(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
$df40fd757129ab80$exports = $df40fd757129ab80$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $068ff3c29d5984dd$var$Stack(entries) {
    var data = this.__data__ = new $4ce40578e3a36603$exports(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$068ff3c29d5984dd$var$Stack.prototype.clear = $53c825f2e28dbcde$exports;
$068ff3c29d5984dd$var$Stack.prototype["delete"] = $5e61590ea076697f$exports;
$068ff3c29d5984dd$var$Stack.prototype.get = $4e2fa638457a0afa$exports;
$068ff3c29d5984dd$var$Stack.prototype.has = $a4cce36f2ea14dac$exports;
$068ff3c29d5984dd$var$Stack.prototype.set = $df40fd757129ab80$exports;
$068ff3c29d5984dd$exports = $068ff3c29d5984dd$var$Stack;


var $7cc170f69c8922af$exports = {};
var $2e073332f1588bca$exports = {};

var $786d0fce31ae492d$exports = {};
var $f5cbf6641c4b308c$exports = {};

var $3d614f880ece8fc6$exports = {};
/** Used to stand-in for `undefined` hash values. */ var $3d614f880ece8fc6$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $3d614f880ece8fc6$var$setCacheAdd(value) {
    this.__data__.set(value, $3d614f880ece8fc6$var$HASH_UNDEFINED);
    return this;
}
$3d614f880ece8fc6$exports = $3d614f880ece8fc6$var$setCacheAdd;


var $67c502f4b70d45b1$exports = {};
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $67c502f4b70d45b1$var$setCacheHas(value) {
    return this.__data__.has(value);
}
$67c502f4b70d45b1$exports = $67c502f4b70d45b1$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $f5cbf6641c4b308c$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new $174b18e58d802de1$exports;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$f5cbf6641c4b308c$var$SetCache.prototype.add = $f5cbf6641c4b308c$var$SetCache.prototype.push = $3d614f880ece8fc6$exports;
$f5cbf6641c4b308c$var$SetCache.prototype.has = $67c502f4b70d45b1$exports;
$f5cbf6641c4b308c$exports = $f5cbf6641c4b308c$var$SetCache;


var $67ed48d2b21bbdf3$exports = {};
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $67ed48d2b21bbdf3$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
$67ed48d2b21bbdf3$exports = $67ed48d2b21bbdf3$var$arraySome;


var $01fedadae9fa2482$exports = {};
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $01fedadae9fa2482$var$cacheHas(cache, key) {
    return cache.has(key);
}
$01fedadae9fa2482$exports = $01fedadae9fa2482$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $786d0fce31ae492d$var$COMPARE_PARTIAL_FLAG = 1, $786d0fce31ae492d$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $786d0fce31ae492d$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $786d0fce31ae492d$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $786d0fce31ae492d$var$COMPARE_UNORDERED_FLAG ? new $f5cbf6641c4b308c$exports : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!$67ed48d2b21bbdf3$exports(other, function(othValue, othIndex) {
                if (!$01fedadae9fa2482$exports(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
$786d0fce31ae492d$exports = $786d0fce31ae492d$var$equalArrays;


var $a50805363801bce8$exports = {};

var $b12687f5cc756803$exports = {};

var $jVTpz = parcelRequire("jVTpz");
/** Built-in value references. */ var $b12687f5cc756803$var$Uint8Array = $jVTpz.Uint8Array;
$b12687f5cc756803$exports = $b12687f5cc756803$var$Uint8Array;




var $d1fc571a8585eee3$exports = {};
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $d1fc571a8585eee3$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
$d1fc571a8585eee3$exports = $d1fc571a8585eee3$var$mapToArray;


var $5df61789b301e5ff$exports = {};
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $5df61789b301e5ff$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
$5df61789b301e5ff$exports = $5df61789b301e5ff$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $a50805363801bce8$var$COMPARE_PARTIAL_FLAG = 1, $a50805363801bce8$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $a50805363801bce8$var$boolTag = "[object Boolean]", $a50805363801bce8$var$dateTag = "[object Date]", $a50805363801bce8$var$errorTag = "[object Error]", $a50805363801bce8$var$mapTag = "[object Map]", $a50805363801bce8$var$numberTag = "[object Number]", $a50805363801bce8$var$regexpTag = "[object RegExp]", $a50805363801bce8$var$setTag = "[object Set]", $a50805363801bce8$var$stringTag = "[object String]", $a50805363801bce8$var$symbolTag = "[object Symbol]";
var $a50805363801bce8$var$arrayBufferTag = "[object ArrayBuffer]", $a50805363801bce8$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $a50805363801bce8$var$symbolProto = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.prototype : undefined, $a50805363801bce8$var$symbolValueOf = $a50805363801bce8$var$symbolProto ? $a50805363801bce8$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $a50805363801bce8$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $a50805363801bce8$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $a50805363801bce8$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new $b12687f5cc756803$exports(object), new $b12687f5cc756803$exports(other))) return false;
            return true;
        case $a50805363801bce8$var$boolTag:
        case $a50805363801bce8$var$dateTag:
        case $a50805363801bce8$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return $e8a952114a2113aa$exports(+object, +other);
        case $a50805363801bce8$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $a50805363801bce8$var$regexpTag:
        case $a50805363801bce8$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $a50805363801bce8$var$mapTag:
            var convert = $d1fc571a8585eee3$exports;
        case $a50805363801bce8$var$setTag:
            var isPartial = bitmask & $a50805363801bce8$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = $5df61789b301e5ff$exports);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $a50805363801bce8$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = $786d0fce31ae492d$exports(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $a50805363801bce8$var$symbolTag:
            if ($a50805363801bce8$var$symbolValueOf) return $a50805363801bce8$var$symbolValueOf.call(object) == $a50805363801bce8$var$symbolValueOf.call(other);
    }
    return false;
}
$a50805363801bce8$exports = $a50805363801bce8$var$equalByTag;


var $767784c9525d7d51$exports = {};
var $69402b4e3bcd529f$exports = {};
var $c109bddf0a819f91$exports = {};
var $93da0abe6e6dc744$exports = {};
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $93da0abe6e6dc744$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
$93da0abe6e6dc744$exports = $93da0abe6e6dc744$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $c109bddf0a819f91$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return $0731a2307bf9d7f9$exports(object) ? result : $93da0abe6e6dc744$exports(result, symbolsFunc(object));
}
$c109bddf0a819f91$exports = $c109bddf0a819f91$var$baseGetAllKeys;


var $1b3f92ff973c2e2f$exports = {};
var $63b7b8a5ac515461$exports = {};
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $63b7b8a5ac515461$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
$63b7b8a5ac515461$exports = $63b7b8a5ac515461$var$arrayFilter;


var $8dc2472a69a3192f$exports = {};
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $8dc2472a69a3192f$var$stubArray() {
    return [];
}
$8dc2472a69a3192f$exports = $8dc2472a69a3192f$var$stubArray;


/** Used for built-in method references. */ var $1b3f92ff973c2e2f$var$objectProto = Object.prototype;
/** Built-in value references. */ var $1b3f92ff973c2e2f$var$propertyIsEnumerable = $1b3f92ff973c2e2f$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1b3f92ff973c2e2f$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $1b3f92ff973c2e2f$var$getSymbols = !$1b3f92ff973c2e2f$var$nativeGetSymbols ? $8dc2472a69a3192f$exports : function(object) {
    if (object == null) return [];
    object = Object(object);
    return $63b7b8a5ac515461$exports($1b3f92ff973c2e2f$var$nativeGetSymbols(object), function(symbol) {
        return $1b3f92ff973c2e2f$var$propertyIsEnumerable.call(object, symbol);
    });
};
$1b3f92ff973c2e2f$exports = $1b3f92ff973c2e2f$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $69402b4e3bcd529f$var$getAllKeys(object) {
    return $c109bddf0a819f91$exports(object, $69c7a2966b4129b5$exports, $1b3f92ff973c2e2f$exports);
}
$69402b4e3bcd529f$exports = $69402b4e3bcd529f$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $767784c9525d7d51$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $767784c9525d7d51$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $767784c9525d7d51$var$hasOwnProperty = $767784c9525d7d51$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $767784c9525d7d51$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $767784c9525d7d51$var$COMPARE_PARTIAL_FLAG, objProps = $69402b4e3bcd529f$exports(object), objLength = objProps.length, othProps = $69402b4e3bcd529f$exports(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $767784c9525d7d51$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
$767784c9525d7d51$exports = $767784c9525d7d51$var$equalObjects;


var $d2a775c7e42cc499$exports = {};
var $2c1cc94a0bbf4eab$exports = {};


var $jVTpz = parcelRequire("jVTpz");
/* Built-in method references that are verified to be native. */ var $2c1cc94a0bbf4eab$var$DataView = $6f8a018ca632af05$exports($jVTpz, "DataView");
$2c1cc94a0bbf4eab$exports = $2c1cc94a0bbf4eab$var$DataView;



var $4ba7575c0b03b46d$exports = {};


var $jVTpz = parcelRequire("jVTpz");
/* Built-in method references that are verified to be native. */ var $4ba7575c0b03b46d$var$Promise = $6f8a018ca632af05$exports($jVTpz, "Promise");
$4ba7575c0b03b46d$exports = $4ba7575c0b03b46d$var$Promise;


var $5deb88fbb4a464a1$exports = {};


var $jVTpz = parcelRequire("jVTpz");
/* Built-in method references that are verified to be native. */ var $5deb88fbb4a464a1$var$Set = $6f8a018ca632af05$exports($jVTpz, "Set");
$5deb88fbb4a464a1$exports = $5deb88fbb4a464a1$var$Set;


var $effe5c7febcde37d$exports = {};


var $jVTpz = parcelRequire("jVTpz");
/* Built-in method references that are verified to be native. */ var $effe5c7febcde37d$var$WeakMap = $6f8a018ca632af05$exports($jVTpz, "WeakMap");
$effe5c7febcde37d$exports = $effe5c7febcde37d$var$WeakMap;




/** `Object#toString` result references. */ var $d2a775c7e42cc499$var$mapTag = "[object Map]", $d2a775c7e42cc499$var$objectTag = "[object Object]", $d2a775c7e42cc499$var$promiseTag = "[object Promise]", $d2a775c7e42cc499$var$setTag = "[object Set]", $d2a775c7e42cc499$var$weakMapTag = "[object WeakMap]";
var $d2a775c7e42cc499$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $d2a775c7e42cc499$var$dataViewCtorString = $459364632d4a54c9$exports($2c1cc94a0bbf4eab$exports), $d2a775c7e42cc499$var$mapCtorString = $459364632d4a54c9$exports($468dd1e2742ba352$exports), $d2a775c7e42cc499$var$promiseCtorString = $459364632d4a54c9$exports($4ba7575c0b03b46d$exports), $d2a775c7e42cc499$var$setCtorString = $459364632d4a54c9$exports($5deb88fbb4a464a1$exports), $d2a775c7e42cc499$var$weakMapCtorString = $459364632d4a54c9$exports($effe5c7febcde37d$exports);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $d2a775c7e42cc499$var$getTag = $8f26fc8d3b90e8ac$exports;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ($2c1cc94a0bbf4eab$exports && $d2a775c7e42cc499$var$getTag(new $2c1cc94a0bbf4eab$exports(new ArrayBuffer(1))) != $d2a775c7e42cc499$var$dataViewTag || $468dd1e2742ba352$exports && $d2a775c7e42cc499$var$getTag(new $468dd1e2742ba352$exports) != $d2a775c7e42cc499$var$mapTag || $4ba7575c0b03b46d$exports && $d2a775c7e42cc499$var$getTag($4ba7575c0b03b46d$exports.resolve()) != $d2a775c7e42cc499$var$promiseTag || $5deb88fbb4a464a1$exports && $d2a775c7e42cc499$var$getTag(new $5deb88fbb4a464a1$exports) != $d2a775c7e42cc499$var$setTag || $effe5c7febcde37d$exports && $d2a775c7e42cc499$var$getTag(new $effe5c7febcde37d$exports) != $d2a775c7e42cc499$var$weakMapTag) $d2a775c7e42cc499$var$getTag = function(value) {
    var result = $8f26fc8d3b90e8ac$exports(value), Ctor = result == $d2a775c7e42cc499$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? $459364632d4a54c9$exports(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $d2a775c7e42cc499$var$dataViewCtorString:
            return $d2a775c7e42cc499$var$dataViewTag;
        case $d2a775c7e42cc499$var$mapCtorString:
            return $d2a775c7e42cc499$var$mapTag;
        case $d2a775c7e42cc499$var$promiseCtorString:
            return $d2a775c7e42cc499$var$promiseTag;
        case $d2a775c7e42cc499$var$setCtorString:
            return $d2a775c7e42cc499$var$setTag;
        case $d2a775c7e42cc499$var$weakMapCtorString:
            return $d2a775c7e42cc499$var$weakMapTag;
    }
    return result;
};
$d2a775c7e42cc499$exports = $d2a775c7e42cc499$var$getTag;




var $jrO3d = parcelRequire("jrO3d");

/** Used to compose bitmasks for value comparisons. */ var $2e073332f1588bca$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $2e073332f1588bca$var$argsTag = "[object Arguments]", $2e073332f1588bca$var$arrayTag = "[object Array]", $2e073332f1588bca$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $2e073332f1588bca$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2e073332f1588bca$var$hasOwnProperty = $2e073332f1588bca$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $2e073332f1588bca$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = $0731a2307bf9d7f9$exports(object), othIsArr = $0731a2307bf9d7f9$exports(other), objTag = objIsArr ? $2e073332f1588bca$var$arrayTag : $d2a775c7e42cc499$exports(object), othTag = othIsArr ? $2e073332f1588bca$var$arrayTag : $d2a775c7e42cc499$exports(other);
    objTag = objTag == $2e073332f1588bca$var$argsTag ? $2e073332f1588bca$var$objectTag : objTag;
    othTag = othTag == $2e073332f1588bca$var$argsTag ? $2e073332f1588bca$var$objectTag : othTag;
    var objIsObj = objTag == $2e073332f1588bca$var$objectTag, othIsObj = othTag == $2e073332f1588bca$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && $jrO3d(object)) {
        if (!$jrO3d(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new $068ff3c29d5984dd$exports);
        return objIsArr || $0623facb4d8a883e$exports(object) ? $786d0fce31ae492d$exports(object, other, bitmask, customizer, equalFunc, stack) : $a50805363801bce8$exports(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $2e073332f1588bca$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $2e073332f1588bca$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $2e073332f1588bca$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new $068ff3c29d5984dd$exports);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new $068ff3c29d5984dd$exports);
    return $767784c9525d7d51$exports(object, other, bitmask, customizer, equalFunc, stack);
}
$2e073332f1588bca$exports = $2e073332f1588bca$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $7cc170f69c8922af$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !$61068a3203fea8d0$exports(value) && !$61068a3203fea8d0$exports(other)) return value !== value && other !== other;
    return $2e073332f1588bca$exports(value, other, bitmask, customizer, $7cc170f69c8922af$var$baseIsEqual, stack);
}
$7cc170f69c8922af$exports = $7cc170f69c8922af$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $69cee7d21f25926a$var$COMPARE_PARTIAL_FLAG = 1, $69cee7d21f25926a$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $69cee7d21f25926a$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new $068ff3c29d5984dd$exports;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? $7cc170f69c8922af$exports(srcValue, objValue, $69cee7d21f25926a$var$COMPARE_PARTIAL_FLAG | $69cee7d21f25926a$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
$69cee7d21f25926a$exports = $69cee7d21f25926a$var$baseIsMatch;


var $dd441023f2b273c4$exports = {};
var $eb17b4bc45509ea2$exports = {};

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $eb17b4bc45509ea2$var$isStrictComparable(value) {
    return value === value && !$6012f8e4c7891baf$exports(value);
}
$eb17b4bc45509ea2$exports = $eb17b4bc45509ea2$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $dd441023f2b273c4$var$getMatchData(object) {
    var result = $69c7a2966b4129b5$exports(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            $eb17b4bc45509ea2$exports(value)
        ];
    }
    return result;
}
$dd441023f2b273c4$exports = $dd441023f2b273c4$var$getMatchData;


var $437f0564b9003054$exports = {};
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $437f0564b9003054$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
$437f0564b9003054$exports = $437f0564b9003054$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $aa0e401cc09bc413$var$baseMatches(source) {
    var matchData = $dd441023f2b273c4$exports(source);
    if (matchData.length == 1 && matchData[0][2]) return $437f0564b9003054$exports(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || $69cee7d21f25926a$exports(object, source, matchData);
    };
}
$aa0e401cc09bc413$exports = $aa0e401cc09bc413$var$baseMatches;


var $96b89f14771ef471$exports = {};

var $5d6ab69f292f1b81$exports = {};
var $6e7ad4bf12182a3e$exports = {};
var $393eefb428823693$exports = {};

var $aa1f719fdc75bc5f$exports = {};

var $75f82d2fc8a8760e$exports = {};


/** `Object#toString` result references. */ var $75f82d2fc8a8760e$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $75f82d2fc8a8760e$var$isSymbol(value) {
    return typeof value == "symbol" || $61068a3203fea8d0$exports(value) && $8f26fc8d3b90e8ac$exports(value) == $75f82d2fc8a8760e$var$symbolTag;
}
$75f82d2fc8a8760e$exports = $75f82d2fc8a8760e$var$isSymbol;


/** Used to match property names within property paths. */ var $aa1f719fdc75bc5f$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $aa1f719fdc75bc5f$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $aa1f719fdc75bc5f$var$isKey(value, object) {
    if ($0731a2307bf9d7f9$exports(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || $75f82d2fc8a8760e$exports(value)) return true;
    return $aa1f719fdc75bc5f$var$reIsPlainProp.test(value) || !$aa1f719fdc75bc5f$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
$aa1f719fdc75bc5f$exports = $aa1f719fdc75bc5f$var$isKey;


var $e17c6b11c3d1ab9e$exports = {};
var $ed9f3dd152899c47$exports = {};
var $19912207116721db$exports = {};

/** Error message constants. */ var $19912207116721db$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $19912207116721db$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($19912207116721db$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($19912207116721db$var$memoize.Cache || $174b18e58d802de1$exports);
    return memoized;
}
// Expose `MapCache`.
$19912207116721db$var$memoize.Cache = $174b18e58d802de1$exports;
$19912207116721db$exports = $19912207116721db$var$memoize;


/** Used as the maximum memoize cache size. */ var $ed9f3dd152899c47$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $ed9f3dd152899c47$var$memoizeCapped(func) {
    var result = $19912207116721db$exports(func, function(key) {
        if (cache.size === $ed9f3dd152899c47$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
$ed9f3dd152899c47$exports = $ed9f3dd152899c47$var$memoizeCapped;


/** Used to match property names within property paths. */ var $e17c6b11c3d1ab9e$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $e17c6b11c3d1ab9e$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $e17c6b11c3d1ab9e$var$stringToPath = $ed9f3dd152899c47$exports(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($e17c6b11c3d1ab9e$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($e17c6b11c3d1ab9e$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
$e17c6b11c3d1ab9e$exports = $e17c6b11c3d1ab9e$var$stringToPath;


var $b54895e624e7fc74$exports = {};
var $084177e771962dbf$exports = {};




/** Used as references for various `Number` constants. */ var $084177e771962dbf$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $084177e771962dbf$var$symbolProto = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.prototype : undefined, $084177e771962dbf$var$symbolToString = $084177e771962dbf$var$symbolProto ? $084177e771962dbf$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $084177e771962dbf$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ($0731a2307bf9d7f9$exports(value)) // Recursively convert values (susceptible to call stack limits).
    return $eeb990c9a870c3fa$exports(value, $084177e771962dbf$var$baseToString) + "";
    if ($75f82d2fc8a8760e$exports(value)) return $084177e771962dbf$var$symbolToString ? $084177e771962dbf$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$084177e771962dbf$var$INFINITY ? "-0" : result;
}
$084177e771962dbf$exports = $084177e771962dbf$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $b54895e624e7fc74$var$toString(value) {
    return value == null ? "" : $084177e771962dbf$exports(value);
}
$b54895e624e7fc74$exports = $b54895e624e7fc74$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $393eefb428823693$var$castPath(value, object) {
    if ($0731a2307bf9d7f9$exports(value)) return value;
    return $aa1f719fdc75bc5f$exports(value, object) ? [
        value
    ] : $e17c6b11c3d1ab9e$exports($b54895e624e7fc74$exports(value));
}
$393eefb428823693$exports = $393eefb428823693$var$castPath;


var $3519c084644c1f9b$exports = {};

/** Used as references for various `Number` constants. */ var $3519c084644c1f9b$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $3519c084644c1f9b$var$toKey(value) {
    if (typeof value == "string" || $75f82d2fc8a8760e$exports(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$3519c084644c1f9b$var$INFINITY ? "-0" : result;
}
$3519c084644c1f9b$exports = $3519c084644c1f9b$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $6e7ad4bf12182a3e$var$baseGet(object, path) {
    path = $393eefb428823693$exports(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[$3519c084644c1f9b$exports(path[index++])];
    return index && index == length ? object : undefined;
}
$6e7ad4bf12182a3e$exports = $6e7ad4bf12182a3e$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $5d6ab69f292f1b81$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : $6e7ad4bf12182a3e$exports(object, path);
    return result === undefined ? defaultValue : result;
}
$5d6ab69f292f1b81$exports = $5d6ab69f292f1b81$var$get;


var $0fc50f92b9343bb0$exports = {};
var $297109af154fec78$exports = {};
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $297109af154fec78$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
$297109af154fec78$exports = $297109af154fec78$var$baseHasIn;


var $cea75a9d3e561e4a$exports = {};






/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $cea75a9d3e561e4a$var$hasPath(object, path, hasFunc) {
    path = $393eefb428823693$exports(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = $3519c084644c1f9b$exports(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && $41671756f2bfb3b6$exports(length) && $edcbf53930595f47$exports(key, length) && ($0731a2307bf9d7f9$exports(object) || $9f652b1571d8ed7c$exports(object));
}
$cea75a9d3e561e4a$exports = $cea75a9d3e561e4a$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $0fc50f92b9343bb0$var$hasIn(object, path) {
    return object != null && $cea75a9d3e561e4a$exports(object, path, $297109af154fec78$exports);
}
$0fc50f92b9343bb0$exports = $0fc50f92b9343bb0$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $96b89f14771ef471$var$COMPARE_PARTIAL_FLAG = 1, $96b89f14771ef471$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $96b89f14771ef471$var$baseMatchesProperty(path, srcValue) {
    if ($aa1f719fdc75bc5f$exports(path) && $eb17b4bc45509ea2$exports(srcValue)) return $437f0564b9003054$exports($3519c084644c1f9b$exports(path), srcValue);
    return function(object) {
        var objValue = $5d6ab69f292f1b81$exports(object, path);
        return objValue === undefined && objValue === srcValue ? $0fc50f92b9343bb0$exports(object, path) : $7cc170f69c8922af$exports(srcValue, objValue, $96b89f14771ef471$var$COMPARE_PARTIAL_FLAG | $96b89f14771ef471$var$COMPARE_UNORDERED_FLAG);
    };
}
$96b89f14771ef471$exports = $96b89f14771ef471$var$baseMatchesProperty;




var $570a3eed823e2629$exports = {};
var $452a37a7d2e212cb$exports = {};
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $452a37a7d2e212cb$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
$452a37a7d2e212cb$exports = $452a37a7d2e212cb$var$baseProperty;


var $5b4017dca65df4b7$exports = {};

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $5b4017dca65df4b7$var$basePropertyDeep(path) {
    return function(object) {
        return $6e7ad4bf12182a3e$exports(object, path);
    };
}
$5b4017dca65df4b7$exports = $5b4017dca65df4b7$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $570a3eed823e2629$var$property(path) {
    return $aa1f719fdc75bc5f$exports(path) ? $452a37a7d2e212cb$exports($3519c084644c1f9b$exports(path)) : $5b4017dca65df4b7$exports(path);
}
$570a3eed823e2629$exports = $570a3eed823e2629$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $0ef980bf7dd42cec$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return $d776a9304296f9f7$exports;
    if (typeof value == "object") return $0731a2307bf9d7f9$exports(value) ? $96b89f14771ef471$exports(value[0], value[1]) : $aa0e401cc09bc413$exports(value);
    return $570a3eed823e2629$exports(value);
}
$0ef980bf7dd42cec$exports = $0ef980bf7dd42cec$var$baseIteratee;


var $66a7787fffa5a00a$exports = {};
var $04737f5e6900eacf$exports = {};

var $146b8c9f04546777$exports = {};

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $146b8c9f04546777$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!$dd7f3dc0af86f403$exports(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
$146b8c9f04546777$exports = $146b8c9f04546777$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $04737f5e6900eacf$var$baseEach = $146b8c9f04546777$exports($7684658affa33219$exports);
$04737f5e6900eacf$exports = $04737f5e6900eacf$var$baseEach;



/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $66a7787fffa5a00a$var$baseMap(collection, iteratee) {
    var index = -1, result = $dd7f3dc0af86f403$exports(collection) ? Array(collection.length) : [];
    $04737f5e6900eacf$exports(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
$66a7787fffa5a00a$exports = $66a7787fffa5a00a$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $e3a5da4e5e795541$var$map(collection, iteratee) {
    var func = $0731a2307bf9d7f9$exports(collection) ? $eeb990c9a870c3fa$exports : $66a7787fffa5a00a$exports;
    return func(collection, $0ef980bf7dd42cec$exports(iteratee, 3));
}
$e3a5da4e5e795541$exports = $e3a5da4e5e795541$var$map;


var $37fe9c1dabc054d3$var$_map3 = $37fe9c1dabc054d3$var$_interopRequireDefault($e3a5da4e5e795541$exports);
function $37fe9c1dabc054d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $37fe9c1dabc054d3$var$flattenNames = $37fe9c1dabc054d3$exports.flattenNames = function flattenNames() {
    var things = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var names = [];
    (0, $37fe9c1dabc054d3$var$_map3.default)(things, function(thing) {
        if (Array.isArray(thing)) flattenNames(thing).map(function(name) {
            return names.push(name);
        });
        else if ((0, $37fe9c1dabc054d3$var$_isPlainObject3.default)(thing)) (0, $37fe9c1dabc054d3$var$_forOwn3.default)(thing, function(value, key) {
            value === true && names.push(key);
            names.push(key + "-" + value);
        });
        else if ((0, $37fe9c1dabc054d3$var$_isString3.default)(thing)) names.push(thing);
    });
    return names;
};
$37fe9c1dabc054d3$exports.default = $37fe9c1dabc054d3$var$flattenNames;


var $30b13a56cd0faccc$var$_flattenNames2 = $30b13a56cd0faccc$var$_interopRequireDefault($37fe9c1dabc054d3$exports);
var $2048e7aad89867d3$exports = {};
"use strict";
Object.defineProperty($2048e7aad89867d3$exports, "__esModule", {
    value: true
});
$2048e7aad89867d3$exports.mergeClasses = undefined;

var $2048e7aad89867d3$var$_forOwn3 = $2048e7aad89867d3$var$_interopRequireDefault($ad6e8de3503db2ef$exports);
var $dcce9dfec18e8f22$exports = {};
var $0b721e5b23a4b168$exports = {};

var $d73004f6bd1871e1$exports = {};
/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $d73004f6bd1871e1$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
$d73004f6bd1871e1$exports = $d73004f6bd1871e1$var$arrayEach;


var $2f00d2d68c13dbd3$exports = {};
var $75d5cb8c754ffa1c$exports = {};
var $caab04187fff7f7a$exports = {};

var $caab04187fff7f7a$var$defineProperty = function() {
    try {
        var func = $6f8a018ca632af05$exports(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
$caab04187fff7f7a$exports = $caab04187fff7f7a$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $75d5cb8c754ffa1c$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && $caab04187fff7f7a$exports) $caab04187fff7f7a$exports(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
$75d5cb8c754ffa1c$exports = $75d5cb8c754ffa1c$var$baseAssignValue;



/** Used for built-in method references. */ var $2f00d2d68c13dbd3$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $2f00d2d68c13dbd3$var$hasOwnProperty = $2f00d2d68c13dbd3$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $2f00d2d68c13dbd3$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($2f00d2d68c13dbd3$var$hasOwnProperty.call(object, key) && $e8a952114a2113aa$exports(objValue, value)) || value === undefined && !(key in object)) $75d5cb8c754ffa1c$exports(object, key, value);
}
$2f00d2d68c13dbd3$exports = $2f00d2d68c13dbd3$var$assignValue;


var $503523e6625fa333$exports = {};
var $4ff0f4755ebd80de$exports = {};


/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $4ff0f4755ebd80de$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) $75d5cb8c754ffa1c$exports(object, key, newValue);
        else $2f00d2d68c13dbd3$exports(object, key, newValue);
    }
    return object;
}
$4ff0f4755ebd80de$exports = $4ff0f4755ebd80de$var$copyObject;



/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $503523e6625fa333$var$baseAssign(object, source) {
    return object && $4ff0f4755ebd80de$exports(source, $69c7a2966b4129b5$exports(source), object);
}
$503523e6625fa333$exports = $503523e6625fa333$var$baseAssign;


var $a5eab804fb810567$exports = {};

var $a33783dadb84eb22$exports = {};

var $4cbf7ea14b8b9de1$exports = {};


var $f9a566635bc5a241$exports = {};
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f9a566635bc5a241$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
$f9a566635bc5a241$exports = $f9a566635bc5a241$var$nativeKeysIn;


/** Used for built-in method references. */ var $4cbf7ea14b8b9de1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4cbf7ea14b8b9de1$var$hasOwnProperty = $4cbf7ea14b8b9de1$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $4cbf7ea14b8b9de1$var$baseKeysIn(object) {
    if (!$6012f8e4c7891baf$exports(object)) return $f9a566635bc5a241$exports(object);
    var isProto = $8c4ee7a33f96b8eb$exports(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$4cbf7ea14b8b9de1$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
$4cbf7ea14b8b9de1$exports = $4cbf7ea14b8b9de1$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $a33783dadb84eb22$var$keysIn(object) {
    return $dd7f3dc0af86f403$exports(object) ? $774407bad52f3924$exports(object, true) : $4cbf7ea14b8b9de1$exports(object);
}
$a33783dadb84eb22$exports = $a33783dadb84eb22$var$keysIn;


/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */ function $a5eab804fb810567$var$baseAssignIn(object, source) {
    return object && $4ff0f4755ebd80de$exports(source, $a33783dadb84eb22$exports(source), object);
}
$a5eab804fb810567$exports = $a5eab804fb810567$var$baseAssignIn;



var $6JIe0 = parcelRequire("6JIe0");
var $6ec0ec6fdea0821e$exports = {};
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $6ec0ec6fdea0821e$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
$6ec0ec6fdea0821e$exports = $6ec0ec6fdea0821e$var$copyArray;


var $ec3bd30bd99d38e7$exports = {};


/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $ec3bd30bd99d38e7$var$copySymbols(source, object) {
    return $4ff0f4755ebd80de$exports(source, $1b3f92ff973c2e2f$exports(source), object);
}
$ec3bd30bd99d38e7$exports = $ec3bd30bd99d38e7$var$copySymbols;


var $e15b830e5ed48e2f$exports = {};

var $8333b07797519b9b$exports = {};




/* Built-in method references for those with the same name as other `lodash` methods. */ var $8333b07797519b9b$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $8333b07797519b9b$var$getSymbolsIn = !$8333b07797519b9b$var$nativeGetSymbols ? $8dc2472a69a3192f$exports : function(object) {
    var result = [];
    while(object){
        $93da0abe6e6dc744$exports(result, $1b3f92ff973c2e2f$exports(object));
        object = $783269c363df86d6$exports(object);
    }
    return result;
};
$8333b07797519b9b$exports = $8333b07797519b9b$var$getSymbolsIn;


/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */ function $e15b830e5ed48e2f$var$copySymbolsIn(source, object) {
    return $4ff0f4755ebd80de$exports(source, $8333b07797519b9b$exports(source), object);
}
$e15b830e5ed48e2f$exports = $e15b830e5ed48e2f$var$copySymbolsIn;



var $38de9b6605e54d2f$exports = {};



/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $38de9b6605e54d2f$var$getAllKeysIn(object) {
    return $c109bddf0a819f91$exports(object, $a33783dadb84eb22$exports, $8333b07797519b9b$exports);
}
$38de9b6605e54d2f$exports = $38de9b6605e54d2f$var$getAllKeysIn;



var $a083df4232808e3d$exports = {};
/** Used for built-in method references. */ var $a083df4232808e3d$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $a083df4232808e3d$var$hasOwnProperty = $a083df4232808e3d$var$objectProto.hasOwnProperty;
/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */ function $a083df4232808e3d$var$initCloneArray(array) {
    var length = array.length, result = new array.constructor(length);
    // Add properties assigned by `RegExp#exec`.
    if (length && typeof array[0] == "string" && $a083df4232808e3d$var$hasOwnProperty.call(array, "index")) {
        result.index = array.index;
        result.input = array.input;
    }
    return result;
}
$a083df4232808e3d$exports = $a083df4232808e3d$var$initCloneArray;


var $76601c2ea39cf62e$exports = {};
var $63ca6b836e7432e5$exports = {};

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $63ca6b836e7432e5$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new $b12687f5cc756803$exports(result).set(new $b12687f5cc756803$exports(arrayBuffer));
    return result;
}
$63ca6b836e7432e5$exports = $63ca6b836e7432e5$var$cloneArrayBuffer;


var $d1309573ec17b2c4$exports = {};

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */ function $d1309573ec17b2c4$var$cloneDataView(dataView, isDeep) {
    var buffer = isDeep ? $63ca6b836e7432e5$exports(dataView.buffer) : dataView.buffer;
    return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}
$d1309573ec17b2c4$exports = $d1309573ec17b2c4$var$cloneDataView;


var $47df41b1cbb5ec90$exports = {};
/** Used to match `RegExp` flags from their coerced string values. */ var $47df41b1cbb5ec90$var$reFlags = /\w*$/;
/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */ function $47df41b1cbb5ec90$var$cloneRegExp(regexp) {
    var result = new regexp.constructor(regexp.source, $47df41b1cbb5ec90$var$reFlags.exec(regexp));
    result.lastIndex = regexp.lastIndex;
    return result;
}
$47df41b1cbb5ec90$exports = $47df41b1cbb5ec90$var$cloneRegExp;


var $19fdc41fea3470da$exports = {};

/** Used to convert symbols to primitives and strings. */ var $19fdc41fea3470da$var$symbolProto = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.prototype : undefined, $19fdc41fea3470da$var$symbolValueOf = $19fdc41fea3470da$var$symbolProto ? $19fdc41fea3470da$var$symbolProto.valueOf : undefined;
/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */ function $19fdc41fea3470da$var$cloneSymbol(symbol) {
    return $19fdc41fea3470da$var$symbolValueOf ? Object($19fdc41fea3470da$var$symbolValueOf.call(symbol)) : {};
}
$19fdc41fea3470da$exports = $19fdc41fea3470da$var$cloneSymbol;


var $eb77364c2d046fbd$exports = {};

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $eb77364c2d046fbd$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? $63ca6b836e7432e5$exports(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
$eb77364c2d046fbd$exports = $eb77364c2d046fbd$var$cloneTypedArray;


/** `Object#toString` result references. */ var $76601c2ea39cf62e$var$boolTag = "[object Boolean]", $76601c2ea39cf62e$var$dateTag = "[object Date]", $76601c2ea39cf62e$var$mapTag = "[object Map]", $76601c2ea39cf62e$var$numberTag = "[object Number]", $76601c2ea39cf62e$var$regexpTag = "[object RegExp]", $76601c2ea39cf62e$var$setTag = "[object Set]", $76601c2ea39cf62e$var$stringTag = "[object String]", $76601c2ea39cf62e$var$symbolTag = "[object Symbol]";
var $76601c2ea39cf62e$var$arrayBufferTag = "[object ArrayBuffer]", $76601c2ea39cf62e$var$dataViewTag = "[object DataView]", $76601c2ea39cf62e$var$float32Tag = "[object Float32Array]", $76601c2ea39cf62e$var$float64Tag = "[object Float64Array]", $76601c2ea39cf62e$var$int8Tag = "[object Int8Array]", $76601c2ea39cf62e$var$int16Tag = "[object Int16Array]", $76601c2ea39cf62e$var$int32Tag = "[object Int32Array]", $76601c2ea39cf62e$var$uint8Tag = "[object Uint8Array]", $76601c2ea39cf62e$var$uint8ClampedTag = "[object Uint8ClampedArray]", $76601c2ea39cf62e$var$uint16Tag = "[object Uint16Array]", $76601c2ea39cf62e$var$uint32Tag = "[object Uint32Array]";
/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */ function $76601c2ea39cf62e$var$initCloneByTag(object, tag, isDeep) {
    var Ctor = object.constructor;
    switch(tag){
        case $76601c2ea39cf62e$var$arrayBufferTag:
            return $63ca6b836e7432e5$exports(object);
        case $76601c2ea39cf62e$var$boolTag:
        case $76601c2ea39cf62e$var$dateTag:
            return new Ctor(+object);
        case $76601c2ea39cf62e$var$dataViewTag:
            return $d1309573ec17b2c4$exports(object, isDeep);
        case $76601c2ea39cf62e$var$float32Tag:
        case $76601c2ea39cf62e$var$float64Tag:
        case $76601c2ea39cf62e$var$int8Tag:
        case $76601c2ea39cf62e$var$int16Tag:
        case $76601c2ea39cf62e$var$int32Tag:
        case $76601c2ea39cf62e$var$uint8Tag:
        case $76601c2ea39cf62e$var$uint8ClampedTag:
        case $76601c2ea39cf62e$var$uint16Tag:
        case $76601c2ea39cf62e$var$uint32Tag:
            return $eb77364c2d046fbd$exports(object, isDeep);
        case $76601c2ea39cf62e$var$mapTag:
            return new Ctor;
        case $76601c2ea39cf62e$var$numberTag:
        case $76601c2ea39cf62e$var$stringTag:
            return new Ctor(object);
        case $76601c2ea39cf62e$var$regexpTag:
            return $47df41b1cbb5ec90$exports(object);
        case $76601c2ea39cf62e$var$setTag:
            return new Ctor;
        case $76601c2ea39cf62e$var$symbolTag:
            return $19fdc41fea3470da$exports(object);
    }
}
$76601c2ea39cf62e$exports = $76601c2ea39cf62e$var$initCloneByTag;


var $4d5fc97914eb1bd5$exports = {};
var $081f3861a12d8df3$exports = {};

/** Built-in value references. */ var $081f3861a12d8df3$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $081f3861a12d8df3$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!$6012f8e4c7891baf$exports(proto)) return {};
        if ($081f3861a12d8df3$var$objectCreate) return $081f3861a12d8df3$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
$081f3861a12d8df3$exports = $081f3861a12d8df3$var$baseCreate;




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $4d5fc97914eb1bd5$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !$8c4ee7a33f96b8eb$exports(object) ? $081f3861a12d8df3$exports($783269c363df86d6$exports(object)) : {};
}
$4d5fc97914eb1bd5$exports = $4d5fc97914eb1bd5$var$initCloneObject;




var $jrO3d = parcelRequire("jrO3d");
var $ebe742e610719272$exports = {};
var $ef8b4f27574d74e3$exports = {};


/** `Object#toString` result references. */ var $ef8b4f27574d74e3$var$mapTag = "[object Map]";
/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */ function $ef8b4f27574d74e3$var$baseIsMap(value) {
    return $61068a3203fea8d0$exports(value) && $d2a775c7e42cc499$exports(value) == $ef8b4f27574d74e3$var$mapTag;
}
$ef8b4f27574d74e3$exports = $ef8b4f27574d74e3$var$baseIsMap;




var $faAj2 = parcelRequire("faAj2");
/* Node.js helper references. */ var $ebe742e610719272$var$nodeIsMap = $faAj2 && $faAj2.isMap;
/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */ var $ebe742e610719272$var$isMap = $ebe742e610719272$var$nodeIsMap ? $ee9be00b092f853c$exports($ebe742e610719272$var$nodeIsMap) : $ef8b4f27574d74e3$exports;
$ebe742e610719272$exports = $ebe742e610719272$var$isMap;



var $c03b0aa2bca45527$exports = {};
var $f109bf8c92cf86d6$exports = {};


/** `Object#toString` result references. */ var $f109bf8c92cf86d6$var$setTag = "[object Set]";
/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */ function $f109bf8c92cf86d6$var$baseIsSet(value) {
    return $61068a3203fea8d0$exports(value) && $d2a775c7e42cc499$exports(value) == $f109bf8c92cf86d6$var$setTag;
}
$f109bf8c92cf86d6$exports = $f109bf8c92cf86d6$var$baseIsSet;




var $faAj2 = parcelRequire("faAj2");
/* Node.js helper references. */ var $c03b0aa2bca45527$var$nodeIsSet = $faAj2 && $faAj2.isSet;
/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */ var $c03b0aa2bca45527$var$isSet = $c03b0aa2bca45527$var$nodeIsSet ? $ee9be00b092f853c$exports($c03b0aa2bca45527$var$nodeIsSet) : $f109bf8c92cf86d6$exports;
$c03b0aa2bca45527$exports = $c03b0aa2bca45527$var$isSet;




/** Used to compose bitmasks for cloning. */ var $0b721e5b23a4b168$var$CLONE_DEEP_FLAG = 1, $0b721e5b23a4b168$var$CLONE_FLAT_FLAG = 2, $0b721e5b23a4b168$var$CLONE_SYMBOLS_FLAG = 4;
/** `Object#toString` result references. */ var $0b721e5b23a4b168$var$argsTag = "[object Arguments]", $0b721e5b23a4b168$var$arrayTag = "[object Array]", $0b721e5b23a4b168$var$boolTag = "[object Boolean]", $0b721e5b23a4b168$var$dateTag = "[object Date]", $0b721e5b23a4b168$var$errorTag = "[object Error]", $0b721e5b23a4b168$var$funcTag = "[object Function]", $0b721e5b23a4b168$var$genTag = "[object GeneratorFunction]", $0b721e5b23a4b168$var$mapTag = "[object Map]", $0b721e5b23a4b168$var$numberTag = "[object Number]", $0b721e5b23a4b168$var$objectTag = "[object Object]", $0b721e5b23a4b168$var$regexpTag = "[object RegExp]", $0b721e5b23a4b168$var$setTag = "[object Set]", $0b721e5b23a4b168$var$stringTag = "[object String]", $0b721e5b23a4b168$var$symbolTag = "[object Symbol]", $0b721e5b23a4b168$var$weakMapTag = "[object WeakMap]";
var $0b721e5b23a4b168$var$arrayBufferTag = "[object ArrayBuffer]", $0b721e5b23a4b168$var$dataViewTag = "[object DataView]", $0b721e5b23a4b168$var$float32Tag = "[object Float32Array]", $0b721e5b23a4b168$var$float64Tag = "[object Float64Array]", $0b721e5b23a4b168$var$int8Tag = "[object Int8Array]", $0b721e5b23a4b168$var$int16Tag = "[object Int16Array]", $0b721e5b23a4b168$var$int32Tag = "[object Int32Array]", $0b721e5b23a4b168$var$uint8Tag = "[object Uint8Array]", $0b721e5b23a4b168$var$uint8ClampedTag = "[object Uint8ClampedArray]", $0b721e5b23a4b168$var$uint16Tag = "[object Uint16Array]", $0b721e5b23a4b168$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values supported by `_.clone`. */ var $0b721e5b23a4b168$var$cloneableTags = {};
$0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$argsTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$arrayTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$arrayBufferTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$dataViewTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$boolTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$dateTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$float32Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$float64Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$int8Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$int16Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$int32Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$mapTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$numberTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$objectTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$regexpTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$setTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$stringTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$symbolTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$uint8Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$uint8ClampedTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$uint16Tag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$uint32Tag] = true;
$0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$errorTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$funcTag] = $0b721e5b23a4b168$var$cloneableTags[$0b721e5b23a4b168$var$weakMapTag] = false;
/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */ function $0b721e5b23a4b168$var$baseClone(value, bitmask, customizer, key, object, stack) {
    var result, isDeep = bitmask & $0b721e5b23a4b168$var$CLONE_DEEP_FLAG, isFlat = bitmask & $0b721e5b23a4b168$var$CLONE_FLAT_FLAG, isFull = bitmask & $0b721e5b23a4b168$var$CLONE_SYMBOLS_FLAG;
    if (customizer) result = object ? customizer(value, key, object, stack) : customizer(value);
    if (result !== undefined) return result;
    if (!$6012f8e4c7891baf$exports(value)) return value;
    var isArr = $0731a2307bf9d7f9$exports(value);
    if (isArr) {
        result = $a083df4232808e3d$exports(value);
        if (!isDeep) return $6ec0ec6fdea0821e$exports(value, result);
    } else {
        var tag = $d2a775c7e42cc499$exports(value), isFunc = tag == $0b721e5b23a4b168$var$funcTag || tag == $0b721e5b23a4b168$var$genTag;
        if ($jrO3d(value)) return $6JIe0(value, isDeep);
        if (tag == $0b721e5b23a4b168$var$objectTag || tag == $0b721e5b23a4b168$var$argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : $4d5fc97914eb1bd5$exports(value);
            if (!isDeep) return isFlat ? $e15b830e5ed48e2f$exports(value, $a5eab804fb810567$exports(result, value)) : $ec3bd30bd99d38e7$exports(value, $503523e6625fa333$exports(result, value));
        } else {
            if (!$0b721e5b23a4b168$var$cloneableTags[tag]) return object ? value : {};
            result = $76601c2ea39cf62e$exports(value, tag, isDeep);
        }
    }
    // Check for circular references and return its corresponding clone.
    stack || (stack = new $068ff3c29d5984dd$exports);
    var stacked = stack.get(value);
    if (stacked) return stacked;
    stack.set(value, result);
    if ($c03b0aa2bca45527$exports(value)) value.forEach(function(subValue) {
        result.add($0b721e5b23a4b168$var$baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
    else if ($ebe742e610719272$exports(value)) value.forEach(function(subValue, key) {
        result.set(key, $0b721e5b23a4b168$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    var keysFunc = isFull ? isFlat ? $38de9b6605e54d2f$exports : $69402b4e3bcd529f$exports : isFlat ? $a33783dadb84eb22$exports : $69c7a2966b4129b5$exports;
    var props = isArr ? undefined : keysFunc(value);
    $d73004f6bd1871e1$exports(props || value, function(subValue, key) {
        if (props) {
            key = subValue;
            subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        $2f00d2d68c13dbd3$exports(result, key, $0b721e5b23a4b168$var$baseClone(subValue, bitmask, customizer, key, value, stack));
    });
    return result;
}
$0b721e5b23a4b168$exports = $0b721e5b23a4b168$var$baseClone;


/** Used to compose bitmasks for cloning. */ var $dcce9dfec18e8f22$var$CLONE_DEEP_FLAG = 1, $dcce9dfec18e8f22$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */ function $dcce9dfec18e8f22$var$cloneDeep(value) {
    return $0b721e5b23a4b168$exports(value, $dcce9dfec18e8f22$var$CLONE_DEEP_FLAG | $dcce9dfec18e8f22$var$CLONE_SYMBOLS_FLAG);
}
$dcce9dfec18e8f22$exports = $dcce9dfec18e8f22$var$cloneDeep;


var $2048e7aad89867d3$var$_cloneDeep3 = $2048e7aad89867d3$var$_interopRequireDefault($dcce9dfec18e8f22$exports);
var $2048e7aad89867d3$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $2048e7aad89867d3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $2048e7aad89867d3$var$mergeClasses = $2048e7aad89867d3$exports.mergeClasses = function mergeClasses(classes) {
    var activeNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var styles = classes.default && (0, $2048e7aad89867d3$var$_cloneDeep3.default)(classes.default) || {};
    activeNames.map(function(name) {
        var toMerge = classes[name];
        if (toMerge) (0, $2048e7aad89867d3$var$_forOwn3.default)(toMerge, function(value, key) {
            if (!styles[key]) styles[key] = {};
            styles[key] = $2048e7aad89867d3$var$_extends({}, styles[key], toMerge[key]);
        });
        return name;
    });
    return styles;
};
$2048e7aad89867d3$exports.default = $2048e7aad89867d3$var$mergeClasses;


var $30b13a56cd0faccc$var$_mergeClasses2 = $30b13a56cd0faccc$var$_interopRequireDefault($2048e7aad89867d3$exports);
var $84d4ac8f907de5bf$exports = {};
"use strict";
Object.defineProperty($84d4ac8f907de5bf$exports, "__esModule", {
    value: true
});
$84d4ac8f907de5bf$exports.autoprefix = undefined;

var $84d4ac8f907de5bf$var$_forOwn3 = $84d4ac8f907de5bf$var$_interopRequireDefault($ad6e8de3503db2ef$exports);
var $84d4ac8f907de5bf$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $84d4ac8f907de5bf$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $84d4ac8f907de5bf$var$transforms = {
    borderRadius: function borderRadius(value) {
        return {
            msBorderRadius: value,
            MozBorderRadius: value,
            OBorderRadius: value,
            WebkitBorderRadius: value,
            borderRadius: value
        };
    },
    boxShadow: function boxShadow(value) {
        return {
            msBoxShadow: value,
            MozBoxShadow: value,
            OBoxShadow: value,
            WebkitBoxShadow: value,
            boxShadow: value
        };
    },
    userSelect: function userSelect(value) {
        return {
            WebkitTouchCallout: value,
            KhtmlUserSelect: value,
            MozUserSelect: value,
            msUserSelect: value,
            WebkitUserSelect: value,
            userSelect: value
        };
    },
    flex: function flex(value) {
        return {
            WebkitBoxFlex: value,
            MozBoxFlex: value,
            WebkitFlex: value,
            msFlex: value,
            flex: value
        };
    },
    flexBasis: function flexBasis(value) {
        return {
            WebkitFlexBasis: value,
            flexBasis: value
        };
    },
    justifyContent: function justifyContent(value) {
        return {
            WebkitJustifyContent: value,
            justifyContent: value
        };
    },
    transition: function transition(value) {
        return {
            msTransition: value,
            MozTransition: value,
            OTransition: value,
            WebkitTransition: value,
            transition: value
        };
    },
    transform: function transform(value) {
        return {
            msTransform: value,
            MozTransform: value,
            OTransform: value,
            WebkitTransform: value,
            transform: value
        };
    },
    absolute: function absolute(value) {
        var direction = value && value.split(" ");
        return {
            position: "absolute",
            top: direction && direction[0],
            right: direction && direction[1],
            bottom: direction && direction[2],
            left: direction && direction[3]
        };
    },
    extend: function extend(name, otherElementStyles) {
        var otherStyle = otherElementStyles[name];
        if (otherStyle) return otherStyle;
        return {
            "extend": name
        };
    }
};
var $84d4ac8f907de5bf$var$autoprefix = $84d4ac8f907de5bf$exports.autoprefix = function autoprefix(elements) {
    var prefixed = {};
    (0, $84d4ac8f907de5bf$var$_forOwn3.default)(elements, function(styles, element) {
        var expanded = {};
        (0, $84d4ac8f907de5bf$var$_forOwn3.default)(styles, function(value, key) {
            var transform = $84d4ac8f907de5bf$var$transforms[key];
            if (transform) expanded = $84d4ac8f907de5bf$var$_extends({}, expanded, transform(value));
            else expanded[key] = value;
        });
        prefixed[element] = expanded;
    });
    return prefixed;
};
$84d4ac8f907de5bf$exports.default = $84d4ac8f907de5bf$var$autoprefix;


var $30b13a56cd0faccc$var$_autoprefix2 = $30b13a56cd0faccc$var$_interopRequireDefault($84d4ac8f907de5bf$exports);
var $c16c7acbdf1c8868$exports = {};
"use strict";
Object.defineProperty($c16c7acbdf1c8868$exports, "__esModule", {
    value: true
});
$c16c7acbdf1c8868$exports.hover = undefined;
var $c16c7acbdf1c8868$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eCoWV = parcelRequire("eCoWV");
var $c16c7acbdf1c8868$var$_react2 = $c16c7acbdf1c8868$var$_interopRequireDefault($eCoWV);
function $c16c7acbdf1c8868$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c16c7acbdf1c8868$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c16c7acbdf1c8868$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $c16c7acbdf1c8868$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $c16c7acbdf1c8868$var$hover = $c16c7acbdf1c8868$exports.hover = function hover(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $c16c7acbdf1c8868$var$_inherits(Hover, _React$Component);
        function Hover() {
            var _ref;
            var _temp, _this, _ret;
            $c16c7acbdf1c8868$var$_classCallCheck(this, Hover);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $c16c7acbdf1c8868$var$_possibleConstructorReturn(this, (_ref = Hover.__proto__ || Object.getPrototypeOf(Hover)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                hover: false
            }, _this.handleMouseOver = function() {
                return _this.setState({
                    hover: true
                });
            }, _this.handleMouseOut = function() {
                return _this.setState({
                    hover: false
                });
            }, _this.render = function() {
                return $c16c7acbdf1c8868$var$_react2.default.createElement(Span, {
                    onMouseOver: _this.handleMouseOver,
                    onMouseOut: _this.handleMouseOut
                }, $c16c7acbdf1c8868$var$_react2.default.createElement(Component, $c16c7acbdf1c8868$var$_extends({}, _this.props, _this.state)));
            }, _temp), $c16c7acbdf1c8868$var$_possibleConstructorReturn(_this, _ret);
        }
        return Hover;
    }($c16c7acbdf1c8868$var$_react2.default.Component);
};
$c16c7acbdf1c8868$exports.default = $c16c7acbdf1c8868$var$hover;


var $30b13a56cd0faccc$var$_hover3 = $30b13a56cd0faccc$var$_interopRequireDefault($c16c7acbdf1c8868$exports);
var $d0921dcb1d5aa2f7$exports = {};
"use strict";
Object.defineProperty($d0921dcb1d5aa2f7$exports, "__esModule", {
    value: true
});
$d0921dcb1d5aa2f7$exports.active = undefined;
var $d0921dcb1d5aa2f7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eCoWV = parcelRequire("eCoWV");
var $d0921dcb1d5aa2f7$var$_react2 = $d0921dcb1d5aa2f7$var$_interopRequireDefault($eCoWV);
function $d0921dcb1d5aa2f7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0921dcb1d5aa2f7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d0921dcb1d5aa2f7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d0921dcb1d5aa2f7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d0921dcb1d5aa2f7$var$active = $d0921dcb1d5aa2f7$exports.active = function active(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $d0921dcb1d5aa2f7$var$_inherits(Active, _React$Component);
        function Active() {
            var _ref;
            var _temp, _this, _ret;
            $d0921dcb1d5aa2f7$var$_classCallCheck(this, Active);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $d0921dcb1d5aa2f7$var$_possibleConstructorReturn(this, (_ref = Active.__proto__ || Object.getPrototypeOf(Active)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                active: false
            }, _this.handleMouseDown = function() {
                return _this.setState({
                    active: true
                });
            }, _this.handleMouseUp = function() {
                return _this.setState({
                    active: false
                });
            }, _this.render = function() {
                return $d0921dcb1d5aa2f7$var$_react2.default.createElement(Span, {
                    onMouseDown: _this.handleMouseDown,
                    onMouseUp: _this.handleMouseUp
                }, $d0921dcb1d5aa2f7$var$_react2.default.createElement(Component, $d0921dcb1d5aa2f7$var$_extends({}, _this.props, _this.state)));
            }, _temp), $d0921dcb1d5aa2f7$var$_possibleConstructorReturn(_this, _ret);
        }
        return Active;
    }($d0921dcb1d5aa2f7$var$_react2.default.Component);
};
$d0921dcb1d5aa2f7$exports.default = $d0921dcb1d5aa2f7$var$active;


var $30b13a56cd0faccc$var$_active2 = $30b13a56cd0faccc$var$_interopRequireDefault($d0921dcb1d5aa2f7$exports);
var $611c8bb84e0bc956$exports = {};
"use strict";
Object.defineProperty($611c8bb84e0bc956$exports, "__esModule", {
    value: true
});
var $611c8bb84e0bc956$var$loopable = function loopable(i, length) {
    var props = {};
    var setProp = function setProp(name) {
        var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        props[name] = value;
    };
    i === 0 && setProp("first-child");
    i === length - 1 && setProp("last-child");
    (i === 0 || i % 2 === 0) && setProp("even");
    Math.abs(i % 2) === 1 && setProp("odd");
    setProp("nth-child", i);
    return props;
};
$611c8bb84e0bc956$exports.default = $611c8bb84e0bc956$var$loopable;


var $30b13a56cd0faccc$var$_loop3 = $30b13a56cd0faccc$var$_interopRequireDefault($611c8bb84e0bc956$exports);
function $30b13a56cd0faccc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$30b13a56cd0faccc$exports.hover = $30b13a56cd0faccc$var$_hover3.default;
$30b13a56cd0faccc$exports.handleHover = $30b13a56cd0faccc$var$_hover3.default;
$30b13a56cd0faccc$exports.handleActive = $30b13a56cd0faccc$var$_active2.default;
$30b13a56cd0faccc$exports.loop = $30b13a56cd0faccc$var$_loop3.default;
var $30b13a56cd0faccc$var$ReactCSS = $30b13a56cd0faccc$exports.ReactCSS = function ReactCSS(classes) {
    for(var _len = arguments.length, activations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)activations[_key - 1] = arguments[_key];
    var activeNames = (0, $30b13a56cd0faccc$var$_flattenNames2.default)(activations);
    var merged = (0, $30b13a56cd0faccc$var$_mergeClasses2.default)(classes, activeNames);
    return (0, $30b13a56cd0faccc$var$_autoprefix2.default)(merged);
};
$30b13a56cd0faccc$exports.default = $30b13a56cd0faccc$var$ReactCSS;



var $eCoWV = parcelRequire("eCoWV");

var $430c2098e013e3aa$export$a056a977bf6a9a3c = function calculateChange(e, hsl, direction, initialA, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var a = void 0;
        if (top < 0) a = 0;
        else if (top > containerHeight) a = 1;
        else a = Math.round(top * 100 / containerHeight) / 100;
        if (hsl.a !== a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: a,
            source: "rgb"
        };
    } else {
        var _a = void 0;
        if (left < 0) _a = 0;
        else if (left > containerWidth) _a = 1;
        else _a = Math.round(left * 100 / containerWidth) / 100;
        if (initialA !== _a) return {
            h: hsl.h,
            s: hsl.s,
            l: hsl.l,
            a: _a,
            source: "rgb"
        };
    }
    return null;
};



var $eCoWV = parcelRequire("eCoWV");

var $4ac7c0436aa15619$var$checkboardCache = {};
var $4ac7c0436aa15619$export$b3890eb0ae9dca99 = function render(c1, c2, size, serverCanvas) {
    if (typeof document === "undefined" && !serverCanvas) return null;
    var canvas = serverCanvas ? new serverCanvas() : document.createElement("canvas");
    canvas.width = size * 2;
    canvas.height = size * 2;
    var ctx = canvas.getContext("2d");
    if (!ctx) return null;
     // If no context can be found, return early.
    ctx.fillStyle = c1;
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    ctx.fillStyle = c2;
    ctx.fillRect(0, 0, size, size);
    ctx.translate(size, size);
    ctx.fillRect(0, 0, size, size);
    return canvas.toDataURL();
};
var $4ac7c0436aa15619$export$3988ae62b71be9a3 = function get(c1, c2, size, serverCanvas) {
    var key = c1 + "-" + c2 + "-" + size + (serverCanvas ? "-server" : "");
    if ($4ac7c0436aa15619$var$checkboardCache[key]) return $4ac7c0436aa15619$var$checkboardCache[key];
    var checkboard = $4ac7c0436aa15619$export$b3890eb0ae9dca99(c1, c2, size, serverCanvas);
    $4ac7c0436aa15619$var$checkboardCache[key] = checkboard;
    return checkboard;
};


var $49a998e72892ed67$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $49a998e72892ed67$export$457ff74489f64b4a = function Checkboard(_ref) {
    var white = _ref.white, grey = _ref.grey, size = _ref.size, renderers = _ref.renderers, borderRadius = _ref.borderRadius, boxShadow = _ref.boxShadow, children = _ref.children;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            grid: {
                borderRadius: borderRadius,
                boxShadow: boxShadow,
                absolute: "0px 0px 0px 0px",
                background: "url(" + $4ac7c0436aa15619$export$3988ae62b71be9a3(white, grey, size, renderers.canvas) + ") center left"
            }
        }
    });
    return (0, $eCoWV.isValidElement)(children) ? (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(children, $49a998e72892ed67$var$_extends({}, children.props, {
        style: $49a998e72892ed67$var$_extends({}, children.props.style, styles.grid)
    })) : (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.grid
    });
};
$49a998e72892ed67$export$457ff74489f64b4a.defaultProps = {
    size: 8,
    white: "transparent",
    grey: "rgba(0,0,0,.08)",
    renderers: {}
};
var $49a998e72892ed67$export$2e2bcd8739ae039 = $49a998e72892ed67$export$457ff74489f64b4a;


var $cf5fa3fd43734c4f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $cf5fa3fd43734c4f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $cf5fa3fd43734c4f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cf5fa3fd43734c4f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $cf5fa3fd43734c4f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $cf5fa3fd43734c4f$export$b3d0ceb706f8af43 = function(_ref) {
    $cf5fa3fd43734c4f$var$_inherits(Alpha, _ref);
    function Alpha() {
        var _ref2;
        var _temp, _this, _ret;
        $cf5fa3fd43734c4f$var$_classCallCheck(this, Alpha);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $cf5fa3fd43734c4f$var$_possibleConstructorReturn(this, (_ref2 = Alpha.__proto__ || Object.getPrototypeOf(Alpha)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $430c2098e013e3aa$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.props.direction, _this.props.a, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleChange);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        }, _temp), $cf5fa3fd43734c4f$var$_possibleConstructorReturn(_this, _ret);
    }
    $cf5fa3fd43734c4f$var$_createClass(Alpha, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var rgb = this.props.rgb;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
                    "default": {
                        alpha: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        checkboard: {
                            absolute: "0px 0px 0px 0px",
                            overflow: "hidden",
                            borderRadius: this.props.radius
                        },
                        gradient: {
                            absolute: "0px 0px 0px 0px",
                            background: "linear-gradient(to right, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        container: {
                            position: "relative",
                            height: "100%",
                            margin: "0 3px"
                        },
                        pointer: {
                            position: "absolute",
                            left: rgb.a * 100 + "%"
                        },
                        slider: {
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            marginTop: "1px",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        gradient: {
                            background: "linear-gradient(to bottom, rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 0) 0%,\n           rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + ", 1) 100%)"
                        },
                        pointer: {
                            left: 0,
                            top: rgb.a * 100 + "%"
                        }
                    },
                    "overwrite": $cf5fa3fd43734c4f$var$_extends({}, this.props.style)
                }, {
                    vertical: this.props.direction === "vertical",
                    overwrite: true
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.checkboard
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $49a998e72892ed67$export$2e2bcd8739ae039), {
                    renderers: this.props.renderers
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.gradient
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Alpha;
}((0, $eCoWV.PureComponent) || (0, $eCoWV.Component));
var $cf5fa3fd43734c4f$export$2e2bcd8739ae039 = $cf5fa3fd43734c4f$export$b3d0ceb706f8af43;




var $eCoWV = parcelRequire("eCoWV");

var $87c5b25e869e3a91$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $87c5b25e869e3a91$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $87c5b25e869e3a91$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $87c5b25e869e3a91$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $87c5b25e869e3a91$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $87c5b25e869e3a91$var$DEFAULT_ARROW_OFFSET = 1;
var $87c5b25e869e3a91$var$UP_KEY_CODE = 38;
var $87c5b25e869e3a91$var$DOWN_KEY_CODE = 40;
var $87c5b25e869e3a91$var$VALID_KEY_CODES = [
    $87c5b25e869e3a91$var$UP_KEY_CODE,
    $87c5b25e869e3a91$var$DOWN_KEY_CODE
];
var $87c5b25e869e3a91$var$isValidKeyCode = function isValidKeyCode(keyCode) {
    return $87c5b25e869e3a91$var$VALID_KEY_CODES.indexOf(keyCode) > -1;
};
var $87c5b25e869e3a91$var$getNumberValue = function getNumberValue(value) {
    return Number(String(value).replace(/%/g, ""));
};
var $87c5b25e869e3a91$var$idCounter = 1;
var $87c5b25e869e3a91$export$bfb3cbb78d3c298 = function(_ref) {
    $87c5b25e869e3a91$var$_inherits(EditableInput, _ref);
    function EditableInput(props) {
        $87c5b25e869e3a91$var$_classCallCheck(this, EditableInput);
        var _this = $87c5b25e869e3a91$var$_possibleConstructorReturn(this, (EditableInput.__proto__ || Object.getPrototypeOf(EditableInput)).call(this));
        _this.handleBlur = function() {
            if (_this.state.blurValue) _this.setState({
                value: _this.state.blurValue,
                blurValue: null
            });
        };
        _this.handleChange = function(e) {
            _this.setUpdatedValue(e.target.value, e);
        };
        _this.handleKeyDown = function(e) {
            // In case `e.target.value` is a percentage remove the `%` character
            // and update accordingly with a percentage
            // https://github.com/casesandberg/react-color/issues/383
            var value = $87c5b25e869e3a91$var$getNumberValue(e.target.value);
            if (!isNaN(value) && $87c5b25e869e3a91$var$isValidKeyCode(e.keyCode)) {
                var offset = _this.getArrowOffset();
                var updatedValue = e.keyCode === $87c5b25e869e3a91$var$UP_KEY_CODE ? value + offset : value - offset;
                _this.setUpdatedValue(updatedValue, e);
            }
        };
        _this.handleDrag = function(e) {
            if (_this.props.dragLabel) {
                var newValue = Math.round(_this.props.value + e.movementX);
                if (newValue >= 0 && newValue <= _this.props.dragMax) _this.props.onChange && _this.props.onChange(_this.getValueObjectWithLabel(newValue), e);
            }
        };
        _this.handleMouseDown = function(e) {
            if (_this.props.dragLabel) {
                e.preventDefault();
                _this.handleDrag(e);
                window.addEventListener("mousemove", _this.handleDrag);
                window.addEventListener("mouseup", _this.handleMouseUp);
            }
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.unbindEventListeners = function() {
            window.removeEventListener("mousemove", _this.handleDrag);
            window.removeEventListener("mouseup", _this.handleMouseUp);
        };
        _this.state = {
            value: String(props.value).toUpperCase(),
            blurValue: String(props.value).toUpperCase()
        };
        _this.inputId = "rc-editable-input-" + $87c5b25e869e3a91$var$idCounter++;
        return _this;
    }
    $87c5b25e869e3a91$var$_createClass(EditableInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                if (this.props.value !== this.state.value && (prevProps.value !== this.props.value || prevState.value !== this.state.value)) {
                    if (this.input === document.activeElement) this.setState({
                        blurValue: String(this.props.value).toUpperCase()
                    });
                    else this.setState({
                        value: String(this.props.value).toUpperCase(),
                        blurValue: !this.state.blurValue && String(this.props.value).toUpperCase()
                    });
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "getValueObjectWithLabel",
            value: function getValueObjectWithLabel(value) {
                return $87c5b25e869e3a91$var$_defineProperty({}, this.props.label, value);
            }
        },
        {
            key: "getArrowOffset",
            value: function getArrowOffset() {
                return this.props.arrowOffset || $87c5b25e869e3a91$var$DEFAULT_ARROW_OFFSET;
            }
        },
        {
            key: "setUpdatedValue",
            value: function setUpdatedValue(value, e) {
                var onChangeValue = this.props.label ? this.getValueObjectWithLabel(value) : value;
                this.props.onChange && this.props.onChange(onChangeValue, e);
                this.setState({
                    value: value
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
                    "default": {
                        wrap: {
                            position: "relative"
                        }
                    },
                    "user-override": {
                        wrap: this.props.style && this.props.style.wrap ? this.props.style.wrap : {},
                        input: this.props.style && this.props.style.input ? this.props.style.input : {},
                        label: this.props.style && this.props.style.label ? this.props.style.label : {}
                    },
                    "dragLabel-true": {
                        label: {
                            cursor: "ew-resize"
                        }
                    }
                }, {
                    "user-override": true
                }, this.props);
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.wrap
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("input", {
                    id: this.inputId,
                    style: styles.input,
                    ref: function ref(input) {
                        return _this2.input = input;
                    },
                    value: this.state.value,
                    onKeyDown: this.handleKeyDown,
                    onChange: this.handleChange,
                    onBlur: this.handleBlur,
                    placeholder: this.props.placeholder,
                    spellCheck: "false"
                }), this.props.label && !this.props.hideLabel ? (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("label", {
                    htmlFor: this.inputId,
                    style: styles.label,
                    onMouseDown: this.handleMouseDown
                }, this.props.label) : null);
            }
        }
    ]);
    return EditableInput;
}((0, $eCoWV.PureComponent) || (0, $eCoWV.Component));
var $87c5b25e869e3a91$export$2e2bcd8739ae039 = $87c5b25e869e3a91$export$bfb3cbb78d3c298;



var $eCoWV = parcelRequire("eCoWV");

var $f528f406a0c8f2bd$export$a056a977bf6a9a3c = function calculateChange(e, direction, hsl, container) {
    var containerWidth = container.clientWidth;
    var containerHeight = container.clientHeight;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (direction === "vertical") {
        var h = void 0;
        if (top < 0) h = 359;
        else if (top > containerHeight) h = 0;
        else {
            var percent = -(top * 100 / containerHeight) + 100;
            h = 360 * percent / 100;
        }
        if (hsl.h !== h) return {
            h: h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    } else {
        var _h = void 0;
        if (left < 0) _h = 0;
        else if (left > containerWidth) _h = 359;
        else {
            var _percent = left * 100 / containerWidth;
            _h = 360 * _percent / 100;
        }
        if (hsl.h !== _h) return {
            h: _h,
            s: hsl.s,
            l: hsl.l,
            a: hsl.a,
            source: "hsl"
        };
    }
    return null;
};


var $b35a081ce1a7aeeb$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $b35a081ce1a7aeeb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b35a081ce1a7aeeb$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $b35a081ce1a7aeeb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $b35a081ce1a7aeeb$export$3e22a96a58989a47 = function(_ref) {
    $b35a081ce1a7aeeb$var$_inherits(Hue, _ref);
    function Hue() {
        var _ref2;
        var _temp, _this, _ret;
        $b35a081ce1a7aeeb$var$_classCallCheck(this, Hue);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $b35a081ce1a7aeeb$var$_possibleConstructorReturn(this, (_ref2 = Hue.__proto__ || Object.getPrototypeOf(Hue)).call.apply(_ref2, [
            this
        ].concat(args))), _this), _this.handleChange = function(e) {
            var change = $f528f406a0c8f2bd$export$a056a977bf6a9a3c(e, _this.props.direction, _this.props.hsl, _this.container);
            change && typeof _this.props.onChange === "function" && _this.props.onChange(change, e);
        }, _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            window.addEventListener("mousemove", _this.handleChange);
            window.addEventListener("mouseup", _this.handleMouseUp);
        }, _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        }, _temp), $b35a081ce1a7aeeb$var$_possibleConstructorReturn(_this, _ret);
    }
    $b35a081ce1a7aeeb$var$_createClass(Hue, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.unbindEventListeners();
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                window.removeEventListener("mousemove", this.handleChange);
                window.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _props$direction = this.props.direction, direction = _props$direction === undefined ? "horizontal" : _props$direction;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
                    "default": {
                        hue: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius,
                            boxShadow: this.props.shadow
                        },
                        container: {
                            padding: "0 2px",
                            position: "relative",
                            height: "100%",
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            left: this.props.hsl.h * 100 / 360 + "%"
                        },
                        slider: {
                            marginTop: "1px",
                            width: "4px",
                            borderRadius: "1px",
                            height: "8px",
                            boxShadow: "0 0 2px rgba(0, 0, 0, .6)",
                            background: "#fff",
                            transform: "translateX(-2px)"
                        }
                    },
                    "vertical": {
                        pointer: {
                            left: "0px",
                            top: -(this.props.hsl.h * 100 / 360) + 100 + "%"
                        }
                    }
                }, {
                    vertical: direction === "vertical"
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    className: "hue-" + direction,
                    style: styles.container,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("style", null, "\n            .hue-horizontal {\n              background: linear-gradient(to right, #f00 0%, #ff0 17%, #0f0\n                33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to right, #f00 0%, #ff0\n                17%, #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n\n            .hue-vertical {\n              background: linear-gradient(to top, #f00 0%, #ff0 17%, #0f0 33%,\n                #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n              background: -webkit-linear-gradient(to top, #f00 0%, #ff0 17%,\n                #0f0 33%, #0ff 50%, #00f 67%, #f0f 83%, #f00 100%);\n            }\n          "), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.slider
                }))));
            }
        }
    ]);
    return Hue;
}((0, $eCoWV.PureComponent) || (0, $eCoWV.Component));
var $b35a081ce1a7aeeb$export$2e2bcd8739ae039 = $b35a081ce1a7aeeb$export$3e22a96a58989a47;



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $e7e7ec44717ff097$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $e7e7ec44717ff097$export$2e2bcd8739ae039 = $e7e7ec44717ff097$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $4e9d5455d0a9da98$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $4e9d5455d0a9da98$export$2e2bcd8739ae039 = $4e9d5455d0a9da98$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $077d26fc8c5d54eb$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $4e9d5455d0a9da98$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $077d26fc8c5d54eb$export$2e2bcd8739ae039 = $077d26fc8c5d54eb$var$assocIndexOf;


/** Used for built-in method references. */ var $f2c8c6659a4098a9$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $f2c8c6659a4098a9$var$splice = $f2c8c6659a4098a9$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f2c8c6659a4098a9$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $077d26fc8c5d54eb$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $f2c8c6659a4098a9$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $f2c8c6659a4098a9$export$2e2bcd8739ae039 = $f2c8c6659a4098a9$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $6813f65ef6d999de$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $077d26fc8c5d54eb$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $6813f65ef6d999de$export$2e2bcd8739ae039 = $6813f65ef6d999de$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $691d5e165924d3d1$var$listCacheHas(key) {
    return (0, $077d26fc8c5d54eb$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $691d5e165924d3d1$export$2e2bcd8739ae039 = $691d5e165924d3d1$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $1bad54f7f9483f9e$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $077d26fc8c5d54eb$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $1bad54f7f9483f9e$export$2e2bcd8739ae039 = $1bad54f7f9483f9e$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $e43fd33af7fad882$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$e43fd33af7fad882$var$ListCache.prototype.clear = (0, $e7e7ec44717ff097$export$2e2bcd8739ae039);
$e43fd33af7fad882$var$ListCache.prototype["delete"] = (0, $f2c8c6659a4098a9$export$2e2bcd8739ae039);
$e43fd33af7fad882$var$ListCache.prototype.get = (0, $6813f65ef6d999de$export$2e2bcd8739ae039);
$e43fd33af7fad882$var$ListCache.prototype.has = (0, $691d5e165924d3d1$export$2e2bcd8739ae039);
$e43fd33af7fad882$var$ListCache.prototype.set = (0, $1bad54f7f9483f9e$export$2e2bcd8739ae039);
var $e43fd33af7fad882$export$2e2bcd8739ae039 = $e43fd33af7fad882$var$ListCache;



/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function $552066279c535aed$var$stackClear() {
    this.__data__ = new (0, $e43fd33af7fad882$export$2e2bcd8739ae039);
    this.size = 0;
}
var $552066279c535aed$export$2e2bcd8739ae039 = $552066279c535aed$var$stackClear;


/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $eaf8b9f443875130$var$stackDelete(key) {
    var data = this.__data__, result = data["delete"](key);
    this.size = data.size;
    return result;
}
var $eaf8b9f443875130$export$2e2bcd8739ae039 = $eaf8b9f443875130$var$stackDelete;


/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4df392d1742a9028$var$stackGet(key) {
    return this.__data__.get(key);
}
var $4df392d1742a9028$export$2e2bcd8739ae039 = $4df392d1742a9028$var$stackGet;


/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $cab483f6b888a67a$var$stackHas(key) {
    return this.__data__.has(key);
}
var $cab483f6b888a67a$export$2e2bcd8739ae039 = $cab483f6b888a67a$var$stackHas;




var $etFod = parcelRequire("etFod");
/** Built-in value references. */ var $375e3a674890bf85$var$Symbol = (0, $etFod.default).Symbol;
var $375e3a674890bf85$export$2e2bcd8739ae039 = $375e3a674890bf85$var$Symbol;



/** Used for built-in method references. */ var $3e411a48b0ed9ffe$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e411a48b0ed9ffe$var$hasOwnProperty = $3e411a48b0ed9ffe$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3e411a48b0ed9ffe$var$nativeObjectToString = $3e411a48b0ed9ffe$var$objectProto.toString;
/** Built-in value references. */ var $3e411a48b0ed9ffe$var$symToStringTag = (0, $375e3a674890bf85$export$2e2bcd8739ae039) ? (0, $375e3a674890bf85$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3e411a48b0ed9ffe$var$getRawTag(value) {
    var isOwn = $3e411a48b0ed9ffe$var$hasOwnProperty.call(value, $3e411a48b0ed9ffe$var$symToStringTag), tag = value[$3e411a48b0ed9ffe$var$symToStringTag];
    try {
        value[$3e411a48b0ed9ffe$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3e411a48b0ed9ffe$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3e411a48b0ed9ffe$var$symToStringTag] = tag;
        else delete value[$3e411a48b0ed9ffe$var$symToStringTag];
    }
    return result;
}
var $3e411a48b0ed9ffe$export$2e2bcd8739ae039 = $3e411a48b0ed9ffe$var$getRawTag;


/** Used for built-in method references. */ var $440c9d12a3ff7e81$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $440c9d12a3ff7e81$var$nativeObjectToString = $440c9d12a3ff7e81$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $440c9d12a3ff7e81$var$objectToString(value) {
    return $440c9d12a3ff7e81$var$nativeObjectToString.call(value);
}
var $440c9d12a3ff7e81$export$2e2bcd8739ae039 = $440c9d12a3ff7e81$var$objectToString;


/** `Object#toString` result references. */ var $719a43f053b573ae$var$nullTag = "[object Null]", $719a43f053b573ae$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $719a43f053b573ae$var$symToStringTag = (0, $375e3a674890bf85$export$2e2bcd8739ae039) ? (0, $375e3a674890bf85$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $719a43f053b573ae$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $719a43f053b573ae$var$undefinedTag : $719a43f053b573ae$var$nullTag;
    return $719a43f053b573ae$var$symToStringTag && $719a43f053b573ae$var$symToStringTag in Object(value) ? (0, $3e411a48b0ed9ffe$export$2e2bcd8739ae039)(value) : (0, $440c9d12a3ff7e81$export$2e2bcd8739ae039)(value);
}
var $719a43f053b573ae$export$2e2bcd8739ae039 = $719a43f053b573ae$var$baseGetTag;


/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $0fe00e6dc0c0afea$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $0fe00e6dc0c0afea$export$2e2bcd8739ae039 = $0fe00e6dc0c0afea$var$isObject;


/** `Object#toString` result references. */ var $ffe84544d7ecb295$var$asyncTag = "[object AsyncFunction]", $ffe84544d7ecb295$var$funcTag = "[object Function]", $ffe84544d7ecb295$var$genTag = "[object GeneratorFunction]", $ffe84544d7ecb295$var$proxyTag = "[object Proxy]";
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $ffe84544d7ecb295$var$isFunction(value) {
    if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $719a43f053b573ae$export$2e2bcd8739ae039)(value);
    return tag == $ffe84544d7ecb295$var$funcTag || tag == $ffe84544d7ecb295$var$genTag || tag == $ffe84544d7ecb295$var$asyncTag || tag == $ffe84544d7ecb295$var$proxyTag;
}
var $ffe84544d7ecb295$export$2e2bcd8739ae039 = $ffe84544d7ecb295$var$isFunction;



var $etFod = parcelRequire("etFod");
/** Used to detect overreaching core-js shims. */ var $aacb96ce59a78930$var$coreJsData = (0, $etFod.default)["__core-js_shared__"];
var $aacb96ce59a78930$export$2e2bcd8739ae039 = $aacb96ce59a78930$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $bf7b266120532277$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $aacb96ce59a78930$export$2e2bcd8739ae039) && (0, $aacb96ce59a78930$export$2e2bcd8739ae039).keys && (0, $aacb96ce59a78930$export$2e2bcd8739ae039).keys.IE_PROTO || "");
    return uid ? "Symbol(src)_1." + uid : "";
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $bf7b266120532277$var$isMasked(func) {
    return !!$bf7b266120532277$var$maskSrcKey && $bf7b266120532277$var$maskSrcKey in func;
}
var $bf7b266120532277$export$2e2bcd8739ae039 = $bf7b266120532277$var$isMasked;



/** Used for built-in method references. */ var $6cf9d01331166732$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $6cf9d01331166732$var$funcToString = $6cf9d01331166732$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $6cf9d01331166732$var$toSource(func) {
    if (func != null) {
        try {
            return $6cf9d01331166732$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + "";
        } catch (e) {}
    }
    return "";
}
var $6cf9d01331166732$export$2e2bcd8739ae039 = $6cf9d01331166732$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $cdbff1e86734dc96$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $cdbff1e86734dc96$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $cdbff1e86734dc96$var$funcProto = Function.prototype, $cdbff1e86734dc96$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $cdbff1e86734dc96$var$funcToString = $cdbff1e86734dc96$var$funcProto.toString;
/** Used to check objects for own properties. */ var $cdbff1e86734dc96$var$hasOwnProperty = $cdbff1e86734dc96$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $cdbff1e86734dc96$var$reIsNative = RegExp("^" + $cdbff1e86734dc96$var$funcToString.call($cdbff1e86734dc96$var$hasOwnProperty).replace($cdbff1e86734dc96$var$reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $cdbff1e86734dc96$var$baseIsNative(value) {
    if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(value) || (0, $bf7b266120532277$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $ffe84544d7ecb295$export$2e2bcd8739ae039)(value) ? $cdbff1e86734dc96$var$reIsNative : $cdbff1e86734dc96$var$reIsHostCtor;
    return pattern.test((0, $6cf9d01331166732$export$2e2bcd8739ae039)(value));
}
var $cdbff1e86734dc96$export$2e2bcd8739ae039 = $cdbff1e86734dc96$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $f5256c66c953fdf3$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $f5256c66c953fdf3$export$2e2bcd8739ae039 = $f5256c66c953fdf3$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $ff6df215563dc77b$var$getNative(object, key) {
    var value = (0, $f5256c66c953fdf3$export$2e2bcd8739ae039)(object, key);
    return (0, $cdbff1e86734dc96$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $ff6df215563dc77b$export$2e2bcd8739ae039 = $ff6df215563dc77b$var$getNative;



var $etFod = parcelRequire("etFod");
/* Built-in method references that are verified to be native. */ var $19ce6fac2831f009$var$Map = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)((0, $etFod.default), "Map");
var $19ce6fac2831f009$export$2e2bcd8739ae039 = $19ce6fac2831f009$var$Map;



/* Built-in method references that are verified to be native. */ var $10ec6451695236a1$var$nativeCreate = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)(Object, "create");
var $10ec6451695236a1$export$2e2bcd8739ae039 = $10ec6451695236a1$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $23e870847fe5897d$var$hashClear() {
    this.__data__ = (0, $10ec6451695236a1$export$2e2bcd8739ae039) ? (0, $10ec6451695236a1$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $23e870847fe5897d$export$2e2bcd8739ae039 = $23e870847fe5897d$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $3e3a9d9865b9aa36$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $3e3a9d9865b9aa36$export$2e2bcd8739ae039 = $3e3a9d9865b9aa36$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $7f14bb363480fbe0$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/** Used for built-in method references. */ var $7f14bb363480fbe0$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $7f14bb363480fbe0$var$hasOwnProperty = $7f14bb363480fbe0$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $7f14bb363480fbe0$var$hashGet(key) {
    var data = this.__data__;
    if (0, $10ec6451695236a1$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $7f14bb363480fbe0$var$HASH_UNDEFINED ? undefined : result;
    }
    return $7f14bb363480fbe0$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $7f14bb363480fbe0$export$2e2bcd8739ae039 = $7f14bb363480fbe0$var$hashGet;



/** Used for built-in method references. */ var $da92ae5cc68e2801$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $da92ae5cc68e2801$var$hasOwnProperty = $da92ae5cc68e2801$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $da92ae5cc68e2801$var$hashHas(key) {
    var data = this.__data__;
    return (0, $10ec6451695236a1$export$2e2bcd8739ae039) ? data[key] !== undefined : $da92ae5cc68e2801$var$hasOwnProperty.call(data, key);
}
var $da92ae5cc68e2801$export$2e2bcd8739ae039 = $da92ae5cc68e2801$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $ff84c62c9cd631eb$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $ff84c62c9cd631eb$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $10ec6451695236a1$export$2e2bcd8739ae039) && value === undefined ? $ff84c62c9cd631eb$var$HASH_UNDEFINED : value;
    return this;
}
var $ff84c62c9cd631eb$export$2e2bcd8739ae039 = $ff84c62c9cd631eb$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $c645ed8435daf576$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$c645ed8435daf576$var$Hash.prototype.clear = (0, $23e870847fe5897d$export$2e2bcd8739ae039);
$c645ed8435daf576$var$Hash.prototype["delete"] = (0, $3e3a9d9865b9aa36$export$2e2bcd8739ae039);
$c645ed8435daf576$var$Hash.prototype.get = (0, $7f14bb363480fbe0$export$2e2bcd8739ae039);
$c645ed8435daf576$var$Hash.prototype.has = (0, $da92ae5cc68e2801$export$2e2bcd8739ae039);
$c645ed8435daf576$var$Hash.prototype.set = (0, $ff84c62c9cd631eb$export$2e2bcd8739ae039);
var $c645ed8435daf576$export$2e2bcd8739ae039 = $c645ed8435daf576$var$Hash;




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $aad0c3371c10ec33$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        "hash": new (0, $c645ed8435daf576$export$2e2bcd8739ae039),
        "map": new ((0, $19ce6fac2831f009$export$2e2bcd8739ae039) || (0, $e43fd33af7fad882$export$2e2bcd8739ae039)),
        "string": new (0, $c645ed8435daf576$export$2e2bcd8739ae039)
    };
}
var $aad0c3371c10ec33$export$2e2bcd8739ae039 = $aad0c3371c10ec33$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function $451781a23d5a875b$var$isKeyable(value) {
    var type = typeof value;
    return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
}
var $451781a23d5a875b$export$2e2bcd8739ae039 = $451781a23d5a875b$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $223d39f2f0431be9$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $451781a23d5a875b$export$2e2bcd8739ae039)(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
}
var $223d39f2f0431be9$export$2e2bcd8739ae039 = $223d39f2f0431be9$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $0826db090dfc2cff$var$mapCacheDelete(key) {
    var result = (0, $223d39f2f0431be9$export$2e2bcd8739ae039)(this, key)["delete"](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $0826db090dfc2cff$export$2e2bcd8739ae039 = $0826db090dfc2cff$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $9d46098342b3d0cc$var$mapCacheGet(key) {
    return (0, $223d39f2f0431be9$export$2e2bcd8739ae039)(this, key).get(key);
}
var $9d46098342b3d0cc$export$2e2bcd8739ae039 = $9d46098342b3d0cc$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $a68da6da825170b7$var$mapCacheHas(key) {
    return (0, $223d39f2f0431be9$export$2e2bcd8739ae039)(this, key).has(key);
}
var $a68da6da825170b7$export$2e2bcd8739ae039 = $a68da6da825170b7$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $62907ae3d73e7ce4$var$mapCacheSet(key, value) {
    var data = (0, $223d39f2f0431be9$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $62907ae3d73e7ce4$export$2e2bcd8739ae039 = $62907ae3d73e7ce4$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $cd0c97854034ec9e$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$cd0c97854034ec9e$var$MapCache.prototype.clear = (0, $aad0c3371c10ec33$export$2e2bcd8739ae039);
$cd0c97854034ec9e$var$MapCache.prototype["delete"] = (0, $0826db090dfc2cff$export$2e2bcd8739ae039);
$cd0c97854034ec9e$var$MapCache.prototype.get = (0, $9d46098342b3d0cc$export$2e2bcd8739ae039);
$cd0c97854034ec9e$var$MapCache.prototype.has = (0, $a68da6da825170b7$export$2e2bcd8739ae039);
$cd0c97854034ec9e$var$MapCache.prototype.set = (0, $62907ae3d73e7ce4$export$2e2bcd8739ae039);
var $cd0c97854034ec9e$export$2e2bcd8739ae039 = $cd0c97854034ec9e$var$MapCache;


/** Used as the size to enable large array optimizations. */ var $c8a5db6ffd8c010b$var$LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function $c8a5db6ffd8c010b$var$stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof (0, $e43fd33af7fad882$export$2e2bcd8739ae039)) {
        var pairs = data.__data__;
        if (!(0, $19ce6fac2831f009$export$2e2bcd8739ae039) || pairs.length < $c8a5db6ffd8c010b$var$LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new (0, $cd0c97854034ec9e$export$2e2bcd8739ae039)(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
var $c8a5db6ffd8c010b$export$2e2bcd8739ae039 = $c8a5db6ffd8c010b$var$stackSet;


/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $bc3d7f109e126fbe$var$Stack(entries) {
    var data = this.__data__ = new (0, $e43fd33af7fad882$export$2e2bcd8739ae039)(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
$bc3d7f109e126fbe$var$Stack.prototype.clear = (0, $552066279c535aed$export$2e2bcd8739ae039);
$bc3d7f109e126fbe$var$Stack.prototype["delete"] = (0, $eaf8b9f443875130$export$2e2bcd8739ae039);
$bc3d7f109e126fbe$var$Stack.prototype.get = (0, $4df392d1742a9028$export$2e2bcd8739ae039);
$bc3d7f109e126fbe$var$Stack.prototype.has = (0, $cab483f6b888a67a$export$2e2bcd8739ae039);
$bc3d7f109e126fbe$var$Stack.prototype.set = (0, $c8a5db6ffd8c010b$export$2e2bcd8739ae039);
var $bc3d7f109e126fbe$export$2e2bcd8739ae039 = $bc3d7f109e126fbe$var$Stack;



var $2ed8215fb968433c$var$defineProperty = function() {
    try {
        var func = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)(Object, "defineProperty");
        func({}, "", {});
        return func;
    } catch (e) {}
}();
var $2ed8215fb968433c$export$2e2bcd8739ae039 = $2ed8215fb968433c$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $bf4918e784c94fd6$var$baseAssignValue(object, key, value) {
    if (key == "__proto__" && (0, $2ed8215fb968433c$export$2e2bcd8739ae039)) (0, $2ed8215fb968433c$export$2e2bcd8739ae039)(object, key, {
        "configurable": true,
        "enumerable": true,
        "value": value,
        "writable": true
    });
    else object[key] = value;
}
var $bf4918e784c94fd6$export$2e2bcd8739ae039 = $bf4918e784c94fd6$var$baseAssignValue;



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $27b094e612513b36$var$assignMergeValue(object, key, value) {
    if (value !== undefined && !(0, $4e9d5455d0a9da98$export$2e2bcd8739ae039)(object[key], value) || value === undefined && !(key in object)) (0, $bf4918e784c94fd6$export$2e2bcd8739ae039)(object, key, value);
}
var $27b094e612513b36$export$2e2bcd8739ae039 = $27b094e612513b36$var$assignMergeValue;


/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $e9dc17a1443cc880$var$createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
var $e9dc17a1443cc880$export$2e2bcd8739ae039 = $e9dc17a1443cc880$var$createBaseFor;


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var $a08198109d414568$var$baseFor = (0, $e9dc17a1443cc880$export$2e2bcd8739ae039)();
var $a08198109d414568$export$2e2bcd8739ae039 = $a08198109d414568$var$baseFor;




var $344vn = parcelRequire("344vn");

var $etFod = parcelRequire("etFod");
/** Built-in value references. */ var $3d5051da4bd19c85$var$Uint8Array = (0, $etFod.default).Uint8Array;
var $3d5051da4bd19c85$export$2e2bcd8739ae039 = $3d5051da4bd19c85$var$Uint8Array;


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */ function $0c2ca4a729fd7c87$var$cloneArrayBuffer(arrayBuffer) {
    var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
    new (0, $3d5051da4bd19c85$export$2e2bcd8739ae039)(result).set(new (0, $3d5051da4bd19c85$export$2e2bcd8739ae039)(arrayBuffer));
    return result;
}
var $0c2ca4a729fd7c87$export$2e2bcd8739ae039 = $0c2ca4a729fd7c87$var$cloneArrayBuffer;


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */ function $69d2cdcd67b51fde$var$cloneTypedArray(typedArray, isDeep) {
    var buffer = isDeep ? (0, $0c2ca4a729fd7c87$export$2e2bcd8739ae039)(typedArray.buffer) : typedArray.buffer;
    return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}
var $69d2cdcd67b51fde$export$2e2bcd8739ae039 = $69d2cdcd67b51fde$var$cloneTypedArray;


/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */ function $1dc274c0a06a5d86$var$copyArray(source, array) {
    var index = -1, length = source.length;
    array || (array = Array(length));
    while(++index < length)array[index] = source[index];
    return array;
}
var $1dc274c0a06a5d86$export$2e2bcd8739ae039 = $1dc274c0a06a5d86$var$copyArray;



/** Built-in value references. */ var $df0479b213154b01$var$objectCreate = Object.create;
/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */ var $df0479b213154b01$var$baseCreate = function() {
    function object() {}
    return function(proto) {
        if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(proto)) return {};
        if ($df0479b213154b01$var$objectCreate) return $df0479b213154b01$var$objectCreate(proto);
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
    };
}();
var $df0479b213154b01$export$2e2bcd8739ae039 = $df0479b213154b01$var$baseCreate;


/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $26f3cac3d630c17e$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
var $26f3cac3d630c17e$export$2e2bcd8739ae039 = $26f3cac3d630c17e$var$overArg;


/** Built-in value references. */ var $d489b9b5ad2f65f5$var$getPrototype = (0, $26f3cac3d630c17e$export$2e2bcd8739ae039)(Object.getPrototypeOf, Object);
var $d489b9b5ad2f65f5$export$2e2bcd8739ae039 = $d489b9b5ad2f65f5$var$getPrototype;


/** Used for built-in method references. */ var $54aaea143d4aacdf$var$objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function $54aaea143d4aacdf$var$isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || $54aaea143d4aacdf$var$objectProto;
    return value === proto;
}
var $54aaea143d4aacdf$export$2e2bcd8739ae039 = $54aaea143d4aacdf$var$isPrototype;


/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */ function $3a6f9352843d5ae9$var$initCloneObject(object) {
    return typeof object.constructor == "function" && !(0, $54aaea143d4aacdf$export$2e2bcd8739ae039)(object) ? (0, $df0479b213154b01$export$2e2bcd8739ae039)((0, $d489b9b5ad2f65f5$export$2e2bcd8739ae039)(object)) : {};
}
var $3a6f9352843d5ae9$export$2e2bcd8739ae039 = $3a6f9352843d5ae9$var$initCloneObject;



/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $5a1d34ee4ba9ab98$var$isObjectLike(value) {
    return value != null && typeof value == "object";
}
var $5a1d34ee4ba9ab98$export$2e2bcd8739ae039 = $5a1d34ee4ba9ab98$var$isObjectLike;


/** `Object#toString` result references. */ var $94307966a7646584$var$argsTag = "[object Arguments]";
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $94307966a7646584$var$baseIsArguments(value) {
    return (0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && (0, $719a43f053b573ae$export$2e2bcd8739ae039)(value) == $94307966a7646584$var$argsTag;
}
var $94307966a7646584$export$2e2bcd8739ae039 = $94307966a7646584$var$baseIsArguments;



/** Used for built-in method references. */ var $aa9c2f54dd7338fc$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $aa9c2f54dd7338fc$var$hasOwnProperty = $aa9c2f54dd7338fc$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $aa9c2f54dd7338fc$var$propertyIsEnumerable = $aa9c2f54dd7338fc$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $aa9c2f54dd7338fc$var$isArguments = (0, $94307966a7646584$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $94307966a7646584$export$2e2bcd8739ae039) : function(value) {
    return (0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && $aa9c2f54dd7338fc$var$hasOwnProperty.call(value, "callee") && !$aa9c2f54dd7338fc$var$propertyIsEnumerable.call(value, "callee");
};
var $aa9c2f54dd7338fc$export$2e2bcd8739ae039 = $aa9c2f54dd7338fc$var$isArguments;


/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $7b594f54c7511fe7$var$isArray = Array.isArray;
var $7b594f54c7511fe7$export$2e2bcd8739ae039 = $7b594f54c7511fe7$var$isArray;



/** Used as references for various `Number` constants. */ var $ac894660e80824cc$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $ac894660e80824cc$var$isLength(value) {
    return typeof value == "number" && value > -1 && value % 1 == 0 && value <= $ac894660e80824cc$var$MAX_SAFE_INTEGER;
}
var $ac894660e80824cc$export$2e2bcd8739ae039 = $ac894660e80824cc$var$isLength;


/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function $80abbb6b81d2d530$var$isArrayLike(value) {
    return value != null && (0, $ac894660e80824cc$export$2e2bcd8739ae039)(value.length) && !(0, $ffe84544d7ecb295$export$2e2bcd8739ae039)(value);
}
var $80abbb6b81d2d530$export$2e2bcd8739ae039 = $80abbb6b81d2d530$var$isArrayLike;



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */ function $0b3d8114d0884eeb$var$isArrayLikeObject(value) {
    return (0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && (0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(value);
}
var $0b3d8114d0884eeb$export$2e2bcd8739ae039 = $0b3d8114d0884eeb$var$isArrayLikeObject;



var $1nmna = parcelRequire("1nmna");





/** `Object#toString` result references. */ var $f5c6f6bece82ec3f$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $f5c6f6bece82ec3f$var$funcProto = Function.prototype, $f5c6f6bece82ec3f$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $f5c6f6bece82ec3f$var$funcToString = $f5c6f6bece82ec3f$var$funcProto.toString;
/** Used to check objects for own properties. */ var $f5c6f6bece82ec3f$var$hasOwnProperty = $f5c6f6bece82ec3f$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $f5c6f6bece82ec3f$var$objectCtorString = $f5c6f6bece82ec3f$var$funcToString.call(Object);
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $f5c6f6bece82ec3f$var$isPlainObject(value) {
    if (!(0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) || (0, $719a43f053b573ae$export$2e2bcd8739ae039)(value) != $f5c6f6bece82ec3f$var$objectTag) return false;
    var proto = (0, $d489b9b5ad2f65f5$export$2e2bcd8739ae039)(value);
    if (proto === null) return true;
    var Ctor = $f5c6f6bece82ec3f$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $f5c6f6bece82ec3f$var$funcToString.call(Ctor) == $f5c6f6bece82ec3f$var$objectCtorString;
}
var $f5c6f6bece82ec3f$export$2e2bcd8739ae039 = $f5c6f6bece82ec3f$var$isPlainObject;





/** `Object#toString` result references. */ var $a12e0ae25f1a234a$var$argsTag = "[object Arguments]", $a12e0ae25f1a234a$var$arrayTag = "[object Array]", $a12e0ae25f1a234a$var$boolTag = "[object Boolean]", $a12e0ae25f1a234a$var$dateTag = "[object Date]", $a12e0ae25f1a234a$var$errorTag = "[object Error]", $a12e0ae25f1a234a$var$funcTag = "[object Function]", $a12e0ae25f1a234a$var$mapTag = "[object Map]", $a12e0ae25f1a234a$var$numberTag = "[object Number]", $a12e0ae25f1a234a$var$objectTag = "[object Object]", $a12e0ae25f1a234a$var$regexpTag = "[object RegExp]", $a12e0ae25f1a234a$var$setTag = "[object Set]", $a12e0ae25f1a234a$var$stringTag = "[object String]", $a12e0ae25f1a234a$var$weakMapTag = "[object WeakMap]";
var $a12e0ae25f1a234a$var$arrayBufferTag = "[object ArrayBuffer]", $a12e0ae25f1a234a$var$dataViewTag = "[object DataView]", $a12e0ae25f1a234a$var$float32Tag = "[object Float32Array]", $a12e0ae25f1a234a$var$float64Tag = "[object Float64Array]", $a12e0ae25f1a234a$var$int8Tag = "[object Int8Array]", $a12e0ae25f1a234a$var$int16Tag = "[object Int16Array]", $a12e0ae25f1a234a$var$int32Tag = "[object Int32Array]", $a12e0ae25f1a234a$var$uint8Tag = "[object Uint8Array]", $a12e0ae25f1a234a$var$uint8ClampedTag = "[object Uint8ClampedArray]", $a12e0ae25f1a234a$var$uint16Tag = "[object Uint16Array]", $a12e0ae25f1a234a$var$uint32Tag = "[object Uint32Array]";
/** Used to identify `toStringTag` values of typed arrays. */ var $a12e0ae25f1a234a$var$typedArrayTags = {};
$a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$float32Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$float64Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$int8Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$int16Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$int32Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$uint8Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$uint8ClampedTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$uint16Tag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$uint32Tag] = true;
$a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$argsTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$arrayTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$arrayBufferTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$boolTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$dataViewTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$dateTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$errorTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$funcTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$mapTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$numberTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$objectTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$regexpTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$setTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$stringTag] = $a12e0ae25f1a234a$var$typedArrayTags[$a12e0ae25f1a234a$var$weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function $a12e0ae25f1a234a$var$baseIsTypedArray(value) {
    return (0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && (0, $ac894660e80824cc$export$2e2bcd8739ae039)(value.length) && !!$a12e0ae25f1a234a$var$typedArrayTags[(0, $719a43f053b573ae$export$2e2bcd8739ae039)(value)];
}
var $a12e0ae25f1a234a$export$2e2bcd8739ae039 = $a12e0ae25f1a234a$var$baseIsTypedArray;


/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function $7770fff9d02dcc48$var$baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
var $7770fff9d02dcc48$export$2e2bcd8739ae039 = $7770fff9d02dcc48$var$baseUnary;



var $bZVQC = parcelRequire("bZVQC");
/* Node.js helper references. */ var $4932f3d7733b0312$var$nodeIsTypedArray = (0, $bZVQC.default) && (0, $bZVQC.default).isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var $4932f3d7733b0312$var$isTypedArray = $4932f3d7733b0312$var$nodeIsTypedArray ? (0, $7770fff9d02dcc48$export$2e2bcd8739ae039)($4932f3d7733b0312$var$nodeIsTypedArray) : (0, $a12e0ae25f1a234a$export$2e2bcd8739ae039);
var $4932f3d7733b0312$export$2e2bcd8739ae039 = $4932f3d7733b0312$var$isTypedArray;


/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $4bb349745610b5c0$var$safeGet(object, key) {
    if (key === "constructor" && typeof object[key] === "function") return;
    if (key == "__proto__") return;
    return object[key];
}
var $4bb349745610b5c0$export$2e2bcd8739ae039 = $4bb349745610b5c0$var$safeGet;




/** Used for built-in method references. */ var $008796a75200a4c7$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $008796a75200a4c7$var$hasOwnProperty = $008796a75200a4c7$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $008796a75200a4c7$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($008796a75200a4c7$var$hasOwnProperty.call(object, key) && (0, $4e9d5455d0a9da98$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $bf4918e784c94fd6$export$2e2bcd8739ae039)(object, key, value);
}
var $008796a75200a4c7$export$2e2bcd8739ae039 = $008796a75200a4c7$var$assignValue;



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */ function $3d8b482ea5b4797b$var$copyObject(source, props, object, customizer) {
    var isNew = !object;
    object || (object = {});
    var index = -1, length = props.length;
    while(++index < length){
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) newValue = source[key];
        if (isNew) (0, $bf4918e784c94fd6$export$2e2bcd8739ae039)(object, key, newValue);
        else (0, $008796a75200a4c7$export$2e2bcd8739ae039)(object, key, newValue);
    }
    return object;
}
var $3d8b482ea5b4797b$export$2e2bcd8739ae039 = $3d8b482ea5b4797b$var$copyObject;


/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function $4d66d327376f6e9b$var$baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
var $4d66d327376f6e9b$export$2e2bcd8739ae039 = $4d66d327376f6e9b$var$baseTimes;





var $1nmna = parcelRequire("1nmna");
/** Used as references for various `Number` constants. */ var $90b404c092fda5b3$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $90b404c092fda5b3$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $90b404c092fda5b3$var$isIndex(value, length) {
    var type = typeof value;
    length = length == null ? $90b404c092fda5b3$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == "number" || type != "symbol" && $90b404c092fda5b3$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $90b404c092fda5b3$export$2e2bcd8739ae039 = $90b404c092fda5b3$var$isIndex;



/** Used for built-in method references. */ var $1eed5d79e72585b8$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $1eed5d79e72585b8$var$hasOwnProperty = $1eed5d79e72585b8$var$objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function $1eed5d79e72585b8$var$arrayLikeKeys(value, inherited) {
    var isArr = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(value), isArg = !isArr && (0, $aa9c2f54dd7338fc$export$2e2bcd8739ae039)(value), isBuff = !isArr && !isArg && (0, $1nmna.default)(value), isType = !isArr && !isArg && !isBuff && (0, $4932f3d7733b0312$export$2e2bcd8739ae039)(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? (0, $4d66d327376f6e9b$export$2e2bcd8739ae039)(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || $1eed5d79e72585b8$var$hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
    (0, $90b404c092fda5b3$export$2e2bcd8739ae039)(key, length)))) result.push(key);
    return result;
}
var $1eed5d79e72585b8$export$2e2bcd8739ae039 = $1eed5d79e72585b8$var$arrayLikeKeys;




/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $172680aba24f1b17$var$nativeKeysIn(object) {
    var result = [];
    if (object != null) for(var key in Object(object))result.push(key);
    return result;
}
var $172680aba24f1b17$export$2e2bcd8739ae039 = $172680aba24f1b17$var$nativeKeysIn;


/** Used for built-in method references. */ var $f992092915396725$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $f992092915396725$var$hasOwnProperty = $f992092915396725$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $f992092915396725$var$baseKeysIn(object) {
    if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(object)) return (0, $172680aba24f1b17$export$2e2bcd8739ae039)(object);
    var isProto = (0, $54aaea143d4aacdf$export$2e2bcd8739ae039)(object), result = [];
    for(var key in object)if (!(key == "constructor" && (isProto || !$f992092915396725$var$hasOwnProperty.call(object, key)))) result.push(key);
    return result;
}
var $f992092915396725$export$2e2bcd8739ae039 = $f992092915396725$var$baseKeysIn;



/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */ function $af3cd8fc839443d6$var$keysIn(object) {
    return (0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(object) ? (0, $1eed5d79e72585b8$export$2e2bcd8739ae039)(object, true) : (0, $f992092915396725$export$2e2bcd8739ae039)(object);
}
var $af3cd8fc839443d6$export$2e2bcd8739ae039 = $af3cd8fc839443d6$var$keysIn;


/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */ function $aa6fc231b6c8f9d0$var$toPlainObject(value) {
    return (0, $3d8b482ea5b4797b$export$2e2bcd8739ae039)(value, (0, $af3cd8fc839443d6$export$2e2bcd8739ae039)(value));
}
var $aa6fc231b6c8f9d0$export$2e2bcd8739ae039 = $aa6fc231b6c8f9d0$var$toPlainObject;


/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8f938951dc5e6deb$var$baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
    var objValue = (0, $4bb349745610b5c0$export$2e2bcd8739ae039)(object, key), srcValue = (0, $4bb349745610b5c0$export$2e2bcd8739ae039)(source, key), stacked = stack.get(srcValue);
    if (stacked) {
        (0, $27b094e612513b36$export$2e2bcd8739ae039)(object, key, stacked);
        return;
    }
    var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined;
    var isCommon = newValue === undefined;
    if (isCommon) {
        var isArr = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(srcValue), isBuff = !isArr && (0, $1nmna.default)(srcValue), isTyped = !isArr && !isBuff && (0, $4932f3d7733b0312$export$2e2bcd8739ae039)(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
            if ((0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(objValue)) newValue = objValue;
            else if ((0, $0b3d8114d0884eeb$export$2e2bcd8739ae039)(objValue)) newValue = (0, $1dc274c0a06a5d86$export$2e2bcd8739ae039)(objValue);
            else if (isBuff) {
                isCommon = false;
                newValue = (0, $344vn.default)(srcValue, true);
            } else if (isTyped) {
                isCommon = false;
                newValue = (0, $69d2cdcd67b51fde$export$2e2bcd8739ae039)(srcValue, true);
            } else newValue = [];
        } else if ((0, $f5c6f6bece82ec3f$export$2e2bcd8739ae039)(srcValue) || (0, $aa9c2f54dd7338fc$export$2e2bcd8739ae039)(srcValue)) {
            newValue = objValue;
            if ((0, $aa9c2f54dd7338fc$export$2e2bcd8739ae039)(objValue)) newValue = (0, $aa6fc231b6c8f9d0$export$2e2bcd8739ae039)(objValue);
            else if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(objValue) || (0, $ffe84544d7ecb295$export$2e2bcd8739ae039)(objValue)) newValue = (0, $3a6f9352843d5ae9$export$2e2bcd8739ae039)(srcValue);
        } else isCommon = false;
    }
    if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack["delete"](srcValue);
    }
    (0, $27b094e612513b36$export$2e2bcd8739ae039)(object, key, newValue);
}
var $8f938951dc5e6deb$export$2e2bcd8739ae039 = $8f938951dc5e6deb$var$baseMergeDeep;





/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */ function $8599d7379bccb40e$var$baseMerge(object, source, srcIndex, customizer, stack) {
    if (object === source) return;
    (0, $a08198109d414568$export$2e2bcd8739ae039)(source, function(srcValue, key) {
        stack || (stack = new (0, $bc3d7f109e126fbe$export$2e2bcd8739ae039));
        if ((0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(srcValue)) (0, $8f938951dc5e6deb$export$2e2bcd8739ae039)(object, source, key, srcIndex, $8599d7379bccb40e$var$baseMerge, customizer, stack);
        else {
            var newValue = customizer ? customizer((0, $4bb349745610b5c0$export$2e2bcd8739ae039)(object, key), srcValue, key + "", object, source, stack) : undefined;
            if (newValue === undefined) newValue = srcValue;
            (0, $27b094e612513b36$export$2e2bcd8739ae039)(object, key, newValue);
        }
    }, (0, $af3cd8fc839443d6$export$2e2bcd8739ae039));
}
var $8599d7379bccb40e$export$2e2bcd8739ae039 = $8599d7379bccb40e$var$baseMerge;


/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $b62024aa87ab11b8$var$identity(value) {
    return value;
}
var $b62024aa87ab11b8$export$2e2bcd8739ae039 = $b62024aa87ab11b8$var$identity;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $e7b9a8196ccea78a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $e7b9a8196ccea78a$export$2e2bcd8739ae039 = $e7b9a8196ccea78a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $c6878c1feb678d54$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $c6878c1feb678d54$var$overRest(func, start, transform) {
    start = $c6878c1feb678d54$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $c6878c1feb678d54$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $e7b9a8196ccea78a$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $c6878c1feb678d54$export$2e2bcd8739ae039 = $c6878c1feb678d54$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $be100fd53c4ead33$var$constant(value) {
    return function() {
        return value;
    };
}
var $be100fd53c4ead33$export$2e2bcd8739ae039 = $be100fd53c4ead33$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $9bda5c67d95cc627$var$baseSetToString = !(0, $2ed8215fb968433c$export$2e2bcd8739ae039) ? (0, $b62024aa87ab11b8$export$2e2bcd8739ae039) : function(func, string) {
    return (0, $2ed8215fb968433c$export$2e2bcd8739ae039)(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": (0, $be100fd53c4ead33$export$2e2bcd8739ae039)(string),
        "writable": true
    });
};
var $9bda5c67d95cc627$export$2e2bcd8739ae039 = $9bda5c67d95cc627$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $8008142c2fb6a606$var$HOT_COUNT = 800, $8008142c2fb6a606$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $8008142c2fb6a606$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $8008142c2fb6a606$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $8008142c2fb6a606$var$nativeNow(), remaining = $8008142c2fb6a606$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $8008142c2fb6a606$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $8008142c2fb6a606$export$2e2bcd8739ae039 = $8008142c2fb6a606$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $d9b64f4e5779a928$var$setToString = (0, $8008142c2fb6a606$export$2e2bcd8739ae039)((0, $9bda5c67d95cc627$export$2e2bcd8739ae039));
var $d9b64f4e5779a928$export$2e2bcd8739ae039 = $d9b64f4e5779a928$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $b12f2001c3fb0b49$var$baseRest(func, start) {
    return (0, $d9b64f4e5779a928$export$2e2bcd8739ae039)((0, $c6878c1feb678d54$export$2e2bcd8739ae039)(func, start, (0, $b62024aa87ab11b8$export$2e2bcd8739ae039)), func + "");
}
var $b12f2001c3fb0b49$export$2e2bcd8739ae039 = $b12f2001c3fb0b49$var$baseRest;






/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $0e59db32056c1a0b$var$isIterateeCall(value, index, object) {
    if (!(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(object)) return false;
    var type = typeof index;
    if (type == "number" ? (0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(object) && (0, $90b404c092fda5b3$export$2e2bcd8739ae039)(index, object.length) : type == "string" && index in object) return (0, $4e9d5455d0a9da98$export$2e2bcd8739ae039)(object[index], value);
    return false;
}
var $0e59db32056c1a0b$export$2e2bcd8739ae039 = $0e59db32056c1a0b$var$isIterateeCall;


/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */ function $a6d04d750ceb3acf$var$createAssigner(assigner) {
    return (0, $b12f2001c3fb0b49$export$2e2bcd8739ae039)(function(object, sources) {
        var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined, guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined;
        if (guard && (0, $0e59db32056c1a0b$export$2e2bcd8739ae039)(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined : customizer;
            length = 1;
        }
        object = Object(object);
        while(++index < length){
            var source = sources[index];
            if (source) assigner(object, source, index, customizer);
        }
        return object;
    });
}
var $a6d04d750ceb3acf$export$2e2bcd8739ae039 = $a6d04d750ceb3acf$var$createAssigner;


/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */ var $55851e245b6d3090$var$merge = (0, $a6d04d750ceb3acf$export$2e2bcd8739ae039)(function(object, source, srcIndex) {
    (0, $8599d7379bccb40e$export$2e2bcd8739ae039)(object, source, srcIndex);
});
var $55851e245b6d3090$export$2e2bcd8739ae039 = $55851e245b6d3090$var$merge;


var $0fbacba5a68a0690$export$5eec0980ed568dae = function Raised(_ref) {
    var zDepth = _ref.zDepth, radius = _ref.radius, background = _ref.background, children = _ref.children, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            wrap: {
                position: "relative",
                display: "inline-block"
            },
            content: {
                position: "relative"
            },
            bg: {
                absolute: "0px 0px 0px 0px",
                boxShadow: "0 " + zDepth + "px " + zDepth * 4 + "px rgba(0,0,0,.24)",
                borderRadius: radius,
                background: background
            }
        },
        "zDepth-0": {
            bg: {
                boxShadow: "none"
            }
        },
        "zDepth-1": {
            bg: {
                boxShadow: "0 2px 10px rgba(0,0,0,.12), 0 2px 5px rgba(0,0,0,.16)"
            }
        },
        "zDepth-2": {
            bg: {
                boxShadow: "0 6px 20px rgba(0,0,0,.19), 0 8px 17px rgba(0,0,0,.2)"
            }
        },
        "zDepth-3": {
            bg: {
                boxShadow: "0 17px 50px rgba(0,0,0,.19), 0 12px 15px rgba(0,0,0,.24)"
            }
        },
        "zDepth-4": {
            bg: {
                boxShadow: "0 25px 55px rgba(0,0,0,.21), 0 16px 28px rgba(0,0,0,.22)"
            }
        },
        "zDepth-5": {
            bg: {
                boxShadow: "0 40px 77px rgba(0,0,0,.22), 0 27px 24px rgba(0,0,0,.2)"
            }
        },
        "square": {
            bg: {
                borderRadius: "0"
            }
        },
        "circle": {
            bg: {
                borderRadius: "50%"
            }
        }
    }, passedStyles), {
        "zDepth-1": zDepth === 1
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.wrap
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.bg
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.content
    }, children));
};
$0fbacba5a68a0690$export$5eec0980ed568dae.propTypes = {
    background: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
    zDepth: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
        0,
        1,
        2,
        3,
        4,
        5
    ]),
    radius: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$0fbacba5a68a0690$export$5eec0980ed568dae.defaultProps = {
    background: "#fff",
    zDepth: 1,
    radius: 2,
    styles: {}
};
var $0fbacba5a68a0690$export$2e2bcd8739ae039 = $0fbacba5a68a0690$export$5eec0980ed568dae;



var $eCoWV = parcelRequire("eCoWV");



var $etFod = parcelRequire("etFod");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $187afff4887563e7$var$now = function() {
    return (0, $etFod.default).Date.now();
};
var $187afff4887563e7$export$2e2bcd8739ae039 = $187afff4887563e7$var$now;


/** Used to match a single whitespace character. */ var $23cf030a1bdb31ab$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $23cf030a1bdb31ab$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $23cf030a1bdb31ab$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $23cf030a1bdb31ab$export$2e2bcd8739ae039 = $23cf030a1bdb31ab$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $dc7cd80c4a7f5286$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $dc7cd80c4a7f5286$var$baseTrim(string) {
    return string ? string.slice(0, (0, $23cf030a1bdb31ab$export$2e2bcd8739ae039)(string) + 1).replace($dc7cd80c4a7f5286$var$reTrimStart, "") : string;
}
var $dc7cd80c4a7f5286$export$2e2bcd8739ae039 = $dc7cd80c4a7f5286$var$baseTrim;





/** `Object#toString` result references. */ var $262b15375f25f63b$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $262b15375f25f63b$var$isSymbol(value) {
    return typeof value == "symbol" || (0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && (0, $719a43f053b573ae$export$2e2bcd8739ae039)(value) == $262b15375f25f63b$var$symbolTag;
}
var $262b15375f25f63b$export$2e2bcd8739ae039 = $262b15375f25f63b$var$isSymbol;


/** Used as references for various `Number` constants. */ var $4a4341ee12b48643$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $4a4341ee12b48643$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $4a4341ee12b48643$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $4a4341ee12b48643$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $4a4341ee12b48643$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $4a4341ee12b48643$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ((0, $262b15375f25f63b$export$2e2bcd8739ae039)(value)) return $4a4341ee12b48643$var$NAN;
    if ((0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = (0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = (0, $dc7cd80c4a7f5286$export$2e2bcd8739ae039)(value);
    var isBinary = $4a4341ee12b48643$var$reIsBinary.test(value);
    return isBinary || $4a4341ee12b48643$var$reIsOctal.test(value) ? $4a4341ee12b48643$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $4a4341ee12b48643$var$reIsBadHex.test(value) ? $4a4341ee12b48643$var$NAN : +value;
}
var $4a4341ee12b48643$export$2e2bcd8739ae039 = $4a4341ee12b48643$var$toNumber;


/** Error message constants. */ var $c37a21cf058dfbf0$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $c37a21cf058dfbf0$var$nativeMax = Math.max, $c37a21cf058dfbf0$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $c37a21cf058dfbf0$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($c37a21cf058dfbf0$var$FUNC_ERROR_TEXT);
    wait = (0, $4a4341ee12b48643$export$2e2bcd8739ae039)(wait) || 0;
    if ((0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $c37a21cf058dfbf0$var$nativeMax((0, $4a4341ee12b48643$export$2e2bcd8739ae039)(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $c37a21cf058dfbf0$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = (0, $187afff4887563e7$export$2e2bcd8739ae039)();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge((0, $187afff4887563e7$export$2e2bcd8739ae039)());
    }
    function debounced() {
        var time = (0, $187afff4887563e7$export$2e2bcd8739ae039)(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $c37a21cf058dfbf0$export$2e2bcd8739ae039 = $c37a21cf058dfbf0$var$debounce;



/** Error message constants. */ var $5f548c9fffc77be3$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $5f548c9fffc77be3$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($5f548c9fffc77be3$var$FUNC_ERROR_TEXT);
    if ((0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return (0, $c37a21cf058dfbf0$export$2e2bcd8739ae039)(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $5f548c9fffc77be3$export$2e2bcd8739ae039 = $5f548c9fffc77be3$var$throttle;


var $ea3c023b76bbaf47$export$a056a977bf6a9a3c = function calculateChange(e, hsl, container) {
    var _container$getBoundin = container.getBoundingClientRect(), containerWidth = _container$getBoundin.width, containerHeight = _container$getBoundin.height;
    var x = typeof e.pageX === "number" ? e.pageX : e.touches[0].pageX;
    var y = typeof e.pageY === "number" ? e.pageY : e.touches[0].pageY;
    var left = x - (container.getBoundingClientRect().left + window.pageXOffset);
    var top = y - (container.getBoundingClientRect().top + window.pageYOffset);
    if (left < 0) left = 0;
    else if (left > containerWidth) left = containerWidth;
    if (top < 0) top = 0;
    else if (top > containerHeight) top = containerHeight;
    var saturation = left / containerWidth;
    var bright = 1 - top / containerHeight;
    return {
        h: hsl.h,
        s: saturation,
        v: bright,
        a: hsl.a,
        source: "hsv"
    };
};


var $4c4c816213e4c82f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $4c4c816213e4c82f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $4c4c816213e4c82f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $4c4c816213e4c82f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $4c4c816213e4c82f$export$c4dbe12ffaee3c8e = function(_ref) {
    $4c4c816213e4c82f$var$_inherits(Saturation, _ref);
    function Saturation(props) {
        $4c4c816213e4c82f$var$_classCallCheck(this, Saturation);
        var _this = $4c4c816213e4c82f$var$_possibleConstructorReturn(this, (Saturation.__proto__ || Object.getPrototypeOf(Saturation)).call(this, props));
        _this.handleChange = function(e) {
            typeof _this.props.onChange === "function" && _this.throttle(_this.props.onChange, $ea3c023b76bbaf47$export$a056a977bf6a9a3c(e, _this.props.hsl, _this.container), e);
        };
        _this.handleMouseDown = function(e) {
            _this.handleChange(e);
            var renderWindow = _this.getContainerRenderWindow();
            renderWindow.addEventListener("mousemove", _this.handleChange);
            renderWindow.addEventListener("mouseup", _this.handleMouseUp);
        };
        _this.handleMouseUp = function() {
            _this.unbindEventListeners();
        };
        _this.throttle = (0, $5f548c9fffc77be3$export$2e2bcd8739ae039)(function(fn, data, e) {
            fn(data, e);
        }, 50);
        return _this;
    }
    $4c4c816213e4c82f$var$_createClass(Saturation, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.throttle.cancel();
                this.unbindEventListeners();
            }
        },
        {
            key: "getContainerRenderWindow",
            value: function getContainerRenderWindow() {
                var container = this.container;
                var renderWindow = window;
                while(!renderWindow.document.contains(container) && renderWindow.parent !== renderWindow)renderWindow = renderWindow.parent;
                return renderWindow;
            }
        },
        {
            key: "unbindEventListeners",
            value: function unbindEventListeners() {
                var renderWindow = this.getContainerRenderWindow();
                renderWindow.removeEventListener("mousemove", this.handleChange);
                renderWindow.removeEventListener("mouseup", this.handleMouseUp);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _ref2 = this.props.style || {}, color = _ref2.color, white = _ref2.white, black = _ref2.black, pointer = _ref2.pointer, circle = _ref2.circle;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
                    "default": {
                        color: {
                            absolute: "0px 0px 0px 0px",
                            background: "hsl(" + this.props.hsl.h + ",100%, 50%)",
                            borderRadius: this.props.radius
                        },
                        white: {
                            absolute: "0px 0px 0px 0px",
                            borderRadius: this.props.radius
                        },
                        black: {
                            absolute: "0px 0px 0px 0px",
                            boxShadow: this.props.shadow,
                            borderRadius: this.props.radius
                        },
                        pointer: {
                            position: "absolute",
                            top: -(this.props.hsv.v * 100) + 100 + "%",
                            left: this.props.hsv.s * 100 + "%",
                            cursor: "default"
                        },
                        circle: {
                            width: "4px",
                            height: "4px",
                            boxShadow: "0 0 0 1.5px #fff, inset 0 0 1px 1px rgba(0,0,0,.3),\n            0 0 1px 2px rgba(0,0,0,.4)",
                            borderRadius: "50%",
                            cursor: "hand",
                            transform: "translate(-2px, -2px)"
                        }
                    },
                    "custom": {
                        color: color,
                        white: white,
                        black: black,
                        pointer: pointer,
                        circle: circle
                    }
                }, {
                    "custom": !!this.props.style
                });
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.color,
                    ref: function ref(container) {
                        return _this2.container = container;
                    },
                    onMouseDown: this.handleMouseDown,
                    onTouchMove: this.handleChange,
                    onTouchStart: this.handleChange
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("style", null, "\n          .saturation-white {\n            background: -webkit-linear-gradient(to right, #fff, rgba(255,255,255,0));\n            background: linear-gradient(to right, #fff, rgba(255,255,255,0));\n          }\n          .saturation-black {\n            background: -webkit-linear-gradient(to top, #000, rgba(0,0,0,0));\n            background: linear-gradient(to top, #000, rgba(0,0,0,0));\n          }\n        "), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.white,
                    className: "saturation-white"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.black,
                    className: "saturation-black"
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.pointer
                }, this.props.pointer ? (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(this.props.pointer, this.props) : (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.circle
                }))));
            }
        }
    ]);
    return Saturation;
}((0, $eCoWV.PureComponent) || (0, $eCoWV.Component));
var $4c4c816213e4c82f$export$2e2bcd8739ae039 = $4c4c816213e4c82f$export$c4dbe12ffaee3c8e;



var $eCoWV = parcelRequire("eCoWV");

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */ function $cfb96eb0cb0bdcbe$var$arrayEach(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (iteratee(array[index], index, array) === false) break;
    }
    return array;
}
var $cfb96eb0cb0bdcbe$export$2e2bcd8739ae039 = $cfb96eb0cb0bdcbe$var$arrayEach;






/* Built-in method references for those with the same name as other `lodash` methods. */ var $f1c65d5b953f7f8e$var$nativeKeys = (0, $26f3cac3d630c17e$export$2e2bcd8739ae039)(Object.keys, Object);
var $f1c65d5b953f7f8e$export$2e2bcd8739ae039 = $f1c65d5b953f7f8e$var$nativeKeys;


/** Used for built-in method references. */ var $8c575030f202fdf2$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $8c575030f202fdf2$var$hasOwnProperty = $8c575030f202fdf2$var$objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function $8c575030f202fdf2$var$baseKeys(object) {
    if (!(0, $54aaea143d4aacdf$export$2e2bcd8739ae039)(object)) return (0, $f1c65d5b953f7f8e$export$2e2bcd8739ae039)(object);
    var result = [];
    for(var key in Object(object))if ($8c575030f202fdf2$var$hasOwnProperty.call(object, key) && key != "constructor") result.push(key);
    return result;
}
var $8c575030f202fdf2$export$2e2bcd8739ae039 = $8c575030f202fdf2$var$baseKeys;



/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function $9ef7bf4bc0a4b5fa$var$keys(object) {
    return (0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(object) ? (0, $1eed5d79e72585b8$export$2e2bcd8739ae039)(object) : (0, $8c575030f202fdf2$export$2e2bcd8739ae039)(object);
}
var $9ef7bf4bc0a4b5fa$export$2e2bcd8739ae039 = $9ef7bf4bc0a4b5fa$var$keys;


/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function $72831fc572f71e45$var$baseForOwn(object, iteratee) {
    return object && (0, $a08198109d414568$export$2e2bcd8739ae039)(object, iteratee, (0, $9ef7bf4bc0a4b5fa$export$2e2bcd8739ae039));
}
var $72831fc572f71e45$export$2e2bcd8739ae039 = $72831fc572f71e45$var$baseForOwn;



/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function $36af1db788771df0$var$createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!(0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
var $36af1db788771df0$export$2e2bcd8739ae039 = $36af1db788771df0$var$createBaseEach;


/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var $ab655d0bc64138b1$var$baseEach = (0, $36af1db788771df0$export$2e2bcd8739ae039)((0, $72831fc572f71e45$export$2e2bcd8739ae039));
var $ab655d0bc64138b1$export$2e2bcd8739ae039 = $ab655d0bc64138b1$var$baseEach;



/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */ function $65865f51bd73ac3e$var$castFunction(value) {
    return typeof value == "function" ? value : (0, $b62024aa87ab11b8$export$2e2bcd8739ae039);
}
var $65865f51bd73ac3e$export$2e2bcd8739ae039 = $65865f51bd73ac3e$var$castFunction;



/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */ function $fa803b436c5f6962$var$forEach(collection, iteratee) {
    var func = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(collection) ? (0, $cfb96eb0cb0bdcbe$export$2e2bcd8739ae039) : (0, $ab655d0bc64138b1$export$2e2bcd8739ae039);
    return func(collection, (0, $65865f51bd73ac3e$export$2e2bcd8739ae039)(iteratee));
}
var $fa803b436c5f6962$export$2e2bcd8739ae039 = $fa803b436c5f6962$var$forEach;


// This file is autogenerated. It's used to publish ESM to npm.
function $c2e2447aee45c515$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $c2e2447aee45c515$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $c2e2447aee45c515$var$_typeof(obj);
}
// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License
var $c2e2447aee45c515$var$trimLeft = /^\s+/;
var $c2e2447aee45c515$var$trimRight = /\s+$/;
function $c2e2447aee45c515$export$2e2bcd8739ae039(color, opts) {
    color = color ? color : "";
    opts = opts || {};
    // If input is already a tinycolor, return itself
    if (color instanceof $c2e2447aee45c515$export$2e2bcd8739ae039) return color;
    // If we are called as a function, call using new instead
    if (!(this instanceof $c2e2447aee45c515$export$2e2bcd8739ae039)) return new $c2e2447aee45c515$export$2e2bcd8739ae039(color, opts);
    var rgb = $c2e2447aee45c515$var$inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;
    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
}
$c2e2447aee45c515$export$2e2bcd8739ae039.prototype = {
    isDark: function isDark() {
        return this.getBrightness() < 128;
    },
    isLight: function isLight() {
        return !this.isDark();
    },
    isValid: function isValid() {
        return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
        return this._originalInput;
    },
    getFormat: function getFormat() {
        return this._format;
    },
    getAlpha: function getAlpha() {
        return this._a;
    },
    getBrightness: function getBrightness() {
        //http://www.w3.org/TR/AERT#color-contrast
        var rgb = this.toRgb();
        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
        var rgb = this.toRgb();
        var RsRGB, GsRGB, BsRGB, R, G, B;
        RsRGB = rgb.r / 255;
        GsRGB = rgb.g / 255;
        BsRGB = rgb.b / 255;
        if (RsRGB <= 0.03928) R = RsRGB / 12.92;
        else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
        if (GsRGB <= 0.03928) G = GsRGB / 12.92;
        else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
        if (BsRGB <= 0.03928) B = BsRGB / 12.92;
        else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
        this._a = $c2e2447aee45c515$var$boundAlpha(value);
        this._roundA = Math.round(100 * this._a) / 100;
        return this;
    },
    toHsv: function toHsv() {
        var hsv = $c2e2447aee45c515$var$rgbToHsv(this._r, this._g, this._b);
        return {
            h: hsv.h * 360,
            s: hsv.s,
            v: hsv.v,
            a: this._a
        };
    },
    toHsvString: function toHsvString() {
        var hsv = $c2e2447aee45c515$var$rgbToHsv(this._r, this._g, this._b);
        var h = Math.round(hsv.h * 360), s = Math.round(hsv.s * 100), v = Math.round(hsv.v * 100);
        return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
        var hsl = $c2e2447aee45c515$var$rgbToHsl(this._r, this._g, this._b);
        return {
            h: hsl.h * 360,
            s: hsl.s,
            l: hsl.l,
            a: this._a
        };
    },
    toHslString: function toHslString() {
        var hsl = $c2e2447aee45c515$var$rgbToHsl(this._r, this._g, this._b);
        var h = Math.round(hsl.h * 360), s = Math.round(hsl.s * 100), l = Math.round(hsl.l * 100);
        return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
        return $c2e2447aee45c515$var$rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
        return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
        return $c2e2447aee45c515$var$rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
        return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
        return {
            r: Math.round(this._r),
            g: Math.round(this._g),
            b: Math.round(this._b),
            a: this._a
        };
    },
    toRgbString: function toRgbString() {
        return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
        return {
            r: Math.round($c2e2447aee45c515$var$bound01(this._r, 255) * 100) + "%",
            g: Math.round($c2e2447aee45c515$var$bound01(this._g, 255) * 100) + "%",
            b: Math.round($c2e2447aee45c515$var$bound01(this._b, 255) * 100) + "%",
            a: this._a
        };
    },
    toPercentageRgbString: function toPercentageRgbString() {
        return this._a == 1 ? "rgb(" + Math.round($c2e2447aee45c515$var$bound01(this._r, 255) * 100) + "%, " + Math.round($c2e2447aee45c515$var$bound01(this._g, 255) * 100) + "%, " + Math.round($c2e2447aee45c515$var$bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round($c2e2447aee45c515$var$bound01(this._r, 255) * 100) + "%, " + Math.round($c2e2447aee45c515$var$bound01(this._g, 255) * 100) + "%, " + Math.round($c2e2447aee45c515$var$bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
        if (this._a === 0) return "transparent";
        if (this._a < 1) return false;
        return $c2e2447aee45c515$var$hexNames[$c2e2447aee45c515$var$rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
        var hex8String = "#" + $c2e2447aee45c515$var$rgbaToArgbHex(this._r, this._g, this._b, this._a);
        var secondHex8String = hex8String;
        var gradientType = this._gradientType ? "GradientType = 1, " : "";
        if (secondColor) {
            var s = $c2e2447aee45c515$export$2e2bcd8739ae039(secondColor);
            secondHex8String = "#" + $c2e2447aee45c515$var$rgbaToArgbHex(s._r, s._g, s._b, s._a);
        }
        return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
        var formatSet = !!format;
        format = format || this._format;
        var formattedString = false;
        var hasAlpha = this._a < 1 && this._a >= 0;
        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
        if (needsAlphaFormat) {
            // Special case for "transparent", all other non-alpha formats
            // will return rgba when there is transparency.
            if (format === "name" && this._a === 0) return this.toName();
            return this.toRgbString();
        }
        if (format === "rgb") formattedString = this.toRgbString();
        if (format === "prgb") formattedString = this.toPercentageRgbString();
        if (format === "hex" || format === "hex6") formattedString = this.toHexString();
        if (format === "hex3") formattedString = this.toHexString(true);
        if (format === "hex4") formattedString = this.toHex8String(true);
        if (format === "hex8") formattedString = this.toHex8String();
        if (format === "name") formattedString = this.toName();
        if (format === "hsl") formattedString = this.toHslString();
        if (format === "hsv") formattedString = this.toHsvString();
        return formattedString || this.toHexString();
    },
    clone: function clone() {
        return $c2e2447aee45c515$export$2e2bcd8739ae039(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
        var color = fn.apply(null, [
            this
        ].concat([].slice.call(args)));
        this._r = color._r;
        this._g = color._g;
        this._b = color._b;
        this.setAlpha(color._a);
        return this;
    },
    lighten: function lighten() {
        return this._applyModification($c2e2447aee45c515$var$_lighten, arguments);
    },
    brighten: function brighten() {
        return this._applyModification($c2e2447aee45c515$var$_brighten, arguments);
    },
    darken: function darken() {
        return this._applyModification($c2e2447aee45c515$var$_darken, arguments);
    },
    desaturate: function desaturate() {
        return this._applyModification($c2e2447aee45c515$var$_desaturate, arguments);
    },
    saturate: function saturate() {
        return this._applyModification($c2e2447aee45c515$var$_saturate, arguments);
    },
    greyscale: function greyscale() {
        return this._applyModification($c2e2447aee45c515$var$_greyscale, arguments);
    },
    spin: function spin() {
        return this._applyModification($c2e2447aee45c515$var$_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
        return fn.apply(null, [
            this
        ].concat([].slice.call(args)));
    },
    analogous: function analogous() {
        return this._applyCombination($c2e2447aee45c515$var$_analogous, arguments);
    },
    complement: function complement() {
        return this._applyCombination($c2e2447aee45c515$var$_complement, arguments);
    },
    monochromatic: function monochromatic() {
        return this._applyCombination($c2e2447aee45c515$var$_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
        return this._applyCombination($c2e2447aee45c515$var$_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
        return this._applyCombination($c2e2447aee45c515$var$polyad, [
            3
        ]);
    },
    tetrad: function tetrad() {
        return this._applyCombination($c2e2447aee45c515$var$polyad, [
            4
        ]);
    }
};
// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
$c2e2447aee45c515$export$2e2bcd8739ae039.fromRatio = function(color, opts) {
    if ($c2e2447aee45c515$var$_typeof(color) == "object") {
        var newColor = {};
        for(var i in color)if (color.hasOwnProperty(i)) {
            if (i === "a") newColor[i] = color[i];
            else newColor[i] = $c2e2447aee45c515$var$convertToPercentage(color[i]);
        }
        color = newColor;
    }
    return $c2e2447aee45c515$export$2e2bcd8739ae039(color, opts);
};
// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function $c2e2447aee45c515$var$inputToRGB(color) {
    var rgb = {
        r: 0,
        g: 0,
        b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") color = $c2e2447aee45c515$var$stringInputToObject(color);
    if ($c2e2447aee45c515$var$_typeof(color) == "object") {
        if ($c2e2447aee45c515$var$isValidCSSUnit(color.r) && $c2e2447aee45c515$var$isValidCSSUnit(color.g) && $c2e2447aee45c515$var$isValidCSSUnit(color.b)) {
            rgb = $c2e2447aee45c515$var$rgbToRgb(color.r, color.g, color.b);
            ok = true;
            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
        } else if ($c2e2447aee45c515$var$isValidCSSUnit(color.h) && $c2e2447aee45c515$var$isValidCSSUnit(color.s) && $c2e2447aee45c515$var$isValidCSSUnit(color.v)) {
            s = $c2e2447aee45c515$var$convertToPercentage(color.s);
            v = $c2e2447aee45c515$var$convertToPercentage(color.v);
            rgb = $c2e2447aee45c515$var$hsvToRgb(color.h, s, v);
            ok = true;
            format = "hsv";
        } else if ($c2e2447aee45c515$var$isValidCSSUnit(color.h) && $c2e2447aee45c515$var$isValidCSSUnit(color.s) && $c2e2447aee45c515$var$isValidCSSUnit(color.l)) {
            s = $c2e2447aee45c515$var$convertToPercentage(color.s);
            l = $c2e2447aee45c515$var$convertToPercentage(color.l);
            rgb = $c2e2447aee45c515$var$hslToRgb(color.h, s, l);
            ok = true;
            format = "hsl";
        }
        if (color.hasOwnProperty("a")) a = color.a;
    }
    a = $c2e2447aee45c515$var$boundAlpha(a);
    return {
        ok: ok,
        format: color.format || format,
        r: Math.min(255, Math.max(rgb.r, 0)),
        g: Math.min(255, Math.max(rgb.g, 0)),
        b: Math.min(255, Math.max(rgb.b, 0)),
        a: a
    };
}
// Conversion Functions
// --------------------
// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function $c2e2447aee45c515$var$rgbToRgb(r, g, b) {
    return {
        r: $c2e2447aee45c515$var$bound01(r, 255) * 255,
        g: $c2e2447aee45c515$var$bound01(g, 255) * 255,
        b: $c2e2447aee45c515$var$bound01(b, 255) * 255
    };
}
// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function $c2e2447aee45c515$var$rgbToHsl(r, g, b) {
    r = $c2e2447aee45c515$var$bound01(r, 255);
    g = $c2e2447aee45c515$var$bound01(g, 255);
    b = $c2e2447aee45c515$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, l = (max + min) / 2;
    if (max == min) h = s = 0; // achromatic
    else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        l: l
    };
}
// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $c2e2447aee45c515$var$hslToRgb(h, s, l) {
    var r, g, b;
    h = $c2e2447aee45c515$var$bound01(h, 360);
    s = $c2e2447aee45c515$var$bound01(s, 100);
    l = $c2e2447aee45c515$var$bound01(l, 100);
    function hue2rgb(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 0.5) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
    }
    if (s === 0) r = g = b = l; // achromatic
    else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function $c2e2447aee45c515$var$rgbToHsv(r, g, b) {
    r = $c2e2447aee45c515$var$bound01(r, 255);
    g = $c2e2447aee45c515$var$bound01(g, 255);
    b = $c2e2447aee45c515$var$bound01(b, 255);
    var max = Math.max(r, g, b), min = Math.min(r, g, b);
    var h, s, v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) h = 0; // achromatic
    else {
        switch(max){
            case r:
                h = (g - b) / d + (g < b ? 6 : 0);
                break;
            case g:
                h = (b - r) / d + 2;
                break;
            case b:
                h = (r - g) / d + 4;
                break;
        }
        h /= 6;
    }
    return {
        h: h,
        s: s,
        v: v
    };
}
// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function $c2e2447aee45c515$var$hsvToRgb(h, s, v) {
    h = $c2e2447aee45c515$var$bound01(h, 360) * 6;
    s = $c2e2447aee45c515$var$bound01(s, 100);
    v = $c2e2447aee45c515$var$bound01(v, 100);
    var i = Math.floor(h), f = h - i, p = v * (1 - s), q = v * (1 - f * s), t = v * (1 - (1 - f) * s), mod = i % 6, r = [
        v,
        q,
        p,
        p,
        t,
        v
    ][mod], g = [
        t,
        v,
        v,
        q,
        p,
        p
    ][mod], b = [
        p,
        p,
        t,
        v,
        v,
        q
    ][mod];
    return {
        r: r * 255,
        g: g * 255,
        b: b * 255
    };
}
// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function $c2e2447aee45c515$var$rgbToHex(r, g, b, allow3Char) {
    var hex = [
        $c2e2447aee45c515$var$pad2(Math.round(r).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(g).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(b).toString(16))
    ];
    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    return hex.join("");
}
// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function $c2e2447aee45c515$var$rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [
        $c2e2447aee45c515$var$pad2(Math.round(r).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(g).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(b).toString(16)),
        $c2e2447aee45c515$var$pad2($c2e2447aee45c515$var$convertDecimalToHex(a))
    ];
    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    return hex.join("");
}
// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function $c2e2447aee45c515$var$rgbaToArgbHex(r, g, b, a) {
    var hex = [
        $c2e2447aee45c515$var$pad2($c2e2447aee45c515$var$convertDecimalToHex(a)),
        $c2e2447aee45c515$var$pad2(Math.round(r).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(g).toString(16)),
        $c2e2447aee45c515$var$pad2(Math.round(b).toString(16))
    ];
    return hex.join("");
}
// `equals`
// Can be called with any tinycolor input
$c2e2447aee45c515$export$2e2bcd8739ae039.equals = function(color1, color2) {
    if (!color1 || !color2) return false;
    return $c2e2447aee45c515$export$2e2bcd8739ae039(color1).toRgbString() == $c2e2447aee45c515$export$2e2bcd8739ae039(color2).toRgbString();
};
$c2e2447aee45c515$export$2e2bcd8739ae039.random = function() {
    return $c2e2447aee45c515$export$2e2bcd8739ae039.fromRatio({
        r: Math.random(),
        g: Math.random(),
        b: Math.random()
    });
};
// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
function $c2e2447aee45c515$var$_desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = $c2e2447aee45c515$var$clamp01(hsl.s);
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
function $c2e2447aee45c515$var$_saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = $c2e2447aee45c515$var$clamp01(hsl.s);
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
function $c2e2447aee45c515$var$_greyscale(color) {
    return $c2e2447aee45c515$export$2e2bcd8739ae039(color).desaturate(100);
}
function $c2e2447aee45c515$var$_lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = $c2e2447aee45c515$var$clamp01(hsl.l);
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
function $c2e2447aee45c515$var$_brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return $c2e2447aee45c515$export$2e2bcd8739ae039(rgb);
}
function $c2e2447aee45c515$var$_darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = $c2e2447aee45c515$var$clamp01(hsl.l);
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function $c2e2447aee45c515$var$_spin(color, amount) {
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
function $c2e2447aee45c515$var$_complement(color) {
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return $c2e2447aee45c515$export$2e2bcd8739ae039(hsl);
}
function $c2e2447aee45c515$var$polyad(color, number) {
    if (isNaN(number) || number <= 0) throw new Error("Argument to polyad must be a positive number");
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    var result = [
        $c2e2447aee45c515$export$2e2bcd8739ae039(color)
    ];
    var step = 360 / number;
    for(var i = 1; i < number; i++)result.push($c2e2447aee45c515$export$2e2bcd8739ae039({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
    }));
    return result;
}
function $c2e2447aee45c515$var$_splitcomplement(color) {
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    var h = hsl.h;
    return [
        $c2e2447aee45c515$export$2e2bcd8739ae039(color),
        $c2e2447aee45c515$export$2e2bcd8739ae039({
            h: (h + 72) % 360,
            s: hsl.s,
            l: hsl.l
        }),
        $c2e2447aee45c515$export$2e2bcd8739ae039({
            h: (h + 216) % 360,
            s: hsl.s,
            l: hsl.l
        })
    ];
}
function $c2e2447aee45c515$var$_analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsl();
    var part = 360 / slices;
    var ret = [
        $c2e2447aee45c515$export$2e2bcd8739ae039(color)
    ];
    for(hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;){
        hsl.h = (hsl.h + part) % 360;
        ret.push($c2e2447aee45c515$export$2e2bcd8739ae039(hsl));
    }
    return ret;
}
function $c2e2447aee45c515$var$_monochromatic(color, results) {
    results = results || 6;
    var hsv = $c2e2447aee45c515$export$2e2bcd8739ae039(color).toHsv();
    var h = hsv.h, s = hsv.s, v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while(results--){
        ret.push($c2e2447aee45c515$export$2e2bcd8739ae039({
            h: h,
            s: s,
            v: v
        }));
        v = (v + modification) % 1;
    }
    return ret;
}
// Utility Functions
// ---------------------
$c2e2447aee45c515$export$2e2bcd8739ae039.mix = function(color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = $c2e2447aee45c515$export$2e2bcd8739ae039(color1).toRgb();
    var rgb2 = $c2e2447aee45c515$export$2e2bcd8739ae039(color2).toRgb();
    var p = amount / 100;
    var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return $c2e2447aee45c515$export$2e2bcd8739ae039(rgba);
};
// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
$c2e2447aee45c515$export$2e2bcd8739ae039.readability = function(color1, color2) {
    var c1 = $c2e2447aee45c515$export$2e2bcd8739ae039(color1);
    var c2 = $c2e2447aee45c515$export$2e2bcd8739ae039(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};
// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
$c2e2447aee45c515$export$2e2bcd8739ae039.isReadable = function(color1, color2, wcag2) {
    var readability = $c2e2447aee45c515$export$2e2bcd8739ae039.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = $c2e2447aee45c515$var$validateWCAG2Parms(wcag2);
    switch(wcag2Parms.level + wcag2Parms.size){
        case "AAsmall":
        case "AAAlarge":
            out = readability >= 4.5;
            break;
        case "AAlarge":
            out = readability >= 3;
            break;
        case "AAAsmall":
            out = readability >= 7;
            break;
    }
    return out;
};
// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
$c2e2447aee45c515$export$2e2bcd8739ae039.mostReadable = function(baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for(var i = 0; i < colorList.length; i++){
        readability = $c2e2447aee45c515$export$2e2bcd8739ae039.readability(baseColor, colorList[i]);
        if (readability > bestScore) {
            bestScore = readability;
            bestColor = $c2e2447aee45c515$export$2e2bcd8739ae039(colorList[i]);
        }
    }
    if ($c2e2447aee45c515$export$2e2bcd8739ae039.isReadable(baseColor, bestColor, {
        level: level,
        size: size
    }) || !includeFallbackColors) return bestColor;
    else {
        args.includeFallbackColors = false;
        return $c2e2447aee45c515$export$2e2bcd8739ae039.mostReadable(baseColor, [
            "#fff",
            "#000"
        ], args);
    }
};
// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var $c2e2447aee45c515$var$names = $c2e2447aee45c515$export$2e2bcd8739ae039.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
};
// Make it easy to access colors via `hexNames[hex]`
var $c2e2447aee45c515$var$hexNames = $c2e2447aee45c515$export$2e2bcd8739ae039.hexNames = $c2e2447aee45c515$var$flip($c2e2447aee45c515$var$names);
// Utilities
// ---------
// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function $c2e2447aee45c515$var$flip(o) {
    var flipped = {};
    for(var i in o)if (o.hasOwnProperty(i)) flipped[o[i]] = i;
    return flipped;
}
// Return a valid alpha value [0,1] with all invalid values being set to 1
function $c2e2447aee45c515$var$boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) a = 1;
    return a;
}
// Take input from [0, n] and return it as [0, 1]
function $c2e2447aee45c515$var$bound01(n, max) {
    if ($c2e2447aee45c515$var$isOnePointZero(n)) n = "100%";
    var processPercent = $c2e2447aee45c515$var$isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));
    // Automatically convert percentage into number
    if (processPercent) n = parseInt(n * max, 10) / 100;
    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) return 1;
    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
}
// Force a number between 0 and 1
function $c2e2447aee45c515$var$clamp01(val) {
    return Math.min(1, Math.max(0, val));
}
// Parse a base-16 hex value into a base-10 integer
function $c2e2447aee45c515$var$parseIntFromHex(val) {
    return parseInt(val, 16);
}
// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function $c2e2447aee45c515$var$isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}
// Check to see if string passed in is a percentage
function $c2e2447aee45c515$var$isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
}
// Force a hex value to have 2 characters
function $c2e2447aee45c515$var$pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
}
// Replace a decimal with it's percentage value
function $c2e2447aee45c515$var$convertToPercentage(n) {
    if (n <= 1) n = n * 100 + "%";
    return n;
}
// Converts a decimal to a hex value
function $c2e2447aee45c515$var$convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function $c2e2447aee45c515$var$convertHexToDecimal(h) {
    return $c2e2447aee45c515$var$parseIntFromHex(h) / 255;
}
var $c2e2447aee45c515$var$matchers = function() {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";
    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
        CSS_UNIT: new RegExp(CSS_UNIT),
        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
}();
// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function $c2e2447aee45c515$var$isValidCSSUnit(color) {
    return !!$c2e2447aee45c515$var$matchers.CSS_UNIT.exec(color);
}
// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function $c2e2447aee45c515$var$stringInputToObject(color) {
    color = color.replace($c2e2447aee45c515$var$trimLeft, "").replace($c2e2447aee45c515$var$trimRight, "").toLowerCase();
    var named = false;
    if ($c2e2447aee45c515$var$names[color]) {
        color = $c2e2447aee45c515$var$names[color];
        named = true;
    } else if (color == "transparent") return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
    };
    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = $c2e2447aee45c515$var$matchers.rgb.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3]
    };
    if (match = $c2e2447aee45c515$var$matchers.rgba.exec(color)) return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
    };
    if (match = $c2e2447aee45c515$var$matchers.hsl.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3]
    };
    if (match = $c2e2447aee45c515$var$matchers.hsla.exec(color)) return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
    };
    if (match = $c2e2447aee45c515$var$matchers.hsv.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3]
    };
    if (match = $c2e2447aee45c515$var$matchers.hsva.exec(color)) return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
    };
    if (match = $c2e2447aee45c515$var$matchers.hex8.exec(color)) return {
        r: $c2e2447aee45c515$var$parseIntFromHex(match[1]),
        g: $c2e2447aee45c515$var$parseIntFromHex(match[2]),
        b: $c2e2447aee45c515$var$parseIntFromHex(match[3]),
        a: $c2e2447aee45c515$var$convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $c2e2447aee45c515$var$matchers.hex6.exec(color)) return {
        r: $c2e2447aee45c515$var$parseIntFromHex(match[1]),
        g: $c2e2447aee45c515$var$parseIntFromHex(match[2]),
        b: $c2e2447aee45c515$var$parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
    };
    if (match = $c2e2447aee45c515$var$matchers.hex4.exec(color)) return {
        r: $c2e2447aee45c515$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $c2e2447aee45c515$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $c2e2447aee45c515$var$parseIntFromHex(match[3] + "" + match[3]),
        a: $c2e2447aee45c515$var$convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
    };
    if (match = $c2e2447aee45c515$var$matchers.hex3.exec(color)) return {
        r: $c2e2447aee45c515$var$parseIntFromHex(match[1] + "" + match[1]),
        g: $c2e2447aee45c515$var$parseIntFromHex(match[2] + "" + match[2]),
        b: $c2e2447aee45c515$var$parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
    };
    return false;
}
function $c2e2447aee45c515$var$validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
        level: "AA",
        size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") level = "AA";
    if (size !== "small" && size !== "large") size = "small";
    return {
        level: level,
        size: size
    };
}


var $ef913fe6710c7df5$export$4837207a530c7f21 = function simpleCheckForValidColor(data) {
    var keysToCheck = [
        "r",
        "g",
        "b",
        "a",
        "h",
        "s",
        "l",
        "v"
    ];
    var checked = 0;
    var passed = 0;
    (0, $fa803b436c5f6962$export$2e2bcd8739ae039)(keysToCheck, function(letter) {
        if (data[letter]) {
            checked += 1;
            if (!isNaN(data[letter])) passed += 1;
            if (letter === "s" || letter === "l") {
                var percentPatt = /^\d+%$/;
                if (percentPatt.test(data[letter])) passed += 1;
            }
        }
    });
    return checked === passed ? data : false;
};
var $ef913fe6710c7df5$export$6bed283375899438 = function toState(data, oldHue) {
    var color = data.hex ? (0, $c2e2447aee45c515$export$2e2bcd8739ae039)(data.hex) : (0, $c2e2447aee45c515$export$2e2bcd8739ae039)(data);
    var hsl = color.toHsl();
    var hsv = color.toHsv();
    var rgb = color.toRgb();
    var hex = color.toHex();
    if (hsl.s === 0) {
        hsl.h = oldHue || 0;
        hsv.h = oldHue || 0;
    }
    var transparent = hex === "000000" && rgb.a === 0;
    return {
        hsl: hsl,
        hex: transparent ? "transparent" : "#" + hex,
        rgb: rgb,
        hsv: hsv,
        oldHue: data.h || oldHue || hsl.h,
        source: data.source
    };
};
var $ef913fe6710c7df5$export$944f75ec5697b362 = function isValidHex(hex) {
    if (hex === "transparent") return true;
    // disable hex4 and hex8
    var lh = String(hex).charAt(0) === "#" ? 1 : 0;
    return hex.length !== 4 + lh && hex.length < 7 + lh && (0, $c2e2447aee45c515$export$2e2bcd8739ae039)(hex).isValid();
};
var $ef913fe6710c7df5$export$3609eb1d7e55dec = function getContrastingColor(data) {
    if (!data) return "#fff";
    var col = $ef913fe6710c7df5$export$6bed283375899438(data);
    if (col.hex === "transparent") return "rgba(0,0,0,0.4)";
    var yiq = (col.rgb.r * 299 + col.rgb.g * 587 + col.rgb.b * 114) / 1000;
    return yiq >= 128 ? "#000" : "#fff";
};
var $ef913fe6710c7df5$export$a90204d1394caf30 = {
    hsl: {
        a: 1,
        h: 0,
        l: 0.5,
        s: 1
    },
    hex: "#ff0000",
    rgb: {
        r: 255,
        g: 0,
        b: 0,
        a: 1
    },
    hsv: {
        h: 0,
        s: 1,
        v: 1,
        a: 1
    }
};
var $ef913fe6710c7df5$export$e76ec4c5b3cadd73 = function isvalidColorString(string, type) {
    var stringWithoutDegree = string.replace("\xb0", "");
    return (0, $c2e2447aee45c515$export$2e2bcd8739ae039)(type + " (" + stringWithoutDegree + ")")._ok;
};


var $d4aadc8759a4ab83$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $d4aadc8759a4ab83$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $d4aadc8759a4ab83$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d4aadc8759a4ab83$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $d4aadc8759a4ab83$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $d4aadc8759a4ab83$export$68265aef2e61bec7 = function ColorWrap(Picker) {
    var ColorPicker = function(_ref) {
        $d4aadc8759a4ab83$var$_inherits(ColorPicker, _ref);
        function ColorPicker(props) {
            $d4aadc8759a4ab83$var$_classCallCheck(this, ColorPicker);
            var _this = $d4aadc8759a4ab83$var$_possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this));
            _this.handleChange = function(data, event) {
                var isValidColor = $ef913fe6710c7df5$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $ef913fe6710c7df5$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.setState(colors);
                    _this.props.onChangeComplete && _this.debounce(_this.props.onChangeComplete, colors, event);
                    _this.props.onChange && _this.props.onChange(colors, event);
                }
            };
            _this.handleSwatchHover = function(data, event) {
                var isValidColor = $ef913fe6710c7df5$export$4837207a530c7f21(data);
                if (isValidColor) {
                    var colors = $ef913fe6710c7df5$export$6bed283375899438(data, data.h || _this.state.oldHue);
                    _this.props.onSwatchHover && _this.props.onSwatchHover(colors, event);
                }
            };
            _this.state = $d4aadc8759a4ab83$var$_extends({}, $ef913fe6710c7df5$export$6bed283375899438(props.color, 0));
            _this.debounce = (0, $c37a21cf058dfbf0$export$2e2bcd8739ae039)(function(fn, data, event) {
                fn(data, event);
            }, 100);
            return _this;
        }
        $d4aadc8759a4ab83$var$_createClass(ColorPicker, [
            {
                key: "render",
                value: function render() {
                    var optionalEvents = {};
                    if (this.props.onSwatchHover) optionalEvents.onSwatchHover = this.handleSwatchHover;
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Picker, $d4aadc8759a4ab83$var$_extends({}, this.props, this.state, {
                        onChange: this.handleChange
                    }, optionalEvents));
                }
            }
        ], [
            {
                key: "getDerivedStateFromProps",
                value: function getDerivedStateFromProps(nextProps, state) {
                    return $d4aadc8759a4ab83$var$_extends({}, $ef913fe6710c7df5$export$6bed283375899438(nextProps.color, state.oldHue));
                }
            }
        ]);
        return ColorPicker;
    }((0, $eCoWV.PureComponent) || (0, $eCoWV.Component));
    ColorPicker.propTypes = $d4aadc8759a4ab83$var$_extends({}, Picker.propTypes);
    ColorPicker.defaultProps = $d4aadc8759a4ab83$var$_extends({}, Picker.defaultProps, {
        color: {
            h: 250,
            s: 0.50,
            l: 0.20,
            a: 1
        }
    });
    return ColorPicker;
};
var $d4aadc8759a4ab83$export$2e2bcd8739ae039 = $d4aadc8759a4ab83$export$68265aef2e61bec7;



var $eCoWV = parcelRequire("eCoWV");


var $eCoWV = parcelRequire("eCoWV");
var $123a35ff385b17e7$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $123a35ff385b17e7$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $123a35ff385b17e7$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $123a35ff385b17e7$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $123a35ff385b17e7$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $123a35ff385b17e7$export$185584c64f36588 = function handleFocus(Component) {
    var Span = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "span";
    return function(_React$Component) {
        $123a35ff385b17e7$var$_inherits(Focus, _React$Component);
        function Focus() {
            var _ref;
            var _temp, _this, _ret;
            $123a35ff385b17e7$var$_classCallCheck(this, Focus);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $123a35ff385b17e7$var$_possibleConstructorReturn(this, (_ref = Focus.__proto__ || Object.getPrototypeOf(Focus)).call.apply(_ref, [
                this
            ].concat(args))), _this), _this.state = {
                focus: false
            }, _this.handleFocus = function() {
                return _this.setState({
                    focus: true
                });
            }, _this.handleBlur = function() {
                return _this.setState({
                    focus: false
                });
            }, _temp), $123a35ff385b17e7$var$_possibleConstructorReturn(_this, _ret);
        }
        $123a35ff385b17e7$var$_createClass(Focus, [
            {
                key: "render",
                value: function render() {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Span, {
                        onFocus: this.handleFocus,
                        onBlur: this.handleBlur
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(Component, $123a35ff385b17e7$var$_extends({}, this.props, this.state)));
                }
            }
        ]);
        return Focus;
    }((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Component);
};



var $638ea217c626d375$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $638ea217c626d375$var$ENTER = 13;
var $638ea217c626d375$export$c463048d6131b309 = function Swatch(_ref) {
    var color = _ref.color, style = _ref.style, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onHover = _ref.onHover, _ref$title = _ref.title, title = _ref$title === undefined ? color : _ref$title, children = _ref.children, focus = _ref.focus, _ref$focusStyle = _ref.focusStyle, focusStyle = _ref$focusStyle === undefined ? {} : _ref$focusStyle;
    var transparent = color === "transparent";
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        default: {
            swatch: $638ea217c626d375$var$_extends({
                background: color,
                height: "100%",
                width: "100%",
                cursor: "pointer",
                position: "relative",
                outline: "none"
            }, style, focus ? focusStyle : {})
        }
    });
    var handleClick = function handleClick(e) {
        return onClick(color, e);
    };
    var handleKeyDown = function handleKeyDown(e) {
        return e.keyCode === $638ea217c626d375$var$ENTER && onClick(color, e);
    };
    var handleHover = function handleHover(e) {
        return onHover(color, e);
    };
    var optionalEvents = {};
    if (onHover) optionalEvents.onMouseOver = handleHover;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", $638ea217c626d375$var$_extends({
        style: styles.swatch,
        onClick: handleClick,
        title: title,
        tabIndex: 0,
        onKeyDown: handleKeyDown
    }, optionalEvents), children, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $49a998e72892ed67$export$2e2bcd8739ae039), {
        borderRadius: styles.swatch.borderRadius,
        boxShadow: "inset 0 0 0 1px rgba(0,0,0,0.1)"
    }));
};
var $638ea217c626d375$export$2e2bcd8739ae039 = (0, $123a35ff385b17e7$export$185584c64f36588)($638ea217c626d375$export$c463048d6131b309);





var $eCoWV = parcelRequire("eCoWV");

var $c5a541d7f5792be6$export$5bbd8091d1d0e224 = function AlphaPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $c5a541d7f5792be6$export$2e2bcd8739ae039 = $c5a541d7f5792be6$export$5bbd8091d1d0e224;


var $14e1cc43c98b577c$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $14e1cc43c98b577c$export$421d2c1bdabf8a68 = function AlphaPicker(_ref) {
    var rgb = _ref.rgb, hsl = _ref.hsl, width = _ref.width, height = _ref.height, onChange = _ref.onChange, direction = _ref.direction, style = _ref.style, renderers = _ref.renderers, pointer = _ref.pointer, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            alpha: {
                radius: "2px",
                style: style
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "alpha-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $cf5fa3fd43734c4f$export$2e2bcd8739ae039), $14e1cc43c98b577c$var$_extends({}, styles.alpha, {
        rgb: rgb,
        hsl: hsl,
        pointer: pointer,
        renderers: renderers,
        onChange: onChange,
        direction: direction
    })));
};
$14e1cc43c98b577c$export$421d2c1bdabf8a68.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $c5a541d7f5792be6$export$2e2bcd8739ae039)
};
var $14e1cc43c98b577c$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($14e1cc43c98b577c$export$421d2c1bdabf8a68);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");





var $eCoWV = parcelRequire("eCoWV");

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $9100fe639d2e18f7$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $9100fe639d2e18f7$export$2e2bcd8739ae039 = $9100fe639d2e18f7$var$arrayMap;





/** Used to stand-in for `undefined` hash values. */ var $8c39d85a0166754b$var$HASH_UNDEFINED = "__lodash_hash_undefined__";
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function $8c39d85a0166754b$var$setCacheAdd(value) {
    this.__data__.set(value, $8c39d85a0166754b$var$HASH_UNDEFINED);
    return this;
}
var $8c39d85a0166754b$export$2e2bcd8739ae039 = $8c39d85a0166754b$var$setCacheAdd;


/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */ function $2d541e462c80a0aa$var$setCacheHas(value) {
    return this.__data__.has(value);
}
var $2d541e462c80a0aa$export$2e2bcd8739ae039 = $2d541e462c80a0aa$var$setCacheHas;


/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function $2146a7b817b383f0$var$SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new (0, $cd0c97854034ec9e$export$2e2bcd8739ae039);
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
$2146a7b817b383f0$var$SetCache.prototype.add = $2146a7b817b383f0$var$SetCache.prototype.push = (0, $8c39d85a0166754b$export$2e2bcd8739ae039);
$2146a7b817b383f0$var$SetCache.prototype.has = (0, $2d541e462c80a0aa$export$2e2bcd8739ae039);
var $2146a7b817b383f0$export$2e2bcd8739ae039 = $2146a7b817b383f0$var$SetCache;


/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $9fa9d5264b6a6b34$var$arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
var $9fa9d5264b6a6b34$export$2e2bcd8739ae039 = $9fa9d5264b6a6b34$var$arraySome;


/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $51f00ebb63641a44$var$cacheHas(cache, key) {
    return cache.has(key);
}
var $51f00ebb63641a44$export$2e2bcd8739ae039 = $51f00ebb63641a44$var$cacheHas;


/** Used to compose bitmasks for value comparisons. */ var $3ad38f8b051371f9$var$COMPARE_PARTIAL_FLAG = 1, $3ad38f8b051371f9$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function $3ad38f8b051371f9$var$equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $3ad38f8b051371f9$var$COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & $3ad38f8b051371f9$var$COMPARE_UNORDERED_FLAG ? new (0, $2146a7b817b383f0$export$2e2bcd8739ae039) : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!(0, $9fa9d5264b6a6b34$export$2e2bcd8739ae039)(other, function(othValue, othIndex) {
                if (!(0, $51f00ebb63641a44$export$2e2bcd8739ae039)(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack["delete"](array);
    stack["delete"](other);
    return result;
}
var $3ad38f8b051371f9$export$2e2bcd8739ae039 = $3ad38f8b051371f9$var$equalArrays;






/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function $c25b57f6c4c92b5c$var$mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
var $c25b57f6c4c92b5c$export$2e2bcd8739ae039 = $c25b57f6c4c92b5c$var$mapToArray;


/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function $3dc86c7bf8dc5fff$var$setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
var $3dc86c7bf8dc5fff$export$2e2bcd8739ae039 = $3dc86c7bf8dc5fff$var$setToArray;


/** Used to compose bitmasks for value comparisons. */ var $350145d668923fda$var$COMPARE_PARTIAL_FLAG = 1, $350145d668923fda$var$COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var $350145d668923fda$var$boolTag = "[object Boolean]", $350145d668923fda$var$dateTag = "[object Date]", $350145d668923fda$var$errorTag = "[object Error]", $350145d668923fda$var$mapTag = "[object Map]", $350145d668923fda$var$numberTag = "[object Number]", $350145d668923fda$var$regexpTag = "[object RegExp]", $350145d668923fda$var$setTag = "[object Set]", $350145d668923fda$var$stringTag = "[object String]", $350145d668923fda$var$symbolTag = "[object Symbol]";
var $350145d668923fda$var$arrayBufferTag = "[object ArrayBuffer]", $350145d668923fda$var$dataViewTag = "[object DataView]";
/** Used to convert symbols to primitives and strings. */ var $350145d668923fda$var$symbolProto = (0, $375e3a674890bf85$export$2e2bcd8739ae039) ? (0, $375e3a674890bf85$export$2e2bcd8739ae039).prototype : undefined, $350145d668923fda$var$symbolValueOf = $350145d668923fda$var$symbolProto ? $350145d668923fda$var$symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $350145d668923fda$var$equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case $350145d668923fda$var$dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case $350145d668923fda$var$arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new (0, $3d5051da4bd19c85$export$2e2bcd8739ae039)(object), new (0, $3d5051da4bd19c85$export$2e2bcd8739ae039)(other))) return false;
            return true;
        case $350145d668923fda$var$boolTag:
        case $350145d668923fda$var$dateTag:
        case $350145d668923fda$var$numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return (0, $4e9d5455d0a9da98$export$2e2bcd8739ae039)(+object, +other);
        case $350145d668923fda$var$errorTag:
            return object.name == other.name && object.message == other.message;
        case $350145d668923fda$var$regexpTag:
        case $350145d668923fda$var$stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + "";
        case $350145d668923fda$var$mapTag:
            var convert = (0, $c25b57f6c4c92b5c$export$2e2bcd8739ae039);
        case $350145d668923fda$var$setTag:
            var isPartial = bitmask & $350145d668923fda$var$COMPARE_PARTIAL_FLAG;
            convert || (convert = (0, $3dc86c7bf8dc5fff$export$2e2bcd8739ae039));
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= $350145d668923fda$var$COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = (0, $3ad38f8b051371f9$export$2e2bcd8739ae039)(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack["delete"](object);
            return result;
        case $350145d668923fda$var$symbolTag:
            if ($350145d668923fda$var$symbolValueOf) return $350145d668923fda$var$symbolValueOf.call(object) == $350145d668923fda$var$symbolValueOf.call(other);
    }
    return false;
}
var $350145d668923fda$export$2e2bcd8739ae039 = $350145d668923fda$var$equalByTag;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $7438fd5336a9ba90$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $7438fd5336a9ba90$export$2e2bcd8739ae039 = $7438fd5336a9ba90$var$arrayPush;



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $2138d43679e62b85$var$baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(object) ? result : (0, $7438fd5336a9ba90$export$2e2bcd8739ae039)(result, symbolsFunc(object));
}
var $2138d43679e62b85$export$2e2bcd8739ae039 = $2138d43679e62b85$var$baseGetAllKeys;


/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function $a9ed0759d3fdc3e4$var$arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
var $a9ed0759d3fdc3e4$export$2e2bcd8739ae039 = $a9ed0759d3fdc3e4$var$arrayFilter;


/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function $964cf5c90bfa499b$var$stubArray() {
    return [];
}
var $964cf5c90bfa499b$export$2e2bcd8739ae039 = $964cf5c90bfa499b$var$stubArray;


/** Used for built-in method references. */ var $6af6f841314daae7$var$objectProto = Object.prototype;
/** Built-in value references. */ var $6af6f841314daae7$var$propertyIsEnumerable = $6af6f841314daae7$var$objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6af6f841314daae7$var$nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var $6af6f841314daae7$var$getSymbols = !$6af6f841314daae7$var$nativeGetSymbols ? (0, $964cf5c90bfa499b$export$2e2bcd8739ae039) : function(object) {
    if (object == null) return [];
    object = Object(object);
    return (0, $a9ed0759d3fdc3e4$export$2e2bcd8739ae039)($6af6f841314daae7$var$nativeGetSymbols(object), function(symbol) {
        return $6af6f841314daae7$var$propertyIsEnumerable.call(object, symbol);
    });
};
var $6af6f841314daae7$export$2e2bcd8739ae039 = $6af6f841314daae7$var$getSymbols;



/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function $24295171a8f1d7a2$var$getAllKeys(object) {
    return (0, $2138d43679e62b85$export$2e2bcd8739ae039)(object, (0, $9ef7bf4bc0a4b5fa$export$2e2bcd8739ae039), (0, $6af6f841314daae7$export$2e2bcd8739ae039));
}
var $24295171a8f1d7a2$export$2e2bcd8739ae039 = $24295171a8f1d7a2$var$getAllKeys;


/** Used to compose bitmasks for value comparisons. */ var $e9546aabee9fe8c1$var$COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var $e9546aabee9fe8c1$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e9546aabee9fe8c1$var$hasOwnProperty = $e9546aabee9fe8c1$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $e9546aabee9fe8c1$var$equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & $e9546aabee9fe8c1$var$COMPARE_PARTIAL_FLAG, objProps = (0, $24295171a8f1d7a2$export$2e2bcd8739ae039)(object), objLength = objProps.length, othProps = (0, $24295171a8f1d7a2$export$2e2bcd8739ae039)(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : $e9546aabee9fe8c1$var$hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == "constructor");
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && "constructor" in object && "constructor" in other && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) result = false;
    }
    stack["delete"](object);
    stack["delete"](other);
    return result;
}
var $e9546aabee9fe8c1$export$2e2bcd8739ae039 = $e9546aabee9fe8c1$var$equalObjects;




var $etFod = parcelRequire("etFod");
/* Built-in method references that are verified to be native. */ var $9e567855d4d6641d$var$DataView = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)((0, $etFod.default), "DataView");
var $9e567855d4d6641d$export$2e2bcd8739ae039 = $9e567855d4d6641d$var$DataView;





var $etFod = parcelRequire("etFod");
/* Built-in method references that are verified to be native. */ var $96b2e65271587b78$var$Promise = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)((0, $etFod.default), "Promise");
var $96b2e65271587b78$export$2e2bcd8739ae039 = $96b2e65271587b78$var$Promise;




var $etFod = parcelRequire("etFod");
/* Built-in method references that are verified to be native. */ var $befdfaf7d2ee4776$var$Set = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)((0, $etFod.default), "Set");
var $befdfaf7d2ee4776$export$2e2bcd8739ae039 = $befdfaf7d2ee4776$var$Set;




var $etFod = parcelRequire("etFod");
/* Built-in method references that are verified to be native. */ var $72b7063ae0282e2c$var$WeakMap = (0, $ff6df215563dc77b$export$2e2bcd8739ae039)((0, $etFod.default), "WeakMap");
var $72b7063ae0282e2c$export$2e2bcd8739ae039 = $72b7063ae0282e2c$var$WeakMap;




/** `Object#toString` result references. */ var $aafe2c46a67d760a$var$mapTag = "[object Map]", $aafe2c46a67d760a$var$objectTag = "[object Object]", $aafe2c46a67d760a$var$promiseTag = "[object Promise]", $aafe2c46a67d760a$var$setTag = "[object Set]", $aafe2c46a67d760a$var$weakMapTag = "[object WeakMap]";
var $aafe2c46a67d760a$var$dataViewTag = "[object DataView]";
/** Used to detect maps, sets, and weakmaps. */ var $aafe2c46a67d760a$var$dataViewCtorString = (0, $6cf9d01331166732$export$2e2bcd8739ae039)((0, $9e567855d4d6641d$export$2e2bcd8739ae039)), $aafe2c46a67d760a$var$mapCtorString = (0, $6cf9d01331166732$export$2e2bcd8739ae039)((0, $19ce6fac2831f009$export$2e2bcd8739ae039)), $aafe2c46a67d760a$var$promiseCtorString = (0, $6cf9d01331166732$export$2e2bcd8739ae039)((0, $96b2e65271587b78$export$2e2bcd8739ae039)), $aafe2c46a67d760a$var$setCtorString = (0, $6cf9d01331166732$export$2e2bcd8739ae039)((0, $befdfaf7d2ee4776$export$2e2bcd8739ae039)), $aafe2c46a67d760a$var$weakMapCtorString = (0, $6cf9d01331166732$export$2e2bcd8739ae039)((0, $72b7063ae0282e2c$export$2e2bcd8739ae039));
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var $aafe2c46a67d760a$var$getTag = (0, $719a43f053b573ae$export$2e2bcd8739ae039);
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((0, $9e567855d4d6641d$export$2e2bcd8739ae039) && $aafe2c46a67d760a$var$getTag(new (0, $9e567855d4d6641d$export$2e2bcd8739ae039)(new ArrayBuffer(1))) != $aafe2c46a67d760a$var$dataViewTag || (0, $19ce6fac2831f009$export$2e2bcd8739ae039) && $aafe2c46a67d760a$var$getTag(new (0, $19ce6fac2831f009$export$2e2bcd8739ae039)) != $aafe2c46a67d760a$var$mapTag || (0, $96b2e65271587b78$export$2e2bcd8739ae039) && $aafe2c46a67d760a$var$getTag((0, $96b2e65271587b78$export$2e2bcd8739ae039).resolve()) != $aafe2c46a67d760a$var$promiseTag || (0, $befdfaf7d2ee4776$export$2e2bcd8739ae039) && $aafe2c46a67d760a$var$getTag(new (0, $befdfaf7d2ee4776$export$2e2bcd8739ae039)) != $aafe2c46a67d760a$var$setTag || (0, $72b7063ae0282e2c$export$2e2bcd8739ae039) && $aafe2c46a67d760a$var$getTag(new (0, $72b7063ae0282e2c$export$2e2bcd8739ae039)) != $aafe2c46a67d760a$var$weakMapTag) $aafe2c46a67d760a$var$getTag = function(value) {
    var result = (0, $719a43f053b573ae$export$2e2bcd8739ae039)(value), Ctor = result == $aafe2c46a67d760a$var$objectTag ? value.constructor : undefined, ctorString = Ctor ? (0, $6cf9d01331166732$export$2e2bcd8739ae039)(Ctor) : "";
    if (ctorString) switch(ctorString){
        case $aafe2c46a67d760a$var$dataViewCtorString:
            return $aafe2c46a67d760a$var$dataViewTag;
        case $aafe2c46a67d760a$var$mapCtorString:
            return $aafe2c46a67d760a$var$mapTag;
        case $aafe2c46a67d760a$var$promiseCtorString:
            return $aafe2c46a67d760a$var$promiseTag;
        case $aafe2c46a67d760a$var$setCtorString:
            return $aafe2c46a67d760a$var$setTag;
        case $aafe2c46a67d760a$var$weakMapCtorString:
            return $aafe2c46a67d760a$var$weakMapTag;
    }
    return result;
};
var $aafe2c46a67d760a$export$2e2bcd8739ae039 = $aafe2c46a67d760a$var$getTag;




var $1nmna = parcelRequire("1nmna");

/** Used to compose bitmasks for value comparisons. */ var $90d154c0e61fe472$var$COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var $90d154c0e61fe472$var$argsTag = "[object Arguments]", $90d154c0e61fe472$var$arrayTag = "[object Array]", $90d154c0e61fe472$var$objectTag = "[object Object]";
/** Used for built-in method references. */ var $90d154c0e61fe472$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $90d154c0e61fe472$var$hasOwnProperty = $90d154c0e61fe472$var$objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function $90d154c0e61fe472$var$baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(object), othIsArr = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(other), objTag = objIsArr ? $90d154c0e61fe472$var$arrayTag : (0, $aafe2c46a67d760a$export$2e2bcd8739ae039)(object), othTag = othIsArr ? $90d154c0e61fe472$var$arrayTag : (0, $aafe2c46a67d760a$export$2e2bcd8739ae039)(other);
    objTag = objTag == $90d154c0e61fe472$var$argsTag ? $90d154c0e61fe472$var$objectTag : objTag;
    othTag = othTag == $90d154c0e61fe472$var$argsTag ? $90d154c0e61fe472$var$objectTag : othTag;
    var objIsObj = objTag == $90d154c0e61fe472$var$objectTag, othIsObj = othTag == $90d154c0e61fe472$var$objectTag, isSameTag = objTag == othTag;
    if (isSameTag && (0, $1nmna.default)(object)) {
        if (!(0, $1nmna.default)(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new (0, $bc3d7f109e126fbe$export$2e2bcd8739ae039));
        return objIsArr || (0, $4932f3d7733b0312$export$2e2bcd8739ae039)(object) ? (0, $3ad38f8b051371f9$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack) : (0, $350145d668923fda$export$2e2bcd8739ae039)(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & $90d154c0e61fe472$var$COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && $90d154c0e61fe472$var$hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && $90d154c0e61fe472$var$hasOwnProperty.call(other, "__wrapped__");
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new (0, $bc3d7f109e126fbe$export$2e2bcd8739ae039));
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new (0, $bc3d7f109e126fbe$export$2e2bcd8739ae039));
    return (0, $e9546aabee9fe8c1$export$2e2bcd8739ae039)(object, other, bitmask, customizer, equalFunc, stack);
}
var $90d154c0e61fe472$export$2e2bcd8739ae039 = $90d154c0e61fe472$var$baseIsEqualDeep;



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function $0b6752f8f5e972ac$var$baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !(0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(value) && !(0, $5a1d34ee4ba9ab98$export$2e2bcd8739ae039)(other)) return value !== value && other !== other;
    return (0, $90d154c0e61fe472$export$2e2bcd8739ae039)(value, other, bitmask, customizer, $0b6752f8f5e972ac$var$baseIsEqual, stack);
}
var $0b6752f8f5e972ac$export$2e2bcd8739ae039 = $0b6752f8f5e972ac$var$baseIsEqual;


/** Used to compose bitmasks for value comparisons. */ var $d96bfe40f29ac9fd$var$COMPARE_PARTIAL_FLAG = 1, $d96bfe40f29ac9fd$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function $d96bfe40f29ac9fd$var$baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new (0, $bc3d7f109e126fbe$export$2e2bcd8739ae039);
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? (0, $0b6752f8f5e972ac$export$2e2bcd8739ae039)(srcValue, objValue, $d96bfe40f29ac9fd$var$COMPARE_PARTIAL_FLAG | $d96bfe40f29ac9fd$var$COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
var $d96bfe40f29ac9fd$export$2e2bcd8739ae039 = $d96bfe40f29ac9fd$var$baseIsMatch;



/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function $34519205acfc9464$var$isStrictComparable(value) {
    return value === value && !(0, $0fe00e6dc0c0afea$export$2e2bcd8739ae039)(value);
}
var $34519205acfc9464$export$2e2bcd8739ae039 = $34519205acfc9464$var$isStrictComparable;



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function $35a39dfcf36c4e43$var$getMatchData(object) {
    var result = (0, $9ef7bf4bc0a4b5fa$export$2e2bcd8739ae039)(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            (0, $34519205acfc9464$export$2e2bcd8739ae039)(value)
        ];
    }
    return result;
}
var $35a39dfcf36c4e43$export$2e2bcd8739ae039 = $35a39dfcf36c4e43$var$getMatchData;


/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $169abaf1e01dd4d2$var$matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
var $169abaf1e01dd4d2$export$2e2bcd8739ae039 = $169abaf1e01dd4d2$var$matchesStrictComparable;


/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function $679818435cf99fe1$var$baseMatches(source) {
    var matchData = (0, $35a39dfcf36c4e43$export$2e2bcd8739ae039)(source);
    if (matchData.length == 1 && matchData[0][2]) return (0, $169abaf1e01dd4d2$export$2e2bcd8739ae039)(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || (0, $d96bfe40f29ac9fd$export$2e2bcd8739ae039)(object, source, matchData);
    };
}
var $679818435cf99fe1$export$2e2bcd8739ae039 = $679818435cf99fe1$var$baseMatches;






/** Used to match property names within property paths. */ var $be9cadea54f88289$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $be9cadea54f88289$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $be9cadea54f88289$var$isKey(value, object) {
    if ((0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value;
    if (type == "number" || type == "symbol" || type == "boolean" || value == null || (0, $262b15375f25f63b$export$2e2bcd8739ae039)(value)) return true;
    return $be9cadea54f88289$var$reIsPlainProp.test(value) || !$be9cadea54f88289$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $be9cadea54f88289$export$2e2bcd8739ae039 = $be9cadea54f88289$var$isKey;



/** Error message constants. */ var $c6fa7f869dc14cc6$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $c6fa7f869dc14cc6$var$memoize(func, resolver) {
    if (typeof func != "function" || resolver != null && typeof resolver != "function") throw new TypeError($c6fa7f869dc14cc6$var$FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($c6fa7f869dc14cc6$var$memoize.Cache || (0, $cd0c97854034ec9e$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$c6fa7f869dc14cc6$var$memoize.Cache = (0, $cd0c97854034ec9e$export$2e2bcd8739ae039);
var $c6fa7f869dc14cc6$export$2e2bcd8739ae039 = $c6fa7f869dc14cc6$var$memoize;


/** Used as the maximum memoize cache size. */ var $15ca2085492a1a20$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $15ca2085492a1a20$var$memoizeCapped(func) {
    var result = (0, $c6fa7f869dc14cc6$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $15ca2085492a1a20$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $15ca2085492a1a20$export$2e2bcd8739ae039 = $15ca2085492a1a20$var$memoizeCapped;


/** Used to match property names within property paths. */ var $fdf8155af0c22f31$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $fdf8155af0c22f31$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $fdf8155af0c22f31$var$stringToPath = (0, $15ca2085492a1a20$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push("");
    string.replace($fdf8155af0c22f31$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($fdf8155af0c22f31$var$reEscapeChar, "$1") : number || match);
    });
    return result;
});
var $fdf8155af0c22f31$export$2e2bcd8739ae039 = $fdf8155af0c22f31$var$stringToPath;






/** Used as references for various `Number` constants. */ var $ff01b096573b9287$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ff01b096573b9287$var$symbolProto = (0, $375e3a674890bf85$export$2e2bcd8739ae039) ? (0, $375e3a674890bf85$export$2e2bcd8739ae039).prototype : undefined, $ff01b096573b9287$var$symbolToString = $ff01b096573b9287$var$symbolProto ? $ff01b096573b9287$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ff01b096573b9287$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == "string") return value;
    if ((0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $9100fe639d2e18f7$export$2e2bcd8739ae039)(value, $ff01b096573b9287$var$baseToString) + "";
    if ((0, $262b15375f25f63b$export$2e2bcd8739ae039)(value)) return $ff01b096573b9287$var$symbolToString ? $ff01b096573b9287$var$symbolToString.call(value) : "";
    var result = value + "";
    return result == "0" && 1 / value == -$ff01b096573b9287$var$INFINITY ? "-0" : result;
}
var $ff01b096573b9287$export$2e2bcd8739ae039 = $ff01b096573b9287$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $5f6f16d7c2090c5e$var$toString(value) {
    return value == null ? "" : (0, $ff01b096573b9287$export$2e2bcd8739ae039)(value);
}
var $5f6f16d7c2090c5e$export$2e2bcd8739ae039 = $5f6f16d7c2090c5e$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $4d14b202ccf00ad6$var$castPath(value, object) {
    if ((0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(value)) return value;
    return (0, $be9cadea54f88289$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $fdf8155af0c22f31$export$2e2bcd8739ae039)((0, $5f6f16d7c2090c5e$export$2e2bcd8739ae039)(value));
}
var $4d14b202ccf00ad6$export$2e2bcd8739ae039 = $4d14b202ccf00ad6$var$castPath;



/** Used as references for various `Number` constants. */ var $be945af50967c2b7$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $be945af50967c2b7$var$toKey(value) {
    if (typeof value == "string" || (0, $262b15375f25f63b$export$2e2bcd8739ae039)(value)) return value;
    var result = value + "";
    return result == "0" && 1 / value == -$be945af50967c2b7$var$INFINITY ? "-0" : result;
}
var $be945af50967c2b7$export$2e2bcd8739ae039 = $be945af50967c2b7$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $096f7294fec4beb8$var$baseGet(object, path) {
    path = (0, $4d14b202ccf00ad6$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $be945af50967c2b7$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $096f7294fec4beb8$export$2e2bcd8739ae039 = $096f7294fec4beb8$var$baseGet;


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function $ef75f7526c0e9e3e$var$get(object, path, defaultValue) {
    var result = object == null ? undefined : (0, $096f7294fec4beb8$export$2e2bcd8739ae039)(object, path);
    return result === undefined ? defaultValue : result;
}
var $ef75f7526c0e9e3e$export$2e2bcd8739ae039 = $ef75f7526c0e9e3e$var$get;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $e1495fd973c37029$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $e1495fd973c37029$export$2e2bcd8739ae039 = $e1495fd973c37029$var$baseHasIn;








/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $494f1c05ebd8f51f$var$hasPath(object, path, hasFunc) {
    path = (0, $4d14b202ccf00ad6$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $be945af50967c2b7$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $ac894660e80824cc$export$2e2bcd8739ae039)(length) && (0, $90b404c092fda5b3$export$2e2bcd8739ae039)(key, length) && ((0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(object) || (0, $aa9c2f54dd7338fc$export$2e2bcd8739ae039)(object));
}
var $494f1c05ebd8f51f$export$2e2bcd8739ae039 = $494f1c05ebd8f51f$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $16919cf6c5f4c4e3$var$hasIn(object, path) {
    return object != null && (0, $494f1c05ebd8f51f$export$2e2bcd8739ae039)(object, path, (0, $e1495fd973c37029$export$2e2bcd8739ae039));
}
var $16919cf6c5f4c4e3$export$2e2bcd8739ae039 = $16919cf6c5f4c4e3$var$hasIn;






/** Used to compose bitmasks for value comparisons. */ var $8f7aecb8aa3c7707$var$COMPARE_PARTIAL_FLAG = 1, $8f7aecb8aa3c7707$var$COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function $8f7aecb8aa3c7707$var$baseMatchesProperty(path, srcValue) {
    if ((0, $be9cadea54f88289$export$2e2bcd8739ae039)(path) && (0, $34519205acfc9464$export$2e2bcd8739ae039)(srcValue)) return (0, $169abaf1e01dd4d2$export$2e2bcd8739ae039)((0, $be945af50967c2b7$export$2e2bcd8739ae039)(path), srcValue);
    return function(object) {
        var objValue = (0, $ef75f7526c0e9e3e$export$2e2bcd8739ae039)(object, path);
        return objValue === undefined && objValue === srcValue ? (0, $16919cf6c5f4c4e3$export$2e2bcd8739ae039)(object, path) : (0, $0b6752f8f5e972ac$export$2e2bcd8739ae039)(srcValue, objValue, $8f7aecb8aa3c7707$var$COMPARE_PARTIAL_FLAG | $8f7aecb8aa3c7707$var$COMPARE_UNORDERED_FLAG);
    };
}
var $8f7aecb8aa3c7707$export$2e2bcd8739ae039 = $8f7aecb8aa3c7707$var$baseMatchesProperty;




/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $79d4abc9153a1ab6$var$baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
var $79d4abc9153a1ab6$export$2e2bcd8739ae039 = $79d4abc9153a1ab6$var$baseProperty;



/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function $635f625c92d6c8c0$var$basePropertyDeep(path) {
    return function(object) {
        return (0, $096f7294fec4beb8$export$2e2bcd8739ae039)(object, path);
    };
}
var $635f625c92d6c8c0$export$2e2bcd8739ae039 = $635f625c92d6c8c0$var$basePropertyDeep;




/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function $6175dcfd6999bfec$var$property(path) {
    return (0, $be9cadea54f88289$export$2e2bcd8739ae039)(path) ? (0, $79d4abc9153a1ab6$export$2e2bcd8739ae039)((0, $be945af50967c2b7$export$2e2bcd8739ae039)(path)) : (0, $635f625c92d6c8c0$export$2e2bcd8739ae039)(path);
}
var $6175dcfd6999bfec$export$2e2bcd8739ae039 = $6175dcfd6999bfec$var$property;


/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function $3b8d647d9d684ce3$var$baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == "function") return value;
    if (value == null) return 0, $b62024aa87ab11b8$export$2e2bcd8739ae039;
    if (typeof value == "object") return (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(value) ? (0, $8f7aecb8aa3c7707$export$2e2bcd8739ae039)(value[0], value[1]) : (0, $679818435cf99fe1$export$2e2bcd8739ae039)(value);
    return (0, $6175dcfd6999bfec$export$2e2bcd8739ae039)(value);
}
var $3b8d647d9d684ce3$export$2e2bcd8739ae039 = $3b8d647d9d684ce3$var$baseIteratee;




/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $7b469c21362cbe87$var$baseMap(collection, iteratee) {
    var index = -1, result = (0, $80abbb6b81d2d530$export$2e2bcd8739ae039)(collection) ? Array(collection.length) : [];
    (0, $ab655d0bc64138b1$export$2e2bcd8739ae039)(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
    });
    return result;
}
var $7b469c21362cbe87$export$2e2bcd8739ae039 = $7b469c21362cbe87$var$baseMap;



/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $52f6959b28f2c094$var$map(collection, iteratee) {
    var func = (0, $7b594f54c7511fe7$export$2e2bcd8739ae039)(collection) ? (0, $9100fe639d2e18f7$export$2e2bcd8739ae039) : (0, $7b469c21362cbe87$export$2e2bcd8739ae039);
    return func(collection, (0, $3b8d647d9d684ce3$export$2e2bcd8739ae039)(iteratee, 3));
}
var $52f6959b28f2c094$export$2e2bcd8739ae039 = $52f6959b28f2c094$var$map;



var $7482561100a2da34$export$2ce88c5250e54734 = function BlockSwatches(_ref) {
    var colors = _ref.colors, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatches: {
                marginRight: "-10px"
            },
            swatch: {
                width: "22px",
                height: "22px",
                float: "left",
                marginRight: "10px",
                marginBottom: "10px",
                borderRadius: "4px"
            },
            clear: {
                clear: "both"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatches
    }, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            style: styles.swatch,
            onClick: onClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.clear
    }));
};
var $7482561100a2da34$export$2e2bcd8739ae039 = $7482561100a2da34$export$2ce88c5250e54734;


var $c4ef2a097c591b7e$export$d96a8827a60d6b69 = function Block(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var transparent = hex === "transparent";
    var handleChange = function handleChange(hexCode, e) {
        $ef913fe6710c7df5$export$944f75ec5697b362(hexCode) && onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                boxShadow: "0 1px rgba(0,0,0,.1)",
                borderRadius: "6px",
                position: "relative"
            },
            head: {
                height: "110px",
                background: hex,
                borderRadius: "6px 6px 0 0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative"
            },
            body: {
                padding: "10px"
            },
            label: {
                fontSize: "18px",
                color: $ef913fe6710c7df5$export$3609eb1d7e55dec(hex),
                position: "relative"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 10px 10px 10px",
                borderColor: "transparent transparent " + hex + " transparent",
                position: "absolute",
                top: "-10px",
                left: "50%",
                marginLeft: "-10px"
            },
            input: {
                width: "100%",
                fontSize: "12px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "22px",
                boxShadow: "inset 0 0 0 1px #ddd",
                borderRadius: "4px",
                padding: "0 7px",
                boxSizing: "border-box"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.card,
        className: "block-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.head
    }, transparent && (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $49a998e72892ed67$export$2e2bcd8739ae039), {
        borderRadius: "6px 6px 0 0"
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.label
    }, hex)), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $7482561100a2da34$export$2e2bcd8739ae039), {
        colors: colors,
        onClick: handleChange,
        onSwatchHover: onSwatchHover
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input
        },
        value: hex,
        onChange: handleChange
    })));
};
$c4ef2a097c591b7e$export$d96a8827a60d6b69.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
        "top",
        "hide"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$c4ef2a097c591b7e$export$d96a8827a60d6b69.defaultProps = {
    width: 170,
    colors: [
        "#D9E3F0",
        "#F47373",
        "#697689",
        "#37D67A",
        "#2CCCE4",
        "#555555",
        "#dce775",
        "#ff8a65",
        "#ba68c8"
    ],
    triangle: "top",
    styles: {}
};
var $c4ef2a097c591b7e$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($c4ef2a097c591b7e$export$d96a8827a60d6b69);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");



var $e078af2993bfe018$export$a90204d1394caf30 = {
    "50": "#ffebee",
    "100": "#ffcdd2",
    "200": "#ef9a9a",
    "300": "#e57373",
    "400": "#ef5350",
    "500": "#f44336",
    "600": "#e53935",
    "700": "#d32f2f",
    "800": "#c62828",
    "900": "#b71c1c",
    "a100": "#ff8a80",
    "a200": "#ff5252",
    "a400": "#ff1744",
    "a700": "#d50000"
};
var $e078af2993bfe018$export$47853bc718611763 = {
    "50": "#fce4ec",
    "100": "#f8bbd0",
    "200": "#f48fb1",
    "300": "#f06292",
    "400": "#ec407a",
    "500": "#e91e63",
    "600": "#d81b60",
    "700": "#c2185b",
    "800": "#ad1457",
    "900": "#880e4f",
    "a100": "#ff80ab",
    "a200": "#ff4081",
    "a400": "#f50057",
    "a700": "#c51162"
};
var $e078af2993bfe018$export$e13cce2a2d16a9d4 = {
    "50": "#f3e5f5",
    "100": "#e1bee7",
    "200": "#ce93d8",
    "300": "#ba68c8",
    "400": "#ab47bc",
    "500": "#9c27b0",
    "600": "#8e24aa",
    "700": "#7b1fa2",
    "800": "#6a1b9a",
    "900": "#4a148c",
    "a100": "#ea80fc",
    "a200": "#e040fb",
    "a400": "#d500f9",
    "a700": "#aa00ff"
};
var $e078af2993bfe018$export$51ef95b19086af57 = {
    "50": "#ede7f6",
    "100": "#d1c4e9",
    "200": "#b39ddb",
    "300": "#9575cd",
    "400": "#7e57c2",
    "500": "#673ab7",
    "600": "#5e35b1",
    "700": "#512da8",
    "800": "#4527a0",
    "900": "#311b92",
    "a100": "#b388ff",
    "a200": "#7c4dff",
    "a400": "#651fff",
    "a700": "#6200ea"
};
var $e078af2993bfe018$export$3e6ccc7b8562d453 = {
    "50": "#e8eaf6",
    "100": "#c5cae9",
    "200": "#9fa8da",
    "300": "#7986cb",
    "400": "#5c6bc0",
    "500": "#3f51b5",
    "600": "#3949ab",
    "700": "#303f9f",
    "800": "#283593",
    "900": "#1a237e",
    "a100": "#8c9eff",
    "a200": "#536dfe",
    "a400": "#3d5afe",
    "a700": "#304ffe"
};
var $e078af2993bfe018$export$2aa0182783e7e9de = {
    "50": "#e3f2fd",
    "100": "#bbdefb",
    "200": "#90caf9",
    "300": "#64b5f6",
    "400": "#42a5f5",
    "500": "#2196f3",
    "600": "#1e88e5",
    "700": "#1976d2",
    "800": "#1565c0",
    "900": "#0d47a1",
    "a100": "#82b1ff",
    "a200": "#448aff",
    "a400": "#2979ff",
    "a700": "#2962ff"
};
var $e078af2993bfe018$export$7b0d29b70b435c21 = {
    "50": "#e1f5fe",
    "100": "#b3e5fc",
    "200": "#81d4fa",
    "300": "#4fc3f7",
    "400": "#29b6f6",
    "500": "#03a9f4",
    "600": "#039be5",
    "700": "#0288d1",
    "800": "#0277bd",
    "900": "#01579b",
    "a100": "#80d8ff",
    "a200": "#40c4ff",
    "a400": "#00b0ff",
    "a700": "#0091ea"
};
var $e078af2993bfe018$export$7474046f446842ee = {
    "50": "#e0f7fa",
    "100": "#b2ebf2",
    "200": "#80deea",
    "300": "#4dd0e1",
    "400": "#26c6da",
    "500": "#00bcd4",
    "600": "#00acc1",
    "700": "#0097a7",
    "800": "#00838f",
    "900": "#006064",
    "a100": "#84ffff",
    "a200": "#18ffff",
    "a400": "#00e5ff",
    "a700": "#00b8d4"
};
var $e078af2993bfe018$export$8bf7dff220b82b4a = {
    "50": "#e0f2f1",
    "100": "#b2dfdb",
    "200": "#80cbc4",
    "300": "#4db6ac",
    "400": "#26a69a",
    "500": "#009688",
    "600": "#00897b",
    "700": "#00796b",
    "800": "#00695c",
    "900": "#004d40",
    "a100": "#a7ffeb",
    "a200": "#64ffda",
    "a400": "#1de9b6",
    "a700": "#00bfa5"
};
var $e078af2993bfe018$export$955a2ebd2fb142ae = {
    "50": "#e8f5e9",
    "100": "#c8e6c9",
    "200": "#a5d6a7",
    "300": "#81c784",
    "400": "#66bb6a",
    "500": "#4caf50",
    "600": "#43a047",
    "700": "#388e3c",
    "800": "#2e7d32",
    "900": "#1b5e20",
    "a100": "#b9f6ca",
    "a200": "#69f0ae",
    "a400": "#00e676",
    "a700": "#00c853"
};
var $e078af2993bfe018$export$559a8c00376dc936 = {
    "50": "#f1f8e9",
    "100": "#dcedc8",
    "200": "#c5e1a5",
    "300": "#aed581",
    "400": "#9ccc65",
    "500": "#8bc34a",
    "600": "#7cb342",
    "700": "#689f38",
    "800": "#558b2f",
    "900": "#33691e",
    "a100": "#ccff90",
    "a200": "#b2ff59",
    "a400": "#76ff03",
    "a700": "#64dd17"
};
var $e078af2993bfe018$export$221d31baf2636aad = {
    "50": "#f9fbe7",
    "100": "#f0f4c3",
    "200": "#e6ee9c",
    "300": "#dce775",
    "400": "#d4e157",
    "500": "#cddc39",
    "600": "#c0ca33",
    "700": "#afb42b",
    "800": "#9e9d24",
    "900": "#827717",
    "a100": "#f4ff81",
    "a200": "#eeff41",
    "a400": "#c6ff00",
    "a700": "#aeea00"
};
var $e078af2993bfe018$export$594c5a8758200c32 = {
    "50": "#fffde7",
    "100": "#fff9c4",
    "200": "#fff59d",
    "300": "#fff176",
    "400": "#ffee58",
    "500": "#ffeb3b",
    "600": "#fdd835",
    "700": "#fbc02d",
    "800": "#f9a825",
    "900": "#f57f17",
    "a100": "#ffff8d",
    "a200": "#ffff00",
    "a400": "#ffea00",
    "a700": "#ffd600"
};
var $e078af2993bfe018$export$7c1ecc66643fdbd6 = {
    "50": "#fff8e1",
    "100": "#ffecb3",
    "200": "#ffe082",
    "300": "#ffd54f",
    "400": "#ffca28",
    "500": "#ffc107",
    "600": "#ffb300",
    "700": "#ffa000",
    "800": "#ff8f00",
    "900": "#ff6f00",
    "a100": "#ffe57f",
    "a200": "#ffd740",
    "a400": "#ffc400",
    "a700": "#ffab00"
};
var $e078af2993bfe018$export$ad766f34ace1cafd = {
    "50": "#fff3e0",
    "100": "#ffe0b2",
    "200": "#ffcc80",
    "300": "#ffb74d",
    "400": "#ffa726",
    "500": "#ff9800",
    "600": "#fb8c00",
    "700": "#f57c00",
    "800": "#ef6c00",
    "900": "#e65100",
    "a100": "#ffd180",
    "a200": "#ffab40",
    "a400": "#ff9100",
    "a700": "#ff6d00"
};
var $e078af2993bfe018$export$1ceed3dd9ec11704 = {
    "50": "#fbe9e7",
    "100": "#ffccbc",
    "200": "#ffab91",
    "300": "#ff8a65",
    "400": "#ff7043",
    "500": "#ff5722",
    "600": "#f4511e",
    "700": "#e64a19",
    "800": "#d84315",
    "900": "#bf360c",
    "a100": "#ff9e80",
    "a200": "#ff6e40",
    "a400": "#ff3d00",
    "a700": "#dd2c00"
};
var $e078af2993bfe018$export$b6e6178d3f565007 = {
    "50": "#efebe9",
    "100": "#d7ccc8",
    "200": "#bcaaa4",
    "300": "#a1887f",
    "400": "#8d6e63",
    "500": "#795548",
    "600": "#6d4c41",
    "700": "#5d4037",
    "800": "#4e342e",
    "900": "#3e2723"
};
var $e078af2993bfe018$export$e4c89085febbc618 = {
    "50": "#fafafa",
    "100": "#f5f5f5",
    "200": "#eeeeee",
    "300": "#e0e0e0",
    "400": "#bdbdbd",
    "500": "#9e9e9e",
    "600": "#757575",
    "700": "#616161",
    "800": "#424242",
    "900": "#212121"
};
var $e078af2993bfe018$export$7c2da42d08c019c9 = {
    "50": "#eceff1",
    "100": "#cfd8dc",
    "200": "#b0bec5",
    "300": "#90a4ae",
    "400": "#78909c",
    "500": "#607d8b",
    "600": "#546e7a",
    "700": "#455a64",
    "800": "#37474f",
    "900": "#263238"
};
var $e078af2993bfe018$export$b413907788b50267 = {
    "primary": "rgba(0, 0, 0, 0.87)",
    "secondary": "rgba(0, 0, 0, 0.54)",
    "disabled": "rgba(0, 0, 0, 0.38)",
    "dividers": "rgba(0, 0, 0, 0.12)"
};
var $e078af2993bfe018$export$c962f8177a273028 = {
    "primary": "rgba(255, 255, 255, 1)",
    "secondary": "rgba(255, 255, 255, 0.7)",
    "disabled": "rgba(255, 255, 255, 0.5)",
    "dividers": "rgba(255, 255, 255, 0.12)"
};
var $e078af2993bfe018$export$969f6c634341b5cf = {
    "active": "rgba(0, 0, 0, 0.54)",
    "inactive": "rgba(0, 0, 0, 0.38)"
};
var $e078af2993bfe018$export$6b4a43519c60f4b1 = {
    "active": "rgba(255, 255, 255, 1)",
    "inactive": "rgba(255, 255, 255, 0.5)"
};
var $e078af2993bfe018$export$8fa4e5556fd77a60 = "#ffffff";
var $e078af2993bfe018$export$c073df10e766abfa = "#000000";
var $e078af2993bfe018$export$2e2bcd8739ae039 = {
    red: $e078af2993bfe018$export$a90204d1394caf30,
    pink: $e078af2993bfe018$export$47853bc718611763,
    purple: $e078af2993bfe018$export$e13cce2a2d16a9d4,
    deepPurple: $e078af2993bfe018$export$51ef95b19086af57,
    indigo: $e078af2993bfe018$export$3e6ccc7b8562d453,
    blue: $e078af2993bfe018$export$2aa0182783e7e9de,
    lightBlue: $e078af2993bfe018$export$7b0d29b70b435c21,
    cyan: $e078af2993bfe018$export$7474046f446842ee,
    teal: $e078af2993bfe018$export$8bf7dff220b82b4a,
    green: $e078af2993bfe018$export$955a2ebd2fb142ae,
    lightGreen: $e078af2993bfe018$export$559a8c00376dc936,
    lime: $e078af2993bfe018$export$221d31baf2636aad,
    yellow: $e078af2993bfe018$export$594c5a8758200c32,
    amber: $e078af2993bfe018$export$7c1ecc66643fdbd6,
    orange: $e078af2993bfe018$export$ad766f34ace1cafd,
    deepOrange: $e078af2993bfe018$export$1ceed3dd9ec11704,
    brown: $e078af2993bfe018$export$b6e6178d3f565007,
    grey: $e078af2993bfe018$export$e4c89085febbc618,
    blueGrey: $e078af2993bfe018$export$7c2da42d08c019c9,
    darkText: $e078af2993bfe018$export$b413907788b50267,
    lightText: $e078af2993bfe018$export$c962f8177a273028,
    darkIcons: $e078af2993bfe018$export$969f6c634341b5cf,
    lightIcons: $e078af2993bfe018$export$6b4a43519c60f4b1,
    white: $e078af2993bfe018$export$8fa4e5556fd77a60,
    black: $e078af2993bfe018$export$c073df10e766abfa
};




var $eCoWV = parcelRequire("eCoWV");


var $69098fd3c31ad028$export$945d5c8ebb42b0ff = function CircleSwatch(_ref) {
    var color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, hover = _ref.hover, active = _ref.active, circleSize = _ref.circleSize, circleSpacing = _ref.circleSpacing;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatch: {
                width: circleSize,
                height: circleSize,
                marginRight: circleSpacing,
                marginBottom: circleSpacing,
                transform: "scale(1)",
                transition: "100ms transform ease"
            },
            Swatch: {
                borderRadius: "50%",
                background: "transparent",
                boxShadow: "inset 0 0 0 " + (circleSize / 2 + 1) + "px " + color,
                transition: "100ms box-shadow ease"
            }
        },
        "hover": {
            swatch: {
                transform: "scale(1.2)"
            }
        },
        "active": {
            Swatch: {
                boxShadow: "inset 0 0 0 3px " + color
            }
        }
    }, {
        hover: hover,
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
        style: styles.Swatch,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: styles.Swatch.boxShadow + ", 0 0 5px " + color
        }
    }));
};
$69098fd3c31ad028$export$945d5c8ebb42b0ff.defaultProps = {
    circleSize: 28,
    circleSpacing: 14
};
var $69098fd3c31ad028$export$2e2bcd8739ae039 = (0, $30b13a56cd0faccc$exports.handleHover)($69098fd3c31ad028$export$945d5c8ebb42b0ff);


var $9ac2eaa01ca9645d$export$c89a927ffc67e6fa = function Circle(_ref) {
    var width = _ref.width, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, circleSize = _ref.circleSize, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, circleSpacing = _ref.circleSpacing, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                display: "flex",
                flexWrap: "wrap",
                marginRight: -circleSpacing,
                marginBottom: -circleSpacing
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(hexCode, e) {
        return onChange({
            hex: hexCode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.card,
        className: "circle-picker " + className
    }, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $69098fd3c31ad028$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover,
            active: hex === c.toLowerCase(),
            circleSize: circleSize,
            circleSpacing: circleSpacing
        });
    }));
};
$9ac2eaa01ca9645d$export$c89a927ffc67e6fa.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    circleSize: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    circleSpacing: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$9ac2eaa01ca9645d$export$c89a927ffc67e6fa.defaultProps = {
    width: 252,
    circleSize: 28,
    circleSpacing: 14,
    colors: [
        $e078af2993bfe018$export$a90204d1394caf30["500"],
        $e078af2993bfe018$export$47853bc718611763["500"],
        $e078af2993bfe018$export$e13cce2a2d16a9d4["500"],
        $e078af2993bfe018$export$51ef95b19086af57["500"],
        $e078af2993bfe018$export$3e6ccc7b8562d453["500"],
        $e078af2993bfe018$export$2aa0182783e7e9de["500"],
        $e078af2993bfe018$export$7b0d29b70b435c21["500"],
        $e078af2993bfe018$export$7474046f446842ee["500"],
        $e078af2993bfe018$export$8bf7dff220b82b4a["500"],
        $e078af2993bfe018$export$955a2ebd2fb142ae["500"],
        $e078af2993bfe018$export$559a8c00376dc936["500"],
        $e078af2993bfe018$export$221d31baf2636aad["500"],
        $e078af2993bfe018$export$594c5a8758200c32["500"],
        $e078af2993bfe018$export$7c1ecc66643fdbd6["500"],
        $e078af2993bfe018$export$ad766f34ace1cafd["500"],
        $e078af2993bfe018$export$1ceed3dd9ec11704["500"],
        $e078af2993bfe018$export$b6e6178d3f565007["500"],
        $e078af2993bfe018$export$7c2da42d08c019c9["500"]
    ],
    styles: {}
};
var $9ac2eaa01ca9645d$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($9ac2eaa01ca9645d$export$c89a927ffc67e6fa);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");




var $eCoWV = parcelRequire("eCoWV");


/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 * @example
 *
 * _.isUndefined(void 0);
 * // => true
 *
 * _.isUndefined(null);
 * // => false
 */ function $9e8b7c1a47d7d54a$var$isUndefined(value) {
    return value === undefined;
}
var $9e8b7c1a47d7d54a$export$2e2bcd8739ae039 = $9e8b7c1a47d7d54a$var$isUndefined;



var $47d8449b87af3ff9$exports = {};
"use strict";
Object.defineProperty($47d8449b87af3ff9$exports, "__esModule", {
    value: true
});
var $47d8449b87af3ff9$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eCoWV = parcelRequire("eCoWV");
var $47d8449b87af3ff9$var$_react2 = $47d8449b87af3ff9$var$_interopRequireDefault($eCoWV);
function $47d8449b87af3ff9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $47d8449b87af3ff9$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $47d8449b87af3ff9$var$DEFAULT_SIZE = 24;
$47d8449b87af3ff9$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $47d8449b87af3ff9$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $47d8449b87af3ff9$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $47d8449b87af3ff9$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $47d8449b87af3ff9$var$_react2.default.createElement("svg", $47d8449b87af3ff9$var$_extends({
        viewBox: "0 0 " + $47d8449b87af3ff9$var$DEFAULT_SIZE + " " + $47d8449b87af3ff9$var$DEFAULT_SIZE,
        style: $47d8449b87af3ff9$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $47d8449b87af3ff9$var$_react2.default.createElement("path", {
        d: "M12,18.17L8.83,15L7.42,16.41L12,21L16.59,16.41L15.17,15M12,5.83L15.17,9L16.58,7.59L12,3L7.41,7.59L8.83,9L12,5.83Z"
    }));
};


var $0a64b1fffcd23b7a$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $0a64b1fffcd23b7a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $0a64b1fffcd23b7a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $0a64b1fffcd23b7a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $0a64b1fffcd23b7a$export$71685d48a2432635 = function(_React$Component) {
    $0a64b1fffcd23b7a$var$_inherits(ChromeFields, _React$Component);
    function ChromeFields(props) {
        $0a64b1fffcd23b7a$var$_classCallCheck(this, ChromeFields);
        var _this = $0a64b1fffcd23b7a$var$_possibleConstructorReturn(this, (ChromeFields.__proto__ || Object.getPrototypeOf(ChromeFields)).call(this));
        _this.toggleViews = function() {
            if (_this.state.view === "hex") _this.setState({
                view: "rgb"
            });
            else if (_this.state.view === "rgb") _this.setState({
                view: "hsl"
            });
            else if (_this.state.view === "hsl") {
                if (_this.props.hsl.a === 1) _this.setState({
                    view: "hex"
                });
                else _this.setState({
                    view: "rgb"
                });
            }
        };
        _this.handleChange = function(data, e) {
            if (data.hex) $ef913fe6710c7df5$export$944f75ec5697b362(data.hex) && _this.props.onChange({
                hex: data.hex,
                source: "hex"
            }, e);
            else if (data.r || data.g || data.b) _this.props.onChange({
                r: data.r || _this.props.rgb.r,
                g: data.g || _this.props.rgb.g,
                b: data.b || _this.props.rgb.b,
                source: "rgb"
            }, e);
            else if (data.a) {
                if (data.a < 0) data.a = 0;
                else if (data.a > 1) data.a = 1;
                _this.props.onChange({
                    h: _this.props.hsl.h,
                    s: _this.props.hsl.s,
                    l: _this.props.hsl.l,
                    a: Math.round(data.a * 100) / 100,
                    source: "rgb"
                }, e);
            } else if (data.h || data.s || data.l) {
                // Remove any occurances of '%'.
                if (typeof data.s === "string" && data.s.includes("%")) data.s = data.s.replace("%", "");
                if (typeof data.l === "string" && data.l.includes("%")) data.l = data.l.replace("%", "");
                // We store HSL as a unit interval so we need to override the 1 input to 0.01
                if (data.s == 1) data.s = 0.01;
                else if (data.l == 1) data.l = 0.01;
                _this.props.onChange({
                    h: data.h || _this.props.hsl.h,
                    s: Number(!(0, $9e8b7c1a47d7d54a$export$2e2bcd8739ae039)(data.s) ? data.s : _this.props.hsl.s),
                    l: Number(!(0, $9e8b7c1a47d7d54a$export$2e2bcd8739ae039)(data.l) ? data.l : _this.props.hsl.l),
                    source: "hsl"
                }, e);
            }
        };
        _this.showHighlight = function(e) {
            e.currentTarget.style.background = "#eee";
        };
        _this.hideHighlight = function(e) {
            e.currentTarget.style.background = "transparent";
        };
        if (props.hsl.a !== 1 && props.view === "hex") _this.state = {
            view: "rgb"
        };
        else _this.state = {
            view: props.view
        };
        return _this;
    }
    $0a64b1fffcd23b7a$var$_createClass(ChromeFields, [
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
                    "default": {
                        wrap: {
                            paddingTop: "16px",
                            display: "flex"
                        },
                        fields: {
                            flex: "1",
                            display: "flex",
                            marginLeft: "-6px"
                        },
                        field: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        alpha: {
                            paddingLeft: "6px",
                            width: "100%"
                        },
                        toggle: {
                            width: "32px",
                            textAlign: "right",
                            position: "relative"
                        },
                        icon: {
                            marginRight: "-4px",
                            marginTop: "12px",
                            cursor: "pointer",
                            position: "relative"
                        },
                        iconHighlight: {
                            position: "absolute",
                            width: "24px",
                            height: "28px",
                            background: "#eee",
                            borderRadius: "4px",
                            top: "10px",
                            left: "12px",
                            display: "none"
                        },
                        input: {
                            fontSize: "11px",
                            color: "#333",
                            width: "100%",
                            borderRadius: "2px",
                            border: "none",
                            boxShadow: "inset 0 0 0 1px #dadada",
                            height: "21px",
                            textAlign: "center"
                        },
                        label: {
                            textTransform: "uppercase",
                            fontSize: "11px",
                            lineHeight: "11px",
                            color: "#969696",
                            textAlign: "center",
                            display: "block",
                            marginTop: "12px"
                        },
                        svg: {
                            fill: "#333",
                            width: "24px",
                            height: "24px",
                            border: "1px transparent solid",
                            borderRadius: "5px"
                        }
                    },
                    "disableAlpha": {
                        alpha: {
                            display: "none"
                        }
                    }
                }, this.props, this.state);
                var fields = void 0;
                if (this.state.view === "hex") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "hex",
                    value: this.props.hex,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "rgb") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "r",
                    value: this.props.rgb.r,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "g",
                    value: this.props.rgb.g,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "b",
                    value: this.props.rgb.b,
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.rgb.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                else if (this.state.view === "hsl") fields = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.fields,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "h",
                    value: Math.round(this.props.hsl.h),
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "s",
                    value: Math.round(this.props.hsl.s * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.field
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "l",
                    value: Math.round(this.props.hsl.l * 100) + "%",
                    onChange: this.handleChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.alpha
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
                    style: {
                        input: styles.input,
                        label: styles.label
                    },
                    label: "a",
                    value: this.props.hsl.a,
                    arrowOffset: 0.01,
                    onChange: this.handleChange
                })));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.wrap,
                    className: "flexbox-fix"
                }, fields, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.toggle
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.icon,
                    onClick: this.toggleViews,
                    ref: function ref(icon) {
                        return _this2.icon = icon;
                    }
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($47d8449b87af3ff9$exports))), {
                    style: styles.svg,
                    onMouseOver: this.showHighlight,
                    onMouseEnter: this.showHighlight,
                    onMouseOut: this.hideHighlight
                }))));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, state) {
                if (nextProps.hsl.a !== 1 && state.view === "hex") return {
                    view: "rgb"
                };
                return null;
            }
        }
    ]);
    return ChromeFields;
}((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Component);
$0a64b1fffcd23b7a$export$71685d48a2432635.defaultProps = {
    view: "hex"
};
var $0a64b1fffcd23b7a$export$2e2bcd8739ae039 = $0a64b1fffcd23b7a$export$71685d48a2432635;



var $eCoWV = parcelRequire("eCoWV");

var $a776c95dbe62847d$export$a632586f9a957100 = function ChromePointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                transform: "translate(-6px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $a776c95dbe62847d$export$2e2bcd8739ae039 = $a776c95dbe62847d$export$a632586f9a957100;



var $eCoWV = parcelRequire("eCoWV");

var $22ad1bf9dec0c827$export$190c1afe887f7ef7 = function ChromePointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $22ad1bf9dec0c827$export$2e2bcd8739ae039 = $22ad1bf9dec0c827$export$190c1afe887f7ef7;


var $add8139f08dae22a$export$31a305e9779b48b4 = function Chrome(_ref) {
    var width = _ref.width, onChange = _ref.onChange, disableAlpha = _ref.disableAlpha, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className, defaultView = _ref.defaultView;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                borderRadius: "2px",
                boxShadow: "0 0 2px rgba(0,0,0,.3), 0 4px 8px rgba(0,0,0,.3)",
                boxSizing: "initial",
                fontFamily: "Menlo"
            },
            saturation: {
                width: "100%",
                paddingBottom: "55%",
                position: "relative",
                borderRadius: "2px 2px 0 0",
                overflow: "hidden"
            },
            Saturation: {
                radius: "2px 2px 0 0"
            },
            body: {
                padding: "16px 16px 12px"
            },
            controls: {
                display: "flex"
            },
            color: {
                width: "32px"
            },
            swatch: {
                marginTop: "6px",
                width: "16px",
                height: "16px",
                borderRadius: "8px",
                position: "relative",
                overflow: "hidden"
            },
            active: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "8px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.1)",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", " + rgb.a + ")",
                zIndex: "2"
            },
            toggles: {
                flex: "1"
            },
            hue: {
                height: "10px",
                position: "relative",
                marginBottom: "8px"
            },
            Hue: {
                radius: "2px"
            },
            alpha: {
                height: "10px",
                position: "relative"
            },
            Alpha: {
                radius: "2px"
            }
        },
        "disableAlpha": {
            color: {
                width: "22px"
            },
            alpha: {
                display: "none"
            },
            hue: {
                marginBottom: "0px"
            },
            swatch: {
                width: "10px",
                height: "10px",
                marginTop: "0px"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "chrome-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $4c4c816213e4c82f$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $22ad1bf9dec0c827$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $49a998e72892ed67$export$2e2bcd8739ae039), {
        renderers: renderers
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.toggles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: (0, $a776c95dbe62847d$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $cf5fa3fd43734c4f$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        pointer: (0, $a776c95dbe62847d$export$2e2bcd8739ae039),
        renderers: renderers,
        onChange: onChange
    })))), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $0a64b1fffcd23b7a$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        view: defaultView,
        onChange: onChange,
        disableAlpha: disableAlpha
    })));
};
$add8139f08dae22a$export$31a305e9779b48b4.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    defaultView: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
        "hex",
        "rgb",
        "hsl"
    ])
};
$add8139f08dae22a$export$31a305e9779b48b4.defaultProps = {
    width: 225,
    disableAlpha: false,
    styles: {}
};
var $add8139f08dae22a$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($add8139f08dae22a$export$31a305e9779b48b4);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");






var $eCoWV = parcelRequire("eCoWV");



var $d772b9289e6b1654$export$df654652e5203306 = function CompactColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            color: {
                background: color,
                width: "15px",
                height: "15px",
                float: "left",
                marginRight: "5px",
                marginBottom: "5px",
                position: "relative",
                cursor: "pointer"
            },
            dot: {
                absolute: "5px 5px 5px 5px",
                background: $ef913fe6710c7df5$export$3609eb1d7e55dec(color),
                borderRadius: "50%",
                opacity: "0"
            }
        },
        "active": {
            dot: {
                opacity: "1"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            dot: {
                background: "#000"
            }
        },
        "transparent": {
            dot: {
                background: "#000"
            }
        }
    }, {
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
        style: styles.color,
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.dot
    }));
};
var $d772b9289e6b1654$export$2e2bcd8739ae039 = $d772b9289e6b1654$export$df654652e5203306;



var $eCoWV = parcelRequire("eCoWV");


var $88701668a0fe847e$export$11cdb14a03223d9c = function CompactFields(_ref) {
    var hex = _ref.hex, rgb = _ref.rgb, onChange = _ref.onChange;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingBottom: "6px",
                paddingRight: "5px",
                position: "relative"
            },
            active: {
                position: "absolute",
                top: "6px",
                left: "5px",
                height: "9px",
                width: "9px",
                background: hex
            },
            HEXwrap: {
                flex: "6",
                position: "relative"
            },
            HEXinput: {
                width: "80%",
                padding: "0px",
                paddingLeft: "20%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            HEXlabel: {
                display: "none"
            },
            RGBwrap: {
                flex: "3",
                position: "relative"
            },
            RGBinput: {
                width: "70%",
                padding: "0px",
                paddingLeft: "30%",
                border: "none",
                outline: "none",
                background: "none",
                fontSize: "12px",
                color: "#333",
                height: "16px"
            },
            RGBlabel: {
                position: "absolute",
                top: "3px",
                left: "0px",
                lineHeight: "16px",
                textTransform: "uppercase",
                fontSize: "12px",
                color: "#999"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else onChange({
            hex: data.hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.active
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }));
};
var $88701668a0fe847e$export$2e2bcd8739ae039 = $88701668a0fe847e$export$11cdb14a03223d9c;


var $58dd6d63a6e5c0c7$export$6479582a9c9e50ce = function Compact(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            Compact: {
                background: "#f6f6f6",
                radius: "4px"
            },
            compact: {
                paddingTop: "5px",
                paddingLeft: "5px",
                boxSizing: "initial",
                width: "240px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $ef913fe6710c7df5$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else onChange(data, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $0fbacba5a68a0690$export$2e2bcd8739ae039), {
        style: styles.Compact,
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.compact,
        className: "compact-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", null, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d772b9289e6b1654$export$2e2bcd8739ae039), {
            key: c,
            color: c,
            active: c.toLowerCase() === hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.clear
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $88701668a0fe847e$export$2e2bcd8739ae039), {
        hex: hex,
        rgb: rgb,
        onChange: handleChange
    })));
};
$58dd6d63a6e5c0c7$export$6479582a9c9e50ce.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$58dd6d63a6e5c0c7$export$6479582a9c9e50ce.defaultProps = {
    colors: [
        "#4D4D4D",
        "#999999",
        "#FFFFFF",
        "#F44E3B",
        "#FE9200",
        "#FCDC00",
        "#DBDF00",
        "#A4DD00",
        "#68CCCA",
        "#73D8FF",
        "#AEA1FF",
        "#FDA1FF",
        "#333333",
        "#808080",
        "#cccccc",
        "#D33115",
        "#E27300",
        "#FCC400",
        "#B0BC00",
        "#68BC00",
        "#16A5A5",
        "#009CE0",
        "#7B64FF",
        "#FA28FF",
        "#000000",
        "#666666",
        "#B3B3B3",
        "#9F0500",
        "#C45100",
        "#FB9E00",
        "#808900",
        "#194D33",
        "#0C797D",
        "#0062B1",
        "#653294",
        "#AB149E"
    ],
    styles: {}
};
var $58dd6d63a6e5c0c7$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($58dd6d63a6e5c0c7$export$6479582a9c9e50ce);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");





var $eCoWV = parcelRequire("eCoWV");


var $3025e30e9804a812$export$d653c538b92bb84f = function GithubSwatch(_ref) {
    var hover = _ref.hover, color = _ref.color, onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover;
    var hoverSwatch = {
        position: "relative",
        zIndex: "2",
        outline: "2px solid #fff",
        boxShadow: "0 0 5px 2px rgba(0,0,0,0.25)"
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatch: {
                width: "25px",
                height: "25px",
                fontSize: "0"
            }
        },
        "hover": {
            swatch: hoverSwatch
        }
    }, {
        hover: hover
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
        color: color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: hoverSwatch
    }));
};
var $3025e30e9804a812$export$2e2bcd8739ae039 = (0, $30b13a56cd0faccc$exports.handleHover)($3025e30e9804a812$export$d653c538b92bb84f);


var $7b5b7f8a8b74bdef$export$61d478c2aba5d9a5 = function Github(_ref) {
    var width = _ref.width, colors = _ref.colors, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "1px solid rgba(0,0,0,0.2)",
                boxShadow: "0 3px 12px rgba(0,0,0,0.15)",
                borderRadius: "4px",
                position: "relative",
                padding: "5px",
                display: "flex",
                flexWrap: "wrap"
            },
            triangle: {
                position: "absolute",
                border: "7px solid transparent",
                borderBottomColor: "#fff"
            },
            triangleShadow: {
                position: "absolute",
                border: "8px solid transparent",
                borderBottomColor: "rgba(0,0,0,0.15)"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-14px",
                left: "10px"
            },
            triangleShadow: {
                top: "-16px",
                left: "9px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-14px",
                right: "10px"
            },
            triangleShadow: {
                top: "-16px",
                right: "9px"
            }
        },
        "bottom-left-triangle": {
            triangle: {
                top: "35px",
                left: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                left: "9px",
                transform: "rotate(180deg)"
            }
        },
        "bottom-right-triangle": {
            triangle: {
                top: "35px",
                right: "10px",
                transform: "rotate(180deg)"
            },
            triangleShadow: {
                top: "37px",
                right: "9px",
                transform: "rotate(180deg)"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right",
        "bottom-left-triangle": triangle === "bottom-left",
        "bottom-right-triangle": triangle === "bottom-right"
    });
    var handleChange = function handleChange(hex, e) {
        return onChange({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.card,
        className: "github-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.triangle
    }), (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(c) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $3025e30e9804a812$export$2e2bcd8739ae039), {
            color: c,
            key: c,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }));
};
$7b5b7f8a8b74bdef$export$61d478c2aba5d9a5.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
        "hide",
        "top-left",
        "top-right",
        "bottom-left",
        "bottom-right"
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$7b5b7f8a8b74bdef$export$61d478c2aba5d9a5.defaultProps = {
    width: 200,
    colors: [
        "#B80000",
        "#DB3E00",
        "#FCCB00",
        "#008B02",
        "#006B76",
        "#1273DE",
        "#004DCF",
        "#5300EB",
        "#EB9694",
        "#FAD0C3",
        "#FEF3BD",
        "#C1E1C5",
        "#BEDADC",
        "#C4DEF6",
        "#BED3F3",
        "#D4C4FB"
    ],
    triangle: "top-left",
    styles: {}
};
var $7b5b7f8a8b74bdef$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($7b5b7f8a8b74bdef$export$61d478c2aba5d9a5);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");




var $eCoWV = parcelRequire("eCoWV");

var $92521cd5be7e752f$export$9c10b52c64965f67 = function SliderPointer(_ref) {
    var direction = _ref.direction;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                transform: "translate(-9px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        },
        "vertical": {
            picker: {
                transform: "translate(-3px, -9px)"
            }
        }
    }, {
        vertical: direction === "vertical"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $92521cd5be7e752f$export$2e2bcd8739ae039 = $92521cd5be7e752f$export$9c10b52c64965f67;


var $8a3d3cf1e1ae8cbd$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8a3d3cf1e1ae8cbd$export$f176087feb20230e = function HuePicker(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, hsl = _ref.hsl, direction = _ref.direction, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                position: "relative",
                width: width,
                height: height
            },
            hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    // Overwrite to provide pure hue color
    var handleChange = function handleChange(data) {
        return onChange({
            a: 1,
            h: data.h,
            l: 0.5,
            s: 1
        });
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "hue-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), $8a3d3cf1e1ae8cbd$var$_extends({}, styles.hue, {
        hsl: hsl,
        pointer: pointer,
        onChange: handleChange,
        direction: direction
    })));
};
$8a3d3cf1e1ae8cbd$export$f176087feb20230e.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$8a3d3cf1e1ae8cbd$export$f176087feb20230e.defaultProps = {
    width: "316px",
    height: "16px",
    direction: "horizontal",
    pointer: (0, $92521cd5be7e752f$export$2e2bcd8739ae039),
    styles: {}
};
var $8a3d3cf1e1ae8cbd$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($8a3d3cf1e1ae8cbd$export$f176087feb20230e);



var $eCoWV = parcelRequire("eCoWV");




var $4a84effb9576919d$export$a2d8b23205c25948 = function Material(_ref) {
    var onChange = _ref.onChange, hex = _ref.hex, rgb = _ref.rgb, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            material: {
                width: "98px",
                height: "98px",
                padding: "16px",
                fontFamily: "Roboto"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "2px solid " + hex,
                outline: "none",
                height: "30px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            Hex: {
                style: {}
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                width: "100%",
                marginTop: "12px",
                fontSize: "15px",
                color: "#333",
                padding: "0px",
                border: "0px",
                borderBottom: "1px solid #eee",
                outline: "none",
                height: "30px"
            },
            RGBlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                fontSize: "11px",
                color: "#999999",
                textTransform: "capitalize"
            },
            split: {
                display: "flex",
                marginRight: "-10px",
                paddingTop: "11px"
            },
            third: {
                flex: "1",
                paddingRight: "10px"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        if (data.hex) $ef913fe6710c7df5$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $0fbacba5a68a0690$export$2e2bcd8739ae039), {
        styles: passedStyles
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.material,
        className: "material-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.split,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.third
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    })))));
};
var $4a84effb9576919d$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($4a84effb9576919d$export$a2d8b23205c25948);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");




var $eCoWV = parcelRequire("eCoWV");



var $f68eca411d946c51$export$b1808ee9bfa8f4d0 = function PhotoshopPicker(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsv = _ref.hsv, hex = _ref.hex;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            fields: {
                paddingTop: "5px",
                paddingBottom: "9px",
                width: "80px",
                position: "relative"
            },
            divider: {
                height: "5px"
            },
            RGBwrap: {
                position: "relative"
            },
            RGBinput: {
                marginLeft: "40%",
                width: "40%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "5px",
                fontSize: "13px",
                paddingLeft: "3px",
                marginRight: "10px"
            },
            RGBlabel: {
                left: "0px",
                top: "0px",
                width: "34px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px",
                position: "absolute"
            },
            HEXwrap: {
                position: "relative"
            },
            HEXinput: {
                marginLeft: "20%",
                width: "80%",
                height: "18px",
                border: "1px solid #888888",
                boxShadow: "inset 0 1px 1px rgba(0,0,0,.1), 0 1px 0 0 #ECECEC",
                marginBottom: "6px",
                fontSize: "13px",
                paddingLeft: "3px"
            },
            HEXlabel: {
                position: "absolute",
                top: "0px",
                left: "0px",
                width: "14px",
                textTransform: "uppercase",
                fontSize: "13px",
                height: "18px",
                lineHeight: "22px"
            },
            fieldSymbols: {
                position: "absolute",
                top: "5px",
                right: "-7px",
                fontSize: "13px"
            },
            symbol: {
                height: "20px",
                lineHeight: "22px",
                paddingBottom: "7px"
            }
        }
    });
    var handleChange = function handleChange(data, e) {
        if (data["#"]) $ef913fe6710c7df5$export$944f75ec5697b362(data["#"]) && onChange({
            hex: data["#"],
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            source: "rgb"
        }, e);
        else if (data.h || data.s || data.v) onChange({
            h: data.h || hsv.h,
            s: data.s || hsv.s,
            v: data.v || hsv.v,
            source: "hsv"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "h",
        value: Math.round(hsv.h),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "s",
        value: Math.round(hsv.s * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "v",
        value: Math.round(hsv.v * 100),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.RGBwrap,
            input: styles.RGBinput,
            label: styles.RGBlabel
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.divider
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            wrap: styles.HEXwrap,
            input: styles.HEXinput,
            label: styles.HEXlabel
        },
        label: "#",
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.fieldSymbols
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.symbol
    }, "\xb0"), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.symbol
    }, "%"), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.symbol
    }, "%")));
};
var $f68eca411d946c51$export$2e2bcd8739ae039 = $f68eca411d946c51$export$b1808ee9bfa8f4d0;



var $eCoWV = parcelRequire("eCoWV");

var $eb4e6d02bbe3c127$export$123b96ff8455915 = function PhotoshopPointerCircle(_ref) {
    var hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "12px",
                height: "12px",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px #fff",
                transform: "translate(-6px, -6px)"
            }
        },
        "black-outline": {
            picker: {
                boxShadow: "inset 0 0 0 1px #000"
            }
        }
    }, {
        "black-outline": hsl.l > 0.5
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $eb4e6d02bbe3c127$export$2e2bcd8739ae039 = $eb4e6d02bbe3c127$export$123b96ff8455915;



var $eCoWV = parcelRequire("eCoWV");

var $c9bae6f0145efe13$export$123b96ff8455915 = function PhotoshopPointerCircle() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            triangle: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "4px 0 4px 6px",
                borderColor: "transparent transparent transparent #fff",
                position: "absolute",
                top: "1px",
                left: "1px"
            },
            triangleBorder: {
                width: 0,
                height: 0,
                borderStyle: "solid",
                borderWidth: "5px 0 5px 8px",
                borderColor: "transparent transparent transparent #555"
            },
            left: {
                Extend: "triangleBorder",
                transform: "translate(-13px, -4px)"
            },
            leftInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            },
            right: {
                Extend: "triangleBorder",
                transform: "translate(20px, -14px) rotate(180deg)"
            },
            rightInside: {
                Extend: "triangle",
                transform: "translate(-8px, -5px)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.pointer
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.left
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.leftInside
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.right
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.rightInside
    })));
};
var $c9bae6f0145efe13$export$2e2bcd8739ae039 = $c9bae6f0145efe13$export$123b96ff8455915;



var $eCoWV = parcelRequire("eCoWV");

var $8df3a17622fbeec0$export$f7d38a0bd3b98717 = function PhotoshopButton(_ref) {
    var onClick = _ref.onClick, label = _ref.label, children = _ref.children, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            button: {
                backgroundImage: "linear-gradient(-180deg, #FFFFFF 0%, #E6E6E6 100%)",
                border: "1px solid #878787",
                borderRadius: "2px",
                height: "20px",
                boxShadow: "0 1px 0 0 #EAEAEA",
                fontSize: "14px",
                color: "#000",
                lineHeight: "20px",
                textAlign: "center",
                marginBottom: "10px",
                cursor: "pointer"
            }
        },
        "active": {
            button: {
                boxShadow: "0 0 0 1px #878787"
            }
        }
    }, {
        active: active
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.button,
        onClick: onClick
    }, label || children);
};
var $8df3a17622fbeec0$export$2e2bcd8739ae039 = $8df3a17622fbeec0$export$f7d38a0bd3b98717;



var $eCoWV = parcelRequire("eCoWV");

var $5d06e959f9a589f6$export$ce0d7acd66f46f2b = function PhotoshopPreviews(_ref) {
    var rgb = _ref.rgb, currentColor = _ref.currentColor;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatches: {
                border: "1px solid #B3B3B3",
                borderBottom: "1px solid #F0F0F0",
                marginBottom: "2px",
                marginTop: "1px"
            },
            new: {
                height: "34px",
                background: "rgb(" + rgb.r + "," + rgb.g + ", " + rgb.b + ")",
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 1px 0 #000"
            },
            current: {
                height: "34px",
                background: currentColor,
                boxShadow: "inset 1px 0 0 #000, inset -1px 0 0 #000, inset 0 -1px 0 #000"
            },
            label: {
                fontSize: "14px",
                color: "#000",
                textAlign: "center"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", null, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.label
    }, "new"), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.new
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.current
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.label
    }, "current"));
};
var $5d06e959f9a589f6$export$2e2bcd8739ae039 = $5d06e959f9a589f6$export$ce0d7acd66f46f2b;


var $10c0d41a92c5ad86$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $10c0d41a92c5ad86$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $10c0d41a92c5ad86$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $10c0d41a92c5ad86$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $10c0d41a92c5ad86$export$4ed116dea8ad5956 = function(_React$Component) {
    $10c0d41a92c5ad86$var$_inherits(Photoshop, _React$Component);
    function Photoshop(props) {
        $10c0d41a92c5ad86$var$_classCallCheck(this, Photoshop);
        var _this = $10c0d41a92c5ad86$var$_possibleConstructorReturn(this, (Photoshop.__proto__ || Object.getPrototypeOf(Photoshop)).call(this));
        _this.state = {
            currentColor: props.hex
        };
        return _this;
    }
    $10c0d41a92c5ad86$var$_createClass(Photoshop, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, _props$styles = _props.styles, passedStyles = _props$styles === undefined ? {} : _props$styles, _props$className = _props.className, className = _props$className === undefined ? "" : _props$className;
                var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
                    "default": {
                        picker: {
                            background: "#DCDCDC",
                            borderRadius: "4px",
                            boxShadow: "0 0 0 1px rgba(0,0,0,.25), 0 8px 16px rgba(0,0,0,.15)",
                            boxSizing: "initial",
                            width: "513px"
                        },
                        head: {
                            backgroundImage: "linear-gradient(-180deg, #F0F0F0 0%, #D4D4D4 100%)",
                            borderBottom: "1px solid #B1B1B1",
                            boxShadow: "inset 0 1px 0 0 rgba(255,255,255,.2), inset 0 -1px 0 0 rgba(0,0,0,.02)",
                            height: "23px",
                            lineHeight: "24px",
                            borderRadius: "4px 4px 0 0",
                            fontSize: "13px",
                            color: "#4D4D4D",
                            textAlign: "center"
                        },
                        body: {
                            padding: "15px 15px 0",
                            display: "flex"
                        },
                        saturation: {
                            width: "256px",
                            height: "256px",
                            position: "relative",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0",
                            overflow: "hidden"
                        },
                        hue: {
                            position: "relative",
                            height: "256px",
                            width: "19px",
                            marginLeft: "10px",
                            border: "2px solid #B3B3B3",
                            borderBottom: "2px solid #F0F0F0"
                        },
                        controls: {
                            width: "180px",
                            marginLeft: "10px"
                        },
                        top: {
                            display: "flex"
                        },
                        previews: {
                            width: "60px"
                        },
                        actions: {
                            flex: "1",
                            marginLeft: "20px"
                        }
                    }
                }, passedStyles));
                return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.picker,
                    className: "photoshop-picker " + className
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.head
                }, this.props.header), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.body,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.saturation
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $4c4c816213e4c82f$export$2e2bcd8739ae039), {
                    hsl: this.props.hsl,
                    hsv: this.props.hsv,
                    pointer: (0, $eb4e6d02bbe3c127$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.hue
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), {
                    direction: "vertical",
                    hsl: this.props.hsl,
                    pointer: (0, $c9bae6f0145efe13$export$2e2bcd8739ae039),
                    onChange: this.props.onChange
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.controls
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.top,
                    className: "flexbox-fix"
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.previews
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $5d06e959f9a589f6$export$2e2bcd8739ae039), {
                    rgb: this.props.rgb,
                    currentColor: this.state.currentColor
                })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    style: styles.actions
                }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $8df3a17622fbeec0$export$2e2bcd8739ae039), {
                    label: "OK",
                    onClick: this.props.onAccept,
                    active: true
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $8df3a17622fbeec0$export$2e2bcd8739ae039), {
                    label: "Cancel",
                    onClick: this.props.onCancel
                }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $f68eca411d946c51$export$2e2bcd8739ae039), {
                    onChange: this.props.onChange,
                    rgb: this.props.rgb,
                    hsv: this.props.hsv,
                    hex: this.props.hex
                }))))));
            }
        }
    ]);
    return Photoshop;
}((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Component);
$10c0d41a92c5ad86$export$4ed116dea8ad5956.propTypes = {
    header: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$10c0d41a92c5ad86$export$4ed116dea8ad5956.defaultProps = {
    header: "Color Picker",
    styles: {}
};
var $10c0d41a92c5ad86$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($10c0d41a92c5ad86$export$4ed116dea8ad5956);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");



/* eslint-disable no-param-reassign */ 
var $eCoWV = parcelRequire("eCoWV");



var $7ea3b360ef01e98a$export$a9bdb1170868e062 = function SketchFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, disableAlpha = _ref.disableAlpha;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            fields: {
                display: "flex",
                paddingTop: "4px"
            },
            single: {
                flex: "1",
                paddingLeft: "6px"
            },
            alpha: {
                flex: "1",
                paddingLeft: "6px"
            },
            double: {
                flex: "2"
            },
            input: {
                width: "80%",
                padding: "4px 10% 3px",
                border: "none",
                boxShadow: "inset 0 0 0 1px #ccc",
                fontSize: "11px"
            },
            label: {
                display: "block",
                textAlign: "center",
                fontSize: "11px",
                color: "#222",
                paddingTop: "3px",
                paddingBottom: "4px",
                textTransform: "capitalize"
            }
        },
        "disableAlpha": {
            alpha: {
                display: "none"
            }
        }
    }, {
        disableAlpha: disableAlpha
    });
    var handleChange = function handleChange(data, e) {
        if (data.hex) $ef913fe6710c7df5$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.r || data.g || data.b) onChange({
            r: data.r || rgb.r,
            g: data.g || rgb.g,
            b: data.b || rgb.b,
            a: rgb.a,
            source: "rgb"
        }, e);
        else if (data.a) {
            if (data.a < 0) data.a = 0;
            else if (data.a > 100) data.a = 100;
            data.a /= 100;
            onChange({
                h: hsl.h,
                s: hsl.s,
                l: hsl.l,
                a: data.a,
                source: "rgb"
            }, e);
        }
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.fields,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex.replace("#", ""),
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "r",
        value: rgb.r,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "g",
        value: rgb.g,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "b",
        value: rgb.b,
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "255"
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "a",
        value: Math.round(rgb.a * 100),
        onChange: handleChange,
        dragLabel: "true",
        dragMax: "100"
    })));
};
var $7ea3b360ef01e98a$export$2e2bcd8739ae039 = $7ea3b360ef01e98a$export$a9bdb1170868e062;



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");


var $2f59048efd315e66$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $2f59048efd315e66$export$cc78acae6744db3b = function SketchPresetColors(_ref) {
    var colors = _ref.colors, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            colors: {
                margin: "0 -10px",
                padding: "10px 0 0 10px",
                borderTop: "1px solid #eee",
                display: "flex",
                flexWrap: "wrap",
                position: "relative"
            },
            swatchWrap: {
                width: "16px",
                height: "16px",
                margin: "0 10px 10px 0"
            },
            swatch: {
                borderRadius: "3px",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15)"
            }
        },
        "no-presets": {
            colors: {
                display: "none"
            }
        }
    }, {
        "no-presets": !colors || !colors.length
    });
    var handleClick = function handleClick(hex, e) {
        onClick({
            hex: hex,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.colors,
        className: "flexbox-fix"
    }, colors.map(function(colorObjOrString) {
        var c = typeof colorObjOrString === "string" ? {
            color: colorObjOrString
        } : colorObjOrString;
        var key = "" + c.color + (c.title || "");
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
            key: key,
            style: styles.swatchWrap
        }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), $2f59048efd315e66$var$_extends({}, c, {
            style: styles.swatch,
            onClick: handleClick,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), 0 0 4px " + c.color
            }
        })));
    }));
};
$2f59048efd315e66$export$cc78acae6744db3b.propTypes = {
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).shape({
            color: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
            title: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string
        })
    ])).isRequired
};
var $2f59048efd315e66$export$2e2bcd8739ae039 = $2f59048efd315e66$export$cc78acae6744db3b;


var $7bae1266c7975dd8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7bae1266c7975dd8$export$361fce2090be193f = function Sketch(_ref) {
    var width = _ref.width, rgb = _ref.rgb, hex = _ref.hex, hsv = _ref.hsv, hsl = _ref.hsl, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, disableAlpha = _ref.disableAlpha, presetColors = _ref.presetColors, renderers = _ref.renderers, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": $7bae1266c7975dd8$var$_extends({
            picker: {
                width: width,
                padding: "10px 10px 0",
                boxSizing: "initial",
                background: "#fff",
                borderRadius: "4px",
                boxShadow: "0 0 0 1px rgba(0,0,0,.15), 0 8px 16px rgba(0,0,0,.15)"
            },
            saturation: {
                width: "100%",
                paddingBottom: "75%",
                position: "relative",
                overflow: "hidden"
            },
            Saturation: {
                radius: "3px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            controls: {
                display: "flex"
            },
            sliders: {
                padding: "4px 0",
                flex: "1"
            },
            color: {
                width: "24px",
                height: "24px",
                position: "relative",
                marginTop: "4px",
                marginLeft: "4px",
                borderRadius: "3px"
            },
            activeColor: {
                absolute: "0px 0px 0px 0px",
                borderRadius: "2px",
                background: "rgba(" + rgb.r + "," + rgb.g + "," + rgb.b + "," + rgb.a + ")",
                boxShadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            hue: {
                position: "relative",
                height: "10px",
                overflow: "hidden"
            },
            Hue: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            },
            alpha: {
                position: "relative",
                height: "10px",
                marginTop: "4px",
                overflow: "hidden"
            },
            Alpha: {
                radius: "2px",
                shadow: "inset 0 0 0 1px rgba(0,0,0,.15), inset 0 0 4px rgba(0,0,0,.25)"
            }
        }, passedStyles),
        "disableAlpha": {
            color: {
                height: "10px"
            },
            hue: {
                height: "10px"
            },
            alpha: {
                display: "none"
            }
        }
    }, passedStyles), {
        disableAlpha: disableAlpha
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "sketch-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $4c4c816213e4c82f$export$2e2bcd8739ae039), {
        style: styles.Saturation,
        hsl: hsl,
        hsv: hsv,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.sliders
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.alpha
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $cf5fa3fd43734c4f$export$2e2bcd8739ae039), {
        style: styles.Alpha,
        rgb: rgb,
        hsl: hsl,
        renderers: renderers,
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.color
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $49a998e72892ed67$export$2e2bcd8739ae039), null), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.activeColor
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $7ea3b360ef01e98a$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        onChange: onChange,
        disableAlpha: disableAlpha
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $2f59048efd315e66$export$2e2bcd8739ae039), {
        colors: presetColors,
        onClick: onChange,
        onSwatchHover: onSwatchHover
    }));
};
$7bae1266c7975dd8$export$361fce2090be193f.propTypes = {
    disableAlpha: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$7bae1266c7975dd8$export$361fce2090be193f.defaultProps = {
    disableAlpha: false,
    width: 200,
    styles: {},
    presetColors: [
        "#D0021B",
        "#F5A623",
        "#F8E71C",
        "#8B572A",
        "#7ED321",
        "#417505",
        "#BD10E0",
        "#9013FE",
        "#4A90E2",
        "#50E3C2",
        "#B8E986",
        "#000000",
        "#4A4A4A",
        "#9B9B9B",
        "#FFFFFF"
    ]
};
var $7bae1266c7975dd8$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($7bae1266c7975dd8$export$361fce2090be193f);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");




var $eCoWV = parcelRequire("eCoWV");


var $eCoWV = parcelRequire("eCoWV");

var $c9ad13988a9e0b71$export$5c11afa672411de4 = function SliderSwatch(_ref) {
    var hsl = _ref.hsl, offset = _ref.offset, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, active = _ref.active, first = _ref.first, last = _ref.last;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatch: {
                height: "12px",
                background: "hsl(" + hsl.h + ", 50%, " + offset * 100 + "%)",
                cursor: "pointer"
            }
        },
        "first": {
            swatch: {
                borderRadius: "2px 0 0 2px"
            }
        },
        "last": {
            swatch: {
                borderRadius: "0 2px 2px 0"
            }
        },
        "active": {
            swatch: {
                transform: "scaleY(1.8)",
                borderRadius: "3.6px/2px"
            }
        }
    }, {
        active: active,
        first: first,
        last: last
    });
    var handleClick = function handleClick(e) {
        return onClick({
            h: hsl.h,
            s: 0.5,
            l: offset,
            source: "hsl"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch,
        onClick: handleClick
    });
};
var $c9ad13988a9e0b71$export$2e2bcd8739ae039 = $c9ad13988a9e0b71$export$5c11afa672411de4;


var $1f60c824012c9fad$export$48f49e32c66cdd61 = function SliderSwatches(_ref) {
    var onClick = _ref.onClick, hsl = _ref.hsl;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            swatches: {
                marginTop: "20px"
            },
            swatch: {
                boxSizing: "border-box",
                width: "20%",
                paddingRight: "1px",
                float: "left"
            },
            clear: {
                clear: "both"
            }
        }
    });
    // Acceptible difference in floating point equality
    var epsilon = 0.1;
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $c9ad13988a9e0b71$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".80",
        active: Math.abs(hsl.l - 0.80) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        first: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $c9ad13988a9e0b71$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".65",
        active: Math.abs(hsl.l - 0.65) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $c9ad13988a9e0b71$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".50",
        active: Math.abs(hsl.l - 0.50) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $c9ad13988a9e0b71$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".35",
        active: Math.abs(hsl.l - 0.35) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $c9ad13988a9e0b71$export$2e2bcd8739ae039), {
        hsl: hsl,
        offset: ".20",
        active: Math.abs(hsl.l - 0.20) < epsilon && Math.abs(hsl.s - 0.50) < epsilon,
        onClick: onClick,
        last: true
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.clear
    }));
};
var $1f60c824012c9fad$export$2e2bcd8739ae039 = $1f60c824012c9fad$export$48f49e32c66cdd61;



var $eCoWV = parcelRequire("eCoWV");

var $79b7a53c57521109$export$9c10b52c64965f67 = function SliderPointer() {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "14px",
                height: "14px",
                borderRadius: "6px",
                transform: "translate(-7px, -1px)",
                backgroundColor: "rgb(248, 248, 248)",
                boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.37)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
var $79b7a53c57521109$export$2e2bcd8739ae039 = $79b7a53c57521109$export$9c10b52c64965f67;


var $49ce1d7fdff0a4e2$export$472062a354075cee = function Slider(_ref) {
    var hsl = _ref.hsl, onChange = _ref.onChange, pointer = _ref.pointer, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            hue: {
                height: "12px",
                position: "relative"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.wrap || {},
        className: "slider-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        pointer: pointer,
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatches
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $1f60c824012c9fad$export$2e2bcd8739ae039), {
        hsl: hsl,
        onClick: onChange
    })));
};
$49ce1d7fdff0a4e2$export$472062a354075cee.propTypes = {
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$49ce1d7fdff0a4e2$export$472062a354075cee.defaultProps = {
    pointer: (0, $79b7a53c57521109$export$2e2bcd8739ae039),
    styles: {}
};
var $49ce1d7fdff0a4e2$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($49ce1d7fdff0a4e2$export$472062a354075cee);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");






var $eCoWV = parcelRequire("eCoWV");



var $eCoWV = parcelRequire("eCoWV");



var $34d312eab874ef48$exports = {};
"use strict";
Object.defineProperty($34d312eab874ef48$exports, "__esModule", {
    value: true
});
var $34d312eab874ef48$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $eCoWV = parcelRequire("eCoWV");
var $34d312eab874ef48$var$_react2 = $34d312eab874ef48$var$_interopRequireDefault($eCoWV);
function $34d312eab874ef48$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $34d312eab874ef48$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
var $34d312eab874ef48$var$DEFAULT_SIZE = 24;
$34d312eab874ef48$exports.default = function(_ref) {
    var _ref$fill = _ref.fill, fill = _ref$fill === undefined ? "currentColor" : _ref$fill, _ref$width = _ref.width, width = _ref$width === undefined ? $34d312eab874ef48$var$DEFAULT_SIZE : _ref$width, _ref$height = _ref.height, height = _ref$height === undefined ? $34d312eab874ef48$var$DEFAULT_SIZE : _ref$height, _ref$style = _ref.style, style = _ref$style === undefined ? {} : _ref$style, props = $34d312eab874ef48$var$_objectWithoutProperties(_ref, [
        "fill",
        "width",
        "height",
        "style"
    ]);
    return $34d312eab874ef48$var$_react2.default.createElement("svg", $34d312eab874ef48$var$_extends({
        viewBox: "0 0 " + $34d312eab874ef48$var$DEFAULT_SIZE + " " + $34d312eab874ef48$var$DEFAULT_SIZE,
        style: $34d312eab874ef48$var$_extends({
            fill: fill,
            width: width,
            height: height
        }, style)
    }, props), $34d312eab874ef48$var$_react2.default.createElement("path", {
        d: "M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"
    }));
};


var $bbfc91485518626d$export$af5303fde6798b43 = function SwatchesColor(_ref) {
    var color = _ref.color, _ref$onClick = _ref.onClick, onClick = _ref$onClick === undefined ? function() {} : _ref$onClick, onSwatchHover = _ref.onSwatchHover, first = _ref.first, last = _ref.last, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            color: {
                width: "40px",
                height: "24px",
                cursor: "pointer",
                background: color,
                marginBottom: "1px"
            },
            check: {
                color: $ef913fe6710c7df5$export$3609eb1d7e55dec(color),
                marginLeft: "8px",
                display: "none"
            }
        },
        "first": {
            color: {
                overflow: "hidden",
                borderRadius: "2px 2px 0 0"
            }
        },
        "last": {
            color: {
                overflow: "hidden",
                borderRadius: "0 0 2px 2px"
            }
        },
        "active": {
            check: {
                display: "block"
            }
        },
        "color-#FFFFFF": {
            color: {
                boxShadow: "inset 0 0 0 1px #ddd"
            },
            check: {
                color: "#333"
            }
        },
        "transparent": {
            check: {
                color: "#333"
            }
        }
    }, {
        first: first,
        last: last,
        active: active,
        "color-#FFFFFF": color === "#FFFFFF",
        "transparent": color === "transparent"
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
        color: color,
        style: styles.color,
        onClick: onClick,
        onHover: onSwatchHover,
        focusStyle: {
            boxShadow: "0 0 4px " + color
        }
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.check
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34d312eab874ef48$exports))), null)));
};
var $bbfc91485518626d$export$2e2bcd8739ae039 = $bbfc91485518626d$export$af5303fde6798b43;


var $752fdeff5af4a72a$export$354a0399ec1ad469 = function SwatchesGroup(_ref) {
    var onClick = _ref.onClick, onSwatchHover = _ref.onSwatchHover, group = _ref.group, active = _ref.active;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            group: {
                paddingBottom: "10px",
                width: "40px",
                float: "left",
                marginRight: "10px"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.group
    }, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(group, function(color, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $bbfc91485518626d$export$2e2bcd8739ae039), {
            key: color,
            color: color,
            active: color.toLowerCase() === active,
            first: i === 0,
            last: i === group.length - 1,
            onClick: onClick,
            onSwatchHover: onSwatchHover
        });
    }));
};
var $752fdeff5af4a72a$export$2e2bcd8739ae039 = $752fdeff5af4a72a$export$354a0399ec1ad469;


var $935f23ea47d679b4$export$81ebbfd13e06b049 = function Swatches(_ref) {
    var width = _ref.width, height = _ref.height, onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, colors = _ref.colors, hex = _ref.hex, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                height: height
            },
            overflow: {
                height: height,
                overflowY: "scroll"
            },
            body: {
                padding: "16px 0 6px 16px"
            },
            clear: {
                clear: "both"
            }
        }
    }, passedStyles));
    var handleChange = function handleChange(data, e) {
        return onChange({
            hex: data,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "swatches-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $0fbacba5a68a0690$export$2e2bcd8739ae039), null, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.overflow
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.body
    }, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(group) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $752fdeff5af4a72a$export$2e2bcd8739ae039), {
            key: group.toString(),
            group: group,
            active: hex,
            onClick: handleChange,
            onSwatchHover: onSwatchHover
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.clear
    })))));
};
$935f23ea47d679b4$export$81ebbfd13e06b049.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    height: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string)),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$935f23ea47d679b4$export$81ebbfd13e06b049.defaultProps = {
    width: 320,
    height: 240,
    colors: [
        [
            $e078af2993bfe018$export$a90204d1394caf30["900"],
            $e078af2993bfe018$export$a90204d1394caf30["700"],
            $e078af2993bfe018$export$a90204d1394caf30["500"],
            $e078af2993bfe018$export$a90204d1394caf30["300"],
            $e078af2993bfe018$export$a90204d1394caf30["100"]
        ],
        [
            $e078af2993bfe018$export$47853bc718611763["900"],
            $e078af2993bfe018$export$47853bc718611763["700"],
            $e078af2993bfe018$export$47853bc718611763["500"],
            $e078af2993bfe018$export$47853bc718611763["300"],
            $e078af2993bfe018$export$47853bc718611763["100"]
        ],
        [
            $e078af2993bfe018$export$e13cce2a2d16a9d4["900"],
            $e078af2993bfe018$export$e13cce2a2d16a9d4["700"],
            $e078af2993bfe018$export$e13cce2a2d16a9d4["500"],
            $e078af2993bfe018$export$e13cce2a2d16a9d4["300"],
            $e078af2993bfe018$export$e13cce2a2d16a9d4["100"]
        ],
        [
            $e078af2993bfe018$export$51ef95b19086af57["900"],
            $e078af2993bfe018$export$51ef95b19086af57["700"],
            $e078af2993bfe018$export$51ef95b19086af57["500"],
            $e078af2993bfe018$export$51ef95b19086af57["300"],
            $e078af2993bfe018$export$51ef95b19086af57["100"]
        ],
        [
            $e078af2993bfe018$export$3e6ccc7b8562d453["900"],
            $e078af2993bfe018$export$3e6ccc7b8562d453["700"],
            $e078af2993bfe018$export$3e6ccc7b8562d453["500"],
            $e078af2993bfe018$export$3e6ccc7b8562d453["300"],
            $e078af2993bfe018$export$3e6ccc7b8562d453["100"]
        ],
        [
            $e078af2993bfe018$export$2aa0182783e7e9de["900"],
            $e078af2993bfe018$export$2aa0182783e7e9de["700"],
            $e078af2993bfe018$export$2aa0182783e7e9de["500"],
            $e078af2993bfe018$export$2aa0182783e7e9de["300"],
            $e078af2993bfe018$export$2aa0182783e7e9de["100"]
        ],
        [
            $e078af2993bfe018$export$7b0d29b70b435c21["900"],
            $e078af2993bfe018$export$7b0d29b70b435c21["700"],
            $e078af2993bfe018$export$7b0d29b70b435c21["500"],
            $e078af2993bfe018$export$7b0d29b70b435c21["300"],
            $e078af2993bfe018$export$7b0d29b70b435c21["100"]
        ],
        [
            $e078af2993bfe018$export$7474046f446842ee["900"],
            $e078af2993bfe018$export$7474046f446842ee["700"],
            $e078af2993bfe018$export$7474046f446842ee["500"],
            $e078af2993bfe018$export$7474046f446842ee["300"],
            $e078af2993bfe018$export$7474046f446842ee["100"]
        ],
        [
            $e078af2993bfe018$export$8bf7dff220b82b4a["900"],
            $e078af2993bfe018$export$8bf7dff220b82b4a["700"],
            $e078af2993bfe018$export$8bf7dff220b82b4a["500"],
            $e078af2993bfe018$export$8bf7dff220b82b4a["300"],
            $e078af2993bfe018$export$8bf7dff220b82b4a["100"]
        ],
        [
            "#194D33",
            $e078af2993bfe018$export$955a2ebd2fb142ae["700"],
            $e078af2993bfe018$export$955a2ebd2fb142ae["500"],
            $e078af2993bfe018$export$955a2ebd2fb142ae["300"],
            $e078af2993bfe018$export$955a2ebd2fb142ae["100"]
        ],
        [
            $e078af2993bfe018$export$559a8c00376dc936["900"],
            $e078af2993bfe018$export$559a8c00376dc936["700"],
            $e078af2993bfe018$export$559a8c00376dc936["500"],
            $e078af2993bfe018$export$559a8c00376dc936["300"],
            $e078af2993bfe018$export$559a8c00376dc936["100"]
        ],
        [
            $e078af2993bfe018$export$221d31baf2636aad["900"],
            $e078af2993bfe018$export$221d31baf2636aad["700"],
            $e078af2993bfe018$export$221d31baf2636aad["500"],
            $e078af2993bfe018$export$221d31baf2636aad["300"],
            $e078af2993bfe018$export$221d31baf2636aad["100"]
        ],
        [
            $e078af2993bfe018$export$594c5a8758200c32["900"],
            $e078af2993bfe018$export$594c5a8758200c32["700"],
            $e078af2993bfe018$export$594c5a8758200c32["500"],
            $e078af2993bfe018$export$594c5a8758200c32["300"],
            $e078af2993bfe018$export$594c5a8758200c32["100"]
        ],
        [
            $e078af2993bfe018$export$7c1ecc66643fdbd6["900"],
            $e078af2993bfe018$export$7c1ecc66643fdbd6["700"],
            $e078af2993bfe018$export$7c1ecc66643fdbd6["500"],
            $e078af2993bfe018$export$7c1ecc66643fdbd6["300"],
            $e078af2993bfe018$export$7c1ecc66643fdbd6["100"]
        ],
        [
            $e078af2993bfe018$export$ad766f34ace1cafd["900"],
            $e078af2993bfe018$export$ad766f34ace1cafd["700"],
            $e078af2993bfe018$export$ad766f34ace1cafd["500"],
            $e078af2993bfe018$export$ad766f34ace1cafd["300"],
            $e078af2993bfe018$export$ad766f34ace1cafd["100"]
        ],
        [
            $e078af2993bfe018$export$1ceed3dd9ec11704["900"],
            $e078af2993bfe018$export$1ceed3dd9ec11704["700"],
            $e078af2993bfe018$export$1ceed3dd9ec11704["500"],
            $e078af2993bfe018$export$1ceed3dd9ec11704["300"],
            $e078af2993bfe018$export$1ceed3dd9ec11704["100"]
        ],
        [
            $e078af2993bfe018$export$b6e6178d3f565007["900"],
            $e078af2993bfe018$export$b6e6178d3f565007["700"],
            $e078af2993bfe018$export$b6e6178d3f565007["500"],
            $e078af2993bfe018$export$b6e6178d3f565007["300"],
            $e078af2993bfe018$export$b6e6178d3f565007["100"]
        ],
        [
            $e078af2993bfe018$export$7c2da42d08c019c9["900"],
            $e078af2993bfe018$export$7c2da42d08c019c9["700"],
            $e078af2993bfe018$export$7c2da42d08c019c9["500"],
            $e078af2993bfe018$export$7c2da42d08c019c9["300"],
            $e078af2993bfe018$export$7c2da42d08c019c9["100"]
        ],
        [
            "#000000",
            "#525252",
            "#969696",
            "#D9D9D9",
            "#FFFFFF"
        ]
    ],
    styles: {}
};
var $935f23ea47d679b4$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($935f23ea47d679b4$export$81ebbfd13e06b049);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");





var $5e78b70f16348396$export$9e389cdad32a5b7a = function Twitter(_ref) {
    var onChange = _ref.onChange, onSwatchHover = _ref.onSwatchHover, hex = _ref.hex, colors = _ref.colors, width = _ref.width, triangle = _ref.triangle, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            card: {
                width: width,
                background: "#fff",
                border: "0 solid rgba(0,0,0,0.25)",
                boxShadow: "0 1px 4px rgba(0,0,0,0.25)",
                borderRadius: "4px",
                position: "relative"
            },
            body: {
                padding: "15px 9px 9px 15px"
            },
            label: {
                fontSize: "18px",
                color: "#fff"
            },
            triangle: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent #fff transparent",
                position: "absolute"
            },
            triangleShadow: {
                width: "0px",
                height: "0px",
                borderStyle: "solid",
                borderWidth: "0 9px 10px 9px",
                borderColor: "transparent transparent rgba(0,0,0,.1) transparent",
                position: "absolute"
            },
            hash: {
                background: "#F0F0F0",
                height: "30px",
                width: "30px",
                borderRadius: "4px 0 0 4px",
                float: "left",
                color: "#98A1A4",
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            },
            input: {
                width: "100px",
                fontSize: "14px",
                color: "#666",
                border: "0px",
                outline: "none",
                height: "28px",
                boxShadow: "inset 0 0 0 1px #F0F0F0",
                boxSizing: "content-box",
                borderRadius: "0 4px 4px 0",
                float: "left",
                paddingLeft: "8px"
            },
            swatch: {
                width: "30px",
                height: "30px",
                float: "left",
                borderRadius: "4px",
                margin: "0 6px 6px 0"
            },
            clear: {
                clear: "both"
            }
        },
        "hide-triangle": {
            triangle: {
                display: "none"
            },
            triangleShadow: {
                display: "none"
            }
        },
        "top-left-triangle": {
            triangle: {
                top: "-10px",
                left: "12px"
            },
            triangleShadow: {
                top: "-11px",
                left: "12px"
            }
        },
        "top-right-triangle": {
            triangle: {
                top: "-10px",
                right: "12px"
            },
            triangleShadow: {
                top: "-11px",
                right: "12px"
            }
        }
    }, passedStyles), {
        "hide-triangle": triangle === "hide",
        "top-left-triangle": triangle === "top-left",
        "top-right-triangle": triangle === "top-right"
    });
    var handleChange = function handleChange(hexcode, e) {
        $ef913fe6710c7df5$export$944f75ec5697b362(hexcode) && onChange({
            hex: hexcode,
            source: "hex"
        }, e);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.card,
        className: "twitter-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.triangleShadow
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.triangle
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.body
    }, (0, $52f6959b28f2c094$export$2e2bcd8739ae039)(colors, function(c, i) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $638ea217c626d375$export$2e2bcd8739ae039), {
            key: i,
            color: c,
            hex: c,
            style: styles.swatch,
            onClick: handleChange,
            onHover: onSwatchHover,
            focusStyle: {
                boxShadow: "0 0 4px " + c
            }
        });
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.hash
    }, "#"), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        label: null,
        style: {
            input: styles.input
        },
        value: hex.replace("#", ""),
        onChange: handleChange
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.clear
    })));
};
$5e78b70f16348396$export$9e389cdad32a5b7a.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    triangle: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
        "hide",
        "top-left",
        "top-right"
    ]),
    colors: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object
};
$5e78b70f16348396$export$9e389cdad32a5b7a.defaultProps = {
    width: 276,
    colors: [
        "#FF6900",
        "#FCB900",
        "#7BDCB5",
        "#00D084",
        "#8ED1FC",
        "#0693E3",
        "#ABB8C3",
        "#EB144C",
        "#F78DA7",
        "#9900EF"
    ],
    triangle: "top-left",
    styles: {}
};
var $5e78b70f16348396$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($5e78b70f16348396$export$9e389cdad32a5b7a);



var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");




var $eCoWV = parcelRequire("eCoWV");


var $hqomP = parcelRequire("hqomP");
var $b27586d493b058f2$export$a928e0fe8b70765d = function GooglePointerCircle(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                border: "2px #fff solid",
                transform: "translate(-12px, -13px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", " + Math.round(props.hsl.s * 100) + "%, " + Math.round(props.hsl.l * 100) + "%)"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
$b27586d493b058f2$export$a928e0fe8b70765d.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    })
};
$b27586d493b058f2$export$a928e0fe8b70765d.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $b27586d493b058f2$export$2e2bcd8739ae039 = $b27586d493b058f2$export$a928e0fe8b70765d;



var $eCoWV = parcelRequire("eCoWV");


var $hqomP = parcelRequire("hqomP");
var $cd92f1d6328840c3$export$9de61b9626feed9a = function GooglePointer(props) {
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            picker: {
                width: "20px",
                height: "20px",
                borderRadius: "22px",
                transform: "translate(-10px, -7px)",
                background: "hsl(" + Math.round(props.hsl.h) + ", 100%, 50%)",
                border: "2px white solid"
            }
        }
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker
    });
};
$cd92f1d6328840c3$export$9de61b9626feed9a.propTypes = {
    hsl: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).shape({
        h: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        s: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        l: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
        a: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    })
};
$cd92f1d6328840c3$export$9de61b9626feed9a.defaultProps = {
    hsl: {
        a: 1,
        h: 249.94,
        l: 0.2,
        s: 0.50
    }
};
var $cd92f1d6328840c3$export$2e2bcd8739ae039 = $cd92f1d6328840c3$export$9de61b9626feed9a;



var $eCoWV = parcelRequire("eCoWV");



var $e6748216b0ab6203$export$e50902ed332e5599 = function GoogleFields(_ref) {
    var onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hex = _ref.hex, hsv = _ref.hsv;
    var handleChange = function handleChange(data, e) {
        if (data.hex) $ef913fe6710c7df5$export$944f75ec5697b362(data.hex) && onChange({
            hex: data.hex,
            source: "hex"
        }, e);
        else if (data.rgb) {
            var values = data.rgb.split(",");
            $ef913fe6710c7df5$export$e76ec4c5b3cadd73(data.rgb, "rgb") && onChange({
                r: values[0],
                g: values[1],
                b: values[2],
                a: 1,
                source: "rgb"
            }, e);
        } else if (data.hsv) {
            var _values = data.hsv.split(",");
            if ($ef913fe6710c7df5$export$e76ec4c5b3cadd73(data.hsv, "hsv")) {
                _values[2] = _values[2].replace("%", "");
                _values[1] = _values[1].replace("%", "");
                _values[0] = _values[0].replace("\xb0", "");
                if (_values[1] == 1) _values[1] = 0.01;
                else if (_values[2] == 1) _values[2] = 0.01;
                onChange({
                    h: Number(_values[0]),
                    s: Number(_values[1]),
                    v: Number(_values[2]),
                    source: "hsv"
                }, e);
            }
        } else if (data.hsl) {
            var _values2 = data.hsl.split(",");
            if ($ef913fe6710c7df5$export$e76ec4c5b3cadd73(data.hsl, "hsl")) {
                _values2[2] = _values2[2].replace("%", "");
                _values2[1] = _values2[1].replace("%", "");
                _values2[0] = _values2[0].replace("\xb0", "");
                if (hsvValue[1] == 1) hsvValue[1] = 0.01;
                else if (hsvValue[2] == 1) hsvValue[2] = 0.01;
                onChange({
                    h: Number(_values2[0]),
                    s: Number(_values2[1]),
                    v: Number(_values2[2]),
                    source: "hsl"
                }, e);
            }
        }
    };
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))({
        "default": {
            wrap: {
                display: "flex",
                height: "100px",
                marginTop: "4px"
            },
            fields: {
                width: "100%"
            },
            column: {
                paddingTop: "10px",
                display: "flex",
                justifyContent: "space-between"
            },
            double: {
                padding: "0px 4.4px",
                boxSizing: "border-box"
            },
            input: {
                width: "100%",
                height: "38px",
                boxSizing: "border-box",
                padding: "4px 10% 3px",
                textAlign: "center",
                border: "1px solid #dadce0",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            input2: {
                height: "38px",
                width: "100%",
                border: "1px solid #dadce0",
                boxSizing: "border-box",
                fontSize: "11px",
                textTransform: "lowercase",
                borderRadius: "5px",
                outline: "none",
                paddingLeft: "10px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label: {
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "35px",
                top: "-6px",
                left: "0",
                right: "0",
                marginLeft: "auto",
                marginRight: "auto",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            label2: {
                left: "10px",
                textAlign: "center",
                fontSize: "12px",
                background: "#fff",
                position: "absolute",
                textTransform: "uppercase",
                color: "#3c4043",
                width: "32px",
                top: "-6px",
                fontFamily: "Roboto,Arial,sans-serif"
            },
            single: {
                flexGrow: "1",
                margin: "0px 4.4px"
            }
        }
    });
    var rgbValue = rgb.r + ", " + rgb.g + ", " + rgb.b;
    var hslValue = Math.round(hsl.h) + "\xb0, " + Math.round(hsl.s * 100) + "%, " + Math.round(hsl.l * 100) + "%";
    var hsvValue = Math.round(hsv.h) + "\xb0, " + Math.round(hsv.s * 100) + "%, " + Math.round(hsv.v * 100) + "%";
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.wrap,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.fields
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.double
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input,
            label: styles.label
        },
        label: "hex",
        value: hex,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.column
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "rgb",
        value: rgbValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsv",
        value: hsvValue,
        onChange: handleChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.single
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $87c5b25e869e3a91$export$2e2bcd8739ae039), {
        style: {
            input: styles.input2,
            label: styles.label2
        },
        label: "hsl",
        value: hslValue,
        onChange: handleChange
    })))));
};
var $e6748216b0ab6203$export$2e2bcd8739ae039 = $e6748216b0ab6203$export$e50902ed332e5599;


var $092c5273b421d092$export$347eee6e8bf67997 = function Google(_ref) {
    var width = _ref.width, onChange = _ref.onChange, rgb = _ref.rgb, hsl = _ref.hsl, hsv = _ref.hsv, hex = _ref.hex, header = _ref.header, _ref$styles = _ref.styles, passedStyles = _ref$styles === undefined ? {} : _ref$styles, _ref$className = _ref.className, className = _ref$className === undefined ? "" : _ref$className;
    var styles = (0, (/*@__PURE__*/$parcel$interopDefault($30b13a56cd0faccc$exports)))((0, $55851e245b6d3090$export$2e2bcd8739ae039)({
        "default": {
            picker: {
                width: width,
                background: "#fff",
                border: "1px solid #dfe1e5",
                boxSizing: "initial",
                display: "flex",
                flexWrap: "wrap",
                borderRadius: "8px 8px 0px 0px"
            },
            head: {
                height: "57px",
                width: "100%",
                paddingTop: "16px",
                paddingBottom: "16px",
                paddingLeft: "16px",
                fontSize: "20px",
                boxSizing: "border-box",
                fontFamily: "Roboto-Regular,HelveticaNeue,Arial,sans-serif"
            },
            saturation: {
                width: "70%",
                padding: "0px",
                position: "relative",
                overflow: "hidden"
            },
            swatch: {
                width: "30%",
                height: "228px",
                padding: "0px",
                background: "rgba(" + rgb.r + ", " + rgb.g + ", " + rgb.b + ", 1)",
                position: "relative",
                overflow: "hidden"
            },
            body: {
                margin: "auto",
                width: "95%"
            },
            controls: {
                display: "flex",
                boxSizing: "border-box",
                height: "52px",
                paddingTop: "22px"
            },
            color: {
                width: "32px"
            },
            hue: {
                height: "8px",
                position: "relative",
                margin: "0px 16px 0px 16px",
                width: "100%"
            },
            Hue: {
                radius: "2px"
            }
        }
    }, passedStyles));
    return (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.picker,
        className: "google-picker " + className
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.head
    }, header), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.swatch
    }), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.saturation
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $4c4c816213e4c82f$export$2e2bcd8739ae039), {
        hsl: hsl,
        hsv: hsv,
        pointer: (0, $b27586d493b058f2$export$2e2bcd8739ae039),
        onChange: onChange
    })), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.body
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.controls,
        className: "flexbox-fix"
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
        style: styles.hue
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $b35a081ce1a7aeeb$export$2e2bcd8739ae039), {
        style: styles.Hue,
        hsl: hsl,
        radius: "4px",
        pointer: (0, $cd92f1d6328840c3$export$2e2bcd8739ae039),
        onChange: onChange
    }))), (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e6748216b0ab6203$export$2e2bcd8739ae039), {
        rgb: rgb,
        hsl: hsl,
        hex: hex,
        hsv: hsv,
        onChange: onChange
    })));
};
$092c5273b421d092$export$347eee6e8bf67997.propTypes = {
    width: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number
    ]),
    styles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    header: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string
};
$092c5273b421d092$export$347eee6e8bf67997.defaultProps = {
    width: 652,
    styles: {},
    header: "Color picker"
};
var $092c5273b421d092$export$2e2bcd8739ae039 = (0, $d4aadc8759a4ab83$export$2e2bcd8739ae039)($092c5273b421d092$export$347eee6e8bf67997);






var $6PcpQ = parcelRequire("6PcpQ");

var $b3950ae1d3b5e3be$export$1ba6601fde3bb0d0;
var $b3950ae1d3b5e3be$export$34e0f9847d4c02dd;
var $b3950ae1d3b5e3be$export$e4043f67d36cbb26;
var $b3950ae1d3b5e3be$export$bfd64c937657f93a;
var $b3950ae1d3b5e3be$export$4a6dd88bada4e7d2;
$b3950ae1d3b5e3be$export$1ba6601fde3bb0d0 = `_51AnG_brick`;
$b3950ae1d3b5e3be$export$34e0f9847d4c02dd = `_51AnG_container`;
$b3950ae1d3b5e3be$export$e4043f67d36cbb26 = `_51AnG_highlight`;
$b3950ae1d3b5e3be$export$bfd64c937657f93a = `_51AnG_rotating`;
$b3950ae1d3b5e3be$export$4a6dd88bada4e7d2 = `_51AnG_shimmer`;


function $d3f4fc0ac65eef21$var$ColorPicker({ onChange: onChange, value: value = "#000000" }) {
    const anchorRef = (0, $eCoWV.useRef)(null);
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        tabIndex: 0,
        role: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b3950ae1d3b5e3be$export$34e0f9847d4c02dd, isOpen && $b3950ae1d3b5e3be$export$e4043f67d36cbb26),
        onClick: ()=>{
            setIsOpen(true);
        },
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            setIsOpen(true);
        }),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                ref: anchorRef,
                className: $b3950ae1d3b5e3be$export$1ba6601fde3bb0d0,
                style: {
                    backgroundColor: value
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                children: value.toUpperCase()
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                anchorRef: anchorRef,
                isOpen: isOpen,
                horizontalAlign: "start",
                onClose: ()=>{
                    setIsOpen(false);
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $add8139f08dae22a$export$2e2bcd8739ae039), {
                    color: value,
                    onChange: ({ hex: hex })=>{
                        onChange(hex);
                    }
                })
            })
        ]
    });
}
var $d3f4fc0ac65eef21$export$2e2bcd8739ae039 = $d3f4fc0ac65eef21$var$ColorPicker;



var $dADBR = parcelRequire("dADBR");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
const $1625b8f7da86bccb$export$d098614ac05972c2 = Object.freeze({
    "image/jpeg": [
        "jpeg",
        "jpg"
    ],
    "image/png": [
        "png"
    ],
    "image/gif": [
        "gif"
    ],
    "image/vnd.microsoft.icon": [
        "ico"
    ],
    "image/svg+xml": [
        "svg"
    ],
    "image/tiff": [
        "tif",
        "tiff"
    ],
    "image/webp": [
        "webp"
    ],
    "image/bmp": [
        "bmp"
    ]
});


const $333675744efe20d0$export$e3d6b5f79f02cd5b = (mimeTypes)=>mimeTypes.flatMap((type)=>(0, $1625b8f7da86bccb$export$d098614ac05972c2)[type]).map((extension)=>extension.toUpperCase());


const $953ca65e28ae2893$export$7b487c2956dcad6 = 512000; // 500 KB
const $953ca65e28ae2893$var$allowedImageMimeTypes = [
    "image/svg+xml",
    "image/png",
    "image/jpeg",
    "image/vnd.microsoft.icon"
];
const $953ca65e28ae2893$var$useImageMimeTypes = (mimeTypes)=>{
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const allowedMimeTypes = (0, $eCoWV.useMemo)(()=>{
        return mimeTypes?.length ? mimeTypes : $953ca65e28ae2893$var$allowedImageMimeTypes;
    }, [
        mimeTypes
    ]);
    const description = (0, $eCoWV.useMemo)(()=>{
        return t("components.uploader.image_limit", {
            size: $953ca65e28ae2893$export$7b487c2956dcad6 / 1024,
            extensions: (0, $333675744efe20d0$export$e3d6b5f79f02cd5b)(allowedMimeTypes)
        });
    }, [
        allowedMimeTypes,
        t
    ]);
    return {
        allowedMimeTypes: allowedMimeTypes,
        description: description
    };
};
var $953ca65e28ae2893$export$2e2bcd8739ae039 = $953ca65e28ae2893$var$useImageMimeTypes;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a0d306f42ef06769$var$SvgDelete = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8.333 15a.833.833 0 0 0 .834-.833v-5a.833.833 0 1 0-1.667 0v5a.833.833 0 0 0 .833.833Zm8.334-10h-3.334v-.833a2.5 2.5 0 0 0-2.5-2.5H9.167a2.5 2.5 0 0 0-2.5 2.5V5H3.333a.833.833 0 0 0 0 1.667h.834v9.166a2.5 2.5 0 0 0 2.5 2.5h6.666a2.5 2.5 0 0 0 2.5-2.5V6.667h.834a.833.833 0 0 0 0-1.667Zm-8.334-.833a.833.833 0 0 1 .834-.834h1.666a.833.833 0 0 1 .834.834V5H8.333v-.833Zm5.834 11.666a.833.833 0 0 1-.834.834H6.667a.833.833 0 0 1-.834-.834V6.667h8.334v9.166Zm-2.5-.833a.833.833 0 0 0 .833-.833v-5a.833.833 0 1 0-1.667 0v5a.833.833 0 0 0 .834.833Z",
            fill: "currentColor"
        })
    });
var $a0d306f42ef06769$export$2e2bcd8739ae039 = $a0d306f42ef06769$var$SvgDelete;





var $9bgsA = parcelRequire("9bgsA");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $b63Fl = parcelRequire("b63Fl");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $daba873e9b04cf8c$var$extendStatics = function(d, b) {
    $daba873e9b04cf8c$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $daba873e9b04cf8c$var$extendStatics(d, b);
};
function $daba873e9b04cf8c$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $daba873e9b04cf8c$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $daba873e9b04cf8c$export$18ce0697a983be9b = function() {
    $daba873e9b04cf8c$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $daba873e9b04cf8c$export$18ce0697a983be9b.apply(this, arguments);
};
function $daba873e9b04cf8c$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $daba873e9b04cf8c$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $daba873e9b04cf8c$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $daba873e9b04cf8c$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.push(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.push(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $daba873e9b04cf8c$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $daba873e9b04cf8c$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $daba873e9b04cf8c$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $daba873e9b04cf8c$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $daba873e9b04cf8c$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $daba873e9b04cf8c$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $daba873e9b04cf8c$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $daba873e9b04cf8c$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $daba873e9b04cf8c$export$45d3717a4c69092e(o, m, p);
}
function $daba873e9b04cf8c$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $daba873e9b04cf8c$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $daba873e9b04cf8c$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($daba873e9b04cf8c$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $daba873e9b04cf8c$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $daba873e9b04cf8c$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $daba873e9b04cf8c$export$10c90e4f7922046c(v) {
    return this instanceof $daba873e9b04cf8c$export$10c90e4f7922046c ? (this.v = v, this) : new $daba873e9b04cf8c$export$10c90e4f7922046c(v);
}
function $daba873e9b04cf8c$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $daba873e9b04cf8c$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $daba873e9b04cf8c$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $daba873e9b04cf8c$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $daba873e9b04cf8c$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $daba873e9b04cf8c$export$19a8beecd37a4c45 === "function" ? $daba873e9b04cf8c$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $daba873e9b04cf8c$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $daba873e9b04cf8c$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $daba873e9b04cf8c$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $daba873e9b04cf8c$export$45d3717a4c69092e(result, mod, k);
    }
    $daba873e9b04cf8c$var$__setModuleDefault(result, mod);
    return result;
}
function $daba873e9b04cf8c$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $daba873e9b04cf8c$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $daba873e9b04cf8c$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $daba873e9b04cf8c$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


var $b8b2660e8a7441e1$export$db0345794bfc14ed = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    // Others
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]);
function $b8b2660e8a7441e1$export$8cc09085015f0dc7(file, path) {
    var f = $b8b2660e8a7441e1$var$withMimeType(file);
    if (typeof f.path !== "string") {
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, "path", {
            value: typeof path === "string" ? path : typeof webkitRelativePath === "string" && webkitRelativePath.length > 0 ? webkitRelativePath : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function $b8b2660e8a7441e1$var$withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf(".") !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split(".").pop().toLowerCase();
        var type = $b8b2660e8a7441e1$export$db0345794bfc14ed.get(ext);
        if (type) Object.defineProperty(file, "type", {
            value: type,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return file;
}


var $ff104351264256f9$var$FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    ".DS_Store",
    "Thumbs.db" // Windows
];
function $ff104351264256f9$export$a36e16046ae8f1bb(evt) {
    return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
            if ($ff104351264256f9$var$isObject(evt) && $ff104351264256f9$var$isDataTransfer(evt.dataTransfer)) return [
                2 /*return*/ ,
                $ff104351264256f9$var$getDataTransferFiles(evt.dataTransfer, evt.type)
            ];
            else if ($ff104351264256f9$var$isChangeEvt(evt)) return [
                2 /*return*/ ,
                $ff104351264256f9$var$getInputFiles(evt)
            ];
            else if (Array.isArray(evt) && evt.every(function(item) {
                return "getFile" in item && typeof item.getFile === "function";
            })) return [
                2 /*return*/ ,
                $ff104351264256f9$var$getFsHandleFiles(evt)
            ];
            return [
                2 /*return*/ ,
                []
            ];
        });
    });
}
function $ff104351264256f9$var$isDataTransfer(value) {
    return $ff104351264256f9$var$isObject(value);
}
function $ff104351264256f9$var$isChangeEvt(value) {
    return $ff104351264256f9$var$isObject(value) && $ff104351264256f9$var$isObject(value.target);
}
function $ff104351264256f9$var$isObject(v) {
    return typeof v === "object" && v !== null;
}
function $ff104351264256f9$var$getInputFiles(evt) {
    return $ff104351264256f9$var$fromList(evt.target.files).map(function(file) {
        return (0, $b8b2660e8a7441e1$export$8cc09085015f0dc7)(file);
    });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function $ff104351264256f9$var$getFsHandleFiles(handles) {
    return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var files;
        return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    return [
                        4 /*yield*/ ,
                        Promise.all(handles.map(function(h) {
                            return h.getFile();
                        }))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        files.map(function(file) {
                            return (0, $b8b2660e8a7441e1$export$8cc09085015f0dc7)(file);
                        })
                    ];
            }
        });
    });
}
function $ff104351264256f9$var$getDataTransferFiles(dt, type) {
    return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var items, files;
        return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
            switch(_a.label){
                case 0:
                    if (!dt.items) return [
                        3 /*break*/ ,
                        2
                    ];
                    items = $ff104351264256f9$var$fromList(dt.items).filter(function(item) {
                        return item.kind === "file";
                    });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== "drop") return [
                        2 /*return*/ ,
                        items
                    ];
                    return [
                        4 /*yield*/ ,
                        Promise.all(items.map($ff104351264256f9$var$toFilePromises))
                    ];
                case 1:
                    files = _a.sent();
                    return [
                        2 /*return*/ ,
                        $ff104351264256f9$var$noIgnoredFiles($ff104351264256f9$var$flatten(files))
                    ];
                case 2:
                    return [
                        2 /*return*/ ,
                        $ff104351264256f9$var$noIgnoredFiles($ff104351264256f9$var$fromList(dt.files).map(function(file) {
                            return (0, $b8b2660e8a7441e1$export$8cc09085015f0dc7)(file);
                        }))
                    ];
            }
        });
    });
}
function $ff104351264256f9$var$noIgnoredFiles(files) {
    return files.filter(function(file) {
        return $ff104351264256f9$var$FILES_TO_IGNORE.indexOf(file.name) === -1;
    });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function $ff104351264256f9$var$fromList(items) {
    if (items === null) return [];
    var files = [];
    // tslint:disable: prefer-for-of
    for(var i = 0; i < items.length; i++){
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function $ff104351264256f9$var$toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== "function") return $ff104351264256f9$var$fromDataTransferItem(item);
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) return $ff104351264256f9$var$fromDirEntry(entry);
    return $ff104351264256f9$var$fromDataTransferItem(item);
}
function $ff104351264256f9$var$flatten(items) {
    return items.reduce(function(acc, files) {
        return (0, $daba873e9b04cf8c$export$1216008129fb82ed)((0, $daba873e9b04cf8c$export$1216008129fb82ed)([], (0, $daba873e9b04cf8c$export$8d051b38c9118094)(acc), false), (0, $daba873e9b04cf8c$export$8d051b38c9118094)(Array.isArray(files) ? $ff104351264256f9$var$flatten(files) : [
            files
        ]), false);
    }, []);
}
function $ff104351264256f9$var$fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) return Promise.reject("".concat(item, " is not a File"));
    var fwp = (0, $b8b2660e8a7441e1$export$8cc09085015f0dc7)(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function $ff104351264256f9$var$fromEntry(entry) {
    return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                entry.isDirectory ? $ff104351264256f9$var$fromDirEntry(entry) : $ff104351264256f9$var$fromFileEntry(entry)
            ];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function $ff104351264256f9$var$fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function(resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function(batch) {
                return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(_this, void 0, void 0, function() {
                    var files, err_1, items;
                    return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
                        switch(_a.label){
                            case 0:
                                if (!!batch.length) return [
                                    3 /*break*/ ,
                                    5
                                ];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4 /*yield*/ ,
                                    Promise.all(entries)
                                ];
                            case 2:
                                files = _a.sent();
                                resolve(files);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 3:
                                err_1 = _a.sent();
                                reject(err_1);
                                return [
                                    3 /*break*/ ,
                                    4
                                ];
                            case 4:
                                return [
                                    3 /*break*/ ,
                                    6
                                ];
                            case 5:
                                items = Promise.all(batch.map($ff104351264256f9$var$fromEntry));
                                entries.push(items);
                                // Continue reading
                                readEntries();
                                _a.label = 6;
                            case 6:
                                return [
                                    2 /*return*/ 
                                ];
                        }
                    });
                });
            }, function(err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function $ff104351264256f9$var$fromFileEntry(entry) {
    return (0, $daba873e9b04cf8c$export$1050f835b63b671e)(this, void 0, void 0, function() {
        return (0, $daba873e9b04cf8c$export$67ebef60e6f28a6)(this, function(_a) {
            return [
                2 /*return*/ ,
                new Promise(function(resolve, reject) {
                    entry.file(function(file) {
                        var fwp = (0, $b8b2660e8a7441e1$export$8cc09085015f0dc7)(file, entry.fullPath);
                        resolve(fwp);
                    }, function(err) {
                        reject(err);
                    });
                })
            ];
        });
    });
}




var $0fead8f492c9d94c$export$1e511d4a378977f5;
var $0fead8f492c9d94c$export$2e2bcd8739ae039;
"use strict";
$0fead8f492c9d94c$export$1e511d4a378977f5 = true;
$0fead8f492c9d94c$export$2e2bcd8739ae039 = function(file, acceptedFiles) {
    if (file && acceptedFiles) {
        var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(",");
        var fileName = file.name || "";
        var mimeType = (file.type || "").toLowerCase();
        var baseMimeType = mimeType.replace(/\/.*$/, "");
        return acceptedFilesArray.some(function(type) {
            var validType = type.trim().toLowerCase();
            if (validType.charAt(0) === ".") return fileName.toLowerCase().endsWith(validType);
            else if (validType.endsWith("/*")) // This is something like a image/* mime type
            return baseMimeType === validType.replace(/\/.*$/, "");
            return mimeType === validType;
        });
    }
    return true;
};


function $f9ca58ad191b67dc$var$_toConsumableArray(arr) {
    return $f9ca58ad191b67dc$var$_arrayWithoutHoles(arr) || $f9ca58ad191b67dc$var$_iterableToArray(arr) || $f9ca58ad191b67dc$var$_unsupportedIterableToArray(arr) || $f9ca58ad191b67dc$var$_nonIterableSpread();
}
function $f9ca58ad191b67dc$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f9ca58ad191b67dc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $f9ca58ad191b67dc$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $f9ca58ad191b67dc$var$_arrayLikeToArray(arr);
}
function $f9ca58ad191b67dc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f9ca58ad191b67dc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f9ca58ad191b67dc$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f9ca58ad191b67dc$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f9ca58ad191b67dc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f9ca58ad191b67dc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f9ca58ad191b67dc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f9ca58ad191b67dc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f9ca58ad191b67dc$var$_typeof(obj);
}
function $f9ca58ad191b67dc$var$_slicedToArray(arr, i) {
    return $f9ca58ad191b67dc$var$_arrayWithHoles(arr) || $f9ca58ad191b67dc$var$_iterableToArrayLimit(arr, i) || $f9ca58ad191b67dc$var$_unsupportedIterableToArray(arr, i) || $f9ca58ad191b67dc$var$_nonIterableRest();
}
function $f9ca58ad191b67dc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $f9ca58ad191b67dc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $f9ca58ad191b67dc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $f9ca58ad191b67dc$var$_arrayLikeToArray(o, minLen);
}
function $f9ca58ad191b67dc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $f9ca58ad191b67dc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $f9ca58ad191b67dc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $f9ca58ad191b67dc$export$d2c35cc369247232 = "file-invalid-type";
var $f9ca58ad191b67dc$export$d7bd1185abe1e87c = "file-too-large";
var $f9ca58ad191b67dc$export$8bd5ec6ed990dc9 = "file-too-small";
var $f9ca58ad191b67dc$export$3271ef1d2dd155f9 = "too-many-files";
var $f9ca58ad191b67dc$export$d4e71bc0b80dc0fb = {
    FileInvalidType: $f9ca58ad191b67dc$export$d2c35cc369247232,
    FileTooLarge: $f9ca58ad191b67dc$export$d7bd1185abe1e87c,
    FileTooSmall: $f9ca58ad191b67dc$export$8bd5ec6ed990dc9,
    TooManyFiles: $f9ca58ad191b67dc$export$3271ef1d2dd155f9
}; // File Errors
var $f9ca58ad191b67dc$export$bc0bbda045f09b5a = function getInvalidTypeRejectionErr(accept) {
    accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
    var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(", ")) : accept;
    return {
        code: $f9ca58ad191b67dc$export$d2c35cc369247232,
        message: "File type must be ".concat(messageSuffix)
    };
};
var $f9ca58ad191b67dc$export$b70c322af07b9d49 = function getTooLargeRejectionErr(maxSize) {
    return {
        code: $f9ca58ad191b67dc$export$d7bd1185abe1e87c,
        message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? "byte" : "bytes")
    };
};
var $f9ca58ad191b67dc$export$d61cfd6dff5a3e22 = function getTooSmallRejectionErr(minSize) {
    return {
        code: $f9ca58ad191b67dc$export$8bd5ec6ed990dc9,
        message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? "byte" : "bytes")
    };
};
var $f9ca58ad191b67dc$export$1e1e1b6120329fe = {
    code: $f9ca58ad191b67dc$export$3271ef1d2dd155f9,
    message: "Too many files"
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
function $f9ca58ad191b67dc$export$b511db3632effe58(file, accept) {
    var isAcceptable = file.type === "application/x-moz-file" || (0, $0fead8f492c9d94c$export$2e2bcd8739ae039)(file, accept);
    return [
        isAcceptable,
        isAcceptable ? null : $f9ca58ad191b67dc$export$bc0bbda045f09b5a(accept)
    ];
}
function $f9ca58ad191b67dc$export$860631d45ba43fd9(file, minSize, maxSize) {
    if ($f9ca58ad191b67dc$var$isDefined(file.size)) {
        if ($f9ca58ad191b67dc$var$isDefined(minSize) && $f9ca58ad191b67dc$var$isDefined(maxSize)) {
            if (file.size > maxSize) return [
                false,
                $f9ca58ad191b67dc$export$b70c322af07b9d49(maxSize)
            ];
            if (file.size < minSize) return [
                false,
                $f9ca58ad191b67dc$export$d61cfd6dff5a3e22(minSize)
            ];
        } else if ($f9ca58ad191b67dc$var$isDefined(minSize) && file.size < minSize) return [
            false,
            $f9ca58ad191b67dc$export$d61cfd6dff5a3e22(minSize)
        ];
        else if ($f9ca58ad191b67dc$var$isDefined(maxSize) && file.size > maxSize) return [
            false,
            $f9ca58ad191b67dc$export$b70c322af07b9d49(maxSize)
        ];
    }
    return [
        true,
        null
    ];
}
function $f9ca58ad191b67dc$var$isDefined(value) {
    return value !== undefined && value !== null;
}
function $f9ca58ad191b67dc$export$6a0bb4322c81a197(_ref) {
    var files = _ref.files, accept = _ref.accept, minSize = _ref.minSize, maxSize = _ref.maxSize, multiple = _ref.multiple, maxFiles = _ref.maxFiles, validator = _ref.validator;
    if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) return false;
    return files.every(function(file) {
        var _fileAccepted = $f9ca58ad191b67dc$export$b511db3632effe58(file, accept), _fileAccepted2 = $f9ca58ad191b67dc$var$_slicedToArray(_fileAccepted, 1), accepted = _fileAccepted2[0];
        var _fileMatchSize = $f9ca58ad191b67dc$export$860631d45ba43fd9(file, minSize, maxSize), _fileMatchSize2 = $f9ca58ad191b67dc$var$_slicedToArray(_fileMatchSize, 1), sizeMatch = _fileMatchSize2[0];
        var customErrors = validator ? validator(file) : null;
        return accepted && sizeMatch && !customErrors;
    });
} // React's synthetic events has event.isPropagationStopped,
function $f9ca58ad191b67dc$export$8d6d6472146de265(event) {
    if (typeof event.isPropagationStopped === "function") return event.isPropagationStopped();
    else if (typeof event.cancelBubble !== "undefined") return event.cancelBubble;
    return false;
}
function $f9ca58ad191b67dc$export$52f1fc875a1e5986(event) {
    if (!event.dataTransfer) return !!event.target && !!event.target.files;
     // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
    // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file
    return Array.prototype.some.call(event.dataTransfer.types, function(type) {
        return type === "Files" || type === "application/x-moz-file";
    });
}
function $f9ca58ad191b67dc$export$f9006bf02b243736(item) {
    return $f9ca58ad191b67dc$var$_typeof(item) === "object" && item !== null && item.kind === "file";
} // allow the entire document to be a drag target
function $f9ca58ad191b67dc$export$2ead263d6635cecc(event) {
    event.preventDefault();
}
function $f9ca58ad191b67dc$var$isIe(userAgent) {
    return userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1;
}
function $f9ca58ad191b67dc$var$isEdge(userAgent) {
    return userAgent.indexOf("Edge/") !== -1;
}
function $f9ca58ad191b67dc$export$d3498e653911f962() {
    var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
    return $f9ca58ad191b67dc$var$isIe(userAgent) || $f9ca58ad191b67dc$var$isEdge(userAgent);
}
function $f9ca58ad191b67dc$export$b9ecd428b558ff10() {
    for(var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++)fns[_key] = arguments[_key];
    return function(event) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        return fns.some(function(fn) {
            if (!$f9ca58ad191b67dc$export$8d6d6472146de265(event) && fn) fn.apply(void 0, [
                event
            ].concat(args));
            return $f9ca58ad191b67dc$export$8d6d6472146de265(event);
        });
    };
}
function $f9ca58ad191b67dc$export$858af2af50e1eaf8() {
    return "showOpenFilePicker" in window;
}
function $f9ca58ad191b67dc$export$8ce4bd13c494743e(accept) {
    if ($f9ca58ad191b67dc$var$isDefined(accept)) {
        var acceptForPicker = Object.entries(accept).filter(function(_ref2) {
            var _ref3 = $f9ca58ad191b67dc$var$_slicedToArray(_ref2, 2), mimeType = _ref3[0], ext = _ref3[1];
            var ok = true;
            if (!$f9ca58ad191b67dc$export$69c8ec3250e1cfbf(mimeType)) {
                console.warn('Skipped "'.concat(mimeType, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.'));
                ok = false;
            }
            if (!Array.isArray(ext) || !ext.every($f9ca58ad191b67dc$export$42c2be5a6d408120)) {
                console.warn('Skipped "'.concat(mimeType, '" because an invalid file extension was provided.'));
                ok = false;
            }
            return ok;
        }).reduce(function(agg, _ref4) {
            var _ref5 = $f9ca58ad191b67dc$var$_slicedToArray(_ref4, 2), mimeType = _ref5[0], ext = _ref5[1];
            return $f9ca58ad191b67dc$var$_objectSpread($f9ca58ad191b67dc$var$_objectSpread({}, agg), {}, $f9ca58ad191b67dc$var$_defineProperty({}, mimeType, ext));
        }, {});
        return [
            {
                // description is required due to https://crbug.com/1264708
                description: "Files",
                accept: acceptForPicker
            }
        ];
    }
    return accept;
}
function $f9ca58ad191b67dc$export$1278288bcefb97b9(accept) {
    if ($f9ca58ad191b67dc$var$isDefined(accept)) return Object.entries(accept).reduce(function(a, _ref6) {
        var _ref7 = $f9ca58ad191b67dc$var$_slicedToArray(_ref6, 2), mimeType = _ref7[0], ext = _ref7[1];
        return [].concat($f9ca58ad191b67dc$var$_toConsumableArray(a), [
            mimeType
        ], $f9ca58ad191b67dc$var$_toConsumableArray(ext));
    }, []) // Silently discard invalid entries as pickerOptionsFromAccept warns about these
    .filter(function(v) {
        return $f9ca58ad191b67dc$export$69c8ec3250e1cfbf(v) || $f9ca58ad191b67dc$export$42c2be5a6d408120(v);
    }).join(",");
    return undefined;
}
function $f9ca58ad191b67dc$export$72580c77a176a18f(v) {
    return v instanceof DOMException && (v.name === "AbortError" || v.code === v.ABORT_ERR);
}
function $f9ca58ad191b67dc$export$c4f82d4432e209a9(v) {
    return v instanceof DOMException && (v.name === "SecurityError" || v.code === v.SECURITY_ERR);
}
function $f9ca58ad191b67dc$export$69c8ec3250e1cfbf(v) {
    return v === "audio/*" || v === "video/*" || v === "image/*" || v === "text/*" || /\w+\/[-+.\w]+/g.test(v);
}
function $f9ca58ad191b67dc$export$42c2be5a6d408120(v) {
    return /^.*\.[\w]+$/.test(v);
} /**
 * @typedef {Object.<string, string[]>} AcceptProp
 */  /**
 * @typedef {object} FileError
 * @property {string} message
 * @property {ErrorCode|string} code
 */  /**
 * @typedef {"file-invalid-type"|"file-too-large"|"file-too-small"|"too-many-files"} ErrorCode
 */ 



var $cec36242392bfbb2$var$_excluded = [
    "children"
], $cec36242392bfbb2$var$_excluded2 = [
    "open"
], $cec36242392bfbb2$var$_excluded3 = [
    "refKey",
    "role",
    "onKeyDown",
    "onFocus",
    "onBlur",
    "onClick",
    "onDragEnter",
    "onDragOver",
    "onDragLeave",
    "onDrop"
], $cec36242392bfbb2$var$_excluded4 = [
    "refKey",
    "onChange",
    "onClick"
];
function $cec36242392bfbb2$var$_toConsumableArray(arr) {
    return $cec36242392bfbb2$var$_arrayWithoutHoles(arr) || $cec36242392bfbb2$var$_iterableToArray(arr) || $cec36242392bfbb2$var$_unsupportedIterableToArray(arr) || $cec36242392bfbb2$var$_nonIterableSpread();
}
function $cec36242392bfbb2$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cec36242392bfbb2$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $cec36242392bfbb2$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $cec36242392bfbb2$var$_arrayLikeToArray(arr);
}
function $cec36242392bfbb2$var$_slicedToArray(arr, i) {
    return $cec36242392bfbb2$var$_arrayWithHoles(arr) || $cec36242392bfbb2$var$_iterableToArrayLimit(arr, i) || $cec36242392bfbb2$var$_unsupportedIterableToArray(arr, i) || $cec36242392bfbb2$var$_nonIterableRest();
}
function $cec36242392bfbb2$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $cec36242392bfbb2$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $cec36242392bfbb2$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $cec36242392bfbb2$var$_arrayLikeToArray(o, minLen);
}
function $cec36242392bfbb2$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $cec36242392bfbb2$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $cec36242392bfbb2$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $cec36242392bfbb2$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cec36242392bfbb2$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $cec36242392bfbb2$var$ownKeys(Object(source), !0).forEach(function(key) {
            $cec36242392bfbb2$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $cec36242392bfbb2$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cec36242392bfbb2$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cec36242392bfbb2$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cec36242392bfbb2$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cec36242392bfbb2$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */ var $cec36242392bfbb2$var$Dropzone = /*#__PURE__*/ (0, $eCoWV.forwardRef)(function(_ref, ref) {
    var children = _ref.children, params = $cec36242392bfbb2$var$_objectWithoutProperties(_ref, $cec36242392bfbb2$var$_excluded);
    var _useDropzone = $cec36242392bfbb2$export$cd49c0ecc5be9f36(params), open = _useDropzone.open, props = $cec36242392bfbb2$var$_objectWithoutProperties(_useDropzone, $cec36242392bfbb2$var$_excluded2);
    (0, $eCoWV.useImperativeHandle)(ref, function() {
        return {
            open: open
        };
    }, [
        open
    ]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $eCoWV.Fragment), null, children($cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, props), {}, {
        open: open
    })));
});
$cec36242392bfbb2$var$Dropzone.displayName = "Dropzone"; // Add default props for react-docgen
var $cec36242392bfbb2$var$defaultProps = {
    disabled: false,
    getFilesFromEvent: (0, $ff104351264256f9$export$a36e16046ae8f1bb),
    maxSize: Infinity,
    minSize: 0,
    multiple: true,
    maxFiles: 0,
    preventDropOnDocument: true,
    noClick: false,
    noKeyboard: false,
    noDrag: false,
    noDragEventsBubbling: false,
    validator: null,
    useFsAccessApi: true,
    autoFocus: false
};
$cec36242392bfbb2$var$Dropzone.defaultProps = $cec36242392bfbb2$var$defaultProps;
$cec36242392bfbb2$var$Dropzone.propTypes = {
    /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */ children: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */ accept: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).objectOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string)),
    /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */ multiple: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * If false, allow dropped items to take over the current browser window
   */ preventDropOnDocument: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * If true, disables click to open the native file selection dialog
   */ noClick: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */ noKeyboard: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * If true, disables drag 'n' drop
   */ noDrag: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * If true, stops drag event propagation to parents
   */ noDragEventsBubbling: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * Minimum file size (in bytes)
   */ minSize: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    /**
   * Maximum file size (in bytes)
   */ maxSize: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */ maxFiles: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    /**
   * Enable/disable the dropzone
   */ disabled: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ getFilesFromEvent: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when closing the file dialog with no selection
   */ onFileDialogCancel: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when opening the file dialog
   */ onFileDialogOpen: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */ useFsAccessApi: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * Set to true to focus the root element on render
   */ autoFocus: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */ onDragEnter: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */ onDragLeave: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */ onDragOver: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */ onDrop: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */ onDropAccepted: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */ onDropRejected: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */ onError: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */ validator: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
};
var $cec36242392bfbb2$export$2e2bcd8739ae039 = $cec36242392bfbb2$var$Dropzone;
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */ /**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */ /**
 * An object with the current dropzone state.
 *
 * @typedef {object} DropzoneState
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */ /**
 * An object with the dropzone methods.
 *
 * @typedef {object} DropzoneMethods
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 */ var $cec36242392bfbb2$var$initialState = {
    isFocused: false,
    isFileDialogActive: false,
    isDragActive: false,
    isDragAccept: false,
    isDragReject: false,
    acceptedFiles: [],
    fileRejections: []
};
function $cec36242392bfbb2$export$cd49c0ecc5be9f36() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _defaultProps$props = $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, $cec36242392bfbb2$var$defaultProps), props), accept = _defaultProps$props.accept, disabled = _defaultProps$props.disabled, getFilesFromEvent = _defaultProps$props.getFilesFromEvent, maxSize = _defaultProps$props.maxSize, minSize = _defaultProps$props.minSize, multiple = _defaultProps$props.multiple, maxFiles = _defaultProps$props.maxFiles, onDragEnter = _defaultProps$props.onDragEnter, onDragLeave = _defaultProps$props.onDragLeave, onDragOver = _defaultProps$props.onDragOver, onDrop = _defaultProps$props.onDrop, onDropAccepted = _defaultProps$props.onDropAccepted, onDropRejected = _defaultProps$props.onDropRejected, onFileDialogCancel = _defaultProps$props.onFileDialogCancel, onFileDialogOpen = _defaultProps$props.onFileDialogOpen, useFsAccessApi = _defaultProps$props.useFsAccessApi, autoFocus = _defaultProps$props.autoFocus, preventDropOnDocument = _defaultProps$props.preventDropOnDocument, noClick = _defaultProps$props.noClick, noKeyboard = _defaultProps$props.noKeyboard, noDrag = _defaultProps$props.noDrag, noDragEventsBubbling = _defaultProps$props.noDragEventsBubbling, onError = _defaultProps$props.onError, validator = _defaultProps$props.validator;
    var acceptAttr = (0, $eCoWV.useMemo)(function() {
        return (0, $f9ca58ad191b67dc$export$1278288bcefb97b9)(accept);
    }, [
        accept
    ]);
    var pickerTypes = (0, $eCoWV.useMemo)(function() {
        return (0, $f9ca58ad191b67dc$export$8ce4bd13c494743e)(accept);
    }, [
        accept
    ]);
    var onFileDialogOpenCb = (0, $eCoWV.useMemo)(function() {
        return typeof onFileDialogOpen === "function" ? onFileDialogOpen : $cec36242392bfbb2$var$noop;
    }, [
        onFileDialogOpen
    ]);
    var onFileDialogCancelCb = (0, $eCoWV.useMemo)(function() {
        return typeof onFileDialogCancel === "function" ? onFileDialogCancel : $cec36242392bfbb2$var$noop;
    }, [
        onFileDialogCancel
    ]);
    /**
   * @constant
   * @type {React.MutableRefObject<HTMLElement>}
   */ var rootRef = (0, $eCoWV.useRef)(null);
    var inputRef = (0, $eCoWV.useRef)(null);
    var _useReducer = (0, $eCoWV.useReducer)($cec36242392bfbb2$var$reducer, $cec36242392bfbb2$var$initialState), _useReducer2 = $cec36242392bfbb2$var$_slicedToArray(_useReducer, 2), state = _useReducer2[0], dispatch = _useReducer2[1];
    var isFocused = state.isFocused, isFileDialogActive = state.isFileDialogActive;
    var fsAccessApiWorksRef = (0, $eCoWV.useRef)(typeof window !== "undefined" && window.isSecureContext && useFsAccessApi && (0, $f9ca58ad191b67dc$export$858af2af50e1eaf8)()); // Update file dialog active state when the window is focused on
    var onWindowFocus = function onWindowFocus() {
        // Execute the timeout only if the file dialog is opened in the browser
        if (!fsAccessApiWorksRef.current && isFileDialogActive) setTimeout(function() {
            if (inputRef.current) {
                var files = inputRef.current.files;
                if (!files.length) {
                    dispatch({
                        type: "closeDialog"
                    });
                    onFileDialogCancelCb();
                }
            }
        }, 300);
    };
    (0, $eCoWV.useEffect)(function() {
        window.addEventListener("focus", onWindowFocus, false);
        return function() {
            window.removeEventListener("focus", onWindowFocus, false);
        };
    }, [
        inputRef,
        isFileDialogActive,
        onFileDialogCancelCb,
        fsAccessApiWorksRef
    ]);
    var dragTargetsRef = (0, $eCoWV.useRef)([]);
    var onDocumentDrop = function onDocumentDrop(event) {
        if (rootRef.current && rootRef.current.contains(event.target)) // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
        return;
        event.preventDefault();
        dragTargetsRef.current = [];
    };
    (0, $eCoWV.useEffect)(function() {
        if (preventDropOnDocument) {
            document.addEventListener("dragover", (0, $f9ca58ad191b67dc$export$2ead263d6635cecc), false);
            document.addEventListener("drop", onDocumentDrop, false);
        }
        return function() {
            if (preventDropOnDocument) {
                document.removeEventListener("dragover", (0, $f9ca58ad191b67dc$export$2ead263d6635cecc));
                document.removeEventListener("drop", onDocumentDrop);
            }
        };
    }, [
        rootRef,
        preventDropOnDocument
    ]); // Auto focus the root when autoFocus is true
    (0, $eCoWV.useEffect)(function() {
        if (!disabled && autoFocus && rootRef.current) rootRef.current.focus();
        return function() {};
    }, [
        rootRef,
        autoFocus,
        disabled
    ]);
    var onErrCb = (0, $eCoWV.useCallback)(function(e) {
        if (onError) onError(e);
        else // Let the user know something's gone wrong if they haven't provided the onError cb.
        console.error(e);
    }, [
        onError
    ]);
    var onDragEnterCb = (0, $eCoWV.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [].concat($cec36242392bfbb2$var$_toConsumableArray(dragTargetsRef.current), [
            event.target
        ]);
        if ((0, $f9ca58ad191b67dc$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $f9ca58ad191b67dc$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            var fileCount = files.length;
            var isDragAccept = fileCount > 0 && (0, $f9ca58ad191b67dc$export$6a0bb4322c81a197)({
                files: files,
                accept: acceptAttr,
                minSize: minSize,
                maxSize: maxSize,
                multiple: multiple,
                maxFiles: maxFiles,
                validator: validator
            });
            var isDragReject = fileCount > 0 && !isDragAccept;
            dispatch({
                isDragAccept: isDragAccept,
                isDragReject: isDragReject,
                isDragActive: true,
                type: "setDraggedFiles"
            });
            if (onDragEnter) onDragEnter(event);
        }).catch(function(e) {
            return onErrCb(e);
        });
    }, [
        getFilesFromEvent,
        onDragEnter,
        onErrCb,
        noDragEventsBubbling,
        acceptAttr,
        minSize,
        maxSize,
        multiple,
        maxFiles,
        validator
    ]);
    var onDragOverCb = (0, $eCoWV.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event);
        var hasFiles = (0, $f9ca58ad191b67dc$export$52f1fc875a1e5986)(event);
        if (hasFiles && event.dataTransfer) try {
            event.dataTransfer.dropEffect = "copy";
        } catch (_unused) {}
        if (hasFiles && onDragOver) onDragOver(event);
        return false;
    }, [
        onDragOver,
        noDragEventsBubbling
    ]);
    var onDragLeaveCb = (0, $eCoWV.useCallback)(function(event) {
        event.preventDefault();
        event.persist();
        stopPropagation(event); // Only deactivate once the dropzone and all children have been left
        var targets = dragTargetsRef.current.filter(function(target) {
            return rootRef.current && rootRef.current.contains(target);
        }); // Make sure to remove a target present multiple times only once
        // (Firefox may fire dragenter/dragleave multiple times on the same element)
        var targetIdx = targets.indexOf(event.target);
        if (targetIdx !== -1) targets.splice(targetIdx, 1);
        dragTargetsRef.current = targets;
        if (targets.length > 0) return;
        dispatch({
            type: "setDraggedFiles",
            isDragActive: false,
            isDragAccept: false,
            isDragReject: false
        });
        if ((0, $f9ca58ad191b67dc$export$52f1fc875a1e5986)(event) && onDragLeave) onDragLeave(event);
    }, [
        rootRef,
        onDragLeave,
        noDragEventsBubbling
    ]);
    var setFiles = (0, $eCoWV.useCallback)(function(files, event) {
        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function(file) {
            var _fileAccepted = (0, $f9ca58ad191b67dc$export$b511db3632effe58)(file, acceptAttr), _fileAccepted2 = $cec36242392bfbb2$var$_slicedToArray(_fileAccepted, 2), accepted = _fileAccepted2[0], acceptError = _fileAccepted2[1];
            var _fileMatchSize = (0, $f9ca58ad191b67dc$export$860631d45ba43fd9)(file, minSize, maxSize), _fileMatchSize2 = $cec36242392bfbb2$var$_slicedToArray(_fileMatchSize, 2), sizeMatch = _fileMatchSize2[0], sizeError = _fileMatchSize2[1];
            var customErrors = validator ? validator(file) : null;
            if (accepted && sizeMatch && !customErrors) acceptedFiles.push(file);
            else {
                var errors = [
                    acceptError,
                    sizeError
                ];
                if (customErrors) errors = errors.concat(customErrors);
                fileRejections.push({
                    file: file,
                    errors: errors.filter(function(e) {
                        return e;
                    })
                });
            }
        });
        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
            // Reject everything and empty accepted files
            acceptedFiles.forEach(function(file) {
                fileRejections.push({
                    file: file,
                    errors: [
                        (0, $f9ca58ad191b67dc$export$1e1e1b6120329fe)
                    ]
                });
            });
            acceptedFiles.splice(0);
        }
        dispatch({
            acceptedFiles: acceptedFiles,
            fileRejections: fileRejections,
            type: "setFiles"
        });
        if (onDrop) onDrop(acceptedFiles, fileRejections, event);
        if (fileRejections.length > 0 && onDropRejected) onDropRejected(fileRejections, event);
        if (acceptedFiles.length > 0 && onDropAccepted) onDropAccepted(acceptedFiles, event);
    }, [
        dispatch,
        multiple,
        acceptAttr,
        minSize,
        maxSize,
        maxFiles,
        onDrop,
        onDropAccepted,
        onDropRejected,
        validator
    ]);
    var onDropCb = (0, $eCoWV.useCallback)(function(event) {
        event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done
        event.persist();
        stopPropagation(event);
        dragTargetsRef.current = [];
        if ((0, $f9ca58ad191b67dc$export$52f1fc875a1e5986)(event)) Promise.resolve(getFilesFromEvent(event)).then(function(files) {
            if ((0, $f9ca58ad191b67dc$export$8d6d6472146de265)(event) && !noDragEventsBubbling) return;
            setFiles(files, event);
        }).catch(function(e) {
            return onErrCb(e);
        });
        dispatch({
            type: "reset"
        });
    }, [
        getFilesFromEvent,
        setFiles,
        onErrCb,
        noDragEventsBubbling
    ]); // Fn for opening the file dialog programmatically
    var openFileDialog = (0, $eCoWV.useCallback)(function() {
        // No point to use FS access APIs if context is not secure
        // https://developer.mozilla.org/en-US/docs/Web/Security/Secure_Contexts#feature_detection
        if (fsAccessApiWorksRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
            var opts = {
                multiple: multiple,
                types: pickerTypes
            };
            window.showOpenFilePicker(opts).then(function(handles) {
                return getFilesFromEvent(handles);
            }).then(function(files) {
                setFiles(files, null);
                dispatch({
                    type: "closeDialog"
                });
            }).catch(function(e) {
                // AbortError means the user canceled
                if ((0, $f9ca58ad191b67dc$export$72580c77a176a18f)(e)) {
                    onFileDialogCancelCb(e);
                    dispatch({
                        type: "closeDialog"
                    });
                } else if ((0, $f9ca58ad191b67dc$export$c4f82d4432e209a9)(e)) {
                    fsAccessApiWorksRef.current = false; // CORS, so cannot use this API
                    // Try using the input
                    if (inputRef.current) {
                        inputRef.current.value = null;
                        inputRef.current.click();
                    } else onErrCb(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."));
                } else onErrCb(e);
            });
            return;
        }
        if (inputRef.current) {
            dispatch({
                type: "openDialog"
            });
            onFileDialogOpenCb();
            inputRef.current.value = null;
            inputRef.current.click();
        }
    }, [
        dispatch,
        onFileDialogOpenCb,
        onFileDialogCancelCb,
        useFsAccessApi,
        setFiles,
        onErrCb,
        pickerTypes,
        multiple
    ]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone
    var onKeyDownCb = (0, $eCoWV.useCallback)(function(event) {
        // Ignore keyboard events bubbling up the DOM tree
        if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) return;
        if (event.key === " " || event.key === "Enter" || event.keyCode === 32 || event.keyCode === 13) {
            event.preventDefault();
            openFileDialog();
        }
    }, [
        rootRef,
        openFileDialog
    ]); // Update focus state for the dropzone
    var onFocusCb = (0, $eCoWV.useCallback)(function() {
        dispatch({
            type: "focus"
        });
    }, []);
    var onBlurCb = (0, $eCoWV.useCallback)(function() {
        dispatch({
            type: "blur"
        });
    }, []); // Cb to open the file dialog when click occurs on the dropzone
    var onClickCb = (0, $eCoWV.useCallback)(function() {
        if (noClick) return;
         // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
        // to ensure React can handle state changes
        // See: https://github.com/react-dropzone/react-dropzone/issues/450
        if ((0, $f9ca58ad191b67dc$export$d3498e653911f962)()) setTimeout(openFileDialog, 0);
        else openFileDialog();
    }, [
        noClick,
        openFileDialog
    ]);
    var composeHandler = function composeHandler(fn) {
        return disabled ? null : fn;
    };
    var composeKeyboardHandler = function composeKeyboardHandler(fn) {
        return noKeyboard ? null : composeHandler(fn);
    };
    var composeDragHandler = function composeDragHandler(fn) {
        return noDrag ? null : composeHandler(fn);
    };
    var stopPropagation = function stopPropagation(event) {
        if (noDragEventsBubbling) event.stopPropagation();
    };
    var getRootProps = (0, $eCoWV.useMemo)(function() {
        return function() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref2$refKey = _ref2.refKey, refKey = _ref2$refKey === void 0 ? "ref" : _ref2$refKey, role = _ref2.role, onKeyDown = _ref2.onKeyDown, onFocus = _ref2.onFocus, onBlur = _ref2.onBlur, onClick = _ref2.onClick, onDragEnter = _ref2.onDragEnter, onDragOver = _ref2.onDragOver, onDragLeave = _ref2.onDragLeave, onDrop = _ref2.onDrop, rest = $cec36242392bfbb2$var$_objectWithoutProperties(_ref2, $cec36242392bfbb2$var$_excluded3);
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_defineProperty({
                onKeyDown: composeKeyboardHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onKeyDown, onKeyDownCb)),
                onFocus: composeKeyboardHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onFocus, onFocusCb)),
                onBlur: composeKeyboardHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onBlur, onBlurCb)),
                onClick: composeHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onClick, onClickCb)),
                onDragEnter: composeDragHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onDragEnter, onDragEnterCb)),
                onDragOver: composeDragHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onDragOver, onDragOverCb)),
                onDragLeave: composeDragHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onDragLeave, onDragLeaveCb)),
                onDrop: composeDragHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onDrop, onDropCb)),
                role: typeof role === "string" && role !== "" ? role : "presentation"
            }, refKey, rootRef), !disabled && !noKeyboard ? {
                tabIndex: 0
            } : {}), rest);
        };
    }, [
        rootRef,
        onKeyDownCb,
        onFocusCb,
        onBlurCb,
        onClickCb,
        onDragEnterCb,
        onDragOverCb,
        onDragLeaveCb,
        onDropCb,
        noKeyboard,
        noDrag,
        disabled
    ]);
    var onInputElementClick = (0, $eCoWV.useCallback)(function(event) {
        event.stopPropagation();
    }, []);
    var getInputProps = (0, $eCoWV.useMemo)(function() {
        return function() {
            var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, _ref3$refKey = _ref3.refKey, refKey = _ref3$refKey === void 0 ? "ref" : _ref3$refKey, onChange = _ref3.onChange, onClick = _ref3.onClick, rest = $cec36242392bfbb2$var$_objectWithoutProperties(_ref3, $cec36242392bfbb2$var$_excluded4);
            var inputProps = $cec36242392bfbb2$var$_defineProperty({
                accept: acceptAttr,
                multiple: multiple,
                type: "file",
                style: {
                    display: "none"
                },
                onChange: composeHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onChange, onDropCb)),
                onClick: composeHandler((0, $f9ca58ad191b67dc$export$b9ecd428b558ff10)(onClick, onInputElementClick)),
                tabIndex: -1
            }, refKey, inputRef);
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, inputProps), rest);
        };
    }, [
        inputRef,
        accept,
        multiple,
        onDropCb,
        disabled
    ]);
    return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
        isFocused: isFocused && !disabled,
        getRootProps: getRootProps,
        getInputProps: getInputProps,
        rootRef: rootRef,
        inputRef: inputRef,
        open: composeHandler(openFileDialog)
    });
}
/**
 * @param {DropzoneState} state
 * @param {{type: string} & DropzoneState} action
 * @returns {DropzoneState}
 */ function $cec36242392bfbb2$var$reducer(state, action) {
    /* istanbul ignore next */ switch(action.type){
        case "focus":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
                isFocused: true
            });
        case "blur":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
                isFocused: false
            });
        case "openDialog":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, $cec36242392bfbb2$var$initialState), {}, {
                isFileDialogActive: true
            });
        case "closeDialog":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
                isFileDialogActive: false
            });
        case "setDraggedFiles":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
                isDragActive: action.isDragActive,
                isDragAccept: action.isDragAccept,
                isDragReject: action.isDragReject
            });
        case "setFiles":
            return $cec36242392bfbb2$var$_objectSpread($cec36242392bfbb2$var$_objectSpread({}, state), {}, {
                acceptedFiles: action.acceptedFiles,
                fileRejections: action.fileRejections
            });
        case "reset":
            return $cec36242392bfbb2$var$_objectSpread({}, $cec36242392bfbb2$var$initialState);
        default:
            return state;
    }
}
function $cec36242392bfbb2$var$noop() {}


parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $91f5fed362dbc61d$var$SvgUpload = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m7.258 6.425 1.909-1.917V12.5a.833.833 0 1 0 1.666 0V4.508l1.909 1.917a.834.834 0 0 0 1.365-.271.833.833 0 0 0-.182-.912l-3.333-3.334a.833.833 0 0 0-.275-.175.833.833 0 0 0-.634 0 .833.833 0 0 0-.275.175L6.075 5.242a.837.837 0 0 0 1.183 1.183ZM17.5 11.667a.833.833 0 0 0-.833.833v3.333a.833.833 0 0 1-.834.834H4.167a.834.834 0 0 1-.834-.834V12.5a.833.833 0 0 0-1.666 0v3.333a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V12.5a.833.833 0 0 0-.833-.833Z",
            fill: "currentColor"
        })
    });
var $91f5fed362dbc61d$export$2e2bcd8739ae039 = $91f5fed362dbc61d$var$SvgUpload;



var $2ANSb = parcelRequire("2ANSb");


var $6jNMj = parcelRequire("6jNMj");
var $745ef5188aa23f7c$export$3cd962a22a1283f7;
var $745ef5188aa23f7c$export$9add80a8a1d26c03;
var $745ef5188aa23f7c$export$1ca1ec8b29a4ce27;
var $745ef5188aa23f7c$export$c7187bbd1a7a9244;
var $745ef5188aa23f7c$export$bfd64c937657f93a;
var $745ef5188aa23f7c$export$4a6dd88bada4e7d2;
var $745ef5188aa23f7c$export$7472b0d4ff79ef04;
var $745ef5188aa23f7c$export$478d35d0482051bc;
var $745ef5188aa23f7c$export$68adaa21ca97498a;
$745ef5188aa23f7c$export$3cd962a22a1283f7 = `_7kuApa_actionDescription`;
$745ef5188aa23f7c$export$9add80a8a1d26c03 = `_7kuApa_dragActive`;
$745ef5188aa23f7c$export$1ca1ec8b29a4ce27 = `_7kuApa_icon`;
$745ef5188aa23f7c$export$c7187bbd1a7a9244 = `_7kuApa_placeholder`;
$745ef5188aa23f7c$export$bfd64c937657f93a = `_7kuApa_rotating`;
$745ef5188aa23f7c$export$4a6dd88bada4e7d2 = `_7kuApa_shimmer`;
$745ef5188aa23f7c$export$7472b0d4ff79ef04 = `_7kuApa_uploader`;
$745ef5188aa23f7c$export$478d35d0482051bc = `_7kuApa_uploaderError`;
$745ef5188aa23f7c$export$68adaa21ca97498a = `_7kuApa_uploadingIcon`;


function $d4daf0633a8e87e3$var$FileUploader({ maxSize: maxSize, allowedMimeTypes: allowedMimeTypes, actionDescription: actionDescription, onCompleted: onCompleted, onUploadErrorChange: onUploadErrorChange, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isUploading, setIsUploading] = (0, $eCoWV.useState)(false);
    const [uploadError, setUploadError] = (0, $eCoWV.useState)();
    (0, $eCoWV.useEffect)(()=>{
        onUploadErrorChange(uploadError);
        return ()=>{
            onUploadErrorChange(undefined);
        };
    }, [
        onUploadErrorChange,
        uploadError
    ]);
    const api = (0, $2ANSb.default)();
    const onDrop = (0, $eCoWV.useCallback)(async (acceptedFiles = [], fileRejection = [])=>{
        setUploadError(undefined);
        if (fileRejection.length > 1) {
            setUploadError(t("components.uploader.error_file_count"));
            return;
        }
        const rejectedFile = fileRejection[0]?.file;
        if (rejectedFile) {
            /**
         * Note:
         * We need to display this invalid file type error, since the user can select an invalid file type by modifying the file input dialog settings.
         */ if (!allowedMimeTypes.map(String).includes(rejectedFile.type)) setUploadError(t("components.uploader.error_file_type", {
                extensions: (0, $333675744efe20d0$export$e3d6b5f79f02cd5b)(allowedMimeTypes)
            }));
            return;
        }
        const acceptedFile = acceptedFiles[0];
        if (!acceptedFile) return;
        const fileSizeLimit = Math.min(maxSize, (0, $b63Fl.maxUploadFileSize));
        if (acceptedFile.size > fileSizeLimit) {
            setUploadError(t("components.uploader.error_file_size", {
                size: fileSizeLimit / 1024
            }));
            return;
        }
        const formData = new FormData();
        formData.append("file", acceptedFile);
        try {
            setIsUploading(true);
            const { url: url } = await api.post("api/user-assets", {
                body: formData
            }).json();
            onCompleted(url);
        } catch  {
            setUploadError(t("components.uploader.error_upload"));
        } finally{
            setIsUploading(false);
        }
    }, [
        allowedMimeTypes,
        api,
        maxSize,
        onCompleted,
        t
    ]);
    const { getRootProps: getRootProps, getInputProps: getInputProps, isDragActive: isDragActive } = (0, $cec36242392bfbb2$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        disabled: isUploading,
        multiple: false,
        accept: Object.fromEntries(allowedMimeTypes.map((mimeType)=>[
                mimeType,
                []
            ]))
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ...getRootProps(),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($745ef5188aa23f7c$export$7472b0d4ff79ef04, Boolean(uploadError) && $745ef5188aa23f7c$export$478d35d0482051bc, isDragActive && $745ef5188aa23f7c$export$9add80a8a1d26c03, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                ...getInputProps()
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $745ef5188aa23f7c$export$c7187bbd1a7a9244,
                children: isUploading ? /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {
                            className: $745ef5188aa23f7c$export$68adaa21ca97498a
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $745ef5188aa23f7c$export$3cd962a22a1283f7,
                            children: t("components.uploader.uploading")
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $91f5fed362dbc61d$export$2e2bcd8739ae039), {
                            className: $745ef5188aa23f7c$export$1ca1ec8b29a4ce27
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $745ef5188aa23f7c$export$3cd962a22a1283f7,
                            children: actionDescription ?? t("components.uploader.action_description")
                        })
                    ]
                })
            })
        ]
    });
}
var $d4daf0633a8e87e3$export$2e2bcd8739ae039 = $d4daf0633a8e87e3$var$FileUploader;


var $087a4ac342d17e3a$export$34e0f9847d4c02dd;
var $087a4ac342d17e3a$export$1822828d790e23ee;
var $087a4ac342d17e3a$export$4586892ac4b071a;
var $087a4ac342d17e3a$export$bfd64c937657f93a;
var $087a4ac342d17e3a$export$4a6dd88bada4e7d2;
$087a4ac342d17e3a$export$34e0f9847d4c02dd = `_1lFu6a_container`;
$087a4ac342d17e3a$export$1822828d790e23ee = `_1lFu6a_delete`;
$087a4ac342d17e3a$export$4586892ac4b071a = `_1lFu6a_imageUploader`;
$087a4ac342d17e3a$export$bfd64c937657f93a = `_1lFu6a_rotating`;
$087a4ac342d17e3a$export$4a6dd88bada4e7d2 = `_1lFu6a_shimmer`;


function $2e6f10e5b5e7a477$var$ImageUploader({ name: name, value: value, onDelete: onDelete, allowedMimeTypes: imageMimeTypes, className: className, ...rest }) {
    const { allowedMimeTypes: allowedMimeTypes } = (0, $953ca65e28ae2893$export$2e2bcd8739ae039)(imageMimeTypes);
    return value ? /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($087a4ac342d17e3a$export$4586892ac4b071a, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
                containerClassName: $087a4ac342d17e3a$export$34e0f9847d4c02dd,
                src: value,
                alt: name,
                /**
         * Some social connectors like Google will block the references to its image resource,
         * without specifying the referrerPolicy attribute. Reference:
         * https://stackoverflow.com/questions/40570117/http403-forbidden-error-when-trying-to-load-img-src-with-google-profile-pic
         */ referrerPolicy: "no-referrer"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                className: $087a4ac342d17e3a$export$1822828d790e23ee,
                onClick: ()=>{
                    onDelete();
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
            })
        ]
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d4daf0633a8e87e3$export$2e2bcd8739ae039), {
        allowedMimeTypes: allowedMimeTypes,
        maxSize: (0, $953ca65e28ae2893$export$7b487c2956dcad6),
        className: className,
        ...rest
    });
}
var $2e6f10e5b5e7a477$export$2e2bcd8739ae039 = $2e6f10e5b5e7a477$var$ImageUploader;


var $bd8263be7b104242$export$6d59db4903f20f7d;
var $bd8263be7b104242$export$a3bc9b8ed74fc;
var $bd8263be7b104242$export$bfd64c937657f93a;
var $bd8263be7b104242$export$4a6dd88bada4e7d2;
$bd8263be7b104242$export$6d59db4903f20f7d = `K0z4Jq_description`;
$bd8263be7b104242$export$a3bc9b8ed74fc = `K0z4Jq_error`;
$bd8263be7b104242$export$bfd64c937657f93a = `K0z4Jq_rotating`;
$bd8263be7b104242$export$4a6dd88bada4e7d2 = `K0z4Jq_shimmer`;


function $0186093e59e66ade$var$ImageUploaderField({ onChange: onChange, allowedMimeTypes: mimeTypes, ...rest }) {
    const { allowedMimeTypes: allowedMimeTypes, description: limitDescription } = (0, $953ca65e28ae2893$export$2e2bcd8739ae039)(mimeTypes);
    const [uploadError, setUploadError] = (0, $eCoWV.useState)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e6f10e5b5e7a477$export$2e2bcd8739ae039), {
                allowedMimeTypes: allowedMimeTypes,
                onCompleted: onChange,
                onUploadErrorChange: setUploadError,
                onDelete: ()=>{
                    onChange("");
                },
                ...rest
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($bd8263be7b104242$export$6d59db4903f20f7d, Boolean(uploadError) && $bd8263be7b104242$export$a3bc9b8ed74fc),
                children: uploadError ?? limitDescription
            })
        ]
    });
}
var $0186093e59e66ade$export$2e2bcd8739ae039 = $0186093e59e66ade$var$ImageUploaderField;



var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $iwEyX = parcelRequire("iwEyX");
const $dbff85762e334d27$var$useUserAssetsService = ()=>{
    const { data: data, error: error } = (0, $iwEyX.default)("api/user-assets/service-status");
    return {
        isReady: data?.status === "ready",
        isLoading: !error && !data
    };
};
var $dbff85762e334d27$export$2e2bcd8739ae039 = $dbff85762e334d27$var$useUserAssetsService;



var $9zeGj = parcelRequire("9zeGj");

function $3b942cfeaf20c383$var$CardSelector({ name: name, value: value, options: options, onChange: onChange, optionClassName: optionClassName }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
        type: "compact",
        value: value,
        name: name,
        onChange: onChange,
        children: options.map(({ value: optionValue, title: title, icon: icon })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                icon: icon,
                title: title,
                value: optionValue,
                className: optionClassName
            }, optionValue))
    });
}
var $3b942cfeaf20c383$export$2e2bcd8739ae039 = $3b942cfeaf20c383$var$CardSelector;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $fbeQ6 = parcelRequire("fbeQ6");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $6PcpQ = parcelRequire("6PcpQ");
var $7d01dfcc1050bf3a$export$a7db06668cad9adb;
var $7d01dfcc1050bf3a$export$683472f6198a076e;
var $7d01dfcc1050bf3a$export$1ca1ec8b29a4ce27;
var $7d01dfcc1050bf3a$export$7061c75fc5af8b7e;
var $7d01dfcc1050bf3a$export$bfd64c937657f93a;
var $7d01dfcc1050bf3a$export$d90250155de6d7e7;
var $7d01dfcc1050bf3a$export$4a6dd88bada4e7d2;
var $7d01dfcc1050bf3a$export$2b067c6666111485;
var $7d01dfcc1050bf3a$export$eb0a821c2940f274;
$7d01dfcc1050bf3a$export$a7db06668cad9adb = `RkZH6W_content`;
$7d01dfcc1050bf3a$export$683472f6198a076e = `RkZH6W_disabled`;
$7d01dfcc1050bf3a$export$1ca1ec8b29a4ce27 = `RkZH6W_icon`;
$7d01dfcc1050bf3a$export$7061c75fc5af8b7e = `RkZH6W_item`;
$7d01dfcc1050bf3a$export$bfd64c937657f93a = `RkZH6W_rotating`;
$7d01dfcc1050bf3a$export$d90250155de6d7e7 = `RkZH6W_selected`;
$7d01dfcc1050bf3a$export$4a6dd88bada4e7d2 = `RkZH6W_shimmer`;
$7d01dfcc1050bf3a$export$2b067c6666111485 = `RkZH6W_tag`;
$7d01dfcc1050bf3a$export$eb0a821c2940f274 = `RkZH6W_trailingTag`;


function $16924655449e369e$var$CardItem({ option: { icon: icon, title: title, value: value, tag: tag, trailingTag: trailingTag, isDisabled: isDisabled, disabledTip: disabledTip }, isSelected: isSelected, onClick: onClick, className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
        content: (0, $5CQIb.conditional)(isDisabled && disabledTip && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: disabledTip
        })),
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            role: "button",
            tabIndex: 0,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7d01dfcc1050bf3a$export$7061c75fc5af8b7e, isDisabled && $7d01dfcc1050bf3a$export$683472f6198a076e, isSelected && $7d01dfcc1050bf3a$export$d90250155de6d7e7, className),
            onClick: ()=>{
                if (isDisabled) return;
                onClick(value);
            },
            onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                if (isDisabled) return;
                onClick(value);
            }),
            children: [
                icon && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $7d01dfcc1050bf3a$export$1ca1ec8b29a4ce27,
                    children: icon
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $7d01dfcc1050bf3a$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            children: [
                                typeof title === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: title
                                }) : title,
                                trailingTag && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7d01dfcc1050bf3a$export$2b067c6666111485, $7d01dfcc1050bf3a$export$eb0a821c2940f274),
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                        forKey: trailingTag
                                    })
                                })
                            ]
                        }),
                        tag && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            className: $7d01dfcc1050bf3a$export$2b067c6666111485,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: tag
                            })
                        })
                    ]
                })
            ]
        }, value)
    });
}
var $16924655449e369e$export$2e2bcd8739ae039 = $16924655449e369e$var$CardItem;


var $3f264119b93f151e$export$bfd64c937657f93a;
var $3f264119b93f151e$export$aea217a45095ce11;
var $3f264119b93f151e$export$4a6dd88bada4e7d2;
$3f264119b93f151e$export$bfd64c937657f93a = `-XdXDW_rotating`;
$3f264119b93f151e$export$aea217a45095ce11 = `-XdXDW_selector`;
$3f264119b93f151e$export$4a6dd88bada4e7d2 = `-XdXDW_shimmer`;


function $e8aabd15df5eaa5d$var$MultiCardSelector({ options: options, value: selectedValues, onChange: onChange, isNotAllowEmpty: isNotAllowEmpty = false, className: className, optionClassName: optionClassName }) {
    const onToggle = (value)=>{
        if (selectedValues.includes(value) && selectedValues.length === 1 && isNotAllowEmpty) return;
        onChange(selectedValues.includes(value) ? selectedValues.filter((selected)=>selected !== value) : [
            ...selectedValues,
            value
        ]);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3f264119b93f151e$export$aea217a45095ce11, className),
        children: options.map((option)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $16924655449e369e$export$2e2bcd8739ae039), {
                option: option,
                isSelected: selectedValues.includes(option.value),
                className: optionClassName,
                onClick: onToggle
            }, option.value))
    });
}
var $e8aabd15df5eaa5d$export$2e2bcd8739ae039 = $e8aabd15df5eaa5d$var$MultiCardSelector;





var $907d9471e8250569$export$a7db06668cad9adb;
var $907d9471e8250569$export$8f981dffec84ba52;
var $907d9471e8250569$export$523fb3936f49e028;
var $907d9471e8250569$export$bfd64c937657f93a;
var $907d9471e8250569$export$4a6dd88bada4e7d2;
$907d9471e8250569$export$a7db06668cad9adb = `_3zvtua_content`;
$907d9471e8250569$export$8f981dffec84ba52 = `_3zvtua_contentContainer`;
$907d9471e8250569$export$523fb3936f49e028 = `_3zvtua_page`;
$907d9471e8250569$export$bfd64c937657f93a = `_3zvtua_rotating`;
$907d9471e8250569$export$4a6dd88bada4e7d2 = `_3zvtua_shimmer`;



parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");

const $9d023628a9c0fa6c$export$75332796271f8048 = (page)=>(0, $b9zrd.joinPath)((0, $49a3cd5201e05816$export$329ee42b27a3306e).Onboarding, page);



var $bSFEw = parcelRequire("bSFEw");

var $h7VLF = parcelRequire("h7VLF");

var $4ytKy = parcelRequire("4ytKy");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $fU2Vo = parcelRequire("fU2Vo");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8182c3265146ec1b$var$SvgBulb = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248c.027-.937.371-1.836.976-2.552a6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Z",
                fill: "url(#paint0_linear_1175_2653)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248a4.137 4.137 0 0 1 .976-2.552 6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Zm1.336-5.792a5.704 5.704 0 0 0-1.336 3.392h-1.6v-2.4a.8.8 0 0 0-1.6 0v2.4H9.6a5.2 5.2 0 0 0-1.28-3.328 4.8 4.8 0 0 1 4.823-7.736A4.8 4.8 0 0 1 16.8 10.4a4.711 4.711 0 0 1-1.064 3.008Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1175_2653",
                    x1: 5.6,
                    y1: 12.8,
                    x2: 18.399,
                    y2: 12.8,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#FF930F"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FFF95B"
                        })
                    ]
                })
            })
        ]
    });
var $8182c3265146ec1b$export$2e2bcd8739ae039 = $8182c3265146ec1b$var$SvgBulb;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $5002c49faa265bb6$var$SvgLightBulb = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248a4.136 4.136 0 0 1 .976-2.552 6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Z",
                fill: "url(#paint0_linear_691_82122)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M16.072 5.457a6.4 6.4 0 0 0-5.344-1.328 6.4 6.4 0 0 0-5.016 5.056 6.456 6.456 0 0 0 1.376 5.32c.563.635.886 1.448.912 2.296v2.4a2.4 2.4 0 0 0 2.4 2.4h3.2a2.4 2.4 0 0 0 2.4-2.4v-2.248c.027-.937.371-1.836.976-2.552a6.4 6.4 0 0 0-.904-8.96v.016ZM14.4 19.201a.8.8 0 0 1-.8.8h-3.2a.8.8 0 0 1-.8-.8v-.8h4.8v.8Zm1.336-5.792a5.704 5.704 0 0 0-1.336 3.392h-1.6v-2.4a.8.8 0 0 0-1.6 0v2.4H9.6a5.2 5.2 0 0 0-1.28-3.328 4.8 4.8 0 0 1 4.823-7.736A4.8 4.8 0 0 1 16.8 10.4a4.712 4.712 0 0 1-1.064 3.008Z",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 4.616,
                y: 2.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "rotate(45 4.616 2.202)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 1.3,
                y: 8.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.429,
                y: 8.202,
                width: 3,
                height: 1.5,
                rx: 0.75,
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 11.429,
                y: 3,
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "rotate(-90 11.429 3)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 3,
                height: 1.5,
                rx: 0.75,
                transform: "scale(1 -1) rotate(45 15.636 19.987)",
                fill: "#191C1D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_691_82122",
                    x1: 5.6,
                    y1: 12.8,
                    x2: 18.399,
                    y2: 12.8,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#FF930F"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FFF95B"
                        })
                    ]
                })
            })
        ]
    });
var $5002c49faa265bb6$export$2e2bcd8739ae039 = $5002c49faa265bb6$var$SvgLightBulb;



var $kcPww = parcelRequire("kcPww");

var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");
parcelRequire("6ZMK7");
var $kiVDZ = parcelRequire("kiVDZ");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
const $dc36c1ed9a2dd820$export$48daf4eb8bb4366e = (connectors)=>{
    return connectors.reduce((previous, item)=>{
        const groupIndex = previous.findIndex(// Only group social connectors
        ({ target: target })=>target === item.target && item.type === (0, $fU2Vo.ConnectorType).Social);
        if (groupIndex === -1) return [
            ...previous,
            {
                id: item.id,
                isDemo: item.isDemo,
                name: item.name,
                logo: item.logo,
                logoDark: item.logoDark,
                description: item.description,
                target: item.target,
                type: item.type,
                isStandard: item.isStandard,
                connectors: [
                    item
                ]
            }
        ];
        return previous.map((group, index)=>{
            if (index !== groupIndex) return group;
            return {
                ...group,
                connectors: [
                    ...group.connectors,
                    item
                ]
            };
        });
    }, []);
};
const $dc36c1ed9a2dd820$export$3e690d7c9decfaaa = (markdown)=>{
    const match = /# (.*)/.exec(markdown);
    const title = (match ? match[1] : "") ?? "";
    return {
        title: title,
        content: markdown.replace(title, "")
    };
};


// Group connectors by target
const $00909ead6d3649b8$var$useConnectorGroups = ()=>{
    const { data: data, ...rest } = (0, $2mi28.default)("api/connectors");
    const groups = (0, $eCoWV.useMemo)(()=>{
        if (!data) return;
        return (0, $dc36c1ed9a2dd820$export$48daf4eb8bb4366e)(data);
    }, [
        data
    ]);
    const hasSupportNativePlatformTarget = (0, $eCoWV.useMemo)(()=>groups?.some(({ target: target })=>(0, $kiVDZ.supportNativePlatformTargets).includes(target)) ?? false, [
        groups
    ]);
    return {
        ...rest,
        data: groups,
        connectors: data,
        hasSupportNativePlatformTarget: hasSupportNativePlatformTarget
    };
};
var $00909ead6d3649b8$export$2e2bcd8739ae039 = $00909ead6d3649b8$var$useConnectorGroups;


parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

const $9bd5b2807712a0c9$var$assetsUrl = "https://logtodev.blob.core.windows.net/public-blobs/admin/BY4BCq8GvfBF/2023/03/10";
const $9bd5b2807712a0c9$export$784b3784128e5b8d = {
    color: "#5D34F2",
    identifier: (0, $bd0Y0.SignInIdentifier).Email,
    authentications: [
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
    ]
};
// Email + password sign-up; password sign-in
const $9bd5b2807712a0c9$var$configTemplate1 = {
    logo: `${$9bd5b2807712a0c9$var$assetsUrl}/tVCAHjAB/logo1.png`,
    color: "#19BEFD",
    identifier: (0, $bd0Y0.SignInIdentifier).Email,
    authentications: [
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
    ]
};
// Email + password sign-up; password + code sign-in
const $9bd5b2807712a0c9$var$configTemplate2 = {
    logo: `${$9bd5b2807712a0c9$var$assetsUrl}/IcI0snBP/logo3.png`,
    color: "#FF5449",
    identifier: (0, $bd0Y0.SignInIdentifier).Email,
    authentications: [
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password,
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).VerificationCode
    ]
};
// Email + code sign-up; code sign-in
const $9bd5b2807712a0c9$var$configTemplate3 = {
    logo: `${$9bd5b2807712a0c9$var$assetsUrl}/7UQyvuFc/logo4.png`,
    color: "#CA4E96",
    identifier: (0, $bd0Y0.SignInIdentifier).Email,
    authentications: [
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).VerificationCode
    ]
};
// Username sign-up; password sign-in
const $9bd5b2807712a0c9$var$configTemplate4 = {
    logo: `${$9bd5b2807712a0c9$var$assetsUrl}/uLoMzrlz/logo7.png`,
    color: "#FF5449",
    identifier: (0, $bd0Y0.SignInIdentifier).Username,
    authentications: [
        (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
    ]
};
const $9bd5b2807712a0c9$var$sieConfigTemplates = [
    $9bd5b2807712a0c9$var$configTemplate1,
    $9bd5b2807712a0c9$var$configTemplate2,
    $9bd5b2807712a0c9$var$configTemplate3,
    $9bd5b2807712a0c9$var$configTemplate4
];
const $9bd5b2807712a0c9$export$7bcecdb62ad51612 = (lastTemplateIndex, availableSocialTargets)=>{
    // Get random template
    const randomIndex = Math.floor(Math.random() * $9bd5b2807712a0c9$var$sieConfigTemplates.length);
    const index = randomIndex === lastTemplateIndex ? (randomIndex + 1) % $9bd5b2807712a0c9$var$sieConfigTemplates.length : randomIndex;
    const template = $9bd5b2807712a0c9$var$sieConfigTemplates[index] ?? $9bd5b2807712a0c9$var$configTemplate1;
    // Get 2 or 3 random social targets
    const randomCount = Math.floor(Math.random() * 2) + 2;
    // Take the first randomCount after shuffling.
    const socialTargets = availableSocialTargets.slice().sort(()=>0.5 - Math.random()).slice(0, randomCount);
    return {
        template: {
            ...template,
            socialTargets: socialTargets
        },
        templateIndex: index
    };
};


var $ab3aaa70daf0d0c2$export$2ba01fb71ed41cb6;
var $ab3aaa70daf0d0c2$export$3186f5fc4c1ebb22;
var $ab3aaa70daf0d0c2$export$f373648514ea4dec;
var $ab3aaa70daf0d0c2$export$19721b61a25b4f6d;
var $ab3aaa70daf0d0c2$export$2c9f719e4a309fb5;
var $ab3aaa70daf0d0c2$export$bfd64c937657f93a;
var $ab3aaa70daf0d0c2$export$4a6dd88bada4e7d2;
$ab3aaa70daf0d0c2$export$2ba01fb71ed41cb6 = `V-qgmW_button`;
$ab3aaa70daf0d0c2$export$3186f5fc4c1ebb22 = `V-qgmW_inspire`;
$ab3aaa70daf0d0c2$export$f373648514ea4dec = `V-qgmW_inspireContent`;
$ab3aaa70daf0d0c2$export$19721b61a25b4f6d = `V-qgmW_inspireDescription`;
$ab3aaa70daf0d0c2$export$2c9f719e4a309fb5 = `V-qgmW_inspireTitle`;
$ab3aaa70daf0d0c2$export$bfd64c937657f93a = `V-qgmW_rotating`;
$ab3aaa70daf0d0c2$export$4a6dd88bada4e7d2 = `V-qgmW_shimmer`;


function $345586a436fc807b$var$InspireMe({ onInspired: onInspired }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isButtonHover, setIsButtonHover] = (0, $eCoWV.useState)(false);
    const BulbIcon = isButtonHover ? (0, $5002c49faa265bb6$export$2e2bcd8739ae039) : (0, $8182c3265146ec1b$export$2e2bcd8739ae039);
    const [lastTemplateIndex, setLastTemplateIndex] = (0, $eCoWV.useState)();
    const { data: connectorData, error: error } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    const availableSocialTargets = error ? [] : connectorData?.filter(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Social).map(({ target: target })=>target) ?? [];
    const handleInspire = ()=>{
        const { template: template, templateIndex: templateIndex } = (0, $9bd5b2807712a0c9$export$7bcecdb62ad51612)(lastTemplateIndex, availableSocialTargets);
        setLastTemplateIndex(templateIndex);
        onInspired(template);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $ab3aaa70daf0d0c2$export$3186f5fc4c1ebb22,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $ab3aaa70daf0d0c2$export$f373648514ea4dec,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ab3aaa70daf0d0c2$export$2c9f719e4a309fb5,
                        children: t("cloud.sie.inspire.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ab3aaa70daf0d0c2$export$19721b61a25b4f6d,
                        children: t("cloud.sie.inspire.description")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)(BulbIcon, {}),
                size: "large",
                className: $ab3aaa70daf0d0c2$export$2ba01fb71ed41cb6,
                title: "cloud.sie.inspire.inspire_me",
                onMouseEnter: ()=>{
                    setIsButtonHover(true);
                },
                onMouseLeave: ()=>{
                    setIsButtonHover(false);
                },
                onClick: handleInspire
            })
        ]
    });
}
var $345586a436fc807b$export$2e2bcd8739ae039 = $345586a436fc807b$var$InspireMe;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");
function $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039(required, args) {
    if (args.length < required) throw new TypeError(required + " argument" + (required > 1 ? "s" : "") + " required, but only " + args.length + " present");
}


function $4cc161e39581de1a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $4cc161e39581de1a$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $4cc161e39581de1a$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $4cc161e39581de1a$var$_typeof(obj);
}
function $4cc161e39581de1a$export$2e2bcd8739ae039(value) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    return value instanceof Date || $4cc161e39581de1a$var$_typeof(value) === "object" && Object.prototype.toString.call(value) === "[object Date]";
}



function $acb0b6fd302356fa$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $acb0b6fd302356fa$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $acb0b6fd302356fa$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $acb0b6fd302356fa$var$_typeof(obj);
}
function $acb0b6fd302356fa$export$2e2bcd8739ae039(argument) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var argStr = Object.prototype.toString.call(argument); // Clone the date
    if (argument instanceof Date || $acb0b6fd302356fa$var$_typeof(argument) === "object" && argStr === "[object Date]") // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === "number" || argStr === "[object Number]") return new Date(argument);
    else {
        if ((typeof argument === "string" || argStr === "[object String]") && typeof console !== "undefined") {
            // eslint-disable-next-line no-console
            console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"); // eslint-disable-next-line no-console
            console.warn(new Error().stack);
        }
        return new Date(NaN);
    }
}



function $a6d1b76cdb8a2161$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    if (!(0, $4cc161e39581de1a$export$2e2bcd8739ae039)(dirtyDate) && typeof dirtyDate !== "number") return false;
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    return !isNaN(Number(date));
}


function $9a4c7e4b9e9c5209$export$2e2bcd8739ae039(dirtyNumber) {
    if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) return NaN;
    var number = Number(dirtyNumber);
    if (isNaN(number)) return number;
    return number < 0 ? Math.ceil(number) : Math.floor(number);
}




function $11c1e140ec5e3cdb$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(2, arguments);
    var timestamp = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate).getTime();
    var amount = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)(dirtyAmount);
    return new Date(timestamp + amount);
}




function $a5e717e56c4ef822$export$2e2bcd8739ae039(dirtyDate, dirtyAmount) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(2, arguments);
    var amount = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)(dirtyAmount);
    return (0, $11c1e140ec5e3cdb$export$2e2bcd8739ae039)(dirtyDate, -amount);
}





var $bb3bd5e7c9945a31$var$MILLISECONDS_IN_DAY = 86400000;
function $bb3bd5e7c9945a31$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var timestamp = date.getTime();
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
    var startOfYearTimestamp = date.getTime();
    var difference = timestamp - startOfYearTimestamp;
    return Math.floor(difference / $bb3bd5e7c9945a31$var$MILLISECONDS_IN_DAY) + 1;
}





function $382a716fdc4ae2ce$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var weekStartsOn = 1;
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}





function $62b25514c7231bd1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var fourthOfJanuaryOfNextYear = new Date(0);
    fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $382a716fdc4ae2ce$export$2e2bcd8739ae039)(fourthOfJanuaryOfNextYear);
    var fourthOfJanuaryOfThisYear = new Date(0);
    fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $382a716fdc4ae2ce$export$2e2bcd8739ae039)(fourthOfJanuaryOfThisYear);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}




function $f6cdb9558eccd849$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var year = (0, $62b25514c7231bd1$export$2e2bcd8739ae039)(dirtyDate);
    var fourthOfJanuary = new Date(0);
    fourthOfJanuary.setUTCFullYear(year, 0, 4);
    fourthOfJanuary.setUTCHours(0, 0, 0, 0);
    var date = (0, $382a716fdc4ae2ce$export$2e2bcd8739ae039)(fourthOfJanuary);
    return date;
}



var $e59b5abfb7d0fbf1$var$MILLISECONDS_IN_WEEK = 604800000;
function $e59b5abfb7d0fbf1$export$2e2bcd8739ae039(dirtyDate) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $382a716fdc4ae2ce$export$2e2bcd8739ae039)(date).getTime() - (0, $f6cdb9558eccd849$export$2e2bcd8739ae039)(date).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $e59b5abfb7d0fbf1$var$MILLISECONDS_IN_WEEK) + 1;
}







var $5463c97bdad38feb$var$defaultOptions = {};
function $5463c97bdad38feb$export$430a3269e24b912e() {
    return $5463c97bdad38feb$var$defaultOptions;
}
function $5463c97bdad38feb$export$95365be1b0704abc(newOptions) {
    $5463c97bdad38feb$var$defaultOptions = newOptions;
}


function $c68f9d140ac5ed75$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5463c97bdad38feb$export$430a3269e24b912e)();
    var weekStartsOn = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var day = date.getUTCDay();
    var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    date.setUTCDate(date.getUTCDate() - diff);
    date.setUTCHours(0, 0, 0, 0);
    return date;
}







function $4c47940aefe91a66$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var year = date.getUTCFullYear();
    var defaultOptions = (0, $5463c97bdad38feb$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var firstWeekOfNextYear = new Date(0);
    firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
    var startOfNextYear = (0, $c68f9d140ac5ed75$export$2e2bcd8739ae039)(firstWeekOfNextYear, options);
    var firstWeekOfThisYear = new Date(0);
    firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
    var startOfThisYear = (0, $c68f9d140ac5ed75$export$2e2bcd8739ae039)(firstWeekOfThisYear, options);
    if (date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}






function $45d288cb6c7f6103$export$2e2bcd8739ae039(dirtyDate, options) {
    var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var defaultOptions = (0, $5463c97bdad38feb$export$430a3269e24b912e)();
    var firstWeekContainsDate = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
    var year = (0, $4c47940aefe91a66$export$2e2bcd8739ae039)(dirtyDate, options);
    var firstWeek = new Date(0);
    firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setUTCHours(0, 0, 0, 0);
    var date = (0, $c68f9d140ac5ed75$export$2e2bcd8739ae039)(firstWeek, options);
    return date;
}



var $278b82e1664b1b26$var$MILLISECONDS_IN_WEEK = 604800000;
function $278b82e1664b1b26$export$2e2bcd8739ae039(dirtyDate, options) {
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(1, arguments);
    var date = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    var diff = (0, $c68f9d140ac5ed75$export$2e2bcd8739ae039)(date, options).getTime() - (0, $45d288cb6c7f6103$export$2e2bcd8739ae039)(date, options).getTime(); // Round the number of days to the nearest integer
    // because the number of milliseconds in a week is not constant
    // (e.g. it's different in the week of the daylight saving time clock shift)
    return Math.round(diff / $278b82e1664b1b26$var$MILLISECONDS_IN_WEEK) + 1;
}



function $76f3d3ed3bd6dc44$export$2e2bcd8739ae039(number, targetLength) {
    var sign = number < 0 ? "-" : "";
    var output = Math.abs(number).toString();
    while(output.length < targetLength)output = "0" + output;
    return sign + output;
}



/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */ var $011d09a646fe9a0b$var$formatters = {
    // Year
    y: function y(date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M: function M(date, token) {
        var month = date.getUTCMonth();
        return token === "M" ? String(month + 1) : (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(month + 1, 2);
    },
    // Day of the month
    d: function d(date, token) {
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(date.getUTCDate(), token.length);
    },
    // AM or PM
    a: function a(date, token) {
        var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h: function h(date, token) {
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(date.getUTCHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H: function H(date, token) {
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(date.getUTCHours(), token.length);
    },
    // Minute
    m: function m(date, token) {
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(date.getUTCMinutes(), token.length);
    },
    // Second
    s: function s(date, token) {
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(date.getUTCSeconds(), token.length);
    },
    // Fraction of second
    S: function S(date, token) {
        var numberOfDigits = token.length;
        var milliseconds = date.getUTCMilliseconds();
        var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(fractionalSeconds, token.length);
    }
};
var $011d09a646fe9a0b$export$2e2bcd8739ae039 = $011d09a646fe9a0b$var$formatters;


var $eb56960b6fcec594$var$dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */ var $eb56960b6fcec594$var$formatters = {
    // Era
    G: function G(date, token, localize) {
        var era = date.getUTCFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function y(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)
            var year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).y(date, token);
    },
    // Local week-numbering year
    Y: function Y(date, token, localize, options) {
        var signedWeekYear = (0, $4c47940aefe91a66$export$2e2bcd8739ae039)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)
        var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year
        if (token === "YY") {
            var twoDigitYear = weekYear % 100;
            return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(twoDigitYear, 2);
        } // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
         // Padding
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function R(date, token) {
        var isoWeekYear = (0, $62b25514c7231bd1$export$2e2bcd8739ae039)(date); // Padding
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function u(date, token) {
        var year = date.getUTCFullYear();
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(year, token.length);
    },
    // Quarter
    Q: function Q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function q(date, token, localize) {
        var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function M(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function L(date, token, localize) {
        var month = date.getUTCMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function w(date, token, localize, options) {
        var week = (0, $278b82e1664b1b26$export$2e2bcd8739ae039)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(week, token.length);
    },
    // ISO week of year
    I: function I(date, token, localize) {
        var isoWeek = (0, $e59b5abfb7d0fbf1$export$2e2bcd8739ae039)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(isoWeek, token.length);
    },
    // Day of the month
    d: function d(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getUTCDate(), {
            unit: "date"
        });
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).d(date, token);
    },
    // Day of year
    D: function D(date, token, localize) {
        var dayOfYear = (0, $bb3bd5e7c9945a31$export$2e2bcd8739ae039)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(dayOfYear, token.length);
    },
    // Day of week
    E: function E(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function e(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function c(date, token, localize, options) {
        var dayOfWeek = date.getUTCDay();
        var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function i(date, token, localize) {
        var dayOfWeek = date.getUTCDay();
        var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function a(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function b(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function B(date, token, localize) {
        var hours = date.getUTCHours();
        var dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.morning;
        else dayPeriodEnumValue = $eb56960b6fcec594$var$dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function h(date, token, localize) {
        if (token === "ho") {
            var hours = date.getUTCHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).h(date, token);
    },
    // Hour [0-23]
    H: function H(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getUTCHours(), {
            unit: "hour"
        });
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).H(date, token);
    },
    // Hour [0-11]
    K: function K(date, token, localize) {
        var hours = date.getUTCHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Hour [1-24]
    k: function k(date, token, localize) {
        var hours = date.getUTCHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(hours, token.length);
    },
    // Minute
    m: function m(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getUTCMinutes(), {
            unit: "minute"
        });
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).m(date, token);
    },
    // Second
    s: function s(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getUTCSeconds(), {
            unit: "second"
        });
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).s(date, token);
    },
    // Fraction of second
    S: function S(date, token) {
        return (0, $011d09a646fe9a0b$export$2e2bcd8739ae039).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function X(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return $eb56960b6fcec594$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                // Hours and minutes without `:` delimiter
                return $eb56960b6fcec594$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return $eb56960b6fcec594$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function x(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return $eb56960b6fcec594$var$formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                // Hours and minutes without `:` delimiter
                return $eb56960b6fcec594$var$formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return $eb56960b6fcec594$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function O(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + $eb56960b6fcec594$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + $eb56960b6fcec594$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function z(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timezoneOffset = originalDate.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + $eb56960b6fcec594$var$formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + $eb56960b6fcec594$var$formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function t(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = Math.floor(originalDate.getTime() / 1000);
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function T(date, token, _localize, options) {
        var originalDate = options._originalDate || date;
        var timestamp = originalDate.getTime();
        return (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(timestamp, token.length);
    }
};
function $eb56960b6fcec594$var$formatTimezoneShort(offset, dirtyDelimiter) {
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = Math.floor(absOffset / 60);
    var minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    var delimiter = dirtyDelimiter || "";
    return sign + String(hours) + delimiter + (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(minutes, 2);
}
function $eb56960b6fcec594$var$formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
    if (offset % 60 === 0) {
        var sign = offset > 0 ? "-" : "+";
        return sign + (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(Math.abs(offset) / 60, 2);
    }
    return $eb56960b6fcec594$var$formatTimezone(offset, dirtyDelimiter);
}
function $eb56960b6fcec594$var$formatTimezone(offset, dirtyDelimiter) {
    var delimiter = dirtyDelimiter || "";
    var sign = offset > 0 ? "-" : "+";
    var absOffset = Math.abs(offset);
    var hours = (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(Math.floor(absOffset / 60), 2);
    var minutes = (0, $76f3d3ed3bd6dc44$export$2e2bcd8739ae039)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}
var $eb56960b6fcec594$export$2e2bcd8739ae039 = $eb56960b6fcec594$var$formatters;


var $41b6ac5bc6649e02$var$dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
var $41b6ac5bc6649e02$var$timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
var $41b6ac5bc6649e02$var$dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
    var matchResult = pattern.match(/(P+)(p+)?/) || [];
    var datePattern = matchResult[1];
    var timePattern = matchResult[2];
    if (!timePattern) return $41b6ac5bc6649e02$var$dateLongFormatter(pattern, formatLong);
    var dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", $41b6ac5bc6649e02$var$dateLongFormatter(datePattern, formatLong)).replace("{{time}}", $41b6ac5bc6649e02$var$timeLongFormatter(timePattern, formatLong));
};
var $41b6ac5bc6649e02$var$longFormatters = {
    p: $41b6ac5bc6649e02$var$timeLongFormatter,
    P: $41b6ac5bc6649e02$var$dateTimeLongFormatter
};
var $41b6ac5bc6649e02$export$2e2bcd8739ae039 = $41b6ac5bc6649e02$var$longFormatters;


/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ function $59eb8b02f290a75f$export$2e2bcd8739ae039(date) {
    var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return date.getTime() - utcDate.getTime();
}


var $72db3a35ea6d7a31$var$protectedDayOfYearTokens = [
    "D",
    "DD"
];
var $72db3a35ea6d7a31$var$protectedWeekYearTokens = [
    "YY",
    "YYYY"
];
function $72db3a35ea6d7a31$export$c6cc36aa33304772(token) {
    return $72db3a35ea6d7a31$var$protectedDayOfYearTokens.indexOf(token) !== -1;
}
function $72db3a35ea6d7a31$export$c6b49d6dceb604a1(token) {
    return $72db3a35ea6d7a31$var$protectedWeekYearTokens.indexOf(token) !== -1;
}
function $72db3a35ea6d7a31$export$8073c1ae88f0e727(token, format, input) {
    if (token === "YYYY") throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "YY") throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "D") throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
    else if (token === "DD") throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}





var $fb5878f4537e1ce5$var$formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
var $fb5878f4537e1ce5$var$formatDistance = function formatDistance(token, count, options) {
    var result;
    var tokenValue = $fb5878f4537e1ce5$var$formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options !== null && options !== void 0 && options.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};
var $fb5878f4537e1ce5$export$2e2bcd8739ae039 = $fb5878f4537e1ce5$var$formatDistance;


function $15c85eb3fcfd2582$export$2e2bcd8739ae039(args) {
    return function() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        // TODO: Remove String()
        var width = options.width ? String(options.width) : args.defaultWidth;
        var format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}


var $1eef201d5399438d$var$dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
var $1eef201d5399438d$var$timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
var $1eef201d5399438d$var$dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
var $1eef201d5399438d$var$formatLong = {
    date: (0, $15c85eb3fcfd2582$export$2e2bcd8739ae039)({
        formats: $1eef201d5399438d$var$dateFormats,
        defaultWidth: "full"
    }),
    time: (0, $15c85eb3fcfd2582$export$2e2bcd8739ae039)({
        formats: $1eef201d5399438d$var$timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, $15c85eb3fcfd2582$export$2e2bcd8739ae039)({
        formats: $1eef201d5399438d$var$dateTimeFormats,
        defaultWidth: "full"
    })
};
var $1eef201d5399438d$export$2e2bcd8739ae039 = $1eef201d5399438d$var$formatLong;


var $c4380bc2c88f0c9d$var$formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
var $c4380bc2c88f0c9d$var$formatRelative = function formatRelative(token, _date, _baseDate, _options) {
    return $c4380bc2c88f0c9d$var$formatRelativeLocale[token];
};
var $c4380bc2c88f0c9d$export$2e2bcd8739ae039 = $c4380bc2c88f0c9d$var$formatRelative;


function $ba0349a3b30454a9$export$2e2bcd8739ae039(args) {
    return function(dirtyIndex, options) {
        var context = options !== null && options !== void 0 && options.context ? String(options.context) : "standalone";
        var valuesArray;
        if (context === "formatting" && args.formattingValues) {
            var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            var _defaultWidth = args.defaultWidth;
            var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[_width] || args.values[_defaultWidth];
        }
        var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex; // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}


var $2cd911df84097460$var$eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
var $2cd911df84097460$var$quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
}; // Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var $2cd911df84097460$var$monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
var $2cd911df84097460$var$dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
var $2cd911df84097460$var$dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
var $2cd911df84097460$var$formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
var $2cd911df84097460$var$ordinalNumber = function ordinalNumber(dirtyNumber, _options) {
    var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    var rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
var $2cd911df84097460$var$localize = {
    ordinalNumber: $2cd911df84097460$var$ordinalNumber,
    era: (0, $ba0349a3b30454a9$export$2e2bcd8739ae039)({
        values: $2cd911df84097460$var$eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, $ba0349a3b30454a9$export$2e2bcd8739ae039)({
        values: $2cd911df84097460$var$quarterValues,
        defaultWidth: "wide",
        argumentCallback: function argumentCallback(quarter) {
            return quarter - 1;
        }
    }),
    month: (0, $ba0349a3b30454a9$export$2e2bcd8739ae039)({
        values: $2cd911df84097460$var$monthValues,
        defaultWidth: "wide"
    }),
    day: (0, $ba0349a3b30454a9$export$2e2bcd8739ae039)({
        values: $2cd911df84097460$var$dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, $ba0349a3b30454a9$export$2e2bcd8739ae039)({
        values: $2cd911df84097460$var$dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: $2cd911df84097460$var$formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};
var $2cd911df84097460$export$2e2bcd8739ae039 = $2cd911df84097460$var$localize;


function $afb672e75b3827e9$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var width = options.width;
        var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        var matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        var key = Array.isArray(parsePatterns) ? $afb672e75b3827e9$var$findIndex(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        }) : $afb672e75b3827e9$var$findKey(parsePatterns, function(pattern) {
            return pattern.test(matchedString);
        });
        var value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}
function $afb672e75b3827e9$var$findKey(object, predicate) {
    for(var key in object){
        if (object.hasOwnProperty(key) && predicate(object[key])) return key;
    }
    return undefined;
}
function $afb672e75b3827e9$var$findIndex(array, predicate) {
    for(var key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}


function $6cc81879a82cae66$export$2e2bcd8739ae039(args) {
    return function(string) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        var matchedString = matchResult[0];
        var parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        value = options.valueCallback ? options.valueCallback(value) : value;
        var rest = string.slice(matchedString.length);
        return {
            value: value,
            rest: rest
        };
    };
}


var $09660ea720cce347$var$matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var $09660ea720cce347$var$parseOrdinalNumberPattern = /\d+/i;
var $09660ea720cce347$var$matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
var $09660ea720cce347$var$parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
var $09660ea720cce347$var$matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
var $09660ea720cce347$var$parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
var $09660ea720cce347$var$matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var $09660ea720cce347$var$parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
var $09660ea720cce347$var$matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var $09660ea720cce347$var$parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
var $09660ea720cce347$var$matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var $09660ea720cce347$var$parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
var $09660ea720cce347$var$match = {
    ordinalNumber: (0, $6cc81879a82cae66$export$2e2bcd8739ae039)({
        matchPattern: $09660ea720cce347$var$matchOrdinalNumberPattern,
        parsePattern: $09660ea720cce347$var$parseOrdinalNumberPattern,
        valueCallback: function valueCallback(value) {
            return parseInt(value, 10);
        }
    }),
    era: (0, $afb672e75b3827e9$export$2e2bcd8739ae039)({
        matchPatterns: $09660ea720cce347$var$matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09660ea720cce347$var$parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, $afb672e75b3827e9$export$2e2bcd8739ae039)({
        matchPatterns: $09660ea720cce347$var$matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09660ea720cce347$var$parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: function valueCallback(index) {
            return index + 1;
        }
    }),
    month: (0, $afb672e75b3827e9$export$2e2bcd8739ae039)({
        matchPatterns: $09660ea720cce347$var$matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09660ea720cce347$var$parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, $afb672e75b3827e9$export$2e2bcd8739ae039)({
        matchPatterns: $09660ea720cce347$var$matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: $09660ea720cce347$var$parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, $afb672e75b3827e9$export$2e2bcd8739ae039)({
        matchPatterns: $09660ea720cce347$var$matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: $09660ea720cce347$var$parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};
var $09660ea720cce347$export$2e2bcd8739ae039 = $09660ea720cce347$var$match;


/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */ var $1e41db325cf5f3ac$var$locale = {
    code: "en-US",
    formatDistance: (0, $fb5878f4537e1ce5$export$2e2bcd8739ae039),
    formatLong: (0, $1eef201d5399438d$export$2e2bcd8739ae039),
    formatRelative: (0, $c4380bc2c88f0c9d$export$2e2bcd8739ae039),
    localize: (0, $2cd911df84097460$export$2e2bcd8739ae039),
    match: (0, $09660ea720cce347$export$2e2bcd8739ae039),
    options: {
        weekStartsOn: 0,
        firstWeekContainsDate: 1
    }
};
var $1e41db325cf5f3ac$export$2e2bcd8739ae039 = $1e41db325cf5f3ac$var$locale;


var $5c25d2afb47d49f2$export$2e2bcd8739ae039 = (0, $1e41db325cf5f3ac$export$2e2bcd8739ae039);


// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var $fa8b0761f15bed53$var$formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var $fa8b0761f15bed53$var$longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var $fa8b0761f15bed53$var$escapedStringRegExp = /^'([^]*?)'?$/;
var $fa8b0761f15bed53$var$doubleQuoteRegExp = /''/g;
var $fa8b0761f15bed53$var$unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function $fa8b0761f15bed53$export$2e2bcd8739ae039(dirtyDate, dirtyFormatStr, options) {
    var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
    (0, $0f0f4bd4e69d1c9a$export$2e2bcd8739ae039)(2, arguments);
    var formatStr = String(dirtyFormatStr);
    var defaultOptions = (0, $5463c97bdad38feb$export$430a3269e24b912e)();
    var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : (0, $5c25d2afb47d49f2$export$2e2bcd8739ae039);
    var firstWeekContainsDate = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
    if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
    var weekStartsOn = (0, $9a4c7e4b9e9c5209$export$2e2bcd8739ae039)((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
    if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
    if (!locale.localize) throw new RangeError("locale must contain localize property");
    if (!locale.formatLong) throw new RangeError("locale must contain formatLong property");
    var originalDate = (0, $acb0b6fd302356fa$export$2e2bcd8739ae039)(dirtyDate);
    if (!(0, $a6d1b76cdb8a2161$export$2e2bcd8739ae039)(originalDate)) throw new RangeError("Invalid time value");
     // Convert the date in system timezone to the same date in UTC+00:00 timezone.
    // This ensures that when UTC functions will be implemented, locales will be compatible with them.
    // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
    var timezoneOffset = (0, $59eb8b02f290a75f$export$2e2bcd8739ae039)(originalDate);
    var utcDate = (0, $a5e717e56c4ef822$export$2e2bcd8739ae039)(originalDate, timezoneOffset);
    var formatterOptions = {
        firstWeekContainsDate: firstWeekContainsDate,
        weekStartsOn: weekStartsOn,
        locale: locale,
        _originalDate: originalDate
    };
    var result = formatStr.match($fa8b0761f15bed53$var$longFormattingTokensRegExp).map(function(substring) {
        var firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            var longFormatter = (0, $41b6ac5bc6649e02$export$2e2bcd8739ae039)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match($fa8b0761f15bed53$var$formattingTokensRegExp).map(function(substring) {
        // Replace two single quote characters with one single quote character
        if (substring === "''") return "'";
        var firstCharacter = substring[0];
        if (firstCharacter === "'") return $fa8b0761f15bed53$var$cleanEscapedString(substring);
        var formatter = (0, $eb56960b6fcec594$export$2e2bcd8739ae039)[firstCharacter];
        if (formatter) {
            if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && (0, $72db3a35ea6d7a31$export$c6b49d6dceb604a1)(substring)) (0, $72db3a35ea6d7a31$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && (0, $72db3a35ea6d7a31$export$c6cc36aa33304772)(substring)) (0, $72db3a35ea6d7a31$export$8073c1ae88f0e727)(substring, dirtyFormatStr, String(dirtyDate));
            return formatter(utcDate, substring, locale.localize, formatterOptions);
        }
        if (firstCharacter.match($fa8b0761f15bed53$var$unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return substring;
    }).join("");
    return result;
}
function $fa8b0761f15bed53$var$cleanEscapedString(input) {
    var matched = input.match($fa8b0761f15bed53$var$escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace($fa8b0761f15bed53$var$doubleQuoteRegExp, "'");
}



var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1280fdc79a297068$var$SvgPhoneInfo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 55,
        height: 10,
        viewBox: "0 0 55 10",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.35,
                d: "M35.2 3c0-.957.776-1.733 1.734-1.733h13.333C51.224 1.267 52 2.043 52 3v4.8c0 .957-.776 1.733-1.733 1.733H36.934A1.733 1.733 0 0 1 35.2 7.8V3Z",
                stroke: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.4,
                d: "M53.2 3.8V7a1.736 1.736 0 0 0 0-3.2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M36.4 3.533c0-.589.478-1.066 1.067-1.066h12.267c.589 0 1.066.477 1.066 1.066v3.734c0 .589-.477 1.066-1.066 1.066H37.467c-.589 0-1.067-.477-1.067-1.066V3.533ZM24.665 2.686c1.772 0 3.477.682 4.762 1.903a.246.246 0 0 0 .346-.003l.925-.933a.257.257 0 0 0-.002-.365 8.718 8.718 0 0 0-12.064 0 .257.257 0 0 0-.002.365l.925.933c.095.096.25.098.346.003a6.913 6.913 0 0 1 4.764-1.903Zm0 3.037c.973 0 1.913.362 2.634 1.016.098.093.252.09.347-.005l.924-.933a.258.258 0 0 0-.004-.367 5.728 5.728 0 0 0-7.802 0 .257.257 0 0 0-.003.367l.923.933a.248.248 0 0 0 .347.005 3.926 3.926 0 0 1 2.633-1.016Zm1.85 2.043a.251.251 0 0 1-.075.185l-1.598 1.612a.25.25 0 0 1-.355 0l-1.598-1.612a.251.251 0 0 1 .008-.366 2.737 2.737 0 0 1 3.535 0 .252.252 0 0 1 .083.181ZM13.734 1.133h-.8a.8.8 0 0 0-.8.8v6.934a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8V1.933a.8.8 0 0 0-.8-.8ZM9.2 3h.8a.8.8 0 0 1 .8.8v5.067a.8.8 0 0 1-.8.8h-.8a.8.8 0 0 1-.8-.8V3.8a.8.8 0 0 1 .8-.8ZM6.267 4.867h-.8a.8.8 0 0 0-.8.8v3.2a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8v-3.2a.8.8 0 0 0-.8-.8Zm-3.733 1.6h-.8a.8.8 0 0 0-.8.8v1.6a.8.8 0 0 0 .8.8h.8a.8.8 0 0 0 .8-.8v-1.6a.8.8 0 0 0-.8-.8Z",
                fill: "currentColor"
            })
        ]
    });
var $1280fdc79a297068$export$2e2bcd8739ae039 = $1280fdc79a297068$var$SvgPhoneInfo;



var $eEyjP = parcelRequire("eEyjP");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");
var $dMkQh = parcelRequire("dMkQh");

var $2CYkO = parcelRequire("2CYkO");
const $9e8b81068db3cbee$var$action = {
    sign_in: "Anmelden",
    continue: "Weiter",
    create_account: "Konto erstellen",
    create_account_without_linking: "Erstelle ein Konto ohne Verkn\xfcpfung",
    create: "Erstellen",
    enter_passcode: "Best\xe4tigungscode eingeben",
    confirm: "Best\xe4tigen",
    cancel: "Abbrechen",
    save_password: "Passwort speichern",
    bind: "Mit {{address}} verkn\xfcpfen",
    bind_and_continue: "Verkn\xfcpfen und weiter",
    back: "Gehe zur\xfcck",
    nav_back: "Zur\xfcck",
    nav_skip: "\xdcberspringen",
    agree: "Zustimmen",
    got_it: "Alles klar",
    sign_in_with: "Mit {{name}} anmelden",
    forgot_password: "Passwort vergessen?",
    switch_to: "Zu {{method}} wechseln",
    sign_in_via_passcode: "Mit Best\xe4tigungscode anmelden",
    sign_in_via_password: "Mit Passwort anmelden",
    change: "{{method}} \xe4ndern",
    link_another_email: "Andere Email verkn\xfcpfen",
    link_another_phone: "Andere Telefonnummer verkn\xfcpfen",
    link_another_email_or_phone: "Andere Email oder Telefonnummer verkn\xfcpfen",
    show_password: "Passwort anzeigen",
    copy: "Kopieren",
    verify_via_passkey: "\xdcberpr\xfcfen \xfcber Passkey",
    download: "Herunterladen",
    single_sign_on: "Single Sign-On"
};
var $9e8b81068db3cbee$export$2e2bcd8739ae039 = Object.freeze($9e8b81068db3cbee$var$action);


const $3a8cba0cf4f66832$var$description = {
    email: "Email",
    phone_number: "Telefonnummer",
    username: "Benutzername",
    reminder: "Erinnerung",
    not_found: "404 Nicht gefunden",
    agree_with_terms: "Ich akzeptiere die ",
    agree_with_terms_modal: "Bitte akzeptiere die <link></link>.",
    terms_of_use: "Nutzungsbedingungen",
    sign_in: "Anmelden",
    privacy_policy: "Datenschutzrichtlinien",
    create_account: "Konto erstellen",
    or: "oder",
    and: "und",
    enter_passcode: "Der Best\xe4tigungscode wurde an deine {{address}} gesendet",
    passcode_sent: "Der Best\xe4tigungscode wurde erneut gesendet",
    resend_after_seconds: "Nach <span>{{seconds}}</span> Sekunden erneut senden",
    resend_passcode: "Best\xe4tigungscode erneut senden",
    create_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du dich anmelden?",
    link_account_id_exists: "Das Konto mit {{type}} {{value}} existiert bereits, m\xf6chtest du es mit deinem Konto verkn\xfcpfen?",
    sign_in_id_does_not_exist: "Das Konto mit {{type}} {{value}} existiert nicht, m\xf6chtest du ein neues Konto erstellen?",
    sign_in_id_does_not_exist_alert: "Das Konto mit {{type}} {{value}} existiert nicht",
    create_account_id_exists_alert: "Das Konto mit {{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche es mit einem anderen {{type}} erneut",
    social_identity_exist: "{{type}} {{value}} ist mit einem anderen Konto verkn\xfcpft. Bitte versuche ein(e(n)) andere(n/s) {{type}}",
    bind_account_title: "Verlinke oder erstelle ein Konto",
    social_create_account: "Sie k\xf6nnen ein neues Konto erstellen.",
    social_link_email: "Du kannst eine weitere Email verkn\xfcpfen",
    social_link_phone: "Du kannst eine weitere Telefonnummer verkn\xfcpfen",
    social_link_email_or_phone: "Du kannst eine weitere Email oder Telefonnummer verkn\xfcpfen",
    social_bind_with_existing: "Wir haben eine verwandte {{method}} gefunden, die bereits registriert wurde, und Sie k\xf6nnen sie direkt verkn\xfcpfen.",
    reset_password: "Passwort vergessen",
    reset_password_description: "Gib die {{types, list(type: disjunction;)}} deines Kontos ein und wir senden dir einen Best\xe4tigungscode um dein Passwort zur\xfcckzusetzen.",
    new_password: "Neues Passwort",
    set_password: "Passwort setzen",
    password_changed: "Passwort ge\xe4ndert",
    no_account: "Noch kein Konto? ",
    have_account: "Hast du schon ein Konto?",
    enter_password: "Passwort eingeben",
    enter_password_for: "Passwort f\xfcr {{method}} {{value}} eingeben",
    enter_username: "Benutzernamen festlegen",
    enter_username_description: "Der Benutzername kann f\xfcr die Anmeldung verwendet werden. Der Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten.",
    link_email: "Email verkn\xfcpfen",
    link_phone: "Telefonnummer verkn\xfcpfen",
    link_email_or_phone: "Email oder Telefonnummer verkn\xfcpfen",
    link_email_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email mit dem Konto.",
    link_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Telefonnummer mit dem Konto.",
    link_email_or_phone_description: "F\xfcr zus\xe4tzliche Sicherheit, verkn\xfcpfe bitte deine Email oder Telefonnummer mit dem Konto.",
    continue_with_more_information: "F\xfcr zus\xe4tzliche Sicherheit, vervollst\xe4ndige bitte deine Informationen.",
    create_your_account: "Erstelle dein Konto",
    sign_in_to_your_account: "Melde dich in deinem Konto an",
    no_region_code_found: "Kein Regionencode gefunden",
    verify_email: "Best\xe4tige deine E-Mail-Adresse",
    verify_phone: "Best\xe4tige deine Telefonnummer",
    password_requirements: "Passwort {{items, list}}.",
    password_requirement: {
        length_one: "erfordert mindestens {{count}} Zeichen",
        length_other: "erfordert mindestens {{count}} Zeichen",
        character_types_one: "sollte mindestens {{count}} Kategorie der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole",
        character_types_other: "sollte mindestens {{count}} Kategorien der folgenden Zeichenarten enthalten: Gro\xdfbuchstaben, Kleinbuchstaben, Zahlen und Symbole"
    },
    use: "Verwenden",
    single_sign_on_email_form: "Gib deine Unternehmens-E-Mail-Adresse ein.",
    single_sign_on_connectors_list: "Ihr Unternehmen hat Single Sign-On f\xfcr das E-Mail-Konto {{email}} aktiviert. Sie k\xf6nnen sich weiterhin mit den folgenden SSO-Anbietern anmelden.",
    single_sign_on_enabled: "Single Sign-On ist f\xfcr dieses Konto aktiviert"
};
var $3a8cba0cf4f66832$export$2e2bcd8739ae039 = Object.freeze($3a8cba0cf4f66832$var$description);


const $13aa8cbf7ede06e5$var$development_tenant = {
    notification: "Du befindest dich im Entwicklungsmodus"
};
var $13aa8cbf7ede06e5$export$2e2bcd8739ae039 = Object.freeze($13aa8cbf7ede06e5$var$development_tenant);


const $acde135f6d0a56be$var$password_rejected = {
    too_short: "Die minimale L\xe4nge betr\xe4gt {{min}}.",
    too_long: "Die maximale L\xe4nge betr\xe4gt {{max}}.",
    character_types: "Mindestens {{min}} Arten von Zeichen sind erforderlich.",
    unsupported_characters: "Nicht unterst\xfctztes Zeichen gefunden.",
    pwned: "Verwenden Sie keine einfachen Passw\xf6rter, die leicht zu erraten sind.",
    restricted_found: "Vermeiden Sie \xfcberm\xe4\xdfigen Gebrauch von {{list, list}}.",
    restricted: {
        repetition: "wiederholte Zeichen",
        sequence: "sequenzielle Zeichen",
        user_info: "Ihre pers\xf6nlichen Informationen",
        words: "Produktkontext"
    }
};
var $acde135f6d0a56be$export$2e2bcd8739ae039 = Object.freeze($acde135f6d0a56be$var$password_rejected);


const $4b653f9134990402$var$error = {
    general_required: "{{types, list(type: disjunction;)}} ist erforderlich",
    general_invalid: "Die {{types, list(type: disjunction;)}} is ung\xfcltig",
    username_required: "Benutzername ist erforderlich",
    password_required: "Passwort ist erforderlich",
    username_exists: "Benutzername existiert bereits",
    username_should_not_start_with_number: "Benutzername darf nicht mit einer Zahl beginnen",
    username_invalid_charset: "Benutzername darf nur Buchstaben, Zahlen und Unterstriche enthalten",
    invalid_email: "Die Email ist ung\xfcltig",
    invalid_phone: "Die Telefonnummer ist ung\xfcltig",
    passwords_do_not_match: "Passw\xf6rter stimmen nicht \xfcberein",
    invalid_passcode: "Der Best\xe4tigungscode ist ung\xfcltig",
    invalid_connector_auth: "Die Autorisierung ist ung\xfcltig",
    invalid_connector_request: "Connector Daten sind ung\xfcltig",
    unknown: "Unbekannter Fehler. Versuche es sp\xe4ter noch einmal.",
    invalid_session: "Die Sitzung ist ung\xfcltig. Bitte melde dich erneut an.",
    timeout: "Zeit\xfcberschreitung. Bitte melde dich erneut an.",
    password_rejected: $acde135f6d0a56be$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On ist f\xfcr dieses E-Mail-Konto nicht aktiviert."
};
var $4b653f9134990402$export$2e2bcd8739ae039 = Object.freeze($4b653f9134990402$var$error);


const $25c7c6e9e3bf99ae$var$input = {
    username: "Benutzername",
    password: "Passwort",
    email: "Email",
    phone_number: "Telefonnummer",
    confirm_password: "Passwort best\xe4tigen",
    search_region_code: "Suche region code",
    backup_code: "Backup-Code"
};
var $25c7c6e9e3bf99ae$export$2e2bcd8739ae039 = Object.freeze($25c7c6e9e3bf99ae$var$input);


const $fdfb415a16939779$var$list = {
    or: "oder",
    and: "und",
    separator: ","
};
var $fdfb415a16939779$export$2e2bcd8739ae039 = Object.freeze($fdfb415a16939779$var$list);


const $31450310e008a700$var$mfa = {
    totp: "Authenticator-App-OTP",
    webauthn: "Passkey",
    backup_code: "Backup-Code",
    link_totp_description: "z.B. Google Authenticator usw.",
    link_webauthn_description: "Verkn\xfcpfen Sie Ihr Ger\xe4t oder USB-Hardware",
    link_backup_code_description: "Backup-Code generieren",
    verify_totp_description: "Geben Sie den Einmalcode in der App ein",
    verify_webauthn_description: "Verifizieren Sie Ihr Ger\xe4t oder Ihre USB-Hardware",
    verify_backup_code_description: "F\xfcgen Sie den gespeicherten Backup-Code ein",
    add_mfa_factors: "2-Schritte-Verifizierung hinzuf\xfcgen",
    add_mfa_description: "Die Zwei-Faktor-Verifizierung ist aktiviert. W\xe4hlen Sie Ihre zweite Verifizierungsmethode f\xfcr sicheres Anmelden aus.",
    verify_mfa_factors: "2-Schritte-Verifizierung",
    verify_mfa_description: "Die 2-Schritte-Verifizierung ist f\xfcr dieses Konto aktiviert. Bitte w\xe4hlen Sie die zweite Methode zur Verifizierung Ihrer Identit\xe4t aus.",
    add_authenticator_app: "Authenticator-App hinzuf\xfcgen",
    step: "Schritt {{step, number}}: {{content}}",
    scan_qr_code: "Scannen Sie diesen QR-Code",
    scan_qr_code_description: "Scannen Sie den folgenden QR-Code mit Ihrer Authenticator-App, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    qr_code_not_available: "Kann den QR-Code nicht scannen?",
    copy_and_paste_key: "Schl\xfcssel kopieren und einf\xfcgen",
    copy_and_paste_key_description: "Kopieren Sie den folgenden Schl\xfcssel und f\xfcgen Sie ihn in Ihre Authenticator-App ein, wie z.B. Google Authenticator, Duo Mobile, Authy usw.",
    want_to_scan_qr_code: "M\xf6chten Sie den QR-Code scannen?",
    enter_one_time_code: "Einmalcode eingeben",
    enter_one_time_code_link_description: "Geben Sie den 6-stelligen Verifizierungscode ein, der von der Authenticator-App generiert wurde.",
    enter_one_time_code_description: "F\xfcr dieses Konto wurde die Zwei-Faktor-Authentifizierung aktiviert. Bitte geben Sie den einmaligen Code ein, der in Ihrer verkn\xfcpften Authentifizierungs-App angezeigt wird.",
    link_another_mfa_factor: "Zu einer anderen Methode wechseln",
    save_backup_code: "Backup-Code speichern",
    save_backup_code_description: "Sie k\xf6nnen einen dieser Backup-Codes verwenden, um auf Ihr Konto zuzugreifen, wenn Sie w\xe4hrend der 2-Schritte-Verifizierung auf andere Weise Probleme haben. Jeder Code kann nur einmal verwendet werden.",
    backup_code_hint: "Stellen Sie sicher, dass Sie sie kopieren und an einem sicheren Ort speichern.",
    enter_a_backup_code: "Backup-Code eingeben",
    enter_backup_code_description: "Geben Sie den Backup-Code ein, den Sie gespeichert haben, als die 2-Schritte-Verifizierung initial aktiviert wurde.",
    create_a_passkey: "Passkey erstellen",
    create_passkey_description: "Registrieren Sie Ihren Passkey mit biometrischen Daten, Sicherheitsschl\xfcsseln (z.B. YubiKey) oder anderen verf\xfcgbaren Methoden.",
    try_another_verification_method: "Versuchen Sie eine andere Methode zur Verifizierung",
    verify_via_passkey: "\xdcber Passkey verifizieren",
    verify_via_passkey_description: "Verwenden Sie den Passkey zur Verifizierung durch Ihr Ger\xe4tepasswort oder Biometrie, zum Scannen des QR-Codes oder zum Verwenden eines USB-Sicherheitsschl\xfcssels wie YubiKey.",
    secret_key_copied: "Geheimer Schl\xfcssel kopiert.",
    backup_code_copied: "Backup-Code kopiert.",
    webauthn_not_ready: "WebAuthn ist noch nicht bereit. Bitte versuchen Sie es sp\xe4ter erneut.",
    webauthn_not_supported: "WebAuthn wird in diesem Browser nicht unterst\xfctzt.",
    webauthn_failed_to_create: "Erstellung fehlgeschlagen. Bitte versuchen Sie es erneut.",
    webauthn_failed_to_verify: "Verifizierung fehlgeschlagen. Bitte versuchen Sie es erneut."
};
var $31450310e008a700$export$2e2bcd8739ae039 = Object.freeze($31450310e008a700$var$mfa);


const $92ea5f8aa26781e7$var$secondary = {
    social_bind_with: "Besitzt du schon ein Konto? Melde dich an, um {{methods, list(type: disjunction;)}} mit deiner Identit\xe4t zu verbinden."
};
var $92ea5f8aa26781e7$export$2e2bcd8739ae039 = Object.freeze($92ea5f8aa26781e7$var$secondary);


const $5e82a27eecb6733e$var$de = {
    translation: {
        input: $25c7c6e9e3bf99ae$export$2e2bcd8739ae039,
        secondary: $92ea5f8aa26781e7$export$2e2bcd8739ae039,
        action: $9e8b81068db3cbee$export$2e2bcd8739ae039,
        description: $3a8cba0cf4f66832$export$2e2bcd8739ae039,
        error: $4b653f9134990402$export$2e2bcd8739ae039,
        list: $fdfb415a16939779$export$2e2bcd8739ae039,
        mfa: $31450310e008a700$export$2e2bcd8739ae039,
        development_tenant: $13aa8cbf7ede06e5$export$2e2bcd8739ae039
    }
};
var $5e82a27eecb6733e$export$2e2bcd8739ae039 = Object.freeze($5e82a27eecb6733e$var$de);


const $2bbca6646a53e50a$var$action = {
    sign_in: "Sign in",
    continue: "Continue",
    create_account: "Create account",
    create_account_without_linking: "Create account without linking",
    create: "Create",
    enter_passcode: "Enter verification code",
    confirm: "Confirm",
    cancel: "Cancel",
    save_password: "Save password",
    bind: "Link with {{address}}",
    bind_and_continue: "Link and continue",
    back: "Go back",
    nav_back: "Back",
    nav_skip: "Skip",
    agree: "Agree",
    got_it: "Got it",
    sign_in_with: "Continue with {{name}}",
    forgot_password: "Forgot your password?",
    switch_to: "Switch to {{method}}",
    sign_in_via_passcode: "Sign in with verification code",
    sign_in_via_password: "Sign in with password",
    change: "Change {{method}}",
    link_another_email: "Link another email",
    link_another_phone: "Link another phone",
    link_another_email_or_phone: "Link another email or phone",
    show_password: "Show password",
    copy: "Copy",
    verify_via_passkey: "Verify via passkey",
    download: "Download",
    single_sign_on: "Single Sign-On"
};
var $2bbca6646a53e50a$export$2e2bcd8739ae039 = Object.freeze($2bbca6646a53e50a$var$action);


const $ddef82be7e9ff6fd$var$description = {
    email: "email",
    phone_number: "phone number",
    username: "username",
    reminder: "Reminder",
    not_found: "404 Not Found",
    agree_with_terms: "I have read and agree to the ",
    agree_with_terms_modal: "To proceed, please agree to the <link></link>.",
    terms_of_use: "Terms of Use",
    sign_in: "Sign in",
    privacy_policy: "Privacy Policy",
    create_account: "Create account",
    or: "or",
    and: "and",
    enter_passcode: "The verification code has been sent to your {{address}} {{target}}",
    passcode_sent: "The verification code has been resent",
    resend_after_seconds: "Resend after <span>{{seconds}}</span> seconds",
    resend_passcode: "Resend verification code",
    create_account_id_exists: "The account with {{type}} {{value}} already exists, would you like to sign in?",
    link_account_id_exists: "The account with {{type}} {{value}} already exists. Would you like to link?",
    sign_in_id_does_not_exist: "The account with {{type}} {{value}} does not exist, would you like to create a new account?",
    sign_in_id_does_not_exist_alert: "The account with {{type}} {{value}} does not exist.",
    create_account_id_exists_alert: "The account with {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    social_identity_exist: "The {{type}} {{value}} is linked to another account. Please try another {{type}}.",
    bind_account_title: "Link or create account",
    social_create_account: "You can create a new account.",
    social_link_email: "You can link another email",
    social_link_phone: "You can link another phone",
    social_link_email_or_phone: "You can link another email or phone",
    social_bind_with_existing: "We find a related account, you can link it directly.",
    reset_password: "Reset password",
    reset_password_description: "Enter the {{types, list(type: disjunction;)}} associated with your account, and we’ll send you the verification code to reset your password.",
    new_password: "New password",
    set_password: "Set password",
    password_changed: "Password changed",
    no_account: "No account yet? ",
    have_account: "Already had an account?",
    enter_password: "Enter password",
    enter_password_for: "Sign in with the password to {{method}} {{value}}",
    enter_username: "Set username",
    enter_username_description: "Username is an alternative for sign-in. Username should contain only letters, numbers, and underscores.",
    link_email: "Link email",
    link_phone: "Link phone",
    link_email_or_phone: "Link email or phone",
    link_email_description: "For added security, please link your email with the account.",
    link_phone_description: "For added security, please link your phone with the account.",
    link_email_or_phone_description: "For added security, please link your email or phone with the account.",
    continue_with_more_information: "For added security, please complete below account details.",
    create_your_account: "Create your account",
    sign_in_to_your_account: "Sign in to your account",
    no_region_code_found: "No region code found",
    verify_email: "Verify your email",
    verify_phone: "Verify your phone number",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "requires a minimum of {{count}} character",
        length_other: "requires a minimum of {{count}} characters",
        character_types_one: "should contain at least {{count}} type of uppercase letters, lowercase letters, digits, and symbols",
        character_types_other: "should contain at least {{count}} types of uppercase letters, lowercase letters, digits, and symbols"
    },
    use: "Use",
    single_sign_on_email_form: "Enter your enterprise email address",
    single_sign_on_connectors_list: "Your enterprise has enabled Single Sign-On for the email account {{email}}. You can continue to sign in with the following SSO providers.",
    single_sign_on_enabled: "Single Sign-On is enabled for this account"
};
var $ddef82be7e9ff6fd$export$2e2bcd8739ae039 = Object.freeze($ddef82be7e9ff6fd$var$description);


const $c0ca6cdddd245cb4$var$development_tenant = {
    notification: "You're in development mode"
};
var $c0ca6cdddd245cb4$export$2e2bcd8739ae039 = Object.freeze($c0ca6cdddd245cb4$var$development_tenant);


const $73c7ef6d7997085b$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "At least {{min}} types of characters are required.",
    unsupported_characters: "Unsupported character found.",
    pwned: "Avoid using simple passwords that are easy to guess.",
    restricted_found: "Avoid overusing {{list, list}}.",
    restricted: {
        repetition: "repeated characters",
        sequence: "sequential characters",
        user_info: "your personal information",
        words: "product context"
    }
};
var $73c7ef6d7997085b$export$2e2bcd8739ae039 = Object.freeze($73c7ef6d7997085b$var$password_rejected);


const $ba179dac2be7d6a3$var$error = {
    general_required: `{{types, list(type: disjunction;)}} is required`,
    general_invalid: `The {{types, list(type: disjunction;)}} is invalid`,
    username_required: "Username is required",
    password_required: "Password is required",
    username_exists: "Username already exists",
    username_should_not_start_with_number: "Username should not start with a number",
    username_invalid_charset: "Username should only contain letters, numbers, or underscores.",
    invalid_email: "The email is invalid",
    invalid_phone: "The phone number is invalid",
    passwords_do_not_match: "Your passwords don’t match. Please try again.",
    invalid_passcode: "The verification code is invalid",
    invalid_connector_auth: "The authorization is invalid",
    invalid_connector_request: "The connector data is invalid",
    unknown: "Unknown error. Please try again later.",
    invalid_session: "Session not found. Please go back and sign in again.",
    timeout: "Request timeout. Please try again later.",
    password_rejected: $73c7ef6d7997085b$export$2e2bcd8739ae039,
    sso_not_enabled: "Single Sign-On is not enabled for this email account."
};
var $ba179dac2be7d6a3$export$2e2bcd8739ae039 = Object.freeze($ba179dac2be7d6a3$var$error);


const $f8397626d61f21e8$var$input = {
    username: "Username",
    password: "Password",
    email: "Email",
    phone_number: "Phone number",
    confirm_password: "Confirm password",
    search_region_code: "Search region code",
    backup_code: "Backup code"
};
var $f8397626d61f21e8$export$2e2bcd8739ae039 = Object.freeze($f8397626d61f21e8$var$input);


const $5a6db1e6599a4472$var$list = {
    or: "or",
    and: "and",
    separator: ","
};
var $5a6db1e6599a4472$export$2e2bcd8739ae039 = Object.freeze($5a6db1e6599a4472$var$list);


const $0d14ba7e0435bf15$var$mfa = {
    totp: "Authenticator app OTP",
    webauthn: "Passkey",
    backup_code: "Backup code",
    link_totp_description: "E.g., Google Authenticator, etc.",
    link_webauthn_description: "Link your device or USB hardware",
    link_backup_code_description: "Generate a backup code",
    verify_totp_description: "Enter the one-time code in app",
    verify_webauthn_description: "Verify your device or USB hardware",
    verify_backup_code_description: "Paste the backup code you saved",
    add_mfa_factors: "Add 2-step verification",
    add_mfa_description: "Two-factor verification is enabled. Select your second verification method for secure sign-in.",
    verify_mfa_factors: "2-step verification",
    verify_mfa_description: "2-step verification has been enabled for this account. Please select the second way to verify your identity.",
    add_authenticator_app: "Add authenticator app",
    step: "Step {{step, number}}: {{content}}",
    scan_qr_code: "Scan this QR code",
    scan_qr_code_description: "Scan the following QR code with your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Can’t scan the QR code?",
    copy_and_paste_key: "Copy and paste the key",
    copy_and_paste_key_description: "Copy and paste the following key into your authenticator app, such as Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Want to scan QR code?",
    enter_one_time_code: "Enter the one-time code",
    enter_one_time_code_link_description: "Enter the 6-digit verification code generated by the authenticator app.",
    enter_one_time_code_description: "2-step verification has been enabled for this account. Please enter the one-time code shown on your linked authenticator app.",
    link_another_mfa_factor: "Switch to another method",
    save_backup_code: "Save your backup code",
    save_backup_code_description: "You can use one of these backup code to access your account if you have trouble during 2-step verification in another ways. Each code may be used only once.",
    backup_code_hint: "Make sure copy them and save in a safe place.",
    enter_a_backup_code: "Enter a backup code",
    enter_backup_code_description: "Enter the backup code you saved when the 2-step verification was initially enabled.",
    create_a_passkey: "Create a passkey",
    create_passkey_description: "Register your passkey using device biometrics, security keys (e.g., YubiKey), or other available methods.",
    try_another_verification_method: "Try another method to verify",
    verify_via_passkey: "Verify via passkey",
    verify_via_passkey_description: "Use passkey to verify by your device password or biometrics, scanning QR code, or using USB security key like YubiKey.",
    secret_key_copied: "Secret key copied.",
    backup_code_copied: "Backup code copied.",
    webauthn_not_ready: "WebAuthn is not ready yet. Please try again later.",
    webauthn_not_supported: "WebAuthn is not supported in this browser.",
    webauthn_failed_to_create: "Failed to create. Please try again.",
    webauthn_failed_to_verify: "Failed to verify. Please try again."
};
var $0d14ba7e0435bf15$export$2e2bcd8739ae039 = Object.freeze($0d14ba7e0435bf15$var$mfa);


const $0556864cac9d7070$var$secondary = {
    social_bind_with: "Already had an account? Sign in to link {{methods, list(type: disjunction;)}} with your social identity."
};
var $0556864cac9d7070$export$2e2bcd8739ae039 = Object.freeze($0556864cac9d7070$var$secondary);


const $569450392e7041f1$var$en = {
    translation: {
        input: $f8397626d61f21e8$export$2e2bcd8739ae039,
        secondary: $0556864cac9d7070$export$2e2bcd8739ae039,
        action: $2bbca6646a53e50a$export$2e2bcd8739ae039,
        description: $ddef82be7e9ff6fd$export$2e2bcd8739ae039,
        error: $ba179dac2be7d6a3$export$2e2bcd8739ae039,
        list: $5a6db1e6599a4472$export$2e2bcd8739ae039,
        mfa: $0d14ba7e0435bf15$export$2e2bcd8739ae039,
        development_tenant: $c0ca6cdddd245cb4$export$2e2bcd8739ae039
    }
};
var $569450392e7041f1$export$2e2bcd8739ae039 = Object.freeze($569450392e7041f1$var$en);


const $c793390f52b95db9$var$action = {
    sign_in: "Iniciar sesi\xf3n",
    continue: "Continuar",
    create_account: "Crear una cuenta",
    create_account_without_linking: "Crear una cuenta sin vinculaci\xf3n",
    create: "Crear",
    enter_passcode: "Ingresar c\xf3digo de verificaci\xf3n",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar contrase\xf1a",
    bind: "Vincular con {{address}}",
    bind_and_continue: "Vincular y continuar",
    back: "Regresar",
    nav_back: "Atr\xe1s",
    nav_skip: "Omitir",
    agree: "Aceptar",
    got_it: "Entendido",
    sign_in_with: "Continuar con {{name}}",
    forgot_password: "\xbfOlvidaste tu contrase\xf1a?",
    switch_to: "Cambiar a {{method}}",
    sign_in_via_passcode: "Iniciar sesi\xf3n con c\xf3digo de verificaci\xf3n",
    sign_in_via_password: "Iniciar sesi\xf3n con contrase\xf1a",
    change: "Cambiar {{method}}",
    link_another_email: "Vincular otro correo electr\xf3nico",
    link_another_phone: "Vincular otro n\xfamero de tel\xe9fono",
    link_another_email_or_phone: "Vincular otro correo electr\xf3nico o n\xfamero de tel\xe9fono",
    show_password: "Mostrar contrase\xf1a",
    copy: "Copiar",
    verify_via_passkey: "Verificar mediante clave de acceso",
    download: "Descargar",
    single_sign_on: "Inicio de sesi\xf3n \xfanico"
};
var $c793390f52b95db9$export$2e2bcd8739ae039 = Object.freeze($c793390f52b95db9$var$action);


const $99038c525a057250$var$description = {
    email: "correo electr\xf3nico",
    phone_number: "n\xfamero de tel\xe9fono",
    username: "nombre de usuario",
    reminder: "Recordatorio",
    not_found: "404 No encontrado",
    agree_with_terms: "He le\xeddo y acepto los ",
    agree_with_terms_modal: "Para continuar, por favor acepte los <link></link>.",
    terms_of_use: "T\xe9rminos de uso",
    sign_in: "Iniciar sesi\xf3n",
    privacy_policy: "Pol\xedtica de privacidad",
    create_account: "Crear cuenta",
    or: "o",
    and: "y",
    enter_passcode: "El c\xf3digo de verificaci\xf3n ha sido enviado a su {{address}} {{target}}",
    passcode_sent: "El c\xf3digo de verificaci\xf3n ha sido reenviado",
    resend_after_seconds: "Reenviar despu\xe9s de <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verificaci\xf3n",
    create_account_id_exists: "La cuenta con {{type}} {{value}} ya existe, \xbfdesea iniciar sesi\xf3n?",
    link_account_id_exists: "La cuenta con {{type}} {{value}} ya existe. \xbfDesea vincular?",
    sign_in_id_does_not_exist: "La cuenta con {{type}} {{value}} no existe, \xbfdesea crear una nueva cuenta?",
    sign_in_id_does_not_exist_alert: "La cuenta con {{type}} {{value}} no existe.",
    create_account_id_exists_alert: "La cuenta con {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    social_identity_exist: "La {{type}} {{value}} est\xe1 vinculada a otra cuenta. Por favor intente con otra {{type}}.",
    bind_account_title: "Vincular o crear cuenta",
    social_create_account: "Puede crear una nueva cuenta.",
    social_link_email: "Puede vincular otro correo electr\xf3nico",
    social_link_phone: "Puede vincular otro tel\xe9fono",
    social_link_email_or_phone: "Puede vincular otro correo electr\xf3nico o tel\xe9fono",
    social_bind_with_existing: "Hemos encontrado una cuenta relacionada, puede vincularla directamente.",
    reset_password: "Restablecer contrase\xf1a",
    reset_password_description: "Ingrese los {{types, lista(type: disyunci\xf3n;)}} asociados a su cuenta, y le enviaremos el c\xf3digo de verificaci\xf3n para restablecer su contrase\xf1a.",
    new_password: "Nueva contrase\xf1a",
    set_password: "Establecer contrase\xf1a",
    password_changed: "Contrase\xf1a cambiada",
    no_account: "\xbfNo tiene una cuenta todav\xeda? ",
    have_account: "\xbfYa tiene una cuenta?",
    enter_password: "Ingrese la contrase\xf1a",
    enter_password_for: "Inicie sesi\xf3n con la contrase\xf1a de {{method}} {{value}}",
    enter_username: "Establecer nombre de usuario",
    enter_username_description: "El nombre de usuario es una alternativa para iniciar sesi\xf3n. Debe contener solo letras, n\xfameros y guiones bajos.",
    link_email: "Vincular correo electr\xf3nico",
    link_phone: "Vincular tel\xe9fono",
    link_email_or_phone: "Vincular correo electr\xf3nico o tel\xe9fono",
    link_email_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico con la cuenta.",
    link_phone_description: "Para mayor seguridad, por favor vincule su tel\xe9fono con la cuenta.",
    link_email_or_phone_description: "Para mayor seguridad, por favor vincule su correo electr\xf3nico o tel\xe9fono con la cuenta.",
    continue_with_more_information: "Para mayor seguridad, por favor complete los detalles de su cuenta a continuaci\xf3n.",
    create_your_account: "Cree su cuenta",
    sign_in_to_your_account: "Inicie sesi\xf3n en su cuenta",
    no_region_code_found: "No se encontr\xf3 c\xf3digo de regi\xf3n",
    verify_email: "Verificar su correo electr\xf3nico",
    verify_phone: "Verificar su n\xfamero de tel\xe9fono",
    password_requirements: "Contrase\xf1a {{items, lista}}.",
    password_requirement: {
        length_one: "requiere un m\xednimo de {{count}} car\xe1cter",
        length_other: "requiere un m\xednimo de {{count}} caracteres",
        character_types_one: "debe contener al menos {{count}} tipo de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos",
        character_types_other: "debe contener al menos {{count}} tipos de letras may\xfasculas, letras min\xfasculas, d\xedgitos y s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Ingrese su direcci\xf3n de correo electr\xf3nico corporativo",
    single_sign_on_connectors_list: "Su empresa ha habilitado el inicio de sesi\xf3n \xfanico (Single Sign-On) para la cuenta de correo electr\xf3nico {{email}}. Puede continuar iniciando sesi\xf3n con los siguientes proveedores de SSO.",
    single_sign_on_enabled: "El inicio de sesi\xf3n \xfanico (Single Sign-On) est\xe1 habilitado para esta cuenta"
};
var $99038c525a057250$export$2e2bcd8739ae039 = Object.freeze($99038c525a057250$var$description);


const $082cfaf00825684d$var$development_tenant = {
    notification: "Est\xe1s en modo de desarrollo"
};
var $082cfaf00825684d$export$2e2bcd8739ae039 = Object.freeze($082cfaf00825684d$var$development_tenant);


const $0e6cf0f24e250820$var$password_rejected = {
    too_short: "La longitud m\xednima es {{min}}.",
    too_long: "La longitud m\xe1xima es {{max}}.",
    character_types: "Se necesitan al menos {{min}} tipos de caracteres.",
    unsupported_characters: "Se encontr\xf3 un car\xe1cter no admitido.",
    pwned: "Evite usar contrase\xf1as simples que sean f\xe1ciles de adivinar.",
    restricted_found: "Evite utilizar en exceso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres secuenciales",
        user_info: "su informaci\xf3n personal",
        words: "contexto del producto"
    }
};
var $0e6cf0f24e250820$export$2e2bcd8739ae039 = Object.freeze($0e6cf0f24e250820$var$password_rejected);


const $d0710e94d911f359$var$error = {
    general_required: `{{types, list(type: disjunction;)}} es requerido`,
    general_invalid: `El/La {{types, list(type: disjunction;)}} no es válido`,
    username_required: "Se requiere un nombre de usuario",
    password_required: "Se requiere una contrase\xf1a",
    username_exists: "El nombre de usuario ya existe",
    username_should_not_start_with_number: "El nombre de usuario no debe comenzar con un n\xfamero",
    username_invalid_charset: "El nombre de usuario solo debe contener letras, n\xfameros o guiones bajos.",
    invalid_email: "El correo electr\xf3nico no es v\xe1lido",
    invalid_phone: "El n\xfamero de tel\xe9fono no es v\xe1lido",
    passwords_do_not_match: "Las contrase\xf1as no coinciden. Por favor intente de nuevo",
    invalid_passcode: "El c\xf3digo de verificaci\xf3n no es v\xe1lido",
    invalid_connector_auth: "La autorizaci\xf3n no es v\xe1lida",
    invalid_connector_request: "Los datos del conector no son v\xe1lidos",
    unknown: "Error desconocido. Por favor intente de nuevo m\xe1s tarde.",
    invalid_session: "No se encontr\xf3 la sesi\xf3n. Por favor regrese e inicie sesi\xf3n nuevamente.",
    timeout: "Tiempo de espera de solicitud agotado. Por favor intente de nuevo m\xe1s tarde.",
    password_rejected: $0e6cf0f24e250820$export$2e2bcd8739ae039,
    sso_not_enabled: "El inicio de sesi\xf3n \xfanico no est\xe1 habilitado para esta cuenta de correo electr\xf3nico."
};
var $d0710e94d911f359$export$2e2bcd8739ae039 = Object.freeze($d0710e94d911f359$var$error);


const $f50df72949847708$var$input = {
    username: "Nombre de usuario",
    password: "Contrase\xf1a",
    email: "Correo electr\xf3nico",
    phone_number: "N\xfamero de tel\xe9fono",
    confirm_password: "Confirmar contrase\xf1a",
    search_region_code: "C\xf3digo de regi\xf3n de b\xfasqueda",
    backup_code: "C\xf3digo de respaldo"
};
var $f50df72949847708$export$2e2bcd8739ae039 = Object.freeze($f50df72949847708$var$input);


const $0b9477e46354d9fd$var$list = {
    or: "o",
    and: "y",
    separator: ","
};
var $0b9477e46354d9fd$export$2e2bcd8739ae039 = Object.freeze($0b9477e46354d9fd$var$list);


const $0e63c821592baa6e$var$mfa = {
    totp: "OTP de la aplicaci\xf3n autenticadora",
    webauthn: "Contrase\xf1a",
    backup_code: "C\xf3digo de respaldo",
    link_totp_description: "Ej., Google Authenticator, etc.",
    link_webauthn_description: "Vincule su dispositivo o hardware USB",
    link_backup_code_description: "Genere un c\xf3digo de respaldo",
    verify_totp_description: "Ingrese el c\xf3digo de un solo uso en la aplicaci\xf3n",
    verify_webauthn_description: "Verifique su dispositivo o hardware USB",
    verify_backup_code_description: "Pegue el c\xf3digo de respaldo que guard\xf3",
    add_mfa_factors: "Agregar verificaci\xf3n de 2 pasos",
    add_mfa_description: "La verificaci\xf3n de dos factores est\xe1 habilitada. Seleccione su segundo m\xe9todo de verificaci\xf3n para iniciar sesi\xf3n de forma segura.",
    verify_mfa_factors: "Verificaci\xf3n de 2 pasos",
    verify_mfa_description: "La verificaci\xf3n de 2 pasos se ha habilitado para esta cuenta. Seleccione la segunda forma de verificar su identidad.",
    add_authenticator_app: "Agregar aplicaci\xf3n autenticadora",
    step: "Paso {{step, number}}: {{content}}",
    scan_qr_code: "Escanee este c\xf3digo QR",
    scan_qr_code_description: "Escanee el siguiente c\xf3digo QR con su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "\xbfNo puede escanear el c\xf3digo QR?",
    copy_and_paste_key: "Copie y pegue la clave",
    copy_and_paste_key_description: "Copie y pegue la siguiente clave en su aplicaci\xf3n autenticadora, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "\xbfQuiere escanear el c\xf3digo QR?",
    enter_one_time_code: "Ingrese el c\xf3digo de un solo uso",
    enter_one_time_code_link_description: "Ingrese el c\xf3digo de verificaci\xf3n de 6 d\xedgitos generado por la aplicaci\xf3n autenticadora.",
    enter_one_time_code_description: "Se ha habilitado la verificaci\xf3n en dos pasos para esta cuenta. Por favor, ingrese el c\xf3digo de un solo uso que se muestra en su aplicaci\xf3n de autenticaci\xf3n vinculada.",
    link_another_mfa_factor: "Cambiar a otro m\xe9todo",
    save_backup_code: "Guarde su c\xf3digo de respaldo",
    save_backup_code_description: "Puede usar uno de estos c\xf3digos de respaldo para acceder a su cuenta si tiene problemas durante la verificaci\xf3n de 2 pasos de otras maneras. Cada c\xf3digo solo se puede usar una vez.",
    backup_code_hint: "Aseg\xfarese de copiarlos y guardarlos en un lugar seguro.",
    enter_a_backup_code: "Ingrese un c\xf3digo de respaldo",
    enter_backup_code_description: "Ingrese el c\xf3digo de respaldo que guard\xf3 cuando se habilit\xf3 la verificaci\xf3n de 2 pasos inicialmente.",
    create_a_passkey: "Crear una contrase\xf1a",
    create_passkey_description: "Registre su contrase\xf1a utilizando la biometr\xeda del dispositivo, claves de seguridad (por ejemplo, YubiKey) u otros m\xe9todos disponibles.",
    try_another_verification_method: "Pruebe otro m\xe9todo de verificaci\xf3n",
    verify_via_passkey: "Verificar mediante contrase\xf1a",
    verify_via_passkey_description: "Use la contrase\xf1a para verificar mediante la contrase\xf1a de su dispositivo o biometr\xeda, escanee el c\xf3digo QR o use una clave de seguridad USB como YubiKey.",
    secret_key_copied: "Clave secreta copiada.",
    backup_code_copied: "C\xf3digo de respaldo copiado.",
    webauthn_not_ready: "WebAuthn a\xfan no est\xe1 listo. Por favor, int\xe9ntelo de nuevo m\xe1s tarde.",
    webauthn_not_supported: "WebAuthn no es compatible con este navegador.",
    webauthn_failed_to_create: "Error al crear. Por favor, int\xe9ntelo de nuevo.",
    webauthn_failed_to_verify: "Error al verificar. Por favor, int\xe9ntelo de nuevo."
};
var $0e63c821592baa6e$export$2e2bcd8739ae039 = Object.freeze($0e63c821592baa6e$var$mfa);


const $810fbb4c9ff24ca3$var$secondary = {
    social_bind_with: "\xbfYa tienes una cuenta? Inicia sesi\xf3n para vincular {{methods, list(type: disjunction;)}} con tu identidad social."
};
var $810fbb4c9ff24ca3$export$2e2bcd8739ae039 = Object.freeze($810fbb4c9ff24ca3$var$secondary);


const $2859dca83214d271$var$es = {
    translation: {
        input: $f50df72949847708$export$2e2bcd8739ae039,
        secondary: $810fbb4c9ff24ca3$export$2e2bcd8739ae039,
        action: $c793390f52b95db9$export$2e2bcd8739ae039,
        description: $99038c525a057250$export$2e2bcd8739ae039,
        error: $d0710e94d911f359$export$2e2bcd8739ae039,
        list: $0b9477e46354d9fd$export$2e2bcd8739ae039,
        mfa: $0e63c821592baa6e$export$2e2bcd8739ae039,
        development_tenant: $082cfaf00825684d$export$2e2bcd8739ae039
    }
};
var $2859dca83214d271$export$2e2bcd8739ae039 = Object.freeze($2859dca83214d271$var$es);


const $c32c8eba1af913fb$var$action = {
    sign_in: "Connexion",
    continue: "Continuer",
    create_account: "Cr\xe9er un compte",
    create_account_without_linking: "Cr\xe9er un compte sans lier",
    create: "Cr\xe9er",
    enter_passcode: "Entrer le code",
    confirm: "Confirmer",
    cancel: "Annuler",
    save_password: "Enregistrer le mot de passe",
    bind: "Lier avec {{address}}",
    bind_and_continue: "Lier et continuer",
    back: "Aller en arri\xe8re",
    nav_back: "Retour",
    nav_skip: "Passer",
    agree: "Accepter",
    got_it: "Compris",
    sign_in_with: "Continuer avec {{name}}",
    forgot_password: "Mot de passe oubli\xe9?",
    switch_to: "Passer au {{method}}",
    sign_in_via_passcode: "Se connecter avec le code de v\xe9rification",
    sign_in_via_password: "Se connecter avec le mot de passe",
    change: "Changer {{method}}",
    link_another_email: "Lier une autre adresse e-mail",
    link_another_phone: "Lier un autre num\xe9ro de t\xe9l\xe9phone",
    link_another_email_or_phone: "Lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    show_password: "Afficher le mot de passe",
    copy: "Copier",
    verify_via_passkey: "V\xe9rifier via la cl\xe9 d'acc\xe8s",
    download: "T\xe9l\xe9charger",
    single_sign_on: "Connexion unique"
};
var $c32c8eba1af913fb$export$2e2bcd8739ae039 = Object.freeze($c32c8eba1af913fb$var$action);


const $7c2fb7f6c204ec06$var$description = {
    email: "email",
    phone_number: "num\xe9ro de t\xe9l\xe9phone",
    username: "nom d'utilisateur",
    reminder: "Rappel",
    not_found: "404 Non trouv\xe9",
    agree_with_terms: "J'ai lu et accept\xe9 les ",
    agree_with_terms_modal: "Pour continuer, veuillez accepter le <link></link>.",
    terms_of_use: "Conditions d'utilisation",
    sign_in: "Connexion",
    privacy_policy: "Politique de confidentialit\xe9",
    create_account: "Cr\xe9er un compte",
    or: "ou",
    and: "et",
    enter_passcode: "Le code a \xe9t\xe9 envoy\xe9 \xe0 {{address}} {{target}}",
    passcode_sent: "Le code a \xe9t\xe9 renvoy\xe9",
    resend_after_seconds: "Renvoyer apr\xe8s <span>{{seconds}}</span> secondes",
    resend_passcode: "Renvoyer le code",
    create_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous vous connecter?",
    link_account_id_exists: "Le compte avec {{type}} {{value}} existe d\xe9j\xe0, voulez-vous le lier?",
    sign_in_id_does_not_exist: "Le compte avec {{type}} {{value}} n'existe pas, voulez-vous cr\xe9er un nouveau compte?",
    sign_in_id_does_not_exist_alert: "Nous ne trouvons aucun compte associ\xe9 \xe0 {{type}} {{value}}.",
    create_account_id_exists_alert: "Le compte avec {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    social_identity_exist: "Le {{type}} {{value}} est li\xe9 \xe0 un autre compte. Veuillez essayer un autre {{type}}.",
    bind_account_title: "Lier ou cr\xe9er un compte",
    social_create_account: "Vous pouvez cr\xe9er un nouveau compte",
    social_link_email: "Vous pouvez lier une autre adresse e-mail",
    social_link_phone: "Vous pouvez lier un autre num\xe9ro de t\xe9l\xe9phone",
    social_link_email_or_phone: "Vous pouvez lier une autre adresse e-mail ou un autre num\xe9ro de t\xe9l\xe9phone",
    social_bind_with_existing: "Nous avons trouv\xe9 une {{method}} connexe qui a \xe9t\xe9 enregistr\xe9e, et vous pouvez la lier directement.",
    reset_password: "Mot de passe oubli\xe9",
    reset_password_description: "Entrez le {{types, list(type: disjunction;)}} associ\xe9 \xe0 votre compte et nous vous enverrons le code de v\xe9rification pour r\xe9initialiser votre mot de passe.",
    new_password: "Nouveau mot de passe",
    set_password: "D\xe9finir un mot de passe",
    password_changed: "Mot de passe modifi\xe9",
    no_account: "Pas encore de compte? ",
    have_account: "D\xe9j\xe0 un compte?",
    enter_password: "Entrer le mot de passe",
    enter_password_for: "Connectez-vous avec le mot de passe pour {{method}} {{value}}",
    enter_username: "D\xe9finir un nom d'utilisateur",
    enter_username_description: "Le nom d'utilisateur est une alternative pour la connexion. Le nom d'utilisateur doit contenir uniquement des lettres, des chiffres et des underscores.",
    link_email: "Lier l'adresse e-mail",
    link_phone: "Lier le num\xe9ro de t\xe9l\xe9phone",
    link_email_or_phone: "Lier l'adresse e-mail ou le num\xe9ro de t\xe9l\xe9phone",
    link_email_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail au compte.",
    link_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre num\xe9ro de t\xe9l\xe9phone au compte.",
    link_email_or_phone_description: "Pour une s\xe9curit\xe9 accrue, veuillez lier votre adresse e-mail ou votre num\xe9ro de t\xe9l\xe9phone au compte.",
    continue_with_more_information: "Pour une s\xe9curit\xe9 accrue, veuillez compl\xe9ter les d\xe9tails du compte ci-dessous.",
    create_your_account: "Cr\xe9er votre compte",
    sign_in_to_your_account: "Connecte-toi \xe0 ton compte",
    no_region_code_found: "Aucun code de r\xe9gion trouv\xe9",
    verify_email: "V\xe9rifiez votre e-mail",
    verify_phone: "V\xe9rifiez votre num\xe9ro de t\xe9l\xe9phone",
    password_requirements: "Mot de passe {{items, list}}.",
    password_requirement: {
        length_one: "doit contenir au minimum {{count}} caract\xe8re",
        length_other: "doit contenir au minimum {{count}} caract\xe8res",
        character_types_one: "doit contenir au moins {{count}} type de lettres majuscules, lettres minuscules, chiffres et symboles",
        character_types_other: "doit contenir au moins {{count}} types de lettres majuscules, lettres minuscules, chiffres et symboles"
    },
    use: "Utiliser",
    single_sign_on_email_form: "Entrez votre adresse e-mail d'entreprise",
    single_sign_on_connectors_list: "Votre entreprise a activ\xe9 la connexion unique (Single Sign-On) pour le compte email {{email}}. Vous pouvez continuer \xe0 vous connecter avec les fournisseurs SSO suivants.",
    single_sign_on_enabled: "La connexion unique (Single Sign-On) est activ\xe9e pour ce compte"
};
var $7c2fb7f6c204ec06$export$2e2bcd8739ae039 = Object.freeze($7c2fb7f6c204ec06$var$description);


const $420d03959419eba2$var$development_tenant = {
    notification: "Vous \xeates en mode d\xe9veloppement"
};
var $420d03959419eba2$export$2e2bcd8739ae039 = Object.freeze($420d03959419eba2$var$development_tenant);


const $bf23452b9ca70e55$var$password_rejected = {
    too_short: "La longueur minimale est {{min}}.",
    too_long: "La longueur maximale est {{max}}.",
    character_types: "Au moins {{min}} types de caract\xe8res sont requis.",
    unsupported_characters: "Caract\xe8re non support\xe9 trouv\xe9.",
    pwned: "\xc9vitez d'utiliser des mots de passe simples faciles \xe0 deviner.",
    restricted_found: "\xc9vitez d'utiliser de mani\xe8re excessive {{list, list}}.",
    restricted: {
        repetition: "caract\xe8res r\xe9p\xe9t\xe9s",
        sequence: "caract\xe8res s\xe9quentiels",
        user_info: "vos informations personnelles",
        words: "contexte produit"
    }
};
var $bf23452b9ca70e55$export$2e2bcd8739ae039 = Object.freeze($bf23452b9ca70e55$var$password_rejected);


const $4a466f2119693c40$var$error = {
    general_required: "Le {{types, list(type: disjunction;)}} est requis",
    general_invalid: "Le {{types, list(type: disjunction;)}} n'est pas valide",
    username_required: "Le nom d'utilisateur est requis",
    password_required: "Le mot de passe est requis",
    username_exists: "Ce Nom d'utilisateur existe d\xe9j\xe0",
    username_should_not_start_with_number: "Le nom d'utilisateur ne doit pas commencer par un chiffre",
    username_invalid_charset: "Le nom d'utilisateur ne doit contenir que des lettres, des chiffres ou des caract\xe8res de soulignement.",
    invalid_email: "L'email n'est pas valide",
    invalid_phone: "Le num\xe9ro de t\xe9l\xe9phone n'est pas valide",
    passwords_do_not_match: "Les mots de passe ne correspondent pas",
    invalid_passcode: "Le code est invalide",
    invalid_connector_auth: "L'autorisation n'est pas valide",
    invalid_connector_request: "Les donn\xe9es du connecteur ne sont pas valides",
    unknown: "Erreur inconnue. Veuillez r\xe9essayer plus tard.",
    invalid_session: "Session non trouv\xe9e. Veuillez revenir en arri\xe8re et vous connecter \xe0 nouveau.",
    timeout: "D\xe9lai d'attente de la requ\xeate d\xe9pass\xe9. Veuillez r\xe9essayer plus tard.",
    password_rejected: $bf23452b9ca70e55$export$2e2bcd8739ae039,
    sso_not_enabled: "La authentification unique n'est pas activ\xe9e pour ce compte de messagerie."
};
var $4a466f2119693c40$export$2e2bcd8739ae039 = Object.freeze($4a466f2119693c40$var$error);


const $782e1fe0425c0009$var$input = {
    username: "Nom d'utilisateur",
    password: "Mot de passe",
    email: "Email",
    phone_number: "Num\xe9ro de t\xe9l\xe9phone",
    confirm_password: "Confirmer le mot de passe",
    search_region_code: "Rechercher le code de r\xe9gion",
    backup_code: "Code de sauvegarde"
};
var $782e1fe0425c0009$export$2e2bcd8739ae039 = Object.freeze($782e1fe0425c0009$var$input);


const $feadb2b8d0358160$var$list = {
    or: "ou",
    and: "et",
    separator: ","
};
var $feadb2b8d0358160$export$2e2bcd8739ae039 = Object.freeze($feadb2b8d0358160$var$list);


const $4b81d58ba465da05$var$mfa = {
    totp: "OTP de l'application d'authentification",
    webauthn: "Passkey",
    backup_code: "Code de sauvegarde",
    link_totp_description: "Par exemple, Google Authenticator, etc.",
    link_webauthn_description: "Associez votre appareil ou mat\xe9riel USB",
    link_backup_code_description: "G\xe9n\xe9rez un code de sauvegarde",
    verify_totp_description: "Saisissez le code \xe0 usage unique dans l'application",
    verify_webauthn_description: "V\xe9rifiez votre appareil ou mat\xe9riel USB",
    verify_backup_code_description: "Collez le code de sauvegarde que vous avez enregistr\xe9",
    add_mfa_factors: "Ajouter la v\xe9rification en deux \xe9tapes",
    add_mfa_description: "La v\xe9rification en deux \xe9tapes est activ\xe9e. S\xe9lectionnez votre deuxi\xe8me m\xe9thode de v\xe9rification pour une connexion s\xe9curis\xe9e.",
    verify_mfa_factors: "V\xe9rification en deux \xe9tapes",
    verify_mfa_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez s\xe9lectionner la deuxi\xe8me fa\xe7on de v\xe9rifier votre identit\xe9.",
    add_authenticator_app: "Ajouter une application d'authentification",
    step: "\xc9tape {{step, number}} : {{content}}",
    scan_qr_code: "Scannez ce code QR",
    scan_qr_code_description: "Scannez le code QR suivant avec votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "Impossible de scanner le code QR ?",
    copy_and_paste_key: "Copiez et collez la cl\xe9",
    copy_and_paste_key_description: "Copiez et collez la cl\xe9 suivante dans votre application d'authentification, telle que Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Vous voulez scanner le code QR ?",
    enter_one_time_code: "Saisissez le code \xe0 usage unique",
    enter_one_time_code_link_description: "Saisissez le code de v\xe9rification \xe0 6 chiffres g\xe9n\xe9r\xe9 par l'application d'authentification.",
    enter_one_time_code_description: "La v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e pour ce compte. Veuillez entrer le code \xe0 usage unique affich\xe9 sur votre application d'authentification li\xe9e.",
    link_another_mfa_factor: "Passez \xe0 une autre m\xe9thode",
    save_backup_code: "Enregistrez votre code de sauvegarde",
    save_backup_code_description: "Vous pouvez utiliser l'un de ces codes de sauvegarde pour acc\xe9der \xe0 votre compte en cas de probl\xe8me lors de la v\xe9rification en deux \xe9tapes par d'autres moyens. Chaque code ne peut \xeatre utilis\xe9 qu'une fois.",
    backup_code_hint: "Assurez-vous de les copier et de les sauvegarder dans un endroit s\xfbr.",
    enter_a_backup_code: "Saisissez un code de sauvegarde",
    enter_backup_code_description: "Saisissez le code de sauvegarde que vous avez enregistr\xe9 lorsque la v\xe9rification en deux \xe9tapes a \xe9t\xe9 activ\xe9e initialement.",
    create_a_passkey: "Cr\xe9ez une cl\xe9 d'acc\xe8s",
    create_passkey_description: "Enregistrez votre cl\xe9 d'acc\xe8s \xe0 l'aide de la biom\xe9trie de l'appareil, de cl\xe9s de s\xe9curit\xe9 (par exemple, YubiKey) ou d'autres m\xe9thodes disponibles.",
    try_another_verification_method: "Essayez une autre m\xe9thode de v\xe9rification",
    verify_via_passkey: "V\xe9rifiez via la cl\xe9 d'acc\xe8s",
    verify_via_passkey_description: "Utilisez la cl\xe9 d'acc\xe8s pour v\xe9rifier avec votre mot de passe ou la biom\xe9trie de votre appareil, en scannant le code QR ou en utilisant une cl\xe9 de s\xe9curit\xe9 USB comme la YubiKey.",
    secret_key_copied: "Cl\xe9 secr\xe8te copi\xe9e.",
    backup_code_copied: "Code de sauvegarde copi\xe9.",
    webauthn_not_ready: "WebAuthn n'est pas pr\xeat pour le moment. Veuillez r\xe9essayer plus tard.",
    webauthn_not_supported: "WebAuthn n'est pas pris en charge dans ce navigateur.",
    webauthn_failed_to_create: "\xc9chec de la cr\xe9ation. Veuillez r\xe9essayer.",
    webauthn_failed_to_verify: "\xc9chec de la v\xe9rification. Veuillez r\xe9essayer."
};
var $4b81d58ba465da05$export$2e2bcd8739ae039 = Object.freeze($4b81d58ba465da05$var$mfa);


const $de10b9ea5fe70b67$var$secondary = {
    social_bind_with: "Vous avez d\xe9j\xe0 un compte? Connectez-vous pour lier {{methods, list(type: disjunction;)}} avec votre identit\xe9 sociale."
};
var $de10b9ea5fe70b67$export$2e2bcd8739ae039 = Object.freeze($de10b9ea5fe70b67$var$secondary);


const $5c147e42498b9ce8$var$fr = {
    translation: {
        input: $782e1fe0425c0009$export$2e2bcd8739ae039,
        secondary: $de10b9ea5fe70b67$export$2e2bcd8739ae039,
        action: $c32c8eba1af913fb$export$2e2bcd8739ae039,
        description: $7c2fb7f6c204ec06$export$2e2bcd8739ae039,
        error: $4a466f2119693c40$export$2e2bcd8739ae039,
        list: $feadb2b8d0358160$export$2e2bcd8739ae039,
        mfa: $4b81d58ba465da05$export$2e2bcd8739ae039,
        development_tenant: $420d03959419eba2$export$2e2bcd8739ae039
    }
};
var $5c147e42498b9ce8$export$2e2bcd8739ae039 = Object.freeze($5c147e42498b9ce8$var$fr);


const $638f4d986038cd2c$var$action = {
    sign_in: "Accedi",
    continue: "Continua",
    create_account: "Crea account",
    create_account_without_linking: "Crea account senza collegare",
    create: "Crea",
    enter_passcode: "Inserisci il codice di verifica",
    confirm: "Conferma",
    cancel: "Annulla",
    save_password: "Salva password",
    bind: "Collega con {{address}}",
    bind_and_continue: "Collega e continua",
    back: "Torna indietro",
    nav_back: "Indietro",
    nav_skip: "Salta",
    agree: "Accetto",
    got_it: "Capito",
    sign_in_with: "Continua con {{name}}",
    forgot_password: "Hai dimenticato la password?",
    switch_to: "Passa a {{method}}",
    sign_in_via_passcode: "Accedi con il codice di verifica",
    sign_in_via_password: "Accedi con la password",
    change: "Cambia {{method}}",
    link_another_email: "Collega un altro indirizzo email",
    link_another_phone: "Collega un altro numero di telefono",
    link_another_email_or_phone: "Collega un altro indirizzo email o numero di telefono",
    show_password: "Mostra password",
    copy: "Copia",
    verify_via_passkey: "Verifica tramite passkey",
    download: "Scarica",
    single_sign_on: "Single Sign-On"
};
var $638f4d986038cd2c$export$2e2bcd8739ae039 = Object.freeze($638f4d986038cd2c$var$action);


const $e1550e8638b8a43a$var$description = {
    email: "email",
    phone_number: "numero di telefono",
    username: "username",
    reminder: "Promemoria",
    not_found: "404 Non trovato",
    agree_with_terms: "Ho letto e accetto i ",
    agree_with_terms_modal: "Per procedere, si prega di accettare i <link></link>.",
    terms_of_use: "Termini di utilizzo",
    sign_in: "Accedi",
    privacy_policy: "Informativa sulla privacy",
    create_account: "Crea account",
    or: "o",
    and: "e",
    enter_passcode: "Il codice di verifica \xe8 stato inviato alla tua {{address}} {{target}}",
    passcode_sent: "Il codice di verifica \xe8 stato inviato di nuovo",
    resend_after_seconds: "Inviare di nuovo dopo <span>{{seconds}}</span> secondi",
    resend_passcode: "Inviare nuovamente il codice di verifica",
    create_account_id_exists: "L'account con {{type}} {{value}} gi\xe0 esiste, vuoi accedere?",
    link_account_id_exists: "L'account con {{type}} {{value}} \xe8 gi\xe0 esistente. Vuoi collegarlo?",
    sign_in_id_does_not_exist: "L'account con {{type}} {{value}} non esiste, vuoi creare un nuovo account?",
    sign_in_id_does_not_exist_alert: "L'account con {{type}} {{value}} non esiste.",
    create_account_id_exists_alert: "L'account {{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    social_identity_exist: "L'{{type}} {{value}} \xe8 collegato ad un altro account. Prova con un altro {{type}}.",
    bind_account_title: "Collega o crea un account",
    social_create_account: "Puoi creare un nuovo account.",
    social_link_email: "Puoi collegare un'altra email",
    social_link_phone: "Puoi collegare un altro telefono",
    social_link_email_or_phone: "Puoi collegare un'altra email o telefono",
    social_bind_with_existing: "Abbiamo trovato un account correlato, puoi collegarlo direttamente.",
    reset_password: "Resetta la password",
    reset_password_description: "Inserisci il {{types, list(type: disjunction;)}} associato al tuo account, e ti invieremo il codice di verifica per resettare la password.",
    new_password: "Nuova password",
    set_password: "Imposta una password",
    password_changed: "Password cambiata",
    no_account: "Ancora nessun account? ",
    have_account: "Hai gi\xe0 un account?",
    enter_password: "Inserisci la password",
    enter_password_for: "Accedi con la password per {{method}} {{value}}",
    enter_username: "Imposta username",
    enter_username_description: "L'username \xe8 un'alternativa per l'accesso. L'username deve contenere solo lettere, numeri e trattini bassi.",
    link_email: "Collega emails",
    link_phone: "Collega telefono",
    link_email_or_phone: "Collega email o telefono",
    link_email_description: "Per maggiore sicurezza, collega la tua email all'account.",
    link_phone_description: "Per maggiore sicurezza, collega il tuo telefono all'account.",
    link_email_or_phone_description: "Per maggiore sicurezza, collega la tua email o il tuo telefono all'account.",
    continue_with_more_information: "Per maggiore sicurezza, completa i dettagli dell'account qui sotto.",
    create_your_account: "Crea il tuo account",
    sign_in_to_your_account: "Accedi al tuo account",
    no_region_code_found: "Nessun codice di regione trovato",
    verify_email: "Verifica la tua email",
    verify_phone: "Verifica il tuo numero di telefono",
    password_requirements: "Password {{items, list}}.",
    password_requirement: {
        length_one: "richiede almeno {{count}} carattere",
        length_other: "richiede almeno {{count}} caratteri",
        character_types_one: "dovrebbe contenere almeno {{count}} tipo di lettere maiuscole, lettere minuscole, numeri e simboli",
        character_types_other: "dovrebbe contenere almeno {{count}} tipi di lettere maiuscole, lettere minuscole, numeri e simboli"
    },
    use: "Utilizzare",
    single_sign_on_email_form: "Inserisci il tuo indirizzo email aziendale",
    single_sign_on_connectors_list: "La tua azienda ha abilitato il Single Sign-On per l'account email {{email}}. Puoi continuare ad accedere con i seguenti fornitori di SSO.",
    single_sign_on_enabled: "Il Single Sign-On \xe8 abilitato per questo account"
};
var $e1550e8638b8a43a$export$2e2bcd8739ae039 = Object.freeze($e1550e8638b8a43a$var$description);


const $6e9802499c2aabd2$var$development_tenant = {
    notification: "Sei in modalit\xe0 di sviluppo"
};
var $6e9802499c2aabd2$export$2e2bcd8739ae039 = Object.freeze($6e9802499c2aabd2$var$development_tenant);


const $d33f9c7c8394c319$var$password_rejected = {
    too_short: "La lunghezza minima \xe8 {{min}}.",
    too_long: "La lunghezza massima \xe8 {{max}}.",
    character_types: "Sono richiesti almeno {{min}} tipi di caratteri.",
    unsupported_characters: "Carattere non supportato trovato.",
    pwned: "Evita di utilizzare password semplici facili da indovinare.",
    restricted_found: "Evita di utilizzare in eccesso {{list, list}}.",
    restricted: {
        repetition: "caratteri ripetuti",
        sequence: "caratteri sequenziali",
        user_info: "le tue informazioni personali",
        words: "contesto del prodotto"
    }
};
var $d33f9c7c8394c319$export$2e2bcd8739ae039 = Object.freeze($d33f9c7c8394c319$var$password_rejected);


const $aa0bd7dffd492925$var$error = {
    general_required: `{{types, list(type: disjunction;)}} è richiesto`,
    general_invalid: `Il {{types, list(type: disjunction;)}} non è valido`,
    username_required: "Username \xe8 richiesto",
    password_required: "La password \xe8 richiesta",
    username_exists: "Username esiste gi\xe0",
    username_should_not_start_with_number: "L'username non dovrebbe iniziare con un numero",
    username_invalid_charset: "L'username dovrebbe contenere solo lettere, numeri o underscore.",
    invalid_email: "L'email non \xe8 valida",
    invalid_phone: "Il numero di telefono non \xe8 valido",
    passwords_do_not_match: "Le password non corrispondono. Per favore prova di nuovo.",
    invalid_passcode: "Il codice di verifica non \xe8 valido",
    invalid_connector_auth: "L'autorizzazione \xe8 invalida",
    invalid_connector_request: "I dati del connettore non sono validi",
    unknown: "Errore sconosciuto. Si prega di riprovare pi\xf9 tardi.",
    invalid_session: "Sessione non trovata. Si prega di tornare indietro e accedere di nuovo.",
    timeout: "Timeout della richiesta. Si prega di riprovare pi\xf9 tardi.",
    password_rejected: $d33f9c7c8394c319$export$2e2bcd8739ae039,
    sso_not_enabled: "Single sign-on non abilitato per questo account email."
};
var $aa0bd7dffd492925$export$2e2bcd8739ae039 = Object.freeze($aa0bd7dffd492925$var$error);


const $ad9924897a0ad666$var$input = {
    username: "Nome utente",
    password: "Password",
    email: "Email",
    phone_number: "Numero di telefono",
    confirm_password: "Conferma password",
    search_region_code: "Codice regione di ricerca",
    backup_code: "Codice di backup"
};
var $ad9924897a0ad666$export$2e2bcd8739ae039 = Object.freeze($ad9924897a0ad666$var$input);


const $42345c0a910a88c1$var$list = {
    or: "o",
    and: "e",
    separator: ","
};
var $42345c0a910a88c1$export$2e2bcd8739ae039 = Object.freeze($42345c0a910a88c1$var$list);


const $11c0d841dee33c95$var$mfa = {
    totp: "OTP dell'app Autenticatore",
    webauthn: "Passkey",
    backup_code: "Codice di backup",
    link_totp_description: "Ad esempio, Google Authenticator, ecc.",
    link_webauthn_description: "Collega il tuo dispositivo o hardware USB",
    link_backup_code_description: "Genera un codice di backup",
    verify_totp_description: "Inserisci il codice monouso nell'app",
    verify_webauthn_description: "Verifica il tuo dispositivo o hardware USB",
    verify_backup_code_description: "Incolla il codice di backup che hai salvato",
    add_mfa_factors: "Aggiungi la verifica in due passaggi",
    add_mfa_description: "La verifica in due passaggi \xe8 abilitata. Seleziona il tuo secondo metodo di verifica per un accesso sicuro.",
    verify_mfa_factors: "Verifica in due passaggi",
    verify_mfa_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Seleziona il secondo modo per verificare la tua identit\xe0.",
    add_authenticator_app: "Aggiungi app di autenticazione",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Scansiona questo codice QR",
    scan_qr_code_description: "Scansiona il seguente codice QR con la tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    qr_code_not_available: "Non \xe8 possibile scansionare il codice QR?",
    copy_and_paste_key: "Copia e incolla la chiave",
    copy_and_paste_key_description: "Copia e incolla la seguente chiave nella tua app di autenticazione, come Google Authenticator, Duo Mobile, Authy, ecc.",
    want_to_scan_qr_code: "Vuoi scansionare il codice QR?",
    enter_one_time_code: "Inserisci il codice monouso",
    enter_one_time_code_link_description: "Inserisci il codice di verifica a 6 cifre generato dall'app di autenticazione.",
    enter_one_time_code_description: "La verifica in due passaggi \xe8 stata abilitata per questo account. Inserisci il codice monouso mostrato sulla tua app di autenticazione collegata.",
    link_another_mfa_factor: "Passa a un altro metodo",
    save_backup_code: "Salva il codice di backup",
    save_backup_code_description: "Puoi utilizzare uno di questi codici di backup per accedere al tuo account in caso di problemi durante la verifica in due passaggi in altri modi. Ogni codice pu\xf2 essere utilizzato solo una volta.",
    backup_code_hint: "Assicurati di copiarli e salvarli in un luogo sicuro.",
    enter_a_backup_code: "Inserisci un codice di backup",
    enter_backup_code_description: "Inserisci il codice di backup salvato quando \xe8 stata abilitata la verifica in due passaggi.",
    create_a_passkey: "Crea una chiave di accesso",
    create_passkey_description: "Registra la tua chiave di accesso utilizzando le biometrie del dispositivo, le chiavi di sicurezza (ad esempio, YubiKey) o altri metodi disponibili.",
    try_another_verification_method: "Prova un altro metodo di verifica",
    verify_via_passkey: "Verifica tramite chiave di accesso",
    verify_via_passkey_description: "Usa la chiave di accesso per verificare tramite la password o le biometrie del tuo dispositivo, la scansione del codice QR o l'uso di una chiave di sicurezza USB come YubiKey.",
    secret_key_copied: "Chiave segreta copiata.",
    backup_code_copied: "Codice di backup copiato.",
    webauthn_not_ready: "WebAuthn non \xe8 ancora pronto. Riprova pi\xf9 tardi.",
    webauthn_not_supported: "WebAuthn non \xe8 supportato in questo browser.",
    webauthn_failed_to_create: "Impossibile creare. Riprova.",
    webauthn_failed_to_verify: "Verifica non riuscita. Riprova."
};
var $11c0d841dee33c95$export$2e2bcd8739ae039 = Object.freeze($11c0d841dee33c95$var$mfa);


const $abf9ab8384f8b6c8$var$secondary = {
    social_bind_with: "Gi\xe0 un account? Accedi per collegare {{methods, list(type: disjunction;)}} con la tua identit\xe0 sociale."
};
var $abf9ab8384f8b6c8$export$2e2bcd8739ae039 = Object.freeze($abf9ab8384f8b6c8$var$secondary);


const $9807ebe3a7f8f697$var$it = {
    translation: {
        input: $ad9924897a0ad666$export$2e2bcd8739ae039,
        secondary: $abf9ab8384f8b6c8$export$2e2bcd8739ae039,
        action: $638f4d986038cd2c$export$2e2bcd8739ae039,
        description: $e1550e8638b8a43a$export$2e2bcd8739ae039,
        error: $aa0bd7dffd492925$export$2e2bcd8739ae039,
        list: $42345c0a910a88c1$export$2e2bcd8739ae039,
        mfa: $11c0d841dee33c95$export$2e2bcd8739ae039,
        development_tenant: $6e9802499c2aabd2$export$2e2bcd8739ae039
    }
};
var $9807ebe3a7f8f697$export$2e2bcd8739ae039 = Object.freeze($9807ebe3a7f8f697$var$it);


const $a103ed85893d4957$var$action = {
    sign_in: "サインイン",
    continue: "続ける",
    create_account: "アカウントを作成する",
    create_account_without_linking: "リンクなしでアカウントを作成する",
    create: "作成する",
    enter_passcode: "認証コードを入力してください",
    confirm: "確認する",
    cancel: "キャンセル",
    save_password: "パスワードを保存する",
    bind: "{{address}} とリンクする",
    bind_and_continue: "リンクして続行する",
    back: "戻る",
    nav_back: "戻る",
    nav_skip: "スキップ",
    agree: "同意する",
    got_it: "わかりました",
    sign_in_with: "{{name}} で続ける",
    forgot_password: "パスワードを忘れましたか？",
    switch_to: "{{method}} に切り替える",
    sign_in_via_passcode: "認証コードでサインインする",
    sign_in_via_password: "パスワードでサインインする",
    change: "{{method}} を変更する",
    link_another_email: "別のメールアドレスをリンクする",
    link_another_phone: "別の電話番号をリンクする",
    link_another_email_or_phone: "別のメールアドレスまたは電話番号をリンクする",
    show_password: "パスワードを表示する",
    copy: "コピー",
    verify_via_passkey: "パスキー経由で確認",
    download: "ダウンロード",
    single_sign_on: "シングルサインオン"
};
var $a103ed85893d4957$export$2e2bcd8739ae039 = Object.freeze($a103ed85893d4957$var$action);


const $e9162bf1f8f3b714$var$description = {
    email: "メールアドレス",
    phone_number: "電話番号",
    username: "ユーザー名",
    reminder: "リマインダー",
    not_found: "404 Not Found",
    agree_with_terms: "以下に同意することを確認しました：",
    agree_with_terms_modal: "続行するには、<link></link>に同意してください。",
    terms_of_use: "利用規約",
    sign_in: "サインイン",
    privacy_policy: "プライバシーポリシー",
    create_account: "アカウントを作成する",
    or: "または",
    and: "及び",
    enter_passcode: "確認コードが{{address}} {{target}}に送信されました",
    passcode_sent: "確認コードを再送します",
    resend_after_seconds: "<span>{{seconds}}</span>秒後に再送信",
    resend_passcode: "確認コードを再送信します",
    create_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。ログインしますか？",
    link_account_id_exists: "{{type}} {{value}}でアカウントが既に存在しています。リンクしますか？",
    sign_in_id_does_not_exist: "{{type}} {{value}}のアカウントは存在しません。新しいアカウントを作成しますか？",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}}のアカウントは存在しません。",
    create_account_id_exists_alert: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    social_identity_exist: "{{type}} {{value}}は他のアカウントにリンクされています。他の{{type}}を試してください。",
    bind_account_title: "アカウントのリンクまたは作成",
    social_create_account: "新しいアカウントを作成できます。",
    social_link_email: "別のメールアドレスをリンクできます。",
    social_link_phone: "他の電話番号にリンクできます。",
    social_link_email_or_phone: "他のメールアドレスまたは電話番号にリンクできます。",
    social_bind_with_existing: "関連するアカウントが見つかりました。それを直接リンクできます。",
    reset_password: "パスワードを再設定する",
    reset_password_description: "アカウントに関連する{{types, list(type: disjunction;)}}を入力すると、パスワードの再設定に必要な確認コードが送信されます。",
    new_password: "新しいパスワード",
    set_password: "パスワードを設定する",
    password_changed: "パスワードが変更されました",
    no_account: "アカウントを作成していませんか？",
    have_account: "すでにアカウントをお持ちですか？",
    enter_password: "パスワードを入力する",
    enter_password_for: "{{method}} {{value}}でパスワードでサインインする",
    enter_username: "ユーザー名を入力する",
    enter_username_description: "ユーザー名はサインインの代替手段です。ユーザー名には、文字、数字、アンダースコアのみを含める必要があります。",
    link_email: "メールアドレスをリンクする",
    link_phone: "電話番号をリンクする",
    link_email_or_phone: "メールアドレスまたは電話番号をリンクする",
    link_email_description: "セキュリティを高めるために、アカウントにメールアドレスをリンクしてください。",
    link_phone_description: "セキュリティを高めるために、アカウントに電話番号をリンクしてください。",
    link_email_or_phone_description: "セキュリティを高めるために、アカウントに別のメールアドレスまたは電話番号をリンクしてください。",
    continue_with_more_information: "以下にアカウントの詳細を入力して、セキュリティを高めてください。",
    create_your_account: "アカウントを作成する",
    sign_in_to_your_account: "アカウントにサインインする",
    no_region_code_found: "地域コードが見つかりません",
    verify_email: "Eメールを確認する",
    verify_phone: "電話番号を確認する",
    password_requirements: "パスワード {{items, list}}。",
    password_requirement: {
        length_one: "最低 {{count}} 文字",
        length_other: "最低 {{count}} 文字",
        character_types_one: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります",
        character_types_other: "大文字、小文字、数字、記号のうち {{count}} 種類を含む必要があります"
    },
    use: "使用する",
    single_sign_on_email_form: "企業のメールアドレスを入力してください",
    single_sign_on_connectors_list: "あなたの企業は、メールアカウント{{email}}に対してシングルサインオンを有効にしました。以下のSSOプロバイダーを使用してサインインを続けることができます。",
    single_sign_on_enabled: "このアカウントではシングル サインオンが有効になっています"
};
var $e9162bf1f8f3b714$export$2e2bcd8739ae039 = Object.freeze($e9162bf1f8f3b714$var$description);


const $a7e0c8e81b7de1ff$var$development_tenant = {
    notification: "開発モードです"
};
var $a7e0c8e81b7de1ff$export$2e2bcd8739ae039 = Object.freeze($a7e0c8e81b7de1ff$var$development_tenant);


const $a1c45aaefd8804a3$var$password_rejected = {
    too_short: "最小の長さは{{min}}です。",
    too_long: "最大の長さは{{max}}です。",
    character_types: "少なくとも{{min}}種類の文字が必要です。",
    unsupported_characters: "サポートされていない文字が見つかりました。",
    pwned: "簡単に推測できる簡単なパスワードの使用を避けてください。",
    restricted_found: "{{list, list}}の過度な使用を避けてください。",
    restricted: {
        repetition: "繰り返された文字",
        sequence: "連続する文字",
        user_info: "個人情報",
        words: "製品のコンテキスト"
    }
};
var $a1c45aaefd8804a3$export$2e2bcd8739ae039 = Object.freeze($a1c45aaefd8804a3$var$password_rejected);


const $6d27ffd8ff43973a$var$error = {
    general_required: `{{types, list(type: disjunction;)}}が必要です`,
    general_invalid: `{{types, list(type: disjunction;)}}が無効です`,
    username_required: "ユーザー名が必要です",
    password_required: "パスワードが必要です",
    username_exists: "ユーザー名が既に存在しています",
    username_should_not_start_with_number: "ユーザー名は数字で始めることはできません",
    username_invalid_charset: "ユーザー名は文字、数字、またはアンダースコアのみを含める必要があります。",
    invalid_email: "メールアドレスが無効です",
    invalid_phone: "電話番号が無効です",
    passwords_do_not_match: "パスワードが一致しません。もう一度お試しください。",
    invalid_passcode: "検証コードが無効です",
    invalid_connector_auth: "認証が無効です",
    invalid_connector_request: "コネクターデータが無効です",
    unknown: "不明なエラーが発生しました。後でもう一度お試しください。",
    invalid_session: "セッションが見つかりません。もう一度サインインしてください。",
    timeout: "リクエストタイムアウト。後でもう一度お試しください。",
    password_rejected: $a1c45aaefd8804a3$export$2e2bcd8739ae039,
    sso_not_enabled: "このメールアカウントではシングルサインオンが有効になっていません。"
};
var $6d27ffd8ff43973a$export$2e2bcd8739ae039 = Object.freeze($6d27ffd8ff43973a$var$error);


const $39e76cf1740bff39$var$input = {
    username: "ユーザー名",
    password: "パスワード",
    email: "メールアドレス",
    phone_number: "電話番号",
    confirm_password: "パスワード確認",
    search_region_code: "地域コード検索",
    backup_code: "バックアップコード"
};
var $39e76cf1740bff39$export$2e2bcd8739ae039 = Object.freeze($39e76cf1740bff39$var$input);


const $bdf60940430acad6$var$list = {
    or: "または",
    and: "そして",
    separator: ","
};
var $bdf60940430acad6$export$2e2bcd8739ae039 = Object.freeze($bdf60940430acad6$var$list);


const $550de4f09de42118$var$mfa = {
    totp: "認証アプリOTP",
    webauthn: "パスキー",
    backup_code: "バックアップコード",
    link_totp_description: "例：Google Authenticator など",
    link_webauthn_description: "デバイスまたはUSBハードウェアをリンク",
    link_backup_code_description: "バックアップコードを生成",
    verify_totp_description: "アプリに表示されるワンタイムコードを入力",
    verify_webauthn_description: "デバイスまたはUSBハードウェアを確認",
    verify_backup_code_description: "保存したバックアップコードを貼り付け",
    add_mfa_factors: "2段階認証を追加",
    add_mfa_description: "2段階認証が有効になっています。安全なサインインのために第二の認証方法を選択してください。",
    verify_mfa_factors: "2段階認証",
    verify_mfa_description: "このアカウントでは2段階認証が有効になっています。アイデンティティを確認するための第二の方法を選択してください。",
    add_authenticator_app: "認証アプリを追加",
    step: "ステップ{{step, number}}：{{content}}",
    scan_qr_code: "このQRコードをスキャン",
    scan_qr_code_description: "次のQRコードを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）でスキャンしてください。",
    qr_code_not_available: "QRコードをスキャンできませんか？",
    copy_and_paste_key: "キーをコピーして貼り付ける",
    copy_and_paste_key_description: "次のキーを認証アプリ（例：Google Authenticator、Duo Mobile、Authyなど）にコピーして貼り付けてください。",
    want_to_scan_qr_code: "QRコードをスキャンしますか？",
    enter_one_time_code: "ワンタイムコードを入力",
    enter_one_time_code_link_description: "認証アプリで生成された6桁の確認コードを入力してください。",
    enter_one_time_code_description: "このアカウントでは2段階認証が有効になっています。リンクされた認証アプリに表示されるワンタイムコードを入力してください。",
    link_another_mfa_factor: "別の方法に切り替える",
    save_backup_code: "バックアップコードを保存",
    save_backup_code_description: "2段階認証中に他の方法で問題が発生した場合、これらのバックアップコードのいずれかを使用してアカウントにアクセスできます。各コードは一度だけ使用できます。",
    backup_code_hint: "必ずコピーして安全な場所に保存してください。",
    enter_a_backup_code: "バックアップコードを入力",
    enter_backup_code_description: "初めて2段階認証が有効になったときに保存したバックアップコードを入力してください。",
    create_a_passkey: "パスキーを作成",
    create_passkey_description: "デバイスの生体認証、セキュリティキー（例：YubiKey）などを使用してパスキーを登録します。",
    try_another_verification_method: "別の検証方法を試す",
    verify_via_passkey: "パスキーで確認",
    verify_via_passkey_description: "デバイスのパスワードまたは生体認証、QRコードのスキャン、YubiKeyなどのUSBセキュリティキーを使用してパスキーで確認します。",
    secret_key_copied: "秘密鍵がコピーされました。",
    backup_code_copied: "バックアップコードがコピーされました。",
    webauthn_not_ready: "WebAuthnはまだ準備ができていません。後でもう一度試してください。",
    webauthn_not_supported: "このブラウザではWebAuthnはサポートされていません。",
    webauthn_failed_to_create: "作成に失敗しました。もう一度試してください。",
    webauthn_failed_to_verify: "確認に失敗しました。もう一度試してください。"
};
var $550de4f09de42118$export$2e2bcd8739ae039 = Object.freeze($550de4f09de42118$var$mfa);


const $edddfc60a3f8f0a6$var$secondary = {
    social_bind_with: "既にアカウントを持っていますか？{{methods, list(type: disjunction;)}}をソーシャルアイデンティティにリンクするためにサインインしてください。"
};
var $edddfc60a3f8f0a6$export$2e2bcd8739ae039 = Object.freeze($edddfc60a3f8f0a6$var$secondary);


const $1800de568ffc42fb$var$ja = {
    translation: {
        input: $39e76cf1740bff39$export$2e2bcd8739ae039,
        secondary: $edddfc60a3f8f0a6$export$2e2bcd8739ae039,
        action: $a103ed85893d4957$export$2e2bcd8739ae039,
        description: $e9162bf1f8f3b714$export$2e2bcd8739ae039,
        error: $6d27ffd8ff43973a$export$2e2bcd8739ae039,
        list: $bdf60940430acad6$export$2e2bcd8739ae039,
        mfa: $550de4f09de42118$export$2e2bcd8739ae039,
        development_tenant: $a7e0c8e81b7de1ff$export$2e2bcd8739ae039
    }
};
var $1800de568ffc42fb$export$2e2bcd8739ae039 = Object.freeze($1800de568ffc42fb$var$ja);


const $f1a4cd61415d3513$var$action = {
    sign_in: "로그인",
    continue: "계속",
    create_account: "계정 생성",
    create_account_without_linking: "연동 없이 계정 생성하기",
    create: "생성",
    enter_passcode: "비밀번호 입력",
    confirm: "확인",
    cancel: "취소",
    save_password: "저장",
    bind: "{{address}}로 연동",
    bind_and_continue: "연동하고 계속하기",
    back: "뒤로 가기",
    nav_back: "뒤로",
    nav_skip: "건너뛰기",
    agree: "동의",
    got_it: "알겠습니다",
    sign_in_with: "{{name}} 계속",
    forgot_password: "비밀번호를 잊어버리셨나요?",
    switch_to: "{{method}}로 전환",
    sign_in_via_passcode: "인증번호로 로그인",
    sign_in_via_password: "비밀번호로 로그인",
    change: "변경 {{method}}",
    link_another_email: "다른 이메일 연동",
    link_another_phone: "다른 전화번호 연동",
    link_another_email_or_phone: "다른 이메일 또는 전화번호 연동",
    show_password: "비밀번호 보기",
    copy: "복사",
    verify_via_passkey: "패스키로 확인",
    download: "다운로드",
    single_sign_on: "단일 로그인"
};
var $f1a4cd61415d3513$export$2e2bcd8739ae039 = Object.freeze($f1a4cd61415d3513$var$action);


const $07370d1d62dc462e$var$description = {
    email: "이메일",
    phone_number: "휴대전화번호",
    username: "사용자 이름",
    reminder: "리마인더",
    not_found: "404 찾을 수 없음",
    agree_with_terms: "나는 내용을 읽었으며, 이에 동의합니다.",
    agree_with_terms_modal: "진행하기 위해서는, 다음을 동의해주세요 <link></link>.",
    terms_of_use: "이용약관",
    sign_in: "로그인",
    privacy_policy: "개인정보처리방침",
    create_account: "계정 생성",
    or: "또는",
    and: "그리고",
    enter_passcode: "{{address}} {{target}} 으로 비밀번호가 전송되었어요.",
    passcode_sent: "비밀번호가 재전송되었어요.",
    resend_after_seconds: "<span>{{seconds}}</span> 초 후에 재전송",
    resend_passcode: "비밀번호 재전송",
    create_account_id_exists: "{{type}} {{value}} 계정은 다른 계정과 연결되어 있습니다. 다른 {{type}}을(를) 시도해주세요.",
    link_account_id_exists: "{{type}} {{value}}와/과 연동된 계정이 이미 존재해요. 연동할까요?",
    sign_in_id_does_not_exist: "{type}} {{value}} 계정이 존재하지 않아요. 새로 만드시겠어요?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} 계정이 존재하지 않아요.",
    create_account_id_exists_alert: "{{type}} {{value}} 이미 존재해요.",
    social_identity_exist: "{{type}} {{value}}이/가 다른 계정과 연동되어 있어요. 다른 {{type}}을/를 시도해 보세요.",
    bind_account_title: "계정 만들거나 연동하기",
    social_create_account: "새로운 계정을 만들 수 있습니다.",
    social_link_email: "다른 이메일을 연동할 수 있어요",
    social_link_phone: "다른 휴대전화를 연동할 수 있어요",
    social_link_email_or_phone: "다른 이메일이나 휴대전화를 연동할 수 있어요",
    social_bind_with_existing: "등록된 관련 {{method}}이 있습니다. 직접 연결할 수 있습니다.",
    reset_password: "비밀번호를 잊으셨나요",
    reset_password_description: "귀하의 계정과 연결된 {{types, list(type: disjunction;)}}를 입력하면 비밀번호 재설정을 위한 인증 코드를 보내드립니다.",
    new_password: "새 비밀번호",
    set_password: "비밀번호 설정",
    password_changed: "비밀번호 변경됨",
    no_account: "계정이 없나요?",
    have_account: "이미 계정이 있나요?",
    enter_password: "비밀번호 입력",
    enter_password_for: "{{method}} {{value}} 비밀번호 로그인",
    enter_username: "사용자 이름 설정하기",
    enter_username_description: "사용자 이름은 로그인을 할 때 사용되요. 사용자 이름에는 문자, 숫자 및 밑줄만 포함되어야 해요.",
    link_email: "이메일 연동",
    link_phone: "휴대전화번호 연동",
    link_email_or_phone: "이메일 또는 휴대전화번호 연동",
    link_email_description: "더 나은 보안을 위해 이메일을 연동해 주세요.",
    link_phone_description: "더 나은 보안을 위해 휴대전화번호를 연동해 주세요.",
    link_email_or_phone_description: "더 나은 보안을 위해 이메일 또는 휴대전화번호를 연동해 주세요.",
    continue_with_more_information: "더 나은 보안을 위해 아래 자세한 내용을 따라 주세요.",
    create_your_account: "계정 생성하기",
    sign_in_to_your_account: "계정에 로그인하세요",
    no_region_code_found: "지역 코드를 찾을 수 없습니다.",
    verify_email: "이메일 인증",
    verify_phone: "휴대전화번호 인증",
    password_requirements: "비밀번호는 {{items, list}} 로 이루어져야 합니다.",
    password_requirement: {
        length_one: "최소 {{count}} 자 이상이어야 함",
        length_other: "최소 {{count}} 문자 이상이어야 함",
        character_types_one: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함",
        character_types_other: "최소 {{count}} 개의 대문자, 소문자, 숫자, 특수 기호를 포함해야 함"
    },
    use: "사용",
    single_sign_on_email_form: "기업 이메일 주소를 입력하세요",
    single_sign_on_connectors_list: "귀하의 기업은 {{email}} 이메일 계정에 대해 Single Sign-On을 활성화했습니다. 다음 SSO 제공업체를 사용하여 로그인을 계속할 수 있습니다.",
    single_sign_on_enabled: "이 계정에는 Single Sign-On이 활성화되어 있습니다."
};
var $07370d1d62dc462e$export$2e2bcd8739ae039 = Object.freeze($07370d1d62dc462e$var$description);


const $89d9eb913dbbf90b$var$development_tenant = {
    notification: "개발 모드입니다"
};
var $89d9eb913dbbf90b$export$2e2bcd8739ae039 = Object.freeze($89d9eb913dbbf90b$var$development_tenant);


const $4f2e2bc51a5752ff$var$password_rejected = {
    too_short: "최소 길이는 {{min}}입니다.",
    too_long: "최대 길이는 {{max}}입니다.",
    character_types: "최소 {{min}}개의 문자 유형이 필요합니다.",
    unsupported_characters: "지원되지 않는 문자가 발견되었습니다.",
    pwned: "추측하기 쉬운 간단한 암호 사용을 피하십시오.",
    restricted_found: "{{list, list}}을(를) 과도하게 사용하지 마십시오.",
    restricted: {
        repetition: "반복된 문자",
        sequence: "연속된 문자",
        user_info: "개인 정보",
        words: "품질 가능성"
    }
};
var $4f2e2bc51a5752ff$export$2e2bcd8739ae039 = Object.freeze($4f2e2bc51a5752ff$var$password_rejected);


const $519dae8559ffd315$var$error = {
    general_required: "{{types, list(type: disjunction;)}}은/는 필수예요.",
    general_invalid: "{{types, list(type: disjunction;)}}은/는 유효하지 않아요.",
    username_required: "사용자 이름은 필수예요.",
    password_required: "비밀번호는 필수예요.",
    username_exists: "사용자 이름이 이미 존재해요.",
    username_should_not_start_with_number: "사용자 이름은 숫자로 시작하면 안 돼요.",
    username_invalid_charset: "사용자 이름은 문자, 숫자, _(밑줄 문자) 로만 이루어져야 해요.",
    invalid_email: "이메일이 유효하지 않아요.",
    invalid_phone: "휴대전화번호가 유효하지 않아요.",
    passwords_do_not_match: "비밀번호가 일치하지 않아요.",
    invalid_passcode: "비밀번호가 유효하지 않아요.",
    invalid_connector_auth: "인증이 유효하지 않아요.",
    invalid_connector_request: "연동 정보가 유효하지 않아요.",
    unknown: "알 수 없는 오류가 발생했어요. 잠시 후에 시도해 주세요.",
    invalid_session: "세션을 찾을 수 없어요. 다시 로그인해 주세요.",
    timeout: "요청 시간이 초과되었어요. 잠시 후에 다시 시도해 주세요.",
    password_rejected: $4f2e2bc51a5752ff$export$2e2bcd8739ae039,
    sso_not_enabled: "이 이메일 계정에 대해 단일 로그인이 활성화되지 않았어요."
};
var $519dae8559ffd315$export$2e2bcd8739ae039 = Object.freeze($519dae8559ffd315$var$error);


const $f584c89d8ec13736$var$input = {
    username: "사용자 이름",
    password: "비밀번호",
    email: "이메일",
    phone_number: "휴대전화번호",
    confirm_password: "비밀번호 확인",
    search_region_code: "지역 코드 검색",
    backup_code: "백업 코드"
};
var $f584c89d8ec13736$export$2e2bcd8739ae039 = Object.freeze($f584c89d8ec13736$var$input);


const $ce70d99abf51042f$var$list = {
    or: "또는",
    and: "및",
    separator: ","
};
var $ce70d99abf51042f$export$2e2bcd8739ae039 = Object.freeze($ce70d99abf51042f$var$list);


const $4afeda6991b31476$var$mfa = {
    totp: "인증 앱 OTP",
    webauthn: "패스키",
    backup_code: "백업 코드",
    link_totp_description: "예: Google Authenticator 등",
    link_webauthn_description: "기기 또는 USB 하드웨어 연결",
    link_backup_code_description: "백업 코드 생성",
    verify_totp_description: "앱에 일회용 코드 입력",
    verify_webauthn_description: "기기 또는 USB 하드웨어 확인",
    verify_backup_code_description: "저장한 백업 코드 붙여넣기",
    add_mfa_factors: "2단계 인증 추가",
    add_mfa_description: "2단계 인증이 활성화되었습니다. 안전한 로그인을 위해 두 번째 인증 방법을 선택하세요.",
    verify_mfa_factors: "2단계 인증 확인",
    verify_mfa_description: "이 계정에 대해 2단계 인증이 활성화되었습니다. 신원을 확인하는 두 번째 방법을 선택하세요.",
    add_authenticator_app: "인증 앱 추가",
    step: "단계 {{step, number}}: {{content}}",
    scan_qr_code: "이 QR 코드 스캔",
    scan_qr_code_description: "Google Authenticator, Duo Mobile, Authy 등의 인증 앱으로 다음 QR 코드를 스캔하세요.",
    qr_code_not_available: "QR 코드를 스캔할 수 없나요?",
    copy_and_paste_key: "키 복사 및 붙여넣기",
    copy_and_paste_key_description: "다음 키를 Google Authenticator, Duo Mobile, Authy 등의 인증 앱에 복사하여 붙여넣으세요.",
    want_to_scan_qr_code: "QR 코드를 스캔하고 싶나요?",
    enter_one_time_code: "일회용 코드 입력",
    enter_one_time_code_link_description: "인증 앱에서 생성된 6자리 확인 코드를 입력하세요.",
    enter_one_time_code_description: "이 계정에서는 2단계 인증이 활성화되었습니다. 연결된 인증 앱에 표시된 일회용 코드를 입력하세요.",
    link_another_mfa_factor: "다른 방법으로 전환",
    save_backup_code: "백업 코드 저장",
    save_backup_code_description: "다른 방법으로 2단계 인증 중 문제가 발생하면 이러한 백업 코드 중 하나를 사용하여 계정에 액세스할 수 있습니다. 각 코드는 한 번만 사용할 수 있습니다.",
    backup_code_hint: "반드시 복사하고 안전한 곳에 저장하세요.",
    enter_a_backup_code: "백업 코드 입력",
    enter_backup_code_description: "2단계 인증이 초기에 활성화될 때 저장한 백업 코드를 입력하세요.",
    create_a_passkey: "패스키 생성",
    create_passkey_description: "기기 바이오메트릭스, 보안 키(예: YubiKey) 또는 기타 사용 가능한 방법을 사용하여 패스키를 등록하세요.",
    try_another_verification_method: "다른 방법으로 확인해보세요",
    verify_via_passkey: "패스키로 확인",
    verify_via_passkey_description: "디바이스 비밀번호 또는 바이오메트릭스, QR 코드 스캔 또는 YubiKey와 같은 USB 보안 키 사용하여 패스키로 확인하세요.",
    secret_key_copied: "비밀 키가 복사되었습니다.",
    backup_code_copied: "백업 코드가 복사되었습니다.",
    webauthn_not_ready: "WebAuthn이 아직 준비되지 않았습니다. 나중에 다시 시도하세요.",
    webauthn_not_supported: "이 브라우저에서는 WebAuthn이 지원되지 않습니다.",
    webauthn_failed_to_create: "생성 실패. 다시 시도하세요.",
    webauthn_failed_to_verify: "확인 실패. 다시 시도하세요."
};
var $4afeda6991b31476$export$2e2bcd8739ae039 = Object.freeze($4afeda6991b31476$var$mfa);


const $e6ae5b42dd3f46fd$var$secondary = {
    social_bind_with: "이미 계정이 있으신가요? {{methods, list(type: disjunction;)}}로 로그인 해보세요!"
};
var $e6ae5b42dd3f46fd$export$2e2bcd8739ae039 = Object.freeze($e6ae5b42dd3f46fd$var$secondary);


const $f947133fc81adadb$var$ko = {
    translation: {
        input: $f584c89d8ec13736$export$2e2bcd8739ae039,
        secondary: $e6ae5b42dd3f46fd$export$2e2bcd8739ae039,
        action: $f1a4cd61415d3513$export$2e2bcd8739ae039,
        description: $07370d1d62dc462e$export$2e2bcd8739ae039,
        error: $519dae8559ffd315$export$2e2bcd8739ae039,
        list: $ce70d99abf51042f$export$2e2bcd8739ae039,
        mfa: $4afeda6991b31476$export$2e2bcd8739ae039,
        development_tenant: $89d9eb913dbbf90b$export$2e2bcd8739ae039
    }
};
var $f947133fc81adadb$export$2e2bcd8739ae039 = Object.freeze($f947133fc81adadb$var$ko);


const $fa2441ee1115e6e0$var$action = {
    sign_in: "Zaloguj się",
    continue: "Kontynuuj",
    create_account: "Utw\xf3rz konto",
    create_account_without_linking: "Utw\xf3rz konto bez łączenia",
    create: "Utw\xf3rz",
    enter_passcode: "Wprowadź kod weryfikacyjny",
    confirm: "Potwierdź",
    cancel: "Anuluj",
    save_password: "Zapisz hasło",
    bind: "Połącz z {{address}}",
    bind_and_continue: "Połącz i kontynuuj",
    back: "Wr\xf3ć",
    nav_back: "Wstecz",
    nav_skip: "Pomiń",
    agree: "Zgadzam się",
    got_it: "Zrozumiałem",
    sign_in_with: "Kontynuuj z {{name}}",
    forgot_password: "Zapomniałeś hasła?",
    switch_to: "Przełącz na {{method}}",
    sign_in_via_passcode: "Zaloguj się za pomocą kodu weryfikacyjnego",
    sign_in_via_password: "Zaloguj się za pomocą hasła",
    change: "Zmień {{method}}",
    link_another_email: "Połącz inne konto email",
    link_another_phone: "Połącz inne konto telefoniczne",
    link_another_email_or_phone: "Połącz inne konto email lub telefoniczne",
    show_password: "Pokaż hasło",
    copy: "Kopiuj",
    verify_via_passkey: "Weryfikacja za pomocą klucza dostępu",
    download: "Pobierz",
    single_sign_on: "Pojedyncze logowanie"
};
var $fa2441ee1115e6e0$export$2e2bcd8739ae039 = Object.freeze($fa2441ee1115e6e0$var$action);


const $320a6e8cf9b7d861$var$description = {
    email: "adres email",
    phone_number: "numer telefonu",
    username: "nazwa użytkownika",
    reminder: "Przypomnienie",
    not_found: "404 Nie znaleziono",
    agree_with_terms: "Przeczytałem/am i zgadzam się z ",
    agree_with_terms_modal: "Do kontynuacji należy zaakceptować <link></link>.",
    terms_of_use: "Warunki korzystania",
    sign_in: "Zaloguj się",
    privacy_policy: "Polityka prywatności",
    create_account: "Utw\xf3rz konto",
    or: "lub",
    and: "i",
    enter_passcode: "Kod weryfikacyjny został wysłany na twoje {{address}} {{target}}",
    passcode_sent: "Kod weryfikacyjny został wysłany ponownie",
    resend_after_seconds: "Wyślij ponownie po <span>{{seconds}}</span> sekundach",
    resend_passcode: "Wyślij kod weryfikacyjny ponownie",
    create_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz się zalogować?",
    link_account_id_exists: "Konto z {{type}} {{value}} już istnieje. Czy chcesz je połączyć?",
    sign_in_id_does_not_exist: "Konto z {{type}} {{value}} nie istnieje. Czy chcesz utworzyć nowe konto?",
    sign_in_id_does_not_exist_alert: "Konto z {{type}} {{value}} nie istnieje.",
    create_account_id_exists_alert: "Konto z {{type}} {{value}} jest połączone z innym kontem. Spr\xf3buj inny {{type}}.",
    social_identity_exist: "{{type}} {{value}} jest połączony z innym kontem. Spr\xf3buj inny {{type}}.",
    bind_account_title: "Połącz lub utw\xf3rz konto",
    social_create_account: "Możesz utworzyć nowe konto.",
    social_link_email: "Możesz połączyć kolejny adres email",
    social_link_phone: "Możesz połączyć kolejny numer telefonu",
    social_link_email_or_phone: "Możesz połączyć kolejny adres email lub numer telefonu",
    social_bind_with_existing: "Znaleźliśmy powiązane konto, możesz je połączyć bezpośrednio.",
    reset_password: "Zresetuj hasło",
    reset_password_description: "Wpisz {{types, lista(type: złączonych;)}} związanego z twoim kontem, a wyślemy ci kod weryfikacyjny do zresetowania hasła.",
    new_password: "Nowe hasło",
    set_password: "Ustaw hasło",
    password_changed: "Hasło zmienione",
    no_account: "Nie masz jeszcze konta? ",
    have_account: "Masz już konto?",
    enter_password: "Wpisz hasło",
    enter_password_for: "Zaloguj się przy użyciu hasła do {{method}} {{value}}",
    enter_username: "Ustaw nazwę użytkownika",
    enter_username_description: "Nazwa użytkownika jest alternatywną formą logowania. Nazwa użytkownika powinna zawierać tylko litery, cyfry i podkreślenia.",
    link_email: "Połącz adres email",
    link_phone: "Połącz numer telefonu",
    link_email_or_phone: "Połącz adres email lub numer telefonu",
    link_email_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail.",
    link_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z numerem telefonu.",
    link_email_or_phone_description: "Dla zwiększenia bezpieczeństwa, proszę połączyć konto z adresem e-mail lub numerem telefonu.",
    continue_with_more_information: "Dla zwiększenia bezpieczeństwa, proszę uzupełnić poniższe informacje o koncie.",
    create_your_account: "Utw\xf3rz konto",
    sign_in_to_your_account: "Zaloguj się do swojego konta",
    no_region_code_found: "Nie znaleziono kodu regionu",
    verify_email: "Potwierdź sw\xf3j email",
    verify_phone: "Potwierdź sw\xf3j numer telefonu",
    password_requirements: "Wymagania dotyczące hasła {{items, list}}.",
    password_requirement: {
        length_one: "wymaga co najmniej {{count}} znaku",
        length_other: "wymaga co najmniej {{count}} znak\xf3w",
        character_types_one: "powinno zawierać co najmniej {{count}} rodzaj liter wielkich, małych liter, cyfr i symboli",
        character_types_other: "powinno zawierać co najmniej {{count}} rodzaje liter wielkich, małych liter, cyfr i symboli"
    },
    use: "Użyj",
    single_sign_on_email_form: "Wpisz sw\xf3j służbowy adres email",
    single_sign_on_connectors_list: "Twoja firma włączyła jednokrotne logowanie dla konta e-mail {{email}}. Możesz kontynuować logowanie za pomocą następujących dostawc\xf3w SSO.",
    single_sign_on_enabled: "To konto ma włączone jednokrotne logowanie."
};
var $320a6e8cf9b7d861$export$2e2bcd8739ae039 = Object.freeze($320a6e8cf9b7d861$var$description);


const $46a0af78fadb54f8$var$development_tenant = {
    notification: "Jesteś w trybie deweloperskim"
};
var $46a0af78fadb54f8$export$2e2bcd8739ae039 = Object.freeze($46a0af78fadb54f8$var$development_tenant);


const $88ffeb9d863495de$var$password_rejected = {
    too_short: "Minimalna długość to {{min}}.",
    too_long: "Maksymalna długość to {{max}}.",
    character_types: "Wymagane są przynajmniej {{min}} rodzaje znak\xf3w.",
    unsupported_characters: "Znaleziono niedozwolony znak.",
    pwned: "Unikaj używania prostych haseł, kt\xf3re są łatwe do odgadnięcia.",
    restricted_found: "Unikaj nadużywania {{list, list}}.",
    restricted: {
        repetition: "powtarzających się znak\xf3w",
        sequence: "sekwencyjnych znak\xf3w",
        user_info: "twoich informacji osobistych",
        words: "kontekstu produktu"
    }
};
var $88ffeb9d863495de$export$2e2bcd8739ae039 = Object.freeze($88ffeb9d863495de$var$password_rejected);


const $5ac1dec2963153fd$var$error = {
    general_required: `{{types, list(type: disjunction;)}} jest wymagany`,
    general_invalid: `{{types, list(type: disjunction;)}} jest nieprawidłowe`,
    username_required: "Nazwa użytkownika jest wymagana",
    password_required: "Hasło jest wymagane",
    username_exists: "Nazwa użytkownika już istnieje",
    username_should_not_start_with_number: "Nazwa użytkownika nie powinna zaczynać się od liczby",
    username_invalid_charset: "Nazwa użytkownika powinna zawierać tylko litery, liczby lub podkreślenia.",
    invalid_email: "Nieprawidłowy adres e-mail",
    invalid_phone: "Nieprawidłowy numer telefonu",
    passwords_do_not_match: "Hasła nie pasują do siebie. Proszę spr\xf3buj ponownie.",
    invalid_passcode: "Nieprawidłowy kod weryfikacyjny",
    invalid_connector_auth: "Nieprawidłowa autoryzacja",
    invalid_connector_request: "Nieprawidłowe dane konektora",
    unknown: "Nieznany błąd. Proszę spr\xf3buj ponownie p\xf3źniej.",
    invalid_session: "Sesja nie znaleziona. Proszę wr\xf3ć i zaloguj się ponownie.",
    timeout: "Czas żądania upłynął. Proszę spr\xf3buj ponownie p\xf3źniej.",
    password_rejected: $88ffeb9d863495de$export$2e2bcd8739ae039,
    sso_not_enabled: "Pojedyncze logowanie nie jest włączony dla tego konta e-mail."
};
var $5ac1dec2963153fd$export$2e2bcd8739ae039 = Object.freeze($5ac1dec2963153fd$var$error);


const $e784158667108ae9$var$input = {
    username: "Nazwa użytkownika",
    password: "Hasło",
    email: "E-mail",
    phone_number: "Numer telefonu",
    confirm_password: "Potwierdź hasło",
    search_region_code: "Kod regionu wyszukiwania",
    backup_code: "Kod kopii zapasowej"
};
var $e784158667108ae9$export$2e2bcd8739ae039 = Object.freeze($e784158667108ae9$var$input);


const $22fb58eee9638a7d$var$list = {
    or: "lub",
    and: "i",
    separator: ","
};
var $22fb58eee9638a7d$export$2e2bcd8739ae039 = Object.freeze($22fb58eee9638a7d$var$list);


const $da4f5891df0d6915$var$mfa = {
    totp: "OTP aplikacji autentykacyjnej",
    webauthn: "Klucz gł\xf3wny",
    backup_code: "Kod zapasowy",
    link_totp_description: "Np. Google Authenticator itp.",
    link_webauthn_description: "Połącz urządzenie lub sprzęt USB",
    link_backup_code_description: "Generuj kod zapasowy",
    verify_totp_description: "Wprowadź jednorazowy kod w aplikacji",
    verify_webauthn_description: "Zweryfikuj urządzenie lub sprzęt USB",
    verify_backup_code_description: "Wklej kod zapasowy, kt\xf3ry zapisałeś",
    add_mfa_factors: "Dodaj weryfikację dwuetapową",
    add_mfa_description: "Weryfikacja dwuetapowa jest włączona. Wybierz sw\xf3j drugi spos\xf3b weryfikacji dla bezpiecznego logowania.",
    verify_mfa_factors: "Weryfikacja dwuetapowa",
    verify_mfa_description: "Włączono weryfikację dwuetapową dla tego konta. Proszę wybrać drugi spos\xf3b weryfikacji swojej tożsamości.",
    add_authenticator_app: "Dodaj aplikację autentykacyjną",
    step: "Krok {{step, number}}: {{content}}",
    scan_qr_code: "Zeskanuj ten kod QR",
    scan_qr_code_description: "Zeskanuj poniższy kod QR za pomocą aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    qr_code_not_available: "Nie można zeskanować kodu QR?",
    copy_and_paste_key: "Skopiuj i wklej klucz",
    copy_and_paste_key_description: "Skopiuj i wklej poniższy klucz do aplikacji autentykacyjnej, takiej jak Google Authenticator, Duo Mobile, Authy, itp.",
    want_to_scan_qr_code: "Chcesz zeskanować kod QR?",
    enter_one_time_code: "Wprowadź jednorazowy kod",
    enter_one_time_code_link_description: "Wprowadź 6-cyfrowy kod weryfikacyjny wygenerowany przez aplikację autentykacyjną.",
    enter_one_time_code_description: "Dla tego konta włączono weryfikację dwuetapową. Proszę wprowadzić jednorazowy kod widoczny w aplikacji autentykacyjnej powiązanej z kontem.",
    link_another_mfa_factor: "Przełącz na inny spos\xf3b",
    save_backup_code: "Zapisz sw\xf3j kod zapasowy",
    save_backup_code_description: "Możesz użyć jednego z tych kod\xf3w zapasowych, aby uzyskać dostęp do swojego konta w przypadku problem\xf3w z weryfikacją dwuetapową w inny spos\xf3b. Każdy kod można użyć tylko raz.",
    backup_code_hint: "Upewnij się, że je skopiujesz i zapiszesz w bezpiecznym miejscu.",
    enter_a_backup_code: "Wprowadź kod zapasowy",
    enter_backup_code_description: "Wprowadź kod zapasowy, kt\xf3ry zapisałeś, gdy włączono weryfikację dwuetapową.",
    create_a_passkey: "Utw\xf3rz klucz dostępu",
    create_passkey_description: "Zarejestruj sw\xf3j klucz dostępu za pomocą biometrii urządzenia, kluczy bezpieczeństwa (np. YubiKey) lub innych dostępnych metod.",
    try_another_verification_method: "Wypr\xf3buj inny spos\xf3b weryfikacji",
    verify_via_passkey: "Zweryfikuj za pomocą klucza dostępu",
    verify_via_passkey_description: "Użyj klucza dostępu do weryfikacji za pomocą hasła urządzenia lub biometrii, skanowania kodu QR lub użycia klucza bezpieczeństwa USB, takiego jak YubiKey.",
    secret_key_copied: "Skopiowano klucz prywatny.",
    backup_code_copied: "Skopiowano kod zapasowy.",
    webauthn_not_ready: "WebAuthn nie jest jeszcze gotowy. Spr\xf3buj ponownie p\xf3źniej.",
    webauthn_not_supported: "WebAuthn nie jest obsługiwane w tej przeglądarce.",
    webauthn_failed_to_create: "Nie udało się utworzyć. Spr\xf3buj ponownie.",
    webauthn_failed_to_verify: "Nie udało się zweryfikować. Spr\xf3buj ponownie."
};
var $da4f5891df0d6915$export$2e2bcd8739ae039 = Object.freeze($da4f5891df0d6915$var$mfa);


const $d6acbeccb77e2aae$var$secondary = {
    social_bind_with: "Masz już konto? Zaloguj się, aby połączyć {{methods, list(type: disjunction;)}} z twoją tożsamością społeczną."
};
var $d6acbeccb77e2aae$export$2e2bcd8739ae039 = Object.freeze($d6acbeccb77e2aae$var$secondary);


const $579cd5047d2c6635$var$pl_pl = {
    translation: {
        input: $e784158667108ae9$export$2e2bcd8739ae039,
        secondary: $d6acbeccb77e2aae$export$2e2bcd8739ae039,
        action: $fa2441ee1115e6e0$export$2e2bcd8739ae039,
        description: $320a6e8cf9b7d861$export$2e2bcd8739ae039,
        error: $5ac1dec2963153fd$export$2e2bcd8739ae039,
        list: $22fb58eee9638a7d$export$2e2bcd8739ae039,
        mfa: $da4f5891df0d6915$export$2e2bcd8739ae039,
        development_tenant: $46a0af78fadb54f8$export$2e2bcd8739ae039
    }
};
var $579cd5047d2c6635$export$2e2bcd8739ae039 = Object.freeze($579cd5047d2c6635$var$pl_pl);


const $ce80a86693cfd3f0$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar conta",
    create_account_without_linking: "Criar conta sem vincular",
    create: "Criar",
    enter_passcode: "Inserir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Salvar senha",
    bind: "Link com {{address}}",
    bind_and_continue: "Linkar e continuar",
    back: "Voltar",
    nav_back: "Voltar",
    nav_skip: "Pular",
    agree: "Aceito",
    got_it: "Entendido",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu sua senha?",
    switch_to: "Trocar para {{method}}",
    sign_in_via_passcode: "Fazer login com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Fazer login com senha",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro e-mail",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro e-mail ou telefone",
    show_password: "Mostrar senha",
    copy: "Copiar",
    verify_via_passkey: "Verificar via chave de acesso",
    download: "Baixar",
    single_sign_on: "Single Sign-On"
};
var $ce80a86693cfd3f0$export$2e2bcd8739ae039 = Object.freeze($ce80a86693cfd3f0$var$action);


const $937f4f000b857886$var$description = {
    email: "e-mail",
    phone_number: "n\xfamero de telefone",
    username: "nome de usu\xe1rio",
    reminder: "Lembrete",
    not_found: "404 N\xe3o Encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para continuar, por favor, concorde com os <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar depois <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de entrar?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincular?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma nova conta?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Voc\xea pode criar uma nova conta.",
    social_link_email: "\xc9 poss\xedvel vincular outro e-mail",
    social_link_phone: "\xc9 poss\xedvel vincular outro telefone",
    social_link_email_or_phone: "\xc9 poss\xedvel vincular outro e-mail ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Digite o {{types, list(type: disjunction;)}} \xe0 sua conta e enviaremos a voc\xea o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova senha",
    set_password: "Configurar senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta? ",
    have_account: "J\xe1 tinha uma conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Entre com a senha para {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para fazer login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Linkar e-mail",
    link_phone: "Linkar telefone",
    link_email_or_phone: "Linkar e-mail ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule seu e-mail \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule seu e-mail ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, preencha os detalhes da conta abaixo.",
    create_your_account: "Crie sua conta",
    sign_in_to_your_account: "Fa\xe7a login na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verificar e-mail",
    verify_phone: "Verificar n\xfamero de telefone",
    password_requirements: "Senha {{items, list}}.",
    password_requirement: {
        length_one: "requer no m\xednimo 1 caractere.",
        length_other: "requer no m\xednimo {{count}} caracteres.",
        character_types_one: "deve conter pelo menos 1 tipo de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo.",
        character_types_other: "deve conter pelo menos {{count}} tipos de letra mai\xfascula, letra min\xfascula, d\xedgito e s\xedmbolo."
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de e-mail corporativo",
    single_sign_on_connectors_list: "Sua empresa ativou o Single Sign-On para a conta de email {{email}}. Voc\xea pode continuar a fazer login com os seguintes provedores de SSO.",
    single_sign_on_enabled: "Esta conta tem Single Sign-On ativado."
};
var $937f4f000b857886$export$2e2bcd8739ae039 = Object.freeze($937f4f000b857886$var$description);


const $6a4d795864f7d5e9$var$development_tenant = {
    notification: "Voc\xea est\xe1 no modo de desenvolvimento"
};
var $6a4d795864f7d5e9$export$2e2bcd8739ae039 = Object.freeze($6a4d795864f7d5e9$var$development_tenant);


const $e8ff27f11d4ed65a$var$password_rejected = {
    too_short: "O comprimento m\xednimo \xe9 {{min}}.",
    too_long: "O comprimento m\xe1ximo \xe9 {{max}}.",
    character_types: "Pelo menos {{min}} tipos de caracteres s\xe3o necess\xe1rios.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite usar em excesso {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $e8ff27f11d4ed65a$export$2e2bcd8739ae039 = Object.freeze($e8ff27f11d4ed65a$var$password_rejected);


const $76879c485fcec7e2$var$error = {
    general_required: "{{types, list(type: disjunction;)}} \xe9 obrigat\xf3rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Nome de usu\xe1rio \xe9 obrigat\xf3rio",
    password_required: "Senha \xe9 obrigat\xf3rio",
    username_exists: "O nome de usu\xe1rio j\xe1 existe",
    username_should_not_start_with_number: "O nome de usu\xe1rio n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de usu\xe1rio deve conter apenas letras, n\xfameros ou sublinhados.",
    invalid_email: "O e-mail \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "Suas senhas n\xe3o correspondem. Por favor, tente novamente.",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite excedido. Por favor, tente novamente mais tarde.",
    password_rejected: $e8ff27f11d4ed65a$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $76879c485fcec7e2$export$2e2bcd8739ae039 = Object.freeze($76879c485fcec7e2$var$error);


const $3461dced2b14210f$var$input = {
    username: "Nome de usu\xe1rio",
    password: "Senha",
    email: "E-mail",
    phone_number: "N\xfamero de telefone",
    confirm_password: "Confirme a senha",
    search_region_code: "Pesquisar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $3461dced2b14210f$export$2e2bcd8739ae039 = Object.freeze($3461dced2b14210f$var$input);


const $f51f9e27ff712b63$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $f51f9e27ff712b63$export$2e2bcd8739ae039 = Object.freeze($f51f9e27ff712b63$var$list);


const $b3541398fdddf238$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Digite o c\xf3digo \xfanico no aplicativo",
    verify_webauthn_description: "Verifique seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que voc\xea salvou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione seu segundo m\xe9todo de verifica\xe7\xe3o para login seguro.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Escanear este c\xf3digo QR",
    scan_qr_code_description: "Escanee o seguinte c\xf3digo QR com seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue escanear o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave no seu aplicativo autenticador, como Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer escanear o c\xf3digo QR?",
    enter_one_time_code: "Digite o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Digite o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pelo aplicativo autenticador.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi habilitada para esta conta. Por favor, insira o c\xf3digo de uso \xfanico mostrado no seu aplicativo autenticador vinculado.",
    link_another_mfa_factor: "Trocar para outro m\xe9todo",
    save_backup_code: "Salve seu c\xf3digo de backup",
    save_backup_code_description: "Voc\xea pode usar um desses c\xf3digos de backup para acessar sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras maneiras. Cada c\xf3digo pode ser usado apenas uma vez.",
    backup_code_hint: "Certifique-se de copi\xe1-los e salvar em um local seguro.",
    enter_a_backup_code: "Digite um c\xf3digo de backup",
    enter_backup_code_description: "Digite o c\xf3digo de backup que voc\xea salvou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma senha",
    create_passkey_description: "Registre sua senha usando biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar via senha",
    verify_via_passkey_description: "Use a senha para verificar por meio da senha do seu dispositivo ou biometria, escaneando o c\xf3digo QR ou usando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $b3541398fdddf238$export$2e2bcd8739ae039 = Object.freeze($b3541398fdddf238$var$mfa);


const $9c3ba4b17f5eeb9a$var$secondary = {
    social_bind_with: "J\xe1 tinha uma conta? Fa\xe7a login no link {{methods, list(type: disjunction;)}} com sua identidade social."
};
var $9c3ba4b17f5eeb9a$export$2e2bcd8739ae039 = Object.freeze($9c3ba4b17f5eeb9a$var$secondary);


const $686cff689f541990$var$pt_br = {
    translation: {
        input: $3461dced2b14210f$export$2e2bcd8739ae039,
        secondary: $9c3ba4b17f5eeb9a$export$2e2bcd8739ae039,
        action: $ce80a86693cfd3f0$export$2e2bcd8739ae039,
        description: $937f4f000b857886$export$2e2bcd8739ae039,
        error: $76879c485fcec7e2$export$2e2bcd8739ae039,
        list: $f51f9e27ff712b63$export$2e2bcd8739ae039,
        mfa: $b3541398fdddf238$export$2e2bcd8739ae039,
        development_tenant: $6a4d795864f7d5e9$export$2e2bcd8739ae039
    }
};
var $686cff689f541990$export$2e2bcd8739ae039 = Object.freeze($686cff689f541990$var$pt_br);


const $81cc24c405cbf754$var$action = {
    sign_in: "Entrar",
    continue: "Continuar",
    create_account: "Criar uma conta",
    create_account_without_linking: "Criar conta sem vincula\xe7\xe3o",
    create: "Criar",
    enter_passcode: "Introduzir c\xf3digo de verifica\xe7\xe3o",
    confirm: "Confirmar",
    cancel: "Cancelar",
    save_password: "Guardar palavra-passe",
    bind: "Agregar a {{address}}",
    bind_and_continue: "Ligar e continuar",
    back: "Voltar",
    nav_back: "Anterior",
    nav_skip: "Saltar",
    agree: "Aceito",
    got_it: "Entendi",
    sign_in_with: "Continuar com {{name}}",
    forgot_password: "Esqueceu-se da palavra-passe?",
    switch_to: "Mudar para {{method}}",
    sign_in_via_passcode: "Iniciar sess\xe3o com c\xf3digo de verifica\xe7\xe3o",
    sign_in_via_password: "Iniciar sess\xe3o com palavra-passe",
    change: "Alterar {{method}}",
    link_another_email: "Vincular outro email",
    link_another_phone: "Vincular outro telefone",
    link_another_email_or_phone: "Vincular outro email ou telefone",
    show_password: "Mostrar palavra-passe",
    copy: "Copiar",
    verify_via_passkey: "Verificar atrav\xe9s de chave de acesso",
    download: "Transferir",
    single_sign_on: "Logon \xdanico"
};
var $81cc24c405cbf754$export$2e2bcd8739ae039 = Object.freeze($81cc24c405cbf754$var$action);


const $ca7046ebea050d55$var$description = {
    email: "email",
    phone_number: "telefone",
    username: "utilizador",
    reminder: "Lembrete",
    not_found: "404 N\xe3o encontrado",
    agree_with_terms: "Eu li e concordo com os ",
    agree_with_terms_modal: "Para prosseguir, por favor, concorde com o <link></link>.",
    terms_of_use: "Termos de uso",
    sign_in: "Entrar",
    privacy_policy: "Pol\xedtica de privacidade",
    create_account: "Criar uma conta",
    or: "ou",
    and: "e",
    enter_passcode: "O c\xf3digo de verifica\xe7\xe3o foi enviado para o seu {{address}} {{target}}",
    passcode_sent: "O c\xf3digo de verifica\xe7\xe3o foi reenviado",
    resend_after_seconds: "Reenviar ap\xf3s <span>{{seconds}}</span> segundos",
    resend_passcode: "Reenviar c\xf3digo de verifica\xe7\xe3o",
    create_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de fazer login?",
    link_account_id_exists: "A conta com {{type}} {{value}} j\xe1 existe, gostaria de vincul\xe1-la?",
    sign_in_id_does_not_exist: "A conta com {{type}} {{value}} n\xe3o existe, gostaria de criar uma?",
    sign_in_id_does_not_exist_alert: "A conta com {{type}} {{value}} n\xe3o existe.",
    create_account_id_exists_alert: "A conta com {{type}} {{value}} est\xe1 vinculada a outra conta. Por favor, tente outro {{type}}.",
    social_identity_exist: "O {{type}} {{value}} est\xe1 vinculado a outra conta. Por favor, tente outro {{type}}.",
    bind_account_title: "Vincular ou criar conta",
    social_create_account: "Pode criar uma nova conta.",
    social_link_email: "Pode vincular outro email",
    social_link_phone: "Pode vincular outro telefone",
    social_link_email_or_phone: "Pode vincular outro email ou telefone",
    social_bind_with_existing: "Encontramos uma conta relacionada registrada e voc\xea pode vincul\xe1-la diretamente.",
    reset_password: "Esqueceu a senha",
    reset_password_description: "Insira os {{types, list(type: disjunction;)}} associados \xe0 sua conta e enviaremos o c\xf3digo de verifica\xe7\xe3o para redefinir sua senha.",
    new_password: "Nova Senha",
    set_password: "Definir senha",
    password_changed: "Senha alterada",
    no_account: "Ainda n\xe3o tem conta?",
    have_account: "J\xe1 tem conta?",
    enter_password: "Digite a senha",
    enter_password_for: "Fa\xe7a login com a senha do {{method}} {{value}}",
    enter_username: "Definir nome de usu\xe1rio",
    enter_username_description: "O nome de usu\xe1rio \xe9 uma alternativa para o login. O nome de usu\xe1rio deve conter apenas letras, n\xfameros e sublinhados.",
    link_email: "Vincular email",
    link_phone: "Vincular telefone",
    link_email_or_phone: "Vincular email ou telefone",
    link_email_description: "Para maior seguran\xe7a, vincule o seu email \xe0 conta.",
    link_phone_description: "Para maior seguran\xe7a, vincule o seu telefone \xe0 conta.",
    link_email_or_phone_description: "Para maior seguran\xe7a, vincule o seu email ou telefone \xe0 conta.",
    continue_with_more_information: "Para maior seguran\xe7a, por favor complete os detalhes da conta abaixo.",
    create_your_account: "Crie a sua conta",
    sign_in_to_your_account: "Inicie sess\xe3o na sua conta",
    no_region_code_found: "N\xe3o foi poss\xedvel encontrar o c\xf3digo de regi\xe3o do seu telefone.",
    verify_email: "Verifique o seu email",
    verify_phone: "Verifique o seu n\xfamero de telefone",
    password_requirements: "Requisitos de senha {{items, list}}.",
    password_requirement: {
        length_one: "requer um m\xednimo de {{count}} caracter",
        length_other: "requer um m\xednimo de {{count}} caracteres",
        character_types_one: "deve conter pelo menos {{count}} tipo de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos",
        character_types_other: "deve conter pelo menos {{count}} tipos de letras mai\xfasculas, letras min\xfasculas, d\xedgitos e s\xedmbolos"
    },
    use: "Usar",
    single_sign_on_email_form: "Insira o endere\xe7o de email corporativo",
    single_sign_on_connectors_list: "A sua empresa ativou o Single Sign-On para a conta de email {{email}}. Pode continuar a iniciar sess\xe3o com os seguintes fornecedores de SSO.",
    single_sign_on_enabled: "Esta conta tem o Single Sign-On ativado."
};
var $ca7046ebea050d55$export$2e2bcd8739ae039 = Object.freeze($ca7046ebea050d55$var$description);


const $f3407ed1cf38d35e$var$development_tenant = {
    notification: "Est\xe1s em modo de desenvolvimento"
};
var $f3407ed1cf38d35e$export$2e2bcd8739ae039 = Object.freeze($f3407ed1cf38d35e$var$development_tenant);


const $f213221d4d8c07ce$var$password_rejected = {
    too_short: "M\xednimo de comprimento \xe9 {{min}}.",
    too_long: "M\xe1ximo de comprimento \xe9 {{max}}.",
    character_types: "S\xe3o necess\xe1rios pelo menos {{min}} tipos de caracteres.",
    unsupported_characters: "Caractere n\xe3o suportado encontrado.",
    pwned: "Evite o uso de senhas simples que s\xe3o f\xe1ceis de adivinhar.",
    restricted_found: "Evite o uso excessivo de {{list, list}}.",
    restricted: {
        repetition: "caracteres repetidos",
        sequence: "caracteres sequenciais",
        user_info: "suas informa\xe7\xf5es pessoais",
        words: "contexto do produto"
    }
};
var $f213221d4d8c07ce$export$2e2bcd8739ae039 = Object.freeze($f213221d4d8c07ce$var$password_rejected);


const $d1603a890a9ae22e$var$error = {
    general_required: "{{types, list(type: disjunction;)}} is necess\xe1rio",
    general_invalid: "O {{types, list(type: disjunction;)}} \xe9 inv\xe1lido",
    username_required: "Utilizador necess\xe1rio",
    password_required: "Password necess\xe1ria",
    username_exists: "O nome de utilizador j\xe1 existe",
    username_should_not_start_with_number: "O nome de utilizador n\xe3o deve come\xe7ar com um n\xfamero",
    username_invalid_charset: "O nome de utilizador deve conter apenas letras, n\xfameros ou underscores.",
    invalid_email: "O email \xe9 inv\xe1lido",
    invalid_phone: "O n\xfamero de telefone \xe9 inv\xe1lido",
    passwords_do_not_match: "As passwords n\xe3o coincidem",
    invalid_passcode: "O c\xf3digo de verifica\xe7\xe3o \xe9 inv\xe1lido.",
    invalid_connector_auth: "A autoriza\xe7\xe3o \xe9 inv\xe1lida",
    invalid_connector_request: "Os dados do conector s\xe3o inv\xe1lidos",
    unknown: "Erro desconhecido. Por favor, tente novamente mais tarde.",
    invalid_session: "Sess\xe3o n\xe3o encontrada. Volte e fa\xe7a login novamente.",
    timeout: "Tempo limite de sess\xe3o. Volte e fa\xe7a login novamente.",
    password_rejected: $f213221d4d8c07ce$export$2e2bcd8739ae039,
    sso_not_enabled: "O Single Sign-On n\xe3o est\xe1 habilitado para esta conta de e-mail."
};
var $d1603a890a9ae22e$export$2e2bcd8739ae039 = Object.freeze($d1603a890a9ae22e$var$error);


const $613d2fd482611a78$var$input = {
    username: "Utilizador",
    password: "Palavra-passe",
    email: "Email",
    phone_number: "Telefone",
    confirm_password: "Confirmar palavra-passe",
    search_region_code: "Procurar c\xf3digo de regi\xe3o",
    backup_code: "C\xf3digo de backup"
};
var $613d2fd482611a78$export$2e2bcd8739ae039 = Object.freeze($613d2fd482611a78$var$input);


const $286fc435b339957a$var$list = {
    or: "ou",
    and: "e",
    separator: ","
};
var $286fc435b339957a$export$2e2bcd8739ae039 = Object.freeze($286fc435b339957a$var$list);


const $b79aa0aaa6e50b96$var$mfa = {
    totp: "Senha \xfanica do aplicativo autenticador",
    webauthn: "Senha de dispositivo",
    backup_code: "C\xf3digo de backup",
    link_totp_description: "Por exemplo, Google Authenticator, etc.",
    link_webauthn_description: "Vincule o seu dispositivo ou hardware USB",
    link_backup_code_description: "Gere um c\xf3digo de backup",
    verify_totp_description: "Introduza o c\xf3digo \xfanico na aplica\xe7\xe3o",
    verify_webauthn_description: "Verifique o seu dispositivo ou hardware USB",
    verify_backup_code_description: "Cole o c\xf3digo de backup que guardou",
    add_mfa_factors: "Adicionar verifica\xe7\xe3o em duas etapas",
    add_mfa_description: "A verifica\xe7\xe3o em duas etapas est\xe1 ativada. Selecione o seu segundo m\xe9todo de verifica\xe7\xe3o para iniciar sess\xe3o de forma segura.",
    verify_mfa_factors: "Verifica\xe7\xe3o em duas etapas",
    verify_mfa_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, selecione a segunda forma de verificar a sua identidade.",
    add_authenticator_app: "Adicionar aplicativo autenticador",
    step: "Passo {{step, number}}: {{content}}",
    scan_qr_code: "Digitalize este c\xf3digo QR",
    scan_qr_code_description: "Digitalize o c\xf3digo QR seguinte com a sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    qr_code_not_available: "N\xe3o consegue digitalizar o c\xf3digo QR?",
    copy_and_paste_key: "Copiar e colar a chave",
    copy_and_paste_key_description: "Copie e cole a seguinte chave na sua aplica\xe7\xe3o autenticadora, como o Google Authenticator, Duo Mobile, Authy, etc.",
    want_to_scan_qr_code: "Quer digitalizar o c\xf3digo QR?",
    enter_one_time_code: "Introduza o c\xf3digo \xfanico",
    enter_one_time_code_link_description: "Introduza o c\xf3digo de verifica\xe7\xe3o de 6 d\xedgitos gerado pela aplica\xe7\xe3o autenticadora.",
    enter_one_time_code_description: "A verifica\xe7\xe3o em duas etapas foi ativada para esta conta. Por favor, insira o c\xf3digo de utiliza\xe7\xe3o \xfanica mostrado na sua aplica\xe7\xe3o autenticadora vinculada.",
    link_another_mfa_factor: "Mudar para outro m\xe9todo",
    save_backup_code: "Guarde o seu c\xf3digo de backup",
    save_backup_code_description: "Pode usar um destes c\xf3digos de backup para aceder \xe0 sua conta se tiver problemas durante a verifica\xe7\xe3o em duas etapas de outras formas. Cada c\xf3digo s\xf3 pode ser utilizado uma vez.",
    backup_code_hint: "Certifique-se de os copiar e guardar num local seguro.",
    enter_a_backup_code: "Introduza um c\xf3digo de backup",
    enter_backup_code_description: "Introduza o c\xf3digo de backup que guardou quando a verifica\xe7\xe3o em duas etapas foi ativada inicialmente.",
    create_a_passkey: "Criar uma palavra-passe",
    create_passkey_description: "Registe a sua palavra-passe utilizando a biometria do dispositivo, chaves de seguran\xe7a (por exemplo, YubiKey) ou outros m\xe9todos dispon\xedveis.",
    try_another_verification_method: "Experimente outro m\xe9todo de verifica\xe7\xe3o",
    verify_via_passkey: "Verificar atrav\xe9s da palavra-passe",
    verify_via_passkey_description: "Utilize a palavra-passe para verificar atrav\xe9s da senha do seu dispositivo ou biometria, digitalizando o c\xf3digo QR ou utilizando uma chave de seguran\xe7a USB como a YubiKey.",
    secret_key_copied: "Chave secreta copiada.",
    backup_code_copied: "C\xf3digo de backup copiado.",
    webauthn_not_ready: "O WebAuthn ainda n\xe3o est\xe1 pronto. Por favor, tente novamente mais tarde.",
    webauthn_not_supported: "O WebAuthn n\xe3o \xe9 suportado neste navegador.",
    webauthn_failed_to_create: "Falha ao criar. Por favor, tente novamente.",
    webauthn_failed_to_verify: "Falha ao verificar. Por favor, tente novamente."
};
var $b79aa0aaa6e50b96$export$2e2bcd8739ae039 = Object.freeze($b79aa0aaa6e50b96$var$mfa);


const $5675ad5a0fe5005d$var$secondary = {
    social_bind_with: "J\xe1 tem uma conta? Fa\xe7a login para agregar {{methods, list(type: disjunction;)}} com a sua identidade social."
};
var $5675ad5a0fe5005d$export$2e2bcd8739ae039 = Object.freeze($5675ad5a0fe5005d$var$secondary);


const $d09f25d0a6aff725$var$pt_pt = {
    translation: {
        input: $613d2fd482611a78$export$2e2bcd8739ae039,
        secondary: $5675ad5a0fe5005d$export$2e2bcd8739ae039,
        action: $81cc24c405cbf754$export$2e2bcd8739ae039,
        description: $ca7046ebea050d55$export$2e2bcd8739ae039,
        error: $d1603a890a9ae22e$export$2e2bcd8739ae039,
        list: $286fc435b339957a$export$2e2bcd8739ae039,
        mfa: $b79aa0aaa6e50b96$export$2e2bcd8739ae039,
        development_tenant: $f3407ed1cf38d35e$export$2e2bcd8739ae039
    }
};
var $d09f25d0a6aff725$export$2e2bcd8739ae039 = Object.freeze($d09f25d0a6aff725$var$pt_pt);


const $469bd1403a615e92$var$action = {
    sign_in: "Войти",
    continue: "Продолжить",
    create_account: "Создать аккаунт",
    create_account_without_linking: "Создать аккаунт без связывания",
    create: "Создать",
    enter_passcode: "Введите код подтверждения",
    confirm: "Подтвердить",
    cancel: "Отменить",
    save_password: "Сохраните пароль",
    bind: "Привязать к {{address}}",
    bind_and_continue: "Привязать и продолжить",
    back: "Назад",
    nav_back: "Назад",
    nav_skip: "Пропустить",
    agree: "Согласен",
    got_it: "Понял",
    sign_in_with: "Войти через {{name}}",
    forgot_password: "Забыли пароль?",
    switch_to: "Изменить на {{method}}",
    sign_in_via_passcode: "Войти с кодом подтверждения",
    sign_in_via_password: "Войти с паролем",
    change: "Изменить {{method}}",
    link_another_email: "Привязать другую почту",
    link_another_phone: "Привязать другой номер",
    link_another_email_or_phone: "Привязать другую почту или номер",
    show_password: "Показать пароль",
    copy: "Копировать",
    verify_via_passkey: "Проверить с помощью ключа доступа",
    download: "Скачать",
    single_sign_on: "Единый вход"
};
var $469bd1403a615e92$export$2e2bcd8739ae039 = Object.freeze($469bd1403a615e92$var$action);


const $f20ee9e8ff2ac626$var$description = {
    email: "адрес электронной почты",
    phone_number: "номер телефона",
    username: "имя пользователя",
    reminder: "Напоминание",
    not_found: "404 Не найдено",
    agree_with_terms: "Я прочитал и согласен с ",
    agree_with_terms_modal: "Чтобы продолжить, пожалуйста, согласитесь с <link></link>",
    terms_of_use: "Условиями использования",
    sign_in: "Войти",
    privacy_policy: "Политикой конфиденциальности",
    create_account: "Создать аккаунт",
    or: "или",
    and: "и",
    enter_passcode: "Код подтверждения был отправлен на {{address}}",
    passcode_sent: "Код подтверждения был отправлен повторно",
    resend_after_seconds: "Отправить повторно через <span>{{seconds}}</span> сек.",
    resend_passcode: "Отправить повторно",
    create_account_id_exists: "Учетная запись для {{value}} уже существует, хотите войти?",
    link_account_id_exists: "Учетная запись для {{value}} уже существует, хотите привязать?",
    sign_in_id_does_not_exist: "Учетная запись для {{value}} не существует, хотите зарегистрироваться?",
    sign_in_id_does_not_exist_alert: "Учетная запись для {{value}} не существует.",
    create_account_id_exists_alert: "Аккаунт с {{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    social_identity_exist: "{{type}} {{value}} связан с другим аккаунтом. Пожалуйста, попробуйте другой {{type}}.",
    bind_account_title: "Привязать или создать аккаунт",
    social_create_account: "Вы можете создать новую учетную запись.",
    social_link_email: "Вы можете привязать другой адрес электронной почты",
    social_link_phone: "Вы можете привязать другой номер телефона",
    social_link_email_or_phone: "Вы можете привязать другой адрес электронной почты или телефон",
    social_bind_with_existing: "Мы находим зарегистрированную связанную учетную запись, и вы можете связать ее напрямую.",
    reset_password: "Забыли пароль",
    reset_password_description: "Введите {{types, list(type: disjunction;)}} от вашей учетной записи, и мы вышлем вам код для восстановления пароля.",
    new_password: "Новый пароль",
    set_password: "Задать пароль",
    password_changed: "Пароль изменен",
    no_account: "Еще не зарегистрированы? ",
    have_account: "Уже есть аккаунт?",
    enter_password: "Введите пароль",
    enter_password_for: "Введите пароль для {{value}}",
    enter_username: "Установить имя пользователя",
    enter_username_description: "Имя пользователя является альтернативой для входа в систему. Имя пользователя должно содержать только буквы, цифры и символы подчеркивания.",
    link_email: "Привязать почту",
    link_phone: "Привязать номер телефона",
    link_email_or_phone: "Привязать почту или номер телефона",
    link_email_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту к учетной записи.",
    link_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свой номер телефона к учетной записи.",
    link_email_or_phone_description: "Для дополнительной безопасности, пожалуйста, привяжите свою электронную почту или номер телефона к учетной записи.",
    continue_with_more_information: "Для дополнительной безопасности, пожалуйста, заполните приведенные ниже данные учетной записи.",
    create_your_account: "Создайте свой аккаунт",
    sign_in_to_your_account: "Войди в свой аккаунт",
    no_region_code_found: "Не удалось определить код региона",
    verify_email: "Подтвердите Ваш электронный адрес",
    verify_phone: "Подтвердите свой номер телефона",
    password_requirements: "Требования к паролю {{items, list}}.",
    password_requirement: {
        length_one: "требуется минимум {{count}} символ",
        length_other: "требуется минимум {{count}} символов",
        character_types_one: "должен содержать по крайней мере {{count}} тип прописных букв, строчных букв, цифр и символов",
        character_types_other: "должен содержать по крайней мере {{count}} типа прописных букв, строчных букв, цифр и символов"
    },
    use: "Использовать",
    single_sign_on_email_form: "Введите корпоративный адрес электронной почты",
    single_sign_on_connectors_list: "Ваше предприятие включило функцию единого входа для электронной почты {{email}}. Вы можете продолжить вход в систему с помощью следующих провайдеров SSO.",
    single_sign_on_enabled: "Единый вход в систему включен для этой учетной записи"
};
var $f20ee9e8ff2ac626$export$2e2bcd8739ae039 = Object.freeze($f20ee9e8ff2ac626$var$description);


const $53cd5f94ca65e56f$var$development_tenant = {
    notification: "Вы в режиме разработки"
};
var $53cd5f94ca65e56f$export$2e2bcd8739ae039 = Object.freeze($53cd5f94ca65e56f$var$development_tenant);


const $012f99551982031e$var$password_rejected = {
    too_short: "Минимальная длина {{min}} символов.",
    too_long: "Максимальная длина {{max}} символов.",
    character_types: "Требуется как минимум {{min}} типов символов.",
    unsupported_characters: "Найден неподдерживаемый символ.",
    pwned: "Избегайте использования простых паролей, которые легко угадать.",
    restricted_found: "Избегайте чрезмерного использования {{list,list}}.",
    restricted: {
        repetition: "повторяющиеся символы",
        sequence: "последовательные символы",
        user_info: "ваши личные данные",
        words: "контекст продукта"
    }
};
var $012f99551982031e$export$2e2bcd8739ae039 = Object.freeze($012f99551982031e$var$password_rejected);


const $8aa243422cfda70a$var$error = {
    general_required: "Введите {{types, list(type: disjunction;)}}",
    general_invalid: "Проверьте {{types, list(type: disjunction;)}}",
    username_required: "Введите имя пользователя",
    password_required: "Введите пароль",
    username_exists: "Имя пользователя занято",
    username_should_not_start_with_number: "Имя пользователя не должно начинаться с цифры",
    username_invalid_charset: "Имя пользователя должно содержать только буквы, цифры или символы подчеркивания",
    invalid_email: "Электронная почта указана неправильно",
    invalid_phone: "Номер телефона указан неправильно",
    passwords_do_not_match: "Пароли не совпадают. Пожалуйста, попробуйте еще раз.",
    invalid_passcode: "Неправильный код подтверждения",
    invalid_connector_auth: "Авторизация недействительна",
    invalid_connector_request: "Данные коннектора недействительны.",
    unknown: "Неизвестная ошибка. Пожалуйста, повторите попытку позднее.",
    invalid_session: "Сессия не найдена. Пожалуйста, войдите снова.",
    timeout: "Время ожидания истекло. Пожалуйста, повторите попытку позднее.",
    password_rejected: $012f99551982031e$export$2e2bcd8739ae039,
    sso_not_enabled: "Односторонняя авторизация не включена для этого аккаунта электронной почты."
};
var $8aa243422cfda70a$export$2e2bcd8739ae039 = Object.freeze($8aa243422cfda70a$var$error);


const $8808d673f4d6dc22$var$input = {
    username: "Имя пользователя",
    password: "Пароль",
    email: "Электронная почта",
    phone_number: "Номер телефона",
    confirm_password: "Подтверждение пароля",
    search_region_code: "Поиск кода региона",
    backup_code: "Резервный код"
};
var $8808d673f4d6dc22$export$2e2bcd8739ae039 = Object.freeze($8808d673f4d6dc22$var$input);


const $761a97ac352dfdd8$var$list = {
    or: "или",
    and: "и",
    separator: ","
};
var $761a97ac352dfdd8$export$2e2bcd8739ae039 = Object.freeze($761a97ac352dfdd8$var$list);


const $2e50f717294c4948$var$mfa = {
    totp: "Одноразовый пароль приложения для аутентификации",
    webauthn: "Пароль",
    backup_code: "Резервный код",
    link_totp_description: "Например, Google Authenticator и др.",
    link_webauthn_description: "Привяжите ваше устройство или USB-ключ",
    link_backup_code_description: "Создайте резервный код",
    verify_totp_description: "Введите одноразовый код в приложении",
    verify_webauthn_description: "Подтвердите ваше устройство или USB-ключ",
    verify_backup_code_description: "Вставьте резервный код, который вы сохранили",
    add_mfa_factors: "Добавить двухфакторную аутентификацию",
    add_mfa_description: "Включена двухфакторная аутентификация. Выберите второй метод для безопасного входа.",
    verify_mfa_factors: "Двухфакторная аутентификация",
    verify_mfa_description: "Двухфакторная аутентификация включена для этого аккаунта. Выберите второй способ подтверждения вашей личности.",
    add_authenticator_app: "Добавить приложение для аутентификации",
    step: "Шаг {{step, number}}: {{content}}",
    scan_qr_code: "Отсканируйте этот QR-код",
    scan_qr_code_description: "Отсканируйте следующий QR-код с помощью вашего приложения для аутентификации, такого как Google Authenticator, Duo Mobile, Authy и др.",
    qr_code_not_available: "Нельзя отсканировать QR-код?",
    copy_and_paste_key: "Скопируйте и вставьте ключ",
    copy_and_paste_key_description: "Скопируйте и вставьте следующий ключ в ваше приложение для аутентификации, такое как Google Authenticator, Duo Mobile, Authy и др.",
    want_to_scan_qr_code: "Хотите отсканировать QR-код?",
    enter_one_time_code: "Введите одноразовый код",
    enter_one_time_code_link_description: "Введите 6-значный код, сгенерированный приложением для аутентификации.",
    enter_one_time_code_description: "Для этого аккаунта включена двухэтапная аутентификация. Введите одноразовый код, отображаемый в вашем связанном приложении для аутентификации.",
    link_another_mfa_factor: "Переключиться на другой метод",
    save_backup_code: "Сохраните ваш резервный код",
    save_backup_code_description: "Вы можете использовать один из этих резервных кодов для доступа к своему аккаунту, если у вас возникнут проблемы с двухфакторной аутентификацией другим способом. Каждый код может быть использован только один раз.",
    backup_code_hint: "Убедитесь, что вы скопировали и сохранили их в надежном месте.",
    enter_a_backup_code: "Введите резервный код",
    enter_backup_code_description: "Введите резервный код, который вы сохранили при включении двухфакторной аутентификации.",
    create_a_passkey: "Создать код доступа",
    create_passkey_description: "Зарегистрируйте свой код доступа с использованием биометрических данных устройства, ключей безопасности (например, YubiKey) или других доступных методов.",
    try_another_verification_method: "Попробуйте другой метод подтверждения",
    verify_via_passkey: "Подтвердите через код доступа",
    verify_via_passkey_description: "Используйте код доступа для подтверждения с помощью пароля устройства или биометрии, сканирования QR-кода или использования USB-ключа безопасности, такого как YubiKey.",
    secret_key_copied: "Ключ скопирован.",
    backup_code_copied: "Резервный код скопирован.",
    webauthn_not_ready: "WebAuthn еще не готов. Пожалуйста, попробуйте позже.",
    webauthn_not_supported: "WebAuthn не поддерживается в этом браузере.",
    webauthn_failed_to_create: "Не удалось создать. Пожалуйста, попробуйте еще раз.",
    webauthn_failed_to_verify: "Не удалось проверить. Пожалуйста, попробуйте еще раз."
};
var $2e50f717294c4948$export$2e2bcd8739ae039 = Object.freeze($2e50f717294c4948$var$mfa);


const $e187e12f8a68138d$var$secondary = {
    social_bind_with: "Уже есть аккаунт? Войдите, чтобы привязать {{methods, list(type: disjunction;)}}."
};
var $e187e12f8a68138d$export$2e2bcd8739ae039 = Object.freeze($e187e12f8a68138d$var$secondary);


const $e330628e4a722e29$var$ru = {
    translation: {
        input: $8808d673f4d6dc22$export$2e2bcd8739ae039,
        secondary: $e187e12f8a68138d$export$2e2bcd8739ae039,
        action: $469bd1403a615e92$export$2e2bcd8739ae039,
        description: $f20ee9e8ff2ac626$export$2e2bcd8739ae039,
        error: $8aa243422cfda70a$export$2e2bcd8739ae039,
        list: $761a97ac352dfdd8$export$2e2bcd8739ae039,
        mfa: $2e50f717294c4948$export$2e2bcd8739ae039,
        development_tenant: $53cd5f94ca65e56f$export$2e2bcd8739ae039
    }
};
var $e330628e4a722e29$export$2e2bcd8739ae039 = Object.freeze($e330628e4a722e29$var$ru);


const $698ceb05c0f5ef0a$var$action = {
    sign_in: "Giriş Yap",
    continue: "İlerle",
    create_account: "Hesap Oluştur",
    create_account_without_linking: "Bağlamadan hesap oluştur",
    create: "Oluştur",
    enter_passcode: "Doğrulama kodunu girin",
    confirm: "Onayla",
    cancel: "İptal Et",
    save_password: "Şifreyi kaydet",
    bind: "{{address}} ile birleştir",
    bind_and_continue: "Bağla ve devam et",
    back: "Geri D\xf6n",
    nav_back: "Geri",
    nav_skip: "Atla",
    agree: "Kabul Et",
    got_it: "Anladım",
    sign_in_with: "{{name}} ile ilerle",
    forgot_password: "Şifremi Unuttum?",
    switch_to: "{{method}} y\xf6ntemine ge\xe7",
    sign_in_via_passcode: "Doğrulama koduyla oturum a\xe7ın",
    sign_in_via_password: "şifre ile giriş yap",
    change: "{{method}} değiştir",
    link_another_email: "Başka bir e-postayı bağla",
    link_another_phone: "Başka bir telefon bağla",
    link_another_email_or_phone: "Başka bir e-posta veya telefon bağlayın",
    show_password: "Şifreyi g\xf6ster",
    copy: "Kopyala",
    verify_via_passkey: "Parola ile doğrula",
    download: "İndir",
    single_sign_on: "Tek oturum a\xe7ma"
};
var $698ceb05c0f5ef0a$export$2e2bcd8739ae039 = Object.freeze($698ceb05c0f5ef0a$var$action);


const $6831204fb54ebd38$var$description = {
    email: "e-posta adresi",
    phone_number: "telefon numarası",
    username: "kullanıcı Adı",
    reminder: "Hatırlatıcı",
    not_found: "404 Bulunamadı",
    agree_with_terms: "Okudum ve anladım",
    agree_with_terms_modal: "Devam etmek i\xe7in l\xfctfen <link></link>'i kabul edin.",
    terms_of_use: "Kullanım Koşulları",
    sign_in: "Giriş Yap",
    privacy_policy: "Gizlilik Politikası",
    create_account: "Hesap Oluştur",
    or: "veya",
    and: "ve",
    enter_passcode: "Doğrulama kodu {{address}} {{target}} adresinize g\xf6nderildi",
    passcode_sent: "Doğrulama kodu yeniden g\xf6nderildi",
    resend_after_seconds: "<span>{{seconds}}</span> saniye sonra tekrar g\xf6nder",
    resend_passcode: "Doğrulama kodunu tekrar g\xf6nder",
    create_account_id_exists: "{{type}} {{value}} ile hesap mevcut, giriş yapmak ister misiniz?",
    link_account_id_exists: "{{type}} {{value}} olan hesap zaten var, bağlamak ister misiniz?",
    sign_in_id_does_not_exist: "{{type}} {{value}} ile hesap mevcut değil, yeni bir hesap oluşturmak ister misiniz?",
    sign_in_id_does_not_exist_alert: "{{type}} {{value}} olan hesap mevcut değil.",
    create_account_id_exists_alert: "{{type}} {{value}} olan hesap başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    social_identity_exist: "{{type}} {{value}} başka bir hesaba bağlı. L\xfctfen başka bir {{type}} deneyin.",
    bind_account_title: "Bağla veya hesap oluştur",
    social_create_account: "Yeni bir hesap oluşturabilirsiniz.",
    social_link_email: "Başka bir e-posta bağlayabilirsiniz",
    social_link_phone: "Başka bir telefon bağlayabilirsiniz",
    social_link_email_or_phone: "Başka bir e-posta veya telefon bağlayabilirsiniz",
    social_bind_with_existing: "Kayıtlı ilgili bir hesap bulduk ve onu doğrudan bağlayabilirsiniz.",
    reset_password: "Parolanızı mı unuttunuz",
    reset_password_description: "Hesabınızla ilişkili {{types, list(type: disjunction;)}} girin, şifrenizi sıfırlamanız i\xe7in size doğrulama kodunu g\xf6ndereceğiz.",
    new_password: "Yeni Şifre",
    set_password: "Şifreyi belirle",
    password_changed: "Şifre değişti",
    no_account: "Hen\xfcz hesap yok mu?",
    have_account: "Zaten bir hesabınız var mıydı?",
    enter_password: "Parolanı Gir",
    enter_password_for: "{{method}} {{value}} şifresiyle oturum a\xe7ın",
    enter_username: "Kullanıcı adını ayarla",
    enter_username_description: "Kullanıcı adı, oturum a\xe7mak i\xe7in bir alternatiftir. Kullanıcı adı yalnızca harf, sayı ve alt \xe7izgi i\xe7ermelidir.",
    link_email: "E-postayı bağla",
    link_phone: "Telefonu bağla",
    link_email_or_phone: "E-posta veya telefon bağlantısı",
    link_email_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı hesapla ilişkilendirin.",
    link_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen telefonunuzu hesaba bağlayın.",
    link_email_or_phone_description: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen e-postanızı veya telefonunuzu hesaba bağlayın.",
    continue_with_more_information: "Daha fazla g\xfcvenlik i\xe7in l\xfctfen aşağıdaki hesap ayrıntılarını tamamlayın.",
    create_your_account: "Hesabını oluştur",
    sign_in_to_your_account: "Hesabına giriş yap",
    no_region_code_found: "B\xf6lge kodu bulunamadı",
    verify_email: "E-postanızın doğrulanması",
    verify_phone: "Telefon numaranızın doğrulanması",
    password_requirements: "Şifre {{items, list}}.",
    password_requirement: {
        length_one: "en az {{count}} karakter gerektirir",
        length_other: "en az {{count}} karakter gerektirir",
        character_types_one: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir",
        character_types_other: "en az {{count}} tane b\xfcy\xfck harf, k\xfc\xe7\xfck harf, rakam ve sembol i\xe7ermelidir"
    },
    use: "Kullan",
    single_sign_on_email_form: "Kurumsal e-posta adresinizi girin",
    single_sign_on_connectors_list: "Şirketiniz, {{email}} e-posta hesabı i\xe7in Tekli Oturum A\xe7mayı (Single Sign-On) etkinleştirdi. Aşağıdaki SSO sağlayıcıları ile oturum a\xe7maya devam edebilirsiniz.",
    single_sign_on_enabled: "Bu hesapta Tekli Oturum A\xe7ma etkinleştirildi."
};
var $6831204fb54ebd38$export$2e2bcd8739ae039 = Object.freeze($6831204fb54ebd38$var$description);


const $0b1bc7e28a771e78$var$development_tenant = {
    notification: "Geliştirme modundasın"
};
var $0b1bc7e28a771e78$export$2e2bcd8739ae039 = Object.freeze($0b1bc7e28a771e78$var$development_tenant);


const $5c6981a455696e0d$var$password_rejected = {
    too_short: "Minimum length is {{min}}.",
    too_long: "Maximum length is {{max}}.",
    character_types: "En az {{min}} t\xfcrde karakter gereklidir.",
    unsupported_characters: "Desteklenmeyen karakter bulundu.",
    pwned: "Kolayca tahmin edilebilen basit şifreleri kullanmaktan ka\xe7ının.",
    restricted_found: "{{list, list}} fazla kullanımdan ka\xe7ının.",
    restricted: {
        repetition: "tekrarlanan karakterler",
        sequence: "dizisel karakterler",
        user_info: "kişisel bilgileriniz",
        words: "\xfcr\xfcnle ilgili terimler"
    }
};
var $5c6981a455696e0d$export$2e2bcd8739ae039 = Object.freeze($5c6981a455696e0d$var$password_rejected);


const $3d9e5a075e6e9298$var$error = {
    general_required: "{{types, list(type: disjunction;)}} gerekli",
    general_invalid: "{{types, list(type: disjunction;)}} ge\xe7ersiz",
    username_required: "Kullanıcı adı gerekli.",
    password_required: "Şifre gerekli.",
    username_exists: "Kullanıcı adı mevcut.",
    username_should_not_start_with_number: "Kullanıcı adı sayı ile başlayamaz.",
    username_invalid_charset: "Kullanıcı adı yalnızca harf,sayı veya alt \xe7izgi i\xe7ermeli.",
    invalid_email: "E-posta adresi ge\xe7ersiz",
    invalid_phone: "Telefon numarası ge\xe7ersiz",
    passwords_do_not_match: "Şifreler eşleşmiyor",
    invalid_passcode: "Doğrulama kodu ge\xe7ersiz",
    invalid_connector_auth: "Yetki ge\xe7ersiz",
    invalid_connector_request: "Bağlayıcı veri ge\xe7ersiz",
    unknown: "Bilinmeyen hata. L\xfctfen daha sonra tekrar deneyiniz.",
    invalid_session: "Oturum bulunamadı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    timeout: "Oturum zaman aşımına uğradı. L\xfctfen geri d\xf6n\xfcp tekrar giriş yapınız.",
    password_rejected: $5c6981a455696e0d$export$2e2bcd8739ae039,
    sso_not_enabled: "Bu e-posta hesabı i\xe7in tek oturum a\xe7ma etkin değil."
};
var $3d9e5a075e6e9298$export$2e2bcd8739ae039 = Object.freeze($3d9e5a075e6e9298$var$error);


const $954a0b4630a8472f$var$input = {
    username: "Kullanıcı Adı",
    password: "Şifre",
    email: "E-posta Adresi",
    phone_number: "Telefon Numarası",
    confirm_password: "Şifreyi Doğrula",
    search_region_code: "B\xf6lge kodunu ara",
    backup_code: "Yedek kod"
};
var $954a0b4630a8472f$export$2e2bcd8739ae039 = Object.freeze($954a0b4630a8472f$var$input);


const $2680e482d5d71f24$var$list = {
    or: "veya",
    and: "ve",
    separator: ","
};
var $2680e482d5d71f24$export$2e2bcd8739ae039 = Object.freeze($2680e482d5d71f24$var$list);


const $d84984a21605422c$var$mfa = {
    totp: "Authenticator uygulaması OTP",
    webauthn: "Anahtar",
    backup_code: "Yedek kod",
    link_totp_description: "\xd6rn., Google Authenticator, vb.",
    link_webauthn_description: "Cihazınızı veya USB donanımınızı bağlayın",
    link_backup_code_description: "Yedek kod oluşturun",
    verify_totp_description: "Uygulamadaki tek kullanımlık kodu girin",
    verify_webauthn_description: "Cihazınızı veya USB donanımınızı doğrulayın",
    verify_backup_code_description: "Kaydettiğiniz yedek kodu yapıştırın",
    add_mfa_factors: "2 aşamalı doğrulamayı ekle",
    add_mfa_description: "İki fakt\xf6rl\xfc doğrulama etkin. G\xfcvenli giriş i\xe7in ikinci doğrulama y\xf6nteminizi se\xe7in.",
    verify_mfa_factors: "2 aşamalı doğrulama",
    verify_mfa_description: "Bu hesap i\xe7in 2 aşamalı doğrulama etkinleştirildi. L\xfctfen kimliğinizi doğrulamak i\xe7in ikinci yolu se\xe7in.",
    add_authenticator_app: "Authenticator uygulaması ekle",
    step: "Adım {{step, number}}: {{content}}",
    scan_qr_code: "Bu QR kodunu tarayın",
    scan_qr_code_description: "Bu QR kodunu authenticator uygulamanızla tarayın, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    qr_code_not_available: "QR kodu taranamıyor mu?",
    copy_and_paste_key: "Anahtarı kopyala ve yapıştır",
    copy_and_paste_key_description: "Aşağıdaki anahtarı authenticator uygulamanıza kopyala ve yapıştır, \xf6rneğin Google Authenticator, Duo Mobile, Authy, vb.",
    want_to_scan_qr_code: "QR kodunu tarımak mı istiyorsunuz?",
    enter_one_time_code: "Tek kullanımlık kodu girin",
    enter_one_time_code_link_description: "Authenticator uygulaması tarafından oluşturulan 6 haneli doğrulama kodunu girin.",
    enter_one_time_code_description: "Bu hesap i\xe7in iki aşamalı doğrulama etkinleştirildi. L\xfctfen bağlı kimlik doğrulama uygulamanızda g\xf6sterilen tek kullanımlık kodu girin.",
    link_another_mfa_factor: "Başka bir y\xf6nteme ge\xe7in",
    save_backup_code: "Yedek kodunuzu kaydedin",
    save_backup_code_description: "Başka bir y\xf6ntemle 2 aşamalı doğrulama sırasında sorun yaşarsanız bu yedek kodlardan birini kullanabilirsiniz. Her kod sadece bir kez kullanılabilir.",
    backup_code_hint: "Onları kopyalayın ve g\xfcvenli bir yerde sakladığınızdan emin olun.",
    enter_a_backup_code: "Bir yedek kod girin",
    enter_backup_code_description: "İlk olarak 2 aşamalı doğrulama etkinleştirildiğinde kaydettiğiniz yedek kodu girin.",
    create_a_passkey: "Bir anahtar oluşturun",
    create_passkey_description: "Cihaz biyometrisi, g\xfcvenlik anahtarları (\xf6rneğin YubiKey) veya diğer kullanılabilir y\xf6ntemler kullanarak anahtarınızı kaydedin.",
    try_another_verification_method: "Başka bir doğrulama y\xf6ntemini deneyin",
    verify_via_passkey: "Anahtar ile doğrula",
    verify_via_passkey_description: "Anahtar kullanarak cihaz parolanız veya biyometri ile doğrulama, QR kodunu tarama veya YubiKey gibi USB g\xfcvenlik anahtarı kullanma.",
    secret_key_copied: "Gizli anahtar kopyalandı.",
    backup_code_copied: "Yedek kod kopyalandı.",
    webauthn_not_ready: "WebAuthn hen\xfcz hazır değil. L\xfctfen daha sonra tekrar deneyin.",
    webauthn_not_supported: "Bu tarayıcıda WebAuthn desteklenmiyor.",
    webauthn_failed_to_create: "Oluşturulamadı. L\xfctfen tekrar deneyin.",
    webauthn_failed_to_verify: "Doğrulama başarısız oldu. L\xfctfen tekrar deneyin."
};
var $d84984a21605422c$export$2e2bcd8739ae039 = Object.freeze($d84984a21605422c$var$mfa);


const $d6d8a851e3537162$var$secondary = {
    social_bind_with: "Hesabınız zaten var mı? {{methods, list(type: disjunction;)}} bağlantısına tıklayarak giriş yapabilirsiniz"
};
var $d6d8a851e3537162$export$2e2bcd8739ae039 = Object.freeze($d6d8a851e3537162$var$secondary);


const $3f61b8c86e3e3079$var$tr_tr = {
    translation: {
        input: $954a0b4630a8472f$export$2e2bcd8739ae039,
        secondary: $d6d8a851e3537162$export$2e2bcd8739ae039,
        action: $698ceb05c0f5ef0a$export$2e2bcd8739ae039,
        description: $6831204fb54ebd38$export$2e2bcd8739ae039,
        error: $3d9e5a075e6e9298$export$2e2bcd8739ae039,
        list: $2680e482d5d71f24$export$2e2bcd8739ae039,
        mfa: $d84984a21605422c$export$2e2bcd8739ae039,
        development_tenant: $0b1bc7e28a771e78$export$2e2bcd8739ae039
    }
};
var $3f61b8c86e3e3079$export$2e2bcd8739ae039 = Object.freeze($3f61b8c86e3e3079$var$tr_tr);


const $858e248a8bce95fb$var$action = {
    sign_in: "登录",
    continue: "继续",
    create_account: "注册",
    create_account_without_linking: "注册新的账号",
    create: "注册",
    enter_passcode: "输入验证码",
    confirm: "确认",
    cancel: "取消",
    save_password: "保存密码",
    bind: "绑定到 {{address}}",
    bind_and_continue: "绑定并继续",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳过",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通过 {{name}} 继续",
    forgot_password: "忘记密码？",
    switch_to: "切换到{{method}}",
    sign_in_via_passcode: "用验证码登录",
    sign_in_via_password: "密码登录",
    change: "更改{{method}}",
    link_another_email: "绑定其它邮箱",
    link_another_phone: "绑定其它手机",
    link_another_email_or_phone: "绑定邮箱或手机号",
    show_password: "显示密码",
    copy: "复制",
    verify_via_passkey: "通过 Passkey 验证",
    download: "下载",
    single_sign_on: "单点登录"
};
var $858e248a8bce95fb$export$2e2bcd8739ae039 = Object.freeze($858e248a8bce95fb$var$action);


const $db81fa1761033bb8$var$description = {
    email: "邮箱",
    phone_number: "手机号",
    username: "用户名",
    reminder: "提示",
    not_found: "404 页面不存在",
    agree_with_terms: "我已阅读并同意 ",
    agree_with_terms_modal: "请先同意 <link></link> 以继续",
    terms_of_use: "使用条款",
    sign_in: "登录",
    privacy_policy: "隐私政策",
    create_account: "创建帐号",
    or: "或",
    and: "和",
    enter_passcode: "验证码已经发送至你的{{ address }} {{target}}",
    passcode_sent: "验证码已经发送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒后重发",
    resend_passcode: "重发验证码",
    create_account_id_exists: "{{type}}为 {{value}} 的帐号已存在，你要登录吗？",
    link_account_id_exists: " {{type}}为 {{value}} 的账号已注册，你要绑定至这个账号吗？",
    sign_in_id_does_not_exist: "{{type}}为 {{value}} 的帐号不存在，你要创建一个新帐号吗？",
    sign_in_id_does_not_exist_alert: "{{type}}为 {{value}} 的帐号不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已绑定其他账号。请尝试其他{{type}}",
    bind_account_title: "绑定或注册帐号",
    social_create_account: "你可以注册一个新的账号。",
    social_link_email: "你可以绑定其他邮箱",
    social_link_phone: "你可以绑定其他手机号",
    social_link_email_or_phone: "你可以绑定其他邮箱或手机号",
    social_bind_with_existing: "找到了一个已注册的账号，你可以直接绑定。",
    reset_password: "忘记密码",
    reset_password_description: "输入{{types, list(type: disjunction;)}}，获取验证码以重设密码。",
    new_password: "新密码",
    set_password: "设置密码",
    password_changed: "已重置密码！",
    no_account: "还没有账号？",
    have_account: " 已有账号？",
    enter_password: "输入密码",
    enter_password_for: "输入{{method}} {{value}} 对应的密码进行登录",
    enter_username: "设置用户名",
    enter_username_description: "用户名可以用来进行登录。用户名仅可以包含字母、数字和下划线。",
    link_email: "绑定邮箱",
    link_phone: "绑定手机",
    link_email_or_phone: "绑定邮箱或手机号",
    link_email_description: "绑定邮箱以保障你的账号安全",
    link_phone_description: "绑定手机号以保障你的账号安全",
    link_email_or_phone_description: "绑定邮箱或手机号以保障你的账号安全",
    continue_with_more_information: "为保障你的账号安全，需要你补充以下信息。",
    create_your_account: "注册你的账号",
    sign_in_to_your_account: "登录你的账号",
    no_region_code_found: "没有找到区域码",
    verify_email: "验证你的邮箱",
    verify_phone: "验证你的手机号",
    password_requirements: "密码 {{items, list}}。",
    password_requirement: {
        length_one: "应至少有 {{count}} 个字符",
        length_other: "应至少有 {{count}} 个字符",
        character_types_one: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号",
        character_types_other: "应包含至少 {{count}} 种大写字母、小写字母、数字和符号"
    },
    use: "使用",
    single_sign_on_email_form: "输入你的企业电子邮件地址",
    single_sign_on_connectors_list: "你的企业已为电子邮件账户{{email}}启用了单点登录。你可以继续使用以下SSO提供商进行登录。",
    single_sign_on_enabled: "该帐户已启用单点登录"
};
var $db81fa1761033bb8$export$2e2bcd8739ae039 = Object.freeze($db81fa1761033bb8$var$description);


const $f17a14579a8efeeb$var$development_tenant = {
    notification: "你处于开发模式"
};
var $f17a14579a8efeeb$export$2e2bcd8739ae039 = Object.freeze($f17a14579a8efeeb$var$development_tenant);


const $6cc660b3b8b657be$var$password_rejected = {
    too_short: "最短长度为{{min}}。",
    too_long: "最长长度为{{max}}。",
    character_types: "需要至少{{min}}种字符类型。",
    unsupported_characters: "发现不支持的字符。",
    pwned: "避免使用容易被猜到的简单密码。",
    restricted_found: "避免过度使用{{list, list}}。",
    restricted: {
        repetition: "重复字符",
        sequence: "连续字符",
        user_info: "您的个人信息",
        words: "产品上下文"
    }
};
var $6cc660b3b8b657be$export$2e2bcd8739ae039 = Object.freeze($6cc660b3b8b657be$var$password_rejected);


const $6bb47cf6d6fee9c4$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "无效的{{types, list(type: disjunction;)}}",
    username_required: "用户名必填",
    password_required: "密码必填",
    username_exists: "用户名已存在",
    username_should_not_start_with_number: "用户名不能以数字开头",
    username_invalid_charset: "用户名只能包含英文字母、数字或下划线。",
    invalid_email: "无效的邮箱",
    invalid_phone: "无效的手机号",
    passwords_do_not_match: "两次输入的密码不一致，请重试。",
    invalid_passcode: "无效的验证码",
    invalid_connector_auth: "登录失败",
    invalid_connector_request: "无效的登录请求",
    unknown: "未知错误，请稍后重试。",
    invalid_session: "未找到会话，请返回并重新登录。",
    timeout: "请求超时，请稍后重试。",
    password_rejected: $6cc660b3b8b657be$export$2e2bcd8739ae039,
    sso_not_enabled: "此邮箱账户未启用单点登录。"
};
var $6bb47cf6d6fee9c4$export$2e2bcd8739ae039 = Object.freeze($6bb47cf6d6fee9c4$var$error);


const $b0359de04c83d7fd$var$input = {
    username: "用户名",
    password: "密码",
    email: "邮箱",
    phone_number: "手机号",
    confirm_password: "确认密码",
    search_region_code: "搜索区域码",
    backup_code: "备用码"
};
var $b0359de04c83d7fd$export$2e2bcd8739ae039 = Object.freeze($b0359de04c83d7fd$var$input);


const $cbed9c1e3af05367$var$list = {
    or: "或者",
    and: "和",
    separator: "，"
};
var $cbed9c1e3af05367$export$2e2bcd8739ae039 = Object.freeze($cbed9c1e3af05367$var$list);


const $bc13d5c32b9a2fe5$var$mfa = {
    totp: "身份验证应用 OTP",
    webauthn: "通行证",
    backup_code: "备份代码",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "链接您的设备或 USB 硬件",
    link_backup_code_description: "生成备份代码",
    verify_totp_description: "在应用程序中输入一次性代码",
    verify_webauthn_description: "验证您的设备或 USB 硬件",
    verify_backup_code_description: "粘贴您保存的备份代码",
    add_mfa_factors: "添加两步验证",
    add_mfa_description: "已启用两步验证。选择第二种验证方法以进行安全登录。",
    verify_mfa_factors: "两步验证",
    verify_mfa_description: "此帐户已启用两步验证。请选择第二种验证身份的方式。",
    add_authenticator_app: "添加身份验证应用",
    step: "步骤 {{step, number}}: {{content}}",
    scan_qr_code: "扫描此 QR 码",
    scan_qr_code_description: "使用身份验证应用程序（如 Google Authenticator、Duo Mobile、Authy 等）扫描以下 QR 码。",
    qr_code_not_available: "无法扫描 QR 码？",
    copy_and_paste_key: "复制并粘贴密钥",
    copy_and_paste_key_description: "将以下密钥复制并粘贴到身份验证应用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要扫描 QR 码吗？",
    enter_one_time_code: "输入一次性代码",
    enter_one_time_code_link_description: "输入身份验证应用生成的 6 位验证码。",
    enter_one_time_code_description: "此帐户启用了两步验证。请在你关联的认证应用中输入显示的一次性代码。",
    link_another_mfa_factor: "切换到另一种方法",
    save_backup_code: "保存您的备份代码",
    save_backup_code_description: "如果在其他方式的两步验证中遇到问题，您可以使用这些备份代码之一访问您的帐户。每个代码只能使用一次。",
    backup_code_hint: "确保复制它们并保存在安全的地方。",
    enter_a_backup_code: "输入备份代码",
    enter_backup_code_description: "输入初始启用两步验证时保存的备份代码。",
    create_a_passkey: "创建通行证",
    create_passkey_description: "使用设备生物识别、安全密钥（例如 YubiKey）或其他可用方法注册您的通行证。",
    try_another_verification_method: "尝试其他验证方法",
    verify_via_passkey: "通过通行证验证",
    verify_via_passkey_description: "使用通行证通过设备密码或生物识别、扫描 QR 码或使用 USB 安全密钥（如 YubiKey）进行验证。",
    secret_key_copied: "密钥已复制。",
    backup_code_copied: "备份代码已复制。",
    webauthn_not_ready: "WebAuthn 尚未准备就绪。请稍后重试。",
    webauthn_not_supported: "此浏览器不支持 WebAuthn。",
    webauthn_failed_to_create: "创建失败。请重试。",
    webauthn_failed_to_verify: "验证失败。请重试。"
};
var $bc13d5c32b9a2fe5$export$2e2bcd8739ae039 = Object.freeze($bc13d5c32b9a2fe5$var$mfa);


const $a254c3c26abe6787$var$secondary = {
    social_bind_with: "绑定到已有账户? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登录并绑定。"
};
var $a254c3c26abe6787$export$2e2bcd8739ae039 = Object.freeze($a254c3c26abe6787$var$secondary);


const $bfb44ac04979b543$var$zh_cn = {
    translation: {
        input: $b0359de04c83d7fd$export$2e2bcd8739ae039,
        secondary: $a254c3c26abe6787$export$2e2bcd8739ae039,
        action: $858e248a8bce95fb$export$2e2bcd8739ae039,
        description: $db81fa1761033bb8$export$2e2bcd8739ae039,
        error: $6bb47cf6d6fee9c4$export$2e2bcd8739ae039,
        list: $cbed9c1e3af05367$export$2e2bcd8739ae039,
        mfa: $bc13d5c32b9a2fe5$export$2e2bcd8739ae039,
        development_tenant: $f17a14579a8efeeb$export$2e2bcd8739ae039
    }
};
var $bfb44ac04979b543$export$2e2bcd8739ae039 = Object.freeze($bfb44ac04979b543$var$zh_cn);


const $acf84c827373d5c8$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他電子郵件",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定電子郵件或手機號碼",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄"
};
var $acf84c827373d5c8$export$2e2bcd8739ae039 = Object.freeze($acf84c827373d5c8$var$action);


const $bc94185c587252ee$var$description = {
    email: "郵箱",
    phone_number: "手機號",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意 <link></link> 以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{ address }} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{ seconds }}</span> 秒後重發",
    resend_passcode: "重發驗證碼",
    create_account_id_exists: "{{type}}為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}}為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}}為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}}為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設定密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}} 對應的密碼進行登錄",
    enter_username: "設定用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號",
    password_requirements: "要求密碼 {{items, list}}。",
    password_requirement: {
        length_one: "要求至少 {{count}} 個字符",
        length_other: "要求至少 {{count}} 個字符",
        character_types_one: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號",
        character_types_other: "要求包含至少 {{count}} 類型的大寫字母，小寫字母，數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電郵賬戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入"
};
var $bc94185c587252ee$export$2e2bcd8739ae039 = Object.freeze($bc94185c587252ee$var$description);


const $3d9fb078f066deb9$var$development_tenant = {
    notification: "你處於開發模式"
};
var $3d9fb078f066deb9$export$2e2bcd8739ae039 = Object.freeze($3d9fb078f066deb9$var$development_tenant);


const $9a1529eeea098eaf$var$password_rejected = {
    too_short: "最少長度為{{min}}。",
    too_long: "最大長度為{{max}}。",
    character_types: "至少需要{{min}}種類的字符。",
    unsupported_characters: "發現不支援的字符。",
    pwned: "避免使用容易猜測的簡單密碼。",
    restricted_found: "避免過度使用{{list, list}}。",
    restricted: {
        repetition: "重複的字符",
        sequence: "連續的字符",
        user_info: "個人資訊",
        words: "產品上下文"
    }
};
var $9a1529eeea098eaf$export$2e2bcd8739ae039 = Object.freeze($9a1529eeea098eaf$var$password_rejected);


const $8ae858a783e8ed7c$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "用戶名必填",
    password_required: "密碼必填",
    username_exists: "用戶名已存在",
    username_should_not_start_with_number: "用戶名不能以數字開頭",
    username_invalid_charset: "用戶名只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的電子郵件",
    invalid_phone: "無效的手機號碼",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $9a1529eeea098eaf$export$2e2bcd8739ae039,
    sso_not_enabled: "此電子郵件帳戶未啟用單一登錄。"
};
var $8ae858a783e8ed7c$export$2e2bcd8739ae039 = Object.freeze($8ae858a783e8ed7c$var$error);


const $4d4dc85502f8fd77$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電郵",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜索區域碼",
    backup_code: "備用碼"
};
var $4d4dc85502f8fd77$export$2e2bcd8739ae039 = Object.freeze($4d4dc85502f8fd77$var$input);


const $62ab2f90eb5f0719$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $62ab2f90eb5f0719$export$2e2bcd8739ae039 = Object.freeze($62ab2f90eb5f0719$var$list);


const $da8b432e96ef450b$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $da8b432e96ef450b$export$2e2bcd8739ae039 = Object.freeze($da8b432e96ef450b$var$mfa);


const $9654ef986374023e$var$secondary = {
    social_bind_with: "綁定到已有帳戶? 使用 {{methods, list(type: disjunction;), zhOrSpaces}} 登入並綁定。"
};
var $9654ef986374023e$export$2e2bcd8739ae039 = Object.freeze($9654ef986374023e$var$secondary);


const $f67ffe262ac4bc45$var$zh_hk = {
    translation: {
        input: $4d4dc85502f8fd77$export$2e2bcd8739ae039,
        secondary: $9654ef986374023e$export$2e2bcd8739ae039,
        action: $acf84c827373d5c8$export$2e2bcd8739ae039,
        description: $bc94185c587252ee$export$2e2bcd8739ae039,
        error: $8ae858a783e8ed7c$export$2e2bcd8739ae039,
        list: $62ab2f90eb5f0719$export$2e2bcd8739ae039,
        mfa: $da8b432e96ef450b$export$2e2bcd8739ae039,
        development_tenant: $3d9fb078f066deb9$export$2e2bcd8739ae039
    }
};
var $f67ffe262ac4bc45$export$2e2bcd8739ae039 = Object.freeze($f67ffe262ac4bc45$var$zh_hk);


const $69439982d41bda5b$var$action = {
    sign_in: "登錄",
    continue: "繼續",
    create_account: "註冊",
    create_account_without_linking: "註冊新的帳號",
    create: "註冊",
    enter_passcode: "輸入驗證碼",
    confirm: "確認",
    cancel: "取消",
    save_password: "保存密碼",
    bind: "綁定到 {{address}}",
    bind_and_continue: "綁定並繼續",
    back: "返回",
    nav_back: "返回",
    nav_skip: "跳過",
    agree: "同意",
    got_it: "知道了",
    sign_in_with: "通過 {{name}} 繼續",
    forgot_password: "忘記密碼？",
    switch_to: "切換到{{method}}",
    sign_in_via_passcode: "用驗證碼登錄",
    sign_in_via_password: "密碼登錄",
    change: "更改{{method}}",
    link_another_email: "綁定其他郵箱",
    link_another_phone: "綁定其他手機",
    link_another_email_or_phone: "綁定郵箱或手機號",
    show_password: "顯示密碼",
    copy: "複製",
    verify_via_passkey: "透過 Passkey 驗證",
    download: "下載",
    single_sign_on: "單點登錄"
};
var $69439982d41bda5b$export$2e2bcd8739ae039 = Object.freeze($69439982d41bda5b$var$action);


const $1e949d44af5be061$var$description = {
    email: "郵箱",
    phone_number: "手機號碼",
    username: "用戶名",
    reminder: "提示",
    not_found: "404 頁面不存在",
    agree_with_terms: "我已閱讀並同意 ",
    agree_with_terms_modal: "請先同意<link></link>以繼續",
    terms_of_use: "使用條款",
    sign_in: "登錄",
    privacy_policy: "隱私政策",
    create_account: "創建帳號",
    or: "或",
    and: "和",
    enter_passcode: "驗證碼已經發送至你的{{address}} {{target}}",
    passcode_sent: "驗證碼已經發送",
    resend_after_seconds: "在 <span>{{seconds}}</span> 秒後重新發送",
    resend_passcode: "重新發送驗證碼",
    create_account_id_exists: "{{type}} 為 {{value}} 的帳號已存在，你要登錄嗎？",
    link_account_id_exists: " {{type}} 為 {{value}} 的帳號已註冊，你要綁定至這個帳號嗎？",
    sign_in_id_does_not_exist: "{{type}} 為 {{value}} 的帳號不存在，你要創建一個新帳號嗎？",
    sign_in_id_does_not_exist_alert: "{{type}} 為 {{value}} 的帳號不存在。",
    create_account_id_exists_alert: "{{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}。",
    social_identity_exist: " {{type}} {{value}} 已綁定其他帳號。請嘗試其他{{type}}",
    bind_account_title: "綁定或註冊帳號",
    social_create_account: "你可以註冊一個新的帳號。",
    social_link_email: "你可以綁定其他郵箱",
    social_link_phone: "你可以綁定其他手機號碼",
    social_link_email_or_phone: "你可以綁定其他郵箱或手機號碼",
    social_bind_with_existing: "找到了一個已註冊的帳號，你可以直接綁定。",
    reset_password: "忘記密碼",
    reset_password_description: "輸入{{types, list(type: disjunction;)}}，獲取驗證碼以重設密碼。",
    new_password: "新密碼",
    set_password: "設置密碼",
    password_changed: "已重置密碼！",
    no_account: "還沒有帳號？",
    have_account: " 已有帳號？",
    enter_password: "輸入密碼",
    enter_password_for: "輸入{{method}} {{value}}對應的密碼進行登錄",
    enter_username: "設置用戶名",
    enter_username_description: "用戶名可以用來進行登錄。用戶名僅可以包含字母、數字和下劃線。",
    link_email: "綁定郵箱",
    link_phone: "綁定手機",
    link_email_or_phone: "綁定郵箱或手機號碼",
    link_email_description: "綁定郵箱以保障你的帳號安全",
    link_phone_description: "綁定手機號碼以保障你的帳號安全",
    link_email_or_phone_description: "綁定郵箱或手機號碼以保障你的帳號安全",
    continue_with_more_information: "為保障你的帳號安全，需要你補充以下信息。",
    create_your_account: "註冊你的帳號",
    sign_in_to_your_account: "登錄你的帳號",
    no_region_code_found: "沒有找到區域碼",
    verify_email: "驗證你的郵箱",
    verify_phone: "驗證你的手機號碼",
    password_requirements: "密碼{{items, list}}。",
    password_requirement: {
        length_one: "長度至少為 {{count}} 個字符",
        length_other: "長度至少為 {{count}} 個字符",
        character_types_one: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號",
        character_types_other: "需包含 {{count}} 類型的大寫字母、小寫字母、數字和符號"
    },
    use: "使用",
    single_sign_on_email_form: "輸入你的企業電子郵件地址",
    single_sign_on_connectors_list: "您的企業已為電子郵件帳戶{{email}}啟用單一登入。您可以繼續使用以下的SSO供應商登入。",
    single_sign_on_enabled: "該帳戶已啟用單一登入"
};
var $1e949d44af5be061$export$2e2bcd8739ae039 = Object.freeze($1e949d44af5be061$var$description);


const $185cbf49f505b505$var$development_tenant = {
    notification: "你處於開發模式"
};
var $185cbf49f505b505$export$2e2bcd8739ae039 = Object.freeze($185cbf49f505b505$var$development_tenant);


const $c8d968317db8a65c$var$password_rejected = {
    too_short: "最少需要 {{min}} 位字元。",
    too_long: "最多只能有 {{max}} 位字元。",
    character_types: "至少需要 {{min}} 種不同的字元類型。",
    unsupported_characters: "發現不支援的字元。",
    pwned: "請避免使用容易被猜中的簡單密碼。",
    restricted_found: "請避免過度使用 {{list, list}}。",
    restricted: {
        repetition: "連續重複的字元",
        sequence: "連續的字元",
        user_info: "個人資訊",
        words: "使用產品相關的字詞"
    }
};
var $c8d968317db8a65c$export$2e2bcd8739ae039 = Object.freeze($c8d968317db8a65c$var$password_rejected);


const $ec86c06fc31891c1$var$error = {
    general_required: "{{types, list(type: disjunction;)}}必填",
    general_invalid: "無效的{{types, list(type: disjunction;)}}",
    username_required: "使用者名稱必填",
    password_required: "密碼必填",
    username_exists: "使用者名稱已存在",
    username_should_not_start_with_number: "使用者名稱不能以數字開頭",
    username_invalid_charset: "使用者名稱只能包含英文字母、數字或下劃線。",
    invalid_email: "無效的郵箱",
    invalid_phone: "無效的手機號",
    passwords_do_not_match: "兩次輸入的密碼不一致，請重試。",
    invalid_passcode: "無效的驗證碼",
    invalid_connector_auth: "登錄失敗",
    invalid_connector_request: "無效的登錄請求",
    unknown: "未知錯誤，請稍後重試。",
    invalid_session: "未找到會話，請返回並重新登錄。",
    timeout: "請求超時，請稍後重試。",
    password_rejected: $c8d968317db8a65c$export$2e2bcd8739ae039,
    sso_not_enabled: "此郵箱帳戶未啟用單一登錄。"
};
var $ec86c06fc31891c1$export$2e2bcd8739ae039 = Object.freeze($ec86c06fc31891c1$var$error);


const $55e3fe79cbdba901$var$input = {
    username: "用戶名",
    password: "密碼",
    email: "電子郵件",
    phone_number: "手機號碼",
    confirm_password: "確認密碼",
    search_region_code: "搜尋區域碼",
    backup_code: "備用碼"
};
var $55e3fe79cbdba901$export$2e2bcd8739ae039 = Object.freeze($55e3fe79cbdba901$var$input);


const $d1bcd91f75c30561$var$list = {
    or: "或",
    and: "和",
    separator: "，"
};
var $d1bcd91f75c30561$export$2e2bcd8739ae039 = Object.freeze($d1bcd91f75c30561$var$list);


const $616b4594dbddbda3$var$mfa = {
    totp: "身份驗證應用 OTP",
    webauthn: "通行證",
    backup_code: "備份代碼",
    link_totp_description: "例如，Google Authenticator 等。",
    link_webauthn_description: "鏈接您的設備或 USB 硬件",
    link_backup_code_description: "生成備份代碼",
    verify_totp_description: "在應用程序中輸入一次性代碼",
    verify_webauthn_description: "驗證您的設備或 USB 硬件",
    verify_backup_code_description: "粘貼您保存的備份代碼",
    add_mfa_factors: "添加兩步驗證",
    add_mfa_description: "已啟用兩步驗證。選擇第二種驗證方法進行安全登錄。",
    verify_mfa_factors: "兩步驗證",
    verify_mfa_description: "此帳戶已啟用兩步驗證。請選擇第二種驗證身份的方式。",
    add_authenticator_app: "添加身份驗證應用",
    step: "步驟 {{step, number}}: {{content}}",
    scan_qr_code: "掃描此 QR 碼",
    scan_qr_code_description: "使用身份驗證應用程序（如 Google Authenticator、Duo Mobile、Authy 等）掃描以下 QR 碼。",
    qr_code_not_available: "無法掃描 QR 碼？",
    copy_and_paste_key: "複製並粘貼密鑰",
    copy_and_paste_key_description: "將以下密鑰複製並粘貼到身份驗證應用程序中，如 Google Authenticator、Duo Mobile、Authy 等。",
    want_to_scan_qr_code: "想要掃描 QR 碼嗎？",
    enter_one_time_code: "輸入一次性代碼",
    enter_one_time_code_link_description: "輸入身份驗證應用生成的 6 位驗證碼。",
    enter_one_time_code_description: "此帳戶啟用了兩步驗證。請輸入在您關聯的認證應用中顯示的一次性代碼。",
    link_another_mfa_factor: "切換到另一種方法",
    save_backup_code: "保存您的備份代碼",
    save_backup_code_description: "如果在其他方式的兩步驗證中遇到問題，您可以使用這些備份代碼之一訪問您的帳戶。每個代碼只能使用一次。",
    backup_code_hint: "確保複製它們並保存在安全的地方。",
    enter_a_backup_code: "輸入備份代碼",
    enter_backup_code_description: "輸入初始啟用兩步驗證時保存的備份代碼。",
    create_a_passkey: "創建通行證",
    create_passkey_description: "使用設備生物識別、安全密鑰（例如 YubiKey）或其他可用方法註冊您的通行證。",
    try_another_verification_method: "嘗試其他驗證方法",
    verify_via_passkey: "通過通行證驗證",
    verify_via_passkey_description: "使用通行證通過設備密碼或生物識別、掃描 QR 碼或使用 USB 安全密鑰（如 YubiKey）進行驗證。",
    secret_key_copied: "密鑰已複製。",
    backup_code_copied: "備份代碼已複製。",
    webauthn_not_ready: "WebAuthn 尚未準備就緒。請稍後重試。",
    webauthn_not_supported: "此瀏覽器不支援 WebAuthn。",
    webauthn_failed_to_create: "創建失敗。請重試。",
    webauthn_failed_to_verify: "驗證失敗。請重試。"
};
var $616b4594dbddbda3$export$2e2bcd8739ae039 = Object.freeze($616b4594dbddbda3$var$mfa);


const $c9c5544bf1b95c0b$var$secondary = {
    social_bind_with: "綁定到已有帳戶？使用 {{methods，list(type：disjunction;)，zhOrSpaces}} 登入並綁定。"
};
var $c9c5544bf1b95c0b$export$2e2bcd8739ae039 = Object.freeze($c9c5544bf1b95c0b$var$secondary);


const $cff4ecfde8885655$var$zh_tw = {
    translation: {
        input: $55e3fe79cbdba901$export$2e2bcd8739ae039,
        secondary: $c9c5544bf1b95c0b$export$2e2bcd8739ae039,
        action: $69439982d41bda5b$export$2e2bcd8739ae039,
        description: $1e949d44af5be061$export$2e2bcd8739ae039,
        error: $ec86c06fc31891c1$export$2e2bcd8739ae039,
        list: $d1bcd91f75c30561$export$2e2bcd8739ae039,
        mfa: $616b4594dbddbda3$export$2e2bcd8739ae039,
        development_tenant: $185cbf49f505b505$export$2e2bcd8739ae039
    }
};
var $cff4ecfde8885655$export$2e2bcd8739ae039 = Object.freeze($cff4ecfde8885655$var$zh_tw);


const $4251288b56d63801$export$651548ae3cf5e245 = [
    "de",
    "en",
    "es",
    "fr",
    "it",
    "ja",
    "ko",
    "pl-PL",
    "pt-PT",
    "pt-BR",
    "ru",
    "tr-TR",
    "zh-CN",
    "zh-HK",
    "zh-TW"
];
const $4251288b56d63801$export$91d555a17bb93dc7 = $4251288b56d63801$export$651548ae3cf5e245.map((languageTag)=>({
        value: languageTag,
        title: (0, $3nY0n.languages)[languageTag]
    }));
const $4251288b56d63801$export$5ac61cba82e41a23 = (0, $2CYkO.z).enum($4251288b56d63801$export$651548ae3cf5e245);
const $4251288b56d63801$var$resource = {
    de: $5e82a27eecb6733e$export$2e2bcd8739ae039,
    en: $569450392e7041f1$export$2e2bcd8739ae039,
    es: $2859dca83214d271$export$2e2bcd8739ae039,
    fr: $5c147e42498b9ce8$export$2e2bcd8739ae039,
    it: $9807ebe3a7f8f697$export$2e2bcd8739ae039,
    ja: $1800de568ffc42fb$export$2e2bcd8739ae039,
    ko: $f947133fc81adadb$export$2e2bcd8739ae039,
    "pl-PL": (0, $579cd5047d2c6635$export$2e2bcd8739ae039),
    "pt-PT": (0, $d09f25d0a6aff725$export$2e2bcd8739ae039),
    "pt-BR": (0, $686cff689f541990$export$2e2bcd8739ae039),
    ru: $e330628e4a722e29$export$2e2bcd8739ae039,
    "tr-TR": (0, $3f61b8c86e3e3079$export$2e2bcd8739ae039),
    "zh-CN": (0, $bfb44ac04979b543$export$2e2bcd8739ae039),
    "zh-HK": (0, $f67ffe262ac4bc45$export$2e2bcd8739ae039),
    "zh-TW": (0, $cff4ecfde8885655$export$2e2bcd8739ae039)
};
const $4251288b56d63801$export$559ef0bafb7e082f = (language)=>$4251288b56d63801$export$5ac61cba82e41a23.or((0, $dMkQh.fallback)("en")).parse(language);
const $4251288b56d63801$export$562f9b4f03c85f6c = (language)=>$4251288b56d63801$export$5ac61cba82e41a23.safeParse(language).success;
var $4251288b56d63801$export$2e2bcd8739ae039 = $4251288b56d63801$var$resource;


parcelRequire("bGN6i");
var $5t2HV = parcelRequire("5t2HV");

var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");

var $2ANSb = parcelRequire("2ANSb");
const $d11b3c4baa98b114$var$useUiLanguages = ()=>{
    const { data: customPhraseList, error: error, mutate: mutate } = (0, $2mi28.default)("api/custom-phrases");
    const languages = (0, $eCoWV.useMemo)(()=>(0, $5t2HV.deduplicate)([
            ...(0, $4251288b56d63801$export$651548ae3cf5e245),
            ...customPhraseList?.map(({ languageTag: languageTag })=>languageTag) ?? []
        ]).slice().sort(), [
        customPhraseList
    ]);
    const api = (0, $2ANSb.default)();
    const addLanguage = (0, $eCoWV.useCallback)(async (languageTag)=>{
        await api.put(`api/custom-phrases/${languageTag}`, {
            json: {}
        });
        await mutate();
    }, [
        api,
        mutate
    ]);
    return {
        customPhrases: customPhraseList,
        languages: languages,
        error: error,
        isLoading: !customPhraseList && !error,
        addLanguage: addLanguage,
        mutate: mutate
    };
};
var $d11b3c4baa98b114$export$2e2bcd8739ae039 = $d11b3c4baa98b114$var$useUiLanguages;


var $0f21a3997bf8a09d$exports = {};

$parcel$export($0f21a3997bf8a09d$exports, "dark", function () { return $0f21a3997bf8a09d$export$55ce6f3a06c59543; }, function (v) { return $0f21a3997bf8a09d$export$55ce6f3a06c59543 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "device", function () { return $0f21a3997bf8a09d$export$91cea577896d70d9; }, function (v) { return $0f21a3997bf8a09d$export$91cea577896d70d9 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "deviceWrapper", function () { return $0f21a3997bf8a09d$export$798a0bc8ea81196c; }, function (v) { return $0f21a3997bf8a09d$export$798a0bc8ea81196c = v; });
$parcel$export($0f21a3997bf8a09d$exports, "light", function () { return $0f21a3997bf8a09d$export$a43af521ac8c3202; }, function (v) { return $0f21a3997bf8a09d$export$a43af521ac8c3202 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "mobile", function () { return $0f21a3997bf8a09d$export$1c4e7a9c31a6c071; }, function (v) { return $0f21a3997bf8a09d$export$1c4e7a9c31a6c071 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "preview", function () { return $0f21a3997bf8a09d$export$48c2d0f2f545ac27; }, function (v) { return $0f21a3997bf8a09d$export$48c2d0f2f545ac27 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "rotating", function () { return $0f21a3997bf8a09d$export$bfd64c937657f93a; }, function (v) { return $0f21a3997bf8a09d$export$bfd64c937657f93a = v; });
$parcel$export($0f21a3997bf8a09d$exports, "shimmer", function () { return $0f21a3997bf8a09d$export$4a6dd88bada4e7d2; }, function (v) { return $0f21a3997bf8a09d$export$4a6dd88bada4e7d2 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "time", function () { return $0f21a3997bf8a09d$export$2da9be4cfdb689b1; }, function (v) { return $0f21a3997bf8a09d$export$2da9be4cfdb689b1 = v; });
$parcel$export($0f21a3997bf8a09d$exports, "topBar", function () { return $0f21a3997bf8a09d$export$ac052f74bbc68e2d; }, function (v) { return $0f21a3997bf8a09d$export$ac052f74bbc68e2d = v; });
$parcel$export($0f21a3997bf8a09d$exports, "web", function () { return $0f21a3997bf8a09d$export$6fe8eed8ccd585ce; }, function (v) { return $0f21a3997bf8a09d$export$6fe8eed8ccd585ce = v; });
var $0f21a3997bf8a09d$export$55ce6f3a06c59543;
var $0f21a3997bf8a09d$export$91cea577896d70d9;
var $0f21a3997bf8a09d$export$798a0bc8ea81196c;
var $0f21a3997bf8a09d$export$a43af521ac8c3202;
var $0f21a3997bf8a09d$export$1c4e7a9c31a6c071;
var $0f21a3997bf8a09d$export$48c2d0f2f545ac27;
var $0f21a3997bf8a09d$export$bfd64c937657f93a;
var $0f21a3997bf8a09d$export$4a6dd88bada4e7d2;
var $0f21a3997bf8a09d$export$2da9be4cfdb689b1;
var $0f21a3997bf8a09d$export$ac052f74bbc68e2d;
var $0f21a3997bf8a09d$export$6fe8eed8ccd585ce;
$0f21a3997bf8a09d$export$55ce6f3a06c59543 = `_25xENG_dark`;
$0f21a3997bf8a09d$export$91cea577896d70d9 = `_25xENG_device`;
$0f21a3997bf8a09d$export$798a0bc8ea81196c = `_25xENG_deviceWrapper`;
$0f21a3997bf8a09d$export$a43af521ac8c3202 = `_25xENG_light`;
$0f21a3997bf8a09d$export$1c4e7a9c31a6c071 = `_25xENG_mobile`;
$0f21a3997bf8a09d$export$48c2d0f2f545ac27 = `_25xENG_preview`;
$0f21a3997bf8a09d$export$bfd64c937657f93a = `_25xENG_rotating`;
$0f21a3997bf8a09d$export$4a6dd88bada4e7d2 = `_25xENG_shimmer`;
$0f21a3997bf8a09d$export$2da9be4cfdb689b1 = `_25xENG_time`;
$0f21a3997bf8a09d$export$ac052f74bbc68e2d = `_25xENG_topBar`;
$0f21a3997bf8a09d$export$6fe8eed8ccd585ce = `_25xENG_web`;


var $1fc616453f583432$export$70866093e58553f7;
(function(PreviewPlatform) {
    PreviewPlatform["DesktopWeb"] = "desktopWeb";
    PreviewPlatform["Mobile"] = "mobile";
    PreviewPlatform["MobileWeb"] = "mobileWeb";
})($1fc616453f583432$export$70866093e58553f7 || ($1fc616453f583432$export$70866093e58553f7 = {}));



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $80bcf26300a2c52e$var$SvgMoon = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14.427 8.667a.667.667 0 0 0-.7-.094 5.367 5.367 0 0 1-2.247.487 5.433 5.433 0 0 1-5.427-5.4c.003-.45.06-.897.167-1.333a.667.667 0 0 0-.887-.754 6.76 6.76 0 1 0 9.334 7.794.667.667 0 0 0-.24-.7Zm-6.334 4.46A5.426 5.426 0 0 1 4.72 3.48v.18a6.767 6.767 0 0 0 8.16 6.613 5.406 5.406 0 0 1-4.787 2.88v-.026Z",
            fill: "currentColor"
        })
    });
var $80bcf26300a2c52e$export$2e2bcd8739ae039 = $80bcf26300a2c52e$var$SvgMoon;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a3390331355f0d84$var$SvgSun = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M3.333 8a.667.667 0 0 0-.666-.667H2a.667.667 0 0 0 0 1.334h.667A.667.667 0 0 0 3.333 8Zm.427 3.333-.473.474a.667.667 0 0 0 0 .94.667.667 0 0 0 .94 0l.473-.474a.667.667 0 0 0-.94-.94Zm4.24-8a.667.667 0 0 0 .667-.666V2a.667.667 0 1 0-1.334 0v.667A.667.667 0 0 0 8 3.333Zm3.773 1.56c.175 0 .343-.07.467-.193l.473-.473a.667.667 0 1 0-.94-.94l-.44.473a.667.667 0 0 0 .44 1.133Zm-8-.193a.667.667 0 0 0 1.134-.47.667.667 0 0 0-.194-.47l-.473-.473a.67.67 0 1 0-.953.94l.486.473ZM14 7.333h-.667a.667.667 0 1 0 0 1.334H14a.667.667 0 1 0 0-1.334Zm-1.76 4a.667.667 0 0 0-.907.907l.474.473a.667.667 0 0 0 .94 0 .666.666 0 0 0 0-.94l-.507-.44Zm-4.24-7A3.667 3.667 0 1 0 11.667 8 3.674 3.674 0 0 0 8 4.333Zm0 6a2.333 2.333 0 1 1 0-4.666 2.333 2.333 0 0 1 0 4.666Zm0 2.334a.667.667 0 0 0-.667.666V14a.667.667 0 1 0 1.334 0v-.667A.667.667 0 0 0 8 12.667Z",
            fill: "currentColor"
        })
    });
var $a3390331355f0d84$export$2e2bcd8739ae039 = $a3390331355f0d84$var$SvgSun;



var $kcPww = parcelRequire("kcPww");
var $48a07d70dbcc7ac1$exports = {};

$parcel$export($48a07d70dbcc7ac1$exports, "button", function () { return $48a07d70dbcc7ac1$export$2ba01fb71ed41cb6; }, function (v) { return $48a07d70dbcc7ac1$export$2ba01fb71ed41cb6 = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "container", function () { return $48a07d70dbcc7ac1$export$34e0f9847d4c02dd; }, function (v) { return $48a07d70dbcc7ac1$export$34e0f9847d4c02dd = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "icon", function () { return $48a07d70dbcc7ac1$export$1ca1ec8b29a4ce27; }, function (v) { return $48a07d70dbcc7ac1$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "large", function () { return $48a07d70dbcc7ac1$export$f09585a853dddd32; }, function (v) { return $48a07d70dbcc7ac1$export$f09585a853dddd32 = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "medium", function () { return $48a07d70dbcc7ac1$export$649ecc744817b5c7; }, function (v) { return $48a07d70dbcc7ac1$export$649ecc744817b5c7 = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "rotating", function () { return $48a07d70dbcc7ac1$export$bfd64c937657f93a; }, function (v) { return $48a07d70dbcc7ac1$export$bfd64c937657f93a = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "shimmer", function () { return $48a07d70dbcc7ac1$export$4a6dd88bada4e7d2; }, function (v) { return $48a07d70dbcc7ac1$export$4a6dd88bada4e7d2 = v; });
$parcel$export($48a07d70dbcc7ac1$exports, "small", function () { return $48a07d70dbcc7ac1$export$3c17b0e969a90510; }, function (v) { return $48a07d70dbcc7ac1$export$3c17b0e969a90510 = v; });
var $48a07d70dbcc7ac1$export$2ba01fb71ed41cb6;
var $48a07d70dbcc7ac1$export$34e0f9847d4c02dd;
var $48a07d70dbcc7ac1$export$1ca1ec8b29a4ce27;
var $48a07d70dbcc7ac1$export$f09585a853dddd32;
var $48a07d70dbcc7ac1$export$649ecc744817b5c7;
var $48a07d70dbcc7ac1$export$bfd64c937657f93a;
var $48a07d70dbcc7ac1$export$4a6dd88bada4e7d2;
var $48a07d70dbcc7ac1$export$3c17b0e969a90510;
$48a07d70dbcc7ac1$export$2ba01fb71ed41cb6 = `DiRmtq_button`;
$48a07d70dbcc7ac1$export$34e0f9847d4c02dd = `DiRmtq_container`;
$48a07d70dbcc7ac1$export$1ca1ec8b29a4ce27 = `DiRmtq_icon`;
$48a07d70dbcc7ac1$export$f09585a853dddd32 = `DiRmtq_large`;
$48a07d70dbcc7ac1$export$649ecc744817b5c7 = `DiRmtq_medium`;
$48a07d70dbcc7ac1$export$bfd64c937657f93a = `DiRmtq_rotating`;
$48a07d70dbcc7ac1$export$4a6dd88bada4e7d2 = `DiRmtq_shimmer`;
$48a07d70dbcc7ac1$export$3c17b0e969a90510 = `DiRmtq_small`;


function $c47db53c375844f5$var$ToggleUiThemeButton({ value: value, onToggle: onToggle, className: className, iconClassName: iconClassName, size: size = "medium" }) {
    const ThemeIcon = value === (0, $bhvxB.Theme).Light ? (0, $a3390331355f0d84$export$2e2bcd8739ae039) : (0, $80bcf26300a2c52e$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($48a07d70dbcc7ac1$exports.container, $48a07d70dbcc7ac1$exports[size]),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
            size: size,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($48a07d70dbcc7ac1$exports.button, className),
            icon: /*#__PURE__*/ (0, $9zeGj.jsx)(ThemeIcon, {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($48a07d70dbcc7ac1$exports.icon, iconClassName)
            }),
            onClick: ()=>{
                onToggle(value === (0, $bhvxB.Theme).Light ? (0, $bhvxB.Theme).Dark : (0, $bhvxB.Theme).Light);
            }
        })
    });
}
var $c47db53c375844f5$export$2e2bcd8739ae039 = $c47db53c375844f5$var$ToggleUiThemeButton;


function $4079df6da596c72e$var$SignInExperiencePreview({ platform: platform, mode: mode, language: language = "en", signInExperience: signInExperience }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { customPhrases: customPhrases } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const previewRef = (0, $eCoWV.useRef)(null);
    const { data: allConnectors } = (0, $2mi28.default)("api/connectors");
    const [iframeLoaded, setIframeLoaded] = (0, $eCoWV.useState)(false);
    const configForUiPage = (0, $eCoWV.useMemo)(()=>{
        if (!allConnectors || !signInExperience) return;
        const socialConnectors = signInExperience.socialSignInConnectorTargets.reduce((previous, connectorTarget)=>[
                ...previous,
                ...allConnectors.filter(({ target: target })=>target === connectorTarget)
            ], []);
        const hasEmailConnector = allConnectors.some(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Email);
        const hasSmsConnector = allConnectors.some(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Sms);
        return {
            signInExperience: {
                ...signInExperience,
                socialConnectors: socialConnectors,
                forgotPassword: {
                    email: hasEmailConnector,
                    sms: hasSmsConnector
                }
            },
            language: language,
            mode: mode,
            platform: platform === (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb ? "web" : "mobile",
            isNative: platform === (0, $1fc616453f583432$export$70866093e58553f7).Mobile
        };
    }, [
        allConnectors,
        language,
        mode,
        platform,
        signInExperience
    ]);
    const postPreviewMessage = (0, $eCoWV.useCallback)(()=>{
        if (!configForUiPage || !customPhrases) return;
        previewRef.current?.contentWindow?.postMessage({
            sender: "ac_preview",
            config: configForUiPage
        }, tenantEndpoint?.origin ?? "");
    }, [
        tenantEndpoint?.origin,
        configForUiPage,
        customPhrases
    ]);
    const iframeOnLoadEventHandler = (0, $eCoWV.useCallback)(()=>{
        setIframeLoaded(true);
    }, []);
    (0, $eCoWV.useEffect)(()=>{
        const iframe = previewRef.current;
        iframe?.addEventListener("load", iframeOnLoadEventHandler);
        return ()=>{
            iframe?.removeEventListener("load", iframeOnLoadEventHandler);
        };
    }, [
        iframeLoaded,
        iframeOnLoadEventHandler
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!iframeLoaded) return;
        postPreviewMessage();
    }, [
        iframeLoaded,
        postPreviewMessage
    ]);
    if (!tenantEndpoint) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($0f21a3997bf8a09d$exports.preview, platform === (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb ? $0f21a3997bf8a09d$exports.web : $0f21a3997bf8a09d$exports.mobile),
        style: (0, $5CQIb.conditional)(platform === (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb && {
            // Set background color to match iframe's background color on both dark and light mode.
            backgroundColor: mode === (0, $bhvxB.Theme).Dark ? "#000" : "#e5e1ec"
        }),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            className: $0f21a3997bf8a09d$exports.deviceWrapper,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($0f21a3997bf8a09d$exports.device, $0f21a3997bf8a09d$exports[String(mode)]),
                children: [
                    platform !== (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $0f21a3997bf8a09d$exports.topBar,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0f21a3997bf8a09d$exports.time,
                                children: (0, $fa8b0761f15bed53$export$2e2bcd8739ae039)(Date.now(), "HH:mm")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1280fdc79a297068$export$2e2bcd8739ae039), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("iframe", {
                        ref: previewRef,
                        // Allow all sandbox rules
                        sandbox: undefined,
                        src: new URL("/sign-in?preview=true", tenantEndpoint).toString(),
                        tabIndex: -1,
                        title: t("sign_in_exp.preview.title")
                    })
                ]
            })
        })
    });
}
var $4079df6da596c72e$export$2e2bcd8739ae039 = $4079df6da596c72e$var$SignInExperiencePreview;




var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d190ad56074c82c0$var$SvgConnectorPlatformIconNative = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m8.473 10.86-.1-.08a.508.508 0 0 0-.12-.06l-.12-.053a.667.667 0 0 0-.606.18.766.766 0 0 0-.14.22.667.667 0 0 0 .867.873.974.974 0 0 0 .22-.147.667.667 0 0 0 0-.933Zm2.194-9.527H5.334a2 2 0 0 0-2 2v9.334a2 2 0 0 0 2 2h5.333a2 2 0 0 0 2-2V3.333a2 2 0 0 0-2-2Zm.667 11.334a.666.666 0 0 1-.667.666H5.334a.667.667 0 0 1-.667-.666V3.333a.667.667 0 0 1 .667-.666h5.333a.667.667 0 0 1 .667.666v9.334Z",
            fill: "currentColor"
        })
    });
var $d190ad56074c82c0$export$2e2bcd8739ae039 = $d190ad56074c82c0$var$SvgConnectorPlatformIconNative;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f5b4c873e7b02225$var$SvgConnectorPlatformIconWeb = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.667 2H3.333a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h4v1.334H4.668a.667.667 0 1 0 0 1.333h6.667a.666.666 0 1 0 0-1.333H8.667v-1.334h4a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Zm.667 7.333a.666.666 0 0 1-.667.667H3.333a.667.667 0 0 1-.666-.667V4a.667.667 0 0 1 .667-.667h9.333a.667.667 0 0 1 .667.667v5.333Z",
            fill: "currentColor"
        })
    });
var $f5b4c873e7b02225$export$2e2bcd8739ae039 = $f5b4c873e7b02225$var$SvgConnectorPlatformIconWeb;




var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $fbeQ6 = parcelRequire("fbeQ6");

var $6PcpQ = parcelRequire("6PcpQ");
var $77a6935891f6bfcf$export$1ca1ec8b29a4ce27;
var $77a6935891f6bfcf$export$bfd64c937657f93a;
var $77a6935891f6bfcf$export$d90250155de6d7e7;
var $77a6935891f6bfcf$export$4a6dd88bada4e7d2;
var $77a6935891f6bfcf$export$62d58b1c91e8e902;
$77a6935891f6bfcf$export$1ca1ec8b29a4ce27 = `ml23sq_icon`;
$77a6935891f6bfcf$export$bfd64c937657f93a = `ml23sq_rotating`;
$77a6935891f6bfcf$export$d90250155de6d7e7 = `ml23sq_selected`;
$77a6935891f6bfcf$export$4a6dd88bada4e7d2 = `ml23sq_shimmer`;
$77a6935891f6bfcf$export$62d58b1c91e8e902 = `ml23sq_tab`;


function $767342983d81c641$var$PlatformTab({ isSelected: isSelected, icon: icon, title: title, tab: tab, onClick: onClick }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        role: "tab",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($77a6935891f6bfcf$export$62d58b1c91e8e902, isSelected && $77a6935891f6bfcf$export$d90250155de6d7e7),
        onClick: ()=>{
            onClick(tab);
        },
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            onClick(tab);
        }),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $77a6935891f6bfcf$export$1ca1ec8b29a4ce27,
                children: icon
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: title
            })
        ]
    });
}
var $767342983d81c641$export$2e2bcd8739ae039 = $767342983d81c641$var$PlatformTab;


var $fb095c9bd6363ed8$export$34e0f9847d4c02dd;
var $fb095c9bd6363ed8$export$bfd64c937657f93a;
var $fb095c9bd6363ed8$export$4a6dd88bada4e7d2;
$fb095c9bd6363ed8$export$34e0f9847d4c02dd = `D_MJEG_container`;
$fb095c9bd6363ed8$export$bfd64c937657f93a = `D_MJEG_rotating`;
$fb095c9bd6363ed8$export$4a6dd88bada4e7d2 = `D_MJEG_shimmer`;


function $d6a62433b5c1805c$var$PlatformTabs({ currentTab: currentTab, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $fb095c9bd6363ed8$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $767342983d81c641$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f5b4c873e7b02225$export$2e2bcd8739ae039), {}),
                title: "cloud.sie.preview.web_tab",
                tab: (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb,
                isSelected: currentTab === (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb,
                onClick: onSelect
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $767342983d81c641$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d190ad56074c82c0$export$2e2bcd8739ae039), {}),
                title: "cloud.sie.preview.mobile_tab",
                tab: (0, $1fc616453f583432$export$70866093e58553f7).MobileWeb,
                isSelected: currentTab === (0, $1fc616453f583432$export$70866093e58553f7).MobileWeb,
                onClick: onSelect
            })
        ]
    });
}
var $d6a62433b5c1805c$export$2e2bcd8739ae039 = $d6a62433b5c1805c$var$PlatformTabs;


var $c9128a3c778732d9$export$34e0f9847d4c02dd;
var $c9128a3c778732d9$export$bfd64c937657f93a;
var $c9128a3c778732d9$export$4a6dd88bada4e7d2;
$c9128a3c778732d9$export$34e0f9847d4c02dd = `_7syY9W_container`;
$c9128a3c778732d9$export$bfd64c937657f93a = `_7syY9W_rotating`;
$c9128a3c778732d9$export$4a6dd88bada4e7d2 = `_7syY9W_shimmer`;


function $3d19176eece49f6e$var$Preview({ signInExperience: signInExperience, className: className }) {
    const [currentTab, setCurrentTab] = (0, $eCoWV.useState)((0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c9128a3c778732d9$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d6a62433b5c1805c$export$2e2bcd8739ae039), {
                currentTab: currentTab,
                onSelect: setCurrentTab
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4079df6da596c72e$export$2e2bcd8739ae039), {
                platform: currentTab,
                mode: (0, $bhvxB.Theme).Light,
                signInExperience: signInExperience
            })
        ]
    });
}
var $3d19176eece49f6e$export$2e2bcd8739ae039 = $3d19176eece49f6e$var$Preview;



var $9zeGj = parcelRequire("9zeGj");

var $60492aab8d33c2f1$export$3e4dd27034fea0be;
var $60492aab8d33c2f1$export$e506a1d27d1eaa20;
var $60492aab8d33c2f1$export$a7db06668cad9adb;
var $60492aab8d33c2f1$export$e8c278056cb4f639;
var $60492aab8d33c2f1$export$48c2d0f2f545ac27;
var $60492aab8d33c2f1$export$bfd64c937657f93a;
var $60492aab8d33c2f1$export$4a6dd88bada4e7d2;
var $60492aab8d33c2f1$export$fb184b623420d9be;
$60492aab8d33c2f1$export$3e4dd27034fea0be = `N3FFUG_authnSelector`;
$60492aab8d33c2f1$export$e506a1d27d1eaa20 = `N3FFUG_config`;
$60492aab8d33c2f1$export$a7db06668cad9adb = `N3FFUG_content`;
$60492aab8d33c2f1$export$e8c278056cb4f639 = `N3FFUG_continueActions`;
$60492aab8d33c2f1$export$48c2d0f2f545ac27 = `N3FFUG_preview`;
$60492aab8d33c2f1$export$bfd64c937657f93a = `N3FFUG_rotating`;
$60492aab8d33c2f1$export$4a6dd88bada4e7d2 = `N3FFUG_shimmer`;
$60492aab8d33c2f1$export$fb184b623420d9be = `N3FFUG_title`;


var $c43b76861ee73582$export$e324594224ef24da;
var $c43b76861ee73582$export$2ba01fb71ed41cb6;
var $c43b76861ee73582$export$e0f35d825088c098;
var $c43b76861ee73582$export$75c751978d4a1350;
var $c43b76861ee73582$export$38e42c68cf43b5d4;
var $c43b76861ee73582$export$db3c28d99448dcff;
var $c43b76861ee73582$export$1c4e7a9c31a6c071;
var $c43b76861ee73582$export$48c2d0f2f545ac27;
var $c43b76861ee73582$export$bfd64c937657f93a;
var $c43b76861ee73582$export$4a6dd88bada4e7d2;
var $c43b76861ee73582$export$f30f1338f6f15619;
var $c43b76861ee73582$export$32bc0991cdcef676;
var $c43b76861ee73582$export$cba3d3852a039325;
var $c43b76861ee73582$export$fb184b623420d9be;
$c43b76861ee73582$export$e324594224ef24da = `yGyQLW_actions`;
$c43b76861ee73582$export$2ba01fb71ed41cb6 = `yGyQLW_button`;
$c43b76861ee73582$export$e0f35d825088c098 = `yGyQLW_field`;
$c43b76861ee73582$export$75c751978d4a1350 = `yGyQLW_fieldWrapper`;
$c43b76861ee73582$export$38e42c68cf43b5d4 = `yGyQLW_header`;
$c43b76861ee73582$export$db3c28d99448dcff = `yGyQLW_logo`;
$c43b76861ee73582$export$1c4e7a9c31a6c071 = `yGyQLW_mobile`;
$c43b76861ee73582$export$48c2d0f2f545ac27 = `yGyQLW_preview`;
$c43b76861ee73582$export$bfd64c937657f93a = `yGyQLW_rotating`;
$c43b76861ee73582$export$4a6dd88bada4e7d2 = `yGyQLW_shimmer`;
$c43b76861ee73582$export$4a6dd88bada4e7d2;
$c43b76861ee73582$export$f30f1338f6f15619 = `yGyQLW_slogan`;
$c43b76861ee73582$export$32bc0991cdcef676 = `yGyQLW_smallButton`;
$c43b76861ee73582$export$cba3d3852a039325 = `yGyQLW_social`;
$c43b76861ee73582$export$fb184b623420d9be = `yGyQLW_title`;


function $36ac2696e48a102f$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $907d9471e8250569$export$523fb3936f49e028,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            className: $907d9471e8250569$export$8f981dffec84ba52,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $60492aab8d33c2f1$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $60492aab8d33c2f1$export$e506a1d27d1eaa20,
                        children: Array.from({
                            length: 3
                        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $c43b76861ee73582$export$75c751978d4a1350,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$fb184b623420d9be
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$e0f35d825088c098
                                    })
                                ]
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $c43b76861ee73582$export$48c2d0f2f545ac27,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $c43b76861ee73582$export$38e42c68cf43b5d4,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$2ba01fb71ed41cb6
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $c43b76861ee73582$export$e324594224ef24da,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $c43b76861ee73582$export$32bc0991cdcef676
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $c43b76861ee73582$export$2ba01fb71ed41cb6
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $c43b76861ee73582$export$1c4e7a9c31a6c071,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$db3c28d99448dcff
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$f30f1338f6f15619
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$e0f35d825088c098
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$2ba01fb71ed41cb6
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c43b76861ee73582$export$cba3d3852a039325
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
}
var $36ac2696e48a102f$export$2e2bcd8739ae039 = $36ac2696e48a102f$var$Skeleton;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");


var $93h5F = parcelRequire("93h5F");
var $2e2f0dc44bf8fad6$exports = {};

$parcel$export($2e2f0dc44bf8fad6$exports, "container", function () { return $2e2f0dc44bf8fad6$export$34e0f9847d4c02dd; }, function (v) { return $2e2f0dc44bf8fad6$export$34e0f9847d4c02dd = v; });
$parcel$export($2e2f0dc44bf8fad6$exports, "large", function () { return $2e2f0dc44bf8fad6$export$f09585a853dddd32; }, function (v) { return $2e2f0dc44bf8fad6$export$f09585a853dddd32 = v; });
$parcel$export($2e2f0dc44bf8fad6$exports, "logo", function () { return $2e2f0dc44bf8fad6$export$db3c28d99448dcff; }, function (v) { return $2e2f0dc44bf8fad6$export$db3c28d99448dcff = v; });
$parcel$export($2e2f0dc44bf8fad6$exports, "small", function () { return $2e2f0dc44bf8fad6$export$3c17b0e969a90510; }, function (v) { return $2e2f0dc44bf8fad6$export$3c17b0e969a90510 = v; });
var $2e2f0dc44bf8fad6$export$34e0f9847d4c02dd;
var $2e2f0dc44bf8fad6$export$f09585a853dddd32;
var $2e2f0dc44bf8fad6$export$db3c28d99448dcff;
var $2e2f0dc44bf8fad6$export$3c17b0e969a90510;
$2e2f0dc44bf8fad6$export$34e0f9847d4c02dd = `Am3ekq_container`;
$2e2f0dc44bf8fad6$export$f09585a853dddd32 = `Am3ekq_large`;
$2e2f0dc44bf8fad6$export$db3c28d99448dcff = `Am3ekq_logo`;
$2e2f0dc44bf8fad6$export$3c17b0e969a90510 = `Am3ekq_small`;


function $705b04999648836d$var$ConnectorLogo({ className: className, data: data, size: size = "medium" }) {
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
        containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2e2f0dc44bf8fad6$exports.container, $2e2f0dc44bf8fad6$exports[size]),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2e2f0dc44bf8fad6$exports.logo, $2e2f0dc44bf8fad6$exports[size], className),
        alt: "logo",
        src: theme === (0, $bhvxB.Theme).Dark && data.logoDark ? data.logoDark : data.logo
    });
}
var $705b04999648836d$export$2e2bcd8739ae039 = $705b04999648836d$var$ConnectorLogo;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
function $a190a073a27a2bd7$var$UnnamedTrans({ resource: resource, className: className }) {
    const { i18n: { languages: languages } } = (0, $2A6IJ.useTranslation)();
    const matchedLanguage = languages.find((language)=>resource[language]);
    if (!matchedLanguage) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        className: className,
        children: resource[matchedLanguage]
    });
}
var $a190a073a27a2bd7$export$2e2bcd8739ae039 = $a190a073a27a2bd7$var$UnnamedTrans;



var $5Yzj4 = parcelRequire("5Yzj4");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $5d57426f6ca5b907$var$SvgEnvelop = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14.167 9.167H15a.833.833 0 0 0 .833-.834V7.5A.833.833 0 0 0 15 6.667h-.833a.833.833 0 0 0-.834.833v.833a.834.834 0 0 0 .834.834ZM5 10h4.167a.833.833 0 1 0 0-1.667H5A.833.833 0 0 0 5 10Zm13.333-6.667H1.667a.833.833 0 0 0-.834.834v11.666a.833.833 0 0 0 .834.834h16.666a.833.833 0 0 0 .834-.834V4.167a.833.833 0 0 0-.834-.834ZM17.5 15h-15V5h15v10ZM5 13.333h4.167a.833.833 0 1 0 0-1.666H5a.833.833 0 0 0 0 1.666Z",
            fill: "currentColor"
        })
    });
var $5d57426f6ca5b907$export$2e2bcd8739ae039 = $5d57426f6ca5b907$var$SvgEnvelop;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b2143e366fd9e622$var$SvgKeyboard = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M5.592 7.742a.833.833 0 0 0-1.184 0 .833.833 0 0 0-.175.275.833.833 0 0 0 .175.908.958.958 0 0 0 .275.175.7.7 0 0 0 .317.067.833.833 0 0 0 .767-1.15.833.833 0 0 0-.175-.275Zm2.741 1.425a.833.833 0 0 0 .767-1.15.833.833 0 0 0-.925-.517.5.5 0 0 0-.158.05l-.15.075-.125.1a.875.875 0 0 0-.242.608.833.833 0 0 0 .833.834ZM5.317 10.9a.834.834 0 0 0-1.15.767.833.833 0 0 0 1.15.766.959.959 0 0 0 .275-.175.834.834 0 0 0 .241-.591.833.833 0 0 0-.241-.592.776.776 0 0 0-.275-.175Zm6.35-.067H8.333a.834.834 0 0 0 0 1.667h3.334a.833.833 0 1 0 0-1.667Zm.591-3.091a.833.833 0 0 0-1.183 0 .832.832 0 0 0-.175.275.833.833 0 1 0 1.6.316.7.7 0 0 0-.067-.316.832.832 0 0 0-.175-.275Zm3.209 3.233a.636.636 0 0 0-.15-.075.834.834 0 0 0-.634 0 .958.958 0 0 0-.275.175.875.875 0 0 0-.241.592.833.833 0 1 0 1.666 0 .875.875 0 0 0-.241-.592l-.125-.1Zm1.2-6.808H3.333a2.5 2.5 0 0 0-2.5 2.5v6.666a2.5 2.5 0 0 0 2.5 2.5h13.334a2.5 2.5 0 0 0 2.5-2.5V6.667a2.5 2.5 0 0 0-2.5-2.5Zm.833 9.166a.833.833 0 0 1-.833.834H3.333a.833.833 0 0 1-.833-.834V6.667a.833.833 0 0 1 .833-.834h13.334a.833.833 0 0 1 .833.834v6.666Zm-1.908-5.591a.833.833 0 0 0-1.425.591.834.834 0 1 0 1.6-.316.832.832 0 0 0-.175-.275Z",
            fill: "currentColor"
        })
    });
var $b2143e366fd9e622$export$2e2bcd8739ae039 = $b2143e366fd9e622$var$SvgKeyboard;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a1c5558ddbb9056a$var$SvgLabel = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m17.933 8.925-7.008-7.017a.834.834 0 0 0-.592-.241h-7.5A.833.833 0 0 0 2 2.5V10a.834.834 0 0 0 .242.592L9.258 17.6a2.5 2.5 0 0 0 3.534 0l5.141-5.1a2.5 2.5 0 0 0 0-3.533v-.042Zm-1.175 2.35-5.15 5.142a.833.833 0 0 1-1.175 0L3.667 9.658V3.333h6.325l6.766 6.767a.832.832 0 0 1 0 1.175Z",
            fill: "currentColor"
        })
    });
var $a1c5558ddbb9056a$export$2e2bcd8739ae039 = $a1c5558ddbb9056a$var$SvgLabel;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $72f79b9910d73aa1$var$SvgLock = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14.167 7.5V5.833a4.167 4.167 0 0 0-8.334 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM7.5 5.833a2.5 2.5 0 1 1 5 0V7.5h-5V5.833Zm7.5 10a.834.834 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V10a.833.833 0 0 1 .833-.833h8.334A.833.833 0 0 1 15 10v5.833Z",
            fill: "currentColor"
        })
    });
var $72f79b9910d73aa1$export$2e2bcd8739ae039 = $72f79b9910d73aa1$var$SvgLock;



var $5Yzj4 = parcelRequire("5Yzj4");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $5dcbf506438da8b5$var$SvgSocialApple = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M15.457 10.625a4.522 4.522 0 0 1 2.161-3.805 4.672 4.672 0 0 0-3.658-1.984c-1.558-.158-3.04.917-3.829.917-.79 0-2.009-.894-3.3-.87a4.896 4.896 0 0 0-4.139 2.508c-1.762 3.06-.45 7.593 1.268 10.076C4.8 18.681 5.802 20.05 7.118 20c1.267-.05 1.746-.82 3.276-.82 1.531 0 1.962.82 3.301.795 1.363-.025 2.228-1.239 3.062-2.457a10.948 10.948 0 0 0 1.384-2.845 4.42 4.42 0 0 1-2.684-4.047ZM12.94 3.193A4.405 4.405 0 0 0 13.98 0a4.483 4.483 0 0 0-2.946 1.516 4.185 4.185 0 0 0-1.061 3.093 3.71 3.71 0 0 0 2.967-1.416Z",
            fill: "#000"
        })
    });
var $5dcbf506438da8b5$export$2e2bcd8739ae039 = $5dcbf506438da8b5$var$SvgSocialApple;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ed2608fd949d4526$var$SvgSocialFacebook = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_1812_100173)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.992 3.656 9.129 8.438 9.879V12.89h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.262c-1.242 0-1.629.772-1.629 1.563V10h2.774l-.443 2.89h-2.33v6.989C16.343 19.129 20 14.992 20 10Z",
                        fill: "#1877F2"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "m13.893 12.89.443-2.89h-2.774V8.125c0-.791.387-1.563 1.63-1.563h1.261v-2.46s-1.144-.196-2.238-.196c-2.285 0-3.777 1.385-3.777 3.89V10h-2.54v2.89h2.54v6.989a10.057 10.057 0 0 0 3.124 0V12.89h2.33Z",
                        fill: "#fff"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                    id: "clip0_1812_100173",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $ed2608fd949d4526$export$2e2bcd8739ae039 = $ed2608fd949d4526$var$SvgSocialFacebook;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $3514bd9aaeab88b8$var$SvgSocialKakao = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_1812_100162)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M20 18.438C20 19.3 19.3 20 18.437 20H1.563C.7 20 0 19.3 0 18.437V1.563C0 .7.7 0 1.563 0h16.875C19.3 0 20 .7 20 1.563v16.875Z",
                        fill: "#FFE812"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M10 2.813c-4.487 0-8.125 2.868-8.125 6.406 0 2.287 1.52 4.294 3.808 5.428-.124.429-.8 2.76-.826 2.944 0 0-.016.138.073.19.089.053.194.012.194.012.255-.036 2.964-1.938 3.433-2.269.468.067.95.101 1.443.101 4.487 0 8.125-2.868 8.125-6.406S14.487 2.813 10 2.813Z",
                        fill: "#000"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M5.508 11.455a.46.46 0 0 1-.469-.448V8.223h-.731a.46.46 0 0 1 0-.918h2.4a.46.46 0 0 1 0 .918h-.731v2.784a.46.46 0 0 1-.47.448Zm4.11-.006c-.195 0-.345-.08-.39-.207l-.232-.608h-1.43l-.232.608c-.045.128-.194.207-.39.207a.716.716 0 0 1-.298-.065c-.129-.06-.253-.223-.11-.665l1.12-2.952c.08-.224.32-.455.625-.462.306.007.546.238.625.463l1.12 2.95c.143.443.02.607-.11.666a.717.717 0 0 1-.298.065ZM8.75 9.804l-.468-1.33-.468 1.33h.936Zm2.032 1.583a.44.44 0 0 1-.449-.43V7.773c0-.258.215-.468.478-.468.264 0 .48.21.48.468v2.754h.995a.44.44 0 0 1 .45.43.44.44 0 0 1-.45.43h-1.504Zm2.604.062a.47.47 0 0 1-.468-.469V7.773a.47.47 0 0 1 .937 0v1.008l1.308-1.308a.364.364 0 0 1 .26-.104c.117 0 .235.05.323.138a.462.462 0 0 1 .137.297.365.365 0 0 1-.103.286l-1.068 1.068 1.154 1.529a.465.465 0 0 1-.092.656.464.464 0 0 1-.492.046.467.467 0 0 1-.165-.138l-1.099-1.456-.163.162v1.023a.47.47 0 0 1-.468.469Z",
                        fill: "#FFE812"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                    id: "clip0_1812_100162",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        width: 20,
                        height: 20,
                        rx: 6,
                        fill: "#fff"
                    })
                })
            })
        ]
    });
var $3514bd9aaeab88b8$export$2e2bcd8739ae039 = $3514bd9aaeab88b8$var$SvgSocialKakao;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $9125efc9fd62f497$var$SvgSocialMicrosoft = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 23 23",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 0h23v23H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#f35325",
                d: "M1 1h10v10H1z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#81bc06",
                d: "M12 1h10v10H12z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#05a6f0",
                d: "M1 12h10v10H1z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#ffba08",
                d: "M12 12h10v10H12z"
            })
        ]
    });
var $9125efc9fd62f497$export$2e2bcd8739ae039 = $9125efc9fd62f497$var$SvgSocialMicrosoft;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $4e7eb4637d9d7d85$var$SvgSocialOidc = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_390_81345)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M20 11.5 19.5 7l-1.45.95C16.7 7.1 15 6.5 13.1 6.2c0 0-.95-.2-2.2-.2-1.25 0-2.4.15-2.4.15C3.65 6.75 0 9.5 0 12.8c0 3.4 3.75 6.2 9.5 6.7v-1.95c-3.95-.55-6.45-2.4-6.45-4.75 0-2.2 2.3-4.05 5.45-4.65 0 0 2.45-.55 4.6.1 1.05.25 2 .6 2.8 1.1L14 10.5l6 1Z",
                        fill: "#9E9E9E"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M9.5 2v17.5l3-1.5V.5L9.5 2Z",
                        fill: "#FF9800"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                    id: "clip0_390_81345",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $4e7eb4637d9d7d85$export$2e2bcd8739ae039 = $4e7eb4637d9d7d85$var$SvgSocialOidc;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d9dc6038b896333d$var$SvgSocialSmal = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M0 16.749C0 14.553 2.095 6.359 6.427.867 3.37 6.64 1.591 10.55 2.888 13.595c1.02 2.394 6.258 1.633 9.09.676-5.04 2.28-10.213 2.59-11.978 2.478Z",
                fill: "#C1272D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.384.625c1.912 1.098 8 7 10.616 13.476-3.498-5.52-6.012-9.006-9.314-9.412-2.594-.319-4.551 4.573-5.133 7.49C6.087 6.7 8.403 2.09 9.383.625Z",
                fill: "#C1272D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M18.777 16.73c-1.913 1.098-10.096 3.39-17.044 2.405 6.556-.253 10.849-.675 12.853-3.316 1.575-2.074-1.706-6.206-3.956-8.166 4.506 3.2 7.362 7.5 8.147 9.077Z",
                fill: "#C1272D"
            })
        ]
    });
var $d9dc6038b896333d$export$2e2bcd8739ae039 = $d9dc6038b896333d$var$SvgSocialSmal;


const $d02309ef1f7e694c$export$19ede94f671fb844 = [
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5d57426f6ca5b907$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
        value: (0, $bd0Y0.SignInIdentifier).Email
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a1c5558ddbb9056a$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.identifiers_username",
        value: (0, $bd0Y0.SignInIdentifier).Username
    }
];
const $d02309ef1f7e694c$export$993274cb9b03d078 = [
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $72f79b9910d73aa1$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.password_auth",
        value: (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b2143e366fd9e622$export$2e2bcd8739ae039), {}),
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth",
        value: (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).VerificationCode
    }
];
const $d02309ef1f7e694c$export$d5dcbb51002e85de = [
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5dcbf506438da8b5$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "Apple"
        }),
        value: "fake-apple",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ed2608fd949d4526$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "Facebook"
        }),
        value: "fake-facebook",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9125efc9fd62f497$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "Microsoft"
        }),
        value: "fake-microsoft",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3514bd9aaeab88b8$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "Kakao"
        }),
        value: "fake-kakao",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e7eb4637d9d7d85$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "OIDC"
        }),
        value: "fake-oidc",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d9dc6038b896333d$export$2e2bcd8739ae039), {}),
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: "SAML"
        }),
        value: "fake-saml",
        tag: "cloud.sie.connectors.unlocked_later",
        isDisabled: true,
        disabledTip: "cloud.sie.connectors.unlocked_later_tip"
    }
];


function $02f4e2ec1c902c0a$var$SocialSelector({ value: value, onChange: onChange }) {
    const { data: connectorData, error: error } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    if (!connectorData || error) return null;
    const connectorOptions = connectorData.filter(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Social).map((item)=>{
        return {
            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                size: "small",
                data: item
            }),
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                    resource: item.name
                })
            }),
            value: item.target,
            tag: "general.demo"
        };
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e8aabd15df5eaa5d$export$2e2bcd8739ae039), {
        options: [
            ...connectorOptions,
            ...(0, $d02309ef1f7e694c$export$d5dcbb51002e85de)
        ],
        value: value,
        onChange: onChange
    });
}
var $02f4e2ec1c902c0a$export$2e2bcd8739ae039 = $02f4e2ec1c902c0a$var$SocialSelector;





parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

const $2b19f2c98b9413d1$var$signInExperienceToOnboardSieConfig = (signInExperience)=>{
    const { color: { primaryColor: primaryColor }, branding: { logoUrl: logo }, signIn: { methods: signInMethods }, signUp: { identifiers: signUpIdentifiers }, socialSignInConnectorTargets: socialSignInConnectorTargets } = signInExperience;
    const identifier = signInMethods.find(({ identifier: identifier })=>signUpIdentifiers.includes(identifier))?.identifier ?? (0, $bd0Y0.SignInIdentifier).Username;
    const authentications = signInMethods.reduce((result, method)=>{
        const { password: password, verificationCode: verificationCode } = method;
        return [
            ...result,
            ...password ? [
                (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
            ] : [],
            ...verificationCode ? [
                (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).VerificationCode
            ] : []
        ];
    }, []);
    return {
        logo: logo,
        color: primaryColor,
        identifier: identifier,
        authentications: authentications,
        socialTargets: socialSignInConnectorTargets
    };
};
const $2b19f2c98b9413d1$var$onboardSieConfigToSignInExperience = (config, basedConfig)=>{
    const { logo: logo, color: onboardConfigColor, identifier: identifier, authentications: authentications, socialTargets: socialTargets } = config;
    const { color: baseColorConfig, branding: baseBranding } = basedConfig;
    // Map to sign-up config
    const shouldSetPasswordAtSignUp = identifier === (0, $bd0Y0.SignInIdentifier).Username || authentications.includes((0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password);
    const shouldVerifyAtSignUp = identifier !== (0, $bd0Y0.SignInIdentifier).Username;
    // Map to sign-in methods
    const isSignInByPasswordEnabled = identifier === (0, $bd0Y0.SignInIdentifier).Username || authentications.includes((0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password);
    const isSignInByVerificationCodeEnabled = identifier !== (0, $bd0Y0.SignInIdentifier).Username && authentications.includes((0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).VerificationCode);
    const signInExperience = {
        ...basedConfig,
        branding: {
            ...baseBranding,
            logoUrl: (0, $5CQIb.conditional)(logo?.length && logo),
            darkLogoUrl: (0, $5CQIb.conditional)(logo?.length && logo)
        },
        color: {
            ...baseColorConfig,
            primaryColor: onboardConfigColor
        },
        signUp: {
            identifiers: [
                identifier
            ],
            verify: shouldVerifyAtSignUp,
            password: shouldSetPasswordAtSignUp
        },
        signIn: {
            methods: [
                {
                    identifier: identifier,
                    password: isSignInByPasswordEnabled,
                    verificationCode: isSignInByVerificationCodeEnabled,
                    isPasswordPrimary: isSignInByPasswordEnabled
                }
            ]
        },
        socialSignInConnectorTargets: socialTargets ?? []
    };
    return signInExperience;
};
const $2b19f2c98b9413d1$export$8f49e4af10703ce3 = {
    signInExperienceToOnboardSieConfig: $2b19f2c98b9413d1$var$signInExperienceToOnboardSieConfig,
    onboardSieConfigToSignInExperience: $2b19f2c98b9413d1$var$onboardSieConfigToSignInExperience
};


function $8d05f9f7af3a4336$var$SignInExperience() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { data: signInExperience, error: error, mutate: mutate } = (0, $2mi28.default)("api/sign-in-exp");
    const isSignInExperienceDataLoading = !error && !signInExperience;
    const { isLoading: isUserAssetsServiceLoading } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const isLoading = isSignInExperienceDataLoading || isUserAssetsServiceLoading;
    const api = (0, $2ANSb.default)();
    const { isReady: isUserAssetsServiceReady } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const { update: update } = (0, $abb531754ca753b0$export$2e2bcd8739ae039)();
    const { navigateTenant: navigateTenant, currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const enterAdminConsole = async ()=>{
        await update({
            isOnboardingDone: true
        });
        navigateTenant(currentTenantId);
    };
    const { reset: reset, control: control, watch: watch, register: register, handleSubmit: handleSubmit, getValues: getValues, setValue: setValue, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)({
        defaultValues: (0, $9bd5b2807712a0c9$export$784b3784128e5b8d)
    });
    const updateAuthenticationConfig = (0, $eCoWV.useCallback)(()=>{
        const identifier = getValues("identifier");
        if (identifier === (0, $bd0Y0.SignInIdentifier).Username) setValue("authentications", [
            (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password
        ]);
    }, [
        getValues,
        setValue
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (signInExperience) {
            reset((0, $2b19f2c98b9413d1$export$8f49e4af10703ce3).signInExperienceToOnboardSieConfig(signInExperience));
            updateAuthenticationConfig();
        }
    }, [
        reset,
        signInExperience,
        updateAuthenticationConfig
    ]);
    const onboardingSieConfig = watch();
    const previewSieConfig = (0, $eCoWV.useMemo)(()=>{
        if (signInExperience) return (0, $2b19f2c98b9413d1$export$8f49e4af10703ce3).onboardSieConfigToSignInExperience(onboardingSieConfig, signInExperience);
    }, [
        onboardingSieConfig,
        signInExperience
    ]);
    const submit = (onSuccess)=>(0, $bSFEw.trySubmitSafe)(async (formData)=>{
            if (!signInExperience) return;
            /**
       * If choose `Email` as `identifier`, we will create email service connector for the tenant (when there is no existing email connector).
       * Should create this connector before updating the sign-in experience, otherwise the sign-in experience can not be updated.
       */ if (formData.identifier === (0, $bd0Y0.SignInIdentifier).Email) {
                const connectors = await api.get("api/connectors").json();
                if (!connectors.some(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Email)) await api.post("api/connectors", {
                    json: {
                        connectorId: (0, $4at8B.ServiceConnector).Email
                    }
                });
            }
            /**
       * Note: extract `mfa` since it will not be updated on the SIE config page.
       * This is a temporary solution, we will split `SignInExperience` type into multiple types
       * when the SIE config page is split into multiple pages.
       */ const { mfa: mfa, ...payload } = (0, $2b19f2c98b9413d1$export$8f49e4af10703ce3).onboardSieConfigToSignInExperience(formData, signInExperience);
            const updatedData = await api.patch((0, $h7VLF.buildUrl)("api/sign-in-exp", {
                removeUnusedDemoSocialConnector: "1"
            }), {
                json: payload
            }).json();
            mutate(updatedData);
            onSuccess();
        });
    if (isLoading) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $36ac2696e48a102f$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $907d9471e8250569$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "cloud.sie.page_title",
                    "cloud.general.onboarding"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $907d9471e8250569$export$8f981dffec84ba52,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $60492aab8d33c2f1$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $60492aab8d33c2f1$export$e506a1d27d1eaa20,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7aae23f7be89a76b$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $60492aab8d33c2f1$export$fb184b623420d9be,
                                    children: t("cloud.sie.title")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $345586a436fc807b$export$2e2bcd8739ae039), {
                                    onInspired: (template)=>{
                                        for (const [key, value] of Object.entries(template))// eslint-disable-next-line no-restricted-syntax
                                        setValue(key, value, {
                                            shouldDirty: true
                                        });
                                        updateAuthenticationConfig();
                                    }
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    title: "cloud.sie.logo_field",
                                    children: isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "logo",
                                        control: control,
                                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $0186093e59e66ade$export$2e2bcd8739ae039), {
                                                name: name,
                                                value: value ?? "",
                                                onChange: onChange
                                            })
                                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                        ...register("logo", {
                                            validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                                        }),
                                        error: errors.logo?.message
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    title: "cloud.sie.color_field",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "color",
                                        control: control,
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3f4fc0ac65eef21$export$2e2bcd8739ae039), {
                                                value: value,
                                                onChange: onChange
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    title: "cloud.sie.identifier_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "identifier",
                                        control: control,
                                        render: ({ field: { name: name, value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $3b942cfeaf20c383$export$2e2bcd8739ae039), {
                                                name: name,
                                                value: value,
                                                options: (0, $d02309ef1f7e694c$export$19ede94f671fb844),
                                                onChange: (value)=>{
                                                    onChange(value);
                                                    updateAuthenticationConfig();
                                                }
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    isMultiple: true,
                                    title: "cloud.sie.authn_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "authentications",
                                        control: control,
                                        defaultValue: (0, $9bd5b2807712a0c9$export$784b3784128e5b8d).authentications,
                                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $e8aabd15df5eaa5d$export$2e2bcd8739ae039), {
                                                isNotAllowEmpty: true,
                                                className: $60492aab8d33c2f1$export$3e4dd27034fea0be,
                                                value: value,
                                                options: (0, $d02309ef1f7e694c$export$993274cb9b03d078).filter(({ value: value })=>onboardingSieConfig.identifier !== (0, $bd0Y0.SignInIdentifier).Username || value === (0, $49a3cd5201e05816$export$d9e3c9dc7eaad0c3).Password),
                                                onChange: onChange
                                            })
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    isMultiple: true,
                                    title: "cloud.sie.social_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "socialTargets",
                                        control: control,
                                        defaultValue: (0, $9bd5b2807712a0c9$export$784b3784128e5b8d).socialTargets,
                                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $02f4e2ec1c902c0a$export$2e2bcd8739ae039), {
                                                value: value ?? [],
                                                onChange: onChange
                                            })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3d19176eece49f6e$export$2e2bcd8739ae039), {
                            className: $60492aab8d33c2f1$export$48c2d0f2f545ac27,
                            signInExperience: previewSieConfig
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 2,
                totalSteps: 2,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $60492aab8d33c2f1$export$e8c278056cb4f639,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            type: "primary",
                            title: "cloud.sie.finish_and_done",
                            disabled: isSubmitting,
                            onClick: async ()=>{
                                await handleSubmit(submit(enterAdminConsole))();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.back",
                        disabled: isSubmitting,
                        onClick: ()=>{
                            navigate((0, $9d023628a9c0fa6c$export$75332796271f8048)((0, $49a3cd5201e05816$export$1572a1adf9290869).Welcome));
                        }
                    })
                ]
            })
        ]
    });
}
var $8d05f9f7af3a4336$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($8d05f9f7af3a4336$var$SignInExperience);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $dec12682ad8872b7$var$SvgCase = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M7 17a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V17Z",
                fill: "url(#paint0_linear_331_73558)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.6 13H10.4C8.522 13 7 14.79 7 17v6c0 2.21 1.522 4 3.4 4H37.6c1.878 0 3.4-1.79 3.4-4v-6c0-2.21-1.522-4-3.4-4Z",
                fill: "url(#paint1_linear_331_73558)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.6,
                x: 17,
                y: 22,
                width: 3,
                height: 8,
                rx: 1.5,
                fill: "#7B0093"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.6,
                x: 28,
                y: 22,
                width: 3,
                height: 8,
                rx: 1.5,
                fill: "#7B0093"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15 12a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v1a1 1 0 1 1-2 0v-1a1 1 0 0 0-1-1H18a1 1 0 0 0-1 1v1a1 1 0 1 1-2 0v-1Z",
                fill: "#34353F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_331_73558",
                        x1: 35.51,
                        y1: 15.979,
                        x2: 20.422,
                        y2: 40.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F07EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF480"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_331_73558",
                        x1: 32.5,
                        y1: 27,
                        x2: 14.388,
                        y2: 10.085,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $dec12682ad8872b7$export$2e2bcd8739ae039 = $dec12682ad8872b7$var$SvgCase;




var $a0Ubj = parcelRequire("a0Ubj");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $4W0F0 = parcelRequire("4W0F0");



var $bSFEw = parcelRequire("bSFEw");



var $f0244063f985d8ef$export$6d59db4903f20f7d;
var $f0244063f985d8ef$export$6210fa4921d2a466;
var $f0244063f985d8ef$export$a75d1723e6bda2ec;
var $f0244063f985d8ef$export$bfd64c937657f93a;
var $f0244063f985d8ef$export$4a6dd88bada4e7d2;
var $f0244063f985d8ef$export$fb184b623420d9be;
var $f0244063f985d8ef$export$5c87d3bbeff1b3ef;
$f0244063f985d8ef$export$6d59db4903f20f7d = `k8ahaW_description`;
$f0244063f985d8ef$export$6210fa4921d2a466 = `k8ahaW_form`;
$f0244063f985d8ef$export$a75d1723e6bda2ec = `k8ahaW_option`;
$f0244063f985d8ef$export$bfd64c937657f93a = `k8ahaW_rotating`;
$f0244063f985d8ef$export$4a6dd88bada4e7d2 = `k8ahaW_shimmer`;
$f0244063f985d8ef$export$fb184b623420d9be = `k8ahaW_title`;
$f0244063f985d8ef$export$5c87d3bbeff1b3ef = `k8ahaW_titleSelector`;



var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $e3d695f33bf62c5f$var$SvgBuilding = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.166 6.667H13A.833.833 0 1 0 13 5h-.834a.833.833 0 0 0 0 1.667Zm0 3.333H13a.833.833 0 1 0 0-1.667h-.834a.833.833 0 0 0 0 1.667ZM8 6.667h.833a.833.833 0 0 0 0-1.667H8a.833.833 0 1 0 0 1.667ZM8 10h.833a.833.833 0 0 0 0-1.667H8A.833.833 0 1 0 8 10Zm10 6.667h-.834V2.5a.833.833 0 0 0-.833-.833H4.667a.833.833 0 0 0-.834.833v14.167H3a.833.833 0 1 0 0 1.666h15a.833.833 0 1 0 0-1.666Zm-6.667 0H9.666v-3.334h1.667v3.334Zm4.167 0H13V12.5a.834.834 0 0 0-.834-.833H8.833A.833.833 0 0 0 8 12.5v4.167H5.5V3.333h10v13.334Z",
            fill: "currentColor"
        })
    });
var $e3d695f33bf62c5f$export$2e2bcd8739ae039 = $e3d695f33bf62c5f$var$SvgBuilding;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $efce8b54607b57e7$var$SvgPizza = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M7.092 10.4a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666Zm0-3.733a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666ZM10 8.333a.833.833 0 0 0-.833.834V10a.833.833 0 1 0 1.666 0v-.833A.833.833 0 0 0 10 8.333Zm7.083-1.191a2.5 2.5 0 0 0-1.916-.242c-.333.089-.643.248-.909.467L4.592 1.775a.833.833 0 0 0-.834 0 .833.833 0 0 0-.425.725v10.975a2.45 2.45 0 0 0-1.666 2.358 2.5 2.5 0 0 0 2.433 2.5h.483a15.474 15.474 0 0 0 13.425-7.841 2.5 2.5 0 0 0-.916-3.35h-.009ZM5 3.942 13.242 8.7A10.476 10.476 0 0 1 5 13.333V3.942Zm11.558 5.733a13.817 13.817 0 0 1-12.391 6.992.834.834 0 0 1-.77-1.16.834.834 0 0 1 .186-.274.833.833 0 0 1 .584-.233h.425a12.085 12.085 0 0 0 10.516-6.142.75.75 0 0 1 .484-.366.833.833 0 0 1 .625.075.833.833 0 0 1 .35 1.108h-.009Z",
            fill: "currentColor"
        })
    });
var $efce8b54607b57e7$export$2e2bcd8739ae039 = $efce8b54607b57e7$var$SvgPizza;



const $a239fe6d5383c4e8$export$4c7a833ad93dd57c = [
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $efce8b54607b57e7$export$2e2bcd8739ae039), {}),
        title: "cloud.welcome.project_options.personal",
        value: (0, $49a3cd5201e05816$export$b6032183171af19f).Personal
    },
    {
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e3d695f33bf62c5f$export$2e2bcd8739ae039), {}),
        title: "cloud.welcome.project_options.company",
        value: (0, $49a3cd5201e05816$export$b6032183171af19f).Company
    }
];
const $a239fe6d5383c4e8$export$9a85657c2ffd2fed = [
    {
        title: "cloud.welcome.title_options.developer",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).Developer
    },
    {
        title: "cloud.welcome.title_options.team_lead",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).TeamLead
    },
    {
        title: "cloud.welcome.title_options.ceo",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).Ceo
    },
    {
        title: "cloud.welcome.title_options.cto",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).Cto
    },
    {
        title: "cloud.welcome.title_options.product",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).Product
    },
    {
        title: "cloud.welcome.title_options.others",
        value: (0, $49a3cd5201e05816$export$f99233281efd08a0).Others
    }
];
const $a239fe6d5383c4e8$export$12f749febba0dc9f = [
    {
        title: "cloud.welcome.company_options.size_1",
        value: (0, $49a3cd5201e05816$export$41cc48adf872ce3b).Scale1
    },
    {
        title: "cloud.welcome.company_options.size_2_49",
        value: (0, $49a3cd5201e05816$export$41cc48adf872ce3b).Scale2
    },
    {
        title: "cloud.welcome.company_options.size_50_199",
        value: (0, $49a3cd5201e05816$export$41cc48adf872ce3b).Scale3
    },
    {
        title: "cloud.welcome.company_options.size_200_999",
        value: (0, $49a3cd5201e05816$export$41cc48adf872ce3b).Scale4
    },
    {
        title: "cloud.welcome.company_options.size_1000_plus",
        value: (0, $49a3cd5201e05816$export$41cc48adf872ce3b).Scale5
    }
];
const $a239fe6d5383c4e8$export$860cf56670a3b63e = [
    {
        title: "cloud.welcome.reason_options.passwordless",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).Passwordless
    },
    {
        title: "cloud.welcome.reason_options.efficiency",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).Efficiency
    },
    {
        title: "cloud.welcome.reason_options.access_control",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).AccessControl
    },
    {
        title: "cloud.welcome.reason_options.multi_tenancy",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).MultiTenancy
    },
    {
        title: "cloud.welcome.reason_options.enterprise",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).Enterprise
    },
    {
        title: "cloud.welcome.reason_options.others",
        value: (0, $49a3cd5201e05816$export$fe867595c4640fb1).Others
    }
];


function $04eb01583cbd2b2b$var$Welcome() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { data: { questionnaire: questionnaire }, update: update } = (0, $abb531754ca753b0$export$2e2bcd8739ae039)();
    const { control: control, register: register, handleSubmit: handleSubmit, reset: reset, watch: watch } = (0, $c3LX9.useForm)({
        mode: "onChange"
    });
    (0, $eCoWV.useEffect)(()=>{
        reset(questionnaire);
    }, [
        questionnaire,
        reset
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        await update({
            questionnaire: formData
        });
    }));
    const onNext = async ()=>{
        await onSubmit();
        navigate((0, $9d023628a9c0fa6c$export$75332796271f8048)((0, $49a3cd5201e05816$export$1572a1adf9290869).SignInExperience));
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $907d9471e8250569$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "cloud.welcome.page_title",
                    "cloud.general.onboarding"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $907d9471e8250569$export$8f981dffec84ba52,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $907d9471e8250569$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dec12682ad8872b7$export$2e2bcd8739ae039), {}),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $f0244063f985d8ef$export$fb184b623420d9be,
                            children: t("cloud.welcome.title")
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $f0244063f985d8ef$export$6d59db4903f20f7d,
                            children: t("cloud.welcome.description")
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                            className: $f0244063f985d8ef$export$6210fa4921d2a466,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    title: "cloud.welcome.project_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        control: control,
                                        name: "project",
                                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $3b942cfeaf20c383$export$2e2bcd8739ae039), {
                                                name: name,
                                                value: value ?? "",
                                                options: (0, $a239fe6d5383c4e8$export$4c7a833ad93dd57c),
                                                onChange: onChange
                                            })
                                    })
                                }),
                                watch("project") === (0, $49a3cd5201e05816$export$b6032183171af19f).Company && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                            isMultiple: true,
                                            title: "cloud.welcome.title_field",
                                            headlineSpacing: "large",
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                                control: control,
                                                name: "titles",
                                                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $e8aabd15df5eaa5d$export$2e2bcd8739ae039), {
                                                        className: $f0244063f985d8ef$export$5c87d3bbeff1b3ef,
                                                        optionClassName: $f0244063f985d8ef$export$a75d1723e6bda2ec,
                                                        value: value ?? [],
                                                        options: (0, $a239fe6d5383c4e8$export$9a85657c2ffd2fed),
                                                        onChange: (value)=>{
                                                            onChange(value.length === 0 ? undefined : value);
                                                        }
                                                    })
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                            title: "cloud.welcome.company_name_field",
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                                placeholder: t("cloud.welcome.company_name_placeholder"),
                                                ...register("companyName")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                            title: "cloud.welcome.company_size_field",
                                            headlineSpacing: "large",
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                                control: control,
                                                name: "companySize",
                                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $3b942cfeaf20c383$export$2e2bcd8739ae039), {
                                                        name: name,
                                                        value: value ?? "",
                                                        options: (0, $a239fe6d5383c4e8$export$12f749febba0dc9f),
                                                        optionClassName: $f0244063f985d8ef$export$a75d1723e6bda2ec,
                                                        onChange: (value)=>{
                                                            onChange((0, $5CQIb.conditional)(value && value));
                                                        }
                                                    })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                    isMultiple: true,
                                    title: "cloud.welcome.reason_field",
                                    headlineSpacing: "large",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        control: control,
                                        name: "reasons",
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $e8aabd15df5eaa5d$export$2e2bcd8739ae039), {
                                                value: value ?? [],
                                                options: (0, $a239fe6d5383c4e8$export$860cf56670a3b63e),
                                                onChange: (value)=>{
                                                    onChange(value.length === 0 ? undefined : value);
                                                }
                                            })
                                    })
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 1,
                totalSteps: 2,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "general.next",
                    type: "primary",
                    onClick: onNext
                })
            })
        ]
    });
}
var $04eb01583cbd2b2b$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($04eb01583cbd2b2b$var$Welcome);




const $96b2ff4afcb4ae6e$var$welcomePathname = (0, $9d023628a9c0fa6c$export$75332796271f8048)((0, $49a3cd5201e05816$export$1572a1adf9290869).Welcome);
function $96b2ff4afcb4ae6e$var$Layout() {
    const swrOptions = (0, $451ef8ec75a8d7c6$export$2e2bcd8739ae039)();
    const { setThemeOverride: setThemeOverride } = (0, $eCoWV.useContext)((0, $1iAqo.AppThemeContext));
    const { match: match, getTo: getTo } = (0, $4W0F0.default)();
    (0, $eCoWV.useEffect)(()=>{
        setThemeOverride((0, $bhvxB.Theme).Light);
        return ()=>{
            setThemeOverride(undefined);
        };
    }, [
        setThemeOverride
    ]);
    const { data: { questionnaire: questionnaire } } = (0, $abb531754ca753b0$export$2e2bcd8739ae039)();
    // Redirect to the welcome page if the user has not started the onboarding process.
    if (!questionnaire && !match($96b2ff4afcb4ae6e$var$welcomePathname)) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
        replace: true,
        to: getTo($96b2ff4afcb4ae6e$var$welcomePathname)
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iuOAe.default), {
                component: (0, $dusqy.Component).Console,
                event: (0, $dusqy.ConsoleEvent).Onboard
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $b9701761636dc06f$export$729c8b7179294ba,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2mi28.SWRConfig), {
                    value: swrOptions,
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $82e95263df22bc9e$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5fb1a9eb989bb9ff$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $600b624765f10fdd$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {})
                        ]
                    })
                })
            })
        ]
    });
}
function $96b2ff4afcb4ae6e$export$bd7ec0980162456() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Routes), {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
            path: "/:tenantId",
            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a56066727231a650$export$2e2bcd8739ae039), {}),
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5f3e0712aacdcb31$export$2e2bcd8739ae039), {}),
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                    element: /*#__PURE__*/ (0, $9zeGj.jsx)($96b2ff4afcb4ae6e$var$Layout, {}),
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                replace: true,
                                to: (0, $49a3cd5201e05816$export$329ee42b27a3306e).Onboarding
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                            path: (0, $49a3cd5201e05816$export$329ee42b27a3306e).Onboarding,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $903feabdde16c495$export$2e2bcd8739ae039), {}),
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                        replace: true,
                                        to: (0, $49a3cd5201e05816$export$1572a1adf9290869).Welcome
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                    path: (0, $49a3cd5201e05816$export$1572a1adf9290869).Welcome,
                                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $04eb01583cbd2b2b$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                    path: (0, $49a3cd5201e05816$export$1572a1adf9290869).SignInExperience,
                                    element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8d05f9f7af3a4336$export$2e2bcd8739ae039), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: "*",
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $djktV.default), {})
                        })
                    ]
                })
            })
        })
    });
}




var $9zeGj = parcelRequire("9zeGj");

var $dusqy = parcelRequire("dusqy");
parcelRequire("jZDWq");
var $iuOAe = parcelRequire("iuOAe");
parcelRequire("j6dBR");
var $ceK0K = parcelRequire("ceK0K");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");

var $V1X8c = parcelRequire("V1X8c");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");



var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $gbU1S = parcelRequire("gbU1S");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $d0Zvy = parcelRequire("d0Zvy");

var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $8pPfi = parcelRequire("8pPfi");
var $7537c10f4f456ec4$export$2e2bcd8739ae039 = $7537c10f4f456ec4$var$kebabCase;
/*
  kebabCase('the quick brown fox'); // 'the-quick-brown-fox'
  kebabCase('the-quick-brown-fox'); // 'the-quick-brown-fox'
  kebabCase('the_quick_brown_fox'); // 'the-quick-brown-fox'
  kebabCase('theQuickBrownFox'); // 'the-quick-brown-fox'
  kebabCase('theQuickBrown Fox'); // 'the-quick-brown-fox'
  kebabCase('thequickbrownfox'); // 'thequickbrownfox'
  kebabCase('the - quick * brown# fox'); // 'the-quick-brown-fox'
  kebabCase('theQUICKBrownFox'); // 'the-quick-brown-fox'
*/ // any combination of spaces and punctuation characters
// thanks to http://stackoverflow.com/a/25575009
var $7537c10f4f456ec4$var$wordSeparators = /[\s\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,\-.\/:;<=>?@\[\]^_`{|}~]+/;
var $7537c10f4f456ec4$var$capital_plus_lower = /[A-ZÀ-Ý\u00C0-\u00D6\u00D9-\u00DD][a-zà-ÿ]/g;
var $7537c10f4f456ec4$var$capitals = /[A-ZÀ-Ý\u00C0-\u00D6\u00D9-\u00DD]+/g;
function $7537c10f4f456ec4$var$kebabCase(str) {
    // replace word starts with space + lower case equivalent for later parsing
    // 1) treat cap + lower as start of new word
    str = str.replace($7537c10f4f456ec4$var$capital_plus_lower, function(match) {
        // match is one caps followed by one non-cap
        return " " + (match[0].toLowerCase() || match[0]) + match[1];
    });
    // 2) treat all remaining capitals as words
    str = str.replace($7537c10f4f456ec4$var$capitals, function(match) {
        // match is a series of caps
        return " " + match.toLowerCase();
    });
    return str.trim().split($7537c10f4f456ec4$var$wordSeparators).join("-").replace(/^-/, "").replace(/-\s*$/, "");
}


const $6e9dc250db2f6ebf$export$2aa3fd96c49a84a8 = (title)=>(0, $7537c10f4f456ec4$export$2e2bcd8739ae039)(title);


var $bac8d7e296e00796$export$89da14300d534261;
var $bac8d7e296e00796$export$1ca1ec8b29a4ce27;
var $bac8d7e296e00796$export$bfd64c937657f93a;
var $bac8d7e296e00796$export$120ff0929b202a6d;
var $bac8d7e296e00796$export$4a6dd88bada4e7d2;
var $bac8d7e296e00796$export$fb184b623420d9be;
$bac8d7e296e00796$export$89da14300d534261 = `SoD9uq_active`;
$bac8d7e296e00796$export$1ca1ec8b29a4ce27 = `SoD9uq_icon`;
$bac8d7e296e00796$export$bfd64c937657f93a = `SoD9uq_rotating`;
$bac8d7e296e00796$export$120ff0929b202a6d = `SoD9uq_row`;
$bac8d7e296e00796$export$4a6dd88bada4e7d2 = `SoD9uq_shimmer`;
$bac8d7e296e00796$export$fb184b623420d9be = `SoD9uq_title`;


function $332b9b34693e2dbb$var$Item({ icon: icon, titleKey: titleKey, modal: modal, externalLink: externalLink, isActive: isActive = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.tabs"
    });
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    const content = (0, $eCoWV.useMemo)(()=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                icon && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $bac8d7e296e00796$export$1ca1ec8b29a4ce27,
                    children: icon
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $bac8d7e296e00796$export$fb184b623420d9be,
                    children: t(titleKey)
                })
            ]
        }), [
        icon,
        t,
        titleKey
    ]);
    if (modal) return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("button", {
                className: $bac8d7e296e00796$export$120ff0929b202a6d,
                onClick: ()=>{
                    setIsOpen(true);
                },
                children: content
            }),
            modal(isOpen, ()=>{
                setIsOpen(false);
            })
        ]
    });
    if (externalLink) return /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
        href: externalLink,
        target: "_blank",
        className: $bac8d7e296e00796$export$120ff0929b202a6d,
        rel: "noopener",
        children: content
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
        to: (0, $6e9dc250db2f6ebf$export$2aa3fd96c49a84a8)(titleKey),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($bac8d7e296e00796$export$120ff0929b202a6d, isActive && $bac8d7e296e00796$export$89da14300d534261),
        children: content
    });
}
var $332b9b34693e2dbb$export$2e2bcd8739ae039 = $332b9b34693e2dbb$var$Item;



var $9zeGj = parcelRequire("9zeGj");
var $d436a3417096a36a$export$bfd64c937657f93a;
var $d436a3417096a36a$export$4a6dd88bada4e7d2;
var $d436a3417096a36a$export$fb184b623420d9be;
$d436a3417096a36a$export$bfd64c937657f93a = `s9DuQG_rotating`;
$d436a3417096a36a$export$4a6dd88bada4e7d2 = `s9DuQG_shimmer`;
$d436a3417096a36a$export$fb184b623420d9be = `s9DuQG_title`;


function $cb3afc4250336202$var$Section({ children: children, title: title }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d436a3417096a36a$export$fb184b623420d9be,
                children: title
            }),
            children
        ]
    });
}
var $cb3afc4250336202$export$2e2bcd8739ae039 = $cb3afc4250336202$var$Section;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $e903a356f92d5157$var$SvgBarGraph = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12 6a1 1 0 0 0-1 1v10a1 1 0 0 0 2 0V7a1 1 0 0 0-1-1Zm-5 6a1 1 0 0 0-1 1v4a1 1 0 1 0 2 0v-4a1 1 0 0 0-1-1Zm10-2a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1Zm2-8H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3Zm1 17a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v14Z",
            fill: "currentColor"
        })
    });
var $e903a356f92d5157$export$2e2bcd8739ae039 = $e903a356f92d5157$var$SvgBarGraph;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ba3e2c30123cf00a$var$SvgBolt = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M19.89 9.55A1 1 0 0 0 19 9h-5V3a1 1 0 0 0-1.309-1.002 1 1 0 0 0-.501.362l-8 11a1 1 0 0 0-.08 1A1 1 0 0 0 5 15h5v6a1 1 0 0 0 1.81.59l8-11a1 1 0 0 0 .08-1.04ZM12 17.92V14a1 1 0 0 0-1-1H7l5-6.92V10a1 1 0 0 0 1 1h4l-5 6.92Z",
            fill: "currentColor"
        })
    });
var $ba3e2c30123cf00a$export$2e2bcd8739ae039 = $ba3e2c30123cf00a$var$SvgBolt;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $ab23478e4bd44acc$var$SvgBox = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M20.47 7.37v-.08l-.06-.15a.712.712 0 0 0-.07-.09.93.93 0 0 0-.09-.12l-.09-.07-.16-.08-7.5-4.63a1 1 0 0 0-1.06 0L4 6.78l-.09.08-.09.07a.94.94 0 0 0-.09.12.71.71 0 0 0-.07.09l-.06.15v.08a1.15 1.15 0 0 0 0 .26v8.74a1 1 0 0 0 .47.85l7.5 4.63a.466.466 0 0 0 .15.06h.08a.86.86 0 0 0 .52 0h.08a.465.465 0 0 0 .15-.06L20 17.22a1 1 0 0 0 .47-.85V7.63c.01-.086.01-.174 0-.26ZM11 19.21l-5.5-3.4V9.43l5.5 3.39v6.39Zm1-8.12L6.4 7.63 12 4.18l5.6 3.45-5.6 3.46Zm6.5 4.72-5.5 3.4v-6.39l5.5-3.39v6.38Z",
            fill: "currentColor"
        })
    });
var $ab23478e4bd44acc$export$2e2bcd8739ae039 = $ab23478e4bd44acc$var$SvgBox;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $996314d699bbdee2$var$SvgConnection = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M20.52 3.87a5 5 0 0 0-9.08.13H7a3 3 0 0 0-3 3v4a1 1 0 1 0 2 0V7a1 1 0 0 1 1-1h2.78A3 3 0 0 0 9 8a3 3 0 0 0 3 3h7.33a3.66 3.66 0 0 0 1.19-7.13ZM19.33 9H12a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 21 7.33 1.67 1.67 0 0 1 19.33 9ZM19 13a1 1 0 0 0-1 1v3a1 1 0 0 1-1 1h-2.26a3.662 3.662 0 0 0-2.22-2.13 5 5 0 0 0-9.45 1.28A3 3 0 0 0 4 23h7.33a3.66 3.66 0 0 0 3.6-3H17a3 3 0 0 0 3-3v-3a1 1 0 0 0-1-1Zm-7.67 8H4a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.67A1.65 1.65 0 0 1 13 19.33 1.67 1.67 0 0 1 11.33 21Z",
            fill: "currentColor"
        })
    });
var $996314d699bbdee2$export$2e2bcd8739ae039 = $996314d699bbdee2$var$SvgConnection;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $23e331438f6482bd$var$SvgGear = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m17.767 7.958-1.575-.525.741-1.483a.834.834 0 0 0-.158-.95L15 3.225a.834.834 0 0 0-.958-.158l-1.484.741-.525-1.575a.833.833 0 0 0-.783-.566h-2.5a.833.833 0 0 0-.792.566l-.525 1.575-1.483-.741a.833.833 0 0 0-.95.158L3.225 5a.833.833 0 0 0-.158.958l.741 1.484-1.575.525a.833.833 0 0 0-.566.783v2.5a.834.834 0 0 0 .566.792l1.575.525-.741 1.483a.833.833 0 0 0 .158.95L5 16.775a.834.834 0 0 0 .958.158l1.484-.741.525 1.575a.834.834 0 0 0 .791.566h2.5a.834.834 0 0 0 .792-.566l.525-1.575 1.483.741a.833.833 0 0 0 .942-.158L16.775 15a.834.834 0 0 0 .158-.958l-.741-1.484 1.575-.525a.834.834 0 0 0 .566-.783v-2.5a.833.833 0 0 0-.566-.792Zm-1.1 2.692-1 .333a1.666 1.666 0 0 0-.967 2.35l.475.95-.917.917-.925-.5a1.667 1.667 0 0 0-2.325.967l-.333 1H9.35l-.333-1a1.667 1.667 0 0 0-2.35-.967l-.95.475-.917-.917.5-.925a1.667 1.667 0 0 0-.967-2.35l-1-.333v-1.3l1-.333a1.667 1.667 0 0 0 .967-2.35l-.475-.925.917-.917.925.475a1.667 1.667 0 0 0 2.35-.967l.333-1h1.3l.333 1a1.666 1.666 0 0 0 2.35.967l.95-.475.917.917-.5.925a1.666 1.666 0 0 0 .967 2.325l1 .333v1.325ZM10 6.667a3.333 3.333 0 1 0 0 6.666 3.333 3.333 0 0 0 0-6.666Zm0 5a1.666 1.666 0 1 1 0-3.333 1.666 1.666 0 0 1 0 3.333Z",
            fill: "currentColor"
        })
    });
var $23e331438f6482bd$export$2e2bcd8739ae039 = $23e331438f6482bd$var$SvgGear;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $74e0b072057b5446$var$SvgHook = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M12.549 6.149a.839.839 0 0 0 1.676-.064A4.214 4.214 0 1 0 7.222 9.4l-2.146 3.716a.839.839 0 1 0 1.452.839l2.524-4.371a.839.839 0 0 0-.307-1.146 2.537 2.537 0 1 1 3.804-2.29Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.81 16.354a.839.839 0 0 1 1.133-.35 2.537 2.537 0 1 0-.082-4.44.839.839 0 0 1-1.145-.307l-2.523-4.37a.839.839 0 0 1 1.452-.84l2.146 3.718a4.215 4.215 0 0 1 3.446 7.645 4.211 4.211 0 0 1-4.076.077.839.839 0 0 1-.35-1.133Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M4.795 10.456a.839.839 0 0 1-.263 1.156 2.537 2.537 0 1 0 3.886 2.149c0-.463.375-.838.838-.838h5.047a.838.838 0 1 1 0 1.677h-4.292a4.215 4.215 0 0 1-8.344-.839c0-1.504.789-2.823 1.971-3.568a.839.839 0 0 1 1.157.263Z",
                fill: "currentColor"
            })
        ]
    });
var $74e0b072057b5446$export$2e2bcd8739ae039 = $74e0b072057b5446$var$SvgHook;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f94c29e6f471f649$var$SvgList = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M7.5 8h14c.6 0 1-.4 1-1s-.4-1-1-1h-14c-.6 0-1 .4-1 1s.4 1 1 1Zm14 3h-10c-.6 0-1 .4-1 1s.4 1 1 1h10c.6 0 1-.4 1-1s-.4-1-1-1Zm0 5h-6c-.6 0-1 .4-1 1s.4 1 1 1h6c.6 0 1-.4 1-1s-.4-1-1-1ZM3.5 6c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Zm4 5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Zm4 5c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1Z",
            fill: "currentColor"
        })
    });
var $f94c29e6f471f649$export$2e2bcd8739ae039 = $f94c29e6f471f649$var$SvgList;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $2d35c5575fb3d494$var$SvgOrganization = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M8.333 3.333v3.333h3.334V3.333H8.333ZM7.5 1.666a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h1.667v.833H5.833c-.92 0-1.666.747-1.666 1.667v.833H2.5a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834H5.833v-.833h8.334v.833H12.5a.833.833 0 0 0-.833.834v5c0 .46.373.833.833.833h5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.834h-1.667v-.833c0-.92-.746-1.667-1.666-1.667h-3.334v-.833H12.5c.46 0 .833-.373.833-.833v-5a.833.833 0 0 0-.833-.833h-5ZM3.333 13.334v3.333h3.334v-3.333H3.333Zm10 3.333v-3.333h3.334v3.333h-3.334Z",
            fill: "currentColor"
        })
    });
var $2d35c5575fb3d494$export$2e2bcd8739ae039 = $2d35c5575fb3d494$var$SvgOrganization;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $cbfc082f5cf131f3$var$SvgResource = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M22.5 14.5a2 2 0 0 0-2-2h-6a2 2 0 0 0-2 2h-3v-3h2.33A3.66 3.66 0 0 0 13 4.37a5 5 0 0 0-9.43 1.28 3 3 0 0 0 .93 5.85h3v8a1 1 0 0 0 1 1h4a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-2a2.001 2.001 0 0 0-.28-1c.18-.303.276-.648.28-1v-2Zm-18-5a1 1 0 1 1 0-2 1 1 0 0 0 1-1 3 3 0 0 1 5.84-1 1 1 0 0 0 .78.66 1.65 1.65 0 0 1 1.38 1.67 1.67 1.67 0 0 1-1.67 1.67H4.5Zm8 9h-3v-2h3a2 2 0 0 0 .28 1 2 2 0 0 0-.28 1Zm2 2v-2h6v2h-6Zm0-4v-2h6v2h-6Z",
            fill: "currentColor"
        })
    });
var $cbfc082f5cf131f3$export$2e2bcd8739ae039 = $cbfc082f5cf131f3$var$SvgResource;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $623c9a84069ddbd8$var$SvgRole = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.342 10.233c.527-.566.824-1.309.833-2.083a3.15 3.15 0 0 0-6.3 0c.009.774.306 1.517.833 2.083A4.95 4.95 0 0 0 5 14.075a.838.838 0 0 0 1.667.183 3.333 3.333 0 0 1 6.616 0 .833.833 0 0 0 .884.742h.091a.833.833 0 0 0 .734-.917 4.95 4.95 0 0 0-2.65-3.85ZM10 9.633a1.483 1.483 0 1 1 0-2.966 1.483 1.483 0 0 1 0 2.966Zm5.833-7.966H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h11.666a2.5 2.5 0 0 0 2.5-2.5V4.167a2.5 2.5 0 0 0-2.5-2.5Zm.834 14.166a.833.833 0 0 1-.834.834H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h11.666a.833.833 0 0 1 .834.834v11.666Z",
            fill: "currentColor"
        })
    });
var $623c9a84069ddbd8$export$2e2bcd8739ae039 = $623c9a84069ddbd8$var$SvgRole;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $efb57e0b2a4d79da$var$SvgSecurityLock = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 10.833a1.242 1.242 0 0 0-.833 2.175v1.159a.833.833 0 0 0 1.666 0v-1.159A1.241 1.241 0 0 0 10 10.833ZM14.167 7.5V5.833a4.167 4.167 0 1 0-8.334 0V7.5a2.5 2.5 0 0 0-2.5 2.5v5.833a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V10a2.5 2.5 0 0 0-2.5-2.5ZM7.5 5.833a2.5 2.5 0 1 1 5 0V7.5h-5V5.833Zm7.5 10a.833.833 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V10a.833.833 0 0 1 .833-.833h8.334A.833.833 0 0 1 15 10v5.833Z",
            fill: "currentColor"
        })
    });
var $efb57e0b2a4d79da$export$2e2bcd8739ae039 = $efb57e0b2a4d79da$var$SvgSecurityLock;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $aa8bdcbe956a64b7$var$SvgSingleSignOn = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12.849 3.659a5.833 5.833 0 0 1 2.501 2.764 4.167 4.167 0 0 1 2.984 3.983 4.166 4.166 0 0 1-2.075 3.608.836.836 0 1 1-.834-1.45 2.5 2.5 0 0 0-.833-4.608.833.833 0 0 1-.65-.558 4.167 4.167 0 0 0-8.108 1.341.833.833 0 0 1-.834.834 1.667 1.667 0 0 0-1.666 1.666 1.667 1.667 0 0 0 1.1 1.517.844.844 0 0 1-.267 1.667.942.942 0 0 1-.267-.042 3.333 3.333 0 0 1 .317-6.383 5.833 5.833 0 0 1 8.632-4.339Zm1.49 6.503a.833.833 0 1 0-1.178-1.179l-3.482 3.482a2.5 2.5 0 1 0 1.03 1.327l2-2 .452.453a.833.833 0 1 0 1.178-1.179l-.452-.452.452-.453Zm-5.172 4.41a.833.833 0 1 1-1.667 0 .833.833 0 0 1 1.667 0Z",
            fill: "currentColor"
        })
    });
var $aa8bdcbe956a64b7$export$2e2bcd8739ae039 = $aa8bdcbe956a64b7$var$SvgSingleSignOn;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1ab214f5e7f74d00$var$SvgWeb = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2ZM6 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 0a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm6-4H4a3 3 0 0 0-3 3v16a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V4a3 3 0 0 0-3-3Zm1 19a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-9h18v9Zm0-11H3V4a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v5Z",
            fill: "currentColor"
        })
    });
var $1ab214f5e7f74d00$export$2e2bcd8739ae039 = $1ab214f5e7f74d00$var$SvgWeb;



var $V1X8c = parcelRequire("V1X8c");

const $b249338b106e658c$var$findFirstItem = (sections)=>{
    for (const section of sections){
        const found = section.items.find((item)=>!item.isHidden);
        if (found) return found;
    }
};
const $b249338b106e658c$export$74c84f4d9513e4e1 = ()=>{
    const { data: { getStartedHidden: getStartedHidden } } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const allSections = [
        {
            title: "overview",
            items: [
                {
                    Icon: (0, $ba3e2c30123cf00a$export$2e2bcd8739ae039),
                    title: "get_started",
                    isHidden: getStartedHidden
                },
                {
                    Icon: (0, $e903a356f92d5157$export$2e2bcd8739ae039),
                    title: "dashboard"
                }
            ]
        },
        {
            title: "resources",
            items: [
                {
                    Icon: (0, $ab23478e4bd44acc$export$2e2bcd8739ae039),
                    title: "applications"
                },
                {
                    Icon: (0, $cbfc082f5cf131f3$export$2e2bcd8739ae039),
                    title: "api_resources"
                },
                {
                    Icon: (0, $1ab214f5e7f74d00$export$2e2bcd8739ae039),
                    title: "sign_in_experience"
                },
                {
                    Icon: (0, $efb57e0b2a4d79da$export$2e2bcd8739ae039),
                    title: "mfa"
                },
                {
                    Icon: (0, $996314d699bbdee2$export$2e2bcd8739ae039),
                    title: "connectors"
                },
                {
                    Icon: (0, $aa8bdcbe956a64b7$export$2e2bcd8739ae039),
                    title: "enterprise_sso"
                }
            ]
        },
        {
            title: "users",
            items: [
                {
                    Icon: (0, $2d35c5575fb3d494$export$2e2bcd8739ae039),
                    title: "organizations"
                },
                {
                    Icon: (0, $06aaa25160e82e50$export$2e2bcd8739ae039),
                    title: "users"
                },
                {
                    Icon: (0, $f94c29e6f471f649$export$2e2bcd8739ae039),
                    title: "audit_logs"
                },
                {
                    Icon: (0, $623c9a84069ddbd8$export$2e2bcd8739ae039),
                    title: "roles"
                }
            ]
        },
        {
            title: "automation",
            items: [
                {
                    Icon: (0, $74e0b072057b5446$export$2e2bcd8739ae039),
                    title: "webhooks"
                }
            ]
        },
        {
            title: "tenant",
            isHidden: !(0, $V1X8c.isCloud),
            items: [
                {
                    Icon: (0, $23e331438f6482bd$export$2e2bcd8739ae039),
                    title: "tenant_settings"
                }
            ]
        }
    ];
    const enabledSections = allSections.filter((section)=>!section.isHidden);
    return {
        sections: enabledSections,
        firstItem: $b249338b106e658c$var$findFirstItem(enabledSections)
    };
};


var $1c4f03e87ef5a138$export$bfd64c937657f93a;
var $1c4f03e87ef5a138$export$4a6dd88bada4e7d2;
var $1c4f03e87ef5a138$export$6fbb9cd2843e91b2;
var $1c4f03e87ef5a138$export$8cc075c801fd6817;
$1c4f03e87ef5a138$export$bfd64c937657f93a = `_3ZtC7q_rotating`;
$1c4f03e87ef5a138$export$4a6dd88bada4e7d2 = `_3ZtC7q_shimmer`;
$1c4f03e87ef5a138$export$6fbb9cd2843e91b2 = `_3ZtC7q_sidebar`;
$1c4f03e87ef5a138$export$8cc075c801fd6817 = `_3ZtC7q_spacer`;



function $fb92937fea49e5ea$var$Sidebar() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.tab_sections"
    });
    const { sections: sections } = (0, $b249338b106e658c$export$74c84f4d9513e4e1)();
    const { match: match } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
        className: $1c4f03e87ef5a138$export$6fbb9cd2843e91b2,
        children: sections.map(({ title: title, items: items })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cb3afc4250336202$export$2e2bcd8739ae039), {
                title: t(title),
                children: items.map(({ title: title, Icon: Icon, isHidden: isHidden, modal: modal, externalLink: externalLink })=>!isHidden && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $332b9b34693e2dbb$export$2e2bcd8739ae039), {
                        titleKey: title,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {}),
                        isActive: match("/" + (0, $6e9dc250db2f6ebf$export$2aa3fd96c49a84a8)(title)),
                        modal: modal,
                        externalLink: externalLink
                    }, title))
            }, title))
    });
}
var $fb92937fea49e5ea$export$2e2bcd8739ae039 = $fb92937fea49e5ea$var$Sidebar;




var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $bNFMZ = parcelRequire("bNFMZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $f7a72d648430e6c6$export$34e0f9847d4c02dd;
var $f7a72d648430e6c6$export$e8fe8d4c8a88a102;
var $f7a72d648430e6c6$export$e96ebd20767e3616;
var $f7a72d648430e6c6$export$bfd64c937657f93a;
var $f7a72d648430e6c6$export$4a6dd88bada4e7d2;
var $f7a72d648430e6c6$export$bc302bd3f1a12a2c;
var $f7a72d648430e6c6$export$ef89c04d7f7888be;
var $f7a72d648430e6c6$export$11455a9e44d7c809;
$f7a72d648430e6c6$export$34e0f9847d4c02dd = `fkLd0a_container`;
$f7a72d648430e6c6$export$e8fe8d4c8a88a102 = `fkLd0a_overuse`;
$f7a72d648430e6c6$export$e96ebd20767e3616 = `fkLd0a_planCycle`;
$f7a72d648430e6c6$export$bfd64c937657f93a = `fkLd0a_rotating`;
$f7a72d648430e6c6$export$4a6dd88bada4e7d2 = `fkLd0a_shimmer`;
$f7a72d648430e6c6$export$bc302bd3f1a12a2c = `fkLd0a_usage`;
$f7a72d648430e6c6$export$ef89c04d7f7888be = `fkLd0a_usageBar`;
$f7a72d648430e6c6$export$11455a9e44d7c809 = `fkLd0a_usageBarInner`;


function $78c662d3245f7468$var$PlanUsage({ subscriptionUsage: subscriptionUsage, currentSubscription: currentSubscription, currentPlan: currentPlan }) {
    const { currentPeriodStart: currentPeriodStart, currentPeriodEnd: currentPeriodEnd } = currentSubscription;
    const { activeUsers: activeUsers } = subscriptionUsage;
    const { quota: { mauLimit: mauLimit } } = currentPlan;
    const usagePercent = (0, $5CQIb.conditional)(mauLimit && activeUsers / mauLimit);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $f7a72d648430e6c6$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $f7a72d648430e6c6$export$bc302bd3f1a12a2c,
                children: [
                    `${activeUsers} / `,
                    mauLimit === null ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "subscription.quota_table.unlimited"
                    }) : mauLimit.toLocaleString(),
                    " MAU",
                    usagePercent && ` (${(usagePercent * 100).toFixed(2)}%)`
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f7a72d648430e6c6$export$e96ebd20767e3616,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "subscription.plan_cycle",
                    interpolation: {
                        period: (0, $f11d0f720bf4029b$export$b971ca6f7de66f44)({
                            periodStart: currentPeriodStart,
                            periodEnd: currentPeriodEnd
                        }),
                        renewDate: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))(currentPeriodEnd).add(1, "day").format("MMM D, YYYY")
                    }
                })
            }),
            usagePercent && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f7a72d648430e6c6$export$ef89c04d7f7888be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f7a72d648430e6c6$export$11455a9e44d7c809, usagePercent >= 1 && $f7a72d648430e6c6$export$e8fe8d4c8a88a102),
                    style: {
                        width: `${Math.min(usagePercent, 1) * 100}%`
                    }
                })
            })
        ]
    });
}
var $78c662d3245f7468$export$2e2bcd8739ae039 = $78c662d3245f7468$var$PlanUsage;


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");
parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");
const $f5861ec06c49db25$export$6d940d0d58a60bc4 = `/tenant-settings/${(0, $emGEN.TenantSettingsTabs).Subscription}`;



var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");

var $bNHoO = parcelRequire("bNHoO");


var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");

var $29587aad088ca553$export$9126ebe212f3bdac;
$29587aad088ca553$export$9126ebe212f3bdac = `kupZfW_linkButton`;


function $f445888e2d1c5135$var$MauExceededModal() {
    const { currentTenant: currentTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { usage: usage, subscription: subscription } = currentTenant ?? {};
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [hasClosed, setHasClosed] = (0, $eCoWV.useState)(false);
    const handleCloseModal = ()=>{
        setHasClosed(true);
    };
    const { data: subscriptionPlans } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const currentPlan = subscriptionPlans?.find((plan)=>plan.id === subscription?.planId);
    if (!subscription || !usage || !currentPlan || hasClosed) return null;
    const { quota: { mauLimit: mauLimit }, name: planName } = currentPlan;
    const isMauExceeded = mauLimit !== null && usage.activeUsers >= mauLimit;
    if (!isMauExceeded) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: handleCloseModal,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: "upsell.mau_exceeded_modal.title",
            footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                        href: (0, $o53Y2.contactEmailLink),
                        className: $29587aad088ca553$export$9126ebe212f3bdac,
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "general.contact_us_action"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: "primary",
                        title: "upsell.upgrade_plan",
                        onClick: ()=>{
                            navigate((0, $f5861ec06c49db25$export$6d940d0d58a60bc4));
                            handleCloseModal();
                        }
                    })
                ]
            }),
            onClose: handleCloseModal,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                    severity: "error",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                                name: planName
                            })
                        },
                        children: t("upsell.mau_exceeded_modal.notification")
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "subscription.plan_usage",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $78c662d3245f7468$export$2e2bcd8739ae039), {
                        subscriptionUsage: usage,
                        currentSubscription: subscription,
                        currentPlan: currentPlan
                    })
                })
            ]
        })
    });
}
var $f445888e2d1c5135$export$2e2bcd8739ae039 = $f445888e2d1c5135$var$MauExceededModal;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");
parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");

var $bNHoO = parcelRequire("bNHoO");


var $7iZsu = parcelRequire("7iZsu");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $ds4Cq = parcelRequire("ds4Cq");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");

var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");

var $b40128e47af14324$export$c7f35b042535c54c;
var $b40128e47af14324$export$41d105e05873013c;
var $b40128e47af14324$export$34e0f9847d4c02dd;
var $b40128e47af14324$export$6d59db4903f20f7d;
var $b40128e47af14324$export$321c0b1a406de31f;
var $b40128e47af14324$export$bfd64c937657f93a;
var $b40128e47af14324$export$4a6dd88bada4e7d2;
$b40128e47af14324$export$c7f35b042535c54c = `BcZZjq_articleLink`;
$b40128e47af14324$export$41d105e05873013c = `BcZZjq_billInfo`;
$b40128e47af14324$export$34e0f9847d4c02dd = `BcZZjq_container`;
$b40128e47af14324$export$6d59db4903f20f7d = `BcZZjq_description`;
$b40128e47af14324$export$321c0b1a406de31f = `BcZZjq_price`;
$b40128e47af14324$export$bfd64c937657f93a = `BcZZjq_rotating`;
$b40128e47af14324$export$4a6dd88bada4e7d2 = `BcZZjq_shimmer`;


function $b84aac1cf1606946$var$BillInfo({ cost: cost, isManagePaymentVisible: isManagePaymentVisible }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $b40128e47af14324$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $b40128e47af14324$export$41d105e05873013c,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $b40128e47af14324$export$321c0b1a406de31f,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: `$${(cost / 100).toLocaleString()}`
                            }),
                            cost > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                                content: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "subscription.next_bill_tip"
                                }),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    size: "small",
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $b40128e47af14324$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                    className: $b40128e47af14324$export$c7f35b042535c54c,
                                    href: "https://blog.logto.io/logto-pricing-model",
                                    targetBlank: "noopener"
                                })
                            },
                            children: t("subscription.next_bill_hint")
                        })
                    })
                ]
            }),
            isManagePaymentVisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: "subscription.manage_payment",
                isLoading: isLoading,
                onClick: async ()=>{
                    setIsLoading(true);
                    await visitManagePaymentPage(currentTenantId);
                    setIsLoading(false);
                }
            })
        ]
    });
}
var $b84aac1cf1606946$export$2e2bcd8739ae039 = $b84aac1cf1606946$var$BillInfo;


var $ab5ee2450fb20a34$export$9126ebe212f3bdac;
var $ab5ee2450fb20a34$export$59ae2c325a998f89;
$ab5ee2450fb20a34$export$9126ebe212f3bdac = `_23BWOW_linkButton`;
$ab5ee2450fb20a34$export$59ae2c325a998f89 = `_23BWOW_strong`;


function $13b8b1fc56d9bff7$var$PaymentOverdueModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenant: currentTenant, currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { openInvoices: openInvoices = [] } = currentTenant ?? {};
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const [isActionLoading, setIsActionLoading] = (0, $eCoWV.useState)(false);
    const [hasClosed, setHasClosed] = (0, $eCoWV.useState)(false);
    const handleCloseModal = ()=>{
        setHasClosed(true);
    };
    if (!(0, $V1X8c.isCloud) || openInvoices.length === 0 || hasClosed) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: handleCloseModal,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: "upsell.payment_overdue_modal.title",
            footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                        href: (0, $o53Y2.contactEmailLink),
                        className: $ab5ee2450fb20a34$export$9126ebe212f3bdac,
                        rel: "noopener",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "general.contact_us_action"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: "primary",
                        title: "upsell.payment_overdue_modal.update_payment",
                        isLoading: isActionLoading,
                        onClick: async ()=>{
                            setIsActionLoading(true);
                            await visitManagePaymentPage(currentTenantId);
                            setIsActionLoading(false);
                        }
                    })
                ]
            }),
            onClose: handleCloseModal,
            children: [
                currentTenant && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                    severity: "error",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                className: $ab5ee2450fb20a34$export$59ae2c325a998f89
                            })
                        },
                        children: t("upsell.payment_overdue_modal.notification", {
                            name: currentTenant.name
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "upsell.payment_overdue_modal.unpaid_bills",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b84aac1cf1606946$export$2e2bcd8739ae039), {
                        cost: openInvoices.reduce((total, currentInvoice)=>total + currentInvoice.amountDue, 0)
                    })
                })
            ]
        })
    });
}
var $13b8b1fc56d9bff7$export$2e2bcd8739ae039 = $13b8b1fc56d9bff7$var$PaymentOverdueModal;



var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");
var $7bbc2ae5f6197d16$exports = {};

!function(t, e) {
    $7bbc2ae5f6197d16$exports = e((parcelRequire("eCoWV")));
}("undefined" != typeof self ? self : $7bbc2ae5f6197d16$exports, function(t) {
    return function(t) {
        var e = {};
        function n(r) {
            if (e[r]) return e[r].exports;
            var i = e[r] = {
                i: r,
                l: !1,
                exports: {}
            };
            return t[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports;
        }
        return n.m = t, n.c = e, n.d = function(t, e, r) {
            n.o(t, e) || Object.defineProperty(t, e, {
                enumerable: !0,
                get: r
            });
        }, n.r = function(t) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(t, "__esModule", {
                value: !0
            });
        }, n.t = function(t, e) {
            if (1 & e && (t = n(t)), 8 & e) return t;
            if (4 & e && "object" == typeof t && t && t.__esModule) return t;
            var r = Object.create(null);
            if (n.r(r), Object.defineProperty(r, "default", {
                enumerable: !0,
                value: t
            }), 2 & e && "string" != typeof t) for(var i in t)n.d(r, i, (function(e) {
                return t[e];
            }).bind(null, i));
            return r;
        }, n.n = function(t) {
            var e = t && t.__esModule ? function() {
                return t.default;
            } : function() {
                return t;
            };
            return n.d(e, "a", e), e;
        }, n.o = function(t, e) {
            return Object.prototype.hasOwnProperty.call(t, e);
        }, n.p = "", n(n.s = 2);
    }([
        function(e, n) {
            e.exports = t;
        },
        function(t, e, n) {
            "use strict";
            var r = {
                linear: function(t, e, n, r) {
                    return (n - e) * t / r + e;
                },
                easeInQuad: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t + e;
                },
                easeOutQuad: function(t, e, n, r) {
                    return -(n - e) * (t /= r) * (t - 2) + e;
                },
                easeInOutQuad: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t + e : -i / 2 * (--t * (t - 2) - 1) + e;
                },
                easeInCubic: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t + e;
                },
                easeOutCubic: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t + 1) + e;
                },
                easeInOutCubic: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t + e : i / 2 * ((t -= 2) * t * t + 2) + e;
                },
                easeInQuart: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t + e;
                },
                easeOutQuart: function(t, e, n, r) {
                    return -(n - e) * ((t = t / r - 1) * t * t * t - 1) + e;
                },
                easeInOutQuart: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t + e : -i / 2 * ((t -= 2) * t * t * t - 2) + e;
                },
                easeInQuint: function(t, e, n, r) {
                    return (n - e) * (t /= r) * t * t * t * t + e;
                },
                easeOutQuint: function(t, e, n, r) {
                    return (n - e) * ((t = t / r - 1) * t * t * t * t + 1) + e;
                },
                easeInOutQuint: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? i / 2 * t * t * t * t * t + e : i / 2 * ((t -= 2) * t * t * t * t + 2) + e;
                },
                easeInSine: function(t, e, n, r) {
                    var i = n - e;
                    return -i * Math.cos(t / r * (Math.PI / 2)) + i + e;
                },
                easeOutSine: function(t, e, n, r) {
                    return (n - e) * Math.sin(t / r * (Math.PI / 2)) + e;
                },
                easeInOutSine: function(t, e, n, r) {
                    return -(n - e) / 2 * (Math.cos(Math.PI * t / r) - 1) + e;
                },
                easeInExpo: function(t, e, n, r) {
                    return 0 == t ? e : (n - e) * Math.pow(2, 10 * (t / r - 1)) + e;
                },
                easeOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return t == r ? e + i : i * (1 - Math.pow(2, -10 * t / r)) + e;
                },
                easeInOutExpo: function(t, e, n, r) {
                    var i = n - e;
                    return 0 === t ? e : t === r ? e + i : (t /= r / 2) < 1 ? i / 2 * Math.pow(2, 10 * (t - 1)) + e : i / 2 * (2 - Math.pow(2, -10 * --t)) + e;
                },
                easeInCirc: function(t, e, n, r) {
                    return -(n - e) * (Math.sqrt(1 - (t /= r) * t) - 1) + e;
                },
                easeOutCirc: function(t, e, n, r) {
                    return (n - e) * Math.sqrt(1 - (t = t / r - 1) * t) + e;
                },
                easeInOutCirc: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r / 2) < 1 ? -i / 2 * (Math.sqrt(1 - t * t) - 1) + e : i / 2 * (Math.sqrt(1 - (t -= 2) * t) + 1) + e;
                },
                easeInElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), -i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) + e);
                },
                easeOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 1 == (t /= r) ? e + c : (o = 0, o = .3 * r, (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), i * Math.pow(2, -10 * t) * Math.sin((t * r - a) * (2 * Math.PI) / o) + c + e);
                },
                easeInOutElastic: function(t, e, n, r) {
                    var i, o, a, c = n - e;
                    return a = 1.70158, 0 === t ? e : 2 == (t /= r / 2) ? e + c : (o = 0, o = r * (.3 * 1.5), (i = c) < Math.abs(c) ? (i = c, a = o / 4) : a = o / (2 * Math.PI) * Math.asin(c / i), t < 1 ? i * Math.pow(2, 10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * -0.5 + e : i * Math.pow(2, -10 * (t -= 1)) * Math.sin((t * r - a) * (2 * Math.PI) / o) * .5 + c + e);
                },
                easeInBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * (t /= r) * t * ((i + 1) * t - i) + e;
                },
                easeOutBack: function(t, e, n, r, i) {
                    return void 0 === i && (i = 1.70158), (n - e) * ((t = t / r - 1) * t * ((i + 1) * t + i) + 1) + e;
                },
                easeInOutBack: function(t, e, n, r, i) {
                    var o = n - e;
                    return void 0 === i && (i = 1.70158), (t /= r / 2) < 1 ? o / 2 * (t * t * ((1 + (i *= 1.525)) * t - i)) + e : o / 2 * ((t -= 2) * t * ((1 + (i *= 1.525)) * t + i) + 2) + e;
                },
                easeInBounce: function(t, e, n, i) {
                    var o = n - e;
                    return o - r.easeOutBounce(i - t, 0, o, i) + e;
                },
                easeOutBounce: function(t, e, n, r) {
                    var i = n - e;
                    return (t /= r) < 1 / 2.75 ? i * (7.5625 * t * t) + e : t < 2 / 2.75 ? i * (7.5625 * (t -= 1.5 / 2.75) * t + .75) + e : t < 2.5 / 2.75 ? i * (7.5625 * (t -= 2.25 / 2.75) * t + .9375) + e : i * (7.5625 * (t -= 2.625 / 2.75) * t + .984375) + e;
                },
                easeInOutBounce: function(t, e, n, i) {
                    var o = n - e;
                    return t < i / 2 ? .5 * r.easeInBounce(2 * t, 0, o, i) + e : .5 * r.easeOutBounce(2 * t - i, 0, o, i) + .5 * o + e;
                }
            };
            t.exports = r;
        },
        function(t, e, n) {
            t.exports = n(3);
        },
        function(t, e, n) {
            "use strict";
            n.r(e), n.d(e, "ReactConfetti", function() {
                return Q;
            });
            var r, i, o = n(0), a = n.n(o), c = n(1), s = n.n(c);
            function u(t, e) {
                return t + Math.random() * (e - t);
            }
            function f(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function h(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            !function(t) {
                t[t.Circle = 0] = "Circle", t[t.Square = 1] = "Square", t[t.Strip = 2] = "Strip";
            }(r || (r = {})), function(t) {
                t[t.Positive = 1] = "Positive", t[t.Negative = -1] = "Negative";
            }(i || (i = {}));
            var l = function() {
                function t(e, n, r, o) {
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), h(this, "context", void 0), h(this, "radius", void 0), h(this, "x", void 0), h(this, "y", void 0), h(this, "w", void 0), h(this, "h", void 0), h(this, "vx", void 0), h(this, "vy", void 0), h(this, "shape", void 0), h(this, "angle", void 0), h(this, "angularSpin", void 0), h(this, "color", void 0), h(this, "rotateY", void 0), h(this, "rotationDirection", void 0), h(this, "getOptions", void 0), this.getOptions = n;
                    var a, c, s = this.getOptions(), f = s.colors, l = s.initialVelocityX, p = s.initialVelocityY;
                    this.context = e, this.x = r, this.y = o, this.w = u(5, 20), this.h = u(5, 20), this.radius = u(5, 10), this.vx = "number" == typeof l ? u(-l, l) : u(l.min, l.max), this.vy = "number" == typeof p ? u(-p, 0) : u(p.min, p.max), this.shape = (a = 0, c = 2, Math.floor(a + Math.random() * (c - a + 1))), this.angle = u(0, 360) * Math.PI / 180, this.angularSpin = u(-0.2, .2), this.color = f[Math.floor(Math.random() * f.length)], this.rotateY = u(0, 1), this.rotationDirection = u(0, 1) ? i.Positive : i.Negative;
                }
                var e, n, o;
                return e = t, n = [
                    {
                        key: "update",
                        value: function() {
                            var t = this.getOptions(), e = t.gravity, n = t.wind, o = t.friction, a = t.opacity, c = t.drawShape;
                            this.x += this.vx, this.y += this.vy, this.vy += e, this.vx += n, this.vx *= o, this.vy *= o, this.rotateY >= 1 && this.rotationDirection === i.Positive ? this.rotationDirection = i.Negative : this.rotateY <= -1 && this.rotationDirection === i.Negative && (this.rotationDirection = i.Positive);
                            var s = .1 * this.rotationDirection;
                            if (this.rotateY += s, this.angle += this.angularSpin, this.context.save(), this.context.translate(this.x, this.y), this.context.rotate(this.angle), this.context.scale(1, this.rotateY), this.context.rotate(this.angle), this.context.beginPath(), this.context.fillStyle = this.color, this.context.strokeStyle = this.color, this.context.globalAlpha = a, this.context.lineCap = "round", this.context.lineWidth = 2, c && "function" == typeof c) c.call(this, this.context);
                            else switch(this.shape){
                                case r.Circle:
                                    this.context.beginPath(), this.context.arc(0, 0, this.radius, 0, 2 * Math.PI), this.context.fill();
                                    break;
                                case r.Square:
                                    this.context.fillRect(-this.w / 2, -this.h / 2, this.w, this.h);
                                    break;
                                case r.Strip:
                                    this.context.fillRect(-this.w / 6, -this.h / 2, this.w / 3, this.h);
                            }
                            this.context.closePath(), this.context.restore();
                        }
                    }
                ], f(e.prototype, n), o && f(e, o), t;
            }();
            function p(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var v = function t(e, n) {
                var r = this;
                !function(t, e) {
                    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                }(this, t), p(this, "canvas", void 0), p(this, "context", void 0), p(this, "getOptions", void 0), p(this, "x", 0), p(this, "y", 0), p(this, "w", 0), p(this, "h", 0), p(this, "lastNumberOfPieces", 0), p(this, "tweenInitTime", Date.now()), p(this, "particles", []), p(this, "particlesGenerated", 0), p(this, "removeParticleAt", function(t) {
                    r.particles.splice(t, 1);
                }), p(this, "getParticle", function() {
                    var t = u(r.x, r.w + r.x), e = u(r.y, r.h + r.y);
                    return new l(r.context, r.getOptions, t, e);
                }), p(this, "animate", function() {
                    var t = r.canvas, e = r.context, n = r.particlesGenerated, i = r.lastNumberOfPieces, o = r.getOptions(), a = o.run, c = o.recycle, s = o.numberOfPieces, u = o.debug, f = o.tweenFunction, h = o.tweenDuration;
                    if (!a) return !1;
                    var l = r.particles.length, p = c ? l : n, v = Date.now();
                    if (p < s) {
                        i !== s && (r.tweenInitTime = v, r.lastNumberOfPieces = s);
                        for(var y = r.tweenInitTime, d = f(v - y > h ? h : Math.max(0, v - y), p, s, h), b = Math.round(d - p), g = 0; g < b; g++)r.particles.push(r.getParticle());
                        r.particlesGenerated += b;
                    }
                    return u && (e.font = "12px sans-serif", e.fillStyle = "#333", e.textAlign = "right", e.fillText("Particles: ".concat(l), t.width - 10, t.height - 20)), r.particles.forEach(function(e, n) {
                        e.update(), (e.y > t.height || e.y < -100 || e.x > t.width + 100 || e.x < -100) && (c && p <= s ? r.particles[n] = r.getParticle() : r.removeParticleAt(n));
                    }), l > 0 || p < s;
                }), this.canvas = e;
                var i = this.canvas.getContext("2d");
                if (!i) throw new Error("Could not get canvas context");
                this.context = i, this.getOptions = n;
            };
            function y(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function d(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? y(Object(n), !0).forEach(function(e) {
                        g(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function b(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function g(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var O = {
                width: "undefined" != typeof window ? window.innerWidth : 300,
                height: "undefined" != typeof window ? window.innerHeight : 200,
                numberOfPieces: 200,
                friction: .99,
                wind: 0,
                gravity: .1,
                initialVelocityX: 4,
                initialVelocityY: 10,
                colors: [
                    "#f44336",
                    "#e91e63",
                    "#9c27b0",
                    "#673ab7",
                    "#3f51b5",
                    "#2196f3",
                    "#03a9f4",
                    "#00bcd4",
                    "#009688",
                    "#4CAF50",
                    "#8BC34A",
                    "#CDDC39",
                    "#FFEB3B",
                    "#FFC107",
                    "#FF9800",
                    "#FF5722",
                    "#795548"
                ],
                opacity: 1,
                debug: !1,
                tweenFunction: s.a.easeInOutQuad,
                tweenDuration: 5e3,
                recycle: !0,
                run: !0
            }, w = function() {
                function t(e, n) {
                    var r = this;
                    !function(t, e) {
                        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
                    }(this, t), g(this, "canvas", void 0), g(this, "context", void 0), g(this, "_options", void 0), g(this, "generator", void 0), g(this, "rafId", void 0), g(this, "setOptionsWithDefaults", function(t) {
                        var e = {
                            confettiSource: {
                                x: 0,
                                y: 0,
                                w: r.canvas.width,
                                h: 0
                            }
                        };
                        r._options = d(d(d({}, e), O), t), Object.assign(r, t.confettiSource);
                    }), g(this, "update", function() {
                        var t = r.options, e = t.run, n = t.onConfettiComplete, i = r.canvas, o = r.context;
                        e && (o.fillStyle = "white", o.clearRect(0, 0, i.width, i.height)), r.generator.animate() ? r.rafId = requestAnimationFrame(r.update) : (n && "function" == typeof n && r.generator.particlesGenerated > 0 && n.call(r, r), r._options.run = !1);
                    }), g(this, "reset", function() {
                        r.generator && r.generator.particlesGenerated > 0 && (r.generator.particlesGenerated = 0, r.generator.particles = [], r.generator.lastNumberOfPieces = 0);
                    }), g(this, "stop", function() {
                        r.options = {
                            run: !1
                        }, r.rafId && (cancelAnimationFrame(r.rafId), r.rafId = void 0);
                    }), this.canvas = e;
                    var i = this.canvas.getContext("2d");
                    if (!i) throw new Error("Could not get canvas context");
                    this.context = i, this.generator = new v(this.canvas, function() {
                        return r.options;
                    }), this.options = n, this.update();
                }
                var e, n, r;
                return e = t, n = [
                    {
                        key: "options",
                        get: function() {
                            return this._options;
                        },
                        set: function(t) {
                            var e = this._options && this._options.run, n = this._options && this._options.recycle;
                            this.setOptionsWithDefaults(t), this.generator && (Object.assign(this.generator, this.options.confettiSource), "boolean" == typeof t.recycle && t.recycle && !1 === n && (this.generator.lastNumberOfPieces = this.generator.particles.length)), "boolean" == typeof t.run && t.run && !1 === e && this.update();
                        }
                    }
                ], b(e.prototype, n), r && b(e, r), t;
            }();
            function m(t) {
                return function(t) {
                    if (Array.isArray(t)) return C(t);
                }(t) || function(t) {
                    if ("undefined" != typeof Symbol && Symbol.iterator in Object(t)) return Array.from(t);
                }(t) || S(t) || function() {
                    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function x(t) {
                return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
                    return typeof t;
                } : function(t) {
                    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
                })(t);
            }
            function P() {
                return (P = Object.assign || function(t) {
                    for(var e = 1; e < arguments.length; e++){
                        var n = arguments[e];
                        for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (t[r] = n[r]);
                    }
                    return t;
                }).apply(this, arguments);
            }
            function j(t, e) {
                var n = Object.keys(t);
                if (Object.getOwnPropertySymbols) {
                    var r = Object.getOwnPropertySymbols(t);
                    e && (r = r.filter(function(e) {
                        return Object.getOwnPropertyDescriptor(t, e).enumerable;
                    })), n.push.apply(n, r);
                }
                return n;
            }
            function M(t) {
                for(var e = 1; e < arguments.length; e++){
                    var n = null != arguments[e] ? arguments[e] : {};
                    e % 2 ? j(Object(n), !0).forEach(function(e) {
                        T(t, e, n[e]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : j(Object(n)).forEach(function(e) {
                        Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(n, e));
                    });
                }
                return t;
            }
            function I(t, e) {
                return function(t) {
                    if (Array.isArray(t)) return t;
                }(t) || function(t, e) {
                    if ("undefined" == typeof Symbol || !(Symbol.iterator in Object(t))) return;
                    var n = [], r = !0, i = !1, o = void 0;
                    try {
                        for(var a, c = t[Symbol.iterator](); !(r = (a = c.next()).done) && (n.push(a.value), !e || n.length !== e); r = !0);
                    } catch (t) {
                        i = !0, o = t;
                    } finally{
                        try {
                            r || null == c.return || c.return();
                        } finally{
                            if (i) throw o;
                        }
                    }
                    return n;
                }(t, e) || S(t, e) || function() {
                    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }();
            }
            function S(t, e) {
                if (t) {
                    if ("string" == typeof t) return C(t, e);
                    var n = Object.prototype.toString.call(t).slice(8, -1);
                    return "Object" === n && t.constructor && (n = t.constructor.name), "Map" === n || "Set" === n ? Array.from(t) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? C(t, e) : void 0;
                }
            }
            function C(t, e) {
                (null == e || e > t.length) && (e = t.length);
                for(var n = 0, r = new Array(e); n < e; n++)r[n] = t[n];
                return r;
            }
            function D(t, e) {
                if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
            }
            function E(t, e) {
                for(var n = 0; n < e.length; n++){
                    var r = e[n];
                    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(t, r.key, r);
                }
            }
            function _(t, e) {
                return (_ = Object.setPrototypeOf || function(t, e) {
                    return t.__proto__ = e, t;
                })(t, e);
            }
            function R(t) {
                var e = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {})), !0;
                    } catch (t) {
                        return !1;
                    }
                }();
                return function() {
                    var n, r = F(t);
                    if (e) {
                        var i = F(this).constructor;
                        n = Reflect.construct(r, arguments, i);
                    } else n = r.apply(this, arguments);
                    return k(this, n);
                };
            }
            function k(t, e) {
                return !e || "object" !== x(e) && "function" != typeof e ? A(t) : e;
            }
            function A(t) {
                if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return t;
            }
            function F(t) {
                return (F = Object.setPrototypeOf ? Object.getPrototypeOf : function(t) {
                    return t.__proto__ || Object.getPrototypeOf(t);
                })(t);
            }
            function T(t, e, n) {
                return e in t ? Object.defineProperty(t, e, {
                    value: n,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : t[e] = n, t;
            }
            var B = a.a.createRef(), N = function(t) {
                !function(t, e) {
                    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
                    t.prototype = Object.create(e && e.prototype, {
                        constructor: {
                            value: t,
                            writable: !0,
                            configurable: !0
                        }
                    }), e && _(t, e);
                }(o, t);
                var e, n, r, i = R(o);
                function o(t) {
                    var e;
                    D(this, o);
                    for(var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), c = 1; c < n; c++)r[c - 1] = arguments[c];
                    return T(A(e = i.call.apply(i, [
                        this,
                        t
                    ].concat(r))), "canvas", a.a.createRef()), T(A(e), "confetti", void 0), e.canvas = t.canvasRef || B, e;
                }
                return e = o, n = [
                    {
                        key: "componentDidMount",
                        value: function() {
                            if (this.canvas.current) {
                                var t = q(this.props)[0];
                                this.confetti = new w(this.canvas.current, t);
                            }
                        }
                    },
                    {
                        key: "componentDidUpdate",
                        value: function() {
                            var t = q(this.props)[0];
                            this.confetti && (this.confetti.options = t);
                        }
                    },
                    {
                        key: "componentWillUnmount",
                        value: function() {
                            this.confetti && this.confetti.stop(), this.confetti = void 0;
                        }
                    },
                    {
                        key: "render",
                        value: function() {
                            var t = I(q(this.props), 2), e = t[0], n = t[1], r = M({
                                zIndex: 2,
                                position: "absolute",
                                pointerEvents: "none",
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0
                            }, n.style);
                            return a.a.createElement("canvas", P({
                                width: e.width,
                                height: e.height,
                                ref: this.canvas
                            }, n, {
                                style: r
                            }));
                        }
                    }
                ], E(e.prototype, n), r && E(e, r), o;
            }(o.Component);
            function q(t) {
                var e = {}, n = {}, r = [].concat(m(Object.keys(O)), [
                    "confettiSource",
                    "drawShape",
                    "onConfettiComplete"
                ]), i = [
                    "canvasRef"
                ];
                for(var o in t){
                    var a = t[o];
                    r.includes(o) ? e[o] = a : i.includes(o) ? i[o] = a : n[o] = a;
                }
                return [
                    e,
                    n,
                    {}
                ];
            }
            T(N, "defaultProps", M({}, O)), T(N, "displayName", "ReactConfetti");
            var Q = a.a.forwardRef(function(t, e) {
                return a.a.createElement(N, P({
                    canvasRef: e
                }, t));
            });
            e.default = Q;
        }
    ]).default;
});


parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $5467c62e5314af6b$var$SvgTenantModalFireworks = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 824,
        height: 417,
        viewBox: "0 0 824 417",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M783.928 55.334c0-.185.15-.334.334-.334h6.008c.184 0 .334.15.334.334v10.573l9.156-5.286a.334.334 0 0 1 .456.122l3.004 5.203a.333.333 0 0 1-.122.456l-9.157 5.287 9.158 5.287a.334.334 0 0 1 .122.456l-3.004 5.203a.334.334 0 0 1-.456.122l-9.157-5.287v10.574c0 .184-.15.334-.334.334h-6.008a.334.334 0 0 1-.334-.334V77.47l-9.158 5.287a.334.334 0 0 1-.456-.122l-3.004-5.203a.334.334 0 0 1 .123-.456l9.157-5.287-9.157-5.287a.333.333 0 0 1-.122-.456l3.004-5.203a.334.334 0 0 1 .456-.122l9.157 5.287V55.334Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m75.957 199.757 1.513-5.45a5.656 5.656 0 0 0-3.937-6.964v0a5.657 5.657 0 0 1-3.938-6.964v0a5.657 5.657 0 0 0-3.937-6.964v0a5.657 5.657 0 0 1-3.938-6.964L63.234 161",
                stroke: "#FFD5FF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M652.766 23c6.351 0 11.5-5.149 11.5-11.5S659.117 0 652.766 0c-6.352 0-11.5 5.149-11.5 11.5s5.148 11.5 11.5 11.5Zm0-5.75a5.75 5.75 0 1 0 0-11.501 5.75 5.75 0 0 0 0 11.5ZM815.266 190a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m20.012 272.242-1.127-5.544a5.658 5.658 0 0 0-6.67-4.417v0a5.656 5.656 0 0 1-6.67-4.416l-1.127-5.544",
                stroke: "#C4C7C7",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m159.324 49.033-.155-5.655a5.657 5.657 0 0 0-5.81-5.5v0a5.656 5.656 0 0 1-5.809-5.5v0a5.657 5.657 0 0 0-5.81-5.5v0a5.657 5.657 0 0 1-5.81-5.499l-.155-5.655",
                stroke: "#CABEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m492.121 56.688-1.365-5.49a5.658 5.658 0 0 1 4.126-6.854v0a5.658 5.658 0 0 0 4.125-6.854L497.642 32M715.297 414.09l3.985-4.015a5.657 5.657 0 0 1 8-.03v0a5.656 5.656 0 0 0 8-.03l3.985-4.015",
                stroke: "#E6DEFF",
                strokeWidth: 4,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M629.269 83.5V104c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.501 4-2.001 10",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M628.466 84.5a1 1 0 0 1 1.732 0l3.634 6.294c.694 1.203-.174 2.706-1.562 2.706l-1.438-.36a1.567 1.567 0 0 0-1.081.12 1.569 1.569 0 0 1-1.009.134l-1.14-.228a5.003 5.003 0 0 0-1.681-.045c-1.065.152-1.863-.986-1.326-1.918l3.871-6.703Z",
                fill: "#DEA0E1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M649.27 61.77c0 11.47-8.955 26.153-20 26.153-11.046 0-20-14.683-20-26.154 0-11.47 8.954-20.769 20-20.769 11.045 0 20 9.299 20 20.77Z",
                fill: "#F4B4FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M635.85 47.806a19.809 19.809 0 0 1 1.614 1.71m5.219 18.767c1.507-5.654-.256-11.044-2.591-15.038a26.91 26.91 0 0 0-1.215-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M592.768 143.5c3.504-5.5 4.502-7 2.001-10-1.319-1.584-3-3-1.5-8s-1.499-4 0-8.5c1.001-2.5 0-7.1 0-7.5",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M592.698 105.99a.66.66 0 0 1 1.143 0l2.398 4.153a1.19 1.19 0 0 1-1.031 1.785l-.948-.237a1.037 1.037 0 0 0-.714.078c-.206.103-.44.135-.666.09l-.752-.151a3.304 3.304 0 0 0-1.109-.03c-.703.101-1.23-.65-.875-1.265l2.554-4.423Z",
                fill: "#71C171"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M607.27 90.538c0 8.03-6.268 18.308-14 18.308s-14-10.278-14-18.308c0-8.029 6.268-14.538 14-14.538s14 6.51 14 14.538Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M598.582 82a9.09 9.09 0 0 1 1 1.217m1.5 10.783c1.085-3.04.747-5.823-.056-8-.136-.37-.286-.722-.444-1.055",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            })
        ]
    });
var $5467c62e5314af6b$export$2e2bcd8739ae039 = $5467c62e5314af6b$var$SvgTenantModalFireworks;


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $bNHoO = parcelRequire("bNHoO");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");

var $2mi28 = parcelRequire("2mi28");

var $2ANSb = parcelRequire("2ANSb");
const $143de1ad4ba7f448$var$useConfigs = ()=>{
    const { isAuthenticated: isAuthenticated, error: authError } = (0, $dtOpc.useLogto)();
    const shouldFetch = isAuthenticated && !authError;
    const { data: configs, error: error, mutate: mutate } = (0, $2mi28.default)(shouldFetch && "api/configs/admin-console");
    const api = (0, $2ANSb.default)();
    const updateConfigs = async (json)=>{
        const updatedConfigs = await api.patch("api/configs/admin-console", {
            json: json
        }).json();
        mutate(updatedConfigs);
    };
    return {
        isLoading: !configs && !error,
        configs: configs,
        error: error,
        mutate: mutate,
        updateConfigs: updateConfigs
    };
};
var $143de1ad4ba7f448$export$2e2bcd8739ae039 = $143de1ad4ba7f448$var$useConfigs;




var $93h5F = parcelRequire("93h5F");

var $7iZsu = parcelRequire("7iZsu");
var $00066b268faa84de$export$a7db06668cad9adb;
var $00066b268faa84de$export$e1a536b96d046f66;
var $00066b268faa84de$export$2e4cabdda5b7ccbd;
var $00066b268faa84de$export$af5dcc21c8ae7acc;
var $00066b268faa84de$export$464c821cd4347539;
var $00066b268faa84de$export$2469d05e9fc95e3a;
var $00066b268faa84de$export$bfd64c937657f93a;
var $00066b268faa84de$export$4a6dd88bada4e7d2;
var $00066b268faa84de$export$59ae2c325a998f89;
var $00066b268faa84de$export$fb184b623420d9be;
$00066b268faa84de$export$a7db06668cad9adb = `X6m6Xa_content`;
$00066b268faa84de$export$e1a536b96d046f66 = `X6m6Xa_fireworks`;
$00066b268faa84de$export$2e4cabdda5b7ccbd = `X6m6Xa_fireworksImage`;
$00066b268faa84de$export$af5dcc21c8ae7acc = `X6m6Xa_headerIcon`;
$00066b268faa84de$export$464c821cd4347539 = `X6m6Xa_hint`;
$00066b268faa84de$export$2469d05e9fc95e3a = `X6m6Xa_modalLayoutWrapper`;
$00066b268faa84de$export$bfd64c937657f93a = `X6m6Xa_rotating`;
$00066b268faa84de$export$4a6dd88bada4e7d2 = `X6m6Xa_shimmer`;
$00066b268faa84de$export$59ae2c325a998f89 = `X6m6Xa_strong`;
$00066b268faa84de$export$fb184b623420d9be = `X6m6Xa_title`;


/**
 * This modal is used to notify the user that the tenant env has been migrated.
 *
 * In our new development tenant feature, the old tenant env `staging` is deprecated,
 * we migrated the existing paid tenant's env to 'production', and the existing free 'staging' tenant's env to 'production'.
 *
 * For the original paid and free staging tenants, we will show the migration hint to notify the user that the tenant env has been migrated to 'production'.
 */ function $3b6d9851e9d25c7c$var$TenantEnvMigrationModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const HeaderIcon = theme === (0, $bhvxB.Theme).Light ? (0, $2f1758de09de54a0$export$2e2bcd8739ae039) : (0, $478091f8c43e559f$export$2e2bcd8739ae039);
    const { configs: configs, updateConfigs: updateConfigs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const { developmentTenantMigrationNotification: migrationData } = configs ?? {};
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const onClose = (0, $eCoWV.useCallback)(async ()=>{
        if (!migrationData) return;
        await updateConfigs({
            developmentTenantMigrationNotification: {
                ...migrationData,
                readAt: Date.now()
            }
        });
    }, [
        migrationData,
        updateConfigs
    ]);
    if (!migrationData || migrationData.readAt) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $00066b268faa84de$export$2469d05e9fc95e3a,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
                        isWordWrapEnabled: true,
                        headerIcon: /*#__PURE__*/ (0, $9zeGj.jsx)(HeaderIcon, {
                            className: $00066b268faa84de$export$af5dcc21c8ae7acc
                        }),
                        title: "tenants.dev_tenant_migration.title",
                        footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                                    title: "tenants.dev_tenant_migration.about_tenant_type",
                                    size: "large",
                                    href: getDocumentationUrl((0, $o53Y2.envTagsFeatureLink)),
                                    targetBlank: "noopener"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                    title: "general.got_it",
                                    size: "large",
                                    type: "primary",
                                    onClick: onClose
                                })
                            ]
                        }),
                        onClose: onClose,
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $00066b268faa84de$export$a7db06668cad9adb,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $00066b268faa84de$export$fb184b623420d9be,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                        forKey: "tenants.dev_tenant_migration.affect_title"
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $00066b268faa84de$export$464c821cd4347539,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                                components: {
                                                    strong: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                        className: $00066b268faa84de$export$59ae2c325a998f89
                                                    })
                                                },
                                                children: t("tenants.dev_tenant_migration.hint_1")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                                components: {
                                                    strong: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                        className: $00066b268faa84de$export$59ae2c325a998f89
                                                    })
                                                },
                                                children: t("tenants.dev_tenant_migration.hint_2")
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            children: t("tenants.dev_tenant_migration.hint_3")
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $00066b268faa84de$export$e1a536b96d046f66,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5467c62e5314af6b$export$2e2bcd8739ae039), {
                            className: $00066b268faa84de$export$2e4cabdda5b7ccbd
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7bbc2ae5f6197d16$exports))), {
                recycle: false
            })
        ]
    });
}
var $3b6d9851e9d25c7c$export$2e2bcd8739ae039 = $3b6d9851e9d25c7c$var$TenantEnvMigrationModal;


function $06c13bc3ced34932$var$TenantNotificationContainer() {
    const { currentTenant: currentTenant, isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const isTenantSuspended = currentTenant?.isSuspended;
    if (!(0, $V1X8c.isCloud) || isTenantSuspended) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            !isDevTenant && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f445888e2d1c5135$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $13b8b1fc56d9bff7$export$2e2bcd8739ae039), {})
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3b6d9851e9d25c7c$export$2e2bcd8739ae039), {})
        ]
    });
}
var $06c13bc3ced34932$export$2e2bcd8739ae039 = $06c13bc3ced34932$var$TenantNotificationContainer;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1472ddfe7d5258a7$var$SvgErrorDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#C2BDD5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_274_17729",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_274_17729)",
                fill: "#B4AFCC",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M64.8 142.2v-128h.8v128zM73 142V14h.8v128zM81 142V14h.8v128zM89 142V14h.8v128zM97 142V14h.8v128zM105 142V14h.8v128zM113 142V14h.8v128zM121 142V14h.8v128zM129 142V14h.8v128zM137 142V14h.8v128zM145 142V14h.8v128zM153 142V14h.8v128zM161 142V14h.8v128zM169 142V14h.8v128zM177 142V14h.8v128z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M57 78h128v.8H57zM57 86h128v.8H57zM57 94h128v.8H57zM57 102h128v.8H57zM57 110h128v.8H57zM57 118h128v.8H57zM57 126h128v.8H57zM57 134h128v.8H57z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M125.333 107.619c1.186-2.053 4.148-2.053 5.334 0l26.666 46.188c1.186 2.053-.296 4.619-2.666 4.619h-53.334c-2.37 0-3.852-2.566-2.666-4.619l26.666-46.188Z",
                fill: "#F9EF95"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 119a4 4 0 0 0-4 4v12a4 4 0 0 0 8 0v-12a4 4 0 0 0-4-4Zm0 24a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
                fill: "#444748"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#4E5065",
                d: "m203.134 214.277 6.511-4.648 4.648 6.51-6.51 4.65z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 206,
                y: 27.648,
                width: 8,
                height: 8,
                rx: 0.16,
                transform: "rotate(-35.523 206 27.648)",
                fill: "#41485E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 172.452,
                y: 171,
                width: 16,
                height: 16,
                rx: 4,
                transform: "rotate(50.249 172.452 171)",
                fill: "#5C6273"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M221.914 96.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.209.209 0 0 1-.209.208h-3.755a.209.209 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61ZM94.331 193.209c0-.116.094-.209.209-.209h2.92c.116 0 .21.093.21.209v5.245l4.542-2.623a.208.208 0 0 1 .284.077l1.461 2.529a.21.21 0 0 1-.077.285l-4.542 2.622 4.542 2.623c.1.058.134.185.076.285l-1.46 2.529a.209.209 0 0 1-.285.077l-4.542-2.623v5.245a.21.21 0 0 1-.208.209H94.54a.21.21 0 0 1-.209-.209v-5.245l-4.542 2.623a.21.21 0 0 1-.285-.077l-1.46-2.529a.209.209 0 0 1 .076-.285l4.542-2.623-4.542-2.622a.209.209 0 0 1-.077-.285l1.46-2.529a.21.21 0 0 1 .285-.077l4.543 2.623v-5.245Z",
                fill: "#4E5075"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52 62a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#626685"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39 167a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#4A475C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M153.212 48.314a.16.16 0 0 1 .177-.213l15.222 2.616a.16.16 0 0 1 .096.26l-9.877 11.875a.16.16 0 0 1-.273-.047l-5.345-14.491Z",
                fill: "#373C4A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#5E6775",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#4E5075"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#4E5075"
            })
        ]
    });
var $1472ddfe7d5258a7$export$2e2bcd8739ae039 = $1472ddfe7d5258a7$var$SvgErrorDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f30a2cc5dc4ce819$var$SvgError = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12.191,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_3312_122828",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#CABEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_3312_122828)",
                fill: "#000",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M64.8 142.2v-128h.4v128zM73 142V14h.4v128zM81 142V14h.4v128zM89 142V14h.4v128zM97 142V14h.4v128zM105 142V14h.4v128zM113 142V14h.4v128zM121 142V14h.4v128zM129 142V14h.4v128zM137 142V14h.4v128zM145 142V14h.4v128zM153 142V14h.4v128zM161 142V14h.4v128zM169 142V14h.4v128zM177 142V14h.4v128z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M57 78h128v.4H57zM57 86h128v.4H57zM57 94h128v.4H57zM57 102h128v.4H57zM57 110h128v.4H57zM57 118h128v.4H57zM57 126h128v.4H57zM57 134h128v.4H57z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M125.333 107.619c1.186-2.053 4.148-2.053 5.334 0l26.666 46.188c1.186 2.053-.296 4.619-2.666 4.619h-53.334c-2.37 0-3.852-2.566-2.666-4.619l26.666-46.188Z",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M128 119a4 4 0 0 0-4 4v12a4 4 0 0 0 8 0v-12a4 4 0 0 0-4-4Zm0 24a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z",
                fill: "#444748"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v8H58v-8Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 77,
                cy: 84,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 97,
                cy: 84,
                r: 3,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#C4C4C4",
                d: "m203.133 214.277 6.511-4.648 4.648 6.51-6.51 4.65z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 206,
                y: 27.648,
                width: 8,
                height: 8,
                rx: 0.16,
                transform: "rotate(-35.523 206 27.648)",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                transform: "rotate(50.249 172.453 171)",
                fill: "#C4C7C7",
                d: "M172.453 171h16v16h-16z",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M221.914 96.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.207.207 0 0 1-.284.076l-5.723-3.304v6.609a.209.209 0 0 1-.209.208h-3.755a.209.209 0 0 1-.209-.208v-6.609l-5.723 3.304a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61ZM94.331 193.209c0-.116.094-.209.209-.209h2.92c.116 0 .21.093.21.209v5.245l4.542-2.623a.208.208 0 0 1 .284.077l1.461 2.529a.21.21 0 0 1-.077.285l-4.542 2.622 4.542 2.623c.1.058.134.185.076.285l-1.46 2.529a.209.209 0 0 1-.285.077l-4.542-2.623v5.245a.21.21 0 0 1-.208.209H94.54a.21.21 0 0 1-.209-.209v-5.245l-4.542 2.623a.21.21 0 0 1-.285-.077l-1.46-2.529a.209.209 0 0 1 .076-.285l4.542-2.623-4.542-2.622a.209.209 0 0 1-.077-.285l1.46-2.529a.21.21 0 0 1 .285-.077l4.543 2.623v-5.245Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M52 62a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M39 167a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#E0E3E3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M153.212 48.314a.16.16 0 0 1 .177-.213l15.222 2.616a.16.16 0 0 1 .096.26l-9.877 11.875a.16.16 0 0 1-.273-.047l-5.345-14.491Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#F7F8F8",
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m117.818 59.546 2.108-4.005a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113v0a4.525 4.525 0 0 0-1.896-6.112v0a4.525 4.525 0 0 1-1.897-6.113l2.108-4.005",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 3.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M29.717 172.618a.16.16 0 0 1 .261-.094l5.675 4.821a.16.16 0 0 1-.05.273l-7.012 2.504a.16.16 0 0 1-.212-.18l1.338-7.324Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#747778"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#747778"
            })
        ]
    });
var $f30a2cc5dc4ce819$export$2e2bcd8739ae039 = $f30a2cc5dc4ce819$var$SvgError;


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $93h5F = parcelRequire("93h5F");
var $79f1713ea2f6d8b1$export$6d59db4903f20f7d;
var $79f1713ea2f6d8b1$export$5c452ff88e35e47d;
var $79f1713ea2f6d8b1$export$9126ebe212f3bdac;
var $79f1713ea2f6d8b1$export$bfd64c937657f93a;
var $79f1713ea2f6d8b1$export$4a6dd88bada4e7d2;
var $79f1713ea2f6d8b1$export$8cbac80413230349;
var $79f1713ea2f6d8b1$export$fb184b623420d9be;
$79f1713ea2f6d8b1$export$6d59db4903f20f7d = `fTcdFG_description`;
$79f1713ea2f6d8b1$export$5c452ff88e35e47d = `fTcdFG_image`;
$79f1713ea2f6d8b1$export$9126ebe212f3bdac = `fTcdFG_linkButton`;
$79f1713ea2f6d8b1$export$bfd64c937657f93a = `fTcdFG_rotating`;
$79f1713ea2f6d8b1$export$4a6dd88bada4e7d2 = `fTcdFG_shimmer`;
$79f1713ea2f6d8b1$export$8cbac80413230349 = `fTcdFG_suspendedPage`;
$79f1713ea2f6d8b1$export$fb184b623420d9be = `fTcdFG_title`;


function $a4d2cdfaf51e6472$var$TenantSuspendedPage() {
    const theme = (0, $93h5F.default)();
    const ErrorImage = theme === (0, $bhvxB.Theme).Light ? (0, $f30a2cc5dc4ce819$export$2e2bcd8739ae039) : (0, $1472ddfe7d5258a7$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $79f1713ea2f6d8b1$export$8cbac80413230349,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(ErrorImage, {
                className: $79f1713ea2f6d8b1$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $79f1713ea2f6d8b1$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "tenants.tenant_suspended_page.title"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $79f1713ea2f6d8b1$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "tenants.tenant_suspended_page.description_1"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $79f1713ea2f6d8b1$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "tenants.tenant_suspended_page.description_2"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                href: (0, $o53Y2.contactEmailLink),
                className: $79f1713ea2f6d8b1$export$9126ebe212f3bdac,
                rel: "noopener",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "general.contact_us_action",
                    type: "outline"
                })
            })
        ]
    });
}
var $a4d2cdfaf51e6472$export$2e2bcd8739ae039 = $a4d2cdfaf51e6472$var$TenantSuspendedPage;


var $cea6da780b21d2d8$export$729c8b7179294ba;
var $cea6da780b21d2d8$export$bfd64c937657f93a;
var $cea6da780b21d2d8$export$4a6dd88bada4e7d2;
var $cea6da780b21d2d8$export$38c1c9d77d97076;
$cea6da780b21d2d8$export$729c8b7179294ba = `wZF7yG_app`;
$cea6da780b21d2d8$export$bfd64c937657f93a = `wZF7yG_rotating`;
$cea6da780b21d2d8$export$4a6dd88bada4e7d2 = `wZF7yG_shimmer`;
$cea6da780b21d2d8$export$38c1c9d77d97076 = `wZF7yG_topbarShadow`;


function $6d4c5a47f1872192$export$2e2bcd8739ae039() {
    const { isLoading: isLoading } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const { currentTenant: currentTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const isTenantSuspended = (0, $V1X8c.isCloud) && currentTenant?.isSuspended;
    const scrollableContent = (0, $eCoWV.useRef)(null);
    const { scrollTop: scrollTop } = (0, $gbU1S.default)(scrollableContent.current);
    if (isLoading || !currentTenant) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $cea6da780b21d2d8$export$729c8b7179294ba,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c55ce026a9f50563$export$2e2bcd8739ae039), {
                        className: (0, $5CQIb.conditional)(scrollTop && $cea6da780b21d2d8$export$38c1c9d77d97076)
                    }),
                    isTenantSuspended && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a4d2cdfaf51e6472$export$2e2bcd8739ae039), {}),
                    !isTenantSuspended && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {
                        context: {
                            scrollableContent: scrollableContent
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $06c13bc3ced34932$export$2e2bcd8739ae039), {})
        ]
    });
}
function $6d4c5a47f1872192$export$468d45f4f0fe384a() {
    const { tenantId: tenantId } = (0, $9X5Bp.useParams)();
    const { firstItem: firstItem } = (0, $b249338b106e658c$export$74c84f4d9513e4e1)();
    if (!firstItem) throw new Error("First sidebar item not found");
    if (!tenantId) throw new Error("Tenant ID not found");
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
        replace: true,
        to: (0, $b9zrd.joinPath)(tenantId, (0, $6e9dc250db2f6ebf$export$2aa3fd96c49a84a8)(firstItem.title))
    });
}



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $d0Zvy = parcelRequire("d0Zvy");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
var $MRt6E = parcelRequire("MRt6E");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d3531ed89fdec97a$var$SvgApiResourceDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-2-inside-1_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.78 6.5a1 1 0 0 0-.97.757L17 10.5l3 1 3-1-.81-3.243a1 1 0 0 0-.97-.757h-2.44Zm0 28a1 1 0 0 1-.97-.758L17 30.5l3-1 3 1-.81 3.242a1 1 0 0 1-.97.758h-2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m17.81 7.257-.97-.242.97.242ZM17 10.5l-.97-.242-.225.898.879.293L17 10.5Zm3 1-.316.949.316.105.316-.105L20 11.5Zm3-1 .316.949.879-.293-.225-.899-.97.243Zm-.81-3.243-.97.243.97-.243Zm-4.38 26.485-.97.243.97-.242ZM17 30.5l-.316-.949-.879.293.225.898.97-.242Zm3-1 .316-.949-.316-.105-.316.105.316.949Zm3 1 .97.242.225-.898-.879-.293L23 30.5Zm-4.22-23v-2a2 2 0 0 0-1.94 1.515l1.94.485Zm-.81 3.242.81-3.242-1.94-.485-.81 3.243 1.94.485Zm2.346-.19-3-1-.632 1.897 3 1 .632-1.898Zm2.368-1-3 1 .632 1.897 3-1-.632-1.898ZM21.219 7.5l.81 3.242 1.941-.485-.81-3.242-1.94.485Zm0 0 1.94-.485A2 2 0 0 0 21.22 5.5v2Zm-2.438 0h2.438v-2h-2.438v2Zm-1.94 26.485a2 2 0 0 0 1.94 1.515v-2l-1.94.485Zm-.811-3.242.81 3.242 1.94-.485-.81-3.242-1.94.485Zm3.654-2.192-3 1 .632 1.898 3-1-.632-1.898Zm3.632 1-3-1-.632 1.898 3 1 .632-1.898Zm-.156 4.434.81-3.242-1.94-.485-.81 3.242 1.94.485ZM21.22 35.5a2 2 0 0 0 1.94-1.515l-1.94-.485v2Zm-2.44 0h2.44v-2h-2.44v2Z",
                fill: "#F4A6FE",
                mask: "url(#path-2-inside-1_4272_16285)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-4-inside-2_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.238 11.463a1 1 0 0 0-.15 1.221l1.719 2.866 3.192-1.05 1.05-3.193-2.865-1.72a1 1 0 0 0-1.222.151l-1.724 1.725Zm19.799 19.799a1 1 0 0 1-1.222.15l-2.866-1.72L26 26.5l3.193-1.05 1.72 2.866a1 1 0 0 1-.151 1.221l-1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m9.087 12.684-.857.515.857-.515Zm1.72 2.866-.858.515.412.685.758-.25-.312-.95Zm3.192-1.05.313.95.48-.158.157-.48L14 14.5Zm1.05-3.193.95.313.25-.759-.685-.411-.514.857Zm-2.865-1.72-.515.858.515-.857Zm15.631 21.825-.514.857.514-.857Zm-2.866-1.72L24 29.38l-.25.759.686.41.514-.857ZM26 26.5l-.312-.95-.48.158-.158.48.95.312Zm3.193-1.05.857-.515-.41-.685-.76.25.313.95ZM9.945 12.17 8.53 10.755A2 2 0 0 0 8.23 13.2l1.715-1.03Zm1.72 2.866-1.72-2.866-1.715 1.029 1.72 2.866 1.714-1.03Zm2.022-1.486-3.193 1.05.625 1.9 3.193-1.05-.625-1.9Zm.413-2.555-1.05 3.192 1.9.625L16 11.62l-1.9-.625Zm-2.43-.55 2.865 1.72 1.03-1.715-2.867-1.72-1.029 1.715Zm0 0 1.028-1.715a2 2 0 0 0-2.443.301l1.414 1.414ZM9.944 12.17l1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415ZM27.3 32.27a2 2 0 0 0 2.443-.301l-1.414-1.415-1.03 1.715Zm-2.866-1.72 2.866 1.72 1.029-1.716-2.866-1.72-1.03 1.716Zm.614-4.363L24 29.38l1.9.625 1.05-3.192-1.9-.626Zm3.83-1.687-3.192 1.05.625 1.9 3.192-1.05-.625-1.9Zm2.89 3.301-1.72-2.866-1.715 1.03 1.72 2.865 1.715-1.029Zm-.3 2.443a2 2 0 0 0 .3-2.443l-1.715 1.03 1.414 1.413Zm-1.725 1.725 1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415Z",
                fill: "#F4A6FE",
                mask: "url(#path-4-inside-2_4272_16285)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-6-inside-3_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.762 11.463a1 1 0 0 1 .15 1.221l-1.719 2.866-3.192-1.05-1.05-3.193 2.865-1.72a1 1 0 0 1 1.222.151l1.724 1.725ZM10.963 31.261a1 1 0 0 0 1.222.15l2.866-1.72L14 26.5l-3.193-1.05-1.72 2.866a1 1 0 0 0 .151 1.221l1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m30.913 12.684.857.515-.857-.515Zm-.15-1.221.706-.708-.707.707Zm-1.57 4.087.858.515-.411.685-.76-.25.313-.95Zm-3.192-1.05-.313.95-.48-.158-.157-.48.95-.312Zm-1.05-3.193-.95.313-.25-.759.685-.411.514.857Zm2.865-1.72.515.858-.515-.857Zm1.222.151-.707.707.707-.707ZM12.185 31.412l.514.857-.514-.857Zm-1.222-.15.707-.708-.707.708Zm4.088-1.57.95-.312.25.759-.686.41-.514-.857ZM14 26.5l.312-.95.48.158.158.48-.95.312Zm-3.193-1.05-.857-.515.41-.685.76.25-.313.95Zm-1.72 2.866.858.514-.857-.514Zm.151 1.221-.707.707.707-.707ZM30.055 12.17l1.414-1.415a2 2 0 0 1 .301 2.444l-1.715-1.03Zm-1.72 2.866 1.72-2.866 1.715 1.029-1.72 2.866-1.714-1.03Zm-2.022-1.486 3.193 1.05-.625 1.9-3.193-1.05.625-1.9Zm-.413-2.555 1.05 3.192-1.9.625L24 11.62l1.9-.625Zm2.43-.55-2.865 1.72-1.03-1.715 2.867-1.72 1.029 1.715Zm0 0L27.303 8.73a2 2 0 0 1 2.443.301l-1.414 1.414Zm1.725 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415ZM12.7 32.27a2 2 0 0 1-2.443-.301l1.414-1.415 1.03 1.715Zm2.866-1.72L12.7 32.27l-1.029-1.716 2.866-1.72 1.03 1.716Zm-.614-4.363L16 29.38l-1.9.625-1.05-3.193 1.9-.625ZM11.12 24.5l3.192 1.05-.625 1.9-3.192-1.05.625-1.9ZM8.23 27.8l1.72-2.866 1.715 1.03-1.72 2.865-1.715-1.029Zm.301 2.443a2 2 0 0 1-.3-2.443l1.714 1.03-1.414 1.413Zm1.724 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415Z",
                fill: "#F4A6FE",
                mask: "url(#path-6-inside-3_4272_16285)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-8-inside-4_4272_16285",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6 21.72a1 1 0 0 0 .757.97L10 23.5l1-3-1-3-3.243.81a1 1 0 0 0-.757.97v2.44Zm28 0a1 1 0 0 1-.758.97L30 23.5l-1-3 1-3 3.242.81a1 1 0 0 1 .758.97v2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m6.757 22.69-.242.97.242-.97ZM10 23.5l-.243.97.899.225.293-.879L10 23.5Zm1-3 .949.316.105-.316-.105-.316L11 20.5Zm-1-3 .949-.316-.293-.879-.899.225.243.97Zm-3.243.81.243.97-.243-.97Zm26.485 4.38.243.97-.242-.97ZM30 23.5l-.949.316.293.879.898-.225L30 23.5Zm-1-3-.949-.316-.105.316.105.316L29 20.5Zm1-3 .242-.97-.898-.225-.293.879.949.316ZM7 21.72H5a2 2 0 0 0 1.515 1.94L7 21.72Zm3.242.81L7 21.72l-.485 1.94 3.242.81.486-1.94Zm-.19-2.346-1 3 1.897.632 1-3-1.898-.632Zm-1-2.368 1 3 1.897-.632-1-3-1.898.632ZM7 19.281l3.242-.81-.485-1.941-3.242.81L7 19.28Zm0 0-.485-1.94A2 2 0 0 0 5 19.28h2Zm0 2.438v-2.438H5v2.438h2Zm26.485 1.94A2 2 0 0 0 35 21.72h-2l.485 1.94Zm-3.242.811 3.242-.81L33 21.72l-3.242.81.485 1.94Zm-2.192-3.654 1 3 1.898-.632-1-3-1.898.632Zm1-3.632-1 3 1.898.632 1-3-1.898-.632Zm4.434.156-3.242-.81-.485 1.94 3.242.81.485-1.94ZM35 19.28a2 2 0 0 0-1.515-1.94L33 19.28h2Zm0 2.44v-2.44h-2v2.44h2Z",
                fill: "#F4A6FE",
                mask: "url(#path-8-inside-4_4272_16285)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 31.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Zm0-4a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
                fill: "url(#paint0_linear_4272_16285)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F0DAFF",
                d: "M15 18.5h1v1h-1zM14 18.5h1v1h-1zM14 19.5h1v1h-1zM14 20.5h1v1h-1zM15 20.5h1v1h-1zM16 20.5h1v1h-1zM14 21.5h1v1h-1zM16 18.5h1v1h-1zM17 18.5h1v1h-1zM19 18.5h1v1h-1zM20 18.5h1v1h-1zM21 18.5h1v1h-1zM22 18.5h1v1h-1zM22 19.5h1v1h-1zM24 19.5h1v1h-1zM24 20.5h1v1h-1zM24 21.5h1v1h-1zM24 18.5h1v1h-1zM22 20.5h1v1h-1zM21 20.5h1v1h-1zM20 20.5h1v1h-1zM19 21.5h1v1h-1zM19 20.5h1v1h-1zM19 19.5h1v1h-1zM17 19.5h1v1h-1zM17 20.5h1v1h-1zM17 21.5h1v1h-1z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_4272_16285",
                    x1: 7.193,
                    y1: 22.104,
                    x2: 30.707,
                    y2: 13.422,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#614DDD"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#D47AFE"
                        })
                    ]
                })
            })
        ]
    });
var $d3531ed89fdec97a$export$2e2bcd8739ae039 = $d3531ed89fdec97a$var$SvgApiResourceDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $457ebd48361125e9$var$SvgApiResource = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-2-inside-1_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.78 6.5a1 1 0 0 0-.97.757L17 10.5l3 1 3-1-.81-3.243a1 1 0 0 0-.97-.757h-2.44Zm0 28a1 1 0 0 1-.97-.758L17 30.5l3-1 3 1-.81 3.242a1 1 0 0 1-.97.758h-2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m17.81 7.257-.97-.242.97.242ZM17 10.5l-.97-.242-.225.898.879.293L17 10.5Zm3 1-.316.949.316.105.316-.105L20 11.5Zm3-1 .316.949.879-.293-.225-.899-.97.243Zm-.81-3.243-.97.243.97-.243Zm-4.38 26.485-.97.243.97-.242ZM17 30.5l-.316-.949-.879.293.225.898.97-.242Zm3-1 .316-.949-.316-.105-.316.105.316.949Zm3 1 .97.242.225-.898-.879-.293L23 30.5Zm-4.22-23v-2a2 2 0 0 0-1.94 1.515l1.94.485Zm-.81 3.242.81-3.242-1.94-.485-.81 3.243 1.94.485Zm2.346-.19-3-1-.632 1.897 3 1 .632-1.898Zm2.368-1-3 1 .632 1.897 3-1-.632-1.898ZM21.219 7.5l.81 3.242 1.941-.485-.81-3.242-1.94.485Zm0 0 1.94-.485A2 2 0 0 0 21.22 5.5v2Zm-2.438 0h2.438v-2h-2.438v2Zm-1.94 26.485a2 2 0 0 0 1.94 1.515v-2l-1.94.485Zm-.811-3.242.81 3.242 1.94-.485-.81-3.242-1.94.485Zm3.654-2.192-3 1 .632 1.898 3-1-.632-1.898Zm3.632 1-3-1-.632 1.898 3 1 .632-1.898Zm-.156 4.434.81-3.242-1.94-.485-.81 3.242 1.94.485ZM21.22 35.5a2 2 0 0 0 1.94-1.515l-1.94-.485v2Zm-2.44 0h2.44v-2h-2.44v2Z",
                fill: "#F07EFF",
                mask: "url(#path-2-inside-1_1555_8784)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-4-inside-2_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M9.238 11.463a1 1 0 0 0-.15 1.221l1.719 2.866 3.192-1.05 1.05-3.193-2.865-1.72a1 1 0 0 0-1.222.151l-1.724 1.725Zm19.799 19.799a1 1 0 0 1-1.222.15l-2.866-1.72L26 26.5l3.193-1.05 1.72 2.866a1 1 0 0 1-.151 1.221l-1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m9.087 12.684-.857.515.857-.515Zm.15-1.221-.706-.708.707.707Zm1.57 4.087-.858.515.412.685.758-.25-.312-.95Zm3.192-1.05.313.95.48-.158.157-.48L14 14.5Zm1.05-3.193.95.313.25-.759-.685-.411-.514.857Zm-2.865-1.72-.515.858.515-.857Zm-1.222.151.707.707-.707-.707Zm16.853 21.674-.514.857.514-.857Zm1.222-.15-.707-.708.707.708Zm-4.088-1.57L24 29.38l-.25.759.686.41.514-.857ZM26 26.5l-.312-.95-.48.158-.158.48.95.312Zm3.193-1.05.857-.515-.41-.685-.76.25.313.95Zm1.569 4.087.707.707-.707-.707ZM9.945 12.17 8.53 10.755A2 2 0 0 0 8.23 13.2l1.715-1.03Zm1.72 2.866-1.72-2.866-1.715 1.029 1.72 2.866 1.714-1.03Zm2.022-1.486-3.193 1.05.625 1.9 3.193-1.05-.625-1.9Zm.413-2.555-1.05 3.192 1.9.625L16 11.62l-1.9-.625Zm-2.43-.55 2.865 1.72 1.03-1.715-2.867-1.72-1.029 1.715Zm0 0 1.028-1.715a2 2 0 0 0-2.443.301l1.414 1.414ZM9.944 12.17l1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415ZM27.3 32.27a2 2 0 0 0 2.443-.301l-1.414-1.415-1.03 1.715Zm-2.866-1.72 2.866 1.72 1.029-1.716-2.866-1.72-1.03 1.716Zm.614-4.363L24 29.38l1.9.625 1.05-3.192-1.9-.626Zm3.83-1.687-3.192 1.05.625 1.9 3.192-1.05-.625-1.9Zm2.89 3.301-1.72-2.866-1.715 1.03 1.72 2.865 1.715-1.029Zm-.3 2.443a2 2 0 0 0 .3-2.443l-1.715 1.03 1.414 1.413Zm-1.725 1.725 1.724-1.725-1.414-1.414-1.724 1.724 1.414 1.415Z",
                fill: "#F07EFF",
                mask: "url(#path-4-inside-2_1555_8784)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-6-inside-3_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M30.762 11.463a1 1 0 0 1 .15 1.221l-1.719 2.866-3.192-1.05-1.05-3.193 2.865-1.72a1 1 0 0 1 1.222.151l1.724 1.725ZM10.963 31.261a1 1 0 0 0 1.222.15l2.866-1.72L14 26.5l-3.193-1.05-1.72 2.866a1 1 0 0 0 .151 1.221l1.724 1.725Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m30.913 12.684.857.515-.857-.515Zm-.15-1.221.706-.708-.707.707Zm-1.57 4.087.858.515-.411.685-.76-.25.313-.95Zm-3.192-1.05-.313.95-.48-.158-.157-.48.95-.312Zm-1.05-3.193-.95.313-.25-.759.685-.411.514.857Zm2.865-1.72.515.858-.515-.857Zm1.222.151-.707.707.707-.707ZM12.185 31.412l.514.857-.514-.857Zm-1.222-.15.707-.708-.707.708Zm4.088-1.57.95-.312.25.759-.686.41-.514-.857ZM14 26.5l.312-.95.48.158.158.48-.95.312Zm-3.193-1.05-.857-.515.41-.685.76.25-.313.95ZM9.24 29.537l-.707.707.707-.707ZM30.055 12.17l1.414-1.415a2 2 0 0 1 .301 2.444l-1.715-1.03Zm-1.72 2.866 1.72-2.866 1.715 1.029-1.72 2.866-1.714-1.03Zm-2.022-1.486 3.193 1.05-.625 1.9-3.193-1.05.625-1.9Zm-.413-2.555 1.05 3.192-1.9.625L24 11.62l1.9-.625Zm2.43-.55-2.865 1.72-1.03-1.715 2.867-1.72 1.029 1.715Zm0 0L27.303 8.73a2 2 0 0 1 2.443.301l-1.414 1.414Zm1.725 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415ZM12.7 32.27a2 2 0 0 1-2.443-.301l1.414-1.415 1.03 1.715Zm2.866-1.72L12.7 32.27l-1.029-1.716 2.866-1.72 1.03 1.716Zm-.614-4.363L16 29.38l-1.9.625-1.05-3.193 1.9-.625ZM11.12 24.5l3.192 1.05-.625 1.9-3.192-1.05.625-1.9ZM8.23 27.8l1.72-2.866 1.715 1.03-1.72 2.865-1.715-1.029Zm.301 2.443a2 2 0 0 1-.3-2.443l1.714 1.03-1.414 1.413Zm1.724 1.725-1.724-1.725 1.414-1.414 1.724 1.724-1.414 1.415Z",
                fill: "#F07EFF",
                mask: "url(#path-6-inside-3_1555_8784)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-8-inside-4_1555_8784",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M6 21.72a1 1 0 0 0 .757.97L10 23.5l1-3-1-3-3.243.81a1 1 0 0 0-.757.97v2.44Zm28 0a1 1 0 0 1-.758.97L30 23.5l-1-3 1-3 3.242.81a1 1 0 0 1 .758.97v2.44Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m6.757 22.69-.242.97.242-.97ZM10 23.5l-.243.97.899.225.293-.879L10 23.5Zm1-3 .949.316.105-.316-.105-.316L11 20.5Zm-1-3 .949-.316-.293-.879-.899.225.243.97Zm-3.243.81.243.97-.243-.97Zm26.485 4.38.243.97-.242-.97ZM30 23.5l-.949.316.293.879.898-.225L30 23.5Zm-1-3-.949-.316-.105.316.105.316L29 20.5Zm1-3 .242-.97-.898-.225-.293.879.949.316ZM7 21.72H5a2 2 0 0 0 1.515 1.94L7 21.72Zm3.242.81L7 21.72l-.485 1.94 3.242.81.486-1.94Zm-.19-2.346-1 3 1.897.632 1-3-1.898-.632Zm-1-2.368 1 3 1.897-.632-1-3-1.898.632ZM7 19.281l3.242-.81-.485-1.941-3.242.81L7 19.28Zm0 0-.485-1.94A2 2 0 0 0 5 19.28h2Zm0 2.438v-2.438H5v2.438h2Zm26.485 1.94A2 2 0 0 0 35 21.72h-2l.485 1.94Zm-3.242.811 3.242-.81L33 21.72l-3.242.81.485 1.94Zm-2.192-3.654 1 3 1.898-.632-1-3-1.898.632Zm1-3.632-1 3 1.898.632 1-3-1.898-.632Zm4.434.156-3.242-.81-.485 1.94 3.242.81.485-1.94ZM35 19.28a2 2 0 0 0-1.515-1.94L33 19.28h2Zm0 2.44v-2.44h-2v2.44h2Z",
                fill: "#F07EFF",
                mask: "url(#path-8-inside-4_1555_8784)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20 31.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11Zm0-4a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z",
                fill: "url(#paint0_linear_1555_8784)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M15 18.5h1v1h-1zM14 18.5h1v1h-1zM14 19.5h1v1h-1zM14 20.5h1v1h-1zM15 20.5h1v1h-1zM16 20.5h1v1h-1zM14 21.5h1v1h-1zM16 18.5h1v1h-1zM17 18.5h1v1h-1zM19 18.5h1v1h-1zM20 18.5h1v1h-1zM21 18.5h1v1h-1zM22 18.5h1v1h-1zM22 19.5h1v1h-1zM24 19.5h1v1h-1zM24 20.5h1v1h-1zM24 21.5h1v1h-1zM24 18.5h1v1h-1zM22 20.5h1v1h-1zM21 20.5h1v1h-1zM20 20.5h1v1h-1zM19 21.5h1v1h-1zM19 20.5h1v1h-1zM19 19.5h1v1h-1zM17 19.5h1v1h-1zM17 20.5h1v1h-1zM17 21.5h1v1h-1z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1555_8784",
                    x1: 7.193,
                    y1: 22.104,
                    x2: 32.587,
                    y2: 9.589,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#492EF3"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#CF69FF"
                        })
                    ]
                })
            })
        ]
    });
var $457ebd48361125e9$export$2e2bcd8739ae039 = $457ebd48361125e9$var$SvgApiResource;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $7529b38878187ba2$var$SvgFile = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M7.5 8.333h.833a.833.833 0 1 0 0-1.666H7.5a.833.833 0 1 0 0 1.666ZM7.5 10a.833.833 0 1 0 0 1.667h5a.833.833 0 1 0 0-1.667h-5Zm9.167-2.55a1.097 1.097 0 0 0-.05-.225V7.15a.893.893 0 0 0-.159-.233l-5-5a.892.892 0 0 0-.233-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H5.833a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5h8.334a2.5 2.5 0 0 0 2.5-2.5V7.45Zm-5-2.942 2.158 2.159H12.5a.833.833 0 0 1-.833-.834V4.508ZM15 15.833a.833.833 0 0 1-.833.834H5.833A.833.833 0 0 1 5 15.833V4.167a.833.833 0 0 1 .833-.834H10v2.5a2.5 2.5 0 0 0 2.5 2.5H15v7.5Zm-2.5-2.5h-5A.833.833 0 1 0 7.5 15h5a.833.833 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $7529b38878187ba2$export$2e2bcd8739ae039 = $7529b38878187ba2$var$SvgFile;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $0fad305167d7e141$var$SvgManagementApiResourceDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 10.654c0-.603 0-.905.117-1.148.103-.214.269-.395.478-.522.237-.145.552-.187 1.182-.273l8.984-1.222c.815-.11 1.223-.166 1.54-.049.278.103.51.294.657.54.167.28.167.671.167 1.453v16.884c0 .782 0 1.172-.167 1.453a1.276 1.276 0 0 1-.657.54c-.317.117-.725.061-1.54-.05L9.027 27.04c-.63-.086-.945-.128-1.182-.273a1.248 1.248 0 0 1-.478-.522c-.117-.243-.117-.545-.117-1.148V10.654Zm9.625 5.693c0-.184 0-.275.03-.348a.344.344 0 0 1 .126-.154c.062-.04.144-.049.307-.065l.732-.075c.192-.02.289-.03.363.007.065.031.12.086.153.156.039.08.039.188.039.405v3.204c0 .217 0 .325-.039.405a.335.335 0 0 1-.153.156c-.074.036-.17.026-.363.007l-.732-.075c-.163-.016-.245-.024-.307-.066a.344.344 0 0 1-.125-.153c-.031-.073-.031-.164-.031-.348v-3.056Zm5.97-6.785h-1.157v17.063h1.156c.668 0 1.001 0 1.256-.13.224-.115.406-.297.52-.522.13-.256.13-.59.13-1.259v-13.24c0-.67 0-1.004-.13-1.26a1.193 1.193 0 0 0-.52-.521c-.255-.13-.588-.13-1.256-.13Z",
                fill: "url(#paint0_linear_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-3-inside-1_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.319 19.5a.5.5 0 0 0-.485.379l-.441 1.764 1.607.536 1.607-.536-.44-1.764a.5.5 0 0 0-.486-.379h-1.362Zm0 15a.5.5 0 0 1-.485-.379l-.441-1.764L26 31.821l1.607.536-.44 1.764a.5.5 0 0 1-.486.379h-1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m24.834 19.879 77.611 19.403-77.611-19.403Zm-.441 1.764L-53.22 2.24l-17.967 71.87 70.28 23.427 25.299-75.894Zm1.607.536L.702 98.073 26 106.506l25.298-8.433L26 22.18Zm1.607-.536 25.298 75.894 70.281-23.426L105.219 2.24 27.607 21.643Zm-.44-1.764L104.776.476l-77.61 19.403ZM24.833 34.12l-77.612 19.403 77.612-19.403Zm-.441-1.764L-.905-43.537-71.186-20.11l17.968 71.87 77.61-19.403ZM26 31.821l25.298-75.894L26-52.506.702-44.073 26 31.82Zm1.607.536L105.22 51.76l17.967-71.87-70.28-23.428-25.299 75.895Zm-.44 1.764 77.61 19.403h.001L27.166 34.121Zm75.278 5.16C93.598 74.673 61.799 99.5 25.319 99.5v-160C-11.62-60.5-43.82-35.36-52.778.476l155.223 38.806Zm-.441 1.765.441-1.764L-52.777.476l-.442 1.764 155.223 38.806ZM51.298-53.716l-1.607-.536L-.905 97.538l1.607.535 50.596-151.79Zm-48.99-.536-1.606.536 50.596 151.79 1.607-.537L2.31-54.251Zm-52.753 93.534.44 1.764L105.22 2.24l-.442-1.764-155.222 38.806ZM26.68 99.5c-36.48 0-68.279-24.828-77.126-60.218L104.777.476C95.818-35.36 63.62-60.5 26.681-60.5v160Zm-1.362 0h1.362v-160h-1.362v160Zm-78.097-45.976C-43.818 89.36-11.62 114.5 25.32 114.5v-160c36.48 0 68.279 24.828 77.126 60.218L-52.777 53.524Zm-.44-1.764.44 1.764 155.223-38.806-.441-1.764L-53.218 51.76ZM.702-44.073l-1.607.535 50.596 151.79 1.607-.536L.702-44.074Zm52.203.535-1.607-.535L.702 107.716l1.607.536 50.596-151.79Zm51.873 97.062.441-1.764-155.223-38.806-.441 1.764 155.223 38.806ZM26.681 114.5c36.939 0 69.138-25.14 78.096-60.976L-50.445 14.718C-41.598-20.672-9.8-45.5 26.68-45.5v160Zm-1.362 0h1.362v-160h-1.362v160Z",
                fill: "#FAABFF",
                mask: "url(#path-3-inside-1_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-5-inside-2_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.215 22.178a.5.5 0 0 0-.075.611l.935 1.56 1.71-.563.563-1.71-1.56-.936a.5.5 0 0 0-.61.075l-.963.963Zm10.607 10.607a.5.5 0 0 1-.611.075l-1.56-.936.563-1.71 1.71-.563.936 1.56a.5.5 0 0 1-.075.61l-.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m20.14 22.789 68.6-41.16-68.6 41.16Zm.935 1.56-68.6 41.159 32.885 54.807 60.715-19.973-25-75.994Zm1.71-.563 25 75.993 38.371-12.623L98.78 48.785l-75.993-25Zm.563-1.71 75.994 24.999 19.973-60.715-54.807-32.884-41.16 68.6Zm-1.56-.936 41.16-68.6-41.16 68.6Zm8.423 11.72-41.16 68.599 41.16-68.6Zm-1.56-.936L-47.34 6.921l-19.977 60.717 54.81 32.886 41.16-68.6Zm.563-1.71L4.211-45.778l-38.366 12.623L-46.778 5.21l75.992 25.003Zm1.71-.563 68.6-41.16-32.886-54.809L5.922-46.34 30.924 29.65Zm.936 1.56 68.599-41.16-68.6 41.16Zm56.88-49.582c18.768 31.282 13.839 71.323-11.956 97.118L-36.355-34.39c-26.12 26.12-31.11 66.664-12.106 98.339l137.2-82.32Zm.935 1.56-.936-1.56L-48.46 63.95l.936 1.559 137.199-82.32Zm-91.89-35.397-1.71.563 50 151.987 1.71-.563-50-151.987Zm-50.43 49.284-.563 1.71L98.779 48.785l.563-1.71L-52.646-2.924Zm33.274 92.663 1.56.936L64.508-46.524l-1.56-.936-82.319 137.2Zm97.118-11.955C51.95 103.579 11.91 108.508-19.371 89.739L62.95-47.46c-31.675-19.005-72.22-14.013-98.34 12.107L77.748 77.784Zm-.963.963.963-.963L-35.391-35.354l-.963.964L76.784 78.747Zm-87.733 22.712c31.675 19.005 72.22 14.014 98.34-12.106L-25.748-23.784C.048-49.579 40.09-54.508 71.37-35.74L-10.949 101.46Zm-1.56-.935 1.56.935L71.371-35.74l-1.56-.935-82.32 137.199Zm-34.27-95.313-.562 1.71 151.985 50.007.563-1.71L-46.778 5.21Zm52.7-51.552-1.71.563 50.006 151.985 1.71-.563L5.922-46.341ZM100.46-9.95l-.935-1.56-137.2 82.32.937 1.56L100.459-9.95ZM88.353 88.39c26.12-26.12 31.111-66.664 12.106-98.339l-137.198 82.32C-55.51 41.088-50.58 1.047-24.784-24.748L88.353 88.39Zm-.963.963.963-.963L-24.784-24.747l-.963.963L87.39 89.353Z",
                fill: "#FAABFF",
                mask: "url(#path-5-inside-2_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-7-inside-3_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.785 22.178a.5.5 0 0 1 .075.611l-.935 1.56-1.71-.563-.563-1.71 1.56-.936a.5.5 0 0 1 .61.075l.963.963ZM21.178 32.785a.5.5 0 0 0 .611.075l1.56-.936-.563-1.71-1.71-.563-.936 1.56a.5.5 0 0 0 .075.61l.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m31.86 22.789-68.6-41.16 68.6 41.16Zm-.935 1.56 68.6 41.159-32.886 54.808-60.715-19.975 25-75.993Zm-1.71-.563L4.213 99.779l-38.369-12.623-12.623-38.369 75.993-25.001Zm-.563-1.71-75.993 25.001-19.976-60.716 54.81-32.885 41.159 68.6Zm1.56-.936-41.16-68.6 41.16 68.6Zm-8.423 11.72 41.16 68.599-41.16-68.6Zm1.56-.936 75.993-25 19.974 60.715-54.808 32.885-41.16-68.6Zm-.563-1.71 25.002-75.993 38.368 12.624L98.78 5.213 22.786 30.214Zm-1.71-.563-68.6-41.16 32.886-54.808 60.716 19.976L21.076 29.65Zm-.936 1.56-68.6-41.16 68.6 41.16Zm-56.88-49.582c-18.768 31.282-13.839 71.323 11.957 97.118L88.353-34.39c26.119 26.12 31.111 66.664 12.106 98.339l-137.2-82.32Zm-.935 1.56.936-1.56L100.46 63.95l-.936 1.559-137.199-82.32Zm91.89-35.397 1.71.563-50 151.986-1.711-.562L54.215-52.208Zm50.43 49.281.562 1.71-151.985 50.005-.563-1.71L104.645-2.928ZM71.371 89.74l-1.56.936-82.319-137.199 1.56-.936L71.37 89.74Zm-97.118-11.955C.05 103.579 40.09 108.508 71.371 89.739L-10.95-47.46c31.675-19.005 72.22-14.013 98.34 12.107L-25.748 77.784Zm.963.963-.963-.963L87.391-35.354l.963.964L-24.784 78.747Zm87.733 22.712c-31.675 19.005-72.22 14.014-98.34-12.106L77.748-23.784C51.952-49.579 11.91-54.508-19.37-35.74L62.949 101.46Zm1.56-.935-1.56.935-82.32-137.199 1.56-.935 82.32 137.199Zm34.27-95.31.563 1.71-151.987 50-.562-1.71 151.986-50ZM46.078-46.342l1.71.562-50.004 151.986-1.71-.563L46.078-46.341ZM-48.46-9.95l.935-1.56 137.2 82.32-.936 1.56-137.2-82.32Zm12.106 98.339C-62.473 62.27-67.464 21.726-48.46-9.949L88.74 72.371c18.768-31.282 13.839-71.323-11.956-97.118L-36.353 88.39Zm.963.963-.963-.963L76.784-24.747l.963.963L-35.39 89.353Z",
                fill: "#FAABFF",
                mask: "url(#path-7-inside-3_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-9-inside-4_8738_119575",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.5 27.68a.5.5 0 0 0 .379.485l1.764.441.536-1.607-.536-1.607-1.764.441a.5.5 0 0 0-.379.485v1.362Zm15 0a.5.5 0 0 1-.379.485l-1.764.441L30.821 27l.536-1.607 1.764.441a.5.5 0 0 1 .379.485v1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m18.879 28.165 19.403-77.611-19.403 77.611Zm1.764.441L1.24 106.218l71.87 17.967 23.427-70.28-75.894-25.299ZM21.179 27l75.894 25.299 8.433-25.299-8.433-25.298L21.18 27Zm-.536-1.607L96.537.094l-23.426-70.28L1.24-52.22l19.403 77.611Zm-1.764.441L-.524-51.778l19.403 77.611Zm14.242 2.332 19.403 77.612-19.403-77.612Zm-1.764.441-75.894 25.299 23.427 70.28 71.87-17.967-19.403-77.612ZM30.821 27-45.073 1.701l-8.433 25.298 8.433 25.299L30.82 26.999Zm.536-1.607L50.76-52.219l-71.87-17.968L-44.538.093l75.895 25.3Zm1.764.441 19.403-77.611-19.403 77.611Zm5.16-75.279C73.673-40.598 98.5-8.8 98.5 27.68h-160c0 36.94 25.14 69.138 60.976 78.097L38.282-49.446Zm1.765.441-1.764-.441L-.524 105.777l1.764.441L40.046-49.005ZM-54.716 1.701l-.536 1.607 151.79 50.597.535-1.608-151.79-50.596Zm-.536 48.99.536 1.606L97.074 1.702 96.536.094-55.251 50.69Zm93.534 52.754 1.764-.441L1.24-52.219l-1.764.44 38.806 155.224ZM98.5 26.318c0 36.48-24.828 68.279-60.218 77.127L-.524-51.778C-36.36-42.82-61.5-10.621-61.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Zm-45.976 78.097C88.36 96.817 113.5 64.619 113.5 27.68h-160c0-36.48 24.828-68.278 60.218-77.126l38.806 155.223Zm-1.764.441 1.764-.441L13.718-49.446l-1.764.441L50.76 106.218Zm-95.833-53.92.535 1.607 151.79-50.597-.536-1.607-151.79 50.597Zm.535-52.204-.535 1.607 151.789 50.597.536-1.608L-44.538.094Zm97.062-51.872-1.764-.441-38.806 155.223 1.764.441L52.524-51.778ZM113.5 26.318c0-36.939-25.14-69.137-60.976-78.096L13.718 103.445C-21.672 94.597-46.5 62.798-46.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Z",
                fill: "#FAABFF",
                mask: "url(#path-9-inside-4_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M31.893 27a5.893 5.893 0 1 1-11.786 0 5.893 5.893 0 0 1 11.786 0Z",
                fill: "url(#paint1_linear_8738_119575)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 26,
                cy: 26.999,
                r: 3.75,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.589 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.053 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.053 26.464h.536V27h-.536zM23.053 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M23.589 27h.536v.536h-.536zM24.125 27h.536v.536h-.536zM23.053 27.536h.536v.536h-.536zM24.125 25.929h.536v.536h-.536zM24.661 25.929h.536v.536h-.536zM25.732 25.929h.536v.536h-.536zM26.268 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.803 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M27.339 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M27.339 26.464h.536V27h-.536zM28.411 26.464h.536V27h-.536zM28.411 27h.536v.536h-.536zM28.411 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M28.411 25.929h.536v.536h-.536zM27.339 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.803 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#F7F8F8",
                d: "M26.268 27h.536v.536h-.536zM25.732 27.536h.536v.536h-.536zM25.732 27h.536v.536h-.536zM25.732 26.464h.536V27h-.536zM24.661 26.464h.536V27h-.536zM24.661 27h.536v.536h-.536zM24.661 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8738_119575",
                        x1: 1.833,
                        y1: 21.898,
                        x2: 23.389,
                        y2: 13.086,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8738_119575",
                        x1: 19.139,
                        y1: 27.859,
                        x2: 32.743,
                        y2: 21.154,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $0fad305167d7e141$export$2e2bcd8739ae039 = $0fad305167d7e141$var$SvgManagementApiResourceDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $3e3948c112d6cadd$var$SvgManagementApiResource = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M7.25 10.654c0-.603 0-.905.117-1.148.103-.214.269-.395.478-.522.237-.145.552-.187 1.182-.273l8.984-1.222c.815-.11 1.223-.166 1.54-.049.278.103.51.294.657.54.167.28.167.671.167 1.453v16.884c0 .782 0 1.172-.167 1.453a1.276 1.276 0 0 1-.657.54c-.317.117-.725.061-1.54-.05L9.027 27.04c-.63-.086-.945-.128-1.182-.273a1.248 1.248 0 0 1-.478-.522c-.117-.243-.117-.545-.117-1.148V10.654Zm9.625 5.693c0-.184 0-.275.03-.348a.344.344 0 0 1 .126-.154c.062-.04.144-.049.307-.065l.732-.075c.192-.02.289-.03.363.007.065.031.12.086.153.156.039.08.039.188.039.405v3.204c0 .217 0 .325-.039.405a.335.335 0 0 1-.153.156c-.074.036-.17.026-.363.007l-.732-.075c-.163-.016-.245-.024-.307-.066a.344.344 0 0 1-.125-.153c-.031-.073-.031-.164-.031-.348v-3.056Zm5.97-6.785h-1.157v17.063h1.156c.668 0 1.001 0 1.256-.13.224-.115.406-.297.52-.522.13-.256.13-.59.13-1.259v-13.24c0-.67 0-1.004-.13-1.26a1.193 1.193 0 0 0-.52-.521c-.255-.13-.588-.13-1.256-.13Z",
                fill: "url(#paint0_linear_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-3-inside-1_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M25.319 19.5a.5.5 0 0 0-.485.379l-.441 1.764 1.607.536 1.607-.536-.44-1.764a.5.5 0 0 0-.486-.379h-1.362Zm0 15a.5.5 0 0 1-.485-.379l-.441-1.764L26 31.821l1.607.536-.44 1.764a.5.5 0 0 1-.486.379h-1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m24.834 19.879 77.611 19.403-77.611-19.403Zm-.441 1.764L-53.22 2.24l-17.967 71.87 70.28 23.427 25.299-75.894Zm1.607.536L.702 98.073 26 106.506l25.298-8.433L26 22.18Zm1.607-.536 25.298 75.894 70.281-23.426L105.219 2.24 27.607 21.643Zm-.44-1.764L104.776.476l-77.61 19.403ZM24.833 34.12l-77.612 19.403 77.612-19.403Zm-.441-1.764L-.905-43.537-71.186-20.11l17.968 71.87 77.61-19.403ZM26 31.821l25.298-75.894L26-52.506.702-44.073 26 31.82Zm1.607.536L105.22 51.76l17.967-71.87-70.28-23.428-25.299 75.895Zm-.44 1.764 77.61 19.403h.001L27.166 34.121Zm75.278 5.16C93.598 74.673 61.799 99.5 25.319 99.5v-160C-11.62-60.5-43.82-35.36-52.778.476l155.223 38.806Zm-.441 1.765.441-1.764L-52.777.476l-.442 1.764 155.223 38.806ZM51.298-53.716l-1.607-.536L-.905 97.538l1.607.535 50.596-151.79Zm-48.99-.536-1.606.536 50.596 151.79 1.607-.537L2.31-54.251Zm-52.753 93.534.44 1.764L105.22 2.24l-.442-1.764-155.222 38.806ZM26.68 99.5c-36.48 0-68.279-24.828-77.126-60.218L104.777.476C95.818-35.36 63.62-60.5 26.681-60.5v160Zm-1.362 0h1.362v-160h-1.362v160Zm-78.097-45.976C-43.818 89.36-11.62 114.5 25.32 114.5v-160c36.48 0 68.279 24.828 77.126 60.218L-52.777 53.524Zm-.44-1.764.44 1.764 155.223-38.806-.441-1.764L-53.218 51.76ZM.702-44.073l-1.607.535 50.596 151.79 1.607-.536L.702-44.074Zm52.203.535-1.607-.535L.702 107.716l1.607.536 50.596-151.79Zm51.873 97.062.441-1.764-155.223-38.806-.441 1.764 155.223 38.806ZM26.681 114.5c36.939 0 69.138-25.14 78.096-60.976L-50.445 14.718C-41.598-20.672-9.8-45.5 26.68-45.5v160Zm-1.362 0h1.362v-160h-1.362v160Z",
                fill: "#F07EFF",
                mask: "url(#path-3-inside-1_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-5-inside-2_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M20.215 22.178a.5.5 0 0 0-.075.611l.935 1.56 1.71-.563.563-1.71-1.56-.936a.5.5 0 0 0-.61.075l-.963.963Zm10.607 10.607a.5.5 0 0 1-.611.075l-1.56-.936.563-1.71 1.71-.563.936 1.56a.5.5 0 0 1-.075.61l-.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m20.14 22.789 68.6-41.16-68.6 41.16Zm.075-.61-56.569-56.57 56.569 56.57Zm.86 2.17-68.6 41.159 32.885 54.807 60.715-19.973-25-75.994Zm1.71-.563 25 75.993 38.371-12.623L98.78 48.785l-75.993-25Zm.563-1.71 75.994 24.999 19.973-60.715-54.807-32.884-41.16 68.6Zm-1.56-.936 41.16-68.6-41.16 68.6Zm-.61.075 56.569 56.569-56.569-56.569Zm9.033 11.645-41.16 68.599 41.16-68.6Zm-1.56-.936L-47.34 6.921l-19.977 60.717 54.81 32.886 41.16-68.6Zm.563-1.71L4.211-45.778l-38.366 12.623L-46.778 5.21l75.992 25.003Zm1.71-.563 68.6-41.16-32.886-54.809L5.922-46.34 30.924 29.65Zm.936 1.56 68.599-41.16-68.6 41.16Zm56.88-49.582c18.768 31.282 13.839 71.323-11.956 97.118L-36.355-34.39c-26.12 26.12-31.11 66.664-12.106 98.339l137.2-82.32Zm.935 1.56-.936-1.56L-48.46 63.95l.936 1.559 137.199-82.32Zm-91.89-35.397-1.71.563 50 151.987 1.71-.563-50-151.987Zm-50.43 49.284-.563 1.71L98.779 48.785l.563-1.71L-52.646-2.924Zm33.274 92.663 1.56.936L64.508-46.524l-1.56-.936-82.319 137.2Zm97.118-11.955C51.95 103.579 11.91 108.508-19.371 89.739L62.95-47.46c-31.675-19.005-72.22-14.013-98.34 12.107L77.748 77.784Zm-.963.963.963-.963L-35.391-35.354l-.963.964L76.784 78.747Zm-87.733 22.712c31.675 19.005 72.22 14.014 98.34-12.106L-25.748-23.784C.048-49.579 40.09-54.508 71.37-35.74L-10.949 101.46Zm-1.56-.935 1.56.935L71.371-35.74l-1.56-.935-82.32 137.199Zm-34.27-95.313-.562 1.71 151.985 50.007.563-1.71L-46.778 5.21Zm52.7-51.552-1.71.563 50.006 151.985 1.71-.563L5.922-46.341ZM100.46-9.95l-.935-1.56-137.2 82.32.937 1.56L100.459-9.95ZM88.353 88.39c26.12-26.12 31.111-66.664 12.106-98.339l-137.198 82.32C-55.51 41.088-50.58 1.047-24.784-24.748L88.353 88.39Zm-.963.963.963-.963L-24.784-24.747l-.963.963L87.39 89.353Z",
                fill: "#F07EFF",
                mask: "url(#path-5-inside-2_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-7-inside-3_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M31.785 22.178a.5.5 0 0 1 .075.611l-.935 1.56-1.71-.563-.563-1.71 1.56-.936a.5.5 0 0 1 .61.075l.963.963ZM21.178 32.785a.5.5 0 0 0 .611.075l1.56-.936-.563-1.71-1.71-.563-.936 1.56a.5.5 0 0 0 .075.61l.963.964Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m31.86 22.789-68.6-41.16 68.6 41.16Zm-.075-.61 56.569-56.57-56.569 56.57Zm-.86 2.17 68.6 41.159-32.886 54.808-60.715-19.975 25-75.993Zm-1.71-.563L4.213 99.779l-38.369-12.623-12.623-38.369 75.993-25.001Zm-.563-1.71-75.993 25.001-19.976-60.716 54.81-32.885 41.159 68.6Zm1.56-.936-41.16-68.6 41.16 68.6Zm.61.075-56.569 56.569 56.569-56.569ZM21.789 32.86l41.16 68.599-41.16-68.6Zm1.56-.936 75.993-25 19.974 60.715-54.808 32.885-41.16-68.6Zm-.563-1.71 25.002-75.993 38.368 12.624L98.78 5.213 22.786 30.214Zm-1.71-.563-68.6-41.16 32.886-54.808 60.716 19.976L21.076 29.65Zm-.936 1.56-68.6-41.16 68.6 41.16Zm-56.88-49.582c-18.768 31.282-13.839 71.323 11.957 97.118L88.353-34.39c26.119 26.12 31.111 66.664 12.106 98.339l-137.2-82.32Zm-.935 1.56.936-1.56L100.46 63.95l-.936 1.559-137.199-82.32Zm91.89-35.397 1.71.563-50 151.986-1.711-.562L54.215-52.208Zm50.43 49.281.562 1.71-151.985 50.005-.563-1.71L104.645-2.928ZM71.371 89.74l-1.56.936-82.319-137.199 1.56-.936L71.37 89.74Zm-97.118-11.955C.05 103.579 40.09 108.508 71.371 89.739L-10.95-47.46c31.675-19.005 72.22-14.013 98.34 12.107L-25.748 77.784Zm.963.963-.963-.963L87.391-35.354l.963.964L-24.784 78.747Zm87.733 22.712c-31.675 19.005-72.22 14.014-98.34-12.106L77.748-23.784C51.952-49.579 11.91-54.508-19.37-35.74L62.949 101.46Zm1.56-.935-1.56.935-82.32-137.199 1.56-.935 82.32 137.199Zm34.27-95.31.563 1.71-151.987 50-.562-1.71 151.986-50ZM46.078-46.342l1.71.562-50.004 151.986-1.71-.563L46.078-46.341ZM-48.46-9.95l.935-1.56 137.2 82.32-.936 1.56-137.2-82.32Zm12.106 98.339C-62.473 62.27-67.464 21.726-48.46-9.949L88.74 72.371c18.768-31.282 13.839-71.323-11.956-97.118L-36.353 88.39Zm.963.963-.963-.963L76.784-24.747l.963.963L-35.39 89.353Z",
                fill: "#F07EFF",
                mask: "url(#path-7-inside-3_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "path-9-inside-4_8738_113352",
                fill: "#fff",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M18.5 27.68a.5.5 0 0 0 .379.485l1.764.441.536-1.607-.536-1.607-1.764.441a.5.5 0 0 0-.379.485v1.362Zm15 0a.5.5 0 0 1-.379.485l-1.764.441L30.821 27l.536-1.607 1.764.441a.5.5 0 0 1 .379.485v1.362Z"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m18.879 28.165 19.403-77.611-19.403 77.611Zm1.764.441L1.24 106.218l71.87 17.967 23.427-70.28-75.894-25.299ZM21.179 27l75.894 25.299 8.433-25.299-8.433-25.298L21.18 27Zm-.536-1.607L96.537.094l-23.426-70.28L1.24-52.22l19.403 77.611Zm-1.764.441L-.524-51.778l19.403 77.611Zm14.242 2.332 19.403 77.612-19.403-77.612Zm-1.764.441-75.894 25.299 23.427 70.28 71.87-17.967-19.403-77.612ZM30.821 27-45.073 1.701l-8.433 25.298 8.433 25.299L30.82 26.999Zm.536-1.607L50.76-52.219l-71.87-17.968L-44.538.093l75.895 25.3Zm1.764.441 19.403-77.611-19.403 77.611Zm5.16-75.279C73.673-40.598 98.5-8.8 98.5 27.68h-160c0 36.94 25.14 69.138 60.976 78.097L38.282-49.446Zm1.765.441-1.764-.441L-.524 105.777l1.764.441L40.046-49.005ZM-54.716 1.701l-.536 1.607 151.79 50.597.535-1.608-151.79-50.596Zm-.536 48.99.536 1.606L97.074 1.702 96.536.094-55.251 50.69Zm93.534 52.754 1.764-.441L1.24-52.219l-1.764.44 38.806 155.224ZM98.5 26.318c0 36.48-24.828 68.279-60.218 77.127L-.524-51.778C-36.36-42.82-61.5-10.621-61.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Zm-45.976 78.097C88.36 96.817 113.5 64.619 113.5 27.68h-160c0-36.48 24.828-68.278 60.218-77.126l38.806 155.223Zm-1.764.441 1.764-.441L13.718-49.446l-1.764.441L50.76 106.218Zm-95.833-53.92.535 1.607 151.79-50.597-.536-1.607-151.79 50.597Zm.535-52.204-.535 1.607 151.789 50.597.536-1.608L-44.538.094Zm97.062-51.872-1.764-.441-38.806 155.223 1.764.441L52.524-51.778ZM113.5 26.318c0-36.939-25.14-69.137-60.976-78.096L13.718 103.445C-21.672 94.597-46.5 62.798-46.5 26.318h160Zm0 1.362v-1.362h-160v1.362h160Z",
                fill: "#F07EFF",
                mask: "url(#path-9-inside-4_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M31.893 27a5.893 5.893 0 1 1-11.786 0 5.893 5.893 0 0 1 11.786 0Z",
                fill: "url(#paint1_linear_8738_113352)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 26,
                cy: 26.999,
                r: 3.75,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.589 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.053 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.053 26.464h.536V27h-.536zM23.053 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M23.589 27h.536v.536h-.536zM24.125 27h.536v.536h-.536zM23.053 27.536h.536v.536h-.536zM24.125 25.929h.536v.536h-.536zM24.661 25.929h.536v.536h-.536zM25.732 25.929h.536v.536h-.536zM26.268 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.803 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M27.339 25.929h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M27.339 26.464h.536V27h-.536zM28.411 26.464h.536V27h-.536zM28.411 27h.536v.536h-.536zM28.411 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M28.411 25.929h.536v.536h-.536zM27.339 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.803 27h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#1B1B22",
                d: "M26.268 27h.536v.536h-.536zM25.732 27.536h.536v.536h-.536zM25.732 27h.536v.536h-.536zM25.732 26.464h.536V27h-.536zM24.661 26.464h.536V27h-.536zM24.661 27h.536v.536h-.536zM24.661 27.536h.536v.536h-.536z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8738_113352",
                        x1: 1.833,
                        y1: 21.898,
                        x2: 23.389,
                        y2: 13.086,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#4B2EFB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E65FFC"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8738_113352",
                        x1: 19.139,
                        y1: 27.859,
                        x2: 32.743,
                        y2: 21.154,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $3e3948c112d6cadd$export$2e2bcd8739ae039 = $3e3948c112d6cadd$var$SvgManagementApiResource;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $27acfe1341419091$var$SvgBack = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 -2 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10.357 13.656 4.7 8l5.657-5.657.943.943L6.585 8l4.715 4.714-.943.942Z",
            fill: "currentColor"
        })
    });
var $27acfe1341419091$export$2e2bcd8739ae039 = $27acfe1341419091$var$SvgBack;



var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $9fbe619fa1af843c$var$SvgRequestErrorDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_5321_35616",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 58,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 58,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12.191,
                    fill: "#928F9A"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H58v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M101.686 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L118.657 136l5.658-5.657a4 4 0 0 0-5.657-5.657L113 130.344l-5.657-5.658a4 4 0 0 0-5.657 0ZM149.686 124.686a4 4 0 0 0 0 5.657l5.657 5.657-5.656 5.657a4 4 0 1 0 5.657 5.656l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.656L166.657 136l5.658-5.657a4 4 0 0 0-5.657-5.657L161 130.344l-5.657-5.658a4 4 0 0 0-5.657 0Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 72,
                cy: 82,
                r: 2,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 82,
                cy: 82,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 92,
                cy: 82,
                r: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 74,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 74,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 172,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 92,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 146,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 159,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask1_5321_35616",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 25,
                y: 93,
                width: 92,
                height: 99,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M116 98.5V94H25.5v97.5H63c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff",
                    stroke: "#F7F8F8",
                    strokeOpacity: 0.16,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask1_5321_35616)",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "m-4 90 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 90M-4 94l4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L124 94M-4 98l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.917 8.917 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0l3.996-2M-4 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 102M-4 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 106M-4 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 110M-4 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 114M-4 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 118M-4 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 122M-4 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 126M-4 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 130M-4 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 134M-4 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 138M-4 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 142M-4 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 146M-4 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 150M-4 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 154M-4 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 158M-4 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 162M-4 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 166M-4 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 170M-4 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 174M-4 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 178M-4 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 182M-4 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 186M-4 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L124 190"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167.453,
                y: 52,
                width: 24,
                height: 24,
                rx: 4,
                transform: "rotate(50.249 167.453 52)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M205.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M194 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M76.305 53.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 75,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#CABEFF",
                fillOpacity: 0.12
            })
        ]
    });
var $9fbe619fa1af843c$export$2e2bcd8739ae039 = $9fbe619fa1af843c$var$SvgRequestErrorDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d002392bb0267558$var$SvgRequestError = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 57,
                y: 74,
                width: 140,
                height: 108,
                rx: 12,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_5318_34653",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 57,
                y: 74,
                width: 140,
                height: 108,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                    x: 57,
                    y: 74,
                    width: 140,
                    height: 108,
                    rx: 12,
                    fill: "#D5CFF1"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M57 86c0-6.627 5.373-12 12-12h116c6.627 0 12 5.373 12 12v4H57v-4Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M100.686 124.687a3.999 3.999 0 0 0 0 5.656l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L112 130.344l-5.657-5.657a3.999 3.999 0 0 0-5.657 0ZM148.686 124.687a4 4 0 0 0 0 5.656l5.657 5.658-5.656 5.656a4 4 0 0 0 5.657 5.657l5.656-5.656 5.656 5.656a4 4 0 0 0 5.657-5.657l-5.656-5.656 5.658-5.658a4 4 0 0 0-5.657-5.657L160 130.344l-5.657-5.657a3.999 3.999 0 0 0-5.657 0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 71,
                cy: 82,
                r: 2,
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 81,
                cy: 82,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 91,
                cy: 82,
                r: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 73,
                y: 102,
                width: 64,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 73,
                y: 109,
                width: 14,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 171,
                y: 109,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 91,
                y: 109,
                width: 74,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 145,
                y: 102,
                width: 10,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 158,
                y: 102,
                width: 23,
                height: 4,
                rx: 2,
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask1_5318_34653",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 24,
                y: 94,
                width: 91,
                height: 98,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M115 98.5V94H24.5v97.5H62c13.255 0 24-10.745 24-24v-40c0-8.008 6.492-14.5 14.5-14.5s14.5-6.492 14.5-14.5Z",
                    fill: "#fff"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask1_5318_34653)",
                stroke: "#C9C5D0",
                strokeWidth: 0.8,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "m-5 94 4 2a8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.03 9.03 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.693 8.693 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.984 8.984 0 0 0 7.999 0 8.92 8.92 0 0 1 7.991-.002 8.917 8.917 0 0 0 7.985 0L123 94M-5 98l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.15a8.692 8.692 0 0 1 7.777.082 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.027 9.027 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.917 8.917 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0l3.996-2M-5 102l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 102M-5 106l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 106M-5 110l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 110M-5 114l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 114M-5 118l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 118M-5 122l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 122M-5 126l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 126M-5 130l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 130M-5 134l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 134M-5 138l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 138M-5 142l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 142M-5 146l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 146M-5 150l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 150M-5 154l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 154M-5 158l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 158M-5 162l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 162M-5 166l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 166M-5 170l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 170M-5 174l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 174M-5 178l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 178M-5 182l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 182M-5 186l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 186M-5 190l4 2a8.944 8.944 0 0 0 8 0 8.945 8.945 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.944 8.944 0 0 1 8 0 8.944 8.944 0 0 0 8 0 8.972 8.972 0 0 1 8.013.007 9.034 9.034 0 0 0 7.981.048l.31-.151a8.693 8.693 0 0 1 7.777.083 8.692 8.692 0 0 0 7.86.043l.086-.043a8.912 8.912 0 0 1 7.96.006 8.98 8.98 0 0 0 8.016.006 9.025 9.025 0 0 1 8.026.004 8.987 8.987 0 0 0 7.999.001 8.92 8.92 0 0 1 7.991-.003 8.92 8.92 0 0 0 7.985 0L123 190"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 166.453,
                y: 52,
                width: 24,
                height: 24,
                rx: 6,
                transform: "rotate(50.249 166.453 52)",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M204.914 28.209a.21.21 0 0 1 .209-.209h3.755a.21.21 0 0 1 .209.209v6.608l5.723-3.304a.209.209 0 0 1 .285.076l1.877 3.252c.058.1.024.228-.076.285l-5.724 3.305 5.724 3.304a.209.209 0 0 1 .076.285l-1.878 3.252a.208.208 0 0 1-.284.076l-5.723-3.304v6.609a.21.21 0 0 1-.209.208h-3.755a.21.21 0 0 1-.209-.208v-6.61l-5.723 3.305a.208.208 0 0 1-.285-.076l-1.878-3.252a.21.21 0 0 1 .077-.285l5.723-3.304-5.724-3.305a.209.209 0 0 1-.076-.285l1.878-3.252a.208.208 0 0 1 .284-.076l5.724 3.305v-6.61Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M31 53a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm0-4a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M193 190c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12Zm0-6a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z",
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M75.305 53.602c-1.066-2.889 1.395-5.848 4.43-5.327l4.552.783c3.035.521 4.367 4.132 2.398 6.5l-2.953 3.55c-1.97 2.368-5.763 1.716-6.829-1.173l-1.598-4.333Z",
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 74,
                y: 220,
                width: 80,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 166,
                y: 220,
                width: 19,
                height: 4,
                rx: 2,
                fill: "#C9C5D0"
            })
        ]
    });
var $d002392bb0267558$export$2e2bcd8739ae039 = $d002392bb0267558$var$SvgRequestError;



var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $93h5F = parcelRequire("93h5F");
var $6fa5539513415b49$export$a7db06668cad9adb;
var $6fa5539513415b49$export$a3bc9b8ed74fc;
var $6fa5539513415b49$export$5c452ff88e35e47d;
var $6fa5539513415b49$export$bfd64c937657f93a;
var $6fa5539513415b49$export$4a6dd88bada4e7d2;
var $6fa5539513415b49$export$fb184b623420d9be;
$6fa5539513415b49$export$a7db06668cad9adb = `_60TtZq_content`;
$6fa5539513415b49$export$a3bc9b8ed74fc = `_60TtZq_error`;
$6fa5539513415b49$export$5c452ff88e35e47d = `_60TtZq_image`;
$6fa5539513415b49$export$bfd64c937657f93a = `_60TtZq_rotating`;
$6fa5539513415b49$export$4a6dd88bada4e7d2 = `_60TtZq_shimmer`;
$6fa5539513415b49$export$fb184b623420d9be = `_60TtZq_title`;


function $45d431f1843a1407$var$RequestDataError({ error: error, onRetry: onRetry, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const errorMessage = error.body?.message ?? error.message;
    const isNotFoundError = error.status === 404;
    const ErrorImage = theme === (0, $bhvxB.Theme).Light ? (0, $d002392bb0267558$export$2e2bcd8739ae039) : (0, $9fbe619fa1af843c$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($6fa5539513415b49$export$a3bc9b8ed74fc, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(ErrorImage, {
                className: $6fa5539513415b49$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6fa5539513415b49$export$fb184b623420d9be,
                children: t(isNotFoundError ? "errors.not_found" : "errors.something_went_wrong")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6fa5539513415b49$export$a7db06668cad9adb,
                children: errorMessage
            }),
            onRetry && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: "general.retry",
                onClick: onRetry
            })
        ]
    });
}
var $45d431f1843a1407$export$2e2bcd8739ae039 = $45d431f1843a1407$var$RequestDataError;



var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");

var $9zeGj = parcelRequire("9zeGj");

var $1UQTm = parcelRequire("1UQTm");
var $3e9a366406443d81$export$34e0f9847d4c02dd;
var $3e9a366406443d81$export$6210fa4921d2a466;
var $3e9a366406443d81$export$a279c5c553241f38;
var $3e9a366406443d81$export$5e54b446970e67c0;
var $3e9a366406443d81$export$bfd64c937657f93a;
var $3e9a366406443d81$export$4a6dd88bada4e7d2;
$3e9a366406443d81$export$34e0f9847d4c02dd = `K4QE8a_container`;
$3e9a366406443d81$export$6210fa4921d2a466 = `K4QE8a_form`;
$3e9a366406443d81$export$a279c5c553241f38 = `K4QE8a_introduction`;
$3e9a366406443d81$export$5e54b446970e67c0 = `K4QE8a_responsiveWrapper`;
$3e9a366406443d81$export$bfd64c937657f93a = `K4QE8a_rotating`;
$3e9a366406443d81$export$4a6dd88bada4e7d2 = `K4QE8a_shimmer`;


function $23b70c1b51441b27$var$FormCardLayout({ introduction: introduction, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $3e9a366406443d81$export$5e54b446970e67c0,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
            className: $3e9a366406443d81$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $3e9a366406443d81$export$a279c5c553241f38,
                    children: introduction
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $3e9a366406443d81$export$6210fa4921d2a466,
                    children: children
                })
            ]
        })
    });
}
var $23b70c1b51441b27$export$2e2bcd8739ae039 = $23b70c1b51441b27$var$FormCardLayout;


var $e4a52bff8727bafb$export$6d59db4903f20f7d;
var $e4a52bff8727bafb$export$bfd64c937657f93a;
var $e4a52bff8727bafb$export$4a6dd88bada4e7d2;
var $e4a52bff8727bafb$export$fb184b623420d9be;
$e4a52bff8727bafb$export$6d59db4903f20f7d = `-TV4Uq_description`;
$e4a52bff8727bafb$export$bfd64c937657f93a = `-TV4Uq_rotating`;
$e4a52bff8727bafb$export$4a6dd88bada4e7d2 = `-TV4Uq_shimmer`;
$e4a52bff8727bafb$export$fb184b623420d9be = `-TV4Uq_title`;



var $9zeGj = parcelRequire("9zeGj");

var $d8804e894bb53045$export$e0f35d825088c098;
var $d8804e894bb53045$export$bfd64c937657f93a;
var $d8804e894bb53045$export$4a6dd88bada4e7d2;
var $d8804e894bb53045$export$6f093cfa640b7166;
var $d8804e894bb53045$export$fb184b623420d9be;
$d8804e894bb53045$export$e0f35d825088c098 = `iExUWa_field`;
$d8804e894bb53045$export$bfd64c937657f93a = `iExUWa_rotating`;
$d8804e894bb53045$export$4a6dd88bada4e7d2 = `iExUWa_shimmer`;
$d8804e894bb53045$export$4a6dd88bada4e7d2;
$d8804e894bb53045$export$6f093cfa640b7166 = `iExUWa_text`;
$d8804e894bb53045$export$fb184b623420d9be = `iExUWa_title`;


function $354ce2d22530b458$var$Skeleton({ formFieldCount: formFieldCount = 4 }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b70c1b51441b27$export$2e2bcd8739ae039), {
        introduction: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $d8804e894bb53045$export$fb184b623420d9be
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    children: Array.from({
                        length: 2
                    }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $d8804e894bb53045$export$6f093cfa640b7166
                        }, index))
                })
            ]
        }),
        children: Array.from({
            length: formFieldCount
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d8804e894bb53045$export$e0f35d825088c098
            }, index))
    });
}
var $354ce2d22530b458$export$2e2bcd8739ae039 = $354ce2d22530b458$var$Skeleton;


function $3e994d6132d55b2e$var$FormCard({ title: title, tag: tag, description: description, descriptionInterpolation: descriptionInterpolation, learnMoreLink: learnMoreLink, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b70c1b51441b27$export$2e2bcd8739ae039), {
        introduction: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $e4a52bff8727bafb$export$fb184b623420d9be,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: title
                        }),
                        tag
                    ]
                }),
                description && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $e4a52bff8727bafb$export$6d59db4903f20f7d,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: description,
                            interpolation: descriptionInterpolation
                        }),
                        learnMoreLink?.href && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                            children: [
                                " ",
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                    href: learnMoreLink.href,
                                    targetBlank: learnMoreLink.targetBlank,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                        forKey: learnMoreLink.linkText ?? "general.learn_more"
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        }),
        children: children
    });
}
var $3e994d6132d55b2e$export$2e2bcd8739ae039 = $3e994d6132d55b2e$var$FormCard;



var $3MzPh = parcelRequire("3MzPh");
var $d19e00f4ae79c695$export$2ba01fb71ed41cb6;
var $d19e00f4ae79c695$export$34e0f9847d4c02dd;
var $d19e00f4ae79c695$export$38e42c68cf43b5d4;
var $d19e00f4ae79c695$export$1ca1ec8b29a4ce27;
var $d19e00f4ae79c695$export$bfd64c937657f93a;
var $d19e00f4ae79c695$export$4a6dd88bada4e7d2;
var $d19e00f4ae79c695$export$1261a644c63cbc91;
var $d19e00f4ae79c695$export$8b7a896ae75accbf;
var $d19e00f4ae79c695$export$fb184b623420d9be;
var $d19e00f4ae79c695$export$cc74dcc53cfce4eb;
$d19e00f4ae79c695$export$2ba01fb71ed41cb6 = `_V32qG_button`;
$d19e00f4ae79c695$export$34e0f9847d4c02dd = `_V32qG_container`;
$d19e00f4ae79c695$export$38e42c68cf43b5d4 = `_V32qG_header`;
$d19e00f4ae79c695$export$1ca1ec8b29a4ce27 = `_V32qG_icon`;
$d19e00f4ae79c695$export$bfd64c937657f93a = `_V32qG_rotating`;
$d19e00f4ae79c695$export$4a6dd88bada4e7d2 = `_V32qG_shimmer`;
$d19e00f4ae79c695$export$4a6dd88bada4e7d2;
$d19e00f4ae79c695$export$1261a644c63cbc91 = `_V32qG_tabBar`;
$d19e00f4ae79c695$export$8b7a896ae75accbf = `_V32qG_tags`;
$d19e00f4ae79c695$export$fb184b623420d9be = `_V32qG_title`;
$d19e00f4ae79c695$export$cc74dcc53cfce4eb = `_V32qG_wrapper`;


function $3f9b15e0b0084c45$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d19e00f4ae79c695$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $d19e00f4ae79c695$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $d19e00f4ae79c695$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $d19e00f4ae79c695$export$cc74dcc53cfce4eb,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $d19e00f4ae79c695$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $d19e00f4ae79c695$export$8b7a896ae75accbf
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $d19e00f4ae79c695$export$2ba01fb71ed41cb6
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d19e00f4ae79c695$export$1261a644c63cbc91
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $354ce2d22530b458$export$2e2bcd8739ae039), {})
        ]
    });
}
var $3f9b15e0b0084c45$export$2e2bcd8739ae039 = $3f9b15e0b0084c45$var$Skeleton;


var $7ed53a85d4bbd421$export$3e2b3ca194606303;
var $7ed53a85d4bbd421$export$34e0f9847d4c02dd;
var $7ed53a85d4bbd421$export$bfd64c937657f93a;
var $7ed53a85d4bbd421$export$4a6dd88bada4e7d2;
$7ed53a85d4bbd421$export$3e2b3ca194606303 = `_1JPFKW_backLink`;
$7ed53a85d4bbd421$export$34e0f9847d4c02dd = `_1JPFKW_container`;
$7ed53a85d4bbd421$export$bfd64c937657f93a = `_1JPFKW_rotating`;
$7ed53a85d4bbd421$export$4a6dd88bada4e7d2 = `_1JPFKW_shimmer`;


function $c295648577aecb91$var$DetailsPage({ backLink: backLink, backLinkTitle: backLinkTitle, isLoading: isLoading, error: error, onRetry: onRetry, children: children, className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7ed53a85d4bbd421$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                to: backLink,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $27acfe1341419091$export$2e2bcd8739ae039), {}),
                className: $7ed53a85d4bbd421$export$3e2b3ca194606303,
                children: typeof backLinkTitle === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: backLinkTitle
                }) : backLinkTitle
            }),
            isLoading ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3f9b15e0b0084c45$export$2e2bcd8739ae039), {}) : error ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $45d431f1843a1407$export$2e2bcd8739ae039), {
                error: error,
                onRetry: onRetry
            }) : children
        ]
    });
}
var $c295648577aecb91$export$2e2bcd8739ae039 = $c295648577aecb91$var$DetailsPage;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $c8927b9279b58d6c$var$SvgMore = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 5.833A1.667 1.667 0 1 0 10 2.5a1.667 1.667 0 0 0 0 3.333Zm0 8.334a1.666 1.666 0 1 0 0 3.332 1.666 1.666 0 0 0 0-3.332Zm0-5.834a1.667 1.667 0 1 0 0 3.334 1.667 1.667 0 0 0 0-3.334Z",
            fill: "currentColor"
        })
    });
var $c8927b9279b58d6c$export$2e2bcd8739ae039 = $c8927b9279b58d6c$var$SvgMore;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");


var $9bgsA = parcelRequire("9bgsA");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $kcPww = parcelRequire("kcPww");
const $920cbd925ef2fde6$var$ActionMenuButton = /*#__PURE__*/ (0, $eCoWV.forwardRef)((props, anchorReference)=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ref: anchorReference,
        style: {
            display: "inline-block"
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
            ...props
        })
    }));
var $920cbd925ef2fde6$export$2e2bcd8739ae039 = $920cbd925ef2fde6$var$ActionMenuButton;


var $23af878c19d0d5c3$export$a7db06668cad9adb;
var $23af878c19d0d5c3$export$22711916b0c9a0b1;
var $23af878c19d0d5c3$export$bfd64c937657f93a;
var $23af878c19d0d5c3$export$4a6dd88bada4e7d2;
$23af878c19d0d5c3$export$a7db06668cad9adb = `sE9p8W_content`;
$23af878c19d0d5c3$export$22711916b0c9a0b1 = `sE9p8W_dropdownTitle`;
$23af878c19d0d5c3$export$bfd64c937657f93a = `sE9p8W_rotating`;
$23af878c19d0d5c3$export$4a6dd88bada4e7d2 = `sE9p8W_shimmer`;



/**
 * A button that can be used to open and close a dropdown menu.
 *
 * @param props If `buttonProps` is provided, the button will be rendered using the `ActionMenuButton`
 * component. Otherwise, `icon` will be required to render the button using the `IconButton`
 * component.
 * @see {@link ActionMenuButton} for the list of props that can be passed to the button.
 * @see {@link IconButton} for how the button will be rendered if `icon` is provided.
 */ function $bcb314c46a8bc4c1$var$ActionMenu(props) {
    const { children: children, title: title, dropdownHorizontalAlign: dropdownHorizontalAlign, dropdownClassName: dropdownClassName, isDropdownFullWidth: isDropdownFullWidth = false } = props;
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    const anchorReference = (0, $eCoWV.useRef)(null);
    const hasButtonProps = "buttonProps" in props;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            hasButtonProps && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $920cbd925ef2fde6$export$2e2bcd8739ae039), {
                ...props.buttonProps,
                ref: anchorReference,
                onClick: ()=>{
                    setIsOpen(true);
                }
            }),
            !hasButtonProps && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                ref: anchorReference,
                onClick: ()=>{
                    setIsOpen(true);
                },
                children: props.icon
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                title: title,
                titleClassName: $23af878c19d0d5c3$export$22711916b0c9a0b1,
                anchorRef: anchorReference,
                isOpen: isOpen,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($23af878c19d0d5c3$export$a7db06668cad9adb, dropdownClassName),
                horizontalAlign: dropdownHorizontalAlign,
                isFullWidth: isDropdownFullWidth,
                onClose: ()=>{
                    setIsOpen(false);
                },
                children: children
            })
        ]
    });
}
var $bcb314c46a8bc4c1$export$2e2bcd8739ae039 = $bcb314c46a8bc4c1$var$ActionMenu;



var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");


var $eCoWV = parcelRequire("eCoWV");
const $c0b37dd2da18e290$var$useWindowResize = (callback)=>{
    const callbackRef = (0, $eCoWV.useRef)(callback);
    (0, $eCoWV.useEffect)(()=>{
        // eslint-disable-next-line @silverhand/fp/no-mutation
        callbackRef.current = callback;
    }, [
        callback
    ]);
    (0, $eCoWV.useLayoutEffect)(()=>{
        const handler = (event)=>{
            callbackRef.current(event);
        };
        handler();
        window.addEventListener("resize", handler);
        return ()=>{
            window.removeEventListener("resize", handler);
        };
    }, []);
};
var $c0b37dd2da18e290$export$2e2bcd8739ae039 = $c0b37dd2da18e290$var$useWindowResize;


var $75549c043e3c1ad6$export$201c1586e0f2a1e0;
var $75549c043e3c1ad6$export$38e42c68cf43b5d4;
var $75549c043e3c1ad6$export$1ca1ec8b29a4ce27;
var $75549c043e3c1ad6$export$dbb5e893e736e4ee;
var $75549c043e3c1ad6$export$a8ff84c12d48cfa6;
var $75549c043e3c1ad6$export$59894c102379d64a;
var $75549c043e3c1ad6$export$bfd64c937657f93a;
var $75549c043e3c1ad6$export$120ff0929b202a6d;
var $75549c043e3c1ad6$export$4a6dd88bada4e7d2;
var $75549c043e3c1ad6$export$6f093cfa640b7166;
var $75549c043e3c1ad6$export$d999e528e771887b;
$75549c043e3c1ad6$export$201c1586e0f2a1e0 = `ReARlW_copyId`;
$75549c043e3c1ad6$export$38e42c68cf43b5d4 = `ReARlW_header`;
$75549c043e3c1ad6$export$1ca1ec8b29a4ce27 = `ReARlW_icon`;
$75549c043e3c1ad6$export$dbb5e893e736e4ee = `ReARlW_metadata`;
$75549c043e3c1ad6$export$a8ff84c12d48cfa6 = `ReARlW_name`;
$75549c043e3c1ad6$export$59894c102379d64a = `ReARlW_operations`;
$75549c043e3c1ad6$export$bfd64c937657f93a = `ReARlW_rotating`;
$75549c043e3c1ad6$export$120ff0929b202a6d = `ReARlW_row`;
$75549c043e3c1ad6$export$4a6dd88bada4e7d2 = `ReARlW_shimmer`;
$75549c043e3c1ad6$export$6f093cfa640b7166 = `ReARlW_text`;
$75549c043e3c1ad6$export$d999e528e771887b = `ReARlW_verticalBar`;


function $84892818f27475db$var$DetailsPageHeader({ icon: icon, title: title, subtitle: subtitle, primaryTag: primaryTag, statusTag: statusTag, identifier: identifier, additionalActionButton: additionalActionButton, additionalCustomElement: additionalCustomElement, actionMenuItems: actionMenuItems }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [showIcon, setShowIcon] = (0, $eCoWV.useState)(true);
    const [isCompact, setIsCompact] = (0, $eCoWV.useState)(false);
    const [showAdditionalCustomElement, setShowAdditionalCustomElement] = (0, $eCoWV.useState)(true);
    const identifierRef = (0, $eCoWV.useRef)(null);
    const operationRef = (0, $eCoWV.useRef)(null);
    (0, $c0b37dd2da18e290$export$2e2bcd8739ae039)(()=>{
        if (!identifierRef.current || !operationRef.current) return;
        // Dynamically handle the visibility of the icon and action button styles. Sources:
        // https://www.figma.com/file/hqAWH3Di8gkiV5TXAt6juO/%F0%9F%8C%B9-%5BAC%5D-Layout-UI-Optimization?type=design&node-id=896-75673
        const { right: identifierRightEdge, width: identifierWidth } = identifierRef.current.getBoundingClientRect();
        const operationLeftEdge = operationRef.current.getBoundingClientRect().left;
        // When the operation buttons are in regular form, and the gap between the operation area and the identifier copy box is
        // only 24px. This means the window is shrinking and reaching the 1st breakpoint. Set operation buttons to compact form.
        if (!isCompact && operationLeftEdge - identifierRightEdge <= 24) setIsCompact(true);
        // When the operation buttons are compact, and the gap between the operation area and the identifier copy box is only 24px.
        // This means the window keeps shrinking and reaching the 2nd breakpoint. Hide the main icon on the very left.
        if (isCompact && showIcon && operationLeftEdge - identifierRightEdge <= 24) setShowIcon(false);
        // When the identifier copy box is 50px, and the gap between the operation area and the identifier copy box is only 24px.
        // This is when the page header is extremely narrow and barely has space to hold the identifier. Hide the additional custom element.
        if (identifierWidth <= 50 && operationLeftEdge - identifierRightEdge <= 24) setShowAdditionalCustomElement(false);
        // When the gap between the operation buttons and the identifier copy box is greater than 80px, show the additional custom element.
        if (!showAdditionalCustomElement && operationLeftEdge - identifierRightEdge > 80) setShowAdditionalCustomElement(true);
        // When the operation buttons are compact, icon is hidden, and the operation area is 120px away from the identifier copy box.
        // This means the window is enlarging and there is enough room to hold the icon. Show the icon.
        // 120px is a bit greater than the space required to hold the icon (60px + 24px padding), in order to avoid jittering.
        if (isCompact && !showIcon && operationLeftEdge - identifierRightEdge > 120) setShowIcon(true);
        // When the operation buttons are compact, icon is visible, and the operation area is 240px away from the identifier copy box.
        // This means the window width keeps increasing, and there is enough room to hold the regular size operation buttons.
        // Set compact operation buttons to regular form. Also, 240px is a bit greater than the actual space required to hold the regular
        // form operation buttons (around 180 ~ 240px in various cases), and this is also to avoid jittering.
        if (isCompact && showIcon && operationLeftEdge - identifierRightEdge > (additionalCustomElement ? 240 : 180)) setIsCompact(false);
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        className: $75549c043e3c1ad6$export$38e42c68cf43b5d4,
        children: [
            showIcon && /*#__PURE__*/ (0, $eCoWV.isValidElement)(icon) && /*#__PURE__*/ (0, $eCoWV.cloneElement)(icon, {
                className: $75549c043e3c1ad6$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $75549c043e3c1ad6$export$dbb5e893e736e4ee,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $75549c043e3c1ad6$export$a8ff84c12d48cfa6,
                        children: title
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $75549c043e3c1ad6$export$120ff0929b202a6d,
                        children: [
                            primaryTag && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    typeof primaryTag === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                        children: primaryTag
                                    }) : primaryTag,
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $75549c043e3c1ad6$export$d999e528e771887b
                                    })
                                ]
                            }),
                            subtitle && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $75549c043e3c1ad6$export$6f093cfa640b7166,
                                        children: subtitle
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $75549c043e3c1ad6$export$d999e528e771887b
                                    })
                                ]
                            }),
                            statusTag && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                        type: "state",
                                        status: statusTag.status,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                            forKey: statusTag.text
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $75549c043e3c1ad6$export$d999e528e771887b
                                    })
                                ]
                            }),
                            identifier && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $75549c043e3c1ad6$export$6f093cfa640b7166,
                                        children: identifier.name
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                        ref: identifierRef,
                                        className: $75549c043e3c1ad6$export$201c1586e0f2a1e0,
                                        // It's OK to use `ch` here because the font is monospace. 40px is the copy icon + padding.
                                        style: {
                                            maxWidth: `calc(${identifier.value.length}ch + 40px)`
                                        },
                                        valueStyle: {
                                            width: 0
                                        },
                                        size: "small",
                                        value: identifier.value
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                ref: operationRef,
                className: $75549c043e3c1ad6$export$59894c102379d64a,
                children: [
                    showAdditionalCustomElement && /*#__PURE__*/ (0, $eCoWV.isValidElement)(additionalCustomElement) && /*#__PURE__*/ (0, $eCoWV.cloneElement)(additionalCustomElement, {
                        isCompact: isCompact
                    }),
                    additionalActionButton && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        icon: (0, $5CQIb.conditional)(isCompact && additionalActionButton.icon),
                        title: (0, $5CQIb.conditional)(!isCompact && additionalActionButton.title),
                        size: "large",
                        onClick: additionalActionButton.onClick
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
                        buttonProps: {
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c8927b9279b58d6c$export$2e2bcd8739ae039), {}),
                            size: "large"
                        },
                        title: t("general.more_options"),
                        children: actionMenuItems?.map(({ title: title, icon: icon, type: type, onClick: onClick })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                                icon: icon,
                                type: type,
                                onClick: onClick,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: title
                                })
                            }, title))
                    })
                ]
            })
        ]
    });
}
var $84892818f27475db$export$2e2bcd8739ae039 = $84892818f27475db$var$DetailsPageHeader;



var $9zeGj = parcelRequire("9zeGj");

var $bFFWx = parcelRequire("bFFWx");

var $iHViS = parcelRequire("iHViS");

var $lSA0o = parcelRequire("lSA0o");

var $9bgsA = parcelRequire("9bgsA");

var $3MzPh = parcelRequire("3MzPh");
var $9d435c5621f95cba$export$a7db06668cad9adb;
var $9d435c5621f95cba$export$cc74dcc53cfce4eb;
var $9d435c5621f95cba$export$38e42c68cf43b5d4;
var $9d435c5621f95cba$export$32180ef41b15b513;
var $9d435c5621f95cba$export$29dd17c7f3c81c36;
var $9d435c5621f95cba$export$bfd64c937657f93a;
var $9d435c5621f95cba$export$4a6dd88bada4e7d2;
$9d435c5621f95cba$export$a7db06668cad9adb = "content_a964f6";
$9d435c5621f95cba$export$cc74dcc53cfce4eb = "wrapper_a964f6";
$9d435c5621f95cba$export$38e42c68cf43b5d4 = "header_a964f6";
$9d435c5621f95cba$export$32180ef41b15b513 = "body_a964f6";
$9d435c5621f95cba$export$29dd17c7f3c81c36 = "overlay_a964f6";
$9d435c5621f95cba$export$bfd64c937657f93a = "rotating_a964f6";
$9d435c5621f95cba$export$4a6dd88bada4e7d2 = "shimmer_a964f6";


function $23b42f3bf1cd82d7$var$Drawer({ title: title, subtitle: subtitle, isOpen: isOpen, children: children, onClose: onClose }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnOverlayClick: true,
        // Styling purpose
        // eslint-disable-next-line jsx-a11y/aria-role
        role: "drawer",
        isOpen: isOpen,
        className: $9d435c5621f95cba$export$a7db06668cad9adb,
        overlayClassName: $9d435c5621f95cba$export$29dd17c7f3c81c36,
        closeTimeoutMS: 300,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $9d435c5621f95cba$export$cc74dcc53cfce4eb,
            children: [
                title && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $9d435c5621f95cba$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                            size: "small",
                            title: title,
                            subtitle: subtitle
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "large",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $9d435c5621f95cba$export$32180ef41b15b513,
                    children: children
                })
            ]
        })
    });
}
var $23b42f3bf1cd82d7$export$2e2bcd8739ae039 = $23b42f3bf1cd82d7$var$Drawer;



var $a0Ubj = parcelRequire("a0Ubj");

var $emGEN = parcelRequire("emGEN");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $kMAP9 = parcelRequire("kMAP9");

var $hdJkM = parcelRequire("hdJkM");
function $2700d7c48278cb73$var$DeleteConfirmModal({ isOpen: isOpen, isLoading: isLoading = false, expectedInput: expectedInput, inputPlaceholder: inputPlaceholder, children: children, className: className, onCancel: onCancel, onConfirm: onConfirm, title: title, confirmButtonText: confirmButtonText }) {
    const [input, setInput] = (0, $eCoWV.useState)("");
    const isConfirmBlocked = Boolean(expectedInput) && input !== expectedInput;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $kMAP9.default), {
        isOpen: isOpen,
        isLoading: isLoading,
        isConfirmButtonDisabled: isConfirmBlocked,
        confirmButtonText: confirmButtonText ?? "general.delete",
        className: className,
        title: title,
        onCancel: onCancel,
        onConfirm: onConfirm,
        children: [
            children,
            expectedInput && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                value: input,
                placeholder: inputPlaceholder,
                onChange: (event)=>{
                    setInput(event.currentTarget.value);
                }
            })
        ]
    });
}
var $2700d7c48278cb73$export$2e2bcd8739ae039 = $2700d7c48278cb73$var$DeleteConfirmModal;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $85c9b8c4e9bd6388$export$80e4b313e5e6b30d;
var $85c9b8c4e9bd6388$export$bfd64c937657f93a;
var $85c9b8c4e9bd6388$export$4a6dd88bada4e7d2;
$85c9b8c4e9bd6388$export$80e4b313e5e6b30d = `AFg1_W_nav`;
$85c9b8c4e9bd6388$export$bfd64c937657f93a = `AFg1_W_rotating`;
$85c9b8c4e9bd6388$export$4a6dd88bada4e7d2 = `AFg1_W_shimmer`;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $8pPfi = parcelRequire("8pPfi");

var $4W0F0 = parcelRequire("4W0F0");

var $6PcpQ = parcelRequire("6PcpQ");
var $b23722a1a982b40d$export$30f3b02011db23c0;
var $b23722a1a982b40d$export$7061c75fc5af8b7e;
var $b23722a1a982b40d$export$9c30223ca0a664fb;
var $b23722a1a982b40d$export$bfd64c937657f93a;
var $b23722a1a982b40d$export$d90250155de6d7e7;
var $b23722a1a982b40d$export$4a6dd88bada4e7d2;
$b23722a1a982b40d$export$30f3b02011db23c0 = `Vu2b8a_errors`;
$b23722a1a982b40d$export$7061c75fc5af8b7e = `Vu2b8a_item`;
$b23722a1a982b40d$export$9c30223ca0a664fb = `Vu2b8a_link`;
$b23722a1a982b40d$export$bfd64c937657f93a = `Vu2b8a_rotating`;
$b23722a1a982b40d$export$d90250155de6d7e7 = `Vu2b8a_selected`;
$b23722a1a982b40d$export$4a6dd88bada4e7d2 = `Vu2b8a_shimmer`;


function $bda3ff2e6ba62f6f$var$TabNavItem({ children: children, href: href, isActive: isActive, errorCount: errorCount = 0, onClick: onClick }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { match: match, getTo: getTo } = (0, $4W0F0.default)();
    // `isActive` is used to override the default behavior of `match` when the
    // tab is not a link or the link is a relative path.
    const selected = isActive ?? (href ? match(href) : false);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $b23722a1a982b40d$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b23722a1a982b40d$export$9c30223ca0a664fb, selected && $b23722a1a982b40d$export$d90250155de6d7e7),
                children: href ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
                    to: getTo(href),
                    children: children
                }) : // eslint-disable-next-line jsx-a11y/anchor-is-valid
                /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                    role: "tab",
                    tabIndex: 0,
                    onKeyDown: (0, $6PcpQ.onKeyDownHandler)(onClick),
                    onClick: onClick,
                    children: children
                })
            }),
            errorCount > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $b23722a1a982b40d$export$30f3b02011db23c0,
                children: t("general.tab_errors", {
                    count: errorCount
                })
            })
        ]
    });
}
var $bda3ff2e6ba62f6f$export$2e2bcd8739ae039 = $bda3ff2e6ba62f6f$var$TabNavItem;


function $68d24eb9a1429606$var$TabNav({ className: className, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("nav", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($85c9b8c4e9bd6388$export$80e4b313e5e6b30d, className),
        children: children
    });
}
var $68d24eb9a1429606$export$2e2bcd8739ae039 = $68d24eb9a1429606$var$TabNav;



var $2ANSb = parcelRequire("2ANSb");


var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $505074c92853ff4a$var$SvgArrowLeft = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            id: "Vector",
            d: "m8.46 11.29 5.66-5.65a.999.999 0 0 1 1.42 0 1 1 0 0 1 0 1.41l-4.95 5L15.54 17a1 1 0 0 1-.325 1.631.998.998 0 0 1-.385.079 1 1 0 0 1-.71-.3l-5.66-5.65a1 1 0 0 1 0-1.47Z",
            fill: "currentColor"
        })
    });
var $505074c92853ff4a$export$2e2bcd8739ae039 = $505074c92853ff4a$var$SvgArrowLeft;



var $iHViS = parcelRequire("iHViS");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $ckJfF = parcelRequire("ckJfF");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $aHzBK = parcelRequire("aHzBK");

var $V1X8c = parcelRequire("V1X8c");


var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");


var $V1X8c = parcelRequire("V1X8c");
const $b73382a83e5d20dd$var$useSubscription = (tenantId)=>{
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    return (0, $2mi28.default)((0, $V1X8c.isCloud) && `/api/tenants/${tenantId}/subscription`, async ()=>cloudApi.get("/api/tenants/:tenantId/subscription", {
            params: {
                tenantId: tenantId
            }
        }));
};
var $b73382a83e5d20dd$export$2e2bcd8739ae039 = $b73382a83e5d20dd$var$useSubscription;



const $098ebafe1d66e039$var$useSubscriptionPlan = (tenantId)=>{
    const { data: subscription, error: fetchSubscriptionError } = (0, $b73382a83e5d20dd$export$2e2bcd8739ae039)(tenantId);
    const { data: subscriptionPlans, error: fetchSubscriptionPlansError } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const currentPlan = (0, $eCoWV.useMemo)(()=>subscriptionPlans?.find(({ id: planId })=>planId === subscription?.planId), [
        subscription?.planId,
        subscriptionPlans
    ]);
    return {
        data: currentPlan,
        error: fetchSubscriptionError ?? fetchSubscriptionPlansError
    };
};
var $098ebafe1d66e039$export$2e2bcd8739ae039 = $098ebafe1d66e039$var$useSubscriptionPlan;



var $4W0F0 = parcelRequire("4W0F0");

var $6PcpQ = parcelRequire("6PcpQ");
var $8a0694f89eefba0a$export$aa3e815946b80764;
var $8a0694f89eefba0a$export$6d59db4903f20f7d;
var $8a0694f89eefba0a$export$3b0508b4994f1c2d;
var $8a0694f89eefba0a$export$e77b9811020023f0;
var $8a0694f89eefba0a$export$70b14f10e1c53761;
var $8a0694f89eefba0a$export$38e42c68cf43b5d4;
var $8a0694f89eefba0a$export$7fffd76db8c31048;
var $8a0694f89eefba0a$export$db3c28d99448dcff;
var $8a0694f89eefba0a$export$58edefb809f879ec;
var $8a0694f89eefba0a$export$a8ff84c12d48cfa6;
var $8a0694f89eefba0a$export$bfd64c937657f93a;
var $8a0694f89eefba0a$export$4a6dd88bada4e7d2;
$8a0694f89eefba0a$export$aa3e815946b80764 = `_7CsCrG_card`;
$8a0694f89eefba0a$export$6d59db4903f20f7d = `_7CsCrG_description`;
$8a0694f89eefba0a$export$3b0508b4994f1c2d = `_7CsCrG_flexRow`;
$8a0694f89eefba0a$export$e77b9811020023f0 = `_7CsCrG_hasBorder`;
$8a0694f89eefba0a$export$70b14f10e1c53761 = `_7CsCrG_hasButton`;
$8a0694f89eefba0a$export$38e42c68cf43b5d4 = `_7CsCrG_header`;
$8a0694f89eefba0a$export$7fffd76db8c31048 = `_7CsCrG_infoWrapper`;
$8a0694f89eefba0a$export$db3c28d99448dcff = `_7CsCrG_logo`;
$8a0694f89eefba0a$export$58edefb809f879ec = `_7CsCrG_logoSkeleton`;
$8a0694f89eefba0a$export$a8ff84c12d48cfa6 = `_7CsCrG_name`;
$8a0694f89eefba0a$export$bfd64c937657f93a = `_7CsCrG_rotating`;
$8a0694f89eefba0a$export$4a6dd88bada4e7d2 = `_7CsCrG_shimmer`;
$8a0694f89eefba0a$export$4a6dd88bada4e7d2;


function $76f783dcb44baa58$var$GuideCard({ data: data, onClick: onClick, hasBorder: hasBorder, hasButton: hasButton }) {
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isM2mDisabled = (0, $V1X8c.isCloud) && currentPlan?.quota.machineToMachineLimit === 0;
    const { id: id, Logo: Logo, metadata: { target: target, name: name, description: description } } = data;
    const hasPaywall = (0, $V1X8c.isCloud) && target === (0, $3kVX5.ApplicationType).MachineToMachine;
    const isSubscriptionRequired = isM2mDisabled && target === (0, $3kVX5.ApplicationType).MachineToMachine;
    const buttonText = isSubscriptionRequired ? "upsell.upgrade_plan" : target === "API" ? "guide.get_started" : "guide.start_building";
    const handleClick = (0, $eCoWV.useCallback)(()=>{
        if (isSubscriptionRequired) navigate((0, $f5861ec06c49db25$export$6d940d0d58a60bc4));
        else onClick({
            id: id,
            target: target,
            name: name
        });
    }, [
        id,
        isSubscriptionRequired,
        name,
        target,
        navigate,
        onClick
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8a0694f89eefba0a$export$aa3e815946b80764, hasBorder && $8a0694f89eefba0a$export$e77b9811020023f0, hasButton && $8a0694f89eefba0a$export$70b14f10e1c53761),
        ...!hasButton && {
            tabIndex: 0,
            role: "button",
            onKeyDown: (0, $6PcpQ.onKeyDownHandler)(handleClick),
            onClick: handleClick
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $8a0694f89eefba0a$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eCoWV.Suspense), {
                        fallback: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $8a0694f89eefba0a$export$58edefb809f879ec
                        }),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)(Logo, {
                            className: $8a0694f89eefba0a$export$db3c28d99448dcff
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $8a0694f89eefba0a$export$7fffd76db8c31048,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $8a0694f89eefba0a$export$3b0508b4994f1c2d,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $8a0694f89eefba0a$export$a8ff84c12d48cfa6,
                                        children: name
                                    }),
                                    hasPaywall && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                                        isVisible: isM2mDisabled,
                                        for: "upsell",
                                        plan: (0, $ckJfF.ReservedPlanId).Hobby
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $8a0694f89eefba0a$export$6d59db4903f20f7d,
                                title: description,
                                children: description
                            })
                        ]
                    })
                ]
            }),
            hasButton && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: buttonText,
                size: "small",
                onClick: handleClick
            })
        ]
    });
}
var $76f783dcb44baa58$export$2e2bcd8739ae039 = $76f783dcb44baa58$var$GuideCard;


var $035e3b4a114b2097$export$85fc379452d91af0;
var $035e3b4a114b2097$export$1f1f054184239bf5;
var $035e3b4a114b2097$export$bfd64c937657f93a;
var $035e3b4a114b2097$export$4a6dd88bada4e7d2;
$035e3b4a114b2097$export$85fc379452d91af0 = `_5Dl9qW_grid`;
$035e3b4a114b2097$export$1f1f054184239bf5 = `_5Dl9qW_guideGroup`;
$035e3b4a114b2097$export$bfd64c937657f93a = `_5Dl9qW_rotating`;
$035e3b4a114b2097$export$4a6dd88bada4e7d2 = `_5Dl9qW_shimmer`;


function $460401404e060952$var$GuideCardGroup({ className: className, categoryName: categoryName, guides: guides, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton, onClickGuide: onClickGuide }, ref) {
    if (!guides?.length) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($035e3b4a114b2097$export$1f1f054184239bf5, className),
        children: [
            categoryName && /*#__PURE__*/ (0, $9zeGj.jsx)("label", {
                children: categoryName
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $035e3b4a114b2097$export$85fc379452d91af0,
                children: guides.map((guide)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $76f783dcb44baa58$export$2e2bcd8739ae039), {
                        hasBorder: hasCardBorder,
                        hasButton: hasCardButton,
                        data: guide,
                        onClick: onClickGuide
                    }, guide.id))
            })
        ]
    });
}
var $460401404e060952$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($460401404e060952$var$GuideCardGroup);



var $eCoWV = parcelRequire("eCoWV");

var $ac8G1 = parcelRequire("ac8G1");
const $461d44ddf3f0b8fb$var$defaultStructuredMetadata = {
    featured: [],
    Traditional: [],
    SPA: [],
    Native: [],
    MachineToMachine: []
};
const $461d44ddf3f0b8fb$export$6bb65ec2faabc0af = ()=>(0, $ac8G1.default).filter(({ metadata: { target: target } })=>target === "API");
const $461d44ddf3f0b8fb$export$6b80cd72646f4cab = ()=>{
    const appGuides = (0, $eCoWV.useMemo)(()=>(0, $ac8G1.default).filter(({ metadata: { target: target } })=>target !== "API"), []);
    const getFilteredAppGuideMetadata = (0, $eCoWV.useCallback)((filters)=>{
        const { categories: filterCategories, keyword: keyword } = filters ?? {};
        // If no filter is applied, return all metadata
        if (!filterCategories?.length && !keyword) return appGuides;
        // Keyword only, return partial name matched result
        if (keyword && !filterCategories?.length) return appGuides.filter(({ metadata: { name: name } })=>name.toLowerCase().includes(keyword.toLowerCase()));
        // Categories only, return selected categories
        if (!keyword && filterCategories?.length) return appGuides.filter(({ metadata: { target: target, isFeatured: isFeatured } })=>filterCategories.some((filterCategory)=>filterCategory === target || isFeatured && filterCategory === "featured"));
        // Keyword and categories, return partial name matched result in selected categories
        if (keyword && filterCategories?.length) return appGuides.filter(({ metadata: { name: name, target: target, isFeatured: isFeatured } })=>name.toLowerCase().includes(keyword.toLowerCase()) && filterCategories.some((filterCategory)=>filterCategory === target || isFeatured && filterCategory === "featured"));
        return [];
    }, [
        appGuides
    ]);
    const getStructuredAppGuideMetadata = (0, $eCoWV.useCallback)((filters)=>{
        const filteredMetadata = getFilteredAppGuideMetadata(filters);
        return filteredMetadata.reduce((accumulated, guide)=>{
            const { target: target, isFeatured: isFeatured } = guide.metadata;
            // Rule out API target guides to make TypeScript happy
            if (target === "API") return accumulated;
            return {
                ...accumulated,
                [target]: [
                    ...accumulated[target],
                    guide
                ],
                ...isFeatured && {
                    featured: [
                        ...accumulated.featured,
                        guide
                    ]
                }
            };
        }, $461d44ddf3f0b8fb$var$defaultStructuredMetadata);
    }, [
        getFilteredAppGuideMetadata
    ]);
    return {
        getFilteredAppGuideMetadata: getFilteredAppGuideMetadata,
        getStructuredAppGuideMetadata: getStructuredAppGuideMetadata
    };
};



var $9bgsA = parcelRequire("9bgsA");

var $3MzPh = parcelRequire("3MzPh");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $ac8G1 = parcelRequire("ac8G1");

var $7fydw = parcelRequire("7fydw");

var $eEyjP = parcelRequire("eEyjP");

var $itzs0 = parcelRequire("itzs0");
function $9777b6cf8d28c2a4$var$ApiGuide({ className: className, guideId: guideId, apiResource: apiResource, isCompact: isCompact, onClose: onClose }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    const guide = (0, $ac8G1.default).find(({ id: id })=>id === guideId);
    const memorizedContext = (0, $eCoWV.useMemo)(()=>(0, $5CQIb.conditional)(!!guide && !!apiResource && {
            metadata: guide.metadata,
            Logo: guide.Logo,
            isCompact: Boolean(isCompact),
            endpoint: applyCustomDomain(tenantEndpoint?.href ?? ""),
            audience: apiResource.indicator
        }), [
        apiResource,
        applyCustomDomain,
        guide,
        isCompact,
        tenantEndpoint?.href
    ]);
    return memorizedContext ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fydw.GuideContext).Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fydw.default), {
            className: className,
            guideId: guideId,
            isLoading: !guide,
            onClose: onClose
        })
    }) : null;
}
var $9777b6cf8d28c2a4$export$2e2bcd8739ae039 = $9777b6cf8d28c2a4$var$ApiGuide;


var $0a5a943f26eb41c8$export$a22f64ad99009e4f;
var $0a5a943f26eb41c8$export$e2ebc74040679039;
var $0a5a943f26eb41c8$export$675bc0f5721dbbd7;
var $0a5a943f26eb41c8$export$38e42c68cf43b5d4;
var $0a5a943f26eb41c8$export$bfd64c937657f93a;
var $0a5a943f26eb41c8$export$3e523c77c1f23f8c;
var $0a5a943f26eb41c8$export$4a6dd88bada4e7d2;
$0a5a943f26eb41c8$export$a22f64ad99009e4f = `UaW6SG_cardGroup`;
$0a5a943f26eb41c8$export$e2ebc74040679039 = `UaW6SG_drawerContainer`;
$0a5a943f26eb41c8$export$675bc0f5721dbbd7 = `UaW6SG_guide`;
$0a5a943f26eb41c8$export$38e42c68cf43b5d4 = `UaW6SG_header`;
$0a5a943f26eb41c8$export$bfd64c937657f93a = `UaW6SG_rotating`;
$0a5a943f26eb41c8$export$3e523c77c1f23f8c = `UaW6SG_separator`;
$0a5a943f26eb41c8$export$4a6dd88bada4e7d2 = `UaW6SG_shimmer`;


function $505b6b2dec84a6d8$var$GuideDrawer({ apiResource: apiResource, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.guide"
    });
    const guides = (0, $461d44ddf3f0b8fb$export$6bb65ec2faabc0af)();
    const [selectedGuide, setSelectedGuide] = (0, $eCoWV.useState)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $0a5a943f26eb41c8$export$e2ebc74040679039,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $0a5a943f26eb41c8$export$38e42c68cf43b5d4,
                children: [
                    selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                size: "large",
                                onClick: ()=>{
                                    setSelectedGuide(undefined);
                                },
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $505074c92853ff4a$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0a5a943f26eb41c8$export$3e523c77c1f23f8c
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: t("checkout_tutorial", {
                                    name: selectedGuide.name
                                })
                            })
                        ]
                    }),
                    !selectedGuide && t("api.select_a_tutorial"),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        size: "large",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
                    })
                ]
            }),
            !selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                className: $0a5a943f26eb41c8$export$a22f64ad99009e4f,
                guides: guides,
                onClickGuide: (guide)=>{
                    setSelectedGuide(guide);
                }
            }),
            selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9777b6cf8d28c2a4$export$2e2bcd8739ae039), {
                isCompact: true,
                className: $0a5a943f26eb41c8$export$675bc0f5721dbbd7,
                guideId: selectedGuide.id,
                apiResource: apiResource,
                onClose: ()=>{
                    setSelectedGuide(undefined);
                }
            })
        ]
    });
}
var $505b6b2dec84a6d8$export$2e2bcd8739ae039 = $505b6b2dec84a6d8$var$GuideDrawer;



var $9zeGj = parcelRequire("9zeGj");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $V1X8c = parcelRequire("V1X8c");

var $kcPww = parcelRequire("kcPww");

var $9zeGj = parcelRequire("9zeGj");

var $iHViS = parcelRequire("iHViS");

var $lSA0o = parcelRequire("lSA0o");

var $9bgsA = parcelRequire("9bgsA");

var $3MzPh = parcelRequire("3MzPh");
var $a8b407f29f815b9b$export$64a53ecd158b85c4;
var $a8b407f29f815b9b$export$38e42c68cf43b5d4;
var $a8b407f29f815b9b$export$bfd64c937657f93a;
var $a8b407f29f815b9b$export$3e523c77c1f23f8c;
var $a8b407f29f815b9b$export$4a6dd88bada4e7d2;
$a8b407f29f815b9b$export$64a53ecd158b85c4 = `UAORjW_closeIcon`;
$a8b407f29f815b9b$export$38e42c68cf43b5d4 = `UAORjW_header`;
$a8b407f29f815b9b$export$bfd64c937657f93a = `UAORjW_rotating`;
$a8b407f29f815b9b$export$3e523c77c1f23f8c = `UAORjW_separator`;
$a8b407f29f815b9b$export$4a6dd88bada4e7d2 = `UAORjW_shimmer`;


function $444e1b6fad81232a$var$ModalHeader({ title: title, subtitle: subtitle, actionButton: actionButton, onClose: onClose }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $a8b407f29f815b9b$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                size: "large",
                onClick: onClose,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                    className: $a8b407f29f815b9b$export$64a53ecd158b85c4
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $a8b407f29f815b9b$export$3e523c77c1f23f8c
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                size: "small",
                title: title,
                subtitle: subtitle
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
            actionButton
        ]
    });
}
var $444e1b6fad81232a$export$2e2bcd8739ae039 = $444e1b6fad81232a$var$ModalHeader;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");


var $7iZsu = parcelRequire("7iZsu");
function $9f3ff304ecc5c51d$export$2e2bcd8739ae039({ title: title, fieldLabel: fieldLabel, fieldPlaceholder: fieldPlaceholder, successMessage: successMessage, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [inputValue, setInputValue] = (0, $eCoWV.useState)("");
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const { data: data, update: update } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const guideRequests = data?.guideRequests;
    const submit = async ()=>{
        setIsLoading(true);
        try {
            await update({
                guideRequests: Array.isArray(guideRequests) ? guideRequests.concat(inputValue) : [
                    inputValue
                ]
            });
        } catch  {
            setIsLoading(false);
            return;
        }
        setIsLoading(false);
        setInputValue("");
        onClose();
        (0, $horhC.toast).success(String(t(successMessage)));
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: title
            }),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "large",
                type: "primary",
                title: "general.submit",
                isLoading: isLoading,
                disabled: !inputValue,
                onClick: submit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: fieldLabel
                }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    /** The i18n value is already string here. */ placeholder: String(t(fieldPlaceholder)),
                    value: inputValue,
                    onChange: ({ currentTarget: { value: value } })=>{
                        setInputValue(value);
                    }
                })
            })
        })
    });
}


var $977abbb9497e49fa$export$bded1fa0dae15b2b;
var $977abbb9497e49fa$export$bfd64c937657f93a;
var $977abbb9497e49fa$export$4a6dd88bada4e7d2;
$977abbb9497e49fa$export$bded1fa0dae15b2b = `GSUL-G_requestSdkButton`;
$977abbb9497e49fa$export$bfd64c937657f93a = `GSUL-G_rotating`;
$977abbb9497e49fa$export$4a6dd88bada4e7d2 = `GSUL-G_shimmer`;


function $25451d9c34e1e7ec$var$ModalHeader({ title: title, subtitle: subtitle, buttonText: buttonText, requestFormTitle: requestFormTitle = buttonText, requestFormFieldLabel: requestFormFieldLabel, requestFormFieldPlaceholder: requestFormFieldPlaceholder, requestSuccessMessage: requestSuccessMessage, onClose: onClose }) {
    const [isRequestGuideOpen, setIsRequestGuideOpen] = (0, $eCoWV.useState)(false);
    const onRequestGuideClose = (0, $eCoWV.useCallback)(()=>{
        setIsRequestGuideOpen(false);
    }, []);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $444e1b6fad81232a$export$2e2bcd8739ae039), {
                title: title,
                subtitle: subtitle,
                actionButton: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    className: $977abbb9497e49fa$export$bded1fa0dae15b2b,
                    type: "outline",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ab23478e4bd44acc$export$2e2bcd8739ae039), {}),
                    title: buttonText,
                    onClick: ()=>{
                        if (0, $V1X8c.isCloud) setIsRequestGuideOpen(true);
                        else window.open((0, $o53Y2.githubIssuesLink), "_blank");
                    }
                }),
                onClose: onClose
            }),
            (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9f3ff304ecc5c51d$export$2e2bcd8739ae039), {
                title: requestFormTitle,
                successMessage: requestSuccessMessage,
                fieldLabel: requestFormFieldLabel,
                fieldPlaceholder: requestFormFieldPlaceholder,
                isOpen: isRequestGuideOpen,
                onClose: onRequestGuideClose
            })
        ]
    });
}
var $25451d9c34e1e7ec$export$2e2bcd8739ae039 = $25451d9c34e1e7ec$var$ModalHeader;



var $7iZsu = parcelRequire("7iZsu");

var $58f67e264a5b4e15$export$675bc0f5721dbbd7;
var $58f67e264a5b4e15$export$56c24f306bd986cf;
var $58f67e264a5b4e15$export$bfd64c937657f93a;
var $58f67e264a5b4e15$export$4a6dd88bada4e7d2;
$58f67e264a5b4e15$export$675bc0f5721dbbd7 = `K2_WUa_guide`;
$58f67e264a5b4e15$export$56c24f306bd986cf = `K2_WUa_modalContainer`;
$58f67e264a5b4e15$export$bfd64c937657f93a = `K2_WUa_rotating`;
$58f67e264a5b4e15$export$4a6dd88bada4e7d2 = `K2_WUa_shimmer`;


function $6887d591600e200d$var$GuideModal({ guideId: guideId, apiResource: apiResource, onClose: onClose }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $58f67e264a5b4e15$export$56c24f306bd986cf,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25451d9c34e1e7ec$export$2e2bcd8739ae039), {
                    title: "guide.api.modal_title",
                    subtitle: "guide.api.modal_subtitle",
                    buttonText: "guide.cannot_find_guide",
                    requestFormFieldLabel: "guide.describe_guide_looking_for",
                    requestFormFieldPlaceholder: "guide.api.describe_guide_looking_for_placeholder",
                    requestSuccessMessage: "guide.request_guide_successfully",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9777b6cf8d28c2a4$export$2e2bcd8739ae039), {
                    className: $58f67e264a5b4e15$export$675bc0f5721dbbd7,
                    guideId: guideId,
                    apiResource: apiResource,
                    onClose: onClose
                })
            ]
        })
    });
}
var $6887d591600e200d$export$2e2bcd8739ae039 = $6887d591600e200d$var$GuideModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9XAkT = parcelRequire("9XAkT");

var $1Iq4D = parcelRequire("1Iq4D");


function $225fa4e889059144$var$ManagementApiNotice() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { data: data, isLoading: isLoading, update: update } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const { managementApiAcknowledged: managementApiAcknowledged } = data;
    if (isLoading || managementApiAcknowledged) return null;
    const learnMoreLink = getDocumentationUrl("/docs/tutorials/get-started/explore-management-api");
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        action: "general.got_it",
        onClick: ()=>{
            update({
                managementApiAcknowledged: true
            });
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                    href: learnMoreLink,
                    targetBlank: "noopener"
                })
            },
            children: t("api_resource_details.management_api_notice")
        })
    });
}
var $225fa4e889059144$export$2e2bcd8739ae039 = $225fa4e889059144$var$ManagementApiNotice;


var $38982bd58c6b6875$export$64fda0c1cfacc296;
var $38982bd58c6b6875$export$6d59db4903f20f7d;
var $38982bd58c6b6875$export$e4043f67d36cbb26;
var $38982bd58c6b6875$export$cc11a623cb30934;
var $38982bd58c6b6875$export$bfd64c937657f93a;
var $38982bd58c6b6875$export$4a6dd88bada4e7d2;
$38982bd58c6b6875$export$64fda0c1cfacc296 = `nfnr9a_deleteConfirm`;
$38982bd58c6b6875$export$6d59db4903f20f7d = `nfnr9a_description`;
$38982bd58c6b6875$export$e4043f67d36cbb26 = `nfnr9a_highlight`;
$38982bd58c6b6875$export$cc11a623cb30934 = `nfnr9a_permissionPage`;
$38982bd58c6b6875$export$bfd64c937657f93a = `nfnr9a_rotating`;
$38982bd58c6b6875$export$4a6dd88bada4e7d2 = `nfnr9a_shimmer`;


const $3a92d6ed0a0d6f8e$var$icons = {
    [(0, $bhvxB.Theme).Light]: {
        ApiIcon: (0, $457ebd48361125e9$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $3e3948c112d6cadd$export$2e2bcd8739ae039)
    },
    [(0, $bhvxB.Theme).Dark]: {
        ApiIcon: (0, $d3531ed89fdec97a$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $0fad305167d7e141$export$2e2bcd8739ae039)
    }
};
function $3a92d6ed0a0d6f8e$var$ApiResourceDetails() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { id: id, guideId: guideId } = (0, $9X5Bp.useParams)();
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const isGuideView = !!id && !!guideId && match(`/api-resources/${id}/guide/${guideId}`);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && `api/resources/${id}`);
    const isLoading = !data && !error;
    const theme = (0, $93h5F.default)();
    const { ApiIcon: ApiIcon, ManagementApiIcon: ManagementApiIcon } = $3a92d6ed0a0d6f8e$var$icons[theme];
    const isOnPermissionPage = pathname.endsWith((0, $emGEN.ApiResourceDetailsTabs).Permissions);
    const isLogtoManagementApiResource = (0, $MRt6E.isManagementApi)(data?.indicator ?? "");
    const Icon = isLogtoManagementApiResource ? ManagementApiIcon : ApiIcon;
    const [isGuideDrawerOpen, setIsGuideDrawerOpen] = (0, $eCoWV.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $eCoWV.useState)(false);
    (0, $eCoWV.useEffect)(()=>{
        setIsDeleteFormOpen(false);
    }, [
        pathname
    ]);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const onDelete = async ()=>{
        if (!data || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/resources/${data.id}`);
            (0, $horhC.toast).success(t("api_resource_details.api_resource_deleted", {
                name: data.name
            }));
            navigate(`/api-resources`);
        } finally{
            setIsDeleting(false);
        }
    };
    const onCloseDrawer = ()=>{
        setIsGuideDrawerOpen(false);
    };
    if (isGuideView) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6887d591600e200d$export$2e2bcd8739ae039), {
        guideId: guideId,
        apiResource: data,
        onClose: ()=>{
            navigate(`/api-resources/${id}`);
        }
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: "/api-resources",
        backLinkTitle: "api_resource_details.back_to_api_resources",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isOnPermissionPage && $38982bd58c6b6875$export$cc11a623cb30934),
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "api_resource_details.page_title"
            }),
            isLogtoManagementApiResource && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $225fa4e889059144$export$2e2bcd8739ae039), {}),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {}),
                        title: data.name,
                        primaryTag: data.isDefault && t("api_resources.default_api"),
                        identifier: {
                            name: "API Identifier",
                            value: data.indicator
                        },
                        additionalActionButton: {
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7529b38878187ba2$export$2e2bcd8739ae039), {}),
                            title: "application_details.check_guide",
                            onClick: ()=>{
                                if (isLogtoManagementApiResource) window.open(getDocumentationUrl("/docs/recipes/interact-with-management-api/"), "_blank");
                                else setIsGuideDrawerOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                title: "general.delete",
                                type: "danger",
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b42f3bf1cd82d7$export$2e2bcd8739ae039), {
                        isOpen: isGuideDrawerOpen,
                        onClose: onCloseDrawer,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $505b6b2dec84a6d8$export$2e2bcd8739ae039), {
                            apiResource: data,
                            onClose: onCloseDrawer
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        expectedInput: data.name,
                        className: $38982bd58c6b6875$export$64fda0c1cfacc296,
                        inputPlaceholder: t("api_resource_details.enter_your_api_resource_name"),
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $38982bd58c6b6875$export$6d59db4903f20f7d,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        className: $38982bd58c6b6875$export$e4043f67d36cbb26
                                    })
                                },
                                children: t("api_resource_details.delete_description", {
                                    name: data.name
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/api-resources/${data.id}/${(0, $emGEN.ApiResourceDetailsTabs).Settings}`,
                                children: t("api_resource_details.settings_tab")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/api-resources/${data.id}/${(0, $emGEN.ApiResourceDetailsTabs).Permissions}`,
                                children: t("api_resource_details.permissions_tab")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {
                        context: {
                            resource: data,
                            isDeleting: isDeleting,
                            isLogtoManagementApiResource: isLogtoManagementApiResource,
                            onResourceUpdated: (resource)=>{
                                mutate(resource);
                            }
                        }
                    })
                ]
            })
        ]
    });
}
var $3a92d6ed0a0d6f8e$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($3a92d6ed0a0d6f8e$var$ApiResourceDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1e6114bf161d390f$var$SvgPermissionsEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#191C1D",
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M250 219H15l19.087-29.902a18.05 18.05 0 0 1 15.214-8.337h.65c3.114 0 6.16.915 8.757 2.632 7.128 4.71 16.704 2.939 21.675-4.008l22.791-31.844a20.433 20.433 0 0 1 30.081-3.477l6.509 5.702a23.895 23.895 0 0 0 28.7 2.106 23.894 23.894 0 0 1 12.954-3.815h.946a27.106 27.106 0 0 1 25.812 18.83l5.335 16.636a13.406 13.406 0 0 0 12.766 9.313c4.633 0 8.938 2.392 11.385 6.327L250 219Z",
                fill: "#59566E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.181 210.929c1.207-1.064 2.384-2.449 2.572-4.111.09-.788.016-1.741-.639-2.289-.614-.518-1.474-.554-2.23-.388-1.676.369-3.035 1.582-4.774 1.734a5.25 5.25 0 0 1-1.613-.11c-2.697-3.57-4.281-7.764-4.933-12.255-.007-.04-.007-.08-.013-.118.443.142.889.27 1.34.368 1.168.255 2.37.338 3.564.28 1.19-.057 2.454-.252 3.571-.678.476-.18.937-.498 1.133-.986.233-.588-.057-1.14-.445-1.578-1.414-1.59-3.527-2.12-5.53-2.54-1.385-.293-2.925-.606-4.068-1.463-.012-3.339.212-6.687.38-10.019.014-.272.024-.545.038-.82.46.268.91.549 1.349.846l1.576 1.225a.86.86 0 0 0 .233.128c.098.082.199.155.297.237.32.27.795.213 1.084-.063.02-.018.036-.041.05-.061.437-.117.77-.541.548-1.065-.605-1.43-1.65-2.557-2.715-3.66-.851-.88-1.737-1.779-2.313-2.865-.059-4.473-.603-8.93-2.407-13.07-.312-.713.45-1.278 1.095-1.068 5.209 1.716 10.23 3.906 15.08 6.441.798 1.109.916 2.671.996 3.984a22.07 22.07 0 0 1 0 2.695c-.05.819-.078 1.642.497 2.303.48.552 1.178.802 1.867.977.38.095.76.154 1.12-.041.388-.214.503-.628.619-1.023.418-1.417 1.093-3.626.983-5.491a147.93 147.93 0 0 1 9.324 6.067c.503 2.108-.556 4.519-1.337 6.471-.913 2.277-1.883 5.15-.673 7.507.54 1.052 1.533 1.865 2.748 1.937.563.035 1.379-.05 1.654-.625.243-.505.32-1.069.595-1.574 1.268-2.318 3.74-3.664 5.588-5.458.355-.347.633-.697.796-1.058 1.456 1.383 2.777 2.885 3.848 4.567 1.4 2.204 2.225 4.648 2.538 7.158a4.278 4.278 0 0 1-.396.433 5.473 5.473 0 0 1-.995.753c-.34.197-.699.362-1.01.6-.81.624-1.106 1.647-.535 2.542.534.838 1.62 1.117 2.56 1.139.1.001.185-.011.273-.025a20.875 20.875 0 0 1-.858 3.477c-.921 2.699-2.395 5.15-4.216 7.325-2.675 1.578-6.068 1.632-8.912-.035a.585.585 0 0 0-.264-.075 76.952 76.952 0 0 0-2.75-6.423c-1.913-3.989-4.077-7.831-6.316-11.616l-6.776-11.311c-2.272-3.76-4.64-7.494-7.482-10.85 2.737 3.444 4.974 7.233 7.124 11.058l6.415 11.51c2.114 3.844 4.145 7.733 5.909 11.724a74.632 74.632 0 0 1 2.857 7.462 8.545 8.545 0 0 1-3.35 5.158 8.127 8.127 0 0 1-1.154.686c-2.12.64-4.383.765-6.625.542-2.761-.811-5.33-2.19-7.65-3.909.266-.195.52-.399.758-.613Z",
                fill: "url(#paint0_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52 132a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H52v-85Z",
                fill: "url(#paint1_linear_6532_88970)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M56 131a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H56v-82Z",
                fill: "url(#paint2_linear_6532_88970)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M27 213h193v2a4 4 0 0 1-4 4H32a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M114 127h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 69,
                y: 143,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M100.548 143h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint3_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 207.098,
                y: 115,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 207.098 115)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M108 86.632c-4.145 0-6.109-3.537-6.109-6.632 0 3.095-1.746 6.632-5.891 6.632 4.145 0 5.891 2.18 5.891 7.368 0-5.187 1.964-7.368 6.109-7.368ZM30 108.632c-4.145 0-6.11-3.537-6.11-6.632 0 3.095-1.745 6.632-5.89 6.632 4.145 0 5.89 2.181 5.89 7.368 0-5.187 1.965-7.368 6.11-7.368Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218.956 53.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.038.142l-2.862 1.653 2.861 1.652c.05.029.067.092.039.142l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.862-1.652-2.862-1.653a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.7,
                x: 100,
                y: 154,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100,
                y: 166,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100,
                y: 178,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m173.162 115.98.003.003 11.335 10.239V195a9.5 9.5 0 0 1-9.5 9.5h-51a9.5 9.5 0 0 1-9.5-9.5v-79a9.5 9.5 0 0 1 9.5-9.5h38.806l10.356 9.48Z",
                fill: "#E6DEFF",
                stroke: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M169.774 124H184v72a9 9 0 0 1-9 9h-18.5l13.274-81Z",
                fill: "url(#paint4_linear_6532_88970)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 150,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.7,
                x: 124,
                y: 139,
                width: 7,
                height: 6,
                rx: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 138,
                y: 139,
                width: 18,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 172,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 159,
                y: 172,
                width: 14,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 161,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 184,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M153 79a4 4 0 0 1 4-4h25v17h-25a4 4 0 0 1-4-4v-9Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M245.5 88a4 4 0 0 1-4 4H182V75h59.5a4 4 0 0 1 4 4v9Z",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M221 92.5h20a5 5 0 0 0 5-5V82",
                stroke: "#B1869F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.7,
                d: "M101 95H34a4 4 0 0 0-4 4v7",
                stroke: "#58577B"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M163.5 116v-8.863l20.027 18.363H173a9.5 9.5 0 0 1-9.5-9.5Z",
                fill: "#DBD3FF",
                stroke: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M160.5 74.5H193",
                stroke: "#B1869F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#2A2C32",
                d: "M131 101h14v6h-14z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 157,
                y: 82,
                width: 18,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 192,
                y: 82,
                width: 49,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M182 76v16",
                stroke: "#B18BA1",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 83.5,
                cy: 159.5,
                r: 7.5,
                fill: "#9C7ECC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_6532_88970",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 76,
                y: 152,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 83.5,
                    cy: 159.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_6532_88970)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M83.434 154.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M34 146a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M130.8 130.015c4.003 0 7.25-3.237 7.25-7.233 0-3.995-3.247-7.232-7.25-7.232s-7.25 3.237-7.25 7.232c0 3.996 3.247 7.233 7.25 7.233Z",
                stroke: "url(#paint5_linear_6532_88970)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 130.8,
                cy: 122.783,
                rx: 6.152,
                ry: 6.136,
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1.756,
                height: 5.268,
                rx: 0.878,
                transform: "rotate(-44.926 211.263 -91.91)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.024,
                height: 1.756,
                rx: 0.878,
                transform: "rotate(-44.926 215.506 -93.677)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6532_88970",
                        x1: 57.329,
                        y1: 213.747,
                        x2: 24.255,
                        y2: 153.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6ADD3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#5124DB",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6532_88970",
                        x1: 120.556,
                        y1: 126.099,
                        x2: 151.327,
                        y2: 228.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#735DF9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D781FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_6532_88970",
                        x1: 192,
                        y1: 213.001,
                        x2: -17,
                        y2: 80.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_6532_88970",
                        x1: 130.59,
                        y1: 168.664,
                        x2: 90.951,
                        y2: 193.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_6532_88970",
                        x1: 184.795,
                        y1: 161.121,
                        x2: 158.308,
                        y2: 166.914,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_6532_88970",
                        x1: 125.619,
                        y1: 117.938,
                        x2: 137.57,
                        y2: 129.596,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#74B382"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $1e6114bf161d390f$export$2e2bcd8739ae039 = $1e6114bf161d390f$var$SvgPermissionsEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1edc5bf75e3ca205$var$SvgPermissionsEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M250 220H15l19.087-29.902a18.05 18.05 0 0 1 15.214-8.337h.65c3.114 0 6.16.915 8.757 2.632 7.128 4.71 16.704 2.939 21.675-4.008l22.791-31.844a20.433 20.433 0 0 1 30.081-3.477l6.509 5.702a23.895 23.895 0 0 0 28.7 2.106 23.894 23.894 0 0 1 12.954-3.815h.946a27.106 27.106 0 0 1 25.812 18.83l5.335 16.636a13.406 13.406 0 0 0 12.766 9.313c4.633 0 8.938 2.392 11.385 6.327L250 220Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.181 210.929c1.207-1.064 2.384-2.449 2.572-4.111.09-.788.016-1.741-.639-2.289-.614-.518-1.474-.554-2.23-.388-1.676.369-3.035 1.582-4.774 1.734a5.25 5.25 0 0 1-1.613-.11c-2.697-3.57-4.281-7.764-4.933-12.255-.007-.04-.007-.08-.013-.118.443.142.889.27 1.34.368 1.168.255 2.37.338 3.564.28 1.19-.057 2.454-.252 3.571-.678.476-.18.937-.498 1.133-.986.233-.588-.057-1.14-.445-1.578-1.414-1.59-3.527-2.12-5.53-2.54-1.385-.293-2.925-.606-4.068-1.463-.012-3.339.212-6.687.38-10.019.014-.272.024-.545.038-.82.46.268.91.549 1.349.846l1.576 1.225a.86.86 0 0 0 .233.128c.098.082.199.155.297.237.32.27.795.213 1.084-.063.02-.018.036-.041.05-.061.437-.117.77-.541.548-1.065-.605-1.43-1.65-2.557-2.715-3.66-.851-.88-1.737-1.779-2.313-2.865-.059-4.473-.603-8.93-2.407-13.07-.312-.713.45-1.278 1.095-1.068 5.209 1.716 10.23 3.906 15.08 6.441.798 1.109.916 2.671.996 3.984a22.07 22.07 0 0 1 0 2.695c-.05.819-.078 1.642.497 2.303.48.552 1.178.802 1.867.977.38.095.76.154 1.12-.041.388-.214.503-.628.619-1.023.418-1.417 1.093-3.626.983-5.491a147.93 147.93 0 0 1 9.324 6.067c.503 2.108-.556 4.519-1.337 6.471-.913 2.277-1.883 5.15-.673 7.507.54 1.052 1.533 1.865 2.748 1.937.563.035 1.379-.05 1.654-.625.243-.505.32-1.069.595-1.574 1.268-2.318 3.74-3.664 5.588-5.458.355-.347.633-.697.796-1.058 1.456 1.382 2.777 2.885 3.848 4.567 1.4 2.204 2.225 4.648 2.538 7.158a4.278 4.278 0 0 1-.396.433 5.473 5.473 0 0 1-.995.753c-.34.197-.699.362-1.01.6-.81.624-1.106 1.647-.535 2.542.534.838 1.62 1.117 2.56 1.139.1.001.185-.011.273-.025a20.875 20.875 0 0 1-.858 3.477c-.921 2.699-2.395 5.15-4.216 7.325-2.675 1.578-6.068 1.632-8.912-.035a.585.585 0 0 0-.264-.075 76.952 76.952 0 0 0-2.75-6.423c-1.913-3.989-4.077-7.831-6.316-11.616l-6.776-11.311c-2.272-3.76-4.64-7.494-7.482-10.85 2.737 3.444 4.974 7.233 7.124 11.058l6.415 11.51c2.114 3.844 4.145 7.733 5.909 11.724a74.632 74.632 0 0 1 2.857 7.462 8.545 8.545 0 0 1-3.35 5.158 8.127 8.127 0 0 1-1.154.686c-2.12.64-4.383.765-6.625.542-2.761-.811-5.33-2.19-7.65-3.909.266-.195.52-.399.758-.613Z",
                fill: "url(#paint0_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52 132a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H52v-85Z",
                fill: "url(#paint1_linear_6485_85356)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M56 131a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H56v-82Z",
                fill: "url(#paint2_linear_6485_85356)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M27 213h193v2a4 4 0 0 1-4 4H32a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M114 127h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 69,
                y: 143,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M100.548 143h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint3_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 207.098,
                y: 115,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 207.098 115)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M108 86.632c-4.145 0-6.109-3.537-6.109-6.632 0 3.095-1.746 6.632-5.891 6.632 4.145 0 5.891 2.18 5.891 7.368 0-5.187 1.964-7.368 6.109-7.368ZM30 108.632c-4.145 0-6.11-3.537-6.11-6.632 0 3.095-1.745 6.632-5.89 6.632 4.145 0 5.89 2.181 5.89 7.368 0-5.187 1.965-7.368 6.11-7.368Z",
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M218.956 53.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.038.142l-2.862 1.653 2.861 1.652c.05.029.067.092.039.142l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.862-1.652-2.862-1.653a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100,
                y: 154,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100,
                y: 166,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100,
                y: 178,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m173.162 115.98.003.003 11.335 10.239V195a9.5 9.5 0 0 1-9.5 9.5h-51a9.5 9.5 0 0 1-9.5-9.5v-79a9.5 9.5 0 0 1 9.5-9.5h38.806l10.356 9.48Z",
                fill: "#FFFBFF",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M169.774 124H184v72a9 9 0 0 1-9 9h-18.5l13.274-81Z",
                fill: "url(#paint4_linear_6485_85356)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 149,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 139,
                width: 7,
                height: 6,
                rx: 2,
                fill: "#FFC3F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 138,
                y: 139,
                width: 18,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 172,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 159,
                y: 172,
                width: 14,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 161,
                width: 49,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 124,
                y: 184,
                width: 32,
                height: 6,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M130.8 130.015c4.003 0 7.25-3.237 7.25-7.233 0-3.995-3.247-7.232-7.25-7.232s-7.25 3.237-7.25 7.232c0 3.996 3.247 7.233 7.25 7.233Z",
                stroke: "url(#paint5_linear_6485_85356)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 130.8,
                cy: 122.783,
                rx: 6.152,
                ry: 6.136,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1.756,
                height: 5.268,
                rx: 0.878,
                transform: "rotate(-44.926 211.263 -91.91)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.024,
                height: 1.756,
                rx: 0.878,
                transform: "rotate(-44.926 215.506 -93.677)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M153 79a4 4 0 0 1 4-4h25v17h-25a4 4 0 0 1-4-4v-9Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.7,
                d: "M245.5 88a4 4 0 0 1-4 4H182V75h59.5a4 4 0 0 1 4 4v9Z",
                fill: "#FFA9EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M221 92.5h20a5 5 0 0 0 5-5V82",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.7,
                d: "M101 95H34a4 4 0 0 0-4 4v7",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M163.5 116v-8.863l20.027 18.363H173a9.5 9.5 0 0 1-9.5-9.5Z",
                fill: "#fff",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M160.5 74.5H193",
                stroke: "#C9AAC1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#fff",
                d: "M131 101h14v6h-14z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 157,
                y: 82,
                width: 18,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 192,
                y: 82,
                width: 49,
                height: 3,
                rx: 1.5,
                fill: "#635452",
                fillOpacity: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M182 76v16",
                stroke: "#B18BA1",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 83.5,
                cy: 159.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_6485_85356",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 76,
                y: 152,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 83.5,
                    cy: 159.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_6485_85356)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M83.434 154.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M34 146a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6485_85356",
                        x1: 57.329,
                        y1: 213.747,
                        x2: 24.255,
                        y2: 153.83,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6485_85356",
                        x1: 120.556,
                        y1: 126.099,
                        x2: 151.327,
                        y2: 228.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_6485_85356",
                        x1: 192,
                        y1: 213.001,
                        x2: -17,
                        y2: 80.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_6485_85356",
                        x1: 130.59,
                        y1: 168.664,
                        x2: 90.951,
                        y2: 193.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_6485_85356",
                        x1: 184.795,
                        y1: 161.121,
                        x2: 158.308,
                        y2: 166.914,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#E1CEE8"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFFBFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_6485_85356",
                        x1: 125.619,
                        y1: 117.938,
                        x2: 137.57,
                        y2: 129.596,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#83DA85"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $1edc5bf75e3ca205$export$2e2bcd8739ae039 = $1edc5bf75e3ca205$var$SvgPermissionsEmpty;



var $emGEN = parcelRequire("emGEN");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $bf4fb85417208454$var$SvgSearch = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8 12a4 4 0 1 1 0-8 4 4 0 0 1 0 8Zm9.707 4.293-4.82-4.82A5.968 5.968 0 0 0 14 8 6 6 0 0 0 2 8a6 6 0 0 0 6 6 5.968 5.968 0 0 0 3.473-1.113l4.82 4.82a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414Z",
            fill: "currentColor"
        })
    });
var $bf4fb85417208454$export$2e2bcd8739ae039 = $bf4fb85417208454$var$SvgSearch;



var $kcPww = parcelRequire("kcPww");

var $hdJkM = parcelRequire("hdJkM");
var $b0cc59a46c30c7ac$export$bfd64c937657f93a;
var $b0cc59a46c30c7ac$export$d76128d007d19019;
var $b0cc59a46c30c7ac$export$8687ffcdea58e000;
var $b0cc59a46c30c7ac$export$4a6dd88bada4e7d2;
$b0cc59a46c30c7ac$export$bfd64c937657f93a = `XhA89q_rotating`;
$b0cc59a46c30c7ac$export$d76128d007d19019 = `XhA89q_search`;
$b0cc59a46c30c7ac$export$8687ffcdea58e000 = `XhA89q_searchIcon`;
$b0cc59a46c30c7ac$export$4a6dd88bada4e7d2 = `XhA89q_shimmer`;


/**
 * The body-2 font declared in @logto/core-kit/scss/fonts. It is referenced here to calculate the
 * width of the placeholder text, which determines the minimum width of the search input field.
 */ const $4e917d0f808c0c52$var$fontBody2 = "400 14px / 20px -apple-system, system-ui, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji";
function $4e917d0f808c0c52$var$Search({ defaultValue: defaultValue = "", isClearable: isClearable = false, placeholder: placeholder = "", inputClassName: inputClassName, onSearch: onSearch, onClearSearch: onClearSearch }) {
    const [inputValue, setInputValue] = (0, $eCoWV.useState)(defaultValue);
    const [minInputWidth, setMinInputWidth] = (0, $eCoWV.useState)(0);
    const canvasRef = (0, $eCoWV.useRef)(null);
    const handleSearchKeyPress = (event)=>{
        if (event.key === "Enter" && inputValue) onSearch?.(inputValue);
    };
    const handleSearchChange = (event)=>{
        setInputValue(event.currentTarget.value);
    };
    const handleClick = ()=>{
        onSearch?.(inputValue);
    };
    (0, $eCoWV.useEffect)(()=>{
        // Render placeholder text in canvas to calculate its width in CSS pixels.
        const ctx = canvasRef.current?.getContext("2d");
        if (!ctx) return;
        ctx.font = $4e917d0f808c0c52$var$fontBody2;
        setMinInputWidth(ctx.measureText(placeholder).width);
    }, [
        placeholder
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $b0cc59a46c30c7ac$export$d76128d007d19019,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("canvas", {
                ref: canvasRef
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                className: inputClassName,
                value: inputValue,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                    className: $b0cc59a46c30c7ac$export$8687ffcdea58e000
                }),
                placeholder: placeholder,
                style: {
                    minWidth: `${minInputWidth}px`
                },
                onChange: handleSearchChange,
                onKeyPress: handleSearchKeyPress
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: "general.search",
                onClick: handleClick
            }),
            isClearable && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "small",
                type: "text",
                title: "general.clear_result",
                onClick: ()=>{
                    setInputValue("");
                    onClearSearch?.();
                }
            })
        ]
    });
}
var $4e917d0f808c0c52$export$2e2bcd8739ae039 = $4e917d0f808c0c52$var$Search;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $cwrCy = parcelRequire("cwrCy");

var $eCoWV = parcelRequire("eCoWV");
const $8b6f4bb60a2b907b$var$useCacheValue = (value)=>{
    const [cachedValue, setCachedValue] = (0, $eCoWV.useState)();
    (0, $eCoWV.useEffect)(()=>{
        if (value !== undefined) setCachedValue(value);
    }, [
        value
    ]);
    return cachedValue;
};
var $8b6f4bb60a2b907b$export$2e2bcd8739ae039 = $8b6f4bb60a2b907b$var$useCacheValue;



var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $9zeGj = parcelRequire("9zeGj");
function $a73f3329222a577d$var$Next() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.9509 9.40832L8.23425 4.69999C8.15679 4.62188 8.06462 4.55989 7.96307 4.51758C7.86152 4.47527 7.7526 4.45349 7.64259 4.45349C7.53258 4.45349 7.42366 4.47527 7.32211 4.51758C7.22056 4.55989 7.12839 4.62188 7.05092 4.69999C6.89571 4.85613 6.80859 5.06734 6.80859 5.28749C6.80859 5.50764 6.89571 5.71885 7.05092 5.87499L11.1759 10.0417L7.05092 14.1667C6.89571 14.3228 6.80859 14.534 6.80859 14.7542C6.80859 14.9743 6.89571 15.1855 7.05092 15.3417C7.1281 15.4204 7.22014 15.483 7.3217 15.526C7.42326 15.5689 7.53233 15.5912 7.64259 15.5917C7.75284 15.5912 7.86191 15.5689 7.96348 15.526C8.06504 15.483 8.15708 15.4204 8.23425 15.3417L12.9509 10.6333C13.0355 10.5553 13.103 10.4606 13.1492 10.3552C13.1954 10.2497 13.2192 10.1359 13.2192 10.0208C13.2192 9.90574 13.1954 9.7919 13.1492 9.68648C13.103 9.58107 13.0355 9.48636 12.9509 9.40832Z",
            fill: "#747778"
        })
    });
}
var $a73f3329222a577d$export$2e2bcd8739ae039 = $a73f3329222a577d$var$Next;



var $9zeGj = parcelRequire("9zeGj");
function $7916d3a0dd31eab8$var$Previous() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M7.04908 9.40832L11.7657 4.69999C11.8432 4.62188 11.9354 4.55989 12.0369 4.51758C12.1385 4.47527 12.2474 4.45349 12.3574 4.45349C12.4674 4.45349 12.5763 4.47527 12.6779 4.51758C12.7794 4.55989 12.8716 4.62188 12.9491 4.69999C13.1043 4.85613 13.1914 5.06734 13.1914 5.28749C13.1914 5.50764 13.1043 5.71885 12.9491 5.87499L8.82408 10.0417L12.9491 14.1667C13.1043 14.3228 13.1914 14.534 13.1914 14.7542C13.1914 14.9743 13.1043 15.1855 12.9491 15.3417C12.8719 15.4204 12.7799 15.483 12.6783 15.526C12.5767 15.5689 12.4677 15.5912 12.3574 15.5917C12.2472 15.5912 12.1381 15.5689 12.0365 15.526C11.935 15.483 11.8429 15.4204 11.7657 15.3417L7.04908 10.6333C6.96449 10.5553 6.89698 10.4606 6.85081 10.3552C6.80464 10.2497 6.7808 10.1359 6.7808 10.0208C6.7808 9.90574 6.80464 9.7919 6.85081 9.68648C6.89698 9.58107 6.96449 9.48636 7.04908 9.40832Z",
            fill: "#747778"
        })
    });
}
var $7916d3a0dd31eab8$export$2e2bcd8739ae039 = $7916d3a0dd31eab8$var$Previous;


var $d3a8f1b7cd67c036$export$89da14300d534261;
var $d3a8f1b7cd67c036$export$2ba01fb71ed41cb6;
var $d3a8f1b7cd67c036$export$34e0f9847d4c02dd;
var $d3a8f1b7cd67c036$export$683472f6198a076e;
var $d3a8f1b7cd67c036$export$22fa394f3ba39578;
var $d3a8f1b7cd67c036$export$e10c52a2ab594201;
var $d3a8f1b7cd67c036$export$a04a6574f0d14896;
var $d3a8f1b7cd67c036$export$bfd64c937657f93a;
var $d3a8f1b7cd67c036$export$4a6dd88bada4e7d2;
$d3a8f1b7cd67c036$export$89da14300d534261 = `i6FXZq_active`;
$d3a8f1b7cd67c036$export$2ba01fb71ed41cb6 = `i6FXZq_button`;
$d3a8f1b7cd67c036$export$34e0f9847d4c02dd = `i6FXZq_container`;
$d3a8f1b7cd67c036$export$683472f6198a076e = `i6FXZq_disabled`;
$d3a8f1b7cd67c036$export$22fa394f3ba39578 = `i6FXZq_pagination`;
$d3a8f1b7cd67c036$export$e10c52a2ab594201 = `i6FXZq_pico`;
$d3a8f1b7cd67c036$export$a04a6574f0d14896 = `i6FXZq_positionInfo`;
$d3a8f1b7cd67c036$export$bfd64c937657f93a = `i6FXZq_rotating`;
$d3a8f1b7cd67c036$export$4a6dd88bada4e7d2 = `i6FXZq_shimmer`;


function $226d823c87c084c3$var$Pagination({ page: page, totalCount: totalCount, pageSize: pageSize, className: className, mode: mode = "normal", onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    /**
   * Note:
   * The `totalCount` will become `undefined` temporarily when fetching data on page changes, and this causes the pagination to disappear.
   * Cache `totalCount` to solve this problem.
   */ const cachedTotalCount = (0, $8b6f4bb60a2b907b$export$2e2bcd8739ae039)(totalCount) ?? 0;
    const pageCount = Math.ceil(cachedTotalCount / pageSize);
    if (pageCount <= 1) return null;
    const min = (page - 1) * pageSize + 1;
    const max = Math.min(page * pageSize, cachedTotalCount);
    const isPicoMode = mode === "pico";
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d3a8f1b7cd67c036$export$34e0f9847d4c02dd, isPicoMode && $d3a8f1b7cd67c036$export$e10c52a2ab594201, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d3a8f1b7cd67c036$export$a04a6574f0d14896,
                children: t("general.page_info", {
                    min: min,
                    max: max,
                    total: cachedTotalCount
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cwrCy))), {
                className: $d3a8f1b7cd67c036$export$22fa394f3ba39578,
                pageCount: pageCount,
                forcePage: page - 1,
                pageLabelBuilder: (pageNumber)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: pageNumber === page ? "outline" : "default",
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d3a8f1b7cd67c036$export$2ba01fb71ed41cb6, pageNumber === page && $d3a8f1b7cd67c036$export$89da14300d534261),
                        size: "small",
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                            children: pageNumber
                        })
                    }),
                previousLabel: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    className: $d3a8f1b7cd67c036$export$2ba01fb71ed41cb6,
                    size: "small",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7916d3a0dd31eab8$export$2e2bcd8739ae039), {}),
                    disabled: page === 1
                }),
                nextLabel: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    className: $d3a8f1b7cd67c036$export$2ba01fb71ed41cb6,
                    size: "small",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a73f3329222a577d$export$2e2bcd8739ae039), {}),
                    disabled: page === pageCount
                }),
                breakLabel: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    className: $d3a8f1b7cd67c036$export$2ba01fb71ed41cb6,
                    size: "small",
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                        children: "..."
                    })
                }),
                disabledClassName: $d3a8f1b7cd67c036$export$683472f6198a076e,
                pageRangeDisplayed: isPicoMode ? -1 : undefined,
                marginPagesDisplayed: isPicoMode ? 0 : undefined,
                onPageChange: ({ selected: selected })=>{
                    onChange?.(selected + 1);
                }
            })
        ]
    });
}
var $226d823c87c084c3$export$2e2bcd8739ae039 = $226d823c87c084c3$var$Pagination;



var $d0Zvy = parcelRequire("d0Zvy");

var $9zeGj = parcelRequire("9zeGj");
var $04ccac2b26c2aee9$export$345c5736c8054f22;
var $04ccac2b26c2aee9$export$a7db06668cad9adb;
var $04ccac2b26c2aee9$export$d532169bc1db23fb;
var $04ccac2b26c2aee9$export$4b409e53cf4df6e6;
var $04ccac2b26c2aee9$export$bfd64c937657f93a;
var $04ccac2b26c2aee9$export$120ff0929b202a6d;
var $04ccac2b26c2aee9$export$4a6dd88bada4e7d2;
var $04ccac2b26c2aee9$export$896d2bb7e421ffa1;
var $04ccac2b26c2aee9$export$fb184b623420d9be;
$04ccac2b26c2aee9$export$345c5736c8054f22 = `YeJh6G_avatar`;
$04ccac2b26c2aee9$export$a7db06668cad9adb = `YeJh6G_content`;
$04ccac2b26c2aee9$export$d532169bc1db23fb = `YeJh6G_itemPreview`;
$04ccac2b26c2aee9$export$4b409e53cf4df6e6 = `YeJh6G_rect`;
$04ccac2b26c2aee9$export$bfd64c937657f93a = `YeJh6G_rotating`;
$04ccac2b26c2aee9$export$120ff0929b202a6d = `YeJh6G_row`;
$04ccac2b26c2aee9$export$4a6dd88bada4e7d2 = `YeJh6G_shimmer`;
$04ccac2b26c2aee9$export$4a6dd88bada4e7d2;
$04ccac2b26c2aee9$export$896d2bb7e421ffa1 = `YeJh6G_subTitle`;
$04ccac2b26c2aee9$export$fb184b623420d9be = `YeJh6G_title`;


function $64157299d3e2c8ad$var$Skeleton({ columnSpans: columnSpans, isCompact: isCompact }) {
    if (isCompact) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: Array.from({
            length: 2
        }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
                children: columnSpans.map((colSpan, columnIndex)=>// eslint-disable-next-line react/no-array-index-key
                    /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                        colSpan: colSpan,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $04ccac2b26c2aee9$export$4b409e53cf4df6e6
                        })
                    }, columnIndex))
            }, `row-${rowIndex}`))
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: Array.from({
            length: 8
        }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsxs)("tr", {
                className: $04ccac2b26c2aee9$export$120ff0929b202a6d,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                        colSpan: columnSpans[0],
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $04ccac2b26c2aee9$export$d532169bc1db23fb,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $04ccac2b26c2aee9$export$345c5736c8054f22
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $04ccac2b26c2aee9$export$a7db06668cad9adb,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $04ccac2b26c2aee9$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $04ccac2b26c2aee9$export$896d2bb7e421ffa1
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    columnSpans.slice(1).map((colSpan, index)=>// eslint-disable-next-line react/no-array-index-key
                        /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                            colSpan: colSpan,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $04ccac2b26c2aee9$export$4b409e53cf4df6e6
                            })
                        }, index))
                ]
            }, `row-${rowIndex}`))
    });
}
var $64157299d3e2c8ad$export$2e2bcd8739ae039 = $64157299d3e2c8ad$var$Skeleton;



var $9zeGj = parcelRequire("9zeGj");
var $6a66d152c02a6d86$export$a7db06668cad9adb;
var $6a66d152c02a6d86$export$bfd64c937657f93a;
var $6a66d152c02a6d86$export$4a6dd88bada4e7d2;
var $6a66d152c02a6d86$export$19fc884436501bea;
$6a66d152c02a6d86$export$a7db06668cad9adb = `yl7C0q_content`;
$6a66d152c02a6d86$export$bfd64c937657f93a = `yl7C0q_rotating`;
$6a66d152c02a6d86$export$4a6dd88bada4e7d2 = `yl7C0q_shimmer`;
$6a66d152c02a6d86$export$19fc884436501bea = `yl7C0q_tableEmptyWrapper`;


function $db3083ab4721f6a0$var$TableEmptyWrapper({ columns: columns, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
            colSpan: columns,
            className: $6a66d152c02a6d86$export$19fc884436501bea,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6a66d152c02a6d86$export$a7db06668cad9adb,
                children: children
            })
        })
    });
}
var $db3083ab4721f6a0$export$2e2bcd8739ae039 = $db3083ab4721f6a0$var$TableEmptyWrapper;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $93h5F = parcelRequire("93h5F");

var $kcPww = parcelRequire("kcPww");
var $9ab824240cf6f3c5$export$a7db06668cad9adb;
var $9ab824240cf6f3c5$export$bfd64c937657f93a;
var $9ab824240cf6f3c5$export$4a6dd88bada4e7d2;
var $9ab824240cf6f3c5$export$2229a34b9ab2b766;
var $9ab824240cf6f3c5$export$fb184b623420d9be;
$9ab824240cf6f3c5$export$a7db06668cad9adb = `KxIFNq_content`;
$9ab824240cf6f3c5$export$bfd64c937657f93a = `KxIFNq_rotating`;
$9ab824240cf6f3c5$export$4a6dd88bada4e7d2 = `KxIFNq_shimmer`;
$9ab824240cf6f3c5$export$2229a34b9ab2b766 = `KxIFNq_tableError`;
$9ab824240cf6f3c5$export$fb184b623420d9be = `KxIFNq_title`;


function $f7ff385d1d8beb95$var$TableError({ title: title, content: content, onRetry: onRetry, columns: columns }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
            colSpan: columns,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $9ab824240cf6f3c5$export$2229a34b9ab2b766,
                children: [
                    theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d002392bb0267558$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9fbe619fa1af843c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $9ab824240cf6f3c5$export$fb184b623420d9be,
                        children: title ?? t("errors.something_went_wrong")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $9ab824240cf6f3c5$export$a7db06668cad9adb,
                        children: content ?? t("errors.unknown_server_error")
                    }),
                    onRetry && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.retry",
                        onClick: onRetry
                    })
                ]
            })
        })
    });
}
var $f7ff385d1d8beb95$export$2e2bcd8739ae039 = $f7ff385d1d8beb95$var$TableError;


var $81d65c87c104529c$export$46a4a5faf57246fb;
var $81d65c87c104529c$export$60d5655c6babb2a0;
var $81d65c87c104529c$export$34e0f9847d4c02dd;
var $81d65c87c104529c$export$6e22c362a0406a2c;
var $81d65c87c104529c$export$3dea766d36a8935f;
var $81d65c87c104529c$export$d9ce03847cc286f2;
var $81d65c87c104529c$export$adb608be33961c98;
var $81d65c87c104529c$export$e77b9811020023f0;
var $81d65c87c104529c$export$ac4de22553a86e47;
var $81d65c87c104529c$export$6418f2f28151f498;
var $81d65c87c104529c$export$2712072f82bc811d;
var $81d65c87c104529c$export$22fa394f3ba39578;
var $81d65c87c104529c$export$bfd64c937657f93a;
var $81d65c87c104529c$export$4a6dd88bada4e7d2;
var $81d65c87c104529c$export$f2d5245d66b09437;
$81d65c87c104529c$export$46a4a5faf57246fb = `Orfd3G_bodyTable`;
$81d65c87c104529c$export$60d5655c6babb2a0 = `Orfd3G_clickable`;
$81d65c87c104529c$export$34e0f9847d4c02dd = `Orfd3G_container`;
$81d65c87c104529c$export$6e22c362a0406a2c = `Orfd3G_empty`;
$81d65c87c104529c$export$3dea766d36a8935f = `Orfd3G_filter`;
$81d65c87c104529c$export$d9ce03847cc286f2 = `Orfd3G_filterContainer`;
$81d65c87c104529c$export$adb608be33961c98 = `Orfd3G_footer`;
$81d65c87c104529c$export$e77b9811020023f0 = `Orfd3G_hasBorder`;
$81d65c87c104529c$export$ac4de22553a86e47 = `Orfd3G_headerTable`;
$81d65c87c104529c$export$6418f2f28151f498 = `Orfd3G_hideTopBorderRadius`;
$81d65c87c104529c$export$2712072f82bc811d = `Orfd3G_hoverEffect`;
$81d65c87c104529c$export$22fa394f3ba39578 = `Orfd3G_pagination`;
$81d65c87c104529c$export$bfd64c937657f93a = `Orfd3G_rotating`;
$81d65c87c104529c$export$4a6dd88bada4e7d2 = `Orfd3G_shimmer`;
$81d65c87c104529c$export$f2d5245d66b09437 = `Orfd3G_tableContainer`;


function $90f8b92e12ac536b$var$Table({ rowGroups: rowGroups, columns: columns, rowIndexKey: rowIndexKey, filter: filter, isRowHoverEffectDisabled: isRowHoverEffectDisabled = false, rowClickHandler: rowClickHandler, isRowClickable: isRowClickable = ()=>Boolean(rowClickHandler), rowClassName: rowClassName, className: className, headerTableClassName: headerTableClassName, bodyTableWrapperClassName: bodyTableWrapperClassName, isLoading: isLoading, pagination: pagination, placeholder: placeholder, loadingSkeleton: loadingSkeleton, errorMessage: errorMessage, hasBorder: hasBorder, onRetry: onRetry, footer: footer }) {
    const totalColspan = columns.reduce((result, { colSpan: colSpan })=>{
        return result + (colSpan ?? 1);
    }, 0);
    const hasData = rowGroups.some(({ data: data })=>data?.length);
    const hasError = !isLoading && !hasData && errorMessage;
    const isEmpty = !isLoading && !hasData && !errorMessage;
    const isLoaded = !isLoading && hasData;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($81d65c87c104529c$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($81d65c87c104529c$export$f2d5245d66b09437, hasBorder && $81d65c87c104529c$export$e77b9811020023f0),
                children: [
                    filter && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $81d65c87c104529c$export$d9ce03847cc286f2,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $81d65c87c104529c$export$3dea766d36a8935f,
                            children: filter
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("table", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($81d65c87c104529c$export$ac4de22553a86e47, filter && $81d65c87c104529c$export$6418f2f28151f498, headerTableClassName),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
                                children: columns.map(({ title: title, colSpan: colSpan, dataIndex: dataIndex })=>/*#__PURE__*/ (0, $9zeGj.jsx)("th", {
                                        colSpan: colSpan,
                                        children: title
                                    }, dataIndex))
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($81d65c87c104529c$export$46a4a5faf57246fb, isEmpty && $81d65c87c104529c$export$6e22c362a0406a2c, bodyTableWrapperClassName),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("table", {
                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("tbody", {
                                children: [
                                    isLoading && (loadingSkeleton ?? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $64157299d3e2c8ad$export$2e2bcd8739ae039), {
                                        isCompact: hasBorder,
                                        columnSpans: columns.map(({ colSpan: colSpan })=>colSpan ?? 1)
                                    })),
                                    hasError && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f7ff385d1d8beb95$export$2e2bcd8739ae039), {
                                        columns: columns.length,
                                        content: errorMessage,
                                        onRetry: onRetry
                                    }),
                                    isEmpty && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $db3083ab4721f6a0$export$2e2bcd8739ae039), {
                                        columns: columns.length,
                                        children: placeholder
                                    }),
                                    isLoaded && rowGroups.map(({ key: key, label: label, labelClassName: labelClassName, data: data })=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $eCoWV.Fragment), {
                                            children: [
                                                label && /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                                        colSpan: totalColspan,
                                                        className: labelClassName,
                                                        children: label
                                                    })
                                                }),
                                                data?.map((row, rowIndex)=>{
                                                    const rowClickable = isRowClickable(row);
                                                    const onClick = (0, $5CQIb.conditional)(rowClickable && rowClickHandler && (()=>{
                                                        rowClickHandler(row);
                                                    }));
                                                    return /*#__PURE__*/ (0, $9zeGj.jsx)("tr", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(rowClickable && $81d65c87c104529c$export$60d5655c6babb2a0, !isRowHoverEffectDisabled && $81d65c87c104529c$export$2712072f82bc811d, rowClassName?.(row, rowIndex)),
                                                        onClick: onClick,
                                                        children: columns.map(({ dataIndex: dataIndex, colSpan: colSpan, className: className, render: render })=>/*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                                                colSpan: colSpan,
                                                                className: className,
                                                                children: render(row, rowIndex)
                                                            }, dataIndex))
                                                    }, row[rowIndexKey]);
                                                })
                                            ]
                                        }, key))
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $81d65c87c104529c$export$adb608be33961c98,
                children: [
                    footer ?? /*#__PURE__*/ (0, $9zeGj.jsx)("div", {}),
                    pagination && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $226d823c87c084c3$export$2e2bcd8739ae039), {
                        className: $81d65c87c104529c$export$22fa394f3ba39578,
                        ...pagination
                    })
                ]
            })
        ]
    });
}
var $90f8b92e12ac536b$export$2e2bcd8739ae039 = $90f8b92e12ac536b$var$Table;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $93h5F = parcelRequire("93h5F");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");
var $74e0227d83072843$export$31eb53bd5b582a97;
var $74e0227d83072843$export$6d59db4903f20f7d;
var $74e0227d83072843$export$5c452ff88e35e47d;
var $74e0227d83072843$export$c7187bbd1a7a9244;
var $74e0227d83072843$export$bfd64c937657f93a;
var $74e0227d83072843$export$4a6dd88bada4e7d2;
var $74e0227d83072843$export$fb184b623420d9be;
$74e0227d83072843$export$31eb53bd5b582a97 = `uyn--W_action`;
$74e0227d83072843$export$6d59db4903f20f7d = `uyn--W_description`;
$74e0227d83072843$export$5c452ff88e35e47d = `uyn--W_image`;
$74e0227d83072843$export$c7187bbd1a7a9244 = `uyn--W_placeholder`;
$74e0227d83072843$export$bfd64c937657f93a = `uyn--W_rotating`;
$74e0227d83072843$export$4a6dd88bada4e7d2 = `uyn--W_shimmer`;
$74e0227d83072843$export$fb184b623420d9be = `uyn--W_title`;


function $93faad655816a21c$var$TablePlaceholder({ image: image, imageDark: imageDark, title: title, description: description, learnMoreLink: learnMoreLink, action: action }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $74e0227d83072843$export$c7187bbd1a7a9244,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $74e0227d83072843$export$5c452ff88e35e47d,
                children: theme === (0, $bhvxB.Theme).Light ? image : imageDark
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $74e0227d83072843$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $74e0227d83072843$export$6d59db4903f20f7d,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: description
                    }),
                    learnMoreLink?.href && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            " ",
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                href: learnMoreLink.href,
                                targetBlank: learnMoreLink.targetBlank,
                                children: t("general.learn_more")
                            })
                        ]
                    })
                ]
            }),
            action && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $74e0227d83072843$export$31eb53bd5b582a97,
                children: action
            })
        ]
    });
}
var $93faad655816a21c$export$2e2bcd8739ae039 = $93faad655816a21c$var$TablePlaceholder;




var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $0241037c1de431d6$var$SvgTableEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M22.5 198h81m13 0h-6",
                stroke: "#4E5075",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.815 132.884c0-1.384.957-2.583 2.306-2.89l62.223-14.141a2.969 2.969 0 0 1 1.313 0l62.222 14.141a2.964 2.964 0 0 1 2.307 2.89v63.418a2.964 2.964 0 0 1-2.307 2.889l-62.222 14.141a2.969 2.969 0 0 1-1.313 0l-62.223-14.141a2.963 2.963 0 0 1-2.306-2.889v-63.418Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.815 134.23a2.963 2.963 0 0 1 3.62-2.889l60.909 13.843c.432.098.881.098 1.313 0l60.909-13.843a2.964 2.964 0 0 1 3.62 2.889v62.072a2.964 2.964 0 0 1-2.307 2.889l-62.222 14.141a2.94 2.94 0 0 1-1.313 0l-62.223-14.141a2.963 2.963 0 0 1-2.306-2.889V134.23Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.815 134.23v62.072c0 1.383.958 2.582 2.307 2.889L106 213.482v-68.149l-61.566-13.992a2.963 2.963 0 0 0-3.62 2.889Z",
                fill: "url(#paint0_linear_490_14139)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.327 132.697a2.221 2.221 0 0 1 2.377-.989l62.115 14.117-13.146 21.034a2.221 2.221 0 0 1-2.377.989L30.23 154.424a2.222 2.222 0 0 1-1.392-3.345l11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint1_linear_490_14139)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M39.699 128.733a2.964 2.964 0 0 0 3.17 1.319L106 115.704 92.301 93.786a2.963 2.963 0 0 0-3.17-1.32l-59.065 13.425a2.962 2.962 0 0 0-1.856 4.459l11.489 18.383Z",
                fill: "#625881"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M171.673 132.697a2.221 2.221 0 0 0-2.377-.989l-62.115 14.117 13.146 21.034a2.221 2.221 0 0 0 2.377.989l59.066-13.424a2.222 2.222 0 0 0 1.392-3.345l-11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint2_linear_490_14139)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M172.301 128.733a2.964 2.964 0 0 1-3.169 1.319L106 115.704l13.699-21.918a2.963 2.963 0 0 1 3.169-1.32l59.066 13.425a2.962 2.962 0 0 1 1.856 4.459l-11.489 18.383Z",
                fill: "#625881"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m14.426 132.746 1.114 1.281a1.697 1.697 0 0 0 2.394.167v0a1.697 1.697 0 0 1 2.394.167v0a1.697 1.697 0 0 0 2.395.167l1.28-1.114",
                stroke: "#947DFF",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M179.289 103.654a3 3 0 0 1 3.899-4.56l10.641 9.098a3 3 0 0 1-3.899 4.561l-10.641-9.099Z",
                fill: "#C4B4E0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M182.759 102.674c10.049-11.753 8.668-29.428-3.085-39.478s-29.428-8.668-39.478 3.085c-10.049 11.753-8.668 29.428 3.085 39.478 11.753 10.049 29.428 8.668 39.478-3.085Zm-4.56-3.9c7.896-9.234 6.811-23.121-2.424-31.017-9.234-7.897-23.122-6.811-31.018 2.423-7.896 9.235-6.811 23.122 2.424 31.018 9.235 7.897 23.122 6.812 31.018-2.423Z",
                fill: "#DDA8E0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                opacity: 0.6,
                cx: 161.478,
                cy: 84.478,
                r: 22,
                transform: "rotate(-49.468 161.478 84.478)",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M161.458 67.901a15.927 15.927 0 0 0-7.958 2.116M150.436 95.5a16.05 16.05 0 0 1-3.062-4 15.93 15.93 0 0 1-1.916-7.599c0-2.276.475-4.44 1.332-6.401",
                stroke: "#FEE8FF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 184.94,
                y: 112.433,
                width: 12,
                height: 28,
                rx: 6,
                transform: "rotate(-49.468 184.94 112.433)",
                fill: "#C584D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90.916,
                y: 74.016,
                width: 2,
                height: 4,
                rx: 1,
                transform: "rotate(-21.657 90.916 74.016)",
                fill: "#D7C947"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 90,
                cy: 69,
                rx: 4,
                ry: 6,
                transform: "rotate(-21.657 90 69)",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87.417,
                cy: 62.494,
                r: 2,
                transform: "rotate(-21.657 87.417 62.494)",
                fill: "#6D698D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                opacity: 0.6,
                cx: 82.004,
                cy: 73.251,
                rx: 6,
                ry: 3,
                transform: "rotate(-37.657 82.004 73.25)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                opacity: 0.6,
                rx: 6,
                ry: 3,
                transform: "scale(1 -1) rotate(5.657 753.563 783.485)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                opacity: 0.6,
                rx: 6,
                ry: 3,
                transform: "scale(-1 1) rotate(5.657 -723.473 -965.922)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                opacity: 0.6,
                cx: 97.626,
                cy: 63.82,
                rx: 6,
                ry: 3,
                transform: "rotate(142.343 97.626 63.82)",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M95 82.5c3.833 2.167 10 9 4 19s.167 16.5 4 18.5",
                stroke: "#CABEFF",
                strokeLinecap: "round",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M141.5 209h81m13 0h-6",
                stroke: "#4E5075",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 219.562,
                y: 155.275,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-47.512 219.562 155.275)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 215.622,
                y: 151.748,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-71.512 215.622 151.748)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 8,
                height: 2,
                rx: 1,
                transform: "scale(1 -1) rotate(23.512 497.432 460.195)",
                fill: "#807694"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M145 165a8 8 0 0 1 8-8h27.823a1 1 0 0 1 .987 1.161L180.528 166l4.916 7-3.747 7.196L187.5 189l-1.833-8 4.583-6-3.25-9 5.703-8.555c.186-.278.498-.445.832-.445H209a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-36Z",
                fill: "#C4B4E0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M141 167h69",
                stroke: "#C9C5D0",
                strokeLinecap: "round",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 154,
                y: 171,
                width: 12,
                height: 12,
                rx: 4,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 154,
                y: 189,
                width: 24,
                height: 2,
                rx: 1,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 154,
                y: 195,
                width: 51,
                height: 2,
                rx: 1,
                fill: "#AC95D3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 151.5,
                cy: 162.5,
                r: 1.5,
                fill: "#FF897A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 156.5,
                cy: 162.5,
                r: 1.5,
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 161.5,
                cy: 162.5,
                r: 1.5,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 194.758,
                y: 19.621,
                width: 6,
                height: 6,
                rx: 0.12,
                transform: "rotate(-44.634 194.758 19.621)",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M234.009 76.33a.125.125 0 0 1 .171-.045l1.947 1.135a.127.127 0 0 1 .045.172l-1.998 3.424 3.965.018c.069 0 .124.057.124.126l-.01 2.253c0 .07-.057.125-.126.125l-3.965-.018 1.967 3.443a.125.125 0 0 1-.047.17l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.966-3.442-1.998 3.425a.126.126 0 0 1-.172.045l-1.946-1.135a.126.126 0 0 1-.045-.172l1.998-3.425-3.965-.018a.126.126 0 0 1-.125-.125l.011-2.253c0-.07.056-.125.125-.125l3.965.018-1.967-3.443a.126.126 0 0 1 .047-.17l1.956-1.118a.125.125 0 0 1 .171.046l1.967 3.443 1.998-3.425Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m45.259 25.757.029 2.263a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.263",
                stroke: "#8983A2",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_490_14139",
                        x1: 73.408,
                        y1: 130.519,
                        x2: 73.408,
                        y2: 213.482,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#423379"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#473296",
                                stopOpacity: 0.49
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_490_14139",
                        x1: 66,
                        y1: 130.519,
                        x2: 53.407,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CACCFE",
                                stopOpacity: 0.32
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_490_14139",
                        x1: 146,
                        y1: 130.519,
                        x2: 158.593,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CBCDFF",
                                stopOpacity: 0.32
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $0241037c1de431d6$export$2e2bcd8739ae039 = $0241037c1de431d6$var$SvgTableEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $6749a6e24544971c$var$SvgTableEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 257,
        height: 256,
        viewBox: "0 0 257 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M23 198h81m13 0h-6",
                stroke: "#ADAAB4",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M41.315 132.884c0-1.384.958-2.583 2.307-2.89l62.222-14.141a2.969 2.969 0 0 1 1.313 0l62.223 14.141a2.963 2.963 0 0 1 2.306 2.89v63.417a2.963 2.963 0 0 1-2.306 2.89l-62.223 14.141a2.969 2.969 0 0 1-1.313 0l-62.222-14.141a2.964 2.964 0 0 1-2.307-2.89v-63.417Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M41.315 134.23a2.963 2.963 0 0 1 3.62-2.889l60.909 13.843c.432.098.881.098 1.313 0l60.909-13.843a2.964 2.964 0 0 1 3.62 2.889v62.072a2.963 2.963 0 0 1-2.306 2.889l-62.223 14.141a2.94 2.94 0 0 1-1.313 0l-62.222-14.141a2.963 2.963 0 0 1-2.307-2.889V134.23Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M41.315 134.23v62.072c0 1.383.958 2.582 2.307 2.889l59.259 13.468a2.964 2.964 0 0 0 3.62-2.889v-63.638c0-.467-.323-.872-.779-.976l-60.787-13.815a2.963 2.963 0 0 0-3.62 2.889Z",
                fill: "url(#paint0_linear_5794_197247)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.827 132.697a2.221 2.221 0 0 1 2.377-.989l62.115 14.117-13.146 21.034a2.221 2.221 0 0 1-2.377.989L30.73 154.424a2.222 2.222 0 0 1-1.392-3.345l11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint1_linear_5794_197247)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.199 128.733a2.964 2.964 0 0 0 3.17 1.319l63.131-14.348-13.699-21.918a2.963 2.963 0 0 0-3.17-1.32l-59.065 13.425a2.962 2.962 0 0 0-1.856 4.459l11.489 18.383Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M172.173 132.697a2.221 2.221 0 0 0-2.377-.989l-62.115 14.117 13.146 21.034a2.221 2.221 0 0 0 2.377.989l59.066-13.424a2.222 2.222 0 0 0 1.392-3.345l-11.489-18.382Z",
                fill: "#CABEFF",
                fillOpacity: 0.16,
                stroke: "url(#paint2_linear_5794_197247)",
                strokeWidth: 1.481
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M172.801 128.733a2.964 2.964 0 0 1-3.169 1.319L106.5 115.704l13.699-21.918a2.963 2.963 0 0 1 3.169-1.32l59.066 13.425a2.962 2.962 0 0 1 1.856 4.459l-11.489 18.383Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m14.927 132.746 1.113 1.281a1.697 1.697 0 0 0 2.395.167v0a1.697 1.697 0 0 1 2.394.167v0a1.697 1.697 0 0 0 2.394.167l1.28-1.114",
                stroke: "#947DFF",
                strokeWidth: 1.2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M179.789 103.655a3 3 0 1 1 3.899-4.56l10.641 9.098a3 3 0 1 1-3.9 4.56l-10.64-9.098Z",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.259 102.674c10.049-11.753 8.668-29.428-3.085-39.477-11.753-10.05-29.428-8.669-39.478 3.084-10.049 11.754-8.668 29.428 3.085 39.478s29.428 8.669 39.478-3.085Zm-4.56-3.899c7.896-9.235 6.811-23.122-2.424-31.018-9.234-7.896-23.122-6.811-31.018 2.424-7.896 9.234-6.811 23.122 2.424 31.018 9.235 7.896 23.122 6.811 31.018-2.424Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                opacity: 0.6,
                cx: 161.978,
                cy: 84.478,
                r: 22,
                transform: "rotate(-49.468 161.978 84.478)",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M161.958 67.902A15.92 15.92 0 0 0 154 70.018M150.936 95.5a16.052 16.052 0 0 1-3.062-4 15.93 15.93 0 0 1-1.916-7.598c0-2.276.475-4.441 1.332-6.402",
                stroke: "#FEE8FF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 185.439,
                y: 112.434,
                width: 12,
                height: 28,
                rx: 6,
                transform: "rotate(-49.468 185.439 112.434)",
                fill: "#D361E7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 91.416,
                y: 74.016,
                width: 2,
                height: 4,
                rx: 1,
                transform: "rotate(-21.657 91.416 74.016)",
                fill: "#D7C947"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 90.5,
                cy: 69,
                rx: 4,
                ry: 6,
                transform: "rotate(-21.657 90.5 69)",
                fill: "#F4E560"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 87.916,
                cy: 62.494,
                r: 2,
                transform: "rotate(-21.657 87.916 62.494)",
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 82.505,
                cy: 73.251,
                rx: 6,
                ry: 3,
                transform: "rotate(-37.657 82.505 73.25)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                rx: 6,
                ry: 3,
                transform: "scale(1 -1) rotate(5.657 753.812 788.553)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                rx: 6,
                ry: 3,
                transform: "scale(-1 1) rotate(5.657 -723.723 -970.983)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 98.126,
                cy: 63.82,
                rx: 6,
                ry: 3,
                transform: "rotate(142.343 98.126 63.82)",
                fill: "#83DA85",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M95.5 82.5c3.833 2.167 10 9 4 19s.167 16.5 4 18.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M142 209h81m13 0h-6",
                stroke: "#ADAAB4",
                strokeWidth: 4,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 220.062,
                y: 155.274,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-47.512 220.062 155.274)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 216.122,
                y: 151.749,
                width: 8,
                height: 2,
                rx: 1,
                transform: "rotate(-71.512 216.122 151.749)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 8,
                height: 2,
                rx: 1,
                transform: "scale(1 -1) rotate(23.512 497.682 461.397)",
                fill: "#C4C7C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M145.5 165a8 8 0 0 1 8-8h27.823a1 1 0 0 1 .987 1.161L181.028 166l4.916 7-3.747 7.196L188 189l-1.833-8 4.583-6-3.25-9 5.703-8.555c.186-.278.498-.445.832-.445H209.5a8 8 0 0 1 8 8v36a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8v-36Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M141 167a.5.5 0 0 1 .5-.5h69a.5.5 0 0 1 0 1h-69a.5.5 0 0 1-.5-.5Z",
                fill: "#C9C5D0",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154.5 175a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v4a4 4 0 0 1-4 4h-4a4 4 0 0 1-4-4v-4Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154.5 190a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2h-22a1 1 0 0 1-1-1ZM154.5 196a1 1 0 0 1 1-1h49a1 1 0 0 1 0 2h-49a1 1 0 0 1-1-1Z",
                fill: "#C9C5D0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 152,
                cy: 162.5,
                r: 1.5,
                fill: "#FF897A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 157,
                cy: 162.5,
                r: 1.5,
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 162,
                cy: 162.5,
                r: 1.5,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 215.258,
                y: 22.621,
                width: 6,
                height: 6,
                rx: 0.12,
                transform: "rotate(-44.634 215.258 22.621)",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M234.509 76.33a.125.125 0 0 1 .171-.045l1.947 1.135a.126.126 0 0 1 .045.171l-1.998 3.425 3.965.018c.069 0 .124.057.124.126l-.01 2.253c0 .069-.057.125-.126.124l-3.965-.017 1.967 3.442a.126.126 0 0 1-.047.171l-1.956 1.118a.126.126 0 0 1-.171-.047l-1.966-3.442-1.998 3.425a.126.126 0 0 1-.172.045l-1.946-1.136a.126.126 0 0 1-.045-.17l1.998-3.426-3.965-.018a.126.126 0 0 1-.125-.126l.011-2.252c0-.07.056-.125.125-.125l3.965.018-1.967-3.443a.126.126 0 0 1 .047-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.998-3.425Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#F7F8F8",
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#78767F",
                strokeOpacity: 0.02,
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m45.758 25.757.029 2.263a2.263 2.263 0 0 0 2.291 2.233v0a2.263 2.263 0 0 1 2.292 2.234v0a2.263 2.263 0 0 0 2.292 2.233v0a2.263 2.263 0 0 1 2.291 2.234l.03 2.262",
                stroke: "#5D34F2",
                strokeOpacity: 0.11,
                strokeWidth: 1.6,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_5794_197247",
                        x1: 73.908,
                        y1: 130.519,
                        x2: 73.908,
                        y2: 213.482,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#4F33B7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#5337B8",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_5794_197247",
                        x1: 66.5,
                        y1: 130.519,
                        x2: 53.907,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A1A5FF",
                                stopOpacity: 0.32
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_5794_197247",
                        x1: 146.5,
                        y1: 130.519,
                        x2: 159.093,
                        y2: 165.333,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#2E2AF5",
                                stopOpacity: 0
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#A1A5FF",
                                stopOpacity: 0.32
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $6749a6e24544971c$export$2e2bcd8739ae039 = $6749a6e24544971c$var$SvgTableEmpty;



var $93h5F = parcelRequire("93h5F");
var $b07db566c89fcb05$exports = {};

$parcel$export($b07db566c89fcb05$exports, "description", function () { return $b07db566c89fcb05$export$6d59db4903f20f7d; }, function (v) { return $b07db566c89fcb05$export$6d59db4903f20f7d = v; });
$parcel$export($b07db566c89fcb05$exports, "empty", function () { return $b07db566c89fcb05$export$6e22c362a0406a2c; }, function (v) { return $b07db566c89fcb05$export$6e22c362a0406a2c = v; });
$parcel$export($b07db566c89fcb05$exports, "image", function () { return $b07db566c89fcb05$export$5c452ff88e35e47d; }, function (v) { return $b07db566c89fcb05$export$5c452ff88e35e47d = v; });
$parcel$export($b07db566c89fcb05$exports, "large", function () { return $b07db566c89fcb05$export$f09585a853dddd32; }, function (v) { return $b07db566c89fcb05$export$f09585a853dddd32 = v; });
$parcel$export($b07db566c89fcb05$exports, "medium", function () { return $b07db566c89fcb05$export$649ecc744817b5c7; }, function (v) { return $b07db566c89fcb05$export$649ecc744817b5c7 = v; });
$parcel$export($b07db566c89fcb05$exports, "rotating", function () { return $b07db566c89fcb05$export$bfd64c937657f93a; }, function (v) { return $b07db566c89fcb05$export$bfd64c937657f93a = v; });
$parcel$export($b07db566c89fcb05$exports, "shimmer", function () { return $b07db566c89fcb05$export$4a6dd88bada4e7d2; }, function (v) { return $b07db566c89fcb05$export$4a6dd88bada4e7d2 = v; });
$parcel$export($b07db566c89fcb05$exports, "small", function () { return $b07db566c89fcb05$export$3c17b0e969a90510; }, function (v) { return $b07db566c89fcb05$export$3c17b0e969a90510 = v; });
$parcel$export($b07db566c89fcb05$exports, "title", function () { return $b07db566c89fcb05$export$fb184b623420d9be; }, function (v) { return $b07db566c89fcb05$export$fb184b623420d9be = v; });
var $b07db566c89fcb05$export$6d59db4903f20f7d;
var $b07db566c89fcb05$export$6e22c362a0406a2c;
var $b07db566c89fcb05$export$5c452ff88e35e47d;
var $b07db566c89fcb05$export$f09585a853dddd32;
var $b07db566c89fcb05$export$649ecc744817b5c7;
var $b07db566c89fcb05$export$bfd64c937657f93a;
var $b07db566c89fcb05$export$4a6dd88bada4e7d2;
var $b07db566c89fcb05$export$3c17b0e969a90510;
var $b07db566c89fcb05$export$fb184b623420d9be;
$b07db566c89fcb05$export$6d59db4903f20f7d = `ljXalG_description`;
$b07db566c89fcb05$export$6e22c362a0406a2c = `ljXalG_empty`;
$b07db566c89fcb05$export$5c452ff88e35e47d = `ljXalG_image`;
$b07db566c89fcb05$export$f09585a853dddd32 = `ljXalG_large`;
$b07db566c89fcb05$export$649ecc744817b5c7 = `ljXalG_medium`;
$b07db566c89fcb05$export$bfd64c937657f93a = `ljXalG_rotating`;
$b07db566c89fcb05$export$4a6dd88bada4e7d2 = `ljXalG_shimmer`;
$b07db566c89fcb05$export$3c17b0e969a90510 = `ljXalG_small`;
$b07db566c89fcb05$export$fb184b623420d9be = `ljXalG_title`;


function $19005d7669ab632a$var$EmptyDataPlaceholder({ title: title, size: size = "medium", className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const EmptyImage = theme === (0, $bhvxB.Theme).Light ? (0, $6749a6e24544971c$export$2e2bcd8739ae039) : (0, $0241037c1de431d6$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b07db566c89fcb05$exports.empty, $b07db566c89fcb05$exports[size], className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(EmptyImage, {
                className: $b07db566c89fcb05$exports.image
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $b07db566c89fcb05$exports.title,
                children: title ?? t("errors.empty")
            })
        ]
    });
}
var $19005d7669ab632a$export$2e2bcd8739ae039 = $19005d7669ab632a$var$EmptyDataPlaceholder;


var $daf75bc9a373737c$export$9b6d6ca62970729f;
var $daf75bc9a373737c$export$f4f2d7d33085c714;
var $daf75bc9a373737c$export$6d59db4903f20f7d;
var $daf75bc9a373737c$export$3dea766d36a8935f;
var $daf75bc9a373737c$export$9c30223ca0a664fb;
var $daf75bc9a373737c$export$9abc8bff93154df;
var $daf75bc9a373737c$export$bfd64c937657f93a;
var $daf75bc9a373737c$export$4a6dd88bada4e7d2;
$daf75bc9a373737c$export$9b6d6ca62970729f = `vPj7DW_createButton`;
$daf75bc9a373737c$export$f4f2d7d33085c714 = `vPj7DW_deleteColumn`;
$daf75bc9a373737c$export$6d59db4903f20f7d = `vPj7DW_description`;
$daf75bc9a373737c$export$3dea766d36a8935f = `vPj7DW_filter`;
$daf75bc9a373737c$export$9c30223ca0a664fb = `vPj7DW_link`;
$daf75bc9a373737c$export$9abc8bff93154df = `vPj7DW_permissionTable`;
$daf75bc9a373737c$export$bfd64c937657f93a = `vPj7DW_rotating`;
$daf75bc9a373737c$export$4a6dd88bada4e7d2 = `vPj7DW_shimmer`;


function $d49945d5344ba010$var$PermissionsTable({ scopes: scopes, isLoading: isLoading, errorMessage: errorMessage, createButtonTitle: createButtonTitle, deleteButtonTitle: deleteButtonTitle = "general.delete", isReadOnly: isReadOnly = false, isApiColumnVisible: isApiColumnVisible = false, isCreateGuideVisible: isCreateGuideVisible = false, pagination: pagination, search: { keyword: keyword, searchHandler: searchHandler, clearSearchHandler: clearSearchHandler }, createHandler: createHandler, deleteHandler: deleteHandler, retryHandler: retryHandler }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const nameColumn = {
        title: t("permissions.name_column"),
        dataIndex: "name",
        colSpan: isApiColumnVisible ? 5 : 6,
        render: ({ name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                variant: "cell",
                children: name
            })
    };
    const descriptionColumn = {
        title: t("permissions.description_column"),
        dataIndex: "description",
        colSpan: isApiColumnVisible ? 5 : 9,
        render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $daf75bc9a373737c$export$6d59db4903f20f7d,
                children: description
            })
    };
    const apiColumn = {
        title: t("permissions.api_column"),
        dataIndex: "resource",
        colSpan: 5,
        render: ({ resource: resource })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                className: $daf75bc9a373737c$export$9c30223ca0a664fb,
                to: `/api-resources/${resource.id}/${(0, $emGEN.ApiResourceDetailsTabs).Settings}`,
                children: resource.name
            })
    };
    const deleteColumn = {
        title: null,
        dataIndex: "delete",
        colSpan: 2,
        className: $daf75bc9a373737c$export$f4f2d7d33085c714,
        render: (scope)=>/**
       * When the table is read-only, hide the delete button rather than the whole column to keep the table column spaces.
       */ isReadOnly ? null : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                content: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: deleteButtonTitle
                }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    onClick: ()=>{
                        deleteHandler(scope);
                    },
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                })
            })
    };
    const columns = [
        nameColumn,
        descriptionColumn,
        (0, $5CQIb.conditional)(isApiColumnVisible && apiColumn),
        deleteColumn
    ].filter((column)=>Boolean(column));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
        className: $daf75bc9a373737c$export$9abc8bff93154df,
        rowIndexKey: "id",
        rowGroups: [
            {
                key: "scopes",
                data: scopes
            }
        ],
        columns: columns,
        filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $daf75bc9a373737c$export$3dea766d36a8935f,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                    defaultValue: keyword,
                    isClearable: Boolean(keyword),
                    placeholder: t(isApiColumnVisible ? "permissions.search_placeholder" : "permissions.search_placeholder_without_api"),
                    onSearch: searchHandler,
                    onClearSearch: clearSearchHandler
                }),
                !isReadOnly && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: createButtonTitle,
                    className: $daf75bc9a373737c$export$9b6d6ca62970729f,
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        createHandler();
                    }
                })
            ]
        }),
        isLoading: isLoading,
        pagination: pagination,
        placeholder: !isReadOnly && isCreateGuideVisible ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
            image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1edc5bf75e3ca205$export$2e2bcd8739ae039), {}),
            imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e6114bf161d390f$export$2e2bcd8739ae039), {}),
            title: "permissions.placeholder_title",
            description: "permissions.placeholder_description",
            learnMoreLink: {
                href: getDocumentationUrl("/docs/recipes/rbac/manage-permissions-and-roles"),
                targetBlank: "noopener"
            },
            action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: createButtonTitle,
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    createHandler();
                }
            })
        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
        errorMessage: errorMessage,
        onRetry: retryHandler
    });
}
var $d49945d5344ba010$export$2e2bcd8739ae039 = $d49945d5344ba010$var$PermissionsTable;



var $6ZMK7 = parcelRequire("6ZMK7");

var $kMAP9 = parcelRequire("kMAP9");

var $2ANSb = parcelRequire("2ANSb");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $8pPfi = parcelRequire("8pPfi");
/**
 * Watch search parameters
 *
 * @param config Define search parameter keys and their default value. E.g., `{ page: 1, keyword: '' }`
 * @returns [searchParams, updateSearchParams]
 */ const $844674d3e76c47e1$var$useSearchParametersWatcher = (config)=>{
    const [searchParameters, setSearchParameters] = (0, $8pPfi.useSearchParams)();
    const updateSearchParameters = (0, $eCoWV.useCallback)((parameters)=>{
        const baseParameters = new URLSearchParams(searchParameters);
        for (const key of Object.keys(parameters)){
            // eslint-disable-next-line no-restricted-syntax
            const value = parameters[key];
            if (value === undefined) baseParameters.delete(key);
            else baseParameters.set(key, String(value));
        }
        setSearchParameters(baseParameters);
    }, [
        searchParameters,
        setSearchParameters
    ]);
    return [
        // eslint-disable-next-line no-restricted-syntax
        Object.fromEntries(Object.entries(config).map(([parameterKey, defaultValue])=>{
            const locationParameterValue = searchParameters.get(parameterKey);
            const parameterValue = typeof defaultValue === "string" ? locationParameterValue ?? defaultValue : (0, $5CQIb.conditional)(locationParameterValue && Number(locationParameterValue)) ?? defaultValue;
            return [
                parameterKey,
                parameterValue
            ];
        })),
        updateSearchParameters
    ];
};
var $844674d3e76c47e1$export$2e2bcd8739ae039 = $844674d3e76c47e1$var$useSearchParametersWatcher;



var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $1Iq4D = parcelRequire("1Iq4D");
function $954fb8e7e9037d3a$var$ContactUsPhraseLink({ children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
        href: (0, $o53Y2.contactEmailLink),
        children: children
    });
}
var $954fb8e7e9037d3a$export$2e2bcd8739ae039 = $954fb8e7e9037d3a$var$ContactUsPhraseLink;




var $9zeGj = parcelRequire("9zeGj");

var $kcPww = parcelRequire("kcPww");

var $4W0F0 = parcelRequire("4W0F0");
var $d5a9dd71522e9838$export$34e0f9847d4c02dd;
var $d5a9dd71522e9838$export$6d59db4903f20f7d;
var $d5a9dd71522e9838$export$bfd64c937657f93a;
var $d5a9dd71522e9838$export$4a6dd88bada4e7d2;
$d5a9dd71522e9838$export$34e0f9847d4c02dd = `lK2u-q_container`;
$d5a9dd71522e9838$export$6d59db4903f20f7d = `lK2u-q_description`;
$d5a9dd71522e9838$export$bfd64c937657f93a = `lK2u-q_rotating`;
$d5a9dd71522e9838$export$4a6dd88bada4e7d2 = `lK2u-q_shimmer`;


function $11524bf69118eb72$var$QuotaGuardFooter({ children: children }) {
    const { navigate: navigate } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d5a9dd71522e9838$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d5a9dd71522e9838$export$6d59db4903f20f7d,
                children: children
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "large",
                type: "primary",
                title: "upsell.upgrade_plan",
                onClick: ()=>{
                    navigate("/tenant-settings/subscription");
                }
            })
        ]
    });
}
var $11524bf69118eb72$export$2e2bcd8739ae039 = $11524bf69118eb72$var$QuotaGuardFooter;



var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");

var $V1X8c = parcelRequire("V1X8c");
const $ce29ac0c76414b31$export$1cc4b5152472cd4f = ({ quotaKey: quotaKey, usage: usage, plan: plan })=>{
    // If the plan is not loaded, guarded by backend APIs
    if (!(0, $V1X8c.isCloud) || !plan) return false;
    const quotaValue = plan.quota[quotaKey];
    // Unlimited
    if (quotaValue === null) return false;
    if (typeof quotaValue === "boolean") return !quotaValue;
    return usage >= quotaValue;
};


function $f38b19623af82fb3$var$CreatePermissionModal({ resourceId: resourceId, totalResourceCount: totalResourceCount, onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)();
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const createdScope = await api.post(`api/resources/${resourceId}/scopes`, {
            json: formData
        }).json();
        onClose(createdScope);
    }));
    const isScopesPerResourceReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "scopesPerResourceLimit",
        plan: currentPlan,
        usage: totalResourceCount
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "api_resource_details.permission.create_title",
            subtitle: "api_resource_details.permission.create_subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-role-permissions",
                targetBlank: "noopener"
            },
            footer: isScopesPerResourceReachLimit && currentPlan ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.scopes_per_resource", {
                        count: currentPlan.quota.scopesPerResourceLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                htmlType: "submit",
                title: "api_resource_details.permission.confirm_create",
                size: "large",
                type: "primary",
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "api_resource_details.permission.name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: t("api_resource_details.permission.name_placeholder"),
                            ...register("name", {
                                required: true,
                                pattern: {
                                    value: (0, $dQcUe.noSpaceRegEx),
                                    message: t("api_resource_details.permission.forbidden_space_in_name")
                                }
                            }),
                            error: errors.name?.message
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "api_resource_details.permission.description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("api_resource_details.permission.description_placeholder"),
                            ...register("description", {
                                required: true
                            }),
                            error: Boolean(errors.description)
                        })
                    })
                ]
            })
        })
    });
}
var $f38b19623af82fb3$export$2e2bcd8739ae039 = $f38b19623af82fb3$var$CreatePermissionModal;


const $a87297d328861428$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $a87297d328861428$var$ApiResourcePermissions() {
    const { resource: { id: resourceId }, isLogtoManagementApiResource: isLogtoManagementApiResource } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(resourceId && (0, $h7VLF.buildUrl)(`api/resources/${resourceId}/scopes`, {
        page: String(page),
        page_size: String($a87297d328861428$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [scopes, totalCount] = data ?? [];
    const api = (0, $2ANSb.default)();
    const [isCreateFormOpen, setIsCreateFormOpen] = (0, $eCoWV.useState)(false);
    const [scopeToBeDeleted, setScopeToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const handleDelete = async ()=>{
        if (!scopeToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/resources/${resourceId}/scopes/${scopeToBeDeleted.id}`);
            (0, $horhC.toast).success(t("api_resource_details.permission.deleted", {
                name: scopeToBeDeleted.name
            }));
            await mutate();
            setScopeToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d49945d5344ba010$export$2e2bcd8739ae039), {
                isCreateGuideVisible: true,
                scopes: scopes,
                isLoading: isLoading,
                isReadOnly: isLogtoManagementApiResource,
                createButtonTitle: "api_resource_details.permission.create_button",
                createHandler: ()=>{
                    setIsCreateFormOpen(true);
                },
                deleteHandler: setScopeToBeDeleted,
                errorMessage: error?.body?.message ?? error?.message,
                retryHandler: async ()=>mutate(undefined, true),
                pagination: {
                    page: page,
                    pageSize: $a87297d328861428$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                search: {
                    keyword: keyword,
                    searchHandler: (keyword)=>{
                        updateSearchParameters({
                            keyword: keyword,
                            page: 1
                        });
                    },
                    clearSearchHandler: ()=>{
                        updateSearchParameters({
                            keyword: "",
                            page: 1
                        });
                    }
                }
            }),
            isCreateFormOpen && totalCount !== undefined && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f38b19623af82fb3$export$2e2bcd8739ae039), {
                resourceId: resourceId,
                totalResourceCount: totalCount,
                onClose: (scope)=>{
                    if (scope) {
                        (0, $horhC.toast).success(t("api_resource_details.permission.permission_created", {
                            name: scope.name
                        }));
                        mutate();
                    }
                    setIsCreateFormOpen(false);
                }
            }),
            scopeToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.delete",
                onCancel: ()=>{
                    setScopeToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("api_resource_details.permission.delete_description")
            })
        ]
    });
}
var $a87297d328861428$export$2e2bcd8739ae039 = $a87297d328861428$var$ApiResourcePermissions;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9X5Bp = parcelRequire("9X5Bp");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $kcPww = parcelRequire("kcPww");
var $42d374563a272dfe$export$795623e8105ba10a;
var $42d374563a272dfe$export$89da14300d534261;
var $42d374563a272dfe$export$34e0f9847d4c02dd;
var $42d374563a272dfe$export$bfd64c937657f93a;
var $42d374563a272dfe$export$4a6dd88bada4e7d2;
$42d374563a272dfe$export$795623e8105ba10a = `_7BqVIW_actionBar`;
$42d374563a272dfe$export$89da14300d534261 = `_7BqVIW_active`;
$42d374563a272dfe$export$34e0f9847d4c02dd = `_7BqVIW_container`;
$42d374563a272dfe$export$bfd64c937657f93a = `_7BqVIW_rotating`;
$42d374563a272dfe$export$4a6dd88bada4e7d2 = `_7BqVIW_shimmer`;


function $0ff0308e2fe37f42$var$SubmitFormChangesActionBar({ isOpen: isOpen, isSubmitting: isSubmitting, onSubmit: onSubmit, onDiscard: onDiscard }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($42d374563a272dfe$export$34e0f9847d4c02dd, isOpen && $42d374563a272dfe$export$89da14300d534261),
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $42d374563a272dfe$export$795623e8105ba10a,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    size: "medium",
                    title: "general.discard",
                    disabled: isSubmitting,
                    onClick: ()=>{
                        onDiscard();
                    }
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    isLoading: isSubmitting,
                    type: "primary",
                    size: "medium",
                    title: "general.save_changes",
                    onClick: async ()=>onSubmit()
                })
            ]
        })
    });
}
var $0ff0308e2fe37f42$export$2e2bcd8739ae039 = $0ff0308e2fe37f42$var$SubmitFormChangesActionBar;


var $c94bc6c84a3f0b4c$export$34e0f9847d4c02dd;
var $c94bc6c84a3f0b4c$export$4dbdc8f16fed8a34;
var $c94bc6c84a3f0b4c$export$bfd64c937657f93a;
var $c94bc6c84a3f0b4c$export$4a6dd88bada4e7d2;
var $c94bc6c84a3f0b4c$export$1258c5dd981c51cf;
$c94bc6c84a3f0b4c$export$34e0f9847d4c02dd = `l9fJqW_container`;
$c94bc6c84a3f0b4c$export$4dbdc8f16fed8a34 = `l9fJqW_fields`;
$c94bc6c84a3f0b4c$export$bfd64c937657f93a = `l9fJqW_rotating`;
$c94bc6c84a3f0b4c$export$4a6dd88bada4e7d2 = `l9fJqW_shimmer`;
$c94bc6c84a3f0b4c$export$1258c5dd981c51cf = `l9fJqW_withSubmitActionBar`;


function $30ff50140180d24e$var$DetailsForm({ autoComplete: autoComplete, isDirty: isDirty, isSubmitting: isSubmitting, onSubmit: onSubmit, onDiscard: onDiscard, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c94bc6c84a3f0b4c$export$34e0f9847d4c02dd, isDirty && $c94bc6c84a3f0b4c$export$1258c5dd981c51cf),
        autoComplete: autoComplete,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $c94bc6c84a3f0b4c$export$4dbdc8f16fed8a34,
                children: children
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0ff0308e2fe37f42$export$2e2bcd8739ae039), {
                isOpen: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: onDiscard
            })
        ]
    });
}
var $30ff50140180d24e$export$2e2bcd8739ae039 = $30ff50140180d24e$var$DetailsForm;




var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $kMAP9 = parcelRequire("kMAP9");
function $d667d8b0c4bcfb48$var$UnsavedChangesAlertModal({ hasUnsavedChanges: hasUnsavedChanges, parentPath: parentPath }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const blocker = (0, $9X5Bp.unstable_useBlocker)(hasUnsavedChanges);
    // Reset the blocker if the conditions are met.
    (0, $eCoWV.useEffect)(()=>{
        if (blocker.state !== "blocked") return;
        const targetPathname = blocker.location.pathname;
        if (!hasUnsavedChanges || targetPathname === pathname) {
            blocker.reset();
            return;
        }
        if (parentPath && targetPathname.startsWith(parentPath)) blocker.proceed();
    }, [
        blocker,
        pathname,
        hasUnsavedChanges,
        parentPath
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
        isOpen: blocker.state === "blocked",
        confirmButtonText: "general.leave_page",
        cancelButtonText: "general.stay_on_page",
        onCancel: blocker.reset,
        onConfirm: blocker.proceed,
        children: t("general.unsaved_changes_warning")
    });
}
var $d667d8b0c4bcfb48$export$2e2bcd8739ae039 = $d667d8b0c4bcfb48$var$UnsavedChangesAlertModal;



var $dADBR = parcelRequire("dADBR");

var $5P1O9 = parcelRequire("5P1O9");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $2ANSb = parcelRequire("2ANSb");


var $bSFEw = parcelRequire("bSFEw");
function $cd340641c4c30295$var$ApiResourceSettings() {
    const { resource: resource, isDeleting: isDeleting, isLogtoManagementApiResource: isLogtoManagementApiResource, onResourceUpdated: onResourceUpdated } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { handleSubmit: handleSubmit, register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)({
        defaultValues: resource
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ isDefault: isDefault, ...rest })=>{
        if (isSubmitting) return;
        const [data] = await Promise.all([
            api.patch(`api/resources/${resource.id}`, {
                json: rest
            }).json(),
            api.patch(`api/resources/${resource.id}/is-default`, {
                json: {
                    isDefault: isDefault
                }
            }).json()
        ]);
        // We cannot ensure the order of API requests, manually combine the results
        const updatedApiResource = {
            ...data,
            isDefault: isDefault
        };
        reset(updatedApiResource);
        onResourceUpdated(updatedApiResource);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                    title: "api_resource_details.settings",
                    description: isLogtoManagementApiResource ? "api_resource_details.management_api_settings_description" : "api_resource_details.settings_description",
                    learnMoreLink: {
                        href: getDocumentationUrl(isLogtoManagementApiResource ? "/docs/recipes/interact-with-management-api/" : "/docs/recipes/protect-your-api/"),
                        targetBlank: "noopener"
                    },
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            isRequired: true,
                            title: "api_resources.api_name",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name),
                                readOnly: isLogtoManagementApiResource,
                                placeholder: t("api_resources.api_name_placeholder")
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            isRequired: true,
                            title: "api_resource_details.token_expiration_time_in_seconds",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("accessTokenTtl", {
                                    required: true,
                                    valueAsNumber: true
                                }),
                                type: "number",
                                error: Boolean(errors.accessTokenTtl),
                                placeholder: t("api_resource_details.token_expiration_time_in_seconds_placeholder")
                            })
                        }),
                        !isLogtoManagementApiResource && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "api_resources.default_api",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                                ...register("isDefault"),
                                label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                            href: "https://docs.logto.io/docs/references/resources/#default-api",
                                            targetBlank: "noopener"
                                        })
                                    },
                                    children: t("api_resources.default_api_label")
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $cd340641c4c30295$export$2e2bcd8739ae039 = $cd340641c4c30295$var$ApiResourceSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
var $MRt6E = parcelRequire("MRt6E");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");






var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $8pPfi = parcelRequire("8pPfi");

var $4W0F0 = parcelRequire("4W0F0");
var $966c8e8c88b0c3eb$exports = {};

$parcel$export($966c8e8c88b0c3eb$exports, "compact", function () { return $966c8e8c88b0c3eb$export$8e16b83750b44988; }, function (v) { return $966c8e8c88b0c3eb$export$8e16b83750b44988 = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "content", function () { return $966c8e8c88b0c3eb$export$a7db06668cad9adb; }, function (v) { return $966c8e8c88b0c3eb$export$a7db06668cad9adb = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "item", function () { return $966c8e8c88b0c3eb$export$7061c75fc5af8b7e; }, function (v) { return $966c8e8c88b0c3eb$export$7061c75fc5af8b7e = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "meta", function () { return $966c8e8c88b0c3eb$export$6990040ee07315; }, function (v) { return $966c8e8c88b0c3eb$export$6990040ee07315 = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "rotating", function () { return $966c8e8c88b0c3eb$export$bfd64c937657f93a; }, function (v) { return $966c8e8c88b0c3eb$export$bfd64c937657f93a = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "shimmer", function () { return $966c8e8c88b0c3eb$export$4a6dd88bada4e7d2; }, function (v) { return $966c8e8c88b0c3eb$export$4a6dd88bada4e7d2 = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "subtitle", function () { return $966c8e8c88b0c3eb$export$c96745152eb2740f; }, function (v) { return $966c8e8c88b0c3eb$export$c96745152eb2740f = v; });
$parcel$export($966c8e8c88b0c3eb$exports, "title", function () { return $966c8e8c88b0c3eb$export$fb184b623420d9be; }, function (v) { return $966c8e8c88b0c3eb$export$fb184b623420d9be = v; });
var $966c8e8c88b0c3eb$export$8e16b83750b44988;
var $966c8e8c88b0c3eb$export$a7db06668cad9adb;
var $966c8e8c88b0c3eb$export$7061c75fc5af8b7e;
var $966c8e8c88b0c3eb$export$6990040ee07315;
var $966c8e8c88b0c3eb$export$bfd64c937657f93a;
var $966c8e8c88b0c3eb$export$4a6dd88bada4e7d2;
var $966c8e8c88b0c3eb$export$c96745152eb2740f;
var $966c8e8c88b0c3eb$export$fb184b623420d9be;
$966c8e8c88b0c3eb$export$8e16b83750b44988 = `mTaj3G_compact`;
$966c8e8c88b0c3eb$export$a7db06668cad9adb = `mTaj3G_content`;
$966c8e8c88b0c3eb$export$7061c75fc5af8b7e = `mTaj3G_item`;
$966c8e8c88b0c3eb$export$6990040ee07315 = `mTaj3G_meta`;
$966c8e8c88b0c3eb$export$bfd64c937657f93a = `mTaj3G_rotating`;
$966c8e8c88b0c3eb$export$4a6dd88bada4e7d2 = `mTaj3G_shimmer`;
$966c8e8c88b0c3eb$export$c96745152eb2740f = `mTaj3G_subtitle`;
$966c8e8c88b0c3eb$export$fb184b623420d9be = `mTaj3G_title`;


function $82d274a280aee8c6$var$ItemPreview({ title: title, subtitle: subtitle, icon: icon, to: to, size: size = "default", suffix: suffix, toTarget: toTarget }) {
    const { getTo: getTo } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($966c8e8c88b0c3eb$exports.item, $966c8e8c88b0c3eb$exports[size]),
        children: [
            icon,
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $966c8e8c88b0c3eb$exports.content,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $966c8e8c88b0c3eb$exports.meta,
                        children: [
                            to && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
                                className: $966c8e8c88b0c3eb$exports.title,
                                to: getTo(to),
                                target: toTarget,
                                onClick: (event)=>{
                                    event.stopPropagation();
                                },
                                children: title
                            }),
                            !to && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $966c8e8c88b0c3eb$exports.title,
                                children: title
                            }),
                            subtitle && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $966c8e8c88b0c3eb$exports.subtitle,
                                children: subtitle
                            })
                        ]
                    }),
                    suffix
                ]
            })
        ]
    });
}
var $82d274a280aee8c6$export$2e2bcd8739ae039 = $82d274a280aee8c6$var$ItemPreview;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $a0Ubj = parcelRequire("a0Ubj");

var $kcPww = parcelRequire("kcPww");

var $lSA0o = parcelRequire("lSA0o");

var $f3853caa1df6ee27$export$34e0f9847d4c02dd;
var $f3853caa1df6ee27$export$516dd90aeaaabcf0;
var $f3853caa1df6ee27$export$bfd64c937657f93a;
var $f3853caa1df6ee27$export$4a6dd88bada4e7d2;
var $f3853caa1df6ee27$export$9852986a3ec5f6a0;
$f3853caa1df6ee27$export$34e0f9847d4c02dd = `KDjGaq_container`;
$f3853caa1df6ee27$export$516dd90aeaaabcf0 = `KDjGaq_headline`;
$f3853caa1df6ee27$export$bfd64c937657f93a = `KDjGaq_rotating`;
$f3853caa1df6ee27$export$4a6dd88bada4e7d2 = `KDjGaq_shimmer`;
$f3853caa1df6ee27$export$9852986a3ec5f6a0 = `KDjGaq_table`;


function $00cb4947eb0d79c7$var$ListPage({ title: title, pageMeta: pageMeta, createButton: createButton, subHeader: subHeader, table: table, widgets: widgets, className: className }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f3853caa1df6ee27$export$34e0f9847d4c02dd, className),
        children: [
            pageMeta && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                ...pageMeta
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $f3853caa1df6ee27$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                        ...title
                    }),
                    createButton && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        ...createButton
                    })
                ]
            }),
            subHeader,
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                className: $f3853caa1df6ee27$export$9852986a3ec5f6a0,
                ...table
            }),
            widgets
        ]
    });
}
var $00cb4947eb0d79c7$export$2e2bcd8739ae039 = $00cb4947eb0d79c7$var$ListPage;



var $6ZMK7 = parcelRequire("6ZMK7");

var $emGEN = parcelRequire("emGEN");

var $47yah = parcelRequire("47yah");



var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");
var $dc204873b1c17409$export$795623e8105ba10a;
var $dc204873b1c17409$export$bfd64c937657f93a;
var $dc204873b1c17409$export$4a6dd88bada4e7d2;
var $dc204873b1c17409$export$6f093cfa640b7166;
var $dc204873b1c17409$export$cc74dcc53cfce4eb;
$dc204873b1c17409$export$795623e8105ba10a = `iJckjG_actionBar`;
$dc204873b1c17409$export$bfd64c937657f93a = `iJckjG_rotating`;
$dc204873b1c17409$export$4a6dd88bada4e7d2 = `iJckjG_shimmer`;
$dc204873b1c17409$export$6f093cfa640b7166 = `iJckjG_text`;
$dc204873b1c17409$export$cc74dcc53cfce4eb = `iJckjG_wrapper`;


function $9372f297e6326ac2$export$2e2bcd8739ae039({ wrapperClassName: wrapperClassName, content: content, buttonText: buttonText, onClick: onClick }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("nav", {
        className: $dc204873b1c17409$export$795623e8105ba10a,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($dc204873b1c17409$export$cc74dcc53cfce4eb, wrapperClassName),
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $dc204873b1c17409$export$6f093cfa640b7166,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: content
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    size: "large",
                    title: buttonText,
                    type: "outline",
                    onClick: onClick
                })
            ]
        })
    });
}




var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $MRt6E = parcelRequire("MRt6E");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");

var $2mi28 = parcelRequire("2mi28");




var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");

function $691f89219d7e5395$var$CreateForm({ onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { data: allResources } = (0, $2mi28.default)("api/resources");
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)();
    const resourceCount = allResources?.filter(({ indicator: indicator })=>!(0, $MRt6E.isManagementApi)(indicator)).length ?? 0;
    const isResourcesReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "resourcesLimit",
        plan: currentPlan,
        usage: resourceCount
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const createdApiResource = await api.post("api/resources", {
            json: data
        }).json();
        (0, $horhC.toast).success(t("api_resources.api_resource_created", {
            name: createdApiResource.name
        }));
        onClose?.(createdApiResource);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "api_resources.create",
            subtitle: "api_resources.subtitle",
            footer: isResourcesReachLimit && currentPlan ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.resources", {
                        count: currentPlan.quota.resourcesLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                htmlType: "submit",
                title: "api_resources.create",
                size: "large",
                type: "primary",
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "api_resources.api_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            ...register("name", {
                                required: true
                            }),
                            placeholder: t("api_resources.api_name_placeholder")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "api_resources.api_identifier",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                        targetBlank: true,
                                        href: "https://datatracker.ietf.org/doc/html/rfc8707#section-2",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("api_resources.api_identifier_tip")
                            }),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("indicator", {
                                required: true
                            }),
                            placeholder: t("api_resources.api_identifier_placeholder")
                        })
                    })
                ]
            })
        })
    });
}
var $691f89219d7e5395$export$2e2bcd8739ae039 = $691f89219d7e5395$var$CreateForm;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");




var $d0Zvy = parcelRequire("d0Zvy");

var $4W0F0 = parcelRequire("4W0F0");

var $0e26a8aa2b30e968$export$34e0f9847d4c02dd;
var $0e26a8aa2b30e968$export$a76584009ca8faeb;
var $0e26a8aa2b30e968$export$d4abd167df80d226;
var $0e26a8aa2b30e968$export$1f1f054184239bf5;
var $0e26a8aa2b30e968$export$bfd64c937657f93a;
var $0e26a8aa2b30e968$export$4a6dd88bada4e7d2;
var $0e26a8aa2b30e968$export$cc74dcc53cfce4eb;
$0e26a8aa2b30e968$export$34e0f9847d4c02dd = `nzzT_q_container`;
$0e26a8aa2b30e968$export$a76584009ca8faeb = `nzzT_q_emptyPlaceholder`;
$0e26a8aa2b30e968$export$d4abd167df80d226 = `nzzT_q_groups`;
$0e26a8aa2b30e968$export$1f1f054184239bf5 = `nzzT_q_guideGroup`;
$0e26a8aa2b30e968$export$bfd64c937657f93a = `nzzT_q_rotating`;
$0e26a8aa2b30e968$export$4a6dd88bada4e7d2 = `nzzT_q_shimmer`;
$0e26a8aa2b30e968$export$cc74dcc53cfce4eb = `nzzT_q_wrapper`;


function $294f9d07dd256376$var$GuideLibrary({ className: className, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton }) {
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [selectedGuide, setSelectedGuide] = (0, $eCoWV.useState)();
    const guides = (0, $461d44ddf3f0b8fb$export$6bb65ec2faabc0af)();
    const [showCreateForm, setShowCreateForm] = (0, $eCoWV.useState)(false);
    const onClickGuide = (0, $eCoWV.useCallback)((data)=>{
        setShowCreateForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateForm = (0, $eCoWV.useCallback)((newResource)=>{
        if (newResource && selectedGuide) {
            navigate(`/api-resources/${newResource.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $d0Zvy.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($0e26a8aa2b30e968$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $0e26a8aa2b30e968$export$cc74dcc53cfce4eb,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $0e26a8aa2b30e968$export$d4abd167df80d226,
                    children: guides.length > 0 ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                        className: $0e26a8aa2b30e968$export$1f1f054184239bf5,
                        hasCardBorder: hasCardBorder,
                        hasCardButton: hasCardButton,
                        guides: guides,
                        onClickGuide: onClickGuide
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {
                        className: $0e26a8aa2b30e968$export$a76584009ca8faeb,
                        size: "large"
                    })
                })
            }),
            selectedGuide?.target === "API" && showCreateForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $691f89219d7e5395$export$2e2bcd8739ae039), {
                onClose: onCloseCreateForm
            })
        ]
    });
}
var $294f9d07dd256376$export$2e2bcd8739ae039 = $294f9d07dd256376$var$GuideLibrary;


var $2d31d6db2e468577$export$34e0f9847d4c02dd;
var $2d31d6db2e468577$export$a7db06668cad9adb;
var $2d31d6db2e468577$export$bfd64c937657f93a;
var $2d31d6db2e468577$export$4a6dd88bada4e7d2;
$2d31d6db2e468577$export$34e0f9847d4c02dd = `BBV9gW_container`;
$2d31d6db2e468577$export$a7db06668cad9adb = `BBV9gW_content`;
$2d31d6db2e468577$export$bfd64c937657f93a = `BBV9gW_rotating`;
$2d31d6db2e468577$export$4a6dd88bada4e7d2 = `BBV9gW_shimmer`;


function $686ac98a93e98633$var$GuideLibraryModal({ isOpen: isOpen, onClose: onClose }) {
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [showCreateForm, setShowCreateForm] = (0, $eCoWV.useState)(false);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $2d31d6db2e468577$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25451d9c34e1e7ec$export$2e2bcd8739ae039), {
                        title: "guide.api.modal_title",
                        subtitle: "guide.api.modal_subtitle",
                        buttonText: "guide.cannot_find_guide",
                        requestFormFieldLabel: "guide.describe_guide_looking_for",
                        requestFormFieldPlaceholder: "guide.api.describe_guide_looking_for_placeholder",
                        requestSuccessMessage: "guide.request_guide_successfully",
                        onClose: onClose
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $294f9d07dd256376$export$2e2bcd8739ae039), {
                        hasCardButton: true,
                        className: $2d31d6db2e468577$export$a7db06668cad9adb
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9372f297e6326ac2$export$2e2bcd8739ae039), {
                        content: "guide.do_not_need_tutorial",
                        buttonText: "guide.api.continue_without_tutorial",
                        onClick: ()=>{
                            setShowCreateForm(true);
                        }
                    })
                ]
            }),
            showCreateForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $691f89219d7e5395$export$2e2bcd8739ae039), {
                onClose: (newApiResource)=>{
                    if (newApiResource) navigate(`/api-resources/${newApiResource.id}`);
                    setShowCreateForm(false);
                }
            })
        ]
    });
}
var $686ac98a93e98633$export$2e2bcd8739ae039 = $686ac98a93e98633$var$GuideLibraryModal;


var $aba0c8868e5975b4$export$1ca1ec8b29a4ce27;
var $aba0c8868e5975b4$export$bfd64c937657f93a;
var $aba0c8868e5975b4$export$4a6dd88bada4e7d2;
$aba0c8868e5975b4$export$1ca1ec8b29a4ce27 = `_2WfC1G_icon`;
$aba0c8868e5975b4$export$bfd64c937657f93a = `_2WfC1G_rotating`;
$aba0c8868e5975b4$export$4a6dd88bada4e7d2 = `_2WfC1G_shimmer`;


const $9946707120d8d280$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $9946707120d8d280$var$apiResourcesPathname = "/api-resources";
const $9946707120d8d280$var$createApiResourcePathname = `${$9946707120d8d280$var$apiResourcesPathname}/create`;
const $9946707120d8d280$var$buildDetailsPathname = (id)=>`${$9946707120d8d280$var$apiResourcesPathname}/${id}/${(0, $emGEN.ApiResourceDetailsTabs).Settings}`;
const $9946707120d8d280$var$icons = {
    [(0, $bhvxB.Theme).Light]: {
        ApiIcon: (0, $457ebd48361125e9$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $3e3948c112d6cadd$export$2e2bcd8739ae039)
    },
    [(0, $bhvxB.Theme).Dark]: {
        ApiIcon: (0, $d3531ed89fdec97a$export$2e2bcd8739ae039),
        ManagementApiIcon: (0, $0fad305167d7e141$export$2e2bcd8739ae039)
    }
};
function $9946707120d8d280$var$ApiResources() {
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1
    });
    const url = (0, $h7VLF.buildUrl)("api/resources", {
        page: String(page),
        page_size: String($9946707120d8d280$var$pageSize)
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const theme = (0, $93h5F.default)();
    const [apiResources, totalCount] = data ?? [];
    const { ApiIcon: ApiIcon, ManagementApiIcon: ManagementApiIcon } = $9946707120d8d280$var$icons[theme];
    const isCreating = match($9946707120d8d280$var$createApiResourcePathname);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
                title: {
                    title: "api_resources.title",
                    subtitle: "api_resources.subtitle"
                },
                pageMeta: {
                    titleKey: "api_resources.page_title"
                },
                createButton: {
                    title: "api_resources.create",
                    onClick: ()=>{
                        navigate({
                            pathname: $9946707120d8d280$var$createApiResourcePathname,
                            search: search
                        });
                    }
                },
                table: {
                    rowGroups: [
                        {
                            key: "apiResources",
                            data: apiResources
                        }
                    ],
                    rowIndexKey: "id",
                    isLoading: isLoading,
                    errorMessage: error?.body?.message ?? error?.message,
                    columns: [
                        {
                            title: t("api_resources.api_name"),
                            dataIndex: "name",
                            colSpan: 6,
                            render: ({ id: id, name: name, isDefault: isDefault, indicator: indicator })=>{
                                const Icon = (0, $MRt6E.isManagementApi)(indicator) ? ManagementApiIcon : ApiIcon;
                                return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                    title: name,
                                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
                                        className: $aba0c8868e5975b4$export$1ca1ec8b29a4ce27
                                    }),
                                    to: $9946707120d8d280$var$buildDetailsPathname(id),
                                    suffix: isDefault && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                        children: t("api_resources.default_api")
                                    })
                                });
                            }
                        },
                        {
                            title: t("api_resources.api_identifier"),
                            dataIndex: "indicator",
                            colSpan: 10,
                            render: ({ indicator: indicator })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                    value: indicator,
                                    variant: "text"
                                })
                        }
                    ],
                    placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
                    rowClickHandler: ({ id: id })=>{
                        navigate($9946707120d8d280$var$buildDetailsPathname(id));
                    },
                    onRetry: async ()=>mutate(undefined, true),
                    pagination: {
                        page: page,
                        totalCount: totalCount,
                        pageSize: $9946707120d8d280$var$pageSize,
                        onChange: (page)=>{
                            updateSearchParameters({
                                page: page
                            });
                        }
                    }
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $686ac98a93e98633$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: ()=>{
                    navigate({
                        pathname: $9946707120d8d280$var$apiResourcesPathname,
                        search: search
                    });
                }
            })
        ]
    });
}
var $9946707120d8d280$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($9946707120d8d280$var$ApiResources);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $duSFh = parcelRequire("duSFh");
var $3kVX5 = parcelRequire("3kVX5");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("6ZMK7");
var $hWlPe = parcelRequire("hWlPe");

var $93h5F = parcelRequire("93h5F");
function $b89a4a093c790c4c$var$ApplicationIcon({ type: type, className: className }) {
    const theme = (0, $93h5F.default)();
    const isLightMode = theme === (0, $bhvxB.Theme).Light;
    const Icon = isLightMode ? (0, $hWlPe.lightModeApplicationIconMap)[type] : (0, $hWlPe.darkModeApplicationIconMap)[type];
    return /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
        className: className
    });
}
var $b89a4a093c790c4c$export$2e2bcd8739ae039 = $b89a4a093c790c4c$var$ApplicationIcon;







var $a0Ubj = parcelRequire("a0Ubj");

parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $iiBsj = parcelRequire("iiBsj");



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $ca03ffacc7a03580$export$fe8985bb6374093c;
$ca03ffacc7a03580$export$fe8985bb6374093c = `Sol9Da_hide`;


function $dbded6c841f8ee49$var$TabWrapper({ isActive: isActive, className: className, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(!isActive && $ca03ffacc7a03580$export$fe8985bb6374093c, className),
        children: children
    });
}
var $dbded6c841f8ee49$export$2e2bcd8739ae039 = $dbded6c841f8ee49$var$TabWrapper;



var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
const $24afe283ce6acd30$export$d8e4c8dab9129f15 = Object.freeze({
    [(0, $3kVX5.ApplicationType).Native]: "applications.type.native",
    [(0, $3kVX5.ApplicationType).SPA]: "applications.type.spa",
    [(0, $3kVX5.ApplicationType).Traditional]: "applications.type.traditional",
    [(0, $3kVX5.ApplicationType).MachineToMachine]: "applications.type.machine_to_machine"
});
const $24afe283ce6acd30$export$a5fbc60a6db6cc4b = Object.freeze([
    "featured",
    "Traditional",
    "SPA",
    "Native",
    "MachineToMachine"
]);



var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $eyD2M = parcelRequire("eyD2M");
var $1EA0k = parcelRequire("1EA0k");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


var $iiBsj = parcelRequire("iiBsj");

var $eEyjP = parcelRequire("eEyjP");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $5P1O9 = parcelRequire("5P1O9");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $itzs0 = parcelRequire("itzs0");
var $3b321dcb10565fb9$export$73afd3c3e9f6aecf;
var $3b321dcb10565fb9$export$64fda0c1cfacc296;
var $3b321dcb10565fb9$export$6d59db4903f20f7d;
var $3b321dcb10565fb9$export$e4043f67d36cbb26;
var $3b321dcb10565fb9$export$bfd64c937657f93a;
var $3b321dcb10565fb9$export$4a6dd88bada4e7d2;
var $3b321dcb10565fb9$export$c54b92c0bb02ba64;
$3b321dcb10565fb9$export$73afd3c3e9f6aecf = `ck2QpG_customEndpointNotes`;
$3b321dcb10565fb9$export$64fda0c1cfacc296 = `ck2QpG_deleteConfirm`;
$3b321dcb10565fb9$export$6d59db4903f20f7d = `ck2QpG_description`;
$3b321dcb10565fb9$export$e4043f67d36cbb26 = `ck2QpG_highlight`;
$3b321dcb10565fb9$export$bfd64c937657f93a = `ck2QpG_rotating`;
$3b321dcb10565fb9$export$4a6dd88bada4e7d2 = `ck2QpG_shimmer`;
$3b321dcb10565fb9$export$c54b92c0bb02ba64 = `ck2QpG_textField`;


function $e7549bd374b809a3$var$AdvancedSettings({ app: { type: type }, oidcConfig: oidcConfig }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { minValue: minValue, maxValue: maxValue } = (0, $eyD2M.customClientMetadataGuard).shape.refreshTokenTtlInDays._def.innerType;
    const minTtl = minValue ?? Number.NEGATIVE_INFINITY;
    const maxTtl = maxValue ?? Number.POSITIVE_INFINITY;
    const ttlErrorMessage = t("errors.number_should_be_between_inclusive", {
        min: minTtl,
        max: maxTtl
    });
    const { data: customDomain, applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "application_details.advanced_settings",
        description: "application_details.advanced_settings_description",
        learnMoreLink: {
            href: "https://openid.net/specs/openid-connect-core-1_0.html#TokenEndpoint",
            targetBlank: true
        },
        children: [
            tenantEndpoint && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.config_endpoint",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64,
                    value: applyCustomDomain((0, $b9zrd.appendPath)(tenantEndpoint, (0, $iiBsj.openIdProviderConfigPath)).href),
                    variant: "border"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.authorization_endpoint",
                tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                targetBlank: true,
                                href: "https://openid.net/specs/openid-connect-core-1_0.html#Authentication",
                                onClick: closeTipHandler
                            })
                        },
                        children: t("application_details.authorization_endpoint_tip")
                    }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64,
                    value: applyCustomDomain(oidcConfig.authorization_endpoint),
                    variant: "border"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.token_endpoint",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64,
                    value: applyCustomDomain(oidcConfig.token_endpoint),
                    variant: "border"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.user_info_endpoint",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64,
                    value: applyCustomDomain(oidcConfig.userinfo_endpoint),
                    variant: "border"
                })
            }),
            customDomain?.status === (0, $1EA0k.DomainStatus).Active && tenantEndpoint && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $3b321dcb10565fb9$export$73afd3c3e9f6aecf,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "domain.custom_endpoint_note",
                    interpolation: {
                        custom: customDomain.domain,
                        default: new URL(tenantEndpoint).host
                    }
                })
            }),
            [
                (0, $3kVX5.ApplicationType).Traditional,
                (0, $3kVX5.ApplicationType).SPA
            ].includes(type) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.always_issue_refresh_token",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                    label: t("application_details.always_issue_refresh_token_label"),
                    ...register("customClientMetadata.alwaysIssueRefreshToken")
                })
            }),
            type !== (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "application_details.rotate_refresh_token",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                            label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                        href: "https://docs.logto.io/docs/references/applications/#rotate-refresh-token",
                                        targetBlank: "noopener"
                                    })
                                },
                                children: t("application_details.rotate_refresh_token_label")
                            }),
                            ...register("customClientMetadata.rotateRefreshToken")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "application_details.refresh_token_ttl",
                        tip: t("application_details.refresh_token_ttl_tip"),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("customClientMetadata.refreshTokenTtlInDays", {
                                min: {
                                    value: minTtl,
                                    message: ttlErrorMessage
                                },
                                max: {
                                    value: maxTtl,
                                    message: ttlErrorMessage
                                },
                                valueAsNumber: true,
                                validate: (value)=>value === undefined || Number.isInteger(value) || t("errors.should_be_an_integer")
                            }),
                            placeholder: "14",
                            // Confirm if we need a customized message here
                            error: errors.customClientMetadata?.refreshTokenTtlInDays?.message
                        })
                    })
                ]
            })
        ]
    });
}
var $e7549bd374b809a3$export$2e2bcd8739ae039 = $e7549bd374b809a3$var$AdvancedSettings;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $iHViS = parcelRequire("iHViS");



var $9bgsA = parcelRequire("9bgsA");

var $3MzPh = parcelRequire("3MzPh");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $ac8G1 = parcelRequire("ac8G1");

var $7fydw = parcelRequire("7fydw");

var $eEyjP = parcelRequire("eEyjP");

var $itzs0 = parcelRequire("itzs0");
function $bdfa2046bc8b3277$var$AppGuide({ className: className, guideId: guideId, app: app, isCompact: isCompact, onClose: onClose }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    const guide = (0, $ac8G1.default).find(({ id: id })=>id === guideId);
    const memorizedContext = (0, $eCoWV.useMemo)(()=>(0, $5CQIb.conditional)(!!guide && !!app && {
            metadata: guide.metadata,
            Logo: guide.Logo,
            app: app,
            endpoint: applyCustomDomain(tenantEndpoint?.href ?? ""),
            redirectUris: app.oidcClientMetadata.redirectUris,
            postLogoutRedirectUris: app.oidcClientMetadata.postLogoutRedirectUris,
            isCompact: Boolean(isCompact),
            sampleUrls: {
                origin: "http://localhost:3001/",
                callback: "http://localhost:3001/callback"
            }
        }), [
        guide,
        app,
        tenantEndpoint?.href,
        applyCustomDomain,
        isCompact
    ]);
    return memorizedContext ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fydw.GuideContext).Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fydw.default), {
            className: className,
            guideId: guideId,
            isEmpty: !app && !guide,
            isLoading: !app,
            onClose: onClose
        })
    }) : null;
}
var $bdfa2046bc8b3277$export$2e2bcd8739ae039 = $bdfa2046bc8b3277$var$AppGuide;


var $27af186dc26717ba$export$a22f64ad99009e4f;
var $27af186dc26717ba$export$e2ebc74040679039;
var $27af186dc26717ba$export$675bc0f5721dbbd7;
var $27af186dc26717ba$export$38e42c68cf43b5d4;
var $27af186dc26717ba$export$bfd64c937657f93a;
var $27af186dc26717ba$export$3e523c77c1f23f8c;
var $27af186dc26717ba$export$4a6dd88bada4e7d2;
$27af186dc26717ba$export$a22f64ad99009e4f = `fL1tgG_cardGroup`;
$27af186dc26717ba$export$e2ebc74040679039 = `fL1tgG_drawerContainer`;
$27af186dc26717ba$export$675bc0f5721dbbd7 = `fL1tgG_guide`;
$27af186dc26717ba$export$38e42c68cf43b5d4 = `fL1tgG_header`;
$27af186dc26717ba$export$bfd64c937657f93a = `fL1tgG_rotating`;
$27af186dc26717ba$export$3e523c77c1f23f8c = `fL1tgG_separator`;
$27af186dc26717ba$export$4a6dd88bada4e7d2 = `fL1tgG_shimmer`;


function $34f5432334a6c09e$var$GuideDrawer({ app: app, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.guide"
    });
    const { getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $461d44ddf3f0b8fb$export$6b80cd72646f4cab)();
    const [selectedGuide, setSelectedGuide] = (0, $eCoWV.useState)();
    const structuredMetadata = (0, $eCoWV.useMemo)(()=>getStructuredAppGuideMetadata({
            categories: [
                app.type
            ]
        }), [
        getStructuredAppGuideMetadata,
        app.type
    ]);
    const hasSingleGuide = (0, $eCoWV.useMemo)(()=>{
        return structuredMetadata[app.type].length === 1;
    }, [
        app.type,
        structuredMetadata
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (hasSingleGuide) {
            const guide = structuredMetadata[app.type][0];
            if (guide) {
                const { id: id, metadata: { target: target, name: name } } = guide;
                setSelectedGuide({
                    id: id,
                    target: target,
                    name: name
                });
            }
        }
    }, [
        hasSingleGuide,
        app.type,
        structuredMetadata
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $27af186dc26717ba$export$e2ebc74040679039,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $27af186dc26717ba$export$38e42c68cf43b5d4,
                children: [
                    selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            !hasSingleGuide && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                        size: "large",
                                        onClick: ()=>{
                                            setSelectedGuide(undefined);
                                        },
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $505074c92853ff4a$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $27af186dc26717ba$export$3e523c77c1f23f8c
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: t("checkout_tutorial", {
                                    name: selectedGuide.name
                                })
                            })
                        ]
                    }),
                    !selectedGuide && t("app.select_a_framework"),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        size: "large",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
                    })
                ]
            }),
            !selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                className: $27af186dc26717ba$export$a22f64ad99009e4f,
                categoryName: t(`categories.${app.type}`),
                guides: structuredMetadata[app.type],
                onClickGuide: (guide)=>{
                    setSelectedGuide(guide);
                }
            }),
            selectedGuide && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bdfa2046bc8b3277$export$2e2bcd8739ae039), {
                isCompact: true,
                className: $27af186dc26717ba$export$675bc0f5721dbbd7,
                guideId: selectedGuide.id,
                app: app,
                onClose: ()=>{
                    setSelectedGuide(undefined);
                }
            })
        ]
    });
}
var $34f5432334a6c09e$export$2e2bcd8739ae039 = $34f5432334a6c09e$var$GuideDrawer;



var $9zeGj = parcelRequire("9zeGj");

var $bFFWx = parcelRequire("bFFWx");


var $7iZsu = parcelRequire("7iZsu");

var $a59603eb056cd8b8$export$675bc0f5721dbbd7;
var $a59603eb056cd8b8$export$56c24f306bd986cf;
var $a59603eb056cd8b8$export$bfd64c937657f93a;
var $a59603eb056cd8b8$export$4a6dd88bada4e7d2;
$a59603eb056cd8b8$export$675bc0f5721dbbd7 = `_8OjxsG_guide`;
$a59603eb056cd8b8$export$56c24f306bd986cf = `_8OjxsG_modalContainer`;
$a59603eb056cd8b8$export$bfd64c937657f93a = `_8OjxsG_rotating`;
$a59603eb056cd8b8$export$4a6dd88bada4e7d2 = `_8OjxsG_shimmer`;


function $30fbdaf9865b9deb$var$GuideModal({ guideId: guideId, app: app, onClose: onClose }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $a59603eb056cd8b8$export$56c24f306bd986cf,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25451d9c34e1e7ec$export$2e2bcd8739ae039), {
                    title: "guide.app.guide_modal_title",
                    subtitle: "guide.app.modal_subtitle",
                    buttonText: "guide.cannot_find_guide",
                    requestFormFieldLabel: "guide.describe_guide_looking_for",
                    requestFormFieldPlaceholder: "guide.app.describe_guide_looking_for_placeholder",
                    requestSuccessMessage: "guide.request_guide_successfully",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bdfa2046bc8b3277$export$2e2bcd8739ae039), {
                    className: $a59603eb056cd8b8$export$675bc0f5721dbbd7,
                    guideId: guideId,
                    app: app,
                    onClose: onClose
                })
            ]
        })
    });
}
var $30fbdaf9865b9deb$export$2e2bcd8739ae039 = $30fbdaf9865b9deb$var$GuideModal;



var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $lSUTm = parcelRequire("lSUTm");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $faCyI = parcelRequire("faCyI");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $8pPfi = parcelRequire("8pPfi");

var $2mi28 = parcelRequire("2mi28");

var $4W0F0 = parcelRequire("4W0F0");
var $d1e06f5a73ee00b3$export$9c30223ca0a664fb;
$d1e06f5a73ee00b3$export$9c30223ca0a664fb = `QCDwsq_link`;


function $1e5c80becd11c9ff$var$ApplicationName({ applicationId: applicationId, isLink: isLink = false }) {
    const isAdminConsole = applicationId === (0, $faCyI.adminConsoleApplicationId);
    const { data: data } = (0, $2mi28.default)(!isAdminConsole && `api/applications/${applicationId}`);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getTo: getTo } = (0, $4W0F0.default)();
    const name = (isAdminConsole ? /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            "Admin Console (",
            t("system_app"),
            ")"
        ]
    }) : data?.name) ?? "-";
    if (isLink && !isAdminConsole) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
        className: $d1e06f5a73ee00b3$export$9c30223ca0a664fb,
        to: getTo(`/applications/${applicationId}`),
        children: name
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: name
    });
}
var $1e5c80becd11c9ff$export$2e2bcd8739ae039 = $1e5c80becd11c9ff$var$ApplicationName;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $8pPfi = parcelRequire("8pPfi");

var $2mi28 = parcelRequire("2mi28");

var $4W0F0 = parcelRequire("4W0F0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $awn06 = parcelRequire("awn06");

const $3f85170a081a517a$var$getSecondaryUserInfo = (user)=>{
    const { primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username } = user ?? {};
    const formattedPhoneNumber = (0, $5CQIb.conditional)(primaryPhone && (0, $75ee91b14347449d$export$d79b62bd58081ca4)(primaryPhone));
    return primaryEmail ?? formattedPhoneNumber ?? username;
};
const $3f85170a081a517a$export$5f7a1baecd59f846 = (user)=>user?.name ?? $3f85170a081a517a$var$getSecondaryUserInfo(user) ?? (0, $awn06.t)("admin_console.users.unnamed");
const $3f85170a081a517a$export$336d714c72178bf2 = (user)=>(0, $5CQIb.conditional)(user?.name && $3f85170a081a517a$var$getSecondaryUserInfo(user));



var $669b3b372048f975$export$9c30223ca0a664fb;
var $669b3b372048f975$export$bfd64c937657f93a;
var $669b3b372048f975$export$4a6dd88bada4e7d2;
var $669b3b372048f975$export$fb184b623420d9be;
var $669b3b372048f975$export$c86d3ca66f38ed60;
$669b3b372048f975$export$9c30223ca0a664fb = `_3-KeZq_link`;
$669b3b372048f975$export$bfd64c937657f93a = `_3-KeZq_rotating`;
$669b3b372048f975$export$4a6dd88bada4e7d2 = `_3-KeZq_shimmer`;
$669b3b372048f975$export$fb184b623420d9be = `_3-KeZq_title`;
$669b3b372048f975$export$c86d3ca66f38ed60 = `_3-KeZq_userName`;


function $5704ffbe656efb4c$var$UserName({ userId: userId, isLink: isLink = false }) {
    const { data: data, error: error } = (0, $2mi28.default)(`api/users/${userId}`);
    const isLoading = !data && !error;
    const name = (0, $5CQIb.conditionalString)(data && (0, $3f85170a081a517a$export$5f7a1baecd59f846)(data));
    const { getTo: getTo } = (0, $4W0F0.default)();
    if (isLoading) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $669b3b372048f975$export$c86d3ca66f38ed60,
        children: isLink ? /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $8pPfi.Link), {
            to: getTo(`/users/${userId}`),
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($669b3b372048f975$export$fb184b623420d9be, $669b3b372048f975$export$9c30223ca0a664fb),
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                    hasTooltip: true,
                    size: "micro",
                    user: data
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    children: name
                })
            ]
        }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            className: $669b3b372048f975$export$fb184b623420d9be,
            children: name
        })
    });
}
var $5704ffbe656efb4c$export$2e2bcd8739ae039 = $5704ffbe656efb4c$var$UserName;


parcelRequire("6ZMK7");
var $adtV2 = parcelRequire("adtV2");
var $6ZMK7 = parcelRequire("6ZMK7");



var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $8zpKJ = parcelRequire("8zpKJ");
var $faCyI = parcelRequire("faCyI");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $iHViS = parcelRequire("iHViS");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $fb79e1374131f586$var$SvgKeyboardArrowUp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m11.29 8.46-5.65 5.66a.999.999 0 0 0 0 1.42 1 1 0 0 0 1.41 0l5-4.95L17 15.54a1 1 0 0 0 1.631-.325.998.998 0 0 0 .079-.385 1 1 0 0 0-.3-.71l-5.65-5.66a1 1 0 0 0-1.47 0Z",
            fill: "currentColor"
        })
    });
var $fb79e1374131f586$export$2e2bcd8739ae039 = $fb79e1374131f586$var$SvgKeyboardArrowUp;





var $6PcpQ = parcelRequire("6PcpQ");


var $9bgsA = parcelRequire("9bgsA");
var $14a941e7f738b0de$exports = {};

$parcel$export($14a941e7f738b0de$exports, "arrow", function () { return $14a941e7f738b0de$export$f2120bbfa5450bd2; }, function (v) { return $14a941e7f738b0de$export$f2120bbfa5450bd2 = v; });
$parcel$export($14a941e7f738b0de$exports, "clear", function () { return $14a941e7f738b0de$export$42ffd38884aecdac; }, function (v) { return $14a941e7f738b0de$export$42ffd38884aecdac = v; });
$parcel$export($14a941e7f738b0de$exports, "clearable", function () { return $14a941e7f738b0de$export$9a75bea1029d84f2; }, function (v) { return $14a941e7f738b0de$export$9a75bea1029d84f2 = v; });
$parcel$export($14a941e7f738b0de$exports, "close", function () { return $14a941e7f738b0de$export$8360e631d277ea4d; }, function (v) { return $14a941e7f738b0de$export$8360e631d277ea4d = v; });
$parcel$export($14a941e7f738b0de$exports, "delete", function () { return $14a941e7f738b0de$export$1822828d790e23ee; }, function (v) { return $14a941e7f738b0de$export$1822828d790e23ee = v; });
$parcel$export($14a941e7f738b0de$exports, "dropdown", function () { return $14a941e7f738b0de$export$81207e5cc4186890; }, function (v) { return $14a941e7f738b0de$export$81207e5cc4186890 = v; });
$parcel$export($14a941e7f738b0de$exports, "error", function () { return $14a941e7f738b0de$export$a3bc9b8ed74fc; }, function (v) { return $14a941e7f738b0de$export$a3bc9b8ed74fc = v; });
$parcel$export($14a941e7f738b0de$exports, "focused", function () { return $14a941e7f738b0de$export$4c2b230493b2b322; }, function (v) { return $14a941e7f738b0de$export$4c2b230493b2b322 = v; });
$parcel$export($14a941e7f738b0de$exports, "icon", function () { return $14a941e7f738b0de$export$1ca1ec8b29a4ce27; }, function (v) { return $14a941e7f738b0de$export$1ca1ec8b29a4ce27 = v; });
$parcel$export($14a941e7f738b0de$exports, "large", function () { return $14a941e7f738b0de$export$f09585a853dddd32; }, function (v) { return $14a941e7f738b0de$export$f09585a853dddd32 = v; });
$parcel$export($14a941e7f738b0de$exports, "medium", function () { return $14a941e7f738b0de$export$649ecc744817b5c7; }, function (v) { return $14a941e7f738b0de$export$649ecc744817b5c7 = v; });
$parcel$export($14a941e7f738b0de$exports, "multiple", function () { return $14a941e7f738b0de$export$939ddaa3205df08e; }, function (v) { return $14a941e7f738b0de$export$939ddaa3205df08e = v; });
$parcel$export($14a941e7f738b0de$exports, "noResult", function () { return $14a941e7f738b0de$export$17aca76bf89ef49e; }, function (v) { return $14a941e7f738b0de$export$17aca76bf89ef49e = v; });
$parcel$export($14a941e7f738b0de$exports, "open", function () { return $14a941e7f738b0de$export$3ce6949f20cea765; }, function (v) { return $14a941e7f738b0de$export$3ce6949f20cea765 = v; });
$parcel$export($14a941e7f738b0de$exports, "readOnly", function () { return $14a941e7f738b0de$export$b2cbc93d4da94977; }, function (v) { return $14a941e7f738b0de$export$b2cbc93d4da94977 = v; });
$parcel$export($14a941e7f738b0de$exports, "rotating", function () { return $14a941e7f738b0de$export$bfd64c937657f93a; }, function (v) { return $14a941e7f738b0de$export$bfd64c937657f93a = v; });
$parcel$export($14a941e7f738b0de$exports, "search", function () { return $14a941e7f738b0de$export$d76128d007d19019; }, function (v) { return $14a941e7f738b0de$export$d76128d007d19019 = v; });
$parcel$export($14a941e7f738b0de$exports, "searchInput", function () { return $14a941e7f738b0de$export$952af3258ed45903; }, function (v) { return $14a941e7f738b0de$export$952af3258ed45903 = v; });
$parcel$export($14a941e7f738b0de$exports, "searchInputContainer", function () { return $14a941e7f738b0de$export$de44969449e66315; }, function (v) { return $14a941e7f738b0de$export$de44969449e66315 = v; });
$parcel$export($14a941e7f738b0de$exports, "select", function () { return $14a941e7f738b0de$export$2e6c959c16ff56b8; }, function (v) { return $14a941e7f738b0de$export$2e6c959c16ff56b8 = v; });
$parcel$export($14a941e7f738b0de$exports, "shimmer", function () { return $14a941e7f738b0de$export$4a6dd88bada4e7d2; }, function (v) { return $14a941e7f738b0de$export$4a6dd88bada4e7d2 = v; });
$parcel$export($14a941e7f738b0de$exports, "small", function () { return $14a941e7f738b0de$export$3c17b0e969a90510; }, function (v) { return $14a941e7f738b0de$export$3c17b0e969a90510 = v; });
$parcel$export($14a941e7f738b0de$exports, "spinner", function () { return $14a941e7f738b0de$export$641374ffb95bc399; }, function (v) { return $14a941e7f738b0de$export$641374ffb95bc399 = v; });
$parcel$export($14a941e7f738b0de$exports, "tag", function () { return $14a941e7f738b0de$export$2b067c6666111485; }, function (v) { return $14a941e7f738b0de$export$2b067c6666111485 = v; });
$parcel$export($14a941e7f738b0de$exports, "title", function () { return $14a941e7f738b0de$export$fb184b623420d9be; }, function (v) { return $14a941e7f738b0de$export$fb184b623420d9be = v; });
var $14a941e7f738b0de$export$f2120bbfa5450bd2;
var $14a941e7f738b0de$export$42ffd38884aecdac;
var $14a941e7f738b0de$export$9a75bea1029d84f2;
var $14a941e7f738b0de$export$8360e631d277ea4d;
var $14a941e7f738b0de$export$1822828d790e23ee;
var $14a941e7f738b0de$export$81207e5cc4186890;
var $14a941e7f738b0de$export$a3bc9b8ed74fc;
var $14a941e7f738b0de$export$4c2b230493b2b322;
var $14a941e7f738b0de$export$1ca1ec8b29a4ce27;
var $14a941e7f738b0de$export$f09585a853dddd32;
var $14a941e7f738b0de$export$649ecc744817b5c7;
var $14a941e7f738b0de$export$939ddaa3205df08e;
var $14a941e7f738b0de$export$17aca76bf89ef49e;
var $14a941e7f738b0de$export$3ce6949f20cea765;
var $14a941e7f738b0de$export$b2cbc93d4da94977;
var $14a941e7f738b0de$export$bfd64c937657f93a;
var $14a941e7f738b0de$export$d76128d007d19019;
var $14a941e7f738b0de$export$952af3258ed45903;
var $14a941e7f738b0de$export$de44969449e66315;
var $14a941e7f738b0de$export$2e6c959c16ff56b8;
var $14a941e7f738b0de$export$4a6dd88bada4e7d2;
var $14a941e7f738b0de$export$3c17b0e969a90510;
var $14a941e7f738b0de$export$641374ffb95bc399;
var $14a941e7f738b0de$export$2b067c6666111485;
var $14a941e7f738b0de$export$fb184b623420d9be;
$14a941e7f738b0de$export$f2120bbfa5450bd2 = `el1x2W_arrow`;
$14a941e7f738b0de$export$42ffd38884aecdac = `el1x2W_clear`;
$14a941e7f738b0de$export$9a75bea1029d84f2 = `el1x2W_clearable`;
$14a941e7f738b0de$export$8360e631d277ea4d = `el1x2W_close`;
$14a941e7f738b0de$export$1822828d790e23ee = `el1x2W_delete`;
$14a941e7f738b0de$export$81207e5cc4186890 = `el1x2W_dropdown`;
$14a941e7f738b0de$export$a3bc9b8ed74fc = `el1x2W_error`;
$14a941e7f738b0de$export$4c2b230493b2b322 = `el1x2W_focused`;
$14a941e7f738b0de$export$1ca1ec8b29a4ce27 = `el1x2W_icon`;
$14a941e7f738b0de$export$f09585a853dddd32 = `el1x2W_large`;
$14a941e7f738b0de$export$649ecc744817b5c7 = `el1x2W_medium`;
$14a941e7f738b0de$export$939ddaa3205df08e = `el1x2W_multiple`;
$14a941e7f738b0de$export$17aca76bf89ef49e = `el1x2W_noResult`;
$14a941e7f738b0de$export$3ce6949f20cea765 = `el1x2W_open`;
$14a941e7f738b0de$export$b2cbc93d4da94977 = `el1x2W_readOnly`;
$14a941e7f738b0de$export$bfd64c937657f93a = `el1x2W_rotating`;
$14a941e7f738b0de$export$d76128d007d19019 = `el1x2W_search`;
$14a941e7f738b0de$export$952af3258ed45903 = `el1x2W_searchInput`;
$14a941e7f738b0de$export$de44969449e66315 = `el1x2W_searchInputContainer`;
$14a941e7f738b0de$export$2e6c959c16ff56b8 = `el1x2W_select`;
$14a941e7f738b0de$export$4a6dd88bada4e7d2 = `el1x2W_shimmer`;
$14a941e7f738b0de$export$3c17b0e969a90510 = `el1x2W_small`;
$14a941e7f738b0de$export$641374ffb95bc399 = `el1x2W_spinner`;
$14a941e7f738b0de$export$2b067c6666111485 = `el1x2W_tag`;
$14a941e7f738b0de$export$fb184b623420d9be = `el1x2W_title`;


function $55c80f28eec7e930$var$Select({ className: className, value: value, options: options, onChange: onChange, isReadOnly: isReadOnly, error: error, placeholder: placeholder, isClearable: isClearable, size: size = "large", isSearchEnabled: isSearchEnabled }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    const [searchInputValue, setSearchInputValue] = (0, $eCoWV.useState)("");
    const [searchInputContainerStyles, setSearchInputContainerStyles] = (0, $eCoWV.useState)({});
    const anchorRef = (0, $eCoWV.useRef)(null);
    const current = options.find((option)=>value && option.value === value);
    const filteredOptions = (0, $eCoWV.useMemo)(()=>{
        return searchInputValue ? options.filter(({ value: value })=>value.toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase())) : options;
    }, [
        searchInputValue,
        options
    ]);
    const handleSelect = (value)=>{
        onChange?.(value);
        setIsOpen(false);
    };
    const handleClear = (event)=>{
        onChange?.(undefined);
        setIsOpen(false);
        event.stopPropagation();
    };
    const getSearchInputContainerStyles = ()=>{
        if (!anchorRef.current) return {};
        const element = anchorRef.current;
        const cs = getComputedStyle(element);
        const paddingX = Number.parseFloat(cs.paddingLeft) + Number.parseFloat(cs.paddingRight);
        const paddingY = Number.parseFloat(cs.paddingTop) + Number.parseFloat(cs.paddingBottom);
        const borderX = Number.parseFloat(cs.borderLeftWidth) + Number.parseFloat(cs.borderRightWidth);
        const borderY = Number.parseFloat(cs.borderTopWidth) + Number.parseFloat(cs.borderBottomWidth);
        return {
            position: "fixed",
            width: `${element.offsetWidth - paddingX - borderX}px`,
            height: `${element.offsetHeight - paddingY - borderY}px`,
            top: `${element.getBoundingClientRect().top + Number.parseFloat(cs.borderTopWidth) + Number.parseFloat(cs.paddingTop)}px`,
            left: `${element.getBoundingClientRect().left + Number.parseFloat(cs.borderLeftWidth) + Number.parseFloat(cs.paddingLeft)}px`,
            backgroundColor: cs.backgroundColor
        };
    };
    (0, $c0b37dd2da18e290$export$2e2bcd8739ae039)(()=>{
        setSearchInputContainerStyles(getSearchInputContainerStyles());
    });
    (0, $eCoWV.useEffect)(()=>{
        if (isOpen) {
            anchorRef.current?.scrollIntoView({
                block: "nearest"
            });
            setSearchInputContainerStyles(getSearchInputContainerStyles());
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                ref: anchorRef,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($14a941e7f738b0de$exports.select, $14a941e7f738b0de$exports[size], isOpen && $14a941e7f738b0de$exports.open, isReadOnly && $14a941e7f738b0de$exports.readOnly, Boolean(error) && $14a941e7f738b0de$exports.error, isClearable && value && $14a941e7f738b0de$exports.clearable, className),
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    if (!isReadOnly) setIsOpen(true);
                }),
                onClick: ()=>{
                    if (!isReadOnly) setIsOpen(true);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $14a941e7f738b0de$exports.title,
                        children: current?.title ?? placeholder
                    }),
                    isClearable && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($14a941e7f738b0de$exports.icon, $14a941e7f738b0de$exports.clear),
                        size: "small",
                        onClick: handleClear,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($14a941e7f738b0de$exports.icon, $14a941e7f738b0de$exports.arrow),
                        children: isOpen ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fb79e1374131f586$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $46ab19a7423faf73$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                isFullWidth: true,
                anchorRef: anchorRef,
                className: $14a941e7f738b0de$exports.dropdown,
                isOpen: isOpen,
                onClose: ()=>{
                    setIsOpen(false);
                    setSearchInputValue("");
                },
                children: [
                    isSearchEnabled && isOpen && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        style: searchInputContainerStyles,
                        className: $14a941e7f738b0de$exports.searchInputContainer,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                                className: $14a941e7f738b0de$exports.search
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                                ref: (input)=>input?.focus(),
                                className: $14a941e7f738b0de$exports.searchInput,
                                value: searchInputValue,
                                role: "searchbox",
                                autoComplete: "off",
                                placeholder: t("general.type_to_search"),
                                onChange: (event)=>{
                                    setSearchInputValue(event.target.value);
                                },
                                onClick: (event)=>{
                                    event.stopPropagation();
                                }
                            })
                        ]
                    }),
                    filteredOptions.map(({ value: value, title: title })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                            onClick: ()=>{
                                handleSelect(value);
                            },
                            children: title
                        }, value))
                ]
            })
        ]
    });
}
var $55c80f28eec7e930$export$2e2bcd8739ae039 = $55c80f28eec7e930$var$Select;


function $be2d97f29d9e48be$var$ApplicationSelector({ value: value, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: data } = (0, $2mi28.default)("api/applications");
    const options = data?.map(({ id: id, name: name })=>({
            value: id,
            title: name
        })) ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
        isClearable: true,
        value: value,
        options: [
            ...(0, $5CQIb.conditional)((0, $V1X8c.isCloud) && currentTenantId === (0, $8zpKJ.adminTenantId) && [
                {
                    value: (0, $faCyI.adminConsoleApplicationId),
                    title: "Admin Console"
                }
            ]) ?? [],
            ...options
        ],
        placeholder: t("logs.application"),
        onChange: onChange
    });
}
var $be2d97f29d9e48be$export$2e2bcd8739ae039 = $be2d97f29d9e48be$var$ApplicationSelector;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $8pPfi = parcelRequire("8pPfi");



var $adtV2 = parcelRequire("adtV2");

var $4W0F0 = parcelRequire("4W0F0");
var $6552fb017536d3c4$export$a0305a8c6cff19c8;
var $6552fb017536d3c4$export$2b62a06a9fee979c;
var $6552fb017536d3c4$export$1ca1ec8b29a4ce27;
var $6552fb017536d3c4$export$bfd64c937657f93a;
var $6552fb017536d3c4$export$4a6dd88bada4e7d2;
var $6552fb017536d3c4$export$fe7c49d056ea1d88;
var $6552fb017536d3c4$export$fb184b623420d9be;
$6552fb017536d3c4$export$a0305a8c6cff19c8 = `ji4gBq_eventName`;
$6552fb017536d3c4$export$2b62a06a9fee979c = `ji4gBq_fail`;
$6552fb017536d3c4$export$1ca1ec8b29a4ce27 = `ji4gBq_icon`;
$6552fb017536d3c4$export$bfd64c937657f93a = `ji4gBq_rotating`;
$6552fb017536d3c4$export$4a6dd88bada4e7d2 = `ji4gBq_shimmer`;
$6552fb017536d3c4$export$fe7c49d056ea1d88 = `ji4gBq_success`;
$6552fb017536d3c4$export$fb184b623420d9be = `ji4gBq_title`;


function $2ae034889f6797e9$var$EventName({ eventKey: eventKey, isSuccess: isSuccess, to: to }) {
    const title = (0, $adtV2.logEventTitle)[eventKey] ?? eventKey;
    const { getTo: getTo } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $6552fb017536d3c4$export$a0305a8c6cff19c8,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($6552fb017536d3c4$export$1ca1ec8b29a4ce27, isSuccess ? $6552fb017536d3c4$export$fe7c49d056ea1d88 : $6552fb017536d3c4$export$2b62a06a9fee979c),
                children: isSuccess ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c485b7de5371d8$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7739235756d87309$export$2e2bcd8739ae039), {})
            }),
            to && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8pPfi.Link), {
                className: $6552fb017536d3c4$export$fb184b623420d9be,
                to: getTo(to),
                onClick: (event)=>{
                    event.stopPropagation();
                },
                children: title
            }),
            !to && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6552fb017536d3c4$export$fb184b623420d9be,
                children: title
            })
        ]
    });
}
var $2ae034889f6797e9$export$2e2bcd8739ae039 = $2ae034889f6797e9$var$EventName;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $adtV2 = parcelRequire("adtV2");

const $c9d893b595530942$var$defaultEventOptions = Object.entries((0, $adtV2.logEventTitle)).map(([value, title])=>({
        value: value,
        title: title ?? value
    }));
function $c9d893b595530942$var$EventSelector({ value: value, onChange: onChange, options: options }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
        isClearable: true,
        value: value,
        options: options ?? $c9d893b595530942$var$defaultEventOptions,
        placeholder: t("logs.event"),
        onChange: onChange
    });
}
var $c9d893b595530942$export$2e2bcd8739ae039 = $c9d893b595530942$var$EventSelector;


var $68754b138fc3f855$export$5b2ad1bf581a1d7b;
var $68754b138fc3f855$export$baf82c066573e902;
var $68754b138fc3f855$export$3dea766d36a8935f;
var $68754b138fc3f855$export$bfd64c937657f93a;
var $68754b138fc3f855$export$4a6dd88bada4e7d2;
var $68754b138fc3f855$export$fb184b623420d9be;
$68754b138fc3f855$export$5b2ad1bf581a1d7b = `_l4QRW_applicationSelector`;
$68754b138fc3f855$export$baf82c066573e902 = `_l4QRW_eventSelector`;
$68754b138fc3f855$export$3dea766d36a8935f = `_l4QRW_filter`;
$68754b138fc3f855$export$bfd64c937657f93a = `_l4QRW_rotating`;
$68754b138fc3f855$export$4a6dd88bada4e7d2 = `_l4QRW_shimmer`;
$68754b138fc3f855$export$fb184b623420d9be = `_l4QRW_title`;


const $cf7839843df44a16$var$auditLogEventOptions = Object.entries((0, $adtV2.auditLogEventTitle)).map(([value, title])=>({
        value: value,
        title: title ?? value
    }));
function $cf7839843df44a16$var$AuditLogTable({ applicationId: applicationId, userId: userId, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const pageSize = (0, $6ZMK7.defaultPageSize);
    const [{ page: page, event: event, applicationId: applicationIdFromSearch }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        event: "",
        // If `applicationId` not specified when init this component, then search parameter of `applicationId` can be accepted.
        ...(0, $5CQIb.conditional)(!applicationId && {
            applicationId: ""
        })
    });
    // TODO: LOG-7135, revisit this fallback logic and see whether this should be done outside of this component.
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    const searchApplicationId = applicationId || applicationIdFromSearch;
    const { data: specifiedApplication } = (0, $2mi28.default)(applicationId && `api/applications/${applicationId}`);
    const url = (0, $h7VLF.buildUrl)("api/logs", {
        page: String(page),
        page_size: String(pageSize),
        ...(0, $5CQIb.conditional)(event && {
            logKey: event
        }),
        ...(0, $5CQIb.conditional)(searchApplicationId && {
            applicationId: searchApplicationId
        }),
        ...(0, $5CQIb.conditional)(userId && {
            userId: userId
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [logs, totalCount] = data ?? [];
    const isUserColumnVisible = !userId && specifiedApplication?.type !== (0, $3kVX5.ApplicationType).MachineToMachine;
    const eventColumn = {
        title: t("logs.event"),
        dataIndex: "event",
        colSpan: isUserColumnVisible ? 5 : 6,
        render: ({ key: key, payload: { result: result } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2ae034889f6797e9$export$2e2bcd8739ae039), {
                eventKey: key,
                isSuccess: result === (0, $lSUTm.LogResult).Success
            })
    };
    const userColumn = {
        title: t("logs.user"),
        dataIndex: "user",
        colSpan: 5,
        render: ({ payload: { userId: userId } })=>userId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5704ffbe656efb4c$export$2e2bcd8739ae039), {
                userId: userId
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                children: "-"
            })
    };
    const applicationColumn = {
        title: t("logs.application"),
        dataIndex: "application",
        colSpan: isUserColumnVisible ? 3 : 5,
        render: ({ payload: { applicationId: applicationId } })=>applicationId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5c80becd11c9ff$export$2e2bcd8739ae039), {
                applicationId: applicationId
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                children: "-"
            })
    };
    const timeColumn = {
        title: t("logs.time"),
        dataIndex: "time",
        colSpan: isUserColumnVisible ? 3 : 5,
        render: ({ createdAt: createdAt })=>new Date(createdAt).toLocaleString()
    };
    const columns = [
        eventColumn,
        (0, $5CQIb.conditional)(isUserColumnVisible && userColumn),
        applicationColumn,
        timeColumn
    ].filter((column)=>Boolean(column));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
        className: className,
        rowGroups: [
            {
                key: "logs",
                data: logs
            }
        ],
        rowIndexKey: "id",
        columns: columns,
        rowClickHandler: ({ id: id })=>{
            navigate(id);
        },
        filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $68754b138fc3f855$export$3dea766d36a8935f,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $68754b138fc3f855$export$fb184b623420d9be,
                    children: t("logs.filter_by")
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $68754b138fc3f855$export$baf82c066573e902,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c9d893b595530942$export$2e2bcd8739ae039), {
                        value: event,
                        options: $cf7839843df44a16$var$auditLogEventOptions,
                        onChange: (event)=>{
                            updateSearchParameters({
                                event: event,
                                page: undefined
                            });
                        }
                    })
                }),
                !applicationId && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $68754b138fc3f855$export$5b2ad1bf581a1d7b,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $be2d97f29d9e48be$export$2e2bcd8739ae039), {
                        value: applicationIdFromSearch,
                        onChange: (applicationIdFromSearch)=>{
                            updateSearchParameters({
                                applicationId: applicationIdFromSearch,
                                page: undefined
                            });
                        }
                    })
                })
            ]
        }),
        placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: pageSize,
            onChange: (page)=>{
                updateSearchParameters({
                    page: page
                });
            }
        },
        isLoading: isLoading,
        errorMessage: error?.body?.message ?? error?.message,
        onRetry: async ()=>mutate(undefined, true)
    });
}
var $cf7839843df44a16$export$2e2bcd8739ae039 = $cf7839843df44a16$var$AuditLogTable;


var $d7737aa2d04f0002$export$fa0831f497706bad;
var $d7737aa2d04f0002$export$bfd64c937657f93a;
var $d7737aa2d04f0002$export$4a6dd88bada4e7d2;
$d7737aa2d04f0002$export$fa0831f497706bad = `_97l8UW_logs`;
$d7737aa2d04f0002$export$bfd64c937657f93a = `_97l8UW_rotating`;
$d7737aa2d04f0002$export$4a6dd88bada4e7d2 = `_97l8UW_shimmer`;


function $121e11b9ce7afc2b$var$MachineLogs({ applicationId: applicationId }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cf7839843df44a16$export$2e2bcd8739ae039), {
        applicationId: applicationId,
        className: $d7737aa2d04f0002$export$fa0831f497706bad
    });
}
var $121e11b9ce7afc2b$export$2e2bcd8739ae039 = $121e11b9ce7afc2b$var$MachineLogs;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a9b26f155c5b34c5$var$SvgM2MRoleDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_8921_102395)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M21 26.556c0-.86.696-1.556 1.556-1.556h10.888c.86 0 1.556.696 1.556 1.556v7.777c0 .86-.696 1.556-1.556 1.556H22.556c-.86 0-1.556-.697-1.556-1.556v-7.777Z",
                fill: "url(#paint1_linear_8921_102395)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M21 28.111h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 26.945c0-.215.174-.39.389-.39h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.388Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.556,
                y: 26.556,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 30.833c0-.215.174-.389.389-.389h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.389Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.556,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24.111,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 34.723c0-.215.174-.389.389-.389h3.888a.389.389 0 0 1 0 .778h-3.889a.389.389 0 0 1-.388-.39Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.555,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24.111,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M21 32h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8921_102395",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8921_102395",
                        x1: 19.85,
                        y1: 31.238,
                        x2: 33.727,
                        y2: 24.651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $a9b26f155c5b34c5$export$2e2bcd8739ae039 = $a9b26f155c5b34c5$var$SvgM2MRoleDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $844c753ae2b24ff8$var$SvgM2MRole = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_8921_102314)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M21 26.556c0-.86.696-1.556 1.556-1.556h10.888c.86 0 1.556.696 1.556 1.556v7.777c0 .86-.696 1.556-1.556 1.556H22.556c-.86 0-1.556-.697-1.556-1.556v-7.777Z",
                fill: "url(#paint1_linear_8921_102314)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M21 28.111h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 26.945c0-.215.174-.39.389-.39h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.388Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.556,
                y: 26.556,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 30.833c0-.215.174-.389.389-.389h3.889a.389.389 0 1 1 0 .778h-3.89a.389.389 0 0 1-.388-.389Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.556,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24.111,
                y: 30.444,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M28.778 34.723c0-.215.174-.389.389-.389h3.889a.389.389 0 0 1 0 .778h-3.889a.389.389 0 0 1-.389-.39Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.556,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24.112,
                y: 34.334,
                width: 0.778,
                height: 0.778,
                rx: 0.389,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M21 32h14v.778H21z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8921_102314",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8921_102314",
                        x1: 19.85,
                        y1: 31.238,
                        x2: 33.727,
                        y2: 24.651,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $844c753ae2b24ff8$export$2e2bcd8739ae039 = $844c753ae2b24ff8$var$SvgM2MRole;






var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");


parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");


var $93h5F = parcelRequire("93h5F");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $d9a7729c7b9aa700$export$827f4ee28efc37;
var $d9a7729c7b9aa700$export$a03f626b8106969c;
var $d9a7729c7b9aa700$export$eda11a42e6b44edc;
var $d9a7729c7b9aa700$export$9f6c77b8cdee9051;
var $d9a7729c7b9aa700$export$34e0f9847d4c02dd;
var $d9a7729c7b9aa700$export$2d49e08edfff676e;
var $d9a7729c7b9aa700$export$bfd64c937657f93a;
var $d9a7729c7b9aa700$export$4a6dd88bada4e7d2;
var $d9a7729c7b9aa700$export$d999e528e771887b;
$d9a7729c7b9aa700$export$827f4ee28efc37 = `G_cUGW_box`;
$d9a7729c7b9aa700$export$a03f626b8106969c = `G_cUGW_boxContent`;
$d9a7729c7b9aa700$export$eda11a42e6b44edc = `G_cUGW_boxPagination`;
$d9a7729c7b9aa700$export$9f6c77b8cdee9051 = `G_cUGW_boxTopBar`;
$d9a7729c7b9aa700$export$34e0f9847d4c02dd = `G_cUGW_container`;
$d9a7729c7b9aa700$export$2d49e08edfff676e = `G_cUGW_emptyBoxContent`;
$d9a7729c7b9aa700$export$bfd64c937657f93a = `G_cUGW_rotating`;
$d9a7729c7b9aa700$export$4a6dd88bada4e7d2 = `G_cUGW_shimmer`;
$d9a7729c7b9aa700$export$d999e528e771887b = `G_cUGW_verticalBar`;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");



var $6ZMK7 = parcelRequire("6ZMK7");


var $hdJkM = parcelRequire("hdJkM");

var $eCoWV = parcelRequire("eCoWV");
const $e92af1f6c236dce4$var$defaultDelay = 500;
const $e92af1f6c236dce4$var$useDebounce = (delay = $e92af1f6c236dce4$var$defaultDelay)=>{
    const timerRef = (0, $eCoWV.useRef)();
    const clearTimer = ()=>{
        if (timerRef.current) clearTimeout(timerRef.current);
    };
    (0, $eCoWV.useEffect)(()=>{
        return ()=>{
            clearTimer();
        };
    }, []);
    return (callback)=>{
        clearTimer();
        // eslint-disable-next-line @silverhand/fp/no-mutation
        timerRef.current = window.setTimeout(()=>{
            callback();
            clearTimer();
        }, delay);
    };
};
var $e92af1f6c236dce4$export$2e2bcd8739ae039 = $e92af1f6c236dce4$var$useDebounce;




var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $6PcpQ = parcelRequire("6PcpQ");
var $bc8fbce981136f98$export$8ce1fd94bee2f412;
var $bc8fbce981136f98$export$1edee58a52776cd9;
var $bc8fbce981136f98$export$b07e517d22efa1ca;
var $bc8fbce981136f98$export$b96bb35bc88d6fa;
var $bc8fbce981136f98$export$683472f6198a076e;
var $bc8fbce981136f98$export$1ca1ec8b29a4ce27;
var $bc8fbce981136f98$export$1237798dc640739a;
var $bc8fbce981136f98$export$bfd64c937657f93a;
var $bc8fbce981136f98$export$4a6dd88bada4e7d2;
var $bc8fbce981136f98$export$e94f7fc6c53d997d;
var $bc8fbce981136f98$export$cc74dcc53cfce4eb;
$bc8fbce981136f98$export$8ce1fd94bee2f412 = `nsdVTW_background`;
$bc8fbce981136f98$export$1edee58a52776cd9 = `nsdVTW_border`;
$bc8fbce981136f98$export$b07e517d22efa1ca = `nsdVTW_checkbox`;
$bc8fbce981136f98$export$b96bb35bc88d6fa = `nsdVTW_checked`;
$bc8fbce981136f98$export$683472f6198a076e = `nsdVTW_disabled`;
$bc8fbce981136f98$export$1ca1ec8b29a4ce27 = `nsdVTW_icon`;
$bc8fbce981136f98$export$1237798dc640739a = `nsdVTW_label`;
$bc8fbce981136f98$export$bfd64c937657f93a = `nsdVTW_rotating`;
$bc8fbce981136f98$export$4a6dd88bada4e7d2 = `nsdVTW_shimmer`;
$bc8fbce981136f98$export$e94f7fc6c53d997d = `nsdVTW_tooltipAnchor`;
$bc8fbce981136f98$export$cc74dcc53cfce4eb = `nsdVTW_wrapper`;


function $fd557585b642c791$var$Checkbox({ checked: checked, disabled: disabled = false, indeterminate: indeterminate, onChange: onChange, label: label, className: className, tooltip: tooltip }) {
    const [isIndeterminate, setIsIndeterminate] = (0, $eCoWV.useState)(indeterminate);
    (0, $eCoWV.useLayoutEffect)(()=>{
        setIsIndeterminate(indeterminate);
    }, [
        indeterminate
    ]);
    const handleChange = ()=>{
        if (disabled) return;
        if (isIndeterminate) onChange(false);
        setIsIndeterminate(false);
        onChange(!checked);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($bc8fbce981136f98$export$b07e517d22efa1ca, disabled && $bc8fbce981136f98$export$683472f6198a076e, className),
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            "aria-checked": checked,
            className: $bc8fbce981136f98$export$cc74dcc53cfce4eb,
            role: "checkbox",
            tabIndex: 0,
            onClick: handleChange,
            onKeyDown: (0, $6PcpQ.onKeyDownHandler)(handleChange),
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                    horizontalAlign: "start",
                    content: tooltip,
                    anchorClassName: $bc8fbce981136f98$export$e94f7fc6c53d997d,
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($bc8fbce981136f98$export$1ca1ec8b29a4ce27, (checked || isIndeterminate) && $bc8fbce981136f98$export$b96bb35bc88d6fa, disabled && $bc8fbce981136f98$export$683472f6198a076e),
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                className: $bc8fbce981136f98$export$8ce1fd94bee2f412,
                                x: "1.66663",
                                y: "1.6665",
                                width: "16.6667",
                                height: "16.6667",
                                rx: "4"
                            }),
                            checked && !isIndeterminate && /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M8.31476 13.858L5.13295 10.441C4.95568 10.253 4.95568 9.947 5.13295 9.757L5.77568 9.074C5.95295 8.886 6.24113 8.886 6.4184 9.074L8.63657 11.466L13.5811 6.141C13.7584 5.953 14.0465 5.953 14.2238 6.141L14.8665 6.825C15.0438 7.013 15.0438 7.32 14.8665 7.507L8.95748 13.858C8.78021 14.046 8.49203 14.046 8.31476 13.858Z",
                                fill: "white"
                            }),
                            isIndeterminate && /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M5 9.37516C5 9.14504 5.1599 8.9585 5.35714 8.9585H14.6429C14.8401 8.9585 15 9.14504 15 9.37516V10.6252C15 10.8553 14.8401 11.0418 14.6429 11.0418H5.35714C5.1599 11.0418 5 10.8553 5 10.6252V9.37516Z",
                                fill: "white"
                            }),
                            !checked && !isIndeterminate && /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                className: $bc8fbce981136f98$export$1edee58a52776cd9,
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M15.2469 3.20971H4.75305C3.90076 3.20971 3.20984 3.90063 3.20984 4.75293V15.2467C3.20984 16.099 3.90076 16.79 4.75305 16.79H15.2469C16.0992 16.79 16.7901 16.099 16.7901 15.2467V4.75292C16.7901 3.90063 16.0992 3.20971 15.2469 3.20971ZM4.75305 1.6665C3.04846 1.6665 1.66663 3.04834 1.66663 4.75293V15.2467C1.66663 16.9513 3.04847 18.3332 4.75305 18.3332H15.2469C16.9515 18.3332 18.3333 16.9513 18.3333 15.2467V4.75292C18.3333 3.04834 16.9515 1.6665 15.2469 1.6665H4.75305Z"
                            })
                        ]
                    })
                }),
                label && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $bc8fbce981136f98$export$1237798dc640739a,
                    children: label
                })
            ]
        })
    });
}
var $fd557585b642c791$export$2e2bcd8739ae039 = $fd557585b642c791$var$Checkbox;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $fbeQ6 = parcelRequire("fbeQ6");

var $8df82a76eae272a7$export$e5e25fbcc1f7affe;
var $8df82a76eae272a7$export$bfd64c937657f93a;
var $8df82a76eae272a7$export$4a6dd88bada4e7d2;
$8df82a76eae272a7$export$e5e25fbcc1f7affe = `BNvetG_group`;
$8df82a76eae272a7$export$bfd64c937657f93a = `BNvetG_rotating`;
$8df82a76eae272a7$export$4a6dd88bada4e7d2 = `BNvetG_shimmer`;


function $6e06fb568fe18a34$var$CheckboxGroup({ options: options, value: checkedValues, onChange: onChange, className: className }) {
    const toggleValue = (value)=>{
        onChange(checkedValues.includes(value) ? checkedValues.filter((selected)=>selected !== value) : [
            ...checkedValues,
            value
        ]);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8df82a76eae272a7$export$e5e25fbcc1f7affe, className),
        children: options.map(({ title: title, value: value })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                }),
                checked: checkedValues.includes(value),
                onChange: ()=>{
                    toggleValue(value);
                }
            }, value))
    });
}
var $6e06fb568fe18a34$export$2e2bcd8739ae039 = $6e06fb568fe18a34$var$CheckboxGroup;





var $6PcpQ = parcelRequire("6PcpQ");
var $aae6e6eb22e61416$export$85b9a36db797e02b;
var $aae6e6eb22e61416$export$7061c75fc5af8b7e;
var $aae6e6eb22e61416$export$a8ff84c12d48cfa6;
var $aae6e6eb22e61416$export$bfd64c937657f93a;
var $aae6e6eb22e61416$export$4a6dd88bada4e7d2;
$aae6e6eb22e61416$export$85b9a36db797e02b = `_4xx24W_count`;
$aae6e6eb22e61416$export$7061c75fc5af8b7e = `_4xx24W_item`;
$aae6e6eb22e61416$export$a8ff84c12d48cfa6 = `_4xx24W_name`;
$aae6e6eb22e61416$export$bfd64c937657f93a = `_4xx24W_rotating`;
$aae6e6eb22e61416$export$4a6dd88bada4e7d2 = `_4xx24W_shimmer`;


function $342650d30a6d4c9b$var$SourceRoleItem({ role: role, isSelected: isSelected, onSelect: onSelect }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, type: type, usersCount: usersCount, applicationsCount: applicationsCount } = role;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $aae6e6eb22e61416$export$7061c75fc5af8b7e,
        role: "button",
        tabIndex: 0,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            onSelect();
        }),
        onClick: ()=>{
            onSelect();
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $aae6e6eb22e61416$export$a8ff84c12d48cfa6,
                children: name
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $aae6e6eb22e61416$export$85b9a36db797e02b,
                children: [
                    "(",
                    type === (0, $3kVX5.RoleType).User ? t("user_details.roles.assigned_user_count", {
                        value: usersCount
                    }) : t("application_details.roles.assigned_app_count", {
                        value: applicationsCount
                    }),
                    ")"
                ]
            })
        ]
    });
}
var $342650d30a6d4c9b$export$2e2bcd8739ae039 = $342650d30a6d4c9b$var$SourceRoleItem;


var $eaae2ce7b336fd68$export$f05c1fab6a17ec98;
var $eaae2ce7b336fd68$export$1ca1ec8b29a4ce27;
var $eaae2ce7b336fd68$export$d76128d007d19019;
$eaae2ce7b336fd68$export$f05c1fab6a17ec98 = `-Tm1cW_emptyImage`;
$eaae2ce7b336fd68$export$1ca1ec8b29a4ce27 = `-Tm1cW_icon`;
$eaae2ce7b336fd68$export$d76128d007d19019 = `-Tm1cW_search`;


const $6e9508d9e0f89cc6$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $6e9508d9e0f89cc6$var$SourceRolesBox({ entityId: entityId, type: type, selectedRoles: selectedRoles, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const debounce = (0, $e92af1f6c236dce4$export$2e2bcd8739ae039)();
    const url = (0, $h7VLF.buildUrl)("api/roles", {
        page: String(page),
        page_size: String($6e9508d9e0f89cc6$var$pageSize),
        type: type,
        [type === (0, $3kVX5.RoleType).User ? "excludeUserId" : "excludeApplicationId"]: entityId,
        ...(0, $5CQIb.conditional)(keyword && {
            search: `%${keyword}%`
        })
    });
    const { data: data, error: error } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const [dataSource = [], totalCount] = data ?? [];
    const isRoleSelected = (role)=>selectedRoles.findIndex(({ id: id })=>role.id === id) >= 0;
    const handleSearchInput = (event)=>{
        debounce(()=>{
            setPage(1);
            setKeyword(event.target.value);
        });
    };
    const isEmpty = !isLoading && !error && dataSource.length === 0;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    className: $eaae2ce7b336fd68$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                        className: $eaae2ce7b336fd68$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$a03f626b8106969c, isEmpty && $d9a7729c7b9aa700$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {
                    size: "small",
                    title: t(type === (0, $3kVX5.RoleType).User ? "user_details.roles.empty" : "application_details.roles.empty")
                }) : dataSource.map((role)=>{
                    const isSelected = isRoleSelected(role);
                    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $342650d30a6d4c9b$export$2e2bcd8739ae039), {
                        role: role,
                        isSelected: isSelected,
                        onSelect: ()=>{
                            onChange(isSelected ? selectedRoles.filter(({ id: id })=>id !== role.id) : [
                                role,
                                ...selectedRoles
                            ]);
                        }
                    }, role.id);
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $226d823c87c084c3$export$2e2bcd8739ae039), {
                mode: "pico",
                page: page,
                totalCount: totalCount,
                pageSize: $6e9508d9e0f89cc6$var$pageSize,
                className: $d9a7729c7b9aa700$export$eda11a42e6b44edc,
                onChange: (page)=>{
                    setPage(page);
                }
            })
        ]
    });
}
var $6e9508d9e0f89cc6$export$2e2bcd8739ae039 = $6e9508d9e0f89cc6$var$SourceRolesBox;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $iHViS = parcelRequire("iHViS");

var $9bgsA = parcelRequire("9bgsA");
var $66417b9bab55b4af$export$85b9a36db797e02b;
var $66417b9bab55b4af$export$a80b3bd66acc52ff;
var $66417b9bab55b4af$export$7061c75fc5af8b7e;
var $66417b9bab55b4af$export$a8ff84c12d48cfa6;
var $66417b9bab55b4af$export$bfd64c937657f93a;
var $66417b9bab55b4af$export$4a6dd88bada4e7d2;
$66417b9bab55b4af$export$85b9a36db797e02b = `poi3lG_count`;
$66417b9bab55b4af$export$a80b3bd66acc52ff = `poi3lG_info`;
$66417b9bab55b4af$export$7061c75fc5af8b7e = `poi3lG_item`;
$66417b9bab55b4af$export$a8ff84c12d48cfa6 = `poi3lG_name`;
$66417b9bab55b4af$export$bfd64c937657f93a = `poi3lG_rotating`;
$66417b9bab55b4af$export$4a6dd88bada4e7d2 = `poi3lG_shimmer`;


function $6fd1cba880a3363f$var$TargetRoleItem({ role: role, onDelete: onDelete }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, type: type, usersCount: usersCount, applicationsCount: applicationsCount } = role;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $66417b9bab55b4af$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $66417b9bab55b4af$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $66417b9bab55b4af$export$a8ff84c12d48cfa6,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $66417b9bab55b4af$export$85b9a36db797e02b,
                        children: [
                            "(",
                            type === (0, $3kVX5.RoleType).User ? t("user_details.roles.assigned_user_count", {
                                value: usersCount
                            }) : t("application_details.roles.assigned_app_count", {
                                value: applicationsCount
                            }),
                            ")"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                size: "small",
                onClick: onDelete,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
            })
        ]
    });
}
var $6fd1cba880a3363f$export$2e2bcd8739ae039 = $6fd1cba880a3363f$var$TargetRoleItem;


var $b0413e0d2c1b0a8f$export$80f73db1a407fae0;
var $b0413e0d2c1b0a8f$export$1ca1ec8b29a4ce27;
$b0413e0d2c1b0a8f$export$80f73db1a407fae0 = `muW9bW_added`;
$b0413e0d2c1b0a8f$export$1ca1ec8b29a4ce27 = `muW9bW_icon`;


function $bee397787e56cd4b$var$TargetRolesBox({ selectedRoles: selectedRoles, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                    className: $b0413e0d2c1b0a8f$export$80f73db1a407fae0,
                    children: [
                        `${selectedRoles.length} `,
                        t("general.added")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$a03f626b8106969c,
                children: selectedRoles.map((role)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $6fd1cba880a3363f$export$2e2bcd8739ae039), {
                        role: role,
                        onDelete: ()=>{
                            onChange(selectedRoles.filter(({ id: id })=>id !== role.id));
                        }
                    }, role.id))
            })
        ]
    });
}
var $bee397787e56cd4b$export$2e2bcd8739ae039 = $bee397787e56cd4b$var$TargetRolesBox;


var $f4d8c755d898d80d$export$a9c4b5b7bc92a147;
$f4d8c755d898d80d$export$a9c4b5b7bc92a147 = `_1g5OiG_rolesTransfer`;


function $1dc4d544f7cc687f$var$RolesTransfer({ entityId: entityId, type: type, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$34e0f9847d4c02dd, $f4d8c755d898d80d$export$a9c4b5b7bc92a147),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6e9508d9e0f89cc6$export$2e2bcd8739ae039), {
                entityId: entityId,
                type: type,
                selectedRoles: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$d999e528e771887b
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bee397787e56cd4b$export$2e2bcd8739ae039), {
                selectedRoles: value,
                onChange: onChange
            })
        ]
    });
}
var $1dc4d544f7cc687f$export$2e2bcd8739ae039 = $1dc4d544f7cc687f$var$RolesTransfer;



var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $bNHoO = parcelRequire("bNHoO");

var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");

function $3c071dfe7dd5aca2$var$AssignToRoleModal({ entity: entity, onClose: onClose, type: type }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isSubmitting, setIsSubmitting] = (0, $eCoWV.useState)(false);
    const [roles, setRoles] = (0, $eCoWV.useState)([]);
    const api = (0, $2ANSb.default)();
    const handleAssign = async ()=>{
        if (isSubmitting || roles.length === 0) return;
        setIsSubmitting(true);
        try {
            await api.post(`api/${type === (0, $3kVX5.RoleType).User ? "users" : "applications"}/${entity.id}/roles`, {
                json: {
                    roleIds: roles.map(({ id: id })=>id)
                }
            });
            (0, $horhC.toast).success(t("user_details.roles.role_assigned"));
            onClose(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: t(type === (0, $3kVX5.RoleType).User ? "user_details.roles.assign_title" : "application_details.roles.assign_title", {
                    name: type === (0, $3kVX5.RoleType).User ? (0, $3f85170a081a517a$export$5f7a1baecd59f846)(entity) : entity.name
                })
            }),
            subtitle: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: t(type === (0, $3kVX5.RoleType).User ? "user_details.roles.assign_subtitle" : "application_details.roles.assign_subtitle", {
                    name: type === (0, $3kVX5.RoleType).User ? (0, $3f85170a081a517a$export$5f7a1baecd59f846)(entity) : entity.name
                })
            }),
            size: "large",
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                disabled: roles.length === 0,
                htmlType: "submit",
                title: type === (0, $3kVX5.RoleType).User ? "user_details.roles.confirm_assign" : "application_details.roles.confirm_assign",
                size: "large",
                type: "primary",
                onClick: handleAssign
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1dc4d544f7cc687f$export$2e2bcd8739ae039), {
                entityId: entity.id,
                type: type,
                value: roles,
                onChange: (value)=>{
                    setRoles(value);
                }
            })
        })
    });
}
var $3c071dfe7dd5aca2$export$2e2bcd8739ae039 = $3c071dfe7dd5aca2$var$AssignToRoleModal;



var $h7VLF = parcelRequire("h7VLF");
var $ebe79269e5941550$export$6d59db4903f20f7d;
var $ebe79269e5941550$export$3dea766d36a8935f;
var $ebe79269e5941550$export$1ca1ec8b29a4ce27;
var $ebe79269e5941550$export$2e4d17fb8dfe5f16;
var $ebe79269e5941550$export$bfd64c937657f93a;
var $ebe79269e5941550$export$4a6dd88bada4e7d2;
$ebe79269e5941550$export$6d59db4903f20f7d = `R0EvsW_description`;
$ebe79269e5941550$export$3dea766d36a8935f = `R0EvsW_filter`;
$ebe79269e5941550$export$1ca1ec8b29a4ce27 = `R0EvsW_icon`;
$ebe79269e5941550$export$2e4d17fb8dfe5f16 = `R0EvsW_rolesTable`;
$ebe79269e5941550$export$bfd64c937657f93a = `R0EvsW_rotating`;
$ebe79269e5941550$export$4a6dd88bada4e7d2 = `R0EvsW_shimmer`;


const $badef53ae0ecab37$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $badef53ae0ecab37$var$MachineToMachineApplicationRoles({ application: application }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(`api/applications/${application.id}/roles`, {
        page: String(page),
        page_size: String($badef53ae0ecab37$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    const [isAssignRolesModalOpen, setIsAssignRolesModalOpen] = (0, $eCoWV.useState)(false);
    const [roleToBeDeleted, setRoleToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!roleToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/applications/${application.id}/roles/${roleToBeDeleted.id}`);
            (0, $horhC.toast).success(t("application_details.roles.deleted", {
                name: roleToBeDeleted.name
            }));
            await mutate();
            setRoleToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                className: $ebe79269e5941550$export$2e4d17fb8dfe5f16,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "roles",
                        data: roles
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("application_details.roles.name_column"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                title: name,
                                to: `/roles/${id}`,
                                icon: theme === (0, $bhvxB.Theme).Dark ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9b26f155c5b34c5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $844c753ae2b24ff8$export$2e2bcd8739ae039), {})
                            })
                    },
                    {
                        title: t("application_details.roles.description_column"),
                        dataIndex: "description",
                        colSpan: 9,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $ebe79269e5941550$export$6d59db4903f20f7d,
                                children: description
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (role)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        setRoleToBeDeleted(role);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $ebe79269e5941550$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("application_details.roles.search"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "application_details.roles.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignRolesModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $badef53ae0ecab37$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            roleToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setRoleToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("application_details.roles.delete_description")
            }),
            isAssignRolesModalOpen && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3c071dfe7dd5aca2$export$2e2bcd8739ae039), {
                entity: application,
                type: (0, $3kVX5.RoleType).MachineToMachine,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignRolesModalOpen(false);
                }
            })
        ]
    });
}
var $badef53ae0ecab37$export$2e2bcd8739ae039 = $badef53ae0ecab37$var$MachineToMachineApplicationRoles;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $91b1s = parcelRequire("91b1s");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


var $1r8cJ = parcelRequire("1r8cJ");

var $eEyjP = parcelRequire("eEyjP");

var $47yah = parcelRequire("47yah");

var $dADBR = parcelRequire("dADBR");

var $9e9DZ = parcelRequire("9e9DZ");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $itzs0 = parcelRequire("itzs0");


function $269c8b0a23bd0dc8$var$Settings({ data: data }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const { secret: secret, type: applicationType } = data;
    const isNativeApp = applicationType === (0, $3kVX5.ApplicationType).Native;
    const uriPatternRules = {
        pattern: {
            verify: (value)=>!value || (0, $91b1s.validateRedirectUrl)(value, isNativeApp ? "mobile" : "web"),
            message: t("errors.invalid_uri_format")
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "application_details.settings",
        description: "application_details.settings_description",
        learnMoreLink: {
            href: getDocumentationUrl("/docs/references/applications"),
            targetBlank: "noopener"
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "application_details.application_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("name", {
                        required: true
                    }),
                    error: Boolean(errors.name),
                    placeholder: t("application_details.application_name_placeholder")
                })
            }),
            tenantEndpoint && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.logto_endpoint",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    value: applyCustomDomain(tenantEndpoint.href),
                    variant: "border",
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.description",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("description"),
                    placeholder: t("application_details.description_placeholder")
                })
            }),
            [
                (0, $3kVX5.ApplicationType).Traditional,
                (0, $3kVX5.ApplicationType).MachineToMachine
            ].includes(applicationType) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "application_details.application_secret",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    hasVisibilityToggle: true,
                    value: secret,
                    variant: "border",
                    className: $3b321dcb10565fb9$export$c54b92c0bb02ba64
                })
            }),
            applicationType !== (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                name: "oidcClientMetadata.redirectUris",
                control: control,
                defaultValue: [],
                rules: {
                    validate: (0, $9e9DZ.createValidatorForRhf)({
                        ...uriPatternRules,
                        required: t("application_details.redirect_uri_required")
                    })
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1r8cJ.default), {
                        isRequired: true,
                        title: "application_details.redirect_uris",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                        targetBlank: true,
                                        href: "https://openid.net/specs/openid-connect-core-1_0.html#AuthRequest",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("application_details.redirect_uri_tip")
                            }),
                        value: value,
                        error: (0, $9e9DZ.convertRhfErrorMessage)(error?.message),
                        placeholder: applicationType === (0, $3kVX5.ApplicationType).Native ? t("application_details.redirect_uri_placeholder_native") : t("application_details.redirect_uri_placeholder"),
                        onChange: onChange
                    })
            }),
            applicationType !== (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                name: "oidcClientMetadata.postLogoutRedirectUris",
                control: control,
                defaultValue: [],
                rules: {
                    validate: (0, $9e9DZ.createValidatorForRhf)(uriPatternRules)
                },
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1r8cJ.default), {
                        title: "application_details.post_sign_out_redirect_uris",
                        tip: t("application_details.post_sign_out_redirect_uri_tip"),
                        value: value,
                        error: (0, $9e9DZ.convertRhfErrorMessage)(error?.message),
                        placeholder: t("application_details.post_sign_out_redirect_uri_placeholder"),
                        onChange: onChange
                    })
            }),
            applicationType !== (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                name: "customClientMetadata.corsAllowedOrigins",
                control: control,
                defaultValue: [],
                render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1r8cJ.default), {
                        title: "application_details.cors_allowed_origins",
                        tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                        targetBlank: true,
                                        href: "https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS",
                                        onClick: closeTipHandler
                                    })
                                },
                                children: t("application_details.cors_allowed_origins_tip")
                            }),
                        value: value,
                        error: (0, $9e9DZ.convertRhfErrorMessage)(error?.message),
                        placeholder: t("application_details.cors_allowed_origins_placeholder"),
                        onChange: onChange
                    })
            })
        ]
    });
}
var $269c8b0a23bd0dc8$export$2e2bcd8739ae039 = $269c8b0a23bd0dc8$var$Settings;



const $79d4566b6fc7e849$var$mapToUriFormatArrays = (value)=>value?.filter(Boolean).map((uri)=>decodeURIComponent(uri));
const $79d4566b6fc7e849$var$mapToUriOriginFormatArrays = (value)=>value?.filter(Boolean).map((uri)=>decodeURIComponent(uri.replace(/\/*$/, "")));
function $79d4566b6fc7e849$var$ApplicationDetails() {
    const { id: id, guideId: guideId, tab: tab } = (0, $9X5Bp.useParams)();
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const isGuideView = !!id && !!guideId && match(`/applications/${id}/guide/${guideId}`);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && `api/applications/${id}`);
    const { data: oidcConfig, error: fetchOidcConfigError, mutate: mutateOidcConfig } = (0, $2mi28.default)((0, $iiBsj.openIdProviderConfigPath));
    const isLoading = !data && !error || !oidcConfig && !fetchOidcConfigError;
    const requestError = error ?? fetchOidcConfigError;
    const [isReadmeOpen, setIsReadmeOpen] = (0, $eCoWV.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const [isDeleted, setIsDeleted] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const formMethods = (0, $c3LX9.useForm)({
        defaultValues: {
            customClientMetadata: (0, $duSFh.customClientMetadataDefault),
            isAdmin: false
        }
    });
    const { handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = formMethods;
    (0, $eCoWV.useEffect)(()=>{
        if (!data) return;
        if (isDirty) return;
        reset(data);
    }, [
        data,
        isDirty,
        reset
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (!data || isSubmitting) return;
        await api.patch(`api/applications/${data.id}`, {
            json: {
                ...formData,
                oidcClientMetadata: {
                    ...formData.oidcClientMetadata,
                    redirectUris: $79d4566b6fc7e849$var$mapToUriFormatArrays(formData.oidcClientMetadata.redirectUris),
                    postLogoutRedirectUris: $79d4566b6fc7e849$var$mapToUriFormatArrays(formData.oidcClientMetadata.postLogoutRedirectUris)
                },
                customClientMetadata: {
                    ...formData.customClientMetadata,
                    corsAllowedOrigins: $79d4566b6fc7e849$var$mapToUriOriginFormatArrays(formData.customClientMetadata.corsAllowedOrigins)
                }
            }
        }).json();
        reset(formData);
        mutate();
        (0, $horhC.toast).success(t("general.saved"));
    }));
    const onDelete = async ()=>{
        if (!data || isDeleting) return;
        try {
            await api.delete(`api/applications/${data.id}`);
            setIsDeleted(true);
            setIsDeleting(false);
            setIsDeleteFormOpen(false);
            (0, $horhC.toast).success(t("application_details.application_deleted", {
                name: data.name
            }));
            navigate(`/applications`);
        } catch  {
            setIsDeleting(false);
        }
    };
    const onCloseDrawer = ()=>{
        setIsReadmeOpen(false);
    };
    if (isGuideView) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $30fbdaf9865b9deb$export$2e2bcd8739ae039), {
        guideId: guideId,
        app: data,
        onClose: ()=>{
            navigate(`/applications/${id}`);
        }
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: "/applications",
        backLinkTitle: "application_details.back_to_applications",
        isLoading: isLoading,
        error: requestError,
        onRetry: ()=>{
            mutate();
            mutateOidcConfig();
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "application_details.page_title"
            }),
            data && oidcConfig && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                            type: data.type
                        }),
                        title: data.name,
                        primaryTag: t(`${(0, $24afe283ce6acd30$export$d8e4c8dab9129f15)[data.type]}.title`),
                        identifier: {
                            name: "App ID",
                            value: data.id
                        },
                        additionalActionButton: {
                            title: "application_details.check_guide",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7529b38878187ba2$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsReadmeOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                type: "danger",
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b42f3bf1cd82d7$export$2e2bcd8739ae039), {
                        isOpen: isReadmeOpen,
                        onClose: onCloseDrawer,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $34f5432334a6c09e$export$2e2bcd8739ae039), {
                            app: data,
                            onClose: onCloseDrawer
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        expectedInput: data.name,
                        inputPlaceholder: t("application_details.enter_your_application_name"),
                        className: $3b321dcb10565fb9$export$64fda0c1cfacc296,
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $3b321dcb10565fb9$export$6d59db4903f20f7d,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        className: $3b321dcb10565fb9$export$e4043f67d36cbb26
                                    })
                                },
                                children: t("application_details.delete_description", {
                                    name: data.name
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $emGEN.ApplicationDetailsTabs).Settings}`,
                                children: t("application_details.settings")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/applications/${data.id}/${(0, $emGEN.ApplicationDetailsTabs).AdvancedSettings}`,
                                children: t("application_details.advanced_settings")
                            }),
                            data.type === (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                        href: `/applications/${data.id}/${(0, $emGEN.ApplicationDetailsTabs).Roles}`,
                                        children: t("application_details.application_roles")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                        href: `/applications/${data.id}/${(0, $emGEN.ApplicationDetailsTabs).Logs}`,
                                        children: t("application_details.machine_logs")
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
                        ...formMethods,
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                            isDirty: isDirty,
                            isSubmitting: isSubmitting,
                            onDiscard: reset,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
                                    isActive: tab === (0, $emGEN.ApplicationDetailsTabs).Settings,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $269c8b0a23bd0dc8$export$2e2bcd8739ae039), {
                                        data: data
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
                                    isActive: tab === (0, $emGEN.ApplicationDetailsTabs).AdvancedSettings,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e7549bd374b809a3$export$2e2bcd8739ae039), {
                                        app: data,
                                        oidcConfig: oidcConfig
                                    })
                                }),
                                data.type === (0, $3kVX5.ApplicationType).MachineToMachine && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $emGEN.ApplicationDetailsTabs).Roles,
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $badef53ae0ecab37$export$2e2bcd8739ae039), {
                                                application: data
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
                                            isActive: tab === (0, $emGEN.ApplicationDetailsTabs).Logs,
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $121e11b9ce7afc2b$export$2e2bcd8739ae039), {
                                                applicationId: data.id
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $79d4566b6fc7e849$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($79d4566b6fc7e849$var$ApplicationDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");




var $a0Ubj = parcelRequire("a0Ubj");

var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $lSA0o = parcelRequire("lSA0o");

var $47yah = parcelRequire("47yah");

var $d0Zvy = parcelRequire("d0Zvy");



var $4W0F0 = parcelRequire("4W0F0");



var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $aHzBK = parcelRequire("aHzBK");



var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");


var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");


var $4W0F0 = parcelRequire("4W0F0");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");


var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");


var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $ckJfF = parcelRequire("ckJfF");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");


var $aHzBK = parcelRequire("aHzBK");

var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $22dd48fdf567ffa8$exports = {};

$parcel$export($22dd48fdf567ffa8$exports, "container", function () { return $22dd48fdf567ffa8$export$34e0f9847d4c02dd; }, function (v) { return $22dd48fdf567ffa8$export$34e0f9847d4c02dd = v; });
$parcel$export($22dd48fdf567ffa8$exports, "description", function () { return $22dd48fdf567ffa8$export$6d59db4903f20f7d; }, function (v) { return $22dd48fdf567ffa8$export$6d59db4903f20f7d = v; });
$parcel$export($22dd48fdf567ffa8$exports, "proTag", function () { return $22dd48fdf567ffa8$export$5389c3225d6cd45c; }, function (v) { return $22dd48fdf567ffa8$export$5389c3225d6cd45c = v; });
$parcel$export($22dd48fdf567ffa8$exports, "rotating", function () { return $22dd48fdf567ffa8$export$bfd64c937657f93a; }, function (v) { return $22dd48fdf567ffa8$export$bfd64c937657f93a = v; });
$parcel$export($22dd48fdf567ffa8$exports, "shimmer", function () { return $22dd48fdf567ffa8$export$4a6dd88bada4e7d2; }, function (v) { return $22dd48fdf567ffa8$export$4a6dd88bada4e7d2 = v; });
$parcel$export($22dd48fdf567ffa8$exports, "small", function () { return $22dd48fdf567ffa8$export$3c17b0e969a90510; }, function (v) { return $22dd48fdf567ffa8$export$3c17b0e969a90510 = v; });
$parcel$export($22dd48fdf567ffa8$exports, "subtitle", function () { return $22dd48fdf567ffa8$export$c96745152eb2740f; }, function (v) { return $22dd48fdf567ffa8$export$c96745152eb2740f = v; });
$parcel$export($22dd48fdf567ffa8$exports, "title", function () { return $22dd48fdf567ffa8$export$fb184b623420d9be; }, function (v) { return $22dd48fdf567ffa8$export$fb184b623420d9be = v; });
var $22dd48fdf567ffa8$export$34e0f9847d4c02dd;
var $22dd48fdf567ffa8$export$6d59db4903f20f7d;
var $22dd48fdf567ffa8$export$5389c3225d6cd45c;
var $22dd48fdf567ffa8$export$bfd64c937657f93a;
var $22dd48fdf567ffa8$export$4a6dd88bada4e7d2;
var $22dd48fdf567ffa8$export$3c17b0e969a90510;
var $22dd48fdf567ffa8$export$c96745152eb2740f;
var $22dd48fdf567ffa8$export$fb184b623420d9be;
$22dd48fdf567ffa8$export$34e0f9847d4c02dd = `q8OBxa_container`;
$22dd48fdf567ffa8$export$6d59db4903f20f7d = `q8OBxa_description`;
$22dd48fdf567ffa8$export$5389c3225d6cd45c = `q8OBxa_proTag`;
$22dd48fdf567ffa8$export$bfd64c937657f93a = `q8OBxa_rotating`;
$22dd48fdf567ffa8$export$4a6dd88bada4e7d2 = `q8OBxa_shimmer`;
$22dd48fdf567ffa8$export$3c17b0e969a90510 = `q8OBxa_small`;
$22dd48fdf567ffa8$export$c96745152eb2740f = `q8OBxa_subtitle`;
$22dd48fdf567ffa8$export$fb184b623420d9be = `q8OBxa_title`;


function $b365515e9e5af8d1$var$TypeDescription({ title: title, subtitle: subtitle, description: description, type: type, size: size = "large" }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const hasPaywall = (0, $V1X8c.isCloud) && type === (0, $3kVX5.ApplicationType).MachineToMachine;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($22dd48fdf567ffa8$exports.container, $22dd48fdf567ffa8$exports[size]),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                type: type
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $22dd48fdf567ffa8$exports.title,
                children: title
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $22dd48fdf567ffa8$exports.subtitle,
                children: subtitle
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $22dd48fdf567ffa8$exports.description,
                children: description
            }),
            hasPaywall && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $22dd48fdf567ffa8$exports.proTag,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                    isVisible: !currentPlan?.quota.machineToMachineLimit,
                    for: "upsell",
                    plan: (0, $ckJfF.ReservedPlanId).Hobby
                })
            })
        ]
    });
}
var $b365515e9e5af8d1$export$2e2bcd8739ae039 = $b365515e9e5af8d1$var$TypeDescription;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $ckJfF = parcelRequire("ckJfF");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $2mi28 = parcelRequire("2mi28");




var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");


function $a6c33869b098488d$var$Footer({ selectedType: selectedType, isLoading: isLoading, onClickCreate: onClickCreate }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { data: allApplications } = (0, $2mi28.default)("api/applications");
    const m2mAppCount = (0, $eCoWV.useMemo)(()=>allApplications?.filter(({ type: type })=>type === (0, $3kVX5.ApplicationType).MachineToMachine).length ?? 0, [
        allApplications
    ]);
    const nonM2mApplicationCount = allApplications ? allApplications.length - m2mAppCount : 0;
    const isM2mAppsReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "machineToMachineLimit",
        plan: currentPlan,
        usage: m2mAppCount
    });
    const isNonM2mAppsReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "applicationsLimit",
        plan: currentPlan,
        usage: nonM2mApplicationCount
    });
    if (currentPlan && selectedType) {
        const { id: planId, name: planName, quota: quota } = currentPlan;
        if (selectedType === (0, $3kVX5.ApplicationType).MachineToMachine && isM2mAppsReachLimit) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
            children: quota.machineToMachineLimit === 0 && planId === (0, $ckJfF.ReservedPlanId).Free ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                },
                children: t("machine_to_machine_feature")
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: t("machine_to_machine", {
                    count: quota.machineToMachineLimit ?? 0
                })
            })
        });
        if (selectedType !== (0, $3kVX5.ApplicationType).MachineToMachine && isNonM2mAppsReachLimit) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: t("applications", {
                    count: quota.applicationsLimit ?? 0
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
        isLoading: isLoading,
        htmlType: "submit",
        title: "applications.create",
        size: "large",
        type: "primary",
        onClick: onClickCreate
    });
}
var $a6c33869b098488d$export$2e2bcd8739ae039 = $a6c33869b098488d$var$Footer;


var $8faabf9af3e04694$export$a3bc9b8ed74fc;
var $8faabf9af3e04694$export$7246d22ab0922ede;
var $8faabf9af3e04694$export$bfd64c937657f93a;
var $8faabf9af3e04694$export$4a6dd88bada4e7d2;
$8faabf9af3e04694$export$a3bc9b8ed74fc = `lMkVDq_error`;
$8faabf9af3e04694$export$7246d22ab0922ede = `lMkVDq_radioGroup`;
$8faabf9af3e04694$export$bfd64c937657f93a = `lMkVDq_rotating`;
$8faabf9af3e04694$export$4a6dd88bada4e7d2 = `lMkVDq_shimmer`;


function $5193b988a4e9b907$var$CreateForm({ defaultCreateType: defaultCreateType, defaultCreateFrameworkName: defaultCreateFrameworkName, onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isMachineToMachineDisabled = (0, $V1X8c.isCloud) && !currentPlan?.quota.machineToMachineLimit;
    const { handleSubmit: handleSubmit, control: control, register: register, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        defaultValues: {
            type: defaultCreateType
        }
    });
    const { field: { onChange: onChange, value: value, name: name, ref: ref } } = (0, $c3LX9.useController)({
        name: "type",
        control: control,
        rules: {
            required: true
        }
    });
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        const createdApp = await api.post("api/applications", {
            json: data
        }).json();
        (0, $horhC.toast).success(t("applications.application_created"));
        onClose?.(createdApp);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "applications.create",
            subtitle: defaultCreateFrameworkName ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: "applications.subtitle_with_app_type",
                interpolation: {
                    name: defaultCreateFrameworkName
                }
            }) : "applications.subtitle",
            size: "large",
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a6c33869b098488d$export$2e2bcd8739ae039), {
                selectedType: value,
                isLoading: isSubmitting,
                onClickCreate: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                children: [
                    !defaultCreateType && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        title: "applications.select_application_type",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                ref: ref,
                                className: $8faabf9af3e04694$export$7246d22ab0922ede,
                                name: name,
                                value: value,
                                type: "card",
                                onChange: onChange,
                                children: Object.values((0, $3kVX5.ApplicationType)).map((type)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                        value: type,
                                        hasCheckIconForCard: type !== (0, $3kVX5.ApplicationType).MachineToMachine,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b365515e9e5af8d1$export$2e2bcd8739ae039), {
                                            type: type,
                                            title: t(`${(0, $24afe283ce6acd30$export$d8e4c8dab9129f15)[type]}.title`),
                                            subtitle: t(`${(0, $24afe283ce6acd30$export$d8e4c8dab9129f15)[type]}.subtitle`),
                                            description: t(`${(0, $24afe283ce6acd30$export$d8e4c8dab9129f15)[type]}.description`)
                                        })
                                    }, type))
                            }),
                            errors.type?.type === "required" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $8faabf9af3e04694$export$a3bc9b8ed74fc,
                                children: t("applications.no_application_type_selected")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "applications.application_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("name", {
                                required: true
                            }),
                            placeholder: t("applications.application_name_placeholder"),
                            error: Boolean(errors.name)
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "applications.application_description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("description"),
                            placeholder: t("applications.application_description_placeholder")
                        })
                    }),
                    defaultCreateType && /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                        hidden: true,
                        ...register("type"),
                        value: defaultCreateType
                    })
                ]
            })
        })
    });
}
var $5193b988a4e9b907$export$2e2bcd8739ae039 = $5193b988a4e9b907$var$CreateForm;


var $87431305d78c1681$export$b507296dd3c7a2ce;
var $87431305d78c1681$export$b33cb64c1b36574c;
var $87431305d78c1681$export$34e0f9847d4c02dd;
var $87431305d78c1681$export$a76584009ca8faeb;
var $87431305d78c1681$export$774b667cba0f8f5f;
var $87431305d78c1681$export$82462a21aead86ed;
var $87431305d78c1681$export$d4abd167df80d226;
var $87431305d78c1681$export$1f1f054184239bf5;
var $87431305d78c1681$export$93a3f47f7318e7e2;
var $87431305d78c1681$export$5389c3225d6cd45c;
var $87431305d78c1681$export$bfd64c937657f93a;
var $87431305d78c1681$export$952af3258ed45903;
var $87431305d78c1681$export$4a6dd88bada4e7d2;
var $87431305d78c1681$export$cc74dcc53cfce4eb;
$87431305d78c1681$export$b507296dd3c7a2ce = `aBenmW_checkboxGroup`;
$87431305d78c1681$export$b33cb64c1b36574c = `aBenmW_checkboxGroupContainer`;
$87431305d78c1681$export$34e0f9847d4c02dd = `aBenmW_container`;
$87431305d78c1681$export$a76584009ca8faeb = `aBenmW_emptyPlaceholder`;
$87431305d78c1681$export$774b667cba0f8f5f = `aBenmW_filterAnchor`;
$87431305d78c1681$export$82462a21aead86ed = `aBenmW_filters`;
$87431305d78c1681$export$d4abd167df80d226 = `aBenmW_groups`;
$87431305d78c1681$export$1f1f054184239bf5 = `aBenmW_guideGroup`;
$87431305d78c1681$export$93a3f47f7318e7e2 = `aBenmW_hasFilters`;
$87431305d78c1681$export$5389c3225d6cd45c = `aBenmW_proTag`;
$87431305d78c1681$export$bfd64c937657f93a = `aBenmW_rotating`;
$87431305d78c1681$export$952af3258ed45903 = `aBenmW_searchInput`;
$87431305d78c1681$export$4a6dd88bada4e7d2 = `aBenmW_shimmer`;
$87431305d78c1681$export$cc74dcc53cfce4eb = `aBenmW_wrapper`;


function $6fd305ce2c745ce4$var$GuideLibrary({ className: className, hasCardBorder: hasCardBorder, hasCardButton: hasCardButton, hasFilters: hasFilters }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.guide"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const [filterCategories, setFilterCategories] = (0, $eCoWV.useState)([]);
    const [selectedGuide, setSelectedGuide] = (0, $eCoWV.useState)();
    const { getFilteredAppGuideMetadata: getFilteredAppGuideMetadata, getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $461d44ddf3f0b8fb$export$6b80cd72646f4cab)();
    const [showCreateForm, setShowCreateForm] = (0, $eCoWV.useState)(false);
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isM2mDisabledForCurrentPlan = (0, $V1X8c.isCloud) && !currentPlan?.quota.machineToMachineLimit;
    const structuredMetadata = (0, $eCoWV.useMemo)(()=>getStructuredAppGuideMetadata({
            categories: filterCategories
        }), [
        getStructuredAppGuideMetadata,
        filterCategories
    ]);
    const filteredMetadata = (0, $eCoWV.useMemo)(()=>getFilteredAppGuideMetadata({
            keyword: keyword,
            categories: filterCategories
        }), [
        getFilteredAppGuideMetadata,
        keyword,
        filterCategories
    ]);
    const onClickGuide = (0, $eCoWV.useCallback)((data)=>{
        setShowCreateForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateForm = (0, $eCoWV.useCallback)((newApp)=>{
        if (newApp && selectedGuide) {
            navigate(`/applications/${newApp.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $d0Zvy.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($87431305d78c1681$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($87431305d78c1681$export$cc74dcc53cfce4eb, hasFilters && $87431305d78c1681$export$93a3f47f7318e7e2),
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $87431305d78c1681$export$d4abd167df80d226,
                    children: [
                        hasFilters && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $87431305d78c1681$export$774b667cba0f8f5f,
                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $87431305d78c1681$export$82462a21aead86ed,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("label", {
                                        children: t("filter.title")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                        className: $87431305d78c1681$export$952af3258ed45903,
                                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {}),
                                        placeholder: t("filter.placeholder"),
                                        value: keyword,
                                        onChange: (event)=>{
                                            setKeyword(event.currentTarget.value);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $87431305d78c1681$export$b33cb64c1b36574c,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6e06fb568fe18a34$export$2e2bcd8739ae039), {
                                                className: $87431305d78c1681$export$b507296dd3c7a2ce,
                                                options: (0, $24afe283ce6acd30$export$a5fbc60a6db6cc4b).map((category)=>({
                                                        title: `guide.categories.${category}`,
                                                        value: category
                                                    })),
                                                value: filterCategories,
                                                onChange: (value)=>{
                                                    const sortedValue = (0, $24afe283ce6acd30$export$a5fbc60a6db6cc4b).filter((category)=>value.includes(category));
                                                    setFilterCategories(sortedValue);
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                                                isVisible: isM2mDisabledForCurrentPlan,
                                                for: "upsell",
                                                plan: (0, $ckJfF.ReservedPlanId).Hobby,
                                                className: $87431305d78c1681$export$5389c3225d6cd45c
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        keyword && (filteredMetadata.length > 0 ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                            className: $87431305d78c1681$export$1f1f054184239bf5,
                            hasCardBorder: hasCardBorder,
                            hasCardButton: hasCardButton,
                            guides: filteredMetadata,
                            onClickGuide: onClickGuide
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {
                            className: $87431305d78c1681$export$a76584009ca8faeb,
                            size: "large"
                        })),
                        !keyword && (filterCategories.length > 0 ? filterCategories : (0, $24afe283ce6acd30$export$a5fbc60a6db6cc4b)).map((category)=>structuredMetadata[category].length > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                                className: $87431305d78c1681$export$1f1f054184239bf5,
                                hasCardBorder: hasCardBorder,
                                hasCardButton: hasCardButton,
                                categoryName: t(`categories.${category}`),
                                guides: structuredMetadata[category],
                                onClickGuide: onClickGuide
                            }, category))
                    ]
                })
            }),
            selectedGuide?.target !== "API" && showCreateForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5193b988a4e9b907$export$2e2bcd8739ae039), {
                defaultCreateType: selectedGuide?.target,
                defaultCreateFrameworkName: selectedGuide?.name,
                onClose: onCloseCreateForm
            })
        ]
    });
}
var $6fd305ce2c745ce4$export$2e2bcd8739ae039 = $6fd305ce2c745ce4$var$GuideLibrary;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");



var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");


var $ab23235ba97268fe$export$34e0f9847d4c02dd;
var $ab23235ba97268fe$export$a7db06668cad9adb;
var $ab23235ba97268fe$export$f0c9323dff8f5149;
var $ab23235ba97268fe$export$bfd64c937657f93a;
var $ab23235ba97268fe$export$4a6dd88bada4e7d2;
$ab23235ba97268fe$export$34e0f9847d4c02dd = `oksFFW_container`;
$ab23235ba97268fe$export$a7db06668cad9adb = `oksFFW_content`;
$ab23235ba97268fe$export$f0c9323dff8f5149 = `oksFFW_footerInnerWrapper`;
$ab23235ba97268fe$export$bfd64c937657f93a = `oksFFW_rotating`;
$ab23235ba97268fe$export$4a6dd88bada4e7d2 = `oksFFW_shimmer`;


function $33726cd719359263$var$GuideLibraryModal({ isOpen: isOpen, onClose: onClose }) {
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [showCreateForm, setShowCreateForm] = (0, $eCoWV.useState)(false);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $ab23235ba97268fe$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25451d9c34e1e7ec$export$2e2bcd8739ae039), {
                        title: "guide.app.guide_modal_title",
                        subtitle: "guide.app.modal_subtitle",
                        buttonText: "guide.cannot_find_guide",
                        requestFormFieldLabel: "guide.describe_guide_looking_for",
                        requestFormFieldPlaceholder: "guide.app.describe_guide_looking_for_placeholder",
                        requestSuccessMessage: "guide.request_guide_successfully",
                        onClose: onClose
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6fd305ce2c745ce4$export$2e2bcd8739ae039), {
                        hasFilters: true,
                        hasCardButton: true,
                        className: $ab23235ba97268fe$export$a7db06668cad9adb
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9372f297e6326ac2$export$2e2bcd8739ae039), {
                        wrapperClassName: $ab23235ba97268fe$export$f0c9323dff8f5149,
                        content: "guide.do_not_need_tutorial",
                        buttonText: "guide.app.continue_without_framework",
                        onClick: ()=>{
                            setShowCreateForm(true);
                        }
                    })
                ]
            }),
            showCreateForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5193b988a4e9b907$export$2e2bcd8739ae039), {
                onClose: (newApp)=>{
                    if (newApp) navigate(`/applications/${newApp.id}`);
                    setShowCreateForm(false);
                }
            })
        ]
    });
}
var $33726cd719359263$export$2e2bcd8739ae039 = $33726cd719359263$var$GuideLibraryModal;


var $ae2c800e52e329b3$export$25ada6361acbb81c;
var $ae2c800e52e329b3$export$deecac453d2344ce;
var $ae2c800e52e329b3$export$1ca1ec8b29a4ce27;
var $ae2c800e52e329b3$export$b839f963c7dc0e34;
var $ae2c800e52e329b3$export$bfd64c937657f93a;
var $ae2c800e52e329b3$export$4a6dd88bada4e7d2;
var $ae2c800e52e329b3$export$fb184b623420d9be;
$ae2c800e52e329b3$export$25ada6361acbb81c = `_7_IiMW_applicationName`;
$ae2c800e52e329b3$export$deecac453d2344ce = `_7_IiMW_guideLibraryContainer`;
$ae2c800e52e329b3$export$1ca1ec8b29a4ce27 = `_7_IiMW_icon`;
$ae2c800e52e329b3$export$b839f963c7dc0e34 = `_7_IiMW_library`;
$ae2c800e52e329b3$export$bfd64c937657f93a = `_7_IiMW_rotating`;
$ae2c800e52e329b3$export$4a6dd88bada4e7d2 = `_7_IiMW_shimmer`;
$ae2c800e52e329b3$export$fb184b623420d9be = `_7_IiMW_title`;


const $d89e5ea4d5929442$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $d89e5ea4d5929442$var$applicationsPathname = "/applications";
const $d89e5ea4d5929442$var$createApplicationPathname = `${$d89e5ea4d5929442$var$applicationsPathname}/create`;
const $d89e5ea4d5929442$var$buildDetailsPathname = (id)=>`${$d89e5ea4d5929442$var$applicationsPathname}/${id}`;
function $d89e5ea4d5929442$var$Applications() {
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { match: match, navigate: navigate } = (0, $4W0F0.default)();
    const isCreating = match($d89e5ea4d5929442$var$createApplicationPathname);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1
    });
    const url = (0, $h7VLF.buildUrl)("api/applications", {
        page: String(page),
        page_size: String($d89e5ea4d5929442$var$pageSize)
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const [applications, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $f3853caa1df6ee27$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "applications.title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $f3853caa1df6ee27$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                        title: "applications.title",
                        subtitle: "applications.subtitle"
                    }),
                    !!totalCount && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        title: "applications.create",
                        onClick: ()=>{
                            navigate({
                                pathname: $d89e5ea4d5929442$var$createApplicationPathname,
                                search: search
                            });
                        }
                    })
                ]
            }),
            !isLoading && !applications?.length && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $d0Zvy.default), {
                className: $ae2c800e52e329b3$export$deecac453d2344ce,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                        className: $ae2c800e52e329b3$export$fb184b623420d9be,
                        title: "guide.app.select_framework_or_tutorial",
                        subtitle: "guide.app.modal_subtitle"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6fd305ce2c745ce4$export$2e2bcd8739ae039), {
                        hasCardBorder: true,
                        hasCardButton: true,
                        className: $ae2c800e52e329b3$export$b839f963c7dc0e34
                    })
                ]
            }),
            (isLoading || !!applications?.length) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                isLoading: isLoading,
                className: $f3853caa1df6ee27$export$9852986a3ec5f6a0,
                rowGroups: [
                    {
                        key: "applications",
                        data: applications
                    }
                ],
                rowIndexKey: "id",
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("applications.application_name"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name, type: type })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                title: name,
                                subtitle: t(`${(0, $24afe283ce6acd30$export$d8e4c8dab9129f15)[type]}.title`),
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                                    className: $ae2c800e52e329b3$export$1ca1ec8b29a4ce27,
                                    type: type
                                }),
                                to: $d89e5ea4d5929442$var$buildDetailsPathname(id)
                            })
                    },
                    {
                        title: t("applications.app_id"),
                        dataIndex: "id",
                        colSpan: 10,
                        render: ({ id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                value: id,
                                variant: "text"
                            })
                    }
                ],
                rowClickHandler: ({ id: id })=>{
                    navigate($d89e5ea4d5929442$var$buildDetailsPathname(id));
                },
                pagination: {
                    page: page,
                    totalCount: totalCount,
                    pageSize: $d89e5ea4d5929442$var$pageSize,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                onRetry: async ()=>mutate(undefined, true)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $33726cd719359263$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: ()=>{
                    navigate({
                        pathname: $d89e5ea4d5929442$var$applicationsPathname,
                        search: search
                    });
                }
            })
        ]
    });
}
var $d89e5ea4d5929442$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($d89e5ea4d5929442$var$Applications);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $faCyI = parcelRequire("faCyI");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");



var $a0Ubj = parcelRequire("a0Ubj");


var $adtV2 = parcelRequire("adtV2");
parcelRequire("j6dBR");
var $lq5Qn = parcelRequire("lq5Qn");
const $d1ae2259def9c839$export$80c7b11c6af2a158 = Object.freeze({
    [(0, $lq5Qn.HookEvent).PostRegister]: "webhooks.events.post_register",
    [(0, $lq5Qn.HookEvent).PostResetPassword]: "webhooks.events.post_reset_password",
    [(0, $lq5Qn.HookEvent).PostSignIn]: "webhooks.events.post_sign_in"
});
const $d1ae2259def9c839$export$2c04910a41e08127 = Object.freeze({
    [(0, $lq5Qn.HookEvent).PostRegister]: "TriggerHook.PostRegister",
    [(0, $lq5Qn.HookEvent).PostResetPassword]: "TriggerHook.PostResetPassword",
    [(0, $lq5Qn.HookEvent).PostSignIn]: "TriggerHook.PostSignIn"
});



var $1UQTm = parcelRequire("1UQTm");

var $5irU4 = parcelRequire("5irU4");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $4a53c13519cce05c$export$2b62a06a9fee979c;
var $4a53c13519cce05c$export$1ca1ec8b29a4ce27;
var $4a53c13519cce05c$export$1237798dc640739a;
var $4a53c13519cce05c$export$fe7c49d056ea1d88;
$4a53c13519cce05c$export$2b62a06a9fee979c = `_1f0U4G_fail`;
$4a53c13519cce05c$export$1ca1ec8b29a4ce27 = `_1f0U4G_icon`;
$4a53c13519cce05c$export$1237798dc640739a = `_1f0U4G_label`;
$4a53c13519cce05c$export$fe7c49d056ea1d88 = `_1f0U4G_success`;


function $5fe64ec080f12f00$var$EventIcon({ isSuccess: isSuccess }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: isSuccess ? $4a53c13519cce05c$export$fe7c49d056ea1d88 : $4a53c13519cce05c$export$2b62a06a9fee979c,
                children: isSuccess ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c485b7de5371d8$export$2e2bcd8739ae039), {
                    className: $4a53c13519cce05c$export$1ca1ec8b29a4ce27
                }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7739235756d87309$export$2e2bcd8739ae039), {
                    className: $4a53c13519cce05c$export$1ca1ec8b29a4ce27
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $4a53c13519cce05c$export$1237798dc640739a,
                children: t(isSuccess ? "log_details.success" : "log_details.failed")
            })
        ]
    });
}
var $5fe64ec080f12f00$export$2e2bcd8739ae039 = $5fe64ec080f12f00$var$EventIcon;


var $d9688b996dfe526a$export$ff9539f96fd6527c;
var $d9688b996dfe526a$export$32180ef41b15b513;
var $d9688b996dfe526a$export$a7db06668cad9adb;
var $d9688b996dfe526a$export$a0305a8c6cff19c8;
var $d9688b996dfe526a$export$38e42c68cf43b5d4;
var $d9688b996dfe526a$export$e9205afa0ff1255b;
var $d9688b996dfe526a$export$1237798dc640739a;
var $d9688b996dfe526a$export$f22da7240b7add18;
var $d9688b996dfe526a$export$bfd64c937657f93a;
var $d9688b996dfe526a$export$4a6dd88bada4e7d2;
$d9688b996dfe526a$export$ff9539f96fd6527c = `tI75Cq_basicInfo`;
$d9688b996dfe526a$export$32180ef41b15b513 = `tI75Cq_body`;
$d9688b996dfe526a$export$a7db06668cad9adb = `tI75Cq_content`;
$d9688b996dfe526a$export$a0305a8c6cff19c8 = `tI75Cq_eventName`;
$d9688b996dfe526a$export$38e42c68cf43b5d4 = `tI75Cq_header`;
$d9688b996dfe526a$export$e9205afa0ff1255b = `tI75Cq_infoItem`;
$d9688b996dfe526a$export$1237798dc640739a = `tI75Cq_label`;
$d9688b996dfe526a$export$f22da7240b7add18 = `tI75Cq_main`;
$d9688b996dfe526a$export$bfd64c937657f93a = `tI75Cq_rotating`;
$d9688b996dfe526a$export$4a6dd88bada4e7d2 = `tI75Cq_shimmer`;


const $c0edd8f6d5f01a0d$var$getAuditLogDetailsRelatedResourceLink = (pathname)=>`${pathname.slice(0, pathname.lastIndexOf("/"))}`;
const $c0edd8f6d5f01a0d$var$getDetailsTabNavLink = (logId, userId)=>userId ? `/users/${userId}/logs/${logId}` : `/audit-logs/${logId}`;
const $c0edd8f6d5f01a0d$var$isWebhookEventLog = (key)=>key && Object.values((0, $d1ae2259def9c839$export$2c04910a41e08127)).includes(key);
function $c0edd8f6d5f01a0d$var$AuditLogDetails() {
    const { userId: userId, hookId: hookId, logId: logId } = (0, $9X5Bp.useParams)();
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(logId && `api/logs/${logId}`);
    const { data: userData } = (0, $2mi28.default)(userId && `api/users/${userId}`);
    const { data: hookData } = (0, $2mi28.default)(hookId && `api/hooks/${hookId}`);
    const isLoading = !data && !error;
    const backLink = $c0edd8f6d5f01a0d$var$getAuditLogDetailsRelatedResourceLink(pathname);
    const backLinkTitle = (0, $5CQIb.conditional)(userId && t("log_details.back_to", {
        name: (0, $3f85170a081a517a$export$5f7a1baecd59f846)(userData)
    })) ?? (0, $5CQIb.conditional)(hookId && t("log_details.back_to", {
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        name: hookData?.name || t("users.unnamed")
    })) ?? t("log_details.back_to_logs");
    if (!logId) return null;
    const isWebHookEvent = $c0edd8f6d5f01a0d$var$isWebhookEventLog(data?.key);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: backLink,
        backLinkTitle: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
            children: backLinkTitle
        }),
        isLoading: isLoading,
        error: error,
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "log_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: $d9688b996dfe526a$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5fe64ec080f12f00$export$2e2bcd8739ae039), {
                                isSuccess: data.payload.result === "Success"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $d9688b996dfe526a$export$a7db06668cad9adb,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $d9688b996dfe526a$export$a0305a8c6cff19c8,
                                        children: (0, $adtV2.logEventTitle)[data.key]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $d9688b996dfe526a$export$ff9539f96fd6527c,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $d9688b996dfe526a$export$1237798dc640739a,
                                                        children: t("log_details.event_key")
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        children: data.key
                                                    })
                                                ]
                                            }),
                                            !isWebHookEvent && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                        className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                className: $d9688b996dfe526a$export$1237798dc640739a,
                                                                children: t("log_details.application")
                                                            }),
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                children: data.payload.applicationId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5c80becd11c9ff$export$2e2bcd8739ae039), {
                                                                    isLink: data.payload.applicationId !== (0, $faCyI.demoAppApplicationId),
                                                                    applicationId: data.payload.applicationId
                                                                }) : "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                        className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                className: $d9688b996dfe526a$export$1237798dc640739a,
                                                                children: t("log_details.ip_address")
                                                            }),
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                children: data.payload.ip ?? "-"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                        className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                        children: [
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                className: $d9688b996dfe526a$export$1237798dc640739a,
                                                                children: t("log_details.user")
                                                            }),
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                                children: data.payload.userId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5704ffbe656efb4c$export$2e2bcd8739ae039), {
                                                                    isLink: true,
                                                                    userId: data.payload.userId
                                                                }) : "-"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $d9688b996dfe526a$export$1237798dc640739a,
                                                        children: t("log_details.log_id")
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        children: data.id
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                                children: [
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $d9688b996dfe526a$export$1237798dc640739a,
                                                        children: t("log_details.time")
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        children: new Date(data.createdAt).toLocaleString()
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isWebHookEvent && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $d9688b996dfe526a$export$e9205afa0ff1255b,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $d9688b996dfe526a$export$1237798dc640739a,
                                                    children: t("log_details.user_agent")
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    children: data.payload.userAgent
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: $c0edd8f6d5f01a0d$var$getDetailsTabNavLink(logId, userId),
                            children: t("log_details.tab_details")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1UQTm.default), {
                        className: $d9688b996dfe526a$export$32180ef41b15b513,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $d9688b996dfe526a$export$f22da7240b7add18,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "log_details.raw_data",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                                    language: "json",
                                    value: JSON.stringify(data.payload, null, 2)
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}
var $c0edd8f6d5f01a0d$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($c0edd8f6d5f01a0d$var$AuditLogDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");


var $a0Ubj = parcelRequire("a0Ubj");

var $lSA0o = parcelRequire("lSA0o");

function $0cb561f1335407d8$var$AuditLogs() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $f3853caa1df6ee27$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "logs.page_title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f3853caa1df6ee27$export$516dd90aeaaabcf0,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                    title: "logs.title",
                    subtitle: "logs.subtitle"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cf7839843df44a16$export$2e2bcd8739ae039), {
                className: $f3853caa1df6ee27$export$9852986a3ec5f6a0
            })
        ]
    });
}
var $0cb561f1335407d8$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($0cb561f1335407d8$var$AuditLogs);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j7Jj8");
var $4at8B = parcelRequire("4at8B");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");
var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");
var $2mi28 = parcelRequire("2mi28");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $d8aef6862763847e$var$SvgReset = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 0 0-5.733 2.308V2.5a.833.833 0 1 0-1.667 0v3.75a.833.833 0 0 0 .834.833h3.75a.833.833 0 0 0 0-1.666h-2A6.667 6.667 0 1 1 3.334 10a.833.833 0 1 0-1.667 0A8.333 8.333 0 1 0 10 1.667Zm0 5a.833.833 0 0 0-.833.833V10a.833.833 0 0 0 .833.833h1.667a.833.833 0 1 0 0-1.666h-.833V7.5A.833.833 0 0 0 10 6.667Z",
            fill: "currentColor"
        })
    });
var $d8aef6862763847e$export$2e2bcd8739ae039 = $d8aef6862763847e$var$SvgReset;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
var $ckJfF = parcelRequire("ckJfF");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");

var $2mi28 = parcelRequire("2mi28");

var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $bNHoO = parcelRequire("bNHoO");


var $7iZsu = parcelRequire("7iZsu");


var $aHzBK = parcelRequire("aHzBK");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $eb297b6792417b9c$export$f79a732982c93a3b;
var $eb297b6792417b9c$export$1ed84f4bcea4be27;
var $eb297b6792417b9c$export$a7db06668cad9adb;
var $eb297b6792417b9c$export$6d59db4903f20f7d;
var $eb297b6792417b9c$export$a8ff84c12d48cfa6;
var $eb297b6792417b9c$export$bfd64c937657f93a;
var $eb297b6792417b9c$export$4a6dd88bada4e7d2;
$eb297b6792417b9c$export$f79a732982c93a3b = `BnCFfW_connector`;
$eb297b6792417b9c$export$1ed84f4bcea4be27 = `BnCFfW_connectorId`;
$eb297b6792417b9c$export$a7db06668cad9adb = `BnCFfW_content`;
$eb297b6792417b9c$export$6d59db4903f20f7d = `BnCFfW_description`;
$eb297b6792417b9c$export$a8ff84c12d48cfa6 = `BnCFfW_name`;
$eb297b6792417b9c$export$bfd64c937657f93a = `BnCFfW_rotating`;
$eb297b6792417b9c$export$4a6dd88bada4e7d2 = `BnCFfW_shimmer`;


function $d61c40e0a4da7eca$var$ConnectorRadio({ data: { name: name, logo: logo, logoDark: logoDark, description: description } }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $eb297b6792417b9c$export$f79a732982c93a3b,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                data: {
                    logo: logo,
                    logoDark: logoDark
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $eb297b6792417b9c$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($eb297b6792417b9c$export$a8ff84c12d48cfa6),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                            resource: name
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $eb297b6792417b9c$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                            resource: description
                        })
                    })
                ]
            })
        ]
    });
}
var $d61c40e0a4da7eca$export$2e2bcd8739ae039 = $d61c40e0a4da7eca$var$ConnectorRadio;


var $4327595e827210d4$exports = {};

$parcel$export($4327595e827210d4$exports, "connectorGroup", function () { return $4327595e827210d4$export$8a5ac33d5834e89d; }, function (v) { return $4327595e827210d4$export$8a5ac33d5834e89d = v; });
$parcel$export($4327595e827210d4$exports, "large", function () { return $4327595e827210d4$export$f09585a853dddd32; }, function (v) { return $4327595e827210d4$export$f09585a853dddd32 = v; });
$parcel$export($4327595e827210d4$exports, "medium", function () { return $4327595e827210d4$export$649ecc744817b5c7; }, function (v) { return $4327595e827210d4$export$649ecc744817b5c7 = v; });
$parcel$export($4327595e827210d4$exports, "rotating", function () { return $4327595e827210d4$export$bfd64c937657f93a; }, function (v) { return $4327595e827210d4$export$bfd64c937657f93a = v; });
$parcel$export($4327595e827210d4$exports, "shimmer", function () { return $4327595e827210d4$export$4a6dd88bada4e7d2; }, function (v) { return $4327595e827210d4$export$4a6dd88bada4e7d2 = v; });
var $4327595e827210d4$export$8a5ac33d5834e89d;
var $4327595e827210d4$export$f09585a853dddd32;
var $4327595e827210d4$export$649ecc744817b5c7;
var $4327595e827210d4$export$bfd64c937657f93a;
var $4327595e827210d4$export$4a6dd88bada4e7d2;
$4327595e827210d4$export$8a5ac33d5834e89d = `ZBQxdG_connectorGroup`;
$4327595e827210d4$export$f09585a853dddd32 = `ZBQxdG_large`;
$4327595e827210d4$export$649ecc744817b5c7 = `ZBQxdG_medium`;
$4327595e827210d4$export$bfd64c937657f93a = `ZBQxdG_rotating`;
$4327595e827210d4$export$4a6dd88bada4e7d2 = `ZBQxdG_shimmer`;


function $85ae747a418fe165$var$ConnectorRadioGroup({ name: name, groups: groups, value: value, size: size, onChange: onChange }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
        name: name,
        value: value,
        type: "card",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($4327595e827210d4$exports.connectorGroup, $4327595e827210d4$exports[size]),
        onChange: onChange,
        children: groups.map((data)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                value: data.id,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d61c40e0a4da7eca$export$2e2bcd8739ae039), {
                    data: data
                })
            }, data.id))
    });
}
var $85ae747a418fe165$export$2e2bcd8739ae039 = $85ae747a418fe165$var$ConnectorRadioGroup;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
var $ckJfF = parcelRequire("ckJfF");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");




var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");


function $8f52873f4dfb74cb$var$Footer({ isCreatingSocialConnector: isCreatingSocialConnector, existingConnectors: existingConnectors, selectedConnectorGroup: selectedConnectorGroup, isCreateButtonDisabled: isCreateButtonDisabled, onClickCreateButton: onClickCreateButton }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const standardConnectorCount = (0, $eCoWV.useMemo)(()=>existingConnectors.filter(({ isStandard: isStandard, isDemo: isDemo, type: type })=>isStandard && !isDemo && type === (0, $fU2Vo.ConnectorType).Social).length, [
        existingConnectors
    ]);
    const socialConnectorCount = (0, $eCoWV.useMemo)(()=>existingConnectors.filter(({ isStandard: isStandard, isDemo: isDemo, type: type })=>!isStandard && !isDemo && type === (0, $fU2Vo.ConnectorType).Social).length, [
        existingConnectors
    ]);
    const isStandardConnectorsReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "standardConnectorsLimit",
        plan: currentPlan,
        usage: standardConnectorCount
    });
    const isSocialConnectorsReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "socialConnectorsLimit",
        plan: currentPlan,
        usage: socialConnectorCount
    });
    if (isCreatingSocialConnector && currentPlan && selectedConnectorGroup) {
        const { id: planId, name: planName, quota: quota } = currentPlan;
        if (isStandardConnectorsReachLimit && selectedConnectorGroup.isStandard) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: quota.standardConnectorsLimit === 0 ? t("standard_connectors_feature") : t(planId === (0, $ckJfF.ReservedPlanId).Pro ? "standard_connectors_pro" : "standard_connectors", {
                    count: quota.standardConnectorsLimit ?? 0
                })
            })
        });
        if (isSocialConnectorsReachLimit && !selectedConnectorGroup.isStandard) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: planName
                    })
                },
                children: t("social_connectors", {
                    count: quota.socialConnectorsLimit ?? 0
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
        title: "general.next",
        type: "primary",
        disabled: isCreateButtonDisabled,
        onClick: onClickCreateButton
    });
}
var $8f52873f4dfb74cb$export$2e2bcd8739ae039 = $8f52873f4dfb74cb$var$Footer;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $kiVDZ = parcelRequire("kiVDZ");

var $4a5e9e9147ba3c19$export$caa92bdde36f2a2d;
var $4a5e9e9147ba3c19$export$bfd64c937657f93a;
var $4a5e9e9147ba3c19$export$4a6dd88bada4e7d2;
var $4a5e9e9147ba3c19$export$fb184b623420d9be;
$4a5e9e9147ba3c19$export$caa92bdde36f2a2d = `NQKgPa_platforms`;
$4a5e9e9147ba3c19$export$bfd64c937657f93a = `NQKgPa_rotating`;
$4a5e9e9147ba3c19$export$4a6dd88bada4e7d2 = `NQKgPa_shimmer`;
$4a5e9e9147ba3c19$export$fb184b623420d9be = `NQKgPa_title`;


function $ed3129e3df72cfa3$var$PlatformSelector({ connectorGroup: connectorGroup, connectorId: connectorId, onConnectorIdChange: onConnectorIdChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    if (connectorGroup.connectors.length <= 1) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $4a5e9e9147ba3c19$export$caa92bdde36f2a2d,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $4a5e9e9147ba3c19$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                        resource: connectorGroup.name
                    }),
                    t("connectors.add_multi_platform")
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                type: "plain",
                name: "connector",
                value: connectorId,
                onChange: onConnectorIdChange,
                children: connectorGroup.connectors.map(({ platform: platform, id: id, added: added })=>platform && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                        value: id,
                        title: (0, $kiVDZ.connectorPlatformLabel)[platform],
                        isDisabled: added
                    }, id))
            })
        ]
    });
}
var $ed3129e3df72cfa3$export$2e2bcd8739ae039 = $ed3129e3df72cfa3$var$PlatformSelector;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $9ecc922c8beeb480$export$f79a732982c93a3b;
var $9ecc922c8beeb480$export$6d59db4903f20f7d;
var $9ecc922c8beeb480$export$db3c28d99448dcff;
var $9ecc922c8beeb480$export$a8ff84c12d48cfa6;
var $9ecc922c8beeb480$export$bfd64c937657f93a;
var $9ecc922c8beeb480$export$4a6dd88bada4e7d2;
var $9ecc922c8beeb480$export$ced924466afdd597;
$9ecc922c8beeb480$export$f79a732982c93a3b = `ZBI9IG_connector`;
$9ecc922c8beeb480$export$6d59db4903f20f7d = `ZBI9IG_description`;
$9ecc922c8beeb480$export$db3c28d99448dcff = `ZBI9IG_logo`;
$9ecc922c8beeb480$export$a8ff84c12d48cfa6 = `ZBI9IG_name`;
$9ecc922c8beeb480$export$bfd64c937657f93a = `ZBI9IG_rotating`;
$9ecc922c8beeb480$export$4a6dd88bada4e7d2 = `ZBI9IG_shimmer`;
$9ecc922c8beeb480$export$4a6dd88bada4e7d2;
$9ecc922c8beeb480$export$ced924466afdd597 = `ZBI9IG_shortDescription`;


function $ebb8af931eb3b482$var$Skeleton({ numberOfLoadingConnectors: numberOfLoadingConnectors = 8 }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $4327595e827210d4$export$8a5ac33d5834e89d,
        children: Array.from({
            length: numberOfLoadingConnectors
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($eb297b6792417b9c$export$f79a732982c93a3b, $9ecc922c8beeb480$export$f79a732982c93a3b),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $9ecc922c8beeb480$export$db3c28d99448dcff
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $eb297b6792417b9c$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $9ecc922c8beeb480$export$a8ff84c12d48cfa6
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $9ecc922c8beeb480$export$6d59db4903f20f7d
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($9ecc922c8beeb480$export$6d59db4903f20f7d, $9ecc922c8beeb480$export$ced924466afdd597)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, index))
    });
}
var $ebb8af931eb3b482$export$2e2bcd8739ae039 = $ebb8af931eb3b482$var$Skeleton;


var $b1c31c00c7c2cd61$export$bfd64c937657f93a;
var $b1c31c00c7c2cd61$export$4a6dd88bada4e7d2;
var $b1c31c00c7c2cd61$export$51242721bb71b0ff;
$b1c31c00c7c2cd61$export$bfd64c937657f93a = `_21Rf0a_rotating`;
$b1c31c00c7c2cd61$export$4a6dd88bada4e7d2 = `_21Rf0a_shimmer`;
$b1c31c00c7c2cd61$export$51242721bb71b0ff = `_21Rf0a_standardLabel`;


parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
const $423eb1a806d38a65$export$624a8265433e880 = [
    // Social
    "google",
    "apple",
    "facebook",
    "github",
    "discord",
    "wechat",
    "alipay",
    "kakao",
    "naver",
    "azuread",
    // Email
    "logto-email",
    "aws-ses",
    "sendgrid-mail",
    "aliyun-dm",
    // SMS
    "twilio-sms",
    "aliyun-sms",
    "tencent-sms"
];


const $0bb9b31ce73ff929$var$getConnectorOrder = (target, isStandard)=>{
    const order = (0, $423eb1a806d38a65$export$624a8265433e880).indexOf(target);
    if (order === -1) // Standard connectors come last.
    return isStandard ? (0, $423eb1a806d38a65$export$624a8265433e880).length + 1 : (0, $423eb1a806d38a65$export$624a8265433e880).length;
    return order;
};
const $0bb9b31ce73ff929$export$1f031023d9a4beb9 = (connectorA, connectorB)=>{
    const orderA = $0bb9b31ce73ff929$var$getConnectorOrder(connectorA.target, connectorA.isStandard);
    const orderB = $0bb9b31ce73ff929$var$getConnectorOrder(connectorB.target, connectorB.isStandard);
    return orderA - orderB;
};
const $0bb9b31ce73ff929$export$2ace16fb29e63d87 = (connectorCount, connectorType)=>{
    /**
   * Note:
   * Fix the size to large, since now we have little passwordless connectors.
   */ if (connectorType !== (0, $fU2Vo.ConnectorType).Social) return "large";
    if (connectorCount <= 2) return "medium";
    if (connectorCount === 3) return "large";
    return "xlarge";
};
const $0bb9b31ce73ff929$export$56d81f3a0a66aebd = (connectorType)=>{
    if (connectorType === (0, $fU2Vo.ConnectorType).Email) return "connectors.setup_title.email";
    if (connectorType === (0, $fU2Vo.ConnectorType).Sms) return "connectors.setup_title.sms";
    return "connectors.setup_title.social";
};


function $5942e5adf122c259$var$CreateConnectorForm({ onClose: onClose, isOpen: isFormOpen, type: type }) {
    const { data: existingConnectors, error: connectorsError } = (0, $2mi28.default)("api/connectors");
    const { data: factories, error: factoriesError } = (0, $2mi28.default)("api/connector-factories");
    const isLoading = !factories && !existingConnectors && !connectorsError && !factoriesError;
    const [activeGroupId, setActiveGroupId] = (0, $eCoWV.useState)();
    const [activeFactoryId, setActiveFactoryId] = (0, $eCoWV.useState)();
    const isCreatingSocialConnector = type === (0, $fU2Vo.ConnectorType).Social;
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isStandardConnectorDisabled = !currentPlan?.quota.standardConnectorsLimit;
    const groups = (0, $eCoWV.useMemo)(()=>{
        if (!factories || !existingConnectors) return [];
        const allGroups = (0, $dc36c1ed9a2dd820$export$48daf4eb8bb4366e)(factories.filter(({ type: factoryType, isDemo: isDemo })=>factoryType === type && !isDemo)// Hide the entrance of adding SAML social connectors, users should go to Enterprise SSO if they want to use SAML.
        // Should not remove the SAML factory from GET /connector-factories API, since that could break the existing SAML connectors.
        .filter(({ id: id })=>id !== "saml"));
        return allGroups.map((group)=>({
                ...group,
                connectors: group.connectors.map((connector)=>({
                        ...connector,
                        added: !group.isStandard && existingConnectors.some(({ connectorId: connectorId })=>connector.id === connectorId)
                    }))
            })).filter(({ connectors: connectors })=>!connectors.every(({ added: added })=>added)).slice().sort((0, $0bb9b31ce73ff929$export$1f031023d9a4beb9));
    }, [
        factories,
        type,
        existingConnectors
    ]);
    const activeGroup = (0, $eCoWV.useMemo)(()=>groups.find(({ id: id })=>id === activeGroupId), [
        activeGroupId,
        groups
    ]);
    const cardTitle = (0, $eCoWV.useMemo)(()=>(0, $0bb9b31ce73ff929$export$56d81f3a0a66aebd)(type), [
        type
    ]);
    const radioGroupSize = (0, $eCoWV.useMemo)(()=>(0, $0bb9b31ce73ff929$export$2ace16fb29e63d87)(groups.length, type), [
        groups.length,
        type
    ]);
    const handleGroupChange = (groupId)=>{
        setActiveGroupId(groupId);
        const group = groups.find(({ id: id })=>id === groupId);
        if (!group) return;
        const firstAvailableConnector = group.connectors.find(({ added: added })=>!added);
        setActiveFactoryId(firstAvailableConnector?.id);
    };
    const defaultGroups = (0, $eCoWV.useMemo)(()=>isCreatingSocialConnector ? groups.filter((group)=>!group.isStandard) : groups, [
        groups,
        isCreatingSocialConnector
    ]);
    const standardGroups = (0, $eCoWV.useMemo)(()=>groups.filter((group)=>group.isStandard), [
        groups
    ]);
    if (!isFormOpen) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isFormOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose?.();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: cardTitle,
            footer: existingConnectors && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8f52873f4dfb74cb$export$2e2bcd8739ae039), {
                isCreatingSocialConnector: isCreatingSocialConnector,
                existingConnectors: existingConnectors,
                selectedConnectorGroup: activeGroup,
                isCreateButtonDisabled: !activeFactoryId,
                onClickCreateButton: ()=>{
                    onClose?.(activeFactoryId);
                }
            }),
            size: radioGroupSize,
            onClose: onClose,
            children: [
                isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ebb8af931eb3b482$export$2e2bcd8739ae039), {}),
                factoriesError?.message ?? connectorsError?.message,
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $85ae747a418fe165$export$2e2bcd8739ae039), {
                    name: "group",
                    groups: defaultGroups,
                    value: activeGroupId,
                    size: radioGroupSize,
                    onChange: handleGroupChange
                }),
                activeGroup && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ed3129e3df72cfa3$export$2e2bcd8739ae039), {
                    connectorGroup: activeGroup,
                    connectorId: activeFactoryId,
                    onConnectorIdChange: setActiveFactoryId
                }),
                standardGroups.length > 0 && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $b1c31c00c7c2cd61$export$51242721bb71b0ff,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "connectors.standard_connectors"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                                    isVisible: isStandardConnectorDisabled,
                                    for: "upsell",
                                    plan: (0, $ckJfF.ReservedPlanId).Hobby
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $85ae747a418fe165$export$2e2bcd8739ae039), {
                            name: "group",
                            groups: standardGroups,
                            value: activeGroupId,
                            size: radioGroupSize,
                            onChange: handleGroupChange
                        })
                    ]
                })
            ]
        })
    });
}
var $5942e5adf122c259$export$2e2bcd8739ae039 = $5942e5adf122c259$var$CreateConnectorForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


var $kMAP9 = parcelRequire("kMAP9");
function $396803ba381ea6b5$var$DeleteConnectorConfirmModal({ data: data, isOpen: isOpen, isInUse: isInUse, isLoading: isLoading, onCancel: onCancel, onConfirm: onConfirm }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isSocial = data.type === (0, $fU2Vo.ConnectorType).Social;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $kMAP9.default), {
        isOpen: isOpen,
        confirmButtonText: "general.delete",
        isLoading: isLoading,
        onCancel: onCancel,
        onConfirm: onConfirm,
        children: [
            !isInUse && t("connector_details.deletion_description"),
            isInUse && isSocial && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                t: t,
                i18nKey: "connector_details.in_used_social_deletion_description",
                components: {
                    name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                        resource: data.name
                    })
                }
            }),
            isInUse && !isSocial && t("connector_details.in_used_passwordless_deletion_description", {
                name: t(data.type === (0, $fU2Vo.ConnectorType).Email ? "connector_details.type_email" : "connector_details.type_sms")
            })
        ]
    });
}
var $396803ba381ea6b5$export$2e2bcd8739ae039 = $396803ba381ea6b5$var$DeleteConnectorConfirmModal;






var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
// Register `Raw` in tree:
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 * @typedef {import('hast').Root} Root
 * @typedef {import('hast-util-to-jsx-runtime').Components} JsxRuntimeComponents
 * @typedef {import('remark-rehype').Options} RemarkRehypeOptions
 * @typedef {import('unist-util-visit').BuildVisitor<Root>} Visitor
 * @typedef {import('unified').PluggableList} PluggableList
 */ /**
 * @callback AllowElement
 *   Filter elements.
 * @param {Readonly<Element>} element
 *   Element to check.
 * @param {number} index
 *   Index of `element` in `parent`.
 * @param {Readonly<Parents> | undefined} parent
 *   Parent of `element`.
 * @returns {boolean | null | undefined}
 *   Whether to allow `element` (default: `false`).
 *
 * @typedef {Partial<JsxRuntimeComponents>} Components
 *   Map tag names to components.
 *
 * @typedef Deprecation
 *   Deprecation.
 * @property {string} from
 *   Old field.
 * @property {string} id
 *   ID in readme.
 * @property {keyof Options} [to]
 *   New field.
 *
 * @typedef Options
 *   Configuration.
 * @property {AllowElement | null | undefined} [allowElement]
 *   Filter elements (optional);
 *   `allowedElements` / `disallowedElements` is used first.
 * @property {ReadonlyArray<string> | null | undefined} [allowedElements]
 *   Tag names to allow (default: all tag names);
 *   cannot combine w/ `disallowedElements`.
 * @property {string | null | undefined} [children]
 *   Markdown.
 * @property {string | null | undefined} [className]
 *   Wrap in a `div` with this class name.
 * @property {Components | null | undefined} [components]
 *   Map tag names to components.
 * @property {ReadonlyArray<string> | null | undefined} [disallowedElements]
 *   Tag names to disallow (default: `[]`);
 *   cannot combine w/ `allowedElements`.
 * @property {PluggableList | null | undefined} [rehypePlugins]
 *   List of rehype plugins to use.
 * @property {PluggableList | null | undefined} [remarkPlugins]
 *   List of remark plugins to use.
 * @property {Readonly<RemarkRehypeOptions> | null | undefined} [remarkRehypeOptions]
 *   Options to pass through to `remark-rehype`.
 * @property {boolean | null | undefined} [skipHtml=false]
 *   Ignore HTML in markdown completely (default: `false`).
 * @property {boolean | null | undefined} [unwrapDisallowed=false]
 *   Extract (unwrap) what’s in disallowed elements (default: `false`);
 *   normally when say `strong` is not allowed, it and it’s children are dropped,
 *   with `unwrapDisallowed` the element itself is replaced by its children.
 * @property {UrlTransform | null | undefined} [urlTransform]
 *   Change URLs (default: `defaultUrlTransform`)
 *
 * @callback UrlTransform
 *   Transform all URLs.
 * @param {string} url
 *   URL.
 * @param {string} key
 *   Property name (example: `'href'`).
 * @param {Readonly<Element>} node
 *   Node.
 * @returns {string | null | undefined}
 *   Transformed URL (optional).
 */ function $5d95e0aa9a039766$export$b680e6b2c82f8c2f(fn) {
    return fn;
}
function $5d95e0aa9a039766$export$411ce8e5a71e3069() {}
function $5d95e0aa9a039766$export$dcb8b3f0e2de7e49() {}
function $5d95e0aa9a039766$export$565e9d9bd6b6e0d4() {}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Nodes} Nodes
 * @typedef {import('hast').Parents} Parents
 *
 * @typedef {import('property-information').Schema} Schema
 *
 * @typedef {import('./components.js').Components} Components
 */ /**
 * @typedef {JSX.Element | string | null | undefined} Child
 *   Child.
 *
 * @callback Create
 *   Create something in development or production.
 * @param {Nodes} node
 *   hast node.
 * @param {unknown} type
 *   Fragment symbol or tag name.
 * @param {Props} props
 *   Properties and children.
 * @param {string | undefined} key
 *   Key.
 * @returns {JSX.Element}
 *   Result.
 *
 * @typedef {'html' | 'react'} ElementAttributeNameCase
 *   Casing to use for attribute names.
 *
 *   HTML casing is for example `class`, `stroke-linecap`, `xml:lang`.
 *   React casing is for example `className`, `strokeLinecap`, `xmlLang`.
 *
 * @typedef {[string, Value]} Field
 *   Property field.
 *
 * @typedef {unknown} Fragment
 *   Represent the children, typically a symbol.
 *
 * @callback Jsx
 *   Create a production element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} [key]
 *   Dynamicly generated key to use.
 * @returns {JSX.Element}
 *   An element from your framework.
 *
 * @callback JsxDev
 *   Create a development element.
 * @param {unknown} type
 *   Element type: `Fragment` symbol, tag name (`string`), component.
 * @param {Props} props
 *   Element props, `children`, and maybe `node`.
 * @param {string | undefined} key
 *   Dynamicly generated key to use.
 * @param {boolean} isStaticChildren
 *   Whether two or more children are passed (in an array), which is whether
 *   `jsxs` or `jsx` would be used.
 * @param {Source} source
 *   Info about source.
 * @param {undefined} self
 *   Nothing (this is used by frameworks that have components, we don’t).
 * @returns {JSX.Element}
 *   An element from your framework.
 *
 * @typedef {{children?: Array<Child> | Child, node?: Element | undefined, [prop: string]: Array<Child> | Child | Element | Value | undefined}} Props
 *   Properties and children.
 *
 * @typedef RegularFields
 *   Configuration.
 * @property {Partial<Components> | null | undefined} [components]
 *   Components to use (optional).
 * @property {ElementAttributeNameCase | null | undefined} [elementAttributeNameCase='react']
 *   Specify casing to use for attribute names (default: `'react'`).
 * @property {string | null | undefined} [filePath]
 *   File path to the original source file (optional).
 *
 *   Passed in source info to `jsxDEV` when using the automatic runtime with
 *   `development: true`.
 * @property {boolean | null | undefined} [ignoreInvalidStyle=false]
 *   Ignore invalid CSS in `style` props (default: `false`);
 *   the default behavior is to throw an error.
 * @property {boolean | null | undefined} [passKeys=true]
 *   Generate keys to optimize frameworks that support them (default: `true`).
 *
 *   > 👉 **Note**: Solid currently fails if keys are passed.
 * @property {boolean | null | undefined} [passNode=false]
 *   Pass the hast element node to components (default: `false`).
 * @property {Space | null | undefined} [space='html']
 *   Whether `tree` is in the `'html'` or `'svg'` space (default: `'html'`).
 *
 *   When an `<svg>` element is found in the HTML space, this package already
 *   automatically switches to and from the SVG space when entering and exiting
 *   it.
 * @property {StylePropertyNameCase | null | undefined} [stylePropertyNameCase='dom']
 *   Specify casing to use for property names in `style` objects (default:
 *   `'dom'`).
 * @property {boolean | null | undefined} [tableCellAlignToStyle=true]
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props
 *   (default: `true`).
 *
 * @typedef RuntimeDevelopment
 *   Runtime fields when development is on.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {true} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev} jsxDEV
 *   Development JSX.
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef RuntimeProduction
 *   Runtime fields when development is off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {false | null | undefined} [development]
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off) (optional).
 * @property {Jsx} jsx
 *   Dynamic JSX.
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx} jsxs
 *   Static JSX.
 *
 * @typedef RuntimeUnknown
 *   Runtime fields when development might be on or off.
 * @property {Fragment} Fragment
 *   Fragment.
 * @property {boolean} development
 *   Whether to use `jsxDEV` (when on) or `jsx` and `jsxs` (when off).
 * @property {Jsx | null | undefined} [jsx]
 *   Dynamic JSX (optional).
 * @property {JsxDev | null | undefined} [jsxDEV]
 *   Development JSX (optional).
 * @property {Jsx | null | undefined} [jsxs]
 *   Static JSX (optional).
 *
 * @typedef Source
 *   Info about source.
 * @property {number | undefined} columnNumber
 *   Column where thing starts (0-indexed).
 * @property {string | undefined} fileName
 *   Name of source file.
 * @property {number | undefined} lineNumber
 *   Line where thing starts (1-indexed).
 *
 * @typedef {'html' | 'svg'} Space
 *   Namespace.
 *
 *   > 👉 **Note**: hast is not XML.
 *   > It supports SVG as embedded in HTML.
 *   > It does not support the features available in XML.
 *   > Passing SVG might break but fragments of modern SVG should be fine.
 *   > Use `xast` if you need to support SVG as XML.
 *
 * @typedef State
 *   Info passed around.
 * @property {unknown} Fragment
 *   Fragment symbol.
 * @property {Array<Parents>} ancestors
 *   Stack of parents.
 * @property {Partial<Components>} components
 *   Components to swap.
 * @property {Create} create
 *   Create something in development or production.
 * @property {ElementAttributeNameCase} elementAttributeNameCase
 *   Casing to use for attribute names.
 * @property {string | undefined} filePath
 *   File path.
 * @property {boolean} ignoreInvalidStyle
 *   Ignore invalid CSS in `style` props.
 * @property {boolean} passKeys
 *   Generate keys to optimize frameworks that support them.
 * @property {boolean} passNode
 *   Pass `node` to components.
 * @property {Schema} schema
 *   Current schema.
 * @property {StylePropertyNameCase} stylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 * @property {boolean} tableCellAlignToStyle
 *   Turn obsolete `align` props on `td` and `th` into CSS `style` props.
 *
 * @typedef {Record<string, string>} Style
 *   Style map.
 *
 * @typedef {'css' | 'dom'} StylePropertyNameCase
 *   Casing to use for property names in `style` objects.
 *
 *   CSS casing is for example `background-color` and `-webkit-line-clamp`.
 *   DOM casing is for example `backgroundColor` and `WebkitLineClamp`.
 *
 * @typedef {Style | boolean | number | string} Value
 *   Primitive property value and `Style` map.
 */ /**
 * @typedef {RuntimeDevelopment & RegularFields} Development
 *   Configuration (development).
 * @typedef {Development | Production | Unknown} Options
 *   Configuration.
 * @typedef {RegularFields & RuntimeProduction} Production
 *   Configuration (production).
 * @typedef {RegularFields & RuntimeUnknown} Unknown
 *   Configuration (production or development).
 */ /**
 * @typedef {Object} StringifyOptions
 * @property {boolean} [padLeft=true] Whether to pad a space before a token (`boolean`, default: `true`).
 * @property {boolean} [padRight=false] Whether to pad a space after a token (`boolean`, default: `false`).
 */ /**
 * Parse comma separated tokens to an array.
 *
 * @param {string} value
 * @returns {Array.<string>}
 */ function $f7ed1f99e7dfe605$export$98e6a39c04603d36(value) {
    /** @type {Array.<string>} */ var tokens = [];
    var input = String(value || "");
    var index = input.indexOf(",");
    var start = 0;
    /** @type {boolean} */ var end;
    /** @type {string} */ var token;
    while(!end){
        if (index === -1) {
            index = input.length;
            end = true;
        }
        token = input.slice(start, index).trim();
        if (token || !end) tokens.push(token);
        start = index + 1;
        index = input.indexOf(",", start);
    }
    return tokens;
}
function $f7ed1f99e7dfe605$export$fac44ee5b035f737(values, options) {
    var settings = options || {};
    // Ensure the last empty entry is seen.
    if (values[values.length - 1] === "") values = values.concat("");
    return values.join((settings.padRight ? " " : "") + "," + (settings.padLeft === false ? "" : " ")).trim();
}


/**
 * @typedef {import('hast').Nodes} Nodes
 */ // HTML whitespace expression.
// See <https://infra.spec.whatwg.org/#ascii-whitespace>.
const $4e8525678352af73$var$re = /[ \t\n\f\r]/g;
function $4e8525678352af73$export$7af1228ff777d175(thing) {
    return typeof thing === "object" ? thing.type === "text" ? $4e8525678352af73$var$empty(thing.value) : false : $4e8525678352af73$var$empty(thing);
}
/**
 * @param {string} value
 * @returns {boolean}
 */ function $4e8525678352af73$var$empty(value) {
    return value.replace($4e8525678352af73$var$re, "") === "";
}


/**
 * @typedef {import('./util/schema.js').Schema} Schema
 */ /**
 * @param {string} value
 * @returns {string}
 */ function $22e0d5d18462a4fa$export$a3295358bff77e(value) {
    return value.toLowerCase();
}


class $39a81709980d6d1c$export$c4868e4a24d48fad {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */ constructor(property, attribute){
        /** @type {string} */ this.property = property;
        /** @type {string} */ this.attribute = attribute;
    }
}
/** @type {string|null} */ $39a81709980d6d1c$export$c4868e4a24d48fad.prototype.space = null;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.boolean = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.booleanish = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.overloadedBoolean = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.number = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.commaSeparated = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.spaceSeparated = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.commaOrSpaceSeparated = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.mustUseProperty = false;
$39a81709980d6d1c$export$c4868e4a24d48fad.prototype.defined = false;


var $1cd8c5931fc08f77$exports = {};

$parcel$export($1cd8c5931fc08f77$exports, "boolean", function () { return $1cd8c5931fc08f77$export$4a21f16c33752377; });
$parcel$export($1cd8c5931fc08f77$exports, "booleanish", function () { return $1cd8c5931fc08f77$export$55e9e1fbc638dc8f; });
$parcel$export($1cd8c5931fc08f77$exports, "overloadedBoolean", function () { return $1cd8c5931fc08f77$export$242ac3d3042558aa; });
$parcel$export($1cd8c5931fc08f77$exports, "number", function () { return $1cd8c5931fc08f77$export$98e628dec113755e; });
$parcel$export($1cd8c5931fc08f77$exports, "spaceSeparated", function () { return $1cd8c5931fc08f77$export$ab8645c862eb5a3e; });
$parcel$export($1cd8c5931fc08f77$exports, "commaSeparated", function () { return $1cd8c5931fc08f77$export$9c8d678629b3d3; });
$parcel$export($1cd8c5931fc08f77$exports, "commaOrSpaceSeparated", function () { return $1cd8c5931fc08f77$export$2ad25cfebf36cacd; });
let $1cd8c5931fc08f77$var$powers = 0;
const $1cd8c5931fc08f77$export$4a21f16c33752377 = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$55e9e1fbc638dc8f = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$242ac3d3042558aa = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$98e628dec113755e = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$ab8645c862eb5a3e = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$9c8d678629b3d3 = $1cd8c5931fc08f77$var$increment();
const $1cd8c5931fc08f77$export$2ad25cfebf36cacd = $1cd8c5931fc08f77$var$increment();
function $1cd8c5931fc08f77$var$increment() {
    return 2 ** ++$1cd8c5931fc08f77$var$powers;
}


/** @type {Array<keyof types>} */ // @ts-expect-error: hush.
const $22a0b999dbf6481b$var$checks = Object.keys($1cd8c5931fc08f77$exports);
class $22a0b999dbf6481b$export$ea6b9f0064e88c9b extends (0, $39a81709980d6d1c$export$c4868e4a24d48fad) {
    /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */ constructor(property, attribute, mask, space){
        let index = -1;
        super(property, attribute);
        $22a0b999dbf6481b$var$mark(this, "space", space);
        if (typeof mask === "number") while(++index < $22a0b999dbf6481b$var$checks.length){
            const check = $22a0b999dbf6481b$var$checks[index];
            $22a0b999dbf6481b$var$mark(this, $22a0b999dbf6481b$var$checks[index], (mask & $1cd8c5931fc08f77$exports[check]) === $1cd8c5931fc08f77$exports[check]);
        }
    }
}
$22a0b999dbf6481b$export$ea6b9f0064e88c9b.prototype.defined = true;
/**
 * @param {DefinedInfo} values
 * @param {string} key
 * @param {unknown} value
 */ function $22a0b999dbf6481b$var$mark(values, key, value) {
    if (value) // @ts-expect-error: assume `value` matches the expected value of `key`.
    values[key] = value;
}



const $262b1e8417e96ac0$var$valid = /^data[-\w.:]+$/i;
const $262b1e8417e96ac0$var$dash = /-[a-z]/g;
const $262b1e8417e96ac0$var$cap = /[A-Z]/g;
function $262b1e8417e96ac0$export$71aa6c912b956294(schema, value) {
    const normal = (0, $22e0d5d18462a4fa$export$a3295358bff77e)(value);
    let prop = value;
    let Type = (0, $39a81709980d6d1c$export$c4868e4a24d48fad);
    if (normal in schema.normal) return schema.property[schema.normal[normal]];
    if (normal.length > 4 && normal.slice(0, 4) === "data" && $262b1e8417e96ac0$var$valid.test(value)) {
        // Attribute or property.
        if (value.charAt(4) === "-") {
            // Turn it into a property.
            const rest = value.slice(5).replace($262b1e8417e96ac0$var$dash, $262b1e8417e96ac0$var$camelcase);
            prop = "data" + rest.charAt(0).toUpperCase() + rest.slice(1);
        } else {
            // Turn it into an attribute.
            const rest = value.slice(4);
            if (!$262b1e8417e96ac0$var$dash.test(rest)) {
                let dashes = rest.replace($262b1e8417e96ac0$var$cap, $262b1e8417e96ac0$var$kebab);
                if (dashes.charAt(0) !== "-") dashes = "-" + dashes;
                value = "data" + dashes;
            }
        }
        Type = (0, $22a0b999dbf6481b$export$ea6b9f0064e88c9b);
    }
    return new Type(prop, value);
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $262b1e8417e96ac0$var$kebab($0) {
    return "-" + $0.toLowerCase();
}
/**
 * @param {string} $0
 * @returns {string}
 */ function $262b1e8417e96ac0$var$camelcase($0) {
    return $0.charAt(1).toUpperCase();
}

/**
 * `hast` is close to `React`, but differs in a couple of cases.
 *
 * To get a React property from a hast property, check if it is in
 * `hastToReact`, if it is, then use the corresponding value,
 * otherwise, use the hast property.
 *
 * @type {Record<string, string>}
 */ const $ac9dfc82e96f8ce5$export$d8abd7e5fb6871f9 = {
    classId: "classID",
    dataType: "datatype",
    itemId: "itemID",
    strokeDashArray: "strokeDasharray",
    strokeDashOffset: "strokeDashoffset",
    strokeLineCap: "strokeLinecap",
    strokeLineJoin: "strokeLinejoin",
    strokeMiterLimit: "strokeMiterlimit",
    typeOf: "typeof",
    xLinkActuate: "xlinkActuate",
    xLinkArcRole: "xlinkArcrole",
    xLinkHref: "xlinkHref",
    xLinkRole: "xlinkRole",
    xLinkShow: "xlinkShow",
    xLinkTitle: "xlinkTitle",
    xLinkType: "xlinkType",
    xmlnsXLink: "xmlnsXlink"
};

/**
 * @typedef {import('./lib/util/info.js').Info} Info
 * @typedef {import('./lib/util/schema.js').Schema} Schema
 */ /**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 */ /**
 * @typedef {import('./info.js').Info} Info
 * @typedef {Record<string, Info>} Properties
 * @typedef {Record<string, string>} Normal
 */ class $8864dfaf97140cc9$export$19342e026b58ebb7 {
    /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */ constructor(property, normal, space){
        this.property = property;
        this.normal = normal;
        if (space) this.space = space;
    }
}
/** @type {Properties} */ $8864dfaf97140cc9$export$19342e026b58ebb7.prototype.property = {};
/** @type {Normal} */ $8864dfaf97140cc9$export$19342e026b58ebb7.prototype.normal = {};
/** @type {string|null} */ $8864dfaf97140cc9$export$19342e026b58ebb7.prototype.space = null;


function $88748e0f0004348f$export$4950aa0f605343fb(definitions, space) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    let index = -1;
    while(++index < definitions.length){
        Object.assign(property, definitions[index].property);
        Object.assign(normal, definitions[index].normal);
    }
    return new (0, $8864dfaf97140cc9$export$19342e026b58ebb7)(property, normal, space);
}


/**
 * @typedef {import('./schema.js').Properties} Properties
 * @typedef {import('./schema.js').Normal} Normal
 *
 * @typedef {Record<string, string>} Attributes
 *
 * @typedef {Object} Definition
 * @property {Record<string, number|null>} properties
 * @property {(attributes: Attributes, property: string) => string} transform
 * @property {string} [space]
 * @property {Attributes} [attributes]
 * @property {Array<string>} [mustUseProperty]
 */ 


const $b786a00d4d2aa2cc$var$own = {}.hasOwnProperty;
function $b786a00d4d2aa2cc$export$185802fd694ee1f5(definition) {
    /** @type {Properties} */ const property = {};
    /** @type {Normal} */ const normal = {};
    /** @type {string} */ let prop;
    for(prop in definition.properties)if ($b786a00d4d2aa2cc$var$own.call(definition.properties, prop)) {
        const value = definition.properties[prop];
        const info = new (0, $22a0b999dbf6481b$export$ea6b9f0064e88c9b)(prop, definition.transform(definition.attributes || {}, prop), value, definition.space);
        if (definition.mustUseProperty && definition.mustUseProperty.includes(prop)) info.mustUseProperty = true;
        property[prop] = info;
        normal[(0, $22e0d5d18462a4fa$export$a3295358bff77e)(prop)] = prop;
        normal[(0, $22e0d5d18462a4fa$export$a3295358bff77e)(info.attribute)] = prop;
    }
    return new (0, $8864dfaf97140cc9$export$19342e026b58ebb7)(property, normal, definition.space);
}


const $f0763097e6b0d9dc$export$2bd1230ec7600845 = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    space: "xlink",
    transform (_, prop) {
        return "xlink:" + prop.slice(5).toLowerCase();
    },
    properties: {
        xLinkActuate: null,
        xLinkArcRole: null,
        xLinkHref: null,
        xLinkRole: null,
        xLinkShow: null,
        xLinkTitle: null,
        xLinkType: null
    }
});



const $ffe02515452e22ad$export$f2913fe8983302e = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    space: "xml",
    transform (_, prop) {
        return "xml:" + prop.slice(3).toLowerCase();
    },
    properties: {
        xmlLang: null,
        xmlBase: null,
        xmlSpace: null
    }
});



/**
 * @param {Record<string, string>} attributes
 * @param {string} attribute
 * @returns {string}
 */ function $1e7c10f061e715af$export$5b10b3bc32d7efbc(attributes, attribute) {
    return attribute in attributes ? attributes[attribute] : attribute;
}


function $e2f2d8b6037f0d1a$export$32b9e4cec9c208e1(attributes, property) {
    return (0, $1e7c10f061e715af$export$5b10b3bc32d7efbc)(attributes, property.toLowerCase());
}


const $a4eaed7275c800fe$export$e20c24a128671213 = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    space: "xmlns",
    attributes: {
        xmlnsxlink: "xmlns:xlink"
    },
    transform: (0, $e2f2d8b6037f0d1a$export$32b9e4cec9c208e1),
    properties: {
        xmlns: null,
        xmlnsXLink: null
    }
});




const $c3593fe6a0c959f9$export$4d2d26490572750a = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    transform (_, prop) {
        return prop === "role" ? prop : "aria-" + prop.slice(4).toLowerCase();
    },
    properties: {
        ariaActiveDescendant: null,
        ariaAtomic: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaAutoComplete: null,
        ariaBusy: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaChecked: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaColCount: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaColIndex: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaColSpan: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaControls: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaCurrent: null,
        ariaDescribedBy: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaDetails: null,
        ariaDisabled: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaDropEffect: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaErrorMessage: null,
        ariaExpanded: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaFlowTo: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaGrabbed: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaHasPopup: null,
        ariaHidden: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaInvalid: null,
        ariaKeyShortcuts: null,
        ariaLabel: null,
        ariaLabelledBy: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaLevel: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaLive: null,
        ariaModal: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaMultiLine: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaMultiSelectable: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaOrientation: null,
        ariaOwns: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaPlaceholder: null,
        ariaPosInSet: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaPressed: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaReadOnly: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaRelevant: null,
        ariaRequired: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaRoleDescription: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        ariaRowCount: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaRowIndex: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaRowSpan: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaSelected: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        ariaSetSize: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaSort: null,
        ariaValueMax: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaValueMin: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaValueNow: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        ariaValueText: null,
        role: null
    }
});





const $2812865310bd3cff$export$c0bb0b647f701bb5 = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    space: "html",
    attributes: {
        acceptcharset: "accept-charset",
        classname: "class",
        htmlfor: "for",
        httpequiv: "http-equiv"
    },
    transform: (0, $e2f2d8b6037f0d1a$export$32b9e4cec9c208e1),
    mustUseProperty: [
        "checked",
        "multiple",
        "muted",
        "selected"
    ],
    properties: {
        // Standard Properties.
        abbr: null,
        accept: (0, $1cd8c5931fc08f77$export$9c8d678629b3d3),
        acceptCharset: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        accessKey: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        action: null,
        allow: null,
        allowFullScreen: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        allowPaymentRequest: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        allowUserMedia: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        alt: null,
        as: null,
        async: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        autoCapitalize: null,
        autoComplete: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        autoFocus: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        autoPlay: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        capture: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        charSet: null,
        checked: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        cite: null,
        className: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        cols: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        colSpan: null,
        content: null,
        contentEditable: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        controls: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        controlsList: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        coords: (0, $1cd8c5931fc08f77$export$98e628dec113755e) | (0, $1cd8c5931fc08f77$export$9c8d678629b3d3),
        crossOrigin: null,
        data: null,
        dateTime: null,
        decoding: null,
        default: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        defer: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        dir: null,
        dirName: null,
        disabled: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        download: (0, $1cd8c5931fc08f77$export$242ac3d3042558aa),
        draggable: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        encType: null,
        enterKeyHint: null,
        form: null,
        formAction: null,
        formEncType: null,
        formMethod: null,
        formNoValidate: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        formTarget: null,
        headers: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        height: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        hidden: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        high: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        href: null,
        hrefLang: null,
        htmlFor: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        httpEquiv: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        id: null,
        imageSizes: null,
        imageSrcSet: null,
        inputMode: null,
        integrity: null,
        is: null,
        isMap: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        itemId: null,
        itemProp: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        itemRef: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        itemScope: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        itemType: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        kind: null,
        label: null,
        lang: null,
        language: null,
        list: null,
        loading: null,
        loop: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        low: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        manifest: null,
        max: null,
        maxLength: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        media: null,
        method: null,
        min: null,
        minLength: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        multiple: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        muted: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        name: null,
        nonce: null,
        noModule: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        noValidate: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        onAbort: null,
        onAfterPrint: null,
        onAuxClick: null,
        onBeforeMatch: null,
        onBeforePrint: null,
        onBeforeUnload: null,
        onBlur: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onContextLost: null,
        onContextMenu: null,
        onContextRestored: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFormData: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLanguageChange: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadEnd: null,
        onLoadStart: null,
        onMessage: null,
        onMessageError: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRejectionHandled: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onScrollEnd: null,
        onSecurityPolicyViolation: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onSlotChange: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnhandledRejection: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onWheel: null,
        open: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        optimum: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        pattern: null,
        ping: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        placeholder: null,
        playsInline: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        poster: null,
        preload: null,
        readOnly: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        referrerPolicy: null,
        rel: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        required: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        reversed: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        rows: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        rowSpan: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        sandbox: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        scope: null,
        scoped: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        seamless: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        selected: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        shape: null,
        size: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        sizes: null,
        slot: null,
        span: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        spellCheck: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        src: null,
        srcDoc: null,
        srcLang: null,
        srcSet: null,
        start: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        step: null,
        style: null,
        tabIndex: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        target: null,
        title: null,
        translate: null,
        type: null,
        typeMustMatch: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        useMap: null,
        value: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        width: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        wrap: null,
        // Legacy.
        // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
        align: null,
        aLink: null,
        archive: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        axis: null,
        background: null,
        bgColor: null,
        border: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        borderColor: null,
        bottomMargin: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        cellPadding: null,
        cellSpacing: null,
        char: null,
        charOff: null,
        classId: null,
        clear: null,
        code: null,
        codeBase: null,
        codeType: null,
        color: null,
        compact: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        declare: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        event: null,
        face: null,
        frame: null,
        frameBorder: null,
        hSpace: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        leftMargin: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        link: null,
        longDesc: null,
        lowSrc: null,
        marginHeight: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        marginWidth: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        noResize: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        noHref: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        noShade: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        noWrap: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        object: null,
        profile: null,
        prompt: null,
        rev: null,
        rightMargin: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        rules: null,
        scheme: null,
        scrolling: (0, $1cd8c5931fc08f77$export$55e9e1fbc638dc8f),
        standby: null,
        summary: null,
        text: null,
        topMargin: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        valueType: null,
        version: null,
        vAlign: null,
        vLink: null,
        vSpace: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        // Non-standard Properties.
        allowTransparency: null,
        autoCorrect: null,
        autoSave: null,
        disablePictureInPicture: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        disableRemotePlayback: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        prefix: null,
        property: null,
        results: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        security: null,
        unselectable: null
    }
});





const $16ff35f2443dceb0$export$7ed1367e7fa1ad68 = (0, $b786a00d4d2aa2cc$export$185802fd694ee1f5)({
    space: "svg",
    attributes: {
        accentHeight: "accent-height",
        alignmentBaseline: "alignment-baseline",
        arabicForm: "arabic-form",
        baselineShift: "baseline-shift",
        capHeight: "cap-height",
        className: "class",
        clipPath: "clip-path",
        clipRule: "clip-rule",
        colorInterpolation: "color-interpolation",
        colorInterpolationFilters: "color-interpolation-filters",
        colorProfile: "color-profile",
        colorRendering: "color-rendering",
        crossOrigin: "crossorigin",
        dataType: "datatype",
        dominantBaseline: "dominant-baseline",
        enableBackground: "enable-background",
        fillOpacity: "fill-opacity",
        fillRule: "fill-rule",
        floodColor: "flood-color",
        floodOpacity: "flood-opacity",
        fontFamily: "font-family",
        fontSize: "font-size",
        fontSizeAdjust: "font-size-adjust",
        fontStretch: "font-stretch",
        fontStyle: "font-style",
        fontVariant: "font-variant",
        fontWeight: "font-weight",
        glyphName: "glyph-name",
        glyphOrientationHorizontal: "glyph-orientation-horizontal",
        glyphOrientationVertical: "glyph-orientation-vertical",
        hrefLang: "hreflang",
        horizAdvX: "horiz-adv-x",
        horizOriginX: "horiz-origin-x",
        horizOriginY: "horiz-origin-y",
        imageRendering: "image-rendering",
        letterSpacing: "letter-spacing",
        lightingColor: "lighting-color",
        markerEnd: "marker-end",
        markerMid: "marker-mid",
        markerStart: "marker-start",
        navDown: "nav-down",
        navDownLeft: "nav-down-left",
        navDownRight: "nav-down-right",
        navLeft: "nav-left",
        navNext: "nav-next",
        navPrev: "nav-prev",
        navRight: "nav-right",
        navUp: "nav-up",
        navUpLeft: "nav-up-left",
        navUpRight: "nav-up-right",
        onAbort: "onabort",
        onActivate: "onactivate",
        onAfterPrint: "onafterprint",
        onBeforePrint: "onbeforeprint",
        onBegin: "onbegin",
        onCancel: "oncancel",
        onCanPlay: "oncanplay",
        onCanPlayThrough: "oncanplaythrough",
        onChange: "onchange",
        onClick: "onclick",
        onClose: "onclose",
        onCopy: "oncopy",
        onCueChange: "oncuechange",
        onCut: "oncut",
        onDblClick: "ondblclick",
        onDrag: "ondrag",
        onDragEnd: "ondragend",
        onDragEnter: "ondragenter",
        onDragExit: "ondragexit",
        onDragLeave: "ondragleave",
        onDragOver: "ondragover",
        onDragStart: "ondragstart",
        onDrop: "ondrop",
        onDurationChange: "ondurationchange",
        onEmptied: "onemptied",
        onEnd: "onend",
        onEnded: "onended",
        onError: "onerror",
        onFocus: "onfocus",
        onFocusIn: "onfocusin",
        onFocusOut: "onfocusout",
        onHashChange: "onhashchange",
        onInput: "oninput",
        onInvalid: "oninvalid",
        onKeyDown: "onkeydown",
        onKeyPress: "onkeypress",
        onKeyUp: "onkeyup",
        onLoad: "onload",
        onLoadedData: "onloadeddata",
        onLoadedMetadata: "onloadedmetadata",
        onLoadStart: "onloadstart",
        onMessage: "onmessage",
        onMouseDown: "onmousedown",
        onMouseEnter: "onmouseenter",
        onMouseLeave: "onmouseleave",
        onMouseMove: "onmousemove",
        onMouseOut: "onmouseout",
        onMouseOver: "onmouseover",
        onMouseUp: "onmouseup",
        onMouseWheel: "onmousewheel",
        onOffline: "onoffline",
        onOnline: "ononline",
        onPageHide: "onpagehide",
        onPageShow: "onpageshow",
        onPaste: "onpaste",
        onPause: "onpause",
        onPlay: "onplay",
        onPlaying: "onplaying",
        onPopState: "onpopstate",
        onProgress: "onprogress",
        onRateChange: "onratechange",
        onRepeat: "onrepeat",
        onReset: "onreset",
        onResize: "onresize",
        onScroll: "onscroll",
        onSeeked: "onseeked",
        onSeeking: "onseeking",
        onSelect: "onselect",
        onShow: "onshow",
        onStalled: "onstalled",
        onStorage: "onstorage",
        onSubmit: "onsubmit",
        onSuspend: "onsuspend",
        onTimeUpdate: "ontimeupdate",
        onToggle: "ontoggle",
        onUnload: "onunload",
        onVolumeChange: "onvolumechange",
        onWaiting: "onwaiting",
        onZoom: "onzoom",
        overlinePosition: "overline-position",
        overlineThickness: "overline-thickness",
        paintOrder: "paint-order",
        panose1: "panose-1",
        pointerEvents: "pointer-events",
        referrerPolicy: "referrerpolicy",
        renderingIntent: "rendering-intent",
        shapeRendering: "shape-rendering",
        stopColor: "stop-color",
        stopOpacity: "stop-opacity",
        strikethroughPosition: "strikethrough-position",
        strikethroughThickness: "strikethrough-thickness",
        strokeDashArray: "stroke-dasharray",
        strokeDashOffset: "stroke-dashoffset",
        strokeLineCap: "stroke-linecap",
        strokeLineJoin: "stroke-linejoin",
        strokeMiterLimit: "stroke-miterlimit",
        strokeOpacity: "stroke-opacity",
        strokeWidth: "stroke-width",
        tabIndex: "tabindex",
        textAnchor: "text-anchor",
        textDecoration: "text-decoration",
        textRendering: "text-rendering",
        typeOf: "typeof",
        underlinePosition: "underline-position",
        underlineThickness: "underline-thickness",
        unicodeBidi: "unicode-bidi",
        unicodeRange: "unicode-range",
        unitsPerEm: "units-per-em",
        vAlphabetic: "v-alphabetic",
        vHanging: "v-hanging",
        vIdeographic: "v-ideographic",
        vMathematical: "v-mathematical",
        vectorEffect: "vector-effect",
        vertAdvY: "vert-adv-y",
        vertOriginX: "vert-origin-x",
        vertOriginY: "vert-origin-y",
        wordSpacing: "word-spacing",
        writingMode: "writing-mode",
        xHeight: "x-height",
        // These were camelcased in Tiny. Now lowercased in SVG 2
        playbackOrder: "playbackorder",
        timelineBegin: "timelinebegin"
    },
    transform: (0, $1e7c10f061e715af$export$5b10b3bc32d7efbc),
    properties: {
        about: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        accentHeight: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        accumulate: null,
        additive: null,
        alignmentBaseline: null,
        alphabetic: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        amplitude: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        arabicForm: null,
        ascent: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        attributeName: null,
        attributeType: null,
        azimuth: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        bandwidth: null,
        baselineShift: null,
        baseFrequency: null,
        baseProfile: null,
        bbox: null,
        begin: null,
        bias: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        by: null,
        calcMode: null,
        capHeight: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        className: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        clip: null,
        clipPath: null,
        clipPathUnits: null,
        clipRule: null,
        color: null,
        colorInterpolation: null,
        colorInterpolationFilters: null,
        colorProfile: null,
        colorRendering: null,
        content: null,
        contentScriptType: null,
        contentStyleType: null,
        crossOrigin: null,
        cursor: null,
        cx: null,
        cy: null,
        d: null,
        dataType: null,
        defaultAction: null,
        descent: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        diffuseConstant: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        direction: null,
        display: null,
        dur: null,
        divisor: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        dominantBaseline: null,
        download: (0, $1cd8c5931fc08f77$export$4a21f16c33752377),
        dx: null,
        dy: null,
        edgeMode: null,
        editable: null,
        elevation: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        enableBackground: null,
        end: null,
        event: null,
        exponent: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        externalResourcesRequired: null,
        fill: null,
        fillOpacity: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        fillRule: null,
        filter: null,
        filterRes: null,
        filterUnits: null,
        floodColor: null,
        floodOpacity: null,
        focusable: null,
        focusHighlight: null,
        fontFamily: null,
        fontSize: null,
        fontSizeAdjust: null,
        fontStretch: null,
        fontStyle: null,
        fontVariant: null,
        fontWeight: null,
        format: null,
        fr: null,
        from: null,
        fx: null,
        fy: null,
        g1: (0, $1cd8c5931fc08f77$export$9c8d678629b3d3),
        g2: (0, $1cd8c5931fc08f77$export$9c8d678629b3d3),
        glyphName: (0, $1cd8c5931fc08f77$export$9c8d678629b3d3),
        glyphOrientationHorizontal: null,
        glyphOrientationVertical: null,
        glyphRef: null,
        gradientTransform: null,
        gradientUnits: null,
        handler: null,
        hanging: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        hatchContentUnits: null,
        hatchUnits: null,
        height: null,
        href: null,
        hrefLang: null,
        horizAdvX: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        horizOriginX: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        horizOriginY: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        id: null,
        ideographic: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        imageRendering: null,
        initialVisibility: null,
        in: null,
        in2: null,
        intercept: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        k: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        k1: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        k2: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        k3: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        k4: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        kernelMatrix: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        kernelUnitLength: null,
        keyPoints: null,
        keySplines: null,
        keyTimes: null,
        kerning: null,
        lang: null,
        lengthAdjust: null,
        letterSpacing: null,
        lightingColor: null,
        limitingConeAngle: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        local: null,
        markerEnd: null,
        markerMid: null,
        markerStart: null,
        markerHeight: null,
        markerUnits: null,
        markerWidth: null,
        mask: null,
        maskContentUnits: null,
        maskUnits: null,
        mathematical: null,
        max: null,
        media: null,
        mediaCharacterEncoding: null,
        mediaContentEncodings: null,
        mediaSize: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        mediaTime: null,
        method: null,
        min: null,
        mode: null,
        name: null,
        navDown: null,
        navDownLeft: null,
        navDownRight: null,
        navLeft: null,
        navNext: null,
        navPrev: null,
        navRight: null,
        navUp: null,
        navUpLeft: null,
        navUpRight: null,
        numOctaves: null,
        observer: null,
        offset: null,
        onAbort: null,
        onActivate: null,
        onAfterPrint: null,
        onBeforePrint: null,
        onBegin: null,
        onCancel: null,
        onCanPlay: null,
        onCanPlayThrough: null,
        onChange: null,
        onClick: null,
        onClose: null,
        onCopy: null,
        onCueChange: null,
        onCut: null,
        onDblClick: null,
        onDrag: null,
        onDragEnd: null,
        onDragEnter: null,
        onDragExit: null,
        onDragLeave: null,
        onDragOver: null,
        onDragStart: null,
        onDrop: null,
        onDurationChange: null,
        onEmptied: null,
        onEnd: null,
        onEnded: null,
        onError: null,
        onFocus: null,
        onFocusIn: null,
        onFocusOut: null,
        onHashChange: null,
        onInput: null,
        onInvalid: null,
        onKeyDown: null,
        onKeyPress: null,
        onKeyUp: null,
        onLoad: null,
        onLoadedData: null,
        onLoadedMetadata: null,
        onLoadStart: null,
        onMessage: null,
        onMouseDown: null,
        onMouseEnter: null,
        onMouseLeave: null,
        onMouseMove: null,
        onMouseOut: null,
        onMouseOver: null,
        onMouseUp: null,
        onMouseWheel: null,
        onOffline: null,
        onOnline: null,
        onPageHide: null,
        onPageShow: null,
        onPaste: null,
        onPause: null,
        onPlay: null,
        onPlaying: null,
        onPopState: null,
        onProgress: null,
        onRateChange: null,
        onRepeat: null,
        onReset: null,
        onResize: null,
        onScroll: null,
        onSeeked: null,
        onSeeking: null,
        onSelect: null,
        onShow: null,
        onStalled: null,
        onStorage: null,
        onSubmit: null,
        onSuspend: null,
        onTimeUpdate: null,
        onToggle: null,
        onUnload: null,
        onVolumeChange: null,
        onWaiting: null,
        onZoom: null,
        opacity: null,
        operator: null,
        order: null,
        orient: null,
        orientation: null,
        origin: null,
        overflow: null,
        overlay: null,
        overlinePosition: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        overlineThickness: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        paintOrder: null,
        panose1: null,
        path: null,
        pathLength: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        patternContentUnits: null,
        patternTransform: null,
        patternUnits: null,
        phase: null,
        ping: (0, $1cd8c5931fc08f77$export$ab8645c862eb5a3e),
        pitch: null,
        playbackOrder: null,
        pointerEvents: null,
        points: null,
        pointsAtX: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        pointsAtY: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        pointsAtZ: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        preserveAlpha: null,
        preserveAspectRatio: null,
        primitiveUnits: null,
        propagate: null,
        property: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        r: null,
        radius: null,
        referrerPolicy: null,
        refX: null,
        refY: null,
        rel: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        rev: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        renderingIntent: null,
        repeatCount: null,
        repeatDur: null,
        requiredExtensions: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        requiredFeatures: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        requiredFonts: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        requiredFormats: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        resource: null,
        restart: null,
        result: null,
        rotate: null,
        rx: null,
        ry: null,
        scale: null,
        seed: null,
        shapeRendering: null,
        side: null,
        slope: null,
        snapshotTime: null,
        specularConstant: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        specularExponent: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        spreadMethod: null,
        spacing: null,
        startOffset: null,
        stdDeviation: null,
        stemh: null,
        stemv: null,
        stitchTiles: null,
        stopColor: null,
        stopOpacity: null,
        strikethroughPosition: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        strikethroughThickness: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        string: null,
        stroke: null,
        strokeDashArray: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        strokeDashOffset: null,
        strokeLineCap: null,
        strokeLineJoin: null,
        strokeMiterLimit: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        strokeOpacity: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        strokeWidth: null,
        style: null,
        surfaceScale: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        syncBehavior: null,
        syncBehaviorDefault: null,
        syncMaster: null,
        syncTolerance: null,
        syncToleranceDefault: null,
        systemLanguage: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        tabIndex: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        tableValues: null,
        target: null,
        targetX: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        targetY: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        textAnchor: null,
        textDecoration: null,
        textRendering: null,
        textLength: null,
        timelineBegin: null,
        title: null,
        transformBehavior: null,
        type: null,
        typeOf: (0, $1cd8c5931fc08f77$export$2ad25cfebf36cacd),
        to: null,
        transform: null,
        u1: null,
        u2: null,
        underlinePosition: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        underlineThickness: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        unicode: null,
        unicodeBidi: null,
        unicodeRange: null,
        unitsPerEm: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        values: null,
        vAlphabetic: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        vMathematical: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        vectorEffect: null,
        vHanging: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        vIdeographic: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        version: null,
        vertAdvY: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        vertOriginX: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        vertOriginY: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        viewBox: null,
        viewTarget: null,
        visibility: null,
        width: null,
        widths: null,
        wordSpacing: null,
        writingMode: null,
        x: null,
        x1: null,
        x2: null,
        xChannelSelector: null,
        xHeight: (0, $1cd8c5931fc08f77$export$98e628dec113755e),
        y: null,
        y1: null,
        y2: null,
        yChannelSelector: null,
        z: null,
        zoomAndPan: null
    }
});





const $67c0d6acca69086d$export$c0bb0b647f701bb5 = (0, $88748e0f0004348f$export$4950aa0f605343fb)([
    (0, $ffe02515452e22ad$export$f2913fe8983302e),
    (0, $f0763097e6b0d9dc$export$2bd1230ec7600845),
    (0, $a4eaed7275c800fe$export$e20c24a128671213),
    (0, $c3593fe6a0c959f9$export$4d2d26490572750a),
    (0, $2812865310bd3cff$export$c0bb0b647f701bb5)
], "html");
const $67c0d6acca69086d$export$7ed1367e7fa1ad68 = (0, $88748e0f0004348f$export$4950aa0f605343fb)([
    (0, $ffe02515452e22ad$export$f2913fe8983302e),
    (0, $f0763097e6b0d9dc$export$2bd1230ec7600845),
    (0, $a4eaed7275c800fe$export$e20c24a128671213),
    (0, $c3593fe6a0c959f9$export$4d2d26490572750a),
    (0, $16ff35f2443dceb0$export$7ed1367e7fa1ad68)
], "svg");


/**
 * Parse space separated tokens to an array of strings.
 *
 * @param {string} value Space separated tokens
 * @returns {Array.<string>} Tokens
 */ function $b4c21dac4962995f$export$98e6a39c04603d36(value) {
    const input = String(value || "").trim();
    return input ? input.split(/[ \t\n\r\f]+/g) : [];
}
function $b4c21dac4962995f$export$fac44ee5b035f737(values) {
    return values.join(" ").trim();
}


var $9109950bea1f2705$exports = {};
var $821391e113b26577$exports = {};
// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var $821391e113b26577$var$COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;
var $821391e113b26577$var$NEWLINE_REGEX = /\n/g;
var $821391e113b26577$var$WHITESPACE_REGEX = /^\s*/;
// declaration
var $821391e113b26577$var$PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var $821391e113b26577$var$COLON_REGEX = /^:\s*/;
var $821391e113b26577$var$VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var $821391e113b26577$var$SEMICOLON_REGEX = /^[;\s]*/;
// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var $821391e113b26577$var$TRIM_REGEX = /^\s+|\s+$/g;
// strings
var $821391e113b26577$var$NEWLINE = "\n";
var $821391e113b26577$var$FORWARD_SLASH = "/";
var $821391e113b26577$var$ASTERISK = "*";
var $821391e113b26577$var$EMPTY_STRING = "";
// types
var $821391e113b26577$var$TYPE_COMMENT = "comment";
var $821391e113b26577$var$TYPE_DECLARATION = "declaration";
/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */ $821391e113b26577$exports = function(style, options) {
    if (typeof style !== "string") throw new TypeError("First argument must be a string");
    if (!style) return [];
    options = options || {};
    /**
   * Positional.
   */ var lineno = 1;
    var column = 1;
    /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */ function updatePosition(str) {
        var lines = str.match($821391e113b26577$var$NEWLINE_REGEX);
        if (lines) lineno += lines.length;
        var i = str.lastIndexOf($821391e113b26577$var$NEWLINE);
        column = ~i ? str.length - i : column + str.length;
    }
    /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */ function position() {
        var start = {
            line: lineno,
            column: column
        };
        return function(node) {
            node.position = new Position(start);
            whitespace();
            return node;
        };
    }
    /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */ function Position(start) {
        this.start = start;
        this.end = {
            line: lineno,
            column: column
        };
        this.source = options.source;
    }
    /**
   * Non-enumerable source string.
   */ Position.prototype.content = style;
    var errorsList = [];
    /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */ function error(msg) {
        var err = new Error(options.source + ":" + lineno + ":" + column + ": " + msg);
        err.reason = msg;
        err.filename = options.source;
        err.line = lineno;
        err.column = column;
        err.source = style;
        if (options.silent) errorsList.push(err);
        else throw err;
    }
    /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */ function match(re) {
        var m = re.exec(style);
        if (!m) return;
        var str = m[0];
        updatePosition(str);
        style = style.slice(str.length);
        return m;
    }
    /**
   * Parse whitespace.
   */ function whitespace() {
        match($821391e113b26577$var$WHITESPACE_REGEX);
    }
    /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */ function comments(rules) {
        var c;
        rules = rules || [];
        while(c = comment())if (c !== false) rules.push(c);
        return rules;
    }
    /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */ function comment() {
        var pos = position();
        if ($821391e113b26577$var$FORWARD_SLASH != style.charAt(0) || $821391e113b26577$var$ASTERISK != style.charAt(1)) return;
        var i = 2;
        while($821391e113b26577$var$EMPTY_STRING != style.charAt(i) && ($821391e113b26577$var$ASTERISK != style.charAt(i) || $821391e113b26577$var$FORWARD_SLASH != style.charAt(i + 1)))++i;
        i += 2;
        if ($821391e113b26577$var$EMPTY_STRING === style.charAt(i - 1)) return error("End of comment missing");
        var str = style.slice(2, i - 2);
        column += 2;
        updatePosition(str);
        style = style.slice(i);
        column += 2;
        return pos({
            type: $821391e113b26577$var$TYPE_COMMENT,
            comment: str
        });
    }
    /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */ function declaration() {
        var pos = position();
        // prop
        var prop = match($821391e113b26577$var$PROPERTY_REGEX);
        if (!prop) return;
        comment();
        // :
        if (!match($821391e113b26577$var$COLON_REGEX)) return error("property missing ':'");
        // val
        var val = match($821391e113b26577$var$VALUE_REGEX);
        var ret = pos({
            type: $821391e113b26577$var$TYPE_DECLARATION,
            property: $821391e113b26577$var$trim(prop[0].replace($821391e113b26577$var$COMMENT_REGEX, $821391e113b26577$var$EMPTY_STRING)),
            value: val ? $821391e113b26577$var$trim(val[0].replace($821391e113b26577$var$COMMENT_REGEX, $821391e113b26577$var$EMPTY_STRING)) : $821391e113b26577$var$EMPTY_STRING
        });
        // ;
        match($821391e113b26577$var$SEMICOLON_REGEX);
        return ret;
    }
    /**
   * Parse declarations.
   *
   * @return {Object[]}
   */ function declarations() {
        var decls = [];
        comments(decls);
        // declarations
        var decl;
        while(decl = declaration())if (decl !== false) {
            decls.push(decl);
            comments(decls);
        }
        return decls;
    }
    whitespace();
    return declarations();
};
/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */ function $821391e113b26577$var$trim(str) {
    return str ? str.replace($821391e113b26577$var$TRIM_REGEX, $821391e113b26577$var$EMPTY_STRING) : $821391e113b26577$var$EMPTY_STRING;
}


/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */ function $9109950bea1f2705$var$StyleToObject(style, iterator) {
    var output = null;
    if (!style || typeof style !== "string") return output;
    var declaration;
    var declarations = $821391e113b26577$exports(style);
    var hasIterator = typeof iterator === "function";
    var property;
    var value;
    for(var i = 0, len = declarations.length; i < len; i++){
        declaration = declarations[i];
        property = declaration.property;
        value = declaration.value;
        if (hasIterator) iterator(property, value, declaration);
        else if (value) {
            output || (output = {});
            output[property] = value;
        }
    }
    return output;
}
$9109950bea1f2705$exports = $9109950bea1f2705$var$StyleToObject;
$9109950bea1f2705$exports.default = $9109950bea1f2705$var$StyleToObject; // ESM support


var $142a059dd635f1d5$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($9109950bea1f2705$exports)));


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 */ /**
 * Get the ending point of `node`.
 *
 * @param node
 *   Node.
 * @returns
 *   Point.
 */ const $376270e3d73468cb$export$da309cdce9dc2a25 = $376270e3d73468cb$var$point("end");
const $376270e3d73468cb$export$771bf3e4949bfbee = $376270e3d73468cb$var$point("start");
/**
 * Get the positional info of `node`.
 *
 * @param {'end' | 'start'} type
 *   Side.
 * @returns
 *   Getter.
 */ function $376270e3d73468cb$var$point(type) {
    return point;
    /**
   * Get the point info of `node` at a bound side.
   *
   * @param {Node | NodeLike | null | undefined} [node]
   * @returns {Point | undefined}
   */ function point(node) {
        const point = node && node.position && node.position[type] || {};
        if (typeof point.line === "number" && point.line > 0 && typeof point.column === "number" && point.column > 0) return {
            line: point.line,
            column: point.column,
            offset: typeof point.offset === "number" && point.offset > -1 ? point.offset : undefined
        };
    }
}
function $376270e3d73468cb$export$5880b8b5730aff45(node) {
    const start = $376270e3d73468cb$export$771bf3e4949bfbee(node);
    const end = $376270e3d73468cb$export$da309cdce9dc2a25(node);
    if (start && end) return {
        start: start,
        end: end
    };
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef Options
 *   Configuration.
 * @property {Array<Node> | null | undefined} [ancestors]
 *   Stack of (inclusive) ancestor nodes surrounding the message (optional).
 * @property {Error | null | undefined} [cause]
 *   Original error cause of the message (optional).
 * @property {Point | Position | null | undefined} [place]
 *   Place of message (optional).
 * @property {string | null | undefined} [ruleId]
 *   Category of message (optional, example: `'my-rule'`).
 * @property {string | null | undefined} [source]
 *   Namespace of who sent the message (optional, example: `'my-package'`).
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 */ /**
 * @typedef NodeLike
 * @property {string} type
 * @property {PositionLike | null | undefined} [position]
 *
 * @typedef PointLike
 * @property {number | null | undefined} [line]
 * @property {number | null | undefined} [column]
 * @property {number | null | undefined} [offset]
 *
 * @typedef PositionLike
 * @property {PointLike | null | undefined} [start]
 * @property {PointLike | null | undefined} [end]
 */ /**
 * Serialize the positional info of a point, position (start and end points),
 * or node.
 *
 * @param {Node | NodeLike | Point | PointLike | Position | PositionLike | null | undefined} [value]
 *   Node, position, or point.
 * @returns {string}
 *   Pretty printed positional info of a node (`string`).
 *
 *   In the format of a range `ls:cs-le:ce` (when given `node` or `position`)
 *   or a point `l:c` (when given `point`), where `l` stands for line, `c` for
 *   column, `s` for `start`, and `e` for end.
 *   An empty string (`''`) is returned if the given value is neither `node`,
 *   `position`, nor `point`.
 */ function $9628fc39c3f83a4c$export$c304dd45fe166145(value) {
    // Nothing.
    if (!value || typeof value !== "object") return "";
    // Node.
    if ("position" in value || "type" in value) return $9628fc39c3f83a4c$var$position(value.position);
    // Position.
    if ("start" in value || "end" in value) return $9628fc39c3f83a4c$var$position(value);
    // Point.
    if ("line" in value || "column" in value) return $9628fc39c3f83a4c$var$point(value);
    // ?
    return "";
}
/**
 * @param {Point | PointLike | null | undefined} point
 * @returns {string}
 */ function $9628fc39c3f83a4c$var$point(point) {
    return $9628fc39c3f83a4c$var$index(point && point.line) + ":" + $9628fc39c3f83a4c$var$index(point && point.column);
}
/**
 * @param {Position | PositionLike | null | undefined} pos
 * @returns {string}
 */ function $9628fc39c3f83a4c$var$position(pos) {
    return $9628fc39c3f83a4c$var$point(pos && pos.start) + "-" + $9628fc39c3f83a4c$var$point(pos && pos.end);
}
/**
 * @param {number | null | undefined} value
 * @returns {number}
 */ function $9628fc39c3f83a4c$var$index(value) {
    return value && typeof value === "number" ? value : 1;
}


class $1069c7510fec44f3$export$752e5c445fe834ef extends Error {
    /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */ // eslint-disable-next-line complexity
    constructor(causeOrReason, optionsOrParentOrPlace, origin){
        super();
        if (typeof optionsOrParentOrPlace === "string") {
            origin = optionsOrParentOrPlace;
            optionsOrParentOrPlace = undefined;
        }
        /** @type {string} */ let reason = "";
        /** @type {Options} */ let options = {};
        let legacyCause = false;
        if (optionsOrParentOrPlace) {
            // Point.
            if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) options = {
                place: optionsOrParentOrPlace
            };
            else if ("type" in optionsOrParentOrPlace) options = {
                ancestors: [
                    optionsOrParentOrPlace
                ],
                place: optionsOrParentOrPlace.position
            };
            else options = {
                ...optionsOrParentOrPlace
            };
        }
        if (typeof causeOrReason === "string") reason = causeOrReason;
        else if (!options.cause && causeOrReason) {
            legacyCause = true;
            reason = causeOrReason.message;
            options.cause = causeOrReason;
        }
        if (!options.ruleId && !options.source && typeof origin === "string") {
            const index = origin.indexOf(":");
            if (index === -1) options.ruleId = origin;
            else {
                options.source = origin.slice(0, index);
                options.ruleId = origin.slice(index + 1);
            }
        }
        if (!options.place && options.ancestors && options.ancestors) {
            const parent = options.ancestors[options.ancestors.length - 1];
            if (parent) options.place = parent.position;
        }
        const start = options.place && "start" in options.place ? options.place.start : options.place;
        /* eslint-disable no-unused-expressions */ /**
     * Stack of ancestor nodes surrounding the message.
     *
     * @type {Array<Node> | undefined}
     */ this.ancestors = options.ancestors || undefined;
        /**
     * Original error cause of the message.
     *
     * @type {Error | undefined}
     */ this.cause = options.cause || undefined;
        /**
     * Starting column of message.
     *
     * @type {number | undefined}
     */ this.column = start ? start.column : undefined;
        /**
     * State of problem.
     *
     * * `true` — error, file not usable
     * * `false` — warning, change may be needed
     * * `undefined` — change likely not needed
     *
     * @type {boolean | null | undefined}
     */ this.fatal = undefined;
        /**
     * Path of a file (used throughout the `VFile` ecosystem).
     *
     * @type {string | undefined}
     */ this.file;
        // Field from `Error`.
        /**
     * Reason for message.
     *
     * @type {string}
     */ this.message = reason;
        /**
     * Starting line of error.
     *
     * @type {number | undefined}
     */ this.line = start ? start.line : undefined;
        // Field from `Error`.
        /**
     * Serialized positional info of message.
     *
     * On normal errors, this would be something like `ParseError`, buit in
     * `VFile` messages we use this space to show where an error happened.
     */ this.name = (0, $9628fc39c3f83a4c$export$c304dd45fe166145)(options.place) || "1:1";
        /**
     * Place of message.
     *
     * @type {Point | Position | undefined}
     */ this.place = options.place || undefined;
        /**
     * Reason for message, should use markdown.
     *
     * @type {string}
     */ this.reason = this.message;
        /**
     * Category of message (example: `'my-rule'`).
     *
     * @type {string | undefined}
     */ this.ruleId = options.ruleId || undefined;
        /**
     * Namespace of message (example: `'my-package'`).
     *
     * @type {string | undefined}
     */ this.source = options.source || undefined;
        // Field from `Error`.
        /**
     * Stack of message.
     *
     * This is used by normal errors to show where something happened in
     * programming code, irrelevant for `VFile` messages,
     *
     * @type {string}
     */ this.stack = legacyCause && options.cause && typeof options.cause.stack === "string" ? options.cause.stack : "";
        // The following fields are “well known”.
        // Not standard.
        // Feel free to add other non-standard fields to your messages.
        /**
     * Specify the source value that’s being reported, which is deemed
     * incorrect.
     *
     * @type {string | undefined}
     */ this.actual;
        /**
     * Suggest acceptable values that can be used instead of `actual`.
     *
     * @type {Array<string> | undefined}
     */ this.expected;
        /**
     * Long form description of the message (you should use markdown).
     *
     * @type {string | undefined}
     */ this.note;
        /**
     * Link to docs for the message.
     *
     * > 👉 **Note**: this must be an absolute URL that can be passed as `x`
     * > to `new URL(x)`.
     *
     * @type {string | undefined}
     */ this.url;
    /* eslint-enable no-unused-expressions */ }
}
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.file = "";
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.name = "";
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.reason = "";
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.message = "";
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.stack = "";
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.column = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.line = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.ancestors = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.cause = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.fatal = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.place = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.ruleId = undefined;
$1069c7510fec44f3$export$752e5c445fe834ef.prototype.source = undefined;


const $7e7a0df6c3ed41a4$var$own = {}.hasOwnProperty;
/** @type {Map<string, number>} */ const $7e7a0df6c3ed41a4$var$emptyMap = new Map();
const $7e7a0df6c3ed41a4$var$cap = /[A-Z]/g;
const $7e7a0df6c3ed41a4$var$dashSomething = /-([a-z])/g;
// `react-dom` triggers a warning for *any* white space in tables.
// To follow GFM, `mdast-util-to-hast` injects line endings between elements.
// Other tools might do so too, but they don’t do here, so we remove all of
// that.
// See: <https://github.com/facebook/react/pull/7081>.
// See: <https://github.com/facebook/react/pull/7515>.
// See: <https://github.com/remarkjs/remark-react/issues/64>.
// See: <https://github.com/rehypejs/rehype-react/pull/29>.
// See: <https://github.com/rehypejs/rehype-react/pull/32>.
// See: <https://github.com/rehypejs/rehype-react/pull/45>.
const $7e7a0df6c3ed41a4$var$tableElements = new Set([
    "table",
    "tbody",
    "thead",
    "tfoot",
    "tr"
]);
const $7e7a0df6c3ed41a4$var$tableCellElement = new Set([
    "td",
    "th"
]);
function $7e7a0df6c3ed41a4$export$59c10052b2dee561(tree, options) {
    if (!options || options.Fragment === undefined) throw new TypeError("Expected `Fragment` in options");
    const filePath = options.filePath || undefined;
    /** @type {Create} */ let create;
    if (options.development) {
        if (typeof options.jsxDEV !== "function") throw new TypeError("Expected `jsxDEV` in options when `development: true`");
        create = $7e7a0df6c3ed41a4$var$developmentCreate(filePath, options.jsxDEV);
    } else {
        if (typeof options.jsx !== "function") throw new TypeError("Expected `jsx` in production options");
        if (typeof options.jsxs !== "function") throw new TypeError("Expected `jsxs` in production options");
        create = $7e7a0df6c3ed41a4$var$productionCreate(filePath, options.jsx, options.jsxs);
    }
    /** @type {State} */ const state = {
        Fragment: options.Fragment,
        ancestors: [],
        components: options.components || {},
        create: create,
        elementAttributeNameCase: options.elementAttributeNameCase || "react",
        filePath: filePath,
        ignoreInvalidStyle: options.ignoreInvalidStyle || false,
        passKeys: options.passKeys !== false,
        passNode: options.passNode || false,
        schema: options.space === "svg" ? (0, $67c0d6acca69086d$export$7ed1367e7fa1ad68) : (0, $67c0d6acca69086d$export$c0bb0b647f701bb5),
        stylePropertyNameCase: options.stylePropertyNameCase || "dom",
        tableCellAlignToStyle: options.tableCellAlignToStyle !== false
    };
    const result = $7e7a0df6c3ed41a4$var$one(state, tree, undefined);
    // JSX element.
    if (result && typeof result !== "string") return result;
    // Text node or something that turned into nothing.
    return state.create(tree, state.Fragment, {
        children: result || undefined
    }, undefined);
}
/**
 * Transform a node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Nodes} node
 *   Current node.
 * @param {string | undefined} key
 *   Key.
 * @returns {Child | undefined}
 *   Child, optional.
 */ function $7e7a0df6c3ed41a4$var$one(state, node, key) {
    if (node.type === "element" || node.type === "root") {
        const parentSchema = state.schema;
        let schema = parentSchema;
        if (node.type === "element" && node.tagName.toLowerCase() === "svg" && parentSchema.space === "html") {
            schema = (0, $67c0d6acca69086d$export$7ed1367e7fa1ad68);
            state.schema = schema;
        }
        state.ancestors.push(node);
        let children = $7e7a0df6c3ed41a4$var$createChildren(state, node);
        const props = $7e7a0df6c3ed41a4$var$createProperties(state, state.ancestors);
        let type = state.Fragment;
        state.ancestors.pop();
        if (node.type === "element") {
            if (children && $7e7a0df6c3ed41a4$var$tableElements.has(node.tagName)) children = children.filter(function(child) {
                return typeof child === "string" ? !(0, $4e8525678352af73$export$7af1228ff777d175)(child) : true;
            });
            if ($7e7a0df6c3ed41a4$var$own.call(state.components, node.tagName)) {
                const key = /** @type {keyof JSX.IntrinsicElements} */ node.tagName;
                type = state.components[key];
                // If this is swapped out for a component:
                if (typeof type !== "string" && type !== state.Fragment && state.passNode) props.node = node;
            } else type = node.tagName;
        }
        if (children.length > 0) {
            const value = children.length > 1 ? children : children[0];
            if (value) props.children = value;
        }
        // Restore parent schema.
        state.schema = parentSchema;
        return state.create(node, type, props, key);
    }
    if (node.type === "text") return node.value;
}
/**
 * @param {string | undefined} _
 *   Path to file.
 * @param {Jsx} jsx
 *   Dynamic.
 * @param {Jsx} jsxs
 *   Static.
 * @returns {Create}
 *   Create a production element.
 */ function $7e7a0df6c3ed41a4$var$productionCreate(_, jsx, jsxs) {
    return create;
    /** @type {Create} */ function create(_, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const fn = isStaticChildren ? jsxs : jsx;
        return key ? fn(type, props, key) : fn(type, props);
    }
}
/**
 * @param {string | undefined} filePath
 *   Path to file.
 * @param {JsxDev} jsxDEV
 *   Development.
 * @returns {Create}
 *   Create a development element.
 */ function $7e7a0df6c3ed41a4$var$developmentCreate(filePath, jsxDEV) {
    return create;
    /** @type {Create} */ function create(node, type, props, key) {
        // Only an array when there are 2 or more children.
        const isStaticChildren = Array.isArray(props.children);
        const point = (0, $376270e3d73468cb$export$771bf3e4949bfbee)(node);
        return jsxDEV(type, props, key, isStaticChildren, {
            columnNumber: point ? point.column - 1 : undefined,
            fileName: filePath,
            lineNumber: point ? point.line : undefined
        }, undefined);
    }
}
/**
 * Create children.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Parents} node
 *   Current element.
 * @returns {Array<Child>}
 *   Children.
 */ function $7e7a0df6c3ed41a4$var$createChildren(state, node) {
    /** @type {Array<Child>} */ const children = [];
    let index = -1;
    /** @type {Map<string, number>} */ // Note: test this when Solid doesn’t want to merge my upcoming PR.
    /* c8 ignore next */ const countsByTagName = state.passKeys ? new Map() : $7e7a0df6c3ed41a4$var$emptyMap;
    while(++index < node.children.length){
        const child = node.children[index];
        /** @type {string | undefined} */ let key;
        if (state.passKeys && child.type === "element") {
            const count = countsByTagName.get(child.tagName) || 0;
            key = child.tagName + "-" + count;
            countsByTagName.set(child.tagName, count + 1);
        }
        const result = $7e7a0df6c3ed41a4$var$one(state, child, key);
        if (result !== undefined) children.push(result);
    }
    return children;
}
/**
 * Handle properties.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Parents>} ancestors
 *   Stack of parents.
 * @returns {Props}
 *   Props for runtime.
 */ function $7e7a0df6c3ed41a4$var$createProperties(state, ancestors) {
    const node = ancestors[ancestors.length - 1];
    /** @type {Props} */ const props = {};
    /** @type {string} */ let prop;
    if ("properties" in node && node.properties) {
        /** @type {string | undefined} */ let alignValue;
        for(prop in node.properties)if (prop !== "children" && $7e7a0df6c3ed41a4$var$own.call(node.properties, prop)) {
            const result = $7e7a0df6c3ed41a4$var$createProperty(state, ancestors, prop, node.properties[prop]);
            if (result) {
                const [key, value] = result;
                if (state.tableCellAlignToStyle && key === "align" && typeof value === "string" && $7e7a0df6c3ed41a4$var$tableCellElement.has(node.tagName)) alignValue = value;
                else props[key] = value;
            }
        }
        if (alignValue) {
            // Assume style is an object.
            const style = /** @type {Style} */ props.style || (props.style = {});
            style[state.stylePropertyNameCase === "css" ? "text-align" : "textAlign"] = alignValue;
        }
    }
    return props;
}
/**
 * Handle a property.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Parents>} ancestors
 *   Stack of parents.
 * @param {string} prop
 *   Key.
 * @param {Array<number | string> | boolean | number | string | null | undefined} value
 *   hast property value.
 * @returns {Field | undefined}
 *   Field for runtime, optional.
 */ function $7e7a0df6c3ed41a4$var$createProperty(state, ancestors, prop, value) {
    const info = (0, $262b1e8417e96ac0$export$71aa6c912b956294)(state.schema, prop);
    // Ignore nullish and `NaN` values.
    if (value === null || value === undefined || typeof value === "number" && Number.isNaN(value)) return;
    if (Array.isArray(value)) // Accept `array`.
    // Most props are space-separated.
    value = info.commaSeparated ? (0, $f7ed1f99e7dfe605$export$fac44ee5b035f737)(value) : (0, $b4c21dac4962995f$export$fac44ee5b035f737)(value);
    // React only accepts `style` as object.
    if (info.property === "style") {
        let styleObject = typeof value === "object" ? value : $7e7a0df6c3ed41a4$var$parseStyle(state, ancestors, String(value));
        if (state.stylePropertyNameCase === "css") styleObject = $7e7a0df6c3ed41a4$var$transformStylesToCssCasing(styleObject);
        return [
            "style",
            styleObject
        ];
    }
    return [
        state.elementAttributeNameCase === "react" && info.space ? (0, $ac9dfc82e96f8ce5$export$d8abd7e5fb6871f9)[info.property] || info.property : info.attribute,
        value
    ];
}
/**
 * Parse a CSS declaration to an object.
 *
 * @param {State} state
 *   Info passed around.
 * @param {Array<Nodes>} ancestors
 *   Stack of nodes.
 * @param {string} value
 *   CSS declarations.
 * @returns {Style}
 *   Properties.
 * @throws
 *   Throws `VFileMessage` when CSS cannot be parsed.
 */ function $7e7a0df6c3ed41a4$var$parseStyle(state, ancestors, value) {
    /** @type {Style} */ const result = {};
    try {
        (0, $142a059dd635f1d5$export$2e2bcd8739ae039)(value, replacer);
    } catch (error) {
        if (!state.ignoreInvalidStyle) {
            const cause = /** @type {Error} */ error;
            const message = new (0, $1069c7510fec44f3$export$752e5c445fe834ef)("Cannot parse `style` attribute", {
                ancestors: ancestors,
                cause: cause,
                source: "hast-util-to-jsx-runtime",
                ruleId: "style"
            });
            message.file = state.filePath || undefined;
            message.url = "https://github.com/syntax-tree/hast-util-to-jsx-runtime#cannot-parse-style-attribute";
            throw message;
        }
    }
    return result;
    /**
   * Add a CSS property (normal, so with dashes) to `result` as a DOM CSS
   * property.
   *
   * @param {string} name
   *   Key.
   * @param {string} value
   *   Value
   * @returns {undefined}
   *   Nothing.
   */ function replacer(name, value) {
        let key = name;
        if (key.slice(0, 2) !== "--") {
            if (key.slice(0, 4) === "-ms-") key = "ms-" + key.slice(4);
            key = key.replace($7e7a0df6c3ed41a4$var$dashSomething, $7e7a0df6c3ed41a4$var$toCamel);
        }
        result[key] = value;
    }
}
/**
 * Transform a DOM casing style object to a CSS casing style object.
 *
 * @param {Style} domCasing
 * @returns {Style}
 */ function $7e7a0df6c3ed41a4$var$transformStylesToCssCasing(domCasing) {
    /** @type {Style} */ const cssCasing = {};
    /** @type {string} */ let from;
    for(from in domCasing)if ($7e7a0df6c3ed41a4$var$own.call(domCasing, from)) cssCasing[$7e7a0df6c3ed41a4$var$transformStyleToCssCasing(from)] = domCasing[from];
    return cssCasing;
}
/**
 * Transform a DOM casing style field to a CSS casing style field.
 *
 * @param {string} from
 * @returns {string}
 */ function $7e7a0df6c3ed41a4$var$transformStyleToCssCasing(from) {
    let to = from.replace($7e7a0df6c3ed41a4$var$cap, $7e7a0df6c3ed41a4$var$toDash);
    // Handle `ms-xxx` -> `-ms-xxx`.
    if (to.slice(0, 3) === "ms-") to = "-" + to;
    return to;
}
/**
 * Make `$1` capitalized.
 *
 * @param {string} _
 *   Whatever.
 * @param {string} $1
 *   Single ASCII alphabetical.
 * @returns {string}
 *   Capitalized `$1`.
 */ function $7e7a0df6c3ed41a4$var$toCamel(_, $1) {
    return $1.toUpperCase();
}
/**
 * Make `$0` dash cased.
 *
 * @param {string} $0
 *   Capitalized ASCII leter.
 * @returns {string}
 *   Dash and lower letter.
 */ function $7e7a0df6c3ed41a4$var$toDash($0) {
    return "-" + $0.toLowerCase();
}


/**
 * HTML URL properties.
 *
 * Each key is a property name and each value is a list of tag names it applies
 * to or `null` if it applies to all elements.
 *
 * @type {Record<string, Array<string> | null>}
 */ const $653782b3457a4366$export$de3e062aedff083a = {
    action: [
        "form"
    ],
    cite: [
        "blockquote",
        "del",
        "ins",
        "q"
    ],
    data: [
        "object"
    ],
    formAction: [
        "button",
        "input"
    ],
    href: [
        "a",
        "area",
        "base",
        "link"
    ],
    icon: [
        "menuitem"
    ],
    itemId: null,
    manifest: [
        "html"
    ],
    ping: [
        "a",
        "area"
    ],
    poster: [
        "video"
    ],
    src: [
        "audio",
        "embed",
        "iframe",
        "img",
        "input",
        "script",
        "source",
        "track",
        "video"
    ]
};


/**
 * @typedef {import('micromark-util-types').Code} Code
 */ const $b4c110780d01af5f$var$unicodePunctuationInternal = $b4c110780d01af5f$var$regexCheck(/\p{P}/u);
const $b4c110780d01af5f$export$d65d6b62c24d5436 = $b4c110780d01af5f$var$regexCheck(/[A-Za-z]/);
const $b4c110780d01af5f$export$75c76db11865a9f4 = $b4c110780d01af5f$var$regexCheck(/[\dA-Za-z]/);
const $b4c110780d01af5f$export$4397998b34fe597d = $b4c110780d01af5f$var$regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function $b4c110780d01af5f$export$67dbf494fc8394df(code) {
    return(// Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code !== null && (code < 32 || code === 127));
}
const $b4c110780d01af5f$export$ca8b5b1a6c320e6e = $b4c110780d01af5f$var$regexCheck(/\d/);
const $b4c110780d01af5f$export$eca2752363989806 = $b4c110780d01af5f$var$regexCheck(/[\dA-Fa-f]/);
const $b4c110780d01af5f$export$35794a7d1db99380 = $b4c110780d01af5f$var$regexCheck(/[!-/:-@[-`{-~]/);
function $b4c110780d01af5f$export$34a1dff1c0936953(code) {
    return code !== null && code < -2;
}
function $b4c110780d01af5f$export$a30284361b3814b7(code) {
    return code !== null && (code < 0 || code === 32);
}
function $b4c110780d01af5f$export$2c6cf65c1127992a(code) {
    return code === -2 || code === -1 || code === 32;
}
function $b4c110780d01af5f$export$aa04114dd888a7a0(code) {
    return $b4c110780d01af5f$export$35794a7d1db99380(code) || $b4c110780d01af5f$var$unicodePunctuationInternal(code);
}
const $b4c110780d01af5f$export$a0ff789c034ffdf4 = $b4c110780d01af5f$var$regexCheck(/\s/);
/**
 * Create a code check from a regex.
 *
 * @param {RegExp} regex
 * @returns {(code: Code) => boolean}
 */ function $b4c110780d01af5f$var$regexCheck(regex) {
    return check;
    /**
   * Check whether a code matches the bound regex.
   *
   * @param {Code} code
   *   Character code.
   * @returns {boolean}
   *   Whether the character code matches the bound regex.
   */ function check(code) {
        return code !== null && code > -1 && regex.test(String.fromCharCode(code));
    }
}


const $c5c344bd342934a9$var$characterReferences = {
    '"': "quot",
    "&": "amp",
    "<": "lt",
    ">": "gt"
};
function $c5c344bd342934a9$export$c564cdbbe6da493(value) {
    return value.replace(/["&<>]/g, replace);
    /**
   * @param {string} value
   * @returns {string}
   */ function replace(value) {
        // @ts-expect-error Hush, it’s fine.
        return "&" + $c5c344bd342934a9$var$characterReferences[value] + ";";
    }
}


function $e133dd0f2d166be7$export$d130a2d684099e5a(url, protocol) {
    const value = (0, $c5c344bd342934a9$export$c564cdbbe6da493)($e133dd0f2d166be7$export$e42a3e39590d28b5(url || ""));
    if (!protocol) return value;
    const colon = value.indexOf(":");
    const questionMark = value.indexOf("?");
    const numberSign = value.indexOf("#");
    const slash = value.indexOf("/");
    if (// If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol.test(value.slice(0, colon))) return value;
    return "";
}
function $e133dd0f2d166be7$export$e42a3e39590d28b5(value) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    let start = 0;
    let skip = 0;
    while(++index < value.length){
        const code = value.charCodeAt(index);
        /** @type {string} */ let replace = "";
        // A correct percent encoded value.
        if (code === 37 && (0, $b4c110780d01af5f$export$75c76db11865a9f4)(value.charCodeAt(index + 1)) && (0, $b4c110780d01af5f$export$75c76db11865a9f4)(value.charCodeAt(index + 2))) skip = 2;
        else if (code < 128) {
            if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code))) replace = String.fromCharCode(code);
        } else if (code > 55295 && code < 57344) {
            const next = value.charCodeAt(index + 1);
            // A correct surrogate pair.
            if (code < 56320 && next > 56319 && next < 57344) {
                replace = String.fromCharCode(code, next);
                skip = 1;
            } else replace = "�";
        } else replace = String.fromCharCode(code);
        if (replace) {
            result.push(value.slice(start, index), encodeURIComponent(replace));
            start = index + skip + 1;
            replace = "";
        }
        if (skip) {
            index += skip;
            skip = 0;
        }
    }
    return result.join("") + value.slice(start);
}



var $9zeGj = parcelRequire("9zeGj");
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-from-markdown').Options} FromMarkdownOptions
 * @typedef {import('unified').Parser<Root>} Parser
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {Omit<FromMarkdownOptions, 'extensions' | 'mdastExtensions'>} Options
 */ /**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Html} Html
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parent} Parent
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').ReferenceType} ReferenceType
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('mdast').Text} Text
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 *
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Value} Value
 *
 * @typedef {import('unist').Point} Point
 *
 * @typedef {import('../index.js').CompileData} CompileData
 */ /**
 * @typedef {Omit<Parent, 'children' | 'type'> & {type: 'fragment', children: Array<PhrasingContent>}} Fragment
 */ /**
 * @callback Transform
 *   Extra transform, to change the AST afterwards.
 * @param {Root} tree
 *   Tree to transform.
 * @returns {Root | null | undefined | void}
 *   New tree or nothing (in which case the current tree is used).
 *
 * @callback Handle
 *   Handle a token.
 * @param {CompileContext} this
 *   Context.
 * @param {Token} token
 *   Current token.
 * @returns {undefined | void}
 *   Nothing.
 *
 * @typedef {Record<string, Handle>} Handles
 *   Token types mapping to handles
 *
 * @callback OnEnterError
 *   Handle the case where the `right` token is open, but it is closed (by the
 *   `left` token) or because we reached the end of the document.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token | undefined} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @callback OnExitError
 *   Handle the case where the `right` token is open but it is closed by
 *   exiting the `left` token.
 * @param {Omit<CompileContext, 'sliceSerialize'>} this
 *   Context.
 * @param {Token} left
 *   Left token.
 * @param {Token} right
 *   Right token.
 * @returns {undefined}
 *   Nothing.
 *
 * @typedef {[Token, OnEnterError | undefined]} TokenTuple
 *   Open token on the stack, with an optional error handler for when
 *   that token isn’t closed properly.
 */ /**
 * @typedef Config
 *   Configuration.
 *
 *   We have our defaults, but extensions will add more.
 * @property {Array<string>} canContainEols
 *   Token types where line endings are used.
 * @property {Handles} enter
 *   Opening handles.
 * @property {Handles} exit
 *   Closing handles.
 * @property {Array<Transform>} transforms
 *   Tree transforms.
 *
 * @typedef {Partial<Config>} Extension
 *   Change how markdown tokens from micromark are turned into mdast.
 *
 * @typedef CompileContext
 *   mdast compiler context.
 * @property {Array<Fragment | Nodes>} stack
 *   Stack of nodes.
 * @property {Array<TokenTuple>} tokenStack
 *   Stack of tokens.
 * @property {(this: CompileContext) => undefined} buffer
 *   Capture some of the output data.
 * @property {(this: CompileContext) => string} resume
 *   Stop capturing and access the output data.
 * @property {(this: CompileContext, node: Nodes, token: Token, onError?: OnEnterError) => undefined} enter
 *   Enter a node.
 * @property {(this: CompileContext, token: Token, onError?: OnExitError) => undefined} exit
 *   Exit a node.
 * @property {TokenizeContext['sliceSerialize']} sliceSerialize
 *   Get the string value of a token.
 * @property {Config} config
 *   Configuration.
 * @property {CompileData} data
 *   Info passed around; key/value store.
 *
 * @typedef FromMarkdownOptions
 *   Configuration for how to build mdast.
 * @property {Array<Extension | Array<Extension>> | null | undefined} [mdastExtensions]
 *   Extensions for this utility to change how tokens are turned into a tree.
 *
 * @typedef {ParseOptions & FromMarkdownOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Nodes} Nodes
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [includeImageAlt=true]
 *   Whether to use `alt` for `image`s (default: `true`).
 * @property {boolean | null | undefined} [includeHtml=true]
 *   Whether to use `value` of HTML (default: `true`).
 */ /** @type {Options} */ const $05e7756bd26ae88a$var$emptyOptions = {};
function $05e7756bd26ae88a$export$f84e8e69fd4488a5(value, options) {
    const settings = options || $05e7756bd26ae88a$var$emptyOptions;
    const includeImageAlt = typeof settings.includeImageAlt === "boolean" ? settings.includeImageAlt : true;
    const includeHtml = typeof settings.includeHtml === "boolean" ? settings.includeHtml : true;
    return $05e7756bd26ae88a$var$one(value, includeImageAlt, includeHtml);
}
/**
 * One node or several nodes.
 *
 * @param {unknown} value
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized node.
 */ function $05e7756bd26ae88a$var$one(value, includeImageAlt, includeHtml) {
    if ($05e7756bd26ae88a$var$node(value)) {
        if ("value" in value) return value.type === "html" && !includeHtml ? "" : value.value;
        if (includeImageAlt && "alt" in value && value.alt) return value.alt;
        if ("children" in value) return $05e7756bd26ae88a$var$all(value.children, includeImageAlt, includeHtml);
    }
    if (Array.isArray(value)) return $05e7756bd26ae88a$var$all(value, includeImageAlt, includeHtml);
    return "";
}
/**
 * Serialize a list of nodes.
 *
 * @param {Array<unknown>} values
 *   Thing to serialize.
 * @param {boolean} includeImageAlt
 *   Include image `alt`s.
 * @param {boolean} includeHtml
 *   Include HTML.
 * @returns {string}
 *   Serialized nodes.
 */ function $05e7756bd26ae88a$var$all(values, includeImageAlt, includeHtml) {
    /** @type {Array<string>} */ const result = [];
    let index = -1;
    while(++index < values.length)result[index] = $05e7756bd26ae88a$var$one(values[index], includeImageAlt, includeHtml);
    return result.join("");
}
/**
 * Check if `value` looks like a node.
 *
 * @param {unknown} value
 *   Thing.
 * @returns {value is Nodes}
 *   Whether `value` is a node.
 */ function $05e7756bd26ae88a$var$node(value) {
    return Boolean(value && typeof value === "object");
}


/**
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Options} Options
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * While micromark is a lexer/tokenizer, the common case of going from markdown
 * to html is currently built in as this module, even though the parts can be
 * used separately to build ASTs, CSTs, or many other output formats.
 *
 * Having an HTML compiler built in is useful because it allows us to check for
 * compliancy to CommonMark, the de facto norm of markdown, specified in roughly
 * 600 input/output cases.
 *
 * This module has an interface that accepts lists of events instead of the
 * whole at once, however, because markdown can’t be truly streaming, we buffer
 * events before processing and outputting the final result.
 */ /**
 * @typedef {import('micromark-util-types').Compile} Compile
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').CompileData} CompileData
 * @typedef {import('micromark-util-types').CompileOptions} CompileOptions
 * @typedef {import('micromark-util-types').Definition} Definition
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedHtmlExtension} NormalizedHtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ /**
 * @typedef Media
 * @property {boolean | undefined} [image]
 * @property {string | undefined} [labelId]
 * @property {string | undefined} [label]
 * @property {string | undefined} [referenceId]
 * @property {string | undefined} [destination]
 * @property {string | undefined} [title]
 */ /// <reference lib="dom" />
/* eslint-env browser */ const $04b95225700f8616$var$element = document.createElement("i");
function $04b95225700f8616$export$289b6a6320f709b4(value) {
    const characterReference = "&" + value + ";";
    $04b95225700f8616$var$element.innerHTML = characterReference;
    const char = $04b95225700f8616$var$element.textContent;
    // Some named character references do not require the closing semicolon
    // (`&not`, for instance), which leads to situations where parsing the assumed
    // named reference of `&notit;` will result in the string `¬it;`.
    // When we encounter a trailing semicolon after parsing, and the character
    // reference to decode was not a semicolon (`&semi;`), we can assume that the
    // matching was not complete.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    if (char.charCodeAt(char.length - 1) === 59 /* `;` */  && value !== "semi") return false;
    // If the decoded string is equal to the input, the character reference was
    // not valid.
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    return char === characterReference ? false : char;
}


/**
 * Like `Array#splice`, but smarter for giant arrays.
 *
 * `Array#splice` takes all items to be inserted as individual argument which
 * causes a stack overflow in V8 when trying to insert 100k items for instance.
 *
 * Otherwise, this does not return the removed items, and takes `items` as an
 * array instead of rest parameters.
 *
 * @template {unknown} T
 *   Item type.
 * @param {Array<T>} list
 *   List to operate on.
 * @param {number} start
 *   Index to remove/insert at (can be negative).
 * @param {number} remove
 *   Number of items to remove.
 * @param {Array<T>} items
 *   Items to inject into `list`.
 * @returns {undefined}
 *   Nothing.
 */ function $5720affce988170b$export$869882364835d202(list, start, remove, items) {
    const end = list.length;
    let chunkStart = 0;
    /** @type {Array<unknown>} */ let parameters;
    // Make start between zero and `end` (included).
    if (start < 0) start = -start > end ? 0 : end + start;
    else start = start > end ? end : start;
    remove = remove > 0 ? remove : 0;
    // No need to chunk the items if there’s only a couple (10k) items.
    if (items.length < 10000) {
        parameters = Array.from(items);
        parameters.unshift(start, remove);
        // @ts-expect-error Hush, it’s fine.
        list.splice(...parameters);
    } else {
        // Delete `remove` items starting from `start`
        if (remove) list.splice(start, remove);
        // Insert the items in chunks to not cause stack overflows.
        while(chunkStart < items.length){
            parameters = items.slice(chunkStart, chunkStart + 10000);
            parameters.unshift(start, 0);
            // @ts-expect-error Hush, it’s fine.
            list.splice(...parameters);
            chunkStart += 10000;
            start += 10000;
        }
    }
}
function $5720affce988170b$export$4cbf152802aa238(list, items) {
    if (list.length > 0) {
        $5720affce988170b$export$869882364835d202(list, list.length, 0, items);
        return list;
    }
    return items;
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Handles} Handles
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').NormalizedExtension} NormalizedExtension
 */ 
const $4902ed8d243ad70e$var$hasOwnProperty = {}.hasOwnProperty;
function $4902ed8d243ad70e$export$86a865d89ef3c690(extensions) {
    /** @type {NormalizedExtension} */ const all = {};
    let index = -1;
    while(++index < extensions.length)$4902ed8d243ad70e$var$syntaxExtension(all, extensions[index]);
    return all;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {NormalizedExtension} all
 *   Extension to merge into.
 * @param {Extension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $4902ed8d243ad70e$var$syntaxExtension(all, extension) {
    /** @type {keyof Extension} */ let hook;
    for(hook in extension){
        const maybe = $4902ed8d243ad70e$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        /** @type {Record<string, unknown>} */ const left = maybe || (all[hook] = {});
        /** @type {Record<string, unknown> | undefined} */ const right = extension[hook];
        /** @type {string} */ let code;
        if (right) for(code in right){
            if (!$4902ed8d243ad70e$var$hasOwnProperty.call(left, code)) left[code] = [];
            const value = right[code];
            $4902ed8d243ad70e$var$constructs(// @ts-expect-error Looks like a list.
            left[code], Array.isArray(value) ? value : value ? [
                value
            ] : []);
        }
    }
}
/**
 * Merge `list` into `existing` (both lists of constructs).
 * Mutates `existing`.
 *
 * @param {Array<unknown>} existing
 * @param {Array<unknown>} list
 * @returns {undefined}
 */ function $4902ed8d243ad70e$var$constructs(existing, list) {
    let index = -1;
    /** @type {Array<unknown>} */ const before = [];
    while(++index < list.length)(list[index].add === "after" ? existing : before).push(list[index]);
    (0, $5720affce988170b$export$869882364835d202)(existing, 0, 0, before);
}
function $4902ed8d243ad70e$export$eaf8c406dfb0a620(htmlExtensions) {
    /** @type {HtmlExtension} */ const handlers = {};
    let index = -1;
    while(++index < htmlExtensions.length)$4902ed8d243ad70e$var$htmlExtension(handlers, htmlExtensions[index]);
    return handlers;
}
/**
 * Merge `extension` into `all`.
 *
 * @param {HtmlExtension} all
 *   Extension to merge into.
 * @param {HtmlExtension} extension
 *   Extension to merge.
 * @returns {undefined}
 */ function $4902ed8d243ad70e$var$htmlExtension(all, extension) {
    /** @type {keyof HtmlExtension} */ let hook;
    for(hook in extension){
        const maybe = $4902ed8d243ad70e$var$hasOwnProperty.call(all, hook) ? all[hook] : undefined;
        const left = maybe || (all[hook] = {});
        const right = extension[hook];
        /** @type {keyof Handles} */ let type;
        if (right) for(type in right)// @ts-expect-error assume document vs regular handler are managed correctly.
        left[type] = right[type];
    }
}


/**
 * Turn the number (in string form as either hexa- or plain decimal) coming from
 * a numeric character reference into a character.
 *
 * Sort of like `String.fromCharCode(Number.parseInt(value, base))`, but makes
 * non-characters and control characters safe.
 *
 * @param {string} value
 *   Value to decode.
 * @param {number} base
 *   Numeric base.
 * @returns {string}
 *   Character.
 */ function $de6a351f52b69b30$export$15a69557afac2c20(value, base) {
    const code = Number.parseInt(value, base);
    if (// C0 except for HT, LF, FF, CR, space.
    code < 9 || code === 11 || code > 13 && code < 32 || // Control character (DEL) of C0, and C1 controls.
    code > 126 && code < 160 || // Lone high surrogates and low surrogates.
    code > 55295 && code < 57344 || // Noncharacters.
    code > 64975 && code < 65008 || (code & 65535) === 65535 || (code & 65535) === 65534 /* eslint-enable no-bitwise */  || // Out of range
    code > 1114111) return "�";
    return String.fromCharCode(code);
}



/**
 * Normalize an identifier (as found in references, definitions).
 *
 * Collapses markdown whitespace, trim, and then lower- and uppercase.
 *
 * Some characters are considered “uppercase”, such as U+03F4 (`ϴ`), but if their
 * lowercase counterpart (U+03B8 (`θ`)) is uppercased will result in a different
 * uppercase character (U+0398 (`Θ`)).
 * So, to get a canonical form, we perform both lower- and uppercase.
 *
 * Using uppercase last makes sure keys will never interact with default
 * prototypal values (such as `constructor`): nothing in the prototype of
 * `Object` is uppercase.
 *
 * @param {string} value
 *   Identifier to normalize.
 * @returns {string}
 *   Normalized identifier.
 */ function $8900bf1e9be862c4$export$806d55e226cfcd08(value) {
    return value// Collapse markdown whitespace.
    .replace(/[\t\n\r ]+/g, " ")// Trim.
    .replace(/^ | $/g, "")// Some characters are considered “uppercase”, but if their lowercase
    // counterpart is uppercased will result in a different uppercase
    // character.
    // Hence, to get that form, we perform both lower- and uppercase.
    // Upper case makes sure keys will not interact with default prototypal
    // methods: no method is uppercase.
    .toLowerCase().toUpperCase();
}



const $c56b064c2cb3718f$var$hasOwnProperty = {}.hasOwnProperty;
/**
 * These two are allowlists of safe protocols for full URLs in respectively the
 * `href` (on `<a>`) and `src` (on `<img>`) attributes.
 * They are based on what is allowed on GitHub,
 * <https://github.com/syntax-tree/hast-util-sanitize/blob/9275b21/lib/github.json#L31>
 */ const $c56b064c2cb3718f$var$protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const $c56b064c2cb3718f$var$protocolSrc = /^https?$/i;
function $c56b064c2cb3718f$export$ef7acd7185315e22(options) {
    const settings = options || {};
    /**
   * Tags is needed because according to markdown, links and emphasis and
   * whatnot can exist in images, however, as HTML doesn’t allow content in
   * images, the tags are ignored in the `alt` attribute, but the content
   * remains.
   *
   * @type {boolean | undefined}
   */ let tags = true;
    /**
   * An object to track identifiers to media (URLs and titles) defined with
   * definitions.
   *
   * @type {Record<string, Definition>}
   */ const definitions = {};
    /**
   * A lot of the handlers need to capture some of the output data, modify it
   * somehow, and then deal with it.
   * We do that by tracking a stack of buffers, that can be opened (with
   * `buffer`) and closed (with `resume`) to access them.
   *
   * @type {Array<Array<string>>}
   */ const buffers = [
        []
    ];
    /**
   * As we can have links in images and the other way around, where the deepest
   * ones are closed first, we need to track which one we’re in.
   *
   * @type {Array<Media>}
   */ const mediaStack = [];
    /**
   * Same as `mediaStack` for tightness, which is specific to lists.
   * We need to track if we’re currently in a tight or loose container.
   *
   * @type {Array<boolean>}
   */ const tightStack = [];
    /** @type {HtmlExtension} */ const defaultHandlers = {
        enter: {
            blockQuote: onenterblockquote,
            codeFenced: onentercodefenced,
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: onentercodeindented,
            codeText: onentercodetext,
            content: onentercontent,
            definition: onenterdefinition,
            definitionDestinationString: onenterdefinitiondestinationstring,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: onenteremphasis,
            htmlFlow: onenterhtmlflow,
            htmlText: onenterhtml,
            image: onenterimage,
            label: buffer,
            link: onenterlink,
            listItemMarker: onenterlistitemmarker,
            listItemValue: onenterlistitemvalue,
            listOrdered: onenterlistordered,
            listUnordered: onenterlistunordered,
            paragraph: onenterparagraph,
            reference: buffer,
            resource: onenterresource,
            resourceDestinationString: onenterresourcedestinationstring,
            resourceTitleString: buffer,
            setextHeading: onentersetextheading,
            strong: onenterstrong
        },
        exit: {
            atxHeading: onexitatxheading,
            atxHeadingSequence: onexitatxheadingsequence,
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: onexitblockquote,
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: onexitflowcode,
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onresumedrop,
            codeFlowValue: onexitcodeflowvalue,
            codeIndented: onexitflowcode,
            codeText: onexitcodetext,
            codeTextData: onexitdata,
            data: onexitdata,
            definition: onexitdefinition,
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: onexitemphasis,
            hardBreakEscape: onexithardbreak,
            hardBreakTrailing: onexithardbreak,
            htmlFlow: onexithtml,
            htmlFlowData: onexitdata,
            htmlText: onexithtml,
            htmlTextData: onexitdata,
            image: onexitmedia,
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: onexitmedia,
            listOrdered: onexitlistordered,
            listUnordered: onexitlistunordered,
            paragraph: onexitparagraph,
            reference: onresumedrop,
            referenceString: onexitreferencestring,
            resource: onresumedrop,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            setextHeading: onexitsetextheading,
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: onexitstrong,
            thematicBreak: onexitthematicbreak
        }
    };
    /**
   * Combine the HTML extensions with the default handlers.
   * An HTML extension is an object whose fields are either `enter` or `exit`
   * (reflecting whether a token is entered or exited).
   * The values at such objects are names of tokens mapping to handlers.
   * Handlers are called, respectively when a token is opener or closed, with
   * that token, and a context as `this`.
   */ const handlers = /** @type {NormalizedHtmlExtension} */ (0, $4902ed8d243ad70e$export$eaf8c406dfb0a620)([
        defaultHandlers
    ].concat(settings.htmlExtensions || []));
    /**
   * Handlers do often need to keep track of some state.
   * That state is provided here as a key-value store (an object).
   *
   * @type {CompileData}
   */ const data = {
        tightStack: tightStack,
        definitions: definitions
    };
    /**
   * The context for handlers references a couple of useful functions.
   * In handlers from extensions, those can be accessed at `this`.
   * For the handlers here, they can be accessed directly.
   *
   * @type {Omit<CompileContext, 'sliceSerialize'>}
   */ const context = {
        lineEndingIfNeeded: lineEndingIfNeeded,
        options: settings,
        encode: encode,
        raw: raw,
        tag: tag,
        buffer: buffer,
        resume: resume,
        setData: setData,
        getData: getData
    };
    /**
   * Generally, micromark copies line endings (`'\r'`, `'\n'`, `'\r\n'`) in the
   * markdown document over to the compiled HTML.
   * In some cases, such as `> a`, CommonMark requires that extra line endings
   * are added: `<blockquote>\n<p>a</p>\n</blockquote>`.
   * This variable hold the default line ending when given (or `undefined`),
   * and in the latter case will be updated to the first found line ending if
   * there is one.
   */ let lineEndingStyle = settings.defaultLineEnding;
    // Return the function that handles a slice of events.
    return compile;
    /**
   * Deal w/ a slice of events.
   * Return either the empty string if there’s nothing of note to return, or the
   * result when done.
   *
   * @param {Array<Event>} events
   * @returns {string}
   */ function compile(events) {
        let index = -1;
        let start = 0;
        /** @type {Array<number>} */ const listStack = [];
        // As definitions can come after references, we need to figure out the media
        // (urls and titles) defined by them before handling the references.
        // So, we do sort of what HTML does: put metadata at the start (in head), and
        // then put content after (`body`).
        /** @type {Array<Event>} */ let head = [];
        /** @type {Array<Event>} */ let body = [];
        while(++index < events.length){
            // Figure out the line ending style used in the document.
            if (!lineEndingStyle && (events[index][1].type === "lineEnding" || events[index][1].type === "lineEndingBlank")) // @ts-expect-error Hush, it’s a line ending.
            lineEndingStyle = events[index][2].sliceSerialize(events[index][1]);
            // Preprocess lists to infer whether the list is loose or not.
            if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
                if (events[index][0] === "enter") listStack.push(index);
                else prepareList(events.slice(listStack.pop(), index));
            }
            // Move definitions to the front.
            if (events[index][1].type === "definition") {
                if (events[index][0] === "enter") {
                    body = (0, $5720affce988170b$export$4cbf152802aa238)(body, events.slice(start, index));
                    start = index;
                } else {
                    head = (0, $5720affce988170b$export$4cbf152802aa238)(head, events.slice(start, index + 1));
                    start = index + 1;
                }
            }
        }
        head = (0, $5720affce988170b$export$4cbf152802aa238)(head, body);
        head = (0, $5720affce988170b$export$4cbf152802aa238)(head, events.slice(start));
        index = -1;
        const result = head;
        // Handle the start of the document, if defined.
        if (handlers.enter.null) handlers.enter.null.call(context);
        // Handle all events.
        while(++index < events.length){
            const handles = handlers[result[index][0]];
            const kind = result[index][1].type;
            const handle = handles[kind];
            if ($c56b064c2cb3718f$var$hasOwnProperty.call(handles, kind) && handle) handle.call(Object.assign({
                sliceSerialize: result[index][2].sliceSerialize
            }, context), result[index][1]);
        }
        // Handle the end of the document, if defined.
        if (handlers.exit.null) handlers.exit.null.call(context);
        return buffers[0].join("");
    }
    /**
   * Figure out whether lists are loose or not.
   *
   * @param {Array<Event>} slice
   * @returns {undefined}
   */ function prepareList(slice) {
        const length = slice.length;
        let index = 0 // Skip open.
        ;
        let containerBalance = 0;
        let loose = false;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index < length){
            const event = slice[index];
            if (event[1]._container) {
                atMarker = undefined;
                if (event[0] === "enter") containerBalance++;
                else containerBalance--;
            } else switch(event[1].type){
                case "listItemPrefix":
                    if (event[0] === "exit") atMarker = true;
                    break;
                case "linePrefix":
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter" && !containerBalance) {
                        if (atMarker) atMarker = undefined;
                        else loose = true;
                    }
                    break;
                default:
                    atMarker = undefined;
            }
        }
        slice[0][1]._loose = loose;
    }
    /**
   * @type {CompileContext['setData']}
   */ function setData(key, value) {
        // @ts-expect-error: assume `value` is omitted (`undefined` is passed) only
        // if allowed.
        data[key] = value;
    }
    /**
   * @type {CompileContext['getData']}
   */ function getData(key) {
        return data[key];
    }
    /** @type {CompileContext['buffer']} */ function buffer() {
        buffers.push([]);
    }
    /** @type {CompileContext['resume']} */ function resume() {
        const buf = buffers.pop();
        return buf.join("");
    }
    /** @type {CompileContext['tag']} */ function tag(value) {
        if (!tags) return;
        setData("lastWasTag", true);
        buffers[buffers.length - 1].push(value);
    }
    /** @type {CompileContext['raw']} */ function raw(value) {
        setData("lastWasTag");
        buffers[buffers.length - 1].push(value);
    }
    /**
   * Output an extra line ending.
   *
   * @returns {undefined}
   */ function lineEnding() {
        raw(lineEndingStyle || "\n");
    }
    /** @type {CompileContext['lineEndingIfNeeded']} */ function lineEndingIfNeeded() {
        const buffer = buffers[buffers.length - 1];
        const slice = buffer[buffer.length - 1];
        const previous = slice ? slice.charCodeAt(slice.length - 1) : null;
        if (previous === 10 || previous === 13 || previous === null) return;
        lineEnding();
    }
    /** @type {CompileContext['encode']} */ function encode(value) {
        return getData("ignoreEncode") ? value : (0, $c5c344bd342934a9$export$c564cdbbe6da493)(value);
    }
    //
    // Handlers.
    //
    /**
   * @returns {undefined}
   */ function onresumedrop() {
        resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ol");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistunordered(token) {
        tightStack.push(!token._loose);
        lineEndingIfNeeded();
        tag("<ul");
        setData("expectFirstItem", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (getData("expectFirstItem")) {
            const value = Number.parseInt(this.sliceSerialize(token), 10);
            if (value !== 1) tag(' start="' + encode(String(value)) + '"');
        }
    }
    /**
   * @returns {undefined}
   */ function onenterlistitemmarker() {
        if (getData("expectFirstItem")) tag(">");
        else onexitlistitem();
        lineEndingIfNeeded();
        tag("<li>");
        setData("expectFirstItem");
        // “Hack” to prevent a line ending from showing up if the item is empty.
        setData("lastWasTag");
    }
    /**
   * @returns {undefined}
   */ function onexitlistordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ol>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistunordered() {
        onexitlistitem();
        tightStack.pop();
        lineEnding();
        tag("</ul>");
    }
    /**
   * @returns {undefined}
   */ function onexitlistitem() {
        if (getData("lastWasTag") && !getData("slurpAllLineEndings")) lineEndingIfNeeded();
        tag("</li>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterblockquote() {
        tightStack.push(false);
        lineEndingIfNeeded();
        tag("<blockquote>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitblockquote() {
        tightStack.pop();
        lineEndingIfNeeded();
        tag("</blockquote>");
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterparagraph() {
        if (!tightStack[tightStack.length - 1]) {
            lineEndingIfNeeded();
            tag("<p>");
        }
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitparagraph() {
        if (tightStack[tightStack.length - 1]) setData("slurpAllLineEndings", true);
        else tag("</p>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodefenced() {
        lineEndingIfNeeded();
        tag("<pre><code");
        setData("fencesCount", 0);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const value = resume();
        tag(' class="language-' + value + '"');
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        const count = getData("fencesCount") || 0;
        if (!count) {
            tag(">");
            setData("slurpOneLineEnding", true);
        }
        setData("fencesCount", count + 1);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercodeindented() {
        lineEndingIfNeeded();
        tag("<pre><code>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitflowcode() {
        const count = getData("fencesCount");
        // One special case is if we are inside a container, and the fenced code was
        // not closed (meaning it runs to the end).
        // In that case, the following line ending, is considered *outside* the
        // fenced code and block quote by micromark, but CM wants to treat that
        // ending as part of the code.
        if (count !== undefined && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) lineEnding();
        // But in most cases, it’s simpler: when we’ve seen some data, emit an extra
        // line ending when needed.
        if (getData("flowCodeSeenData")) lineEndingIfNeeded();
        tag("</code></pre>");
        if (count !== undefined && count < 2) lineEndingIfNeeded();
        setData("flowCodeSeenData");
        setData("fencesCount");
        setData("slurpOneLineEnding");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterimage() {
        mediaStack.push({
            image: true
        });
        tags = undefined // Disallow tags.
        ;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlink() {
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        mediaStack[mediaStack.length - 1].label = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresource() {
        buffer() // We can have line endings in the resource, ignore them.
        ;
        mediaStack[mediaStack.length - 1].destination = "";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterresourcedestinationstring() {
        buffer();
        // Ignore encoding the result, as we’ll first percent encode the url and
        // encode manually after.
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitmedia() {
        let index = mediaStack.length - 1 // Skip current.
        ;
        const media = mediaStack[index];
        const id = media.referenceId || media.labelId;
        const context = media.destination === undefined ? definitions[(0, $8900bf1e9be862c4$export$806d55e226cfcd08)(id)] : media;
        tags = true;
        while(index--)if (mediaStack[index].image) {
            tags = undefined;
            break;
        }
        if (media.image) {
            tag('<img src="' + (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $c56b064c2cb3718f$var$protocolSrc) + '" alt="');
            raw(media.label);
            tag('"');
        } else tag('<a href="' + (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(context.destination, settings.allowDangerousProtocol ? undefined : $c56b064c2cb3718f$var$protocolHref) + '"');
        tag(context.title ? ' title="' + context.title + '"' : "");
        if (media.image) tag(" />");
        else {
            tag(">");
            raw(media.label);
            tag("</a>");
        }
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinition() {
        buffer();
        mediaStack.push({});
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        // Discard label, use the source content instead.
        resume();
        mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdefinitiondestinationstring() {
        buffer();
        setData("ignoreEncode", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        mediaStack[mediaStack.length - 1].destination = resume();
        setData("ignoreEncode");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        mediaStack[mediaStack.length - 1].title = resume();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinition() {
        const media = mediaStack[mediaStack.length - 1];
        const id = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(media.labelId);
        resume();
        if (!$c56b064c2cb3718f$var$hasOwnProperty.call(definitions, id)) definitions[id] = mediaStack[mediaStack.length - 1];
        mediaStack.pop();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentercontent() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        // Exit for further sequences.
        if (getData("headingRank")) return;
        setData("headingRank", this.sliceSerialize(token).length);
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onentersetextheading() {
        buffer();
        setData("slurpAllLineEndings");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        setData("slurpAllLineEndings", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheading() {
        tag("</h" + getData("headingRank") + ">");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        const value = resume();
        lineEndingIfNeeded();
        tag("<h" + getData("headingRank") + ">");
        raw(value);
        tag("</h" + getData("headingRank") + ">");
        setData("slurpAllLineEndings");
        setData("headingRank");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        if (getData("slurpAllLineEndings")) return;
        if (getData("slurpOneLineEnding")) {
            setData("slurpOneLineEnding");
            return;
        }
        if (getData("inCodeText")) {
            raw(" ");
            return;
        }
        raw(encode(this.sliceSerialize(token)));
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeflowvalue(token) {
        raw(encode(this.sliceSerialize(token)));
        setData("flowCodeSeenData", true);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        tag("<br />");
    }
    /**
   * @returns {undefined}
   */ function onenterhtmlflow() {
        lineEndingIfNeeded();
        onenterhtml();
    }
    /**
   * @returns {undefined}
   */ function onexithtml() {
        setData("ignoreEncode");
    }
    /**
   * @returns {undefined}
   */ function onenterhtml() {
        if (settings.allowDangerousHtml) setData("ignoreEncode", true);
    }
    /**
   * @returns {undefined}
   */ function onenteremphasis() {
        tag("<em>");
    }
    /**
   * @returns {undefined}
   */ function onenterstrong() {
        tag("<strong>");
    }
    /**
   * @returns {undefined}
   */ function onentercodetext() {
        setData("inCodeText", true);
        tag("<code>");
    }
    /**
   * @returns {undefined}
   */ function onexitcodetext() {
        setData("inCodeText");
        tag("</code>");
    }
    /**
   * @returns {undefined}
   */ function onexitemphasis() {
        tag("</em>");
    }
    /**
   * @returns {undefined}
   */ function onexitstrong() {
        tag("</strong>");
    }
    /**
   * @returns {undefined}
   */ function onexitthematicbreak() {
        lineEndingIfNeeded();
        tag("<hr />");
    }
    /**
   * @this {CompileContext}
   * @param {Token} token
   * @returns {undefined}
   */ function onexitcharacterreferencemarker(token) {
        setData("characterReferenceType", token.type);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        let value = this.sliceSerialize(token);
        // @ts-expect-error `decodeNamedCharacterReference` can return false for
        // invalid named character references, but everything we’ve tokenized is
        // valid.
        value = getData("characterReferenceType") ? (0, $de6a351f52b69b30$export$15a69557afac2c20)(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : (0, $04b95225700f8616$export$289b6a6320f709b4)(value);
        raw(encode(value));
        setData("characterReferenceType");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(uri, settings.allowDangerousProtocol ? undefined : $c56b064c2cb3718f$var$protocolHref) + '">');
        raw(encode(uri));
        tag("</a>");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        const uri = this.sliceSerialize(token);
        tag('<a href="' + (0, $e133dd0f2d166be7$export$d130a2d684099e5a)("mailto:" + uri) + '">');
        raw(encode(uri));
        tag("</a>");
    }
}


/**
 * @typedef {import('micromark-util-types').Create} Create
 * @typedef {import('micromark-util-types').FullNormalizedExtension} FullNormalizedExtension
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').ParseOptions} ParseOptions
 */ 
/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $d7969320ccc069d2$export$ae105c1eb063a0a2(effects, ok, type, max) {
    const limit = max ? max - 1 : Number.POSITIVE_INFINITY;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.enter(type);
            return prefix(code);
        }
        return ok(code);
    }
    /** @type {State} */ function prefix(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) && size++ < limit) {
            effects.consume(code);
            return prefix;
        }
        effects.exit(type);
        return ok(code);
    }
}



const $a2fbc673d13ffc29$export$a7db06668cad9adb = {
    tokenize: $a2fbc673d13ffc29$var$initializeContent
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $a2fbc673d13ffc29$var$initializeContent(effects) {
    const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
    /** @type {Token} */ let previous;
    return contentStart;
    /** @type {State} */ function afterContentStartConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, contentStart, "linePrefix");
    }
    /** @type {State} */ function paragraphInitial(code) {
        effects.enter("paragraph");
        return lineStart(code);
    }
    /** @type {State} */ function lineStart(code) {
        const token = effects.enter("chunkText", {
            contentType: "text",
            previous: previous
        });
        if (previous) previous.next = token;
        previous = token;
        return data(code);
    }
    /** @type {State} */ function data(code) {
        if (code === null) {
            effects.exit("chunkText");
            effects.exit("paragraph");
            effects.consume(code);
            return;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            effects.exit("chunkText");
            return lineStart;
        }
        // Data.
        effects.consume(code);
        return data;
    }
}


/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[Construct, ContainerState]} StackItem
 */ 


const $6728e34912905e82$export$5a7bfc01df82fcd1 = {
    tokenize: $6728e34912905e82$var$initializeDocument
};
/** @type {Construct} */ const $6728e34912905e82$var$containerConstruct = {
    tokenize: $6728e34912905e82$var$tokenizeContainer
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $6728e34912905e82$var$initializeDocument(effects) {
    const self = this;
    /** @type {Array<StackItem>} */ const stack = [];
    let continued = 0;
    /** @type {TokenizeContext | undefined} */ let childFlow;
    /** @type {Token | undefined} */ let childToken;
    /** @type {number} */ let lineStartOffset;
    return start;
    /** @type {State} */ function start(code) {
        // First we iterate through the open blocks, starting with the root
        // document, and descending through last children down to the last open
        // block.
        // Each block imposes a condition that the line must satisfy if the block is
        // to remain open.
        // For example, a block quote requires a `>` character.
        // A paragraph requires a non-blank line.
        // In this phase we may match all or just some of the open blocks.
        // But we cannot close unmatched blocks yet, because we may have a lazy
        // continuation line.
        if (continued < stack.length) {
            const item = stack[continued];
            self.containerState = item[1];
            return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code);
        }
        // Done.
        return checkNewContainers(code);
    }
    /** @type {State} */ function documentContinue(code) {
        continued++;
        // Note: this field is called `_closeFlow` but it also closes containers.
        // Perhaps a good idea to rename it but it’s already used in the wild by
        // extensions.
        if (self.containerState._closeFlow) {
            self.containerState._closeFlow = undefined;
            if (childFlow) closeFlow();
            // Note: this algorithm for moving events around is similar to the
            // algorithm when dealing with lazy lines in `writeToChild`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {Point | undefined} */ let point;
            // Find the flow chunk.
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                point = self.events[indexBeforeFlow][1].end;
                break;
            }
            exitContainers(continued);
            // Fix positions.
            let index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $5720affce988170b$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
            return checkNewContainers(code);
        }
        return start(code);
    }
    /** @type {State} */ function checkNewContainers(code) {
        // Next, after consuming the continuation markers for existing blocks, we
        // look for new block starts (e.g. `>` for a block quote).
        // If we encounter a new block start, we close any blocks unmatched in
        // step 1 before creating the new block as a child of the last matched
        // block.
        if (continued === stack.length) {
            // No need to `check` whether there’s a container, of `exitContainers`
            // would be moot.
            // We can instead immediately `attempt` to parse one.
            if (!childFlow) return documentContinued(code);
            // If we have concrete content, such as block HTML or fenced code,
            // we can’t have containers “pierce” into them, so we can immediately
            // start.
            if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) return flowStart(code);
            // If we do have flow, it could still be a blank line,
            // but we’d be interrupting it w/ a new container if there’s a current
            // construct.
            // To do: next major: remove `_gfmTableDynamicInterruptHack` (no longer
            // needed in micromark-extension-gfm-table@1.0.6).
            self.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
        }
        // Check if there is a new container.
        self.containerState = {};
        return effects.check($6728e34912905e82$var$containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code);
    }
    /** @type {State} */ function thereIsANewContainer(code) {
        if (childFlow) closeFlow();
        exitContainers(continued);
        return documentContinued(code);
    }
    /** @type {State} */ function thereIsNoNewContainer(code) {
        self.parser.lazy[self.now().line] = continued !== stack.length;
        lineStartOffset = self.now().offset;
        return flowStart(code);
    }
    /** @type {State} */ function documentContinued(code) {
        // Try new containers.
        self.containerState = {};
        return effects.attempt($6728e34912905e82$var$containerConstruct, containerContinue, flowStart)(code);
    }
    /** @type {State} */ function containerContinue(code) {
        continued++;
        stack.push([
            self.currentConstruct,
            self.containerState
        ]);
        // Try another.
        return documentContinued(code);
    }
    /** @type {State} */ function flowStart(code) {
        if (code === null) {
            if (childFlow) closeFlow();
            exitContainers(0);
            effects.consume(code);
            return;
        }
        childFlow = childFlow || self.parser.flow(self.now());
        effects.enter("chunkFlow", {
            contentType: "flow",
            previous: childToken,
            _tokenizer: childFlow
        });
        return flowContinue(code);
    }
    /** @type {State} */ function flowContinue(code) {
        if (code === null) {
            writeToChild(effects.exit("chunkFlow"), true);
            exitContainers(0);
            effects.consume(code);
            return;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.consume(code);
            writeToChild(effects.exit("chunkFlow"));
            // Get ready for the next line.
            continued = 0;
            self.interrupt = undefined;
            return start;
        }
        effects.consume(code);
        return flowContinue;
    }
    /**
   * @param {Token} token
   * @param {boolean | undefined} [eof]
   * @returns {undefined}
   */ function writeToChild(token, eof) {
        const stream = self.sliceStream(token);
        if (eof) stream.push(null);
        token.previous = childToken;
        if (childToken) childToken.next = token;
        childToken = token;
        childFlow.defineSkip(token.start);
        childFlow.write(stream);
        // Alright, so we just added a lazy line:
        //
        // ```markdown
        // > a
        // b.
        //
        // Or:
        //
        // > ~~~c
        // d
        //
        // Or:
        //
        // > | e |
        // f
        // ```
        //
        // The construct in the second example (fenced code) does not accept lazy
        // lines, so it marked itself as done at the end of its first line, and
        // then the content construct parses `d`.
        // Most constructs in markdown match on the first line: if the first line
        // forms a construct, a non-lazy line can’t “unmake” it.
        //
        // The construct in the third example is potentially a GFM table, and
        // those are *weird*.
        // It *could* be a table, from the first line, if the following line
        // matches a condition.
        // In this case, that second line is lazy, which “unmakes” the first line
        // and turns the whole into one content block.
        //
        // We’ve now parsed the non-lazy and the lazy line, and can figure out
        // whether the lazy line started a new flow block.
        // If it did, we exit the current containers between the two flow blocks.
        if (self.parser.lazy[token.start.line]) {
            let index = childFlow.events.length;
            while(index--){
                if (// The token starts before the line ending…
                childFlow.events[index][1].start.offset < lineStartOffset && // …and either is not ended yet…
                (!childFlow.events[index][1].end || // …or ends after it.
                childFlow.events[index][1].end.offset > lineStartOffset)) // Exit: there’s still something open, which means it’s a lazy line
                // part of something.
                return;
            }
            // Note: this algorithm for moving events around is similar to the
            // algorithm when closing flow in `documentContinue`.
            const indexBeforeExits = self.events.length;
            let indexBeforeFlow = indexBeforeExits;
            /** @type {boolean | undefined} */ let seen;
            /** @type {Point | undefined} */ let point;
            // Find the previous chunk (the one before the lazy line).
            while(indexBeforeFlow--)if (self.events[indexBeforeFlow][0] === "exit" && self.events[indexBeforeFlow][1].type === "chunkFlow") {
                if (seen) {
                    point = self.events[indexBeforeFlow][1].end;
                    break;
                }
                seen = true;
            }
            exitContainers(continued);
            // Fix positions.
            index = indexBeforeExits;
            while(index < self.events.length){
                self.events[index][1].end = Object.assign({}, point);
                index++;
            }
            // Inject the exits earlier (they’re still also at the end).
            (0, $5720affce988170b$export$869882364835d202)(self.events, indexBeforeFlow + 1, 0, self.events.slice(indexBeforeExits));
            // Discard the duplicate exits.
            self.events.length = index;
        }
    }
    /**
   * @param {number} size
   * @returns {undefined}
   */ function exitContainers(size) {
        let index = stack.length;
        // Exit open containers.
        while(index-- > size){
            const entry = stack[index];
            self.containerState = entry[1];
            entry[0].exit.call(self, effects);
        }
        stack.length = size;
    }
    function closeFlow() {
        childFlow.write([
            null
        ]);
        childToken = undefined;
        childFlow = undefined;
        self.containerState._closeFlow = undefined;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6728e34912905e82$var$tokenizeContainer(effects, ok, nok) {
    // Always populated by defaults.
    return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.document, ok, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4);
}


/**
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $6462050da1e6035a$export$d50d28ce3ab2a612 = {
    tokenize: $6462050da1e6035a$var$tokenizeBlankLine,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $6462050da1e6035a$var$tokenizeBlankLine(effects, ok, nok) {
    return start;
    /**
   * Start of blank line.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *     ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, after, "linePrefix")(code) : after(code);
    }
    /**
   * At eof/eol, after optional whitespace.
   *
   * > 👉 **Note**: `␠` represents a space character.
   *
   * ```markdown
   * > | ␠␠␊
   *       ^
   * > | ␊
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $32a1128000851050$export$12949d1dd00fddf4(events) {
    /** @type {Record<string, number>} */ const jumps = {};
    let index = -1;
    /** @type {Event} */ let event;
    /** @type {number | undefined} */ let lineIndex;
    /** @type {number} */ let otherIndex;
    /** @type {Event} */ let otherEvent;
    /** @type {Array<Event>} */ let parameters;
    /** @type {Array<Event>} */ let subevents;
    /** @type {boolean | undefined} */ let more;
    while(++index < events.length){
        while(index in jumps)index = jumps[index];
        event = events[index];
        // Add a hook for the GFM tasklist extension, which needs to know if text
        // is in the first content of a list item.
        if (index && event[1].type === "chunkFlow" && events[index - 1][1].type === "listItemPrefix") {
            subevents = event[1]._tokenizer.events;
            otherIndex = 0;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") otherIndex += 2;
            if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") while(++otherIndex < subevents.length){
                if (subevents[otherIndex][1].type === "content") break;
                if (subevents[otherIndex][1].type === "chunkText") {
                    subevents[otherIndex][1]._isInFirstContentOfListItem = true;
                    otherIndex++;
                }
            }
        }
        // Enter.
        if (event[0] === "enter") {
            if (event[1].contentType) {
                Object.assign(jumps, $32a1128000851050$var$subcontent(events, index));
                index = jumps[index];
                more = true;
            }
        } else if (event[1]._container) {
            otherIndex = index;
            lineIndex = undefined;
            while(otherIndex--){
                otherEvent = events[otherIndex];
                if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
                    if (otherEvent[0] === "enter") {
                        if (lineIndex) events[lineIndex][1].type = "lineEndingBlank";
                        otherEvent[1].type = "lineEnding";
                        lineIndex = otherIndex;
                    }
                } else break;
            }
            if (lineIndex) {
                // Fix position.
                event[1].end = Object.assign({}, events[lineIndex][1].start);
                // Switch container exit w/ line endings.
                parameters = events.slice(lineIndex, index);
                parameters.unshift(event);
                (0, $5720affce988170b$export$869882364835d202)(events, lineIndex, index - lineIndex + 1, parameters);
            }
        }
    }
    return !more;
}
/**
 * Tokenize embedded tokens.
 *
 * @param {Array<Event>} events
 * @param {number} eventIndex
 * @returns {Record<string, number>}
 */ function $32a1128000851050$var$subcontent(events, eventIndex) {
    const token = events[eventIndex][1];
    const context = events[eventIndex][2];
    let startPosition = eventIndex - 1;
    /** @type {Array<number>} */ const startPositions = [];
    const tokenizer = token._tokenizer || context.parser[token.contentType](token.start);
    const childEvents = tokenizer.events;
    /** @type {Array<[number, number]>} */ const jumps = [];
    /** @type {Record<string, number>} */ const gaps = {};
    /** @type {Array<Chunk>} */ let stream;
    /** @type {Token | undefined} */ let previous;
    let index = -1;
    /** @type {Token | undefined} */ let current = token;
    let adjust = 0;
    let start = 0;
    const breaks = [
        start
    ];
    // Loop forward through the linked tokens to pass them in order to the
    // subtokenizer.
    while(current){
        // Find the position of the event for this token.
        while(events[++startPosition][1] !== current);
        startPositions.push(startPosition);
        if (!current._tokenizer) {
            stream = context.sliceStream(current);
            if (!current.next) stream.push(null);
            if (previous) tokenizer.defineSkip(current.start);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = true;
            tokenizer.write(stream);
            if (current._isInFirstContentOfListItem) tokenizer._gfmTasklistFirstContentOfListItem = undefined;
        }
        // Unravel the next token.
        previous = current;
        current = current.next;
    }
    // Now, loop back through all events (and linked tokens), to figure out which
    // parts belong where.
    current = token;
    while(++index < childEvents.length)if (// Find a void token that includes a break.
    childEvents[index][0] === "exit" && childEvents[index - 1][0] === "enter" && childEvents[index][1].type === childEvents[index - 1][1].type && childEvents[index][1].start.line !== childEvents[index][1].end.line) {
        start = index + 1;
        breaks.push(start);
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
        current = current.next;
    }
    // Help GC.
    tokenizer.events = [];
    // If there’s one more token (which is the cases for lines that end in an
    // EOF), that’s perfect: the last point we found starts it.
    // If there isn’t then make sure any remaining content is added to it.
    if (current) {
        // Help GC.
        current._tokenizer = undefined;
        current.previous = undefined;
    } else breaks.pop();
    // Now splice the events from the subtokenizer into the current events,
    // moving back to front so that splice indices aren’t affected.
    index = breaks.length;
    while(index--){
        const slice = childEvents.slice(breaks[index], breaks[index + 1]);
        const start = startPositions.pop();
        jumps.unshift([
            start,
            start + slice.length - 1
        ]);
        (0, $5720affce988170b$export$869882364835d202)(events, start, 2, slice);
    }
    index = -1;
    while(++index < jumps.length){
        gaps[adjust + jumps[index][0]] = adjust + jumps[index][1];
        adjust += jumps[index][1] - jumps[index][0] - 1;
    }
    return gaps;
}


const $273203efb61d18a7$export$a7db06668cad9adb = {
    tokenize: $273203efb61d18a7$var$tokenizeContent,
    resolve: $273203efb61d18a7$var$resolveContent
};
/** @type {Construct} */ const $273203efb61d18a7$var$continuationConstruct = {
    tokenize: $273203efb61d18a7$var$tokenizeContinuation,
    partial: true
};
/**
 * Content is transparent: it’s parsed right now. That way, definitions are also
 * parsed right now: before text in paragraphs (specifically, media) are parsed.
 *
 * @type {Resolver}
 */ function $273203efb61d18a7$var$resolveContent(events) {
    (0, $32a1128000851050$export$12949d1dd00fddf4)(events);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $273203efb61d18a7$var$tokenizeContent(effects, ok) {
    /** @type {Token | undefined} */ let previous;
    return chunkStart;
    /**
   * Before a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^
   * ```
   *
   * @type {State}
   */ function chunkStart(code) {
        effects.enter("content");
        previous = effects.enter("chunkContent", {
            contentType: "content"
        });
        return chunkInside(code);
    }
    /**
   * In a content chunk.
   *
   * ```markdown
   * > | abc
   *     ^^^
   * ```
   *
   * @type {State}
   */ function chunkInside(code) {
        if (code === null) return contentEnd(code);
        // To do: in `markdown-rs`, each line is parsed on its own, and everything
        // is stitched together resolving.
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return effects.check($273203efb61d18a7$var$continuationConstruct, contentContinue, contentEnd)(code);
        // Data.
        effects.consume(code);
        return chunkInside;
    }
    /**
   *
   *
   * @type {State}
   */ function contentEnd(code) {
        effects.exit("chunkContent");
        effects.exit("content");
        return ok(code);
    }
    /**
   *
   *
   * @type {State}
   */ function contentContinue(code) {
        effects.consume(code);
        effects.exit("chunkContent");
        previous.next = effects.enter("chunkContent", {
            contentType: "content",
            previous: previous
        });
        previous = previous.next;
        return chunkInside;
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $273203efb61d18a7$var$tokenizeContinuation(effects, ok, nok) {
    const self = this;
    return startLookahead;
    /**
   *
   *
   * @type {State}
   */ function startLookahead(code) {
        effects.exit("chunkContent");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, prefixed, "linePrefix");
    }
    /**
   *
   *
   * @type {State}
   */ function prefixed(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return nok(code);
        // Always populated by defaults.
        const tail = self.events[self.events.length - 1];
        if (!self.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) return ok(code);
        return effects.interrupt(self.parser.constructs.flow, nok, ok)(code);
    }
}




const $136eeee8daab488e$export$ccc7b0636abaffc3 = {
    tokenize: $136eeee8daab488e$var$initializeFlow
};
/**
 * @this {TokenizeContext}
 * @type {Initializer}
 */ function $136eeee8daab488e$var$initializeFlow(effects) {
    const self = this;
    const initial = effects.attempt(// Try to parse a blank line.
    (0, $6462050da1e6035a$export$d50d28ce3ab2a612), atBlankEnding, // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt((0, $273203efb61d18a7$export$a7db06668cad9adb), afterConstruct)), "linePrefix")));
    return initial;
    /** @type {State} */ function atBlankEnding(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEndingBlank");
        effects.consume(code);
        effects.exit("lineEndingBlank");
        self.currentConstruct = undefined;
        return initial;
    }
    /** @type {State} */ function afterConstruct(code) {
        if (code === null) {
            effects.consume(code);
            return;
        }
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        self.currentConstruct = undefined;
        return initial;
    }
}


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').Initializer} Initializer
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ const $cb6447d82e9d703c$export$50397835cbfdbc24 = {
    resolveAll: $cb6447d82e9d703c$var$createResolver()
};
const $cb6447d82e9d703c$export$22b082955e083ec3 = $cb6447d82e9d703c$var$initializeFactory("string");
const $cb6447d82e9d703c$export$6f093cfa640b7166 = $cb6447d82e9d703c$var$initializeFactory("text");
/**
 * @param {'string' | 'text'} field
 * @returns {InitialConstruct}
 */ function $cb6447d82e9d703c$var$initializeFactory(field) {
    return {
        tokenize: initializeText,
        resolveAll: $cb6447d82e9d703c$var$createResolver(field === "text" ? $cb6447d82e9d703c$var$resolveAllLineSuffixes : undefined)
    };
    /**
   * @this {TokenizeContext}
   * @type {Initializer}
   */ function initializeText(effects) {
        const self = this;
        const constructs = this.parser.constructs[field];
        const text = effects.attempt(constructs, start, notText);
        return start;
        /** @type {State} */ function start(code) {
            return atBreak(code) ? text(code) : notText(code);
        }
        /** @type {State} */ function notText(code) {
            if (code === null) {
                effects.consume(code);
                return;
            }
            effects.enter("data");
            effects.consume(code);
            return data;
        }
        /** @type {State} */ function data(code) {
            if (atBreak(code)) {
                effects.exit("data");
                return text(code);
            }
            // Data.
            effects.consume(code);
            return data;
        }
        /**
     * @param {Code} code
     * @returns {boolean}
     */ function atBreak(code) {
            if (code === null) return true;
            const list = constructs[code];
            let index = -1;
            if (list) // Always populated by defaults.
            while(++index < list.length){
                const item = list[index];
                if (!item.previous || item.previous.call(self, self.previous)) return true;
            }
            return false;
        }
    }
}
/**
 * @param {Resolver | undefined} [extraResolver]
 * @returns {Resolver}
 */ function $cb6447d82e9d703c$var$createResolver(extraResolver) {
    return resolveAllText;
    /** @type {Resolver} */ function resolveAllText(events, context) {
        let index = -1;
        /** @type {number | undefined} */ let enter;
        // A rather boring computation (to merge adjacent `data` events) which
        // improves mm performance by 29%.
        while(++index <= events.length){
            if (enter === undefined) {
                if (events[index] && events[index][1].type === "data") {
                    enter = index;
                    index++;
                }
            } else if (!events[index] || events[index][1].type !== "data") {
                // Don’t do anything if there is one data token.
                if (index !== enter + 2) {
                    events[enter][1].end = events[index - 1][1].end;
                    events.splice(enter + 2, index - enter - 2);
                    index = enter + 2;
                }
                enter = undefined;
            }
        }
        return extraResolver ? extraResolver(events, context) : events;
    }
}
/**
 * A rather ugly set of instructions which again looks at chunks in the input
 * stream.
 * The reason to do this here is that it is *much* faster to parse in reverse.
 * And that we can’t hook into `null` to split the line suffix before an EOF.
 * To do: figure out if we can make this into a clean utility, or even in core.
 * As it will be useful for GFMs literal autolink extension (and maybe even
 * tables?)
 *
 * @type {Resolver}
 */ function $cb6447d82e9d703c$var$resolveAllLineSuffixes(events, context) {
    let eventIndex = 0 // Skip first.
    ;
    while(++eventIndex <= events.length)if ((eventIndex === events.length || events[eventIndex][1].type === "lineEnding") && events[eventIndex - 1][1].type === "data") {
        const data = events[eventIndex - 1][1];
        const chunks = context.sliceStream(data);
        let index = chunks.length;
        let bufferIndex = -1;
        let size = 0;
        /** @type {boolean | undefined} */ let tabs;
        while(index--){
            const chunk = chunks[index];
            if (typeof chunk === "string") {
                bufferIndex = chunk.length;
                while(chunk.charCodeAt(bufferIndex - 1) === 32){
                    size++;
                    bufferIndex--;
                }
                if (bufferIndex) break;
                bufferIndex = -1;
            } else if (chunk === -2) {
                tabs = true;
                size++;
            } else if (chunk === -1) ;
            else {
                // Replacement character, exit.
                index++;
                break;
            }
        }
        if (size) {
            const token = {
                type: eventIndex === events.length || tabs || size < 2 ? "lineSuffix" : "hardBreakTrailing",
                start: {
                    line: data.end.line,
                    column: data.end.column - size,
                    offset: data.end.offset - size,
                    _index: data.start._index + index,
                    _bufferIndex: index ? bufferIndex : data.start._bufferIndex + bufferIndex
                },
                end: Object.assign({}, data.end)
            };
            data.end = Object.assign({}, token.start);
            if (data.start.offset === data.end.offset) Object.assign(data, token);
            else {
                events.splice(eventIndex, 0, [
                    "enter",
                    token,
                    context
                ], [
                    "exit",
                    token,
                    context
                ]);
                eventIndex += 2;
            }
        }
        eventIndex++;
    }
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').InitialConstruct} InitialConstruct
 * @typedef {import('micromark-util-types').ParseContext} ParseContext
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenType} TokenType
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * @callback Restore
 * @returns {undefined}
 *
 * @typedef Info
 * @property {Restore} restore
 * @property {number} from
 *
 * @callback ReturnHandle
 *   Handle a successful run.
 * @param {Construct} construct
 * @param {Info} info
 * @returns {undefined}
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 */ /**
 * Call all `resolveAll`s.
 *
 * @param {Array<{resolveAll?: Resolver | undefined}>} constructs
 *   List of constructs, optionally with `resolveAll`s.
 * @param {Array<Event>} events
 *   List of events.
 * @param {TokenizeContext} context
 *   Context used by `tokenize`.
 * @returns {Array<Event>}
 *   Changed events.
 */ function $ff8c7b537158f4c7$export$3ff61ec196ff408b(constructs, events, context) {
    /** @type {Array<Resolver>} */ const called = [];
    let index = -1;
    while(++index < constructs.length){
        const resolve = constructs[index].resolveAll;
        if (resolve && !called.includes(resolve)) {
            events = resolve(events, context);
            called.push(resolve);
        }
    }
    return events;
}


function $97f7327678708c2e$export$ae34f10ee4b29837(parser, initialize, from) {
    /** @type {Point} */ let point = Object.assign(from ? Object.assign({}, from) : {
        line: 1,
        column: 1,
        offset: 0
    }, {
        _index: 0,
        _bufferIndex: -1
    });
    /** @type {Record<string, number>} */ const columnStart = {};
    /** @type {Array<Construct>} */ const resolveAllConstructs = [];
    /** @type {Array<Chunk>} */ let chunks = [];
    /** @type {Array<Token>} */ let stack = [];
    /** @type {boolean | undefined} */ let consumed = true;
    /**
   * Tools used for tokenizing.
   *
   * @type {Effects}
   */ const effects = {
        consume: consume,
        enter: enter,
        exit: exit,
        attempt: constructFactory(onsuccessfulconstruct),
        check: constructFactory(onsuccessfulcheck),
        interrupt: constructFactory(onsuccessfulcheck, {
            interrupt: true
        })
    };
    /**
   * State and tools for resolving and serializing.
   *
   * @type {TokenizeContext}
   */ const context = {
        previous: null,
        code: null,
        containerState: {},
        events: [],
        parser: parser,
        sliceStream: sliceStream,
        sliceSerialize: sliceSerialize,
        now: now,
        defineSkip: defineSkip,
        write: write
    };
    /**
   * The state function.
   *
   * @type {State | undefined}
   */ let state = initialize.tokenize.call(context, effects);
    /**
   * Track which character we expect to be consumed, to catch bugs.
   *
   * @type {Code}
   */ let expectedCode;
    if (initialize.resolveAll) resolveAllConstructs.push(initialize);
    return context;
    /** @type {TokenizeContext['write']} */ function write(slice) {
        chunks = (0, $5720affce988170b$export$4cbf152802aa238)(chunks, slice);
        main();
        // Exit if we’re not done, resolve might change stuff.
        if (chunks[chunks.length - 1] !== null) return [];
        addResult(initialize, 0);
        // Otherwise, resolve, and exit.
        context.events = (0, $ff8c7b537158f4c7$export$3ff61ec196ff408b)(resolveAllConstructs, context.events, context);
        return context.events;
    }
    //
    // Tools.
    //
    /** @type {TokenizeContext['sliceSerialize']} */ function sliceSerialize(token, expandTabs) {
        return $97f7327678708c2e$var$serializeChunks(sliceStream(token), expandTabs);
    }
    /** @type {TokenizeContext['sliceStream']} */ function sliceStream(token) {
        return $97f7327678708c2e$var$sliceChunks(chunks, token);
    }
    /** @type {TokenizeContext['now']} */ function now() {
        // This is a hot path, so we clone manually instead of `Object.assign({}, point)`
        const { line: line, column: column, offset: offset, _index: _index, _bufferIndex: _bufferIndex } = point;
        return {
            line: line,
            column: column,
            offset: offset,
            _index: _index,
            _bufferIndex: _bufferIndex
        };
    }
    /** @type {TokenizeContext['defineSkip']} */ function defineSkip(value) {
        columnStart[value.line] = value.column;
        accountForPotentialSkip();
    }
    //
    // State management.
    //
    /**
   * Main loop (note that `_index` and `_bufferIndex` in `point` are modified by
   * `consume`).
   * Here is where we walk through the chunks, which either include strings of
   * several characters, or numerical character codes.
   * The reason to do this in a loop instead of a call is so the stack can
   * drain.
   *
   * @returns {undefined}
   */ function main() {
        /** @type {number} */ let chunkIndex;
        while(point._index < chunks.length){
            const chunk = chunks[point._index];
            // If we’re in a buffer chunk, loop through it.
            if (typeof chunk === "string") {
                chunkIndex = point._index;
                if (point._bufferIndex < 0) point._bufferIndex = 0;
                while(point._index === chunkIndex && point._bufferIndex < chunk.length)go(chunk.charCodeAt(point._bufferIndex));
            } else go(chunk);
        }
    }
    /**
   * Deal with one code.
   *
   * @param {Code} code
   * @returns {undefined}
   */ function go(code) {
        consumed = undefined;
        expectedCode = code;
        state = state(code);
    }
    /** @type {Effects['consume']} */ function consume(code) {
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            point.line++;
            point.column = 1;
            point.offset += code === -3 ? 2 : 1;
            accountForPotentialSkip();
        } else if (code !== -1) {
            point.column++;
            point.offset++;
        }
        // Not in a string chunk.
        if (point._bufferIndex < 0) point._index++;
        else {
            point._bufferIndex++;
            // At end of string chunk.
            // @ts-expect-error Points w/ non-negative `_bufferIndex` reference
            // strings.
            if (point._bufferIndex === chunks[point._index].length) {
                point._bufferIndex = -1;
                point._index++;
            }
        }
        // Expose the previous character.
        context.previous = code;
        // Mark as consumed.
        consumed = true;
    }
    /** @type {Effects['enter']} */ function enter(type, fields) {
        /** @type {Token} */ // @ts-expect-error Patch instead of assign required fields to help GC.
        const token = fields || {};
        token.type = type;
        token.start = now();
        context.events.push([
            "enter",
            token,
            context
        ]);
        stack.push(token);
        return token;
    }
    /** @type {Effects['exit']} */ function exit(type) {
        const token = stack.pop();
        token.end = now();
        context.events.push([
            "exit",
            token,
            context
        ]);
        return token;
    }
    /**
   * Use results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulconstruct(construct, info) {
        addResult(construct, info.from);
    }
    /**
   * Discard results.
   *
   * @type {ReturnHandle}
   */ function onsuccessfulcheck(_, info) {
        info.restore();
    }
    /**
   * Factory to attempt/check/interrupt.
   *
   * @param {ReturnHandle} onreturn
   * @param {{interrupt?: boolean | undefined} | undefined} [fields]
   */ function constructFactory(onreturn, fields) {
        return hook;
        /**
     * Handle either an object mapping codes to constructs, a list of
     * constructs, or a single construct.
     *
     * @param {Array<Construct> | Construct | ConstructRecord} constructs
     * @param {State} returnState
     * @param {State | undefined} [bogusState]
     * @returns {State}
     */ function hook(constructs, returnState, bogusState) {
            /** @type {Array<Construct>} */ let listOfConstructs;
            /** @type {number} */ let constructIndex;
            /** @type {Construct} */ let currentConstruct;
            /** @type {Info} */ let info;
            return Array.isArray(constructs) ? handleListOfConstructs(constructs) : "tokenize" in constructs ? handleListOfConstructs([
                constructs
            ]) : handleMapOfConstructs(constructs);
            /**
       * Handle a list of construct.
       *
       * @param {ConstructRecord} map
       * @returns {State}
       */ function handleMapOfConstructs(map) {
                return start;
                /** @type {State} */ function start(code) {
                    const def = code !== null && map[code];
                    const all = code !== null && map.null;
                    const list = [
                        // To do: add more extension tests.
                        /* c8 ignore next 2 */ ...Array.isArray(def) ? def : def ? [
                            def
                        ] : [],
                        ...Array.isArray(all) ? all : all ? [
                            all
                        ] : []
                    ];
                    return handleListOfConstructs(list)(code);
                }
            }
            /**
       * Handle a list of construct.
       *
       * @param {Array<Construct>} list
       * @returns {State}
       */ function handleListOfConstructs(list) {
                listOfConstructs = list;
                constructIndex = 0;
                if (list.length === 0) return bogusState;
                return handleConstruct(list[constructIndex]);
            }
            /**
       * Handle a single construct.
       *
       * @param {Construct} construct
       * @returns {State}
       */ function handleConstruct(construct) {
                return start;
                /** @type {State} */ function start(code) {
                    // To do: not needed to store if there is no bogus state, probably?
                    // Currently doesn’t work because `inspect` in document does a check
                    // w/o a bogus, which doesn’t make sense. But it does seem to help perf
                    // by not storing.
                    info = store();
                    currentConstruct = construct;
                    if (!construct.partial) context.currentConstruct = construct;
                    // Always populated by defaults.
                    if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) return nok(code);
                    return construct.tokenize.call(// If we do have fields, create an object w/ `context` as its
                    // prototype.
                    // This allows a “live binding”, which is needed for `interrupt`.
                    fields ? Object.assign(Object.create(context), fields) : context, effects, ok, nok)(code);
                }
            }
            /** @type {State} */ function ok(code) {
                consumed = true;
                onreturn(currentConstruct, info);
                return returnState;
            }
            /** @type {State} */ function nok(code) {
                consumed = true;
                info.restore();
                if (++constructIndex < listOfConstructs.length) return handleConstruct(listOfConstructs[constructIndex]);
                return bogusState;
            }
        }
    }
    /**
   * @param {Construct} construct
   * @param {number} from
   * @returns {undefined}
   */ function addResult(construct, from) {
        if (construct.resolveAll && !resolveAllConstructs.includes(construct)) resolveAllConstructs.push(construct);
        if (construct.resolve) (0, $5720affce988170b$export$869882364835d202)(context.events, from, context.events.length - from, construct.resolve(context.events.slice(from), context));
        if (construct.resolveTo) context.events = construct.resolveTo(context.events, context);
    }
    /**
   * Store state.
   *
   * @returns {Info}
   */ function store() {
        const startPoint = now();
        const startPrevious = context.previous;
        const startCurrentConstruct = context.currentConstruct;
        const startEventsIndex = context.events.length;
        const startStack = Array.from(stack);
        return {
            restore: restore,
            from: startEventsIndex
        };
        /**
     * Restore state.
     *
     * @returns {undefined}
     */ function restore() {
            point = startPoint;
            context.previous = startPrevious;
            context.currentConstruct = startCurrentConstruct;
            context.events.length = startEventsIndex;
            stack = startStack;
            accountForPotentialSkip();
        }
    }
    /**
   * Move the current point a bit forward in the line when it’s on a column
   * skip.
   *
   * @returns {undefined}
   */ function accountForPotentialSkip() {
        if (point.line in columnStart && point.column < 2) {
            point.column = columnStart[point.line];
            point.offset += columnStart[point.line] - 1;
        }
    }
}
/**
 * Get the chunks from a slice of chunks in the range of a token.
 *
 * @param {Array<Chunk>} chunks
 * @param {Pick<Token, 'end' | 'start'>} token
 * @returns {Array<Chunk>}
 */ function $97f7327678708c2e$var$sliceChunks(chunks, token) {
    const startIndex = token.start._index;
    const startBufferIndex = token.start._bufferIndex;
    const endIndex = token.end._index;
    const endBufferIndex = token.end._bufferIndex;
    /** @type {Array<Chunk>} */ let view;
    if (startIndex === endIndex) // @ts-expect-error `_bufferIndex` is used on string chunks.
    view = [
        chunks[startIndex].slice(startBufferIndex, endBufferIndex)
    ];
    else {
        view = chunks.slice(startIndex, endIndex);
        if (startBufferIndex > -1) {
            const head = view[0];
            if (typeof head === "string") view[0] = head.slice(startBufferIndex);
            else view.shift();
        }
        if (endBufferIndex > 0) // @ts-expect-error `_bufferIndex` is used on string chunks.
        view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
    return view;
}
/**
 * Get the string value of a slice of chunks.
 *
 * @param {Array<Chunk>} chunks
 * @param {boolean | undefined} [expandTabs=false]
 * @returns {string}
 */ function $97f7327678708c2e$var$serializeChunks(chunks, expandTabs) {
    let index = -1;
    /** @type {Array<string>} */ const result = [];
    /** @type {boolean | undefined} */ let atTab;
    while(++index < chunks.length){
        const chunk = chunks[index];
        /** @type {string} */ let value;
        if (typeof chunk === "string") value = chunk;
        else switch(chunk){
            case -5:
                value = "\r";
                break;
            case -4:
                value = "\n";
                break;
            case -3:
                value = "\r\n";
                break;
            case -2:
                value = expandTabs ? " " : "	";
                break;
            case -1:
                if (!expandTabs && atTab) continue;
                value = " ";
                break;
            default:
                // Currently only replacement character.
                value = String.fromCharCode(chunk);
        }
        atTab = chunk === -2;
        result.push(value);
    }
    return result.join("");
}


var $ddaee6ba621e609d$exports = {};

$parcel$export($ddaee6ba621e609d$exports, "document", function () { return $ddaee6ba621e609d$export$5a7bfc01df82fcd1; });
$parcel$export($ddaee6ba621e609d$exports, "contentInitial", function () { return $ddaee6ba621e609d$export$5a2181fb44b58173; });
$parcel$export($ddaee6ba621e609d$exports, "flowInitial", function () { return $ddaee6ba621e609d$export$cf8bead395eff824; });
$parcel$export($ddaee6ba621e609d$exports, "flow", function () { return $ddaee6ba621e609d$export$ccc7b0636abaffc3; });
$parcel$export($ddaee6ba621e609d$exports, "string", function () { return $ddaee6ba621e609d$export$22b082955e083ec3; });
$parcel$export($ddaee6ba621e609d$exports, "text", function () { return $ddaee6ba621e609d$export$6f093cfa640b7166; });
$parcel$export($ddaee6ba621e609d$exports, "insideSpan", function () { return $ddaee6ba621e609d$export$d44f260a3f9b69f5; });
$parcel$export($ddaee6ba621e609d$exports, "attentionMarkers", function () { return $ddaee6ba621e609d$export$b9c0b60d74426aea; });
$parcel$export($ddaee6ba621e609d$exports, "disable", function () { return $ddaee6ba621e609d$export$e20fbacbb41798b; });
/**
 * @typedef {import('micromark-util-types').Extension} Extension
 */ /**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 */ 
function $884a47228e85f4cd$export$e3902bc0d835cad0(code) {
    if (code === null || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code)) return 1;
    if ((0, $b4c110780d01af5f$export$aa04114dd888a7a0)(code)) return 2;
}



const $7e72189b143d2036$export$45b92471da762af7 = {
    name: "attention",
    tokenize: $7e72189b143d2036$var$tokenizeAttention,
    resolveAll: $7e72189b143d2036$var$resolveAllAttention
};
/**
 * Take all events and resolve attention to emphasis or strong.
 *
 * @type {Resolver}
 */ // eslint-disable-next-line complexity
function $7e72189b143d2036$var$resolveAllAttention(events, context) {
    let index = -1;
    /** @type {number} */ let open;
    /** @type {Token} */ let group;
    /** @type {Token} */ let text;
    /** @type {Token} */ let openingSequence;
    /** @type {Token} */ let closingSequence;
    /** @type {number} */ let use;
    /** @type {Array<Event>} */ let nextEvents;
    /** @type {number} */ let offset;
    // Walk through all events.
    //
    // Note: performance of this is fine on an mb of normal markdown, but it’s
    // a bottleneck for malicious stuff.
    while(++index < events.length)// Find a token that can close.
    if (events[index][0] === "enter" && events[index][1].type === "attentionSequence" && events[index][1]._close) {
        open = index;
        // Now walk back to find an opener.
        while(open--)// Find a token that can open the closer.
        if (events[open][0] === "exit" && events[open][1].type === "attentionSequence" && events[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events[open][1]).charCodeAt(0) === context.sliceSerialize(events[index][1]).charCodeAt(0)) {
            // If the opening can close or the closing can open,
            // and the close size *is not* a multiple of three,
            // but the sum of the opening and closing size *is* multiple of three,
            // then don’t match.
            if ((events[open][1]._close || events[index][1]._open) && (events[index][1].end.offset - events[index][1].start.offset) % 3 && !((events[open][1].end.offset - events[open][1].start.offset + events[index][1].end.offset - events[index][1].start.offset) % 3)) continue;
            // Number of markers to use from the sequence.
            use = events[open][1].end.offset - events[open][1].start.offset > 1 && events[index][1].end.offset - events[index][1].start.offset > 1 ? 2 : 1;
            const start = Object.assign({}, events[open][1].end);
            const end = Object.assign({}, events[index][1].start);
            $7e72189b143d2036$var$movePoint(start, -use);
            $7e72189b143d2036$var$movePoint(end, use);
            openingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: start,
                end: Object.assign({}, events[open][1].end)
            };
            closingSequence = {
                type: use > 1 ? "strongSequence" : "emphasisSequence",
                start: Object.assign({}, events[index][1].start),
                end: end
            };
            text = {
                type: use > 1 ? "strongText" : "emphasisText",
                start: Object.assign({}, events[open][1].end),
                end: Object.assign({}, events[index][1].start)
            };
            group = {
                type: use > 1 ? "strong" : "emphasis",
                start: Object.assign({}, openingSequence.start),
                end: Object.assign({}, closingSequence.end)
            };
            events[open][1].end = Object.assign({}, openingSequence.start);
            events[index][1].start = Object.assign({}, closingSequence.end);
            nextEvents = [];
            // If there are more markers in the opening, add them before.
            if (events[open][1].end.offset - events[open][1].start.offset) nextEvents = (0, $5720affce988170b$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    events[open][1],
                    context
                ],
                [
                    "exit",
                    events[open][1],
                    context
                ]
            ]);
            // Opening.
            nextEvents = (0, $5720affce988170b$export$4cbf152802aa238)(nextEvents, [
                [
                    "enter",
                    group,
                    context
                ],
                [
                    "enter",
                    openingSequence,
                    context
                ],
                [
                    "exit",
                    openingSequence,
                    context
                ],
                [
                    "enter",
                    text,
                    context
                ]
            ]);
            // Always populated by defaults.
            // Between.
            nextEvents = (0, $5720affce988170b$export$4cbf152802aa238)(nextEvents, (0, $ff8c7b537158f4c7$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + 1, index), context));
            // Closing.
            nextEvents = (0, $5720affce988170b$export$4cbf152802aa238)(nextEvents, [
                [
                    "exit",
                    text,
                    context
                ],
                [
                    "enter",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    closingSequence,
                    context
                ],
                [
                    "exit",
                    group,
                    context
                ]
            ]);
            // If there are more markers in the closing, add them after.
            if (events[index][1].end.offset - events[index][1].start.offset) {
                offset = 2;
                nextEvents = (0, $5720affce988170b$export$4cbf152802aa238)(nextEvents, [
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ]
                ]);
            } else offset = 0;
            (0, $5720affce988170b$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
            index = open + nextEvents.length - offset - 2;
            break;
        }
    }
    // Remove remaining sequences.
    index = -1;
    while(++index < events.length)if (events[index][1].type === "attentionSequence") events[index][1].type = "data";
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $7e72189b143d2036$var$tokenizeAttention(effects, ok) {
    const attentionMarkers = this.parser.constructs.attentionMarkers.null;
    const previous = this.previous;
    const before = (0, $884a47228e85f4cd$export$e3902bc0d835cad0)(previous);
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Before a sequence.
   *
   * ```markdown
   * > | **
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        marker = code;
        effects.enter("attentionSequence");
        return inside(code);
    }
    /**
   * In a sequence.
   *
   * ```markdown
   * > | **
   *     ^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        const token = effects.exit("attentionSequence");
        // To do: next major: move this to resolver, just like `markdown-rs`.
        const after = (0, $884a47228e85f4cd$export$e3902bc0d835cad0)(code);
        // Always populated by defaults.
        const open = !after || after === 2 && before || attentionMarkers.includes(code);
        const close = !before || before === 2 && after || attentionMarkers.includes(previous);
        token._open = Boolean(marker === 42 ? open : open && (before || !close));
        token._close = Boolean(marker === 42 ? close : close && (after || !open));
        return ok(code);
    }
}
/**
 * Move a point a bit.
 *
 * Note: `move` only works inside lines! It’s not possible to move past other
 * chunks (replacement characters, tabs, or line endings).
 *
 * @param {Point} point
 * @param {number} offset
 * @returns {undefined}
 */ function $7e72189b143d2036$var$movePoint(point, offset) {
    point.column += offset;
    point.offset += offset;
    point._bufferIndex += offset;
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $733e76032c6978d4$export$17ddf85e4c916ad6 = {
    name: "autolink",
    tokenize: $733e76032c6978d4$var$tokenizeAutolink
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $733e76032c6978d4$var$tokenizeAutolink(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of an autolink.
   *
   * ```markdown
   * > | a<https://example.com>b
   *      ^
   * > | a<user@example.com>b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("autolink");
        effects.enter("autolinkMarker");
        effects.consume(code);
        effects.exit("autolinkMarker");
        effects.enter("autolinkProtocol");
        return open;
    }
    /**
   * After `<`, at protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *       ^
   * > | a<user@example.com>b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return schemeOrEmailAtext;
        }
        return emailAtext(code);
    }
    /**
   * At second byte of protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeOrEmailAtext(code) {
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if (code === 43 || code === 45 || code === 46 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            // Count the previous alphabetical from `open` too.
            size = 1;
            return schemeInsideOrEmailAtext(code);
        }
        return emailAtext(code);
    }
    /**
   * In ambiguous protocol or atext.
   *
   * ```markdown
   * > | a<https://example.com>b
   *        ^
   * > | a<user@example.com>b
   *        ^
   * ```
   *
   * @type {State}
   */ function schemeInsideOrEmailAtext(code) {
        if (code === 58) {
            effects.consume(code);
            size = 0;
            return urlInside;
        }
        // ASCII alphanumeric and `+`, `-`, and `.`.
        if ((code === 43 || code === 45 || code === 46 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) && size++ < 32) {
            effects.consume(code);
            return schemeInsideOrEmailAtext;
        }
        size = 0;
        return emailAtext(code);
    }
    /**
   * After protocol, in URL.
   *
   * ```markdown
   * > | a<https://example.com>b
   *             ^
   * ```
   *
   * @type {State}
   */ function urlInside(code) {
        if (code === 62) {
            effects.exit("autolinkProtocol");
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        // ASCII control, space, or `<`.
        if (code === null || code === 32 || code === 60 || (0, $b4c110780d01af5f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return urlInside;
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *              ^
   * ```
   *
   * @type {State}
   */ function emailAtext(code) {
        if (code === 64) {
            effects.consume(code);
            return emailAtSignOrDot;
        }
        if ((0, $b4c110780d01af5f$export$4397998b34fe597d)(code)) {
            effects.consume(code);
            return emailAtext;
        }
        return nok(code);
    }
    /**
   * In label, after at-sign or dot.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                 ^       ^
   * ```
   *
   * @type {State}
   */ function emailAtSignOrDot(code) {
        return (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code) ? emailLabel(code) : nok(code);
    }
    /**
   * In label, where `.` and `>` are allowed.
   *
   * ```markdown
   * > | a<user.name@example.com>b
   *                   ^
   * ```
   *
   * @type {State}
   */ function emailLabel(code) {
        if (code === 46) {
            effects.consume(code);
            size = 0;
            return emailAtSignOrDot;
        }
        if (code === 62) {
            // Exit, then change the token type.
            effects.exit("autolinkProtocol").type = "autolinkEmail";
            effects.enter("autolinkMarker");
            effects.consume(code);
            effects.exit("autolinkMarker");
            effects.exit("autolink");
            return ok;
        }
        return emailValue(code);
    }
    /**
   * In label, where `.` and `>` are *not* allowed.
   *
   * Though, this is also used in `emailLabel` to parse other values.
   *
   * ```markdown
   * > | a<user.name@ex-ample.com>b
   *                    ^
   * ```
   *
   * @type {State}
   */ function emailValue(code) {
        // ASCII alphanumeric or `-`.
        if ((code === 45 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) && size++ < 63) {
            const next = code === 45 ? emailValue : emailLabel;
            effects.consume(code);
            return next;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $f340675ed8c47c20$export$200dcd0a5903c968 = {
    name: "blockQuote",
    tokenize: $f340675ed8c47c20$var$tokenizeBlockQuoteStart,
    continuation: {
        tokenize: $f340675ed8c47c20$var$tokenizeBlockQuoteContinuation
    },
    exit: $f340675ed8c47c20$var$exit
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f340675ed8c47c20$var$tokenizeBlockQuoteStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of block quote.
   *
   * ```markdown
   * > | > a
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 62) {
            const state = self.containerState;
            if (!state.open) {
                effects.enter("blockQuote", {
                    _container: true
                });
                state.open = true;
            }
            effects.enter("blockQuotePrefix");
            effects.enter("blockQuoteMarker");
            effects.consume(code);
            effects.exit("blockQuoteMarker");
            return after;
        }
        return nok(code);
    }
    /**
   * After `>`, before optional whitespace.
   *
   * ```markdown
   * > | > a
   *      ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.enter("blockQuotePrefixWhitespace");
            effects.consume(code);
            effects.exit("blockQuotePrefixWhitespace");
            effects.exit("blockQuotePrefix");
            return ok;
        }
        effects.exit("blockQuotePrefix");
        return ok(code);
    }
}
/**
 * Start of block quote continuation.
 *
 * ```markdown
 *   | > a
 * > | > b
 *     ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f340675ed8c47c20$var$tokenizeBlockQuoteContinuation(effects, ok, nok) {
    const self = this;
    return contStart;
    /**
   * Start of block quote continuation.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contStart(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) // Always populated by defaults.
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, contBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return contBefore(code);
    }
    /**
   * At `>`, after optional whitespace.
   *
   * Also used to parse the first block quote opening.
   *
   * ```markdown
   *   | > a
   * > | > b
   *     ^
   * ```
   *
   * @type {State}
   */ function contBefore(code) {
        return effects.attempt($f340675ed8c47c20$export$200dcd0a5903c968, ok, nok)(code);
    }
}
/** @type {Exiter} */ function $f340675ed8c47c20$var$exit(effects) {
    effects.exit("blockQuote");
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $81a53f0b1a6e2516$export$2005478564e78d96 = {
    name: "characterEscape",
    tokenize: $81a53f0b1a6e2516$var$tokenizeCharacterEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $81a53f0b1a6e2516$var$tokenizeCharacterEscape(effects, ok, nok) {
    return start;
    /**
   * Start of character escape.
   *
   * ```markdown
   * > | a\*b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterEscape");
        effects.enter("escapeMarker");
        effects.consume(code);
        effects.exit("escapeMarker");
        return inside;
    }
    /**
   * After `\`, at punctuation.
   *
   * ```markdown
   * > | a\*b
   *       ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // ASCII punctuation.
        if ((0, $b4c110780d01af5f$export$35794a7d1db99380)(code)) {
            effects.enter("characterEscapeValue");
            effects.consume(code);
            effects.exit("characterEscapeValue");
            effects.exit("characterEscape");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $12c3fbf72e440502$export$e31905600aaf3d8e = {
    name: "characterReference",
    tokenize: $12c3fbf72e440502$var$tokenizeCharacterReference
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $12c3fbf72e440502$var$tokenizeCharacterReference(effects, ok, nok) {
    const self = this;
    let size = 0;
    /** @type {number} */ let max;
    /** @type {(code: Code) => boolean} */ let test;
    return start;
    /**
   * Start of character reference.
   *
   * ```markdown
   * > | a&amp;b
   *      ^
   * > | a&#123;b
   *      ^
   * > | a&#x9;b
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("characterReference");
        effects.enter("characterReferenceMarker");
        effects.consume(code);
        effects.exit("characterReferenceMarker");
        return open;
    }
    /**
   * After `&`, at `#` for numeric references or alphanumeric for named
   * references.
   *
   * ```markdown
   * > | a&amp;b
   *       ^
   * > | a&#123;b
   *       ^
   * > | a&#x9;b
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 35) {
            effects.enter("characterReferenceMarkerNumeric");
            effects.consume(code);
            effects.exit("characterReferenceMarkerNumeric");
            return numeric;
        }
        effects.enter("characterReferenceValue");
        max = 31;
        test = (0, $b4c110780d01af5f$export$75c76db11865a9f4);
        return value(code);
    }
    /**
   * After `#`, at `x` for hexadecimals or digit for decimals.
   *
   * ```markdown
   * > | a&#123;b
   *        ^
   * > | a&#x9;b
   *        ^
   * ```
   *
   * @type {State}
   */ function numeric(code) {
        if (code === 88 || code === 120) {
            effects.enter("characterReferenceMarkerHexadecimal");
            effects.consume(code);
            effects.exit("characterReferenceMarkerHexadecimal");
            effects.enter("characterReferenceValue");
            max = 6;
            test = (0, $b4c110780d01af5f$export$eca2752363989806);
            return value;
        }
        effects.enter("characterReferenceValue");
        max = 7;
        test = (0, $b4c110780d01af5f$export$ca8b5b1a6c320e6e);
        return value(code);
    }
    /**
   * After markers (`&#x`, `&#`, or `&`), in value, before `;`.
   *
   * The character reference kind defines what and how many characters are
   * allowed.
   *
   * ```markdown
   * > | a&amp;b
   *       ^^^
   * > | a&#123;b
   *        ^^^
   * > | a&#x9;b
   *         ^
   * ```
   *
   * @type {State}
   */ function value(code) {
        if (code === 59 && size) {
            const token = effects.exit("characterReferenceValue");
            if (test === (0, $b4c110780d01af5f$export$75c76db11865a9f4) && !(0, $04b95225700f8616$export$289b6a6320f709b4)(self.sliceSerialize(token))) return nok(code);
            // To do: `markdown-rs` uses a different name:
            // `CharacterReferenceMarkerSemi`.
            effects.enter("characterReferenceMarker");
            effects.consume(code);
            effects.exit("characterReferenceMarker");
            effects.exit("characterReference");
            return ok;
        }
        if (test(code) && size++ < max) {
            effects.consume(code);
            return value;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

/** @type {Construct} */ const $b21b05fad854d61f$var$nonLazyContinuation = {
    tokenize: $b21b05fad854d61f$var$tokenizeNonLazyContinuation,
    partial: true
};
const $b21b05fad854d61f$export$c23e4921f8d87e7c = {
    name: "codeFenced",
    tokenize: $b21b05fad854d61f$var$tokenizeCodeFenced,
    concrete: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b21b05fad854d61f$var$tokenizeCodeFenced(effects, ok, nok) {
    const self = this;
    /** @type {Construct} */ const closeStart = {
        tokenize: tokenizeCloseStart,
        partial: true
    };
    let initialPrefix = 0;
    let sizeOpen = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of code.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse whitespace like `markdown-rs`.
        return beforeSequenceOpen(code);
    }
    /**
   * In opening fence, after prefix, at sequence.
   *
   * ```markdown
   * > | ~~~js
   *     ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeSequenceOpen(code) {
        const tail = self.events[self.events.length - 1];
        initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
        marker = code;
        effects.enter("codeFenced");
        effects.enter("codeFencedFence");
        effects.enter("codeFencedFenceSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening fence sequence.
   *
   * ```markdown
   * > | ~~~js
   *      ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === marker) {
            sizeOpen++;
            effects.consume(code);
            return sequenceOpen;
        }
        if (sizeOpen < 3) return nok(code);
        effects.exit("codeFencedFenceSequence");
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, infoBefore, "whitespace")(code) : infoBefore(code);
    }
    /**
   * In opening fence, after the sequence (and optional whitespace), before info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function infoBefore(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFencedFence");
            return self.interrupt ? ok(code) : effects.check($b21b05fad854d61f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        }
        effects.enter("codeFencedFenceInfo");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return info(code);
    }
    /**
   * In info.
   *
   * ```markdown
   * > | ~~~js
   *        ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function info(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return infoBefore(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceInfo");
            return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, metaBefore, "whitespace")(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return info;
    }
    /**
   * In opening fence, after info and whitespace, before meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function metaBefore(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return infoBefore(code);
        effects.enter("codeFencedFenceMeta");
        effects.enter("chunkString", {
            contentType: "string"
        });
        return meta(code);
    }
    /**
   * In meta.
   *
   * ```markdown
   * > | ~~~js eval
   *           ^
   *   | alert(1)
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function meta(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            effects.exit("codeFencedFenceMeta");
            return infoBefore(code);
        }
        if (code === 96 && code === marker) return nok(code);
        effects.consume(code);
        return meta;
    }
    /**
   * At eol/eof in code, before a non-lazy closing fence or content.
   *
   * ```markdown
   * > | ~~~js
   *          ^
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function atNonLazyBreak(code) {
        return effects.attempt(closeStart, after, contentBefore)(code);
    }
    /**
   * Before code content, not a closing fence, at eol.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *             ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentBefore(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return contentStart;
    }
    /**
   * Before code content, not a closing fence.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentStart(code) {
        return initialPrefix > 0 && (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code) : beforeContentChunk(code);
    }
    /**
   * Before code content, after optional prefix.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function beforeContentChunk(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return effects.check($b21b05fad854d61f$var$nonLazyContinuation, atNonLazyBreak, after)(code);
        effects.enter("codeFlowValue");
        return contentChunk(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   *   | ~~~js
   * > | alert(1)
   *     ^^^^^^^^
   *   | ~~~
   * ```
   *
   * @type {State}
   */ function contentChunk(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return beforeContentChunk(code);
        }
        effects.consume(code);
        return contentChunk;
    }
    /**
   * After code.
   *
   * ```markdown
   *   | ~~~js
   *   | alert(1)
   * > | ~~~
   *        ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        effects.exit("codeFenced");
        return ok(code);
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeCloseStart(effects, ok, nok) {
        let size = 0;
        return startBefore;
        /**
     *
     *
     * @type {State}
     */ function startBefore(code) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return start;
        }
        /**
     * Before closing fence, at optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function start(code) {
            // Always populated by defaults.
            // To do: `enter` here or in next state?
            effects.enter("codeFencedFence");
            return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, beforeSequenceClose, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : beforeSequenceClose(code);
        }
        /**
     * In closing fence, after optional whitespace, at sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function beforeSequenceClose(code) {
            if (code === marker) {
                effects.enter("codeFencedFenceSequence");
                return sequenceClose(code);
            }
            return nok(code);
        }
        /**
     * In closing fence sequence.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *     ^
     * ```
     *
     * @type {State}
     */ function sequenceClose(code) {
            if (code === marker) {
                size++;
                effects.consume(code);
                return sequenceClose;
            }
            if (size >= sizeOpen) {
                effects.exit("codeFencedFenceSequence");
                return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, sequenceCloseAfter, "whitespace")(code) : sequenceCloseAfter(code);
            }
            return nok(code);
        }
        /**
     * After closing fence sequence, after optional whitespace.
     *
     * ```markdown
     *   | ~~~js
     *   | alert(1)
     * > | ~~~
     *        ^
     * ```
     *
     * @type {State}
     */ function sequenceCloseAfter(code) {
            if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
                effects.exit("codeFencedFence");
                return ok(code);
            }
            return nok(code);
        }
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b21b05fad854d61f$var$tokenizeNonLazyContinuation(effects, ok, nok) {
    const self = this;
    return start;
    /**
   *
   *
   * @type {State}
   */ function start(code) {
        if (code === null) return nok(code);
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineStart;
    }
    /**
   *
   *
   * @type {State}
   */ function lineStart(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $d3fbfbfd857fa6bf$export$47910b7ab28d1853 = {
    name: "codeIndented",
    tokenize: $d3fbfbfd857fa6bf$var$tokenizeCodeIndented
};
/** @type {Construct} */ const $d3fbfbfd857fa6bf$var$furtherStart = {
    tokenize: $d3fbfbfd857fa6bf$var$tokenizeFurtherStart,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d3fbfbfd857fa6bf$var$tokenizeCodeIndented(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of code (indented).
   *
   * > **Parsing note**: it is not needed to check if this first line is a
   * > filled line (that it has a non-whitespace character), because blank lines
   * > are parsed already, so we never run into that.
   *
   * ```markdown
   * > |     aaa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: manually check if interrupting like `markdown-rs`.
        effects.enter("codeIndented");
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code) : nok(code);
    }
    /**
   * At a break.
   *
   * ```markdown
   * > |     aaa
   *         ^  ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === null) return after(code);
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return effects.attempt($d3fbfbfd857fa6bf$var$furtherStart, atBreak, after)(code);
        effects.enter("codeFlowValue");
        return inside(code);
    }
    /**
   * In code content.
   *
   * ```markdown
   * > |     aaa
   *         ^^^^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeFlowValue");
            return atBreak(code);
        }
        effects.consume(code);
        return inside;
    }
    /** @type {State} */ function after(code) {
        effects.exit("codeIndented");
        // To do: allow interrupting like `markdown-rs`.
        // Feel free to interrupt.
        // tokenizer.interrupt = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d3fbfbfd857fa6bf$var$tokenizeFurtherStart(effects, ok, nok) {
    const self = this;
    return furtherStart;
    /**
   * At eol, trying to parse another indent.
   *
   * ```markdown
   * > |     aaa
   *            ^
   *   |     bbb
   * ```
   *
   * @type {State}
   */ function furtherStart(code) {
        // To do: improve `lazy` / `pierce` handling.
        // If this is a lazy line, it can’t be code.
        if (self.parser.lazy[self.now().line]) return nok(code);
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return furtherStart;
        }
        // To do: the code here in `micromark-js` is a bit different from
        // `markdown-rs` because there it can attempt spaces.
        // We can’t yet.
        //
        // To do: use an improved `space_or_tab` function like `markdown-rs`,
        // so that we can drop the next state.
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterPrefix, "linePrefix", 5)(code);
    }
    /**
   * At start, after 1 or 4 spaces.
   *
   * ```markdown
   * > |     aaa
   *         ^
   * ```
   *
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok(code) : (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code) ? furtherStart(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $f528bb1b63694fb9$export$d24f93e715f9df88 = {
    name: "codeText",
    tokenize: $f528bb1b63694fb9$var$tokenizeCodeText,
    resolve: $f528bb1b63694fb9$var$resolveCodeText,
    previous: $f528bb1b63694fb9$var$previous
};
// To do: next major: don’t resolve, like `markdown-rs`.
/** @type {Resolver} */ function $f528bb1b63694fb9$var$resolveCodeText(events) {
    let tailExitIndex = events.length - 4;
    let headEnterIndex = 3;
    /** @type {number} */ let index;
    /** @type {number | undefined} */ let enter;
    // If we start and end with an EOL or a space.
    if ((events[headEnterIndex][1].type === "lineEnding" || events[headEnterIndex][1].type === "space") && (events[tailExitIndex][1].type === "lineEnding" || events[tailExitIndex][1].type === "space")) {
        index = headEnterIndex;
        // And we have data.
        while(++index < tailExitIndex)if (events[index][1].type === "codeTextData") {
            // Then we have padding.
            events[headEnterIndex][1].type = "codeTextPadding";
            events[tailExitIndex][1].type = "codeTextPadding";
            headEnterIndex += 2;
            tailExitIndex -= 2;
            break;
        }
    }
    // Merge adjacent spaces and data.
    index = headEnterIndex - 1;
    tailExitIndex++;
    while(++index <= tailExitIndex){
        if (enter === undefined) {
            if (index !== tailExitIndex && events[index][1].type !== "lineEnding") enter = index;
        } else if (index === tailExitIndex || events[index][1].type === "lineEnding") {
            events[enter][1].type = "codeTextData";
            if (index !== enter + 2) {
                events[enter][1].end = events[index - 1][1].end;
                events.splice(enter + 2, index - enter - 2);
                tailExitIndex -= index - enter - 2;
                index = enter + 2;
            }
            enter = undefined;
        }
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $f528bb1b63694fb9$var$previous(code) {
    // If there is a previous code, there will always be a tail.
    return code !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $f528bb1b63694fb9$var$tokenizeCodeText(effects, ok, nok) {
    const self = this;
    let sizeOpen = 0;
    /** @type {number} */ let size;
    /** @type {Token} */ let token;
    return start;
    /**
   * Start of code (text).
   *
   * ```markdown
   * > | `a`
   *     ^
   * > | \`a`
   *      ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("codeText");
        effects.enter("codeTextSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | `a`
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 96) {
            effects.consume(code);
            sizeOpen++;
            return sequenceOpen;
        }
        effects.exit("codeTextSequence");
        return between(code);
    }
    /**
   * Between something and something else.
   *
   * ```markdown
   * > | `a`
   *      ^^
   * ```
   *
   * @type {State}
   */ function between(code) {
        // EOF.
        if (code === null) return nok(code);
        // To do: next major: don’t do spaces in resolve, but when compiling,
        // like `markdown-rs`.
        // Tabs don’t work, and virtual spaces don’t make sense.
        if (code === 32) {
            effects.enter("space");
            effects.consume(code);
            effects.exit("space");
            return between;
        }
        // Closing fence? Could also be data.
        if (code === 96) {
            token = effects.enter("codeTextSequence");
            size = 0;
            return sequenceClose(code);
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return between;
        }
        // Data.
        effects.enter("codeTextData");
        return data(code);
    }
    /**
   * In data.
   *
   * ```markdown
   * > | `a`
   *      ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 32 || code === 96 || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("codeTextData");
            return between(code);
        }
        effects.consume(code);
        return data;
    }
    /**
   * In closing sequence.
   *
   * ```markdown
   * > | `a`
   *       ^
   * ```
   *
   * @type {State}
   */ function sequenceClose(code) {
        // More.
        if (code === 96) {
            effects.consume(code);
            size++;
            return sequenceClose;
        }
        // Done!
        if (size === sizeOpen) {
            effects.exit("codeTextSequence");
            effects.exit("codeText");
            return ok(code);
        }
        // More or less accents: mark as data.
        token.type = "codeTextData";
        return data(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $905db82bff251f54$export$2e6c8deaa96af245(effects, ok, nok, type, literalType, literalMarkerType, rawType, stringType, max) {
    const limit = max || Number.POSITIVE_INFINITY;
    let balance = 0;
    return start;
    /**
   * Start of destination.
   *
   * ```markdown
   * > | <aa>
   *     ^
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 60) {
            effects.enter(type);
            effects.enter(literalType);
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            return enclosedBefore;
        }
        // ASCII control, space, closing paren.
        if (code === null || code === 32 || code === 41 || (0, $b4c110780d01af5f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.enter(type);
        effects.enter(rawType);
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return raw(code);
    }
    /**
   * After `<`, at an enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosedBefore(code) {
        if (code === 62) {
            effects.enter(literalMarkerType);
            effects.consume(code);
            effects.exit(literalMarkerType);
            effects.exit(literalType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        effects.enter("chunkString", {
            contentType: "string"
        });
        return enclosed(code);
    }
    /**
   * In enclosed destination.
   *
   * ```markdown
   * > | <aa>
   *      ^
   * ```
   *
   * @type {State}
   */ function enclosed(code) {
        if (code === 62) {
            effects.exit("chunkString");
            effects.exit(stringType);
            return enclosedBefore(code);
        }
        if (code === null || code === 60 || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? enclosedEscape : enclosed;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | <a\*a>
   *        ^
   * ```
   *
   * @type {State}
   */ function enclosedEscape(code) {
        if (code === 60 || code === 62 || code === 92) {
            effects.consume(code);
            return enclosed;
        }
        return enclosed(code);
    }
    /**
   * In raw destination.
   *
   * ```markdown
   * > | aa
   *     ^
   * ```
   *
   * @type {State}
   */ function raw(code) {
        if (!balance && (code === null || code === 41 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code))) {
            effects.exit("chunkString");
            effects.exit(stringType);
            effects.exit(rawType);
            effects.exit(type);
            return ok(code);
        }
        if (balance < limit && code === 40) {
            effects.consume(code);
            balance++;
            return raw;
        }
        if (code === 41) {
            effects.consume(code);
            balance--;
            return raw;
        }
        // ASCII control (but *not* `\0`) and space and `(`.
        // Note: in `markdown-rs`, `\0` exists in codes, in `micromark-js` it
        // doesn’t.
        if (code === null || code === 32 || code === 40 || (0, $b4c110780d01af5f$export$67dbf494fc8394df)(code)) return nok(code);
        effects.consume(code);
        return code === 92 ? rawEscape : raw;
    }
    /**
   * After `\`, at special character.
   *
   * ```markdown
   * > | a\*a
   *       ^
   * ```
   *
   * @type {State}
   */ function rawEscape(code) {
        if (code === 40 || code === 41 || code === 92) {
            effects.consume(code);
            return raw;
        }
        return raw(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 
function $fbba99e035dbf033$export$7b768614d8ba97a7(effects, ok, nok, type, markerType, stringType) {
    const self = this;
    let size = 0;
    /** @type {boolean} */ let seen;
    return start;
    /**
   * Start of label.
   *
   * ```markdown
   * > | [a]
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter(type);
        effects.enter(markerType);
        effects.consume(code);
        effects.exit(markerType);
        effects.enter(stringType);
        return atBreak;
    }
    /**
   * In label, at something, before something else.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (size > 999 || code === null || code === 91 || code === 93 && !seen || // To do: remove in the future once we’ve switched from
        // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
        // which doesn’t need this.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ code === 94 && !size && "_hiddenFootnoteSupport" in self.parser.constructs) return nok(code);
        if (code === 93) {
            effects.exit(stringType);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        // To do: indent? Link chunks and EOLs together?
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return atBreak;
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return labelInside(code);
    }
    /**
   * In label, in text.
   *
   * ```markdown
   * > | [a]
   *      ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (code === null || code === 91 || code === 93 || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code) || size++ > 999) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        if (!seen) seen = !(0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | [a\*a]
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
}



/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenType} TokenType
 */ 

function $f9e3007c64ffd9a3$export$f970569cc855e483(effects, ok, nok, type, markerType, stringType) {
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of title.
   *
   * ```markdown
   * > | "a"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (code === 34 || code === 39 || code === 40) {
            effects.enter(type);
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            marker = code === 40 ? 41 : code;
            return begin;
        }
        return nok(code);
    }
    /**
   * After opening marker.
   *
   * This is also used at the closing marker.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function begin(code) {
        if (code === marker) {
            effects.enter(markerType);
            effects.consume(code);
            effects.exit(markerType);
            effects.exit(type);
            return ok;
        }
        effects.enter(stringType);
        return atBreak(code);
    }
    /**
   * At something, before something else.
   *
   * ```markdown
   * > | "a"
   *      ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.exit(stringType);
            return begin(marker);
        }
        if (code === null) return nok(code);
        // Note: blank lines can’t exist in content.
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            // To do: use `space_or_tab_eol_with_options`, connect.
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, atBreak, "linePrefix");
        }
        effects.enter("chunkString", {
            contentType: "string"
        });
        return inside(code);
    }
    /**
   *
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker || code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("chunkString");
            return atBreak(code);
        }
        effects.consume(code);
        return code === 92 ? escape : inside;
    }
    /**
   * After `\`, at a special character.
   *
   * ```markdown
   * > | "a\*b"
   *      ^
   * ```
   *
   * @type {State}
   */ function escape(code) {
        if (code === marker || code === 92) {
            effects.consume(code);
            return inside;
        }
        return inside(code);
    }
}


/**
 * @typedef {import('micromark-util-types').Effects} Effects
 * @typedef {import('micromark-util-types').State} State
 */ 

function $84f290fc8a35b5b1$export$1f27bd1aa33ce173(effects, ok) {
    /** @type {boolean} */ let seen;
    return start;
    /** @type {State} */ function start(code) {
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            seen = true;
            return start;
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, start, seen ? "linePrefix" : "lineSuffix")(code);
        return ok(code);
    }
}




const $0dfaba7180aafd37$export$69f215ed977cdb73 = {
    name: "definition",
    tokenize: $0dfaba7180aafd37$var$tokenizeDefinition
};
/** @type {Construct} */ const $0dfaba7180aafd37$var$titleBefore = {
    tokenize: $0dfaba7180aafd37$var$tokenizeTitleBefore,
    partial: true
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0dfaba7180aafd37$var$tokenizeDefinition(effects, ok, nok) {
    const self = this;
    /** @type {string} */ let identifier;
    return start;
    /**
   * At start of a definition.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Do not interrupt paragraphs (but do follow definitions).
        // To do: do `interrupt` the way `markdown-rs` does.
        // To do: parse whitespace the way `markdown-rs` does.
        effects.enter("definition");
        return before(code);
    }
    /**
   * After optional whitespace, at `[`.
   *
   * ```markdown
   * > | [a]: b "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        // To do: parse whitespace the way `markdown-rs` does.
        return (0, $fbba99e035dbf033$export$7b768614d8ba97a7).call(self, effects, labelAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionLabel", "definitionLabelMarker", "definitionLabelString")(code);
    }
    /**
   * After label.
   *
   * ```markdown
   * > | [a]: b "c"
   *        ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1));
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            return markerAfter;
        }
        return nok(code);
    }
    /**
   * After marker.
   *
   * ```markdown
   * > | [a]: b "c"
   *         ^
   * ```
   *
   * @type {State}
   */ function markerAfter(code) {
        // Note: whitespace is optional.
        return (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) ? (0, $84f290fc8a35b5b1$export$1f27bd1aa33ce173)(effects, destinationBefore)(code) : destinationBefore(code);
    }
    /**
   * Before destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *          ^
   * ```
   *
   * @type {State}
   */ function destinationBefore(code) {
        return (0, $905db82bff251f54$export$2e6c8deaa96af245)(effects, destinationAfter, // Note: we don’t need to reset the way `markdown-rs` does.
        nok, "definitionDestination", "definitionDestinationLiteral", "definitionDestinationLiteralMarker", "definitionDestinationRaw", "definitionDestinationString")(code);
    }
    /**
   * After destination.
   *
   * ```markdown
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function destinationAfter(code) {
        return effects.attempt($0dfaba7180aafd37$var$titleBefore, after, after)(code);
    }
    /**
   * After definition.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterWhitespace, "whitespace")(code) : afterWhitespace(code);
    }
    /**
   * After definition, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function afterWhitespace(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("definition");
            // Note: we don’t care about uniqueness.
            // It’s likely that that doesn’t happen very frequently.
            // It is more likely that it wastes precious time.
            self.parser.defined.push(identifier);
            // To do: `markdown-rs` interrupt.
            // // You’d be interrupting.
            // tokenizer.interrupt = true
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0dfaba7180aafd37$var$tokenizeTitleBefore(effects, ok, nok) {
    return titleBefore;
    /**
   * After destination, at whitespace.
   *
   * ```markdown
   * > | [a]: b
   *           ^
   * > | [a]: b "c"
   *           ^
   * ```
   *
   * @type {State}
   */ function titleBefore(code) {
        return (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) ? (0, $84f290fc8a35b5b1$export$1f27bd1aa33ce173)(effects, beforeMarker)(code) : nok(code);
    }
    /**
   * At title.
   *
   * ```markdown
   *   | [a]: b
   * > | "c"
   *     ^
   * ```
   *
   * @type {State}
   */ function beforeMarker(code) {
        return (0, $f9e3007c64ffd9a3$export$f970569cc855e483)(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code);
    }
    /**
   * After title.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfter(code) {
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, titleAfterOptionalWhitespace, "whitespace")(code) : titleAfterOptionalWhitespace(code);
    }
    /**
   * After title, after optional whitespace.
   *
   * ```markdown
   * > | [a]: b "c"
   *               ^
   * ```
   *
   * @type {State}
   */ function titleAfterOptionalWhitespace(code) {
        return code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code) ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $68311ec08720b6e0$export$86c573ab9e06f418 = {
    name: "hardBreakEscape",
    tokenize: $68311ec08720b6e0$var$tokenizeHardBreakEscape
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $68311ec08720b6e0$var$tokenizeHardBreakEscape(effects, ok, nok) {
    return start;
    /**
   * Start of a hard break (escape).
   *
   * ```markdown
   * > | a\
   *      ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("hardBreakEscape");
        effects.consume(code);
        return after;
    }
    /**
   * After `\`, at eol.
   *
   * ```markdown
   * > | a\
   *       ^
   *   | b
   * ```
   *
   *  @type {State}
   */ function after(code) {
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("hardBreakEscape");
            return ok(code);
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


const $9dd159508d941fea$export$3871e9deb360695c = {
    name: "headingAtx",
    tokenize: $9dd159508d941fea$var$tokenizeHeadingAtx,
    resolve: $9dd159508d941fea$var$resolveHeadingAtx
};
/** @type {Resolver} */ function $9dd159508d941fea$var$resolveHeadingAtx(events, context) {
    let contentEnd = events.length - 2;
    let contentStart = 3;
    /** @type {Token} */ let content;
    /** @type {Token} */ let text;
    // Prefix whitespace, part of the opening.
    if (events[contentStart][1].type === "whitespace") contentStart += 2;
    // Suffix whitespace, part of the closing.
    if (contentEnd - 2 > contentStart && events[contentEnd][1].type === "whitespace") contentEnd -= 2;
    if (events[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events[contentEnd - 2][1].type === "whitespace")) contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
    if (contentEnd > contentStart) {
        content = {
            type: "atxHeadingText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end
        };
        text = {
            type: "chunkText",
            start: events[contentStart][1].start,
            end: events[contentEnd][1].end,
            contentType: "text"
        };
        (0, $5720affce988170b$export$869882364835d202)(events, contentStart, contentEnd - contentStart + 1, [
            [
                "enter",
                content,
                context
            ],
            [
                "enter",
                text,
                context
            ],
            [
                "exit",
                text,
                context
            ],
            [
                "exit",
                content,
                context
            ]
        ]);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $9dd159508d941fea$var$tokenizeHeadingAtx(effects, ok, nok) {
    let size = 0;
    return start;
    /**
   * Start of a heading (atx).
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        effects.enter("atxHeading");
        return before(code);
    }
    /**
   * After optional whitespace, at `#`.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("atxHeadingSequence");
        return sequenceOpen(code);
    }
    /**
   * In opening sequence.
   *
   * ```markdown
   * > | ## aa
   *     ^
   * ```
   *
   * @type {State}
   */ function sequenceOpen(code) {
        if (code === 35 && size++ < 6) {
            effects.consume(code);
            return sequenceOpen;
        }
        // Always at least one `#`.
        if (code === null || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingSequence");
            return atBreak(code);
        }
        return nok(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ## aa
   *       ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === 35) {
            effects.enter("atxHeadingSequence");
            return sequenceFurther(code);
        }
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("atxHeading");
            // To do: interrupt like `markdown-rs`.
            // // Feel free to interrupt.
            // tokenizer.interrupt = false
            return ok(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code);
        // To do: generate `data` tokens, add the `text` token later.
        // Needs edit map, see: `markdown.rs`.
        effects.enter("atxHeadingText");
        return data(code);
    }
    /**
   * In further sequence (after whitespace).
   *
   * Could be normal “visible” hashes in the heading or a final sequence.
   *
   * ```markdown
   * > | ## aa ##
   *           ^
   * ```
   *
   * @type {State}
   */ function sequenceFurther(code) {
        if (code === 35) {
            effects.consume(code);
            return sequenceFurther;
        }
        effects.exit("atxHeadingSequence");
        return atBreak(code);
    }
    /**
   * In text.
   *
   * ```markdown
   * > | ## aa
   *        ^
   * ```
   *
   * @type {State}
   */ function data(code) {
        if (code === null || code === 35 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            effects.exit("atxHeadingText");
            return atBreak(code);
        }
        effects.consume(code);
        return data;
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
/**
 * List of lowercase HTML “block” tag names.
 *
 * The list, when parsing HTML (flow), results in more relaxed rules (condition
 * 6).
 * Because they are known blocks, the HTML-like syntax doesn’t have to be
 * strictly parsed.
 * For tag names not in this list, a more strict algorithm (condition 7) is used
 * to detect whether the HTML-like syntax is seen as HTML (flow) or not.
 *
 * This is copied from:
 * <https://spec.commonmark.org/0.30/#html-blocks>.
 *
 * > 👉 **Note**: `search` was added in `CommonMark@0.31`.
 */ const $89fcea36ea6e8331$export$7364aee1c59d1879 = [
    "address",
    "article",
    "aside",
    "base",
    "basefont",
    "blockquote",
    "body",
    "caption",
    "center",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "dir",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "frame",
    "frameset",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "head",
    "header",
    "hr",
    "html",
    "iframe",
    "legend",
    "li",
    "link",
    "main",
    "menu",
    "menuitem",
    "nav",
    "noframes",
    "ol",
    "optgroup",
    "option",
    "p",
    "param",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "title",
    "tr",
    "track",
    "ul"
];
const $89fcea36ea6e8331$export$948e66da505d080 = [
    "pre",
    "script",
    "style",
    "textarea"
];



const $3c60187190fb773d$export$476ac411cb7d0d8f = {
    name: "htmlFlow",
    tokenize: $3c60187190fb773d$var$tokenizeHtmlFlow,
    resolveTo: $3c60187190fb773d$var$resolveToHtmlFlow,
    concrete: true
};
/** @type {Construct} */ const $3c60187190fb773d$var$blankLineBefore = {
    tokenize: $3c60187190fb773d$var$tokenizeBlankLineBefore,
    partial: true
};
const $3c60187190fb773d$var$nonLazyContinuationStart = {
    tokenize: $3c60187190fb773d$var$tokenizeNonLazyContinuationStart,
    partial: true
};
/** @type {Resolver} */ function $3c60187190fb773d$var$resolveToHtmlFlow(events) {
    let index = events.length;
    while(index--){
        if (events[index][0] === "enter" && events[index][1].type === "htmlFlow") break;
    }
    if (index > 1 && events[index - 2][1].type === "linePrefix") {
        // Add the prefix start to the HTML token.
        events[index][1].start = events[index - 2][1].start;
        // Add the prefix start to the HTML line token.
        events[index + 1][1].start = events[index - 2][1].start;
        // Remove the line prefix.
        events.splice(index - 2, 2);
    }
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3c60187190fb773d$var$tokenizeHtmlFlow(effects, ok, nok) {
    const self = this;
    /** @type {number} */ let marker;
    /** @type {boolean} */ let closingTag;
    /** @type {string} */ let buffer;
    /** @type {number} */ let index;
    /** @type {Code} */ let markerB;
    return start;
    /**
   * Start of HTML (flow).
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * At `<`, after optional whitespace.
   *
   * ```markdown
   * > | <x />
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("htmlFlow");
        effects.enter("htmlFlowData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | <x />
   *      ^
   * > | <!doctype>
   *      ^
   * > | <!--xxx-->
   *      ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            closingTag = true;
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            marker = 3;
            // To do:
            // tokenizer.concrete = true
            // To do: use `markdown-rs` style interrupt.
            // While we’re in an instruction instead of a declaration, we’re on a `?`
            // right now, so we do need to search for `>`, similar to declarations.
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        // ASCII alphabetical.
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | <!doctype>
   *       ^
   * > | <!--xxx-->
   *       ^
   * > | <![CDATA[>&<]]>
   *       ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            marker = 2;
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            marker = 5;
            index = 0;
            return cdataOpenInside;
        }
        // ASCII alphabetical.
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            marker = 4;
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<!-`, inside a comment, at another `-`.
   *
   * ```markdown
   * > | <!--xxx-->
   *        ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuationDeclarationInside;
        }
        return nok(code);
    }
    /**
   * After `<![`, inside CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *        ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            if (index === value.length) // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
            return cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | </x>
   *       ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer = String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * In tag name.
   *
   * ```markdown
   * > | <ab>
   *      ^^
   * > | </ab>
   *       ^^
   * ```
   *
   * @type {State}
   */ function tagName(code) {
        if (code === null || code === 47 || code === 62 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            const slash = code === 47;
            const name = buffer.toLowerCase();
            if (!slash && !closingTag && (0, $89fcea36ea6e8331$export$948e66da505d080).includes(name)) {
                marker = 1;
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            if ((0, $89fcea36ea6e8331$export$7364aee1c59d1879).includes(buffer.toLowerCase())) {
                marker = 6;
                if (slash) {
                    effects.consume(code);
                    return basicSelfClosing;
                }
                // // Do not form containers.
                // tokenizer.concrete = true
                return self.interrupt ? ok(code) : continuation(code);
            }
            marker = 7;
            // Do not support complete HTML when interrupting.
            return self.interrupt && !self.parser.lazy[self.now().line] ? nok(code) : closingTag ? completeClosingTagAfter(code) : completeAttributeNameBefore(code);
        }
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            buffer += String.fromCharCode(code);
            return tagName;
        }
        return nok(code);
    }
    /**
   * After closing slash of a basic tag name.
   *
   * ```markdown
   * > | <div/>
   *          ^
   * ```
   *
   * @type {State}
   */ function basicSelfClosing(code) {
        if (code === 62) {
            effects.consume(code);
            // // Do not form containers.
            // tokenizer.concrete = true
            return self.interrupt ? ok : continuation;
        }
        return nok(code);
    }
    /**
   * After closing slash of a complete tag name.
   *
   * ```markdown
   * > | <x/>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeClosingTagAfter(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeClosingTagAfter;
        }
        return completeEnd(code);
    }
    /**
   * At an attribute name.
   *
   * At first, this state is used after a complete tag name, after whitespace,
   * where it expects optional attributes or the end of the tag.
   * It is also reused after attributes, when expecting more optional
   * attributes.
   *
   * ```markdown
   * > | <a />
   *        ^
   * > | <a :b>
   *        ^
   * > | <a _b>
   *        ^
   * > | <a b>
   *        ^
   * > | <a >
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameBefore(code) {
        if (code === 47) {
            effects.consume(code);
            return completeEnd;
        }
        // ASCII alphanumerical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameBefore;
        }
        return completeEnd(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | <a :b>
   *         ^
   * > | <a _b>
   *         ^
   * > | <a b>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeName(code) {
        // ASCII alphanumerical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return completeAttributeName;
        }
        return completeAttributeNameAfter(code);
    }
    /**
   * After attribute name, at an optional initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | <a b>
   *         ^
   * > | <a b=c>
   *         ^
   * ```
   *
   * @type {State}
   */ function completeAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeNameAfter;
        }
        return completeAttributeNameBefore(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * > | <a b="c">
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            markerB = code;
            return completeAttributeValueQuoted;
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAttributeValueBefore;
        }
        return completeAttributeValueUnquoted(code);
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | <a b="c">
   *           ^
   * > | <a b='c'>
   *           ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuoted(code) {
        if (code === markerB) {
            effects.consume(code);
            markerB = null;
            return completeAttributeValueQuotedAfter;
        }
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return nok(code);
        effects.consume(code);
        return completeAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | <a b=c>
   *          ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 47 || code === 60 || code === 61 || code === 62 || code === 96 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return completeAttributeNameAfter(code);
        effects.consume(code);
        return completeAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the
   * end of the tag.
   *
   * ```markdown
   * > | <a b="c">
   *            ^
   * ```
   *
   * @type {State}
   */ function completeAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return completeAttributeNameBefore(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a complete tag where only an `>` is allowed.
   *
   * ```markdown
   * > | <a b="c">
   *             ^
   * ```
   *
   * @type {State}
   */ function completeEnd(code) {
        if (code === 62) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * After `>` in a complete tag.
   *
   * ```markdown
   * > | <x>
   *        ^
   * ```
   *
   * @type {State}
   */ function completeAfter(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) // // Do not form containers.
        // tokenizer.concrete = true
        return continuation(code);
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return completeAfter;
        }
        return nok(code);
    }
    /**
   * In continuation of any HTML kind.
   *
   * ```markdown
   * > | <!--xxx-->
   *          ^
   * ```
   *
   * @type {State}
   */ function continuation(code) {
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationCommentInside;
        }
        if (code === 60 && marker === 1) {
            effects.consume(code);
            return continuationRawTagOpen;
        }
        if (code === 62 && marker === 4) {
            effects.consume(code);
            return continuationClose;
        }
        if (code === 63 && marker === 3) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        if (code === 93 && marker === 5) {
            effects.consume(code);
            return continuationCdataInside;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code) && (marker === 6 || marker === 7)) {
            effects.exit("htmlFlowData");
            return effects.check($3c60187190fb773d$var$blankLineBefore, continuationAfter, continuationStart)(code);
        }
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationStart(code);
        }
        effects.consume(code);
        return continuation;
    }
    /**
   * In continuation, at eol.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStart(code) {
        return effects.check($3c60187190fb773d$var$nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code);
    }
    /**
   * In continuation, at eol, before non-lazy content.
   *
   * ```markdown
   * > | <x>
   *        ^
   *   | asd
   * ```
   *
   * @type {State}
   */ function continuationStartNonLazy(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return continuationBefore;
    }
    /**
   * In continuation, before non-lazy content.
   *
   * ```markdown
   *   | <x>
   * > | asd
   *     ^
   * ```
   *
   * @type {State}
   */ function continuationBefore(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return continuationStart(code);
        effects.enter("htmlFlowData");
        return continuation(code);
    }
    /**
   * In comment continuation, after one `-`, expecting another.
   *
   * ```markdown
   * > | <!--xxx-->
   *             ^
   * ```
   *
   * @type {State}
   */ function continuationCommentInside(code) {
        if (code === 45) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `<`, at `/`.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                            ^
   * ```
   *
   * @type {State}
   */ function continuationRawTagOpen(code) {
        if (code === 47) {
            effects.consume(code);
            buffer = "";
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In raw continuation, after `</`, in a raw tag name.
   *
   * ```markdown
   * > | <script>console.log(1)</script>
   *                             ^^^^^^
   * ```
   *
   * @type {State}
   */ function continuationRawEndTag(code) {
        if (code === 62) {
            const name = buffer.toLowerCase();
            if ((0, $89fcea36ea6e8331$export$948e66da505d080).includes(name)) {
                effects.consume(code);
                return continuationClose;
            }
            return continuation(code);
        }
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code) && buffer.length < 8) {
            effects.consume(code);
            // @ts-expect-error: not null.
            buffer += String.fromCharCode(code);
            return continuationRawEndTag;
        }
        return continuation(code);
    }
    /**
   * In cdata continuation, after `]`, expecting `]>`.
   *
   * ```markdown
   * > | <![CDATA[>&<]]>
   *                  ^
   * ```
   *
   * @type {State}
   */ function continuationCdataInside(code) {
        if (code === 93) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In declaration or instruction continuation, at `>`.
   *
   * ```markdown
   * > | <!-->
   *         ^
   * > | <?>
   *       ^
   * > | <!q>
   *        ^
   * > | <!--ab-->
   *             ^
   * > | <![CDATA[>&<]]>
   *                   ^
   * ```
   *
   * @type {State}
   */ function continuationDeclarationInside(code) {
        if (code === 62) {
            effects.consume(code);
            return continuationClose;
        }
        // More dashes.
        if (code === 45 && marker === 2) {
            effects.consume(code);
            return continuationDeclarationInside;
        }
        return continuation(code);
    }
    /**
   * In closed continuation: everything we get until the eol/eof is part of it.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationClose(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("htmlFlowData");
            return continuationAfter(code);
        }
        effects.consume(code);
        return continuationClose;
    }
    /**
   * Done.
   *
   * ```markdown
   * > | <!doctype>
   *               ^
   * ```
   *
   * @type {State}
   */ function continuationAfter(code) {
        effects.exit("htmlFlow");
        // // Feel free to interrupt.
        // tokenizer.interrupt = false
        // // No longer concrete.
        // tokenizer.concrete = false
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3c60187190fb773d$var$tokenizeNonLazyContinuationStart(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * At eol, before continuation.
   *
   * ```markdown
   * > | * ```js
   *            ^
   *   | b
   * ```
   *
   * @type {State}
   */ function start(code) {
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.enter("lineEnding");
            effects.consume(code);
            effects.exit("lineEnding");
            return after;
        }
        return nok(code);
    }
    /**
   * A continuation.
   *
   * ```markdown
   *   | * ```js
   * > | b
   *     ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        return self.parser.lazy[self.now().line] ? nok(code) : ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $3c60187190fb773d$var$tokenizeBlankLineBefore(effects, ok, nok) {
    return start;
    /**
   * Before eol, expecting blank line.
   *
   * ```markdown
   * > | <div>
   *          ^
   *   |
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return effects.attempt((0, $6462050da1e6035a$export$d50d28ce3ab2a612), ok, nok);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $b8af2897e3abb59b$export$398af27f284914fe = {
    name: "htmlText",
    tokenize: $b8af2897e3abb59b$var$tokenizeHtmlText
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $b8af2897e3abb59b$var$tokenizeHtmlText(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code> | undefined} */ let marker;
    /** @type {number} */ let index;
    /** @type {State} */ let returnState;
    return start;
    /**
   * Start of HTML (text).
   *
   * ```markdown
   * > | a <b> c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("htmlText");
        effects.enter("htmlTextData");
        effects.consume(code);
        return open;
    }
    /**
   * After `<`, at tag name or other stuff.
   *
   * ```markdown
   * > | a <b> c
   *        ^
   * > | a <!doctype> c
   *        ^
   * > | a <!--b--> c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 33) {
            effects.consume(code);
            return declarationOpen;
        }
        if (code === 47) {
            effects.consume(code);
            return tagCloseStart;
        }
        if (code === 63) {
            effects.consume(code);
            return instruction;
        }
        // ASCII alphabetical.
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        return nok(code);
    }
    /**
   * After `<!`, at declaration, comment, or CDATA.
   *
   * ```markdown
   * > | a <!doctype> c
   *         ^
   * > | a <!--b--> c
   *         ^
   * > | a <![CDATA[>&<]]> c
   *         ^
   * ```
   *
   * @type {State}
   */ function declarationOpen(code) {
        if (code === 45) {
            effects.consume(code);
            return commentOpenInside;
        }
        if (code === 91) {
            effects.consume(code);
            index = 0;
            return cdataOpenInside;
        }
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return declaration;
        }
        return nok(code);
    }
    /**
   * In a comment, after `<!-`, at another `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *          ^
   * ```
   *
   * @type {State}
   */ function commentOpenInside(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return nok(code);
    }
    /**
   * In comment.
   *
   * ```markdown
   * > | a <!--b--> c
   *           ^
   * ```
   *
   * @type {State}
   */ function comment(code) {
        if (code === null) return nok(code);
        if (code === 45) {
            effects.consume(code);
            return commentClose;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = comment;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return comment;
    }
    /**
   * In comment, after `-`.
   *
   * ```markdown
   * > | a <!--b--> c
   *             ^
   * ```
   *
   * @type {State}
   */ function commentClose(code) {
        if (code === 45) {
            effects.consume(code);
            return commentEnd;
        }
        return comment(code);
    }
    /**
   * In comment, after `--`.
   *
   * ```markdown
   * > | a <!--b--> c
   *              ^
   * ```
   *
   * @type {State}
   */ function commentEnd(code) {
        return code === 62 ? end(code) : code === 45 ? commentClose(code) : comment(code);
    }
    /**
   * After `<![`, in CDATA, expecting `CDATA[`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *          ^^^^^^
   * ```
   *
   * @type {State}
   */ function cdataOpenInside(code) {
        const value = "CDATA[";
        if (code === value.charCodeAt(index++)) {
            effects.consume(code);
            return index === value.length ? cdata : cdataOpenInside;
        }
        return nok(code);
    }
    /**
   * In CDATA.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                ^^^
   * ```
   *
   * @type {State}
   */ function cdata(code) {
        if (code === null) return nok(code);
        if (code === 93) {
            effects.consume(code);
            return cdataClose;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = cdata;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return cdata;
    }
    /**
   * In CDATA, after `]`, at another `]`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                    ^
   * ```
   *
   * @type {State}
   */ function cdataClose(code) {
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In CDATA, after `]]`, at `>`.
   *
   * ```markdown
   * > | a <![CDATA[>&<]]> b
   *                     ^
   * ```
   *
   * @type {State}
   */ function cdataEnd(code) {
        if (code === 62) return end(code);
        if (code === 93) {
            effects.consume(code);
            return cdataEnd;
        }
        return cdata(code);
    }
    /**
   * In declaration.
   *
   * ```markdown
   * > | a <!b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function declaration(code) {
        if (code === null || code === 62) return end(code);
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = declaration;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return declaration;
    }
    /**
   * In instruction.
   *
   * ```markdown
   * > | a <?b?> c
   *         ^
   * ```
   *
   * @type {State}
   */ function instruction(code) {
        if (code === null) return nok(code);
        if (code === 63) {
            effects.consume(code);
            return instructionClose;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = instruction;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return instruction;
    }
    /**
   * In instruction, after `?`, at `>`.
   *
   * ```markdown
   * > | a <?b?> c
   *           ^
   * ```
   *
   * @type {State}
   */ function instructionClose(code) {
        return code === 62 ? end(code) : instruction(code);
    }
    /**
   * After `</`, in closing tag, at tag name.
   *
   * ```markdown
   * > | a </b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagCloseStart(code) {
        // ASCII alphabetical.
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return nok(code);
    }
    /**
   * After `</x`, in a tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagClose(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagClose;
        }
        return tagCloseBetween(code);
    }
    /**
   * In closing tag, after tag name.
   *
   * ```markdown
   * > | a </b> c
   *          ^
   * ```
   *
   * @type {State}
   */ function tagCloseBetween(code) {
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = tagCloseBetween;
            return lineEndingBefore(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagCloseBetween;
        }
        return end(code);
    }
    /**
   * After `<x`, in opening tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpen(code) {
        // ASCII alphanumerical and `-`.
        if (code === 45 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpen;
        }
        if (code === 47 || code === 62 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In opening tag, after tag name.
   *
   * ```markdown
   * > | a <b> c
   *         ^
   * ```
   *
   * @type {State}
   */ function tagOpenBetween(code) {
        if (code === 47) {
            effects.consume(code);
            return end;
        }
        // ASCII alphabetical and `:` and `_`.
        if (code === 58 || code === 95 || (0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenBetween;
            return lineEndingBefore(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenBetween;
        }
        return end(code);
    }
    /**
   * In attribute name.
   *
   * ```markdown
   * > | a <b c> d
   *          ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeName(code) {
        // ASCII alphabetical and `-`, `.`, `:`, and `_`.
        if (code === 45 || code === 46 || code === 58 || code === 95 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            effects.consume(code);
            return tagOpenAttributeName;
        }
        return tagOpenAttributeNameAfter(code);
    }
    /**
   * After attribute name, before initializer, the end of the tag, or
   * whitespace.
   *
   * ```markdown
   * > | a <b c> d
   *           ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeNameAfter(code) {
        if (code === 61) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeNameAfter;
            return lineEndingBefore(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeNameAfter;
        }
        return tagOpenBetween(code);
    }
    /**
   * Before unquoted, double quoted, or single quoted attribute value, allowing
   * whitespace.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueBefore(code) {
        if (code === null || code === 60 || code === 61 || code === 62 || code === 96) return nok(code);
        if (code === 34 || code === 39) {
            effects.consume(code);
            marker = code;
            return tagOpenAttributeValueQuoted;
        }
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueBefore;
            return lineEndingBefore(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.consume(code);
            return tagOpenAttributeValueBefore;
        }
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * In double or single quoted attribute value.
   *
   * ```markdown
   * > | a <b c="d"> e
   *             ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuoted(code) {
        if (code === marker) {
            effects.consume(code);
            marker = undefined;
            return tagOpenAttributeValueQuotedAfter;
        }
        if (code === null) return nok(code);
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            returnState = tagOpenAttributeValueQuoted;
            return lineEndingBefore(code);
        }
        effects.consume(code);
        return tagOpenAttributeValueQuoted;
    }
    /**
   * In unquoted attribute value.
   *
   * ```markdown
   * > | a <b c=d> e
   *            ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueUnquoted(code) {
        if (code === null || code === 34 || code === 39 || code === 60 || code === 61 || code === 96) return nok(code);
        if (code === 47 || code === 62 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        effects.consume(code);
        return tagOpenAttributeValueUnquoted;
    }
    /**
   * After double or single quoted attribute value, before whitespace or the end
   * of the tag.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function tagOpenAttributeValueQuotedAfter(code) {
        if (code === 47 || code === 62 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return tagOpenBetween(code);
        return nok(code);
    }
    /**
   * In certain circumstances of a tag where only an `>` is allowed.
   *
   * ```markdown
   * > | a <b c="d"> e
   *               ^
   * ```
   *
   * @type {State}
   */ function end(code) {
        if (code === 62) {
            effects.consume(code);
            effects.exit("htmlTextData");
            effects.exit("htmlText");
            return ok;
        }
        return nok(code);
    }
    /**
   * At eol.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   * > | a <!--a
   *            ^
   *   | b-->
   * ```
   *
   * @type {State}
   */ function lineEndingBefore(code) {
        effects.exit("htmlTextData");
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return lineEndingAfter;
    }
    /**
   * After eol, at optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfter(code) {
        // Always populated by defaults.
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, lineEndingAfterPrefix, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code) : lineEndingAfterPrefix(code);
    }
    /**
   * After eol, after optional whitespace.
   *
   * > 👉 **Note**: we can’t have blank lines in text, so no need to worry about
   * > empty tokens.
   *
   * ```markdown
   *   | a <!--a
   * > | b-->
   *     ^
   * ```
   *
   * @type {State}
   */ function lineEndingAfterPrefix(code) {
        effects.enter("htmlTextData");
        return returnState(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 







const $d208647f3b57f6c4$export$470a5dafbbf62654 = {
    name: "labelEnd",
    tokenize: $d208647f3b57f6c4$var$tokenizeLabelEnd,
    resolveTo: $d208647f3b57f6c4$var$resolveToLabelEnd,
    resolveAll: $d208647f3b57f6c4$var$resolveAllLabelEnd
};
/** @type {Construct} */ const $d208647f3b57f6c4$var$resourceConstruct = {
    tokenize: $d208647f3b57f6c4$var$tokenizeResource
};
/** @type {Construct} */ const $d208647f3b57f6c4$var$referenceFullConstruct = {
    tokenize: $d208647f3b57f6c4$var$tokenizeReferenceFull
};
/** @type {Construct} */ const $d208647f3b57f6c4$var$referenceCollapsedConstruct = {
    tokenize: $d208647f3b57f6c4$var$tokenizeReferenceCollapsed
};
/** @type {Resolver} */ function $d208647f3b57f6c4$var$resolveAllLabelEnd(events) {
    let index = -1;
    while(++index < events.length){
        const token = events[index][1];
        if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
            // Remove the marker.
            events.splice(index + 1, token.type === "labelImage" ? 4 : 2);
            token.type = "data";
            index++;
        }
    }
    return events;
}
/** @type {Resolver} */ function $d208647f3b57f6c4$var$resolveToLabelEnd(events, context) {
    let index = events.length;
    let offset = 0;
    /** @type {Token} */ let token;
    /** @type {number | undefined} */ let open;
    /** @type {number | undefined} */ let close;
    /** @type {Array<Event>} */ let media;
    // Find an opening.
    while(index--){
        token = events[index][1];
        if (open) {
            // If we see another link, or inactive link label, we’ve been here before.
            if (token.type === "link" || token.type === "labelLink" && token._inactive) break;
            // Mark other link openings as inactive, as we can’t have links in
            // links.
            if (events[index][0] === "enter" && token.type === "labelLink") token._inactive = true;
        } else if (close) {
            if (events[index][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
                open = index;
                if (token.type !== "labelLink") {
                    offset = 2;
                    break;
                }
            }
        } else if (token.type === "labelEnd") close = index;
    }
    const group = {
        type: events[open][1].type === "labelLink" ? "link" : "image",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    const label = {
        type: "label",
        start: Object.assign({}, events[open][1].start),
        end: Object.assign({}, events[close][1].end)
    };
    const text = {
        type: "labelText",
        start: Object.assign({}, events[open + offset + 2][1].end),
        end: Object.assign({}, events[close - 2][1].start)
    };
    media = [
        [
            "enter",
            group,
            context
        ],
        [
            "enter",
            label,
            context
        ]
    ];
    // Opening marker.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, events.slice(open + 1, open + offset + 3));
    // Text open.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, [
        [
            "enter",
            text,
            context
        ]
    ]);
    // Always populated by defaults.
    // Between.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, (0, $ff8c7b537158f4c7$export$3ff61ec196ff408b)(context.parser.constructs.insideSpan.null, events.slice(open + offset + 4, close - 3), context));
    // Text close, marker close, label close.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, [
        [
            "exit",
            text,
            context
        ],
        events[close - 2],
        events[close - 1],
        [
            "exit",
            label,
            context
        ]
    ]);
    // Reference, resource, or so.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, events.slice(close + 1));
    // Media close.
    media = (0, $5720affce988170b$export$4cbf152802aa238)(media, [
        [
            "exit",
            group,
            context
        ]
    ]);
    (0, $5720affce988170b$export$869882364835d202)(events, open, events.length, media);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d208647f3b57f6c4$var$tokenizeLabelEnd(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    /** @type {Token} */ let labelStart;
    /** @type {boolean} */ let defined;
    // Find an opening.
    while(index--)if ((self.events[index][1].type === "labelImage" || self.events[index][1].type === "labelLink") && !self.events[index][1]._balanced) {
        labelStart = self.events[index][1];
        break;
    }
    return start;
    /**
   * Start of label end.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   * ```
   *
   * @type {State}
   */ function start(code) {
        // If there is not an okay opening.
        if (!labelStart) return nok(code);
        // If the corresponding label (link) start is marked as inactive,
        // it means we’d be wrapping a link, like this:
        //
        // ```markdown
        // > | a [b [c](d) e](f) g.
        //                  ^
        // ```
        //
        // We can’t have that, so it’s just balanced brackets.
        if (labelStart._inactive) return labelEndNok(code);
        defined = self.parser.defined.includes((0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        })));
        effects.enter("labelEnd");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelEnd");
        return after;
    }
    /**
   * After `]`.
   *
   * ```markdown
   * > | [a](b) c
   *       ^
   * > | [a][b] c
   *       ^
   * > | [a][] b
   *       ^
   * > | [a] b
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Note: `markdown-rs` also parses GFM footnotes here, which for us is in
        // an extension.
        // Resource (`[asd](fgh)`)?
        if (code === 40) return effects.attempt($d208647f3b57f6c4$var$resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code);
        // Full (`[asd][fgh]`) or collapsed (`[asd][]`) reference?
        if (code === 91) return effects.attempt($d208647f3b57f6c4$var$referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code);
        // Shortcut (`[asd]`) reference?
        return defined ? labelEndOk(code) : labelEndNok(code);
    }
    /**
   * After `]`, at `[`, but not at a full reference.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] b
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceNotFull(code) {
        return effects.attempt($d208647f3b57f6c4$var$referenceCollapsedConstruct, labelEndOk, labelEndNok)(code);
    }
    /**
   * Done, we found something.
   *
   * ```markdown
   * > | [a](b) c
   *           ^
   * > | [a][b] c
   *           ^
   * > | [a][] b
   *          ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndOk(code) {
        // Note: `markdown-rs` does a bunch of stuff here.
        return ok(code);
    }
    /**
   * Done, it’s nothing.
   *
   * There was an okay opening, but we didn’t match anything.
   *
   * ```markdown
   * > | [a](b c
   *        ^
   * > | [a][b c
   *        ^
   * > | [a] b
   *        ^
   * ```
   *
   * @type {State}
   */ function labelEndNok(code) {
        labelStart._balanced = true;
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d208647f3b57f6c4$var$tokenizeResource(effects, ok, nok) {
    return resourceStart;
    /**
   * At a resource.
   *
   * ```markdown
   * > | [a](b) c
   *        ^
   * ```
   *
   * @type {State}
   */ function resourceStart(code) {
        effects.enter("resource");
        effects.enter("resourceMarker");
        effects.consume(code);
        effects.exit("resourceMarker");
        return resourceBefore;
    }
    /**
   * In resource, after `(`, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceBefore(code) {
        return (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) ? (0, $84f290fc8a35b5b1$export$1f27bd1aa33ce173)(effects, resourceOpen)(code) : resourceOpen(code);
    }
    /**
   * In resource, after optional whitespace, at `)` or a destination.
   *
   * ```markdown
   * > | [a](b) c
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceOpen(code) {
        if (code === 41) return resourceEnd(code);
        return (0, $905db82bff251f54$export$2e6c8deaa96af245)(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code);
    }
    /**
   * In resource, after destination, at optional whitespace.
   *
   * ```markdown
   * > | [a](b) c
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationAfter(code) {
        return (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) ? (0, $84f290fc8a35b5b1$export$1f27bd1aa33ce173)(effects, resourceBetween)(code) : resourceEnd(code);
    }
    /**
   * At invalid destination.
   *
   * ```markdown
   * > | [a](<<) b
   *         ^
   * ```
   *
   * @type {State}
   */ function resourceDestinationMissing(code) {
        return nok(code);
    }
    /**
   * In resource, after destination and whitespace, at `(` or title.
   *
   * ```markdown
   * > | [a](b ) c
   *           ^
   * ```
   *
   * @type {State}
   */ function resourceBetween(code) {
        if (code === 34 || code === 39 || code === 40) return (0, $f9e3007c64ffd9a3$export$f970569cc855e483)(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code);
        return resourceEnd(code);
    }
    /**
   * In resource, after title, at optional whitespace.
   *
   * ```markdown
   * > | [a](b "c") d
   *              ^
   * ```
   *
   * @type {State}
   */ function resourceTitleAfter(code) {
        return (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) ? (0, $84f290fc8a35b5b1$export$1f27bd1aa33ce173)(effects, resourceEnd)(code) : resourceEnd(code);
    }
    /**
   * In resource, at `)`.
   *
   * ```markdown
   * > | [a](b) d
   *          ^
   * ```
   *
   * @type {State}
   */ function resourceEnd(code) {
        if (code === 41) {
            effects.enter("resourceMarker");
            effects.consume(code);
            effects.exit("resourceMarker");
            effects.exit("resource");
            return ok;
        }
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d208647f3b57f6c4$var$tokenizeReferenceFull(effects, ok, nok) {
    const self = this;
    return referenceFull;
    /**
   * In a reference (full), at the `[`.
   *
   * ```markdown
   * > | [a][b] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFull(code) {
        return (0, $fbba99e035dbf033$export$7b768614d8ba97a7).call(self, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code);
    }
    /**
   * In a reference (full), after `]`.
   *
   * ```markdown
   * > | [a][b] d
   *          ^
   * ```
   *
   * @type {State}
   */ function referenceFullAfter(code) {
        return self.parser.defined.includes((0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize(self.events[self.events.length - 1][1]).slice(1, -1))) ? ok(code) : nok(code);
    }
    /**
   * In reference (full) that was missing.
   *
   * ```markdown
   * > | [a][b d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceFullMissing(code) {
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $d208647f3b57f6c4$var$tokenizeReferenceCollapsed(effects, ok, nok) {
    return referenceCollapsedStart;
    /**
   * In reference (collapsed), at `[`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *        ^
   * ```
   *
   * @type {State}
   */ function referenceCollapsedStart(code) {
        // We only attempt a collapsed label if there’s a `[`.
        effects.enter("reference");
        effects.enter("referenceMarker");
        effects.consume(code);
        effects.exit("referenceMarker");
        return referenceCollapsedOpen;
    }
    /**
   * In reference (collapsed), at `]`.
   *
   * > 👉 **Note**: we only get here if the label is defined.
   *
   * ```markdown
   * > | [a][] d
   *         ^
   * ```
   *
   *  @type {State}
   */ function referenceCollapsedOpen(code) {
        if (code === 93) {
            effects.enter("referenceMarker");
            effects.consume(code);
            effects.exit("referenceMarker");
            effects.exit("reference");
            return ok;
        }
        return nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $0c5de4c4ae3c22f5$export$3d754936e25aa5f5 = {
    name: "labelStartImage",
    tokenize: $0c5de4c4ae3c22f5$var$tokenizeLabelStartImage,
    resolveAll: (0, $d208647f3b57f6c4$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $0c5de4c4ae3c22f5$var$tokenizeLabelStartImage(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (image) start.
   *
   * ```markdown
   * > | a ![b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelImage");
        effects.enter("labelImageMarker");
        effects.consume(code);
        effects.exit("labelImageMarker");
        return open;
    }
    /**
   * After `!`, at `[`.
   *
   * ```markdown
   * > | a ![b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (code === 91) {
            effects.enter("labelMarker");
            effects.consume(code);
            effects.exit("labelMarker");
            effects.exit("labelImage");
            return after;
        }
        return nok(code);
    }
    /**
   * After `![`.
   *
   * ```markdown
   * > | a ![b] c
   *         ^
   * ```
   *
   * This is needed in because, when GFM footnotes are enabled, images never
   * form when started with a `^`.
   * Instead, links form:
   *
   * ```markdown
   * ![^a](b)
   *
   * ![^a][b]
   *
   * [b]: c
   * ```
   *
   * ```html
   * <p>!<a href=\"b\">^a</a></p>
   * <p>!<a href=\"c\">^a</a></p>
   * ```
   *
   * @type {State}
   */ function after(code) {
        // To do: use a new field to do this, this is still needed for
        // `micromark-extension-gfm-footnote`, but the `label-start-link`
        // behavior isn’t.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $a81702b8af9ea267$export$5c0cee0701a3b584 = {
    name: "labelStartLink",
    tokenize: $a81702b8af9ea267$var$tokenizeLabelStartLink,
    resolveAll: (0, $d208647f3b57f6c4$export$470a5dafbbf62654).resolveAll
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a81702b8af9ea267$var$tokenizeLabelStartLink(effects, ok, nok) {
    const self = this;
    return start;
    /**
   * Start of label (link) start.
   *
   * ```markdown
   * > | a [b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("labelLink");
        effects.enter("labelMarker");
        effects.consume(code);
        effects.exit("labelMarker");
        effects.exit("labelLink");
        return after;
    }
    /** @type {State} */ function after(code) {
        // To do: this isn’t needed in `micromark-extension-gfm-footnote`,
        // remove.
        // Hidden footnotes hook.
        /* c8 ignore next 3 */ return code === 94 && "_hiddenFootnoteSupport" in self.parser.constructs ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $ae8f2195cf345c81$export$8e62e0ad51c97b2 = {
    name: "lineEnding",
    tokenize: $ae8f2195cf345c81$var$tokenizeLineEnding
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $ae8f2195cf345c81$var$tokenizeLineEnding(effects, ok) {
    return start;
    /** @type {State} */ function start(code) {
        effects.enter("lineEnding");
        effects.consume(code);
        effects.exit("lineEnding");
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, ok, "linePrefix");
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').ContainerState} ContainerState
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 


/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $535e471b3e1f25d5$export$ba7b13e047416c03 = {
    name: "thematicBreak",
    tokenize: $535e471b3e1f25d5$var$tokenizeThematicBreak
};
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $535e471b3e1f25d5$var$tokenizeThematicBreak(effects, ok, nok) {
    let size = 0;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * Start of thematic break.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("thematicBreak");
        // To do: parse indent like `markdown-rs`.
        return before(code);
    }
    /**
   * After optional whitespace, at marker.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        marker = code;
        return atBreak(code);
    }
    /**
   * After something, before something else.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function atBreak(code) {
        if (code === marker) {
            effects.enter("thematicBreakSequence");
            return sequence(code);
        }
        if (size >= 3 && (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code))) {
            effects.exit("thematicBreak");
            return ok(code);
        }
        return nok(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   * > | ***
   *     ^
   * ```
   *
   * @type {State}
   */ function sequence(code) {
        if (code === marker) {
            effects.consume(code);
            size++;
            return sequence;
        }
        effects.exit("thematicBreakSequence");
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, atBreak, "whitespace")(code) : atBreak(code);
    }
}


const $60b928773aa644b2$export$8837f4fc672e936d = {
    name: "list",
    tokenize: $60b928773aa644b2$var$tokenizeListStart,
    continuation: {
        tokenize: $60b928773aa644b2$var$tokenizeListContinuation
    },
    exit: $60b928773aa644b2$var$tokenizeListEnd
};
/** @type {Construct} */ const $60b928773aa644b2$var$listItemPrefixWhitespaceConstruct = {
    tokenize: $60b928773aa644b2$var$tokenizeListItemPrefixWhitespace,
    partial: true
};
/** @type {Construct} */ const $60b928773aa644b2$var$indentConstruct = {
    tokenize: $60b928773aa644b2$var$tokenizeIndent,
    partial: true
};
// To do: `markdown-rs` parses list items on their own and later stitches them
// together.
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $60b928773aa644b2$var$tokenizeListStart(effects, ok, nok) {
    const self = this;
    const tail = self.events[self.events.length - 1];
    let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    let size = 0;
    return start;
    /** @type {State} */ function start(code) {
        const kind = self.containerState.type || (code === 42 || code === 43 || code === 45 ? "listUnordered" : "listOrdered");
        if (kind === "listUnordered" ? !self.containerState.marker || code === self.containerState.marker : (0, $b4c110780d01af5f$export$ca8b5b1a6c320e6e)(code)) {
            if (!self.containerState.type) {
                self.containerState.type = kind;
                effects.enter(kind, {
                    _container: true
                });
            }
            if (kind === "listUnordered") {
                effects.enter("listItemPrefix");
                return code === 42 || code === 45 ? effects.check((0, $535e471b3e1f25d5$export$ba7b13e047416c03), nok, atMarker)(code) : atMarker(code);
            }
            if (!self.interrupt || code === 49) {
                effects.enter("listItemPrefix");
                effects.enter("listItemValue");
                return inside(code);
            }
        }
        return nok(code);
    }
    /** @type {State} */ function inside(code) {
        if ((0, $b4c110780d01af5f$export$ca8b5b1a6c320e6e)(code) && ++size < 10) {
            effects.consume(code);
            return inside;
        }
        if ((!self.interrupt || size < 2) && (self.containerState.marker ? code === self.containerState.marker : code === 41 || code === 46)) {
            effects.exit("listItemValue");
            return atMarker(code);
        }
        return nok(code);
    }
    /**
   * @type {State}
   **/ function atMarker(code) {
        effects.enter("listItemMarker");
        effects.consume(code);
        effects.exit("listItemMarker");
        self.containerState.marker = self.containerState.marker || code;
        return effects.check((0, $6462050da1e6035a$export$d50d28ce3ab2a612), // Can’t be empty when interrupting.
        self.interrupt ? nok : onBlank, effects.attempt($60b928773aa644b2$var$listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix));
    }
    /** @type {State} */ function onBlank(code) {
        self.containerState.initialBlankLine = true;
        initialSize++;
        return endOfPrefix(code);
    }
    /** @type {State} */ function otherPrefix(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            effects.enter("listItemPrefixWhitespace");
            effects.consume(code);
            effects.exit("listItemPrefixWhitespace");
            return endOfPrefix;
        }
        return nok(code);
    }
    /** @type {State} */ function endOfPrefix(code) {
        self.containerState.size = initialSize + self.sliceSerialize(effects.exit("listItemPrefix"), true).length;
        return ok(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $60b928773aa644b2$var$tokenizeListContinuation(effects, ok, nok) {
    const self = this;
    self.containerState._closeFlow = undefined;
    return effects.check((0, $6462050da1e6035a$export$d50d28ce3ab2a612), onBlank, notBlank);
    /** @type {State} */ function onBlank(code) {
        self.containerState.furtherBlankLines = self.containerState.furtherBlankLines || self.containerState.initialBlankLine;
        // We have a blank line.
        // Still, try to consume at most the items size.
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, ok, "listItemIndent", self.containerState.size + 1)(code);
    }
    /** @type {State} */ function notBlank(code) {
        if (self.containerState.furtherBlankLines || !(0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) {
            self.containerState.furtherBlankLines = undefined;
            self.containerState.initialBlankLine = undefined;
            return notInCurrentItem(code);
        }
        self.containerState.furtherBlankLines = undefined;
        self.containerState.initialBlankLine = undefined;
        return effects.attempt($60b928773aa644b2$var$indentConstruct, ok, notInCurrentItem)(code);
    }
    /** @type {State} */ function notInCurrentItem(code) {
        // While we do continue, we signal that the flow should be closed.
        self.containerState._closeFlow = true;
        // As we’re closing flow, we’re no longer interrupting.
        self.interrupt = undefined;
        // Always populated by defaults.
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, effects.attempt($60b928773aa644b2$export$8837f4fc672e936d, ok, nok), "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
    }
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $60b928773aa644b2$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemIndent", self.containerState.size + 1);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self.containerState.size ? ok(code) : nok(code);
    }
}
/**
 * @type {Exiter}
 * @this {TokenizeContext}
 */ function $60b928773aa644b2$var$tokenizeListEnd(effects) {
    effects.exit(this.containerState.type);
}
/**
 * @type {Tokenizer}
 * @this {TokenizeContext}
 */ function $60b928773aa644b2$var$tokenizeListItemPrefixWhitespace(effects, ok, nok) {
    const self = this;
    // Always populated by defaults.
    return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterPrefix, "listItemPrefixWhitespace", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 5);
    /** @type {State} */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return !(0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Construct} Construct
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $233d7da812ddda71$export$e104e2de391dfde9 = {
    name: "setextUnderline",
    tokenize: $233d7da812ddda71$var$tokenizeSetextUnderline,
    resolveTo: $233d7da812ddda71$var$resolveToSetextUnderline
};
/** @type {Resolver} */ function $233d7da812ddda71$var$resolveToSetextUnderline(events, context) {
    // To do: resolve like `markdown-rs`.
    let index = events.length;
    /** @type {number | undefined} */ let content;
    /** @type {number | undefined} */ let text;
    /** @type {number | undefined} */ let definition;
    // Find the opening of the content.
    // It’ll always exist: we don’t tokenize if it isn’t there.
    while(index--)if (events[index][0] === "enter") {
        if (events[index][1].type === "content") {
            content = index;
            break;
        }
        if (events[index][1].type === "paragraph") text = index;
    } else {
        if (events[index][1].type === "content") // Remove the content end (if needed we’ll add it later)
        events.splice(index, 1);
        if (!definition && events[index][1].type === "definition") definition = index;
    }
    const heading = {
        type: "setextHeading",
        start: Object.assign({}, events[text][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // Change the paragraph to setext heading text.
    events[text][1].type = "setextHeadingText";
    // If we have definitions in the content, we’ll keep on having content,
    // but we need move it.
    if (definition) {
        events.splice(text, 0, [
            "enter",
            heading,
            context
        ]);
        events.splice(definition + 1, 0, [
            "exit",
            events[content][1],
            context
        ]);
        events[content][1].end = Object.assign({}, events[definition][1].end);
    } else events[content][1] = heading;
    // Add the heading exit at the end.
    events.push([
        "exit",
        heading,
        context
    ]);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $233d7da812ddda71$var$tokenizeSetextUnderline(effects, ok, nok) {
    const self = this;
    /** @type {NonNullable<Code>} */ let marker;
    return start;
    /**
   * At start of heading (setext) underline.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        let index = self.events.length;
        /** @type {boolean | undefined} */ let paragraph;
        // Find an opening.
        while(index--)// Skip enter/exit of line ending, line prefix, and content.
        // We can now either have a definition or a paragraph.
        if (self.events[index][1].type !== "lineEnding" && self.events[index][1].type !== "linePrefix" && self.events[index][1].type !== "content") {
            paragraph = self.events[index][1].type === "paragraph";
            break;
        }
        // To do: handle lazy/pierce like `markdown-rs`.
        // To do: parse indent like `markdown-rs`.
        if (!self.parser.lazy[self.now().line] && (self.interrupt || paragraph)) {
            effects.enter("setextHeadingLine");
            marker = code;
            return before(code);
        }
        return nok(code);
    }
    /**
   * After optional whitespace, at `-` or `=`.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function before(code) {
        effects.enter("setextHeadingLineSequence");
        return inside(code);
    }
    /**
   * In sequence.
   *
   * ```markdown
   *   | aa
   * > | ==
   *     ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        if (code === marker) {
            effects.consume(code);
            return inside;
        }
        effects.exit("setextHeadingLineSequence");
        return (0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code) ? (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, after, "lineSuffix")(code) : after(code);
    }
    /**
   * After sequence, after optional whitespace.
   *
   * ```markdown
   *   | aa
   * > | ==
   *       ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("setextHeadingLine");
            return ok(code);
        }
        return nok(code);
    }
}



const $ddaee6ba621e609d$export$5a7bfc01df82fcd1 = {
    [42]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [43]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [45]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [48]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [49]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [50]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [51]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [52]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [53]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [54]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [55]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [56]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [57]: (0, $60b928773aa644b2$export$8837f4fc672e936d),
    [62]: (0, $f340675ed8c47c20$export$200dcd0a5903c968)
};
const $ddaee6ba621e609d$export$5a2181fb44b58173 = {
    [91]: (0, $0dfaba7180aafd37$export$69f215ed977cdb73)
};
const $ddaee6ba621e609d$export$cf8bead395eff824 = {
    [-2]: (0, $d3fbfbfd857fa6bf$export$47910b7ab28d1853),
    [-1]: (0, $d3fbfbfd857fa6bf$export$47910b7ab28d1853),
    [32]: (0, $d3fbfbfd857fa6bf$export$47910b7ab28d1853)
};
const $ddaee6ba621e609d$export$ccc7b0636abaffc3 = {
    [35]: (0, $9dd159508d941fea$export$3871e9deb360695c),
    [42]: (0, $535e471b3e1f25d5$export$ba7b13e047416c03),
    [45]: [
        (0, $233d7da812ddda71$export$e104e2de391dfde9),
        (0, $535e471b3e1f25d5$export$ba7b13e047416c03)
    ],
    [60]: (0, $3c60187190fb773d$export$476ac411cb7d0d8f),
    [61]: (0, $233d7da812ddda71$export$e104e2de391dfde9),
    [95]: (0, $535e471b3e1f25d5$export$ba7b13e047416c03),
    [96]: (0, $b21b05fad854d61f$export$c23e4921f8d87e7c),
    [126]: (0, $b21b05fad854d61f$export$c23e4921f8d87e7c)
};
const $ddaee6ba621e609d$export$22b082955e083ec3 = {
    [38]: (0, $12c3fbf72e440502$export$e31905600aaf3d8e),
    [92]: (0, $81a53f0b1a6e2516$export$2005478564e78d96)
};
const $ddaee6ba621e609d$export$6f093cfa640b7166 = {
    [-5]: (0, $ae8f2195cf345c81$export$8e62e0ad51c97b2),
    [-4]: (0, $ae8f2195cf345c81$export$8e62e0ad51c97b2),
    [-3]: (0, $ae8f2195cf345c81$export$8e62e0ad51c97b2),
    [33]: (0, $0c5de4c4ae3c22f5$export$3d754936e25aa5f5),
    [38]: (0, $12c3fbf72e440502$export$e31905600aaf3d8e),
    [42]: (0, $7e72189b143d2036$export$45b92471da762af7),
    [60]: [
        (0, $733e76032c6978d4$export$17ddf85e4c916ad6),
        (0, $b8af2897e3abb59b$export$398af27f284914fe)
    ],
    [91]: (0, $a81702b8af9ea267$export$5c0cee0701a3b584),
    [92]: [
        (0, $68311ec08720b6e0$export$86c573ab9e06f418),
        (0, $81a53f0b1a6e2516$export$2005478564e78d96)
    ],
    [93]: (0, $d208647f3b57f6c4$export$470a5dafbbf62654),
    [95]: (0, $7e72189b143d2036$export$45b92471da762af7),
    [96]: (0, $f528bb1b63694fb9$export$d24f93e715f9df88)
};
const $ddaee6ba621e609d$export$d44f260a3f9b69f5 = {
    null: [
        (0, $7e72189b143d2036$export$45b92471da762af7),
        (0, $cb6447d82e9d703c$export$50397835cbfdbc24)
    ]
};
const $ddaee6ba621e609d$export$b9c0b60d74426aea = {
    null: [
        42,
        95
    ]
};
const $ddaee6ba621e609d$export$e20fbacbb41798b = {
    null: []
};


function $a0227096c7a3d9d3$export$98e6a39c04603d36(options) {
    const settings = options || {};
    const constructs = /** @type {FullNormalizedExtension} */ (0, $4902ed8d243ad70e$export$86a865d89ef3c690)([
        $ddaee6ba621e609d$exports,
        ...settings.extensions || []
    ]);
    /** @type {ParseContext} */ const parser = {
        defined: [],
        lazy: {},
        constructs: constructs,
        content: create((0, $a2fbc673d13ffc29$export$a7db06668cad9adb)),
        document: create((0, $6728e34912905e82$export$5a7bfc01df82fcd1)),
        flow: create((0, $136eeee8daab488e$export$ccc7b0636abaffc3)),
        string: create((0, $cb6447d82e9d703c$export$22b082955e083ec3)),
        text: create((0, $cb6447d82e9d703c$export$6f093cfa640b7166))
    };
    return parser;
    /**
   * @param {InitialConstruct} initial
   */ function create(initial) {
        return creator;
        /** @type {Create} */ function creator(from) {
            return (0, $97f7327678708c2e$export$ae34f10ee4b29837)(parser, initial, from);
        }
    }
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ 
function $c0f08ea7774b0f08$export$bd0e6e1378a871d7(events) {
    while(!(0, $32a1128000851050$export$12949d1dd00fddf4)(events));
    return events;
}


/**
 * @typedef {import('micromark-util-types').Chunk} Chunk
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').Encoding} Encoding
 * @typedef {import('micromark-util-types').Value} Value
 */ /**
 * @callback Preprocessor
 * @param {Value} value
 * @param {Encoding | null | undefined} [encoding]
 * @param {boolean | null | undefined} [end=false]
 * @returns {Array<Chunk>}
 */ const $cfeb7e92e89cad0c$var$search = /[\0\t\n\r]/g;
function $cfeb7e92e89cad0c$export$fc37fe19dfda43ee() {
    let column = 1;
    let buffer = "";
    /** @type {boolean | undefined} */ let start = true;
    /** @type {boolean | undefined} */ let atCarriageReturn;
    return preprocessor;
    /** @type {Preprocessor} */ // eslint-disable-next-line complexity
    function preprocessor(value, encoding, end) {
        /** @type {Array<Chunk>} */ const chunks = [];
        /** @type {RegExpMatchArray | null} */ let match;
        /** @type {number} */ let next;
        /** @type {number} */ let startPosition;
        /** @type {number} */ let endPosition;
        /** @type {Code} */ let code;
        value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || undefined).decode(value));
        startPosition = 0;
        buffer = "";
        if (start) {
            // To do: `markdown-rs` actually parses BOMs (byte order mark).
            if (value.charCodeAt(0) === 65279) startPosition++;
            start = undefined;
        }
        while(startPosition < value.length){
            $cfeb7e92e89cad0c$var$search.lastIndex = startPosition;
            match = $cfeb7e92e89cad0c$var$search.exec(value);
            endPosition = match && match.index !== undefined ? match.index : value.length;
            code = value.charCodeAt(endPosition);
            if (!match) {
                buffer = value.slice(startPosition);
                break;
            }
            if (code === 10 && startPosition === endPosition && atCarriageReturn) {
                chunks.push(-3);
                atCarriageReturn = undefined;
            } else {
                if (atCarriageReturn) {
                    chunks.push(-5);
                    atCarriageReturn = undefined;
                }
                if (startPosition < endPosition) {
                    chunks.push(value.slice(startPosition, endPosition));
                    column += endPosition - startPosition;
                }
                switch(code){
                    case 0:
                        chunks.push(65533);
                        column++;
                        break;
                    case 9:
                        next = Math.ceil(column / 4) * 4;
                        chunks.push(-2);
                        while(column++ < next)chunks.push(-1);
                        break;
                    case 10:
                        chunks.push(-4);
                        column = 1;
                        break;
                    default:
                        atCarriageReturn = true;
                        column = 1;
                }
            }
            startPosition = endPosition + 1;
        }
        if (end) {
            if (atCarriageReturn) chunks.push(-5);
            if (buffer) chunks.push(buffer);
            chunks.push(null);
        }
        return chunks;
    }
}


function $83a345947849f972$export$eb6d260b88819962(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return (0, $c56b064c2cb3718f$export$ef7acd7185315e22)(options)((0, $c0f08ea7774b0f08$export$bd0e6e1378a871d7)((0, $a0227096c7a3d9d3$export$98e6a39c04603d36)(options).document().write((0, $cfeb7e92e89cad0c$export$fc37fe19dfda43ee)()(value, encoding, true))));
}





const $fd54ada4861b2bf3$var$characterEscapeOrReference = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function $fd54ada4861b2bf3$export$a0fb664af7d0cc44(value) {
    return value.replace($fd54ada4861b2bf3$var$characterEscapeOrReference, $fd54ada4861b2bf3$var$decode);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @param {string} $2
 * @returns {string}
 */ function $fd54ada4861b2bf3$var$decode($0, $1, $2) {
    if ($1) // Escape.
    return $1;
    // Reference.
    const head = $2.charCodeAt(0);
    if (head === 35) {
        const head = $2.charCodeAt(1);
        const hex = head === 120 || head === 88;
        return (0, $de6a351f52b69b30$export$15a69557afac2c20)($2.slice(hex ? 2 : 1), hex ? 16 : 10);
    }
    return (0, $04b95225700f8616$export$289b6a6320f709b4)($2) || $0;
}





const $7f1f30d85f0808d5$var$own = {}.hasOwnProperty;
function $7f1f30d85f0808d5$export$d744d789c09bfde6(value, encoding, options) {
    if (typeof encoding !== "string") {
        options = encoding;
        encoding = undefined;
    }
    return $7f1f30d85f0808d5$var$compiler(options)((0, $c0f08ea7774b0f08$export$bd0e6e1378a871d7)((0, $a0227096c7a3d9d3$export$98e6a39c04603d36)(options).document().write((0, $cfeb7e92e89cad0c$export$fc37fe19dfda43ee)()(value, encoding, true))));
}
/**
 * Note this compiler only understand complete buffering, not streaming.
 *
 * @param {Options | null | undefined} [options]
 */ function $7f1f30d85f0808d5$var$compiler(options) {
    /** @type {Config} */ const config = {
        transforms: [],
        canContainEols: [
            "emphasis",
            "fragment",
            "heading",
            "paragraph",
            "strong"
        ],
        enter: {
            autolink: opener(link),
            autolinkProtocol: onenterdata,
            autolinkEmail: onenterdata,
            atxHeading: opener(heading),
            blockQuote: opener(blockQuote),
            characterEscape: onenterdata,
            characterReference: onenterdata,
            codeFenced: opener(codeFlow),
            codeFencedFenceInfo: buffer,
            codeFencedFenceMeta: buffer,
            codeIndented: opener(codeFlow, buffer),
            codeText: opener(codeText, buffer),
            codeTextData: onenterdata,
            data: onenterdata,
            codeFlowValue: onenterdata,
            definition: opener(definition),
            definitionDestinationString: buffer,
            definitionLabelString: buffer,
            definitionTitleString: buffer,
            emphasis: opener(emphasis),
            hardBreakEscape: opener(hardBreak),
            hardBreakTrailing: opener(hardBreak),
            htmlFlow: opener(html, buffer),
            htmlFlowData: onenterdata,
            htmlText: opener(html, buffer),
            htmlTextData: onenterdata,
            image: opener(image),
            label: buffer,
            link: opener(link),
            listItem: opener(listItem),
            listItemValue: onenterlistitemvalue,
            listOrdered: opener(list, onenterlistordered),
            listUnordered: opener(list),
            paragraph: opener(paragraph),
            reference: onenterreference,
            referenceString: buffer,
            resourceDestinationString: buffer,
            resourceTitleString: buffer,
            setextHeading: opener(heading),
            strong: opener(strong),
            thematicBreak: opener(thematicBreak)
        },
        exit: {
            atxHeading: closer(),
            atxHeadingSequence: onexitatxheadingsequence,
            autolink: closer(),
            autolinkEmail: onexitautolinkemail,
            autolinkProtocol: onexitautolinkprotocol,
            blockQuote: closer(),
            characterEscapeValue: onexitdata,
            characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
            characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
            characterReferenceValue: onexitcharacterreferencevalue,
            codeFenced: closer(onexitcodefenced),
            codeFencedFence: onexitcodefencedfence,
            codeFencedFenceInfo: onexitcodefencedfenceinfo,
            codeFencedFenceMeta: onexitcodefencedfencemeta,
            codeFlowValue: onexitdata,
            codeIndented: closer(onexitcodeindented),
            codeText: closer(onexitcodetext),
            codeTextData: onexitdata,
            data: onexitdata,
            definition: closer(),
            definitionDestinationString: onexitdefinitiondestinationstring,
            definitionLabelString: onexitdefinitionlabelstring,
            definitionTitleString: onexitdefinitiontitlestring,
            emphasis: closer(),
            hardBreakEscape: closer(onexithardbreak),
            hardBreakTrailing: closer(onexithardbreak),
            htmlFlow: closer(onexithtmlflow),
            htmlFlowData: onexitdata,
            htmlText: closer(onexithtmltext),
            htmlTextData: onexitdata,
            image: closer(onexitimage),
            label: onexitlabel,
            labelText: onexitlabeltext,
            lineEnding: onexitlineending,
            link: closer(onexitlink),
            listItem: closer(),
            listOrdered: closer(),
            listUnordered: closer(),
            paragraph: closer(),
            referenceString: onexitreferencestring,
            resourceDestinationString: onexitresourcedestinationstring,
            resourceTitleString: onexitresourcetitlestring,
            resource: onexitresource,
            setextHeading: closer(onexitsetextheading),
            setextHeadingLineSequence: onexitsetextheadinglinesequence,
            setextHeadingText: onexitsetextheadingtext,
            strong: closer(),
            thematicBreak: closer()
        }
    };
    $7f1f30d85f0808d5$var$configure(config, (options || {}).mdastExtensions || []);
    /** @type {CompileData} */ const data = {};
    return compile;
    /**
   * Turn micromark events into an mdast tree.
   *
   * @param {Array<Event>} events
   *   Events.
   * @returns {Root}
   *   mdast tree.
   */ function compile(events) {
        /** @type {Root} */ let tree = {
            type: "root",
            children: []
        };
        /** @type {Omit<CompileContext, 'sliceSerialize'>} */ const context = {
            stack: [
                tree
            ],
            tokenStack: [],
            config: config,
            enter: enter,
            exit: exit,
            buffer: buffer,
            resume: resume,
            data: data
        };
        /** @type {Array<number>} */ const listStack = [];
        let index = -1;
        while(++index < events.length)// We preprocess lists to add `listItem` tokens, and to infer whether
        // items the list itself are spread out.
        if (events[index][1].type === "listOrdered" || events[index][1].type === "listUnordered") {
            if (events[index][0] === "enter") listStack.push(index);
            else {
                const tail = listStack.pop();
                index = prepareList(events, tail, index);
            }
        }
        index = -1;
        while(++index < events.length){
            const handler = config[events[index][0]];
            if ($7f1f30d85f0808d5$var$own.call(handler, events[index][1].type)) handler[events[index][1].type].call(Object.assign({
                sliceSerialize: events[index][2].sliceSerialize
            }, context), events[index][1]);
        }
        // Handle tokens still being open.
        if (context.tokenStack.length > 0) {
            const tail = context.tokenStack[context.tokenStack.length - 1];
            const handler = tail[1] || $7f1f30d85f0808d5$var$defaultOnError;
            handler.call(context, undefined, tail[0]);
        }
        // Figure out `root` position.
        tree.position = {
            start: $7f1f30d85f0808d5$var$point(events.length > 0 ? events[0][1].start : {
                line: 1,
                column: 1,
                offset: 0
            }),
            end: $7f1f30d85f0808d5$var$point(events.length > 0 ? events[events.length - 2][1].end : {
                line: 1,
                column: 1,
                offset: 0
            })
        };
        // Call transforms.
        index = -1;
        while(++index < config.transforms.length)tree = config.transforms[index](tree) || tree;
        return tree;
    }
    /**
   * @param {Array<Event>} events
   * @param {number} start
   * @param {number} length
   * @returns {number}
   */ function prepareList(events, start, length) {
        let index = start - 1;
        let containerBalance = -1;
        let listSpread = false;
        /** @type {Token | undefined} */ let listItem;
        /** @type {number | undefined} */ let lineIndex;
        /** @type {number | undefined} */ let firstBlankLineIndex;
        /** @type {boolean | undefined} */ let atMarker;
        while(++index <= length){
            const event = events[index];
            switch(event[1].type){
                case "listUnordered":
                case "listOrdered":
                case "blockQuote":
                    if (event[0] === "enter") containerBalance++;
                    else containerBalance--;
                    atMarker = undefined;
                    break;
                case "lineEndingBlank":
                    if (event[0] === "enter") {
                        if (listItem && !atMarker && !containerBalance && !firstBlankLineIndex) firstBlankLineIndex = index;
                        atMarker = undefined;
                    }
                    break;
                case "linePrefix":
                case "listItemValue":
                case "listItemMarker":
                case "listItemPrefix":
                case "listItemPrefixWhitespace":
                    break;
                default:
                    atMarker = undefined;
            }
            if (!containerBalance && event[0] === "enter" && event[1].type === "listItemPrefix" || containerBalance === -1 && event[0] === "exit" && (event[1].type === "listUnordered" || event[1].type === "listOrdered")) {
                if (listItem) {
                    let tailIndex = index;
                    lineIndex = undefined;
                    while(tailIndex--){
                        const tailEvent = events[tailIndex];
                        if (tailEvent[1].type === "lineEnding" || tailEvent[1].type === "lineEndingBlank") {
                            if (tailEvent[0] === "exit") continue;
                            if (lineIndex) {
                                events[lineIndex][1].type = "lineEndingBlank";
                                listSpread = true;
                            }
                            tailEvent[1].type = "lineEnding";
                            lineIndex = tailIndex;
                        } else if (tailEvent[1].type === "linePrefix" || tailEvent[1].type === "blockQuotePrefix" || tailEvent[1].type === "blockQuotePrefixWhitespace" || tailEvent[1].type === "blockQuoteMarker" || tailEvent[1].type === "listItemIndent") ;
                        else break;
                    }
                    if (firstBlankLineIndex && (!lineIndex || firstBlankLineIndex < lineIndex)) listItem._spread = true;
                    // Fix position.
                    listItem.end = Object.assign({}, lineIndex ? events[lineIndex][1].start : event[1].end);
                    events.splice(lineIndex || index, 0, [
                        "exit",
                        listItem,
                        event[2]
                    ]);
                    index++;
                    length++;
                }
                // Create a new list item.
                if (event[1].type === "listItemPrefix") {
                    /** @type {Token} */ const item = {
                        type: "listItem",
                        _spread: false,
                        start: Object.assign({}, event[1].start),
                        // @ts-expect-error: we’ll add `end` in a second.
                        end: undefined
                    };
                    listItem = item;
                    events.splice(index, 0, [
                        "enter",
                        item,
                        event[2]
                    ]);
                    index++;
                    length++;
                    firstBlankLineIndex = undefined;
                    atMarker = true;
                }
            }
        }
        events[start][1]._spread = listSpread;
        return length;
    }
    /**
   * Create an opener handle.
   *
   * @param {(token: Token) => Nodes} create
   *   Create a node.
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function opener(create, and) {
        return open;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function open(token) {
            enter.call(this, create(token), token);
            if (and) and.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @returns {undefined}
   */ function buffer() {
        this.stack.push({
            type: "fragment",
            children: []
        });
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Nodes} node
   *   Node to enter.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnEnterError | undefined} [errorHandler]
   *   Handle the case where this token is open, but it is closed by something else.
   * @returns {undefined}
   *   Nothing.
   */ function enter(node, token, errorHandler) {
        const parent = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        siblings.push(node);
        this.stack.push(node);
        this.tokenStack.push([
            token,
            errorHandler
        ]);
        node.position = {
            start: $7f1f30d85f0808d5$var$point(token.start),
            // @ts-expect-error: `end` will be patched later.
            end: undefined
        };
    }
    /**
   * Create a closer handle.
   *
   * @param {Handle | undefined} [and]
   *   Optional function to also run.
   * @returns {Handle}
   *   Handle.
   */ function closer(and) {
        return close;
        /**
     * @this {CompileContext}
     * @param {Token} token
     * @returns {undefined}
     */ function close(token) {
            if (and) and.call(this, token);
            exit.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   *   Context.
   * @param {Token} token
   *   Corresponding token.
   * @param {OnExitError | undefined} [onExitError]
   *   Handle the case where another token is open.
   * @returns {undefined}
   *   Nothing.
   */ function exit(token, onExitError) {
        const node = this.stack.pop();
        const open = this.tokenStack.pop();
        if (!open) throw new Error("Cannot close `" + token.type + "` (" + (0, $9628fc39c3f83a4c$export$c304dd45fe166145)({
            start: token.start,
            end: token.end
        }) + "): it’s not open");
        else if (open[0].type !== token.type) {
            if (onExitError) onExitError.call(this, token, open[0]);
            else {
                const handler = open[1] || $7f1f30d85f0808d5$var$defaultOnError;
                handler.call(this, token, open[0]);
            }
        }
        node.position.end = $7f1f30d85f0808d5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @returns {string}
   */ function resume() {
        return (0, $05e7756bd26ae88a$export$f84e8e69fd4488a5)(this.stack.pop());
    }
    //
    // Handlers.
    //
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistordered() {
        this.data.expectingFirstListItemValue = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterlistitemvalue(token) {
        if (this.data.expectingFirstListItemValue) {
            const ancestor = this.stack[this.stack.length - 2];
            ancestor.start = Number.parseInt(this.sliceSerialize(token), 10);
            this.data.expectingFirstListItemValue = undefined;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfenceinfo() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.lang = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfencemeta() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.meta = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefencedfence() {
        // Exit if this is the closing fence.
        if (this.data.flowCodeInside) return;
        this.buffer();
        this.data.flowCodeInside = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodefenced() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, "");
        this.data.flowCodeInside = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodeindented() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data.replace(/(\r?\n|\r)$/g, "");
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitionlabelstring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.label = label;
        node.identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiontitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdefinitiondestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitatxheadingsequence(token) {
        const node = this.stack[this.stack.length - 1];
        if (!node.depth) {
            const depth = this.sliceSerialize(token).length;
            node.depth = depth;
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadingtext() {
        this.data.setextHeadingSlurpLineEnding = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheadinglinesequence(token) {
        const node = this.stack[this.stack.length - 1];
        node.depth = this.sliceSerialize(token).codePointAt(0) === 61 ? 1 : 2;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitsetextheading() {
        this.data.setextHeadingSlurpLineEnding = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterdata(token) {
        const node = this.stack[this.stack.length - 1];
        /** @type {Array<Nodes>} */ const siblings = node.children;
        let tail = siblings[siblings.length - 1];
        if (!tail || tail.type !== "text") {
            // Add a new text node.
            tail = text();
            tail.position = {
                start: $7f1f30d85f0808d5$var$point(token.start),
                // @ts-expect-error: we’ll add `end` later.
                end: undefined
            };
            siblings.push(tail);
        }
        this.stack.push(tail);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitdata(token) {
        const tail = this.stack.pop();
        tail.value += this.sliceSerialize(token);
        tail.position.end = $7f1f30d85f0808d5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlineending(token) {
        const context = this.stack[this.stack.length - 1];
        // If we’re at a hard break, include the line ending in there.
        if (this.data.atHardBreak) {
            const tail = context.children[context.children.length - 1];
            tail.position.end = $7f1f30d85f0808d5$var$point(token.end);
            this.data.atHardBreak = undefined;
            return;
        }
        if (!this.data.setextHeadingSlurpLineEnding && config.canContainEols.includes(context.type)) {
            onenterdata.call(this, token);
            onexitdata.call(this, token);
        }
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithardbreak() {
        this.data.atHardBreak = true;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmlflow() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexithtmltext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcodetext() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.value = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlink() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitimage() {
        const node = this.stack[this.stack.length - 1];
        // Note: there are also `identifier` and `label` fields on this link node!
        // These are used / cleaned here.
        // To do: clean.
        if (this.data.inReference) {
            /** @type {ReferenceType} */ const referenceType = this.data.referenceType || "shortcut";
            node.type += "Reference";
            // @ts-expect-error: mutate.
            node.referenceType = referenceType;
            // @ts-expect-error: mutate.
            delete node.url;
            delete node.title;
        } else {
            // @ts-expect-error: mutate.
            delete node.identifier;
            // @ts-expect-error: mutate.
            delete node.label;
        }
        this.data.referenceType = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabeltext(token) {
        const string = this.sliceSerialize(token);
        const ancestor = this.stack[this.stack.length - 2];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        ancestor.label = (0, $fd54ada4861b2bf3$export$a0fb664af7d0cc44)(string);
        // @ts-expect-error: same as above.
        ancestor.identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(string).toLowerCase();
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitlabel() {
        const fragment = this.stack[this.stack.length - 1];
        const value = this.resume();
        const node = this.stack[this.stack.length - 1];
        // Assume a reference.
        this.data.inReference = true;
        if (node.type === "link") {
            /** @type {Array<PhrasingContent>} */ const children = fragment.children;
            node.children = children;
        } else node.alt = value;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcedestinationstring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.url = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresourcetitlestring() {
        const data = this.resume();
        const node = this.stack[this.stack.length - 1];
        node.title = data;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitresource() {
        this.data.inReference = undefined;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onenterreference() {
        this.data.referenceType = "collapsed";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitreferencestring(token) {
        const label = this.resume();
        const node = this.stack[this.stack.length - 1];
        // @ts-expect-error: stash this on the node, as it might become a reference
        // later.
        node.label = label;
        // @ts-expect-error: same as above.
        node.identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
        this.data.referenceType = "full";
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencemarker(token) {
        this.data.characterReferenceType = token.type;
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitcharacterreferencevalue(token) {
        const data = this.sliceSerialize(token);
        const type = this.data.characterReferenceType;
        /** @type {string} */ let value;
        if (type) {
            value = (0, $de6a351f52b69b30$export$15a69557afac2c20)(data, type === "characterReferenceMarkerNumeric" ? 10 : 16);
            this.data.characterReferenceType = undefined;
        } else {
            const result = (0, $04b95225700f8616$export$289b6a6320f709b4)(data);
            value = result;
        }
        const tail = this.stack.pop();
        tail.value += value;
        tail.position.end = $7f1f30d85f0808d5$var$point(token.end);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkprotocol(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = this.sliceSerialize(token);
    }
    /**
   * @this {CompileContext}
   * @type {Handle}
   */ function onexitautolinkemail(token) {
        onexitdata.call(this, token);
        const node = this.stack[this.stack.length - 1];
        node.url = "mailto:" + this.sliceSerialize(token);
    }
    //
    // Creaters.
    //
    /** @returns {Blockquote} */ function blockQuote() {
        return {
            type: "blockquote",
            children: []
        };
    }
    /** @returns {Code} */ function codeFlow() {
        return {
            type: "code",
            lang: null,
            meta: null,
            value: ""
        };
    }
    /** @returns {InlineCode} */ function codeText() {
        return {
            type: "inlineCode",
            value: ""
        };
    }
    /** @returns {Definition} */ function definition() {
        return {
            type: "definition",
            identifier: "",
            label: null,
            title: null,
            url: ""
        };
    }
    /** @returns {Emphasis} */ function emphasis() {
        return {
            type: "emphasis",
            children: []
        };
    }
    /** @returns {Heading} */ function heading() {
        return {
            type: "heading",
            // @ts-expect-error `depth` will be set later.
            depth: 0,
            children: []
        };
    }
    /** @returns {Break} */ function hardBreak() {
        return {
            type: "break"
        };
    }
    /** @returns {Html} */ function html() {
        return {
            type: "html",
            value: ""
        };
    }
    /** @returns {Image} */ function image() {
        return {
            type: "image",
            title: null,
            url: "",
            alt: null
        };
    }
    /** @returns {Link} */ function link() {
        return {
            type: "link",
            title: null,
            url: "",
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {List}
   */ function list(token) {
        return {
            type: "list",
            ordered: token.type === "listOrdered",
            start: null,
            spread: token._spread,
            children: []
        };
    }
    /**
   * @param {Token} token
   * @returns {ListItem}
   */ function listItem(token) {
        return {
            type: "listItem",
            spread: token._spread,
            checked: null,
            children: []
        };
    }
    /** @returns {Paragraph} */ function paragraph() {
        return {
            type: "paragraph",
            children: []
        };
    }
    /** @returns {Strong} */ function strong() {
        return {
            type: "strong",
            children: []
        };
    }
    /** @returns {Text} */ function text() {
        return {
            type: "text",
            value: ""
        };
    }
    /** @returns {ThematicBreak} */ function thematicBreak() {
        return {
            type: "thematicBreak"
        };
    }
}
/**
 * Copy a point-like value.
 *
 * @param {Point} d
 *   Point-like value.
 * @returns {Point}
 *   unist point.
 */ function $7f1f30d85f0808d5$var$point(d) {
    return {
        line: d.line,
        column: d.column,
        offset: d.offset
    };
}
/**
 * @param {Config} combined
 * @param {Array<Array<Extension> | Extension>} extensions
 * @returns {undefined}
 */ function $7f1f30d85f0808d5$var$configure(combined, extensions) {
    let index = -1;
    while(++index < extensions.length){
        const value = extensions[index];
        if (Array.isArray(value)) $7f1f30d85f0808d5$var$configure(combined, value);
        else $7f1f30d85f0808d5$var$extension(combined, value);
    }
}
/**
 * @param {Config} combined
 * @param {Extension} extension
 * @returns {undefined}
 */ function $7f1f30d85f0808d5$var$extension(combined, extension) {
    /** @type {keyof Extension} */ let key;
    for(key in extension)if ($7f1f30d85f0808d5$var$own.call(extension, key)) switch(key){
        case "canContainEols":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "transforms":
            {
                const right = extension[key];
                if (right) combined[key].push(...right);
                break;
            }
        case "enter":
        case "exit":
            {
                const right = extension[key];
                if (right) Object.assign(combined[key], right);
                break;
            }
    }
}
/** @type {OnEnterError} */ function $7f1f30d85f0808d5$var$defaultOnError(left, right) {
    if (left) throw new Error("Cannot close `" + left.type + "` (" + (0, $9628fc39c3f83a4c$export$c304dd45fe166145)({
        start: left.start,
        end: left.end
    }) + "): a different token (`" + right.type + "`, " + (0, $9628fc39c3f83a4c$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is open");
    else throw new Error("Cannot close document, a token (`" + right.type + "`, " + (0, $9628fc39c3f83a4c$export$c304dd45fe166145)({
        start: right.start,
        end: right.end
    }) + ") is still open");
}


function $73a0c1dba4c2bce4$export$2e2bcd8739ae039(options) {
    /** @type {Processor} */ // @ts-expect-error: TS in JSDoc generates wrong types if `this` is typed regularly.
    const self = this;
    self.parser = parser;
    /**
   * @type {Parser}
   */ function parser(doc) {
        return (0, $7f1f30d85f0808d5$export$d744d789c09bfde6)(doc, {
            ...self.data("settings"),
            ...options,
            // Note: these options are not in the readme.
            // The goal is for them to be set by plugins on `data` instead of being
            // passed by users.
            extensions: self.data("micromarkExtensions") || [],
            mdastExtensions: self.data("fromMarkdownExtensions") || []
        });
    }
}


// Include `data` fields in mdast and `raw` nodes in hast.
/// <reference types="mdast-util-to-hast" />
/**
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('mdast-util-to-hast').Options} Options
 * @typedef {import('unified').Processor} Processor
 * @typedef {import('vfile').VFile} VFile
 */ /**
 * @callback TransformBridge
 *   Bridge-mode.
 *
 *   Runs the destination with the new hast tree.
 *   Discards result.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {Promise<undefined>}
 *   Nothing.
 *
 * @callback TransformMutate
 *  Mutate-mode.
 *
 *  Further transformers run on the hast tree.
 * @param {MdastRoot} tree
 *   Tree.
 * @param {VFile} file
 *   File.
 * @returns {HastRoot}
 *   Tree (hast).
 */ /**
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('./state.js').Options} Options
 */ 
/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('./state.js').State} State
 */ /**
 * @callback FootnoteBackContentTemplate
 *   Generate content for the backreference dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {Array<ElementContent> | ElementContent | string}
 *   Content for the backreference when linking back from definitions to their
 *   reference.
 *
 * @callback FootnoteBackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   *  `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   *  `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   *  `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ const $c64067979d435374$export$1cd1943b3a73bbe8 = -1;
const $c64067979d435374$export$a44b4f3d5b73db95 = 0;
const $c64067979d435374$export$b119f07080a207ba = 1;
const $c64067979d435374$export$8b8a958a7f6f130c = 2;
const $c64067979d435374$export$501a7fac1df67a49 = 3;
const $c64067979d435374$export$cd2b220b1ea851b2 = 4;
const $c64067979d435374$export$ce970371e0e850bc = 5;
const $c64067979d435374$export$5e8f180ef0142226 = 6;
const $c64067979d435374$export$103bedf43ba882db = 7;
const $c64067979d435374$export$9f2207c8fceeefa8 = 8; // export const SYMBOL = 9;


const $cc062a99252e9cef$var$env = typeof self === "object" ? self : globalThis;
const $cc062a99252e9cef$var$deserializer = ($, _)=>{
    const as = (out, index)=>{
        $.set(index, out);
        return out;
    };
    const unpair = (index)=>{
        if ($.has(index)) return $.get(index);
        const [type, value] = _[index];
        switch(type){
            case 0, $c64067979d435374$export$a44b4f3d5b73db95:
            case 0, $c64067979d435374$export$1cd1943b3a73bbe8:
                return as(value, index);
            case 0, $c64067979d435374$export$b119f07080a207ba:
                {
                    const arr = as([], index);
                    for (const index of value)arr.push(unpair(index));
                    return arr;
                }
            case 0, $c64067979d435374$export$8b8a958a7f6f130c:
                {
                    const object = as({}, index);
                    for (const [key, index] of value)object[unpair(key)] = unpair(index);
                    return object;
                }
            case 0, $c64067979d435374$export$501a7fac1df67a49:
                return as(new Date(value), index);
            case 0, $c64067979d435374$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as(new RegExp(source, flags), index);
                }
            case 0, $c64067979d435374$export$ce970371e0e850bc:
                {
                    const map = as(new Map, index);
                    for (const [key, index] of value)map.set(unpair(key), unpair(index));
                    return map;
                }
            case 0, $c64067979d435374$export$5e8f180ef0142226:
                {
                    const set = as(new Set, index);
                    for (const index of value)set.add(unpair(index));
                    return set;
                }
            case 0, $c64067979d435374$export$103bedf43ba882db:
                {
                    const { name: name, message: message } = value;
                    return as(new $cc062a99252e9cef$var$env[name](message), index);
                }
            case 0, $c64067979d435374$export$9f2207c8fceeefa8:
                return as(BigInt(value), index);
            case "BigInt":
                return as(Object(BigInt(value)), index);
        }
        return as(new $cc062a99252e9cef$var$env[type](value), index);
    };
    return unpair;
};
const $cc062a99252e9cef$export$efcd34ab6248d3cd = (serialized)=>$cc062a99252e9cef$var$deserializer(new Map, serialized)(0);



const $46c344745ed58a33$var$EMPTY = "";
const { toString: $46c344745ed58a33$var$toString } = {};
const { keys: $46c344745ed58a33$var$keys } = Object;
const $46c344745ed58a33$var$typeOf = (value)=>{
    const type = typeof value;
    if (type !== "object" || !value) return [
        (0, $c64067979d435374$export$a44b4f3d5b73db95),
        type
    ];
    const asString = $46c344745ed58a33$var$toString.call(value).slice(8, -1);
    switch(asString){
        case "Array":
            return [
                (0, $c64067979d435374$export$b119f07080a207ba),
                $46c344745ed58a33$var$EMPTY
            ];
        case "Object":
            return [
                (0, $c64067979d435374$export$8b8a958a7f6f130c),
                $46c344745ed58a33$var$EMPTY
            ];
        case "Date":
            return [
                (0, $c64067979d435374$export$501a7fac1df67a49),
                $46c344745ed58a33$var$EMPTY
            ];
        case "RegExp":
            return [
                (0, $c64067979d435374$export$cd2b220b1ea851b2),
                $46c344745ed58a33$var$EMPTY
            ];
        case "Map":
            return [
                (0, $c64067979d435374$export$ce970371e0e850bc),
                $46c344745ed58a33$var$EMPTY
            ];
        case "Set":
            return [
                (0, $c64067979d435374$export$5e8f180ef0142226),
                $46c344745ed58a33$var$EMPTY
            ];
    }
    if (asString.includes("Array")) return [
        (0, $c64067979d435374$export$b119f07080a207ba),
        asString
    ];
    if (asString.includes("Error")) return [
        (0, $c64067979d435374$export$103bedf43ba882db),
        asString
    ];
    return [
        (0, $c64067979d435374$export$8b8a958a7f6f130c),
        asString
    ];
};
const $46c344745ed58a33$var$shouldSkip = ([TYPE, type])=>TYPE === (0, $c64067979d435374$export$a44b4f3d5b73db95) && (type === "function" || type === "symbol");
const $46c344745ed58a33$var$serializer = (strict, json, $, _)=>{
    const as = (out, value)=>{
        const index = _.push(out) - 1;
        $.set(value, index);
        return index;
    };
    const pair = (value)=>{
        if ($.has(value)) return $.get(value);
        let [TYPE, type] = $46c344745ed58a33$var$typeOf(value);
        switch(TYPE){
            case 0, $c64067979d435374$export$a44b4f3d5b73db95:
                {
                    let entry = value;
                    switch(type){
                        case "bigint":
                            TYPE = (0, $c64067979d435374$export$9f2207c8fceeefa8);
                            entry = value.toString();
                            break;
                        case "function":
                        case "symbol":
                            if (strict) throw new TypeError("unable to serialize " + type);
                            entry = null;
                            break;
                        case "undefined":
                            return as([
                                (0, $c64067979d435374$export$1cd1943b3a73bbe8)
                            ], value);
                    }
                    return as([
                        TYPE,
                        entry
                    ], value);
                }
            case 0, $c64067979d435374$export$b119f07080a207ba:
                {
                    if (type) return as([
                        type,
                        [
                            ...value
                        ]
                    ], value);
                    const arr = [];
                    const index = as([
                        TYPE,
                        arr
                    ], value);
                    for (const entry of value)arr.push(pair(entry));
                    return index;
                }
            case 0, $c64067979d435374$export$8b8a958a7f6f130c:
                {
                    if (type) switch(type){
                        case "BigInt":
                            return as([
                                type,
                                value.toString()
                            ], value);
                        case "Boolean":
                        case "Number":
                        case "String":
                            return as([
                                type,
                                value.valueOf()
                            ], value);
                    }
                    if (json && "toJSON" in value) return pair(value.toJSON());
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const key of $46c344745ed58a33$var$keys(value))if (strict || !$46c344745ed58a33$var$shouldSkip($46c344745ed58a33$var$typeOf(value[key]))) entries.push([
                        pair(key),
                        pair(value[key])
                    ]);
                    return index;
                }
            case 0, $c64067979d435374$export$501a7fac1df67a49:
                return as([
                    TYPE,
                    value.toISOString()
                ], value);
            case 0, $c64067979d435374$export$cd2b220b1ea851b2:
                {
                    const { source: source, flags: flags } = value;
                    return as([
                        TYPE,
                        {
                            source: source,
                            flags: flags
                        }
                    ], value);
                }
            case 0, $c64067979d435374$export$ce970371e0e850bc:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const [key, entry] of value)if (strict || !($46c344745ed58a33$var$shouldSkip($46c344745ed58a33$var$typeOf(key)) || $46c344745ed58a33$var$shouldSkip($46c344745ed58a33$var$typeOf(entry)))) entries.push([
                        pair(key),
                        pair(entry)
                    ]);
                    return index;
                }
            case 0, $c64067979d435374$export$5e8f180ef0142226:
                {
                    const entries = [];
                    const index = as([
                        TYPE,
                        entries
                    ], value);
                    for (const entry of value)if (strict || !$46c344745ed58a33$var$shouldSkip($46c344745ed58a33$var$typeOf(entry))) entries.push(pair(entry));
                    return index;
                }
        }
        const { message: message } = value;
        return as([
            TYPE,
            {
                name: type,
                message: message
            }
        ], value);
    };
    return pair;
};
const $46c344745ed58a33$export$dfdc1655ccc5b9cb = (value, { json: json, lossy: lossy } = {})=>{
    const _ = [];
    return $46c344745ed58a33$var$serializer(!(json || lossy), !!json, new Map, _)(value), _;
};


var /**
 * @typedef {Array<string,any>} Record a type representation
 */ /**
 * Returns an array of serialized Records.
 * @param {any} any a serializable value.
 * @param {{transfer?: any[], json?: boolean, lossy?: boolean}?} options an object with
 * a transfer option (ignored when polyfilled) and/or non standard fields that
 * fallback to the polyfill if present.
 * @returns {Record[]}
 */ $3567eb35e91f3fe8$export$2e2bcd8739ae039 = typeof structuredClone === "function" ? /* c8 ignore start */ (any, options)=>options && ("json" in options || "lossy" in options) ? (0, $cc062a99252e9cef$export$efcd34ab6248d3cd)((0, $46c344745ed58a33$export$dfdc1655ccc5b9cb)(any, options)) : structuredClone(any) : (any, options)=>(0, $cc062a99252e9cef$export$efcd34ab6248d3cd)((0, $46c344745ed58a33$export$dfdc1655ccc5b9cb)(any, options));



function $64a846b37751068f$export$4a6e1c4b9e5bc5d1(_, rereferenceIndex) {
    /** @type {Array<ElementContent>} */ const result = [
        {
            type: "text",
            value: "↩"
        }
    ];
    if (rereferenceIndex > 1) result.push({
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            {
                type: "text",
                value: String(rereferenceIndex)
            }
        ]
    });
    return result;
}
function $64a846b37751068f$export$d83e66a407212d3b(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $64a846b37751068f$export$adb608be33961c98(state) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const footnoteBackContent = state.options.footnoteBackContent || $64a846b37751068f$export$4a6e1c4b9e5bc5d1;
    const footnoteBackLabel = state.options.footnoteBackLabel || $64a846b37751068f$export$d83e66a407212d3b;
    const footnoteLabel = state.options.footnoteLabel || "Footnotes";
    const footnoteLabelTagName = state.options.footnoteLabelTagName || "h2";
    const footnoteLabelProperties = state.options.footnoteLabelProperties || {
        className: [
            "sr-only"
        ]
    };
    /** @type {Array<ElementContent>} */ const listItems = [];
    let referenceIndex = -1;
    while(++referenceIndex < state.footnoteOrder.length){
        const def = state.footnoteById.get(state.footnoteOrder[referenceIndex]);
        if (!def) continue;
        const content = state.all(def);
        const id = String(def.identifier).toUpperCase();
        const safeId = (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(id.toLowerCase());
        let rereferenceIndex = 0;
        /** @type {Array<ElementContent>} */ const backReferences = [];
        const counts = state.footnoteCounts.get(id);
        // eslint-disable-next-line no-unmodified-loop-condition
        while(counts !== undefined && ++rereferenceIndex <= counts){
            if (backReferences.length > 0) backReferences.push({
                type: "text",
                value: " "
            });
            let children = typeof footnoteBackContent === "string" ? footnoteBackContent : footnoteBackContent(referenceIndex, rereferenceIndex);
            if (typeof children === "string") children = {
                type: "text",
                value: children
            };
            backReferences.push({
                type: "element",
                tagName: "a",
                properties: {
                    href: "#" + clobberPrefix + "fnref-" + safeId + (rereferenceIndex > 1 ? "-" + rereferenceIndex : ""),
                    dataFootnoteBackref: "",
                    ariaLabel: typeof footnoteBackLabel === "string" ? footnoteBackLabel : footnoteBackLabel(referenceIndex, rereferenceIndex),
                    className: [
                        "data-footnote-backref"
                    ]
                },
                children: Array.isArray(children) ? children : [
                    children
                ]
            });
        }
        const tail = content[content.length - 1];
        if (tail && tail.type === "element" && tail.tagName === "p") {
            const tailTail = tail.children[tail.children.length - 1];
            if (tailTail && tailTail.type === "text") tailTail.value += " ";
            else tail.children.push({
                type: "text",
                value: " "
            });
            tail.children.push(...backReferences);
        } else content.push(...backReferences);
        /** @type {Element} */ const listItem = {
            type: "element",
            tagName: "li",
            properties: {
                id: clobberPrefix + "fn-" + safeId
            },
            children: state.wrap(content, true)
        };
        state.patch(def, listItem);
        listItems.push(listItem);
    }
    if (listItems.length === 0) return;
    return {
        type: "element",
        tagName: "section",
        properties: {
            dataFootnotes: true,
            className: [
                "footnotes"
            ]
        },
        children: [
            {
                type: "element",
                tagName: footnoteLabelTagName,
                properties: {
                    ...(0, $3567eb35e91f3fe8$export$2e2bcd8739ae039)(footnoteLabelProperties),
                    id: "footnote-label"
                },
                children: [
                    {
                        type: "text",
                        value: footnoteLabel
                    }
                ]
            },
            {
                type: "text",
                value: "\n"
            },
            {
                type: "element",
                tagName: "ol",
                properties: {},
                children: state.wrap(listItems, true)
            },
            {
                type: "text",
                value: "\n"
            }
        ]
    };
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').ElementContent} HastElementContent
 * @typedef {import('hast').Nodes} HastNodes
 * @typedef {import('hast').Properties} HastProperties
 * @typedef {import('hast').RootContent} HastRootContent
 * @typedef {import('hast').Text} HastText
 *
 * @typedef {import('mdast').Definition} MdastDefinition
 * @typedef {import('mdast').FootnoteDefinition} MdastFootnoteDefinition
 * @typedef {import('mdast').Nodes} MdastNodes
 * @typedef {import('mdast').Parents} MdastParents
 *
 * @typedef {import('./footer.js').FootnoteBackContentTemplate} FootnoteBackContentTemplate
 * @typedef {import('./footer.js').FootnoteBackLabelTemplate} FootnoteBackLabelTemplate
 */ /**
 * @callback Handler
 *   Handle a node.
 * @param {State} state
 *   Info passed around.
 * @param {any} node
 *   mdast node to handle.
 * @param {MdastParents | undefined} parent
 *   Parent of `node`.
 * @returns {Array<HastElementContent> | HastElementContent | undefined}
 *   hast node.
 *
 * @typedef {Partial<Record<MdastNodes['type'], Handler>>} Handlers
 *   Handle nodes.
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [allowDangerousHtml=false]
 *   Whether to persist raw HTML in markdown in the hast tree (default:
 *   `false`).
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` property on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {FootnoteBackContentTemplate | string | null | undefined} [footnoteBackContent]
 *   Content of the backreference back to references (default: `defaultFootnoteBackContent`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackContent(_, rereferenceIndex) {
 *     const result = [{type: 'text', value: '↩'}]
 *
 *     if (rereferenceIndex > 1) {
 *       result.push({
 *         type: 'element',
 *         tagName: 'sup',
 *         properties: {},
 *         children: [{type: 'text', value: String(rereferenceIndex)}]
 *       })
 *     }
 *
 *     return result
 *   }
 *   ```
 *
 *   This content is used in the `a` element of each backreference (the `↩`
 *   links).
 * @property {FootnoteBackLabelTemplate | string | null | undefined} [footnoteBackLabel]
 *   Label to describe the backreference back to references (default:
 *   `defaultFootnoteBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultFootnoteBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *   }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `ariaLabel` property on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 * @property {string | null | undefined} [footnoteLabel='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {HastProperties | null | undefined} [footnoteLabelProperties={className: ['sr-only']}]
 *   Properties to use on the footnote label (default: `{className:
 *   ['sr-only']}`).
 *
 *   Change it to show the label and add other properties.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different properties.
 *
 *   > 👉 **Note**: `id: 'footnote-label'` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [footnoteLabelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different properties with the `footnoteLabelProperties` option.
 * @property {Handlers | null | undefined} [handlers]
 *   Extra handlers for nodes (optional).
 * @property {Array<MdastNodes['type']> | null | undefined} [passThrough]
 *   List of custom mdast node types to pass through (keep) in hast (note that
 *   the node itself is passed, but eventual children are transformed)
 *   (optional).
 * @property {Handler | null | undefined} [unknownHandler]
 *   Handler for all unknown nodes (optional).
 *
 * @typedef State
 *   Info passed around.
 * @property {(node: MdastNodes) => Array<HastElementContent>} all
 *   Transform the children of an mdast parent to hast.
 * @property {<Type extends HastNodes>(from: MdastNodes, to: Type) => HastElement | Type} applyData
 *   Honor the `data` of `from`, and generate an element instead of `node`.
 * @property {Map<string, MdastDefinition>} definitionById
 *   Definitions by their identifier.
 * @property {Map<string, MdastFootnoteDefinition>} footnoteById
 *   Footnote definitions by their identifier.
 * @property {Map<string, number>} footnoteCounts
 *   Counts for how often the same footnote was called.
 * @property {Array<string>} footnoteOrder
 *   Identifiers of order when footnote calls first appear in tree order.
 * @property {Handlers} handlers
 *   Applied handlers.
 * @property {(node: MdastNodes, parent: MdastParents | undefined) => Array<HastElementContent> | HastElementContent | undefined} one
 *   Transform an mdast node to hast.
 * @property {Options} options
 *   Configuration.
 * @property {(from: MdastNodes, node: HastNodes) => undefined} patch
 *   Copy a node’s positional info.
 * @property {<Type extends HastRootContent>(nodes: Array<Type>, loose?: boolean | undefined) => Array<HastText | Type>} wrap
 *   Wrap `nodes` with line endings between each node, adds initial/final line endings when `loose`.
 */ 
/**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ // To do: use types from `unist-util-visit-parents` when it’s released.
/**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform `parent`.
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of `parent` still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Visited extends UnistNode ? number | undefined : never} index
 *   Index of `node` in `parent`.
 * @param {Ancestor extends UnistParent ? Ancestor | undefined : never} parent
 *   Parent of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [Ancestor=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Visited, Parent<Ancestor, Visited>>} BuildVisitorFromMatch
 *   Build a typed `Visitor` function from a node and all possible parents.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Visited
 *   Node type.
 * @template {UnistParent} Ancestor
 *   Parent type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromMatch<
 *     Matches<Descendant, Check>,
 *     Extract<Descendant, UnistParent>
 *   >
 * )} BuildVisitorFromDescendants
 *   Build a typed `Visitor` function from a list of descendants and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} Descendant
 *   Node type.
 * @template {Test} Check
 *   Test type.
 */ /**
 * @typedef {(
 *   BuildVisitorFromDescendants<
 *     InclusiveDescendant<Tree>,
 *     Check
 *   >
 * )} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parent`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Node type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} UnistNode
 * @typedef {import('unist').Parent} UnistParent
 */ /**
 * @typedef {Exclude<import('unist-util-is').Test, undefined> | undefined} Test
 *   Test from `unist-util-is`.
 *
 *   Note: we have remove and add `undefined`, because otherwise when generating
 *   automatic `.d.ts` files, TS tries to flatten paths from a local perspective,
 *   which doesn’t work when publishing on npm.
 */ /**
 * @typedef {(
 *   Fn extends (value: any) => value is infer Thing
 *   ? Thing
 *   : Fallback
 * )} Predicate
 *   Get the value of a type guard `Fn`.
 * @template Fn
 *   Value; typically function that is a type guard (such as `(x): x is Y`).
 * @template Fallback
 *   Value to yield if `Fn` is not a type guard.
 */ /**
 * @typedef {(
 *   Check extends null | undefined // No test.
 *   ? Value
 *   : Value extends {type: Check} // String (type) test.
 *   ? Value
 *   : Value extends Check // Partial test.
 *   ? Value
 *   : Check extends Function // Function test.
 *   ? Predicate<Check, Value> extends Value
 *     ? Predicate<Check, Value>
 *     : never
 *   : never // Some other test?
 * )} MatchesOne
 *   Check whether a node matches a primitive check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test, but not arrays.
 */ /**
 * @typedef {(
 *   Check extends Array<any>
 *   ? MatchesOne<Value, Check[keyof Check]>
 *   : MatchesOne<Value, Check>
 * )} Matches
 *   Check whether a node matches a check in the type system.
 * @template Value
 *   Value; typically unist `Node`.
 * @template Check
 *   Value; typically `unist-util-is`-compatible test.
 */ /**
 * @typedef {0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10} Uint
 *   Number; capped reasonably.
 */ /**
 * @typedef {I extends 0 ? 1 : I extends 1 ? 2 : I extends 2 ? 3 : I extends 3 ? 4 : I extends 4 ? 5 : I extends 5 ? 6 : I extends 6 ? 7 : I extends 7 ? 8 : I extends 8 ? 9 : 10} Increment
 *   Increment a number in the type system.
 * @template {Uint} [I=0]
 *   Index.
 */ /**
 * @typedef {(
 *   Node extends UnistParent
 *   ? Node extends {children: Array<infer Children>}
 *     ? Child extends Children ? Node : never
 *     : never
 *   : never
 * )} InternalParent
 *   Collect nodes that can be parents of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {InternalParent<InclusiveDescendant<Tree>, Child>} Parent
 *   Collect nodes in `Tree` that can be parents of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Depth extends Max
 *   ? never
 *   :
 *     | InternalParent<Node, Child>
 *     | InternalAncestor<Node, InternalParent<Node, Child>, Max, Increment<Depth>>
 * )} InternalAncestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Node
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {InternalAncestor<InclusiveDescendant<Tree>, Child>} Ancestor
 *   Collect nodes in `Tree` that can be ancestors of `Child`.
 * @template {UnistNode} Tree
 *   All node types in a tree.
 * @template {UnistNode} Child
 *   Node to search for.
 */ /**
 * @typedef {(
 *   Tree extends UnistParent
 *     ? Depth extends Max
 *       ? Tree
 *       : Tree | InclusiveDescendant<Tree['children'][number], Max, Increment<Depth>>
 *     : Tree
 * )} InclusiveDescendant
 *   Collect all (inclusive) descendants of `Tree`.
 *
 *   > 👉 **Note**: for performance reasons, this seems to be the fastest way to
 *   > recurse without actually running into an infinite loop, which the
 *   > previous version did.
 *   >
 *   > Practically, a max of `2` is typically enough assuming a `Root` is
 *   > passed, but it doesn’t improve performance.
 *   > It gets higher with `List > ListItem > Table > TableRow > TableCell`.
 *   > Using up to `10` doesn’t hurt or help either.
 * @template {UnistNode} Tree
 *   Tree type.
 * @template {Uint} [Max=10]
 *   Max; searches up to this depth.
 * @template {Uint} [Depth=0]
 *   Current depth.
 */ /**
 * @typedef {'skip' | boolean} Action
 *   Union of the action types.
 *
 * @typedef {number} Index
 *   Move to the sibling at `index` next (after node itself is completely
 *   traversed).
 *
 *   Useful if mutating the tree, such as removing the node the visitor is
 *   currently on, or any of its previous siblings.
 *   Results less than 0 or greater than or equal to `children.length` stop
 *   traversing the parent.
 *
 * @typedef {[(Action | null | undefined | void)?, (Index | null | undefined)?]} ActionTuple
 *   List with one or two values, the first an action, the second an index.
 *
 * @typedef {Action | ActionTuple | Index | null | undefined | void} VisitorResult
 *   Any value that can be returned from a visitor.
 */ /**
 * @callback Visitor
 *   Handle a node (matching `test`, if given).
 *
 *   Visitors are free to transform `node`.
 *   They can also transform the parent of node (the last of `ancestors`).
 *
 *   Replacing `node` itself, if `SKIP` is not returned, still causes its
 *   descendants to be walked (which is a bug).
 *
 *   When adding or removing previous siblings of `node` (or next siblings, in
 *   case of reverse), the `Visitor` should return a new `Index` to specify the
 *   sibling to traverse after `node` is traversed.
 *   Adding or removing next siblings of `node` (or previous siblings, in case
 *   of reverse) is handled as expected without needing to return a new `Index`.
 *
 *   Removing the children property of an ancestor still results in them being
 *   traversed.
 * @param {Visited} node
 *   Found node.
 * @param {Array<VisitedParents>} ancestors
 *   Ancestors of `node`.
 * @returns {VisitorResult}
 *   What to do next.
 *
 *   An `Index` is treated as a tuple of `[CONTINUE, Index]`.
 *   An `Action` is treated as a tuple of `[Action]`.
 *
 *   Passing a tuple back only makes sense if the `Action` is `SKIP`.
 *   When the `Action` is `EXIT`, that action can be returned.
 *   When the `Action` is `CONTINUE`, `Index` can be returned.
 * @template {UnistNode} [Visited=UnistNode]
 *   Visited node type.
 * @template {UnistParent} [VisitedParents=UnistParent]
 *   Ancestor type.
 */ /**
 * @typedef {Visitor<Matches<InclusiveDescendant<Tree>, Check>, Ancestor<Tree, Matches<InclusiveDescendant<Tree>, Check>>>} BuildVisitor
 *   Build a typed `Visitor` function from a tree and a test.
 *
 *   It will infer which values are passed as `node` and which as `parents`.
 * @template {UnistNode} [Tree=UnistNode]
 *   Tree type.
 * @template {Test} [Check=Test]
 *   Test type.
 */ /**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 */ /**
 * @template Fn
 * @template Fallback
 * @typedef {Fn extends (value: any) => value is infer Thing ? Thing : Fallback} Predicate
 */ /**
 * @callback Check
 *   Check that an arbitrary value is a node.
 * @param {unknown} this
 *   The given context.
 * @param {unknown} [node]
 *   Anything (typically a node).
 * @param {number | null | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean}
 *   Whether this is a node and passes a test.
 *
 * @typedef {Record<string, unknown> | Node} Props
 *   Object to check for equivalence.
 *
 *   Note: `Node` is included as it is common but is not indexable.
 *
 * @typedef {Array<Props | TestFunction | string> | Props | TestFunction | string | null | undefined} Test
 *   Check for an arbitrary node.
 *
 * @callback TestFunction
 *   Check if a node passes a test.
 * @param {unknown} this
 *   The given context.
 * @param {Node} node
 *   A node.
 * @param {number | undefined} [index]
 *   The node’s position in its parent.
 * @param {Parent | undefined} [parent]
 *   The node’s parent.
 * @returns {boolean | undefined | void}
 *   Whether this node passes the test.
 *
 *   Note: `void` is included until TS sees no return as `undefined`.
 */ /**
 * Check if `node` is a `Node` and whether it passes the given test.
 *
 * @param {unknown} node
 *   Thing to check, typically `Node`.
 * @param {Test} test
 *   A check for a specific node.
 * @param {number | null | undefined} index
 *   The node’s position in its parent.
 * @param {Parent | null | undefined} parent
 *   The node’s parent.
 * @param {unknown} context
 *   Context object (`this`) to pass to `test` functions.
 * @returns {boolean}
 *   Whether `node` is a node and passes a test.
 */ const $c32fa7de1b4c617f$export$226b3eccf92c9ed9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(node: unknown, test: Condition, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((node?: null | undefined) => false) &
   *   ((node: unknown, test?: null | undefined, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((node: unknown, test?: Test, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => boolean)
   * )}
   */ /**
     * @param {unknown} [node]
     * @param {Test} [test]
     * @param {number | null | undefined} [index]
     * @param {Parent | null | undefined} [parent]
     * @param {unknown} [context]
     * @returns {boolean}
     */ // eslint-disable-next-line max-params
function(node, test, index, parent, context) {
    const check = $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9(test);
    if (index !== undefined && index !== null && (typeof index !== "number" || index < 0 || index === Number.POSITIVE_INFINITY)) throw new Error("Expected positive finite index");
    if (parent !== undefined && parent !== null && (!$c32fa7de1b4c617f$export$226b3eccf92c9ed9(parent) || !parent.children)) throw new Error("Expected parent node");
    if ((parent === undefined || parent === null) !== (index === undefined || index === null)) throw new Error("Expected both parent and index");
    return $c32fa7de1b4c617f$var$looksLikeANode(node) ? check.call(context, node, index, parent) : false;
};
const $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9 = // Note: overloads in JSDoc can’t yet use different `@template`s.
/**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */ /**
     * @param {Test} [test]
     * @returns {Check}
     */ function(test) {
    if (test === null || test === undefined) return $c32fa7de1b4c617f$var$ok;
    if (typeof test === "function") return $c32fa7de1b4c617f$var$castFactory(test);
    if (typeof test === "object") return Array.isArray(test) ? $c32fa7de1b4c617f$var$anyFactory(test) : $c32fa7de1b4c617f$var$propsFactory(test);
    if (typeof test === "string") return $c32fa7de1b4c617f$var$typeFactory(test);
    throw new Error("Expected function, string, or object as test");
};
/**
 * @param {Array<Props | TestFunction | string>} tests
 * @returns {Check}
 */ function $c32fa7de1b4c617f$var$anyFactory(tests) {
    /** @type {Array<Check>} */ const checks = [];
    let index = -1;
    while(++index < tests.length)checks[index] = $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9(tests[index]);
    return $c32fa7de1b4c617f$var$castFactory(any);
    /**
   * @this {unknown}
   * @type {TestFunction}
   */ function any(...parameters) {
        let index = -1;
        while(++index < checks.length){
            if (checks[index].apply(this, parameters)) return true;
        }
        return false;
    }
}
/**
 * Turn an object into a test for a node with a certain fields.
 *
 * @param {Props} check
 * @returns {Check}
 */ function $c32fa7de1b4c617f$var$propsFactory(check) {
    const checkAsRecord = /** @type {Record<string, unknown>} */ check;
    return $c32fa7de1b4c617f$var$castFactory(all);
    /**
   * @param {Node} node
   * @returns {boolean}
   */ function all(node) {
        const nodeAsRecord = /** @type {Record<string, unknown>} */ /** @type {unknown} */ node;
        /** @type {string} */ let key;
        for(key in check){
            if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
        }
        return true;
    }
}
/**
 * Turn a string into a test for a node with a certain type.
 *
 * @param {string} check
 * @returns {Check}
 */ function $c32fa7de1b4c617f$var$typeFactory(check) {
    return $c32fa7de1b4c617f$var$castFactory(type);
    /**
   * @param {Node} node
   */ function type(node) {
        return node && node.type === check;
    }
}
/**
 * Turn a custom test into a test for a node that passes that test.
 *
 * @param {TestFunction} testFunction
 * @returns {Check}
 */ function $c32fa7de1b4c617f$var$castFactory(testFunction) {
    return check;
    /**
   * @this {unknown}
   * @type {Check}
   */ function check(value, index, parent) {
        return Boolean($c32fa7de1b4c617f$var$looksLikeANode(value) && testFunction.call(this, value, typeof index === "number" ? index : undefined, parent || undefined));
    }
}
function $c32fa7de1b4c617f$var$ok() {
    return true;
}
/**
 * @param {unknown} value
 * @returns {value is Node}
 */ function $c32fa7de1b4c617f$var$looksLikeANode(value) {
    return value !== null && typeof value === "object" && "type" in value;
}


/**
 * @param {string} d
 * @returns {string}
 */ function $16a0da7527906142$export$35e9368ef982300f(d) {
    return d;
}


/** @type {Readonly<ActionTuple>} */ const $fa87f0c78841621d$var$empty = [];
const $fa87f0c78841621d$export$f4d8133c446fe484 = true;
const $fa87f0c78841621d$export$7f100f842f565dc9 = false;
const $fa87f0c78841621d$export$8773f85c2fb2c116 = "skip";
function $fa87f0c78841621d$export$70008a21eb6de899(tree, test, visitor, reverse) {
    /** @type {Test} */ let check;
    if (typeof test === "function" && typeof visitor !== "function") {
        reverse = visitor;
        // @ts-expect-error no visitor given, so `visitor` is test.
        visitor = test;
    } else // @ts-expect-error visitor given, so `test` isn’t a visitor.
    check = test;
    const is = (0, $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9)(check);
    const step = reverse ? -1 : 1;
    factory(tree, undefined, [])();
    /**
   * @param {UnistNode} node
   * @param {number | undefined} index
   * @param {Array<UnistParent>} parents
   */ function factory(node, index, parents) {
        const value = /** @type {Record<string, unknown>} */ node && typeof node === "object" ? node : {};
        if (typeof value.type === "string") {
            const name = // `hast`
            typeof value.tagName === "string" ? value.tagName : typeof value.name === "string" ? value.name : undefined;
            Object.defineProperty(visit, "name", {
                value: "node (" + (0, $16a0da7527906142$export$35e9368ef982300f)(node.type + (name ? "<" + name + ">" : "")) + ")"
            });
        }
        return visit;
        function visit() {
            /** @type {Readonly<ActionTuple>} */ let result = $fa87f0c78841621d$var$empty;
            /** @type {Readonly<ActionTuple>} */ let subresult;
            /** @type {number} */ let offset;
            /** @type {Array<UnistParent>} */ let grandparents;
            if (!test || is(node, index, parents[parents.length - 1] || undefined)) {
                // @ts-expect-error: `visitor` is now a visitor.
                result = $fa87f0c78841621d$var$toResult(visitor(node, parents));
                if (result[0] === $fa87f0c78841621d$export$7f100f842f565dc9) return result;
            }
            if ("children" in node && node.children) {
                const nodeAsParent = /** @type {UnistParent} */ node;
                if (nodeAsParent.children && result[0] !== $fa87f0c78841621d$export$8773f85c2fb2c116) {
                    offset = (reverse ? nodeAsParent.children.length : -1) + step;
                    grandparents = parents.concat(nodeAsParent);
                    while(offset > -1 && offset < nodeAsParent.children.length){
                        const child = nodeAsParent.children[offset];
                        subresult = factory(child, offset, grandparents)();
                        if (subresult[0] === $fa87f0c78841621d$export$7f100f842f565dc9) return subresult;
                        offset = typeof subresult[1] === "number" ? subresult[1] : offset + step;
                    }
                }
            }
            return result;
        }
    }
}
/**
 * Turn a return value into a clean result.
 *
 * @param {VisitorResult} value
 *   Valid return values from visitors.
 * @returns {Readonly<ActionTuple>}
 *   Clean result.
 */ function $fa87f0c78841621d$var$toResult(value) {
    if (Array.isArray(value)) return value;
    if (typeof value === "number") return [
        $fa87f0c78841621d$export$f4d8133c446fe484,
        value
    ];
    return value === null || value === undefined ? $fa87f0c78841621d$var$empty : [
        value
    ];
}


function $425a1aa39753930c$export$bf638b60ea8b89b7(tree, testOrVisitor, visitorOrReverse, maybeReverse) {
    /** @type {boolean | null | undefined} */ let reverse;
    /** @type {Test} */ let test;
    /** @type {Visitor} */ let visitor;
    if (typeof testOrVisitor === "function" && typeof visitorOrReverse !== "function") {
        test = undefined;
        visitor = testOrVisitor;
        reverse = visitorOrReverse;
    } else {
        // @ts-expect-error: assume the overload with test was given.
        test = testOrVisitor;
        // @ts-expect-error: assume the overload with test was given.
        visitor = visitorOrReverse;
        reverse = maybeReverse;
    }
    (0, $fa87f0c78841621d$export$70008a21eb6de899)(tree, test, overload, reverse);
    /**
   * @param {UnistNode} node
   * @param {Array<UnistParent>} parents
   */ function overload(node, parents) {
        const parent = parents[parents.length - 1];
        const index = parent ? parent.children.indexOf(node) : undefined;
        return visitor(node, index, parent);
    }
}



/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $b5c6e9c33097077d$export$67dc04e652a298ca(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "blockquote",
        properties: {},
        children: state.wrap(state.all(node), true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').Break} Break
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $09339e8bad780139$export$371da9dd35aba193(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "br",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return [
        state.applyData(node, result),
        {
            type: "text",
            value: "\n"
        }
    ];
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $4b8fc966f9f9498f$export$6565f9f03506010b(state, node) {
    const value = node.value ? node.value + "\n" : "";
    /** @type {Properties} */ const properties = {};
    if (node.lang) properties.className = [
        "language-" + node.lang
    ];
    // Create `<code>`.
    /** @type {Element} */ let result = {
        type: "element",
        tagName: "code",
        properties: properties,
        children: [
            {
                type: "text",
                value: value
            }
        ]
    };
    if (node.meta) result.data = {
        meta: node.meta
    };
    state.patch(node, result);
    result = state.applyData(node, result);
    // Create `<pre>`.
    result = {
        type: "element",
        tagName: "pre",
        properties: {},
        children: [
            result
        ]
    };
    state.patch(node, result);
    return result;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Delete} Delete
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $2f5f6c8e09431814$export$19426ff118fe8be(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "del",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $ab08c4d78c2502f7$export$bef81ba411953b51(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "em",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('../state.js').State} State
 */ 
function $f53283b430343b34$export$7f87ee744075c1ba(state, node) {
    const clobberPrefix = typeof state.options.clobberPrefix === "string" ? state.options.clobberPrefix : "user-content-";
    const id = String(node.identifier).toUpperCase();
    const safeId = (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(id.toLowerCase());
    const index = state.footnoteOrder.indexOf(id);
    /** @type {number} */ let counter;
    let reuseCounter = state.footnoteCounts.get(id);
    if (reuseCounter === undefined) {
        reuseCounter = 0;
        state.footnoteOrder.push(id);
        counter = state.footnoteOrder.length;
    } else counter = index + 1;
    reuseCounter += 1;
    state.footnoteCounts.set(id, reuseCounter);
    /** @type {Element} */ const link = {
        type: "element",
        tagName: "a",
        properties: {
            href: "#" + clobberPrefix + "fn-" + safeId,
            id: clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : ""),
            dataFootnoteRef: true,
            ariaDescribedBy: [
                "footnote-label"
            ]
        },
        children: [
            {
                type: "text",
                value: String(counter)
            }
        ]
    };
    state.patch(node, link);
    /** @type {Element} */ const sup = {
        type: "element",
        tagName: "sup",
        properties: {},
        children: [
            link
        ]
    };
    state.patch(node, sup);
    return state.applyData(node, sup);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $c7f0279a942eb70d$export$46e4a324ac90507f(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "h" + node.depth,
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Html} Html
 * @typedef {import('../state.js').State} State
 * @typedef {import('../../index.js').Raw} Raw
 */ // Make VS Code show references to the above types.
"";
function $89b602966f88e584$export$c0bb0b647f701bb5(state, node) {
    if (state.options.allowDangerousHtml) {
        /** @type {Raw} */ const result = {
            type: "raw",
            value: node.value
        };
        state.patch(node, result);
        return state.applyData(node, result);
    }
    return undefined;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('../state.js').State} State
 */ 
/**
 * @typedef {import('hast').ElementContent} ElementContent
 *
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Reference} Reference
 *
 * @typedef {import('./state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $66d057cea42911d5$export$3fdd26f3d9e7dc78(state, node) {
    const subtype = node.referenceType;
    let suffix = "]";
    if (subtype === "collapsed") suffix += "[]";
    else if (subtype === "full") suffix += "[" + (node.label || node.identifier) + "]";
    if (node.type === "imageReference") return [
        {
            type: "text",
            value: "![" + node.alt + suffix
        }
    ];
    const contents = state.all(node);
    const head = contents[0];
    if (head && head.type === "text") head.value = "[" + head.value;
    else contents.unshift({
        type: "text",
        value: "["
    });
    const tail = contents[contents.length - 1];
    if (tail && tail.type === "text") tail.value += suffix;
    else contents.push({
        type: "text",
        value: suffix
    });
    return contents;
}


function $6569e722fb2ce946$export$f281796f6bc3b8db(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $66d057cea42911d5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        src: (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(def.url || ""),
        alt: node.alt
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Image} Image
 * @typedef {import('../state.js').State} State
 */ 
function $d856dba8ceab62bd$export$5c452ff88e35e47d(state, node) {
    /** @type {Properties} */ const properties = {
        src: (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(node.url)
    };
    if (node.alt !== null && node.alt !== undefined) properties.alt = node.alt;
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "img",
        properties: properties,
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Text} Text
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $597195a23d65a586$export$91b9bee19a0d8569(state, node) {
    /** @type {Text} */ const text = {
        type: "text",
        value: node.value.replace(/\r?\n|\r/g, " ")
    };
    state.patch(node, text);
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "code",
        properties: {},
        children: [
            text
        ]
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('../state.js').State} State
 */ 

function $24acf304cb02fb78$export$e6c469b1b7b2bc6a(state, node) {
    const id = String(node.identifier).toUpperCase();
    const def = state.definitionById.get(id);
    if (!def) return (0, $66d057cea42911d5$export$3fdd26f3d9e7dc78)(state, node);
    /** @type {Properties} */ const properties = {
        href: (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(def.url || "")
    };
    if (def.title !== null && def.title !== undefined) properties.title = def.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../state.js').State} State
 */ 
function $57a06cf48a2aebb5$export$9c30223ca0a664fb(state, node) {
    /** @type {Properties} */ const properties = {
        href: (0, $e133dd0f2d166be7$export$e42a3e39590d28b5)(node.url)
    };
    if (node.title !== null && node.title !== undefined) properties.title = node.title;
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "a",
        properties: properties,
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $773c5142d98ed87b$export$76c7e83ecc9cdf05(state, node, parent) {
    const results = state.all(node);
    const loose = parent ? $773c5142d98ed87b$var$listLoose(parent) : $773c5142d98ed87b$var$listItemLoose(node);
    /** @type {Properties} */ const properties = {};
    /** @type {Array<ElementContent>} */ const children = [];
    if (typeof node.checked === "boolean") {
        const head = results[0];
        /** @type {Element} */ let paragraph;
        if (head && head.type === "element" && head.tagName === "p") paragraph = head;
        else {
            paragraph = {
                type: "element",
                tagName: "p",
                properties: {},
                children: []
            };
            results.unshift(paragraph);
        }
        if (paragraph.children.length > 0) paragraph.children.unshift({
            type: "text",
            value: " "
        });
        paragraph.children.unshift({
            type: "element",
            tagName: "input",
            properties: {
                type: "checkbox",
                checked: node.checked,
                disabled: true
            },
            children: []
        });
        // According to github-markdown-css, this class hides bullet.
        // See: <https://github.com/sindresorhus/github-markdown-css>.
        properties.className = [
            "task-list-item"
        ];
    }
    let index = -1;
    while(++index < results.length){
        const child = results[index];
        // Add eols before nodes, except if this is a loose, first paragraph.
        if (loose || index !== 0 || child.type !== "element" || child.tagName !== "p") children.push({
            type: "text",
            value: "\n"
        });
        if (child.type === "element" && child.tagName === "p" && !loose) children.push(...child.children);
        else children.push(child);
    }
    const tail = results[results.length - 1];
    // Add a final eol.
    if (tail && (loose || tail.type !== "element" || tail.tagName !== "p")) children.push({
        type: "text",
        value: "\n"
    });
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "li",
        properties: properties,
        children: children
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
/**
 * @param {Parents} node
 * @return {Boolean}
 */ function $773c5142d98ed87b$var$listLoose(node) {
    let loose = false;
    if (node.type === "list") {
        loose = node.spread || false;
        const children = node.children;
        let index = -1;
        while(!loose && ++index < children.length)loose = $773c5142d98ed87b$var$listItemLoose(children[index]);
    }
    return loose;
}
/**
 * @param {ListItem} node
 * @return {Boolean}
 */ function $773c5142d98ed87b$var$listItemLoose(node) {
    const spread = node.spread;
    return spread === null || spread === undefined ? node.children.length > 1 : spread;
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').List} List
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $fa594ff479f8c3b8$export$8837f4fc672e936d(state, node) {
    /** @type {Properties} */ const properties = {};
    const results = state.all(node);
    let index = -1;
    if (typeof node.start === "number" && node.start !== 1) properties.start = node.start;
    // Like GitHub, add a class for custom styling.
    while(++index < results.length){
        const child = results[index];
        if (child.type === "element" && child.tagName === "li" && child.properties && Array.isArray(child.properties.className) && child.properties.className.includes("task-list-item")) {
            properties.className = [
                "contains-task-list"
            ];
            break;
        }
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: node.ordered ? "ol" : "ul",
        properties: properties,
        children: state.wrap(results, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $c92517f4f4ee03f9$export$9c206ddddb32a9b(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "p",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Parents} HastParents
 * @typedef {import('hast').Root} HastRoot
 * @typedef {import('mdast').Root} MdastRoot
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $77834837f6cb436f$export$e8e78c978b129247(state, node) {
    /** @type {HastRoot} */ const result = {
        type: "root",
        children: state.wrap(state.all(node))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $d8a5c1774c1958e3$export$59ae2c325a998f89(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "strong",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').Table} Table
 * @typedef {import('../state.js').State} State
 */ 
function $efa6caacabd42864$export$9852986a3ec5f6a0(state, node) {
    const rows = state.all(node);
    const firstRow = rows.shift();
    /** @type {Array<Element>} */ const tableContent = [];
    if (firstRow) {
        /** @type {Element} */ const head = {
            type: "element",
            tagName: "thead",
            properties: {},
            children: state.wrap([
                firstRow
            ], true)
        };
        state.patch(node.children[0], head);
        tableContent.push(head);
    }
    if (rows.length > 0) {
        /** @type {Element} */ const body = {
            type: "element",
            tagName: "tbody",
            properties: {},
            children: state.wrap(rows, true)
        };
        const start = (0, $376270e3d73468cb$export$771bf3e4949bfbee)(node.children[1]);
        const end = (0, $376270e3d73468cb$export$da309cdce9dc2a25)(node.children[node.children.length - 1]);
        if (start && end) body.position = {
            start: start,
            end: end
        };
        tableContent.push(body);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "table",
        properties: {},
        children: state.wrap(tableContent, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('hast').ElementContent} ElementContent
 * @typedef {import('hast').Properties} Properties
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').TableRow} TableRow
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $125fc21376eb63dd$export$ce666bf02318c957(state, node, parent) {
    const siblings = parent ? parent.children : undefined;
    // Generate a body row when without parent.
    const rowIndex = siblings ? siblings.indexOf(node) : 1;
    const tagName = rowIndex === 0 ? "th" : "td";
    // To do: option to use `style`?
    const align = parent && parent.type === "table" ? parent.align : undefined;
    const length = align ? align.length : node.children.length;
    let cellIndex = -1;
    /** @type {Array<ElementContent>} */ const cells = [];
    while(++cellIndex < length){
        // Note: can also be undefined.
        const cell = node.children[cellIndex];
        /** @type {Properties} */ const properties = {};
        const alignValue = align ? align[cellIndex] : undefined;
        if (alignValue) properties.align = alignValue;
        /** @type {Element} */ let result = {
            type: "element",
            tagName: tagName,
            properties: properties,
            children: []
        };
        if (cell) {
            result.children = state.all(cell);
            state.patch(cell, result);
            result = state.applyData(cell, result);
        }
        cells.push(result);
    }
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "tr",
        properties: {},
        children: state.wrap(cells, true)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $351e8ad919baf8ce$export$e1e720e5f4603e6a(state, node) {
    // Note: this function is normally not called: see `table-row` for how rows
    // and their cells are compiled.
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "td",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} HastElement
 * @typedef {import('hast').Text} HastText
 * @typedef {import('mdast').Text} MdastText
 * @typedef {import('../state.js').State} State
 */ const $ea29e1b8f554e312$var$tab = 9 /* `\t` */ ;
const $ea29e1b8f554e312$var$space = 32 /* ` ` */ ;
function $ea29e1b8f554e312$export$a771f20bdd13def9(value) {
    const source = String(value);
    const search = /\r?\n|\r/g;
    let match = search.exec(source);
    let last = 0;
    /** @type {Array<string>} */ const lines = [];
    while(match){
        lines.push($ea29e1b8f554e312$var$trimLine(source.slice(last, match.index), last > 0, true), match[0]);
        last = match.index + match[0].length;
        match = search.exec(source);
    }
    lines.push($ea29e1b8f554e312$var$trimLine(source.slice(last), last > 0, false));
    return lines.join("");
}
/**
 * @param {string} value
 *   Line to trim.
 * @param {boolean} start
 *   Whether to trim the start of the line.
 * @param {boolean} end
 *   Whether to trim the end of the line.
 * @returns {string}
 *   Trimmed line.
 */ function $ea29e1b8f554e312$var$trimLine(value, start, end) {
    let startIndex = 0;
    let endIndex = value.length;
    if (start) {
        let code = value.codePointAt(startIndex);
        while(code === $ea29e1b8f554e312$var$tab || code === $ea29e1b8f554e312$var$space){
            startIndex++;
            code = value.codePointAt(startIndex);
        }
    }
    if (end) {
        let code = value.codePointAt(endIndex - 1);
        while(code === $ea29e1b8f554e312$var$tab || code === $ea29e1b8f554e312$var$space){
            endIndex--;
            code = value.codePointAt(endIndex - 1);
        }
    }
    return endIndex > startIndex ? value.slice(startIndex, endIndex) : "";
}


function $92e15f0b3df21454$export$6f093cfa640b7166(state, node) {
    /** @type {HastText} */ const result = {
        type: "text",
        value: (0, $ea29e1b8f554e312$export$a771f20bdd13def9)(String(node.value))
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


/**
 * @typedef {import('hast').Element} Element
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../state.js').State} State
 */ // Make VS Code show references to the above types.
"";
function $34143969670a9f52$export$ba7b13e047416c03(state, node) {
    /** @type {Element} */ const result = {
        type: "element",
        tagName: "hr",
        properties: {},
        children: []
    };
    state.patch(node, result);
    return state.applyData(node, result);
}


const $ec8ba7340b5e991c$export$455ce229eb3d2472 = {
    blockquote: $b5c6e9c33097077d$export$67dc04e652a298ca,
    break: (0, $09339e8bad780139$export$371da9dd35aba193),
    code: $4b8fc966f9f9498f$export$6565f9f03506010b,
    delete: (0, $2f5f6c8e09431814$export$19426ff118fe8be),
    emphasis: $ab08c4d78c2502f7$export$bef81ba411953b51,
    footnoteReference: $f53283b430343b34$export$7f87ee744075c1ba,
    heading: $c7f0279a942eb70d$export$46e4a324ac90507f,
    html: $89b602966f88e584$export$c0bb0b647f701bb5,
    imageReference: $6569e722fb2ce946$export$f281796f6bc3b8db,
    image: $d856dba8ceab62bd$export$5c452ff88e35e47d,
    inlineCode: $597195a23d65a586$export$91b9bee19a0d8569,
    linkReference: $24acf304cb02fb78$export$e6c469b1b7b2bc6a,
    link: $57a06cf48a2aebb5$export$9c30223ca0a664fb,
    listItem: $773c5142d98ed87b$export$76c7e83ecc9cdf05,
    list: $fa594ff479f8c3b8$export$8837f4fc672e936d,
    paragraph: $c92517f4f4ee03f9$export$9c206ddddb32a9b,
    root: // @ts-expect-error: root is different, but hard to type.
    $77834837f6cb436f$export$e8e78c978b129247,
    strong: $d8a5c1774c1958e3$export$59ae2c325a998f89,
    table: $efa6caacabd42864$export$9852986a3ec5f6a0,
    tableCell: $351e8ad919baf8ce$export$e1e720e5f4603e6a,
    tableRow: $125fc21376eb63dd$export$ce666bf02318c957,
    text: $92e15f0b3df21454$export$6f093cfa640b7166,
    thematicBreak: $34143969670a9f52$export$ba7b13e047416c03,
    toml: $ec8ba7340b5e991c$var$ignore,
    yaml: $ec8ba7340b5e991c$var$ignore,
    definition: $ec8ba7340b5e991c$var$ignore,
    footnoteDefinition: $ec8ba7340b5e991c$var$ignore
};
// Return nothing for nodes that are ignored.
function $ec8ba7340b5e991c$var$ignore() {
    return undefined;
}


const $caccdfd5cbf72a05$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $caccdfd5cbf72a05$var$emptyOptions = {};
function $caccdfd5cbf72a05$export$e6a0daad8304de(tree, options) {
    const settings = options || $caccdfd5cbf72a05$var$emptyOptions;
    /** @type {Map<string, MdastDefinition>} */ const definitionById = new Map();
    /** @type {Map<string, MdastFootnoteDefinition>} */ const footnoteById = new Map();
    /** @type {Map<string, number>} */ const footnoteCounts = new Map();
    /** @type {Handlers} */ // @ts-expect-error: the root handler returns a root.
    // Hard to type.
    const handlers = {
        ...(0, $ec8ba7340b5e991c$export$455ce229eb3d2472),
        ...settings.handlers
    };
    /** @type {State} */ const state = {
        all: all,
        applyData: $caccdfd5cbf72a05$var$applyData,
        definitionById: definitionById,
        footnoteById: footnoteById,
        footnoteCounts: footnoteCounts,
        footnoteOrder: [],
        handlers: handlers,
        one: one,
        options: settings,
        patch: $caccdfd5cbf72a05$var$patch,
        wrap: $caccdfd5cbf72a05$export$4997ffc0176396a6
    };
    (0, $425a1aa39753930c$export$bf638b60ea8b89b7)(tree, function(node) {
        if (node.type === "definition" || node.type === "footnoteDefinition") {
            const map = node.type === "definition" ? definitionById : footnoteById;
            const id = String(node.identifier).toUpperCase();
            // Mimick CM behavior of link definitions.
            // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/9032189/lib/index.js#L20-L21>.
            if (!map.has(id)) // @ts-expect-error: node type matches map.
            map.set(id, node);
        }
    });
    return state;
    /**
   * Transform an mdast node into a hast node.
   *
   * @param {MdastNodes} node
   *   mdast node.
   * @param {MdastParents | undefined} [parent]
   *   Parent of `node`.
   * @returns {Array<HastElementContent> | HastElementContent | undefined}
   *   Resulting hast node.
   */ function one(node, parent) {
        const type = node.type;
        const handle = state.handlers[type];
        if ($caccdfd5cbf72a05$var$own.call(state.handlers, type) && handle) return handle(state, node, parent);
        if (state.options.passThrough && state.options.passThrough.includes(type)) {
            if ("children" in node) {
                const { children: children, ...shallow } = node;
                const result = (0, $3567eb35e91f3fe8$export$2e2bcd8739ae039)(shallow);
                // @ts-expect-error: TS doesn’t understand…
                result.children = state.all(node);
                // @ts-expect-error: TS doesn’t understand…
                return result;
            }
            // @ts-expect-error: it’s custom.
            return (0, $3567eb35e91f3fe8$export$2e2bcd8739ae039)(node);
        }
        const unknown = state.options.unknownHandler || $caccdfd5cbf72a05$var$defaultUnknownHandler;
        return unknown(state, node, parent);
    }
    /**
   * Transform the children of an mdast node into hast nodes.
   *
   * @param {MdastNodes} parent
   *   mdast node to compile
   * @returns {Array<HastElementContent>}
   *   Resulting hast nodes.
   */ function all(parent) {
        /** @type {Array<HastElementContent>} */ const values = [];
        if ("children" in parent) {
            const nodes = parent.children;
            let index = -1;
            while(++index < nodes.length){
                const result = state.one(nodes[index], parent);
                // To do: see if we van clean this? Can we merge texts?
                if (result) {
                    if (index && nodes[index - 1].type === "break") {
                        if (!Array.isArray(result) && result.type === "text") result.value = $caccdfd5cbf72a05$var$trimMarkdownSpaceStart(result.value);
                        if (!Array.isArray(result) && result.type === "element") {
                            const head = result.children[0];
                            if (head && head.type === "text") head.value = $caccdfd5cbf72a05$var$trimMarkdownSpaceStart(head.value);
                        }
                    }
                    if (Array.isArray(result)) values.push(...result);
                    else values.push(result);
                }
            }
        }
        return values;
    }
}
/**
 * Copy a node’s positional info.
 *
 * @param {MdastNodes} from
 *   mdast node to copy from.
 * @param {HastNodes} to
 *   hast node to copy into.
 * @returns {undefined}
 *   Nothing.
 */ function $caccdfd5cbf72a05$var$patch(from, to) {
    if (from.position) to.position = (0, $376270e3d73468cb$export$5880b8b5730aff45)(from);
}
/**
 * Honor the `data` of `from` and maybe generate an element instead of `to`.
 *
 * @template {HastNodes} Type
 *   Node type.
 * @param {MdastNodes} from
 *   mdast node to use data from.
 * @param {Type} to
 *   hast node to change.
 * @returns {HastElement | Type}
 *   Nothing.
 */ function $caccdfd5cbf72a05$var$applyData(from, to) {
    /** @type {HastElement | Type} */ let result = to;
    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (from && from.data) {
        const hName = from.data.hName;
        const hChildren = from.data.hChildren;
        const hProperties = from.data.hProperties;
        if (typeof hName === "string") {
            // Transforming the node resulted in an element with a different name
            // than wanted:
            if (result.type === "element") result.tagName = hName;
            else {
                /** @type {Array<HastElementContent>} */ // @ts-expect-error: assume no doctypes in `root`.
                const children = "children" in result ? result.children : [
                    result
                ];
                result = {
                    type: "element",
                    tagName: hName,
                    properties: {},
                    children: children
                };
            }
        }
        if (result.type === "element" && hProperties) Object.assign(result.properties, (0, $3567eb35e91f3fe8$export$2e2bcd8739ae039)(hProperties));
        if ("children" in result && result.children && hChildren !== null && hChildren !== undefined) result.children = hChildren;
    }
    return result;
}
/**
 * Transform an unknown node.
 *
 * @param {State} state
 *   Info passed around.
 * @param {MdastNodes} node
 *   Unknown mdast node.
 * @returns {HastElement | HastText}
 *   Resulting hast node.
 */ function $caccdfd5cbf72a05$var$defaultUnknownHandler(state, node) {
    const data = node.data || {};
    /** @type {HastElement | HastText} */ const result = "value" in node && !($caccdfd5cbf72a05$var$own.call(data, "hProperties") || $caccdfd5cbf72a05$var$own.call(data, "hChildren")) ? {
        type: "text",
        value: node.value
    } : {
        type: "element",
        tagName: "div",
        properties: {},
        children: state.all(node)
    };
    state.patch(node, result);
    return state.applyData(node, result);
}
function $caccdfd5cbf72a05$export$4997ffc0176396a6(nodes, loose) {
    /** @type {Array<HastText | Type>} */ const result = [];
    let index = -1;
    if (loose) result.push({
        type: "text",
        value: "\n"
    });
    while(++index < nodes.length){
        if (index) result.push({
            type: "text",
            value: "\n"
        });
        result.push(nodes[index]);
    }
    if (loose && nodes.length > 0) result.push({
        type: "text",
        value: "\n"
    });
    return result;
}
/**
 * Trim spaces and tabs at the start of `value`.
 *
 * @param {string} value
 *   Value to trim.
 * @returns {string}
 *   Result.
 */ function $caccdfd5cbf72a05$var$trimMarkdownSpaceStart(value) {
    let index = 0;
    let code = value.charCodeAt(index);
    while(code === 9 || code === 32){
        index++;
        code = value.charCodeAt(index);
    }
    return value.slice(index);
}


function $9c63f1b14b68d1b1$export$c0e4c5cf07538633(tree, options) {
    const state = (0, $caccdfd5cbf72a05$export$e6a0daad8304de)(tree, options);
    const node = state.one(tree, undefined);
    const foot = (0, $64a846b37751068f$export$adb608be33961c98)(state);
    /** @type {HastNodes} */ const result = Array.isArray(node) ? {
        type: "root",
        children: node
    } : node || {
        type: "root",
        children: []
    };
    if (foot) {
        // If there’s a footer, there were definitions, meaning block
        // content.
        // So `result` is a parent node.
        (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)("children" in result);
        result.children.push({
            type: "text",
            value: "\n"
        }, foot);
    }
    return result;
}


function $17f743cea1135a51$export$2e2bcd8739ae039(destination, options) {
    if (destination && "run" in destination) /**
     * @type {TransformBridge}
     */ return async function(tree, file) {
        // Cast because root in -> root out.
        const hastTree = /** @type {HastRoot} */ (0, $9c63f1b14b68d1b1$export$c0e4c5cf07538633)(tree, options);
        await destination.run(hastTree, file);
    };
    /**
   * @type {TransformMutate}
   */ return function(tree) {
        // Cast because root in -> root out.
        return /** @type {HastRoot} */ (0, $9c63f1b14b68d1b1$export$c0e4c5cf07538633)(tree, options || destination);
    };
}


/**
 * @typedef {import('trough').Pipeline} Pipeline
 *
 * @typedef {import('unist').Node} Node
 *
 * @typedef {import('vfile').Compatible} Compatible
 * @typedef {import('vfile').Value} Value
 *
 * @typedef {import('../index.js').CompileResultMap} CompileResultMap
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Settings} Settings
 */ /**
 * @typedef {CompileResultMap[keyof CompileResultMap]} CompileResults
 *   Acceptable results from compilers.
 *
 *   To register custom results, add them to
 *   {@link CompileResultMap `CompileResultMap`}.
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the compiler receives (default: `Node`).
 * @template {CompileResults} [Result=CompileResults]
 *   The thing that the compiler yields (default: `CompileResults`).
 * @callback Compiler
 *   A **compiler** handles the compiling of a syntax tree to something else
 *   (in most cases, text) (TypeScript type).
 *
 *   It is used in the stringify phase and called with a {@link Node `Node`}
 *   and {@link VFile `VFile`} representation of the document to compile.
 *   It should return the textual representation of the given tree (typically
 *   `string`).
 *
 *   > 👉 **Note**: unified typically compiles by serializing: most compilers
 *   > return `string` (or `Uint8Array`).
 *   > Some compilers, such as the one configured with
 *   > [`rehype-react`][rehype-react], return other values (in this case, a
 *   > React tree).
 *   > If you’re using a compiler that doesn’t serialize, expect different
 *   > result values.
 *   >
 *   > To register custom results in TypeScript, add them to
 *   > {@link CompileResultMap `CompileResultMap`}.
 *
 *   [rehype-react]: https://github.com/rehypejs/rehype-react
 * @param {Tree} tree
 *   Tree to compile.
 * @param {VFile} file
 *   File associated with `tree`.
 * @returns {Result}
 *   New content: compiled text (`string` or `Uint8Array`, for `file.value`) or
 *   something else (for `file.result`).
 */ /**
 * @template {Node} [Tree=Node]
 *   The node that the parser yields (default: `Node`)
 * @callback Parser
 *   A **parser** handles the parsing of text to a syntax tree.
 *
 *   It is used in the parse phase and is called with a `string` and
 *   {@link VFile `VFile`} of the document to parse.
 *   It must return the syntax tree representation of the given file
 *   ({@link Node `Node`}).
 * @param {string} document
 *   Document to parse.
 * @param {VFile} file
 *   File associated with `document`.
 * @returns {Tree}
 *   Node representing the given file.
 */ /**
 * @typedef {(
 *   Plugin<Array<any>, any, any> |
 *   PluginTuple<Array<any>, any, any> |
 *   Preset
 * )} Pluggable
 *   Union of the different ways to add plugins and settings.
 */ /**
 * @typedef {Array<Pluggable>} PluggableList
 *   List of plugins and presets.
 */ // Note: we can’t use `callback` yet as it messes up `this`:
//  <https://github.com/microsoft/TypeScript/issues/55197>.
/**
 * @template {Array<unknown>} [PluginParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=Node]
 *   Value that is expected as input (default: `Node`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=Input]
 *   Value that is yielded as output (default: `Input`).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   (this: Processor, ...parameters: PluginParameters) =>
 *     Input extends string ? // Parser.
 *        Output extends Node | undefined ? undefined | void : never :
 *     Output extends CompileResults ? // Compiler.
 *        Input extends Node | undefined ? undefined | void : never :
 *     Transformer<
 *       Input extends Node ? Input : Node,
 *       Output extends Node ? Output : Node
 *     > | undefined | void
 * )} Plugin
 *   Single plugin.
 *
 *   Plugins configure the processors they are applied on in the following
 *   ways:
 *
 *   *   they change the processor, such as the parser, the compiler, or by
 *       configuring data
 *   *   they specify how to handle trees and files
 *
 *   In practice, they are functions that can receive options and configure the
 *   processor (`this`).
 *
 *   > 👉 **Note**: plugins are called when the processor is *frozen*, not when
 *   > they are applied.
 */ /**
 * Tuple of a plugin and its configuration.
 *
 * The first item is a plugin, the rest are its parameters.
 *
 * @template {Array<unknown>} [TupleParameters=[]]
 *   Arguments passed to the plugin (default: `[]`, the empty tuple).
 * @template {Node | string | undefined} [Input=undefined]
 *   Value that is expected as input (optional).
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node it expects.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be
 *       `string`.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be the
 *       node it expects.
 * @template [Output=undefined] (optional).
 *   Value that is yielded as output.
 *
 *   *   If the plugin returns a {@link Transformer `Transformer`}, this
 *       should be the node that that yields.
 *   *   If the plugin sets a {@link Parser `Parser`}, this should be the
 *       node that it yields.
 *   *   If the plugin sets a {@link Compiler `Compiler`}, this should be
 *       result it yields.
 * @typedef {(
 *   [
 *     plugin: Plugin<TupleParameters, Input, Output>,
 *     ...parameters: TupleParameters
 *   ]
 * )} PluginTuple
 */ /**
 * @typedef Preset
 *   Sharable configuration.
 *
 *   They can contain plugins and settings.
 * @property {PluggableList | undefined} [plugins]
 *   List of plugins and presets (optional).
 * @property {Settings | undefined} [settings]
 *   Shared settings for parsers and compilers (optional).
 */ /**
 * @template {VFile} [File=VFile]
 *   The file that the callback receives (default: `VFile`).
 * @callback ProcessCallback
 *   Callback called when the process is done.
 *
 *   Called with either an error or a result.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {File | undefined} [file]
 *   Processed file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Tree=Node]
 *   The tree that the callback receives (default: `Node`).
 * @callback RunCallback
 *   Callback called when transformers are done.
 *
 *   Called with either an error or results.
 * @param {Error | undefined} [error]
 *   Fatal error (optional).
 * @param {Tree | undefined} [tree]
 *   Transformed tree (optional).
 * @param {VFile | undefined} [file]
 *   File (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Output=Node]
 *   Node type that the transformer yields (default: `Node`).
 * @callback TransformCallback
 *   Callback passed to transforms.
 *
 *   If the signature of a `transformer` accepts a third argument, the
 *   transformer may perform asynchronous operations, and must call it.
 * @param {Error | undefined} [error]
 *   Fatal error to stop the process (optional).
 * @param {Output | undefined} [tree]
 *   New, changed, tree (optional).
 * @param {VFile | undefined} [file]
 *   New, changed, file (optional).
 * @returns {undefined}
 *   Nothing.
 */ /**
 * @template {Node} [Input=Node]
 *   Node type that the transformer expects (default: `Node`).
 * @template {Node} [Output=Input]
 *   Node type that the transformer yields (default: `Input`).
 * @callback Transformer
 *   Transformers handle syntax trees and files.
 *
 *   They are functions that are called each time a syntax tree and file are
 *   passed through the run phase.
 *   When an error occurs in them (either because it’s thrown, returned,
 *   rejected, or passed to `next`), the process stops.
 *
 *   The run phase is handled by [`trough`][trough], see its documentation for
 *   the exact semantics of these functions.
 *
 *   > 👉 **Note**: you should likely ignore `next`: don’t accept it.
 *   > it supports callback-style async work.
 *   > But promises are likely easier to reason about.
 *
 *   [trough]: https://github.com/wooorm/trough#function-fninput-next
 * @param {Input} tree
 *   Tree to handle.
 * @param {VFile} file
 *   File to handle.
 * @param {TransformCallback<Output>} next
 *   Callback.
 * @returns {(
 *   Promise<Output | undefined | void> |
 *   Promise<never> | // For some reason this is needed separately.
 *   Output |
 *   Error |
 *   undefined |
 *   void
 * )}
 *   If you accept `next`, nothing.
 *   Otherwise:
 *
 *   *   `Error` — fatal error to stop the process
 *   *   `Promise<undefined>` or `undefined` — the next transformer keeps using
 *       same tree
 *   *   `Promise<Node>` or `Node` — new, changed, tree
 */ /**
 * @template {Node | undefined} ParseTree
 *   Output of `parse`.
 * @template {Node | undefined} HeadTree
 *   Input for `run`.
 * @template {Node | undefined} TailTree
 *   Output for `run`.
 * @template {Node | undefined} CompileTree
 *   Input of `stringify`.
 * @template {CompileResults | undefined} CompileResult
 *   Output of `stringify`.
 * @template {Node | string | undefined} Input
 *   Input of plugin.
 * @template Output
 *   Output of plugin (optional).
 * @typedef {(
 *   Input extends string
 *     ? Output extends Node | undefined
 *       ? // Parser.
 *         Processor<
 *           Output extends undefined ? ParseTree : Output,
 *           HeadTree,
 *           TailTree,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Output extends CompileResults
 *     ? Input extends Node | undefined
 *       ? // Compiler.
 *         Processor<
 *           ParseTree,
 *           HeadTree,
 *           TailTree,
 *           Input extends undefined ? CompileTree : Input,
 *           Output extends undefined ? CompileResult : Output
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : Input extends Node | undefined
 *     ? Output extends Node | undefined
 *       ? // Transform.
 *         Processor<
 *           ParseTree,
 *           HeadTree extends undefined ? Input : HeadTree,
 *           Output extends undefined ? TailTree : Output,
 *           CompileTree,
 *           CompileResult
 *         >
 *       : // Unknown.
 *         Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 *     : // Unknown.
 *       Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>
 * )} UsePlugin
 *   Create a processor based on the input/output of a {@link Plugin plugin}.
 */ /**
 * @template {CompileResults | undefined} Result
 *   Node type that the transformer yields.
 * @typedef {(
 *   Result extends Value | undefined ?
 *     VFile :
 *     VFile & {result: Result}
 *   )} VFileWithOutput
 *   Type to generate a {@link VFile `VFile`} corresponding to a compiler result.
 *
 *   If a result that is not acceptable on a `VFile` is used, that will
 *   be stored on the `result` field of {@link VFile `VFile`}.
 */ /**
 * Throw a given error.
 *
 * @param {Error|null|undefined} [error]
 *   Maybe error.
 * @returns {asserts error is null|undefined}
 */ function $864220ba46ea3463$export$dd911e13ecb11e05(error) {
    if (error) throw error;
}


var $3546b8beef561689$exports = {};
"use strict";
var $3546b8beef561689$var$hasOwn = Object.prototype.hasOwnProperty;
var $3546b8beef561689$var$toStr = Object.prototype.toString;
var $3546b8beef561689$var$defineProperty = Object.defineProperty;
var $3546b8beef561689$var$gOPD = Object.getOwnPropertyDescriptor;
var $3546b8beef561689$var$isArray = function isArray(arr) {
    if (typeof Array.isArray === "function") return Array.isArray(arr);
    return $3546b8beef561689$var$toStr.call(arr) === "[object Array]";
};
var $3546b8beef561689$var$isPlainObject = function isPlainObject(obj) {
    if (!obj || $3546b8beef561689$var$toStr.call(obj) !== "[object Object]") return false;
    var hasOwnConstructor = $3546b8beef561689$var$hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && $3546b8beef561689$var$hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    // Not own constructor property must be Object
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) return false;
    // Own properties are enumerated firstly, so to speed up,
    // if last one is own, then all properties are own.
    var key;
    for(key in obj);
    return typeof key === "undefined" || $3546b8beef561689$var$hasOwn.call(obj, key);
};
// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var $3546b8beef561689$var$setProperty = function setProperty(target, options) {
    if ($3546b8beef561689$var$defineProperty && options.name === "__proto__") $3546b8beef561689$var$defineProperty(target, options.name, {
        enumerable: true,
        configurable: true,
        value: options.newValue,
        writable: true
    });
    else target[options.name] = options.newValue;
};
// Return undefined instead of __proto__ if '__proto__' is not an own property
var $3546b8beef561689$var$getProperty = function getProperty(obj, name) {
    if (name === "__proto__") {
        if (!$3546b8beef561689$var$hasOwn.call(obj, name)) return void 0;
        else if ($3546b8beef561689$var$gOPD) // In early versions of node, obj['__proto__'] is buggy when obj has
        // __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
        return $3546b8beef561689$var$gOPD(obj, name).value;
    }
    return obj[name];
};
$3546b8beef561689$exports = function extend() {
    var options, name, src, copy, copyIsArray, clone;
    var target = arguments[0];
    var i = 1;
    var length = arguments.length;
    var deep = false;
    // Handle a deep copy situation
    if (typeof target === "boolean") {
        deep = target;
        target = arguments[1] || {};
        // skip the boolean and the target
        i = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") target = {};
    for(; i < length; ++i){
        options = arguments[i];
        // Only deal with non-null/undefined values
        if (options != null) // Extend the base object
        for(name in options){
            src = $3546b8beef561689$var$getProperty(target, name);
            copy = $3546b8beef561689$var$getProperty(options, name);
            // Prevent never-ending loop
            if (target !== copy) {
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && ($3546b8beef561689$var$isPlainObject(copy) || (copyIsArray = $3546b8beef561689$var$isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && $3546b8beef561689$var$isArray(src) ? src : [];
                    } else clone = src && $3546b8beef561689$var$isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    $3546b8beef561689$var$setProperty(target, {
                        name: name,
                        newValue: extend(deep, clone, copy)
                    });
                // Don't bring in undefined values
                } else if (typeof copy !== "undefined") $3546b8beef561689$var$setProperty(target, {
                    name: name,
                    newValue: copy
                });
            }
        }
    }
    // Return the modified object
    return target;
};



function $72a1e67b51df2d6f$export$2e2bcd8739ae039(value) {
    if (typeof value !== "object" || value === null) return false;
    const prototype = Object.getPrototypeOf(value);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}


/**
 * @typedef {(error?: Error|null|undefined, ...output: Array<any>) => void} Callback
 * @typedef {(...input: Array<any>) => any} Middleware
 *
 * @typedef {(...input: Array<any>) => void} Run
 *   Call all middleware.
 * @typedef {(fn: Middleware) => Pipeline} Use
 *   Add `fn` (middleware) to the list.
 * @typedef {{run: Run, use: Use}} Pipeline
 *   Middleware.
 */ /**
 * Create new middleware.
 *
 * @returns {Pipeline}
 */ function $9993211b3837d06d$export$91b56f5ca106aa43() {
    /** @type {Array<Middleware>} */ const fns = [];
    /** @type {Pipeline} */ const pipeline = {
        run: run,
        use: use
    };
    return pipeline;
    /** @type {Run} */ function run(...values) {
        let middlewareIndex = -1;
        /** @type {Callback} */ const callback = values.pop();
        if (typeof callback !== "function") throw new TypeError("Expected function as last argument, not " + callback);
        next(null, ...values);
        /**
     * Run the next `fn`, or we’re done.
     *
     * @param {Error|null|undefined} error
     * @param {Array<any>} output
     */ function next(error, ...output) {
            const fn = fns[++middlewareIndex];
            let index = -1;
            if (error) {
                callback(error);
                return;
            }
            // Copy non-nullish input into values.
            while(++index < values.length)if (output[index] === null || output[index] === undefined) output[index] = values[index];
            // Save the newly created `output` for the next call.
            values = output;
            // Next or done.
            if (fn) $9993211b3837d06d$export$4997ffc0176396a6(fn, next)(...output);
            else callback(null, ...output);
        }
    }
    /** @type {Use} */ function use(middelware) {
        if (typeof middelware !== "function") throw new TypeError("Expected `middelware` to be a function, not " + middelware);
        fns.push(middelware);
        return pipeline;
    }
}
function $9993211b3837d06d$export$4997ffc0176396a6(middleware, callback) {
    /** @type {boolean} */ let called;
    return wrapped;
    /**
   * Call `middleware`.
   * @this {any}
   * @param {Array<any>} parameters
   * @returns {void}
   */ function wrapped(...parameters) {
        const fnExpectsCallback = middleware.length > parameters.length;
        /** @type {any} */ let result;
        if (fnExpectsCallback) parameters.push(done);
        try {
            result = middleware.apply(this, parameters);
        } catch (error) {
            const exception = /** @type {Error} */ error;
            // Well, this is quite the pickle.
            // `middleware` received a callback and called it synchronously, but that
            // threw an error.
            // The only thing left to do is to throw the thing instead.
            if (fnExpectsCallback && called) throw exception;
            return done(exception);
        }
        if (!fnExpectsCallback) {
            if (result instanceof Promise) result.then(then, done);
            else if (result instanceof Error) done(result);
            else then(result);
        }
    }
    /**
   * Call `callback`, only once.
   * @type {Callback}
   */ function done(error, ...output) {
        if (!called) {
            called = true;
            callback(error, ...output);
        }
    }
    /**
   * Call `done` with one value.
   *
   * @param {any} [value]
   */ function then(value) {
        done(null, value);
    }
}


/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Point} Point
 * @typedef {import('unist').Position} Position
 * @typedef {import('vfile-message').Options} MessageOptions
 * @typedef {import('../index.js').Data} Data
 * @typedef {import('../index.js').Value} Value
 */ /**
 * @typedef {object & {type: string, position?: Position | undefined}} NodeLike
 *
 * @typedef {Options | URL | VFile | Value} Compatible
 *   Things that can be passed to the constructor.
 *
 * @typedef VFileCoreOptions
 *   Set multiple values.
 * @property {string | null | undefined} [basename]
 *   Set `basename` (name).
 * @property {string | null | undefined} [cwd]
 *   Set `cwd` (working directory).
 * @property {Data | null | undefined} [data]
 *   Set `data` (associated info).
 * @property {string | null | undefined} [dirname]
 *   Set `dirname` (path w/o basename).
 * @property {string | null | undefined} [extname]
 *   Set `extname` (extension with dot).
 * @property {Array<string> | null | undefined} [history]
 *   Set `history` (paths the file moved between).
 * @property {URL | string | null | undefined} [path]
 *   Set `path` (current path).
 * @property {string | null | undefined} [stem]
 *   Set `stem` (name without extension).
 * @property {Value | null | undefined} [value]
 *   Set `value` (the contents of the file).
 *
 * @typedef Map
 *   Raw source map.
 *
 *   See:
 *   <https://github.com/mozilla/source-map/blob/60adcb0/source-map.d.ts#L15-L23>.
 * @property {number} version
 *   Which version of the source map spec this map is following.
 * @property {Array<string>} sources
 *   An array of URLs to the original source files.
 * @property {Array<string>} names
 *   An array of identifiers which can be referenced by individual mappings.
 * @property {string | undefined} [sourceRoot]
 *   The URL root from which all sources are relative.
 * @property {Array<string> | undefined} [sourcesContent]
 *   An array of contents of the original source files.
 * @property {string} mappings
 *   A string of base64 VLQs which contain the actual mappings.
 * @property {string} file
 *   The generated file this source map is associated with.
 *
 * @typedef {Record<string, unknown> & VFileCoreOptions} Options
 *   Configuration.
 *
 *   A bunch of keys that will be shallow copied over to the new file.
 *
 * @typedef {Record<string, unknown>} ReporterSettings
 *   Configuration for reporters.
 */ /**
 * @template [Settings=ReporterSettings]
 *   Options type.
 * @callback Reporter
 *   Type for a reporter.
 * @param {Array<VFile>} files
 *   Files to report.
 * @param {Settings} options
 *   Configuration.
 * @returns {string}
 *   Report.
 */ 
// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
const $953807132fc69013$export$bb654e07daaf8c3a = {
    basename: $953807132fc69013$var$basename,
    dirname: $953807132fc69013$var$dirname,
    extname: $953807132fc69013$var$extname,
    join: $953807132fc69013$var$join,
    sep: "/"
};
/* eslint-disable max-depth, complexity */ /**
 * Get the basename from a path.
 *
 * @param {string} path
 *   File path.
 * @param {string | null | undefined} [ext]
 *   Extension to strip.
 * @returns {string}
 *   Stem or basename.
 */ function $953807132fc69013$var$basename(path, ext) {
    if (ext !== undefined && typeof ext !== "string") throw new TypeError('"ext" argument must be a string');
    $953807132fc69013$var$assertPath(path);
    let start = 0;
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let seenNonSlash;
    if (ext === undefined || ext.length === 0 || ext.length > path.length) {
        while(index--){
            if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            {
                if (seenNonSlash) {
                    start = index + 1;
                    break;
                }
            } else if (end < 0) {
                // We saw the first non-path separator, mark this as the end of our
                // path component.
                seenNonSlash = true;
                end = index + 1;
            }
        }
        return end < 0 ? "" : path.slice(start, end);
    }
    if (ext === path) return "";
    let firstNonSlashEnd = -1;
    let extIndex = ext.length - 1;
    while(index--){
        if (path.codePointAt(index) === 47 /* `/` */ ) // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        {
            if (seenNonSlash) {
                start = index + 1;
                break;
            }
        } else {
            if (firstNonSlashEnd < 0) {
                // We saw the first non-path separator, remember this index in case
                // we need it if the extension ends up not matching.
                seenNonSlash = true;
                firstNonSlashEnd = index + 1;
            }
            if (extIndex > -1) {
                // Try to match the explicit extension.
                if (path.codePointAt(index) === ext.codePointAt(extIndex--)) {
                    if (extIndex < 0) // We matched the extension, so mark this as the end of our path
                    // component
                    end = index;
                } else {
                    // Extension does not match, so our result is the entire path
                    // component
                    extIndex = -1;
                    end = firstNonSlashEnd;
                }
            }
        }
    }
    if (start === end) end = firstNonSlashEnd;
    else if (end < 0) end = path.length;
    return path.slice(start, end);
}
/**
 * Get the dirname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ function $953807132fc69013$var$dirname(path) {
    $953807132fc69013$var$assertPath(path);
    if (path.length === 0) return ".";
    let end = -1;
    let index = path.length;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    // Prefix `--` is important to not run on `0`.
    while(--index){
        if (path.codePointAt(index) === 47 /* `/` */ ) {
            if (unmatchedSlash) {
                end = index;
                break;
            }
        } else if (!unmatchedSlash) // We saw the first non-path separator
        unmatchedSlash = true;
    }
    return end < 0 ? path.codePointAt(0) === 47 /* `/` */  ? "/" : "." : end === 1 && path.codePointAt(0) === 47 /* `/` */  ? "//" : path.slice(0, end);
}
/**
 * Get an extname from a path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   Extname.
 */ function $953807132fc69013$var$extname(path) {
    $953807132fc69013$var$assertPath(path);
    let index = path.length;
    let end = -1;
    let startPart = 0;
    let startDot = -1;
    // Track the state of characters (if any) we see before our first dot and
    // after any path separator we find.
    let preDotState = 0;
    /** @type {boolean | undefined} */ let unmatchedSlash;
    while(index--){
        const code = path.codePointAt(index);
        if (code === 47 /* `/` */ ) {
            // If we reached a path separator that was not part of a set of path
            // separators at the end of the string, stop now.
            if (unmatchedSlash) {
                startPart = index + 1;
                break;
            }
            continue;
        }
        if (end < 0) {
            // We saw the first non-path separator, mark this as the end of our
            // extension.
            unmatchedSlash = true;
            end = index + 1;
        }
        if (code === 46 /* `.` */ ) {
            // If this is our first dot, mark it as the start of our extension.
            if (startDot < 0) startDot = index;
            else if (preDotState !== 1) preDotState = 1;
        } else if (startDot > -1) // We saw a non-dot and non-path separator before our dot, so we should
        // have a good chance at having a non-empty extension.
        preDotState = -1;
    }
    if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
    preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
    preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return "";
    return path.slice(startDot, end);
}
/**
 * Join segments from a path.
 *
 * @param {Array<string>} segments
 *   Path segments.
 * @returns {string}
 *   File path.
 */ function $953807132fc69013$var$join(...segments) {
    let index = -1;
    /** @type {string | undefined} */ let joined;
    while(++index < segments.length){
        $953807132fc69013$var$assertPath(segments[index]);
        if (segments[index]) joined = joined === undefined ? segments[index] : joined + "/" + segments[index];
    }
    return joined === undefined ? "." : $953807132fc69013$var$normalize(joined);
}
/**
 * Normalize a basic file path.
 *
 * @param {string} path
 *   File path.
 * @returns {string}
 *   File path.
 */ // Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function $953807132fc69013$var$normalize(path) {
    $953807132fc69013$var$assertPath(path);
    const absolute = path.codePointAt(0) === 47 /* `/` */ ;
    // Normalize the path according to POSIX rules.
    let value = $953807132fc69013$var$normalizeString(path, !absolute);
    if (value.length === 0 && !absolute) value = ".";
    if (value.length > 0 && path.codePointAt(path.length - 1) === 47 /* / */ ) value += "/";
    return absolute ? "/" + value : value;
}
/**
 * Resolve `.` and `..` elements in a path with directory names.
 *
 * @param {string} path
 *   File path.
 * @param {boolean} allowAboveRoot
 *   Whether `..` can move above root.
 * @returns {string}
 *   File path.
 */ function $953807132fc69013$var$normalizeString(path, allowAboveRoot) {
    let result = "";
    let lastSegmentLength = 0;
    let lastSlash = -1;
    let dots = 0;
    let index = -1;
    /** @type {number | undefined} */ let code;
    /** @type {number} */ let lastSlashIndex;
    while(++index <= path.length){
        if (index < path.length) code = path.codePointAt(index);
        else if (code === 47 /* `/` */ ) break;
        else code = 47 /* `/` */ ;
        if (code === 47 /* `/` */ ) {
            if (lastSlash === index - 1 || dots === 1) ;
            else if (lastSlash !== index - 1 && dots === 2) {
                if (result.length < 2 || lastSegmentLength !== 2 || result.codePointAt(result.length - 1) !== 46 /* `.` */  || result.codePointAt(result.length - 2) !== 46 /* `.` */ ) {
                    if (result.length > 2) {
                        lastSlashIndex = result.lastIndexOf("/");
                        if (lastSlashIndex !== result.length - 1) {
                            if (lastSlashIndex < 0) {
                                result = "";
                                lastSegmentLength = 0;
                            } else {
                                result = result.slice(0, lastSlashIndex);
                                lastSegmentLength = result.length - 1 - result.lastIndexOf("/");
                            }
                            lastSlash = index;
                            dots = 0;
                            continue;
                        }
                    } else if (result.length > 0) {
                        result = "";
                        lastSegmentLength = 0;
                        lastSlash = index;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    result = result.length > 0 ? result + "/.." : "..";
                    lastSegmentLength = 2;
                }
            } else {
                if (result.length > 0) result += "/" + path.slice(lastSlash + 1, index);
                else result = path.slice(lastSlash + 1, index);
                lastSegmentLength = index - lastSlash - 1;
            }
            lastSlash = index;
            dots = 0;
        } else if (code === 46 /* `.` */  && dots > -1) dots++;
        else dots = -1;
    }
    return result;
}
/**
 * Make sure `path` is a string.
 *
 * @param {string} path
 *   File path.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $953807132fc69013$var$assertPath(path) {
    if (typeof path !== "string") throw new TypeError("Path must be a string. Received " + JSON.stringify(path));
} /* eslint-enable max-depth, complexity */ 


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
const $34053c0b6595333c$export$97a5aaf482767187 = {
    cwd: $34053c0b6595333c$var$cwd
};
function $34053c0b6595333c$var$cwd() {
    return "/";
}


/**
 * Checks if a value has the shape of a WHATWG URL object.
 *
 * Using a symbol or instanceof would not be able to recognize URL objects
 * coming from other implementations (e.g. in Electron), so instead we are
 * checking some well known properties for a lack of a better test.
 *
 * We use `href` and `protocol` as they are the only properties that are
 * easy to retrieve and calculate due to the lazy nature of the getters.
 *
 * We check for auth attribute to distinguish legacy url instance with
 * WHATWG URL instance.
 *
 * @param {unknown} fileUrlOrPath
 *   File path or URL.
 * @returns {fileUrlOrPath is URL}
 *   Whether it’s a URL.
 */ // From: <https://github.com/nodejs/node/blob/6a3403c/lib/internal/url.js#L720>
function $7305c14dc01738f5$export$8304a22d431f958(fileUrlOrPath) {
    return Boolean(fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === undefined);
}


function $4c40bb55539458e0$export$9b2b676c902de799(path) {
    if (typeof path === "string") path = new URL(path);
    else if (!(0, $7305c14dc01738f5$export$8304a22d431f958)(path)) {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('The "path" argument must be of type string or an instance of URL. Received `' + path + "`");
        error.code = "ERR_INVALID_ARG_TYPE";
        throw error;
    }
    if (path.protocol !== "file:") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError("The URL must be of scheme file");
        error.code = "ERR_INVALID_URL_SCHEME";
        throw error;
    }
    return $4c40bb55539458e0$var$getPathFromURLPosix(path);
}
/**
 * Get a path from a POSIX URL.
 *
 * @param {URL} url
 *   URL.
 * @returns {string}
 *   File path.
 */ function $4c40bb55539458e0$var$getPathFromURLPosix(url) {
    if (url.hostname !== "") {
        /** @type {NodeJS.ErrnoException} */ const error = new TypeError('File URL host must be "localhost" or empty on darwin');
        error.code = "ERR_INVALID_FILE_URL_HOST";
        throw error;
    }
    const pathname = url.pathname;
    let index = -1;
    while(++index < pathname.length)if (pathname.codePointAt(index) === 37 /* `%` */  && pathname.codePointAt(index + 1) === 50 /* `2` */ ) {
        const third = pathname.codePointAt(index + 2);
        if (third === 70 /* `F` */  || third === 102 /* `f` */ ) {
            /** @type {NodeJS.ErrnoException} */ const error = new TypeError("File URL path must not include encoded / characters");
            error.code = "ERR_INVALID_FILE_URL_PATH";
            throw error;
        }
    }
    return decodeURIComponent(pathname);
}


/**
 * Order of setting (least specific to most), we need this because otherwise
 * `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
 * stem can be set.
 */ const $30d620e50417fdeb$var$order = /** @type {const} */ [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
];
class $30d620e50417fdeb$export$93dff69eb10dc7ce {
    /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */ constructor(value){
        /** @type {Options | VFile} */ let options;
        if (!value) options = {};
        else if ((0, $7305c14dc01738f5$export$8304a22d431f958)(value)) options = {
            path: value
        };
        else if (typeof value === "string" || $30d620e50417fdeb$var$isUint8Array(value)) options = {
            value: value
        };
        else options = value;
        /* eslint-disable no-unused-expressions */ /**
     * Base of `path` (default: `process.cwd()` or `'/'` in browsers).
     *
     * @type {string}
     */ this.cwd = (0, $34053c0b6595333c$export$97a5aaf482767187).cwd();
        /**
     * Place to store custom info (default: `{}`).
     *
     * It’s OK to store custom data directly on the file but moving it to
     * `data` is recommended.
     *
     * @type {Data}
     */ this.data = {};
        /**
     * List of file paths the file moved between.
     *
     * The first is the original path and the last is the current path.
     *
     * @type {Array<string>}
     */ this.history = [];
        /**
     * List of messages associated with the file.
     *
     * @type {Array<VFileMessage>}
     */ this.messages = [];
        /**
     * Raw value.
     *
     * @type {Value}
     */ this.value;
        // The below are non-standard, they are “well-known”.
        // As in, used in several tools.
        /**
     * Source map.
     *
     * This type is equivalent to the `RawSourceMap` type from the `source-map`
     * module.
     *
     * @type {Map | null | undefined}
     */ this.map;
        /**
     * Custom, non-string, compiled, representation.
     *
     * This is used by unified to store non-string results.
     * One example is when turning markdown into React nodes.
     *
     * @type {unknown}
     */ this.result;
        /**
     * Whether a file was saved to disk.
     *
     * This is used by vfile reporters.
     *
     * @type {boolean}
     */ this.stored;
        /* eslint-enable no-unused-expressions */ // Set path related properties in the correct order.
        let index = -1;
        while(++index < $30d620e50417fdeb$var$order.length){
            const prop = $30d620e50417fdeb$var$order[index];
            // Note: we specifically use `in` instead of `hasOwnProperty` to accept
            // `vfile`s too.
            if (prop in options && options[prop] !== undefined && options[prop] !== null) // @ts-expect-error: TS doesn’t understand basic reality.
            this[prop] = prop === "history" ? [
                ...options[prop]
            ] : options[prop];
        }
        /** @type {string} */ let prop;
        // Set non-path related properties.
        for(prop in options)// @ts-expect-error: fine to set other things.
        if (!$30d620e50417fdeb$var$order.includes(prop)) // @ts-expect-error: fine to set other things.
        this[prop] = options[prop];
    }
    /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */ get basename() {
        return typeof this.path === "string" ? (0, $953807132fc69013$export$bb654e07daaf8c3a).basename(this.path) : undefined;
    }
    /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */ set basename(basename) {
        $30d620e50417fdeb$var$assertNonEmpty(basename, "basename");
        $30d620e50417fdeb$var$assertPart(basename, "basename");
        this.path = (0, $953807132fc69013$export$bb654e07daaf8c3a).join(this.dirname || "", basename);
    }
    /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */ get dirname() {
        return typeof this.path === "string" ? (0, $953807132fc69013$export$bb654e07daaf8c3a).dirname(this.path) : undefined;
    }
    /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */ set dirname(dirname) {
        $30d620e50417fdeb$var$assertPath(this.basename, "dirname");
        this.path = (0, $953807132fc69013$export$bb654e07daaf8c3a).join(dirname || "", this.basename);
    }
    /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */ get extname() {
        return typeof this.path === "string" ? (0, $953807132fc69013$export$bb654e07daaf8c3a).extname(this.path) : undefined;
    }
    /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */ set extname(extname) {
        $30d620e50417fdeb$var$assertPart(extname, "extname");
        $30d620e50417fdeb$var$assertPath(this.dirname, "extname");
        if (extname) {
            if (extname.codePointAt(0) !== 46 /* `.` */ ) throw new Error("`extname` must start with `.`");
            if (extname.includes(".", 1)) throw new Error("`extname` cannot contain multiple dots");
        }
        this.path = (0, $953807132fc69013$export$bb654e07daaf8c3a).join(this.dirname, this.stem + (extname || ""));
    }
    /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */ get path() {
        return this.history[this.history.length - 1];
    }
    /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */ set path(path) {
        if ((0, $7305c14dc01738f5$export$8304a22d431f958)(path)) path = (0, $4c40bb55539458e0$export$9b2b676c902de799)(path);
        $30d620e50417fdeb$var$assertNonEmpty(path, "path");
        if (this.path !== path) this.history.push(path);
    }
    /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */ get stem() {
        return typeof this.path === "string" ? (0, $953807132fc69013$export$bb654e07daaf8c3a).basename(this.path, this.extname) : undefined;
    }
    /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */ set stem(stem) {
        $30d620e50417fdeb$var$assertNonEmpty(stem, "stem");
        $30d620e50417fdeb$var$assertPart(stem, "stem");
        this.path = (0, $953807132fc69013$export$bb654e07daaf8c3a).join(this.dirname || "", stem + (this.extname || ""));
    }
    // Normal prototypal methods.
    /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */ fail(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = true;
        throw message;
    }
    /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ info(causeOrReason, optionsOrParentOrPlace, origin) {
        // @ts-expect-error: the overloads are fine.
        const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
        message.fatal = undefined;
        return message;
    }
    /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */ message(causeOrReason, optionsOrParentOrPlace, origin) {
        const message = new (0, $1069c7510fec44f3$export$752e5c445fe834ef)(// @ts-expect-error: the overloads are fine.
        causeOrReason, optionsOrParentOrPlace, origin);
        if (this.path) {
            message.name = this.path + ":" + message.name;
            message.file = this.path;
        }
        message.fatal = false;
        this.messages.push(message);
        return message;
    }
    /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */ toString(encoding) {
        if (this.value === undefined) return "";
        if (typeof this.value === "string") return this.value;
        const decoder = new TextDecoder(encoding || undefined);
        return decoder.decode(this.value);
    }
}
/**
 * Assert that `part` is not a path (as in, does not contain `path.sep`).
 *
 * @param {string | null | undefined} part
 *   File path part.
 * @param {string} name
 *   Part name.
 * @returns {undefined}
 *   Nothing.
 */ function $30d620e50417fdeb$var$assertPart(part, name) {
    if (part && part.includes((0, $953807132fc69013$export$bb654e07daaf8c3a).sep)) throw new Error("`" + name + "` cannot be a path: did not expect `" + (0, $953807132fc69013$export$bb654e07daaf8c3a).sep + "`");
}
/**
 * Assert that `part` is not empty.
 *
 * @param {string | undefined} part
 *   Thing.
 * @param {string} name
 *   Part name.
 * @returns {asserts part is string}
 *   Nothing.
 */ function $30d620e50417fdeb$var$assertNonEmpty(part, name) {
    if (!part) throw new Error("`" + name + "` cannot be empty");
}
/**
 * Assert `path` exists.
 *
 * @param {string | undefined} path
 *   Path.
 * @param {string} name
 *   Dependency name.
 * @returns {asserts path is string}
 *   Nothing.
 */ function $30d620e50417fdeb$var$assertPath(path, name) {
    if (!path) throw new Error("Setting `" + name + "` requires `path` to be set too");
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $30d620e50417fdeb$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}


const $5df72a9bba62379e$export$b7de1db558410812 = /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */ /** @type {unknown} */ /**
       * @this {Function}
       * @param {string | symbol} property
       * @returns {(...parameters: Array<unknown>) => unknown}
       */ function(property) {
    const self = this;
    const constr = self.constructor;
    const proto = /** @type {Record<string | symbol, Function>} */ // Prototypes do exist.
    // type-coverage:ignore-next-line
    constr.prototype;
    const func = proto[property];
    /** @type {(...parameters: Array<unknown>) => unknown} */ const apply = function() {
        return func.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    const names = Object.getOwnPropertyNames(func);
    for (const p of names){
        const descriptor = Object.getOwnPropertyDescriptor(func, p);
        if (descriptor) Object.defineProperty(apply, p, descriptor);
    }
    return apply;
};


// To do: next major: drop `Compiler`, `Parser`: prefer lowercase.
// To do: we could start yielding `never` in TS when a parser is missing and
// `parse` is called.
// Currently, we allow directly setting `processor.parser`, which is untyped.
const $41a75c822756697f$var$own = {}.hasOwnProperty;
class $41a75c822756697f$export$c30cd198d731db19 extends (0, $5df72a9bba62379e$export$b7de1db558410812) {
    /**
   * Create a processor.
   */ constructor(){
        // If `Processor()` is called (w/o new), `copy` is called instead.
        super("copy");
        /**
     * Compiler to use (deprecated).
     *
     * @deprecated
     *   Use `compiler` instead.
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.Compiler = undefined;
        /**
     * Parser to use (deprecated).
     *
     * @deprecated
     *   Use `parser` instead.
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.Parser = undefined;
        // Note: the following fields are considered private.
        // However, they are needed for tests, and TSC generates an untyped
        // `private freezeIndex` field for, which trips `type-coverage` up.
        // Instead, we use `@deprecated` to visualize that they shouldn’t be used.
        /**
     * Internal list of configured plugins.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Array<PluginTuple<Array<unknown>>>}
     */ this.attachers = [];
        /**
     * Compiler to use.
     *
     * @type {(
     *   Compiler<
     *     CompileTree extends undefined ? Node : CompileTree,
     *     CompileResult extends undefined ? CompileResults : CompileResult
     *   > |
     *   undefined
     * )}
     */ this.compiler = undefined;
        /**
     * Internal state to track where we are while freezing.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {number}
     */ this.freezeIndex = -1;
        /**
     * Internal state to track whether we’re frozen.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {boolean | undefined}
     */ this.frozen = undefined;
        /**
     * Internal state.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Data}
     */ this.namespace = {};
        /**
     * Parser to use.
     *
     * @type {(
     *   Parser<ParseTree extends undefined ? Node : ParseTree> |
     *   undefined
     * )}
     */ this.parser = undefined;
        /**
     * Internal list of configured transformers.
     *
     * @deprecated
     *   This is a private internal property and should not be used.
     * @type {Pipeline}
     */ this.transformers = (0, $9993211b3837d06d$export$91b56f5ca106aa43)();
    }
    /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@link Processor `Processor`}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */ copy() {
        // Cast as the type parameters will be the same after attaching.
        const destination = /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */ new $41a75c822756697f$export$c30cd198d731db19();
        let index = -1;
        while(++index < this.attachers.length){
            const attacher = this.attachers[index];
            destination.use(...attacher);
        }
        destination.data((0, (/*@__PURE__*/$parcel$interopDefault($3546b8beef561689$exports)))(true, {}, this.namespace));
        return destination;
    }
    /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > 👉 **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > 👉 **Note**: to register custom data in TypeScript, augment the
   * > {@link Data `Data`} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */ data(key, value) {
        if (typeof key === "string") {
            // Set `key`.
            if (arguments.length === 2) {
                $41a75c822756697f$var$assertUnfrozen("data", this.frozen);
                this.namespace[key] = value;
                return this;
            }
            // Get `key`.
            return $41a75c822756697f$var$own.call(this.namespace, key) && this.namespace[key] || undefined;
        }
        // Set space.
        if (key) {
            $41a75c822756697f$var$assertUnfrozen("data", this.frozen);
            this.namespace = key;
            return this;
        }
        // Get space.
        return this.namespace;
    }
    /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */ freeze() {
        if (this.frozen) return this;
        // Cast so that we can type plugins easier.
        // Plugins are supposed to be usable on different processors, not just on
        // this exact processor.
        const self = /** @type {Processor} */ /** @type {unknown} */ this;
        while(++this.freezeIndex < this.attachers.length){
            const [attacher, ...options] = this.attachers[this.freezeIndex];
            if (options[0] === false) continue;
            if (options[0] === true) options[0] = undefined;
            const transformer = attacher.call(self, ...options);
            if (typeof transformer === "function") this.transformers.use(transformer);
        }
        this.frozen = true;
        this.freezeIndex = Number.POSITIVE_INFINITY;
        return this;
    }
    /**
   * Parse text to a syntax tree.
   *
   * > 👉 **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */ parse(file) {
        this.freeze();
        const realFile = $41a75c822756697f$var$vfile(file);
        const parser = this.parser || this.Parser;
        $41a75c822756697f$var$assertParser("parse", parser);
        return parser(String(realFile), realFile);
    }
    /**
   * Process the given file as configured on the processor.
   *
   * > 👉 **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ process(file, done) {
        const self = this;
        this.freeze();
        $41a75c822756697f$var$assertParser("process", this.parser || this.Parser);
        $41a75c822756697f$var$assertCompiler("process", this.compiler || this.Compiler);
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {((file: VFileWithOutput<CompileResult>) => undefined | void) | undefined} resolve
     * @param {(error: Error | undefined) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            const realFile = $41a75c822756697f$var$vfile(file);
            // Assume `ParseTree` (the result of the parser) matches `HeadTree` (the
            // input of the first transform).
            const parseTree = /** @type {HeadTree extends undefined ? Node : HeadTree} */ /** @type {unknown} */ self.parse(realFile);
            self.run(parseTree, realFile, function(error, tree, file) {
                if (error || !tree || !file) return realDone(error);
                // Assume `TailTree` (the output of the last transform) matches
                // `CompileTree` (the input of the compiler).
                const compileTree = /** @type {CompileTree extends undefined ? Node : CompileTree} */ /** @type {unknown} */ tree;
                const compileResult = self.stringify(compileTree, file);
                if ($41a75c822756697f$var$looksLikeAValue(compileResult)) file.value = compileResult;
                else file.result = compileResult;
                realDone(error, /** @type {VFileWithOutput<CompileResult>} */ file);
            });
            /**
       * @param {Error | undefined} error
       * @param {VFileWithOutput<CompileResult> | undefined} [file]
       * @returns {undefined}
       */ function realDone(error, file) {
                if (error || !file) reject(error);
                else if (resolve) resolve(file);
                else {
                    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, file);
                }
            }
        }
    }
    /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ processSync(file) {
        /** @type {boolean} */ let complete = false;
        /** @type {VFileWithOutput<CompileResult> | undefined} */ let result;
        this.freeze();
        $41a75c822756697f$var$assertParser("processSync", this.parser || this.Parser);
        $41a75c822756697f$var$assertCompiler("processSync", this.compiler || this.Compiler);
        this.process(file, realDone);
        $41a75c822756697f$var$assertDone("processSync", "process", complete);
        (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {ProcessCallback<VFileWithOutput<CompileResult>>}
     */ function realDone(error, file) {
            complete = true;
            (0, $864220ba46ea3463$export$dd911e13ecb11e05)(error);
            result = file;
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * > 👉 **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */ run(tree, file, done) {
        $41a75c822756697f$var$assertNode(tree);
        this.freeze();
        const transformers = this.transformers;
        if (!done && typeof file === "function") {
            done = file;
            file = undefined;
        }
        return done ? executor(undefined, done) : new Promise(executor);
        // Note: `void`s needed for TS.
        /**
     * @param {(
     *   ((tree: TailTree extends undefined ? Node : TailTree) => undefined | void) |
     *   undefined
     * )} resolve
     * @param {(error: Error) => undefined | void} reject
     * @returns {undefined}
     */ function executor(resolve, reject) {
            (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(typeof file !== "function", "`file` can’t be a `done` anymore, we checked");
            const realFile = $41a75c822756697f$var$vfile(file);
            transformers.run(tree, realFile, realDone);
            /**
       * @param {Error | undefined} error
       * @param {Node} outputTree
       * @param {VFile} file
       * @returns {undefined}
       */ function realDone(error, outputTree, file) {
                const resultingTree = /** @type {TailTree extends undefined ? Node : TailTree} */ outputTree || tree;
                if (error) reject(error);
                else if (resolve) resolve(resultingTree);
                else {
                    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(done, "`done` is defined if `resolve` is not");
                    done(undefined, resultingTree, file);
                }
            }
        }
    }
    /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > 👉 **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */ runSync(tree, file) {
        /** @type {boolean} */ let complete = false;
        /** @type {(TailTree extends undefined ? Node : TailTree) | undefined} */ let result;
        this.run(tree, file, realDone);
        $41a75c822756697f$var$assertDone("runSync", "run", complete);
        (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(result, "we either bailed on an error or have a tree");
        return result;
        /**
     * @type {RunCallback<TailTree extends undefined ? Node : TailTree>}
     */ function realDone(error, tree) {
            (0, $864220ba46ea3463$export$dd911e13ecb11e05)(error);
            result = tree;
            complete = true;
        }
    }
    /**
   * Compile a syntax tree.
   *
   * > 👉 **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > 👉 **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > 👉 **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@link CompileResultMap `CompileResultMap`}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */ stringify(tree, file) {
        this.freeze();
        const realFile = $41a75c822756697f$var$vfile(file);
        const compiler = this.compiler || this.Compiler;
        $41a75c822756697f$var$assertCompiler("stringify", compiler);
        $41a75c822756697f$var$assertNode(tree);
        return compiler(tree, realFile);
    }
    /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > 👉 **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */ use(value, ...parameters) {
        const attachers = this.attachers;
        const namespace = this.namespace;
        $41a75c822756697f$var$assertUnfrozen("use", this.frozen);
        if (value === null || value === undefined) ;
        else if (typeof value === "function") addPlugin(value, parameters);
        else if (typeof value === "object") {
            if (Array.isArray(value)) addList(value);
            else addPreset(value);
        } else throw new TypeError("Expected usable value, not `" + value + "`");
        return this;
        /**
     * @param {Pluggable} value
     * @returns {undefined}
     */ function add(value) {
            if (typeof value === "function") addPlugin(value, []);
            else if (typeof value === "object") {
                if (Array.isArray(value)) {
                    const [plugin, ...parameters] = /** @type {PluginTuple<Array<unknown>>} */ value;
                    addPlugin(plugin, parameters);
                } else addPreset(value);
            } else throw new TypeError("Expected usable value, not `" + value + "`");
        }
        /**
     * @param {Preset} result
     * @returns {undefined}
     */ function addPreset(result) {
            if (!("plugins" in result) && !("settings" in result)) throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");
            addList(result.plugins);
            if (result.settings) namespace.settings = (0, (/*@__PURE__*/$parcel$interopDefault($3546b8beef561689$exports)))(true, namespace.settings, result.settings);
        }
        /**
     * @param {PluggableList | null | undefined} plugins
     * @returns {undefined}
     */ function addList(plugins) {
            let index = -1;
            if (plugins === null || plugins === undefined) ;
            else if (Array.isArray(plugins)) while(++index < plugins.length){
                const thing = plugins[index];
                add(thing);
            }
            else throw new TypeError("Expected a list of plugins, not `" + plugins + "`");
        }
        /**
     * @param {Plugin} plugin
     * @param {Array<unknown>} parameters
     * @returns {undefined}
     */ function addPlugin(plugin, parameters) {
            let index = -1;
            let entryIndex = -1;
            while(++index < attachers.length)if (attachers[index][0] === plugin) {
                entryIndex = index;
                break;
            }
            if (entryIndex === -1) attachers.push([
                plugin,
                ...parameters
            ]);
            else if (parameters.length > 0) {
                let [primary, ...rest] = parameters;
                const currentPrimary = attachers[entryIndex][1];
                if ((0, $72a1e67b51df2d6f$export$2e2bcd8739ae039)(currentPrimary) && (0, $72a1e67b51df2d6f$export$2e2bcd8739ae039)(primary)) primary = (0, (/*@__PURE__*/$parcel$interopDefault($3546b8beef561689$exports)))(true, currentPrimary, primary);
                attachers[entryIndex] = [
                    plugin,
                    primary,
                    ...rest
                ];
            }
        }
    }
}
const $41a75c822756697f$export$7cc1b2fe10c52bb = new $41a75c822756697f$export$c30cd198d731db19().freeze();
/**
 * Assert a parser is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Parser}
 */ function $41a75c822756697f$var$assertParser(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `parser`");
}
/**
 * Assert a compiler is available.
 *
 * @param {string} name
 * @param {unknown} value
 * @returns {asserts value is Compiler}
 */ function $41a75c822756697f$var$assertCompiler(name, value) {
    if (typeof value !== "function") throw new TypeError("Cannot `" + name + "` without `compiler`");
}
/**
 * Assert the processor is not frozen.
 *
 * @param {string} name
 * @param {unknown} frozen
 * @returns {asserts frozen is false}
 */ function $41a75c822756697f$var$assertUnfrozen(name, frozen) {
    if (frozen) throw new Error("Cannot call `" + name + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.");
}
/**
 * Assert `node` is a unist node.
 *
 * @param {unknown} node
 * @returns {asserts node is Node}
 */ function $41a75c822756697f$var$assertNode(node) {
    // `isPlainObj` unfortunately uses `any` instead of `unknown`.
    // type-coverage:ignore-next-line
    if (!(0, $72a1e67b51df2d6f$export$2e2bcd8739ae039)(node) || typeof node.type !== "string") throw new TypeError("Expected node, got `" + node + "`");
}
/**
 * Assert that `complete` is `true`.
 *
 * @param {string} name
 * @param {string} asyncName
 * @param {unknown} complete
 * @returns {asserts complete is true}
 */ function $41a75c822756697f$var$assertDone(name, asyncName, complete) {
    if (!complete) throw new Error("`" + name + "` finished async. Use `" + asyncName + "` instead");
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {VFile}
 */ function $41a75c822756697f$var$vfile(value) {
    return $41a75c822756697f$var$looksLikeAVFile(value) ? value : new (0, $30d620e50417fdeb$export$93dff69eb10dc7ce)(value);
}
/**
 * @param {Compatible | undefined} [value]
 * @returns {value is VFile}
 */ function $41a75c822756697f$var$looksLikeAVFile(value) {
    return Boolean(value && typeof value === "object" && "message" in value && "messages" in value);
}
/**
 * @param {unknown} [value]
 * @returns {value is Value}
 */ function $41a75c822756697f$var$looksLikeAValue(value) {
    return typeof value === "string" || $41a75c822756697f$var$isUint8Array(value);
}
/**
 * Assert `value` is an `Uint8Array`.
 *
 * @param {unknown} value
 *   thing.
 * @returns {value is Uint8Array}
 *   Whether `value` is an `Uint8Array`.
 */ function $41a75c822756697f$var$isUint8Array(value) {
    return Boolean(value && typeof value === "object" && "byteLength" in value && "byteOffset" in value);
}




const $f9e23f615f360611$var$own = {}.hasOwnProperty;
const $f9e23f615f360611$var$changelog = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md";
/** @type {PluggableList} */ const $f9e23f615f360611$var$emptyPlugins = [];
/** @type {Readonly<RemarkRehypeOptions>} */ const $f9e23f615f360611$var$emptyRemarkRehypeOptions = {
    allowDangerousHtml: true
};
const $f9e23f615f360611$var$safeProtocol = /^(https?|ircs?|mailto|xmpp)$/i;
// Mutable because we `delete` any time it’s used and a message is sent.
/** @type {ReadonlyArray<Readonly<Deprecation>>} */ const $f9e23f615f360611$var$deprecations = [
    {
        from: "astPlugins",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowDangerousHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "allowNode",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowElement"
    },
    {
        from: "allowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "allowedElements"
    },
    {
        from: "disallowedTypes",
        id: "replace-allownode-allowedtypes-and-disallowedtypes",
        to: "disallowedElements"
    },
    {
        from: "escapeHtml",
        id: "remove-buggy-html-in-markdown-parser"
    },
    {
        from: "includeElementIndex",
        id: "#remove-includeelementindex"
    },
    {
        from: "includeNodeIndex",
        id: "change-includenodeindex-to-includeelementindex"
    },
    {
        from: "linkTarget",
        id: "remove-linktarget"
    },
    {
        from: "plugins",
        id: "change-plugins-to-remarkplugins",
        to: "remarkPlugins"
    },
    {
        from: "rawSourcePos",
        id: "#remove-rawsourcepos"
    },
    {
        from: "renderers",
        id: "change-renderers-to-components",
        to: "components"
    },
    {
        from: "source",
        id: "change-source-to-children",
        to: "children"
    },
    {
        from: "sourcePos",
        id: "#remove-sourcepos"
    },
    {
        from: "transformImageUri",
        id: "#add-urltransform",
        to: "urlTransform"
    },
    {
        from: "transformLinkUri",
        id: "#add-urltransform",
        to: "urlTransform"
    }
];
function $f9e23f615f360611$export$7460c8b7e4ce9582(options) {
    const allowedElements = options.allowedElements;
    const allowElement = options.allowElement;
    const children = options.children || "";
    const className = options.className;
    const components = options.components;
    const disallowedElements = options.disallowedElements;
    const rehypePlugins = options.rehypePlugins || $f9e23f615f360611$var$emptyPlugins;
    const remarkPlugins = options.remarkPlugins || $f9e23f615f360611$var$emptyPlugins;
    const remarkRehypeOptions = options.remarkRehypeOptions ? {
        ...options.remarkRehypeOptions,
        ...$f9e23f615f360611$var$emptyRemarkRehypeOptions
    } : $f9e23f615f360611$var$emptyRemarkRehypeOptions;
    const skipHtml = options.skipHtml;
    const unwrapDisallowed = options.unwrapDisallowed;
    const urlTransform = options.urlTransform || $f9e23f615f360611$export$ca5e94754123e2f3;
    const processor = (0, $41a75c822756697f$export$7cc1b2fe10c52bb)().use((0, $73a0c1dba4c2bce4$export$2e2bcd8739ae039)).use(remarkPlugins).use((0, $17f743cea1135a51$export$2e2bcd8739ae039), remarkRehypeOptions).use(rehypePlugins);
    const file = new (0, $30d620e50417fdeb$export$93dff69eb10dc7ce)();
    if (typeof children === "string") file.value = children;
    else (0, $5d95e0aa9a039766$export$565e9d9bd6b6e0d4)("Unexpected value `" + children + "` for `children` prop, expected `string`");
    if (allowedElements && disallowedElements) (0, $5d95e0aa9a039766$export$565e9d9bd6b6e0d4)("Unexpected combined `allowedElements` and `disallowedElements`, expected one or the other");
    for (const deprecation of $f9e23f615f360611$var$deprecations)if (Object.hasOwn(options, deprecation.from)) (0, $5d95e0aa9a039766$export$565e9d9bd6b6e0d4)("Unexpected `" + deprecation.from + "` prop, " + (deprecation.to ? "use `" + deprecation.to + "` instead" : "remove it") + " (see <" + $f9e23f615f360611$var$changelog + "#" + deprecation.id + "> for more info)");
    const mdastTree = processor.parse(file);
    /** @type {Nodes} */ let hastTree = processor.runSync(mdastTree, file);
    // Wrap in `div` if there’s a class name.
    if (className) hastTree = {
        type: "element",
        tagName: "div",
        properties: {
            className: className
        },
        // Assume no doctypes.
        children: /** @type {Array<ElementContent>} */ hastTree.type === "root" ? hastTree.children : [
            hastTree
        ]
    };
    (0, $425a1aa39753930c$export$bf638b60ea8b89b7)(hastTree, transform);
    return (0, $7e7a0df6c3ed41a4$export$59c10052b2dee561)(hastTree, {
        Fragment: $9zeGj.Fragment,
        components: components,
        ignoreInvalidStyle: true,
        jsx: $9zeGj.jsx,
        jsxs: $9zeGj.jsxs,
        passKeys: true,
        passNode: true
    });
    /** @type {Visitor} */ function transform(node, index, parent) {
        if (node.type === "raw" && parent && typeof index === "number") {
            if (skipHtml) parent.children.splice(index, 1);
            else parent.children[index] = {
                type: "text",
                value: node.value
            };
            return index;
        }
        if (node.type === "element") {
            /** @type {string} */ let key;
            for(key in 0, $653782b3457a4366$export$de3e062aedff083a)if ($f9e23f615f360611$var$own.call((0, $653782b3457a4366$export$de3e062aedff083a), key) && $f9e23f615f360611$var$own.call(node.properties, key)) {
                const value = node.properties[key];
                const test = (0, $653782b3457a4366$export$de3e062aedff083a)[key];
                if (test === null || test.includes(node.tagName)) node.properties[key] = urlTransform(String(value || ""), key, node);
            }
        }
        if (node.type === "element") {
            let remove = allowedElements ? !allowedElements.includes(node.tagName) : disallowedElements ? disallowedElements.includes(node.tagName) : false;
            if (!remove && allowElement && typeof index === "number") remove = !allowElement(node, index, parent);
            if (remove && parent && typeof index === "number") {
                if (unwrapDisallowed && node.children) parent.children.splice(index, 1, ...node.children);
                else parent.children.splice(index, 1);
                return index;
            }
        }
    }
}
function $f9e23f615f360611$export$ca5e94754123e2f3(value) {
    return (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(value, $f9e23f615f360611$var$safeProtocol);
}


/// <reference types="remark-parse" />
/// <reference types="remark-stringify" />
/**
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast-util-gfm').Options} MdastOptions
 * @typedef {import('micromark-extension-gfm').Options} MicromarkOptions
 * @typedef {import('unified').Processor<Root>} Processor
 */ /**
 * @typedef {MicromarkOptions & MdastOptions} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * @typedef {import('mdast-util-gfm-table').Options} Options
 *   Configuration.
 */ /**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-from-markdown').Transform} FromMarkdownTransform
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 *
 * @typedef {import('mdast-util-find-and-replace').RegExpMatchObject} RegExpMatchObject
 * @typedef {import('mdast-util-find-and-replace').ReplaceFunction} ReplaceFunction
 */ /**
 * Count how often a character (or substring) is used in a string.
 *
 * @param {string} value
 *   Value to search in.
 * @param {string} character
 *   Character (or substring) to look for.
 * @return {number}
 *   Number of times `character` occurred in `value`.
 */ function $4acc8705bfd6f83b$export$fa42eaa97a352e23(value, character) {
    const source = String(value);
    if (typeof character !== "string") throw new TypeError("Expected character");
    let count = 0;
    let index = source.indexOf(character);
    while(index !== -1){
        count++;
        index = source.indexOf(character, index + character.length);
    }
    return count;
}




/**
 * @typedef {import('mdast').Nodes} Nodes
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 * @typedef {import('mdast').Root} Root
 * @typedef {import('mdast').Text} Text
 * @typedef {import('unist-util-visit-parents').Test} Test
 * @typedef {import('unist-util-visit-parents').VisitorResult} VisitorResult
 */ /**
 * @typedef RegExpMatchObject
 *   Info on the match.
 * @property {number} index
 *   The index of the search at which the result was found.
 * @property {string} input
 *   A copy of the search string in the text node.
 * @property {[...Array<Parents>, Text]} stack
 *   All ancestors of the text node, where the last node is the text itself.
 *
 * @typedef {RegExp | string} Find
 *   Pattern to find.
 *
 *   Strings are escaped and then turned into global expressions.
 *
 * @typedef {Array<FindAndReplaceTuple>} FindAndReplaceList
 *   Several find and replaces, in array form.
 *
 * @typedef {[Find, Replace?]} FindAndReplaceTuple
 *   Find and replace in tuple form.
 *
 * @typedef {ReplaceFunction | string | null | undefined} Replace
 *   Thing to replace with.
 *
 * @callback ReplaceFunction
 *   Callback called when a search matches.
 * @param {...any} parameters
 *   The parameters are the result of corresponding search expression:
 *
 *   * `value` (`string`) — whole match
 *   * `...capture` (`Array<string>`) — matches from regex capture groups
 *   * `match` (`RegExpMatchObject`) — info on the match
 * @returns {Array<PhrasingContent> | PhrasingContent | string | false | null | undefined}
 *   Thing to replace with.
 *
 *   * when `null`, `undefined`, `''`, remove the match
 *   * …or when `false`, do not replace at all
 *   * …or when `string`, replace with a text node of that value
 *   * …or when `Node` or `Array<Node>`, replace with those nodes
 *
 * @typedef {[RegExp, ReplaceFunction]} Pair
 *   Normalized find and replace.
 *
 * @typedef {Array<Pair>} Pairs
 *   All find and replaced.
 *
 * @typedef Options
 *   Configuration.
 * @property {Test | null | undefined} [ignore]
 *   Test for which nodes to ignore (optional).
 */ function $367ebb339b1a96aa$export$2e2bcd8739ae039(string) {
    if (typeof string !== "string") throw new TypeError("Expected a string");
    // Escape characters with special meaning either inside or outside character sets.
    // Use a simple backslash escape when it’s always valid, and a `\xnn` escape when the simpler form would be disallowed by Unicode patterns’ stricter grammar.
    return string.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}




function $ecbc9e396fd6e8ab$export$fb306ebf003fc574(tree, list, options) {
    const settings = options || {};
    const ignored = (0, $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9)(settings.ignore || []);
    const pairs = $ecbc9e396fd6e8ab$var$toPairs(list);
    let pairIndex = -1;
    while(++pairIndex < pairs.length)(0, $fa87f0c78841621d$export$70008a21eb6de899)(tree, "text", visitor);
    /** @type {import('unist-util-visit-parents').BuildVisitor<Root, 'text'>} */ function visitor(node, parents) {
        let index = -1;
        /** @type {Parents | undefined} */ let grandparent;
        while(++index < parents.length){
            const parent = parents[index];
            /** @type {Array<Nodes> | undefined} */ const siblings = grandparent ? grandparent.children : undefined;
            if (ignored(parent, siblings ? siblings.indexOf(parent) : undefined, grandparent)) return;
            grandparent = parent;
        }
        if (grandparent) return handler(node, parents);
    }
    /**
   * Handle a text node which is not in an ignored parent.
   *
   * @param {Text} node
   *   Text node.
   * @param {Array<Parents>} parents
   *   Parents.
   * @returns {VisitorResult}
   *   Result.
   */ function handler(node, parents) {
        const parent = parents[parents.length - 1];
        const find = pairs[pairIndex][0];
        const replace = pairs[pairIndex][1];
        let start = 0;
        /** @type {Array<Nodes>} */ const siblings = parent.children;
        const index = siblings.indexOf(node);
        let change = false;
        /** @type {Array<PhrasingContent>} */ let nodes = [];
        find.lastIndex = 0;
        let match = find.exec(node.value);
        while(match){
            const position = match.index;
            /** @type {RegExpMatchObject} */ const matchObject = {
                index: match.index,
                input: match.input,
                stack: [
                    ...parents,
                    node
                ]
            };
            let value = replace(...match, matchObject);
            if (typeof value === "string") value = value.length > 0 ? {
                type: "text",
                value: value
            } : undefined;
            // It wasn’t a match after all.
            if (value === false) // False acts as if there was no match.
            // So we need to reset `lastIndex`, which currently being at the end of
            // the current match, to the beginning.
            find.lastIndex = position + 1;
            else {
                if (start !== position) nodes.push({
                    type: "text",
                    value: node.value.slice(start, position)
                });
                if (Array.isArray(value)) nodes.push(...value);
                else if (value) nodes.push(value);
                start = position + match[0].length;
                change = true;
            }
            if (!find.global) break;
            match = find.exec(node.value);
        }
        if (change) {
            if (start < node.value.length) nodes.push({
                type: "text",
                value: node.value.slice(start)
            });
            parent.children.splice(index, 1, ...nodes);
        } else nodes = [
            node
        ];
        return index + nodes.length;
    }
}
/**
 * Turn a tuple or a list of tuples into pairs.
 *
 * @param {FindAndReplaceList | FindAndReplaceTuple} tupleOrList
 *   Schema.
 * @returns {Pairs}
 *   Clean pairs.
 */ function $ecbc9e396fd6e8ab$var$toPairs(tupleOrList) {
    /** @type {Pairs} */ const result = [];
    if (!Array.isArray(tupleOrList)) throw new TypeError("Expected find and replace tuple or list of tuples");
    /** @type {FindAndReplaceList} */ // @ts-expect-error: correct.
    const list = !tupleOrList[0] || Array.isArray(tupleOrList[0]) ? tupleOrList : [
        tupleOrList
    ];
    let index = -1;
    while(++index < list.length){
        const tuple = list[index];
        result.push([
            $ecbc9e396fd6e8ab$var$toExpression(tuple[0]),
            $ecbc9e396fd6e8ab$var$toFunction(tuple[1])
        ]);
    }
    return result;
}
/**
 * Turn a find into an expression.
 *
 * @param {Find} find
 *   Find.
 * @returns {RegExp}
 *   Expression.
 */ function $ecbc9e396fd6e8ab$var$toExpression(find) {
    return typeof find === "string" ? new RegExp((0, $367ebb339b1a96aa$export$2e2bcd8739ae039)(find), "g") : find;
}
/**
 * Turn a replace into a function.
 *
 * @param {Replace} replace
 *   Replace.
 * @returns {ReplaceFunction}
 *   Function.
 */ function $ecbc9e396fd6e8ab$var$toFunction(replace) {
    return typeof replace === "function" ? replace : function() {
        return replace;
    };
}


/** @type {ConstructName} */ const $c2445ee9011ee097$var$inConstruct = "phrasing";
/** @type {Array<ConstructName>} */ const $c2445ee9011ee097$var$notInConstruct = [
    "autolink",
    "link",
    "image",
    "label"
];
function $c2445ee9011ee097$export$b6afdfff2163546f() {
    return {
        transforms: [
            $c2445ee9011ee097$var$transformGfmAutolinkLiterals
        ],
        enter: {
            literalAutolink: $c2445ee9011ee097$var$enterLiteralAutolink,
            literalAutolinkEmail: $c2445ee9011ee097$var$enterLiteralAutolinkValue,
            literalAutolinkHttp: $c2445ee9011ee097$var$enterLiteralAutolinkValue,
            literalAutolinkWww: $c2445ee9011ee097$var$enterLiteralAutolinkValue
        },
        exit: {
            literalAutolink: $c2445ee9011ee097$var$exitLiteralAutolink,
            literalAutolinkEmail: $c2445ee9011ee097$var$exitLiteralAutolinkEmail,
            literalAutolinkHttp: $c2445ee9011ee097$var$exitLiteralAutolinkHttp,
            literalAutolinkWww: $c2445ee9011ee097$var$exitLiteralAutolinkWww
        }
    };
}
function $c2445ee9011ee097$export$d3ace9096b01c39d() {
    return {
        unsafe: [
            {
                character: "@",
                before: "[+\\-.\\w]",
                after: "[\\-.\\w]",
                inConstruct: $c2445ee9011ee097$var$inConstruct,
                notInConstruct: $c2445ee9011ee097$var$notInConstruct
            },
            {
                character: ".",
                before: "[Ww]",
                after: "[\\-.\\w]",
                inConstruct: $c2445ee9011ee097$var$inConstruct,
                notInConstruct: $c2445ee9011ee097$var$notInConstruct
            },
            {
                character: ":",
                before: "[ps]",
                after: "\\/",
                inConstruct: $c2445ee9011ee097$var$inConstruct,
                notInConstruct: $c2445ee9011ee097$var$notInConstruct
            }
        ]
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$enterLiteralAutolink(token) {
    this.enter({
        type: "link",
        title: null,
        url: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$enterLiteralAutolinkValue(token) {
    this.config.enter.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$exitLiteralAutolinkHttp(token) {
    this.config.exit.autolinkProtocol.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$exitLiteralAutolinkWww(token) {
    this.config.exit.data.call(this, token);
    const node = this.stack[this.stack.length - 1];
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "link");
    node.url = "http://" + this.sliceSerialize(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$exitLiteralAutolinkEmail(token) {
    this.config.exit.autolinkEmail.call(this, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $c2445ee9011ee097$var$exitLiteralAutolink(token) {
    this.exit(token);
}
/** @type {FromMarkdownTransform} */ function $c2445ee9011ee097$var$transformGfmAutolinkLiterals(tree) {
    (0, $ecbc9e396fd6e8ab$export$fb306ebf003fc574)(tree, [
        [
            /(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi,
            $c2445ee9011ee097$var$findUrl
        ],
        [
            /([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g,
            $c2445ee9011ee097$var$findEmail
        ]
    ], {
        ignore: [
            "link",
            "linkReference"
        ]
    });
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} protocol
 * @param {string} domain
 * @param {string} path
 * @param {RegExpMatchObject} match
 * @returns {Array<PhrasingContent> | Link | false}
 */ // eslint-disable-next-line max-params
function $c2445ee9011ee097$var$findUrl(_, protocol, domain, path, match) {
    let prefix = "";
    // Not an expected previous character.
    if (!$c2445ee9011ee097$var$previous(match)) return false;
    // Treat `www` as part of the domain.
    if (/^w/i.test(protocol)) {
        domain = protocol + domain;
        protocol = "";
        prefix = "http://";
    }
    if (!$c2445ee9011ee097$var$isCorrectDomain(domain)) return false;
    const parts = $c2445ee9011ee097$var$splitUrl(domain + path);
    if (!parts[0]) return false;
    /** @type {Link} */ const result = {
        type: "link",
        title: null,
        url: prefix + protocol + parts[0],
        children: [
            {
                type: "text",
                value: protocol + parts[0]
            }
        ]
    };
    if (parts[1]) return [
        result,
        {
            type: "text",
            value: parts[1]
        }
    ];
    return result;
}
/**
 * @type {ReplaceFunction}
 * @param {string} _
 * @param {string} atext
 * @param {string} label
 * @param {RegExpMatchObject} match
 * @returns {Link | false}
 */ function $c2445ee9011ee097$var$findEmail(_, atext, label, match) {
    if (// Not an expected previous character.
    !$c2445ee9011ee097$var$previous(match, true) || // Label ends in not allowed character.
    /[-\d_]$/.test(label)) return false;
    return {
        type: "link",
        title: null,
        url: "mailto:" + atext + "@" + label,
        children: [
            {
                type: "text",
                value: atext + "@" + label
            }
        ]
    };
}
/**
 * @param {string} domain
 * @returns {boolean}
 */ function $c2445ee9011ee097$var$isCorrectDomain(domain) {
    const parts = domain.split(".");
    if (parts.length < 2 || parts[parts.length - 1] && (/_/.test(parts[parts.length - 1]) || !/[a-zA-Z\d]/.test(parts[parts.length - 1])) || parts[parts.length - 2] && (/_/.test(parts[parts.length - 2]) || !/[a-zA-Z\d]/.test(parts[parts.length - 2]))) return false;
    return true;
}
/**
 * @param {string} url
 * @returns {[string, string | undefined]}
 */ function $c2445ee9011ee097$var$splitUrl(url) {
    const trailExec = /[!"&'),.:;<>?\]}]+$/.exec(url);
    if (!trailExec) return [
        url,
        undefined
    ];
    url = url.slice(0, trailExec.index);
    let trail = trailExec[0];
    let closingParenIndex = trail.indexOf(")");
    const openingParens = (0, $4acc8705bfd6f83b$export$fa42eaa97a352e23)(url, "(");
    let closingParens = (0, $4acc8705bfd6f83b$export$fa42eaa97a352e23)(url, ")");
    while(closingParenIndex !== -1 && openingParens > closingParens){
        url += trail.slice(0, closingParenIndex + 1);
        trail = trail.slice(closingParenIndex + 1);
        closingParenIndex = trail.indexOf(")");
        closingParens++;
    }
    return [
        url,
        trail
    ];
}
/**
 * @param {RegExpMatchObject} match
 * @param {boolean | null | undefined} [email=false]
 * @returns {boolean}
 */ function $c2445ee9011ee097$var$previous(match, email) {
    const code = match.input.charCodeAt(match.index - 1);
    return (match.index === 0 || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code) || (0, $b4c110780d01af5f$export$aa04114dd888a7a0)(code)) && (!email || code !== 47);
}


/**
 * @typedef {import('mdast').FootnoteDefinition} FootnoteDefinition
 * @typedef {import('mdast').FootnoteReference} FootnoteReference
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Map} Map
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ 

$8facc16d76eb4654$var$footnoteReference.peek = $8facc16d76eb4654$var$footnoteReferencePeek;
function $8facc16d76eb4654$export$c9d5ad4bdf6ff801() {
    return {
        enter: {
            gfmFootnoteDefinition: $8facc16d76eb4654$var$enterFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $8facc16d76eb4654$var$enterFootnoteDefinitionLabelString,
            gfmFootnoteCall: $8facc16d76eb4654$var$enterFootnoteCall,
            gfmFootnoteCallString: $8facc16d76eb4654$var$enterFootnoteCallString
        },
        exit: {
            gfmFootnoteDefinition: $8facc16d76eb4654$var$exitFootnoteDefinition,
            gfmFootnoteDefinitionLabelString: $8facc16d76eb4654$var$exitFootnoteDefinitionLabelString,
            gfmFootnoteCall: $8facc16d76eb4654$var$exitFootnoteCall,
            gfmFootnoteCallString: $8facc16d76eb4654$var$exitFootnoteCallString
        }
    };
}
function $8facc16d76eb4654$export$3727766a73a6c09f() {
    return {
        // This is on by default already.
        unsafe: [
            {
                character: "[",
                inConstruct: [
                    "phrasing",
                    "label",
                    "reference"
                ]
            }
        ],
        handlers: {
            footnoteDefinition: $8facc16d76eb4654$var$footnoteDefinition,
            footnoteReference: $8facc16d76eb4654$var$footnoteReference
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$enterFootnoteDefinition(token) {
    this.enter({
        type: "footnoteDefinition",
        identifier: "",
        label: "",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$enterFootnoteDefinitionLabelString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$exitFootnoteDefinitionLabelString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "footnoteDefinition");
    node.label = label;
    node.identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$exitFootnoteDefinition(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$enterFootnoteCall(token) {
    this.enter({
        type: "footnoteReference",
        identifier: "",
        label: ""
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$enterFootnoteCallString() {
    this.buffer();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$exitFootnoteCallString(token) {
    const label = this.resume();
    const node = this.stack[this.stack.length - 1];
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "footnoteReference");
    node.label = label;
    node.identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token)).toLowerCase();
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $8facc16d76eb4654$var$exitFootnoteCall(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteReference} node
 */ function $8facc16d76eb4654$var$footnoteReference(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit = state.enter("footnoteReference");
    const subexit = state.enter("reference");
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    exit();
    value += tracker.move("]");
    return value;
}
/** @type {ToMarkdownHandle} */ function $8facc16d76eb4654$var$footnoteReferencePeek() {
    return "[";
}
/**
 * @type {ToMarkdownHandle}
 * @param {FootnoteDefinition} node
 */ function $8facc16d76eb4654$var$footnoteDefinition(node, _, state, info) {
    const tracker = state.createTracker(info);
    let value = tracker.move("[^");
    const exit = state.enter("footnoteDefinition");
    const subexit = state.enter("label");
    value += tracker.move(state.safe(state.associationId(node), {
        ...tracker.current(),
        before: value,
        after: "]"
    }));
    subexit();
    value += tracker.move("]:" + (node.children && node.children.length > 0 ? " " : ""));
    tracker.shift(4);
    value += tracker.move(state.indentLines(state.containerFlow(node, tracker.current()), $8facc16d76eb4654$var$map));
    exit();
    return value;
}
/** @type {Map} */ function $8facc16d76eb4654$var$map(line, index, blank) {
    if (index === 0) return line;
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Delete} Delete
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').ConstructName} ConstructName
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 */ /**
 * List of constructs that occur in phrasing (paragraphs, headings), but cannot
 * contain strikethrough.
 * So they sort of cancel each other out.
 * Note: could use a better name.
 *
 * Note: keep in sync with: <https://github.com/syntax-tree/mdast-util-to-markdown/blob/8ce8dbf/lib/unsafe.js#L14>
 *
 * @type {Array<ConstructName>}
 */ const $9857e2d2ea54569a$var$constructsWithoutStrikethrough = [
    "autolink",
    "destinationLiteral",
    "destinationRaw",
    "reference",
    "titleQuote",
    "titleApostrophe"
];
$9857e2d2ea54569a$var$handleDelete.peek = $9857e2d2ea54569a$var$peekDelete;
function $9857e2d2ea54569a$export$34d64e709dd0b9bb() {
    return {
        canContainEols: [
            "delete"
        ],
        enter: {
            strikethrough: $9857e2d2ea54569a$var$enterStrikethrough
        },
        exit: {
            strikethrough: $9857e2d2ea54569a$var$exitStrikethrough
        }
    };
}
function $9857e2d2ea54569a$export$1632835bd2c84956() {
    return {
        unsafe: [
            {
                character: "~",
                inConstruct: "phrasing",
                notInConstruct: $9857e2d2ea54569a$var$constructsWithoutStrikethrough
            }
        ],
        handlers: {
            delete: $9857e2d2ea54569a$var$handleDelete
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $9857e2d2ea54569a$var$enterStrikethrough(token) {
    this.enter({
        type: "delete",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $9857e2d2ea54569a$var$exitStrikethrough(token) {
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {Delete} node
 */ function $9857e2d2ea54569a$var$handleDelete(node, _, state, info) {
    const tracker = state.createTracker(info);
    const exit = state.enter("strikethrough");
    let value = tracker.move("~~");
    value += state.containerPhrasing(node, {
        ...tracker.current(),
        before: value,
        after: "~"
    });
    value += tracker.move("~~");
    exit();
    return value;
}
/** @type {ToMarkdownHandle} */ function $9857e2d2ea54569a$var$peekDelete() {
    return "~";
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Table} Table
 * @typedef {import('mdast').TableCell} TableCell
 * @typedef {import('mdast').TableRow} TableRow
 *
 * @typedef {import('markdown-table').Options} MarkdownTableOptions
 *
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 *
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').State} State
 * @typedef {import('mdast-util-to-markdown').Info} Info
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {boolean | null | undefined} [tableCellPadding=true]
 *   Whether to add a space of padding between delimiters and cells (default:
 *   `true`).
 * @property {boolean | null | undefined} [tablePipeAlign=true]
 *   Whether to align the delimiters (default: `true`).
 * @property {MarkdownTableOptions['stringLength'] | null | undefined} [stringLength]
 *   Function to detect the length of table cell content, used when aligning
 *   the delimiters between cells (optional).
 */ 
/**
 * @typedef Options
 *   Configuration (optional).
 * @property {string|null|Array<string|null|undefined>} [align]
 *   One style for all columns, or styles for their respective columns.
 *   Each style is either `'l'` (left), `'r'` (right), or `'c'` (center).
 *   Other values are treated as `''`, which doesn’t place the colon in the
 *   alignment row but does align left.
 *   *Only the lowercased first character is used, so `Right` is fine.*
 * @property {boolean} [padding=true]
 *   Whether to add a space of padding between delimiters and cells.
 *
 *   When `true`, there is padding:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there is no padding:
 *
 *   ```markdown
 *   |Alpha|B    |
 *   |-----|-----|
 *   |C    |Delta|
 *   ```
 * @property {boolean} [delimiterStart=true]
 *   Whether to begin each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are starting delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no starting delimiters:
 *
 *   ```markdown
 *   Alpha | B     |
 *   ----- | ----- |
 *   C     | Delta |
 *   ```
 * @property {boolean} [delimiterEnd=true]
 *   Whether to end each row with the delimiter.
 *
 *   > 👉 **Note**: please don’t use this: it could create fragile structures
 *   > that aren’t understandable to some markdown parsers.
 *
 *   When `true`, there are ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   When `false`, there are no ending delimiters:
 *
 *   ```markdown
 *   | Alpha | B
 *   | ----- | -----
 *   | C     | Delta
 *   ```
 * @property {boolean} [alignDelimiters=true]
 *   Whether to align the delimiters.
 *   By default, they are aligned:
 *
 *   ```markdown
 *   | Alpha | B     |
 *   | ----- | ----- |
 *   | C     | Delta |
 *   ```
 *
 *   Pass `false` to make them staggered:
 *
 *   ```markdown
 *   | Alpha | B |
 *   | - | - |
 *   | C | Delta |
 *   ```
 * @property {(value: string) => number} [stringLength]
 *   Function to detect the length of table cell content.
 *   This is used when aligning the delimiters (`|`) between table cells.
 *   Full-width characters and emoji mess up delimiter alignment when viewing
 *   the markdown source.
 *   To fix this, you can pass this function, which receives the cell content
 *   and returns its “visible” size.
 *   Note that what is and isn’t visible depends on where the text is displayed.
 *
 *   Without such a function, the following:
 *
 *   ```js
 *   markdownTable([
 *     ['Alpha', 'Bravo'],
 *     ['中文', 'Charlie'],
 *     ['👩‍❤️‍👩', 'Delta']
 *   ])
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo |
 *   | - | - |
 *   | 中文 | Charlie |
 *   | 👩‍❤️‍👩 | Delta |
 *   ```
 *
 *   With [`string-width`](https://github.com/sindresorhus/string-width):
 *
 *   ```js
 *   import stringWidth from 'string-width'
 *
 *   markdownTable(
 *     [
 *       ['Alpha', 'Bravo'],
 *       ['中文', 'Charlie'],
 *       ['👩‍❤️‍👩', 'Delta']
 *     ],
 *     {stringLength: stringWidth}
 *   )
 *   ```
 *
 *   Yields:
 *
 *   ```markdown
 *   | Alpha | Bravo   |
 *   | ----- | ------- |
 *   | 中文  | Charlie |
 *   | 👩‍❤️‍👩    | Delta   |
 *   ```
 */ /**
 * @typedef {Options} MarkdownTableOptions
 * @todo
 *   Remove next major.
 */ /**
 * Generate a markdown ([GFM](https://docs.github.com/en/github/writing-on-github/working-with-advanced-formatting/organizing-information-with-tables)) table..
 *
 * @param {Array<Array<string|null|undefined>>} table
 *   Table data (matrix of strings).
 * @param {Options} [options]
 *   Configuration (optional).
 * @returns {string}
 */ function $778fc2ec48a1ea78$export$cdb7288612c4f3d6(table, options = {}) {
    const align = (options.align || []).concat();
    const stringLength = options.stringLength || $778fc2ec48a1ea78$var$defaultStringLength;
    /** @type {Array<number>} Character codes as symbols for alignment per column. */ const alignments = [];
    /** @type {Array<Array<string>>} Cells per row. */ const cellMatrix = [];
    /** @type {Array<Array<number>>} Sizes of each cell per row. */ const sizeMatrix = [];
    /** @type {Array<number>} */ const longestCellByColumn = [];
    let mostCellsPerRow = 0;
    let rowIndex = -1;
    // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
    // do superfluous work when aligning, so optimize for aligning.
    while(++rowIndex < table.length){
        /** @type {Array<string>} */ const row = [];
        /** @type {Array<number>} */ const sizes = [];
        let columnIndex = -1;
        if (table[rowIndex].length > mostCellsPerRow) mostCellsPerRow = table[rowIndex].length;
        while(++columnIndex < table[rowIndex].length){
            const cell = $778fc2ec48a1ea78$var$serialize(table[rowIndex][columnIndex]);
            if (options.alignDelimiters !== false) {
                const size = stringLength(cell);
                sizes[columnIndex] = size;
                if (longestCellByColumn[columnIndex] === undefined || size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            }
            row.push(cell);
        }
        cellMatrix[rowIndex] = row;
        sizeMatrix[rowIndex] = sizes;
    }
    // Figure out which alignments to use.
    let columnIndex = -1;
    if (typeof align === "object" && "length" in align) while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = $778fc2ec48a1ea78$var$toAlignment(align[columnIndex]);
    else {
        const code = $778fc2ec48a1ea78$var$toAlignment(align);
        while(++columnIndex < mostCellsPerRow)alignments[columnIndex] = code;
    }
    // Inject the alignment row.
    columnIndex = -1;
    /** @type {Array<string>} */ const row = [];
    /** @type {Array<number>} */ const sizes = [];
    while(++columnIndex < mostCellsPerRow){
        const code = alignments[columnIndex];
        let before = "";
        let after = "";
        if (code === 99 /* `c` */ ) {
            before = ":";
            after = ":";
        } else if (code === 108 /* `l` */ ) before = ":";
        else if (code === 114 /* `r` */ ) after = ":";
        // There *must* be at least one hyphen-minus in each alignment cell.
        let size = options.alignDelimiters === false ? 1 : Math.max(1, longestCellByColumn[columnIndex] - before.length - after.length);
        const cell = before + "-".repeat(size) + after;
        if (options.alignDelimiters !== false) {
            size = before.length + size + after.length;
            if (size > longestCellByColumn[columnIndex]) longestCellByColumn[columnIndex] = size;
            sizes[columnIndex] = size;
        }
        row[columnIndex] = cell;
    }
    // Inject the alignment row.
    cellMatrix.splice(1, 0, row);
    sizeMatrix.splice(1, 0, sizes);
    rowIndex = -1;
    /** @type {Array<string>} */ const lines = [];
    while(++rowIndex < cellMatrix.length){
        const row = cellMatrix[rowIndex];
        const sizes = sizeMatrix[rowIndex];
        columnIndex = -1;
        /** @type {Array<string>} */ const line = [];
        while(++columnIndex < mostCellsPerRow){
            const cell = row[columnIndex] || "";
            let before = "";
            let after = "";
            if (options.alignDelimiters !== false) {
                const size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0);
                const code = alignments[columnIndex];
                if (code === 114 /* `r` */ ) before = " ".repeat(size);
                else if (code === 99 /* `c` */ ) {
                    if (size % 2) {
                        before = " ".repeat(size / 2 + 0.5);
                        after = " ".repeat(size / 2 - 0.5);
                    } else {
                        before = " ".repeat(size / 2);
                        after = before;
                    }
                } else after = " ".repeat(size);
            }
            if (options.delimiterStart !== false && !columnIndex) line.push("|");
            if (options.padding !== false && // Don’t add the opening space if we’re not aligning and the cell is
            // empty: there will be a closing space.
            !(options.alignDelimiters === false && cell === "") && (options.delimiterStart !== false || columnIndex)) line.push(" ");
            if (options.alignDelimiters !== false) line.push(before);
            line.push(cell);
            if (options.alignDelimiters !== false) line.push(after);
            if (options.padding !== false) line.push(" ");
            if (options.delimiterEnd !== false || columnIndex !== mostCellsPerRow - 1) line.push("|");
        }
        lines.push(options.delimiterEnd === false ? line.join("").replace(/ +$/, "") : line.join(""));
    }
    return lines.join("\n");
}
/**
 * @param {string|null|undefined} [value]
 * @returns {string}
 */ function $778fc2ec48a1ea78$var$serialize(value) {
    return value === null || value === undefined ? "" : String(value);
}
/**
 * @param {string} value
 * @returns {number}
 */ function $778fc2ec48a1ea78$var$defaultStringLength(value) {
    return value.length;
}
/**
 * @param {string|null|undefined} value
 * @returns {number}
 */ function $778fc2ec48a1ea78$var$toAlignment(value) {
    const code = typeof value === "string" ? value.codePointAt(0) : 0;
    return code === 67 /* `C` */  || code === 99 /* `c` */  ? 99 /* `c` */  : code === 76 /* `L` */  || code === 108 /* `l` */  ? 108 /* `l` */  : code === 82 /* `R` */  || code === 114 /* `r` */  ? 114 /* `r` */  : 0;
}


/**
 * @typedef {import('mdast').Blockquote} Blockquote
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Blockquote} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $e1e0b27b7a4eb442$export$67dc04e652a298ca(node, _, state, info) {
    const exit = state.enter("blockquote");
    const tracker = state.createTracker(info);
    tracker.move("> ");
    tracker.shift(2);
    const value = state.indentLines(state.containerFlow(node, tracker.current()), $e1e0b27b7a4eb442$var$map);
    exit();
    return value;
}
/** @type {Map} */ function $e1e0b27b7a4eb442$var$map(line, _, blank) {
    return ">" + (blank ? "" : " ") + line;
}


/**
 * @typedef {import('mdast').Break} Break
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').ConstructName} ConstructName
 * @typedef {import('../types.js').Unsafe} Unsafe
 */ /**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe} pattern
 * @returns {boolean}
 */ function $d6f0281626def1e7$export$78221a09424368d(stack, pattern) {
    return $d6f0281626def1e7$var$listInScope(stack, pattern.inConstruct, true) && !$d6f0281626def1e7$var$listInScope(stack, pattern.notInConstruct, false);
}
/**
 * @param {Array<ConstructName>} stack
 * @param {Unsafe['inConstruct']} list
 * @param {boolean} none
 * @returns {boolean}
 */ function $d6f0281626def1e7$var$listInScope(stack, list, none) {
    if (typeof list === "string") list = [
        list
    ];
    if (!list || list.length === 0) return none;
    let index = -1;
    while(++index < list.length){
        if (stack.includes(list[index])) return true;
    }
    return false;
}


function $8091a82cb5157a67$export$371da9dd35aba193(_, _1, state, info) {
    let index = -1;
    while(++index < state.unsafe.length){
        // If we can’t put eols in this construct (setext headings, tables), use a
        // space instead.
        if (state.unsafe[index].character === "\n" && (0, $d6f0281626def1e7$export$78221a09424368d)(state.stack, state.unsafe[index])) return /[ \t]/.test(info.before) ? "" : " ";
    }
    return "\\\n";
}


/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ /**
 * Get the count of the longest repeating streak of `character` in `value`.
 *
 * @param {string} value
 *   Content to search in.
 * @param {string} character
 *   Single character to look for.
 * @returns {number}
 *   Count of most frequent adjacent `character`s in `value`.
 */ function $57909ee9b9040fac$export$711675ff42d864f2(value, character) {
    const source = String(value);
    let index = source.indexOf(character);
    let expected = index;
    let count = 0;
    let max = 0;
    if (typeof character !== "string" || character.length !== 1) throw new Error("Expected character");
    while(index !== -1){
        if (index === expected) {
            if (++count > max) max = count;
        } else count = 1;
        expected = index + 1;
        index = source.indexOf(character, expected);
    }
    return max;
}


/**
 * @typedef {import('mdast').Code} Code
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Code} node
 * @param {State} state
 * @returns {boolean}
 */ function $9cc6d1f20e360212$export$8c0df78a8cad9f4b(node, state) {
    return Boolean(state.options.fences === false && node.value && // If there’s no info…
    !node.lang && // And there’s a non-whitespace character…
    /[^ \r\n]/.test(node.value) && // And the value doesn’t start or end in a blank…
    !/^[\t ]*(?:[\r\n]|$)|(?:^|[\r\n])[\t ]*$/.test(node.value));
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['fence'], null | undefined>}
 */ function $ac5802a6f0c8c0da$export$7487ee7cbb2e2919(state) {
    const marker = state.options.fence || "`";
    if (marker !== "`" && marker !== "~") throw new Error("Cannot serialize code with `" + marker + "` for `options.fence`, expected `` ` `` or `~`");
    return marker;
}


function $9422496b7dcd7487$export$6565f9f03506010b(node, _, state, info) {
    const marker = (0, $ac5802a6f0c8c0da$export$7487ee7cbb2e2919)(state);
    const raw = node.value || "";
    const suffix = marker === "`" ? "GraveAccent" : "Tilde";
    if ((0, $9cc6d1f20e360212$export$8c0df78a8cad9f4b)(node, state)) {
        const exit = state.enter("codeIndented");
        const value = state.indentLines(raw, $9422496b7dcd7487$var$map);
        exit();
        return value;
    }
    const tracker = state.createTracker(info);
    const sequence = marker.repeat(Math.max((0, $57909ee9b9040fac$export$711675ff42d864f2)(raw, marker) + 1, 3));
    const exit = state.enter("codeFenced");
    let value = tracker.move(sequence);
    if (node.lang) {
        const subexit = state.enter(`codeFencedLang${suffix}`);
        value += tracker.move(state.safe(node.lang, {
            before: value,
            after: " ",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    if (node.lang && node.meta) {
        const subexit = state.enter(`codeFencedMeta${suffix}`);
        value += tracker.move(" ");
        value += tracker.move(state.safe(node.meta, {
            before: value,
            after: "\n",
            encode: [
                "`"
            ],
            ...tracker.current()
        }));
        subexit();
    }
    value += tracker.move("\n");
    if (raw) value += tracker.move(raw + "\n");
    value += tracker.move(sequence);
    exit();
    return value;
}
/** @type {Map} */ function $9422496b7dcd7487$var$map(line, _, blank) {
    return (blank ? "" : "    ") + line;
}


/**
 * @typedef {import('mdast').Definition} Definition
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['quote'], null | undefined>}
 */ function $a34c6d90b8345fb7$export$7aeba63896b2719(state) {
    const marker = state.options.quote || '"';
    if (marker !== '"' && marker !== "'") throw new Error("Cannot serialize title with `" + marker + "` for `options.quote`, expected `\"`, or `'`");
    return marker;
}


function $13aa32b3713ea2f5$export$69f215ed977cdb73(node, _, state, info) {
    const quote = (0, $a34c6d90b8345fb7$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("definition");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    value += tracker.move(state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("]: ");
    subexit();
    if (// If there’s no url, or…
    !node.url || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : "\n",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Emphasis} Emphasis
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['emphasis'], null | undefined>}
 */ function $0ccdf9e4f6a185c2$export$f967eb786dea04e7(state) {
    const marker = state.options.emphasis || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize emphasis with `" + marker + "` for `options.emphasis`, expected `*`, or `_`");
    return marker;
}


$527363be5472d1df$export$bef81ba411953b51.peek = $527363be5472d1df$var$emphasisPeek;
function $527363be5472d1df$export$bef81ba411953b51(node, _, state, info) {
    const marker = (0, $0ccdf9e4f6a185c2$export$f967eb786dea04e7)(state);
    const exit = state.enter("emphasis");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker);
    exit();
    return value;
}
/**
 * @param {Emphasis} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $527363be5472d1df$var$emphasisPeek(_, _1, state) {
    return state.options.emphasis || "*";
}


/**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('mdast').Heading} Heading
 * @typedef {import('../types.js').State} State
 */ 

function $32517622ae4a7127$export$78863676235adfbc(node, state) {
    let literalWithBreak = false;
    // Look for literals with a line break.
    // Note that this also
    (0, $425a1aa39753930c$export$bf638b60ea8b89b7)(node, function(node) {
        if ("value" in node && /\r?\n|\r/.test(node.value) || node.type === "break") {
            literalWithBreak = true;
            return 0, $fa87f0c78841621d$export$7f100f842f565dc9;
        }
    });
    return Boolean((!node.depth || node.depth < 3) && (0, $05e7756bd26ae88a$export$f84e8e69fd4488a5)(node) && (state.options.setext || literalWithBreak));
}


function $d0924d5e659905f9$export$46e4a324ac90507f(node, _, state, info) {
    const rank = Math.max(Math.min(6, node.depth || 1), 1);
    const tracker = state.createTracker(info);
    if ((0, $32517622ae4a7127$export$78863676235adfbc)(node, state)) {
        const exit = state.enter("headingSetext");
        const subexit = state.enter("phrasing");
        const value = state.containerPhrasing(node, {
            ...tracker.current(),
            before: "\n",
            after: "\n"
        });
        subexit();
        exit();
        return value + "\n" + (rank === 1 ? "=" : "-").repeat(// The whole size…
        value.length - // Minus the position of the character after the last EOL (or
        // 0 if there is none)…
        (Math.max(value.lastIndexOf("\r"), value.lastIndexOf("\n")) + 1));
    }
    const sequence = "#".repeat(rank);
    const exit = state.enter("headingAtx");
    const subexit = state.enter("phrasing");
    // Note: for proper tracking, we should reset the output positions when there
    // is no content returned, because then the space is not output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    tracker.move(sequence + " ");
    let value = state.containerPhrasing(node, {
        before: "# ",
        after: "\n",
        ...tracker.current()
    });
    if (/^[\t ]/.test(value)) // To do: what effect has the character reference on tracking?
    value = "&#x" + value.charCodeAt(0).toString(16).toUpperCase() + ";" + value.slice(1);
    value = value ? sequence + " " + value : sequence;
    if (state.options.closeAtx) value += " " + sequence;
    subexit();
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Html} Html
 */ $f0d572fb0951a3be$export$c0bb0b647f701bb5.peek = $f0d572fb0951a3be$var$htmlPeek;
function $f0d572fb0951a3be$export$c0bb0b647f701bb5(node) {
    return node.value || "";
}
/**
 * @returns {string}
 */ function $f0d572fb0951a3be$var$htmlPeek() {
    return "<";
}


/**
 * @typedef {import('mdast').Image} Image
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ 
$fe24558c2a234f1d$export$5c452ff88e35e47d.peek = $fe24558c2a234f1d$var$imagePeek;
function $fe24558c2a234f1d$export$5c452ff88e35e47d(node, _, state, info) {
    const quote = (0, $a34c6d90b8345fb7$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const exit = state.enter("image");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    value += tracker.move(state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @returns {string}
 */ function $fe24558c2a234f1d$var$imagePeek() {
    return "!";
}


/**
 * @typedef {import('mdast').ImageReference} ImageReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ $8a2063619ff7b34f$export$f281796f6bc3b8db.peek = $8a2063619ff7b34f$var$imageReferencePeek;
function $8a2063619ff7b34f$export$f281796f6bc3b8db(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("imageReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("![");
    const alt = state.safe(node.alt, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(alt + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !alt || alt !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $8a2063619ff7b34f$var$imageReferencePeek() {
    return "!";
}


/**
 * @typedef {import('mdast').InlineCode} InlineCode
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').State} State
 */ $7c3abb73b748536f$export$91b9bee19a0d8569.peek = $7c3abb73b748536f$var$inlineCodePeek;
function $7c3abb73b748536f$export$91b9bee19a0d8569(node, _, state) {
    let value = node.value || "";
    let sequence = "`";
    let index = -1;
    // If there is a single grave accent on its own in the code, use a fence of
    // two.
    // If there are two in a row, use one.
    while(new RegExp("(^|[^`])" + sequence + "([^`]|$)").test(value))sequence += "`";
    // If this is not just spaces or eols (tabs don’t count), and either the
    // first or last character are a space, eol, or tick, then pad with spaces.
    if (/[^ \r\n]/.test(value) && (/^[ \r\n]/.test(value) && /[ \r\n]$/.test(value) || /^`|`$/.test(value))) value = " " + value + " ";
    // We have a potential problem: certain characters after eols could result in
    // blocks being seen.
    // For example, if someone injected the string `'\n# b'`, then that would
    // result in an ATX heading.
    // We can’t escape characters in `inlineCode`, but because eols are
    // transformed to spaces when going from markdown to HTML anyway, we can swap
    // them out.
    while(++index < state.unsafe.length){
        const pattern = state.unsafe[index];
        const expression = state.compilePattern(pattern);
        /** @type {RegExpExecArray | null} */ let match;
        // Only look for `atBreak`s.
        // Btw: note that `atBreak` patterns will always start the regex at LF or
        // CR.
        if (!pattern.atBreak) continue;
        while(match = expression.exec(value)){
            let position = match.index;
            // Support CRLF (patterns only look for one of the characters).
            if (value.charCodeAt(position) === 10 /* `\n` */  && value.charCodeAt(position - 1) === 13 /* `\r` */ ) position--;
            value = value.slice(0, position) + " " + value.slice(match.index + 1);
        }
    }
    return sequence + value + sequence;
}
/**
 * @returns {string}
 */ function $7c3abb73b748536f$var$inlineCodePeek() {
    return "`";
}


/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Exit} Exit
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ 
/**
 * @typedef {import('mdast').Link} Link
 * @typedef {import('../types.js').State} State
 */ 
function $99d0b83abe480f58$export$74cae3045e3179ed(node, state) {
    const raw = (0, $05e7756bd26ae88a$export$f84e8e69fd4488a5)(node);
    return Boolean(!state.options.resourceLink && // If there’s a url…
    node.url && // And there’s a no title…
    !node.title && // And the content of `node` is a single text node…
    node.children && node.children.length === 1 && node.children[0].type === "text" && // And if the url is the same as the content…
    (raw === node.url || "mailto:" + raw === node.url) && // And that starts w/ a protocol…
    /^[a-z][a-z+.-]+:/i.test(node.url) && // And that doesn’t contain ASCII control codes (character escapes and
    // references don’t work), space, or angle brackets…
    !/[\0- <>\u007F]/.test(node.url));
}


$7db01c0243146976$export$9c30223ca0a664fb.peek = $7db01c0243146976$var$linkPeek;
function $7db01c0243146976$export$9c30223ca0a664fb(node, _, state, info) {
    const quote = (0, $a34c6d90b8345fb7$export$7aeba63896b2719)(state);
    const suffix = quote === '"' ? "Quote" : "Apostrophe";
    const tracker = state.createTracker(info);
    /** @type {Exit} */ let exit;
    /** @type {Exit} */ let subexit;
    if ((0, $99d0b83abe480f58$export$74cae3045e3179ed)(node, state)) {
        // Hide the fact that we’re in phrasing, because escapes don’t work.
        const stack = state.stack;
        state.stack = [];
        exit = state.enter("autolink");
        let value = tracker.move("<");
        value += tracker.move(state.containerPhrasing(node, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
        exit();
        state.stack = stack;
        return value;
    }
    exit = state.enter("link");
    subexit = state.enter("label");
    let value = tracker.move("[");
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: "](",
        ...tracker.current()
    }));
    value += tracker.move("](");
    subexit();
    if (// If there’s no url but there is a title…
    !node.url && node.title || // If there are control characters or whitespace.
    /[\0- \u007F]/.test(node.url)) {
        subexit = state.enter("destinationLiteral");
        value += tracker.move("<");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: ">",
            ...tracker.current()
        }));
        value += tracker.move(">");
    } else {
        // No whitespace, raw is prettier.
        subexit = state.enter("destinationRaw");
        value += tracker.move(state.safe(node.url, {
            before: value,
            after: node.title ? " " : ")",
            ...tracker.current()
        }));
    }
    subexit();
    if (node.title) {
        subexit = state.enter(`title${suffix}`);
        value += tracker.move(" " + quote);
        value += tracker.move(state.safe(node.title, {
            before: value,
            after: quote,
            ...tracker.current()
        }));
        value += tracker.move(quote);
        subexit();
    }
    value += tracker.move(")");
    exit();
    return value;
}
/**
 * @param {Link} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @returns {string}
 */ function $7db01c0243146976$var$linkPeek(node, _, state) {
    return (0, $99d0b83abe480f58$export$74cae3045e3179ed)(node, state) ? "<" : "[";
}


/**
 * @typedef {import('mdast').LinkReference} LinkReference
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ $73382dd52379d9a0$export$e6c469b1b7b2bc6a.peek = $73382dd52379d9a0$var$linkReferencePeek;
function $73382dd52379d9a0$export$e6c469b1b7b2bc6a(node, _, state, info) {
    const type = node.referenceType;
    const exit = state.enter("linkReference");
    let subexit = state.enter("label");
    const tracker = state.createTracker(info);
    let value = tracker.move("[");
    const text = state.containerPhrasing(node, {
        before: value,
        after: "]",
        ...tracker.current()
    });
    value += tracker.move(text + "][");
    subexit();
    // Hide the fact that we’re in phrasing, because escapes don’t work.
    const stack = state.stack;
    state.stack = [];
    subexit = state.enter("reference");
    // Note: for proper tracking, we should reset the output positions when we end
    // up making a `shortcut` reference, because then there is no brace output.
    // Practically, in that case, there is no content, so it doesn’t matter that
    // we’ve tracked one too many characters.
    const reference = state.safe(state.associationId(node), {
        before: value,
        after: "]",
        ...tracker.current()
    });
    subexit();
    state.stack = stack;
    exit();
    if (type === "full" || !text || text !== reference) value += tracker.move(reference + "]");
    else if (type === "shortcut") // Remove the unwanted `[`.
    value = value.slice(0, -1);
    else value += tracker.move("]");
    return value;
}
/**
 * @returns {string}
 */ function $73382dd52379d9a0$var$linkReferencePeek() {
    return "[";
}


/**
 * @typedef {import('mdast').List} List
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bullet'], null | undefined>}
 */ function $3beee08fff0000b3$export$7425517207a4d0ae(state) {
    const marker = state.options.bullet || "*";
    if (marker !== "*" && marker !== "+" && marker !== "-") throw new Error("Cannot serialize items with `" + marker + "` for `options.bullet`, expected `*`, `+`, or `-`");
    return marker;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ 
function $ab7dd704fed03b62$export$e6803bf0889262a1(state) {
    const bullet = (0, $3beee08fff0000b3$export$7425517207a4d0ae)(state);
    const bulletOther = state.options.bulletOther;
    if (!bulletOther) return bullet === "*" ? "-" : "*";
    if (bulletOther !== "*" && bulletOther !== "+" && bulletOther !== "-") throw new Error("Cannot serialize items with `" + bulletOther + "` for `options.bulletOther`, expected `*`, `+`, or `-`");
    if (bulletOther === bullet) throw new Error("Expected `bullet` (`" + bullet + "`) and `bulletOther` (`" + bulletOther + "`) to be different");
    return bulletOther;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['bulletOrdered'], null | undefined>}
 */ function $0e5a397d55b25294$export$98d522b78eddc19b(state) {
    const marker = state.options.bulletOrdered || ".";
    if (marker !== "." && marker !== ")") throw new Error("Cannot serialize items with `" + marker + "` for `options.bulletOrdered`, expected `.` or `)`");
    return marker;
}


/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['rule'], null | undefined>}
 */ function $282f790e656db030$export$d8d533ef24dba866(state) {
    const marker = state.options.rule || "*";
    if (marker !== "*" && marker !== "-" && marker !== "_") throw new Error("Cannot serialize rules with `" + marker + "` for `options.rule`, expected `*`, `-`, or `_`");
    return marker;
}


function $11dd97b68f7592e4$export$8837f4fc672e936d(node, parent, state, info) {
    const exit = state.enter("list");
    const bulletCurrent = state.bulletCurrent;
    /** @type {string} */ let bullet = node.ordered ? (0, $0e5a397d55b25294$export$98d522b78eddc19b)(state) : (0, $3beee08fff0000b3$export$7425517207a4d0ae)(state);
    /** @type {string} */ const bulletOther = node.ordered ? bullet === "." ? ")" : "." : (0, $ab7dd704fed03b62$export$e6803bf0889262a1)(state);
    let useDifferentMarker = parent && state.bulletLastUsed ? bullet === state.bulletLastUsed : false;
    if (!node.ordered) {
        const firstListItem = node.children ? node.children[0] : undefined;
        // If there’s an empty first list item directly in two list items,
        // we have to use a different bullet:
        //
        // ```markdown
        // * - *
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if (// Bullet could be used as a thematic break marker:
        (bullet === "*" || bullet === "-") && // Empty first list item:
        firstListItem && (!firstListItem.children || !firstListItem.children[0]) && // Directly in two other list items:
        state.stack[state.stack.length - 1] === "list" && state.stack[state.stack.length - 2] === "listItem" && state.stack[state.stack.length - 3] === "list" && state.stack[state.stack.length - 4] === "listItem" && // That are each the first child.
        state.indexStack[state.indexStack.length - 1] === 0 && state.indexStack[state.indexStack.length - 2] === 0 && state.indexStack[state.indexStack.length - 3] === 0) useDifferentMarker = true;
        // If there’s a thematic break at the start of the first list item,
        // we have to use a different bullet:
        //
        // ```markdown
        // * ---
        // ```
        //
        // …because otherwise it would become one big thematic break.
        if ((0, $282f790e656db030$export$d8d533ef24dba866)(state) === bullet && firstListItem) {
            let index = -1;
            while(++index < node.children.length){
                const item = node.children[index];
                if (item && item.type === "listItem" && item.children && item.children[0] && item.children[0].type === "thematicBreak") {
                    useDifferentMarker = true;
                    break;
                }
            }
        }
    }
    if (useDifferentMarker) bullet = bulletOther;
    state.bulletCurrent = bullet;
    const value = state.containerFlow(node, info);
    state.bulletLastUsed = bullet;
    state.bulletCurrent = bulletCurrent;
    exit();
    return value;
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').Map} Map
 * @typedef {import('../types.js').State} State
 */ 
/**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['listItemIndent'], null | undefined>}
 */ function $d515e737affb5bf4$export$2d5358b63da92261(state) {
    const style = state.options.listItemIndent || "one";
    if (style !== "tab" && style !== "one" && style !== "mixed") throw new Error("Cannot serialize items with `" + style + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");
    return style;
}


function $e30d778f643aae1e$export$76c7e83ecc9cdf05(node, parent, state, info) {
    const listItemIndent = (0, $d515e737affb5bf4$export$2d5358b63da92261)(state);
    let bullet = state.bulletCurrent || (0, $3beee08fff0000b3$export$7425517207a4d0ae)(state);
    // Add the marker value for ordered lists.
    if (parent && parent.type === "list" && parent.ordered) bullet = (typeof parent.start === "number" && parent.start > -1 ? parent.start : 1) + (state.options.incrementListMarker === false ? 0 : parent.children.indexOf(node)) + bullet;
    let size = bullet.length + 1;
    if (listItemIndent === "tab" || listItemIndent === "mixed" && (parent && parent.type === "list" && parent.spread || node.spread)) size = Math.ceil(size / 4) * 4;
    const tracker = state.createTracker(info);
    tracker.move(bullet + " ".repeat(size - bullet.length));
    tracker.shift(size);
    const exit = state.enter("listItem");
    const value = state.indentLines(state.containerFlow(node, tracker.current()), map);
    exit();
    return value;
    /** @type {Map} */ function map(line, index, blank) {
        if (index) return (blank ? "" : " ".repeat(size)) + line;
        return (blank ? bullet : bullet + " ".repeat(size - bullet.length)) + line;
    }
}


/**
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Paragraph} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $54973fe4b9a4b2b1$export$9c206ddddb32a9b(node, _, state, info) {
    const exit = state.enter("paragraph");
    const subexit = state.enter("phrasing");
    const value = state.containerPhrasing(node, info);
    subexit();
    exit();
    return value;
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Root} Root
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('mdast').PhrasingContent} PhrasingContent
 */ 
const $60afd88da4d069d8$export$444c9dec66a6f08c = /** @type {(node?: unknown) => node is PhrasingContent} */ (0, $c32fa7de1b4c617f$export$9c68d69a4c5bbcf9)([
    "break",
    "delete",
    "emphasis",
    "footnote",
    "footnoteReference",
    "image",
    "imageReference",
    "inlineCode",
    "link",
    "linkReference",
    "strong",
    "text"
]);


function $122faa78fc1ff334$export$e8e78c978b129247(node, _, state, info) {
    // Note: `html` nodes are ambiguous.
    const hasPhrasing = node.children.some(function(d) {
        return (0, $60afd88da4d069d8$export$444c9dec66a6f08c)(d);
    });
    const fn = hasPhrasing ? state.containerPhrasing : state.containerFlow;
    return fn.call(state, node, info);
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Strong} Strong
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['strong'], null | undefined>}
 */ function $72ac8c8be4769904$export$b7ce17905d66a6c3(state) {
    const marker = state.options.strong || "*";
    if (marker !== "*" && marker !== "_") throw new Error("Cannot serialize strong with `" + marker + "` for `options.strong`, expected `*`, or `_`");
    return marker;
}


$dc776035a28ed734$export$59ae2c325a998f89.peek = $dc776035a28ed734$var$strongPeek;
function $dc776035a28ed734$export$59ae2c325a998f89(node, _, state, info) {
    const marker = (0, $72ac8c8be4769904$export$b7ce17905d66a6c3)(state);
    const exit = state.enter("strong");
    const tracker = state.createTracker(info);
    let value = tracker.move(marker + marker);
    value += tracker.move(state.containerPhrasing(node, {
        before: value,
        after: marker,
        ...tracker.current()
    }));
    value += tracker.move(marker + marker);
    exit();
    return value;
}
/**
 * @param {Strong} _
 * @param {Parents | undefined} _1
 * @param {State} state
 * @returns {string}
 */ function $dc776035a28ed734$var$strongPeek(_, _1, state) {
    return state.options.strong || "*";
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').Text} Text
 * @typedef {import('../types.js').Info} Info
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {Text} node
 * @param {Parents | undefined} _
 * @param {State} state
 * @param {Info} info
 * @returns {string}
 */ function $f8750fb71170dc51$export$6f093cfa640b7166(node, _, state, info) {
    return state.safe(node.value, info);
}


/**
 * @typedef {import('mdast').Parents} Parents
 * @typedef {import('mdast').ThematicBreak} ThematicBreak
 * @typedef {import('../types.js').State} State
 */ /**
 * @typedef {import('../types.js').Options} Options
 * @typedef {import('../types.js').State} State
 */ /**
 * @param {State} state
 * @returns {Exclude<Options['ruleRepetition'], null | undefined>}
 */ function $bcc0c3926bbd258b$export$72f02155834d89c4(state) {
    const repetition = state.options.ruleRepetition || 3;
    if (repetition < 3) throw new Error("Cannot serialize rules with repetition `" + repetition + "` for `options.ruleRepetition`, expected `3` or more");
    return repetition;
}



function $d26635d925ddba87$export$ba7b13e047416c03(_, _1, state) {
    const value = ((0, $282f790e656db030$export$d8d533ef24dba866)(state) + (state.options.ruleSpaces ? " " : "")).repeat((0, $bcc0c3926bbd258b$export$72f02155834d89c4)(state));
    return state.options.ruleSpaces ? value.slice(0, -1) : value;
}


const $af8817d5271c8fd2$export$8f34ce051745d39e = {
    blockquote: $e1e0b27b7a4eb442$export$67dc04e652a298ca,
    break: (0, $8091a82cb5157a67$export$371da9dd35aba193),
    code: $9422496b7dcd7487$export$6565f9f03506010b,
    definition: $13aa32b3713ea2f5$export$69f215ed977cdb73,
    emphasis: $527363be5472d1df$export$bef81ba411953b51,
    hardBreak: $8091a82cb5157a67$export$371da9dd35aba193,
    heading: $d0924d5e659905f9$export$46e4a324ac90507f,
    html: $f0d572fb0951a3be$export$c0bb0b647f701bb5,
    image: $fe24558c2a234f1d$export$5c452ff88e35e47d,
    imageReference: $8a2063619ff7b34f$export$f281796f6bc3b8db,
    inlineCode: $7c3abb73b748536f$export$91b9bee19a0d8569,
    link: $7db01c0243146976$export$9c30223ca0a664fb,
    linkReference: $73382dd52379d9a0$export$e6c469b1b7b2bc6a,
    list: $11dd97b68f7592e4$export$8837f4fc672e936d,
    listItem: $e30d778f643aae1e$export$76c7e83ecc9cdf05,
    paragraph: $54973fe4b9a4b2b1$export$9c206ddddb32a9b,
    root: $122faa78fc1ff334$export$e8e78c978b129247,
    strong: $dc776035a28ed734$export$59ae2c325a998f89,
    text: $f8750fb71170dc51$export$6f093cfa640b7166,
    thematicBreak: $d26635d925ddba87$export$ba7b13e047416c03
};


function $4240895fead5da88$export$8bd0ec8ecf6adb7d() {
    return {
        enter: {
            table: $4240895fead5da88$var$enterTable,
            tableData: $4240895fead5da88$var$enterCell,
            tableHeader: $4240895fead5da88$var$enterCell,
            tableRow: $4240895fead5da88$var$enterRow
        },
        exit: {
            codeText: $4240895fead5da88$var$exitCodeText,
            table: $4240895fead5da88$var$exitTable,
            tableData: $4240895fead5da88$var$exit,
            tableHeader: $4240895fead5da88$var$exit,
            tableRow: $4240895fead5da88$var$exit
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$enterTable(token) {
    const align = token._align;
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(align, "expected `_align` on table");
    this.enter({
        type: "table",
        align: align.map(function(d) {
            return d === "none" ? null : d;
        }),
        children: []
    }, token);
    this.data.inTable = true;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$exitTable(token) {
    this.exit(token);
    this.data.inTable = undefined;
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$enterRow(token) {
    this.enter({
        type: "tableRow",
        children: []
    }, token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$exit(token) {
    this.exit(token);
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$enterCell(token) {
    this.enter({
        type: "tableCell",
        children: []
    }, token);
}
// Overwrite the default code text data handler to unescape escaped pipes when
// they are in tables.
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $4240895fead5da88$var$exitCodeText(token) {
    let value = this.resume();
    if (this.data.inTable) value = value.replace(/\\([\\|])/g, $4240895fead5da88$var$replace);
    const node = this.stack[this.stack.length - 1];
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "inlineCode");
    node.value = value;
    this.exit(token);
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $4240895fead5da88$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}
function $4240895fead5da88$export$dafcad76ea6e0045(options) {
    const settings = options || {};
    const padding = settings.tableCellPadding;
    const alignDelimiters = settings.tablePipeAlign;
    const stringLength = settings.stringLength;
    const around = padding ? " " : "|";
    return {
        unsafe: [
            {
                character: "\r",
                inConstruct: "tableCell"
            },
            {
                character: "\n",
                inConstruct: "tableCell"
            },
            // A pipe, when followed by a tab or space (padding), or a dash or colon
            // (unpadded delimiter row), could result in a table.
            {
                atBreak: true,
                character: "|",
                after: "[	 :-]"
            },
            // A pipe in a cell must be encoded.
            {
                character: "|",
                inConstruct: "tableCell"
            },
            // A colon must be followed by a dash, in which case it could start a
            // delimiter row.
            {
                atBreak: true,
                character: ":",
                after: "-"
            },
            // A delimiter row can also start with a dash, when followed by more
            // dashes, a colon, or a pipe.
            // This is a stricter version than the built in check for lists, thematic
            // breaks, and setex heading underlines though:
            // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            inlineCode: inlineCodeWithTable,
            table: handleTable,
            tableCell: handleTableCell,
            tableRow: handleTableRow
        }
    };
    /**
   * @type {ToMarkdownHandle}
   * @param {Table} node
   */ function handleTable(node, _, state, info) {
        return serializeData(handleTableAsData(node, state, info), node.align);
    }
    /**
   * This function isn’t really used normally, because we handle rows at the
   * table level.
   * But, if someone passes in a table row, this ensures we make somewhat sense.
   *
   * @type {ToMarkdownHandle}
   * @param {TableRow} node
   */ function handleTableRow(node, _, state, info) {
        const row = handleTableRowAsData(node, state, info);
        const value = serializeData([
            row
        ]);
        // `markdown-table` will always add an align row
        return value.slice(0, value.indexOf("\n"));
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {TableCell} node
   */ function handleTableCell(node, _, state, info) {
        const exit = state.enter("tableCell");
        const subexit = state.enter("phrasing");
        const value = state.containerPhrasing(node, {
            ...info,
            before: around,
            after: around
        });
        subexit();
        exit();
        return value;
    }
    /**
   * @param {Array<Array<string>>} matrix
   * @param {Array<string | null | undefined> | null | undefined} [align]
   */ function serializeData(matrix, align) {
        return (0, $778fc2ec48a1ea78$export$cdb7288612c4f3d6)(matrix, {
            align: align,
            alignDelimiters: // @ts-expect-error: `markdown-table` types should support `null`.
            alignDelimiters,
            padding: // @ts-expect-error: `markdown-table` types should support `null`.
            padding,
            stringLength: // @ts-expect-error: `markdown-table` types should support `null`.
            stringLength
        });
    }
    /**
   * @param {Table} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<Array<string>>} */ const result = [];
        const subexit = state.enter("table");
        while(++index < children.length)result[index] = handleTableRowAsData(children[index], state, info);
        subexit();
        return result;
    }
    /**
   * @param {TableRow} node
   * @param {State} state
   * @param {Info} info
   */ function handleTableRowAsData(node, state, info) {
        const children = node.children;
        let index = -1;
        /** @type {Array<string>} */ const result = [];
        const subexit = state.enter("tableRow");
        while(++index < children.length)// Note: the positional info as used here is incorrect.
        // Making it correct would be impossible due to aligning cells?
        // And it would need copy/pasting `markdown-table` into this project.
        result[index] = handleTableCell(children[index], node, state, info);
        subexit();
        return result;
    }
    /**
   * @type {ToMarkdownHandle}
   * @param {InlineCode} node
   */ function inlineCodeWithTable(node, parent, state) {
        let value = (0, $af8817d5271c8fd2$export$8f34ce051745d39e).inlineCode(node, parent, state);
        if (state.stack.includes("tableCell")) value = value.replace(/\|/g, "\\$&");
        return value;
    }
}


/**
 * @typedef {import('mdast').ListItem} ListItem
 * @typedef {import('mdast').Paragraph} Paragraph
 * @typedef {import('mdast-util-from-markdown').CompileContext} CompileContext
 * @typedef {import('mdast-util-from-markdown').Extension} FromMarkdownExtension
 * @typedef {import('mdast-util-from-markdown').Handle} FromMarkdownHandle
 * @typedef {import('mdast-util-to-markdown').Options} ToMarkdownExtension
 * @typedef {import('mdast-util-to-markdown').Handle} ToMarkdownHandle
 */ 

function $6d93ef1c4f3c2321$export$a427a608608b215f() {
    return {
        exit: {
            taskListCheckValueChecked: $6d93ef1c4f3c2321$var$exitCheck,
            taskListCheckValueUnchecked: $6d93ef1c4f3c2321$var$exitCheck,
            paragraph: $6d93ef1c4f3c2321$var$exitParagraphWithTaskListItem
        }
    };
}
function $6d93ef1c4f3c2321$export$9975722e7e834b78() {
    return {
        unsafe: [
            {
                atBreak: true,
                character: "-",
                after: "[:|-]"
            }
        ],
        handlers: {
            listItem: $6d93ef1c4f3c2321$var$listItemWithTaskListItem
        }
    };
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $6d93ef1c4f3c2321$var$exitCheck(token) {
    // We’re always in a paragraph, in a list item.
    const node = this.stack[this.stack.length - 2];
    (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "listItem");
    node.checked = token.type === "taskListCheckValueChecked";
}
/**
 * @this {CompileContext}
 * @type {FromMarkdownHandle}
 */ function $6d93ef1c4f3c2321$var$exitParagraphWithTaskListItem(token) {
    const parent = this.stack[this.stack.length - 2];
    if (parent && parent.type === "listItem" && typeof parent.checked === "boolean") {
        const node = this.stack[this.stack.length - 1];
        (0, $5d95e0aa9a039766$export$dcb8b3f0e2de7e49)(node.type === "paragraph");
        const head = node.children[0];
        if (head && head.type === "text") {
            const siblings = parent.children;
            let index = -1;
            /** @type {Paragraph | undefined} */ let firstParaghraph;
            while(++index < siblings.length){
                const sibling = siblings[index];
                if (sibling.type === "paragraph") {
                    firstParaghraph = sibling;
                    break;
                }
            }
            if (firstParaghraph === node) {
                // Must start with a space or a tab.
                head.value = head.value.slice(1);
                if (head.value.length === 0) node.children.shift();
                else if (node.position && head.position && typeof head.position.start.offset === "number") {
                    head.position.start.column++;
                    head.position.start.offset++;
                    node.position.start = Object.assign({}, head.position.start);
                }
            }
        }
    }
    this.exit(token);
}
/**
 * @type {ToMarkdownHandle}
 * @param {ListItem} node
 */ function $6d93ef1c4f3c2321$var$listItemWithTaskListItem(node, parent, state, info) {
    const head = node.children[0];
    const checkable = typeof node.checked === "boolean" && head && head.type === "paragraph";
    const checkbox = "[" + (node.checked ? "x" : " ") + "] ";
    const tracker = state.createTracker(info);
    if (checkable) tracker.move(checkbox);
    let value = (0, $af8817d5271c8fd2$export$8f34ce051745d39e).listItem(node, parent, state, {
        ...info,
        ...tracker.current()
    });
    if (checkable) value = value.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, check);
    return value;
    /**
   * @param {string} $0
   * @returns {string}
   */ function check($0) {
        return $0 + checkbox;
    }
}


function $e95901bd3b2ed8ee$export$95adae814eb7433e() {
    return [
        (0, $c2445ee9011ee097$export$b6afdfff2163546f)(),
        (0, $8facc16d76eb4654$export$c9d5ad4bdf6ff801)(),
        (0, $9857e2d2ea54569a$export$34d64e709dd0b9bb)(),
        (0, $4240895fead5da88$export$8bd0ec8ecf6adb7d)(),
        (0, $6d93ef1c4f3c2321$export$a427a608608b215f)()
    ];
}
function $e95901bd3b2ed8ee$export$ea77de6901e7c72b(options) {
    return {
        extensions: [
            (0, $c2445ee9011ee097$export$d3ace9096b01c39d)(),
            (0, $8facc16d76eb4654$export$3727766a73a6c09f)(),
            (0, $9857e2d2ea54569a$export$1632835bd2c84956)(),
            (0, $4240895fead5da88$export$dafcad76ea6e0045)(options),
            (0, $6d93ef1c4f3c2321$export$9975722e7e834b78)()
        ]
    };
}


/**
 * @typedef {import('micromark-extension-gfm-footnote').HtmlOptions} HtmlOptions
 * @typedef {import('micromark-extension-gfm-strikethrough').Options} Options
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ 
/**
 * @typedef {import('micromark-util-types').Code} Code
 * @typedef {import('micromark-util-types').ConstructRecord} ConstructRecord
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Previous} Previous
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 
const $10b0bcd3101d6b3e$var$wwwPrefix = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeWwwPrefix,
    partial: true
};
const $10b0bcd3101d6b3e$var$domain = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeDomain,
    partial: true
};
const $10b0bcd3101d6b3e$var$path = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizePath,
    partial: true
};
const $10b0bcd3101d6b3e$var$trail = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeTrail,
    partial: true
};
const $10b0bcd3101d6b3e$var$emailDomainDotTrail = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeEmailDomainDotTrail,
    partial: true
};
const $10b0bcd3101d6b3e$var$wwwAutolink = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeWwwAutolink,
    previous: $10b0bcd3101d6b3e$var$previousWww
};
const $10b0bcd3101d6b3e$var$protocolAutolink = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeProtocolAutolink,
    previous: $10b0bcd3101d6b3e$var$previousProtocol
};
const $10b0bcd3101d6b3e$var$emailAutolink = {
    tokenize: $10b0bcd3101d6b3e$var$tokenizeEmailAutolink,
    previous: $10b0bcd3101d6b3e$var$previousEmail
};
/** @type {ConstructRecord} */ const $10b0bcd3101d6b3e$var$text = {};
function $10b0bcd3101d6b3e$export$608123d9b549151() {
    return {
        text: $10b0bcd3101d6b3e$var$text
    };
}
/** @type {Code} */ let $10b0bcd3101d6b3e$var$code = 48;
// Add alphanumerics.
while($10b0bcd3101d6b3e$var$code < 123){
    $10b0bcd3101d6b3e$var$text[$10b0bcd3101d6b3e$var$code] = $10b0bcd3101d6b3e$var$emailAutolink;
    $10b0bcd3101d6b3e$var$code++;
    if ($10b0bcd3101d6b3e$var$code === 58) $10b0bcd3101d6b3e$var$code = 65;
    else if ($10b0bcd3101d6b3e$var$code === 91) $10b0bcd3101d6b3e$var$code = 97;
}
$10b0bcd3101d6b3e$var$text[43] = $10b0bcd3101d6b3e$var$emailAutolink;
$10b0bcd3101d6b3e$var$text[45] = $10b0bcd3101d6b3e$var$emailAutolink;
$10b0bcd3101d6b3e$var$text[46] = $10b0bcd3101d6b3e$var$emailAutolink;
$10b0bcd3101d6b3e$var$text[95] = $10b0bcd3101d6b3e$var$emailAutolink;
$10b0bcd3101d6b3e$var$text[72] = [
    $10b0bcd3101d6b3e$var$emailAutolink,
    $10b0bcd3101d6b3e$var$protocolAutolink
];
$10b0bcd3101d6b3e$var$text[104] = [
    $10b0bcd3101d6b3e$var$emailAutolink,
    $10b0bcd3101d6b3e$var$protocolAutolink
];
$10b0bcd3101d6b3e$var$text[87] = [
    $10b0bcd3101d6b3e$var$emailAutolink,
    $10b0bcd3101d6b3e$var$wwwAutolink
];
$10b0bcd3101d6b3e$var$text[119] = [
    $10b0bcd3101d6b3e$var$emailAutolink,
    $10b0bcd3101d6b3e$var$wwwAutolink
];
// To do: perform email autolink literals on events, afterwards.
// That’s where `markdown-rs` and `cmark-gfm` perform it.
// It should look for `@`, then for atext backwards, and then for a label
// forwards.
// To do: `mailto:`, `xmpp:` protocol as prefix.
/**
 * Email autolink literal.
 *
 * ```markdown
 * > | a contact@example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeEmailAutolink(effects, ok, nok) {
    const self = this;
    /** @type {boolean | undefined} */ let dot;
    /** @type {boolean} */ let data;
    return start;
    /**
   * Start of email autolink literal.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        if (!$10b0bcd3101d6b3e$var$gfmAtext(code) || !$10b0bcd3101d6b3e$var$previousEmail.call(self, self.previous) || $10b0bcd3101d6b3e$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkEmail");
        return atext(code);
    }
    /**
   * In email atext.
   *
   * ```markdown
   * > | a contact@example.org b
   *       ^
   * ```
   *
   * @type {State}
   */ function atext(code) {
        if ($10b0bcd3101d6b3e$var$gfmAtext(code)) {
            effects.consume(code);
            return atext;
        }
        if (code === 64) {
            effects.consume(code);
            return emailDomain;
        }
        return nok(code);
    }
    /**
   * In email domain.
   *
   * The reference code is a bit overly complex as it handles the `@`, of which
   * there may be just one.
   * Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L318>
   *
   * ```markdown
   * > | a contact@example.org b
   *               ^
   * ```
   *
   * @type {State}
   */ function emailDomain(code) {
        // Dot followed by alphanumerical (not `-` or `_`).
        if (code === 46) return effects.check($10b0bcd3101d6b3e$var$emailDomainDotTrail, emailDomainAfter, emailDomainDot)(code);
        // Alphanumerical, `-`, and `_`.
        if (code === 45 || code === 95 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code)) {
            data = true;
            effects.consume(code);
            return emailDomain;
        }
        // To do: `/` if xmpp.
        // Note: normally we’d truncate trailing punctuation from the link.
        // However, email autolink literals cannot contain any of those markers,
        // except for `.`, but that can only occur if it isn’t trailing.
        // So we can ignore truncating!
        return emailDomainAfter(code);
    }
    /**
   * In email domain, on dot that is not a trail.
   *
   * ```markdown
   * > | a contact@example.org b
   *                      ^
   * ```
   *
   * @type {State}
   */ function emailDomainDot(code) {
        effects.consume(code);
        dot = true;
        return emailDomain;
    }
    /**
   * After email domain.
   *
   * ```markdown
   * > | a contact@example.org b
   *                          ^
   * ```
   *
   * @type {State}
   */ function emailDomainAfter(code) {
        // Domain must not be empty, must include a dot, and must end in alphabetical.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L332>.
        if (data && dot && (0, $b4c110780d01af5f$export$d65d6b62c24d5436)(self.previous)) {
            effects.exit("literalAutolinkEmail");
            effects.exit("literalAutolink");
            return ok(code);
        }
        return nok(code);
    }
}
/**
 * `www` autolink literal.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeWwwAutolink(effects, ok, nok) {
    const self = this;
    return wwwStart;
    /**
   * Start of www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function wwwStart(code) {
        if (code !== 87 && code !== 119 || !$10b0bcd3101d6b3e$var$previousWww.call(self, self.previous) || $10b0bcd3101d6b3e$var$previousUnbalanced(self.events)) return nok(code);
        effects.enter("literalAutolink");
        effects.enter("literalAutolinkWww");
        // Note: we *check*, so we can discard the `www.` we parsed.
        // If it worked, we consider it as a part of the domain.
        return effects.check($10b0bcd3101d6b3e$var$wwwPrefix, effects.attempt($10b0bcd3101d6b3e$var$domain, effects.attempt($10b0bcd3101d6b3e$var$path, wwwAfter), nok), nok)(code);
    }
    /**
   * After a www autolink literal.
   *
   * ```markdown
   * > | www.example.com/a?b#c
   *                          ^
   * ```
   *
   * @type {State}
   */ function wwwAfter(code) {
        effects.exit("literalAutolinkWww");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * Protocol autolink literal.
 *
 * ```markdown
 * > | a https://example.org b
 *       ^^^^^^^^^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeProtocolAutolink(effects, ok, nok) {
    const self = this;
    let buffer = "";
    let seen = false;
    return protocolStart;
    /**
   * Start of protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^
   * ```
   *
   * @type {State}
   */ function protocolStart(code) {
        if ((code === 72 || code === 104) && $10b0bcd3101d6b3e$var$previousProtocol.call(self, self.previous) && !$10b0bcd3101d6b3e$var$previousUnbalanced(self.events)) {
            effects.enter("literalAutolink");
            effects.enter("literalAutolinkHttp");
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        return nok(code);
    }
    /**
   * In protocol.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *     ^^^^^
   * ```
   *
   * @type {State}
   */ function protocolPrefixInside(code) {
        // `5` is size of `https`
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code) && buffer.length < 5) {
            // @ts-expect-error: definitely number.
            buffer += String.fromCodePoint(code);
            effects.consume(code);
            return protocolPrefixInside;
        }
        if (code === 58) {
            const protocol = buffer.toLowerCase();
            if (protocol === "http" || protocol === "https") {
                effects.consume(code);
                return protocolSlashesInside;
            }
        }
        return nok(code);
    }
    /**
   * In slashes.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *           ^^
   * ```
   *
   * @type {State}
   */ function protocolSlashesInside(code) {
        if (code === 47) {
            effects.consume(code);
            if (seen) return afterProtocol;
            seen = true;
            return protocolSlashesInside;
        }
        return nok(code);
    }
    /**
   * After protocol, before domain.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *             ^
   * ```
   *
   * @type {State}
   */ function afterProtocol(code) {
        // To do: this is different from `markdown-rs`:
        // https://github.com/wooorm/markdown-rs/blob/b3a921c761309ae00a51fe348d8a43adbc54b518/src/construct/gfm_autolink_literal.rs#L172-L182
        return code === null || (0, $b4c110780d01af5f$export$67dbf494fc8394df)(code) || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code) || (0, $b4c110780d01af5f$export$aa04114dd888a7a0)(code) ? nok(code) : effects.attempt($10b0bcd3101d6b3e$var$domain, effects.attempt($10b0bcd3101d6b3e$var$path, protocolAfter), nok)(code);
    }
    /**
   * After a protocol autolink literal.
   *
   * ```markdown
   * > | https://example.com/a?b#c
   *                              ^
   * ```
   *
   * @type {State}
   */ function protocolAfter(code) {
        effects.exit("literalAutolinkHttp");
        effects.exit("literalAutolink");
        return ok(code);
    }
}
/**
 * `www` prefix.
 *
 * ```markdown
 * > | a www.example.org b
 *       ^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeWwwPrefix(effects, ok, nok) {
    let size = 0;
    return wwwPrefixInside;
    /**
   * In www prefix.
   *
   * ```markdown
   * > | www.example.com
   *     ^^^^
   * ```
   *
   * @type {State}
   */ function wwwPrefixInside(code) {
        if ((code === 87 || code === 119) && size < 3) {
            size++;
            effects.consume(code);
            return wwwPrefixInside;
        }
        if (code === 46 && size === 3) {
            effects.consume(code);
            return wwwPrefixAfter;
        }
        return nok(code);
    }
    /**
   * After www prefix.
   *
   * ```markdown
   * > | www.example.com
   *         ^
   * ```
   *
   * @type {State}
   */ function wwwPrefixAfter(code) {
        // If there is *anything*, we can link.
        return code === null ? nok(code) : ok(code);
    }
}
/**
 * Domain.
 *
 * ```markdown
 * > | a https://example.org b
 *               ^^^^^^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeDomain(effects, ok, nok) {
    /** @type {boolean | undefined} */ let underscoreInLastSegment;
    /** @type {boolean | undefined} */ let underscoreInLastLastSegment;
    /** @type {boolean | undefined} */ let seen;
    return domainInside;
    /**
   * In domain.
   *
   * ```markdown
   * > | https://example.com/a
   *             ^^^^^^^^^^^
   * ```
   *
   * @type {State}
   */ function domainInside(code) {
        // Check whether this marker, which is a trailing punctuation
        // marker, optionally followed by more trailing markers, and then
        // followed by an end.
        if (code === 46 || code === 95) return effects.check($10b0bcd3101d6b3e$var$trail, domainAfter, domainAtPunctuation)(code);
        // GH documents that only alphanumerics (other than `-`, `.`, and `_`) can
        // occur, which sounds like ASCII only, but they also support `www.點看.com`,
        // so that’s Unicode.
        // Instead of some new production for Unicode alphanumerics, markdown
        // already has that for Unicode punctuation and whitespace, so use those.
        // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L12>.
        if (code === null || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code) || code !== 45 && (0, $b4c110780d01af5f$export$aa04114dd888a7a0)(code)) return domainAfter(code);
        seen = true;
        effects.consume(code);
        return domainInside;
    }
    /**
   * In domain, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com
   *                    ^
   * ```
   *
   * @type {State}
   */ function domainAtPunctuation(code) {
        // There is an underscore in the last segment of the domain
        if (code === 95) underscoreInLastSegment = true;
        else {
            underscoreInLastLastSegment = underscoreInLastSegment;
            underscoreInLastSegment = undefined;
        }
        effects.consume(code);
        return domainInside;
    }
    /**
   * After domain.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^
   * ```
   *
   * @type {State} */ function domainAfter(code) {
        // Note: that’s GH says a dot is needed, but it’s not true:
        // <https://github.com/github/cmark-gfm/issues/279>
        if (underscoreInLastLastSegment || underscoreInLastSegment || !seen) return nok(code);
        return ok(code);
    }
}
/**
 * Path.
 *
 * ```markdown
 * > | a https://example.org/stuff b
 *                          ^^^^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizePath(effects, ok) {
    let sizeOpen = 0;
    let sizeClose = 0;
    return pathInside;
    /**
   * In path.
   *
   * ```markdown
   * > | https://example.com/a
   *                        ^^
   * ```
   *
   * @type {State}
   */ function pathInside(code) {
        if (code === 40) {
            sizeOpen++;
            effects.consume(code);
            return pathInside;
        }
        // To do: `markdown-rs` also needs this.
        // If this is a paren, and there are less closings than openings,
        // we don’t check for a trail.
        if (code === 41 && sizeClose < sizeOpen) return pathAtPunctuation(code);
        // Check whether this trailing punctuation marker is optionally
        // followed by more trailing markers, and then followed
        // by an end.
        if (code === 33 || code === 34 || code === 38 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 60 || code === 63 || code === 93 || code === 95 || code === 126) return effects.check($10b0bcd3101d6b3e$var$trail, ok, pathAtPunctuation)(code);
        if (code === null || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code)) return ok(code);
        effects.consume(code);
        return pathInside;
    }
    /**
   * In path, at potential trailing punctuation, that was not trailing.
   *
   * ```markdown
   * > | https://example.com/a"b
   *                          ^
   * ```
   *
   * @type {State}
   */ function pathAtPunctuation(code) {
        // Count closing parens.
        if (code === 41) sizeClose++;
        effects.consume(code);
        return pathInside;
    }
}
/**
 * Trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the entire trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | https://example.com").
 *                        ^^^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeTrail(effects, ok, nok) {
    return trail;
    /**
   * In trail of domain or path.
   *
   * ```markdown
   * > | https://example.com").
   *                        ^
   * ```
   *
   * @type {State}
   */ function trail(code) {
        // Regular trailing punctuation.
        if (code === 33 || code === 34 || code === 39 || code === 41 || code === 42 || code === 44 || code === 46 || code === 58 || code === 59 || code === 63 || code === 95 || code === 126) {
            effects.consume(code);
            return trail;
        }
        // `&` followed by one or more alphabeticals and then a `;`, is
        // as a whole considered as trailing punctuation.
        // In all other cases, it is considered as continuation of the URL.
        if (code === 38) {
            effects.consume(code);
            return trailCharRefStart;
        }
        // Needed because we allow literals after `[`, as we fix:
        // <https://github.com/github/cmark-gfm/issues/278>.
        // Check that it is not followed by `(` or `[`.
        if (code === 93) {
            effects.consume(code);
            return trailBracketAfter;
        }
        if (// `<` is an end.
        code === 60 || // So is whitespace.
        code === null || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code)) return ok(code);
        return nok(code);
    }
    /**
   * In trail, after `]`.
   *
   * > 👉 **Note**: this deviates from `cmark-gfm` to fix a bug.
   * > See end of <https://github.com/github/cmark-gfm/issues/278> for more.
   *
   * ```markdown
   * > | https://example.com](
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailBracketAfter(code) {
        // Whitespace or something that could start a resource or reference is the end.
        // Switch back to trail otherwise.
        if (code === null || code === 40 || code === 91 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code) || (0, $b4c110780d01af5f$export$a0ff789c034ffdf4)(code)) return ok(code);
        return trail(code);
    }
    /**
   * In character-reference like trail, after `&`.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefStart(code) {
        // When non-alpha, it’s not a trail.
        return (0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code) ? trailCharRefInside(code) : nok(code);
    }
    /**
   * In character-reference like trail.
   *
   * ```markdown
   * > | https://example.com&amp;).
   *                         ^
   * ```
   *
   * @type {State}
   */ function trailCharRefInside(code) {
        // Switch back to trail if this is well-formed.
        if (code === 59) {
            effects.consume(code);
            return trail;
        }
        if ((0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code)) {
            effects.consume(code);
            return trailCharRefInside;
        }
        // It’s not a trail.
        return nok(code);
    }
}
/**
 * Dot in email domain trail.
 *
 * This calls `ok` if this *is* the trail, followed by an end, which means
 * the trail is not part of the link.
 * It calls `nok` if this *is* part of the link.
 *
 * ```markdown
 * > | contact@example.org.
 *                        ^
 * ```
 *
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $10b0bcd3101d6b3e$var$tokenizeEmailDomainDotTrail(effects, ok, nok) {
    return start;
    /**
   * Dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                    ^   ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        // Must be dot.
        effects.consume(code);
        return after;
    }
    /**
   * After dot.
   *
   * ```markdown
   * > | contact@example.org.
   *                     ^   ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // Not a trail if alphanumeric.
        return (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code) ? nok(code) : ok(code);
    }
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L156>.
 *
 * @type {Previous}
 */ function $10b0bcd3101d6b3e$var$previousWww(code) {
    return code === null || code === 40 || code === 42 || code === 95 || code === 91 || code === 93 || code === 126 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code);
}
/**
 * See:
 * <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L214>.
 *
 * @type {Previous}
 */ function $10b0bcd3101d6b3e$var$previousProtocol(code) {
    return !(0, $b4c110780d01af5f$export$d65d6b62c24d5436)(code);
}
/**
 * @this {TokenizeContext}
 * @type {Previous}
 */ function $10b0bcd3101d6b3e$var$previousEmail(code) {
    // Do not allow a slash “inside” atext.
    // The reference code is a bit weird, but that’s what it results in.
    // Source: <https://github.com/github/cmark-gfm/blob/ef1cfcb/extensions/autolink.c#L307>.
    // Other than slash, every preceding character is allowed.
    return !(code === 47 || $10b0bcd3101d6b3e$var$gfmAtext(code));
}
/**
 * @param {Code} code
 * @returns {boolean}
 */ function $10b0bcd3101d6b3e$var$gfmAtext(code) {
    return code === 43 || code === 45 || code === 46 || code === 95 || (0, $b4c110780d01af5f$export$75c76db11865a9f4)(code);
}
/**
 * @param {Array<Event>} events
 * @returns {boolean}
 */ function $10b0bcd3101d6b3e$var$previousUnbalanced(events) {
    let index = events.length;
    let result = false;
    while(index--){
        const token = events[index][1];
        if ((token.type === "labelLink" || token.type === "labelImage") && !token._balanced) {
            result = true;
            break;
        }
        // If we’ve seen this token, and it was marked as not having any unbalanced
        // bracket before it, we can exit.
        if (token._gfmAutolinkLiteralWalkedInto) {
            result = false;
            break;
        }
    }
    if (events.length > 0 && !result) // Mark the last token as “walked into” w/o finding
    // anything.
    events[events.length - 1][1]._gfmAutolinkLiteralWalkedInto = true;
    return result;
}

/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').Handle} Handle
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ 
function $794cb09720dc8a3a$export$999603f1f1c3d2f9() {
    return {
        exit: {
            literalAutolinkEmail: $794cb09720dc8a3a$var$literalAutolinkEmail,
            literalAutolinkHttp: $794cb09720dc8a3a$var$literalAutolinkHttp,
            literalAutolinkWww: $794cb09720dc8a3a$var$literalAutolinkWww
        }
    };
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $794cb09720dc8a3a$var$literalAutolinkWww(token) {
    $794cb09720dc8a3a$var$anchorFromToken.call(this, token, "http://");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $794cb09720dc8a3a$var$literalAutolinkEmail(token) {
    $794cb09720dc8a3a$var$anchorFromToken.call(this, token, "mailto:");
}
/**
 * @this {CompileContext}
 * @type {Handle}
 */ function $794cb09720dc8a3a$var$literalAutolinkHttp(token) {
    $794cb09720dc8a3a$var$anchorFromToken.call(this, token);
}
/**
 * @this CompileContext
 * @param {Token} token
 * @param {string | null | undefined} [protocol]
 * @returns {undefined}
 */ function $794cb09720dc8a3a$var$anchorFromToken(token, protocol) {
    const url = this.sliceSerialize(token);
    this.tag('<a href="' + (0, $e133dd0f2d166be7$export$d130a2d684099e5a)((protocol || "") + url) + '">');
    this.raw(this.encode(url));
    this.tag("</a>");
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Exiter} Exiter
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 



const $4180b4b4a6dbd101$var$indent = {
    tokenize: $4180b4b4a6dbd101$var$tokenizeIndent,
    partial: true
};
function $4180b4b4a6dbd101$export$c82499b6656305df() {
    /** @type {Extension} */ return {
        document: {
            [91]: {
                tokenize: $4180b4b4a6dbd101$var$tokenizeDefinitionStart,
                continuation: {
                    tokenize: $4180b4b4a6dbd101$var$tokenizeDefinitionContinuation
                },
                exit: $4180b4b4a6dbd101$var$gfmFootnoteDefinitionEnd
            }
        },
        text: {
            [91]: {
                tokenize: $4180b4b4a6dbd101$var$tokenizeGfmFootnoteCall
            },
            [93]: {
                add: "after",
                tokenize: $4180b4b4a6dbd101$var$tokenizePotentialGfmFootnoteCall,
                resolveTo: $4180b4b4a6dbd101$var$resolveToPotentialGfmFootnoteCall
            }
        }
    };
}
// To do: remove after micromark update.
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4180b4b4a6dbd101$var$tokenizePotentialGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    let index = self.events.length;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {Token} */ let labelStart;
    // Find an opening.
    while(index--){
        const token = self.events[index][1];
        if (token.type === "labelImage") {
            labelStart = token;
            break;
        }
        // Exit if we’ve walked far enough.
        if (token.type === "gfmFootnoteCall" || token.type === "labelLink" || token.type === "label" || token.type === "image" || token.type === "link") break;
    }
    return start;
    /**
   * @type {State}
   */ function start(code) {
        if (!labelStart || !labelStart._balanced) return nok(code);
        const id = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize({
            start: labelStart.end,
            end: self.now()
        }));
        if (id.codePointAt(0) !== 94 || !defined.includes(id.slice(1))) return nok(code);
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return ok(code);
    }
}
// To do: remove after micromark update.
/** @type {Resolver} */ function $4180b4b4a6dbd101$var$resolveToPotentialGfmFootnoteCall(events, context) {
    let index = events.length;
    /** @type {Token | undefined} */ let labelStart;
    // Find an opening.
    while(index--)if (events[index][1].type === "labelImage" && events[index][0] === "enter") {
        labelStart = events[index][1];
        break;
    }
    // Change the `labelImageMarker` to a `data`.
    events[index + 1][1].type = "data";
    events[index + 3][1].type = "gfmFootnoteCallLabelMarker";
    // The whole (without `!`):
    /** @type {Token} */ const call = {
        type: "gfmFootnoteCall",
        start: Object.assign({}, events[index + 3][1].start),
        end: Object.assign({}, events[events.length - 1][1].end)
    };
    // The `^` marker
    /** @type {Token} */ const marker = {
        type: "gfmFootnoteCallMarker",
        start: Object.assign({}, events[index + 3][1].end),
        end: Object.assign({}, events[index + 3][1].end)
    };
    // Increment the end 1 character.
    marker.end.column++;
    marker.end.offset++;
    marker.end._bufferIndex++;
    /** @type {Token} */ const string = {
        type: "gfmFootnoteCallString",
        start: Object.assign({}, marker.end),
        end: Object.assign({}, events[events.length - 1][1].start)
    };
    /** @type {Token} */ const chunk = {
        type: "chunkString",
        contentType: "string",
        start: Object.assign({}, string.start),
        end: Object.assign({}, string.end)
    };
    /** @type {Array<Event>} */ const replacement = [
        // Take the `labelImageMarker` (now `data`, the `!`)
        events[index + 1],
        events[index + 2],
        [
            "enter",
            call,
            context
        ],
        // The `[`
        events[index + 3],
        events[index + 4],
        // The `^`.
        [
            "enter",
            marker,
            context
        ],
        [
            "exit",
            marker,
            context
        ],
        // Everything in between.
        [
            "enter",
            string,
            context
        ],
        [
            "enter",
            chunk,
            context
        ],
        [
            "exit",
            chunk,
            context
        ],
        [
            "exit",
            string,
            context
        ],
        // The ending (`]`, properly parsed and labelled).
        events[events.length - 2],
        events[events.length - 1],
        [
            "exit",
            call,
            context
        ]
    ];
    events.splice(index, events.length - index + 1, ...replacement);
    return events;
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4180b4b4a6dbd101$var$tokenizeGfmFootnoteCall(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    let size = 0;
    /** @type {boolean} */ let data;
    // Note: the implementation of `markdown-rs` is different, because it houses
    // core *and* extensions in one project.
    // Therefore, it can include footnote logic inside `label-end`.
    // We can’t do that, but luckily, we can parse footnotes in a simpler way than
    // needed for labels.
    return start;
    /**
   * Start of footnote label.
   *
   * ```markdown
   * > | a [^b] c
   *       ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteCall");
        effects.enter("gfmFootnoteCallLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallLabelMarker");
        return callStart;
    }
    /**
   * After `[`, at `^`.
   *
   * ```markdown
   * > | a [^b] c
   *        ^
   * ```
   *
   * @type {State}
   */ function callStart(code) {
        if (code !== 94) return nok(code);
        effects.enter("gfmFootnoteCallMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteCallMarker");
        effects.enter("gfmFootnoteCallString");
        effects.enter("chunkString").contentType = "string";
        return callData;
    }
    /**
   * In label.
   *
   * ```markdown
   * > | a [^b] c
   *         ^
   * ```
   *
   * @type {State}
   */ function callData(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteCallString");
            if (!defined.includes((0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize(token)))) return nok(code);
            effects.enter("gfmFootnoteCallLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteCallLabelMarker");
            effects.exit("gfmFootnoteCall");
            return ok;
        }
        if (!(0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? callEscape : callData;
    }
    /**
   * On character after escape.
   *
   * ```markdown
   * > | a [^b\c] d
   *           ^
   * ```
   *
   * @type {State}
   */ function callEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return callData;
        }
        return callData(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4180b4b4a6dbd101$var$tokenizeDefinitionStart(effects, ok, nok) {
    const self = this;
    const defined = self.parser.gfmFootnotes || (self.parser.gfmFootnotes = []);
    /** @type {string} */ let identifier;
    let size = 0;
    /** @type {boolean | undefined} */ let data;
    return start;
    /**
   * Start of GFM footnote definition.
   *
   * ```markdown
   * > | [^a]: b
   *     ^
   * ```
   *
   * @type {State}
   */ function start(code) {
        effects.enter("gfmFootnoteDefinition")._container = true;
        effects.enter("gfmFootnoteDefinitionLabel");
        effects.enter("gfmFootnoteDefinitionLabelMarker");
        effects.consume(code);
        effects.exit("gfmFootnoteDefinitionLabelMarker");
        return labelAtMarker;
    }
    /**
   * In label, at caret.
   *
   * ```markdown
   * > | [^a]: b
   *      ^
   * ```
   *
   * @type {State}
   */ function labelAtMarker(code) {
        if (code === 94) {
            effects.enter("gfmFootnoteDefinitionMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionMarker");
            effects.enter("gfmFootnoteDefinitionLabelString");
            effects.enter("chunkString").contentType = "string";
            return labelInside;
        }
        return nok(code);
    }
    /**
   * In label.
   *
   * > 👉 **Note**: `cmark-gfm` prevents whitespace from occurring in footnote
   * > definition labels.
   *
   * ```markdown
   * > | [^a]: b
   *       ^
   * ```
   *
   * @type {State}
   */ function labelInside(code) {
        if (// Too long.
        size > 999 || // Closing brace with nothing.
        code === 93 && !data || // Space or tab is not supported by GFM for some reason.
        // `\n` and `[` not being supported makes sense.
        code === null || code === 91 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) return nok(code);
        if (code === 93) {
            effects.exit("chunkString");
            const token = effects.exit("gfmFootnoteDefinitionLabelString");
            identifier = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(self.sliceSerialize(token));
            effects.enter("gfmFootnoteDefinitionLabelMarker");
            effects.consume(code);
            effects.exit("gfmFootnoteDefinitionLabelMarker");
            effects.exit("gfmFootnoteDefinitionLabel");
            return labelAfter;
        }
        if (!(0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) data = true;
        size++;
        effects.consume(code);
        return code === 92 ? labelEscape : labelInside;
    }
    /**
   * After `\`, at a special character.
   *
   * > 👉 **Note**: `cmark-gfm` currently does not support escaped brackets:
   * > <https://github.com/github/cmark-gfm/issues/240>
   *
   * ```markdown
   * > | [^a\*b]: c
   *         ^
   * ```
   *
   * @type {State}
   */ function labelEscape(code) {
        if (code === 91 || code === 92 || code === 93) {
            effects.consume(code);
            size++;
            return labelInside;
        }
        return labelInside(code);
    }
    /**
   * After definition label.
   *
   * ```markdown
   * > | [^a]: b
   *         ^
   * ```
   *
   * @type {State}
   */ function labelAfter(code) {
        if (code === 58) {
            effects.enter("definitionMarker");
            effects.consume(code);
            effects.exit("definitionMarker");
            if (!defined.includes(identifier)) defined.push(identifier);
            // Any whitespace after the marker is eaten, forming indented code
            // is not possible.
            // No space is also fine, just like a block quote marker.
            return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, whitespaceAfter, "gfmFootnoteDefinitionWhitespace");
        }
        return nok(code);
    }
    /**
   * After definition prefix.
   *
   * ```markdown
   * > | [^a]: b
   *           ^
   * ```
   *
   * @type {State}
   */ function whitespaceAfter(code) {
        // `markdown-rs` has a wrapping token for the prefix that is closed here.
        return ok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4180b4b4a6dbd101$var$tokenizeDefinitionContinuation(effects, ok, nok) {
    /// Start of footnote definition continuation.
    ///
    /// ```markdown
    ///   | [^a]: b
    /// > |     c
    ///     ^
    /// ```
    //
    // Either a blank line, which is okay, or an indented thing.
    return effects.check((0, $6462050da1e6035a$export$d50d28ce3ab2a612), ok, effects.attempt($4180b4b4a6dbd101$var$indent, ok, nok));
}
/** @type {Exiter} */ function $4180b4b4a6dbd101$var$gfmFootnoteDefinitionEnd(effects) {
    effects.exit("gfmFootnoteDefinition");
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $4180b4b4a6dbd101$var$tokenizeIndent(effects, ok, nok) {
    const self = this;
    return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, afterPrefix, "gfmFootnoteDefinitionIndent", 5);
    /**
   * @type {State}
   */ function afterPrefix(code) {
        const tail = self.events[self.events.length - 1];
        return tail && tail[1].type === "gfmFootnoteDefinitionIndent" && tail[2].sliceSerialize(tail[1], true).length === 4 ? ok(code) : nok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @callback BackLabelTemplate
 *   Generate a back label dynamically.
 *
 *   For the following markdown:
 *
 *   ```markdown
 *   Alpha[^micromark], bravo[^micromark], and charlie[^remark].
 *
 *   [^remark]: things about remark
 *   [^micromark]: things about micromark
 *   ```
 *
 *   This function will be called with:
 *
 *   * `0` and `0` for the backreference from `things about micromark` to
 *      `alpha`, as it is the first used definition, and the first call to it
 *   * `0` and `1` for the backreference from `things about micromark` to
 *      `bravo`, as it is the first used definition, and the second call to it
 *   * `1` and `0` for the backreference from `things about remark` to
 *      `charlie`, as it is the second used definition
 * @param {number} referenceIndex
 *   Index of the definition in the order that they are first referenced,
 *   0-indexed.
 * @param {number} rereferenceIndex
 *   Index of calls to the same definition, 0-indexed.
 * @returns {string}
 *   Back label to use when linking back from definitions to their reference.
 */ /**
 * @typedef Options
 *   Configuration.
 * @property {string | null | undefined} [clobberPrefix='user-content-']
 *   Prefix to use before the `id` attribute on footnotes to prevent them from
 *   *clobbering* (default: `'user-content-'`).
 *
 *   Pass `''` for trusted markdown and when you are careful with
 *   polyfilling.
 *   You could pass a different prefix.
 *
 *   DOM clobbering is this:
 *
 *   ```html
 *   <p id="x"></p>
 *   <script>alert(x) // `x` now refers to the `p#x` DOM element</script>
 *   ```
 *
 *   The above example shows that elements are made available by browsers, by
 *   their ID, on the `window` object.
 *   This is a security risk because you might be expecting some other variable
 *   at that place.
 *   It can also break polyfills.
 *   Using a prefix solves these problems.
 * @property {string | null | undefined} [label='Footnotes']
 *   Textual label to use for the footnotes section (default: `'Footnotes'`).
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {string | null | undefined} [labelAttributes='class="sr-only"']
 *   Attributes to use on the footnote label (default: `'class="sr-only"'`).
 *
 *   Change it to show the label and add other attributes.
 *
 *   This label is typically hidden visually (assuming an `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass an empty string.
 *   You can also add different attributes.
 *
 *   > 👉 **Note**: `id="footnote-label"` is always added, because footnote
 *   > calls use it with `aria-describedby` to provide an accessible label.
 * @property {string | null | undefined} [labelTagName='h2']
 *   HTML tag name to use for the footnote label element (default: `'h2'`).
 *
 *   Change it to match your document structure.
 *
 *   This label is typically hidden visually (assuming a `sr-only` CSS class
 *   is defined that does that) and so affects screen readers only.
 *   If you do have such a class, but want to show this section to everyone,
 *   pass different attributes with the `labelAttributes` option.
 * @property {BackLabelTemplate | string | null | undefined} [backLabel]
 *   Textual label to describe the backreference back to references (default:
 *   `defaultBackLabel`).
 *
 *   The default value is:
 *
 *   ```js
 *   function defaultBackLabel(referenceIndex, rereferenceIndex) {
 *    return (
 *      'Back to reference ' +
 *      (referenceIndex + 1) +
 *      (rereferenceIndex > 1 ? '-' + rereferenceIndex : '')
 *    )
 *  }
 *   ```
 *
 *   Change it when the markdown is not in English.
 *
 *   This label is used in the `aria-label` attribute on each backreference
 *   (the `↩` links).
 *   It affects users of assistive technology.
 */ 

const $3832832eacbb9446$var$own = {}.hasOwnProperty;
/** @type {Options} */ const $3832832eacbb9446$var$emptyOptions = {};
function $3832832eacbb9446$export$a18c77a47f4154b6(referenceIndex, rereferenceIndex) {
    return "Back to reference " + (referenceIndex + 1) + (rereferenceIndex > 1 ? "-" + rereferenceIndex : "");
}
function $3832832eacbb9446$export$a731a1f6cf81900c(options) {
    const config = options || $3832832eacbb9446$var$emptyOptions;
    const label = config.label || "Footnotes";
    const labelTagName = config.labelTagName || "h2";
    const labelAttributes = config.labelAttributes === null || config.labelAttributes === undefined ? 'class="sr-only"' : config.labelAttributes;
    const backLabel = config.backLabel || $3832832eacbb9446$export$a18c77a47f4154b6;
    const clobberPrefix = config.clobberPrefix === null || config.clobberPrefix === undefined ? "user-content-" : config.clobberPrefix;
    return {
        enter: {
            gfmFootnoteDefinition () {
                const stack = this.getData("tightStack");
                stack.push(false);
            },
            gfmFootnoteDefinitionLabelString () {
                this.buffer();
            },
            gfmFootnoteCallString () {
                this.buffer();
            }
        },
        exit: {
            gfmFootnoteDefinition () {
                let definitions = this.getData("gfmFootnoteDefinitions");
                const footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                const tightStack = this.getData("tightStack");
                const current = footnoteStack.pop();
                const value = this.resume();
                if (!definitions) this.setData("gfmFootnoteDefinitions", definitions = {});
                if (!$3832832eacbb9446$var$own.call(definitions, current)) definitions[current] = value;
                tightStack.pop();
                this.setData("slurpOneLineEnding", true);
                // “Hack” to prevent a line ending from showing up if we’re in a definition in
                // an empty list item.
                this.setData("lastWasTag");
            },
            gfmFootnoteDefinitionLabelString (token) {
                let footnoteStack = this.getData("gfmFootnoteDefinitionStack");
                if (!footnoteStack) this.setData("gfmFootnoteDefinitionStack", footnoteStack = []);
                footnoteStack.push((0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token)));
                this.resume() // Drop the label.
                ;
                this.buffer() // Get ready for a value.
                ;
            },
            gfmFootnoteCallString (token) {
                let calls = this.getData("gfmFootnoteCallOrder");
                let counts = this.getData("gfmFootnoteCallCounts");
                const id = (0, $8900bf1e9be862c4$export$806d55e226cfcd08)(this.sliceSerialize(token));
                /** @type {number} */ let counter;
                this.resume();
                if (!calls) this.setData("gfmFootnoteCallOrder", calls = []);
                if (!counts) this.setData("gfmFootnoteCallCounts", counts = {});
                const index = calls.indexOf(id);
                const safeId = (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(id.toLowerCase());
                if (index === -1) {
                    calls.push(id);
                    counts[id] = 1;
                    counter = calls.length;
                } else {
                    counts[id]++;
                    counter = index + 1;
                }
                const reuseCounter = counts[id];
                this.tag('<sup><a href="#' + clobberPrefix + "fn-" + safeId + '" id="' + clobberPrefix + "fnref-" + safeId + (reuseCounter > 1 ? "-" + reuseCounter : "") + '" data-footnote-ref="" aria-describedby="footnote-label">' + String(counter) + "</a></sup>");
            },
            null () {
                const calls = this.getData("gfmFootnoteCallOrder") || [];
                const counts = this.getData("gfmFootnoteCallCounts") || {};
                const definitions = this.getData("gfmFootnoteDefinitions") || {};
                let index = -1;
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag('<section data-footnotes="" class="footnotes"><' + labelTagName + ' id="footnote-label"' + (labelAttributes ? " " + labelAttributes : "") + ">");
                    this.raw(this.encode(label));
                    this.tag("</" + labelTagName + ">");
                    this.lineEndingIfNeeded();
                    this.tag("<ol>");
                }
                while(++index < calls.length){
                    // Called definitions are always defined.
                    const id = calls[index];
                    const safeId = (0, $e133dd0f2d166be7$export$d130a2d684099e5a)(id.toLowerCase());
                    let referenceIndex = 0;
                    /** @type {Array<string>} */ const references = [];
                    while(++referenceIndex <= counts[id])references.push('<a href="#' + clobberPrefix + "fnref-" + safeId + (referenceIndex > 1 ? "-" + referenceIndex : "") + '" data-footnote-backref="" aria-label="' + this.encode(typeof backLabel === "string" ? backLabel : backLabel(index, referenceIndex)) + '" class="data-footnote-backref">↩' + (referenceIndex > 1 ? "<sup>" + referenceIndex + "</sup>" : "") + "</a>");
                    const reference = references.join(" ");
                    let injected = false;
                    this.lineEndingIfNeeded();
                    this.tag('<li id="' + clobberPrefix + "fn-" + safeId + '">');
                    this.lineEndingIfNeeded();
                    this.tag(definitions[id].replace(/<\/p>(?:\r?\n|\r)?$/, function($0) {
                        injected = true;
                        return " " + reference + $0;
                    }));
                    if (!injected) {
                        this.lineEndingIfNeeded();
                        this.tag(reference);
                    }
                    this.lineEndingIfNeeded();
                    this.tag("</li>");
                }
                if (calls.length > 0) {
                    this.lineEndingIfNeeded();
                    this.tag("</ol>");
                    this.lineEndingIfNeeded();
                    this.tag("</section>");
                }
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 *
 * @typedef Options
 *   Configuration (optional).
 * @property {boolean | null | undefined} [singleTilde=true]
 *   Whether to support strikethrough with a single tilde (default: `true`).
 *
 *   Single tildes work on github.com, but are technically prohibited by the
 *   GFM spec.
 */ 


function $11b76ee77c3fbae0$export$8bbec8ea1400a00e(options) {
    const options_ = options || {};
    let single = options_.singleTilde;
    const tokenizer = {
        tokenize: tokenizeStrikethrough,
        resolveAll: resolveAllStrikethrough
    };
    if (single === null || single === undefined) single = true;
    return {
        text: {
            [126]: tokenizer
        },
        insideSpan: {
            null: [
                tokenizer
            ]
        },
        attentionMarkers: {
            null: [
                126
            ]
        }
    };
    /**
   * Take events and resolve strikethrough.
   *
   * @type {Resolver}
   */ function resolveAllStrikethrough(events, context) {
        let index = -1;
        // Walk through all events.
        while(++index < events.length)// Find a token that can close.
        if (events[index][0] === "enter" && events[index][1].type === "strikethroughSequenceTemporary" && events[index][1]._close) {
            let open = index;
            // Now walk back to find an opener.
            while(open--)// Find a token that can open the closer.
            if (events[open][0] === "exit" && events[open][1].type === "strikethroughSequenceTemporary" && events[open][1]._open && // If the sizes are the same:
            events[index][1].end.offset - events[index][1].start.offset === events[open][1].end.offset - events[open][1].start.offset) {
                events[index][1].type = "strikethroughSequence";
                events[open][1].type = "strikethroughSequence";
                /** @type {Token} */ const strikethrough = {
                    type: "strikethrough",
                    start: Object.assign({}, events[open][1].start),
                    end: Object.assign({}, events[index][1].end)
                };
                /** @type {Token} */ const text = {
                    type: "strikethroughText",
                    start: Object.assign({}, events[open][1].end),
                    end: Object.assign({}, events[index][1].start)
                };
                // Opening.
                /** @type {Array<Event>} */ const nextEvents = [
                    [
                        "enter",
                        strikethrough,
                        context
                    ],
                    [
                        "enter",
                        events[open][1],
                        context
                    ],
                    [
                        "exit",
                        events[open][1],
                        context
                    ],
                    [
                        "enter",
                        text,
                        context
                    ]
                ];
                const insideSpan = context.parser.constructs.insideSpan.null;
                if (insideSpan) // Between.
                (0, $5720affce988170b$export$869882364835d202)(nextEvents, nextEvents.length, 0, (0, $ff8c7b537158f4c7$export$3ff61ec196ff408b)(insideSpan, events.slice(open + 1, index), context));
                // Closing.
                (0, $5720affce988170b$export$869882364835d202)(nextEvents, nextEvents.length, 0, [
                    [
                        "exit",
                        text,
                        context
                    ],
                    [
                        "enter",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        events[index][1],
                        context
                    ],
                    [
                        "exit",
                        strikethrough,
                        context
                    ]
                ]);
                (0, $5720affce988170b$export$869882364835d202)(events, open - 1, index - open + 3, nextEvents);
                index = open + nextEvents.length - 2;
                break;
            }
        }
        index = -1;
        while(++index < events.length)if (events[index][1].type === "strikethroughSequenceTemporary") events[index][1].type = "data";
        return events;
    }
    /**
   * @this {TokenizeContext}
   * @type {Tokenizer}
   */ function tokenizeStrikethrough(effects, ok, nok) {
        const previous = this.previous;
        const events = this.events;
        let size = 0;
        return start;
        /** @type {State} */ function start(code) {
            if (previous === 126 && events[events.length - 1][1].type !== "characterEscape") return nok(code);
            effects.enter("strikethroughSequenceTemporary");
            return more(code);
        }
        /** @type {State} */ function more(code) {
            const before = (0, $884a47228e85f4cd$export$e3902bc0d835cad0)(previous);
            if (code === 126) {
                // If this is the third marker, exit.
                if (size > 1) return nok(code);
                effects.consume(code);
                size++;
                return more;
            }
            if (size < 2 && !single) return nok(code);
            const token = effects.exit("strikethroughSequenceTemporary");
            const after = (0, $884a47228e85f4cd$export$e3902bc0d835cad0)(code);
            token._open = !after || after === 2 && Boolean(before);
            token._close = !before || before === 2 && Boolean(after);
            return ok(code);
        }
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * Create an HTML extension for `micromark` to support GFM strikethrough when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions`, to
 *   support GFM strikethrough when serializing to HTML.
 */ function $b3db7660329aa8b4$export$58acedca46108820() {
    return {
        enter: {
            strikethrough () {
                this.tag("<del>");
            }
        },
        exit: {
            strikethrough () {
                this.tag("</del>");
            }
        }
    };
}


/**
 * @typedef {import('micromark-util-types').Event} Event
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').Point} Point
 * @typedef {import('micromark-util-types').Resolver} Resolver
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').Token} Token
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ /**
 * @typedef {[number, number, number, number]} Range
 *   Cell info.
 *
 * @typedef {0 | 1 | 2 | 3} RowKind
 *   Where we are: `1` for head row, `2` for delimiter row, `3` for body row.
 */ 

/**
 * @typedef {import('micromark-util-types').Event} Event
 */ // Port of `edit_map.rs` from `markdown-rs`.
// This should move to `markdown-js` later.
// Deal with several changes in events, batching them together.
//
// Preferably, changes should be kept to a minimum.
// Sometimes, it’s needed to change the list of events, because parsing can be
// messy, and it helps to expose a cleaner interface of events to the compiler
// and other users.
// It can also help to merge many adjacent similar events.
// And, in other cases, it’s needed to parse subcontent: pass some events
// through another tokenizer and inject the result.
/**
 * @typedef {[number, number, Array<Event>]} Change
 * @typedef {[number, number, number]} Jump
 */ /**
 * Tracks a bunch of edits.
 */ class $83c4e48d013eaf7b$export$9348908dd4518b4a {
    /**
   * Create a new edit map.
   */ constructor(){
        /**
     * Record of changes.
     *
     * @type {Array<Change>}
     */ this.map = [];
    }
    /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {undefined}
   */ add(index, remove, add) {
        $83c4e48d013eaf7b$var$addImpl(this, index, remove, add);
    }
    // To do: add this when moving to `micromark`.
    // /**
    //  * Create an edit: but insert `add` before existing additions.
    //  *
    //  * @param {number} index
    //  * @param {number} remove
    //  * @param {Array<Event>} add
    //  * @returns {undefined}
    //  */
    // addBefore(index, remove, add) {
    //   addImpl(this, index, remove, add, true)
    // }
    /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {undefined}
   */ consume(events) {
        this.map.sort(function(a, b) {
            return a[0] - b[0];
        });
        /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (this.map.length === 0) return;
        // To do: if links are added in events, like they are in `markdown-rs`,
        // this is needed.
        // // Calculate jumps: where items in the current list move to.
        // /** @type {Array<Jump>} */
        // const jumps = []
        // let index = 0
        // let addAcc = 0
        // let removeAcc = 0
        // while (index < this.map.length) {
        //   const [at, remove, add] = this.map[index]
        //   removeAcc += remove
        //   addAcc += add.length
        //   jumps.push([at, removeAcc, addAcc])
        //   index += 1
        // }
        //
        // . shiftLinks(events, jumps)
        let index = this.map.length;
        /** @type {Array<Array<Event>>} */ const vecs = [];
        while(index > 0){
            index -= 1;
            vecs.push(events.slice(this.map[index][0] + this.map[index][1]), this.map[index][2]);
            // Truncate rest.
            events.length = this.map[index][0];
        }
        vecs.push([
            ...events
        ]);
        events.length = 0;
        let slice = vecs.pop();
        while(slice){
            events.push(...slice);
            slice = vecs.pop();
        }
        // Truncate everything.
        this.map.length = 0;
    }
}
/**
 * Create an edit.
 *
 * @param {EditMap} editMap
 * @param {number} at
 * @param {number} remove
 * @param {Array<Event>} add
 * @returns {undefined}
 */ function $83c4e48d013eaf7b$var$addImpl(editMap, at, remove, add) {
    let index = 0;
    /* c8 ignore next 3 -- `resolve` is never called without tables, so without edits. */ if (remove === 0 && add.length === 0) return;
    while(index < editMap.map.length){
        if (editMap.map[index][0] === at) {
            editMap.map[index][1] += remove;
            // To do: before not used by tables, use when moving to micromark.
            // if (before) {
            //   add.push(...editMap.map[index][2])
            //   editMap.map[index][2] = add
            // } else {
            editMap.map[index][2].push(...add);
            // }
            return;
        }
        index += 1;
    }
    editMap.map.push([
        at,
        remove,
        add
    ]);
} // /**
 //  * Shift `previous` and `next` links according to `jumps`.
 //  *
 //  * This fixes links in case there are events removed or added between them.
 //  *
 //  * @param {Array<Event>} events
 //  * @param {Array<Jump>} jumps
 //  */
 // function shiftLinks(events, jumps) {
 //   let jumpIndex = 0
 //   let index = 0
 //   let add = 0
 //   let rm = 0
 //   while (index < events.length) {
 //     const rmCurr = rm
 //     while (jumpIndex < jumps.length && jumps[jumpIndex][0] <= index) {
 //       add = jumps[jumpIndex][2]
 //       rm = jumps[jumpIndex][1]
 //       jumpIndex += 1
 //     }
 //     // Ignore items that will be removed.
 //     if (rm > rmCurr) {
 //       index += rm - rmCurr
 //     } else {
 //       // ?
 //       // if let Some(link) = &events[index].link {
 //       //     if let Some(next) = link.next {
 //       //         events[next].link.as_mut().unwrap().previous = Some(index + add - rm);
 //       //         while jumpIndex < jumps.len() && jumps[jumpIndex].0 <= next {
 //       //             add = jumps[jumpIndex].2;
 //       //             rm = jumps[jumpIndex].1;
 //       //             jumpIndex += 1;
 //       //         }
 //       //         events[index].link.as_mut().unwrap().next = Some(next + add - rm);
 //       //         index = next;
 //       //         continue;
 //       //     }
 //       // }
 //       index += 1
 //     }
 //   }
 // }


/**
 * @typedef {import('micromark-util-types').Event} Event
 */ /**
 * @typedef {'center' | 'left' | 'none' | 'right'} Align
 */ /**
 * Figure out the alignment of a GFM table.
 *
 * @param {Readonly<Array<Event>>} events
 *   List of events.
 * @param {number} index
 *   Table enter event.
 * @returns {Array<Align>}
 *   List of aligns.
 */ function $cd0fc386aa37e4fc$export$bbf4fe2c547a4878(events, index) {
    let inDelimiterRow = false;
    /** @type {Array<Align>} */ const align = [];
    while(index < events.length){
        const event = events[index];
        if (inDelimiterRow) {
            if (event[0] === "enter") // Start of alignment value: set a new column.
            // To do: `markdown-rs` uses `tableDelimiterCellValue`.
            {
                if (event[1].type === "tableContent") align.push(events[index + 1][1].type === "tableDelimiterMarker" ? "left" : "none");
            } else if (event[1].type === "tableContent") {
                if (events[index - 1][1].type === "tableDelimiterMarker") {
                    const alignIndex = align.length - 1;
                    align[alignIndex] = align[alignIndex] === "left" ? "center" : "right";
                }
            } else if (event[1].type === "tableDelimiterRow") break;
        } else if (event[0] === "enter" && event[1].type === "tableDelimiterRow") inDelimiterRow = true;
        index += 1;
    }
    return align;
}


function $a1366062d1e221c7$export$e36cebda627bf2dd() {
    return {
        flow: {
            null: {
                tokenize: $a1366062d1e221c7$var$tokenizeTable,
                resolveAll: $a1366062d1e221c7$var$resolveTable
            }
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $a1366062d1e221c7$var$tokenizeTable(effects, ok, nok) {
    const self = this;
    let size = 0;
    let sizeB = 0;
    /** @type {boolean | undefined} */ let seen;
    return start;
    /**
   * Start of a GFM table.
   *
   * If there is a valid table row or table head before, then we try to parse
   * another row.
   * Otherwise, we try to parse a head.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   * > | | b |
   *     ^
   * ```
   * @type {State}
   */ function start(code) {
        let index = self.events.length - 1;
        while(index > -1){
            const type = self.events[index][1].type;
            if (type === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
            type === "linePrefix") index--;
            else break;
        }
        const tail = index > -1 ? self.events[index][1].type : null;
        const next = tail === "tableHead" || tail === "tableRow" ? bodyRowStart : headRowBefore;
        // Don’t allow lazy body rows.
        if (next === bodyRowStart && self.parser.lazy[self.now().line]) return nok(code);
        return next(code);
    }
    /**
   * Before table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBefore(code) {
        effects.enter("tableHead");
        effects.enter("tableRow");
        return headRowStart(code);
    }
    /**
   * Before table head row, after whitespace.
   *
   * ```markdown
   * > | | a |
   *     ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowStart(code) {
        if (code === 124) return headRowBreak(code);
        // To do: micromark-js should let us parse our own whitespace in extensions,
        // like `markdown-rs`:
        //
        // ```js
        // // 4+ spaces.
        // if (markdownSpace(code)) {
        //   return nok(code)
        // }
        // ```
        seen = true;
        // Count the first character, that isn’t a pipe, double.
        sizeB += 1;
        return headRowBreak(code);
    }
    /**
   * At break in table head row.
   *
   * ```markdown
   * > | | a |
   *     ^
   *       ^
   *         ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowBreak(code) {
        if (code === null) // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            // If anything other than one pipe (ignoring whitespace) was used, it’s fine.
            if (sizeB > 1) {
                sizeB = 0;
                // To do: check if this works.
                // Feel free to interrupt:
                self.interrupt = true;
                effects.exit("tableRow");
                effects.enter("lineEnding");
                effects.consume(code);
                effects.exit("lineEnding");
                return headDelimiterStart;
            }
            // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
            return nok(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) // To do: check if this is fine.
        // effects.attempt(State::Next(StateName::GfmTableHeadRowBreak), State::Nok)
        // State::Retry(space_or_tab(tokenizer))
        return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, headRowBreak, "whitespace")(code);
        sizeB += 1;
        if (seen) {
            seen = false;
            // Header cell count.
            size += 1;
        }
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            // Whether a delimiter was seen.
            seen = true;
            return headRowBreak;
        }
        // Anything else is cell data.
        effects.enter("data");
        return headRowData(code);
    }
    /**
   * In table head row data.
   *
   * ```markdown
   * > | | a |
   *       ^
   *   | | - |
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headRowData(code) {
        if (code === null || code === 124 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return headRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? headRowEscape : headRowData;
    }
    /**
   * In table head row escape.
   *
   * ```markdown
   * > | | a\-b |
   *         ^
   *   | | ---- |
   *   | | c    |
   * ```
   *
   * @type {State}
   */ function headRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return headRowData;
        }
        return headRowData(code);
    }
    /**
   * Before delimiter row.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterStart(code) {
        // Reset `interrupt`.
        self.interrupt = false;
        // Note: in `markdown-rs`, we need to handle piercing here too.
        if (self.parser.lazy[self.now().line]) return nok(code);
        effects.enter("tableDelimiterRow");
        // Track if we’ve seen a `:` or `|`.
        seen = false;
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, headDelimiterBefore, "linePrefix", self.parser.constructs.disable.null.includes("codeIndented") ? undefined : 4)(code);
        return headDelimiterBefore(code);
    }
    /**
   * Before delimiter row, after optional whitespace.
   *
   * Reused when a `|` is found later, to parse another cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *     ^
   *   | | b |
   * ```
   *
   * @type {State}
   */ function headDelimiterBefore(code) {
        if (code === 45 || code === 58) return headDelimiterValueBefore(code);
        if (code === 124) {
            seen = true;
            // If we start with a pipe, we open a cell marker.
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return headDelimiterCellBefore;
        }
        // More whitespace / empty row not allowed at start.
        return headDelimiterNok(code);
    }
    /**
   * After `|`, before delimiter cell.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *      ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellBefore(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, headDelimiterValueBefore, "whitespace")(code);
        return headDelimiterValueBefore(code);
    }
    /**
   * Before delimiter cell value.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterValueBefore(code) {
        // Align: left.
        if (code === 58) {
            sizeB += 1;
            seen = true;
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterLeftAlignmentAfter;
        }
        // Align: none.
        if (code === 45) {
            sizeB += 1;
            // To do: seems weird that this *isn’t* left aligned, but that state is used?
            return headDelimiterLeftAlignmentAfter(code);
        }
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return headDelimiterCellAfter(code);
        return headDelimiterNok(code);
    }
    /**
   * After delimiter cell left alignment marker.
   *
   * ```markdown
   *   | | a  |
   * > | | :- |
   *        ^
   * ```
   *
   * @type {State}
   */ function headDelimiterLeftAlignmentAfter(code) {
        if (code === 45) {
            effects.enter("tableDelimiterFiller");
            return headDelimiterFiller(code);
        }
        // Anything else is not ok after the left-align colon.
        return headDelimiterNok(code);
    }
    /**
   * In delimiter cell filler.
   *
   * ```markdown
   *   | | a |
   * > | | - |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterFiller(code) {
        if (code === 45) {
            effects.consume(code);
            return headDelimiterFiller;
        }
        // Align is `center` if it was `left`, `right` otherwise.
        if (code === 58) {
            seen = true;
            effects.exit("tableDelimiterFiller");
            effects.enter("tableDelimiterMarker");
            effects.consume(code);
            effects.exit("tableDelimiterMarker");
            return headDelimiterRightAlignmentAfter;
        }
        effects.exit("tableDelimiterFiller");
        return headDelimiterRightAlignmentAfter(code);
    }
    /**
   * After delimiter cell right alignment marker.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *         ^
   * ```
   *
   * @type {State}
   */ function headDelimiterRightAlignmentAfter(code) {
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, headDelimiterCellAfter, "whitespace")(code);
        return headDelimiterCellAfter(code);
    }
    /**
   * After delimiter cell.
   *
   * ```markdown
   *   | |  a |
   * > | | -: |
   *          ^
   * ```
   *
   * @type {State}
   */ function headDelimiterCellAfter(code) {
        if (code === 124) return headDelimiterBefore(code);
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            // Exit when:
            // * there was no `:` or `|` at all (it’s a thematic break or setext
            //   underline instead)
            // * the header cell count is not the delimiter cell count
            if (!seen || size !== sizeB) return headDelimiterNok(code);
            // Note: in markdown-rs`, a reset is needed here.
            effects.exit("tableDelimiterRow");
            effects.exit("tableHead");
            // To do: in `markdown-rs`, resolvers need to be registered manually.
            // effects.register_resolver(ResolveName::GfmTable)
            return ok(code);
        }
        return headDelimiterNok(code);
    }
    /**
   * In delimiter row, at a disallowed byte.
   *
   * ```markdown
   *   | | a |
   * > | | x |
   *       ^
   * ```
   *
   * @type {State}
   */ function headDelimiterNok(code) {
        // Note: in `markdown-rs`, we need to reset, in `micromark-js` we don‘t.
        return nok(code);
    }
    /**
   * Before table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   * ```
   *
   * @type {State}
   */ function bodyRowStart(code) {
        // Note: in `markdown-rs` we need to manually take care of a prefix,
        // but in `micromark-js` that is done for us, so if we’re here, we’re
        // never at whitespace.
        effects.enter("tableRow");
        return bodyRowBreak(code);
    }
    /**
   * At break in table body row.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *     ^
   *       ^
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowBreak(code) {
        if (code === 124) {
            effects.enter("tableCellDivider");
            effects.consume(code);
            effects.exit("tableCellDivider");
            return bodyRowBreak;
        }
        if (code === null || (0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) {
            effects.exit("tableRow");
            return ok(code);
        }
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, bodyRowBreak, "whitespace")(code);
        // Anything else is cell content.
        effects.enter("data");
        return bodyRowData(code);
    }
    /**
   * In table body row data.
   *
   * ```markdown
   *   | | a |
   *   | | - |
   * > | | b |
   *       ^
   * ```
   *
   * @type {State}
   */ function bodyRowData(code) {
        if (code === null || code === 124 || (0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            effects.exit("data");
            return bodyRowBreak(code);
        }
        effects.consume(code);
        return code === 92 ? bodyRowEscape : bodyRowData;
    }
    /**
   * In table body row escape.
   *
   * ```markdown
   *   | | a    |
   *   | | ---- |
   * > | | b\-c |
   *         ^
   * ```
   *
   * @type {State}
   */ function bodyRowEscape(code) {
        if (code === 92 || code === 124) {
            effects.consume(code);
            return bodyRowData;
        }
        return bodyRowData(code);
    }
}
/** @type {Resolver} */ function $a1366062d1e221c7$var$resolveTable(events, context) {
    let index = -1;
    let inFirstCellAwaitingPipe = true;
    /** @type {RowKind} */ let rowKind = 0;
    /** @type {Range} */ let lastCell = [
        0,
        0,
        0,
        0
    ];
    /** @type {Range} */ let cell = [
        0,
        0,
        0,
        0
    ];
    let afterHeadAwaitingFirstBodyRow = false;
    let lastTableEnd = 0;
    /** @type {Token | undefined} */ let currentTable;
    /** @type {Token | undefined} */ let currentBody;
    /** @type {Token | undefined} */ let currentCell;
    const map = new (0, $83c4e48d013eaf7b$export$9348908dd4518b4a)();
    while(++index < events.length){
        const event = events[index];
        const token = event[1];
        if (event[0] === "enter") {
            // Start of head.
            if (token.type === "tableHead") {
                afterHeadAwaitingFirstBodyRow = false;
                // Inject previous (body end and) table end.
                if (lastTableEnd !== 0) {
                    $a1366062d1e221c7$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
                    currentBody = undefined;
                    lastTableEnd = 0;
                }
                // Inject table start.
                currentTable = {
                    type: "table",
                    start: Object.assign({}, token.start),
                    // Note: correct end is set later.
                    end: Object.assign({}, token.end)
                };
                map.add(index, 0, [
                    [
                        "enter",
                        currentTable,
                        context
                    ]
                ]);
            } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
                inFirstCellAwaitingPipe = true;
                currentCell = undefined;
                lastCell = [
                    0,
                    0,
                    0,
                    0
                ];
                cell = [
                    0,
                    index + 1,
                    0,
                    0
                ];
                // Inject table body start.
                if (afterHeadAwaitingFirstBodyRow) {
                    afterHeadAwaitingFirstBodyRow = false;
                    currentBody = {
                        type: "tableBody",
                        start: Object.assign({}, token.start),
                        // Note: correct end is set later.
                        end: Object.assign({}, token.end)
                    };
                    map.add(index, 0, [
                        [
                            "enter",
                            currentBody,
                            context
                        ]
                    ]);
                }
                rowKind = token.type === "tableDelimiterRow" ? 2 : currentBody ? 3 : 1;
            } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) {
                inFirstCellAwaitingPipe = false;
                // First value in cell.
                if (cell[2] === 0) {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $a1366062d1e221c7$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                        lastCell = [
                            0,
                            0,
                            0,
                            0
                        ];
                    }
                    cell[2] = index;
                }
            } else if (token.type === "tableCellDivider") {
                if (inFirstCellAwaitingPipe) inFirstCellAwaitingPipe = false;
                else {
                    if (lastCell[1] !== 0) {
                        cell[0] = cell[1];
                        currentCell = $a1366062d1e221c7$var$flushCell(map, context, lastCell, rowKind, undefined, currentCell);
                    }
                    lastCell = cell;
                    cell = [
                        lastCell[1],
                        index,
                        0,
                        0
                    ];
                }
            }
        } else if (token.type === "tableHead") {
            afterHeadAwaitingFirstBodyRow = true;
            lastTableEnd = index;
        } else if (token.type === "tableRow" || token.type === "tableDelimiterRow") {
            lastTableEnd = index;
            if (lastCell[1] !== 0) {
                cell[0] = cell[1];
                currentCell = $a1366062d1e221c7$var$flushCell(map, context, lastCell, rowKind, index, currentCell);
            } else if (cell[1] !== 0) currentCell = $a1366062d1e221c7$var$flushCell(map, context, cell, rowKind, index, currentCell);
            rowKind = 0;
        } else if (rowKind && (token.type === "data" || token.type === "tableDelimiterMarker" || token.type === "tableDelimiterFiller")) cell[3] = index;
    }
    if (lastTableEnd !== 0) $a1366062d1e221c7$var$flushTableEnd(map, context, lastTableEnd, currentTable, currentBody);
    map.consume(context.events);
    // To do: move this into `html`, when events are exposed there.
    // That’s what `markdown-rs` does.
    // That needs updates to `mdast-util-gfm-table`.
    index = -1;
    while(++index < context.events.length){
        const event = context.events[index];
        if (event[0] === "enter" && event[1].type === "table") event[1]._align = (0, $cd0fc386aa37e4fc$export$bbf4fe2c547a4878)(context.events, index);
    }
    return events;
}
/**
 * Generate a cell.
 *
 * @param {EditMap} map
 * @param {Readonly<TokenizeContext>} context
 * @param {Readonly<Range>} range
 * @param {RowKind} rowKind
 * @param {number | undefined} rowEnd
 * @param {Token | undefined} previousCell
 * @returns {Token | undefined}
 */ // eslint-disable-next-line max-params
function $a1366062d1e221c7$var$flushCell(map, context, range, rowKind, rowEnd, previousCell) {
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCell' : 'tableCell'
    const groupName = rowKind === 1 ? "tableHeader" : rowKind === 2 ? "tableDelimiter" : "tableData";
    // `markdown-rs` uses:
    // rowKind === 2 ? 'tableDelimiterCellValue' : 'tableCellText'
    const valueName = "tableContent";
    // Insert an exit for the previous cell, if there is one.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //          ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[0] !== 0) {
        previousCell.end = Object.assign({}, $a1366062d1e221c7$var$getPoint(context.events, range[0]));
        map.add(range[0], 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
    }
    // Insert enter of this cell.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //           ^-- enter
    //           ^^^^-- this cell
    // ```
    const now = $a1366062d1e221c7$var$getPoint(context.events, range[1]);
    previousCell = {
        type: groupName,
        start: Object.assign({}, now),
        // Note: correct end is set later.
        end: Object.assign({}, now)
    };
    map.add(range[1], 0, [
        [
            "enter",
            previousCell,
            context
        ]
    ]);
    // Insert text start at first data start and end at last data end, and
    // remove events between.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //            ^-- enter
    //             ^-- exit
    //           ^^^^-- this cell
    // ```
    if (range[2] !== 0) {
        const relatedStart = $a1366062d1e221c7$var$getPoint(context.events, range[2]);
        const relatedEnd = $a1366062d1e221c7$var$getPoint(context.events, range[3]);
        /** @type {Token} */ const valueToken = {
            type: valueName,
            start: Object.assign({}, relatedStart),
            end: Object.assign({}, relatedEnd)
        };
        map.add(range[2], 0, [
            [
                "enter",
                valueToken,
                context
            ]
        ]);
        if (rowKind !== 2) {
            // Fix positional info on remaining events
            const start = context.events[range[2]];
            const end = context.events[range[3]];
            start[1].end = Object.assign({}, end[1].end);
            start[1].type = "chunkText";
            start[1].contentType = "text";
            // Remove if needed.
            if (range[3] > range[2] + 1) {
                const a = range[2] + 1;
                const b = range[3] - range[2] - 1;
                map.add(a, b, []);
            }
        }
        map.add(range[3] + 1, 0, [
            [
                "exit",
                valueToken,
                context
            ]
        ]);
    }
    // Insert an exit for the last cell, if at the row end.
    //
    // ```markdown
    // > | | aa | bb | cc |
    //                    ^-- exit
    //               ^^^^^^-- this cell (the last one contains two “between” parts)
    // ```
    if (rowEnd !== undefined) {
        previousCell.end = Object.assign({}, $a1366062d1e221c7$var$getPoint(context.events, rowEnd));
        map.add(rowEnd, 0, [
            [
                "exit",
                previousCell,
                context
            ]
        ]);
        previousCell = undefined;
    }
    return previousCell;
}
/**
 * Generate table end (and table body end).
 *
 * @param {Readonly<EditMap>} map
 * @param {Readonly<TokenizeContext>} context
 * @param {number} index
 * @param {Token} table
 * @param {Token | undefined} tableBody
 */ // eslint-disable-next-line max-params
function $a1366062d1e221c7$var$flushTableEnd(map, context, index, table, tableBody) {
    /** @type {Array<Event>} */ const exits = [];
    const related = $a1366062d1e221c7$var$getPoint(context.events, index);
    if (tableBody) {
        tableBody.end = Object.assign({}, related);
        exits.push([
            "exit",
            tableBody,
            context
        ]);
    }
    table.end = Object.assign({}, related);
    exits.push([
        "exit",
        table,
        context
    ]);
    map.add(index + 1, 0, exits);
}
/**
 * @param {Readonly<Array<Event>>} events
 * @param {number} index
 * @returns {Readonly<Point>}
 */ function $a1366062d1e221c7$var$getPoint(events, index) {
    const event = events[index];
    const side = event[0] === "enter" ? "start" : "end";
    return event[1][side];
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * @typedef {import('./infer.js').Align} Align
 */ const $dc14d91c2b6a9317$var$alignment = {
    none: "",
    left: ' align="left"',
    right: ' align="right"',
    center: ' align="center"'
};
function $dc14d91c2b6a9317$export$c64626c032567c7f() {
    return {
        enter: {
            table (token) {
                const tableAlign = token._align;
                this.lineEndingIfNeeded();
                this.tag("<table>");
                this.setData("tableAlign", tableAlign);
            },
            tableBody () {
                this.tag("<tbody>");
            },
            tableData () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                const align = $dc14d91c2b6a9317$var$alignment[tableAlign[tableColumn]];
                if (align === undefined) // Capture results to ignore them.
                this.buffer();
                else {
                    this.lineEndingIfNeeded();
                    this.tag("<td" + align + ">");
                }
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag("<thead>");
            },
            tableHeader () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                const align = $dc14d91c2b6a9317$var$alignment[tableAlign[tableColumn]];
                this.lineEndingIfNeeded();
                this.tag("<th" + align + ">");
            },
            tableRow () {
                this.setData("tableColumn", 0);
                this.lineEndingIfNeeded();
                this.tag("<tr>");
            }
        },
        exit: {
            // Overwrite the default code text data handler to unescape escaped pipes when
            // they are in tables.
            codeTextData (token) {
                let value = this.sliceSerialize(token);
                if (this.getData("tableAlign")) value = value.replace(/\\([\\|])/g, $dc14d91c2b6a9317$var$replace);
                this.raw(this.encode(value));
            },
            table () {
                this.setData("tableAlign");
                // Note: we don’t set `slurpAllLineEndings` anymore, in delimiter rows,
                // but we do need to reset it to match a funky newline GH generates for
                // list items combined with tables.
                this.setData("slurpAllLineEndings");
                this.lineEndingIfNeeded();
                this.tag("</table>");
            },
            tableBody () {
                this.lineEndingIfNeeded();
                this.tag("</tbody>");
            },
            tableData () {
                const tableAlign = this.getData("tableAlign");
                const tableColumn = this.getData("tableColumn");
                if (tableColumn in tableAlign) {
                    this.tag("</td>");
                    this.setData("tableColumn", tableColumn + 1);
                } else // Stop capturing.
                this.resume();
            },
            tableHead () {
                this.lineEndingIfNeeded();
                this.tag("</thead>");
            },
            tableHeader () {
                const tableColumn = this.getData("tableColumn");
                this.tag("</th>");
                this.setData("tableColumn", tableColumn + 1);
            },
            tableRow () {
                const tableAlign = this.getData("tableAlign");
                let tableColumn = this.getData("tableColumn");
                while(tableColumn < tableAlign.length){
                    this.lineEndingIfNeeded();
                    this.tag("<td" + $dc14d91c2b6a9317$var$alignment[tableAlign[tableColumn]] + "></td>");
                    tableColumn++;
                }
                this.setData("tableColumn", tableColumn);
                this.lineEndingIfNeeded();
                this.tag("</tr>");
            }
        }
    };
}
/**
 * @param {string} $0
 * @param {string} $1
 * @returns {string}
 */ function $dc14d91c2b6a9317$var$replace($0, $1) {
    // Pipes work, backslashes don’t (but can’t escape pipes).
    return $1 === "|" ? $1 : $0;
}


/**
 * @typedef {import('micromark-util-types').CompileContext} CompileContext
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 * @typedef {import('micromark-util-types').Token} Token
 */ // An opening or closing tag start, followed by a case-insensitive specific tag name,
// followed by HTML whitespace, a greater than, or a slash.
const $eaa0fa84f0326eca$var$reFlow = /<(\/?)(iframe|noembed|noframes|plaintext|script|style|title|textarea|xmp)(?=[\t\n\f\r />])/gi;
// As HTML (text) parses tags separately (and very strictly), we don’t need to be
// global.
const $eaa0fa84f0326eca$var$reText = new RegExp("^" + $eaa0fa84f0326eca$var$reFlow.source, "i");
function $eaa0fa84f0326eca$export$c9bf87ea36d00682() {
    return {
        exit: {
            htmlFlowData (token) {
                $eaa0fa84f0326eca$var$exitHtmlData.call(this, token, $eaa0fa84f0326eca$var$reFlow);
            },
            htmlTextData (token) {
                $eaa0fa84f0326eca$var$exitHtmlData.call(this, token, $eaa0fa84f0326eca$var$reText);
            }
        }
    };
}
/**
 * @this {CompileContext}
 * @param {Token} token
 * @param {RegExp} filter
 * @returns {undefined}
 */ function $eaa0fa84f0326eca$var$exitHtmlData(token, filter) {
    let value = this.sliceSerialize(token);
    if (this.options.allowDangerousHtml) value = value.replace(filter, "&lt;$1$2");
    this.raw(this.encode(value));
}


/**
 * @typedef {import('micromark-util-types').Extension} Extension
 * @typedef {import('micromark-util-types').State} State
 * @typedef {import('micromark-util-types').TokenizeContext} TokenizeContext
 * @typedef {import('micromark-util-types').Tokenizer} Tokenizer
 */ 

const $74ef55543af9cc7f$var$tasklistCheck = {
    tokenize: $74ef55543af9cc7f$var$tokenizeTasklistCheck
};
function $74ef55543af9cc7f$export$2912e8b2802475ff() {
    return {
        text: {
            [91]: $74ef55543af9cc7f$var$tasklistCheck
        }
    };
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $74ef55543af9cc7f$var$tokenizeTasklistCheck(effects, ok, nok) {
    const self = this;
    return open;
    /**
   * At start of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *       ^
   * ```
   *
   * @type {State}
   */ function open(code) {
        if (// Exit if there’s stuff before.
        self.previous !== null || // Exit if not in the first content that is the first child of a list
        // item.
        !self._gfmTasklistFirstContentOfListItem) return nok(code);
        effects.enter("taskListCheck");
        effects.enter("taskListCheckMarker");
        effects.consume(code);
        effects.exit("taskListCheckMarker");
        return inside;
    }
    /**
   * In task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *        ^
   * ```
   *
   * @type {State}
   */ function inside(code) {
        // Currently we match how GH works in files.
        // To match how GH works in comments, use `markdownSpace` (`[\t ]`) instead
        // of `markdownLineEndingOrSpace` (`[\t\n\r ]`).
        if ((0, $b4c110780d01af5f$export$a30284361b3814b7)(code)) {
            effects.enter("taskListCheckValueUnchecked");
            effects.consume(code);
            effects.exit("taskListCheckValueUnchecked");
            return close;
        }
        if (code === 88 || code === 120) {
            effects.enter("taskListCheckValueChecked");
            effects.consume(code);
            effects.exit("taskListCheckValueChecked");
            return close;
        }
        return nok(code);
    }
    /**
   * At close of task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *         ^
   * ```
   *
   * @type {State}
   */ function close(code) {
        if (code === 93) {
            effects.enter("taskListCheckMarker");
            effects.consume(code);
            effects.exit("taskListCheckMarker");
            effects.exit("taskListCheck");
            return after;
        }
        return nok(code);
    }
    /**
   * @type {State}
   */ function after(code) {
        // EOL in paragraph means there must be something else after it.
        if ((0, $b4c110780d01af5f$export$34a1dff1c0936953)(code)) return ok(code);
        // Space or tab?
        // Check what comes after.
        if ((0, $b4c110780d01af5f$export$2c6cf65c1127992a)(code)) return effects.check({
            tokenize: $74ef55543af9cc7f$var$spaceThenNonSpace
        }, ok, nok)(code);
        // EOF, or non-whitespace, both wrong.
        return nok(code);
    }
}
/**
 * @this {TokenizeContext}
 * @type {Tokenizer}
 */ function $74ef55543af9cc7f$var$spaceThenNonSpace(effects, ok, nok) {
    return (0, $d7969320ccc069d2$export$ae105c1eb063a0a2)(effects, after, "whitespace");
    /**
   * After whitespace, after task list item check.
   *
   * ```markdown
   * > | * [x] y.
   *           ^
   * ```
   *
   * @type {State}
   */ function after(code) {
        // EOF means there was nothing, so bad.
        // EOL means there’s content after it, so good.
        // Impossible to have more spaces.
        // Anything else is good.
        return code === null ? nok(code) : ok(code);
    }
}

/**
 * @typedef {import('micromark-util-types').HtmlExtension} HtmlExtension
 */ /**
 * Create an HTML extension for `micromark` to support GFM task list items when
 * serializing to HTML.
 *
 * @returns {HtmlExtension}
 *   Extension for `micromark` that can be passed in `htmlExtensions` to
 *   support GFM task list items when serializing to HTML.
 */ function $552a8cefbea4d989$export$4b6a13e2af1b08ed() {
    return {
        enter: {
            taskListCheck () {
                this.tag('<input type="checkbox" disabled="" ');
            }
        },
        exit: {
            taskListCheck () {
                this.tag("/>");
            },
            taskListCheckValueChecked () {
                this.tag('checked="" ');
            }
        }
    };
}


function $932633c55d202195$export$59ffe8c4d7a4aab2(options) {
    return (0, $4902ed8d243ad70e$export$86a865d89ef3c690)([
        (0, $10b0bcd3101d6b3e$export$608123d9b549151)(),
        (0, $4180b4b4a6dbd101$export$c82499b6656305df)(),
        (0, $11b76ee77c3fbae0$export$8bbec8ea1400a00e)(options),
        (0, $a1366062d1e221c7$export$e36cebda627bf2dd)(),
        (0, $74ef55543af9cc7f$export$2912e8b2802475ff)()
    ]);
}
function $932633c55d202195$export$6983b82e6105d62a(options) {
    return (0, $4902ed8d243ad70e$export$eaf8c406dfb0a620)([
        (0, $794cb09720dc8a3a$export$999603f1f1c3d2f9)(),
        (0, $3832832eacbb9446$export$a731a1f6cf81900c)(options),
        (0, $b3db7660329aa8b4$export$58acedca46108820)(),
        (0, $dc14d91c2b6a9317$export$c64626c032567c7f)(),
        (0, $eaa0fa84f0326eca$export$c9bf87ea36d00682)(),
        (0, $552a8cefbea4d989$export$4b6a13e2af1b08ed)()
    ]);
}


/** @type {Options} */ const $191f6fa2a587d51a$var$emptyOptions = {};
function $191f6fa2a587d51a$export$2e2bcd8739ae039(options) {
    // @ts-expect-error: TS is wrong about `this`.
    // eslint-disable-next-line unicorn/no-this-assignment
    const self = /** @type {Processor} */ this;
    const settings = options || $191f6fa2a587d51a$var$emptyOptions;
    const data = self.data();
    const micromarkExtensions = data.micromarkExtensions || (data.micromarkExtensions = []);
    const fromMarkdownExtensions = data.fromMarkdownExtensions || (data.fromMarkdownExtensions = []);
    const toMarkdownExtensions = data.toMarkdownExtensions || (data.toMarkdownExtensions = []);
    micromarkExtensions.push((0, $932633c55d202195$export$59ffe8c4d7a4aab2)(settings));
    fromMarkdownExtensions.push((0, $e95901bd3b2ed8ee$export$95adae814eb7433e)());
    toMarkdownExtensions.push((0, $e95901bd3b2ed8ee$export$ea77de6901e7c72b)(settings));
}




var $5irU4 = parcelRequire("5irU4");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
const $58d2747510318e97$var$githubRawUrlPrefix = "https://raw.githubusercontent.com/logto-io/logto/master";
function $58d2747510318e97$var$GithubRawImage({ src: src, alt: alt }) {
    const imgRef = (0, $eCoWV.useRef)(null);
    const [width, setWidth] = (0, $eCoWV.useState)(0);
    const onLoad = ()=>{
        if (imgRef.current) {
            const { naturalWidth: naturalWidth, parentElement: parentElement } = imgRef.current;
            const parentClientWidth = parentElement?.clientWidth ?? 0;
            const preferredWidth = Math.min(parentClientWidth, naturalWidth / 2);
            setWidth(preferredWidth);
        }
    };
    if (!src) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("img", {
        ref: imgRef,
        src: `${$58d2747510318e97$var$githubRawUrlPrefix}${src}`,
        alt: alt,
        width: `${width}px`,
        crossOrigin: "anonymous",
        onLoad: onLoad
    });
}
var $58d2747510318e97$export$2e2bcd8739ae039 = $58d2747510318e97$var$GithubRawImage;


var $36b0a9684dad1d9c$export$91b9bee19a0d8569;
var $36b0a9684dad1d9c$export$199d64cd116a5491;
var $36b0a9684dad1d9c$export$bfd64c937657f93a;
var $36b0a9684dad1d9c$export$4a6dd88bada4e7d2;
$36b0a9684dad1d9c$export$91b9bee19a0d8569 = `dvBGRa_inlineCode`;
$36b0a9684dad1d9c$export$199d64cd116a5491 = `dvBGRa_markdown`;
$36b0a9684dad1d9c$export$bfd64c937657f93a = `dvBGRa_rotating`;
$36b0a9684dad1d9c$export$4a6dd88bada4e7d2 = `dvBGRa_shimmer`;


function $ba19dac3f36add1e$var$Markdown({ className: className, children: children }) {
    const tocIdSet = (0, $eCoWV.useRef)(new Set());
    const generateTocId = (text)=>{
        const resolveIdCollision = (kebabCaseString, index = 0)=>{
            const result = `${kebabCaseString}${(0, $5CQIb.conditionalString)(index && `-${index}`)}`;
            if (!tocIdSet.current.has(result)) {
                tocIdSet.current.add(result);
                return result;
            }
            return resolveIdCollision(kebabCaseString, index + 1);
        };
        const initialKebabCaseString = text// Remove all symbols and punctuations except for dash and underscore. https://javascript.info/regexp-unicode
        .replaceAll(/\p{S}|\p{Pi}|\p{Pf}|\p{Ps}|\p{Pe}|\p{Po}/gu, "").replaceAll(/\s+/g, "-").toLowerCase();
        return resolveIdCollision(initialKebabCaseString);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f9e23f615f360611$export$7460c8b7e4ce9582), {
        remarkPlugins: [
            (0, $191f6fa2a587d51a$export$2e2bcd8739ae039)
        ],
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($36b0a9684dad1d9c$export$199d64cd116a5491, className),
        components: {
            code: ({ className: className, children: children, ...props })=>{
                const [, codeBlockType] = /language-(\w+)/.exec(className ?? "") ?? [];
                return codeBlockType ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                    isReadonly: true,
                    language: codeBlockType,
                    value: String(children)
                }) : /*#__PURE__*/ (0, $9zeGj.jsx)("code", {
                    className: $36b0a9684dad1d9c$export$91b9bee19a0d8569,
                    ...props,
                    children: children
                });
            },
            img: ({ src: src, alt: alt })=>{
                return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $58d2747510318e97$export$2e2bcd8739ae039), {
                    src: src,
                    alt: alt
                });
            },
            a: ({ href: href, children: children })=>{
                const isExternalLink = href?.startsWith("http");
                return /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                    href: href,
                    target: isExternalLink ? "_blank" : "_self",
                    rel: "noopener",
                    children: children
                });
            },
            h1: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h1", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h2: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h2", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h3: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h3", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h4: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h4", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h5: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h5", {
                    id: generateTocId(String(children)),
                    children: children
                }),
            h6: ({ children: children })=>/*#__PURE__*/ (0, $9zeGj.jsx)("h6", {
                    id: generateTocId(String(children)),
                    children: children
                })
        },
        children: children
    });
}
var $ba19dac3f36add1e$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.memo)($ba19dac3f36add1e$var$Markdown);



var $a0Ubj = parcelRequire("a0Ubj");


var $emGEN = parcelRequire("emGEN");


var $2ANSb = parcelRequire("2ANSb");

var $2ANSb = parcelRequire("2ANSb");
const $a159769e424a60ee$var$useConnectorApi = (props = {})=>{
    const api = (0, $2ANSb.default)(props);
    const createConnector = async (payload)=>api.post("api/connectors", {
            json: payload
        }).json();
    return {
        createConnector: createConnector
    };
};
var $a159769e424a60ee$export$2e2bcd8739ae039 = $a159769e424a60ee$var$useConnectorApi;


parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
var $bd0Y0 = parcelRequire("bd0Y0");

var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");
const $23b420b35fae99c8$var$useConnectorInUse = ()=>{
    const { data: data } = (0, $2mi28.default)("api/sign-in-exp");
    const isConnectorInUse = (0, $eCoWV.useCallback)((connector)=>{
        if (!connector || !data) return false;
        const { type: type, target: target } = connector;
        if (type === (0, $fU2Vo.ConnectorType).Social) return data.socialSignInConnectorTargets.includes(target);
        const relatedIdentifier = type === (0, $fU2Vo.ConnectorType).Email ? (0, $bd0Y0.SignInIdentifier).Email : (0, $bd0Y0.SignInIdentifier).Phone;
        const usedInSignUp = data.signUp.identifiers.includes(relatedIdentifier) && data.signUp.verify;
        const usedInSignIn = data.signIn.methods.some(({ identifier: identifier, verificationCode: verificationCode })=>verificationCode && identifier === relatedIdentifier);
        return usedInSignUp || usedInSignIn;
    }, [
        data
    ]);
    return {
        isConnectorInUse: isConnectorInUse
    };
};
var $23b420b35fae99c8$export$2e2bcd8739ae039 = $23b420b35fae99c8$var$useConnectorInUse;



var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $4at8B = parcelRequire("4at8B");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a35329775620cc91$var$SvgCaretDown = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M8.473 9.887 11.3 7.06a.666.666 0 0 0-.47-1.14.667.667 0 0 0-.47.193L8 8.473l-2.36-2.36a.667.667 0 0 0-1.084.218.667.667 0 0 0-.05.256.667.667 0 0 0 .194.473l2.827 2.827a.668.668 0 0 0 .946 0Z",
            fill: "currentColor"
        })
    });
var $a35329775620cc91$export$2e2bcd8739ae039 = $a35329775620cc91$var$SvgCaretDown;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $df1565e9aadd56da$var$SvgCaretUp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M7.527 6.113 4.7 8.94a.667.667 0 1 0 .94.947L8 7.527l2.36 2.36a.667.667 0 0 0 1.084-.218.666.666 0 0 0 .05-.256.666.666 0 0 0-.194-.473L8.473 6.113a.667.667 0 0 0-.946 0Z",
            fill: "currentColor"
        })
    });
var $df1565e9aadd56da$export$2e2bcd8739ae039 = $df1565e9aadd56da$var$SvgCaretUp;



var $hEugJ = parcelRequire("hEugJ");


var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");


var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $f301906f72f3f4fb$export$ed9ee40b3ba009ed;
(function(SyncProfileMode) {
    SyncProfileMode["OnlyAtRegister"] = "OnlyAtRegister";
    SyncProfileMode["EachSignIn"] = "EachSignIn";
})($f301906f72f3f4fb$export$ed9ee40b3ba009ed || ($f301906f72f3f4fb$export$ed9ee40b3ba009ed = {}));



var $4ytKy = parcelRequire("4ytKy");
var $7c013f6b793e7c77$export$a7db06668cad9adb;
var $7c013f6b793e7c77$export$a3bc9b8ed74fc;
var $7c013f6b793e7c77$export$a2f81f0e973500f1;
var $7c013f6b793e7c77$export$1ca1ec8b29a4ce27;
var $7c013f6b793e7c77$export$bfd64c937657f93a;
var $7c013f6b793e7c77$export$4a6dd88bada4e7d2;
var $7c013f6b793e7c77$export$5e5b4df997cb5eaa;
var $7c013f6b793e7c77$export$74dc5dd4e622afa8;
$7c013f6b793e7c77$export$a7db06668cad9adb = `MeDZeq_content`;
$7c013f6b793e7c77$export$a3bc9b8ed74fc = `MeDZeq_error`;
$7c013f6b793e7c77$export$a2f81f0e973500f1 = `MeDZeq_fieldButton`;
$7c013f6b793e7c77$export$1ca1ec8b29a4ce27 = `MeDZeq_icon`;
$7c013f6b793e7c77$export$bfd64c937657f93a = `MeDZeq_rotating`;
$7c013f6b793e7c77$export$4a6dd88bada4e7d2 = `MeDZeq_shimmer`;
$7c013f6b793e7c77$export$5e5b4df997cb5eaa = `MeDZeq_tip`;
$7c013f6b793e7c77$export$74dc5dd4e622afa8 = `MeDZeq_trailingIcon`;


function $abc38b470023b326$var$BasicForm({ isAllowEditTarget: isAllowEditTarget, isDarkDefaultVisible: isDarkDefaultVisible, isStandard: isStandard, conflictConnectorName: conflictConnectorName }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const [darkVisible, setDarkVisible] = (0, $eCoWV.useState)(Boolean(isDarkDefaultVisible));
    const toggleDarkVisible = ()=>{
        setDarkVisible((previous)=>!previous);
    };
    const toggleVisibleButtonTitle = darkVisible ? "connectors.guide.logo_dark_collapse" : "connectors.guide.logo_dark_show";
    const ToggleVisibleCaretIcon = darkVisible ? (0, $df1565e9aadd56da$export$2e2bcd8739ae039) : (0, $a35329775620cc91$export$2e2bcd8739ae039);
    const syncProfileOptions = [
        {
            value: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister,
            title: t("connectors.guide.sync_profile_only_at_sign_up")
        },
        {
            value: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn,
            title: t("connectors.guide.sync_profile_each_sign_in")
        }
    ];
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            isStandard && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "connectors.guide.name",
                        tip: t("connectors.guide.name_tip"),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("connectors.guide.name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "connectors.guide.logo",
                        tip: t("connectors.guide.logo_tip"),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("connectors.guide.logo_placeholder"),
                            error: errors.logo?.message,
                            ...register("logo", {
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            })
                        })
                    }),
                    darkVisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "connectors.guide.logo_dark",
                        tip: t("connectors.guide.logo_dark_tip"),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("connectors.guide.logo_dark_placeholder"),
                            error: errors.logoDark?.message,
                            ...register("logoDark", {
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7c013f6b793e7c77$export$a2f81f0e973500f1,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            size: "small",
                            type: "text",
                            title: toggleVisibleButtonTitle,
                            trailingIcon: /*#__PURE__*/ (0, $9zeGj.jsx)(ToggleVisibleCaretIcon, {
                                className: $7c013f6b793e7c77$export$74dc5dd4e622afa8
                            }),
                            onClick: toggleDarkVisible
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                isRequired: isStandard,
                title: "connectors.guide.target",
                tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                href: getDocumentationUrl("/docs/references/connectors/#target"),
                                targetBlank: "noopener",
                                onClick: closeTipHandler
                            })
                        },
                        children: t("connectors.guide.target_tooltip")
                    }),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        placeholder: t("connectors.guide.target_placeholder"),
                        error: Boolean(errors.target),
                        disabled: !isAllowEditTarget,
                        ...register("target", {
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7c013f6b793e7c77$export$5e5b4df997cb5eaa,
                        children: isStandard ? t("connectors.guide.target_tip_standard") : t("connectors.guide.target_tip")
                    }),
                    conflictConnectorName && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $7c013f6b793e7c77$export$a3bc9b8ed74fc,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $7c013f6b793e7c77$export$1ca1ec8b29a4ce27,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hEugJ.default), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $7c013f6b793e7c77$export$a7db06668cad9adb,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                        components: {
                                            span: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                                                resource: conflictConnectorName
                                            })
                                        },
                                        children: t("connectors.guide.target_conflict")
                                    }),
                                    isStandard ? /*#__PURE__*/ (0, $9zeGj.jsxs)("ul", {
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                                    components: {
                                                        span: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                                                            resource: conflictConnectorName
                                                        })
                                                    },
                                                    children: t("connectors.guide.target_conflict_line2")
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                                                children: t("connectors.guide.target_conflict_line3")
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $j9r7N.Trans), {
                                        components: {
                                            span: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                                                resource: conflictConnectorName
                                            })
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("br", {}),
                                            t("connectors.guide.target_conflict_line2")
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "connectors.guide.sync_profile",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "syncProfile",
                        control: control,
                        rules: {
                            required: true
                        },
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                                options: syncProfileOptions,
                                value: value,
                                onChange: onChange
                            })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7c013f6b793e7c77$export$5e5b4df997cb5eaa,
                        children: t("connectors.guide.sync_profile_tip")
                    })
                ]
            })
        ]
    });
}
var $abc38b470023b326$export$2e2bcd8739ae039 = $abc38b470023b326$var$BasicForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("j6dBR");
var $1EA0k = parcelRequire("1EA0k");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $eEyjP = parcelRequire("eEyjP");

var $5irU4 = parcelRequire("5irU4");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $itzs0 = parcelRequire("itzs0");

var $4ytKy = parcelRequire("4ytKy");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $g3kBE = parcelRequire("g3kBE");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $5irU4 = parcelRequire("5irU4");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");


var $5P1O9 = parcelRequire("5P1O9");

var $hdJkM = parcelRequire("hdJkM");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
var $ba28c19eb51f0400$export$34e0f9847d4c02dd;
var $ba28c19eb51f0400$export$a3bc9b8ed74fc;
var $ba28c19eb51f0400$export$bfd64c937657f93a;
var $ba28c19eb51f0400$export$4a6dd88bada4e7d2;
$ba28c19eb51f0400$export$34e0f9847d4c02dd = `pHWkkq_container`;
$ba28c19eb51f0400$export$a3bc9b8ed74fc = `pHWkkq_error`;
$ba28c19eb51f0400$export$bfd64c937657f93a = `pHWkkq_rotating`;
$ba28c19eb51f0400$export$4a6dd88bada4e7d2 = `pHWkkq_shimmer`;


function $db7c365bf8c87e6c$var$Textarea({ className: className, error: error, ...rest }, reference) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($ba28c19eb51f0400$export$34e0f9847d4c02dd, Boolean(error) && $ba28c19eb51f0400$export$a3bc9b8ed74fc, className),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("textarea", {
            ...rest,
            ref: reference
        })
    });
}
var $db7c365bf8c87e6c$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eCoWV.forwardRef)($db7c365bf8c87e6c$var$Textarea);



var $4ytKy = parcelRequire("4ytKy");
var $e2df308004d0ce60$export$6d59db4903f20f7d;
var $e2df308004d0ce60$export$bfd64c937657f93a;
var $e2df308004d0ce60$export$4a6dd88bada4e7d2;
$e2df308004d0ce60$export$6d59db4903f20f7d = `FmIcgq_description`;
$e2df308004d0ce60$export$bfd64c937657f93a = `FmIcgq_rotating`;
$e2df308004d0ce60$export$4a6dd88bada4e7d2 = `FmIcgq_shimmer`;


function $a3ca7bece9746012$var$ConfigFormFields({ formItems: formItems }) {
    const { watch: watch, register: register, control: control, formState: { errors: { formConfig: formConfigErrors } } } = (0, $c3LX9.useFormContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const values = watch("formConfig");
    const showFormItems = (0, $eCoWV.useCallback)((formItem)=>{
        if (!formItem.showConditions) return true;
        return formItem.showConditions.every(({ expectValue: expectValue, targetKey: targetKey })=>{
            const targetValue = values[targetKey];
            return targetValue === expectValue;
        });
    }, [
        values
    ]);
    const renderFormItem = (item)=>{
        const errorMessage = formConfigErrors?.[item.key]?.message;
        const error = typeof errorMessage === "string" && errorMessage.length > 0 ? errorMessage : Boolean(formConfigErrors?.[item.key]);
        const buildCommonProperties = ()=>({
                ...register(`formConfig.${item.key}`, {
                    required: item.required,
                    valueAsNumber: item.type === (0, $g3kBE.ConnectorConfigFormItemType).Number
                }),
                placeholder: item.placeholder,
                error: error
            });
        if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Text) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
            ...buildCommonProperties(),
            // TODO: update connectors form config and remove RegExp check
            isConfidential: item.isConfidential ?? /(Key|Secret)$/.test(item.key)
        });
        if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).MultilineText) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $db7c365bf8c87e6c$export$2e2bcd8739ae039), {
            rows: 5,
            ...buildCommonProperties()
        });
        if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Number) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
            type: "number",
            ...buildCommonProperties()
        });
        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
            name: `formConfig.${item.key}`,
            control: control,
            rules: {
                // For switch, "false" will be treated as an empty value, so we need to set required to false.
                required: item.type === (0, $g3kBE.ConnectorConfigFormItemType).Switch ? false : item.required,
                validate: item.type === (0, $g3kBE.ConnectorConfigFormItemType).Json ? (value)=>typeof value === "string" && (0, $4ytKy.jsonValidator)(value) || t("errors.invalid_json_format") : undefined
            },
            render: ({ field: { onChange: onChange, value: value } })=>{
                if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Switch) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                    label: item.label,
                    checked: typeof value === "boolean" ? value : false,
                    onChange: ({ currentTarget: { checked: checked } })=>{
                        onChange(checked);
                    }
                });
                if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Select) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                    options: item.selectItems,
                    value: typeof value === "string" ? value : undefined,
                    error: error,
                    onChange: onChange
                });
                if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Json) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                    language: "json",
                    error: error,
                    value: typeof value === "string" ? value : "{}",
                    onChange: onChange
                });
                // Default (unknown) type is "Text"
                // This will happen when connector's version is ahead of AC
                return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    error: error,
                    value: typeof value === "string" ? value : "",
                    onChange: onChange
                });
            }
        });
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: formItems.map((item)=>showFormItems(item) ? /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                isRequired: item.required,
                // Tooltip is currently string and does not support i18n.
                tip: item.tooltip,
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                    children: item.type !== (0, $g3kBE.ConnectorConfigFormItemType).Switch && item.label
                }),
                children: [
                    renderFormItem(item),
                    Boolean(item.description) && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $e2df308004d0ce60$export$6d59db4903f20f7d,
                        children: item.description
                    })
                ]
            }, item.key) : null)
    });
}
var $a3ca7bece9746012$export$2e2bcd8739ae039 = $a3ca7bece9746012$var$ConfigFormFields;


var $345cf51517a8b9f1$export$2cdf1b96a9f86d16;
var $345cf51517a8b9f1$export$6d59db4903f20f7d;
var $345cf51517a8b9f1$export$bfd64c937657f93a;
var $345cf51517a8b9f1$export$4a6dd88bada4e7d2;
$345cf51517a8b9f1$export$2cdf1b96a9f86d16 = `ne1fZq_copyToClipboard`;
$345cf51517a8b9f1$export$6d59db4903f20f7d = `ne1fZq_description`;
$345cf51517a8b9f1$export$bfd64c937657f93a = `ne1fZq_rotating`;
$345cf51517a8b9f1$export$4a6dd88bada4e7d2 = `ne1fZq_shimmer`;


function $184a57a617ef81e1$var$ConfigForm({ formItems: formItems, className: className, connectorId: connectorId, connectorType: connectorType }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { data: customDomain, applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    const callbackUri = new URL(`/callback/${connectorId}`, tenantEndpoint).toString();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: className,
        children: [
            connectorType === (0, $fU2Vo.ConnectorType).Social && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "connectors.guide.callback_uri",
                tip: t("connectors.guide.callback_uri_description"),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        className: $345cf51517a8b9f1$export$2cdf1b96a9f86d16,
                        variant: "border",
                        value: applyCustomDomain(callbackUri)
                    }),
                    customDomain?.status === (0, $1EA0k.DomainStatus).Active && tenantEndpoint && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $345cf51517a8b9f1$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "domain.custom_social_callback_url_note",
                            interpolation: {
                                custom: customDomain.domain,
                                default: new URL(tenantEndpoint).host
                            }
                        })
                    })
                ]
            }),
            formItems ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a3ca7bece9746012$export$2e2bcd8739ae039), {
                formItems: formItems
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "connectors.guide.config",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                    name: "jsonConfig",
                    control: control,
                    rules: {
                        validate: (value)=>(0, $4ytKy.jsonValidator)(value) || t("errors.invalid_json_format")
                    },
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                            error: errors.jsonConfig?.message ?? Boolean(errors.jsonConfig),
                            language: "json",
                            value: value,
                            onChange: onChange
                        })
                })
            })
        ]
    });
}
var $184a57a617ef81e1$export$2e2bcd8739ae039 = $184a57a617ef81e1$var$ConfigForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $4at8B = parcelRequire("4at8B");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");

var $6PcpQ = parcelRequire("6PcpQ");

var $bSFEw = parcelRequire("bSFEw");

var $f02c276c756283a8$export$6d59db4903f20f7d;
var $f02c276c756283a8$export$a3bc9b8ed74fc;
var $f02c276c756283a8$export$4dbdc8f16fed8a34;
var $f02c276c756283a8$export$bfd64c937657f93a;
var $f02c276c756283a8$export$89db4734f6c919c4;
var $f02c276c756283a8$export$4a6dd88bada4e7d2;
var $f02c276c756283a8$export$c54b92c0bb02ba64;
$f02c276c756283a8$export$6d59db4903f20f7d = `MRFoga_description`;
$f02c276c756283a8$export$a3bc9b8ed74fc = `MRFoga_error`;
$f02c276c756283a8$export$4dbdc8f16fed8a34 = `MRFoga_fields`;
$f02c276c756283a8$export$bfd64c937657f93a = `MRFoga_rotating`;
$f02c276c756283a8$export$89db4734f6c919c4 = `MRFoga_send`;
$f02c276c756283a8$export$4a6dd88bada4e7d2 = `MRFoga_shimmer`;
$f02c276c756283a8$export$c54b92c0bb02ba64 = `MRFoga_textField`;


function $98c5fac4dd0dbfcd$var$ConnectorTester({ connectorFactoryId: connectorFactoryId, connectorType: connectorType, className: className, parse: parse, updateUsage: updateUsage }) {
    const [showTooltip, setShowTooltip] = (0, $eCoWV.useState)(false);
    const { handleSubmit: handleSubmit, register: register, formState: { errors: { sendTo: inputError }, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)();
    const { trigger: trigger } = (0, $c3LX9.useFormContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $2ANSb.default)();
    const isSms = connectorType === (0, $fU2Vo.ConnectorType).Sms;
    const isEmailServiceConnector = connectorFactoryId === (0, $4at8B.ServiceConnector).Email;
    (0, $eCoWV.useEffect)(()=>{
        if (!showTooltip) return;
        const tooltipTimeout = setTimeout(()=>{
            setShowTooltip(false);
        }, 2000);
        return ()=>{
            clearTimeout(tooltipTimeout);
        };
    }, [
        showTooltip
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        const isConfigFormValid = await trigger(undefined, {
            shouldFocus: true
        });
        if (!isConfigFormValid) return;
        const { sendTo: sendTo } = formData;
        const data = {
            config: parse(),
            ...isSms ? {
                phone: (0, $75ee91b14347449d$export$da44e4eaa54bc82e)(sendTo)
            } : {
                email: sendTo
            }
        };
        await api.post(`api/connectors/${connectorFactoryId}/test`, {
            json: data
        }).json();
        updateUsage?.();
        setShowTooltip(true);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $f02c276c756283a8$export$4dbdc8f16fed8a34,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: isSms ? "connector_details.test_sms_sender" : "connector_details.test_email_sender",
                        className: $f02c276c756283a8$export$c54b92c0bb02ba64,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            error: Boolean(inputError),
                            type: isSms ? "tel" : "email",
                            placeholder: isSms ? t("connector_details.test_sms_placeholder") : t("connector_details.test_email_placeholder"),
                            onKeyDown: (0, $6PcpQ.onKeyDownHandler)({
                                Enter: onSubmit
                            }),
                            ...register("sendTo", {
                                required: true,
                                pattern: {
                                    value: isSms ? (0, $dQcUe.phoneInputRegEx) : (0, $dQcUe.emailRegEx),
                                    message: t("connector_details.send_error_invalid_format")
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                        isKeepOpen: true,
                        isSuccessful: true,
                        anchorClassName: $f02c276c756283a8$export$89db4734f6c919c4,
                        content: (0, $5CQIb.conditional)(showTooltip && t("connector_details.test_message_sent")),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            isLoading: isSubmitting,
                            title: "connector_details.send",
                            type: "outline",
                            onClick: onSubmit
                        })
                    })
                ]
            }),
            !isEmailServiceConnector && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f02c276c756283a8$export$6d59db4903f20f7d,
                children: t("connector_details.test_sender_description")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f02c276c756283a8$export$a3bc9b8ed74fc,
                children: inputError?.message
            })
        ]
    });
}
var $98c5fac4dd0dbfcd$export$2e2bcd8739ae039 = $98c5fac4dd0dbfcd$var$ConnectorTester;






var $2ANSb = parcelRequire("2ANSb");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("j7Jj8");
var $g3kBE = parcelRequire("g3kBE");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");


var $5a1Rp = parcelRequire("5a1Rp");
const $f8b42fae3873d986$var$initFormData = (formItems, config)=>{
    const data = formItems.map((item)=>{
        const value = config?.[item.key] ?? item.defaultValue;
        if (item.type === (0, $g3kBE.ConnectorConfigFormItemType).Json) return [
            item.key,
            JSON.stringify(value, null, 2)
        ];
        return [
            item.key,
            value
        ];
    });
    return Object.fromEntries(data);
};
const $f8b42fae3873d986$export$938064bb4218f4f0 = (config, formItems)=>{
    return Object.fromEntries(Object.entries(config).map(([key, value])=>{
        // Filter out empty input
        if (value === "") return null;
        const formItem = formItems.find((item)=>item.key === key);
        if (!formItem) return null;
        if (formItem.type === (0, $g3kBE.ConnectorConfigFormItemType).Number) /**
           * When set ReactHookForm valueAsNumber to true, the number input field
           * will return number value. If the input can not be properly converted
           * to number value, it will return NaN instead.
           */ // The number input my return string value.
        return Number.isNaN(value) ? null : [
            key,
            Number(value)
        ];
        if (formItem.type === (0, $g3kBE.ConnectorConfigFormItemType).Json) {
            // The JSON validation is done in the form
            const result = (0, $5a1Rp.safeParseJson)(typeof value === "string" ? value : "");
            return [
                key,
                result.success ? result.data : {}
            ];
        }
        return [
            key,
            value
        ];
    }).filter((item)=>Array.isArray(item)));
};
const $f8b42fae3873d986$export$6dae40d70e178ce1 = (connector)=>{
    const { metadata: metadata, type: type, config: config, syncProfile: syncProfile, isStandard: isStandard, formItems: formItems, target: target } = connector;
    const { name: name, logo: logo, logoDark: logoDark } = metadata;
    const formConfig = (0, $5CQIb.conditional)(formItems && $f8b42fae3873d986$var$initFormData(formItems, config)) ?? {};
    return {
        name: name?.en,
        logo: logo,
        logoDark: logoDark,
        target: (0, $5CQIb.conditional)(type === (0, $fU2Vo.ConnectorType).Social && (isStandard ? target : metadata.target ?? target)),
        syncProfile: syncProfile ? (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn : (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister,
        jsonConfig: JSON.stringify(config, null, 2),
        formConfig: formConfig
    };
};
const $f8b42fae3873d986$export$7bb2f28ad6c44e46 = (connectorFactory)=>{
    const { formItems: formItems, configTemplate: configTemplate, type: type, isStandard: isStandard, target: target } = connectorFactory;
    const jsonConfig = configTemplate ?? "{}";
    const formConfig = (0, $5CQIb.conditional)(formItems && $f8b42fae3873d986$var$initFormData(formItems)) ?? {};
    return {
        target: (0, $5CQIb.conditional)(type === (0, $fU2Vo.ConnectorType).Social && !isStandard && target),
        syncProfile: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister,
        jsonConfig: jsonConfig,
        formConfig: formConfig
    };
};



var $5a1Rp = parcelRequire("5a1Rp");
const $a7cfa996bbe47dd1$var$useJsonStringConfigParser = ()=>{
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return (config)=>{
        if (!config) {
            (0, $horhC.toast).error(t("connector_details.save_error_empty_config"));
            return;
        }
        const result = (0, $5a1Rp.safeParseJson)(config);
        if (!result.success) {
            (0, $horhC.toast).error(result.error);
            return;
        }
        return result.data;
    };
};
const $a7cfa996bbe47dd1$export$4c86d49e765c99cd = ()=>{
    const parseJsonConfig = $a7cfa996bbe47dd1$var$useJsonStringConfigParser();
    return (data, formItems)=>{
        return formItems ? (0, $f8b42fae3873d986$export$938064bb4218f4f0)(data.formConfig, formItems) : parseJsonConfig(data.jsonConfig);
    };
};






var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $8shoi = parcelRequire("8shoi");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2CYkO = parcelRequire("2CYkO");


var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");




var $4ytKy = parcelRequire("4ytKy");
var $7daffe537c8e0f4e$export$6d59db4903f20f7d;
var $7daffe537c8e0f4e$export$bfd64c937657f93a;
var $7daffe537c8e0f4e$export$4a6dd88bada4e7d2;
$7daffe537c8e0f4e$export$6d59db4903f20f7d = `FnKWBW_description`;
$7daffe537c8e0f4e$export$bfd64c937657f93a = `FnKWBW_rotating`;
$7daffe537c8e0f4e$export$4a6dd88bada4e7d2 = `FnKWBW_shimmer`;


const $7d596a8139904ae9$var$extraInfoGuard = (0, $2CYkO.z).object({
    fromEmail: (0, $2CYkO.z).string()
});
/**
 * Note:
 * This `EmailServiceConnectorForm` is hard-coded since the custom connector config form does not support i18n and we need i18n for our built-in connectors.
 *
 * TODO: @xiaoyijun @darcyYe remove this hard-coded form once the custom connector config form supports i18n.
 */ function $7d596a8139904ae9$var$EmailServiceConnectorForm({ extraInfo: extraInfo }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const parsedExtraInfo = $7d596a8139904ae9$var$extraInfoGuard.safeParse(extraInfo ?? {});
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { control: control, register: register, formState: { errors: { formConfig: fromConfigErrors } } } = (0, $c3LX9.useFormContext)();
    const validateInput = (value)=>{
        const containUrl = (0, $8shoi.urlRegEx).test(value);
        return containUrl ? t("connector_details.logto_email.urls_not_allowed") : true;
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "connector_details.logto_email.email_template_title",
        description: "connector_details.logto_email.template_description",
        learnMoreLink: {
            href: getDocumentationUrl("/docs/recipes/configure-connectors/email-connector/configure-logto-email-service/#unified-email-templates"),
            targetBlank: "noopener",
            linkText: "connector_details.logto_email.template_description_link_text"
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "connector_details.logto_email.from_email_field",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    readOnly: true,
                    value: (0, $5CQIb.conditionalString)(parsedExtraInfo.success && parsedExtraInfo.data.fromEmail)
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "connector_details.logto_email.sender_name_field",
                tip: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "connector_details.logto_email.sender_name_tip"
                }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("formConfig.senderName", {
                        validate: (value)=>validateInput((0, $5CQIb.conditionalString)(value))
                    }),
                    error: fromConfigErrors?.senderName?.message,
                    placeholder: t("connector_details.logto_email.sender_name_placeholder")
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "connector_details.logto_email.company_information_field",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        ...register("formConfig.companyInformation", {
                            validate: (value)=>validateInput((0, $5CQIb.conditionalString)(value))
                        }),
                        error: fromConfigErrors?.companyInformation?.message,
                        placeholder: t("connector_details.logto_email.company_information_placeholder")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $7daffe537c8e0f4e$export$6d59db4903f20f7d,
                        children: t("connector_details.logto_email.company_information_description")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "connector_details.logto_email.app_logo_field",
                tip: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "connector_details.logto_email.app_logo_tip"
                }),
                headlineSpacing: isUserAssetsServiceReady ? "large" : "default",
                children: isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                    name: "formConfig.appLogo",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $0186093e59e66ade$export$2e2bcd8739ae039), {
                            name: name,
                            allowedMimeTypes: [
                                "image/png",
                                "image/jpeg"
                            ],
                            value: (0, $5CQIb.conditionalString)(value),
                            onChange: onChange
                        })
                }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("formConfig.appLogo", {
                        validate: (value)=>!value || (0, $4ytKy.uriValidator)((0, $5CQIb.conditionalString)(value)) || t("errors.invalid_uri_format")
                    }),
                    error: fromConfigErrors?.appLogo?.message
                })
            })
        ]
    });
}
var $7d596a8139904ae9$export$2e2bcd8739ae039 = $7d596a8139904ae9$var$EmailServiceConnectorForm;


function $6ffb1f428283921c$var$ConnectorContent({ isDeleted: isDeleted, connectorData: connectorData, onConnectorUpdated: onConnectorUpdated }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const api = (0, $2ANSb.default)();
    const formData = (0, $eCoWV.useMemo)(()=>(0, $f8b42fae3873d986$export$6dae40d70e178ce1)(connectorData), [
        connectorData
    ]);
    const methods = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur",
        defaultValues: {
            ...formData,
            /**
       * Note:
       * The `formConfig` will be setup in the `useEffect` hook since react-hook-form's `useForm` hook infers `Record<string, unknown>` to `{ [x: string]: {} | undefined }` incorrectly,
       * this causes we cannot apply the default value of `formConfig` to the form.
       */ formConfig: {}
        }
    });
    const { formState: { isSubmitting: isSubmitting, isDirty: isDirty }, handleSubmit: handleSubmit, watch: watch, reset: reset } = methods;
    const { id: id, connectorId: connectorId, type: connectorType, formItems: formItems, isStandard: isStandardConnector, metadata: { logoDark: logoDark } } = connectorData;
    const isSocialConnector = connectorType === (0, $fU2Vo.ConnectorType).Social;
    const isEmailServiceConnector = connectorId === (0, $4at8B.ServiceConnector).Email;
    (0, $eCoWV.useEffect)(()=>{
        /**
     * Note: should not refresh form data when the form is dirty.
     */ if (isDirty) return;
        reset(formData);
    }, [
        formData,
        isDirty,
        reset
    ]);
    const configParser = (0, $a7cfa996bbe47dd1$export$4c86d49e765c99cd)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        const { formItems: formItems, isStandard: isStandard, id: id } = connectorData;
        const config = configParser(data, formItems);
        const { syncProfile: syncProfile, name: name, logo: logo, logoDark: logoDark, target: target } = data;
        const payload = isSocialConnector ? {
            config: config,
            syncProfile: syncProfile === (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn
        } : {
            config: config
        };
        const standardConnectorPayload = {
            ...payload,
            metadata: {
                name: {
                    en: name
                },
                logo: logo,
                logoDark: logoDark,
                target: target
            }
        };
        // Should not update `target` for neither passwordless connectors nor non-standard social connectors.
        const body = isStandard ? standardConnectorPayload : {
            ...payload,
            target: undefined
        };
        const updatedConnector = await api.patch(`api/connectors/${id}`, {
            json: body
        }).json();
        /**
       * Note: reset form dirty state before updating the form data.
       */ reset((0, $f8b42fae3873d986$export$6dae40d70e178ce1)(updatedConnector));
        onConnectorUpdated(updatedConnector);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    const updateUsage = (0, $eCoWV.useCallback)(()=>{
        if (connectorData.usage === undefined) return;
        onConnectorUpdated();
    }, [
        connectorData,
        onConnectorUpdated
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c3LX9.FormProvider), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                autoComplete: "off",
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: ()=>{
                    reset();
                },
                onSubmit: onSubmit,
                children: [
                    isSocialConnector && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "connector_details.settings",
                        description: "connector_details.settings_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/references/connectors"),
                            targetBlank: "noopener"
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $abc38b470023b326$export$2e2bcd8739ae039), {
                            isStandard: isStandardConnector,
                            isDarkDefaultVisible: Boolean(logoDark)
                        })
                    }),
                    isEmailServiceConnector ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d596a8139904ae9$export$2e2bcd8739ae039), {
                        extraInfo: connectorData.extraInfo
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "connector_details.parameter_configuration",
                        description: (0, $5CQIb.conditional)(!isSocialConnector && "connector_details.settings_description"),
                        learnMoreLink: (0, $5CQIb.conditional)(!isSocialConnector && {
                            href: getDocumentationUrl("/docs/references/connectors"),
                            targetBlank: "noopener"
                        }),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $184a57a617ef81e1$export$2e2bcd8739ae039), {
                            formItems: formItems,
                            connectorId: id,
                            connectorType: connectorType
                        })
                    }),
                    !isSocialConnector && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "connector_details.test_connection",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c5fac4dd0dbfcd$export$2e2bcd8739ae039), {
                            connectorFactoryId: connectorId,
                            connectorType: connectorType,
                            parse: ()=>configParser(watch(), formItems),
                            updateUsage: updateUsage
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $6ffb1f428283921c$export$2e2bcd8739ae039 = $6ffb1f428283921c$var$ConnectorContent;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $86S23 = parcelRequire("86S23");
var $fU2Vo = parcelRequire("fU2Vo");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $8pPfi = parcelRequire("8pPfi");

var $2mi28 = parcelRequire("2mi28");
parcelRequire("6ZMK7");
var $kiVDZ = parcelRequire("kiVDZ");

var $emGEN = parcelRequire("emGEN");

var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $86S23 = parcelRequire("86S23");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b339f5a1242ef3aa$var$SvgConnectorPlatformIconUniversal = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M6.667 3.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334ZM4 3.333a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm5.333 0a.667.667 0 1 0 0 1.334.667.667 0 0 0 0-1.334Zm4-2.666H2.667a2 2 0 0 0-2 2v10.666a2 2 0 0 0 2 2h10.666a2 2 0 0 0 2-2V2.667a2 2 0 0 0-2-2ZM14 13.333a.667.667 0 0 1-.667.667H2.667A.667.667 0 0 1 2 13.333v-6h12v6ZM14 6H2V2.667A.667.667 0 0 1 2.667 2h10.666a.667.667 0 0 1 .667.667V6Z",
            fill: "currentColor"
        })
    });
var $b339f5a1242ef3aa$export$2e2bcd8739ae039 = $b339f5a1242ef3aa$var$SvgConnectorPlatformIconUniversal;



function $b1a590d94aaaa586$var$ConnectorPlatformIcon({ platform: platform }) {
    if (platform === (0, $86S23.ConnectorPlatform).Native) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d190ad56074c82c0$export$2e2bcd8739ae039), {});
    if (platform === (0, $86S23.ConnectorPlatform).Web) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f5b4c873e7b02225$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b339f5a1242ef3aa$export$2e2bcd8739ae039), {});
}
var $b1a590d94aaaa586$export$2e2bcd8739ae039 = $b1a590d94aaaa586$var$ConnectorPlatformIcon;


var $a656cb5ad04f4b4b$export$89da14300d534261;
var $a656cb5ad04f4b4b$export$1ca1ec8b29a4ce27;
var $a656cb5ad04f4b4b$export$bfd64c937657f93a;
var $a656cb5ad04f4b4b$export$4a6dd88bada4e7d2;
var $a656cb5ad04f4b4b$export$62d58b1c91e8e902;
var $a656cb5ad04f4b4b$export$39f5674517ec0000;
$a656cb5ad04f4b4b$export$89da14300d534261 = `O1NQ5W_active`;
$a656cb5ad04f4b4b$export$1ca1ec8b29a4ce27 = `O1NQ5W_icon`;
$a656cb5ad04f4b4b$export$bfd64c937657f93a = `O1NQ5W_rotating`;
$a656cb5ad04f4b4b$export$4a6dd88bada4e7d2 = `O1NQ5W_shimmer`;
$a656cb5ad04f4b4b$export$62d58b1c91e8e902 = `O1NQ5W_tab`;
$a656cb5ad04f4b4b$export$39f5674517ec0000 = `O1NQ5W_tabs`;


function $2b81581589ee1aa2$var$ConnectorTabs({ target: target, connectorId: connectorId }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectors } = (0, $2mi28.default)(`api/connectors?target=${target}`);
    const { getTo: getTo } = (0, $4W0F0.default)();
    if (!connectors) return null;
    if (connectors.length === 0) return null;
    if (connectors.length === 1 && connectors[0]?.platform === (0, $86S23.ConnectorPlatform).Universal) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $a656cb5ad04f4b4b$export$39f5674517ec0000,
        children: connectors.map((connector)=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $8pPfi.Link), {
                to: getTo(`/connectors/${connector.type === (0, $fU2Vo.ConnectorType).Social ? (0, $emGEN.ConnectorsTabs).Social : (0, $emGEN.ConnectorsTabs).Passwordless}/${connector.id}`),
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($a656cb5ad04f4b4b$export$62d58b1c91e8e902, connector.id === connectorId && $a656cb5ad04f4b4b$export$89da14300d534261),
                children: [
                    connector.platform && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $a656cb5ad04f4b4b$export$1ca1ec8b29a4ce27,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b1a590d94aaaa586$export$2e2bcd8739ae039), {
                            platform: connector.platform
                        })
                    }),
                    connector.platform && t((0, $kiVDZ.connectorPlatformLabel)[connector.platform])
                ]
            }, connector.id))
    });
}
var $2b81581589ee1aa2$export$2e2bcd8739ae039 = $2b81581589ee1aa2$var$ConnectorTabs;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

function $21290f9244d9c123$var$ConnectorTypeName({ type: type }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        children: [
            type === (0, $fU2Vo.ConnectorType).Email && t("connector_details.type_email"),
            type === (0, $fU2Vo.ConnectorType).Sms && t("connector_details.type_sms"),
            type === (0, $fU2Vo.ConnectorType).Social && t("connector_details.type_social")
        ]
    });
}
var $21290f9244d9c123$export$2e2bcd8739ae039 = $21290f9244d9c123$var$ConnectorTypeName;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $047ebb669ea113ac$var$SvgEmailSentDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.44 3.23 9.6 10.07l-6.838-6.84c.143-.019.29-.029.438-.029H16c.15 0 .296.01.44.03ZM9.6 11.96a.798.798 0 0 1-.605-.234l-7.81-7.81A3.194 3.194 0 0 0 0 6.4V16a3.2 3.2 0 0 0 3.2 3.2H16a3.2 3.2 0 0 0 3.2-3.2V6.4a3.194 3.194 0 0 0-1.183-2.484l-7.81 7.81a.798.798 0 0 1-.606.233Z",
                fill: "url(#paint0_linear_8601_113491)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 18.4,
                cy: 14.4,
                r: 5.6,
                fill: "#68BE6C"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1.603,
                height: 4.808,
                rx: 0.801,
                transform: "rotate(-44.926 24.231 -10.617)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.41,
                height: 1.603,
                rx: 0.801,
                transform: "rotate(-44.926 28.102 -12.23)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_8601_113491",
                    x1: 13.6,
                    y1: 3.2,
                    x2: -1.2,
                    y2: 19.2,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $047ebb669ea113ac$export$2e2bcd8739ae039 = $047ebb669ea113ac$var$SvgEmailSentDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $5a9c71444defd384$var$SvgEmailSent = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M16.44 3.23 9.6 10.069l-6.838-6.84c.143-.019.29-.029.438-.029H16c.15 0 .296.01.44.03ZM9.6 11.958a.798.798 0 0 1-.605-.233l-7.81-7.81A3.194 3.194 0 0 0 0 6.4V16a3.2 3.2 0 0 0 3.2 3.2H16a3.2 3.2 0 0 0 3.2-3.2V6.4a3.194 3.194 0 0 0-1.183-2.485l-7.81 7.81a.798.798 0 0 1-.606.233Z",
                fill: "url(#paint0_linear_271_9123)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 18.4,
                cy: 14.4,
                r: 5.6,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1.603,
                height: 4.808,
                rx: 0.801,
                transform: "rotate(-44.926 24.231 -10.617)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.41,
                height: 1.603,
                rx: 0.801,
                transform: "rotate(-44.926 28.103 -12.23)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_271_9123",
                    x1: 13.6,
                    y1: 3.2,
                    x2: -1.2,
                    y2: 19.2,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#D361E7"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#7D5FF4"
                        })
                    ]
                })
            })
        ]
    });
var $5a9c71444defd384$export$2e2bcd8739ae039 = $5a9c71444defd384$var$SvgEmailSent;



var $ds4Cq = parcelRequire("ds4Cq");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");

var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");


var $93h5F = parcelRequire("93h5F");
var $b46a71c5f16ca448$export$34e0f9847d4c02dd;
var $b46a71c5f16ca448$export$bfd64c937657f93a;
var $b46a71c5f16ca448$export$4a6dd88bada4e7d2;
$b46a71c5f16ca448$export$34e0f9847d4c02dd = `_84lriq_container`;
$b46a71c5f16ca448$export$bfd64c937657f93a = `_84lriq_rotating`;
$b46a71c5f16ca448$export$4a6dd88bada4e7d2 = `_84lriq_shimmer`;


function $3e0d12035490e028$var$EmailUsage({ usage: usage, isCompact: isCompact }) {
    const theme = (0, $93h5F.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $b46a71c5f16ca448$export$34e0f9847d4c02dd,
        children: [
            theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5a9c71444defd384$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $047ebb669ea113ac$export$2e2bcd8739ae039), {}),
            isCompact ? usage : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: "connector_details.logto_email.total_email_sent",
                interpolation: {
                    value: usage
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                content: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                href: getDocumentationUrl("docs/recipes/configure-connectors/email-connector/configure-logto-email-service"),
                                targetBlank: "noopener",
                                onClick: closeTipHandler
                            })
                        },
                        children: t("connector_details.logto_email.total_email_sent_tip")
                    }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                })
            })
        ]
    });
}
var $3e0d12035490e028$export$2e2bcd8739ae039 = $3e0d12035490e028$var$EmailUsage;


var $1ccefac5e70aed96$export$20b6fe5c276910c1;
var $1ccefac5e70aed96$export$bfd64c937657f93a;
var $1ccefac5e70aed96$export$4a6dd88bada4e7d2;
$1ccefac5e70aed96$export$20b6fe5c276910c1 = `ke03AG_readme`;
$1ccefac5e70aed96$export$bfd64c937657f93a = `ke03AG_rotating`;
$1ccefac5e70aed96$export$4a6dd88bada4e7d2 = `ke03AG_shimmer`;


// TODO: refactor path-related operation utils in both Connectors and ConnectorDetails page
const $88f960af93587c98$var$getConnectorsPathname = (isSocial)=>`/connectors/${isSocial ? (0, $emGEN.ConnectorsTabs).Social : (0, $emGEN.ConnectorsTabs).Passwordless}`;
function $88f960af93587c98$var$ConnectorDetails() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { connectorId: connectorId } = (0, $9X5Bp.useParams)();
    const { createConnector: createConnector } = (0, $a159769e424a60ee$export$2e2bcd8739ae039)();
    const { mutate: mutateGlobal } = (0, $4Korf.useSWRConfig)();
    const [isDeleted, setIsDeleted] = (0, $eCoWV.useState)(false);
    const [isReadMeOpen, setIsReadMeOpen] = (0, $eCoWV.useState)(false);
    const [isSetupOpen, setIsSetupOpen] = (0, $eCoWV.useState)(false);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(connectorId && `api/connectors/${connectorId}`, {
        keepPreviousData: true
    });
    const { data: connectorFactory, error: fetchConnectorFactoryError, mutate: mutateConnectorFactory } = (0, $2mi28.default)(data?.isStandard && `api/connector-factories/${data.connectorId}`);
    const requestError = error ?? fetchConnectorFactoryError;
    const { isConnectorInUse: isConnectorInUse } = (0, $23b420b35fae99c8$export$2e2bcd8739ae039)();
    const inUse = isConnectorInUse(data);
    const isLoading = !data && !error || data?.isStandard && !connectorFactory && !fetchConnectorFactoryError;
    const api = (0, $2ANSb.default)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const isSocial = data?.type === (0, $fU2Vo.ConnectorType).Social;
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    (0, $eCoWV.useEffect)(()=>{
        setIsDeleteAlertOpen(false);
    }, [
        pathname
    ]);
    const handleDelete = async ()=>{
        if (!connectorId || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/connectors/${connectorId}`).json();
            setIsDeleted(true);
            (0, $horhC.toast).success(t("connector_details.connector_deleted"));
            await mutateGlobal("api/connectors");
            navigate($88f960af93587c98$var$getConnectorsPathname(isSocial), {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    if (!connectorId) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: $88f960af93587c98$var$getConnectorsPathname(isSocial),
        backLinkTitle: "connector_details.back_to_connectors",
        isLoading: isLoading,
        error: requestError,
        onRetry: ()=>{
            mutate();
            mutateConnectorFactory();
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "connector_details.page_title"
            }),
            isSocial && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2b81581589ee1aa2$export$2e2bcd8739ae039), {
                target: data.target,
                connectorId: data.id
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                            data: data,
                            size: "large"
                        }),
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                            resource: data.name
                        }),
                        primaryTag: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $21290f9244d9c123$export$2e2bcd8739ae039), {
                            type: data.type
                        }),
                        statusTag: {
                            status: inUse ? "success" : "info",
                            text: inUse ? "connectors.connector_status_in_use" : "connectors.connector_status_not_in_use"
                        },
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        additionalActionButton: (0, $5CQIb.conditional)(data.connectorId !== (0, $4at8B.ServiceConnector).Email && {
                            title: "connector_details.check_readme",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7529b38878187ba2$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsReadMeOpen(true);
                            }
                        }),
                        additionalCustomElement: (0, $5CQIb.conditional)(data.type === (0, $fU2Vo.ConnectorType).Email && data.usage !== undefined && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e0d12035490e028$export$2e2bcd8739ae039), {
                            usage: data.usage
                        })),
                        actionMenuItems: [
                            ...(0, $5CQIb.condArray)(!isSocial && [
                                {
                                    title: data.type === (0, $fU2Vo.ConnectorType).Sms ? "connector_details.options_change_sms" : "connector_details.options_change_email",
                                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d8aef6862763847e$export$2e2bcd8739ae039), {}),
                                    onClick: ()=>{
                                        setIsSetupOpen(true);
                                    }
                                }
                            ]),
                            {
                                type: "danger",
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b42f3bf1cd82d7$export$2e2bcd8739ae039), {
                        title: "connectors.title",
                        subtitle: "connectors.subtitle",
                        isOpen: isReadMeOpen,
                        onClose: ()=>{
                            setIsReadMeOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ba19dac3f36add1e$export$2e2bcd8739ae039), {
                            className: $1ccefac5e70aed96$export$20b6fe5c276910c1,
                            children: data.readme
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5942e5adf122c259$export$2e2bcd8739ae039), {
                        isOpen: isSetupOpen,
                        type: data.type,
                        onClose: async (connectorId)=>{
                            setIsSetupOpen(false);
                            if (connectorId) {
                                /**
                 * Note:
                 * The "Email Service Connector" is a built-in connector that can be directly created without the need for setup in the guide.
                 */ if (connectorId === (0, $4at8B.ServiceConnector).Email) {
                                    const created = await createConnector({
                                        connectorId: connectorId
                                    });
                                    navigate(`/connectors/${(0, $emGEN.ConnectorsTabs).Passwordless}/${created.id}`, {
                                        replace: true
                                    });
                                    return;
                                }
                                navigate(`${$88f960af93587c98$var$getConnectorsPathname(isSocial)}/guide/${connectorId}`);
                            }
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: `${$88f960af93587c98$var$getConnectorsPathname(isSocial)}/${connectorId}`,
                            children: t("general.settings_nav")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6ffb1f428283921c$export$2e2bcd8739ae039), {
                        isDeleted: isDeleted,
                        connectorData: data,
                        onConnectorUpdated: (connector)=>{
                            mutate(connector);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $396803ba381ea6b5$export$2e2bcd8739ae039), {
                        data: data,
                        isInUse: inUse,
                        isOpen: isDeleteAlertOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteAlertOpen(false);
                        },
                        onConfirm: handleDelete
                    })
                ]
            })
        ]
    });
}
var $88f960af93587c98$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($88f960af93587c98$var$ConnectorDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j7Jj8");
var $4at8B = parcelRequire("4at8B");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $cc5355640d7be30c$var$SvgSocialConnectorEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M103.585 156H69.048c-19.844 0-36.687 14.548-39.575 34.18L24.5 224H234l-.31-1.013A24 24 0 0 0 210.738 206h-29.086a16.002 16.002 0 0 1-14.154-8.537l-1.662-3.153a29.628 29.628 0 0 0-26.209-15.81h-1.42a12.628 12.628 0 0 1-11.54-7.5 25.258 25.258 0 0 0-23.082-15Z",
                fill: "#41425F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M61 75H30a4 4 0 0 0 0 8h31",
                stroke: "#6669A8",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m26.5 69.5 37-23M114.5 71.5l-40-25M164.5 71.5l-90-25",
                stroke: "#A39BD8",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M87 72h82.597a3 3 0 0 1 1.874.657l10 8c2.214 1.772.962 5.343-1.874 5.343H87a3 3 0 0 1-3-3v-8a3 3 0 0 1 3-3Z",
                stroke: "#6669A8",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                fill: "#7B7EBB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_503_14464",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 42,
                y: 96,
                width: 56,
                height: 128,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                    fill: "#3F375A"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_503_14464)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 130.268 62.354-36 1 1.732-62.354 36zM34 133h72v2H34zM34 172.732h72v2H34z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 170.268 62.354-36 1 1.732-62.354 36zM39.822 210.268l62.354-36 1 1.732-62.354 36zM39.822 97.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#6669A8",
                        d: "m39.822 137.732 62.354 36 1-1.732-62.354-36zM39.822 177.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M47.5 93.5h21l-1 130.5H-1L47.5 93.5Z",
                        fill: "url(#paint0_linear_503_14464)",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M62.694 46.668A4 4 0 0 1 66.68 43h4.64a4 4 0 0 1 3.986 3.668l3.333 40A4 4 0 0 1 74.653 91H63.347a4 4 0 0 1-3.986-4.332l3.333-40Z",
                fill: "#7B7EBB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 70,
                y: 67,
                width: 24,
                height: 24,
                rx: 6,
                fill: "url(#paint1_linear_503_14464)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 18,
                y: 67,
                width: 16,
                height: 24,
                rx: 4,
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M170 200.667a3.333 3.333 0 1 1 0 6.666h-43.333v-6.666H170Z",
                fill: "#746A9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 197.333a6 6 0 0 1 6 6v1.334a6 6 0 0 1-6 6h-14.667a6 6 0 0 1-6-6v-1.334a6 6 0 0 1 6-6H184Z",
                fill: "#B780FE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M113.333 184c9.205 0 16.667 7.462 16.667 16.667v6.666c0 9.205-7.462 16.667-16.667 16.667H66.667C57.462 224 50 216.538 50 207.333v-6.666C50 191.462 57.462 184 66.667 184h46.666Z",
                fill: "url(#paint2_linear_503_14464)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116.666,
                y: 195,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 195)",
                fill: "#DA9FFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116.666,
                y: 207.333,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 207.333)",
                fill: "#DA9FFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 214,
                cy: 56,
                r: 20,
                fill: "#696B97"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m208 46 16 10-16 10",
                stroke: "#40456D",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 224,
                cy: 56,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 208,
                cy: 66,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 208,
                cy: 46,
                r: 4,
                fill: "#B19EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 154,
                cy: 124,
                r: 20,
                fill: "#696B97"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154 110.996a13.33 13.33 0 0 0-13.161 11.198 13.332 13.332 0 0 0 8.944 14.785c.667.117.917-.283.917-.633 0-.317-.017-1.367-.017-2.484-3.35.617-4.216-.816-4.483-1.566a4.848 4.848 0 0 0-1.367-1.884c-.466-.25-1.133-.866-.016-.883a2.672 2.672 0 0 1 2.05 1.367 2.84 2.84 0 0 0 1.713 1.355 2.832 2.832 0 0 0 2.17-.255 2.81 2.81 0 0 1 .85-1.784c-2.967-.333-6.067-1.483-6.067-6.583a5.185 5.185 0 0 1 1.367-3.583 4.793 4.793 0 0 1 .133-3.534s1.117-.35 3.667 1.367c2.182-.6 4.485-.6 6.667 0 2.55-1.733 3.666-1.367 3.666-1.367a4.793 4.793 0 0 1 .134 3.534 5.156 5.156 0 0 1 1.366 3.583c0 5.117-3.116 6.25-6.083 6.583a3.158 3.158 0 0 1 .9 2.467c0 1.783-.017 3.217-.017 3.667 0 .35.25.766.917.633a13.336 13.336 0 0 0 8.908-14.796A13.336 13.336 0 0 0 154 110.996Z",
                fill: "#BFBEF0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 126,
                cy: 24,
                r: 16,
                fill: "#615984"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M136.666 24c0-5.892-4.775-10.667-10.667-10.667-5.891 0-10.666 4.775-10.666 10.667 0 5.325 3.9 9.737 9 10.538v-7.455h-2.709V24h2.709v-2.35c0-2.673 1.591-4.15 4.029-4.15 1.166 0 2.387.208 2.387.208v2.625h-1.346c-1.325 0-1.737.823-1.737 1.667v2h2.958l-.473 3.083h-2.485v7.455c5.1-.8 9-5.213 9-10.538Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m130.151 27.083.473-3.083h-2.958v-2c0-.844.412-1.667 1.737-1.667h1.346v-2.625s-1.221-.208-2.387-.208c-2.438 0-4.03 1.477-4.03 4.15V24h-2.708v3.083h2.708v7.455a10.736 10.736 0 0 0 3.334 0v-7.455h2.485Z",
                fill: "#F0EDFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M246 172c0-5.072-1.888-9.703-5-13.229a20.065 20.065 0 0 0-7-5.107M212.771 157a20.079 20.079 0 0 0-4.095 5A19.87 19.87 0 0 0 206 172a19.89 19.89 0 0 0 2.676 10 20.088 20.088 0 0 0 7.634 7.5A19.909 19.909 0 0 0 226 192c3.516 0 6.819-.907 9.69-2.5a20.098 20.098 0 0 0 6.675-6M219 153.259c-.863.323-1.698.703-2.5 1.137",
                stroke: "#AF9EFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M237.52 172.273c0-.851-.076-1.669-.218-2.455H226v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.269-2.089 3.578-5.166 3.578-8.82Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 184c3.24 0 5.956-1.075 7.941-2.907l-3.878-3.011c-1.074.72-2.449 1.145-4.063 1.145-3.126 0-5.771-2.111-6.715-4.947h-4.009v3.109A11.995 11.995 0 0 0 226 184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.285 174.28a7.213 7.213 0 0 1-.376-2.28c0-.791.136-1.56.376-2.28v-3.109h-4.009A12.005 12.005 0 0 0 214 172c0 1.936.464 3.769 1.276 5.389l4.009-3.109Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 164.773c1.761 0 3.343.605 4.587 1.794l3.442-3.442C231.95 161.189 229.234 160 226 160c-4.691 0-8.75 2.689-10.724 6.611l4.009 3.109c.944-2.836 3.589-4.947 6.715-4.947Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 153,
                cy: 180,
                r: 8,
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 34,
                cy: 34,
                r: 7,
                stroke: "#E0E3E3",
                strokeWidth: 2,
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 238,
                cy: 104,
                r: 4,
                fill: "#9FE79F",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#C093C0",
                d: "m198.311 125 7.283 3.311-3.312 7.283-7.282-3.311z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#79709C",
                d: "M168 46.212 174.07 41l5.211 6.07-6.07 5.212z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m15.629 125 1.011 2.641a2.828 2.828 0 0 0 3.653 1.63v0a2.829 2.829 0 0 1 3.653 1.63v0a2.828 2.828 0 0 0 3.653 1.63v0a2.828 2.828 0 0 1 3.653 1.63l1.011 2.641",
                stroke: "#9F96CD",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_503_14464",
                        x1: 37.5,
                        y1: 224,
                        x2: 69,
                        y2: 91.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#ADAAB4"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ADAAB4",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_503_14464",
                        x1: 67.5,
                        y1: 82.5,
                        x2: 90.125,
                        y2: 68.123,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#DA8CFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_503_14464",
                        x1: 24,
                        y1: 214.5,
                        x2: 132.815,
                        y2: 216.789,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D376FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $cc5355640d7be30c$export$2e2bcd8739ae039 = $cc5355640d7be30c$var$SvgSocialConnectorEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f029a1af34cbac2d$var$SvgSocialConnectorEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M103.585 156H69.048c-19.844 0-36.687 14.548-39.575 34.18L24.5 224H234l-.31-1.013A24 24 0 0 0 210.738 206h-29.086a16.002 16.002 0 0 1-14.154-8.537l-1.662-3.153a29.628 29.628 0 0 0-26.209-15.81h-1.42a12.628 12.628 0 0 1-11.54-7.5 25.258 25.258 0 0 0-23.082-15Z",
                fill: "#5D34F2",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m26.5 69.5 37-23M114.5 71.5l-40-25",
                stroke: "#E5E1EC",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M61 75H30a4 4 0 0 0 0 8h31",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m164.5 71.5-90-25",
                stroke: "#E5E1EC",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M84 75a3 3 0 0 1 3-3h82.597a3 3 0 0 1 1.874.657l10 8c2.214 1.772.962 5.343-1.874 5.343H87a3 3 0 0 1-3-3v-8Z",
                stroke: "#C9C5D0",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_8614_113852",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 42,
                y: 96,
                width: 56,
                height: 128,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M45.818 101.813A6 6 0 0 1 51.815 96h36.37a6 6 0 0 1 5.997 5.813l3.625 116A6 6 0 0 1 91.81 224H48.19a6 6 0 0 1-5.997-6.187l3.625-116Z",
                    fill: "#3F375A"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                mask: "url(#mask0_8614_113852)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 130.268 62.354-36 1 1.732-62.354 36zM34 133h72v2H34zM34 172.732h72v2H34z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 170.268 62.354-36 1 1.732-62.354 36zM39.822 210.268l62.354-36 1 1.732-62.354 36zM39.822 97.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#AF9EFF",
                        d: "m39.822 137.732 62.354 36 1-1.732-62.354-36zM39.822 177.732l62.354 36 1-1.732-62.354-36z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M47.5 93.5h21l-1 130.5H-1L47.5 93.5Z",
                        fill: "#E6DEFF",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M62.694 46.668A4 4 0 0 1 66.68 43h4.64a4 4 0 0 1 3.986 3.668l3.333 40A4 4 0 0 1 74.653 91H63.347a4 4 0 0 1-3.986-4.332l3.333-40Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 70,
                y: 67,
                width: 24,
                height: 24,
                rx: 6,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 18,
                y: 67,
                width: 16,
                height: 24,
                rx: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M170.001 200.667a3.333 3.333 0 1 1 0 6.667h-43.334v-6.667h43.334Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 197.333a6 6 0 0 1 6 6v1.333a6 6 0 0 1-6 6h-14.667a6 6 0 0 1-6-6v-1.333a6 6 0 0 1 6-6H184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M114 224c8.837 0 16-7.163 16-16v-8c0-8.837-7.163-16-16-16H66c-8.837 0-16 7.163-16 16v8c0 8.837 7.163 16 16 16h48Z",
                fill: "url(#paint0_linear_8614_113852)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116.666,
                y: 195,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 195)",
                fill: "#DFAEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116.666,
                y: 207.333,
                width: 4,
                height: 53.333,
                rx: 2,
                transform: "rotate(90 116.666 207.333)",
                fill: "#DFAEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 214,
                cy: 56,
                r: 20,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m208 46 16 10-16 10",
                stroke: "#947DFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 224,
                cy: 56,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 208,
                cy: 66,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 208,
                cy: 46,
                r: 4,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 154,
                cy: 124,
                r: 20,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154 110.996a13.331 13.331 0 0 0-13.161 11.198 13.335 13.335 0 0 0 8.944 14.785c.667.117.917-.283.917-.633 0-.317-.017-1.367-.017-2.483-3.35.616-4.216-.817-4.483-1.567a4.845 4.845 0 0 0-1.367-1.883c-.466-.25-1.133-.867-.016-.884a2.678 2.678 0 0 1 2.05 1.367 2.843 2.843 0 0 0 2.823 1.444 2.855 2.855 0 0 0 1.06-.344c.058-.678.36-1.312.85-1.783-2.967-.334-6.067-1.484-6.067-6.584a5.185 5.185 0 0 1 1.367-3.583 4.79 4.79 0 0 1 .133-3.533s1.117-.35 3.667 1.366c2.182-.6 4.485-.6 6.667 0 2.55-1.733 3.666-1.366 3.666-1.366a4.79 4.79 0 0 1 .134 3.533 5.16 5.16 0 0 1 1.366 3.583c0 5.117-3.116 6.25-6.083 6.584a3.154 3.154 0 0 1 .9 2.466c0 1.784-.017 3.217-.017 3.667 0 .35.25.767.917.633a13.337 13.337 0 0 0 8.908-14.796A13.337 13.337 0 0 0 154 110.996Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 126,
                cy: 24,
                r: 16,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M136.666 24c0-5.891-4.775-10.666-10.666-10.666-5.892 0-10.667 4.775-10.667 10.667 0 5.325 3.9 9.737 9 10.537v-7.454h-2.708v-3.083h2.708v-2.35c0-2.673 1.592-4.15 4.029-4.15 1.167 0 2.388.208 2.388.208v2.625h-1.346c-1.325 0-1.738.823-1.738 1.667v2h2.959l-.473 3.083h-2.486v7.454c5.1-.8 9-5.212 9-10.537Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m130.152 27.084.473-3.083h-2.959v-2c0-.844.413-1.667 1.738-1.667h1.346V17.71s-1.221-.208-2.388-.208c-2.437 0-4.029 1.477-4.029 4.15v2.35h-2.708v3.083h2.708v7.454a10.736 10.736 0 0 0 3.333 0v-7.454h2.486Z",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M246 172c0-5.073-1.888-9.704-5-13.23a20.05 20.05 0 0 0-7-5.106M212.771 157a20.06 20.06 0 0 0-4.095 5 19.855 19.855 0 0 0-2.046 5 20.048 20.048 0 0 0-.63 5c0 2.275.38 4.462 1.08 6.5a19.957 19.957 0 0 0 1.596 3.5 20.095 20.095 0 0 0 7.634 7.5A19.92 19.92 0 0 0 226 192a19.92 19.92 0 0 0 9.69-2.5 20.108 20.108 0 0 0 6.675-6M219 153.259c-.863.322-1.698.703-2.5 1.136",
                stroke: "#E5E1EC",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M237.52 172.273c0-.851-.076-1.669-.218-2.455H226v4.642h6.458a5.52 5.52 0 0 1-2.394 3.622v3.011h3.878c2.269-2.089 3.578-5.166 3.578-8.82Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 184c3.24 0 5.956-1.074 7.941-2.907l-3.878-3.011c-1.074.72-2.449 1.146-4.063 1.146-3.126 0-5.771-2.111-6.715-4.948h-4.009v3.109A11.995 11.995 0 0 0 226 184Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.285 174.279a7.213 7.213 0 0 1-.376-2.28c0-.79.136-1.56.376-2.28v-3.109h-4.009a12.005 12.005 0 0 0-1.276 5.389c0 1.937.464 3.77 1.276 5.39l4.009-3.11Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M226 164.773c1.761 0 3.343.605 4.587 1.794l3.442-3.442C231.95 161.189 229.234 160 226 160c-4.691 0-8.75 2.689-10.724 6.611l4.009 3.109c.944-2.836 3.589-4.947 6.715-4.947Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 153,
                cy: 180,
                r: 8,
                fill: "#E5E1EC",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m15.629 125 1.011 2.641a2.828 2.828 0 0 0 3.653 1.63v0a2.829 2.829 0 0 1 3.653 1.63v0a2.828 2.828 0 0 0 3.653 1.63v0a2.828 2.828 0 0 1 3.653 1.63l1.011 2.641",
                stroke: "#AF9EFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_8614_113852",
                    x1: 60.833,
                    y1: 217.125,
                    x2: 84.802,
                    y2: 172.314,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $f029a1af34cbac2d$export$2e2bcd8739ae039 = $f029a1af34cbac2d$var$SvgSocialConnectorEmpty;




parcelRequire("6ZMK7");
var $kiVDZ = parcelRequire("kiVDZ");

var $emGEN = parcelRequire("emGEN");

var $kcPww = parcelRequire("kcPww");






var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9XAkT = parcelRequire("9XAkT");
var $b7b367b4200f52fe$export$b31f6ae88848cf15;
var $b7b367b4200f52fe$export$bfd64c937657f93a;
var $b7b367b4200f52fe$export$4a6dd88bada4e7d2;
$b7b367b4200f52fe$export$b31f6ae88848cf15 = `LfdwjW_notice`;
$b7b367b4200f52fe$export$bfd64c937657f93a = `LfdwjW_rotating`;
$b7b367b4200f52fe$export$4a6dd88bada4e7d2 = `LfdwjW_shimmer`;


function $f93083a3c1ec99b2$var$DemoConnectorNotice() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        className: $b7b367b4200f52fe$export$b31f6ae88848cf15,
        children: t("cloud.sie.connectors.notice")
    });
}
var $f93083a3c1ec99b2$export$2e2bcd8739ae039 = $f93083a3c1ec99b2$var$DemoConnectorNotice;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");



var $9bgsA = parcelRequire("9bgsA");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");

function $22c7d0220049887b$var$ConnectorDeleteButton({ connectorGroup: connectorGroup }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { mutate: mutateGlobal } = (0, $4Korf.useSWRConfig)();
    const { connectors: connectors } = connectorGroup;
    const { isConnectorInUse: isConnectorInUse } = (0, $23b420b35fae99c8$export$2e2bcd8739ae039)();
    const firstConnector = connectors[0];
    const inUse = isConnectorInUse(firstConnector);
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!firstConnector || isDeleting) return;
        setIsDeleting(true);
        const { connectors: connectors } = connectorGroup;
        try {
            await Promise.all(connectors.map(async (connector)=>{
                await api.delete(`api/connectors/${connector.id}`);
            }));
            (0, $horhC.toast).success(t("connector_details.connector_deleted"));
            await mutateGlobal("api/connectors");
        } finally{
            setIsDeleting(false);
        }
    };
    if (!firstConnector) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                content: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    children: t("general.delete")
                }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    onClick: ()=>{
                        setIsDeleteAlertOpen(true);
                    },
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $396803ba381ea6b5$export$2e2bcd8739ae039), {
                data: firstConnector,
                isInUse: inUse,
                isOpen: isDeleteAlertOpen,
                isLoading: isDeleting,
                onCancel: ()=>{
                    setIsDeleteAlertOpen(false);
                },
                onConfirm: handleDelete
            })
        ]
    });
}
var $22c7d0220049887b$export$2e2bcd8739ae039 = $22c7d0220049887b$var$ConnectorDeleteButton;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $86S23 = parcelRequire("86S23");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");




var $kiVDZ = parcelRequire("kiVDZ");

var $emGEN = parcelRequire("emGEN");

var $kcPww = parcelRequire("kcPww");

var $4W0F0 = parcelRequire("4W0F0");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");
function $0c8383a4b4805f0e$var$DemoTag({ connectorType: connectorType }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isSocial = connectorType === (0, $fU2Vo.ConnectorType).Social;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
        content: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            children: t(isSocial ? "connectors.social_demo_tip" : "connectors.demo_tip")
        }),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
            status: "alert",
            children: t("general.demo")
        })
    });
}
var $0c8383a4b4805f0e$export$2e2bcd8739ae039 = $0c8383a4b4805f0e$var$DemoTag;


var $8c5ebdf2cb9cc754$export$34e0f9847d4c02dd;
var $8c5ebdf2cb9cc754$export$db3c28d99448dcff;
var $8c5ebdf2cb9cc754$export$a1fe6a2d7788354f;
var $8c5ebdf2cb9cc754$export$722a64dea1b767dc;
var $8c5ebdf2cb9cc754$export$caa92bdde36f2a2d;
var $8c5ebdf2cb9cc754$export$435aa072d3c70d67;
var $8c5ebdf2cb9cc754$export$bfd64c937657f93a;
var $8c5ebdf2cb9cc754$export$4a6dd88bada4e7d2;
$8c5ebdf2cb9cc754$export$34e0f9847d4c02dd = `_3V_yJa_container`;
$8c5ebdf2cb9cc754$export$db3c28d99448dcff = `_3V_yJa_logo`;
$8c5ebdf2cb9cc754$export$a1fe6a2d7788354f = `_3V_yJa_logoContainer`;
$8c5ebdf2cb9cc754$export$722a64dea1b767dc = `_3V_yJa_platform`;
$8c5ebdf2cb9cc754$export$caa92bdde36f2a2d = `_3V_yJa_platforms`;
$8c5ebdf2cb9cc754$export$435aa072d3c70d67 = `_3V_yJa_previewTitle`;
$8c5ebdf2cb9cc754$export$bfd64c937657f93a = `_3V_yJa_rotating`;
$8c5ebdf2cb9cc754$export$4a6dd88bada4e7d2 = `_3V_yJa_shimmer`;


function $be31d061e1b1984f$var$ConnectorName({ connectorGroup: connectorGroup, isDemo: isDemo = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { type: type, connectors: connectors } = connectorGroup;
    const connector = connectors[0];
    const { navigate: navigate } = (0, $4W0F0.default)();
    const hasNonUniversalConnector = connectors.some(({ platform: platform })=>platform !== (0, $86S23.ConnectorPlatform).Universal);
    if (!connector) {
        const PlaceholderIcon = (0, $kiVDZ.connectorPlaceholderIcon)[type];
        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
            title: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $8c5ebdf2cb9cc754$export$435aa072d3c70d67,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: t((0, $kiVDZ.connectorTitlePlaceHolder)[type])
                    }),
                    type !== (0, $fU2Vo.ConnectorType).Social && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.set_up",
                        onClick: ()=>{
                            navigate(`/connectors/${(0, $emGEN.ConnectorsTabs).Passwordless}/create/${type}`);
                        }
                    })
                ]
            }),
            icon: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8c5ebdf2cb9cc754$export$a1fe6a2d7788354f,
                children: PlaceholderIcon && /*#__PURE__*/ (0, $9zeGj.jsx)(PlaceholderIcon, {
                    className: $8c5ebdf2cb9cc754$export$db3c28d99448dcff
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $8c5ebdf2cb9cc754$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                    resource: connector.name
                }),
                subtitle: type === (0, $fU2Vo.ConnectorType).Social && hasNonUniversalConnector && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $8c5ebdf2cb9cc754$export$caa92bdde36f2a2d,
                    children: connectors.map(({ id: id, platform: platform })=>platform && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $8c5ebdf2cb9cc754$export$722a64dea1b767dc,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b1a590d94aaaa586$export$2e2bcd8739ae039), {
                                    platform: platform
                                }),
                                t((0, $kiVDZ.connectorPlatformLabel)[platform])
                            ]
                        }, id))
                }),
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                    data: connector
                }),
                to: (0, $5CQIb.conditional)(!isDemo && `/connectors/${connector.type === (0, $fU2Vo.ConnectorType).Social ? (0, $emGEN.ConnectorsTabs).Social : (0, $emGEN.ConnectorsTabs).Passwordless}/${connector.id}`)
            }),
            isDemo && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0c8383a4b4805f0e$export$2e2bcd8739ae039), {
                connectorType: connector.type
            })
        ]
    });
}
var $be31d061e1b1984f$export$2e2bcd8739ae039 = $be31d061e1b1984f$var$ConnectorName;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


function $8e60f466d550ddc6$var$ConnectorStatus({ connectorGroup: connectorGroup }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { connectors: connectors } = connectorGroup;
    const { isConnectorInUse: isConnectorInUse } = (0, $23b420b35fae99c8$export$2e2bcd8739ae039)();
    const firstConnector = connectors[0];
    const inUse = isConnectorInUse(firstConnector);
    return firstConnector ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        type: "state",
        status: inUse ? "success" : "info",
        variant: "plain",
        children: t(inUse ? "connectors.connector_status_in_use" : "connectors.connector_status_not_in_use")
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: "-"
    });
}
var $8e60f466d550ddc6$export$2e2bcd8739ae039 = $8e60f466d550ddc6$var$ConnectorStatus;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $ds4Cq = parcelRequire("ds4Cq");

var $9bgsA = parcelRequire("9bgsA");

var $1Iq4D = parcelRequire("1Iq4D");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");
var $065939d9c92657f4$export$a7db06668cad9adb;
var $065939d9c92657f4$export$e0f35d825088c098;
var $065939d9c92657f4$export$bfd64c937657f93a;
var $065939d9c92657f4$export$4a6dd88bada4e7d2;
var $065939d9c92657f4$export$ce3e55343e166f1c;
var $065939d9c92657f4$export$fb184b623420d9be;
$065939d9c92657f4$export$a7db06668cad9adb = `_6N10NW_content`;
$065939d9c92657f4$export$e0f35d825088c098 = `_6N10NW_field`;
$065939d9c92657f4$export$bfd64c937657f93a = `_6N10NW_rotating`;
$065939d9c92657f4$export$4a6dd88bada4e7d2 = `_6N10NW_shimmer`;
$065939d9c92657f4$export$ce3e55343e166f1c = `_6N10NW_tipButton`;
$065939d9c92657f4$export$fb184b623420d9be = `_6N10NW_title`;


function $82dab70ad191af48$var$ConnectorStatusField() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $065939d9c92657f4$export$e0f35d825088c098,
        children: [
            t("connectors.connector_status"),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                anchorClassName: $065939d9c92657f4$export$ce3e55343e166f1c,
                content: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $065939d9c92657f4$export$fb184b623420d9be,
                                children: t("connectors.connector_status")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $065939d9c92657f4$export$a7db06668cad9adb,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                            to: "/sign-in-experience/sign-up-and-sign-in",
                                            onClick: closeTipHandler
                                        })
                                    },
                                    children: t("connectors.not_in_use_tip.content", {
                                        link: t("connectors.not_in_use_tip.go_to_sie")
                                    })
                                })
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                })
            })
        ]
    });
}
var $82dab70ad191af48$export$2e2bcd8739ae039 = $82dab70ad191af48$var$ConnectorStatusField;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");


var $kiVDZ = parcelRequire("kiVDZ");
function $a2fdf409c9a2445d$var$ConnectorTypeColumn({ connectorGroup: { type: type, connectors: connectors } }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const standardConnectors = connectors.filter(({ isStandard: isStandard })=>isStandard);
    if (standardConnectors.length > 1) throw new Error("More than one standard connectors with the same target is not supported.");
    const firstStandardConnector = standardConnectors[0];
    const { data: connectorFactory } = (0, $2mi28.default)(firstStandardConnector && `api/connector-factories/${firstStandardConnector.connectorId}`);
    if (!firstStandardConnector) return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: t((0, $kiVDZ.connectorTitlePlaceHolder)[type])
    });
    if (!connectorFactory) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
        resource: connectorFactory.name
    });
}
var $a2fdf409c9a2445d$export$2e2bcd8739ae039 = $a2fdf409c9a2445d$var$ConnectorTypeColumn;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $dMkQh = parcelRequire("dMkQh");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $awn06 = parcelRequire("awn06");

var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $iHViS = parcelRequire("iHViS");





var $emGEN = parcelRequire("emGEN");

var $kcPww = parcelRequire("kcPww");

var $lSA0o = parcelRequire("lSA0o");

var $5Yzj4 = parcelRequire("5Yzj4");

var $9bgsA = parcelRequire("9bgsA");

var $d0Zvy = parcelRequire("d0Zvy");



var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");



var $bSFEw = parcelRequire("bSFEw");

var $9959b033d155937e$export$837bd02682cd3db9;
var $9959b033d155937e$export$2f3470a7f0d1a379;
var $9959b033d155937e$export$64a53ecd158b85c4;
var $9959b033d155937e$export$34e0f9847d4c02dd;
var $9959b033d155937e$export$a7db06668cad9adb;
var $9959b033d155937e$export$adb608be33961c98;
var $9959b033d155937e$export$38e42c68cf43b5d4;
var $9959b033d155937e$export$98e628dec113755e;
var $9959b033d155937e$export$20b6fe5c276910c1;
var $9959b033d155937e$export$ca1a0b14edb13127;
var $9959b033d155937e$export$62b98b62cb75971a;
var $9959b033d155937e$export$bfd64c937657f93a;
var $9959b033d155937e$export$3e523c77c1f23f8c;
var $9959b033d155937e$export$de27182ff8187d6c;
var $9959b033d155937e$export$4a6dd88bada4e7d2;
$9959b033d155937e$export$837bd02682cd3db9 = `_2-O1KW_block`;
$9959b033d155937e$export$2f3470a7f0d1a379 = `_2-O1KW_blockTitle`;
$9959b033d155937e$export$64a53ecd158b85c4 = `_2-O1KW_closeIcon`;
$9959b033d155937e$export$34e0f9847d4c02dd = `_2-O1KW_container`;
$9959b033d155937e$export$a7db06668cad9adb = `_2-O1KW_content`;
$9959b033d155937e$export$adb608be33961c98 = `_2-O1KW_footer`;
$9959b033d155937e$export$38e42c68cf43b5d4 = `_2-O1KW_header`;
$9959b033d155937e$export$98e628dec113755e = `_2-O1KW_number`;
$9959b033d155937e$export$20b6fe5c276910c1 = `_2-O1KW_readme`;
$9959b033d155937e$export$ca1a0b14edb13127 = `_2-O1KW_readmeContent`;
$9959b033d155937e$export$62b98b62cb75971a = `_2-O1KW_readmeTitle`;
$9959b033d155937e$export$bfd64c937657f93a = `_2-O1KW_rotating`;
$9959b033d155937e$export$3e523c77c1f23f8c = `_2-O1KW_separator`;
$9959b033d155937e$export$de27182ff8187d6c = `_2-O1KW_setup`;
$9959b033d155937e$export$4a6dd88bada4e7d2 = `_2-O1KW_shimmer`;


const $aa71f8a8afb72aeb$var$targetErrorCode = "connector.multiple_target_with_same_platform";
function $aa71f8a8afb72aeb$var$Guide({ connector: connector, onClose: onClose }) {
    const { createConnector: createConnector } = (0, $a159769e424a60ee$export$2e2bcd8739ae039)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const callbackConnectorId = (0, $eCoWV.useRef)((0, $jKlLV.generateStandardId)());
    const [conflictConnectorName, setConflictConnectorName] = (0, $eCoWV.useState)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { type: connectorType, formItems: formItems, isStandard: isStandard } = connector ?? {};
    const { language: language } = (0, $awn06.default);
    const isSocialConnector = connectorType !== (0, $fU2Vo.ConnectorType).Sms && connectorType !== (0, $fU2Vo.ConnectorType).Email;
    const methods = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur",
        defaultValues: {
            jsonConfig: "{}",
            formConfig: {},
            syncProfile: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister
        }
    });
    const { formState: { isSubmitting: isSubmitting }, handleSubmit: handleSubmit, watch: watch, setError: setError, reset: reset } = methods;
    (0, $eCoWV.useEffect)(()=>{
        if (!connector) return;
        reset((0, $f8b42fae3873d986$export$7bb2f28ad6c44e46)(connector));
    }, [
        reset,
        connector
    ]);
    const configParser = (0, $a7cfa996bbe47dd1$export$4c86d49e765c99cd)();
    (0, $eCoWV.useEffect)(()=>{
        setConflictConnectorName(undefined);
    }, [
        connector
    ]);
    if (!connector) return null;
    const { id: connectorId, name: name, readme: readme } = connector;
    const { title: title, content: content } = (0, $dc36c1ed9a2dd820$export$3e690d7c9decfaaa)(readme);
    const connectorName = (0, $5CQIb.conditional)((0, $dMkQh.isLanguageTag)(language) && name[language]) ?? name.en;
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        // Recover error state
        setConflictConnectorName(undefined);
        const config = configParser(data, formItems);
        const { syncProfile: syncProfile, name: name, logo: logo, logoDark: logoDark, target: target } = data;
        const basePayload = {
            config: config,
            connectorId: connectorId,
            id: (0, $5CQIb.conditional)(connectorType === (0, $fU2Vo.ConnectorType).Social && callbackConnectorId.current),
            metadata: (0, $5CQIb.conditional)(isStandard && {
                logo: logo,
                logoDark: logoDark,
                target: target,
                name: {
                    en: name
                }
            })
        };
        const payload = isSocialConnector ? {
            ...basePayload,
            syncProfile: syncProfile === (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn
        } : basePayload;
        try {
            const createdConnector = await createConnector(payload);
            onClose();
            (0, $horhC.toast).success(t("general.saved"));
            navigate(`/connectors/${isSocialConnector ? (0, $emGEN.ConnectorsTabs).Social : (0, $emGEN.ConnectorsTabs).Passwordless}/${createdConnector.id}`);
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.json();
                if (metadata.code === $aa71f8a8afb72aeb$var$targetErrorCode) {
                    setConflictConnectorName(metadata.data.connectorName);
                    setError("target", {}, {
                        shouldFocus: true
                    });
                    return;
                }
            }
            throw error;
        }
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: Boolean(connector),
        className: $7iZsu.fullScreen,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $9959b033d155937e$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $9959b033d155937e$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "large",
                            onClick: ()=>{
                                onClose(callbackConnectorId.current);
                            },
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                                className: $9959b033d155937e$export$64a53ecd158b85c4
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $9959b033d155937e$export$3e523c77c1f23f8c
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                            size: "small",
                            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                                children: connectorName
                            }),
                            subtitle: "connectors.guide.subtitle"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $9959b033d155937e$export$a7db06668cad9adb,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $d0Zvy.default), {
                            className: $9959b033d155937e$export$20b6fe5c276910c1,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $9959b033d155937e$export$62b98b62cb75971a,
                                    children: [
                                        "README: ",
                                        title
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ba19dac3f36add1e$export$2e2bcd8739ae039), {
                                    className: $9959b033d155937e$export$ca1a0b14edb13127,
                                    children: content
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $9959b033d155937e$export$de27182ff8187d6c,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
                                ...methods,
                                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                                    autoComplete: "off",
                                    onSubmit: onSubmit,
                                    children: [
                                        isSocialConnector && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $9959b033d155937e$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                    className: $9959b033d155937e$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            className: $9959b033d155937e$export$98e628dec113755e,
                                                            children: "1"
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            children: t("connectors.guide.general_setting")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $abc38b470023b326$export$2e2bcd8739ae039), {
                                                    isAllowEditTarget: isStandard,
                                                    isStandard: isStandard,
                                                    conflictConnectorName: conflictConnectorName
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $9959b033d155937e$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                    className: $9959b033d155937e$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            className: $9959b033d155937e$export$98e628dec113755e,
                                                            children: isSocialConnector ? 2 : 1
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            children: t("connectors.guide.parameter_configuration")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $184a57a617ef81e1$export$2e2bcd8739ae039), {
                                                    connectorId: callbackConnectorId.current,
                                                    connectorType: connectorType,
                                                    formItems: formItems
                                                })
                                            ]
                                        }),
                                        !isSocialConnector && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $9959b033d155937e$export$837bd02682cd3db9,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                    className: $9959b033d155937e$export$2f3470a7f0d1a379,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            className: $9959b033d155937e$export$98e628dec113755e,
                                                            children: "2"
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                            children: t("connectors.guide.test_connection")
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c5fac4dd0dbfcd$export$2e2bcd8739ae039), {
                                                    connectorFactoryId: connectorId,
                                                    connectorType: connectorType,
                                                    parse: ()=>configParser(watch(), formItems)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $9959b033d155937e$export$adb608be33961c98,
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                                title: "connectors.save_and_done",
                                                type: "primary",
                                                htmlType: "submit",
                                                isLoading: isSubmitting
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
}
var $aa71f8a8afb72aeb$export$2e2bcd8739ae039 = $aa71f8a8afb72aeb$var$Guide;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $2mi28 = parcelRequire("2mi28");

var $9XAkT = parcelRequire("9XAkT");

var $1Iq4D = parcelRequire("1Iq4D");

var $370bb5919c7f9587$export$b31f6ae88848cf15;
var $370bb5919c7f9587$export$bfd64c937657f93a;
var $370bb5919c7f9587$export$4a6dd88bada4e7d2;
$370bb5919c7f9587$export$b31f6ae88848cf15 = `_78fBFG_notice`;
$370bb5919c7f9587$export$bfd64c937657f93a = `_78fBFG_rotating`;
$370bb5919c7f9587$export$4a6dd88bada4e7d2 = `_78fBFG_shimmer`;


function $00fbf0349d46aadd$var$SignInExperienceSetupNotice() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectors } = (0, $2mi28.default)("api/connectors");
    const { data: { connectorSieNoticeConfirmed: connectorSieNoticeConfirmed }, update: update } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    if (!connectors || connectors.length === 0 || connectorSieNoticeConfirmed) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        action: "general.got_it",
        className: $370bb5919c7f9587$export$b31f6ae88848cf15,
        onClick: ()=>{
            update({
                connectorSieNoticeConfirmed: true
            });
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                    to: "/sign-in-experience/sign-up-and-sign-in"
                })
            },
            children: t("connectors.config_sie_notice", {
                link: t("connectors.config_sie_link_text")
            })
        })
    });
}
var $00fbf0349d46aadd$export$2e2bcd8739ae039 = $00fbf0349d46aadd$var$SignInExperienceSetupNotice;


var $756ce5086153088d$export$ded9b5979746c93f;
var $756ce5086153088d$export$34e0f9847d4c02dd;
var $756ce5086153088d$export$6e22c362a0406a2c;
var $756ce5086153088d$export$c34e3c28fad7070e;
var $756ce5086153088d$export$bfd64c937657f93a;
var $756ce5086153088d$export$4a6dd88bada4e7d2;
var $756ce5086153088d$export$39f5674517ec0000;
$756ce5086153088d$export$ded9b5979746c93f = `G05ORa_connectorName`;
$756ce5086153088d$export$34e0f9847d4c02dd = `G05ORa_container`;
$756ce5086153088d$export$6e22c362a0406a2c = `G05ORa_empty`;
$756ce5086153088d$export$c34e3c28fad7070e = `G05ORa_emptyLine`;
$756ce5086153088d$export$bfd64c937657f93a = `G05ORa_rotating`;
$756ce5086153088d$export$4a6dd88bada4e7d2 = `G05ORa_shimmer`;
$756ce5086153088d$export$39f5674517ec0000 = `G05ORa_tabs`;


const $fbf94a58443b74af$var$basePathname = "/connectors";
const $fbf94a58443b74af$var$passwordlessPathname = `${$fbf94a58443b74af$var$basePathname}/${(0, $emGEN.ConnectorsTabs).Passwordless}`;
const $fbf94a58443b74af$var$socialPathname = `${$fbf94a58443b74af$var$basePathname}/${(0, $emGEN.ConnectorsTabs).Social}`;
const $fbf94a58443b74af$var$buildTabPathname = (connectorType)=>connectorType === (0, $fU2Vo.ConnectorType).Social ? $fbf94a58443b74af$var$socialPathname : $fbf94a58443b74af$var$passwordlessPathname;
const $fbf94a58443b74af$var$buildCreatePathname = (connectorType)=>{
    const tabPath = $fbf94a58443b74af$var$buildTabPathname(connectorType);
    return `${tabPath}/create/${connectorType}`;
};
const $fbf94a58443b74af$var$buildGuidePathname = (connectorType, factoryId)=>{
    const tabPath = $fbf94a58443b74af$var$buildTabPathname(connectorType);
    return `${tabPath}/guide/${factoryId}`;
};
const $fbf94a58443b74af$var$isConnectorType = (value)=>Object.values((0, $fU2Vo.ConnectorType)).includes(value);
const $fbf94a58443b74af$var$parseToConnectorType = (value)=>(0, $5CQIb.conditional)(value && $fbf94a58443b74af$var$isConnectorType(value) && value);
function $fbf94a58443b74af$var$Connectors() {
    const { tab: tab = (0, $emGEN.ConnectorsTabs).Passwordless, createType: createType, factoryId: factoryId } = (0, $9X5Bp.useParams)();
    const createConnectorType = $fbf94a58443b74af$var$parseToConnectorType(createType);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const isSocial = tab === (0, $emGEN.ConnectorsTabs).Social;
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { createConnector: createConnector } = (0, $a159769e424a60ee$export$2e2bcd8739ae039)();
    const { data: data, error: error, mutate: mutate } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    const { data: factories, error: factoriesError } = (0, $2mi28.default)("api/connector-factories");
    const isLoading = !data && !factories && !error && !factoriesError;
    const passwordlessConnectors = (0, $eCoWV.useMemo)(()=>{
        const emailConnector = data?.find(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Email) ?? (0, $kiVDZ.defaultEmailConnectorGroup);
        const smsConnector = data?.find(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Sms) ?? (0, $kiVDZ.defaultSmsConnectorGroup);
        return [
            emailConnector,
            smsConnector
        ];
    }, [
        data
    ]);
    const socialConnectors = (0, $eCoWV.useMemo)(()=>data?.filter(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Social), [
        data
    ]);
    const connectors = isSocial ? socialConnectors : passwordlessConnectors;
    const hasDemoConnector = connectors?.some(({ isDemo: isDemo })=>isDemo);
    const connectorToShowInGuide = (0, $eCoWV.useMemo)(()=>{
        if (factories && factoryId) return factories.find(({ id: id })=>id === factoryId);
    }, [
        factoryId,
        factories
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
        className: $756ce5086153088d$export$34e0f9847d4c02dd,
        title: {
            title: "connectors.title",
            subtitle: "connectors.subtitle"
        },
        pageMeta: {
            titleKey: "connectors.page_title"
        },
        createButton: (0, $5CQIb.conditional)(isSocial && {
            title: "connectors.create",
            onClick: ()=>{
                navigate($fbf94a58443b74af$var$buildCreatePathname((0, $fU2Vo.ConnectorType).Social));
            }
        }),
        subHeader: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00fbf0349d46aadd$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                    className: $756ce5086153088d$export$39f5674517ec0000,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: $fbf94a58443b74af$var$passwordlessPathname,
                            children: t("connectors.tab_email_sms")
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: $fbf94a58443b74af$var$socialPathname,
                            children: t("connectors.tab_social")
                        })
                    ]
                }),
                hasDemoConnector && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f93083a3c1ec99b2$export$2e2bcd8739ae039), {})
            ]
        }),
        table: {
            rowIndexKey: "id",
            rowGroups: [
                {
                    key: "connectors",
                    data: connectors
                }
            ],
            columns: [
                {
                    title: t("connectors.connector_name"),
                    dataIndex: "name",
                    colSpan: 6,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $be31d061e1b1984f$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup,
                            isDemo: connectorGroup.isDemo
                        })
                },
                {
                    title: t("connectors.connector_type"),
                    dataIndex: "type",
                    colSpan: 5,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $a2fdf409c9a2445d$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        })
                },
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82dab70ad191af48$export$2e2bcd8739ae039), {}),
                    dataIndex: "status",
                    colSpan: 4,
                    render: (connectorGroup)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $8e60f466d550ddc6$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        })
                },
                {
                    title: null,
                    dataIndex: "delete",
                    colSpan: 1,
                    render: (connectorGroup)=>connectorGroup.isDemo ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $22c7d0220049887b$export$2e2bcd8739ae039), {
                            connectorGroup: connectorGroup
                        }) : null
                }
            ],
            isRowClickable: ({ connectors: connectors })=>Boolean(connectors[0]) && !connectors[0]?.isDemo,
            rowClickHandler: ({ connectors: connectors })=>{
                const firstConnector = connectors[0];
                if (!firstConnector) return;
                const { type: type, id: id } = firstConnector;
                navigate(`${type === (0, $fU2Vo.ConnectorType).Social ? $fbf94a58443b74af$var$socialPathname : $fbf94a58443b74af$var$passwordlessPathname}/${id}`);
            },
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            placeholder: (0, $5CQIb.conditional)(isSocial && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f029a1af34cbac2d$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cc5355640d7be30c$export$2e2bcd8739ae039), {}),
                title: "connectors.placeholder_title",
                description: "connectors.placeholder_description",
                learnMoreLink: {
                    href: getDocumentationUrl("/docs/recipes/configure-connectors/configure-social-connector"),
                    targetBlank: "noopener"
                },
                action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "connectors.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate($fbf94a58443b74af$var$buildCreatePathname((0, $fU2Vo.ConnectorType).Social));
                    }
                })
            })),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5942e5adf122c259$export$2e2bcd8739ae039), {
                    isOpen: Boolean(createConnectorType),
                    type: createConnectorType,
                    onClose: async (id)=>{
                        if (createConnectorType && id) {
                            /**
                 * Note:
                 * The "Email Service Connector" is a built-in connector that can be directly created without the need for setup in the guide.
                 */ if (id === (0, $4at8B.ServiceConnector).Email) {
                                const created = await createConnector({
                                    connectorId: id
                                });
                                navigate(`/connectors/${(0, $emGEN.ConnectorsTabs).Passwordless}/${created.id}`, {
                                    replace: true
                                });
                                return;
                            }
                            navigate($fbf94a58443b74af$var$buildGuidePathname(createConnectorType, id), {
                                replace: true
                            });
                            return;
                        }
                        navigate(`${$fbf94a58443b74af$var$basePathname}/${tab}`);
                    }
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aa71f8a8afb72aeb$export$2e2bcd8739ae039), {
                    connector: connectorToShowInGuide,
                    onClose: ()=>{
                        navigate(`${$fbf94a58443b74af$var$basePathname}/${tab}`);
                    }
                })
            ]
        })
    });
}
var $fbf94a58443b74af$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($fbf94a58443b74af$var$Connectors);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");


var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $e6eb5f93f0f2349f$exports = {};

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */ function $e6eb5f93f0f2349f$var$isEqual(value, other) {
    return $7cc170f69c8922af$exports(value, other);
}
$e6eb5f93f0f2349f$exports = $e6eb5f93f0f2349f$var$isEqual;


var $aa7127c7503d27f5$exports = {};
var $ec729ee529b2009e$exports = {};


/** `Object#toString` result references. */ var $ec729ee529b2009e$var$numberTag = "[object Number]";
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $ec729ee529b2009e$var$isNumber(value) {
    return typeof value == "number" || $61068a3203fea8d0$exports(value) && $8f26fc8d3b90e8ac$exports(value) == $ec729ee529b2009e$var$numberTag;
}
$ec729ee529b2009e$exports = $ec729ee529b2009e$var$isNumber;


/**
 * Checks if `value` is `NaN`.
 *
 * **Note:** This method is based on
 * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
 * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
 * `undefined` and other non-number values.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 * @example
 *
 * _.isNaN(NaN);
 * // => true
 *
 * _.isNaN(new Number(NaN));
 * // => true
 *
 * isNaN(undefined);
 * // => true
 *
 * _.isNaN(undefined);
 * // => false
 */ function $aa7127c7503d27f5$var$isNaN(value) {
    // An `NaN` primitive is the only value that is not equal to itself.
    // Perform the `toStringTag` check first to avoid errors with some
    // ActiveX objects in IE.
    return $ec729ee529b2009e$exports(value) && value != +value;
}
$aa7127c7503d27f5$exports = $aa7127c7503d27f5$var$isNaN;


var $ae1d014ea9777699$exports = {};
var $d8de6711659655db$exports = {};

/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $d8de6711659655db$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$75f82d2fc8a8760e$exports(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
$d8de6711659655db$exports = $d8de6711659655db$var$baseExtremum;


var $4a19ba745db576af$exports = {};
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $4a19ba745db576af$var$baseGt(value, other) {
    return value > other;
}
$4a19ba745db576af$exports = $4a19ba745db576af$var$baseGt;



/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $ae1d014ea9777699$var$max(array) {
    return array && array.length ? $d8de6711659655db$exports(array, $d776a9304296f9f7$exports, $4a19ba745db576af$exports) : undefined;
}
$ae1d014ea9777699$exports = $ae1d014ea9777699$var$max;




var $f4c1eb24faf142bb$exports = {};
/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */ function $f4c1eb24faf142bb$var$isNil(value) {
    return value == null;
}
$f4c1eb24faf142bb$exports = $f4c1eb24faf142bb$var$isNil;




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $hqomP = parcelRequire("hqomP");
var $36bfcd01a3983471$exports = {};
(function(global, factory) {
    factory($36bfcd01a3983471$exports);
})($36bfcd01a3983471$exports, function(exports1) {
    "use strict";
    var HAS_WEAKSET_SUPPORT = typeof WeakSet === "function";
    var keys = Object.keys;
    /**
   * are the values passed strictly equal or both NaN
   *
   * @param a the value to compare against
   * @param b the value to test
   * @returns are the values equal by the SameValueZero principle
   */ function sameValueZeroEqual(a, b) {
        return a === b || a !== a && b !== b;
    }
    /**
   * is the value a plain object
   *
   * @param value the value to test
   * @returns is the value a plain object
   */ function isPlainObject(value) {
        return value.constructor === Object || value.constructor == null;
    }
    /**
   * is the value promise-like (meaning it is thenable)
   *
   * @param value the value to test
   * @returns is the value promise-like
   */ function isPromiseLike(value) {
        return !!value && typeof value.then === "function";
    }
    /**
   * is the value passed a react element
   *
   * @param value the value to test
   * @returns is the value a react element
   */ function isReactElement(value) {
        return !!(value && value.$$typeof);
    }
    /**
   * in cases where WeakSet is not supported, creates a new custom
   * object that mimics the necessary API aspects for cache purposes
   *
   * @returns the new cache object
   */ function getNewCacheFallback() {
        var values = [];
        return {
            add: function(value) {
                values.push(value);
            },
            has: function(value) {
                return values.indexOf(value) !== -1;
            }
        };
    }
    /**
   * get a new cache object to prevent circular references
   *
   * @returns the new cache object
   */ var getNewCache = function(canUseWeakMap) {
        if (canUseWeakMap) return function _getNewCache() {
            return new WeakSet();
        };
        return getNewCacheFallback;
    }(HAS_WEAKSET_SUPPORT);
    /**
   * create a custom isEqual handler specific to circular objects
   *
   * @param [isEqual] the isEqual comparator to use instead of isDeepEqual
   * @returns the method to create the `isEqual` function
   */ function createCircularEqualCreator(isEqual) {
        return function createCircularEqual(comparator) {
            var _comparator = isEqual || comparator;
            return function circularEqual(a, b, cache) {
                if (cache === void 0) cache = getNewCache();
                var isCacheableA = !!a && typeof a === "object";
                var isCacheableB = !!b && typeof b === "object";
                if (isCacheableA || isCacheableB) {
                    var hasA = isCacheableA && cache.has(a);
                    var hasB = isCacheableB && cache.has(b);
                    if (hasA || hasB) return hasA && hasB;
                    if (isCacheableA) cache.add(a);
                    if (isCacheableB) cache.add(b);
                }
                return _comparator(a, b, cache);
            };
        };
    }
    /**
   * are the arrays equal in value
   *
   * @param a the array to test
   * @param b the array to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the arrays equal
   */ function areArraysEqual(a, b, isEqual, meta) {
        var index = a.length;
        if (b.length !== index) return false;
        while(index-- > 0){
            if (!isEqual(a[index], b[index], meta)) return false;
        }
        return true;
    }
    /**
   * are the maps equal in value
   *
   * @param a the map to test
   * @param b the map to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta map to pass through
   * @returns are the maps equal
   */ function areMapsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (isValueEqual && a.size) {
            var matchedIndices_1 = {};
            a.forEach(function(aValue, aKey) {
                if (isValueEqual) {
                    var hasMatch_1 = false;
                    var matchIndex_1 = 0;
                    b.forEach(function(bValue, bKey) {
                        if (!hasMatch_1 && !matchedIndices_1[matchIndex_1]) {
                            hasMatch_1 = isEqual(aKey, bKey, meta) && isEqual(aValue, bValue, meta);
                            if (hasMatch_1) matchedIndices_1[matchIndex_1] = true;
                        }
                        matchIndex_1++;
                    });
                    isValueEqual = hasMatch_1;
                }
            });
        }
        return isValueEqual;
    }
    var OWNER = "_owner";
    var hasOwnProperty = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
    /**
   * are the objects equal in value
   *
   * @param a the object to test
   * @param b the object to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the objects equal
   */ function areObjectsEqual(a, b, isEqual, meta) {
        var keysA = keys(a);
        var index = keysA.length;
        if (keys(b).length !== index) return false;
        if (index) {
            var key = void 0;
            while(index-- > 0){
                key = keysA[index];
                if (key === OWNER) {
                    var reactElementA = isReactElement(a);
                    var reactElementB = isReactElement(b);
                    if ((reactElementA || reactElementB) && reactElementA !== reactElementB) return false;
                }
                if (!hasOwnProperty(b, key) || !isEqual(a[key], b[key], meta)) return false;
            }
        }
        return true;
    }
    /**
   * are the regExps equal in value
   *
   * @param a the regExp to test
   * @param b the regExp to test agains
   * @returns are the regExps equal
   */ function areRegExpsEqual(a, b) {
        return a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.unicode === b.unicode && a.sticky === b.sticky && a.lastIndex === b.lastIndex;
    }
    /**
   * are the sets equal in value
   *
   * @param a the set to test
   * @param b the set to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta set to pass through
   * @returns are the sets equal
   */ function areSetsEqual(a, b, isEqual, meta) {
        var isValueEqual = a.size === b.size;
        if (isValueEqual && a.size) {
            var matchedIndices_2 = {};
            a.forEach(function(aValue) {
                if (isValueEqual) {
                    var hasMatch_2 = false;
                    var matchIndex_2 = 0;
                    b.forEach(function(bValue) {
                        if (!hasMatch_2 && !matchedIndices_2[matchIndex_2]) {
                            hasMatch_2 = isEqual(aValue, bValue, meta);
                            if (hasMatch_2) matchedIndices_2[matchIndex_2] = true;
                        }
                        matchIndex_2++;
                    });
                    isValueEqual = hasMatch_2;
                }
            });
        }
        return isValueEqual;
    }
    var HAS_MAP_SUPPORT = typeof Map === "function";
    var HAS_SET_SUPPORT = typeof Set === "function";
    function createComparator(createIsEqual) {
        var isEqual = /* eslint-disable no-use-before-define */ typeof createIsEqual === "function" ? createIsEqual(comparator) : comparator;
        /* eslint-enable */ /**
       * compare the value of the two objects and return true if they are equivalent in values
       *
       * @param a the value to test against
       * @param b the value to test
       * @param [meta] an optional meta object that is passed through to all equality test calls
       * @returns are a and b equivalent in value
       */ function comparator(a, b, meta) {
            if (a === b) return true;
            if (a && b && typeof a === "object" && typeof b === "object") {
                if (isPlainObject(a) && isPlainObject(b)) return areObjectsEqual(a, b, isEqual, meta);
                var aShape = Array.isArray(a);
                var bShape = Array.isArray(b);
                if (aShape || bShape) return aShape === bShape && areArraysEqual(a, b, isEqual, meta);
                aShape = a instanceof Date;
                bShape = b instanceof Date;
                if (aShape || bShape) return aShape === bShape && sameValueZeroEqual(a.getTime(), b.getTime());
                aShape = a instanceof RegExp;
                bShape = b instanceof RegExp;
                if (aShape || bShape) return aShape === bShape && areRegExpsEqual(a, b);
                if (isPromiseLike(a) || isPromiseLike(b)) return a === b;
                if (HAS_MAP_SUPPORT) {
                    aShape = a instanceof Map;
                    bShape = b instanceof Map;
                    if (aShape || bShape) return aShape === bShape && areMapsEqual(a, b, isEqual, meta);
                }
                if (HAS_SET_SUPPORT) {
                    aShape = a instanceof Set;
                    bShape = b instanceof Set;
                    if (aShape || bShape) return aShape === bShape && areSetsEqual(a, b, isEqual, meta);
                }
                return areObjectsEqual(a, b, isEqual, meta);
            }
            return a !== a && b !== b;
        }
        return comparator;
    }
    var deepEqual = createComparator();
    var shallowEqual = createComparator(function() {
        return sameValueZeroEqual;
    });
    var circularDeepEqual = createComparator(createCircularEqualCreator());
    var circularShallowEqual = createComparator(createCircularEqualCreator(sameValueZeroEqual));
    exports1.circularDeepEqual = circularDeepEqual;
    exports1.circularShallowEqual = circularShallowEqual;
    exports1.createCustomEqual = createComparator;
    exports1.deepEqual = deepEqual;
    exports1.sameValueZeroEqual = sameValueZeroEqual;
    exports1.shallowEqual = shallowEqual;
    Object.defineProperty(exports1, "__esModule", {
        value: true
    });
});


function $66611b8307e8b548$export$2e2bcd8739ae039(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var currTime = -1;
    var shouldUpdate = function shouldUpdate(now) {
        if (currTime < 0) currTime = now;
        if (now - currTime > timeout) {
            callback(now);
            currTime = -1;
        } else requestAnimationFrame(shouldUpdate);
    };
    requestAnimationFrame(shouldUpdate);
}


function $a980a386ff6236bc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $a980a386ff6236bc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $a980a386ff6236bc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $a980a386ff6236bc$var$_typeof(obj);
}
function $a980a386ff6236bc$var$_toArray(arr) {
    return $a980a386ff6236bc$var$_arrayWithHoles(arr) || $a980a386ff6236bc$var$_iterableToArray(arr) || $a980a386ff6236bc$var$_unsupportedIterableToArray(arr) || $a980a386ff6236bc$var$_nonIterableRest();
}
function $a980a386ff6236bc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $a980a386ff6236bc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $a980a386ff6236bc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $a980a386ff6236bc$var$_arrayLikeToArray(o, minLen);
}
function $a980a386ff6236bc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $a980a386ff6236bc$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $a980a386ff6236bc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $a980a386ff6236bc$export$2e2bcd8739ae039() {
    var currStyle = {};
    var handleChange = function handleChange() {
        return null;
    };
    var shouldStop = false;
    var setStyle = function setStyle(_style) {
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var _styles = $a980a386ff6236bc$var$_toArray(styles), curr = _styles[0], restStyles = _styles.slice(1);
            if (typeof curr === "number") {
                (0, $66611b8307e8b548$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            (0, $66611b8307e8b548$export$2e2bcd8739ae039)(setStyle.bind(null, restStyles));
            return;
        }
        if ($a980a386ff6236bc$var$_typeof(_style) === "object") {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === "function") _style();
    };
    return {
        stop: function stop() {
            shouldStop = true;
        },
        start: function start(style) {
            shouldStop = false;
            setStyle(style);
        },
        subscribe: function subscribe(_handleChange) {
            handleChange = _handleChange;
            return function() {
                handleChange = function handleChange() {
                    return null;
                };
            };
        }
    };
}


function $95a61dc07598fcdc$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $95a61dc07598fcdc$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $95a61dc07598fcdc$var$ownKeys(Object(source), true).forEach(function(key) {
            $95a61dc07598fcdc$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $95a61dc07598fcdc$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $95a61dc07598fcdc$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/* eslint no-console: 0 */ var $95a61dc07598fcdc$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $95a61dc07598fcdc$var$IN_LINE_PREFIX_LIST = [
    "-webkit-",
    "-moz-",
    "-o-",
    "-ms-"
];
var $95a61dc07598fcdc$var$IN_COMPATIBLE_PROPERTY = [
    "transform",
    "transformOrigin",
    "transition"
];
var $95a61dc07598fcdc$export$59e29973723da0b3 = function getIntersectionKeys(preObj, nextObj) {
    return [
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce(function(a, b) {
        return a.filter(function(c) {
            return b.includes(c);
        });
    });
};
var $95a61dc07598fcdc$export$f0954fd7d5368655 = function identity(param) {
    return param;
};
var $95a61dc07598fcdc$export$51610fddbf64bc9d = function getDashCase(name) {
    return name.replace(/([A-Z])/g, function(v) {
        return "-".concat(v.toLowerCase());
    });
};
var $95a61dc07598fcdc$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if ($95a61dc07598fcdc$var$IN_COMPATIBLE_PROPERTY.indexOf(name) === -1) return $95a61dc07598fcdc$var$_defineProperty({}, name, value);
    var isTransition = name === "transition";
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var styleVal = value;
    return $95a61dc07598fcdc$var$PREFIX_LIST.reduce(function(result, property, i) {
        if (isTransition) styleVal = value.replace(/(transform|transform-origin)/gim, "".concat($95a61dc07598fcdc$var$IN_LINE_PREFIX_LIST[i], "$1"));
        return $95a61dc07598fcdc$var$_objectSpread($95a61dc07598fcdc$var$_objectSpread({}, result), {}, $95a61dc07598fcdc$var$_defineProperty({}, property + camelName, styleVal));
    }, {});
};
var $95a61dc07598fcdc$export$bef1f36f5486a6a3 = function log() {
    var _console;
    (_console = console).log.apply(_console, arguments);
};
var $95a61dc07598fcdc$export$1c9f709888824e05 = function debug(name) {
    return function(item) {
        $95a61dc07598fcdc$export$bef1f36f5486a6a3(name, item);
        return item;
    };
};
var $95a61dc07598fcdc$export$1dc45301cd23a8c7 = function debugf(tag, f) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var res = f.apply(void 0, args);
        var name = tag || f.name || "anonymous function";
        var argNames = "(".concat(args.map(JSON.stringify).join(", "), ")");
        $95a61dc07598fcdc$export$bef1f36f5486a6a3("".concat(name, ": ").concat(argNames, " => ").concat(JSON.stringify(res)));
        return res;
    };
};
var $95a61dc07598fcdc$export$d6051a0f7a227332 = function mapObject(fn, obj) {
    return Object.keys(obj).reduce(function(res, key) {
        return $95a61dc07598fcdc$var$_objectSpread($95a61dc07598fcdc$var$_objectSpread({}, res), {}, $95a61dc07598fcdc$var$_defineProperty({}, key, fn(key, obj[key])));
    }, {});
};
var $95a61dc07598fcdc$export$ff9926a5d1daa67c = function translateStyle(style) {
    return Object.keys(style).reduce(function(res, key) {
        return $95a61dc07598fcdc$var$_objectSpread($95a61dc07598fcdc$var$_objectSpread({}, res), $95a61dc07598fcdc$export$4a9169b65825efee(key, res[key]));
    }, style);
};
var $95a61dc07598fcdc$export$f672e0b6f7222cd7 = function compose() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    if (!args.length) return $95a61dc07598fcdc$export$f0954fd7d5368655;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $95a61dc07598fcdc$export$1594c78389ee3429 = function getTransitionVal(props, duration, easing) {
    return props.map(function(prop) {
        return "".concat($95a61dc07598fcdc$export$51610fddbf64bc9d(prop), " ").concat(duration, "ms ").concat(easing);
    }).join(",");
};
var $95a61dc07598fcdc$var$isDev = false;
var $95a61dc07598fcdc$export$c106dd0671a0fc2d = function warn(condition, format, a, b, c, d, e, f) {
    if ($95a61dc07598fcdc$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var args = [
                    a,
                    b,
                    c,
                    d,
                    e,
                    f
                ];
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};


function $244e96d31332d1e4$var$_slicedToArray(arr, i) {
    return $244e96d31332d1e4$var$_arrayWithHoles(arr) || $244e96d31332d1e4$var$_iterableToArrayLimit(arr, i) || $244e96d31332d1e4$var$_unsupportedIterableToArray(arr, i) || $244e96d31332d1e4$var$_nonIterableRest();
}
function $244e96d31332d1e4$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $244e96d31332d1e4$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $244e96d31332d1e4$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $244e96d31332d1e4$var$_toConsumableArray(arr) {
    return $244e96d31332d1e4$var$_arrayWithoutHoles(arr) || $244e96d31332d1e4$var$_iterableToArray(arr) || $244e96d31332d1e4$var$_unsupportedIterableToArray(arr) || $244e96d31332d1e4$var$_nonIterableSpread();
}
function $244e96d31332d1e4$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $244e96d31332d1e4$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $244e96d31332d1e4$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $244e96d31332d1e4$var$_arrayLikeToArray(o, minLen);
}
function $244e96d31332d1e4$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $244e96d31332d1e4$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $244e96d31332d1e4$var$_arrayLikeToArray(arr);
}
function $244e96d31332d1e4$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $244e96d31332d1e4$var$ACCURACY = 1e-4;
var $244e96d31332d1e4$var$cubicBezierFactor = function cubicBezierFactor(c1, c2) {
    return [
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
};
var $244e96d31332d1e4$var$multyTime = function multyTime(params, t) {
    return params.map(function(param, i) {
        return param * Math.pow(t, i);
    }).reduce(function(pre, curr) {
        return pre + curr;
    });
};
var $244e96d31332d1e4$var$cubicBezier = function cubicBezier(c1, c2) {
    return function(t) {
        var params = $244e96d31332d1e4$var$cubicBezierFactor(c1, c2);
        return $244e96d31332d1e4$var$multyTime(params, t);
    };
};
var $244e96d31332d1e4$var$derivativeCubicBezier = function derivativeCubicBezier(c1, c2) {
    return function(t) {
        var params = $244e96d31332d1e4$var$cubicBezierFactor(c1, c2);
        var newParams = [].concat($244e96d31332d1e4$var$_toConsumableArray(params.map(function(param, i) {
            return param * i;
        }).slice(1)), [
            0
        ]);
        return $244e96d31332d1e4$var$multyTime(newParams, t);
    };
}; // calculate cubic-bezier using Newton's method
var $244e96d31332d1e4$export$56c51296f72f0592 = function configBezier() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var x1 = args[0], y1 = args[1], x2 = args[2], y2 = args[3];
    if (args.length === 1) switch(args[0]){
        case "linear":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease":
            x1 = 0.25;
            y1 = 0.1;
            x2 = 0.25;
            y2 = 1.0;
            break;
        case "ease-in":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 1.0;
            y2 = 1.0;
            break;
        case "ease-out":
            x1 = 0.42;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        case "ease-in-out":
            x1 = 0.0;
            y1 = 0.0;
            x2 = 0.58;
            y2 = 1.0;
            break;
        default:
            var easing = args[0].split("(");
            if (easing[0] === "cubic-bezier" && easing[1].split(")")[0].split(",").length === 4) {
                var _easing$1$split$0$spl = easing[1].split(")")[0].split(",").map(function(x) {
                    return parseFloat(x);
                });
                var _easing$1$split$0$spl2 = $244e96d31332d1e4$var$_slicedToArray(_easing$1$split$0$spl, 4);
                x1 = _easing$1$split$0$spl2[0];
                y1 = _easing$1$split$0$spl2[1];
                x2 = _easing$1$split$0$spl2[2];
                y2 = _easing$1$split$0$spl2[3];
            } else (0, $95a61dc07598fcdc$export$c106dd0671a0fc2d)(false, "[configBezier]: arguments should be one of oneOf 'linear', 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', instead received %s", args);
    }
    (0, $95a61dc07598fcdc$export$c106dd0671a0fc2d)([
        x1,
        x2,
        y1,
        y2
    ].every(function(num) {
        return typeof num === "number" && num >= 0 && num <= 1;
    }), "[configBezier]: arguments should be x1, y1, x2, y2 of [0, 1] instead received %s", args);
    var curveX = $244e96d31332d1e4$var$cubicBezier(x1, x2);
    var curveY = $244e96d31332d1e4$var$cubicBezier(y1, y2);
    var derCurveX = $244e96d31332d1e4$var$derivativeCubicBezier(x1, x2);
    var rangeValue = function rangeValue(value) {
        if (value > 1) return 1;
        else if (value < 0) return 0;
        return value;
    };
    var bezier = function bezier(_t) {
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < $244e96d31332d1e4$var$ACCURACY || derVal < $244e96d31332d1e4$var$ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var $244e96d31332d1e4$export$12fc25daf62b865a = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _config$stiff = config.stiff, stiff = _config$stiff === void 0 ? 100 : _config$stiff, _config$damping = config.damping, damping = _config$damping === void 0 ? 8 : _config$damping, _config$dt = config.dt, dt = _config$dt === void 0 ? 17 : _config$dt;
    var stepper = function stepper(currX, destX, currV) {
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < $244e96d31332d1e4$var$ACCURACY && Math.abs(newV) < $244e96d31332d1e4$var$ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var $244e96d31332d1e4$export$e3e04925801e5434 = function configEasing() {
    for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
    var easing = args[0];
    if (typeof easing === "string") switch(easing){
        case "ease":
        case "ease-in-out":
        case "ease-out":
        case "ease-in":
        case "linear":
            return $244e96d31332d1e4$export$56c51296f72f0592(easing);
        case "spring":
            return $244e96d31332d1e4$export$12fc25daf62b865a();
        default:
            if (easing.split("(")[0] === "cubic-bezier") return $244e96d31332d1e4$export$56c51296f72f0592(easing);
            (0, $95a61dc07598fcdc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument should be one of 'ease', 'ease-in', 'ease-out', 'ease-in-out','cubic-bezier(x1,y1,x2,y2)', 'linear' and 'spring', instead  received %s", args);
    }
    if (typeof easing === "function") return easing;
    (0, $95a61dc07598fcdc$export$c106dd0671a0fc2d)(false, "[configEasing]: first argument type should be function or string, instead received %s", args);
    return null;
};



function $d9249d25b9faaac1$var$_toConsumableArray(arr) {
    return $d9249d25b9faaac1$var$_arrayWithoutHoles(arr) || $d9249d25b9faaac1$var$_iterableToArray(arr) || $d9249d25b9faaac1$var$_unsupportedIterableToArray(arr) || $d9249d25b9faaac1$var$_nonIterableSpread();
}
function $d9249d25b9faaac1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d9249d25b9faaac1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $d9249d25b9faaac1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $d9249d25b9faaac1$var$_arrayLikeToArray(arr);
}
function $d9249d25b9faaac1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d9249d25b9faaac1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d9249d25b9faaac1$var$ownKeys(Object(source), true).forEach(function(key) {
            $d9249d25b9faaac1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d9249d25b9faaac1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d9249d25b9faaac1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d9249d25b9faaac1$var$_slicedToArray(arr, i) {
    return $d9249d25b9faaac1$var$_arrayWithHoles(arr) || $d9249d25b9faaac1$var$_iterableToArrayLimit(arr, i) || $d9249d25b9faaac1$var$_unsupportedIterableToArray(arr, i) || $d9249d25b9faaac1$var$_nonIterableRest();
}
function $d9249d25b9faaac1$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $d9249d25b9faaac1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $d9249d25b9faaac1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $d9249d25b9faaac1$var$_arrayLikeToArray(o, minLen);
}
function $d9249d25b9faaac1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $d9249d25b9faaac1$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $d9249d25b9faaac1$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $d9249d25b9faaac1$var$alpha = function alpha(begin, end, k) {
    return begin + (end - begin) * k;
};
var $d9249d25b9faaac1$var$needContinue = function needContinue(_ref) {
    var from = _ref.from, to = _ref.to;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var $d9249d25b9faaac1$var$calStepperVals = function calStepperVals(easing, preVals, steps) {
    var nextStepVals = (0, $95a61dc07598fcdc$export$d6051a0f7a227332)(function(key, val) {
        if ($d9249d25b9faaac1$var$needContinue(val)) {
            var _easing = easing(val.from, val.to, val.velocity), _easing2 = $d9249d25b9faaac1$var$_slicedToArray(_easing, 2), newX = _easing2[0], newV = _easing2[1];
            return $d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, $95a61dc07598fcdc$export$d6051a0f7a227332)(function(key, val) {
        if ($d9249d25b9faaac1$var$needContinue(val)) return $d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, val), {}, {
            velocity: $d9249d25b9faaac1$var$alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: $d9249d25b9faaac1$var$alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
}; // configure update function
var $d9249d25b9faaac1$export$2e2bcd8739ae039 = function(from, to, easing, duration, render) {
    var interKeys = (0, $95a61dc07598fcdc$export$59e29973723da0b3)(from, to);
    var timingStyle = interKeys.reduce(function(res, key) {
        return $d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, res), {}, $d9249d25b9faaac1$var$_defineProperty({}, key, [
            from[key],
            to[key]
        ]));
    }, {});
    var stepperStyle = interKeys.reduce(function(res, key) {
        return $d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, res), {}, $d9249d25b9faaac1$var$_defineProperty({}, key, {
            from: from[key],
            velocity: 0,
            to: to[key]
        }));
    }, {});
    var cafId = -1;
    var preTime;
    var beginTime;
    var update = function update() {
        return null;
    };
    var getCurrStyle = function getCurrStyle() {
        return (0, $95a61dc07598fcdc$export$d6051a0f7a227332)(function(key, val) {
            return val.from;
        }, stepperStyle);
    };
    var shouldStopAnimation = function shouldStopAnimation() {
        return !Object.values(stepperStyle).filter($d9249d25b9faaac1$var$needContinue).length;
    }; // stepper timing function like spring
    var stepperUpdate = function stepperUpdate(now) {
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = $d9249d25b9faaac1$var$calStepperVals(easing, stepperStyle, steps); // get union set and add compatible prefix
        render($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, from), to), getCurrStyle(stepperStyle)));
        preTime = now;
        if (!shouldStopAnimation()) cafId = requestAnimationFrame(update);
    }; // t => val timing function like cubic-bezier
    var timingUpdate = function timingUpdate(now) {
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, $95a61dc07598fcdc$export$d6051a0f7a227332)(function(key, val) {
            return $d9249d25b9faaac1$var$alpha.apply(void 0, $d9249d25b9faaac1$var$_toConsumableArray(val).concat([
                easing(t)
            ]));
        }, timingStyle); // get union set and add compatible prefix
        render($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, from), to), currStyle));
        if (t < 1) cafId = requestAnimationFrame(update);
        else {
            var finalStyle = (0, $95a61dc07598fcdc$export$d6051a0f7a227332)(function(key, val) {
                return $d9249d25b9faaac1$var$alpha.apply(void 0, $d9249d25b9faaac1$var$_toConsumableArray(val).concat([
                    easing(1)
                ]));
            }, timingStyle);
            render($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread($d9249d25b9faaac1$var$_objectSpread({}, from), to), finalStyle));
        }
    };
    update = easing.isStepper ? stepperUpdate : timingUpdate; // return start animation method
    return function() {
        requestAnimationFrame(update); // return stop animation method
        return function() {
            cancelAnimationFrame(cafId);
        };
    };
};



function $53d6cb3bde67bbc8$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $53d6cb3bde67bbc8$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $53d6cb3bde67bbc8$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $53d6cb3bde67bbc8$var$_typeof(obj);
}
function $53d6cb3bde67bbc8$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $53d6cb3bde67bbc8$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $53d6cb3bde67bbc8$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $53d6cb3bde67bbc8$var$_toConsumableArray(arr) {
    return $53d6cb3bde67bbc8$var$_arrayWithoutHoles(arr) || $53d6cb3bde67bbc8$var$_iterableToArray(arr) || $53d6cb3bde67bbc8$var$_unsupportedIterableToArray(arr) || $53d6cb3bde67bbc8$var$_nonIterableSpread();
}
function $53d6cb3bde67bbc8$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $53d6cb3bde67bbc8$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $53d6cb3bde67bbc8$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $53d6cb3bde67bbc8$var$_arrayLikeToArray(o, minLen);
}
function $53d6cb3bde67bbc8$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $53d6cb3bde67bbc8$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $53d6cb3bde67bbc8$var$_arrayLikeToArray(arr);
}
function $53d6cb3bde67bbc8$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $53d6cb3bde67bbc8$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $53d6cb3bde67bbc8$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $53d6cb3bde67bbc8$var$ownKeys(Object(source), true).forEach(function(key) {
            $53d6cb3bde67bbc8$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $53d6cb3bde67bbc8$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $53d6cb3bde67bbc8$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $53d6cb3bde67bbc8$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $53d6cb3bde67bbc8$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53d6cb3bde67bbc8$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $53d6cb3bde67bbc8$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53d6cb3bde67bbc8$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $53d6cb3bde67bbc8$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $53d6cb3bde67bbc8$var$_setPrototypeOf(subClass, superClass);
}
function $53d6cb3bde67bbc8$var$_setPrototypeOf(o, p) {
    $53d6cb3bde67bbc8$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $53d6cb3bde67bbc8$var$_setPrototypeOf(o, p);
}
function $53d6cb3bde67bbc8$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $53d6cb3bde67bbc8$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $53d6cb3bde67bbc8$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $53d6cb3bde67bbc8$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $53d6cb3bde67bbc8$var$_possibleConstructorReturn(this, result);
    };
}
function $53d6cb3bde67bbc8$var$_possibleConstructorReturn(self, call) {
    if (call && ($53d6cb3bde67bbc8$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $53d6cb3bde67bbc8$var$_assertThisInitialized(self);
}
function $53d6cb3bde67bbc8$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $53d6cb3bde67bbc8$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $53d6cb3bde67bbc8$var$_getPrototypeOf(o) {
    $53d6cb3bde67bbc8$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $53d6cb3bde67bbc8$var$_getPrototypeOf(o);
}
var $53d6cb3bde67bbc8$var$Animate = /*#__PURE__*/ function(_PureComponent) {
    $53d6cb3bde67bbc8$var$_inherits(Animate, _PureComponent);
    var _super = $53d6cb3bde67bbc8$var$_createSuper(Animate);
    function Animate(props, context) {
        var _this;
        $53d6cb3bde67bbc8$var$_classCallCheck(this, Animate);
        _this = _super.call(this, props, context);
        var _this$props = _this.props, isActive = _this$props.isActive, attributeName = _this$props.attributeName, from = _this$props.from, to = _this$props.to, steps = _this$props.steps, children = _this$props.children;
        _this.handleStyleChange = _this.handleStyleChange.bind($53d6cb3bde67bbc8$var$_assertThisInitialized(_this));
        _this.changeStyle = _this.changeStyle.bind($53d6cb3bde67bbc8$var$_assertThisInitialized(_this));
        if (!isActive) {
            _this.state = {
                style: {}
            }; // if children is a function and animation is not active, set style to 'to'
            if (typeof children === "function") _this.state = {
                style: to
            };
            return $53d6cb3bde67bbc8$var$_possibleConstructorReturn(_this);
        }
        if (steps && steps.length) _this.state = {
            style: steps[0].style
        };
        else if (from) {
            if (typeof children === "function") {
                _this.state = {
                    style: from
                };
                return $53d6cb3bde67bbc8$var$_possibleConstructorReturn(_this);
            }
            _this.state = {
                style: attributeName ? $53d6cb3bde67bbc8$var$_defineProperty({}, attributeName, from) : from
            };
        } else _this.state = {
            style: {}
        };
        return _this;
    }
    $53d6cb3bde67bbc8$var$_createClass(Animate, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this$props2 = this.props, isActive = _this$props2.isActive, canBegin = _this$props2.canBegin;
                this.mounted = true;
                if (!isActive || !canBegin) return;
                this.runAnimation(this.props);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props3 = this.props, isActive = _this$props3.isActive, canBegin = _this$props3.canBegin, attributeName = _this$props3.attributeName, shouldReAnimate = _this$props3.shouldReAnimate;
                if (!canBegin) return;
                if (!isActive) {
                    var newState = {
                        style: attributeName ? $53d6cb3bde67bbc8$var$_defineProperty({}, attributeName, this.props.to) : this.props.to
                    };
                    if (this.state && this.state.style) {
                        if (attributeName && this.state.style[attributeName] !== this.props.to || !attributeName && this.state.style !== this.props.to) // eslint-disable-next-line react/no-did-update-set-state
                        this.setState(newState);
                    }
                    return;
                }
                if ((0, $36bfcd01a3983471$exports.deepEqual)(prevProps.to, this.props.to) && prevProps.canBegin && prevProps.isActive) return;
                var isTriggered = !prevProps.canBegin || !prevProps.isActive;
                if (this.manager) this.manager.stop();
                if (this.stopJSAnimation) this.stopJSAnimation();
                var from = isTriggered || shouldReAnimate ? this.props.from : prevProps.to;
                if (this.state && this.state.style) {
                    var _newState = {
                        style: attributeName ? $53d6cb3bde67bbc8$var$_defineProperty({}, attributeName, from) : from
                    };
                    if (attributeName && this.state.style[attributeName] !== from || !attributeName && this.state.style !== from) // eslint-disable-next-line react/no-did-update-set-state
                    this.setState(_newState);
                }
                this.runAnimation($53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread({}, this.props), {}, {
                    from: from,
                    begin: 0
                }));
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.mounted = false;
                if (this.unSubscribe) this.unSubscribe();
                if (this.manager) {
                    this.manager.stop();
                    this.manager = null;
                }
                if (this.stopJSAnimation) this.stopJSAnimation();
            }
        },
        {
            key: "runJSAnimation",
            value: function runJSAnimation(props) {
                var _this2 = this;
                var from = props.from, to = props.to, duration = props.duration, easing = props.easing, begin = props.begin, onAnimationEnd = props.onAnimationEnd, onAnimationStart = props.onAnimationStart;
                var startAnimation = (0, $d9249d25b9faaac1$export$2e2bcd8739ae039)(from, to, (0, $244e96d31332d1e4$export$e3e04925801e5434)(easing), duration, this.changeStyle);
                var finalStartAnimation = function finalStartAnimation() {
                    _this2.stopJSAnimation = startAnimation();
                };
                this.manager.start([
                    onAnimationStart,
                    begin,
                    finalStartAnimation,
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "runStepAnimation",
            value: function runStepAnimation(props) {
                var _this3 = this;
                var steps = props.steps, begin = props.begin, onAnimationStart = props.onAnimationStart;
                var _steps$ = steps[0], initialStyle = _steps$.style, _steps$$duration = _steps$.duration, initialTime = _steps$$duration === void 0 ? 0 : _steps$$duration;
                var addStyle = function addStyle(sequence, nextItem, index) {
                    if (index === 0) return sequence;
                    var duration = nextItem.duration, _nextItem$easing = nextItem.easing, easing = _nextItem$easing === void 0 ? "ease" : _nextItem$easing, style = nextItem.style, nextProperties = nextItem.properties, onAnimationEnd = nextItem.onAnimationEnd;
                    var preItem = index > 0 ? steps[index - 1] : nextItem;
                    var properties = nextProperties || Object.keys(style);
                    if (typeof easing === "function" || easing === "spring") return [].concat($53d6cb3bde67bbc8$var$_toConsumableArray(sequence), [
                        _this3.runJSAnimation.bind(_this3, {
                            from: preItem.style,
                            to: style,
                            duration: duration,
                            easing: easing
                        }),
                        duration
                    ]);
                    var transition = (0, $95a61dc07598fcdc$export$1594c78389ee3429)(properties, duration, easing);
                    var newStyle = $53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread({}, preItem.style), style), {}, {
                        transition: transition
                    });
                    return [].concat($53d6cb3bde67bbc8$var$_toConsumableArray(sequence), [
                        newStyle,
                        duration,
                        onAnimationEnd
                    ]).filter((0, $95a61dc07598fcdc$export$f0954fd7d5368655));
                };
                return this.manager.start([
                    onAnimationStart
                ].concat($53d6cb3bde67bbc8$var$_toConsumableArray(steps.reduce(addStyle, [
                    initialStyle,
                    Math.max(initialTime, begin)
                ])), [
                    props.onAnimationEnd
                ]));
            }
        },
        {
            key: "runAnimation",
            value: function runAnimation(props) {
                if (!this.manager) this.manager = (0, $a980a386ff6236bc$export$2e2bcd8739ae039)();
                var begin = props.begin, duration = props.duration, attributeName = props.attributeName, propsTo = props.to, easing = props.easing, onAnimationStart = props.onAnimationStart, onAnimationEnd = props.onAnimationEnd, steps = props.steps, children = props.children;
                var manager = this.manager;
                this.unSubscribe = manager.subscribe(this.handleStyleChange);
                if (typeof easing === "function" || typeof children === "function" || easing === "spring") {
                    this.runJSAnimation(props);
                    return;
                }
                if (steps.length > 1) {
                    this.runStepAnimation(props);
                    return;
                }
                var to = attributeName ? $53d6cb3bde67bbc8$var$_defineProperty({}, attributeName, propsTo) : propsTo;
                var transition = (0, $95a61dc07598fcdc$export$1594c78389ee3429)(Object.keys(to), duration, easing);
                manager.start([
                    onAnimationStart,
                    begin,
                    $53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread({}, to), {}, {
                        transition: transition
                    }),
                    duration,
                    onAnimationEnd
                ]);
            }
        },
        {
            key: "handleStyleChange",
            value: function handleStyleChange(style) {
                this.changeStyle(style);
            }
        },
        {
            key: "changeStyle",
            value: function changeStyle(style) {
                if (this.mounted) this.setState({
                    style: style
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, children = _this$props4.children, begin = _this$props4.begin, duration = _this$props4.duration, attributeName = _this$props4.attributeName, easing = _this$props4.easing, isActive = _this$props4.isActive, steps = _this$props4.steps, from = _this$props4.from, to = _this$props4.to, canBegin = _this$props4.canBegin, onAnimationEnd = _this$props4.onAnimationEnd, shouldReAnimate = _this$props4.shouldReAnimate, onAnimationReStart = _this$props4.onAnimationReStart, others = $53d6cb3bde67bbc8$var$_objectWithoutProperties(_this$props4, [
                    "children",
                    "begin",
                    "duration",
                    "attributeName",
                    "easing",
                    "isActive",
                    "steps",
                    "from",
                    "to",
                    "canBegin",
                    "onAnimationEnd",
                    "shouldReAnimate",
                    "onAnimationReStart"
                ]);
                var count = (0, $eCoWV.Children).count(children);
                var stateStyle = (0, $95a61dc07598fcdc$export$ff9926a5d1daa67c)(this.state.style);
                if (typeof children === "function") return children(stateStyle);
                if (!isActive || count === 0) return children;
                var cloneContainer = function cloneContainer(container) {
                    var _container$props = container.props, _container$props$styl = _container$props.style, style = _container$props$styl === void 0 ? {} : _container$props$styl, className = _container$props.className;
                    var res = /*#__PURE__*/ (0, $eCoWV.cloneElement)(container, $53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread({}, others), {}, {
                        style: $53d6cb3bde67bbc8$var$_objectSpread($53d6cb3bde67bbc8$var$_objectSpread({}, style), stateStyle),
                        className: className
                    }));
                    return res;
                };
                if (count === 1) return cloneContainer((0, $eCoWV.Children).only(children));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", null, (0, $eCoWV.Children).map(children, function(child) {
                    return cloneContainer(child);
                }));
            }
        }
    ]);
    return Animate;
}((0, $eCoWV.PureComponent));
$53d6cb3bde67bbc8$var$Animate.displayName = "Animate";
$53d6cb3bde67bbc8$var$Animate.propTypes = {
    from: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string
    ]),
    to: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string
    ]),
    attributeName: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
    // animation duration
    duration: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    begin: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number,
    easing: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
    ]),
    steps: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf((0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).shape({
        duration: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).number.isRequired,
        style: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object.isRequired,
        easing: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOf([
                "ease",
                "ease-in",
                "ease-out",
                "ease-in-out",
                "linear"
            ]),
            (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
        ]),
        // transition css properties(dash case), optional
        properties: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).arrayOf("string"),
        onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
    })),
    children: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).node,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
    ]),
    isActive: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    canBegin: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    onAnimationEnd: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    // decide if it should reanimate with initial from style when props change
    shouldReAnimate: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).bool,
    onAnimationStart: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func,
    onAnimationReStart: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).func
};
$53d6cb3bde67bbc8$var$Animate.defaultProps = {
    begin: 0,
    duration: 1000,
    from: "",
    to: "",
    attributeName: "",
    easing: "ease",
    isActive: true,
    canBegin: true,
    steps: [],
    onAnimationEnd: function onAnimationEnd() {},
    onAnimationStart: function onAnimationStart() {}
};
var $53d6cb3bde67bbc8$export$2e2bcd8739ae039 = $53d6cb3bde67bbc8$var$Animate;





var $eCoWV = parcelRequire("eCoWV");
var $d6838d1b5890782b$exports = {};
"use strict";

var $d6838d1b5890782b$var$_CSSTransition = $d6838d1b5890782b$var$_interopRequireDefault((parcelRequire("daYMR")));

var $d6838d1b5890782b$var$_ReplaceTransition = $d6838d1b5890782b$var$_interopRequireDefault((parcelRequire("buvfY")));

var $d6838d1b5890782b$var$_TransitionGroup = $d6838d1b5890782b$var$_interopRequireDefault((parcelRequire("g8KCq")));

var $d6838d1b5890782b$var$_Transition = $d6838d1b5890782b$var$_interopRequireDefault((parcelRequire("cvGLH")));
function $d6838d1b5890782b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
$d6838d1b5890782b$exports = {
    Transition: $d6838d1b5890782b$var$_Transition.default,
    TransitionGroup: $d6838d1b5890782b$var$_TransitionGroup.default,
    ReplaceTransition: $d6838d1b5890782b$var$_ReplaceTransition.default,
    CSSTransition: $d6838d1b5890782b$var$_CSSTransition.default
};



var $hqomP = parcelRequire("hqomP");

var $eCoWV = parcelRequire("eCoWV");


var $hqomP = parcelRequire("hqomP");

function $062c7a48ca675ac6$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $062c7a48ca675ac6$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $062c7a48ca675ac6$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $062c7a48ca675ac6$var$_typeof(obj);
}
function $062c7a48ca675ac6$var$_extends() {
    $062c7a48ca675ac6$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $062c7a48ca675ac6$var$_extends.apply(this, arguments);
}
function $062c7a48ca675ac6$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $062c7a48ca675ac6$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $062c7a48ca675ac6$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $062c7a48ca675ac6$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $062c7a48ca675ac6$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $062c7a48ca675ac6$var$ownKeys(Object(source), true).forEach(function(key) {
            $062c7a48ca675ac6$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $062c7a48ca675ac6$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $062c7a48ca675ac6$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $062c7a48ca675ac6$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $062c7a48ca675ac6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $062c7a48ca675ac6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $062c7a48ca675ac6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $062c7a48ca675ac6$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $062c7a48ca675ac6$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $062c7a48ca675ac6$var$_setPrototypeOf(subClass, superClass);
}
function $062c7a48ca675ac6$var$_setPrototypeOf(o, p) {
    $062c7a48ca675ac6$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $062c7a48ca675ac6$var$_setPrototypeOf(o, p);
}
function $062c7a48ca675ac6$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $062c7a48ca675ac6$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $062c7a48ca675ac6$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $062c7a48ca675ac6$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $062c7a48ca675ac6$var$_possibleConstructorReturn(this, result);
    };
}
function $062c7a48ca675ac6$var$_possibleConstructorReturn(self, call) {
    if (call && ($062c7a48ca675ac6$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $062c7a48ca675ac6$var$_assertThisInitialized(self);
}
function $062c7a48ca675ac6$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $062c7a48ca675ac6$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $062c7a48ca675ac6$var$_getPrototypeOf(o) {
    $062c7a48ca675ac6$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $062c7a48ca675ac6$var$_getPrototypeOf(o);
}
if (Number.isFinite === undefined) Number.isFinite = function(value) {
    return typeof value === "number" && isFinite(value);
};
var $062c7a48ca675ac6$var$parseDurationOfSingleTransition = function parseDurationOfSingleTransition() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var steps = options.steps, duration = options.duration;
    if (steps && steps.length) return steps.reduce(function(result, entry) {
        return result + (Number.isFinite(entry.duration) && entry.duration > 0 ? entry.duration : 0);
    }, 0);
    if (Number.isFinite(duration)) return duration;
    return 0;
};
var $062c7a48ca675ac6$var$AnimateGroupChild = /*#__PURE__*/ function(_Component) {
    $062c7a48ca675ac6$var$_inherits(AnimateGroupChild, _Component);
    var _super = $062c7a48ca675ac6$var$_createSuper(AnimateGroupChild);
    function AnimateGroupChild() {
        var _this;
        $062c7a48ca675ac6$var$_classCallCheck(this, AnimateGroupChild);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            isActive: false
        };
        _this.handleEnter = function(node, isAppearing) {
            var _this$props = _this.props, appearOptions = _this$props.appearOptions, enterOptions = _this$props.enterOptions;
            _this.handleStyleActive(isAppearing ? appearOptions : enterOptions);
        };
        _this.handleExit = function() {
            _this.handleStyleActive(_this.props.leaveOptions);
        };
        return _this;
    }
    $062c7a48ca675ac6$var$_createClass(AnimateGroupChild, [
        {
            key: "handleStyleActive",
            value: function handleStyleActive(style) {
                if (style) {
                    var onAnimationEnd = style.onAnimationEnd ? function() {
                        style.onAnimationEnd();
                    } : null;
                    this.setState($062c7a48ca675ac6$var$_objectSpread($062c7a48ca675ac6$var$_objectSpread({}, style), {}, {
                        onAnimationEnd: onAnimationEnd,
                        isActive: true
                    }));
                }
            }
        },
        {
            key: "parseTimeout",
            value: function parseTimeout() {
                var _this$props2 = this.props, appearOptions = _this$props2.appearOptions, enterOptions = _this$props2.enterOptions, leaveOptions = _this$props2.leaveOptions;
                return $062c7a48ca675ac6$var$parseDurationOfSingleTransition(appearOptions) + $062c7a48ca675ac6$var$parseDurationOfSingleTransition(enterOptions) + $062c7a48ca675ac6$var$parseDurationOfSingleTransition(leaveOptions);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props3 = this.props, children = _this$props3.children, appearOptions = _this$props3.appearOptions, enterOptions = _this$props3.enterOptions, leaveOptions = _this$props3.leaveOptions, props = $062c7a48ca675ac6$var$_objectWithoutProperties(_this$props3, [
                    "children",
                    "appearOptions",
                    "enterOptions",
                    "leaveOptions"
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d6838d1b5890782b$exports.Transition), $062c7a48ca675ac6$var$_extends({}, props, {
                    onEnter: this.handleEnter,
                    onExit: this.handleExit,
                    timeout: this.parseTimeout()
                }), function() {
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $53d6cb3bde67bbc8$export$2e2bcd8739ae039), _this2.state, (0, $eCoWV.Children).only(children));
                });
            }
        }
    ]);
    return AnimateGroupChild;
}((0, $eCoWV.Component));
$062c7a48ca675ac6$var$AnimateGroupChild.propTypes = {
    appearOptions: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    enterOptions: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    leaveOptions: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).element
};
var $062c7a48ca675ac6$export$2e2bcd8739ae039 = $062c7a48ca675ac6$var$AnimateGroupChild;


function $633e748abba5380f$var$AnimateGroup(props) {
    var component = props.component, children = props.children, appear = props.appear, enter = props.enter, leave = props.leave;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d6838d1b5890782b$exports.TransitionGroup), {
        component: component
    }, (0, $eCoWV.Children).map(children, function(child, index) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $062c7a48ca675ac6$export$2e2bcd8739ae039), {
            appearOptions: appear,
            enterOptions: enter,
            leaveOptions: leave,
            key: "child-".concat(index) // eslint-disable-line
        }, child);
    }));
}
$633e748abba5380f$var$AnimateGroup.propTypes = {
    appear: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    enter: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    leave: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).object,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).array,
        (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).element
    ]),
    component: (0, (/*@__PURE__*/$parcel$interopDefault($hqomP))).any
};
$633e748abba5380f$var$AnimateGroup.defaultProps = {
    component: "span"
};
var $633e748abba5380f$export$2e2bcd8739ae039 = $633e748abba5380f$var$AnimateGroup;


var $d7ffd80b59fbbca7$export$2e2bcd8739ae039 = (0, $53d6cb3bde67bbc8$export$2e2bcd8739ae039);



var $bace4a80b17174f2$exports = {};
var $ace6f55aba7d3db6$exports = {};
var $c67fa5de644d9540$exports = {};
var $f9fa78115a1768e6$exports = {};
/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */ function $f9fa78115a1768e6$var$baseSlice(array, start, end) {
    var index = -1, length = array.length;
    if (start < 0) start = -start > length ? 0 : length + start;
    end = end > length ? length : end;
    if (end < 0) end += length;
    length = start > end ? 0 : end - start >>> 0;
    start >>>= 0;
    var result = Array(length);
    while(++index < length)result[index] = array[index + start];
    return result;
}
$f9fa78115a1768e6$exports = $f9fa78115a1768e6$var$baseSlice;


/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */ function $c67fa5de644d9540$var$castSlice(array, start, end) {
    var length = array.length;
    end = end === undefined ? length : end;
    return !start && end >= length ? array : $f9fa78115a1768e6$exports(array, start, end);
}
$c67fa5de644d9540$exports = $c67fa5de644d9540$var$castSlice;


var $5a7a65ee10574d6a$exports = {};
/** Used to compose unicode character classes. */ var $5a7a65ee10574d6a$var$rsAstralRange = "\ud800-\udfff", $5a7a65ee10574d6a$var$rsComboMarksRange = "\\u0300-\\u036f", $5a7a65ee10574d6a$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $5a7a65ee10574d6a$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $5a7a65ee10574d6a$var$rsComboRange = $5a7a65ee10574d6a$var$rsComboMarksRange + $5a7a65ee10574d6a$var$reComboHalfMarksRange + $5a7a65ee10574d6a$var$rsComboSymbolsRange, $5a7a65ee10574d6a$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $5a7a65ee10574d6a$var$rsZWJ = "\\u200d";
/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */ var $5a7a65ee10574d6a$var$reHasUnicode = RegExp("[" + $5a7a65ee10574d6a$var$rsZWJ + $5a7a65ee10574d6a$var$rsAstralRange + $5a7a65ee10574d6a$var$rsComboRange + $5a7a65ee10574d6a$var$rsVarRange + "]");
/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */ function $5a7a65ee10574d6a$var$hasUnicode(string) {
    return $5a7a65ee10574d6a$var$reHasUnicode.test(string);
}
$5a7a65ee10574d6a$exports = $5a7a65ee10574d6a$var$hasUnicode;


var $64001dbd22cf125f$exports = {};
var $1d2ecb3c50efe2df$exports = {};
/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $1d2ecb3c50efe2df$var$asciiToArray(string) {
    return string.split("");
}
$1d2ecb3c50efe2df$exports = $1d2ecb3c50efe2df$var$asciiToArray;



var $33d7f4d0533cba8d$exports = {};
/** Used to compose unicode character classes. */ var $33d7f4d0533cba8d$var$rsAstralRange = "\ud800-\udfff", $33d7f4d0533cba8d$var$rsComboMarksRange = "\\u0300-\\u036f", $33d7f4d0533cba8d$var$reComboHalfMarksRange = "\\ufe20-\\ufe2f", $33d7f4d0533cba8d$var$rsComboSymbolsRange = "\\u20d0-\\u20ff", $33d7f4d0533cba8d$var$rsComboRange = $33d7f4d0533cba8d$var$rsComboMarksRange + $33d7f4d0533cba8d$var$reComboHalfMarksRange + $33d7f4d0533cba8d$var$rsComboSymbolsRange, $33d7f4d0533cba8d$var$rsVarRange = "\\ufe0e\\ufe0f";
/** Used to compose unicode capture groups. */ var $33d7f4d0533cba8d$var$rsAstral = "[" + $33d7f4d0533cba8d$var$rsAstralRange + "]", $33d7f4d0533cba8d$var$rsCombo = "[" + $33d7f4d0533cba8d$var$rsComboRange + "]", $33d7f4d0533cba8d$var$rsFitz = "\ud83c[\udffb-\udfff]", $33d7f4d0533cba8d$var$rsModifier = "(?:" + $33d7f4d0533cba8d$var$rsCombo + "|" + $33d7f4d0533cba8d$var$rsFitz + ")", $33d7f4d0533cba8d$var$rsNonAstral = "[^" + $33d7f4d0533cba8d$var$rsAstralRange + "]", $33d7f4d0533cba8d$var$rsRegional = "(?:\ud83c[\udde6-\uddff]){2}", $33d7f4d0533cba8d$var$rsSurrPair = "[\ud800-\udbff][\udc00-\udfff]", $33d7f4d0533cba8d$var$rsZWJ = "\\u200d";
/** Used to compose unicode regexes. */ var $33d7f4d0533cba8d$var$reOptMod = $33d7f4d0533cba8d$var$rsModifier + "?", $33d7f4d0533cba8d$var$rsOptVar = "[" + $33d7f4d0533cba8d$var$rsVarRange + "]?", $33d7f4d0533cba8d$var$rsOptJoin = "(?:" + $33d7f4d0533cba8d$var$rsZWJ + "(?:" + [
    $33d7f4d0533cba8d$var$rsNonAstral,
    $33d7f4d0533cba8d$var$rsRegional,
    $33d7f4d0533cba8d$var$rsSurrPair
].join("|") + ")" + $33d7f4d0533cba8d$var$rsOptVar + $33d7f4d0533cba8d$var$reOptMod + ")*", $33d7f4d0533cba8d$var$rsSeq = $33d7f4d0533cba8d$var$rsOptVar + $33d7f4d0533cba8d$var$reOptMod + $33d7f4d0533cba8d$var$rsOptJoin, $33d7f4d0533cba8d$var$rsSymbol = "(?:" + [
    $33d7f4d0533cba8d$var$rsNonAstral + $33d7f4d0533cba8d$var$rsCombo + "?",
    $33d7f4d0533cba8d$var$rsCombo,
    $33d7f4d0533cba8d$var$rsRegional,
    $33d7f4d0533cba8d$var$rsSurrPair,
    $33d7f4d0533cba8d$var$rsAstral
].join("|") + ")";
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $33d7f4d0533cba8d$var$reUnicode = RegExp($33d7f4d0533cba8d$var$rsFitz + "(?=" + $33d7f4d0533cba8d$var$rsFitz + ")|" + $33d7f4d0533cba8d$var$rsSymbol + $33d7f4d0533cba8d$var$rsSeq, "g");
/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $33d7f4d0533cba8d$var$unicodeToArray(string) {
    return string.match($33d7f4d0533cba8d$var$reUnicode) || [];
}
$33d7f4d0533cba8d$exports = $33d7f4d0533cba8d$var$unicodeToArray;


/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */ function $64001dbd22cf125f$var$stringToArray(string) {
    return $5a7a65ee10574d6a$exports(string) ? $33d7f4d0533cba8d$exports(string) : $1d2ecb3c50efe2df$exports(string);
}
$64001dbd22cf125f$exports = $64001dbd22cf125f$var$stringToArray;



/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */ function $ace6f55aba7d3db6$var$createCaseFirst(methodName) {
    return function(string) {
        string = $b54895e624e7fc74$exports(string);
        var strSymbols = $5a7a65ee10574d6a$exports(string) ? $64001dbd22cf125f$exports(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? $c67fa5de644d9540$exports(strSymbols, 1).join("") : string.slice(1);
        return chr[methodName]() + trailing;
    };
}
$ace6f55aba7d3db6$exports = $ace6f55aba7d3db6$var$createCaseFirst;


/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */ var $bace4a80b17174f2$var$upperFirst = $ace6f55aba7d3db6$exports("toUpperCase");
$bace4a80b17174f2$exports = $bace4a80b17174f2$var$upperFirst;




var $eCoWV = parcelRequire("eCoWV");
const $fef862baa9a89322$var$pi = Math.PI, $fef862baa9a89322$var$tau = 2 * $fef862baa9a89322$var$pi, $fef862baa9a89322$var$epsilon = 1e-6, $fef862baa9a89322$var$tauEpsilon = $fef862baa9a89322$var$tau - $fef862baa9a89322$var$epsilon;
function $fef862baa9a89322$var$Path() {
    this._x0 = this._y0 = this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function $fef862baa9a89322$var$path() {
    return new $fef862baa9a89322$var$Path;
}
$fef862baa9a89322$var$Path.prototype = $fef862baa9a89322$var$path.prototype = {
    constructor: $fef862baa9a89322$var$Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > $fef862baa9a89322$var$epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > $fef862baa9a89322$var$epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan(($fef862baa9a89322$var$pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > $fef862baa9a89322$var$epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > $fef862baa9a89322$var$epsilon || Math.abs(this._y1 - y0) > $fef862baa9a89322$var$epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % $fef862baa9a89322$var$tau + $fef862baa9a89322$var$tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > $fef862baa9a89322$var$tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > $fef862baa9a89322$var$epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= $fef862baa9a89322$var$pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var $fef862baa9a89322$export$2e2bcd8739ae039 = $fef862baa9a89322$var$path;


var $7a305163978c18e2$export$58adb3bec8346d0f = Array.prototype.slice;
function $7a305163978c18e2$export$2e2bcd8739ae039(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}


function $5c5e96e92443e707$export$2e2bcd8739ae039(x) {
    return function constant() {
        return x;
    };
}


function $b61574f0d85ec581$var$Linear(context) {
    this._context = context;
}
$b61574f0d85ec581$var$Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function $b61574f0d85ec581$export$2e2bcd8739ae039(context) {
    return new $b61574f0d85ec581$var$Linear(context);
}






function $7d41d41f1bbbd231$export$d141bba7fdc215a3(p) {
    return p[0];
}
function $7d41d41f1bbbd231$export$4a5767248b18ef41(p) {
    return p[1];
}


function $d0017b2e97e8acad$export$2e2bcd8739ae039(x, y) {
    var defined = (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(true), context = null, curve = (0, $b61574f0d85ec581$export$2e2bcd8739ae039), output = null;
    x = typeof x === "function" ? x : x === undefined ? (0, $7d41d41f1bbbd231$export$d141bba7fdc215a3) : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(x);
    y = typeof y === "function" ? y : y === undefined ? (0, $7d41d41f1bbbd231$export$4a5767248b18ef41) : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(y);
    function line(data) {
        var i, n = (data = (0, $7a305163978c18e2$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, $fef862baa9a89322$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}



function $87c0eb3e100c263b$export$2e2bcd8739ae039(x0, y0, y1) {
    var x1 = null, defined = (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(true), context = null, curve = (0, $b61574f0d85ec581$export$2e2bcd8739ae039), output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? (0, $7d41d41f1bbbd231$export$d141bba7fdc215a3) : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(0) : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? (0, $7d41d41f1bbbd231$export$4a5767248b18ef41) : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, $7a305163978c18e2$export$2e2bcd8739ae039)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, $fef862baa9a89322$export$2e2bcd8739ae039)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, $d0017b2e97e8acad$export$2e2bcd8739ae039)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

function $7256b28551f3ccbb$export$105684a3041cb6f3(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function $7256b28551f3ccbb$export$957f7263e89bedd2(context) {
    this._context = context;
}
$7256b28551f3ccbb$export$957f7263e89bedd2.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                $7256b28551f3ccbb$export$105684a3041cb6f3(this, this._x1, this._y1); // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6); // falls through
            default:
                $7256b28551f3ccbb$export$105684a3041cb6f3(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $7256b28551f3ccbb$export$2e2bcd8739ae039(context) {
    return new $7256b28551f3ccbb$export$957f7263e89bedd2(context);
}

function $3a36dcb4b86862f4$export$2e2bcd8739ae039() {}



function $587abb3050c4a44f$var$BasisClosed(context) {
    this._context = context;
}
$587abb3050c4a44f$var$BasisClosed.prototype = {
    areaStart: (0, $3a36dcb4b86862f4$export$2e2bcd8739ae039),
    areaEnd: (0, $3a36dcb4b86862f4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, $7256b28551f3ccbb$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $587abb3050c4a44f$export$2e2bcd8739ae039(context) {
    return new $587abb3050c4a44f$var$BasisClosed(context);
}


function $9c65b5954a0b3552$var$BasisOpen(context) {
    this._context = context;
}
$9c65b5954a0b3552$var$BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4; // falls through
            default:
                (0, $7256b28551f3ccbb$export$105684a3041cb6f3)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function $9c65b5954a0b3552$export$2e2bcd8739ae039(context) {
    return new $9c65b5954a0b3552$var$BasisOpen(context);
}


function $7d715575e273a4eb$var$LinearClosed(context) {
    this._context = context;
}
$7d715575e273a4eb$var$LinearClosed.prototype = {
    areaStart: (0, $3a36dcb4b86862f4$export$2e2bcd8739ae039),
    areaEnd: (0, $3a36dcb4b86862f4$export$2e2bcd8739ae039),
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function $7d715575e273a4eb$export$2e2bcd8739ae039(context) {
    return new $7d715575e273a4eb$var$LinearClosed(context);
}

function $cb7427e0621d7ff1$var$sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function $cb7427e0621d7ff1$var$slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return ($cb7427e0621d7ff1$var$sign(s0) + $cb7427e0621d7ff1$var$sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function $cb7427e0621d7ff1$var$slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function $cb7427e0621d7ff1$var$point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function $cb7427e0621d7ff1$var$MonotoneX(context) {
    this._context = context;
}
$cb7427e0621d7ff1$var$MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                $cb7427e0621d7ff1$var$point(this, this._t0, $cb7427e0621d7ff1$var$slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                $cb7427e0621d7ff1$var$point(this, $cb7427e0621d7ff1$var$slope2(this, t1 = $cb7427e0621d7ff1$var$slope3(this, x, y)), t1);
                break;
            default:
                $cb7427e0621d7ff1$var$point(this, this._t0, t1 = $cb7427e0621d7ff1$var$slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function $cb7427e0621d7ff1$var$MonotoneY(context) {
    this._context = new $cb7427e0621d7ff1$var$ReflectContext(context);
}
($cb7427e0621d7ff1$var$MonotoneY.prototype = Object.create($cb7427e0621d7ff1$var$MonotoneX.prototype)).point = function(x, y) {
    $cb7427e0621d7ff1$var$MonotoneX.prototype.point.call(this, y, x);
};
function $cb7427e0621d7ff1$var$ReflectContext(context) {
    this._context = context;
}
$cb7427e0621d7ff1$var$ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function $cb7427e0621d7ff1$export$99563b5420dbdc55(context) {
    return new $cb7427e0621d7ff1$var$MonotoneX(context);
}
function $cb7427e0621d7ff1$export$8b5360456d6bdb88(context) {
    return new $cb7427e0621d7ff1$var$MonotoneY(context);
}

function $66f91a29ca3796db$var$Natural(context) {
    this._context = context;
}
$66f91a29ca3796db$var$Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = $66f91a29ca3796db$var$controlPoints(x), py = $66f91a29ca3796db$var$controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function $66f91a29ca3796db$var$controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function $66f91a29ca3796db$export$2e2bcd8739ae039(context) {
    return new $66f91a29ca3796db$var$Natural(context);
}

function $b54a1ba879f543bc$var$Step(context, t) {
    this._context = context;
    this._t = t;
}
$b54a1ba879f543bc$var$Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2; // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function $b54a1ba879f543bc$export$2e2bcd8739ae039(context) {
    return new $b54a1ba879f543bc$var$Step(context, 0.5);
}
function $b54a1ba879f543bc$export$10eafa5b7478b343(context) {
    return new $b54a1ba879f543bc$var$Step(context, 0);
}
function $b54a1ba879f543bc$export$793b3db073781cbb(context) {
    return new $b54a1ba879f543bc$var$Step(context, 1);
}



var $iyeK6 = parcelRequire("iyeK6");


var $eCoWV = parcelRequire("eCoWV");
function $dd873d09408694ab$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $dd873d09408694ab$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $dd873d09408694ab$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $dd873d09408694ab$var$_typeof(obj);
}
var $dd873d09408694ab$var$SVGContainerPropKeys = [
    "viewBox",
    "children"
];
var $dd873d09408694ab$var$SVGElementPropKeys = [
    "aria-activedescendant",
    "aria-atomic",
    "aria-autocomplete",
    "aria-busy",
    "aria-checked",
    "aria-colcount",
    "aria-colindex",
    "aria-colspan",
    "aria-controls",
    "aria-current",
    "aria-describedby",
    "aria-details",
    "aria-disabled",
    "aria-errormessage",
    "aria-expanded",
    "aria-flowto",
    "aria-haspopup",
    "aria-hidden",
    "aria-invalid",
    "aria-keyshortcuts",
    "aria-label",
    "aria-labelledby",
    "aria-level",
    "aria-live",
    "aria-modal",
    "aria-multiline",
    "aria-multiselectable",
    "aria-orientation",
    "aria-owns",
    "aria-placeholder",
    "aria-posinset",
    "aria-pressed",
    "aria-readonly",
    "aria-relevant",
    "aria-required",
    "aria-roledescription",
    "aria-rowcount",
    "aria-rowindex",
    "aria-rowspan",
    "aria-selected",
    "aria-setsize",
    "aria-sort",
    "aria-valuemax",
    "aria-valuemin",
    "aria-valuenow",
    "aria-valuetext",
    "className",
    "color",
    "height",
    "id",
    "lang",
    "max",
    "media",
    "method",
    "min",
    "name",
    "style",
    "target",
    "type",
    "width",
    "role",
    "tabIndex",
    "accentHeight",
    "accumulate",
    "additive",
    "alignmentBaseline",
    "allowReorder",
    "alphabetic",
    "amplitude",
    "arabicForm",
    "ascent",
    "attributeName",
    "attributeType",
    "autoReverse",
    "azimuth",
    "baseFrequency",
    "baselineShift",
    "baseProfile",
    "bbox",
    "begin",
    "bias",
    "by",
    "calcMode",
    "capHeight",
    "clip",
    "clipPath",
    "clipPathUnits",
    "clipRule",
    "colorInterpolation",
    "colorInterpolationFilters",
    "colorProfile",
    "colorRendering",
    "contentScriptType",
    "contentStyleType",
    "cursor",
    "cx",
    "cy",
    "d",
    "decelerate",
    "descent",
    "diffuseConstant",
    "direction",
    "display",
    "divisor",
    "dominantBaseline",
    "dur",
    "dx",
    "dy",
    "edgeMode",
    "elevation",
    "enableBackground",
    "end",
    "exponent",
    "externalResourcesRequired",
    "fill",
    "fillOpacity",
    "fillRule",
    "filter",
    "filterRes",
    "filterUnits",
    "floodColor",
    "floodOpacity",
    "focusable",
    "fontFamily",
    "fontSize",
    "fontSizeAdjust",
    "fontStretch",
    "fontStyle",
    "fontVariant",
    "fontWeight",
    "format",
    "from",
    "fx",
    "fy",
    "g1",
    "g2",
    "glyphName",
    "glyphOrientationHorizontal",
    "glyphOrientationVertical",
    "glyphRef",
    "gradientTransform",
    "gradientUnits",
    "hanging",
    "horizAdvX",
    "horizOriginX",
    "href",
    "ideographic",
    "imageRendering",
    "in2",
    "in",
    "intercept",
    "k1",
    "k2",
    "k3",
    "k4",
    "k",
    "kernelMatrix",
    "kernelUnitLength",
    "kerning",
    "keyPoints",
    "keySplines",
    "keyTimes",
    "lengthAdjust",
    "letterSpacing",
    "lightingColor",
    "limitingConeAngle",
    "local",
    "markerEnd",
    "markerHeight",
    "markerMid",
    "markerStart",
    "markerUnits",
    "markerWidth",
    "mask",
    "maskContentUnits",
    "maskUnits",
    "mathematical",
    "mode",
    "numOctaves",
    "offset",
    "opacity",
    "operator",
    "order",
    "orient",
    "orientation",
    "origin",
    "overflow",
    "overlinePosition",
    "overlineThickness",
    "paintOrder",
    "panose1",
    "pathLength",
    "patternContentUnits",
    "patternTransform",
    "patternUnits",
    "pointerEvents",
    "points",
    "pointsAtX",
    "pointsAtY",
    "pointsAtZ",
    "preserveAlpha",
    "preserveAspectRatio",
    "primitiveUnits",
    "r",
    "radius",
    "refX",
    "refY",
    "renderingIntent",
    "repeatCount",
    "repeatDur",
    "requiredExtensions",
    "requiredFeatures",
    "restart",
    "result",
    "rotate",
    "rx",
    "ry",
    "seed",
    "shapeRendering",
    "slope",
    "spacing",
    "specularConstant",
    "specularExponent",
    "speed",
    "spreadMethod",
    "startOffset",
    "stdDeviation",
    "stemh",
    "stemv",
    "stitchTiles",
    "stopColor",
    "stopOpacity",
    "strikethroughPosition",
    "strikethroughThickness",
    "string",
    "stroke",
    "strokeDasharray",
    "strokeDashoffset",
    "strokeLinecap",
    "strokeLinejoin",
    "strokeMiterlimit",
    "strokeOpacity",
    "strokeWidth",
    "surfaceScale",
    "systemLanguage",
    "tableValues",
    "targetX",
    "targetY",
    "textAnchor",
    "textDecoration",
    "textLength",
    "textRendering",
    "to",
    "transform",
    "u1",
    "u2",
    "underlinePosition",
    "underlineThickness",
    "unicode",
    "unicodeBidi",
    "unicodeRange",
    "unitsPerEm",
    "vAlphabetic",
    "values",
    "vectorEffect",
    "version",
    "vertAdvY",
    "vertOriginX",
    "vertOriginY",
    "vHanging",
    "vIdeographic",
    "viewTarget",
    "visibility",
    "vMathematical",
    "widths",
    "wordSpacing",
    "writingMode",
    "x1",
    "x2",
    "x",
    "xChannelSelector",
    "xHeight",
    "xlinkActuate",
    "xlinkArcrole",
    "xlinkHref",
    "xlinkRole",
    "xlinkShow",
    "xlinkTitle",
    "xlinkType",
    "xmlBase",
    "xmlLang",
    "xmlns",
    "xmlnsXlink",
    "xmlSpace",
    "y1",
    "y2",
    "y",
    "yChannelSelector",
    "z",
    "zoomAndPan",
    "ref",
    "key",
    "angle"
];
var $dd873d09408694ab$var$EventKeys = [
    "dangerouslySetInnerHTML",
    "onCopy",
    "onCopyCapture",
    "onCut",
    "onCutCapture",
    "onPaste",
    "onPasteCapture",
    "onCompositionEnd",
    "onCompositionEndCapture",
    "onCompositionStart",
    "onCompositionStartCapture",
    "onCompositionUpdate",
    "onCompositionUpdateCapture",
    "onFocus",
    "onFocusCapture",
    "onBlur",
    "onBlurCapture",
    "onChange",
    "onChangeCapture",
    "onBeforeInput",
    "onBeforeInputCapture",
    "onInput",
    "onInputCapture",
    "onReset",
    "onResetCapture",
    "onSubmit",
    "onSubmitCapture",
    "onInvalid",
    "onInvalidCapture",
    "onLoad",
    "onLoadCapture",
    "onError",
    "onErrorCapture",
    "onKeyDown",
    "onKeyDownCapture",
    "onKeyPress",
    "onKeyPressCapture",
    "onKeyUp",
    "onKeyUpCapture",
    "onAbort",
    "onAbortCapture",
    "onCanPlay",
    "onCanPlayCapture",
    "onCanPlayThrough",
    "onCanPlayThroughCapture",
    "onDurationChange",
    "onDurationChangeCapture",
    "onEmptied",
    "onEmptiedCapture",
    "onEncrypted",
    "onEncryptedCapture",
    "onEnded",
    "onEndedCapture",
    "onLoadedData",
    "onLoadedDataCapture",
    "onLoadedMetadata",
    "onLoadedMetadataCapture",
    "onLoadStart",
    "onLoadStartCapture",
    "onPause",
    "onPauseCapture",
    "onPlay",
    "onPlayCapture",
    "onPlaying",
    "onPlayingCapture",
    "onProgress",
    "onProgressCapture",
    "onRateChange",
    "onRateChangeCapture",
    "onSeeked",
    "onSeekedCapture",
    "onSeeking",
    "onSeekingCapture",
    "onStalled",
    "onStalledCapture",
    "onSuspend",
    "onSuspendCapture",
    "onTimeUpdate",
    "onTimeUpdateCapture",
    "onVolumeChange",
    "onVolumeChangeCapture",
    "onWaiting",
    "onWaitingCapture",
    "onAuxClick",
    "onAuxClickCapture",
    "onClick",
    "onClickCapture",
    "onContextMenu",
    "onContextMenuCapture",
    "onDoubleClick",
    "onDoubleClickCapture",
    "onDrag",
    "onDragCapture",
    "onDragEnd",
    "onDragEndCapture",
    "onDragEnter",
    "onDragEnterCapture",
    "onDragExit",
    "onDragExitCapture",
    "onDragLeave",
    "onDragLeaveCapture",
    "onDragOver",
    "onDragOverCapture",
    "onDragStart",
    "onDragStartCapture",
    "onDrop",
    "onDropCapture",
    "onMouseDown",
    "onMouseDownCapture",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseMove",
    "onMouseMoveCapture",
    "onMouseOut",
    "onMouseOutCapture",
    "onMouseOver",
    "onMouseOverCapture",
    "onMouseUp",
    "onMouseUpCapture",
    "onSelect",
    "onSelectCapture",
    "onTouchCancel",
    "onTouchCancelCapture",
    "onTouchEnd",
    "onTouchEndCapture",
    "onTouchMove",
    "onTouchMoveCapture",
    "onTouchStart",
    "onTouchStartCapture",
    "onPointerDown",
    "onPointerDownCapture",
    "onPointerMove",
    "onPointerMoveCapture",
    "onPointerUp",
    "onPointerUpCapture",
    "onPointerCancel",
    "onPointerCancelCapture",
    "onPointerEnter",
    "onPointerEnterCapture",
    "onPointerLeave",
    "onPointerLeaveCapture",
    "onPointerOver",
    "onPointerOverCapture",
    "onPointerOut",
    "onPointerOutCapture",
    "onGotPointerCapture",
    "onGotPointerCaptureCapture",
    "onLostPointerCapture",
    "onLostPointerCaptureCapture",
    "onScroll",
    "onScrollCapture",
    "onWheel",
    "onWheelCapture",
    "onAnimationStart",
    "onAnimationStartCapture",
    "onAnimationEnd",
    "onAnimationEndCapture",
    "onAnimationIteration",
    "onAnimationIterationCapture",
    "onTransitionEnd",
    "onTransitionEndCapture"
]; // Animation Types => TODO: Should be moved when react-smooth is typescriptified.
var $dd873d09408694ab$export$d697c39a2985a4c = function filterProps(props, includeEvents, isSvg) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        // viewBox only exist in <svg />
        if ($dd873d09408694ab$var$SVGElementPropKeys.includes(key) || isSvg && $dd873d09408694ab$var$SVGContainerPropKeys.includes(key) || includeEvents && $dd873d09408694ab$var$EventKeys.includes(key)) out[key] = inputProps[key];
    });
    return out;
};
var $dd873d09408694ab$export$7c4c290a4a9c1b1e = function adaptEventHandlers(props, newHandler) {
    if (!props || typeof props === "function" || typeof props === "boolean") return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(props)) inputProps = props.props;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(inputProps)) return null;
    var out = {};
    Object.keys(inputProps).forEach(function(key) {
        if ($dd873d09408694ab$var$EventKeys.includes(key)) out[key] = newHandler || function(e) {
            return inputProps[key](inputProps, e);
        };
    });
    return out;
};
var $dd873d09408694ab$var$getEventHandlerOfChild = function getEventHandlerOfChild(originalHandler, data, index) {
    return function(e) {
        originalHandler(data, index, e);
        return null;
    };
};
var $dd873d09408694ab$export$ca62be0d67a3158c = function adaptEventsOfChild(props, data, index) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(props) || $dd873d09408694ab$var$_typeof(props) !== "object") return null;
    var out = null;
    Object.keys(props).forEach(function(key) {
        var item = props[key];
        if ($dd873d09408694ab$var$EventKeys.includes(key) && typeof item === "function") {
            if (!out) out = {};
            out[key] = $dd873d09408694ab$var$getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};







var $a4d9ec64928c627b$export$9d334328eb75e624 = function mathSign(value) {
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var $a4d9ec64928c627b$export$e50269385c77c348 = function isPercent(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($58bed27071520d70$exports)))(value) && value.indexOf("%") === value.length - 1;
};
var $a4d9ec64928c627b$export$7e4aa119212bc614 = function isNumber(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ec729ee529b2009e$exports)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($aa7127c7503d27f5$exports)))(value);
};
var $a4d9ec64928c627b$export$402a499e1ea44294 = function isNumOrStr(value) {
    return $a4d9ec64928c627b$export$7e4aa119212bc614(value) || (0, (/*@__PURE__*/$parcel$interopDefault($58bed27071520d70$exports)))(value);
};
var $a4d9ec64928c627b$var$idCounter = 0;
var $a4d9ec64928c627b$export$8b15d37bc3f197d4 = function uniqueId(prefix) {
    var id = ++$a4d9ec64928c627b$var$idCounter;
    return "".concat(prefix || "").concat(id);
};
var $a4d9ec64928c627b$export$476354dbf49bdff6 = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!$a4d9ec64928c627b$export$7e4aa119212bc614(percent) && !(0, (/*@__PURE__*/$parcel$interopDefault($58bed27071520d70$exports)))(percent)) return defaultValue;
    var value;
    if ($a4d9ec64928c627b$export$e50269385c77c348(percent)) {
        var index = percent.indexOf("%");
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aa7127c7503d27f5$exports)))(value)) value = defaultValue;
    if (validate && value > totalValue) value = totalValue;
    return value;
};
var $a4d9ec64928c627b$export$b88993f0aa0bf776 = function getAnyElementOfObject(obj) {
    if (!obj) return null;
    var keys = Object.keys(obj);
    if (keys && keys.length) return obj[keys[0]];
    return null;
};
var $a4d9ec64928c627b$export$732baf6a98f122 = function hasDuplicate(ary) {
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[ary[i]]) cache[ary[i]] = true;
        else return true;
    }
    return false;
};
var $a4d9ec64928c627b$export$d871d53bd7eeb390 = function interpolateNumber(numberA, numberB) {
    if ($a4d9ec64928c627b$export$7e4aa119212bc614(numberA) && $a4d9ec64928c627b$export$7e4aa119212bc614(numberB)) return function(t) {
        return numberA + t * (numberB - numberA);
    };
    return function() {
        return numberB;
    };
};
function $a4d9ec64928c627b$export$66950d3869f5cc67(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return null;
    return ary.find(function(entry) {
        return entry && (typeof specifiedKey === "function" ? specifiedKey(entry) : (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, specifiedKey)) === specifiedValue;
    });
}
var $a4d9ec64928c627b$export$484982720961754e = function getLinearRegression(data) {
    if (!data || !data.length) return null;
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        xcurrent = data[i].cx || 0;
        ycurrent = data[i].cy || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin: xmin,
        xmax: xmax,
        a: a,
        b: (ysum - a * xsum) / len
    };
};


function $1046975411d24196$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $1046975411d24196$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $1046975411d24196$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $1046975411d24196$var$_typeof(obj);
}
function $1046975411d24196$var$_extends() {
    $1046975411d24196$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1046975411d24196$var$_extends.apply(this, arguments);
}
function $1046975411d24196$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1046975411d24196$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1046975411d24196$var$ownKeys(Object(source), true).forEach(function(key) {
            $1046975411d24196$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1046975411d24196$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1046975411d24196$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1046975411d24196$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $1046975411d24196$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $1046975411d24196$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $1046975411d24196$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $1046975411d24196$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $1046975411d24196$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $1046975411d24196$var$_setPrototypeOf(subClass, superClass);
}
function $1046975411d24196$var$_setPrototypeOf(o, p) {
    $1046975411d24196$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $1046975411d24196$var$_setPrototypeOf(o, p);
}
function $1046975411d24196$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $1046975411d24196$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $1046975411d24196$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $1046975411d24196$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $1046975411d24196$var$_possibleConstructorReturn(this, result);
    };
}
function $1046975411d24196$var$_possibleConstructorReturn(self, call) {
    if (call && ($1046975411d24196$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $1046975411d24196$var$_assertThisInitialized(self);
}
function $1046975411d24196$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $1046975411d24196$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $1046975411d24196$var$_getPrototypeOf(o) {
    $1046975411d24196$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $1046975411d24196$var$_getPrototypeOf(o);
}
var $1046975411d24196$var$CURVE_FACTORIES = {
    curveBasisClosed: (0, $587abb3050c4a44f$export$2e2bcd8739ae039),
    curveBasisOpen: (0, $9c65b5954a0b3552$export$2e2bcd8739ae039),
    curveBasis: (0, $7256b28551f3ccbb$export$2e2bcd8739ae039),
    curveLinearClosed: (0, $7d715575e273a4eb$export$2e2bcd8739ae039),
    curveLinear: (0, $b61574f0d85ec581$export$2e2bcd8739ae039),
    curveMonotoneX: (0, $cb7427e0621d7ff1$export$99563b5420dbdc55),
    curveMonotoneY: (0, $cb7427e0621d7ff1$export$8b5360456d6bdb88),
    curveNatural: (0, $66f91a29ca3796db$export$2e2bcd8739ae039),
    curveStep: (0, $b54a1ba879f543bc$export$2e2bcd8739ae039),
    curveStepAfter: (0, $b54a1ba879f543bc$export$793b3db073781cbb),
    curveStepBefore: (0, $b54a1ba879f543bc$export$10eafa5b7478b343)
};
var $1046975411d24196$var$defined = function defined(p) {
    return p.x === +p.x && p.y === +p.y;
};
var $1046975411d24196$var$getX = function getX(p) {
    return p.x;
};
var $1046975411d24196$var$getY = function getY(p) {
    return p.y;
};
var $1046975411d24196$var$getCurveFactory = function getCurveFactory(type, layout) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(type)) return type;
    var name = "curve".concat((0, (/*@__PURE__*/$parcel$interopDefault($bace4a80b17174f2$exports)))(type));
    if (name === "curveMonotone" && layout) return $1046975411d24196$var$CURVE_FACTORIES["".concat(name).concat(layout === "vertical" ? "Y" : "X")];
    return $1046975411d24196$var$CURVE_FACTORIES[name] || (0, $b61574f0d85ec581$export$2e2bcd8739ae039);
};
var $1046975411d24196$export$b0e83c3ef8d2db1 = /*#__PURE__*/ function(_PureComponent) {
    $1046975411d24196$var$_inherits(Curve, _PureComponent);
    var _super = $1046975411d24196$var$_createSuper(Curve);
    function Curve() {
        $1046975411d24196$var$_classCallCheck(this, Curve);
        return _super.apply(this, arguments);
    }
    $1046975411d24196$var$_createClass(Curve, [
        {
            key: "getPath",
            value: /**
     * Calculate the path of curve
     * @return {String} path
     */ function getPath() {
                var _this$props = this.props, type = _this$props.type, points = _this$props.points, baseLine = _this$props.baseLine, layout = _this$props.layout, connectNulls = _this$props.connectNulls;
                var curveFactory = $1046975411d24196$var$getCurveFactory(type, layout);
                var formatPoints = connectNulls ? points.filter(function(entry) {
                    return $1046975411d24196$var$defined(entry);
                }) : points;
                var lineFunction;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(baseLine)) {
                    var formatBaseLine = connectNulls ? baseLine.filter(function(base) {
                        return $1046975411d24196$var$defined(base);
                    }) : baseLine;
                    var areaPoints = formatPoints.map(function(entry, index) {
                        return $1046975411d24196$var$_objectSpread($1046975411d24196$var$_objectSpread({}, entry), {}, {
                            base: formatBaseLine[index]
                        });
                    });
                    if (layout === "vertical") lineFunction = (0, $87c0eb3e100c263b$export$2e2bcd8739ae039)().y($1046975411d24196$var$getY).x1($1046975411d24196$var$getX).x0(function(d) {
                        return d.base.x;
                    });
                    else lineFunction = (0, $87c0eb3e100c263b$export$2e2bcd8739ae039)().x($1046975411d24196$var$getX).y1($1046975411d24196$var$getY).y0(function(d) {
                        return d.base.y;
                    });
                    lineFunction.defined($1046975411d24196$var$defined).curve(curveFactory);
                    return lineFunction(areaPoints);
                }
                if (layout === "vertical" && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $87c0eb3e100c263b$export$2e2bcd8739ae039)().y($1046975411d24196$var$getY).x1($1046975411d24196$var$getX).x0(baseLine);
                else if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseLine)) lineFunction = (0, $87c0eb3e100c263b$export$2e2bcd8739ae039)().x($1046975411d24196$var$getX).y1($1046975411d24196$var$getY).y0(baseLine);
                else lineFunction = (0, $d0017b2e97e8acad$export$2e2bcd8739ae039)().x($1046975411d24196$var$getX).y($1046975411d24196$var$getY);
                lineFunction.defined($1046975411d24196$var$defined).curve(curveFactory);
                return lineFunction(formatPoints);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, points = _this$props2.points, path = _this$props2.path, pathRef = _this$props2.pathRef;
                if ((!points || !points.length) && !path) return null;
                var realPath = points && points.length ? this.getPath() : path;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $1046975411d24196$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props), (0, $dd873d09408694ab$export$7c4c290a4a9c1b1e)(this.props), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-curve", className),
                    d: realPath,
                    ref: pathRef
                }));
            }
        }
    ]);
    return Curve;
}((0, $eCoWV.PureComponent));
$1046975411d24196$export$b0e83c3ef8d2db1.defaultProps = {
    type: "linear",
    points: [],
    connectNulls: false
};



var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

function $18507106bbcc53ce$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $18507106bbcc53ce$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $18507106bbcc53ce$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $18507106bbcc53ce$var$_typeof(obj);
}
function $18507106bbcc53ce$var$_extends() {
    $18507106bbcc53ce$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $18507106bbcc53ce$var$_extends.apply(this, arguments);
}
function $18507106bbcc53ce$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $18507106bbcc53ce$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $18507106bbcc53ce$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $18507106bbcc53ce$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $18507106bbcc53ce$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $18507106bbcc53ce$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $18507106bbcc53ce$var$_setPrototypeOf(subClass, superClass);
}
function $18507106bbcc53ce$var$_setPrototypeOf(o, p) {
    $18507106bbcc53ce$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $18507106bbcc53ce$var$_setPrototypeOf(o, p);
}
function $18507106bbcc53ce$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $18507106bbcc53ce$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $18507106bbcc53ce$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $18507106bbcc53ce$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $18507106bbcc53ce$var$_possibleConstructorReturn(this, result);
    };
}
function $18507106bbcc53ce$var$_possibleConstructorReturn(self, call) {
    if (call && ($18507106bbcc53ce$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $18507106bbcc53ce$var$_assertThisInitialized(self);
}
function $18507106bbcc53ce$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $18507106bbcc53ce$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $18507106bbcc53ce$var$_getPrototypeOf(o) {
    $18507106bbcc53ce$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $18507106bbcc53ce$var$_getPrototypeOf(o);
}
var $18507106bbcc53ce$export$d046b3c4a416f60d = /*#__PURE__*/ function(_PureComponent) {
    $18507106bbcc53ce$var$_inherits(Dot, _PureComponent);
    var _super = $18507106bbcc53ce$var$_createSuper(Dot);
    function Dot() {
        $18507106bbcc53ce$var$_classCallCheck(this, Dot);
        return _super.apply(this, arguments);
    }
    $18507106bbcc53ce$var$_createClass(Dot, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, r = _this$props.r, className = _this$props.className;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-dot", className);
                if (cx === +cx && cy === +cy && r === +r) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("circle", $18507106bbcc53ce$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props), (0, $dd873d09408694ab$export$7c4c290a4a9c1b1e)(this.props), {
                    className: layerClass,
                    cx: cx,
                    cy: cy,
                    r: r
                }));
                return null;
            }
        }
    ]);
    return Dot;
}((0, $eCoWV.PureComponent));



var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

function $e8b40bd38b345c87$var$_extends() {
    $e8b40bd38b345c87$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e8b40bd38b345c87$var$_extends.apply(this, arguments);
}
function $e8b40bd38b345c87$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e8b40bd38b345c87$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e8b40bd38b345c87$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e8b40bd38b345c87$export$936d0764594b6eb3(props) {
    var children = props.children, className = props.className, others = $e8b40bd38b345c87$var$_objectWithoutProperties(props, [
        "children",
        "className"
    ]);
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-layer", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", $e8b40bd38b345c87$var$_extends({
        className: layerClass
    }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(others, true)), children);
}





var $1eaa4283cabf6b33$exports = {};
/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */ function $1eaa4283cabf6b33$var$last(array) {
    var length = array == null ? 0 : array.length;
    return length ? array[length - 1] : undefined;
}
$1eaa4283cabf6b33$exports = $1eaa4283cabf6b33$var$last;




var $eCoWV = parcelRequire("eCoWV");




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");


var $eCoWV = parcelRequire("eCoWV");
var $8607684acc2f3f12$exports = {};
"use strict";
Object.defineProperty($8607684acc2f3f12$exports, "__esModule", {
    value: true
});
var $03aabcf00f33173d$exports = {};
var $a8ad09ca15e35547$exports = {};
var $a8ad09ca15e35547$var$openParentheses = "(".charCodeAt(0);
var $a8ad09ca15e35547$var$closeParentheses = ")".charCodeAt(0);
var $a8ad09ca15e35547$var$singleQuote = "'".charCodeAt(0);
var $a8ad09ca15e35547$var$doubleQuote = '"'.charCodeAt(0);
var $a8ad09ca15e35547$var$backslash = "\\".charCodeAt(0);
var $a8ad09ca15e35547$var$slash = "/".charCodeAt(0);
var $a8ad09ca15e35547$var$comma = ",".charCodeAt(0);
var $a8ad09ca15e35547$var$colon = ":".charCodeAt(0);
var $a8ad09ca15e35547$var$star = "*".charCodeAt(0);
$a8ad09ca15e35547$exports = function(input) {
    var tokens = [];
    var value = input;
    var next, quote, prev, token, escape, escapePos, whitespacePos;
    var pos = 0;
    var code = value.charCodeAt(pos);
    var max = value.length;
    var stack = [
        {
            nodes: tokens
        }
    ];
    var balanced = 0;
    var parent;
    var name = "";
    var before = "";
    var after = "";
    while(pos < max){
        // Whitespaces
        if (code <= 32) {
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = value.slice(pos, next);
            prev = tokens[tokens.length - 1];
            if (code === $a8ad09ca15e35547$var$closeParentheses && balanced) after = token;
            else if (prev && prev.type === "div") prev.after = token;
            else if (code === $a8ad09ca15e35547$var$comma || code === $a8ad09ca15e35547$var$colon || code === $a8ad09ca15e35547$var$slash && value.charCodeAt(next + 1) !== $a8ad09ca15e35547$var$star) before = token;
            else tokens.push({
                type: "space",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        // Quotes
        } else if (code === $a8ad09ca15e35547$var$singleQuote || code === $a8ad09ca15e35547$var$doubleQuote) {
            next = pos;
            quote = code === $a8ad09ca15e35547$var$singleQuote ? "'" : '"';
            token = {
                type: "string",
                sourceIndex: pos,
                quote: quote
            };
            do {
                escape = false;
                next = value.indexOf(quote, next + 1);
                if (~next) {
                    escapePos = next;
                    while(value.charCodeAt(escapePos - 1) === $a8ad09ca15e35547$var$backslash){
                        escapePos -= 1;
                        escape = !escape;
                    }
                } else {
                    value += quote;
                    next = value.length - 1;
                    token.unclosed = true;
                }
            }while (escape);
            token.value = value.slice(pos + 1, next);
            tokens.push(token);
            pos = next + 1;
            code = value.charCodeAt(pos);
        // Comments
        } else if (code === $a8ad09ca15e35547$var$slash && value.charCodeAt(pos + 1) === $a8ad09ca15e35547$var$star) {
            token = {
                type: "comment",
                sourceIndex: pos
            };
            next = value.indexOf("*/", pos);
            if (next === -1) {
                token.unclosed = true;
                next = value.length;
            }
            token.value = value.slice(pos + 2, next);
            tokens.push(token);
            pos = next + 2;
            code = value.charCodeAt(pos);
        // Dividers
        } else if (code === $a8ad09ca15e35547$var$slash || code === $a8ad09ca15e35547$var$comma || code === $a8ad09ca15e35547$var$colon) {
            token = value[pos];
            tokens.push({
                type: "div",
                sourceIndex: pos - before.length,
                value: token,
                before: before,
                after: ""
            });
            before = "";
            pos += 1;
            code = value.charCodeAt(pos);
        // Open parentheses
        } else if ($a8ad09ca15e35547$var$openParentheses === code) {
            // Whitespaces after open parentheses
            next = pos;
            do {
                next += 1;
                code = value.charCodeAt(next);
            }while (code <= 32);
            token = {
                type: "function",
                sourceIndex: pos - name.length,
                value: name,
                before: value.slice(pos + 1, next)
            };
            pos = next;
            if (name === "url" && code !== $a8ad09ca15e35547$var$singleQuote && code !== $a8ad09ca15e35547$var$doubleQuote) {
                next -= 1;
                do {
                    escape = false;
                    next = value.indexOf(")", next + 1);
                    if (~next) {
                        escapePos = next;
                        while(value.charCodeAt(escapePos - 1) === $a8ad09ca15e35547$var$backslash){
                            escapePos -= 1;
                            escape = !escape;
                        }
                    } else {
                        value += ")";
                        next = value.length - 1;
                        token.unclosed = true;
                    }
                }while (escape);
                // Whitespaces before closed
                whitespacePos = next;
                do {
                    whitespacePos -= 1;
                    code = value.charCodeAt(whitespacePos);
                }while (code <= 32);
                if (pos !== whitespacePos + 1) token.nodes = [
                    {
                        type: "word",
                        sourceIndex: pos,
                        value: value.slice(pos, whitespacePos + 1)
                    }
                ];
                else token.nodes = [];
                if (token.unclosed && whitespacePos + 1 !== next) {
                    token.after = "";
                    token.nodes.push({
                        type: "space",
                        sourceIndex: whitespacePos + 1,
                        value: value.slice(whitespacePos + 1, next)
                    });
                } else token.after = value.slice(whitespacePos + 1, next);
                pos = next + 1;
                code = value.charCodeAt(pos);
                tokens.push(token);
            } else {
                balanced += 1;
                token.after = "";
                tokens.push(token);
                stack.push(token);
                tokens = token.nodes = [];
                parent = token;
            }
            name = "";
        // Close parentheses
        } else if ($a8ad09ca15e35547$var$closeParentheses === code && balanced) {
            pos += 1;
            code = value.charCodeAt(pos);
            parent.after = after;
            after = "";
            balanced -= 1;
            stack.pop();
            parent = stack[balanced];
            tokens = parent.nodes;
        // Words
        } else {
            next = pos;
            do {
                if (code === $a8ad09ca15e35547$var$backslash) next += 1;
                next += 1;
                code = value.charCodeAt(next);
            }while (next < max && !(code <= 32 || code === $a8ad09ca15e35547$var$singleQuote || code === $a8ad09ca15e35547$var$doubleQuote || code === $a8ad09ca15e35547$var$comma || code === $a8ad09ca15e35547$var$colon || code === $a8ad09ca15e35547$var$slash || code === $a8ad09ca15e35547$var$openParentheses || code === $a8ad09ca15e35547$var$closeParentheses && balanced));
            token = value.slice(pos, next);
            if ($a8ad09ca15e35547$var$openParentheses === code) name = token;
            else tokens.push({
                type: "word",
                sourceIndex: pos,
                value: token
            });
            pos = next;
        }
    }
    for(pos = stack.length - 1; pos; pos -= 1)stack[pos].unclosed = true;
    return stack[0].nodes;
};


var $a2136b111d0eb44b$exports = {};
$a2136b111d0eb44b$exports = function walk(nodes, cb, bubble) {
    var i, max, node, result;
    for(i = 0, max = nodes.length; i < max; i += 1){
        node = nodes[i];
        if (!bubble) result = cb(node, i, nodes);
        if (result !== false && node.type === "function" && Array.isArray(node.nodes)) walk(node.nodes, cb, bubble);
        if (bubble) cb(node, i, nodes);
    }
};


var $84a78b1eff292bc0$exports = {};
function $84a78b1eff292bc0$var$stringifyNode(node, custom) {
    var type = node.type;
    var value = node.value;
    var buf;
    var customResult;
    if (custom && (customResult = custom(node)) !== undefined) return customResult;
    else if (type === "word" || type === "space") return value;
    else if (type === "string") {
        buf = node.quote || "";
        return buf + value + (node.unclosed ? "" : buf);
    } else if (type === "comment") return "/*" + value + (node.unclosed ? "" : "*/");
    else if (type === "div") return (node.before || "") + value + (node.after || "");
    else if (Array.isArray(node.nodes)) {
        buf = $84a78b1eff292bc0$var$stringify(node.nodes);
        if (type !== "function") return buf;
        return value + "(" + (node.before || "") + buf + (node.after || "") + (node.unclosed ? "" : ")");
    }
    return value;
}
function $84a78b1eff292bc0$var$stringify(nodes, custom) {
    var result, i;
    if (Array.isArray(nodes)) {
        result = "";
        for(i = nodes.length - 1; ~i; i -= 1)result = $84a78b1eff292bc0$var$stringifyNode(nodes[i], custom) + result;
        return result;
    }
    return $84a78b1eff292bc0$var$stringifyNode(nodes, custom);
}
$84a78b1eff292bc0$exports = $84a78b1eff292bc0$var$stringify;


function $03aabcf00f33173d$var$ValueParser(value) {
    if (this instanceof $03aabcf00f33173d$var$ValueParser) {
        this.nodes = $a8ad09ca15e35547$exports(value);
        return this;
    }
    return new $03aabcf00f33173d$var$ValueParser(value);
}
$03aabcf00f33173d$var$ValueParser.prototype.toString = function() {
    return Array.isArray(this.nodes) ? $84a78b1eff292bc0$exports(this.nodes) : "";
};
$03aabcf00f33173d$var$ValueParser.prototype.walk = function(cb, bubble) {
    $a2136b111d0eb44b$exports(this.nodes, cb, bubble);
    return this;
};

$03aabcf00f33173d$var$ValueParser.unit = (parcelRequire("jP5zR"));
$03aabcf00f33173d$var$ValueParser.walk = $a2136b111d0eb44b$exports;
$03aabcf00f33173d$var$ValueParser.stringify = $84a78b1eff292bc0$exports;
$03aabcf00f33173d$exports = $03aabcf00f33173d$var$ValueParser;


var $8607684acc2f3f12$var$_postcssValueParser2 = $8607684acc2f3f12$var$_interopRequireDefault($03aabcf00f33173d$exports);
/* parser generated by jison 0.6.1-215 */ /*
 * Returns a Parser object of the following structure:
 *
 *  Parser: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a derivative/copy of this one,
 *               not a direct reference!
 *  }
 *
 *  Parser.prototype: {
 *    yy: {},
 *    EOF: 1,
 *    TERROR: 2,
 *
 *    trace: function(errorMessage, ...),
 *
 *    JisonParserError: function(msg, hash),
 *
 *    quoteName: function(name),
 *               Helper function which can be overridden by user code later on: put suitable
 *               quotes around literal IDs in a description string.
 *
 *    originalQuoteName: function(name),
 *               The basic quoteName handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `quoteName()` to reference this function
 *               at the end of the `parse()`.
 *
 *    describeSymbol: function(symbol),
 *               Return a more-or-less human-readable description of the given symbol, when
 *               available, or the symbol itself, serving as its own 'description' for lack
 *               of something better to serve up.
 *
 *               Return NULL when the symbol is unknown to the parser.
 *
 *    symbols_: {associative list: name ==> number},
 *    terminals_: {associative list: number ==> name},
 *    nonterminals: {associative list: rule-name ==> {associative list: number ==> rule-alt}},
 *    terminal_descriptions_: (if there are any) {associative list: number ==> description},
 *    productions_: [...],
 *
 *    performAction: function parser__performAction(yytext, yyleng, yylineno, yyloc, yystate, yysp, yyvstack, yylstack, yystack, yysstack),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `yyval` internal object, which has members (`$` and `_$`)
 *                             to store/reference the rule value `$$` and location info `@$`.
 *
 *                 One important thing to note about `this` a.k.a. `yyval`: every *reduce* action gets
 *                 to see the same object via the `this` reference, i.e. if you wish to carry custom
 *                 data from one reduce action through to the next within a single parse run, then you
 *                 may get nasty and use `yyval` a.k.a. `this` for storing you own semi-permanent data.
 *
 *                 `this.yy` is a direct reference to the `yy` shared state object.
 *
 *                 `%parse-param`-specified additional `parse()` arguments have been added to this `yy`
 *                 object at `parse()` start and are therefore available to the action code via the
 *                 same named `yy.xxxx` attributes (where `xxxx` represents a identifier name from
 *                 the %parse-param` list.
 *
 *               - `yytext`  : reference to the lexer value which belongs to the last lexer token used
 *                             to match this rule. This is *not* the look-ahead token, but the last token
 *                             that's actually part of this rule.
 *
 *                 Formulated another way, `yytext` is the value of the token immediately preceeding
 *                 the current look-ahead token.
 *                 Caveats apply for rules which don't require look-ahead, such as epsilon rules.
 *
 *               - `yyleng`  : ditto as `yytext`, only now for the lexer.yyleng value.
 *
 *               - `yylineno`: ditto as `yytext`, only now for the lexer.yylineno value.
 *
 *               - `yyloc`   : ditto as `yytext`, only now for the lexer.yylloc lexer token location info.
 *
 *                               WARNING: since jison 0.4.18-186 this entry may be NULL/UNDEFINED instead
 *                               of an empty object when no suitable location info can be provided.
 *
 *               - `yystate` : the current parser state number, used internally for dispatching and
 *                               executing the action code chunk matching the rule currently being reduced.
 *
 *               - `yysp`    : the current state stack position (a.k.a. 'stack pointer')
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *                 Also note that you can access this and other stack index values using the new double-hash
 *                 syntax, i.e. `##$ === ##0 === yysp`, while `##1` is the stack index for all things
 *                 related to the first rule term, just like you have `$1`, `@1` and `#1`.
 *                 This is made available to write very advanced grammar action rules, e.g. when you want
 *                 to investigate the parse state stack in your action code, which would, for example,
 *                 be relevant when you wish to implement error diagnostics and reporting schemes similar
 *                 to the work described here:
 *
 *                 + Pottier, F., 2016. Reachability and error diagnosis in LR(1) automata.
 *                   In Journées Francophones des Languages Applicatifs.
 *
 *                 + Jeffery, C.L., 2003. Generating LR syntax error messages from examples.
 *                   ACM Transactions on Programming Languages and Systems (TOPLAS), 25(5), pp.631–640.
 *
 *               - `yyrulelength`: the current rule's term count, i.e. the number of entries occupied on the stack.
 *
 *                 This one comes in handy when you are going to do advanced things to the parser
 *                 stacks, all of which are accessible from your action code (see the next entries below).
 *
 *               - `yyvstack`: reference to the parser value stack. Also accessed via the `$1` etc.
 *                             constructs.
 *
 *               - `yylstack`: reference to the parser token location stack. Also accessed via
 *                             the `@1` etc. constructs.
 *
 *                             WARNING: since jison 0.4.18-186 this array MAY contain slots which are
 *                             UNDEFINED rather than an empty (location) object, when the lexer/parser
 *                             action code did not provide a suitable location info object when such a
 *                             slot was filled!
 *
 *               - `yystack` : reference to the parser token id stack. Also accessed via the
 *                             `#1` etc. constructs.
 *
 *                 Note: this is a bit of a **white lie** as we can statically decode any `#n` reference to
 *                 its numeric token id value, hence that code wouldn't need the `yystack` but *you* might
 *                 want access this array for your own purposes, such as error analysis as mentioned above!
 *
 *                 Note that this stack stores the current stack of *tokens*, that is the sequence of
 *                 already parsed=reduced *nonterminals* (tokens representing rules) and *terminals*
 *                 (lexer tokens *shifted* onto the stack until the rule they belong to is found and
 *                 *reduced*.
 *
 *               - `yysstack`: reference to the parser state stack. This one carries the internal parser
 *                             *states* such as the one in `yystate`, which are used to represent
 *                             the parser state machine in the *parse table*. *Very* *internal* stuff,
 *                             what can I say? If you access this one, you're clearly doing wicked things
 *
 *               - `...`     : the extra arguments you specified in the `%parse-param` statement in your
 *                             grammar definition file.
 *
 *    table: [...],
 *               State transition table
 *               ----------------------
 *
 *               index levels are:
 *               - `state`  --> hash table
 *               - `symbol` --> action (number or array)
 *
 *                 If the `action` is an array, these are the elements' meaning:
 *                 - index [0]: 1 = shift, 2 = reduce, 3 = accept
 *                 - index [1]: GOTO `state`
 *
 *                 If the `action` is a number, it is the GOTO `state`
 *
 *    defaultActions: {...},
 *
 *    parseError: function(str, hash, ExceptionClass),
 *    yyError: function(str, ...),
 *    yyRecovering: function(),
 *    yyErrOk: function(),
 *    yyClearIn: function(),
 *
 *    constructParseErrorInfo: function(error_message, exception_object, expected_token_set, is_recoverable),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this parser kernel in many places; example usage:
 *
 *                   var infoObj = parser.constructParseErrorInfo('fail!', null,
 *                                     parser.collect_expected_token_set(state), true);
 *                   var retVal = parser.parseError(infoObj.errStr, infoObj, parser.JisonParserError);
 *
 *    originalParseError: function(str, hash, ExceptionClass),
 *               The basic `parseError` handler provided by JISON.
 *               `cleanupAfterParse()` will clean up and reset `parseError()` to reference this function
 *               at the end of the `parse()`.
 *
 *    options: { ... parser %options ... },
 *
 *    parse: function(input[, args...]),
 *               Parse the given `input` and return the parsed value (or `true` when none was provided by
 *               the root action, in which case the parser is acting as a *matcher*).
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of this grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Parser's additional `args...` parameters (via `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the jison run-time;
 *               when such a collision is detected an exception is thrown to prevent the generated run-time
 *               from silently accepting this confusing and potentially hazardous situation!
 *
 *               The lexer MAY add its own set of additional parameters (via the `%parse-param` line in
 *               the lexer section of the grammar spec): these will be inserted in the `yy` shared state
 *               object and any collision with those will be reported by the lexer via a thrown exception.
 *
 *    cleanupAfterParse: function(resultValue, invoke_post_methods, do_not_nuke_errorinfos),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API is invoked at the end of the `parse()` call, unless an exception was thrown
 *               and `%options no-try-catch` has been defined for this grammar: in that case this helper MAY
 *               be invoked by calling user code to ensure the `post_parse` callbacks are invoked and
 *               the internal parser gets properly garbage collected under these particular circumstances.
 *
 *    yyMergeLocationInfo: function(first_index, last_index, first_yylloc, last_yylloc, dont_look_back),
 *               Helper function **which will be set up during the first invocation of the `parse()` method**.
 *               This helper API can be invoked to calculate a spanning `yylloc` location info object.
 *
 *               Note: %epsilon rules MAY specify no `first_index` and `first_yylloc`, in which case
 *               this function will attempt to obtain a suitable location marker by inspecting the location stack
 *               backwards.
 *
 *               For more info see the documentation comment further below, immediately above this function's
 *               implementation.
 *
 *    lexer: {
 *        yy: {...},           A reference to the so-called "shared state" `yy` once
 *                             received via a call to the `.setInput(input, yy)` lexer API.
 *        EOF: 1,
 *        ERROR: 2,
 *        JisonLexerError: function(msg, hash),
 *        parseError: function(str, hash, ExceptionClass),
 *        setInput: function(input, [yy]),
 *        input: function(),
 *        unput: function(str),
 *        more: function(),
 *        reject: function(),
 *        less: function(n),
 *        pastInput: function(n),
 *        upcomingInput: function(n),
 *        showPosition: function(),
 *        test_match: function(regex_match_array, rule_index, ...),
 *        next: function(...),
 *        lex: function(...),
 *        begin: function(condition),
 *        pushState: function(condition),
 *        popState: function(),
 *        topState: function(),
 *        _currentRules: function(),
 *        stateStackSize: function(),
 *        cleanupAfterLex: function()
 *
 *        options: { ... lexer %options ... },
 *
 *        performAction: function(yy, yy_, $avoiding_name_collisions, YY_START, ...),
 *        rules: [...],
 *        conditions: {associative list: name ==> set},
 *    }
 *  }
 *
 *
 *  token location info (@$, _$, etc.): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer and
 * parser errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *  }
 *
 * parser (grammar) errors will also provide these additional members:
 *
 *  {
 *    expected:    (array describing the set of expected tokens;
 *                  may be UNDEFINED when we cannot easily produce such a set)
 *    state:       (integer (or array when the table includes grammar collisions);
 *                  represents the current internal state of the parser kernel.
 *                  can, for example, be used to pass to the `collect_expected_token_set()`
 *                  API to obtain the expected token set)
 *    action:      (integer; represents the current internal action which will be executed)
 *    new_state:   (integer; represents the next/planned internal state, once the current
 *                  action has executed)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    state_stack: (array: the current parser LALR/LR internal state stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    value_stack: (array: the current parser LALR/LR internal `$$` value stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    location_stack: (array: the current parser LALR/LR internal location stack; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *    parser:      (reference to the current parser instance)
 *  }
 *
 * while `this` will reference the current parser instance.
 *
 * When `parseError` is invoked by the lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    lexer:       (reference to the current lexer instance which reported the error)
 *  }
 *
 * When `parseError` is invoked by the parser due to a **JavaScript exception** being fired
 * from either the parser or lexer, `this` will still reference the related *parser*
 * instance, while these additional `hash` fields will also be provided:
 *
 *  {
 *    exception:   (reference to the exception thrown)
 *  }
 *
 * Please do note that in the latter situation, the `expected` field will be omitted as
 * this type of failure is assumed not to be due to *parse errors* but rather due to user
 * action code in either parser or lexer failing unexpectedly.
 *
 * ---
 *
 * You can specify parser options by setting / modifying the `.yy` object of your Parser instance.
 * These options are available:
 *
 * ### options which are global for all parser instances
 *
 *  Parser.pre_parse: function(yy)
 *                 optional: you can specify a pre_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`.
 *  Parser.post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: you can specify a post_parse() function in the chunk following
 *                 the grammar, i.e. after the last `%%`. When it does not return any value,
 *                 the parser will return the original `retval`.
 *
 * ### options which can be set up per parser instance
 *
 *  yy: {
 *      pre_parse:  function(yy)
 *                 optional: is invoked before the parse cycle starts (and before the first
 *                 invocation of `lex()`) but immediately after the invocation of
 *                 `parser.pre_parse()`).
 *      post_parse: function(yy, retval, parseInfo) { return retval; }
 *                 optional: is invoked when the parse terminates due to success ('accept')
 *                 or failure (even when exceptions are thrown).
 *                 `retval` contains the return value to be produced by `Parser.parse()`;
 *                 this function can override the return value by returning another.
 *                 When it does not return any value, the parser will return the original
 *                 `retval`.
 *                 This function is invoked immediately before `parser.post_parse()`.
 *
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *      quoteName: function(name),
 *                 optional: overrides the default `quoteName` function.
 *  }
 *
 *  parser.lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this `%option` has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var $3e245abb866b1818$export$8f49e4af10703ce3;
var $3e245abb866b1818$export$7acfa6ed01010e37;
var $3e245abb866b1818$export$98e6a39c04603d36;
var $3e245abb866b1818$var$parser = function() {
    // See also:
    // http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
    // but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
    // with userland code which might access the derived class in a 'classic' way.
    function JisonParserError(msg, hash) {
        Object.defineProperty(this, "name", {
            enumerable: false,
            writable: false,
            value: "JisonParserError"
        });
        if (msg == null) msg = "???";
        Object.defineProperty(this, "message", {
            enumerable: false,
            writable: true,
            value: msg
        });
        this.hash = hash;
        var stacktrace;
        if (hash && hash.exception instanceof Error) {
            var ex2 = hash.exception;
            this.message = ex2.message || msg;
            stacktrace = ex2.stack;
        }
        if (!stacktrace) {
            if (Error.hasOwnProperty("captureStackTrace")) Error.captureStackTrace(this, this.constructor);
            else stacktrace = new Error(msg).stack;
        }
        if (stacktrace) Object.defineProperty(this, "stack", {
            enumerable: false,
            writable: false,
            value: stacktrace
        });
    }
    if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonParserError.prototype, Error.prototype);
    else JisonParserError.prototype = Object.create(Error.prototype);
    JisonParserError.prototype.constructor = JisonParserError;
    JisonParserError.prototype.name = "JisonParserError";
    // helper: reconstruct the productions[] table
    function bp(s) {
        var rv = [];
        var p = s.pop;
        var r = s.rule;
        for(var i = 0, l = p.length; i < l; i++)rv.push([
            p[i],
            r[i]
        ]);
        return rv;
    }
    // helper: reconstruct the defaultActions[] table
    function bda(s) {
        var rv = {};
        var d = s.idx;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var j = d[i];
            rv[j] = g[i];
        }
        return rv;
    }
    // helper: reconstruct the 'goto' table
    function bt(s) {
        var rv = [];
        var d = s.len;
        var y = s.symbol;
        var t = s.type;
        var a = s.state;
        var m = s.mode;
        var g = s.goto;
        for(var i = 0, l = d.length; i < l; i++){
            var n = d[i];
            var q = {};
            for(var j = 0; j < n; j++){
                var z = y.shift();
                switch(t.shift()){
                    case 2:
                        q[z] = [
                            m.shift(),
                            g.shift()
                        ];
                        break;
                    case 0:
                        q[z] = a.shift();
                        break;
                    default:
                        // type === 1: accept
                        q[z] = [
                            3
                        ];
                }
            }
            rv.push(q);
        }
        return rv;
    }
    // helper: runlength encoding with increment step: code, length: step (default step = 0)
    // `this` references an array
    function s(c, l, a) {
        a = a || 0;
        for(var i = 0; i < l; i++){
            this.push(c);
            c += a;
        }
    }
    // helper: duplicate sequence from *relative* offset and length.
    // `this` references an array
    function c(i, l) {
        i = this.length - i;
        for(l += i; i < l; i++)this.push(this[i]);
    }
    // helper: unpack an array using helpers and data, all passed in an array argument 'a'.
    function u(a) {
        var rv = [];
        for(var i = 0, l = a.length; i < l; i++){
            var e = a[i];
            // Is this entry a helper function?
            if (typeof e === "function") {
                i++;
                e.apply(rv, a[i]);
            } else rv.push(e);
        }
        return rv;
    }
    var parser = {
        // Code Generator Information Report
        // ---------------------------------
        //
        // Options:
        //
        //   default action mode: ............. ["classic","merge"]
        //   test-compile action mode: ........ "parser:*,lexer:*"
        //   try..catch: ...................... true
        //   default resolve on conflict: ..... true
        //   on-demand look-ahead: ............ false
        //   error recovery token skip maximum: 3
        //   yyerror in parse actions is: ..... NOT recoverable,
        //   yyerror in lexer actions and other non-fatal lexer are:
        //   .................................. NOT recoverable,
        //   debug grammar/output: ............ false
        //   has partial LR conflict upgrade:   true
        //   rudimentary token-stack support:   false
        //   parser table compression mode: ... 2
        //   export debug tables: ............. false
        //   export *all* tables: ............. false
        //   module type: ..................... commonjs
        //   parser engine type: .............. lalr
        //   output main() in the module: ..... true
        //   has user-specified main(): ....... false
        //   has user-specified require()/import modules for main():
        //   .................................. false
        //   number of expected conflicts: .... 0
        //
        //
        // Parser Analysis flags:
        //
        //   no significant actions (parser is a language matcher only):
        //   .................................. false
        //   uses yyleng: ..................... false
        //   uses yylineno: ................... false
        //   uses yytext: ..................... false
        //   uses yylloc: ..................... false
        //   uses ParseError API: ............. false
        //   uses YYERROR: .................... false
        //   uses YYRECOVERING: ............... false
        //   uses YYERROK: .................... false
        //   uses YYCLEARIN: .................. false
        //   tracks rule values: .............. true
        //   assigns rule values: ............. true
        //   uses location tracking: .......... false
        //   assigns location: ................ false
        //   uses yystack: .................... false
        //   uses yysstack: ................... false
        //   uses yysp: ....................... true
        //   uses yyrulelength: ............... false
        //   uses yyMergeLocationInfo API: .... false
        //   has error recovery: .............. false
        //   has error reporting: ............. false
        //
        // --------- END OF REPORT -----------
        trace: function no_op_trace() {},
        JisonParserError: JisonParserError,
        yy: {},
        options: {
            type: "lalr",
            hasPartialLrUpgradeOnConflict: true,
            errorRecoveryTokenDiscardCount: 3
        },
        symbols_: {
            "$accept": 0,
            "$end": 1,
            "ADD": 3,
            "ANGLE": 16,
            "CHS": 22,
            "COMMA": 14,
            "CSS_CPROP": 13,
            "CSS_VAR": 12,
            "DIV": 6,
            "EMS": 20,
            "EOF": 1,
            "EXS": 21,
            "FREQ": 18,
            "LENGTH": 15,
            "LPAREN": 7,
            "MUL": 5,
            "NESTED_CALC": 9,
            "NUMBER": 11,
            "PERCENTAGE": 28,
            "PREFIX": 10,
            "REMS": 23,
            "RES": 19,
            "RPAREN": 8,
            "SUB": 4,
            "TIME": 17,
            "VHS": 24,
            "VMAXS": 27,
            "VMINS": 26,
            "VWS": 25,
            "css_value": 33,
            "css_variable": 32,
            "error": 2,
            "expression": 29,
            "math_expression": 30,
            "value": 31
        },
        terminals_: {
            1: "EOF",
            2: "error",
            3: "ADD",
            4: "SUB",
            5: "MUL",
            6: "DIV",
            7: "LPAREN",
            8: "RPAREN",
            9: "NESTED_CALC",
            10: "PREFIX",
            11: "NUMBER",
            12: "CSS_VAR",
            13: "CSS_CPROP",
            14: "COMMA",
            15: "LENGTH",
            16: "ANGLE",
            17: "TIME",
            18: "FREQ",
            19: "RES",
            20: "EMS",
            21: "EXS",
            22: "CHS",
            23: "REMS",
            24: "VHS",
            25: "VWS",
            26: "VMINS",
            27: "VMAXS",
            28: "PERCENTAGE"
        },
        TERROR: 2,
        EOF: 1,
        // internals: defined here so the object *structure* doesn't get modified by parse() et al,
        // thus helping JIT compilers like Chrome V8.
        originalQuoteName: null,
        originalParseError: null,
        cleanupAfterParse: null,
        constructParseErrorInfo: null,
        yyMergeLocationInfo: null,
        __reentrant_call_depth: 0,
        __error_infos: [],
        __error_recovery_infos: [],
        // APIs which will be set up depending on user action code analysis:
        //yyRecovering: 0,
        //yyErrOk: 0,
        //yyClearIn: 0,
        // Helper APIs
        // -----------
        // Helper function which can be overridden by user code later on: put suitable quotes around
        // literal IDs in a description string.
        quoteName: function parser_quoteName(id_str) {
            return '"' + id_str + '"';
        },
        // Return the name of the given symbol (terminal or non-terminal) as a string, when available.
        //
        // Return NULL when the symbol is unknown to the parser.
        getSymbolName: function parser_getSymbolName(symbol) {
            if (this.terminals_[symbol]) return this.terminals_[symbol];
            // Otherwise... this might refer to a RULE token i.e. a non-terminal: see if we can dig that one up.
            //
            // An example of this may be where a rule's action code contains a call like this:
            //
            //      parser.getSymbolName(#$)
            //
            // to obtain a human-readable name of the current grammar rule.
            var s = this.symbols_;
            for(var key in s){
                if (s[key] === symbol) return key;
            }
            return null;
        },
        // Return a more-or-less human-readable description of the given symbol, when available,
        // or the symbol itself, serving as its own 'description' for lack of something better to serve up.
        //
        // Return NULL when the symbol is unknown to the parser.
        describeSymbol: function parser_describeSymbol(symbol) {
            if (symbol !== this.EOF && this.terminal_descriptions_ && this.terminal_descriptions_[symbol]) return this.terminal_descriptions_[symbol];
            else if (symbol === this.EOF) return "end of input";
            var id = this.getSymbolName(symbol);
            if (id) return this.quoteName(id);
            return null;
        },
        // Produce a (more or less) human-readable list of expected tokens at the point of failure.
        //
        // The produced list may contain token or token set descriptions instead of the tokens
        // themselves to help turning this output into something that easier to read by humans
        // unless `do_not_describe` parameter is set, in which case a list of the raw, *numeric*,
        // expected terminals and nonterminals is produced.
        //
        // The returned list (array) will not contain any duplicate entries.
        collect_expected_token_set: function parser_collect_expected_token_set(state, do_not_describe) {
            var TERROR = this.TERROR;
            var tokenset = [];
            var check = {};
            // Has this (error?) state been outfitted with a custom expectations description text for human consumption?
            // If so, use that one instead of the less palatable token set.
            if (!do_not_describe && this.state_descriptions_ && this.state_descriptions_[state]) return [
                this.state_descriptions_[state]
            ];
            for(var p in this.table[state]){
                p = +p;
                if (p !== TERROR) {
                    var d = do_not_describe ? p : this.describeSymbol(p);
                    if (d && !check[d]) {
                        tokenset.push(d);
                        check[d] = true; // Mark this token description as already mentioned to prevent outputting duplicate entries.
                    }
                }
            }
            return tokenset;
        },
        productions_: bp({
            pop: u([
                29,
                s,
                [
                    30,
                    10
                ],
                31,
                31,
                32,
                32,
                s,
                [
                    33,
                    15
                ]
            ]),
            rule: u([
                2,
                s,
                [
                    3,
                    5
                ],
                4,
                7,
                s,
                [
                    1,
                    4
                ],
                2,
                4,
                6,
                s,
                [
                    1,
                    14
                ],
                2
            ])
        }),
        performAction: function parser__PerformAction(yystate /* action[1] */ , yysp, yyvstack) {
            /* this == yyval */ // the JS engine itself can go and remove these statements when `yy` turns out to be unused in any action code!
            var yy = this.yy;
            var yyparser = yy.parser;
            var yylexer = yy.lexer;
            switch(yystate){
                case 0:
                    /*! Production::    $accept : expression $end */ // default action (generated by JISON mode classic/merge :: 1,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    break;
                case 1:
                    /*! Production::    expression : math_expression EOF */ // default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-):
                    this.$ = yyvstack[yysp - 1];
                    // END of default action (generated by JISON mode classic/merge :: 2,VT,VA,-,-,-,-,-,-)
                    return yyvstack[yysp - 1];
                case 2:
                /*! Production::    math_expression : math_expression ADD math_expression */ case 3:
                /*! Production::    math_expression : math_expression SUB math_expression */ case 4:
                /*! Production::    math_expression : math_expression MUL math_expression */ case 5:
                    /*! Production::    math_expression : math_expression DIV math_expression */ this.$ = {
                        type: "MathExpression",
                        operator: yyvstack[yysp - 1],
                        left: yyvstack[yysp - 2],
                        right: yyvstack[yysp]
                    };
                    break;
                case 6:
                    /*! Production::    math_expression : LPAREN math_expression RPAREN */ this.$ = yyvstack[yysp - 1];
                    break;
                case 7:
                    /*! Production::    math_expression : NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 8:
                    /*! Production::    math_expression : SUB PREFIX SUB NESTED_CALC LPAREN math_expression RPAREN */ this.$ = {
                        type: "Calc",
                        value: yyvstack[yysp - 1],
                        prefix: yyvstack[yysp - 5]
                    };
                    break;
                case 9:
                /*! Production::    math_expression : css_variable */ case 10:
                /*! Production::    math_expression : css_value */ case 11:
                    /*! Production::    math_expression : value */ this.$ = yyvstack[yysp];
                    break;
                case 12:
                    /*! Production::    value : NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp])
                    };
                    break;
                case 13:
                    /*! Production::    value : SUB NUMBER */ this.$ = {
                        type: "Value",
                        value: parseFloat(yyvstack[yysp]) * -1
                    };
                    break;
                case 14:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 1]
                    };
                    break;
                case 15:
                    /*! Production::    css_variable : CSS_VAR LPAREN CSS_CPROP COMMA math_expression RPAREN */ this.$ = {
                        type: "CssVariable",
                        value: yyvstack[yysp - 3],
                        fallback: yyvstack[yysp - 1]
                    };
                    break;
                case 16:
                    /*! Production::    css_value : LENGTH */ this.$ = {
                        type: "LengthValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 17:
                    /*! Production::    css_value : ANGLE */ this.$ = {
                        type: "AngleValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 18:
                    /*! Production::    css_value : TIME */ this.$ = {
                        type: "TimeValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 19:
                    /*! Production::    css_value : FREQ */ this.$ = {
                        type: "FrequencyValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 20:
                    /*! Production::    css_value : RES */ this.$ = {
                        type: "ResolutionValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: /[a-z]+/.exec(yyvstack[yysp])[0]
                    };
                    break;
                case 21:
                    /*! Production::    css_value : EMS */ this.$ = {
                        type: "EmValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "em"
                    };
                    break;
                case 22:
                    /*! Production::    css_value : EXS */ this.$ = {
                        type: "ExValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ex"
                    };
                    break;
                case 23:
                    /*! Production::    css_value : CHS */ this.$ = {
                        type: "ChValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "ch"
                    };
                    break;
                case 24:
                    /*! Production::    css_value : REMS */ this.$ = {
                        type: "RemValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "rem"
                    };
                    break;
                case 25:
                    /*! Production::    css_value : VHS */ this.$ = {
                        type: "VhValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vh"
                    };
                    break;
                case 26:
                    /*! Production::    css_value : VWS */ this.$ = {
                        type: "VwValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vw"
                    };
                    break;
                case 27:
                    /*! Production::    css_value : VMINS */ this.$ = {
                        type: "VminValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmin"
                    };
                    break;
                case 28:
                    /*! Production::    css_value : VMAXS */ this.$ = {
                        type: "VmaxValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "vmax"
                    };
                    break;
                case 29:
                    /*! Production::    css_value : PERCENTAGE */ this.$ = {
                        type: "PercentageValue",
                        value: parseFloat(yyvstack[yysp]),
                        unit: "%"
                    };
                    break;
                case 30:
                    /*! Production::    css_value : SUB css_value */ var prev = yyvstack[yysp];
                    prev.value *= -1;
                    this.$ = prev;
                    break;
            }
        },
        table: bt({
            len: u([
                24,
                1,
                5,
                23,
                1,
                18,
                s,
                [
                    0,
                    3
                ],
                1,
                s,
                [
                    0,
                    16
                ],
                s,
                [
                    23,
                    4
                ],
                c,
                [
                    28,
                    3
                ],
                0,
                0,
                16,
                1,
                6,
                6,
                s,
                [
                    0,
                    3
                ],
                5,
                1,
                2,
                c,
                [
                    37,
                    3
                ],
                c,
                [
                    20,
                    3
                ],
                5,
                0,
                0
            ]),
            symbol: u([
                4,
                7,
                9,
                11,
                12,
                s,
                [
                    15,
                    19,
                    1
                ],
                1,
                1,
                s,
                [
                    3,
                    4,
                    1
                ],
                c,
                [
                    30,
                    19
                ],
                c,
                [
                    29,
                    4
                ],
                7,
                4,
                10,
                11,
                c,
                [
                    22,
                    14
                ],
                c,
                [
                    19,
                    3
                ],
                c,
                [
                    43,
                    22
                ],
                c,
                [
                    23,
                    69
                ],
                c,
                [
                    139,
                    4
                ],
                8,
                c,
                [
                    51,
                    24
                ],
                4,
                c,
                [
                    138,
                    15
                ],
                13,
                c,
                [
                    186,
                    5
                ],
                8,
                c,
                [
                    6,
                    6
                ],
                c,
                [
                    5,
                    5
                ],
                9,
                8,
                14,
                c,
                [
                    159,
                    47
                ],
                c,
                [
                    60,
                    10
                ]
            ]),
            type: u([
                s,
                [
                    2,
                    19
                ],
                s,
                [
                    0,
                    5
                ],
                1,
                s,
                [
                    2,
                    24
                ],
                s,
                [
                    0,
                    4
                ],
                c,
                [
                    22,
                    19
                ],
                c,
                [
                    43,
                    42
                ],
                c,
                [
                    23,
                    70
                ],
                c,
                [
                    28,
                    25
                ],
                c,
                [
                    45,
                    25
                ],
                c,
                [
                    113,
                    54
                ]
            ]),
            state: u([
                1,
                2,
                8,
                6,
                7,
                30,
                c,
                [
                    4,
                    3
                ],
                33,
                37,
                c,
                [
                    5,
                    3
                ],
                38,
                c,
                [
                    4,
                    3
                ],
                39,
                c,
                [
                    4,
                    3
                ],
                40,
                c,
                [
                    4,
                    3
                ],
                42,
                c,
                [
                    21,
                    4
                ],
                50,
                c,
                [
                    5,
                    3
                ],
                51,
                c,
                [
                    4,
                    3
                ]
            ]),
            mode: u([
                s,
                [
                    1,
                    179
                ],
                s,
                [
                    2,
                    3
                ],
                c,
                [
                    5,
                    5
                ],
                c,
                [
                    6,
                    4
                ],
                s,
                [
                    1,
                    57
                ]
            ]),
            goto: u([
                5,
                3,
                4,
                24,
                s,
                [
                    9,
                    15,
                    1
                ],
                s,
                [
                    25,
                    5,
                    1
                ],
                c,
                [
                    24,
                    19
                ],
                31,
                35,
                32,
                34,
                c,
                [
                    18,
                    14
                ],
                36,
                c,
                [
                    38,
                    19
                ],
                c,
                [
                    19,
                    57
                ],
                c,
                [
                    118,
                    4
                ],
                41,
                c,
                [
                    24,
                    19
                ],
                43,
                35,
                c,
                [
                    16,
                    14
                ],
                44,
                s,
                [
                    2,
                    3
                ],
                28,
                29,
                2,
                s,
                [
                    3,
                    3
                ],
                28,
                29,
                3,
                c,
                [
                    53,
                    4
                ],
                s,
                [
                    45,
                    5,
                    1
                ],
                c,
                [
                    100,
                    42
                ],
                52,
                c,
                [
                    5,
                    4
                ],
                53
            ])
        }),
        defaultActions: bda({
            idx: u([
                6,
                7,
                8,
                s,
                [
                    10,
                    16,
                    1
                ],
                33,
                34,
                39,
                40,
                41,
                45,
                47,
                52,
                53
            ]),
            goto: u([
                9,
                10,
                11,
                s,
                [
                    16,
                    14,
                    1
                ],
                12,
                1,
                30,
                13,
                s,
                [
                    4,
                    4,
                    1
                ],
                14,
                15,
                8
            ])
        }),
        parseError: function parseError(str, hash, ExceptionClass) {
            if (hash.recoverable) {
                if (typeof this.trace === "function") this.trace(str);
                hash.destroy(); // destroy... well, *almost*!
            } else {
                if (typeof this.trace === "function") this.trace(str);
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                throw new ExceptionClass(str, hash);
            }
        },
        parse: function parse(input) {
            var self = this;
            var stack = new Array(128); // token stack: stores token which leads to state at the same index (column storage)
            var sstack = new Array(128); // state stack: stores states (column storage)
            var vstack = new Array(128); // semantic value stack
            var table = this.table;
            var sp = 0; // 'stack pointer': index into the stacks
            var symbol = 0;
            var TERROR = this.TERROR;
            var EOF = this.EOF;
            var ERROR_RECOVERY_TOKEN_DISCARD_COUNT = this.options.errorRecoveryTokenDiscardCount | 0 || 3;
            var NO_ACTION = [
                0,
                54 /* === table.length :: ensures that anyone using this new state will fail dramatically! */ 
            ];
            var lexer;
            if (this.__lexer__) lexer = this.__lexer__;
            else lexer = this.__lexer__ = Object.create(this.lexer);
            var sharedState_yy = {
                parseError: undefined,
                quoteName: undefined,
                lexer: undefined,
                parser: undefined,
                pre_parse: undefined,
                post_parse: undefined,
                pre_lex: undefined,
                post_lex: undefined // WARNING: must be written this way for the code expanders to work correctly in both ES5 and ES6 modes!
            };
            var ASSERT;
            if (typeof assert !== "function") ASSERT = function JisonAssert(cond, msg) {
                if (!cond) throw new Error("assertion failed: " + (msg || "***"));
            };
            else ASSERT = assert;
            this.yyGetSharedState = function yyGetSharedState() {
                return sharedState_yy;
            };
            function shallow_copy_noclobber(dst, src) {
                for(var k in src)if (typeof dst[k] === "undefined" && Object.prototype.hasOwnProperty.call(src, k)) dst[k] = src[k];
            }
            // copy state
            shallow_copy_noclobber(sharedState_yy, this.yy);
            sharedState_yy.lexer = lexer;
            sharedState_yy.parser = this;
            // Does the shared state override the default `parseError` that already comes with this instance?
            if (typeof sharedState_yy.parseError === "function") this.parseError = function parseErrorAlt(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonParserError;
                return sharedState_yy.parseError.call(this, str, hash, ExceptionClass);
            };
            else this.parseError = this.originalParseError;
            // Does the shared state override the default `quoteName` that already comes with this instance?
            if (typeof sharedState_yy.quoteName === "function") this.quoteName = function quoteNameAlt(id_str) {
                return sharedState_yy.quoteName.call(this, id_str);
            };
            else this.quoteName = this.originalQuoteName;
            // set up the cleanup function; make it an API so that external code can re-use this one in case of
            // calamities or when the `%options no-try-catch` option has been specified for the grammar, in which
            // case this parse() API method doesn't come with a `finally { ... }` block any more!
            //
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `sharedState`, etc. references will be *wrong*!
            this.cleanupAfterParse = function parser_cleanupAfterParse(resultValue, invoke_post_methods, do_not_nuke_errorinfos) {
                var rv;
                if (invoke_post_methods) {
                    var hash;
                    if (sharedState_yy.post_parse || this.post_parse) // create an error hash info instance: we re-use this API in a **non-error situation**
                    // as this one delivers all parser internals ready for access by userland code.
                    hash = this.constructParseErrorInfo(null, null, null, false);
                    if (sharedState_yy.post_parse) {
                        rv = sharedState_yy.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    if (this.post_parse) {
                        rv = this.post_parse.call(this, sharedState_yy, resultValue, hash);
                        if (typeof rv !== "undefined") resultValue = rv;
                    }
                    // cleanup:
                    if (hash && hash.destroy) hash.destroy();
                }
                if (this.__reentrant_call_depth > 1) return resultValue; // do not (yet) kill the sharedState when this is a reentrant run.
                // clean up the lingering lexer structures as well:
                if (lexer.cleanupAfterLex) lexer.cleanupAfterLex(do_not_nuke_errorinfos);
                // prevent lingering circular references from causing memory leaks:
                if (sharedState_yy) {
                    sharedState_yy.lexer = undefined;
                    sharedState_yy.parser = undefined;
                    if (lexer.yy === sharedState_yy) lexer.yy = undefined;
                }
                sharedState_yy = undefined;
                this.parseError = this.originalParseError;
                this.quoteName = this.originalQuoteName;
                // nuke the vstack[] array at least as that one will still reference obsoleted user values.
                // To be safe, we nuke the other internal stack columns as well...
                stack.length = 0; // fastest way to nuke an array without overly bothering the GC
                sstack.length = 0;
                vstack.length = 0;
                sp = 0;
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return resultValue;
            };
            // NOTE: as this API uses parse() as a closure, it MUST be set again on every parse() invocation,
            //       or else your `lexer`, `sharedState`, etc. references will be *wrong*!
            this.constructParseErrorInfo = function parser_constructParseErrorInfo(msg, ex, expected, recoverable) {
                var pei = {
                    errStr: msg,
                    exception: ex,
                    text: lexer.match,
                    value: lexer.yytext,
                    token: this.describeSymbol(symbol) || symbol,
                    token_id: symbol,
                    line: lexer.yylineno,
                    expected: expected,
                    recoverable: recoverable,
                    state: state,
                    action: action,
                    new_state: newState,
                    symbol_stack: stack,
                    state_stack: sstack,
                    value_stack: vstack,
                    stack_pointer: sp,
                    yy: sharedState_yy,
                    lexer: lexer,
                    parser: this,
                    // and make sure the error info doesn't stay due to potential
                    // ref cycle via userland code manipulations.
                    // These would otherwise all be memory leak opportunities!
                    //
                    // Note that only array and object references are nuked as those
                    // constitute the set of elements which can produce a cyclic ref.
                    // The rest of the members is kept intact as they are harmless.
                    destroy: function destructParseErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // info.value = null;
                        // info.value_stack = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            };
            function getNonTerminalFromCode(symbol) {
                var tokenName = self.getSymbolName(symbol);
                if (!tokenName) tokenName = symbol;
                return tokenName;
            }
            function stdLex() {
                var token = lexer.lex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            function fastLex() {
                var token = lexer.fastLex();
                // if token isn't its numeric value, convert
                if (typeof token !== "number") token = self.symbols_[token] || token;
                return token || EOF;
            }
            var lex = stdLex;
            var state, action, r, t;
            var yyval = {
                $: true,
                _$: undefined,
                yy: sharedState_yy
            };
            var p;
            var yyrulelen;
            var this_production;
            var newState;
            var retval = false;
            try {
                this.__reentrant_call_depth++;
                lexer.setInput(input, sharedState_yy);
                // NOTE: we *assume* no lexer pre/post handlers are set up *after* 
                // this initial `setInput()` call: hence we can now check and decide
                // whether we'll go with the standard, slower, lex() API or the
                // `fast_lex()` one:
                if (typeof lexer.canIUse === "function") {
                    var lexerInfo = lexer.canIUse();
                    if (lexerInfo.fastLex && typeof fastLex === "function") lex = fastLex;
                }
                vstack[sp] = null;
                sstack[sp] = 0;
                stack[sp] = 0;
                ++sp;
                if (this.pre_parse) this.pre_parse.call(this, sharedState_yy);
                if (sharedState_yy.pre_parse) sharedState_yy.pre_parse.call(this, sharedState_yy);
                newState = sstack[sp - 1];
                for(;;){
                    // retrieve state number from top of stack
                    state = newState; // sstack[sp - 1];
                    // use default actions if available
                    if (this.defaultActions[state]) {
                        action = 2;
                        newState = this.defaultActions[state];
                    } else {
                        // The single `==` condition below covers both these `===` comparisons in a single
                        // operation:
                        //
                        //     if (symbol === null || typeof symbol === 'undefined') ...
                        if (!symbol) symbol = lex();
                        // read action for current state and first input
                        t = table[state] && table[state][symbol] || NO_ACTION;
                        newState = t[1];
                        action = t[0];
                        // handle parse error
                        if (!action) {
                            var errStr;
                            var errSymbolDescr = this.describeSymbol(symbol) || symbol;
                            var expected = this.collect_expected_token_set(state);
                            // Report error
                            if (typeof lexer.yylineno === "number") errStr = "Parse error on line " + (lexer.yylineno + 1) + ": ";
                            else errStr = "Parse error: ";
                            if (typeof lexer.showPosition === "function") errStr += "\n" + lexer.showPosition(69, 10) + "\n";
                            if (expected.length) errStr += "Expecting " + expected.join(", ") + ", got unexpected " + errSymbolDescr;
                            else errStr += "Unexpected " + errSymbolDescr;
                            // we cannot recover from the error!
                            p = this.constructParseErrorInfo(errStr, null, expected, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        }
                    }
                    switch(action){
                        // catch misc. parse failures:
                        default:
                            // this shouldn't happen, unless resolve defaults are off
                            if (action instanceof Array) {
                                p = this.constructParseErrorInfo("Parse Error: multiple actions possible at state: " + state + ", token: " + symbol, null, null, false);
                                r = this.parseError(p.errStr, p, this.JisonParserError);
                                if (typeof r !== "undefined") retval = r;
                                break;
                            }
                            // Another case of better safe than sorry: in case state transitions come out of another error recovery process
                            // or a buggy LUT (LookUp Table):
                            p = this.constructParseErrorInfo("Parsing halted. No viable error recovery approach available due to internal system failure.", null, null, false);
                            r = this.parseError(p.errStr, p, this.JisonParserError);
                            if (typeof r !== "undefined") retval = r;
                            break;
                        // shift:
                        case 1:
                            stack[sp] = symbol;
                            vstack[sp] = lexer.yytext;
                            sstack[sp] = newState; // push state
                            ++sp;
                            symbol = 0;
                            continue;
                        // reduce:
                        case 2:
                            this_production = this.productions_[newState - 1]; // `this.productions_[]` is zero-based indexed while states start from 1 upwards...
                            yyrulelen = this_production[1];
                            r = this.performAction.call(yyval, newState, sp - 1, vstack);
                            if (typeof r !== "undefined") {
                                retval = r;
                                break;
                            }
                            // pop off stack
                            sp -= yyrulelen;
                            // don't overwrite the `symbol` variable: use a local var to speed things up:
                            var ntsymbol = this_production[0]; // push nonterminal (reduce)
                            stack[sp] = ntsymbol;
                            vstack[sp] = yyval.$;
                            // goto new state = table[STATE][NONTERMINAL]
                            newState = table[sstack[sp - 1]][ntsymbol];
                            sstack[sp] = newState;
                            ++sp;
                            continue;
                        // accept:
                        case 3:
                            if (sp !== -2) {
                                retval = true;
                                // Return the `$accept` rule's `$$` result, if available.
                                //
                                // Also note that JISON always adds this top-most `$accept` rule (with implicit,
                                // default, action):
                                //
                                //     $accept: <startSymbol> $end
                                //                  %{ $$ = $1; @$ = @1; %}
                                //
                                // which, combined with the parse kernel's `$accept` state behaviour coded below,
                                // will produce the `$$` value output of the <startSymbol> rule as the parse result,
                                // IFF that result is *not* `undefined`. (See also the parser kernel code.)
                                //
                                // In code:
                                //
                                //                  %{
                                //                      @$ = @1;            // if location tracking support is included
                                //                      if (typeof $1 !== 'undefined')
                                //                          return $1;
                                //                      else
                                //                          return true;           // the default parse result if the rule actions don't produce anything
                                //                  %}
                                sp--;
                                if (typeof vstack[sp] !== "undefined") retval = vstack[sp];
                            }
                            break;
                    }
                    break;
                }
            } catch (ex) {
                // report exceptions through the parseError callback too, but keep the exception intact
                // if it is a known parser or lexer error which has been thrown by parseError() already:
                if (ex instanceof this.JisonParserError) throw ex;
                else if (lexer && typeof lexer.JisonLexerError === "function" && ex instanceof lexer.JisonLexerError) throw ex;
                p = this.constructParseErrorInfo("Parsing aborted due to exception.", ex, null, false);
                retval = false;
                r = this.parseError(p.errStr, p, this.JisonParserError);
                if (typeof r !== "undefined") retval = r;
            } finally{
                retval = this.cleanupAfterParse(retval, true, true);
                this.__reentrant_call_depth--;
            } // /finally
            return retval;
        }
    };
    parser.originalParseError = parser.parseError;
    parser.originalQuoteName = parser.quoteName;
    /* lexer generated by jison-lex 0.6.1-215 */ /*
 * Returns a Lexer object of the following structure:
 *
 *  Lexer: {
 *    yy: {}     The so-called "shared state" or rather the *source* of it;
 *               the real "shared state" `yy` passed around to
 *               the rule actions, etc. is a direct reference!
 *
 *               This "shared context" object was passed to the lexer by way of 
 *               the `lexer.setInput(str, yy)` API before you may use it.
 *
 *               This "shared context" object is passed to the lexer action code in `performAction()`
 *               so userland code in the lexer actions may communicate with the outside world 
 *               and/or other lexer rules' actions in more or less complex ways.
 *
 *  }
 *
 *  Lexer.prototype: {
 *    EOF: 1,
 *    ERROR: 2,
 *
 *    yy:        The overall "shared context" object reference.
 *
 *    JisonLexerError: function(msg, hash),
 *
 *    performAction: function lexer__performAction(yy, yyrulenumber, YY_START),
 *
 *               The function parameters and `this` have the following value/meaning:
 *               - `this`    : reference to the `lexer` instance. 
 *                               `yy_` is an alias for `this` lexer instance reference used internally.
 *
 *               - `yy`      : a reference to the `yy` "shared state" object which was passed to the lexer
 *                             by way of the `lexer.setInput(str, yy)` API before.
 *
 *                             Note:
 *                             The extra arguments you specified in the `%parse-param` statement in your
 *                             **parser** grammar definition file are passed to the lexer via this object
 *                             reference as member variables.
 *
 *               - `yyrulenumber`   : index of the matched lexer rule (regex), used internally.
 *
 *               - `YY_START`: the current lexer "start condition" state.
 *
 *    parseError: function(str, hash, ExceptionClass),
 *
 *    constructLexErrorInfo: function(error_message, is_recoverable),
 *               Helper function.
 *               Produces a new errorInfo 'hash object' which can be passed into `parseError()`.
 *               See it's use in this lexer kernel in many places; example usage:
 *
 *                   var infoObj = lexer.constructParseErrorInfo('fail!', true);
 *                   var retVal = lexer.parseError(infoObj.errStr, infoObj, lexer.JisonLexerError);
 *
 *    options: { ... lexer %options ... },
 *
 *    lex: function(),
 *               Produce one token of lexed input, which was passed in earlier via the `lexer.setInput()` API.
 *               You MAY use the additional `args...` parameters as per `%parse-param` spec of the **lexer** grammar:
 *               these extra `args...` are added verbatim to the `yy` object reference as member variables.
 *
 *               WARNING:
 *               Lexer's additional `args...` parameters (via lexer's `%parse-param`) MAY conflict with
 *               any attributes already added to `yy` by the **parser** or the jison run-time; 
 *               when such a collision is detected an exception is thrown to prevent the generated run-time 
 *               from silently accepting this confusing and potentially hazardous situation! 
 *
 *    cleanupAfterLex: function(do_not_nuke_errorinfos),
 *               Helper function.
 *
 *               This helper API is invoked when the **parse process** has completed: it is the responsibility
 *               of the **parser** (or the calling userland code) to invoke this method once cleanup is desired. 
 *
 *               This helper may be invoked by user code to ensure the internal lexer gets properly garbage collected.
 *
 *    setInput: function(input, [yy]),
 *
 *
 *    input: function(),
 *
 *
 *    unput: function(str),
 *
 *
 *    more: function(),
 *
 *
 *    reject: function(),
 *
 *
 *    less: function(n),
 *
 *
 *    pastInput: function(n),
 *
 *
 *    upcomingInput: function(n),
 *
 *
 *    showPosition: function(),
 *
 *
 *    test_match: function(regex_match_array, rule_index),
 *
 *
 *    next: function(),
 *
 *
 *    begin: function(condition),
 *
 *
 *    pushState: function(condition),
 *
 *
 *    popState: function(),
 *
 *
 *    topState: function(),
 *
 *
 *    _currentRules: function(),
 *
 *
 *    stateStackSize: function(),
 *
 *
 *    performAction: function(yy, yy_, yyrulenumber, YY_START),
 *
 *
 *    rules: [...],
 *
 *
 *    conditions: {associative list: name ==> set},
 *  }
 *
 *
 *  token location info (`yylloc`): {
 *    first_line: n,
 *    last_line: n,
 *    first_column: n,
 *    last_column: n,
 *    range: [start_number, end_number]
 *               (where the numbers are indexes into the input string, zero-based)
 *  }
 *
 * ---
 *
 * The `parseError` function receives a 'hash' object with these members for lexer errors:
 *
 *  {
 *    text:        (matched text)
 *    token:       (the produced terminal token, if any)
 *    token_id:    (the produced terminal token numeric ID, if any)
 *    line:        (yylineno)
 *    loc:         (yylloc)
 *    recoverable: (boolean: TRUE when the parser MAY have an error recovery rule
 *                  available for this particular error)
 *    yy:          (object: the current parser internal "shared state" `yy`
 *                  as is also available in the rule actions; this can be used,
 *                  for instance, for advanced error analysis and reporting)
 *    lexer:       (reference to the current lexer instance used by the parser)
 *  }
 *
 * while `this` will reference the current lexer instance.
 *
 * When `parseError` is invoked by the lexer, the default implementation will
 * attempt to invoke `yy.parser.parseError()`; when this callback is not provided
 * it will try to invoke `yy.parseError()` instead. When that callback is also not
 * provided, a `JisonLexerError` exception will be thrown containing the error
 * message and `hash`, as constructed by the `constructLexErrorInfo()` API.
 *
 * Note that the lexer's `JisonLexerError` error class is passed via the
 * `ExceptionClass` argument, which is invoked to construct the exception
 * instance to be thrown, so technically `parseError` will throw the object
 * produced by the `new ExceptionClass(str, hash)` JavaScript expression.
 *
 * ---
 *
 * You can specify lexer options by setting / modifying the `.options` object of your Lexer instance.
 * These options are available:
 *
 * (Options are permanent.)
 *  
 *  yy: {
 *      parseError: function(str, hash, ExceptionClass)
 *                 optional: overrides the default `parseError` function.
 *  }
 *
 *  lexer.options: {
 *      pre_lex:  function()
 *                 optional: is invoked before the lexer is invoked to produce another token.
 *                 `this` refers to the Lexer object.
 *      post_lex: function(token) { return token; }
 *                 optional: is invoked when the lexer has produced a token `token`;
 *                 this function can override the returned token value by returning another.
 *                 When it does not return any (truthy) value, the lexer will return
 *                 the original `token`.
 *                 `this` refers to the Lexer object.
 *
 * WARNING: the next set of options are not meant to be changed. They echo the abilities of
 * the lexer as per when it was compiled!
 *
 *      ranges: boolean
 *                 optional: `true` ==> token location info will include a .range[] member.
 *      flex: boolean
 *                 optional: `true` ==> flex-like lexing behaviour where the rules are tested
 *                 exhaustively to find the longest match.
 *      backtrack_lexer: boolean
 *                 optional: `true` ==> lexer regexes are tested in order and for invoked;
 *                 the lexer terminates the scan when a token is returned by the action code.
 *      xregexp: boolean
 *                 optional: `true` ==> lexer rule regexes are "extended regex format" requiring the
 *                 `XRegExp` library. When this %option has not been specified at compile time, all lexer
 *                 rule regexes have been written as standard JavaScript RegExp expressions.
 *  }
 */ var lexer = function() {
        /**
   * See also:
   * http://stackoverflow.com/questions/1382107/whats-a-good-way-to-extend-error-in-javascript/#35881508
   * but we keep the prototype.constructor and prototype.name assignment lines too for compatibility
   * with userland code which might access the derived class in a 'classic' way.
   *
   * @public
   * @constructor
   * @nocollapse
   */ function JisonLexerError(msg, hash) {
            Object.defineProperty(this, "name", {
                enumerable: false,
                writable: false,
                value: "JisonLexerError"
            });
            if (msg == null) msg = "???";
            Object.defineProperty(this, "message", {
                enumerable: false,
                writable: true,
                value: msg
            });
            this.hash = hash;
            var stacktrace;
            if (hash && hash.exception instanceof Error) {
                var ex2 = hash.exception;
                this.message = ex2.message || msg;
                stacktrace = ex2.stack;
            }
            if (!stacktrace) {
                if (Error.hasOwnProperty("captureStackTrace")) // V8
                Error.captureStackTrace(this, this.constructor);
                else stacktrace = new Error(msg).stack;
            }
            if (stacktrace) Object.defineProperty(this, "stack", {
                enumerable: false,
                writable: false,
                value: stacktrace
            });
        }
        if (typeof Object.setPrototypeOf === "function") Object.setPrototypeOf(JisonLexerError.prototype, Error.prototype);
        else JisonLexerError.prototype = Object.create(Error.prototype);
        JisonLexerError.prototype.constructor = JisonLexerError;
        JisonLexerError.prototype.name = "JisonLexerError";
        var lexer = {
            // Code Generator Information Report
            // ---------------------------------
            //
            // Options:
            //
            //   backtracking: .................... false
            //   location.ranges: ................. false
            //   location line+column tracking: ... true
            //
            //
            // Forwarded Parser Analysis flags:
            //
            //   uses yyleng: ..................... false
            //   uses yylineno: ................... false
            //   uses yytext: ..................... false
            //   uses yylloc: ..................... false
            //   uses lexer values: ............... true / true
            //   location tracking: ............... false
            //   location assignment: ............. false
            //
            //
            // Lexer Analysis flags:
            //
            //   uses yyleng: ..................... ???
            //   uses yylineno: ................... ???
            //   uses yytext: ..................... ???
            //   uses yylloc: ..................... ???
            //   uses ParseError API: ............. ???
            //   uses yyerror: .................... ???
            //   uses location tracking & editing:  ???
            //   uses more() API: ................. ???
            //   uses unput() API: ................ ???
            //   uses reject() API: ............... ???
            //   uses less() API: ................. ???
            //   uses display APIs pastInput(), upcomingInput(), showPosition():
            //        ............................. ???
            //   uses describeYYLLOC() API: ....... ???
            //
            // --------- END OF REPORT -----------
            EOF: 1,
            ERROR: 2,
            // JisonLexerError: JisonLexerError,        /// <-- injected by the code generator
            // options: {},                             /// <-- injected by the code generator
            // yy: ...,                                 /// <-- injected by setInput()
            __currentRuleSet__: null,
            __error_infos: [],
            __decompressed: false,
            done: false,
            _backtrack: false,
            _input: "",
            _more: false,
            _signaled_error_token: false,
            conditionStack: [],
            match: "",
            matched: "",
            matches: false,
            yytext: "",
            offset: 0,
            yyleng: 0,
            yylineno: 0,
            yylloc: null,
            /**
     * INTERNAL USE: construct a suitable error info hash object instance for `parseError`.
     * 
     * @public
     * @this {RegExpLexer}
     */ constructLexErrorInfo: function lexer_constructLexErrorInfo(msg, recoverable, show_input_position) {
                msg = "" + msg;
                // heuristic to determine if the error message already contains a (partial) source code dump
                // as produced by either `showPosition()` or `prettyPrintRange()`:
                if (show_input_position == undefined) show_input_position = !(msg.indexOf("\n") > 0 && msg.indexOf("^") > 0);
                if (this.yylloc && show_input_position) {
                    if (typeof this.prettyPrintRange === "function") {
                        var pretty_src = this.prettyPrintRange(this.yylloc);
                        if (!/\n\s*$/.test(msg)) msg += "\n";
                        msg += "\n  Erroneous area:\n" + this.prettyPrintRange(this.yylloc);
                    } else if (typeof this.showPosition === "function") {
                        var pos_str = this.showPosition();
                        if (pos_str) {
                            if (msg.length && msg[msg.length - 1] !== "\n" && pos_str[0] !== "\n") msg += "\n" + pos_str;
                            else msg += pos_str;
                        }
                    }
                }
                /** @constructor */ var pei = {
                    errStr: msg,
                    recoverable: !!recoverable,
                    text: this.match,
                    token: null,
                    line: this.yylineno,
                    loc: this.yylloc,
                    yy: this.yy,
                    lexer: this,
                    /**
         * and make sure the error info doesn't stay due to potential
         * ref cycle via userland code manipulations.
         * These would otherwise all be memory leak opportunities!
         * 
         * Note that only array and object references are nuked as those
         * constitute the set of elements which can produce a cyclic ref.
         * The rest of the members is kept intact as they are harmless.
         * 
         * @public
         * @this {LexErrorInfo}
         */ destroy: function destructLexErrorInfo() {
                        // remove cyclic references added to error info:
                        // info.yy = null;
                        // info.lexer = null;
                        // ...
                        var rec = !!this.recoverable;
                        for(var key in this)if (this.hasOwnProperty(key) && typeof key === "object") this[key] = undefined;
                        this.recoverable = rec;
                    }
                };
                // track this instance so we can `destroy()` it once we deem it superfluous and ready for garbage collection!
                this.__error_infos.push(pei);
                return pei;
            },
            /**
     * handler which is invoked when a lexer error occurs.
     * 
     * @public
     * @this {RegExpLexer}
     */ parseError: function lexer_parseError(str, hash, ExceptionClass) {
                if (!ExceptionClass) ExceptionClass = this.JisonLexerError;
                if (this.yy) {
                    if (this.yy.parser && typeof this.yy.parser.parseError === "function") return this.yy.parser.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                    else if (typeof this.yy.parseError === "function") return this.yy.parseError.call(this, str, hash, ExceptionClass) || this.ERROR;
                }
                throw new ExceptionClass(str, hash);
            },
            /**
     * method which implements `yyerror(str, ...args)` functionality for use inside lexer actions.
     * 
     * @public
     * @this {RegExpLexer}
     */ yyerror: function yyError(str /*, ...args */ ) {
                var lineno_msg = "";
                if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": " + str, this.options.lexerErrorsAreRecoverable);
                // Add any extra args to the hash under the name `extra_error_attributes`:
                var args = Array.prototype.slice.call(arguments, 1);
                if (args.length) p.extra_error_attributes = args;
                return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
            },
            /**
     * final cleanup function for when we have completed lexing the input;
     * make it an API so that external code can use this one once userland
     * code has decided it's time to destroy any lingering lexer error
     * hash object instances and the like: this function helps to clean
     * up these constructs, which *may* carry cyclic references which would
     * otherwise prevent the instances from being properly and timely
     * garbage-collected, i.e. this function helps prevent memory leaks!
     * 
     * @public
     * @this {RegExpLexer}
     */ cleanupAfterLex: function lexer_cleanupAfterLex(do_not_nuke_errorinfos) {
                // prevent lingering circular references from causing memory leaks:
                this.setInput("", {});
                // nuke the error hash info instances created during this run.
                // Userland code must COPY any data/references
                // in the error hash instance(s) it is more permanently interested in.
                if (!do_not_nuke_errorinfos) {
                    for(var i = this.__error_infos.length - 1; i >= 0; i--){
                        var el = this.__error_infos[i];
                        if (el && typeof el.destroy === "function") el.destroy();
                    }
                    this.__error_infos.length = 0;
                }
                return this;
            },
            /**
     * clear the lexer token context; intended for internal use only
     * 
     * @public
     * @this {RegExpLexer}
     */ clear: function lexer_clear() {
                this.yytext = "";
                this.yyleng = 0;
                this.match = "";
                // - DO NOT reset `this.matched`
                this.matches = false;
                this._more = false;
                this._backtrack = false;
                var col = this.yylloc ? this.yylloc.last_column : 0;
                this.yylloc = {
                    first_line: this.yylineno + 1,
                    first_column: col,
                    last_line: this.yylineno + 1,
                    last_column: col,
                    range: [
                        this.offset,
                        this.offset
                    ]
                };
            },
            /**
     * resets the lexer, sets new input
     * 
     * @public
     * @this {RegExpLexer}
     */ setInput: function lexer_setInput(input, yy) {
                this.yy = yy || this.yy || {};
                // also check if we've fully initialized the lexer instance,
                // including expansion work to be done to go from a loaded
                // lexer to a usable lexer:
                if (!this.__decompressed) {
                    // step 1: decompress the regex list:
                    var rules = this.rules;
                    for(var i = 0, len = rules.length; i < len; i++){
                        var rule_re = rules[i];
                        // compression: is the RE an xref to another RE slot in the rules[] table?
                        if (typeof rule_re === "number") rules[i] = rules[rule_re];
                    }
                    // step 2: unfold the conditions[] set to make these ready for use:
                    var conditions = this.conditions;
                    for(var k in conditions){
                        var spec = conditions[k];
                        var rule_ids = spec.rules;
                        var len = rule_ids.length;
                        var rule_regexes = new Array(len + 1); // slot 0 is unused; we use a 1-based index approach here to keep the hottest code in `lexer_next()` fast and simple! 
                        var rule_new_ids = new Array(len + 1);
                        for(var i = 0; i < len; i++){
                            var idx = rule_ids[i];
                            var rule_re = rules[idx];
                            rule_regexes[i + 1] = rule_re;
                            rule_new_ids[i + 1] = idx;
                        }
                        spec.rules = rule_new_ids;
                        spec.__rule_regexes = rule_regexes;
                        spec.__rule_count = len;
                    }
                    this.__decompressed = true;
                }
                this._input = input || "";
                this.clear();
                this._signaled_error_token = false;
                this.done = false;
                this.yylineno = 0;
                this.matched = "";
                this.conditionStack = [
                    "INITIAL"
                ];
                this.__currentRuleSet__ = null;
                this.yylloc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                this.offset = 0;
                return this;
            },
            /**
     * edit the remaining input via user-specified callback.
     * This can be used to forward-adjust the input-to-parse, 
     * e.g. inserting macro expansions and alike in the
     * input which has yet to be lexed.
     * The behaviour of this API contrasts the `unput()` et al
     * APIs as those act on the *consumed* input, while this
     * one allows one to manipulate the future, without impacting
     * the current `yyloc` cursor location or any history. 
     * 
     * Use this API to help implement C-preprocessor-like
     * `#include` statements, etc.
     * 
     * The provided callback must be synchronous and is
     * expected to return the edited input (string).
     *
     * The `cpsArg` argument value is passed to the callback
     * as-is.
     *
     * `callback` interface: 
     * `function callback(input, cpsArg)`
     * 
     * - `input` will carry the remaining-input-to-lex string
     *   from the lexer.
     * - `cpsArg` is `cpsArg` passed into this API.
     * 
     * The `this` reference for the callback will be set to
     * reference this lexer instance so that userland code
     * in the callback can easily and quickly access any lexer
     * API. 
     *
     * When the callback returns a non-string-type falsey value,
     * we assume the callback did not edit the input and we
     * will using the input as-is.
     *
     * When the callback returns a non-string-type value, it
     * is converted to a string for lexing via the `"" + retval`
     * operation. (See also why: http://2ality.com/2012/03/converting-to-string.html 
     * -- that way any returned object's `toValue()` and `toString()`
     * methods will be invoked in a proper/desirable order.)
     * 
     * @public
     * @this {RegExpLexer}
     */ editRemainingInput: function lexer_editRemainingInput(callback, cpsArg) {
                var rv = callback.call(this, this._input, cpsArg);
                if (typeof rv !== "string") {
                    if (rv) this._input = "" + rv;
                } else this._input = rv;
                return this;
            },
            /**
     * consumes and returns one char from the input
     * 
     * @public
     * @this {RegExpLexer}
     */ input: function lexer_input() {
                if (!this._input) //this.done = true;    -- don't set `done` as we want the lex()/next() API to be able to produce one custom EOF token match after this anyhow. (lexer can match special <<EOF>> tokens and perform user action code for a <<EOF>> match, but only does so *once*)
                return null;
                var ch = this._input[0];
                this.yytext += ch;
                this.yyleng++;
                this.offset++;
                this.match += ch;
                this.matched += ch;
                // Count the linenumber up when we hit the LF (or a stand-alone CR).
                // On CRLF, the linenumber is incremented when you fetch the CR or the CRLF combo
                // and we advance immediately past the LF as well, returning both together as if
                // it was all a single 'character' only.
                var slice_len = 1;
                var lines = false;
                if (ch === "\n") lines = true;
                else if (ch === "\r") {
                    lines = true;
                    var ch2 = this._input[1];
                    if (ch2 === "\n") {
                        slice_len++;
                        ch += ch2;
                        this.yytext += ch2;
                        this.yyleng++;
                        this.offset++;
                        this.match += ch2;
                        this.matched += ch2;
                        this.yylloc.range[1]++;
                    }
                }
                if (lines) {
                    this.yylineno++;
                    this.yylloc.last_line++;
                    this.yylloc.last_column = 0;
                } else this.yylloc.last_column++;
                this.yylloc.range[1]++;
                this._input = this._input.slice(slice_len);
                return ch;
            },
            /**
     * unshifts one char (or an entire string) into the input
     * 
     * @public
     * @this {RegExpLexer}
     */ unput: function lexer_unput(ch) {
                var len = ch.length;
                var lines = ch.split(/(?:\r\n?|\n)/g);
                this._input = ch + this._input;
                this.yytext = this.yytext.substr(0, this.yytext.length - len);
                this.yyleng = this.yytext.length;
                this.offset -= len;
                this.match = this.match.substr(0, this.match.length - len);
                this.matched = this.matched.substr(0, this.matched.length - len);
                if (lines.length > 1) {
                    this.yylineno -= lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    // Get last entirely matched line into the `pre_lines[]` array's
                    // last index slot; we don't mind when other previously 
                    // matched lines end up in the array too. 
                    var pre = this.match;
                    var pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    if (pre_lines.length === 1) {
                        pre = this.matched;
                        pre_lines = pre.split(/(?:\r\n?|\n)/g);
                    }
                    this.yylloc.last_column = pre_lines[pre_lines.length - 1].length;
                } else this.yylloc.last_column -= len;
                this.yylloc.range[1] = this.yylloc.range[0] + this.yyleng;
                this.done = false;
                return this;
            },
            /**
     * cache matched text and append it on next action
     * 
     * @public
     * @this {RegExpLexer}
     */ more: function lexer_more() {
                this._more = true;
                return this;
            },
            /**
     * signal the lexer that this rule fails to match the input, so the
     * next matching rule (regex) should be tested instead.
     * 
     * @public
     * @this {RegExpLexer}
     */ reject: function lexer_reject() {
                if (this.options.backtrack_lexer) this._backtrack = true;
                else {
                    // when the `parseError()` call returns, we MUST ensure that the error is registered.
                    // We accomplish this by signaling an 'error' token to be produced for the current
                    // `.lex()` run.
                    var lineno_msg = "";
                    if (this.yylloc) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": You can only invoke reject() in the lexer when the lexer is of the backtracking persuasion (options.backtrack_lexer = true).", false);
                    this._signaled_error_token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                }
                return this;
            },
            /**
     * retain first n characters of the match
     * 
     * @public
     * @this {RegExpLexer}
     */ less: function lexer_less(n) {
                return this.unput(this.match.slice(n));
            },
            /**
     * return (part of the) already matched input, i.e. for error
     * messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of
     * input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     * 
     * @public
     * @this {RegExpLexer}
     */ pastInput: function lexer_pastInput(maxSize, maxLines) {
                var past = this.matched.substring(0, this.matched.length - this.match.length);
                if (maxSize < 0) maxSize = past.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = past.length; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substr` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                past = past.substr(-maxSize * 2 - 2);
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = past.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(-maxLines);
                past = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis prefix...
                if (past.length > maxSize) past = "..." + past.substr(-maxSize);
                return past;
            },
            /**
     * return (part of the) upcoming input, i.e. for error messages.
     * 
     * Limit the returned string length to `maxSize` (default: 20).
     * 
     * Limit the returned string to the `maxLines` number of lines of input (default: 1).
     * 
     * Negative limit values equal *unlimited*.
     *
     * > ### NOTE ###
     * >
     * > *"upcoming input"* is defined as the whole of the both
     * > the *currently lexed* input, together with any remaining input
     * > following that. *"currently lexed"* input is the input 
     * > already recognized by the lexer but not yet returned with
     * > the lexer token. This happens when you are invoking this API
     * > from inside any lexer rule action code block. 
     * >
     * 
     * @public
     * @this {RegExpLexer}
     */ upcomingInput: function lexer_upcomingInput(maxSize, maxLines) {
                var next = this.match;
                if (maxSize < 0) maxSize = next.length + this._input.length;
                else if (!maxSize) maxSize = 20;
                if (maxLines < 0) maxLines = maxSize; // can't ever have more input lines than this! 
                else if (!maxLines) maxLines = 1;
                // `substring` anticipation: treat \r\n as a single character and take a little
                // more than necessary so that we can still properly check against maxSize
                // after we've transformed and limited the newLines in here:
                if (next.length < maxSize * 2 + 2) next += this._input.substring(0, maxSize * 2 + 2); // substring is faster on Chrome/V8 
                // now that we have a significantly reduced string to process, transform the newlines
                // and chop them, then limit them:
                var a = next.replace(/\r\n|\r/g, "\n").split("\n");
                a = a.slice(0, maxLines);
                next = a.join("\n");
                // When, after limiting to maxLines, we still have too much to return,
                // do add an ellipsis postfix...
                if (next.length > maxSize) next = next.substring(0, maxSize) + "...";
                return next;
            },
            /**
     * return a string which displays the character position where the
     * lexing error occurred, i.e. for error messages
     * 
     * @public
     * @this {RegExpLexer}
     */ showPosition: function lexer_showPosition(maxPrefix, maxPostfix) {
                var pre = this.pastInput(maxPrefix).replace(/\s/g, " ");
                var c = new Array(pre.length + 1).join("-");
                return pre + this.upcomingInput(maxPostfix).replace(/\s/g, " ") + "\n" + c + "^";
            },
            /**
     * return an YYLLOC info object derived off the given context (actual, preceding, following, current).
     * Use this method when the given `actual` location is not guaranteed to exist (i.e. when
     * it MAY be NULL) and you MUST have a valid location info object anyway:
     * then we take the given context of the `preceding` and `following` locations, IFF those are available,
     * and reconstruct the `actual` location info from those.
     * If this fails, the heuristic is to take the `current` location, IFF available.
     * If this fails as well, we assume the sought location is at/around the current lexer position
     * and then produce that one as a response. DO NOTE that these heuristic/derived location info
     * values MAY be inaccurate!
     *
     * NOTE: `deriveLocationInfo()` ALWAYS produces a location info object *copy* of `actual`, not just
     * a *reference* hence all input location objects can be assumed to be 'constant' (function has no side-effects).
     * 
     * @public
     * @this {RegExpLexer}
     */ deriveLocationInfo: function lexer_deriveYYLLOC(actual, preceding, following, current) {
                var loc = {
                    first_line: 1,
                    first_column: 0,
                    last_line: 1,
                    last_column: 0,
                    range: [
                        0,
                        0
                    ]
                };
                if (actual) {
                    loc.first_line = actual.first_line | 0;
                    loc.last_line = actual.last_line | 0;
                    loc.first_column = actual.first_column | 0;
                    loc.last_column = actual.last_column | 0;
                    if (actual.range) {
                        loc.range[0] = actual.range[0] | 0;
                        loc.range[1] = actual.range[1] | 0;
                    }
                }
                if (loc.first_line <= 0 || loc.last_line < loc.first_line) {
                    // plan B: heuristic using preceding and following:
                    if (loc.first_line <= 0 && preceding) {
                        loc.first_line = preceding.last_line | 0;
                        loc.first_column = preceding.last_column | 0;
                        if (preceding.range) loc.range[0] = actual.range[1] | 0;
                    }
                    if ((loc.last_line <= 0 || loc.last_line < loc.first_line) && following) {
                        loc.last_line = following.first_line | 0;
                        loc.last_column = following.first_column | 0;
                        if (following.range) loc.range[1] = actual.range[0] | 0;
                    }
                    // plan C?: see if the 'current' location is useful/sane too:
                    if (loc.first_line <= 0 && current && (loc.last_line <= 0 || current.last_line <= loc.last_line)) {
                        loc.first_line = current.first_line | 0;
                        loc.first_column = current.first_column | 0;
                        if (current.range) loc.range[0] = current.range[0] | 0;
                    }
                    if (loc.last_line <= 0 && current && (loc.first_line <= 0 || current.first_line >= loc.first_line)) {
                        loc.last_line = current.last_line | 0;
                        loc.last_column = current.last_column | 0;
                        if (current.range) loc.range[1] = current.range[1] | 0;
                    }
                }
                // sanitize: fix last_line BEFORE we fix first_line as we use the 'raw' value of the latter
                // or plan D heuristics to produce a 'sensible' last_line value:
                if (loc.last_line <= 0) {
                    if (loc.first_line <= 0) {
                        loc.first_line = this.yylloc.first_line;
                        loc.last_line = this.yylloc.last_line;
                        loc.first_column = this.yylloc.first_column;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[0] = this.yylloc.range[0];
                        loc.range[1] = this.yylloc.range[1];
                    } else {
                        loc.last_line = this.yylloc.last_line;
                        loc.last_column = this.yylloc.last_column;
                        loc.range[1] = this.yylloc.range[1];
                    }
                }
                if (loc.first_line <= 0) {
                    loc.first_line = loc.last_line;
                    loc.first_column = 0; // loc.last_column; 
                    loc.range[1] = loc.range[0];
                }
                if (loc.first_column < 0) loc.first_column = 0;
                if (loc.last_column < 0) loc.last_column = loc.first_column > 0 ? loc.first_column : 80;
                return loc;
            },
            /**
     * return a string which displays the lines & columns of input which are referenced 
     * by the given location info range, plus a few lines of context.
     * 
     * This function pretty-prints the indicated section of the input, with line numbers 
     * and everything!
     * 
     * This function is very useful to provide highly readable error reports, while
     * the location range may be specified in various flexible ways:
     * 
     * - `loc` is the location info object which references the area which should be
     *   displayed and 'marked up': these lines & columns of text are marked up by `^`
     *   characters below each character in the entire input range.
     * 
     * - `context_loc` is the *optional* location info object which instructs this
     *   pretty-printer how much *leading* context should be displayed alongside
     *   the area referenced by `loc`. This can help provide context for the displayed
     *   error, etc.
     * 
     *   When this location info is not provided, a default context of 3 lines is
     *   used.
     * 
     * - `context_loc2` is another *optional* location info object, which serves
     *   a similar purpose to `context_loc`: it specifies the amount of *trailing*
     *   context lines to display in the pretty-print output.
     * 
     *   When this location info is not provided, a default context of 1 line only is
     *   used.
     * 
     * Special Notes:
     * 
     * - when the `loc`-indicated range is very large (about 5 lines or more), then
     *   only the first and last few lines of this block are printed while a
     *   `...continued...` message will be printed between them.
     * 
     *   This serves the purpose of not printing a huge amount of text when the `loc`
     *   range happens to be huge: this way a manageable & readable output results
     *   for arbitrary large ranges.
     * 
     * - this function can display lines of input which whave not yet been lexed.
     *   `prettyPrintRange()` can access the entire input!
     * 
     * @public
     * @this {RegExpLexer}
     */ prettyPrintRange: function lexer_prettyPrintRange(loc, context_loc, context_loc2) {
                loc = this.deriveLocationInfo(loc, context_loc, context_loc2);
                const CONTEXT = 3;
                const CONTEXT_TAIL = 1;
                const MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT = 2;
                var input = this.matched + this._input;
                var lines = input.split("\n");
                var l0 = Math.max(1, context_loc ? context_loc.first_line : loc.first_line - CONTEXT);
                var l1 = Math.max(1, context_loc2 ? context_loc2.last_line : loc.last_line + CONTEXT_TAIL);
                var lineno_display_width = 1 + Math.log10(l1 | 1) | 0;
                var ws_prefix = new Array(lineno_display_width).join(" ");
                var nonempty_line_indexes = [];
                var rv = lines.slice(l0 - 1, l1 + 1).map(function injectLineNumber(line, index) {
                    var lno = index + l0;
                    var lno_pfx = (ws_prefix + lno).substr(-lineno_display_width);
                    var rv = lno_pfx + ": " + line;
                    var errpfx = new Array(lineno_display_width + 1).join("^");
                    var offset = 3;
                    var len = 0;
                    if (lno === loc.first_line) {
                        offset += loc.first_column;
                        len = Math.max(2, (lno === loc.last_line ? loc.last_column : line.length) - loc.first_column + 1);
                    } else if (lno === loc.last_line) len = Math.max(2, loc.last_column + 1);
                    else if (lno > loc.first_line && lno < loc.last_line) len = Math.max(2, line.length + 1);
                    if (len) {
                        var lead = new Array(offset).join(".");
                        var mark = new Array(len).join("^");
                        rv += "\n" + errpfx + lead + mark;
                        if (line.trim().length > 0) nonempty_line_indexes.push(index);
                    }
                    rv = rv.replace(/\t/g, " ");
                    return rv;
                });
                // now make sure we don't print an overly large amount of error area: limit it 
                // to the top and bottom line count:
                if (nonempty_line_indexes.length > 2 * MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT) {
                    var clip_start = nonempty_line_indexes[MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT - 1] + 1;
                    var clip_end = nonempty_line_indexes[nonempty_line_indexes.length - MINIMUM_VISIBLE_NONEMPTY_LINE_COUNT] - 1;
                    var intermediate_line = new Array(lineno_display_width + 1).join(" ") + "  (...continued...)";
                    intermediate_line += "\n" + new Array(lineno_display_width + 1).join("-") + "  (---------------)";
                    rv.splice(clip_start, clip_end - clip_start + 1, intermediate_line);
                }
                return rv.join("\n");
            },
            /**
     * helper function, used to produce a human readable description as a string, given
     * the input `yylloc` location object.
     * 
     * Set `display_range_too` to TRUE to include the string character index position(s)
     * in the description if the `yylloc.range` is available.
     * 
     * @public
     * @this {RegExpLexer}
     */ describeYYLLOC: function lexer_describe_yylloc(yylloc, display_range_too) {
                var l1 = yylloc.first_line;
                var l2 = yylloc.last_line;
                var c1 = yylloc.first_column;
                var c2 = yylloc.last_column;
                var dl = l2 - l1;
                var dc = c2 - c1;
                var rv;
                if (dl === 0) {
                    rv = "line " + l1 + ", ";
                    if (dc <= 1) rv += "column " + c1;
                    else rv += "columns " + c1 + " .. " + c2;
                } else rv = "lines " + l1 + "(column " + c1 + ") .. " + l2 + "(column " + c2 + ")";
                if (yylloc.range && display_range_too) {
                    var r1 = yylloc.range[0];
                    var r2 = yylloc.range[1] - 1;
                    if (r2 <= r1) rv += " {String Offset: " + r1 + "}";
                    else rv += " {String Offset range: " + r1 + " .. " + r2 + "}";
                }
                return rv;
            },
            /**
     * test the lexed token: return FALSE when not a match, otherwise return token.
     * 
     * `match` is supposed to be an array coming out of a regex match, i.e. `match[0]`
     * contains the actually matched text string.
     * 
     * Also move the input cursor forward and update the match collectors:
     * 
     * - `yytext`
     * - `yyleng`
     * - `match`
     * - `matches`
     * - `yylloc`
     * - `offset`
     * 
     * @public
     * @this {RegExpLexer}
     */ test_match: function lexer_test_match(match, indexed_rule) {
                var token, lines, backup, match_str, match_str_len;
                if (this.options.backtrack_lexer) // save context
                backup = {
                    yylineno: this.yylineno,
                    yylloc: {
                        first_line: this.yylloc.first_line,
                        last_line: this.yylloc.last_line,
                        first_column: this.yylloc.first_column,
                        last_column: this.yylloc.last_column,
                        range: this.yylloc.range.slice(0)
                    },
                    yytext: this.yytext,
                    match: this.match,
                    matches: this.matches,
                    matched: this.matched,
                    yyleng: this.yyleng,
                    offset: this.offset,
                    _more: this._more,
                    _input: this._input,
                    //_signaled_error_token: this._signaled_error_token,
                    yy: this.yy,
                    conditionStack: this.conditionStack.slice(0),
                    done: this.done
                };
                match_str = match[0];
                match_str_len = match_str.length;
                // if (match_str.indexOf('\n') !== -1 || match_str.indexOf('\r') !== -1) {
                lines = match_str.split(/(?:\r\n?|\n)/g);
                if (lines.length > 1) {
                    this.yylineno += lines.length - 1;
                    this.yylloc.last_line = this.yylineno + 1;
                    this.yylloc.last_column = lines[lines.length - 1].length;
                } else this.yylloc.last_column += match_str_len;
                // }
                this.yytext += match_str;
                this.match += match_str;
                this.matched += match_str;
                this.matches = match;
                this.yyleng = this.yytext.length;
                this.yylloc.range[1] += match_str_len;
                // previous lex rules MAY have invoked the `more()` API rather than producing a token:
                // those rules will already have moved this `offset` forward matching their match lengths,
                // hence we must only add our own match length now:
                this.offset += match_str_len;
                this._more = false;
                this._backtrack = false;
                this._input = this._input.slice(match_str_len);
                // calling this method:
                //
                //   function lexer__performAction(yy, yyrulenumber, YY_START) {...}
                token = this.performAction.call(this, this.yy, indexed_rule, this.conditionStack[this.conditionStack.length - 1]);
                // otherwise, when the action codes are all simple return token statements:
                //token = this.simpleCaseActionClusters[indexed_rule];
                if (this.done && this._input) this.done = false;
                if (token) return token;
                else if (this._backtrack) {
                    // recover context
                    for(var k in backup)this[k] = backup[k];
                    this.__currentRuleSet__ = null;
                    return false; // rule action called reject() implying the next rule should be tested instead. 
                } else if (this._signaled_error_token) {
                    // produce one 'error' token as `.parseError()` in `reject()`
                    // did not guarantee a failure signal by throwing an exception!
                    token = this._signaled_error_token;
                    this._signaled_error_token = false;
                    return token;
                }
                return false;
            },
            /**
     * return next match in input
     * 
     * @public
     * @this {RegExpLexer}
     */ next: function lexer_next() {
                if (this.done) {
                    this.clear();
                    return this.EOF;
                }
                if (!this._input) this.done = true;
                var token, match, tempMatch, index;
                if (!this._more) this.clear();
                var spec = this.__currentRuleSet__;
                if (!spec) {
                    // Update the ruleset cache as we apparently encountered a state change or just started lexing.
                    // The cache is set up for fast lookup -- we assume a lexer will switch states much less often than it will
                    // invoke the `lex()` token-producing API and related APIs, hence caching the set for direct access helps
                    // speed up those activities a tiny bit.
                    spec = this.__currentRuleSet__ = this._currentRules();
                    // Check whether a *sane* condition has been pushed before: this makes the lexer robust against
                    // user-programmer bugs such as https://github.com/zaach/jison-lex/issues/19
                    if (!spec || !spec.rules) {
                        var lineno_msg = "";
                        if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                        var p = this.constructLexErrorInfo("Internal lexer engine error" + lineno_msg + ': The lex grammar programmer pushed a non-existing condition name "' + this.topState() + '"; this is a fatal error and should be reported to the application programmer team!', false);
                        // produce one 'error' token until this situation has been resolved, most probably by parse termination!
                        return this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    }
                }
                var rule_ids = spec.rules;
                var regexes = spec.__rule_regexes;
                var len = spec.__rule_count;
                // Note: the arrays are 1-based, while `len` itself is a valid index,
                // hence the non-standard less-or-equal check in the next loop condition!
                for(var i = 1; i <= len; i++){
                    tempMatch = this._input.match(regexes[i]);
                    if (tempMatch && (!match || tempMatch[0].length > match[0].length)) {
                        match = tempMatch;
                        index = i;
                        if (this.options.backtrack_lexer) {
                            token = this.test_match(tempMatch, rule_ids[i]);
                            if (token !== false) return token;
                            else if (this._backtrack) {
                                match = undefined;
                                continue; // rule action called reject() implying a rule MISmatch. 
                            } else // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                            return false;
                        } else if (!this.options.flex) break;
                    }
                }
                if (match) {
                    token = this.test_match(match, rule_ids[index]);
                    if (token !== false) return token;
                    // else: this is a lexer rule which consumes input without producing a token (e.g. whitespace)
                    return false;
                }
                if (!this._input) {
                    this.done = true;
                    this.clear();
                    return this.EOF;
                } else {
                    var lineno_msg = "";
                    if (this.options.trackPosition) lineno_msg = " on line " + (this.yylineno + 1);
                    var p = this.constructLexErrorInfo("Lexical error" + lineno_msg + ": Unrecognized text.", this.options.lexerErrorsAreRecoverable);
                    var pendingInput = this._input;
                    var activeCondition = this.topState();
                    var conditionStackDepth = this.conditionStack.length;
                    token = this.parseError(p.errStr, p, this.JisonLexerError) || this.ERROR;
                    if (token === this.ERROR) // we can try to recover from a lexer error that `parseError()` did not 'recover' for us
                    // by moving forward at least one character at a time IFF the (user-specified?) `parseError()`
                    // has not consumed/modified any pending input or changed state in the error handler:
                    {
                        if (!this.matches && // and make sure the input has been modified/consumed ...
                        pendingInput === this._input && // ...or the lexer state has been modified significantly enough
                        // to merit a non-consuming error handling action right now.
                        activeCondition === this.topState() && conditionStackDepth === this.conditionStack.length) this.input();
                    }
                    return token;
                }
            },
            /**
     * return next match that has a token
     * 
     * @public
     * @this {RegExpLexer}
     */ lex: function lexer_lex() {
                var r;
                // allow the PRE/POST handlers set/modify the return token for maximum flexibility of the generated lexer:
                if (typeof this.pre_lex === "function") r = this.pre_lex.call(this, 0);
                if (typeof this.options.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.pre_lex.call(this, r) || r;
                if (this.yy && typeof this.yy.pre_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.pre_lex.call(this, r) || r;
                while(!r)r = this.next();
                if (this.yy && typeof this.yy.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.yy.post_lex.call(this, r) || r;
                if (typeof this.options.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.options.post_lex.call(this, r) || r;
                if (typeof this.post_lex === "function") // (also account for a userdef function which does not return any value: keep the token as is)
                r = this.post_lex.call(this, r) || r;
                return r;
            },
            /**
     * return next match that has a token. Identical to the `lex()` API but does not invoke any of the 
     * `pre_lex()` nor any of the `post_lex()` callbacks.
     * 
     * @public
     * @this {RegExpLexer}
     */ fastLex: function lexer_fastLex() {
                var r;
                while(!r)r = this.next();
                return r;
            },
            /**
     * return info about the lexer state that can help a parser or other lexer API user to use the
     * most efficient means available. This API is provided to aid run-time performance for larger
     * systems which employ this lexer.
     * 
     * @public
     * @this {RegExpLexer}
     */ canIUse: function lexer_canIUse() {
                var rv = {
                    fastLex: !(typeof this.pre_lex === "function" || typeof this.options.pre_lex === "function" || this.yy && typeof this.yy.pre_lex === "function" || this.yy && typeof this.yy.post_lex === "function" || typeof this.options.post_lex === "function" || typeof this.post_lex === "function") && typeof this.fastLex === "function"
                };
                return rv;
            },
            /**
     * backwards compatible alias for `pushState()`;
     * the latter is symmetrical with `popState()` and we advise to use
     * those APIs in any modern lexer code, rather than `begin()`.
     * 
     * @public
     * @this {RegExpLexer}
     */ begin: function lexer_begin(condition) {
                return this.pushState(condition);
            },
            /**
     * activates a new lexer condition state (pushes the new lexer
     * condition state onto the condition stack)
     * 
     * @public
     * @this {RegExpLexer}
     */ pushState: function lexer_pushState(condition) {
                this.conditionStack.push(condition);
                this.__currentRuleSet__ = null;
                return this;
            },
            /**
     * pop the previously active lexer condition state off the condition
     * stack
     * 
     * @public
     * @this {RegExpLexer}
     */ popState: function lexer_popState() {
                var n = this.conditionStack.length - 1;
                if (n > 0) {
                    this.__currentRuleSet__ = null;
                    return this.conditionStack.pop();
                } else return this.conditionStack[0];
            },
            /**
     * return the currently active lexer condition state; when an index
     * argument is provided it produces the N-th previous condition state,
     * if available
     * 
     * @public
     * @this {RegExpLexer}
     */ topState: function lexer_topState(n) {
                n = this.conditionStack.length - 1 - Math.abs(n || 0);
                if (n >= 0) return this.conditionStack[n];
                else return "INITIAL";
            },
            /**
     * (internal) determine the lexer rule set which is active for the
     * currently active lexer condition state
     * 
     * @public
     * @this {RegExpLexer}
     */ _currentRules: function lexer__currentRules() {
                if (this.conditionStack.length && this.conditionStack[this.conditionStack.length - 1]) return this.conditions[this.conditionStack[this.conditionStack.length - 1]];
                else return this.conditions["INITIAL"];
            },
            /**
     * return the number of states currently on the stack
     * 
     * @public
     * @this {RegExpLexer}
     */ stateStackSize: function lexer_stateStackSize() {
                return this.conditionStack.length;
            },
            options: {
                trackPosition: true
            },
            JisonLexerError: JisonLexerError,
            performAction: function lexer__performAction(yy, yyrulenumber, YY_START) {
                var yy_ = this;
                var YYSTATE = YY_START;
                switch(yyrulenumber){
                    case 1:
                        break;
                    default:
                        return this.simpleCaseActionClusters[yyrulenumber];
                }
            },
            simpleCaseActionClusters: {
                /*! Conditions:: INITIAL */ /*! Rule::       (--[0-9a-z-A-Z-]*) */ 0: 13,
                /*! Conditions:: INITIAL */ /*! Rule::       \* */ 2: 5,
                /*! Conditions:: INITIAL */ /*! Rule::       \/ */ 3: 6,
                /*! Conditions:: INITIAL */ /*! Rule::       \+ */ 4: 3,
                /*! Conditions:: INITIAL */ /*! Rule::       - */ 5: 4,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)px\b */ 6: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)cm\b */ 7: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)mm\b */ 8: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)in\b */ 9: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pt\b */ 10: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)pc\b */ 11: 15,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)deg\b */ 12: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)grad\b */ 13: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rad\b */ 14: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)turn\b */ 15: 16,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)s\b */ 16: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ms\b */ 17: 17,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)Hz\b */ 18: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)kHz\b */ 19: 18,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpi\b */ 20: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dpcm\b */ 21: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)dppx\b */ 22: 19,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)em\b */ 23: 20,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ex\b */ 24: 21,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)ch\b */ 25: 22,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)rem\b */ 26: 23,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vw\b */ 27: 25,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vh\b */ 28: 24,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmin\b */ 29: 26,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)vmax\b */ 30: 27,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)% */ 31: 28,
                /*! Conditions:: INITIAL */ /*! Rule::       ([0-9]+(\.[0-9]*)?|\.[0-9]+)\b */ 32: 11,
                /*! Conditions:: INITIAL */ /*! Rule::       (calc) */ 33: 9,
                /*! Conditions:: INITIAL */ /*! Rule::       (var) */ 34: 12,
                /*! Conditions:: INITIAL */ /*! Rule::       ([a-z]+) */ 35: 10,
                /*! Conditions:: INITIAL */ /*! Rule::       \( */ 36: 7,
                /*! Conditions:: INITIAL */ /*! Rule::       \) */ 37: 8,
                /*! Conditions:: INITIAL */ /*! Rule::       , */ 38: 14,
                /*! Conditions:: INITIAL */ /*! Rule::       $ */ 39: 1
            },
            rules: [
                /*  0: */ /^(?:(--[\d\-A-Za-z]*))/,
                /*  1: */ /^(?:\s+)/,
                /*  2: */ /^(?:\*)/,
                /*  3: */ /^(?:\/)/,
                /*  4: */ /^(?:\+)/,
                /*  5: */ /^(?:-)/,
                /*  6: */ /^(?:(\d+(\.\d*)?|\.\d+)px\b)/,
                /*  7: */ /^(?:(\d+(\.\d*)?|\.\d+)cm\b)/,
                /*  8: */ /^(?:(\d+(\.\d*)?|\.\d+)mm\b)/,
                /*  9: */ /^(?:(\d+(\.\d*)?|\.\d+)in\b)/,
                /* 10: */ /^(?:(\d+(\.\d*)?|\.\d+)pt\b)/,
                /* 11: */ /^(?:(\d+(\.\d*)?|\.\d+)pc\b)/,
                /* 12: */ /^(?:(\d+(\.\d*)?|\.\d+)deg\b)/,
                /* 13: */ /^(?:(\d+(\.\d*)?|\.\d+)grad\b)/,
                /* 14: */ /^(?:(\d+(\.\d*)?|\.\d+)rad\b)/,
                /* 15: */ /^(?:(\d+(\.\d*)?|\.\d+)turn\b)/,
                /* 16: */ /^(?:(\d+(\.\d*)?|\.\d+)s\b)/,
                /* 17: */ /^(?:(\d+(\.\d*)?|\.\d+)ms\b)/,
                /* 18: */ /^(?:(\d+(\.\d*)?|\.\d+)Hz\b)/,
                /* 19: */ /^(?:(\d+(\.\d*)?|\.\d+)kHz\b)/,
                /* 20: */ /^(?:(\d+(\.\d*)?|\.\d+)dpi\b)/,
                /* 21: */ /^(?:(\d+(\.\d*)?|\.\d+)dpcm\b)/,
                /* 22: */ /^(?:(\d+(\.\d*)?|\.\d+)dppx\b)/,
                /* 23: */ /^(?:(\d+(\.\d*)?|\.\d+)em\b)/,
                /* 24: */ /^(?:(\d+(\.\d*)?|\.\d+)ex\b)/,
                /* 25: */ /^(?:(\d+(\.\d*)?|\.\d+)ch\b)/,
                /* 26: */ /^(?:(\d+(\.\d*)?|\.\d+)rem\b)/,
                /* 27: */ /^(?:(\d+(\.\d*)?|\.\d+)vw\b)/,
                /* 28: */ /^(?:(\d+(\.\d*)?|\.\d+)vh\b)/,
                /* 29: */ /^(?:(\d+(\.\d*)?|\.\d+)vmin\b)/,
                /* 30: */ /^(?:(\d+(\.\d*)?|\.\d+)vmax\b)/,
                /* 31: */ /^(?:(\d+(\.\d*)?|\.\d+)%)/,
                /* 32: */ /^(?:(\d+(\.\d*)?|\.\d+)\b)/,
                /* 33: */ /^(?:(calc))/,
                /* 34: */ /^(?:(var))/,
                /* 35: */ /^(?:([a-z]+))/,
                /* 36: */ /^(?:\()/,
                /* 37: */ /^(?:\))/,
                /* 38: */ /^(?:,)/,
                /* 39: */ /^(?:$)/
            ],
            conditions: {
                "INITIAL": {
                    rules: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10,
                        11,
                        12,
                        13,
                        14,
                        15,
                        16,
                        17,
                        18,
                        19,
                        20,
                        21,
                        22,
                        23,
                        24,
                        25,
                        26,
                        27,
                        28,
                        29,
                        30,
                        31,
                        32,
                        33,
                        34,
                        35,
                        36,
                        37,
                        38,
                        39
                    ],
                    inclusive: true
                }
            }
        };
        return lexer;
    }();
    parser.lexer = lexer;
    function Parser() {
        this.yy = {};
    }
    Parser.prototype = parser;
    parser.Parser = Parser;
    return new Parser();
}();
$3e245abb866b1818$export$8f49e4af10703ce3 = $3e245abb866b1818$var$parser;
$3e245abb866b1818$export$7acfa6ed01010e37 = $3e245abb866b1818$var$parser.Parser;
$3e245abb866b1818$export$98e6a39c04603d36 = function() {
    return $3e245abb866b1818$var$parser.parse.apply($3e245abb866b1818$var$parser, arguments);
};


var $a7930557d15da2c1$exports = {};
"use strict";
Object.defineProperty($a7930557d15da2c1$exports, "__esModule", {
    value: true
});
$a7930557d15da2c1$exports.flip = $a7930557d15da2c1$var$flip;
var $65dbb058bfef3b37$exports = {};
"use strict";
Object.defineProperty($65dbb058bfef3b37$exports, "__esModule", {
    value: true
});
var $52288e792a664d6a$exports = {};
var $52288e792a664d6a$var$conversions = {
    // length
    "px": {
        "px": 1,
        "cm": 96.0 / 2.54,
        "mm": 96.0 / 25.4,
        "in": 96,
        "pt": 96.0 / 72.0,
        "pc": 16
    },
    "cm": {
        "px": 2.54 / 96.0,
        "cm": 1,
        "mm": 0.1,
        "in": 2.54,
        "pt": 2.54 / 72.0,
        "pc": 2.54 / 6.0
    },
    "mm": {
        "px": 25.4 / 96.0,
        "cm": 10,
        "mm": 1,
        "in": 25.4,
        "pt": 25.4 / 72.0,
        "pc": 25.4 / 6.0
    },
    "in": {
        "px": 1.0 / 96.0,
        "cm": 1.0 / 2.54,
        "mm": 1.0 / 25.4,
        "in": 1,
        "pt": 1.0 / 72.0,
        "pc": 1.0 / 6.0
    },
    "pt": {
        "px": 0.75,
        "cm": 72.0 / 2.54,
        "mm": 72.0 / 25.4,
        "in": 72,
        "pt": 1,
        "pc": 12
    },
    "pc": {
        "px": 0.0625,
        "cm": 6.0 / 2.54,
        "mm": 6.0 / 25.4,
        "in": 6,
        "pt": 6.0 / 72.0,
        "pc": 1
    },
    // angle
    "deg": {
        "deg": 1,
        "grad": 0.9,
        "rad": 180 / Math.PI,
        "turn": 360
    },
    "grad": {
        "deg": 400 / 360,
        "grad": 1,
        "rad": 200 / Math.PI,
        "turn": 400
    },
    "rad": {
        "deg": Math.PI / 180,
        "grad": Math.PI / 200,
        "rad": 1,
        "turn": Math.PI * 2
    },
    "turn": {
        "deg": 1 / 360,
        "grad": 1 / 400,
        "rad": 0.5 / Math.PI,
        "turn": 1
    },
    // time
    "s": {
        "s": 1,
        "ms": 0.001
    },
    "ms": {
        "s": 1000,
        "ms": 1
    },
    // frequency
    "Hz": {
        "Hz": 1,
        "kHz": 1000
    },
    "kHz": {
        "Hz": 0.001,
        "kHz": 1
    },
    // resolution
    "dpi": {
        "dpi": 1,
        "dpcm": 1.0 / 2.54,
        "dppx": 1 / 96
    },
    "dpcm": {
        "dpi": 2.54,
        "dpcm": 1,
        "dppx": 2.54 / 96.0
    },
    "dppx": {
        "dpi": 96,
        "dpcm": 96.0 / 2.54,
        "dppx": 1
    }
};
$52288e792a664d6a$exports = function(value, sourceUnit, targetUnit, precision) {
    if (!$52288e792a664d6a$var$conversions.hasOwnProperty(targetUnit)) throw new Error("Cannot convert to " + targetUnit);
    if (!$52288e792a664d6a$var$conversions[targetUnit].hasOwnProperty(sourceUnit)) throw new Error("Cannot convert from " + sourceUnit + " to " + targetUnit);
    var converted = $52288e792a664d6a$var$conversions[targetUnit][sourceUnit] * value;
    if (precision !== false) {
        precision = Math.pow(10, parseInt(precision) || 5);
        return Math.round(converted * precision) / precision;
    }
    return converted;
};


var $65dbb058bfef3b37$var$_cssUnitConverter2 = $65dbb058bfef3b37$var$_interopRequireDefault($52288e792a664d6a$exports);
function $65dbb058bfef3b37$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $65dbb058bfef3b37$var$convertNodes(left, right, precision) {
    switch(left.type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
            return $65dbb058bfef3b37$var$convertAbsoluteLength(left, right, precision);
        default:
            return {
                left: left,
                right: right
            };
    }
}
function $65dbb058bfef3b37$var$convertAbsoluteLength(left, right, precision) {
    if (right.type === left.type) right = {
        type: left.type,
        value: (0, $65dbb058bfef3b37$var$_cssUnitConverter2.default)(right.value, right.unit, left.unit, precision),
        unit: left.unit
    };
    return {
        left: left,
        right: right
    };
}
$65dbb058bfef3b37$exports.default = $65dbb058bfef3b37$var$convertNodes;
$65dbb058bfef3b37$exports = $65dbb058bfef3b37$exports["default"];


var $a7930557d15da2c1$var$_convert2 = $a7930557d15da2c1$var$_interopRequireDefault($65dbb058bfef3b37$exports);
function $a7930557d15da2c1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $a7930557d15da2c1$var$reduce(node, precision) {
    if (node.type === "MathExpression") return $a7930557d15da2c1$var$reduceMathExpression(node, precision);
    if (node.type === "Calc") return $a7930557d15da2c1$var$reduce(node.value, precision);
    return node;
}
function $a7930557d15da2c1$var$isEqual(left, right) {
    return left.type === right.type && left.value === right.value;
}
function $a7930557d15da2c1$var$isValueType(type) {
    switch(type){
        case "LengthValue":
        case "AngleValue":
        case "TimeValue":
        case "FrequencyValue":
        case "ResolutionValue":
        case "EmValue":
        case "ExValue":
        case "ChValue":
        case "RemValue":
        case "VhValue":
        case "VwValue":
        case "VminValue":
        case "VmaxValue":
        case "PercentageValue":
        case "Value":
            return true;
    }
    return false;
}
function $a7930557d15da2c1$var$convertMathExpression(node, precision) {
    var nodes = (0, $a7930557d15da2c1$var$_convert2.default)(node.left, node.right, precision);
    var left = $a7930557d15da2c1$var$reduce(nodes.left, precision);
    var right = $a7930557d15da2c1$var$reduce(nodes.right, precision);
    if (left.type === "MathExpression" && right.type === "MathExpression") {
        if (left.operator === "/" && right.operator === "*" || left.operator === "-" && right.operator === "+" || left.operator === "*" && right.operator === "/" || left.operator === "+" && right.operator === "-") {
            if ($a7930557d15da2c1$var$isEqual(left.right, right.right)) nodes = (0, $a7930557d15da2c1$var$_convert2.default)(left.left, right.left, precision);
            else if ($a7930557d15da2c1$var$isEqual(left.right, right.left)) nodes = (0, $a7930557d15da2c1$var$_convert2.default)(left.left, right.right, precision);
            left = $a7930557d15da2c1$var$reduce(nodes.left, precision);
            right = $a7930557d15da2c1$var$reduce(nodes.right, precision);
        }
    }
    node.left = left;
    node.right = right;
    return node;
}
function $a7930557d15da2c1$var$flip(operator) {
    return operator === "+" ? "-" : "+";
}
function $a7930557d15da2c1$var$flipValue(node) {
    if ($a7930557d15da2c1$var$isValueType(node.type)) node.value = -node.value;
    else if (node.type == "MathExpression") {
        node.left = $a7930557d15da2c1$var$flipValue(node.left);
        node.right = $a7930557d15da2c1$var$flipValue(node.right);
    }
    return node;
}
function $a7930557d15da2c1$var$reduceAddSubExpression(node, precision) {
    var _node = node, left = _node.left, right = _node.right, op = _node.operator;
    if (left.type === "CssVariable" || right.type === "CssVariable") return node;
    // something + 0 => something
    // something - 0 => something
    if (right.value === 0) return left;
    // 0 + something => something
    if (left.value === 0 && op === "+") return right;
    // 0 - something => -something
    if (left.value === 0 && op === "-") return $a7930557d15da2c1$var$flipValue(right);
    // value + value
    // value - value
    if (left.type === right.type && $a7930557d15da2c1$var$isValueType(left.type)) {
        node = Object.assign({}, left);
        if (op === "+") node.value = left.value + right.value;
        else node.value = left.value - right.value;
    }
    // value <op> (expr)
    if ($a7930557d15da2c1$var$isValueType(left.type) && (right.operator === "+" || right.operator === "-") && right.type === "MathExpression") {
        // value + (value + something) => (value + value) + something
        // value + (value - something) => (value + value) - something
        // value - (value + something) => (value - value) - something
        // value - (value - something) => (value - value) + something
        if (left.type === right.left.type) {
            node = Object.assign({}, node);
            node.left = $a7930557d15da2c1$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left,
                right: right.left
            }, precision);
            node.right = right.right;
            node.operator = op === "-" ? $a7930557d15da2c1$var$flip(right.operator) : right.operator;
            return $a7930557d15da2c1$var$reduce(node, precision);
        } else if (left.type === right.right.type) {
            node = Object.assign({}, node);
            node.left = $a7930557d15da2c1$var$reduce({
                type: "MathExpression",
                operator: op === "-" ? $a7930557d15da2c1$var$flip(right.operator) : right.operator,
                left: left,
                right: right.right
            }, precision);
            node.right = right.left;
            return $a7930557d15da2c1$var$reduce(node, precision);
        }
    }
    // (expr) <op> value
    if (left.type === "MathExpression" && (left.operator === "+" || left.operator === "-") && $a7930557d15da2c1$var$isValueType(right.type)) {
        // (value + something) + value => (value + value) + something
        // (value - something) + value => (value + value) - something
        // (value + something) - value => (value - value) + something
        // (value - something) - value => (value - value) - something
        if (right.type === left.left.type) {
            node = Object.assign({}, left);
            node.left = $a7930557d15da2c1$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.left,
                right: right
            }, precision);
            return $a7930557d15da2c1$var$reduce(node, precision);
        } else if (right.type === left.right.type) {
            node = Object.assign({}, left);
            if (left.operator === "-") {
                node.right = $a7930557d15da2c1$var$reduce({
                    type: "MathExpression",
                    operator: op === "-" ? "+" : "-",
                    left: right,
                    right: left.right
                }, precision);
                node.operator = op === "-" ? "-" : "+";
            } else node.right = $a7930557d15da2c1$var$reduce({
                type: "MathExpression",
                operator: op,
                left: left.right,
                right: right
            }, precision);
            if (node.right.value < 0) {
                node.right.value *= -1;
                node.operator = node.operator === "-" ? "+" : "-";
            }
            return $a7930557d15da2c1$var$reduce(node, precision);
        }
    }
    return node;
}
function $a7930557d15da2c1$var$reduceDivisionExpression(node, precision) {
    if (!$a7930557d15da2c1$var$isValueType(node.right.type)) return node;
    if (node.right.type !== "Value") throw new Error('Cannot divide by "' + node.right.unit + '", number expected');
    if (node.right.value === 0) throw new Error("Cannot divide by zero");
    // (expr) / value
    if (node.left.type === "MathExpression") {
        if ($a7930557d15da2c1$var$isValueType(node.left.left.type) && $a7930557d15da2c1$var$isValueType(node.left.right.type)) {
            node.left.left.value /= node.right.value;
            node.left.right.value /= node.right.value;
            return $a7930557d15da2c1$var$reduce(node.left, precision);
        }
        return node;
    } else if ($a7930557d15da2c1$var$isValueType(node.left.type)) {
        node.left.value /= node.right.value;
        return node.left;
    }
    return node;
}
function $a7930557d15da2c1$var$reduceMultiplicationExpression(node) {
    // (expr) * value
    if (node.left.type === "MathExpression" && node.right.type === "Value") {
        if ($a7930557d15da2c1$var$isValueType(node.left.left.type) && $a7930557d15da2c1$var$isValueType(node.left.right.type)) {
            node.left.left.value *= node.right.value;
            node.left.right.value *= node.right.value;
            return node.left;
        }
    } else if ($a7930557d15da2c1$var$isValueType(node.left.type) && node.right.type === "Value") {
        node.left.value *= node.right.value;
        return node.left;
    } else if (node.left.type === "Value" && node.right.type === "MathExpression") {
        if ($a7930557d15da2c1$var$isValueType(node.right.left.type) && $a7930557d15da2c1$var$isValueType(node.right.right.type)) {
            node.right.left.value *= node.left.value;
            node.right.right.value *= node.left.value;
            return node.right;
        }
    } else if (node.left.type === "Value" && $a7930557d15da2c1$var$isValueType(node.right.type)) {
        node.right.value *= node.left.value;
        return node.right;
    }
    return node;
}
function $a7930557d15da2c1$var$reduceMathExpression(node, precision) {
    node = $a7930557d15da2c1$var$convertMathExpression(node, precision);
    switch(node.operator){
        case "+":
        case "-":
            return $a7930557d15da2c1$var$reduceAddSubExpression(node, precision);
        case "/":
            return $a7930557d15da2c1$var$reduceDivisionExpression(node, precision);
        case "*":
            return $a7930557d15da2c1$var$reduceMultiplicationExpression(node);
    }
    return node;
}
$a7930557d15da2c1$exports.default = $a7930557d15da2c1$var$reduce;


var $8607684acc2f3f12$var$_reducer2 = $8607684acc2f3f12$var$_interopRequireDefault($a7930557d15da2c1$exports);
var $bf19901b493d4dca$exports = {};
"use strict";
Object.defineProperty($bf19901b493d4dca$exports, "__esModule", {
    value: true
});
$bf19901b493d4dca$exports.default = function(calc, node, precision) {
    var str = $bf19901b493d4dca$var$stringify(node, precision);
    if (node.type === "MathExpression") // if calc expression couldn't be resolved to a single value, re-wrap it as
    // a calc()
    str = calc + "(" + str + ")";
    return str;
};

var $bf19901b493d4dca$var$order = {
    "*": 0,
    "/": 0,
    "+": 1,
    "-": 1
};
function $bf19901b493d4dca$var$round(value, prec) {
    if (prec !== false) {
        var precision = Math.pow(10, prec);
        return Math.round(value * precision) / precision;
    }
    return value;
}
function $bf19901b493d4dca$var$stringify(node, prec) {
    switch(node.type){
        case "MathExpression":
            var left = node.left, right = node.right, op = node.operator;
            var str = "";
            if (left.type === "MathExpression" && $bf19901b493d4dca$var$order[op] < $bf19901b493d4dca$var$order[left.operator]) str += "(" + $bf19901b493d4dca$var$stringify(left, prec) + ")";
            else str += $bf19901b493d4dca$var$stringify(left, prec);
            str += " " + node.operator + " ";
            if (right.type === "MathExpression" && $bf19901b493d4dca$var$order[op] < $bf19901b493d4dca$var$order[right.operator]) str += "(" + $bf19901b493d4dca$var$stringify(right, prec) + ")";
            else if (right.type === "MathExpression" && op === "-" && [
                "+",
                "-"
            ].includes(right.operator)) {
                // fix #52 : a-(b+c) = a-b-c
                right.operator = (0, $a7930557d15da2c1$exports.flip)(right.operator);
                str += $bf19901b493d4dca$var$stringify(right, prec);
            } else str += $bf19901b493d4dca$var$stringify(right, prec);
            return str;
        case "Value":
            return $bf19901b493d4dca$var$round(node.value, prec);
        case "CssVariable":
            if (node.fallback) return "var(" + node.value + ", " + $bf19901b493d4dca$var$stringify(node.fallback, prec, true) + ")";
            return "var(" + node.value + ")";
        case "Calc":
            if (node.prefix) return "-" + node.prefix + "-calc(" + $bf19901b493d4dca$var$stringify(node.value, prec) + ")";
            return "calc(" + $bf19901b493d4dca$var$stringify(node.value, prec) + ")";
        default:
            return $bf19901b493d4dca$var$round(node.value, prec) + node.unit;
    }
}
$bf19901b493d4dca$exports = $bf19901b493d4dca$exports["default"];


var $8607684acc2f3f12$var$_stringifier2 = $8607684acc2f3f12$var$_interopRequireDefault($bf19901b493d4dca$exports);
function $8607684acc2f3f12$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// eslint-disable-line
var $8607684acc2f3f12$var$MATCH_CALC = /((?:\-[a-z]+\-)?calc)/;
$8607684acc2f3f12$exports.default = function(value) {
    var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
    return (0, $8607684acc2f3f12$var$_postcssValueParser2.default)(value).walk(function(node) {
        // skip anything which isn't a calc() function
        if (node.type !== "function" || !$8607684acc2f3f12$var$MATCH_CALC.test(node.value)) return;
        // stringify calc expression and produce an AST
        var contents = $8607684acc2f3f12$var$_postcssValueParser2.default.stringify(node.nodes);
        // skip constant() and env()
        if (contents.indexOf("constant") >= 0 || contents.indexOf("env") >= 0) return;
        var ast = $3e245abb866b1818$export$8f49e4af10703ce3.parse(contents);
        // reduce AST to its simplest form, that is, either to a single value
        // or a simplified calc expression
        var reducedAst = (0, $8607684acc2f3f12$var$_reducer2.default)(ast, precision);
        // stringify AST and write it back
        node.type = "word";
        node.value = (0, $8607684acc2f3f12$var$_stringifier2.default)(node.value, reducedAst, precision);
    }, true).toString();
};
$8607684acc2f3f12$exports = $8607684acc2f3f12$exports["default"];



var $iyeK6 = parcelRequire("iyeK6");

var $2cfdd8db3ab543a8$var$parseIsSsrByDefault = function parseIsSsrByDefault() {
    return !(typeof window !== "undefined" && window.document && window.document.createElement && window.setTimeout);
};
var $2cfdd8db3ab543a8$export$98f03c5d19621d70 = {
    isSsr: $2cfdd8db3ab543a8$var$parseIsSsrByDefault(),
    get: function get(key) {
        return $2cfdd8db3ab543a8$export$98f03c5d19621d70[key];
    },
    set: function set(key, value) {
        if (typeof key === "string") $2cfdd8db3ab543a8$export$98f03c5d19621d70[key] = value;
        else {
            var keys = Object.keys(key);
            if (keys && keys.length) keys.forEach(function(k) {
                $2cfdd8db3ab543a8$export$98f03c5d19621d70[k] = key[k];
            });
        }
    }
};




function $aea69284868f6157$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $aea69284868f6157$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $aea69284868f6157$var$ownKeys(Object(source), true).forEach(function(key) {
            $aea69284868f6157$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $aea69284868f6157$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $aea69284868f6157$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $aea69284868f6157$var$_toConsumableArray(arr) {
    return $aea69284868f6157$var$_arrayWithoutHoles(arr) || $aea69284868f6157$var$_iterableToArray(arr) || $aea69284868f6157$var$_unsupportedIterableToArray(arr) || $aea69284868f6157$var$_nonIterableSpread();
}
function $aea69284868f6157$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $aea69284868f6157$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $aea69284868f6157$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $aea69284868f6157$var$_arrayLikeToArray(o, minLen);
}
function $aea69284868f6157$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $aea69284868f6157$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $aea69284868f6157$var$_arrayLikeToArray(arr);
}
function $aea69284868f6157$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $aea69284868f6157$var$stringCache = {
    widthCache: {},
    cacheCount: 0
};
var $aea69284868f6157$var$MAX_CACHE_NUM = 2000;
var $aea69284868f6157$var$SPAN_STYLE = {
    position: "absolute",
    top: "-20000px",
    left: 0,
    padding: 0,
    margin: 0,
    border: "none",
    whiteSpace: "pre"
};
var $aea69284868f6157$var$STYLE_LIST = [
    "minWidth",
    "maxWidth",
    "width",
    "minHeight",
    "maxHeight",
    "height",
    "top",
    "left",
    "fontSize",
    "lineHeight",
    "padding",
    "margin",
    "paddingLeft",
    "paddingRight",
    "paddingTop",
    "paddingBottom",
    "marginLeft",
    "marginRight",
    "marginTop",
    "marginBottom"
];
var $aea69284868f6157$var$MEASUREMENT_SPAN_ID = "recharts_measurement_span";
function $aea69284868f6157$var$autoCompleteStyle(name, value) {
    if ($aea69284868f6157$var$STYLE_LIST.indexOf(name) >= 0 && value === +value) return "".concat(value, "px");
    return value;
}
function $aea69284868f6157$var$camelToMiddleLine(text) {
    var strs = text.split("");
    var formatStrs = strs.reduce(function(result, entry) {
        if (entry === entry.toUpperCase()) return [].concat($aea69284868f6157$var$_toConsumableArray(result), [
            "-",
            entry.toLowerCase()
        ]);
        return [].concat($aea69284868f6157$var$_toConsumableArray(result), [
            entry
        ]);
    }, []);
    return formatStrs.join("");
}
var $aea69284868f6157$export$9a2c38fb88d8e30 = function getStyleString(style) {
    return Object.keys(style).reduce(function(result, s) {
        return "".concat(result).concat($aea69284868f6157$var$camelToMiddleLine(s), ":").concat($aea69284868f6157$var$autoCompleteStyle(s, style[s]), ";");
    }, "");
};
var $aea69284868f6157$export$e5560531f057ad5d = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, $2cfdd8db3ab543a8$export$98f03c5d19621d70).isSsr) return {
        width: 0,
        height: 0
    };
    var str = "".concat(text);
    var styleString = $aea69284868f6157$export$9a2c38fb88d8e30(style);
    var cacheKey = "".concat(str, "-").concat(styleString);
    if ($aea69284868f6157$var$stringCache.widthCache[cacheKey]) return $aea69284868f6157$var$stringCache.widthCache[cacheKey];
    try {
        var measurementSpan = document.getElementById($aea69284868f6157$var$MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement("span");
            measurementSpan.setAttribute("id", $aea69284868f6157$var$MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute("aria-hidden", "true");
            document.body.appendChild(measurementSpan);
        } // Need to use CSS Object Model (CSSOM) to be able to comply with Content Security Policy (CSP)
        // https://en.wikipedia.org/wiki/Content_Security_Policy
        var measurementSpanStyle = $aea69284868f6157$var$_objectSpread($aea69284868f6157$var$_objectSpread({}, $aea69284868f6157$var$SPAN_STYLE), style);
        Object.keys(measurementSpanStyle).map(function(styleKey) {
            measurementSpan.style[styleKey] = measurementSpanStyle[styleKey];
            return styleKey;
        });
        measurementSpan.textContent = str;
        var rect = measurementSpan.getBoundingClientRect();
        var result = {
            width: rect.width,
            height: rect.height
        };
        $aea69284868f6157$var$stringCache.widthCache[cacheKey] = result;
        if (++$aea69284868f6157$var$stringCache.cacheCount > $aea69284868f6157$var$MAX_CACHE_NUM) {
            $aea69284868f6157$var$stringCache.cacheCount = 0;
            $aea69284868f6157$var$stringCache.widthCache = {};
        }
        return result;
    } catch (e) {
        return {
            width: 0,
            height: 0
        };
    }
};
var $aea69284868f6157$export$622cea445a1c5b7d = function getOffset(el) {
    var html = el.ownerDocument.documentElement;
    var box = {
        top: 0,
        left: 0
    }; // If we don't have gBCR, just use 0,0 rather than error
    // BlackBerry 5, iOS 3 (original iPhone)
    if (typeof el.getBoundingClientRect !== "undefined") box = el.getBoundingClientRect();
    return {
        top: box.top + window.pageYOffset - html.clientTop,
        left: box.left + window.pageXOffset - html.clientLeft
    };
};
var $aea69284868f6157$export$f209e6c32ad3d02e = function calculateChartCoordinate(event, offset) {
    return {
        chartX: Math.round(event.pageX - offset.left),
        chartY: Math.round(event.pageY - offset.top)
    };
};


function $ddbf2ed6ffdaf856$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ddbf2ed6ffdaf856$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ddbf2ed6ffdaf856$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ddbf2ed6ffdaf856$var$_typeof(obj);
}
function $ddbf2ed6ffdaf856$var$_extends() {
    $ddbf2ed6ffdaf856$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ddbf2ed6ffdaf856$var$_extends.apply(this, arguments);
}
function $ddbf2ed6ffdaf856$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ddbf2ed6ffdaf856$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ddbf2ed6ffdaf856$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $ddbf2ed6ffdaf856$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ddbf2ed6ffdaf856$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ddbf2ed6ffdaf856$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $ddbf2ed6ffdaf856$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ddbf2ed6ffdaf856$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $ddbf2ed6ffdaf856$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $ddbf2ed6ffdaf856$var$_setPrototypeOf(subClass, superClass);
}
function $ddbf2ed6ffdaf856$var$_setPrototypeOf(o, p) {
    $ddbf2ed6ffdaf856$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $ddbf2ed6ffdaf856$var$_setPrototypeOf(o, p);
}
function $ddbf2ed6ffdaf856$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $ddbf2ed6ffdaf856$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $ddbf2ed6ffdaf856$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $ddbf2ed6ffdaf856$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $ddbf2ed6ffdaf856$var$_possibleConstructorReturn(this, result);
    };
}
function $ddbf2ed6ffdaf856$var$_possibleConstructorReturn(self, call) {
    if (call && ($ddbf2ed6ffdaf856$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $ddbf2ed6ffdaf856$var$_assertThisInitialized(self);
}
function $ddbf2ed6ffdaf856$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $ddbf2ed6ffdaf856$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $ddbf2ed6ffdaf856$var$_getPrototypeOf(o) {
    $ddbf2ed6ffdaf856$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ddbf2ed6ffdaf856$var$_getPrototypeOf(o);
}
function $ddbf2ed6ffdaf856$var$_slicedToArray(arr, i) {
    return $ddbf2ed6ffdaf856$var$_arrayWithHoles(arr) || $ddbf2ed6ffdaf856$var$_iterableToArrayLimit(arr, i) || $ddbf2ed6ffdaf856$var$_unsupportedIterableToArray(arr, i) || $ddbf2ed6ffdaf856$var$_nonIterableRest();
}
function $ddbf2ed6ffdaf856$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ddbf2ed6ffdaf856$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ddbf2ed6ffdaf856$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ddbf2ed6ffdaf856$var$_arrayLikeToArray(o, minLen);
}
function $ddbf2ed6ffdaf856$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ddbf2ed6ffdaf856$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ddbf2ed6ffdaf856$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $ddbf2ed6ffdaf856$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ddbf2ed6ffdaf856$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ddbf2ed6ffdaf856$var$ownKeys(Object(source), true).forEach(function(key) {
            $ddbf2ed6ffdaf856$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ddbf2ed6ffdaf856$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ddbf2ed6ffdaf856$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $ddbf2ed6ffdaf856$var$BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var $ddbf2ed6ffdaf856$var$calculateWordWidths = function calculateWordWidths(props) {
    try {
        var words = [];
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(props.children)) {
            if (props.breakAll) words = props.children.toString().split("");
            else words = props.children.toString().split($ddbf2ed6ffdaf856$var$BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map(function(word) {
            return {
                word: word,
                width: (0, $aea69284868f6157$export$e5560531f057ad5d)(word, props.style).width
            };
        });
        var spaceWidth = props.breakAll ? 0 : (0, $aea69284868f6157$export$e5560531f057ad5d)("\xa0", props.style).width;
        return {
            wordsWithComputedWidth: wordsWithComputedWidth,
            spaceWidth: spaceWidth
        };
    } catch (e) {
        return null;
    }
};
var $ddbf2ed6ffdaf856$var$calculateWordsByLines = function calculateWordsByLines(props, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit) {
    var shouldLimitLines = (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(props.maxLines);
    var text = props.children;
    var calculate = function calculate() {
        var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        return words.reduce(function(result, _ref) {
            var word = _ref.word, width = _ref.width;
            var currentLine = result[result.length - 1];
            if (currentLine && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < lineWidth)) {
                // Word can be added to an existing line
                currentLine.words.push(word);
                currentLine.width += width + spaceWidth;
            } else {
                // Add first word to line or word is too long to scaleToFit on existing line
                var newLine = {
                    words: [
                        word
                    ],
                    width: width
                };
                result.push(newLine);
            }
            return result;
        }, []);
    };
    var originalResult = calculate(initialWordsWithComputedWith);
    var findLongestLine = function findLongestLine(words) {
        return words.reduce(function(a, b) {
            return a.width > b.width ? a : b;
        });
    };
    if (!shouldLimitLines) return originalResult;
    var suffix = "…";
    var checkOverflow = function checkOverflow(index) {
        var tempText = text.slice(0, index);
        var words = $ddbf2ed6ffdaf856$var$calculateWordWidths($ddbf2ed6ffdaf856$var$_objectSpread($ddbf2ed6ffdaf856$var$_objectSpread({}, props), {}, {
            children: tempText + suffix
        })).wordsWithComputedWidth;
        var result = calculate(words);
        var doesOverflow = result.length > props.maxLines || findLongestLine(result).width > lineWidth;
        return [
            doesOverflow,
            result
        ];
    };
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var _checkOverflow = checkOverflow(prev), _checkOverflow2 = $ddbf2ed6ffdaf856$var$_slicedToArray(_checkOverflow, 2), doesPrevOverflow = _checkOverflow2[0], result = _checkOverflow2[1];
        var _checkOverflow3 = checkOverflow(middle), _checkOverflow4 = $ddbf2ed6ffdaf856$var$_slicedToArray(_checkOverflow3, 1), doesMiddleOverflow = _checkOverflow4[0];
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    } // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var $ddbf2ed6ffdaf856$var$getWordsWithoutCalculate = function getWordsWithoutCalculate(children) {
    var words = !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(children) ? children.toString().split($ddbf2ed6ffdaf856$var$BREAKING_SPACES) : [];
    return [
        {
            words: words
        }
    ];
};
var $ddbf2ed6ffdaf856$var$getWordsByLines = function getWordsByLines(props, needCalculate) {
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((props.width || props.scaleToFit) && !(0, $2cfdd8db3ab543a8$export$98f03c5d19621d70).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        if (needCalculate) {
            var wordWidths = $ddbf2ed6ffdaf856$var$calculateWordWidths(props);
            if (wordWidths) {
                var wcw = wordWidths.wordsWithComputedWidth, sw = wordWidths.spaceWidth;
                wordsWithComputedWidth = wcw;
                spaceWidth = sw;
            } else return $ddbf2ed6ffdaf856$var$getWordsWithoutCalculate(props.children);
            return $ddbf2ed6ffdaf856$var$calculateWordsByLines(props, wordsWithComputedWidth, spaceWidth, props.width, props.scaleToFit);
        }
    }
    return $ddbf2ed6ffdaf856$var$getWordsWithoutCalculate(props.children);
};
var $ddbf2ed6ffdaf856$export$5f1af8db9871e1d6 = /*#__PURE__*/ function(_Component) {
    $ddbf2ed6ffdaf856$var$_inherits(Text, _Component);
    var _super = $ddbf2ed6ffdaf856$var$_createSuper(Text);
    function Text() {
        var _this;
        $ddbf2ed6ffdaf856$var$_classCallCheck(this, Text);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {};
        return _this;
    }
    $ddbf2ed6ffdaf856$var$_createClass(Text, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, dx = _this$props.dx, dy = _this$props.dy, textAnchor = _this$props.textAnchor, verticalAnchor = _this$props.verticalAnchor, scaleToFit = _this$props.scaleToFit, angle = _this$props.angle, lineHeight = _this$props.lineHeight, capHeight = _this$props.capHeight, className = _this$props.className, breakAll = _this$props.breakAll, textProps = $ddbf2ed6ffdaf856$var$_objectWithoutProperties(_this$props, [
                    "dx",
                    "dy",
                    "textAnchor",
                    "verticalAnchor",
                    "scaleToFit",
                    "angle",
                    "lineHeight",
                    "capHeight",
                    "className",
                    "breakAll"
                ]);
                var wordsByLines = this.state.wordsByLines;
                if (!(0, $a4d9ec64928c627b$export$402a499e1ea44294)(textProps.x) || !(0, $a4d9ec64928c627b$export$402a499e1ea44294)(textProps.y)) return null;
                var x = textProps.x + ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(dx) ? dx : 0);
                var y = textProps.y + ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(dy) ? dy : 0);
                var startDy;
                switch(verticalAnchor){
                    case "start":
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8607684acc2f3f12$exports)))("calc(".concat(capHeight, ")"));
                        break;
                    case "middle":
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8607684acc2f3f12$exports)))("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
                        break;
                    default:
                        startDy = (0, (/*@__PURE__*/$parcel$interopDefault($8607684acc2f3f12$exports)))("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
                        break;
                }
                var transforms = [];
                if (scaleToFit) {
                    var lineWidth = wordsByLines[0].width;
                    var width = this.props.width;
                    transforms.push("scale(".concat(((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) ? width / lineWidth : 1) / lineWidth, ")"));
                }
                if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
                if (transforms.length) textProps.transform = transforms.join(" ");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("text", $ddbf2ed6ffdaf856$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(textProps, true), {
                    x: x,
                    y: y,
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-text", className),
                    textAnchor: textAnchor
                }), wordsByLines.map(function(line, index) {
                    return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                    (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("tspan", {
                        x: x,
                        dy: index === 0 ? startDy : lineHeight,
                        key: index
                    }, line.words.join(breakAll ? "" : " ")));
                }));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.width !== prevState.prevWidth || nextProps.scaleToFit !== prevState.prevScaleToFit || nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll) {
                    var needCalculate = nextProps.children !== prevState.prevChildren || nextProps.style !== prevState.prevStyle || nextProps.breakAll !== prevState.prevBreakAll;
                    return {
                        prevWidth: nextProps.width,
                        prevScaleToFit: nextProps.scaleToFit,
                        prevChildren: nextProps.children,
                        prevStyle: nextProps.style,
                        wordsByLines: $ddbf2ed6ffdaf856$var$getWordsByLines(nextProps, needCalculate)
                    };
                }
                return null;
            }
        }
    ]);
    return Text;
}((0, $eCoWV.Component));
$ddbf2ed6ffdaf856$export$5f1af8db9871e1d6.defaultProps = {
    x: 0,
    y: 0,
    lineHeight: "1em",
    capHeight: "0.71em",
    // Magic number from d3
    scaleToFit: false,
    textAnchor: "start",
    verticalAnchor: "end" // Maintain compat with existing charts / default SVG behavior
};







var $eCoWV = parcelRequire("eCoWV");
var $d2c2c8fad2e8eab7$exports = {};
"use strict";

$d2c2c8fad2e8eab7$exports = (parcelRequire("dqSKp"));



function $876e5fb324af2e46$export$d36bdfa510afb180(a, b) {
    /* eslint-disable no-restricted-syntax */ for(var key in a){
        if (({}).hasOwnProperty.call(a, key) && (!({}).hasOwnProperty.call(b, key) || a[key] !== b[key])) return false;
    }
    for(var _key in b){
        if (({}).hasOwnProperty.call(b, _key) && !({}).hasOwnProperty.call(a, _key)) return false;
    }
    return true;
}


function $ffd74d03487febd9$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $ffd74d03487febd9$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $ffd74d03487febd9$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $ffd74d03487febd9$var$REACT_BROWSER_EVENT_MAP = {
    click: "onClick",
    mousedown: "onMouseDown",
    mouseup: "onMouseUp",
    mouseover: "onMouseOver",
    mousemove: "onMouseMove",
    mouseout: "onMouseOut",
    mouseenter: "onMouseEnter",
    mouseleave: "onMouseLeave",
    touchcancel: "onTouchCancel",
    touchend: "onTouchEnd",
    touchmove: "onTouchMove",
    touchstart: "onTouchStart"
};
var $ffd74d03487febd9$export$e65e0ff8d3882b46 = [
    "auto",
    "linear",
    "pow",
    "sqrt",
    "log",
    "identity",
    "time",
    "band",
    "point",
    "ordinal",
    "quantile",
    "quantize",
    "utc",
    "sequential",
    "threshold"
];
var $ffd74d03487febd9$export$84dbd3b52ff06578 = [
    "plainline",
    "line",
    "square",
    "rect",
    "circle",
    "cross",
    "diamond",
    "star",
    "triangle",
    "wye",
    "none"
];
var $ffd74d03487febd9$export$59a4d7d024cf1025 = [
    "none"
];
var $ffd74d03487febd9$export$be63e0664592e141 = function getDisplayName(Comp) {
    if (typeof Comp === "string") return Comp;
    if (!Comp) return "";
    return Comp.displayName || Comp.name || "Component";
}; // `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var $ffd74d03487febd9$var$lastChildren = null;
var $ffd74d03487febd9$var$lastResult = null;
var $ffd74d03487febd9$export$45b10814cc054894 = function toArray(children) {
    if (children === $ffd74d03487febd9$var$lastChildren && (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))($ffd74d03487febd9$var$lastResult)) return $ffd74d03487febd9$var$lastResult;
    var result = [];
    (0, $eCoWV.Children).forEach(children, function(child) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(child)) return;
        if ((0, $d2c2c8fad2e8eab7$exports.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else result.push(child);
    });
    $ffd74d03487febd9$var$lastResult = result;
    $ffd74d03487febd9$var$lastChildren = children;
    return result;
};
var $ffd74d03487febd9$export$fdd5e64c0e8495bb = function findAllByType(children, type) {
    var result = [];
    var types = [];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(type)) types = type.map(function(t) {
        return $ffd74d03487febd9$export$be63e0664592e141(t);
    });
    else types = [
        $ffd74d03487febd9$export$be63e0664592e141(type)
    ];
    $ffd74d03487febd9$export$45b10814cc054894(children).forEach(function(child) {
        var childType = (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(child, "type.displayName") || (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(child, "type.name");
        if (types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
};
var $ffd74d03487febd9$export$64c61536a2b72e0f = function findChildByType(children, type) {
    var result = $ffd74d03487febd9$export$fdd5e64c0e8495bb(children, type);
    return result && result[0];
};
var $ffd74d03487febd9$export$d0b46a9571fa5ebf = function withoutType(children, type) {
    var newChildren = [];
    var types;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(type)) types = type.map(function(t) {
        return $ffd74d03487febd9$export$be63e0664592e141(t);
    });
    else types = [
        $ffd74d03487febd9$export$be63e0664592e141(type)
    ];
    $ffd74d03487febd9$export$45b10814cc054894(children).forEach(function(child) {
        var displayName = (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(child, "type.displayName");
        if (displayName && types.indexOf(displayName) !== -1) return;
        newChildren.push(child);
    });
    return newChildren;
};
var $ffd74d03487febd9$export$5301de6bfd3cfa2a = function validateWidthHeight(el) {
    if (!el || !el.props) return false;
    var _el$props = el.props, width = _el$props.width, height = _el$props.height;
    if (!(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(height) || height <= 0) return false;
    return true;
};
var $ffd74d03487febd9$var$SVG_TAGS = [
    "a",
    "altGlyph",
    "altGlyphDef",
    "altGlyphItem",
    "animate",
    "animateColor",
    "animateMotion",
    "animateTransform",
    "circle",
    "clipPath",
    "color-profile",
    "cursor",
    "defs",
    "desc",
    "ellipse",
    "feBlend",
    "feColormatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDistantLight",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "filter",
    "font",
    "font-face",
    "font-face-format",
    "font-face-name",
    "font-face-url",
    "foreignObject",
    "g",
    "glyph",
    "glyphRef",
    "hkern",
    "image",
    "line",
    "lineGradient",
    "marker",
    "mask",
    "metadata",
    "missing-glyph",
    "mpath",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "radialGradient",
    "rect",
    "script",
    "set",
    "stop",
    "style",
    "svg",
    "switch",
    "symbol",
    "text",
    "textPath",
    "title",
    "tref",
    "tspan",
    "use",
    "view",
    "vkern"
];
var $ffd74d03487febd9$var$isSvgElement = function isSvgElement(child) {
    return child && child.type && (0, (/*@__PURE__*/$parcel$interopDefault($58bed27071520d70$exports)))(child.type) && $ffd74d03487febd9$var$SVG_TAGS.indexOf(child.type) >= 0;
};
var $ffd74d03487febd9$export$ef6f3b46dcb37b3f = function filterSvgElements(children) {
    var svgElements = [];
    $ffd74d03487febd9$export$45b10814cc054894(children).forEach(function(entry) {
        if ($ffd74d03487febd9$var$isSvgElement(entry)) svgElements.push(entry);
    });
    return svgElements;
};
var $ffd74d03487febd9$export$acdc716e08572f94 = function isChildrenEqual(nextChildren, prevChildren) {
    if (nextChildren === prevChildren) return true;
    var count = (0, $eCoWV.Children).count(nextChildren);
    if (count !== (0, $eCoWV.Children).count(prevChildren)) return false;
    if (count === 0) return true;
    if (count === 1) // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define
    return $ffd74d03487febd9$export$96bceecf65400492((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(nextChildren) ? nextChildren[0] : nextChildren, (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(prevChildren) ? prevChildren[0] : prevChildren);
    for(var i = 0; i < count; i++){
        var nextChild = nextChildren[i];
        var prevChild = prevChildren[i];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(nextChild) || (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(prevChild)) {
            if (!isChildrenEqual(nextChild, prevChild)) return false;
             // eslint-disable-next-line no-use-before-define,@typescript-eslint/no-use-before-define
        } else if (!$ffd74d03487febd9$export$96bceecf65400492(nextChild, prevChild)) return false;
    }
    return true;
};
var $ffd74d03487febd9$export$96bceecf65400492 = function isSingleChildEqual(nextChild, prevChild) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(nextChild) && (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(prevChild)) return true;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(nextChild) && !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(prevChild)) {
        var _ref = nextChild.props || {}, nextChildren = _ref.children, nextProps = $ffd74d03487febd9$var$_objectWithoutProperties(_ref, [
            "children"
        ]);
        var _ref2 = prevChild.props || {}, prevChildren = _ref2.children, prevProps = $ffd74d03487febd9$var$_objectWithoutProperties(_ref2, [
            "children"
        ]);
        if (nextChildren && prevChildren) // eslint-disable-next-line no-use-before-define
        return (0, $876e5fb324af2e46$export$d36bdfa510afb180)(nextProps, prevProps) && $ffd74d03487febd9$export$acdc716e08572f94(nextChildren, prevChildren);
        if (!nextChildren && !prevChildren) return (0, $876e5fb324af2e46$export$d36bdfa510afb180)(nextProps, prevProps);
        return false;
    }
    return false;
};
var $ffd74d03487febd9$export$a98d6da55570cb82 = function renderByOrder(children, renderMap) {
    var elements = [];
    var record = {};
    $ffd74d03487febd9$export$45b10814cc054894(children).forEach(function(child, index) {
        if ($ffd74d03487febd9$var$isSvgElement(child)) elements.push(child);
        else if (child) {
            var displayName = $ffd74d03487febd9$export$be63e0664592e141(child.type);
            var _ref3 = renderMap[displayName] || {}, handler = _ref3.handler, once = _ref3.once;
            if (handler && (!once || !record[displayName])) {
                var results = handler(child, displayName, index);
                elements.push(results);
                record[displayName] = true;
            }
        }
    });
    return elements;
};
var $ffd74d03487febd9$export$afb3591bc51a0b70 = function getReactEventByType(e) {
    var type = e && e.type;
    if (type && $ffd74d03487febd9$var$REACT_BROWSER_EVENT_MAP[type]) return $ffd74d03487febd9$var$REACT_BROWSER_EVENT_MAP[type];
    return null;
};
var $ffd74d03487febd9$export$857ca101f741953 = function parseChildIndex(child, children) {
    return $ffd74d03487febd9$export$45b10814cc054894(children).indexOf(child);
};






var $421c39c39f87f3ba$exports = {};
var $b906f6996d15bad9$exports = {};

var $40d1f6b67c0ac460$exports = {};



/** Built-in value references. */ var $40d1f6b67c0ac460$var$spreadableSymbol = $a26231c658c479a7$exports ? $a26231c658c479a7$exports.isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $40d1f6b67c0ac460$var$isFlattenable(value) {
    return $0731a2307bf9d7f9$exports(value) || $9f652b1571d8ed7c$exports(value) || !!($40d1f6b67c0ac460$var$spreadableSymbol && value && value[$40d1f6b67c0ac460$var$spreadableSymbol]);
}
$40d1f6b67c0ac460$exports = $40d1f6b67c0ac460$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $b906f6996d15bad9$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = $40d1f6b67c0ac460$exports);
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $b906f6996d15bad9$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else $93da0abe6e6dc744$exports(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
$b906f6996d15bad9$exports = $b906f6996d15bad9$var$baseFlatten;


var $3b01f0c9ef20fb91$exports = {};




var $8b688d9da5f05f13$exports = {};
/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */ function $8b688d9da5f05f13$var$baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while(length--)array[length] = array[length].value;
    return array;
}
$8b688d9da5f05f13$exports = $8b688d9da5f05f13$var$baseSortBy;



var $83e19eb6be40027c$exports = {};
var $4514150b4736540c$exports = {};

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */ function $4514150b4736540c$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = $75f82d2fc8a8760e$exports(value);
        var othIsDefined = other !== undefined, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = $75f82d2fc8a8760e$exports(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) return 1;
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) return -1;
    }
    return 0;
}
$4514150b4736540c$exports = $4514150b4736540c$var$compareAscending;


/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */ function $83e19eb6be40027c$var$compareMultiple(object, other, orders) {
    var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
    while(++index < length){
        var result = $4514150b4736540c$exports(objCriteria[index], othCriteria[index]);
        if (result) {
            if (index >= ordersLength) return result;
            var order = orders[index];
            return result * (order == "desc" ? -1 : 1);
        }
    }
    // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
    // that causes it, under certain circumstances, to provide the same value for
    // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
    // for more details.
    //
    // This also ensures a stable sort in V8 and other engines.
    // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
    return object.index - other.index;
}
$83e19eb6be40027c$exports = $83e19eb6be40027c$var$compareMultiple;




/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */ function $3b01f0c9ef20fb91$var$baseOrderBy(collection, iteratees, orders) {
    if (iteratees.length) iteratees = $eeb990c9a870c3fa$exports(iteratees, function(iteratee) {
        if ($0731a2307bf9d7f9$exports(iteratee)) return function(value) {
            return $6e7ad4bf12182a3e$exports(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        };
        return iteratee;
    });
    else iteratees = [
        $d776a9304296f9f7$exports
    ];
    var index = -1;
    iteratees = $eeb990c9a870c3fa$exports(iteratees, $ee9be00b092f853c$exports($0ef980bf7dd42cec$exports));
    var result = $66a7787fffa5a00a$exports(collection, function(value, key, collection) {
        var criteria = $eeb990c9a870c3fa$exports(iteratees, function(iteratee) {
            return iteratee(value);
        });
        return {
            "criteria": criteria,
            "index": ++index,
            "value": value
        };
    });
    return $8b688d9da5f05f13$exports(result, function(object, other) {
        return $83e19eb6be40027c$exports(object, other, orders);
    });
}
$3b01f0c9ef20fb91$exports = $3b01f0c9ef20fb91$var$baseOrderBy;


var $eb317ef57b2131fd$exports = {};

var $f9fb367de43c51a6$exports = {};
var $3334420a57b9220a$exports = {};
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $3334420a57b9220a$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
$3334420a57b9220a$exports = $3334420a57b9220a$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $f9fb367de43c51a6$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $f9fb367de43c51a6$var$overRest(func, start, transform) {
    start = $f9fb367de43c51a6$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $f9fb367de43c51a6$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return $3334420a57b9220a$exports(func, this, otherArgs);
    };
}
$f9fb367de43c51a6$exports = $f9fb367de43c51a6$var$overRest;


var $b3bb3863f56b0071$exports = {};
var $19a0106588731a42$exports = {};
var $1943d6585c72750a$exports = {};
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $1943d6585c72750a$var$constant(value) {
    return function() {
        return value;
    };
}
$1943d6585c72750a$exports = $1943d6585c72750a$var$constant;




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $19a0106588731a42$var$baseSetToString = !$caab04187fff7f7a$exports ? $d776a9304296f9f7$exports : function(func, string) {
    return $caab04187fff7f7a$exports(func, "toString", {
        "configurable": true,
        "enumerable": false,
        "value": $1943d6585c72750a$exports(string),
        "writable": true
    });
};
$19a0106588731a42$exports = $19a0106588731a42$var$baseSetToString;


var $b09516ab3b8c9731$exports = {};
/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $b09516ab3b8c9731$var$HOT_COUNT = 800, $b09516ab3b8c9731$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b09516ab3b8c9731$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $b09516ab3b8c9731$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $b09516ab3b8c9731$var$nativeNow(), remaining = $b09516ab3b8c9731$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $b09516ab3b8c9731$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
$b09516ab3b8c9731$exports = $b09516ab3b8c9731$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b3bb3863f56b0071$var$setToString = $b09516ab3b8c9731$exports($19a0106588731a42$exports);
$b3bb3863f56b0071$exports = $b3bb3863f56b0071$var$setToString;


/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */ function $eb317ef57b2131fd$var$baseRest(func, start) {
    return $b3bb3863f56b0071$exports($f9fb367de43c51a6$exports(func, start, $d776a9304296f9f7$exports), func + "");
}
$eb317ef57b2131fd$exports = $eb317ef57b2131fd$var$baseRest;


var $b49463b59fa498e5$exports = {};




/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */ function $b49463b59fa498e5$var$isIterateeCall(value, index, object) {
    if (!$6012f8e4c7891baf$exports(object)) return false;
    var type = typeof index;
    if (type == "number" ? $dd7f3dc0af86f403$exports(object) && $edcbf53930595f47$exports(index, object.length) : type == "string" && index in object) return $e8a952114a2113aa$exports(object[index], value);
    return false;
}
$b49463b59fa498e5$exports = $b49463b59fa498e5$var$isIterateeCall;


/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */ var $421c39c39f87f3ba$var$sortBy = $eb317ef57b2131fd$exports(function(collection, iteratees) {
    if (collection == null) return [];
    var length = iteratees.length;
    if (length > 1 && $b49463b59fa498e5$exports(collection, iteratees[0], iteratees[1])) iteratees = [];
    else if (length > 2 && $b49463b59fa498e5$exports(iteratees[0], iteratees[1], iteratees[2])) iteratees = [
        iteratees[0]
    ];
    return $3b01f0c9ef20fb91$exports(collection, $b906f6996d15bad9$exports(iteratees, 1), []);
});
$421c39c39f87f3ba$exports = $421c39c39f87f3ba$var$sortBy;







var $35f6cdeacb5f1b1b$exports = {};

var $79f7b96482faabfe$exports = {};
/**
 * The base implementation of `_.lt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is less than `other`,
 *  else `false`.
 */ function $79f7b96482faabfe$var$baseLt(value, other) {
    return value < other;
}
$79f7b96482faabfe$exports = $79f7b96482faabfe$var$baseLt;



/**
 * Computes the minimum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the minimum value.
 * @example
 *
 * _.min([4, 2, 8, 6]);
 * // => 2
 *
 * _.min([]);
 * // => undefined
 */ function $35f6cdeacb5f1b1b$var$min(array) {
    return array && array.length ? $d8de6711659655db$exports(array, $d776a9304296f9f7$exports, $79f7b96482faabfe$exports) : undefined;
}
$35f6cdeacb5f1b1b$exports = $35f6cdeacb5f1b1b$var$min;


var $2b47cc84fc9a16c2$exports = {};


/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $2b47cc84fc9a16c2$var$flatMap(collection, iteratee) {
    return $b906f6996d15bad9$exports($e3a5da4e5e795541$exports(collection, iteratee), 1);
}
$2b47cc84fc9a16c2$exports = $2b47cc84fc9a16c2$var$flatMap;





var $4f0f631807016390$exports = {};
(function(globalScope) {
    "use strict";
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: "2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286"
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = "[DecimalError] ", invalidArgument = decimalError + "Invalid argument: ", exponentOutOfRange = decimalError + "Exponent out of range: ", mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + "NaN");
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + "NaN");
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + "NaN");
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += "0";
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = "5e" + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf("e") + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == "4999") {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != "9999") break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? "-" + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + "Infinity");
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + "NaN");
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = "", w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + "";
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + "";
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return "0";
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + "Division by zero");
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + "LN10 precision limit exceeded");
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = "";
        for(; k--;)zs += "0";
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? "NaN" : "-Infinity"));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor("0." + c);
                e++;
            } else x = new Ctor(c0 + "." + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + "");
            x = ln(new Ctor(c0 + "." + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ""));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf(".")) > -1) str = str.replace(".", "");
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += "0";
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + "." + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + "." + str.slice(1);
            str = str + (e < 0 ? "e" : "e+") + e;
        } else if (e < 0) {
            str = "0." + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + "." + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + "." + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += ".";
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? "-" + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === "number") {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== "string") throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                "precision",
                "rounding",
                "toExpNeg",
                "toExpPos",
                "LN10"
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== "object") throw Error(decimalError + "Object expected");
        var i, p, v, ps = [
            "precision",
            1,
            MAX_DIGITS,
            "rounding",
            0,
            8,
            "toExpNeg",
            -1 / 0,
            0,
            "toExpPos",
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ": " + v);
        }
        if ((v = obj[p = "LN10"]) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ": " + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal["default"] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == "function" && define.amd) define(function() {
        return Decimal;
    });
    else if (0, $4f0f631807016390$exports) $4f0f631807016390$exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != "undefined" && self && self.self == self ? self : Function("return this")();
        globalScope.Decimal = Decimal;
    }
})($4f0f631807016390$exports);


function $70af710c0ca90e63$var$_toConsumableArray(arr) {
    return $70af710c0ca90e63$var$_arrayWithoutHoles(arr) || $70af710c0ca90e63$var$_iterableToArray(arr) || $70af710c0ca90e63$var$_unsupportedIterableToArray(arr) || $70af710c0ca90e63$var$_nonIterableSpread();
}
function $70af710c0ca90e63$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $70af710c0ca90e63$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $70af710c0ca90e63$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $70af710c0ca90e63$var$_arrayLikeToArray(o, minLen);
}
function $70af710c0ca90e63$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $70af710c0ca90e63$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $70af710c0ca90e63$var$_arrayLikeToArray(arr);
}
function $70af710c0ca90e63$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $70af710c0ca90e63$var$identity = function identity(i) {
    return i;
};
var $70af710c0ca90e63$export$ca73b6d700d0505 = {
    "@@functional/placeholder": true
};
var $70af710c0ca90e63$var$isPlaceHolder = function isPlaceHolder(val) {
    return val === $70af710c0ca90e63$export$ca73b6d700d0505;
};
var $70af710c0ca90e63$var$curry0 = function curry0(fn) {
    return function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && $70af710c0ca90e63$var$isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn.apply(void 0, arguments);
    };
};
var $70af710c0ca90e63$var$curryN = function curryN(n, fn) {
    if (n === 1) return fn;
    return $70af710c0ca90e63$var$curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter(function(arg) {
            return arg !== $70af710c0ca90e63$export$ca73b6d700d0505;
        }).length;
        if (argsLength >= n) return fn.apply(void 0, args);
        return curryN(n - argsLength, $70af710c0ca90e63$var$curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map(function(arg) {
                return $70af710c0ca90e63$var$isPlaceHolder(arg) ? restArgs.shift() : arg;
            });
            return fn.apply(void 0, $70af710c0ca90e63$var$_toConsumableArray(newArgs).concat(restArgs));
        }));
    });
};
var $70af710c0ca90e63$export$c3095a23b368d1f2 = function curry(fn) {
    return $70af710c0ca90e63$var$curryN(fn.length, fn);
};
var $70af710c0ca90e63$export$d02631cccf789723 = function range(begin, end) {
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var $70af710c0ca90e63$export$871de8747c9eaa88 = $70af710c0ca90e63$export$c3095a23b368d1f2(function(fn, arr) {
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map(function(key) {
        return arr[key];
    }).map(fn);
});
var $70af710c0ca90e63$export$f672e0b6f7222cd7 = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return $70af710c0ca90e63$var$identity;
    var fns = args.reverse(); // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce(function(res, fn) {
            return fn(res);
        }, firstFn.apply(void 0, arguments));
    };
};
var $70af710c0ca90e63$export$66c1ae025e96b4bc = function reverse(arr) {
    if (Array.isArray(arr)) return arr.reverse();
     // can be string
    return arr.split("").reverse.join("");
};
var $70af710c0ca90e63$export$fc10aeed3a532e2a = function memoize(fn) {
    var lastArgs = null;
    var lastResult = null;
    return function() {
        for(var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)args[_key4] = arguments[_key4];
        if (lastArgs && args.every(function(val, i) {
            return val === lastArgs[i];
        })) return lastResult;
        lastArgs = args;
        lastResult = fn.apply(void 0, args);
        return lastResult;
    };
};


/**
 * @fileOverview 一些公用的运算方法
 * @author xile611
 * @date 2015-09-17
 */ 

/**
 * 获取数值的位数
 * 其中绝对值属于区间[0.1, 1)， 得到的值为0
 * 绝对值属于区间[0.01, 0.1)，得到的位数为 -1
 * 绝对值属于区间[0.001, 0.01)，得到的位数为 -2
 *
 * @param  {Number} value 数值
 * @return {Integer} 位数
 */ function $b5933ffd8200f5b8$var$getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * 按照固定的步长获取[start, end)这个区间的数据
 * 并且需要处理js计算精度的问题
 *
 * @param  {Decimal} start 起点
 * @param  {Decimal} end   终点，不包含该值
 * @param  {Decimal} step  步长
 * @return {Array}         若干数值
 */ function $b5933ffd8200f5b8$var$rangeStep(start, end, step) {
    var num = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(start);
    var i = 0;
    var result = []; // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}
/**
 * 对数值进行线性插值
 *
 * @param  {Number} a  定义域的极点
 * @param  {Number} b  定义域的极点
 * @param  {Number} t  [0, 1]内的某个值
 * @return {Number}    定义域内的某个值
 */ var $b5933ffd8200f5b8$var$interpolateNumber = (0, $70af710c0ca90e63$export$c3095a23b368d1f2)(function(a, b, t) {
    var newA = +a;
    var newB = +b;
    return newA + t * (newB - newA);
});
/**
 * 线性插值的逆运算
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个范围内时，返回值属于[0, 1]
 */ var $b5933ffd8200f5b8$var$uninterpolateNumber = (0, $70af710c0ca90e63$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return (x - a) / diff;
});
/**
 * 线性插值的逆运算，并且有截断的操作
 *
 * @param  {Number} a 定义域的极点
 * @param  {Number} b 定义域的极点
 * @param  {Number} x 可以认为是插值后的一个输出值
 * @return {Number}   当x在 a ~ b这个区间内时，返回值属于[0, 1]，
 * 当x不在 a ~ b这个区间时，会截断到 a ~ b 这个区间
 */ var $b5933ffd8200f5b8$var$uninterpolateTruncation = (0, $70af710c0ca90e63$export$c3095a23b368d1f2)(function(a, b, x) {
    var diff = b - +a;
    diff = diff || Infinity;
    return Math.max(0, Math.min(1, (x - a) / diff));
});
var $b5933ffd8200f5b8$export$2e2bcd8739ae039 = {
    rangeStep: $b5933ffd8200f5b8$var$rangeStep,
    getDigitCount: $b5933ffd8200f5b8$var$getDigitCount,
    interpolateNumber: $b5933ffd8200f5b8$var$interpolateNumber,
    uninterpolateNumber: $b5933ffd8200f5b8$var$uninterpolateNumber,
    uninterpolateTruncation: $b5933ffd8200f5b8$var$uninterpolateTruncation
};


function $181c1401c1488530$var$_toConsumableArray(arr) {
    return $181c1401c1488530$var$_arrayWithoutHoles(arr) || $181c1401c1488530$var$_iterableToArray(arr) || $181c1401c1488530$var$_unsupportedIterableToArray(arr) || $181c1401c1488530$var$_nonIterableSpread();
}
function $181c1401c1488530$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $181c1401c1488530$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $181c1401c1488530$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $181c1401c1488530$var$_arrayLikeToArray(arr);
}
function $181c1401c1488530$var$_slicedToArray(arr, i) {
    return $181c1401c1488530$var$_arrayWithHoles(arr) || $181c1401c1488530$var$_iterableToArrayLimit(arr, i) || $181c1401c1488530$var$_unsupportedIterableToArray(arr, i) || $181c1401c1488530$var$_nonIterableRest();
}
function $181c1401c1488530$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $181c1401c1488530$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $181c1401c1488530$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $181c1401c1488530$var$_arrayLikeToArray(o, minLen);
}
function $181c1401c1488530$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $181c1401c1488530$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $181c1401c1488530$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
/**
 * Calculate a interval of a minimum value and a maximum value
 *
 * @param  {Number} min       The minimum value
 * @param  {Number} max       The maximum value
 * @return {Array} An interval
 */ function $181c1401c1488530$var$getValidInterval(_ref) {
    var _ref2 = $181c1401c1488530$var$_slicedToArray(_ref, 2), min = _ref2[0], max = _ref2[1];
    var validMin = min, validMax = max; // exchange
    if (min > max) {
        validMin = max;
        validMax = min;
    }
    return [
        validMin,
        validMax
    ];
}
/**
 * Calculate the step which is easy to understand between ticks, like 10, 20, 25
 *
 * @param  {Decimal} roughStep        The rough step calculated by deviding the
 * difference by the tickCount
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Integer} correctionFactor A correction factor
 * @return {Decimal} The step which is easy to understand between two ticks
 */ function $181c1401c1488530$var$getFormatStep(roughStep, allowDecimals, correctionFactor) {
    if (roughStep.lte(0)) return new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0);
    var digitCount = (0, $b5933ffd8200f5b8$export$2e2bcd8739ae039).getDigitCount(roughStep.toNumber()); // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue); // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? formatStep : new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.ceil(formatStep));
}
/**
 * calculate the ticks when the minimum value equals to the maximum value
 *
 * @param  {Number}  value         The minimum valuue which is also the maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}                 ticks
 */ function $181c1401c1488530$var$getTickOfSingleValue(value, tickCount, allowDecimals) {
    var step = 1; // calculate the middle value of ticks
    var middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(10).pow((0, $b5933ffd8200f5b8$export$2e2bcd8739ae039).getDigitCount(value) - 1);
            middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.floor(value));
    } else if (value === 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, $70af710c0ca90e63$export$f672e0b6f7222cd7)((0, $70af710c0ca90e63$export$871de8747c9eaa88)(function(n) {
        return middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(n - middleIndex).mul(step)).toNumber();
    }), (0, $70af710c0ca90e63$export$d02631cccf789723));
    return fn(0, tickCount);
}
/**
 * Calculate the step
 *
 * @param  {Number}  min              The minimum value of an interval
 * @param  {Number}  max              The maximum value of an interval
 * @param  {Integer} tickCount        The count of ticks
 * @param  {Boolean} allowDecimals    Allow the ticks to be decimals or not
 * @param  {Number}  correctionFactor A correction factor
 * @return {Object}  The step, minimum value of ticks, maximum value of ticks
 */ function $181c1401c1488530$var$calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0),
        tickMin: new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0),
        tickMax: new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0)
    };
     // The step which is easy to understand between two ticks
    var step = $181c1401c1488530$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor); // A medial value of ticks
    var middle; // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0);
    else {
        // calculate the middle value
        middle = new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(min).add(max).div(2); // minus modulo value
        middle = middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return $181c1401c1488530$var$calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step: step,
        tickMin: middle.sub(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(belowCount).mul(step)),
        tickMax: middle.add(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(upCount).mul(step))
    };
}
/**
 * Calculate the ticks of an interval, the count of ticks will be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $181c1401c1488530$var$getNiceTickValuesFn(_ref3) {
    var _ref4 = $181c1401c1488530$var$_slicedToArray(_ref3, 2), min = _ref4[0], max = _ref4[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval = $181c1401c1488530$var$getValidInterval([
        min,
        max
    ]), _getValidInterval2 = $181c1401c1488530$var$_slicedToArray(_getValidInterval, 2), cormin = _getValidInterval2[0], cormax = _getValidInterval2[1];
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin
        ].concat($181c1401c1488530$var$_toConsumableArray((0, $70af710c0ca90e63$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return Infinity;
        }))) : [].concat($181c1401c1488530$var$_toConsumableArray((0, $70af710c0ca90e63$export$d02631cccf789723)(0, tickCount - 1).map(function() {
            return -Infinity;
        })), [
            cormax
        ]);
        return min > max ? (0, $70af710c0ca90e63$export$66c1ae025e96b4bc)(_values) : _values;
    }
    if (cormin === cormax) return $181c1401c1488530$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
     // Get the step between two ticks
    var _calculateStep = $181c1401c1488530$var$calculateStep(cormin, cormax, count, allowDecimals), step = _calculateStep.step, tickMin = _calculateStep.tickMin, tickMax = _calculateStep.tickMax;
    var values = (0, $b5933ffd8200f5b8$export$2e2bcd8739ae039).rangeStep(tickMin, tickMax.add(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0.1).mul(step)), step);
    return min > max ? (0, $70af710c0ca90e63$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $181c1401c1488530$var$getTickValuesFn(_ref5) {
    var _ref6 = $181c1401c1488530$var$_slicedToArray(_ref5, 2), min = _ref6[0], max = _ref6[1];
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var _getValidInterval3 = $181c1401c1488530$var$getValidInterval([
        min,
        max
    ]), _getValidInterval4 = $181c1401c1488530$var$_slicedToArray(_getValidInterval3, 2), cormin = _getValidInterval4[0], cormax = _getValidInterval4[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return $181c1401c1488530$var$getTickOfSingleValue(cormin, tickCount, allowDecimals);
    var step = $181c1401c1488530$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var fn = (0, $70af710c0ca90e63$export$f672e0b6f7222cd7)((0, $70af710c0ca90e63$export$871de8747c9eaa88)(function(n) {
        return new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(cormin).add(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(n).mul(step)).toNumber();
    }), (0, $70af710c0ca90e63$export$d02631cccf789723));
    var values = fn(0, count).filter(function(entry) {
        return entry >= cormin && entry <= cormax;
    });
    return min > max ? (0, $70af710c0ca90e63$export$66c1ae025e96b4bc)(values) : values;
}
/**
 * Calculate the ticks of an interval, the count of ticks won't be guraranteed,
 * but the domain will be guaranteed
 *
 * @param  {Number}  min, max      min: The minimum value, max: The maximum value
 * @param  {Integer} tickCount     The count of ticks
 * @param  {Boolean} allowDecimals Allow the ticks to be decimals or not
 * @return {Array}   ticks
 */ function $181c1401c1488530$var$getTickValuesFixedDomainFn(_ref7, tickCount) {
    var _ref8 = $181c1401c1488530$var$_slicedToArray(_ref7, 2), min = _ref8[0], max = _ref8[1];
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var _getValidInterval5 = $181c1401c1488530$var$getValidInterval([
        min,
        max
    ]), _getValidInterval6 = $181c1401c1488530$var$_slicedToArray(_getValidInterval5, 2), cormin = _getValidInterval6[0], cormax = _getValidInterval6[1];
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = $181c1401c1488530$var$getFormatStep(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [].concat($181c1401c1488530$var$_toConsumableArray((0, $b5933ffd8200f5b8$export$2e2bcd8739ae039).rangeStep(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(cormin), new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(cormax).sub(new (0, (/*@__PURE__*/$parcel$interopDefault($4f0f631807016390$exports)))(0.99).mul(step)), step)), [
        cormax
    ]);
    return min > max ? (0, $70af710c0ca90e63$export$66c1ae025e96b4bc)(values) : values;
}
var $181c1401c1488530$export$b84e75ccbfe6a612 = (0, $70af710c0ca90e63$export$fc10aeed3a532e2a)($181c1401c1488530$var$getNiceTickValuesFn);
var $181c1401c1488530$export$4cc7a216492b1f53 = (0, $70af710c0ca90e63$export$fc10aeed3a532e2a)($181c1401c1488530$var$getTickValuesFn);
var $181c1401c1488530$export$e9d28da780436e98 = (0, $70af710c0ca90e63$export$fc10aeed3a532e2a)($181c1401c1488530$var$getTickValuesFixedDomainFn);




var $24ef65aa2cbd5704$exports = {};

$parcel$export($24ef65aa2cbd5704$exports, "scaleBand", function () { return $ebfdc6234f770f61$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scalePoint", function () { return $ebfdc6234f770f61$export$105684a3041cb6f3; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleIdentity", function () { return $cb93b41cba021ba9$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleLinear", function () { return $6488995c00e88b5a$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleLog", function () { return $815d9ddbd2324009$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSymlog", function () { return $b26419c4c20a95da$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleOrdinal", function () { return $dcac5b2f505b0dfe$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleImplicit", function () { return $dcac5b2f505b0dfe$export$e4f898ab14d9d460; });
$parcel$export($24ef65aa2cbd5704$exports, "scalePow", function () { return $620dfea9ea91a5b7$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSqrt", function () { return $620dfea9ea91a5b7$export$eba8049fb5020b81; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleRadial", function () { return $ce3c96a9dc17e1fa$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleQuantile", function () { return $eb8ea8057bab6489$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleQuantize", function () { return $d4f2d1e1f81e2ae0$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleThreshold", function () { return $308e64f06f7457ae$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleTime", function () { return $2013512213518732$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleUtc", function () { return $f50892e0e5876236$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequential", function () { return $c0a336936e98f9cc$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequentialLog", function () { return $c0a336936e98f9cc$export$6843e08bf2ff981f; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequentialPow", function () { return $c0a336936e98f9cc$export$de9f78581b4f2405; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequentialSqrt", function () { return $c0a336936e98f9cc$export$413d935127ed466e; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequentialSymlog", function () { return $c0a336936e98f9cc$export$9d4af4de62c81941; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleSequentialQuantile", function () { return $48fac3024a809b0d$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleDiverging", function () { return $38c3ab0098441a5f$export$2e2bcd8739ae039; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleDivergingLog", function () { return $38c3ab0098441a5f$export$5f0266a9159c47fb; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleDivergingPow", function () { return $38c3ab0098441a5f$export$d6cedcc63bf26e7e; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleDivergingSqrt", function () { return $38c3ab0098441a5f$export$33ddefb5c4ab9e9c; });
$parcel$export($24ef65aa2cbd5704$exports, "scaleDivergingSymlog", function () { return $38c3ab0098441a5f$export$50b3da713cf557c6; });
$parcel$export($24ef65aa2cbd5704$exports, "tickFormat", function () { return $24d56fa9f2f200b8$export$2e2bcd8739ae039; });
function $c6c05e0c9590a7e7$export$2e2bcd8739ae039(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}


function $d92e6e09c56ce871$export$23c7bb9e6558da2a(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function $d92e6e09c56ce871$export$7d6b419e59e83f3d(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}


class $ce32548a2d961f40$export$dcc6fb7d82b5bc7b extends Map {
    constructor(entries, key = $ce32548a2d961f40$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get($ce32548a2d961f40$var$intern_get(this, key));
    }
    has(key) {
        return super.has($ce32548a2d961f40$var$intern_get(this, key));
    }
    set(key, value) {
        return super.set($ce32548a2d961f40$var$intern_set(this, key), value);
    }
    delete(key) {
        return super.delete($ce32548a2d961f40$var$intern_delete(this, key));
    }
}
class $ce32548a2d961f40$export$55278c3294239828 extends Set {
    constructor(values, key = $ce32548a2d961f40$var$keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has($ce32548a2d961f40$var$intern_get(this, value));
    }
    add(value) {
        return super.add($ce32548a2d961f40$var$intern_set(this, value));
    }
    delete(value) {
        return super.delete($ce32548a2d961f40$var$intern_delete(this, value));
    }
}
function $ce32548a2d961f40$var$intern_get({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function $ce32548a2d961f40$var$intern_set({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function $ce32548a2d961f40$var$intern_delete({ _intern: _intern, _key: _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(value);
        _intern.delete(key);
    }
    return value;
}
function $ce32548a2d961f40$var$keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}



const $dcac5b2f505b0dfe$export$e4f898ab14d9d460 = Symbol("implicit");
function $dcac5b2f505b0dfe$export$2e2bcd8739ae039() {
    var index = new (0, $ce32548a2d961f40$export$dcc6fb7d82b5bc7b)(), domain = [], range = [], unknown = $dcac5b2f505b0dfe$export$e4f898ab14d9d460;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== $dcac5b2f505b0dfe$export$e4f898ab14d9d460) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new (0, $ce32548a2d961f40$export$dcc6fb7d82b5bc7b)();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $dcac5b2f505b0dfe$export$2e2bcd8739ae039(domain, range).unknown(unknown);
    };
    (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}


function $ebfdc6234f770f61$export$2e2bcd8739ae039() {
    var scale = (0, $dcac5b2f505b0dfe$export$2e2bcd8739ae039)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, $c6c05e0c9590a7e7$export$2e2bcd8739ae039)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return $ebfdc6234f770f61$export$2e2bcd8739ae039(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(rescale(), arguments);
}
function $ebfdc6234f770f61$var$pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return $ebfdc6234f770f61$var$pointish(copy());
    };
    return scale;
}
function $ebfdc6234f770f61$export$105684a3041cb6f3() {
    return $ebfdc6234f770f61$var$pointish($ebfdc6234f770f61$export$2e2bcd8739ae039.apply(null, arguments).paddingInner(1));
}


var $4d170257369f8996$var$e10 = Math.sqrt(50), $4d170257369f8996$var$e5 = Math.sqrt(10), $4d170257369f8996$var$e2 = Math.sqrt(2);
function $4d170257369f8996$export$2e2bcd8739ae039(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = $4d170257369f8996$export$bc64d00cc98e7e95(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function $4d170257369f8996$export$bc64d00cc98e7e95(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= $4d170257369f8996$var$e10 ? 10 : error >= $4d170257369f8996$var$e5 ? 5 : error >= $4d170257369f8996$var$e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= $4d170257369f8996$var$e10 ? 10 : error >= $4d170257369f8996$var$e5 ? 5 : error >= $4d170257369f8996$var$e2 ? 2 : 1);
}
function $4d170257369f8996$export$81087d9b915d4ede(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= $4d170257369f8996$var$e10) step1 *= 10;
    else if (error >= $4d170257369f8996$var$e5) step1 *= 5;
    else if (error >= $4d170257369f8996$var$e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}


function $f548b959188c763f$export$2e2bcd8739ae039(a, b) {
    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}



function $a034a40bc2bf9a0f$export$2e2bcd8739ae039(f) {
    let delta = f;
    let compare = f;
    if (f.length === 1) {
        delta = (d, x)=>f(d) - x;
        compare = $a034a40bc2bf9a0f$var$ascendingComparator(f);
    }
    function left(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) < 0) lo = mid + 1;
            else hi = mid;
        }
        return lo;
    }
    function right(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        while(lo < hi){
            const mid = lo + hi >>> 1;
            if (compare(a[mid], x) > 0) hi = mid;
            else lo = mid + 1;
        }
        return lo;
    }
    function center(a, x, lo, hi) {
        if (lo == null) lo = 0;
        if (hi == null) hi = a.length;
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left: left,
        center: center,
        right: right
    };
}
function $a034a40bc2bf9a0f$var$ascendingComparator(f) {
    return (d, x)=>(0, $f548b959188c763f$export$2e2bcd8739ae039)(f(d), x);
}


function $0677bf06261e86ad$export$2e2bcd8739ae039(x) {
    return x === null ? NaN : +x;
}
function* $0677bf06261e86ad$export$1f6c9cc012ebacae(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}


const $9c8c58c1752a5b15$var$ascendingBisect = (0, $a034a40bc2bf9a0f$export$2e2bcd8739ae039)((0, $f548b959188c763f$export$2e2bcd8739ae039));
const $9c8c58c1752a5b15$export$4d945ad3ad5751b0 = $9c8c58c1752a5b15$var$ascendingBisect.right;
const $9c8c58c1752a5b15$export$df7d25c84ebd12a5 = $9c8c58c1752a5b15$var$ascendingBisect.left;
const $9c8c58c1752a5b15$export$c1cb828b1117c77b = (0, $a034a40bc2bf9a0f$export$2e2bcd8739ae039)((0, $0677bf06261e86ad$export$2e2bcd8739ae039)).center;
var $9c8c58c1752a5b15$export$2e2bcd8739ae039 = $9c8c58c1752a5b15$export$4d945ad3ad5751b0;


function $7af985638884058e$export$2e2bcd8739ae039(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function $7af985638884058e$export$8b58be045bf06082(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}


function $c0d806ff4d68c665$export$892596cec99bc70e() {}
var $c0d806ff4d68c665$export$4adafc6ed0600c10 = 0.7;
var $c0d806ff4d68c665$export$9eace2cc0d12c98d = 1 / $c0d806ff4d68c665$export$4adafc6ed0600c10;
var $c0d806ff4d68c665$var$reI = "\\s*([+-]?\\d+)\\s*", $c0d806ff4d68c665$var$reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", $c0d806ff4d68c665$var$reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $c0d806ff4d68c665$var$reHex = /^#([0-9a-f]{3,8})$/, $c0d806ff4d68c665$var$reRgbInteger = new RegExp("^rgb\\(" + [
    $c0d806ff4d68c665$var$reI,
    $c0d806ff4d68c665$var$reI,
    $c0d806ff4d68c665$var$reI
] + "\\)$"), $c0d806ff4d68c665$var$reRgbPercent = new RegExp("^rgb\\(" + [
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP
] + "\\)$"), $c0d806ff4d68c665$var$reRgbaInteger = new RegExp("^rgba\\(" + [
    $c0d806ff4d68c665$var$reI,
    $c0d806ff4d68c665$var$reI,
    $c0d806ff4d68c665$var$reI,
    $c0d806ff4d68c665$var$reN
] + "\\)$"), $c0d806ff4d68c665$var$reRgbaPercent = new RegExp("^rgba\\(" + [
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reN
] + "\\)$"), $c0d806ff4d68c665$var$reHslPercent = new RegExp("^hsl\\(" + [
    $c0d806ff4d68c665$var$reN,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP
] + "\\)$"), $c0d806ff4d68c665$var$reHslaPercent = new RegExp("^hsla\\(" + [
    $c0d806ff4d68c665$var$reN,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reP,
    $c0d806ff4d68c665$var$reN
] + "\\)$");
var $c0d806ff4d68c665$var$named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, $7af985638884058e$export$2e2bcd8739ae039)($c0d806ff4d68c665$export$892596cec99bc70e, $c0d806ff4d68c665$export$2e2bcd8739ae039, {
    copy: function(channels) {
        return Object.assign(new this.constructor, this, channels);
    },
    displayable: function() {
        return this.rgb().displayable();
    },
    hex: $c0d806ff4d68c665$var$color_formatHex,
    formatHex: $c0d806ff4d68c665$var$color_formatHex,
    formatHsl: $c0d806ff4d68c665$var$color_formatHsl,
    formatRgb: $c0d806ff4d68c665$var$color_formatRgb,
    toString: $c0d806ff4d68c665$var$color_formatRgb
});
function $c0d806ff4d68c665$var$color_formatHex() {
    return this.rgb().formatHex();
}
function $c0d806ff4d68c665$var$color_formatHsl() {
    return $c0d806ff4d68c665$export$8133dc3fa904d6d1(this).formatHsl();
}
function $c0d806ff4d68c665$var$color_formatRgb() {
    return this.rgb().formatRgb();
}
function $c0d806ff4d68c665$export$2e2bcd8739ae039(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = $c0d806ff4d68c665$var$reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? $c0d806ff4d68c665$var$rgbn(m) // #ff0000
     : l === 3 ? new $c0d806ff4d68c665$export$5e05a94393ac29e3(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? $c0d806ff4d68c665$var$rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? $c0d806ff4d68c665$var$rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = $c0d806ff4d68c665$var$reRgbInteger.exec(format)) ? new $c0d806ff4d68c665$export$5e05a94393ac29e3(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = $c0d806ff4d68c665$var$reRgbPercent.exec(format)) ? new $c0d806ff4d68c665$export$5e05a94393ac29e3(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = $c0d806ff4d68c665$var$reRgbaInteger.exec(format)) ? $c0d806ff4d68c665$var$rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = $c0d806ff4d68c665$var$reRgbaPercent.exec(format)) ? $c0d806ff4d68c665$var$rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = $c0d806ff4d68c665$var$reHslPercent.exec(format)) ? $c0d806ff4d68c665$var$hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = $c0d806ff4d68c665$var$reHslaPercent.exec(format)) ? $c0d806ff4d68c665$var$hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : $c0d806ff4d68c665$var$named.hasOwnProperty(format) ? $c0d806ff4d68c665$var$rgbn($c0d806ff4d68c665$var$named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new $c0d806ff4d68c665$export$5e05a94393ac29e3(NaN, NaN, NaN, 0) : null;
}
function $c0d806ff4d68c665$var$rgbn(n) {
    return new $c0d806ff4d68c665$export$5e05a94393ac29e3(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function $c0d806ff4d68c665$var$rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new $c0d806ff4d68c665$export$5e05a94393ac29e3(r, g, b, a);
}
function $c0d806ff4d68c665$export$42da0a331c2802f5(o) {
    if (!(o instanceof $c0d806ff4d68c665$export$892596cec99bc70e)) o = $c0d806ff4d68c665$export$2e2bcd8739ae039(o);
    if (!o) return new $c0d806ff4d68c665$export$5e05a94393ac29e3;
    o = o.rgb();
    return new $c0d806ff4d68c665$export$5e05a94393ac29e3(o.r, o.g, o.b, o.opacity);
}
function $c0d806ff4d68c665$export$8972dc0e6ad9238f(r, g, b, opacity) {
    return arguments.length === 1 ? $c0d806ff4d68c665$export$42da0a331c2802f5(r) : new $c0d806ff4d68c665$export$5e05a94393ac29e3(r, g, b, opacity == null ? 1 : opacity);
}
function $c0d806ff4d68c665$export$5e05a94393ac29e3(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, $7af985638884058e$export$2e2bcd8739ae039)($c0d806ff4d68c665$export$5e05a94393ac29e3, $c0d806ff4d68c665$export$8972dc0e6ad9238f, (0, $7af985638884058e$export$8b58be045bf06082)($c0d806ff4d68c665$export$892596cec99bc70e, {
    brighter: function(k) {
        k = k == null ? $c0d806ff4d68c665$export$9eace2cc0d12c98d : Math.pow($c0d806ff4d68c665$export$9eace2cc0d12c98d, k);
        return new $c0d806ff4d68c665$export$5e05a94393ac29e3(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? $c0d806ff4d68c665$export$4adafc6ed0600c10 : Math.pow($c0d806ff4d68c665$export$4adafc6ed0600c10, k);
        return new $c0d806ff4d68c665$export$5e05a94393ac29e3(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb: function() {
        return this;
    },
    displayable: function() {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: $c0d806ff4d68c665$var$rgb_formatHex,
    formatHex: $c0d806ff4d68c665$var$rgb_formatHex,
    formatRgb: $c0d806ff4d68c665$var$rgb_formatRgb,
    toString: $c0d806ff4d68c665$var$rgb_formatRgb
}));
function $c0d806ff4d68c665$var$rgb_formatHex() {
    return "#" + $c0d806ff4d68c665$var$hex(this.r) + $c0d806ff4d68c665$var$hex(this.g) + $c0d806ff4d68c665$var$hex(this.b);
}
function $c0d806ff4d68c665$var$rgb_formatRgb() {
    var a = this.opacity;
    a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
    return (a === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (a === 1 ? ")" : ", " + a + ")");
}
function $c0d806ff4d68c665$var$hex(value) {
    value = Math.max(0, Math.min(255, Math.round(value) || 0));
    return (value < 16 ? "0" : "") + value.toString(16);
}
function $c0d806ff4d68c665$var$hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new $c0d806ff4d68c665$var$Hsl(h, s, l, a);
}
function $c0d806ff4d68c665$export$8133dc3fa904d6d1(o) {
    if (o instanceof $c0d806ff4d68c665$var$Hsl) return new $c0d806ff4d68c665$var$Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof $c0d806ff4d68c665$export$892596cec99bc70e)) o = $c0d806ff4d68c665$export$2e2bcd8739ae039(o);
    if (!o) return new $c0d806ff4d68c665$var$Hsl;
    if (o instanceof $c0d806ff4d68c665$var$Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new $c0d806ff4d68c665$var$Hsl(h, s, l, o.opacity);
}
function $c0d806ff4d68c665$export$8f4a7c0bb78e6ea8(h, s, l, opacity) {
    return arguments.length === 1 ? $c0d806ff4d68c665$export$8133dc3fa904d6d1(h) : new $c0d806ff4d68c665$var$Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function $c0d806ff4d68c665$var$Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, $7af985638884058e$export$2e2bcd8739ae039)($c0d806ff4d68c665$var$Hsl, $c0d806ff4d68c665$export$8f4a7c0bb78e6ea8, (0, $7af985638884058e$export$8b58be045bf06082)($c0d806ff4d68c665$export$892596cec99bc70e, {
    brighter: function(k) {
        k = k == null ? $c0d806ff4d68c665$export$9eace2cc0d12c98d : Math.pow($c0d806ff4d68c665$export$9eace2cc0d12c98d, k);
        return new $c0d806ff4d68c665$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker: function(k) {
        k = k == null ? $c0d806ff4d68c665$export$4adafc6ed0600c10 : Math.pow($c0d806ff4d68c665$export$4adafc6ed0600c10, k);
        return new $c0d806ff4d68c665$var$Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb: function() {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new $c0d806ff4d68c665$export$5e05a94393ac29e3($c0d806ff4d68c665$var$hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), $c0d806ff4d68c665$var$hsl2rgb(h, m1, m2), $c0d806ff4d68c665$var$hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    displayable: function() {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl: function() {
        var a = this.opacity;
        a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
        return (a === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (a === 1 ? ")" : ", " + a + ")");
    }
}));
/* From FvD 13.37, CSS Color Module Level 3 */ function $c0d806ff4d68c665$var$hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}



function $bc148b3a602359b6$export$4e41033bfeec1a4c(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function $bc148b3a602359b6$export$2e2bcd8739ae039(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return $bc148b3a602359b6$export$4e41033bfeec1a4c((t - i / n) * n, v0, v1, v2, v3);
    };
}



function $f99ed21cff16723c$export$2e2bcd8739ae039(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, $bc148b3a602359b6$export$4e41033bfeec1a4c)((t - i / n) * n, v0, v1, v2, v3);
    };
}


var $a68a6b794e202132$export$2e2bcd8739ae039 = (x)=>()=>x;


function $c3e28213ea9d35a8$var$linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function $c3e28213ea9d35a8$var$exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function $c3e28213ea9d35a8$export$97d7b0c7ddb78dcf(a, b) {
    var d = b - a;
    return d ? $c3e28213ea9d35a8$var$linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, $a68a6b794e202132$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}
function $c3e28213ea9d35a8$export$a7ebe8cc6aaf8d37(y) {
    return (y = +y) === 1 ? $c3e28213ea9d35a8$export$2e2bcd8739ae039 : function(a, b) {
        return b - a ? $c3e28213ea9d35a8$var$exponential(a, b, y) : (0, $a68a6b794e202132$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
    };
}
function $c3e28213ea9d35a8$export$2e2bcd8739ae039(a, b) {
    var d = b - a;
    return d ? $c3e28213ea9d35a8$var$linear(a, d) : (0, $a68a6b794e202132$export$2e2bcd8739ae039)(isNaN(a) ? b : a);
}


var $35feba46353fca18$export$2e2bcd8739ae039 = function rgbGamma(y) {
    var color = (0, $c3e28213ea9d35a8$export$a7ebe8cc6aaf8d37)(y);
    function rgb(start, end) {
        var r = color((start = (0, $c0d806ff4d68c665$export$8972dc0e6ad9238f)(start)).r, (end = (0, $c0d806ff4d68c665$export$8972dc0e6ad9238f)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, $c3e28213ea9d35a8$export$2e2bcd8739ae039)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function $35feba46353fca18$var$rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, $c0d806ff4d68c665$export$8972dc0e6ad9238f)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var $35feba46353fca18$export$2c0e28f2e2852d3f = $35feba46353fca18$var$rgbSpline((0, $bc148b3a602359b6$export$2e2bcd8739ae039));
var $35feba46353fca18$export$53d5214f625ccd4c = $35feba46353fca18$var$rgbSpline((0, $f99ed21cff16723c$export$2e2bcd8739ae039));



function $10dadefa1f9e7c3f$export$2e2bcd8739ae039(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function $10dadefa1f9e7c3f$export$5cd576d1827d40c8(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}


function $070f3d3b9dee25de$export$2e2bcd8739ae039(a, b) {
    return ((0, $10dadefa1f9e7c3f$export$5cd576d1827d40c8)(b) ? (0, $10dadefa1f9e7c3f$export$2e2bcd8739ae039) : $070f3d3b9dee25de$export$15d09067c6a5ee49)(a, b);
}
function $070f3d3b9dee25de$export$15d09067c6a5ee49(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, $f822e5bb151a52dc$export$2e2bcd8739ae039)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}


function $1c0431613fa7d624$export$2e2bcd8739ae039(a, b) {
    var d = new Date;
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}


function $36fee5fbeff192db$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}



function $81d414c4c31de7f0$export$2e2bcd8739ae039(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, $f822e5bb151a52dc$export$2e2bcd8739ae039)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}



var $8383f9fe0d599b16$var$reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, $8383f9fe0d599b16$var$reB = new RegExp($8383f9fe0d599b16$var$reA.source, "g");
function $8383f9fe0d599b16$var$zero(b) {
    return function() {
        return b;
    };
}
function $8383f9fe0d599b16$var$one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function $8383f9fe0d599b16$export$2e2bcd8739ae039(a, b) {
    var bi = $8383f9fe0d599b16$var$reA.lastIndex = $8383f9fe0d599b16$var$reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = $8383f9fe0d599b16$var$reA.exec(a)) && (bm = $8383f9fe0d599b16$var$reB.exec(b))){
        if ((bs = bm.index) > bi) {
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            s[++i] = null;
            q.push({
                i: i,
                x: (0, $36fee5fbeff192db$export$2e2bcd8739ae039)(am, bm)
            });
        }
        bi = $8383f9fe0d599b16$var$reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? $8383f9fe0d599b16$var$one(q[0].x) : $8383f9fe0d599b16$var$zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}




function $f822e5bb151a52dc$export$2e2bcd8739ae039(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, $a68a6b794e202132$export$2e2bcd8739ae039)(b) : (t === "number" ? (0, $36fee5fbeff192db$export$2e2bcd8739ae039) : t === "string" ? (c = (0, $c0d806ff4d68c665$export$2e2bcd8739ae039)(b)) ? (b = c, $35feba46353fca18$export$2e2bcd8739ae039) : (0, $8383f9fe0d599b16$export$2e2bcd8739ae039) : b instanceof (0, $c0d806ff4d68c665$export$2e2bcd8739ae039) ? (0, $35feba46353fca18$export$2e2bcd8739ae039) : b instanceof Date ? (0, $1c0431613fa7d624$export$2e2bcd8739ae039) : (0, $10dadefa1f9e7c3f$export$5cd576d1827d40c8)(b) ? (0, $10dadefa1f9e7c3f$export$2e2bcd8739ae039) : Array.isArray(b) ? (0, $070f3d3b9dee25de$export$15d09067c6a5ee49) : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? (0, $81d414c4c31de7f0$export$2e2bcd8739ae039) : (0, $36fee5fbeff192db$export$2e2bcd8739ae039))(a, b);
}

function $9eff91e007b3638d$export$2e2bcd8739ae039(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}


function $aea797e1b7c8b15b$export$2e2bcd8739ae039(x) {
    return function() {
        return x;
    };
}


function $ac13a6cdddb71d5d$export$2e2bcd8739ae039(x) {
    return +x;
}


var $de84e4e7fff24235$var$unit = [
    0,
    1
];
function $de84e4e7fff24235$export$f0954fd7d5368655(x) {
    return x;
}
function $de84e4e7fff24235$var$normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, $aea797e1b7c8b15b$export$2e2bcd8739ae039)(isNaN(b) ? NaN : 0.5);
}
function $de84e4e7fff24235$var$clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function $de84e4e7fff24235$var$bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = $de84e4e7fff24235$var$normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = $de84e4e7fff24235$var$normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function $de84e4e7fff24235$var$polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = $de84e4e7fff24235$var$normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, $9c8c58c1752a5b15$export$2e2bcd8739ae039)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function $de84e4e7fff24235$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function $de84e4e7fff24235$export$6b468dcfb64c653c() {
    var domain = $de84e4e7fff24235$var$unit, range = $de84e4e7fff24235$var$unit, interpolate = (0, $f822e5bb151a52dc$export$2e2bcd8739ae039), transform, untransform, unknown, clamp = $de84e4e7fff24235$export$f0954fd7d5368655, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== $de84e4e7fff24235$export$f0954fd7d5368655) clamp = $de84e4e7fff24235$var$clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? $de84e4e7fff24235$var$polymap : $de84e4e7fff24235$var$bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), (0, $36fee5fbeff192db$export$2e2bcd8739ae039))))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $ac13a6cdddb71d5d$export$2e2bcd8739ae039)), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = (0, $9eff91e007b3638d$export$2e2bcd8739ae039), rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : $de84e4e7fff24235$export$f0954fd7d5368655, rescale()) : clamp !== $de84e4e7fff24235$export$f0954fd7d5368655;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function $de84e4e7fff24235$export$2e2bcd8739ae039() {
    return $de84e4e7fff24235$export$6b468dcfb64c653c()($de84e4e7fff24235$export$f0954fd7d5368655, $de84e4e7fff24235$export$f0954fd7d5368655);
}




function $c0e834640ce2145b$export$2e2bcd8739ae039(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
function $c0e834640ce2145b$export$8f8e23dd27dc19f5(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}


function $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039(x) {
    return x = (0, $c0e834640ce2145b$export$8f8e23dd27dc19f5)(Math.abs(x)), x ? x[1] : NaN;
}


function $585555938fae0e80$export$2e2bcd8739ae039(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}


function $f0619e8bae9cd5ae$export$2e2bcd8739ae039(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}


// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var $b857b859422d31be$var$re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function $b857b859422d31be$export$2e2bcd8739ae039(specifier) {
    if (!(match = $b857b859422d31be$var$re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new $b857b859422d31be$export$963aac351db36ed4({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
$b857b859422d31be$export$2e2bcd8739ae039.prototype = $b857b859422d31be$export$963aac351db36ed4.prototype; // instanceof
function $b857b859422d31be$export$963aac351db36ed4(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
$b857b859422d31be$export$963aac351db36ed4.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};


// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function $d0d52f85f94cb4a1$export$2e2bcd8739ae039(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}




var $6439e89982ada8a1$export$6863724d9a42263;
function $6439e89982ada8a1$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c0e834640ce2145b$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - ($6439e89982ada8a1$export$6863724d9a42263 = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, $c0e834640ce2145b$export$8f8e23dd27dc19f5)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}



function $561793650b55a9bd$export$2e2bcd8739ae039(x, p) {
    var d = (0, $c0e834640ce2145b$export$8f8e23dd27dc19f5)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}


var $32a66cd53f52d8f9$export$2e2bcd8739ae039 = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": (0, $c0e834640ce2145b$export$2e2bcd8739ae039),
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, $561793650b55a9bd$export$2e2bcd8739ae039)(x * 100, p),
    "r": (0, $561793650b55a9bd$export$2e2bcd8739ae039),
    "s": (0, $6439e89982ada8a1$export$2e2bcd8739ae039),
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};



function $1b3ec21ae1ca487d$export$2e2bcd8739ae039(x) {
    return x;
}


var $210c024f707aff41$var$map = Array.prototype.map, $210c024f707aff41$var$prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function $210c024f707aff41$export$2e2bcd8739ae039(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? (0, $1b3ec21ae1ca487d$export$2e2bcd8739ae039) : (0, $585555938fae0e80$export$2e2bcd8739ae039)($210c024f707aff41$var$map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? (0, $1b3ec21ae1ca487d$export$2e2bcd8739ae039) : (0, $f0619e8bae9cd5ae$export$2e2bcd8739ae039)($210c024f707aff41$var$map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "−" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, $b857b859422d31be$export$2e2bcd8739ae039)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!(0, $32a66cd53f52d8f9$export$2e2bcd8739ae039)[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = (0, $32a66cd53f52d8f9$export$2e2bcd8739ae039)[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, $d0d52f85f94cb4a1$export$2e2bcd8739ae039)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? $210c024f707aff41$var$prefixes[8 + (0, $6439e89982ada8a1$export$6863724d9a42263) / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, $b857b859422d31be$export$2e2bcd8739ae039)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = $210c024f707aff41$var$prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}


var $b545efa15fb887ba$var$locale;
var $b545efa15fb887ba$export$d9468344d3651243;
var $b545efa15fb887ba$export$8d85692a469dde6f;
$b545efa15fb887ba$export$2e2bcd8739ae039({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function $b545efa15fb887ba$export$2e2bcd8739ae039(definition) {
    $b545efa15fb887ba$var$locale = (0, $210c024f707aff41$export$2e2bcd8739ae039)(definition);
    $b545efa15fb887ba$export$d9468344d3651243 = $b545efa15fb887ba$var$locale.format;
    $b545efa15fb887ba$export$8d85692a469dde6f = $b545efa15fb887ba$var$locale.formatPrefix;
    return $b545efa15fb887ba$var$locale;
}


function $39c6b92ef27fbbe2$export$2e2bcd8739ae039(step) {
    return Math.max(0, -(0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $e8678dd7485a293f$export$2e2bcd8739ae039(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(value) / 3))) * 3 - (0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(Math.abs(step)));
}


function $0c76022fb1749716$export$2e2bcd8739ae039(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(max) - (0, $1c2ee0c8ecb85fc1$export$2e2bcd8739ae039)(step)) + 1;
}


function $24d56fa9f2f200b8$export$2e2bcd8739ae039(start, stop, count, specifier) {
    var step = (0, $4d170257369f8996$export$81087d9b915d4ede)(start, stop, count), precision;
    specifier = (0, $b857b859422d31be$export$2e2bcd8739ae039)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, $e8678dd7485a293f$export$2e2bcd8739ae039)(step, value))) specifier.precision = precision;
            return (0, $b545efa15fb887ba$export$8d85692a469dde6f)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, $0c76022fb1749716$export$2e2bcd8739ae039)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, $39c6b92ef27fbbe2$export$2e2bcd8739ae039)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, $b545efa15fb887ba$export$d9468344d3651243)(specifier);
}


function $6488995c00e88b5a$export$16a5d4b4a61a274d(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, $4d170257369f8996$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, $24d56fa9f2f200b8$export$2e2bcd8739ae039)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, $4d170257369f8996$export$bc64d00cc98e7e95)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function $6488995c00e88b5a$export$2e2bcd8739ae039() {
    var scale = (0, $de84e4e7fff24235$export$2e2bcd8739ae039)();
    scale.copy = function() {
        return (0, $de84e4e7fff24235$export$784d13d8ee351f07)(scale, $6488995c00e88b5a$export$2e2bcd8739ae039());
    };
    (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
    return $6488995c00e88b5a$export$16a5d4b4a61a274d(scale);
}



function $cb93b41cba021ba9$export$2e2bcd8739ae039(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, (0, $ac13a6cdddb71d5d$export$2e2bcd8739ae039)), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $cb93b41cba021ba9$export$2e2bcd8739ae039(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, (0, $ac13a6cdddb71d5d$export$2e2bcd8739ae039)) : [
        0,
        1
    ];
    return (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)(scale);
}





function $e0fbbf8192ac8d86$export$2e2bcd8739ae039(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}




function $815d9ddbd2324009$var$transformLog(x) {
    return Math.log(x);
}
function $815d9ddbd2324009$var$transformExp(x) {
    return Math.exp(x);
}
function $815d9ddbd2324009$var$transformLogn(x) {
    return -Math.log(-x);
}
function $815d9ddbd2324009$var$transformExpn(x) {
    return -Math.exp(-x);
}
function $815d9ddbd2324009$var$pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function $815d9ddbd2324009$var$powp(base) {
    return base === 10 ? $815d9ddbd2324009$var$pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function $815d9ddbd2324009$var$logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function $815d9ddbd2324009$var$reflect(f) {
    return (x, k)=>-f(-x, k);
}
function $815d9ddbd2324009$export$860836db074028f0(transform) {
    const scale = transform($815d9ddbd2324009$var$transformLog, $815d9ddbd2324009$var$transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = $815d9ddbd2324009$var$logp(base), pows = $815d9ddbd2324009$var$powp(base);
        if (domain()[0] < 0) {
            logs = $815d9ddbd2324009$var$reflect(logs), pows = $815d9ddbd2324009$var$reflect(pows);
            transform($815d9ddbd2324009$var$transformLogn, $815d9ddbd2324009$var$transformExpn);
        } else transform($815d9ddbd2324009$var$transformLog, $815d9ddbd2324009$var$transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, $4d170257369f8996$export$2e2bcd8739ae039)(u, v, n);
        } else z = (0, $4d170257369f8996$export$2e2bcd8739ae039)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, $b857b859422d31be$export$2e2bcd8739ae039)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, $b545efa15fb887ba$export$d9468344d3651243)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, $e0fbbf8192ac8d86$export$2e2bcd8739ae039)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function $815d9ddbd2324009$export$2e2bcd8739ae039() {
    const scale = $815d9ddbd2324009$export$860836db074028f0((0, $de84e4e7fff24235$export$6b468dcfb64c653c)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, $de84e4e7fff24235$export$784d13d8ee351f07)(scale, $815d9ddbd2324009$export$2e2bcd8739ae039()).base(scale.base());
    (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}





function $b26419c4c20a95da$var$transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function $b26419c4c20a95da$var$transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function $b26419c4c20a95da$export$4602684e614eba38(transform) {
    var c = 1, scale = transform($b26419c4c20a95da$var$transformSymlog(c), $b26419c4c20a95da$var$transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform($b26419c4c20a95da$var$transformSymlog(c = +_), $b26419c4c20a95da$var$transformSymexp(c)) : c;
    };
    return (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)(scale);
}
function $b26419c4c20a95da$export$2e2bcd8739ae039() {
    var scale = $b26419c4c20a95da$export$4602684e614eba38((0, $de84e4e7fff24235$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $de84e4e7fff24235$export$784d13d8ee351f07)(scale, $b26419c4c20a95da$export$2e2bcd8739ae039()).constant(scale.constant());
    };
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
}






function $620dfea9ea91a5b7$var$transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function $620dfea9ea91a5b7$var$transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function $620dfea9ea91a5b7$var$transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function $620dfea9ea91a5b7$export$34695211ec403a46(transform) {
    var scale = transform((0, $de84e4e7fff24235$export$f0954fd7d5368655), (0, $de84e4e7fff24235$export$f0954fd7d5368655)), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform((0, $de84e4e7fff24235$export$f0954fd7d5368655), (0, $de84e4e7fff24235$export$f0954fd7d5368655)) : exponent === 0.5 ? transform($620dfea9ea91a5b7$var$transformSqrt, $620dfea9ea91a5b7$var$transformSquare) : transform($620dfea9ea91a5b7$var$transformPow(exponent), $620dfea9ea91a5b7$var$transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)(scale);
}
function $620dfea9ea91a5b7$export$2e2bcd8739ae039() {
    var scale = $620dfea9ea91a5b7$export$34695211ec403a46((0, $de84e4e7fff24235$export$6b468dcfb64c653c)());
    scale.copy = function() {
        return (0, $de84e4e7fff24235$export$784d13d8ee351f07)(scale, $620dfea9ea91a5b7$export$2e2bcd8739ae039()).exponent(scale.exponent());
    };
    (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
    return scale;
}
function $620dfea9ea91a5b7$export$eba8049fb5020b81() {
    return $620dfea9ea91a5b7$export$2e2bcd8739ae039.apply(null, arguments).exponent(0.5);
}






function $ce3c96a9dc17e1fa$var$square(x) {
    return Math.sign(x) * x * x;
}
function $ce3c96a9dc17e1fa$var$unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function $ce3c96a9dc17e1fa$export$2e2bcd8739ae039() {
    var squared = (0, $de84e4e7fff24235$export$2e2bcd8739ae039)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = $ce3c96a9dc17e1fa$var$unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert($ce3c96a9dc17e1fa$var$square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, (0, $ac13a6cdddb71d5d$export$2e2bcd8739ae039))).map($ce3c96a9dc17e1fa$var$square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $ce3c96a9dc17e1fa$export$2e2bcd8739ae039(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
    return (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)(scale);
}


function $de30806c79eaa6a6$export$2e2bcd8739ae039(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}


function $9260c8c7cf8706ad$export$2e2bcd8739ae039(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}



function $57fce2f50a512a74$export$2e2bcd8739ae039(array, k, left = 0, right = array.length - 1, compare = (0, $f548b959188c763f$export$2e2bcd8739ae039)) {
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            $57fce2f50a512a74$export$2e2bcd8739ae039(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        $57fce2f50a512a74$var$swap(array, left, k);
        if (compare(array[right], t) > 0) $57fce2f50a512a74$var$swap(array, left, right);
        while(i < j){
            $57fce2f50a512a74$var$swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) $57fce2f50a512a74$var$swap(array, left, j);
        else ++j, $57fce2f50a512a74$var$swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function $57fce2f50a512a74$var$swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}



function $1ec473348aab6a4a$export$2e2bcd8739ae039(values, p, valueof) {
    values = Float64Array.from((0, $0677bf06261e86ad$export$1f6c9cc012ebacae)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, $9260c8c7cf8706ad$export$2e2bcd8739ae039)(values);
    if (p >= 1) return (0, $de30806c79eaa6a6$export$2e2bcd8739ae039)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, $de30806c79eaa6a6$export$2e2bcd8739ae039)((0, $57fce2f50a512a74$export$2e2bcd8739ae039)(values, i0).subarray(0, i0 + 1)), value1 = (0, $9260c8c7cf8706ad$export$2e2bcd8739ae039)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function $1ec473348aab6a4a$export$f924a6cad778dddb(values, p, valueof = (0, $0677bf06261e86ad$export$2e2bcd8739ae039)) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}



function $eb8ea8057bab6489$export$2e2bcd8739ae039() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, $1ec473348aab6a4a$export$f924a6cad778dddb)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, $9c8c58c1752a5b15$export$2e2bcd8739ae039)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $f548b959188c763f$export$2e2bcd8739ae039));
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return $eb8ea8057bab6489$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
}





function $d4f2d1e1f81e2ae0$export$2e2bcd8739ae039() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, $9c8c58c1752a5b15$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return $d4f2d1e1f81e2ae0$export$2e2bcd8739ae039().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply((0, $6488995c00e88b5a$export$16a5d4b4a61a274d)(scale), arguments);
}




function $308e64f06f7457ae$export$2e2bcd8739ae039() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, $9c8c58c1752a5b15$export$2e2bcd8739ae039)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return $308e64f06f7457ae$export$2e2bcd8739ae039().domain(domain).range(range).unknown(unknown);
    };
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply(scale, arguments);
}


var $761326a64c209a21$var$t0 = new Date, $761326a64c209a21$var$t1 = new Date;
function $761326a64c209a21$export$2e2bcd8739ae039(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return $761326a64c209a21$export$2e2bcd8739ae039(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            $761326a64c209a21$var$t0.setTime(+start), $761326a64c209a21$var$t1.setTime(+end);
            floori($761326a64c209a21$var$t0), floori($761326a64c209a21$var$t1);
            return Math.floor(count($761326a64c209a21$var$t0, $761326a64c209a21$var$t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}


const $a5f3a326648f6a6c$export$79ef0e34099623dc = 1000;
const $a5f3a326648f6a6c$export$683905d551c33fa9 = $a5f3a326648f6a6c$export$79ef0e34099623dc * 60;
const $a5f3a326648f6a6c$export$4157bf0c8e241659 = $a5f3a326648f6a6c$export$683905d551c33fa9 * 60;
const $a5f3a326648f6a6c$export$353686095f4fbf45 = $a5f3a326648f6a6c$export$4157bf0c8e241659 * 24;
const $a5f3a326648f6a6c$export$c241eb88520d5016 = $a5f3a326648f6a6c$export$353686095f4fbf45 * 7;
const $a5f3a326648f6a6c$export$ab95684df7020b26 = $a5f3a326648f6a6c$export$353686095f4fbf45 * 30;
const $a5f3a326648f6a6c$export$61f8ee2d834c6959 = $a5f3a326648f6a6c$export$353686095f4fbf45 * 365;


var $298ba98185c4e486$var$day = (0, $761326a64c209a21$export$2e2bcd8739ae039)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a5f3a326648f6a6c$export$683905d551c33fa9)) / (0, $a5f3a326648f6a6c$export$353686095f4fbf45), (date)=>date.getDate() - 1);
var $298ba98185c4e486$export$2e2bcd8739ae039 = $298ba98185c4e486$var$day;
var $298ba98185c4e486$export$3cf5dda4201cc0f2 = $298ba98185c4e486$var$day.range;



var $e922358398431cbc$var$hour = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc) - date.getMinutes() * (0, $a5f3a326648f6a6c$export$683905d551c33fa9));
}, function(date, step) {
    date.setTime(+date + step * (0, $a5f3a326648f6a6c$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$4157bf0c8e241659);
}, function(date) {
    return date.getHours();
});
var $e922358398431cbc$export$2e2bcd8739ae039 = $e922358398431cbc$var$hour;
var $e922358398431cbc$export$8d468796d69cdad1 = $e922358398431cbc$var$hour.range;



var $28bd2ee35beeaac0$var$minute = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc));
}, function(date, step) {
    date.setTime(+date + step * (0, $a5f3a326648f6a6c$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$683905d551c33fa9);
}, function(date) {
    return date.getMinutes();
});
var $28bd2ee35beeaac0$export$2e2bcd8739ae039 = $28bd2ee35beeaac0$var$minute;
var $28bd2ee35beeaac0$export$666252b437cce0c7 = $28bd2ee35beeaac0$var$minute.range;


var $7d42ddde3beca12a$var$month = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var $7d42ddde3beca12a$export$2e2bcd8739ae039 = $7d42ddde3beca12a$var$month;
var $7d42ddde3beca12a$export$16352d1b10c5eb38 = $7d42ddde3beca12a$var$month.range;



var $25dfaaa729b53d45$var$second = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc));
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$79ef0e34099623dc);
}, function(date) {
    return date.getUTCSeconds();
});
var $25dfaaa729b53d45$export$2e2bcd8739ae039 = $25dfaaa729b53d45$var$second;
var $25dfaaa729b53d45$export$4792e48abc550fa1 = $25dfaaa729b53d45$var$second.range;




var $db3c3b1f0014e266$var$millisecond = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
$db3c3b1f0014e266$var$millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return $db3c3b1f0014e266$var$millisecond;
    return (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var $db3c3b1f0014e266$export$2e2bcd8739ae039 = $db3c3b1f0014e266$var$millisecond;
var $db3c3b1f0014e266$export$9a27fac83d67afd3 = $db3c3b1f0014e266$var$millisecond.range;








function $e2327f7020bbd480$var$weekday(i) {
    return (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * (0, $a5f3a326648f6a6c$export$683905d551c33fa9)) / (0, $a5f3a326648f6a6c$export$c241eb88520d5016);
    });
}
var $e2327f7020bbd480$export$fb3ee18ed410cc21 = $e2327f7020bbd480$var$weekday(0);
var $e2327f7020bbd480$export$6416afaab03bc9b8 = $e2327f7020bbd480$var$weekday(1);
var $e2327f7020bbd480$export$cb8f040f5d17ac7b = $e2327f7020bbd480$var$weekday(2);
var $e2327f7020bbd480$export$347581849975dfc8 = $e2327f7020bbd480$var$weekday(3);
var $e2327f7020bbd480$export$2f2b56683a3e5629 = $e2327f7020bbd480$var$weekday(4);
var $e2327f7020bbd480$export$59b8c2ccd931d806 = $e2327f7020bbd480$var$weekday(5);
var $e2327f7020bbd480$export$478ceadebff4d377 = $e2327f7020bbd480$var$weekday(6);
var $e2327f7020bbd480$export$e8daabaa40641211 = $e2327f7020bbd480$export$fb3ee18ed410cc21.range;
var $e2327f7020bbd480$export$74e5b559c235c00e = $e2327f7020bbd480$export$6416afaab03bc9b8.range;
var $e2327f7020bbd480$export$e7d6aa4fb107bc56 = $e2327f7020bbd480$export$cb8f040f5d17ac7b.range;
var $e2327f7020bbd480$export$fcd5880b20bb06a8 = $e2327f7020bbd480$export$347581849975dfc8.range;
var $e2327f7020bbd480$export$682716b7bbe33641 = $e2327f7020bbd480$export$2f2b56683a3e5629.range;
var $e2327f7020bbd480$export$482924968ca86084 = $e2327f7020bbd480$export$59b8c2ccd931d806.range;
var $e2327f7020bbd480$export$7d755172c9cda9d2 = $e2327f7020bbd480$export$478ceadebff4d377.range;




var $ad3d6e9f5c4d8bf3$var$year = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
$ad3d6e9f5c4d8bf3$var$year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039 = $ad3d6e9f5c4d8bf3$var$year;
var $ad3d6e9f5c4d8bf3$export$6fda41c7fb23acf9 = $ad3d6e9f5c4d8bf3$var$year.range;




var $7298c3f36be64fd4$var$utcMinute = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a5f3a326648f6a6c$export$683905d551c33fa9));
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$683905d551c33fa9);
}, function(date) {
    return date.getUTCMinutes();
});
var $7298c3f36be64fd4$export$2e2bcd8739ae039 = $7298c3f36be64fd4$var$utcMinute;
var $7298c3f36be64fd4$export$cedd563624e8ee50 = $7298c3f36be64fd4$var$utcMinute.range;




var $140e5fded8576661$var$utcHour = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * (0, $a5f3a326648f6a6c$export$4157bf0c8e241659));
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$4157bf0c8e241659);
}, function(date) {
    return date.getUTCHours();
});
var $140e5fded8576661$export$2e2bcd8739ae039 = $140e5fded8576661$var$utcHour;
var $140e5fded8576661$export$6e7a76cd5f50b719 = $140e5fded8576661$var$utcHour.range;




var $3c9a06d3d6828ebc$var$utcDay = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / (0, $a5f3a326648f6a6c$export$353686095f4fbf45);
}, function(date) {
    return date.getUTCDate() - 1;
});
var $3c9a06d3d6828ebc$export$2e2bcd8739ae039 = $3c9a06d3d6828ebc$var$utcDay;
var $3c9a06d3d6828ebc$export$d277e198508549a1 = $3c9a06d3d6828ebc$var$utcDay.range;




function $a49c7f1ccf2ef3f4$var$utcWeekday(i) {
    return (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / (0, $a5f3a326648f6a6c$export$c241eb88520d5016);
    });
}
var $a49c7f1ccf2ef3f4$export$4898b06303a92011 = $a49c7f1ccf2ef3f4$var$utcWeekday(0);
var $a49c7f1ccf2ef3f4$export$9cfc53b9cfafd080 = $a49c7f1ccf2ef3f4$var$utcWeekday(1);
var $a49c7f1ccf2ef3f4$export$2a6d545f77eceb15 = $a49c7f1ccf2ef3f4$var$utcWeekday(2);
var $a49c7f1ccf2ef3f4$export$a5c25d8ed64433c4 = $a49c7f1ccf2ef3f4$var$utcWeekday(3);
var $a49c7f1ccf2ef3f4$export$1db08111baec2f53 = $a49c7f1ccf2ef3f4$var$utcWeekday(4);
var $a49c7f1ccf2ef3f4$export$29265e34dd5921f7 = $a49c7f1ccf2ef3f4$var$utcWeekday(5);
var $a49c7f1ccf2ef3f4$export$85b74dad05049604 = $a49c7f1ccf2ef3f4$var$utcWeekday(6);
var $a49c7f1ccf2ef3f4$export$6f3e1c2b0f7d7880 = $a49c7f1ccf2ef3f4$export$4898b06303a92011.range;
var $a49c7f1ccf2ef3f4$export$1d2d8b858bb366f9 = $a49c7f1ccf2ef3f4$export$9cfc53b9cfafd080.range;
var $a49c7f1ccf2ef3f4$export$1d5f6785fc7f30f8 = $a49c7f1ccf2ef3f4$export$2a6d545f77eceb15.range;
var $a49c7f1ccf2ef3f4$export$7a75faf0e37ef4af = $a49c7f1ccf2ef3f4$export$a5c25d8ed64433c4.range;
var $a49c7f1ccf2ef3f4$export$417eb959611b2f2f = $a49c7f1ccf2ef3f4$export$1db08111baec2f53.range;
var $a49c7f1ccf2ef3f4$export$59d308db7af08c64 = $a49c7f1ccf2ef3f4$export$29265e34dd5921f7.range;
var $a49c7f1ccf2ef3f4$export$a124108a0a7f34c8 = $a49c7f1ccf2ef3f4$export$85b74dad05049604.range;



var $281207ec8a179f87$var$utcMonth = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var $281207ec8a179f87$export$2e2bcd8739ae039 = $281207ec8a179f87$var$utcMonth;
var $281207ec8a179f87$export$49159f585997498 = $281207ec8a179f87$var$utcMonth.range;



var $96799038530a0290$var$utcYear = (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
$96799038530a0290$var$utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, $761326a64c209a21$export$2e2bcd8739ae039)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var $96799038530a0290$export$2e2bcd8739ae039 = $96799038530a0290$var$utcYear;
var $96799038530a0290$export$3e24d311e17f5802 = $96799038530a0290$var$utcYear.range;


function $3b4216d8fb4deb62$var$ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            (0, $25dfaaa729b53d45$export$2e2bcd8739ae039),
            1,
            (0, $a5f3a326648f6a6c$export$79ef0e34099623dc)
        ],
        [
            (0, $25dfaaa729b53d45$export$2e2bcd8739ae039),
            5,
            5 * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc)
        ],
        [
            (0, $25dfaaa729b53d45$export$2e2bcd8739ae039),
            15,
            15 * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc)
        ],
        [
            (0, $25dfaaa729b53d45$export$2e2bcd8739ae039),
            30,
            30 * (0, $a5f3a326648f6a6c$export$79ef0e34099623dc)
        ],
        [
            minute,
            1,
            (0, $a5f3a326648f6a6c$export$683905d551c33fa9)
        ],
        [
            minute,
            5,
            5 * (0, $a5f3a326648f6a6c$export$683905d551c33fa9)
        ],
        [
            minute,
            15,
            15 * (0, $a5f3a326648f6a6c$export$683905d551c33fa9)
        ],
        [
            minute,
            30,
            30 * (0, $a5f3a326648f6a6c$export$683905d551c33fa9)
        ],
        [
            hour,
            1,
            (0, $a5f3a326648f6a6c$export$4157bf0c8e241659)
        ],
        [
            hour,
            3,
            3 * (0, $a5f3a326648f6a6c$export$4157bf0c8e241659)
        ],
        [
            hour,
            6,
            6 * (0, $a5f3a326648f6a6c$export$4157bf0c8e241659)
        ],
        [
            hour,
            12,
            12 * (0, $a5f3a326648f6a6c$export$4157bf0c8e241659)
        ],
        [
            day,
            1,
            (0, $a5f3a326648f6a6c$export$353686095f4fbf45)
        ],
        [
            day,
            2,
            2 * (0, $a5f3a326648f6a6c$export$353686095f4fbf45)
        ],
        [
            week,
            1,
            (0, $a5f3a326648f6a6c$export$c241eb88520d5016)
        ],
        [
            month,
            1,
            (0, $a5f3a326648f6a6c$export$ab95684df7020b26)
        ],
        [
            month,
            3,
            3 * (0, $a5f3a326648f6a6c$export$ab95684df7020b26)
        ],
        [
            year,
            1,
            (0, $a5f3a326648f6a6c$export$61f8ee2d834c6959)
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, $a034a40bc2bf9a0f$export$2e2bcd8739ae039)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, $4d170257369f8996$export$81087d9b915d4ede)(start / (0, $a5f3a326648f6a6c$export$61f8ee2d834c6959), stop / (0, $a5f3a326648f6a6c$export$61f8ee2d834c6959), count));
        if (i === 0) return (0, $db3c3b1f0014e266$export$2e2bcd8739ae039).every(Math.max((0, $4d170257369f8996$export$81087d9b915d4ede)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [$3b4216d8fb4deb62$export$826ba5ae907e9767, $3b4216d8fb4deb62$export$6262d8d056ea44c4] = $3b4216d8fb4deb62$var$ticker((0, $96799038530a0290$export$2e2bcd8739ae039), (0, $281207ec8a179f87$export$2e2bcd8739ae039), (0, $a49c7f1ccf2ef3f4$export$4898b06303a92011), (0, $3c9a06d3d6828ebc$export$2e2bcd8739ae039), (0, $140e5fded8576661$export$2e2bcd8739ae039), (0, $7298c3f36be64fd4$export$2e2bcd8739ae039));
const [$3b4216d8fb4deb62$export$60c76498552d28a6, $3b4216d8fb4deb62$export$69511150134dd174] = $3b4216d8fb4deb62$var$ticker((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039), (0, $7d42ddde3beca12a$export$2e2bcd8739ae039), (0, $e2327f7020bbd480$export$fb3ee18ed410cc21), (0, $298ba98185c4e486$export$2e2bcd8739ae039), (0, $e922358398431cbc$export$2e2bcd8739ae039), (0, $28bd2ee35beeaac0$export$2e2bcd8739ae039));



function $767665ebb185d8fa$var$localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function $767665ebb185d8fa$var$utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function $767665ebb185d8fa$var$newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function $767665ebb185d8fa$export$2e2bcd8739ae039(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = $767665ebb185d8fa$var$formatRe(locale_periods), periodLookup = $767665ebb185d8fa$var$formatLookup(locale_periods), weekdayRe = $767665ebb185d8fa$var$formatRe(locale_weekdays), weekdayLookup = $767665ebb185d8fa$var$formatLookup(locale_weekdays), shortWeekdayRe = $767665ebb185d8fa$var$formatRe(locale_shortWeekdays), shortWeekdayLookup = $767665ebb185d8fa$var$formatLookup(locale_shortWeekdays), monthRe = $767665ebb185d8fa$var$formatRe(locale_months), monthLookup = $767665ebb185d8fa$var$formatLookup(locale_months), shortMonthRe = $767665ebb185d8fa$var$formatRe(locale_shortMonths), shortMonthLookup = $767665ebb185d8fa$var$formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": $767665ebb185d8fa$var$formatDayOfMonth,
        "e": $767665ebb185d8fa$var$formatDayOfMonth,
        "f": $767665ebb185d8fa$var$formatMicroseconds,
        "g": $767665ebb185d8fa$var$formatYearISO,
        "G": $767665ebb185d8fa$var$formatFullYearISO,
        "H": $767665ebb185d8fa$var$formatHour24,
        "I": $767665ebb185d8fa$var$formatHour12,
        "j": $767665ebb185d8fa$var$formatDayOfYear,
        "L": $767665ebb185d8fa$var$formatMilliseconds,
        "m": $767665ebb185d8fa$var$formatMonthNumber,
        "M": $767665ebb185d8fa$var$formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": $767665ebb185d8fa$var$formatUnixTimestamp,
        "s": $767665ebb185d8fa$var$formatUnixTimestampSeconds,
        "S": $767665ebb185d8fa$var$formatSeconds,
        "u": $767665ebb185d8fa$var$formatWeekdayNumberMonday,
        "U": $767665ebb185d8fa$var$formatWeekNumberSunday,
        "V": $767665ebb185d8fa$var$formatWeekNumberISO,
        "w": $767665ebb185d8fa$var$formatWeekdayNumberSunday,
        "W": $767665ebb185d8fa$var$formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $767665ebb185d8fa$var$formatYear,
        "Y": $767665ebb185d8fa$var$formatFullYear,
        "Z": $767665ebb185d8fa$var$formatZone,
        "%": $767665ebb185d8fa$var$formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": $767665ebb185d8fa$var$formatUTCDayOfMonth,
        "e": $767665ebb185d8fa$var$formatUTCDayOfMonth,
        "f": $767665ebb185d8fa$var$formatUTCMicroseconds,
        "g": $767665ebb185d8fa$var$formatUTCYearISO,
        "G": $767665ebb185d8fa$var$formatUTCFullYearISO,
        "H": $767665ebb185d8fa$var$formatUTCHour24,
        "I": $767665ebb185d8fa$var$formatUTCHour12,
        "j": $767665ebb185d8fa$var$formatUTCDayOfYear,
        "L": $767665ebb185d8fa$var$formatUTCMilliseconds,
        "m": $767665ebb185d8fa$var$formatUTCMonthNumber,
        "M": $767665ebb185d8fa$var$formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": $767665ebb185d8fa$var$formatUnixTimestamp,
        "s": $767665ebb185d8fa$var$formatUnixTimestampSeconds,
        "S": $767665ebb185d8fa$var$formatUTCSeconds,
        "u": $767665ebb185d8fa$var$formatUTCWeekdayNumberMonday,
        "U": $767665ebb185d8fa$var$formatUTCWeekNumberSunday,
        "V": $767665ebb185d8fa$var$formatUTCWeekNumberISO,
        "w": $767665ebb185d8fa$var$formatUTCWeekdayNumberSunday,
        "W": $767665ebb185d8fa$var$formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": $767665ebb185d8fa$var$formatUTCYear,
        "Y": $767665ebb185d8fa$var$formatUTCFullYear,
        "Z": $767665ebb185d8fa$var$formatUTCZone,
        "%": $767665ebb185d8fa$var$formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": $767665ebb185d8fa$var$parseDayOfMonth,
        "e": $767665ebb185d8fa$var$parseDayOfMonth,
        "f": $767665ebb185d8fa$var$parseMicroseconds,
        "g": $767665ebb185d8fa$var$parseYear,
        "G": $767665ebb185d8fa$var$parseFullYear,
        "H": $767665ebb185d8fa$var$parseHour24,
        "I": $767665ebb185d8fa$var$parseHour24,
        "j": $767665ebb185d8fa$var$parseDayOfYear,
        "L": $767665ebb185d8fa$var$parseMilliseconds,
        "m": $767665ebb185d8fa$var$parseMonthNumber,
        "M": $767665ebb185d8fa$var$parseMinutes,
        "p": parsePeriod,
        "q": $767665ebb185d8fa$var$parseQuarter,
        "Q": $767665ebb185d8fa$var$parseUnixTimestamp,
        "s": $767665ebb185d8fa$var$parseUnixTimestampSeconds,
        "S": $767665ebb185d8fa$var$parseSeconds,
        "u": $767665ebb185d8fa$var$parseWeekdayNumberMonday,
        "U": $767665ebb185d8fa$var$parseWeekNumberSunday,
        "V": $767665ebb185d8fa$var$parseWeekNumberISO,
        "w": $767665ebb185d8fa$var$parseWeekdayNumberSunday,
        "W": $767665ebb185d8fa$var$parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": $767665ebb185d8fa$var$parseYear,
        "Y": $767665ebb185d8fa$var$parseFullYear,
        "Z": $767665ebb185d8fa$var$parseZone,
        "%": $767665ebb185d8fa$var$parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = $767665ebb185d8fa$var$pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = $767665ebb185d8fa$var$newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = $767665ebb185d8fa$var$utcDate($767665ebb185d8fa$var$newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? (0, $a49c7f1ccf2ef3f4$export$9cfc53b9cfafd080).ceil(week) : (0, $a49c7f1ccf2ef3f4$export$9cfc53b9cfafd080)(week);
                    week = (0, $3c9a06d3d6828ebc$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = $767665ebb185d8fa$var$localDate($767665ebb185d8fa$var$newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? (0, $e2327f7020bbd480$export$6416afaab03bc9b8).ceil(week) : (0, $e2327f7020bbd480$export$6416afaab03bc9b8)(week);
                    week = (0, $298ba98185c4e486$export$2e2bcd8739ae039).offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? $767665ebb185d8fa$var$utcDate($767665ebb185d8fa$var$newDate(d.y, 0, 1)).getUTCDay() : $767665ebb185d8fa$var$localDate($767665ebb185d8fa$var$newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return $767665ebb185d8fa$var$utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return $767665ebb185d8fa$var$localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in $767665ebb185d8fa$var$pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var $767665ebb185d8fa$var$pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, $767665ebb185d8fa$var$numberRe = /^\s*\d+/, $767665ebb185d8fa$var$percentRe = /^%/, $767665ebb185d8fa$var$requoteRe = /[\\^$*+?|[\]().{}]/g;
function $767665ebb185d8fa$var$pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function $767665ebb185d8fa$var$requote(s) {
    return s.replace($767665ebb185d8fa$var$requoteRe, "\\$&");
}
function $767665ebb185d8fa$var$formatRe(names) {
    return new RegExp("^(?:" + names.map($767665ebb185d8fa$var$requote).join("|") + ")", "i");
}
function $767665ebb185d8fa$var$formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function $767665ebb185d8fa$var$parseWeekdayNumberSunday(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseWeekdayNumberMonday(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseWeekNumberSunday(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseWeekNumberISO(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseWeekNumberMonday(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseFullYear(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseYear(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseQuarter(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseMonthNumber(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseDayOfMonth(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseDayOfYear(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseHour24(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseMinutes(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseSeconds(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseMilliseconds(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseMicroseconds(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseLiteralPercent(d, string, i) {
    var n = $767665ebb185d8fa$var$percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function $767665ebb185d8fa$var$parseUnixTimestamp(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$parseUnixTimestampSeconds(d, string, i) {
    var n = $767665ebb185d8fa$var$numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function $767665ebb185d8fa$var$formatDayOfMonth(d, p) {
    return $767665ebb185d8fa$var$pad(d.getDate(), p, 2);
}
function $767665ebb185d8fa$var$formatHour24(d, p) {
    return $767665ebb185d8fa$var$pad(d.getHours(), p, 2);
}
function $767665ebb185d8fa$var$formatHour12(d, p) {
    return $767665ebb185d8fa$var$pad(d.getHours() % 12 || 12, p, 2);
}
function $767665ebb185d8fa$var$formatDayOfYear(d, p) {
    return $767665ebb185d8fa$var$pad(1 + (0, $298ba98185c4e486$export$2e2bcd8739ae039).count((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $767665ebb185d8fa$var$formatMilliseconds(d, p) {
    return $767665ebb185d8fa$var$pad(d.getMilliseconds(), p, 3);
}
function $767665ebb185d8fa$var$formatMicroseconds(d, p) {
    return $767665ebb185d8fa$var$formatMilliseconds(d, p) + "000";
}
function $767665ebb185d8fa$var$formatMonthNumber(d, p) {
    return $767665ebb185d8fa$var$pad(d.getMonth() + 1, p, 2);
}
function $767665ebb185d8fa$var$formatMinutes(d, p) {
    return $767665ebb185d8fa$var$pad(d.getMinutes(), p, 2);
}
function $767665ebb185d8fa$var$formatSeconds(d, p) {
    return $767665ebb185d8fa$var$pad(d.getSeconds(), p, 2);
}
function $767665ebb185d8fa$var$formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function $767665ebb185d8fa$var$formatWeekNumberSunday(d, p) {
    return $767665ebb185d8fa$var$pad((0, $e2327f7020bbd480$export$fb3ee18ed410cc21).count((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $767665ebb185d8fa$var$dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, $e2327f7020bbd480$export$2f2b56683a3e5629)(d) : (0, $e2327f7020bbd480$export$2f2b56683a3e5629).ceil(d);
}
function $767665ebb185d8fa$var$formatWeekNumberISO(d, p) {
    d = $767665ebb185d8fa$var$dISO(d);
    return $767665ebb185d8fa$var$pad((0, $e2327f7020bbd480$export$2f2b56683a3e5629).count((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039)(d), d) + ((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039)(d).getDay() === 4), p, 2);
}
function $767665ebb185d8fa$var$formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function $767665ebb185d8fa$var$formatWeekNumberMonday(d, p) {
    return $767665ebb185d8fa$var$pad((0, $e2327f7020bbd480$export$6416afaab03bc9b8).count((0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $767665ebb185d8fa$var$formatYear(d, p) {
    return $767665ebb185d8fa$var$pad(d.getFullYear() % 100, p, 2);
}
function $767665ebb185d8fa$var$formatYearISO(d, p) {
    d = $767665ebb185d8fa$var$dISO(d);
    return $767665ebb185d8fa$var$pad(d.getFullYear() % 100, p, 2);
}
function $767665ebb185d8fa$var$formatFullYear(d, p) {
    return $767665ebb185d8fa$var$pad(d.getFullYear() % 10000, p, 4);
}
function $767665ebb185d8fa$var$formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, $e2327f7020bbd480$export$2f2b56683a3e5629)(d) : (0, $e2327f7020bbd480$export$2f2b56683a3e5629).ceil(d);
    return $767665ebb185d8fa$var$pad(d.getFullYear() % 10000, p, 4);
}
function $767665ebb185d8fa$var$formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + $767665ebb185d8fa$var$pad(z / 60 | 0, "0", 2) + $767665ebb185d8fa$var$pad(z % 60, "0", 2);
}
function $767665ebb185d8fa$var$formatUTCDayOfMonth(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCDate(), p, 2);
}
function $767665ebb185d8fa$var$formatUTCHour24(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCHours(), p, 2);
}
function $767665ebb185d8fa$var$formatUTCHour12(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCHours() % 12 || 12, p, 2);
}
function $767665ebb185d8fa$var$formatUTCDayOfYear(d, p) {
    return $767665ebb185d8fa$var$pad(1 + (0, $3c9a06d3d6828ebc$export$2e2bcd8739ae039).count((0, $96799038530a0290$export$2e2bcd8739ae039)(d), d), p, 3);
}
function $767665ebb185d8fa$var$formatUTCMilliseconds(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCMilliseconds(), p, 3);
}
function $767665ebb185d8fa$var$formatUTCMicroseconds(d, p) {
    return $767665ebb185d8fa$var$formatUTCMilliseconds(d, p) + "000";
}
function $767665ebb185d8fa$var$formatUTCMonthNumber(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCMonth() + 1, p, 2);
}
function $767665ebb185d8fa$var$formatUTCMinutes(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCMinutes(), p, 2);
}
function $767665ebb185d8fa$var$formatUTCSeconds(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCSeconds(), p, 2);
}
function $767665ebb185d8fa$var$formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function $767665ebb185d8fa$var$formatUTCWeekNumberSunday(d, p) {
    return $767665ebb185d8fa$var$pad((0, $a49c7f1ccf2ef3f4$export$4898b06303a92011).count((0, $96799038530a0290$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $767665ebb185d8fa$var$UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, $a49c7f1ccf2ef3f4$export$1db08111baec2f53)(d) : (0, $a49c7f1ccf2ef3f4$export$1db08111baec2f53).ceil(d);
}
function $767665ebb185d8fa$var$formatUTCWeekNumberISO(d, p) {
    d = $767665ebb185d8fa$var$UTCdISO(d);
    return $767665ebb185d8fa$var$pad((0, $a49c7f1ccf2ef3f4$export$1db08111baec2f53).count((0, $96799038530a0290$export$2e2bcd8739ae039)(d), d) + ((0, $96799038530a0290$export$2e2bcd8739ae039)(d).getUTCDay() === 4), p, 2);
}
function $767665ebb185d8fa$var$formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function $767665ebb185d8fa$var$formatUTCWeekNumberMonday(d, p) {
    return $767665ebb185d8fa$var$pad((0, $a49c7f1ccf2ef3f4$export$9cfc53b9cfafd080).count((0, $96799038530a0290$export$2e2bcd8739ae039)(d) - 1, d), p, 2);
}
function $767665ebb185d8fa$var$formatUTCYear(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $767665ebb185d8fa$var$formatUTCYearISO(d, p) {
    d = $767665ebb185d8fa$var$UTCdISO(d);
    return $767665ebb185d8fa$var$pad(d.getUTCFullYear() % 100, p, 2);
}
function $767665ebb185d8fa$var$formatUTCFullYear(d, p) {
    return $767665ebb185d8fa$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $767665ebb185d8fa$var$formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, $a49c7f1ccf2ef3f4$export$1db08111baec2f53)(d) : (0, $a49c7f1ccf2ef3f4$export$1db08111baec2f53).ceil(d);
    return $767665ebb185d8fa$var$pad(d.getUTCFullYear() % 10000, p, 4);
}
function $767665ebb185d8fa$var$formatUTCZone() {
    return "+0000";
}
function $767665ebb185d8fa$var$formatLiteralPercent() {
    return "%";
}
function $767665ebb185d8fa$var$formatUnixTimestamp(d) {
    return +d;
}
function $767665ebb185d8fa$var$formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}


var $069ec9db6a68b85e$var$locale;
var $069ec9db6a68b85e$export$94f4d87fad5dcf9a;
var $069ec9db6a68b85e$export$32b9cd16e1b8c8d2;
var $069ec9db6a68b85e$export$1a08fe38f63ebbbb;
var $069ec9db6a68b85e$export$3edae9cf8e233729;
$069ec9db6a68b85e$export$2e2bcd8739ae039({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function $069ec9db6a68b85e$export$2e2bcd8739ae039(definition) {
    $069ec9db6a68b85e$var$locale = (0, $767665ebb185d8fa$export$2e2bcd8739ae039)(definition);
    $069ec9db6a68b85e$export$94f4d87fad5dcf9a = $069ec9db6a68b85e$var$locale.format;
    $069ec9db6a68b85e$export$32b9cd16e1b8c8d2 = $069ec9db6a68b85e$var$locale.parse;
    $069ec9db6a68b85e$export$1a08fe38f63ebbbb = $069ec9db6a68b85e$var$locale.utcFormat;
    $069ec9db6a68b85e$export$3edae9cf8e233729 = $069ec9db6a68b85e$var$locale.utcParse;
    return $069ec9db6a68b85e$var$locale;
}





function $2013512213518732$var$date(t) {
    return new Date(t);
}
function $2013512213518732$var$number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function $2013512213518732$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, $de84e4e7fff24235$export$2e2bcd8739ae039)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, $2013512213518732$var$number)) : domain().map($2013512213518732$var$date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, $e0fbbf8192ac8d86$export$2e2bcd8739ae039)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, $de84e4e7fff24235$export$784d13d8ee351f07)(scale, $2013512213518732$export$56bbcdb8aca31149(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function $2013512213518732$export$2e2bcd8739ae039() {
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply($2013512213518732$export$56bbcdb8aca31149((0, $3b4216d8fb4deb62$export$60c76498552d28a6), (0, $3b4216d8fb4deb62$export$69511150134dd174), (0, $ad3d6e9f5c4d8bf3$export$2e2bcd8739ae039), (0, $7d42ddde3beca12a$export$2e2bcd8739ae039), (0, $e2327f7020bbd480$export$fb3ee18ed410cc21), (0, $298ba98185c4e486$export$2e2bcd8739ae039), (0, $e922358398431cbc$export$2e2bcd8739ae039), (0, $28bd2ee35beeaac0$export$2e2bcd8739ae039), (0, $25dfaaa729b53d45$export$2e2bcd8739ae039), (0, $069ec9db6a68b85e$export$94f4d87fad5dcf9a)).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}






function $f50892e0e5876236$export$2e2bcd8739ae039() {
    return (0, $d92e6e09c56ce871$export$23c7bb9e6558da2a).apply((0, $2013512213518732$export$56bbcdb8aca31149)((0, $3b4216d8fb4deb62$export$826ba5ae907e9767), (0, $3b4216d8fb4deb62$export$6262d8d056ea44c4), (0, $96799038530a0290$export$2e2bcd8739ae039), (0, $281207ec8a179f87$export$2e2bcd8739ae039), (0, $a49c7f1ccf2ef3f4$export$4898b06303a92011), (0, $3c9a06d3d6828ebc$export$2e2bcd8739ae039), (0, $140e5fded8576661$export$2e2bcd8739ae039), (0, $7298c3f36be64fd4$export$2e2bcd8739ae039), (0, $25dfaaa729b53d45$export$2e2bcd8739ae039), (0, $069ec9db6a68b85e$export$1a08fe38f63ebbbb)).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}









function $c0a336936e98f9cc$var$transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = (0, $de84e4e7fff24235$export$f0954fd7d5368655), clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $f822e5bb151a52dc$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $9eff91e007b3638d$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function $c0a336936e98f9cc$export$784d13d8ee351f07(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function $c0a336936e98f9cc$export$2e2bcd8739ae039() {
    var scale = (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)($c0a336936e98f9cc$var$transformer()((0, $de84e4e7fff24235$export$f0954fd7d5368655)));
    scale.copy = function() {
        return $c0a336936e98f9cc$export$784d13d8ee351f07(scale, $c0a336936e98f9cc$export$2e2bcd8739ae039());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c0a336936e98f9cc$export$6843e08bf2ff981f() {
    var scale = (0, $815d9ddbd2324009$export$860836db074028f0)($c0a336936e98f9cc$var$transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return $c0a336936e98f9cc$export$784d13d8ee351f07(scale, $c0a336936e98f9cc$export$6843e08bf2ff981f()).base(scale.base());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c0a336936e98f9cc$export$9d4af4de62c81941() {
    var scale = (0, $b26419c4c20a95da$export$4602684e614eba38)($c0a336936e98f9cc$var$transformer());
    scale.copy = function() {
        return $c0a336936e98f9cc$export$784d13d8ee351f07(scale, $c0a336936e98f9cc$export$9d4af4de62c81941()).constant(scale.constant());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c0a336936e98f9cc$export$de9f78581b4f2405() {
    var scale = (0, $620dfea9ea91a5b7$export$34695211ec403a46)($c0a336936e98f9cc$var$transformer());
    scale.copy = function() {
        return $c0a336936e98f9cc$export$784d13d8ee351f07(scale, $c0a336936e98f9cc$export$de9f78581b4f2405()).exponent(scale.exponent());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $c0a336936e98f9cc$export$413d935127ed466e() {
    return $c0a336936e98f9cc$export$de9f78581b4f2405.apply(null, arguments).exponent(0.5);
}





function $48fac3024a809b0d$export$2e2bcd8739ae039() {
    var domain = [], interpolator = (0, $de84e4e7fff24235$export$f0954fd7d5368655);
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, $9c8c58c1752a5b15$export$2e2bcd8739ae039)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort((0, $f548b959188c763f$export$2e2bcd8739ae039));
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, $1ec473348aab6a4a$export$2e2bcd8739ae039)(domain, i / n));
    };
    scale.copy = function() {
        return $48fac3024a809b0d$export$2e2bcd8739ae039(interpolator).domain(domain);
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}



function $cc0220b9649412c4$export$2e2bcd8739ae039(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = (0, $f822e5bb151a52dc$export$2e2bcd8739ae039);
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}









function $38c3ab0098441a5f$var$transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = (0, $de84e4e7fff24235$export$f0954fd7d5368655), transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, $cc0220b9649412c4$export$2e2bcd8739ae039)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range((0, $f822e5bb151a52dc$export$2e2bcd8739ae039));
    scale.rangeRound = range((0, $9eff91e007b3638d$export$2e2bcd8739ae039));
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function $38c3ab0098441a5f$export$2e2bcd8739ae039() {
    var scale = (0, $6488995c00e88b5a$export$16a5d4b4a61a274d)($38c3ab0098441a5f$var$transformer()((0, $de84e4e7fff24235$export$f0954fd7d5368655)));
    scale.copy = function() {
        return (0, $c0a336936e98f9cc$export$784d13d8ee351f07)(scale, $38c3ab0098441a5f$export$2e2bcd8739ae039());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $38c3ab0098441a5f$export$5f0266a9159c47fb() {
    var scale = (0, $815d9ddbd2324009$export$860836db074028f0)($38c3ab0098441a5f$var$transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, $c0a336936e98f9cc$export$784d13d8ee351f07)(scale, $38c3ab0098441a5f$export$5f0266a9159c47fb()).base(scale.base());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $38c3ab0098441a5f$export$50b3da713cf557c6() {
    var scale = (0, $b26419c4c20a95da$export$4602684e614eba38)($38c3ab0098441a5f$var$transformer());
    scale.copy = function() {
        return (0, $c0a336936e98f9cc$export$784d13d8ee351f07)(scale, $38c3ab0098441a5f$export$50b3da713cf557c6()).constant(scale.constant());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $38c3ab0098441a5f$export$d6cedcc63bf26e7e() {
    var scale = (0, $620dfea9ea91a5b7$export$34695211ec403a46)($38c3ab0098441a5f$var$transformer());
    scale.copy = function() {
        return (0, $c0a336936e98f9cc$export$784d13d8ee351f07)(scale, $38c3ab0098441a5f$export$d6cedcc63bf26e7e()).exponent(scale.exponent());
    };
    return (0, $d92e6e09c56ce871$export$7d6b419e59e83f3d).apply(scale, arguments);
}
function $38c3ab0098441a5f$export$33ddefb5c4ab9e9c() {
    return $38c3ab0098441a5f$export$d6cedcc63bf26e7e.apply(null, arguments).exponent(0.5);
}







function $e6f333c1b3a793a3$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}


function $785b58177a16c62e$export$2e2bcd8739ae039(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}


function $cb287d0d105c490e$var$stackValue(d, key) {
    return d[key];
}
function $cb287d0d105c490e$var$stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function $cb287d0d105c490e$export$2e2bcd8739ae039() {
    var keys = (0, $5c5e96e92443e707$export$2e2bcd8739ae039)([]), order = (0, $785b58177a16c62e$export$2e2bcd8739ae039), offset = (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039), value = $cb287d0d105c490e$var$stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), $cb287d0d105c490e$var$stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, $7a305163978c18e2$export$2e2bcd8739ae039)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? (0, $785b58177a16c62e$export$2e2bcd8739ae039) : typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039) : _, stack) : offset;
    };
    return stack;
}


function $ec0683d5684c1f76$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039)(series, order);
}


function $5d161527b4283bb4$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039)(series, order);
}


function $27cafa74c89e581d$export$2e2bcd8739ae039(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039)(series, order);
}




var $3cd389e91472e4cd$exports = {};

var $e3fc83da7b1fe117$exports = {};

var $6e4f7cef485965a7$exports = {};
var $bc97c69d2a29b9bb$exports = {};
var $84fd401837261274$exports = {};
/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $84fd401837261274$var$baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
    while(fromRight ? index-- : ++index < length){
        if (predicate(array[index], index, array)) return index;
    }
    return -1;
}
$84fd401837261274$exports = $84fd401837261274$var$baseFindIndex;


var $1aa4af0181e152d9$exports = {};
/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */ function $1aa4af0181e152d9$var$baseIsNaN(value) {
    return value !== value;
}
$1aa4af0181e152d9$exports = $1aa4af0181e152d9$var$baseIsNaN;


var $1fd4e425bf2903f0$exports = {};
/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $1fd4e425bf2903f0$var$strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1, length = array.length;
    while(++index < length){
        if (array[index] === value) return index;
    }
    return -1;
}
$1fd4e425bf2903f0$exports = $1fd4e425bf2903f0$var$strictIndexOf;


/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $bc97c69d2a29b9bb$var$baseIndexOf(array, value, fromIndex) {
    return value === value ? $1fd4e425bf2903f0$exports(array, value, fromIndex) : $84fd401837261274$exports(array, $1aa4af0181e152d9$exports, fromIndex);
}
$bc97c69d2a29b9bb$exports = $bc97c69d2a29b9bb$var$baseIndexOf;


/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $6e4f7cef485965a7$var$arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && $bc97c69d2a29b9bb$exports(array, value, 0) > -1;
}
$6e4f7cef485965a7$exports = $6e4f7cef485965a7$var$arrayIncludes;


var $c7ea864cc4a648a0$exports = {};
/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */ function $c7ea864cc4a648a0$var$arrayIncludesWith(array, value, comparator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (comparator(value, array[index])) return true;
    }
    return false;
}
$c7ea864cc4a648a0$exports = $c7ea864cc4a648a0$var$arrayIncludesWith;



var $7de632305bda377d$exports = {};

var $de4e0f3a64aaabe0$exports = {};
/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */ function $de4e0f3a64aaabe0$var$noop() {
// No operation performed.
}
$de4e0f3a64aaabe0$exports = $de4e0f3a64aaabe0$var$noop;



/** Used as references for various `Number` constants. */ var $7de632305bda377d$var$INFINITY = 1 / 0;
/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */ var $7de632305bda377d$var$createSet = !($5deb88fbb4a464a1$exports && 1 / $5df61789b301e5ff$exports(new $5deb88fbb4a464a1$exports([
    ,
    -0
]))[1] == $7de632305bda377d$var$INFINITY) ? $de4e0f3a64aaabe0$exports : function(values) {
    return new $5deb88fbb4a464a1$exports(values);
};
$7de632305bda377d$exports = $7de632305bda377d$var$createSet;



/** Used as the size to enable large array optimizations. */ var $e3fc83da7b1fe117$var$LARGE_ARRAY_SIZE = 200;
/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */ function $e3fc83da7b1fe117$var$baseUniq(array, iteratee, comparator) {
    var index = -1, includes = $6e4f7cef485965a7$exports, length = array.length, isCommon = true, result = [], seen = result;
    if (comparator) {
        isCommon = false;
        includes = $c7ea864cc4a648a0$exports;
    } else if (length >= $e3fc83da7b1fe117$var$LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : $7de632305bda377d$exports(array);
        if (set) return $5df61789b301e5ff$exports(set);
        isCommon = false;
        includes = $01fedadae9fa2482$exports;
        seen = new $f5cbf6641c4b308c$exports;
    } else seen = iteratee ? [] : result;
    outer: while(++index < length){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
            var seenIndex = seen.length;
            while(seenIndex--){
                if (seen[seenIndex] === computed) continue outer;
            }
            if (iteratee) seen.push(computed);
            result.push(value);
        } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
$e3fc83da7b1fe117$exports = $e3fc83da7b1fe117$var$baseUniq;


/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */ function $3cd389e91472e4cd$var$uniqBy(array, iteratee) {
    return array && array.length ? $e3fc83da7b1fe117$exports(array, $0ef980bf7dd42cec$exports(iteratee, 2)) : [];
}
$3cd389e91472e4cd$exports = $3cd389e91472e4cd$var$uniqBy;



var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

function $97e02d2bb4391b31$var$_extends() {
    $97e02d2bb4391b31$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $97e02d2bb4391b31$var$_extends.apply(this, arguments);
}
function $97e02d2bb4391b31$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $97e02d2bb4391b31$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $97e02d2bb4391b31$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $97e02d2bb4391b31$export$7b92b459e668cb21(props) {
    var children = props.children, width = props.width, height = props.height, viewBox = props.viewBox, className = props.className, style = props.style, others = $97e02d2bb4391b31$var$_objectWithoutProperties(props, [
        "children",
        "width",
        "height",
        "viewBox",
        "className",
        "style"
    ]);
    var svgView = viewBox || {
        width: width,
        height: height,
        x: 0,
        y: 0
    };
    var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-surface", className);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("svg", $97e02d2bb4391b31$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(others, true, true), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        version: "1.1"
    }), children);
}




var $eCoWV = parcelRequire("eCoWV");


const $78fd7906683416e6$export$2335f513bbd82c6d = Math.abs;
const $78fd7906683416e6$export$b8b770ee6a0d9760 = Math.atan2;
const $78fd7906683416e6$export$50d414a77b60d802 = Math.cos;
const $78fd7906683416e6$export$8960430cfd85939f = Math.max;
const $78fd7906683416e6$export$96ec731ed4dcb222 = Math.min;
const $78fd7906683416e6$export$5de3937cb4b592ed = Math.sin;
const $78fd7906683416e6$export$eba8049fb5020b81 = Math.sqrt;
const $78fd7906683416e6$export$6c421550c66a327d = 1e-12;
const $78fd7906683416e6$export$18c7bea995a110f = Math.PI;
const $78fd7906683416e6$export$e51408a300e8929a = $78fd7906683416e6$export$18c7bea995a110f / 2;
const $78fd7906683416e6$export$a4b4b4d4d776fe92 = 2 * $78fd7906683416e6$export$18c7bea995a110f;
function $78fd7906683416e6$export$fd6306be3fde5b04(x) {
    return x > 1 ? 0 : x < -1 ? $78fd7906683416e6$export$18c7bea995a110f : Math.acos(x);
}
function $78fd7906683416e6$export$41726bdb1fc63f(x) {
    return x >= 1 ? $78fd7906683416e6$export$e51408a300e8929a : x <= -1 ? -$78fd7906683416e6$export$e51408a300e8929a : Math.asin(x);
}


const $7a7f57c2d42a8241$var$sqrt3 = (0, $78fd7906683416e6$export$eba8049fb5020b81)(3);
var $7a7f57c2d42a8241$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size + (0, $78fd7906683416e6$export$96ec731ed4dcb222)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * $7a7f57c2d42a8241$var$sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};



var $daf36e5327a667f7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size / (0, $78fd7906683416e6$export$18c7bea995a110f));
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, (0, $78fd7906683416e6$export$a4b4b4d4d776fe92));
    }
};



var $a55c2a27ed41a507$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};



const $8c2be31605c6b3f3$var$tan30 = (0, $78fd7906683416e6$export$eba8049fb5020b81)(1 / 3);
const $8c2be31605c6b3f3$var$tan30_2 = $8c2be31605c6b3f3$var$tan30 * 2;
var $8c2be31605c6b3f3$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size / $8c2be31605c6b3f3$var$tan30_2);
        const x = y * $8c2be31605c6b3f3$var$tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};



var $d85cd34370d2c7eb$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};



var $5e363d036e5a20af$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size - (0, $78fd7906683416e6$export$96ec731ed4dcb222)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};



var $de7e81ea70dff8c7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const w = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};



var $7ebf2d627d0854a7$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};



const $d843e25a96df88c2$var$ka = 0.89081309152928522810;
const $d843e25a96df88c2$var$kr = (0, $78fd7906683416e6$export$5de3937cb4b592ed)((0, $78fd7906683416e6$export$18c7bea995a110f) / 10) / (0, $78fd7906683416e6$export$5de3937cb4b592ed)(7 * (0, $78fd7906683416e6$export$18c7bea995a110f) / 10);
const $d843e25a96df88c2$var$kx = (0, $78fd7906683416e6$export$5de3937cb4b592ed)((0, $78fd7906683416e6$export$a4b4b4d4d776fe92) / 10) * $d843e25a96df88c2$var$kr;
const $d843e25a96df88c2$var$ky = -(0, $78fd7906683416e6$export$50d414a77b60d802)((0, $78fd7906683416e6$export$a4b4b4d4d776fe92) / 10) * $d843e25a96df88c2$var$kr;
var $d843e25a96df88c2$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size * $d843e25a96df88c2$var$ka);
        const x = $d843e25a96df88c2$var$kx * r;
        const y = $d843e25a96df88c2$var$ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = (0, $78fd7906683416e6$export$a4b4b4d4d776fe92) * i / 5;
            const c = (0, $78fd7906683416e6$export$50d414a77b60d802)(a);
            const s = (0, $78fd7906683416e6$export$5de3937cb4b592ed)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};



const $2cb8338e5d4f0754$var$sqrt3 = (0, $78fd7906683416e6$export$eba8049fb5020b81)(3);
var $2cb8338e5d4f0754$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const y = -(0, $78fd7906683416e6$export$eba8049fb5020b81)(size / ($2cb8338e5d4f0754$var$sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-$2cb8338e5d4f0754$var$sqrt3 * y, -y);
        context.lineTo($2cb8338e5d4f0754$var$sqrt3 * y, -y);
        context.closePath();
    }
};



const $2e6bfbcb1095bfea$var$sqrt3 = (0, $78fd7906683416e6$export$eba8049fb5020b81)(3);
var $2e6bfbcb1095bfea$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const s = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size) * 0.6824;
        const t = s / 2;
        const u = s * $2e6bfbcb1095bfea$var$sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};



const $cb4792015df5b244$var$c = -0.5;
const $cb4792015df5b244$var$s = (0, $78fd7906683416e6$export$eba8049fb5020b81)(3) / 2;
const $cb4792015df5b244$var$k = 1 / (0, $78fd7906683416e6$export$eba8049fb5020b81)(12);
const $cb4792015df5b244$var$a = ($cb4792015df5b244$var$k / 2 + 1) * 3;
var $cb4792015df5b244$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size / $cb4792015df5b244$var$a);
        const x0 = r / 2, y0 = r * $cb4792015df5b244$var$k;
        const x1 = x0, y1 = r * $cb4792015df5b244$var$k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo($cb4792015df5b244$var$c * x0 - $cb4792015df5b244$var$s * y0, $cb4792015df5b244$var$s * x0 + $cb4792015df5b244$var$c * y0);
        context.lineTo($cb4792015df5b244$var$c * x1 - $cb4792015df5b244$var$s * y1, $cb4792015df5b244$var$s * x1 + $cb4792015df5b244$var$c * y1);
        context.lineTo($cb4792015df5b244$var$c * x2 - $cb4792015df5b244$var$s * y2, $cb4792015df5b244$var$s * x2 + $cb4792015df5b244$var$c * y2);
        context.lineTo($cb4792015df5b244$var$c * x0 + $cb4792015df5b244$var$s * y0, $cb4792015df5b244$var$c * y0 - $cb4792015df5b244$var$s * x0);
        context.lineTo($cb4792015df5b244$var$c * x1 + $cb4792015df5b244$var$s * y1, $cb4792015df5b244$var$c * y1 - $cb4792015df5b244$var$s * x1);
        context.lineTo($cb4792015df5b244$var$c * x2 + $cb4792015df5b244$var$s * y2, $cb4792015df5b244$var$c * y2 - $cb4792015df5b244$var$s * x2);
        context.closePath();
    }
};



var $1cf00929721e1f48$export$2e2bcd8739ae039 = {
    draw (context, size) {
        const r = (0, $78fd7906683416e6$export$eba8049fb5020b81)(size - (0, $78fd7906683416e6$export$96ec731ed4dcb222)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};


const $54c490958243a65a$export$19158c96a6700c15 = [
    (0, $daf36e5327a667f7$export$2e2bcd8739ae039),
    (0, $a55c2a27ed41a507$export$2e2bcd8739ae039),
    (0, $8c2be31605c6b3f3$export$2e2bcd8739ae039),
    (0, $de7e81ea70dff8c7$export$2e2bcd8739ae039),
    (0, $d843e25a96df88c2$export$2e2bcd8739ae039),
    (0, $2cb8338e5d4f0754$export$2e2bcd8739ae039),
    (0, $cb4792015df5b244$export$2e2bcd8739ae039)
];
const $54c490958243a65a$export$915e06de6acf8fe = [
    (0, $daf36e5327a667f7$export$2e2bcd8739ae039),
    (0, $5e363d036e5a20af$export$2e2bcd8739ae039),
    (0, $1cf00929721e1f48$export$2e2bcd8739ae039),
    (0, $2e6bfbcb1095bfea$export$2e2bcd8739ae039),
    (0, $7a7f57c2d42a8241$export$2e2bcd8739ae039),
    (0, $7ebf2d627d0854a7$export$2e2bcd8739ae039),
    (0, $d85cd34370d2c7eb$export$2e2bcd8739ae039)
];
function $54c490958243a65a$export$2e2bcd8739ae039(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(type || (0, $daf36e5327a667f7$export$2e2bcd8739ae039));
    size = typeof size === "function" ? size : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, $fef862baa9a89322$export$2e2bcd8739ae039)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, $5c5e96e92443e707$export$2e2bcd8739ae039)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}



var $iyeK6 = parcelRequire("iyeK6");

function $3073a288329acf48$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $3073a288329acf48$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $3073a288329acf48$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $3073a288329acf48$var$_typeof(obj);
}
function $3073a288329acf48$var$_extends() {
    $3073a288329acf48$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $3073a288329acf48$var$_extends.apply(this, arguments);
}
function $3073a288329acf48$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $3073a288329acf48$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $3073a288329acf48$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $3073a288329acf48$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $3073a288329acf48$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $3073a288329acf48$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $3073a288329acf48$var$_setPrototypeOf(subClass, superClass);
}
function $3073a288329acf48$var$_setPrototypeOf(o, p) {
    $3073a288329acf48$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $3073a288329acf48$var$_setPrototypeOf(o, p);
}
function $3073a288329acf48$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $3073a288329acf48$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $3073a288329acf48$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $3073a288329acf48$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $3073a288329acf48$var$_possibleConstructorReturn(this, result);
    };
}
function $3073a288329acf48$var$_possibleConstructorReturn(self, call) {
    if (call && ($3073a288329acf48$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $3073a288329acf48$var$_assertThisInitialized(self);
}
function $3073a288329acf48$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $3073a288329acf48$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $3073a288329acf48$var$_getPrototypeOf(o) {
    $3073a288329acf48$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $3073a288329acf48$var$_getPrototypeOf(o);
}
var $3073a288329acf48$var$symbolFactories = {
    symbolCircle: (0, $daf36e5327a667f7$export$2e2bcd8739ae039),
    symbolCross: (0, $a55c2a27ed41a507$export$2e2bcd8739ae039),
    symbolDiamond: (0, $8c2be31605c6b3f3$export$2e2bcd8739ae039),
    symbolSquare: (0, $de7e81ea70dff8c7$export$2e2bcd8739ae039),
    symbolStar: (0, $d843e25a96df88c2$export$2e2bcd8739ae039),
    symbolTriangle: (0, $2cb8338e5d4f0754$export$2e2bcd8739ae039),
    symbolWye: (0, $cb4792015df5b244$export$2e2bcd8739ae039)
};
var $3073a288329acf48$var$RADIAN = Math.PI / 180;
var $3073a288329acf48$var$getSymbolFactory = function getSymbolFactory(type) {
    var name = "symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($bace4a80b17174f2$exports)))(type));
    return $3073a288329acf48$var$symbolFactories[name] || (0, $daf36e5327a667f7$export$2e2bcd8739ae039);
};
var $3073a288329acf48$var$calculateAreaSize = function calculateAreaSize(size, sizeType, type) {
    if (sizeType === "area") return size;
    switch(type){
        case "cross":
            return 5 * size * size / 9;
        case "diamond":
            return 0.5 * size * size / Math.sqrt(3);
        case "square":
            return size * size;
        case "star":
            var angle = 18 * $3073a288329acf48$var$RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.pow(Math.tan(angle), 2));
        case "triangle":
            return Math.sqrt(3) * size * size / 4;
        case "wye":
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var $3073a288329acf48$export$fa456266707bf4e4 = /*#__PURE__*/ function(_PureComponent) {
    $3073a288329acf48$var$_inherits(Symbols, _PureComponent);
    var _super = $3073a288329acf48$var$_createSuper(Symbols);
    function Symbols() {
        $3073a288329acf48$var$_classCallCheck(this, Symbols);
        return _super.apply(this, arguments);
    }
    $3073a288329acf48$var$_createClass(Symbols, [
        {
            key: "getPath",
            value: /**
     * Calculate the path of curve
     * @return {String} path
     */ function getPath() {
                var _this$props = this.props, size = _this$props.size, sizeType = _this$props.sizeType, type = _this$props.type;
                var symbolFactory = $3073a288329acf48$var$getSymbolFactory(type);
                var symbol = (0, $54c490958243a65a$export$2e2bcd8739ae039)().type(symbolFactory).size($3073a288329acf48$var$calculateAreaSize(size, sizeType, type));
                return symbol();
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, className = _this$props2.className, cx = _this$props2.cx, cy = _this$props2.cy, size = _this$props2.size;
                if (cx === +cx && cy === +cy && size === +size) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $3073a288329acf48$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props, true), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-symbols", className),
                    transform: "translate(".concat(cx, ", ").concat(cy, ")"),
                    d: this.getPath()
                }));
                return null;
            }
        }
    ]);
    return Symbols;
}((0, $eCoWV.PureComponent));
$3073a288329acf48$export$fa456266707bf4e4.defaultProps = {
    type: "circle",
    size: 64,
    sizeType: "area"
};
$3073a288329acf48$export$fa456266707bf4e4.registerSymbol = function(key, factory) {
    $3073a288329acf48$var$symbolFactories["symbol".concat((0, (/*@__PURE__*/$parcel$interopDefault($bace4a80b17174f2$exports)))(key))] = factory;
};



function $d63b3ad664b64d2e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $d63b3ad664b64d2e$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $d63b3ad664b64d2e$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $d63b3ad664b64d2e$var$_typeof(obj);
}
function $d63b3ad664b64d2e$var$_extends() {
    $d63b3ad664b64d2e$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $d63b3ad664b64d2e$var$_extends.apply(this, arguments);
}
function $d63b3ad664b64d2e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d63b3ad664b64d2e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d63b3ad664b64d2e$var$ownKeys(Object(source), true).forEach(function(key) {
            $d63b3ad664b64d2e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d63b3ad664b64d2e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d63b3ad664b64d2e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d63b3ad664b64d2e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $d63b3ad664b64d2e$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $d63b3ad664b64d2e$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $d63b3ad664b64d2e$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $d63b3ad664b64d2e$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $d63b3ad664b64d2e$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $d63b3ad664b64d2e$var$_setPrototypeOf(subClass, superClass);
}
function $d63b3ad664b64d2e$var$_setPrototypeOf(o, p) {
    $d63b3ad664b64d2e$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $d63b3ad664b64d2e$var$_setPrototypeOf(o, p);
}
function $d63b3ad664b64d2e$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $d63b3ad664b64d2e$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $d63b3ad664b64d2e$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $d63b3ad664b64d2e$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $d63b3ad664b64d2e$var$_possibleConstructorReturn(this, result);
    };
}
function $d63b3ad664b64d2e$var$_possibleConstructorReturn(self, call) {
    if (call && ($d63b3ad664b64d2e$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $d63b3ad664b64d2e$var$_assertThisInitialized(self);
}
function $d63b3ad664b64d2e$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $d63b3ad664b64d2e$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $d63b3ad664b64d2e$var$_getPrototypeOf(o) {
    $d63b3ad664b64d2e$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $d63b3ad664b64d2e$var$_getPrototypeOf(o);
}
var $d63b3ad664b64d2e$var$SIZE = 32;
var $d63b3ad664b64d2e$export$99f8d96ed0cededa = /*#__PURE__*/ function(_PureComponent) {
    $d63b3ad664b64d2e$var$_inherits(DefaultLegendContent, _PureComponent);
    var _super = $d63b3ad664b64d2e$var$_createSuper(DefaultLegendContent);
    function DefaultLegendContent() {
        $d63b3ad664b64d2e$var$_classCallCheck(this, DefaultLegendContent);
        return _super.apply(this, arguments);
    }
    $d63b3ad664b64d2e$var$_createClass(DefaultLegendContent, [
        {
            key: "renderIcon",
            value: /**
     * Render the path of icon
     * @param {Object} data Data of each legend item
     * @return {String} Path element
     */ function renderIcon(data) {
                var inactiveColor = this.props.inactiveColor;
                var halfSize = $d63b3ad664b64d2e$var$SIZE / 2;
                var sixthSize = $d63b3ad664b64d2e$var$SIZE / 6;
                var thirdSize = $d63b3ad664b64d2e$var$SIZE / 3;
                var color = data.inactive ? inactiveColor : data.color;
                if (data.type === "plainline") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    strokeDasharray: data.payload.strokeDasharray,
                    x1: 0,
                    y1: halfSize,
                    x2: $d63b3ad664b64d2e$var$SIZE,
                    y2: halfSize,
                    className: "recharts-legend-icon"
                });
                if (data.type === "line") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", {
                    strokeWidth: 4,
                    fill: "none",
                    stroke: color,
                    d: "M0,".concat(halfSize, "h").concat(thirdSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(2 * thirdSize, ",").concat(halfSize, "\n            H").concat($d63b3ad664b64d2e$var$SIZE, "M").concat(2 * thirdSize, ",").concat(halfSize, "\n            A").concat(sixthSize, ",").concat(sixthSize, ",0,1,1,").concat(thirdSize, ",").concat(halfSize),
                    className: "recharts-legend-icon"
                });
                if (data.type === "rect") return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", {
                    stroke: "none",
                    fill: color,
                    d: "M0,".concat($d63b3ad664b64d2e$var$SIZE / 8, "h").concat($d63b3ad664b64d2e$var$SIZE, "v").concat($d63b3ad664b64d2e$var$SIZE * 3 / 4, "h").concat(-$d63b3ad664b64d2e$var$SIZE, "z"),
                    className: "recharts-legend-icon"
                });
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(data.legendIcon)) {
                    var iconProps = $d63b3ad664b64d2e$var$_objectSpread({}, data);
                    delete iconProps.legendIcon;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(data.legendIcon, iconProps);
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $3073a288329acf48$export$fa456266707bf4e4), {
                    fill: color,
                    cx: halfSize,
                    cy: halfSize,
                    size: $d63b3ad664b64d2e$var$SIZE,
                    sizeType: "diameter",
                    type: data.type
                });
            }
        },
        {
            key: "renderItems",
            value: function renderItems() {
                var _this = this;
                var _this$props = this.props, payload = _this$props.payload, iconSize = _this$props.iconSize, layout = _this$props.layout, formatter = _this$props.formatter, inactiveColor = _this$props.inactiveColor;
                var viewBox = {
                    x: 0,
                    y: 0,
                    width: $d63b3ad664b64d2e$var$SIZE,
                    height: $d63b3ad664b64d2e$var$SIZE
                };
                var itemStyle = {
                    display: layout === "horizontal" ? "inline-block" : "block",
                    marginRight: 10
                };
                var svgStyle = {
                    display: "inline-block",
                    verticalAlign: "middle",
                    marginRight: 4
                };
                return payload.map(function(entry, i) {
                    var _classNames;
                    var finalFormatter = entry.formatter || formatter;
                    var className = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))((_classNames = {
                        "recharts-legend-item": true
                    }, $d63b3ad664b64d2e$var$_defineProperty(_classNames, "legend-item-".concat(i), true), $d63b3ad664b64d2e$var$_defineProperty(_classNames, "inactive", entry.inactive), _classNames));
                    if (entry.type === "none") return null;
                    var color = entry.inactive ? inactiveColor : entry.color;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("li", $d63b3ad664b64d2e$var$_extends({
                        className: className,
                        style: itemStyle,
                        key: "legend-item-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $dd873d09408694ab$export$ca62be0d67a3158c)(_this.props, entry, i)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $97e02d2bb4391b31$export$7b92b459e668cb21), {
                        width: iconSize,
                        height: iconSize,
                        viewBox: viewBox,
                        style: svgStyle
                    }, _this.renderIcon(entry)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
                        className: "recharts-legend-item-text",
                        style: {
                            color: color
                        }
                    }, finalFormatter ? finalFormatter(entry.value, entry, i) : entry.value));
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, payload = _this$props2.payload, layout = _this$props2.layout, align = _this$props2.align;
                if (!payload || !payload.length) return null;
                var finalStyle = {
                    padding: 0,
                    margin: 0,
                    textAlign: layout === "horizontal" ? align : "left"
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("ul", {
                    className: "recharts-default-legend",
                    style: finalStyle
                }, this.renderItems());
            }
        }
    ]);
    return DefaultLegendContent;
}((0, $eCoWV.PureComponent));
$d63b3ad664b64d2e$export$99f8d96ed0cededa.displayName = "Legend";
$d63b3ad664b64d2e$export$99f8d96ed0cededa.defaultProps = {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "middle",
    inactiveColor: "#ccc"
};



function $30a7618641b2544d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $30a7618641b2544d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $30a7618641b2544d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $30a7618641b2544d$var$_typeof(obj);
}
function $30a7618641b2544d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $30a7618641b2544d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $30a7618641b2544d$var$ownKeys(Object(source), true).forEach(function(key) {
            $30a7618641b2544d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $30a7618641b2544d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $30a7618641b2544d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $30a7618641b2544d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $30a7618641b2544d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $30a7618641b2544d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $30a7618641b2544d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $30a7618641b2544d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $30a7618641b2544d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $30a7618641b2544d$var$_setPrototypeOf(subClass, superClass);
}
function $30a7618641b2544d$var$_setPrototypeOf(o, p) {
    $30a7618641b2544d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $30a7618641b2544d$var$_setPrototypeOf(o, p);
}
function $30a7618641b2544d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $30a7618641b2544d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $30a7618641b2544d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $30a7618641b2544d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $30a7618641b2544d$var$_possibleConstructorReturn(this, result);
    };
}
function $30a7618641b2544d$var$_possibleConstructorReturn(self, call) {
    if (call && ($30a7618641b2544d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $30a7618641b2544d$var$_assertThisInitialized(self);
}
function $30a7618641b2544d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $30a7618641b2544d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $30a7618641b2544d$var$_getPrototypeOf(o) {
    $30a7618641b2544d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $30a7618641b2544d$var$_getPrototypeOf(o);
}
function $30a7618641b2544d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $30a7618641b2544d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $30a7618641b2544d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $30a7618641b2544d$var$defaultUniqBy(entry) {
    return entry.value;
}
function $30a7618641b2544d$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($3cd389e91472e4cd$exports)))(payload, $30a7618641b2544d$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($3cd389e91472e4cd$exports)))(payload, option);
    return payload;
}
function $30a7618641b2544d$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(content, props);
    var ref = props.ref, otherProps = $30a7618641b2544d$var$_objectWithoutProperties(props, [
        "ref"
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d63b3ad664b64d2e$export$99f8d96ed0cededa), otherProps);
}
var $30a7618641b2544d$var$EPS = 1;
var $30a7618641b2544d$export$ed247974535929c7 = /*#__PURE__*/ function(_PureComponent) {
    $30a7618641b2544d$var$_inherits(Legend, _PureComponent);
    var _super = $30a7618641b2544d$var$_createSuper(Legend);
    function Legend() {
        var _this;
        $30a7618641b2544d$var$_classCallCheck(this, Legend);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.wrapperNode = void 0;
        _this.state = {
            boxWidth: -1,
            boxHeight: -1
        };
        return _this;
    }
    $30a7618641b2544d$var$_createClass(Legend, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "getBBox",
            value: function getBBox() {
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) return this.wrapperNode.getBoundingClientRect();
                return null;
            }
        },
        {
            key: "getBBoxSnapshot",
            value: function getBBoxSnapshot() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight;
                if (boxWidth >= 0 && boxHeight >= 0) return {
                    width: boxWidth,
                    height: boxHeight
                };
                return null;
            }
        },
        {
            key: "getDefaultPosition",
            value: function getDefaultPosition(style) {
                var _this$props = this.props, layout = _this$props.layout, align = _this$props.align, verticalAlign = _this$props.verticalAlign, margin = _this$props.margin, chartWidth = _this$props.chartWidth, chartHeight = _this$props.chartHeight;
                var hPos, vPos;
                if (!style || (style.left === undefined || style.left === null) && (style.right === undefined || style.right === null)) {
                    if (align === "center" && layout === "vertical") {
                        var _box = this.getBBoxSnapshot() || {
                            width: 0
                        };
                        hPos = {
                            left: ((chartWidth || 0) - _box.width) / 2
                        };
                    } else hPos = align === "right" ? {
                        right: margin && margin.right || 0
                    } : {
                        left: margin && margin.left || 0
                    };
                }
                if (!style || (style.top === undefined || style.top === null) && (style.bottom === undefined || style.bottom === null)) {
                    if (verticalAlign === "middle") {
                        var _box2 = this.getBBoxSnapshot() || {
                            height: 0
                        };
                        vPos = {
                            top: ((chartHeight || 0) - _box2.height) / 2
                        };
                    } else vPos = verticalAlign === "bottom" ? {
                        bottom: margin && margin.bottom || 0
                    } : {
                        top: margin && margin.top || 0
                    };
                }
                return $30a7618641b2544d$var$_objectSpread($30a7618641b2544d$var$_objectSpread({}, hPos), vPos);
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                var onBBoxUpdate = this.props.onBBoxUpdate;
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var _box3 = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(_box3.width - boxWidth) > $30a7618641b2544d$var$EPS || Math.abs(_box3.height - boxHeight) > $30a7618641b2544d$var$EPS) this.setState({
                        boxWidth: _box3.width,
                        boxHeight: _box3.height
                    }, function() {
                        if (onBBoxUpdate) onBBoxUpdate(_box3);
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                }, function() {
                    if (onBBoxUpdate) onBBoxUpdate(null);
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props2 = this.props, content = _this$props2.content, width = _this$props2.width, height = _this$props2.height, wrapperStyle = _this$props2.wrapperStyle, payloadUniqBy = _this$props2.payloadUniqBy, payload = _this$props2.payload;
                var outerStyle = $30a7618641b2544d$var$_objectSpread($30a7618641b2544d$var$_objectSpread({
                    position: "absolute",
                    width: width || "auto",
                    height: height || "auto"
                }, this.getDefaultPosition(wrapperStyle)), wrapperStyle);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    className: "recharts-legend-wrapper",
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $30a7618641b2544d$var$renderContent(content, $30a7618641b2544d$var$_objectSpread($30a7618641b2544d$var$_objectSpread({}, this.props), {}, {
                    payload: $30a7618641b2544d$var$getUniqPayload(payloadUniqBy, payload)
                })));
            }
        }
    ], [
        {
            key: "getWithHeight",
            value: function getWithHeight(item, chartWidth) {
                var layout = item.props.layout;
                if (layout === "vertical" && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(item.props.height)) return {
                    height: item.props.height
                };
                if (layout === "horizontal") return {
                    width: item.props.width || chartWidth
                };
                return null;
            }
        }
    ]);
    return Legend;
}((0, $eCoWV.PureComponent));
$30a7618641b2544d$export$ed247974535929c7.displayName = "Legend";
$30a7618641b2544d$export$ed247974535929c7.defaultProps = {
    iconSize: 14,
    layout: "horizontal",
    align: "center",
    verticalAlign: "bottom"
};




function $ce9b7262abb43277$var$_toConsumableArray(arr) {
    return $ce9b7262abb43277$var$_arrayWithoutHoles(arr) || $ce9b7262abb43277$var$_iterableToArray(arr) || $ce9b7262abb43277$var$_unsupportedIterableToArray(arr) || $ce9b7262abb43277$var$_nonIterableSpread();
}
function $ce9b7262abb43277$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ce9b7262abb43277$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ce9b7262abb43277$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ce9b7262abb43277$var$_arrayLikeToArray(o, minLen);
}
function $ce9b7262abb43277$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $ce9b7262abb43277$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $ce9b7262abb43277$var$_arrayLikeToArray(arr);
}
function $ce9b7262abb43277$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ce9b7262abb43277$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $ce9b7262abb43277$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $ce9b7262abb43277$var$ownKeys(Object(source), true).forEach(function(key) {
            $ce9b7262abb43277$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $ce9b7262abb43277$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $ce9b7262abb43277$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $ce9b7262abb43277$export$f97fc4a450f29a(obj, dataKey, defaultValue) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(dataKey)) return defaultValue;
    if ((0, $a4d9ec64928c627b$export$402a499e1ea44294)(dataKey)) return (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(obj, dataKey, defaultValue);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(dataKey)) return dataKey(obj);
    return defaultValue;
}
function $ce9b7262abb43277$export$6a1e7873444c95a7(data, key, type, filterNil) {
    var flattenData = (0, (/*@__PURE__*/$parcel$interopDefault($2b47cc84fc9a16c2$exports)))(data, function(entry) {
        return $ce9b7262abb43277$export$f97fc4a450f29a(entry, key);
    });
    if (type === "number") {
        var domain = flattenData.filter(function(entry) {
            return (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(entry) || parseFloat(entry);
        });
        return domain.length ? [
            (0, (/*@__PURE__*/$parcel$interopDefault($35f6cdeacb5f1b1b$exports)))(domain),
            (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(domain)
        ] : [
            Infinity,
            -Infinity
        ];
    }
    var validateData = filterNil ? flattenData.filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry);
    }) : flattenData; // 支持Date类型的x轴
    return validateData.map(function(entry) {
        return (0, $a4d9ec64928c627b$export$402a499e1ea44294)(entry) || entry instanceof Date ? entry : "";
    });
}
var $ce9b7262abb43277$export$3071d39cc844078e = function calculateActiveTickIndex(coordinate) {
    var _ticks$length;
    var ticks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var unsortedTicks = arguments.length > 2 ? arguments[2] : undefined;
    var axis = arguments.length > 3 ? arguments[3] : undefined;
    var index = -1;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    if (len > 1) {
        if (axis && axis.axisType === "angleAxis" && Math.abs(Math.abs(axis.range[1] - axis.range[0]) - 360) <= 1e-6) {
            var range = axis.range; // ticks are distributed in a circle
            for(var i = 0; i < len; i++){
                var before = i > 0 ? unsortedTicks[i - 1].coordinate : unsortedTicks[len - 1].coordinate;
                var cur = unsortedTicks[i].coordinate;
                var after = i >= len - 1 ? unsortedTicks[0].coordinate : unsortedTicks[i + 1].coordinate;
                var sameDirectionCoord = void 0;
                if ((0, $a4d9ec64928c627b$export$9d334328eb75e624)(cur - before) !== (0, $a4d9ec64928c627b$export$9d334328eb75e624)(after - cur)) {
                    var diffInterval = [];
                    if ((0, $a4d9ec64928c627b$export$9d334328eb75e624)(after - cur) === (0, $a4d9ec64928c627b$export$9d334328eb75e624)(range[1] - range[0])) {
                        sameDirectionCoord = after;
                        var curInRange = cur + range[1] - range[0];
                        diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                        diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
                    } else {
                        sameDirectionCoord = before;
                        var afterInRange = after + range[1] - range[0];
                        diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                        diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
                    }
                    var sameInterval = [
                        Math.min(cur, (sameDirectionCoord + cur) / 2),
                        Math.max(cur, (sameDirectionCoord + cur) / 2)
                    ];
                    if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                        index = unsortedTicks[i].index;
                        break;
                    }
                } else {
                    var min = Math.min(before, after);
                    var max = Math.max(before, after);
                    if (coordinate > (min + cur) / 2 && coordinate <= (max + cur) / 2) {
                        index = unsortedTicks[i].index;
                        break;
                    }
                }
            }
        } else {
            // ticks are distributed in a single direction
            for(var _i = 0; _i < len; _i++)if (_i === 0 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i > 0 && _i < len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2 && coordinate <= (ticks[_i].coordinate + ticks[_i + 1].coordinate) / 2 || _i === len - 1 && coordinate > (ticks[_i].coordinate + ticks[_i - 1].coordinate) / 2) {
                index = ticks[_i].index;
                break;
            }
        }
    } else index = 0;
    return index;
};
var $ce9b7262abb43277$export$ec6cab5a7a3b93bf = function getMainColorOfGraphicItem(item) {
    var _ref = item, displayName = _ref.type.displayName; // TODO: check if displayName is valid.
    var _item$props = item.props, stroke = _item$props.stroke, fill = _item$props.fill;
    var result;
    switch(displayName){
        case "Line":
            result = stroke;
            break;
        case "Area":
        case "Radar":
            result = stroke && stroke !== "none" ? stroke : fill;
            break;
        default:
            result = fill;
            break;
    }
    return result;
};
var $ce9b7262abb43277$export$8f9424d123c36aa = function getLegendProps(_ref2) {
    var children = _ref2.children, formattedGraphicalItems = _ref2.formattedGraphicalItems, legendWidth = _ref2.legendWidth, legendContent = _ref2.legendContent;
    var legendItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $30a7618641b2544d$export$ed247974535929c7).displayName);
    if (!legendItem) return null;
    var legendData;
    if (legendItem.props && legendItem.props.payload) legendData = legendItem.props && legendItem.props.payload;
    else if (legendContent === "children") legendData = (formattedGraphicalItems || []).reduce(function(result, _ref3) {
        var item = _ref3.item, props = _ref3.props;
        var data = props.sectors || props.data || [];
        return result.concat(data.map(function(entry) {
            return {
                type: legendItem.props.iconType || item.props.legendType,
                value: entry.name,
                color: entry.fill,
                payload: entry
            };
        }));
    }, []);
    else legendData = (formattedGraphicalItems || []).map(function(_ref4) {
        var item = _ref4.item;
        var _item$props2 = item.props, dataKey = _item$props2.dataKey, name = _item$props2.name, legendType = _item$props2.legendType, hide = _item$props2.hide;
        return {
            inactive: hide,
            dataKey: dataKey,
            type: legendItem.props.iconType || legendType || "square",
            color: $ce9b7262abb43277$export$ec6cab5a7a3b93bf(item),
            value: name || dataKey,
            payload: item.props
        };
    });
    return $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, legendItem.props), (0, $30a7618641b2544d$export$ed247974535929c7).getWithHeight(legendItem, legendWidth)), {}, {
        payload: legendData,
        item: legendItem
    });
};
var $ce9b7262abb43277$export$570d306bee26c748 = function getBarSizeList(_ref5) {
    var globalSize = _ref5.barSize, _ref5$stackGroups = _ref5.stackGroups, stackGroups = _ref5$stackGroups === void 0 ? {} : _ref5$stackGroups;
    if (!stackGroups) return {};
    var result = {};
    var numericAxisIds = Object.keys(stackGroups);
    for(var i = 0, len = numericAxisIds.length; i < len; i++){
        var sgs = stackGroups[numericAxisIds[i]].stackGroups;
        var stackIds = Object.keys(sgs);
        for(var j = 0, sLen = stackIds.length; j < sLen; j++){
            var _sgs$stackIds$j = sgs[stackIds[j]], items = _sgs$stackIds$j.items, cateAxisId = _sgs$stackIds$j.cateAxisId;
            var barItems = items.filter(function(item) {
                return (0, $ffd74d03487febd9$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            });
            if (barItems && barItems.length) {
                var selfSize = barItems[0].props.barSize;
                var cateId = barItems[0].props[cateAxisId];
                if (!result[cateId]) result[cateId] = [];
                result[cateId].push({
                    item: barItems[0],
                    stackList: barItems.slice(1),
                    barSize: (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(selfSize) ? globalSize : selfSize
                });
            }
        }
    }
    return result;
};
var $ce9b7262abb43277$export$d36834ecd87f906b = function getBarPosition(_ref6) {
    var barGap = _ref6.barGap, barCategoryGap = _ref6.barCategoryGap, bandSize = _ref6.bandSize, _ref6$sizeList = _ref6.sizeList, sizeList = _ref6$sizeList === void 0 ? [] : _ref6$sizeList, maxBarSize = _ref6.maxBarSize;
    var len = sizeList.length;
    if (len < 1) return null;
    var realBarGap = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(barGap, bandSize, 0, true);
    var result; // whether or not is barSize setted by user
    if (sizeList[0].barSize === +sizeList[0].barSize) {
        var useFull = false;
        var fullBarSize = bandSize / len;
        var sum = sizeList.reduce(function(res, entry) {
            return res + entry.barSize || 0;
        }, 0);
        sum += (len - 1) * realBarGap;
        if (sum >= bandSize) {
            sum -= (len - 1) * realBarGap;
            realBarGap = 0;
        }
        if (sum >= bandSize && fullBarSize > 0) {
            useFull = true;
            fullBarSize *= 0.9;
            sum = len * fullBarSize;
        }
        var offset = (bandSize - sum) / 2 >> 0;
        var prev = {
            offset: offset - realBarGap,
            size: 0
        };
        result = sizeList.reduce(function(res, entry) {
            var newRes = [].concat($ce9b7262abb43277$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: prev.offset + prev.size + realBarGap,
                        size: useFull ? fullBarSize : entry.barSize
                    }
                }
            ]);
            prev = newRes[newRes.length - 1].position;
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: prev
                });
            });
            return newRes;
        }, []);
    } else {
        var _offset = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(barCategoryGap, bandSize, 0, true);
        if (bandSize - 2 * _offset - (len - 1) * realBarGap <= 0) realBarGap = 0;
        var originalSize = (bandSize - 2 * _offset - (len - 1) * realBarGap) / len;
        if (originalSize > 1) originalSize >>= 0;
        var size = maxBarSize === +maxBarSize ? Math.min(originalSize, maxBarSize) : originalSize;
        result = sizeList.reduce(function(res, entry, i) {
            var newRes = [].concat($ce9b7262abb43277$var$_toConsumableArray(res), [
                {
                    item: entry.item,
                    position: {
                        offset: _offset + (originalSize + realBarGap) * i + (originalSize - size) / 2,
                        size: size
                    }
                }
            ]);
            if (entry.stackList && entry.stackList.length) entry.stackList.forEach(function(item) {
                newRes.push({
                    item: item,
                    position: newRes[newRes.length - 1].position
                });
            });
            return newRes;
        }, []);
    }
    return result;
};
var $ce9b7262abb43277$export$3a657a8c9f789617 = function appendOffsetOfLegend(offset, items, props, legendBox) {
    var children = props.children, width = props.width, margin = props.margin;
    var legendWidth = width - (margin.left || 0) - (margin.right || 0); // const legendHeight = height - (margin.top || 0) - (margin.bottom || 0);
    var legendProps = $ce9b7262abb43277$export$8f9424d123c36aa({
        children: children,
        legendWidth: legendWidth
    });
    var newOffset = offset;
    if (legendProps) {
        var box = legendBox || {};
        var align = legendProps.align, verticalAlign = legendProps.verticalAlign, layout = legendProps.layout;
        if ((layout === "vertical" || layout === "horizontal" && verticalAlign === "center") && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(offset[align])) newOffset = $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, offset), {}, $ce9b7262abb43277$var$_defineProperty({}, align, newOffset[align] + (box.width || 0)));
        if ((layout === "horizontal" || layout === "vertical" && align === "center") && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(offset[verticalAlign])) newOffset = $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, offset), {}, $ce9b7262abb43277$var$_defineProperty({}, verticalAlign, newOffset[verticalAlign] + (box.height || 0)));
    }
    return newOffset;
};
var $ce9b7262abb43277$var$isErrorBarRelevantForAxis = function isErrorBarRelevantForAxis(layout, axisType, direction) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(axisType)) return true;
    if (layout === "horizontal") return axisType === "yAxis";
    if (layout === "vertical") return axisType === "xAxis";
    if (direction === "x") return axisType === "xAxis";
    if (direction === "y") return axisType === "yAxis";
    return true;
};
var $ce9b7262abb43277$export$8a46d1a2b0f8e61a = function getDomainOfErrorBars(data, item, dataKey, layout, axisType) {
    var children = item.props.children;
    var errorBars = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, "ErrorBar").filter(function(errorBarChild) {
        return $ce9b7262abb43277$var$isErrorBarRelevantForAxis(layout, axisType, errorBarChild.props.direction);
    });
    if (errorBars && errorBars.length) {
        var keys = errorBars.map(function(errorBarChild) {
            return errorBarChild.props.dataKey;
        });
        return data.reduce(function(result, entry) {
            var entryValue = $ce9b7262abb43277$export$f97fc4a450f29a(entry, dataKey, 0);
            var mainValue = (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(entryValue) ? [
                (0, (/*@__PURE__*/$parcel$interopDefault($35f6cdeacb5f1b1b$exports)))(entryValue),
                (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(entryValue)
            ] : [
                entryValue,
                entryValue
            ];
            var errorDomain = keys.reduce(function(prevErrorArr, k) {
                var errorValue = $ce9b7262abb43277$export$f97fc4a450f29a(entry, k, 0);
                var lowerValue = mainValue[0] - Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(errorValue) ? errorValue[0] : errorValue);
                var upperValue = mainValue[1] + Math.abs((0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(errorValue) ? errorValue[1] : errorValue);
                return [
                    Math.min(lowerValue, prevErrorArr[0]),
                    Math.max(upperValue, prevErrorArr[1])
                ];
            }, [
                Infinity,
                -Infinity
            ]);
            return [
                Math.min(errorDomain[0], result[0]),
                Math.max(errorDomain[1], result[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
    }
    return null;
};
var $ce9b7262abb43277$export$2266342e22c737e8 = function parseErrorBarsOfAxis(data, items, dataKey, axisType, layout) {
    var domains = items.map(function(item) {
        return $ce9b7262abb43277$export$8a46d1a2b0f8e61a(data, item, dataKey, layout, axisType);
    }).filter(function(entry) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry);
    });
    if (domains && domains.length) return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    return null;
};
var $ce9b7262abb43277$export$c92c4f4286b1390d = function getDomainOfItemsWithSameAxis(data, items, type, layout, filterNil) {
    var domains = items.map(function(item) {
        var dataKey = item.props.dataKey;
        if (type === "number" && dataKey) return $ce9b7262abb43277$export$8a46d1a2b0f8e61a(data, item, dataKey, layout) || $ce9b7262abb43277$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
        return $ce9b7262abb43277$export$6a1e7873444c95a7(data, dataKey, type, filterNil);
    });
    if (type === "number") // Calculate the domain of number axis
    return domains.reduce(function(result, entry) {
        return [
            Math.min(result[0], entry[0]),
            Math.max(result[1], entry[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]);
    var tag = {}; // Get the union set of category axis
    return domains.reduce(function(result, entry) {
        for(var i = 0, len = entry.length; i < len; i++)if (!tag[entry[i]]) {
            tag[entry[i]] = true;
            result.push(entry[i]);
        }
        return result;
    }, []);
};
var $ce9b7262abb43277$export$9fc1baaa6c6368b = function isCategoricalAxis(layout, axisType) {
    return layout === "horizontal" && axisType === "xAxis" || layout === "vertical" && axisType === "yAxis" || layout === "centric" && axisType === "angleAxis" || layout === "radial" && axisType === "radiusAxis";
};
var $ce9b7262abb43277$export$846dc5ac5fecff74 = function getCoordinatesOfGrid(ticks, min, max) {
    var hasMin, hasMax;
    var values = ticks.map(function(entry) {
        if (entry.coordinate === min) hasMin = true;
        if (entry.coordinate === max) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(min);
    if (!hasMax) values.push(max);
    return values;
};
var $ce9b7262abb43277$export$c829ee42daf7f66d = function getTicksOfAxis(axis, isGrid, isAll) {
    if (!axis) return null;
    var scale = axis.scale;
    var duplicateDomain = axis.duplicateDomain, type = axis.type, range = axis.range;
    var offsetForBand = axis.realScaleType === "scaleBand" ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === "category" && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axis.axisType === "angleAxis" ? (0, $a4d9ec64928c627b$export$9d334328eb75e624)(range[0] - range[1]) * 2 * offset : offset; // The ticks setted by user should only affect the ticks adjacent to axis line
    if (isGrid && (axis.ticks || axis.niceTicks)) return (axis.ticks || axis.niceTicks).map(function(entry) {
        var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
        return {
            coordinate: scale(scaleContent) + offset,
            value: entry,
            offset: offset
        };
    });
     // When axis is a categorial axis, but the type of axis is number or the scale of axis is not "auto"
    if (axis.isCategorical && axis.categoricalDomain) return axis.categoricalDomain.map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            index: index,
            offset: offset
        };
    });
    if (scale.ticks && !isAll) return scale.ticks(axis.tickCount).map(function(entry) {
        return {
            coordinate: scale(entry) + offset,
            value: entry,
            offset: offset
        };
    });
     // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map(function(entry, index) {
        return {
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index: index,
            offset: offset
        };
    });
};
var $ce9b7262abb43277$export$760ec406ba47bace = function combineEventHandlers(defaultHandler, parentHandler, childHandler) {
    var customizedHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(childHandler)) customizedHandler = childHandler;
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(parentHandler)) customizedHandler = parentHandler;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(defaultHandler) || customizedHandler) return function(arg1, arg2, arg3, arg4) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(defaultHandler)) defaultHandler(arg1, arg2, arg3, arg4);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(customizedHandler)) customizedHandler(arg1, arg2, arg3, arg4);
    };
    return null;
};
var $ce9b7262abb43277$export$534b094a708572c1 = function parseScale(axis, chartType, hasBar) {
    var scale = axis.scale, type = axis.type, layout = axis.layout, axisType = axis.axisType;
    if (scale === "auto") {
        if (layout === "radial" && axisType === "radiusAxis") return {
            scale: $24ef65aa2cbd5704$exports.scaleBand(),
            realScaleType: "band"
        };
        if (layout === "radial" && axisType === "angleAxis") return {
            scale: $24ef65aa2cbd5704$exports.scaleLinear(),
            realScaleType: "linear"
        };
        if (type === "category" && chartType && (chartType.indexOf("LineChart") >= 0 || chartType.indexOf("AreaChart") >= 0 || chartType.indexOf("ComposedChart") >= 0 && !hasBar)) return {
            scale: $24ef65aa2cbd5704$exports.scalePoint(),
            realScaleType: "point"
        };
        if (type === "category") return {
            scale: $24ef65aa2cbd5704$exports.scaleBand(),
            realScaleType: "band"
        };
        return {
            scale: $24ef65aa2cbd5704$exports.scaleLinear(),
            realScaleType: "linear"
        };
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($58bed27071520d70$exports)))(scale)) {
        var name = "scale".concat((0, (/*@__PURE__*/$parcel$interopDefault($bace4a80b17174f2$exports)))(scale));
        return {
            scale: ($24ef65aa2cbd5704$exports[name] || $24ef65aa2cbd5704$exports.scalePoint)(),
            realScaleType: $24ef65aa2cbd5704$exports[name] ? name : "point"
        };
    }
    return (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(scale) ? {
        scale: scale
    } : {
        scale: $24ef65aa2cbd5704$exports.scalePoint(),
        realScaleType: "point"
    };
};
var $ce9b7262abb43277$var$EPS = 1e-4;
var $ce9b7262abb43277$export$9d80152e23bae434 = function checkDomainOfScale(scale) {
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var min = Math.min(range[0], range[1]) - $ce9b7262abb43277$var$EPS;
    var max = Math.max(range[0], range[1]) + $ce9b7262abb43277$var$EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < min || first > max || last < min || last > max) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var $ce9b7262abb43277$export$778e70011fdf4625 = function findPositionOfBar(barPosition, child) {
    if (!barPosition) return null;
    for(var i = 0, len = barPosition.length; i < len; i++){
        if (barPosition[i].item === child) return barPosition[i].position;
    }
    return null;
};
var $ce9b7262abb43277$export$c7ec0fa96d0c462e = function truncateByDomain(value, domain) {
    if (!domain || domain.length !== 2 || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(domain[0]) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(domain[1])) return value;
    var min = Math.min(domain[0], domain[1]);
    var max = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(value[0]) || value[0] < min) result[0] = min;
    if (!(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(value[1]) || value[1] > max) result[1] = max;
    if (result[0] > max) result[0] = max;
    if (result[1] < min) result[1] = min;
    return result;
};
var $ce9b7262abb43277$export$3104c513558164c1 = function offsetSign(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($aa7127c7503d27f5$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = negative;
                series[i][j][1] = negative + value;
                negative = series[i][j][1];
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $ce9b7262abb43277$export$9f2c6ead70935022 = function offsetPositive(series) {
    var n = series.length;
    if (n <= 0) return;
    for(var j = 0, m = series[0].length; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var value = (0, (/*@__PURE__*/$parcel$interopDefault($aa7127c7503d27f5$exports)))(series[i][j][1]) ? series[i][j][0] : series[i][j][1];
            /* eslint-disable prefer-destructuring */ if (value >= 0) {
                series[i][j][0] = positive;
                series[i][j][1] = positive + value;
                positive = series[i][j][1];
            } else {
                series[i][j][0] = 0;
                series[i][j][1] = 0;
            }
        /* eslint-enable prefer-destructuring */ }
    }
};
var $ce9b7262abb43277$var$STACK_OFFSET_MAP = {
    sign: $ce9b7262abb43277$export$3104c513558164c1,
    expand: (0, $ec0683d5684c1f76$export$2e2bcd8739ae039),
    none: (0, $e6f333c1b3a793a3$export$2e2bcd8739ae039),
    silhouette: (0, $5d161527b4283bb4$export$2e2bcd8739ae039),
    wiggle: (0, $27cafa74c89e581d$export$2e2bcd8739ae039),
    positive: $ce9b7262abb43277$export$9f2c6ead70935022
};
var $ce9b7262abb43277$export$c2170542cfc0177c = function getStackedData(data, stackItems, offsetType) {
    var dataKeys = stackItems.map(function(item) {
        return item.props.dataKey;
    });
    var stack = (0, $cb287d0d105c490e$export$2e2bcd8739ae039)().keys(dataKeys).value(function(d, key) {
        return +$ce9b7262abb43277$export$f97fc4a450f29a(d, key, 0);
    }).order((0, $785b58177a16c62e$export$2e2bcd8739ae039)).offset($ce9b7262abb43277$var$STACK_OFFSET_MAP[offsetType]);
    return stack(data);
};
var $ce9b7262abb43277$export$9af3ba56474b9601 = function getStackGroupsByAxisId(data, _items, numericAxisId, cateAxisId, offsetType, reverseStackOrder) {
    if (!data) return null;
     // reversing items to affect render order (for layering)
    var items = reverseStackOrder ? _items.reverse() : _items;
    var stackGroups = items.reduce(function(result, item) {
        var _item$props3 = item.props, stackId = _item$props3.stackId, hide = _item$props3.hide;
        if (hide) return result;
        var axisId = item.props[numericAxisId];
        var parentGroup = result[axisId] || {
            hasStack: false,
            stackGroups: {}
        };
        if ((0, $a4d9ec64928c627b$export$402a499e1ea44294)(stackId)) {
            var childGroup = parentGroup.stackGroups[stackId] || {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: []
            };
            childGroup.items.push(item);
            parentGroup.hasStack = true;
            parentGroup.stackGroups[stackId] = childGroup;
        } else parentGroup.stackGroups[(0, $a4d9ec64928c627b$export$8b15d37bc3f197d4)("_stackId_")] = {
            numericAxisId: numericAxisId,
            cateAxisId: cateAxisId,
            items: [
                item
            ]
        };
        return $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, result), {}, $ce9b7262abb43277$var$_defineProperty({}, axisId, parentGroup));
    }, {});
    return Object.keys(stackGroups).reduce(function(result, axisId) {
        var group = stackGroups[axisId];
        if (group.hasStack) group.stackGroups = Object.keys(group.stackGroups).reduce(function(res, stackId) {
            var g = group.stackGroups[stackId];
            return $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, res), {}, $ce9b7262abb43277$var$_defineProperty({}, stackId, {
                numericAxisId: numericAxisId,
                cateAxisId: cateAxisId,
                items: g.items,
                stackedData: $ce9b7262abb43277$export$c2170542cfc0177c(data, g.items, offsetType)
            }));
        }, {});
        return $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, result), {}, $ce9b7262abb43277$var$_defineProperty({}, axisId, group));
    }, {});
};
var $ce9b7262abb43277$export$ddbfea630ecc591e = function calculateDomainOfTicks(ticks, type) {
    if (type === "number") return [
        (0, (/*@__PURE__*/$parcel$interopDefault($35f6cdeacb5f1b1b$exports)))(ticks),
        (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(ticks)
    ];
    return ticks;
};
var $ce9b7262abb43277$export$ac086aaa4358d590 = function getTicksOfScale(scale, opts) {
    var realScaleType = opts.realScaleType, type = opts.type, tickCount = opts.tickCount, originalDomain = opts.originalDomain, allowDecimals = opts.allowDecimals;
    var scaleType = realScaleType || opts.scale;
    if (scaleType !== "auto" && scaleType !== "linear") return null;
    if (tickCount && type === "number" && originalDomain && (originalDomain[0] === "auto" || originalDomain[1] === "auto")) {
        // Calculate the ticks by the number of grid when the axis is a number axis
        var domain = scale.domain();
        if (!domain.length) return null;
        var tickValues = (0, $181c1401c1488530$export$b84e75ccbfe6a612)(domain, tickCount, allowDecimals);
        scale.domain($ce9b7262abb43277$export$ddbfea630ecc591e(tickValues, type));
        return {
            niceTicks: tickValues
        };
    }
    if (tickCount && type === "number") {
        var _domain = scale.domain();
        var _tickValues = (0, $181c1401c1488530$export$e9d28da780436e98)(_domain, tickCount, allowDecimals);
        return {
            niceTicks: _tickValues
        };
    }
    return null;
};
var $ce9b7262abb43277$export$6e87f3defb83c3f = function getCateCoordinateOfLine(_ref7) {
    var axis = _ref7.axis, ticks = _ref7.ticks, bandSize = _ref7.bandSize, entry = _ref7.entry, index = _ref7.index, dataKey = _ref7.dataKey;
    if (axis.type === "category") {
        // find coordinate of category axis by the value of category
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry[axis.dataKey])) {
            var matchedTick = (0, $a4d9ec64928c627b$export$66950d3869f5cc67)(ticks, "value", entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = $ce9b7262abb43277$export$f97fc4a450f29a(entry, !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(dataKey) ? dataKey : axis.dataKey);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(value) ? axis.scale(value) : null;
};
var $ce9b7262abb43277$export$8abb9e87422f3a0c = function getCateCoordinateOfBar(_ref8) {
    var axis = _ref8.axis, ticks = _ref8.ticks, offset = _ref8.offset, bandSize = _ref8.bandSize, entry = _ref8.entry, index = _ref8.index;
    if (axis.type === "category") return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = $ce9b7262abb43277$export$f97fc4a450f29a(entry, axis.dataKey, axis.domain[index]);
    return !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var $ce9b7262abb43277$export$54f3200dd4a8a235 = function getBaseValueOfBar(_ref9) {
    var numericAxis = _ref9.numericAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var min = Math.min(domain[0], domain[1]);
        var max = Math.max(domain[0], domain[1]);
        if (min <= 0 && max >= 0) return 0;
        if (max < 0) return max;
        return min;
    }
    return domain[0];
};
var $ce9b7262abb43277$export$a17bf3d98457878c = function getStackedDataOfItem(item, stackGroups) {
    var stackId = item.props.stackId;
    if ((0, $a4d9ec64928c627b$export$402a499e1ea44294)(stackId)) {
        var group = stackGroups[stackId];
        if (group && group.items.length) {
            var itemIndex = -1;
            for(var i = 0, len = group.items.length; i < len; i++)if (group.items[i] === item) {
                itemIndex = i;
                break;
            }
            return itemIndex >= 0 ? group.stackedData[itemIndex] : null;
        }
    }
    return null;
};
var $ce9b7262abb43277$var$getDomainOfSingle = function getDomainOfSingle(data) {
    return data.reduce(function(result, entry) {
        return [
            (0, (/*@__PURE__*/$parcel$interopDefault($35f6cdeacb5f1b1b$exports)))(entry.concat([
                result[0]
            ]).filter((0, $a4d9ec64928c627b$export$7e4aa119212bc614))),
            (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(entry.concat([
                result[1]
            ]).filter((0, $a4d9ec64928c627b$export$7e4aa119212bc614)))
        ];
    }, [
        Infinity,
        -Infinity
    ]);
};
var $ce9b7262abb43277$export$26522b779eb5497c = function getDomainOfStackGroups(stackGroups, startIndex, endIndex) {
    return Object.keys(stackGroups).reduce(function(result, stackId) {
        var group = stackGroups[stackId];
        var stackedData = group.stackedData;
        var domain = stackedData.reduce(function(res, entry) {
            var s = $ce9b7262abb43277$var$getDomainOfSingle(entry.slice(startIndex, endIndex + 1));
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]).map(function(result) {
        return result === Infinity || result === -Infinity ? 0 : result;
    });
};
var $ce9b7262abb43277$export$75a7b23ff266dfa1 = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $ce9b7262abb43277$export$19c111ec8ad6c644 = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var $ce9b7262abb43277$export$a0bc8660980558a0 = function parseSpecifiedDomain(specifiedDomain, dataDomain, allowDataOverflow) {
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(specifiedDomain)) return specifiedDomain(dataDomain, allowDataOverflow);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(specifiedDomain)) return dataDomain;
    var domain = [];
    /* eslint-disable prefer-destructuring */ if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(specifiedDomain[0])) domain[0] = allowDataOverflow ? specifiedDomain[0] : Math.min(specifiedDomain[0], dataDomain[0]);
    else if ($ce9b7262abb43277$export$75a7b23ff266dfa1.test(specifiedDomain[0])) {
        var value = +$ce9b7262abb43277$export$75a7b23ff266dfa1.exec(specifiedDomain[0])[1];
        domain[0] = dataDomain[0] - value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(specifiedDomain[0])) domain[0] = specifiedDomain[0](dataDomain[0]);
    else domain[0] = dataDomain[0];
    if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(specifiedDomain[1])) domain[1] = allowDataOverflow ? specifiedDomain[1] : Math.max(specifiedDomain[1], dataDomain[1]);
    else if ($ce9b7262abb43277$export$19c111ec8ad6c644.test(specifiedDomain[1])) {
        var _value = +$ce9b7262abb43277$export$19c111ec8ad6c644.exec(specifiedDomain[1])[1];
        domain[1] = dataDomain[1] + _value;
    } else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(specifiedDomain[1])) domain[1] = specifiedDomain[1](dataDomain[1]);
    else domain[1] = dataDomain[1];
    /* eslint-enable prefer-destructuring */ return domain;
};
var $ce9b7262abb43277$export$212ec45c42fe68a7 = function getBandSizeOfAxis(axis, ticks, isBar) {
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, (/*@__PURE__*/$parcel$interopDefault($421c39c39f87f3ba$exports)))(ticks, function(o) {
            return o.coordinate;
        });
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min((cur.coordinate || 0) - (prev.coordinate || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
var $ce9b7262abb43277$export$c9a5230f0dda41bf = function parseDomainOfCategoryAxis(specifiedDomain, calculatedDomain, axisChild) {
    if (!specifiedDomain || !specifiedDomain.length) return calculatedDomain;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($e6eb5f93f0f2349f$exports)))(specifiedDomain, (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(axisChild, "type.defaultProps.domain"))) return calculatedDomain;
    return specifiedDomain;
};
var $ce9b7262abb43277$export$a4ea3faa19bc2d90 = function getTooltipItem(graphicalItem, payload) {
    var _graphicalItem$props = graphicalItem.props, dataKey = _graphicalItem$props.dataKey, name = _graphicalItem$props.name, unit = _graphicalItem$props.unit, formatter = _graphicalItem$props.formatter, tooltipType = _graphicalItem$props.tooltipType, chartType = _graphicalItem$props.chartType;
    return $ce9b7262abb43277$var$_objectSpread($ce9b7262abb43277$var$_objectSpread({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(graphicalItem)), {}, {
        dataKey: dataKey,
        unit: unit,
        formatter: formatter,
        name: name || dataKey,
        color: $ce9b7262abb43277$export$ec6cab5a7a3b93bf(graphicalItem),
        value: $ce9b7262abb43277$export$f97fc4a450f29a(payload, dataKey),
        type: tooltipType,
        payload: payload,
        chartType: chartType
    });
};


function $0fac551513a25c6a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0fac551513a25c6a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $0fac551513a25c6a$var$ownKeys(Object(source), true).forEach(function(key) {
            $0fac551513a25c6a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $0fac551513a25c6a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0fac551513a25c6a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0fac551513a25c6a$var$_slicedToArray(arr, i) {
    return $0fac551513a25c6a$var$_arrayWithHoles(arr) || $0fac551513a25c6a$var$_iterableToArrayLimit(arr, i) || $0fac551513a25c6a$var$_unsupportedIterableToArray(arr, i) || $0fac551513a25c6a$var$_nonIterableRest();
}
function $0fac551513a25c6a$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $0fac551513a25c6a$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $0fac551513a25c6a$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $0fac551513a25c6a$var$_arrayLikeToArray(o, minLen);
}
function $0fac551513a25c6a$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $0fac551513a25c6a$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $0fac551513a25c6a$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $0fac551513a25c6a$export$d74e8f7e9cc3fed3 = Math.PI / 180;
var $0fac551513a25c6a$export$4f2c4f194778dcbb = function degreeToRadian(angle) {
    return angle * Math.PI / 180;
};
var $0fac551513a25c6a$export$1c20e104e3e29a0a = function radianToDegree(angleInRadian) {
    return angleInRadian * 180 / Math.PI;
};
var $0fac551513a25c6a$export$5c9a959bb3fc7749 = function polarToCartesian(cx, cy, radius, angle) {
    return {
        x: cx + Math.cos(-$0fac551513a25c6a$export$d74e8f7e9cc3fed3 * angle) * radius,
        y: cy + Math.sin(-$0fac551513a25c6a$export$d74e8f7e9cc3fed3 * angle) * radius
    };
};
var $0fac551513a25c6a$export$ad5c48602371adfa = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var $0fac551513a25c6a$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height;
    var startAngle = props.startAngle, endAngle = props.endAngle;
    var cx = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(props.cx, width, width / 2);
    var cy = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(props.cy, height, height / 2);
    var maxRadius = $0fac551513a25c6a$export$ad5c48602371adfa(width, height, offset);
    var innerRadius = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(props.innerRadius, maxRadius, 0);
    var outerRadius = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(props.outerRadius, maxRadius, maxRadius * 0.8);
    var ids = Object.keys(axisMap);
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var domain = axis.domain, reversed = axis.reversed;
        var range;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(axis.range)) {
            if (axisType === "angleAxis") range = [
                startAngle,
                endAngle
            ];
            else if (axisType === "radiusAxis") range = [
                innerRadius,
                outerRadius
            ];
            if (reversed) range = [
                range[1],
                range[0]
            ];
        } else {
            range = axis.range;
            var _range = range;
            var _range2 = $0fac551513a25c6a$var$_slicedToArray(_range, 2);
            startAngle = _range2[0];
            endAngle = _range2[1];
        }
        var _parseScale = (0, $ce9b7262abb43277$export$534b094a708572c1)(axis, chartName), realScaleType = _parseScale.realScaleType, scale = _parseScale.scale;
        scale.domain(domain).range(range);
        (0, $ce9b7262abb43277$export$9d80152e23bae434)(scale);
        var ticks = (0, $ce9b7262abb43277$export$ac086aaa4358d590)(scale, $0fac551513a25c6a$var$_objectSpread($0fac551513a25c6a$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        var finalAxis = $0fac551513a25c6a$var$_objectSpread($0fac551513a25c6a$var$_objectSpread($0fac551513a25c6a$var$_objectSpread({}, axis), ticks), {}, {
            range: range,
            radius: outerRadius,
            realScaleType: realScaleType,
            scale: scale,
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
        return $0fac551513a25c6a$var$_objectSpread($0fac551513a25c6a$var$_objectSpread({}, result), {}, $0fac551513a25c6a$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $0fac551513a25c6a$export$b59117efbc9c7af = function distanceBetweenPoints(point, anotherPoint) {
    var x1 = point.x, y1 = point.y;
    var x2 = anotherPoint.x, y2 = anotherPoint.y;
    return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};
var $0fac551513a25c6a$export$bc42f851bd05a2ae = function getAngleOfPoint(_ref, _ref2) {
    var x = _ref.x, y = _ref.y;
    var cx = _ref2.cx, cy = _ref2.cy;
    var radius = $0fac551513a25c6a$export$b59117efbc9c7af({
        x: x,
        y: y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius: radius
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius: radius,
        angle: $0fac551513a25c6a$export$1c20e104e3e29a0a(angleInRadian),
        angleInRadian: angleInRadian
    };
};
var $0fac551513a25c6a$export$c8ca70209d427b81 = function formatAngleOfSector(_ref3) {
    var startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var $0fac551513a25c6a$var$reverseFormatAngleOfSetor = function reverseFormatAngleOfSetor(angle, _ref4) {
    var startAngle = _ref4.startAngle, endAngle = _ref4.endAngle;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var $0fac551513a25c6a$export$e85a2bf8cd31c504 = function inRangeOfSector(_ref5, sector) {
    var x = _ref5.x, y = _ref5.y;
    var _getAngleOfPoint = $0fac551513a25c6a$export$bc42f851bd05a2ae({
        x: x,
        y: y
    }, sector), radius = _getAngleOfPoint.radius, angle = _getAngleOfPoint.angle;
    var innerRadius = sector.innerRadius, outerRadius = sector.outerRadius;
    if (radius < innerRadius || radius > outerRadius) return false;
    if (radius === 0) return true;
    var _formatAngleOfSector = $0fac551513a25c6a$export$c8ca70209d427b81(sector), startAngle = _formatAngleOfSector.startAngle, endAngle = _formatAngleOfSector.endAngle;
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return $0fac551513a25c6a$var$_objectSpread($0fac551513a25c6a$var$_objectSpread({}, sector), {}, {
        radius: radius,
        angle: $0fac551513a25c6a$var$reverseFormatAngleOfSetor(formatAngle, sector)
    });
    return null;
};



function $e21f9fc05175df16$var$_toConsumableArray(arr) {
    return $e21f9fc05175df16$var$_arrayWithoutHoles(arr) || $e21f9fc05175df16$var$_iterableToArray(arr) || $e21f9fc05175df16$var$_unsupportedIterableToArray(arr) || $e21f9fc05175df16$var$_nonIterableSpread();
}
function $e21f9fc05175df16$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $e21f9fc05175df16$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $e21f9fc05175df16$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $e21f9fc05175df16$var$_arrayLikeToArray(o, minLen);
}
function $e21f9fc05175df16$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $e21f9fc05175df16$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $e21f9fc05175df16$var$_arrayLikeToArray(arr);
}
function $e21f9fc05175df16$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $e21f9fc05175df16$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e21f9fc05175df16$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $e21f9fc05175df16$var$ownKeys(Object(source), true).forEach(function(key) {
            $e21f9fc05175df16$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $e21f9fc05175df16$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e21f9fc05175df16$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e21f9fc05175df16$var$_extends() {
    $e21f9fc05175df16$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $e21f9fc05175df16$var$_extends.apply(this, arguments);
}
var $e21f9fc05175df16$var$getLabel = function getLabel(props) {
    var value = props.value, formatter = props.formatter;
    var label = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(props.children) ? value : props.children;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(formatter)) return formatter(label);
    return label;
};
var $e21f9fc05175df16$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $a4d9ec64928c627b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var $e21f9fc05175df16$var$renderRadialLabel = function renderRadialLabel(labelProps, label, attrs) {
    var position = labelProps.position, viewBox = labelProps.viewBox, offset = labelProps.offset, className = labelProps.className;
    var _ref = viewBox, cx = _ref.cx, cy = _ref.cy, innerRadius = _ref.innerRadius, outerRadius = _ref.outerRadius, startAngle = _ref.startAngle, endAngle = _ref.endAngle, clockWise = _ref.clockWise;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = $e21f9fc05175df16$var$getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    if (position === "insideStart") {
        labelAngle = startAngle + sign * offset;
        direction = clockWise;
    } else if (position === "insideEnd") {
        labelAngle = endAngle - sign * offset;
        direction = !clockWise;
    } else if (position === "end") {
        labelAngle = endAngle + sign * offset;
        direction = clockWise;
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle);
    var endPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(labelProps.id) ? (0, $a4d9ec64928c627b$export$8b15d37bc3f197d4)("recharts-radial-line-") : labelProps.id;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("text", $e21f9fc05175df16$var$_extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-radial-bar-label", className)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var $e21f9fc05175df16$var$getAttrsOfPolarLabel = function getAttrsOfPolarLabel(props) {
    var viewBox = props.viewBox, offset = props.offset, position = props.position;
    var _ref2 = viewBox, cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === "outside") {
        var _polarToCartesian = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, outerRadius + offset, midAngle), _x = _polarToCartesian.x, _y = _polarToCartesian.y;
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? "start" : "end",
            verticalAnchor: "middle"
        };
    }
    if (position === "center") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
    if (position === "centerTop") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "start"
    };
    if (position === "centerBottom") return {
        x: cx,
        y: cy,
        textAnchor: "middle",
        verticalAnchor: "end"
    };
    var r = (innerRadius + outerRadius) / 2;
    var _polarToCartesian2 = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, r, midAngle), x = _polarToCartesian2.x, y = _polarToCartesian2.y;
    return {
        x: x,
        y: y,
        textAnchor: "middle",
        verticalAnchor: "middle"
    };
};
var $e21f9fc05175df16$var$getAttrsOfCartesianLabel = function getAttrsOfCartesianLabel(props) {
    var viewBox = props.viewBox, parentViewBox = props.parentViewBox, offset = props.offset, position = props.position;
    var _ref3 = viewBox, x = _ref3.x, y = _ref3.y, width = _ref3.width, height = _ref3.height; // Define vertical offsets and position inverts based on the value being positive or negative
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? "end" : "start";
    var verticalStart = verticalSign > 0 ? "start" : "end"; // Define horizontal offsets and position inverts based on the value being positive or negative
    var horizontalSign = width >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? "end" : "start";
    var horizontalStart = horizontalSign > 0 ? "start" : "end";
    if (position === "top") {
        var attrs = {
            x: x + width / 2,
            y: y - verticalSign * offset,
            textAnchor: "middle",
            verticalAnchor: verticalEnd
        };
        return $e21f9fc05175df16$var$_objectSpread($e21f9fc05175df16$var$_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: width
        } : {});
    }
    if (position === "bottom") {
        var _attrs = {
            x: x + width / 2,
            y: y + height + verticalOffset,
            textAnchor: "middle",
            verticalAnchor: verticalStart
        };
        return $e21f9fc05175df16$var$_objectSpread($e21f9fc05175df16$var$_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: width
        } : {});
    }
    if (position === "left") {
        var _attrs2 = {
            x: x - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: "middle"
        };
        return $e21f9fc05175df16$var$_objectSpread($e21f9fc05175df16$var$_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height: height
        } : {});
    }
    if (position === "right") {
        var _attrs3 = {
            x: x + width + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: "middle"
        };
        return $e21f9fc05175df16$var$_objectSpread($e21f9fc05175df16$var$_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height: height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: width,
        height: height
    } : {};
    if (position === "insideLeft") return $e21f9fc05175df16$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideRight") return $e21f9fc05175df16$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: "middle"
    }, sizeAttrs);
    if (position === "insideTop") return $e21f9fc05175df16$var$_objectSpread({
        x: x + width / 2,
        y: y + verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottom") return $e21f9fc05175df16$var$_objectSpread({
        x: x + width / 2,
        y: y + height - verticalOffset,
        textAnchor: "middle",
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideTopLeft") return $e21f9fc05175df16$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideTopRight") return $e21f9fc05175df16$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === "insideBottomLeft") return $e21f9fc05175df16$var$_objectSpread({
        x: x + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === "insideBottomRight") return $e21f9fc05175df16$var$_objectSpread({
        x: x + width - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(position) && ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(position.x) || (0, $a4d9ec64928c627b$export$e50269385c77c348)(position.x)) && ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(position.y) || (0, $a4d9ec64928c627b$export$e50269385c77c348)(position.y))) return $e21f9fc05175df16$var$_objectSpread({
        x: x + (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(position.x, width),
        y: y + (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(position.y, height),
        textAnchor: "end",
        verticalAnchor: "end"
    }, sizeAttrs);
    return $e21f9fc05175df16$var$_objectSpread({
        x: x + width / 2,
        y: y + height / 2,
        textAnchor: "middle",
        verticalAnchor: "middle"
    }, sizeAttrs);
};
var $e21f9fc05175df16$var$isPolar = function isPolar(viewBox) {
    return (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(viewBox.cx);
};
function $e21f9fc05175df16$export$b04be29aa201d4f5(props) {
    var viewBox = props.viewBox, position = props.position, value = props.value, children = props.children, content = props.content, _props$className = props.className, className = _props$className === void 0 ? "" : _props$className, textBreakAll = props.textBreakAll;
    if (!viewBox || (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(value) && (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(children) && !/*#__PURE__*/ (0, $eCoWV.isValidElement)(content) && !(0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(content)) return null;
    if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(content)) return /*#__PURE__*/ (0, $eCoWV.cloneElement)(content, props);
    var label;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(content)) {
        label = /*#__PURE__*/ (0, $eCoWV.createElement)(content, props);
        if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(label)) return label;
    } else label = $e21f9fc05175df16$var$getLabel(props);
    var isPolarLabel = $e21f9fc05175df16$var$isPolar(viewBox);
    var attrs = (0, $dd873d09408694ab$export$d697c39a2985a4c)(props, true);
    if (isPolarLabel && (position === "insideStart" || position === "insideEnd" || position === "end")) return $e21f9fc05175df16$var$renderRadialLabel(props, label, attrs);
    var positionAttrs = isPolarLabel ? $e21f9fc05175df16$var$getAttrsOfPolarLabel(props) : $e21f9fc05175df16$var$getAttrsOfCartesianLabel(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $ddbf2ed6ffdaf856$export$5f1af8db9871e1d6), $e21f9fc05175df16$var$_extends({
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-label", className)
    }, attrs, positionAttrs, {
        breakAll: textBreakAll
    }), label);
}
$e21f9fc05175df16$export$b04be29aa201d4f5.displayName = "Label";
$e21f9fc05175df16$export$b04be29aa201d4f5.defaultProps = {
    offset: 5
};
var $e21f9fc05175df16$var$parseViewBox = function parseViewBox(props) {
    var cx = props.cx, cy = props.cy, angle = props.angle, startAngle = props.startAngle, endAngle = props.endAngle, r = props.r, radius = props.radius, innerRadius = props.innerRadius, outerRadius = props.outerRadius, x = props.x, y = props.y, top = props.top, left = props.left, width = props.width, height = props.height, clockWise = props.clockWise, labelViewBox = props.labelViewBox;
    if (labelViewBox) return labelViewBox;
    if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(height)) {
        if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(x) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(y)) return {
            x: x,
            y: y,
            width: width,
            height: height
        };
        if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(top) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(left)) return {
            x: top,
            y: left,
            width: width,
            height: height
        };
    }
    if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(x) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(y)) return {
        x: x,
        y: y,
        width: 0,
        height: 0
    };
    if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(cx) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(cy)) return {
        cx: cx,
        cy: cy,
        startAngle: startAngle || angle || 0,
        endAngle: endAngle || angle || 0,
        innerRadius: innerRadius || 0,
        outerRadius: outerRadius || radius || r || 0,
        clockWise: clockWise
    };
    if (props.viewBox) return props.viewBox;
    return {};
};
var $e21f9fc05175df16$var$parseLabel = function parseLabel(label, viewBox) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($e21f9fc05175df16$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox
    });
    if ((0, $a4d9ec64928c627b$export$402a499e1ea44294)(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($e21f9fc05175df16$export$b04be29aa201d4f5, {
        key: "label-implicit",
        viewBox: viewBox,
        value: label
    });
    if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(label)) {
        if (label.type === $e21f9fc05175df16$export$b04be29aa201d4f5) return /*#__PURE__*/ (0, $eCoWV.cloneElement)(label, {
            key: "label-implicit",
            viewBox: viewBox
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($e21f9fc05175df16$export$b04be29aa201d4f5, {
            key: "label-implicit",
            content: label,
            viewBox: viewBox
        });
    }
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($e21f9fc05175df16$export$b04be29aa201d4f5, {
        key: "label-implicit",
        content: label,
        viewBox: viewBox
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($e21f9fc05175df16$export$b04be29aa201d4f5, $e21f9fc05175df16$var$_extends({
        viewBox: viewBox
    }, label, {
        key: "label-implicit"
    }));
    return null;
};
var $e21f9fc05175df16$var$renderCallByParent = function renderCallByParent(parentProps, viewBox) {
    var checkPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && checkPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var parentViewBox = $e21f9fc05175df16$var$parseViewBox(parentProps);
    var explicitChildren = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, $e21f9fc05175df16$export$b04be29aa201d4f5.displayName).map(function(child, index) {
        return /*#__PURE__*/ (0, $eCoWV.cloneElement)(child, {
            viewBox: viewBox || parentViewBox,
            key: "label-".concat(index)
        });
    });
    if (!checkPropsLabel) return explicitChildren;
    var implicitLabel = $e21f9fc05175df16$var$parseLabel(parentProps.label, viewBox || parentViewBox);
    return [
        implicitLabel
    ].concat($e21f9fc05175df16$var$_toConsumableArray(explicitChildren));
};
$e21f9fc05175df16$export$b04be29aa201d4f5.parseViewBox = $e21f9fc05175df16$var$parseViewBox;
$e21f9fc05175df16$export$b04be29aa201d4f5.renderCallByParent = $e21f9fc05175df16$var$renderCallByParent;






function $4d9a40e6e0d325cf$var$_toConsumableArray(arr) {
    return $4d9a40e6e0d325cf$var$_arrayWithoutHoles(arr) || $4d9a40e6e0d325cf$var$_iterableToArray(arr) || $4d9a40e6e0d325cf$var$_unsupportedIterableToArray(arr) || $4d9a40e6e0d325cf$var$_nonIterableSpread();
}
function $4d9a40e6e0d325cf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $4d9a40e6e0d325cf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $4d9a40e6e0d325cf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $4d9a40e6e0d325cf$var$_arrayLikeToArray(o, minLen);
}
function $4d9a40e6e0d325cf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $4d9a40e6e0d325cf$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $4d9a40e6e0d325cf$var$_arrayLikeToArray(arr);
}
function $4d9a40e6e0d325cf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $4d9a40e6e0d325cf$var$_extends() {
    $4d9a40e6e0d325cf$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $4d9a40e6e0d325cf$var$_extends.apply(this, arguments);
}
function $4d9a40e6e0d325cf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $4d9a40e6e0d325cf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $4d9a40e6e0d325cf$var$ownKeys(Object(source), true).forEach(function(key) {
            $4d9a40e6e0d325cf$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $4d9a40e6e0d325cf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $4d9a40e6e0d325cf$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $4d9a40e6e0d325cf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4d9a40e6e0d325cf$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4d9a40e6e0d325cf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $4d9a40e6e0d325cf$var$defaultProps = {
    valueAccessor: function valueAccessor(entry) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(entry.value) ? (0, (/*@__PURE__*/$parcel$interopDefault($1eaa4283cabf6b33$exports)))(entry.value) : entry.value;
    }
};
function $4d9a40e6e0d325cf$export$835fcf23ab7bf88(props) {
    var data = props.data, valueAccessor = props.valueAccessor, dataKey = props.dataKey, clockWise = props.clockWise, id = props.id, textBreakAll = props.textBreakAll, others = $4d9a40e6e0d325cf$var$_objectWithoutProperties(props, [
        "data",
        "valueAccessor",
        "dataKey",
        "clockWise",
        "id",
        "textBreakAll"
    ]);
    if (!data || !data.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
        className: "recharts-label-list"
    }, data.map(function(entry, index) {
        var value = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(dataKey) ? valueAccessor(entry, index) : (0, $ce9b7262abb43277$export$f97fc4a450f29a)(entry && entry.payload, dataKey);
        var idProps = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e21f9fc05175df16$export$b04be29aa201d4f5), $4d9a40e6e0d325cf$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(entry, true), others, idProps, {
            parentViewBox: entry.parentViewBox,
            index: index,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: (0, $e21f9fc05175df16$export$b04be29aa201d4f5).parseViewBox((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(clockWise) ? entry : $4d9a40e6e0d325cf$var$_objectSpread($4d9a40e6e0d325cf$var$_objectSpread({}, entry), {}, {
                clockWise: clockWise
            })),
            key: "label-".concat(index) // eslint-disable-line react/no-array-index-key
        }));
    }));
}
$4d9a40e6e0d325cf$export$835fcf23ab7bf88.displayName = "LabelList";
function $4d9a40e6e0d325cf$var$parseLabelList(label, data) {
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($4d9a40e6e0d325cf$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data
    });
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(label) || (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($4d9a40e6e0d325cf$export$835fcf23ab7bf88, {
        key: "labelList-implicit",
        data: data,
        content: label
    });
    if ((0, (/*@__PURE__*/$parcel$interopDefault($6012f8e4c7891baf$exports)))(label)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement($4d9a40e6e0d325cf$export$835fcf23ab7bf88, $4d9a40e6e0d325cf$var$_extends({
        data: data
    }, label, {
        key: "labelList-implicit"
    }));
    return null;
}
function $4d9a40e6e0d325cf$var$renderCallByParent(parentProps, data) {
    var ckeckPropsLabel = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (!parentProps || !parentProps.children && ckeckPropsLabel && !parentProps.label) return null;
    var children = parentProps.children;
    var explicitChilren = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, $4d9a40e6e0d325cf$export$835fcf23ab7bf88.displayName).map(function(child, index) {
        return /*#__PURE__*/ (0, $eCoWV.cloneElement)(child, {
            data: data,
            key: "labelList-".concat(index)
        });
    });
    if (!ckeckPropsLabel) return explicitChilren;
    var implicitLabelList = $4d9a40e6e0d325cf$var$parseLabelList(parentProps.label, data);
    return [
        implicitLabelList
    ].concat($4d9a40e6e0d325cf$var$_toConsumableArray(explicitChilren));
}
$4d9a40e6e0d325cf$export$835fcf23ab7bf88.renderCallByParent = $4d9a40e6e0d325cf$var$renderCallByParent;
$4d9a40e6e0d325cf$export$835fcf23ab7bf88.defaultProps = $4d9a40e6e0d325cf$var$defaultProps;






function $126bbb1a4f17672d$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $126bbb1a4f17672d$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $126bbb1a4f17672d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $126bbb1a4f17672d$var$_typeof(obj);
}
function $126bbb1a4f17672d$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $126bbb1a4f17672d$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $126bbb1a4f17672d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $126bbb1a4f17672d$var$_extends() {
    $126bbb1a4f17672d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $126bbb1a4f17672d$var$_extends.apply(this, arguments);
}
function $126bbb1a4f17672d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $126bbb1a4f17672d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $126bbb1a4f17672d$var$ownKeys(Object(source), true).forEach(function(key) {
            $126bbb1a4f17672d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $126bbb1a4f17672d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $126bbb1a4f17672d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $126bbb1a4f17672d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $126bbb1a4f17672d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $126bbb1a4f17672d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $126bbb1a4f17672d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $126bbb1a4f17672d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $126bbb1a4f17672d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $126bbb1a4f17672d$var$_setPrototypeOf(subClass, superClass);
}
function $126bbb1a4f17672d$var$_setPrototypeOf(o, p) {
    $126bbb1a4f17672d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $126bbb1a4f17672d$var$_setPrototypeOf(o, p);
}
function $126bbb1a4f17672d$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $126bbb1a4f17672d$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $126bbb1a4f17672d$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $126bbb1a4f17672d$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $126bbb1a4f17672d$var$_possibleConstructorReturn(this, result);
    };
}
function $126bbb1a4f17672d$var$_possibleConstructorReturn(self, call) {
    if (call && ($126bbb1a4f17672d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $126bbb1a4f17672d$var$_assertThisInitialized(self);
}
function $126bbb1a4f17672d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $126bbb1a4f17672d$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $126bbb1a4f17672d$var$_getPrototypeOf(o) {
    $126bbb1a4f17672d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $126bbb1a4f17672d$var$_getPrototypeOf(o);
}
var $126bbb1a4f17672d$export$ea1a111407f37557 = /*#__PURE__*/ function(_PureComponent) {
    $126bbb1a4f17672d$var$_inherits(Area, _PureComponent);
    var _super = $126bbb1a4f17672d$var$_createSuper(Area);
    function Area() {
        var _this;
        $126bbb1a4f17672d$var$_classCallCheck(this, Area);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            isAnimationFinished: true
        };
        _this.id = (0, $a4d9ec64928c627b$export$8b15d37bc3f197d4)("recharts-area-");
        _this.handleAnimationEnd = function() {
            var onAnimationEnd = _this.props.onAnimationEnd;
            _this.setState({
                isAnimationFinished: true
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onAnimationEnd)) onAnimationEnd();
        };
        _this.handleAnimationStart = function() {
            var onAnimationStart = _this.props.onAnimationStart;
            _this.setState({
                isAnimationFinished: false
            });
            if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onAnimationStart)) onAnimationStart();
        };
        return _this;
    }
    $126bbb1a4f17672d$var$_createClass(Area, [
        {
            key: "renderDots",
            value: function renderDots(needClip, clipPathId) {
                var isAnimationActive = this.props.isAnimationActive;
                var isAnimationFinished = this.state.isAnimationFinished;
                if (isAnimationActive && !isAnimationFinished) return null;
                var _this$props = this.props, dot = _this$props.dot, points = _this$props.points, dataKey = _this$props.dataKey;
                var areaProps = (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props);
                var customDotProps = (0, $dd873d09408694ab$export$d697c39a2985a4c)(dot, true);
                var dots = points.map(function(entry, i) {
                    var dotProps = $126bbb1a4f17672d$var$_objectSpread($126bbb1a4f17672d$var$_objectSpread($126bbb1a4f17672d$var$_objectSpread({
                        key: "dot-".concat(i),
                        r: 3
                    }, areaProps), customDotProps), {}, {
                        dataKey: dataKey,
                        cx: entry.x,
                        cy: entry.y,
                        index: i,
                        value: entry.value,
                        payload: entry.payload
                    });
                    return Area.renderDotItem(dot, dotProps);
                });
                var dotsProps = {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), $126bbb1a4f17672d$var$_extends({
                    className: "recharts-area-dots"
                }, dotsProps), dots);
            }
        },
        {
            key: "renderHorizontalRect",
            value: function renderHorizontalRect(alpha) {
                var _this$props2 = this.props, baseLine = _this$props2.baseLine, points = _this$props2.points, strokeWidth = _this$props2.strokeWidth;
                var startX = points[0].x;
                var endX = points[points.length - 1].x;
                var width = alpha * Math.abs(startX - endX);
                var maxY = (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(points.map(function(entry) {
                    return entry.y || 0;
                }));
                if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxY = Math.max(baseLine, maxY);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(baseLine) && baseLine.length) maxY = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(baseLine.map(function(entry) {
                    return entry.y || 0;
                })), maxY);
                if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(maxY)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    x: startX < endX ? startX : startX - width,
                    y: 0,
                    width: width,
                    height: Math.floor(maxY + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1))
                });
                return null;
            }
        },
        {
            key: "renderVerticalRect",
            value: function renderVerticalRect(alpha) {
                var _this$props3 = this.props, baseLine = _this$props3.baseLine, points = _this$props3.points, strokeWidth = _this$props3.strokeWidth;
                var startY = points[0].y;
                var endY = points[points.length - 1].y;
                var height = alpha * Math.abs(startY - endY);
                var maxX = (0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(points.map(function(entry) {
                    return entry.x || 0;
                }));
                if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") maxX = Math.max(baseLine, maxX);
                else if (baseLine && (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(baseLine) && baseLine.length) maxX = Math.max((0, (/*@__PURE__*/$parcel$interopDefault($ae1d014ea9777699$exports)))(baseLine.map(function(entry) {
                    return entry.x || 0;
                })), maxX);
                if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(maxX)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    x: 0,
                    y: startY < endY ? startY : startY - height,
                    width: maxX + (strokeWidth ? parseInt("".concat(strokeWidth), 10) : 1),
                    height: Math.floor(height)
                });
                return null;
            }
        },
        {
            key: "renderClipRect",
            value: function renderClipRect(alpha) {
                var layout = this.props.layout;
                if (layout === "vertical") return this.renderVerticalRect(alpha);
                return this.renderHorizontalRect(alpha);
            }
        },
        {
            key: "renderAreaStatically",
            value: function renderAreaStatically(points, baseLine, needClip, clipPathId) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                var _this$props4 = this.props, layout = _this$props4.layout, type = _this$props4.type, stroke = _this$props4.stroke, connectNulls = _this$props4.connectNulls, isRange = _this$props4.isRange, ref = _this$props4.ref, others = $126bbb1a4f17672d$var$_objectWithoutProperties(_this$props4, [
                    "layout",
                    "type",
                    "stroke",
                    "connectNulls",
                    "isRange",
                    "ref"
                ]);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $1046975411d24196$export$b0e83c3ef8d2db1), $126bbb1a4f17672d$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(others, true), {
                    points: points,
                    connectNulls: connectNulls,
                    type: type,
                    baseLine: baseLine,
                    layout: layout,
                    stroke: "none",
                    className: "recharts-area-area"
                })), stroke !== "none" && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $1046975411d24196$export$b0e83c3ef8d2db1), $126bbb1a4f17672d$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: points
                })), stroke !== "none" && isRange && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $1046975411d24196$export$b0e83c3ef8d2db1), $126bbb1a4f17672d$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props), {
                    className: "recharts-area-curve",
                    layout: layout,
                    type: type,
                    connectNulls: connectNulls,
                    fill: "none",
                    points: baseLine
                })));
            }
        },
        {
            key: "renderAreaWithAnimation",
            value: function renderAreaWithAnimation(needClip, clipPathId) {
                var _this2 = this;
                var _this$props5 = this.props, points = _this$props5.points, baseLine = _this$props5.baseLine, isAnimationActive = _this$props5.isAnimationActive, animationBegin = _this$props5.animationBegin, animationDuration = _this$props5.animationDuration, animationEasing = _this$props5.animationEasing, animationId = _this$props5.animationId;
                var _this$state = this.state, prevPoints = _this$state.prevPoints, prevBaseLine = _this$state.prevBaseLine; // const clipPathId = _.isNil(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d7ffd80b59fbbca7$export$2e2bcd8739ae039), {
                    begin: animationBegin,
                    duration: animationDuration,
                    isActive: isAnimationActive,
                    easing: animationEasing,
                    from: {
                        t: 0
                    },
                    to: {
                        t: 1
                    },
                    key: "area-".concat(animationId),
                    onAnimationEnd: this.handleAnimationEnd,
                    onAnimationStart: this.handleAnimationStart
                }, function(_ref) {
                    var t = _ref.t;
                    if (prevPoints) {
                        var prevPointsDiffFactor = prevPoints.length / points.length; // update animtaion
                        var stepPoints = points.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevPoints[prevPointIndex]) {
                                var prev = prevPoints[prevPointIndex];
                                var interpolatorX = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $126bbb1a4f17672d$var$_objectSpread($126bbb1a4f17672d$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        var stepBaseLine;
                        if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseLine) && typeof baseLine === "number") {
                            var interpolator = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prevBaseLine, baseLine);
                            stepBaseLine = interpolator(t);
                        } else if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(baseLine) || (0, (/*@__PURE__*/$parcel$interopDefault($aa7127c7503d27f5$exports)))(baseLine)) {
                            var _interpolator = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prevBaseLine, 0);
                            stepBaseLine = _interpolator(t);
                        } else stepBaseLine = baseLine.map(function(entry, index) {
                            var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                            if (prevBaseLine[prevPointIndex]) {
                                var prev = prevBaseLine[prevPointIndex];
                                var interpolatorX = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prev.x, entry.x);
                                var interpolatorY = (0, $a4d9ec64928c627b$export$d871d53bd7eeb390)(prev.y, entry.y);
                                return $126bbb1a4f17672d$var$_objectSpread($126bbb1a4f17672d$var$_objectSpread({}, entry), {}, {
                                    x: interpolatorX(t),
                                    y: interpolatorY(t)
                                });
                            }
                            return entry;
                        });
                        return _this2.renderAreaStatically(stepPoints, stepBaseLine, needClip, clipPathId);
                    }
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("clipPath", {
                        id: "animationClipPath-".concat(clipPathId)
                    }, _this2.renderClipRect(t))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                        clipPath: "url(#animationClipPath-".concat(clipPathId, ")")
                    }, _this2.renderAreaStatically(points, baseLine, needClip, clipPathId)));
                });
            }
        },
        {
            key: "renderArea",
            value: function renderArea(needClip, clipPathId) {
                var _this$props6 = this.props, points = _this$props6.points, baseLine = _this$props6.baseLine, isAnimationActive = _this$props6.isAnimationActive;
                var _this$state2 = this.state, prevPoints = _this$state2.prevPoints, prevBaseLine = _this$state2.prevBaseLine, totalLength = _this$state2.totalLength;
                if (isAnimationActive && points && points.length && (!prevPoints && totalLength > 0 || !(0, (/*@__PURE__*/$parcel$interopDefault($e6eb5f93f0f2349f$exports)))(prevPoints, points) || !(0, (/*@__PURE__*/$parcel$interopDefault($e6eb5f93f0f2349f$exports)))(prevBaseLine, baseLine))) return this.renderAreaWithAnimation(needClip, clipPathId);
                return this.renderAreaStatically(points, baseLine, needClip, clipPathId);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props7 = this.props, hide = _this$props7.hide, dot = _this$props7.dot, points = _this$props7.points, className = _this$props7.className, top = _this$props7.top, left = _this$props7.left, xAxis = _this$props7.xAxis, yAxis = _this$props7.yAxis, width = _this$props7.width, height = _this$props7.height, isAnimationActive = _this$props7.isAnimationActive, id = _this$props7.id;
                if (hide || !points || !points.length) return null;
                var isAnimationFinished = this.state.isAnimationFinished;
                var hasSinglePoint = points.length === 1;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-area", className);
                var needClip = xAxis && xAxis.allowDataOverflow || yAxis && yAxis.allowDataOverflow;
                var clipPathId = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(id) ? this.id : id;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    className: layerClass
                }, needClip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("clipPath", {
                    id: "clipPath-".concat(clipPathId)
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    x: left,
                    y: top,
                    width: width,
                    height: Math.floor(height)
                }))) : null, !hasSinglePoint ? this.renderArea(needClip, clipPathId) : null, (dot || hasSinglePoint) && this.renderDots(needClip, clipPathId), (!isAnimationActive || isAnimationFinished) && (0, $4d9a40e6e0d325cf$export$835fcf23ab7bf88).renderCallByParent(this.props, points));
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                if (nextProps.animationId !== prevState.prevAnimationId) return {
                    prevAnimationId: nextProps.animationId,
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine,
                    prevPoints: prevState.curPoints,
                    prevBaseLine: prevState.curBaseLine
                };
                if (nextProps.points !== prevState.curPoints || nextProps.baseLine !== prevState.curBaseLine) return {
                    curPoints: nextProps.points,
                    curBaseLine: nextProps.baseLine
                };
                return null;
            }
        }
    ]);
    return Area;
}((0, $eCoWV.PureComponent));
$126bbb1a4f17672d$export$ea1a111407f37557.displayName = "Area";
$126bbb1a4f17672d$export$ea1a111407f37557.defaultProps = {
    stroke: "#3182bd",
    fill: "#3182bd",
    fillOpacity: 0.6,
    xAxisId: 0,
    yAxisId: 0,
    legendType: "line",
    connectNulls: false,
    // points of area
    points: [],
    dot: false,
    activeDot: true,
    hide: false,
    isAnimationActive: !(0, $2cfdd8db3ab543a8$export$98f03c5d19621d70).isSsr,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};
$126bbb1a4f17672d$export$ea1a111407f37557.getBaseValue = function(props, xAxis, yAxis) {
    var layout = props.layout, baseValue = props.baseValue;
    if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(baseValue) && typeof baseValue === "number") return baseValue;
    var numericAxis = layout === "horizontal" ? yAxis : xAxis;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === "number") {
        var max = Math.max(domain[0], domain[1]);
        var min = Math.min(domain[0], domain[1]);
        if (baseValue === "dataMin") return min;
        if (baseValue === "dataMax") return max;
        return max < 0 ? max : Math.max(Math.min(domain[0], domain[1]), 0);
    }
    if (baseValue === "dataMin") return domain[0];
    if (baseValue === "dataMax") return domain[1];
    return domain[0];
};
$126bbb1a4f17672d$export$ea1a111407f37557.getComposedData = function(_ref2) {
    var props = _ref2.props, xAxis = _ref2.xAxis, yAxis = _ref2.yAxis, xAxisTicks = _ref2.xAxisTicks, yAxisTicks = _ref2.yAxisTicks, bandSize = _ref2.bandSize, dataKey = _ref2.dataKey, stackedData = _ref2.stackedData, dataStartIndex = _ref2.dataStartIndex, displayedData = _ref2.displayedData, offset = _ref2.offset;
    var layout = props.layout;
    var hasStack = stackedData && stackedData.length;
    var baseValue = $126bbb1a4f17672d$export$ea1a111407f37557.getBaseValue(props, xAxis, yAxis);
    var isRange = false;
    var points = displayedData.map(function(entry, index) {
        var originalValue = (0, $ce9b7262abb43277$export$f97fc4a450f29a)(entry, dataKey);
        var value;
        if (hasStack) value = stackedData[dataStartIndex + index];
        else {
            value = originalValue;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(value)) value = [
                baseValue,
                value
            ];
            else isRange = true;
        }
        var isBreakPoint = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(value[1]) || hasStack && (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(originalValue);
        if (layout === "horizontal") return {
            x: (0, $ce9b7262abb43277$export$6e87f3defb83c3f)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            y: isBreakPoint ? null : yAxis.scale(value[1]),
            value: value,
            payload: entry
        };
        return {
            x: isBreakPoint ? null : xAxis.scale(value[1]),
            y: (0, $ce9b7262abb43277$export$6e87f3defb83c3f)({
                axis: yAxis,
                ticks: yAxisTicks,
                bandSize: bandSize,
                entry: entry,
                index: index
            }),
            value: value,
            payload: entry
        };
    });
    var baseLine;
    if (hasStack || isRange) baseLine = points.map(function(entry) {
        if (layout === "horizontal") return {
            x: entry.x,
            y: !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, "value[0]")) && !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, "y")) ? yAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, "value[0]")) : null
        };
        return {
            x: !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, "value[0]")) ? xAxis.scale((0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(entry, "value[0]")) : null,
            y: entry.y
        };
    });
    else if (layout === "horizontal") baseLine = yAxis.scale(baseValue);
    else baseLine = xAxis.scale(baseValue);
    return $126bbb1a4f17672d$var$_objectSpread({
        points: points,
        baseLine: baseLine,
        layout: layout,
        isRange: isRange
    }, offset);
};
$126bbb1a4f17672d$export$ea1a111407f37557.renderDotItem = function(option, props) {
    var dotItem;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) dotItem = option(props);
    else dotItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $18507106bbcc53ce$export$d046b3c4a416f60d), $126bbb1a4f17672d$var$_extends({}, props, {
        className: "recharts-area-dot"
    }));
    return dotItem;
};

/**
 * @fileOverview Area Chart
 */ var $c058f5bdb4b78d5f$exports = {};
var $fdbb0370f195d9f6$exports = {};
/**
 * A specialized version of `_.every` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 */ function $fdbb0370f195d9f6$var$arrayEvery(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (!predicate(array[index], index, array)) return false;
    }
    return true;
}
$fdbb0370f195d9f6$exports = $fdbb0370f195d9f6$var$arrayEvery;


var $11e1c28dbdd52a11$exports = {};

/**
 * The base implementation of `_.every` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`
 */ function $11e1c28dbdd52a11$var$baseEvery(collection, predicate) {
    var result = true;
    $04737f5e6900eacf$exports(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
    });
    return result;
}
$11e1c28dbdd52a11$exports = $11e1c28dbdd52a11$var$baseEvery;





/**
 * Checks if `predicate` returns truthy for **all** elements of `collection`.
 * Iteration is stopped once `predicate` returns falsey. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * **Note:** This method returns `true` for
 * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
 * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
 * elements of empty collections.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if all elements pass the predicate check,
 *  else `false`.
 * @example
 *
 * _.every([true, 1, null, 'yes'], Boolean);
 * // => false
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.every(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.every(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.every(users, 'active');
 * // => false
 */ function $c058f5bdb4b78d5f$var$every(collection, predicate, guard) {
    var func = $0731a2307bf9d7f9$exports(collection) ? $fdbb0370f195d9f6$exports : $11e1c28dbdd52a11$exports;
    if (guard && $b49463b59fa498e5$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $0ef980bf7dd42cec$exports(predicate, 3));
}
$c058f5bdb4b78d5f$exports = $c058f5bdb4b78d5f$var$every;


var $2c70d7833d64d5e4$exports = {};
var $00d0bb076c7ba065$exports = {};



/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $00d0bb076c7ba065$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$dd7f3dc0af86f403$exports(collection)) {
            var iteratee = $0ef980bf7dd42cec$exports(predicate, 3);
            collection = $69c7a2966b4129b5$exports(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
$00d0bb076c7ba065$exports = $00d0bb076c7ba065$var$createFind;


var $708bf250e939dfa2$exports = {};


var $40ae2580de42a164$exports = {};
var $901ca8422c907340$exports = {};
var $e7337102942980da$exports = {};
var $fbacf2926d142b78$exports = {};
var $8ef0874afae1a3de$exports = {};
/** Used to match a single whitespace character. */ var $8ef0874afae1a3de$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $8ef0874afae1a3de$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $8ef0874afae1a3de$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$8ef0874afae1a3de$exports = $8ef0874afae1a3de$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $fbacf2926d142b78$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $fbacf2926d142b78$var$baseTrim(string) {
    return string ? string.slice(0, $8ef0874afae1a3de$exports(string) + 1).replace($fbacf2926d142b78$var$reTrimStart, "") : string;
}
$fbacf2926d142b78$exports = $fbacf2926d142b78$var$baseTrim;




/** Used as references for various `Number` constants. */ var $e7337102942980da$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $e7337102942980da$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $e7337102942980da$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $e7337102942980da$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $e7337102942980da$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $e7337102942980da$var$toNumber(value) {
    if (typeof value == "number") return value;
    if ($75f82d2fc8a8760e$exports(value)) return $e7337102942980da$var$NAN;
    if ($6012f8e4c7891baf$exports(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $6012f8e4c7891baf$exports(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $fbacf2926d142b78$exports(value);
    var isBinary = $e7337102942980da$var$reIsBinary.test(value);
    return isBinary || $e7337102942980da$var$reIsOctal.test(value) ? $e7337102942980da$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $e7337102942980da$var$reIsBadHex.test(value) ? $e7337102942980da$var$NAN : +value;
}
$e7337102942980da$exports = $e7337102942980da$var$toNumber;


/** Used as references for various `Number` constants. */ var $901ca8422c907340$var$INFINITY = 1 / 0, $901ca8422c907340$var$MAX_INTEGER = 1.7976931348623157e+308;
/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */ function $901ca8422c907340$var$toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = $e7337102942980da$exports(value);
    if (value === $901ca8422c907340$var$INFINITY || value === -$901ca8422c907340$var$INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * $901ca8422c907340$var$MAX_INTEGER;
    }
    return value === value ? value : 0;
}
$901ca8422c907340$exports = $901ca8422c907340$var$toFinite;


/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */ function $40ae2580de42a164$var$toInteger(value) {
    var result = $901ca8422c907340$exports(value), remainder = result % 1;
    return result === result ? remainder ? result - remainder : result : 0;
}
$40ae2580de42a164$exports = $40ae2580de42a164$var$toInteger;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $708bf250e939dfa2$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $708bf250e939dfa2$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $40ae2580de42a164$exports(fromIndex);
    if (index < 0) index = $708bf250e939dfa2$var$nativeMax(length + index, 0);
    return $84fd401837261274$exports(array, $0ef980bf7dd42cec$exports(predicate, 3), index);
}
$708bf250e939dfa2$exports = $708bf250e939dfa2$var$findIndex;


/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $2c70d7833d64d5e4$var$find = $00d0bb076c7ba065$exports($708bf250e939dfa2$exports);
$2c70d7833d64d5e4$exports = $2c70d7833d64d5e4$var$find;



var $d47bb8aefe2e817f$exports = {};
var $1b21a616e5a5263c$exports = {};

var $a59532af0b3e85df$exports = {};

var $jVTpz = parcelRequire("jVTpz");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $a59532af0b3e85df$var$now = function() {
    return $jVTpz.Date.now();
};
$a59532af0b3e85df$exports = $a59532af0b3e85df$var$now;



/** Error message constants. */ var $1b21a616e5a5263c$var$FUNC_ERROR_TEXT = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $1b21a616e5a5263c$var$nativeMax = Math.max, $1b21a616e5a5263c$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $1b21a616e5a5263c$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($1b21a616e5a5263c$var$FUNC_ERROR_TEXT);
    wait = $e7337102942980da$exports(wait) || 0;
    if ($6012f8e4c7891baf$exports(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $1b21a616e5a5263c$var$nativeMax($e7337102942980da$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $1b21a616e5a5263c$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $a59532af0b3e85df$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($a59532af0b3e85df$exports());
    }
    function debounced() {
        var time = $a59532af0b3e85df$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$1b21a616e5a5263c$exports = $1b21a616e5a5263c$var$debounce;



/** Error message constants. */ var $d47bb8aefe2e817f$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $d47bb8aefe2e817f$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($d47bb8aefe2e817f$var$FUNC_ERROR_TEXT);
    if ($6012f8e4c7891baf$exports(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $1b21a616e5a5263c$exports(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
$d47bb8aefe2e817f$exports = $d47bb8aefe2e817f$var$throttle;




var $b2fdf882f2ea6452$exports = {};
var $b94b053e153c7c3e$exports = {};
var $2c9ed87873d4f737$exports = {};
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2c9ed87873d4f737$var$nativeCeil = Math.ceil, $2c9ed87873d4f737$var$nativeMax = Math.max;
/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */ function $2c9ed87873d4f737$var$baseRange(start, end, step, fromRight) {
    var index = -1, length = $2c9ed87873d4f737$var$nativeMax($2c9ed87873d4f737$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
    while(length--){
        result[fromRight ? length : ++index] = start;
        start += step;
    }
    return result;
}
$2c9ed87873d4f737$exports = $2c9ed87873d4f737$var$baseRange;




/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */ function $b94b053e153c7c3e$var$createRange(fromRight) {
    return function(start, end, step) {
        if (step && typeof step != "number" && $b49463b59fa498e5$exports(start, end, step)) end = step = undefined;
        // Ensure the sign of `-0` is preserved.
        start = $901ca8422c907340$exports(start);
        if (end === undefined) {
            end = start;
            start = 0;
        } else end = $901ca8422c907340$exports(end);
        step = step === undefined ? start < end ? 1 : -1 : $901ca8422c907340$exports(step);
        return $2c9ed87873d4f737$exports(start, end, step, fromRight);
    };
}
$b94b053e153c7c3e$exports = $b94b053e153c7c3e$var$createRange;


/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */ var $b2fdf882f2ea6452$var$range = $b94b053e153c7c3e$exports();
$b2fdf882f2ea6452$exports = $b2fdf882f2ea6452$var$range;



var $a957fa86a99b0b41$exports = {};


/** `Object#toString` result references. */ var $a957fa86a99b0b41$var$boolTag = "[object Boolean]";
/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */ function $a957fa86a99b0b41$var$isBoolean(value) {
    return value === true || value === false || $61068a3203fea8d0$exports(value) && $8f26fc8d3b90e8ac$exports(value) == $a957fa86a99b0b41$var$boolTag;
}
$a957fa86a99b0b41$exports = $a957fa86a99b0b41$var$isBoolean;




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");






var $eCoWV = parcelRequire("eCoWV");


var $iyeK6 = parcelRequire("iyeK6");




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");

function $660decb81c16d3ef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $660decb81c16d3ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $660decb81c16d3ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $660decb81c16d3ef$var$_typeof(obj);
}
function $660decb81c16d3ef$var$_slicedToArray(arr, i) {
    return $660decb81c16d3ef$var$_arrayWithHoles(arr) || $660decb81c16d3ef$var$_iterableToArrayLimit(arr, i) || $660decb81c16d3ef$var$_unsupportedIterableToArray(arr, i) || $660decb81c16d3ef$var$_nonIterableRest();
}
function $660decb81c16d3ef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $660decb81c16d3ef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $660decb81c16d3ef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $660decb81c16d3ef$var$_arrayLikeToArray(o, minLen);
}
function $660decb81c16d3ef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $660decb81c16d3ef$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $660decb81c16d3ef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $660decb81c16d3ef$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $660decb81c16d3ef$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $660decb81c16d3ef$var$ownKeys(Object(source), true).forEach(function(key) {
            $660decb81c16d3ef$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $660decb81c16d3ef$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $660decb81c16d3ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $660decb81c16d3ef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $660decb81c16d3ef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $660decb81c16d3ef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $660decb81c16d3ef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $660decb81c16d3ef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $660decb81c16d3ef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $660decb81c16d3ef$var$_setPrototypeOf(subClass, superClass);
}
function $660decb81c16d3ef$var$_setPrototypeOf(o, p) {
    $660decb81c16d3ef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $660decb81c16d3ef$var$_setPrototypeOf(o, p);
}
function $660decb81c16d3ef$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $660decb81c16d3ef$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $660decb81c16d3ef$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $660decb81c16d3ef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $660decb81c16d3ef$var$_possibleConstructorReturn(this, result);
    };
}
function $660decb81c16d3ef$var$_possibleConstructorReturn(self, call) {
    if (call && ($660decb81c16d3ef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $660decb81c16d3ef$var$_assertThisInitialized(self);
}
function $660decb81c16d3ef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $660decb81c16d3ef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $660decb81c16d3ef$var$_getPrototypeOf(o) {
    $660decb81c16d3ef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $660decb81c16d3ef$var$_getPrototypeOf(o);
}
function $660decb81c16d3ef$var$defaultFormatter(value) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(value) && (0, $a4d9ec64928c627b$export$402a499e1ea44294)(value[0]) && (0, $a4d9ec64928c627b$export$402a499e1ea44294)(value[1]) ? value.join(" ~ ") : value;
}
var $660decb81c16d3ef$export$6fe33945eebf9ac8 = /*#__PURE__*/ function(_PureComponent) {
    $660decb81c16d3ef$var$_inherits(DefaultTooltipContent, _PureComponent);
    var _super = $660decb81c16d3ef$var$_createSuper(DefaultTooltipContent);
    function DefaultTooltipContent() {
        $660decb81c16d3ef$var$_classCallCheck(this, DefaultTooltipContent);
        return _super.apply(this, arguments);
    }
    $660decb81c16d3ef$var$_createClass(DefaultTooltipContent, [
        {
            key: "renderContent",
            value: function renderContent() {
                var _this$props = this.props, payload = _this$props.payload, separator = _this$props.separator, formatter = _this$props.formatter, itemStyle = _this$props.itemStyle, itemSorter = _this$props.itemSorter;
                if (payload && payload.length) {
                    var listStyle = {
                        padding: 0,
                        margin: 0
                    };
                    var items = (itemSorter ? (0, (/*@__PURE__*/$parcel$interopDefault($421c39c39f87f3ba$exports)))(payload, itemSorter) : payload).map(function(entry, i) {
                        if (entry.type === "none") return null;
                        var finalItemStyle = $660decb81c16d3ef$var$_objectSpread({
                            display: "block",
                            paddingTop: 4,
                            paddingBottom: 4,
                            color: entry.color || "#000"
                        }, itemStyle);
                        var finalFormatter = entry.formatter || formatter || $660decb81c16d3ef$var$defaultFormatter;
                        var name = entry.name, value = entry.value;
                        if (finalFormatter) {
                            var formatted = finalFormatter(value, name, entry, i, payload);
                            if (Array.isArray(formatted)) {
                                var _formatted = $660decb81c16d3ef$var$_slicedToArray(formatted, 2);
                                value = _formatted[0];
                                name = _formatted[1];
                            } else value = formatted;
                        }
                        return(/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
                        (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("li", {
                            className: "recharts-tooltip-item",
                            key: "tooltip-item-".concat(i),
                            style: finalItemStyle
                        }, (0, $a4d9ec64928c627b$export$402a499e1ea44294)(name) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
                            className: "recharts-tooltip-item-name"
                        }, name) : null, (0, $a4d9ec64928c627b$export$402a499e1ea44294)(name) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
                            className: "recharts-tooltip-item-separator"
                        }, separator) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
                            className: "recharts-tooltip-item-value"
                        }, value), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("span", {
                            className: "recharts-tooltip-item-unit"
                        }, entry.unit || "")));
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("ul", {
                        className: "recharts-tooltip-item-list",
                        style: listStyle
                    }, items);
                }
                return null;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props2 = this.props, wrapperClassName = _this$props2.wrapperClassName, contentStyle = _this$props2.contentStyle, labelClassName = _this$props2.labelClassName, labelStyle = _this$props2.labelStyle, label = _this$props2.label, labelFormatter = _this$props2.labelFormatter, payload = _this$props2.payload;
                var finalStyle = $660decb81c16d3ef$var$_objectSpread({
                    margin: 0,
                    padding: 10,
                    backgroundColor: "#fff",
                    border: "1px solid #ccc",
                    whiteSpace: "nowrap"
                }, contentStyle);
                var finalLabelStyle = $660decb81c16d3ef$var$_objectSpread({
                    margin: 0
                }, labelStyle);
                var hasLabel = !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(label);
                var finalLabel = hasLabel ? label : "";
                var wrapperCN = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-default-tooltip", wrapperClassName);
                var labelCN = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-tooltip-label", labelClassName);
                if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    className: wrapperCN,
                    style: finalStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("p", {
                    className: labelCN,
                    style: finalLabelStyle
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), this.renderContent());
            }
        }
    ]);
    return DefaultTooltipContent;
}((0, $eCoWV.PureComponent));
$660decb81c16d3ef$export$6fe33945eebf9ac8.displayName = "DefaultTooltipContent";
$660decb81c16d3ef$export$6fe33945eebf9ac8.defaultProps = {
    separator: " : ",
    contentStyle: {},
    itemStyle: {},
    labelStyle: {}
};




function $b4b3fd02c5ccdb66$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b4b3fd02c5ccdb66$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b4b3fd02c5ccdb66$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b4b3fd02c5ccdb66$var$_typeof(obj);
}
function $b4b3fd02c5ccdb66$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $b4b3fd02c5ccdb66$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $b4b3fd02c5ccdb66$var$ownKeys(Object(source), true).forEach(function(key) {
            $b4b3fd02c5ccdb66$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $b4b3fd02c5ccdb66$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $b4b3fd02c5ccdb66$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $b4b3fd02c5ccdb66$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $b4b3fd02c5ccdb66$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b4b3fd02c5ccdb66$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $b4b3fd02c5ccdb66$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b4b3fd02c5ccdb66$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $b4b3fd02c5ccdb66$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $b4b3fd02c5ccdb66$var$_setPrototypeOf(subClass, superClass);
}
function $b4b3fd02c5ccdb66$var$_setPrototypeOf(o, p) {
    $b4b3fd02c5ccdb66$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $b4b3fd02c5ccdb66$var$_setPrototypeOf(o, p);
}
function $b4b3fd02c5ccdb66$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b4b3fd02c5ccdb66$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $b4b3fd02c5ccdb66$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $b4b3fd02c5ccdb66$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $b4b3fd02c5ccdb66$var$_possibleConstructorReturn(this, result);
    };
}
function $b4b3fd02c5ccdb66$var$_possibleConstructorReturn(self, call) {
    if (call && ($b4b3fd02c5ccdb66$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $b4b3fd02c5ccdb66$var$_assertThisInitialized(self);
}
function $b4b3fd02c5ccdb66$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $b4b3fd02c5ccdb66$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $b4b3fd02c5ccdb66$var$_getPrototypeOf(o) {
    $b4b3fd02c5ccdb66$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $b4b3fd02c5ccdb66$var$_getPrototypeOf(o);
}
var $b4b3fd02c5ccdb66$var$CLS_PREFIX = "recharts-tooltip-wrapper";
var $b4b3fd02c5ccdb66$var$EPS = 1;
function $b4b3fd02c5ccdb66$var$defaultUniqBy(entry) {
    return entry.dataKey;
}
function $b4b3fd02c5ccdb66$var$getUniqPayload(option, payload) {
    if (option === true) return (0, (/*@__PURE__*/$parcel$interopDefault($3cd389e91472e4cd$exports)))(payload, $b4b3fd02c5ccdb66$var$defaultUniqBy);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) return (0, (/*@__PURE__*/$parcel$interopDefault($3cd389e91472e4cd$exports)))(payload, option);
    return payload;
}
function $b4b3fd02c5ccdb66$var$renderContent(content, props) {
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(content, props);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(content)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement(content, props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $660decb81c16d3ef$export$6fe33945eebf9ac8), props);
}
var $b4b3fd02c5ccdb66$export$28c660c63b792dea = /*#__PURE__*/ function(_PureComponent) {
    $b4b3fd02c5ccdb66$var$_inherits(Tooltip, _PureComponent);
    var _super = $b4b3fd02c5ccdb66$var$_createSuper(Tooltip);
    function Tooltip() {
        var _this;
        $b4b3fd02c5ccdb66$var$_classCallCheck(this, Tooltip);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            boxWidth: -1,
            boxHeight: -1,
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        };
        _this.wrapperNode = void 0;
        _this.getTranslate = function(_ref) {
            var key = _ref.key, tooltipDimension = _ref.tooltipDimension, viewBoxDimension = _ref.viewBoxDimension;
            var _this$props = _this.props, allowEscapeViewBox = _this$props.allowEscapeViewBox, coordinate = _this$props.coordinate, offset = _this$props.offset, position = _this$props.position, viewBox = _this$props.viewBox;
            if (position && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(position[key])) return position[key];
            var restricted = coordinate[key] - tooltipDimension - offset;
            var unrestricted = coordinate[key] + offset;
            if (allowEscapeViewBox[key]) return unrestricted;
            var tooltipBoundary = coordinate[key] + tooltipDimension + offset;
            var viewBoxBoundary = viewBox[key] + viewBoxDimension;
            if (tooltipBoundary > viewBoxBoundary) return Math.max(restricted, viewBox[key]);
            return Math.max(unrestricted, viewBox[key]);
        };
        return _this;
    }
    $b4b3fd02c5ccdb66$var$_createClass(Tooltip, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.updateBBox();
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.updateBBox();
            }
        },
        {
            key: "updateBBox",
            value: function updateBBox() {
                var _this$state = this.state, boxWidth = _this$state.boxWidth, boxHeight = _this$state.boxHeight, dismissed = _this$state.dismissed;
                if (dismissed) {
                    this.wrapperNode.blur();
                    if (this.props.coordinate.x !== this.state.dismissedAtCoordinate.x || this.props.coordinate.y !== this.state.dismissedAtCoordinate.y) this.setState({
                        dismissed: false
                    });
                } else this.wrapperNode.focus();
                if (this.wrapperNode && this.wrapperNode.getBoundingClientRect) {
                    var box = this.wrapperNode.getBoundingClientRect();
                    if (Math.abs(box.width - boxWidth) > $b4b3fd02c5ccdb66$var$EPS || Math.abs(box.height - boxHeight) > $b4b3fd02c5ccdb66$var$EPS) this.setState({
                        boxWidth: box.width,
                        boxHeight: box.height
                    });
                } else if (boxWidth !== -1 || boxHeight !== -1) this.setState({
                    boxWidth: -1,
                    boxHeight: -1
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _classNames, _this2 = this;
                var _this$props2 = this.props, payload = _this$props2.payload, isAnimationActive = _this$props2.isAnimationActive, animationDuration = _this$props2.animationDuration, animationEasing = _this$props2.animationEasing, filterNull = _this$props2.filterNull, payloadUniqBy = _this$props2.payloadUniqBy;
                var finalPayload = $b4b3fd02c5ccdb66$var$getUniqPayload(payloadUniqBy, filterNull && payload && payload.length ? payload.filter(function(entry) {
                    return !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry.value);
                }) : payload);
                var hasPayload = finalPayload && finalPayload.length;
                var _this$props3 = this.props, content = _this$props3.content, viewBox = _this$props3.viewBox, coordinate = _this$props3.coordinate, position = _this$props3.position, active = _this$props3.active, wrapperStyle = _this$props3.wrapperStyle;
                var outerStyle = $b4b3fd02c5ccdb66$var$_objectSpread({
                    pointerEvents: "none",
                    visibility: !this.state.dismissed && active && hasPayload ? "visible" : "hidden",
                    position: "absolute",
                    top: 0,
                    left: 0
                }, wrapperStyle);
                var translateX, translateY;
                if (position && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(position.x) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(position.y)) {
                    translateX = position.x;
                    translateY = position.y;
                } else {
                    var _this$state2 = this.state, boxWidth = _this$state2.boxWidth, boxHeight = _this$state2.boxHeight;
                    if (boxWidth > 0 && boxHeight > 0 && coordinate) {
                        translateX = this.getTranslate({
                            key: "x",
                            tooltipDimension: boxWidth,
                            viewBoxDimension: viewBox.width
                        });
                        translateY = this.getTranslate({
                            key: "y",
                            tooltipDimension: boxHeight,
                            viewBoxDimension: viewBox.height
                        });
                    } else outerStyle.visibility = "hidden";
                }
                outerStyle = $b4b3fd02c5ccdb66$var$_objectSpread($b4b3fd02c5ccdb66$var$_objectSpread({}, (0, $95a61dc07598fcdc$export$ff9926a5d1daa67c)({
                    transform: this.props.useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
                })), outerStyle);
                if (isAnimationActive && active) outerStyle = $b4b3fd02c5ccdb66$var$_objectSpread($b4b3fd02c5ccdb66$var$_objectSpread({}, (0, $95a61dc07598fcdc$export$ff9926a5d1daa67c)({
                    transition: "transform ".concat(animationDuration, "ms ").concat(animationEasing)
                })), outerStyle);
                var cls = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($b4b3fd02c5ccdb66$var$CLS_PREFIX, (_classNames = {}, $b4b3fd02c5ccdb66$var$_defineProperty(_classNames, "".concat($b4b3fd02c5ccdb66$var$CLS_PREFIX, "-right"), (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(coordinate.x) && translateX >= coordinate.x), $b4b3fd02c5ccdb66$var$_defineProperty(_classNames, "".concat($b4b3fd02c5ccdb66$var$CLS_PREFIX, "-left"), (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(translateX) && coordinate && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(coordinate.x) && translateX < coordinate.x), $b4b3fd02c5ccdb66$var$_defineProperty(_classNames, "".concat($b4b3fd02c5ccdb66$var$CLS_PREFIX, "-bottom"), (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(coordinate.y) && translateY >= coordinate.y), $b4b3fd02c5ccdb66$var$_defineProperty(_classNames, "".concat($b4b3fd02c5ccdb66$var$CLS_PREFIX, "-top"), (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(translateY) && coordinate && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(coordinate.y) && translateY < coordinate.y), _classNames));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", {
                    tabIndex: 0,
                    onKeyDown: function onKeyDown(event) {
                        if (event.key === "Escape") _this2.setState({
                            dismissed: true,
                            dismissedAtCoordinate: $b4b3fd02c5ccdb66$var$_objectSpread($b4b3fd02c5ccdb66$var$_objectSpread({}, _this2.state.dismissedAtCoordinate), {}, {
                                x: _this2.props.coordinate.x,
                                y: _this2.props.coordinate.y
                            })
                        });
                    },
                    className: cls,
                    style: outerStyle,
                    ref: function ref(node) {
                        _this2.wrapperNode = node;
                    }
                }, $b4b3fd02c5ccdb66$var$renderContent(content, $b4b3fd02c5ccdb66$var$_objectSpread($b4b3fd02c5ccdb66$var$_objectSpread({}, this.props), {}, {
                    payload: finalPayload
                })));
            }
        }
    ]);
    return Tooltip;
}((0, $eCoWV.PureComponent));
$b4b3fd02c5ccdb66$export$28c660c63b792dea.displayName = "Tooltip";
$b4b3fd02c5ccdb66$export$28c660c63b792dea.defaultProps = {
    active: false,
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    offset: 10,
    viewBox: {
        x1: 0,
        x2: 0,
        y1: 0,
        y2: 0
    },
    coordinate: {
        x: 0,
        y: 0
    },
    cursorStyle: {},
    separator: " : ",
    wrapperStyle: {},
    contentStyle: {},
    itemStyle: {},
    labelStyle: {},
    cursor: true,
    trigger: "hover",
    isAnimationActive: !(0, $2cfdd8db3ab543a8$export$98f03c5d19621d70).isSsr,
    animationEasing: "ease",
    animationDuration: 400,
    filterNull: true,
    useTranslate3d: false
};





var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");


function $9a5c5df298bd3ceb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $9a5c5df298bd3ceb$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $9a5c5df298bd3ceb$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $9a5c5df298bd3ceb$var$_typeof(obj);
}
function $9a5c5df298bd3ceb$var$_extends() {
    $9a5c5df298bd3ceb$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9a5c5df298bd3ceb$var$_extends.apply(this, arguments);
}
function $9a5c5df298bd3ceb$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $9a5c5df298bd3ceb$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $9a5c5df298bd3ceb$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $9a5c5df298bd3ceb$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $9a5c5df298bd3ceb$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $9a5c5df298bd3ceb$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $9a5c5df298bd3ceb$var$_setPrototypeOf(subClass, superClass);
}
function $9a5c5df298bd3ceb$var$_setPrototypeOf(o, p) {
    $9a5c5df298bd3ceb$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $9a5c5df298bd3ceb$var$_setPrototypeOf(o, p);
}
function $9a5c5df298bd3ceb$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $9a5c5df298bd3ceb$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $9a5c5df298bd3ceb$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $9a5c5df298bd3ceb$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $9a5c5df298bd3ceb$var$_possibleConstructorReturn(this, result);
    };
}
function $9a5c5df298bd3ceb$var$_possibleConstructorReturn(self, call) {
    if (call && ($9a5c5df298bd3ceb$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $9a5c5df298bd3ceb$var$_assertThisInitialized(self);
}
function $9a5c5df298bd3ceb$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $9a5c5df298bd3ceb$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $9a5c5df298bd3ceb$var$_getPrototypeOf(o) {
    $9a5c5df298bd3ceb$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $9a5c5df298bd3ceb$var$_getPrototypeOf(o);
}
var $9a5c5df298bd3ceb$export$3c877bb842c36952 = /*#__PURE__*/ function(_PureComponent) {
    $9a5c5df298bd3ceb$var$_inherits(Cross, _PureComponent);
    var _super = $9a5c5df298bd3ceb$var$_createSuper(Cross);
    function Cross() {
        $9a5c5df298bd3ceb$var$_classCallCheck(this, Cross);
        return _super.apply(this, arguments);
    }
    $9a5c5df298bd3ceb$var$_createClass(Cross, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, width = _this$props.width, height = _this$props.height, top = _this$props.top, left = _this$props.left, className = _this$props.className;
                if (!(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(x) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(y) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(height) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(top) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(left)) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $9a5c5df298bd3ceb$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props, true), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-cross", className),
                    d: Cross.getPath(x, y, width, height, top, left)
                }));
            }
        }
    ], [
        {
            key: "getPath",
            value: function getPath(x, y, width, height, top, left) {
                return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
            }
        }
    ]);
    return Cross;
}((0, $eCoWV.PureComponent));
$9a5c5df298bd3ceb$export$3c877bb842c36952.defaultProps = {
    x: 0,
    y: 0,
    top: 0,
    left: 0,
    width: 0,
    height: 0
};



var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");



function $57a3d2c9ea84bfee$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $57a3d2c9ea84bfee$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $57a3d2c9ea84bfee$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $57a3d2c9ea84bfee$var$_typeof(obj);
}
function $57a3d2c9ea84bfee$var$_extends() {
    $57a3d2c9ea84bfee$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $57a3d2c9ea84bfee$var$_extends.apply(this, arguments);
}
function $57a3d2c9ea84bfee$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $57a3d2c9ea84bfee$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $57a3d2c9ea84bfee$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $57a3d2c9ea84bfee$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $57a3d2c9ea84bfee$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $57a3d2c9ea84bfee$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $57a3d2c9ea84bfee$var$_setPrototypeOf(subClass, superClass);
}
function $57a3d2c9ea84bfee$var$_setPrototypeOf(o, p) {
    $57a3d2c9ea84bfee$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $57a3d2c9ea84bfee$var$_setPrototypeOf(o, p);
}
function $57a3d2c9ea84bfee$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $57a3d2c9ea84bfee$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $57a3d2c9ea84bfee$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $57a3d2c9ea84bfee$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $57a3d2c9ea84bfee$var$_possibleConstructorReturn(this, result);
    };
}
function $57a3d2c9ea84bfee$var$_possibleConstructorReturn(self, call) {
    if (call && ($57a3d2c9ea84bfee$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $57a3d2c9ea84bfee$var$_assertThisInitialized(self);
}
function $57a3d2c9ea84bfee$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $57a3d2c9ea84bfee$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $57a3d2c9ea84bfee$var$_getPrototypeOf(o) {
    $57a3d2c9ea84bfee$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $57a3d2c9ea84bfee$var$_getPrototypeOf(o);
}
var $57a3d2c9ea84bfee$var$getDeltaAngle = function getDeltaAngle(startAngle, endAngle) {
    var sign = (0, $a4d9ec64928c627b$export$9d334328eb75e624)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var $57a3d2c9ea84bfee$var$getTangentCircle = function getTangentCircle(_ref) {
    var cx = _ref.cx, cy = _ref.cy, radius = _ref.radius, angle = _ref.angle, sign = _ref.sign, isExternal = _ref.isExternal, cornerRadius = _ref.cornerRadius, cornerIsExternal = _ref.cornerIsExternal;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, $0fac551513a25c6a$export$d74e8f7e9cc3fed3);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, centerRadius, centerAngle); // The coordinate of point which is tangent to the circle
    var circleTangency = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, radius, centerAngle); // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, centerRadius * Math.cos(theta * (0, $0fac551513a25c6a$export$d74e8f7e9cc3fed3)), lineTangencyAngle);
    return {
        center: center,
        circleTangency: circleTangency,
        lineTangency: lineTangency,
        theta: theta
    };
};
var $57a3d2c9ea84bfee$var$getSectorPath = function getSectorPath(_ref2) {
    var cx = _ref2.cx, cy = _ref2.cy, innerRadius = _ref2.innerRadius, outerRadius = _ref2.outerRadius, startAngle = _ref2.startAngle, endAngle = _ref2.endAngle;
    var angle = $57a3d2c9ea84bfee$var$getDeltaAngle(startAngle, endAngle); // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, tempEndAngle);
    var path = "M ".concat(outerStartPoint.x, ",").concat(outerStartPoint.y, "\n    A ").concat(outerRadius, ",").concat(outerRadius, ",0,\n    ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle > tempEndAngle), ",\n    ").concat(outerEndPoint.x, ",").concat(outerEndPoint.y, "\n  ");
    if (innerRadius > 0) {
        var innerStartPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, tempEndAngle);
        path += "L ".concat(innerEndPoint.x, ",").concat(innerEndPoint.y, "\n            A ").concat(innerRadius, ",").concat(innerRadius, ",0,\n            ").concat(+(Math.abs(angle) > 180), ",").concat(+(startAngle <= tempEndAngle), ",\n            ").concat(innerStartPoint.x, ",").concat(innerStartPoint.y, " Z");
    } else path += "L ".concat(cx, ",").concat(cy, " Z");
    return path;
};
var $57a3d2c9ea84bfee$var$getSectorWithCorner = function getSectorWithCorner(_ref3) {
    var cx = _ref3.cx, cy = _ref3.cy, innerRadius = _ref3.innerRadius, outerRadius = _ref3.outerRadius, cornerRadius = _ref3.cornerRadius, forceCornerRadius = _ref3.forceCornerRadius, cornerIsExternal = _ref3.cornerIsExternal, startAngle = _ref3.startAngle, endAngle = _ref3.endAngle;
    var sign = (0, $a4d9ec64928c627b$export$9d334328eb75e624)(endAngle - startAngle);
    var _getTangentCircle = $57a3d2c9ea84bfee$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: startAngle,
        sign: sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), soct = _getTangentCircle.circleTangency, solt = _getTangentCircle.lineTangency, sot = _getTangentCircle.theta;
    var _getTangentCircle2 = $57a3d2c9ea84bfee$var$getTangentCircle({
        cx: cx,
        cy: cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius: cornerRadius,
        cornerIsExternal: cornerIsExternal
    }), eoct = _getTangentCircle2.circleTangency, eolt = _getTangentCircle2.lineTangency, eot = _getTangentCircle2.theta;
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return "M ".concat(solt.x, ",").concat(solt.y, "\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(cornerRadius * 2, ",0\n        a").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,1,").concat(-cornerRadius * 2, ",0\n      ");
        return $57a3d2c9ea84bfee$var$getSectorPath({
            cx: cx,
            cy: cy,
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            startAngle: startAngle,
            endAngle: endAngle
        });
    }
    var path = "M ".concat(solt.x, ",").concat(solt.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(soct.x, ",").concat(soct.y, "\n    A").concat(outerRadius, ",").concat(outerRadius, ",0,").concat(+(outerArcAngle > 180), ",").concat(+(sign < 0), ",").concat(eoct.x, ",").concat(eoct.y, "\n    A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eolt.x, ",").concat(eolt.y, "\n  ");
    if (innerRadius > 0) {
        var _getTangentCircle3 = $57a3d2c9ea84bfee$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: startAngle,
            sign: sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), sict = _getTangentCircle3.circleTangency, silt = _getTangentCircle3.lineTangency, sit = _getTangentCircle3.theta;
        var _getTangentCircle4 = $57a3d2c9ea84bfee$var$getTangentCircle({
            cx: cx,
            cy: cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius: cornerRadius,
            cornerIsExternal: cornerIsExternal
        }), eict = _getTangentCircle4.circleTangency, eilt = _getTangentCircle4.lineTangency, eit = _getTangentCircle4.theta;
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += "L".concat(eilt.x, ",").concat(eilt.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(eict.x, ",").concat(eict.y, "\n      A").concat(innerRadius, ",").concat(innerRadius, ",0,").concat(+(innerArcAngle > 180), ",").concat(+(sign > 0), ",").concat(sict.x, ",").concat(sict.y, "\n      A").concat(cornerRadius, ",").concat(cornerRadius, ",0,0,").concat(+(sign < 0), ",").concat(silt.x, ",").concat(silt.y, "Z");
    } else path += "L".concat(cx, ",").concat(cy, "Z");
    return path;
};
var $57a3d2c9ea84bfee$export$e98c2c7eb2b14f45 = /*#__PURE__*/ function(_PureComponent) {
    $57a3d2c9ea84bfee$var$_inherits(Sector, _PureComponent);
    var _super = $57a3d2c9ea84bfee$var$_createSuper(Sector);
    function Sector() {
        $57a3d2c9ea84bfee$var$_classCallCheck(this, Sector);
        return _super.apply(this, arguments);
    }
    $57a3d2c9ea84bfee$var$_createClass(Sector, [
        {
            key: "render",
            value: function render() {
                var _this$props = this.props, cx = _this$props.cx, cy = _this$props.cy, innerRadius = _this$props.innerRadius, outerRadius = _this$props.outerRadius, cornerRadius = _this$props.cornerRadius, forceCornerRadius = _this$props.forceCornerRadius, cornerIsExternal = _this$props.cornerIsExternal, startAngle = _this$props.startAngle, endAngle = _this$props.endAngle, className = _this$props.className;
                if (outerRadius < innerRadius || startAngle === endAngle) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-sector", className);
                var deltaRadius = outerRadius - innerRadius;
                var cr = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(cornerRadius, deltaRadius, 0, true);
                var path;
                if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = $57a3d2c9ea84bfee$var$getSectorWithCorner({
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    cornerRadius: Math.min(cr, deltaRadius / 2),
                    forceCornerRadius: forceCornerRadius,
                    cornerIsExternal: cornerIsExternal,
                    startAngle: startAngle,
                    endAngle: endAngle
                });
                else path = $57a3d2c9ea84bfee$var$getSectorPath({
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    startAngle: startAngle,
                    endAngle: endAngle
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $57a3d2c9ea84bfee$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props, true), {
                    className: layerClass,
                    d: path
                }));
            }
        }
    ]);
    return Sector;
}((0, $eCoWV.PureComponent));
$57a3d2c9ea84bfee$export$e98c2c7eb2b14f45.defaultProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");


function $f932de744a8ef4df$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f932de744a8ef4df$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f932de744a8ef4df$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f932de744a8ef4df$var$_typeof(obj);
}
function $f932de744a8ef4df$var$_extends() {
    $f932de744a8ef4df$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f932de744a8ef4df$var$_extends.apply(this, arguments);
}
function $f932de744a8ef4df$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f932de744a8ef4df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f932de744a8ef4df$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f932de744a8ef4df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f932de744a8ef4df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f932de744a8ef4df$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f932de744a8ef4df$var$_setPrototypeOf(subClass, superClass);
}
function $f932de744a8ef4df$var$_setPrototypeOf(o, p) {
    $f932de744a8ef4df$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f932de744a8ef4df$var$_setPrototypeOf(o, p);
}
function $f932de744a8ef4df$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $f932de744a8ef4df$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $f932de744a8ef4df$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $f932de744a8ef4df$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f932de744a8ef4df$var$_possibleConstructorReturn(this, result);
    };
}
function $f932de744a8ef4df$var$_possibleConstructorReturn(self, call) {
    if (call && ($f932de744a8ef4df$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f932de744a8ef4df$var$_assertThisInitialized(self);
}
function $f932de744a8ef4df$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f932de744a8ef4df$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f932de744a8ef4df$var$_getPrototypeOf(o) {
    $f932de744a8ef4df$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f932de744a8ef4df$var$_getPrototypeOf(o);
}
var $f932de744a8ef4df$var$getRectanglePath = function getRectanglePath(x, y, width, height, radius) {
    var maxRadius = Math.min(Math.abs(width) / 2, Math.abs(height) / 2);
    var ySign = height >= 0 ? 1 : -1;
    var xSign = width >= 0 ? 1 : -1;
    var clockWise = height >= 0 && width >= 0 || height < 0 && width < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = "M".concat(x, ",").concat(y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += "A ".concat(newRadius[0], ",").concat(newRadius[0], ",0,0,").concat(clockWise, ",").concat(x + xSign * newRadius[0], ",").concat(y);
        path += "L ".concat(x + width - xSign * newRadius[1], ",").concat(y);
        if (newRadius[1] > 0) path += "A ".concat(newRadius[1], ",").concat(newRadius[1], ",0,0,").concat(clockWise, ",\n        ").concat(x + width, ",").concat(y + ySign * newRadius[1]);
        path += "L ".concat(x + width, ",").concat(y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += "A ".concat(newRadius[2], ",").concat(newRadius[2], ",0,0,").concat(clockWise, ",\n        ").concat(x + width - xSign * newRadius[2], ",").concat(y + height);
        path += "L ".concat(x + xSign * newRadius[3], ",").concat(y + height);
        if (newRadius[3] > 0) path += "A ".concat(newRadius[3], ",").concat(newRadius[3], ",0,0,").concat(clockWise, ",\n        ").concat(x, ",").concat(y + height - ySign * newRadius[3]);
        path += "Z";
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = "M ".concat(x, ",").concat(y + ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + xSign * _newRadius, ",").concat(y, "\n            L ").concat(x + width - xSign * _newRadius, ",").concat(y, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width, ",").concat(y + ySign * _newRadius, "\n            L ").concat(x + width, ",").concat(y + height - ySign * _newRadius, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x + width - xSign * _newRadius, ",").concat(y + height, "\n            L ").concat(x + xSign * _newRadius, ",").concat(y + height, "\n            A ").concat(_newRadius, ",").concat(_newRadius, ",0,0,").concat(clockWise, ",").concat(x, ",").concat(y + height - ySign * _newRadius, " Z");
    } else path = "M ".concat(x, ",").concat(y, " h ").concat(width, " v ").concat(height, " h ").concat(-width, " Z");
    return path;
};
var $f932de744a8ef4df$export$f783d19325be51d5 = function isInRectangle(point, rect) {
    if (!point || !rect) return false;
    var px = point.x, py = point.y;
    var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
    if (Math.abs(width) > 0 && Math.abs(height) > 0) {
        var minX = Math.min(x, x + width);
        var maxX = Math.max(x, x + width);
        var minY = Math.min(y, y + height);
        var maxY = Math.max(y, y + height);
        return px >= minX && px <= maxX && py >= minY && py <= maxY;
    }
    return false;
};
var $f932de744a8ef4df$export$4617fb02663045ef = /*#__PURE__*/ function(_PureComponent) {
    $f932de744a8ef4df$var$_inherits(Rectangle, _PureComponent);
    var _super = $f932de744a8ef4df$var$_createSuper(Rectangle);
    function Rectangle() {
        var _this;
        $f932de744a8ef4df$var$_classCallCheck(this, Rectangle);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = _super.call.apply(_super, [
            this
        ].concat(args));
        _this.state = {
            totalLength: -1
        };
        _this.node = void 0;
        return _this;
    }
    $f932de744a8ef4df$var$_createClass(Rectangle, [
        {
            key: "componentDidMount",
            value: /* eslint-disable  react/no-did-mount-set-state */ function componentDidMount() {
                if (this.node && this.node.getTotalLength) try {
                    var totalLength = this.node.getTotalLength();
                    if (totalLength) this.setState({
                        totalLength: totalLength
                    });
                } catch (err) {}
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, x = _this$props.x, y = _this$props.y, width = _this$props.width, height = _this$props.height, radius = _this$props.radius, className = _this$props.className;
                var totalLength = this.state.totalLength;
                var _this$props2 = this.props, animationEasing = _this$props2.animationEasing, animationDuration = _this$props2.animationDuration, animationBegin = _this$props2.animationBegin, isAnimationActive = _this$props2.isAnimationActive, isUpdateAnimationActive = _this$props2.isUpdateAnimationActive;
                if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-rectangle", className);
                if (!isUpdateAnimationActive) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $f932de744a8ef4df$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props, true), {
                    className: layerClass,
                    d: $f932de744a8ef4df$var$getRectanglePath(x, y, width, height, radius)
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d7ffd80b59fbbca7$export$2e2bcd8739ae039), {
                    canBegin: totalLength > 0,
                    from: {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    },
                    to: {
                        width: width,
                        height: height,
                        x: x,
                        y: y
                    },
                    duration: animationDuration,
                    animationEasing: animationEasing,
                    isActive: isUpdateAnimationActive
                }, function(_ref) {
                    var currWidth = _ref.width, currHeight = _ref.height, currX = _ref.x, currY = _ref.y;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $d7ffd80b59fbbca7$export$2e2bcd8739ae039), {
                        canBegin: totalLength > 0,
                        from: "0px ".concat(totalLength === -1 ? 1 : totalLength, "px"),
                        to: "".concat(totalLength, "px 0px"),
                        attributeName: "strokeDasharray",
                        begin: animationBegin,
                        duration: animationDuration,
                        isActive: isAnimationActive,
                        easing: animationEasing
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("path", $f932de744a8ef4df$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(_this2.props, true), {
                        className: layerClass,
                        d: $f932de744a8ef4df$var$getRectanglePath(currX, currY, currWidth, currHeight, radius),
                        ref: function ref(node) {
                            _this2.node = node;
                        }
                    })));
                });
            }
        }
    ]);
    return Rectangle;
}((0, $eCoWV.PureComponent));
$f932de744a8ef4df$export$4617fb02663045ef.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: "ease"
};






var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");








function $fbb091d423dfa995$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $fbb091d423dfa995$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $fbb091d423dfa995$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $fbb091d423dfa995$var$_typeof(obj);
}
function $fbb091d423dfa995$var$_extends() {
    $fbb091d423dfa995$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $fbb091d423dfa995$var$_extends.apply(this, arguments);
}
function $fbb091d423dfa995$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $fbb091d423dfa995$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $fbb091d423dfa995$var$ownKeys(Object(source), true).forEach(function(key) {
            $fbb091d423dfa995$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $fbb091d423dfa995$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $fbb091d423dfa995$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $fbb091d423dfa995$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $fbb091d423dfa995$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $fbb091d423dfa995$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $fbb091d423dfa995$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbb091d423dfa995$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $fbb091d423dfa995$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $fbb091d423dfa995$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $fbb091d423dfa995$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $fbb091d423dfa995$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $fbb091d423dfa995$var$_setPrototypeOf(subClass, superClass);
}
function $fbb091d423dfa995$var$_setPrototypeOf(o, p) {
    $fbb091d423dfa995$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $fbb091d423dfa995$var$_setPrototypeOf(o, p);
}
function $fbb091d423dfa995$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $fbb091d423dfa995$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $fbb091d423dfa995$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $fbb091d423dfa995$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $fbb091d423dfa995$var$_possibleConstructorReturn(this, result);
    };
}
function $fbb091d423dfa995$var$_possibleConstructorReturn(self, call) {
    if (call && ($fbb091d423dfa995$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $fbb091d423dfa995$var$_assertThisInitialized(self);
}
function $fbb091d423dfa995$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $fbb091d423dfa995$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $fbb091d423dfa995$var$_getPrototypeOf(o) {
    $fbb091d423dfa995$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $fbb091d423dfa995$var$_getPrototypeOf(o);
}
var $fbb091d423dfa995$export$bdd99f2cdf352bae = /*#__PURE__*/ function(_Component) {
    $fbb091d423dfa995$var$_inherits(CartesianAxis, _Component);
    var _super = $fbb091d423dfa995$var$_createSuper(CartesianAxis);
    function CartesianAxis() {
        $fbb091d423dfa995$var$_classCallCheck(this, CartesianAxis);
        return _super.apply(this, arguments);
    }
    $fbb091d423dfa995$var$_createClass(CartesianAxis, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(_ref) {
                var viewBox = _ref.viewBox, restProps = $fbb091d423dfa995$var$_objectWithoutProperties(_ref, [
                    "viewBox"
                ]);
                // props.viewBox is sometimes generated every time -
                // check that specially as object equality is likely to fail
                var _this$props = this.props, viewBoxOld = _this$props.viewBox, restPropsOld = $fbb091d423dfa995$var$_objectWithoutProperties(_this$props, [
                    "viewBox"
                ]);
                return !(0, $876e5fb324af2e46$export$d36bdfa510afb180)(viewBox, viewBoxOld) || !(0, $876e5fb324af2e46$export$d36bdfa510afb180)(restProps, restPropsOld);
            }
        },
        {
            key: "getTickLineCoord",
            value: function getTickLineCoord(data) {
                var _this$props2 = this.props, x = _this$props2.x, y = _this$props2.y, width = _this$props2.width, height = _this$props2.height, orientation = _this$props2.orientation, tickSize = _this$props2.tickSize, mirror = _this$props2.mirror, tickMargin = _this$props2.tickMargin;
                var x1, x2, y1, y2, tx, ty;
                var sign = mirror ? -1 : 1;
                var finalTickSize = data.tickSize || tickSize;
                var tickCoord = (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(data.tickCoord) ? data.tickCoord : data.coordinate;
                switch(orientation){
                    case "top":
                        x1 = x2 = data.coordinate;
                        y2 = y + +!mirror * height;
                        y1 = y2 - sign * finalTickSize;
                        ty = y1 - sign * tickMargin;
                        tx = tickCoord;
                        break;
                    case "left":
                        y1 = y2 = data.coordinate;
                        x2 = x + +!mirror * width;
                        x1 = x2 - sign * finalTickSize;
                        tx = x1 - sign * tickMargin;
                        ty = tickCoord;
                        break;
                    case "right":
                        y1 = y2 = data.coordinate;
                        x2 = x + +mirror * width;
                        x1 = x2 + sign * finalTickSize;
                        tx = x1 + sign * tickMargin;
                        ty = tickCoord;
                        break;
                    default:
                        x1 = x2 = data.coordinate;
                        y2 = y + +mirror * height;
                        y1 = y2 + sign * finalTickSize;
                        ty = y1 + sign * tickMargin;
                        tx = tickCoord;
                        break;
                }
                return {
                    line: {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2
                    },
                    tick: {
                        x: tx,
                        y: ty
                    }
                };
            }
        },
        {
            key: "getTickTextAnchor",
            value: function getTickTextAnchor() {
                var _this$props3 = this.props, orientation = _this$props3.orientation, mirror = _this$props3.mirror;
                var textAnchor;
                switch(orientation){
                    case "left":
                        textAnchor = mirror ? "start" : "end";
                        break;
                    case "right":
                        textAnchor = mirror ? "end" : "start";
                        break;
                    default:
                        textAnchor = "middle";
                        break;
                }
                return textAnchor;
            }
        },
        {
            key: "getTickVerticalAnchor",
            value: function getTickVerticalAnchor() {
                var _this$props4 = this.props, orientation = _this$props4.orientation, mirror = _this$props4.mirror;
                var verticalAnchor = "end";
                switch(orientation){
                    case "left":
                    case "right":
                        verticalAnchor = "middle";
                        break;
                    case "top":
                        verticalAnchor = mirror ? "start" : "end";
                        break;
                    default:
                        verticalAnchor = mirror ? "end" : "start";
                        break;
                }
                return verticalAnchor;
            }
        },
        {
            key: "renderAxisLine",
            value: function renderAxisLine() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, orientation = _this$props5.orientation, mirror = _this$props5.mirror, axisLine = _this$props5.axisLine;
                var props = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props)), (0, $dd873d09408694ab$export$d697c39a2985a4c)(axisLine)), {}, {
                    fill: "none"
                });
                if (orientation === "top" || orientation === "bottom") {
                    var needHeight = +(orientation === "top" && !mirror || orientation === "bottom" && mirror);
                    props = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, props), {}, {
                        x1: x,
                        y1: y + needHeight * height,
                        x2: x + width,
                        y2: y + needHeight * height
                    });
                } else {
                    var needWidth = +(orientation === "left" && !mirror || orientation === "right" && mirror);
                    props = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, props), {}, {
                        x1: x + needWidth * width,
                        y1: y,
                        x2: x + needWidth * width,
                        y2: y + height
                    });
                }
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", $fbb091d423dfa995$var$_extends({}, props, {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-cartesian-axis-line", (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(axisLine, "className"))
                }));
            }
        },
        {
            key: "renderTicks",
            value: /**
     * render the ticks
     * @param {Array} ticks The ticks to actually render (overrides what was passed in props)
     * @return {ReactComponent} renderedTicks
     */ function renderTicks(ticks) {
                var _this = this;
                var _this$props6 = this.props, tickLine = _this$props6.tickLine, stroke = _this$props6.stroke, tick = _this$props6.tick, tickFormatter = _this$props6.tickFormatter, unit = _this$props6.unit;
                var finalTicks = CartesianAxis.getTicks($fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, this.props), {}, {
                    ticks: ticks
                }));
                var textAnchor = this.getTickTextAnchor();
                var verticalAnchor = this.getTickVerticalAnchor();
                var axisProps = (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props);
                var customTickProps = (0, $dd873d09408694ab$export$d697c39a2985a4c)(tick);
                var tickLineProps = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, axisProps), {}, {
                    fill: "none"
                }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(tickLine));
                var items = finalTicks.map(function(entry, i) {
                    var _this$getTickLineCoor = _this.getTickLineCoord(entry), lineCoord = _this$getTickLineCoor.line, tickCoord = _this$getTickLineCoor.tick;
                    var tickProps = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({
                        textAnchor: textAnchor,
                        verticalAnchor: verticalAnchor
                    }, axisProps), {}, {
                        stroke: "none",
                        fill: stroke
                    }, customTickProps), tickCoord), {}, {
                        index: i,
                        payload: entry,
                        visibleTicksCount: finalTicks.length,
                        tickFormatter: tickFormatter
                    });
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), $fbb091d423dfa995$var$_extends({
                        className: "recharts-cartesian-axis-tick",
                        key: "tick-".concat(i) // eslint-disable-line react/no-array-index-key
                    }, (0, $dd873d09408694ab$export$ca62be0d67a3158c)(_this.props, entry, i)), tickLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", $fbb091d423dfa995$var$_extends({}, tickLineProps, lineCoord, {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-cartesian-axis-tick-line", (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(tickLine, "className"))
                    })), tick && CartesianAxis.renderTickItem(tick, tickProps, "".concat((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value).concat(unit || "")));
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-axis-ticks"
                }, items);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props7 = this.props, axisLine = _this$props7.axisLine, width = _this$props7.width, height = _this$props7.height, ticksGenerator = _this$props7.ticksGenerator, className = _this$props7.className, hide = _this$props7.hide;
                if (hide) return null;
                var _this$props8 = this.props, ticks = _this$props8.ticks, noTicksProps = $fbb091d423dfa995$var$_objectWithoutProperties(_this$props8, [
                    "ticks"
                ]);
                var finalTicks = ticks;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(ticksGenerator)) finalTicks = ticks && ticks.length > 0 ? ticksGenerator(this.props) : ticksGenerator(noTicksProps);
                if (width <= 0 || height <= 0 || !finalTicks || !finalTicks.length) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-cartesian-axis", className)
                }, axisLine && this.renderAxisLine(), this.renderTicks(finalTicks), (0, $e21f9fc05175df16$export$b04be29aa201d4f5).renderCallByParent(this.props));
            }
        }
    ], [
        {
            key: "getTicks",
            value: function getTicks(props) {
                var tick = props.tick, ticks = props.ticks, viewBox = props.viewBox, minTickGap = props.minTickGap, orientation = props.orientation, interval = props.interval, tickFormatter = props.tickFormatter, unit = props.unit;
                if (!ticks || !ticks.length || !tick) return [];
                if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(interval) || (0, $2cfdd8db3ab543a8$export$98f03c5d19621d70).isSsr) return CartesianAxis.getNumberIntervalTicks(ticks, typeof interval === "number" && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(interval) ? interval : 0);
                if (interval === "preserveStartEnd") return CartesianAxis.getTicksStart({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                }, true);
                if (interval === "preserveStart") return CartesianAxis.getTicksStart({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                });
                return CartesianAxis.getTicksEnd({
                    ticks: ticks,
                    tickFormatter: tickFormatter,
                    viewBox: viewBox,
                    orientation: orientation,
                    minTickGap: minTickGap,
                    unit: unit
                });
            }
        },
        {
            key: "getNumberIntervalTicks",
            value: function getNumberIntervalTicks(ticks, interval) {
                return ticks.filter(function(entry, i) {
                    return i % (interval + 1) === 0;
                });
            }
        },
        {
            key: "getTicksStart",
            value: function getTicksStart(_ref2, preserveEnd) {
                var ticks = _ref2.ticks, tickFormatter = _ref2.tickFormatter, viewBox = _ref2.viewBox, orientation = _ref2.orientation, minTickGap = _ref2.minTickGap, unit = _ref2.unit;
                var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
                var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height";
                var result = (ticks || []).slice(); // we need add the width of 'unit' only when sizeKey === 'width'
                var unitSize = unit && sizeKey === "width" ? (0, $aea69284868f6157$export$e5560531f057ad5d)(unit)[sizeKey] : 0;
                var len = result.length;
                var sign = len >= 2 ? (0, $a4d9ec64928c627b$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
                var start, end;
                if (sign === 1) {
                    start = sizeKey === "width" ? x : y;
                    end = sizeKey === "width" ? x + width : y + height;
                } else {
                    start = sizeKey === "width" ? x + width : y + height;
                    end = sizeKey === "width" ? x : y;
                }
                if (preserveEnd) {
                    // Try to guarantee the tail to be displayed
                    var tail = ticks[len - 1];
                    var tailContent = (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(tickFormatter) ? tickFormatter(tail.value, len - 1) : tail.value;
                    var tailSize = (0, $aea69284868f6157$export$e5560531f057ad5d)(tailContent)[sizeKey] + unitSize;
                    var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
                    result[len - 1] = tail = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, tail), {}, {
                        tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
                    });
                    var isTailShow = sign * (tail.tickCoord - sign * tailSize / 2 - start) >= 0 && sign * (tail.tickCoord + sign * tailSize / 2 - end) <= 0;
                    if (isTailShow) {
                        end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                        result[len - 1] = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, tail), {}, {
                            isShow: true
                        });
                    }
                }
                var count = preserveEnd ? len - 1 : len;
                for(var i = 0; i < count; i++){
                    var entry = result[i];
                    var content = (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(tickFormatter) ? tickFormatter(entry.value, i) : entry.value;
                    var size = (0, $aea69284868f6157$export$e5560531f057ad5d)(content)[sizeKey] + unitSize;
                    if (i === 0) {
                        var gap = sign * (entry.coordinate - sign * size / 2 - start);
                        result[i] = entry = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                            tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
                        });
                    } else result[i] = entry = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                        tickCoord: entry.coordinate
                    });
                    var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
                    if (isShow) {
                        start = entry.tickCoord + sign * (size / 2 + minTickGap);
                        result[i] = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                            isShow: true
                        });
                    }
                }
                return result.filter(function(entry) {
                    return entry.isShow;
                });
            }
        },
        {
            key: "getTicksEnd",
            value: function getTicksEnd(_ref3) {
                var ticks = _ref3.ticks, tickFormatter = _ref3.tickFormatter, viewBox = _ref3.viewBox, orientation = _ref3.orientation, minTickGap = _ref3.minTickGap, unit = _ref3.unit;
                var x = viewBox.x, y = viewBox.y, width = viewBox.width, height = viewBox.height;
                var sizeKey = orientation === "top" || orientation === "bottom" ? "width" : "height"; // we need add the width of 'unit' only when sizeKey === 'width'
                var unitSize = unit && sizeKey === "width" ? (0, $aea69284868f6157$export$e5560531f057ad5d)(unit)[sizeKey] : 0;
                var result = (ticks || []).slice();
                var len = result.length;
                var sign = len >= 2 ? (0, $a4d9ec64928c627b$export$9d334328eb75e624)(result[1].coordinate - result[0].coordinate) : 1;
                var start, end;
                if (sign === 1) {
                    start = sizeKey === "width" ? x : y;
                    end = sizeKey === "width" ? x + width : y + height;
                } else {
                    start = sizeKey === "width" ? x + width : y + height;
                    end = sizeKey === "width" ? x : y;
                }
                for(var i = len - 1; i >= 0; i--){
                    var entry = result[i];
                    var content = (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(tickFormatter) ? tickFormatter(entry.value, len - i - 1) : entry.value;
                    var size = (0, $aea69284868f6157$export$e5560531f057ad5d)(content)[sizeKey] + unitSize;
                    if (i === len - 1) {
                        var gap = sign * (entry.coordinate + sign * size / 2 - end);
                        result[i] = entry = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                            tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
                        });
                    } else result[i] = entry = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                        tickCoord: entry.coordinate
                    });
                    var isShow = sign * (entry.tickCoord - sign * size / 2 - start) >= 0 && sign * (entry.tickCoord + sign * size / 2 - end) <= 0;
                    if (isShow) {
                        end = entry.tickCoord - sign * (size / 2 + minTickGap);
                        result[i] = $fbb091d423dfa995$var$_objectSpread($fbb091d423dfa995$var$_objectSpread({}, entry), {}, {
                            isShow: true
                        });
                    }
                }
                return result.filter(function(entry) {
                    return entry.isShow;
                });
            }
        },
        {
            key: "renderTickItem",
            value: function renderTickItem(option, props, value) {
                var tickItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) tickItem = option(props);
                else tickItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $ddbf2ed6ffdaf856$export$5f1af8db9871e1d6), $fbb091d423dfa995$var$_extends({}, props, {
                    className: "recharts-cartesian-axis-tick-value"
                }), value);
                return tickItem;
            }
        }
    ]);
    return CartesianAxis;
}((0, $eCoWV.Component));
$fbb091d423dfa995$export$bdd99f2cdf352bae.displayName = "CartesianAxis";
$fbb091d423dfa995$export$bdd99f2cdf352bae.defaultProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: "bottom",
    // The ticks
    ticks: [],
    stroke: "#666",
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: "preserveEnd"
};





var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");





function $23520179561baa9f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $23520179561baa9f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $23520179561baa9f$var$ownKeys(Object(source), true).forEach(function(key) {
            $23520179561baa9f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $23520179561baa9f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $23520179561baa9f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $23520179561baa9f$var$PREFIX_LIST = [
    "Webkit",
    "Moz",
    "O",
    "ms"
];
var $23520179561baa9f$export$4a9169b65825efee = function generatePrefixStyle(name, value) {
    if (!name) return null;
    var camelName = name.replace(/(\w)/, function(v) {
        return v.toUpperCase();
    });
    var result = $23520179561baa9f$var$PREFIX_LIST.reduce(function(res, entry) {
        return $23520179561baa9f$var$_objectSpread($23520179561baa9f$var$_objectSpread({}, res), {}, $23520179561baa9f$var$_defineProperty({}, entry + camelName, value));
    }, {});
    result[name] = value;
    return result;
};



function $84c84903fbb7ba96$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $84c84903fbb7ba96$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $84c84903fbb7ba96$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $84c84903fbb7ba96$var$_typeof(obj);
}
function $84c84903fbb7ba96$var$_extends() {
    $84c84903fbb7ba96$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $84c84903fbb7ba96$var$_extends.apply(this, arguments);
}
function $84c84903fbb7ba96$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $84c84903fbb7ba96$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $84c84903fbb7ba96$var$ownKeys(Object(source), true).forEach(function(key) {
            $84c84903fbb7ba96$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $84c84903fbb7ba96$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $84c84903fbb7ba96$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $84c84903fbb7ba96$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $84c84903fbb7ba96$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $84c84903fbb7ba96$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $84c84903fbb7ba96$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $84c84903fbb7ba96$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $84c84903fbb7ba96$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $84c84903fbb7ba96$var$_setPrototypeOf(subClass, superClass);
}
function $84c84903fbb7ba96$var$_setPrototypeOf(o, p) {
    $84c84903fbb7ba96$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $84c84903fbb7ba96$var$_setPrototypeOf(o, p);
}
function $84c84903fbb7ba96$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $84c84903fbb7ba96$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $84c84903fbb7ba96$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $84c84903fbb7ba96$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $84c84903fbb7ba96$var$_possibleConstructorReturn(this, result);
    };
}
function $84c84903fbb7ba96$var$_possibleConstructorReturn(self, call) {
    if (call && ($84c84903fbb7ba96$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $84c84903fbb7ba96$var$_assertThisInitialized(self);
}
function $84c84903fbb7ba96$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $84c84903fbb7ba96$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $84c84903fbb7ba96$var$_getPrototypeOf(o) {
    $84c84903fbb7ba96$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $84c84903fbb7ba96$var$_getPrototypeOf(o);
}
var $84c84903fbb7ba96$var$createScale = function createScale(_ref) {
    var data = _ref.data, startIndex = _ref.startIndex, endIndex = _ref.endIndex, x = _ref.x, width = _ref.width, travellerWidth = _ref.travellerWidth;
    if (!data || !data.length) return {};
    var len = data.length;
    var scale = (0, $ebfdc6234f770f61$export$105684a3041cb6f3)().domain((0, (/*@__PURE__*/$parcel$interopDefault($b2fdf882f2ea6452$exports)))(0, len)).range([
        x,
        x + width - travellerWidth
    ]);
    var scaleValues = scale.domain().map(function(entry) {
        return scale(entry);
    });
    return {
        isTextActive: false,
        isSlideMoving: false,
        isTravellerMoving: false,
        startX: scale(startIndex),
        endX: scale(endIndex),
        scale: scale,
        scaleValues: scaleValues
    };
};
var $84c84903fbb7ba96$var$isTouch = function isTouch(e) {
    return e.changedTouches && !!e.changedTouches.length;
};
var $84c84903fbb7ba96$export$59bc2e3533b384a0 = /*#__PURE__*/ function(_PureComponent) {
    $84c84903fbb7ba96$var$_inherits(Brush, _PureComponent);
    var _super = $84c84903fbb7ba96$var$_createSuper(Brush);
    function Brush(props) {
        var _this;
        $84c84903fbb7ba96$var$_classCallCheck(this, Brush);
        _this = _super.call(this, props);
        _this.leaveTimer = void 0;
        _this.travellerDragStartHandlers = void 0;
        _this.handleDrag = function(e) {
            if (_this.leaveTimer) {
                clearTimeout(_this.leaveTimer);
                _this.leaveTimer = null;
            }
            if (_this.state.isTravellerMoving) _this.handleTravellerMove(e);
            else if (_this.state.isSlideMoving) _this.handleSlideDrag(e);
        };
        _this.handleTouchMove = function(e) {
            if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleDrag(e.changedTouches[0]);
        };
        _this.handleDragEnd = function() {
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: false
            });
            _this.detachDragEndListener();
        };
        _this.handleLeaveWrapper = function() {
            if (_this.state.isTravellerMoving || _this.state.isSlideMoving) _this.leaveTimer = window.setTimeout(_this.handleDragEnd, _this.props.leaveTimeOut);
        };
        _this.handleEnterSlideOrTraveller = function() {
            _this.setState({
                isTextActive: true
            });
        };
        _this.handleLeaveSlideOrTraveller = function() {
            _this.setState({
                isTextActive: false
            });
        };
        _this.handleSlideDragStart = function(e) {
            var event = $84c84903fbb7ba96$var$isTouch(e) ? e.changedTouches[0] : e;
            _this.setState({
                isTravellerMoving: false,
                isSlideMoving: true,
                slideMoveStartX: event.pageX
            });
            _this.attachDragEndListener();
        };
        _this.travellerDragStartHandlers = {
            startX: _this.handleTravellerDragStart.bind($84c84903fbb7ba96$var$_assertThisInitialized(_this), "startX"),
            endX: _this.handleTravellerDragStart.bind($84c84903fbb7ba96$var$_assertThisInitialized(_this), "endX")
        };
        _this.state = {};
        return _this;
    }
    $84c84903fbb7ba96$var$_createClass(Brush, [
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                if (this.leaveTimer) {
                    clearTimeout(this.leaveTimer);
                    this.leaveTimer = null;
                }
                this.detachDragEndListener();
            }
        },
        {
            key: "getIndex",
            value: function getIndex(_ref2) {
                var startX = _ref2.startX, endX = _ref2.endX;
                var scaleValues = this.state.scaleValues;
                var _this$props = this.props, gap = _this$props.gap, data = _this$props.data;
                var lastIndex = data.length - 1;
                var min = Math.min(startX, endX);
                var max = Math.max(startX, endX);
                var minIndex = Brush.getIndexInRange(scaleValues, min);
                var maxIndex = Brush.getIndexInRange(scaleValues, max);
                return {
                    startIndex: minIndex - minIndex % gap,
                    endIndex: maxIndex === lastIndex ? lastIndex : maxIndex - maxIndex % gap
                };
            }
        },
        {
            key: "getTextOfTick",
            value: function getTextOfTick(index) {
                var _this$props2 = this.props, data = _this$props2.data, tickFormatter = _this$props2.tickFormatter, dataKey = _this$props2.dataKey;
                var text = (0, $ce9b7262abb43277$export$f97fc4a450f29a)(data[index], dataKey, index);
                return (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(tickFormatter) ? tickFormatter(text, index) : text;
            }
        },
        {
            key: "attachDragEndListener",
            value: function attachDragEndListener() {
                window.addEventListener("mouseup", this.handleDragEnd, true);
                window.addEventListener("touchend", this.handleDragEnd, true);
            }
        },
        {
            key: "detachDragEndListener",
            value: function detachDragEndListener() {
                window.removeEventListener("mouseup", this.handleDragEnd, true);
                window.removeEventListener("touchend", this.handleDragEnd, true);
            }
        },
        {
            key: "handleSlideDrag",
            value: function handleSlideDrag(e) {
                var _this$state = this.state, slideMoveStartX = _this$state.slideMoveStartX, startX = _this$state.startX, endX = _this$state.endX;
                var _this$props3 = this.props, x = _this$props3.x, width = _this$props3.width, travellerWidth = _this$props3.travellerWidth, startIndex = _this$props3.startIndex, endIndex = _this$props3.endIndex, onChange = _this$props3.onChange;
                var delta = e.pageX - slideMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - endX, x + width - travellerWidth - startX);
                else if (delta < 0) delta = Math.max(delta, x - startX, x - endX);
                var newIndex = this.getIndex({
                    startX: startX + delta,
                    endX: endX + delta
                });
                if ((newIndex.startIndex !== startIndex || newIndex.endIndex !== endIndex) && onChange) onChange(newIndex);
                this.setState({
                    startX: startX + delta,
                    endX: endX + delta,
                    slideMoveStartX: e.pageX
                });
            }
        },
        {
            key: "handleTravellerDragStart",
            value: function handleTravellerDragStart(id, e) {
                var event = $84c84903fbb7ba96$var$isTouch(e) ? e.changedTouches[0] : e;
                this.setState({
                    isSlideMoving: false,
                    isTravellerMoving: true,
                    movingTravellerId: id,
                    brushMoveStartX: event.pageX
                });
                this.attachDragEndListener();
            }
        },
        {
            key: "handleTravellerMove",
            value: function handleTravellerMove(e) {
                var _this$setState;
                var _this$state2 = this.state, brushMoveStartX = _this$state2.brushMoveStartX, movingTravellerId = _this$state2.movingTravellerId, endX = _this$state2.endX, startX = _this$state2.startX;
                var prevValue = this.state[movingTravellerId];
                var _this$props4 = this.props, x = _this$props4.x, width = _this$props4.width, travellerWidth = _this$props4.travellerWidth, onChange = _this$props4.onChange, gap = _this$props4.gap, data = _this$props4.data;
                var params = {
                    startX: this.state.startX,
                    endX: this.state.endX
                };
                var delta = e.pageX - brushMoveStartX;
                if (delta > 0) delta = Math.min(delta, x + width - travellerWidth - prevValue);
                else if (delta < 0) delta = Math.max(delta, x - prevValue);
                params[movingTravellerId] = prevValue + delta;
                var newIndex = this.getIndex(params);
                var startIndex = newIndex.startIndex, endIndex = newIndex.endIndex;
                var isFullGap = function isFullGap() {
                    var lastIndex = data.length - 1;
                    if (movingTravellerId === "startX" && (endX > startX ? startIndex % gap === 0 : endIndex % gap === 0) || endX < startX && endIndex === lastIndex || movingTravellerId === "endX" && (endX > startX ? endIndex % gap === 0 : startIndex % gap === 0) || endX > startX && endIndex === lastIndex) return true;
                    return false;
                };
                this.setState((_this$setState = {}, $84c84903fbb7ba96$var$_defineProperty(_this$setState, movingTravellerId, prevValue + delta), $84c84903fbb7ba96$var$_defineProperty(_this$setState, "brushMoveStartX", e.pageX), _this$setState), function() {
                    if (onChange) {
                        if (isFullGap()) onChange(newIndex);
                    }
                });
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var _this$props5 = this.props, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height, fill = _this$props5.fill, stroke = _this$props5.stroke;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    stroke: stroke,
                    fill: fill,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderPanorama",
            value: function renderPanorama() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, data = _this$props6.data, children = _this$props6.children, padding = _this$props6.padding;
                var chartElement = (0, $eCoWV.Children).only(children);
                if (!chartElement) return null;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(chartElement, {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    margin: padding,
                    compact: true,
                    data: data
                });
            }
        },
        {
            key: "renderTravellerLayer",
            value: function renderTravellerLayer(travellerX, id) {
                var _this$props7 = this.props, y = _this$props7.y, travellerWidth = _this$props7.travellerWidth, height = _this$props7.height, traveller = _this$props7.traveller;
                var x = Math.max(travellerX, this.props.x);
                var travellerProps = $84c84903fbb7ba96$var$_objectSpread($84c84903fbb7ba96$var$_objectSpread({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(this.props)), {}, {
                    x: x,
                    y: y,
                    width: travellerWidth,
                    height: height
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    className: "recharts-brush-traveller",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.travellerDragStartHandlers[id],
                    onTouchStart: this.travellerDragStartHandlers[id],
                    style: {
                        cursor: "col-resize"
                    }
                }, Brush.renderTraveller(traveller, travellerProps));
            }
        },
        {
            key: "renderSlide",
            value: function renderSlide(startX, endX) {
                var _this$props8 = this.props, y = _this$props8.y, height = _this$props8.height, stroke = _this$props8.stroke, travellerWidth = _this$props8.travellerWidth;
                var x = Math.min(startX, endX) + travellerWidth;
                var width = Math.max(Math.abs(endX - startX) - travellerWidth, 0);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    className: "recharts-brush-slide",
                    onMouseEnter: this.handleEnterSlideOrTraveller,
                    onMouseLeave: this.handleLeaveSlideOrTraveller,
                    onMouseDown: this.handleSlideDragStart,
                    onTouchStart: this.handleSlideDragStart,
                    style: {
                        cursor: "move"
                    },
                    stroke: "none",
                    fill: stroke,
                    fillOpacity: 0.2,
                    x: x,
                    y: y,
                    width: width,
                    height: height
                });
            }
        },
        {
            key: "renderText",
            value: function renderText() {
                var _this$props9 = this.props, startIndex = _this$props9.startIndex, endIndex = _this$props9.endIndex, y = _this$props9.y, height = _this$props9.height, travellerWidth = _this$props9.travellerWidth, stroke = _this$props9.stroke;
                var _this$state3 = this.state, startX = _this$state3.startX, endX = _this$state3.endX;
                var offset = 5;
                var attrs = {
                    pointerEvents: "none",
                    fill: stroke
                };
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    className: "recharts-brush-texts"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $ddbf2ed6ffdaf856$export$5f1af8db9871e1d6), $84c84903fbb7ba96$var$_extends({
                    textAnchor: "end",
                    verticalAnchor: "middle",
                    x: Math.min(startX, endX) - offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(startIndex)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $ddbf2ed6ffdaf856$export$5f1af8db9871e1d6), $84c84903fbb7ba96$var$_extends({
                    textAnchor: "start",
                    verticalAnchor: "middle",
                    x: Math.max(startX, endX) + travellerWidth + offset,
                    y: y + height / 2
                }, attrs), this.getTextOfTick(endIndex)));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props10 = this.props, data = _this$props10.data, className = _this$props10.className, children = _this$props10.children, x = _this$props10.x, y = _this$props10.y, width = _this$props10.width, height = _this$props10.height, alwaysShowText = _this$props10.alwaysShowText;
                var _this$state4 = this.state, startX = _this$state4.startX, endX = _this$state4.endX, isTextActive = _this$state4.isTextActive, isSlideMoving = _this$state4.isSlideMoving, isTravellerMoving = _this$state4.isTravellerMoving;
                if (!data || !data.length || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(x) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(y) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(height) || width <= 0 || height <= 0) return null;
                var layerClass = (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-brush", className);
                var isPanoramic = (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Children.count(children) === 1;
                var style = (0, $23520179561baa9f$export$4a9169b65825efee)("userSelect", "none");
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
                    className: layerClass,
                    onMouseMove: this.handleDrag,
                    onMouseLeave: this.handleLeaveWrapper,
                    onTouchMove: this.handleTouchMove,
                    style: style
                }, this.renderBackground(), isPanoramic && this.renderPanorama(), this.renderSlide(startX, endX), this.renderTravellerLayer(startX, "startX"), this.renderTravellerLayer(endX, "endX"), (isTextActive || isSlideMoving || isTravellerMoving || alwaysShowText) && this.renderText());
            }
        }
    ], [
        {
            key: "renderDefaultTraveller",
            value: function renderDefaultTraveller(props) {
                var x = props.x, y = props.y, width = props.width, height = props.height, stroke = props.stroke;
                var lineY = Math.floor(y + height / 2) - 1;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    fill: stroke,
                    stroke: "none"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", {
                    x1: x + 1,
                    y1: lineY,
                    x2: x + width - 1,
                    y2: lineY,
                    fill: "none",
                    stroke: "#fff"
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", {
                    x1: x + 1,
                    y1: lineY + 2,
                    x2: x + width - 1,
                    y2: lineY + 2,
                    fill: "none",
                    stroke: "#fff"
                }));
            }
        },
        {
            key: "renderTraveller",
            value: function renderTraveller(option, props) {
                var rectangle;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) rectangle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) rectangle = option(props);
                else rectangle = Brush.renderDefaultTraveller(props);
                return rectangle;
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var data = nextProps.data, width = nextProps.width, x = nextProps.x, travellerWidth = nextProps.travellerWidth, updateId = nextProps.updateId, startIndex = nextProps.startIndex, endIndex = nextProps.endIndex;
                if (data !== prevState.prevData || updateId !== prevState.prevUpdateId) return $84c84903fbb7ba96$var$_objectSpread({
                    prevData: data,
                    prevTravellerWidth: travellerWidth,
                    prevUpdateId: updateId,
                    prevX: x,
                    prevWidth: width
                }, data && data.length ? $84c84903fbb7ba96$var$createScale({
                    data: data,
                    width: width,
                    x: x,
                    travellerWidth: travellerWidth,
                    startIndex: startIndex,
                    endIndex: endIndex
                }) : {
                    scale: null,
                    scaleValues: null
                });
                if (prevState.scale && (width !== prevState.prevWidth || x !== prevState.prevX || travellerWidth !== prevState.prevTravellerWidth)) {
                    prevState.scale.range([
                        x,
                        x + width - travellerWidth
                    ]);
                    var scaleValues = prevState.scale.domain().map(function(entry) {
                        return prevState.scale(entry);
                    });
                    return {
                        prevData: data,
                        prevTravellerWidth: travellerWidth,
                        prevUpdateId: updateId,
                        prevX: x,
                        prevWidth: width,
                        startX: prevState.scale(nextProps.startIndex),
                        endX: prevState.scale(nextProps.endIndex),
                        scaleValues: scaleValues
                    };
                }
                return null;
            }
        },
        {
            key: "getIndexInRange",
            value: function getIndexInRange(range, x) {
                var len = range.length;
                var start = 0;
                var end = len - 1;
                while(end - start > 1){
                    var middle = Math.floor((start + end) / 2);
                    if (range[middle] > x) end = middle;
                    else start = middle;
                }
                return x >= range[end] ? end : start;
            }
        }
    ]);
    return Brush;
}((0, $eCoWV.PureComponent));
$84c84903fbb7ba96$export$59bc2e3533b384a0.displayName = "Brush";
$84c84903fbb7ba96$export$59bc2e3533b384a0.defaultProps = {
    height: 40,
    travellerWidth: 5,
    gap: 1,
    fill: "#fff",
    stroke: "#666",
    padding: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
    },
    leaveTimeOut: 1000,
    alwaysShowText: false
};







var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");




var $583d77ab609e8355$export$3fb112445eb31879 = function ifOverflowMatches(props, value) {
    var alwaysShow = props.alwaysShow;
    var ifOverflow = props.ifOverflow;
    if (alwaysShow) ifOverflow = "extendDomain";
    return ifOverflow === value;
};



var $c5ecdd3eaa3e8040$exports = {};



/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $c5ecdd3eaa3e8040$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $0ef980bf7dd42cec$exports(iteratee, 3);
    $7684658affa33219$exports(object, function(value, key, object) {
        $75d5cb8c754ffa1c$exports(result, key, iteratee(value, key, object));
    });
    return result;
}
$c5ecdd3eaa3e8040$exports = $c5ecdd3eaa3e8040$var$mapValues;





function $178894d76e936054$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $178894d76e936054$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $178894d76e936054$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $178894d76e936054$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $178894d76e936054$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $178894d76e936054$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $178894d76e936054$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $178894d76e936054$var$ownKeys(Object(source), true).forEach(function(key) {
            $178894d76e936054$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $178894d76e936054$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $178894d76e936054$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $178894d76e936054$export$ece7de1383db5ac = function formatAxisMap(props, axisMap, offset, axisType, chartName) {
    var width = props.width, height = props.height, layout = props.layout, children = props.children;
    var ids = Object.keys(axisMap);
    var steps = {
        left: offset.left,
        leftMirror: offset.left,
        right: width - offset.right,
        rightMirror: width - offset.right,
        top: offset.top,
        topMirror: offset.top,
        bottom: height - offset.bottom,
        bottomMirror: height - offset.bottom
    };
    var hasBar = !!(0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, "Bar");
    return ids.reduce(function(result, id) {
        var axis = axisMap[id];
        var orientation = axis.orientation, domain = axis.domain, _axis$padding = axis.padding, padding = _axis$padding === void 0 ? {} : _axis$padding, mirror = axis.mirror, reversed = axis.reversed;
        var offsetKey = "".concat(orientation).concat(mirror ? "Mirror" : "");
        var calculatedPadding, range, x, y, needSpace;
        if (axis.type === "number" && (axis.padding === "gap" || axis.padding === "no-gap")) {
            var diff = domain[1] - domain[0];
            var smallestDistanceBetweenValues = Infinity;
            var sortedValues = axis.categoricalDomain.sort();
            sortedValues.forEach(function(value, index) {
                if (index > 0) smallestDistanceBetweenValues = Math.min((value || 0) - (sortedValues[index - 1] || 0), smallestDistanceBetweenValues);
            });
            var smallestDistanceInPercent = smallestDistanceBetweenValues / diff;
            var rangeWidth = axis.layout === "vertical" ? offset.height : offset.width;
            if (axis.padding === "gap") calculatedPadding = smallestDistanceInPercent * rangeWidth / 2;
            if (axis.padding === "no-gap") {
                var gap = (0, $a4d9ec64928c627b$export$476354dbf49bdff6)(props.barCategoryGap, smallestDistanceInPercent * rangeWidth);
                var halfBand = smallestDistanceInPercent * rangeWidth / 2;
                calculatedPadding = halfBand - gap - (halfBand - gap) / rangeWidth * gap;
            }
        }
        if (axisType === "xAxis") range = [
            offset.left + (padding.left || 0) + (calculatedPadding || 0),
            offset.left + offset.width - (padding.right || 0) - (calculatedPadding || 0)
        ];
        else if (axisType === "yAxis") range = layout === "horizontal" ? [
            offset.top + offset.height - (padding.bottom || 0),
            offset.top + (padding.top || 0)
        ] : [
            offset.top + (padding.top || 0) + (calculatedPadding || 0),
            offset.top + offset.height - (padding.bottom || 0) - (calculatedPadding || 0)
        ];
        else range = axis.range;
        if (reversed) range = [
            range[1],
            range[0]
        ];
        var _parseScale = (0, $ce9b7262abb43277$export$534b094a708572c1)(axis, chartName, hasBar), scale = _parseScale.scale, realScaleType = _parseScale.realScaleType;
        scale.domain(domain).range(range);
        (0, $ce9b7262abb43277$export$9d80152e23bae434)(scale);
        var ticks = (0, $ce9b7262abb43277$export$ac086aaa4358d590)(scale, $178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread({}, axis), {}, {
            realScaleType: realScaleType
        }));
        if (axisType === "xAxis") {
            needSpace = orientation === "top" && !mirror || orientation === "bottom" && mirror;
            x = offset.left;
            y = steps[offsetKey] - needSpace * axis.height;
        } else if (axisType === "yAxis") {
            needSpace = orientation === "left" && !mirror || orientation === "right" && mirror;
            x = steps[offsetKey] - needSpace * axis.width;
            y = offset.top;
        }
        var finalAxis = $178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread({}, axis), ticks), {}, {
            realScaleType: realScaleType,
            x: x,
            y: y,
            scale: scale,
            width: axisType === "xAxis" ? offset.width : axis.width,
            height: axisType === "yAxis" ? offset.height : axis.height
        });
        finalAxis.bandSize = (0, $ce9b7262abb43277$export$212ec45c42fe68a7)(finalAxis, ticks);
        if (!axis.hide && axisType === "xAxis") steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.height;
        else if (!axis.hide) steps[offsetKey] += (needSpace ? -1 : 1) * finalAxis.width;
        return $178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread({}, result), {}, $178894d76e936054$var$_defineProperty({}, id, finalAxis));
    }, {});
};
var $178894d76e936054$export$c7964a5b9439ae62 = function rectWithPoints(_ref, _ref2) {
    var x1 = _ref.x, y1 = _ref.y;
    var x2 = _ref2.x, y2 = _ref2.y;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var $178894d76e936054$export$6df2062b9e15eec0 = function rectWithCoords(_ref3) {
    var x1 = _ref3.x1, y1 = _ref3.y1, x2 = _ref3.x2, y2 = _ref3.y2;
    return $178894d76e936054$export$c7964a5b9439ae62({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
var $178894d76e936054$export$dae1ac4449a69ee8 = /*#__PURE__*/ function() {
    function ScaleHelper(scale) {
        $178894d76e936054$var$_classCallCheck(this, ScaleHelper);
        this.scale = void 0;
        this.scale = scale;
    }
    $178894d76e936054$var$_createClass(ScaleHelper, [
        {
            key: "domain",
            get: function get() {
                return this.scale.domain;
            }
        },
        {
            key: "range",
            get: function get() {
                return this.scale.range;
            }
        },
        {
            key: "rangeMin",
            get: function get() {
                return this.range()[0];
            }
        },
        {
            key: "rangeMax",
            get: function get() {
                return this.range()[1];
            }
        },
        {
            key: "bandwidth",
            get: function get() {
                return this.scale.bandwidth;
            }
        },
        {
            key: "apply",
            value: function apply(value) {
                var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref4.bandAware, position = _ref4.position;
                if (value === undefined) return undefined;
                if (position) switch(position){
                    case "start":
                        return this.scale(value);
                    case "middle":
                        var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                        return this.scale(value) + offset;
                    case "end":
                        var _offset = this.bandwidth ? this.bandwidth() : 0;
                        return this.scale(value) + _offset;
                    default:
                        return this.scale(value);
                }
                if (bandAware) {
                    var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
                    return this.scale(value) + _offset2;
                }
                return this.scale(value);
            }
        },
        {
            key: "isInRange",
            value: function isInRange(value) {
                var range = this.range();
                var first = range[0];
                var last = range[range.length - 1];
                return first <= last ? value >= first && value <= last : value >= last && value <= first;
            }
        }
    ], [
        {
            key: "create",
            value: function create(obj) {
                return new ScaleHelper(obj);
            }
        }
    ]);
    return ScaleHelper;
}();
$178894d76e936054$export$dae1ac4449a69ee8.EPS = 1e-4;
var $178894d76e936054$export$db77ae668c18269f = function createLabeledScales(options) {
    var scales = Object.keys(options).reduce(function(res, key) {
        return $178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread({}, res), {}, $178894d76e936054$var$_defineProperty({}, key, $178894d76e936054$export$dae1ac4449a69ee8.create(options[key])));
    }, {});
    return $178894d76e936054$var$_objectSpread($178894d76e936054$var$_objectSpread({}, scales), {}, {
        apply: function apply(coord) {
            var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, bandAware = _ref5.bandAware, position = _ref5.position;
            return (0, (/*@__PURE__*/$parcel$interopDefault($c5ecdd3eaa3e8040$exports)))(coord, function(value, label) {
                return scales[label].apply(value, {
                    bandAware: bandAware,
                    position: position
                });
            });
        },
        isInRange: function isInRange(coord) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($c058f5bdb4b78d5f$exports)))(coord, function(value, label) {
                return scales[label].isInRange(value);
            });
        }
    });
};


/* eslint no-console: 0 */ var $ad6f526231c1928a$var$isDev = false;
var $ad6f526231c1928a$export$c106dd0671a0fc2d = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if ($ad6f526231c1928a$var$isDev && typeof console !== "undefined" && console.warn) {
        if (format === undefined) console.warn("LogUtils requires an error message argument");
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, function() {
                    return args[argIndex++];
                }));
            }
        }
    }
};



function $915fd3fc06fad929$var$_extends() {
    $915fd3fc06fad929$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $915fd3fc06fad929$var$_extends.apply(this, arguments);
}
function $915fd3fc06fad929$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $915fd3fc06fad929$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $915fd3fc06fad929$var$ownKeys(Object(source), true).forEach(function(key) {
            $915fd3fc06fad929$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $915fd3fc06fad929$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $915fd3fc06fad929$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $915fd3fc06fad929$var$getCoordinate = function getCoordinate(props) {
    var x = props.x, y = props.y, xAxis = props.xAxis, yAxis = props.yAxis;
    var scales = (0, $178894d76e936054$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var result = scales.apply({
        x: x,
        y: y
    }, {
        bandAware: true
    });
    if ((0, $583d77ab609e8355$export$3fb112445eb31879)(props, "discard") && !scales.isInRange(result)) return null;
    return result;
};
function $915fd3fc06fad929$export$aa7f0b0106bff39(props) {
    var x = props.x, y = props.y, r = props.r, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    var isX = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(x);
    var isY = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(y);
    (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    if (!isX || !isY) return null;
    var coordinate = $915fd3fc06fad929$var$getCoordinate(props);
    if (!coordinate) return null;
    var cx = coordinate.x, cy = coordinate.y;
    var shape = props.shape, className = props.className;
    var clipPath = (0, $583d77ab609e8355$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var dotProps = $915fd3fc06fad929$var$_objectSpread($915fd3fc06fad929$var$_objectSpread({
        clipPath: clipPath
    }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(props, true)), {}, {
        cx: cx,
        cy: cy
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-reference-dot", className)
    }, $915fd3fc06fad929$export$aa7f0b0106bff39.renderDot(shape, dotProps), (0, $e21f9fc05175df16$export$b04be29aa201d4f5).renderCallByParent(props, {
        x: cx - r,
        y: cy - r,
        width: 2 * r,
        height: 2 * r
    }));
}
$915fd3fc06fad929$export$aa7f0b0106bff39.displayName = "ReferenceDot";
$915fd3fc06fad929$export$aa7f0b0106bff39.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#fff",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1
};
$915fd3fc06fad929$export$aa7f0b0106bff39.renderDot = function(option, props) {
    var dot;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) dot = option(props);
    else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $18507106bbcc53ce$export$d046b3c4a416f60d), $915fd3fc06fad929$var$_extends({}, props, {
        cx: props.cx,
        cy: props.cy,
        className: "recharts-reference-dot-dot"
    }));
    return dot;
};


var $1b147e688916999f$exports = {};


var $1090714f1ebaf981$exports = {};

/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $1090714f1ebaf981$var$baseSome(collection, predicate) {
    var result;
    $04737f5e6900eacf$exports(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
$1090714f1ebaf981$exports = $1090714f1ebaf981$var$baseSome;




/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $1b147e688916999f$var$some(collection, predicate, guard) {
    var func = $0731a2307bf9d7f9$exports(collection) ? $67ed48d2b21bbdf3$exports : $1090714f1ebaf981$exports;
    if (guard && $b49463b59fa498e5$exports(collection, predicate, guard)) predicate = undefined;
    return func(collection, $0ef980bf7dd42cec$exports(predicate, 3));
}
$1b147e688916999f$exports = $1b147e688916999f$var$some;




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");







function $82ab1a00372d8b6d$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $82ab1a00372d8b6d$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $82ab1a00372d8b6d$var$ownKeys(Object(source), true).forEach(function(key) {
            $82ab1a00372d8b6d$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $82ab1a00372d8b6d$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $82ab1a00372d8b6d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $82ab1a00372d8b6d$var$_slicedToArray(arr, i) {
    return $82ab1a00372d8b6d$var$_arrayWithHoles(arr) || $82ab1a00372d8b6d$var$_iterableToArrayLimit(arr, i) || $82ab1a00372d8b6d$var$_unsupportedIterableToArray(arr, i) || $82ab1a00372d8b6d$var$_nonIterableRest();
}
function $82ab1a00372d8b6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $82ab1a00372d8b6d$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $82ab1a00372d8b6d$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $82ab1a00372d8b6d$var$_arrayLikeToArray(o, minLen);
}
function $82ab1a00372d8b6d$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $82ab1a00372d8b6d$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $82ab1a00372d8b6d$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $82ab1a00372d8b6d$var$_extends() {
    $82ab1a00372d8b6d$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $82ab1a00372d8b6d$var$_extends.apply(this, arguments);
}
var $82ab1a00372d8b6d$var$renderLine = function renderLine(option, props) {
    var line;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) line = option(props);
    else line = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", $82ab1a00372d8b6d$var$_extends({}, props, {
        className: "recharts-reference-line-line"
    }));
    return line;
}; // TODO: ScaleHelper
var $82ab1a00372d8b6d$var$getEndPoints = function getEndPoints(scales, isFixedX, isFixedY, isSegment, props) {
    var _props$viewBox = props.viewBox, x = _props$viewBox.x, y = _props$viewBox.y, width = _props$viewBox.width, height = _props$viewBox.height, position = props.position;
    if (isFixedY) {
        var yCoord = props.y, orientation = props.yAxis.orientation;
        var coord = scales.y.apply(yCoord, {
            position: position
        });
        if ((0, $583d77ab609e8355$export$3fb112445eb31879)(props, "discard") && !scales.y.isInRange(coord)) return null;
        var points = [
            {
                x: x + width,
                y: coord
            },
            {
                x: x,
                y: coord
            }
        ];
        return orientation === "left" ? points.reverse() : points;
    }
    if (isFixedX) {
        var xCoord = props.x, _orientation = props.xAxis.orientation;
        var _coord = scales.x.apply(xCoord, {
            position: position
        });
        if ((0, $583d77ab609e8355$export$3fb112445eb31879)(props, "discard") && !scales.x.isInRange(_coord)) return null;
        var _points = [
            {
                x: _coord,
                y: y + height
            },
            {
                x: _coord,
                y: y
            }
        ];
        return _orientation === "top" ? _points.reverse() : _points;
    }
    if (isSegment) {
        var segment = props.segment;
        var _points2 = segment.map(function(p) {
            return scales.apply(p, {
                position: position
            });
        });
        if ((0, $583d77ab609e8355$export$3fb112445eb31879)(props, "discard") && (0, (/*@__PURE__*/$parcel$interopDefault($1b147e688916999f$exports)))(_points2, function(p) {
            return !scales.isInRange(p);
        })) return null;
        return _points2;
    }
    return null;
};
function $82ab1a00372d8b6d$export$b2f28e248e7838eb(props) {
    var fixedX = props.x, fixedY = props.y, segment = props.segment, xAxis = props.xAxis, yAxis = props.yAxis, shape = props.shape, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var scales = (0, $178894d76e936054$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var isX = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(fixedX);
    var isY = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(fixedY);
    var isSegment = segment && segment.length === 2;
    var endPoints = $82ab1a00372d8b6d$var$getEndPoints(scales, isX, isY, isSegment, props);
    if (!endPoints) return null;
    var _endPoints = $82ab1a00372d8b6d$var$_slicedToArray(endPoints, 2), _endPoints$ = _endPoints[0], x1 = _endPoints$.x, y1 = _endPoints$.y, _endPoints$2 = _endPoints[1], x2 = _endPoints$2.x, y2 = _endPoints$2.y;
    var clipPath = (0, $583d77ab609e8355$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    var lineProps = $82ab1a00372d8b6d$var$_objectSpread($82ab1a00372d8b6d$var$_objectSpread({
        clipPath: clipPath
    }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(props, true)), {}, {
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-reference-line", className)
    }, $82ab1a00372d8b6d$var$renderLine(shape, lineProps), (0, $e21f9fc05175df16$export$b04be29aa201d4f5).renderCallByParent(props, (0, $178894d76e936054$export$6df2062b9e15eec0)({
        x1: x1,
        y1: y1,
        x2: x2,
        y2: y2
    })));
}
$82ab1a00372d8b6d$export$b2f28e248e7838eb.displayName = "ReferenceLine";
$82ab1a00372d8b6d$export$b2f28e248e7838eb.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    fill: "none",
    stroke: "#ccc",
    fillOpacity: 1,
    strokeWidth: 1,
    position: "middle"
};




var $eCoWV = parcelRequire("eCoWV");

var $iyeK6 = parcelRequire("iyeK6");








function $5306f64f6a7e9f9a$var$_extends() {
    $5306f64f6a7e9f9a$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5306f64f6a7e9f9a$var$_extends.apply(this, arguments);
}
function $5306f64f6a7e9f9a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5306f64f6a7e9f9a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $5306f64f6a7e9f9a$var$ownKeys(Object(source), true).forEach(function(key) {
            $5306f64f6a7e9f9a$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $5306f64f6a7e9f9a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5306f64f6a7e9f9a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $5306f64f6a7e9f9a$var$getRect = function getRect(hasX1, hasX2, hasY1, hasY2, props) {
    var xValue1 = props.x1, xValue2 = props.x2, yValue1 = props.y1, yValue2 = props.y2, xAxis = props.xAxis, yAxis = props.yAxis;
    if (!xAxis || !yAxis) return null;
    var scales = (0, $178894d76e936054$export$db77ae668c18269f)({
        x: xAxis.scale,
        y: yAxis.scale
    });
    var p1 = {
        x: hasX1 ? scales.x.apply(xValue1, {
            position: "start"
        }) : scales.x.rangeMin,
        y: hasY1 ? scales.y.apply(yValue1, {
            position: "start"
        }) : scales.y.rangeMin
    };
    var p2 = {
        x: hasX2 ? scales.x.apply(xValue2, {
            position: "end"
        }) : scales.x.rangeMax,
        y: hasY2 ? scales.y.apply(yValue2, {
            position: "end"
        }) : scales.y.rangeMax
    };
    if ((0, $583d77ab609e8355$export$3fb112445eb31879)(props, "discard") && (!scales.isInRange(p1) || !scales.isInRange(p2))) return null;
    return (0, $178894d76e936054$export$c7964a5b9439ae62)(p1, p2);
};
function $5306f64f6a7e9f9a$export$b4ec4f050ce240b9(props) {
    var x1 = props.x1, x2 = props.x2, y1 = props.y1, y2 = props.y2, className = props.className, alwaysShow = props.alwaysShow, clipPathId = props.clipPathId;
    (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)(alwaysShow === undefined, 'The alwaysShow prop is deprecated. Please use ifOverflow="extendDomain" instead.');
    var hasX1 = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(x1);
    var hasX2 = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(x2);
    var hasY1 = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(y1);
    var hasY2 = (0, $a4d9ec64928c627b$export$402a499e1ea44294)(y2);
    var shape = props.shape;
    if (!hasX1 && !hasX2 && !hasY1 && !hasY2 && !shape) return null;
    var rect = $5306f64f6a7e9f9a$var$getRect(hasX1, hasX2, hasY1, hasY2, props);
    if (!rect && !shape) return null;
    var clipPath = (0, $583d77ab609e8355$export$3fb112445eb31879)(props, "hidden") ? "url(#".concat(clipPathId, ")") : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-reference-area", className)
    }, $5306f64f6a7e9f9a$export$b4ec4f050ce240b9.renderRect(shape, $5306f64f6a7e9f9a$var$_objectSpread($5306f64f6a7e9f9a$var$_objectSpread({
        clipPath: clipPath
    }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(props, true)), rect)), (0, $e21f9fc05175df16$export$b04be29aa201d4f5).renderCallByParent(props, rect));
}
$5306f64f6a7e9f9a$export$b4ec4f050ce240b9.displayName = "ReferenceArea";
$5306f64f6a7e9f9a$export$b4ec4f050ce240b9.defaultProps = {
    isFront: false,
    ifOverflow: "discard",
    xAxisId: 0,
    yAxisId: 0,
    r: 10,
    fill: "#ccc",
    fillOpacity: 0.5,
    stroke: "none",
    strokeWidth: 1
};
$5306f64f6a7e9f9a$export$b4ec4f050ce240b9.renderRect = function(option, props) {
    var rect;
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
    else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) rect = option(props);
    else rect = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $f932de744a8ef4df$export$4617fb02663045ef), $5306f64f6a7e9f9a$var$_extends({}, props, {
        className: "recharts-reference-area-rect"
    }));
    return rect;
};





var $4fea6254a16eae71$export$62ecf5c04b491381 = function detectReferenceElementsDomain(children, domain, axisId, axisType, specifiedTicks) {
    var lines = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, (0, $82ab1a00372d8b6d$export$b2f28e248e7838eb).displayName);
    var dots = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, (0, $915fd3fc06fad929$export$aa7f0b0106bff39).displayName);
    var elements = lines.concat(dots);
    var areas = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, (0, $5306f64f6a7e9f9a$export$b4ec4f050ce240b9).displayName);
    var idKey = "".concat(axisType, "Id");
    var valueKey = axisType[0];
    var finalDomain = domain;
    if (elements.length) finalDomain = elements.reduce(function(result, el) {
        if (el.props[idKey] === axisId && (0, $583d77ab609e8355$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(el.props[valueKey])) {
            var value = el.props[valueKey];
            return [
                Math.min(result[0], value),
                Math.max(result[1], value)
            ];
        }
        return result;
    }, finalDomain);
    if (areas.length) {
        var key1 = "".concat(valueKey, "1");
        var key2 = "".concat(valueKey, "2");
        finalDomain = areas.reduce(function(result, el) {
            if (el.props[idKey] === axisId && (0, $583d77ab609e8355$export$3fb112445eb31879)(el.props, "extendDomain") && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(el.props[key1]) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(el.props[key2])) {
                var value1 = el.props[key1];
                var value2 = el.props[key2];
                return [
                    Math.min(result[0], value1, value2),
                    Math.max(result[1], value1, value2)
                ];
            }
            return result;
        }, finalDomain);
    }
    if (specifiedTicks && specifiedTicks.length) finalDomain = specifiedTicks.reduce(function(result, tick) {
        if ((0, $a4d9ec64928c627b$export$7e4aa119212bc614)(tick)) return [
            Math.min(result[0], tick),
            Math.max(result[1], tick)
        ];
        return result;
    }, finalDomain);
    return finalDomain;
};




var $aa67280e3a0164be$exports = {};
"use strict";
var $aa67280e3a0164be$var$has = Object.prototype.hasOwnProperty, $aa67280e3a0164be$var$prefix = "~";
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function $aa67280e3a0164be$var$Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    $aa67280e3a0164be$var$Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new $aa67280e3a0164be$var$Events().__proto__) $aa67280e3a0164be$var$prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function $aa67280e3a0164be$var$EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function $aa67280e3a0164be$var$addListener(emitter, event, fn, context, once) {
    if (typeof fn !== "function") throw new TypeError("The listener must be a function");
    var listener = new $aa67280e3a0164be$var$EE(fn, context || emitter, once), evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function $aa67280e3a0164be$var$clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new $aa67280e3a0164be$var$Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function $aa67280e3a0164be$var$EventEmitter() {
    this._events = new $aa67280e3a0164be$var$Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if ($aa67280e3a0164be$var$has.call(events, name)) names.push($aa67280e3a0164be$var$prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.listeners = function listeners(event) {
    var evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.on = function on(event, fn, context) {
    return $aa67280e3a0164be$var$addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.once = function once(event, fn, context) {
    return $aa67280e3a0164be$var$addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        $aa67280e3a0164be$var$clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) $aa67280e3a0164be$var$clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else $aa67280e3a0164be$var$clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ $aa67280e3a0164be$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = $aa67280e3a0164be$var$prefix ? $aa67280e3a0164be$var$prefix + event : event;
        if (this._events[evt]) $aa67280e3a0164be$var$clearEvent(this, evt);
    } else {
        this._events = new $aa67280e3a0164be$var$Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
$aa67280e3a0164be$var$EventEmitter.prototype.off = $aa67280e3a0164be$var$EventEmitter.prototype.removeListener;
$aa67280e3a0164be$var$EventEmitter.prototype.addListener = $aa67280e3a0164be$var$EventEmitter.prototype.on;
//
// Expose the prefix.
//
$aa67280e3a0164be$var$EventEmitter.prefixed = $aa67280e3a0164be$var$prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
$aa67280e3a0164be$var$EventEmitter.EventEmitter = $aa67280e3a0164be$var$EventEmitter;
$aa67280e3a0164be$exports = $aa67280e3a0164be$var$EventEmitter;


var $0ce71bcaa759bc7b$export$9bcdfe5f29bb33 = new (0, (/*@__PURE__*/$parcel$interopDefault($aa67280e3a0164be$exports)))();
if ($0ce71bcaa759bc7b$export$9bcdfe5f29bb33.setMaxListeners) $0ce71bcaa759bc7b$export$9bcdfe5f29bb33.setMaxListeners(10);
var $0ce71bcaa759bc7b$export$ff9a08f6d0c38b8f = "recharts.syncMouseEvents"; // eslint-disable-next-line no-redeclare



function $c61dda0fca74c9ef$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c61dda0fca74c9ef$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c61dda0fca74c9ef$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c61dda0fca74c9ef$var$_typeof(obj);
}
function $c61dda0fca74c9ef$var$_slicedToArray(arr, i) {
    return $c61dda0fca74c9ef$var$_arrayWithHoles(arr) || $c61dda0fca74c9ef$var$_iterableToArrayLimit(arr, i) || $c61dda0fca74c9ef$var$_unsupportedIterableToArray(arr, i) || $c61dda0fca74c9ef$var$_nonIterableRest();
}
function $c61dda0fca74c9ef$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c61dda0fca74c9ef$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c61dda0fca74c9ef$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c61dda0fca74c9ef$var$_extends() {
    $c61dda0fca74c9ef$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c61dda0fca74c9ef$var$_extends.apply(this, arguments);
}
function $c61dda0fca74c9ef$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c61dda0fca74c9ef$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c61dda0fca74c9ef$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $c61dda0fca74c9ef$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c61dda0fca74c9ef$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c61dda0fca74c9ef$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c61dda0fca74c9ef$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c61dda0fca74c9ef$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c61dda0fca74c9ef$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c61dda0fca74c9ef$var$_setPrototypeOf(subClass, superClass);
}
function $c61dda0fca74c9ef$var$_setPrototypeOf(o, p) {
    $c61dda0fca74c9ef$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c61dda0fca74c9ef$var$_setPrototypeOf(o, p);
}
function $c61dda0fca74c9ef$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $c61dda0fca74c9ef$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $c61dda0fca74c9ef$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $c61dda0fca74c9ef$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $c61dda0fca74c9ef$var$_possibleConstructorReturn(this, result);
    };
}
function $c61dda0fca74c9ef$var$_possibleConstructorReturn(self, call) {
    if (call && ($c61dda0fca74c9ef$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c61dda0fca74c9ef$var$_assertThisInitialized(self);
}
function $c61dda0fca74c9ef$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c61dda0fca74c9ef$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $c61dda0fca74c9ef$var$_getPrototypeOf(o) {
    $c61dda0fca74c9ef$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c61dda0fca74c9ef$var$_getPrototypeOf(o);
}
function $c61dda0fca74c9ef$var$_toConsumableArray(arr) {
    return $c61dda0fca74c9ef$var$_arrayWithoutHoles(arr) || $c61dda0fca74c9ef$var$_iterableToArray(arr) || $c61dda0fca74c9ef$var$_unsupportedIterableToArray(arr) || $c61dda0fca74c9ef$var$_nonIterableSpread();
}
function $c61dda0fca74c9ef$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c61dda0fca74c9ef$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c61dda0fca74c9ef$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c61dda0fca74c9ef$var$_arrayLikeToArray(o, minLen);
}
function $c61dda0fca74c9ef$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $c61dda0fca74c9ef$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $c61dda0fca74c9ef$var$_arrayLikeToArray(arr);
}
function $c61dda0fca74c9ef$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c61dda0fca74c9ef$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c61dda0fca74c9ef$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c61dda0fca74c9ef$var$ownKeys(Object(source), true).forEach(function(key) {
            $c61dda0fca74c9ef$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c61dda0fca74c9ef$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c61dda0fca74c9ef$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c61dda0fca74c9ef$var$ORIENT_MAP = {
    xAxis: [
        "bottom",
        "top"
    ],
    yAxis: [
        "left",
        "right"
    ]
};
var $c61dda0fca74c9ef$var$originCoordinate = {
    x: 0,
    y: 0
}; // use legacy isFinite only if there is a problem (aka IE)
// eslint-disable-next-line no-restricted-globals
var $c61dda0fca74c9ef$var$isFinit = Number.isFinite ? Number.isFinite : isFinite;
var $c61dda0fca74c9ef$var$defer = typeof requestAnimationFrame === "function" ? requestAnimationFrame : typeof setImmediate === "function" ? setImmediate : setTimeout;
var $c61dda0fca74c9ef$var$deferClear = typeof cancelAnimationFrame === "function" ? cancelAnimationFrame : typeof clearImmediate === "function" ? clearImmediate : clearTimeout;
var $c61dda0fca74c9ef$var$calculateTooltipPos = function calculateTooltipPos(rangeObj, layout) {
    if (layout === "horizontal") return rangeObj.x;
    if (layout === "vertical") return rangeObj.y;
    if (layout === "centric") return rangeObj.angle;
    return rangeObj.radius;
};
var $c61dda0fca74c9ef$var$getActiveCoordinate = function getActiveCoordinate(layout, tooltipTicks, activeIndex, rangeObj) {
    var entry = tooltipTicks.find(function(tick) {
        return tick && tick.index === activeIndex;
    });
    if (entry) {
        if (layout === "horizontal") return {
            x: entry.coordinate,
            y: rangeObj.y
        };
        if (layout === "vertical") return {
            x: rangeObj.x,
            y: entry.coordinate
        };
        if (layout === "centric") {
            var _angle = entry.coordinate;
            var _radius = rangeObj.radius;
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, rangeObj), (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var angle = rangeObj.angle;
        return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, rangeObj), (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle: angle,
            radius: radius
        });
    }
    return $c61dda0fca74c9ef$var$originCoordinate;
};
var $c61dda0fca74c9ef$var$getDisplayedData = function getDisplayedData(data, _ref, item) {
    var graphicalItems = _ref.graphicalItems, dataStartIndex = _ref.dataStartIndex, dataEndIndex = _ref.dataEndIndex;
    var itemsData = (graphicalItems || []).reduce(function(result, child) {
        var itemData = child.props.data;
        if (itemData && itemData.length) return [].concat($c61dda0fca74c9ef$var$_toConsumableArray(result), $c61dda0fca74c9ef$var$_toConsumableArray(itemData));
        return result;
    }, []);
    if (itemsData && itemsData.length > 0) return itemsData;
    if (item && item.props && item.props.data && item.props.data.length > 0) return item.props.data;
    if (data && data.length && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(dataStartIndex) && (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(dataEndIndex)) return data.slice(dataStartIndex, dataEndIndex + 1);
    return [];
};
/**
 * Get the content to be displayed in the tooltip
 * @param  {Object} state          Current state
 * @param  {Array}  chartData      The data defined in chart
 * @param  {Number} activeIndex    Active index of data
 * @param  {String} activeLabel    Active label of data
 * @return {Array}                 The content of tooltip
 */ var $c61dda0fca74c9ef$var$getTooltipContent = function getTooltipContent(state, chartData, activeIndex, activeLabel) {
    var graphicalItems = state.graphicalItems, tooltipAxis = state.tooltipAxis;
    var displayedData = $c61dda0fca74c9ef$var$getDisplayedData(chartData, state);
    if (activeIndex < 0 || !graphicalItems || !graphicalItems.length || activeIndex >= displayedData.length) return null;
     // get data by activeIndex when the axis don't allow duplicated category
    return graphicalItems.reduce(function(result, child) {
        var hide = child.props.hide;
        if (hide) return result;
        var data = child.props.data;
        var payload;
        if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
            // graphic child has data props
            var entries = data === undefined ? displayedData : data;
            payload = (0, $a4d9ec64928c627b$export$66950d3869f5cc67)(entries, tooltipAxis.dataKey, activeLabel);
        } else payload = data && data[activeIndex] || displayedData[activeIndex];
        if (!payload) return result;
        return [].concat($c61dda0fca74c9ef$var$_toConsumableArray(result), [
            (0, $ce9b7262abb43277$export$a4ea3faa19bc2d90)(child, payload)
        ]);
    }, []);
};
/**
 * Returns tooltip data based on a mouse position (as a parameter or in state)
 * @param  {Object} state     current state
 * @param  {Array}  chartData the data defined in chart
 * @param  {String} layout     The layout type of chart
 * @param  {Object} rangeObj  { x, y } coordinates
 * @return {Object}           Tooltip data data
 */ var $c61dda0fca74c9ef$var$getTooltipData = function getTooltipData(state, chartData, layout, rangeObj) {
    var rangeData = rangeObj || {
        x: state.chartX,
        y: state.chartY
    };
    var pos = $c61dda0fca74c9ef$var$calculateTooltipPos(rangeData, layout);
    var ticks = state.orderedTooltipTicks, axis = state.tooltipAxis, tooltipTicks = state.tooltipTicks;
    var activeIndex = (0, $ce9b7262abb43277$export$3071d39cc844078e)(pos, ticks, tooltipTicks, axis);
    if (activeIndex >= 0 && tooltipTicks) {
        var activeLabel = tooltipTicks[activeIndex] && tooltipTicks[activeIndex].value;
        var activePayload = $c61dda0fca74c9ef$var$getTooltipContent(state, chartData, activeIndex, activeLabel);
        var activeCoordinate = $c61dda0fca74c9ef$var$getActiveCoordinate(layout, ticks, activeIndex, rangeData);
        return {
            activeTooltipIndex: activeIndex,
            activeLabel: activeLabel,
            activePayload: activePayload,
            activeCoordinate: activeCoordinate
        };
    }
    return null;
};
/**
 * Get the configuration of axis by the options of axis instance
 * @param  {Object} props         Latest props
 * @param {Array}  axes           The instance of axes
 * @param  {Array} graphicalItems The instances of item
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}      Configuration
 */ var $c61dda0fca74c9ef$var$getAxisMapByAxes = function getAxisMapByAxes(props, _ref2) {
    var axes = _ref2.axes, graphicalItems = _ref2.graphicalItems, axisType = _ref2.axisType, axisIdKey = _ref2.axisIdKey, stackGroups = _ref2.stackGroups, dataStartIndex = _ref2.dataStartIndex, dataEndIndex = _ref2.dataEndIndex;
    var layout = props.layout, children = props.children, stackOffset = props.stackOffset;
    var isCategorical = (0, $ce9b7262abb43277$export$9fc1baaa6c6368b)(layout, axisType); // Eliminate duplicated axes
    var axisMap = axes.reduce(function(result, child) {
        var _child$props = child.props, type = _child$props.type, dataKey = _child$props.dataKey, allowDataOverflow = _child$props.allowDataOverflow, allowDuplicatedCategory = _child$props.allowDuplicatedCategory, scale = _child$props.scale, ticks = _child$props.ticks;
        var axisId = child.props[axisIdKey];
        var displayedData = $c61dda0fca74c9ef$var$getDisplayedData(props.data, {
            graphicalItems: graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId;
            }),
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex
        });
        var len = displayedData.length;
        if (!result[axisId]) {
            var domain, duplicateDomain, categoricalDomain;
            if (dataKey) {
                // has dataKey in <Axis />
                domain = (0, $ce9b7262abb43277$export$6a1e7873444c95a7)(displayedData, dataKey, type);
                if (type === "category" && isCategorical) {
                    // the field type is category data and this axis is catrgorical axis
                    var duplicate = (0, $a4d9ec64928c627b$export$732baf6a98f122)(domain);
                    if (allowDuplicatedCategory && duplicate) {
                        duplicateDomain = domain; // When category axis has duplicated text, serial numbers are used to generate scale
                        domain = (0, (/*@__PURE__*/$parcel$interopDefault($b2fdf882f2ea6452$exports)))(0, len);
                    } else if (!allowDuplicatedCategory) // remove duplicated category
                    domain = (0, $ce9b7262abb43277$export$c9a5230f0dda41bf)(child.props.domain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 ? finalDomain : [].concat($c61dda0fca74c9ef$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                } else if (type === "category") {
                    // the field type is category data and this axis is numerical axis
                    if (!allowDuplicatedCategory) domain = (0, $ce9b7262abb43277$export$c9a5230f0dda41bf)(child.props.domain, domain, child).reduce(function(finalDomain, entry) {
                        return finalDomain.indexOf(entry) >= 0 || entry === "" || (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry) ? finalDomain : [].concat($c61dda0fca74c9ef$var$_toConsumableArray(finalDomain), [
                            entry
                        ]);
                    }, []);
                    else // eliminate undefined or null or empty string
                    domain = domain.filter(function(entry) {
                        return entry !== "" && !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(entry);
                    });
                } else if (type === "number") {
                    // the field type is numerical
                    var errorBarsDomain = (0, $ce9b7262abb43277$export$2266342e22c737e8)(displayedData, graphicalItems.filter(function(item) {
                        return item.props[axisIdKey] === axisId && !item.props.hide;
                    }), dataKey, axisType, layout);
                    if (errorBarsDomain) domain = errorBarsDomain;
                }
                if (isCategorical && (type === "number" || scale !== "auto")) categoricalDomain = (0, $ce9b7262abb43277$export$6a1e7873444c95a7)(displayedData, dataKey, "category");
            } else if (isCategorical) // the axis is a categorical axis
            domain = (0, (/*@__PURE__*/$parcel$interopDefault($b2fdf882f2ea6452$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack && type === "number") // when stackOffset is 'expand', the domain may be calculated as [0, 1.000000000002]
            domain = stackOffset === "expand" ? [
                0,
                1
            ] : (0, $ce9b7262abb43277$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
            else domain = (0, $ce9b7262abb43277$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                return item.props[axisIdKey] === axisId && !item.props.hide;
            }), type, layout, true);
            if (type === "number") {
                // To detect wether there is any reference lines whose props alwaysShow is true
                domain = (0, $4fea6254a16eae71$export$62ecf5c04b491381)(children, domain, axisId, axisType, ticks);
                if (child.props.domain) domain = (0, $ce9b7262abb43277$export$a0bc8660980558a0)(child.props.domain, domain, allowDataOverflow);
            } else if (type === "category" && child.props.domain) {
                var axisDomain = child.props.domain;
                var isDomainValidate = domain.every(function(entry) {
                    return axisDomain.indexOf(entry) >= 0;
                });
                if (isDomainValidate) domain = axisDomain;
            }
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, $c61dda0fca74c9ef$var$_defineProperty({}, axisId, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, child.props), {}, {
                axisType: axisType,
                domain: domain,
                categoricalDomain: categoricalDomain,
                duplicateDomain: duplicateDomain,
                originalDomain: child.props.domain,
                isCategorical: isCategorical,
                layout: layout
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of axis by the options of item,
 * this kind of axis does not display in chart
 * @param  {Object} props         Latest props
 * @param  {Array} graphicalItems The instances of item
 * @param  {ReactElement} Axis    Axis Component
 * @param  {String} axisType      The type of axis, xAxis - x-axis, yAxis - y-axis
 * @param  {String} axisIdKey     The unique id of an axis
 * @param  {Object} stackGroups   The items grouped by axisId and stackId
 * @param {Number} dataStartIndex The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex   The end index of the data series when a brush is applied
 * @return {Object}               Configuration
 */ var $c61dda0fca74c9ef$var$getAxisMapByItems = function getAxisMapByItems(props, _ref3) {
    var graphicalItems = _ref3.graphicalItems, Axis = _ref3.Axis, axisType = _ref3.axisType, axisIdKey = _ref3.axisIdKey, stackGroups = _ref3.stackGroups, dataStartIndex = _ref3.dataStartIndex, dataEndIndex = _ref3.dataEndIndex;
    var layout = props.layout, children = props.children;
    var displayedData = $c61dda0fca74c9ef$var$getDisplayedData(props.data, {
        graphicalItems: graphicalItems,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    var len = displayedData.length;
    var isCategorical = (0, $ce9b7262abb43277$export$9fc1baaa6c6368b)(layout, axisType);
    var index = -1; // The default type of x-axis is category axis,
    // The default contents of x-axis is the serial numbers of data
    // The default type of y-axis is number axis
    // The default contents of y-axis is the domain of data
    var axisMap = graphicalItems.reduce(function(result, child) {
        var axisId = child.props[axisIdKey];
        if (!result[axisId]) {
            index++;
            var domain;
            if (isCategorical) domain = (0, (/*@__PURE__*/$parcel$interopDefault($b2fdf882f2ea6452$exports)))(0, len);
            else if (stackGroups && stackGroups[axisId] && stackGroups[axisId].hasStack) {
                domain = (0, $ce9b7262abb43277$export$26522b779eb5497c)(stackGroups[axisId].stackGroups, dataStartIndex, dataEndIndex);
                domain = (0, $4fea6254a16eae71$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            } else {
                domain = (0, $ce9b7262abb43277$export$a0bc8660980558a0)(Axis.defaultProps.domain, (0, $ce9b7262abb43277$export$c92c4f4286b1390d)(displayedData, graphicalItems.filter(function(item) {
                    return item.props[axisIdKey] === axisId && !item.props.hide;
                }), "number", layout), Axis.defaultProps.allowDataOverflow);
                domain = (0, $4fea6254a16eae71$export$62ecf5c04b491381)(children, domain, axisId, axisType);
            }
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, $c61dda0fca74c9ef$var$_defineProperty({}, axisId, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                axisType: axisType
            }, Axis.defaultProps), {}, {
                hide: true,
                orientation: (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))($c61dda0fca74c9ef$var$ORIENT_MAP, "".concat(axisType, ".").concat(index % 2), null),
                domain: domain,
                originalDomain: Axis.defaultProps.domain,
                isCategorical: isCategorical,
                layout: layout // specify scale when no Axis
            })));
        }
        return result;
    }, {});
    return axisMap;
};
/**
 * Get the configuration of all x-axis or y-axis
 * @param  {Object} props          Latest props
 * @param  {String} axisType       The type of axis
 * @param  {Array}  graphicalItems The instances of item
 * @param  {Object} stackGroups    The items grouped by axisId and stackId
 * @param {Number} dataStartIndex  The start index of the data series when a brush is applied
 * @param {Number} dataEndIndex    The end index of the data series when a brush is applied
 * @return {Object}          Configuration
 */ var $c61dda0fca74c9ef$var$getAxisMap = function getAxisMap(props, _ref4) {
    var _ref4$axisType = _ref4.axisType, axisType = _ref4$axisType === void 0 ? "xAxis" : _ref4$axisType, AxisComp = _ref4.AxisComp, graphicalItems = _ref4.graphicalItems, stackGroups = _ref4.stackGroups, dataStartIndex = _ref4.dataStartIndex, dataEndIndex = _ref4.dataEndIndex;
    var children = props.children;
    var axisIdKey = "".concat(axisType, "Id"); // Get all the instance of Axis
    var axes = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, AxisComp);
    var axisMap = {};
    if (axes && axes.length) axisMap = $c61dda0fca74c9ef$var$getAxisMapByAxes(props, {
        axes: axes,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    else if (graphicalItems && graphicalItems.length) axisMap = $c61dda0fca74c9ef$var$getAxisMapByItems(props, {
        Axis: AxisComp,
        graphicalItems: graphicalItems,
        axisType: axisType,
        axisIdKey: axisIdKey,
        stackGroups: stackGroups,
        dataStartIndex: dataStartIndex,
        dataEndIndex: dataEndIndex
    });
    return axisMap;
};
var $c61dda0fca74c9ef$var$tooltipTicksGenerator = function tooltipTicksGenerator(axisMap) {
    var axis = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(axisMap);
    var tooltipTicks = (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(axis, false, true);
    return {
        tooltipTicks: tooltipTicks,
        orderedTooltipTicks: (0, (/*@__PURE__*/$parcel$interopDefault($421c39c39f87f3ba$exports)))(tooltipTicks, function(o) {
            return o.coordinate;
        }),
        tooltipAxis: axis,
        tooltipAxisBandSize: (0, $ce9b7262abb43277$export$212ec45c42fe68a7)(axis, tooltipTicks)
    };
};
/**
 * Returns default, reset state for the categorical chart.
 * @param {Object} props Props object to use when creating the default state
 * @return {Object} Whole new state
 */ var $c61dda0fca74c9ef$var$createDefaultState = function createDefaultState(props) {
    var children = props.children, defaultShowTooltip = props.defaultShowTooltip;
    var brushItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $84c84903fbb7ba96$export$59bc2e3533b384a0).displayName);
    var startIndex = brushItem && brushItem.props && brushItem.props.startIndex || 0;
    var endIndex = brushItem && brushItem.props && brushItem.props.endIndex || props.data && props.data.length - 1 || 0;
    return {
        chartX: 0,
        chartY: 0,
        dataStartIndex: startIndex,
        dataEndIndex: endIndex,
        activeTooltipIndex: -1,
        isTooltipActive: !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(defaultShowTooltip) ? defaultShowTooltip : false
    };
};
var $c61dda0fca74c9ef$var$hasGraphicalBarItem = function hasGraphicalBarItem(graphicalItems) {
    if (!graphicalItems || !graphicalItems.length) return false;
    return graphicalItems.some(function(item) {
        var name = (0, $ffd74d03487febd9$export$be63e0664592e141)(item && item.type);
        return name && name.indexOf("Bar") >= 0;
    });
};
var $c61dda0fca74c9ef$var$getAxisNameByLayout = function getAxisNameByLayout(layout) {
    if (layout === "horizontal") return {
        numericAxisName: "yAxis",
        cateAxisName: "xAxis"
    };
    if (layout === "vertical") return {
        numericAxisName: "xAxis",
        cateAxisName: "yAxis"
    };
    if (layout === "centric") return {
        numericAxisName: "radiusAxis",
        cateAxisName: "angleAxis"
    };
    return {
        numericAxisName: "angleAxis",
        cateAxisName: "radiusAxis"
    };
};
/**
 * Calculate the offset of main part in the svg element
 * @param  {Object} props          Latest props
 * graphicalItems The instances of item
 * xAxisMap       The configuration of x-axis
 * yAxisMap       The configuration of y-axis
 * @param  {Object} prevLegendBBox          the boundary box of legend
 * @return {Object} The offset of main part in the svg element
 */ var $c61dda0fca74c9ef$var$calculateOffset = function calculateOffset(_ref5, prevLegendBBox) {
    var props = _ref5.props, graphicalItems = _ref5.graphicalItems, _ref5$xAxisMap = _ref5.xAxisMap, xAxisMap = _ref5$xAxisMap === void 0 ? {} : _ref5$xAxisMap, _ref5$yAxisMap = _ref5.yAxisMap, yAxisMap = _ref5$yAxisMap === void 0 ? {} : _ref5$yAxisMap;
    var width = props.width, height = props.height, children = props.children;
    var margin = props.margin || {};
    var brushItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $84c84903fbb7ba96$export$59bc2e3533b384a0).displayName);
    var legendItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $30a7618641b2544d$export$ed247974535929c7).displayName);
    var offsetH = Object.keys(yAxisMap).reduce(function(result, id) {
        var entry = yAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, $c61dda0fca74c9ef$var$_defineProperty({}, orientation, result[orientation] + entry.width));
        return result;
    }, {
        left: margin.left || 0,
        right: margin.right || 0
    });
    var offsetV = Object.keys(xAxisMap).reduce(function(result, id) {
        var entry = xAxisMap[id];
        var orientation = entry.orientation;
        if (!entry.mirror && !entry.hide) return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, $c61dda0fca74c9ef$var$_defineProperty({}, orientation, (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(result, "".concat(orientation)) + entry.height));
        return result;
    }, {
        top: margin.top || 0,
        bottom: margin.bottom || 0
    });
    var offset = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    if (brushItem) offset.bottom += brushItem.props.height || (0, $84c84903fbb7ba96$export$59bc2e3533b384a0).defaultProps.height;
    if (legendItem && prevLegendBBox) offset = (0, $ce9b7262abb43277$export$3a657a8c9f789617)(offset, graphicalItems, props, prevLegendBBox);
    return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
        brushBottom: brushBottom
    }, offset), {}, {
        width: width - offset.left - offset.right,
        height: height - offset.top - offset.bottom
    });
};
var $c61dda0fca74c9ef$export$77871aede60e6838 = function generateCategoricalChart(_ref6) {
    var _class, _temp;
    var chartName = _ref6.chartName, GraphicalChild = _ref6.GraphicalChild, _ref6$defaultTooltipE = _ref6.defaultTooltipEventType, defaultTooltipEventType = _ref6$defaultTooltipE === void 0 ? "axis" : _ref6$defaultTooltipE, _ref6$validateTooltip = _ref6.validateTooltipEventTypes, validateTooltipEventTypes = _ref6$validateTooltip === void 0 ? [
        "axis"
    ] : _ref6$validateTooltip, axisComponents = _ref6.axisComponents, legendContent = _ref6.legendContent, formatAxisMap = _ref6.formatAxisMap, defaultProps = _ref6.defaultProps;
    var getFormatItems = function getFormatItems(props, currentState) {
        var graphicalItems = currentState.graphicalItems, stackGroups = currentState.stackGroups, offset = currentState.offset, updateId = currentState.updateId, dataStartIndex = currentState.dataStartIndex, dataEndIndex = currentState.dataEndIndex;
        var barSize = props.barSize, layout = props.layout, barGap = props.barGap, barCategoryGap = props.barCategoryGap, globalMaxBarSize = props.maxBarSize;
        var _getAxisNameByLayout = $c61dda0fca74c9ef$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout.numericAxisName, cateAxisName = _getAxisNameByLayout.cateAxisName;
        var hasBar = $c61dda0fca74c9ef$var$hasGraphicalBarItem(graphicalItems);
        var sizeList = hasBar && (0, $ce9b7262abb43277$export$570d306bee26c748)({
            barSize: barSize,
            stackGroups: stackGroups
        });
        var formattedItems = [];
        graphicalItems.forEach(function(item, index) {
            var displayedData = $c61dda0fca74c9ef$var$getDisplayedData(props.data, {
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }, item);
            var _item$props = item.props, dataKey = _item$props.dataKey, childMaxBarSize = _item$props.maxBarSize;
            var numericAxisId = item.props["".concat(numericAxisName, "Id")];
            var cateAxisId = item.props["".concat(cateAxisName, "Id")];
            var axisObj = axisComponents.reduce(function(result, entry) {
                var _objectSpread6;
                var axisMap = currentState["".concat(entry.axisType, "Map")];
                var id = item.props["".concat(entry.axisType, "Id")];
                var axis = axisMap && axisMap[id];
                return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, (_objectSpread6 = {}, $c61dda0fca74c9ef$var$_defineProperty(_objectSpread6, entry.axisType, axis), $c61dda0fca74c9ef$var$_defineProperty(_objectSpread6, "".concat(entry.axisType, "Ticks"), (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(axis)), _objectSpread6));
            }, {});
            var cateAxis = axisObj[cateAxisName];
            var cateTicks = axisObj["".concat(cateAxisName, "Ticks")];
            var stackedData = stackGroups && stackGroups[numericAxisId] && stackGroups[numericAxisId].hasStack && (0, $ce9b7262abb43277$export$a17bf3d98457878c)(item, stackGroups[numericAxisId].stackGroups);
            var itemIsBar = (0, $ffd74d03487febd9$export$be63e0664592e141)(item.type).indexOf("Bar") >= 0;
            var bandSize = (0, $ce9b7262abb43277$export$212ec45c42fe68a7)(cateAxis, cateTicks);
            var barPosition = [];
            if (itemIsBar) {
                var _ref7, _getBandSizeOfAxis;
                // 如果是bar，计算bar的位置
                var maxBarSize = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(childMaxBarSize) ? globalMaxBarSize : childMaxBarSize;
                var barBandSize = (_ref7 = (_getBandSizeOfAxis = (0, $ce9b7262abb43277$export$212ec45c42fe68a7)(cateAxis, cateTicks, true)) !== null && _getBandSizeOfAxis !== void 0 ? _getBandSizeOfAxis : maxBarSize) !== null && _ref7 !== void 0 ? _ref7 : 0;
                barPosition = (0, $ce9b7262abb43277$export$d36834ecd87f906b)({
                    barGap: barGap,
                    barCategoryGap: barCategoryGap,
                    bandSize: barBandSize !== bandSize ? barBandSize : bandSize,
                    sizeList: sizeList[cateAxisId],
                    maxBarSize: maxBarSize
                });
                if (barBandSize !== bandSize) barPosition = barPosition.map(function(pos) {
                    return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, pos), {}, {
                        position: $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, pos.position), {}, {
                            offset: pos.position.offset - barBandSize / 2
                        })
                    });
                });
            }
            var composedFn = item && item.type && item.type.getComposedData;
            if (composedFn) {
                var _objectSpread7;
                formattedItems.push({
                    props: $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, composedFn($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, axisObj), {}, {
                        displayedData: displayedData,
                        props: props,
                        dataKey: dataKey,
                        item: item,
                        bandSize: bandSize,
                        barPosition: barPosition,
                        offset: offset,
                        stackedData: stackedData,
                        layout: layout,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }))), {}, (_objectSpread7 = {
                        key: item.key || "item-".concat(index)
                    }, $c61dda0fca74c9ef$var$_defineProperty(_objectSpread7, numericAxisName, axisObj[numericAxisName]), $c61dda0fca74c9ef$var$_defineProperty(_objectSpread7, cateAxisName, axisObj[cateAxisName]), $c61dda0fca74c9ef$var$_defineProperty(_objectSpread7, "animationId", updateId), _objectSpread7)),
                    childIndex: (0, $ffd74d03487febd9$export$857ca101f741953)(item, props.children),
                    item: item
                });
            }
        });
        return formattedItems;
    };
    /**
   * The AxisMaps are expensive to render on large data sets
   * so provide the ability to store them in state and only update them when necessary
   * they are dependent upon the start and end index of
   * the brush so it's important that this method is called _after_
   * the state is updated with any new start/end indices
   *
   * @param {Object} props          The props object to be used for updating the axismaps
   * dataStartIndex: The start index of the data series when a brush is applied
   * dataEndIndex: The end index of the data series when a brush is applied
   * updateId: The update id
   * @param {Object} prevState      Prev state
   * @return {Object} state New state to set
   */ var updateStateOfAxisMapsOffsetAndStackGroups = function updateStateOfAxisMapsOffsetAndStackGroups(_ref8, prevState) {
        var props = _ref8.props, dataStartIndex = _ref8.dataStartIndex, dataEndIndex = _ref8.dataEndIndex, updateId = _ref8.updateId;
        if (!(0, $ffd74d03487febd9$export$5301de6bfd3cfa2a)({
            props: props
        })) return null;
        var children = props.children, layout = props.layout, stackOffset = props.stackOffset, data = props.data, reverseStackOrder = props.reverseStackOrder;
        var _getAxisNameByLayout2 = $c61dda0fca74c9ef$var$getAxisNameByLayout(layout), numericAxisName = _getAxisNameByLayout2.numericAxisName, cateAxisName = _getAxisNameByLayout2.cateAxisName;
        var graphicalItems = (0, $ffd74d03487febd9$export$fdd5e64c0e8495bb)(children, GraphicalChild);
        var stackGroups = (0, $ce9b7262abb43277$export$9af3ba56474b9601)(data, graphicalItems, "".concat(numericAxisName, "Id"), "".concat(cateAxisName, "Id"), stackOffset, reverseStackOrder);
        var axisObj = axisComponents.reduce(function(result, entry) {
            var name = "".concat(entry.axisType, "Map");
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, result), {}, $c61dda0fca74c9ef$var$_defineProperty({}, name, $c61dda0fca74c9ef$var$getAxisMap(props, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, entry), {}, {
                graphicalItems: graphicalItems,
                stackGroups: entry.axisType === numericAxisName && stackGroups,
                dataStartIndex: dataStartIndex,
                dataEndIndex: dataEndIndex
            }))));
        }, {});
        var offset = $c61dda0fca74c9ef$var$calculateOffset($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, axisObj), {}, {
            props: props,
            graphicalItems: graphicalItems
        }), prevState === null || prevState === void 0 ? void 0 : prevState.legendBBox);
        Object.keys(axisObj).forEach(function(key) {
            axisObj[key] = formatAxisMap(props, axisObj[key], offset, key.replace("Map", ""), chartName);
        });
        var cateAxisMap = axisObj["".concat(cateAxisName, "Map")];
        var ticksObj = $c61dda0fca74c9ef$var$tooltipTicksGenerator(cateAxisMap);
        var formattedGraphicalItems = getFormatItems(props, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, axisObj), {}, {
            dataStartIndex: dataStartIndex,
            dataEndIndex: dataEndIndex,
            updateId: updateId,
            graphicalItems: graphicalItems,
            stackGroups: stackGroups,
            offset: offset
        }));
        return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
            formattedGraphicalItems: formattedGraphicalItems,
            graphicalItems: graphicalItems,
            offset: offset,
            stackGroups: stackGroups
        }, ticksObj), axisObj);
    };
    return _temp = _class = /*#__PURE__*/ function(_Component) {
        $c61dda0fca74c9ef$var$_inherits(CategoricalChartWrapper, _Component);
        var _super = $c61dda0fca74c9ef$var$_createSuper(CategoricalChartWrapper);
        // todo join specific chart propTypes
        function CategoricalChartWrapper(_props) {
            var _this;
            $c61dda0fca74c9ef$var$_classCallCheck(this, CategoricalChartWrapper);
            _this = _super.call(this, _props);
            _this.uniqueChartId = void 0;
            _this.clipPathId = void 0;
            _this.legendInstance = void 0;
            _this.deferId = void 0;
            _this.container = void 0;
            _this.clearDeferId = function() {
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(_this.deferId) && $c61dda0fca74c9ef$var$deferClear) $c61dda0fca74c9ef$var$deferClear(_this.deferId);
                _this.deferId = null;
            };
            _this.handleLegendBBoxUpdate = function(box) {
                if (box) {
                    var _this$state = _this.state, dataStartIndex = _this$state.dataStartIndex, dataEndIndex = _this$state.dataEndIndex, updateId = _this$state.updateId;
                    _this.setState($c61dda0fca74c9ef$var$_objectSpread({
                        legendBBox: box
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: _this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, _this.state), {}, {
                        legendBBox: box
                    }))));
                }
            };
            _this.handleReceiveSyncEvent = function(cId, chartId, data) {
                var syncId = _this.props.syncId;
                if (syncId === cId && chartId !== _this.uniqueChartId) {
                    _this.clearDeferId();
                    _this.deferId = $c61dda0fca74c9ef$var$defer && $c61dda0fca74c9ef$var$defer(_this.applySyncEvent.bind($c61dda0fca74c9ef$var$_assertThisInitialized(_this), data));
                }
            };
            _this.handleBrushChange = function(_ref9) {
                var startIndex = _ref9.startIndex, endIndex = _ref9.endIndex;
                // Only trigger changes if the extents of the brush have actually changed
                if (startIndex !== _this.state.dataStartIndex || endIndex !== _this.state.dataEndIndex) {
                    var updateId = _this.state.updateId;
                    _this.setState(function() {
                        return $c61dda0fca74c9ef$var$_objectSpread({
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex
                        }, updateStateOfAxisMapsOffsetAndStackGroups({
                            props: _this.props,
                            dataStartIndex: startIndex,
                            dataEndIndex: endIndex,
                            updateId: updateId
                        }, _this.state));
                    });
                    _this.triggerSyncEvent({
                        dataStartIndex: startIndex,
                        dataEndIndex: endIndex
                    });
                }
            };
            _this.handleMouseEnter = function(e) {
                var onMouseEnter = _this.props.onMouseEnter;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState);
                    _this.triggerSyncEvent(_nextState);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onMouseEnter)) onMouseEnter(_nextState, e);
                }
            };
            _this.triggeredAfterMouseMove = function(e) {
                var onMouseMove = _this.props.onMouseMove;
                var mouse = _this.getMouseInfo(e);
                var nextState = mouse ? $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, mouse), {}, {
                    isTooltipActive: true
                }) : {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onMouseMove)) onMouseMove(nextState, e);
            };
            _this.handleItemMouseEnter = function(el) {
                _this.setState(function() {
                    return {
                        isTooltipActive: true,
                        activeItem: el,
                        activePayload: el.tooltipPayload,
                        activeCoordinate: el.tooltipPosition || {
                            x: el.cx,
                            y: el.cy
                        }
                    };
                });
            };
            _this.handleItemMouseLeave = function() {
                _this.setState(function() {
                    return {
                        isTooltipActive: false
                    };
                });
            };
            _this.handleMouseMove = function(e) {
                if (e && (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(e.persist)) e.persist();
                _this.triggeredAfterMouseMove(e);
            };
            _this.handleMouseLeave = function(e) {
                var onMouseLeave = _this.props.onMouseLeave;
                var nextState = {
                    isTooltipActive: false
                };
                _this.setState(nextState);
                _this.triggerSyncEvent(nextState);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onMouseLeave)) onMouseLeave(nextState, e);
                _this.cancelThrottledTriggerAfterMouseMove();
            };
            _this.handleOuterEvent = function(e) {
                var eventName = (0, $ffd74d03487febd9$export$afb3591bc51a0b70)(e);
                var event = (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(_this.props, "".concat(eventName));
                if (eventName && (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(event)) {
                    var mouse;
                    if (/.*touch.*/i.test(eventName)) mouse = _this.getMouseInfo(e.changedTouches[0]);
                    else mouse = _this.getMouseInfo(e);
                    var handler = event;
                    handler(mouse, e);
                }
            };
            _this.handleClick = function(e) {
                var onClick = _this.props.onClick;
                var mouse = _this.getMouseInfo(e);
                if (mouse) {
                    var _nextState2 = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, mouse), {}, {
                        isTooltipActive: true
                    });
                    _this.setState(_nextState2);
                    _this.triggerSyncEvent(_nextState2);
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onClick)) onClick(_nextState2, e);
                }
            };
            _this.handleMouseDown = function(e) {
                var onMouseDown = _this.props.onMouseDown;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onMouseDown)) {
                    var _nextState3 = _this.getMouseInfo(e);
                    onMouseDown(_nextState3, e);
                }
            };
            _this.handleMouseUp = function(e) {
                var onMouseUp = _this.props.onMouseUp;
                if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(onMouseUp)) {
                    var _nextState4 = _this.getMouseInfo(e);
                    onMouseUp(_nextState4, e);
                }
            };
            _this.handleTouchMove = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseMove(e.changedTouches[0]);
            };
            _this.handleTouchStart = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseDown(e.changedTouches[0]);
            };
            _this.handleTouchEnd = function(e) {
                if (e.changedTouches != null && e.changedTouches.length > 0) _this.handleMouseUp(e.changedTouches[0]);
            };
            _this.verticalCoordinatesGenerator = function(_ref10) {
                var xAxis = _ref10.xAxis, width = _ref10.width, height = _ref10.height, offset = _ref10.offset;
                return (0, $ce9b7262abb43277$export$846dc5ac5fecff74)((0, $fbb091d423dfa995$export$bdd99f2cdf352bae).getTicks($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, (0, $fbb091d423dfa995$export$bdd99f2cdf352bae).defaultProps), xAxis), {}, {
                    ticks: (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(xAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.left, offset.left + offset.width);
            };
            _this.horizontalCoordinatesGenerator = function(_ref11) {
                var yAxis = _ref11.yAxis, width = _ref11.width, height = _ref11.height, offset = _ref11.offset;
                return (0, $ce9b7262abb43277$export$846dc5ac5fecff74)((0, $fbb091d423dfa995$export$bdd99f2cdf352bae).getTicks($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, (0, $fbb091d423dfa995$export$bdd99f2cdf352bae).defaultProps), yAxis), {}, {
                    ticks: (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(yAxis, true),
                    viewBox: {
                        x: 0,
                        y: 0,
                        width: width,
                        height: height
                    }
                })), offset.top, offset.top + offset.height);
            };
            _this.axesTicksGenerator = function(axis) {
                return (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(axis, true);
            };
            _this.renderCursor = function(element) {
                var _this$state2 = _this.state, isTooltipActive = _this$state2.isTooltipActive, activeCoordinate = _this$state2.activeCoordinate, activePayload = _this$state2.activePayload, offset = _this$state2.offset, activeTooltipIndex = _this$state2.activeTooltipIndex;
                var tooltipEventType = _this.getTooltipEventType();
                if (!element || !element.props.cursor || !isTooltipActive || !activeCoordinate || chartName !== "ScatterChart" && tooltipEventType !== "axis") return null;
                var layout = _this.props.layout;
                var restProps;
                var cursorComp = (0, $1046975411d24196$export$b0e83c3ef8d2db1);
                if (chartName === "ScatterChart") {
                    restProps = activeCoordinate;
                    cursorComp = (0, $9a5c5df298bd3ceb$export$3c877bb842c36952);
                } else if (chartName === "BarChart") {
                    restProps = _this.getCursorRectangle();
                    cursorComp = (0, $f932de744a8ef4df$export$4617fb02663045ef);
                } else if (layout === "radial") {
                    var _this$getCursorPoints = _this.getCursorPoints(), cx = _this$getCursorPoints.cx, cy = _this$getCursorPoints.cy, radius = _this$getCursorPoints.radius, startAngle = _this$getCursorPoints.startAngle, endAngle = _this$getCursorPoints.endAngle;
                    restProps = {
                        cx: cx,
                        cy: cy,
                        startAngle: startAngle,
                        endAngle: endAngle,
                        innerRadius: radius,
                        outerRadius: radius
                    };
                    cursorComp = (0, $57a3d2c9ea84bfee$export$e98c2c7eb2b14f45);
                } else {
                    restProps = {
                        points: _this.getCursorPoints()
                    };
                    cursorComp = (0, $1046975411d24196$export$b0e83c3ef8d2db1);
                }
                var key = element.key || "_recharts-cursor";
                var cursorProps = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                    stroke: "#ccc",
                    pointerEvents: "none"
                }, offset), restProps), (0, $dd873d09408694ab$export$d697c39a2985a4c)(element.props.cursor)), {}, {
                    payload: activePayload,
                    payloadIndex: activeTooltipIndex,
                    key: key,
                    className: "recharts-tooltip-cursor"
                });
                return /*#__PURE__*/ (0, $eCoWV.isValidElement)(element.props.cursor) ? /*#__PURE__*/ (0, $eCoWV.cloneElement)(element.props.cursor, cursorProps) : /*#__PURE__*/ (0, $eCoWV.createElement)(cursorComp, cursorProps);
            };
            _this.renderPolarAxis = function(element, displayName, index) {
                var axisType = (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(element, "type.axisType");
                var axisMap = (0, (/*@__PURE__*/$parcel$interopDefault($5d6ab69f292f1b81$exports)))(_this.state, "".concat(axisType, "Map"));
                var axisOption = axisMap[element.props["".concat(axisType, "Id")]];
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, axisOption), {}, {
                    className: axisType,
                    key: element.key || "".concat(displayName, "-").concat(index),
                    ticks: (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(axisOption, true)
                }));
            };
            _this.renderXAxis = function(element, displayName, index) {
                var xAxisMap = _this.state.xAxisMap;
                var axisObj = xAxisMap[element.props.xAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            };
            _this.renderYAxis = function(element, displayName, index) {
                var yAxisMap = _this.state.yAxisMap;
                var axisObj = yAxisMap[element.props.yAxisId];
                return _this.renderAxis(axisObj, element, displayName, index);
            };
            _this.renderGrid = function(element) {
                var _this$state3 = _this.state, xAxisMap = _this$state3.xAxisMap, yAxisMap = _this$state3.yAxisMap, offset = _this$state3.offset;
                var _this$props = _this.props, width = _this$props.width, height = _this$props.height;
                var xAxis = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(xAxisMap);
                var yAxisWithFiniteDomain = (0, (/*@__PURE__*/$parcel$interopDefault($2c70d7833d64d5e4$exports)))(yAxisMap, function(axis) {
                    return (0, (/*@__PURE__*/$parcel$interopDefault($c058f5bdb4b78d5f$exports)))(axis.domain, $c61dda0fca74c9ef$var$isFinit);
                });
                var yAxis = yAxisWithFiniteDomain || (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(yAxisMap);
                var props = element.props || {};
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, {
                    key: element.key || "grid",
                    x: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(props.x) ? props.x : offset.left,
                    y: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(props.y) ? props.y : offset.top,
                    width: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(props.width) ? props.width : offset.width,
                    height: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(props.height) ? props.height : offset.height,
                    xAxis: xAxis,
                    yAxis: yAxis,
                    offset: offset,
                    chartWidth: width,
                    chartHeight: height,
                    verticalCoordinatesGenerator: props.verticalCoordinatesGenerator || _this.verticalCoordinatesGenerator,
                    horizontalCoordinatesGenerator: props.horizontalCoordinatesGenerator || _this.horizontalCoordinatesGenerator
                });
            };
            _this.renderPolarGrid = function(element) {
                var _element$props = element.props, radialLines = _element$props.radialLines, polarAngles = _element$props.polarAngles, polarRadius = _element$props.polarRadius;
                var _this$state4 = _this.state, radiusAxisMap = _this$state4.radiusAxisMap, angleAxisMap = _this$state4.angleAxisMap;
                var radiusAxis = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(radiusAxisMap);
                var angleAxis = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(angleAxisMap);
                var cx = angleAxis.cx, cy = angleAxis.cy, innerRadius = angleAxis.innerRadius, outerRadius = angleAxis.outerRadius;
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, {
                    polarAngles: (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(polarAngles) ? polarAngles : (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(angleAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    polarRadius: (0, (/*@__PURE__*/$parcel$interopDefault($0731a2307bf9d7f9$exports)))(polarRadius) ? polarRadius : (0, $ce9b7262abb43277$export$c829ee42daf7f66d)(radiusAxis, true).map(function(entry) {
                        return entry.coordinate;
                    }),
                    cx: cx,
                    cy: cy,
                    innerRadius: innerRadius,
                    outerRadius: outerRadius,
                    key: element.key || "polar-grid",
                    radialLines: radialLines
                });
            };
            _this.renderLegend = function() {
                var formattedGraphicalItems = _this.state.formattedGraphicalItems;
                var _this$props2 = _this.props, children = _this$props2.children, width = _this$props2.width, height = _this$props2.height;
                var margin = _this.props.margin || {};
                var legendWidth = width - (margin.left || 0) - (margin.right || 0);
                var props = (0, $ce9b7262abb43277$export$8f9424d123c36aa)({
                    children: children,
                    formattedGraphicalItems: formattedGraphicalItems,
                    legendWidth: legendWidth,
                    legendContent: legendContent
                });
                if (!props) return null;
                var item = props.item, otherProps = $c61dda0fca74c9ef$var$_objectWithoutProperties(props, [
                    "item"
                ]);
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(item, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, otherProps), {}, {
                    chartWidth: width,
                    chartHeight: height,
                    margin: margin,
                    ref: function ref(legend) {
                        _this.legendInstance = legend;
                    },
                    onBBoxUpdate: _this.handleLegendBBoxUpdate
                }));
            };
            _this.renderTooltip = function() {
                var children = _this.props.children;
                var tooltipItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $b4b3fd02c5ccdb66$export$28c660c63b792dea).displayName);
                if (!tooltipItem) return null;
                var _this$state5 = _this.state, isTooltipActive = _this$state5.isTooltipActive, activeCoordinate = _this$state5.activeCoordinate, activePayload = _this$state5.activePayload, activeLabel = _this$state5.activeLabel, offset = _this$state5.offset;
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(tooltipItem, {
                    viewBox: $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, offset), {}, {
                        x: offset.left,
                        y: offset.top
                    }),
                    active: isTooltipActive,
                    label: activeLabel,
                    payload: isTooltipActive ? activePayload : [],
                    coordinate: activeCoordinate
                });
            };
            _this.renderBrush = function(element) {
                var _this$props3 = _this.props, margin = _this$props3.margin, data = _this$props3.data;
                var _this$state6 = _this.state, offset = _this$state6.offset, dataStartIndex = _this$state6.dataStartIndex, dataEndIndex = _this$state6.dataEndIndex, updateId = _this$state6.updateId; // TODO: update brush when children update
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, {
                    key: element.key || "_recharts-brush",
                    onChange: (0, $ce9b7262abb43277$export$760ec406ba47bace)(_this.handleBrushChange, null, element.props.onChange),
                    data: data,
                    x: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(element.props.x) ? element.props.x : offset.left,
                    y: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(element.props.y) ? element.props.y : offset.top + offset.height + offset.brushBottom - (margin.bottom || 0),
                    width: (0, $a4d9ec64928c627b$export$7e4aa119212bc614)(element.props.width) ? element.props.width : offset.width,
                    startIndex: dataStartIndex,
                    endIndex: dataEndIndex,
                    updateId: "brush-".concat(updateId)
                });
            };
            _this.renderReferenceElement = function(element, displayName, index) {
                if (!element) return null;
                var _assertThisInitialize = $c61dda0fca74c9ef$var$_assertThisInitialized(_this), clipPathId = _assertThisInitialize.clipPathId;
                var _this$state7 = _this.state, xAxisMap = _this$state7.xAxisMap, yAxisMap = _this$state7.yAxisMap, offset = _this$state7.offset;
                var _element$props2 = element.props, xAxisId = _element$props2.xAxisId, yAxisId = _element$props2.yAxisId;
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, {
                    key: element.key || "".concat(displayName, "-").concat(index),
                    xAxis: xAxisMap[xAxisId],
                    yAxis: yAxisMap[yAxisId],
                    viewBox: {
                        x: offset.left,
                        y: offset.top,
                        width: offset.width,
                        height: offset.height
                    },
                    clipPathId: clipPathId
                });
            };
            _this.renderActivePoints = function(_ref12) {
                var item = _ref12.item, activePoint = _ref12.activePoint, basePoint = _ref12.basePoint, childIndex = _ref12.childIndex, isRange = _ref12.isRange;
                var result = [];
                var key = item.props.key;
                var _item$item$props = item.item.props, activeDot = _item$item$props.activeDot, dataKey = _item$item$props.dataKey;
                var dotProps = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                    index: childIndex,
                    dataKey: dataKey,
                    cx: activePoint.x,
                    cy: activePoint.y,
                    r: 4,
                    fill: (0, $ce9b7262abb43277$export$ec6cab5a7a3b93bf)(item.item),
                    strokeWidth: 2,
                    stroke: "#fff",
                    payload: activePoint.payload,
                    value: activePoint.value,
                    key: "".concat(key, "-activePoint-").concat(childIndex)
                }, (0, $dd873d09408694ab$export$d697c39a2985a4c)(activeDot)), (0, $dd873d09408694ab$export$7c4c290a4a9c1b1e)(activeDot));
                result.push(CategoricalChartWrapper.renderActiveDot(activeDot, dotProps));
                if (basePoint) result.push(CategoricalChartWrapper.renderActiveDot(activeDot, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, dotProps), {}, {
                    cx: basePoint.x,
                    cy: basePoint.y,
                    key: "".concat(key, "-basePoint-").concat(childIndex)
                })));
                else if (isRange) result.push(null);
                return result;
            };
            _this.renderGraphicChild = function(element, displayName, index) {
                var item = _this.filterFormatItem(element, displayName, index);
                if (!item) return null;
                var tooltipEventType = _this.getTooltipEventType();
                var _this$state8 = _this.state, isTooltipActive = _this$state8.isTooltipActive, tooltipAxis = _this$state8.tooltipAxis, activeTooltipIndex = _this$state8.activeTooltipIndex, activeLabel = _this$state8.activeLabel;
                var children = _this.props.children;
                var tooltipItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $b4b3fd02c5ccdb66$export$28c660c63b792dea).displayName);
                var _item$props2 = item.props, points = _item$props2.points, isRange = _item$props2.isRange, baseLine = _item$props2.baseLine;
                var _item$item$props2 = item.item.props, activeDot = _item$item$props2.activeDot, hide = _item$item$props2.hide;
                var hasActive = !hide && isTooltipActive && tooltipItem && activeDot && activeTooltipIndex >= 0;
                var itemEvents = {};
                if (tooltipEventType !== "axis" && tooltipItem && tooltipItem.props.trigger === "click") itemEvents = {
                    onClick: (0, $ce9b7262abb43277$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onCLick)
                };
                else if (tooltipEventType !== "axis") itemEvents = {
                    onMouseLeave: (0, $ce9b7262abb43277$export$760ec406ba47bace)(_this.handleItemMouseLeave, null, element.props.onMouseLeave),
                    onMouseEnter: (0, $ce9b7262abb43277$export$760ec406ba47bace)(_this.handleItemMouseEnter, null, element.props.onMouseEnter)
                };
                var graphicalItem = /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, item.props), itemEvents));
                function findWithPayload(entry) {
                    // TODO needs to verify dataKey is Function
                    return typeof tooltipAxis.dataKey === "function" ? tooltipAxis.dataKey(entry.payload) : null;
                }
                if (hasActive) {
                    var activePoint, basePoint;
                    if (tooltipAxis.dataKey && !tooltipAxis.allowDuplicatedCategory) {
                        // number transform to string
                        var specifiedKey = typeof tooltipAxis.dataKey === "function" ? findWithPayload : "payload.".concat(tooltipAxis.dataKey.toString());
                        activePoint = (0, $a4d9ec64928c627b$export$66950d3869f5cc67)(points, specifiedKey, activeLabel);
                        basePoint = isRange && baseLine && (0, $a4d9ec64928c627b$export$66950d3869f5cc67)(baseLine, specifiedKey, activeLabel);
                    } else {
                        activePoint = points[activeTooltipIndex];
                        basePoint = isRange && baseLine && baseLine[activeTooltipIndex];
                    }
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(activePoint)) return [
                        graphicalItem
                    ].concat($c61dda0fca74c9ef$var$_toConsumableArray(_this.renderActivePoints({
                        item: item,
                        activePoint: activePoint,
                        basePoint: basePoint,
                        childIndex: activeTooltipIndex,
                        isRange: isRange
                    })));
                }
                if (isRange) return [
                    graphicalItem,
                    null,
                    null
                ];
                return [
                    graphicalItem,
                    null
                ];
            };
            _this.renderCustomized = function(element, displayName, index) {
                return /*#__PURE__*/ (0, $eCoWV.cloneElement)(element, $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                    key: "recharts-customized-".concat(index)
                }, _this.props), _this.state));
            };
            _this.uniqueChartId = (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(_props.id) ? (0, $a4d9ec64928c627b$export$8b15d37bc3f197d4)("recharts") : _props.id;
            _this.clipPathId = "".concat(_this.uniqueChartId, "-clip");
            if (_props.throttleDelay) _this.triggeredAfterMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($d47bb8aefe2e817f$exports)))(_this.triggeredAfterMouseMove, _props.throttleDelay);
            _this.state = {};
            return _this;
        }
        /* eslint-disable  react/no-did-mount-set-state */ $c61dda0fca74c9ef$var$_createClass(CategoricalChartWrapper, [
            {
                key: "componentDidMount",
                value: function componentDidMount() {
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(this.props.syncId)) this.addListener();
                }
            },
            {
                key: "componentDidUpdate",
                value: function componentDidUpdate(prevProps) {
                    // add syncId
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(prevProps.syncId) && !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(this.props.syncId)) this.addListener();
                     // remove syncId
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(prevProps.syncId) && (0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(this.props.syncId)) this.removeListener();
                }
            },
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.clearDeferId();
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(this.props.syncId)) this.removeListener();
                    this.cancelThrottledTriggerAfterMouseMove();
                }
            },
            {
                key: "cancelThrottledTriggerAfterMouseMove",
                value: function cancelThrottledTriggerAfterMouseMove() {
                    if (typeof this.triggeredAfterMouseMove.cancel === "function") this.triggeredAfterMouseMove.cancel();
                }
            },
            {
                key: "getTooltipEventType",
                value: function getTooltipEventType() {
                    var tooltipItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(this.props.children, (0, $b4b3fd02c5ccdb66$export$28c660c63b792dea).displayName);
                    if (tooltipItem && (0, (/*@__PURE__*/$parcel$interopDefault($a957fa86a99b0b41$exports)))(tooltipItem.props.shared)) {
                        var eventType = tooltipItem.props.shared ? "axis" : "item";
                        return validateTooltipEventTypes.indexOf(eventType) >= 0 ? eventType : defaultTooltipEventType;
                    }
                    return defaultTooltipEventType;
                }
            },
            {
                key: "getMouseInfo",
                value: function getMouseInfo(event) {
                    if (!this.container) return null;
                    var containerOffset = (0, $aea69284868f6157$export$622cea445a1c5b7d)(this.container);
                    var e = (0, $aea69284868f6157$export$f209e6c32ad3d02e)(event, containerOffset);
                    var rangeObj = this.inRange(e.chartX, e.chartY);
                    if (!rangeObj) return null;
                    var _this$state9 = this.state, xAxisMap = _this$state9.xAxisMap, yAxisMap = _this$state9.yAxisMap;
                    var tooltipEventType = this.getTooltipEventType();
                    if (tooltipEventType !== "axis" && xAxisMap && yAxisMap) {
                        var xScale = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(xAxisMap).scale;
                        var yScale = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(yAxisMap).scale;
                        var xValue = xScale && xScale.invert ? xScale.invert(e.chartX) : null;
                        var yValue = yScale && yScale.invert ? yScale.invert(e.chartY) : null;
                        return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, e), {}, {
                            xValue: xValue,
                            yValue: yValue
                        });
                    }
                    var toolTipData = $c61dda0fca74c9ef$var$getTooltipData(this.state, this.props.data, this.props.layout, rangeObj);
                    if (toolTipData) return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, e), toolTipData);
                    return null;
                }
            },
            {
                key: "getCursorRectangle",
                value: function getCursorRectangle() {
                    var layout = this.props.layout;
                    var _this$state10 = this.state, activeCoordinate = _this$state10.activeCoordinate, offset = _this$state10.offset, tooltipAxisBandSize = _this$state10.tooltipAxisBandSize;
                    var halfSize = tooltipAxisBandSize / 2;
                    return {
                        stroke: "none",
                        fill: "#ccc",
                        x: layout === "horizontal" ? activeCoordinate.x - halfSize : offset.left + 0.5,
                        y: layout === "horizontal" ? offset.top + 0.5 : activeCoordinate.y - halfSize,
                        width: layout === "horizontal" ? tooltipAxisBandSize : offset.width - 1,
                        height: layout === "horizontal" ? offset.height - 1 : tooltipAxisBandSize
                    };
                }
            },
            {
                key: "getCursorPoints",
                value: function getCursorPoints() {
                    var layout = this.props.layout;
                    var _this$state11 = this.state, activeCoordinate = _this$state11.activeCoordinate, offset = _this$state11.offset;
                    var x1, y1, x2, y2;
                    if (layout === "horizontal") {
                        x1 = activeCoordinate.x;
                        x2 = x1;
                        y1 = offset.top;
                        y2 = offset.top + offset.height;
                    } else if (layout === "vertical") {
                        y1 = activeCoordinate.y;
                        y2 = y1;
                        x1 = offset.left;
                        x2 = offset.left + offset.width;
                    } else if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(activeCoordinate.cx) || !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(activeCoordinate.cy)) {
                        if (layout === "centric") {
                            var cx = activeCoordinate.cx, cy = activeCoordinate.cy, innerRadius = activeCoordinate.innerRadius, outerRadius = activeCoordinate.outerRadius, angle = activeCoordinate.angle;
                            var innerPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, innerRadius, angle);
                            var outerPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(cx, cy, outerRadius, angle);
                            x1 = innerPoint.x;
                            y1 = innerPoint.y;
                            x2 = outerPoint.x;
                            y2 = outerPoint.y;
                        } else {
                            var _cx = activeCoordinate.cx, _cy = activeCoordinate.cy, radius = activeCoordinate.radius, startAngle = activeCoordinate.startAngle, endAngle = activeCoordinate.endAngle;
                            var startPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(_cx, _cy, radius, startAngle);
                            var endPoint = (0, $0fac551513a25c6a$export$5c9a959bb3fc7749)(_cx, _cy, radius, endAngle);
                            return {
                                points: [
                                    startPoint,
                                    endPoint
                                ],
                                cx: _cx,
                                cy: _cy,
                                radius: radius,
                                startAngle: startAngle,
                                endAngle: endAngle
                            };
                        }
                    }
                    return [
                        {
                            x: x1,
                            y: y1
                        },
                        {
                            x: x2,
                            y: y2
                        }
                    ];
                }
            },
            {
                key: "inRange",
                value: function inRange(x, y) {
                    var layout = this.props.layout;
                    if (layout === "horizontal" || layout === "vertical") {
                        var offset = this.state.offset;
                        var isInRange = x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
                        return isInRange ? {
                            x: x,
                            y: y
                        } : null;
                    }
                    var _this$state12 = this.state, angleAxisMap = _this$state12.angleAxisMap, radiusAxisMap = _this$state12.radiusAxisMap;
                    if (angleAxisMap && radiusAxisMap) {
                        var angleAxis = (0, $a4d9ec64928c627b$export$b88993f0aa0bf776)(angleAxisMap);
                        return (0, $0fac551513a25c6a$export$e85a2bf8cd31c504)({
                            x: x,
                            y: y
                        }, angleAxis);
                    }
                    return null;
                }
            },
            {
                key: "parseEventsOfWrapper",
                value: function parseEventsOfWrapper() {
                    var children = this.props.children;
                    var tooltipEventType = this.getTooltipEventType();
                    var tooltipItem = (0, $ffd74d03487febd9$export$64c61536a2b72e0f)(children, (0, $b4b3fd02c5ccdb66$export$28c660c63b792dea).displayName);
                    var tooltipEvents = {};
                    if (tooltipItem && tooltipEventType === "axis") {
                        if (tooltipItem.props.trigger === "click") tooltipEvents = {
                            onClick: this.handleClick
                        };
                        else tooltipEvents = {
                            onMouseEnter: this.handleMouseEnter,
                            onMouseMove: this.handleMouseMove,
                            onMouseLeave: this.handleMouseLeave,
                            onTouchMove: this.handleTouchMove,
                            onTouchStart: this.handleTouchStart,
                            onTouchEnd: this.handleTouchEnd
                        };
                    }
                    var outerEvents = (0, $dd873d09408694ab$export$7c4c290a4a9c1b1e)(this.props, this.handleOuterEvent);
                    return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, outerEvents), tooltipEvents);
                }
            },
            {
                key: "addListener",
                value: function addListener() {
                    (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).on((0, $0ce71bcaa759bc7b$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).setMaxListeners && (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33)._maxListeners) (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).setMaxListeners((0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33)._maxListeners + 1);
                }
            },
            {
                key: "removeListener",
                value: function removeListener() {
                    (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).removeListener((0, $0ce71bcaa759bc7b$export$ff9a08f6d0c38b8f), this.handleReceiveSyncEvent);
                    if ((0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).setMaxListeners && (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33)._maxListeners) (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).setMaxListeners((0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33)._maxListeners - 1);
                }
            },
            {
                key: "triggerSyncEvent",
                value: function triggerSyncEvent(data) {
                    var syncId = this.props.syncId;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(syncId)) (0, $0ce71bcaa759bc7b$export$9bcdfe5f29bb33).emit((0, $0ce71bcaa759bc7b$export$ff9a08f6d0c38b8f), syncId, this.uniqueChartId, data);
                }
            },
            {
                key: "applySyncEvent",
                value: function applySyncEvent(data) {
                    var _this$props4 = this.props, layout = _this$props4.layout, syncMethod = _this$props4.syncMethod;
                    var updateId = this.state.updateId;
                    var dataStartIndex = data.dataStartIndex, dataEndIndex = data.dataEndIndex;
                    if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(data.dataStartIndex) || !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(data.dataEndIndex)) this.setState($c61dda0fca74c9ef$var$_objectSpread({
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex
                    }, updateStateOfAxisMapsOffsetAndStackGroups({
                        props: this.props,
                        dataStartIndex: dataStartIndex,
                        dataEndIndex: dataEndIndex,
                        updateId: updateId
                    }, this.state)));
                    else if (!(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(data.activeTooltipIndex)) {
                        var chartX = data.chartX, chartY = data.chartY;
                        var activeTooltipIndex = data.activeTooltipIndex;
                        var _this$state13 = this.state, offset = _this$state13.offset, tooltipTicks = _this$state13.tooltipTicks;
                        if (!offset) return;
                        if (typeof syncMethod === "function") // Call a callback function. If there is an application specific algorithm
                        activeTooltipIndex = syncMethod(tooltipTicks, data);
                        else if (syncMethod === "value") {
                            // Set activeTooltipIndex to the index with the same value as data.activeLabel
                            // For loop instead of findIndex because the latter is very slow in some browsers
                            activeTooltipIndex = -1; // in case we cannot find the element
                            for(var i = 0; i < tooltipTicks.length; i++)if (tooltipTicks[i].value === data.activeLabel) {
                                activeTooltipIndex = i;
                                break;
                            }
                        }
                        var viewBox = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, offset), {}, {
                            x: offset.left,
                            y: offset.top
                        }); // When a categotical chart is combined with another chart, the value of chartX
                        // and chartY may beyond the boundaries.
                        var validateChartX = Math.min(chartX, viewBox.x + viewBox.width);
                        var validateChartY = Math.min(chartY, viewBox.y + viewBox.height);
                        var activeLabel = tooltipTicks[activeTooltipIndex] && tooltipTicks[activeTooltipIndex].value;
                        var activePayload = $c61dda0fca74c9ef$var$getTooltipContent(this.state, this.props.data, activeTooltipIndex);
                        var activeCoordinate = tooltipTicks[activeTooltipIndex] ? {
                            x: layout === "horizontal" ? tooltipTicks[activeTooltipIndex].coordinate : validateChartX,
                            y: layout === "horizontal" ? validateChartY : tooltipTicks[activeTooltipIndex].coordinate
                        } : $c61dda0fca74c9ef$var$originCoordinate;
                        this.setState($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, data), {}, {
                            activeLabel: activeLabel,
                            activeCoordinate: activeCoordinate,
                            activePayload: activePayload,
                            activeTooltipIndex: activeTooltipIndex
                        }));
                    } else this.setState(data);
                }
            },
            {
                key: "filterFormatItem",
                value: function filterFormatItem(item, displayName, childIndex) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var entry = formattedGraphicalItems[i];
                        if (entry.item === item || entry.props.key === item.key || displayName === (0, $ffd74d03487febd9$export$be63e0664592e141)(entry.item.type) && childIndex === entry.childIndex) return entry;
                    }
                    return null;
                }
            },
            {
                key: "renderAxis",
                value: /**
       * Draw axis
       * @param {Object} axisOptions The options of axis
       * @param {Object} element      The axis element
       * @param {String} displayName  The display name of axis
       * @param {Number} index        The index of element
       * @return {ReactElement}       The instance of x-axes
       */ function renderAxis(axisOptions, element, displayName, index) {
                    var _this$props5 = this.props, width = _this$props5.width, height = _this$props5.height;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $fbb091d423dfa995$export$bdd99f2cdf352bae), $c61dda0fca74c9ef$var$_extends({}, axisOptions, {
                        className: "recharts-".concat(axisOptions.axisType, " ").concat(axisOptions.axisType),
                        key: element.key || "".concat(displayName, "-").concat(index),
                        viewBox: {
                            x: 0,
                            y: 0,
                            width: width,
                            height: height
                        },
                        ticksGenerator: this.axesTicksGenerator
                    }));
                }
            },
            {
                key: "renderClipPath",
                value: function renderClipPath() {
                    var clipPathId = this.clipPathId;
                    var _this$state$offset = this.state.offset, left = _this$state$offset.left, top = _this$state$offset.top, height = _this$state$offset.height, width = _this$state$offset.width;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("clipPath", {
                        id: clipPathId
                    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                        x: left,
                        y: top,
                        height: height,
                        width: width
                    })));
                }
            },
            {
                key: "getXScales",
                value: function getXScales() {
                    var xAxisMap = this.state.xAxisMap;
                    return xAxisMap ? Object.entries(xAxisMap).reduce(function(res, _ref13) {
                        var _ref14 = $c61dda0fca74c9ef$var$_slicedToArray(_ref13, 2), axisId = _ref14[0], axisProps = _ref14[1];
                        return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, res), {}, $c61dda0fca74c9ef$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getYScales",
                value: function getYScales() {
                    var yAxisMap = this.state.yAxisMap;
                    return yAxisMap ? Object.entries(yAxisMap).reduce(function(res, _ref15) {
                        var _ref16 = $c61dda0fca74c9ef$var$_slicedToArray(_ref15, 2), axisId = _ref16[0], axisProps = _ref16[1];
                        return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, res), {}, $c61dda0fca74c9ef$var$_defineProperty({}, axisId, axisProps.scale));
                    }, {}) : null;
                }
            },
            {
                key: "getXScaleByAxisId",
                value: function getXScaleByAxisId(axisId) {
                    var _this$state$xAxisMap, _this$state$xAxisMap$;
                    return (_this$state$xAxisMap = this.state.xAxisMap) === null || _this$state$xAxisMap === void 0 ? void 0 : (_this$state$xAxisMap$ = _this$state$xAxisMap[axisId]) === null || _this$state$xAxisMap$ === void 0 ? void 0 : _this$state$xAxisMap$.scale;
                }
            },
            {
                key: "getYScaleByAxisId",
                value: function getYScaleByAxisId(axisId) {
                    var _this$state$yAxisMap, _this$state$yAxisMap$;
                    return (_this$state$yAxisMap = this.state.yAxisMap) === null || _this$state$yAxisMap === void 0 ? void 0 : (_this$state$yAxisMap$ = _this$state$yAxisMap[axisId]) === null || _this$state$yAxisMap$ === void 0 ? void 0 : _this$state$yAxisMap$.scale;
                }
            },
            {
                key: "getItemByXY",
                value: function getItemByXY(chartXY) {
                    var formattedGraphicalItems = this.state.formattedGraphicalItems;
                    if (formattedGraphicalItems && formattedGraphicalItems.length) for(var i = 0, len = formattedGraphicalItems.length; i < len; i++){
                        var graphicalItem = formattedGraphicalItems[i];
                        var props = graphicalItem.props, item = graphicalItem.item;
                        var itemDisplayName = (0, $ffd74d03487febd9$export$be63e0664592e141)(item.type);
                        if (itemDisplayName === "Bar") {
                            var activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $f932de744a8ef4df$export$f783d19325be51d5)(chartXY, entry);
                            });
                            if (activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: activeBarItem
                            };
                        } else if (itemDisplayName === "RadialBar") {
                            var _activeBarItem = (props.data || []).find(function(entry) {
                                return (0, $0fac551513a25c6a$export$e85a2bf8cd31c504)(chartXY, entry);
                            });
                            if (_activeBarItem) return {
                                graphicalItem: graphicalItem,
                                payload: _activeBarItem
                            };
                        }
                    }
                    return null;
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this2 = this;
                    if (!(0, $ffd74d03487febd9$export$5301de6bfd3cfa2a)(this)) return null;
                    var _this$props6 = this.props, children = _this$props6.children, className = _this$props6.className, width = _this$props6.width, height = _this$props6.height, style = _this$props6.style, compact = _this$props6.compact, others = $c61dda0fca74c9ef$var$_objectWithoutProperties(_this$props6, [
                        "children",
                        "className",
                        "width",
                        "height",
                        "style",
                        "compact"
                    ]);
                    var attrs = (0, $dd873d09408694ab$export$d697c39a2985a4c)(others);
                    var map = {
                        CartesianGrid: {
                            handler: this.renderGrid,
                            once: true
                        },
                        ReferenceArea: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceLine: {
                            handler: this.renderReferenceElement
                        },
                        ReferenceDot: {
                            handler: this.renderReferenceElement
                        },
                        XAxis: {
                            handler: this.renderXAxis
                        },
                        YAxis: {
                            handler: this.renderYAxis
                        },
                        Brush: {
                            handler: this.renderBrush,
                            once: true
                        },
                        Bar: {
                            handler: this.renderGraphicChild
                        },
                        Line: {
                            handler: this.renderGraphicChild
                        },
                        Area: {
                            handler: this.renderGraphicChild
                        },
                        Radar: {
                            handler: this.renderGraphicChild
                        },
                        RadialBar: {
                            handler: this.renderGraphicChild
                        },
                        Scatter: {
                            handler: this.renderGraphicChild
                        },
                        Pie: {
                            handler: this.renderGraphicChild
                        },
                        Funnel: {
                            handler: this.renderGraphicChild
                        },
                        Tooltip: {
                            handler: this.renderCursor,
                            once: true
                        },
                        PolarGrid: {
                            handler: this.renderPolarGrid,
                            once: true
                        },
                        PolarAngleAxis: {
                            handler: this.renderPolarAxis
                        },
                        PolarRadiusAxis: {
                            handler: this.renderPolarAxis
                        },
                        Customized: {
                            handler: this.renderCustomized
                        }
                    }; // The "compact" mode is mainly used as the panorama within Brush
                    if (compact) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $97e02d2bb4391b31$export$7b92b459e668cb21), $c61dda0fca74c9ef$var$_extends({}, attrs, {
                        width: width,
                        height: height
                    }), this.renderClipPath(), (0, $ffd74d03487febd9$export$a98d6da55570cb82)(children, map));
                    var events = this.parseEventsOfWrapper();
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", $c61dda0fca74c9ef$var$_extends({
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-wrapper", className),
                        style: $c61dda0fca74c9ef$var$_objectSpread({
                            position: "relative",
                            cursor: "default",
                            width: width,
                            height: height
                        }, style)
                    }, events, {
                        ref: function ref(node) {
                            _this2.container = node;
                        }
                    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $97e02d2bb4391b31$export$7b92b459e668cb21), $c61dda0fca74c9ef$var$_extends({}, attrs, {
                        width: width,
                        height: height
                    }), this.renderClipPath(), (0, $ffd74d03487febd9$export$a98d6da55570cb82)(children, map)), this.renderLegend(), this.renderTooltip());
                }
            }
        ]);
        return CategoricalChartWrapper;
    }((0, $eCoWV.Component)), _class.displayName = chartName, _class.defaultProps = $c61dda0fca74c9ef$var$_objectSpread({
        layout: "horizontal",
        stackOffset: "none",
        barCategoryGap: "10%",
        barGap: 4,
        margin: {
            top: 5,
            right: 5,
            bottom: 5,
            left: 5
        },
        reverseStackOrder: false,
        syncMethod: "index"
    }, defaultProps), _class.getDerivedStateFromProps = function(nextProps, prevState) {
        var data = nextProps.data, children = nextProps.children, width = nextProps.width, height = nextProps.height, layout = nextProps.layout, stackOffset = nextProps.stackOffset, margin = nextProps.margin;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(prevState.updateId)) {
            var defaultState = $c61dda0fca74c9ef$var$createDefaultState(nextProps);
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, defaultState), {}, {
                updateId: 0
            }, updateStateOfAxisMapsOffsetAndStackGroups($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                props: nextProps
            }, defaultState), {}, {
                updateId: 0
            }), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (data !== prevState.prevData || width !== prevState.prevWidth || height !== prevState.prevHeight || layout !== prevState.prevLayout || stackOffset !== prevState.prevStackOffset || !(0, $876e5fb324af2e46$export$d36bdfa510afb180)(margin, prevState.prevMargin)) {
            var _defaultState = $c61dda0fca74c9ef$var$createDefaultState(nextProps); // Fixes https://github.com/recharts/recharts/issues/2143
            var keepFromPrevState = {
                // (chartX, chartY) are (0,0) in default state, but we want to keep the last mouse position to avoid
                // any flickering
                chartX: prevState.chartX,
                chartY: prevState.chartY,
                // The tooltip should stay active when it was active in the previous render. If this is not
                // the case, the tooltip disappears and immediately re-appears, causing a flickering effect
                isTooltipActive: prevState.isTooltipActive
            };
            var updatesToState = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, $c61dda0fca74c9ef$var$getTooltipData(prevState, data, layout)), {}, {
                updateId: prevState.updateId + 1
            });
            var newState = $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, _defaultState), keepFromPrevState), updatesToState);
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({}, newState), updateStateOfAxisMapsOffsetAndStackGroups($c61dda0fca74c9ef$var$_objectSpread({
                props: nextProps
            }, newState), prevState)), {}, {
                prevData: data,
                prevWidth: width,
                prevHeight: height,
                prevLayout: layout,
                prevStackOffset: stackOffset,
                prevMargin: margin,
                prevChildren: children
            });
        }
        if (!(0, $ffd74d03487febd9$export$acdc716e08572f94)(children, prevState.prevChildren)) {
            // update configuration in chilren
            var hasGlobalData = !(0, (/*@__PURE__*/$parcel$interopDefault($f4c1eb24faf142bb$exports)))(data);
            var newUpdateId = hasGlobalData ? prevState.updateId : prevState.updateId + 1;
            return $c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                updateId: newUpdateId
            }, updateStateOfAxisMapsOffsetAndStackGroups($c61dda0fca74c9ef$var$_objectSpread($c61dda0fca74c9ef$var$_objectSpread({
                props: nextProps
            }, prevState), {}, {
                updateId: newUpdateId
            }), prevState)), {}, {
                prevChildren: children
            });
        }
        return null;
    }, _class.renderActiveDot = function(option, props) {
        var dot;
        if (/*#__PURE__*/ (0, $eCoWV.isValidElement)(option)) dot = /*#__PURE__*/ (0, $eCoWV.cloneElement)(option, props);
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) dot = option(props);
        else dot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $18507106bbcc53ce$export$d046b3c4a416f60d), props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $e8b40bd38b345c87$export$936d0764594b6eb3), {
            className: "recharts-active-dot",
            key: props.key
        }, dot);
    }, _temp;
};



/**
 * @fileOverview X Axis
 */ /** Define of XAxis props */ var $62178bb4259884f4$export$ea77231de273b52d = function XAxis() {
    return null;
};
$62178bb4259884f4$export$ea77231de273b52d.displayName = "XAxis";
$62178bb4259884f4$export$ea77231de273b52d.defaultProps = {
    allowDecimals: true,
    hide: false,
    orientation: "bottom",
    width: 0,
    height: 30,
    mirror: false,
    xAxisId: 0,
    tickCount: 5,
    type: "category",
    domain: [
        0,
        "auto"
    ],
    padding: {
        left: 0,
        right: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false,
    allowDuplicatedCategory: true
};


/**
 * @fileOverview Y Axis
 */ var $4e1c235152c6651c$export$f96c4024c52de8f4 = function YAxis() {
    return null;
};
$4e1c235152c6651c$export$f96c4024c52de8f4.displayName = "YAxis";
$4e1c235152c6651c$export$f96c4024c52de8f4.defaultProps = {
    allowDuplicatedCategory: true,
    allowDecimals: true,
    hide: false,
    orientation: "left",
    width: 60,
    height: 0,
    mirror: false,
    yAxisId: 0,
    tickCount: 5,
    type: "number",
    domain: [
        0,
        "auto"
    ],
    padding: {
        top: 0,
        bottom: 0
    },
    allowDataOverflow: false,
    scale: "auto",
    reversed: false
};



var $75fc06af604f7c6d$export$f510429275d6f1a8 = (0, $c61dda0fca74c9ef$export$77871aede60e6838)({
    chartName: "AreaChart",
    GraphicalChild: (0, $126bbb1a4f17672d$export$ea1a111407f37557),
    axisComponents: [
        {
            axisType: "xAxis",
            AxisComp: (0, $62178bb4259884f4$export$ea77231de273b52d)
        },
        {
            axisType: "yAxis",
            AxisComp: (0, $4e1c235152c6651c$export$f96c4024c52de8f4)
        }
    ],
    formatAxisMap: (0, $178894d76e936054$export$ece7de1383db5ac)
});



var $eCoWV = parcelRequire("eCoWV");


function $cb8b19d7bc42e54c$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $cb8b19d7bc42e54c$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $cb8b19d7bc42e54c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $cb8b19d7bc42e54c$var$_typeof(obj);
}
function $cb8b19d7bc42e54c$var$_extends() {
    $cb8b19d7bc42e54c$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $cb8b19d7bc42e54c$var$_extends.apply(this, arguments);
}
function $cb8b19d7bc42e54c$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $cb8b19d7bc42e54c$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $cb8b19d7bc42e54c$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $cb8b19d7bc42e54c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $cb8b19d7bc42e54c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $cb8b19d7bc42e54c$var$ownKeys(Object(source), true).forEach(function(key) {
            $cb8b19d7bc42e54c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $cb8b19d7bc42e54c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $cb8b19d7bc42e54c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $cb8b19d7bc42e54c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $cb8b19d7bc42e54c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $cb8b19d7bc42e54c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $cb8b19d7bc42e54c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $cb8b19d7bc42e54c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $cb8b19d7bc42e54c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $cb8b19d7bc42e54c$var$_setPrototypeOf(subClass, superClass);
}
function $cb8b19d7bc42e54c$var$_setPrototypeOf(o, p) {
    $cb8b19d7bc42e54c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $cb8b19d7bc42e54c$var$_setPrototypeOf(o, p);
}
function $cb8b19d7bc42e54c$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $cb8b19d7bc42e54c$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $cb8b19d7bc42e54c$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $cb8b19d7bc42e54c$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $cb8b19d7bc42e54c$var$_possibleConstructorReturn(this, result);
    };
}
function $cb8b19d7bc42e54c$var$_possibleConstructorReturn(self, call) {
    if (call && ($cb8b19d7bc42e54c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $cb8b19d7bc42e54c$var$_assertThisInitialized(self);
}
function $cb8b19d7bc42e54c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $cb8b19d7bc42e54c$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $cb8b19d7bc42e54c$var$_getPrototypeOf(o) {
    $cb8b19d7bc42e54c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $cb8b19d7bc42e54c$var$_getPrototypeOf(o);
}
var $cb8b19d7bc42e54c$export$6440e27b9f186856 = /*#__PURE__*/ function(_PureComponent) {
    $cb8b19d7bc42e54c$var$_inherits(CartesianGrid, _PureComponent);
    var _super = $cb8b19d7bc42e54c$var$_createSuper(CartesianGrid);
    function CartesianGrid() {
        $cb8b19d7bc42e54c$var$_classCallCheck(this, CartesianGrid);
        return _super.apply(this, arguments);
    }
    $cb8b19d7bc42e54c$var$_createClass(CartesianGrid, [
        {
            key: "renderHorizontal",
            value: /**
     * Draw the horizontal grid lines
     * @param {Array} horizontalPoints either passed in as props or generated from function
     * @return {Group} Horizontal lines
     */ function renderHorizontal(horizontalPoints) {
                var _this = this;
                var _this$props = this.props, x = _this$props.x, width = _this$props.width, horizontal = _this$props.horizontal;
                if (!horizontalPoints || !horizontalPoints.length) return null;
                var items = horizontalPoints.map(function(entry, i) {
                    var props = $cb8b19d7bc42e54c$var$_objectSpread($cb8b19d7bc42e54c$var$_objectSpread({}, _this.props), {}, {
                        x1: x,
                        y1: entry,
                        x2: x + width,
                        y2: entry,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(horizontal, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-grid-horizontal"
                }, items);
            }
        },
        {
            key: "renderVertical",
            value: function renderVertical(verticalPoints) {
                var _this2 = this;
                var _this$props2 = this.props, y = _this$props2.y, height = _this$props2.height, vertical = _this$props2.vertical;
                if (!verticalPoints || !verticalPoints.length) return null;
                var items = verticalPoints.map(function(entry, i) {
                    var props = $cb8b19d7bc42e54c$var$_objectSpread($cb8b19d7bc42e54c$var$_objectSpread({}, _this2.props), {}, {
                        x1: entry,
                        y1: y,
                        x2: entry,
                        y2: y + height,
                        key: "line-".concat(i),
                        index: i
                    });
                    return CartesianGrid.renderLineItem(vertical, props);
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-grid-vertical"
                }, items);
            }
        },
        {
            key: "renderVerticalStripes",
            value: function renderVerticalStripes(verticalPoints) {
                var verticalFill = this.props.verticalFill;
                if (!verticalFill || !verticalFill.length) return null;
                var _this$props3 = this.props, fillOpacity = _this$props3.fillOpacity, x = _this$props3.x, y = _this$props3.y, width = _this$props3.width, height = _this$props3.height;
                var verticalPointsUpdated = verticalPoints.slice().sort(function(a, b) {
                    return a - b;
                });
                if (x !== verticalPointsUpdated[0]) verticalPointsUpdated.unshift(0);
                var items = verticalPointsUpdated.map(function(entry, i) {
                    var lineWidth = verticalPointsUpdated[i + 1] ? verticalPointsUpdated[i + 1] - entry : x + width - entry;
                    if (lineWidth <= 0) return null;
                    var colorIndex = i % verticalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        x: Math.round(entry + x - x),
                        y: y,
                        width: lineWidth,
                        height: height,
                        stroke: "none",
                        fill: verticalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-vertical"
                }, items);
            }
        },
        {
            key: "renderHorizontalStripes",
            value: function renderHorizontalStripes(horizontalPoints) {
                var horizontalFill = this.props.horizontalFill;
                if (!horizontalFill || !horizontalFill.length) return null;
                var _this$props4 = this.props, fillOpacity = _this$props4.fillOpacity, x = _this$props4.x, y = _this$props4.y, width = _this$props4.width, height = _this$props4.height;
                var horizontalPointsUpdated = horizontalPoints.slice().sort(function(a, b) {
                    return a - b;
                });
                if (y !== horizontalPointsUpdated[0]) horizontalPointsUpdated.unshift(0);
                var items = horizontalPointsUpdated.map(function(entry, i) {
                    var lineHeight = horizontalPointsUpdated[i + 1] ? horizontalPointsUpdated[i + 1] - entry : y + height - entry;
                    if (lineHeight <= 0) return null;
                    var colorIndex = i % horizontalFill.length;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                        key: "react-".concat(i) // eslint-disable-line react/no-array-index-key
                        ,
                        y: Math.round(entry + y - y),
                        x: x,
                        height: lineHeight,
                        width: width,
                        stroke: "none",
                        fill: horizontalFill[colorIndex],
                        fillOpacity: fillOpacity,
                        className: "recharts-cartesian-grid-bg"
                    });
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-gridstripes-horizontal"
                }, items);
            }
        },
        {
            key: "renderBackground",
            value: function renderBackground() {
                var fill = this.props.fill;
                if (!fill || fill === "none") return null;
                var _this$props5 = this.props, fillOpacity = _this$props5.fillOpacity, x = _this$props5.x, y = _this$props5.y, width = _this$props5.width, height = _this$props5.height;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("rect", {
                    x: x,
                    y: y,
                    width: width,
                    height: height,
                    stroke: "none",
                    fill: fill,
                    fillOpacity: fillOpacity,
                    className: "recharts-cartesian-grid-bg"
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$props6 = this.props, x = _this$props6.x, y = _this$props6.y, width = _this$props6.width, height = _this$props6.height, horizontal = _this$props6.horizontal, vertical = _this$props6.vertical, horizontalCoordinatesGenerator = _this$props6.horizontalCoordinatesGenerator, verticalCoordinatesGenerator = _this$props6.verticalCoordinatesGenerator, xAxis = _this$props6.xAxis, yAxis = _this$props6.yAxis, offset = _this$props6.offset, chartWidth = _this$props6.chartWidth, chartHeight = _this$props6.chartHeight;
                if (!(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(width) || width <= 0 || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(height) || height <= 0 || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(x) || x !== +x || !(0, $a4d9ec64928c627b$export$7e4aa119212bc614)(y) || y !== +y) return null;
                var _this$props7 = this.props, horizontalPoints = _this$props7.horizontalPoints, verticalPoints = _this$props7.verticalPoints; // No horizontal points are specified
                if ((!horizontalPoints || !horizontalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(horizontalCoordinatesGenerator)) horizontalPoints = horizontalCoordinatesGenerator({
                    yAxis: yAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                 // No vertical points are specified
                if ((!verticalPoints || !verticalPoints.length) && (0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(verticalCoordinatesGenerator)) verticalPoints = verticalCoordinatesGenerator({
                    xAxis: xAxis,
                    width: chartWidth,
                    height: chartHeight,
                    offset: offset
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("g", {
                    className: "recharts-cartesian-grid"
                }, this.renderBackground(), horizontal && this.renderHorizontal(horizontalPoints), vertical && this.renderVertical(verticalPoints), horizontal && this.renderHorizontalStripes(horizontalPoints), vertical && this.renderVerticalStripes(verticalPoints));
            }
        }
    ], [
        {
            key: "renderLineItem",
            value: function renderLineItem(option, props) {
                var lineItem;
                if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).isValidElement(option)) lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).cloneElement(option, props);
                else if ((0, (/*@__PURE__*/$parcel$interopDefault($aceb43529efb4f1a$exports)))(option)) lineItem = option(props);
                else {
                    var x1 = props.x1, y1 = props.y1, x2 = props.x2, y2 = props.y2, key = props.key, others = $cb8b19d7bc42e54c$var$_objectWithoutProperties(props, [
                        "x1",
                        "y1",
                        "x2",
                        "y2",
                        "key"
                    ]);
                    lineItem = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("line", $cb8b19d7bc42e54c$var$_extends({}, (0, $dd873d09408694ab$export$d697c39a2985a4c)(others), {
                        x1: x1,
                        y1: y1,
                        x2: x2,
                        y2: y2,
                        fill: "none",
                        key: key
                    }));
                }
                return lineItem;
            }
        }
    ]);
    return CartesianGrid;
}((0, $eCoWV.PureComponent));
$cb8b19d7bc42e54c$export$6440e27b9f186856.displayName = "CartesianGrid";
$cb8b19d7bc42e54c$export$6440e27b9f186856.defaultProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: "#ccc",
    fill: "none",
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: []
};



var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");

var $iVz18 = parcelRequire("iVz18");
/* global Reflect, Promise */ var $58874850092d80ae$var$extendStatics = function(d, b) {
    $58874850092d80ae$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $58874850092d80ae$var$extendStatics(d, b);
};
function $58874850092d80ae$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $58874850092d80ae$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $58874850092d80ae$var$__assign = function() {
    $58874850092d80ae$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $58874850092d80ae$var$__assign.apply(this, arguments);
};
function $58874850092d80ae$var$__rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
var $58874850092d80ae$var$commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : {}; /**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
function $58874850092d80ae$var$isObject$3(value) {
    var type = typeof value;
    return value != null && (type == "object" || type == "function");
}
var $58874850092d80ae$var$isObject_1 = $58874850092d80ae$var$isObject$3; /** Detect free variable `global` from Node.js. */ 
var $58874850092d80ae$var$freeGlobal$1 = typeof $58874850092d80ae$var$commonjsGlobal == "object" && $58874850092d80ae$var$commonjsGlobal && $58874850092d80ae$var$commonjsGlobal.Object === Object && $58874850092d80ae$var$commonjsGlobal;
var $58874850092d80ae$var$_freeGlobal = $58874850092d80ae$var$freeGlobal$1;
var $58874850092d80ae$var$freeGlobal = $58874850092d80ae$var$_freeGlobal;
/** Detect free variable `self`. */ var $58874850092d80ae$var$freeSelf = typeof self == "object" && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $58874850092d80ae$var$root$2 = $58874850092d80ae$var$freeGlobal || $58874850092d80ae$var$freeSelf || Function("return this")();
var $58874850092d80ae$var$_root = $58874850092d80ae$var$root$2;
var $58874850092d80ae$var$root$1 = $58874850092d80ae$var$_root;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $58874850092d80ae$var$now$1 = function() {
    return $58874850092d80ae$var$root$1.Date.now();
};
var $58874850092d80ae$var$now_1 = $58874850092d80ae$var$now$1; /** Used to match a single whitespace character. */ 
var $58874850092d80ae$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $58874850092d80ae$var$trimmedEndIndex$1(string) {
    var index = string.length;
    while(index-- && $58874850092d80ae$var$reWhitespace.test(string.charAt(index)));
    return index;
}
var $58874850092d80ae$var$_trimmedEndIndex = $58874850092d80ae$var$trimmedEndIndex$1;
var $58874850092d80ae$var$trimmedEndIndex = $58874850092d80ae$var$_trimmedEndIndex;
/** Used to match leading whitespace. */ var $58874850092d80ae$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $58874850092d80ae$var$baseTrim$1(string) {
    return string ? string.slice(0, $58874850092d80ae$var$trimmedEndIndex(string) + 1).replace($58874850092d80ae$var$reTrimStart, "") : string;
}
var $58874850092d80ae$var$_baseTrim = $58874850092d80ae$var$baseTrim$1;
var $58874850092d80ae$var$root = $58874850092d80ae$var$_root;
/** Built-in value references. */ var $58874850092d80ae$var$Symbol$2 = $58874850092d80ae$var$root.Symbol;
var $58874850092d80ae$var$_Symbol = $58874850092d80ae$var$Symbol$2;
var $58874850092d80ae$var$Symbol$1 = $58874850092d80ae$var$_Symbol;
/** Used for built-in method references. */ var $58874850092d80ae$var$objectProto$1 = Object.prototype;
/** Used to check objects for own properties. */ var $58874850092d80ae$var$hasOwnProperty = $58874850092d80ae$var$objectProto$1.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $58874850092d80ae$var$nativeObjectToString$1 = $58874850092d80ae$var$objectProto$1.toString;
/** Built-in value references. */ var $58874850092d80ae$var$symToStringTag$1 = $58874850092d80ae$var$Symbol$1 ? $58874850092d80ae$var$Symbol$1.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $58874850092d80ae$var$getRawTag$1(value) {
    var isOwn = $58874850092d80ae$var$hasOwnProperty.call(value, $58874850092d80ae$var$symToStringTag$1), tag = value[$58874850092d80ae$var$symToStringTag$1];
    try {
        value[$58874850092d80ae$var$symToStringTag$1] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $58874850092d80ae$var$nativeObjectToString$1.call(value);
    if (unmasked) {
        if (isOwn) value[$58874850092d80ae$var$symToStringTag$1] = tag;
        else delete value[$58874850092d80ae$var$symToStringTag$1];
    }
    return result;
}
var $58874850092d80ae$var$_getRawTag = $58874850092d80ae$var$getRawTag$1; /** Used for built-in method references. */ 
var $58874850092d80ae$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $58874850092d80ae$var$nativeObjectToString = $58874850092d80ae$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $58874850092d80ae$var$objectToString$1(value) {
    return $58874850092d80ae$var$nativeObjectToString.call(value);
}
var $58874850092d80ae$var$_objectToString = $58874850092d80ae$var$objectToString$1;
var $58874850092d80ae$var$Symbol = $58874850092d80ae$var$_Symbol, $58874850092d80ae$var$getRawTag = $58874850092d80ae$var$_getRawTag, $58874850092d80ae$var$objectToString = $58874850092d80ae$var$_objectToString;
/** `Object#toString` result references. */ var $58874850092d80ae$var$nullTag = "[object Null]", $58874850092d80ae$var$undefinedTag = "[object Undefined]";
/** Built-in value references. */ var $58874850092d80ae$var$symToStringTag = $58874850092d80ae$var$Symbol ? $58874850092d80ae$var$Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $58874850092d80ae$var$baseGetTag$1(value) {
    if (value == null) return value === undefined ? $58874850092d80ae$var$undefinedTag : $58874850092d80ae$var$nullTag;
    return $58874850092d80ae$var$symToStringTag && $58874850092d80ae$var$symToStringTag in Object(value) ? $58874850092d80ae$var$getRawTag(value) : $58874850092d80ae$var$objectToString(value);
}
var $58874850092d80ae$var$_baseGetTag = $58874850092d80ae$var$baseGetTag$1; /**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
function $58874850092d80ae$var$isObjectLike$1(value) {
    return value != null && typeof value == "object";
}
var $58874850092d80ae$var$isObjectLike_1 = $58874850092d80ae$var$isObjectLike$1;
var $58874850092d80ae$var$baseGetTag = $58874850092d80ae$var$_baseGetTag, $58874850092d80ae$var$isObjectLike = $58874850092d80ae$var$isObjectLike_1;
/** `Object#toString` result references. */ var $58874850092d80ae$var$symbolTag = "[object Symbol]";
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $58874850092d80ae$var$isSymbol$1(value) {
    return typeof value == "symbol" || $58874850092d80ae$var$isObjectLike(value) && $58874850092d80ae$var$baseGetTag(value) == $58874850092d80ae$var$symbolTag;
}
var $58874850092d80ae$var$isSymbol_1 = $58874850092d80ae$var$isSymbol$1;
var $58874850092d80ae$var$baseTrim = $58874850092d80ae$var$_baseTrim, $58874850092d80ae$var$isObject$2 = $58874850092d80ae$var$isObject_1, $58874850092d80ae$var$isSymbol = $58874850092d80ae$var$isSymbol_1;
/** Used as references for various `Number` constants. */ var $58874850092d80ae$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $58874850092d80ae$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $58874850092d80ae$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $58874850092d80ae$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $58874850092d80ae$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $58874850092d80ae$var$toNumber$1(value) {
    if (typeof value == "number") return value;
    if ($58874850092d80ae$var$isSymbol(value)) return $58874850092d80ae$var$NAN;
    if ($58874850092d80ae$var$isObject$2(value)) {
        var other = typeof value.valueOf == "function" ? value.valueOf() : value;
        value = $58874850092d80ae$var$isObject$2(other) ? other + "" : other;
    }
    if (typeof value != "string") return value === 0 ? value : +value;
    value = $58874850092d80ae$var$baseTrim(value);
    var isBinary = $58874850092d80ae$var$reIsBinary.test(value);
    return isBinary || $58874850092d80ae$var$reIsOctal.test(value) ? $58874850092d80ae$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $58874850092d80ae$var$reIsBadHex.test(value) ? $58874850092d80ae$var$NAN : +value;
}
var $58874850092d80ae$var$toNumber_1 = $58874850092d80ae$var$toNumber$1;
var $58874850092d80ae$var$isObject$1 = $58874850092d80ae$var$isObject_1, $58874850092d80ae$var$now = $58874850092d80ae$var$now_1, $58874850092d80ae$var$toNumber = $58874850092d80ae$var$toNumber_1;
/** Error message constants. */ var $58874850092d80ae$var$FUNC_ERROR_TEXT$1 = "Expected a function";
/* Built-in method references for those with the same name as other `lodash` methods. */ var $58874850092d80ae$var$nativeMax = Math.max, $58874850092d80ae$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $58874850092d80ae$var$debounce$1(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != "function") throw new TypeError($58874850092d80ae$var$FUNC_ERROR_TEXT$1);
    wait = $58874850092d80ae$var$toNumber(wait) || 0;
    if ($58874850092d80ae$var$isObject$1(options)) {
        leading = !!options.leading;
        maxing = "maxWait" in options;
        maxWait = maxing ? $58874850092d80ae$var$nativeMax($58874850092d80ae$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $58874850092d80ae$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $58874850092d80ae$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($58874850092d80ae$var$now());
    }
    function debounced() {
        var time = $58874850092d80ae$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
var $58874850092d80ae$var$debounce_1 = $58874850092d80ae$var$debounce$1;
var $58874850092d80ae$var$debounce = $58874850092d80ae$var$debounce_1, $58874850092d80ae$var$isObject = $58874850092d80ae$var$isObject_1;
/** Error message constants. */ var $58874850092d80ae$var$FUNC_ERROR_TEXT = "Expected a function";
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $58874850092d80ae$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != "function") throw new TypeError($58874850092d80ae$var$FUNC_ERROR_TEXT);
    if ($58874850092d80ae$var$isObject(options)) {
        leading = "leading" in options ? !!options.leading : leading;
        trailing = "trailing" in options ? !!options.trailing : trailing;
    }
    return $58874850092d80ae$var$debounce(func, wait, {
        "leading": leading,
        "maxWait": wait,
        "trailing": trailing
    });
}
var $58874850092d80ae$var$throttle_1 = $58874850092d80ae$var$throttle;
var $58874850092d80ae$var$patchResizeHandler = function(resizeCallback, refreshMode, refreshRate, refreshOptions) {
    switch(refreshMode){
        case "debounce":
            return $58874850092d80ae$var$debounce_1(resizeCallback, refreshRate, refreshOptions);
        case "throttle":
            return $58874850092d80ae$var$throttle_1(resizeCallback, refreshRate, refreshOptions);
        default:
            return resizeCallback;
    }
};
var $58874850092d80ae$var$isFunction = function(fn) {
    return typeof fn === "function";
};
var $58874850092d80ae$var$isSSR = function() {
    return typeof window === "undefined";
};
var $58874850092d80ae$var$isDOMElement = function(element) {
    return element instanceof Element || element instanceof HTMLDocument;
};
var $58874850092d80ae$var$createNotifier = function(onResize, setSize, handleWidth, handleHeight) {
    return function(_a) {
        var width = _a.width, height = _a.height;
        setSize(function(prev) {
            if (prev.width === width && prev.height === height) // skip if dimensions haven't changed
            return prev;
            if (prev.width === width && !handleHeight || prev.height === height && !handleWidth) // process `handleHeight/handleWidth` props
            return prev;
            if (onResize && $58874850092d80ae$var$isFunction(onResize)) onResize(width, height);
            return {
                width: width,
                height: height
            };
        });
    };
};
var $58874850092d80ae$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $58874850092d80ae$var$__extends(ResizeDetector, _super);
    function ResizeDetector(props) {
        var _this = _super.call(this, props) || this;
        _this.cancelHandler = function() {
            if (_this.resizeHandler && _this.resizeHandler.cancel) {
                // cancel debounced handler
                _this.resizeHandler.cancel();
                _this.resizeHandler = null;
            }
        };
        _this.attachObserver = function() {
            var _a = _this.props, targetRef = _a.targetRef, observerOptions = _a.observerOptions;
            if ($58874850092d80ae$var$isSSR()) return;
            if (targetRef && targetRef.current) _this.targetRef.current = targetRef.current;
            var element = _this.getElement();
            if (!element) // can't find element to observe
            return;
            if (_this.observableElement && _this.observableElement === element) // element is already observed
            return;
            _this.observableElement = element;
            _this.resizeObserver.observe(element, observerOptions);
        };
        _this.getElement = function() {
            var _a = _this.props, querySelector = _a.querySelector, targetDomEl = _a.targetDomEl;
            if ($58874850092d80ae$var$isSSR()) return null;
            // in case we pass a querySelector
            if (querySelector) return document.querySelector(querySelector);
            // in case we pass a DOM element
            if (targetDomEl && $58874850092d80ae$var$isDOMElement(targetDomEl)) return targetDomEl;
            // in case we pass a React ref using React.createRef()
            if (_this.targetRef && $58874850092d80ae$var$isDOMElement(_this.targetRef.current)) return _this.targetRef.current;
            // the worse case when we don't receive any information from the parent and the library doesn't add any wrappers
            // we have to use a deprecated `findDOMNode` method in order to find a DOM element to attach to
            var currentElement = (0, $iVz18.findDOMNode)(_this);
            if (!currentElement) return null;
            var renderType = _this.getRenderType();
            switch(renderType){
                case "renderProp":
                    return currentElement;
                case "childFunction":
                    return currentElement;
                case "child":
                    return currentElement;
                case "childArray":
                    return currentElement;
                default:
                    return currentElement.parentElement;
            }
        };
        _this.createResizeHandler = function(entries) {
            var _a = _this.props, _b = _a.handleWidth, handleWidth = _b === void 0 ? true : _b, _c = _a.handleHeight, handleHeight = _c === void 0 ? true : _c, onResize = _a.onResize;
            if (!handleWidth && !handleHeight) return;
            var notifyResize = $58874850092d80ae$var$createNotifier(onResize, _this.setState.bind(_this), handleWidth, handleHeight);
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !_this.skipOnMount && !$58874850092d80ae$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                _this.skipOnMount = false;
            });
        };
        _this.getRenderType = function() {
            var _a = _this.props, render = _a.render, children = _a.children;
            if ($58874850092d80ae$var$isFunction(render)) // DEPRECATED. Use `Child Function Pattern` instead
            return "renderProp";
            if ($58874850092d80ae$var$isFunction(children)) return "childFunction";
            if ((0, $eCoWV.isValidElement)(children)) return "child";
            if (Array.isArray(children)) // DEPRECATED. Wrap children with a single parent
            return "childArray";
            // DEPRECATED. Use `Child Function Pattern` instead
            return "parent";
        };
        var skipOnMount = props.skipOnMount, refreshMode = props.refreshMode, _a = props.refreshRate, refreshRate = _a === void 0 ? 1000 : _a, refreshOptions = props.refreshOptions;
        _this.state = {
            width: undefined,
            height: undefined
        };
        _this.skipOnMount = skipOnMount;
        _this.targetRef = (0, $eCoWV.createRef)();
        _this.observableElement = null;
        if ($58874850092d80ae$var$isSSR()) return _this;
        _this.resizeHandler = $58874850092d80ae$var$patchResizeHandler(_this.createResizeHandler, refreshMode, refreshRate, refreshOptions);
        _this.resizeObserver = new window.ResizeObserver(_this.resizeHandler);
        return _this;
    }
    ResizeDetector.prototype.componentDidMount = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentDidUpdate = function() {
        this.attachObserver();
    };
    ResizeDetector.prototype.componentWillUnmount = function() {
        if ($58874850092d80ae$var$isSSR()) return;
        this.observableElement = null;
        this.resizeObserver.disconnect();
        this.cancelHandler();
    };
    ResizeDetector.prototype.render = function() {
        var _a = this.props, render = _a.render, children = _a.children, _b = _a.nodeType, WrapperTag = _b === void 0 ? "div" : _b;
        var _c = this.state, width = _c.width, height = _c.height;
        var childProps = {
            width: width,
            height: height,
            targetRef: this.targetRef
        };
        var renderType = this.getRenderType();
        var typedChildren;
        switch(renderType){
            case "renderProp":
                return render && render(childProps);
            case "childFunction":
                typedChildren = children;
                return typedChildren(childProps);
            case "child":
                // @TODO bug prone logic
                typedChildren = children;
                if (typedChildren.type && typeof typedChildren.type === "string") {
                    // child is a native DOM elements such as div, span etc
                    childProps.targetRef;
                    var nativeProps = $58874850092d80ae$var$__rest(childProps, [
                        "targetRef"
                    ]);
                    return (0, $eCoWV.cloneElement)(typedChildren, nativeProps);
                }
                // class or functional component otherwise
                return (0, $eCoWV.cloneElement)(typedChildren, childProps);
            case "childArray":
                typedChildren = children;
                return typedChildren.map(function(el) {
                    return !!el && (0, $eCoWV.cloneElement)(el, childProps);
                });
            default:
                return $eCoWV.createElement(WrapperTag, null);
        }
    };
    return ResizeDetector;
}((0, $eCoWV.PureComponent));
function $58874850092d80ae$export$fa0519968090da40(ComponentInner, options) {
    if (options === void 0) options = {};
    var ResizeDetectorHOC = /** @class */ function(_super) {
        $58874850092d80ae$var$__extends(ResizeDetectorHOC, _super);
        function ResizeDetectorHOC() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.ref = (0, $eCoWV.createRef)();
            return _this;
        }
        ResizeDetectorHOC.prototype.render = function() {
            var _a = this.props, forwardedRef = _a.forwardedRef, rest = $58874850092d80ae$var$__rest(_a, [
                "forwardedRef"
            ]);
            var targetRef = forwardedRef !== null && forwardedRef !== void 0 ? forwardedRef : this.ref;
            return $eCoWV.createElement($58874850092d80ae$export$2e2bcd8739ae039, $58874850092d80ae$var$__assign({}, options, {
                targetRef: targetRef
            }), $eCoWV.createElement(ComponentInner, $58874850092d80ae$var$__assign({
                targetRef: targetRef
            }, rest)));
        };
        return ResizeDetectorHOC;
    }((0, $eCoWV.Component));
    function forwardRefWrapper(props, ref) {
        return $eCoWV.createElement(ResizeDetectorHOC, $58874850092d80ae$var$__assign({}, props, {
            forwardedRef: ref
        }));
    }
    var name = ComponentInner.displayName || ComponentInner.name;
    forwardRefWrapper.displayName = "withResizeDetector(".concat(name, ")");
    return (0, $eCoWV.forwardRef)(forwardRefWrapper);
}
var $58874850092d80ae$var$useEnhancedEffect = $58874850092d80ae$var$isSSR() ? (0, $eCoWV.useEffect) : (0, $eCoWV.useLayoutEffect);
function $58874850092d80ae$export$453c3d1cba18d800(props) {
    if (props === void 0) props = {};
    var _a = props.skipOnMount, skipOnMount = _a === void 0 ? false : _a, refreshMode = props.refreshMode, _b = props.refreshRate, refreshRate = _b === void 0 ? 1000 : _b, refreshOptions = props.refreshOptions, _c = props.handleWidth, handleWidth = _c === void 0 ? true : _c, _d = props.handleHeight, handleHeight = _d === void 0 ? true : _d, targetRef = props.targetRef, observerOptions = props.observerOptions, onResize = props.onResize;
    var skipResize = (0, $eCoWV.useRef)(skipOnMount);
    var localRef = (0, $eCoWV.useRef)(null);
    var ref = targetRef !== null && targetRef !== void 0 ? targetRef : localRef;
    var resizeHandler = (0, $eCoWV.useRef)();
    var _e = (0, $eCoWV.useState)({
        width: undefined,
        height: undefined
    }), size = _e[0], setSize = _e[1];
    $58874850092d80ae$var$useEnhancedEffect(function() {
        if ($58874850092d80ae$var$isSSR()) return;
        var notifyResize = $58874850092d80ae$var$createNotifier(onResize, setSize, handleWidth, handleHeight);
        var resizeCallback = function(entries) {
            if (!handleWidth && !handleHeight) return;
            entries.forEach(function(entry) {
                var _a = entry && entry.contentRect || {}, width = _a.width, height = _a.height;
                var shouldSetSize = !skipResize.current && !$58874850092d80ae$var$isSSR();
                if (shouldSetSize) notifyResize({
                    width: width,
                    height: height
                });
                skipResize.current = false;
            });
        };
        resizeHandler.current = $58874850092d80ae$var$patchResizeHandler(resizeCallback, refreshMode, refreshRate, refreshOptions);
        var resizeObserver = new window.ResizeObserver(resizeHandler.current);
        if (ref.current) // Something wrong with typings here...
        resizeObserver.observe(ref.current, observerOptions);
        return function() {
            resizeObserver.disconnect();
            var patchedResizeHandler = resizeHandler.current;
            if (patchedResizeHandler && patchedResizeHandler.cancel) patchedResizeHandler.cancel();
        };
    }, [
        refreshMode,
        refreshRate,
        refreshOptions,
        handleWidth,
        handleHeight,
        onResize,
        observerOptions,
        ref.current
    ]);
    return $58874850092d80ae$var$__assign({
        ref: ref
    }, size);
}




function $ddb5b9d6532a36e0$var$_extends() {
    $ddb5b9d6532a36e0$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $ddb5b9d6532a36e0$var$_extends.apply(this, arguments);
}
function $ddb5b9d6532a36e0$var$_slicedToArray(arr, i) {
    return $ddb5b9d6532a36e0$var$_arrayWithHoles(arr) || $ddb5b9d6532a36e0$var$_iterableToArrayLimit(arr, i) || $ddb5b9d6532a36e0$var$_unsupportedIterableToArray(arr, i) || $ddb5b9d6532a36e0$var$_nonIterableRest();
}
function $ddb5b9d6532a36e0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ddb5b9d6532a36e0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ddb5b9d6532a36e0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ddb5b9d6532a36e0$var$_arrayLikeToArray(o, minLen);
}
function $ddb5b9d6532a36e0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ddb5b9d6532a36e0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ddb5b9d6532a36e0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ddb5b9d6532a36e0$export$e60a4704009a0009 = /*#__PURE__*/ (0, $eCoWV.forwardRef)(function(_ref, ref) {
    var aspect = _ref.aspect, _ref$width = _ref.width, width = _ref$width === void 0 ? "100%" : _ref$width, _ref$height = _ref.height, height = _ref$height === void 0 ? "100%" : _ref$height, minWidth = _ref.minWidth, minHeight = _ref.minHeight, maxHeight = _ref.maxHeight, children = _ref.children, _ref$debounce = _ref.debounce, debounce = _ref$debounce === void 0 ? 0 : _ref$debounce, id = _ref.id, className = _ref.className;
    var _useState = (0, $eCoWV.useState)({
        containerWidth: -1,
        containerHeight: -1
    }), _useState2 = $ddb5b9d6532a36e0$var$_slicedToArray(_useState, 2), sizes = _useState2[0], setSizes = _useState2[1];
    var containerRef = (0, $eCoWV.useRef)(null);
    (0, $eCoWV.useImperativeHandle)(ref, function() {
        return containerRef;
    }, [
        containerRef
    ]);
    var _useState3 = (0, $eCoWV.useState)(false), _useState4 = $ddb5b9d6532a36e0$var$_slicedToArray(_useState3, 2), mounted = _useState4[0], setMounted = _useState4[1];
    var getContainerSize = function getContainerSize() {
        if (!containerRef.current) return null;
        return {
            containerWidth: containerRef.current.clientWidth,
            containerHeight: containerRef.current.clientHeight
        };
    };
    var updateDimensionsImmediate = function updateDimensionsImmediate() {
        if (!mounted) return;
        var newSize = getContainerSize();
        if (newSize) {
            var oldWidth = sizes.containerWidth, oldHeight = sizes.containerHeight;
            var containerWidth = newSize.containerWidth, containerHeight = newSize.containerHeight;
            if (containerWidth !== oldWidth || containerHeight !== oldHeight) setSizes({
                containerWidth: containerWidth,
                containerHeight: containerHeight
            });
        }
    };
    var handleResize = debounce > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($1b21a616e5a5263c$exports)))(updateDimensionsImmediate, debounce) : updateDimensionsImmediate;
    var renderChart = function renderChart() {
        var containerWidth = sizes.containerWidth, containerHeight = sizes.containerHeight;
        if (containerWidth < 0 || containerHeight < 0) return null;
        (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)((0, $a4d9ec64928c627b$export$e50269385c77c348)(width) || (0, $a4d9ec64928c627b$export$e50269385c77c348)(height), "The width(%s) and height(%s) are both fixed numbers,\n       maybe you don't need to use a ResponsiveContainer.", width, height);
        (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)(!aspect || aspect > 0, "The aspect(%s) must be greater than zero.", aspect);
        var calculatedWidth = (0, $a4d9ec64928c627b$export$e50269385c77c348)(width) ? containerWidth : width;
        var calculatedHeight = (0, $a4d9ec64928c627b$export$e50269385c77c348)(height) ? containerHeight : height;
        if (aspect && aspect > 0) {
            // Preserve the desired aspect ratio
            if (calculatedWidth) // Will default to using width for aspect ratio
            calculatedHeight = calculatedWidth / aspect;
            else if (calculatedHeight) // But we should also take height into consideration
            calculatedWidth = calculatedHeight * aspect;
             // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
            if (maxHeight && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
        }
        (0, $ad6f526231c1928a$export$c106dd0671a0fc2d)(calculatedWidth > 0 || calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
        return /*#__PURE__*/ (0, $eCoWV.cloneElement)(children, {
            width: calculatedWidth,
            height: calculatedHeight
        });
    };
    (0, $eCoWV.useEffect)(function() {
        if (mounted) {
            var size = getContainerSize();
            if (size) setSizes(size);
        }
    }, [
        mounted
    ]);
    (0, $eCoWV.useEffect)(function() {
        setMounted(true);
    }, []);
    var style = {
        width: width,
        height: height,
        minWidth: minWidth,
        minHeight: minHeight,
        maxHeight: maxHeight
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement((0, $58874850092d80ae$export$2e2bcd8739ae039), {
        handleWidth: true,
        handleHeight: true,
        onResize: handleResize,
        targetRef: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eCoWV))).createElement("div", $ddb5b9d6532a36e0$var$_extends({}, id != null ? {
        id: "".concat(id)
    } : {}, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))("recharts-responsive-container", className),
        style: style,
        ref: containerRef
    }), renderChart()));
});



var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");





var $93h5F = parcelRequire("93h5F");

var $6PcpQ = parcelRequire("6PcpQ");
var $bad6e2ac54223cd7$export$34e0f9847d4c02dd;
var $bad6e2ac54223cd7$export$41ee12f6f6f05843;
var $bad6e2ac54223cd7$export$f194ed9df726ec47;
var $bad6e2ac54223cd7$export$bfd64c937657f93a;
var $bad6e2ac54223cd7$export$4a6dd88bada4e7d2;
var $bad6e2ac54223cd7$export$9a2dbef7a17e2e58;
$bad6e2ac54223cd7$export$34e0f9847d4c02dd = `Mn-v3W_container`;
$bad6e2ac54223cd7$export$41ee12f6f6f05843 = `Mn-v3W_details`;
$bad6e2ac54223cd7$export$f194ed9df726ec47 = `Mn-v3W_expander`;
$bad6e2ac54223cd7$export$bfd64c937657f93a = `Mn-v3W_rotating`;
$bad6e2ac54223cd7$export$4a6dd88bada4e7d2 = `Mn-v3W_shimmer`;
$bad6e2ac54223cd7$export$9a2dbef7a17e2e58 = `Mn-v3W_summary`;


function $a274721f157217dc$var$AppError({ title: title, errorCode: errorCode, errorMessage: errorMessage, callStack: callStack, children: children }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isDetailsOpen, setIsDetailsOpen] = (0, $eCoWV.useState)(false);
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $bad6e2ac54223cd7$export$34e0f9847d4c02dd,
        children: [
            theme === (0, $bhvxB.Theme).Light ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f30a2cc5dc4ce819$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1472ddfe7d5258a7$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)("label", {
                children: title ?? t("errors.something_went_wrong")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $bad6e2ac54223cd7$export$9a2dbef7a17e2e58,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                    children: [
                        errorCode,
                        errorCode && errorMessage && ": ",
                        errorMessage,
                        callStack && /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                            role: "button",
                            tabIndex: 0,
                            className: $bad6e2ac54223cd7$export$f194ed9df726ec47,
                            onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                                setIsDetailsOpen(!isDetailsOpen);
                            }),
                            onClick: ()=>{
                                setIsDetailsOpen(!isDetailsOpen);
                            },
                            children: [
                                t("errors.more_details"),
                                isDetailsOpen ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fb79e1374131f586$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $46ab19a7423faf73$export$2e2bcd8739ae039), {})
                            ]
                        })
                    ]
                })
            }),
            callStack && isDetailsOpen && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $bad6e2ac54223cd7$export$41ee12f6f6f05843,
                children: callStack
            }),
            children
        ]
    });
}
var $a274721f157217dc$export$2e2bcd8739ae039 = $a274721f157217dc$var$AppError;



var $a0Ubj = parcelRequire("a0Ubj");

var $1UQTm = parcelRequire("1UQTm");

var $hdJkM = parcelRequire("hdJkM");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $231f26fc10dfa70c$var$SvgArrowDown = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m14.758 10.588-4.167 4.167a.835.835 0 0 1-.275.175.834.834 0 0 1-.633 0 .835.835 0 0 1-.275-.175L5.24 10.588a.837.837 0 1 1 1.184-1.183l2.741 2.75V5.83a.833.833 0 1 1 1.667 0v6.325l2.742-2.75a.833.833 0 0 1 1.183 0 .833.833 0 0 1 0 1.183Z",
            fill: "currentColor"
        })
    });
var $231f26fc10dfa70c$export$2e2bcd8739ae039 = $231f26fc10dfa70c$var$SvgArrowDown;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $84253ff140b1269f$var$SvgArrowUp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14.758 9.412 10.59 5.245a.834.834 0 0 0-.275-.175.833.833 0 0 0-.633 0 .833.833 0 0 0-.275.175L5.24 9.412a.837.837 0 1 0 1.184 1.183l2.741-2.75v6.325a.833.833 0 0 0 1.667 0V7.845l2.742 2.75a.833.833 0 0 0 1.183 0 .832.832 0 0 0 0-1.183Z",
            fill: "currentColor"
        })
    });
var $84253ff140b1269f$export$2e2bcd8739ae039 = $84253ff140b1269f$var$SvgArrowUp;



var $ds4Cq = parcelRequire("ds4Cq");

var $1UQTm = parcelRequire("1UQTm");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");
const $ceb7f19e5e5550c7$export$6a7c5d109b9a49cf = (value)=>value.toString().replaceAll(/\B(?=(\d{3})+(?!\d))/g, ",");


var $2984ccb6363335e2$exports = {};

$parcel$export($2984ccb6363335e2$exports, "block", function () { return $2984ccb6363335e2$export$837bd02682cd3db9; }, function (v) { return $2984ccb6363335e2$export$837bd02682cd3db9 = v; });
$parcel$export($2984ccb6363335e2$exports, "bordered", function () { return $2984ccb6363335e2$export$ecb9dc282039f854; }, function (v) { return $2984ccb6363335e2$export$ecb9dc282039f854 = v; });
$parcel$export($2984ccb6363335e2$exports, "content", function () { return $2984ccb6363335e2$export$a7db06668cad9adb; }, function (v) { return $2984ccb6363335e2$export$a7db06668cad9adb = v; });
$parcel$export($2984ccb6363335e2$exports, "delta", function () { return $2984ccb6363335e2$export$eabbe41f409ce55b; }, function (v) { return $2984ccb6363335e2$export$eabbe41f409ce55b = v; });
$parcel$export($2984ccb6363335e2$exports, "down", function () { return $2984ccb6363335e2$export$5df884bdba3ad6a1; }, function (v) { return $2984ccb6363335e2$export$5df884bdba3ad6a1 = v; });
$parcel$export($2984ccb6363335e2$exports, "number", function () { return $2984ccb6363335e2$export$98e628dec113755e; }, function (v) { return $2984ccb6363335e2$export$98e628dec113755e = v; });
$parcel$export($2984ccb6363335e2$exports, "plain", function () { return $2984ccb6363335e2$export$58d971314ad6cab; }, function (v) { return $2984ccb6363335e2$export$58d971314ad6cab = v; });
$parcel$export($2984ccb6363335e2$exports, "rotating", function () { return $2984ccb6363335e2$export$bfd64c937657f93a; }, function (v) { return $2984ccb6363335e2$export$bfd64c937657f93a = v; });
$parcel$export($2984ccb6363335e2$exports, "shimmer", function () { return $2984ccb6363335e2$export$4a6dd88bada4e7d2; }, function (v) { return $2984ccb6363335e2$export$4a6dd88bada4e7d2 = v; });
$parcel$export($2984ccb6363335e2$exports, "title", function () { return $2984ccb6363335e2$export$fb184b623420d9be; }, function (v) { return $2984ccb6363335e2$export$fb184b623420d9be = v; });
$parcel$export($2984ccb6363335e2$exports, "toggleTipButton", function () { return $2984ccb6363335e2$export$d7648c09dd2d912c; }, function (v) { return $2984ccb6363335e2$export$d7648c09dd2d912c = v; });
var $2984ccb6363335e2$export$837bd02682cd3db9;
var $2984ccb6363335e2$export$ecb9dc282039f854;
var $2984ccb6363335e2$export$a7db06668cad9adb;
var $2984ccb6363335e2$export$eabbe41f409ce55b;
var $2984ccb6363335e2$export$5df884bdba3ad6a1;
var $2984ccb6363335e2$export$98e628dec113755e;
var $2984ccb6363335e2$export$58d971314ad6cab;
var $2984ccb6363335e2$export$bfd64c937657f93a;
var $2984ccb6363335e2$export$4a6dd88bada4e7d2;
var $2984ccb6363335e2$export$fb184b623420d9be;
var $2984ccb6363335e2$export$d7648c09dd2d912c;
$2984ccb6363335e2$export$837bd02682cd3db9 = `bk57eW_block`;
$2984ccb6363335e2$export$ecb9dc282039f854 = `bk57eW_bordered`;
$2984ccb6363335e2$export$a7db06668cad9adb = `bk57eW_content`;
$2984ccb6363335e2$export$eabbe41f409ce55b = `bk57eW_delta`;
$2984ccb6363335e2$export$5df884bdba3ad6a1 = `bk57eW_down`;
$2984ccb6363335e2$export$98e628dec113755e = `bk57eW_number`;
$2984ccb6363335e2$export$58d971314ad6cab = `bk57eW_plain`;
$2984ccb6363335e2$export$bfd64c937657f93a = `bk57eW_rotating`;
$2984ccb6363335e2$export$4a6dd88bada4e7d2 = `bk57eW_shimmer`;
$2984ccb6363335e2$export$fb184b623420d9be = `bk57eW_title`;
$2984ccb6363335e2$export$d7648c09dd2d912c = `bk57eW_toggleTipButton`;


function $7a179be6c426238b$var$Block({ variant: variant = "default", count: count, delta: delta, title: title, tip: tip }) {
    const deltaLabel = delta !== undefined && `${(0, $5CQIb.conditionalString)(delta >= 0 && "+")}${delta}`;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2984ccb6363335e2$exports.block, $2984ccb6363335e2$exports[variant]),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $2984ccb6363335e2$exports.title,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: title
                    }),
                    tip && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                        anchorClassName: $2984ccb6363335e2$exports.toggleTipButton,
                        content: tip,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $2984ccb6363335e2$exports.content,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $2984ccb6363335e2$exports.number,
                        children: (0, $ceb7f19e5e5550c7$export$6a7c5d109b9a49cf)(count)
                    }),
                    delta !== undefined && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2984ccb6363335e2$exports.delta, delta < 0 && $2984ccb6363335e2$exports.down),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                                children: [
                                    "(",
                                    deltaLabel,
                                    ")"
                                ]
                            }),
                            delta > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84253ff140b1269f$export$2e2bcd8739ae039), {}),
                            delta < 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $231f26fc10dfa70c$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            })
        ]
    });
}
var $7a179be6c426238b$export$2e2bcd8739ae039 = $7a179be6c426238b$var$Block;



var $9zeGj = parcelRequire("9zeGj");

var $082a44437ecbc408$export$206ef41b79261bbb;
var $082a44437ecbc408$export$1237798dc640739a;
var $082a44437ecbc408$export$bfd64c937657f93a;
var $082a44437ecbc408$export$4a6dd88bada4e7d2;
var $082a44437ecbc408$export$2ab9a8f9f1186f14;
$082a44437ecbc408$export$206ef41b79261bbb = `hGh_LW_chartTooltip`;
$082a44437ecbc408$export$1237798dc640739a = `hGh_LW_label`;
$082a44437ecbc408$export$bfd64c937657f93a = `hGh_LW_rotating`;
$082a44437ecbc408$export$4a6dd88bada4e7d2 = `hGh_LW_shimmer`;
$082a44437ecbc408$export$2ab9a8f9f1186f14 = `hGh_LW_value`;


function $019b0ea602d15b32$var$ChartTooltip({ label: label, payload: payload }) {
    if (!label || !payload?.[0]) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $082a44437ecbc408$export$206ef41b79261bbb,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $082a44437ecbc408$export$2ab9a8f9f1186f14,
                children: (0, $ceb7f19e5e5550c7$export$6a7c5d109b9a49cf)(payload[0].payload.count)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $082a44437ecbc408$export$1237798dc640739a,
                children: label
            })
        ]
    });
}
var $019b0ea602d15b32$export$2e2bcd8739ae039 = $019b0ea602d15b32$var$ChartTooltip;



var $9zeGj = parcelRequire("9zeGj");

var $1UQTm = parcelRequire("1UQTm");
var $0bd560ed02ccf2c4$export$ff43767a4f1fa449;
var $0bd560ed02ccf2c4$export$837bd02682cd3db9;
var $0bd560ed02ccf2c4$export$12a40731da9c9684;
var $0bd560ed02ccf2c4$export$c05cc7140eecf824;
var $0bd560ed02ccf2c4$export$d224e3b3d2a2842c;
var $0bd560ed02ccf2c4$export$98e628dec113755e;
var $0bd560ed02ccf2c4$export$bfd64c937657f93a;
var $0bd560ed02ccf2c4$export$4a6dd88bada4e7d2;
var $0bd560ed02ccf2c4$export$fb184b623420d9be;
$0bd560ed02ccf2c4$export$ff43767a4f1fa449 = `grVxOq_activeBlocks`;
$0bd560ed02ccf2c4$export$837bd02682cd3db9 = `grVxOq_block`;
$0bd560ed02ccf2c4$export$12a40731da9c9684 = `grVxOq_blocks`;
$0bd560ed02ccf2c4$export$c05cc7140eecf824 = `grVxOq_curve`;
$0bd560ed02ccf2c4$export$d224e3b3d2a2842c = `grVxOq_dau`;
$0bd560ed02ccf2c4$export$98e628dec113755e = `grVxOq_number`;
$0bd560ed02ccf2c4$export$bfd64c937657f93a = `grVxOq_rotating`;
$0bd560ed02ccf2c4$export$4a6dd88bada4e7d2 = `grVxOq_shimmer`;
$0bd560ed02ccf2c4$export$4a6dd88bada4e7d2;
$0bd560ed02ccf2c4$export$fb184b623420d9be = `grVxOq_title`;


function $ecf28d660b66834f$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $0bd560ed02ccf2c4$export$12a40731da9c9684,
                children: [
                    ...Array.from({
                        length: 3
                    }).keys()
                ].map((index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: $0bd560ed02ccf2c4$export$837bd02682cd3db9,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0bd560ed02ccf2c4$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0bd560ed02ccf2c4$export$98e628dec113755e
                            })
                        ]
                    }, index))
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $0bd560ed02ccf2c4$export$d224e3b3d2a2842c,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0bd560ed02ccf2c4$export$fb184b623420d9be
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $0bd560ed02ccf2c4$export$98e628dec113755e
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $0bd560ed02ccf2c4$export$c05cc7140eecf824
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $0bd560ed02ccf2c4$export$ff43767a4f1fa449,
                        children: [
                            ...Array.from({
                                length: 2
                            }).keys()
                        ].map((index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                                className: $0bd560ed02ccf2c4$export$837bd02682cd3db9,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $0bd560ed02ccf2c4$export$fb184b623420d9be
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $0bd560ed02ccf2c4$export$98e628dec113755e
                                    })
                                ]
                            }, index))
                    })
                ]
            })
        ]
    });
}
var $ecf28d660b66834f$export$2e2bcd8739ae039 = $ecf28d660b66834f$var$Skeleton;


var $ce68da552df2f56b$export$ffb9aadaab235117;
var $ce68da552df2f56b$export$12a40731da9c9684;
var $ce68da552df2f56b$export$34e0f9847d4c02dd;
var $ce68da552df2f56b$export$c05cc7140eecf824;
var $ce68da552df2f56b$export$a727d6cd3f21b50b;
var $ce68da552df2f56b$export$38e42c68cf43b5d4;
var $ce68da552df2f56b$export$bfd64c937657f93a;
var $ce68da552df2f56b$export$4a6dd88bada4e7d2;
var $ce68da552df2f56b$export$c96745152eb2740f;
var $ce68da552df2f56b$export$fb184b623420d9be;
$ce68da552df2f56b$export$ffb9aadaab235117 = `aADheW_activeCard`;
$ce68da552df2f56b$export$12a40731da9c9684 = `aADheW_blocks`;
$ce68da552df2f56b$export$34e0f9847d4c02dd = `aADheW_container`;
$ce68da552df2f56b$export$c05cc7140eecf824 = `aADheW_curve`;
$ce68da552df2f56b$export$a727d6cd3f21b50b = `aADheW_datePicker`;
$ce68da552df2f56b$export$38e42c68cf43b5d4 = `aADheW_header`;
$ce68da552df2f56b$export$bfd64c937657f93a = `aADheW_rotating`;
$ce68da552df2f56b$export$4a6dd88bada4e7d2 = `aADheW_shimmer`;
$ce68da552df2f56b$export$c96745152eb2740f = `aADheW_subtitle`;
$ce68da552df2f56b$export$fb184b623420d9be = `aADheW_title`;


const $688da2f940aadd35$var$tickStyle = {
    fill: "var(--color-text-secondary)",
    fontSize: 11,
    fontFamily: "var(--font-family)"
};
const $688da2f940aadd35$var$tickFormatter = new Intl.NumberFormat("en-US", {
    maximumFractionDigits: 1,
    notation: "compact"
});
function $688da2f940aadd35$var$Dashboard() {
    const [date, setDate] = (0, $eCoWV.useState)((0, $fa8b0761f15bed53$export$2e2bcd8739ae039)(Date.now(), "yyyy-MM-dd"));
    const { data: totalData, error: totalError } = (0, $2mi28.default)("api/dashboard/users/total");
    const { data: newData, error: newError } = (0, $2mi28.default)("api/dashboard/users/new");
    const { data: activeData, error: activeError } = (0, $2mi28.default)(`api/dashboard/users/active?date=${date}`);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Pick an error as the page's error
    const error = totalError ?? newError ?? activeError;
    const isLoading = (!totalData || !newData || !activeData) && !error;
    const handleDateChange = (event)=>{
        setDate(event.target.value);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $ce68da552df2f56b$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "dashboard.title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $ce68da552df2f56b$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ce68da552df2f56b$export$fb184b623420d9be,
                        children: t("dashboard.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ce68da552df2f56b$export$c96745152eb2740f,
                        children: t("dashboard.description")
                    })
                ]
            }),
            isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecf28d660b66834f$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
                errorMessage: error.body?.message
            }),
            !isLoading && totalData && newData && activeData && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $ce68da552df2f56b$export$12a40731da9c9684,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                title: "dashboard.total_users",
                                tip: t("dashboard.total_users_tip"),
                                count: totalData.totalUserCount
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                title: "dashboard.new_users_today",
                                tip: t("dashboard.new_users_today_tip"),
                                count: newData.today.count,
                                delta: newData.today.delta
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                title: "dashboard.new_users_7_days",
                                tip: t("dashboard.new_users_7_days_tip"),
                                count: newData.last7Days.count,
                                delta: newData.last7Days.delta
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: $ce68da552df2f56b$export$ffb9aadaab235117,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                title: "dashboard.daily_active_users",
                                tip: t("dashboard.daily_active_users_tip"),
                                count: activeData.dau.count,
                                delta: activeData.dau.delta,
                                variant: "plain"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $ce68da552df2f56b$export$a727d6cd3f21b50b,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    type: "date",
                                    value: date,
                                    onChange: handleDateChange
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $ce68da552df2f56b$export$c05cc7140eecf824,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ddb5b9d6532a36e0$export$e60a4704009a0009), {
                                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $75fc06af604f7c6d$export$f510429275d6f1a8), {
                                        data: activeData.dauCurve.map((item)=>({
                                                ...item,
                                                // Remove "year" for a compact label.
                                                date: item.date.replace(/\d{4}-/, "")
                                            })),
                                        width: 1100,
                                        height: 168,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cb8b19d7bc42e54c$export$6440e27b9f186856), {
                                                vertical: false,
                                                stroke: "var(--color-divider)"
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $126bbb1a4f17672d$export$ea1a111407f37557), {
                                                type: "monotone",
                                                dataKey: "count",
                                                stroke: "var(--color-primary)",
                                                strokeWidth: 2,
                                                fill: "var(--color-hover-variant)"
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $62178bb4259884f4$export$ea77231de273b52d), {
                                                dataKey: "date",
                                                tickLine: false,
                                                tick: $688da2f940aadd35$var$tickStyle
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e1c235152c6651c$export$f96c4024c52de8f4), {
                                                width: 35,
                                                axisLine: false,
                                                tickLine: false,
                                                tick: $688da2f940aadd35$var$tickStyle,
                                                tickFormatter: (tick)=>$688da2f940aadd35$var$tickFormatter.format(Number(tick)).toLowerCase()
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b4b3fd02c5ccdb66$export$28c660c63b792dea), {
                                                content: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $019b0ea602d15b32$export$2e2bcd8739ae039), {}),
                                                cursor: {
                                                    stroke: "var(--color-primary"
                                                }
                                            })
                                        ]
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $ce68da552df2f56b$export$12a40731da9c9684,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                        title: "dashboard.weekly_active_users",
                                        tip: t("dashboard.weekly_active_users_tip"),
                                        count: activeData.wau.count,
                                        delta: activeData.wau.delta,
                                        variant: "bordered"
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7a179be6c426238b$export$2e2bcd8739ae039), {
                                        title: "dashboard.monthly_active_users",
                                        tip: t("dashboard.monthly_active_users_tip"),
                                        count: activeData.mau.count,
                                        delta: activeData.mau.delta,
                                        variant: "bordered"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $688da2f940aadd35$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($688da2f940aadd35$var$Dashboard);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $51c738948628e5f7$var$SvgSsoConnectorEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M168.233 70c0-7.05 5.716-12.767 12.767-12.767h2v1.534h-2c-6.204 0-11.233 5.03-11.233 11.233v117c0 6.204 5.029 11.233 11.233 11.233h2v1.534h-2c-7.051 0-12.767-5.716-12.767-12.767V70Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.712 204.2a6.134 6.134 0 1 0 6.285-10.537 6.134 6.134 0 0 0-6.285 10.537Zm1.572-2.634a3.068 3.068 0 1 0 3.14-5.269 3.068 3.068 0 0 0-3.14 5.269Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M27.926 70.828a2.045 2.045 0 0 0-.22-2.884l-1.878-1.612a2.045 2.045 0 0 0-2.883.22l-1.613 1.877a2.045 2.045 0 0 0 .22 2.884l1.878 1.612a2.045 2.045 0 0 0 2.883-.22l1.613-1.877Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.999 127.233h29v1.534h-29v-1.534ZM72 127.233h14v1.534H72v-1.534Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M14 111.269C14 104.493 19.493 99 26.269 99h33.462C66.507 99 72 104.493 72 111.269v33.462C72 151.507 66.507 157 59.73 157H26.27C19.493 157 14 151.507 14 144.731v-33.462Z",
                fill: "url(#paint0_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M47.695 129.398v3.293c0 .634-9.39.421-9.39-.493 0-.861.017-4.761 0-8.772-2.103-2.719-2.103-4.418-.44-6.175 1.662-1.756 13.498-2.634 13.498-2.634s.888 8.519 1.027 10.83c.056.929.66 3.951-1.687 3.951h-3.008Z",
                fill: "url(#paint1_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M47.692 129.113a13.916 13.916 0 0 1-5.425-1.767s1.174 2.78 5.425 3.535v-1.768Z",
                fill: "#FFD7B8",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58.406 139.246c.869 1.761 1.566 4.596 2.09 8.503a.763.763 0 0 1-.758.863H26.263a.763.763 0 0 1-.759-.863c.525-3.908 1.222-6.742 2.09-8.503.928-1.882 9.537-5.504 9.537-5.504s.172-1.656.587-1.893c.416-.238 10.07-.237 10.564 0 .495.237.587 1.892.587 1.892s8.611 3.627 9.537 5.505Z",
                fill: "#6F45E5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.216 119.036c-.466-.4-1.033-.669-1.835-.254-1.9.984-.639 4.78 1.488 4.706.733-.026.397 1.433-1.563 2.396 0-1.537-2.348-5.342-2.553-8.806-2.362-.878-1.775-4.388-.154-4.388-.258-3.218 4.908-4.881 6.908-3.034 2.035-2.432 7.17-1.188 7.48.922 3.532-1.88 5.853 3.524 2.546 5.622-1.36.864-4.543 1.192-9.138 1.192-2.204 0-.936 5.147-.247 6.809.88 2.122 5.796 2.414 7.336 2.195 1.203-.171 1.834-.659 1.908-.951 1.1 2.927-.294 4.683-2.495 4.683-3.741 0-7.483-1.098-8.07-3.805-.467-2.155-.441-5.632-1.61-7.287Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.902 149.905c-8.12-.593-14.525-7.439-14.525-15.798 0-8.567 6.729-15.545 15.136-15.83 2.272-9.345 10.616-16.277 20.562-16.277 9.64 0 17.775 6.511 20.335 15.42 8.868.286 15.967 7.456 15.967 16.259 0 8.524-6.656 15.516-15.129 16.211v.11H98.902v-.095Z",
                fill: "url(#paint2_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "url(#paint3_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 41.269C184 34.493 189.493 29 196.269 29h33.462C236.507 29 242 34.493 242 41.269v33.462C242 81.507 236.507 87 229.731 87h-33.462C189.493 87 184 81.507 184 74.731V41.269Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 29.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75V41.269c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V75.5c0 6.766-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019V41.269c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                opacity: 0.8,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint4_linear_2731_87774)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint5_linear_2731_87774)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M197.001 50.768h32v-2.733a2.479 2.479 0 0 0-2.479-2.479H199.48a2.479 2.479 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M200.557 55.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.869.869 0 0 1-.868-.868ZM200.557 60.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.869.869 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 181.269c0-6.776 5.493-12.269 12.269-12.269h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 169.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75v-34.231c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V215.5c0 6.765-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                opacity: 0.8,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint6_linear_2731_87774)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                        fill: "url(#paint7_linear_2731_87774)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M197.001 190.768h32v-2.733a2.48 2.48 0 0 0-2.479-2.479H199.48a2.48 2.48 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M200.557 195.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.868.868 0 0 1-.868-.868ZM200.557 200.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.868.868 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 111.269C184 104.493 189.493 99 196.269 99h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 99.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519h33.462c6.362 0 11.519-5.157 11.519-11.519v-.231h1.5v.231c0 7.19-5.829 13.019-13.019 13.019h-33.462c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019h1.231v1.5h-1.231Zm33.462 0H205v-1.5h24.731c7.19 0 13.019 5.829 13.019 13.019V144.5h-1.5v-33.231c0-6.362-5.157-11.519-11.519-11.519Z",
                fill: "#454262"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint8_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint9_linear_2731_87774)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M215.142 140.899c0 .978-.833 1.815-1.917 1.815s-1.917-.837-1.917-1.815.833-1.815 1.917-1.815 1.917.837 1.917 1.815Z",
                stroke: "#F5EEFF",
                strokeWidth: 1.278
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M208.112 110.278c0-.706.572-1.278 1.278-1.278h7.668c.706 0 1.279.572 1.279 1.278v1.176c0 .677-.573 1.227-1.279 1.227h-7.668c-.706 0-1.278-.55-1.278-1.227v-1.176Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.36 40.718a1.107 1.107 0 0 1-.643 1.421c-.898.339-1.767.738-2.6 1.193a1.09 1.09 0 0 1-1.485-.446 1.11 1.11 0 0 1 .442-1.497 22.792 22.792 0 0 1 2.876-1.319 1.092 1.092 0 0 1 1.41.648Zm14.398.392a1.092 1.092 0 0 1 1.442-.57 23.07 23.07 0 0 1 8.05 5.922A23.224 23.224 0 0 1 94 61.805a1.1 1.1 0 0 1-1.095 1.104 1.1 1.1 0 0 1-1.096-1.104c0-5.323-1.963-10.181-5.202-13.881a20.88 20.88 0 0 0-7.284-5.36 1.108 1.108 0 0 1-.565-1.454Zm-21.426 3.396c.4.457.357 1.155-.096 1.559a21.053 21.053 0 0 0-4.262 5.247 20.951 20.951 0 0 0-2.128 5.245 21.196 21.196 0 0 0-.655 5.248c0 2.39.395 4.683 1.123 6.82a21 21 0 0 0 9.605 11.543A20.574 20.574 0 0 0 71 82.791c3.66 0 7.096-.952 10.082-2.623a20.98 20.98 0 0 0 6.946-6.297 1.09 1.09 0 0 1 1.526-.267 1.11 1.11 0 0 1 .265 1.539 23.176 23.176 0 0 1-7.675 6.957A22.75 22.75 0 0 1 71 85a22.75 22.75 0 0 1-11.144-2.9 23.2 23.2 0 0 1-10.614-12.757A23.345 23.345 0 0 1 48 61.805c0-2 .251-3.944.725-5.798a23.166 23.166 0 0 1 2.353-5.8 23.256 23.256 0 0 1 4.708-5.798 1.089 1.089 0 0 1 1.546.097Z",
                fill: "#CABEFF",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_2731_87774)",
                fill: "#AF9EFF",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "m83.999 62.95-.65-5.85-1.886 1.236C79.71 57.23 77.5 56.45 75.03 56.06c0 0-1.236-.26-2.86-.26-1.626 0-3.12.195-3.12.195-6.306.78-11.05 4.355-11.05 8.645 0 4.42 4.874 8.06 12.35 8.71v-2.535c-5.136-.715-8.386-3.12-8.386-6.175 0-2.86 2.99-5.265 7.086-6.045 0 0 3.184-.715 5.98.13 1.365.325 2.6.78 3.64 1.43l-2.47 1.495 7.8 1.3Z",
                        fillOpacity: 0.6
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M70.348 50.6v22.75l3.9-1.95V48.65l-3.9 1.95Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154 77c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                clipPath: "url(#clip1_2731_87774)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m135.498 65.174-.503 6.215a6.004 6.004 0 0 0-1.627.024l-.287-3.014a.16.16 0 0 1 .161-.175h.515l-.249-3.05a.16.16 0 0 1 .16-.174h1.668c.094 0 .167.08.16.174h.002Zm-4.211.308a.16.16 0 0 0-.21-.108l-1.568.572a.16.16 0 0 0-.091.218l1.275 2.78-.484.176a.161.161 0 0 0-.091.22l1.299 2.735c.471-.26.982-.455 1.521-.578l-1.651-6.014Zm-3.85 1.732 3.609 5.084a5.951 5.951 0 0 0-1.23 1.066l-2.158-2.126a.161.161 0 0 1 .009-.238l.395-.33-2.149-2.177a.16.16 0 0 1 .012-.236l1.277-1.073a.161.161 0 0 1 .235.03Zm-3.027 2.943a.163.163 0 0 0-.231.052l-.834 1.445a.161.161 0 0 0 .07.226l2.764 1.31-.258.446a.16.16 0 0 0 .072.227l2.754 1.259c.2-.513.466-.99.792-1.42l-5.129-3.545Zm-2.036 3.929a.16.16 0 0 1 .199-.128l6.031 1.575a5.953 5.953 0 0 0-.255 1.607l-3.02-.243a.161.161 0 0 1-.146-.188l.091-.507-3.045-.285a.162.162 0 0 1-.143-.189l.289-1.643h-.001Zm-.228 4.073a.16.16 0 0 0-.143.19l.289 1.643a.161.161 0 0 0 .199.127l2.959-.773.089.506a.16.16 0 0 0 .201.127l2.919-.806a5.875 5.875 0 0 1-.306-1.598l-6.207.584Zm.965 4.32a.16.16 0 0 1 .07-.226l5.632-2.67c.214.505.498.974.837 1.394l-2.468 1.756a.16.16 0 0 1-.232-.05l-.257-.447-2.516 1.74a.161.161 0 0 1-.231-.052l-.835-1.445Zm6.824-1.172-4.381 4.438a.16.16 0 0 0 .011.236l1.278 1.072c.073.061.181.047.236-.03l1.769-2.495.394.332c.072.061.182.047.236-.032l1.718-2.492a6.028 6.028 0 0 1-1.261-1.029Zm-.865 7.125a.16.16 0 0 1-.091-.219l2.598-5.668c.478.244.994.426 1.536.534l-.762 2.93a.16.16 0 0 1-.21.11l-.484-.177-.81 2.95a.16.16 0 0 1-.21.108l-1.569-.57.002.002Zm4.474-5.284-.503 6.216a.161.161 0 0 0 .16.174h1.668a.16.16 0 0 0 .16-.174l-.248-3.049h.514a.16.16 0 0 0 .161-.175l-.287-3.014a6.032 6.032 0 0 1-1.626.023l.001-.001Zm6.017-16.824a.162.162 0 0 0-.091-.219l-1.568-.57a.162.162 0 0 0-.211.108l-.81 2.95-.484-.177a.16.16 0 0 0-.21.11l-.762 2.93c.542.108 1.058.29 1.536.535l2.6-5.668Zm3.424 2.47-4.381 4.438a5.95 5.95 0 0 0-1.261-1.03l1.718-2.492a.16.16 0 0 1 .236-.031l.394.332 1.769-2.495a.161.161 0 0 1 .235-.03l1.278 1.072a.16.16 0 0 1 .012.236Zm2.372 3.493a.16.16 0 0 0 .07-.226l-.835-1.446a.16.16 0 0 0-.231-.051l-2.515 1.739-.257-.447a.16.16 0 0 0-.232-.05l-2.469 1.756c.34.422.623.89.838 1.395l5.631-2.67Zm.889 2.262.29 1.643a.161.161 0 0 1-.143.189l-6.207.582a5.875 5.875 0 0 0-.307-1.598l2.919-.805a.16.16 0 0 1 .201.127l.088.506 2.959-.773a.16.16 0 0 1 .199.128h.001Zm-.28 6.032a.161.161 0 0 0 .199-.127l.288-1.644a.161.161 0 0 0-.143-.189l-3.045-.285.091-.507a.16.16 0 0 0-.145-.188l-3.02-.243a5.96 5.96 0 0 1-.256 1.608l6.032 1.574-.001.001Zm-1.607 3.75a.162.162 0 0 1-.231.052l-5.13-3.544c.326-.43.593-.908.792-1.42l2.754 1.26a.16.16 0 0 1 .072.226l-.259.445 2.764 1.311a.16.16 0 0 1 .07.226l-.834 1.445h.002Zm-6.867-2.09 3.609 5.085c.055.077.162.091.235.03l1.278-1.073a.16.16 0 0 0 .011-.236l-2.149-2.176.395-.33a.16.16 0 0 0 .009-.238l-2.158-2.126a5.957 5.957 0 0 1-1.23 1.065Zm-.031 6.924a.161.161 0 0 1-.21-.108l-1.652-6.014c.54-.123 1.05-.32 1.521-.578l1.299 2.734a.16.16 0 0 1-.09.221l-.485.175 1.275 2.781a.161.161 0 0 1-.09.219l-1.569.571.001-.001Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.336 164.738a1.108 1.108 0 0 1-.994 1.202c-.955.089-1.898.245-2.823.464a1.09 1.09 0 0 1-1.314-.821 1.11 1.11 0 0 1 .821-1.328 22.93 22.93 0 0 1 3.122-.514 1.093 1.093 0 0 1 1.188.997Zm13.787 4.174a1.092 1.092 0 0 1 1.541-.17 23.077 23.077 0 0 1 6.203 7.835 23.22 23.22 0 0 1 1.502 16.316 1.1 1.1 0 0 1-1.347.777 1.1 1.1 0 0 1-.766-1.355 21.001 21.001 0 0 0-1.358-14.761 20.886 20.886 0 0 0-5.614-7.09 1.109 1.109 0 0 1-.161-1.552Zm-21.564-2.373c.266.547.04 1.209-.504 1.479a21.051 21.051 0 0 0-5.494 3.938 20.965 20.965 0 0 0-3.436 4.498 21.204 21.204 0 0 0-2.015 4.889 21.118 21.118 0 0 0-.715 6.876 20.995 20.995 0 0 0 6.222 13.666 20.574 20.574 0 0 0 9.033 5.188c3.53.965 7.096.953 10.416.128a20.978 20.978 0 0 0 8.362-4.243 1.09 1.09 0 0 1 1.542.144c.385.47.317 1.166-.15 1.555a23.18 23.18 0 0 1-9.238 4.688 22.754 22.754 0 0 1-11.514-.141 22.75 22.75 0 0 1-9.986-5.735 23.203 23.203 0 0 1-6.874-15.104 23.34 23.34 0 0 1 .789-7.599 23.423 23.423 0 0 1 2.227-5.402 23.166 23.166 0 0 1 3.8-4.975 23.264 23.264 0 0 1 6.07-4.351c.544-.27 1.2-.046 1.465.501Z",
                fill: "#CABEFF",
                fillOpacity: 0.2
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M86 194.449c0-3.075 2.933-14.547 8.998-22.234-4.28 8.081-6.771 13.553-4.955 17.819 1.427 3.351 8.76 2.286 12.725.946-7.056 3.193-14.297 3.627-16.768 3.469Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M99.137 171.875c2.678 1.537 11.201 9.8 14.863 18.867-4.897-7.728-8.417-12.609-13.039-13.177-3.632-.446-6.372 6.402-7.187 10.486.748-7.674 3.99-14.127 5.363-16.176Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M112.287 194.422c-2.677 1.537-14.134 4.747-23.86 3.367 9.177-.354 15.188-.945 17.994-4.642 2.204-2.904-2.389-8.688-5.539-11.432 6.309 4.48 10.307 10.5 11.405 12.707Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_2731_87774",
                        x1: 43,
                        y1: 99,
                        x2: 19.686,
                        y2: 157,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_2731_87774",
                        x1: 44.584,
                        y1: 114.617,
                        x2: 44.584,
                        y2: 133.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_2731_87774",
                        x1: 120.377,
                        y1: 102,
                        x2: 106.437,
                        y2: 154.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_2731_87774",
                        x1: 117.831,
                        y1: 132.612,
                        x2: 129.398,
                        y2: 121.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD099"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFC37D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_2731_87774",
                        x1: 194.372,
                        y1: 59.489,
                        x2: 225.817,
                        y2: 44.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_2731_87774",
                        x1: 202.501,
                        y1: 66.582,
                        x2: 217.966,
                        y2: 44.815,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_2731_87774",
                        x1: 194.372,
                        y1: 199.489,
                        x2: 225.817,
                        y2: 184.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_2731_87774",
                        x1: 202.501,
                        y1: 206.582,
                        x2: 217.966,
                        y2: 184.815,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_2731_87774",
                        x1: 201.32,
                        y1: 130.087,
                        x2: 225.153,
                        y2: 125.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_2731_87774",
                        x1: 206.515,
                        y1: 140.823,
                        x2: 228.286,
                        y2: 127.884,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_2731_87774",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(58 48)",
                            d: "M0 0h26v26H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_2731_87774",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(122 65)",
                            d: "M0 0h24.538v24.538H0z"
                        })
                    })
                ]
            })
        ]
    });
var $51c738948628e5f7$export$2e2bcd8739ae039 = $51c738948628e5f7$var$SvgSsoConnectorEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8438e80d99b840bb$var$SvgSsoConnectorEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M42.712 204.2a6.134 6.134 0 1 0 6.285-10.537 6.134 6.134 0 0 0-6.285 10.537Zm1.572-2.634a3.068 3.068 0 1 0 3.14-5.269 3.068 3.068 0 0 0-3.14 5.269Z",
                fill: "#DBC1FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M27.926 70.828a2.045 2.045 0 0 0-.22-2.884l-1.878-1.612a2.045 2.045 0 0 0-2.883.22l-1.613 1.877a2.045 2.045 0 0 0 .22 2.884l1.878 1.612a2.045 2.045 0 0 0 2.883-.22l1.613-1.877Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M168.233 70c0-7.05 5.716-12.767 12.767-12.767h2v1.534h-2c-6.204 0-11.233 5.03-11.233 11.233v117c0 6.204 5.029 11.233 11.233 11.233h2v1.534h-2c-7.051 0-12.767-5.716-12.767-12.767V70Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153.999 127.233h29v1.534h-29v-1.534ZM72 127.233h14v1.534H72v-1.534Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M14 111.269C14 104.493 19.493 99 26.269 99h33.462C66.507 99 72 104.493 72 111.269v33.462C72 151.507 66.507 157 59.73 157H26.27C19.493 157 14 151.507 14 144.731v-33.462Z",
                fill: "url(#paint0_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M47.695 129.398v3.293c0 .634-9.39.421-9.39-.493 0-.861.017-4.761 0-8.772-2.103-2.719-2.103-4.418-.44-6.175 1.662-1.756 13.498-2.634 13.498-2.634s.888 8.519 1.027 10.83c.056.929.66 3.951-1.687 3.951h-3.008Z",
                fill: "url(#paint1_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M47.692 129.113a13.916 13.916 0 0 1-5.425-1.767s1.174 2.78 5.425 3.535v-1.768Z",
                fill: "#FFD7B8",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58.406 139.246c.869 1.761 1.566 4.596 2.09 8.503a.763.763 0 0 1-.758.863H26.263a.763.763 0 0 1-.759-.863c.525-3.908 1.222-6.742 2.09-8.503.928-1.882 9.537-5.504 9.537-5.504s.172-1.656.587-1.893c.416-.238 10.07-.237 10.564 0 .495.237.587 1.892.587 1.892s8.611 3.627 9.537 5.505Z",
                fill: "#6F45E5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.216 119.036c-.466-.4-1.033-.669-1.835-.254-1.9.984-.639 4.78 1.488 4.706.733-.026.397 1.433-1.563 2.396 0-1.537-2.348-5.342-2.553-8.806-2.362-.878-1.775-4.388-.154-4.388-.258-3.218 4.908-4.881 6.908-3.034 2.035-2.432 7.17-1.188 7.48.922 3.532-1.88 5.853 3.524 2.546 5.622-1.36.864-4.543 1.192-9.138 1.192-2.204 0-.936 5.147-.247 6.809.88 2.122 5.796 2.414 7.336 2.195 1.203-.171 1.834-.659 1.908-.951 1.1 2.927-.294 4.683-2.495 4.683-3.741 0-7.483-1.098-8.07-3.805-.467-2.155-.441-5.632-1.61-7.287Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.902 149.905c-8.12-.593-14.525-7.439-14.525-15.798 0-8.567 6.729-15.545 15.136-15.83 2.272-9.345 10.616-16.277 20.562-16.277 9.64 0 17.775 6.511 20.335 15.42 8.868.286 15.967 7.456 15.967 16.259 0 8.524-6.656 15.516-15.129 16.211v.11H98.902v-.095Z",
                fill: "url(#paint2_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M120.401 125.349a3.22 3.22 0 0 1-4.628 0 3.404 3.404 0 0 1 0-4.736 3.22 3.22 0 0 1 4.628 0 3.404 3.404 0 0 1 0 4.736Zm-7.714 3.158a7.51 7.51 0 0 0 9.033 1.349l4.586 4.693-.751.768a1.135 1.135 0 0 0 0 1.579l1.543 1.578a1.072 1.072 0 0 0 1.542 0l.751-.768 2.284 2.337a2.147 2.147 0 0 0 3.086 0 2.27 2.27 0 0 0 0-3.158l-9.955-10.186c1.566-2.961 1.127-6.74-1.319-9.243a7.514 7.514 0 0 0-10.8 0c-2.982 3.052-2.982 7.999 0 11.051Z",
                fill: "url(#paint3_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 41.269C184 34.493 189.493 29 196.269 29h33.462C236.507 29 242 34.493 242 41.269v33.462C242 81.507 236.507 87 229.731 87h-33.462C189.493 87 184 81.507 184 74.731V41.269Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 29.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75V41.269c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V75.5c0 6.766-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019V41.269c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.8,
                d: "M197.001 48.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                fill: "url(#paint4_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M197.001 50.768h32v-2.733a2.479 2.479 0 0 0-2.479-2.479H199.48a2.479 2.479 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M200.557 55.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.869.869 0 0 1-.868-.868ZM200.557 60.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.869.869 0 0 1-.868-.868ZM184 181.269c0-6.776 5.493-12.269 12.269-12.269h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.8,
                d: "M197.001 188.116a2.56 2.56 0 0 1 2.56-2.56h26.88a2.56 2.56 0 0 1 2.56 2.56v19.2a2.56 2.56 0 0 1-2.56 2.56h-26.88a2.56 2.56 0 0 1-2.56-2.56v-19.2Z",
                fill: "url(#paint5_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M197.001 190.768h32v-2.733a2.48 2.48 0 0 0-2.479-2.479H199.48a2.48 2.48 0 0 0-2.479 2.479v2.733Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M200.557 195.109c0-.48.389-.869.868-.869h8.93a.869.869 0 0 1 0 1.737h-8.93a.868.868 0 0 1-.868-.868ZM200.557 200.322c0-.48.389-.869.868-.869h19.596a.869.869 0 1 1 0 1.737h-19.596a.868.868 0 0 1-.868-.868Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 169.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519H230.5c5.937 0 10.75-4.813 10.75-10.75v-34.231c0-6.362-5.157-11.519-11.519-11.519H229v-1.5h.731c7.19 0 13.019 5.829 13.019 13.019V215.5c0 6.765-5.485 12.25-12.25 12.25h-34.231c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019H222v1.5h-25.731Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M184 111.269C184 104.493 189.493 99 196.269 99h33.462c6.776 0 12.269 5.493 12.269 12.269v33.462c0 6.776-5.493 12.269-12.269 12.269h-33.462c-6.776 0-12.269-5.493-12.269-12.269v-33.462Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M196.269 99.75c-6.362 0-11.519 5.157-11.519 11.519v33.462c0 6.362 5.157 11.519 11.519 11.519h33.462c6.362 0 11.519-5.157 11.519-11.519v-33.462c0-6.362-5.157-11.519-11.519-11.519H205v-1.5h24.731c7.19 0 13.019 5.829 13.019 13.019v33.462c0 7.19-5.829 13.019-13.019 13.019h-33.462c-7.19 0-13.019-5.829-13.019-13.019v-33.462c0-7.19 5.829-13.019 13.019-13.019h1.231v1.5h-1.231Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M203 113.908c0-2.711 2.289-4.908 5.112-4.908h10.224c2.824 0 5.112 2.197 5.112 4.908V140.9c0 2.71-2.288 4.907-5.112 4.907h-10.224c-2.823 0-5.112-2.197-5.112-4.907v-26.992Z",
                fill: "url(#paint6_linear_2731_87834)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M215.142 140.899c0 .978-.833 1.815-1.917 1.815s-1.917-.837-1.917-1.815.833-1.815 1.917-1.815 1.917.837 1.917 1.815Z",
                stroke: "#F5EEFF",
                strokeWidth: 1.278
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M208.112 110.278c0-.706.572-1.278 1.278-1.278h7.668c.706 0 1.279.572 1.279 1.278v1.176c0 .677-.573 1.227-1.279 1.227h-7.668c-.706 0-1.278-.55-1.278-1.227v-1.176Z",
                fill: "#4300DA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M64.36 40.718a1.107 1.107 0 0 1-.643 1.421c-.898.339-1.767.738-2.6 1.193a1.09 1.09 0 0 1-1.485-.446 1.11 1.11 0 0 1 .442-1.497 22.792 22.792 0 0 1 2.876-1.319 1.092 1.092 0 0 1 1.41.648Zm14.398.392a1.092 1.092 0 0 1 1.442-.57 23.07 23.07 0 0 1 8.05 5.922A23.224 23.224 0 0 1 94 61.805a1.1 1.1 0 0 1-1.095 1.104 1.1 1.1 0 0 1-1.096-1.104c0-5.323-1.963-10.181-5.202-13.881a20.88 20.88 0 0 0-7.284-5.36 1.108 1.108 0 0 1-.565-1.454Zm-21.426 3.396c.4.457.357 1.155-.096 1.559a21.053 21.053 0 0 0-4.262 5.247 20.951 20.951 0 0 0-2.128 5.245 21.196 21.196 0 0 0-.655 5.248c0 2.39.395 4.683 1.123 6.82a21 21 0 0 0 9.605 11.543A20.574 20.574 0 0 0 71 82.791c3.66 0 7.096-.952 10.082-2.623a20.98 20.98 0 0 0 6.946-6.297 1.09 1.09 0 0 1 1.526-.267 1.11 1.11 0 0 1 .265 1.539 23.176 23.176 0 0 1-7.675 6.957A22.75 22.75 0 0 1 71 85a22.75 22.75 0 0 1-11.144-2.9 23.2 23.2 0 0 1-10.614-12.757A23.345 23.345 0 0 1 48 61.805c0-2 .251-3.944.725-5.798a23.166 23.166 0 0 1 2.353-5.8 23.256 23.256 0 0 1 4.708-5.798 1.089 1.089 0 0 1 1.546.097Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_2731_87834)",
                fill: "#AF9EFF",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "m83.999 62.95-.65-5.85-1.886 1.236C79.71 57.23 77.5 56.45 75.03 56.06c0 0-1.236-.26-2.86-.26-1.626 0-3.12.195-3.12.195-6.306.78-11.05 4.355-11.05 8.645 0 4.42 4.874 8.06 12.35 8.71v-2.535c-5.136-.715-8.386-3.12-8.386-6.175 0-2.86 2.99-5.265 7.086-6.045 0 0 3.184-.715 5.98.13 1.365.325 2.6.78 3.64 1.43l-2.47 1.495 7.8 1.3Z",
                        fillOpacity: 0.6
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M70.348 50.6v22.75l3.9-1.95V48.65l-3.9 1.95Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M154 77c0 11.046-8.954 20-20 20s-20-8.954-20-20 8.954-20 20-20 20 8.954 20 20Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                clipPath: "url(#clip1_2731_87834)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "m135.498 65.174-.503 6.215a6.004 6.004 0 0 0-1.627.024l-.287-3.014a.16.16 0 0 1 .161-.175h.515l-.249-3.05a.16.16 0 0 1 .16-.174h1.668c.094 0 .167.08.16.174h.002Zm-4.211.308a.16.16 0 0 0-.21-.108l-1.568.572a.16.16 0 0 0-.091.218l1.275 2.78-.484.176a.161.161 0 0 0-.091.22l1.299 2.735c.471-.26.982-.455 1.521-.578l-1.651-6.014Zm-3.85 1.732 3.609 5.084a5.951 5.951 0 0 0-1.23 1.066l-2.158-2.126a.161.161 0 0 1 .009-.238l.395-.33-2.149-2.177a.16.16 0 0 1 .012-.236l1.277-1.073a.161.161 0 0 1 .235.03Zm-3.027 2.943a.163.163 0 0 0-.231.052l-.834 1.445a.161.161 0 0 0 .07.226l2.764 1.31-.258.446a.16.16 0 0 0 .072.227l2.754 1.259c.2-.513.466-.99.792-1.42l-5.129-3.545Zm-2.036 3.929a.16.16 0 0 1 .199-.128l6.031 1.575a5.953 5.953 0 0 0-.255 1.607l-3.02-.243a.161.161 0 0 1-.146-.188l.091-.507-3.045-.285a.162.162 0 0 1-.143-.189l.289-1.643h-.001Zm-.228 4.073a.16.16 0 0 0-.143.19l.289 1.643a.161.161 0 0 0 .199.127l2.959-.773.089.506a.16.16 0 0 0 .201.127l2.919-.806a5.875 5.875 0 0 1-.306-1.598l-6.207.584Zm.965 4.32a.16.16 0 0 1 .07-.226l5.632-2.67c.214.505.498.974.837 1.394l-2.468 1.756a.16.16 0 0 1-.232-.05l-.257-.447-2.516 1.74a.161.161 0 0 1-.231-.052l-.835-1.445Zm6.824-1.172-4.381 4.438a.16.16 0 0 0 .011.236l1.278 1.072c.073.061.181.047.236-.03l1.769-2.495.394.332c.072.061.182.047.236-.032l1.718-2.492a6.028 6.028 0 0 1-1.261-1.029Zm-.865 7.125a.16.16 0 0 1-.091-.219l2.598-5.668c.478.244.994.426 1.536.534l-.762 2.93a.16.16 0 0 1-.21.11l-.484-.177-.81 2.95a.16.16 0 0 1-.21.108l-1.569-.57.002.002Zm4.474-5.284-.503 6.216a.161.161 0 0 0 .16.174h1.668a.16.16 0 0 0 .16-.174l-.248-3.049h.514a.16.16 0 0 0 .161-.175l-.287-3.014a6.032 6.032 0 0 1-1.626.023l.001-.001Zm6.017-16.824a.162.162 0 0 0-.091-.219l-1.568-.57a.162.162 0 0 0-.211.108l-.81 2.95-.484-.177a.16.16 0 0 0-.21.11l-.762 2.93c.542.108 1.058.29 1.536.535l2.6-5.668Zm3.424 2.47-4.381 4.438a5.95 5.95 0 0 0-1.261-1.03l1.718-2.492a.16.16 0 0 1 .236-.031l.394.332 1.769-2.495a.161.161 0 0 1 .235-.03l1.278 1.072a.16.16 0 0 1 .012.236Zm2.372 3.493a.16.16 0 0 0 .07-.226l-.835-1.446a.16.16 0 0 0-.231-.051l-2.515 1.739-.257-.447a.16.16 0 0 0-.232-.05l-2.469 1.756c.34.422.623.89.838 1.395l5.631-2.67Zm.889 2.262.29 1.643a.161.161 0 0 1-.143.189l-6.207.582a5.875 5.875 0 0 0-.307-1.598l2.919-.805a.16.16 0 0 1 .201.127l.088.506 2.959-.773a.16.16 0 0 1 .199.128h.001Zm-.28 6.032a.161.161 0 0 0 .199-.127l.288-1.644a.161.161 0 0 0-.143-.189l-3.045-.285.091-.507a.16.16 0 0 0-.145-.188l-3.02-.243a5.96 5.96 0 0 1-.256 1.608l6.032 1.574-.001.001Zm-1.607 3.75a.162.162 0 0 1-.231.052l-5.13-3.544c.326-.43.593-.908.792-1.42l2.754 1.26a.16.16 0 0 1 .072.226l-.259.445 2.764 1.311a.16.16 0 0 1 .07.226l-.834 1.445h.002Zm-6.867-2.09 3.609 5.085c.055.077.162.091.235.03l1.278-1.073a.16.16 0 0 0 .011-.236l-2.149-2.176.395-.33a.16.16 0 0 0 .009-.238l-2.158-2.126a5.957 5.957 0 0 1-1.23 1.065Zm-.031 6.924a.161.161 0 0 1-.21-.108l-1.652-6.014c.54-.123 1.05-.32 1.521-.578l1.299 2.734a.16.16 0 0 1-.09.221l-.485.175 1.275 2.781a.161.161 0 0 1-.09.219l-1.569.571.001-.001Z",
                    fill: "#AF9EFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M86 194.449c0-3.075 2.934-14.547 8.999-22.234-4.281 8.081-6.772 13.553-4.955 17.819 1.427 3.351 8.76 2.286 12.724.946-7.056 3.193-14.297 3.627-16.767 3.469Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M99.138 171.875c2.678 1.537 11.201 9.8 14.863 18.867-4.897-7.728-8.417-12.609-13.04-13.177-3.631-.446-6.371 6.402-7.186 10.486.747-7.674 3.99-14.127 5.363-16.176Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M112.288 194.422c-2.678 1.537-14.135 4.747-23.861 3.367 9.178-.354 15.188-.945 17.994-4.642 2.205-2.904-2.389-8.688-5.538-11.432 6.309 4.48 10.307 10.5 11.405 12.707Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M98.337 164.738a1.108 1.108 0 0 1-.995 1.202c-.955.089-1.898.245-2.823.464a1.09 1.09 0 0 1-1.314-.821 1.11 1.11 0 0 1 .822-1.328 22.927 22.927 0 0 1 3.121-.514 1.093 1.093 0 0 1 1.189.997Zm13.786 4.174a1.092 1.092 0 0 1 1.541-.17 23.068 23.068 0 0 1 6.204 7.835 23.23 23.23 0 0 1 1.502 16.316 1.101 1.101 0 0 1-1.348.777 1.1 1.1 0 0 1-.765-1.355 21.001 21.001 0 0 0-6.972-21.851 1.109 1.109 0 0 1-.162-1.552Zm-21.563-2.373c.265.547.04 1.209-.504 1.479a21.054 21.054 0 0 0-5.495 3.938 20.968 20.968 0 0 0-3.435 4.498 21.2 21.2 0 0 0-2.016 4.889 21.118 21.118 0 0 0-.714 6.876 20.995 20.995 0 0 0 6.222 13.666 20.574 20.574 0 0 0 9.033 5.188c3.53.965 7.095.953 10.416.128a20.98 20.98 0 0 0 8.361-4.243 1.09 1.09 0 0 1 1.543.144c.384.47.317 1.166-.15 1.555a23.186 23.186 0 0 1-9.238 4.688 22.756 22.756 0 0 1-11.515-.141 22.749 22.749 0 0 1-9.985-5.735 23.203 23.203 0 0 1-6.875-15.104 23.34 23.34 0 0 1 .79-7.599 23.419 23.419 0 0 1 2.227-5.402 23.169 23.169 0 0 1 3.799-4.975 23.265 23.265 0 0 1 6.07-4.351c.544-.27 1.2-.046 1.466.501Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_2731_87834",
                        x1: 43,
                        y1: 122.304,
                        x2: 19.686,
                        y2: 157,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_2731_87834",
                        x1: 44.584,
                        y1: 114.617,
                        x2: 44.584,
                        y2: 133.055,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_2731_87834",
                        x1: 120.377,
                        y1: 102,
                        x2: 106.437,
                        y2: 154.02,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_2731_87834",
                        x1: 117.831,
                        y1: 132.612,
                        x2: 129.398,
                        y2: 121.307,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD099"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFC37D"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_2731_87834",
                        x1: 194.372,
                        y1: 59.489,
                        x2: 225.817,
                        y2: 44.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_2731_87834",
                        x1: 194.372,
                        y1: 199.489,
                        x2: 225.817,
                        y2: 184.213,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_2731_87834",
                        x1: 201.32,
                        y1: 130.087,
                        x2: 225.153,
                        y2: 125.199,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_2731_87834",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(58 48)",
                            d: "M0 0h26v26H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_2731_87834",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(122 65)",
                            d: "M0 0h24.538v24.538H0z"
                        })
                    })
                ]
            })
        ]
    });
var $8438e80d99b840bb$export$2e2bcd8739ae039 = $8438e80d99b840bb$var$SvgSsoConnectorEmpty;





var $6ZMK7 = parcelRequire("6ZMK7");

var $V1X8c = parcelRequire("V1X8c");


var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");





var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");


var $93h5F = parcelRequire("93h5F");
var $88dae2d4c68f785c$export$34e0f9847d4c02dd;
var $88dae2d4c68f785c$export$db3c28d99448dcff;
$88dae2d4c68f785c$export$34e0f9847d4c02dd = `KNePoW_container`;
$88dae2d4c68f785c$export$db3c28d99448dcff = `KNePoW_logo`;


const $0b7a072141ea52e2$export$9c5801498225ab9c = (isDarkMode, logo, logoDark)=>{
    return (isDarkMode ? logoDark : logo) || logoDark || logo;
};


/**
 * Prioritize `branding` configuration:
 *   - Even if it's in light mode and have `branding.darkLogo` configured, use `branding.darkLogo`.
 */ const $a131401853bc7959$var$pickLogoForCurrentTheme = (isDarkMode, { logo: logo, logoDark: logoDark }, branding)=>{
    // Need to use `||` here since `??` operator can not avoid empty strings.
    // Since `logo` and `darkLogo` are both optional, when it is dark mode and `darkLogo` is not configured, should fallback to `logo`.
    const configuredLogo = (0, $0b7a072141ea52e2$export$9c5801498225ab9c)(isDarkMode, branding.logo, branding.darkLogo);
    const builtInLogo = (0, $0b7a072141ea52e2$export$9c5801498225ab9c)(isDarkMode, logo, logoDark);
    // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
    return configuredLogo || builtInLogo;
};
function $a131401853bc7959$var$SsoConnectorLogo({ className: className, containerClassName: containerClassName, data: data }) {
    const theme = (0, $93h5F.default)();
    const isDarkMode = theme === (0, $bhvxB.Theme).Dark;
    const { providerLogo: logo, providerLogoDark: logoDark, branding: branding } = data;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
        containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($88dae2d4c68f785c$export$34e0f9847d4c02dd, containerClassName),
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($88dae2d4c68f785c$export$db3c28d99448dcff, className),
        alt: "logo",
        src: $a131401853bc7959$var$pickLogoForCurrentTheme(isDarkMode, {
            logo: logo,
            logoDark: logoDark
        }, branding)
    });
}
var $a131401853bc7959$export$2e2bcd8739ae039 = $a131401853bc7959$var$SsoConnectorLogo;



var $9zeGj = parcelRequire("9zeGj");

var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");

var $2mi28 = parcelRequire("2mi28");





var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");


var $93h5F = parcelRequire("93h5F");
var $493a65a6286902ae$export$34e0f9847d4c02dd;
var $493a65a6286902ae$export$a7db06668cad9adb;
var $493a65a6286902ae$export$6d59db4903f20f7d;
var $493a65a6286902ae$export$db3c28d99448dcff;
var $493a65a6286902ae$export$a8ff84c12d48cfa6;
var $493a65a6286902ae$export$bfd64c937657f93a;
var $493a65a6286902ae$export$4a6dd88bada4e7d2;
var $493a65a6286902ae$export$8d4349e65e8dc335;
$493a65a6286902ae$export$34e0f9847d4c02dd = `EhFvKG_container`;
$493a65a6286902ae$export$a7db06668cad9adb = `EhFvKG_content`;
$493a65a6286902ae$export$6d59db4903f20f7d = `EhFvKG_description`;
$493a65a6286902ae$export$db3c28d99448dcff = `EhFvKG_logo`;
$493a65a6286902ae$export$a8ff84c12d48cfa6 = `EhFvKG_name`;
$493a65a6286902ae$export$bfd64c937657f93a = `EhFvKG_rotating`;
$493a65a6286902ae$export$4a6dd88bada4e7d2 = `EhFvKG_shimmer`;
$493a65a6286902ae$export$8d4349e65e8dc335 = `EhFvKG_ssoConnector`;


function $07ae5552bd05aa52$var$SsoConnectorRadio({ data: { logo: logo, logoDark: logoDark, description: description, name: name } }) {
    const theme = (0, $93h5F.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $493a65a6286902ae$export$8d4349e65e8dc335,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
                containerClassName: $493a65a6286902ae$export$34e0f9847d4c02dd,
                className: $493a65a6286902ae$export$db3c28d99448dcff,
                alt: "logo",
                src: theme === (0, $bhvxB.Theme).Light ? logo : logoDark
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $493a65a6286902ae$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($493a65a6286902ae$export$a8ff84c12d48cfa6),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            children: name
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $493a65a6286902ae$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            children: description
                        })
                    })
                ]
            })
        ]
    });
}
var $07ae5552bd05aa52$export$2e2bcd8739ae039 = $07ae5552bd05aa52$var$SsoConnectorRadio;


var $8fdf1832e6b49422$exports = {};

$parcel$export($8fdf1832e6b49422$exports, "large", function () { return $8fdf1832e6b49422$export$f09585a853dddd32; }, function (v) { return $8fdf1832e6b49422$export$f09585a853dddd32 = v; });
$parcel$export($8fdf1832e6b49422$exports, "medium", function () { return $8fdf1832e6b49422$export$649ecc744817b5c7; }, function (v) { return $8fdf1832e6b49422$export$649ecc744817b5c7 = v; });
$parcel$export($8fdf1832e6b49422$exports, "rotating", function () { return $8fdf1832e6b49422$export$bfd64c937657f93a; }, function (v) { return $8fdf1832e6b49422$export$bfd64c937657f93a = v; });
$parcel$export($8fdf1832e6b49422$exports, "shimmer", function () { return $8fdf1832e6b49422$export$4a6dd88bada4e7d2; }, function (v) { return $8fdf1832e6b49422$export$4a6dd88bada4e7d2 = v; });
$parcel$export($8fdf1832e6b49422$exports, "ssoConnectorGroup", function () { return $8fdf1832e6b49422$export$956c7f28362e1bcc; }, function (v) { return $8fdf1832e6b49422$export$956c7f28362e1bcc = v; });
var $8fdf1832e6b49422$export$f09585a853dddd32;
var $8fdf1832e6b49422$export$649ecc744817b5c7;
var $8fdf1832e6b49422$export$bfd64c937657f93a;
var $8fdf1832e6b49422$export$4a6dd88bada4e7d2;
var $8fdf1832e6b49422$export$956c7f28362e1bcc;
$8fdf1832e6b49422$export$f09585a853dddd32 = `zOIz_a_large`;
$8fdf1832e6b49422$export$649ecc744817b5c7 = `zOIz_a_medium`;
$8fdf1832e6b49422$export$bfd64c937657f93a = `zOIz_a_rotating`;
$8fdf1832e6b49422$export$4a6dd88bada4e7d2 = `zOIz_a_shimmer`;
$8fdf1832e6b49422$export$956c7f28362e1bcc = `zOIz_a_ssoConnectorGroup`;


function $bb3c13d34f1d0735$var$SsoConnectorRadioGroup({ name: name, value: value, className: className, size: size, connectors: connectors, onChange: onChange }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
        name: name,
        value: value,
        type: "card",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(className, $8fdf1832e6b49422$exports.ssoConnectorGroup, $8fdf1832e6b49422$exports[size]),
        onChange: onChange,
        children: connectors.map((data)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                value: data.providerName,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $07ae5552bd05aa52$export$2e2bcd8739ae039), {
                    data: data
                })
            }, data.providerName))
    });
}
var $bb3c13d34f1d0735$export$2e2bcd8739ae039 = $bb3c13d34f1d0735$var$SsoConnectorRadioGroup;


var $d0eaa12ad0dce691$export$bfd64c937657f93a;
var $d0eaa12ad0dce691$export$4a6dd88bada4e7d2;
var $d0eaa12ad0dce691$export$e086976dd0272b53;
$d0eaa12ad0dce691$export$bfd64c937657f93a = `TBsm3a_rotating`;
$d0eaa12ad0dce691$export$4a6dd88bada4e7d2 = `TBsm3a_shimmer`;
$d0eaa12ad0dce691$export$e086976dd0272b53 = `TBsm3a_textDivider`;


parcelRequire("j6dBR");
var $5Je5u = parcelRequire("5Je5u");
const $d31d69b8b6da3cd2$var$standardSsoConnectorProviders = Object.freeze([
    (0, $5Je5u.SsoProviderName).OIDC,
    (0, $5Je5u.SsoProviderName).SAML
]);
function $d31d69b8b6da3cd2$export$cd5022949ec0f454(providers = []) {
    const standardProviders = new Set();
    const enterpriseProviders = new Set();
    for (const provider of providers)if ($d31d69b8b6da3cd2$var$standardSsoConnectorProviders.includes(provider.providerName)) standardProviders.add(provider);
    else enterpriseProviders.add(provider);
    return {
        standardProviders: [
            ...standardProviders
        ],
        enterpriseProviders: [
            ...enterpriseProviders
        ]
    };
}


const $2df203bc0ac987e5$var$duplicateConnectorNameErrorCode = "single_sign_on.duplicate_connector_name";
function $2df203bc0ac987e5$var$SsoCreationModal({ isOpen: isOpen, onClose: rawOnClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const [selectedProviderName, setSelectedProviderName] = (0, $eCoWV.useState)();
    const isSsoEnabled = !(0, $V1X8c.isCloud) || currentPlan?.quota.ssoEnabled;
    const { data: data, error: error } = (0, $2mi28.default)("api/sso-connector-providers");
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting, errors: errors }, setError: setError, watch: watch } = (0, $c3LX9.useForm)({
        resetOptions: {
            keepErrors: true
        }
    });
    const api = (0, $2ANSb.default)({
        hideErrorToast: true
    });
    const isLoading = !data && !error;
    const { standardProviders: standardProviders, enterpriseProviders: enterpriseProviders } = (0, $d31d69b8b6da3cd2$export$cd5022949ec0f454)(data);
    const radioGroupSize = (0, $0bb9b31ce73ff929$export$2ace16fb29e63d87)(standardProviders.length + enterpriseProviders.length);
    const isAnyConnectorSelected = (0, $eCoWV.useMemo)(()=>[
            ...standardProviders,
            ...enterpriseProviders
        ].some(({ providerName: providerName })=>selectedProviderName === providerName), [
        enterpriseProviders,
        selectedProviderName,
        standardProviders
    ]);
    // `rawOnClose` does not clean the state of the modal.
    const onClose = (ssoConnector)=>{
        setSelectedProviderName(undefined);
        reset();
        rawOnClose(ssoConnector);
    };
    const handleSsoSelection = (providerName)=>{
        setSelectedProviderName(providerName);
    };
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const createdSsoConnector = await api.post(`api/sso-connectors`, {
                json: {
                    ...formData,
                    providerName: selectedProviderName
                }
            }).json();
            onClose(createdSsoConnector);
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                if (metadata.code === $2df203bc0ac987e5$var$duplicateConnectorNameErrorCode) setError("connectorName", {
                    type: "custom",
                    message: metadata.message
                });
            }
        }
    }));
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: "enterprise_sso.create_modal.title",
            footer: isSsoEnabled ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                title: "enterprise_sso.create_modal.create_button_text",
                type: "primary",
                disabled: // The button is available only when:
                // 1. `connectorName` field is not empty.
                // 2. At least one connector is selected.
                // 3. Error is resolved. Since `connectorName` is the only field of this form, it means `connectorName` field error is resolved.
                !(watch("connectorName") && isAnyConnectorSelected) || Boolean(errors.connectorName),
                onClick: onSubmit
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.organizations")
                })
            }),
            size: radioGroupSize,
            onClose: onClose,
            children: [
                isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ebb8af931eb3b482$export$2e2bcd8739ae039), {
                    numberOfLoadingConnectors: 2
                }),
                error?.message,
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bb3c13d34f1d0735$export$2e2bcd8739ae039), {
                    name: "enterpriseProviders",
                    value: selectedProviderName,
                    connectors: enterpriseProviders,
                    size: radioGroupSize,
                    onChange: handleSsoSelection
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $d0eaa12ad0dce691$export$e086976dd0272b53,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "enterprise_sso.create_modal.text_divider"
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bb3c13d34f1d0735$export$2e2bcd8739ae039), {
                    name: "standardProviders",
                    value: selectedProviderName,
                    connectors: standardProviders,
                    size: radioGroupSize,
                    onChange: handleSsoSelection
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    isRequired: true,
                    title: "enterprise_sso.create_modal.connector_name_field_title",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        ...register("connectorName", {
                            required: true
                        }),
                        placeholder: t("enterprise_sso.create_modal.connector_name_field_placeholder"),
                        error: errors.connectorName?.message
                    })
                })
            ]
        })
    });
}
var $2df203bc0ac987e5$export$2e2bcd8739ae039 = $2df203bc0ac987e5$var$SsoCreationModal;


var $f054a8228977efa6$export$34e0f9847d4c02dd;
var $f054a8228977efa6$export$5d15c6f5dc2166f9;
var $f054a8228977efa6$export$db3c28d99448dcff;
var $f054a8228977efa6$export$bfd64c937657f93a;
var $f054a8228977efa6$export$4a6dd88bada4e7d2;
var $f054a8228977efa6$export$bf9fb029d174d554;
$f054a8228977efa6$export$34e0f9847d4c02dd = `EpHMJG_container`;
$f054a8228977efa6$export$5d15c6f5dc2166f9 = `EpHMJG_domains`;
$f054a8228977efa6$export$db3c28d99448dcff = `EpHMJG_logo`;
$f054a8228977efa6$export$bfd64c937657f93a = `EpHMJG_rotating`;
$f054a8228977efa6$export$4a6dd88bada4e7d2 = `EpHMJG_shimmer`;
$f054a8228977efa6$export$bf9fb029d174d554 = `EpHMJG_type`;


const $5a5c5c8d6a7ce863$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $5a5c5c8d6a7ce863$var$enterpriseSsoPathname = "/enterprise-sso";
const $5a5c5c8d6a7ce863$var$createEnterpriseSsoPathname = `${$5a5c5c8d6a7ce863$var$enterpriseSsoPathname}/create`;
const $5a5c5c8d6a7ce863$var$buildDetailsPathname = (id)=>`${$5a5c5c8d6a7ce863$var$enterpriseSsoPathname}/${id}`;
function $5a5c5c8d6a7ce863$var$EnterpriseSsoConnectors() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId, isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const [{ page: page }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1
    });
    const isSsoEnabled = !(0, $V1X8c.isCloud) || currentPlan?.quota.ssoEnabled;
    const handleButtonClick = (0, $eCoWV.useCallback)(()=>{
        navigate(isSsoEnabled ? $5a5c5c8d6a7ce863$var$createEnterpriseSsoPathname : (0, $f5861ec06c49db25$export$6d940d0d58a60bc4));
    }, [
        isSsoEnabled,
        navigate
    ]);
    const url = (0, $h7VLF.buildUrl)("api/sso-connectors", {
        page: String(page),
        page_size: String($5a5c5c8d6a7ce863$var$pageSize)
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const [ssoConnectors, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
        title: {
            isBeta: true,
            paywall: (0, $5CQIb.conditional)((!isSsoEnabled || isDevTenant) && (0, $ckJfF.ReservedPlanId).Hobby),
            title: "enterprise_sso.title",
            subtitle: "enterprise_sso.subtitle"
        },
        pageMeta: {
            titleKey: "enterprise_sso.page_title"
        },
        createButton: (0, $5CQIb.conditional)(ssoConnectors?.length && {
            title: "enterprise_sso.create",
            onClick: ()=>{
                navigate($5a5c5c8d6a7ce863$var$createEnterpriseSsoPathname);
            }
        }),
        table: {
            rowGroups: [
                {
                    key: "enterprise_sso",
                    data: ssoConnectors
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("enterprise_sso.col_connector_name"),
                    dataIndex: "name",
                    colSpan: 5,
                    render: ({ id: id, connectorName: connectorName, ...rest })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                            title: connectorName,
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a131401853bc7959$export$2e2bcd8739ae039), {
                                className: $f054a8228977efa6$export$db3c28d99448dcff,
                                containerClassName: $f054a8228977efa6$export$34e0f9847d4c02dd,
                                data: rest
                            }),
                            to: $5a5c5c8d6a7ce863$var$buildDetailsPathname(id)
                        })
                },
                {
                    title: t("enterprise_sso.col_type"),
                    dataIndex: "type",
                    colSpan: 4,
                    render: ({ name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $f054a8228977efa6$export$bf9fb029d174d554,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: name
                            })
                        })
                },
                {
                    title: t("enterprise_sso.col_email_domain"),
                    dataIndex: "emailDomain",
                    colSpan: 7,
                    render: ({ domains: domains })=>domains.length === 0 ? "-" : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $f054a8228977efa6$export$5d15c6f5dc2166f9,
                            children: domains.map((domain, index)=>// eslint-disable-next-line react/no-array-index-key
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                    variant: "cell",
                                    children: domain
                                }, index))
                        })
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($5a5c5c8d6a7ce863$var$buildDetailsPathname(id));
            },
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $5a5c5c8d6a7ce863$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8438e80d99b840bb$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $51c738948628e5f7$export$2e2bcd8739ae039), {}),
                title: "enterprise_sso.placeholder_title",
                description: "enterprise_sso.placeholder_description",
                action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: isSsoEnabled ? "enterprise_sso.create" : "upsell.upgrade_plan",
                    type: "primary",
                    size: "large",
                    icon: (0, $5CQIb.conditional)(isSsoEnabled && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {})),
                    onClick: handleButtonClick
                })
            }),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2df203bc0ac987e5$export$2e2bcd8739ae039), {
            isOpen: pathname.endsWith($5a5c5c8d6a7ce863$var$createEnterpriseSsoPathname),
            onClose: (ssoConnector)=>{
                if (ssoConnector) {
                    mutate();
                    navigate($5a5c5c8d6a7ce863$var$buildDetailsPathname(ssoConnector.id));
                    return;
                }
                navigate($5a5c5c8d6a7ce863$var$enterpriseSsoPathname);
            }
        })
    });
}
var $5a5c5c8d6a7ce863$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($5a5c5c8d6a7ce863$var$EnterpriseSsoConnectors);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $apgZ7 = parcelRequire("apgZ7");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");
var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");
var $2mi28 = parcelRequire("2mi28");







var $a0Ubj = parcelRequire("a0Ubj");
parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $kMAP9 = parcelRequire("kMAP9");

var $fbeQ6 = parcelRequire("fbeQ6");


var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $5Je5u = parcelRequire("5Je5u");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $e8124284f538c6ba$exports = {};
/**
 * Module dependencies.
 */ 
var $eoBgQ = parcelRequire("eoBgQ");
var $348b817e581085d6$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** `Object#toString` result references. */ var $348b817e581085d6$var$objectTag = "[object Object]";
/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */ function $348b817e581085d6$var$isHostObject(value) {
    // Many host objects are `Object` objects that can coerce to strings
    // despite having improperly defined `toString` methods.
    var result = false;
    if (value != null && typeof value.toString != "function") try {
        result = !!(value + "");
    } catch (e) {}
    return result;
}
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function $348b817e581085d6$var$overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
/** Used for built-in method references. */ var $348b817e581085d6$var$funcProto = Function.prototype, $348b817e581085d6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $348b817e581085d6$var$funcToString = $348b817e581085d6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $348b817e581085d6$var$hasOwnProperty = $348b817e581085d6$var$objectProto.hasOwnProperty;
/** Used to infer the `Object` constructor. */ var $348b817e581085d6$var$objectCtorString = $348b817e581085d6$var$funcToString.call(Object);
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $348b817e581085d6$var$objectToString = $348b817e581085d6$var$objectProto.toString;
/** Built-in value references. */ var $348b817e581085d6$var$getPrototype = $348b817e581085d6$var$overArg(Object.getPrototypeOf, Object);
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $348b817e581085d6$var$isObjectLike(value) {
    return !!value && typeof value == "object";
}
/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */ function $348b817e581085d6$var$isPlainObject(value) {
    if (!$348b817e581085d6$var$isObjectLike(value) || $348b817e581085d6$var$objectToString.call(value) != $348b817e581085d6$var$objectTag || $348b817e581085d6$var$isHostObject(value)) return false;
    var proto = $348b817e581085d6$var$getPrototype(value);
    if (proto === null) return true;
    var Ctor = $348b817e581085d6$var$hasOwnProperty.call(proto, "constructor") && proto.constructor;
    return typeof Ctor == "function" && Ctor instanceof Ctor && $348b817e581085d6$var$funcToString.call(Ctor) == $348b817e581085d6$var$objectCtorString;
}
$348b817e581085d6$exports = $348b817e581085d6$var$isPlainObject;



var $euBJa = parcelRequire("euBJa");
/**
 * Export `cleanDeep` function.
 */ $e8124284f538c6ba$exports = function cleanDeep(object, { cleanKeys: cleanKeys = [], cleanValues: cleanValues = [], emptyArrays: emptyArrays = true, emptyObjects: emptyObjects = true, emptyStrings: emptyStrings = true, NaNValues: NaNValues = false, nullValues: nullValues = true, undefinedValues: undefinedValues = true } = {}) {
    return $euBJa(object, (result, value, key)=>{
        // Exclude specific keys.
        if (cleanKeys.includes(key)) return;
        // Recurse into arrays and objects.
        if (Array.isArray(value) || $348b817e581085d6$exports(value)) value = cleanDeep(value, {
            NaNValues: NaNValues,
            cleanKeys: cleanKeys,
            cleanValues: cleanValues,
            emptyArrays: emptyArrays,
            emptyObjects: emptyObjects,
            emptyStrings: emptyStrings,
            nullValues: nullValues,
            undefinedValues: undefinedValues
        });
        // Exclude specific values.
        if (cleanValues.includes(value)) return;
        // Exclude empty objects.
        if (emptyObjects && $348b817e581085d6$exports(value) && $eoBgQ(value)) return;
        // Exclude empty arrays.
        if (emptyArrays && Array.isArray(value) && !value.length) return;
        // Exclude empty strings.
        if (emptyStrings && value === "") return;
        // Exclude NaN values.
        if (NaNValues && Number.isNaN(value)) return;
        // Exclude null values.
        if (nullValues && value === null) return;
        // Exclude undefined values.
        if (undefinedValues && value === undefined) return;
        // Append when recursing arrays.
        if (Array.isArray(result)) return result.push(value);
        result[key] = value;
    });
};



var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");




var $2ANSb = parcelRequire("2ANSb");

var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $5Je5u = parcelRequire("5Je5u");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $2CYkO = parcelRequire("2CYkO");

var $eEyjP = parcelRequire("eEyjP");

var $47yah = parcelRequire("47yah");

var $dADBR = parcelRequire("dADBR");

var $itzs0 = parcelRequire("itzs0");
var $aba4e46cabf33c32$export$2cdf1b96a9f86d16;
var $aba4e46cabf33c32$export$bfd64c937657f93a;
var $aba4e46cabf33c32$export$4a6dd88bada4e7d2;
$aba4e46cabf33c32$export$2cdf1b96a9f86d16 = `zuDSTG_copyToClipboard`;
$aba4e46cabf33c32$export$bfd64c937657f93a = `zuDSTG_rotating`;
$aba4e46cabf33c32$export$4a6dd88bada4e7d2 = `zuDSTG_shimmer`;


/**
 * TODO: Should align this with the guard `samlServiceProviderMetadataGuard` defined in {@link logto/core/src/sso/types/saml.ts}.
 * This only applies to SAML SSO connectors.
 */ const $4c33dc84e0310bea$var$providerPropertiesGuard = (0, $2CYkO.z).object({
    serviceProvider: (0, $2CYkO.z).object({
        assertionConsumerServiceUrl: (0, $2CYkO.z).string().min(1),
        entityId: (0, $2CYkO.z).string().min(1)
    })
});
function $4c33dc84e0310bea$var$BasicInfo({ ssoConnectorId: ssoConnectorId, providerName: providerName, providerConfig: providerConfig }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { applyDomain: applyCustomDomain } = (0, $itzs0.default)();
    if ([
        (0, $5Je5u.SsoProviderName).OIDC,
        (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE,
        (0, $5Je5u.SsoProviderName).OKTA
    ].includes(providerName)) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
        title: "enterprise_sso.basic_info.oidc.redirect_uri_field_name",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
            className: $aba4e46cabf33c32$export$2cdf1b96a9f86d16,
            variant: "border",
            value: applyCustomDomain(new URL(`/callback/${ssoConnectorId}`, tenantEndpoint).toString())
        })
    });
    const result = $4c33dc84e0310bea$var$providerPropertiesGuard.safeParse(providerConfig);
    /**
   * Should not fallback to some other manually concatenated URL, show empty string instead.
   * Empty string should never show up unless the API does not work properly.
   */ return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "enterprise_sso.basic_info.saml.acs_url_field_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $aba4e46cabf33c32$export$2cdf1b96a9f86d16,
                    variant: "border",
                    value: (0, $5CQIb.conditionalString)(result.success && result.data.serviceProvider.assertionConsumerServiceUrl && applyCustomDomain(result.data.serviceProvider.assertionConsumerServiceUrl))
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "enterprise_sso.basic_info.saml.audience_uri_field_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    className: $aba4e46cabf33c32$export$2cdf1b96a9f86d16,
                    variant: "border",
                    value: (0, $5CQIb.conditionalString)(result.success && result.data.serviceProvider.entityId && applyCustomDomain(result.data.serviceProvider.entityId))
                })
            })
        ]
    });
}
var $4c33dc84e0310bea$export$2e2bcd8739ae039 = $4c33dc84e0310bea$var$BasicInfo;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $5Je5u = parcelRequire("5Je5u");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $47yah = parcelRequire("47yah");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");

var $hdJkM = parcelRequire("hdJkM");

var $4ytKy = parcelRequire("4ytKy");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $812015d0ccc32706$export$34e0f9847d4c02dd;
var $812015d0ccc32706$export$a7db06668cad9adb;
var $812015d0ccc32706$export$bfd64c937657f93a;
var $812015d0ccc32706$export$4a6dd88bada4e7d2;
var $812015d0ccc32706$export$fb184b623420d9be;
$812015d0ccc32706$export$34e0f9847d4c02dd = `Qn5Lwq_container`;
$812015d0ccc32706$export$a7db06668cad9adb = `Qn5Lwq_content`;
$812015d0ccc32706$export$bfd64c937657f93a = `Qn5Lwq_rotating`;
$812015d0ccc32706$export$4a6dd88bada4e7d2 = `Qn5Lwq_shimmer`;
$812015d0ccc32706$export$fb184b623420d9be = `Qn5Lwq_title`;


function $a0848b181d58e9c3$var$ParsedConfigPreview({ providerConfig: providerConfig, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.enterprise_sso_details.oidc_preview"
    });
    const { authorizationEndpoint: authorizationEndpoint, tokenEndpoint: tokenEndpoint, userinfoEndpoint: userinfoEndpoint, jwksUri: jwksUri, issuer: issuer } = providerConfig;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($812015d0ccc32706$export$34e0f9847d4c02dd, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$fb184b623420d9be,
                        children: t("authorization_endpoint")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$a7db06668cad9adb,
                        children: authorizationEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$fb184b623420d9be,
                        children: t("token_endpoint")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$a7db06668cad9adb,
                        children: tokenEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$fb184b623420d9be,
                        children: t("userinfo_endpoint")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$a7db06668cad9adb,
                        children: userinfoEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$fb184b623420d9be,
                        children: t("jwks_uri")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$a7db06668cad9adb,
                        children: jwksUri
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$fb184b623420d9be,
                        children: t("issuer")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $812015d0ccc32706$export$a7db06668cad9adb,
                        children: issuer
                    })
                ]
            })
        ]
    });
}
var $a0848b181d58e9c3$export$2e2bcd8739ae039 = $a0848b181d58e9c3$var$ParsedConfigPreview;


var $4f3d53f4fed8b9e6$export$2cdf1b96a9f86d16;
var $4f3d53f4fed8b9e6$export$a18c376ddfc9b6e5;
var $4f3d53f4fed8b9e6$export$bfd64c937657f93a;
var $4f3d53f4fed8b9e6$export$4a6dd88bada4e7d2;
$4f3d53f4fed8b9e6$export$2cdf1b96a9f86d16 = `tsEUTq_copyToClipboard`;
$4f3d53f4fed8b9e6$export$a18c376ddfc9b6e5 = `tsEUTq_oidcConfigPreview`;
$4f3d53f4fed8b9e6$export$bfd64c937657f93a = `tsEUTq_rotating`;
$4f3d53f4fed8b9e6$export$4a6dd88bada4e7d2 = `tsEUTq_shimmer`;


// Do not show inline notification and parsed config preview if it is on guide page.
function $878c4e5724fd1f7d$var$OidcMetadataForm({ providerConfig: providerConfig, config: config, providerName: providerName }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const isConfigEmpty = !config || Object.keys(config).length === 0;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            !providerConfig && isConfigEmpty && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                severity: "alert",
                children: t("enterprise_sso_details.upload_oidc_idp_info_text")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "enterprise_sso.metadata.oidc.client_id_field_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("clientId", {
                        required: true
                    }),
                    error: Boolean(errors.clientId),
                    placeholder: "Client ID"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "enterprise_sso.metadata.oidc.client_secret_field_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    isConfidential: true,
                    ...register("clientSecret", {
                        required: true
                    }),
                    error: Boolean(errors.clientSecret),
                    placeholder: "Client secret"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                isRequired: providerName !== (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE,
                title: "enterprise_sso.metadata.oidc.issuer_field_name",
                children: [
                    providerName === (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        className: $4f3d53f4fed8b9e6$export$2cdf1b96a9f86d16,
                        variant: "border",
                        // TODO: this hard-coded value should align with the `googleIssuer` value defined in `packages/core/src/sso/GoogleWorkspaceSsoConnector/index.ts`.
                        value: providerConfig?.issuer ?? "https://accounts.google.com"
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        ...register("issuer", {
                            required: true,
                            validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                        }),
                        error: errors.issuer?.message,
                        placeholder: "http(s)://"
                    }),
                    providerConfig && (config?.issuer ?? providerName === (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0848b181d58e9c3$export$2e2bcd8739ae039), {
                        className: $4f3d53f4fed8b9e6$export$a18c376ddfc9b6e5,
                        providerConfig: providerConfig
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "enterprise_sso.metadata.oidc.scope_field_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("scope"),
                    error: Boolean(errors.scope)
                })
            })
        ]
    });
}
var $878c4e5724fd1f7d$export$2e2bcd8739ae039 = $878c4e5724fd1f7d$var$OidcMetadataForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $9rcvl = parcelRequire("9rcvl");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $c3LX9 = parcelRequire("c3LX9");

var $2CYkO = parcelRequire("2CYkO");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $hdJkM = parcelRequire("hdJkM");
/**
 * Type definitions for Enterprise SSO guide form, since the type of SAML config is defined in
 * @logto/core and can not be imported here, should align with SAML config types.
 * See {@link @logto/core/packages/core/src/sso/SamlConnector/index.ts}.
 */ const $16838c16d872880c$export$e1c83a5896ba711f = Object.freeze([
    "id",
    "email",
    "name"
]);


var $9cddc277d27bfa01$export$32180ef41b15b513;
var $9cddc277d27bfa01$export$2cdf1b96a9f86d16;
var $9cddc277d27bfa01$export$38e42c68cf43b5d4;
var $9cddc277d27bfa01$export$bfd64c937657f93a;
var $9cddc277d27bfa01$export$120ff0929b202a6d;
var $9cddc277d27bfa01$export$4a6dd88bada4e7d2;
var $9cddc277d27bfa01$export$9852986a3ec5f6a0;
$9cddc277d27bfa01$export$32180ef41b15b513 = `v3-9YW_body`;
$9cddc277d27bfa01$export$2cdf1b96a9f86d16 = `v3-9YW_copyToClipboard`;
$9cddc277d27bfa01$export$38e42c68cf43b5d4 = `v3-9YW_header`;
$9cddc277d27bfa01$export$bfd64c937657f93a = `v3-9YW_rotating`;
$9cddc277d27bfa01$export$120ff0929b202a6d = `v3-9YW_row`;
$9cddc277d27bfa01$export$4a6dd88bada4e7d2 = `v3-9YW_shimmer`;
$9cddc277d27bfa01$export$9852986a3ec5f6a0 = `v3-9YW_table`;


/**
 * TODO: Should align this with the guard `samlAttributeMappingGuard` defined in {@link logto/core/src/sso/types/saml.ts}.
 * This only applies to SAML-protocol-based SSO connectors.
 */ const $483c63059005fc0b$var$providerPropertiesGuard = (0, $2CYkO.z).object({
    defaultAttributeMapping: (0, $9rcvl.socialUserInfoGuard).pick({
        id: true,
        email: true,
        name: true
    }).required()
});
const $483c63059005fc0b$var$primaryKey = "attributeMapping";
function $483c63059005fc0b$var$SamlAttributeMapping({ providerConfig: providerConfig }) {
    const { register: register } = (0, $c3LX9.useFormContext)();
    const result = $483c63059005fc0b$var$providerPropertiesGuard.safeParse(providerConfig);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("table", {
        className: $9cddc277d27bfa01$export$9852986a3ec5f6a0,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("thead", {
                className: $9cddc277d27bfa01$export$38e42c68cf43b5d4,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("tr", {
                    className: $9cddc277d27bfa01$export$120ff0929b202a6d,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("th", {
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "enterprise_sso.attribute_mapping.col_sp_claims"
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("th", {
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "enterprise_sso.attribute_mapping.col_idp_claims"
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("tbody", {
                className: $9cddc277d27bfa01$export$32180ef41b15b513,
                children: (0, $16838c16d872880c$export$e1c83a5896ba711f).map((key)=>{
                    return /*#__PURE__*/ (0, $9zeGj.jsxs)("tr", {
                        className: $9cddc277d27bfa01$export$120ff0929b202a6d,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                    className: $9cddc277d27bfa01$export$2cdf1b96a9f86d16,
                                    variant: "border",
                                    value: key
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                children: key === "id" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                    className: $9cddc277d27bfa01$export$2cdf1b96a9f86d16,
                                    variant: "border",
                                    value: (0, $5CQIb.conditionalString)(result.success && result.data.defaultAttributeMapping[key])
                                }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register(`${$483c63059005fc0b$var$primaryKey}.${key}`),
                                    placeholder: (0, $5CQIb.conditional)(result.success && result.data.defaultAttributeMapping[key])
                                })
                            })
                        ]
                    }, key);
                })
            })
        ]
    });
}
var $483c63059005fc0b$export$2e2bcd8739ae039 = $483c63059005fc0b$var$SamlAttributeMapping;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");

var $hdJkM = parcelRequire("hdJkM");

var $4ytKy = parcelRequire("4ytKy");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $aadbb151d38f89aa$var$SvgFileIconDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V10L25 0H9Z",
                fill: "#5D34F2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m25 0 10 10h-8a2 2 0 0 1-2-2V0Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.317 16.552a1 1 0 0 1 .632 1.265l-3.5 10.5a1 1 0 0 1-1.897-.633l3.5-10.5a1 1 0 0 1 1.265-.632ZM15.633 16.726a1 1 0 0 1 .141 1.407l-3.957 4.836 3.926 4.362a1 1 0 1 1-1.486 1.338l-4.5-5a1 1 0 0 1-.031-1.302l4.5-5.5a1 1 0 0 1 1.407-.14ZM24.367 16.726a1 1 0 0 0-.141 1.407l3.957 4.836-3.926 4.362a1 1 0 1 0 1.486 1.338l4.5-5a1 1 0 0 0 .031-1.302l-4.5-5.5a1 1 0 0 0-1.407-.14Z",
                fill: "#AF9EFF"
            })
        ]
    });
var $aadbb151d38f89aa$export$2e2bcd8739ae039 = $aadbb151d38f89aa$var$SvgFileIconDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $68a7b201eb674703$var$SvgFileIcon = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.5,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9 0a4 4 0 0 0-4 4v32a4 4 0 0 0 4 4h22a4 4 0 0 0 4-4V10L25 0H9Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m25 0 10 10h-8a2 2 0 0 1-2-2V0Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.317 16.552a1 1 0 0 1 .632 1.265l-3.5 10.5a1 1 0 0 1-1.897-.633l3.5-10.5a1 1 0 0 1 1.265-.632ZM15.633 16.726a1 1 0 0 1 .141 1.407l-3.957 4.836 3.926 4.362a1 1 0 1 1-1.486 1.338l-4.5-5a1 1 0 0 1-.031-1.302l4.5-5.5a1 1 0 0 1 1.407-.14ZM24.367 16.726a1 1 0 0 0-.141 1.407l3.957 4.836-3.926 4.362a1 1 0 1 0 1.486 1.338l4.5-5a1 1 0 0 0 .031-1.302l-4.5-5.5a1 1 0 0 0-1.407-.14Z",
                fill: "#947DFF"
            })
        ]
    });
var $68a7b201eb674703$export$2e2bcd8739ae039 = $68a7b201eb674703$var$SvgFileIcon;




var $kcPww = parcelRequire("kcPww");

var $9bgsA = parcelRequire("9bgsA");

var $93h5F = parcelRequire("93h5F");
// In Bytes.
const $1b9b6459d6f227be$export$daea4c00f4def5a0 = (xmlContent, fileName, mimeType)=>{
    const blob = new Blob([
        xmlContent
    ], {
        type: mimeType
    });
    const file = new File([
        blob
    ], fileName);
    return file.size;
};


var $c43bf78516d4220b$export$1822828d790e23ee;
var $c43bf78516d4220b$export$a3bc9b8ed74fc;
var $c43bf78516d4220b$export$c03ea6337221a120;
var $c43bf78516d4220b$export$5d5b61cfc3d870a9;
var $c43bf78516d4220b$export$45547f6c19231c9;
var $c43bf78516d4220b$export$cd8a31fb65ca89f4;
var $c43bf78516d4220b$export$1ca1ec8b29a4ce27;
var $c43bf78516d4220b$export$48c2d0f2f545ac27;
var $c43bf78516d4220b$export$bfd64c937657f93a;
var $c43bf78516d4220b$export$4a6dd88bada4e7d2;
$c43bf78516d4220b$export$1822828d790e23ee = `_6EOEtq_delete`;
$c43bf78516d4220b$export$a3bc9b8ed74fc = `_6EOEtq_error`;
$c43bf78516d4220b$export$c03ea6337221a120 = `_6EOEtq_fileInfo`;
$c43bf78516d4220b$export$5d5b61cfc3d870a9 = `_6EOEtq_fileInput`;
$c43bf78516d4220b$export$45547f6c19231c9 = `_6EOEtq_fileName`;
$c43bf78516d4220b$export$cd8a31fb65ca89f4 = `_6EOEtq_fileSize`;
$c43bf78516d4220b$export$1ca1ec8b29a4ce27 = `_6EOEtq_icon`;
$c43bf78516d4220b$export$48c2d0f2f545ac27 = `_6EOEtq_preview`;
$c43bf78516d4220b$export$bfd64c937657f93a = `_6EOEtq_rotating`;
$c43bf78516d4220b$export$4a6dd88bada4e7d2 = `_6EOEtq_shimmer`;


const $de86dab489aca161$var$fileSizeLimit = 512000; // 500 KB
function $de86dab489aca161$var$FileReader({ onChange: onChange, value: value, attributes: attributes, fieldError: fieldError, setError: setError }) {
    const theme = (0, $93h5F.default)();
    const { accept: accept, buttonTitle: buttonTitle, defaultFilename: defaultFilename, defaultFileMimeType: defaultFileMimeType } = attributes;
    /**
   * As you can see, per `useDropzone` hook's config, there are at most one file, if file is rejected, then we can return as long as we get the error message.
   */ const onDrop = (0, $eCoWV.useCallback)(async (acceptedFiles = [], fileRejection = [])=>{
        if (fileRejection.length > 0) {
            const fileErrors = fileRejection[0]?.errors;
            if (fileErrors?.[0]?.message) setError({
                type: "custom",
                message: fileErrors[0]?.message
            });
            return;
        }
        const acceptedFile = acceptedFiles[0];
        if (!acceptedFile) return;
        const fileContent = await acceptedFile.text();
        onChange(fileContent);
    }, [
        onChange,
        setError
    ]);
    const handleRemove = ()=>{
        onChange(undefined);
    };
    const { getRootProps: getRootProps, getInputProps: getInputProps } = (0, $cec36242392bfbb2$export$cd49c0ecc5be9f36)({
        onDrop: onDrop,
        noDrag: true,
        maxFiles: 1,
        maxSize: $de86dab489aca161$var$fileSizeLimit,
        multiple: false,
        accept: accept
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        children: value ? /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $c43bf78516d4220b$export$48c2d0f2f545ac27,
            children: [
                theme === (0, $bhvxB.Theme).Dark ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aadbb151d38f89aa$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $68a7b201eb674703$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $c43bf78516d4220b$export$c03ea6337221a120,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            className: $c43bf78516d4220b$export$45547f6c19231c9,
                            children: defaultFilename
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            className: $c43bf78516d4220b$export$cd8a31fb65ca89f4,
                            children: `${((0, $1b9b6459d6f227be$export$daea4c00f4def5a0)(value, defaultFilename, defaultFileMimeType) / 1024).toFixed(2)} KB`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    className: $c43bf78516d4220b$export$1822828d790e23ee,
                    onClick: ()=>{
                        handleRemove();
                    },
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {
                        className: $c43bf78516d4220b$export$1ca1ec8b29a4ce27
                    })
                })
            ]
        }) : /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    ...getRootProps(),
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $91f5fed362dbc61d$export$2e2bcd8739ae039), {}),
                            title: buttonTitle,
                            size: "large"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                            ...getInputProps({
                                className: $c43bf78516d4220b$export$5d5b61cfc3d870a9
                            })
                        })
                    ]
                }),
                Boolean(fieldError) && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $c43bf78516d4220b$export$a3bc9b8ed74fc,
                    children: fieldError?.message
                })
            ]
        })
    });
}
var $de86dab489aca161$export$2e2bcd8739ae039 = $de86dab489aca161$var$FileReader;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $dMkQh = parcelRequire("dMkQh");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $awn06 = parcelRequire("awn06");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");
var $c94f2d60e4a8aa63$export$af8f8af11f83a76a;
var $c94f2d60e4a8aa63$export$34e0f9847d4c02dd;
var $c94f2d60e4a8aa63$export$a7db06668cad9adb;
var $c94f2d60e4a8aa63$export$2cdf1b96a9f86d16;
var $c94f2d60e4a8aa63$export$916114a2e15d3c1c;
var $c94f2d60e4a8aa63$export$e897cab68364f2de;
var $c94f2d60e4a8aa63$export$bfd64c937657f93a;
var $c94f2d60e4a8aa63$export$4a6dd88bada4e7d2;
var $c94f2d60e4a8aa63$export$fb184b623420d9be;
$c94f2d60e4a8aa63$export$af8f8af11f83a76a = `JgiM0G_certificatePreview`;
$c94f2d60e4a8aa63$export$34e0f9847d4c02dd = `JgiM0G_container`;
$c94f2d60e4a8aa63$export$a7db06668cad9adb = `JgiM0G_content`;
$c94f2d60e4a8aa63$export$2cdf1b96a9f86d16 = `JgiM0G_copyToClipboard`;
$c94f2d60e4a8aa63$export$916114a2e15d3c1c = `JgiM0G_errorStatus`;
$c94f2d60e4a8aa63$export$e897cab68364f2de = `JgiM0G_indicator`;
$c94f2d60e4a8aa63$export$bfd64c937657f93a = `JgiM0G_rotating`;
$c94f2d60e4a8aa63$export$4a6dd88bada4e7d2 = `JgiM0G_shimmer`;
$c94f2d60e4a8aa63$export$fb184b623420d9be = `JgiM0G_title`;


function $078a7655d5e3d7d3$export$f1c9def0bdce5f3d({ identityProviderConfig: { x509Certificate: x509Certificate, certificateExpiresAt: certificateExpiresAt, isCertificateValid: isCertificateValid }, className: className }) {
    const { language: language } = (0, $awn06.default);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c94f2d60e4a8aa63$export$af8f8af11f83a76a, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($c94f2d60e4a8aa63$export$e897cab68364f2de, !isCertificateValid && $c94f2d60e4a8aa63$export$916114a2e15d3c1c)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                forKey: "enterprise_sso_details.saml_preview.certificate_content",
                interpolation: {
                    date: new Date(certificateExpiresAt).toLocaleDateString(// TODO: @darcyYe check whether can use date-fns later, may need a Logto locale to date-fns locale mapping.
                    (0, $5CQIb.conditional)((0, $dMkQh.isLanguageTag)(language) && language) ?? "en", {
                        weekday: "long",
                        year: "numeric",
                        month: "long",
                        day: "numeric"
                    })
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                className: $c94f2d60e4a8aa63$export$2cdf1b96a9f86d16,
                variant: "icon",
                value: x509Certificate
            })
        ]
    });
}
function $078a7655d5e3d7d3$var$ParsedConfigPreview({ identityProviderConfig: identityProviderConfig }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.enterprise_sso_details.saml_preview"
    });
    if (!identityProviderConfig) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $c94f2d60e4a8aa63$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$fb184b623420d9be,
                        children: t("sign_on_url")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$a7db06668cad9adb,
                        children: identityProviderConfig.signInEndpoint
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$fb184b623420d9be,
                        children: t("entity_id")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$a7db06668cad9adb,
                        children: identityProviderConfig.entityId
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$fb184b623420d9be,
                        children: t("x509_certificate")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c94f2d60e4a8aa63$export$a7db06668cad9adb,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)($078a7655d5e3d7d3$export$f1c9def0bdce5f3d, {
                            identityProviderConfig: identityProviderConfig
                        })
                    })
                ]
            })
        ]
    });
}
var $078a7655d5e3d7d3$export$2e2bcd8739ae039 = $078a7655d5e3d7d3$var$ParsedConfigPreview;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $56f925fc5afe39c9$var$SvgSwitchArrow = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 21,
        height: 20,
        viewBox: "0 0 21 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m18.591 7.742-3.333-3.334a.837.837 0 1 0-1.183 1.183L15.992 7.5H6.332a.833.833 0 0 0 0 1.666H18a.833.833 0 0 0 .767-.516.834.834 0 0 0-.175-.909Zm-3.925 3.091H3a.833.833 0 0 0-.767.517.833.833 0 0 0 .175.908l3.333 3.334a.833.833 0 0 0 1.184 0 .833.833 0 0 0 0-1.184L5.008 12.5h9.659a.834.834 0 0 0 0-1.667Z",
            fill: "currentColor"
        })
    });
var $56f925fc5afe39c9$export$2e2bcd8739ae039 = $56f925fc5afe39c9$var$SvgSwitchArrow;



var $307Eo = parcelRequire("307Eo");



var $fbeQ6 = parcelRequire("fbeQ6");
var $26462725127930d1$export$81207e5cc4186890;
var $26462725127930d1$export$b7f029de53087ca2;
var $26462725127930d1$export$1ca1ec8b29a4ce27;
var $26462725127930d1$export$d366b825f37a435b;
var $26462725127930d1$export$bfd64c937657f93a;
var $26462725127930d1$export$d90250155de6d7e7;
var $26462725127930d1$export$4a6dd88bada4e7d2;
var $26462725127930d1$export$fb184b623420d9be;
$26462725127930d1$export$81207e5cc4186890 = `eYEHqq_dropdown`;
$26462725127930d1$export$b7f029de53087ca2 = `eYEHqq_dropdownIcon`;
$26462725127930d1$export$1ca1ec8b29a4ce27 = `eYEHqq_icon`;
$26462725127930d1$export$d366b825f37a435b = `eYEHqq_optionText`;
$26462725127930d1$export$bfd64c937657f93a = `eYEHqq_rotating`;
$26462725127930d1$export$d90250155de6d7e7 = `eYEHqq_selected`;
$26462725127930d1$export$4a6dd88bada4e7d2 = `eYEHqq_shimmer`;
$26462725127930d1$export$fb184b623420d9be = `eYEHqq_title`;


var $ad59da415609e486$export$20c44e4bf7f271bb;
(function(FormFormat) {
    FormFormat["Url"] = "url";
    FormFormat["Xml"] = "xml";
    FormFormat["Manual"] = "manual";
})($ad59da415609e486$export$20c44e4bf7f271bb || ($ad59da415609e486$export$20c44e4bf7f271bb = {}));
const $ad59da415609e486$var$options = [
    {
        value: $ad59da415609e486$export$20c44e4bf7f271bb.Url,
        title: "enterprise_sso.metadata.metadata_format_url"
    },
    {
        value: $ad59da415609e486$export$20c44e4bf7f271bb.Xml,
        title: "enterprise_sso.metadata.metadata_format_xml"
    },
    {
        value: $ad59da415609e486$export$20c44e4bf7f271bb.Manual,
        title: "enterprise_sso.metadata.metadata_format_manual"
    }
];
function $ad59da415609e486$var$SwitchFormatButton({ value: value, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
        buttonProps: {
            type: "text",
            size: "small",
            title: "enterprise_sso.metadata.dropdown_trigger_text",
            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $56f925fc5afe39c9$export$2e2bcd8739ae039), {
                className: $26462725127930d1$export$b7f029de53087ca2
            })
        },
        dropdownHorizontalAlign: "start",
        dropdownClassName: $26462725127930d1$export$81207e5cc4186890,
        title: t("enterprise_sso.metadata.dropdown_title"),
        children: $ad59da415609e486$var$options.map(({ value: optionValue, title: title })=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onChange(optionValue);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $307Eo.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($26462725127930d1$export$1ca1ec8b29a4ce27, value === optionValue && $26462725127930d1$export$d90250155de6d7e7)
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($26462725127930d1$export$fb184b623420d9be, $26462725127930d1$export$d366b825f37a435b, value === optionValue && $26462725127930d1$export$d90250155de6d7e7),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: title
                        })
                    })
                ]
            }, optionValue))
    });
}
var $ad59da415609e486$export$2e2bcd8739ae039 = $ad59da415609e486$var$SwitchFormatButton;


var $9ada8242038fcbd2$export$af8f8af11f83a76a;
var $9ada8242038fcbd2$export$6d59db4903f20f7d;
var $9ada8242038fcbd2$export$bfd64c937657f93a;
var $9ada8242038fcbd2$export$4a6dd88bada4e7d2;
$9ada8242038fcbd2$export$af8f8af11f83a76a = `VZM6aG_certificatePreview`;
$9ada8242038fcbd2$export$6d59db4903f20f7d = `VZM6aG_description`;
$9ada8242038fcbd2$export$bfd64c937657f93a = `VZM6aG_rotating`;
$9ada8242038fcbd2$export$4a6dd88bada4e7d2 = `VZM6aG_shimmer`;


const $5b3b7385c32af2e4$var$keyToAttributes = {
    // Accept xml file.
    metadata: {
        buttonTitle: "enterprise_sso.metadata.saml.metadata_xml_uploader_text",
        accept: {
            "application/xml": [],
            "text/xml": []
        },
        defaultFilename: "identity provider metadata.xml",
        defaultFileMimeType: "application/xml"
    },
    x509Certificate: {
        buttonTitle: "enterprise_sso_details.upload_signing_certificate_button_text",
        accept: {
            "application/x-x509-user-cert": [
                ".crt",
                ".cer"
            ],
            "application/x-x509-ca-cert": [
                ".crt",
                ".cer"
            ],
            "application/x-pem-file": [
                ".pem"
            ]
        },
        defaultFilename: "signing certificate.cer",
        defaultFileMimeType: "application/x-x509-user-cert"
    }
};
function $5b3b7385c32af2e4$var$SamlMetadataFormFields({ formFormat: formFormat, identityProviderConfig: identityProviderConfig, config: config }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setError: setError, control: control, register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    switch(formFormat){
        case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Manual:
            return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.sign_in_endpoint_field_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("signInEndpoint", {
                                required: true,
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: Boolean(errors.signInEndpoint),
                            placeholder: "https://"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.idp_entity_id_field_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("entityId", {
                                required: true,
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: Boolean(errors.entityId),
                            placeholder: "https://"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.certificate_field_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "x509Certificate",
                            rules: {
                                validate: (value)=>{
                                    if (!value) return t("enterprise_sso.metadata.saml.certificate_required");
                                    return true;
                                }
                            },
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $de86dab489aca161$export$2e2bcd8739ae039), {
                                            attributes: $5b3b7385c32af2e4$var$keyToAttributes.x509Certificate,
                                            value: value,
                                            fieldError: errors.x509Certificate,
                                            setError: (error)=>{
                                                setError("x509Certificate", error);
                                            },
                                            onChange: onChange
                                        }),
                                        value && identityProviderConfig && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $078a7655d5e3d7d3$export$f1c9def0bdce5f3d), {
                                            className: $9ada8242038fcbd2$export$af8f8af11f83a76a,
                                            identityProviderConfig: identityProviderConfig
                                        })
                                    ]
                                })
                        })
                    })
                ]
            });
        case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Xml:
            return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "enterprise_sso.metadata.saml.metadata_xml_field_name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "metadata",
                            render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $de86dab489aca161$export$2e2bcd8739ae039), {
                                    attributes: $5b3b7385c32af2e4$var$keyToAttributes.metadata,
                                    value: value,
                                    fieldError: errors.metadata,
                                    setError: (error)=>{
                                        setError("metadata", error);
                                    },
                                    onChange: onChange
                                })
                        })
                    }),
                    config?.metadata && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $078a7655d5e3d7d3$export$2e2bcd8739ae039), {
                        identityProviderConfig: identityProviderConfig
                    })
                ]
            });
        case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url:
            return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        isRequired: true,
                        title: "enterprise_sso.metadata.saml.metadata_url_field_name",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("metadataUrl", {
                                    required: true,
                                    validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                                }),
                                error: Boolean(errors.metadataUrl),
                                placeholder: "https://"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $9ada8242038fcbd2$export$6d59db4903f20f7d,
                                children: t("enterprise_sso.metadata.saml.metadata_url_description")
                            })
                        ]
                    }),
                    config?.metadataUrl && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $078a7655d5e3d7d3$export$2e2bcd8739ae039), {
                        identityProviderConfig: identityProviderConfig
                    })
                ]
            });
        default:
            return null;
    }
}
// Do not show inline notification and parsed config preview if it is on guide page.
function $5b3b7385c32af2e4$var$SamlMetadataForm({ config: config, providerConfig: providerConfig }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setValue: setValue } = (0, $c3LX9.useFormContext)();
    const identityProviderConfig = providerConfig?.identityProvider;
    const isConfigEmpty = !config || Object.keys(config).length === 0;
    // Default form format could change based on the value of ORIGINAL `config`.
    // We emphasis ORIGINAL here to avoid using `watch()` which got the real-time value and could lead to conflict.
    const [formFormat, setFormFormat] = (0, $eCoWV.useState)(()=>{
        if (!config) return (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url;
        const { metadataUrl: metadataUrl, metadata: metadata, entityId: entityId, signInEndpoint: signInEndpoint, x509Certificate: x509Certificate } = config;
        if (metadataUrl) return (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url;
        if (metadata) return (0, $ad59da415609e486$export$20c44e4bf7f271bb).Xml;
        if (entityId && signInEndpoint && x509Certificate) return (0, $ad59da415609e486$export$20c44e4bf7f271bb).Manual;
        return (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url;
    });
    // If some form format is selected, then fields from other fields should be cleared.
    const onSelect = (newFormFormat)=>{
        if (newFormFormat === formFormat) return;
        // Reset old format form values.
        switch(formFormat){
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url:
                setValue("metadataUrl", undefined);
                break;
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Xml:
                setValue("metadata", undefined);
                break;
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Manual:
                setValue("entityId", undefined);
                setValue("signInEndpoint", undefined);
                setValue("x509Certificate", undefined);
                break;
            default:
                break;
        }
        // Resume field if exists in `config`; should show original value if switch to another form format and switch back.
        switch(newFormFormat){
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url:
                setValue("metadataUrl", config?.metadataUrl);
                break;
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Xml:
                setValue("metadata", config?.metadata);
                break;
            case (0, $ad59da415609e486$export$20c44e4bf7f271bb).Manual:
                setValue("entityId", config?.entityId);
                setValue("signInEndpoint", config?.signInEndpoint);
                setValue("x509Certificate", config?.x509Certificate);
                break;
            default:
                break;
        }
        setFormFormat(newFormFormat);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            !identityProviderConfig && isConfigEmpty && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                severity: "alert",
                children: t(formFormat === (0, $ad59da415609e486$export$20c44e4bf7f271bb).Url ? "enterprise_sso_details.upload_saml_idp_metadata_info_text_url" : formFormat === (0, $ad59da415609e486$export$20c44e4bf7f271bb).Xml ? "enterprise_sso_details.upload_saml_idp_metadata_info_text_xml" : "enterprise_sso_details.upload_saml_idp_metadata_info_text_manual")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)($5b3b7385c32af2e4$var$SamlMetadataFormFields, {
                formFormat: formFormat,
                identityProviderConfig: identityProviderConfig,
                config: config
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad59da415609e486$export$2e2bcd8739ae039), {
                value: formFormat,
                onChange: onSelect
            })
        ]
    });
}
var $5b3b7385c32af2e4$export$2e2bcd8739ae039 = $5b3b7385c32af2e4$var$SamlMetadataForm;


var $ed8099144f3f92c4$export$bfd64c937657f93a;
var $ed8099144f3f92c4$export$f8e7b82cc7a7899b;
var $ed8099144f3f92c4$export$4a6dd88bada4e7d2;
$ed8099144f3f92c4$export$bfd64c937657f93a = `PniY7q_rotating`;
$ed8099144f3f92c4$export$f8e7b82cc7a7899b = `PniY7q_samlMetadataForm`;
$ed8099144f3f92c4$export$4a6dd88bada4e7d2 = `PniY7q_shimmer`;


const $db4c53c177c2a5ad$var$invalidConfigErrorCode = "connector.invalid_config";
const $db4c53c177c2a5ad$var$invalidMetadataErrorCode = "connector.invalid_metadata";
// This component contains only `data.config`.
function $db4c53c177c2a5ad$var$Connection({ isDeleted: isDeleted, data: data, onUpdated: onUpdated }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { id: ssoConnectorId, providerName: providerName, providerConfig: providerConfig, config: config } = data;
    const api = (0, $2ANSb.default)({
        hideErrorToast: true
    });
    const methods = (0, $c3LX9.useForm)();
    const { watch: watch, setError: setError, formState: { isSubmitting: isSubmitting, isDirty: isDirty }, handleSubmit: handleSubmit, reset: reset } = methods;
    (0, $eCoWV.useEffect)(()=>{
        reset(config);
    }, [
        config,
        reset
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const updatedSsoConnector = await api// TODO: @darcyYe add console test case to remove attribute mapping config.
            .patch(`api/sso-connectors/${ssoConnectorId}`, {
                json: {
                    config: (0, (/*@__PURE__*/$parcel$interopDefault($e8124284f538c6ba$exports)))(formData)
                }
            }).json();
            (0, $horhC.toast).success(t("general.saved"));
            onUpdated(updatedSsoConnector);
            reset(updatedSsoConnector.config);
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                // TODO: @darcyYe refactor the generic of `GuideFormType<T>`.
                // Typescript can not infer the generic `GuideFormType<T>`, find a better way to deal with the types later.
                if (metadata.code === $db4c53c177c2a5ad$var$invalidConfigErrorCode) {
                    // OIDC-based SSO connector's config only relies on the result of read from `issuer` field.
                    if ([
                        (0, $5Je5u.SsoProviderName).OIDC,
                        (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE,
                        (0, $5Je5u.SsoProviderName).OKTA
                    ].includes(providerName)) // eslint-disable-next-line no-restricted-syntax
                    setError("issuer", {
                        type: "custom",
                        message: metadata.message
                    });
                    // OIDC-based config has been excluded in previous condition check.
                    // eslint-disable-next-line no-restricted-syntax
                    const formConfig = watch();
                    const key = (0, $5CQIb.conditional)(formConfig.metadata && "metadata") ?? (0, $5CQIb.conditional)(formConfig.metadataUrl && "metadataUrl");
                    if (key) // eslint-disable-next-line no-restricted-syntax
                    setError(key, {
                        type: "custom",
                        message: metadata.message
                    });
                }
                // Invalid metadata error only happens for SAML based SSO connectors, when trying to init IdP with XML-format metadata.
                if (metadata.code === $db4c53c177c2a5ad$var$invalidMetadataErrorCode && [
                    (0, $5Je5u.SsoProviderName).SAML,
                    (0, $5Je5u.SsoProviderName).AZURE_AD
                ].includes(providerName)) {
                    // Typescript can not infer the generic of setError() path.
                    // eslint-disable-next-line no-restricted-syntax
                    const formConfig = watch();
                    const key = (0, $5CQIb.conditional)(formConfig.metadata && "metadata") ?? (0, $5CQIb.conditional)(formConfig.metadataUrl && "metadataUrl");
                    // eslint-disable-next-line no-restricted-syntax
                    setError(key, {
                        type: "custom",
                        message: metadata.message
                    });
                }
            }
            throw error;
        }
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c3LX9.FormProvider), {
        ...methods,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: [
                    [
                        (0, $5Je5u.SsoProviderName).OIDC,
                        (0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE,
                        (0, $5Je5u.SsoProviderName).OKTA
                    ].includes(providerName) ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.upload_idp_metadata_title_oidc",
                        description: "enterprise_sso_details.upload_idp_metadata_description_oidc",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $878c4e5724fd1f7d$export$2e2bcd8739ae039), {
                            providerName: providerName,
                            // eslint-disable-next-line no-restricted-syntax
                            config: config,
                            providerConfig: // eslint-disable-next-line no-restricted-syntax
                            providerConfig
                        })
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.upload_idp_metadata_title_saml",
                        description: "enterprise_sso_details.upload_idp_metadata_description_saml",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $ed8099144f3f92c4$export$f8e7b82cc7a7899b,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5b3b7385c32af2e4$export$2e2bcd8739ae039), {
                                // eslint-disable-next-line no-restricted-syntax
                                config: config,
                                providerConfig: // eslint-disable-next-line no-restricted-syntax
                                providerConfig
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.service_provider_property_title",
                        description: "enterprise_sso_details.service_provider_property_description",
                        descriptionInterpolation: {
                            protocol: [
                                (0, $5Je5u.SsoProviderName).SAML,
                                (0, $5Je5u.SsoProviderName).AZURE_AD
                            ].includes(providerName) ? "SAML 2.0" : "OIDC"
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4c33dc84e0310bea$export$2e2bcd8739ae039), {
                            ssoConnectorId: ssoConnectorId,
                            providerName: providerName,
                            providerConfig: providerConfig
                        })
                    }),
                    [
                        (0, $5Je5u.SsoProviderName).SAML,
                        (0, $5Je5u.SsoProviderName).AZURE_AD
                    ].includes(providerName) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.attribute_mapping_title",
                        description: "enterprise_sso_details.attribute_mapping_description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $483c63059005fc0b$export$2e2bcd8739ae039), {
                            providerConfig: providerConfig
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $db4c53c177c2a5ad$export$2e2bcd8739ae039 = $db4c53c177c2a5ad$var$Connection;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");


var $d2Ivz = parcelRequire("d2Ivz");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");




var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");


var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");



var $bSFEw = parcelRequire("bSFEw");

var $4ytKy = parcelRequire("4ytKy");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $iHViS = parcelRequire("iHViS");

var $9bgsA = parcelRequire("9bgsA");


var $6PcpQ = parcelRequire("6PcpQ");
const $ac57096d4b8a77dc$export$a5d922e87633d379 = "single_sign_on.duplicated_domains";
const $ac57096d4b8a77dc$export$87bccd4692227778 = "single_sign_on.forbidden_domains";
const $ac57096d4b8a77dc$export$e4db90811da8f94 = "single_sign_on.invalid_domain_format";
const $ac57096d4b8a77dc$export$693a7739508f6d01 = new RegExp("\\S+[\\.]{1}\\S+");


var $3b9505b001f84be2$exports = {};

$parcel$export($3b9505b001f84be2$exports, "close", function () { return $3b9505b001f84be2$export$8360e631d277ea4d; }, function (v) { return $3b9505b001f84be2$export$8360e631d277ea4d = v; });
$parcel$export($3b9505b001f84be2$exports, "delete", function () { return $3b9505b001f84be2$export$1822828d790e23ee; }, function (v) { return $3b9505b001f84be2$export$1822828d790e23ee = v; });
$parcel$export($3b9505b001f84be2$exports, "error", function () { return $3b9505b001f84be2$export$a3bc9b8ed74fc; }, function (v) { return $3b9505b001f84be2$export$a3bc9b8ed74fc = v; });
$parcel$export($3b9505b001f84be2$exports, "errorMessage", function () { return $3b9505b001f84be2$export$493b5823483d2c4e; }, function (v) { return $3b9505b001f84be2$export$493b5823483d2c4e = v; });
$parcel$export($3b9505b001f84be2$exports, "focused", function () { return $3b9505b001f84be2$export$4c2b230493b2b322; }, function (v) { return $3b9505b001f84be2$export$4c2b230493b2b322 = v; });
$parcel$export($3b9505b001f84be2$exports, "info", function () { return $3b9505b001f84be2$export$a80b3bd66acc52ff; }, function (v) { return $3b9505b001f84be2$export$a80b3bd66acc52ff = v; });
$parcel$export($3b9505b001f84be2$exports, "input", function () { return $3b9505b001f84be2$export$b7e3ae3d7c15e42e; }, function (v) { return $3b9505b001f84be2$export$b7e3ae3d7c15e42e = v; });
$parcel$export($3b9505b001f84be2$exports, "multiple", function () { return $3b9505b001f84be2$export$939ddaa3205df08e; }, function (v) { return $3b9505b001f84be2$export$939ddaa3205df08e = v; });
$parcel$export($3b9505b001f84be2$exports, "rotating", function () { return $3b9505b001f84be2$export$bfd64c937657f93a; }, function (v) { return $3b9505b001f84be2$export$bfd64c937657f93a = v; });
$parcel$export($3b9505b001f84be2$exports, "shimmer", function () { return $3b9505b001f84be2$export$4a6dd88bada4e7d2; }, function (v) { return $3b9505b001f84be2$export$4a6dd88bada4e7d2 = v; });
$parcel$export($3b9505b001f84be2$exports, "tag", function () { return $3b9505b001f84be2$export$2b067c6666111485; }, function (v) { return $3b9505b001f84be2$export$2b067c6666111485 = v; });
var $3b9505b001f84be2$export$8360e631d277ea4d;
var $3b9505b001f84be2$export$1822828d790e23ee;
var $3b9505b001f84be2$export$a3bc9b8ed74fc;
var $3b9505b001f84be2$export$493b5823483d2c4e;
var $3b9505b001f84be2$export$4c2b230493b2b322;
var $3b9505b001f84be2$export$a80b3bd66acc52ff;
var $3b9505b001f84be2$export$b7e3ae3d7c15e42e;
var $3b9505b001f84be2$export$939ddaa3205df08e;
var $3b9505b001f84be2$export$bfd64c937657f93a;
var $3b9505b001f84be2$export$4a6dd88bada4e7d2;
var $3b9505b001f84be2$export$2b067c6666111485;
$3b9505b001f84be2$export$8360e631d277ea4d = `_8qpGpW_close`;
$3b9505b001f84be2$export$1822828d790e23ee = `_8qpGpW_delete`;
$3b9505b001f84be2$export$a3bc9b8ed74fc = `_8qpGpW_error`;
$3b9505b001f84be2$export$493b5823483d2c4e = `_8qpGpW_errorMessage`;
$3b9505b001f84be2$export$4c2b230493b2b322 = `_8qpGpW_focused`;
$3b9505b001f84be2$export$a80b3bd66acc52ff = `_8qpGpW_info`;
$3b9505b001f84be2$export$b7e3ae3d7c15e42e = `_8qpGpW_input`;
$3b9505b001f84be2$export$939ddaa3205df08e = `_8qpGpW_multiple`;
$3b9505b001f84be2$export$bfd64c937657f93a = `_8qpGpW_rotating`;
$3b9505b001f84be2$export$4a6dd88bada4e7d2 = `_8qpGpW_shimmer`;
$3b9505b001f84be2$export$2b067c6666111485 = `_8qpGpW_tag`;


parcelRequire("j6dBR");
var $khQz7 = parcelRequire("khQz7");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $awn06 = parcelRequire("awn06");

const $17c7cba9b45d283e$export$929a2b2dcadf379e = (inputValues)=>{
    const { duplicatedDomains: duplicatedDomains, forbiddenDomains: forbiddenDomains } = (0, $khQz7.findDuplicatedOrBlockedEmailDomains)(inputValues.map((domain)=>domain.value));
    const isAnyDomainInvalid = inputValues.some(({ value: value })=>!(0, $ac57096d4b8a77dc$export$693a7739508f6d01).test(value));
    // Show error message and update the inputs' status for error display.
    if (duplicatedDomains.size > 0 || forbiddenDomains.size > 0 || isAnyDomainInvalid) return {
        values: inputValues.map(({ status: status, ...rest })=>({
                ...rest,
                ...(0, $5CQIb.conditional)((duplicatedDomains.has(rest.value) || forbiddenDomains.has(rest.value) || !(0, $ac57096d4b8a77dc$export$693a7739508f6d01).test(rest.value)) && {
                    status: "info"
                })
            })),
        errorMessage: (0, $5CQIb.conditionalArray)((0, $5CQIb.conditionalString)(duplicatedDomains.size > 0 && (0, $awn06.t)(`errors:${(0, $ac57096d4b8a77dc$export$a5d922e87633d379)}`)), (0, $5CQIb.conditionalString)(forbiddenDomains.size > 0 && (0, $awn06.t)(`errors:${(0, $ac57096d4b8a77dc$export$87bccd4692227778)}`)), (0, $5CQIb.conditionalString)(isAnyDomainInvalid && (0, $awn06.t)(`errors:${(0, $ac57096d4b8a77dc$export$e4db90811da8f94)}`))).join(" ")
    };
    return {
        values: inputValues
    };
};


function $001018729eb4381f$var$DomainsInput({ className: className, values: values, onChange: rawOnChange, error: error, placeholder: placeholder }) {
    const inputRef = (0, $eCoWV.useRef)(null);
    const [focusedValueId, setFocusedValueId] = (0, $eCoWV.useState)(null);
    const [currentValue, setCurrentValue] = (0, $eCoWV.useState)("");
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { setError: setError } = (0, $c3LX9.useFormContext)();
    const onChange = (values)=>{
        const { values: parsedValues, errorMessage: errorMessage } = (0, $17c7cba9b45d283e$export$929a2b2dcadf379e)(values);
        if (errorMessage) setError("domains", {
            type: "custom",
            message: errorMessage
        });
        rawOnChange(parsedValues);
    };
    const handleAdd = (value)=>{
        const newValues = [
            ...values,
            {
                value: value,
                id: (0, $jKlLV.generateStandardShortId)(),
                ...(0, $5CQIb.conditional)(!(0, $ac57096d4b8a77dc$export$693a7739508f6d01).test(value) && {
                    status: "info"
                })
            }
        ];
        onChange(newValues);
        setCurrentValue("");
        inputRef.current?.focus();
    };
    const handleDelete = (option)=>{
        onChange(values.filter(({ id: id })=>id !== option.id));
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3b9505b001f84be2$exports.input, $3b9505b001f84be2$exports.multiple, Boolean(error) && $3b9505b001f84be2$exports.error, className),
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    inputRef.current?.focus();
                }),
                onClick: ()=>{
                    inputRef.current?.focus();
                },
                children: [
                    values.map((option)=>{
                        return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                            variant: "cell",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3b9505b001f84be2$exports.tag, option.status && $3b9505b001f84be2$exports[option.status], option.id === focusedValueId && $3b9505b001f84be2$exports.focused),
                            onClick: ()=>{
                                inputRef.current?.focus();
                            },
                            children: [
                                option.value,
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    className: $3b9505b001f84be2$exports.delete,
                                    size: "small",
                                    onClick: ()=>{
                                        handleDelete(option);
                                    },
                                    onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                                        handleDelete(option);
                                    }),
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                                        className: $3b9505b001f84be2$exports.close
                                    })
                                })
                            ]
                        }, option.id);
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                        ref: inputRef,
                        // Need to use t() to complete the translation with prefix, use String() to convert the result to string.
                        // Should not show placeholder when there are values.
                        placeholder: (0, $5CQIb.conditional)(values.length === 0 && placeholder && String(t(placeholder))),
                        value: currentValue,
                        onKeyDown: (event)=>{
                            if (event.key === "Backspace" && currentValue === "") {
                                if (focusedValueId) {
                                    onChange(values.filter(({ id: id })=>id !== focusedValueId));
                                    setFocusedValueId(null);
                                } else setFocusedValueId(values.at(-1)?.id ?? null);
                                inputRef.current?.focus();
                            }
                            if (event.key === " " || event.code === "Space" || event.key === "Enter") {
                                // Focusing on input
                                if (currentValue !== "" && document.activeElement === inputRef.current) handleAdd(currentValue);
                                // Do not react to "Enter"
                                event.preventDefault();
                            }
                        },
                        onChange: ({ currentTarget: { value: value } })=>{
                            setCurrentValue(value);
                            setFocusedValueId(null);
                        },
                        onFocus: ()=>{
                            inputRef.current?.focus();
                        },
                        onBlur: ()=>{
                            if (currentValue !== "") handleAdd(currentValue);
                            setFocusedValueId(null);
                        }
                    })
                ]
            }),
            Boolean(error) && typeof error === "string" && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $3b9505b001f84be2$exports.errorMessage,
                children: error
            })
        ]
    });
}
var $001018729eb4381f$export$2e2bcd8739ae039 = $001018729eb4381f$var$DomainsInput;





var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $3872910536d327d3$export$34e0f9847d4c02dd;
var $3872910536d327d3$export$6d59db4903f20f7d;
var $3872910536d327d3$export$a3bc9b8ed74fc;
var $3872910536d327d3$export$2cef06c20297c17d;
var $3872910536d327d3$export$8d14eecd258bcdb7;
var $3872910536d327d3$export$96cc76c17ae5d4f1;
var $3872910536d327d3$export$f1185274f83a7a7d;
var $3872910536d327d3$export$a7b0d73c5acc4a43;
var $3872910536d327d3$export$8a0fd8301fa867af;
var $3872910536d327d3$export$bfd64c937657f93a;
var $3872910536d327d3$export$4a6dd88bada4e7d2;
var $3872910536d327d3$export$7472b0d4ff79ef04;
$3872910536d327d3$export$34e0f9847d4c02dd = `wBBHtG_container`;
$3872910536d327d3$export$6d59db4903f20f7d = `wBBHtG_description`;
$3872910536d327d3$export$a3bc9b8ed74fc = `wBBHtG_error`;
$3872910536d327d3$export$2cef06c20297c17d = `wBBHtG_frame`;
$3872910536d327d3$export$8d14eecd258bcdb7 = `wBBHtG_frameBackground`;
$3872910536d327d3$export$96cc76c17ae5d4f1 = `wBBHtG_frameDark`;
$3872910536d327d3$export$f1185274f83a7a7d = `wBBHtG_frameDarkBackground`;
$3872910536d327d3$export$a7b0d73c5acc4a43 = `wBBHtG_logoDarkUploader`;
$3872910536d327d3$export$8a0fd8301fa867af = `wBBHtG_logoUploader`;
$3872910536d327d3$export$bfd64c937657f93a = `wBBHtG_rotating`;
$3872910536d327d3$export$4a6dd88bada4e7d2 = `wBBHtG_shimmer`;
$3872910536d327d3$export$7472b0d4ff79ef04 = `wBBHtG_uploader`;


const $e9753ed18a8f396b$var$allowedMimeTypes = [
    "image/png",
    "image/jpeg",
    "image/svg+xml"
]; // Only allow `svg`, `png`, `jpg` and `jpeg` files.
function $e9753ed18a8f396b$var$LogosUploader({ isDarkModeEnabled: isDarkModeEnabled }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [uploadLogoError, setUploadLogoError] = (0, $eCoWV.useState)();
    const [uploadDarkLogoError, setUploadDarkLogoError] = (0, $eCoWV.useState)();
    const { control: control } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $3872910536d327d3$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $3872910536d327d3$export$7472b0d4ff79ef04,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $3872910536d327d3$export$8a0fd8301fa867af,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "branding.logo",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e6f10e5b5e7a477$export$2e2bcd8739ae039), {
                                    name: name,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isDarkModeEnabled && $3872910536d327d3$export$2cef06c20297c17d, isDarkModeEnabled && value && $3872910536d327d3$export$8d14eecd258bcdb7),
                                    value: value ?? "",
                                    actionDescription: t(isDarkModeEnabled ? "enterprise_sso_details.branding_light_logo_context" : "enterprise_sso_details.branding_logo_context"),
                                    allowedMimeTypes: $e9753ed18a8f396b$var$allowedMimeTypes,
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    }),
                    isDarkModeEnabled && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $3872910536d327d3$export$a7b0d73c5acc4a43,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "branding.darkLogo",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e6f10e5b5e7a477$export$2e2bcd8739ae039), {
                                    name: name,
                                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3872910536d327d3$export$96cc76c17ae5d4f1, value && $3872910536d327d3$export$f1185274f83a7a7d),
                                    value: value ?? "",
                                    actionDescription: t("enterprise_sso_details.branding_dark_logo_context"),
                                    allowedMimeTypes: $e9753ed18a8f396b$var$allowedMimeTypes,
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadDarkLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    })
                ]
            }),
            uploadLogoError && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3872910536d327d3$export$6d59db4903f20f7d, $3872910536d327d3$export$a3bc9b8ed74fc),
                children: t(isDarkModeEnabled ? "enterprise_sso_details.branding_light_logo_error" : "enterprise_sso_details.branding_logo_error", {
                    error: uploadLogoError
                })
            }),
            uploadDarkLogoError && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3872910536d327d3$export$6d59db4903f20f7d, $3872910536d327d3$export$a3bc9b8ed74fc),
                children: t("enterprise_sso_details.branding_dark_logo_error", {
                    error: uploadDarkLogoError
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $3872910536d327d3$export$6d59db4903f20f7d,
                children: t("enterprise_sso_details.connector_logo_field_description")
            })
        ]
    });
}
var $e9753ed18a8f396b$export$2e2bcd8739ae039 = $e9753ed18a8f396b$var$LogosUploader;


var $26ec30ad29fa7542$export$6d59db4903f20f7d;
var $26ec30ad29fa7542$export$9e9024ab31cc2703;
var $26ec30ad29fa7542$export$bfd64c937657f93a;
var $26ec30ad29fa7542$export$4a6dd88bada4e7d2;
$26ec30ad29fa7542$export$6d59db4903f20f7d = `_32dlKq_description`;
$26ec30ad29fa7542$export$9e9024ab31cc2703 = `_32dlKq_inlineNotification`;
$26ec30ad29fa7542$export$bfd64c937657f93a = `_32dlKq_rotating`;
$26ec30ad29fa7542$export$4a6dd88bada4e7d2 = `_32dlKq_shimmer`;


const $4042eae8e5481376$var$duplicateConnectorNameErrorCode = "single_sign_on.duplicate_connector_name";
const $4042eae8e5481376$var$dataToFormParser = (data)=>{
    const { branding: branding, connectorName: connectorName, domains: domains, syncProfile: syncProfile } = data;
    return {
        branding: branding,
        connectorName: connectorName,
        domains: domains.map((domain)=>({
                value: domain,
                id: (0, $jKlLV.generateStandardShortId)()
            })),
        syncProfile: syncProfile ? (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn : (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister
    };
};
const $4042eae8e5481376$var$formDataToSsoConnectorParser = (formData)=>{
    const { branding: branding, connectorName: connectorName, domains: domains, syncProfile: syncProfile } = formData;
    return {
        branding: branding,
        connectorName: connectorName,
        domains: domains.map(({ value: value })=>value),
        syncProfile: syncProfile === (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn
    };
};
function $4042eae8e5481376$var$Experience({ data: data, isDeleted: isDeleted, onUpdated: onUpdated, isDarkModeEnabled: isDarkModeEnabled }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const api = (0, $2ANSb.default)({
        hideErrorToast: true
    });
    const syncProfileOptions = [
        {
            value: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).OnlyAtRegister,
            title: t("enterprise_sso_details.sync_profile_option.register_only")
        },
        {
            value: (0, $f301906f72f3f4fb$export$ed9ee40b3ba009ed).EachSignIn,
            title: t("enterprise_sso_details.sync_profile_option.each_sign_in")
        }
    ];
    const formMethods = (0, $c3LX9.useForm)({
        defaultValues: $4042eae8e5481376$var$dataToFormParser(data)
    });
    const { control: control, watch: watch, setValue: setValue, setError: setError, clearErrors: clearErrors, handleSubmit: handleSubmit, register: register, formState: { defaultValues: defaultValues, isDirty: isDirty, isSubmitting: isSubmitting, errors: errors }, reset: reset } = formMethods;
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        try {
            const updatedSsoConnector = await api// TODO: @darcyYe add console test case of clean up `branding` config.
            // Only keep non-empty values since PATCH operation performs a merge scheme.
            .patch(`api/sso-connectors/${data.id}`, {
                json: (0, (/*@__PURE__*/$parcel$interopDefault($e8124284f538c6ba$exports)))($4042eae8e5481376$var$formDataToSsoConnectorParser(formData), {
                    // To overwrite the `branding` field, which is a JSONB typed column in DB.
                    emptyObjects: false
                })
            }).json();
            reset($4042eae8e5481376$var$dataToFormParser(updatedSsoConnector));
            (0, $horhC.toast).success(t("general.saved"));
            onUpdated(updatedSsoConnector);
        } catch (error) {
            if (error instanceof (0, $d2Ivz.HTTPError)) {
                const { response: response } = error;
                const metadata = await response.clone().json();
                /**
           * Should render invalid domains:
           * - show `error` tag for forbidden domains
           * - show `info` tag for duplicated domains
           *
           * Also manually passed the returned error message to `setError` to show the error message in-place.
           */ if ([
                    (0, $ac57096d4b8a77dc$export$a5d922e87633d379),
                    (0, $ac57096d4b8a77dc$export$87bccd4692227778),
                    (0, $ac57096d4b8a77dc$export$e4db90811da8f94)
                ].includes(metadata.code)) {
                    setValue("domains", watch("domains").map((domain)=>({
                            ...domain,
                            ...(0, $5CQIb.conditional)(metadata.data.data.includes(domain.value) && {
                                status: "info"
                            })
                        })), {
                        shouldDirty: true
                    });
                    setError("domains", {
                        type: "custom",
                        message: metadata.message
                    });
                }
                if ($4042eae8e5481376$var$duplicateConnectorNameErrorCode === metadata.code) setError("connectorName", {
                    type: "custom",
                    message: metadata.message
                });
            }
        }
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c3LX9.FormProvider), {
        ...formMethods,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.general_settings_title",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                isRequired: true,
                                title: "enterprise_sso_details.connector_name_field_name",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("connectorName", {
                                        required: true
                                    }),
                                    error: errors.connectorName?.message
                                })
                            }),
                            !defaultValues?.domains?.length && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                                className: $26ec30ad29fa7542$export$9e9024ab31cc2703,
                                severity: "alert",
                                children: t("enterprise_sso_details.configure_domain_field_info_text")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                                isRequired: true,
                                title: "enterprise_sso_details.email_domain_field_name",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                        name: "domains",
                                        control: control,
                                        rules: {
                                            validate: (value)=>{
                                                if (value.length === 0) return t("enterprise_sso_details.email_domain_field_required");
                                                const { errorMessage: errorMessage } = (0, $17c7cba9b45d283e$export$929a2b2dcadf379e)(value);
                                                if (errorMessage) return errorMessage;
                                                return true;
                                            }
                                        },
                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $001018729eb4381f$export$2e2bcd8739ae039), {
                                                values: value,
                                                // Per previous error handling on submitting, error message will be truthy.
                                                error: errors.domains?.message,
                                                placeholder: "enterprise_sso_details.email_domain_field_placeholder",
                                                onChange: onChange
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $26ec30ad29fa7542$export$6d59db4903f20f7d,
                                        children: t("enterprise_sso_details.email_domain_field_description")
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "enterprise_sso_details.sync_profile_field_name",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                    name: "syncProfile",
                                    control: control,
                                    rules: {
                                        required: true
                                    },
                                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                                            options: syncProfileOptions,
                                            value: value,
                                            onChange: onChange
                                        })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.custom_branding_title",
                        description: "enterprise_sso_details.custom_branding_description",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "enterprise_sso_details.display_name_field_name",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("branding.displayName"),
                                    placeholder: data.name,
                                    error: errors.branding?.displayName?.message
                                })
                            }),
                            isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "enterprise_sso_details.connector_logo_field_name",
                                headlineSpacing: "large",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e9753ed18a8f396b$export$2e2bcd8739ae039), {
                                    isDarkModeEnabled: isDarkModeEnabled
                                })
                            }) : /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                        title: "enterprise_sso_details.branding_logo_field_name",
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                            ...register("branding.logo", {
                                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                                            }),
                                            error: errors.branding?.logo?.message,
                                            placeholder: t("enterprise_sso_details.branding_logo_field_placeholder")
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                        title: "enterprise_sso_details.branding_dark_logo_field_name",
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                            ...register("branding.darkLogo", {
                                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                                            }),
                                            error: errors.branding?.darkLogo?.message,
                                            placeholder: t("enterprise_sso_details.branding_dark_logo_field_placeholder")
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleted && isDirty
            })
        ]
    });
}
var $4042eae8e5481376$export$2e2bcd8739ae039 = $4042eae8e5481376$var$Experience;



var $9zeGj = parcelRequire("9zeGj");

var $d871A = parcelRequire("d871A");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("j6dBR");
var $5Je5u = parcelRequire("5Je5u");

var $eCoWV = parcelRequire("eCoWV");





const $8f805b55aacaa293$var$ssoConnectorGuides = {
    [(0, $5Je5u.SsoProviderName).SAML]: (0, $eCoWV.lazy)(async ()=>(parcelRequire("hdMZc"))),
    [(0, $5Je5u.SsoProviderName).OIDC]: (0, $eCoWV.lazy)(async ()=>(parcelRequire("ds8sa"))),
    [(0, $5Je5u.SsoProviderName).AZURE_AD]: (0, $eCoWV.lazy)(async ()=>(parcelRequire("lrnE2"))),
    [(0, $5Je5u.SsoProviderName).GOOGLE_WORKSPACE]: (0, $eCoWV.lazy)(async ()=>(parcelRequire("jCYzn"))),
    [(0, $5Je5u.SsoProviderName).OKTA]: (0, $eCoWV.lazy)(async ()=>(parcelRequire("clonT")))
};
var $8f805b55aacaa293$export$2e2bcd8739ae039 = $8f805b55aacaa293$var$ssoConnectorGuides;



var $aMkCU = parcelRequire("aMkCU");

var $d0Zvy = parcelRequire("d0Zvy");

var $1Iq4D = parcelRequire("1Iq4D");

var $djktV = parcelRequire("djktV");
var $11c09d0c454c4957$export$a7db06668cad9adb;
var $11c09d0c454c4957$export$bfd64c937657f93a;
var $11c09d0c454c4957$export$4a6dd88bada4e7d2;
$11c09d0c454c4957$export$a7db06668cad9adb = `-ViIsG_content`;
$11c09d0c454c4957$export$bfd64c937657f93a = `-ViIsG_rotating`;
$11c09d0c454c4957$export$4a6dd88bada4e7d2 = `-ViIsG_shimmer`;


function $dcf11349e3c601b3$var$SsoGuide({ ssoConnector: ssoConnector, className: className }) {
    if (!ssoConnector) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $djktV.default), {});
    const { providerName: providerName } = ssoConnector;
    const Guide = (0, $8f805b55aacaa293$export$2e2bcd8739ae039)[providerName];
    if (!Guide) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $djktV.default), {});
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aMkCU.default), {
        ssoConnector: ssoConnector,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($11c09d0c454c4957$export$a7db06668cad9adb, className),
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d871A.MDXProvider), {
                components: {
                    a: ({ children: children, ...props })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            ...props,
                            targetBlank: true,
                            children: children
                        })
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eCoWV.Suspense), {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)(Guide, {})
                })
            })
        })
    });
}
var $dcf11349e3c601b3$export$2e2bcd8739ae039 = $dcf11349e3c601b3$var$SsoGuide;


var $36b5a52d8d37410a$export$34e0f9847d4c02dd;
var $36b5a52d8d37410a$export$db3c28d99448dcff;
var $36b5a52d8d37410a$export$20b6fe5c276910c1;
var $36b5a52d8d37410a$export$bfd64c937657f93a;
var $36b5a52d8d37410a$export$4a6dd88bada4e7d2;
$36b5a52d8d37410a$export$34e0f9847d4c02dd = `_6rYuna_container`;
$36b5a52d8d37410a$export$db3c28d99448dcff = `_6rYuna_logo`;
$36b5a52d8d37410a$export$20b6fe5c276910c1 = `_6rYuna_readme`;
$36b5a52d8d37410a$export$bfd64c937657f93a = `_6rYuna_rotating`;
$36b5a52d8d37410a$export$4a6dd88bada4e7d2 = `_6rYuna_shimmer`;


const $fbee01ee803ba367$var$enterpriseSsoPathname = "/enterprise-sso";
const $fbee01ee803ba367$var$getSsoConnectorDetailsPathname = (ssoConnectorId, tab)=>`${$fbee01ee803ba367$var$enterpriseSsoPathname}/${ssoConnectorId}/${tab}`;
function $fbee01ee803ba367$var$EnterpriseSsoConnectorDetails() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { ssoConnectorId: ssoConnectorId, tab: tab } = (0, $9X5Bp.useParams)();
    const { mutate: mutateGlobal } = (0, $4Korf.useSWRConfig)();
    const [isDeleted, setIsDeleted] = (0, $eCoWV.useState)(false);
    const [isReadmeOpen, setIsReadmeOpen] = (0, $eCoWV.useState)(false);
    const { isLoading: isUserAssetServiceLoading } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const { data: signInExperience, isLoading: isSignInExperienceLoading } = (0, $2mi28.default)("api/sign-in-exp");
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: ssoConnector, error: requestError, mutate: mutate, isLoading: isSsoConnectorLoading } = (0, $2mi28.default)(ssoConnectorId && `api/sso-connectors/${ssoConnectorId}`, {
        keepPreviousData: true
    });
    const isLoading = isSsoConnectorLoading || isUserAssetServiceLoading || isSignInExperienceLoading;
    const api = (0, $2ANSb.default)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [isDeleteAlertOpen, setIsDeleteAlertOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const isDarkModeEnabled = signInExperience?.color.isDarkModeEnabled ?? false;
    (0, $eCoWV.useEffect)(()=>{
        setIsDeleteAlertOpen(false);
    }, [
        pathname
    ]);
    const handleDelete = async ()=>{
        if (!ssoConnectorId || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/sso-connectors/${ssoConnectorId}`).json();
            setIsDeleted(true);
            (0, $horhC.toast).success(t("enterprise_sso_details.enterprise_sso_deleted"));
            await mutateGlobal("api/sso-connectors");
            navigate($fbee01ee803ba367$var$enterpriseSsoPathname, {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    if (!ssoConnectorId) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: $fbee01ee803ba367$var$enterpriseSsoPathname,
        backLinkTitle: "enterprise_sso_details.back_to_sso_connectors",
        error: requestError,
        onRetry: ()=>{
            mutate();
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "enterprise_sso_details.page_title"
            }),
            isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3f9b15e0b0084c45$export$2e2bcd8739ae039), {}),
            !isLoading && ssoConnector && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a131401853bc7959$export$2e2bcd8739ae039), {
                            className: $36b5a52d8d37410a$export$db3c28d99448dcff,
                            containerClassName: $36b5a52d8d37410a$export$34e0f9847d4c02dd,
                            data: (0, $apgZ7.pick)(ssoConnector, "providerLogo", "providerLogoDark", "branding")
                        }),
                        title: ssoConnector.connectorName,
                        primaryTag: ssoConnector.name,
                        identifier: {
                            name: "ID",
                            value: ssoConnector.id
                        },
                        additionalActionButton: {
                            title: "enterprise_sso_details.check_connection_guide",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7529b38878187ba2$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsReadmeOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                type: "danger",
                                title: "general.delete",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteAlertOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b42f3bf1cd82d7$export$2e2bcd8739ae039), {
                        title: "enterprise_sso_details.readme_drawer_title",
                        subtitle: "enterprise_sso_details.readme_drawer_subtitle",
                        isOpen: isReadmeOpen,
                        onClose: ()=>{
                            setIsReadmeOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dcf11349e3c601b3$export$2e2bcd8739ae039), {
                            ssoConnector: ssoConnector,
                            className: $36b5a52d8d37410a$export$20b6fe5c276910c1
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: $fbee01ee803ba367$var$getSsoConnectorDetailsPathname(ssoConnectorId, (0, $emGEN.EnterpriseSsoDetailsTabs).Connection),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "enterprise_sso_details.tab_connection"
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: $fbee01ee803ba367$var$getSsoConnectorDetailsPathname(ssoConnectorId, (0, $emGEN.EnterpriseSsoDetailsTabs).Experience),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "enterprise_sso_details.tab_experience"
                                })
                            })
                        ]
                    }),
                    tab === (0, $emGEN.EnterpriseSsoDetailsTabs).Experience && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4042eae8e5481376$export$2e2bcd8739ae039), {
                        data: ssoConnector,
                        isDeleted: isDeleted,
                        isDarkModeEnabled: isDarkModeEnabled,
                        onUpdated: ()=>{
                            mutate();
                        }
                    }),
                    tab === (0, $emGEN.EnterpriseSsoDetailsTabs).Connection && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $db4c53c177c2a5ad$export$2e2bcd8739ae039), {
                        data: ssoConnector,
                        isDeleted: isDeleted,
                        onUpdated: (ssoConnector)=>{
                            mutate(ssoConnector);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                        isOpen: isDeleteAlertOpen,
                        isLoading: isDeleting,
                        confirmButtonText: "general.delete",
                        title: "enterprise_sso_details.delete_confirm_modal_title",
                        onCancel: async ()=>{
                            setIsDeleteAlertOpen(false);
                        },
                        onConfirm: handleDelete,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "enterprise_sso_details.delete_confirm_modal_content"
                        })
                    })
                ]
            })
        ]
    });
}
var $fbee01ee803ba367$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($fbee01ee803ba367$var$EnterpriseSsoConnectorDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $6957028707bb0f90$var$SvgCheckDemoDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12,
                y: 6,
                width: 20,
                height: 36,
                rx: 4,
                fill: "url(#paint0_linear_4272_17340)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 22,
                cy: 38,
                r: 1.5,
                stroke: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M19 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
                fill: "#5938A3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.64,
                d: "M42 24c0 1.533-5.373 7-12 7s-12-5.467-12-7c0-1.533 5.373-7 12-7 1.324 0 2.598.218 3.79.58A15.75 15.75 0 0 1 37 18.973c3.028 1.726 5 4.099 5 5.027Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 30,
                cy: 24,
                r: 4,
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 33,
                cy: 24,
                r: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 30,
                y: 11,
                width: 1,
                height: 4,
                rx: 0.5,
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.56,
                y: 12.232,
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "rotate(45 36.56 12.232)",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "scale(1 -1) rotate(45 32.314 24.177)",
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_4272_17340",
                    x1: 15.438,
                    y1: 37.125,
                    x2: 36.732,
                    y2: 24.47,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $6957028707bb0f90$export$2e2bcd8739ae039 = $6957028707bb0f90$var$SvgCheckDemoDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $c51d4af7658dcdcf$var$SvgCheckDemo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12,
                y: 6,
                width: 20,
                height: 36,
                rx: 4,
                fill: "url(#paint0_linear_1555_9124)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 22,
                cy: 38,
                r: 1.5,
                stroke: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M19 9a1 1 0 0 1 1-1h4a1 1 0 1 1 0 2h-4a1 1 0 0 1-1-1Z",
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.64,
                d: "M42 24c0 1.533-5.373 7-12 7s-12-5.467-12-7c0-1.533 5.373-7 12-7 1.324 0 2.598.218 3.79.58A15.75 15.75 0 0 1 37 18.973c3.028 1.726 5 4.099 5 5.027Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 30,
                cy: 24,
                r: 4,
                fill: "#302F38"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 33,
                cy: 24,
                r: 2,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 30,
                y: 11,
                width: 1,
                height: 4,
                rx: 0.5,
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.56,
                y: 12.232,
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "rotate(45 36.56 12.232)",
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 1,
                height: 4,
                rx: 0.5,
                transform: "scale(1 -1) rotate(45 32.314 24.177)",
                fill: "#FFFBF7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_1555_9124",
                    x1: 15.438,
                    y1: 37.125,
                    x2: 36.732,
                    y2: 24.47,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FAABFF"
                        })
                    ]
                })
            })
        ]
    });
var $c51d4af7658dcdcf$export$2e2bcd8739ae039 = $c51d4af7658dcdcf$var$SvgCheckDemo;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $b210842425d30b44$var$SvgCreateRoleDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_1820_100266)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#3A3B59"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_1820_100266)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 22.709,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.47 26.56a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .851-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.689-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#CABEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_1820_100266)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1820_100266",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1820_100266",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_1820_100266",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $b210842425d30b44$export$2e2bcd8739ae039 = $b210842425d30b44$var$SvgCreateRoleDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $4c986f5d0803bb65$var$SvgCreateRole = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_1724_99135)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#F3EFFA"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_1724_99135)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 22.709,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.47 26.56a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .851-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.689-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#7958FF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_1724_99135)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1724_99135",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1724_99135",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_1724_99135",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $4c986f5d0803bb65$export$2e2bcd8739ae039 = $4c986f5d0803bb65$var$SvgCreateRole;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $e587337efea909e1$var$SvgSocialDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m26 24 3-6m-3 6h2.942a4 4 0 0 0 3.255-1.675l2.606-3.65A4 4 0 0 1 38.06 17H41m-15 7v3m0 0h4.735a4 4 0 0 1 3.43 1.942l.67 1.116A4 4 0 0 0 38.265 32H41m-15-5v5M24 24V9m0 15h-3.718a4 4 0 0 1-2.325-.745l-4.914-3.51A4 4 0 0 0 10.718 19H10m14 5v14m-8-11-4.05 2.43a4 4 0 0 1-2.058.57H7",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 24,
                r: 12,
                fill: "url(#paint0_linear_4272_17343)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_4272_17343",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 12,
                y: 12,
                width: 24,
                height: 24,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 24,
                    cy: 24,
                    r: 12,
                    fill: "url(#paint1_linear_4272_17343)"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_4272_17343)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M23.508 16a.8.8 0 0 0-.782.63l-.268 1.231a.87.87 0 0 1-.553.617c-.112.042-.221.088-.33.136a.871.871 0 0 1-.828-.045l-1.056-.679a.8.8 0 0 0-.998.108l-.695.695a.8.8 0 0 0-.108.998l.68 1.056c.158.248.165.56.044.829a5.883 5.883 0 0 0-.136.329.87.87 0 0 1-.617.553l-1.23.268a.8.8 0 0 0-.631.782v.984a.8.8 0 0 0 .63.782l1.231.268a.87.87 0 0 1 .617.553c.042.112.088.221.136.33a.871.871 0 0 1-.045.828l-.679 1.056a.8.8 0 0 0 .108.998l.695.695a.8.8 0 0 0 .998.108l1.056-.68a.871.871 0 0 1 .829-.044c.108.048.217.094.329.136a.87.87 0 0 1 .553.617l.268 1.23a.8.8 0 0 0 .782.631h.984a.8.8 0 0 0 .782-.63l.268-1.231a.87.87 0 0 1 .553-.617c.112-.042.221-.088.33-.136a.871.871 0 0 1 .828.045l1.056.679a.8.8 0 0 0 .998-.108l.695-.695a.8.8 0 0 0 .108-.998l-.68-1.056a.871.871 0 0 1-.044-.829c.048-.108.094-.217.136-.329a.87.87 0 0 1 .617-.553l1.23-.268a.8.8 0 0 0 .631-.782v-.984a.8.8 0 0 0-.63-.782l-1.231-.268a.87.87 0 0 1-.617-.553 5.883 5.883 0 0 0-.136-.33.871.871 0 0 1 .045-.828l.679-1.056a.8.8 0 0 0-.108-.998l-.695-.695a.8.8 0 0 0-.998-.108l-1.056.68a.871.871 0 0 1-.829.044 5.883 5.883 0 0 0-.329-.136.87.87 0 0 1-.553-.617l-.268-1.23a.8.8 0 0 0-.782-.631h-.984ZM24 20.571a3.429 3.429 0 1 1 0 6.858 3.429 3.429 0 0 1 0-6.858Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 17,
                r: 2,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 3,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 7,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 41,
                cy: 32,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 30,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 41,
                r: 3,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_4272_17343",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_4272_17343",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $e587337efea909e1$export$2e2bcd8739ae039 = $e587337efea909e1$var$SvgSocialDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $124892a6b333f6ef$var$SvgSocial = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 48,
                height: 48,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m26 24 3-6m-3 6h2.942a4 4 0 0 0 3.255-1.675l2.606-3.65A4 4 0 0 1 38.06 17H41m-15 7v3m0 0h4.735a4 4 0 0 1 3.43 1.942l.67 1.116A4 4 0 0 0 38.265 32H41m-15-5v5M24 24V9m0 15h-3.718a4 4 0 0 1-2.325-.745l-4.914-3.51A4 4 0 0 0 10.718 19H10m14 5v14m-8-11-4.05 2.43a4 4 0 0 1-2.058.57H7",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 24,
                r: 12,
                fill: "url(#paint0_linear_1555_9204)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_1555_9204",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 12,
                y: 12,
                width: 24,
                height: 24,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 24,
                    cy: 24,
                    r: 12,
                    fill: "url(#paint1_linear_1555_9204)"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_1555_9204)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M23.508 16a.8.8 0 0 0-.782.63l-.268 1.231a.87.87 0 0 1-.553.617c-.112.042-.221.088-.33.136a.871.871 0 0 1-.828-.045l-1.056-.679a.8.8 0 0 0-.998.108l-.695.695a.8.8 0 0 0-.108.998l.68 1.056c.158.248.165.56.044.829a5.883 5.883 0 0 0-.136.329.87.87 0 0 1-.617.553l-1.23.268a.8.8 0 0 0-.631.782v.984a.8.8 0 0 0 .63.782l1.231.268a.87.87 0 0 1 .617.553c.042.112.088.221.136.33a.871.871 0 0 1-.045.828l-.679 1.056a.8.8 0 0 0 .108.998l.695.695a.8.8 0 0 0 .998.108l1.056-.68a.871.871 0 0 1 .829-.044c.108.048.217.094.329.136a.87.87 0 0 1 .553.617l.268 1.23a.8.8 0 0 0 .782.631h.984a.8.8 0 0 0 .782-.63l.268-1.231a.87.87 0 0 1 .553-.617c.112-.042.221-.088.33-.136a.871.871 0 0 1 .828.045l1.056.679a.8.8 0 0 0 .998-.108l.695-.695a.8.8 0 0 0 .108-.998l-.68-1.056a.871.871 0 0 1-.044-.829c.048-.108.094-.217.136-.329a.87.87 0 0 1 .617-.553l1.23-.268a.8.8 0 0 0 .631-.782v-.984a.8.8 0 0 0-.63-.782l-1.231-.268a.87.87 0 0 1-.617-.553 5.883 5.883 0 0 0-.136-.33.871.871 0 0 1 .045-.828l.679-1.056a.8.8 0 0 0-.108-.998l-.695-.695a.8.8 0 0 0-.998-.108l-1.056.68a.871.871 0 0 1-.829.044 5.883 5.883 0 0 0-.329-.136.87.87 0 0 1-.553-.617l-.268-1.23a.8.8 0 0 0-.782-.631h-.984ZM24 20.571a3.429 3.429 0 1 1 0 6.858 3.429 3.429 0 0 1 0-6.858Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 42,
                cy: 17,
                r: 2,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 3,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 7,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 41,
                cy: 32,
                r: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 30,
                r: 3,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 24,
                cy: 41,
                r: 3,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_1555_9204",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_1555_9204",
                        x1: 16.125,
                        y1: 32.75,
                        x2: 32.25,
                        y2: 15.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAABFF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $124892a6b333f6ef$export$2e2bcd8739ae039 = $124892a6b333f6ef$var$SvgSocial;





var $a0Ubj = parcelRequire("a0Ubj");
parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $V1X8c = parcelRequire("V1X8c");

var $eEyjP = parcelRequire("eEyjP");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $3MzPh = parcelRequire("3MzPh");

var $1Iq4D = parcelRequire("1Iq4D");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");


var $93h5F = parcelRequire("93h5F");
var $dba5720959927384$export$34e0f9847d4c02dd;
var $dba5720959927384$export$a7db06668cad9adb;
var $dba5720959927384$export$6d59db4903f20f7d;
var $dba5720959927384$export$5c452ff88e35e47d;
var $dba5720959927384$export$9c30223ca0a664fb;
var $dba5720959927384$export$bfd64c937657f93a;
var $dba5720959927384$export$4a6dd88bada4e7d2;
var $dba5720959927384$export$fb184b623420d9be;
$dba5720959927384$export$34e0f9847d4c02dd = `YU8oZa_container`;
$dba5720959927384$export$a7db06668cad9adb = `YU8oZa_content`;
$dba5720959927384$export$6d59db4903f20f7d = `YU8oZa_description`;
$dba5720959927384$export$5c452ff88e35e47d = `YU8oZa_image`;
$dba5720959927384$export$9c30223ca0a664fb = `YU8oZa_link`;
$dba5720959927384$export$bfd64c937657f93a = `YU8oZa_rotating`;
$dba5720959927384$export$4a6dd88bada4e7d2 = `YU8oZa_shimmer`;
$dba5720959927384$export$fb184b623420d9be = `YU8oZa_title`;


function $599e042d9d033cfa$var$DevelopmentTenantNotification() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const theme = (0, $93h5F.default)();
    const Image = theme === (0, $bhvxB.Theme).Light ? (0, $2f1758de09de54a0$export$2e2bcd8739ae039) : (0, $478091f8c43e559f$export$2e2bcd8739ae039);
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $dba5720959927384$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(Image, {
                className: $dba5720959927384$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $dba5720959927384$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $dba5720959927384$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                    href: (0, $o53Y2.pricingLink),
                                    targetBlank: "noopener",
                                    className: $dba5720959927384$export$9c30223ca0a664fb
                                })
                            },
                            children: t("tenants.dev_tenant_notification.title")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $dba5720959927384$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.dev_tenant_notification.description"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                title: "general.learn_more",
                type: "outline",
                size: "large",
                href: getDocumentationUrl((0, $o53Y2.envTagsFeatureLink)),
                targetBlank: "noopener"
            })
        ]
    });
}
var $599e042d9d033cfa$export$2e2bcd8739ae039 = $599e042d9d033cfa$var$DevelopmentTenantNotification;


var $366716c8586b0940$export$ed32643c9618a26;
var $366716c8586b0940$export$bbea856fdb3e3c5f;
var $366716c8586b0940$export$aa3e815946b80764;
var $366716c8586b0940$export$2839a4a39e4d1879;
var $366716c8586b0940$export$34e0f9847d4c02dd;
var $366716c8586b0940$export$85fc379452d91af0;
var $366716c8586b0940$export$38e42c68cf43b5d4;
var $366716c8586b0940$export$1ca1ec8b29a4ce27;
var $366716c8586b0940$export$bfd64c937657f93a;
var $366716c8586b0940$export$d3257a3edf3cda05;
var $366716c8586b0940$export$4a6dd88bada4e7d2;
var $366716c8586b0940$export$c96745152eb2740f;
var $366716c8586b0940$export$fb184b623420d9be;
$366716c8586b0940$export$ed32643c9618a26 = `vUugRG_borderBox`;
$366716c8586b0940$export$bbea856fdb3e3c5f = `vUugRG_buttons`;
$366716c8586b0940$export$aa3e815946b80764 = `vUugRG_card`;
$366716c8586b0940$export$2839a4a39e4d1879 = `vUugRG_columnWrapper`;
$366716c8586b0940$export$34e0f9847d4c02dd = `vUugRG_container`;
$366716c8586b0940$export$85fc379452d91af0 = `vUugRG_grid`;
$366716c8586b0940$export$38e42c68cf43b5d4 = `vUugRG_header`;
$366716c8586b0940$export$1ca1ec8b29a4ce27 = `vUugRG_icon`;
$366716c8586b0940$export$bfd64c937657f93a = `vUugRG_rotating`;
$366716c8586b0940$export$d3257a3edf3cda05 = `vUugRG_rowWrapper`;
$366716c8586b0940$export$4a6dd88bada4e7d2 = `vUugRG_shimmer`;
$366716c8586b0940$export$c96745152eb2740f = `vUugRG_subtitle`;
$366716c8586b0940$export$fb184b623420d9be = `vUugRG_title`;


const $434afc4a4409c455$var$icons = {
    [(0, $bhvxB.Theme).Light]: {
        PreviewIcon: (0, $c51d4af7658dcdcf$export$2e2bcd8739ae039),
        SocialIcon: (0, $124892a6b333f6ef$export$2e2bcd8739ae039),
        RbacIcon: (0, $4c986f5d0803bb65$export$2e2bcd8739ae039)
    },
    [(0, $bhvxB.Theme).Dark]: {
        PreviewIcon: (0, $6957028707bb0f90$export$2e2bcd8739ae039),
        SocialIcon: (0, $e587337efea909e1$export$2e2bcd8739ae039),
        RbacIcon: (0, $b210842425d30b44$export$2e2bcd8739ae039)
    }
};
function $434afc4a4409c455$var$GetStarted() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const [selectedGuide, setSelectedGuide] = (0, $eCoWV.useState)();
    const { getStructuredAppGuideMetadata: getStructuredAppGuideMetadata } = (0, $461d44ddf3f0b8fb$export$6b80cd72646f4cab)();
    const apiGuideMetadata = (0, $461d44ddf3f0b8fb$export$6bb65ec2faabc0af)();
    const [showCreateAppForm, setShowCreateAppForm] = (0, $eCoWV.useState)(false);
    const [showCreateApiForm, setShowCreateApiForm] = (0, $eCoWV.useState)(false);
    // The number of visible guide cards to show in one row per the current screen width
    const [visibleCardCount, setVisibleCardCount] = (0, $eCoWV.useState)(4);
    const containerRef = (0, $eCoWV.useRef)(null);
    const theme = (0, $93h5F.default)();
    const { PreviewIcon: PreviewIcon, SocialIcon: SocialIcon, RbacIcon: RbacIcon } = $434afc4a4409c455$var$icons[theme];
    (0, $c0b37dd2da18e290$export$2e2bcd8739ae039)(()=>{
        const containerWidth = containerRef.current?.clientWidth ?? 0;
        // Responsive breakpoints (1080, 680px) are defined in `GuideCardGroup` component SCSS,
        // and we need to keep them consistent.
        setVisibleCardCount(containerWidth > 1080 ? 4 : containerWidth > 680 ? 3 : 2);
    });
    /**
   * Slice the guide metadata as we only need to show 1 row of guide cards in get-started page
   */ const featuredAppGuides = (0, $eCoWV.useMemo)(()=>getStructuredAppGuideMetadata().featured.slice(0, visibleCardCount), [
        visibleCardCount,
        getStructuredAppGuideMetadata
    ]);
    const onClickAppGuide = (0, $eCoWV.useCallback)((data)=>{
        setShowCreateAppForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateAppForm = (0, $eCoWV.useCallback)((newApp)=>{
        if (newApp && selectedGuide) {
            navigate(`/applications/${newApp.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateAppForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    const onClickApiGuide = (0, $eCoWV.useCallback)((data)=>{
        setShowCreateApiForm(true);
        setSelectedGuide(data);
    }, []);
    const onCloseCreateApiForm = (0, $eCoWV.useCallback)((newResource)=>{
        if (newResource && selectedGuide) {
            navigate(`/api-resources/${newResource.id}/guide/${selectedGuide.id}`, {
                replace: true
            });
            return;
        }
        setShowCreateApiForm(false);
        setSelectedGuide(undefined);
    }, [
        navigate,
        selectedGuide
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $366716c8586b0940$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "get_started.page_title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $366716c8586b0940$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$fb184b623420d9be,
                        children: t("get_started.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$c96745152eb2740f,
                        children: t("get_started.subtitle")
                    })
                ]
            }),
            (0, $V1X8c.isCloud) && isDevTenant && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $599e042d9d033cfa$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $366716c8586b0940$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$fb184b623420d9be,
                        children: t("get_started.develop.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                        ref: containerRef,
                        hasCardBorder: true,
                        hasCardButton: true,
                        guides: featuredAppGuides,
                        onClickGuide: onClickAppGuide
                    }),
                    selectedGuide?.target !== "API" && showCreateAppForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5193b988a4e9b907$export$2e2bcd8739ae039), {
                        defaultCreateType: selectedGuide?.target,
                        defaultCreateFrameworkName: selectedGuide?.name,
                        onClose: onCloseCreateAppForm
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        to: "/applications/create",
                        children: t("get_started.view_all")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $366716c8586b0940$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$fb184b623420d9be,
                        children: t("get_started.customize.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $366716c8586b0940$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $366716c8586b0940$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $366716c8586b0940$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)(PreviewIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $366716c8586b0940$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$fb184b623420d9be,
                                                children: t("get_started.customize.preview.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$c96745152eb2740f,
                                                children: t("get_started.customize.preview.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($366716c8586b0940$export$d3257a3edf3cda05, $366716c8586b0940$export$bbea856fdb3e3c5f),
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                                        title: "get_started.customize.continue_customizing",
                                        href: "/sign-in-experience"
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                                        title: "get_started.customize.try_now",
                                        href: new URL("/demo-app", tenantEndpoint).href,
                                        targetBlank: "noopener"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $366716c8586b0940$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $366716c8586b0940$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $366716c8586b0940$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)(SocialIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $366716c8586b0940$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$fb184b623420d9be,
                                                children: t("get_started.customize.connector.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$c96745152eb2740f,
                                                children: t("get_started.customize.connector.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                                title: "get_started.customize.add_more",
                                href: `/connectors/${(0, $emGEN.ConnectorsTabs).Social}`
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $366716c8586b0940$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$fb184b623420d9be,
                        children: t("get_started.secure.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460401404e060952$export$2e2bcd8739ae039), {
                        ref: containerRef,
                        hasCardBorder: true,
                        hasCardButton: true,
                        guides: apiGuideMetadata,
                        onClickGuide: onClickApiGuide
                    }),
                    showCreateApiForm && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $691f89219d7e5395$export$2e2bcd8739ae039), {
                        onClose: onCloseCreateApiForm
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        to: "/api-resources/create",
                        children: t("get_started.view_all")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $366716c8586b0940$export$aa3e815946b80764,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $366716c8586b0940$export$fb184b623420d9be,
                        children: t("get_started.manage.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $366716c8586b0940$export$ed32643c9618a26,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $366716c8586b0940$export$d3257a3edf3cda05,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $366716c8586b0940$export$1ca1ec8b29a4ce27,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)(RbacIcon, {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $366716c8586b0940$export$2839a4a39e4d1879,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$fb184b623420d9be,
                                                children: t("get_started.manage.rbac.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $366716c8586b0940$export$c96745152eb2740f,
                                                children: t("get_started.manage.rbac.subtitle")
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.LinkButton), {
                                title: "get_started.manage.create_roles",
                                href: "/roles"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $434afc4a4409c455$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($434afc4a4409c455$var$GetStarted);



var $9zeGj = parcelRequire("9zeGj");

var $gvHPO = parcelRequire("gvHPO");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9XAkT = parcelRequire("9XAkT");

var $4W0F0 = parcelRequire("4W0F0");

var $5a66b83f51ec875b$export$2adf6238a2d0dafa;
var $5a66b83f51ec875b$export$bfd64c937657f93a;
var $5a66b83f51ec875b$export$4a6dd88bada4e7d2;
$5a66b83f51ec875b$export$2adf6238a2d0dafa = `d6tymq_notification`;
$5a66b83f51ec875b$export$bfd64c937657f93a = `d6tymq_rotating`;
$5a66b83f51ec875b$export$4a6dd88bada4e7d2 = `d6tymq_shimmer`;


/** Displays an inline notification that explains the paywall and provides a clickable action button which links to the subscription page. */ function $44f9d86084b206ab$var$InlineUpsell({ className: className, for: forFeature, actionButtonText: actionButtonText }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.upsell.paywall"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        hasIcon: false,
        severity: "info",
        action: actionButtonText ?? "upsell.compare_plans",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($5a66b83f51ec875b$export$2adf6238a2d0dafa, className),
        onClick: ()=>{
            navigate("/tenant-settings/subscription");
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
            components: {
                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
            },
            children: t(forFeature)
        })
    });
}
var $44f9d86084b206ab$export$2e2bcd8739ae039 = $44f9d86084b206ab$var$InlineUpsell;




var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");


var $5P1O9 = parcelRequire("5P1O9");

var $2ANSb = parcelRequire("2ANSb");



var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $bc43c96067ae4a7d$var$SvgFactorBackupCode = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 16.667H4.167a.833.833 0 0 1-.834-.834V4.167a.833.833 0 0 1 .834-.834h4.166v2.5a2.5 2.5 0 0 0 2.5 2.5h2.5v.834a.833.833 0 1 0 1.667 0V7.45a1.09 1.09 0 0 0-.05-.225V7.15a.893.893 0 0 0-.158-.233l-5-5a.892.892 0 0 0-.234-.159.267.267 0 0 0-.075 0 .733.733 0 0 0-.275-.091H4.167a2.5 2.5 0 0 0-2.5 2.5v11.666a2.5 2.5 0 0 0 2.5 2.5H10a.833.833 0 0 0 0-1.666Zm0-12.159 2.158 2.159h-1.325A.833.833 0 0 1 10 5.833V4.508ZM5.833 6.667a.833.833 0 1 0 0 1.666h.834a.833.833 0 1 0 0-1.666h-.834Zm12.259 10.241-.975-.966a2.867 2.867 0 0 0-.45-3.442 2.908 2.908 0 0 0-5 2.075 2.883 2.883 0 0 0 4.275 2.542l.966.975a.834.834 0 0 0 1.366-.272.833.833 0 0 0-.182-.912ZM15.45 15.45a1.283 1.283 0 0 1-1.758 0 1.25 1.25 0 0 1 .008-1.758c.222-.221.52-.35.833-.359a1.223 1.223 0 0 1 1.3 1.242 1.25 1.25 0 0 1-.383.875ZM10.833 10h-5a.834.834 0 0 0 0 1.667h5a.833.833 0 0 0 0-1.667Zm-1.666 5a.833.833 0 1 0 0-1.667H5.833a.833.833 0 1 0 0 1.667h3.334Z",
            fill: "currentColor"
        })
    });
var $bc43c96067ae4a7d$export$2e2bcd8739ae039 = $bc43c96067ae4a7d$var$SvgFactorBackupCode;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f1501c8cedf3c602$var$SvgFactorTotp = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M17.5 1.667h-5a.833.833 0 0 0 0 1.666h4.167V7.5a.833.833 0 0 0 1.666 0v-5a.833.833 0 0 0-.833-.833Zm0 10a.833.833 0 0 0-.833.833v4.167H12.5a.833.833 0 0 0 0 1.666h5a.833.833 0 0 0 .833-.833v-5a.833.833 0 0 0-.833-.833ZM10 5a2.5 2.5 0 0 0-2.5 2.5v.833A1.667 1.667 0 0 0 5.833 10v3.333A1.667 1.667 0 0 0 7.5 15h5a1.667 1.667 0 0 0 1.667-1.667V10A1.666 1.666 0 0 0 12.5 8.333V7.5A2.5 2.5 0 0 0 10 5Zm-.833 2.5a.833.833 0 0 1 1.666 0v.833H9.167V7.5Zm3.333 5.833h-5V10h5v3.333Zm-10-5a.833.833 0 0 0 .833-.833V3.333H7.5a.833.833 0 1 0 0-1.666h-5a.833.833 0 0 0-.833.833v5a.833.833 0 0 0 .833.833Zm5 8.334H3.333V12.5a.833.833 0 1 0-1.666 0v5a.833.833 0 0 0 .833.833h5a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $f1501c8cedf3c602$export$2e2bcd8739ae039 = $f1501c8cedf3c602$var$SvgFactorTotp;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $6bc9de1ff4678c72$var$SvgFactorWebauthn = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_1158_5594)",
                fillRule: "evenodd",
                clipRule: "evenodd",
                fill: "currentColor",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M10 2.917a.417.417 0 0 0-.417-.417h-5a.417.417 0 0 0-.416.417v2.916H10V2.917ZM4.167.833C3.247.833 2.5 1.58 2.5 2.5v3.333c0 .92.746.834 1.667.834H10c.92 0 1.667.087 1.667-.834V2.5c0-.92-.746-1.667-1.667-1.667H4.167Z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M.833 7.5c0-.92.747-1.667 1.667-1.667h9.167c.92 0 1.666.746 1.666 1.667H2.917a.417.417 0 0 0-.417.417v9.166c0 .23.187.417.417.417H5a.833.833 0 0 1 0 1.667H2.5c-.92 0-1.667-.747-1.667-1.667v-10ZM5.833 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667ZM8.333 5a.833.833 0 1 1 0-1.667.833.833 0 0 1 0 1.667Z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.75 10C11.602 10 10 11.565 10 13.333v5a.833.833 0 0 1-1.667 0v-5c0-2.834 2.502-5 5.417-5s5.417 2.166 5.417 5V15a.833.833 0 1 1-1.667 0v-1.667c0-1.768-1.602-3.333-3.75-3.333Z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.75 12.5c.767 0 1.25.548 1.25 1.06v4.773a.833.833 0 0 0 1.667 0v-4.772c0-1.58-1.383-2.728-2.917-2.728-1.534 0-2.917 1.148-2.917 2.727v.758a.833.833 0 0 0 1.667 0v-.758c0-.512.483-1.06 1.25-1.06ZM18.333 16.666c.46 0 .834.374.834.834v.833a.833.833 0 0 1-1.667 0V17.5c0-.46.373-.834.833-.834Z"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.75 16.666c.46 0 .833.374.833.834v.833a.833.833 0 0 1-1.666 0V17.5c0-.46.373-.834.833-.834ZM11.667 15.833c.46 0 .833.373.833.834v1.666a.833.833 0 0 1-1.667 0v-1.666c0-.46.373-.834.834-.834ZM13.75 13.333c.46 0 .833.373.833.834V15a.833.833 0 1 1-1.666 0v-.833c0-.46.373-.834.833-.834Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                    id: "clip0_1158_5594",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });
var $6bc9de1ff4678c72$export$2e2bcd8739ae039 = $6bc9de1ff4678c72$var$SvgFactorWebauthn;



var $ds4Cq = parcelRequire("ds4Cq");

var $9bgsA = parcelRequire("9bgsA");
parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

var $fbeQ6 = parcelRequire("fbeQ6");
const $cd16c9d8245c2c19$var$factorNameLabel = {
    [(0, $bd0Y0.MfaFactor).TOTP]: "mfa.totp",
    [(0, $bd0Y0.MfaFactor).WebAuthn]: "mfa.webauthn",
    [(0, $bd0Y0.MfaFactor).BackupCode]: "mfa.backup_code"
};
function $cd16c9d8245c2c19$var$MfaFactorName({ type: type }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
        forKey: $cd16c9d8245c2c19$var$factorNameLabel[type]
    });
}
var $cd16c9d8245c2c19$export$2e2bcd8739ae039 = $cd16c9d8245c2c19$var$MfaFactorName;


var $8f4f687b4b686d26$export$873364fe1dae561a;
var $8f4f687b4b686d26$export$f679e3eca39988e1;
var $8f4f687b4b686d26$export$bb188c6f3a9eb2a0;
var $8f4f687b4b686d26$export$bfd64c937657f93a;
var $8f4f687b4b686d26$export$4a6dd88bada4e7d2;
$8f4f687b4b686d26$export$873364fe1dae561a = `Dwh-rW_factorIcon`;
$8f4f687b4b686d26$export$f679e3eca39988e1 = `Dwh-rW_factorTip`;
$8f4f687b4b686d26$export$bb188c6f3a9eb2a0 = `Dwh-rW_factorTitle`;
$8f4f687b4b686d26$export$bfd64c937657f93a = `Dwh-rW_rotating`;
$8f4f687b4b686d26$export$4a6dd88bada4e7d2 = `Dwh-rW_shimmer`;


const $79a03f9e70dc786c$var$factorIcon = {
    [(0, $bd0Y0.MfaFactor).TOTP]: (0, $f1501c8cedf3c602$export$2e2bcd8739ae039),
    [(0, $bd0Y0.MfaFactor).WebAuthn]: (0, $6bc9de1ff4678c72$export$2e2bcd8739ae039),
    [(0, $bd0Y0.MfaFactor).BackupCode]: (0, $bc43c96067ae4a7d$export$2e2bcd8739ae039)
};
function $79a03f9e70dc786c$var$MfaFactorTitle({ type: type, tooltip: tooltip }) {
    const Icon = $79a03f9e70dc786c$var$factorIcon[type];
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $8f4f687b4b686d26$export$bb188c6f3a9eb2a0,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
                className: $8f4f687b4b686d26$export$873364fe1dae561a
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cd16c9d8245c2c19$export$2e2bcd8739ae039), {
                type: type
            }),
            tooltip && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                anchorClassName: $8f4f687b4b686d26$export$f679e3eca39988e1,
                content: tooltip,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    size: "small",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                })
            })
        ]
    });
}
var $79a03f9e70dc786c$export$2e2bcd8739ae039 = $79a03f9e70dc786c$var$MfaFactorTitle;



var $fbeQ6 = parcelRequire("fbeQ6");

var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");
var $3562c677cba1f1bc$export$bfd64c937657f93a;
var $3562c677cba1f1bc$export$4a6dd88bada4e7d2;
var $3562c677cba1f1bc$export$63233d98cbda935;
$3562c677cba1f1bc$export$bfd64c937657f93a = `zXM0ta_rotating`;
$3562c677cba1f1bc$export$4a6dd88bada4e7d2 = `zXM0ta_shimmer`;
$3562c677cba1f1bc$export$63233d98cbda935 = `zXM0ta_webauthnTipContent`;


function $5f187253ccb472d4$var$WebAuthnTipContent() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("ul", {
        className: $3562c677cba1f1bc$export$63233d98cbda935,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "mfa.webauthn_native_tip"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "mfa.webauthn_domain_tip"
                })
            })
        ]
    });
}
var $5f187253ccb472d4$export$2e2bcd8739ae039 = $5f187253ccb472d4$var$WebAuthnTipContent;


var $757e37e3ee40c179$export$72c773c1d6af3870;
var $757e37e3ee40c179$export$9ded734754bb4e14;
var $757e37e3ee40c179$export$bfd64c937657f93a;
var $757e37e3ee40c179$export$4a6dd88bada4e7d2;
$757e37e3ee40c179$export$72c773c1d6af3870 = `dqcVIG_factorDescription`;
$757e37e3ee40c179$export$9ded734754bb4e14 = `dqcVIG_factorLabel`;
$757e37e3ee40c179$export$bfd64c937657f93a = `dqcVIG_rotating`;
$757e37e3ee40c179$export$4a6dd88bada4e7d2 = `dqcVIG_shimmer`;


const $d3aa850b53949b41$var$factorDescriptionLabel = {
    [(0, $bd0Y0.MfaFactor).TOTP]: "mfa.otp_description",
    [(0, $bd0Y0.MfaFactor).WebAuthn]: "mfa.webauthn_description",
    [(0, $bd0Y0.MfaFactor).BackupCode]: "mfa.backup_code_description"
};
function $d3aa850b53949b41$var$FactorLabel({ type: type }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $757e37e3ee40c179$export$9ded734754bb4e14,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $79a03f9e70dc786c$export$2e2bcd8739ae039), {
                type: type,
                tooltip: type === (0, $bd0Y0.MfaFactor).WebAuthn && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5f187253ccb472d4$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $757e37e3ee40c179$export$72c773c1d6af3870,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: $d3aa850b53949b41$var$factorDescriptionLabel[type]
                })
            })
        ]
    });
}
var $d3aa850b53949b41$export$2e2bcd8739ae039 = $d3aa850b53949b41$var$FactorLabel;


parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
const $56fc6495400d4fe0$export$6f1d9681af8abc37 = {
    [(0, $bd0Y0.MfaPolicy).UserControlled]: "mfa.user_controlled",
    [(0, $bd0Y0.MfaPolicy).Mandatory]: "mfa.mandatory"
};


var $51b27c128367edb9$export$743a1e05baa63b3;
var $51b27c128367edb9$export$2fc99d9950743efd;
var $51b27c128367edb9$export$fc93d7d2231c45c3;
var $51b27c128367edb9$export$bfd64c937657f93a;
var $51b27c128367edb9$export$4a6dd88bada4e7d2;
var $51b27c128367edb9$export$f6622776f1de379c;
$51b27c128367edb9$export$743a1e05baa63b3 = `Pc7KcW_backupCodeDescription`;
$51b27c128367edb9$export$2fc99d9950743efd = `Pc7KcW_backupCodeField`;
$51b27c128367edb9$export$fc93d7d2231c45c3 = `Pc7KcW_factorField`;
$51b27c128367edb9$export$bfd64c937657f93a = `Pc7KcW_rotating`;
$51b27c128367edb9$export$4a6dd88bada4e7d2 = `Pc7KcW_shimmer`;
$51b27c128367edb9$export$f6622776f1de379c = `Pc7KcW_unlockMfaNotice`;


parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
const $dec80bef325ea460$export$f12469c4ef30ac22 = ({ policy: policy, factors: factors })=>({
        policy: policy,
        totpEnabled: factors.includes((0, $bd0Y0.MfaFactor).TOTP),
        webAuthnEnabled: factors.includes((0, $bd0Y0.MfaFactor).WebAuthn),
        backupCodeEnabled: factors.includes((0, $bd0Y0.MfaFactor).BackupCode)
    });
const $dec80bef325ea460$export$e3a56780a63c79fa = (mfaConfigForm)=>{
    const { policy: policy, totpEnabled: totpEnabled, webAuthnEnabled: webAuthnEnabled, backupCodeEnabled: backupCodeEnabled } = mfaConfigForm;
    const factors = [
        (0, $5CQIb.conditional)(totpEnabled && (0, $bd0Y0.MfaFactor).TOTP),
        (0, $5CQIb.conditional)(webAuthnEnabled && (0, $bd0Y0.MfaFactor).WebAuthn),
        (0, $5CQIb.conditional)(backupCodeEnabled && (0, $bd0Y0.MfaFactor).BackupCode)
    ].filter((factor)=>Boolean(factor));
    return {
        policy: policy,
        factors: factors
    };
};
const $dec80bef325ea460$export$ce1e34af78d84da0 = (factors)=>{
    return !(factors.length === 1 && factors.includes((0, $bd0Y0.MfaFactor).BackupCode));
};


function $e5991d184372416e$var$MfaForm({ data: data, onMfaUpdated: onMfaUpdated }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isMfaDisabled = (0, $V1X8c.isCloud) && !currentPlan?.quota.mfaEnabled;
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting }, handleSubmit: handleSubmit, control: control, watch: watch } = (0, $c3LX9.useForm)({
        defaultValues: (0, $dec80bef325ea460$export$f12469c4ef30ac22)(data),
        mode: "onChange"
    });
    const api = (0, $2ANSb.default)();
    const formValues = watch();
    const isBackupCodeAllowed = (0, $eCoWV.useMemo)(()=>{
        const { factors: factors } = (0, $dec80bef325ea460$export$e3a56780a63c79fa)(formValues);
        return (0, $dec80bef325ea460$export$ce1e34af78d84da0)(factors);
    }, [
        formValues
    ]);
    const isPolicySettingsDisabled = (0, $eCoWV.useMemo)(()=>{
        if (isMfaDisabled) return true;
        const { factors: factors } = (0, $dec80bef325ea460$export$e3a56780a63c79fa)(formValues);
        return factors.length === 0;
    }, [
        formValues,
        isMfaDisabled
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        const mfaConfig = (0, $dec80bef325ea460$export$e3a56780a63c79fa)(formData);
        if (!(0, $dec80bef325ea460$export$ce1e34af78d84da0)(mfaConfig.factors)) return;
        const { mfa: updatedMfaConfig } = await api.patch("api/sign-in-exp", {
            json: {
                mfa: mfaConfig
            }
        }).json();
        reset((0, $dec80bef325ea460$export$f12469c4ef30ac22)(updatedMfaConfig));
        (0, $horhC.toast).success(t("general.saved"));
        onMfaUpdated(updatedMfaConfig);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "mfa.factors",
                        description: "mfa.multi_factors_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/recipes/multi-factor-auth/configure-mfa"),
                            targetBlank: "noopener"
                        },
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "mfa.multi_factors",
                                headlineSpacing: "large",
                                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $51b27c128367edb9$export$fc93d7d2231c45c3,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                                            disabled: isMfaDisabled,
                                            label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3aa850b53949b41$export$2e2bcd8739ae039), {
                                                type: (0, $bd0Y0.MfaFactor).TOTP
                                            }),
                                            ...register("totpEnabled")
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                                            disabled: isMfaDisabled,
                                            label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3aa850b53949b41$export$2e2bcd8739ae039), {
                                                type: (0, $bd0Y0.MfaFactor).WebAuthn
                                            }),
                                            ...register("webAuthnEnabled")
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $51b27c128367edb9$export$2fc99d9950743efd,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $51b27c128367edb9$export$743a1e05baa63b3,
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                                        forKey: "mfa.backup_code_setup_hint"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                                                    disabled: isMfaDisabled,
                                                    label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3aa850b53949b41$export$2e2bcd8739ae039), {
                                                        type: (0, $bd0Y0.MfaFactor).BackupCode
                                                    }),
                                                    hasError: !isBackupCodeAllowed,
                                                    ...register("backupCodeEnabled")
                                                }),
                                                !isBackupCodeAllowed && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                                        forKey: "mfa.backup_code_error_hint"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            isMfaDisabled && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $44f9d86084b206ab$export$2e2bcd8739ae039), {
                                for: "mfa",
                                className: $51b27c128367edb9$export$f6622776f1de379c,
                                actionButtonText: "upsell.view_plans"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "mfa.policy",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "mfa.two_step_sign_in_policy",
                            headlineSpacing: "large",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                control: control,
                                name: "policy",
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                        name: name,
                                        value: value,
                                        onChange: onChange,
                                        children: Object.values((0, $bd0Y0.MfaPolicy)).map((policy)=>{
                                            const title = (0, $56fc6495400d4fe0$export$6f1d9681af8abc37)[policy];
                                            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                                isDisabled: isPolicySettingsDisabled,
                                                title: title,
                                                value: policy
                                            }, policy);
                                        })
                                    })
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty
            })
        ]
    });
}
var $e5991d184372416e$export$2e2bcd8739ae039 = $e5991d184372416e$var$MfaForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


var $a0Ubj = parcelRequire("a0Ubj");

var $2wPYZ = parcelRequire("2wPYZ");

var $lSA0o = parcelRequire("lSA0o");

var $9XAkT = parcelRequire("9XAkT");

var $d06dbbca1cfcedec$export$b871cb8291ece61;
var $d06dbbca1cfcedec$export$3aac624c619dfa7f;
var $d06dbbca1cfcedec$export$34e0f9847d4c02dd;
var $d06dbbca1cfcedec$export$bfd64c937657f93a;
var $d06dbbca1cfcedec$export$4a6dd88bada4e7d2;
$d06dbbca1cfcedec$export$b871cb8291ece61 = `_6tXdya_betaNotice`;
$d06dbbca1cfcedec$export$3aac624c619dfa7f = `_6tXdya_cardTitle`;
$d06dbbca1cfcedec$export$34e0f9847d4c02dd = `_6tXdya_container`;
$d06dbbca1cfcedec$export$bfd64c937657f93a = `_6tXdya_rotating`;
$d06dbbca1cfcedec$export$4a6dd88bada4e7d2 = `_6tXdya_shimmer`;


function $836ce38afb504810$var$PageWrapper({ children: children }) {
    const { currentTenantId: currentTenantId, isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Note: fallback to true for OSS version
    const isMfaEnabled = currentPlan?.quota.mfaEnabled ?? true;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d06dbbca1cfcedec$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "mfa.title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                isBeta: true,
                paywall: (0, $5CQIb.cond)((!isMfaEnabled || isDevTenant) && (0, $ckJfF.ReservedPlanId).Hobby),
                title: "mfa.title",
                subtitle: "mfa.description",
                className: $d06dbbca1cfcedec$export$3aac624c619dfa7f
            }),
            isMfaEnabled && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                hasIcon: false,
                className: $d06dbbca1cfcedec$export$b871cb8291ece61,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        ContactLink: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                    },
                    children: t("general.beta_notice", {
                        feature: "MFA"
                    })
                })
            }),
            children
        ]
    });
}
var $836ce38afb504810$export$2e2bcd8739ae039 = $836ce38afb504810$var$PageWrapper;



var $9zeGj = parcelRequire("9zeGj");

var $c7de458e05c97a61$export$34e0f9847d4c02dd;
var $c7de458e05c97a61$export$bfd64c937657f93a;
var $c7de458e05c97a61$export$4a6dd88bada4e7d2;
$c7de458e05c97a61$export$34e0f9847d4c02dd = `JK0d5G_container`;
$c7de458e05c97a61$export$bfd64c937657f93a = `JK0d5G_rotating`;
$c7de458e05c97a61$export$4a6dd88bada4e7d2 = `JK0d5G_shimmer`;


function $e8d21a74d94decd9$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $c7de458e05c97a61$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $354ce2d22530b458$export$2e2bcd8739ae039), {
                formFieldCount: 1
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $354ce2d22530b458$export$2e2bcd8739ae039), {
                formFieldCount: 1
            })
        ]
    });
}
var $e8d21a74d94decd9$export$2e2bcd8739ae039 = $e8d21a74d94decd9$var$Skeleton;


function $e20e6edd0e42354f$var$Mfa() {
    const { data: data, error: error, mutate: mutate, isLoading: isLoading } = (0, $2mi28.default)("api/sign-in-exp");
    if (isLoading) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $836ce38afb504810$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e8d21a74d94decd9$export$2e2bcd8739ae039), {})
    });
    if (error) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $836ce38afb504810$export$2e2bcd8739ae039), {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $45d431f1843a1407$export$2e2bcd8739ae039), {
            error: error,
            onRetry: mutate
        })
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $836ce38afb504810$export$2e2bcd8739ae039), {
        children: data && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e5991d184372416e$export$2e2bcd8739ae039), {
            data: data.mfa,
            onMfaUpdated: (mfa)=>{
                mutate({
                    ...data,
                    mfa: mfa
                });
            }
        })
    });
}
var $e20e6edd0e42354f$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($e20e6edd0e42354f$var$Mfa);



var $djktV = parcelRequire("djktV");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $11c317f8d53fc2a7$var$SvgOrganizationPreview = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M18.4 12.1v4.2h4.2v-4.2h-4.2ZM17.35 10c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-6.3ZM12.1 24.7v4.2h4.2v-4.2h-4.2Zm-1.05-2.1c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-2.1v-1.05h10.5v1.05h-2.1c-.58 0-1.05.47-1.05 1.05v6.3c0 .58.47 1.05 1.05 1.05h6.3c.58 0 1.05-.47 1.05-1.05v-6.3c0-.58-.47-1.05-1.05-1.05h-2.1v-1.05a2.1 2.1 0 0 0-2.1-2.1h-4.2V18.4h-2.1v1.05h-4.2a2.1 2.1 0 0 0-2.1 2.1v1.05h-2.1Zm13.65 6.3v-4.2h4.2v4.2h-4.2Z",
                fill: "url(#paint0_linear_550_31630)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_550_31630",
                    x1: 13.609,
                    y1: 28.156,
                    x2: 27.719,
                    y2: 13.063,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $11c317f8d53fc2a7$export$2e2bcd8739ae039 = $11c317f8d53fc2a7$var$SvgOrganizationPreview;








var $a0Ubj = parcelRequire("a0Ubj");

var $9zeGj = parcelRequire("9zeGj");
var $f5cefbd6aed852cd$export$1ca1ec8b29a4ce27;
$f5cefbd6aed852cd$export$1ca1ec8b29a4ce27 = `wvr_2q_icon`;


/**
 * Renders an icon with color according to the current theme. It uses `--color-specific-icon-bg`
 * CSS variable to determine the color.
 */ function $3dc4aee746c180b4$var$ThemedIcon({ for: Icon, size: size }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
        className: $f5cefbd6aed852cd$export$1ca1ec8b29a4ce27,
        style: {
            width: size,
            height: size
        }
    });
}
var $3dc4aee746c180b4$export$2e2bcd8739ae039 = $3dc4aee746c180b4$var$ThemedIcon;





var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $bc9f76eed31c7c6f$var$SvgOrganizationFeatureDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM19.2 8a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V9.6A1.6 1.6 0 0 0 28.8 8h-9.6Zm-8 22.4v6.4h6.4v-6.4h-6.4Zm-1.6-3.2A1.6 1.6 0 0 0 8 28.8v9.6A1.6 1.6 0 0 0 9.6 40h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6H16v-1.6h16v1.6h-3.2a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-3.2v-1.6a3.2 3.2 0 0 0-3.2-3.2h-6.4v-1.6h-3.2v1.6H16a3.2 3.2 0 0 0-3.2 3.2v1.6H9.6Zm20.8 9.6v-6.4h6.4v6.4h-6.4Z",
                fill: "url(#paint0_linear_9450_17742)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M11.2 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M30.4 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF",
                fillOpacity: 0.3
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_9450_17742",
                    x1: 13.5,
                    y1: 35.666,
                    x2: 35,
                    y2: 12.666,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $bc9f76eed31c7c6f$export$2e2bcd8739ae039 = $bc9f76eed31c7c6f$var$SvgOrganizationFeatureDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $0d591b4d318c7c8f$var$SvgOrganizationFeature = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM19.2 8a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6V9.6A1.6 1.6 0 0 0 28.8 8h-9.6Zm-8 22.4v6.4h6.4v-6.4h-6.4Zm-1.6-3.2A1.6 1.6 0 0 0 8 28.8v9.6A1.6 1.6 0 0 0 9.6 40h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6H16v-1.6h16v1.6h-3.2a1.6 1.6 0 0 0-1.6 1.6v9.6a1.6 1.6 0 0 0 1.6 1.6h9.6a1.6 1.6 0 0 0 1.6-1.6v-9.6a1.6 1.6 0 0 0-1.6-1.6h-3.2v-1.6a3.2 3.2 0 0 0-3.2-3.2h-6.4v-1.6h-3.2v1.6H16a3.2 3.2 0 0 0-3.2 3.2v1.6H9.6Zm20.8 9.6v-6.4h6.4v6.4h-6.4Z",
                fill: "url(#paint0_linear_9448_17722)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 7,
                cy: 19,
                r: 1.5,
                stroke: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 36.879,
                y: 7,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 36.879 7)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 18.707,
                y: 44.828,
                width: 3,
                height: 3,
                rx: 0.5,
                transform: "rotate(-45 18.707 44.828)",
                stroke: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.6,
                d: "M20.8 11.2v6.4h6.4v-6.4h-6.4ZM11.2 30.4v6.4h6.4v-6.4h-6.4ZM30.4 30.4v6.4h6.4v-6.4h-6.4Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_9448_17722",
                    x1: 13.5,
                    y1: 35.666,
                    x2: 35,
                    y2: 12.666,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $0d591b4d318c7c8f$export$2e2bcd8739ae039 = $0d591b4d318c7c8f$var$SvgOrganizationFeature;




var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $d0Zvy = parcelRequire("d0Zvy");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");
const $fec8fa852791059b$export$be3f796aed065412 = Object.freeze({
    introduction: "introduction",
    permissions: "permissions",
    roles: "roles",
    organizationInfo: "organization-info"
});
const $fec8fa852791059b$export$64cee2a13326b43d = Object.keys($fec8fa852791059b$export$be3f796aed065412).length;


var $73aa291f835e531b$export$aa3e815946b80764;
var $73aa291f835e531b$export$a7db06668cad9adb;
var $73aa291f835e531b$export$6d59db4903f20f7d;
var $73aa291f835e531b$export$42f9fc1286aa9efd;
var $73aa291f835e531b$export$1ca1ec8b29a4ce27;
var $73aa291f835e531b$export$5c452ff88e35e47d;
var $73aa291f835e531b$export$56c24f306bd986cf;
var $73aa291f835e531b$export$bfd64c937657f93a;
var $73aa291f835e531b$export$fe2e36411d703b3d;
var $73aa291f835e531b$export$4a6dd88bada4e7d2;
var $73aa291f835e531b$export$543dc55cf524ac77;
var $73aa291f835e531b$export$c96745152eb2740f;
var $73aa291f835e531b$export$fb184b623420d9be;
$73aa291f835e531b$export$aa3e815946b80764 = `qq06Ba_card`;
$73aa291f835e531b$export$a7db06668cad9adb = `qq06Ba_content`;
$73aa291f835e531b$export$6d59db4903f20f7d = `qq06Ba_description`;
$73aa291f835e531b$export$42f9fc1286aa9efd = `qq06Ba_fieldGroup`;
$73aa291f835e531b$export$1ca1ec8b29a4ce27 = `qq06Ba_icon`;
$73aa291f835e531b$export$5c452ff88e35e47d = `qq06Ba_image`;
$73aa291f835e531b$export$56c24f306bd986cf = `qq06Ba_modalContainer`;
$73aa291f835e531b$export$bfd64c937657f93a = `qq06Ba_rotating`;
$73aa291f835e531b$export$fe2e36411d703b3d = `qq06Ba_section`;
$73aa291f835e531b$export$4a6dd88bada4e7d2 = `qq06Ba_shimmer`;
$73aa291f835e531b$export$543dc55cf524ac77 = `qq06Ba_stepContainer`;
$73aa291f835e531b$export$c96745152eb2740f = `qq06Ba_subtitle`;
$73aa291f835e531b$export$fb184b623420d9be = `qq06Ba_title`;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $fd7239ef257a11e4$exports = {};

$parcel$export($fd7239ef257a11e4$exports, "column", function () { return $fd7239ef257a11e4$export$4e0c71f277ca26b3; }, function (v) { return $fd7239ef257a11e4$export$4e0c71f277ca26b3 = v; });
$parcel$export($fd7239ef257a11e4$exports, "equallyDivided", function () { return $fd7239ef257a11e4$export$53eab53cdc9a3971; }, function (v) { return $fd7239ef257a11e4$export$53eab53cdc9a3971 = v; });
$parcel$export($fd7239ef257a11e4$exports, "flexBox", function () { return $fd7239ef257a11e4$export$6b39a1ef00710959; }, function (v) { return $fd7239ef257a11e4$export$6b39a1ef00710959 = v; });
$parcel$export($fd7239ef257a11e4$exports, "rotating", function () { return $fd7239ef257a11e4$export$bfd64c937657f93a; }, function (v) { return $fd7239ef257a11e4$export$bfd64c937657f93a = v; });
$parcel$export($fd7239ef257a11e4$exports, "shimmer", function () { return $fd7239ef257a11e4$export$4a6dd88bada4e7d2; }, function (v) { return $fd7239ef257a11e4$export$4a6dd88bada4e7d2 = v; });
var $fd7239ef257a11e4$export$4e0c71f277ca26b3;
var $fd7239ef257a11e4$export$53eab53cdc9a3971;
var $fd7239ef257a11e4$export$6b39a1ef00710959;
var $fd7239ef257a11e4$export$bfd64c937657f93a;
var $fd7239ef257a11e4$export$4a6dd88bada4e7d2;
$fd7239ef257a11e4$export$4e0c71f277ca26b3 = `V12j3W_column`;
$fd7239ef257a11e4$export$53eab53cdc9a3971 = `V12j3W_equallyDivided`;
$fd7239ef257a11e4$export$6b39a1ef00710959 = `V12j3W_flexBox`;
$fd7239ef257a11e4$export$bfd64c937657f93a = `V12j3W_rotating`;
$fd7239ef257a11e4$export$4a6dd88bada4e7d2 = `V12j3W_shimmer`;


function $15fc71b39e47573b$var$FlexBox({ className: className, children: children, type: type = "row", gap: gap = 12, style: style, isEquallyDivided: isEquallyDivided, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($fd7239ef257a11e4$exports.flexBox, $fd7239ef257a11e4$exports[type], isEquallyDivided && $fd7239ef257a11e4$exports.equallyDivided, className),
        style: {
            gap: `${gap}px`,
            ...style
        },
        onFocus: onMouseOver,
        onBlur: onMouseOut,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        children: children
    });
}
var $15fc71b39e47573b$export$2e2bcd8739ae039 = $15fc71b39e47573b$var$FlexBox;


/* eslint-disable complexity */ 
var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $f74d49d04e006405$exports = {};

$parcel$export($f74d49d04e006405$exports, "blue", function () { return $f74d49d04e006405$export$2aa0182783e7e9de; }, function (v) { return $f74d49d04e006405$export$2aa0182783e7e9de = v; });
$parcel$export($f74d49d04e006405$exports, "body", function () { return $f74d49d04e006405$export$32180ef41b15b513; }, function (v) { return $f74d49d04e006405$export$32180ef41b15b513 = v; });
$parcel$export($f74d49d04e006405$exports, "header", function () { return $f74d49d04e006405$export$38e42c68cf43b5d4; }, function (v) { return $f74d49d04e006405$export$38e42c68cf43b5d4 = v; });
$parcel$export($f74d49d04e006405$exports, "panel", function () { return $f74d49d04e006405$export$21f42ab9b6679f44; }, function (v) { return $f74d49d04e006405$export$21f42ab9b6679f44 = v; });
$parcel$export($f74d49d04e006405$exports, "purple", function () { return $f74d49d04e006405$export$e13cce2a2d16a9d4; }, function (v) { return $f74d49d04e006405$export$e13cce2a2d16a9d4 = v; });
$parcel$export($f74d49d04e006405$exports, "rotating", function () { return $f74d49d04e006405$export$bfd64c937657f93a; }, function (v) { return $f74d49d04e006405$export$bfd64c937657f93a = v; });
$parcel$export($f74d49d04e006405$exports, "shimmer", function () { return $f74d49d04e006405$export$4a6dd88bada4e7d2; }, function (v) { return $f74d49d04e006405$export$4a6dd88bada4e7d2 = v; });
$parcel$export($f74d49d04e006405$exports, "small", function () { return $f74d49d04e006405$export$3c17b0e969a90510; }, function (v) { return $f74d49d04e006405$export$3c17b0e969a90510 = v; });
var $f74d49d04e006405$export$2aa0182783e7e9de;
var $f74d49d04e006405$export$32180ef41b15b513;
var $f74d49d04e006405$export$38e42c68cf43b5d4;
var $f74d49d04e006405$export$21f42ab9b6679f44;
var $f74d49d04e006405$export$e13cce2a2d16a9d4;
var $f74d49d04e006405$export$bfd64c937657f93a;
var $f74d49d04e006405$export$4a6dd88bada4e7d2;
var $f74d49d04e006405$export$3c17b0e969a90510;
$f74d49d04e006405$export$2aa0182783e7e9de = `Eorspq_blue`;
$f74d49d04e006405$export$32180ef41b15b513 = `Eorspq_body`;
$f74d49d04e006405$export$38e42c68cf43b5d4 = `Eorspq_header`;
$f74d49d04e006405$export$21f42ab9b6679f44 = `Eorspq_panel`;
$f74d49d04e006405$export$e13cce2a2d16a9d4 = `Eorspq_purple`;
$f74d49d04e006405$export$bfd64c937657f93a = `Eorspq_rotating`;
$f74d49d04e006405$export$4a6dd88bada4e7d2 = `Eorspq_shimmer`;
$f74d49d04e006405$export$3c17b0e969a90510 = `Eorspq_small`;


function $762145cc85bc40d0$var$Panel({ className: className, label: label, variant: variant, size: size = "medium", children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f74d49d04e006405$exports.panel, variant && $f74d49d04e006405$exports[variant], $f74d49d04e006405$exports[size], className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f74d49d04e006405$exports.header,
                children: label
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f74d49d04e006405$exports.body,
                children: children
            })
        ]
    });
}
var $762145cc85bc40d0$export$2e2bcd8739ae039 = $762145cc85bc40d0$var$Panel;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $4v6om = parcelRequire("4v6om");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $421fe2e3705dce80$export$d8cfd17610b730e0;
var $421fe2e3705dce80$export$ff398d236afe1183;
var $421fe2e3705dce80$export$bfd64c937657f93a;
var $421fe2e3705dce80$export$4a6dd88bada4e7d2;
$421fe2e3705dce80$export$d8cfd17610b730e0 = `WNEnQa_monoSpace`;
$421fe2e3705dce80$export$ff398d236afe1183 = `WNEnQa_permission`;
$421fe2e3705dce80$export$bfd64c937657f93a = `WNEnQa_rotating`;
$421fe2e3705dce80$export$4a6dd88bada4e7d2 = `WNEnQa_shimmer`;


function $167f9dc7165146aa$var$Permission({ className: className, name: name, isMonospace: isMonospace = true }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($421fe2e3705dce80$export$ff398d236afe1183, isMonospace && $421fe2e3705dce80$export$d8cfd17610b730e0, className),
        children: name
    });
}
var $167f9dc7165146aa$export$2e2bcd8739ae039 = $167f9dc7165146aa$var$Permission;


var $67ec393c72453d46$exports = {};

$parcel$export($67ec393c72453d46$exports, "active", function () { return $67ec393c72453d46$export$89da14300d534261; }, function (v) { return $67ec393c72453d46$export$89da14300d534261 = v; });
$parcel$export($67ec393c72453d46$exports, "interactive", function () { return $67ec393c72453d46$export$dbd07fce1f97166e; }, function (v) { return $67ec393c72453d46$export$dbd07fce1f97166e = v; });
$parcel$export($67ec393c72453d46$exports, "label", function () { return $67ec393c72453d46$export$1237798dc640739a; }, function (v) { return $67ec393c72453d46$export$1237798dc640739a = v; });
$parcel$export($67ec393c72453d46$exports, "permissions", function () { return $67ec393c72453d46$export$430c45605c9594b5; }, function (v) { return $67ec393c72453d46$export$430c45605c9594b5 = v; });
$parcel$export($67ec393c72453d46$exports, "role", function () { return $67ec393c72453d46$export$3100efae45e879; }, function (v) { return $67ec393c72453d46$export$3100efae45e879 = v; });
$parcel$export($67ec393c72453d46$exports, "rotating", function () { return $67ec393c72453d46$export$bfd64c937657f93a; }, function (v) { return $67ec393c72453d46$export$bfd64c937657f93a = v; });
$parcel$export($67ec393c72453d46$exports, "shimmer", function () { return $67ec393c72453d46$export$4a6dd88bada4e7d2; }, function (v) { return $67ec393c72453d46$export$4a6dd88bada4e7d2 = v; });
$parcel$export($67ec393c72453d46$exports, "small", function () { return $67ec393c72453d46$export$3c17b0e969a90510; }, function (v) { return $67ec393c72453d46$export$3c17b0e969a90510 = v; });
var $67ec393c72453d46$export$89da14300d534261;
var $67ec393c72453d46$export$dbd07fce1f97166e;
var $67ec393c72453d46$export$1237798dc640739a;
var $67ec393c72453d46$export$430c45605c9594b5;
var $67ec393c72453d46$export$3100efae45e879;
var $67ec393c72453d46$export$bfd64c937657f93a;
var $67ec393c72453d46$export$4a6dd88bada4e7d2;
var $67ec393c72453d46$export$3c17b0e969a90510;
$67ec393c72453d46$export$89da14300d534261 = `nnhCmG_active`;
$67ec393c72453d46$export$dbd07fce1f97166e = `nnhCmG_interactive`;
$67ec393c72453d46$export$1237798dc640739a = `nnhCmG_label`;
$67ec393c72453d46$export$430c45605c9594b5 = `nnhCmG_permissions`;
$67ec393c72453d46$export$3100efae45e879 = `nnhCmG_role`;
$67ec393c72453d46$export$bfd64c937657f93a = `nnhCmG_rotating`;
$67ec393c72453d46$export$4a6dd88bada4e7d2 = `nnhCmG_shimmer`;
$67ec393c72453d46$export$3c17b0e969a90510 = `nnhCmG_small`;


function $ad66e42a1d25c6fa$var$Role({ className: className, label: label, permissions: permissions, tooltip: tooltip, size: size = "default", isActive: isActive = true, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
            type: "column",
            gap: 10,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($67ec393c72453d46$exports.role, $67ec393c72453d46$exports[size], isActive && $67ec393c72453d46$exports.active, tooltip && $67ec393c72453d46$exports.interactive, className),
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $67ec393c72453d46$exports.label,
                    children: label
                }),
                !!permissions?.length && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                    type: "column",
                    gap: 10,
                    className: $67ec393c72453d46$exports.permissions,
                    children: permissions.map((permission)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $167f9dc7165146aa$export$2e2bcd8739ae039), {
                            name: permission
                        }, permission))
                })
            ]
        })
    });
}
var $ad66e42a1d25c6fa$export$2e2bcd8739ae039 = $ad66e42a1d25c6fa$var$Role;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $edc87b6ba604f520$var$SvgUser = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 26,
        height: 28,
        viewBox: "0 0 26 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            id: "Union",
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M13 0a5.478 5.478 0 0 0-5.478 5.478v1.218a5.478 5.478 0 0 0 10.956 0V5.478A5.478 5.478 0 0 0 13 0Zm0 28c12.174 0 12.174-3.957 12.174-3.957 0-5.133-2.548-9.918-9.13-10.043-.029 0-.219.184-.494.452-.723.704-2.036 1.98-2.55 1.98-.514 0-1.827-1.276-2.55-1.98-.275-.268-.466-.453-.494-.452-6.582.125-9.13 4.91-9.13 10.043 0 0 0 3.957 12.174 3.957Z",
            fill: "currentColor"
        })
    });
var $edc87b6ba604f520$export$2e2bcd8739ae039 = $edc87b6ba604f520$var$SvgUser;



var $4v6om = parcelRequire("4v6om");
var $3b6639a8361093a5$exports = {};

$parcel$export($3b6639a8361093a5$exports, "active", function () { return $3b6639a8361093a5$export$89da14300d534261; }, function (v) { return $3b6639a8361093a5$export$89da14300d534261 = v; });
$parcel$export($3b6639a8361093a5$exports, "avatar", function () { return $3b6639a8361093a5$export$345c5736c8054f22; }, function (v) { return $3b6639a8361093a5$export$345c5736c8054f22 = v; });
$parcel$export($3b6639a8361093a5$exports, "blue", function () { return $3b6639a8361093a5$export$2aa0182783e7e9de; }, function (v) { return $3b6639a8361093a5$export$2aa0182783e7e9de = v; });
$parcel$export($3b6639a8361093a5$exports, "interactive", function () { return $3b6639a8361093a5$export$dbd07fce1f97166e; }, function (v) { return $3b6639a8361093a5$export$dbd07fce1f97166e = v; });
$parcel$export($3b6639a8361093a5$exports, "name", function () { return $3b6639a8361093a5$export$a8ff84c12d48cfa6; }, function (v) { return $3b6639a8361093a5$export$a8ff84c12d48cfa6 = v; });
$parcel$export($3b6639a8361093a5$exports, "pink", function () { return $3b6639a8361093a5$export$47853bc718611763; }, function (v) { return $3b6639a8361093a5$export$47853bc718611763 = v; });
$parcel$export($3b6639a8361093a5$exports, "rotating", function () { return $3b6639a8361093a5$export$bfd64c937657f93a; }, function (v) { return $3b6639a8361093a5$export$bfd64c937657f93a = v; });
$parcel$export($3b6639a8361093a5$exports, "shimmer", function () { return $3b6639a8361093a5$export$4a6dd88bada4e7d2; }, function (v) { return $3b6639a8361093a5$export$4a6dd88bada4e7d2 = v; });
$parcel$export($3b6639a8361093a5$exports, "small", function () { return $3b6639a8361093a5$export$3c17b0e969a90510; }, function (v) { return $3b6639a8361093a5$export$3c17b0e969a90510 = v; });
$parcel$export($3b6639a8361093a5$exports, "user", function () { return $3b6639a8361093a5$export$ddb906a32562356c; }, function (v) { return $3b6639a8361093a5$export$ddb906a32562356c = v; });
var $3b6639a8361093a5$export$89da14300d534261;
var $3b6639a8361093a5$export$345c5736c8054f22;
var $3b6639a8361093a5$export$2aa0182783e7e9de;
var $3b6639a8361093a5$export$dbd07fce1f97166e;
var $3b6639a8361093a5$export$a8ff84c12d48cfa6;
var $3b6639a8361093a5$export$47853bc718611763;
var $3b6639a8361093a5$export$bfd64c937657f93a;
var $3b6639a8361093a5$export$4a6dd88bada4e7d2;
var $3b6639a8361093a5$export$3c17b0e969a90510;
var $3b6639a8361093a5$export$ddb906a32562356c;
$3b6639a8361093a5$export$89da14300d534261 = `LUuDUa_active`;
$3b6639a8361093a5$export$345c5736c8054f22 = `LUuDUa_avatar`;
$3b6639a8361093a5$export$2aa0182783e7e9de = `LUuDUa_blue`;
$3b6639a8361093a5$export$dbd07fce1f97166e = `LUuDUa_interactive`;
$3b6639a8361093a5$export$a8ff84c12d48cfa6 = `LUuDUa_name`;
$3b6639a8361093a5$export$47853bc718611763 = `LUuDUa_pink`;
$3b6639a8361093a5$export$bfd64c937657f93a = `LUuDUa_rotating`;
$3b6639a8361093a5$export$4a6dd88bada4e7d2 = `LUuDUa_shimmer`;
$3b6639a8361093a5$export$3c17b0e969a90510 = `LUuDUa_small`;
$3b6639a8361093a5$export$ddb906a32562356c = `LUuDUa_user`;


function $eba650fb0f342274$var$User({ className: className, name: name, hasIcon: hasIcon = true, variant: variant, size: size, tooltip: tooltip, isActive: isActive = true, onMouseOver: onMouseOver, onMouseOut: onMouseOut }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
        content: tooltip,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($3b6639a8361093a5$exports.user, variant && $3b6639a8361093a5$exports[variant], size && $3b6639a8361093a5$exports[size], isActive && $3b6639a8361093a5$exports.active, tooltip && $3b6639a8361093a5$exports.interactive, className),
            onFocus: onMouseOver,
            onBlur: onMouseOut,
            onMouseOver: onMouseOver,
            onMouseOut: onMouseOut,
            children: [
                hasIcon && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $edc87b6ba604f520$export$2e2bcd8739ae039), {
                    className: $3b6639a8361093a5$exports.avatar
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $3b6639a8361093a5$exports.name,
                    children: name
                })
            ]
        })
    });
}
var $eba650fb0f342274$export$2e2bcd8739ae039 = $eba650fb0f342274$var$User;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
var $2352e5e233f21d2e$export$89da14300d534261;
var $2352e5e233f21d2e$export$6f093cfa640b7166;
var $2352e5e233f21d2e$export$aa6223da92b253dd;
var $2352e5e233f21d2e$export$6074e20ba5c64bef;
$2352e5e233f21d2e$export$89da14300d534261 = `pKzp0W_active`;
$2352e5e233f21d2e$export$6f093cfa640b7166 = `pKzp0W_text`;
$2352e5e233f21d2e$export$aa6223da92b253dd = `pKzp0W_textWrapper`;
$2352e5e233f21d2e$export$6074e20ba5c64bef = `pKzp0W_vector`;


function $10ae03e67d0633a3$var$John({ isActive: isActive = true }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2352e5e233f21d2e$export$6074e20ba5c64bef, isActive && $2352e5e233f21d2e$export$89da14300d534261),
        width: "190",
        height: "200",
        viewBox: "0 0 190 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        style: {
            transform: "translateY(90px)"
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M186.704 11.589L183.121 9.50968L183.114 13.6504L186.704 11.589ZM0.233412 11.4807L183.476 11.9395L183.477 11.2223L0.234605 10.7635L0.233412 11.4807Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                className: $2352e5e233f21d2e$export$aa6223da92b253dd,
                width: "107",
                height: "24",
                transform: "translate(41.8317 0.121582)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("text", {
                className: $2352e5e233f21d2e$export$6f093cfa640b7166,
                x: "48",
                y: "15",
                children: "john@email.com"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M185.27 186.451L181.684 188.521V184.381L185.27 186.451ZM21.3918 11.4565V177.845H20.6746V11.4565H21.3918ZM29.6395 186.092H182.042V186.809H29.6395V186.092ZM21.3918 177.845C21.3918 182.4 25.0844 186.092 29.6395 186.092V186.809C24.6883 186.809 20.6746 182.796 20.6746 177.845H21.3918Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                className: $2352e5e233f21d2e$export$aa6223da92b253dd,
                width: "107",
                height: "24",
                transform: "translate(41.8317 175.693)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("text", {
                className: $2352e5e233f21d2e$export$6f093cfa640b7166,
                x: "48",
                y: "190",
                children: "john@email.com"
            })
        ]
    });
}
var $10ae03e67d0633a3$export$2e2bcd8739ae039 = $10ae03e67d0633a3$var$John;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

function $ada7084639171712$var$Sarah({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($2352e5e233f21d2e$export$6074e20ba5c64bef, isActive && $2352e5e233f21d2e$export$89da14300d534261),
        width: "187",
        height: "25",
        viewBox: "0 0 187 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M186.704 10.8857L183.118 8.81539V12.9561L186.704 10.8857ZM0.234619 11.2443L183.477 11.2443V10.5271L0.234619 10.5271L0.234619 11.2443Z",
                fill: "#8E9192"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                className: $2352e5e233f21d2e$export$aa6223da92b253dd,
                width: "108",
                height: "24",
                transform: "translate(41.8317 0.326172)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("text", {
                className: $2352e5e233f21d2e$export$6f093cfa640b7166,
                x: "47",
                y: "14",
                children: "sarah@email.com"
            })
        ]
    });
}
var $ada7084639171712$export$2e2bcd8739ae039 = $ada7084639171712$var$Sarah;


var $eb5b07d5c583009d$export$6d59db4903f20f7d;
var $eb5b07d5c583009d$export$21f42ab9b6679f44;
var $eb5b07d5c583009d$export$bfd64c937657f93a;
var $eb5b07d5c583009d$export$1a952fe22cdce89e;
var $eb5b07d5c583009d$export$4a6dd88bada4e7d2;
$eb5b07d5c583009d$export$6d59db4903f20f7d = `QBcT2a_description`;
$eb5b07d5c583009d$export$21f42ab9b6679f44 = `QBcT2a_panel`;
$eb5b07d5c583009d$export$bfd64c937657f93a = `QBcT2a_rotating`;
$eb5b07d5c583009d$export$1a952fe22cdce89e = `QBcT2a_sectionTitle`;
$eb5b07d5c583009d$export$4a6dd88bada4e7d2 = `QBcT2a_shimmer`;


function $1f6dd0dd4a66d07b$var$InteractiveDiagram() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const [activePerson, setActivePerson] = (0, $eCoWV.useState)();
    const [activeRole, setActiveRole] = (0, $eCoWV.useState)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
        type: "column",
        gap: 32,
        style: {
            padding: "12px 0"
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                        variant: "blue",
                        name: "John",
                        tooltip: t("guide.john_tip"),
                        isActive: activePerson !== "Sarah" && !activeRole,
                        onMouseOver: ()=>{
                            setActivePerson("John");
                        },
                        onMouseOut: ()=>{
                            setActivePerson(undefined);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $10ae03e67d0633a3$export$2e2bcd8739ae039), {
                        isActive: activePerson !== "Sarah" && !activeRole
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $762145cc85bc40d0$export$2e2bcd8739ae039), {
                        className: $eb5b07d5c583009d$export$21f42ab9b6679f44,
                        label: `${t("organization")} A`,
                        size: "small",
                        variant: "blue",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                style: {
                                    marginBottom: "8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Admin`,
                                        tooltip: t("guide.role_description", {
                                            role: "Admin"
                                        }),
                                        isActive: (activeRole === "Admin" || !activeRole) && activePerson !== "Sarah",
                                        onMouseOver: ()=>{
                                            setActiveRole("Admin");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Member`,
                                        tooltip: t("guide.role_description", {
                                            role: "Member"
                                        }),
                                        isActive: (activeRole === "Member" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Member");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Guest`,
                                        tooltip: t("guide.role_description", {
                                            role: "Guest"
                                        }),
                                        isActive: (activeRole === "Guest" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Guest");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: "...",
                                        isActive: !activeRole && !activePerson
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                                size: "small",
                                variant: "blue",
                                name: "John",
                                tooltip: t("guide.john_tip"),
                                isActive: activePerson !== "Sarah" && !activeRole,
                                onMouseOver: ()=>{
                                    setActivePerson("John");
                                },
                                onMouseOut: ()=>{
                                    setActivePerson(undefined);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                style: {
                    alignItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                        variant: "pink",
                        name: "Sarah",
                        tooltip: t("guide.sarah_tip"),
                        isActive: activePerson !== "John" && !activeRole,
                        onMouseOver: ()=>{
                            setActivePerson("Sarah");
                        },
                        onMouseOut: ()=>{
                            setActivePerson(undefined);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ada7084639171712$export$2e2bcd8739ae039), {
                        isActive: activePerson !== "John" && !activeRole
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $762145cc85bc40d0$export$2e2bcd8739ae039), {
                        className: $eb5b07d5c583009d$export$21f42ab9b6679f44,
                        label: `${t("organization")} B`,
                        size: "small",
                        variant: "purple",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                style: {
                                    marginBottom: "8px"
                                },
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Admin`,
                                        tooltip: t("guide.role_description", {
                                            role: "Admin"
                                        }),
                                        isActive: (activeRole === "Admin" || !activeRole) && activePerson !== "John",
                                        onMouseOver: ()=>{
                                            setActiveRole("Admin");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Member`,
                                        tooltip: t("guide.role_description", {
                                            role: "Member"
                                        }),
                                        isActive: (activeRole === "Member" || !activeRole) && !activePerson,
                                        onMouseOver: ()=>{
                                            setActiveRole("Member");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: `${t("role")}: Guest`,
                                        tooltip: t("guide.role_description", {
                                            role: "Guest"
                                        }),
                                        isActive: (activeRole === "Guest" || !activeRole) && activePerson !== "Sarah",
                                        onMouseOver: ()=>{
                                            setActiveRole("Guest");
                                        },
                                        onMouseOut: ()=>{
                                            setActiveRole(undefined);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                        size: "small",
                                        label: "...",
                                        isActive: !activeRole && !activePerson
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                isEquallyDivided: true,
                                gap: 10,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                                            variant: "pink",
                                            name: "Sarah",
                                            size: "small",
                                            tooltip: t("guide.sarah_tip"),
                                            isActive: activePerson !== "John" && !activeRole,
                                            onMouseOver: ()=>{
                                                setActivePerson("Sarah");
                                            },
                                            onMouseOut: ()=>{
                                                setActivePerson(undefined);
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                                            variant: "blue",
                                            name: "John",
                                            size: "small",
                                            tooltip: t("guide.john_tip"),
                                            isActive: activePerson !== "Sarah" && !activeRole,
                                            onMouseOver: ()=>{
                                                setActivePerson("John");
                                            },
                                            onMouseOut: ()=>{
                                                setActivePerson(undefined);
                                            }
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $1f6dd0dd4a66d07b$export$2e2bcd8739ae039 /* eslint-enable complexity */  = $1f6dd0dd4a66d07b$var$InteractiveDiagram;






var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $16cbba0464675a35$export$6d59db4903f20f7d;
var $16cbba0464675a35$export$bfd64c937657f93a;
var $16cbba0464675a35$export$fe2e36411d703b3d;
var $16cbba0464675a35$export$4a6dd88bada4e7d2;
var $16cbba0464675a35$export$fb184b623420d9be;
$16cbba0464675a35$export$6d59db4903f20f7d = `g_WjkG_description`;
$16cbba0464675a35$export$bfd64c937657f93a = `g_WjkG_rotating`;
$16cbba0464675a35$export$fe2e36411d703b3d = `g_WjkG_section`;
$16cbba0464675a35$export$4a6dd88bada4e7d2 = `g_WjkG_shimmer`;
$16cbba0464675a35$export$fb184b623420d9be = `g_WjkG_title`;


function $c3569b098ce3b425$var$Section({ className: className, title: title, description: description, children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
        type: "column",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($16cbba0464675a35$export$fe2e36411d703b3d, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $16cbba0464675a35$export$fb184b623420d9be,
                children: title
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $16cbba0464675a35$export$6d59db4903f20f7d,
                children: description
            }),
            children
        ]
    });
}
var $c3569b098ce3b425$export$2e2bcd8739ae039 = $c3569b098ce3b425$var$Section;



var $85f1f2bcee94130d$export$8e16b83750b44988;
var $85f1f2bcee94130d$export$34e0f9847d4c02dd;
var $85f1f2bcee94130d$export$6d59db4903f20f7d;
var $85f1f2bcee94130d$export$21f42ab9b6679f44;
var $85f1f2bcee94130d$export$bfd64c937657f93a;
var $85f1f2bcee94130d$export$1a952fe22cdce89e;
var $85f1f2bcee94130d$export$4a6dd88bada4e7d2;
var $85f1f2bcee94130d$export$fb184b623420d9be;
$85f1f2bcee94130d$export$8e16b83750b44988 = `XAQ4ba_compact`;
$85f1f2bcee94130d$export$34e0f9847d4c02dd = `XAQ4ba_container`;
$85f1f2bcee94130d$export$6d59db4903f20f7d = `XAQ4ba_description`;
$85f1f2bcee94130d$export$21f42ab9b6679f44 = `XAQ4ba_panel`;
$85f1f2bcee94130d$export$bfd64c937657f93a = `XAQ4ba_rotating`;
$85f1f2bcee94130d$export$1a952fe22cdce89e = `XAQ4ba_sectionTitle`;
$85f1f2bcee94130d$export$4a6dd88bada4e7d2 = `XAQ4ba_shimmer`;
$85f1f2bcee94130d$export$fb184b623420d9be = `XAQ4ba_title`;


const $b2f02aa31b602632$var$icons = {
    [(0, $bhvxB.Theme).Light]: {
        OrganizationIcon: (0, $0d591b4d318c7c8f$export$2e2bcd8739ae039)
    },
    [(0, $bhvxB.Theme).Dark]: {
        OrganizationIcon: (0, $bc9f76eed31c7c6f$export$2e2bcd8739ae039)
    }
};
function $b2f02aa31b602632$var$Introduction({ isReadonly: isReadonly }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const theme = (0, $93h5F.default)();
    const { OrganizationIcon: OrganizationIcon } = $b2f02aa31b602632$var$icons[theme];
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $73aa291f835e531b$export$543dc55cf524ac77,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($73aa291f835e531b$export$a7db06668cad9adb, $85f1f2bcee94130d$export$34e0f9847d4c02dd),
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($73aa291f835e531b$export$aa3e815946b80764, isReadonly && $85f1f2bcee94130d$export$8e16b83750b44988),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)(OrganizationIcon, {
                                className: $73aa291f835e531b$export$1ca1ec8b29a4ce27
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                type: "column",
                                gap: 24,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $85f1f2bcee94130d$export$fb184b623420d9be,
                                        children: t("guide.introduction.title")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                        type: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $85f1f2bcee94130d$export$1a952fe22cdce89e,
                                                children: t("guide.introduction.section_1.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3569b098ce3b425$export$2e2bcd8739ae039), {
                                                title: t("organization_and_member"),
                                                description: t("organization_and_member_description"),
                                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $762145cc85bc40d0$export$2e2bcd8739ae039), {
                                                    label: t("organization"),
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                                        gap: 20,
                                                        style: {
                                                            justifyContent: "center"
                                                        },
                                                        children: [
                                                            Array.from({
                                                                length: 5
                                                            }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
                                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                                                                    name: t("guide.member")
                                                                }, index)),
                                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eba650fb0f342274$export$2e2bcd8739ae039), {
                                                                hasIcon: false,
                                                                name: "......"
                                                            })
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                        type: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $85f1f2bcee94130d$export$1a952fe22cdce89e,
                                                children: t("guide.introduction.section_2.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $85f1f2bcee94130d$export$6d59db4903f20f7d,
                                                children: t("guide.introduction.section_2.description")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3569b098ce3b425$export$2e2bcd8739ae039), {
                                                title: t("guide.organization_permissions"),
                                                description: t("guide.introduction.section_2.permission_description"),
                                                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                                    isEquallyDivided: true,
                                                    gap: 20,
                                                    style: {
                                                        padding: "12px 0",
                                                        justifyContent: "center"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $167f9dc7165146aa$export$2e2bcd8739ae039), {
                                                            name: "read:resource"
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $167f9dc7165146aa$export$2e2bcd8739ae039), {
                                                            name: "edit:resource"
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $167f9dc7165146aa$export$2e2bcd8739ae039), {
                                                            name: "delete:resource"
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $167f9dc7165146aa$export$2e2bcd8739ae039), {
                                                            name: "......",
                                                            isMonospace: false
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3569b098ce3b425$export$2e2bcd8739ae039), {
                                                title: t("guide.organization_roles"),
                                                description: t("guide.introduction.section_2.role_description"),
                                                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                                    isEquallyDivided: true,
                                                    gap: 20,
                                                    children: [
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                                            label: t("guide.admin"),
                                                            permissions: [
                                                                "read:resource",
                                                                "edit:resource",
                                                                "delete:resource"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                                            label: t("guide.member"),
                                                            permissions: [
                                                                "read:resource",
                                                                "edit:resource"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                                            label: t("guide.guest"),
                                                            permissions: [
                                                                "read:resource"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad66e42a1d25c6fa$export$2e2bcd8739ae039), {
                                                            label: "......"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $15fc71b39e47573b$export$2e2bcd8739ae039), {
                                        type: "column",
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $85f1f2bcee94130d$export$1a952fe22cdce89e,
                                                children: t("guide.introduction.section_3.title")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $85f1f2bcee94130d$export$6d59db4903f20f7d,
                                                children: t("guide.introduction.section_3.description")
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1f6dd0dd4a66d07b$export$2e2bcd8739ae039), {})
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            !isReadonly && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 1,
                totalSteps: (0, $fec8fa852791059b$export$64cee2a13326b43d),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "general.next",
                    type: "primary",
                    onClick: ()=>{
                        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).permissions}`);
                    }
                })
            })
        ]
    });
}
var $b2f02aa31b602632$export$2e2bcd8739ae039 = $b2f02aa31b602632$var$Introduction;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $60daba8457847026$var$SvgEdit = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M4.167 15H7.7a.833.833 0 0 0 .592-.242l5.766-5.775 2.367-2.317a.833.833 0 0 0 0-1.183l-3.533-3.575a.833.833 0 0 0-1.184 0l-2.35 2.358-5.783 5.775a.833.833 0 0 0-.242.592v3.534a.833.833 0 0 0 .834.833ZM12.3 3.675l2.358 2.358-1.183 1.183-2.358-2.358L12.3 3.675Zm-7.3 7.3 4.942-4.942L12.3 8.391l-4.942 4.942H5v-2.358Zm12.5 5.691h-15a.834.834 0 0 0 0 1.667h15a.833.833 0 1 0 0-1.666Z",
            fill: "currentColor"
        })
    });
var $60daba8457847026$export$2e2bcd8739ae039 = $60daba8457847026$var$SvgEdit;





var $kMAP9 = parcelRequire("kMAP9");

var $fbeQ6 = parcelRequire("fbeQ6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
const $00040280a7356217$export$da1930f05c3ce270 = (value)=>value.charAt(0).toLowerCase() + value.slice(1);


/**
 * Returns a function that translates a given action and target into a short phrase.
 */ const $e1fc45c1d9052dc3$var$useActionTranslation = ()=>{
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return (0, $eCoWV.useCallback)((action, target)=>t(`general.${action}_field`, {
            field: (0, $00040280a7356217$export$da1930f05c3ce270)(String(t(target)))
        }), [
        t
    ]);
};
var $e1fc45c1d9052dc3$export$2e2bcd8739ae039 = $e1fc45c1d9052dc3$var$useActionTranslation;


var $ed1671474b3de025$export$1ca1ec8b29a4ce27;
$ed1671474b3de025$export$1ca1ec8b29a4ce27 = `v6CNCW_icon`;


/**
 * A button that displays a three-dot icon and opens a menu the following options:
 *
 * - Edit (optional)
 * - Delete
 */ function $716efe74a753793a$var$ActionsButton({ onDelete: onDelete, onEdit: onEdit, deleteConfirmation: deleteConfirmation, fieldName: fieldName, textOverrides: textOverrides }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $e1fc45c1d9052dc3$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const handleDelete = (0, $eCoWV.useCallback)(async ()=>{
        setIsDeleting(true);
        try {
            await onDelete();
        } finally{
            setIsDeleting(false);
            setIsModalOpen(false);
        }
    }, [
        onDelete
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c8927b9279b58d6c$export$2e2bcd8739ae039), {
                    className: $ed1671474b3de025$export$1ca1ec8b29a4ce27
                }),
                title: t("general.more_options"),
                children: [
                    onEdit && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                        iconClassName: $ed1671474b3de025$export$1ca1ec8b29a4ce27,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $60daba8457847026$export$2e2bcd8739ae039), {}),
                        onClick: onEdit,
                        children: textOverrides?.edit ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: textOverrides.edit
                        }) : tAction("edit", fieldName)
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                        type: "danger",
                        onClick: ()=>{
                            setIsModalOpen(true);
                        },
                        children: textOverrides?.delete ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: textOverrides.delete
                        }) : tAction("delete", fieldName)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: isModalOpen,
                confirmButtonText: textOverrides?.deleteConfirmation ?? "general.delete",
                isLoading: isDeleting,
                onCancel: ()=>{
                    setIsModalOpen(false);
                },
                onConfirm: handleDelete,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: deleteConfirmation
                })
            })
        ]
    });
}
var $716efe74a753793a$export$2e2bcd8739ae039 = $716efe74a753793a$var$ActionsButton;



var $9zeGj = parcelRequire("9zeGj");

function $c5e91545b40d865d$var$DateTime({ children: children }) {
    const date = children && new Date(children);
    if (!date || !(0, $a6d1b76cdb8a2161$export$2e2bcd8739ae039)(date)) return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: "-"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: date.toLocaleDateString()
    });
}
var $c5e91545b40d865d$export$2e2bcd8739ae039 = $c5e91545b40d865d$var$DateTime;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

function $25fa274a5b9cf7f9$var$SuspendedTag({ className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        status: "error",
        className: className,
        children: t("user_details.suspended")
    });
}
var $25fa274a5b9cf7f9$export$2e2bcd8739ae039 = $25fa274a5b9cf7f9$var$SuspendedTag;





/** A component that renders a preview of a user. It's useful for displaying a user in a list. */ function $ef60daefc2bdaaa2$var$UserPreview({ user: user }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
        title: (0, $3f85170a081a517a$export$5f7a1baecd59f846)(user),
        subtitle: (0, $3f85170a081a517a$export$336d714c72178bf2)(user),
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
            size: "large",
            user: user
        }),
        to: `/users/${user.id}`,
        suffix: (0, $5CQIb.conditional)(user.isSuspended && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25fa274a5b9cf7f9$export$2e2bcd8739ae039), {}))
    });
}
var $ef60daefc2bdaaa2$export$2e2bcd8739ae039 = $ef60daefc2bdaaa2$var$UserPreview;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $9d526652203f47b7$var$SvgRoleFeature = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 40,
        viewBox: "0 0 40 40",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 40,
                height: 40,
                rx: 6,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 19.792,
                cy: 13.5,
                r: 6.5,
                fill: "url(#paint0_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12.194,
                y: 11.889,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 23.167,
                y: 11.889,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 28.584A6.583 6.583 0 0 1 16.584 22h6.832A6.583 6.583 0 0 1 30 28.584v2.221A2.194 2.194 0 0 1 27.805 33h-15.61A2.194 2.194 0 0 1 10 30.805v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M27.2 22a.6.6 0 0 0-.6.6v3.6a.6.6 0 0 0 .6.6h3.6a.6.6 0 0 0 .6-.6v-3.6a.6.6 0 0 0-.6-.6h-3.6Zm-3.6 7.2a.6.6 0 0 0-.6.6v3.6a.6.6 0 0 0 .6.6h3.6a.6.6 0 0 0 .6-.6v-3.6a.6.6 0 0 0-.6-.6h-3.6Zm6.6.6a.6.6 0 0 1 .6-.6h3.6a.6.6 0 0 1 .6.6v3.6a.6.6 0 0 1-.6.6h-3.6a.6.6 0 0 1-.6-.6v-3.6Zm-5.4-1.2a1.2 1.2 0 0 1 1.2-1.2h2.4v-.6h1.2v.6H32a1.2 1.2 0 0 1 1.2 1.2v.6H32v-.6h-6v.6h-1.2v-.6Z",
                fill: "url(#paint1_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M27.8 23.2v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint2_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24.2 30.4v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint3_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M31.4 30.4v2.4h2.4v-2.4h-2.4Z",
                fill: "url(#paint4_linear_897_8053)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_897_8053",
                        x1: 15.526,
                        y1: 18.24,
                        x2: 24.261,
                        y2: 8.896,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_897_8053",
                        x1: 25.063,
                        y1: 32.375,
                        x2: 33.125,
                        y2: 23.75,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5D34F2"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FF88FA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_897_8053",
                        x1: 27.833,
                        y1: 24.31,
                        x2: 30.2,
                        y2: 24.31,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_897_8053",
                        x1: 24.233,
                        y1: 31.509,
                        x2: 26.6,
                        y2: 31.509,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_897_8053",
                        x1: 31.433,
                        y1: 31.51,
                        x2: 33.8,
                        y2: 31.51,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $9d526652203f47b7$export$2e2bcd8739ae039 = $9d526652203f47b7$var$SvgRoleFeature;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $iHViS = parcelRequire("iHViS");

var $6jNMj = parcelRequire("6jNMj");

var $6PcpQ = parcelRequire("6PcpQ");


var $9bgsA = parcelRequire("9bgsA");


function $b45be41e304f3631$var$MultiSelect({ className: className, value: value, options: options, onSearch: onSearch, onChange: onChange, isReadOnly: isReadOnly, error: error, placeholder: placeholder, isOptionsLoading: isOptionsLoading, renderOption: renderOption = ({ title: title, value: value })=>title ?? value }) {
    const inputRef = (0, $eCoWV.useRef)(null);
    const selectRef = (0, $eCoWV.useRef)(null);
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const [isInputFocused, setIsInputFocused] = (0, $eCoWV.useState)(false);
    // Used to focus on the last tag to perform deletion
    const [focusedValue, setFocusedValue] = (0, $eCoWV.useState)(null);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    // Search on keyword changes
    (0, $eCoWV.useEffect)(()=>{
        if (isInputFocused) onSearch(keyword);
    }, [
        keyword,
        isInputFocused,
        onSearch
    ]);
    const handleSelect = (option)=>{
        if (value.some(({ value: value })=>value === option.value)) return;
        onChange([
            ...value,
            option
        ]);
        setKeyword("");
        inputRef.current?.focus();
    };
    const handleDelete = (option)=>{
        onChange(value.filter(({ value: value })=>value !== option.value));
    };
    // https://exogen.github.io/blog/focus-state/
    (0, $eCoWV.useEffect)(()=>{
        if (document.hasFocus() && inputRef.current?.contains(document.activeElement)) setIsInputFocused(true);
    }, []);
    const isOpen = !isReadOnly && isInputFocused && !focusedValue;
    const filteredOptions = options.filter(({ value: current })=>{
        return !value.some(({ value: value })=>value === current);
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: selectRef,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($14a941e7f738b0de$export$2e6c959c16ff56b8, $14a941e7f738b0de$export$939ddaa3205df08e, isOpen && $14a941e7f738b0de$export$3ce6949f20cea765, isReadOnly && $14a941e7f738b0de$export$b2cbc93d4da94977, Boolean(error) && $14a941e7f738b0de$export$a3bc9b8ed74fc, className),
        role: "button",
        tabIndex: 0,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            if (!isReadOnly) inputRef.current?.focus();
        }),
        onClick: ()=>{
            if (!isReadOnly) inputRef.current?.focus();
        },
        children: [
            value.map((option)=>{
                return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                    variant: "cell",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($14a941e7f738b0de$export$2b067c6666111485, option.value === focusedValue && $14a941e7f738b0de$export$4c2b230493b2b322),
                    onClick: (event)=>{
                        event.stopPropagation();
                    },
                    children: [
                        renderOption(option),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            className: $14a941e7f738b0de$export$1822828d790e23ee,
                            size: "small",
                            onClick: ()=>{
                                handleDelete(option);
                            },
                            onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                                handleDelete(option);
                            }),
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                                className: $14a941e7f738b0de$export$8360e631d277ea4d
                            })
                        })
                    ]
                }, option.value);
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                ref: inputRef,
                type: "text",
                placeholder: (0, $5CQIb.cond)(value.length === 0 && placeholder && String(t(placeholder))),
                value: keyword,
                onKeyDown: (event)=>{
                    if (event.key === "Backspace" && keyword === "") {
                        if (focusedValue) {
                            onChange(value.filter(({ value: value })=>value !== focusedValue));
                            setFocusedValue(null);
                        } else setFocusedValue(value.at(-1)?.value ?? null);
                        event.stopPropagation();
                    }
                },
                onChange: ({ currentTarget: { value: value } })=>{
                    setKeyword(value);
                    setFocusedValue(null);
                },
                onFocus: ()=>{
                    setIsInputFocused(true);
                },
                onBlur: ()=>{
                    setIsInputFocused(false);
                    setFocusedValue(null);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $2b49de81819d0209$export$2e2bcd8739ae039), {
                isFullWidth: true,
                noOverlay: true,
                isOpen: isOpen,
                className: $14a941e7f738b0de$export$81207e5cc4186890,
                anchorRef: selectRef,
                children: [
                    isOptionsLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {
                        className: $14a941e7f738b0de$export$641374ffb95bc399
                    }),
                    !isOptionsLoading && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            filteredOptions.length === 0 && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $14a941e7f738b0de$export$17aca76bf89ef49e,
                                children: t("errors.empty")
                            }),
                            filteredOptions.map((option)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                                    onClick: (event)=>{
                                        event.preventDefault();
                                        handleSelect(option);
                                    },
                                    children: renderOption(option)
                                }, option.value))
                        ]
                    })
                ]
            })
        ]
    });
}
var $b45be41e304f3631$export$2e2bcd8739ae039 = $b45be41e304f3631$var$MultiSelect;



var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");

var $6ZMK7 = parcelRequire("6ZMK7");

var $h7VLF = parcelRequire("h7VLF");
const $2c4bcd56964a1bef$var$useSearchValues = (pathname, keyword)=>{
    const { data: response, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(pathname, {
        page: String(1),
        page_size: String((0, $6ZMK7.defaultPageSize)),
        q: keyword
    }), {
        revalidateOnFocus: false
    });
    const [data] = response ?? [
        [],
        0
    ];
    return (0, $eCoWV.useMemo)(()=>({
            isLoading: !response && !error,
            data: data,
            mutate: mutate,
            error: error
        }), [
        data,
        error,
        mutate,
        response
    ]);
};
var $2c4bcd56964a1bef$export$2e2bcd8739ae039 = $2c4bcd56964a1bef$var$useSearchValues;



var $9zeGj = parcelRequire("9zeGj");
var $c070109206a852bc$export$743d887d09c13b13;
$c070109206a852bc$export$743d887d09c13b13 = `wAHLyq_breakable`;


/**
 * A component that can be used to render text that can be broken into multiple lines. It
 * wraps the children with a div and applies `word-break: break-word` and
 * `overflow-wrap: break-word` to it.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/word-break | word-break in MDN}
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/CSS/overflow-wrap | overflow-wrap in MDN}
 */ function $be95a5f425bfc2aa$var$Breakable({ children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $c070109206a852bc$export$743d887d09c13b13,
        children: children
    });
}
var $be95a5f425bfc2aa$export$2e2bcd8739ae039 = $be95a5f425bfc2aa$var$Breakable;



var $e66634a77d5e39c4$export$f09585a853dddd32;
var $e66634a77d5e39c4$export$f8907ddf2999bb8a;
var $e66634a77d5e39c4$export$bfd64c937657f93a;
var $e66634a77d5e39c4$export$4a6dd88bada4e7d2;
$e66634a77d5e39c4$export$f09585a853dddd32 = `FQBl7a_large`;
$e66634a77d5e39c4$export$f8907ddf2999bb8a = `FQBl7a_roleOption`;
$e66634a77d5e39c4$export$bfd64c937657f93a = `FQBl7a_rotating`;
$e66634a77d5e39c4$export$4a6dd88bada4e7d2 = `FQBl7a_shimmer`;


function $6d516a7c4b867a01$export$9b2040b3fe7f4e3f({ title: title, value: value, size: size = "small" }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($e66634a77d5e39c4$export$f8907ddf2999bb8a, size === "large" && $e66634a77d5e39c4$export$f09585a853dddd32),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3dc4aee746c180b4$export$2e2bcd8739ae039), {
                for: (0, $9d526652203f47b7$export$2e2bcd8739ae039),
                size: size === "small" ? 16 : 40
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $be95a5f425bfc2aa$export$2e2bcd8739ae039), {
                children: title ?? value
            })
        ]
    });
}
function $6d516a7c4b867a01$var$OrganizationRolesSelect({ value: value, onChange: onChange, keyword: keyword, setKeyword: setKeyword }) {
    const { data: scopes, isLoading: isLoading } = (0, $2c4bcd56964a1bef$export$2e2bcd8739ae039)("api/organization-roles", keyword);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b45be41e304f3631$export$2e2bcd8739ae039), {
        value: value,
        options: scopes.map(({ id: id, name: name })=>({
                value: id,
                title: name
            })),
        placeholder: "organizations.search_role_placeholder",
        isOptionsLoading: isLoading,
        renderOption: $6d516a7c4b867a01$export$9b2040b3fe7f4e3f,
        onChange: onChange,
        onSearch: setKeyword
    });
}
var $6d516a7c4b867a01$export$2e2bcd8739ae039 = $6d516a7c4b867a01$var$OrganizationRolesSelect;



var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");





var $2ANSb = parcelRequire("2ANSb");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");



var $6ZMK7 = parcelRequire("6ZMK7");

var $fbeQ6 = parcelRequire("fbeQ6");


var $hdJkM = parcelRequire("hdJkM");



var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");


var $6PcpQ = parcelRequire("6PcpQ");
var $2706456651b68f20$export$1ca1ec8b29a4ce27;
var $2706456651b68f20$export$7061c75fc5af8b7e;
var $2706456651b68f20$export$bfd64c937657f93a;
var $2706456651b68f20$export$4a6dd88bada4e7d2;
var $2706456651b68f20$export$9c4e203df590c544;
var $2706456651b68f20$export$fb184b623420d9be;
$2706456651b68f20$export$1ca1ec8b29a4ce27 = `Y0u9ea_icon`;
$2706456651b68f20$export$7061c75fc5af8b7e = `Y0u9ea_item`;
$2706456651b68f20$export$bfd64c937657f93a = `Y0u9ea_rotating`;
$2706456651b68f20$export$4a6dd88bada4e7d2 = `Y0u9ea_shimmer`;
$2706456651b68f20$export$9c4e203df590c544 = `Y0u9ea_suspended`;
$2706456651b68f20$export$fb184b623420d9be = `Y0u9ea_title`;


function $e50da971edb537f5$var$SourceEntityItem({ entity: entity, isSelected: isSelected, onSelect: onSelect, render: render }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        role: "button",
        tabIndex: 0,
        className: $2706456651b68f20$export$7061c75fc5af8b7e,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
            onSelect();
        }),
        onClick: ()=>{
            onSelect();
        },
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect();
                }
            }),
            render(entity)
        ]
    });
}
var $e50da971edb537f5$export$2e2bcd8739ae039 = $e50da971edb537f5$var$SourceEntityItem;


var $1214789a1ab820b8$export$1ca1ec8b29a4ce27;
var $1214789a1ab820b8$export$d76128d007d19019;
$1214789a1ab820b8$export$1ca1ec8b29a4ce27 = `Nr_Nla_icon`;
$1214789a1ab820b8$export$d76128d007d19019 = `Nr_Nla_search`;


const $e34c1dbe36064de7$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $e34c1dbe36064de7$var$SourceEntitiesBox({ searchProps: { pathname: pathname, parameters: parameters }, selectedEntities: selectedEntities, onChange: onChange, emptyPlaceholder: emptyPlaceholder, renderEntity: renderEntity }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const debounce = (0, $e92af1f6c236dce4$export$2e2bcd8739ae039)();
    const commonSearchParams = {
        page: String(page),
        page_size: String($e34c1dbe36064de7$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    };
    const { data: data, error: error } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(pathname, {
        ...parameters,
        ...commonSearchParams
    }));
    const isLoading = !data && !error;
    const [dataSource = [], totalCount] = data ?? [];
    const handleSearchInput = (event)=>{
        debounce(()=>{
            setPage(1);
            setKeyword(event.target.value);
        });
    };
    const isEntityAdded = (entity)=>selectedEntities.findIndex(({ id: id })=>id === entity.id) >= 0;
    const isEmpty = !isLoading && !error && dataSource.length === 0;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    className: $1214789a1ab820b8$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                        className: $1214789a1ab820b8$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$a03f626b8106969c, isEmpty && $d9a7729c7b9aa700$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {
                    size: "small",
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: emptyPlaceholder
                    })
                }) : dataSource.map((entity)=>{
                    const isSelected = isEntityAdded(entity);
                    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e50da971edb537f5$export$2e2bcd8739ae039), {
                        entity: entity,
                        isSelected: isSelected,
                        render: renderEntity,
                        onSelect: ()=>{
                            onChange(isSelected ? selectedEntities.filter(({ id: id })=>entity.id !== id) : [
                                entity,
                                ...selectedEntities
                            ]);
                        }
                    }, entity.id);
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $226d823c87c084c3$export$2e2bcd8739ae039), {
                mode: "pico",
                page: page,
                totalCount: totalCount,
                pageSize: $e34c1dbe36064de7$var$pageSize,
                className: $d9a7729c7b9aa700$export$eda11a42e6b44edc,
                onChange: (page)=>{
                    setPage(page);
                }
            })
        ]
    });
}
var $e34c1dbe36064de7$export$2e2bcd8739ae039 = $e34c1dbe36064de7$var$SourceEntitiesBox;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");

var $iHViS = parcelRequire("iHViS");

var $9bgsA = parcelRequire("9bgsA");
var $c8974ab2d8d808e8$export$1ca1ec8b29a4ce27;
var $c8974ab2d8d808e8$export$7061c75fc5af8b7e;
var $c8974ab2d8d808e8$export$6990040ee07315;
var $c8974ab2d8d808e8$export$bfd64c937657f93a;
var $c8974ab2d8d808e8$export$4a6dd88bada4e7d2;
var $c8974ab2d8d808e8$export$9c4e203df590c544;
var $c8974ab2d8d808e8$export$fb184b623420d9be;
$c8974ab2d8d808e8$export$1ca1ec8b29a4ce27 = `-f8eNq_icon`;
$c8974ab2d8d808e8$export$7061c75fc5af8b7e = `-f8eNq_item`;
$c8974ab2d8d808e8$export$6990040ee07315 = `-f8eNq_meta`;
$c8974ab2d8d808e8$export$bfd64c937657f93a = `-f8eNq_rotating`;
$c8974ab2d8d808e8$export$4a6dd88bada4e7d2 = `-f8eNq_shimmer`;
$c8974ab2d8d808e8$export$9c4e203df590c544 = `-f8eNq_suspended`;
$c8974ab2d8d808e8$export$fb184b623420d9be = `-f8eNq_title`;


function $d5f5178e3a2d37fb$var$TargetEntityItem({ entity: entity, render: render, onDelete: onDelete }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $c8974ab2d8d808e8$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $c8974ab2d8d808e8$export$6990040ee07315,
                children: render(entity)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                size: "small",
                onClick: ()=>{
                    onDelete();
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
            })
        ]
    });
}
var $d5f5178e3a2d37fb$export$2e2bcd8739ae039 = $d5f5178e3a2d37fb$var$TargetEntityItem;


var $a1da1faf5f59de9a$export$80f73db1a407fae0;
$a1da1faf5f59de9a$export$80f73db1a407fae0 = `OoY2hq_added`;


function $daa9cfb78ab64712$var$TargetEntitiesBox({ renderEntity: renderEntity, selectedEntities: selectedEntities, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                    className: $a1da1faf5f59de9a$export$80f73db1a407fae0,
                    children: [
                        `${selectedEntities.length} `,
                        t("general.added")
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$a03f626b8106969c,
                children: selectedEntities.map((entity)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $d5f5178e3a2d37fb$export$2e2bcd8739ae039), {
                        entity: entity,
                        render: renderEntity,
                        onDelete: ()=>{
                            onChange(selectedEntities.filter(({ id: id })=>id !== entity.id));
                        }
                    }, entity.id))
            })
        ]
    });
}
var $daa9cfb78ab64712$export$2e2bcd8739ae039 = $daa9cfb78ab64712$var$TargetEntitiesBox;


var $4e1db1a163fee059$export$493b5823483d2c4e;
var $4e1db1a163fee059$export$a9c4b5b7bc92a147;
var $4e1db1a163fee059$export$bfd64c937657f93a;
var $4e1db1a163fee059$export$4a6dd88bada4e7d2;
$4e1db1a163fee059$export$493b5823483d2c4e = `zPwfGa_errorMessage`;
$4e1db1a163fee059$export$a9c4b5b7bc92a147 = `zPwfGa_rolesTransfer`;
$4e1db1a163fee059$export$bfd64c937657f93a = `zPwfGa_rotating`;
$4e1db1a163fee059$export$4a6dd88bada4e7d2 = `zPwfGa_shimmer`;


function $44c5435b872fb25e$var$EntitiesTransfer({ errorMessage: errorMessage, ...props }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$34e0f9847d4c02dd, $4e1db1a163fee059$export$a9c4b5b7bc92a147),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e34c1dbe36064de7$export$2e2bcd8739ae039), {
                        ...props
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $d9a7729c7b9aa700$export$d999e528e771887b
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $daa9cfb78ab64712$export$2e2bcd8739ae039), {
                        ...props
                    })
                ]
            }),
            errorMessage && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $4e1db1a163fee059$export$493b5823483d2c4e,
                children: errorMessage
            })
        ]
    });
}
var $44c5435b872fb25e$export$2e2bcd8739ae039 = $44c5435b872fb25e$var$EntitiesTransfer;



var $9zeGj = parcelRequire("9zeGj");




var $0d8e03c22b2ce799$export$1ca1ec8b29a4ce27;
var $0d8e03c22b2ce799$export$bfd64c937657f93a;
var $0d8e03c22b2ce799$export$4a6dd88bada4e7d2;
var $0d8e03c22b2ce799$export$9c4e203df590c544;
var $0d8e03c22b2ce799$export$fb184b623420d9be;
$0d8e03c22b2ce799$export$1ca1ec8b29a4ce27 = `da450q_icon`;
$0d8e03c22b2ce799$export$bfd64c937657f93a = `da450q_rotating`;
$0d8e03c22b2ce799$export$4a6dd88bada4e7d2 = `da450q_shimmer`;
$0d8e03c22b2ce799$export$9c4e203df590c544 = `da450q_suspended`;
$0d8e03c22b2ce799$export$fb184b623420d9be = `da450q_title`;


function $2189af2994a8c825$export$7d5b61b2bb96bf4d({ entity: entity }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                hasTooltip: true,
                user: entity,
                size: "micro"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $0d8e03c22b2ce799$export$fb184b623420d9be,
                children: (0, $3f85170a081a517a$export$5f7a1baecd59f846)(entity)
            }),
            entity.isSuspended && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25fa274a5b9cf7f9$export$2e2bcd8739ae039), {
                className: $0d8e03c22b2ce799$export$9c4e203df590c544
            })
        ]
    });
}
function $2189af2994a8c825$export$a42ffac851fa6a76({ entity: entity }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                type: entity.type,
                className: $0d8e03c22b2ce799$export$1ca1ec8b29a4ce27
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $0d8e03c22b2ce799$export$fb184b623420d9be,
                children: entity.name
            })
        ]
    });
}




var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");


var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");
function $d9d1cd6f2b836480$var$AddMembersToOrganization({ organization: organization, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $e1fc45c1d9052dc3$export$2e2bcd8739ae039)();
    const api = (0, $2ANSb.default)();
    const { reset: reset, control: control, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        defaultValues: {
            users: [],
            scopes: []
        }
    });
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        await api.post(`api/organizations/${organization.id}/users`, {
            json: {
                userIds: data.users.map(({ id: id })=>id)
            }
        });
        if (data.scopes.length > 0) await api.post(`api/organizations/${organization.id}/users/roles`, {
            json: {
                userIds: data.users.map(({ id: id })=>id),
                organizationRoleIds: data.scopes.map(({ value: value })=>value)
            }
        });
        onClose();
    }));
    (0, $eCoWV.useEffect)(()=>{
        if (isOpen) {
            reset();
            setKeyword("");
        }
    }, [
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            size: "large",
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: t("organization_details.add_members_to_organization", {
                    name: organization.name
                })
            }),
            subtitle: "organization_details.add_members_to_organization_description",
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                size: "large",
                type: "primary",
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                    children: tAction("add", "organization_details.member_other")
                }),
                onClick: onSubmit
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "organization_details.member_other",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "users",
                        control: control,
                        rules: {
                            validate: (value)=>{
                                if (value.length === 0) return t("organization_details.at_least_one_user");
                                return true;
                            }
                        },
                        render: ({ field: { onChange: onChange, value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $44c5435b872fb25e$export$2e2bcd8739ae039), {
                                errorMessage: error?.message,
                                searchProps: {
                                    pathname: "api/users",
                                    parameters: {
                                        excludeOrganizationId: organization.id
                                    }
                                },
                                selectedEntities: value,
                                emptyPlaceholder: "errors.empty",
                                renderEntity: (entity)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2189af2994a8c825$export$7d5b61b2bb96bf4d), {
                                        entity: entity
                                    }),
                                onChange: onChange
                            })
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "organization_details.add_with_organization_role",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "scopes",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d516a7c4b867a01$export$2e2bcd8739ae039), {
                                keyword: keyword,
                                setKeyword: setKeyword,
                                value: value,
                                onChange: onChange
                            })
                    })
                })
            ]
        })
    });
}
var $d9d1cd6f2b836480$export$2e2bcd8739ae039 = $d9d1cd6f2b836480$var$AddMembersToOrganization;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");


var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");

function $917583a2bc0c99b9$var$EditOrganizationRolesModal({ organizationId: organizationId, user: user, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const [roles, setRoles] = (0, $eCoWV.useState)(user.organizationRoles.map(({ id: id, name: name })=>({
            value: id,
            title: name
        })));
    const name = user.name ?? (0, $00040280a7356217$export$da1930f05c3ce270)(t("organization_details.user"));
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const onSubmit = async ()=>{
        setIsLoading(true);
        try {
            await api.put(`api/organizations/${organizationId}/users/${user.id}/roles`, {
                json: {
                    organizationRoleIds: roles.map(({ value: value })=>value)
                }
            });
            onClose();
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                children: t("organization_details.edit_organization_roles_of_user", {
                    name: name
                })
            }),
            subtitle: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
                children: t("organization_details.authorize_to_roles", {
                    name: name
                })
            }),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "large",
                type: "primary",
                title: "general.save",
                isLoading: isLoading,
                onClick: onSubmit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "organizations.organization_role_other",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d516a7c4b867a01$export$2e2bcd8739ae039), {
                    value: roles,
                    keyword: keyword,
                    setKeyword: setKeyword,
                    onChange: setRoles
                })
            })
        })
    });
}
var $917583a2bc0c99b9$export$2e2bcd8739ae039 = $917583a2bc0c99b9$var$EditOrganizationRolesModal;


var $f699696f8f1157eb$export$3dea766d36a8935f;
var $f699696f8f1157eb$export$8e77a375f9a5908e;
var $f699696f8f1157eb$export$bfd64c937657f93a;
var $f699696f8f1157eb$export$4a6dd88bada4e7d2;
$f699696f8f1157eb$export$3dea766d36a8935f = `HFfI9G_filter`;
$f699696f8f1157eb$export$8e77a375f9a5908e = `HFfI9G_roles`;
$f699696f8f1157eb$export$bfd64c937657f93a = `HFfI9G_rotating`;
$f699696f8f1157eb$export$4a6dd88bada4e7d2 = `HFfI9G_shimmer`;


const $b23d33b1df9fe1a5$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $b23d33b1df9fe1a5$var$Members({ organization: organization }) {
    const api = (0, $2ANSb.default)();
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const { data: response, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(`api/organizations/${organization.id}/users`, {
        q: keyword,
        page: String(page),
        page_size: String($b23d33b1df9fe1a5$var$pageSize)
    }));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $e1fc45c1d9052dc3$export$2e2bcd8739ae039)();
    const [isModalOpen, setIsModalOpen] = (0, $eCoWV.useState)(false);
    const [userToBeEdited, setUserToBeEdited] = (0, $eCoWV.useState)();
    const isLoading = !response && !error;
    const [data, totalCount] = response ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                isRowHoverEffectDisabled: true,
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
                pagination: {
                    page: page,
                    totalCount: totalCount,
                    pageSize: $b23d33b1df9fe1a5$var$pageSize,
                    onChange: setPage
                },
                isLoading: isLoading,
                errorMessage: error?.toString(),
                rowGroups: [
                    {
                        key: "data",
                        data: data
                    }
                ],
                columns: [
                    {
                        dataIndex: "user",
                        title: "User",
                        colSpan: 4,
                        render: (user)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $ef60daefc2bdaaa2$export$2e2bcd8739ae039), {
                                user: user
                            })
                    },
                    {
                        dataIndex: "roles",
                        title: "Organization roles",
                        colSpan: 6,
                        render: ({ organizationRoles: organizationRoles })=>{
                            if (organizationRoles.length === 0) return "-";
                            return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $f699696f8f1157eb$export$8e77a375f9a5908e,
                                children: organizationRoles.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                        variant: "cell",
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d516a7c4b867a01$export$9b2040b3fe7f4e3f), {
                                            value: id,
                                            title: name
                                        })
                                    }, id))
                            });
                        }
                    },
                    {
                        dataIndex: "lastSignInAt",
                        title: "Last sign-in",
                        colSpan: 5,
                        render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $c5e91545b40d865d$export$2e2bcd8739ae039), {
                                children: lastSignInAt
                            })
                    },
                    {
                        dataIndex: "actions",
                        title: null,
                        colSpan: 1,
                        render: (user)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $716efe74a753793a$export$2e2bcd8739ae039), {
                                deleteConfirmation: "organization_details.remove_user_from_organization_description",
                                fieldName: "organization_details.user",
                                textOverrides: {
                                    edit: "organization_details.edit_organization_roles",
                                    delete: "organization_details.remove_user_from_organization",
                                    deleteConfirmation: "general.remove"
                                },
                                onEdit: ()=>{
                                    setUserToBeEdited(user);
                                },
                                onDelete: async ()=>{
                                    await api.delete(`api/organizations/${organization.id}/users/${user.id}`);
                                    mutate();
                                }
                            })
                    }
                ],
                rowIndexKey: "id",
                filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $f699696f8f1157eb$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("organization_details.search_user_placeholder"),
                            onSearch: (value)=>{
                                setKeyword(value);
                                setPage(1);
                            },
                            onClearSearch: ()=>{
                                setKeyword("");
                                setPage(1);
                            }
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            size: "large",
                            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                                children: tAction("add", "organization_details.member")
                            }),
                            type: "primary",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsModalOpen(true);
                            }
                        })
                    ]
                })
            }),
            userToBeEdited && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $917583a2bc0c99b9$export$2e2bcd8739ae039), {
                isOpen: true,
                organizationId: organization.id,
                user: userToBeEdited,
                onClose: ()=>{
                    setUserToBeEdited(undefined);
                    mutate();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d9d1cd6f2b836480$export$2e2bcd8739ae039), {
                organization: organization,
                isOpen: isModalOpen,
                onClose: ()=>{
                    setIsModalOpen(false);
                    mutate();
                }
            })
        ]
    });
}
var $b23d33b1df9fe1a5$export$2e2bcd8739ae039 = $b23d33b1df9fe1a5$var$Members;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");




var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $bSFEw = parcelRequire("bSFEw");
function $b57d4eba5e02b2ef$var$Settings({ isDeleting: isDeleting, data: data, onUpdated: onUpdated }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, reset: reset, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)({
        defaultValues: data
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (json)=>{
        if (isSubmitting) return;
        const updatedData = await api.patch(`api/organizations/${data.id}`, {
            json: json
        }).json();
        reset(updatedData);
        (0, $horhC.toast).success(t("general.saved"));
        onUpdated(updatedData);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
        isDirty: isDirty,
        isSubmitting: isSubmitting,
        onDiscard: reset,
        onSubmit: onSubmit,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                title: "general.settings_nav",
                description: "organization_details.settings_description",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("organization_details.name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "general.description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            placeholder: t("organization_details.description_placeholder"),
                            ...register("description")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $b57d4eba5e02b2ef$export$2e2bcd8739ae039 = $b57d4eba5e02b2ef$var$Settings;


var $3c3734dc9a8e2ca6$export$38e42c68cf43b5d4;
var $3c3734dc9a8e2ca6$export$1237798dc640739a;
var $3c3734dc9a8e2ca6$export$dbb5e893e736e4ee;
var $3c3734dc9a8e2ca6$export$a8ff84c12d48cfa6;
var $3c3734dc9a8e2ca6$export$523fb3936f49e028;
var $3c3734dc9a8e2ca6$export$bfd64c937657f93a;
var $3c3734dc9a8e2ca6$export$120ff0929b202a6d;
var $3c3734dc9a8e2ca6$export$4a6dd88bada4e7d2;
$3c3734dc9a8e2ca6$export$38e42c68cf43b5d4 = `sCS0zG_header`;
$3c3734dc9a8e2ca6$export$1237798dc640739a = `sCS0zG_label`;
$3c3734dc9a8e2ca6$export$dbb5e893e736e4ee = `sCS0zG_metadata`;
$3c3734dc9a8e2ca6$export$a8ff84c12d48cfa6 = `sCS0zG_name`;
$3c3734dc9a8e2ca6$export$523fb3936f49e028 = `sCS0zG_page`;
$3c3734dc9a8e2ca6$export$bfd64c937657f93a = `sCS0zG_rotating`;
$3c3734dc9a8e2ca6$export$120ff0929b202a6d = `sCS0zG_row`;
$3c3734dc9a8e2ca6$export$4a6dd88bada4e7d2 = `sCS0zG_shimmer`;


const $89f71c55405f67fe$var$pathname = "/organizations";
const $89f71c55405f67fe$var$tabs = Object.freeze({
    settings: "settings",
    members: "members"
});
function $89f71c55405f67fe$var$OrganizationDetails() {
    const { id: id } = (0, $9X5Bp.useParams)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && `api/organizations/${id}`);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const [isGuideDrawerOpen, setIsGuideDrawerOpen] = (0, $eCoWV.useState)(false);
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const deleteOrganization = (0, $eCoWV.useCallback)(async ()=>{
        if (!id || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/organizations/${id}`);
            navigate($89f71c55405f67fe$var$pathname);
        } finally{
            setIsDeleting(false);
        }
    }, [
        api,
        id,
        isDeleting,
        navigate
    ]);
    const isLoading = !data && !error;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: $89f71c55405f67fe$var$pathname,
        backLinkTitle: "organizations.title",
        className: $3c3734dc9a8e2ca6$export$523fb3936f49e028,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "organization_details.page_title"
            }),
            isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3f9b15e0b0084c45$export$2e2bcd8739ae039), {}),
            error && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
                errorCode: error.body?.code,
                errorMessage: error.body?.message
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3dc4aee746c180b4$export$2e2bcd8739ae039), {
                            for: (0, $11c317f8d53fc2a7$export$2e2bcd8739ae039),
                            size: 60
                        }),
                        title: data.name,
                        identifier: {
                            name: t("organization_details.organization_id"),
                            value: data.id
                        },
                        additionalActionButton: {
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7529b38878187ba2$export$2e2bcd8739ae039), {}),
                            title: "application_details.check_guide",
                            onClick: ()=>{
                                setIsGuideDrawerOpen(true);
                            }
                        },
                        actionMenuItems: [
                            {
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                title: "general.delete",
                                type: "danger",
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $23b42f3bf1cd82d7$export$2e2bcd8739ae039), {
                        title: "organizations.guide.title",
                        subtitle: "organizations.guide.subtitle",
                        isOpen: isGuideDrawerOpen,
                        onClose: ()=>{
                            setIsGuideDrawerOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b2f02aa31b602632$export$2e2bcd8739ae039), {
                            isReadonly: true
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: deleteOrganization,
                        children: t("organization_details.delete_confirmation")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `${$89f71c55405f67fe$var$pathname}/${data.id}/${$89f71c55405f67fe$var$tabs.settings}`,
                                children: t("general.settings_nav")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `${$89f71c55405f67fe$var$pathname}/${data.id}/${$89f71c55405f67fe$var$tabs.members}`,
                                children: t("organizations.members")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                index: true,
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                    replace: true,
                                    to: $89f71c55405f67fe$var$tabs.settings
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: $89f71c55405f67fe$var$tabs.settings,
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b57d4eba5e02b2ef$export$2e2bcd8739ae039), {
                                    isDeleting: isDeleting,
                                    data: data,
                                    onUpdated: async (data)=>mutate(data)
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: $89f71c55405f67fe$var$tabs.members,
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b23d33b1df9fe1a5$export$2e2bcd8739ae039), {
                                    organization: data
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $89f71c55405f67fe$export$2e2bcd8739ae039 = $89f71c55405f67fe$var$OrganizationDetails;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $a0Ubj = parcelRequire("a0Ubj");

var $V1X8c = parcelRequire("V1X8c");


var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $lSA0o = parcelRequire("lSA0o");




var $4W0F0 = parcelRequire("4W0F0");


var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");



var $V1X8c = parcelRequire("V1X8c");

var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");
function $7144984399a479cd$var$CreateOrganizationModal({ isOpen: isOpen, onClose: onClose }) {
    const api = (0, $2ANSb.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const isOrganizationsDisabled = (0, $V1X8c.isCloud) && !currentPlan?.quota.organizationsEnabled;
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)();
    const submit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (json)=>{
        const { id: id } = await api.post("api/organizations", {
            json: json
        }).json();
        onClose(id);
    }));
    // Reset form on open
    (0, $eCoWV.useEffect)(()=>{
        if (isOpen) reset({});
    }, [
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "organizations.create_organization",
            footer: isOrganizationsDisabled ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.organizations")
                })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                title: "general.create",
                isLoading: isSubmitting,
                onClick: submit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: t("organizations.organization_name_placeholder"),
                            error: Boolean(errors.name),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "general.description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            error: Boolean(errors.description),
                            placeholder: t("organizations.organization_description_placeholder"),
                            ...register("description")
                        })
                    })
                ]
            })
        })
    });
}
var $7144984399a479cd$export$2e2bcd8739ae039 = $7144984399a479cd$var$CreateOrganizationModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");




var $6ZMK7 = parcelRequire("6ZMK7");

var $47yah = parcelRequire("47yah");



var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $iyeK6 = parcelRequire("iyeK6");



var $fbeQ6 = parcelRequire("fbeQ6");
var $cff4f3d989d1ca35$export$fae01a4f5c829e19;
var $cff4f3d989d1ca35$export$345c5736c8054f22;
var $cff4f3d989d1ca35$export$31d6f2c3562ba09e;
var $cff4f3d989d1ca35$export$85b9a36db797e02b;
var $cff4f3d989d1ca35$export$6e22c362a0406a2c;
var $cff4f3d989d1ca35$export$5345fd892b40e1f6;
var $cff4f3d989d1ca35$export$bfd64c937657f93a;
var $cff4f3d989d1ca35$export$4a6dd88bada4e7d2;
$cff4f3d989d1ca35$export$fae01a4f5c829e19 = `UErFpq_applicationIcon`;
$cff4f3d989d1ca35$export$345c5736c8054f22 = `UErFpq_avatar`;
$cff4f3d989d1ca35$export$31d6f2c3562ba09e = `UErFpq_avatars`;
$cff4f3d989d1ca35$export$85b9a36db797e02b = `UErFpq_count`;
$cff4f3d989d1ca35$export$6e22c362a0406a2c = `UErFpq_empty`;
$cff4f3d989d1ca35$export$5345fd892b40e1f6 = `UErFpq_entities`;
$cff4f3d989d1ca35$export$bfd64c937657f93a = `UErFpq_rotating`;
$cff4f3d989d1ca35$export$4a6dd88bada4e7d2 = `UErFpq_shimmer`;


function $319fdc3543ade48a$var$AssignedEntities({ entities: entities, count: count, type: type }) {
    return count ? /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $cff4f3d989d1ca35$export$5345fd892b40e1f6,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $cff4f3d989d1ca35$export$31d6f2c3562ba09e,
                children: entities.map((entity)=>type === (0, $3kVX5.RoleType).User ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                        className: $cff4f3d989d1ca35$export$345c5736c8054f22,
                        user: entity,
                        size: "small"
                    }, entity.id) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                        type: (0, $3kVX5.ApplicationType).MachineToMachine,
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($cff4f3d989d1ca35$export$fae01a4f5c829e19, $cff4f3d989d1ca35$export$345c5736c8054f22)
                    }, entity.id))
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                className: $cff4f3d989d1ca35$export$85b9a36db797e02b,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: count >= 2 ? type === (0, $3kVX5.RoleType).User ? "roles.user_counts" : "roles.application_counts" : type === (0, $3kVX5.RoleType).User ? "roles.user_count" : "roles.application_count",
                    interpolation: {
                        count: count
                    }
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $cff4f3d989d1ca35$export$6e22c362a0406a2c,
        children: "-"
    });
}
var $319fdc3543ade48a$export$2e2bcd8739ae039 = $319fdc3543ade48a$var$AssignedEntities;




var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f000de1cab1d9fc2$var$SvgOrganizationEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                opacity: 0.4,
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.392 208.572H74.295c-2.523.361-5.1.548-7.717.548a54.46 54.46 0 0 1-7.717-.548h-4.39v-.814C29.042 201.941 10 178.181 10 149.755c0-29.527 20.545-54.02 47.453-58.597C66.408 59.273 94.515 36 127.804 36c31.611 0 58.551 20.988 68.853 50.408 29.827 2.865 53.187 29.183 53.187 61.227 0 30.421-21.055 55.682-48.709 60.613v.324H199.1a56.417 56.417 0 0 1-7.854.548c-2.663 0-5.285-.187-7.854-.548Z",
                fill: "url(#paint0_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint1_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.814 226.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.733 27.416 4.154-3.285 12.106-7.058 12.106-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint2_linear_9679_23642)",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M15.882 229h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6",
                style: {
                    mixBlendMode: "hard-light"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint3_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M222.346 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.069 0 .125.056.125.126l-.011 2.252c0 .07-.056.125-.125.125l-3.966-.018 1.967 3.443a.124.124 0 0 1-.046.171l-1.956 1.118a.125.125 0 0 1-.171-.047l-1.967-3.442-1.998 3.424a.125.125 0 0 1-.171.046l-1.946-1.136a.125.125 0 0 1-.045-.171l1.998-3.425-3.966-.018a.125.125 0 0 1-.124-.126l.01-2.253c0-.07.057-.125.126-.124l3.965.017-1.967-3.442a.124.124 0 0 1 .046-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.999-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 56.962 74.91)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M44 142a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H44v-85Z",
                fill: "url(#paint4_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M48 141a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H48v-82Z",
                fill: "url(#paint5_linear_9679_23642)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M19 223h193v2a4 4 0 0 1-4 4H24a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M106 137h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 59,
                y: 153,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M90.548 153h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint6_linear_9679_23642)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 164,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 176,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 188,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 73.5,
                cy: 169.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_9679_23642",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 66,
                y: 162,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 73.5,
                    cy: 169.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_9679_23642)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M73.434 164.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_9679_23642)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 99,
                        y: 62,
                        width: 139.8,
                        height: 153,
                        rx: 10,
                        fill: "#E6DEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 110.519,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FF5449"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 121.152,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 131.785,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#68BE6C"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 91.24,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint7_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 97.469v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 94.873,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint8_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 118.506,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint9_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 124.734v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.499h-1v.499h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 122.139,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint10_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 145.771,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint11_linear_9679_23642)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 152v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 149.404,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint12_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 173.038,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "#9C7ECC"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M122.629 183.081h-3.545v-3.544a.59.59 0 1 0-1.181 0v3.544h-3.544a.595.595 0 0 0-.591.591.59.59 0 0 0 .591.591h3.544v3.544a.59.59 0 1 0 1.181 0v-3.544h3.545a.588.588 0 0 0 .59-.591.59.59 0 0 0-.59-.591Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 176.671,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint13_linear_9679_23642)",
                        opacity: 0.4
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                        clipPath: "url(#clip1_9679_23642)",
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                            clipPath: "url(#clip2_9679_23642)",
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 86,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint14_linear_9679_23642)"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 106.38,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint15_linear_9679_23642)"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 126.76,
                                    width: 51,
                                    height: 92,
                                    rx: 2.658,
                                    fill: "url(#paint16_linear_9679_23642)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 99.3,
                y: 62.3,
                width: 139.2,
                height: 152.4,
                rx: 9.7,
                stroke: "#C9C5D0",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -162.595 155.586) skewX(-.13)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m252.791 71-1.195 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#928F9A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m72.521 65.49-.36-2.514a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.544 2.544 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#928F9A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_9679_23642",
                        x1: 44,
                        y1: -19,
                        x2: 130,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_9679_23642",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_9679_23642",
                        x1: 42.861,
                        y1: 228.869,
                        x2: 56.406,
                        y2: 112.054,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_9679_23642",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_9679_23642",
                        x1: 112.556,
                        y1: 136.099,
                        x2: 143.327,
                        y2: 238.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_9679_23642",
                        x1: 184,
                        y1: 223.001,
                        x2: -25,
                        y2: 90.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_9679_23642",
                        x1: 120.59,
                        y1: 178.664,
                        x2: 80.951,
                        y2: 203.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_9679_23642",
                        x1: 109.423,
                        y1: 101.855,
                        x2: 131.77,
                        y2: 101.855,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_9679_23642",
                        x1: 137.524,
                        y1: 101.861,
                        x2: 194.27,
                        y2: 101.861,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_9679_23642",
                        x1: 109.423,
                        y1: 129.121,
                        x2: 131.77,
                        y2: 129.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_9679_23642",
                        x1: 137.524,
                        y1: 129.127,
                        x2: 194.27,
                        y2: 129.127,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_9679_23642",
                        x1: 109.423,
                        y1: 156.387,
                        x2: 131.77,
                        y2: 156.387,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_9679_23642",
                        x1: 137.524,
                        y1: 156.393,
                        x2: 194.27,
                        y2: 156.393,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint13_linear_9679_23642",
                        x1: 137.524,
                        y1: 183.659,
                        x2: 194.27,
                        y2: 183.659,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint14_linear_9679_23642",
                        x1: 204.71,
                        y1: 92.634,
                        x2: 257.785,
                        y2: 92.634,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint15_linear_9679_23642",
                        x1: 204.71,
                        y1: 113.014,
                        x2: 257.785,
                        y2: 113.014,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint16_linear_9679_23642",
                        x1: 204.747,
                        y1: 172.683,
                        x2: 258.34,
                        y2: 172.683,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_9679_23642",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 99,
                            y: 62,
                            width: 139.8,
                            height: 153,
                            rx: 10,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_9679_23642",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(192 75)",
                            d: "M0 0h47v140H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip2_9679_23642",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(201 86)",
                            d: "M0 0h51v149H0z"
                        })
                    })
                ]
            })
        ]
    });
var $f000de1cab1d9fc2$export$2e2bcd8739ae039 = $f000de1cab1d9fc2$var$SvgOrganizationEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $24a3526f8dfa5359$var$SvgOrganizationEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M183.392 208.572H74.295c-2.523.361-5.1.548-7.717.548a54.46 54.46 0 0 1-7.717-.548h-4.39v-.814C29.042 201.941 10 178.181 10 149.755c0-29.527 20.545-54.02 47.453-58.597C66.408 59.273 94.515 36 127.804 36c31.611 0 58.551 20.988 68.853 50.408 29.827 2.865 53.187 29.183 53.187 61.227 0 30.421-21.055 55.682-48.709 60.613v.324H199.1a56.417 56.417 0 0 1-7.854.548c-2.663 0-5.285-.187-7.854-.548Z",
                fill: "url(#paint0_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M140.954 172.951C125.886 171.862 114 159.293 114 143.947c0-15.729 12.487-28.541 28.088-29.064C146.304 97.727 161.789 85 180.246 85c17.889 0 32.986 11.955 37.737 28.311 16.456.525 29.63 13.688 29.63 29.85 0 15.649-12.352 28.487-28.075 29.762v.202h-78.584v-.174Z",
                fill: "url(#paint1_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M41.814 226.968c4.89-.693 7.251-17.031 7.423-37.533 1.31-1.024 2.688-2.307 4.1-3.719 4.629-4.629 6.705-10.058 5.155-11.608-1.307-1.307-5.373-.035-9.392 3.172-.557-17.391-2.763-30.274-7.613-30.274-6.534 0-7.76 17.905-7.76 39.992 0 2.757.039 5.449.116 8.049-1.841-2.114-3.575-3.272-4.89-3.272-3.582 0-1.806 9.763 1.858 19.326 2.541 6.634 5.503 12.107 8.213 14.403.607.795 1.268 1.286 1.984 1.437l-.025-9.277c-3.448-6.652-10.65-20.117-10.65-20.117l10.642 17.085-.021-7.437v-.008l-.05-17.788-.078.073v-2.208l.072-.064c-.038-13.916-.072-26.436-.072-27.962 0-2.379.44 6.332.733 27.416 4.154-3.285 12.106-7.058 12.106-7.058-5.705 3.651-10.324 7.617-12.078 9.184.13 10.066.224 22.754.227 38.188Z",
                fill: "url(#paint2_linear_9679_23375)",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M15.882 229h30.244c2.88 0 4.68-3.398 0-5.663-4.681-2.265-15.842-3.964-24.484-3.114-8.64.849-9 8.777-5.76 8.777Z",
                fill: "#C8BEE6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M219.527 125.238c.007-.314.011-.63.011-.946 0-21.7-17.591-39.292-39.292-39.292-18.457 0-33.942 12.727-38.158 29.883-15.601.523-28.088 13.335-28.088 29.064 0 15.346 11.886 27.915 26.954 29.004v.174h78.584v-47.887h-.011Z",
                fill: "url(#paint3_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M222.346 34.5a.125.125 0 0 1 .171-.044l1.946 1.135c.06.035.08.112.045.171l-1.998 3.425 3.965.018c.069 0 .125.056.125.126l-.011 2.252c0 .07-.056.125-.125.125l-3.966-.018 1.967 3.443a.124.124 0 0 1-.046.171l-1.956 1.118a.125.125 0 0 1-.171-.047l-1.967-3.442-1.998 3.424a.125.125 0 0 1-.171.046l-1.946-1.136a.125.125 0 0 1-.045-.171l1.998-3.425-3.966-.018a.125.125 0 0 1-.124-.126l.01-2.253c0-.07.057-.125.126-.124l3.965.017-1.967-3.442a.124.124 0 0 1 .046-.17l1.956-1.119a.125.125 0 0 1 .171.047l1.967 3.443 1.999-3.425Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 6.421,
                height: 6.421,
                rx: 2,
                transform: "scale(-1 1) rotate(-40.65 56.962 74.91)",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M44 142a8 8 0 0 1 8-8h128a8 8 0 0 1 8 8v85H44v-85Z",
                fill: "url(#paint4_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M48 141a4 4 0 0 1 4-4h128a4 4 0 0 1 4 4v82H48v-82Z",
                fill: "url(#paint5_linear_9679_23375)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M19 223h193v2a4 4 0 0 1-4 4H24a5 5 0 0 1-5-5v-1Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M106 137h20v2a4 4 0 0 1-4 4h-12a4 4 0 0 1-4-4v-2Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 59,
                y: 153,
                width: 110,
                height: 56,
                rx: 5,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M90.548 153h28.451v47a9 9 0 0 1-9 9h-33l13.549-56Z",
                fill: "url(#paint6_linear_9679_23375)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 164,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#FF91DF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 176,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 90,
                y: 188,
                width: 68,
                height: 6,
                rx: 2,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 73.5,
                cy: 169.5,
                r: 7.5,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("mask", {
                id: "mask0_9679_23375",
                style: {
                    maskType: "alpha"
                },
                maskUnits: "userSpaceOnUse",
                x: 66,
                y: 162,
                width: 15,
                height: 15,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                    cx: 73.5,
                    cy: 169.5,
                    r: 7.5,
                    fill: "#FF91DF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                mask: "url(#mask0_9679_23375)",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                    d: "M73.434 164.5a.8.8 0 0 0-.782.63l-.092.425a.773.773 0 0 1-.475.535.769.769 0 0 1-.712-.044l-.363-.234a.8.8 0 0 0-.998.107l-.093.093a.8.8 0 0 0-.107.998l.234.363a.77.77 0 0 1 .044.712.774.774 0 0 1-.535.475l-.425.092a.8.8 0 0 0-.63.782v.132a.8.8 0 0 0 .63.782l.425.092c.246.053.439.242.535.475a.77.77 0 0 1-.044.712l-.234.363a.8.8 0 0 0 .107.998l.093.093a.8.8 0 0 0 .998.107l.364-.234a.769.769 0 0 1 .711-.044.773.773 0 0 1 .475.535l.092.425a.8.8 0 0 0 .782.63h.132a.8.8 0 0 0 .782-.63l.092-.425a.773.773 0 0 1 .475-.535.769.769 0 0 1 .712.044l.363.234a.8.8 0 0 0 .998-.107l.093-.093a.8.8 0 0 0 .107-.998l-.234-.363a.77.77 0 0 1-.044-.712.774.774 0 0 1 .535-.475l.425-.092a.8.8 0 0 0 .63-.782v-.132a.8.8 0 0 0-.63-.782l-.425-.092a.774.774 0 0 1-.535-.475.77.77 0 0 1 .044-.712l.234-.363a.8.8 0 0 0-.107-.998l-.093-.093a.8.8 0 0 0-.998-.107l-.364.234a.769.769 0 0 1-.711.044.773.773 0 0 1-.475-.535l-.092-.425a.8.8 0 0 0-.782-.63h-.132Zm.066 2.857a2.143 2.143 0 1 1 0 4.287 2.143 2.143 0 0 1 0-4.287Z",
                    fill: "#F5EEFF"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_9679_23375)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 99,
                        y: 62,
                        width: 139.8,
                        height: 153,
                        rx: 10,
                        fill: "#FFFBFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 110.519,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FF5449"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 121.152,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 131.785,
                        cy: 77.949,
                        r: 2.658,
                        fill: "#68BE6C"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 91.24,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint7_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 97.469v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 94.873,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint8_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 118.506,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint9_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 124.734v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.499h-1v.499h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 122.139,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint10_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 145.771,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "url(#paint11_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M117.361 152v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-3Zm-2.5 7v2h2v-2h-2Zm-.5-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5h5v.5h-1a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-1v-.5a1 1 0 0 0-1-1h-2v-.5h-1v.5h-2a1 1 0 0 0-1 1v.5h-1Zm6.5 3v-2h2v2h-2Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 149.404,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint12_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 107.861,
                        y: 173.038,
                        width: 21.266,
                        height: 21.266,
                        rx: 4.43,
                        fill: "#BDBDBD"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M122.629 183.081h-3.545v-3.544a.59.59 0 1 0-1.181 0v3.544h-3.544a.595.595 0 0 0-.591.591.59.59 0 0 0 .591.591h3.544v3.544a.59.59 0 1 0 1.181 0v-3.544h3.545a.588.588 0 0 0 .59-.591.59.59 0 0 0-.59-.591Z",
                        fill: "#fff"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 133.557,
                        y: 176.671,
                        width: 54,
                        height: 14,
                        rx: 3,
                        fill: "url(#paint13_linear_9679_23375)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("g", {
                        clipPath: "url(#clip1_9679_23375)",
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                            clipPath: "url(#clip2_9679_23375)",
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 86,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint14_linear_9679_23375)"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 106.38,
                                    width: 50.506,
                                    height: 13.291,
                                    rx: 2.658,
                                    fill: "url(#paint15_linear_9679_23375)"
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                                    opacity: 0.2,
                                    x: 201,
                                    y: 126.76,
                                    width: 51,
                                    height: 92,
                                    rx: 2.658,
                                    fill: "url(#paint16_linear_9679_23375)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 99.3,
                y: 62.3,
                width: 139.2,
                height: 152.4,
                rx: 9.7,
                stroke: "#C9C5D0",
                strokeWidth: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -162.595 155.586) skewX(-.13)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m252.791 71-1.195 2.564a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37v0a2.828 2.828 0 0 1-3.758 1.37v0a2.828 2.828 0 0 0-3.758 1.37l-1.194 2.563",
                stroke: "#CABEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m72.521 65.49-.36-2.514a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.544 2.544 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#FFF06A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_9679_23375",
                        x1: 129.922,
                        y1: 36,
                        x2: 129.922,
                        y2: 209.12,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F3EFFA"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_9679_23375",
                        x1: 180.807,
                        y1: 85,
                        x2: 180.807,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_9679_23375",
                        x1: 42.861,
                        y1: 228.869,
                        x2: 57.649,
                        y2: 145.844,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C7BDE6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E4DBFF",
                                stopOpacity: 0.16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_9679_23375",
                        x1: 166.769,
                        y1: 85,
                        x2: 166.769,
                        y2: 232.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEFDFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAF7FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_9679_23375",
                        x1: 112.556,
                        y1: 136.099,
                        x2: 143.327,
                        y2: 238.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_9679_23375",
                        x1: 184,
                        y1: 223.001,
                        x2: -25,
                        y2: 90.001,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_9679_23375",
                        x1: 120.59,
                        y1: 178.664,
                        x2: 80.951,
                        y2: 203.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#ECB6FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_9679_23375",
                        x1: 109.423,
                        y1: 101.855,
                        x2: 131.77,
                        y2: 101.855,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_9679_23375",
                        x1: 134.307,
                        y1: 101.348,
                        x2: 187.557,
                        y2: 101.348,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_9679_23375",
                        x1: 109.423,
                        y1: 129.121,
                        x2: 131.77,
                        y2: 129.121,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_9679_23375",
                        x1: 134.307,
                        y1: 128.614,
                        x2: 187.557,
                        y2: 128.614,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_9679_23375",
                        x1: 109.423,
                        y1: 156.387,
                        x2: 131.77,
                        y2: 156.387,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6B47F7"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#7F46FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_9679_23375",
                        x1: 134.307,
                        y1: 155.879,
                        x2: 187.557,
                        y2: 155.879,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint13_linear_9679_23375",
                        x1: 134.307,
                        y1: 183.146,
                        x2: 187.557,
                        y2: 183.146,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#D2C4FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ECD5FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint14_linear_9679_23375",
                        x1: 194.797,
                        y1: 92.646,
                        x2: 209.282,
                        y2: 67.446,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint15_linear_9679_23375",
                        x1: 194.797,
                        y1: 113.025,
                        x2: 209.282,
                        y2: 87.826,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint16_linear_9679_23375",
                        x1: 194.737,
                        y1: 172.76,
                        x2: 250.069,
                        y2: 158.716,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A278FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3A8FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_9679_23375",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 99,
                            y: 62,
                            width: 139.8,
                            height: 153,
                            rx: 10,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_9679_23375",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(192 75)",
                            d: "M0 0h47v140H0z"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip2_9679_23375",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                            fill: "#fff",
                            transform: "translate(201 86)",
                            d: "M0 0h51v149H0z"
                        })
                    })
                ]
            })
        ]
    });
var $24a3526f8dfa5359$export$2e2bcd8739ae039 = $24a3526f8dfa5359$var$SvgOrganizationEmpty;



var $kcPww = parcelRequire("kcPww");


var $93h5F = parcelRequire("93h5F");
var $6f347032901b21a4$export$2ba01fb71ed41cb6;
var $6f347032901b21a4$export$5c452ff88e35e47d;
var $6f347032901b21a4$export$c7187bbd1a7a9244;
var $6f347032901b21a4$export$bfd64c937657f93a;
var $6f347032901b21a4$export$4a6dd88bada4e7d2;
var $6f347032901b21a4$export$6f093cfa640b7166;
var $6f347032901b21a4$export$fb184b623420d9be;
$6f347032901b21a4$export$2ba01fb71ed41cb6 = `MBDhfG_button`;
$6f347032901b21a4$export$5c452ff88e35e47d = `MBDhfG_image`;
$6f347032901b21a4$export$c7187bbd1a7a9244 = `MBDhfG_placeholder`;
$6f347032901b21a4$export$bfd64c937657f93a = `MBDhfG_rotating`;
$6f347032901b21a4$export$4a6dd88bada4e7d2 = `MBDhfG_shimmer`;
$6f347032901b21a4$export$6f093cfa640b7166 = `MBDhfG_text`;
$6f347032901b21a4$export$fb184b623420d9be = `MBDhfG_title`;


function $cdeb4d49203d9370$var$EmptyDataPlaceholder({ buttonProps: buttonProps }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const { configs: configs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const theme = (0, $93h5F.default)();
    const PlaceholderImage = theme === (0, $bhvxB.Theme).Light ? (0, $24a3526f8dfa5359$export$2e2bcd8739ae039) : (0, $f000de1cab1d9fc2$export$2e2bcd8739ae039);
    const isInitialSetup = !configs?.organizationCreated;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $6f347032901b21a4$export$c7187bbd1a7a9244,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)(PlaceholderImage, {
                className: $6f347032901b21a4$export$5c452ff88e35e47d
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6f347032901b21a4$export$fb184b623420d9be,
                children: t("organization_list_placeholder_title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $6f347032901b21a4$export$6f093cfa640b7166,
                children: t("organization_list_placeholder_text")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                className: $6f347032901b21a4$export$2ba01fb71ed41cb6,
                type: "primary",
                size: "large",
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                title: isInitialSetup ? "organizations.setup_organization" : "organizations.create_organization",
                ...buttonProps
            })
        ]
    });
}
var $cdeb4d49203d9370$export$2e2bcd8739ae039 = $cdeb4d49203d9370$var$EmptyDataPlaceholder;


/** The page size of the organizations table. */ const $a8570f8d8b6c7479$var$pageSize = (0, $6ZMK7.defaultPageSize);
/** The organizations page root pathname. */ const $a8570f8d8b6c7479$var$pathname = "/organizations";
/** The organizations API pathname in the management API. */ const $a8570f8d8b6c7479$var$apiPathname = "api/organizations";
function $a8570f8d8b6c7479$var$OrganizationsTable({ isLoading: isLoading, onCreate: onCreate }) {
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const { data: response, error: error } = (0, $2mi28.default)((0, $h7VLF.buildUrl)($a8570f8d8b6c7479$var$apiPathname, {
        q: keyword,
        showFeatured: "1",
        page: String(page),
        page_size: String($a8570f8d8b6c7479$var$pageSize)
    }));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const isTableLoading = isLoading || !response && !error;
    const [data, totalCount] = response ?? [
        [],
        0
    ];
    const { navigate: navigate } = (0, $4W0F0.default)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
        className: $f3853caa1df6ee27$export$9852986a3ec5f6a0,
        isLoading: isTableLoading,
        placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cdeb4d49203d9370$export$2e2bcd8739ae039), {
            buttonProps: {
                title: "organizations.create_organization",
                onClick: onCreate
            }
        }),
        rowGroups: [
            {
                key: "data",
                data: data
            }
        ],
        rowClickHandler: ({ id: id })=>{
            navigate((0, $b9zrd.joinPath)($a8570f8d8b6c7479$var$pathname, id));
        },
        columns: [
            {
                title: t("general.name"),
                dataIndex: "name",
                render: ({ name: name, id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                        title: name,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3dc4aee746c180b4$export$2e2bcd8739ae039), {
                            for: (0, $11c317f8d53fc2a7$export$2e2bcd8739ae039)
                        }),
                        to: (0, $b9zrd.joinPath)($a8570f8d8b6c7479$var$pathname, id)
                    })
            },
            {
                title: t("organizations.organization_id"),
                dataIndex: "id",
                render: ({ id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        value: id,
                        variant: "text"
                    })
            },
            {
                title: t("organizations.members"),
                dataIndex: "members",
                render: ({ usersCount: usersCount, featuredUsers: featuredUsers })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $319fdc3543ade48a$export$2e2bcd8739ae039), {
                        type: (0, $3kVX5.RoleType).User,
                        entities: featuredUsers ?? [],
                        count: usersCount ?? 0
                    })
            }
        ],
        rowIndexKey: "id",
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: $a8570f8d8b6c7479$var$pageSize,
            onChange: setPage
        },
        filter: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
            defaultValue: keyword,
            isClearable: Boolean(keyword),
            placeholder: t("organizations.search_placeholder"),
            onSearch: (value)=>{
                setKeyword(value);
                setPage(1);
            },
            onClearSearch: ()=>{
                setKeyword("");
                setPage(1);
            }
        })
    });
}
var $a8570f8d8b6c7479$export$2e2bcd8739ae039 = $a8570f8d8b6c7479$var$OrganizationsTable;




var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");





var $2ANSb = parcelRequire("2ANSb");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");


var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");
const $2b7f17ed8d5dfd22$export$be74e4801fb4e62 = "api/organization-scopes";
/** A modal that allows users to create or edit an organization scope. */ function $2b7f17ed8d5dfd22$var$PermissionModal({ isOpen: isOpen, editData: editData, onClose: onClose }) {
    const api = (0, $2ANSb.default)();
    const { reset: reset, register: register, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $e1fc45c1d9052dc3$export$2e2bcd8739ae039)();
    const title = editData ? tAction("edit", "organizations.organization_permission") : tAction("create", "organizations.organization_permission");
    const action = editData ? t("general.save") : tAction("create", "organizations.permission");
    const submit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (json)=>{
        await (editData ? api.patch(`${$2b7f17ed8d5dfd22$export$be74e4801fb4e62}/${editData.id}`, {
            json: json
        }) : api.post($2b7f17ed8d5dfd22$export$be74e4801fb4e62, {
            json: json
        }));
        onClose();
    }));
    // Reset form on open
    (0, $eCoWV.useEffect)(()=>{
        if (isOpen) reset(editData ?? {});
    }, [
        editData,
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: title
            }),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                    children: action
                }),
                isLoading: isSubmitting,
                onClick: submit
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        isRequired: true,
                        title: "general.name",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            placeholder: "read:appointment",
                            error: Boolean(errors.name),
                            disabled: Boolean(editData),
                            ...register("name", {
                                required: true
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "general.description",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: Boolean(editData),
                            placeholder: t("organizations.create_permission_placeholder"),
                            error: Boolean(errors.description),
                            ...register("description")
                        })
                    })
                ]
            })
        })
    });
}
var $2b7f17ed8d5dfd22$export$2e2bcd8739ae039 = $2b7f17ed8d5dfd22$var$PermissionModal;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");






var $2ANSb = parcelRequire("2ANSb");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $9zeGj = parcelRequire("9zeGj");



function $bd9178e07beffffd$var$OrganizationScopesSelect({ value: value, onChange: onChange, keyword: keyword, setKeyword: setKeyword }) {
    const { data: scopes, isLoading: isLoading } = (0, $2c4bcd56964a1bef$export$2e2bcd8739ae039)("api/organization-scopes", keyword);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b45be41e304f3631$export$2e2bcd8739ae039), {
        value: value,
        options: scopes.map(({ id: id, name: name })=>({
                value: id,
                title: name
            })),
        placeholder: "organizations.search_permission_placeholder",
        isOptionsLoading: isLoading,
        renderOption: ({ title: title, value: value })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $be95a5f425bfc2aa$export$2e2bcd8739ae039), {
                children: title ?? value
            }),
        onChange: onChange,
        onSearch: setKeyword
    });
}
var $bd9178e07beffffd$export$2e2bcd8739ae039 = $bd9178e07beffffd$var$OrganizationScopesSelect;



var $kcPww = parcelRequire("kcPww");

var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");


var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");
const $f607ec609103c35b$export$4f9fe85677997186 = "api/organization-roles";
/** A modal that allows users to create or edit an organization role. */ function $f607ec609103c35b$var$RoleModal({ isOpen: isOpen, editData: editData, onClose: onClose }) {
    const api = (0, $2ANSb.default)();
    const { reset: reset, register: register, control: control, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        defaultValues: {
            scopes: []
        }
    });
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tAction = (0, $e1fc45c1d9052dc3$export$2e2bcd8739ae039)();
    const title = editData ? tAction("edit", "organizations.organization_role") : tAction("create", "organizations.organization_role");
    const action = editData ? t("general.save") : tAction("create", "organizations.role");
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const submit = handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ scopes: scopes, ...json })=>{
        // Create or update rol e
        const { id: id } = await (editData ? api.patch(`${$f607ec609103c35b$export$4f9fe85677997186}/${editData.id}`, {
            json: json
        }) : api.post($f607ec609103c35b$export$4f9fe85677997186, {
            json: json
        })).json();
        // Update scopes for role
        await api.put(`${$f607ec609103c35b$export$4f9fe85677997186}/${id}/scopes`, {
            json: {
                organizationScopeIds: scopes.map(({ value: value })=>value)
            }
        });
        onClose();
    }));
    // Reset form on open
    (0, $eCoWV.useEffect)(()=>{
        if (isOpen) {
            reset(editData ? {
                ...editData,
                scopes: editData.scopes.map(({ id: id, name: name })=>({
                        value: id,
                        title: name
                    }))
            } : {
                scopes: []
            });
            setKeyword("");
        }
    }, [
        editData,
        isOpen,
        reset
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                children: title
            }),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5Yzj4.default), {
                    children: action
                }),
                isLoading: isSubmitting,
                onClick: submit
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    isRequired: true,
                    title: "general.name",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        // eslint-disable-next-line jsx-a11y/no-autofocus
                        autoFocus: true,
                        placeholder: "viewer",
                        error: Boolean(errors.name),
                        ...register("name", {
                            required: true
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "general.description",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        placeholder: t("organizations.create_role_placeholder"),
                        error: Boolean(errors.description),
                        ...register("description")
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "organizations.permission_other",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "scopes",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $bd9178e07beffffd$export$2e2bcd8739ae039), {
                                keyword: keyword,
                                setKeyword: setKeyword,
                                value: value,
                                onChange: onChange
                            })
                    })
                })
            ]
        })
    });
}
var $f607ec609103c35b$export$2e2bcd8739ae039 = $f607ec609103c35b$var$RoleModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $ecDp6 = parcelRequire("ecDp6");


var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $de9d06a1bae7bd24$export$ae5f3242c350d062;
var $de9d06a1bae7bd24$export$6e22c362a0406a2c;
var $de9d06a1bae7bd24$export$bfd64c937657f93a;
var $de9d06a1bae7bd24$export$fe2e36411d703b3d;
var $de9d06a1bae7bd24$export$4a6dd88bada4e7d2;
var $de9d06a1bae7bd24$export$641374ffb95bc399;
var $de9d06a1bae7bd24$export$fb184b623420d9be;
$de9d06a1bae7bd24$export$ae5f3242c350d062 = `NCPgPa_addAnother`;
$de9d06a1bae7bd24$export$6e22c362a0406a2c = `NCPgPa_empty`;
$de9d06a1bae7bd24$export$bfd64c937657f93a = `NCPgPa_rotating`;
$de9d06a1bae7bd24$export$fe2e36411d703b3d = `NCPgPa_section`;
$de9d06a1bae7bd24$export$4a6dd88bada4e7d2 = `NCPgPa_shimmer`;
$de9d06a1bae7bd24$export$641374ffb95bc399 = `NCPgPa_spinner`;
$de9d06a1bae7bd24$export$fb184b623420d9be = `NCPgPa_title`;


const $a0634d6fc48b5d9a$export$3a40bd8b0ff0173c = 10;
/**
 * The table component for organization template editing, such as permissions and roles.
 * If `onAdd` is provided, an add button will be rendered in the bottom.
 */ function $a0634d6fc48b5d9a$var$TemplateTable({ name: name, rowIndexKey: rowIndexKey, data: data, columns: columns, onAdd: onAdd, totalCount: totalCount, page: page, isLoading: isLoading, onPageChange: onPageChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const noData = !isLoading && data.length === 0;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("section", {
        className: $de9d06a1bae7bd24$export$fe2e36411d703b3d,
        children: [
            name && /*#__PURE__*/ (0, $9zeGj.jsx)("header", {
                className: $de9d06a1bae7bd24$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: name,
                    interpolation: {
                        count: 2
                    }
                })
            }),
            onAdd && noData && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    name && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $de9d06a1bae7bd24$export$6e22c362a0406a2c,
                        children: t("organizations.empty_placeholder", {
                            entity: String(t(name)).toLowerCase()
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                        title: "general.add",
                        onClick: onAdd
                    })
                ]
            }),
            !noData && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                hasBorder: true,
                isRowHoverEffectDisabled: true,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "data",
                        data: data
                    }
                ],
                columns: columns,
                rowIndexKey: rowIndexKey,
                pagination: {
                    page: page,
                    totalCount: totalCount,
                    pageSize: $a0634d6fc48b5d9a$export$3a40bd8b0ff0173c,
                    onChange: onPageChange
                },
                footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    size: "small",
                    type: "text",
                    className: $de9d06a1bae7bd24$export$ae5f3242c350d062,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {}),
                    title: "general.add_another",
                    onClick: onAdd
                })
            })
        ]
    });
}
var $a0634d6fc48b5d9a$export$2e2bcd8739ae039 = $a0634d6fc48b5d9a$var$TemplateTable;


var $d6f09acbe37cb457$export$430c45605c9594b5;
var $d6f09acbe37cb457$export$bfd64c937657f93a;
var $d6f09acbe37cb457$export$4a6dd88bada4e7d2;
$d6f09acbe37cb457$export$430c45605c9594b5 = `_63e_tG_permissions`;
$d6f09acbe37cb457$export$bfd64c937657f93a = `_63e_tG_rotating`;
$d6f09acbe37cb457$export$4a6dd88bada4e7d2 = `_63e_tG_shimmer`;


const $187978de6531d877$export$3c580307a69a1ace = "api/organization-roles";
/**
 * Renders the roles card that allows users to add, edit, and delete organization
 * roles.
 */ function $187978de6531d877$var$RolesCard() {
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const { data: response, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)($187978de6531d877$export$3c580307a69a1ace, {
        page: String(page),
        page_size: String((0, $a0634d6fc48b5d9a$export$3a40bd8b0ff0173c))
    }));
    const [data, totalCount] = response ?? [
        [],
        0
    ];
    const api = (0, $2ANSb.default)();
    const [isModalOpen, setIsModalOpen] = (0, $eCoWV.useState)(false);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [editData, setEditData] = (0, $eCoWV.useState)(null);
    const isLoading = !response && !error;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "organizations.organization_role_other",
        description: "organizations.organization_role_description",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f607ec609103c35b$export$2e2bcd8739ae039), {
                isOpen: isModalOpen,
                editData: editData,
                onClose: ()=>{
                    setIsModalOpen(false);
                    mutate();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0634d6fc48b5d9a$export$2e2bcd8739ae039), {
                name: "organizations.organization_role",
                rowIndexKey: "id",
                isLoading: isLoading,
                page: page,
                totalCount: totalCount,
                data: data,
                columns: [
                    {
                        title: t("general.name"),
                        dataIndex: "name",
                        colSpan: 4,
                        render: ({ name: name, id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d516a7c4b867a01$export$9b2040b3fe7f4e3f), {
                                size: "large",
                                value: id,
                                title: name
                            })
                    },
                    {
                        title: t("organizations.permission_other"),
                        dataIndex: "permissions",
                        colSpan: 6,
                        render: ({ scopes: scopes })=>scopes.length === 0 ? "-" : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $d6f09acbe37cb457$export$430c45605c9594b5,
                                children: scopes.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                        variant: "cell",
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $be95a5f425bfc2aa$export$2e2bcd8739ae039), {
                                            children: name
                                        })
                                    }, id))
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        render: (data)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $716efe74a753793a$export$2e2bcd8739ae039), {
                                fieldName: "organizations.role",
                                deleteConfirmation: "organizations.organization_role_delete_confirm",
                                onEdit: ()=>{
                                    setEditData(data);
                                    setIsModalOpen(true);
                                },
                                onDelete: async ()=>{
                                    await api.delete(`api/organization-roles/${data.id}`);
                                    mutate();
                                }
                            })
                    }
                ],
                onPageChange: setPage,
                onAdd: ()=>{
                    setEditData(null);
                    setIsModalOpen(true);
                }
            })
        ]
    });
}
var $187978de6531d877$export$2e2bcd8739ae039 = $187978de6531d877$var$RolesCard;



/**
 * Renders the permissions card that allows users to add, edit, and delete organization
 * permissions.
 */ function $eeb4481e19941c27$var$PermissionsCard() {
    const [page, setPage] = (0, $eCoWV.useState)(1);
    const { data: response, error: error, mutate: mutatePermissions } = (0, $2mi28.default)((0, $h7VLF.buildUrl)("api/organization-scopes", {
        page: String(page),
        page_size: String((0, $a0634d6fc48b5d9a$export$3a40bd8b0ff0173c))
    }));
    const { mutate: globalMutate } = (0, $4Korf.useSWRConfig)();
    const [data, totalCount] = response ?? [
        [],
        0
    ];
    const api = (0, $2ANSb.default)();
    const [isModalOpen, setIsModalOpen] = (0, $eCoWV.useState)(false);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [editData, setEditData] = (0, $eCoWV.useState)(null);
    const mutate = (0, $eCoWV.useCallback)(()=>{
        mutatePermissions();
        globalMutate((key)=>typeof key === "string" && key.startsWith((0, $187978de6531d877$export$3c580307a69a1ace)));
    }, [
        mutatePermissions,
        globalMutate
    ]);
    const isLoading = !response && !error;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "organizations.organization_permission_other",
        description: "organizations.organization_permission_description",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2b7f17ed8d5dfd22$export$2e2bcd8739ae039), {
                isOpen: isModalOpen,
                editData: editData,
                onClose: ()=>{
                    setIsModalOpen(false);
                    mutate();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0634d6fc48b5d9a$export$2e2bcd8739ae039), {
                name: "organizations.organization_permission",
                rowIndexKey: "id",
                isLoading: isLoading,
                page: page,
                totalCount: totalCount,
                data: data,
                columns: [
                    {
                        title: t("general.name"),
                        dataIndex: "name",
                        colSpan: 4,
                        render: ({ name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $be95a5f425bfc2aa$export$2e2bcd8739ae039), {
                                    children: name
                                })
                            })
                    },
                    {
                        title: t("general.description"),
                        dataIndex: "description",
                        colSpan: 6,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $be95a5f425bfc2aa$export$2e2bcd8739ae039), {
                                children: description ?? "-"
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        render: (data)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $716efe74a753793a$export$2e2bcd8739ae039), {
                                fieldName: "organizations.permission",
                                deleteConfirmation: "organizations.organization_permission_delete_confirm",
                                onEdit: ()=>{
                                    setEditData(data);
                                    setIsModalOpen(true);
                                },
                                onDelete: async ()=>{
                                    await api.delete(`api/organization-scopes/${data.id}`);
                                    mutate();
                                }
                            })
                    }
                ],
                onPageChange: setPage,
                onAdd: ()=>{
                    setEditData(null);
                    setIsModalOpen(true);
                }
            })
        ]
    });
}
var $eeb4481e19941c27$export$2e2bcd8739ae039 = $eeb4481e19941c27$var$PermissionsCard;



var $be3cc2888859d8d1$export$a7db06668cad9adb;
var $be3cc2888859d8d1$export$bfd64c937657f93a;
var $be3cc2888859d8d1$export$4a6dd88bada4e7d2;
$be3cc2888859d8d1$export$a7db06668cad9adb = `rexQaG_content`;
$be3cc2888859d8d1$export$bfd64c937657f93a = `rexQaG_rotating`;
$be3cc2888859d8d1$export$4a6dd88bada4e7d2 = `rexQaG_shimmer`;


function $2558136c26da4c28$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $be3cc2888859d8d1$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeb4481e19941c27$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $187978de6531d877$export$2e2bcd8739ae039), {})
        ]
    });
}


const $591a2c8fdcf40a7f$export$3f195fbd14360a14 = "/organizations";
const $591a2c8fdcf40a7f$export$f4c3a0c40dbd37d0 = "/organization-guide";


var $60c0bc5249f090fa$export$d2728412f6b340a9;
var $60c0bc5249f090fa$export$bfd64c937657f93a;
var $60c0bc5249f090fa$export$4a6dd88bada4e7d2;
var $60c0bc5249f090fa$export$39f5674517ec0000;
$60c0bc5249f090fa$export$d2728412f6b340a9 = `ynTgOa_emptyCardContainer`;
$60c0bc5249f090fa$export$bfd64c937657f93a = `ynTgOa_rotating`;
$60c0bc5249f090fa$export$4a6dd88bada4e7d2 = `ynTgOa_shimmer`;
$60c0bc5249f090fa$export$39f5674517ec0000 = `ynTgOa_tabs`;


const $c70ac5e118c7eccf$var$tabs = Object.freeze({
    template: "template"
});
function $c70ac5e118c7eccf$var$Organizations({ tab: tab }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { currentTenantId: currentTenantId, isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [isCreating, setIsCreating] = (0, $eCoWV.useState)(false);
    const { configs: configs, isLoading: isLoadingConfigs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const isInitialSetup = !isLoadingConfigs && !configs?.organizationCreated;
    const isOrganizationsDisabled = (0, $V1X8c.isCloud) && !currentPlan?.quota.organizationsEnabled;
    const upgradePlan = (0, $eCoWV.useCallback)(()=>{
        navigate((0, $f5861ec06c49db25$export$6d940d0d58a60bc4));
    }, [
        navigate
    ]);
    const handleCreate = (0, $eCoWV.useCallback)(()=>{
        if (isInitialSetup) {
            navigate((0, $591a2c8fdcf40a7f$export$f4c3a0c40dbd37d0));
            return;
        }
        setIsCreating(true);
    }, [
        isInitialSetup,
        navigate
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $f3853caa1df6ee27$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7144984399a479cd$export$2e2bcd8739ae039), {
                isOpen: isCreating,
                onClose: (createdId)=>{
                    if (createdId) {
                        navigate((0, $591a2c8fdcf40a7f$export$3f195fbd14360a14) + `/${createdId}`);
                        return;
                    }
                    setIsCreating(false);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "organizations.page_title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $f3853caa1df6ee27$export$516dd90aeaaabcf0,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                        isBeta: true,
                        paywall: (0, $5CQIb.cond)((isOrganizationsDisabled || isDevTenant) && (0, $ckJfF.ReservedPlanId).Hobby),
                        title: "organizations.title",
                        subtitle: "organizations.subtitle"
                    }),
                    !isInitialSetup && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                        type: "primary",
                        size: "large",
                        title: "organizations.create_organization",
                        onClick: handleCreate
                    })
                ]
            }),
            isInitialSetup && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1UQTm.default), {
                className: $60c0bc5249f090fa$export$d2728412f6b340a9,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cdeb4d49203d9370$export$2e2bcd8739ae039), {
                    buttonProps: {
                        title: isOrganizationsDisabled ? "upsell.upgrade_plan" : "organizations.setup_organization",
                        onClick: isOrganizationsDisabled ? upgradePlan : handleCreate,
                        ...(0, $5CQIb.conditional)(isOrganizationsDisabled && {
                            icon: undefined
                        })
                    }
                })
            }),
            !isInitialSetup && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        className: $60c0bc5249f090fa$export$39f5674517ec0000,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: "/organizations",
                                isActive: !tab,
                                children: t("organizations.title")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: (0, $b9zrd.joinPath)("/organizations", $c70ac5e118c7eccf$var$tabs.template),
                                isActive: tab === "template",
                                children: t("organizations.organization_template")
                            })
                        ]
                    }),
                    !tab && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a8570f8d8b6c7479$export$2e2bcd8739ae039), {
                        isLoading: isLoadingConfigs,
                        onCreate: handleCreate
                    }),
                    tab === "template" && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2558136c26da4c28$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $c70ac5e118c7eccf$export$2e2bcd8739ae039 = $c70ac5e118c7eccf$var$Organizations;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $bFFWx = parcelRequire("bFFWx");

var $9X5Bp = parcelRequire("9X5Bp");


var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");




var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $2ANSb = parcelRequire("2ANSb");


var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $bSFEw = parcelRequire("bSFEw");


function $b5e5ceefe74d83b8$var$OrganizationInfo() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const theme = (0, $93h5F.default)();
    const Icon = theme === (0, $bhvxB.Theme).Light ? (0, $0d591b4d318c7c8f$export$2e2bcd8739ae039) : (0, $bc9f76eed31c7c6f$export$2e2bcd8739ae039);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const api = (0, $2ANSb.default)();
    const { updateConfigs: updateConfigs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const { register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        defaultValues: {
            name: ""
        }
    });
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (json)=>{
        await api.post(`api/organizations`, {
            json: json
        });
        updateConfigs({
            organizationCreated: true
        });
        navigate(`/organizations`);
    }));
    const onNavigateBack = ()=>{
        reset();
        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).roles}`);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $73aa291f835e531b$export$543dc55cf524ac77,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($73aa291f835e531b$export$a7db06668cad9adb),
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                            className: $73aa291f835e531b$export$aa3e815946b80764,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)(Icon, {
                                    className: $73aa291f835e531b$export$1ca1ec8b29a4ce27
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $73aa291f835e531b$export$fe2e36411d703b3d,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $73aa291f835e531b$export$fb184b623420d9be,
                                            children: t("guide.step_3")
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $73aa291f835e531b$export$6d59db4903f20f7d,
                                            children: t("guide.step_3_description")
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("form", {
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                        isRequired: true,
                                        title: "organizations.guide.organization_name",
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                            ...register("name", {
                                                required: true
                                            }),
                                            error: Boolean(errors.name),
                                            placeholder: t("organization_name_placeholder")
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1UQTm.default), {
                            className: $73aa291f835e531b$export$aa3e815946b80764,
                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $73aa291f835e531b$export$fe2e36411d703b3d,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $73aa291f835e531b$export$fb184b623420d9be,
                                        children: t("guide.more_next_steps")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $73aa291f835e531b$export$c96745152eb2740f,
                                        children: t("guide.add_members")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                                href: "https://docs.logto.io/docs/tutorials/",
                                                targetBlank: "noopener",
                                                children: t("guide.add_members_action")
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 4,
                totalSteps: (0, $fec8fa852791059b$export$64cee2a13326b43d),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        isLoading: isSubmitting,
                        title: "general.done",
                        type: "primary",
                        onClick: onSubmit
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.back",
                        onClick: onNavigateBack
                    })
                ]
            })
        ]
    });
}
var $b5e5ceefe74d83b8$export$2e2bcd8739ae039 = $b5e5ceefe74d83b8$var$OrganizationInfo;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $67568986f9a413bb$var$SvgPermissionFeatureDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M7 12a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V12Z",
                fill: "url(#paint0_linear_9450_17840)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 14,
                y: 36,
                width: 20,
                height: 4,
                rx: 2,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 35,
                cy: 28,
                r: 5,
                fill: "url(#paint1_linear_9450_17840)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.348 27.375a.625.625 0 0 0 0 .884l1.768 1.768a.625.625 0 0 0 .897-.013l2.638-2.639a.625.625 0 1 0-.884-.884l-2.21 2.21-1.325-1.326a.625.625 0 0 0-.884 0Z",
                fill: "url(#paint2_linear_9450_17840)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_9450_17840",
                        x1: 35.51,
                        y1: 10.979,
                        x2: 20.422,
                        y2: 35.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F07EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF480"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_9450_17840",
                        x1: 35.938,
                        y1: 23,
                        x2: 33.125,
                        y2: 32.688,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#80E670"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#50AC56"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_9450_17840",
                        x1: 36.406,
                        y1: 25.657,
                        x2: 33.75,
                        y2: 30.032,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9F2E9"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $67568986f9a413bb$export$2e2bcd8739ae039 = $67568986f9a413bb$var$SvgPermissionFeatureDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $827c60eedafb9a45$var$SvgPermissionFeature = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M7 12a4 4 0 0 1 4-4h26a4 4 0 0 1 4 4v18a4 4 0 0 1-4 4H11a4 4 0 0 1-4-4V12Z",
                fill: "url(#paint0_linear_9450_17778)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 14.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 14.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 21.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 21.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 10.25,
                y: 28.25,
                width: 6.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#191C1D",
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#C4C7C7",
                strokeOpacity: 0.02,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 19.25,
                y: 28.25,
                width: 18.5,
                height: 0.5,
                rx: 0.25,
                stroke: "#CABEFF",
                strokeOpacity: 0.14,
                strokeWidth: 0.5
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 14,
                y: 36,
                width: 20,
                height: 4,
                rx: 2,
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 35,
                cy: 28,
                r: 5,
                fill: "url(#paint1_linear_9450_17778)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M32.348 27.375a.625.625 0 0 0 0 .884l1.768 1.768a.625.625 0 0 0 .897-.013l2.638-2.639a.625.625 0 1 0-.884-.884l-2.21 2.21-1.325-1.326a.625.625 0 0 0-.884 0Z",
                fill: "url(#paint2_linear_9450_17778)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_9450_17778",
                        x1: 35.51,
                        y1: 10.979,
                        x2: 20.422,
                        y2: 35.562,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F07EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF480"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_9450_17778",
                        x1: 35.938,
                        y1: 23,
                        x2: 33.125,
                        y2: 32.688,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#80E670"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#50AC56"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_9450_17778",
                        x1: 36.406,
                        y1: 25.657,
                        x2: 33.75,
                        y2: 30.032,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E9F2E9"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $827c60eedafb9a45$export$2e2bcd8739ae039 = $827c60eedafb9a45$var$SvgPermissionFeature;




var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $bSFEw = parcelRequire("bSFEw");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $ecDp6 = parcelRequire("ecDp6");

var $gCKnS = parcelRequire("gCKnS");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");
var $1207db5d241db78e$export$e0f35d825088c098;
var $1207db5d241db78e$export$75c751978d4a1350;
var $1207db5d241db78e$export$231ba5fc42c01d86;
var $1207db5d241db78e$export$e5e25fbcc1f7affe;
var $1207db5d241db78e$export$7061c75fc5af8b7e;
var $1207db5d241db78e$export$bfd64c937657f93a;
var $1207db5d241db78e$export$4a6dd88bada4e7d2;
var $1207db5d241db78e$export$2a0674ff2eb10214;
var $1207db5d241db78e$export$fb184b623420d9be;
$1207db5d241db78e$export$e0f35d825088c098 = `_3H-apq_field`;
$1207db5d241db78e$export$75c751978d4a1350 = `_3H-apq_fieldWrapper`;
$1207db5d241db78e$export$231ba5fc42c01d86 = `_3H-apq_formContainer`;
$1207db5d241db78e$export$e5e25fbcc1f7affe = `_3H-apq_group`;
$1207db5d241db78e$export$7061c75fc5af8b7e = `_3H-apq_item`;
$1207db5d241db78e$export$bfd64c937657f93a = `_3H-apq_rotating`;
$1207db5d241db78e$export$4a6dd88bada4e7d2 = `_3H-apq_shimmer`;
$1207db5d241db78e$export$4a6dd88bada4e7d2;
$1207db5d241db78e$export$2a0674ff2eb10214 = `_3H-apq_skeleton`;
$1207db5d241db78e$export$fb184b623420d9be = `_3H-apq_title`;


function $d8cc78495d51814f$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $1207db5d241db78e$export$2a0674ff2eb10214,
        children: Array.from({
            length: 2
        }).map((_, index)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $1207db5d241db78e$export$e5e25fbcc1f7affe,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1207db5d241db78e$export$fb184b623420d9be
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1207db5d241db78e$export$e0f35d825088c098
                    })
                ]
            }, index))
    });
}
function $d8cc78495d51814f$var$DynamicFormFields({ className: className, title: title, fields: fields, isLoading: isLoading, onAdd: onAdd, onRemove: onRemove, render: render }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($1207db5d241db78e$export$231ba5fc42c01d86, className),
        children: [
            title && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $1207db5d241db78e$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                })
            }),
            fields.map((field, index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $1207db5d241db78e$export$7061c75fc5af8b7e,
                    children: [
                        isLoading ? /*#__PURE__*/ (0, $9zeGj.jsx)($d8cc78495d51814f$var$Skeleton, {}) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $1207db5d241db78e$export$75c751978d4a1350,
                            children: render(index)
                        }),
                        fields.length > 1 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "small",
                            onClick: ()=>{
                                onRemove(index);
                            },
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $gCKnS.default), {})
                        })
                    ]
                }, field.id)),
            !isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "small",
                type: "text",
                title: "general.add_another",
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {}),
                onClick: ()=>{
                    onAdd();
                }
            })
        ]
    });
}
var $d8cc78495d51814f$export$2e2bcd8739ae039 = $d8cc78495d51814f$var$DynamicFormFields;




const $6e3b6c385cfff572$var$defaultValue = {
    name: "",
    description: ""
};
function $6e3b6c385cfff572$var$OrganizationPermissions() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const theme = (0, $93h5F.default)();
    const PermissionIcon = theme === (0, $bhvxB.Theme).Light ? (0, $827c60eedafb9a45$export$2e2bcd8739ae039) : (0, $67568986f9a413bb$export$2e2bcd8739ae039);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const api = (0, $2ANSb.default)();
    const { data: data, error: error } = (0, $2mi28.default)("api/organization-scopes");
    const { control: control, register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitting: isSubmitting, isDirty: isDirty } } = (0, $c3LX9.useForm)({
        defaultValues: {
            permissions: [
                $6e3b6c385cfff572$var$defaultValue
            ]
        }
    });
    (0, $eCoWV.useEffect)(()=>{
        if (data?.length) reset({
            permissions: data.map(({ name: name, description: description })=>({
                    name: name,
                    description: description
                }))
        });
    }, [
        data,
        reset
    ]);
    const permissionFields = (0, $c3LX9.useFieldArray)({
        control: control,
        name: "permissions"
    });
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ permissions: permissions })=>{
        // If the form is pristine then skip the submit and go directly to the next step
        if (!isDirty) {
            navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).roles}`);
            return;
        }
        // If there's pre-saved permissions, remove them first
        if (data?.length) await Promise.all(data.map(async ({ id: id })=>api.delete(`${(0, $2b7f17ed8d5dfd22$export$be74e4801fb4e62)}/${id}`)));
        // Create new permissions
        if (permissions.length > 0) await Promise.all(permissions.filter(({ name: name })=>name).map(async ({ name: name, description: description })=>{
            await api.post((0, $2b7f17ed8d5dfd22$export$be74e4801fb4e62), {
                json: {
                    name: name,
                    description: description
                }
            });
        }));
        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).roles}`);
    }));
    const onNavigateBack = ()=>{
        reset();
        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).introduction}`);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $73aa291f835e531b$export$543dc55cf524ac77,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($73aa291f835e531b$export$a7db06668cad9adb),
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: $73aa291f835e531b$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)(PermissionIcon, {
                                className: $73aa291f835e531b$export$1ca1ec8b29a4ce27
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $73aa291f835e531b$export$fb184b623420d9be,
                                children: t("guide.step_1")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("form", {
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d8cc78495d51814f$export$2e2bcd8739ae039), {
                                    isLoading: !data && !error,
                                    title: "organizations.guide.organization_permissions",
                                    fields: permissionFields.fields,
                                    render: (index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $73aa291f835e531b$export$42f9fc1286aa9efd,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                                    title: "organizations.guide.permission_name",
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                                        ...register(`permissions.${index}.name`),
                                                        error: Boolean(errors.permissions?.[index]?.name),
                                                        placeholder: "read:appointment"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                                    title: "general.description",
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                                        ...register(`permissions.${index}.description`),
                                                        placeholder: t("create_permission_placeholder")
                                                    })
                                                })
                                            ]
                                        }),
                                    onAdd: ()=>{
                                        permissionFields.append($6e3b6c385cfff572$var$defaultValue);
                                    },
                                    onRemove: permissionFields.remove
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 2,
                totalSteps: (0, $fec8fa852791059b$export$64cee2a13326b43d),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        isLoading: isSubmitting,
                        title: "general.next",
                        type: "primary",
                        onClick: onSubmit
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.back",
                        onClick: onNavigateBack
                    })
                ]
            })
        ]
    });
}
var $6e3b6c385cfff572$export$2e2bcd8739ae039 = $6e3b6c385cfff572$var$OrganizationPermissions;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $7e9dc12529d32156$var$SvgRbacFeatureDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_6999_105958)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#F7F8F8",
                        fillOpacity: 0.12
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_6999_105958)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 22.71,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.47 26.561a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .85-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.69-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#CABEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_6999_105958)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6999_105958",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6999_105958",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_6999_105958",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $7e9dc12529d32156$export$2e2bcd8739ae039 = $7e9dc12529d32156$var$SvgRbacFeatureDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8fdb67f5b455b820$var$SvgRbacFeature = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 48,
        height: 48,
        viewBox: "0 0 48 48",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_6929_103505)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        width: 48,
                        height: 48,
                        rx: 8,
                        fill: "#F3EFFA"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 5,
                        y: 5,
                        width: 30.8,
                        height: 30.8,
                        rx: 8,
                        fill: "url(#paint0_linear_6929_103505)",
                        fillOpacity: 0.8
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                        cx: 20.4,
                        cy: 15.781,
                        r: 4.62,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 15.01,
                        y: 14.241,
                        width: 6.16,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 22.71,
                        y: 14.241,
                        width: 3.08,
                        height: 0.77,
                        rx: 0.385,
                        fill: "#2D2C61"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M13.47 26.561a4.62 4.62 0 0 1 4.62-4.62h4.62a4.62 4.62 0 0 1 4.62 4.62v1.54c0 .85-.69 1.54-1.54 1.54H15.01c-.85 0-1.54-.69-1.54-1.54v-1.54Z",
                        fill: "#FAABFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        opacity: 0.7,
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M34.72 26.634a.77.77 0 0 1 .77-.77h1.54a.77.77 0 0 1 .77.77v1.54h-3.08v-1.54Zm0 17.71c0 .426.345.77.77.77h1.54a.77.77 0 0 0 .77-.77v-1.54h-3.08v1.54Zm-7.315-7.314a.77.77 0 0 1-.77-.77v-1.54a.77.77 0 0 1 .77-.77h1.54v3.08h-1.54Zm17.71 0a.77.77 0 0 0 .77-.77v-1.54a.77.77 0 0 0-.77-.77h-1.54v3.08h1.54ZM28.91 30.317a.77.77 0 0 1 0-1.09l1.088-1.088c.301-.301.789-.301 1.09 0l1.088 1.089-2.178 2.177-1.088-1.088ZM41.432 42.84c.301.3.789.3 1.09 0l1.088-1.09c.3-.3.3-.788 0-1.088l-1.089-1.09-2.178 2.179 1.09 1.089Zm-10.344 0c-.301.3-.789.3-1.09 0l-1.088-1.089a.77.77 0 0 1 0-1.089l1.089-1.089 2.178 2.178-1.09 1.09ZM43.61 30.317c.301-.3.301-.788 0-1.089l-1.089-1.089a.77.77 0 0 0-1.089 0l-1.088 1.09 2.178 2.177 1.088-1.089Z",
                        fill: "#7958FF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M36.26 43.191a7.7 7.7 0 1 0 0-15.4 7.7 7.7 0 0 0 0 15.4Zm0-4.62a3.08 3.08 0 1 0 0-6.16 3.08 3.08 0 0 0 0 6.16Z",
                        fill: "url(#paint1_linear_6929_103505)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6929_103505",
                        x1: 32.5,
                        y1: 7,
                        x2: 4,
                        y2: 40.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#5E35F3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5A7FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6929_103505",
                        x1: 27.811,
                        y1: 42.091,
                        x2: 42.755,
                        y2: 30.013,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFF06A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E54AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_6929_103505",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            width: 48,
                            height: 48,
                            rx: 8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $8fdb67f5b455b820$export$2e2bcd8739ae039 = $8fdb67f5b455b820$var$SvgRbacFeature;





var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $bSFEw = parcelRequire("bSFEw");




const $999e9b9cea7e6792$var$defaultValue = {
    name: "",
    description: "",
    scopes: []
};
function $999e9b9cea7e6792$var$OrganizationRoles() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.organizations"
    });
    const theme = (0, $93h5F.default)();
    const RbacIcon = theme === (0, $bhvxB.Theme).Light ? (0, $8fdb67f5b455b820$export$2e2bcd8739ae039) : (0, $7e9dc12529d32156$export$2e2bcd8739ae039);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const api = (0, $2ANSb.default)();
    const { data: data, error: error } = (0, $2mi28.default)("api/organization-roles");
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const { control: control, register: register, handleSubmit: handleSubmit, reset: reset, formState: { errors: errors, isSubmitting: isSubmitting, isDirty: isDirty } } = (0, $c3LX9.useForm)({
        defaultValues: {
            roles: [
                $999e9b9cea7e6792$var$defaultValue
            ]
        }
    });
    (0, $eCoWV.useEffect)(()=>{
        if (data?.length) reset({
            roles: data.map(({ name: name, description: description, scopes: scopes })=>({
                    name: name,
                    description: description,
                    scopes: scopes.map(({ id: id, name: name })=>({
                            value: id,
                            title: name
                        }))
                }))
        });
    }, [
        data,
        reset
    ]);
    const roleFields = (0, $c3LX9.useFieldArray)({
        control: control,
        name: "roles"
    });
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ roles: roles })=>{
        // If the form is pristine then skip the submit and go directly to the next step
        if (!isDirty) {
            navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).organizationInfo}`);
            return;
        }
        // Remove pre-saved roles
        if (data?.length) await Promise.all(data.map(async ({ id: id })=>api.delete(`${(0, $f607ec609103c35b$export$4f9fe85677997186)}/${id}`)));
        // Create new roles
        if (roles.length > 0) await Promise.all(roles.filter(({ name: name })=>name).map(async ({ name: name, description: description, scopes: scopes })=>{
            const { id: id } = await api.post((0, $f607ec609103c35b$export$4f9fe85677997186), {
                json: {
                    name: name,
                    description: description
                }
            }).json();
            if (scopes.length > 0) await api.put(`${(0, $f607ec609103c35b$export$4f9fe85677997186)}/${id}/scopes`, {
                json: {
                    organizationScopeIds: scopes.map(({ value: value })=>value)
                }
            });
        }));
        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).organizationInfo}`);
    }));
    const onNavigateBack = ()=>{
        reset();
        setKeyword("");
        navigate(`../${(0, $fec8fa852791059b$export$be3f796aed065412).permissions}`);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $73aa291f835e531b$export$543dc55cf524ac77,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($73aa291f835e531b$export$a7db06668cad9adb),
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                        className: $73aa291f835e531b$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)(RbacIcon, {
                                className: $73aa291f835e531b$export$1ca1ec8b29a4ce27
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $73aa291f835e531b$export$fe2e36411d703b3d,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $73aa291f835e531b$export$fb184b623420d9be,
                                    children: t("guide.step_2")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("form", {
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d8cc78495d51814f$export$2e2bcd8739ae039), {
                                    isLoading: !data && !error,
                                    title: "organizations.guide.organization_roles",
                                    fields: roleFields.fields,
                                    render: (index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $73aa291f835e531b$export$42f9fc1286aa9efd,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                                    title: "organizations.guide.role_name",
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                                        ...register(`roles.${index}.name`),
                                                        error: Boolean(errors.roles?.[index]?.name),
                                                        placeholder: "viewer"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                                    title: "general.description",
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                                        ...register(`roles.${index}.description`),
                                                        placeholder: t("create_role_placeholder")
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                                    title: "organizations.guide.permissions",
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                                        name: `roles.${index}.scopes`,
                                                        control: control,
                                                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $bd9178e07beffffd$export$2e2bcd8739ae039), {
                                                                keyword: keyword,
                                                                setKeyword: setKeyword,
                                                                value: value,
                                                                onChange: onChange
                                                            })
                                                    })
                                                })
                                            ]
                                        }),
                                    onAdd: ()=>{
                                        roleFields.append($999e9b9cea7e6792$var$defaultValue);
                                    },
                                    onRemove: roleFields.remove
                                })
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $de0ac914cb204d1c$export$2e2bcd8739ae039), {
                step: 3,
                totalSteps: (0, $fec8fa852791059b$export$64cee2a13326b43d),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        isLoading: isSubmitting,
                        title: "general.next",
                        type: "primary",
                        onClick: onSubmit
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.back",
                        onClick: onNavigateBack
                    })
                ]
            })
        ]
    });
}
var $999e9b9cea7e6792$export$2e2bcd8739ae039 = $999e9b9cea7e6792$var$OrganizationRoles;




function $409d60f5497292f3$var$Guide() {
    const { navigate: navigate } = (0, $4W0F0.default)();
    const onClose = (0, $eCoWV.useCallback)(()=>{
        navigate("/organizations");
    }, [
        navigate
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $73aa291f835e531b$export$56c24f306bd986cf,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $444e1b6fad81232a$export$2e2bcd8739ae039), {
                    title: "organizations.guide.title",
                    subtitle: "organizations.guide.subtitle",
                    onClose: onClose
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Routes), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                replace: true,
                                to: (0, $fec8fa852791059b$export$be3f796aed065412).introduction
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: (0, $fec8fa852791059b$export$be3f796aed065412).introduction,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b2f02aa31b602632$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: (0, $fec8fa852791059b$export$be3f796aed065412).permissions,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6e3b6c385cfff572$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: (0, $fec8fa852791059b$export$be3f796aed065412).roles,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $999e9b9cea7e6792$export$2e2bcd8739ae039), {})
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                            path: (0, $fec8fa852791059b$export$be3f796aed065412).organizationInfo,
                            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b5e5ceefe74d83b8$export$2e2bcd8739ae039), {})
                        })
                    ]
                })
            ]
        })
    });
}
var $409d60f5497292f3$export$2e2bcd8739ae039 = $409d60f5497292f3$var$Guide;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $iwEyX = parcelRequire("iwEyX");


var $a0Ubj = parcelRequire("a0Ubj");
parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $V1X8c = parcelRequire("V1X8c");

var $kcPww = parcelRequire("kcPww");

var $lSA0o = parcelRequire("lSA0o");

var $2ANSb = parcelRequire("2ANSb");



var $4W0F0 = parcelRequire("4W0F0");



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");



var $V1X8c = parcelRequire("V1X8c");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");
parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $kcPww = parcelRequire("kcPww");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");


var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");


var $7iZsu = parcelRequire("7iZsu");

var $d2Ivz = parcelRequire("d2Ivz");

var $horhC = parcelRequire("horhC");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");

var $2CYkO = parcelRequire("2CYkO");
const $39a048a8d34ab715$export$7d5dc3ccf1648df4 = (0, $2CYkO.z).object({
    email: (0, $2CYkO.z).string().regex((0, $dQcUe.emailRegEx)),
    action: (0, $2CYkO.z).union([
        (0, $2CYkO.z).literal("changeEmail"),
        (0, $2CYkO.z).literal("changePassword")
    ])
});


const $4a20295e045d868b$export$23da1b6a36f0a363 = (state)=>{
    const parsed = (0, $39a048a8d34ab715$export$7d5dc3ccf1648df4).safeParse(state);
    return parsed.success ? parsed.data : {
        email: undefined,
        action: undefined
    };
};
const $4a20295e045d868b$export$20ff57c8784c652c = (url, windowName, width, height)=>{
    const outerHeight = window.top?.outerHeight ?? 0;
    const outerWidth = window.top?.outerWidth ?? 0;
    const screenX = window.top?.screenX ?? 0;
    const screenY = window.top?.screenY ?? 0;
    const yAxis = outerHeight / 2 + screenY - height / 2;
    const xAxis = outerWidth / 2 + screenX - width / 2;
    return window.open(url, windowName, [
        `toolbar=no`,
        `location=no`,
        `directories=no`,
        `status=no`,
        `menubar=no`,
        `scrollbars=no`,
        `resizable=no`,
        `copyhistory=no`,
        `width=${width}`,
        `height=${height}`,
        `top=${yAxis}`,
        `left=${xAxis}`
    ].join(","));
};
const $4a20295e045d868b$export$d3da1ecaf1206c58 = async (error, exec)=>{
    if (error instanceof (0, $d2Ivz.HTTPError)) {
        const logtoError = await error.response.json();
        const { code: code, message: message } = logtoError;
        const handled = await exec?.(code, message, error.response.status);
        if (handled) return;
        if (error.response.status !== 401) {
            (0, $horhC.toast).error(message);
            return;
        }
    }
    throw error;
};


function $8e2514e0da123904$var$BasicUserInfoUpdateModal({ field: field, value: initialValue, isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { show: showModal } = (0, $9ENFn.useConfirmModal)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator,
        hideErrorToast: true
    });
    const { register: register, clearErrors: clearErrors, handleSubmit: handleSubmit, setValue: setValue, reset: reset, control: control, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    (0, $eCoWV.useEffect)(()=>{
        clearErrors();
        if (!field) return;
        setValue(field, initialValue);
        return ()=>{
            reset();
        };
    }, [
        clearErrors,
        field,
        initialValue,
        reset,
        setValue
    ]);
    if (!field) return null;
    const getModalTitle = ()=>{
        if (field === "name") return initialValue ? "profile.change_name" : "profile.set_name";
        return `profile.change_${field}`;
    };
    const getInputPlaceholder = ()=>{
        const i18nKey = field === "avatar" ? "user_details.field_avatar_placeholder" : `profile.settings.${field}`;
        return t(i18nKey);
    };
    const onSubmit = async ()=>{
        clearErrors();
        handleSubmit(async (data)=>{
            try {
                await api.patch("me", {
                    json: {
                        [field]: data[field]
                    }
                });
                (0, $horhC.toast).success(t("profile.updated", {
                    target: t(`profile.settings.${field}`)
                }));
                onClose();
            } catch (error) {
                (0, $4a20295e045d868b$export$d3da1ecaf1206c58)(error, async (_, message, status)=>{
                    if (status === 422) {
                        await showModal({
                            ModalContent: message,
                            type: "alert",
                            cancelButtonText: "general.got_it"
                        });
                        return true;
                    }
                });
            }
        })();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: getModalTitle(),
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                size: "large",
                title: "general.save",
                isLoading: isSubmitting,
                onClick: onSubmit
            }),
            onClose: onClose,
            children: field === "avatar" && isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                name: "avatar",
                control: control,
                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $0186093e59e66ade$export$2e2bcd8739ae039), {
                        name: name,
                        value: value,
                        onChange: onChange
                    })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                ...register(field, {
                    validate: (value)=>field !== "username" || !!value || t("errors.required_field_missing", {
                            field: t(`profile.settings.${field}`)
                        })
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                placeholder: getInputPlaceholder(),
                error: errors[field]?.message,
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            })
        })
    });
}
var $8e2514e0da123904$export$2e2bcd8739ae039 = $8e2514e0da123904$var$BasicUserInfoUpdateModal;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $9fc00c837c262536$export$6f093cfa640b7166;
$9fc00c837c262536$export$6f093cfa640b7166 = `kSGQ4G_text`;


function $7fb5def8d0e99e02$var$NotSet() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        className: $9fc00c837c262536$export$6f093cfa640b7166,
        children: t("profile.not_set")
    });
}
var $7fb5def8d0e99e02$export$2e2bcd8739ae039 = $7fb5def8d0e99e02$var$NotSet;


var $428c0fc2e66d62f3$export$a75c7ea49564edd7;
var $428c0fc2e66d62f3$export$34e0f9847d4c02dd;
var $428c0fc2e66d62f3$export$1ca1ec8b29a4ce27;
var $428c0fc2e66d62f3$export$bfd64c937657f93a;
var $428c0fc2e66d62f3$export$4a6dd88bada4e7d2;
var $428c0fc2e66d62f3$export$fb184b623420d9be;
var $428c0fc2e66d62f3$export$cc74dcc53cfce4eb;
$428c0fc2e66d62f3$export$a75c7ea49564edd7 = `Qw8NkG_actionButton`;
$428c0fc2e66d62f3$export$34e0f9847d4c02dd = `Qw8NkG_container`;
$428c0fc2e66d62f3$export$1ca1ec8b29a4ce27 = `Qw8NkG_icon`;
$428c0fc2e66d62f3$export$bfd64c937657f93a = `Qw8NkG_rotating`;
$428c0fc2e66d62f3$export$4a6dd88bada4e7d2 = `Qw8NkG_shimmer`;
$428c0fc2e66d62f3$export$fb184b623420d9be = `Qw8NkG_title`;
$428c0fc2e66d62f3$export$cc74dcc53cfce4eb = `Qw8NkG_wrapper`;


function $3caa4832f69a8ce3$var$CardContent({ title: title, data: data }) {
    const defaultRenderer = (value)=>value ? /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
            children: String(value)
        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fb5def8d0e99e02$export$2e2bcd8739ae039), {});
    if (data.length === 0) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $428c0fc2e66d62f3$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $428c0fc2e66d62f3$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: title
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("table", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("tbody", {
                    children: data.map(({ key: key, icon: icon, label: label, value: value, renderer: renderer = defaultRenderer, action: action })=>{
                        const actions = Array.isArray(action) ? action : [
                            action
                        ];
                        return /*#__PURE__*/ (0, $9zeGj.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $428c0fc2e66d62f3$export$cc74dcc53cfce4eb,
                                        children: [
                                            icon && /*#__PURE__*/ (0, $eCoWV.cloneElement)(icon, {
                                                className: $428c0fc2e66d62f3$export$1ca1ec8b29a4ce27
                                            }),
                                            typeof label === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                                forKey: label
                                            }) : label
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                    children: renderer(value)
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $428c0fc2e66d62f3$export$cc74dcc53cfce4eb,
                                        children: actions.map(({ name: name, handler: handler })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                                className: $428c0fc2e66d62f3$export$a75c7ea49564edd7,
                                                type: "text",
                                                size: "small",
                                                title: name,
                                                onClick: handler
                                            }, name))
                                    })
                                })
                            ]
                        }, key);
                    })
                })
            })
        ]
    });
}
var $3caa4832f69a8ce3$export$2e2bcd8739ae039 = $3caa4832f69a8ce3$var$CardContent;


function $febd2b1edd449175$var$BasicUserInfoSection({ user: user, onUpdate: onUpdate }) {
    const [editingField, setEditingField] = (0, $eCoWV.useState)();
    const [isUpdateModalOpen, setIsUpdateModalOpen] = (0, $eCoWV.useState)(false);
    const { name: name, username: username, avatar: avatar } = user;
    const conditionalUsername = (0, $V1X8c.isCloud) ? [] : [
        {
            key: "username",
            label: "profile.settings.username",
            value: username,
            action: {
                name: "profile.change",
                handler: ()=>{
                    setEditingField("username");
                    setIsUpdateModalOpen(true);
                }
            }
        }
    ];
    // Get the value of the editing simple field (avatar, username or name)
    const getSimpleFieldValue = (field)=>{
        const value = field === "avatar" ? avatar : user[field];
        return value ?? "";
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "profile.settings.title",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3caa4832f69a8ce3$export$2e2bcd8739ae039), {
                title: "profile.settings.profile_information",
                data: [
                    {
                        key: "avatar",
                        label: "profile.settings.avatar",
                        value: avatar,
                        renderer: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                                size: "large",
                                user: user
                            }),
                        action: {
                            name: "profile.change",
                            handler: ()=>{
                                setEditingField("avatar");
                                setIsUpdateModalOpen(true);
                            }
                        }
                    },
                    {
                        key: "name",
                        label: "profile.settings.name",
                        value: name,
                        action: {
                            name: name ? "profile.change" : "profile.set_name",
                            handler: ()=>{
                                setEditingField("name");
                                setIsUpdateModalOpen(true);
                            }
                        }
                    },
                    ...conditionalUsername
                ]
            }),
            editingField && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8e2514e0da123904$export$2e2bcd8739ae039), {
                value: getSimpleFieldValue(editingField),
                field: editingField,
                isOpen: isUpdateModalOpen,
                onClose: ()=>{
                    setIsUpdateModalOpen(false);
                    onUpdate?.();
                }
            })
        ]
    });
}
var $febd2b1edd449175$export$2e2bcd8739ae039 = $febd2b1edd449175$var$BasicUserInfoSection;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j7Jj8");
var $9rcvl = parcelRequire("9rcvl");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("cL8zv");
var $jKlLV = parcelRequire("jKlLV");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
var $b9zrd = parcelRequire("b9zrd");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8d763a335e7d75ac$var$SvgMail = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M15.834 3.333H4.167a2.5 2.5 0 0 0-2.5 2.5v8.334a2.5 2.5 0 0 0 2.5 2.5h11.667a2.5 2.5 0 0 0 2.5-2.5V5.833a2.5 2.5 0 0 0-2.5-2.5ZM4.167 5h11.667a.833.833 0 0 1 .833.833L10 9.9 3.334 5.833A.833.833 0 0 1 4.167 5Zm12.5 9.167a.833.833 0 0 1-.833.833H4.167a.833.833 0 0 1-.833-.833V7.734l6.233 3.808a.833.833 0 0 0 .833 0l6.267-3.808v6.433Z",
            fill: "currentColor"
        })
    });
var $8d763a335e7d75ac$export$2e2bcd8739ae039 = $8d763a335e7d75ac$var$SvgMail;





parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");
var $mbOAD = parcelRequire("mbOAD");


var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");



var $5b98e2b22fb37c49$export$bfd64c937657f93a;
var $5b98e2b22fb37c49$export$4a6dd88bada4e7d2;
var $5b98e2b22fb37c49$export$cc74dcc53cfce4eb;
$5b98e2b22fb37c49$export$bfd64c937657f93a = `XeRJzW_rotating`;
$5b98e2b22fb37c49$export$4a6dd88bada4e7d2 = `XeRJzW_shimmer`;
$5b98e2b22fb37c49$export$cc74dcc53cfce4eb = `XeRJzW_wrapper`;


function $6a0bd3a873794170$var$LinkAccountSection({ user: user, connectors: connectors, onUpdate: onUpdate }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate, getUrl: getUrl } = (0, $4W0F0.default)();
    const theme = (0, $93h5F.default)();
    const { show: showConfirm } = (0, $9ENFn.useConfirmModal)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator
    });
    const getSocialAuthorizationUri = (0, $eCoWV.useCallback)(async (connectorId)=>{
        const adminTenantEndpointUrl = new URL((0, $9oLtf.adminTenantEndpoint));
        const state = (0, $jKlLV.generateStandardId)(8);
        const redirectUri = new URL(`/callback/${connectorId}`, adminTenantEndpointUrl).href;
        const { redirectTo: redirectTo } = await api.post("me/social/authorization-uri", {
            json: {
                connectorId: connectorId,
                state: state,
                redirectUri: redirectUri
            }
        }).json();
        sessionStorage.setItem((0, $mbOAD.storageKeys).linkingSocialConnector, connectorId);
        return redirectTo;
    }, [
        api
    ]);
    const tableInfo = (0, $eCoWV.useMemo)(()=>{
        if (!connectors) return [];
        return connectors.map(({ id: id, name: name, logo: logo, logoDark: logoDark, target: target })=>{
            const logoSrc = theme === (0, $bhvxB.Theme).Dark && logoDark ? logoDark : logo;
            const relatedUserDetails = user.identities[target]?.details;
            const socialUserInfo = (0, $9rcvl.socialUserInfoGuard).safeParse(relatedUserDetails);
            const hasLinked = socialUserInfo.success;
            return {
                key: target,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
                    src: logoSrc
                }),
                label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                    resource: name
                }),
                value: (0, $5CQIb.conditional)(hasLinked && socialUserInfo.data),
                renderer: (user)=>user ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $61a8dce11d5a3fab$export$2e2bcd8739ae039), {
                        user: user
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fb5def8d0e99e02$export$2e2bcd8739ae039), {}),
                action: hasLinked ? {
                    name: "profile.unlink",
                    handler: async ()=>{
                        const [result] = await showConfirm({
                            ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                    components: {
                                        span: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                                            resource: name
                                        })
                                    },
                                    children: t("profile.unlink_reminder")
                                }),
                            confirmButtonText: "profile.unlink_confirm_text"
                        });
                        if (result) {
                            await api.delete(`me/social/identity/${id}`);
                            onUpdate();
                        }
                    }
                } : {
                    name: "profile.link",
                    handler: async ()=>{
                        const authUri = await getSocialAuthorizationUri(id);
                        const callback = getUrl("handle-social").href;
                        const queries = new URLSearchParams({
                            redirectTo: authUri,
                            connectorId: id,
                            callback: callback
                        });
                        const newWindow = (0, $4a20295e045d868b$export$20ff57c8784c652c)((0, $b9zrd.appendPath)((0, $9oLtf.adminTenantEndpoint), `/springboard?${queries.toString()}`).href, "Link social account with Logto", 600, 640);
                        newWindow?.focus();
                    }
                }
            };
        });
    }, [
        api,
        connectors,
        theme,
        user.identities,
        showConfirm,
        t,
        onUpdate,
        getSocialAuthorizationUri,
        getUrl
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "profile.link_account.title",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3caa4832f69a8ce3$export$2e2bcd8739ae039), {
                title: "profile.link_account.email_sign_in",
                data: [
                    {
                        key: "email",
                        label: "profile.link_account.email",
                        value: user.primaryEmail,
                        renderer: (email)=>email ? /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $5b98e2b22fb37c49$export$cc74dcc53cfce4eb,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8d763a335e7d75ac$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        children: email
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fb5def8d0e99e02$export$2e2bcd8739ae039), {}),
                        action: {
                            name: user.primaryEmail ? "profile.change" : "profile.link",
                            handler: ()=>{
                                navigate("link-email", {
                                    state: {
                                        email: user.primaryEmail,
                                        action: "changeEmail"
                                    }
                                });
                            }
                        }
                    }
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3caa4832f69a8ce3$export$2e2bcd8739ae039), {
                title: "profile.link_account.social_sign_in",
                data: tableInfo
            })
        ]
    });
}
var $6a0bd3a873794170$export$2e2bcd8739ae039 = $6a0bd3a873794170$var$LinkAccountSection;




var $9zeGj = parcelRequire("9zeGj");
var $bd58518315e66ed1$export$aa3e815946b80764;
var $bd58518315e66ed1$export$34e0f9847d4c02dd;
var $bd58518315e66ed1$export$7061c75fc5af8b7e;
var $bd58518315e66ed1$export$1237798dc640739a;
var $bd58518315e66ed1$export$bfd64c937657f93a;
var $bd58518315e66ed1$export$fe2e36411d703b3d;
var $bd58518315e66ed1$export$4a6dd88bada4e7d2;
var $bd58518315e66ed1$export$9852986a3ec5f6a0;
var $bd58518315e66ed1$export$fb184b623420d9be;
var $bd58518315e66ed1$export$f9922917cc86d0cb;
$bd58518315e66ed1$export$aa3e815946b80764 = `NgX8vq_card`;
$bd58518315e66ed1$export$34e0f9847d4c02dd = `NgX8vq_container`;
$bd58518315e66ed1$export$7061c75fc5af8b7e = `NgX8vq_item`;
$bd58518315e66ed1$export$1237798dc640739a = `NgX8vq_label`;
$bd58518315e66ed1$export$bfd64c937657f93a = `NgX8vq_rotating`;
$bd58518315e66ed1$export$fe2e36411d703b3d = `NgX8vq_section`;
$bd58518315e66ed1$export$4a6dd88bada4e7d2 = `NgX8vq_shimmer`;
$bd58518315e66ed1$export$4a6dd88bada4e7d2;
$bd58518315e66ed1$export$9852986a3ec5f6a0 = `NgX8vq_table`;
$bd58518315e66ed1$export$fb184b623420d9be = `NgX8vq_title`;
$bd58518315e66ed1$export$f9922917cc86d0cb = `NgX8vq_titleWrapper`;


function $e29fdc2e091d68fc$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        className: $bd58518315e66ed1$export$34e0f9847d4c02dd,
        children: Array.from({
            length: 2
        }).map((_, sectionIndex)=>// eslint-disable-next-line react/no-array-index-key
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $bd58518315e66ed1$export$fe2e36411d703b3d,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $bd58518315e66ed1$export$f9922917cc86d0cb,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $bd58518315e66ed1$export$fb184b623420d9be
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $bd58518315e66ed1$export$aa3e815946b80764,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $bd58518315e66ed1$export$1237798dc640739a
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("table", {
                                className: $bd58518315e66ed1$export$9852986a3ec5f6a0,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)("tbody", {
                                    children: Array.from({
                                        length: 3
                                    }).map((_, rowIndex)=>// eslint-disable-next-line react/no-array-index-key
                                        /*#__PURE__*/ (0, $9zeGj.jsxs)("tr", {
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $bd58518315e66ed1$export$7061c75fc5af8b7e
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $bd58518315e66ed1$export$7061c75fc5af8b7e
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("td", {
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $bd58518315e66ed1$export$7061c75fc5af8b7e
                                                    })
                                                })
                                            ]
                                        }, rowIndex))
                                })
                            })
                        ]
                    })
                ]
            }, sectionIndex))
    });
}
var $e29fdc2e091d68fc$export$2e2bcd8739ae039 = $e29fdc2e091d68fc$var$Skeleton;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");
parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $kcPww = parcelRequire("kcPww");

var $bNHoO = parcelRequire("bNHoO");

var $1Iq4D = parcelRequire("1Iq4D");

var $7iZsu = parcelRequire("7iZsu");
var $aa9df7355ddd09c2$export$34e0f9847d4c02dd;
var $aa9df7355ddd09c2$export$b602b78110e4ab1e;
var $aa9df7355ddd09c2$export$bfd64c937657f93a;
var $aa9df7355ddd09c2$export$4a6dd88bada4e7d2;
$aa9df7355ddd09c2$export$34e0f9847d4c02dd = `shIkWq_container`;
$aa9df7355ddd09c2$export$b602b78110e4ab1e = `shIkWq_mail`;
$aa9df7355ddd09c2$export$bfd64c937657f93a = `shIkWq_rotating`;
$aa9df7355ddd09c2$export$4a6dd88bada4e7d2 = `shIkWq_shimmer`;


const $3c2a328aa2984008$var$mailToLink = `${(0, $o53Y2.contactEmailLink)}?subject=Account%20Deletion%20Request`;
function $3c2a328aa2984008$var$DeleteAccountModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "profile.delete_account.label",
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "large",
                title: "general.got_it",
                onClick: onClose
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $aa9df7355ddd09c2$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                        children: t("profile.delete_account.dialog_paragraph_1")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                    href: $3c2a328aa2984008$var$mailToLink,
                                    className: $aa9df7355ddd09c2$export$b602b78110e4ab1e
                                })
                            },
                            children: t("profile.delete_account.dialog_paragraph_2", {
                                mail: (0, $o53Y2.contactEmail)
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                        children: t("profile.delete_account.dialog_paragraph_3")
                    })
                ]
            })
        })
    });
}
var $3c2a328aa2984008$export$2e2bcd8739ae039 = $3c2a328aa2984008$var$DeleteAccountModal;


var $369cd175f8076caa$export$a7db06668cad9adb;
var $369cd175f8076caa$export$45abfc3976589d02;
var $369cd175f8076caa$export$6d59db4903f20f7d;
var $369cd175f8076caa$export$bfd64c937657f93a;
var $369cd175f8076caa$export$4a6dd88bada4e7d2;
$369cd175f8076caa$export$a7db06668cad9adb = `HzVHqa_content`;
$369cd175f8076caa$export$45abfc3976589d02 = `HzVHqa_deleteAccount`;
$369cd175f8076caa$export$6d59db4903f20f7d = `HzVHqa_description`;
$369cd175f8076caa$export$bfd64c937657f93a = `HzVHqa_rotating`;
$369cd175f8076caa$export$4a6dd88bada4e7d2 = `HzVHqa_shimmer`;


function $f1109971e06adf3b$var$Profile() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator
    });
    const fetcher = (0, $9c44974c18641844$export$2e2bcd8739ae039)(api);
    const { data: connectors, error: fetchConnectorsError } = (0, $iwEyX.default)("me/social/connectors", fetcher);
    const isLoadingConnectors = !connectors && !fetchConnectorsError;
    const { user: user, reload: reload, isLoading: isLoadingUser } = (0, $475a856ff8d4300b$export$2e2bcd8739ae039)();
    const { isLoading: isUserAssetServiceLoading } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const [showDeleteAccountModal, setShowDeleteAccountModal] = (0, $eCoWV.useState)(false);
    const showLoadingSkeleton = isLoadingUser || isLoadingConnectors || isUserAssetServiceLoading;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $f3853caa1df6ee27$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "profile.page_title"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f3853caa1df6ee27$export$516dd90aeaaabcf0,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                    title: "profile.title",
                    subtitle: "profile.description"
                })
            }),
            showLoadingSkeleton && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e29fdc2e091d68fc$export$2e2bcd8739ae039), {}),
            user && !showLoadingSkeleton && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $369cd175f8076caa$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $febd2b1edd449175$export$2e2bcd8739ae039), {
                        user: user,
                        onUpdate: reload
                    }),
                    (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6a0bd3a873794170$export$2e2bcd8739ae039), {
                        user: user,
                        connectors: connectors,
                        onUpdate: reload
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "profile.password.title",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3caa4832f69a8ce3$export$2e2bcd8739ae039), {
                            title: "profile.password.password_setting",
                            data: [
                                {
                                    key: "password",
                                    label: "profile.password.password",
                                    value: user.hasPassword,
                                    renderer: (value)=>value ? /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                            children: "********"
                                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7fb5def8d0e99e02$export$2e2bcd8739ae039), {}),
                                    action: {
                                        name: "profile.change",
                                        handler: ()=>{
                                            navigate(user.hasPassword ? "verify-password" : "change-password", {
                                                state: {
                                                    email: user.primaryEmail,
                                                    action: "changePassword"
                                                }
                                            });
                                        }
                                    }
                                }
                            ]
                        })
                    }),
                    (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "profile.delete_account.title",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $369cd175f8076caa$export$45abfc3976589d02,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $369cd175f8076caa$export$6d59db4903f20f7d,
                                        children: t("profile.delete_account.description")
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                        title: "profile.delete_account.button",
                                        onClick: ()=>{
                                            setShowDeleteAccountModal(true);
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3c2a328aa2984008$export$2e2bcd8739ae039), {
                                isOpen: showDeleteAccountModal,
                                onClose: ()=>{
                                    setShowDeleteAccountModal(false);
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $f1109971e06adf3b$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($f1109971e06adf3b$var$Profile);



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $6d0070ca65c05c95$var$SvgClearInput = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18ZM8.464 9.879A1 1 0 1 1 9.88 8.464L12 10.586l2.121-2.122a1 1 0 1 1 1.415 1.415L13.414 12l2.122 2.121a1 1 0 1 1-1.415 1.415L12 13.414l-2.121 2.122a1 1 0 1 1-1.415-1.415L10.586 12 8.464 9.879Z",
            fill: "currentcolor"
        })
    });
var $6d0070ca65c05c95$export$2e2bcd8739ae039 = $6d0070ca65c05c95$var$SvgClearInput;


parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $kcPww = parcelRequire("kcPww");


var $9bgsA = parcelRequire("9bgsA");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");

var $4W0F0 = parcelRequire("4W0F0");

var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");


var $fbeQ6 = parcelRequire("fbeQ6");

var $1Iq4D = parcelRequire("1Iq4D");

var $7iZsu = parcelRequire("7iZsu");
var $c485672b625b3b34$export$8d6d009d1f06226e;
var $c485672b625b3b34$export$34e0f9847d4c02dd;
var $c485672b625b3b34$export$bfd64c937657f93a;
var $c485672b625b3b34$export$4a6dd88bada4e7d2;
var $c485672b625b3b34$export$59ae2c325a998f89;
var $c485672b625b3b34$export$c96745152eb2740f;
var $c485672b625b3b34$export$fb184b623420d9be;
var $c485672b625b3b34$export$cc74dcc53cfce4eb;
$c485672b625b3b34$export$8d6d009d1f06226e = `_79gXNq_backButton`;
$c485672b625b3b34$export$34e0f9847d4c02dd = `_79gXNq_container`;
$c485672b625b3b34$export$bfd64c937657f93a = `_79gXNq_rotating`;
$c485672b625b3b34$export$4a6dd88bada4e7d2 = `_79gXNq_shimmer`;
$c485672b625b3b34$export$59ae2c325a998f89 = `_79gXNq_strong`;
$c485672b625b3b34$export$c96745152eb2740f = `_79gXNq_subtitle`;
$c485672b625b3b34$export$fb184b623420d9be = `_79gXNq_title`;
$c485672b625b3b34$export$cc74dcc53cfce4eb = `_79gXNq_wrapper`;


function $78fb4cbcbe65b190$var$MainFlowLikeModal({ title: title, subtitle: subtitle, subtitleProps: subtitleProps, children: children, onClose: onClose, onGoBack: onGoBack }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const navigate = (0, $9X5Bp.useNavigate)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.fullScreen,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($7iZsu.content, $c485672b625b3b34$export$34e0f9847d4c02dd),
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c485672b625b3b34$export$cc74dcc53cfce4eb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        className: $c485672b625b3b34$export$8d6d009d1f06226e,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $505074c92853ff4a$export$2e2bcd8739ae039), {}),
                        onClick: ()=>{
                            if (onGoBack) onGoBack();
                            else navigate(-1);
                        },
                        children: t("general.back")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $c485672b625b3b34$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: title
                        })
                    }),
                    subtitle && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $c485672b625b3b34$export$c96745152eb2740f,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                strong: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                    className: $c485672b625b3b34$export$59ae2c325a998f89
                                })
                            },
                            children: t(subtitle, subtitleProps ?? {})
                        })
                    }),
                    children
                ]
            })
        })
    });
}
var $78fb4cbcbe65b190$export$2e2bcd8739ae039 = $78fb4cbcbe65b190$var$MainFlowLikeModal;



const $94b6d6f91f56539f$var$defaultValues = {
    newPassword: "",
    confirmPassword: "",
    showPassword: false
};
function $94b6d6f91f56539f$var$ChangePasswordModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { show: showModal } = (0, $9ENFn.useConfirmModal)();
    const { watch: watch, reset: reset, register: register, clearErrors: clearErrors, handleSubmit: handleSubmit, setValue: setValue, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur",
        defaultValues: $94b6d6f91f56539f$var$defaultValues
    });
    const [showPassword, setShowPassword] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator,
        hideErrorToast: true
    });
    const onClose = ()=>{
        reset();
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit(async ({ newPassword: newPassword })=>{
            try {
                await api.post(`me/password`, {
                    json: {
                        password: newPassword
                    }
                });
                (0, $horhC.toast).success(t("profile.password_changed"));
                onClose();
            } catch (error) {
                (0, $4a20295e045d868b$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                    if (code === "session.verification_failed") {
                        await showModal({
                            ModalContent: message,
                            type: "alert",
                            cancelButtonText: "general.got_it"
                        });
                        onClose();
                        return true;
                    }
                });
            }
        })();
    };
    const onKeyDown = (event)=>{
        if (event.key === "Enter") onSubmit();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $78fb4cbcbe65b190$export$2e2bcd8739ae039), {
        title: "profile.password.set_password",
        onClose: onClose,
        onGoBack: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                placeholder: t("profile.password.password"),
                ...register("newPassword", {
                    required: t("profile.password.required")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                type: showPassword ? "text" : "password",
                error: errors.newPassword?.message,
                suffix: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setValue("newPassword", "");
                    },
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d0070ca65c05c95$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                placeholder: t("profile.password.confirm_password"),
                ...register("confirmPassword", {
                    validate: (value)=>value === watch("newPassword") || t("profile.password.do_not_match")
                }),
                type: showPassword ? "text" : "password",
                error: errors.confirmPassword?.message,
                suffix: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setValue("confirmPassword", "");
                    },
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d0070ca65c05c95$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: onKeyDown
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                checked: showPassword,
                label: t("profile.password.show_password"),
                onChange: ()=>{
                    setShowPassword((value)=>!value);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                title: "general.create",
                size: "large",
                isLoading: isSubmitting,
                onClick: onSubmit
            })
        ]
    });
}
var $94b6d6f91f56539f$export$2e2bcd8739ae039 = $94b6d6f91f56539f$var$ChangePasswordModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $kcPww = parcelRequire("kcPww");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $bSFEw = parcelRequire("bSFEw");


function $f7dc9254f7cd6e01$var$LinkEmailModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { state: state } = (0, $9X5Bp.useLocation)();
    const { register: register, reset: reset, clearErrors: clearErrors, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur"
    });
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator
    });
    const onClose = ()=>{
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ email: email })=>{
            await api.post(`me/verification-codes`, {
                json: {
                    email: email
                }
            });
            reset();
            navigate("../verification-code", {
                state: {
                    email: email,
                    action: "changeEmail"
                }
            });
        }))();
    };
    const { email: currentEmail } = (0, $4a20295e045d868b$export$23da1b6a36f0a363)(state);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $78fb4cbcbe65b190$export$2e2bcd8739ae039), {
        title: "profile.link_account.link_email",
        subtitle: "profile.link_account.link_email_subtitle",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                ...register("email", {
                    required: t("profile.link_account.email_required"),
                    pattern: {
                        value: (0, $dQcUe.emailRegEx),
                        message: t("profile.link_account.invalid_email")
                    },
                    validate: (value)=>!currentEmail || currentEmail !== value || t("profile.link_account.identical_email_address")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                error: errors.email?.message,
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                size: "large",
                title: "general.continue",
                isLoading: isSubmitting,
                onClick: onSubmit
            })
        ]
    });
}
var $f7dc9254f7cd6e01$export$2e2bcd8739ae039 = $f7dc9254f7cd6e01$var$LinkEmailModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $674b10126250d6b7$var$SvgArrowConnection = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 18,
        height: 18,
        viewBox: "0 0 18 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m16.282 6.713-3-3a.752.752 0 1 0-1.065 1.065l1.725 1.718H5.25a.75.75 0 1 0 0 1.5h10.5a.75.75 0 0 0 .69-.465.75.75 0 0 0-.158-.818Zm-3.532 3.783H2.25a.75.75 0 0 0-.69.465.75.75 0 0 0 .157.817l3 3a.75.75 0 0 0 1.23-.244.75.75 0 0 0-.165-.82l-1.725-1.718h8.693a.75.75 0 1 0 0-1.5Z",
            fill: "currentColor"
        })
    });
var $674b10126250d6b7$export$2e2bcd8739ae039 = $674b10126250d6b7$var$SvgArrowConnection;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
var $60d21513b4d4b200$export$493b5823483d2c4e;
var $60d21513b4d4b200$export$b7e3ae3d7c15e42e;
var $60d21513b4d4b200$export$bfd64c937657f93a;
var $60d21513b4d4b200$export$4a6dd88bada4e7d2;
var $60d21513b4d4b200$export$cc74dcc53cfce4eb;
$60d21513b4d4b200$export$493b5823483d2c4e = `oZB0cq_errorMessage`;
$60d21513b4d4b200$export$b7e3ae3d7c15e42e = `oZB0cq_input`;
$60d21513b4d4b200$export$bfd64c937657f93a = `oZB0cq_rotating`;
$60d21513b4d4b200$export$4a6dd88bada4e7d2 = `oZB0cq_shimmer`;
$60d21513b4d4b200$export$cc74dcc53cfce4eb = `oZB0cq_wrapper`;


const $dac351cfe1ad4802$export$439d7c9fdf7148d2 = 6;
const $dac351cfe1ad4802$var$isNumeric = (char)=>/^\d+$/.test(char);
const $dac351cfe1ad4802$var$normalize = (value, length)=>{
    if (value.length > length) return value.slice(0, length);
    if (value.length < length) // Undefined will not overwrite the original input displays, need to pass in empty string instead
    return value.concat(Array.from({
        length: length - value.length
    }).fill(""));
    return value;
};
function $dac351cfe1ad4802$var$VerificationCodeInput({ name: name, className: className, value: value, length: length = $dac351cfe1ad4802$export$439d7c9fdf7148d2, error: error, onChange: onChange }) {
    /* eslint-disable @typescript-eslint/ban-types */ const inputReferences = (0, $eCoWV.useRef)(Array.from({
        length: length
    }).fill(null));
    /* eslint-enable @typescript-eslint/ban-types */ const codes = (0, $eCoWV.useMemo)(()=>$dac351cfe1ad4802$var$normalize(value, length), [
        length,
        value
    ]);
    const updateValue = (0, $eCoWV.useCallback)((data, targetId)=>{
        // Filter non-numeric input
        if (!$dac351cfe1ad4802$var$isNumeric(data)) return;
        const chars = data.split("");
        const trimmedChars = chars.slice(0, Math.min(chars.length, codes.length - targetId));
        const value = [
            ...codes.slice(0, targetId),
            ...trimmedChars,
            ...codes.slice(targetId + trimmedChars.length, codes.length)
        ];
        onChange(value);
        // Move to the next target
        const nextTarget = inputReferences.current[Math.min(targetId + trimmedChars.length, codes.length - 1)];
        nextTarget?.focus();
    }, [
        codes,
        onChange
    ]);
    const onInputHandler = (0, $eCoWV.useCallback)((event)=>{
        const { target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(value, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onPasteHandler = (0, $eCoWV.useCallback)((event)=>{
        if (!(event.target instanceof HTMLInputElement)) return;
        const { target: { dataset: dataset }, clipboardData: clipboardData } = event;
        const data = clipboardData.getData("text").match(/\d/g)?.join("") ?? "";
        // Unrecognized target input field
        if (!dataset.id) return;
        event.preventDefault();
        updateValue(data, Number(dataset.id));
    }, [
        updateValue
    ]);
    const onKeyDownHandler = (0, $eCoWV.useCallback)((event)=>{
        const { key: key, target: target } = event;
        if (!(target instanceof HTMLInputElement)) return;
        const { value: value, dataset: dataset } = target;
        if (!dataset.id) return;
        const targetId = Number(dataset.id);
        const nextTarget = inputReferences.current[targetId + 1];
        const previousTarget = inputReferences.current[targetId - 1];
        switch(key){
            case "Backspace":
                event.preventDefault();
                if (value) {
                    onChange(Object.assign([], codes, {
                        [targetId]: ""
                    }));
                    break;
                }
                if (previousTarget) {
                    previousTarget.focus();
                    onChange(Object.assign([], codes, {
                        [targetId - 1]: ""
                    }));
                }
                break;
            case "ArrowLeft":
                event.preventDefault();
                previousTarget?.focus();
                break;
            case "ArrowRight":
                event.preventDefault();
                nextTarget?.focus();
                break;
            case "+":
            case "-":
            case "e":
            case ".":
            case "ArrowUp":
            case "ArrowDown":
                event.preventDefault();
                break;
            default:
                break;
        }
    }, [
        codes,
        onChange
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (value.length === 0) inputReferences.current[0]?.focus();
    }, [
        value
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: className,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $60d21513b4d4b200$export$cc74dcc53cfce4eb,
                children: Array.from({
                    length: length
                }).map((_, index)=>/*#__PURE__*/ (0, $9zeGj.jsx)("input", {
                        ref: (element)=>{
                            // eslint-disable-next-line @silverhand/fp/no-mutation
                            inputReferences.current[index] = element;
                        },
                        className: $60d21513b4d4b200$export$b7e3ae3d7c15e42e,
                        name: `${name}_${index}`,
                        "data-id": index,
                        value: codes[index],
                        type: "number",
                        inputMode: "numeric",
                        pattern: "[0-9]*",
                        autoComplete: "off",
                        onPaste: onPasteHandler,
                        onInput: onInputHandler,
                        onKeyDown: onKeyDownHandler
                    }, `${name}_${index}`))
            }),
            error && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $60d21513b4d4b200$export$493b5823483d2c4e,
                children: error
            })
        ]
    });
}
var $dac351cfe1ad4802$export$2e2bcd8739ae039 = $dac351cfe1ad4802$var$VerificationCodeInput;


parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $1Iq4D = parcelRequire("1Iq4D");

var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");


var $4W0F0 = parcelRequire("4W0F0");


var $179f28892607b1fb$export$9c30223ca0a664fb;
var $179f28892607b1fb$export$a8ecead220dd38a6;
$179f28892607b1fb$export$9c30223ca0a664fb = `KTc0zW_link`;
$179f28892607b1fb$export$a8ecead220dd38a6 = `KTc0zW_message`;


const $af21ae4746dd3cb9$var$resendTimeout = 59;
const $af21ae4746dd3cb9$var$getTimeout = ()=>{
    const now = new Date();
    now.setSeconds(now.getSeconds() + $af21ae4746dd3cb9$var$resendTimeout);
    return now;
};
function $af21ae4746dd3cb9$var$VerificationCodeModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { show: showModal } = (0, $9ENFn.useConfirmModal)();
    const { state: state } = (0, $9X5Bp.useLocation)();
    const { reload: reload } = (0, $475a856ff8d4300b$export$2e2bcd8739ae039)();
    const [code, setCode] = (0, $eCoWV.useState)([]);
    const [error, setError] = (0, $eCoWV.useState)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator,
        hideErrorToast: true
    });
    const { email: email, action: action } = (0, $4a20295e045d868b$export$23da1b6a36f0a363)(state);
    const { seconds: seconds, isRunning: isRunning, restart: restart } = (0, $a0a31230e6397188$exports.useTimer)({
        autoStart: true,
        expiryTimestamp: $af21ae4746dd3cb9$var$getTimeout()
    });
    const onClose = (0, $eCoWV.useCallback)(()=>{
        navigate("/profile");
        reload();
    }, [
        navigate,
        reload
    ]);
    const onSubmit = (0, $eCoWV.useCallback)(async ()=>{
        const verificationCode = code.join("");
        if (!email || !verificationCode) return;
        try {
            await api.post(`me/verification-codes/verify`, {
                json: {
                    verificationCode: verificationCode,
                    email: email,
                    action: action
                }
            });
            if (action === "changeEmail") {
                await api.patch("me", {
                    json: {
                        primaryEmail: email
                    }
                });
                (0, $horhC.toast).success(t("profile.email_changed"));
                onClose();
            }
            if (action === "changePassword") navigate("../change-password", {
                state: state
            });
        } catch (error) {
            (0, $4a20295e045d868b$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                // The following errors will be displayed as inline error message.
                if ([
                    "verification_code.code_mismatch",
                    "verification_code.exceed_max_try",
                    "verification_code.not_found"
                ].includes(code)) {
                    setError(message);
                    return true;
                }
                // Other verification code errors will be displayed in a popup modal.
                if (code.startsWith("verification_code.") || code === "user.email_already_in_use") {
                    await showModal({
                        ModalContent: message,
                        type: "alert",
                        cancelButtonText: "general.got_it"
                    });
                    onClose();
                    return true;
                }
            });
        }
    }, [
        code,
        email,
        api,
        action,
        t,
        onClose,
        navigate,
        state,
        showModal
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (code.length === (0, $dac351cfe1ad4802$export$439d7c9fdf7148d2) && code.every(Boolean)) onSubmit();
    }, [
        code,
        onSubmit
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $78fb4cbcbe65b190$export$2e2bcd8739ae039), {
        title: "profile.code.enter_verification_code",
        subtitle: "profile.code.enter_verification_code_subtitle",
        subtitleProps: (0, $5CQIb.conditional)(email && {
            target: email
        }),
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dac351cfe1ad4802$export$2e2bcd8739ae039), {
                name: "verificationCode",
                value: code,
                error: error,
                onChange: (value)=>{
                    setCode(value);
                    setError(undefined);
                }
            }),
            isRunning ? /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $179f28892607b1fb$export$a8ecead220dd38a6,
                children: t("profile.code.resend_countdown", {
                    countdown: seconds
                })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                className: $179f28892607b1fb$export$9c30223ca0a664fb,
                onClick: async ()=>{
                    setCode([]);
                    setError(undefined);
                    await api.post(`me/verification-codes`, {
                        json: {
                            email: email
                        }
                    });
                    restart($af21ae4746dd3cb9$var$getTimeout(), true);
                },
                children: t("profile.code.resend")
            }),
            action === "changePassword" && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                className: $179f28892607b1fb$export$9c30223ca0a664fb,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $674b10126250d6b7$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    navigate("../verify-password", {
                        state: state
                    });
                },
                children: t("profile.password.verify_via_password")
            })
        ]
    });
}
var $af21ae4746dd3cb9$export$2e2bcd8739ae039 = $af21ae4746dd3cb9$var$VerificationCodeModal;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $8cb605c19c99cb47$var$SvgPasswordHide = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4.929 3.929a1 1 0 0 0 0 1.414L6.505 6.92C3.791 8.797 2 11.452 2 12c0 .866 4.477 7 10 7 1.82 0 3.526-.666 4.996-1.59l.66.661a1 1 0 0 0 1.415-1.414L6.343 3.929a1 1 0 0 0-1.414 0Zm9.685 11.099L8.972 9.386a4 4 0 0 0 5.642 5.642Zm-1.057-6.714a4.014 4.014 0 0 1 2.129 2.13l4.39 4.389C21.285 13.533 22 12.346 22 12c0-.866-4.477-7-10-7-.542 0-1.073.059-1.591.166l3.148 3.148Z",
            fill: "currentcolor"
        })
    });
var $8cb605c19c99cb47$export$2e2bcd8739ae039 = $8cb605c19c99cb47$var$SvgPasswordHide;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $14cec15c7bd7d45a$var$SvgPasswordShow = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M22 12c0 .866-4.477 7-10 7S2 12.866 2 12c0-.866 4.477-7 10-7s10 6.134 10 7Zm-6 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0Zm-5 2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
            fill: "currentcolor"
        })
    });
var $14cec15c7bd7d45a$export$2e2bcd8739ae039 = $14cec15c7bd7d45a$var$SvgPasswordShow;


parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");

var $kcPww = parcelRequire("kcPww");

var $9bgsA = parcelRequire("9bgsA");

var $hdJkM = parcelRequire("hdJkM");

var $1Iq4D = parcelRequire("1Iq4D");

var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");


var $95b92a62797d7452$export$9c30223ca0a664fb;
$95b92a62797d7452$export$9c30223ca0a664fb = `bsdY_q_link`;


function $a2740c5b351e2f1e$var$VerifyPasswordModal() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { state: state } = (0, $9X5Bp.useLocation)();
    const { register: register, reset: reset, clearErrors: clearErrors, setError: setError, handleSubmit: handleSubmit, formState: { errors: errors, isSubmitting: isSubmitting } } = (0, $c3LX9.useForm)({
        reValidateMode: "onBlur"
    });
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator,
        hideErrorToast: true
    });
    const [showPassword, setShowPassword] = (0, $eCoWV.useState)(false);
    const { email: email } = (0, $4a20295e045d868b$export$23da1b6a36f0a363)(state);
    const onClose = ()=>{
        navigate("/profile");
    };
    const onSubmit = ()=>{
        clearErrors();
        handleSubmit(async ({ password: password })=>{
            try {
                await api.post(`me/password/verify`, {
                    json: {
                        password: password
                    }
                });
                reset();
                navigate("../change-password", {
                    state: state
                });
            } catch (error) {
                (0, $4a20295e045d868b$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                    if (code === "session.invalid_credentials") {
                        setError("password", {
                            type: "custom",
                            message: message
                        });
                        return true;
                    }
                });
            }
        })();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $78fb4cbcbe65b190$export$2e2bcd8739ae039), {
        title: "profile.password.enter_password",
        subtitle: "profile.password.enter_password_subtitle",
        onClose: onClose,
        onGoBack: onClose,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                ...register("password", {
                    required: t("profile.password.required")
                }),
                // eslint-disable-next-line jsx-a11y/no-autofocus
                autoFocus: true,
                error: errors.password?.message,
                type: showPassword ? "text" : "password",
                suffix: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                    onMouseDown: (event)=>{
                        event.preventDefault();
                        setShowPassword((flag)=>!flag);
                    },
                    children: showPassword ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $14cec15c7bd7d45a$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8cb605c19c99cb47$export$2e2bcd8739ae039), {})
                }),
                onKeyDown: (event)=>{
                    if (event.key === "Enter") onSubmit();
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "primary",
                size: "large",
                title: "general.continue",
                isLoading: isSubmitting,
                onClick: onSubmit
            }),
            email && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                className: $95b92a62797d7452$export$9c30223ca0a664fb,
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $674b10126250d6b7$export$2e2bcd8739ae039), {}),
                onClick: ()=>{
                    api.post("me/verification-codes", {
                        json: {
                            email: email
                        }
                    });
                    navigate("../verification-code", {
                        state: state
                    });
                },
                children: t("profile.code.verify_via_code")
            })
        ]
    });
}
var $a2740c5b351e2f1e$export$2e2bcd8739ae039 = $a2740c5b351e2f1e$var$VerifyPasswordModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
var $3kVX5 = parcelRequire("3kVX5");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $89556d785f25fda7$var$SvgUserRoleDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 19.792,
                cy: 14,
                r: 6.5,
                fill: "url(#paint0_linear_8738_113276)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12.194,
                y: 12.389,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 23.167,
                y: 12.389,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 29.084a6.583 6.583 0 0 1 6.584-6.584h6.832A6.583 6.583 0 0 1 30 29.084v2.221a2.194 2.194 0 0 1-2.195 2.195h-15.61A2.194 2.194 0 0 1 10 31.305v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_8738_113276",
                    x1: 15.526,
                    y1: 18.74,
                    x2: 24.261,
                    y2: 9.396,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $89556d785f25fda7$export$2e2bcd8739ae039 = $89556d785f25fda7$var$SvgUserRoleDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1000e8ee7949b499$var$SvgUserRole = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#F3EFFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 19.792,
                cy: 14,
                r: 6.5,
                fill: "url(#paint0_linear_8738_113217)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 12.194,
                y: 12.389,
                width: 8.778,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 23.167,
                y: 12.389,
                width: 4.389,
                height: 1.097,
                rx: 0.549,
                fill: "#2D2C61"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M10 29.084a6.583 6.583 0 0 1 6.584-6.584h6.832A6.583 6.583 0 0 1 30 29.084v2.221a2.194 2.194 0 0 1-2.195 2.195h-15.61A2.194 2.194 0 0 1 10 31.305v-2.221Z",
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("defs", {
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                    id: "paint0_linear_8738_113217",
                    x1: 15.526,
                    y1: 18.74,
                    x2: 24.261,
                    y2: 9.396,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            stopColor: "#5D34F2"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                            offset: 1,
                            stopColor: "#FF88FA"
                        })
                    ]
                })
            })
        ]
    });
var $1000e8ee7949b499$export$2e2bcd8739ae039 = $1000e8ee7949b499$var$SvgUserRole;





var $emGEN = parcelRequire("emGEN");

var $kMAP9 = parcelRequire("kMAP9");


var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");
var $4127b7508f451631$export$bfd64c937657f93a;
var $4127b7508f451631$export$4a6dd88bada4e7d2;
var $4127b7508f451631$export$e16a509e03e8e9f6;
$4127b7508f451631$export$bfd64c937657f93a = `Tm4JdG_rotating`;
$4127b7508f451631$export$4a6dd88bada4e7d2 = `Tm4JdG_shimmer`;
$4127b7508f451631$export$e16a509e03e8e9f6 = `Tm4JdG_withTable`;


const $28855ebc9a5ea4e0$var$icons = {
    [(0, $bhvxB.Theme).Light]: {
        UserIcon: (0, $1000e8ee7949b499$export$2e2bcd8739ae039),
        MachineToMachineIcon: (0, $844c753ae2b24ff8$export$2e2bcd8739ae039)
    },
    [(0, $bhvxB.Theme).Dark]: {
        UserIcon: (0, $89556d785f25fda7$export$2e2bcd8739ae039),
        MachineToMachineIcon: (0, $a9b26f155c5b34c5$export$2e2bcd8739ae039)
    }
};
function $28855ebc9a5ea4e0$var$RoleDetails() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const { id: id } = (0, $9X5Bp.useParams)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const theme = (0, $93h5F.default)();
    const { UserIcon: UserIcon, MachineToMachineIcon: MachineToMachineIcon } = $28855ebc9a5ea4e0$var$icons[theme];
    const isPageHasTable = pathname.endsWith((0, $emGEN.RoleDetailsTabs).Permissions) || pathname.endsWith((0, $emGEN.RoleDetailsTabs).Users) || pathname.endsWith((0, $emGEN.RoleDetailsTabs).M2mApps);
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && `api/roles/${id}`);
    const { mutate: mutateGlobal } = (0, $4Korf.useSWRConfig)();
    const isLoading = !data && !error;
    const [isDeletionAlertOpen, setIsDeletionAlertOpen] = (0, $eCoWV.useState)(false);
    (0, $eCoWV.useEffect)(()=>{
        setIsDeletionAlertOpen(false);
    }, [
        pathname
    ]);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!data) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${data.id}`);
            (0, $horhC.toast).success(t("role_details.role_deleted", {
                name: data.name
            }));
            await mutateGlobal("api/roles");
            navigate("/roles", {
                replace: true
            });
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: "/roles",
        backLinkTitle: "role_details.back_to_roles",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isPageHasTable && $4127b7508f451631$export$e16a509e03e8e9f6),
        onRetry: mutate,
        children: data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                    icon: data.type === (0, $3kVX5.RoleType).User ? /*#__PURE__*/ (0, $9zeGj.jsx)(UserIcon, {}) : /*#__PURE__*/ (0, $9zeGj.jsx)(MachineToMachineIcon, {}),
                    title: data.name,
                    primaryTag: t(data.type === (0, $3kVX5.RoleType).User ? "role_details.type_user_role_tag" : "role_details.type_m2m_role_tag"),
                    identifier: {
                        name: "ID",
                        value: data.id
                    },
                    actionMenuItems: [
                        {
                            title: "general.delete",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                            type: "danger",
                            onClick: ()=>{
                                setIsDeletionAlertOpen(true);
                            }
                        }
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                    isOpen: isDeletionAlertOpen,
                    isLoading: isDeleting,
                    confirmButtonText: "general.delete",
                    onCancel: ()=>{
                        setIsDeletionAlertOpen(false);
                    },
                    onConfirm: handleDelete,
                    children: t("role_details.delete_description")
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: `/roles/${data.id}/${(0, $emGEN.RoleDetailsTabs).Settings}`,
                            children: t("role_details.settings_tab")
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: `/roles/${data.id}/${(0, $emGEN.RoleDetailsTabs).Permissions}`,
                            children: t("role_details.permissions_tab")
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                            href: `/roles/${data.id}/${data.type === (0, $3kVX5.RoleType).User ? (0, $emGEN.RoleDetailsTabs).Users : (0, $emGEN.RoleDetailsTabs).M2mApps}`,
                            children: t(data.type === (0, $3kVX5.RoleType).User ? "role_details.users_tab" : "role_details.m2m_apps_tab")
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {
                    context: {
                        role: data,
                        isDeleting: isDeleting,
                        onRoleUpdated: (role)=>{
                            mutate(role);
                        }
                    }
                })
            ]
        })
    });
}
var $28855ebc9a5ea4e0$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($28855ebc9a5ea4e0$var$RoleDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");






var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");


parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");



var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $2ANSb = parcelRequire("2ANSb");

var $7iZsu = parcelRequire("7iZsu");
const $f8d707165e6db426$var$isUserEntity = (entity)=>"customData" in entity || "identities" in entity;
function $f8d707165e6db426$var$AssignRoleModal({ roleId: roleId, roleType: roleType, isRemindSkip: isRemindSkip = false, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const [entities, setEntities] = (0, $eCoWV.useState)([]);
    const phraseKey = roleType === (0, $3kVX5.RoleType).User ? "users" : "applications";
    const api = (0, $2ANSb.default)();
    const handleAssign = async ()=>{
        if (isLoading || entities.length === 0) return;
        setIsLoading(true);
        try {
            await api.post(`api/roles/${roleId}/${phraseKey}`, {
                json: {
                    [phraseKey.slice(0, -1) + "Ids"]: entities.map(({ id: id })=>id)
                }
            });
            (0, $horhC.toast).success(t(`role_details.${phraseKey}.assigned_toast_text`));
            onClose(true);
        } finally{
            setIsLoading(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: `role_details.${phraseKey}.assign_title`,
            subtitle: `role_details.${phraseKey}.assign_subtitle`,
            size: "large",
            footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        isLoading: isLoading,
                        htmlType: "submit",
                        title: isRemindSkip ? "general.skip_for_now" : "general.cancel",
                        size: "large",
                        type: "default",
                        onClick: ()=>{
                            onClose();
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        isLoading: isLoading,
                        disabled: entities.length === 0,
                        htmlType: "submit",
                        title: `role_details.${phraseKey}.confirm_assign`,
                        size: "large",
                        type: "primary",
                        onClick: handleAssign
                    })
                ]
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: `role_details.${phraseKey}.assign_field`,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $44c5435b872fb25e$export$2e2bcd8739ae039), {
                    searchProps: {
                        pathname: `api/${phraseKey}`,
                        parameters: {
                            excludeRoleId: roleId,
                            ...roleType === (0, $3kVX5.RoleType).User ? {} : {
                                types: (0, $3kVX5.ApplicationType).MachineToMachine
                            }
                        }
                    },
                    selectedEntities: entities,
                    emptyPlaceholder: `role_details.${phraseKey}.empty`,
                    renderEntity: (entity)=>$f8d707165e6db426$var$isUserEntity(entity) ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2189af2994a8c825$export$7d5b61b2bb96bf4d), {
                            entity: entity
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2189af2994a8c825$export$a42ffac851fa6a76), {
                            entity: entity
                        }),
                    onChange: setEntities
                })
            })
        })
    });
}
var $f8d707165e6db426$export$2e2bcd8739ae039 = $f8d707165e6db426$var$AssignRoleModal;



var $h7VLF = parcelRequire("h7VLF");
var $30d9aaa433263a28$export$58fcafe19102a562;
var $30d9aaa433263a28$export$3dea766d36a8935f;
var $30d9aaa433263a28$export$1ca1ec8b29a4ce27;
var $30d9aaa433263a28$export$bfd64c937657f93a;
var $30d9aaa433263a28$export$4a6dd88bada4e7d2;
$30d9aaa433263a28$export$58fcafe19102a562 = `l-2Klq_applicationsTable`;
$30d9aaa433263a28$export$3dea766d36a8935f = `l-2Klq_filter`;
$30d9aaa433263a28$export$1ca1ec8b29a4ce27 = `l-2Klq_icon`;
$30d9aaa433263a28$export$bfd64c937657f93a = `l-2Klq_rotating`;
$30d9aaa433263a28$export$4a6dd88bada4e7d2 = `l-2Klq_shimmer`;


const $d7ea78942d6988b9$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $d7ea78942d6988b9$var$RoleApplications() {
    const { role: { id: roleId } } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(roleId && (0, $h7VLF.buildUrl)(`api/roles/${roleId}/applications`, {
        page: String(page),
        page_size: String($d7ea78942d6988b9$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [applications, totalCount] = data ?? [];
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, $eCoWV.useState)(false);
    const [applicationToBeDeleted, setApplicationToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!applicationToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${roleId}/applications/${applicationToBeDeleted.id}`);
            (0, $horhC.toast).success(t("role_details.applications.deleted", {
                name: applicationToBeDeleted.name
            }));
            await mutate();
            setApplicationToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                className: $30d9aaa433263a28$export$58fcafe19102a562,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "applications",
                        data: applications
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("role_details.applications.app_column"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: (application)=>{
                            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                title: application.name,
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b89a4a093c790c4c$export$2e2bcd8739ae039), {
                                    type: (0, $3kVX5.ApplicationType).MachineToMachine,
                                    className: $30d9aaa433263a28$export$1ca1ec8b29a4ce27
                                }),
                                to: `/applications/${application.id}`
                            });
                        }
                    },
                    {
                        title: t("role_details.applications.description_column"),
                        dataIndex: "description",
                        colSpan: 5,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: (0, $5CQIb.conditional)(description) ?? "-"
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (application)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        setApplicationToBeDeleted(application);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $30d9aaa433263a28$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("general.search_placeholder"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "role_details.applications.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $d7ea78942d6988b9$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {})
            }),
            applicationToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setApplicationToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("role_details.applications.delete_description")
            }),
            isAssignModalOpen && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f8d707165e6db426$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: (0, $3kVX5.RoleType).MachineToMachine,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignModalOpen(false);
                }
            })
        ]
    });
}
var $d7ea78942d6988b9$export$2e2bcd8739ae039 = $d7ea78942d6988b9$var$RoleApplications;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $6ZMK7 = parcelRequire("6ZMK7");

var $kMAP9 = parcelRequire("kMAP9");

var $2ANSb = parcelRequire("2ANSb");


var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $bFFWx = parcelRequire("bFFWx");




var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $az3ON = parcelRequire("az3ON");
var $3kVX5 = parcelRequire("3kVX5");
var $MRt6E = parcelRequire("MRt6E");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");



var $hdJkM = parcelRequire("hdJkM");


var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $4d6f46a366506517$var$SvgCaretExpanded = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "m10.592 12.358 3.533-3.533a.833.833 0 1 0-1.175-1.183L10 10.592l-2.95-2.95a.833.833 0 0 0-1.355.271.833.833 0 0 0-.062.32.833.833 0 0 0 .242.592l3.533 3.533a.833.833 0 0 0 1.184 0Z",
            fill: "currentColor"
        })
    });
var $4d6f46a366506517$export$2e2bcd8739ae039 = $4d6f46a366506517$var$SvgCaretExpanded;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a84346fe6d901783$var$SvgCaretFolded = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12.358 9.408 8.825 5.875A.833.833 0 1 0 7.642 7.05l2.95 2.95-2.95 2.95a.833.833 0 0 0 .271 1.355c.102.041.21.062.32.062a.833.833 0 0 0 .592-.242l3.533-3.533a.834.834 0 0 0 0-1.184Z",
            fill: "currentColor"
        })
    });
var $a84346fe6d901783$export$2e2bcd8739ae039 = $a84346fe6d901783$var$SvgCaretFolded;




var $9bgsA = parcelRequire("9bgsA");

var $6PcpQ = parcelRequire("6PcpQ");

var $9zeGj = parcelRequire("9zeGj");


var $6PcpQ = parcelRequire("6PcpQ");
var $e8a0926969c132df$export$1ca1ec8b29a4ce27;
var $e8a0926969c132df$export$a8ff84c12d48cfa6;
var $e8a0926969c132df$export$bfd64c937657f93a;
var $e8a0926969c132df$export$4a6dd88bada4e7d2;
var $e8a0926969c132df$export$4b74bb440bb801f7;
$e8a0926969c132df$export$1ca1ec8b29a4ce27 = `HOGL5a_icon`;
$e8a0926969c132df$export$a8ff84c12d48cfa6 = `HOGL5a_name`;
$e8a0926969c132df$export$bfd64c937657f93a = `HOGL5a_rotating`;
$e8a0926969c132df$export$4a6dd88bada4e7d2 = `HOGL5a_shimmer`;
$e8a0926969c132df$export$4b74bb440bb801f7 = `HOGL5a_sourceScopeItem`;


function $a5b5bd92505c217c$var$SourceScopeItem({ scope: scope, scope: { name: name }, isSelected: isSelected, onSelect: onSelect }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $e8a0926969c132df$export$4b74bb440bb801f7,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                checked: isSelected,
                onChange: ()=>{
                    onSelect(scope);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $e8a0926969c132df$export$a8ff84c12d48cfa6,
                role: "button",
                tabIndex: 0,
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                    onSelect(scope);
                }),
                onClick: ()=>{
                    onSelect(scope);
                },
                children: name
            })
        ]
    });
}
var $a5b5bd92505c217c$export$2e2bcd8739ae039 = $a5b5bd92505c217c$var$SourceScopeItem;


var $7704e438fbf3c67a$export$e88cb2efb12ae807;
var $7704e438fbf3c67a$export$c99df9cf5e6bee9b;
var $7704e438fbf3c67a$export$a8ff84c12d48cfa6;
var $7704e438fbf3c67a$export$23e0665cffcf8918;
var $7704e438fbf3c67a$export$d3dfeb0bd4220bf7;
var $7704e438fbf3c67a$export$bfd64c937657f93a;
var $7704e438fbf3c67a$export$c2e49e3f3da9e921;
var $7704e438fbf3c67a$export$4a6dd88bada4e7d2;
var $7704e438fbf3c67a$export$fb184b623420d9be;
$7704e438fbf3c67a$export$e88cb2efb12ae807 = `kfGtNa_caret`;
$7704e438fbf3c67a$export$c99df9cf5e6bee9b = `kfGtNa_invisible`;
$7704e438fbf3c67a$export$a8ff84c12d48cfa6 = `kfGtNa_name`;
$7704e438fbf3c67a$export$23e0665cffcf8918 = `kfGtNa_resource`;
$7704e438fbf3c67a$export$d3dfeb0bd4220bf7 = `kfGtNa_resourceItem`;
$7704e438fbf3c67a$export$bfd64c937657f93a = `kfGtNa_rotating`;
$7704e438fbf3c67a$export$c2e49e3f3da9e921 = `kfGtNa_scopeInfo`;
$7704e438fbf3c67a$export$4a6dd88bada4e7d2 = `kfGtNa_shimmer`;
$7704e438fbf3c67a$export$fb184b623420d9be = `kfGtNa_title`;


function $929e945abd1a811c$var$ResourceItem({ resource: resource, selectedScopes: selectedScopes, onSelectResource: onSelectResource, onSelectScope: onSelectScope }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, scopes: scopes } = resource;
    const selectedScopesCount = selectedScopes.length;
    const totalScopesCount = scopes.length;
    const [isScopesInvisible, setIsScopesInvisible] = (0, $eCoWV.useState)(true);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $7704e438fbf3c67a$export$d3dfeb0bd4220bf7,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $7704e438fbf3c67a$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                        checked: selectedScopesCount === totalScopesCount,
                        indeterminate: selectedScopesCount > 0 && selectedScopesCount < totalScopesCount,
                        onChange: ()=>{
                            onSelectResource(resource);
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        role: "button",
                        tabIndex: 0,
                        className: $7704e438fbf3c67a$export$23e0665cffcf8918,
                        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                            setIsScopesInvisible(!isScopesInvisible);
                        }),
                        onClick: ()=>{
                            setIsScopesInvisible(!isScopesInvisible);
                        },
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                size: "medium",
                                className: $7704e438fbf3c67a$export$e88cb2efb12ae807,
                                children: isScopesInvisible ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a84346fe6d901783$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4d6f46a366506517$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $7704e438fbf3c67a$export$a8ff84c12d48cfa6,
                                children: name
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $7704e438fbf3c67a$export$c2e49e3f3da9e921,
                                children: [
                                    "(",
                                    t("role_details.permission.api_permission_count", {
                                        count: scopes.length
                                    }),
                                    ")"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isScopesInvisible && $7704e438fbf3c67a$export$c99df9cf5e6bee9b),
                children: scopes.map((scope)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $a5b5bd92505c217c$export$2e2bcd8739ae039), {
                        scope: scope,
                        isSelected: selectedScopes.findIndex(({ id: id })=>scope.id === id) >= 0,
                        onSelect: onSelectScope
                    }, scope.id))
            })
        ]
    });
}
var $929e945abd1a811c$export$2e2bcd8739ae039 = $929e945abd1a811c$var$ResourceItem;


var $aa890d2234669ec9$export$1ca1ec8b29a4ce27;
var $aa890d2234669ec9$export$d76128d007d19019;
$aa890d2234669ec9$export$1ca1ec8b29a4ce27 = `lgwVMa_icon`;
$aa890d2234669ec9$export$d76128d007d19019 = `lgwVMa_search`;


function $cc3d758525d671e9$var$SourceScopesBox({ roleId: roleId, roleType: roleType, selectedScopes: selectedScopes, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: allResources, error: fetchAllResourcesError } = (0, $2mi28.default)("api/resources?includeScopes=true");
    const { data: roleScopes, error: fetchRoleScopesError } = (0, $2mi28.default)(roleId && `api/roles/${roleId}/scopes`);
    const isLoading = !allResources && !fetchAllResourcesError || roleId && !roleScopes && !fetchRoleScopesError;
    const hasError = Boolean(fetchAllResourcesError) || Boolean(roleId && fetchRoleScopesError);
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const handleSearchInput = (event)=>{
        setKeyword(event.target.value);
    };
    const isScopeAdded = (scope)=>selectedScopes.findIndex(({ id: id })=>id === scope.id) >= 0;
    const onSelectScope = (scope)=>{
        onChange(isScopeAdded(scope) ? selectedScopes.filter(({ id: id })=>id !== scope.id) : [
            scope,
            ...selectedScopes
        ]);
    };
    const onSelectResource = ({ scopes: resourceScopes })=>{
        const isAllSelected = resourceScopes.every((scope)=>isScopeAdded(scope));
        const resourceScopesIds = new Set(resourceScopes.map(({ id: id })=>id));
        const selectedScopesExcludeResourceScopes = selectedScopes.filter(({ id: id })=>!resourceScopesIds.has(id));
        onChange(isAllSelected ? selectedScopesExcludeResourceScopes : [
            ...resourceScopes,
            ...selectedScopesExcludeResourceScopes
        ]);
    };
    const getResourceSelectedScopes = ({ scopes: scopes })=>scopes.filter((scope)=>selectedScopes.findIndex(({ id: id })=>id === scope.id) >= 0);
    const resources = (0, $eCoWV.useMemo)(()=>{
        if (!allResources || roleId && !roleScopes) return [];
        const existingScopeIds = roleScopes?.map(({ id: id })=>id) ?? [];
        const excludeScopeIds = new Set([
            ...existingScopeIds,
            (0, $az3ON.PredefinedScope).All
        ]);
        return allResources.filter(({ indicator: indicator, scopes: scopes })=>/** Should show management API scopes for machine-to-machine roles */ (roleType === (0, $3kVX5.RoleType).MachineToMachine || !(0, $MRt6E.isManagementApi)(indicator)) && scopes.some(({ id: id })=>!excludeScopeIds.has(id))).map(({ scopes: scopes, ...resource })=>({
                ...resource,
                scopes: scopes.filter(({ id: id })=>!excludeScopeIds.has(id)).map((scope)=>({
                        ...scope,
                        resource: resource
                    }))
            }));
    }, [
        allResources,
        roleType,
        roleId,
        roleScopes
    ]);
    const dataSource = (0, $eCoWV.useMemo)(()=>{
        const lowerCasedKeyword = keyword.toLowerCase();
        return (0, $5CQIb.conditional)(lowerCasedKeyword && resources.filter(({ name: name, scopes: scopes })=>{
            return name.toLowerCase().includes(lowerCasedKeyword) || scopes.some(({ name: name })=>name.toLowerCase().includes(lowerCasedKeyword));
        }).map(({ scopes: scopes, ...resource })=>({
                ...resource,
                scopes: scopes.filter(({ name: name, resource: resource })=>name.toLocaleLowerCase().includes(lowerCasedKeyword) || resource.name.toLocaleLowerCase().includes(lowerCasedKeyword))
            })).filter(({ scopes: scopes })=>scopes.length > 0)) ?? resources;
    }, [
        keyword,
        resources
    ]);
    const isEmpty = !isLoading && !hasError && dataSource.length === 0;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    className: $aa890d2234669ec9$export$d76128d007d19019,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                        className: $aa890d2234669ec9$export$1ca1ec8b29a4ce27
                    }),
                    placeholder: t("general.search_placeholder"),
                    onChange: handleSearchInput
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$a03f626b8106969c, isEmpty && $d9a7729c7b9aa700$export$2d49e08edfff676e),
                children: isEmpty ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {
                    size: "small",
                    title: t("role_details.permission.empty")
                }) : dataSource.map((resource)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $929e945abd1a811c$export$2e2bcd8739ae039), {
                        resource: resource,
                        selectedScopes: getResourceSelectedScopes(resource),
                        onSelectResource: onSelectResource,
                        onSelectScope: onSelectScope
                    }, resource.id))
            })
        ]
    });
}
var $cc3d758525d671e9$export$2e2bcd8739ae039 = $cc3d758525d671e9$var$SourceScopesBox;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $9zeGj = parcelRequire("9zeGj");

var $iHViS = parcelRequire("iHViS");

var $9bgsA = parcelRequire("9bgsA");
var $ba95f284b8d108a7$export$a8ff84c12d48cfa6;
var $ba95f284b8d108a7$export$42a13522e3b9f353;
var $ba95f284b8d108a7$export$bfd64c937657f93a;
var $ba95f284b8d108a7$export$4a6dd88bada4e7d2;
var $ba95f284b8d108a7$export$fc4e68ccefdfac4c;
var $ba95f284b8d108a7$export$fb184b623420d9be;
$ba95f284b8d108a7$export$a8ff84c12d48cfa6 = `WBz-qW_name`;
$ba95f284b8d108a7$export$42a13522e3b9f353 = `WBz-qW_resourceName`;
$ba95f284b8d108a7$export$bfd64c937657f93a = `WBz-qW_rotating`;
$ba95f284b8d108a7$export$4a6dd88bada4e7d2 = `WBz-qW_shimmer`;
$ba95f284b8d108a7$export$fc4e68ccefdfac4c = `WBz-qW_targetScopeItem`;
$ba95f284b8d108a7$export$fb184b623420d9be = `WBz-qW_title`;


function $a499db041fbba44d$var$TargetScopeItem({ scope: scope, onDelete: onDelete }) {
    const { name: name, resource: { name: resourceName } } = scope;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $ba95f284b8d108a7$export$fc4e68ccefdfac4c,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $ba95f284b8d108a7$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ba95f284b8d108a7$export$a8ff84c12d48cfa6,
                        children: name
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ba95f284b8d108a7$export$42a13522e3b9f353,
                        children: `(${resourceName})`
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                size: "small",
                onClick: ()=>{
                    onDelete(scope);
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
            })
        ]
    });
}
var $a499db041fbba44d$export$2e2bcd8739ae039 = $a499db041fbba44d$var$TargetScopeItem;


var $349bc977e99c0a0e$export$80f73db1a407fae0;
$349bc977e99c0a0e$export$80f73db1a407fae0 = `_5nfMBq_added`;


function $f6797bbc552f54a2$var$TargetScopesBox({ selectedScopes: selectedScopes, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $d9a7729c7b9aa700$export$827f4ee28efc37,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$9f6c77b8cdee9051,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    className: $349bc977e99c0a0e$export$80f73db1a407fae0,
                    children: t("role_details.permission.added_text", {
                        count: selectedScopes.length
                    })
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$a03f626b8106969c,
                children: selectedScopes.map((scope)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $a499db041fbba44d$export$2e2bcd8739ae039), {
                        scope: scope,
                        onDelete: (scope)=>{
                            onChange(selectedScopes.filter(({ id: id })=>id !== scope.id));
                        }
                    }, scope.id))
            })
        ]
    });
}
var $f6797bbc552f54a2$export$2e2bcd8739ae039 = $f6797bbc552f54a2$var$TargetScopesBox;


var $ac01452690890a79$export$fd3a44c6c35bba04;
var $ac01452690890a79$export$bfd64c937657f93a;
var $ac01452690890a79$export$4a6dd88bada4e7d2;
$ac01452690890a79$export$fd3a44c6c35bba04 = `_4f4-IW_roleScopesTransfer`;
$ac01452690890a79$export$bfd64c937657f93a = `_4f4-IW_rotating`;
$ac01452690890a79$export$4a6dd88bada4e7d2 = `_4f4-IW_shimmer`;


function $1e5692eceb6d9818$var$RoleScopesTransfer({ roleId: roleId, roleType: roleType, value: value, onChange: onChange }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($d9a7729c7b9aa700$export$34e0f9847d4c02dd, $ac01452690890a79$export$fd3a44c6c35bba04),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cc3d758525d671e9$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: roleType,
                selectedScopes: value,
                onChange: onChange
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $d9a7729c7b9aa700$export$d999e528e771887b
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f6797bbc552f54a2$export$2e2bcd8739ae039), {
                selectedScopes: value,
                onChange: onChange
            })
        ]
    });
}
var $1e5692eceb6d9818$export$2e2bcd8739ae039 = $1e5692eceb6d9818$var$RoleScopesTransfer;



var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $2ANSb = parcelRequire("2ANSb");


var $7iZsu = parcelRequire("7iZsu");

function $cffc3505a60e97f0$var$AssignPermissionsModal({ roleId: roleId, roleType: roleType, totalRoleScopeCount: totalRoleScopeCount, onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const [isSubmitting, setIsSubmitting] = (0, $eCoWV.useState)(false);
    const [scopes, setScopes] = (0, $eCoWV.useState)([]);
    const api = (0, $2ANSb.default)();
    const handleAssign = async ()=>{
        if (isSubmitting || scopes.length === 0) return;
        setIsSubmitting(true);
        try {
            await api.post(`api/roles/${roleId}/scopes`, {
                json: {
                    scopeIds: scopes.map(({ id: id })=>id)
                }
            });
            (0, $horhC.toast).success(t("role_details.permission.permission_assigned"));
            onClose(true);
        } finally{
            setIsSubmitting(false);
        }
    };
    const shouldBlockScopeAssignment = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "scopesPerRoleLimit",
        plan: currentPlan,
        /**
     * If usage is equal to the limit, it means the current role has reached the maximum allowed scope.
     * Therefore, we should not assign any more scopes at this point.
     * However, the currently selected scopes haven't been assigned yet, so we subtract 1
     * to allow the assignment when the scope count is equal to the limit.
     */ usage: totalRoleScopeCount + scopes.length - 1
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
            title: "role_details.permission.assign_title",
            subtitle: "role_details.permission.assign_subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-role-permissions",
                targetBlank: "noopener"
            },
            size: "large",
            footer: shouldBlockScopeAssignment && currentPlan ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.scopes_per_role", {
                        count: currentPlan.quota.scopesPerRoleLimit ?? 0
                    })
                })
            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                disabled: scopes.length === 0,
                htmlType: "submit",
                title: "role_details.permission.confirm_assign",
                size: "large",
                type: "primary",
                onClick: handleAssign
            }),
            onClose: onClose,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "role_details.permission.assign_form_field",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5692eceb6d9818$export$2e2bcd8739ae039), {
                    roleId: roleId,
                    roleType: roleType,
                    value: scopes,
                    onChange: (scopes)=>{
                        setScopes(scopes);
                    }
                })
            })
        })
    });
}
var $cffc3505a60e97f0$export$2e2bcd8739ae039 = $cffc3505a60e97f0$var$AssignPermissionsModal;


const $769a181e89b69a89$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $769a181e89b69a89$var$RolePermissions() {
    const { role: { id: roleId, type: roleType } } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(roleId && (0, $h7VLF.buildUrl)(`api/roles/${roleId}/scopes`, {
        page: String(page),
        page_size: String($769a181e89b69a89$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [scopes, totalCount] = data ?? [];
    const [isAssignPermissionsModalOpen, setIsAssignPermissionsModalOpen] = (0, $eCoWV.useState)(false);
    const [scopeToBeDeleted, setScopeToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!scopeToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${roleId}/scopes/${scopeToBeDeleted.id}`);
            (0, $horhC.toast).success(t("role_details.permission.permission_deleted", {
                name: scopeToBeDeleted.name
            }));
            await mutate();
            setScopeToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d49945d5344ba010$export$2e2bcd8739ae039), {
                isApiColumnVisible: true,
                scopes: scopes,
                isLoading: isLoading,
                createButtonTitle: "role_details.permission.assign_button",
                deleteButtonTitle: "general.remove",
                createHandler: ()=>{
                    setIsAssignPermissionsModalOpen(true);
                },
                deleteHandler: setScopeToBeDeleted,
                errorMessage: error?.body?.message ?? error?.message,
                retryHandler: async ()=>mutate(undefined, true),
                pagination: {
                    page: page,
                    pageSize: $769a181e89b69a89$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                search: {
                    keyword: keyword,
                    searchHandler: (keyword)=>{
                        updateSearchParameters({
                            keyword: keyword,
                            page: 1
                        });
                    },
                    clearSearchHandler: ()=>{
                        updateSearchParameters({
                            keyword: "",
                            page: 1
                        });
                    }
                }
            }),
            scopeToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setScopeToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("role_details.permission.deletion_description")
            }),
            isAssignPermissionsModalOpen && totalCount !== undefined && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cffc3505a60e97f0$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: roleType,
                totalRoleScopeCount: totalCount,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignPermissionsModalOpen(false);
                }
            })
        ]
    });
}
var $769a181e89b69a89$export$2e2bcd8739ae039 = $769a181e89b69a89$var$RolePermissions;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");




var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $bSFEw = parcelRequire("bSFEw");
function $80ad8e84bbbd4435$var$RoleSettings() {
    const { role: role, isDeleting: isDeleting, onRoleUpdated: onRoleUpdated } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { handleSubmit: handleSubmit, register: register, reset: reset, formState: { isDirty: isDirty, isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)({
        defaultValues: role
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const updatedRole = await api.patch(`api/roles/${role.id}`, {
            json: formData
        }).json();
        reset(updatedRole);
        onRoleUpdated(updatedRole);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onDiscard: reset,
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                    title: "role_details.settings",
                    description: "role_details.settings_description",
                    learnMoreLink: {
                        href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
                        targetBlank: "noopener"
                    },
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            isRequired: true,
                            title: "role_details.field_name",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("name", {
                                    required: true
                                }),
                                error: Boolean(errors.name)
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            isRequired: true,
                            title: "role_details.field_description",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("description", {
                                    required: true
                                }),
                                error: Boolean(errors.description)
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $80ad8e84bbbd4435$export$2e2bcd8739ae039 = $80ad8e84bbbd4435$var$RoleSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");







var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");


parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");



var $h7VLF = parcelRequire("h7VLF");
var $012c7af53d973d63$export$3dea766d36a8935f;
var $012c7af53d973d63$export$bfd64c937657f93a;
var $012c7af53d973d63$export$4a6dd88bada4e7d2;
var $012c7af53d973d63$export$5f0eed9cd9df5b6a;
$012c7af53d973d63$export$3dea766d36a8935f = `FlVJdW_filter`;
$012c7af53d973d63$export$bfd64c937657f93a = `FlVJdW_rotating`;
$012c7af53d973d63$export$4a6dd88bada4e7d2 = `FlVJdW_shimmer`;
$012c7af53d973d63$export$5f0eed9cd9df5b6a = `FlVJdW_usersTable`;


const $7f7c6316bd0afac9$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $7f7c6316bd0afac9$var$RoleUsers() {
    const { role: { id: roleId } } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(roleId && (0, $h7VLF.buildUrl)(`api/roles/${roleId}/users`, {
        page: String(page),
        page_size: String($7f7c6316bd0afac9$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [users, totalCount] = data ?? [];
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, $eCoWV.useState)(false);
    const [userToBeDeleted, setUserToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!userToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/roles/${roleId}/users/${userToBeDeleted.id}`);
            (0, $horhC.toast).success(t("role_details.users.deleted", {
                name: userToBeDeleted.name
            }));
            await mutate();
            setUserToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                className: $012c7af53d973d63$export$5f0eed9cd9df5b6a,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "users",
                        data: users
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("role_details.users.name_column"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: (user)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $ef60daefc2bdaaa2$export$2e2bcd8739ae039), {
                                user: user
                            })
                    },
                    {
                        title: t("role_details.users.app_column"),
                        dataIndex: "app",
                        colSpan: 5,
                        render: ({ applicationId: applicationId })=>applicationId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5c80becd11c9ff$export$2e2bcd8739ae039), {
                                applicationId: applicationId
                            }) : "-"
                    },
                    {
                        title: t("role_details.users.latest_sign_in_column"),
                        dataIndex: "latestSignIn",
                        colSpan: 5,
                        render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $c5e91545b40d865d$export$2e2bcd8739ae039), {
                                children: lastSignInAt
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (user)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        setUserToBeDeleted(user);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $012c7af53d973d63$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("general.search_placeholder"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "role_details.users.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $7f7c6316bd0afac9$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {})
            }),
            userToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setUserToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("role_details.users.delete_description")
            }),
            isAssignModalOpen && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f8d707165e6db426$export$2e2bcd8739ae039), {
                roleId: roleId,
                roleType: (0, $3kVX5.RoleType).User,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignModalOpen(false);
                }
            })
        ]
    });
}
var $7f7c6316bd0afac9$export$2e2bcd8739ae039 = $7f7c6316bd0afac9$var$RoleUsers;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");






var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $411ab43ab7a708a4$var$SvgRolesEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#191C1D",
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M0 0h256v256H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M22 219h212.4V47.6c0-11.93-9.671-21.6-21.6-21.6H43.6C31.67 26 22 35.67 22 47.6V219Z",
                fill: "url(#paint0_linear_6532_88910)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M104.109 159.753H62.501c-17.539 0-32.526 12.64-35.484 29.928L22 218.999h212.4l-.469-1.319a21.6 21.6 0 0 0-20.352-14.363h-33.978a14.402 14.402 0 0 1-12.274-6.87l-2.057-3.352a28.799 28.799 0 0 0-24.547-13.738h-4.406c-4.519 0-8.66-2.521-10.736-6.535a24.174 24.174 0 0 0-21.472-13.069Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M82.3 193.865H34.6c-11.93 0-21.6-9.67-21.6-21.6v-67.27M188.05 66.395h33.75c11.929 0 21.6 9.646 21.6 21.544v20.647",
                stroke: "#58577B",
                strokeWidth: 0.9,
                strokeDasharray: "3.6 3.6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M148.861 64.694c0-.052.042-.094.094-.094h1.69c.052 0 .094.042.094.094v2.965l2.575-1.483a.095.095 0 0 1 .129.035l.844 1.46a.093.093 0 0 1-.034.127l-2.576 1.483 2.576 1.483c.045.026.06.084.034.129l-.845 1.459a.094.094 0 0 1-.128.034l-2.575-1.483v2.966a.094.094 0 0 1-.094.094h-1.69a.094.094 0 0 1-.094-.094v-2.966l-2.575 1.483a.095.095 0 0 1-.129-.034l-.844-1.46a.093.093 0 0 1 .034-.128l2.575-1.483-2.575-1.483a.094.094 0 0 1-.035-.128l.845-1.46a.095.095 0 0 1 .129-.034l2.575 1.484v-2.966Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m129.822 59.93-.361-2.513a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.545 2.545 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#52514B",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 87.7,
                y: 96.019,
                width: 135,
                height: 97.847,
                rx: 10.8,
                fill: "url(#paint1_linear_6532_88910)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 146.287,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 160.651,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 175.014,
                width: 38.7,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 33.3,
                y: 160.253,
                width: 116,
                height: 58.246,
                rx: 10.3,
                fill: "#CABEFF",
                stroke: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 44.5,
                y: 192.07,
                width: 44.1,
                height: 7.181,
                rx: 1.8,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.7,
                x: 44.5,
                y: 178.605,
                width: 8.1,
                height: 7.181,
                rx: 1.8,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 60.7,
                y: 178.605,
                width: 20.7,
                height: 7.181,
                rx: 1.8,
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_6532_88910)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 104.8,
                        y: 172.321,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#776E9E"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M131.613 200.939c.872 1.662 1.309 7.717 1.309 7.717h-24.521s.437-6.055 1.31-7.717c1.309-2.493 10.951-5.699 10.951-5.699s9.641 3.206 10.951 5.699Z",
                        fill: "#F07EFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "m130.836 193.864-19.338-2.331c-.953-5.048.178-8.229 3.393-9.542 1.486-4.857 7.271-4.462 8.91-4.066 5.58 1.348 7.925 6.661 7.035 15.939Z",
                        fill: "#47464E"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M117.806 196.666v-7.124c-2.979-.044-2.398-5.192.595-3.621.535.237 1.904-.416 1.428-2.018 3.214 2.374 7.692-1.793 7.975.771.557 5.047-.52 9.196-3.375 9.196a4.622 4.622 0 0 1-.91-.054v2.85c-.932.554-1.864.831-2.796.831-.932 0-1.904-.277-2.917-.831Z",
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M123.518 193.816v.949c-1.309 0-3.174-.85-4.166-2.552 1.19.791 2.579 1.326 4.166 1.603Z",
                        fill: "#FA8B54"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M120.657 197.374c.814-.039 2.861-.459 2.861-1.367v-.767c.218 0 .843.515 1.164.95 1.271 1.722-.138 3.265-1.288 3.265-1.45 0-2.412-1.209-2.733-1.79-.321.581-1.283 1.79-2.733 1.79-1.15 0-2.56-1.543-1.289-3.265.322-.435.947-.95 1.165-.95v.767c0 .908 1.993 1.328 2.853 1.367Z",
                        fill: "url(#paint2_linear_6532_88910)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 105.25,
                y: 172.771,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#947DFF",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M59.8 106.819c0-5.965 4.835-10.8 10.8-10.8h141.3c5.965 0 10.8 4.835 10.8 10.8v3.562H59.8v-3.562Z",
                fill: "#635C8F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M219.1 115.32c8.697 0 15.75-7.033 15.75-15.71 0-8.679-7.053-15.711-15.75-15.711s-15.75 7.032-15.75 15.71 7.053 15.711 15.75 15.711Z",
                stroke: "url(#paint3_linear_6532_88910)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 219.101,
                cy: 99.61,
                rx: 13.843,
                ry: 13.807,
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 3.951,
                height: 11.854,
                rx: 1.976,
                transform: "rotate(-44.926 224.116 -204.183)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 15.805,
                height: 3.951,
                rx: 1.976,
                transform: "rotate(-44.926 233.662 -208.158)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m109.3 138.659 10.887-10.859a10.8 10.8 0 0 1 12.877-1.791l9.457 5.26a10.8 10.8 0 0 0 12.573-1.5l6.282-5.796a10.8 10.8 0 0 1 12.924-1.297l26.35 15.983",
                stroke: "#fff",
                strokeOpacity: 0.7,
                strokeWidth: 0.9,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 45.4,
                y: 62.805,
                width: 62.1,
                height: 91.563,
                rx: 14.4,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -30.22 407.104) skewX(-.13)",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.9 66.064c-3.73 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.731 0 5.302 1.958 5.302 6.615 0-4.657 1.767-6.615 5.498-6.615Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M56.2 90.302c-3.731 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.73 0 5.302 1.957 5.302 6.614 0-4.656 1.767-6.614 5.498-6.614Z",
                fill: "#fff",
                fillOpacity: 0.8
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 166.94,
                cy: 121.192,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 126.44,
                cy: 124.784,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 52.6,
                y: 115.77,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 52.6,
                y: 129.234,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#EFE9FF",
                stroke: "#815AE3",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58 120.257c0-.496.402-.898.897-.898h19.805a.898.898 0 0 1 0 1.796H58.897a.898.898 0 0 1-.897-.898Zm25.2 0c0-.496.402-.898.897-.898h5.405a.898.898 0 0 1 0 1.796h-5.405a.898.898 0 0 1-.897-.898Zm9.897-.898a.898.898 0 0 0 0 1.796h1.805a.898.898 0 0 0 0-1.796h-1.805Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 62.5,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 69.7,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 76.9,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 84.1,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 91.3,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip1_6532_88910)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 60.7,
                        y: 74.476,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#D8C7FF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M79.93 97.279v2.44c0 .47-6.96.312-6.96-.366 0-.637.013-3.528 0-6.501-1.56-2.015-1.56-3.275-.327-4.576 1.233-1.302 10.005-1.953 10.005-1.953s.658 6.314.761 8.027c.042.689.49 2.929-1.25 2.929h-2.23Z",
                        fill: "url(#paint4_linear_6532_88910)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M79.928 97.069a10.308 10.308 0 0 1-4.021-1.31s.87 2.06 4.02 2.62v-1.31Z",
                        fill: "#FFD7B8",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M87.868 104.578c.629 1.275 1.136 3.308 1.522 6.099a.744.744 0 0 1-.74.843h-24.4a.744.744 0 0 1-.74-.843c.386-2.792.893-4.824 1.52-6.099.689-1.395 7.07-4.079 7.07-4.079s.127-1.227.435-1.403c.308-.176 7.463-.176 7.83 0s.435 1.402.435 1.402 6.382 2.688 7.068 4.08Z",
                        fill: "#5F5D67"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M74.386 89.598c-.346-.296-.766-.495-1.36-.188-1.408.73-.474 3.543 1.102 3.488.544-.019.295 1.062-1.158 1.776 0-1.139-1.74-3.959-1.892-6.527-1.751-.65-1.316-3.252-.114-3.252-.192-2.385 3.637-3.617 5.12-2.248 1.508-1.803 5.314-.881 5.544.683 2.617-1.394 4.338 2.612 1.887 4.167-1.008.64-3.367.883-6.773.883-1.634 0-.694 3.815-.183 5.047.652 1.572 4.296 1.79 5.437 1.627.892-.127 1.36-.488 1.414-.705.816 2.17-.217 3.47-1.849 3.47-2.773 0-5.546-.813-5.98-2.82-.347-1.596-.328-4.174-1.195-5.4Z",
                        fill: "#7958FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 61.15,
                y: 74.926,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#9877EA",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#191C1D",
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#C4C7C7",
                fillOpacity: 0.02,
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#CABEFF",
                fillOpacity: 0.08,
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6532_88910",
                        x1: 128.2,
                        y1: 219,
                        x2: 128.2,
                        y2: 26,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#444353"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#444353",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6532_88910",
                        x1: 155.2,
                        y1: 96.019,
                        x2: 136.658,
                        y2: 198.202,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#9B84DA"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#8470BD"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_6532_88910",
                        x1: 120.661,
                        y1: 199.455,
                        x2: 120.661,
                        y2: 195.24,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FCF2EB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF9F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_6532_88910",
                        x1: 219.1,
                        y1: 84.349,
                        x2: 219.1,
                        y2: 114.87,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#86BF8F"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#86BF8F",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_6532_88910",
                        x1: 77.624,
                        y1: 86.323,
                        x2: 77.624,
                        y2: 99.989,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_6532_88910",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 104.8,
                            y: 172.321,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_6532_88910",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 60.7,
                            y: 74.476,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $411ab43ab7a708a4$export$2e2bcd8739ae039 = $411ab43ab7a708a4$var$SvgRolesEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $27d055267e8ee57c$var$SvgRolesEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M22 219h212.4V47.6c0-11.93-9.671-21.6-21.6-21.6H43.6C31.67 26 22 35.67 22 47.6V219Z",
                fill: "url(#paint0_linear_6485_85287)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M104.109 159.753H62.501c-17.539 0-32.526 12.64-35.484 29.928L22 218.999h212.4l-.469-1.319a21.6 21.6 0 0 0-20.352-14.363h-33.978a14.402 14.402 0 0 1-12.274-6.87l-2.057-3.352a28.799 28.799 0 0 0-24.547-13.738h-4.406c-4.519 0-8.66-2.521-10.736-6.535a24.174 24.174 0 0 0-21.472-13.069Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M82.3 193.865H34.6c-11.93 0-21.6-9.67-21.6-21.6v-67.27M188.05 66.395h33.75c11.929 0 21.6 9.646 21.6 21.544v20.647",
                stroke: "#A782E8",
                strokeWidth: 0.9,
                strokeDasharray: "3.6 3.6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M148.861 64.694c0-.052.042-.094.094-.094h1.69c.052 0 .094.042.094.094v2.965l2.575-1.483a.094.094 0 0 1 .128.035l.845 1.46a.093.093 0 0 1-.034.127l-2.576 1.483 2.576 1.483c.045.026.06.084.034.129l-.845 1.459a.094.094 0 0 1-.128.034l-2.575-1.483v2.966a.094.094 0 0 1-.094.094h-1.69a.094.094 0 0 1-.094-.094v-2.966l-2.575 1.483a.095.095 0 0 1-.129-.034l-.844-1.46a.093.093 0 0 1 .034-.128l2.575-1.483-2.575-1.483a.094.094 0 0 1-.035-.128l.845-1.46a.095.095 0 0 1 .129-.034l2.575 1.484v-2.966Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m129.822 59.93-.361-2.513a2.544 2.544 0 0 0-2.88-2.154v0a2.544 2.544 0 0 1-2.88-2.154v0a2.545 2.545 0 0 0-2.881-2.154l-2.52.36",
                stroke: "#FFF06A",
                strokeWidth: 1.8,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 87.7,
                y: 96.019,
                width: 135,
                height: 97.847,
                rx: 10.8,
                fill: "url(#paint1_linear_6485_85287)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 146.287,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 160.651,
                width: 102.6,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107.5,
                y: 175.014,
                width: 38.7,
                height: 8.977,
                rx: 3.6,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 33.3,
                y: 160.253,
                width: 116,
                height: 58.246,
                rx: 10.3,
                fill: "#F5EEFF",
                stroke: "#D0BED6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 44.5,
                y: 192.07,
                width: 44.1,
                height: 7.181,
                rx: 1.8,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 44.5,
                y: 178.605,
                width: 8.1,
                height: 7.181,
                rx: 1.8,
                fill: "#FFC3F1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 60.7,
                y: 178.605,
                width: 20.7,
                height: 7.181,
                rx: 1.8,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip0_6485_85287)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 104.8,
                        y: 172.321,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#F5EEFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M131.613 200.939c.872 1.662 1.309 7.717 1.309 7.717h-24.521s.437-6.055 1.31-7.717c1.309-2.493 10.951-5.699 10.951-5.699s9.641 3.206 10.951 5.699Z",
                        fill: "#F07EFF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "m130.836 193.864-19.338-2.331c-.953-5.048.178-8.229 3.393-9.542 1.486-4.857 7.271-4.462 8.91-4.066 5.58 1.348 7.925 6.661 7.035 15.939Z",
                        fill: "#47464E"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M117.806 196.666v-7.124c-2.979-.044-2.398-5.192.595-3.621.535.237 1.904-.416 1.428-2.018 3.214 2.374 7.692-1.793 7.975.771.557 5.047-.52 9.196-3.375 9.196a4.622 4.622 0 0 1-.91-.054v2.85c-.932.554-1.864.831-2.796.831-.932 0-1.904-.277-2.917-.831Z",
                        fill: "#FFB95A"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M123.518 193.816v.949c-1.309 0-3.174-.85-4.166-2.552 1.19.791 2.579 1.326 4.166 1.603Z",
                        fill: "#FA8B54"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M120.657 197.374c.814-.039 2.861-.459 2.861-1.367v-.767c.218 0 .843.515 1.164.95 1.271 1.722-.138 3.265-1.288 3.265-1.45 0-2.412-1.209-2.733-1.79-.321.581-1.283 1.79-2.733 1.79-1.15 0-2.56-1.543-1.289-3.265.322-.435.947-.95 1.165-.95v.767c0 .908 1.993 1.328 2.853 1.367Z",
                        fill: "url(#paint2_linear_6485_85287)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 105.25,
                y: 172.771,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#D0BED6",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M59.8 106.819c0-5.965 4.835-10.8 10.8-10.8h141.3c5.965 0 10.8 4.835 10.8 10.8v3.562H59.8v-3.562Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M219.1 115.32c8.697 0 15.75-7.033 15.75-15.71 0-8.679-7.053-15.711-15.75-15.711s-15.75 7.032-15.75 15.71 7.053 15.711 15.75 15.711Z",
                stroke: "url(#paint3_linear_6485_85287)",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 219.101,
                cy: 99.61,
                rx: 13.843,
                ry: 13.807,
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 3.951,
                height: 11.854,
                rx: 1.976,
                transform: "rotate(-44.926 224.116 -204.183)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 15.805,
                height: 3.951,
                rx: 1.976,
                transform: "rotate(-44.926 233.662 -208.158)",
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m109.3 138.659 10.887-10.859a10.8 10.8 0 0 1 12.877-1.791l9.457 5.26a10.8 10.8 0 0 0 12.573-1.5l6.282-5.796a10.8 10.8 0 0 1 12.924-1.297l26.35 15.983",
                stroke: "#fff",
                strokeOpacity: 0.7,
                strokeWidth: 0.9,
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 45.4,
                y: 62.805,
                width: 62.1,
                height: 91.563,
                rx: 14.4,
                fill: "#C39EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 7.195,
                height: 7.186,
                rx: 1.8,
                transform: "rotate(30.748 -30.22 407.104) skewX(-.13)",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40.9 66.064c-3.73 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.731 0 5.302 1.958 5.302 6.615 0-4.657 1.767-6.615 5.498-6.615ZM56.2 90.302c-3.731 0-5.498-3.175-5.498-5.953 0 2.778-1.571 5.953-5.302 5.953 3.73 0 5.302 1.957 5.302 6.614 0-4.656 1.767-6.614 5.498-6.614Z",
                fill: "#FFF06A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 166.94,
                cy: 121.192,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 126.44,
                cy: 124.784,
                rx: 1.839,
                ry: 1.835,
                fill: "#fff"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 52.6,
                y: 115.77,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 52.6,
                y: 129.234,
                width: 48.6,
                height: 8.977,
                rx: 3.6,
                fill: "#EFE9FF",
                stroke: "#815AE3",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M58 120.257c0-.496.402-.898.897-.898h19.805a.898.898 0 0 1 0 1.796H58.897a.898.898 0 0 1-.897-.898Zm25.2 0c0-.496.402-.898.897-.898h5.405a.898.898 0 0 1 0 1.796h-5.405a.898.898 0 0 1-.897-.898Zm9.897-.898a.898.898 0 0 0 0 1.796h1.805a.898.898 0 0 0 0-1.796h-1.805Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 62.5,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 69.7,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 76.9,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 84.1,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 91.3,
                cy: 133.722,
                rx: 1.8,
                ry: 1.795,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                clipPath: "url(#clip1_6485_85287)",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                        x: 60.7,
                        y: 74.476,
                        width: 32.4,
                        height: 32.316,
                        rx: 10.8,
                        fill: "#D8C7FF"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M79.93 97.279v2.44c0 .47-6.96.312-6.96-.366 0-.637.013-3.528 0-6.501-1.56-2.015-1.56-3.275-.327-4.576 1.233-1.302 10.005-1.953 10.005-1.953s.658 6.314.761 8.027c.042.689.49 2.929-1.25 2.929h-2.23Z",
                        fill: "url(#paint4_linear_6485_85287)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M79.928 97.069a10.308 10.308 0 0 1-4.021-1.31s.87 2.06 4.02 2.62v-1.31Z",
                        fill: "#FFD7B8",
                        style: {
                            mixBlendMode: "multiply"
                        }
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M87.868 104.578c.629 1.275 1.136 3.308 1.522 6.099a.744.744 0 0 1-.74.843h-24.4a.744.744 0 0 1-.74-.843c.386-2.792.893-4.824 1.52-6.099.689-1.395 7.07-4.079 7.07-4.079s.127-1.227.435-1.403c.308-.176 7.463-.176 7.83 0s.435 1.402.435 1.402 6.382 2.688 7.068 4.08Z",
                        fill: "#5F5D67"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M74.386 89.598c-.346-.296-.766-.495-1.36-.188-1.408.73-.474 3.543 1.102 3.488.544-.019.295 1.062-1.158 1.776 0-1.139-1.74-3.959-1.892-6.527-1.751-.65-1.316-3.252-.114-3.252-.192-2.385 3.637-3.617 5.12-2.248 1.508-1.803 5.314-.881 5.544.683 2.617-1.394 4.338 2.612 1.887 4.167-1.008.64-3.367.883-6.773.883-1.634 0-.694 3.815-.183 5.047.652 1.572 4.296 1.79 5.437 1.627.892-.127 1.36-.488 1.414-.705.816 2.17-.217 3.47-1.849 3.47-2.773 0-5.546-.813-5.98-2.82-.347-1.596-.328-4.174-1.195-5.4Z",
                        fill: "#7958FF"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 61.15,
                y: 74.926,
                width: 31.5,
                height: 31.416,
                rx: 10.35,
                stroke: "#9877EA",
                strokeWidth: 0.9
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#fff",
                d: "M89 218h20v5H89z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_6485_85287",
                        x1: 128.2,
                        y1: 219,
                        x2: 128.2,
                        y2: 26,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F5EEFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F5EEFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_6485_85287",
                        x1: 155.2,
                        y1: 96.019,
                        x2: 124.678,
                        y2: 200.782,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_6485_85287",
                        x1: 120.661,
                        y1: 199.455,
                        x2: 120.661,
                        y2: 195.24,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FCF2EB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFF9F5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_6485_85287",
                        x1: 207.443,
                        y1: 88.709,
                        x2: 234.332,
                        y2: 114.939,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#83DA85"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#83DA85",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_6485_85287",
                        x1: 77.624,
                        y1: 86.323,
                        x2: 77.624,
                        y2: 99.989,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFD4B3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFDCC2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip0_6485_85287",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 104.8,
                            y: 172.321,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("clipPath", {
                        id: "clip1_6485_85287",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                            x: 60.7,
                            y: 74.476,
                            width: 32.4,
                            height: 32.316,
                            rx: 10.8,
                            fill: "#fff"
                        })
                    })
                ]
            })
        ]
    });
var $27d055267e8ee57c$export$2e2bcd8739ae039 = $27d055267e8ee57c$var$SvgRolesEmpty;





var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");





var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $h7VLF = parcelRequire("h7VLF");


var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $2O7i9 = parcelRequire("2O7i9");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");




var $aHzBK = parcelRequire("aHzBK");




var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");


var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");



var $bSFEw = parcelRequire("bSFEw");

var $670c0eccaf3ed8fa$export$5389c3225d6cd45c;
var $670c0eccaf3ed8fa$export$7834d747dd9f1115;
var $670c0eccaf3ed8fa$export$32325fe76ee7094c;
var $670c0eccaf3ed8fa$export$bfd64c937657f93a;
var $670c0eccaf3ed8fa$export$4a6dd88bada4e7d2;
var $670c0eccaf3ed8fa$export$74dc5dd4e622afa8;
$670c0eccaf3ed8fa$export$5389c3225d6cd45c = `IGa9CW_proTag`;
$670c0eccaf3ed8fa$export$7834d747dd9f1115 = `IGa9CW_roleTypeSelectionSwitch`;
$670c0eccaf3ed8fa$export$32325fe76ee7094c = `IGa9CW_roleTypes`;
$670c0eccaf3ed8fa$export$bfd64c937657f93a = `IGa9CW_rotating`;
$670c0eccaf3ed8fa$export$4a6dd88bada4e7d2 = `IGa9CW_shimmer`;
$670c0eccaf3ed8fa$export$74dc5dd4e622afa8 = `IGa9CW_trailingIcon`;


const $9b11a7e2b54d5177$var$radioOptions = [
    {
        key: "roles.type_user",
        value: (0, $3kVX5.RoleType).User,
        hasPaywall: false
    },
    {
        key: "roles.type_machine_to_machine",
        value: (0, $3kVX5.RoleType).MachineToMachine,
        hasPaywall: true
    }
];
function $9b11a7e2b54d5177$var$CreateRoleForm({ totalRoleCount: totalRoleCount, onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const [isTypeSelectorVisible, setIsTypeSelectorVisible] = (0, $eCoWV.useState)(false);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { control: control, handleSubmit: handleSubmit, register: register, watch: watch, formState: { isSubmitting: isSubmitting, errors: errors } } = (0, $c3LX9.useForm)({
        defaultValues: {
            type: (0, $3kVX5.RoleType).User
        }
    });
    const api = (0, $2ANSb.default)();
    const roleScopes = watch("scopes", []);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async ({ name: name, description: description, type: type, scopes: scopes })=>{
        if (isSubmitting) return;
        const payload = {
            name: name,
            description: description,
            type: type,
            scopeIds: (0, $5CQIb.conditional)(scopes.length > 0 && scopes.map(({ id: id })=>id))
        };
        const createdRole = await api.post("api/roles", {
            json: payload
        }).json();
        onClose(createdRole);
    }));
    const isRolesReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "rolesLimit",
        plan: currentPlan,
        usage: totalRoleCount
    });
    const isScopesPerReachLimit = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "scopesPerRoleLimit",
        plan: currentPlan,
        /**
     * If usage is equal to the limit, it means the current role has reached the maximum allowed scope.
     * Therefore, we should not assign any more scopes at this point.
     * However, the currently selected scopes haven't been assigned yet, so we subtract 1
     * to allow the assignment when the scope count is equal to the limit.
     */ usage: roleScopes.length - 1
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
        title: "roles.create_role_title",
        subtitle: "roles.create_role_description",
        learnMoreLink: {
            href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
            targetBlank: "noopener"
        },
        size: "large",
        footer: (()=>{
            if (currentPlan?.name === (0, $4b7ab4566c750149$export$e88bde3ace5c7bbf).Free && watch("type") === (0, $3kVX5.RoleType).MachineToMachine) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                    },
                    children: t("upsell.paywall.machine_to_machine_feature")
                })
            });
            if (isRolesReachLimit && currentPlan) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.roles", {
                        count: currentPlan.quota.rolesLimit ?? 0
                    })
                })
            });
            if (isScopesPerReachLimit && currentPlan && !isRolesReachLimit) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                        planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlan.name
                        })
                    },
                    children: t("upsell.paywall.scopes_per_role", {
                        count: currentPlan.quota.scopesPerRoleLimit ?? 0
                    })
                })
            });
            if (!isRolesReachLimit && !isScopesPerReachLimit) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                isLoading: isSubmitting,
                htmlType: "submit",
                title: "roles.create_role_button",
                size: "large",
                type: "primary",
                onClick: onSubmit
            });
        })(),
        onClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                    isRequired: true,
                    title: "roles.role_name",
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            // eslint-disable-next-line jsx-a11y/no-autofocus
                            autoFocus: true,
                            ...register("name", {
                                required: true,
                                validate: (name)=>name.startsWith((0, $2O7i9.internalRolePrefix)) ? t("errors.create_internal_role_violation") : true
                            }),
                            placeholder: t("roles.role_name_placeholder"),
                            error: errors.name?.message
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            type: "text",
                            size: "small",
                            title: isTypeSelectorVisible ? "roles.hide_role_type_button_text" : "roles.show_role_type_button_text",
                            trailingIcon: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $670c0eccaf3ed8fa$export$74dc5dd4e622afa8,
                                children: isTypeSelectorVisible ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fb79e1374131f586$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $46ab19a7423faf73$export$2e2bcd8739ae039), {})
                            }),
                            className: $670c0eccaf3ed8fa$export$7834d747dd9f1115,
                            onClick: ()=>{
                                setIsTypeSelectorVisible(!isTypeSelectorVisible);
                            }
                        })
                    ]
                }),
                isTypeSelectorVisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "roles.role_type",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "type",
                        control: control,
                        render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                name: name,
                                className: $670c0eccaf3ed8fa$export$32325fe76ee7094c,
                                value: value,
                                onChange: (value)=>{
                                    onChange(value);
                                },
                                children: $9b11a7e2b54d5177$var$radioOptions.map(({ key: key, value: value, hasPaywall: hasPaywall })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                            forKey: key
                                        }),
                                        value: value,
                                        trailingIcon: hasPaywall && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $aHzBK.default), {
                                            isVisible: !currentPlan?.quota.machineToMachineLimit,
                                            for: "upsell",
                                            plan: (0, $ckJfF.ReservedPlanId).Hobby,
                                            className: $670c0eccaf3ed8fa$export$5389c3225d6cd45c
                                        })
                                    }, value))
                            })
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    isRequired: true,
                    title: "roles.role_description",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                        ...register("description", {
                            required: true
                        }),
                        placeholder: t("roles.role_description_placeholder"),
                        error: Boolean(errors.description)
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "roles.assign_permissions",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        control: control,
                        name: "scopes",
                        defaultValue: [],
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5692eceb6d9818$export$2e2bcd8739ae039), {
                                roleType: watch("type"),
                                value: value,
                                onChange: onChange
                            })
                    })
                })
            ]
        })
    });
}
var $9b11a7e2b54d5177$export$2e2bcd8739ae039 = $9b11a7e2b54d5177$var$CreateRoleForm;


function $cb06aaf48d0a56b2$var$CreateRoleModal({ totalRoleCount: totalRoleCount, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [createdRole, setCreatedRole] = (0, $eCoWV.useState)();
    const onCreateFormClose = (createdRole)=>{
        if (createdRole) {
            setCreatedRole(createdRole);
            (0, $horhC.toast).success(t("roles.role_created", {
                name: createdRole.name
            }));
            return;
        }
        onClose();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: createdRole ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f8d707165e6db426$export$2e2bcd8739ae039), {
            isRemindSkip: true,
            roleId: createdRole.id,
            roleType: createdRole.type,
            onClose: ()=>{
                navigate(`/roles/${createdRole.id}`, {
                    replace: true
                });
            }
        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9b11a7e2b54d5177$export$2e2bcd8739ae039), {
            totalRoleCount: totalRoleCount,
            onClose: onCreateFormClose
        })
    });
}
var $cb06aaf48d0a56b2$export$2e2bcd8739ae039 = $cb06aaf48d0a56b2$var$CreateRoleModal;


var $910856bd5fb20c45$export$6d59db4903f20f7d;
var $910856bd5fb20c45$export$bfd64c937657f93a;
var $910856bd5fb20c45$export$4a6dd88bada4e7d2;
var $910856bd5fb20c45$export$bf9fb029d174d554;
$910856bd5fb20c45$export$6d59db4903f20f7d = `EXktkG_description`;
$910856bd5fb20c45$export$bfd64c937657f93a = `EXktkG_rotating`;
$910856bd5fb20c45$export$4a6dd88bada4e7d2 = `EXktkG_shimmer`;
$910856bd5fb20c45$export$bf9fb029d174d554 = `EXktkG_type`;


const $e74da459c6551bd7$var$rolesPathname = "/roles";
const $e74da459c6551bd7$var$createRolePathname = `${$e74da459c6551bd7$var$rolesPathname}/create`;
const $e74da459c6551bd7$var$buildDetailsPathname = (id)=>`${$e74da459c6551bd7$var$rolesPathname}/${id}`;
const $e74da459c6551bd7$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $e74da459c6551bd7$var$getRoleIcon = (type, isDarkMode)=>{
    if (type === (0, $3kVX5.RoleType).User) return isDarkMode ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $89556d785f25fda7$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1000e8ee7949b499$export$2e2bcd8739ae039), {});
    return isDarkMode ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9b26f155c5b34c5$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $844c753ae2b24ff8$export$2e2bcd8739ae039), {});
};
function $e74da459c6551bd7$var$Roles() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const isCreating = match($e74da459c6551bd7$var$createRolePathname);
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const theme = (0, $93h5F.default)();
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const url = (0, $h7VLF.buildUrl)("api/roles", {
        page: String(page),
        page_size: String($e74da459c6551bd7$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
        title: {
            title: "roles.title",
            subtitle: "roles.subtitle",
            learnMoreLink: {
                href: "https://docs.logto.io/docs/recipes/rbac/manage-permissions-and-roles#manage-roles",
                targetBlank: "noopener"
            }
        },
        pageMeta: {
            titleKey: "roles.page_title"
        },
        createButton: {
            title: "roles.create",
            onClick: ()=>{
                navigate({
                    pathname: $e74da459c6551bd7$var$createRolePathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "roles",
                    data: roles
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("roles.col_roles"),
                    dataIndex: "roles",
                    colSpan: 5,
                    render: ({ id: id, name: name, type: type })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                            title: name,
                            to: $e74da459c6551bd7$var$buildDetailsPathname(id),
                            icon: $e74da459c6551bd7$var$getRoleIcon(type, theme === (0, $bhvxB.Theme).Dark)
                        })
                },
                {
                    title: t("roles.col_type"),
                    dataIndex: "type",
                    colSpan: 5,
                    render: ({ type: type })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $910856bd5fb20c45$export$bf9fb029d174d554,
                            children: type === (0, $3kVX5.RoleType).User ? t("roles.type_user") : t("roles.type_machine_to_machine")
                        })
                },
                {
                    title: t("roles.col_description"),
                    dataIndex: "description",
                    colSpan: 5,
                    render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $910856bd5fb20c45$export$6d59db4903f20f7d,
                            children: description
                        })
                },
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        children: t("roles.col_assigned_entities")
                    }),
                    dataIndex: "entities",
                    colSpan: 5,
                    render: ({ type: type, featuredUsers: featuredUsers, usersCount: usersCount, featuredApplications: featuredApplications, applicationsCount: applicationsCount })=>{
                        if (type === (0, $3kVX5.RoleType).User) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $319fdc3543ade48a$export$2e2bcd8739ae039), {
                            entities: featuredUsers,
                            count: usersCount,
                            type: type
                        });
                        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $319fdc3543ade48a$export$2e2bcd8739ae039), {
                            entities: featuredApplications,
                            count: applicationsCount,
                            type: type
                        });
                    }
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($e74da459c6551bd7$var$buildDetailsPathname(id));
            },
            filter: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                placeholder: t("roles.search"),
                defaultValue: keyword,
                isClearable: Boolean(keyword),
                onSearch: (keyword)=>{
                    updateSearchParameters({
                        keyword: keyword,
                        page: 1
                    });
                },
                onClearSearch: ()=>{
                    updateSearchParameters({
                        keyword: "",
                        page: 1
                    });
                }
            }),
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $e74da459c6551bd7$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $27d055267e8ee57c$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $411ab43ab7a708a4$export$2e2bcd8739ae039), {}),
                title: "roles.placeholder_title",
                description: "roles.placeholder_description",
                learnMoreLink: {
                    href: getDocumentationUrl("/docs/recipes/rbac/manage-permissions-and-roles#manage-roles"),
                    targetBlank: "noopener"
                },
                action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "roles.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $e74da459c6551bd7$var$createRolePathname,
                            search: search
                        });
                    }
                })
            }),
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: isCreating && totalCount !== undefined && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cb06aaf48d0a56b2$export$2e2bcd8739ae039), {
            totalRoleCount: totalCount,
            onClose: ()=>{
                navigate({
                    pathname: $e74da459c6551bd7$var$rolesPathname,
                    search: search
                });
            }
        })
    });
}
var $e74da459c6551bd7$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($e74da459c6551bd7$var$Roles);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");




var $V1X8c = parcelRequire("V1X8c");

var $lSA0o = parcelRequire("lSA0o");

var $kMAP9 = parcelRequire("kMAP9");


var $2ANSb = parcelRequire("2ANSb");


var $4W0F0 = parcelRequire("4W0F0");



var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $41a65760bf906bca$var$SvgExternalLink = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M12 7.213a.667.667 0 0 0-.667.667v4.787a.667.667 0 0 1-.666.666H3.333a.667.667 0 0 1-.666-.666V5.333a.667.667 0 0 1 .666-.666H8.12a.667.667 0 0 0 0-1.334H3.333a2 2 0 0 0-2 2v7.334a2 2 0 0 0 2 2h7.334a2 2 0 0 0 2-2V7.88A.666.666 0 0 0 12 7.213Zm2.613-5.466A.667.667 0 0 0 14 1.333h-4a.667.667 0 0 0 0 1.334h2.393l-6.866 6.86a.667.667 0 0 0 .217 1.092.668.668 0 0 0 .73-.146l6.86-6.866V6a.667.667 0 1 0 1.333 0V2a.667.667 0 0 0-.054-.253Z",
            fill: "currentColor"
        })
    });
var $41a65760bf906bca$export$2e2bcd8739ae039 = $41a65760bf906bca$var$SvgExternalLink;



var $eEyjP = parcelRequire("eEyjP");

var $kcPww = parcelRequire("kcPww");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");
var $831d8943a4594b2c$export$ca2f546e21dcce87;
var $831d8943a4594b2c$export$eb8ac6f826d2b00;
$831d8943a4594b2c$export$ca2f546e21dcce87 = `od0qPW_defaultIcon`;
$831d8943a4594b2c$export$eb8ac6f826d2b00 = `od0qPW_disabledDefaultIcon`;


function $ad84651c3367bb07$var$LivePreviewButton({ size: size, type: type, isDisabled: isDisabled }) {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
        content: (0, $5CQIb.conditional)(isDisabled && t("sign_in_exp.preview.live_preview_tip")),
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
            size: size,
            type: type,
            disabled: isDisabled,
            title: "sign_in_exp.preview.live_preview",
            trailingIcon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $41a65760bf906bca$export$2e2bcd8739ae039), {
                className: (0, $5CQIb.conditional)(type !== "violet" && (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($831d8943a4594b2c$export$ca2f546e21dcce87, isDisabled && $831d8943a4594b2c$export$eb8ac6f826d2b00))
            }),
            onClick: ()=>{
                window.open(new URL("/demo-app", tenantEndpoint), "_blank");
            }
        })
    });
}
var $ad84651c3367bb07$export$2e2bcd8739ae039 = $ad84651c3367bb07$var$LivePreviewButton;








var $e654bcd2e0d98a30$export$38e42c68cf43b5d4;
var $e654bcd2e0d98a30$export$789c912f57fe164c;
var $e654bcd2e0d98a30$export$80e4b313e5e6b30d;
var $e654bcd2e0d98a30$export$48c2d0f2f545ac27;
var $e654bcd2e0d98a30$export$bfd64c937657f93a;
var $e654bcd2e0d98a30$export$2e44bf0978869fd4;
var $e654bcd2e0d98a30$export$4a6dd88bada4e7d2;
var $e654bcd2e0d98a30$export$fb184b623420d9be;
$e654bcd2e0d98a30$export$38e42c68cf43b5d4 = `R5BQyG_header`;
$e654bcd2e0d98a30$export$789c912f57fe164c = `R5BQyG_language`;
$e654bcd2e0d98a30$export$80e4b313e5e6b30d = `R5BQyG_nav`;
$e654bcd2e0d98a30$export$48c2d0f2f545ac27 = `R5BQyG_preview`;
$e654bcd2e0d98a30$export$bfd64c937657f93a = `R5BQyG_rotating`;
$e654bcd2e0d98a30$export$2e44bf0978869fd4 = `R5BQyG_selects`;
$e654bcd2e0d98a30$export$4a6dd88bada4e7d2 = `R5BQyG_shimmer`;
$e654bcd2e0d98a30$export$fb184b623420d9be = `R5BQyG_title`;


function $99b6920b760e9cc1$var$Preview({ isLivePreviewDisabled: isLivePreviewDisabled = false, isLivePreviewEntryInvisible: isLivePreviewEntryInvisible = false, signInExperience: signInExperience, className: className }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { hasSupportNativePlatformTarget: isNativeTabEnabled } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    const [language, setLanguage] = (0, $eCoWV.useState)("en");
    const [mode, setMode] = (0, $eCoWV.useState)((0, $bhvxB.Theme).Light);
    const [platform, setPlatform] = (0, $eCoWV.useState)((0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb);
    const { languages: languages } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    (0, $eCoWV.useEffect)(()=>{
        if (!signInExperience?.color.isDarkModeEnabled) setMode((0, $bhvxB.Theme).Light);
    }, [
        mode,
        signInExperience
    ]);
    const availableLanguageOptions = (0, $eCoWV.useMemo)(()=>{
        const availableLanguageTags = signInExperience && !signInExperience.languageInfo.autoDetect ? languages.filter((languageTag)=>languageTag === signInExperience.languageInfo.fallbackLanguage) : languages;
        return availableLanguageTags.map((languageTag)=>({
                value: languageTag,
                title: (0, $3nY0n.languages)[languageTag]
            }));
    }, [
        languages,
        signInExperience
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!availableLanguageOptions[0]) return;
        if (!availableLanguageOptions.some(({ value: value })=>value === language)) setLanguage(availableLanguageOptions[0].value);
    }, [
        language,
        availableLanguageOptions
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($e654bcd2e0d98a30$export$48c2d0f2f545ac27, className),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $e654bcd2e0d98a30$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $e654bcd2e0d98a30$export$fb184b623420d9be,
                        children: t("sign_in_exp.preview.title")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $e654bcd2e0d98a30$export$2e44bf0978869fd4,
                        children: [
                            signInExperience?.color.isDarkModeEnabled && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c47db53c375844f5$export$2e2bcd8739ae039), {
                                value: mode,
                                size: "small",
                                onToggle: setMode
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                                className: $e654bcd2e0d98a30$export$789c912f57fe164c,
                                size: "small",
                                value: language,
                                options: availableLanguageOptions,
                                onChange: (value)=>{
                                    if (value) setLanguage(value);
                                }
                            }),
                            !isLivePreviewEntryInvisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ad84651c3367bb07$export$2e2bcd8739ae039), {
                                isDisabled: isLivePreviewDisabled,
                                size: "small"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                className: $e654bcd2e0d98a30$export$80e4b313e5e6b30d,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb,
                        onClick: ()=>{
                            setPlatform((0, $1fc616453f583432$export$70866093e58553f7).DesktopWeb);
                        },
                        children: t(isNativeTabEnabled ? "sign_in_exp.preview.desktop_web" : "sign_in_exp.preview.desktop")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $1fc616453f583432$export$70866093e58553f7).MobileWeb,
                        onClick: ()=>{
                            setPlatform((0, $1fc616453f583432$export$70866093e58553f7).MobileWeb);
                        },
                        children: t(isNativeTabEnabled ? "sign_in_exp.preview.mobile_web" : "sign_in_exp.preview.mobile")
                    }),
                    isNativeTabEnabled && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        isActive: platform === (0, $1fc616453f583432$export$70866093e58553f7).Mobile,
                        onClick: ()=>{
                            setPlatform((0, $1fc616453f583432$export$70866093e58553f7).Mobile);
                        },
                        children: t("sign_in_exp.preview.native")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4079df6da596c72e$export$2e2bcd8739ae039), {
                platform: platform,
                mode: mode,
                language: language,
                signInExperience: signInExperience
            })
        ]
    });
}
var $99b6920b760e9cc1$export$2e2bcd8739ae039 = $99b6920b760e9cc1$var$Preview;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $20diy = parcelRequire("20diy");
const $387c3e54c8962f99$export$871608497c498473 = (d)=>d instanceof Date;
const $387c3e54c8962f99$export$dd1bc94b04021eeb = (o)=>Object.keys(o).length === 0;
const $387c3e54c8962f99$export$a6cdc56e425d0d0a = (o)=>o != null && typeof o === "object";
const $387c3e54c8962f99$export$5a15a386532a5ea4 = (o, ...args)=>Object.prototype.hasOwnProperty.call(o, ...args);
const $387c3e54c8962f99$export$83b788b1a3698c03 = (o)=>$387c3e54c8962f99$export$a6cdc56e425d0d0a(o) && $387c3e54c8962f99$export$dd1bc94b04021eeb(o);
const $387c3e54c8962f99$export$d6d64087a1bd2d = ()=>Object.create(null);


const $338199a87e24bd9f$var$diff = (lhs, rhs)=>{
    if (lhs === rhs) return {}; // equal return no diff
    if (!(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(lhs) || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(rhs)) return rhs; // return updated rhs
    const deletedValues = Object.keys(lhs).reduce((acc, key)=>{
        if (!(0, $387c3e54c8962f99$export$5a15a386532a5ea4)(rhs, key)) acc[key] = undefined;
        return acc;
    }, (0, $387c3e54c8962f99$export$d6d64087a1bd2d)());
    if ((0, $387c3e54c8962f99$export$871608497c498473)(lhs) || (0, $387c3e54c8962f99$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if (!(0, $387c3e54c8962f99$export$5a15a386532a5ea4)(lhs, key)) {
            acc[key] = rhs[key]; // return added r key
            return acc;
        }
        const difference = $338199a87e24bd9f$var$diff(lhs[key], rhs[key]);
        // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
        if ((0, $387c3e54c8962f99$export$83b788b1a3698c03)(difference) && !(0, $387c3e54c8962f99$export$871608497c498473)(difference) && ((0, $387c3e54c8962f99$export$83b788b1a3698c03)(lhs[key]) || !(0, $387c3e54c8962f99$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
        acc[key] = difference // return updated key
        ;
        return acc; // return updated key
    }, deletedValues);
};
var $338199a87e24bd9f$export$2e2bcd8739ae039 = $338199a87e24bd9f$var$diff;



const $77a6e91294ffc838$var$addedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(lhs) || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $387c3e54c8962f99$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $77a6e91294ffc838$var$addedDiff(lhs[key], rhs[key]);
            if ((0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(difference) && (0, $387c3e54c8962f99$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = rhs[key];
        return acc;
    }, (0, $387c3e54c8962f99$export$d6d64087a1bd2d)());
};
var $77a6e91294ffc838$export$2e2bcd8739ae039 = $77a6e91294ffc838$var$addedDiff;



const $7a4bf630a00162af$var$deletedDiff = (lhs, rhs)=>{
    if (lhs === rhs || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(lhs) || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(rhs)) return {};
    return Object.keys(lhs).reduce((acc, key)=>{
        if ((0, $387c3e54c8962f99$export$5a15a386532a5ea4)(rhs, key)) {
            const difference = $7a4bf630a00162af$var$deletedDiff(lhs[key], rhs[key]);
            if ((0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(difference) && (0, $387c3e54c8962f99$export$dd1bc94b04021eeb)(difference)) return acc;
            acc[key] = difference;
            return acc;
        }
        acc[key] = undefined;
        return acc;
    }, (0, $387c3e54c8962f99$export$d6d64087a1bd2d)());
};
var $7a4bf630a00162af$export$2e2bcd8739ae039 = $7a4bf630a00162af$var$deletedDiff;



const $03640a43a84dd369$var$updatedDiff = (lhs, rhs)=>{
    if (lhs === rhs) return {};
    if (!(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(lhs) || !(0, $387c3e54c8962f99$export$a6cdc56e425d0d0a)(rhs)) return rhs;
    if ((0, $387c3e54c8962f99$export$871608497c498473)(lhs) || (0, $387c3e54c8962f99$export$871608497c498473)(rhs)) {
        if (lhs.valueOf() == rhs.valueOf()) return {};
        return rhs;
    }
    return Object.keys(rhs).reduce((acc, key)=>{
        if ((0, $387c3e54c8962f99$export$5a15a386532a5ea4)(lhs, key)) {
            const difference = $03640a43a84dd369$var$updatedDiff(lhs[key], rhs[key]);
            // If the difference is empty, and the lhs is an empty object or the rhs is not an empty object
            if ((0, $387c3e54c8962f99$export$83b788b1a3698c03)(difference) && !(0, $387c3e54c8962f99$export$871608497c498473)(difference) && ((0, $387c3e54c8962f99$export$83b788b1a3698c03)(lhs[key]) || !(0, $387c3e54c8962f99$export$83b788b1a3698c03)(rhs[key]))) return acc; // return no diff
            acc[key] = difference;
            return acc;
        }
        return acc;
    }, (0, $387c3e54c8962f99$export$d6d64087a1bd2d)());
};
var $03640a43a84dd369$export$2e2bcd8739ae039 = $03640a43a84dd369$var$updatedDiff;





const $dd74f23306b87512$var$detailedDiff = (lhs, rhs)=>({
        added: (0, $77a6e91294ffc838$export$2e2bcd8739ae039)(lhs, rhs),
        deleted: (0, $7a4bf630a00162af$export$2e2bcd8739ae039)(lhs, rhs),
        updated: (0, $03640a43a84dd369$export$2e2bcd8739ae039)(lhs, rhs)
    });
var $dd74f23306b87512$export$2e2bcd8739ae039 = $dd74f23306b87512$var$detailedDiff;




parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $fbeQ6 = parcelRequire("fbeQ6");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
var $fU2Vo = parcelRequire("fU2Vo");
var $c346ed781c4c9623$export$69ec1500fb2141d2;
(function(SignUpIdentifier) {
    SignUpIdentifier["Email"] = "email";
    SignUpIdentifier["Phone"] = "phone";
    SignUpIdentifier["Username"] = "username";
    SignUpIdentifier["EmailOrSms"] = "emailOrSms";
    SignUpIdentifier["None"] = "none";
})($c346ed781c4c9623$export$69ec1500fb2141d2 || ($c346ed781c4c9623$export$69ec1500fb2141d2 = {}));


const $61e23b9bb15ba266$export$370e1bd33b1689cd = Object.values((0, $c346ed781c4c9623$export$69ec1500fb2141d2));
const $61e23b9bb15ba266$export$b0ad61f2357dff83 = Object.values((0, $bd0Y0.SignInIdentifier));
const $61e23b9bb15ba266$export$6ce44f6619762c02 = {
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Username]: [
        (0, $bd0Y0.SignInIdentifier).Username
    ],
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Email]: [
        (0, $bd0Y0.SignInIdentifier).Email
    ],
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Phone]: [
        (0, $bd0Y0.SignInIdentifier).Phone
    ],
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).EmailOrSms]: [
        (0, $bd0Y0.SignInIdentifier).Email,
        (0, $bd0Y0.SignInIdentifier).Phone
    ],
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).None]: []
};
const $61e23b9bb15ba266$export$b918f3278c9100b2 = {
    [(0, $bd0Y0.SignInIdentifier).Email]: (0, $fU2Vo.ConnectorType).Email,
    [(0, $bd0Y0.SignInIdentifier).Phone]: (0, $fU2Vo.ConnectorType).Sms
};
const $61e23b9bb15ba266$export$c54a2f6297ba7cbe = Object.freeze({
    [(0, $bd0Y0.SignInIdentifier).Email]: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
    [(0, $bd0Y0.SignInIdentifier).Phone]: "sign_in_exp.sign_up_and_sign_in.identifiers_phone",
    [(0, $bd0Y0.SignInIdentifier).Username]: "sign_in_exp.sign_up_and_sign_in.identifiers_username"
});
const $61e23b9bb15ba266$export$2d3509a8eccb8b17 = Object.freeze({
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Email]: "sign_in_exp.sign_up_and_sign_in.identifiers_email",
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Phone]: "sign_in_exp.sign_up_and_sign_in.identifiers_phone",
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).Username]: "sign_in_exp.sign_up_and_sign_in.identifiers_username",
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).EmailOrSms]: "sign_in_exp.sign_up_and_sign_in.identifiers_email_or_sms",
    [(0, $c346ed781c4c9623$export$69ec1500fb2141d2).None]: "sign_in_exp.sign_up_and_sign_in.identifiers_none"
});
const $61e23b9bb15ba266$export$119b0ebfd4dd4005 = Object.freeze({
    [(0, $fU2Vo.ConnectorType).Email]: "sign_in_exp.setup_warning.no_connector_email",
    [(0, $fU2Vo.ConnectorType).Sms]: "sign_in_exp.setup_warning.no_connector_sms",
    [(0, $fU2Vo.ConnectorType).Social]: "sign_in_exp.setup_warning.no_connector_social"
});



var $9zeGj = parcelRequire("9zeGj");
var $8260c3aa943befb8$export$955a2ebd2fb142ae;
var $8260c3aa943befb8$export$8837f4fc672e936d;
var $8260c3aa943befb8$export$a90204d1394caf30;
var $8260c3aa943befb8$export$bfd64c937657f93a;
var $8260c3aa943befb8$export$4a6dd88bada4e7d2;
var $8260c3aa943befb8$export$fb184b623420d9be;
$8260c3aa943befb8$export$955a2ebd2fb142ae = `KT-IsW_green`;
$8260c3aa943befb8$export$8837f4fc672e936d = `KT-IsW_list`;
$8260c3aa943befb8$export$a90204d1394caf30 = `KT-IsW_red`;
$8260c3aa943befb8$export$bfd64c937657f93a = `KT-IsW_rotating`;
$8260c3aa943befb8$export$4a6dd88bada4e7d2 = `KT-IsW_shimmer`;
$8260c3aa943befb8$export$fb184b623420d9be = `KT-IsW_title`;


function $cca2c35c02805317$var$DiffSegment({ children: children, hasChanged: hasChanged, isAfter: isAfter = false }) {
    if (!hasChanged) // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: children
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        className: isAfter ? $8260c3aa943befb8$export$955a2ebd2fb142ae : $8260c3aa943befb8$export$a90204d1394caf30,
        children: children
    });
}
var $cca2c35c02805317$export$2e2bcd8739ae039 = $cca2c35c02805317$var$DiffSegment;




const $a3440ae6ff625189$export$2c29f57287a6a3cb = (before, after)=>Object.keys((0, $338199a87e24bd9f$export$2e2bcd8739ae039)(before, after)).length > 0;
const $a3440ae6ff625189$export$b103357118c3dddf = (signInMethods)=>signInMethods.reduce((methodsObject, { identifier: identifier, password: password, verificationCode: verificationCode })=>({
            ...methodsObject,
            [identifier]: {
                password: password,
                verificationCode: verificationCode
            }
        }), // eslint-disable-next-line @typescript-eslint/prefer-reduce-type-parameter, no-restricted-syntax
    {});
const $a3440ae6ff625189$export$bc58e504f69b6a58 = (before, after)=>Object.keys((0, $338199a87e24bd9f$export$2e2bcd8739ae039)($a3440ae6ff625189$export$b103357118c3dddf(before), $a3440ae6ff625189$export$b103357118c3dddf(after))).length > 0;
const $a3440ae6ff625189$export$f9c3f53627a5f79a = (before, after)=>Object.keys((0, $338199a87e24bd9f$export$2e2bcd8739ae039)(before.slice().sort(), after.slice().sort())).length > 0;


function $9515a37274e762ba$var$SignInDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const beforeSignInMethodsObject = (0, $a3440ae6ff625189$export$b103357118c3dddf)(before);
    const afterSignInMethodsObject = (0, $a3440ae6ff625189$export$b103357118c3dddf)(after);
    const signInDiff = isAfter ? (0, $dd74f23306b87512$export$2e2bcd8739ae039)(beforeSignInMethodsObject, afterSignInMethodsObject) : (0, $dd74f23306b87512$export$2e2bcd8739ae039)(afterSignInMethodsObject, beforeSignInMethodsObject);
    const displaySignInMethodsObject = isAfter ? afterSignInMethodsObject : beforeSignInMethodsObject;
    const hasIdentifierChanged = (identifierKey)=>(0, $20diy.getSafe)(signInDiff, `added.${identifierKey.toLocaleLowerCase()}`) !== undefined;
    const hasAuthenticationChanged = (identifierKey, authenticationKey)=>(0, $20diy.getSafe)(signInDiff, `updated.${identifierKey.toLocaleLowerCase()}.${authenticationKey}`) !== undefined;
    // eslint-disable-next-line no-restricted-syntax
    const displayedIdentifiers = Object.keys(displaySignInMethodsObject).slice().sort();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8260c3aa943befb8$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.sign_in")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
                className: $8260c3aa943befb8$export$8837f4fc672e936d,
                children: displayedIdentifiers.map((identifierKey)=>{
                    const { password: password, verificationCode: verificationCode } = displaySignInMethodsObject[identifierKey];
                    const hasAuthentication = password || verificationCode;
                    const needDisjunction = password && verificationCode;
                    return /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                            hasChanged: hasIdentifierChanged(identifierKey),
                            isAfter: isAfter,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: (0, $61e23b9bb15ba266$export$c54a2f6297ba7cbe)[identifierKey]
                                }),
                                hasAuthentication && " (",
                                password && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                                    hasChanged: hasAuthenticationChanged(identifierKey, "password"),
                                    isAfter: isAfter,
                                    children: t("sign_in_exp.sign_up_and_sign_in.sign_in.password_auth")
                                }),
                                needDisjunction && ` ${t("sign_in_exp.sign_up_and_sign_in.or")} `,
                                verificationCode && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                                    hasChanged: hasAuthenticationChanged(identifierKey, "verificationCode"),
                                    isAfter: isAfter,
                                    children: needDisjunction ? t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth").toLocaleLowerCase() : t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth")
                                }),
                                hasAuthentication && ")"
                            ]
                        })
                    }, identifierKey);
                })
            })
        ]
    });
}
var $9515a37274e762ba$export$2e2bcd8739ae039 = $9515a37274e762ba$var$SignInDiffSection;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $20diy = parcelRequire("20diy");

parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $fbeQ6 = parcelRequire("fbeQ6");

parcelRequire("8Hfh4");
var $311RW = parcelRequire("311RW");
parcelRequire("j6dBR");
var $3kVX5 = parcelRequire("3kVX5");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");



parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5ddkS = parcelRequire("5ddkS");

const $68842e5e9cc0281c$export$df47f60a13d5578b = (signUpIdentifier)=>{
    const identifiers = (0, $61e23b9bb15ba266$export$6ce44f6619762c02)[signUpIdentifier];
    return identifiers.includes((0, $bd0Y0.SignInIdentifier).Email) || identifiers.includes((0, $bd0Y0.SignInIdentifier).Phone);
};
const $68842e5e9cc0281c$export$897e85dbd73319d2 = (identifiers)=>{
    for (const [signUpIdentifier, mappedIdentifiers] of Object.entries((0, $61e23b9bb15ba266$export$6ce44f6619762c02))){
        if ((0, $5ddkS.isSameArray)(identifiers, mappedIdentifiers)) // eslint-disable-next-line no-restricted-syntax
        return signUpIdentifier;
    }
    throw new Error("Invalid identifiers in the sign up settings.");
};
const $68842e5e9cc0281c$export$765847ef858119f6 = (signUpIdentifier)=>(0, $61e23b9bb15ba266$export$6ce44f6619762c02)[signUpIdentifier].map((identifier)=>(0, $61e23b9bb15ba266$export$b918f3278c9100b2)[identifier])// eslint-disable-next-line unicorn/prefer-native-coercion-functions
    .filter((connectorType)=>Boolean(connectorType));


const $ae391dabc8d90e85$export$e9fdc6a04ee0d638 = {
    toLocalSignUp: (signUp)=>{
        const { identifiers: identifiers, ...signUpData } = signUp;
        return {
            identifier: (0, $68842e5e9cc0281c$export$897e85dbd73319d2)(identifiers),
            ...signUpData
        };
    },
    toRemoteSignUp: (signUpForm)=>{
        const { identifier: identifier, ...signUpFormData } = signUpForm;
        return {
            identifiers: (0, $61e23b9bb15ba266$export$6ce44f6619762c02)[identifier],
            ...signUpFormData
        };
    },
    toLocalForm: (signInExperience)=>{
        const { signUp: signUp, signInMode: signInMode, customCss: customCss, branding: branding, passwordPolicy: passwordPolicy } = signInExperience;
        return {
            ...signInExperience,
            signUp: $ae391dabc8d90e85$export$e9fdc6a04ee0d638.toLocalSignUp(signUp),
            createAccountEnabled: signInMode !== (0, $3kVX5.SignInMode).SignIn,
            customCss: customCss ?? undefined,
            branding: {
                ...branding,
                logoUrl: branding.logoUrl ?? "",
                darkLogoUrl: branding.darkLogoUrl ?? "",
                favicon: branding.favicon ?? ""
            },
            /** Parse password policy with default values. */ passwordPolicy: {
                ...(0, $311RW.passwordPolicyGuard).parse(passwordPolicy),
                customWords: passwordPolicy.rejects?.words?.join("\n") ?? "",
                isCustomWordsEnabled: Boolean(passwordPolicy.rejects?.words?.length)
            }
        };
    },
    toRemoteModel: (setup)=>{
        const { branding: branding, createAccountEnabled: createAccountEnabled, signUp: signUp, customCss: customCss, /** Remove the custom words related properties since they are not used in the remote model. */ passwordPolicy: { isCustomWordsEnabled: isCustomWordsEnabled, customWords: customWords, ...passwordPolicy } } = setup;
        return {
            ...setup,
            branding: {
                ...branding,
                // Transform empty string to undefined
                favicon: (0, $5CQIb.conditional)(branding.favicon?.length && branding.favicon),
                logoUrl: (0, $5CQIb.conditional)(branding.logoUrl?.length && branding.logoUrl),
                darkLogoUrl: (0, $5CQIb.conditional)(branding.darkLogoUrl?.length && branding.darkLogoUrl)
            },
            signUp: signUp ? $ae391dabc8d90e85$export$e9fdc6a04ee0d638.toRemoteSignUp(signUp) : {
                identifiers: [
                    (0, $bd0Y0.SignInIdentifier).Username
                ],
                password: true,
                verify: false
            },
            signInMode: createAccountEnabled ? (0, $3kVX5.SignInMode).SignInAndRegister : (0, $3kVX5.SignInMode).SignIn,
            customCss: customCss?.length ? customCss : null,
            passwordPolicy: {
                ...passwordPolicy,
                rejects: {
                    ...passwordPolicy.rejects,
                    words: isCustomWordsEnabled ? customWords.split("\n").filter(Boolean) : []
                }
            }
        };
    }
};
const $ae391dabc8d90e85$export$a8696f76b721e0ff = (before, after)=>{
    return !(0, $a3440ae6ff625189$export$2c29f57287a6a3cb)(before.signUp, after.signUp) && !(0, $a3440ae6ff625189$export$bc58e504f69b6a58)(before.signIn.methods, after.signIn.methods) && !(0, $a3440ae6ff625189$export$f9c3f53627a5f79a)(before.socialSignInConnectorTargets, after.socialSignInConnectorTargets);
};
const $ae391dabc8d90e85$export$baf53b848b6e91d = (errors)=>{
    const { color: color, branding: branding, customCss: customCss } = errors;
    const colorFormErrorCount = color ? Object.keys(color).length : 0;
    const brandingFormErrorCount = branding ? Object.keys(branding).length : 0;
    const customCssFormErrorCount = customCss ? 1 : 0;
    return colorFormErrorCount + brandingFormErrorCount + customCssFormErrorCount;
};
const $ae391dabc8d90e85$export$466b1d0c39a15838 = (errors, formData)=>{
    const signUpIdentifier = formData.signUp?.identifier;
    /**
   * Note: we treat the `emailOrSms` sign-up identifier as 2 errors when it's invalid.
   */ const signUpIdentifierRelatedErrorCount = signUpIdentifier ? signUpIdentifier === (0, $c346ed781c4c9623$export$69ec1500fb2141d2).EmailOrSms ? 2 : 1 : 0;
    const { signUp: signUp, signIn: signIn } = errors;
    const signUpErrorCount = signUp?.identifier ? signUpIdentifierRelatedErrorCount : 0;
    const signInMethodErrors = signIn?.methods;
    const signInMethodErrorCount = Array.isArray(signInMethodErrors) ? signInMethodErrors.filter(Boolean).length : 0;
    return signUpErrorCount + signInMethodErrorCount;
};
const $ae391dabc8d90e85$export$df85389c5efb9b1b = (errors)=>{
    const termsOfUseUrlErrorCount = errors.termsOfUseUrl ? 1 : 0;
    const privacyPolicyUrlErrorCount = errors.privacyPolicyUrl ? 1 : 0;
    return termsOfUseUrlErrorCount + privacyPolicyUrlErrorCount;
};




function $91a89fb85fc9bca4$var$SignUpDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const parsedBefore = (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toLocalSignUp(before);
    const parsedAfter = (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toLocalSignUp(after);
    const signUpDiff = isAfter ? (0, $338199a87e24bd9f$export$2e2bcd8739ae039)(parsedBefore, parsedAfter) : (0, $338199a87e24bd9f$export$2e2bcd8739ae039)(parsedAfter, parsedBefore);
    const signUp = isAfter ? parsedAfter : parsedBefore;
    const hasChanged = (path)=>(0, $20diy.getSafe)(signUpDiff, path) !== undefined;
    const { identifier: identifier, password: password, verify: verify } = signUp;
    const hasAuthentication = password || verify;
    const needConjunction = password && verify;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8260c3aa943befb8$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.sign_up")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
                className: $8260c3aa943befb8$export$8837f4fc672e936d,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("identifier"),
                            isAfter: isAfter,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: (0, $61e23b9bb15ba266$export$2d3509a8eccb8b17)[identifier]
                            })
                        }),
                        hasAuthentication && " (",
                        password && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("password"),
                            isAfter: isAfter,
                            children: t("sign_in_exp.sign_up_and_sign_in.sign_up.set_a_password_option")
                        }),
                        needConjunction && ` ${t("sign_in_exp.sign_up_and_sign_in.and")} `,
                        verify && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged("verify"),
                            isAfter: isAfter,
                            children: needConjunction ? t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option").toLowerCase() : t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option")
                        }),
                        hasAuthentication && ")"
                    ]
                })
            })
        ]
    });
}
var $91a89fb85fc9bca4$export$2e2bcd8739ae039 = $91a89fb85fc9bca4$var$SignUpDiffSection;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $dMkQh = parcelRequire("dMkQh");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $awn06 = parcelRequire("awn06");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



function $af950a8e1cbb5255$var$SocialTargetsDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: groups, error: error } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    const { language: language } = (0, $awn06.default);
    const sortedBeforeTargets = before.slice().sort();
    const sortedAfterTargets = after.slice().sort();
    const displayTargets = isAfter ? sortedAfterTargets : sortedBeforeTargets;
    const hasChanged = (target)=>!(before.includes(target) && after.includes(target));
    if (!groups || displayTargets.length === 0 || error) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8260c3aa943befb8$export$fb184b623420d9be,
                children: t("sign_in_exp.save_alert.social")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
                className: $8260c3aa943befb8$export$8837f4fc672e936d,
                children: displayTargets.map((target)=>{
                    const connectorDetail = groups.find(({ target: connectorTarget })=>connectorTarget === target);
                    if (!connectorDetail) return null;
                    return /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cca2c35c02805317$export$2e2bcd8739ae039), {
                            hasChanged: hasChanged(target),
                            isAfter: isAfter,
                            children: (0, $5CQIb.conditional)((0, $dMkQh.isLanguageTag)(language) && connectorDetail.name[language]) ?? connectorDetail.name.en
                        })
                    }, target);
                })
            })
        ]
    });
}
var $af950a8e1cbb5255$export$2e2bcd8739ae039 = $af950a8e1cbb5255$var$SocialTargetsDiffSection;


function $32a6855022add01e$var$SignUpAndSignInDiffSection({ before: before, after: after, isAfter: isAfter = false }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $91a89fb85fc9bca4$export$2e2bcd8739ae039), {
                before: before.signUp,
                after: after.signUp,
                isAfter: isAfter
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9515a37274e762ba$export$2e2bcd8739ae039), {
                before: before.signIn.methods,
                after: after.signIn.methods,
                isAfter: isAfter
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $af950a8e1cbb5255$export$2e2bcd8739ae039), {
                before: before.socialSignInConnectorTargets,
                after: after.socialSignInConnectorTargets,
                isAfter: isAfter
            })
        ]
    });
}
var $32a6855022add01e$export$2e2bcd8739ae039 = $32a6855022add01e$var$SignUpAndSignInDiffSection;


var $a53f93f8f56ca877$export$34e0f9847d4c02dd;
var $a53f93f8f56ca877$export$a7db06668cad9adb;
var $a53f93f8f56ca877$export$6d59db4903f20f7d;
var $a53f93f8f56ca877$export$bfd64c937657f93a;
var $a53f93f8f56ca877$export$fe2e36411d703b3d;
var $a53f93f8f56ca877$export$4a6dd88bada4e7d2;
var $a53f93f8f56ca877$export$fb184b623420d9be;
$a53f93f8f56ca877$export$34e0f9847d4c02dd = `_8_PeAG_container`;
$a53f93f8f56ca877$export$a7db06668cad9adb = `_8_PeAG_content`;
$a53f93f8f56ca877$export$6d59db4903f20f7d = `_8_PeAG_description`;
$a53f93f8f56ca877$export$bfd64c937657f93a = `_8_PeAG_rotating`;
$a53f93f8f56ca877$export$fe2e36411d703b3d = `_8_PeAG_section`;
$a53f93f8f56ca877$export$4a6dd88bada4e7d2 = `_8_PeAG_shimmer`;
$a53f93f8f56ca877$export$fb184b623420d9be = `_8_PeAG_title`;


function $a83ec76bfae3ea56$var$SignUpAndSignInChangePreview({ before: before, after: after }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $a53f93f8f56ca877$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $a53f93f8f56ca877$export$6d59db4903f20f7d,
                children: t("sign_in_exp.save_alert.description")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $a53f93f8f56ca877$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $a53f93f8f56ca877$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $a53f93f8f56ca877$export$fb184b623420d9be,
                                children: t("sign_in_exp.save_alert.before")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $32a6855022add01e$export$2e2bcd8739ae039), {
                                before: before,
                                after: after
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $a53f93f8f56ca877$export$fe2e36411d703b3d,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $a53f93f8f56ca877$export$fb184b623420d9be,
                                children: t("sign_in_exp.save_alert.after")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $32a6855022add01e$export$2e2bcd8739ae039), {
                                isAfter: true,
                                before: before,
                                after: after
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $a83ec76bfae3ea56$export$2e2bcd8739ae039 = $a83ec76bfae3ea56$var$SignUpAndSignInChangePreview;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $lSA0o = parcelRequire("lSA0o");

var $3MzPh = parcelRequire("3MzPh");
var $8a03fafceb181759$export$3aac624c619dfa7f;
var $8a03fafceb181759$export$34e0f9847d4c02dd;
var $8a03fafceb181759$export$a7db06668cad9adb;
var $8a03fafceb181759$export$611bd8dea7a0fee9;
var $8a03fafceb181759$export$a3bc9b8ed74fc;
var $8a03fafceb181759$export$6210fa4921d2a466;
var $8a03fafceb181759$export$48c2d0f2f545ac27;
var $8a03fafceb181759$export$bfd64c937657f93a;
var $8a03fafceb181759$export$4a6dd88bada4e7d2;
var $8a03fafceb181759$export$39f5674517ec0000;
var $8a03fafceb181759$export$1258c5dd981c51cf;
$8a03fafceb181759$export$3aac624c619dfa7f = `Wc-taa_cardTitle`;
$8a03fafceb181759$export$34e0f9847d4c02dd = `Wc-taa_container`;
$8a03fafceb181759$export$a7db06668cad9adb = `Wc-taa_content`;
$8a03fafceb181759$export$611bd8dea7a0fee9 = `Wc-taa_contentTop`;
$8a03fafceb181759$export$a3bc9b8ed74fc = `Wc-taa_error`;
$8a03fafceb181759$export$6210fa4921d2a466 = `Wc-taa_form`;
$8a03fafceb181759$export$48c2d0f2f545ac27 = `Wc-taa_preview`;
$8a03fafceb181759$export$bfd64c937657f93a = `Wc-taa_rotating`;
$8a03fafceb181759$export$4a6dd88bada4e7d2 = `Wc-taa_shimmer`;
$8a03fafceb181759$export$39f5674517ec0000 = `Wc-taa_tabs`;
$8a03fafceb181759$export$1258c5dd981c51cf = `Wc-taa_withSubmitActionBar`;


var $f290238de3ac773e$export$2ba01fb71ed41cb6;
var $f290238de3ac773e$export$aa3e815946b80764;
var $f290238de3ac773e$export$34e0f9847d4c02dd;
var $f290238de3ac773e$export$a7db06668cad9adb;
var $f290238de3ac773e$export$e0f35d825088c098;
var $f290238de3ac773e$export$38e42c68cf43b5d4;
var $f290238de3ac773e$export$a80b3bd66acc52ff;
var $f290238de3ac773e$export$db3c28d99448dcff;
var $f290238de3ac773e$export$1c4e7a9c31a6c071;
var $f290238de3ac773e$export$48c2d0f2f545ac27;
var $f290238de3ac773e$export$e5976431db92c0ff;
var $f290238de3ac773e$export$bfd64c937657f93a;
var $f290238de3ac773e$export$4a6dd88bada4e7d2;
var $f290238de3ac773e$export$f30f1338f6f15619;
var $f290238de3ac773e$export$cba3d3852a039325;
var $f290238de3ac773e$export$c96745152eb2740f;
var $f290238de3ac773e$export$1261a644c63cbc91;
var $f290238de3ac773e$export$fb184b623420d9be;
$f290238de3ac773e$export$2ba01fb71ed41cb6 = `H0j30G_button`;
$f290238de3ac773e$export$aa3e815946b80764 = `H0j30G_card`;
$f290238de3ac773e$export$34e0f9847d4c02dd = `H0j30G_container`;
$f290238de3ac773e$export$a7db06668cad9adb = `H0j30G_content`;
$f290238de3ac773e$export$e0f35d825088c098 = `H0j30G_field`;
$f290238de3ac773e$export$38e42c68cf43b5d4 = `H0j30G_header`;
$f290238de3ac773e$export$a80b3bd66acc52ff = `H0j30G_info`;
$f290238de3ac773e$export$db3c28d99448dcff = `H0j30G_logo`;
$f290238de3ac773e$export$1c4e7a9c31a6c071 = `H0j30G_mobile`;
$f290238de3ac773e$export$48c2d0f2f545ac27 = `H0j30G_preview`;
$f290238de3ac773e$export$e5976431db92c0ff = `H0j30G_previewContent`;
$f290238de3ac773e$export$bfd64c937657f93a = `H0j30G_rotating`;
$f290238de3ac773e$export$4a6dd88bada4e7d2 = `H0j30G_shimmer`;
$f290238de3ac773e$export$4a6dd88bada4e7d2;
$f290238de3ac773e$export$f30f1338f6f15619 = `H0j30G_slogan`;
$f290238de3ac773e$export$cba3d3852a039325 = `H0j30G_social`;
$f290238de3ac773e$export$c96745152eb2740f = `H0j30G_subtitle`;
$f290238de3ac773e$export$1261a644c63cbc91 = `H0j30G_tabBar`;
$f290238de3ac773e$export$fb184b623420d9be = `H0j30G_title`;


function $0da636e4b217f9e4$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8a03fafceb181759$export$34e0f9847d4c02dd, $f290238de3ac773e$export$34e0f9847d4c02dd),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                title: "sign_in_exp.title",
                subtitle: "sign_in_exp.description",
                className: $8a03fafceb181759$export$3aac624c619dfa7f
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8a03fafceb181759$export$39f5674517ec0000, $f290238de3ac773e$export$1261a644c63cbc91)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8a03fafceb181759$export$a7db06668cad9adb, $f290238de3ac773e$export$a7db06668cad9adb),
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $8a03fafceb181759$export$611bd8dea7a0fee9,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $8a03fafceb181759$export$6210fa4921d2a466,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $f290238de3ac773e$export$aa3e815946b80764,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$e0f35d825088c098
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$e0f35d825088c098
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $f290238de3ac773e$export$aa3e815946b80764,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$fb184b623420d9be
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$e0f35d825088c098
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                            className: $f290238de3ac773e$export$e0f35d825088c098
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $8a03fafceb181759$export$48c2d0f2f545ac27,
                            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $f290238de3ac773e$export$48c2d0f2f545ac27,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        className: $f290238de3ac773e$export$38e42c68cf43b5d4,
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                                className: $f290238de3ac773e$export$a80b3bd66acc52ff,
                                                children: [
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $f290238de3ac773e$export$fb184b623420d9be
                                                    }),
                                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                        className: $f290238de3ac773e$export$c96745152eb2740f
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $f290238de3ac773e$export$2ba01fb71ed41cb6
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                className: $f290238de3ac773e$export$2ba01fb71ed41cb6
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $f290238de3ac773e$export$e5976431db92c0ff,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $f290238de3ac773e$export$1c4e7a9c31a6c071,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$db3c28d99448dcff
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$f30f1338f6f15619
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$e0f35d825088c098
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$e0f35d825088c098
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$2ba01fb71ed41cb6
                                                }),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                                    className: $f290238de3ac773e$export$cba3d3852a039325
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
var $0da636e4b217f9e4$export$2e2bcd8739ae039 = $0da636e4b217f9e4$var$Skeleton;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $4b10eee18a8a6a95$var$SvgSignInExperienceWelcomeDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 16,
                fill: "#5B5F81"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 12,
                fill: "#47464E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24 152c0-8.837 7.163-16 16-16h96c8.837 0 16 7.163 16 16v4H24v-4Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 179a3 3 0 0 1 3-3h42a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 193a3 3 0 0 1 3-3h74a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 207a3 3 0 0 1 3-3h10a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3Z",
                fill: "#F7F8F8",
                fillOpacity: 0.12
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39,
                cy: 146,
                r: 3,
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 49,
                cy: 146,
                r: 3,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 59,
                cy: 146,
                r: 3,
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 85,
                y: 54,
                width: 86,
                height: 176,
                rx: 14,
                fill: "#C1B2EA",
                stroke: "#7958FF",
                strokeWidth: 4
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M91 72v135c0 8.284 6.716 15 15 15h4m55-153v25m0 78v-27.5",
                stroke: "#AA9BD9",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M110.5 56h36v2a6 6 0 0 1-6 6h-24a6 6 0 0 1-6-6v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 212,
                r: 8.125,
                stroke: "#F0EBFF",
                strokeWidth: 3.75
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                fill: "#5D34F2",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 118,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 132,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 146,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 160,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 174,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 188,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                stroke: "#CBBBF4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M192 232a39.855 39.855 0 0 0 11.5-1.678m-22.5-76.79A40.005 40.005 0 0 1 192 152c22.091 0 40 17.909 40 40a39.867 39.867 0 0 1-3.114 15.5 40.13 40.13 0 0 1-11.005 15 40.279 40.279 0 0 1-3.881 2.912M158.923 169.5A39.832 39.832 0 0 0 152 192c0 9.87 3.575 18.905 9.5 25.881a40.224 40.224 0 0 0 5.5 5.346",
                stroke: "#AF9EFF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                opacity: 0.2,
                cx: 192,
                cy: 192,
                r: 30,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h-30c0-16.569 13.431-30 30-30Z",
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h30c0 16.569-13.431 30-30 30Z",
                fill: "#BE9FF3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h30c0-16.569-13.431-30-30-30Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h-30c0 16.569 13.431 30 30 30Z",
                fill: "#FCCCF1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116,
                y: 76,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 83,
                r: 4,
                fill: "#F2CE41"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M122 92a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107,
                y: 144,
                width: 42,
                height: 4,
                rx: 2,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107,
                y: 152,
                width: 24,
                height: 4,
                rx: 2,
                fill: "#AF9FDB"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.359,
                y: 17.574,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(-40.65 111.359 17.574)",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 220.613,
                y: 89.517,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 220.613 89.517)",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.957 21.105c0-.057.046-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.861-1.652a.105.105 0 0 1 .143.038l.939 1.626a.105.105 0 0 1-.039.142l-2.861 1.652 2.861 1.652c.05.03.067.093.039.143l-.939 1.626a.105.105 0 0 1-.143.038l-2.861-1.652v3.304a.104.104 0 0 1-.104.105h-1.878a.104.104 0 0 1-.104-.105v-3.304l-2.862 1.652a.105.105 0 0 1-.143-.038l-.938-1.626a.104.104 0 0 1 .038-.142l2.861-1.653-2.861-1.652a.104.104 0 0 1-.038-.142l.938-1.626a.105.105 0 0 1 .143-.038l2.862 1.652v-3.305Z",
                fill: "#928F9A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m21.746 93.012.983 2.652a2.828 2.828 0 0 0 3.635 1.668v0A2.828 2.828 0 0 1 30 99.001v0a2.828 2.828 0 0 0 3.635 1.669v0a2.829 2.829 0 0 1 3.635 1.668l.983 2.652M205.424 72.459l2.828.033a2.83 2.83 0 0 0 2.862-2.795v0a2.828 2.828 0 0 1 2.861-2.795v0a2.83 2.83 0 0 0 2.862-2.795l.033-2.828",
                stroke: "#928F9A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m71.596 34.31.516-2.782a2.828 2.828 0 0 0-2.264-3.297v0a2.828 2.828 0 0 1-2.264-3.297v0a2.829 2.829 0 0 0-2.265-3.298l-2.78-.516",
                stroke: "#5C5F60",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
var $4b10eee18a8a6a95$export$2e2bcd8739ae039 = $4b10eee18a8a6a95$var$SvgSignInExperienceWelcomeDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $175d8e7777e7c2a5$var$SvgSignInExperienceWelcome = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 24,
                y: 136,
                width: 128,
                height: 96,
                rx: 12,
                fill: "#5D34F2",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24 148c0-6.627 5.373-12 12-12h104c6.627 0 12 5.373 12 12v4H24v-4Z",
                fill: "#AF9EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M40 179a3 3 0 0 1 3-3h42a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 193a3 3 0 0 1 3-3h74a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3ZM40 207a3 3 0 0 1 3-3h10a3 3 0 1 1 0 6H43a3 3 0 0 1-3-3Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39,
                cy: 144,
                r: 3,
                fill: "#FA9F94"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 49,
                cy: 144,
                r: 3,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 59,
                cy: 144,
                r: 3,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 85,
                y: 54,
                width: 86,
                height: 176,
                rx: 14,
                fill: "#CABEFF",
                stroke: "#7958FF",
                strokeWidth: 4
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M91 82v125c0 8.284 6.716 15 15 15h4m55-160v32m0 78v-27.5",
                stroke: "#CBBEF3",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M110.5 56h36v2a6 6 0 0 1-6 6h-24a6 6 0 0 1-6-6v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 212,
                r: 8.125,
                stroke: "#E6DEFF",
                strokeWidth: 3.75
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 118,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 132,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 146,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 160,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 174,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 188,
                y: 119,
                width: 8,
                height: 8,
                rx: 2,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 102.5,
                y: 110.5,
                width: 107,
                height: 25,
                rx: 7.5,
                fill: "#5D34F2",
                fillOpacity: 0.16,
                stroke: "#D4C4FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 116,
                y: 76,
                width: 24,
                height: 24,
                rx: 8,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 128,
                cy: 83,
                r: 4,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M122 92a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2v-2Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M192 232a39.855 39.855 0 0 0 11.5-1.678m-22.5-76.79A40.005 40.005 0 0 1 192 152c22.091 0 40 17.909 40 40a39.867 39.867 0 0 1-3.114 15.5 40.13 40.13 0 0 1-11.005 15 40.279 40.279 0 0 1-3.881 2.912M158.923 169.5A39.832 39.832 0 0 0 152 192c0 9.87 3.575 18.905 9.5 25.881a40.224 40.224 0 0 0 5.5 5.346",
                stroke: "#AF9EFF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                opacity: 0.2,
                cx: 192,
                cy: 192,
                r: 30,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h-30c0-16.569 13.431-30 30-30Z",
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h30c0 16.569-13.431 30-30 30Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 162v30h30c0-16.569-13.431-30-30-30Z",
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M192 222v-30h-30c0 16.569 13.431 30 30 30Z",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.359,
                y: 17.571,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(-40.65 111.359 17.571)",
                fill: "#E4E4E4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 220.613,
                y: 89.516,
                width: 8,
                height: 8,
                rx: 2,
                transform: "rotate(30.813 220.613 89.516)",
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M212.957 21.104c0-.057.047-.104.105-.104h1.877c.058 0 .104.047.104.104v3.305l2.862-1.652a.104.104 0 0 1 .142.038l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.652c.05.03.067.093.038.143l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.104.104 0 0 1-.104.105h-1.877a.105.105 0 0 1-.105-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.143l2.862-1.652-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.104.104 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m35.746 83.01.983 2.653a2.828 2.828 0 0 0 3.636 1.668v0A2.828 2.828 0 0 1 44 89.001v0a2.828 2.828 0 0 0 3.635 1.668v0a2.828 2.828 0 0 1 3.636 1.668l.983 2.652",
                stroke: "#E4E1E9",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m205.424 72.459 2.829.033a2.828 2.828 0 0 0 2.861-2.795v0a2.829 2.829 0 0 1 2.862-2.795v0a2.828 2.828 0 0 0 2.861-2.795l.033-2.828",
                stroke: "#C1AEF6",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m71.596 34.308.517-2.78a2.828 2.828 0 0 0-2.265-3.298v0a2.829 2.829 0 0 1-2.264-3.297v0a2.828 2.828 0 0 0-2.264-3.298l-2.781-.516",
                stroke: "#E5DFFD",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107,
                y: 144,
                width: 42,
                height: 6,
                rx: 3,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 107,
                y: 158,
                width: 24,
                height: 6,
                rx: 3,
                fill: "#947DFF"
            })
        ]
    });
var $175d8e7777e7c2a5$export$2e2bcd8739ae039 = $175d8e7777e7c2a5$var$SvgSignInExperienceWelcome;



var $kcPww = parcelRequire("kcPww");

var $93h5F = parcelRequire("93h5F");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $2mi28 = parcelRequire("2mi28");

var $iHViS = parcelRequire("iHViS");

var $kcPww = parcelRequire("kcPww");

var $lSA0o = parcelRequire("lSA0o");

var $9bgsA = parcelRequire("9bgsA");

var $9XAkT = parcelRequire("9XAkT");

var $3MzPh = parcelRequire("3MzPh");

var $2ANSb = parcelRequire("2ANSb");



var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");

var $eCoWV = parcelRequire("eCoWV");


const $6129f44a95ead627$var$usePreviewConfigs = (formData, isDirty, data, timeDelay = 400 // Render the preview after the user stops typing in the custom CSS editing box for two seconds.
)=>{
    const debounce = (0, $e92af1f6c236dce4$export$2e2bcd8739ae039)(timeDelay);
    const { customCss: customCss, ...restFormData } = formData;
    const [debouncedCustomCss, setDebouncedCustomCss] = (0, $eCoWV.useState)(customCss);
    (0, $eCoWV.useEffect)(()=>{
        debounce(()=>{
            setDebouncedCustomCss(customCss);
        });
    }, [
        debounce,
        customCss
    ]);
    return (0, $eCoWV.useMemo)(()=>{
        if (!isDirty) return data;
        return (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toRemoteModel({
            ...restFormData,
            customCss: debouncedCustomCss
        });
    }, [
        restFormData,
        debouncedCustomCss,
        isDirty,
        data
    ]);
};
var $6129f44a95ead627$export$2e2bcd8739ae039 = $6129f44a95ead627$var$usePreviewConfigs;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $hVcgO = parcelRequire("hVcgO");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $kcPww = parcelRequire("kcPww");

var $1UQTm = parcelRequire("1UQTm");


var $5Yzj4 = parcelRequire("5Yzj4");

var $dADBR = parcelRequire("dADBR");

var $5P1O9 = parcelRequire("5P1O9");

var $hdJkM = parcelRequire("hdJkM");



var $4ytKy = parcelRequire("4ytKy");
var $293be6a893027faa$export$63edcefea1e7341;
var $293be6a893027faa$export$3742d6e2000a7562;
var $293be6a893027faa$export$f71f035a831fd7a7;
var $293be6a893027faa$export$25d6b38b5bfe0b7;
var $293be6a893027faa$export$26f73335cc2e7868;
var $293be6a893027faa$export$aae056bdd709d7b3;
var $293be6a893027faa$export$a6ad74e382874e8b;
var $293be6a893027faa$export$bfd64c937657f93a;
var $293be6a893027faa$export$4ea6092c933ebdb5;
var $293be6a893027faa$export$95dd8163eacc2ed3;
var $293be6a893027faa$export$de27182ff8187d6c;
var $293be6a893027faa$export$4a6dd88bada4e7d2;
var $293be6a893027faa$export$56cec662996de3c;
var $293be6a893027faa$export$bda7fe321f6bbcf1;
var $293be6a893027faa$export$fb184b623420d9be;
$293be6a893027faa$export$63edcefea1e7341 = `j3eHoW_darkModeTip`;
$293be6a893027faa$export$3742d6e2000a7562 = `j3eHoW_defaultLanguageDescription`;
$293be6a893027faa$export$f71f035a831fd7a7 = `j3eHoW_formFieldDescription`;
$293be6a893027faa$export$25d6b38b5bfe0b7 = `j3eHoW_manageLanguageButton`;
$293be6a893027faa$export$26f73335cc2e7868 = `j3eHoW_method`;
$293be6a893027faa$export$aae056bdd709d7b3 = `j3eHoW_primarySocial`;
$293be6a893027faa$export$a6ad74e382874e8b = `j3eHoW_primaryTag`;
$293be6a893027faa$export$bfd64c937657f93a = `j3eHoW_rotating`;
$293be6a893027faa$export$4ea6092c933ebdb5 = `j3eHoW_selections`;
$293be6a893027faa$export$95dd8163eacc2ed3 = `j3eHoW_setUpHint`;
$293be6a893027faa$export$de27182ff8187d6c = `j3eHoW_setup`;
$293be6a893027faa$export$4a6dd88bada4e7d2 = `j3eHoW_shimmer`;
$293be6a893027faa$export$56cec662996de3c = `j3eHoW_socialOnlyDescription`;
$293be6a893027faa$export$bda7fe321f6bbcf1 = `j3eHoW_tabContent`;
$293be6a893027faa$export$fb184b623420d9be = `j3eHoW_title`;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $1e804e9a7d7e2dfa$export$34e0f9847d4c02dd;
var $1e804e9a7d7e2dfa$export$6d59db4903f20f7d;
var $1e804e9a7d7e2dfa$export$a3bc9b8ed74fc;
var $1e804e9a7d7e2dfa$export$2db776e97d65a417;
var $1e804e9a7d7e2dfa$export$8a0fd8301fa867af;
var $1e804e9a7d7e2dfa$export$bfd64c937657f93a;
var $1e804e9a7d7e2dfa$export$4a6dd88bada4e7d2;
var $1e804e9a7d7e2dfa$export$7472b0d4ff79ef04;
$1e804e9a7d7e2dfa$export$34e0f9847d4c02dd = `_Dgydq_container`;
$1e804e9a7d7e2dfa$export$6d59db4903f20f7d = `_Dgydq_description`;
$1e804e9a7d7e2dfa$export$a3bc9b8ed74fc = `_Dgydq_error`;
$1e804e9a7d7e2dfa$export$2db776e97d65a417 = `_Dgydq_faviconUploader`;
$1e804e9a7d7e2dfa$export$8a0fd8301fa867af = `_Dgydq_logoUploader`;
$1e804e9a7d7e2dfa$export$bfd64c937657f93a = `_Dgydq_rotating`;
$1e804e9a7d7e2dfa$export$4a6dd88bada4e7d2 = `_Dgydq_shimmer`;
$1e804e9a7d7e2dfa$export$7472b0d4ff79ef04 = `_Dgydq_uploader`;


function $c46917384881a1d7$var$LogoAndFaviconUploader() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [uploadLogoError, setUploadLogoError] = (0, $eCoWV.useState)();
    const [uploadFaviconError, setUploadFaviconError] = (0, $eCoWV.useState)();
    const { control: control } = (0, $c3LX9.useFormContext)();
    const { description: description } = (0, $953ca65e28ae2893$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $1e804e9a7d7e2dfa$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $1e804e9a7d7e2dfa$export$7472b0d4ff79ef04,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1e804e9a7d7e2dfa$export$8a0fd8301fa867af,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "branding.logoUrl",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e6f10e5b5e7a477$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.logo_image"),
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadLogoError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $1e804e9a7d7e2dfa$export$2db776e97d65a417,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: "branding.favicon",
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e6f10e5b5e7a477$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.favicon"),
                                    onCompleted: onChange,
                                    onUploadErrorChange: setUploadFaviconError,
                                    onDelete: ()=>{
                                        onChange("");
                                    }
                                })
                        })
                    })
                ]
            }),
            uploadLogoError && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($1e804e9a7d7e2dfa$export$6d59db4903f20f7d, $1e804e9a7d7e2dfa$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.logo_image_error", {
                    error: uploadLogoError
                })
            }),
            uploadFaviconError && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($1e804e9a7d7e2dfa$export$6d59db4903f20f7d, $1e804e9a7d7e2dfa$export$a3bc9b8ed74fc),
                children: t("sign_in_exp.branding.favicon_error", {
                    error: uploadFaviconError
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $1e804e9a7d7e2dfa$export$6d59db4903f20f7d,
                children: description
            })
        ]
    });
}
var $c46917384881a1d7$export$2e2bcd8739ae039 = $c46917384881a1d7$var$LogoAndFaviconUploader;


function $12099ba4c055dd87$var$BrandingForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { isReady: isUserAssetsServiceReady } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const { watch: watch, register: register, setValue: setValue, control: control, formState: { errors: errors, isDirty: isDirty } } = (0, $c3LX9.useFormContext)();
    const isDarkModeEnabled = watch("color.isDarkModeEnabled");
    const primaryColor = watch("color.primaryColor");
    const darkPrimaryColor = watch("color.darkPrimaryColor");
    const calculatedDarkPrimaryColor = (0, $eCoWV.useMemo)(()=>{
        return (0, $hVcgO.generateDarkColor)(primaryColor);
    }, [
        primaryColor
    ]);
    const handleResetColor = (0, $eCoWV.useCallback)(()=>{
        setValue("color.darkPrimaryColor", calculatedDarkPrimaryColor);
    }, [
        calculatedDarkPrimaryColor,
        setValue
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!isDirty) return;
        // If it's enabled, the original dark mode color won't change, users need to click "reset".
        if (!isDarkModeEnabled) handleResetColor();
    }, [
        handleResetColor,
        isDarkModeEnabled,
        isDirty
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.branding.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.color.primary_color",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                    name: "color.primaryColor",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3f4fc0ac65eef21$export$2e2bcd8739ae039), {
                            value: value,
                            onChange: onChange
                        })
                })
            }),
            isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $5Yzj4.default), {
                    children: [
                        t("sign_in_exp.branding.logo_image"),
                        " & ",
                        t("sign_in_exp.branding.favicon")
                    ]
                }),
                headlineSpacing: "large",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c46917384881a1d7$export$2e2bcd8739ae039), {})
            }) : /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "sign_in_exp.branding.logo_image_url",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("branding.logoUrl", {
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.logoUrl?.message,
                            placeholder: t("sign_in_exp.branding.logo_image_url_placeholder")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "sign_in_exp.branding.favicon",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("branding.favicon", {
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.favicon?.message,
                            placeholder: t("sign_in_exp.branding.favicon")
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.color.dark_mode",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                    label: t("sign_in_exp.color.dark_mode_description"),
                    ...register("color.isDarkModeEnabled")
                })
            }),
            isDarkModeEnabled && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        title: "sign_in_exp.color.dark_primary_color",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                name: "color.darkPrimaryColor",
                                control: control,
                                render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $d3f4fc0ac65eef21$export$2e2bcd8739ae039), {
                                        value: value,
                                        onChange: onChange
                                    })
                            }),
                            calculatedDarkPrimaryColor !== darkPrimaryColor && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $293be6a893027faa$export$63edcefea1e7341,
                                children: [
                                    t("sign_in_exp.color.dark_mode_reset_tip"),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                        type: "text",
                                        size: "small",
                                        title: "sign_in_exp.color.reset",
                                        onClick: handleResetColor
                                    })
                                ]
                            })
                        ]
                    }),
                    isUserAssetsServiceReady ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "sign_in_exp.branding.dark_logo_image",
                        headlineSpacing: "large",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            name: "branding.darkLogoUrl",
                            control: control,
                            render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $0186093e59e66ade$export$2e2bcd8739ae039), {
                                    name: name,
                                    value: value ?? "",
                                    actionDescription: t("sign_in_exp.branding.dark_logo_image"),
                                    onChange: onChange
                                })
                        })
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "sign_in_exp.branding.dark_logo_image_url",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                            ...register("branding.darkLogoUrl", {
                                validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                            }),
                            error: errors.branding?.darkLogoUrl?.message,
                            placeholder: t("sign_in_exp.branding.dark_logo_image_url_placeholder")
                        })
                    })
                ]
            })
        ]
    });
}
var $12099ba4c055dd87$export$2e2bcd8739ae039 = $12099ba4c055dd87$var$BrandingForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");


var $5P1O9 = parcelRequire("5P1O9");



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $kcPww = parcelRequire("kcPww");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $iHViS = parcelRequire("iHViS");

var $1UQTm = parcelRequire("1UQTm");

var $lSA0o = parcelRequire("lSA0o");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");



var $578b54c9c3cfa24a$exports = {};
"use strict";
var $578b54c9c3cfa24a$var$isMergeableObject = function isMergeableObject(value) {
    return $578b54c9c3cfa24a$var$isNonNullObject(value) && !$578b54c9c3cfa24a$var$isSpecial(value);
};
function $578b54c9c3cfa24a$var$isNonNullObject(value) {
    return !!value && typeof value === "object";
}
function $578b54c9c3cfa24a$var$isSpecial(value) {
    var stringValue = Object.prototype.toString.call(value);
    return stringValue === "[object RegExp]" || stringValue === "[object Date]" || $578b54c9c3cfa24a$var$isReactElement(value);
}
// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var $578b54c9c3cfa24a$var$canUseSymbol = typeof Symbol === "function" && Symbol.for;
var $578b54c9c3cfa24a$var$REACT_ELEMENT_TYPE = $578b54c9c3cfa24a$var$canUseSymbol ? Symbol.for("react.element") : 0xeac7;
function $578b54c9c3cfa24a$var$isReactElement(value) {
    return value.$$typeof === $578b54c9c3cfa24a$var$REACT_ELEMENT_TYPE;
}
function $578b54c9c3cfa24a$var$emptyTarget(val) {
    return Array.isArray(val) ? [] : {};
}
function $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified(value, options) {
    return options.clone !== false && options.isMergeableObject(value) ? $578b54c9c3cfa24a$var$deepmerge($578b54c9c3cfa24a$var$emptyTarget(value), value, options) : value;
}
function $578b54c9c3cfa24a$var$defaultArrayMerge(target, source, options) {
    return target.concat(source).map(function(element) {
        return $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified(element, options);
    });
}
function $578b54c9c3cfa24a$var$getMergeFunction(key, options) {
    if (!options.customMerge) return $578b54c9c3cfa24a$var$deepmerge;
    var customMerge = options.customMerge(key);
    return typeof customMerge === "function" ? customMerge : $578b54c9c3cfa24a$var$deepmerge;
}
function $578b54c9c3cfa24a$var$getEnumerableOwnPropertySymbols(target) {
    return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(target).filter(function(symbol) {
        return target.propertyIsEnumerable(symbol);
    }) : [];
}
function $578b54c9c3cfa24a$var$getKeys(target) {
    return Object.keys(target).concat($578b54c9c3cfa24a$var$getEnumerableOwnPropertySymbols(target));
}
function $578b54c9c3cfa24a$var$propertyIsOnObject(object, property) {
    try {
        return property in object;
    } catch (_) {
        return false;
    }
}
// Protects from prototype poisoning and unexpected merging up the prototype chain.
function $578b54c9c3cfa24a$var$propertyIsUnsafe(target, key) {
    return $578b54c9c3cfa24a$var$propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
     && !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
     && Object.propertyIsEnumerable.call(target, key) // and also unsafe if they're nonenumerable.
    );
}
function $578b54c9c3cfa24a$var$mergeObject(target, source, options) {
    var destination = {};
    if (options.isMergeableObject(target)) $578b54c9c3cfa24a$var$getKeys(target).forEach(function(key) {
        destination[key] = $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified(target[key], options);
    });
    $578b54c9c3cfa24a$var$getKeys(source).forEach(function(key) {
        if ($578b54c9c3cfa24a$var$propertyIsUnsafe(target, key)) return;
        if ($578b54c9c3cfa24a$var$propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) destination[key] = $578b54c9c3cfa24a$var$getMergeFunction(key, options)(target[key], source[key], options);
        else destination[key] = $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified(source[key], options);
    });
    return destination;
}
function $578b54c9c3cfa24a$var$deepmerge(target, source, options) {
    options = options || {};
    options.arrayMerge = options.arrayMerge || $578b54c9c3cfa24a$var$defaultArrayMerge;
    options.isMergeableObject = options.isMergeableObject || $578b54c9c3cfa24a$var$isMergeableObject;
    // cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
    // implementations can use it. The caller may not replace it.
    options.cloneUnlessOtherwiseSpecified = $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified;
    var sourceIsArray = Array.isArray(source);
    var targetIsArray = Array.isArray(target);
    var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;
    if (!sourceAndTargetTypesMatch) return $578b54c9c3cfa24a$var$cloneUnlessOtherwiseSpecified(source, options);
    else if (sourceIsArray) return options.arrayMerge(target, source, options);
    else return $578b54c9c3cfa24a$var$mergeObject(target, source, options);
}
$578b54c9c3cfa24a$var$deepmerge.all = function deepmergeAll(array, options) {
    if (!Array.isArray(array)) throw new Error("first argument should be an array");
    return array.reduce(function(prev, next) {
        return $578b54c9c3cfa24a$var$deepmerge(prev, next, options);
    }, {});
};
var $578b54c9c3cfa24a$var$deepmerge_1 = $578b54c9c3cfa24a$var$deepmerge;
$578b54c9c3cfa24a$exports = $578b54c9c3cfa24a$var$deepmerge_1;



var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");
var $4Korf = parcelRequire("4Korf");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $eb3f991f5f2ac444$var$SvgClear = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 16,
        height: 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M2.49 7.005a2 2 0 0 1 1.973-1.672h7.074a2 2 0 0 1 1.973 1.672l.889 5.333a2 2 0 0 1-1.973 2.329H3.574a2 2 0 0 1-1.973-2.33l.889-5.332Zm1.973-.338a.667.667 0 0 0-.658.557l-.889 5.333a.667.667 0 0 0 .658.776h8.852c.412 0 .725-.37.657-.776l-.889-5.333a.667.667 0 0 0-.657-.557H4.463Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6 3.333a2 2 0 1 1 4 0v2H8.667v-2a.667.667 0 0 0-1.334 0v2H6v-2Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M4 12a.667.667 0 0 1 1.333 0v1.334a.667.667 0 0 1-1.333 0V12ZM6.667 12A.667.667 0 1 1 8 12v1.333a.667.667 0 1 1-1.333 0V12Z",
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 2.667,
                y: 8,
                width: 10.667,
                height: 1.333,
                rx: 0.667,
                fill: "currentColor"
            })
        ]
    });
var $eb3f991f5f2ac444$export$2e2bcd8739ae039 = $eb3f991f5f2ac444$var$SvgClear;




var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");



parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");


const $a74e5cecdaac2ea2$export$3ce3630e4723edc4 = [
    "development_tenant"
];
const $a74e5cecdaac2ea2$export$c187cc910ee1951e = [];



const $7229c002fa3715f9$export$6284419e04300199 = (translation, keyPrefix = "")=>Object.keys(translation).reduce((result, key)=>{
        const prefix = keyPrefix ? `${keyPrefix}.` : keyPrefix;
        const unwrappedKey = `${prefix}${key}`;
        const unwrapped = translation[key];
        return unwrapped === undefined ? result : {
            ...result,
            ...typeof unwrapped === "string" ? {
                [unwrappedKey]: unwrapped
            } : $7229c002fa3715f9$export$6284419e04300199(unwrapped, unwrappedKey)
        };
    }, {});
const $7229c002fa3715f9$var$emptyTranslation = (translation)=>Object.entries(translation).reduce((result, [key, value])=>{
        return typeof value === "string" ? {
            ...result,
            [key]: ""
        } : {
            ...result,
            [key]: $7229c002fa3715f9$var$emptyTranslation(value)
        };
    }, {});
const $7229c002fa3715f9$export$9bb7f6e016453b9a = ()=>$7229c002fa3715f9$var$emptyTranslation((0, $569450392e7041f1$export$2e2bcd8739ae039).translation);



var $bSFEw = parcelRequire("bSFEw");
var $c0acd224aff9b9a7$export$52aab205873de00;
var $c0acd224aff9b9a7$export$de39a1795fbdd05e;
var $c0acd224aff9b9a7$export$34e0f9847d4c02dd;
var $c0acd224aff9b9a7$export$a7db06668cad9adb;
var $c0acd224aff9b9a7$export$c774a32f4013ebd1;
var $c0acd224aff9b9a7$export$adb608be33961c98;
var $c0acd224aff9b9a7$export$7c37e2db16dd3b00;
var $c0acd224aff9b9a7$export$c0aced386536f657;
var $c0acd224aff9b9a7$export$b975f624cdc70b60;
var $c0acd224aff9b9a7$export$bfd64c937657f93a;
var $c0acd224aff9b9a7$export$ab4de3b61da72174;
var $c0acd224aff9b9a7$export$db08678d9f357d0c;
var $c0acd224aff9b9a7$export$9ec472074ce7d308;
var $c0acd224aff9b9a7$export$1a952fe22cdce89e;
var $c0acd224aff9b9a7$export$4a6dd88bada4e7d2;
var $c0acd224aff9b9a7$export$e7d47881ec916f76;
var $c0acd224aff9b9a7$export$fb184b623420d9be;
$c0acd224aff9b9a7$export$52aab205873de00 = `T_3QJW_clearButton`;
$c0acd224aff9b9a7$export$de39a1795fbdd05e = `T_3QJW_clearIcon`;
$c0acd224aff9b9a7$export$34e0f9847d4c02dd = `T_3QJW_container`;
$c0acd224aff9b9a7$export$a7db06668cad9adb = `T_3QJW_content`;
$c0acd224aff9b9a7$export$c774a32f4013ebd1 = `T_3QJW_customValuesColumn`;
$c0acd224aff9b9a7$export$adb608be33961c98 = `T_3QJW_footer`;
$c0acd224aff9b9a7$export$7c37e2db16dd3b00 = `T_3QJW_inputCell`;
$c0acd224aff9b9a7$export$c0aced386536f657 = `T_3QJW_languageDetails`;
$c0acd224aff9b9a7$export$b975f624cdc70b60 = `T_3QJW_languageInfo`;
$c0acd224aff9b9a7$export$bfd64c937657f93a = `T_3QJW_rotating`;
$c0acd224aff9b9a7$export$ab4de3b61da72174 = `T_3QJW_sectionBuiltInText`;
$c0acd224aff9b9a7$export$db08678d9f357d0c = `T_3QJW_sectionDataKey`;
$c0acd224aff9b9a7$export$9ec472074ce7d308 = `T_3QJW_sectionInputArea`;
$c0acd224aff9b9a7$export$1a952fe22cdce89e = `T_3QJW_sectionTitle`;
$c0acd224aff9b9a7$export$4a6dd88bada4e7d2 = `T_3QJW_shimmer`;
$c0acd224aff9b9a7$export$e7d47881ec916f76 = `T_3QJW_tableWrapper`;
$c0acd224aff9b9a7$export$fb184b623420d9be = `T_3QJW_title`;


parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $eCoWV = parcelRequire("eCoWV");
const $d5469517e0f89cc8$export$af8e7b825b344e4f = (0, $eCoWV.createContext)({
    selectedLanguage: "en",
    preSelectedLanguage: undefined,
    preAddedLanguage: undefined,
    isDirty: false,
    confirmationState: "none",
    setSelectedLanguage: (0, $aWIy6.noop),
    setPreSelectedLanguage: (0, $aWIy6.noop),
    setPreAddedLanguage: (0, $aWIy6.noop),
    setIsDirty: (0, $aWIy6.noop),
    setConfirmationState: (0, $aWIy6.noop)
});
const $d5469517e0f89cc8$var$useLanguageEditorContext = ()=>{
    const [selectedLanguage, setSelectedLanguage] = (0, $eCoWV.useState)("en");
    const [preSelectedLanguage, setPreSelectedLanguage] = (0, $eCoWV.useState)();
    const [preAddedLanguage, setPreAddedLanguage] = (0, $eCoWV.useState)();
    const [isDirty, setIsDirty] = (0, $eCoWV.useState)(false);
    const [confirmationState, setConfirmationState] = (0, $eCoWV.useState)("none");
    const context = (0, $eCoWV.useMemo)(()=>({
            selectedLanguage: selectedLanguage,
            preSelectedLanguage: preSelectedLanguage,
            preAddedLanguage: preAddedLanguage,
            isDirty: isDirty,
            confirmationState: confirmationState,
            setSelectedLanguage: setSelectedLanguage,
            setPreSelectedLanguage: setPreSelectedLanguage,
            setPreAddedLanguage: setPreAddedLanguage,
            setIsDirty: setIsDirty,
            setConfirmationState: setConfirmationState
        }), [
        confirmationState,
        isDirty,
        preAddedLanguage,
        preSelectedLanguage,
        selectedLanguage
    ]);
    return {
        context: context,
        Provider: $d5469517e0f89cc8$export$af8e7b825b344e4f.Provider
    };
};
var $d5469517e0f89cc8$export$2e2bcd8739ae039 = $d5469517e0f89cc8$var$useLanguageEditorContext;


const $29fb0a6f3b660d29$var$emptyUiTranslation = (0, $7229c002fa3715f9$export$9bb7f6e016453b9a)();
function $29fb0a6f3b660d29$var$LanguageDetails() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: signInExperience } = (0, $2mi28.default)("api/sign-in-exp");
    const { languages: languages } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const { selectedLanguage: selectedLanguage, isDirty: isDirty, setIsDirty: setIsDirty, setSelectedLanguage: setSelectedLanguage } = (0, $eCoWV.useContext)((0, $d5469517e0f89cc8$export$af8e7b825b344e4f));
    const [isDeletionAlertOpen, setIsDeletionAlertOpen] = (0, $eCoWV.useState)(false);
    const isBuiltIn = (0, $4251288b56d63801$export$562f9b4f03c85f6c)(selectedLanguage);
    const isDefaultLanguage = signInExperience?.languageInfo.fallbackLanguage === selectedLanguage;
    const fetchApi = (0, $2ANSb.default)({
        hideErrorToast: true
    });
    const fetcher = (0, $9c44974c18641844$export$2e2bcd8739ae039)(fetchApi);
    const translationData = (0, $eCoWV.useMemo)(()=>Object.entries((isBuiltIn ? (0, $4251288b56d63801$export$2e2bcd8739ae039)[selectedLanguage] : (0, $569450392e7041f1$export$2e2bcd8739ae039)).translation).filter(// eslint-disable-next-line no-restricted-syntax
        ([groupKey])=>!(0, $a74e5cecdaac2ea2$export$3ce3630e4723edc4).includes(groupKey)).map(([groupKey, value])=>({
                key: groupKey,
                label: groupKey,
                labelClassName: $c0acd224aff9b9a7$export$1a952fe22cdce89e,
                data: Object.entries((0, $7229c002fa3715f9$export$6284419e04300199)(value)).filter(([phraseKey])=>// eslint-disable-next-line no-restricted-syntax
                    !(0, $a74e5cecdaac2ea2$export$c187cc910ee1951e).includes(`${groupKey}.${phraseKey}`)).map(([phraseKey, value])=>({
                        phraseKey: phraseKey,
                        sourceValue: value,
                        fieldKey: `${groupKey}.${phraseKey}`
                    }))
            })), [
        isBuiltIn,
        selectedLanguage
    ]);
    const { data: customPhrase, mutate: mutate } = (0, $2mi28.default)(`api/custom-phrases/${selectedLanguage}`, {
        fetcher: fetcher,
        shouldRetryOnError: (error)=>{
            if (error instanceof (0, $2ANSb.RequestError)) return error.status !== 404;
            return true;
        }
    });
    const defaultFormValues = (0, $eCoWV.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($578b54c9c3cfa24a$exports)))($29fb0a6f3b660d29$var$emptyUiTranslation, customPhrase?.translation ?? {}), [
        customPhrase
    ]);
    const { handleSubmit: handleSubmit, reset: reset, setValue: setValue, register: register, formState: { isSubmitting: isSubmitting, isDirty: isFormStateDirty, dirtyFields: dirtyFields } } = (0, $c3LX9.useForm)({
        defaultValues: defaultFormValues
    });
    (0, $eCoWV.useEffect)(()=>{
        /**
     * Note: This is a workaround for dirty state checking,
     * for the `isDirty` state does not work correctly when comparing form data with empty / undefined values.
     * Reference: https://github.com/react-hook-form/react-hook-form/issues/4740
     */ setIsDirty(isFormStateDirty && Object.keys(dirtyFields).length > 0);
    }, [
        /**
     * Note: `isDirty` is used to trigger this `useEffect`; for `dirtyFields` object only marks filed dirty at field level.
     * When `dirtyFields` is changed from `{keyA: false}` to `{keyA: true}`, this `useEffect` won't be triggered.
     */ isFormStateDirty,
        dirtyFields,
        setIsDirty
    ]);
    const { mutate: globalMutate } = (0, $4Korf.useSWRConfig)();
    const api = (0, $2ANSb.default)();
    const upsertCustomPhrase = (0, $eCoWV.useCallback)(async (languageTag, translation)=>{
        const updatedCustomPhrase = await api.put(`api/custom-phrases/${languageTag}`, {
            json: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($e8124284f538c6ba$exports)))(translation)
            }
        }).json();
        globalMutate("api/custom-phrases");
        return updatedCustomPhrase;
    }, [
        api,
        globalMutate
    ]);
    const onConfirmDeletion = (0, $eCoWV.useCallback)(async ()=>{
        setIsDeletionAlertOpen(false);
        if (isDefaultLanguage) return;
        await api.delete(`api/custom-phrases/${selectedLanguage}`);
        await globalMutate("api/custom-phrases");
        setIsDirty(false);
        setSelectedLanguage(languages.find((languageTag)=>languageTag !== selectedLanguage) ?? "en");
    }, [
        api,
        globalMutate,
        isDefaultLanguage,
        languages,
        selectedLanguage,
        setIsDirty,
        setSelectedLanguage
    ]);
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        const updatedCustomPhrase = await upsertCustomPhrase(selectedLanguage, formData);
        reset(updatedCustomPhrase.translation);
        mutate(updatedCustomPhrase);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    (0, $eCoWV.useEffect)(()=>{
        if (isDirty) return;
        reset(defaultFormValues);
    }, [
        /**
     * Note: trigger form reset when selectedLanguage changed,
     * for the `defaultValues` will not change when switching between languages with unavailable custom phrases.
     */ selectedLanguage,
        defaultFormValues,
        reset,
        isDirty
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $c0acd224aff9b9a7$export$c0aced386536f657,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c0acd224aff9b9a7$export$fb184b623420d9be,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $c0acd224aff9b9a7$export$b975f624cdc70b60,
                        children: [
                            (0, $3nY0n.languages)[selectedLanguage],
                            /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                children: selectedLanguage
                            }),
                            isBuiltIn && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                children: t("sign_in_exp.content.manage_language.logto_provided")
                            })
                        ]
                    }),
                    !isBuiltIn && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                        content: t("sign_in_exp.content.manage_language.deletion_tip"),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            onClick: ()=>{
                                setIsDeletionAlertOpen(true);
                            },
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $c0acd224aff9b9a7$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                        isRowHoverEffectDisabled: true,
                        className: $c0acd224aff9b9a7$export$a7db06668cad9adb,
                        headerTableClassName: $c0acd224aff9b9a7$export$e7d47881ec916f76,
                        bodyTableWrapperClassName: $c0acd224aff9b9a7$export$e7d47881ec916f76,
                        rowIndexKey: "phraseKey",
                        rowGroups: translationData,
                        columns: [
                            {
                                title: t("sign_in_exp.content.manage_language.key"),
                                dataIndex: "phraseKey",
                                render: ({ phraseKey: phraseKey })=>phraseKey,
                                className: $c0acd224aff9b9a7$export$db08678d9f357d0c
                            },
                            {
                                title: t("sign_in_exp.content.manage_language.logto_source_values"),
                                dataIndex: "sourceValue",
                                render: ({ sourceValue: sourceValue })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $c0acd224aff9b9a7$export$ab4de3b61da72174,
                                        children: sourceValue
                                    })
                            },
                            {
                                title: /*#__PURE__*/ (0, $9zeGj.jsxs)("span", {
                                    className: $c0acd224aff9b9a7$export$c774a32f4013ebd1,
                                    children: [
                                        t("sign_in_exp.content.manage_language.custom_values"),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                            anchorClassName: $c0acd224aff9b9a7$export$52aab205873de00,
                                            content: t("sign_in_exp.content.manage_language.clear_all_tip"),
                                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                                size: "small",
                                                onClick: ()=>{
                                                    for (const [key, value] of Object.entries((0, $7229c002fa3715f9$export$6284419e04300199)($29fb0a6f3b660d29$var$emptyUiTranslation)))setValue(key, value, {
                                                        shouldDirty: true
                                                    });
                                                },
                                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eb3f991f5f2ac444$export$2e2bcd8739ae039), {
                                                    className: $c0acd224aff9b9a7$export$de39a1795fbdd05e
                                                })
                                            })
                                        })
                                    ]
                                }),
                                dataIndex: "fieldKey",
                                render: ({ fieldKey: fieldKey })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $db7c365bf8c87e6c$export$2e2bcd8739ae039), {
                                        className: $c0acd224aff9b9a7$export$9ec472074ce7d308,
                                        ...register(fieldKey)
                                    }),
                                className: $c0acd224aff9b9a7$export$7c37e2db16dd3b00
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $c0acd224aff9b9a7$export$adb608be33961c98,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            isLoading: isSubmitting,
                            type: "primary",
                            title: "general.save",
                            onClick: async ()=>onSubmit()
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: isDeletionAlertOpen,
                title: isDefaultLanguage ? "sign_in_exp.content.manage_language.default_language_deletion_title" : "sign_in_exp.content.manage_language.deletion_title",
                confirmButtonText: isDefaultLanguage ? "general.got_it" : "general.delete",
                confirmButtonType: isDefaultLanguage ? "primary" : "danger",
                onCancel: ()=>{
                    setIsDeletionAlertOpen(false);
                },
                onConfirm: onConfirmDeletion,
                children: isDefaultLanguage ? t("sign_in_exp.content.manage_language.default_language_deletion_description", {
                    language: (0, $3nY0n.languages)[selectedLanguage]
                }) : t("sign_in_exp.content.manage_language.deletion_description")
            })
        ]
    });
}
var $29fb0a6f3b660d29$export$2e2bcd8739ae039 = $29fb0a6f3b660d29$var$LanguageDetails;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");
var $dMkQh = parcelRequire("dMkQh");

var $eCoWV = parcelRequire("eCoWV");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $kcPww = parcelRequire("kcPww");

var $d0Zvy = parcelRequire("d0Zvy");

var $hdJkM = parcelRequire("hdJkM");

var $6PcpQ = parcelRequire("6PcpQ");
var $ae7a5e84d9aeddcd$export$bb37e2b647b67cbf;
var $ae7a5e84d9aeddcd$export$ac9988d300f6ef8a;
var $ae7a5e84d9aeddcd$export$bd4558eab3154e95;
var $ae7a5e84d9aeddcd$export$7541d60b826a3a96;
var $ae7a5e84d9aeddcd$export$b7e3ae3d7c15e42e;
var $ae7a5e84d9aeddcd$export$77849bfc92d943c2;
var $ae7a5e84d9aeddcd$export$79c0f9d0f5163be1;
var $ae7a5e84d9aeddcd$export$ac0adb53061a7575;
var $ae7a5e84d9aeddcd$export$bfd64c937657f93a;
var $ae7a5e84d9aeddcd$export$4a6dd88bada4e7d2;
$ae7a5e84d9aeddcd$export$bb37e2b647b67cbf = `BNJxUG_addLanguageButton`;
$ae7a5e84d9aeddcd$export$ac9988d300f6ef8a = `BNJxUG_buttonIcon`;
$ae7a5e84d9aeddcd$export$bd4558eab3154e95 = `BNJxUG_dropDown`;
$ae7a5e84d9aeddcd$export$7541d60b826a3a96 = `BNJxUG_dropDownItem`;
$ae7a5e84d9aeddcd$export$b7e3ae3d7c15e42e = `BNJxUG_input`;
$ae7a5e84d9aeddcd$export$77849bfc92d943c2 = `BNJxUG_languageName`;
$ae7a5e84d9aeddcd$export$79c0f9d0f5163be1 = `BNJxUG_languageSelector`;
$ae7a5e84d9aeddcd$export$ac0adb53061a7575 = `BNJxUG_languageTag`;
$ae7a5e84d9aeddcd$export$bfd64c937657f93a = `BNJxUG_rotating`;
$ae7a5e84d9aeddcd$export$4a6dd88bada4e7d2 = `BNJxUG_shimmer`;


function $651b55ca7c1bd614$var$AddLanguageSelector({ options: options, onSelect: onSelect }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const selectorRef = (0, $eCoWV.useRef)(null);
    const searchInputRef = (0, $eCoWV.useRef)(null);
    const [isDropDownOpen, setIsDropDownOpen] = (0, $eCoWV.useState)(false);
    const [searchInputValue, setSearchInputValue] = (0, $eCoWV.useState)("");
    const filteredOptions = searchInputValue ? options.filter((languageTag)=>languageTag.toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase()) || (0, $3nY0n.languages)[languageTag].toLocaleLowerCase().includes(searchInputValue.toLocaleLowerCase())) : options;
    const clickOutsideHandler = ({ target: target })=>{
        if (target instanceof HTMLElement && !selectorRef.current?.contains(target)) {
            setIsDropDownOpen(false);
            setSearchInputValue("");
        }
    };
    (0, $eCoWV.useEffect)(()=>{
        if (isDropDownOpen) {
            searchInputRef.current?.focus();
            document.addEventListener("mousedown", clickOutsideHandler);
        } else document.removeEventListener("mousedown", clickOutsideHandler);
        return ()=>{
            if (isDropDownOpen) document.removeEventListener("mousedown", clickOutsideHandler);
        };
    }, [
        isDropDownOpen,
        searchInputRef
    ]);
    const handleSelect = (languageTag)=>{
        onSelect(languageTag);
        setIsDropDownOpen(false);
        setSearchInputValue("");
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: selectorRef,
        className: $ae7a5e84d9aeddcd$export$79c0f9d0f5163be1,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $ae7a5e84d9aeddcd$export$b7e3ae3d7c15e42e,
                children: isDropDownOpen ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ref: searchInputRef,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf4fb85417208454$export$2e2bcd8739ae039), {
                        className: $ae7a5e84d9aeddcd$export$ac9988d300f6ef8a
                    }),
                    placeholder: t("general.type_to_search"),
                    value: searchInputValue,
                    onChange: (event)=>{
                        setSearchInputValue(event.target.value);
                    }
                }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    className: $ae7a5e84d9aeddcd$export$bb37e2b647b67cbf,
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {
                        className: $ae7a5e84d9aeddcd$export$ac9988d300f6ef8a
                    }),
                    title: "sign_in_exp.content.manage_language.add_language",
                    type: "default",
                    size: "medium",
                    onClick: ()=>{
                        setIsDropDownOpen(true);
                    }
                })
            }),
            isDropDownOpen && filteredOptions.length > 0 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $ae7a5e84d9aeddcd$export$bd4558eab3154e95,
                children: filteredOptions.map((languageTag)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        role: "tab",
                        tabIndex: 0,
                        className: $ae7a5e84d9aeddcd$export$7541d60b826a3a96,
                        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(()=>{
                            handleSelect(languageTag);
                        }),
                        onClick: ()=>{
                            handleSelect(languageTag);
                        },
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $ae7a5e84d9aeddcd$export$77849bfc92d943c2,
                                children: (0, $3nY0n.languages)[languageTag]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $ae7a5e84d9aeddcd$export$ac0adb53061a7575,
                                children: languageTag
                            })
                        ]
                    }, languageTag))
            })
        ]
    });
}
var $651b55ca7c1bd614$export$2e2bcd8739ae039 = $651b55ca7c1bd614$var$AddLanguageSelector;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("66B2B");
var $3nY0n = parcelRequire("3nY0n");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $6PcpQ = parcelRequire("6PcpQ");
var $f74fad8c341de475$export$23a6eccff7614b43;
var $f74fad8c341de475$export$77849bfc92d943c2;
var $f74fad8c341de475$export$ac0adb53061a7575;
var $f74fad8c341de475$export$bfd64c937657f93a;
var $f74fad8c341de475$export$d90250155de6d7e7;
var $f74fad8c341de475$export$4a6dd88bada4e7d2;
$f74fad8c341de475$export$23a6eccff7614b43 = `V-NAoa_languageItem`;
$f74fad8c341de475$export$77849bfc92d943c2 = `V-NAoa_languageName`;
$f74fad8c341de475$export$ac0adb53061a7575 = `V-NAoa_languageTag`;
$f74fad8c341de475$export$bfd64c937657f93a = `V-NAoa_rotating`;
$f74fad8c341de475$export$d90250155de6d7e7 = `V-NAoa_selected`;
$f74fad8c341de475$export$4a6dd88bada4e7d2 = `V-NAoa_shimmer`;


function $939313f0ee8b3e2b$var$LanguageItem({ languageTag: languageTag, isSelected: isSelected, onClick: onClick }) {
    const itemRef = (0, $eCoWV.useRef)(null);
    (0, $eCoWV.useEffect)(()=>{
        if (isSelected) itemRef.current?.scrollIntoView({
            block: "nearest",
            behavior: "smooth"
        });
    }, [
        isSelected
    ]);
    const handleSelect = ()=>{
        if (isSelected) return;
        onClick();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        ref: itemRef,
        role: "tab",
        tabIndex: 0,
        "aria-selected": isSelected,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($f74fad8c341de475$export$23a6eccff7614b43, isSelected && $f74fad8c341de475$export$d90250155de6d7e7),
        onClick: handleSelect,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(handleSelect),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f74fad8c341de475$export$77849bfc92d943c2,
                children: (0, $3nY0n.languages)[languageTag]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $f74fad8c341de475$export$ac0adb53061a7575,
                children: languageTag
            })
        ]
    });
}
var $939313f0ee8b3e2b$export$2e2bcd8739ae039 = $939313f0ee8b3e2b$var$LanguageItem;


var $51210bb8058d66d9$export$97e05aa5bd0f5a81;
var $51210bb8058d66d9$export$ad0bd5ce9a315472;
var $51210bb8058d66d9$export$bfd64c937657f93a;
var $51210bb8058d66d9$export$4a6dd88bada4e7d2;
$51210bb8058d66d9$export$97e05aa5bd0f5a81 = `Bg1MHW_languageItemList`;
$51210bb8058d66d9$export$ad0bd5ce9a315472 = `Bg1MHW_languageNav`;
$51210bb8058d66d9$export$bfd64c937657f93a = `Bg1MHW_rotating`;
$51210bb8058d66d9$export$4a6dd88bada4e7d2 = `Bg1MHW_shimmer`;



function $68b621cc366dd888$var$LanguageNav() {
    const { languages: languages, addLanguage: addLanguage } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const { selectedLanguage: selectedLanguage, isDirty: isDirty, setConfirmationState: setConfirmationState, setSelectedLanguage: setSelectedLanguage, setPreSelectedLanguage: setPreSelectedLanguage, setPreAddedLanguage: setPreAddedLanguage } = (0, $eCoWV.useContext)((0, $d5469517e0f89cc8$export$af8e7b825b344e4f));
    const languageOptions = Object.keys((0, $3nY0n.languages)).filter((languageTag)=>(0, $dMkQh.isLanguageTag)(languageTag) && !languages.includes(languageTag));
    const onAddLanguage = async (languageTag)=>{
        if (isDirty) {
            setPreAddedLanguage(languageTag);
            setConfirmationState("try-add-language");
            return;
        }
        await addLanguage(languageTag);
        setSelectedLanguage(languageTag);
    };
    const onSwitchLanguage = (languageTag)=>{
        if (isDirty) {
            setPreSelectedLanguage(languageTag);
            setConfirmationState("try-switch-language");
            return;
        }
        setSelectedLanguage(languageTag);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $51210bb8058d66d9$export$ad0bd5ce9a315472,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $651b55ca7c1bd614$export$2e2bcd8739ae039), {
                options: languageOptions,
                onSelect: onAddLanguage
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $51210bb8058d66d9$export$97e05aa5bd0f5a81,
                children: languages.map((languageTag)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $939313f0ee8b3e2b$export$2e2bcd8739ae039), {
                        languageTag: languageTag,
                        isSelected: selectedLanguage === languageTag,
                        onClick: ()=>{
                            onSwitchLanguage(languageTag);
                        }
                    }, languageTag))
            })
        ]
    });
}
var $68b621cc366dd888$export$2e2bcd8739ae039 = $68b621cc366dd888$var$LanguageNav;


var $f8f722a52e5cf969$export$a7db06668cad9adb;
var $f8f722a52e5cf969$export$b5d042d2b680aed6;
var $f8f722a52e5cf969$export$38e42c68cf43b5d4;
var $f8f722a52e5cf969$export$add244bda2f9423c;
var $f8f722a52e5cf969$export$70c017da01953e13;
var $f8f722a52e5cf969$export$bfd64c937657f93a;
var $f8f722a52e5cf969$export$4a6dd88bada4e7d2;
$f8f722a52e5cf969$export$a7db06668cad9adb = `JineeW_content`;
$f8f722a52e5cf969$export$b5d042d2b680aed6 = `JineeW_editor`;
$f8f722a52e5cf969$export$38e42c68cf43b5d4 = `JineeW_header`;
$f8f722a52e5cf969$export$add244bda2f9423c = `JineeW_modalContent`;
$f8f722a52e5cf969$export$70c017da01953e13 = `JineeW_modalOverlay`;
$f8f722a52e5cf969$export$bfd64c937657f93a = `JineeW_rotating`;
$f8f722a52e5cf969$export$4a6dd88bada4e7d2 = `JineeW_shimmer`;



function $a84453b04ebdacea$var$LanguageEditorModal({ isOpen: isOpen, onClose: onClose }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { languages: languages, addLanguage: addLanguage } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const defaultSelectedLanguage = languages[0] ?? "en";
    const { preSelectedLanguage: preSelectedLanguage, preAddedLanguage: preAddedLanguage, isDirty: isDirty, confirmationState: confirmationState, setSelectedLanguage: setSelectedLanguage, setPreSelectedLanguage: setPreSelectedLanguage, setPreAddedLanguage: setPreAddedLanguage, setConfirmationState: setConfirmationState, setIsDirty: setIsDirty } = (0, $eCoWV.useContext)((0, $d5469517e0f89cc8$export$af8e7b825b344e4f));
    (0, $eCoWV.useEffect)(()=>{
        setSelectedLanguage(defaultSelectedLanguage);
    }, [
        defaultSelectedLanguage,
        setSelectedLanguage
    ]);
    const onCloseModal = ()=>{
        if (isDirty) {
            setConfirmationState("try-close");
            return;
        }
        onClose();
        setSelectedLanguage(languages[0] ?? "en");
    };
    const onConfirmUnsavedChanges = async ()=>{
        if (confirmationState === "try-close") onClose();
        if (confirmationState === "try-switch-language" && preSelectedLanguage) {
            setSelectedLanguage(preSelectedLanguage);
            setPreSelectedLanguage(undefined);
        }
        if (confirmationState === "try-add-language" && preAddedLanguage) {
            await addLanguage(preAddedLanguage);
            setSelectedLanguage(preAddedLanguage);
            setPreAddedLanguage(undefined);
        }
        setConfirmationState("none");
        setIsDirty(false);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $f8f722a52e5cf969$export$add244bda2f9423c,
        overlayClassName: $f8f722a52e5cf969$export$70c017da01953e13,
        onRequestClose: onCloseModal,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                className: $f8f722a52e5cf969$export$b5d042d2b680aed6,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $f8f722a52e5cf969$export$38e42c68cf43b5d4,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                                title: "sign_in_exp.content.manage_language.title",
                                subtitle: "sign_in_exp.content.manage_language.subtitle"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                onClick: onCloseModal,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $f8f722a52e5cf969$export$a7db06668cad9adb,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $68b621cc366dd888$export$2e2bcd8739ae039), {}),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $29fb0a6f3b660d29$export$2e2bcd8739ae039), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: confirmationState !== "none",
                cancelButtonText: "general.stay_on_page",
                confirmButtonText: "general.leave_page",
                onCancel: ()=>{
                    setConfirmationState("none");
                },
                onConfirm: onConfirmUnsavedChanges,
                children: t("sign_in_exp.content.manage_language.unsaved_description")
            })
        ]
    });
}
function $a84453b04ebdacea$var$LanguageEditor(props) {
    const { context: languageEditorContext, Provider: LanguageEditorContextProvider } = (0, $d5469517e0f89cc8$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)(LanguageEditorContextProvider, {
        value: languageEditorContext,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)($a84453b04ebdacea$var$LanguageEditorModal, {
            ...props
        })
    });
}
var $a84453b04ebdacea$export$2e2bcd8739ae039 = $a84453b04ebdacea$var$LanguageEditor;


function $6b0bf0d342d498c2$var$ManageLanguageButton({ className: className }) {
    const [isLanguageEditorOpen, setIsLanguageEditorOpen] = (0, $eCoWV.useState)(false);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "text",
                size: "small",
                title: "sign_in_exp.content.languages.manage_language",
                className: className,
                onClick: ()=>{
                    setIsLanguageEditorOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a84453b04ebdacea$export$2e2bcd8739ae039), {
                isOpen: isLanguageEditorOpen,
                onClose: ()=>{
                    setIsLanguageEditorOpen(false);
                }
            })
        ]
    });
}
var $6b0bf0d342d498c2$export$2e2bcd8739ae039 = $6b0bf0d342d498c2$var$ManageLanguageButton;


function $c7d2bbd7afdb99da$var$LanguagesForm({ isManageLanguageVisible: isManageLanguageVisible = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: signInExperience } = (0, $2mi28.default)("api/sign-in-exp");
    const { watch: watch, control: control, register: register, setValue: setValue } = (0, $c3LX9.useFormContext)();
    const isAutoDetect = watch("languageInfo.autoDetect");
    const selectedDefaultLanguage = watch("languageInfo.fallbackLanguage");
    const { languages: languages } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const languageOptions = (0, $eCoWV.useMemo)(()=>{
        return languages.map((languageTag)=>({
                value: languageTag,
                title: (0, $3nY0n.languages)[languageTag]
            }));
    }, [
        languages
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!languages.includes(selectedDefaultLanguage)) setValue("languageInfo.fallbackLanguage", signInExperience?.languageInfo.fallbackLanguage ?? "en");
    }, [
        languages,
        selectedDefaultLanguage,
        setValue,
        signInExperience
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.content.languages.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.content.languages.enable_auto_detect",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                        ...register("languageInfo.autoDetect"),
                        label: t("sign_in_exp.content.languages.description")
                    }),
                    isManageLanguageVisible && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6b0bf0d342d498c2$export$2e2bcd8739ae039), {
                        className: $293be6a893027faa$export$25d6b38b5bfe0b7
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.content.languages.default_language",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "languageInfo.fallbackLanguage",
                        control: control,
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                                value: value,
                                options: languageOptions,
                                onChange: onChange
                            })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$3742d6e2000a7562,
                        children: isAutoDetect ? t("sign_in_exp.content.languages.default_language_description_auto") : t("sign_in_exp.content.languages.default_language_description_fixed")
                    })
                ]
            })
        ]
    });
}
var $c7d2bbd7afdb99da$export$2e2bcd8739ae039 = $c7d2bbd7afdb99da$var$LanguagesForm;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $4ytKy = parcelRequire("4ytKy");

function $9304b5bcbef817ac$var$TermsForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.content.terms_of_use.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.content.terms_of_use.terms_of_use",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("termsOfUseUrl", {
                        validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    error: errors.termsOfUseUrl?.message,
                    placeholder: t("sign_in_exp.content.terms_of_use.terms_of_use_placeholder")
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.content.terms_of_use.privacy_policy",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("privacyPolicyUrl", {
                        validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    error: errors.termsOfUseUrl?.message,
                    placeholder: t("sign_in_exp.content.terms_of_use.privacy_policy_placeholder")
                })
            })
        ]
    });
}
var $9304b5bcbef817ac$export$2e2bcd8739ae039 = $9304b5bcbef817ac$var$TermsForm;




var $ae025def5e046b0a$export$64a53ecd158b85c4;
var $ae025def5e046b0a$export$34e0f9847d4c02dd;
var $ae025def5e046b0a$export$a7db06668cad9adb;
var $ae025def5e046b0a$export$adb608be33961c98;
var $ae025def5e046b0a$export$a65ca8467dbb209e;
var $ae025def5e046b0a$export$6210fa4921d2a466;
var $ae025def5e046b0a$export$38e42c68cf43b5d4;
var $ae025def5e046b0a$export$f22da7240b7add18;
var $ae025def5e046b0a$export$48c2d0f2f545ac27;
var $ae025def5e046b0a$export$95773baf22be5a8c;
var $ae025def5e046b0a$export$bfd64c937657f93a;
var $ae025def5e046b0a$export$3e523c77c1f23f8c;
var $ae025def5e046b0a$export$4a6dd88bada4e7d2;
$ae025def5e046b0a$export$64a53ecd158b85c4 = `ZLT1Wq_closeIcon`;
$ae025def5e046b0a$export$34e0f9847d4c02dd = `ZLT1Wq_container`;
$ae025def5e046b0a$export$a7db06668cad9adb = `ZLT1Wq_content`;
$ae025def5e046b0a$export$adb608be33961c98 = `ZLT1Wq_footer`;
$ae025def5e046b0a$export$a65ca8467dbb209e = `ZLT1Wq_footerContent`;
$ae025def5e046b0a$export$6210fa4921d2a466 = `ZLT1Wq_form`;
$ae025def5e046b0a$export$38e42c68cf43b5d4 = `ZLT1Wq_header`;
$ae025def5e046b0a$export$f22da7240b7add18 = `ZLT1Wq_main`;
$ae025def5e046b0a$export$48c2d0f2f545ac27 = `ZLT1Wq_preview`;
$ae025def5e046b0a$export$95773baf22be5a8c = `ZLT1Wq_reminder`;
$ae025def5e046b0a$export$bfd64c937657f93a = `ZLT1Wq_rotating`;
$ae025def5e046b0a$export$3e523c77c1f23f8c = `ZLT1Wq_separator`;
$ae025def5e046b0a$export$4a6dd88bada4e7d2 = `ZLT1Wq_shimmer`;


function $bbfd96f4fd56518c$var$GuideModal({ isOpen: isOpen, onClose: onClose }) {
    const { data: data } = (0, $2mi28.default)("api/sign-in-exp");
    const { data: preferences, update: updatePreferences } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const { updateConfigs: updateConfigs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const methods = (0, $c3LX9.useForm)();
    const { reset: reset, handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting, isDirty: isDirty }, watch: watch } = methods;
    const api = (0, $2ANSb.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const formData = watch();
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const previewConfigs = (0, $6129f44a95ead627$export$2e2bcd8739ae039)(formData, isDirty, data);
    (0, $eCoWV.useEffect)(()=>{
        if (data && !isDirty) reset((0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toLocalForm(data));
    }, [
        data,
        reset,
        isDirty
    ]);
    const onGotIt = async ()=>{
        await updatePreferences({
            experienceNoticeConfirmed: true
        });
    };
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (!data || isSubmitting) return;
        await Promise.all([
            api.patch("api/sign-in-exp", {
                json: (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toRemoteModel(formData)
            }),
            updateConfigs({
                signInExperienceCustomized: true
            })
        ]);
        onClose();
    }));
    const onSkip = async ()=>{
        setIsLoading(true);
        await updateConfigs({
            signInExperienceCustomized: true
        });
        setIsLoading(false);
        onClose();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.fullScreen,
        onRequestClose: onSkip,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $ae025def5e046b0a$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $ae025def5e046b0a$export$38e42c68cf43b5d4,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "large",
                            disabled: isLoading,
                            onClick: onSkip,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iHViS.default), {
                                className: $ae025def5e046b0a$export$64a53ecd158b85c4
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $ae025def5e046b0a$export$3e523c77c1f23f8c
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                            size: "small",
                            title: "sign_in_exp.title",
                            subtitle: "sign_in_exp.description"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            type: "text",
                            size: "small",
                            title: "general.skip",
                            isLoading: isLoading,
                            onClick: onSkip
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $ae025def5e046b0a$export$a7db06668cad9adb,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
                        ...methods,
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                            className: $ae025def5e046b0a$export$6210fa4921d2a466,
                            onSubmit: onSubmit,
                            children: [
                                !preferences.experienceNoticeConfirmed && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                                    action: "general.got_it",
                                    variant: "shadow",
                                    className: $ae025def5e046b0a$export$95773baf22be5a8c,
                                    onClick: onGotIt,
                                    children: t("sign_in_exp.welcome.apply_remind")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                    className: $ae025def5e046b0a$export$f22da7240b7add18,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            className: $ae025def5e046b0a$export$6210fa4921d2a466,
                                            children: [
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $12099ba4c055dd87$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9304b5bcbef817ac$export$2e2bcd8739ae039), {}),
                                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c7d2bbd7afdb99da$export$2e2bcd8739ae039), {})
                                            ]
                                        }),
                                        formData.id && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $99b6920b760e9cc1$export$2e2bcd8739ae039), {
                                            isLivePreviewEntryInvisible: true,
                                            signInExperience: previewConfigs,
                                            className: $ae025def5e046b0a$export$48c2d0f2f545ac27
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ae025def5e046b0a$export$adb608be33961c98,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $ae025def5e046b0a$export$a65ca8467dbb209e,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                            isLoading: isSubmitting,
                                            type: "primary",
                                            htmlType: "submit",
                                            title: "general.done"
                                        })
                                    })
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
}
var $bbfd96f4fd56518c$export$2e2bcd8739ae039 = $bbfd96f4fd56518c$var$GuideModal;


var $37678ebbfdd9f661$export$34e0f9847d4c02dd;
var $37678ebbfdd9f661$export$a7db06668cad9adb;
var $37678ebbfdd9f661$export$6d59db4903f20f7d;
var $37678ebbfdd9f661$export$1ca1ec8b29a4ce27;
var $37678ebbfdd9f661$export$bfd64c937657f93a;
var $37678ebbfdd9f661$export$4a6dd88bada4e7d2;
var $37678ebbfdd9f661$export$fb184b623420d9be;
var $37678ebbfdd9f661$export$cc74dcc53cfce4eb;
$37678ebbfdd9f661$export$34e0f9847d4c02dd = `vFdCpa_container`;
$37678ebbfdd9f661$export$a7db06668cad9adb = `vFdCpa_content`;
$37678ebbfdd9f661$export$6d59db4903f20f7d = `vFdCpa_description`;
$37678ebbfdd9f661$export$1ca1ec8b29a4ce27 = `vFdCpa_icon`;
$37678ebbfdd9f661$export$bfd64c937657f93a = `vFdCpa_rotating`;
$37678ebbfdd9f661$export$4a6dd88bada4e7d2 = `vFdCpa_shimmer`;
$37678ebbfdd9f661$export$fb184b623420d9be = `vFdCpa_title`;
$37678ebbfdd9f661$export$cc74dcc53cfce4eb = `vFdCpa_wrapper`;


function $61a914ef55cd168e$var$Welcome({ mutate: mutate }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isOpen, setIsOpen] = (0, $eCoWV.useState)(false);
    const theme = (0, $93h5F.default)();
    const WelcomeIcon = theme === (0, $bhvxB.Theme).Light ? (0, $175d8e7777e7c2a5$export$2e2bcd8739ae039) : (0, $4b10eee18a8a6a95$export$2e2bcd8739ae039);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $37678ebbfdd9f661$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $37678ebbfdd9f661$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)(WelcomeIcon, {
                        className: $37678ebbfdd9f661$export$1ca1ec8b29a4ce27
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $37678ebbfdd9f661$export$cc74dcc53cfce4eb,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $37678ebbfdd9f661$export$fb184b623420d9be,
                                children: t("sign_in_exp.welcome.title")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $37678ebbfdd9f661$export$6d59db4903f20f7d,
                                children: t("sign_in_exp.welcome.description")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                title: "sign_in_exp.welcome.get_started",
                                type: "primary",
                                onClick: ()=>{
                                    setIsOpen(true);
                                }
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bbfd96f4fd56518c$export$2e2bcd8739ae039), {
                isOpen: isOpen,
                onClose: ()=>{
                    setIsOpen(false);
                    mutate();
                }
            })
        ]
    });
}
var $61a914ef55cd168e$export$2e2bcd8739ae039 = $61a914ef55cd168e$var$Welcome;





var $9zeGj = parcelRequire("9zeGj");

var $a0Ubj = parcelRequire("a0Ubj");




var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $1UQTm = parcelRequire("1UQTm");

var $5irU4 = parcelRequire("5irU4");

var $dADBR = parcelRequire("dADBR");

var $1Iq4D = parcelRequire("1Iq4D");


var $dee59a96a0bc5fc7$export$9652dd019aefa3a6;
$dee59a96a0bc5fc7$export$9652dd019aefa3a6 = `_6qORba_customCssCodeEditor`;


function $95c62ea90e3bf960$var$CustomCssForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { control: control } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.custom_css.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.custom_css.css_code_editor_title",
                tip: (closeTipHandler)=>/*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                children: t("sign_in_exp.custom_css.css_code_editor_description1")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                            targetBlank: "noopener",
                                            href: getDocumentationUrl("/docs/recipes/customize-sie/custom-css"),
                                            onClick: closeTipHandler
                                        })
                                    },
                                    children: t("sign_in_exp.custom_css.css_code_editor_description2", {
                                        link: t("sign_in_exp.custom_css.css_code_editor_description_link_content")
                                    })
                                })
                            })
                        ]
                    }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                    name: "customCss",
                    control: control,
                    render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                            className: $dee59a96a0bc5fc7$export$9652dd019aefa3a6,
                            language: "scss",
                            value: value ?? undefined,
                            placeholder: t("sign_in_exp.custom_css.css_code_editor_content_placeholder"),
                            onChange: onChange
                        })
                })
            })
        ]
    });
}
var $95c62ea90e3bf960$export$2e2bcd8739ae039 = $95c62ea90e3bf960$var$CustomCssForm;


function $e010426c7577b87a$var$Branding({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
        isActive: isActive,
        className: $293be6a893027faa$export$bda7fe321f6bbcf1,
        children: [
            isActive && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "sign_in_exp.tabs.branding",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $12099ba4c055dd87$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $95c62ea90e3bf960$export$2e2bcd8739ae039), {})
        ]
    });
}
var $e010426c7577b87a$export$2e2bcd8739ae039 = $e010426c7577b87a$var$Branding;



var $9zeGj = parcelRequire("9zeGj");

var $a0Ubj = parcelRequire("a0Ubj");




function $26083010a6b99c78$var$Content({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
        isActive: isActive,
        className: $293be6a893027faa$export$bda7fe321f6bbcf1,
        children: [
            isActive && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "sign_in_exp.tabs.content",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9304b5bcbef817ac$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c7d2bbd7afdb99da$export$2e2bcd8739ae039), {
                isManageLanguageVisible: true
            })
        ]
    });
}
var $26083010a6b99c78$export$2e2bcd8739ae039 = $26083010a6b99c78$var$Content;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $311RW = parcelRequire("311RW");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $a0Ubj = parcelRequire("a0Ubj");

var $1UQTm = parcelRequire("1UQTm");


var $dADBR = parcelRequire("dADBR");



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");



var $6PcpQ = parcelRequire("6PcpQ");
var $41293acfd0f2fce5$export$2ba01fb71ed41cb6;
var $41293acfd0f2fce5$export$34e0f9847d4c02dd;
var $41293acfd0f2fce5$export$683472f6198a076e;
var $41293acfd0f2fce5$export$5df884bdba3ad6a1;
var $41293acfd0f2fce5$export$bfd64c937657f93a;
var $41293acfd0f2fce5$export$4a6dd88bada4e7d2;
var $41293acfd0f2fce5$export$e1f445cd6eeea85e;
$41293acfd0f2fce5$export$2ba01fb71ed41cb6 = `U6WLiq_button`;
$41293acfd0f2fce5$export$34e0f9847d4c02dd = `U6WLiq_container`;
$41293acfd0f2fce5$export$683472f6198a076e = `U6WLiq_disabled`;
$41293acfd0f2fce5$export$5df884bdba3ad6a1 = `U6WLiq_down`;
$41293acfd0f2fce5$export$bfd64c937657f93a = `U6WLiq_rotating`;
$41293acfd0f2fce5$export$4a6dd88bada4e7d2 = `U6WLiq_shimmer`;
$41293acfd0f2fce5$export$e1f445cd6eeea85e = `U6WLiq_up`;



var $hdJkM = parcelRequire("hdJkM");
function $fe05704dec3fb7b6$var$Button({ className: className, onTrigger: onTrigger, children: children, isDisabled: isDisabled }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        role: "button",
        tabIndex: 0,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($41293acfd0f2fce5$export$2ba01fb71ed41cb6, isDisabled && $41293acfd0f2fce5$export$683472f6198a076e, className),
        "aria-disabled": isDisabled,
        onKeyDown: (0, $6PcpQ.onKeyDownHandler)(onTrigger),
        onClick: (event)=>{
            event.preventDefault();
            if (isDisabled) return;
            onTrigger?.(event);
        },
        children: children
    });
}
/** A numeric text input with up and down buttons for incrementing and decrementing the value. */ function $fe05704dec3fb7b6$var$NumericInput({ onValueUp: onValueUp, onValueDown: onValueDown, ...props }) {
    const isDisabled = Boolean(props.disabled) || Boolean(props.readOnly);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
        ...props,
        alwaysShowSuffix: true,
        type: "number",
        suffix: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $41293acfd0f2fce5$export$34e0f9847d4c02dd,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)($fe05704dec3fb7b6$var$Button, {
                    className: $41293acfd0f2fce5$export$e1f445cd6eeea85e,
                    isDisabled: isDisabled || props.value !== undefined && props.max !== undefined && Number(props.value) >= Number(props.max),
                    onTrigger: onValueUp,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $df1565e9aadd56da$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)($fe05704dec3fb7b6$var$Button, {
                    className: $41293acfd0f2fce5$export$5df884bdba3ad6a1,
                    isDisabled: isDisabled || props.value !== undefined && props.min !== undefined && Number(props.value) <= Number(props.min),
                    onTrigger: onValueDown,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a35329775620cc91$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $fe05704dec3fb7b6$export$2e2bcd8739ae039 = $fe05704dec3fb7b6$var$NumericInput;



var $1Iq4D = parcelRequire("1Iq4D");


var $e5f5b93df90cb8a1$export$3dc8b34440fdaec5;
var $e5f5b93df90cb8a1$export$6d59db4903f20f7d;
var $e5f5b93df90cb8a1$export$1237798dc640739a;
var $e5f5b93df90cb8a1$export$8fe860a115a1e636;
var $e5f5b93df90cb8a1$export$a84c34a1d06a6ca3;
var $e5f5b93df90cb8a1$export$bfd64c937657f93a;
var $e5f5b93df90cb8a1$export$4a6dd88bada4e7d2;
var $e5f5b93df90cb8a1$export$a3574df893ffa88d;
var $e5f5b93df90cb8a1$export$fb184b623420d9be;
$e5f5b93df90cb8a1$export$3dc8b34440fdaec5 = `_2F7FZa_characterTypes`;
$e5f5b93df90cb8a1$export$6d59db4903f20f7d = `_2F7FZa_description`;
$e5f5b93df90cb8a1$export$1237798dc640739a = `_2F7FZa_label`;
$e5f5b93df90cb8a1$export$8fe860a115a1e636 = `_2F7FZa_minLength`;
$e5f5b93df90cb8a1$export$a84c34a1d06a6ca3 = `_2F7FZa_passwordOption`;
$e5f5b93df90cb8a1$export$bfd64c937657f93a = `_2F7FZa_rotating`;
$e5f5b93df90cb8a1$export$4a6dd88bada4e7d2 = `_2F7FZa_shimmer`;
$e5f5b93df90cb8a1$export$a3574df893ffa88d = `_2F7FZa_textarea`;
$e5f5b93df90cb8a1$export$fb184b623420d9be = `_2F7FZa_title`;


/** A display component for password policy options with a title and description. */ function $2e5fc26e7177da38$var$PasswordOption({ name: name, title: title, description: description, children: children }) {
    const { control: control } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
        name: name,
        control: control,
        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                className: $e5f5b93df90cb8a1$export$a84c34a1d06a6ca3,
                label: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $e5f5b93df90cb8a1$export$1237798dc640739a,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $e5f5b93df90cb8a1$export$fb184b623420d9be,
                            children: title
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $e5f5b93df90cb8a1$export$6d59db4903f20f7d,
                            children: description
                        }),
                        children
                    ]
                }),
                checked: Boolean(value),
                onChange: onChange
            })
    });
}
function $2e5fc26e7177da38$var$PasswordPolicy({ isActive: isActive }) {
    const { control: control, register: register, getValues: getValues, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    const max = getValues("passwordPolicy.length.max");
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.sign_in_exp.password_policy"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
        isActive: isActive,
        className: $293be6a893027faa$export$bda7fe321f6bbcf1,
        children: [
            isActive && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "sign_in_exp.tabs.password_policy",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$fb184b623420d9be,
                        children: t("password_requirements")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        title: "sign_in_exp.password_policy.minimum_length",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $293be6a893027faa$export$f71f035a831fd7a7,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                    components: {
                                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                                            targetBlank: true,
                                            href: "https://pages.nist.gov/800-63-3/sp800-63b.html#sec5"
                                        })
                                    },
                                    children: t("minimum_length_description")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                name: "passwordPolicy.length.min",
                                control: control,
                                rules: {
                                    min: 1,
                                    max: max
                                },
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fe05704dec3fb7b6$export$2e2bcd8739ae039), {
                                        className: $e5f5b93df90cb8a1$export$8fe860a115a1e636,
                                        name: name,
                                        value: String(value),
                                        min: 1,
                                        max: max,
                                        error: errors.passwordPolicy?.length?.min && t("minimum_length_error", {
                                            min: 1,
                                            max: max
                                        }),
                                        onChange: ({ target: { value: value } })=>{
                                            onChange(value && Number(value));
                                        },
                                        onValueUp: ()=>{
                                            onChange(value + 1);
                                        },
                                        onValueDown: ()=>{
                                            onChange(value - 1);
                                        },
                                        onBlur: ()=>{
                                            if (value < 1) onChange(1);
                                            else if (value > max) onChange(max);
                                        }
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        title: "sign_in_exp.password_policy.minimum_required_char_types",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $293be6a893027faa$export$f71f035a831fd7a7,
                                children: t("minimum_required_char_types_description", {
                                    symbols: (0, $311RW.PasswordPolicyChecker).symbols
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                name: "passwordPolicy.characterTypes.min",
                                control: control,
                                render: ({ field: { onChange: onChange, value: value, name: name } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $b900c904fd017e6e$export$2e2bcd8739ae039), {
                                        name: name,
                                        className: $e5f5b93df90cb8a1$export$3dc8b34440fdaec5,
                                        value: (0, $5CQIb.cond)(value && String(value)),
                                        onChange: (value)=>{
                                            onChange(Number(value));
                                        },
                                        children: [
                                            1,
                                            2,
                                            3,
                                            4
                                        ].map((i)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d902807ff7d72f9$export$2e2bcd8739ae039), {
                                                title: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                    children: i
                                                }),
                                                value: String(i)
                                            }, i))
                                    })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$fb184b623420d9be,
                        children: t("password_rejection")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "sign_in_exp.password_policy.compromised_passwords",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)($2e5fc26e7177da38$var$PasswordOption, {
                            name: "passwordPolicy.rejects.pwned",
                            title: t("breached_passwords"),
                            description: t("breached_passwords_description")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                        title: "sign_in_exp.password_policy.restricted_phrases",
                        tip: t("restricted_phrases_tooltip"),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)($2e5fc26e7177da38$var$PasswordOption, {
                                name: "passwordPolicy.rejects.repetitionAndSequence",
                                title: t("repetitive_or_sequential_characters"),
                                description: t("repetitive_or_sequential_characters_description")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)($2e5fc26e7177da38$var$PasswordOption, {
                                name: "passwordPolicy.rejects.userInfo",
                                title: t("user_information"),
                                description: t("user_information_description")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)($2e5fc26e7177da38$var$PasswordOption, {
                                name: "passwordPolicy.isCustomWordsEnabled",
                                title: t("custom_words"),
                                description: t("custom_words_description")
                            }),
                            getValues("passwordPolicy.isCustomWordsEnabled") && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $db7c365bf8c87e6c$export$2e2bcd8739ae039), {
                                className: $e5f5b93df90cb8a1$export$a3574df893ffa88d,
                                rows: 5,
                                placeholder: t("custom_words_placeholder"),
                                ...register("passwordPolicy.customWords")
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $2e5fc26e7177da38$export$2e2bcd8739ae039 = $2e5fc26e7177da38$var$PasswordPolicy;



var $9zeGj = parcelRequire("9zeGj");

var $a0Ubj = parcelRequire("a0Ubj");



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");

var $5P1O9 = parcelRequire("5P1O9");

var $1Iq4D = parcelRequire("1Iq4D");

function $ca7a9eeae81e0a88$var$AdvancedOptions() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.sign_in_exp.sign_up_and_sign_in.advanced_options"
    });
    const { register: register } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.advanced_options.enable_single_sign_on",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                    ...register("singleSignOnEnabled"),
                    label: t("enable_single_sign_on_description")
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $293be6a893027faa$export$95dd8163eacc2ed3,
                children: [
                    t("single_sign_on_hint.prefix"),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        to: "/enterprise-sso",
                        className: $293be6a893027faa$export$de27182ff8187d6c,
                        children: t("single_sign_on_hint.link")
                    }),
                    t("single_sign_on_hint.suffix")
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.advanced_options.enable_user_registration",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5P1O9.default), {
                    ...register("createAccountEnabled"),
                    label: t("enable_user_registration_description")
                })
            })
        ]
    });
}
var $ca7a9eeae81e0a88$export$2e2bcd8739ae039 = $ca7a9eeae81e0a88$var$AdvancedOptions;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $9zeGj = parcelRequire("9zeGj");

var $cAQCs = parcelRequire("cAQCs");
function $28766d0dac808940$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $28766d0dac808940$export$2e2bcd8739ae039(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $28766d0dac808940$var$ownKeys(Object(source), !0).forEach(function(key) {
            (0, $cAQCs.default)(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $28766d0dac808940$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $93965a8764a89981$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + "use the non-minified dev environment for full errors. ";
}
// Inlined version of the `symbol-observable` polyfill
var $93965a8764a89981$var$$$observable = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $93965a8764a89981$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split("").join(".");
};
var $93965a8764a89981$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $93965a8764a89981$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $93965a8764a89981$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $93965a8764a89981$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $93965a8764a89981$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $93965a8764a89981$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    var type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($93965a8764a89981$var$isDate(val)) return "date";
    if ($93965a8764a89981$var$isError(val)) return "error";
    var constructorName = $93965a8764a89981$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $93965a8764a89981$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $93965a8764a89981$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $93965a8764a89981$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $93965a8764a89981$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * Creates a Redux store that holds the state tree.
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ function $93965a8764a89981$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($93965a8764a89981$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($93965a8764a89981$var$formatProdErrorMessage(1));
        return enhancer($93965a8764a89981$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== "function") throw new Error($93965a8764a89981$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($93965a8764a89981$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($93965a8764a89981$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($93965a8764a89981$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($93965a8764a89981$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$93965a8764a89981$var$isPlainObject(action)) throw new Error($93965a8764a89981$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($93965a8764a89981$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($93965a8764a89981$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($93965a8764a89981$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $93965a8764a89981$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($93965a8764a89981$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$93965a8764a89981$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $93965a8764a89981$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$93965a8764a89981$var$$$observable] = observable, _ref2;
}
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $93965a8764a89981$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $93965a8764a89981$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $93965a8764a89981$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$93965a8764a89981$var$isPlainObject(inputState)) return "The " + argumentName + ' has unexpected type of "' + $93965a8764a89981$var$kindOf(inputState) + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $93965a8764a89981$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? "keys" : "key") + " " + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
}
function $93965a8764a89981$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $93965a8764a89981$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($93965a8764a89981$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $93965a8764a89981$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($93965a8764a89981$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $93965a8764a89981$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $93965a8764a89981$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                var actionType = action && action.type;
                throw new Error($93965a8764a89981$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $93965a8764a89981$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $93965a8764a89981$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $93965a8764a89981$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($93965a8764a89981$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $93965a8764a89981$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $93965a8764a89981$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $93965a8764a89981$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($93965a8764a89981$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $93965a8764a89981$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $28766d0dac808940$export$2e2bcd8739ae039)((0, $28766d0dac808940$export$2e2bcd8739ae039)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}
/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */ function $93965a8764a89981$var$isCrushed() {}


/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ 
var $f9dfJ = parcelRequire("f9dfJ");
function $98d484686087a39e$export$f5708dca728d7177(condition, format, ...args) {
    if ($98d484686087a39e$var$isProduction()) {
        if (format === undefined) throw new Error("invariant requires an error message argument");
    }
    if (!condition) {
        let error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            let argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1 // we don't care about invariant's own frame
        ;
        throw error;
    }
}
function $98d484686087a39e$var$isProduction() {
    return typeof $f9dfJ !== "undefined" && true;
}


// cheap lodash replacements
/**
 * drop-in replacement for _.get
 * @param obj
 * @param path
 * @param defaultValue
 */ function $f02ae19c8e7d80b8$export$3988ae62b71be9a3(obj, path, defaultValue) {
    return path.split(".").reduce((a, c)=>a && a[c] ? a[c] : defaultValue || null, obj);
}
function $f02ae19c8e7d80b8$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $f02ae19c8e7d80b8$export$844ec244b1367d54(input) {
    return typeof input === "string";
}
function $f02ae19c8e7d80b8$export$a6cdc56e425d0d0a(input) {
    return typeof input === "object";
}
function $f02ae19c8e7d80b8$export$6444ef5cd411280c(itemsA, itemsB) {
    const map = new Map();
    const insertItem = (item)=>{
        map.set(item, map.has(item) ? map.get(item) + 1 : 1);
    };
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    map.forEach((count, key)=>{
        if (count === 1) result.push(key);
    });
    return result;
}
function $f02ae19c8e7d80b8$export$bc86dfbf7795668c(itemsA, itemsB) {
    return itemsA.filter((t)=>itemsB.indexOf(t) > -1);
}


const $f9f7209b2e6f62ed$export$3fc3a33e48b33945 = "dnd-core/INIT_COORDS";
const $f9f7209b2e6f62ed$export$98f9b4193e6b55e6 = "dnd-core/BEGIN_DRAG";
const $f9f7209b2e6f62ed$export$22d1d88e2de0d0e0 = "dnd-core/PUBLISH_DRAG_SOURCE";
const $f9f7209b2e6f62ed$export$9d358706ccac3727 = "dnd-core/HOVER";
const $f9f7209b2e6f62ed$export$b4af72c40fd57063 = "dnd-core/DROP";
const $f9f7209b2e6f62ed$export$d300627d16aeb9cc = "dnd-core/END_DRAG";


function $0cfa7bec4916b97d$export$844048139dfc906d(clientOffset, sourceClientOffset) {
    return {
        type: (0, $f9f7209b2e6f62ed$export$3fc3a33e48b33945),
        payload: {
            sourceClientOffset: sourceClientOffset || null,
            clientOffset: clientOffset || null
        }
    };
}



const $3fabecb7493132a8$var$ResetCoordinatesAction = {
    type: (0, $f9f7209b2e6f62ed$export$3fc3a33e48b33945),
    payload: {
        clientOffset: null,
        sourceClientOffset: null
    }
};
function $3fabecb7493132a8$export$d6542eb0d76867d6(manager) {
    return function beginDrag(sourceIds = [], options = {
        publishSource: true
    }) {
        const { publishSource: publishSource = true, clientOffset: clientOffset, getSourceClientOffset: getSourceClientOffset } = options;
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        // Initialize the coordinates using the client offset
        manager.dispatch((0, $0cfa7bec4916b97d$export$844048139dfc906d)(clientOffset));
        $3fabecb7493132a8$var$verifyInvariants(sourceIds, monitor, registry);
        // Get the draggable source
        const sourceId = $3fabecb7493132a8$var$getDraggableSource(sourceIds, monitor);
        if (sourceId == null) {
            manager.dispatch($3fabecb7493132a8$var$ResetCoordinatesAction);
            return;
        }
        // Get the source client offset
        let sourceClientOffset = null;
        if (clientOffset) {
            if (!getSourceClientOffset) throw new Error("getSourceClientOffset must be defined");
            $3fabecb7493132a8$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset);
            sourceClientOffset = getSourceClientOffset(sourceId);
        }
        // Initialize the full coordinates
        manager.dispatch((0, $0cfa7bec4916b97d$export$844048139dfc906d)(clientOffset, sourceClientOffset));
        const source = registry.getSource(sourceId);
        const item = source.beginDrag(monitor, sourceId);
        // If source.beginDrag returns null, this is an indicator to cancel the drag
        if (item == null) return undefined;
        $3fabecb7493132a8$var$verifyItemIsObject(item);
        registry.pinSource(sourceId);
        const itemType = registry.getSourceType(sourceId);
        return {
            type: (0, $f9f7209b2e6f62ed$export$98f9b4193e6b55e6),
            payload: {
                itemType: itemType,
                item: item,
                sourceId: sourceId,
                clientOffset: clientOffset || null,
                sourceClientOffset: sourceClientOffset || null,
                isSourcePublic: !!publishSource
            }
        };
    };
}
function $3fabecb7493132a8$var$verifyInvariants(sourceIds, monitor, registry) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
    sourceIds.forEach(function(sourceId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(registry.getSource(sourceId), "Expected sourceIds to be registered.");
    });
}
function $3fabecb7493132a8$var$verifyGetSourceClientOffsetIsFunction(getSourceClientOffset) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof getSourceClientOffset === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function $3fabecb7493132a8$var$verifyItemIsObject(item) {
    (0, $98d484686087a39e$export$f5708dca728d7177)((0, $f02ae19c8e7d80b8$export$a6cdc56e425d0d0a)(item), "Item must be an object.");
}
function $3fabecb7493132a8$var$getDraggableSource(sourceIds, monitor) {
    let sourceId = null;
    for(let i = sourceIds.length - 1; i >= 0; i--)if (monitor.canDragSource(sourceIds[i])) {
        sourceId = sourceIds[i];
        break;
    }
    return sourceId;
}





function $351d264da34605f3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $351d264da34605f3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $351d264da34605f3$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $351d264da34605f3$export$9f5cbae8d079dda0(manager) {
    return function drop(options = {}) {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $351d264da34605f3$var$verifyInvariants(monitor);
        const targetIds = $351d264da34605f3$var$getDroppableTargets(monitor);
        // Multiple actions are dispatched here, which is why this doesn't return an action
        targetIds.forEach((targetId, index)=>{
            const dropResult = $351d264da34605f3$var$determineDropResult(targetId, index, registry, monitor);
            const action = {
                type: (0, $f9f7209b2e6f62ed$export$b4af72c40fd57063),
                payload: {
                    dropResult: $351d264da34605f3$var$_objectSpread({}, options, dropResult)
                }
            };
            manager.dispatch(action);
        });
    };
}
function $351d264da34605f3$var$verifyInvariants(monitor) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call drop while not dragging.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function $351d264da34605f3$var$determineDropResult(targetId, index, registry, monitor) {
    const target = registry.getTarget(targetId);
    let dropResult = target ? target.drop(monitor, targetId) : undefined;
    $351d264da34605f3$var$verifyDropResultType(dropResult);
    if (typeof dropResult === "undefined") dropResult = index === 0 ? {} : monitor.getDropResult();
    return dropResult;
}
function $351d264da34605f3$var$verifyDropResultType(dropResult) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof dropResult === "undefined" || (0, $f02ae19c8e7d80b8$export$a6cdc56e425d0d0a)(dropResult), "Drop result must either be an object or undefined.");
}
function $351d264da34605f3$var$getDroppableTargets(monitor) {
    const targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
    targetIds.reverse();
    return targetIds;
}




function $62cf5a0490a56212$export$2f5c7d4805260fdf(manager) {
    return function endDrag() {
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $62cf5a0490a56212$var$verifyIsDragging(monitor);
        const sourceId = monitor.getSourceId();
        if (sourceId != null) {
            const source = registry.getSource(sourceId, true);
            source.endDrag(monitor, sourceId);
            registry.unpinSource();
        }
        return {
            type: (0, $f9f7209b2e6f62ed$export$d300627d16aeb9cc)
        };
    };
}
function $62cf5a0490a56212$var$verifyIsDragging(monitor) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}



function $479bf735bb4097b0$export$2d6239ff106f142f(targetType, draggedItemType) {
    if (draggedItemType === null) return targetType === null;
    return Array.isArray(targetType) ? targetType.some((t)=>t === draggedItemType) : targetType === draggedItemType;
}



function $830bb706deb61dbb$export$2f85b44a1d72ad03(manager) {
    return function hover(targetIdsArg, { clientOffset: clientOffset } = {}) {
        $830bb706deb61dbb$var$verifyTargetIdsIsArray(targetIdsArg);
        const targetIds = targetIdsArg.slice(0);
        const monitor = manager.getMonitor();
        const registry = manager.getRegistry();
        $830bb706deb61dbb$var$checkInvariants(targetIds, monitor, registry);
        const draggedItemType = monitor.getItemType();
        $830bb706deb61dbb$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
        $830bb706deb61dbb$var$hoverAllTargets(targetIds, monitor, registry);
        return {
            type: (0, $f9f7209b2e6f62ed$export$9d358706ccac3727),
            payload: {
                targetIds: targetIds,
                clientOffset: clientOffset || null
            }
        };
    };
}
function $830bb706deb61dbb$var$verifyTargetIdsIsArray(targetIdsArg) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function $830bb706deb61dbb$var$checkInvariants(targetIds, monitor, registry) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(monitor.isDragging(), "Cannot call hover while not dragging.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(!monitor.didDrop(), "Cannot call hover after drop.");
    for(let i = 0; i < targetIds.length; i++){
        const targetId = targetIds[i];
        (0, $98d484686087a39e$export$f5708dca728d7177)(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
        const target = registry.getTarget(targetId);
        (0, $98d484686087a39e$export$f5708dca728d7177)(target, "Expected targetIds to be registered.");
    }
}
function $830bb706deb61dbb$var$removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
    // Remove those targetIds that don't match the targetType.  This
    // fixes shallow isOver which would only be non-shallow because of
    // non-matching targets.
    for(let i = targetIds.length - 1; i >= 0; i--){
        const targetId = targetIds[i];
        const targetType = registry.getTargetType(targetId);
        if (!(0, $479bf735bb4097b0$export$2d6239ff106f142f)(targetType, draggedItemType)) targetIds.splice(i, 1);
    }
}
function $830bb706deb61dbb$var$hoverAllTargets(targetIds, monitor, registry) {
    // Finally call hover on all matching targets.
    targetIds.forEach(function(targetId) {
        const target = registry.getTarget(targetId);
        target.hover(monitor, targetId);
    });
}



function $504e2b499c20db61$export$1675a481db21e714(manager) {
    return function publishDragSource() {
        const monitor = manager.getMonitor();
        if (monitor.isDragging()) return {
            type: (0, $f9f7209b2e6f62ed$export$22d1d88e2de0d0e0)
        };
        return;
    };
}



function $9fd818d2080e66b8$export$ac1b80e79f04247f(manager) {
    return {
        beginDrag: (0, $3fabecb7493132a8$export$d6542eb0d76867d6)(manager),
        publishDragSource: (0, $504e2b499c20db61$export$1675a481db21e714)(manager),
        hover: (0, $830bb706deb61dbb$export$2f85b44a1d72ad03)(manager),
        drop: (0, $351d264da34605f3$export$9f5cbae8d079dda0)(manager),
        endDrag: (0, $62cf5a0490a56212$export$2f5c7d4805260fdf)(manager)
    };
}


class $231bba26070908cb$export$1141bbf61324c55f {
    receiveBackend(backend) {
        this.backend = backend;
    }
    getMonitor() {
        return this.monitor;
    }
    getBackend() {
        return this.backend;
    }
    getRegistry() {
        return this.monitor.registry;
    }
    getActions() {
        /* eslint-disable-next-line @typescript-eslint/no-this-alias */ const manager = this;
        const { dispatch: dispatch } = this.store;
        function bindActionCreator(actionCreator) {
            return (...args)=>{
                const action = actionCreator.apply(manager, args);
                if (typeof action !== "undefined") dispatch(action);
            };
        }
        const actions = (0, $9fd818d2080e66b8$export$ac1b80e79f04247f)(this);
        return Object.keys(actions).reduce((boundActions, key)=>{
            const action = actions[key];
            boundActions[key] = bindActionCreator(action);
            return boundActions;
        }, {});
    }
    dispatch(action) {
        this.store.dispatch(action);
    }
    constructor(store, monitor){
        this.isSetUp = false;
        this.handleRefCountChange = ()=>{
            const shouldSetUp = this.store.getState().refCount > 0;
            if (this.backend) {
                if (shouldSetUp && !this.isSetUp) {
                    this.backend.setup();
                    this.isSetUp = true;
                } else if (!shouldSetUp && this.isSetUp) {
                    this.backend.teardown();
                    this.isSetUp = false;
                }
            }
        };
        this.store = store;
        this.monitor = monitor;
        store.subscribe(this.handleRefCountChange);
    }
}



/**
 * Coordinate addition
 * @param a The first coordinate
 * @param b The second coordinate
 */ function $27b840784216a52d$export$e16d8520af44a096(a, b) {
    return {
        x: a.x + b.x,
        y: a.y + b.y
    };
}
function $27b840784216a52d$export$4e2d2ead65e5f7e3(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $27b840784216a52d$export$b6a5970fca17c71e(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset, initialSourceClientOffset: initialSourceClientOffset } = state;
    if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) return null;
    return $27b840784216a52d$export$4e2d2ead65e5f7e3($27b840784216a52d$export$e16d8520af44a096(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function $27b840784216a52d$export$b57ee1a41eb1620b(state) {
    const { clientOffset: clientOffset, initialClientOffset: initialClientOffset } = state;
    if (!clientOffset || !initialClientOffset) return null;
    return $27b840784216a52d$export$4e2d2ead65e5f7e3(clientOffset, initialClientOffset);
}



const $1e4bcc7163a02c18$export$c53d0f541b41b88e = [];
const $1e4bcc7163a02c18$export$61b49a5ae59d663 = [];
$1e4bcc7163a02c18$export$c53d0f541b41b88e.__IS_NONE__ = true;
$1e4bcc7163a02c18$export$61b49a5ae59d663.__IS_ALL__ = true;
function $1e4bcc7163a02c18$export$3347776eeed47180(dirtyIds, handlerIds) {
    if (dirtyIds === $1e4bcc7163a02c18$export$c53d0f541b41b88e) return false;
    if (dirtyIds === $1e4bcc7163a02c18$export$61b49a5ae59d663 || typeof handlerIds === "undefined") return true;
    const commonIds = (0, $f02ae19c8e7d80b8$export$bc86dfbf7795668c)(handlerIds, dirtyIds);
    return commonIds.length > 0;
}



class $e711c5d5bf674445$export$e220263e518daaed {
    subscribeToStateChange(listener, options = {}) {
        const { handlerIds: handlerIds } = options;
        (0, $98d484686087a39e$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        (0, $98d484686087a39e$export$f5708dca728d7177)(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
        let prevStateId = this.store.getState().stateId;
        const handleChange = ()=>{
            const state = this.store.getState();
            const currentStateId = state.stateId;
            try {
                const canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !(0, $1e4bcc7163a02c18$export$3347776eeed47180)(state.dirtyHandlerIds, handlerIds);
                if (!canSkipListener) listener();
            } finally{
                prevStateId = currentStateId;
            }
        };
        return this.store.subscribe(handleChange);
    }
    subscribeToOffsetChange(listener) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(typeof listener === "function", "listener must be a function.");
        let previousState = this.store.getState().dragOffset;
        const handleChange = ()=>{
            const nextState = this.store.getState().dragOffset;
            if (nextState === previousState) return;
            previousState = nextState;
            listener();
        };
        return this.store.subscribe(handleChange);
    }
    canDragSource(sourceId) {
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId);
        (0, $98d484686087a39e$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (this.isDragging()) return false;
        return source.canDrag(this, sourceId);
    }
    canDropOnTarget(targetId) {
        // undefined on initial render
        if (!targetId) return false;
        const target = this.registry.getTarget(targetId);
        (0, $98d484686087a39e$export$f5708dca728d7177)(target, `Expected to find a valid target. targetId=${targetId}`);
        if (!this.isDragging() || this.didDrop()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        return (0, $479bf735bb4097b0$export$2d6239ff106f142f)(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
    isDragging() {
        return Boolean(this.getItemType());
    }
    isDraggingSource(sourceId) {
        // undefined on initial render
        if (!sourceId) return false;
        const source = this.registry.getSource(sourceId, true);
        (0, $98d484686087a39e$export$f5708dca728d7177)(source, `Expected to find a valid source. sourceId=${sourceId}`);
        if (!this.isDragging() || !this.isSourcePublic()) return false;
        const sourceType = this.registry.getSourceType(sourceId);
        const draggedItemType = this.getItemType();
        if (sourceType !== draggedItemType) return false;
        return source.isDragging(this, sourceId);
    }
    isOverTarget(targetId, options = {
        shallow: false
    }) {
        // undefined on initial render
        if (!targetId) return false;
        const { shallow: shallow } = options;
        if (!this.isDragging()) return false;
        const targetType = this.registry.getTargetType(targetId);
        const draggedItemType = this.getItemType();
        if (draggedItemType && !(0, $479bf735bb4097b0$export$2d6239ff106f142f)(targetType, draggedItemType)) return false;
        const targetIds = this.getTargetIds();
        if (!targetIds.length) return false;
        const index = targetIds.indexOf(targetId);
        if (shallow) return index === targetIds.length - 1;
        else return index > -1;
    }
    getItemType() {
        return this.store.getState().dragOperation.itemType;
    }
    getItem() {
        return this.store.getState().dragOperation.item;
    }
    getSourceId() {
        return this.store.getState().dragOperation.sourceId;
    }
    getTargetIds() {
        return this.store.getState().dragOperation.targetIds;
    }
    getDropResult() {
        return this.store.getState().dragOperation.dropResult;
    }
    didDrop() {
        return this.store.getState().dragOperation.didDrop;
    }
    isSourcePublic() {
        return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
    getInitialClientOffset() {
        return this.store.getState().dragOffset.initialClientOffset;
    }
    getInitialSourceClientOffset() {
        return this.store.getState().dragOffset.initialSourceClientOffset;
    }
    getClientOffset() {
        return this.store.getState().dragOffset.clientOffset;
    }
    getSourceClientOffset() {
        return (0, $27b840784216a52d$export$b6a5970fca17c71e)(this.store.getState().dragOffset);
    }
    getDifferenceFromInitialOffset() {
        return (0, $27b840784216a52d$export$b57ee1a41eb1620b)(this.store.getState().dragOffset);
    }
    constructor(store, registry){
        this.store = store;
        this.registry = registry;
    }
}


/* eslint-disable no-restricted-globals, @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unused-vars, @typescript-eslint/no-non-null-assertion */ // Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
/* globals self */ const $cb7a2a98684b3789$var$scope = typeof $parcel$global !== "undefined" ? $parcel$global : self;
const $cb7a2a98684b3789$var$BrowserMutationObserver = $cb7a2a98684b3789$var$scope.MutationObserver || $cb7a2a98684b3789$var$scope.WebKitMutationObserver;
function $cb7a2a98684b3789$export$27a7cafb047f3c77(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        const timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        const intervalHandle = setInterval(handleTimer, 50);
        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}
function $cb7a2a98684b3789$export$2785f4493cc9ca62(callback) {
    let toggle = 1;
    const observer = new $cb7a2a98684b3789$var$BrowserMutationObserver(callback);
    const node = document.createTextNode("");
    observer.observe(node, {
        characterData: true
    });
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}
const $cb7a2a98684b3789$export$29545a1340296ce3 = typeof $cb7a2a98684b3789$var$BrowserMutationObserver === "function" ? // They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
$cb7a2a98684b3789$export$2785f4493cc9ca62 : // 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.
// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396
// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
$cb7a2a98684b3789$export$27a7cafb047f3c77;


class $b47090bdcbf26aca$export$d3f0708de0e313ed {
    // Use the fastest means possible to execute a task in its own turn, with
    // priority over other events including IO, animation, reflow, and redraw
    // events in browsers.
    //
    // An exception thrown by a task will permanently interrupt the processing of
    // subsequent tasks. The higher level `asap` function ensures that if an
    // exception is thrown by a task, that the task queue will continue flushing as
    // soon as possible, but if you use `rawAsap` directly, you are responsible to
    // either ensure that no exceptions are thrown from your task, or to manually
    // call `rawAsap.requestFlush` if an exception is thrown.
    enqueueTask(task) {
        const { queue: q, requestFlush: requestFlush } = this;
        if (!q.length) {
            requestFlush();
            this.flushing = true;
        }
        // Equivalent to push, but avoids a function call.
        q[q.length] = task;
    }
    constructor(){
        this.queue = [];
        // We queue errors to ensure they are thrown in right order (FIFO).
        // Array-as-queue is good enough here, since we are just dealing with exceptions.
        this.pendingErrors = [];
        // Once a flush has been requested, no further calls to `requestFlush` are
        // necessary until the next `flush` completes.
        // @ts-ignore
        this.flushing = false;
        // The position of the next task to execute in the task queue. This is
        // preserved between calls to `flush` so that it can be resumed if
        // a task throws an exception.
        this.index = 0;
        // If a task schedules additional tasks recursively, the task queue can grow
        // unbounded. To prevent memory exhaustion, the task queue will periodically
        // truncate already-completed tasks.
        this.capacity = 1024;
        // The flush function processes all tasks that have been scheduled with
        // `rawAsap` unless and until one of those tasks throws an exception.
        // If a task throws an exception, `flush` ensures that its state will remain
        // consistent and will resume where it left off when called again.
        // However, `flush` does not make any arrangements to be called again if an
        // exception is thrown.
        this.flush = ()=>{
            const { queue: q } = this;
            while(this.index < q.length){
                const currentIndex = this.index;
                // Advance the index before calling the task. This ensures that we will
                // begin flushing on the next task the task throws an error.
                this.index++;
                q[currentIndex].call();
                // Prevent leaking memory for long chains of recursive calls to `asap`.
                // If we call `asap` within tasks scheduled by `asap`, the queue will
                // grow, but to avoid an O(n) walk for every task we execute, we don't
                // shift tasks off the queue after they have been executed.
                // Instead, we periodically shift 1024 tasks off the queue.
                if (this.index > this.capacity) {
                    // Manually shift all values starting at the index back to the
                    // beginning of the queue.
                    for(let scan = 0, newLength = q.length - this.index; scan < newLength; scan++)q[scan] = q[scan + this.index];
                    q.length -= this.index;
                    this.index = 0;
                }
            }
            q.length = 0;
            this.index = 0;
            this.flushing = false;
        };
        // In a web browser, exceptions are not fatal. However, to avoid
        // slowing down the queue of pending tasks, we rethrow the error in a
        // lower priority turn.
        this.registerPendingError = (err)=>{
            this.pendingErrors.push(err);
            this.requestErrorThrow();
        };
        // `requestFlush` requests that the high priority event queue be flushed as
        // soon as possible.
        // This is useful to prevent an error thrown in a task from stalling the event
        // queue if the exception handled by Node.js’s
        // `process.on("uncaughtException")` or by a domain.
        // `requestFlush` is implemented using a strategy based on data collected from
        // every available SauceLabs Selenium web driver worker at time of writing.
        // https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
        this.requestFlush = (0, $cb7a2a98684b3789$export$29545a1340296ce3)(this.flush);
        this.requestErrorThrow = (0, $cb7a2a98684b3789$export$27a7cafb047f3c77)(()=>{
            // Throw first error
            if (this.pendingErrors.length) throw this.pendingErrors.shift();
        });
    }
} // The message channel technique was discovered by Malte Ubl and was the
 // original foundation for this library.
 // http://www.nonblocking.io/2011/06/windownexttick.html
 // Safari 6.0.5 (at least) intermittently fails to create message ports on a
 // page's first load. Thankfully, this version of Safari supports
 // MutationObservers, so we don't need to fall back in that case.
 // function makeRequestCallFromMessageChannel(callback) {
 //     var channel = new MessageChannel();
 //     channel.port1.onmessage = callback;
 //     return function requestCall() {
 //         channel.port2.postMessage(0);
 //     };
 // }
 // For reasons explained above, we are also unable to use `setImmediate`
 // under any circumstances.
 // Even if we were, there is another bug in Internet Explorer 10.
 // It is not sufficient to assign `setImmediate` to `requestFlush` because
 // `setImmediate` must be called *by name* and therefore must be wrapped in a
 // closure.
 // Never forget.
 // function makeRequestCallFromSetImmediate(callback) {
 //     return function requestCall() {
 //         setImmediate(callback);
 //     };
 // }
 // Safari 6.0 has a problem where timers will get lost while the user is
 // scrolling. This problem does not impact ASAP because Safari 6.0 supports
 // mutation observers, so that implementation is used instead.
 // However, if we ever elect to use timers in Safari, the prevalent work-around
 // is to add a scroll event listener that calls for a flush.
 // `setTimeout` does not call the passed callback if the delay is less than
 // approximately 7 in web workers in Firefox 8 through 18, and sometimes not
 // even then.
 // This is for `asap.js` only.
 // Its name will be periodically randomized to break any code that depends on
 // // its existence.
 // rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer
 // ASAP was originally a nextTick shim included in Q. This was factored out
 // into this ASAP package. It was later adapted to RSVP which made further
 // amendments. These decisions, particularly to marginalize MessageChannel and
 // to capture the MutationObserver implementation in a closure, were integrated
 // back into ASAP proper.
 // https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js


// `call`, just like a function.
class $a31190a435ba9d39$export$c84b69da61b33d93 {
    call() {
        try {
            this.task && this.task();
        } catch (error) {
            this.onError(error);
        } finally{
            this.task = null;
            this.release(this);
        }
    }
    constructor(onError, release){
        this.onError = onError;
        this.release = release;
        this.task = null;
    }
}


class $1018e2ebf745ae23$export$4577931b6c22c63b {
    create(task) {
        const tasks = this.freeTasks;
        const t1 = tasks.length ? tasks.pop() : new (0, $a31190a435ba9d39$export$c84b69da61b33d93)(this.onError, (t)=>tasks[tasks.length] = t);
        t1.task = task;
        return t1;
    }
    constructor(onError){
        this.onError = onError;
        this.freeTasks = [];
    }
}


const $e4caf8908e236568$var$asapQueue = new (0, $b47090bdcbf26aca$export$d3f0708de0e313ed)();
const $e4caf8908e236568$var$taskFactory = new (0, $1018e2ebf745ae23$export$4577931b6c22c63b)($e4caf8908e236568$var$asapQueue.registerPendingError);
function $e4caf8908e236568$export$dc4d482300a341e1(task) {
    $e4caf8908e236568$var$asapQueue.enqueueTask($e4caf8908e236568$var$taskFactory.create(task));
}









const $8f7c228f60121de1$export$b36933c81fb1c092 = "dnd-core/ADD_SOURCE";
const $8f7c228f60121de1$export$2c313542981556ae = "dnd-core/ADD_TARGET";
const $8f7c228f60121de1$export$13332566b98b8783 = "dnd-core/REMOVE_SOURCE";
const $8f7c228f60121de1$export$82ace346d17d8869 = "dnd-core/REMOVE_TARGET";
function $8f7c228f60121de1$export$bc333c64f07a75c4(sourceId) {
    return {
        type: $8f7c228f60121de1$export$b36933c81fb1c092,
        payload: {
            sourceId: sourceId
        }
    };
}
function $8f7c228f60121de1$export$9dd68fe78f37278b(targetId) {
    return {
        type: $8f7c228f60121de1$export$2c313542981556ae,
        payload: {
            targetId: targetId
        }
    };
}
function $8f7c228f60121de1$export$c724aacd61334138(sourceId) {
    return {
        type: $8f7c228f60121de1$export$13332566b98b8783,
        payload: {
            sourceId: sourceId
        }
    };
}
function $8f7c228f60121de1$export$20ae7ec87f7f8696(targetId) {
    return {
        type: $8f7c228f60121de1$export$82ace346d17d8869,
        payload: {
            targetId: targetId
        }
    };
}



function $f1e39c88d0242266$export$a7a13c013ce18993(source) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof source.canDrag === "function", "Expected canDrag to be a function.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function $f1e39c88d0242266$export$77d3cd1340fdeb5a(target) {
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof target.canDrop === "function", "Expected canDrop to be a function.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof target.hover === "function", "Expected hover to be a function.");
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function $f1e39c88d0242266$export$831a593efd22380d(type, allowArray) {
    if (allowArray && Array.isArray(type)) {
        type.forEach((t)=>$f1e39c88d0242266$export$831a593efd22380d(t, false));
        return;
    }
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof type === "string" || typeof type === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}


var $96d94d1873592463$export$bb8f0843d7d66cb0;
(function(HandlerRole) {
    HandlerRole["SOURCE"] = "SOURCE";
    HandlerRole["TARGET"] = "TARGET";
})($96d94d1873592463$export$bb8f0843d7d66cb0 || ($96d94d1873592463$export$bb8f0843d7d66cb0 = {}));


let $abe12cef6206df2d$var$nextUniqueId = 0;
function $abe12cef6206df2d$export$dbfb29c8f2c7bb44() {
    return $abe12cef6206df2d$var$nextUniqueId++;
}


function $905f877e396678d7$var$getNextHandlerId(role) {
    const id = (0, $abe12cef6206df2d$export$dbfb29c8f2c7bb44)().toString();
    switch(role){
        case (0, $96d94d1873592463$export$bb8f0843d7d66cb0).SOURCE:
            return `S${id}`;
        case (0, $96d94d1873592463$export$bb8f0843d7d66cb0).TARGET:
            return `T${id}`;
        default:
            throw new Error(`Unknown Handler Role: ${role}`);
    }
}
function $905f877e396678d7$var$parseRoleFromHandlerId(handlerId) {
    switch(handlerId[0]){
        case "S":
            return (0, $96d94d1873592463$export$bb8f0843d7d66cb0).SOURCE;
        case "T":
            return (0, $96d94d1873592463$export$bb8f0843d7d66cb0).TARGET;
        default:
            throw new Error(`Cannot parse handler ID: ${handlerId}`);
    }
}
function $905f877e396678d7$var$mapContainsValue(map, searchValue) {
    const entries = map.entries();
    let isDone = false;
    do {
        const { done: done, value: [, value] } = entries.next();
        if (value === searchValue) return true;
        isDone = !!done;
    }while (!isDone);
    return false;
}
class $905f877e396678d7$export$60ceab237232d5db {
    addSource(type, source) {
        (0, $f1e39c88d0242266$export$831a593efd22380d)(type);
        (0, $f1e39c88d0242266$export$a7a13c013ce18993)(source);
        const sourceId = this.addHandler((0, $96d94d1873592463$export$bb8f0843d7d66cb0).SOURCE, type, source);
        this.store.dispatch((0, $8f7c228f60121de1$export$bc333c64f07a75c4)(sourceId));
        return sourceId;
    }
    addTarget(type, target) {
        (0, $f1e39c88d0242266$export$831a593efd22380d)(type, true);
        (0, $f1e39c88d0242266$export$77d3cd1340fdeb5a)(target);
        const targetId = this.addHandler((0, $96d94d1873592463$export$bb8f0843d7d66cb0).TARGET, type, target);
        this.store.dispatch((0, $8f7c228f60121de1$export$9dd68fe78f37278b)(targetId));
        return targetId;
    }
    containsHandler(handler) {
        return $905f877e396678d7$var$mapContainsValue(this.dragSources, handler) || $905f877e396678d7$var$mapContainsValue(this.dropTargets, handler);
    }
    getSource(sourceId, includePinned = false) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        const isPinned = includePinned && sourceId === this.pinnedSourceId;
        const source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
        return source;
    }
    getTarget(targetId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.dropTargets.get(targetId);
    }
    getSourceType(sourceId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.isSourceId(sourceId), "Expected a valid source ID.");
        return this.types.get(sourceId);
    }
    getTargetType(targetId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.isTargetId(targetId), "Expected a valid target ID.");
        return this.types.get(targetId);
    }
    isSourceId(handlerId) {
        const role = $905f877e396678d7$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $96d94d1873592463$export$bb8f0843d7d66cb0).SOURCE;
    }
    isTargetId(handlerId) {
        const role = $905f877e396678d7$var$parseRoleFromHandlerId(handlerId);
        return role === (0, $96d94d1873592463$export$bb8f0843d7d66cb0).TARGET;
    }
    removeSource(sourceId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.getSource(sourceId), "Expected an existing source.");
        this.store.dispatch((0, $8f7c228f60121de1$export$c724aacd61334138)(sourceId));
        (0, $e4caf8908e236568$export$dc4d482300a341e1)(()=>{
            this.dragSources.delete(sourceId);
            this.types.delete(sourceId);
        });
    }
    removeTarget(targetId) {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.getTarget(targetId), "Expected an existing target.");
        this.store.dispatch((0, $8f7c228f60121de1$export$20ae7ec87f7f8696)(targetId));
        this.dropTargets.delete(targetId);
        this.types.delete(targetId);
    }
    pinSource(sourceId) {
        const source = this.getSource(sourceId);
        (0, $98d484686087a39e$export$f5708dca728d7177)(source, "Expected an existing source.");
        this.pinnedSourceId = sourceId;
        this.pinnedSource = source;
    }
    unpinSource() {
        (0, $98d484686087a39e$export$f5708dca728d7177)(this.pinnedSource, "No source is pinned at the time.");
        this.pinnedSourceId = null;
        this.pinnedSource = null;
    }
    addHandler(role, type, handler) {
        const id = $905f877e396678d7$var$getNextHandlerId(role);
        this.types.set(id, type);
        if (role === (0, $96d94d1873592463$export$bb8f0843d7d66cb0).SOURCE) this.dragSources.set(id, handler);
        else if (role === (0, $96d94d1873592463$export$bb8f0843d7d66cb0).TARGET) this.dropTargets.set(id, handler);
        return id;
    }
    constructor(store){
        this.types = new Map();
        this.dragSources = new Map();
        this.dropTargets = new Map();
        this.pinnedSourceId = null;
        this.pinnedSource = null;
        this.store = store;
    }
}






const $7f418584909a75c9$export$2116cbe61f6a442a = (a, b)=>a === b;
function $7f418584909a75c9$export$102b20725d4d2263(offsetA, offsetB) {
    if (!offsetA && !offsetB) return true;
    else if (!offsetA || !offsetB) return false;
    else return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
}
function $7f418584909a75c9$export$94fd53d40f0652a(a, b, isEqual = $7f418584909a75c9$export$2116cbe61f6a442a) {
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; ++i){
        if (!isEqual(a[i], b[i])) return false;
    }
    return true;
}



function $f26f24eed60948be$export$533b26079ad0b4b(_state = (0, $1e4bcc7163a02c18$export$c53d0f541b41b88e), action) {
    switch(action.type){
        case 0, $f9f7209b2e6f62ed$export$9d358706ccac3727:
            break;
        case 0, $8f7c228f60121de1$export$b36933c81fb1c092:
        case 0, $8f7c228f60121de1$export$2c313542981556ae:
        case 0, $8f7c228f60121de1$export$82ace346d17d8869:
        case 0, $8f7c228f60121de1$export$13332566b98b8783:
            return 0, $1e4bcc7163a02c18$export$c53d0f541b41b88e;
        case 0, $f9f7209b2e6f62ed$export$98f9b4193e6b55e6:
        case 0, $f9f7209b2e6f62ed$export$22d1d88e2de0d0e0:
        case 0, $f9f7209b2e6f62ed$export$d300627d16aeb9cc:
        case 0, $f9f7209b2e6f62ed$export$b4af72c40fd57063:
        default:
            return 0, $1e4bcc7163a02c18$export$61b49a5ae59d663;
    }
    const { targetIds: targetIds = [], prevTargetIds: prevTargetIds = [] } = action.payload;
    const result = (0, $f02ae19c8e7d80b8$export$6444ef5cd411280c)(targetIds, prevTargetIds);
    const didChange = result.length > 0 || !(0, $7f418584909a75c9$export$94fd53d40f0652a)(targetIds, prevTargetIds);
    if (!didChange) return 0, $1e4bcc7163a02c18$export$c53d0f541b41b88e;
    // Check the target ids at the innermost position. If they are valid, add them
    // to the result
    const prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
    const innermostTargetId = targetIds[targetIds.length - 1];
    if (prevInnermostTargetId !== innermostTargetId) {
        if (prevInnermostTargetId) result.push(prevInnermostTargetId);
        if (innermostTargetId) result.push(innermostTargetId);
    }
    return result;
}




function $7e797ae9fc6c7a3a$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7e797ae9fc6c7a3a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $7e797ae9fc6c7a3a$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $7e797ae9fc6c7a3a$var$initialState = {
    initialSourceClientOffset: null,
    initialClientOffset: null,
    clientOffset: null
};
function $7e797ae9fc6c7a3a$export$533b26079ad0b4b(state = $7e797ae9fc6c7a3a$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $f9f7209b2e6f62ed$export$3fc3a33e48b33945:
        case 0, $f9f7209b2e6f62ed$export$98f9b4193e6b55e6:
            return {
                initialSourceClientOffset: payload.sourceClientOffset,
                initialClientOffset: payload.clientOffset,
                clientOffset: payload.clientOffset
            };
        case 0, $f9f7209b2e6f62ed$export$9d358706ccac3727:
            if ((0, $7f418584909a75c9$export$102b20725d4d2263)(state.clientOffset, payload.clientOffset)) return state;
            return $7e797ae9fc6c7a3a$var$_objectSpread({}, state, {
                clientOffset: payload.clientOffset
            });
        case 0, $f9f7209b2e6f62ed$export$d300627d16aeb9cc:
        case 0, $f9f7209b2e6f62ed$export$b4af72c40fd57063:
            return $7e797ae9fc6c7a3a$var$initialState;
        default:
            return state;
    }
}





function $bee2cb6f6c12b256$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bee2cb6f6c12b256$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $bee2cb6f6c12b256$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
const $bee2cb6f6c12b256$var$initialState = {
    itemType: null,
    item: null,
    sourceId: null,
    targetIds: [],
    dropResult: null,
    didDrop: false,
    isSourcePublic: null
};
function $bee2cb6f6c12b256$export$533b26079ad0b4b(state = $bee2cb6f6c12b256$var$initialState, action) {
    const { payload: payload } = action;
    switch(action.type){
        case 0, $f9f7209b2e6f62ed$export$98f9b4193e6b55e6:
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                itemType: payload.itemType,
                item: payload.item,
                sourceId: payload.sourceId,
                isSourcePublic: payload.isSourcePublic,
                dropResult: null,
                didDrop: false
            });
        case 0, $f9f7209b2e6f62ed$export$22d1d88e2de0d0e0:
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                isSourcePublic: true
            });
        case 0, $f9f7209b2e6f62ed$export$9d358706ccac3727:
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                targetIds: payload.targetIds
            });
        case 0, $8f7c228f60121de1$export$82ace346d17d8869:
            if (state.targetIds.indexOf(payload.targetId) === -1) return state;
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                targetIds: (0, $f02ae19c8e7d80b8$export$5d14bf425b37f49e)(state.targetIds, payload.targetId)
            });
        case 0, $f9f7209b2e6f62ed$export$b4af72c40fd57063:
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                dropResult: payload.dropResult,
                didDrop: true,
                targetIds: []
            });
        case 0, $f9f7209b2e6f62ed$export$d300627d16aeb9cc:
            return $bee2cb6f6c12b256$var$_objectSpread({}, state, {
                itemType: null,
                item: null,
                sourceId: null,
                dropResult: null,
                didDrop: false,
                isSourcePublic: null,
                targetIds: []
            });
        default:
            return state;
    }
}



function $427910da90e975a3$export$533b26079ad0b4b(state = 0, action) {
    switch(action.type){
        case 0, $8f7c228f60121de1$export$b36933c81fb1c092:
        case 0, $8f7c228f60121de1$export$2c313542981556ae:
            return state + 1;
        case 0, $8f7c228f60121de1$export$13332566b98b8783:
        case 0, $8f7c228f60121de1$export$82ace346d17d8869:
            return state - 1;
        default:
            return state;
    }
}


function $a1a24dd57766e107$export$533b26079ad0b4b(state = 0) {
    return state + 1;
}


function $c67cd34e8e086364$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c67cd34e8e086364$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $c67cd34e8e086364$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function $c67cd34e8e086364$export$533b26079ad0b4b(state = {}, action) {
    return {
        dirtyHandlerIds: (0, $f26f24eed60948be$export$533b26079ad0b4b)(state.dirtyHandlerIds, {
            type: action.type,
            payload: $c67cd34e8e086364$var$_objectSpread({}, action.payload, {
                prevTargetIds: (0, $f02ae19c8e7d80b8$export$3988ae62b71be9a3)(state, "dragOperation.targetIds", [])
            })
        }),
        dragOffset: (0, $7e797ae9fc6c7a3a$export$533b26079ad0b4b)(state.dragOffset, action),
        refCount: (0, $427910da90e975a3$export$533b26079ad0b4b)(state.refCount, action),
        dragOperation: (0, $bee2cb6f6c12b256$export$533b26079ad0b4b)(state.dragOperation, action),
        stateId: (0, $a1a24dd57766e107$export$533b26079ad0b4b)(state.stateId)
    };
}


function $ca632db572d620a2$export$ff47aa43d5fd3e5d(backendFactory, globalContext, backendOptions = {}, debugMode = false) {
    const store = $ca632db572d620a2$var$makeStoreInstance(debugMode);
    const monitor = new (0, $e711c5d5bf674445$export$e220263e518daaed)(store, new (0, $905f877e396678d7$export$60ceab237232d5db)(store));
    const manager = new (0, $231bba26070908cb$export$1141bbf61324c55f)(store, monitor);
    const backend = backendFactory(manager, globalContext, backendOptions);
    manager.receiveBackend(backend);
    return manager;
}
function $ca632db572d620a2$var$makeStoreInstance(debugMode) {
    // TODO: if we ever make a react-native version of this,
    // we'll need to consider how to pull off dev-tooling
    const reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
    return (0, $93965a8764a89981$export$f51a9068ac82ea43)((0, $c67cd34e8e086364$export$533b26079ad0b4b), debugMode && reduxDevTools && reduxDevTools({
        name: "dnd-core",
        instanceId: "dnd-core"
    }));
}



var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");
const $6993ae53f6be0cb9$export$2d5c5ceac203fc1e = (0, $eCoWV.createContext)({
    dragDropManager: undefined
});


function $4892b00fc6b8e509$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $4892b00fc6b8e509$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $4892b00fc6b8e509$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
let $4892b00fc6b8e509$var$refCount = 0;
const $4892b00fc6b8e509$var$INSTANCE_SYM = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var $4892b00fc6b8e509$export$9861489d68213f9c = /*#__PURE__*/ (0, $eCoWV.memo)(function DndProvider(_param) {
    var { children: children } = _param, props = $4892b00fc6b8e509$var$_objectWithoutProperties(_param, [
        "children"
    ]);
    const [manager, isGlobalInstance] = $4892b00fc6b8e509$var$getDndContextValue(props) // memoized from props
    ;
    /**
		 * If the global context was used to store the DND context
		 * then where theres no more references to it we should
		 * clean it up to avoid memory leaks
		 */ (0, $eCoWV.useEffect)(()=>{
        if (isGlobalInstance) {
            const context = $4892b00fc6b8e509$var$getGlobalContext();
            ++$4892b00fc6b8e509$var$refCount;
            return ()=>{
                if (--$4892b00fc6b8e509$var$refCount === 0) context[$4892b00fc6b8e509$var$INSTANCE_SYM] = null;
            };
        }
        return;
    }, []);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6993ae53f6be0cb9$export$2d5c5ceac203fc1e).Provider, {
        value: manager,
        children: children
    });
});
function $4892b00fc6b8e509$var$getDndContextValue(props) {
    if ("manager" in props) {
        const manager = {
            dragDropManager: props.manager
        };
        return [
            manager,
            false
        ];
    }
    const manager = $4892b00fc6b8e509$var$createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
    const isGlobalInstance = !props.context;
    return [
        manager,
        isGlobalInstance
    ];
}
function $4892b00fc6b8e509$var$createSingletonDndContext(backend, context = $4892b00fc6b8e509$var$getGlobalContext(), options, debugMode) {
    const ctx = context;
    if (!ctx[$4892b00fc6b8e509$var$INSTANCE_SYM]) ctx[$4892b00fc6b8e509$var$INSTANCE_SYM] = {
        dragDropManager: (0, $ca632db572d620a2$export$ff47aa43d5fd3e5d)(backend, context, options, debugMode)
    };
    return ctx[$4892b00fc6b8e509$var$INSTANCE_SYM];
}
function $4892b00fc6b8e509$var$getGlobalContext() {
    return typeof $parcel$global !== "undefined" ? $parcel$global : window;
}


// cheap lodash replacements
function $d1461c5d415feba2$export$fc10aeed3a532e2a(fn) {
    let result = null;
    const memoized = ()=>{
        if (result == null) result = fn();
        return result;
    };
    return memoized;
}
function $d1461c5d415feba2$export$5d14bf425b37f49e(items, item) {
    return items.filter((i)=>i !== item);
}
function $d1461c5d415feba2$export$971dd5b0dfd021b6(itemsA, itemsB) {
    const set = new Set();
    const insertItem = (item)=>set.add(item);
    itemsA.forEach(insertItem);
    itemsB.forEach(insertItem);
    const result = [];
    set.forEach((key)=>result.push(key));
    return result;
}


class $b4aab0ba906821ab$export$9ff3e6eb5c734d0d {
    enter(enteringNode) {
        const previousLength = this.entered.length;
        const isNodeEntered = (node)=>this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
        this.entered = (0, $d1461c5d415feba2$export$971dd5b0dfd021b6)(this.entered.filter(isNodeEntered), [
            enteringNode
        ]);
        return previousLength === 0 && this.entered.length > 0;
    }
    leave(leavingNode) {
        const previousLength = this.entered.length;
        this.entered = (0, $d1461c5d415feba2$export$5d14bf425b37f49e)(this.entered.filter(this.isNodeInDocument), leavingNode);
        return previousLength > 0 && this.entered.length === 0;
    }
    reset() {
        this.entered = [];
    }
    constructor(isNodeInDocument){
        this.entered = [];
        this.isNodeInDocument = isNodeInDocument;
    }
}


class $21c5a52b7a51cbef$export$f22384f077cf51c4 {
    initializeExposedProperties() {
        Object.keys(this.config.exposeProperties).forEach((property)=>{
            Object.defineProperty(this.item, property, {
                configurable: true,
                enumerable: true,
                get () {
                    // eslint-disable-next-line no-console
                    console.warn(`Browser doesn't allow reading "${property}" until the drop event.`);
                    return null;
                }
            });
        });
    }
    loadDataTransfer(dataTransfer) {
        if (dataTransfer) {
            const newProperties = {};
            Object.keys(this.config.exposeProperties).forEach((property)=>{
                const propertyFn = this.config.exposeProperties[property];
                if (propertyFn != null) newProperties[property] = {
                    value: propertyFn(dataTransfer, this.config.matchesTypes),
                    configurable: true,
                    enumerable: true
                };
            });
            Object.defineProperties(this.item, newProperties);
        }
    }
    canDrag() {
        return true;
    }
    beginDrag() {
        return this.item;
    }
    isDragging(monitor, handle) {
        return handle === monitor.getSourceId();
    }
    endDrag() {
    // empty
    }
    constructor(config){
        this.config = config;
        this.item = {};
        this.initializeExposedProperties();
    }
}


var $0b5b3a44545fbee5$exports = {};

$parcel$export($0b5b3a44545fbee5$exports, "FILE", function () { return $0b5b3a44545fbee5$export$1802dbfd31b58482; });
$parcel$export($0b5b3a44545fbee5$exports, "URL", function () { return $0b5b3a44545fbee5$export$61abde59b50deb8e; });
$parcel$export($0b5b3a44545fbee5$exports, "TEXT", function () { return $0b5b3a44545fbee5$export$d597759d33be802e; });
$parcel$export($0b5b3a44545fbee5$exports, "HTML", function () { return $0b5b3a44545fbee5$export$9dcd2b1ca4768128; });
const $0b5b3a44545fbee5$export$1802dbfd31b58482 = "__NATIVE_FILE__";
const $0b5b3a44545fbee5$export$61abde59b50deb8e = "__NATIVE_URL__";
const $0b5b3a44545fbee5$export$d597759d33be802e = "__NATIVE_TEXT__";
const $0b5b3a44545fbee5$export$9dcd2b1ca4768128 = "__NATIVE_HTML__";


function $066221699bf59bd1$export$dc02f6a7b68f305f(dataTransfer, typesToTry, defaultValue) {
    const result = typesToTry.reduce((resultSoFar, typeToTry)=>resultSoFar || dataTransfer.getData(typeToTry), "");
    return result != null ? result : defaultValue;
}


const $6d57247c3af1bc8e$export$8cc89d9b8cb1bd88 = {
    [$0b5b3a44545fbee5$export$1802dbfd31b58482]: {
        exposeProperties: {
            files: (dataTransfer)=>Array.prototype.slice.call(dataTransfer.files),
            items: (dataTransfer)=>dataTransfer.items,
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Files"
        ]
    },
    [$0b5b3a44545fbee5$export$9dcd2b1ca4768128]: {
        exposeProperties: {
            html: (dataTransfer, matchesTypes)=>(0, $066221699bf59bd1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Html",
            "text/html"
        ]
    },
    [$0b5b3a44545fbee5$export$61abde59b50deb8e]: {
        exposeProperties: {
            urls: (dataTransfer, matchesTypes)=>(0, $066221699bf59bd1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, "").split("\n"),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Url",
            "text/uri-list"
        ]
    },
    [$0b5b3a44545fbee5$export$d597759d33be802e]: {
        exposeProperties: {
            text: (dataTransfer, matchesTypes)=>(0, $066221699bf59bd1$export$dc02f6a7b68f305f)(dataTransfer, matchesTypes, ""),
            dataTransfer: (dataTransfer)=>dataTransfer
        },
        matchesTypes: [
            "Text",
            "text/plain"
        ]
    }
};


function $c9c27176219fce80$export$ada362c01636774d(type, dataTransfer) {
    const config = (0, $6d57247c3af1bc8e$export$8cc89d9b8cb1bd88)[type];
    if (!config) throw new Error(`native type ${type} has no configuration`);
    const result = new (0, $21c5a52b7a51cbef$export$f22384f077cf51c4)(config);
    result.loadDataTransfer(dataTransfer);
    return result;
}
function $c9c27176219fce80$export$11b547ed8c182c11(dataTransfer) {
    if (!dataTransfer) return null;
    const dataTransferTypes = Array.prototype.slice.call(dataTransfer.types || []);
    return Object.keys((0, $6d57247c3af1bc8e$export$8cc89d9b8cb1bd88)).filter((nativeItemType)=>{
        const typeConfig = (0, $6d57247c3af1bc8e$export$8cc89d9b8cb1bd88)[nativeItemType];
        if (!(typeConfig === null || typeConfig === void 0 ? void 0 : typeConfig.matchesTypes)) return false;
        return typeConfig.matchesTypes.some((t)=>dataTransferTypes.indexOf(t) > -1);
    })[0] || null;
}




const $96f329f02b21181f$export$b7d78993b74f766d = (0, $d1461c5d415feba2$export$fc10aeed3a532e2a)(()=>/firefox/i.test(navigator.userAgent));
const $96f329f02b21181f$export$95df08bae54cb4df = (0, $d1461c5d415feba2$export$fc10aeed3a532e2a)(()=>Boolean(window.safari));


class $68f404428cc9000a$export$6d87c156c5199b02 {
    interpolate(x) {
        const { xs: xs, ys: ys, c1s: c1s, c2s: c2s, c3s: c3s } = this;
        // The rightmost point in the dataset should give an exact result
        let i = xs.length - 1;
        if (x === xs[i]) return ys[i];
        // Search for the interval x is in, returning the corresponding y if x is one of the original xs
        let low = 0;
        let high = c3s.length - 1;
        let mid;
        while(low <= high){
            mid = Math.floor(0.5 * (low + high));
            const xHere = xs[mid];
            if (xHere < x) low = mid + 1;
            else if (xHere > x) high = mid - 1;
            else return ys[mid];
        }
        i = Math.max(0, high);
        // Interpolate
        const diff = x - xs[i];
        const diffSq = diff * diff;
        return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
    constructor(xs, ys){
        const { length: length } = xs;
        // Rearrange xs and ys so that xs is sorted
        const indexes = [];
        for(let i = 0; i < length; i++)indexes.push(i);
        indexes.sort((a, b)=>xs[a] < xs[b] ? -1 : 1);
        // Get consecutive differences and slopes
        const dys = [];
        const dxs = [];
        const ms = [];
        let dx;
        let dy;
        for(let i1 = 0; i1 < length - 1; i1++){
            dx = xs[i1 + 1] - xs[i1];
            dy = ys[i1 + 1] - ys[i1];
            dxs.push(dx);
            dys.push(dy);
            ms.push(dy / dx);
        }
        // Get degree-1 coefficients
        const c1s = [
            ms[0]
        ];
        for(let i2 = 0; i2 < dxs.length - 1; i2++){
            const m2 = ms[i2];
            const mNext = ms[i2 + 1];
            if (m2 * mNext <= 0) c1s.push(0);
            else {
                dx = dxs[i2];
                const dxNext = dxs[i2 + 1];
                const common = dx + dxNext;
                c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
            }
        }
        c1s.push(ms[ms.length - 1]);
        // Get degree-2 and degree-3 coefficients
        const c2s = [];
        const c3s = [];
        let m;
        for(let i3 = 0; i3 < c1s.length - 1; i3++){
            m = ms[i3];
            const c1 = c1s[i3];
            const invDx = 1 / dxs[i3];
            const common = c1 + c1s[i3 + 1] - m - m;
            c2s.push((m - c1 - common) * invDx);
            c3s.push(common * invDx * invDx);
        }
        this.xs = xs;
        this.ys = ys;
        this.c1s = c1s;
        this.c2s = c2s;
        this.c3s = c3s;
    }
}


const $d78dec4035d30073$var$ELEMENT_NODE = 1;
function $d78dec4035d30073$export$8419e8612027b1d8(node) {
    const el = node.nodeType === $d78dec4035d30073$var$ELEMENT_NODE ? node : node.parentElement;
    if (!el) return null;
    const { top: top, left: left } = el.getBoundingClientRect();
    return {
        x: left,
        y: top
    };
}
function $d78dec4035d30073$export$710c829989c68339(e) {
    return {
        x: e.clientX,
        y: e.clientY
    };
}
function $d78dec4035d30073$var$isImageNode(node) {
    var ref;
    return node.nodeName === "IMG" && ((0, $96f329f02b21181f$export$b7d78993b74f766d)() || !((ref = document.documentElement) === null || ref === void 0 ? void 0 : ref.contains(node)));
}
function $d78dec4035d30073$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
    let dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
    let dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
    // Work around @2x coordinate discrepancies in browsers
    if ((0, $96f329f02b21181f$export$95df08bae54cb4df)() && isImage) {
        dragPreviewHeight /= window.devicePixelRatio;
        dragPreviewWidth /= window.devicePixelRatio;
    }
    return {
        dragPreviewWidth: dragPreviewWidth,
        dragPreviewHeight: dragPreviewHeight
    };
}
function $d78dec4035d30073$export$e99fdbb90efc75c5(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
    // The browsers will use the image intrinsic size under different conditions.
    // Firefox only cares if it's an image, but WebKit also wants it to be detached.
    const isImage = $d78dec4035d30073$var$isImageNode(dragPreview);
    const dragPreviewNode = isImage ? sourceNode : dragPreview;
    const dragPreviewNodeOffsetFromClient = $d78dec4035d30073$export$8419e8612027b1d8(dragPreviewNode);
    const offsetFromDragPreview = {
        x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
        y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
    };
    const { offsetWidth: sourceWidth, offsetHeight: sourceHeight } = sourceNode;
    const { anchorX: anchorX, anchorY: anchorY } = anchorPoint;
    const { dragPreviewWidth: dragPreviewWidth, dragPreviewHeight: dragPreviewHeight } = $d78dec4035d30073$var$getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight);
    const calculateYOffset = ()=>{
        const interpolantY = new (0, $68f404428cc9000a$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the top
            offsetFromDragPreview.y,
            // Align at the center
            offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
            // Dock to the bottom
            offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
        ]);
        let y = interpolantY.interpolate(anchorY);
        // Work around Safari 8 positioning bug
        if ((0, $96f329f02b21181f$export$95df08bae54cb4df)() && isImage) // We'll have to wait for @3x to see if this is entirely correct
        y += (window.devicePixelRatio - 1) * dragPreviewHeight;
        return y;
    };
    const calculateXOffset = ()=>{
        // Interpolate coordinates depending on anchor point
        // If you know a simpler way to do this, let me know
        const interpolantX = new (0, $68f404428cc9000a$export$6d87c156c5199b02)([
            0,
            0.5,
            1
        ], [
            // Dock to the left
            offsetFromDragPreview.x,
            // Align at the center
            offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
            // Dock to the right
            offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
        ]);
        return interpolantX.interpolate(anchorX);
    };
    // Force offsets if specified in the options.
    const { offsetX: offsetX, offsetY: offsetY } = offsetPoint;
    const isManualOffsetX = offsetX === 0 || offsetX;
    const isManualOffsetY = offsetY === 0 || offsetY;
    return {
        x: isManualOffsetX ? offsetX : calculateXOffset(),
        y: isManualOffsetY ? offsetY : calculateYOffset()
    };
}


class $84b07c9f669e1c3b$export$2b3a268803e49e64 {
    get window() {
        if (this.globalContext) return this.globalContext;
        else if (typeof window !== "undefined") return window;
        return undefined;
    }
    get document() {
        var ref;
        if ((ref = this.globalContext) === null || ref === void 0 ? void 0 : ref.document) return this.globalContext.document;
        else if (this.window) return this.window.document;
        else return undefined;
    }
    get rootElement() {
        var ref;
        return ((ref = this.optionsArgs) === null || ref === void 0 ? void 0 : ref.rootElement) || this.window;
    }
    constructor(globalContext, options){
        this.ownerDocument = null;
        this.globalContext = globalContext;
        this.optionsArgs = options;
    }
}


function $d38753b1f83fe69b$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d38753b1f83fe69b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            $d38753b1f83fe69b$var$_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
class $d38753b1f83fe69b$export$3a01990c235a9281 {
    /**
	 * Generate profiling statistics for the HTML5Backend.
	 */ profile() {
        var ref, ref1;
        return {
            sourcePreviewNodes: this.sourcePreviewNodes.size,
            sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
            sourceNodeOptions: this.sourceNodeOptions.size,
            sourceNodes: this.sourceNodes.size,
            dragStartSourceIds: ((ref = this.dragStartSourceIds) === null || ref === void 0 ? void 0 : ref.length) || 0,
            dropTargetIds: this.dropTargetIds.length,
            dragEnterTargetIds: this.dragEnterTargetIds.length,
            dragOverTargetIds: ((ref1 = this.dragOverTargetIds) === null || ref1 === void 0 ? void 0 : ref1.length) || 0
        };
    }
    // public for test
    get window() {
        return this.options.window;
    }
    get document() {
        return this.options.document;
    }
    /**
	 * Get the root element to use for event subscriptions
	 */ get rootElement() {
        return this.options.rootElement;
    }
    setup() {
        const root = this.rootElement;
        if (root === undefined) return;
        if (root.__isReactDndBackendSetUp) throw new Error("Cannot have two HTML5 backends at the same time.");
        root.__isReactDndBackendSetUp = true;
        this.addEventListeners(root);
    }
    teardown() {
        const root = this.rootElement;
        if (root === undefined) return;
        root.__isReactDndBackendSetUp = false;
        this.removeEventListeners(this.rootElement);
        this.clearCurrentDragSourceNode();
        if (this.asyncEndDragFrameId) {
            var ref;
            (ref = this.window) === null || ref === void 0 || ref.cancelAnimationFrame(this.asyncEndDragFrameId);
        }
    }
    connectDragPreview(sourceId, node, options) {
        this.sourcePreviewNodeOptions.set(sourceId, options);
        this.sourcePreviewNodes.set(sourceId, node);
        return ()=>{
            this.sourcePreviewNodes.delete(sourceId);
            this.sourcePreviewNodeOptions.delete(sourceId);
        };
    }
    connectDragSource(sourceId, node, options) {
        this.sourceNodes.set(sourceId, node);
        this.sourceNodeOptions.set(sourceId, options);
        const handleDragStart = (e)=>this.handleDragStart(e, sourceId);
        const handleSelectStart = (e)=>this.handleSelectStart(e);
        node.setAttribute("draggable", "true");
        node.addEventListener("dragstart", handleDragStart);
        node.addEventListener("selectstart", handleSelectStart);
        return ()=>{
            this.sourceNodes.delete(sourceId);
            this.sourceNodeOptions.delete(sourceId);
            node.removeEventListener("dragstart", handleDragStart);
            node.removeEventListener("selectstart", handleSelectStart);
            node.setAttribute("draggable", "false");
        };
    }
    connectDropTarget(targetId, node) {
        const handleDragEnter = (e)=>this.handleDragEnter(e, targetId);
        const handleDragOver = (e)=>this.handleDragOver(e, targetId);
        const handleDrop = (e)=>this.handleDrop(e, targetId);
        node.addEventListener("dragenter", handleDragEnter);
        node.addEventListener("dragover", handleDragOver);
        node.addEventListener("drop", handleDrop);
        return ()=>{
            node.removeEventListener("dragenter", handleDragEnter);
            node.removeEventListener("dragover", handleDragOver);
            node.removeEventListener("drop", handleDrop);
        };
    }
    addEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.addEventListener) return;
        target.addEventListener("dragstart", this.handleTopDragStart);
        target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.addEventListener("dragend", this.handleTopDragEndCapture, true);
        target.addEventListener("dragenter", this.handleTopDragEnter);
        target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.addEventListener("dragover", this.handleTopDragOver);
        target.addEventListener("dragover", this.handleTopDragOverCapture, true);
        target.addEventListener("drop", this.handleTopDrop);
        target.addEventListener("drop", this.handleTopDropCapture, true);
    }
    removeEventListeners(target) {
        // SSR Fix (https://github.com/react-dnd/react-dnd/pull/813
        if (!target.removeEventListener) return;
        target.removeEventListener("dragstart", this.handleTopDragStart);
        target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
        target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
        target.removeEventListener("dragenter", this.handleTopDragEnter);
        target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
        target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
        target.removeEventListener("dragover", this.handleTopDragOver);
        target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
        target.removeEventListener("drop", this.handleTopDrop);
        target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
    getCurrentSourceNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
        return $d38753b1f83fe69b$var$_objectSpread({
            dropEffect: this.altKeyPressed ? "copy" : "move"
        }, sourceNodeOptions || {});
    }
    getCurrentDropEffect() {
        if (this.isDraggingNativeItem()) // It makes more sense to default to 'copy' for native resources
        return "copy";
        return this.getCurrentSourceNodeOptions().dropEffect;
    }
    getCurrentSourcePreviewNodeOptions() {
        const sourceId = this.monitor.getSourceId();
        const sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
        return $d38753b1f83fe69b$var$_objectSpread({
            anchorX: 0.5,
            anchorY: 0.5,
            captureDraggingState: false
        }, sourcePreviewNodeOptions || {});
    }
    isDraggingNativeItem() {
        const itemType = this.monitor.getItemType();
        return Object.keys($0b5b3a44545fbee5$exports).some((key)=>$0b5b3a44545fbee5$exports[key] === itemType);
    }
    beginDragNativeItem(type, dataTransfer) {
        this.clearCurrentDragSourceNode();
        this.currentNativeSource = (0, $c9c27176219fce80$export$ada362c01636774d)(type, dataTransfer);
        this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
        this.actions.beginDrag([
            this.currentNativeHandle
        ]);
    }
    setCurrentDragSourceNode(node) {
        this.clearCurrentDragSourceNode();
        this.currentDragSourceNode = node;
        // A timeout of > 0 is necessary to resolve Firefox issue referenced
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        const MOUSE_MOVE_TIMEOUT = 1000;
        // Receiving a mouse event in the middle of a dragging operation
        // means it has ended and the drag source node disappeared from DOM,
        // so the browser didn't dispatch the dragend event.
        //
        // We need to wait before we start listening for mousemove events.
        // This is needed because the drag preview needs to be drawn or else it fires an 'mousemove' event
        // immediately in some browsers.
        //
        // See:
        //   * https://github.com/react-dnd/react-dnd/pull/928
        //   * https://github.com/react-dnd/react-dnd/issues/869
        //
        this.mouseMoveTimeoutTimer = setTimeout(()=>{
            var ref;
            return (ref = this.rootElement) === null || ref === void 0 ? void 0 : ref.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }, MOUSE_MOVE_TIMEOUT);
    }
    clearCurrentDragSourceNode() {
        if (this.currentDragSourceNode) {
            this.currentDragSourceNode = null;
            if (this.rootElement) {
                var ref;
                (ref = this.window) === null || ref === void 0 || ref.clearTimeout(this.mouseMoveTimeoutTimer || undefined);
                this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
            }
            this.mouseMoveTimeoutTimer = null;
            return true;
        }
        return false;
    }
    handleDragStart(e, sourceId) {
        if (e.defaultPrevented) return;
        if (!this.dragStartSourceIds) this.dragStartSourceIds = [];
        this.dragStartSourceIds.unshift(sourceId);
    }
    handleDragEnter(_e, targetId) {
        this.dragEnterTargetIds.unshift(targetId);
    }
    handleDragOver(_e, targetId) {
        if (this.dragOverTargetIds === null) this.dragOverTargetIds = [];
        this.dragOverTargetIds.unshift(targetId);
    }
    handleDrop(_e, targetId) {
        this.dropTargetIds.unshift(targetId);
    }
    constructor(manager, globalContext, options){
        this.sourcePreviewNodes = new Map();
        this.sourcePreviewNodeOptions = new Map();
        this.sourceNodes = new Map();
        this.sourceNodeOptions = new Map();
        this.dragStartSourceIds = null;
        this.dropTargetIds = [];
        this.dragEnterTargetIds = [];
        this.currentNativeSource = null;
        this.currentNativeHandle = null;
        this.currentDragSourceNode = null;
        this.altKeyPressed = false;
        this.mouseMoveTimeoutTimer = null;
        this.asyncEndDragFrameId = null;
        this.dragOverTargetIds = null;
        this.lastClientOffset = null;
        this.hoverRafId = null;
        this.getSourceClientOffset = (sourceId)=>{
            const source = this.sourceNodes.get(sourceId);
            return source && (0, $d78dec4035d30073$export$8419e8612027b1d8)(source) || null;
        };
        this.endDragNativeItem = ()=>{
            if (!this.isDraggingNativeItem()) return;
            this.actions.endDrag();
            if (this.currentNativeHandle) this.registry.removeSource(this.currentNativeHandle);
            this.currentNativeHandle = null;
            this.currentNativeSource = null;
        };
        this.isNodeInDocument = (node)=>{
            // Check the node either in the main document or in the current context
            return Boolean(node && this.document && this.document.body && this.document.body.contains(node));
        };
        this.endDragIfSourceWasRemovedFromDOM = ()=>{
            const node = this.currentDragSourceNode;
            if (node == null || this.isNodeInDocument(node)) return;
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.scheduleHover = (dragOverTargetIds)=>{
            if (this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") this.hoverRafId = requestAnimationFrame(()=>{
                if (this.monitor.isDragging()) this.actions.hover(dragOverTargetIds || [], {
                    clientOffset: this.lastClientOffset
                });
                this.hoverRafId = null;
            });
        };
        this.cancelHover = ()=>{
            if (this.hoverRafId !== null && typeof cancelAnimationFrame !== "undefined") {
                cancelAnimationFrame(this.hoverRafId);
                this.hoverRafId = null;
            }
        };
        this.handleTopDragStartCapture = ()=>{
            this.clearCurrentDragSourceNode();
            this.dragStartSourceIds = [];
        };
        this.handleTopDragStart = (e)=>{
            if (e.defaultPrevented) return;
            const { dragStartSourceIds: dragStartSourceIds } = this;
            this.dragStartSourceIds = null;
            const clientOffset = (0, $d78dec4035d30073$export$710c829989c68339)(e);
            // Avoid crashing if we missed a drop event or our previous drag died
            if (this.monitor.isDragging()) {
                this.actions.endDrag();
                this.cancelHover();
            }
            // Don't publish the source just yet (see why below)
            this.actions.beginDrag(dragStartSourceIds || [], {
                publishSource: false,
                getSourceClientOffset: this.getSourceClientOffset,
                clientOffset: clientOffset
            });
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $c9c27176219fce80$export$11b547ed8c182c11)(dataTransfer);
            if (this.monitor.isDragging()) {
                if (dataTransfer && typeof dataTransfer.setDragImage === "function") {
                    // Use custom drag image if user specifies it.
                    // If child drag source refuses drag but parent agrees,
                    // use parent's node as drag image. Neither works in IE though.
                    const sourceId = this.monitor.getSourceId();
                    const sourceNode = this.sourceNodes.get(sourceId);
                    const dragPreview = this.sourcePreviewNodes.get(sourceId) || sourceNode;
                    if (dragPreview) {
                        const { anchorX: anchorX, anchorY: anchorY, offsetX: offsetX, offsetY: offsetY } = this.getCurrentSourcePreviewNodeOptions();
                        const anchorPoint = {
                            anchorX: anchorX,
                            anchorY: anchorY
                        };
                        const offsetPoint = {
                            offsetX: offsetX,
                            offsetY: offsetY
                        };
                        const dragPreviewOffset = (0, $d78dec4035d30073$export$e99fdbb90efc75c5)(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
                        dataTransfer.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
                    }
                }
                try {
                    // Firefox won't drag without setting data
                    dataTransfer === null || dataTransfer === void 0 || dataTransfer.setData("application/json", {});
                } catch (err) {
                // IE doesn't support MIME types in setData
                }
                // Store drag source node so we can check whether
                // it is removed from DOM and trigger endDrag manually.
                this.setCurrentDragSourceNode(e.target);
                // Now we are ready to publish the drag source.. or are we not?
                const { captureDraggingState: captureDraggingState } = this.getCurrentSourcePreviewNodeOptions();
                if (!captureDraggingState) // Usually we want to publish it in the next tick so that browser
                // is able to screenshot the current (not yet dragging) state.
                //
                // It also neatly avoids a situation where render() returns null
                // in the same tick for the source element, and browser freaks out.
                setTimeout(()=>this.actions.publishDragSource(), 0);
                else // In some cases the user may want to override this behavior, e.g.
                // to work around IE not supporting custom drag previews.
                //
                // When using a custom drag layer, the only way to prevent
                // the default drag preview from drawing in IE is to screenshot
                // the dragging state in which the node itself has zero opacity
                // and height. In this case, though, returning null from render()
                // will abruptly end the dragging, which is not obvious.
                //
                // This is the reason such behavior is strictly opt-in.
                this.actions.publishDragSource();
            } else if (nativeType) // A native item (such as URL) dragged from inside the document
            this.beginDragNativeItem(nativeType);
            else if (dataTransfer && !dataTransfer.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) // Looks like a Safari bug: dataTransfer.types is null, but there was no draggable.
            // Just let it drag. It's a native type (URL or text) and will be picked up in
            // dragenter handler.
            return;
            else // If by this time no drag source reacted, tell browser not to drag.
            e.preventDefault();
        };
        this.handleTopDragEndCapture = ()=>{
            if (this.clearCurrentDragSourceNode() && this.monitor.isDragging()) // Firefox can dispatch this event in an infinite loop
            // if dragend handler does something like showing an alert.
            // Only proceed if we have not handled it already.
            this.actions.endDrag();
            this.cancelHover();
        };
        this.handleTopDragEnterCapture = (e)=>{
            this.dragEnterTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
            const isFirstEnter = this.enterLeaveCounter.enter(e.target);
            if (!isFirstEnter || this.monitor.isDragging()) return;
            const { dataTransfer: dataTransfer } = e;
            const nativeType = (0, $c9c27176219fce80$export$11b547ed8c182c11)(dataTransfer);
            if (nativeType) // A native item (such as file or URL) dragged from outside the document
            this.beginDragNativeItem(nativeType, dataTransfer);
        };
        this.handleTopDragEnter = (e)=>{
            const { dragEnterTargetIds: dragEnterTargetIds } = this;
            this.dragEnterTargetIds = [];
            if (!this.monitor.isDragging()) // This is probably a native item type we don't understand.
            return;
            this.altKeyPressed = e.altKey;
            // If the target changes position as the result of `dragenter`, `dragover` might still
            // get dispatched despite target being no longer there. The easy solution is to check
            // whether there actually is a target before firing `hover`.
            if (dragEnterTargetIds.length > 0) this.actions.hover(dragEnterTargetIds, {
                clientOffset: (0, $d78dec4035d30073$export$710c829989c68339)(e)
            });
            const canDrop = dragEnterTargetIds.some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // IE requires this to fire dragover events
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            }
        };
        this.handleTopDragOverCapture = (e)=>{
            this.dragOverTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            }
        };
        this.handleTopDragOver = (e)=>{
            const { dragOverTargetIds: dragOverTargetIds } = this;
            this.dragOverTargetIds = [];
            if (!this.monitor.isDragging()) {
                // This is probably a native item type we don't understand.
                // Prevent default "drop and blow away the whole document" action.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
                return;
            }
            this.altKeyPressed = e.altKey;
            this.lastClientOffset = (0, $d78dec4035d30073$export$710c829989c68339)(e);
            this.scheduleHover(dragOverTargetIds);
            const canDrop = (dragOverTargetIds || []).some((targetId)=>this.monitor.canDropOnTarget(targetId));
            if (canDrop) {
                // Show user-specified drop effect.
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = this.getCurrentDropEffect();
            } else if (this.isDraggingNativeItem()) // Don't show a nice cursor but still prevent default
            // "drop and blow away the whole document" action.
            e.preventDefault();
            else {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = "none";
            }
        };
        this.handleTopDragLeaveCapture = (e)=>{
            if (this.isDraggingNativeItem()) e.preventDefault();
            const isLastLeave = this.enterLeaveCounter.leave(e.target);
            if (!isLastLeave) return;
            if (this.isDraggingNativeItem()) setTimeout(()=>this.endDragNativeItem(), 0);
            this.cancelHover();
        };
        this.handleTopDropCapture = (e)=>{
            this.dropTargetIds = [];
            if (this.isDraggingNativeItem()) {
                var ref;
                e.preventDefault();
                (ref = this.currentNativeSource) === null || ref === void 0 || ref.loadDataTransfer(e.dataTransfer);
            } else if ((0, $c9c27176219fce80$export$11b547ed8c182c11)(e.dataTransfer)) // Dragging some elements, like <a> and <img> may still behave like a native drag event,
            // even if the current drag event matches a user-defined type.
            // Stop the default behavior when we're not expecting a native item to be dropped.
            e.preventDefault();
            this.enterLeaveCounter.reset();
        };
        this.handleTopDrop = (e)=>{
            const { dropTargetIds: dropTargetIds } = this;
            this.dropTargetIds = [];
            this.actions.hover(dropTargetIds, {
                clientOffset: (0, $d78dec4035d30073$export$710c829989c68339)(e)
            });
            this.actions.drop({
                dropEffect: this.getCurrentDropEffect()
            });
            if (this.isDraggingNativeItem()) this.endDragNativeItem();
            else if (this.monitor.isDragging()) this.actions.endDrag();
            this.cancelHover();
        };
        this.handleSelectStart = (e)=>{
            const target = e.target;
            // Only IE requires us to explicitly say
            // we want drag drop operation to start
            if (typeof target.dragDrop !== "function") return;
            // Inputs and textareas should be selectable
            if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) return;
            // For other targets, ask IE
            // to enable drag and drop
            e.preventDefault();
            target.dragDrop();
        };
        this.options = new (0, $84b07c9f669e1c3b$export$2b3a268803e49e64)(globalContext, options);
        this.actions = manager.getActions();
        this.monitor = manager.getMonitor();
        this.registry = manager.getRegistry();
        this.enterLeaveCounter = new (0, $b4aab0ba906821ab$export$9ff3e6eb5c734d0d)(this.isNodeInDocument);
    }
}




const $d07499cdeaef0f1a$export$f4f61d779bb20744 = function createBackend(manager, context, options) {
    return new (0, $d38753b1f83fe69b$export$3a01990c235a9281)(manager, context, options);
};


var $6e5386ec45973bc7$export$8e6c816465ea7419;
var $6e5386ec45973bc7$export$7061c75fc5af8b7e;
$6e5386ec45973bc7$export$8e6c816465ea7419 = `_2SKKNa_dragging`;
$6e5386ec45973bc7$export$7061c75fc5af8b7e = `_2SKKNa_item`;


const $541e14af8d36ef17$export$237bd83162c14364 = /*#__PURE__*/ (0, $eCoWV.createContext)({
    isDragging: false
});
function $541e14af8d36ef17$var$DragDropProvider({ children: children }) {
    const [isDragging, setIsDragging] = (0, $eCoWV.useState)(false);
    const memorizedContext = (0, $eCoWV.useMemo)(()=>({
            isDragging: isDragging,
            setIsDragging: setIsDragging
        }), [
        isDragging
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)($541e14af8d36ef17$export$237bd83162c14364.Provider, {
        value: memorizedContext,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4892b00fc6b8e509$export$9861489d68213f9c), {
            backend: (0, $d07499cdeaef0f1a$export$f4f61d779bb20744),
            children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: (0, $5CQIb.conditionalString)(isDragging && $6e5386ec45973bc7$export$8e6c816465ea7419),
                children: children
            })
        })
    });
}
var $541e14af8d36ef17$export$2e2bcd8739ae039 = $541e14af8d36ef17$var$DragDropProvider;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $00aa3430309f3c0c$exports = {};
"use strict";
// do not edit .js files directly - edit src/index.jst
$00aa3430309f3c0c$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == "object" && typeof b == "object") {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};



var $eCoWV = parcelRequire("eCoWV");

var $eCoWV = parcelRequire("eCoWV");
const $7883307e872fe323$export$700979bc83e7db82 = typeof window !== "undefined" ? (0, $eCoWV.useLayoutEffect) : (0, $eCoWV.useEffect);


function $6f9ea94cf5be2b79$export$e32e64a4387f290a(monitor, collect, onUpdate) {
    const [collected, setCollected] = (0, $eCoWV.useState)(()=>collect(monitor));
    const updateCollected = (0, $eCoWV.useCallback)(()=>{
        const nextValue = collect(monitor);
        // This needs to be a deep-equality check because some monitor-collected values
        // include XYCoord objects that may be equivalent, but do not have instance equality.
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($00aa3430309f3c0c$exports)))(collected, nextValue)) {
            setCollected(nextValue);
            if (onUpdate) onUpdate();
        }
    }, [
        collected,
        monitor,
        onUpdate
    ]);
    // update the collected properties after react renders.
    // Note that the "Dustbin Stress Test" fails if this is not
    // done when the component updates
    (0, $7883307e872fe323$export$700979bc83e7db82)(updateCollected);
    return [
        collected,
        updateCollected
    ];
}



function $5a4e9910841b54ee$export$f34439a5e43bd79c(monitor, collect, onCollect) {
    const [collected, updateCollected] = (0, $6f9ea94cf5be2b79$export$e32e64a4387f290a)(monitor, collect, onCollect);
    (0, $7883307e872fe323$export$700979bc83e7db82)(function subscribeToMonitorStateChange() {
        const handlerId = monitor.getHandlerId();
        if (handlerId == null) return;
        return monitor.subscribeToStateChange(updateCollected, {
            handlerIds: [
                handlerId
            ]
        });
    }, [
        monitor,
        updateCollected
    ]);
    return collected;
}


function $76999b75d33f70a3$export$a55a4e3c0acb6f15(collector, monitor, connector) {
    return (0, $5a4e9910841b54ee$export$f34439a5e43bd79c)(monitor, collector || (()=>({})), ()=>connector.reconnect());
}



var $eCoWV = parcelRequire("eCoWV");
function $03e6532e6299a644$export$f16a07909151e918(arg, deps) {
    const memoDeps = [
        ...deps || []
    ];
    if (deps == null && typeof arg !== "function") memoDeps.push(arg);
    return (0, $eCoWV.useMemo)(()=>{
        return typeof arg === "function" ? arg() : arg;
    }, memoDeps);
}



var $eCoWV = parcelRequire("eCoWV");
function $0c2c420ba2b242cc$export$90c397533e0cc6(connector) {
    return (0, $eCoWV.useMemo)(()=>connector.hooks.dragSource(), [
        connector
    ]);
}
function $0c2c420ba2b242cc$export$a66b3011bc8970d6(connector) {
    return (0, $eCoWV.useMemo)(()=>connector.hooks.dragPreview(), [
        connector
    ]);
}



var $eCoWV = parcelRequire("eCoWV");
function $b08da2ba1fc55006$export$d36bdfa510afb180(objA, objB, compare, compareContext) {
    let compareResult = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (compareResult !== void 0) return !!compareResult;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    const bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(let idx = 0; idx < keysA.length; idx++){
        const key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        const valueA = objA[key];
        const valueB = objB[key];
        compareResult = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (compareResult === false || compareResult === void 0 && valueA !== valueB) return false;
    }
    return true;
}


function $93daac6b9910c28f$export$4f9f5282de18fc69(obj) {
    return obj !== null && typeof obj === "object" && Object.prototype.hasOwnProperty.call(obj, "current");
}




var $eCoWV = parcelRequire("eCoWV");
function $03281fcb94166fce$var$throwIfCompositeComponentElement(element) {
    // Custom components can no longer be wrapped directly in React DnD 2.0
    // so that we don't need to depend on findDOMNode() from react-dom.
    if (typeof element.type === "string") return;
    const displayName = element.type.displayName || element.type.name || "the component";
    throw new Error("Only native element nodes can now be passed to React DnD connectors." + `You can either wrap ${displayName} into a <div>, or turn it into a ` + "drag source or a drop target itself.");
}
function $03281fcb94166fce$var$wrapHookToRecognizeElement(hook) {
    return (elementOrNode = null, options = null)=>{
        // When passed a node, call the hook straight away.
        if (!(0, $eCoWV.isValidElement)(elementOrNode)) {
            const node = elementOrNode;
            hook(node, options);
            // return the node so it can be chained (e.g. when within callback refs
            // <div ref={node => connectDragSource(connectDropTarget(node))}/>
            return node;
        }
        // If passed a ReactElement, clone it and attach this function as a ref.
        // This helps us achieve a neat API where user doesn't even know that refs
        // are being used under the hood.
        const element = elementOrNode;
        $03281fcb94166fce$var$throwIfCompositeComponentElement(element);
        // When no options are passed, use the hook directly
        const ref = options ? (node)=>hook(node, options) : hook;
        return $03281fcb94166fce$var$cloneWithRef(element, ref);
    };
}
function $03281fcb94166fce$export$d8dcaf80ab4f6cb7(hooks) {
    const wrappedHooks = {};
    Object.keys(hooks).forEach((key)=>{
        const hook = hooks[key];
        // ref objects should be passed straight through without wrapping
        if (key.endsWith("Ref")) wrappedHooks[key] = hooks[key];
        else {
            const wrappedHook = $03281fcb94166fce$var$wrapHookToRecognizeElement(hook);
            wrappedHooks[key] = ()=>wrappedHook;
        }
    });
    return wrappedHooks;
}
function $03281fcb94166fce$var$setRef(ref, node) {
    if (typeof ref === "function") ref(node);
    else ref.current = node;
}
function $03281fcb94166fce$var$cloneWithRef(element, newRef) {
    const previousRef = element.ref;
    (0, $98d484686087a39e$export$f5708dca728d7177)(typeof previousRef !== "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs");
    if (!previousRef) // When there is no ref on the element, use the new ref directly
    return (0, $eCoWV.cloneElement)(element, {
        ref: newRef
    });
    else return (0, $eCoWV.cloneElement)(element, {
        ref: (node)=>{
            $03281fcb94166fce$var$setRef(previousRef, node);
            $03281fcb94166fce$var$setRef(newRef, node);
        }
    });
}


class $63ae1eb6d78ade17$export$9a7176fb37ab5028 {
    receiveHandlerId(newHandlerId) {
        if (this.handlerId === newHandlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get connectTarget() {
        return this.dragSource;
    }
    get dragSourceOptions() {
        return this.dragSourceOptionsInternal;
    }
    set dragSourceOptions(options) {
        this.dragSourceOptionsInternal = options;
    }
    get dragPreviewOptions() {
        return this.dragPreviewOptionsInternal;
    }
    set dragPreviewOptions(options) {
        this.dragPreviewOptionsInternal = options;
    }
    reconnect() {
        const didChange = this.reconnectDragSource();
        this.reconnectDragPreview(didChange);
    }
    reconnectDragSource() {
        const dragSource = this.dragSource;
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
        if (didChange) this.disconnectDragSource();
        if (!this.handlerId) return didChange;
        if (!dragSource) {
            this.lastConnectedDragSource = dragSource;
            return didChange;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragSource = dragSource;
            this.lastConnectedDragSourceOptions = this.dragSourceOptions;
            this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, dragSource, this.dragSourceOptions);
        }
        return didChange;
    }
    reconnectDragPreview(forceDidChange = false) {
        const dragPreview = this.dragPreview;
        // if nothing has changed then don't resubscribe
        const didChange = forceDidChange || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
        if (didChange) this.disconnectDragPreview();
        if (!this.handlerId) return;
        if (!dragPreview) {
            this.lastConnectedDragPreview = dragPreview;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDragPreview = dragPreview;
            this.lastConnectedDragPreviewOptions = this.dragPreviewOptions;
            this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, dragPreview, this.dragPreviewOptions);
        }
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didConnectedDragSourceChange() {
        return this.lastConnectedDragSource !== this.dragSource;
    }
    didConnectedDragPreviewChange() {
        return this.lastConnectedDragPreview !== this.dragPreview;
    }
    didDragSourceOptionsChange() {
        return !(0, $b08da2ba1fc55006$export$d36bdfa510afb180)(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
    }
    didDragPreviewOptionsChange() {
        return !(0, $b08da2ba1fc55006$export$d36bdfa510afb180)(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
    }
    disconnectDragSource() {
        if (this.dragSourceUnsubscribe) {
            this.dragSourceUnsubscribe();
            this.dragSourceUnsubscribe = undefined;
        }
    }
    disconnectDragPreview() {
        if (this.dragPreviewUnsubscribe) {
            this.dragPreviewUnsubscribe();
            this.dragPreviewUnsubscribe = undefined;
            this.dragPreviewNode = null;
            this.dragPreviewRef = null;
        }
    }
    get dragSource() {
        return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
    }
    get dragPreview() {
        return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
    }
    clearDragSource() {
        this.dragSourceNode = null;
        this.dragSourceRef = null;
    }
    clearDragPreview() {
        this.dragPreviewNode = null;
        this.dragPreviewRef = null;
    }
    constructor(backend){
        this.hooks = (0, $03281fcb94166fce$export$d8dcaf80ab4f6cb7)({
            dragSource: (node, options)=>{
                this.clearDragSource();
                this.dragSourceOptions = options || null;
                if ((0, $93daac6b9910c28f$export$4f9f5282de18fc69)(node)) this.dragSourceRef = node;
                else this.dragSourceNode = node;
                this.reconnectDragSource();
            },
            dragPreview: (node, options)=>{
                this.clearDragPreview();
                this.dragPreviewOptions = options || null;
                if ((0, $93daac6b9910c28f$export$4f9f5282de18fc69)(node)) this.dragPreviewRef = node;
                else this.dragPreviewNode = node;
                this.reconnectDragPreview();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dragSourceRef = null;
        this.dragSourceOptionsInternal = null;
        // The drag preview may either be attached via ref or connect function
        this.dragPreviewRef = null;
        this.dragPreviewOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDragSource = null;
        this.lastConnectedDragSourceOptions = null;
        this.lastConnectedDragPreview = null;
        this.lastConnectedDragPreviewOptions = null;
        this.backend = backend;
    }
}




var $eCoWV = parcelRequire("eCoWV");

function $ec459b4e203537ca$export$49db7e1a057ab0fa() {
    const { dragDropManager: dragDropManager } = (0, $eCoWV.useContext)((0, $6993ae53f6be0cb9$export$2d5c5ceac203fc1e));
    (0, $98d484686087a39e$export$f5708dca728d7177)(dragDropManager != null, "Expected drag drop context");
    return dragDropManager;
}



function $68402919eb2c5b4a$export$a5dfa024c6f78e86(dragSourceOptions, dragPreviewOptions) {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    const connector = (0, $eCoWV.useMemo)(()=>new (0, $63ae1eb6d78ade17$export$9a7176fb37ab5028)(manager.getBackend()), [
        manager
    ]);
    (0, $7883307e872fe323$export$700979bc83e7db82)(()=>{
        connector.dragSourceOptions = dragSourceOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragSource();
    }, [
        connector,
        dragSourceOptions
    ]);
    (0, $7883307e872fe323$export$700979bc83e7db82)(()=>{
        connector.dragPreviewOptions = dragPreviewOptions || null;
        connector.reconnect();
        return ()=>connector.disconnectDragPreview();
    }, [
        connector,
        dragPreviewOptions
    ]);
    return connector;
}



var $eCoWV = parcelRequire("eCoWV");

let $0575d4b0e1a8f649$var$isCallingCanDrag = false;
let $0575d4b0e1a8f649$var$isCallingIsDragging = false;
class $0575d4b0e1a8f649$export$af934094fb48ddf {
    receiveHandlerId(sourceId) {
        this.sourceId = sourceId;
    }
    getHandlerId() {
        return this.sourceId;
    }
    canDrag() {
        (0, $98d484686087a39e$export$f5708dca728d7177)(!$0575d4b0e1a8f649$var$isCallingCanDrag, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $0575d4b0e1a8f649$var$isCallingCanDrag = true;
            return this.internalMonitor.canDragSource(this.sourceId);
        } finally{
            $0575d4b0e1a8f649$var$isCallingCanDrag = false;
        }
    }
    isDragging() {
        if (!this.sourceId) return false;
        (0, $98d484686087a39e$export$f5708dca728d7177)(!$0575d4b0e1a8f649$var$isCallingIsDragging, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
        try {
            $0575d4b0e1a8f649$var$isCallingIsDragging = true;
            return this.internalMonitor.isDraggingSource(this.sourceId);
        } finally{
            $0575d4b0e1a8f649$var$isCallingIsDragging = false;
        }
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    isDraggingSource(sourceId) {
        return this.internalMonitor.isDraggingSource(sourceId);
    }
    isOverTarget(targetId, options) {
        return this.internalMonitor.isOverTarget(targetId, options);
    }
    getTargetIds() {
        return this.internalMonitor.getTargetIds();
    }
    isSourcePublic() {
        return this.internalMonitor.isSourcePublic();
    }
    getSourceId() {
        return this.internalMonitor.getSourceId();
    }
    subscribeToOffsetChange(listener) {
        return this.internalMonitor.subscribeToOffsetChange(listener);
    }
    canDragSource(sourceId) {
        return this.internalMonitor.canDragSource(sourceId);
    }
    canDropOnTarget(targetId) {
        return this.internalMonitor.canDropOnTarget(targetId);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.sourceId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $db25b4510181de02$export$82f95eab323fcd7a() {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    return (0, $eCoWV.useMemo)(()=>new (0, $0575d4b0e1a8f649$export$af934094fb48ddf)(manager), [
        manager
    ]);
}


function $a0f5122bec5f0014$export$38b18180ae58b09b(type, target, manager) {
    const registry = manager.getRegistry();
    const targetId = registry.addTarget(type, target);
    return [
        targetId,
        ()=>registry.removeTarget(targetId)
    ];
}
function $a0f5122bec5f0014$export$51c814b9e17958c(type, source, manager) {
    const registry = manager.getRegistry();
    const sourceId = registry.addSource(type, source);
    return [
        sourceId,
        ()=>registry.removeSource(sourceId)
    ];
}





var $eCoWV = parcelRequire("eCoWV");
class $a4246c261a00e2c1$export$680f0a3c92f9d645 {
    beginDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        let result = null;
        if (typeof spec.item === "object") result = spec.item;
        else if (typeof spec.item === "function") result = spec.item(monitor);
        else result = {};
        return result !== null && result !== void 0 ? result : null;
    }
    canDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (typeof spec.canDrag === "boolean") return spec.canDrag;
        else if (typeof spec.canDrag === "function") return spec.canDrag(monitor);
        else return true;
    }
    isDragging(globalMonitor, target) {
        const spec = this.spec;
        const monitor = this.monitor;
        const { isDragging: isDragging } = spec;
        return isDragging ? isDragging(monitor) : target === globalMonitor.getSourceId();
    }
    endDrag() {
        const spec = this.spec;
        const monitor = this.monitor;
        const connector = this.connector;
        const { end: end } = spec;
        if (end) end(monitor.getItem(), monitor);
        connector.reconnect();
    }
    constructor(spec, monitor, connector){
        this.spec = spec;
        this.monitor = monitor;
        this.connector = connector;
    }
}


function $a48db26fd5abf302$export$cdddb20adb7aad5c(spec, monitor, connector) {
    const handler = (0, $eCoWV.useMemo)(()=>new (0, $a4246c261a00e2c1$export$680f0a3c92f9d645)(spec, monitor, connector), [
        monitor,
        connector
    ]);
    (0, $eCoWV.useEffect)(()=>{
        handler.spec = spec;
    }, [
        spec
    ]);
    return handler;
}




var $eCoWV = parcelRequire("eCoWV");
function $4c86ebbfe161b89c$export$dec3a5d742510a3f(spec) {
    return (0, $eCoWV.useMemo)(()=>{
        const result = spec.type;
        (0, $98d484686087a39e$export$f5708dca728d7177)(result != null, "spec.type must be defined");
        return result;
    }, [
        spec
    ]);
}


function $045005e02de0a821$export$1bdd19ff5ac2e03c(spec, monitor, connector) {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    const handler = (0, $a48db26fd5abf302$export$cdddb20adb7aad5c)(spec, monitor, connector);
    const itemType = (0, $4c86ebbfe161b89c$export$dec3a5d742510a3f)(spec);
    (0, $7883307e872fe323$export$700979bc83e7db82)(function registerDragSource() {
        if (itemType != null) {
            const [handlerId, unregister] = (0, $a0f5122bec5f0014$export$51c814b9e17958c)(itemType, handler, manager);
            monitor.receiveHandlerId(handlerId);
            connector.receiveHandlerId(handlerId);
            return unregister;
        }
        return;
    }, [
        manager,
        monitor,
        connector,
        handler,
        itemType
    ]);
}


function $b9f03c87e4113056$export$7941f8aafa4b6021(specArg, deps) {
    const spec = (0, $03e6532e6299a644$export$f16a07909151e918)(specArg, deps);
    (0, $98d484686087a39e$export$f5708dca728d7177)(!spec.begin, `useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)`);
    const monitor = (0, $db25b4510181de02$export$82f95eab323fcd7a)();
    const connector = (0, $68402919eb2c5b4a$export$a5dfa024c6f78e86)(spec.options, spec.previewOptions);
    (0, $045005e02de0a821$export$1bdd19ff5ac2e03c)(spec, monitor, connector);
    return [
        (0, $76999b75d33f70a3$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $0c2c420ba2b242cc$export$90c397533e0cc6)(connector),
        (0, $0c2c420ba2b242cc$export$a66b3011bc8970d6)(connector)
    ];
}




var $eCoWV = parcelRequire("eCoWV");
function $7f0ef09c23009713$export$c914595a34b9504a(connector) {
    return (0, $eCoWV.useMemo)(()=>connector.hooks.dropTarget(), [
        connector
    ]);
}



var $eCoWV = parcelRequire("eCoWV");



class $012837f5fe9a4016$export$ed6d7b7bc55193cf {
    get connectTarget() {
        return this.dropTarget;
    }
    reconnect() {
        // if nothing has changed then don't resubscribe
        const didChange = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
        if (didChange) this.disconnectDropTarget();
        const dropTarget = this.dropTarget;
        if (!this.handlerId) return;
        if (!dropTarget) {
            this.lastConnectedDropTarget = dropTarget;
            return;
        }
        if (didChange) {
            this.lastConnectedHandlerId = this.handlerId;
            this.lastConnectedDropTarget = dropTarget;
            this.lastConnectedDropTargetOptions = this.dropTargetOptions;
            this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, dropTarget, this.dropTargetOptions);
        }
    }
    receiveHandlerId(newHandlerId) {
        if (newHandlerId === this.handlerId) return;
        this.handlerId = newHandlerId;
        this.reconnect();
    }
    get dropTargetOptions() {
        return this.dropTargetOptionsInternal;
    }
    set dropTargetOptions(options) {
        this.dropTargetOptionsInternal = options;
    }
    didHandlerIdChange() {
        return this.lastConnectedHandlerId !== this.handlerId;
    }
    didDropTargetChange() {
        return this.lastConnectedDropTarget !== this.dropTarget;
    }
    didOptionsChange() {
        return !(0, $b08da2ba1fc55006$export$d36bdfa510afb180)(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
    }
    disconnectDropTarget() {
        if (this.unsubscribeDropTarget) {
            this.unsubscribeDropTarget();
            this.unsubscribeDropTarget = undefined;
        }
    }
    get dropTarget() {
        return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
    }
    clearDropTarget() {
        this.dropTargetRef = null;
        this.dropTargetNode = null;
    }
    constructor(backend){
        this.hooks = (0, $03281fcb94166fce$export$d8dcaf80ab4f6cb7)({
            dropTarget: (node, options)=>{
                this.clearDropTarget();
                this.dropTargetOptions = options;
                if ((0, $93daac6b9910c28f$export$4f9f5282de18fc69)(node)) this.dropTargetRef = node;
                else this.dropTargetNode = node;
                this.reconnect();
            }
        });
        this.handlerId = null;
        // The drop target may either be attached via ref or connect function
        this.dropTargetRef = null;
        this.dropTargetOptionsInternal = null;
        this.lastConnectedHandlerId = null;
        this.lastConnectedDropTarget = null;
        this.lastConnectedDropTargetOptions = null;
        this.backend = backend;
    }
}




function $fea8f9e943fdb8c5$export$29242ded1aad6df7(options) {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    const connector = (0, $eCoWV.useMemo)(()=>new (0, $012837f5fe9a4016$export$ed6d7b7bc55193cf)(manager.getBackend()), [
        manager
    ]);
    (0, $7883307e872fe323$export$700979bc83e7db82)(()=>{
        connector.dropTargetOptions = options || null;
        connector.reconnect();
        return ()=>connector.disconnectDropTarget();
    }, [
        options
    ]);
    return connector;
}



var $eCoWV = parcelRequire("eCoWV");

let $9de35c855387c5bd$var$isCallingCanDrop = false;
class $9de35c855387c5bd$export$9fe8834769ae8ddf {
    receiveHandlerId(targetId) {
        this.targetId = targetId;
    }
    getHandlerId() {
        return this.targetId;
    }
    subscribeToStateChange(listener, options) {
        return this.internalMonitor.subscribeToStateChange(listener, options);
    }
    canDrop() {
        // Cut out early if the target id has not been set. This should prevent errors
        // where the user has an older version of dnd-core like in
        // https://github.com/react-dnd/react-dnd/issues/1310
        if (!this.targetId) return false;
        (0, $98d484686087a39e$export$f5708dca728d7177)(!$9de35c855387c5bd$var$isCallingCanDrop, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
        try {
            $9de35c855387c5bd$var$isCallingCanDrop = true;
            return this.internalMonitor.canDropOnTarget(this.targetId);
        } finally{
            $9de35c855387c5bd$var$isCallingCanDrop = false;
        }
    }
    isOver(options) {
        if (!this.targetId) return false;
        return this.internalMonitor.isOverTarget(this.targetId, options);
    }
    getItemType() {
        return this.internalMonitor.getItemType();
    }
    getItem() {
        return this.internalMonitor.getItem();
    }
    getDropResult() {
        return this.internalMonitor.getDropResult();
    }
    didDrop() {
        return this.internalMonitor.didDrop();
    }
    getInitialClientOffset() {
        return this.internalMonitor.getInitialClientOffset();
    }
    getInitialSourceClientOffset() {
        return this.internalMonitor.getInitialSourceClientOffset();
    }
    getSourceClientOffset() {
        return this.internalMonitor.getSourceClientOffset();
    }
    getClientOffset() {
        return this.internalMonitor.getClientOffset();
    }
    getDifferenceFromInitialOffset() {
        return this.internalMonitor.getDifferenceFromInitialOffset();
    }
    constructor(manager){
        this.targetId = null;
        this.internalMonitor = manager.getMonitor();
    }
}



function $74524083d3814ba8$export$f0c0ad05844dec3b() {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    return (0, $eCoWV.useMemo)(()=>new (0, $9de35c855387c5bd$export$9fe8834769ae8ddf)(manager), [
        manager
    ]);
}







var $eCoWV = parcelRequire("eCoWV");
function $c2b4a4960a3df40c$export$2a5cc7f0ac8651d0(spec) {
    const { accept: accept } = spec;
    return (0, $eCoWV.useMemo)(()=>{
        (0, $98d484686087a39e$export$f5708dca728d7177)(spec.accept != null, "accept must be defined");
        return Array.isArray(accept) ? accept : [
            accept
        ];
    }, [
        accept
    ]);
}



var $eCoWV = parcelRequire("eCoWV");
class $ec9dcc872a8c022d$export$f26a17703f5cb233 {
    canDrop() {
        const spec = this.spec;
        const monitor = this.monitor;
        return spec.canDrop ? spec.canDrop(monitor.getItem(), monitor) : true;
    }
    hover() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.hover) spec.hover(monitor.getItem(), monitor);
    }
    drop() {
        const spec = this.spec;
        const monitor = this.monitor;
        if (spec.drop) return spec.drop(monitor.getItem(), monitor);
        return;
    }
    constructor(spec, monitor){
        this.spec = spec;
        this.monitor = monitor;
    }
}


function $6290ab20437e2a9e$export$5967d4bb72ce3c0(spec, monitor) {
    const dropTarget = (0, $eCoWV.useMemo)(()=>new (0, $ec9dcc872a8c022d$export$f26a17703f5cb233)(spec, monitor), [
        monitor
    ]);
    (0, $eCoWV.useEffect)(()=>{
        dropTarget.spec = spec;
    }, [
        spec
    ]);
    return dropTarget;
}


function $8cbe8d86b70aef11$export$b31a008bfacf9de1(spec, monitor, connector) {
    const manager = (0, $ec459b4e203537ca$export$49db7e1a057ab0fa)();
    const dropTarget = (0, $6290ab20437e2a9e$export$5967d4bb72ce3c0)(spec, monitor);
    const accept = (0, $c2b4a4960a3df40c$export$2a5cc7f0ac8651d0)(spec);
    (0, $7883307e872fe323$export$700979bc83e7db82)(function registerDropTarget() {
        const [handlerId, unregister] = (0, $a0f5122bec5f0014$export$38b18180ae58b09b)(accept, dropTarget, manager);
        monitor.receiveHandlerId(handlerId);
        connector.receiveHandlerId(handlerId);
        return unregister;
    }, [
        manager,
        monitor,
        dropTarget,
        connector,
        accept.map((a)=>a.toString()).join("|")
    ]);
}


function $5e497e0091c68dfe$export$ccdee5eaf73cf661(specArg, deps) {
    const spec = (0, $03e6532e6299a644$export$f16a07909151e918)(specArg, deps);
    const monitor = (0, $74524083d3814ba8$export$f0c0ad05844dec3b)();
    const connector = (0, $fea8f9e943fdb8c5$export$29242ded1aad6df7)(spec.options);
    (0, $8cbe8d86b70aef11$export$b31a008bfacf9de1)(spec, monitor, connector);
    return [
        (0, $76999b75d33f70a3$export$a55a4e3c0acb6f15)(spec.collect, monitor, connector),
        (0, $7f0ef09c23009713$export$c914595a34b9504a)(connector)
    ];
}



function $8704194ee8361ed2$var$DraggableItem({ id: id, children: children, sortIndex: sortIndex, moveItem: moveItem, dragType: dragType = "DraggableItem", className: className }) {
    const ref = (0, $eCoWV.useRef)(null);
    const { setIsDragging: setIsDragging } = (0, $eCoWV.useContext)((0, $541e14af8d36ef17$export$237bd83162c14364));
    const [{ handlerId: handlerId }, drop] = (0, $5e497e0091c68dfe$export$ccdee5eaf73cf661)({
        accept: dragType,
        collect (monitor) {
            return {
                handlerId: monitor.getHandlerId()
            };
        },
        hover (item, monitor) {
            if (!ref.current) return;
            const dragIndex = item.sortIndex;
            const hoverIndex = sortIndex;
            // Don't replace items with themselves
            if (dragIndex === hoverIndex) return;
            // Determine rectangle on screen
            const hoverBoundingRect = ref.current.getBoundingClientRect();
            // Get vertical middle
            const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
            // Determine mouse position
            const clientOffset = monitor.getClientOffset();
            // Get pixels to the top
            const hoverClientY = (clientOffset?.y ?? 0) - hoverBoundingRect.top;
            // Only perform the move when the mouse has crossed half of the items height
            // When dragging downwards, only move when the cursor is below 50%
            // When dragging upwards, only move when the cursor is above 50%
            // Dragging downwards
            if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) return;
            // Dragging upwards
            if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) return;
            // Time to actually perform the action
            moveItem(dragIndex, hoverIndex);
            // Note: we're mutating the monitor item here!
            // Generally it's better to avoid mutations,
            // but it's good here for the sake of performance
            // to avoid expensive index searches.
            // eslint-disable-next-line @silverhand/fp/no-mutation
            item.sortIndex = hoverIndex;
        }
    });
    const [{ isDragging: isDragging }, drag] = (0, $b9f03c87e4113056$export$7941f8aafa4b6021)({
        type: dragType,
        item: ()=>{
            return {
                id: id,
                sortIndex: sortIndex
            };
        },
        collect: (monitor)=>({
                isDragging: monitor.isDragging()
            })
    });
    const opacity = isDragging ? 0 : 1;
    drag(drop(ref));
    (0, $eCoWV.useEffect)(()=>{
        setIsDragging?.(isDragging);
    }, [
        setIsDragging,
        isDragging
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        ref: ref,
        style: {
            opacity: opacity
        },
        "data-handler-id": handlerId,
        className: className,
        children: children
    });
}
var $8704194ee8361ed2$export$2e2bcd8739ae039 = $8704194ee8361ed2$var$DraggableItem;





var $eCoWV = parcelRequire("eCoWV");

var $2mi28 = parcelRequire("2mi28");
const $f1193a3a0c21d7b7$var$useEnabledConnectorTypes = ()=>{
    const { data: connectors } = (0, $2mi28.default)("api/connectors");
    const enabledConnectorTypes = (0, $eCoWV.useMemo)(()=>connectors?.map(({ type: type })=>type) ?? [], [
        connectors
    ]);
    const isConnectorTypeEnabled = (0, $eCoWV.useCallback)((connectorType)=>enabledConnectorTypes.includes(connectorType), [
        enabledConnectorTypes
    ]);
    return {
        isConnectorTypeEnabled: isConnectorTypeEnabled
    };
};
var $f1193a3a0c21d7b7$export$2e2bcd8739ae039 = $f1193a3a0c21d7b7$var$useEnabledConnectorTypes;




parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");

const $6e7d37c6140453c5$export$2696fec11b4dc54c = (signInIdentifier, signUpConfig, currentCheckState)=>{
    if (signInIdentifier === (0, $bd0Y0.SignInIdentifier).Username) return currentCheckState;
    const { password: isSignUpPasswordRequired } = signUpConfig;
    return isSignUpPasswordRequired || currentCheckState;
};
const $6e7d37c6140453c5$export$6f13fc330d708d53 = (signInIdentifier, signUpConfig, currentCheckState)=>{
    if (signInIdentifier === (0, $bd0Y0.SignInIdentifier).Username) return currentCheckState;
    const { identifier: signUpIdentifier, password: isSignUpPasswordRequired } = signUpConfig;
    if ((0, $c346ed781c4c9623$export$69ec1500fb2141d2).None !== signUpIdentifier && !isSignUpPasswordRequired) return true;
    return currentCheckState;
};
const $6e7d37c6140453c5$export$79c0a739e7155c5f = (identifier)=>({
        identifier: identifier,
        password: true,
        verificationCode: identifier !== (0, $bd0Y0.SignInIdentifier).Username,
        isPasswordPrimary: true
    });



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $ecDp6 = parcelRequire("ecDp6");




var $beb9d34f8b738a23$export$c52a2c2535ad2bcb;
var $beb9d34f8b738a23$export$20de9a48f0a5642d;
var $beb9d34f8b738a23$export$8bf4ce924aca1720;
var $beb9d34f8b738a23$export$1455c8f2746d9c06;
var $beb9d34f8b738a23$export$50021cec2d6efdb6;
var $beb9d34f8b738a23$export$a3bc9b8ed74fc;
var $beb9d34f8b738a23$export$493b5823483d2c4e;
var $beb9d34f8b738a23$export$c2ab62c7bf24634;
var $beb9d34f8b738a23$export$3304639b795b6ae;
var $beb9d34f8b738a23$export$bfd64c937657f93a;
var $beb9d34f8b738a23$export$4a6dd88bada4e7d2;
var $beb9d34f8b738a23$export$3b952bca719b842;
var $beb9d34f8b738a23$export$200aa4c63e47ca8c;
var $beb9d34f8b738a23$export$ad45c99c3690e609;
var $beb9d34f8b738a23$export$cb0615a09427c07b;
$beb9d34f8b738a23$export$c52a2c2535ad2bcb = `A4GuyW_addAnotherSignInMethodDropdown`;
$beb9d34f8b738a23$export$20de9a48f0a5642d = `A4GuyW_addSignInMethodDropDown`;
$beb9d34f8b738a23$export$8bf4ce924aca1720 = `A4GuyW_authentication`;
$beb9d34f8b738a23$export$1455c8f2746d9c06 = `A4GuyW_draggableIcon`;
$beb9d34f8b738a23$export$50021cec2d6efdb6 = `A4GuyW_draggleItemContainer`;
$beb9d34f8b738a23$export$a3bc9b8ed74fc = `A4GuyW_error`;
$beb9d34f8b738a23$export$493b5823483d2c4e = `A4GuyW_errorMessage`;
$beb9d34f8b738a23$export$c2ab62c7bf24634 = `A4GuyW_identifier`;
$beb9d34f8b738a23$export$3304639b795b6ae = `A4GuyW_plusIcon`;
$beb9d34f8b738a23$export$bfd64c937657f93a = `A4GuyW_rotating`;
$beb9d34f8b738a23$export$4a6dd88bada4e7d2 = `A4GuyW_shimmer`;
$beb9d34f8b738a23$export$3b952bca719b842 = `A4GuyW_signInMethod`;
$beb9d34f8b738a23$export$200aa4c63e47ca8c = `A4GuyW_signInMethodItem`;
$beb9d34f8b738a23$export$ad45c99c3690e609 = `A4GuyW_swapButton`;
$beb9d34f8b738a23$export$cb0615a09427c07b = `A4GuyW_verifyCodePrimary`;


function $a588839b40042dac$var$AddButton({ options: options, onSelected: onSelected, hasSelectedIdentifiers: hasSelectedIdentifiers }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    if (options.length === 0) return null;
    const addSignInMethodButtonProps = {
        type: "default",
        size: "medium",
        title: "sign_in_exp.sign_up_and_sign_in.sign_in.add_sign_in_method",
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {
            className: $beb9d34f8b738a23$export$3304639b795b6ae
        })
    };
    const addAnotherButtonProps = {
        type: "text",
        size: "small",
        title: "general.add_another",
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {})
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
        buttonProps: hasSelectedIdentifiers ? addAnotherButtonProps : addSignInMethodButtonProps,
        dropdownHorizontalAlign: "start",
        dropdownClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(hasSelectedIdentifiers ? $beb9d34f8b738a23$export$c52a2c2535ad2bcb : $beb9d34f8b738a23$export$20de9a48f0a5642d),
        isDropdownFullWidth: !hasSelectedIdentifiers,
        children: options.map((identifier)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onSelected(identifier);
                },
                children: t((0, $61e23b9bb15ba266$export$c54a2f6297ba7cbe)[identifier])
            }, identifier))
    });
}
var $a588839b40042dac$export$2e2bcd8739ae039 = $a588839b40042dac$var$AddButton;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bd0Y0 = parcelRequire("bd0Y0");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $7d6ca795f4bff861$var$SvgDraggable = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M6 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM6 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM6 14.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 5.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0ZM11 14.5a1.5 1.5 0 1 0 3 0 1.5 1.5 0 0 0-3 0Z",
            fill: "currentColor"
        })
    });
var $7d6ca795f4bff861$export$2e2bcd8739ae039 = $7d6ca795f4bff861$var$SvgDraggable;



var $gCKnS = parcelRequire("gCKnS");



var $9bgsA = parcelRequire("9bgsA");
parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $9XAkT = parcelRequire("9XAkT");

var $1Iq4D = parcelRequire("1Iq4D");


var $b6f0f4edfcf6a67f$export$b31f6ae88848cf15;
var $b6f0f4edfcf6a67f$export$bfd64c937657f93a;
var $b6f0f4edfcf6a67f$export$4a6dd88bada4e7d2;
$b6f0f4edfcf6a67f$export$b31f6ae88848cf15 = `_46F7ca_notice`;
$b6f0f4edfcf6a67f$export$bfd64c937657f93a = `_46F7ca_rotating`;
$b6f0f4edfcf6a67f$export$4a6dd88bada4e7d2 = `_46F7ca_shimmer`;


function $39059442e46fd1c9$var$ConnectorSetupWarning({ requiredConnectors: requiredConnectors }) {
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $f1193a3a0c21d7b7$export$2e2bcd8739ae039)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const missingConnectors = requiredConnectors.filter((connectorType)=>!isConnectorTypeEnabled(connectorType));
    if (missingConnectors.length === 0) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9zeGj.Fragment), {
        children: missingConnectors.map((connectorType)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
                className: $b6f0f4edfcf6a67f$export$b31f6ae88848cf15,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            to: connectorType === (0, $fU2Vo.ConnectorType).Social ? "/connectors/social" : "/connectors"
                        })
                    },
                    children: t((0, $61e23b9bb15ba266$export$119b0ebfd4dd4005)[connectorType], {
                        link: t("sign_in_exp.setup_warning.setup_link")
                    })
                })
            }, connectorType))
    });
}
var $39059442e46fd1c9$export$2e2bcd8739ae039 = $39059442e46fd1c9$var$ConnectorSetupWarning;



function $2ce72fe249c7eccd$var$SignInMethodItem({ signInMethod: { identifier: identifier, password: password, verificationCode: verificationCode, isPasswordPrimary: isPasswordPrimary }, isPasswordCheckable: isPasswordCheckable, isVerificationCodeCheckable: isVerificationCodeCheckable, isDeletable: isDeletable, requiredConnectors: requiredConnectors, hasError: hasError, errorMessage: errorMessage, onVerificationStateChange: onVerificationStateChange, onToggleVerificationPrimary: onToggleVerificationPrimary, onDelete: onDelete }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $beb9d34f8b738a23$export$200aa4c63e47ca8c,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($beb9d34f8b738a23$export$3b952bca719b842, hasError && $beb9d34f8b738a23$export$a3bc9b8ed74fc),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $beb9d34f8b738a23$export$c2ab62c7bf24634,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d6ca795f4bff861$export$2e2bcd8739ae039), {
                                        className: $beb9d34f8b738a23$export$1455c8f2746d9c06
                                    }),
                                    t((0, $61e23b9bb15ba266$export$c54a2f6297ba7cbe)[identifier])
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($beb9d34f8b738a23$export$8bf4ce924aca1720, !isPasswordPrimary && $beb9d34f8b738a23$export$cb0615a09427c07b),
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_in.password_auth"),
                                        checked: password,
                                        disabled: !isPasswordCheckable,
                                        tooltip: (0, $5CQIb.conditional)(!isPasswordCheckable && t("sign_in_exp.sign_up_and_sign_in.tip.password_auth")),
                                        onChange: (checked)=>{
                                            onVerificationStateChange("password", checked);
                                        }
                                    }),
                                    identifier !== (0, $bd0Y0.SignInIdentifier).Username && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                                anchorClassName: $beb9d34f8b738a23$export$ad45c99c3690e609,
                                                content: t("sign_in_exp.sign_up_and_sign_in.sign_in.auth_swap_tip"),
                                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                                    onClick: onToggleVerificationPrimary,
                                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $56f925fc5afe39c9$export$2e2bcd8739ae039), {})
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                                                label: t("sign_in_exp.sign_up_and_sign_in.sign_in.verification_code_auth"),
                                                checked: verificationCode,
                                                disabled: !isVerificationCodeCheckable,
                                                tooltip: (0, $5CQIb.conditional)(!isVerificationCodeCheckable && t("sign_in_exp.sign_up_and_sign_in.tip.verification_code_auth")),
                                                onChange: (checked)=>{
                                                    onVerificationStateChange("verificationCode", checked);
                                                }
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                        content: (0, $5CQIb.conditional)(!isDeletable && t("sign_in_exp.sign_up_and_sign_in.tip.delete_sign_in_method", {
                            identifier: String(t((0, $61e23b9bb15ba266$export$c54a2f6297ba7cbe)[identifier])).toLocaleLowerCase()
                        })),
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            disabled: !isDeletable,
                            onClick: onDelete,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $gCKnS.default), {})
                        })
                    })
                ]
            }, identifier),
            errorMessage && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $beb9d34f8b738a23$export$493b5823483d2c4e,
                children: errorMessage
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $39059442e46fd1c9$export$2e2bcd8739ae039), {
                requiredConnectors: requiredConnectors
            })
        ]
    });
}
var $2ce72fe249c7eccd$export$2e2bcd8739ae039 = $2ce72fe249c7eccd$var$SignInMethodItem;



function $91e32b69ff866b60$var$SignInMethodEditBox() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, watch: watch, trigger: trigger, formState: { submitCount: submitCount } } = (0, $c3LX9.useFormContext)();
    const signUp = watch("signUp");
    const { fields: fields, swap: swap, update: update, remove: remove, append: append } = (0, $c3LX9.useFieldArray)({
        control: control,
        name: "signIn.methods"
    });
    const revalidate = ()=>{
        if (submitCount) // Note: wait for the form to be updated before validating the new data.
        setTimeout(()=>{
            trigger("signIn.methods");
        }, 0);
    };
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $f1193a3a0c21d7b7$export$2e2bcd8739ae039)();
    if (!signUp) return null;
    const { identifier: signUpIdentifier, password: isSignUpPasswordRequired, verify: isSignUpVerificationRequired } = signUp;
    const requiredSignInIdentifiers = (0, $61e23b9bb15ba266$export$6ce44f6619762c02)[signUpIdentifier];
    const ignoredWarningConnectors = (0, $68842e5e9cc0281c$export$765847ef858119f6)(signUpIdentifier);
    const signInIdentifierOptions = (0, $61e23b9bb15ba266$export$b0ad61f2357dff83).filter((candidateIdentifier)=>fields.every(({ identifier: identifier })=>identifier !== candidateIdentifier));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $541e14af8d36ef17$export$2e2bcd8739ae039), {
                children: fields.map((signInMethod, index)=>{
                    const { id: id, identifier: identifier, verificationCode: verificationCode, isPasswordPrimary: isPasswordPrimary } = signInMethod;
                    const signInRelatedConnector = (0, $61e23b9bb15ba266$export$b918f3278c9100b2)[identifier];
                    const requiredConnectors = (0, $5CQIb.conditional)(verificationCode && signInRelatedConnector && !ignoredWarningConnectors.includes(signInRelatedConnector) && [
                        signInRelatedConnector
                    ]) ?? [];
                    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8704194ee8361ed2$export$2e2bcd8739ae039), {
                        id: id,
                        sortIndex: index,
                        moveItem: swap,
                        className: $beb9d34f8b738a23$export$50021cec2d6efdb6,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                            control: control,
                            name: `signIn.methods.${index}`,
                            rules: {
                                validate: ({ password: password, verificationCode: verificationCode })=>{
                                    if (!password && !verificationCode) return t("sign_in_exp.sign_up_and_sign_in.sign_in.require_auth_factor");
                                    if (verificationCode && requiredConnectors.some((connectorType)=>!isConnectorTypeEnabled(connectorType))) // Note: when required connectors are not all enabled, we show error state without error message for we have the connector setup warning
                                    return false;
                                    return true;
                                }
                            },
                            render: ({ field: { value: value }, fieldState: { error: error } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $2ce72fe249c7eccd$export$2e2bcd8739ae039), {
                                    signInMethod: value,
                                    isPasswordCheckable: identifier !== (0, $bd0Y0.SignInIdentifier).Username && !isSignUpPasswordRequired,
                                    isVerificationCodeCheckable: !(isSignUpVerificationRequired && !isSignUpPasswordRequired),
                                    isDeletable: !requiredSignInIdentifiers.includes(identifier),
                                    requiredConnectors: requiredConnectors,
                                    hasError: Boolean(error),
                                    errorMessage: error?.message,
                                    onVerificationStateChange: (verification, checked)=>{
                                        update(index, {
                                            ...value,
                                            [verification]: checked
                                        });
                                        revalidate();
                                    },
                                    onToggleVerificationPrimary: ()=>{
                                        update(index, {
                                            ...value,
                                            isPasswordPrimary: !isPasswordPrimary
                                        });
                                        revalidate();
                                    },
                                    onDelete: ()=>{
                                        remove(index);
                                        revalidate();
                                    }
                                })
                        })
                    }, id);
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a588839b40042dac$export$2e2bcd8739ae039), {
                options: signInIdentifierOptions,
                hasSelectedIdentifiers: fields.length > 0,
                onSelected: (identifier)=>{
                    append((0, $6e7d37c6140453c5$export$79c0a739e7155c5f)(identifier));
                    revalidate();
                }
            })
        ]
    });
}
var $91e32b69ff866b60$export$2e2bcd8739ae039 = $91e32b69ff866b60$var$SignInMethodEditBox;


function $3d3e7988db6f46ee$var$SignInForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.sign_up_and_sign_in.sign_in.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_in.sign_in_identifier_and_auth",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$f71f035a831fd7a7,
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_in.description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $91e32b69ff866b60$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
}
var $3d3e7988db6f46ee$export$2e2bcd8739ae039 = $3d3e7988db6f46ee$var$SignInForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $1UQTm = parcelRequire("1UQTm");


var $dADBR = parcelRequire("dADBR");








function $bcfacd721f55629b$var$SignUpForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, setValue: setValue, getValues: getValues, watch: watch, trigger: trigger, formState: { errors: errors, submitCount: submitCount } } = (0, $c3LX9.useFormContext)();
    const { isConnectorTypeEnabled: isConnectorTypeEnabled } = (0, $f1193a3a0c21d7b7$export$2e2bcd8739ae039)();
    const signUp = watch("signUp");
    if (!signUp) return null;
    const { identifier: signUpIdentifier } = signUp;
    const isUsernamePasswordSignUp = signUpIdentifier === (0, $c346ed781c4c9623$export$69ec1500fb2141d2).Username;
    const postSignUpIdentifierChange = (signUpIdentifier)=>{
        if (signUpIdentifier === (0, $c346ed781c4c9623$export$69ec1500fb2141d2).Username) {
            setValue("signUp.password", true);
            setValue("signUp.verify", false);
            return;
        }
        if (signUpIdentifier === (0, $c346ed781c4c9623$export$69ec1500fb2141d2).None) {
            setValue("signUp.password", false);
            setValue("signUp.verify", false);
            return;
        }
        if ((0, $68842e5e9cc0281c$export$df47f60a13d5578b)(signUpIdentifier)) setValue("signUp.verify", true);
    };
    const refreshSignInMethods = ()=>{
        const signInMethods = getValues("signIn.methods");
        const { identifier: signUpIdentifier } = signUp;
        // Note: append required sign-in methods according to the sign-up identifier config
        const requiredSignInIdentifiers = (0, $61e23b9bb15ba266$export$6ce44f6619762c02)[signUpIdentifier];
        const allSignInMethods = requiredSignInIdentifiers.reduce((methods, requiredIdentifier)=>{
            if (signInMethods.some(({ identifier: identifier })=>identifier === requiredIdentifier)) return methods;
            return [
                ...methods,
                (0, $6e7d37c6140453c5$export$79c0a739e7155c5f)(requiredIdentifier)
            ];
        }, signInMethods);
        setValue("signIn.methods", // Note: refresh sign-in authentications according to the sign-up authentications config
        allSignInMethods.map((method)=>{
            const { identifier: identifier, password: password, verificationCode: verificationCode } = method;
            return {
                ...method,
                password: (0, $6e7d37c6140453c5$export$2696fec11b4dc54c)(identifier, signUp, password),
                verificationCode: (0, $6e7d37c6140453c5$export$6f13fc330d708d53)(identifier, signUp, verificationCode)
            };
        }));
        // Note: we need to revalidate the sign-in methods after we have submitted
        if (submitCount) // Note: wait for the form to be updated before validating the new data.
        setTimeout(()=>{
            trigger("signIn.methods");
        }, 0);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.sign_up_and_sign_in.sign_up.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_up.sign_up_identifier",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$f71f035a831fd7a7,
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_up.identifier_description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "signUp.identifier",
                        control: control,
                        rules: {
                            validate: (value)=>{
                                return (0, $68842e5e9cc0281c$export$765847ef858119f6)(value).every((connectorType)=>isConnectorTypeEnabled(connectorType));
                            }
                        },
                        render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                                value: value,
                                error: Boolean(errors.signUp?.identifier),
                                options: (0, $61e23b9bb15ba266$export$370e1bd33b1689cd).map((identifier)=>({
                                        value: identifier,
                                        title: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                            children: [
                                                t((0, $61e23b9bb15ba266$export$2d3509a8eccb8b17)[identifier]),
                                                identifier === (0, $c346ed781c4c9623$export$69ec1500fb2141d2).None && /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                                    className: $293be6a893027faa$export$56cec662996de3c,
                                                    children: t("sign_in_exp.sign_up_and_sign_in.sign_up.social_only_creation_description")
                                                })
                                            ]
                                        })
                                    })),
                                onChange: (value)=>{
                                    if (!value) return;
                                    onChange(value);
                                    postSignUpIdentifierChange(value);
                                    refreshSignInMethods();
                                }
                            })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $39059442e46fd1c9$export$2e2bcd8739ae039), {
                        requiredConnectors: (0, $68842e5e9cc0281c$export$765847ef858119f6)(signUpIdentifier)
                    })
                ]
            }),
            signUpIdentifier !== (0, $c346ed781c4c9623$export$69ec1500fb2141d2).None && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.sign_up.sign_up_authentication",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$f71f035a831fd7a7,
                        children: t("sign_in_exp.sign_up_and_sign_in.sign_up.authentication_description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $293be6a893027faa$export$4ea6092c933ebdb5,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                name: "signUp.password",
                                control: control,
                                render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_up.set_a_password_option"),
                                        disabled: isUsernamePasswordSignUp,
                                        checked: value,
                                        tooltip: (0, $5CQIb.conditional)(isUsernamePasswordSignUp && t("sign_in_exp.sign_up_and_sign_in.tip.set_a_password")),
                                        onChange: (value)=>{
                                            onChange(value);
                                            refreshSignInMethods();
                                        }
                                    })
                            }),
                            (0, $68842e5e9cc0281c$export$df47f60a13d5578b)(signUpIdentifier) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                                name: "signUp.verify",
                                control: control,
                                render: ({ field: { value: value, onChange: onChange } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fd557585b642c791$export$2e2bcd8739ae039), {
                                        disabled: true,
                                        label: t("sign_in_exp.sign_up_and_sign_in.sign_up.verify_at_sign_up_option"),
                                        checked: value,
                                        tooltip: t("sign_in_exp.sign_up_and_sign_in.tip.verify_at_sign_up"),
                                        onChange: (value)=>{
                                            onChange(value);
                                            refreshSignInMethods();
                                        }
                                    })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $bcfacd721f55629b$export$2e2bcd8739ae039 = $bcfacd721f55629b$var$SignUpForm;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $1UQTm = parcelRequire("1UQTm");

var $dADBR = parcelRequire("dADBR");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $fU2Vo = parcelRequire("fU2Vo");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $1Iq4D = parcelRequire("1Iq4D");



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");

var $ecDp6 = parcelRequire("ecDp6");






var $6e7f8b09d42740b2$export$fdddc8db4e8f3828;
var $6e7f8b09d42740b2$export$81207e5cc4186890;
var $6e7f8b09d42740b2$export$1ca1ec8b29a4ce27;
var $6e7f8b09d42740b2$export$a8ff84c12d48cfa6;
var $6e7f8b09d42740b2$export$3304639b795b6ae;
var $6e7f8b09d42740b2$export$bfd64c937657f93a;
var $6e7f8b09d42740b2$export$4a6dd88bada4e7d2;
var $6e7f8b09d42740b2$export$fb184b623420d9be;
$6e7f8b09d42740b2$export$fdddc8db4e8f3828 = `_8sspFa_addAnotherDropdown`;
$6e7f8b09d42740b2$export$81207e5cc4186890 = `_8sspFa_dropdown`;
$6e7f8b09d42740b2$export$1ca1ec8b29a4ce27 = `_8sspFa_icon`;
$6e7f8b09d42740b2$export$a8ff84c12d48cfa6 = `_8sspFa_name`;
$6e7f8b09d42740b2$export$3304639b795b6ae = `_8sspFa_plusIcon`;
$6e7f8b09d42740b2$export$bfd64c937657f93a = `_8sspFa_rotating`;
$6e7f8b09d42740b2$export$4a6dd88bada4e7d2 = `_8sspFa_shimmer`;
$6e7f8b09d42740b2$export$fb184b623420d9be = `_8sspFa_title`;


function $ab3281d60df8a406$var$AddButton({ options: options, onSelected: onSelected, hasSelectedConnectors: hasSelectedConnectors }) {
    if (options.length === 0) return null;
    const addSocialConnectorButtonProps = {
        type: "default",
        size: "medium",
        title: "sign_in_exp.sign_up_and_sign_in.social_sign_in.add_social_connector",
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {
            className: $6e7f8b09d42740b2$export$3304639b795b6ae
        })
    };
    const addAnotherButtonProps = {
        type: "text",
        size: "small",
        title: "general.add_another",
        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {})
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
        buttonProps: hasSelectedConnectors ? addAnotherButtonProps : addSocialConnectorButtonProps,
        dropdownHorizontalAlign: "start",
        dropdownClassName: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(hasSelectedConnectors ? $6e7f8b09d42740b2$export$fdddc8db4e8f3828 : $6e7f8b09d42740b2$export$81207e5cc4186890),
        children: options.map(({ target: target, logo: logo, logoDark: logoDark, name: name, connectors: connectors })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                onClick: ()=>{
                    onSelected(target);
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $6e7f8b09d42740b2$export$fb184b623420d9be,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                            data: {
                                logo: logo,
                                logoDark: logoDark
                            },
                            size: "small"
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                            resource: name,
                            className: $6e7f8b09d42740b2$export$a8ff84c12d48cfa6
                        }),
                        connectors.length > 1 && connectors.map(({ platform: platform })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $6e7f8b09d42740b2$export$1ca1ec8b29a4ce27,
                                children: platform && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b1a590d94aaaa586$export$2e2bcd8739ae039), {
                                    platform: platform
                                })
                            }, platform))
                    ]
                })
            }, target))
    });
}
var $ab3281d60df8a406$export$2e2bcd8739ae039 = $ab3281d60df8a406$var$AddButton;



var $9zeGj = parcelRequire("9zeGj");


var $gCKnS = parcelRequire("gCKnS");



var $9bgsA = parcelRequire("9bgsA");

var $2beb1242dc692490$export$1455c8f2746d9c06;
var $2beb1242dc692490$export$1ca1ec8b29a4ce27;
var $2beb1242dc692490$export$a80b3bd66acc52ff;
var $2beb1242dc692490$export$7061c75fc5af8b7e;
var $2beb1242dc692490$export$a8ff84c12d48cfa6;
var $2beb1242dc692490$export$bfd64c937657f93a;
var $2beb1242dc692490$export$4a6dd88bada4e7d2;
$2beb1242dc692490$export$1455c8f2746d9c06 = `cK8lyq_draggableIcon`;
$2beb1242dc692490$export$1ca1ec8b29a4ce27 = `cK8lyq_icon`;
$2beb1242dc692490$export$a80b3bd66acc52ff = `cK8lyq_info`;
$2beb1242dc692490$export$7061c75fc5af8b7e = `cK8lyq_item`;
$2beb1242dc692490$export$a8ff84c12d48cfa6 = `cK8lyq_name`;
$2beb1242dc692490$export$bfd64c937657f93a = `cK8lyq_rotating`;
$2beb1242dc692490$export$4a6dd88bada4e7d2 = `cK8lyq_shimmer`;


function $c9e6e10060060b3e$var$SelectedConnectorItem({ data: { logo: logo, logoDark: logoDark, target: target, name: name, connectors: connectors }, onDelete: onDelete }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $2beb1242dc692490$export$7061c75fc5af8b7e,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $2beb1242dc692490$export$a80b3bd66acc52ff,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7d6ca795f4bff861$export$2e2bcd8739ae039), {
                        className: $2beb1242dc692490$export$1455c8f2746d9c06
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $705b04999648836d$export$2e2bcd8739ae039), {
                        data: {
                            logo: logo,
                            logoDark: logoDark
                        },
                        size: "small"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
                        resource: name,
                        className: $2beb1242dc692490$export$a8ff84c12d48cfa6
                    }),
                    connectors.length > 1 && connectors.map(({ platform: platform })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $2beb1242dc692490$export$1ca1ec8b29a4ce27,
                            children: platform && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b1a590d94aaaa586$export$2e2bcd8739ae039), {
                                platform: platform
                            })
                        }, platform))
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                onClick: ()=>{
                    onDelete(target);
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $gCKnS.default), {})
            })
        ]
    });
}
var $c9e6e10060060b3e$export$2e2bcd8739ae039 = $c9e6e10060060b3e$var$SelectedConnectorItem;


var $6496d06c8eb8168f$export$50021cec2d6efdb6;
var $6496d06c8eb8168f$export$bfd64c937657f93a;
var $6496d06c8eb8168f$export$95dd8163eacc2ed3;
var $6496d06c8eb8168f$export$de27182ff8187d6c;
var $6496d06c8eb8168f$export$4a6dd88bada4e7d2;
$6496d06c8eb8168f$export$50021cec2d6efdb6 = `GhWS2q_draggleItemContainer`;
$6496d06c8eb8168f$export$bfd64c937657f93a = `GhWS2q_rotating`;
$6496d06c8eb8168f$export$95dd8163eacc2ed3 = `GhWS2q_setUpHint`;
$6496d06c8eb8168f$export$de27182ff8187d6c = `GhWS2q_setup`;
$6496d06c8eb8168f$export$4a6dd88bada4e7d2 = `GhWS2q_shimmer`;


function $c28a4028f87bcef9$var$SocialConnectorEditBox({ value: value, onChange: onChange }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: connectorData, error: error } = (0, $00909ead6d3649b8$export$2e2bcd8739ae039)();
    if (!connectorData || error) return null;
    const onMoveItem = (dragIndex, hoverIndex)=>{
        const dragItem = value[dragIndex];
        const hoverItem = value[hoverIndex];
        if (!dragItem || !hoverItem) return;
        onChange(value.map((value_, index)=>{
            if (index === dragIndex) return hoverItem;
            if (index === hoverIndex) return dragItem;
            return value_;
        }));
    };
    const socialConnectors = connectorData.filter(({ type: type })=>type === (0, $fU2Vo.ConnectorType).Social);
    const selectedConnectorItems = value.map((connectorTarget)=>socialConnectors.find(({ target: target })=>target === connectorTarget))// eslint-disable-next-line unicorn/prefer-native-coercion-functions
    .filter((item)=>Boolean(item));
    const connectorOptions = socialConnectors.filter(({ target: target })=>!value.includes(target));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $541e14af8d36ef17$export$2e2bcd8739ae039), {
                children: selectedConnectorItems.map((item, index)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $8704194ee8361ed2$export$2e2bcd8739ae039), {
                        id: item.id,
                        sortIndex: index,
                        moveItem: onMoveItem,
                        className: $6496d06c8eb8168f$export$50021cec2d6efdb6,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c9e6e10060060b3e$export$2e2bcd8739ae039), {
                            data: item,
                            onDelete: (target)=>{
                                onChange(value.filter((connectorTarget)=>connectorTarget !== target));
                            }
                        })
                    }, item.id))
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ab3281d60df8a406$export$2e2bcd8739ae039), {
                options: connectorOptions,
                hasSelectedConnectors: selectedConnectorItems.length > 0,
                onSelected: (target)=>{
                    onChange([
                        ...value,
                        target
                    ]);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $39059442e46fd1c9$export$2e2bcd8739ae039), {
                requiredConnectors: [
                    (0, $fU2Vo.ConnectorType).Social
                ]
            }),
            socialConnectors.length > 0 && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $6496d06c8eb8168f$export$95dd8163eacc2ed3,
                children: [
                    t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.not_in_list"),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                        to: "/connectors/social",
                        className: $6496d06c8eb8168f$export$de27182ff8187d6c,
                        children: t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.set_up_more")
                    }),
                    t("sign_in_exp.sign_up_and_sign_in.social_sign_in.set_up_hint.go_to")
                ]
            })
        ]
    });
}
var $c28a4028f87bcef9$export$2e2bcd8739ae039 = $c28a4028f87bcef9$var$SocialConnectorEditBox;


function $f1641053fae73542$var$SocialSignInForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $1UQTm.default), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $293be6a893027faa$export$fb184b623420d9be,
                children: t("sign_in_exp.sign_up_and_sign_in.social_sign_in.title")
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "sign_in_exp.sign_up_and_sign_in.social_sign_in.social_sign_in",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $293be6a893027faa$export$f71f035a831fd7a7,
                        children: t("sign_in_exp.sign_up_and_sign_in.social_sign_in.description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        control: control,
                        defaultValue: [],
                        name: "socialSignInConnectorTargets",
                        render: ({ field: { value: value, onChange: onChange } })=>{
                            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c28a4028f87bcef9$export$2e2bcd8739ae039), {
                                value: value,
                                onChange: onChange
                            });
                        }
                    })
                ]
            })
        ]
    });
}
var $f1641053fae73542$export$2e2bcd8739ae039 = $f1641053fae73542$var$SocialSignInForm;


function $19ddcc7fcac1f1b1$var$SignUpAndSignIn({ isActive: isActive }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dbded6c841f8ee49$export$2e2bcd8739ae039), {
        isActive: isActive,
        className: $293be6a893027faa$export$bda7fe321f6bbcf1,
        children: [
            isActive && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "sign_in_exp.tabs.sign_up_and_sign_in",
                    "sign_in_exp.page_title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcfacd721f55629b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3d3e7988db6f46ee$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f1641053fae73542$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ca7a9eeae81e0a88$export$2e2bcd8739ae039), {})
        ]
    });
}
var $19ddcc7fcac1f1b1$export$2e2bcd8739ae039 = $19ddcc7fcac1f1b1$var$SignUpAndSignIn;



var $c40b4b371a14037f$export$8ce28b52dd68c0b7;
(function(SignInExperienceTab) {
    SignInExperienceTab["Branding"] = "branding";
    SignInExperienceTab["SignUpAndSignIn"] = "sign-up-and-sign-in";
    SignInExperienceTab["Content"] = "content";
    SignInExperienceTab["PasswordPolicy"] = "password-policy";
})($c40b4b371a14037f$export$8ce28b52dd68c0b7 || ($c40b4b371a14037f$export$8ce28b52dd68c0b7 = {}));
const $c40b4b371a14037f$var$PageTab = (0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039);
function $c40b4b371a14037f$var$PageWrapper({ children: children }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $8a03fafceb181759$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                title: "sign_in_exp.title",
                subtitle: "sign_in_exp.description",
                className: $8a03fafceb181759$export$3aac624c619dfa7f
            }),
            children
        ]
    });
}
function $c40b4b371a14037f$var$SignInExperience() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { tab: tab } = (0, $9X5Bp.useParams)();
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)("api/sign-in-exp");
    const isLoadingSignInExperience = !data && !error;
    const { isLoading: isUserAssetsServiceLoading } = (0, $dbff85762e334d27$export$2e2bcd8739ae039)();
    const [isSaving, setIsSaving] = (0, $eCoWV.useState)(false);
    const { configs: configs, error: configsError, updateConfigs: updateConfigs, isLoading: isLoadingConfig, mutate: mutateConfigs } = (0, $143de1ad4ba7f448$export$2e2bcd8739ae039)();
    const { getPathname: getPathname } = (0, $4W0F0.default)();
    const shouldDisplayWelcome = !(0, $V1X8c.isCloud) && !configs?.signInExperienceCustomized;
    const { error: languageError, isLoading: isLoadingLanguages } = (0, $d11b3c4baa98b114$export$2e2bcd8739ae039)();
    const [dataToCompare, setDataToCompare] = (0, $eCoWV.useState)();
    const requestError = error ?? configsError ?? languageError;
    const isLoading = isLoadingSignInExperience || isLoadingConfig || isLoadingLanguages || isUserAssetsServiceLoading;
    const methods = (0, $c3LX9.useForm)();
    const { reset: reset, handleSubmit: handleSubmit, getValues: getValues, watch: watch, formState: { isDirty: isDirty, errors: errors } } = methods;
    const api = (0, $2ANSb.default)();
    const formData = watch();
    const previewConfigs = (0, $6129f44a95ead627$export$2e2bcd8739ae039)(formData, isDirty, data);
    const defaultFormData = (0, $eCoWV.useMemo)(()=>{
        if (!data) return;
        return (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toLocalForm(data);
    }, [
        data
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (isDirty) return;
        if (defaultFormData) reset(defaultFormData);
    }, [
        reset,
        defaultFormData,
        isDirty
    ]);
    const saveData = async ()=>{
        setIsSaving(true);
        try {
            /**
       * Note: extract `mfa` since it will not be updated on the SIE config page.
       * This is a temporary solution, we will split `SignInExperience` type into multiple types
       * when the SIE config page is split into multiple pages.
       */ const { mfa: mfa, ...payload } = (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toRemoteModel(getValues());
            const updatedData = await api.patch("api/sign-in-exp", {
                json: payload
            }).json();
            reset((0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toLocalForm(updatedData));
            mutate(updatedData);
            setDataToCompare(undefined);
            await updateConfigs({
                signInExperienceCustomized: true
            });
            (0, $horhC.toast).success(t("general.saved"));
        } finally{
            setIsSaving(false);
        }
    };
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (!data || isSaving) return;
        const formatted = (0, $ae391dabc8d90e85$export$e9fdc6a04ee0d638).toRemoteModel(formData);
        // Sign-in methods changed, need to show confirm modal first.
        if (!(0, $ae391dabc8d90e85$export$a8696f76b721e0ff)(data, formatted)) {
            setDataToCompare(formatted);
            return;
        }
        await saveData();
    }));
    if (isLoading) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0da636e4b217f9e4$export$2e2bcd8739ae039), {});
    if (requestError) return /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageWrapper, {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $45d431f1843a1407$export$2e2bcd8739ae039), {
            className: $8a03fafceb181759$export$a3bc9b8ed74fc,
            error: requestError,
            onRetry: ()=>{
                mutateConfigs();
                mutate();
            }
        })
    });
    if (shouldDisplayWelcome) return /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageWrapper, {
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $61a914ef55cd168e$export$2e2bcd8739ae039), {
            mutate: ()=>{
                mutateConfigs();
                mutate();
            }
        })
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)($c40b4b371a14037f$var$PageWrapper, {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                className: $8a03fafceb181759$export$39f5674517ec0000,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageTab, {
                        href: "../branding",
                        errorCount: (0, $ae391dabc8d90e85$export$baf53b848b6e91d)(errors),
                        children: t("sign_in_exp.tabs.branding")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageTab, {
                        href: "../sign-up-and-sign-in",
                        errorCount: (0, $ae391dabc8d90e85$export$466b1d0c39a15838)(errors, formData),
                        children: t("sign_in_exp.tabs.sign_up_and_sign_in")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageTab, {
                        href: "../content",
                        errorCount: (0, $ae391dabc8d90e85$export$df85389c5efb9b1b)(errors),
                        children: t("sign_in_exp.tabs.content")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)($c40b4b371a14037f$var$PageTab, {
                        href: "../password-policy",
                        children: t("sign_in_exp.tabs.password_policy")
                    })
                ]
            }),
            data && defaultFormData && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $8a03fafceb181759$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($8a03fafceb181759$export$611bd8dea7a0fee9, isDirty && $8a03fafceb181759$export$1258c5dd981c51cf),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
                                ...methods,
                                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                                    className: $8a03fafceb181759$export$6210fa4921d2a466,
                                    children: [
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e010426c7577b87a$export$2e2bcd8739ae039), {
                                            isActive: tab === $c40b4b371a14037f$export$8ce28b52dd68c0b7.Branding
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19ddcc7fcac1f1b1$export$2e2bcd8739ae039), {
                                            isActive: tab === $c40b4b371a14037f$export$8ce28b52dd68c0b7.SignUpAndSignIn
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $26083010a6b99c78$export$2e2bcd8739ae039), {
                                            isActive: tab === $c40b4b371a14037f$export$8ce28b52dd68c0b7.Content
                                        }),
                                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2e5fc26e7177da38$export$2e2bcd8739ae039), {
                                            isActive: tab === $c40b4b371a14037f$export$8ce28b52dd68c0b7.PasswordPolicy
                                        })
                                    ]
                                })
                            }),
                            formData.id && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $99b6920b760e9cc1$export$2e2bcd8739ae039), {
                                isLivePreviewDisabled: isDirty,
                                signInExperience: previewConfigs,
                                className: $8a03fafceb181759$export$48c2d0f2f545ac27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0ff0308e2fe37f42$export$2e2bcd8739ae039), {
                        isOpen: isDirty,
                        isSubmitting: isSaving,
                        onDiscard: reset,
                        onSubmit: onSubmit
                    })
                ]
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: Boolean(dataToCompare),
                isLoading: isSaving,
                onCancel: ()=>{
                    setDataToCompare(undefined);
                },
                onConfirm: async ()=>{
                    await saveData();
                },
                children: dataToCompare && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a83ec76bfae3ea56$export$2e2bcd8739ae039), {
                    before: data,
                    after: dataToCompare
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty,
                parentPath: getPathname("/sign-in-experience")
            })
        ]
    });
}
var $c40b4b371a14037f$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($c40b4b371a14037f$var$SignInExperience);



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $9X5Bp = parcelRequire("9X5Bp");
parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $2wPYZ = parcelRequire("2wPYZ");

var $lSA0o = parcelRequire("lSA0o");

var $fbeQ6 = parcelRequire("fbeQ6");

var $731dfe9251998115$export$3aac624c619dfa7f;
var $731dfe9251998115$export$34e0f9847d4c02dd;
var $731dfe9251998115$export$bfd64c937657f93a;
var $731dfe9251998115$export$4a6dd88bada4e7d2;
var $731dfe9251998115$export$39f5674517ec0000;
$731dfe9251998115$export$3aac624c619dfa7f = `D9ZC6a_cardTitle`;
$731dfe9251998115$export$34e0f9847d4c02dd = `D9ZC6a_container`;
$731dfe9251998115$export$bfd64c937657f93a = `D9ZC6a_rotating`;
$731dfe9251998115$export$4a6dd88bada4e7d2 = `D9ZC6a_shimmer`;
$731dfe9251998115$export$39f5674517ec0000 = `D9ZC6a_tabs`;


function $c4930316e4ff1ac3$var$TenantSettings() {
    const { isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $731dfe9251998115$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $lSA0o.default), {
                title: "tenants.title",
                subtitle: "tenants.description",
                className: $731dfe9251998115$export$3aac624c619dfa7f
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                className: $731dfe9251998115$export$39f5674517ec0000,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        href: `/tenant-settings/${(0, $emGEN.TenantSettingsTabs).Settings}`,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.tabs.settings"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        href: `/tenant-settings/${(0, $emGEN.TenantSettingsTabs).Domains}`,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.tabs.domains"
                        })
                    }),
                    !isDevTenant && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/tenant-settings/${(0, $emGEN.TenantSettingsTabs).Subscription}`,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "tenants.tabs.subscription"
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/tenant-settings/${(0, $emGEN.TenantSettingsTabs).BillingHistory}`,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "tenants.tabs.billing_history"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {})
        ]
    });
}
var $c4930316e4ff1ac3$export$2e2bcd8739ae039 = $c4930316e4ff1ac3$var$TenantSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $bNFMZ = parcelRequire("bNFMZ");

var $eCoWV = parcelRequire("eCoWV");




var $a0Ubj = parcelRequire("a0Ubj");


var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");


var $2mi28 = parcelRequire("2mi28");

const $6b05c6edac808b57$var$useInvoices = (tenantId)=>{
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const swrResponse = (0, $2mi28.default)(`/api/tenants/${tenantId}/invoices`, async ()=>cloudApi.get("/api/tenants/:tenantId/invoices", {
            params: {
                tenantId: tenantId
            }
        }));
    const { data: invoicesResponse } = swrResponse;
    return {
        ...swrResponse,
        data: invoicesResponse?.invoices
    };
};
var $6b05c6edac808b57$export$2e2bcd8739ae039 = $6b05c6edac808b57$var$useInvoices;




var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");

const $6fd4a8c8fedd4e3d$var$tagStatusMap = {
    open: "alert",
    paid: "success",
    uncollectible: "error",
    void: "info"
};
const $6fd4a8c8fedd4e3d$var$invoiceStatusPhraseMap = {
    open: "open",
    paid: "paid",
    uncollectible: "uncollectible",
    void: "void"
};
function $6fd4a8c8fedd4e3d$var$InvoiceStatusTag({ status: status }) {
    if (status === "draft" || !status) // Don't show tag for draft invoices
    return /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: "-"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        type: "state",
        status: $6fd4a8c8fedd4e3d$var$tagStatusMap[status],
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: `subscription.billing_history.invoice_status.${$6fd4a8c8fedd4e3d$var$invoiceStatusPhraseMap[status]}`
        })
    });
}
var $6fd4a8c8fedd4e3d$export$2e2bcd8739ae039 = $6fd4a8c8fedd4e3d$var$InvoiceStatusTag;


function $21de7248c1e713c3$var$BillingHistory() {
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: invoices, error: error } = (0, $6b05c6edac808b57$export$2e2bcd8739ae039)(currentTenantId);
    const isLoadingInvoices = !invoices && !error;
    const displayInvoices = (0, $eCoWV.useMemo)(// Don't show draft invoices
    ()=>invoices?.filter(({ status: status })=>status !== "draft"), [
        invoices
    ]);
    const openStripeHostedInvoicePage = (0, $eCoWV.useCallback)(async (invoiceId)=>{
        const { hostedInvoiceUrl: hostedInvoiceUrl } = await cloudApi.get("/api/tenants/:tenantId/invoices/:invoiceId/hosted-invoice-url", {
            params: {
                tenantId: currentTenantId,
                invoiceId: invoiceId
            }
        });
        window.open(hostedInvoiceUrl, "_blank");
    }, [
        cloudApi,
        currentTenantId
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "tenants.tabs.billing_history",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                rowGroups: [
                    {
                        key: "invoices",
                        data: displayInvoices
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "subscription.billing_history.invoice_column"
                        }),
                        dataIndex: "planName",
                        render: ({ planName: planName, periodStart: periodStart, periodEnd: periodEnd })=>{
                            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                title: (0, $f11d0f720bf4029b$export$b971ca6f7de66f44)({
                                    periodStart: periodStart,
                                    periodEnd: periodEnd,
                                    displayYear: true
                                }),
                                subtitle: (0, $5CQIb.conditional)(planName && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                                    name: planName
                                }))
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "subscription.billing_history.status_column"
                        }),
                        dataIndex: "status",
                        render: ({ status: status })=>{
                            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6fd4a8c8fedd4e3d$export$2e2bcd8739ae039), {
                                status: status
                            });
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "subscription.billing_history.amount_column"
                        }),
                        dataIndex: "amountPaid",
                        render: ({ amountPaid: amountPaid })=>{
                            return `$${(amountPaid / 100).toFixed(2)}`;
                        }
                    },
                    {
                        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "subscription.billing_history.invoice_created_date_column"
                        }),
                        dataIndex: "created",
                        render: ({ createdAt: createdAt })=>{
                            return (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))(createdAt).format("MMMM DD, YYYY");
                        }
                    }
                ],
                isLoading: isLoadingInvoices,
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
                rowClickHandler: ({ id: id })=>{
                    openStripeHostedInvoicePage(id);
                }
            })
        ]
    });
}
var $21de7248c1e713c3$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($21de7248c1e713c3$var$BillingHistory);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $a0Ubj = parcelRequire("a0Ubj");

var $2wPYZ = parcelRequire("2wPYZ");



var $2mi28 = parcelRequire("2mi28");


var $V1X8c = parcelRequire("V1X8c");
const $3fcba5f00116a2ae$var$useSubscriptionUsage = (tenantId)=>{
    const cloudApi = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    return (0, $2mi28.default)((0, $V1X8c.isCloud) && `/api/tenants/${tenantId}/usage`, async ()=>cloudApi.get("/api/tenants/:tenantId/usage", {
            params: {
                tenantId: tenantId
            }
        }));
};
var $3fcba5f00116a2ae$export$2e2bcd8739ae039 = $3fcba5f00116a2ae$var$useSubscriptionUsage;




var $9zeGj = parcelRequire("9zeGj");

var $839c02806d138738$export$34e0f9847d4c02dd;
var $839c02806d138738$export$bfd64c937657f93a;
var $839c02806d138738$export$4a6dd88bada4e7d2;
$839c02806d138738$export$34e0f9847d4c02dd = `uOOVxa_container`;
$839c02806d138738$export$bfd64c937657f93a = `uOOVxa_rotating`;
$839c02806d138738$export$4a6dd88bada4e7d2 = `uOOVxa_shimmer`;


function $2a16903d351dcaff$var$Skeleton() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $839c02806d138738$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $354ce2d22530b458$export$2e2bcd8739ae039), {
                formFieldCount: 1
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $354ce2d22530b458$export$2e2bcd8739ae039), {
                formFieldCount: 1
            })
        ]
    });
}
var $2a16903d351dcaff$export$2e2bcd8739ae039 = $2a16903d351dcaff$var$Skeleton;



var $9zeGj = parcelRequire("9zeGj");






var $dADBR = parcelRequire("dADBR");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

var $eCoWV = parcelRequire("eCoWV");



var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9XAkT = parcelRequire("9XAkT");

var $9ENFn = parcelRequire("9ENFn");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");





var $fbeQ6 = parcelRequire("fbeQ6");

var $cad80e71bf2d5c30$export$a2da573beea6475e;
var $cad80e71bf2d5c30$export$34e0f9847d4c02dd;
var $cad80e71bf2d5c30$export$6d59db4903f20f7d;
var $cad80e71bf2d5c30$export$8837f4fc672e936d;
var $cad80e71bf2d5c30$export$bfd64c937657f93a;
var $cad80e71bf2d5c30$export$4a6dd88bada4e7d2;
$cad80e71bf2d5c30$export$a2da573beea6475e = `nXAoga_buttonLink`;
$cad80e71bf2d5c30$export$34e0f9847d4c02dd = `nXAoga_container`;
$cad80e71bf2d5c30$export$6d59db4903f20f7d = `nXAoga_description`;
$cad80e71bf2d5c30$export$8837f4fc672e936d = `nXAoga_list`;
$cad80e71bf2d5c30$export$bfd64c937657f93a = `nXAoga_rotating`;
$cad80e71bf2d5c30$export$4a6dd88bada4e7d2 = `nXAoga_shimmer`;


const $5150c1b53b1f11ed$var$excludedQuotaKeys = new Set([
    "auditLogsRetentionDays",
    "communitySupportEnabled",
    "ticketSupportResponseTime"
]);
function $5150c1b53b1f11ed$var$NotEligibleSwitchPlanModalContent({ targetPlan: targetPlan, exceededQuotaKeys: exceededQuotaKeys, isDowngrade: isDowngrade = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription.not_eligible_modal"
    });
    const { id: id, name: name, quota: quota } = targetPlan;
    const orderedEntries = (0, $eCoWV.useMemo)(()=>{
        // eslint-disable-next-line no-restricted-syntax
        const entries = Object.entries(quota);
        return entries.filter(([quotaKey])=>exceededQuotaKeys.includes(quotaKey)).slice().sort(([preQuotaKey], [nextQuotaKey])=>(0, $65a670f1c344d535$export$b035e44d7bb4278f)((0, $22b72719037fdeab$export$103450479c8ed1e3))(preQuotaKey, nextQuotaKey));
    }, [
        quota,
        exceededQuotaKeys
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $cad80e71bf2d5c30$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $cad80e71bf2d5c30$export$6d59db4903f20f7d,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                                name: name
                            })
                        },
                        children: t(isDowngrade ? "downgrade_description" : "upgrade_description")
                    }),
                    !isDowngrade && id === (0, $ckJfF.ReservedPlanId).Hobby && t("upgrade_pro_tip")
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ul", {
                className: $cad80e71bf2d5c30$export$8837f4fc672e936d,
                children: orderedEntries.map(([quotaKey, quotaValue])=>{
                    if ($5150c1b53b1f11ed$var$excludedQuotaKeys.has(quotaKey) || quotaValue === null || // Unlimited items
                    quotaValue === true // Eligible items
                    ) return null;
                    return /*#__PURE__*/ (0, $9zeGj.jsx)("li", {
                        children: quotaValue ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                item: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: `subscription.quota_item.${(0, $2c4922a130b7773f$export$90b7c469260db368)[quotaKey]}`,
                                    interpolation: (0, $5CQIb.conditional)(typeof quotaValue === "number" && {
                                        count: quotaValue
                                    })
                                })
                            },
                            children: t("a_maximum_of")
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: `subscription.quota_item.${(0, $2c4922a130b7773f$export$fc0debfec7b2b60b)[quotaKey]}`
                        })
                    }, quotaKey);
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                },
                children: t(isDowngrade ? "downgrade_help_tip" : "upgrade_help_tip")
            })
        ]
    });
}
var $5150c1b53b1f11ed$export$2e2bcd8739ae039 = $5150c1b53b1f11ed$var$NotEligibleSwitchPlanModalContent;



function $460bf90489174ba1$var$MauLimitExceededNotification({ activeUsers: activeUsers, currentPlan: currentPlan, className: className }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { subscribe: subscribe } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const { data: subscriptionPlans } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const proPlan = (0, $eCoWV.useMemo)(()=>subscriptionPlans?.find(({ id: id })=>id === (0, $ckJfF.ReservedPlanId).Pro), [
        subscriptionPlans
    ]);
    const { quota: { mauLimit: mauLimit } } = currentPlan;
    if (mauLimit === null || // Unlimited
    activeUsers < mauLimit || !proPlan) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        severity: "error",
        action: "subscription.upgrade_pro",
        className: className,
        isActionLoading: isLoading,
        onClick: async ()=>{
            try {
                setIsLoading(true);
                await subscribe({
                    planId: proPlan.id,
                    tenantId: currentTenantId,
                    callbackPage: (0, $f5861ec06c49db25$export$6d940d0d58a60bc4)
                });
                setIsLoading(false);
            } catch (error) {
                setIsLoading(false);
                const [result, exceededQuotaKeys] = await (0, $f11d0f720bf4029b$export$c0ed1fa5d8f3e3a5)(error);
                if (result) {
                    await show({
                        ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $5150c1b53b1f11ed$export$2e2bcd8739ae039), {
                                targetPlan: proPlan,
                                exceededQuotaKeys: exceededQuotaKeys
                            }),
                        title: "subscription.not_eligible_modal.upgrade_title",
                        confirmButtonText: "general.got_it",
                        confirmButtonType: "primary",
                        isCancelButtonVisible: false
                    });
                    return;
                }
                (0, $3978b41c434b0156$export$10abc8714a7caf54)(error);
            }
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "subscription.overfill_quota_warning"
        })
    });
}
var $460bf90489174ba1$export$2e2bcd8739ae039 = $460bf90489174ba1$var$MauLimitExceededNotification;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $2wPYZ = parcelRequire("2wPYZ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9XAkT = parcelRequire("9XAkT");

function $14def49ef5775ca7$var$PaymentOverdueNotification({ className: className }) {
    const { currentTenant: currentTenant, currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { openInvoices: openInvoices = [] } = currentTenant ?? {};
    const { visitManagePaymentPage: visitManagePaymentPage } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const [isActionLoading, setIsActionLoading] = (0, $eCoWV.useState)(false);
    if (openInvoices.length === 0) return null;
    const totalAmountDue = openInvoices.reduce((total, currentInvoice)=>total + currentInvoice.amountDue, 0);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9XAkT.default), {
        severity: "error",
        action: "subscription.update_payment",
        className: className,
        isActionLoading: isActionLoading,
        onClick: async ()=>{
            setIsActionLoading(true);
            await visitManagePaymentPage(currentTenantId);
            setIsActionLoading(false);
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "subscription.payment_error",
            interpolation: {
                price: totalAmountDue / 100
            }
        })
    });
}
var $14def49ef5775ca7$export$2e2bcd8739ae039 = $14def49ef5775ca7$var$PaymentOverdueNotification;


var $581c52c32e03967f$export$6d59db4903f20f7d;
var $581c52c32e03967f$export$a8ff84c12d48cfa6;
var $581c52c32e03967f$export$2adf6238a2d0dafa;
var $581c52c32e03967f$export$7507ac6a8989448c;
var $581c52c32e03967f$export$bfd64c937657f93a;
var $581c52c32e03967f$export$4a6dd88bada4e7d2;
$581c52c32e03967f$export$6d59db4903f20f7d = `m-BY5a_description`;
$581c52c32e03967f$export$a8ff84c12d48cfa6 = `m-BY5a_name`;
$581c52c32e03967f$export$2adf6238a2d0dafa = `m-BY5a_notification`;
$581c52c32e03967f$export$7507ac6a8989448c = `m-BY5a_planInfo`;
$581c52c32e03967f$export$bfd64c937657f93a = `m-BY5a_rotating`;
$581c52c32e03967f$export$4a6dd88bada4e7d2 = `m-BY5a_shimmer`;


function $09ffe57e96fab9d4$var$CurrentPlan({ subscription: subscription, subscriptionPlan: subscriptionPlan, subscriptionUsage: subscriptionUsage }) {
    const { id: id, name: name } = subscriptionPlan;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "subscription.current_plan",
        description: "subscription.current_plan_description",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $581c52c32e03967f$export$7507ac6a8989448c,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $581c52c32e03967f$export$a8ff84c12d48cfa6,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: name
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $581c52c32e03967f$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47dfccd1e63aea94$export$2e2bcd8739ae039), {
                            planId: id
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "subscription.plan_usage",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $78c662d3245f7468$export$2e2bcd8739ae039), {
                    currentSubscription: subscription,
                    currentPlan: subscriptionPlan,
                    subscriptionUsage: subscriptionUsage
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "subscription.next_bill",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b84aac1cf1606946$export$2e2bcd8739ae039), {
                    cost: subscriptionUsage.cost,
                    isManagePaymentVisible: Boolean(subscriptionUsage.cost)
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $460bf90489174ba1$export$2e2bcd8739ae039), {
                activeUsers: subscriptionUsage.activeUsers,
                currentPlan: subscriptionPlan,
                className: $581c52c32e03967f$export$2adf6238a2d0dafa
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $14def49ef5775ca7$export$2e2bcd8739ae039), {
                className: $581c52c32e03967f$export$2adf6238a2d0dafa
            })
        ]
    });
}
var $09ffe57e96fab9d4$export$2e2bcd8739ae039 = $09ffe57e96fab9d4$var$CurrentPlan;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");




var $fbeQ6 = parcelRequire("fbeQ6");


var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");

const $946e27eff174f3ce$var$planQuotaGroupKeyPhraseMap = {
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).base]: "quota.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).applications]: "application.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).resources]: "resource.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).branding]: "branding.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).userAuthentication]: "user_authn.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).roles]: "user_management.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).hooks]: "hooks.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).organizations]: "organizations.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).auditLogs]: "audit_logs.title",
    [(0, $4b7ab4566c750149$export$65033dd04f7aee7d).support]: "support.title"
};
function $946e27eff174f3ce$var$PlanQuotaGroupKeyLabel({ groupKey: groupKey }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
        forKey: `subscription.quota_table.${$946e27eff174f3ce$var$planQuotaGroupKeyPhraseMap[groupKey]}`
    });
}
var $946e27eff174f3ce$export$2e2bcd8739ae039 = $946e27eff174f3ce$var$PlanQuotaGroupKeyLabel;



var $9zeGj = parcelRequire("9zeGj");

var $fbeQ6 = parcelRequire("fbeQ6");
const $11e3b5ae26cb3d21$var$planQuotaKeyPhraseMap = {
    basePrice: "quota.base_price",
    mauUnitPrice: "quota.mau_unit_price",
    mauLimit: "quota.mau_limit",
    applicationsLimit: "application.total",
    machineToMachineLimit: "application.m2m",
    resourcesLimit: "resource.resource_count",
    scopesPerResourceLimit: "resource.scopes_per_resource",
    customDomainEnabled: "branding.custom_domain",
    customCssEnabled: "branding.custom_css",
    appLogoAndFaviconEnabled: "branding.app_logo_and_favicon",
    darkModeEnabled: "branding.dark_mode",
    i18nEnabled: "branding.i18n",
    omniSignInEnabled: "user_authn.omni_sign_in",
    passwordSignInEnabled: "user_authn.password",
    passwordlessSignInEnabled: "user_authn.passwordless",
    emailConnectorsEnabled: "user_authn.email_connector",
    smsConnectorsEnabled: "user_authn.sms_connector",
    socialConnectorsLimit: "user_authn.social_connectors",
    standardConnectorsLimit: "user_authn.standard_connectors",
    mfaEnabled: "user_authn.mfa",
    ssoEnabled: "user_authn.sso",
    userManagementEnabled: "user_management.user_management",
    rolesLimit: "user_management.roles",
    scopesPerRoleLimit: "user_management.scopes_per_role",
    hooksLimit: "hooks.hooks",
    auditLogsRetentionDays: "audit_logs.retention",
    communitySupportEnabled: "support.community",
    ticketSupportResponseTime: "support.customer_ticket",
    organizationsEnabled: "organizations.organizations"
};
function $11e3b5ae26cb3d21$var$PlanQuotaKeyLabel({ quotaKey: quotaKey }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
        forKey: `subscription.quota_table.${$11e3b5ae26cb3d21$var$planQuotaKeyPhraseMap[quotaKey]}`
    });
}
var $11e3b5ae26cb3d21$export$2e2bcd8739ae039 = $11e3b5ae26cb3d21$var$PlanQuotaKeyLabel;


var $9d21572c8cdb05a1$export$aa79b10cb7913a21;
var $9d21572c8cdb05a1$export$5e399d7655779980;
var $9d21572c8cdb05a1$export$34e0f9847d4c02dd;
var $9d21572c8cdb05a1$export$3b6a720baa2c20ec;
var $9d21572c8cdb05a1$export$808794a1efddf200;
var $9d21572c8cdb05a1$export$ac4de22553a86e47;
var $9d21572c8cdb05a1$export$658ddaa3f057c88;
var $9d21572c8cdb05a1$export$bfd64c937657f93a;
var $9d21572c8cdb05a1$export$4a6dd88bada4e7d2;
var $9d21572c8cdb05a1$export$9852986a3ec5f6a0;
var $9d21572c8cdb05a1$export$2c6254af5d42c03d;
$9d21572c8cdb05a1$export$aa79b10cb7913a21 = `xjN5gq_bodyTableWrapper`;
$9d21572c8cdb05a1$export$5e399d7655779980 = `xjN5gq_colorRow`;
$9d21572c8cdb05a1$export$34e0f9847d4c02dd = `xjN5gq_container`;
$9d21572c8cdb05a1$export$3b6a720baa2c20ec = `xjN5gq_footnote`;
$9d21572c8cdb05a1$export$808794a1efddf200 = `xjN5gq_groupLabel`;
$9d21572c8cdb05a1$export$ac4de22553a86e47 = `xjN5gq_headerTable`;
$9d21572c8cdb05a1$export$658ddaa3f057c88 = `xjN5gq_quotaKeyColumn`;
$9d21572c8cdb05a1$export$bfd64c937657f93a = `xjN5gq_rotating`;
$9d21572c8cdb05a1$export$4a6dd88bada4e7d2 = `xjN5gq_shimmer`;
$9d21572c8cdb05a1$export$9852986a3ec5f6a0 = `xjN5gq_table`;
$9d21572c8cdb05a1$export$2c6254af5d42c03d = `xjN5gq_ticketSupport`;


parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

const $a7cb5314c7bf6113$export$46d9a4649d6890ba = (plans)=>plans.map((plan)=>{
        const { id: id, name: name, stripeProducts: stripeProducts, quota: quota } = plan;
        return {
            id: id,
            name: name,
            table: {
                ...quota,
                basePrice: (0, $5CQIb.conditional)(stripeProducts.find((product)=>product.type === "flat")?.price.unitAmountDecimal) ?? "0",
                mauUnitPrice: stripeProducts.filter(({ type: type })=>type !== "flat").slice().sort((productA, productB)=>{
                    const { price: unitAmountDecimalA } = productA;
                    const { price: unitAmountDecimalB } = productB;
                    return Number(unitAmountDecimalA) - Number(unitAmountDecimalB);
                }).map(({ price: { unitAmountDecimal: unitAmountDecimal } })=>(0, $5CQIb.conditionalString)(unitAmountDecimal)),
                customCssEnabled: (0, $22b72719037fdeab$export$b3650eb261ff6f3)[id],
                appLogoAndFaviconEnabled: (0, $22b72719037fdeab$export$c61300bd74c09979)[id],
                darkModeEnabled: (0, $22b72719037fdeab$export$efacd6af85652202)[id],
                i18nEnabled: (0, $22b72719037fdeab$export$3cb42d554c876baf)[id],
                passwordSignInEnabled: (0, $22b72719037fdeab$export$aecc0a4adaffa522)[id],
                passwordlessSignInEnabled: (0, $22b72719037fdeab$export$67f5d6f8d5cefc45)[id],
                emailConnectorsEnabled: (0, $22b72719037fdeab$export$e6a3866b2ed99278)[id],
                smsConnectorsEnabled: (0, $22b72719037fdeab$export$84203c51b0d4c7a8)[id],
                userManagementEnabled: (0, $22b72719037fdeab$export$84644eb2e3da3d30)[id]
            }
        };
    });


function $2bdca1ccaddfc172$var$PlanQuotaTable({ subscriptionPlans: subscriptionPlans }) {
    const quotaTableRowGroups = (0, $eCoWV.useMemo)(()=>{
        const tableDataArray = [
            ...(0, $a7cb5314c7bf6113$export$46d9a4649d6890ba)(subscriptionPlans),
            // Note: enterprise plan table data is not included in the subscription plans, and it's only for display
            (0, $22b72719037fdeab$export$70a69047fe35dc2e)
        ];
        return Object.entries((0, $22b72719037fdeab$export$c7328c7d01ec967d)).map(([groupKey, quotaKeys])=>{
            return {
                key: groupKey,
                // eslint-disable-next-line no-restricted-syntax
                label: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $946e27eff174f3ce$export$2e2bcd8739ae039), {
                    groupKey: groupKey
                }),
                labelClassName: $9d21572c8cdb05a1$export$808794a1efddf200,
                data: quotaKeys.map((key)=>{
                    const tableData = Object.fromEntries(tableDataArray.map(({ name: name, table: table })=>{
                        return [
                            name,
                            table[key]
                        ];
                    }));
                    return {
                        quotaKey: key,
                        ...tableData
                    };
                })
            };
        });
    }, [
        subscriptionPlans
    ]);
    const quotaTableRowData = quotaTableRowGroups[0]?.data?.at(0);
    if (quotaTableRowData === undefined) return null;
    const planQuotaTableColumns = Object.keys(quotaTableRowData);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $9d21572c8cdb05a1$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                isRowHoverEffectDisabled: true,
                rowGroups: quotaTableRowGroups,
                rowIndexKey: "quotaKey",
                rowClassName: (_, index)=>(0, $5CQIb.conditional)(index % 2 === 0 && $9d21572c8cdb05a1$export$5e399d7655779980),
                className: $9d21572c8cdb05a1$export$9852986a3ec5f6a0,
                headerTableClassName: $9d21572c8cdb05a1$export$ac4de22553a86e47,
                bodyTableWrapperClassName: $9d21572c8cdb05a1$export$aa79b10cb7913a21,
                columns: planQuotaTableColumns.map((column)=>{
                    const columnTitle = (0, $5CQIb.conditional)(column !== "quotaKey" && column);
                    return {
                        title: (0, $5CQIb.conditional)(columnTitle && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: columnTitle
                        })),
                        dataIndex: column,
                        className: (0, $5CQIb.conditional)(column === "quotaKey" && $9d21572c8cdb05a1$export$658ddaa3f057c88),
                        render: (row)=>{
                            const { quotaKey: quotaKey } = row;
                            if (column === "quotaKey") return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11e3b5ae26cb3d21$export$2e2bcd8739ae039), {
                                quotaKey: quotaKey
                            });
                            const quotaValue = row[column];
                            if (quotaValue === undefined) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "subscription.quota_table.contact"
                            });
                            if (quotaValue === null) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "subscription.quota_table.unlimited"
                            });
                            // For base price
                            if (typeof quotaValue === "string") {
                                if (quotaKey === "basePrice") return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "subscription.quota_table.monthly_price",
                                    interpolation: {
                                        value: Number(quotaValue) / 100
                                    }
                                });
                                return quotaValue;
                            }
                            // For mau unit price
                            if (Array.isArray(quotaValue)) return quotaValue.length === 0 ? "-" : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                children: quotaValue.map((value, index)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                                forKey: "subscription.quota_table.tier",
                                                interpolation: {
                                                    value: index + 1
                                                }
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                                forKey: "subscription.quota_table.mau_price",
                                                interpolation: {
                                                    value: (Number(value) / 100).toFixed(3)
                                                }
                                            })
                                        ]
                                    }, value))
                            });
                            if (typeof quotaValue === "boolean") return quotaValue ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c485b7de5371d8$export$2e2bcd8739ae039), {}) : "-";
                            // Note: handle number type
                            if (quotaValue === 0) return "-";
                            if (quotaKey === "auditLogsRetentionDays") return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "subscription.quota_table.days",
                                interpolation: {
                                    count: quotaValue
                                }
                            });
                            if (quotaKey === "ticketSupportResponseTime") return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $9d21572c8cdb05a1$export$2c6254af5d42c03d,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c485b7de5371d8$export$2e2bcd8739ae039), {}),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        children: `(${quotaValue}h)`
                                    })
                                ]
                            });
                            return quotaValue.toLocaleString();
                        }
                    };
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $9d21572c8cdb05a1$export$3b6a720baa2c20ec,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "subscription.quota_table.mau_unit_price_footnote"
                })
            })
        ]
    });
}
var $2bdca1ccaddfc172$export$2e2bcd8739ae039 = $2bdca1ccaddfc172$var$PlanQuotaTable;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $ckJfF = parcelRequire("ckJfF");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");


var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $3MzPh = parcelRequire("3MzPh");

var $9ENFn = parcelRequire("9ENFn");




var $9zeGj = parcelRequire("9zeGj");


var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");


var $ed2e6973ca59de94$export$34e0f9847d4c02dd;
var $ed2e6973ca59de94$export$bfd64c937657f93a;
var $ed2e6973ca59de94$export$4a6dd88bada4e7d2;
var $ed2e6973ca59de94$export$fb184b623420d9be;
$ed2e6973ca59de94$export$34e0f9847d4c02dd = `iok-RW_container`;
$ed2e6973ca59de94$export$bfd64c937657f93a = `iok-RW_rotating`;
$ed2e6973ca59de94$export$4a6dd88bada4e7d2 = `iok-RW_shimmer`;
$ed2e6973ca59de94$export$fb184b623420d9be = `iok-RW_title`;


function $2d1b8a9a8c155d89$var$PlanQuotaDiffCard({ planName: planName, quotaDiff: quotaDiff, isTarget: isTarget = false }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription.downgrade_modal"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $ed2e6973ca59de94$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $ed2e6973ca59de94$export$fb184b623420d9be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: planName
                        })
                    },
                    children: t(isTarget ? "after" : "before")
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f04630148650accd$export$2e2bcd8739ae039), {
                isDiff: true,
                quota: quotaDiff,
                hasIcon: isTarget
            })
        ]
    });
}
var $2d1b8a9a8c155d89$export$2e2bcd8739ae039 = $2d1b8a9a8c155d89$var$PlanQuotaDiffCard;


var $355aad522b551f39$export$34e0f9847d4c02dd;
var $355aad522b551f39$export$a7db06668cad9adb;
var $355aad522b551f39$export$6d59db4903f20f7d;
var $355aad522b551f39$export$bfd64c937657f93a;
var $355aad522b551f39$export$4a6dd88bada4e7d2;
$355aad522b551f39$export$34e0f9847d4c02dd = `_5Fvp8W_container`;
$355aad522b551f39$export$a7db06668cad9adb = `_5Fvp8W_content`;
$355aad522b551f39$export$6d59db4903f20f7d = `_5Fvp8W_description`;
$355aad522b551f39$export$bfd64c937657f93a = `_5Fvp8W_rotating`;
$355aad522b551f39$export$4a6dd88bada4e7d2 = `_5Fvp8W_shimmer`;


const $19be2d5a12e8c16f$var$excludeComingSoonFeatures = (quotaDiff)=>{
    // eslint-disable-next-line no-restricted-syntax
    const entries = Object.entries(quotaDiff);
    return Object.fromEntries(entries.filter(([key])=>!(0, $22b72719037fdeab$export$69143de3c73b76af).includes(key)));
};
function $19be2d5a12e8c16f$var$DowngradeConfirmModalContent({ currentPlan: currentPlan, targetPlan: targetPlan }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { quota: currentQuota, name: currentPlanName } = currentPlan;
    const { quota: targetQuota, name: targetPlanName } = targetPlan;
    const currentQuotaDiff = (0, $eCoWV.useMemo)(()=>$19be2d5a12e8c16f$var$excludeComingSoonFeatures((0, $338199a87e24bd9f$export$2e2bcd8739ae039)(targetQuota, currentQuota)), [
        currentQuota,
        targetQuota
    ]);
    const targetQuotaDiff = (0, $eCoWV.useMemo)(()=>$19be2d5a12e8c16f$var$excludeComingSoonFeatures((0, $338199a87e24bd9f$export$2e2bcd8739ae039)(currentQuota, targetQuota)), [
        currentQuota,
        targetQuota
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $355aad522b551f39$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $355aad522b551f39$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        targetName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: targetPlanName
                        }),
                        currentName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: currentPlanName
                        })
                    },
                    children: t("subscription.downgrade_modal.description")
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $355aad522b551f39$export$a7db06668cad9adb,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2d1b8a9a8c155d89$export$2e2bcd8739ae039), {
                        planName: currentPlanName,
                        quotaDiff: currentQuotaDiff
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2d1b8a9a8c155d89$export$2e2bcd8739ae039), {
                        isTarget: true,
                        planName: targetPlanName,
                        quotaDiff: targetQuotaDiff
                    })
                ]
            })
        ]
    });
}
var $19be2d5a12e8c16f$export$2e2bcd8739ae039 = $19be2d5a12e8c16f$var$DowngradeConfirmModalContent;


var $450c7f38f9bbe8d2$export$a2da573beea6475e;
var $450c7f38f9bbe8d2$export$34e0f9847d4c02dd;
var $450c7f38f9bbe8d2$export$bfd64c937657f93a;
var $450c7f38f9bbe8d2$export$4a6dd88bada4e7d2;
$450c7f38f9bbe8d2$export$a2da573beea6475e = `_7NtmNG_buttonLink`;
$450c7f38f9bbe8d2$export$34e0f9847d4c02dd = `_7NtmNG_container`;
$450c7f38f9bbe8d2$export$bfd64c937657f93a = `_7NtmNG_rotating`;
$450c7f38f9bbe8d2$export$4a6dd88bada4e7d2 = `_7NtmNG_shimmer`;


function $953f7828e1abc33c$var$SwitchPlanActionBar({ currentSubscriptionPlanId: currentSubscriptionPlanId, subscriptionPlans: subscriptionPlans, onSubscriptionUpdated: onSubscriptionUpdated }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.subscription"
    });
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { subscribe: subscribe, cancelSubscription: cancelSubscription } = (0, $25d8bd01c3ca39b7$export$2e2bcd8739ae039)();
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const [currentLoadingPlanId, setCurrentLoadingPlanId] = (0, $eCoWV.useState)();
    const handleSubscribe = async (targetPlanId, isDowngrade)=>{
        if (currentLoadingPlanId) return;
        const currentPlan = subscriptionPlans.find(({ id: id })=>id === currentSubscriptionPlanId);
        const targetPlan = subscriptionPlans.find(({ id: id })=>id === targetPlanId);
        if (!currentPlan || !targetPlan) return;
        if (isDowngrade) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $19be2d5a12e8c16f$export$2e2bcd8739ae039), {
                        currentPlan: currentPlan,
                        targetPlan: targetPlan
                    }),
                title: "subscription.downgrade_modal.title",
                confirmButtonText: "subscription.downgrade_modal.downgrade",
                size: "large"
            });
            if (!result) return;
        }
        try {
            setCurrentLoadingPlanId(targetPlanId);
            if (targetPlanId === (0, $ckJfF.ReservedPlanId).Free) {
                await cancelSubscription(currentTenantId);
                onSubscriptionUpdated();
                (0, $horhC.toast).success(/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                            name: targetPlan.name
                        })
                    },
                    children: t("downgrade_success")
                }));
                return;
            }
            await subscribe({
                tenantId: currentTenantId,
                planId: targetPlanId,
                isDowngrade: isDowngrade,
                callbackPage: (0, $f5861ec06c49db25$export$6d940d0d58a60bc4)
            });
        } catch (error) {
            setCurrentLoadingPlanId(undefined);
            const [result, exceededQuotaKeys] = await (0, $f11d0f720bf4029b$export$c0ed1fa5d8f3e3a5)(error);
            if (result) {
                await show({
                    ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $5150c1b53b1f11ed$export$2e2bcd8739ae039), {
                            targetPlan: targetPlan,
                            isDowngrade: isDowngrade,
                            exceededQuotaKeys: exceededQuotaKeys
                        }),
                    title: isDowngrade ? "subscription.not_eligible_modal.downgrade_title" : "subscription.not_eligible_modal.upgrade_title",
                    confirmButtonText: "general.got_it",
                    confirmButtonType: "primary",
                    isCancelButtonVisible: false
                });
                return;
            }
            (0, $3978b41c434b0156$export$10abc8714a7caf54)(error);
        } finally{
            setCurrentLoadingPlanId(undefined);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $450c7f38f9bbe8d2$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3MzPh.default), {}),
            subscriptionPlans.map(({ id: planId })=>{
                const isCurrentPlan = currentSubscriptionPlanId === planId;
                const isDowngrade = (0, $f11d0f720bf4029b$export$64dac4cdd03b50e1)(currentSubscriptionPlanId, planId);
                return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: isCurrentPlan ? "subscription.current" : isDowngrade ? "subscription.downgrade" : "subscription.upgrade",
                        type: isDowngrade ? "default" : "primary",
                        disabled: isCurrentPlan,
                        isLoading: !isCurrentPlan && currentLoadingPlanId === planId,
                        onClick: ()=>{
                            handleSubscribe(planId, isDowngrade);
                        }
                    })
                }, planId);
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("a", {
                    href: (0, $o53Y2.contactEmailLink),
                    className: $450c7f38f9bbe8d2$export$a2da573beea6475e,
                    rel: "noopener",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: "general.contact_us_action",
                        type: "primary"
                    })
                })
            })
        ]
    });
}
var $953f7828e1abc33c$export$2e2bcd8739ae039 = $953f7828e1abc33c$var$SwitchPlanActionBar;


var $1d8e5834695b321a$export$34e0f9847d4c02dd;
var $1d8e5834695b321a$export$bfd64c937657f93a;
var $1d8e5834695b321a$export$4a6dd88bada4e7d2;
$1d8e5834695b321a$export$34e0f9847d4c02dd = `Av1axa_container`;
$1d8e5834695b321a$export$bfd64c937657f93a = `Av1axa_rotating`;
$1d8e5834695b321a$export$4a6dd88bada4e7d2 = `Av1axa_shimmer`;


function $61045557af6c324f$var$Subscription() {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: subscriptionPlans, error: fetchPlansError } = (0, $066887fd7bfc3383$export$2e2bcd8739ae039)();
    const { data: currentSubscription, error: fetchSubscriptionError, mutate: mutateSubscription } = (0, $b73382a83e5d20dd$export$2e2bcd8739ae039)(currentTenantId);
    const { data: subscriptionUsage, error: fetchSubscriptionUsageError } = (0, $3fcba5f00116a2ae$export$2e2bcd8739ae039)(currentTenantId);
    const isLoadingPlans = !subscriptionPlans && !fetchPlansError;
    const isLoadingSubscription = !currentSubscription && !fetchSubscriptionError;
    const isLoadingSubscriptionUsage = !subscriptionUsage && !fetchSubscriptionUsageError;
    const reservedPlans = (0, $5CQIb.conditionalArray)(subscriptionPlans && (0, $f11d0f720bf4029b$export$1673a249ab23858e)(subscriptionPlans));
    if (isLoadingPlans || isLoadingSubscription || isLoadingSubscriptionUsage) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2a16903d351dcaff$export$2e2bcd8739ae039), {});
    if (!subscriptionPlans || !currentSubscription || !subscriptionUsage) return null;
    const currentSubscriptionPlan = subscriptionPlans.find((plan)=>plan.id === currentSubscription.planId);
    if (!currentSubscriptionPlan) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $1d8e5834695b321a$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "tenants.tabs.subscription",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $09ffe57e96fab9d4$export$2e2bcd8739ae039), {
                subscription: currentSubscription,
                subscriptionPlan: currentSubscriptionPlan,
                subscriptionUsage: subscriptionUsage
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2bdca1ccaddfc172$export$2e2bcd8739ae039), {
                subscriptionPlans: reservedPlans
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $953f7828e1abc33c$export$2e2bcd8739ae039), {
                currentSubscriptionPlanId: currentSubscription.planId,
                subscriptionPlans: reservedPlans,
                onSubscriptionUpdated: mutateSubscription
            })
        ]
    });
}
var $61045557af6c324f$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($61045557af6c324f$var$Subscription);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");
var $ckJfF = parcelRequire("ckJfF");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $a0Ubj = parcelRequire("a0Ubj");



var $2wPYZ = parcelRequire("2wPYZ");

var $9ENFn = parcelRequire("9ENFn");

var $bSFEw = parcelRequire("bSFEw");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $8zpKJ = parcelRequire("8zpKJ");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");
var $8f1dbc75b6de85fc$export$c820a656c5e396da;
var $8f1dbc75b6de85fc$export$6d59db4903f20f7d;
var $8f1dbc75b6de85fc$export$bfd64c937657f93a;
var $8f1dbc75b6de85fc$export$4a6dd88bada4e7d2;
$8f1dbc75b6de85fc$export$c820a656c5e396da = `Wld4Dq_deletionButtonContainer`;
$8f1dbc75b6de85fc$export$6d59db4903f20f7d = `Wld4Dq_description`;
$8f1dbc75b6de85fc$export$bfd64c937657f93a = `Wld4Dq_rotating`;
$8f1dbc75b6de85fc$export$4a6dd88bada4e7d2 = `Wld4Dq_shimmer`;


function $c186929a08b687ac$var$DeleteCard({ currentTenantId: currentTenantId, onClick: onClick }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "tenants.deletion_card.title",
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
            title: "tenants.deletion_card.tenant_deletion",
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $8f1dbc75b6de85fc$export$c820a656c5e396da,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $8f1dbc75b6de85fc$export$6d59db4903f20f7d,
                        children: t("tenants.deletion_card.tenant_deletion_description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: "default",
                        title: "tenants.deletion_card.tenant_deletion_button",
                        disabled: [
                            (0, $8zpKJ.adminTenantId)
                        ].includes(currentTenantId),
                        onClick: onClick
                    })
                ]
            })
        })
    });
}
var $c186929a08b687ac$export$2e2bcd8739ae039 = $c186929a08b687ac$var$DeleteCard;



var $9zeGj = parcelRequire("9zeGj");

var $iyeK6 = parcelRequire("iyeK6");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");



var $eee223e8f5f30a21$export$73ba5813cda80a49;
var $eee223e8f5f30a21$export$a7db06668cad9adb;
var $eee223e8f5f30a21$export$a71f3c3c51e55058;
var $eee223e8f5f30a21$export$6d59db4903f20f7d;
var $eee223e8f5f30a21$export$e4043f67d36cbb26;
var $eee223e8f5f30a21$export$bfd64c937657f93a;
var $eee223e8f5f30a21$export$4a6dd88bada4e7d2;
$eee223e8f5f30a21$export$73ba5813cda80a49 = `yuWCpq_bold`;
$eee223e8f5f30a21$export$a7db06668cad9adb = `yuWCpq_content`;
$eee223e8f5f30a21$export$a71f3c3c51e55058 = `yuWCpq_deleteConfirmModal`;
$eee223e8f5f30a21$export$6d59db4903f20f7d = `yuWCpq_description`;
$eee223e8f5f30a21$export$e4043f67d36cbb26 = `yuWCpq_highlight`;
$eee223e8f5f30a21$export$bfd64c937657f93a = `yuWCpq_rotating`;
$eee223e8f5f30a21$export$4a6dd88bada4e7d2 = `yuWCpq_shimmer`;


function $3c169c19cecafbaf$var$DeleteModal({ isOpen: isOpen, isLoading: isLoading, onClose: onClose, onDelete: onDelete, tenant: tenant }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { name: name, tag: tag } = tenant;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
        isOpen: isOpen,
        isLoading: isLoading,
        expectedInput: name,
        inputPlaceholder: name,
        className: $eee223e8f5f30a21$export$a71f3c3c51e55058,
        title: "tenants.delete_modal.title",
        confirmButtonText: "tenants.delete_modal.delete_button",
        onCancel: onClose,
        onConfirm: onDelete,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($eee223e8f5f30a21$export$6d59db4903f20f7d, $eee223e8f5f30a21$export$a7db06668cad9adb),
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                className: $eee223e8f5f30a21$export$73ba5813cda80a49
                            })
                        },
                        children: t("tenants.delete_modal.description_line1", {
                            name: name,
                            tag: t((0, $1789cada9ae21d95$export$ae9becdfc4a807ab)[tag], {})
                        })
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                className: $eee223e8f5f30a21$export$e4043f67d36cbb26
                            }),
                            a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {})
                        },
                        children: t("tenants.delete_modal.description_line2")
                    })
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("p", {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                className: $eee223e8f5f30a21$export$73ba5813cda80a49
                            })
                        },
                        children: t("tenants.delete_modal.description_line3", {
                            name: name
                        })
                    })
                })
            ]
        })
    });
}
var $3c169c19cecafbaf$export$2e2bcd8739ae039 = $3c169c19cecafbaf$var$DeleteModal;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $47yah = parcelRequire("47yah");

var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $3GN9E = parcelRequire("3GN9E");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $1Iq4D = parcelRequire("1Iq4D");

var $ea9763ffc6f8c54f$export$34e0f9847d4c02dd;
var $ea9763ffc6f8c54f$export$6d59db4903f20f7d;
var $ea9763ffc6f8c54f$export$bfd64c937657f93a;
var $ea9763ffc6f8c54f$export$4a6dd88bada4e7d2;
$ea9763ffc6f8c54f$export$34e0f9847d4c02dd = `IFpuaG_container`;
$ea9763ffc6f8c54f$export$6d59db4903f20f7d = `IFpuaG_description`;
$ea9763ffc6f8c54f$export$bfd64c937657f93a = `IFpuaG_rotating`;
$ea9763ffc6f8c54f$export$4a6dd88bada4e7d2 = `IFpuaG_shimmer`;


function $0a116883992ce1cf$var$TenantEnvironment({ tag: tag }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $ea9763ffc6f8c54f$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1789cada9ae21d95$export$2e2bcd8739ae039), {
                isAbbreviated: false,
                size: "large",
                tag: tag
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $ea9763ffc6f8c54f$export$6d59db4903f20f7d,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            targetBlank: "noopener",
                            href: getDocumentationUrl((0, $o53Y2.envTagsFeatureLink))
                        })
                    },
                    children: t(tag === (0, $3GN9E.TenantTag).Development ? "tenants.settings.development_description" : "tenants.settings.production_description")
                })
            })
        ]
    });
}
var $0a116883992ce1cf$export$2e2bcd8739ae039 = $0a116883992ce1cf$var$TenantEnvironment;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");
parcelRequire("6ZMK7");
var $o53Y2 = parcelRequire("o53Y2");

var $1Iq4D = parcelRequire("1Iq4D");
var $223f6ba3c8ae9e0b$export$34e0f9847d4c02dd;
var $223f6ba3c8ae9e0b$export$1ca1ec8b29a4ce27;
var $223f6ba3c8ae9e0b$export$9b1a70c9ede163e;
var $223f6ba3c8ae9e0b$export$89db558d656a76ad;
var $223f6ba3c8ae9e0b$export$bfd64c937657f93a;
var $223f6ba3c8ae9e0b$export$4a6dd88bada4e7d2;
$223f6ba3c8ae9e0b$export$34e0f9847d4c02dd = `_3Smarq_container`;
$223f6ba3c8ae9e0b$export$1ca1ec8b29a4ce27 = `_3Smarq_icon`;
$223f6ba3c8ae9e0b$export$9b1a70c9ede163e = `_3Smarq_region`;
$223f6ba3c8ae9e0b$export$89db558d656a76ad = `_3Smarq_regionTip`;
$223f6ba3c8ae9e0b$export$bfd64c937657f93a = `_3Smarq_rotating`;
$223f6ba3c8ae9e0b$export$4a6dd88bada4e7d2 = `_3Smarq_shimmer`;


function $ae55a944b4b96945$var$TenantRegion() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $223f6ba3c8ae9e0b$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $223f6ba3c8ae9e0b$export$9b1a70c9ede163e,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $223f6ba3c8ae9e0b$export$1ca1ec8b29a4ce27,
                        children: "\uD83C\uDDEA\uD83C\uDDFA"
                    }),
                    "EU"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $223f6ba3c8ae9e0b$export$89db558d656a76ad,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            targetBlank: "noopener",
                            href: (0, $o53Y2.trustAndSecurityLink)
                        })
                    },
                    children: t("tenants.settings.tenant_region_tip", {
                        region: "EU"
                    })
                })
            })
        ]
    });
}
var $ae55a944b4b96945$export$2e2bcd8739ae039 = $ae55a944b4b96945$var$TenantRegion;


var $ac3eea98aca95de0$export$6d59db4903f20f7d;
var $ac3eea98aca95de0$export$bfd64c937657f93a;
var $ac3eea98aca95de0$export$4a6dd88bada4e7d2;
var $ac3eea98aca95de0$export$c54b92c0bb02ba64;
$ac3eea98aca95de0$export$6d59db4903f20f7d = `DRm1Oq_description`;
$ac3eea98aca95de0$export$bfd64c937657f93a = `DRm1Oq_rotating`;
$ac3eea98aca95de0$export$4a6dd88bada4e7d2 = `DRm1Oq_shimmer`;
$ac3eea98aca95de0$export$c54b92c0bb02ba64 = `DRm1Oq_textField`;


const $dc3061ad3331854b$var$tagOptions = [
    {
        title: "tenants.settings.environment_tag_development",
        value: (0, $3GN9E.TenantTag).Development
    },
    {
        title: "tenants.settings.environment_tag_staging",
        value: (0, $3GN9E.TenantTag).Staging
    },
    {
        title: "tenants.settings.environment_tag_production",
        value: (0, $3GN9E.TenantTag).Production
    }
];
function $dc3061ad3331854b$var$ProfileForm({ currentTenantId: currentTenantId }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, register: register, formState: { errors: errors }, getValues: getValues } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "tenants.settings.title",
        description: "tenants.settings.description",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "tenants.settings.tenant_id",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                    value: currentTenantId,
                    variant: "border",
                    className: $ac3eea98aca95de0$export$c54b92c0bb02ba64
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "tenants.settings.tenant_name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("profile.name", {
                        required: true
                    }),
                    error: Boolean(errors.profile?.name)
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "tenants.settings.tenant_region",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ae55a944b4b96945$export$2e2bcd8739ae039), {})
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: "tenants.settings.tenant_type",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0a116883992ce1cf$export$2e2bcd8739ae039), {
                    tag: getValues("profile.tag")
                })
            })
        ]
    });
}
var $dc3061ad3331854b$export$2e2bcd8739ae039 = $dc3061ad3331854b$var$ProfileForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $gmXIe = parcelRequire("gmXIe");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $2mi28 = parcelRequire("2mi28");



var $kcPww = parcelRequire("kcPww");


var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $9bgsA = parcelRequire("9bgsA");





var $2ANSb = parcelRequire("2ANSb");
var $ec05df88935ae93e$export$dbd89fd7a9dba0cb;
var $ec05df88935ae93e$export$12d45ee5c2161b75;
var $ec05df88935ae93e$export$6d59db4903f20f7d;
var $ec05df88935ae93e$export$d3f18b13a180f10f;
var $ec05df88935ae93e$export$f3b647f123acc394;
var $ec05df88935ae93e$export$bfd64c937657f93a;
var $ec05df88935ae93e$export$4a6dd88bada4e7d2;
$ec05df88935ae93e$export$dbd89fd7a9dba0cb = `LT-eRq_bone`;
$ec05df88935ae93e$export$12d45ee5c2161b75 = `LT-eRq_deleteIcon`;
$ec05df88935ae93e$export$6d59db4903f20f7d = `LT-eRq_description`;
$ec05df88935ae93e$export$d3f18b13a180f10f = `LT-eRq_idWrapper`;
$ec05df88935ae93e$export$f3b647f123acc394 = `LT-eRq_rotateKey`;
$ec05df88935ae93e$export$bfd64c937657f93a = `LT-eRq_rotating`;
$ec05df88935ae93e$export$4a6dd88bada4e7d2 = `LT-eRq_shimmer`;
$ec05df88935ae93e$export$4a6dd88bada4e7d2;


function $8e611599a432d654$var$SigningKeys() {
    const api = (0, $2ANSb.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.tenants.signing_keys"
    });
    const [keyType, setKeyType] = (0, $eCoWV.useState)((0, $gmXIe.LogtoOidcConfigKeyType).PrivateKeys);
    const isPrivateKey = keyType === (0, $gmXIe.LogtoOidcConfigKeyType).PrivateKeys;
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(`api/configs/oidc/${keyType}`);
    const [deletingKeyId, setDeletingKeyId] = (0, $eCoWV.useState)();
    const [showRotateConfirmModal, setShowRotateConfirmModal] = (0, $eCoWV.useState)(false);
    const [isRotating, setIsRotating] = (0, $eCoWV.useState)(false);
    const [rotateKeyAlgorithm, setRotateKeyAlgorithm] = (0, $eCoWV.useState)((0, $gmXIe.SupportedSigningKeyAlgorithm).EC);
    const isLoadingKeys = !data && !error;
    const tableColumns = (0, $eCoWV.useMemo)(()=>[
            {
                title: t("table_column.id"),
                dataIndex: "id",
                colSpan: 8,
                render: ({ id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        className: $ec05df88935ae93e$export$d3f18b13a180f10f,
                        children: id
                    })
            },
            {
                title: t("table_column.status"),
                dataIndex: "status",
                colSpan: 4,
                render: (_, rowIndex)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                        type: "state",
                        variant: "plain",
                        status: rowIndex === 0 ? "success" : "alert",
                        children: t(rowIndex === 0 ? "status.current" : "status.previous")
                    })
            },
            ...(0, $5CQIb.condArray)(isPrivateKey && [
                {
                    title: t("table_column.algorithm"),
                    dataIndex: "signingKeyAlgorithm",
                    colSpan: 7,
                    render: ({ signingKeyAlgorithm: signingKeyAlgorithm })=>/*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                            children: signingKeyAlgorithm
                        })
                }
            ]),
            {
                title: "",
                dataIndex: "action",
                colSpan: 2,
                render: ({ id: id }, rowIndex)=>rowIndex !== 0 && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ec05df88935ae93e$export$12d45ee5c2161b75,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            onClick: ()=>{
                                setDeletingKeyId(id);
                            },
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                        })
                    })
            }
        ], [
        isPrivateKey,
        t
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
        title: "tenants.signing_keys.title",
        description: "tenants.signing_keys.description",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        isActive: keyType === (0, $gmXIe.LogtoOidcConfigKeyType).PrivateKeys,
                        onClick: ()=>{
                            setKeyType((0, $gmXIe.LogtoOidcConfigKeyType).PrivateKeys);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.signing_keys.type.private_key"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                        isActive: keyType === (0, $gmXIe.LogtoOidcConfigKeyType).CookieKeys,
                        onClick: ()=>{
                            setKeyType((0, $gmXIe.LogtoOidcConfigKeyType).CookieKeys);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "tenants.signing_keys.type.cookie_key"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: `tenants.signing_keys.${isPrivateKey ? "private" : "cookie"}_keys_in_use`,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                    hasBorder: true,
                    isRowHoverEffectDisabled: true,
                    isLoading: isLoadingKeys || isRotating,
                    errorMessage: error?.body?.message ?? error?.message,
                    rowIndexKey: "id",
                    rowGroups: [
                        {
                            key: "signing_keys",
                            data: data
                        }
                    ],
                    columns: tableColumns
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                title: `tenants.signing_keys.rotate_${isPrivateKey ? "private" : "cookie"}_keys`,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $ec05df88935ae93e$export$f3b647f123acc394,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $ec05df88935ae93e$export$6d59db4903f20f7d,
                            children: t(`rotate_${isPrivateKey ? "private" : "cookie"}_keys_description`)
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: `tenants.signing_keys.rotate_${isPrivateKey ? "private" : "cookie"}_keys`,
                            type: "default",
                            onClick: ()=>{
                                setShowRotateConfirmModal(true);
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                confirmButtonText: "tenants.signing_keys.rotate_button",
                isOpen: showRotateConfirmModal,
                onCancel: ()=>{
                    setShowRotateConfirmModal(false);
                },
                onConfirm: async ()=>{
                    setIsRotating(true);
                    setShowRotateConfirmModal(false);
                    try {
                        const keys = await api.post(`api/configs/oidc/${keyType}/rotate`, {
                            json: {
                                signingKeyAlgorithm: rotateKeyAlgorithm
                            }
                        }).json();
                        mutate(keys);
                        (0, $horhC.toast).success(t("messages.rotate_key_success"));
                    } finally{
                        setIsRotating(false);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                strong: /*#__PURE__*/ (0, $9zeGj.jsx)("strong", {})
                            },
                            children: t(`reminder.rotate_${isPrivateKey ? "private" : "cookie"}_key`)
                        })
                    }),
                    isPrivateKey && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                        title: "tenants.signing_keys.select_private_key_algorithm",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $55c80f28eec7e930$export$2e2bcd8739ae039), {
                            options: Object.values((0, $gmXIe.SupportedSigningKeyAlgorithm)).map((value)=>({
                                    title: value,
                                    value: value
                                })),
                            value: rotateKeyAlgorithm,
                            onChange: (value)=>{
                                if (!value) return;
                                setRotateKeyAlgorithm(value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                isOpen: Boolean(deletingKeyId),
                onCancel: ()=>{
                    setDeletingKeyId(undefined);
                },
                onConfirm: async ()=>{
                    if (!deletingKeyId) return;
                    try {
                        await api.delete(`api/configs/oidc/${keyType}/${deletingKeyId}`);
                        mutate(data?.filter((key)=>key.id !== deletingKeyId));
                        (0, $horhC.toast).success(t("messages.delete_key_success"));
                    } finally{
                        setDeletingKeyId(undefined);
                    }
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                        components: {
                            strong: /*#__PURE__*/ (0, $9zeGj.jsx)("strong", {})
                        },
                        children: t(`reminder.delete_${isPrivateKey ? "private" : "cookie"}_key`)
                    })
                })
            })
        ]
    });
}
var $8e611599a432d654$export$2e2bcd8739ae039 = $8e611599a432d654$var$SigningKeys;


var $709612b5ffe32892$export$34e0f9847d4c02dd;
var $709612b5ffe32892$export$4dbdc8f16fed8a34;
var $709612b5ffe32892$export$bfd64c937657f93a;
var $709612b5ffe32892$export$4a6dd88bada4e7d2;
var $709612b5ffe32892$export$1258c5dd981c51cf;
$709612b5ffe32892$export$34e0f9847d4c02dd = `tIHRNq_container`;
$709612b5ffe32892$export$4dbdc8f16fed8a34 = `tIHRNq_fields`;
$709612b5ffe32892$export$bfd64c937657f93a = `tIHRNq_rotating`;
$709612b5ffe32892$export$4a6dd88bada4e7d2 = `tIHRNq_shimmer`;
$709612b5ffe32892$export$1258c5dd981c51cf = `tIHRNq_withSubmitActionBar`;


const $a1f3865920951bed$var$tenantProfileToForm = (tenant)=>{
    return {
        profile: {
            name: tenant?.name ?? "My project",
            tag: tenant?.tag ?? (0, $3GN9E.TenantTag).Development
        }
    };
};
function $a1f3865920951bed$var$TenantBasicSettings() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $3978b41c434b0156$export$7a5c900790855d66)();
    const { currentTenant: currentTenant, currentTenantId: currentTenantId, isDevTenant: isDevTenant, updateTenant: updateTenant, removeTenant: removeTenant, navigateTenant: navigateTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const [isDeletionModalOpen, setIsDeletionModalOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const { show: showModal } = (0, $9ENFn.useConfirmModal)();
    const methods = (0, $c3LX9.useForm)({
        defaultValues: $a1f3865920951bed$var$tenantProfileToForm(currentTenant)
    });
    const { watch: watch, reset: reset, handleSubmit: handleSubmit, formState: { isDirty: isDirty, isSubmitting: isSubmitting } } = methods;
    (0, $eCoWV.useEffect)(()=>{
        reset($a1f3865920951bed$var$tenantProfileToForm(currentTenant));
    }, [
        currentTenant,
        reset
    ]);
    const saveData = async (data)=>{
        const { name: name, tag: tag } = await api.patch(`/api/tenants/:tenantId`, {
            params: {
                tenantId: currentTenantId
            },
            body: data
        });
        reset({
            profile: {
                name: name,
                tag: tag
            }
        });
        (0, $horhC.toast).success(t("tenants.settings.tenant_info_saved"));
        updateTenant(currentTenantId, data);
    };
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const { profile: { name: name, tag: tag } } = formData;
        await saveData({
            name: name,
            tag: tag
        });
    }));
    const onClickDeletionButton = async ()=>{
        if (!isDevTenant && (currentTenant?.subscription.planId !== (0, $ckJfF.ReservedPlanId).Free || currentTenant.openInvoices.length > 0)) {
            await showModal({
                title: "tenants.delete_modal.cannot_delete_title",
                ModalContent: t("tenants.delete_modal.cannot_delete_description"),
                type: "alert",
                cancelButtonText: "general.got_it"
            });
            return;
        }
        setIsDeletionModalOpen(true);
    };
    const onDelete = async ()=>{
        if (isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`/api/tenants/:tenantId`, {
                params: {
                    tenantId: currentTenantId
                }
            });
            setIsDeletionModalOpen(false);
            removeTenant(currentTenantId);
            navigateTenant("");
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "tenants.tabs.settings",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($709612b5ffe32892$export$34e0f9847d4c02dd, isDirty && $709612b5ffe32892$export$1258c5dd981c51cf),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
                        ...methods,
                        children: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $709612b5ffe32892$export$4dbdc8f16fed8a34,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dc3061ad3331854b$export$2e2bcd8739ae039), {
                                    currentTenantId: currentTenantId
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8e611599a432d654$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c186929a08b687ac$export$2e2bcd8739ae039), {
                                    currentTenantId: currentTenantId,
                                    onClick: onClickDeletionButton
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0ff0308e2fe37f42$export$2e2bcd8739ae039), {
                        isOpen: isDirty,
                        isSubmitting: isSubmitting,
                        onDiscard: reset,
                        onSubmit: onSubmit
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: isDirty
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3c169c19cecafbaf$export$2e2bcd8739ae039), {
                isOpen: isDeletionModalOpen,
                isLoading: isDeleting,
                tenant: watch("profile"),
                onClose: ()=>{
                    setIsDeletionModalOpen(false);
                },
                onDelete: onDelete
            })
        ]
    });
}
var $a1f3865920951bed$export$2e2bcd8739ae039 = $a1f3865920951bed$var$TenantBasicSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");


var $a0Ubj = parcelRequire("a0Ubj");

var $dADBR = parcelRequire("dADBR");

var $itzs0 = parcelRequire("itzs0");



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $kcPww = parcelRequire("kcPww");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $6PcpQ = parcelRequire("6PcpQ");

var $bSFEw = parcelRequire("bSFEw");
var $4ad8c33437b73758$export$76174c80c75f9baa;
var $4ad8c33437b73758$export$55b49835081025b8;
var $4ad8c33437b73758$export$bfd64c937657f93a;
var $4ad8c33437b73758$export$4a6dd88bada4e7d2;
var $4ad8c33437b73758$export$181ff85155496734;
$4ad8c33437b73758$export$76174c80c75f9baa = `NxrG3q_addButton`;
$4ad8c33437b73758$export$55b49835081025b8 = `NxrG3q_addDomain`;
$4ad8c33437b73758$export$bfd64c937657f93a = `NxrG3q_rotating`;
$4ad8c33437b73758$export$4a6dd88bada4e7d2 = `NxrG3q_shimmer`;
$4ad8c33437b73758$export$181ff85155496734 = `NxrG3q_textInput`;


const $4f32972ad4593c0c$var$subdomainRegex = /^[\dA-Za-z][\dA-Za-z-]*[\dA-Za-z](\.[\dA-Za-z][\dA-Za-z-]*[\dA-Za-z]){2,}$/;
function $4f32972ad4593c0c$var$AddDomainForm({ onCustomDomainAdded: onCustomDomainAdded }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, watch: watch, formState: { errors: errors, isSubmitting: isSubmitting }, handleSubmit: handleSubmit } = (0, $c3LX9.useForm)({
        defaultValues: {
            domain: ""
        }
    });
    const domainInput = watch("domain");
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        const createdDomain = await api.post("api/domains", {
            json: formData
        }).json();
        onCustomDomainAdded(createdDomain);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $4ad8c33437b73758$export$55b49835081025b8,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                className: $4ad8c33437b73758$export$181ff85155496734,
                placeholder: t("domain.custom.custom_domain_placeholder"),
                error: errors.domain?.message,
                onKeyDown: (0, $6PcpQ.onKeyDownHandler)({
                    Enter: onSubmit
                }),
                ...register("domain", {
                    required: true,
                    pattern: {
                        value: $4f32972ad4593c0c$var$subdomainRegex,
                        message: t("domain.custom.invalid_domain_format")
                    }
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                className: $4ad8c33437b73758$export$76174c80c75f9baa,
                type: "primary",
                title: "domain.custom.add_domain",
                isLoading: isSubmitting,
                disabled: domainInput.length === 0,
                onClick: onSubmit
            })
        ]
    });
}
var $4f32972ad4593c0c$export$2e2bcd8739ae039 = $4f32972ad4593c0c$var$AddDomainForm;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $1EA0k = parcelRequire("1EA0k");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $1Iq4D = parcelRequire("1Iq4D");


var $9zeGj = parcelRequire("9zeGj");

var $it2CQ = parcelRequire("it2CQ");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9XAkT = parcelRequire("9XAkT");

var $9zeGj = parcelRequire("9zeGj");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $6jNMj = parcelRequire("6jNMj");

var $ce63d31aadb6f919$export$aa79b10cb7913a21;
var $ce63d31aadb6f919$export$4e0c71f277ca26b3;
var $ce63d31aadb6f919$export$34e0f9847d4c02dd;
var $ce63d31aadb6f919$export$38e42c68cf43b5d4;
var $ce63d31aadb6f919$export$46c1c92549715335;
var $ce63d31aadb6f919$export$5dd8d3d3c0fde971;
var $ce63d31aadb6f919$export$bfd64c937657f93a;
var $ce63d31aadb6f919$export$4a6dd88bada4e7d2;
var $ce63d31aadb6f919$export$9852986a3ec5f6a0;
var $ce63d31aadb6f919$export$5e5b4df997cb5eaa;
$ce63d31aadb6f919$export$aa79b10cb7913a21 = `zsr46a_bodyTableWrapper`;
$ce63d31aadb6f919$export$4e0c71f277ca26b3 = `zsr46a_column`;
$ce63d31aadb6f919$export$34e0f9847d4c02dd = `zsr46a_container`;
$ce63d31aadb6f919$export$38e42c68cf43b5d4 = `zsr46a_header`;
$ce63d31aadb6f919$export$46c1c92549715335 = `zsr46a_loading`;
$ce63d31aadb6f919$export$5dd8d3d3c0fde971 = `zsr46a_loadingIcon`;
$ce63d31aadb6f919$export$bfd64c937657f93a = `zsr46a_rotating`;
$ce63d31aadb6f919$export$4a6dd88bada4e7d2 = `zsr46a_shimmer`;
$ce63d31aadb6f919$export$9852986a3ec5f6a0 = `zsr46a_table`;
$ce63d31aadb6f919$export$5e5b4df997cb5eaa = `zsr46a_tip`;


function $ddbad83ac9b25e79$var$DnsRecordsTable({ records: records }) {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $ce63d31aadb6f919$export$5e5b4df997cb5eaa,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "domain.custom.add_dns_records"
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $ce63d31aadb6f919$export$34e0f9847d4c02dd,
                children: records.length === 0 ? /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $ce63d31aadb6f919$export$46c1c92549715335,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {
                            className: $ce63d31aadb6f919$export$5dd8d3d3c0fde971
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "domain.custom.generating_dns_records"
                        })
                    ]
                }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                    isRowHoverEffectDisabled: true,
                    className: $ce63d31aadb6f919$export$9852986a3ec5f6a0,
                    headerTableClassName: $ce63d31aadb6f919$export$38e42c68cf43b5d4,
                    bodyTableWrapperClassName: $ce63d31aadb6f919$export$aa79b10cb7913a21,
                    rowGroups: [
                        {
                            key: "dnsRecords",
                            data: records
                        }
                    ],
                    rowIndexKey: "name",
                    isRowClickable: ()=>false,
                    columns: [
                        {
                            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "domain.custom.dns_table.type_field"
                            }),
                            dataIndex: "type",
                            colSpan: 2,
                            render: ({ type: type })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ce63d31aadb6f919$export$4e0c71f277ca26b3,
                                    children: type
                                })
                        },
                        {
                            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "domain.custom.dns_table.name_field"
                            }),
                            dataIndex: "name",
                            colSpan: 7,
                            render: ({ name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                    isWordWrapAllowed: true,
                                    className: $ce63d31aadb6f919$export$4e0c71f277ca26b3,
                                    value: name,
                                    variant: "text"
                                })
                        },
                        {
                            title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "domain.custom.dns_table.value_field"
                            }),
                            dataIndex: "value",
                            colSpan: 7,
                            render: ({ value: value })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                    isWordWrapAllowed: true,
                                    className: $ce63d31aadb6f919$export$4e0c71f277ca26b3,
                                    value: value,
                                    variant: "text"
                                })
                        }
                    ]
                })
            })
        ]
    });
}
var $ddbad83ac9b25e79$export$2e2bcd8739ae039 = $ddbad83ac9b25e79$var$DnsRecordsTable;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $1EA0k = parcelRequire("1EA0k");

var $iyeK6 = parcelRequire("iyeK6");


var $ds4Cq = parcelRequire("ds4Cq");

var $fbeQ6 = parcelRequire("fbeQ6");

var $9bgsA = parcelRequire("9bgsA");

var $6jNMj = parcelRequire("6jNMj");

var $bf05n = parcelRequire("bf05n");
var $aa51c97b5518e613$export$8f981dffec84ba52;
var $aa51c97b5518e613$export$90407f30cb0073b9;
var $aa51c97b5518e613$export$38e42c68cf43b5d4;
var $aa51c97b5518e613$export$1ca1ec8b29a4ce27;
var $aa51c97b5518e613$export$46c1c92549715335;
var $aa51c97b5518e613$export$bfd64c937657f93a;
var $aa51c97b5518e613$export$4a6dd88bada4e7d2;
var $aa51c97b5518e613$export$471f7ae5c4103ae1;
var $aa51c97b5518e613$export$35d34bc0ed591a92;
var $aa51c97b5518e613$export$d26e66e6a9da146e;
var $aa51c97b5518e613$export$5e5b4df997cb5eaa;
var $aa51c97b5518e613$export$fb184b623420d9be;
$aa51c97b5518e613$export$8f981dffec84ba52 = `v0c2IW_contentContainer`;
$aa51c97b5518e613$export$90407f30cb0073b9 = `v0c2IW_finished`;
$aa51c97b5518e613$export$38e42c68cf43b5d4 = `v0c2IW_header`;
$aa51c97b5518e613$export$1ca1ec8b29a4ce27 = `v0c2IW_icon`;
$aa51c97b5518e613$export$46c1c92549715335 = `v0c2IW_loading`;
$aa51c97b5518e613$export$bfd64c937657f93a = `v0c2IW_rotating`;
$aa51c97b5518e613$export$4a6dd88bada4e7d2 = `v0c2IW_shimmer`;
$aa51c97b5518e613$export$471f7ae5c4103ae1 = `v0c2IW_status`;
$aa51c97b5518e613$export$35d34bc0ed591a92 = `v0c2IW_step`;
$aa51c97b5518e613$export$d26e66e6a9da146e = `v0c2IW_stepIcon`;
$aa51c97b5518e613$export$5e5b4df997cb5eaa = `v0c2IW_tip`;
$aa51c97b5518e613$export$fb184b623420d9be = `v0c2IW_title`;


const $2dc9da606d447302$var$domainStatusToStep = {
    [(0, $1EA0k.DomainStatus).Error]: 0,
    [(0, $1EA0k.DomainStatus).PendingVerification]: 1,
    [(0, $1EA0k.DomainStatus).PendingSsl]: 2,
    [(0, $1EA0k.DomainStatus).Active]: 3
};
function $2dc9da606d447302$var$Step({ step: step, title: title, tip: tip, domainStatus: domainStatus, children: children }) {
    const domainStatusStep = $2dc9da606d447302$var$domainStatusToStep[domainStatus];
    const isPending = step > domainStatusStep;
    const isLoading = step === domainStatusStep;
    const isFinished = step < domainStatusStep;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $aa51c97b5518e613$export$35d34bc0ed591a92,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $aa51c97b5518e613$export$38e42c68cf43b5d4,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($aa51c97b5518e613$export$d26e66e6a9da146e, isLoading && $aa51c97b5518e613$export$46c1c92549715335, isFinished && $aa51c97b5518e613$export$90407f30cb0073b9),
                        children: [
                            isPending && step,
                            isLoading && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6jNMj.Ring), {}),
                            isFinished && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $98c485b7de5371d8$export$2e2bcd8739ae039), {
                                className: $aa51c97b5518e613$export$1ca1ec8b29a4ce27
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $aa51c97b5518e613$export$fb184b623420d9be,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: title
                        })
                    }),
                    tip && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                        anchorClassName: $aa51c97b5518e613$export$5e5b4df997cb5eaa,
                        content: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: tip
                        }),
                        horizontalAlign: "start",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                            size: "small",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $aa51c97b5518e613$export$8f981dffec84ba52,
                children: children
            })
        ]
    });
}
var $2dc9da606d447302$export$2e2bcd8739ae039 = $2dc9da606d447302$var$Step;


var $44807b5230d1a4c2$export$34e0f9847d4c02dd;
var $44807b5230d1a4c2$export$dd472c3d8fe5a85a;
var $44807b5230d1a4c2$export$464c821cd4347539;
var $44807b5230d1a4c2$export$bfd64c937657f93a;
var $44807b5230d1a4c2$export$4a6dd88bada4e7d2;
$44807b5230d1a4c2$export$34e0f9847d4c02dd = `o9ke_a_container`;
$44807b5230d1a4c2$export$dd472c3d8fe5a85a = `o9ke_a_errorNotification`;
$44807b5230d1a4c2$export$464c821cd4347539 = `o9ke_a_hint`;
$44807b5230d1a4c2$export$bfd64c937657f93a = `o9ke_a_rotating`;
$44807b5230d1a4c2$export$4a6dd88bada4e7d2 = `o9ke_a_shimmer`;


function $77766ece16b8bb36$var$ActivationProcess({ customDomain: customDomain }) {
    const { dnsRecords: dnsRecords, status: domainStatus, errorMessage: errorMessage } = customDomain;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $44807b5230d1a4c2$export$34e0f9847d4c02dd,
        children: [
            errorMessage && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9XAkT.default), {
                className: $44807b5230d1a4c2$export$dd472c3d8fe5a85a,
                severity: "error",
                children: [
                    errorMessage,
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $44807b5230d1a4c2$export$464c821cd4347539,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "domain.error_hint",
                            interpolation: {
                                value: (0, $it2CQ.customDomainSyncInterval)
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2dc9da606d447302$export$2e2bcd8739ae039), {
                step: 1,
                title: "domain.custom.verify_domain",
                tip: "domain.custom.checking_dns_tip",
                domainStatus: domainStatus,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ddbad83ac9b25e79$export$2e2bcd8739ae039), {
                    records: dnsRecords
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2dc9da606d447302$export$2e2bcd8739ae039), {
                step: 2,
                title: "domain.custom.enable_ssl",
                tip: "domain.custom.enable_ssl_tip",
                domainStatus: domainStatus
            })
        ]
    });
}
var $77766ece16b8bb36$export$2e2bcd8739ae039 = $77766ece16b8bb36$var$ActivationProcess;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $1EA0k = parcelRequire("1EA0k");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");




var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");


var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");
var $a732dbb65899b807$export$21779e503be4cd98;
var $a732dbb65899b807$export$b5e8073716d2cfa;
var $a732dbb65899b807$export$38e42c68cf43b5d4;
var $a732dbb65899b807$export$1ca1ec8b29a4ce27;
var $a732dbb65899b807$export$4cc594d73a54e241;
var $a732dbb65899b807$export$bfd64c937657f93a;
var $a732dbb65899b807$export$4a6dd88bada4e7d2;
var $a732dbb65899b807$export$59ae2c325a998f89;
$a732dbb65899b807$export$21779e503be4cd98 = `_7tMuma_domain`;
$a732dbb65899b807$export$b5e8073716d2cfa = `_7tMuma_domainInfo`;
$a732dbb65899b807$export$38e42c68cf43b5d4 = `_7tMuma_header`;
$a732dbb65899b807$export$1ca1ec8b29a4ce27 = `_7tMuma_icon`;
$a732dbb65899b807$export$4cc594d73a54e241 = `_7tMuma_inUsedDeletionTip`;
$a732dbb65899b807$export$bfd64c937657f93a = `_7tMuma_rotating`;
$a732dbb65899b807$export$4a6dd88bada4e7d2 = `_7tMuma_shimmer`;
$a732dbb65899b807$export$59ae2c325a998f89 = `_7tMuma_strong`;


const $bdc739ddbb4a2a9d$var$domainStatusToTag = {
    [(0, $1EA0k.DomainStatus).PendingVerification]: {
        title: "domain.status.connecting",
        status: "alert"
    },
    [(0, $1EA0k.DomainStatus).PendingSsl]: {
        title: "domain.status.connecting",
        status: "alert"
    },
    [(0, $1EA0k.DomainStatus).Active]: {
        title: "domain.status.in_used",
        status: "success"
    },
    [(0, $1EA0k.DomainStatus).Error]: {
        title: "domain.status.failed_to_connect",
        status: "error"
    }
};
function $bdc739ddbb4a2a9d$var$CustomDomainHeader({ customDomain: { id: id, domain: domain, status: status }, onDeleteCustomDomain: onDeleteCustomDomain }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const tag = $bdc739ddbb4a2a9d$var$domainStatusToTag[status];
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        const [result] = await show({
            ModalContent: ()=>{
                if (status !== (0, $1EA0k.DomainStatus).Active) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "domain.custom.deletion.description"
                });
                return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                            components: {
                                span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                    className: $a732dbb65899b807$export$59ae2c325a998f89
                                })
                            },
                            children: t("domain.custom.deletion.in_used_description", {
                                domain: domain
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $a732dbb65899b807$export$4cc594d73a54e241,
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                                components: {
                                    span: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        className: $a732dbb65899b807$export$59ae2c325a998f89
                                    })
                                },
                                children: t("domain.custom.deletion.in_used_tip", {
                                    domain: domain
                                })
                            })
                        })
                    ]
                });
            },
            confirmButtonText: "general.delete",
            title: "domain.custom.deletion.delete_domain"
        });
        if (!result) return;
        await api.delete(`api/domains/${id}`);
        (0, $horhC.toast).success(t("domain.custom.deletion.deleted"));
        onDeleteCustomDomain();
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $a732dbb65899b807$export$38e42c68cf43b5d4,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $a732dbb65899b807$export$b5e8073716d2cfa,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        className: $a732dbb65899b807$export$21779e503be4cd98,
                        value: domain,
                        variant: "text"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                        status: tag.status,
                        type: "state",
                        variant: "plain",
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: tag.title
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bcb314c46a8bc4c1$export$2e2bcd8739ae039), {
                buttonProps: {
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c8927b9279b58d6c$export$2e2bcd8739ae039), {
                        className: $a732dbb65899b807$export$1ca1ec8b29a4ce27
                    }),
                    size: "large"
                },
                title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "general.more_options"
                }),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cebb3b53f6828066$export$2e2bcd8739ae039), {
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                    type: "danger",
                    onClick: handleDelete,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "general.delete"
                    })
                })
            })
        ]
    });
}
var $bdc739ddbb4a2a9d$export$2e2bcd8739ae039 = $bdc739ddbb4a2a9d$var$CustomDomainHeader;


var $3e4497ea6c6c9dd0$export$34e0f9847d4c02dd;
var $3e4497ea6c6c9dd0$export$fff9cb9cb797a870;
var $3e4497ea6c6c9dd0$export$bfd64c937657f93a;
var $3e4497ea6c6c9dd0$export$4a6dd88bada4e7d2;
$3e4497ea6c6c9dd0$export$34e0f9847d4c02dd = `wMuGfW_container`;
$3e4497ea6c6c9dd0$export$fff9cb9cb797a870 = `wMuGfW_notes`;
$3e4497ea6c6c9dd0$export$bfd64c937657f93a = `wMuGfW_rotating`;
$3e4497ea6c6c9dd0$export$4a6dd88bada4e7d2 = `wMuGfW_shimmer`;


function $b71fc3d7f575dc31$var$CustomDomain({ customDomain: customDomain, onDeleteCustomDomain: onDeleteCustomDomain }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $3e4497ea6c6c9dd0$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bdc739ddbb4a2a9d$export$2e2bcd8739ae039), {
                        customDomain: customDomain,
                        onDeleteCustomDomain: onDeleteCustomDomain
                    }),
                    customDomain.status !== (0, $1EA0k.DomainStatus).Active && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $77766ece16b8bb36$export$2e2bcd8739ae039), {
                        customDomain: customDomain
                    })
                ]
            }),
            customDomain.status === (0, $1EA0k.DomainStatus).Active && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $3e4497ea6c6c9dd0$export$fff9cb9cb797a870,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    components: {
                        a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1Iq4D.default), {
                            targetBlank: "noopener",
                            to: getDocumentationUrl("docs/recipes/custom-domain/use-custom-domain")
                        })
                    },
                    children: t("domain.update_endpoint_notice", {
                        link: t("general.learn_more")
                    })
                })
            })
        ]
    });
}
var $b71fc3d7f575dc31$export$2e2bcd8739ae039 = $b71fc3d7f575dc31$var$CustomDomain;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $eEyjP = parcelRequire("eEyjP");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $e0318c94f73ad021$export$34e0f9847d4c02dd;
var $e0318c94f73ad021$export$21779e503be4cd98;
var $e0318c94f73ad021$export$bfd64c937657f93a;
var $e0318c94f73ad021$export$4a6dd88bada4e7d2;
$e0318c94f73ad021$export$34e0f9847d4c02dd = `Ju3gQq_container`;
$e0318c94f73ad021$export$21779e503be4cd98 = `Ju3gQq_domain`;
$e0318c94f73ad021$export$bfd64c937657f93a = `Ju3gQq_rotating`;
$e0318c94f73ad021$export$4a6dd88bada4e7d2 = `Ju3gQq_shimmer`;


function $78be589da22fc01d$var$DefaultDomain() {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    if (!tenantEndpoint) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $e0318c94f73ad021$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                className: $e0318c94f73ad021$export$21779e503be4cd98,
                value: tenantEndpoint.host,
                variant: "text"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                status: "success",
                type: "state",
                variant: "plain",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "domain.status.in_used"
                })
            })
        ]
    });
}
var $78be589da22fc01d$export$2e2bcd8739ae039 = $78be589da22fc01d$var$DefaultDomain;


var $0e21d5f1ddbff785$export$34e0f9847d4c02dd;
var $0e21d5f1ddbff785$export$bfd64c937657f93a;
var $0e21d5f1ddbff785$export$4a6dd88bada4e7d2;
var $0e21d5f1ddbff785$export$a8bf3124b60187b4;
$0e21d5f1ddbff785$export$34e0f9847d4c02dd = `SzQhjG_container`;
$0e21d5f1ddbff785$export$bfd64c937657f93a = `SzQhjG_rotating`;
$0e21d5f1ddbff785$export$4a6dd88bada4e7d2 = `SzQhjG_shimmer`;
$0e21d5f1ddbff785$export$a8bf3124b60187b4 = `SzQhjG_upsellNotification`;


function $d18826402be754b7$var$TenantDomainSettings() {
    const { data: customDomain, isLoading: isLoadingCustomDomain, mutate: mutate } = (0, $itzs0.default)(true);
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    if (isLoadingCustomDomain) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2a16903d351dcaff$export$2e2bcd8739ae039), {});
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $0e21d5f1ddbff785$export$34e0f9847d4c02dd,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: [
                    "tenants.tabs.domains",
                    "tenants.title"
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                title: "domain.custom.custom_domain",
                description: "domain.custom.custom_domain_description",
                learnMoreLink: {
                    href: getDocumentationUrl("docs/recipes/custom-domain"),
                    targetBlank: "noopener"
                },
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "domain.custom.custom_domain_field",
                    children: customDomain ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $b71fc3d7f575dc31$export$2e2bcd8739ae039), {
                        customDomain: customDomain,
                        onDeleteCustomDomain: mutate
                    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4f32972ad4593c0c$export$2e2bcd8739ae039), {
                        onCustomDomainAdded: mutate
                    })
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                title: "domain.default.default_domain",
                description: "domain.default.default_domain_description",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                    title: "domain.default.default_domain_field",
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $78be589da22fc01d$export$2e2bcd8739ae039), {})
                })
            })
        ]
    });
}
var $d18826402be754b7$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($d18826402be754b7$var$TenantDomainSettings);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $43568821afd6a689$var$SvgForbidden = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M10 1.667a8.333 8.333 0 1 0 0 16.666 8.333 8.333 0 0 0 0-16.666Zm0 15A6.667 6.667 0 0 1 3.333 10a6.6 6.6 0 0 1 1.409-4.083l9.341 9.341A6.6 6.6 0 0 1 10 16.667Zm5.258-2.584L5.917 4.742A6.6 6.6 0 0 1 10 3.333 6.667 6.667 0 0 1 16.667 10a6.6 6.6 0 0 1-1.409 4.083Z",
            fill: "currentColor"
        })
    });
var $43568821afd6a689$export$2e2bcd8739ae039 = $43568821afd6a689$var$SvgForbidden;




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a92ac116c25df55c$var$SvgShield = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 20,
        height: 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M16.358 3.042a.833.833 0 0 0-.7-.167 6.666 6.666 0 0 1-5.183-1.058.834.834 0 0 0-.95 0 6.667 6.667 0 0 1-5.183 1.058.833.833 0 0 0-1.008.817V9.9a7.5 7.5 0 0 0 3.141 6.108l3.042 2.167a.834.834 0 0 0 .966 0l3.042-2.167A7.5 7.5 0 0 0 16.667 9.9V3.692a.832.832 0 0 0-.309-.65ZM15 9.9a5.834 5.834 0 0 1-2.441 4.75L10 16.475 7.442 14.65A5.834 5.834 0 0 1 5 9.9V4.65a8.333 8.333 0 0 0 5-1.158 8.333 8.333 0 0 0 5 1.158V9.9Zm-3.716-1.908-2.242 2.25-.742-.75a.837.837 0 1 0-1.183 1.183l1.333 1.333a.833.833 0 0 0 1.184 0L12.5 9.167a.837.837 0 0 0-1.183-1.184l-.034.009Z",
            fill: "currentColor"
        })
    });
var $a92ac116c25df55c$export$2e2bcd8739ae039 = $a92ac116c25df55c$var$SvgShield;





var $a0Ubj = parcelRequire("a0Ubj");


var $emGEN = parcelRequire("emGEN");

var $kMAP9 = parcelRequire("kMAP9");



var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");

var $h7VLF = parcelRequire("h7VLF");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");

var $kzmMx = parcelRequire("kzmMx");

var $kcPww = parcelRequire("kcPww");

var $9bgsA = parcelRequire("9bgsA");

var $bNHoO = parcelRequire("bNHoO");

var $7iZsu = parcelRequire("7iZsu");
var $ee1f532609eaa87c$export$a7db06668cad9adb;
var $ee1f532609eaa87c$export$be704fe733d78a38;
var $ee1f532609eaa87c$export$a80b3bd66acc52ff;
var $ee1f532609eaa87c$export$b8cfaf7638e14578;
var $ee1f532609eaa87c$export$dbca9e3b1ed6816f;
var $ee1f532609eaa87c$export$7b8f6cec25af9dd;
var $ee1f532609eaa87c$export$bfd64c937657f93a;
var $ee1f532609eaa87c$export$4a6dd88bada4e7d2;
$ee1f532609eaa87c$export$a7db06668cad9adb = `_3ZkXhW_content`;
$ee1f532609eaa87c$export$be704fe733d78a38 = `_3ZkXhW_eyeIcon`;
$ee1f532609eaa87c$export$a80b3bd66acc52ff = `_3ZkXhW_info`;
$ee1f532609eaa87c$export$b8cfaf7638e14578 = `_3ZkXhW_infoContent`;
$ee1f532609eaa87c$export$dbca9e3b1ed6816f = `_3ZkXhW_infoLine`;
$ee1f532609eaa87c$export$7b8f6cec25af9dd = `_3ZkXhW_operation`;
$ee1f532609eaa87c$export$bfd64c937657f93a = `_3ZkXhW_rotating`;
$ee1f532609eaa87c$export$4a6dd88bada4e7d2 = `_3ZkXhW_shimmer`;


function $fdba7baf27525206$var$UserAccountInformation({ user: user, password: password, title: title, onClose: onClose, onConfirm: onConfirm, passwordLabel: passwordLabel, confirmButtonTitle: confirmButtonTitle }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [passwordVisible, setPasswordVisible] = (0, $eCoWV.useState)(false);
    const { primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username } = user;
    const handleCopy = async ()=>{
        if (!password) return null;
        const content = (0, $5CQIb.conditionalArray)(primaryEmail && `${t("user_details.created_email")} ${primaryEmail}`, primaryPhone && `${t("user_details.created_phone")} ${primaryPhone}`, username && `${t("user_details.created_username")} ${username}`, `${passwordLabel ?? t("user_details.created_password")} ${password}`).join("\n");
        await navigator.clipboard.writeText(content);
        (0, $horhC.toast).success(t("general.copied"));
    };
    if (!password) return null;
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        isOpen: true,
        shouldCloseOnEsc: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: title,
            footer: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        title: confirmButtonTitle ?? "general.done",
                        onClick: onConfirm ?? onClose
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: "primary",
                        title: "general.copy",
                        onClick: handleCopy
                    })
                ]
            }),
            className: $ee1f532609eaa87c$export$a7db06668cad9adb,
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    children: t("user_details.created_guide")
                }),
                /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $ee1f532609eaa87c$export$a80b3bd66acc52ff,
                    children: [
                        username && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $ee1f532609eaa87c$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    children: t("user_details.created_username")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ee1f532609eaa87c$export$b8cfaf7638e14578,
                                    children: username
                                })
                            ]
                        }),
                        primaryEmail && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $ee1f532609eaa87c$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    children: t("user_details.created_email")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ee1f532609eaa87c$export$b8cfaf7638e14578,
                                    children: primaryEmail
                                })
                            ]
                        }),
                        primaryPhone && /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $ee1f532609eaa87c$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    children: t("user_details.created_phone")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ee1f532609eaa87c$export$b8cfaf7638e14578,
                                    children: primaryPhone
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $ee1f532609eaa87c$export$dbca9e3b1ed6816f,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    children: passwordLabel ?? t("user_details.created_password")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ee1f532609eaa87c$export$b8cfaf7638e14578,
                                    children: passwordVisible ? password : password.replaceAll(/./g, "*")
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                    className: $ee1f532609eaa87c$export$7b8f6cec25af9dd,
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                        onClick: ()=>{
                                            setPasswordVisible((previous)=>!previous);
                                        },
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kzmMx.default), {
                                            className: $ee1f532609eaa87c$export$be704fe733d78a38
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
var $fdba7baf27525206$export$2e2bcd8739ae039 = $fdba7baf27525206$var$UserAccountInformation;




var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $kMAP9 = parcelRequire("kMAP9");

var $2ANSb = parcelRequire("2ANSb");

var $3iNy0 = parcelRequire("3iNy0");
const $447e004ce469432b$export$832e1ed778c99ea4 = ()=>(0, $3iNy0.nanoid)(8);


function $0e2c6c44ff37c903$var$ResetPasswordForm({ onClose: onClose, userId: userId }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const api = (0, $2ANSb.default)();
    const [isLoading, setIsLoading] = (0, $eCoWV.useState)(false);
    const onSubmit = async ()=>{
        const password = (0, $447e004ce469432b$export$832e1ed778c99ea4)();
        setIsLoading(true);
        await api.patch(`api/users/${userId}/password`, {
            json: {
                password: password
            }
        }).json();
        setIsLoading(false);
        onClose?.(password);
    };
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
        isOpen: true,
        title: "user_details.reset_password.title",
        isLoading: isLoading,
        onCancel: ()=>{
            onClose?.();
        },
        onConfirm: onSubmit,
        children: t("user_details.reset_password.content")
    });
}
var $0e2c6c44ff37c903$export$2e2bcd8739ae039 = $0e2c6c44ff37c903$var$ResetPasswordForm;


var $aa63a2ab5370548e$export$26684859963899d2;
var $aa63a2ab5370548e$export$bfd64c937657f93a;
var $aa63a2ab5370548e$export$4a6dd88bada4e7d2;
$aa63a2ab5370548e$export$26684859963899d2 = `tRtS8W_resourceLayout`;
$aa63a2ab5370548e$export$bfd64c937657f93a = `tRtS8W_rotating`;
$aa63a2ab5370548e$export$4a6dd88bada4e7d2 = `tRtS8W_shimmer`;


function $ff62af747b089187$var$UserDetails() {
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const isPageHasTable = pathname.endsWith((0, $emGEN.UserDetailsTabs).Roles) || pathname.endsWith((0, $emGEN.UserDetailsTabs).Logs);
    const { id: id } = (0, $9X5Bp.useParams)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [isDeleteFormOpen, setIsDeleteFormOpen] = (0, $eCoWV.useState)(false);
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const [isResetPasswordFormOpen, setIsResetPasswordFormOpen] = (0, $eCoWV.useState)(false);
    const [isToggleSuspendFormOpen, setIsToggleSuspendFormOpen] = (0, $eCoWV.useState)(false);
    const [isUpdatingSuspendState, setIsUpdatingSuspendState] = (0, $eCoWV.useState)(false);
    const [resetResult, setResetResult] = (0, $eCoWV.useState)();
    // Get user info with user's SSO identities in a single API call.
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && (0, $h7VLF.buildUrl)(`api/users/${id}`, {
        includeSsoIdentities: "true"
    }));
    const { isSuspended: isSuspendedUser = false } = data ?? {};
    const isLoading = !data && !error;
    const api = (0, $2ANSb.default)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const userSubtitle = data && (0, $3f85170a081a517a$export$336d714c72178bf2)(data);
    (0, $eCoWV.useEffect)(()=>{
        setIsDeleteFormOpen(false);
        setIsResetPasswordFormOpen(false);
        setIsToggleSuspendFormOpen(false);
    }, [
        pathname
    ]);
    const onDelete = async ()=>{
        if (!data || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/users/${data.id}`);
            (0, $horhC.toast).success(t("user_details.deleted", {
                name: data.name
            }));
            navigate("/users");
        } finally{
            setIsDeleting(false);
        }
    };
    const onToggleSuspendState = async ()=>{
        if (!data || isUpdatingSuspendState) return;
        setIsUpdatingSuspendState(true);
        try {
            const updatedUser = await api.patch(`api/users/${data.id}/is-suspended`, {
                json: {
                    isSuspended: !isSuspendedUser
                }
            }).json();
            mutate(updatedUser);
            setIsToggleSuspendFormOpen(false);
            (0, $horhC.toast).success(t(updatedUser.isSuspended ? "user_details.user_suspended" : "user_details.user_reactivated"));
        } finally{
            setIsUpdatingSuspendState(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: "/users",
        backLinkTitle: "user_details.back_to_users",
        isLoading: isLoading,
        error: error,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isPageHasTable && $aa63a2ab5370548e$export$26684859963899d2),
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "user_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                            user: data,
                            size: "xlarge"
                        }),
                        title: (0, $3f85170a081a517a$export$5f7a1baecd59f846)(data),
                        subtitle: userSubtitle,
                        primaryTag: isSuspendedUser && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25fa274a5b9cf7f9$export$2e2bcd8739ae039), {}),
                        identifier: {
                            name: "User ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: "user_details.reset_password.reset_password",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d8aef6862763847e$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsResetPasswordFormOpen(true);
                                }
                            },
                            {
                                title: isSuspendedUser ? "user_details.reactivate_user" : "user_details.suspend_user",
                                icon: isSuspendedUser ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a92ac116c25df55c$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $43568821afd6a689$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsToggleSuspendFormOpen(true);
                                }
                            },
                            {
                                title: "general.delete",
                                type: "danger",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                onClick: ()=>{
                                    setIsDeleteFormOpen(true);
                                }
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
                        shouldCloseOnEsc: true,
                        isOpen: isResetPasswordFormOpen,
                        className: $7iZsu.content,
                        overlayClassName: $7iZsu.overlay,
                        onRequestClose: ()=>{
                            setIsResetPasswordFormOpen(false);
                        },
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0e2c6c44ff37c903$export$2e2bcd8739ae039), {
                            userId: data.id,
                            onClose: (password)=>{
                                setIsResetPasswordFormOpen(false);
                                if (password) setResetResult(password);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                        isOpen: isDeleteFormOpen,
                        isLoading: isDeleting,
                        onCancel: ()=>{
                            setIsDeleteFormOpen(false);
                        },
                        onConfirm: onDelete,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            children: t("user_details.delete_description")
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                        isOpen: isToggleSuspendFormOpen,
                        isLoading: isUpdatingSuspendState,
                        confirmButtonText: isSuspendedUser ? "user_details.reactivate_action" : "user_details.suspend_action",
                        onCancel: ()=>{
                            setIsToggleSuspendFormOpen(false);
                        },
                        onConfirm: onToggleSuspendState,
                        children: t(isSuspendedUser ? "user_details.reactivate_user_reminder" : "user_details.suspend_user_reminder")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $emGEN.UserDetailsTabs).Settings}`,
                                children: t("user_details.tab_settings")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $emGEN.UserDetailsTabs).Roles}`,
                                children: t("user_details.tab_roles")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $emGEN.UserDetailsTabs).Logs}`,
                                children: t("user_details.tab_logs")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/users/${data.id}/${(0, $emGEN.UserDetailsTabs).Organizations}`,
                                children: t("user_details.tab_organizations")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {
                        context: {
                            user: data,
                            isDeleting: isDeleting,
                            onUserUpdated: (user)=>{
                                mutate(user);
                            }
                        }
                    }),
                    resetResult && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fdba7baf27525206$export$2e2bcd8739ae039), {
                        title: "user_details.reset_password.congratulations",
                        user: data,
                        password: resetResult,
                        passwordLabel: t("user_details.reset_password.new_password"),
                        onClose: ()=>{
                            setResetResult(undefined);
                        }
                    })
                ]
            })
        ]
    });
}
var $ff62af747b089187$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($ff62af747b089187$var$UserDetails);



var $9zeGj = parcelRequire("9zeGj");

var $9X5Bp = parcelRequire("9X5Bp");

var $4943c49e4cc6b580$export$fa0831f497706bad;
var $4943c49e4cc6b580$export$bfd64c937657f93a;
var $4943c49e4cc6b580$export$4a6dd88bada4e7d2;
$4943c49e4cc6b580$export$fa0831f497706bad = `_0fF0WG_logs`;
$4943c49e4cc6b580$export$bfd64c937657f93a = `_0fF0WG_rotating`;
$4943c49e4cc6b580$export$4a6dd88bada4e7d2 = `_0fF0WG_shimmer`;


function $0245c19a15aab891$var$UserLogs() {
    const { user: { id: id } } = (0, $9X5Bp.useOutletContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cf7839843df44a16$export$2e2bcd8739ae039), {
        userId: id,
        className: $4943c49e4cc6b580$export$fa0831f497706bad
    });
}
var $0245c19a15aab891$export$2e2bcd8739ae039 = $0245c19a15aab891$var$UserLogs;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $ds4Cq = parcelRequire("ds4Cq");





var $47yah = parcelRequire("47yah");

var $9bgsA = parcelRequire("9bgsA");



parcelRequire("hA6MC");
var $bf05n = parcelRequire("bf05n");

var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");
var $3994d7a3a7e6faaa$export$8e77a375f9a5908e;
var $3994d7a3a7e6faaa$export$3689e6d0356e8299;
var $3994d7a3a7e6faaa$export$bfd64c937657f93a;
var $3994d7a3a7e6faaa$export$4a6dd88bada4e7d2;
$3994d7a3a7e6faaa$export$8e77a375f9a5908e = `ch4mzq_roles`;
$3994d7a3a7e6faaa$export$3689e6d0356e8299 = `ch4mzq_rolesHeader`;
$3994d7a3a7e6faaa$export$bfd64c937657f93a = `ch4mzq_rotating`;
$3994d7a3a7e6faaa$export$4a6dd88bada4e7d2 = `ch4mzq_shimmer`;


function $f9b18ef9fcf31f05$var$UserOrganizations() {
    const [keyword, setKeyword] = (0, $eCoWV.useState)("");
    const { user: { id: id } } = (0, $9X5Bp.useOutletContext)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getPathname: getPathname } = (0, $4W0F0.default)();
    // Since this API has no pagination (to align with ID token claims):
    // - We don't need to use the `page` state.
    // - We can perform frontend filtering.
    const { data: rawData, error: error } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(`api/users/${id}/organizations`, {
        showFeatured: "1"
    }));
    const isLoading = !rawData && !error;
    const data = rawData?.filter(({ name: name })=>name.toLowerCase().includes(keyword.toLowerCase()));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
        isLoading: isLoading,
        rowIndexKey: "id",
        rowGroups: [
            {
                key: "data",
                data: data
            }
        ],
        placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
        columns: [
            {
                title: t("general.name"),
                dataIndex: "name",
                render: ({ name: name, id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                        title: name,
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3dc4aee746c180b4$export$2e2bcd8739ae039), {
                            for: (0, $11c317f8d53fc2a7$export$2e2bcd8739ae039)
                        }),
                        to: getPathname(`/organizations/${id}`)
                    })
            },
            {
                title: t("organizations.organization_id"),
                dataIndex: "id",
                render: ({ id: id })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                        value: id,
                        variant: "text"
                    })
            },
            {
                title: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $3994d7a3a7e6faaa$export$3689e6d0356e8299,
                    children: [
                        t("organizations.organization_role_other"),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bf05n.default), {
                            content: t("user_details.organization_roles_tooltip"),
                            horizontalAlign: "start",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                size: "small",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ds4Cq.default), {})
                            })
                        })
                    ]
                }),
                dataIndex: "roles",
                render: ({ organizationRoles: organizationRoles })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $3994d7a3a7e6faaa$export$8e77a375f9a5908e,
                        children: organizationRoles.map(({ id: id, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                                variant: "cell",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d516a7c4b867a01$export$9b2040b3fe7f4e3f), {
                                    value: id,
                                    title: name
                                })
                            }, id))
                    })
            }
        ],
        filter: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
            defaultValue: keyword,
            isClearable: Boolean(keyword),
            placeholder: t("organization_details.search_user_placeholder"),
            onSearch: setKeyword,
            onClearSearch: ()=>{
                setKeyword("");
            }
        })
    });
}
var $f9b18ef9fcf31f05$export$2e2bcd8739ae039 = $f9b18ef9fcf31f05$var$UserOrganizations;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
var $3kVX5 = parcelRequire("3kVX5");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");







var $6ZMK7 = parcelRequire("6ZMK7");

var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $9bgsA = parcelRequire("9bgsA");


parcelRequire("hA6MC");
var $4v6om = parcelRequire("4v6om");

var $2ANSb = parcelRequire("2ANSb");


var $93h5F = parcelRequire("93h5F");


var $h7VLF = parcelRequire("h7VLF");
var $d371467e67c38a89$export$6d59db4903f20f7d;
var $d371467e67c38a89$export$3dea766d36a8935f;
var $d371467e67c38a89$export$2e4d17fb8dfe5f16;
var $d371467e67c38a89$export$bfd64c937657f93a;
var $d371467e67c38a89$export$4a6dd88bada4e7d2;
$d371467e67c38a89$export$6d59db4903f20f7d = `vRnWHW_description`;
$d371467e67c38a89$export$3dea766d36a8935f = `vRnWHW_filter`;
$d371467e67c38a89$export$2e4d17fb8dfe5f16 = `vRnWHW_rolesTable`;
$d371467e67c38a89$export$bfd64c937657f93a = `vRnWHW_rotating`;
$d371467e67c38a89$export$4a6dd88bada4e7d2 = `vRnWHW_shimmer`;


const $0598482e2ffd0d75$var$pageSize = (0, $6ZMK7.defaultPageSize);
function $0598482e2ffd0d75$var$UserRoles() {
    const theme = (0, $93h5F.default)();
    const { user: user } = (0, $9X5Bp.useOutletContext)();
    const { id: userId } = user;
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)(`api/users/${userId}/roles`, {
        page: String(page),
        page_size: String($0598482e2ffd0d75$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    }));
    const isLoading = !data && !error;
    const [roles, totalCount] = data ?? [];
    const [isAssignRolesModalOpen, setIsAssignRolesModalOpen] = (0, $eCoWV.useState)(false);
    const [roleToBeDeleted, setRoleToBeDeleted] = (0, $eCoWV.useState)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)();
    const handleDelete = async ()=>{
        if (!roleToBeDeleted || isDeleting) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/users/${userId}/roles/${roleToBeDeleted.id}`);
            (0, $horhC.toast).success(t("user_details.roles.deleted", {
                name: roleToBeDeleted.name
            }));
            await mutate();
            setRoleToBeDeleted(undefined);
        } finally{
            setIsDeleting(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                className: $d371467e67c38a89$export$2e4d17fb8dfe5f16,
                isLoading: isLoading,
                rowGroups: [
                    {
                        key: "roles",
                        data: roles
                    }
                ],
                rowIndexKey: "id",
                columns: [
                    {
                        title: t("user_details.roles.name_column"),
                        dataIndex: "name",
                        colSpan: 6,
                        render: ({ id: id, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                                title: name,
                                to: `/roles/${id}`,
                                icon: theme === (0, $bhvxB.Theme).Dark ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $89556d785f25fda7$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1000e8ee7949b499$export$2e2bcd8739ae039), {})
                            })
                    },
                    {
                        title: t("user_details.roles.description_column"),
                        dataIndex: "description",
                        colSpan: 9,
                        render: ({ description: description })=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $d371467e67c38a89$export$6d59db4903f20f7d,
                                children: description
                            })
                    },
                    {
                        title: null,
                        dataIndex: "delete",
                        colSpan: 1,
                        render: (role)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $4v6om.default), {
                                content: t("general.remove"),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        setRoleToBeDeleted(role);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {})
                                })
                            })
                    }
                ],
                filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $d371467e67c38a89$export$3dea766d36a8935f,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                            defaultValue: keyword,
                            isClearable: Boolean(keyword),
                            placeholder: t("user_details.roles.search"),
                            onSearch: (keyword)=>{
                                updateSearchParameters({
                                    keyword: keyword,
                                    page: 1
                                });
                            },
                            onClearSearch: ()=>{
                                updateSearchParameters({
                                    keyword: "",
                                    page: 1
                                });
                            }
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                            title: "user_details.roles.assign_button",
                            type: "primary",
                            size: "large",
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                            onClick: ()=>{
                                setIsAssignRolesModalOpen(true);
                            }
                        })
                    ]
                }),
                pagination: {
                    page: page,
                    pageSize: $0598482e2ffd0d75$var$pageSize,
                    totalCount: totalCount,
                    onChange: (page)=>{
                        updateSearchParameters({
                            page: page
                        });
                    }
                },
                placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
                errorMessage: error?.body?.message ?? error?.message,
                onRetry: async ()=>mutate(undefined, true)
            }),
            roleToBeDeleted && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: true,
                isLoading: isDeleting,
                confirmButtonText: "general.remove",
                onCancel: ()=>{
                    setRoleToBeDeleted(undefined);
                },
                onConfirm: handleDelete,
                children: t("user_details.roles.delete_description")
            }),
            isAssignRolesModalOpen && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3c071dfe7dd5aca2$export$2e2bcd8739ae039), {
                entity: user,
                type: (0, $3kVX5.RoleType).User,
                onClose: (success)=>{
                    if (success) mutate();
                    setIsAssignRolesModalOpen(false);
                }
            })
        ]
    });
}
var $0598482e2ffd0d75$export$2e2bcd8739ae039 = $0598482e2ffd0d75$var$UserRoles;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");


var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");




var $5irU4 = parcelRequire("5irU4");

var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");


var $bSFEw = parcelRequire("bSFEw");

var $5a1Rp = parcelRequire("5a1Rp");


var $4ytKy = parcelRequire("4ytKy");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

const $619ef777d90d5b84$export$bd77d53e275ee7f4 = {
    toLocalForm: (data)=>{
        const { primaryEmail: primaryEmail, primaryPhone: primaryPhone, username: username, name: name, avatar: avatar, customData: customData } = data;
        const parsedPhoneNumber = (0, $5CQIb.conditional)(primaryPhone && (0, $75ee91b14347449d$export$d79b62bd58081ca4)(primaryPhone));
        return {
            primaryEmail: primaryEmail ?? "",
            primaryPhone: parsedPhoneNumber ?? primaryPhone ?? "",
            username: username ?? "",
            name: name ?? "",
            avatar: avatar ?? "",
            customData: JSON.stringify(customData, null, 2)
        };
    }
};



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $2mi28 = parcelRequire("2mi28");



var $kcPww = parcelRequire("kcPww");


var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");
var $8a62ff3c5f2cd598$export$b84494756f225a7d;
var $8a62ff3c5f2cd598$export$bfd64c937657f93a;
var $8a62ff3c5f2cd598$export$4a6dd88bada4e7d2;
$8a62ff3c5f2cd598$export$b84494756f225a7d = `OrZ14a_fieldDescription`;
$8a62ff3c5f2cd598$export$bfd64c937657f93a = `OrZ14a_rotating`;
$8a62ff3c5f2cd598$export$4a6dd88bada4e7d2 = `OrZ14a_shimmer`;


function $f2ad7fdd163cd340$var$UserMfaVerifications({ userId: userId }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console.user_details.mfa"
    });
    const { data: mfaVerifications, error: error, isLoading: isLoading, mutate: mutate } = (0, $2mi28.default)(`api/users/${userId}/mfa-verifications`);
    const api = (0, $2ANSb.default)();
    const { show: showConfirm } = (0, $9ENFn.useConfirmModal)();
    const handleDelete = (0, $eCoWV.useCallback)(async (mfaVerification)=>{
        const [result] = await showConfirm({
            ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    t: t,
                    i18nKey: "deletion_confirmation",
                    components: {
                        name: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cd16c9d8245c2c19$export$2e2bcd8739ae039), {
                            ...mfaVerification
                        })
                    }
                }),
            confirmButtonText: "general.remove"
        });
        if (!result) return;
        await api.delete(`api/users/${userId}/mfa-verifications/${mfaVerification.id}`);
        mutate(mfaVerifications?.filter((item)=>item.id !== mfaVerification.id));
    }, [
        api,
        mfaVerifications,
        mutate,
        showConfirm,
        t,
        userId
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $8a62ff3c5f2cd598$export$b84494756f225a7d,
                children: t(mfaVerifications?.length ? "field_description" : "field_description_empty")
            }),
            (isLoading || Boolean(mfaVerifications?.length) || error) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "mfaVerifications",
                        data: mfaVerifications
                    }
                ],
                rowIndexKey: "id",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("name_column"),
                        dataIndex: "name",
                        colSpan: 13,
                        render: (mfaVerification)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $79a03f9e70dc786c$export$2e2bcd8739ae039), {
                                ...mfaVerification
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        render: (mfaVerification)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                title: "general.remove",
                                type: "text",
                                size: "small",
                                onClick: ()=>{
                                    handleDelete(mfaVerification);
                                }
                            })
                    }
                ],
                onRetry: ()=>{
                    mutate();
                }
            })
        ]
    });
}
var $f2ad7fdd163cd340$export$2e2bcd8739ae039 = $f2ad7fdd163cd340$var$UserMfaVerifications;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");

var $2mi28 = parcelRequire("2mi28");


var $kcPww = parcelRequire("kcPww");

var $47yah = parcelRequire("47yah");




var $2ANSb = parcelRequire("2ANSb");

var $59a29a4268228740$export$ded9b5979746c93f;
var $59a29a4268228740$export$6d59db4903f20f7d;
var $59a29a4268228740$export$1ca1ec8b29a4ce27;
var $59a29a4268228740$export$a8ff84c12d48cfa6;
var $59a29a4268228740$export$bfd64c937657f93a;
var $59a29a4268228740$export$4a6dd88bada4e7d2;
var $59a29a4268228740$export$d9aa71f96dda8d28;
$59a29a4268228740$export$ded9b5979746c93f = `Q4-sxa_connectorName`;
$59a29a4268228740$export$6d59db4903f20f7d = `Q4-sxa_description`;
$59a29a4268228740$export$1ca1ec8b29a4ce27 = `Q4-sxa_icon`;
$59a29a4268228740$export$a8ff84c12d48cfa6 = `Q4-sxa_name`;
$59a29a4268228740$export$bfd64c937657f93a = `Q4-sxa_rotating`;
$59a29a4268228740$export$4a6dd88bada4e7d2 = `Q4-sxa_shimmer`;
$59a29a4268228740$export$d9aa71f96dda8d28 = `Q4-sxa_userId`;


function $821615fbfded0571$var$ConnectorName({ name: name }) {
    return typeof name === "string" ? /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
        children: name
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a190a073a27a2bd7$export$2e2bcd8739ae039), {
        resource: name
    });
}
function $821615fbfded0571$var$UserSocialIdentities({ userId: userId, identities: identities, onDelete: onDelete }) {
    const api = (0, $2ANSb.default)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)("api/connectors");
    const [deletingConnector, setDeletingConnector] = (0, $eCoWV.useState)();
    const [isSubmitting, setIsSubmitting] = (0, $eCoWV.useState)(false);
    const connectorGroups = (0, $eCoWV.useMemo)(()=>{
        if (!data?.length) return;
        return (0, $dc36c1ed9a2dd820$export$48daf4eb8bb4366e)(data);
    }, [
        data
    ]);
    const isLoading = !connectorGroups && !error;
    const handleDelete = async (target)=>{
        if (isSubmitting) return;
        setIsSubmitting(true);
        try {
            await api.delete(`api/users/${userId}/identities/${target}`);
            onDelete?.(target);
        } finally{
            setIsSubmitting(false);
        }
    };
    const displayConnectors = (0, $eCoWV.useMemo)(()=>{
        if (!connectorGroups) return;
        return Object.keys(identities).map((key)=>{
            const { logo: logo, name: name } = connectorGroups.find((group)=>group.target === key) ?? {};
            const socialUserId = identities[key]?.userId;
            return {
                logo: logo,
                name: name ?? t("connectors.unknown"),
                target: key,
                userId: socialUserId
            };
        });
    }, [
        connectorGroups,
        identities,
        t
    ]);
    const hasConnectors = Boolean(displayConnectors && displayConnectors.length > 0);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $59a29a4268228740$export$6d59db4903f20f7d,
                children: t(hasConnectors ? "user_details.connectors.connected" : "user_details.connectors.not_connected")
            }),
            (isLoading || hasConnectors || error) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "identities",
                        data: displayConnectors
                    }
                ],
                rowIndexKey: "target",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("user_details.connectors.connectors"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ logo: logo, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $59a29a4268228740$export$ded9b5979746c93f,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c12cc5efebda5c90$export$2e2bcd8739ae039), {
                                        className: $59a29a4268228740$export$1ca1ec8b29a4ce27,
                                        src: logo,
                                        alt: "logo"
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $59a29a4268228740$export$a8ff84c12d48cfa6,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)($821615fbfded0571$var$ConnectorName, {
                                            name: name
                                        })
                                    })
                                ]
                            })
                    },
                    {
                        title: t("user_details.connectors.user_id"),
                        dataIndex: "userId",
                        colSpan: 8,
                        render: ({ userId: userId = "" })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $59a29a4268228740$export$d9aa71f96dda8d28,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        children: userId || "-"
                                    }),
                                    userId && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                        variant: "icon",
                                        value: userId
                                    })
                                ]
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        render: (connector)=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                title: "user_details.connectors.remove",
                                type: "text",
                                size: "small",
                                onClick: ()=>{
                                    setDeletingConnector(connector);
                                }
                            })
                    }
                ],
                onRetry: async ()=>mutate(undefined, true)
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2700d7c48278cb73$export$2e2bcd8739ae039), {
                isOpen: deletingConnector !== undefined,
                isLoading: isSubmitting,
                onCancel: ()=>{
                    setDeletingConnector(undefined);
                },
                onConfirm: async ()=>{
                    if (deletingConnector) {
                        await handleDelete(deletingConnector.target);
                        setDeletingConnector(undefined);
                    }
                },
                children: deletingConnector && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                    t: t,
                    i18nKey: "user_details.connectors.deletion_confirmation",
                    components: {
                        name: /*#__PURE__*/ (0, $9zeGj.jsx)($821615fbfded0571$var$ConnectorName, {
                            name: deletingConnector.name
                        })
                    }
                })
            })
        ]
    });
}
var $821615fbfded0571$export$2e2bcd8739ae039 = $821615fbfded0571$var$UserSocialIdentities;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $9NTe8 = parcelRequire("9NTe8");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $2mi28 = parcelRequire("2mi28");

var $2CYkO = parcelRequire("2CYkO");

var $47yah = parcelRequire("47yah");



const $d7463c8ab4de4745$var$isIdentityDisplayConnector = (identity)=>{
    // `DisplayConnector` instance should have `providerLogo`, `providerLogoDark` and `name` to be non-empty string and `branding` to be an object.
    const identityGuard = (0, $2CYkO.z).object({
        providerLogo: (0, $2CYkO.z).string().min(1),
        providerLogoDark: (0, $2CYkO.z).string().min(1),
        branding: (0, $9NTe8.ssoBrandingGuard),
        name: (0, $2CYkO.z).string().min(1)
    });
    const result = identityGuard.safeParse(identity);
    return result.success;
};
function $d7463c8ab4de4745$var$UserSsoIdentities({ ssoIdentities: ssoIdentities }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)("api/sso-connectors");
    const isLoading = !data && !error;
    const displaySsoConnectors = (0, $eCoWV.useMemo)(()=>{
        if (!data) return;
        return ssoIdentities.map((identity)=>{
            const { providerLogo: providerLogo, providerLogoDark: providerLogoDark, branding: branding, connectorName: name } = data.find((ssoConnector)=>ssoConnector.id === identity.ssoConnectorId) ?? {};
            const { identityId: userIdentity, issuer: issuer } = identity;
            return {
                providerLogo: providerLogo,
                providerLogoDark: providerLogoDark,
                branding: branding,
                name: name,
                userIdentity: userIdentity,
                issuer: issuer
            };
        }).filter((identity)=>$d7463c8ab4de4745$var$isIdentityDisplayConnector(identity));
    }, [
        data,
        ssoIdentities
    ]);
    const hasLinkedSsoIdentities = Boolean(displaySsoConnectors && displaySsoConnectors.length > 0);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        children: [
            !isLoading && !error && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $59a29a4268228740$export$6d59db4903f20f7d,
                children: t(hasLinkedSsoIdentities ? "user_details.sso_connectors.connected" : "user_details.sso_connectors.not_connected")
            }),
            (isLoading || hasLinkedSsoIdentities || error) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
                hasBorder: true,
                rowGroups: [
                    {
                        key: "ssoIdentity",
                        data: displaySsoConnectors
                    }
                ],
                rowIndexKey: "issuer",
                isLoading: isLoading,
                errorMessage: error?.body?.message ?? error?.message,
                columns: [
                    {
                        title: t("user_details.sso_connectors.connectors"),
                        dataIndex: "name",
                        colSpan: 5,
                        render: ({ providerLogo: providerLogo, providerLogoDark: providerLogoDark, branding: branding, name: name })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $59a29a4268228740$export$ded9b5979746c93f,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a131401853bc7959$export$2e2bcd8739ae039), {
                                        containerClassName: $59a29a4268228740$export$1ca1ec8b29a4ce27,
                                        data: {
                                            providerLogo: providerLogo,
                                            providerLogoDark: providerLogoDark,
                                            branding: branding
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                        className: $59a29a4268228740$export$a8ff84c12d48cfa6,
                                        children: /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                            children: name
                                        })
                                    })
                                ]
                            })
                    },
                    {
                        title: t("user_details.sso_connectors.enterprise_id"),
                        dataIndex: "userIdentity",
                        colSpan: 8,
                        render: ({ userIdentity: userIdentity })=>/*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                                className: $59a29a4268228740$export$d9aa71f96dda8d28,
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)("span", {
                                        children: userIdentity || "-"
                                    }),
                                    userIdentity && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                                        variant: "icon",
                                        value: userIdentity
                                    })
                                ]
                            })
                    },
                    {
                        title: null,
                        dataIndex: "action",
                        colSpan: 3,
                        // Align with the social identities column span, leave the deletion action blank since SSO identities is not deletable in this user details page.
                        render: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)("div", {})
                    }
                ],
                onRetry: async ()=>mutate(undefined, true)
            })
        ]
    });
}
var $d7463c8ab4de4745$export$2e2bcd8739ae039 = $d7463c8ab4de4745$var$UserSsoIdentities;


function $c19b9e91e867edda$var$UserSettings() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const { user: user, isDeleting: isDeleting, onUserUpdated: onUserUpdated } = (0, $9X5Bp.useOutletContext)();
    const userFormData = (0, $619ef777d90d5b84$export$bd77d53e275ee7f4).toLocalForm(user);
    const { handleSubmit: handleSubmit, register: register, control: control, reset: reset, formState: { isSubmitting: isSubmitting, errors: errors, isDirty: isDirty } } = (0, $c3LX9.useForm)({
        defaultValues: userFormData
    });
    const { field: { onChange: onChange, value: value } } = (0, $c3LX9.useController)({
        name: "customData",
        control: control
    });
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        if (isSubmitting) return;
        const { identities: identities, id: userId } = user;
        const { customData: inputCustomData, username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone } = formData;
        if (!username && !primaryEmail && !primaryPhone && Object.keys(identities).length === 0) {
            const [result] = await show({
                ModalContent: t("user_details.warning_no_sign_in_identifier"),
                type: "confirm"
            });
            if (!result) return;
        }
        const parseResult = (0, $5a1Rp.safeParseJsonObject)(inputCustomData);
        if (!parseResult.success) {
            (0, $horhC.toast).error(t("user_details.custom_data_invalid"));
            return;
        }
        const payload = {
            ...formData,
            primaryPhone: (0, $75ee91b14347449d$export$da44e4eaa54bc82e)(primaryPhone),
            customData: parseResult.data
        };
        const updatedUser = await api.patch(`api/users/${userId}`, {
            json: payload
        }).json();
        reset((0, $619ef777d90d5b84$export$bd77d53e275ee7f4).toLocalForm(updatedUser));
        onUserUpdated(updatedUser);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isSubmitting: isSubmitting,
                isDirty: isDirty,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "user_details.authentication",
                        description: "user_details.authentication_description",
                        learnMoreLink: {
                            href: getDocumentationUrl("/docs/references/users"),
                            targetBlank: "noopener"
                        },
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_email",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("primaryEmail", {
                                        pattern: {
                                            value: (0, $dQcUe.emailRegEx),
                                            message: t("errors.email_pattern_error")
                                        }
                                    }),
                                    error: errors.primaryEmail?.message,
                                    placeholder: t("users.placeholder_email")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_phone",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("primaryPhone", {
                                        validate: (value)=>{
                                            if (!value) return true;
                                            const parsed = (0, $aWIy6.trySafe)(()=>(0, $53b53cbd69ef2a8a$export$176bb591929cc9a8)(value));
                                            return(// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                                            parsed?.isValid() || t("errors.phone_pattern_error"));
                                        }
                                    }),
                                    error: errors.primaryPhone?.message,
                                    placeholder: t("users.placeholder_phone")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_username",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("username", {
                                        pattern: {
                                            value: (0, $dQcUe.usernameRegEx),
                                            message: t("errors.username_pattern_error")
                                        }
                                    }),
                                    error: errors.username?.message,
                                    placeholder: t("users.placeholder_username")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_connectors",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $821615fbfded0571$export$2e2bcd8739ae039), {
                                    userId: user.id,
                                    identities: user.identities,
                                    onDelete: ()=>{
                                        onUserUpdated();
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_sso_connectors",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d7463c8ab4de4745$export$2e2bcd8739ae039), {
                                    ssoIdentities: user.ssoIdentities ?? []
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.mfa.field_name",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f2ad7fdd163cd340$export$2e2bcd8739ae039), {
                                    userId: user.id
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                        title: "user_details.user_profile",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_name",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("name"),
                                    placeholder: t("users.placeholder_name")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                title: "user_details.field_avatar",
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    ...register("avatar", {
                                        validate: (value)=>!value || (0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                                    }),
                                    error: errors.avatar?.message,
                                    placeholder: t("user_details.field_avatar_placeholder")
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                                isRequired: true,
                                title: "user_details.field_custom_data",
                                tip: t("user_details.field_custom_data_tip"),
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5irU4.default), {
                                    language: "json",
                                    value: value,
                                    onChange: onChange
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $c19b9e91e867edda$export$2e2bcd8739ae039 = $c19b9e91e867edda$var$UserSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f011f3042dc8285a$var$SvgUsersEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M251 237H5.5l19.712-29.375A19.477 19.477 0 0 1 41.387 199h.68c3.223 0 6.38.91 9.11 2.625 7.532 4.735 17.436 2.909 22.785-4.201l23.418-31.125a22.065 22.065 0 0 1 31.757-3.685l6.632 5.527a25.807 25.807 0 0 0 30.02 2.17 25.808 25.808 0 0 1 13.498-3.811h.897a28.983 28.983 0 0 1 27.465 19.726l5.072 15.045A14.294 14.294 0 0 0 226.267 211c4.825 0 9.324 2.434 11.965 6.472L251 237Z",
                fill: "#383A48"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47 185a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v8H47v-8Zm0 48a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-8H47v8Zm-18-18a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h8v12h-8Zm48 0a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4h-8v12h8ZM31.788 196.271a3.999 3.999 0 0 1 0-5.656l2.828-2.829a4 4 0 0 1 5.657 0l5.657 5.657-8.486 8.485-5.657-5.657Zm33.94 33.941a3.998 3.998 0 0 0 5.657 0l2.829-2.828a4 4 0 0 0 0-5.657l-5.657-5.657-8.486 8.486 5.657 5.656Zm-25.456.001a4 4 0 0 1-5.657 0l-2.829-2.829a3.999 3.999 0 0 1 0-5.656l5.657-5.657 8.486 8.485-5.657 5.657Zm33.94-33.941a4 4 0 0 0 0-5.657l-2.828-2.828a3.998 3.998 0 0 0-5.657 0l-5.657 5.656 8.486 8.486 5.657-5.657Z",
                fill: "#635C8F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53 229c11.046 0 20-8.954 20-20s-8.954-20-20-20-20 8.954-20 20 8.954 20 20 20Zm0-12a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
                fill: "#8777C7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M111 115.5h112V158c0 8.837-7.163 16-16 16h-80c-8.837 0-16-7.163-16-16v-42.5Z",
                fill: "#615A7D"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 124,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 136,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 148,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 183,
                y: 124,
                width: 24,
                height: 44,
                rx: 6,
                fill: "#776D9E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M111.5 115c0-8.56 6.94-15.5 15.5-15.5h80c8.56 0 15.5 6.94 15.5 15.5v43c0 8.56-6.94 15.5-15.5 15.5h-80c-8.56 0-15.5-6.94-15.5-15.5v-43Z",
                stroke: "#7269A8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 123,
                cy: 107,
                r: 2,
                fill: "#C48BB0"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 131,
                cy: 107,
                r: 2,
                fill: "#C79B93"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 139,
                cy: 107,
                r: 2,
                fill: "#776E9E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m182.111 63.025 15.363 19.314a1 1 0 0 0 1.266.253l9.937-5.48a1 1 0 0 0 .007-1.747l-17.998-10.134c-.215-.121-.064-.447.167-.362l23.188 8.561a1 1 0 0 0 .875-.089l6.321-3.933c.785-.488.544-1.688-.367-1.836l-37.816-6.156c-.902-.147-1.512.894-.943 1.61Z",
                fill: "#9A8FBC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M215 82.632v-5.866a1 1 0 0 0-1.514-.857l-4.631 2.778a1 1 0 0 0-.04 1.69l4.63 3.087a1 1 0 0 0 1.555-.832Z",
                fill: "#8073BC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 55,
                y: 136,
                width: 102,
                height: 102,
                rx: 16,
                fill: "url(#paint0_linear_5321_35748)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M69 155c-13.5 2.667-43.1 2.6-53.5-19",
                stroke: "#58577B",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M224.304 197.008c-1.446 5.33-6.493 8.6-6.962 8.473-.468-.128-3.17-5.5-1.724-10.83s6.493-8.6 6.961-8.473c.469.127 3.171 5.5 1.725 10.83Z",
                fill: "#74B382"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M216.155 204.787c.095.476 5.271 3.537 10.687 2.455.393-.078.776-.176 1.149-.291a2 2 0 1 1 3.285-1.534c2.852-1.81 4.557-4.216 4.492-4.546-.095-.475-5.272-3.536-10.688-2.455-5.416 1.082-9.02 5.895-8.925 6.371Z",
                fill: "#89CBAB",
                style: {
                    mixBlendMode: "lighten"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M220.5 84.5c4.667 2.333 13.7 9.4 12.5 19-1.5 12-14.482 2.482-8.5-3.5 5-5 18.524 7.157 7.124 23.149",
                stroke: "#58577B",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 86.5,
                y: 148.5,
                width: 39,
                height: 39,
                rx: 11.5,
                stroke: "#DFBEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 106,
                cy: 161,
                r: 6,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M115.894 179.003c.12 1.098-.789 1.997-1.894 1.997H98c-1.105 0-2.014-.899-1.894-1.997C96.812 172.536 100.973 169 106 169s9.188 3.536 9.894 10.003Z",
                fill: "#735EAD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 76,
                y: 196,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 76,
                y: 211,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#EFE9FF",
                stroke: "#69539E"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M84 201a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H85a1 1 0 0 1-1-1Zm28 0a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Zm11-1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 86,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 94,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 102,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 110,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 114,
                y: 213,
                width: 1,
                height: 6,
                rx: 0.5,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m91 215 66-37v60H91v-23Z",
                fill: "url(#paint1_linear_5321_35748)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 141,
                y: 178,
                width: 60,
                height: 60,
                rx: 12,
                fill: "url(#paint2_linear_5321_35748)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M171 188h3a5 5 0 0 1 0 10h-3v-10Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153 178c-6.627 0-12 5.373-12 12v18h10v-3a5 5 0 0 1 10 0v3h10v-30h-18Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M171 208h10v3a5 5 0 0 0 10 0v-3h10v18c0 6.627-5.373 12-12 12h-18v-10h-3a5 5 0 0 1 0-10h3v-10Z",
                fill: "#A989DF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M228 238h8m-19.5 0h-54.09a.448.448 0 0 1-.354-.721l13.654-17.722c5.057-6.563 14.575-7.565 20.888-2.199l1.456 1.238a11.994 11.994 0 0 0 14.494.791v0a11.992 11.992 0 0 1 14.946 1.196l17.54 16.508a.526.526 0 0 1-.36.909H240.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M242.104 168.38a6 6 0 1 0 6.147-10.308 6 6 0 0 0-6.147 10.308Zm1.537-2.577a3 3 0 1 0 3.073-5.152 3 3 0 0 0-3.073 5.152Z",
                fill: "#6E6083"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M45.957 119.104c0-.057.047-.104.104-.104h1.878c.057 0 .104.047.104.104v3.305l2.862-1.653a.105.105 0 0 1 .142.039l.939 1.626a.104.104 0 0 1-.038.142l-2.862 1.652 2.862 1.653c.05.028.067.092.038.142l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.105.105 0 0 1-.104.105H46.06a.105.105 0 0 1-.104-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.142l2.862-1.653-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.105.105 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#78767F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M68.363 33.144c1.43-.57 2.941.623 2.719 2.146l-.333 2.285c-.222 1.524-2.01 2.236-3.219 1.281l-1.812-1.43c-1.209-.955-.93-2.86.5-3.428l2.145-.854Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m105.969 38.704 2.782-.511a2.828 2.828 0 0 0 2.27-3.293v0a2.829 2.829 0 0 1 2.271-3.294v0a2.829 2.829 0 0 0 2.27-3.293l-.512-2.782",
                stroke: "#4A474F",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m15.803 66.799-.4-2.8a2.828 2.828 0 0 0-3.201-2.4v0a2.828 2.828 0 0 1-3.2-2.399v0a2.828 2.828 0 0 0-3.2-2.4l-2.8.4",
                stroke: "#52514B",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M74 48.5V69c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.502 4-2.002 10",
                stroke: "#636063",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M73.196 49.5a1 1 0 0 1 1.732 0l3.634 6.294C79.257 56.997 78.39 58.5 77 58.5l-1.437-.36a1.568 1.568 0 0 0-1.082.12 1.568 1.568 0 0 1-1.008.135l-1.14-.229a5.004 5.004 0 0 0-1.682-.045c-1.065.152-1.863-.986-1.325-1.918l3.87-6.703Z",
                fill: "#B586B7"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M94 26.77c0 11.47-8.954 26.153-20 26.153S54 38.24 54 26.77C54 15.3 62.954 6 74 6s20 9.299 20 20.77Z",
                fill: "#CFA4D1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M80.58 12.806c.491.457 1.041 1.032 1.615 1.71m5.219 18.767c1.506-5.653-.256-11.044-2.591-15.038a27.032 27.032 0 0 0-1.216-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.498 108.5c3.504-5.5 4.502-7 2.002-10-1.32-1.584-3-3-1.5-8s-1.5-4 0-8.5c1-2.5 0-7.1 0-7.5",
                stroke: "#626067",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.429 70.99a.66.66 0 0 1 1.142 0l2.398 4.153a1.19 1.19 0 0 1-1.03 1.785l-.949-.237a1.034 1.034 0 0 0-.714.078c-.205.103-.44.135-.665.09l-.752-.15a3.303 3.303 0 0 0-1.11-.03c-.702.1-1.23-.651-.874-1.266l2.554-4.423Z",
                fill: "#68A973"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52 55.538c0 8.03-6.268 18.308-14 18.308S24 63.568 24 55.538C24 47.51 30.268 41 38 41s14 6.51 14 14.538Z",
                fill: "#86BF8F"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M43.312 47c.307.306.653.717 1 1.217M45.813 59c1.086-3.04.747-5.823-.055-8-.136-.37-.286-.722-.444-1.054",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_5321_35748",
                        x1: 106,
                        y1: 136,
                        x2: 65,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_5321_35748",
                        x1: 159.5,
                        y1: 192,
                        x2: 98.5,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#9C79E0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_5321_35748",
                        x1: 192,
                        y1: 181,
                        x2: 144.5,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFBDE5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAA5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $f011f3042dc8285a$export$2e2bcd8739ae039 = $f011f3042dc8285a$var$SvgUsersEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f08a4623daa8866d$var$SvgUsersEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M251 237H5.5l19.712-29.375A19.477 19.477 0 0 1 41.387 199h.68c3.223 0 6.38.91 9.11 2.625 7.532 4.735 17.436 2.909 22.785-4.201l23.418-31.125a22.065 22.065 0 0 1 31.757-3.685l6.632 5.527a25.807 25.807 0 0 0 30.02 2.17 25.808 25.808 0 0 1 13.498-3.811h.897a28.983 28.983 0 0 1 27.465 19.726l5.072 15.045A14.294 14.294 0 0 0 226.267 211c4.825 0 9.324 2.434 11.965 6.472L251 237Z",
                fill: "#D2CCDD"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M47 185a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v8H47v-8Zm0 48a4 4 0 0 0 4 4h4a4 4 0 0 0 4-4v-8H47v8Zm-18-18a4 4 0 0 1-4-4v-4a4 4 0 0 1 4-4h8v12h-8Zm48 0a4 4 0 0 0 4-4v-4a4 4 0 0 0-4-4h-8v12h8ZM31.788 196.271a3.999 3.999 0 0 1 0-5.656l2.828-2.829a4 4 0 0 1 5.657 0l5.657 5.657-8.486 8.485-5.657-5.657Zm33.94 33.941a3.998 3.998 0 0 0 5.657 0l2.829-2.828a4 4 0 0 0 0-5.657l-5.657-5.657-8.486 8.486 5.657 5.656Zm-25.456.001a4 4 0 0 1-5.657 0l-2.829-2.829a3.999 3.999 0 0 1 0-5.656l5.657-5.657 8.486 8.485-5.657 5.657Zm33.94-33.941a4 4 0 0 0 0-5.657l-2.828-2.828a3.998 3.998 0 0 0-5.657 0l-5.657 5.656 8.486 8.486 5.657-5.657Z",
                fill: "#ADAAB4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M53 229c11.046 0 20-8.955 20-20 0-11.046-8.954-20-20-20s-20 8.954-20 20c0 11.045 8.954 20 20 20Zm0-12a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z",
                fill: "#5F5D67"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M111 115.5h112V158c0 8.837-7.163 16-16 16h-80c-8.837 0-16-7.163-16-16v-42.5Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 124,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 136,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 123,
                y: 148,
                width: 44,
                height: 8,
                rx: 2,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 183,
                y: 124,
                width: 24,
                height: 44,
                rx: 6,
                fill: "#E1CEE8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M215.75 115a.5.5 0 0 0 0 1h6.75v42c0 8.56-6.94 15.5-15.5 15.5h-80c-8.56 0-15.5-6.94-15.5-15.5v-42h94a.5.5 0 0 0 0-1h-94c0-8.56 6.94-15.5 15.5-15.5h80c8.56 0 15.5 6.94 15.5 15.5h-6.75Z",
                stroke: "#C9C5D0",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 123,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 131,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 139,
                cy: 107,
                r: 2,
                fill: "#D9D9D9"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m182.111 63.025 15.363 19.314a1 1 0 0 0 1.266.253l9.937-5.48a1 1 0 0 0 .007-1.747l-17.998-10.134c-.215-.121-.064-.447.167-.362l23.188 8.561a1 1 0 0 0 .875-.089l6.321-3.933c.785-.488.544-1.688-.367-1.836l-37.816-6.156c-.902-.147-1.512.894-.943 1.61Z",
                fill: "#AD93FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M215 84.199v-7.433a1 1 0 0 0-1.514-.857l-4.848 2.908a1 1 0 0 0-.168 1.589l4.848 4.524c.639.596 1.682.143 1.682-.731Z",
                fill: "#795FF2"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 55,
                y: 136,
                width: 102,
                height: 102,
                rx: 16,
                fill: "url(#paint0_linear_5320_34929)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M69 155c-13.5 2.667-43.1 2.6-53.5-19",
                stroke: "#A782E8",
                strokeDasharray: "4 4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M224.304 197.008c-1.446 5.33-6.493 8.6-6.962 8.473-.468-.128-3.17-5.5-1.724-10.83s6.493-8.6 6.961-8.473c.469.127 3.171 5.5 1.725 10.83Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M216.155 204.787c.095.476 5.271 3.536 10.687 2.455.393-.079.776-.177 1.149-.291a2.002 2.002 0 0 1 2.028-3.391 2.002 2.002 0 0 1 1.257 1.856c2.852-1.809 4.557-4.216 4.492-4.545-.095-.476-5.272-3.536-10.688-2.455s-9.02 5.895-8.925 6.371Z",
                fill: "#9FE79F",
                style: {
                    mixBlendMode: "multiply"
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M220.5 84.5c4.667 2.333 13.7 9.4 12.5 19-1.5 12-14.482 2.482-8.5-3.5 5-5 18.524 7.157 7.124 23.149",
                stroke: "#A782E8",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 86.5,
                y: 148.5,
                width: 39,
                height: 39,
                rx: 11.5,
                stroke: "#DFBEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 106,
                cy: 161,
                r: 6,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M115.894 179.003c.12 1.098-.789 1.997-1.894 1.997H98c-1.105 0-2.014-.899-1.894-1.997C96.812 172.536 100.973 169 106 169s9.188 3.536 9.894 10.003Z",
                fill: "#6F45E6"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 76,
                y: 196,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#D8C7FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 76,
                y: 211,
                width: 60,
                height: 10,
                rx: 4,
                fill: "#EFE9FF",
                stroke: "#815AE3"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M84 201a1 1 0 0 1 1-1h22a1 1 0 0 1 0 2H85a1 1 0 0 1-1-1Zm28 0a1 1 0 0 1 1-1h6a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1Zm11-1a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2h-2Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 86,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 94,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 102,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 110,
                cy: 216,
                r: 2,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 114,
                y: 213,
                width: 1,
                height: 6,
                rx: 0.5,
                fill: "#FAABFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m91 215 66-37v60H91v-23Z",
                fill: "url(#paint1_linear_5320_34929)",
                style: {
                    mixBlendMode: "multiply"
                },
                opacity: 0.6
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 141,
                y: 178,
                width: 60,
                height: 60,
                rx: 12,
                fill: "url(#paint2_linear_5320_34929)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M171 188h3a5 5 0 0 1 0 10h-3v-10Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M153 178c-6.627 0-12 5.373-12 12v18h10v-3a5 5 0 0 1 10 0v3h10v-30h-18Z",
                fill: "#FFDAD4"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M171 208h10v3a5 5 0 0 0 10 0v-3h10v18c0 6.627-5.373 12-12 12h-18v-10h-3a5 5 0 0 1 0-10h3v-10Z",
                fill: "#B990FE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M228 238h8m-19.5 0h-54.09a.448.448 0 0 1-.354-.721l13.654-17.722c5.057-6.563 14.575-7.565 20.888-2.199l1.456 1.238a11.994 11.994 0 0 0 14.494.791v0a11.992 11.992 0 0 1 14.946 1.196l17.54 16.508a.526.526 0 0 1-.36.909H240.5",
                stroke: "#947DFF",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M242.104 168.38a6 6 0 1 0 6.147-10.308 6 6 0 0 0-6.147 10.308Zm1.537-2.577a3 3 0 1 0 3.073-5.152 3 3 0 0 0-3.073 5.152Z",
                fill: "#F5EEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M45.957 119.104c0-.057.047-.104.105-.104h1.877c.058 0 .104.047.104.104v3.305l2.862-1.653a.105.105 0 0 1 .142.039l.94 1.626a.104.104 0 0 1-.039.142l-2.862 1.652 2.862 1.653c.05.028.067.092.038.142l-.939 1.626a.104.104 0 0 1-.142.038l-2.862-1.652v3.304a.105.105 0 0 1-.104.105h-1.877a.105.105 0 0 1-.105-.105v-3.304l-2.862 1.652a.104.104 0 0 1-.142-.038l-.939-1.626a.104.104 0 0 1 .038-.142l2.862-1.653-2.862-1.652a.104.104 0 0 1-.038-.142l.939-1.626a.105.105 0 0 1 .142-.039l2.862 1.653v-3.305Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M68.363 33.144c1.43-.57 2.941.623 2.719 2.146l-.333 2.285c-.222 1.524-2.01 2.236-3.219 1.281l-1.812-1.43c-1.209-.955-.93-2.86.5-3.428l2.145-.854Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m105.969 38.704 2.782-.511a2.828 2.828 0 0 0 2.27-3.293v0a2.829 2.829 0 0 1 2.27-3.294v0a2.829 2.829 0 0 0 2.271-3.293l-.512-2.782",
                stroke: "#F5EEFF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m15.803 66.799-.4-2.8a2.828 2.828 0 0 0-3.201-2.4v0a2.828 2.828 0 0 1-3.2-2.4v0a2.828 2.828 0 0 0-3.2-2.399l-2.8.4",
                stroke: "#FFF06A",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M74 48.5V69c0 2.5 1.5 3.5 0 8.5s2 6 1.5 8-3.502 4-2.002 10",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M73.196 49.5a1 1 0 0 1 1.732 0l3.634 6.294C79.257 56.997 78.39 58.5 77 58.5l-1.437-.36a1.568 1.568 0 0 0-1.082.12 1.568 1.568 0 0 1-1.008.135l-1.14-.229a5.004 5.004 0 0 0-1.682-.045c-1.065.152-1.863-.986-1.325-1.918l3.87-6.703Z",
                fill: "#DEA0E1"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M94 26.77c0 11.47-8.954 26.153-20 26.153S54 38.24 54 26.77C54 15.3 62.954 6 74 6s20 9.299 20 20.77Z",
                fill: "#F4B4FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M80.58 12.806c.491.456 1.041 1.032 1.615 1.71m5.219 18.767c1.506-5.654-.256-11.044-2.591-15.038a27.087 27.087 0 0 0-1.216-1.893",
                stroke: "#FEF2FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.498 108.5c3.504-5.5 4.502-7 2.002-10-1.32-1.584-3-3-1.5-8s-1.5-4 0-8.5c1-2.5 0-7.1 0-7.5",
                stroke: "#D1CADE",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M37.429 70.99a.66.66 0 0 1 1.142 0l2.398 4.153a1.19 1.19 0 0 1-1.03 1.785l-.949-.237a1.034 1.034 0 0 0-.714.078c-.205.103-.44.135-.665.09l-.752-.15a3.303 3.303 0 0 0-1.11-.03c-.702.1-1.23-.651-.874-1.266l2.554-4.423Z",
                fill: "#71C171"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52 55.538c0 8.03-6.268 18.308-14 18.308S24 63.568 24 55.538C24 47.51 30.268 41 38 41s14 6.51 14 14.538Z",
                fill: "#83DA85"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M43.312 47c.307.306.653.717 1 1.217M45.813 59c1.086-3.04.747-5.823-.055-8-.136-.37-.286-.722-.444-1.054",
                stroke: "#F7F4FF",
                strokeLinecap: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_5320_34929",
                        x1: 106,
                        y1: 136,
                        x2: 65,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_5320_34929",
                        x1: 159.5,
                        y1: 192,
                        x2: 98.5,
                        y2: 232,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#9C79E0"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BE9BFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_5320_34929",
                        x1: 192,
                        y1: 181,
                        x2: 144.5,
                        y2: 238,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FFBDE5"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FAA5FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $f08a4623daa8866d$export$2e2bcd8739ae039 = $f08a4623daa8866d$var$SvgUsersEmpty;








var $6ZMK7 = parcelRequire("6ZMK7");

var $emGEN = parcelRequire("emGEN");

var $kcPww = parcelRequire("kcPww");




var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("8Hfh4");
var $dQcUe = parcelRequire("dQcUe");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $bFFWx = parcelRequire("bFFWx");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");


var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $bNHoO = parcelRequire("bNHoO");

var $hdJkM = parcelRequire("hdJkM");

var $2ANSb = parcelRequire("2ANSb");

var $4W0F0 = parcelRequire("4W0F0");

var $7iZsu = parcelRequire("7iZsu");

var $bSFEw = parcelRequire("bSFEw");


var $a28d9ae4109abafa$export$a3bc9b8ed74fc;
var $a28d9ae4109abafa$export$bfd64c937657f93a;
var $a28d9ae4109abafa$export$4a6dd88bada4e7d2;
$a28d9ae4109abafa$export$a3bc9b8ed74fc = `ZN2xuG_error`;
$a28d9ae4109abafa$export$bfd64c937657f93a = `ZN2xuG_rotating`;
$a28d9ae4109abafa$export$4a6dd88bada4e7d2 = `ZN2xuG_shimmer`;


function $3ebfb6666d0e2865$var$CreateForm({ onClose: onClose, onCreate: onCreate }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { navigate: navigate } = (0, $4W0F0.default)();
    const [createdUserInfo, setCreatedUserInfo] = (0, $eCoWV.useState)();
    const [missingIdentifierError, setMissingIdentifierError] = (0, $eCoWV.useState)();
    const { handleSubmit: handleSubmit, register: register, formState: { isSubmitting: isSubmitting, errors: errors, submitCount: submitCount }, getValues: getValues } = (0, $c3LX9.useForm)();
    const api = (0, $2ANSb.default)();
    const hasIdentifier = ()=>{
        const { username: username, primaryEmail: primaryEmail, primaryPhone: primaryPhone } = getValues();
        return Boolean(username) || Boolean(primaryEmail) || Boolean(primaryPhone);
    };
    const revalidateForm = ()=>{
        if (submitCount) {
            if (hasIdentifier()) setMissingIdentifierError(undefined);
            else setMissingIdentifierError(t("users.error_missing_identifier"));
        }
    };
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        if (isSubmitting) return;
        setMissingIdentifierError(undefined);
        if (!hasIdentifier()) {
            setMissingIdentifierError(t("users.error_missing_identifier"));
            return;
        }
        const password = (0, $447e004ce469432b$export$832e1ed778c99ea4)();
        const { primaryPhone: primaryPhone } = data;
        const userData = {
            ...data,
            password: password,
            ...(0, $5CQIb.conditional)(primaryPhone && {
                primaryPhone: (0, $75ee91b14347449d$export$da44e4eaa54bc82e)(primaryPhone)
            })
        };
        // Filter out empty values
        const payload = Object.fromEntries(Object.entries(userData).filter(([, value])=>Boolean(value)));
        try {
            const createdUser = await api.post("api/users", {
                json: payload
            }).json();
            setCreatedUserInfo({
                user: createdUser,
                password: password
            });
            onCreate();
        } catch  {
        // Do nothing since we only show error toasts, which is handled in the useApi hook
        }
    }));
    return createdUserInfo ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fdba7baf27525206$export$2e2bcd8739ae039), {
        title: "user_details.created_title",
        user: createdUserInfo.user,
        password: createdUserInfo.password,
        confirmButtonTitle: "users.check_user_detail",
        onClose: ()=>{
            navigate({
                pathname: "/users",
                search: search
            });
        },
        onConfirm: ()=>{
            navigate(`/users/${createdUserInfo.user.id}`, {
                replace: true
            });
        }
    }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnEsc: true,
        isOpen: true,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $bNHoO.default), {
            title: "users.create",
            subtitle: "users.create_subtitle",
            footer: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                disabled: isSubmitting,
                htmlType: "submit",
                title: "users.create",
                size: "large",
                type: "primary",
                onClick: onSubmit
            }),
            onClose: onClose,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsxs)("form", {
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "user_details.field_email",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("primaryEmail", {
                                    pattern: {
                                        value: (0, $dQcUe.emailRegEx),
                                        message: t("errors.email_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_email"),
                                error: errors.primaryEmail?.message ?? Boolean(missingIdentifierError)
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "user_details.field_phone",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("primaryPhone", {
                                    pattern: {
                                        value: (0, $dQcUe.phoneInputRegEx),
                                        message: t("errors.phone_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_phone"),
                                error: errors.primaryPhone?.message ?? Boolean(missingIdentifierError)
                            })
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                            title: "user_details.field_username",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                ...register("username", {
                                    pattern: {
                                        value: (0, $dQcUe.usernameRegEx),
                                        message: t("errors.username_pattern_error")
                                    },
                                    onChange: ()=>{
                                        revalidateForm();
                                    }
                                }),
                                placeholder: t("users.placeholder_username"),
                                error: errors.username?.message ?? Boolean(missingIdentifierError)
                            })
                        })
                    ]
                }),
                missingIdentifierError && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $a28d9ae4109abafa$export$a3bc9b8ed74fc,
                    children: missingIdentifierError
                })
            ]
        })
    });
}
var $3ebfb6666d0e2865$export$2e2bcd8739ae039 = $3ebfb6666d0e2865$var$CreateForm;



const $c81b5ba82b4d0ed5$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $c81b5ba82b4d0ed5$var$usersPathname = "/users";
const $c81b5ba82b4d0ed5$var$createUserPathname = `${$c81b5ba82b4d0ed5$var$usersPathname}/create`;
const $c81b5ba82b4d0ed5$var$buildDetailsPathname = (id)=>`${$c81b5ba82b4d0ed5$var$usersPathname}/${id}/${(0, $emGEN.UserDetailsTabs).Settings}`;
function $c81b5ba82b4d0ed5$var$Users() {
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const [{ page: page, keyword: keyword }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        keyword: ""
    });
    const url = (0, $h7VLF.buildUrl)("api/users", {
        page: String(page),
        page_size: String($c81b5ba82b4d0ed5$var$pageSize),
        ...(0, $5CQIb.conditional)(keyword && {
            search: (0, $h7VLF.formatSearchKeyword)(keyword)
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const [users, totalCount] = data ?? [];
    const isCreating = match($c81b5ba82b4d0ed5$var$createUserPathname);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
        title: {
            title: "users.title",
            subtitle: "users.subtitle"
        },
        pageMeta: {
            titleKey: "users.page_title"
        },
        createButton: {
            title: "users.create",
            onClick: ()=>{
                navigate({
                    pathname: $c81b5ba82b4d0ed5$var$createUserPathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "users",
                    data: users
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: t("users.user_name"),
                    dataIndex: "name",
                    colSpan: 6,
                    render: (user)=>{
                        const { id: id, isSuspended: isSuspended } = user;
                        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                            title: (0, $3f85170a081a517a$export$5f7a1baecd59f846)(user),
                            subtitle: (0, $3f85170a081a517a$export$336d714c72178bf2)(user),
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eeeb5d5d34fbdff9$export$2e2bcd8739ae039), {
                                size: "large",
                                user: user
                            }),
                            to: $c81b5ba82b4d0ed5$var$buildDetailsPathname(id),
                            suffix: (0, $5CQIb.conditional)(isSuspended && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $25fa274a5b9cf7f9$export$2e2bcd8739ae039), {}))
                        });
                    }
                },
                {
                    title: t("users.application_name"),
                    dataIndex: "app",
                    colSpan: 5,
                    render: ({ applicationId: applicationId })=>applicationId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1e5c80becd11c9ff$export$2e2bcd8739ae039), {
                            applicationId: applicationId
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            children: "-"
                        })
                },
                {
                    title: t("users.latest_sign_in"),
                    dataIndex: "lastSignInAt",
                    colSpan: 5,
                    render: ({ lastSignInAt: lastSignInAt })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $c5e91545b40d865d$export$2e2bcd8739ae039), {
                            children: lastSignInAt
                        })
                }
            ],
            filter: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $4e917d0f808c0c52$export$2e2bcd8739ae039), {
                placeholder: t("users.search"),
                defaultValue: keyword,
                isClearable: Boolean(keyword),
                onSearch: (keyword)=>{
                    updateSearchParameters({
                        keyword: keyword,
                        page: 1
                    });
                },
                onClearSearch: ()=>{
                    updateSearchParameters({
                        keyword: "",
                        page: 1
                    });
                }
            }),
            placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f08a4623daa8866d$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f011f3042dc8285a$export$2e2bcd8739ae039), {}),
                title: "users.placeholder_title",
                description: "users.placeholder_description",
                action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "users.create",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $c81b5ba82b4d0ed5$var$createUserPathname,
                            search: search
                        });
                    }
                })
            }),
            rowClickHandler: ({ id: id })=>{
                navigate($c81b5ba82b4d0ed5$var$buildDetailsPathname(id));
            },
            pagination: {
                page: page,
                pageSize: $c81b5ba82b4d0ed5$var$pageSize,
                totalCount: totalCount,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            },
            onRetry: async ()=>mutate(undefined, true)
        },
        widgets: isCreating && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3ebfb6666d0e2865$export$2e2bcd8739ae039), {
            onClose: ()=>{
                navigate({
                    pathname: $c81b5ba82b4d0ed5$var$usersPathname,
                    search: search
                });
            },
            onCreate: ()=>{
                mutate();
            }
        })
    });
}
var $c81b5ba82b4d0ed5$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($c81b5ba82b4d0ed5$var$Users);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $48f4fb72ccc36909$var$SvgWebhookDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 40,
        height: 41,
        viewBox: "0 0 40 41",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                y: 0.5,
                width: 40,
                height: 40,
                rx: 8,
                fill: "#3A3B59"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.353 20.698a1.015 1.015 0 0 1-.48 1.353 4.983 4.983 0 1 0 7.124 4.501c0-.56.455-1.015 1.015-1.015h7.982a1.015 1.015 0 1 1 0 2.03h-7.04a7.015 7.015 0 0 1-13.953-1.015 7.014 7.014 0 0 1 3.998-6.334 1.015 1.015 0 0 1 1.354.48Z",
                fill: "url(#paint0_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M30 26.434a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
                fill: "url(#paint1_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.488 10.133a4.983 4.983 0 0 0-4.983 8.63 1.016 1.016 0 0 1 .372 1.388l-3.99 6.912a1.015 1.015 0 0 1-1.76-1.015l3.52-6.097a7.015 7.015 0 0 1 7.857-11.577l-.508.88.508-.88a7.014 7.014 0 0 1 3.486 6.63 1.015 1.015 0 0 1-2.025-.16 4.984 4.984 0 0 0-2.477-4.71Z",
                fill: "url(#paint2_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M22.488 10.133a4.983 4.983 0 0 0-4.983 8.63 1.016 1.016 0 0 1 .372 1.388l-3.99 6.912a1.015 1.015 0 0 1-1.76-1.015l3.52-6.097a7.015 7.015 0 0 1 7.857-11.577l-.508.88.508-.88a7.014 7.014 0 0 1 3.486 6.63 1.015 1.015 0 0 1-2.025-.16 4.984 4.984 0 0 0-2.477-4.71Z",
                fill: "url(#paint3_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.501 29.031a3 3 0 1 1 3-5.195 3 3 0 0 1-3 5.195Z",
                fill: "url(#paint4_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M11.501 29.031a3 3 0 1 1 3-5.195 3 3 0 0 1-3 5.195Z",
                fill: "url(#paint5_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M19.487 13.565a1.015 1.015 0 0 1 1.387.372l3.52 6.096a7.015 7.015 0 0 1 6.097 12.592 7.014 7.014 0 0 1-7.485-.296 1.015 1.015 0 0 1 1.15-1.673 4.983 4.983 0 1 0 .337-8.42 1.015 1.015 0 0 1-1.387-.372l-3.991-6.912a1.015 1.015 0 0 1 .372-1.387Z",
                fill: "url(#paint6_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M18.501 11.836a3 3 0 1 1 3 5.195 3 3 0 0 1-3-5.195Z",
                fill: "url(#paint7_linear_8003_152192)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8003_152192",
                        x1: 1.646,
                        y1: 25.862,
                        x2: 24.045,
                        y2: 14.569,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8003_152192",
                        x1: 23.508,
                        y1: 26.871,
                        x2: 29.921,
                        y2: 24.503,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_8003_152192",
                        x1: 23.621,
                        y1: 18.838,
                        x2: 14.245,
                        y2: 11.978,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_8003_152192",
                        x1: 14.001,
                        y1: 25.934,
                        x2: 27.612,
                        y2: 12.644,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_8003_152192",
                        x1: 11.625,
                        y1: 28.969,
                        x2: 15.438,
                        y2: 24.835,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_8003_152192",
                        x1: 11.001,
                        y1: 28.934,
                        x2: 15.5,
                        y2: 25.11,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_8003_152192",
                        x1: 31.329,
                        y1: 32.349,
                        x2: 20.37,
                        y2: 17.327,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_8003_152192",
                        x1: 21.663,
                        y1: 16.921,
                        x2: 17.179,
                        y2: 12.944,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#614DDD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#D47AFE"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $48f4fb72ccc36909$export$2e2bcd8739ae039 = $48f4fb72ccc36909$var$SvgWebhookDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $574254d481c50565$var$SvgWebhook = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 32,
        height: 32,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                width: 32,
                height: 32,
                rx: 6,
                fill: "#FFEAFE"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.082 16.212a.812.812 0 0 1-.384 1.082 3.987 3.987 0 1 0 5.7 3.601c0-.448.363-.812.811-.812h6.386a.812.812 0 1 1 0 1.625h-5.632A5.612 5.612 0 0 1 4.8 20.895a5.611 5.611 0 0 1 3.199-5.067.812.812 0 0 1 1.083.384Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M9.082 16.212a.812.812 0 0 1-.384 1.082 3.987 3.987 0 1 0 5.7 3.601c0-.448.363-.812.811-.812h6.386a.812.812 0 1 1 0 1.625h-5.632A5.612 5.612 0 0 1 4.8 20.895a5.611 5.611 0 0 1 3.199-5.067.812.812 0 0 1 1.083.384Z",
                fill: "url(#paint0_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24 20.8a2.4 2.4 0 1 1-4.8 0 2.4 2.4 0 0 1 4.8 0Z",
                fill: "url(#paint1_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.99 7.76a3.986 3.986 0 0 0-3.986 6.904.812.812 0 0 1 .297 1.11l-3.193 5.53a.812.812 0 1 1-1.407-.813l2.816-4.877a5.612 5.612 0 0 1 6.285-9.261l-.406.703.406-.703a5.611 5.611 0 0 1 2.79 5.304.812.812 0 0 1-1.62-.128 3.987 3.987 0 0 0-1.982-3.77Z",
                fill: "url(#paint2_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17.99 7.76a3.986 3.986 0 0 0-3.986 6.904.812.812 0 0 1 .297 1.11l-3.193 5.53a.812.812 0 1 1-1.407-.813l2.816-4.877a5.612 5.612 0 0 1 6.285-9.261l-.406.703.406-.703a5.611 5.611 0 0 1 2.79 5.304.812.812 0 0 1-1.62-.128 3.987 3.987 0 0 0-1.982-3.77Z",
                fill: "url(#paint3_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.2 22.878a2.4 2.4 0 1 1 2.4-4.156 2.4 2.4 0 0 1-2.4 4.156Z",
                fill: "url(#paint4_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M9.2 22.878a2.4 2.4 0 1 1 2.4-4.156 2.4 2.4 0 0 1-2.4 4.156Z",
                fill: "url(#paint5_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.589 10.505a.812.812 0 0 1 1.11.298l2.815 4.877a5.612 5.612 0 1 1-1.11 9.837.812.812 0 1 1 .921-1.339 3.987 3.987 0 1 0 .269-6.736.812.812 0 0 1-1.11-.297l-3.192-5.53a.812.812 0 0 1 .297-1.11Z",
                fill: "#000"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M15.589 10.505a.812.812 0 0 1 1.11.298l2.815 4.877a5.612 5.612 0 1 1-1.11 9.837.812.812 0 1 1 .921-1.339 3.987 3.987 0 1 0 .269-6.736.812.812 0 0 1-1.11-.297l-3.192-5.53a.812.812 0 0 1 .297-1.11Z",
                fill: "url(#paint6_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M14.8 9.122a2.4 2.4 0 1 1 2.4 4.156 2.4 2.4 0 0 1-2.4-4.156Z",
                fill: "url(#paint7_linear_540_1415)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_540_1415",
                        x1: 4.333,
                        y1: 21.595,
                        x2: 18.253,
                        y2: 13.251,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_540_1415",
                        x1: 18.816,
                        y1: 21.046,
                        x2: 23.902,
                        y2: 19.304,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_540_1415",
                        x1: 18.896,
                        y1: 14.724,
                        x2: 11.395,
                        y2: 9.236,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_540_1415",
                        x1: 11.2,
                        y1: 20.4,
                        x2: 22.089,
                        y2: 9.768,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_540_1415",
                        x1: 9.3,
                        y1: 22.828,
                        x2: 12.35,
                        y2: 19.521,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FF897A"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_540_1415",
                        x1: 8.8,
                        y1: 22.8,
                        x2: 12.4,
                        y2: 19.741,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#FEBEA6"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FC85E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#E264F7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_540_1415",
                        x1: 25.232,
                        y1: 25.808,
                        x2: 11.046,
                        y2: 17.925,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_540_1415",
                        x1: 17.606,
                        y1: 13.488,
                        x2: 13.555,
                        y2: 9.955,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $574254d481c50565$export$2e2bcd8739ae039 = $574254d481c50565$var$SvgWebhook;





var $a0Ubj = parcelRequire("a0Ubj");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

function $a8a1dc292de95078$var$SuccessRate({ stats: stats, isNumberOnly: isNumberOnly }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { successCount: successCount, requestCount: requestCount } = stats ?? {
        successCount: 0,
        requestCount: 0
    };
    if (requestCount === 0) return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
        children: "-"
    });
    const percent = successCount / requestCount * 100;
    const statusStyle = percent < 90 ? "error" : percent < 99 ? "alert" : "success";
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
        variant: "plain",
        type: "state",
        status: statusStyle,
        children: [
            percent.toFixed(2),
            "%",
            !isNumberOnly && ` ${t("webhook_details.success_rate")}`
        ]
    });
}
var $a8a1dc292de95078$export$2e2bcd8739ae039 = $a8a1dc292de95078$var$SuccessRate;


parcelRequire("6ZMK7");
var $emGEN = parcelRequire("emGEN");

var $fbeQ6 = parcelRequire("fbeQ6");


var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $h7VLF = parcelRequire("h7VLF");
var $e103a5814608c5fb$export$ff1331ea3d85e750;
var $e103a5814608c5fb$export$bfd64c937657f93a;
var $e103a5814608c5fb$export$4a6dd88bada4e7d2;
$e103a5814608c5fb$export$ff1331ea3d85e750 = `_3gAc1q_containsTableLayout`;
$e103a5814608c5fb$export$bfd64c937657f93a = `_3gAc1q_rotating`;
$e103a5814608c5fb$export$4a6dd88bada4e7d2 = `_3gAc1q_shimmer`;


function $ecb1c6d3edd8c2c5$var$WebhookDetails() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { pathname: pathname } = (0, $9X5Bp.useLocation)();
    const isPageHasTable = pathname.endsWith((0, $emGEN.WebhookDetailsTabs).RecentRequests);
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { id: id } = (0, $9X5Bp.useParams)();
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(id && (0, $h7VLF.buildUrl)(`api/hooks/${id}`, {
        includeExecutionStats: String(true)
    }));
    const { enabled: isEnabled, executionStats: executionStats } = data ?? {};
    const isLoading = !data && !error;
    const api = (0, $2ANSb.default)();
    const theme = (0, $93h5F.default)();
    const WebhookIcon = theme === "light" ? (0, $574254d481c50565$export$2e2bcd8739ae039) : (0, $48f4fb72ccc36909$export$2e2bcd8739ae039);
    const { show: show } = (0, $9ENFn.useConfirmModal)();
    const [isDeleting, setIsDeleting] = (0, $eCoWV.useState)(false);
    const [isUpdatingEnableState, setIsUpdatingEnableState] = (0, $eCoWV.useState)(false);
    const handleDelete = async ()=>{
        if (!data || isDeleting) return;
        const [result] = await show({
            ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "webhook_details.deletion_reminder"
                }),
            confirmButtonText: "general.delete"
        });
        if (!result) return;
        setIsDeleting(true);
        try {
            await api.delete(`api/hooks/${data.id}`);
            (0, $horhC.toast).success(t("webhook_details.deleted", {
                name: data.name
            }));
            navigate("/webhooks");
        } finally{
            setIsDeleting(false);
        }
    };
    const handleToggleEnableState = async ()=>{
        if (!data || isUpdatingEnableState) return;
        if (isEnabled) {
            const [result] = await show({
                ModalContent: ()=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "webhook_details.disable_reminder"
                    }),
                confirmButtonText: "webhook_details.disable_webhook"
            });
            if (!result) return;
        }
        setIsUpdatingEnableState(true);
        try {
            const updatedHook = await api.patch(`api/hooks/${data.id}`, {
                json: {
                    enabled: !isEnabled
                }
            }).json();
            mutate({
                ...updatedHook,
                executionStats: data.executionStats
            });
            const { enabled: enabled } = updatedHook;
            (0, $horhC.toast).success(t(`webhook_details.webhook_${enabled ? "reactivated" : "disabled"}`));
        } finally{
            setIsUpdatingEnableState(false);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c295648577aecb91$export$2e2bcd8739ae039), {
        backLink: "/webhooks",
        backLinkTitle: "webhook_details.back_to_webhooks",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))(isPageHasTable && $e103a5814608c5fb$export$ff1331ea3d85e750),
        isLoading: isLoading,
        error: error,
        onRetry: mutate,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0Ubj.default), {
                titleKey: "webhook_details.page_title"
            }),
            data && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $84892818f27475db$export$2e2bcd8739ae039), {
                        icon: /*#__PURE__*/ (0, $9zeGj.jsx)(WebhookIcon, {}),
                        title: data.name,
                        subtitle: isEnabled && t("webhook_details.requests", {
                            value: executionStats?.requestCount ?? 0
                        }),
                        primaryTag: isEnabled ? (0, $5CQIb.conditional)(!!executionStats?.successCount && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a8a1dc292de95078$export$2e2bcd8739ae039), {
                            stats: executionStats
                        })) : t("webhook_details.not_in_use"),
                        identifier: {
                            name: "ID",
                            value: data.id
                        },
                        actionMenuItems: [
                            {
                                title: `webhook_details.${isEnabled ? "disable" : "reactivate"}_webhook`,
                                icon: isEnabled ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $43568821afd6a689$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a92ac116c25df55c$export$2e2bcd8739ae039), {}),
                                onClick: handleToggleEnableState
                            },
                            {
                                title: "webhook_details.delete_webhook",
                                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a0d306f42ef06769$export$2e2bcd8739ae039), {}),
                                type: "danger",
                                onClick: handleDelete
                            }
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $68d24eb9a1429606$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/webhooks/${data.id}/${(0, $emGEN.WebhookDetailsTabs).Settings}`,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "webhook_details.settings_tab"
                                })
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bda3ff2e6ba62f6f$export$2e2bcd8739ae039), {
                                href: `/webhooks/${data.id}/${(0, $emGEN.WebhookDetailsTabs).RecentRequests}`,
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                    forKey: "webhook_details.recent_requests_tab"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {
                        context: {
                            hook: data,
                            isDeleting: isDeleting,
                            onHookUpdated: (hook)=>{
                                if (hook) {
                                    const { executionStats: executionStats } = data;
                                    mutate({
                                        ...hook,
                                        executionStats: executionStats
                                    });
                                    return;
                                }
                                mutate();
                            }
                        }
                    })
                ]
            })
        ]
    });
}
var $ecb1c6d3edd8c2c5$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($ecb1c6d3edd8c2c5$var$WebhookDetails);



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $lq5Qn = parcelRequire("lq5Qn");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");

var $2CYkO = parcelRequire("2CYkO");



var $6ZMK7 = parcelRequire("6ZMK7");


var $fbeQ6 = parcelRequire("fbeQ6");




var $4W0F0 = parcelRequire("4W0F0");

var $h7VLF = parcelRequire("h7VLF");
var $3f97b209c53763a1$export$baf82c066573e902;
var $3f97b209c53763a1$export$3dea766d36a8935f;
var $3f97b209c53763a1$export$fa0831f497706bad;
var $3f97b209c53763a1$export$bfd64c937657f93a;
var $3f97b209c53763a1$export$4a6dd88bada4e7d2;
var $3f97b209c53763a1$export$fb184b623420d9be;
$3f97b209c53763a1$export$baf82c066573e902 = `Ridwca_eventSelector`;
$3f97b209c53763a1$export$3dea766d36a8935f = `Ridwca_filter`;
$3f97b209c53763a1$export$fa0831f497706bad = `Ridwca_logs`;
$3f97b209c53763a1$export$bfd64c937657f93a = `Ridwca_rotating`;
$3f97b209c53763a1$export$4a6dd88bada4e7d2 = `Ridwca_shimmer`;
$3f97b209c53763a1$export$fb184b623420d9be = `Ridwca_title`;


const $e4815dbea957c980$var$hooLogEventOptions = Object.values((0, $lq5Qn.HookEvent)).map((event)=>({
        title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: (0, $d1ae2259def9c839$export$80c7b11c6af2a158)[event]
        }),
        value: (0, $d1ae2259def9c839$export$2c04910a41e08127)[event]
    }));
function $e4815dbea957c980$var$WebhookLogs() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { hook: { id: id } } = (0, $9X5Bp.useOutletContext)();
    const pageSize = (0, $6ZMK7.defaultPageSize);
    const [{ page: page, event: event }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1,
        event: "",
        startTimeExclusive: ""
    });
    const url = (0, $h7VLF.buildUrl)(`api/hooks/${id}/recent-logs`, {
        page: String(page),
        page_size: String(pageSize),
        ...(0, $5CQIb.conditional)(event && {
            logKey: event
        })
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)(url);
    const isLoading = !data && !error;
    const [logs, totalCount] = data ?? [];
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $90f8b92e12ac536b$export$2e2bcd8739ae039), {
        className: $3f97b209c53763a1$export$fa0831f497706bad,
        rowGroups: [
            {
                key: "logs",
                data: logs
            }
        ],
        rowIndexKey: "id",
        rowClickHandler: ({ id: id })=>{
            navigate(id);
        },
        filter: /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
            className: $3f97b209c53763a1$export$3dea766d36a8935f,
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $3f97b209c53763a1$export$fb184b623420d9be,
                    children: t("logs.filter_by")
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    className: $3f97b209c53763a1$export$baf82c066573e902,
                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c9d893b595530942$export$2e2bcd8739ae039), {
                        value: event,
                        options: $e4815dbea957c980$var$hooLogEventOptions,
                        onChange: (event)=>{
                            updateSearchParameters({
                                event: event,
                                page: undefined
                            });
                        }
                    })
                })
            ]
        }),
        columns: [
            {
                title: "Status",
                dataIndex: "status",
                colSpan: 5,
                render: ({ payload: payload })=>{
                    const result = (0, $2CYkO.z).object({
                        response: (0, $2CYkO.z).object({
                            statusCode: (0, $2CYkO.z).number().optional()
                        })
                    }).optional().safeParse(payload);
                    const statusCode = result.success ? result.data?.response.statusCode : undefined;
                    const isError = !statusCode || statusCode >= 400;
                    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                        type: "result",
                        status: isError ? "error" : "success",
                        children: statusCode ?? "Request error"
                    });
                }
            },
            {
                title: t("logs.event"),
                dataIndex: "event",
                colSpan: 6,
                render: ({ key: key })=>{
                    const event = Object.values((0, $lq5Qn.HookEvent)).find((event)=>(0, $d1ae2259def9c839$export$2c04910a41e08127)[event] === key);
                    return (0, $5CQIb.conditional)(event && t((0, $d1ae2259def9c839$export$80c7b11c6af2a158)[event])) ?? "-";
                }
            },
            {
                title: t("logs.time"),
                dataIndex: "time",
                colSpan: 5,
                render: ({ createdAt: createdAt })=>new Date(createdAt).toLocaleString()
            }
        ],
        placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $19005d7669ab632a$export$2e2bcd8739ae039), {}),
        pagination: {
            page: page,
            totalCount: totalCount,
            pageSize: pageSize,
            onChange: (page)=>{
                updateSearchParameters({
                    page: page
                });
            }
        },
        isLoading: isLoading,
        errorMessage: error?.body?.message ?? error?.message,
        onRetry: async ()=>mutate(undefined, true)
    });
}
var $e4815dbea957c980$export$2e2bcd8739ae039 = $e4815dbea957c980$var$WebhookLogs;



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9X5Bp = parcelRequire("9X5Bp");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $lq5Qn = parcelRequire("lq5Qn");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");



var $dADBR = parcelRequire("dADBR");

var $hdJkM = parcelRequire("hdJkM");

var $4ytKy = parcelRequire("4ytKy");
var $17aa6209cba8ea74$export$493b5823483d2c4e;
var $17aa6209cba8ea74$export$f71f035a831fd7a7;
var $17aa6209cba8ea74$export$bfd64c937657f93a;
var $17aa6209cba8ea74$export$4a6dd88bada4e7d2;
$17aa6209cba8ea74$export$493b5823483d2c4e = `pJ1nTW_errorMessage`;
$17aa6209cba8ea74$export$f71f035a831fd7a7 = `pJ1nTW_formFieldDescription`;
$17aa6209cba8ea74$export$bfd64c937657f93a = `pJ1nTW_rotating`;
$17aa6209cba8ea74$export$4a6dd88bada4e7d2 = `pJ1nTW_shimmer`;


const $0543cf83d53dc95b$var$hookEventOptions = Object.values((0, $lq5Qn.HookEvent)).map((event)=>({
        title: (0, $d1ae2259def9c839$export$80c7b11c6af2a158)[event],
        value: event
    }));
function $0543cf83d53dc95b$var$BasicWebhookForm() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { register: register, control: control, formState: { errors: errors } } = (0, $c3LX9.useFormContext)();
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
                title: "webhooks.create_form.events",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $17aa6209cba8ea74$export$f71f035a831fd7a7,
                        children: t("webhooks.create_form.events_description")
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.Controller), {
                        name: "events",
                        control: control,
                        defaultValue: [],
                        rules: {
                            validate: (value)=>value.length === 0 ? t("webhooks.create_form.missing_event_error") : true
                        },
                        render: ({ field: { onChange: onChange, value: value } })=>/*#__PURE__*/ (0, $9zeGj.jsx)((0, $6e06fb568fe18a34$export$2e2bcd8739ae039), {
                                options: $0543cf83d53dc95b$var$hookEventOptions,
                                value: value,
                                onChange: onChange
                            })
                    }),
                    errors.events && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $17aa6209cba8ea74$export$493b5823483d2c4e,
                        children: errors.events.message
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "webhooks.create_form.name",
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("name", {
                        required: true
                    }),
                    placeholder: t("webhooks.create_form.name_placeholder"),
                    error: Boolean(errors.name)
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dADBR.default), {
                isRequired: true,
                title: "webhooks.create_form.endpoint_url",
                tip: t("webhooks.create_form.endpoint_url_tip"),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                    ...register("url", {
                        required: true,
                        validate: (value)=>(0, $4ytKy.uriValidator)(value) || t("errors.invalid_uri_format")
                    }),
                    placeholder: t("webhooks.create_form.endpoint_url_placeholder"),
                    error: errors.url?.type === "required" ? true : errors.url?.message
                })
            })
        ]
    });
}
var $0543cf83d53dc95b$export$2e2bcd8739ae039 = $0543cf83d53dc95b$var$BasicWebhookForm;






var $2ANSb = parcelRequire("2ANSb");


var $bSFEw = parcelRequire("bSFEw");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");
const $337b4c617ede30eb$export$267897f64bb59b59 = {
    toLocalForm: (data)=>{
        const { event: event, events: events, name: name, config: { url: url, headers: headers } } = data;
        const headerFields = (0, $5CQIb.conditional)(headers && Object.entries(headers).map(([key, value])=>({
                key: key,
                value: value
            })));
        return {
            events: (0, $5CQIb.conditional)(events.length > 0 && events) ?? (event ? [
                event
            ] : []),
            name: name,
            url: url,
            headers: headerFields?.length ? headerFields : [
                {
                    key: "",
                    value: ""
                }
            ]
        };
    },
    toRemoteModel: (formData)=>{
        const { name: name, events: events, url: url, headers: headers } = formData;
        const headersObject = (0, $5CQIb.conditional)(headers && Object.fromEntries(headers.filter(({ key: key, value: value })=>key && value).map(({ key: key, value: value })=>[
                key,
                value
            ])));
        return {
            name: name,
            events: events,
            config: {
                url: url,
                headers: headersObject,
                /**
         * This is for backward compatibility.
         */ retries: 3
            }
        };
    }
};



var $9zeGj = parcelRequire("9zeGj");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $ecDp6 = parcelRequire("ecDp6");

var $gCKnS = parcelRequire("gCKnS");

var $kcPww = parcelRequire("kcPww");

var $dADBR = parcelRequire("dADBR");

var $9bgsA = parcelRequire("9bgsA");

var $hdJkM = parcelRequire("hdJkM");
var $60a8b86568f01399$export$a3bc9b8ed74fc;
var $60a8b86568f01399$export$e0f35d825088c098;
var $60a8b86568f01399$export$b7e3ae3d7c15e42e;
var $60a8b86568f01399$export$a188eecf6751e19c;
var $60a8b86568f01399$export$bfd64c937657f93a;
var $60a8b86568f01399$export$4a6dd88bada4e7d2;
var $60a8b86568f01399$export$ec672cc1b25fb83f;
$60a8b86568f01399$export$a3bc9b8ed74fc = `oTX9DG_error`;
$60a8b86568f01399$export$e0f35d825088c098 = `oTX9DG_field`;
$60a8b86568f01399$export$b7e3ae3d7c15e42e = `oTX9DG_input`;
$60a8b86568f01399$export$a188eecf6751e19c = `oTX9DG_keyInput`;
$60a8b86568f01399$export$bfd64c937657f93a = `oTX9DG_rotating`;
$60a8b86568f01399$export$4a6dd88bada4e7d2 = `oTX9DG_shimmer`;
$60a8b86568f01399$export$ec672cc1b25fb83f = `oTX9DG_valueInput`;


const $313a3efbf67273c7$var$isValidHeaderKey = (key)=>{
    return /^[\u0021-\u0039\u003B-\u007E]+$/.test(key);
};
const $313a3efbf67273c7$var$isValidHeaderValue = (value)=>{
    return /^[\u0020-\u007E]*$/.test(value);
};
function $313a3efbf67273c7$var$CustomHeaderField() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { control: control, register: register, getValues: getValues, trigger: trigger, formState: { errors: { headers: headerErrors }, submitCount: submitCount } } = (0, $c3LX9.useFormContext)();
    const { fields: fields, remove: remove, append: append } = (0, $c3LX9.useFieldArray)({
        control: control,
        name: "headers"
    });
    const keyValidator = (key, index)=>{
        const headers = getValues("headers");
        if (!headers) return true;
        if (headers.filter(({ key: _key })=>_key.length > 0 && _key === key).length > 1) return t("webhook_details.settings.key_duplicated_error");
        const correspondValue = getValues(`headers.${index}.value`);
        if (correspondValue) return Boolean(key) || t("webhook_details.settings.key_missing_error");
        if (Boolean(key) && !$313a3efbf67273c7$var$isValidHeaderKey(key)) return t("webhook_details.settings.invalid_key_error");
        return true;
    };
    const valueValidator = (value, index)=>{
        if (Boolean(value) && !$313a3efbf67273c7$var$isValidHeaderValue(value)) return t("webhook_details.settings.invalid_value_error");
        return getValues(`headers.${index}.key`) ? Boolean(value) || t("webhook_details.settings.value_missing_error") : true;
    };
    const revalidate = ()=>{
        for (const [index] of fields.entries()){
            trigger(`headers.${index}.key`);
            if (submitCount > 0) trigger(`headers.${index}.value`);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
        title: "webhook_details.settings.custom_headers",
        tip: t("webhook_details.settings.custom_headers_tip"),
        children: [
            fields.map((header, index)=>{
                return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                    className: $60a8b86568f01399$export$e0f35d825088c098,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                            className: $60a8b86568f01399$export$b7e3ae3d7c15e42e,
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    className: $60a8b86568f01399$export$a188eecf6751e19c,
                                    placeholder: "Key",
                                    error: Boolean(headerErrors?.[index]?.key),
                                    ...register(`headers.${index}.key`, {
                                        validate: (key)=>keyValidator(key, index),
                                        onChange: revalidate
                                    })
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $hdJkM.default), {
                                    className: $60a8b86568f01399$export$ec672cc1b25fb83f,
                                    placeholder: "Value",
                                    error: Boolean(headerErrors?.[index]?.value),
                                    ...register(`headers.${index}.value`, {
                                        validate: (value)=>valueValidator(value, index),
                                        onChange: revalidate
                                    })
                                }),
                                fields.length > 1 && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9bgsA.default), {
                                    onClick: ()=>{
                                        remove(index);
                                    },
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $gCKnS.default), {})
                                })
                            ]
                        }),
                        headerErrors?.[index]?.key?.message && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $60a8b86568f01399$export$a3bc9b8ed74fc,
                            children: headerErrors[index]?.key?.message
                        }),
                        headerErrors?.[index]?.value?.message && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $60a8b86568f01399$export$a3bc9b8ed74fc,
                            children: headerErrors[index]?.value?.message
                        })
                    ]
                }, header.id);
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                size: "small",
                type: "text",
                title: "general.add_another",
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecDp6.default), {}),
                onClick: ()=>{
                    append({
                        key: "",
                        value: ""
                    });
                }
            })
        ]
    });
}
var $313a3efbf67273c7$export$2e2bcd8739ae039 = $313a3efbf67273c7$var$CustomHeaderField;



var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $f02dcc3eb8d6fce3$var$SvgRedo = (props)=>/*#__PURE__*/ (0, $9zeGj.jsx)("svg", {
        width: 17,
        height: 17,
        viewBox: "0 0 17 17",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
            d: "M14.5 7.833c-.4 0-.667.267-.667.667 0 1.934-1 3.667-2.666 4.6-2.534 1.467-5.8.6-7.267-1.933-1.467-2.534-.6-5.8 1.933-7.267a5.338 5.338 0 0 1 6.534.933h-1.6c-.4 0-.667.267-.667.667s.267.667.667.667h3c.4 0 .666-.267.666-.667v-3c0-.4-.266-.667-.666-.667S13.1 2.1 13.1 2.5v1.2c-1.267-1.2-2.867-1.867-4.6-1.867-3.667 0-6.667 3-6.667 6.667s3 6.667 6.667 6.667 6.667-3 6.667-6.667c0-.4-.267-.667-.667-.667Z",
            fill: "currentColor"
        })
    });
var $f02dcc3eb8d6fce3$export$2e2bcd8739ae039 = $f02dcc3eb8d6fce3$var$SvgRedo;



var $kcPww = parcelRequire("kcPww");

var $kMAP9 = parcelRequire("kMAP9");

var $47yah = parcelRequire("47yah");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $2ANSb = parcelRequire("2ANSb");
var $8423138f30ea00ec$export$fb34ecfba659a0ec;
var $8423138f30ea00ec$export$bfd64c937657f93a;
var $8423138f30ea00ec$export$4a6dd88bada4e7d2;
var $8423138f30ea00ec$export$f32d6fa108c92ed3;
$8423138f30ea00ec$export$fb34ecfba659a0ec = `-OPSRq_regenerateButton`;
$8423138f30ea00ec$export$bfd64c937657f93a = `-OPSRq_rotating`;
$8423138f30ea00ec$export$4a6dd88bada4e7d2 = `-OPSRq_shimmer`;
$8423138f30ea00ec$export$f32d6fa108c92ed3 = `-OPSRq_signingKeyField`;


function $2a3a6b9ee658d607$var$SigningKeyField({ hookId: hookId, signingKey: signingKey, onSigningKeyUpdated: onSigningKeyUpdated }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined);
    const api = (0, $2ANSb.default)();
    const [isRegenerateFormOpen, setIsRegenerateFormOpen] = (0, $eCoWV.useState)(false);
    const [isRegenerating, setIsRegenerating] = (0, $eCoWV.useState)(false);
    const regenerateSigningKey = (0, $eCoWV.useCallback)(async (silent = false)=>{
        if (isRegenerating) return;
        setIsRegenerating(true);
        try {
            const { signingKey: signingKey } = await api.patch(`api/hooks/${hookId}/signing-key`).json();
            if (!silent) (0, $horhC.toast).success(t("admin_console.webhook_details.settings.regenerated"));
            setIsRegenerateFormOpen(false);
            onSigningKeyUpdated(signingKey);
        } finally{
            setIsRegenerating(false);
        }
    }, [
        api,
        hookId,
        isRegenerating,
        onSigningKeyUpdated,
        t
    ]);
    (0, $eCoWV.useEffect)(()=>{
        if (!signingKey) regenerateSigningKey(true);
    }, [
        regenerateSigningKey,
        signingKey
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
        title: "webhook_details.settings.signing_key",
        tip: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
            forKey: "webhook_details.settings.signing_key_tip"
        }),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $47yah.default), {
                hasVisibilityToggle: true,
                value: signingKey,
                variant: "border",
                className: $8423138f30ea00ec$export$f32d6fa108c92ed3
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                type: "text",
                size: "small",
                icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f02dcc3eb8d6fce3$export$2e2bcd8739ae039), {}),
                title: "webhook_details.settings.regenerate",
                className: $8423138f30ea00ec$export$fb34ecfba659a0ec,
                onClick: ()=>{
                    setIsRegenerateFormOpen(true);
                }
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kMAP9.default), {
                isOpen: isRegenerateFormOpen,
                isLoading: isRegenerating,
                confirmButtonText: "webhook_details.settings.regenerate",
                title: "webhook_details.settings.regenerate_key_title",
                onCancel: async ()=>{
                    setIsRegenerateFormOpen(false);
                },
                onConfirm: async ()=>regenerateSigningKey(),
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                    forKey: "webhook_details.settings.regenerate_key_reminder"
                })
            })
        ]
    });
}
var $2a3a6b9ee658d607$export$2e2bcd8739ae039 = $2a3a6b9ee658d607$var$SigningKeyField;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("j6dBR");
var $7bVxi = parcelRequire("7bVxi");
parcelRequire("bGN6i");
var $aWIy6 = parcelRequire("aWIy6");

var $bNFMZ = parcelRequire("bNFMZ");

var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");

var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");

var $dADBR = parcelRequire("dADBR");

var $9XAkT = parcelRequire("9XAkT");

var $2ANSb = parcelRequire("2ANSb");

var $ee9150402331d791$export$34e0f9847d4c02dd;
var $ee9150402331d791$export$6d59db4903f20f7d;
var $ee9150402331d791$export$aaf36426b5008f7a;
var $ee9150402331d791$export$bfd64c937657f93a;
var $ee9150402331d791$export$4a6dd88bada4e7d2;
$ee9150402331d791$export$34e0f9847d4c02dd = `RV9bSa_container`;
$ee9150402331d791$export$6d59db4903f20f7d = `RV9bSa_description`;
$ee9150402331d791$export$aaf36426b5008f7a = `RV9bSa_result`;
$ee9150402331d791$export$bfd64c937657f93a = `RV9bSa_rotating`;
$ee9150402331d791$export$4a6dd88bada4e7d2 = `RV9bSa_shimmer`;


parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $eCoWV = parcelRequire("eCoWV");

var $2CYkO = parcelRequire("2CYkO");
parcelRequire("6ZMK7");
var $mbOAD = parcelRequire("mbOAD");

var $5a1Rp = parcelRequire("5a1Rp");
const $9c325573d10de1ce$var$webhookTestResultGuard = (0, $2CYkO.z).object({
    result: (0, $2CYkO.z).enum([
        "success",
        "error"
    ]),
    endpointUrl: (0, $2CYkO.z).string(),
    requestTime: (0, $2CYkO.z).number(),
    message: (0, $2CYkO.z).string().optional(),
    responseStatus: (0, $2CYkO.z).number().optional(),
    responseBody: (0, $2CYkO.z).string().optional()
});
const $9c325573d10de1ce$var$readResult = ()=>{
    const parsedJson = (0, $5a1Rp.safeParseJson)((0, $5CQIb.conditionalString)(sessionStorage.getItem((0, $mbOAD.storageKeys).webhookTestResult)));
    return (0, $5CQIb.conditional)(parsedJson.success && $9c325573d10de1ce$var$webhookTestResultGuard.parse(parsedJson.data));
};
const $9c325573d10de1ce$var$useWebhookTestResult = ()=>{
    const [testResult, setTestResult] = (0, $eCoWV.useState)($9c325573d10de1ce$var$readResult());
    return {
        result: testResult,
        setResult: (result)=>{
            setTestResult(result);
            if (result) sessionStorage.setItem((0, $mbOAD.storageKeys).webhookTestResult, JSON.stringify(result));
            else sessionStorage.removeItem((0, $mbOAD.storageKeys).webhookTestResult);
        }
    };
};
var $9c325573d10de1ce$export$2e2bcd8739ae039 = $9c325573d10de1ce$var$useWebhookTestResult;


function $78356c9ca97c8711$var$TestWebhook({ hookId: hookId }) {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { getValues: getValues, formState: { isValid: isValid } } = (0, $c3LX9.useFormContext)();
    const testResultRef = (0, $eCoWV.useRef)(null);
    const { result: result, setResult: setResult } = (0, $9c325573d10de1ce$export$2e2bcd8739ae039)();
    const [isSendingPayload, setIsSendingPayload] = (0, $eCoWV.useState)(false);
    const api = (0, $2ANSb.default)({
        hideErrorToast: true
    });
    const sendTestPayload = async ()=>{
        if (isSendingPayload) return;
        setIsSendingPayload(true);
        const endpointUrl = getValues("url");
        const requestTime = Date.now();
        try {
            const formData = getValues();
            const { events: events, config: config } = (0, $337b4c617ede30eb$export$267897f64bb59b59).toRemoteModel(formData);
            await api.post(`api/hooks/${hookId}/test`, {
                json: {
                    events: events,
                    config: config
                }
            });
            setResult({
                result: "success",
                endpointUrl: endpointUrl,
                message: t("webhook_details.settings.test_result.test_success"),
                requestTime: requestTime
            });
        } catch (error) {
            if (!(error instanceof (0, $d2Ivz.HTTPError))) {
                (0, $horhC.toast).error(error instanceof Error ? String(error) : t("general.unknown_error"));
                return;
            }
            const { code: code, data: data, message: message } = await error.response.clone().json();
            if (code === "hook.send_test_payload_failed") {
                setResult({
                    result: "error",
                    endpointUrl: endpointUrl,
                    requestTime: requestTime,
                    message: message
                });
                return;
            }
            if (code === "hook.endpoint_responded_with_error") {
                const { responseStatus: responseStatus, responseBody: responseBody } = (0, $aWIy6.trySafe)(()=>(0, $7bVxi.hookTestErrorResponseDataGuard).parse(data)) ?? {};
                setResult({
                    result: "error",
                    endpointUrl: endpointUrl,
                    requestTime: requestTime,
                    message: message,
                    responseStatus: responseStatus,
                    responseBody: responseBody
                });
                return;
            }
            throw error;
        } finally{
            setIsSendingPayload(false);
            // Set timeout to wait for the notification to be rendered
            setTimeout(()=>{
                testResultRef.current?.scrollIntoView({
                    behavior: "smooth"
                });
            }, 50);
        }
    };
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $dADBR.default), {
        title: "webhook_details.settings.test_webhook",
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                className: $ee9150402331d791$export$34e0f9847d4c02dd,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $ee9150402331d791$export$6d59db4903f20f7d,
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_webhook_description"
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                        type: "outline",
                        title: "webhook_details.settings.send_test_payload",
                        disabled: !isValid,
                        isLoading: isSendingPayload,
                        onClick: async ()=>{
                            await sendTestPayload();
                        }
                    })
                ]
            }),
            result && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9XAkT.default), {
                ref: testResultRef,
                hasIcon: true,
                severity: result.result,
                action: "general.got_it",
                className: $ee9150402331d791$export$aaf36426b5008f7a,
                onClick: ()=>{
                    setResult(undefined);
                },
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_result.endpoint_url",
                            interpolation: {
                                url: result.endpointUrl
                            }
                        })
                    }),
                    result.message && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_result.message",
                            interpolation: {
                                message: result.message
                            }
                        })
                    }),
                    result.responseStatus && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_result.response_status",
                            interpolation: {
                                status: result.responseStatus
                            }
                        })
                    }),
                    result.responseBody && /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_result.response_body",
                            interpolation: {
                                body: result.responseBody
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                            forKey: "webhook_details.settings.test_result.request_time",
                            interpolation: {
                                time: (0, (/*@__PURE__*/$parcel$interopDefault($bNFMZ)))(result.requestTime).format("MM/DD/YYYY, hh:mm:ss A")
                            }
                        })
                    })
                ]
            })
        ]
    });
}
var $78356c9ca97c8711$export$2e2bcd8739ae039 = $78356c9ca97c8711$var$TestWebhook;


function $58201fc1320834ed$var$WebhookSettings() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { hook: hook, isDeleting: isDeleting, onHookUpdated: onHookUpdated } = (0, $9X5Bp.useOutletContext)();
    const webhookFormData = (0, $337b4c617ede30eb$export$267897f64bb59b59).toLocalForm(hook);
    const formMethods = (0, $c3LX9.useForm)({
        defaultValues: webhookFormData
    });
    const { getDocumentationUrl: getDocumentationUrl } = (0, $a3e24a6a68727733$export$2e2bcd8739ae039)();
    const api = (0, $2ANSb.default)();
    const { handleSubmit: handleSubmit, reset: reset, formState: { isSubmitting: isSubmitting, isDirty: isDirty } } = formMethods;
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (formData)=>{
        const updatedHook = await api.patch(`api/hooks/${hook.id}`, {
            json: (0, $337b4c617ede30eb$export$267897f64bb59b59).toRemoteModel(formData)
        }).json();
        reset((0, $337b4c617ede30eb$export$267897f64bb59b59).toLocalForm(updatedHook));
        onHookUpdated(updatedHook);
        (0, $horhC.toast).success(t("general.saved"));
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $30ff50140180d24e$export$2e2bcd8739ae039), {
                isDirty: isDirty,
                isSubmitting: isSubmitting,
                onSubmit: onSubmit,
                onDiscard: reset,
                children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $c3LX9.FormProvider), {
                    ...formMethods,
                    children: [
                        /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                            title: "webhook_details.settings.settings",
                            description: "webhook_details.settings.settings_description",
                            learnMoreLink: {
                                href: getDocumentationUrl("/docs/recipes/webhooks"),
                                targetBlank: "noopener"
                            },
                            children: [
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0543cf83d53dc95b$export$2e2bcd8739ae039), {}),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2a3a6b9ee658d607$export$2e2bcd8739ae039), {
                                    hookId: hook.id,
                                    signingKey: hook.signingKey,
                                    onSigningKeyUpdated: (signingKey)=>{
                                        onHookUpdated({
                                            ...hook,
                                            signingKey: signingKey
                                        });
                                    }
                                }),
                                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $313a3efbf67273c7$export$2e2bcd8739ae039), {})
                            ]
                        }),
                        /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3e994d6132d55b2e$export$2e2bcd8739ae039), {
                            title: "webhook_details.settings.test",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $78356c9ca97c8711$export$2e2bcd8739ae039), {
                                hookId: hook.id
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d667d8b0c4bcfb48$export$2e2bcd8739ae039), {
                hasUnsavedChanges: !isDeleting && isDirty
            })
        ]
    });
}
var $58201fc1320834ed$export$2e2bcd8739ae039 = $58201fc1320834ed$var$WebhookSettings;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("jZDWq");
var $gvHPO = parcelRequire("gvHPO");
parcelRequire("j6dBR");
var $bhvxB = parcelRequire("bhvxB");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");

var $horhC = parcelRequire("horhC");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

var $2mi28 = parcelRequire("2mi28");




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $1395df01f29832b6$var$SvgWebhooksEmptyDark = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 256,
        height: 256,
        viewBox: "0 0 256 256",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                opacity: 0.4,
                fillRule: "evenodd",
                clipRule: "evenodd",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M176.993 221.626H73.809a53.89 53.89 0 0 1-7.298.494 53.89 53.89 0 0 1-7.298-.494h-4.152v-.734C31.01 215.649 13 194.232 13 168.609c0-26.616 19.431-48.693 44.881-52.819 8.47-28.74 35.053-49.719 66.537-49.719 29.899 0 55.379 18.919 65.122 45.438 28.21 2.582 50.304 26.305 50.304 55.189 0 27.421-19.914 50.191-46.069 54.636v.292h-1.923c-2.43.326-4.91.494-7.43.494-2.519 0-4.999-.168-7.429-.494Z",
                        fill: "url(#paint0_linear_8217_108003)"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M176.993 221.626H73.809a53.89 53.89 0 0 1-7.298.494 53.89 53.89 0 0 1-7.298-.494h-4.152v-.734C31.01 215.649 13 194.232 13 168.609c0-26.616 19.431-48.693 44.881-52.819 8.47-28.74 35.053-49.719 66.537-49.719 29.899 0 55.379 18.919 65.122 45.438 28.21 2.582 50.304 26.305 50.304 55.189 0 27.421-19.914 50.191-46.069 54.636v.292h-1.923c-2.43.326-4.91.494-7.43.494-2.519 0-4.999-.168-7.429-.494Z",
                        fill: "url(#paint1_linear_8217_108003)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 100.613,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 115.774h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.924,
                cy: 108.194,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 104.656,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint2_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 120.738,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 135.898h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.924,
                cy: 128.319,
                r: 2.527,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 124.781,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint3_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 140.863,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 156.024h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.924,
                cy: 148.444,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 144.906,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint4_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 160.989,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 176.15h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.924,
                cy: 168.57,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 165.032,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint5_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 181.114,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M31.333 196.274h77.825v5.054H31.333z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.924,
                cy: 188.694,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 185.157,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint6_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 28.301,
                y: 201.239,
                width: 83.889,
                height: 15.161,
                rx: 2.021,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M31.333 216.4h77.825v.526a4.528 4.528 0 0 1-4.528 4.528H35.86a4.528 4.528 0 0 1-4.527-4.528v-.526Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 39.923,
                cy: 208.819,
                r: 2.527,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 47.504,
                y: 205.282,
                width: 56.6,
                height: 7.075,
                rx: 1.011,
                fill: "url(#paint7_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M31.32 100.11c0-2.5 2.026-4.528 4.527-4.528h68.427c2.5 0 4.527 2.027 4.527 4.528v.503H31.319v-.503Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 121.511,
                y: 48.86,
                width: 61,
                height: 85,
                rx: 16,
                fill: "url(#paint8_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 128.511,
                y: 94.518,
                width: 47,
                height: 8.826,
                rx: 3.555,
                fill: "#CABEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 128.511,
                y: 108.757,
                width: 47,
                height: 8.826,
                rx: 3.555,
                fill: "#E5E1EC",
                stroke: "#815AE3",
                strokeWidth: 0.889
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 164.37,
                y: 111.172,
                width: 0.984,
                height: 4,
                rx: 0.492,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M133.733 98.93c0-.487.396-.882.883-.882h19.124a.882.882 0 0 1 0 1.765h-19.124a.883.883 0 0 1-.883-.883Zm24.371 0c0-.487.395-.882.882-.882h5.198a.883.883 0 1 1 0 1.765h-5.198a.882.882 0 0 1-.882-.883Zm9.586-.882a.883.883 0 1 0 0 1.765h1.716a.882.882 0 0 0 0-1.765h-1.716Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 138.084,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 145.048,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 152.011,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 158.974,
                cy: 113.17,
                rx: 1.741,
                ry: 1.765,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 140.511,
                y: 62.86,
                width: 23,
                height: 23,
                rx: 7.701,
                fill: "#F0EBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 152.01,
                cy: 69.57,
                r: 3.833,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 152.01,
                cy: 69.57,
                r: 3.833,
                fill: "#FDCF90"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M146.261 78.21a3.85 3.85 0 0 1 3.851-3.85h3.799a3.85 3.85 0 0 1 3.85 3.85v1.892a1.925 1.925 0 0 1-1.925 1.925h-7.65a1.925 1.925 0 0 1-1.925-1.925V78.21Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                fill: "url(#paint9_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                fill: "url(#paint10_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M106.487 144.638h107.2a5 5 0 0 1 5 5v68.329H101.488v-68.329a5 5 0 0 1 4.999-5Z",
                stroke: "url(#paint11_linear_8217_108003)",
                strokeWidth: 3.237
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M89.7 216.177h139.715v1.634a3.31 3.31 0 0 1-3.31 3.309H93.835a4.137 4.137 0 0 1-4.136-4.137v-.806Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 214.934,
                y: 65.169,
                width: 6.419,
                height: 6.419,
                rx: 2,
                transform: "rotate(30.813 214.934 65.169)",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M238.697 85.249c0-.116.093-.209.209-.209h1.877a.21.21 0 0 1 .209.209v3.713l3.068-1.853a.2.2 0 0 1 .28.074l.945 1.714c.056.1.021.23-.077.29l-3.069 1.853 3.068 1.853c.099.06.134.19.078.29l-.946 1.714a.198.198 0 0 1-.279.074l-3.068-1.852v3.712a.21.21 0 0 1-.209.209h-1.877a.208.208 0 0 1-.209-.209v-3.713l-3.069 1.853a.199.199 0 0 1-.279-.074l-.946-1.714a.219.219 0 0 1 .078-.29l3.068-1.853-3.068-1.853a.218.218 0 0 1-.078-.29l.946-1.714c.055-.1.18-.134.279-.074l3.069 1.853v-3.713Z",
                fill: "#CABEFF",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M116.511 74.08h-39.68c-5.656 0-10.24 4.585-10.24 10.24V92",
                stroke: "#A782E8",
                strokeDasharray: "3.5 3.5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M67.449 93.131a1 1 0 0 1-1.715 0l-2.074-3.456a1 1 0 0 1 .857-1.514h4.148a1 1 0 0 1 .857 1.514l-2.073 3.456Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.9,
                x: 134.252,
                y: 156.023,
                width: 72.594,
                height: 52.31,
                rx: 3.991,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142.792,
                y: 169.901,
                width: 55.513,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142.792,
                y: 195.522,
                width: 27.756,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142.792,
                y: 186.982,
                width: 55.513,
                height: 4.27,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 142.792,
                y: 178.458,
                width: 37.802,
                height: 4.255,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 185.157,
                y: 178.458,
                width: 13.149,
                height: 4.255,
                rx: 1.597,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 142.212,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 148.432,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 154.652,
                cy: 162.42,
                r: 1.555,
                fill: "#FFFBFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m53.127 64.4-1.11-1.921a2.22 2.22 0 0 0-3.032-.813v0a2.22 2.22 0 0 1-3.031-.812v0a2.22 2.22 0 0 0-3.032-.812L41 61.152",
                stroke: "#F7F8F8",
                strokeOpacity: 0.16,
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M74.856 167.531a.5.5 0 0 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "url(#paint12_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M125.304 167.774a.3.3 0 0 1 0 .514l-4.117 2.471a.3.3 0 0 1-.455-.258v-4.94a.3.3 0 0 1 .455-.257l4.117 2.47Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M74.856 182.607a.5.5 0 0 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "url(#paint13_linear_8217_108003)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M125.304 182.85a.3.3 0 0 1 0 .515l-4.117 2.47a.3.3 0 0 1-.455-.257v-4.941a.3.3 0 0 1 .455-.257l4.117 2.47ZM74.856 198.684a.5.5 0 1 0 0 1v-1Zm0 1h1.638v-1h-1.638v1Zm4.915 0h3.277v-1H79.77v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.276v-1H92.88v1Zm6.553 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h3.277v-1h-3.277v1Zm6.554 0h1.638v-1h-1.638v1Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M125.304 198.926a.3.3 0 0 1 0 .515l-4.117 2.47a.3.3 0 0 1-.455-.257v-4.941a.3.3 0 0 1 .455-.257l4.117 2.47Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                opacity: 0.5,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M213.879 122.459a8.039 8.039 0 0 0 11.518-10.638 8.036 8.036 0 0 0-10.977-2.941l-2.673-4.63-.513-.888",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter0_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M206.419 95.014a5 5 0 1 1 5 8.66 5 5 0 0 1-5-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M206.739 95.568a4.36 4.36 0 1 1 4.36 7.552 4.36 4.36 0 0 1-4.36-7.552Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter1_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M215.976 111.511a5 5 0 1 1 5 8.66 5 5 0 1 1-5-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M216.296 112.065a4.36 4.36 0 1 1 4.36 7.55 4.36 4.36 0 0 1-4.36-7.55Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter2_b_8217_108003)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M196.775 111.341a5 5 0 1 1 5.001 8.66 5 5 0 0 1-5.001-8.66Z",
                                fill: "#5F5D67"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M197.095 111.895a4.36 4.36 0 1 1 4.36 7.552 4.36 4.36 0 0 1-4.36-7.552Z",
                                stroke: "#78767F",
                                strokeWidth: 1.28,
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M195.798 108.538a8.038 8.038 0 0 0 3.454 15.293 8.035 8.035 0 0 0 8.035-8.035h6.356",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M216.751 99.994a8.038 8.038 0 0 0-14.971-4.655 8.035 8.035 0 0 0 2.941 10.976l-3.112 5.392",
                        stroke: "#78767F",
                        strokeWidth: 1.28,
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M17 95.04a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
                fill: "#F7F8F8",
                fillOpacity: 0.16
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_8217_108003",
                        x1: 126.422,
                        y1: 66.071,
                        x2: 126.422,
                        y2: 222.12,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#CABEFF",
                                stopOpacity: 0.32
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_8217_108003",
                        x1: 126.422,
                        y1: 66.071,
                        x2: 126.422,
                        y2: 344.967,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0,
                                stopColor: "#6E6A88"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#6E6A88",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_8217_108003",
                        x1: 47.543,
                        y1: 111.293,
                        x2: 104.137,
                        y2: 104.502,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_8217_108003",
                        x1: 47.543,
                        y1: 131.418,
                        x2: 104.137,
                        y2: 124.627,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_8217_108003",
                        x1: 47.543,
                        y1: 151.543,
                        x2: 104.137,
                        y2: 144.752,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_8217_108003",
                        x1: 47.543,
                        y1: 171.669,
                        x2: 104.137,
                        y2: 164.877,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_8217_108003",
                        x1: 47.543,
                        y1: 191.794,
                        x2: 104.137,
                        y2: 185.002,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_8217_108003",
                        x1: 47.543,
                        y1: 211.919,
                        x2: 104.137,
                        y2: 205.127,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A793FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#B3A2FF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#AA97FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_8217_108003",
                        x1: 152.011,
                        y1: 48.86,
                        x2: 109.915,
                        y2: 124.016,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#A089E1"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#816DB9"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_8217_108003",
                        x1: 157.207,
                        y1: 144.748,
                        x2: 182.209,
                        y2: 228.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_8217_108003",
                        x1: 220.306,
                        y1: 219.587,
                        x2: 34.654,
                        y2: 102.074,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#AC7DFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#B084FF",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_8217_108003",
                        x1: 157.207,
                        y1: 144.748,
                        x2: 182.209,
                        y2: 228.96,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_8217_108003",
                        x1: 74.16,
                        y1: 168.531,
                        x2: 120.037,
                        y2: 168.531,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint13_linear_8217_108003",
                        x1: 74.16,
                        y1: 183.607,
                        x2: 120.037,
                        y2: 183.607,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_b_8217_108003",
                        x: 199.918,
                        y: 90.343,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter1_b_8217_108003",
                        x: 209.475,
                        y: 106.84,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter2_b_8217_108003",
                        x: 190.274,
                        y: 106.67,
                        width: 18.002,
                        height: 18.002,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 2
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_8217_108003"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_8217_108003",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $1395df01f29832b6$export$2e2bcd8739ae039 = $1395df01f29832b6$var$SvgWebhooksEmptyDark;



var $9zeGj = parcelRequire("9zeGj");
parcelRequire("eCoWV");
const $a034959df7aaa15b$var$SvgWebhooksEmpty = (props)=>/*#__PURE__*/ (0, $9zeGj.jsxs)("svg", {
        width: 200,
        height: 200,
        viewBox: "0 0 200 200",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#fff",
                d: "M0 0h200v200H0z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M138.276 173.146H57.662a42.204 42.204 0 0 1-5.7.385c-1.934 0-3.837-.131-5.7-.385h-3.245v-.574c-18.79-4.096-32.86-20.828-32.86-40.847 0-20.793 15.18-38.04 35.063-41.264 6.616-22.454 27.385-38.843 51.982-38.843 23.358 0 43.264 14.78 50.876 35.498 22.039 2.018 39.3 20.551 39.3 43.116 0 21.423-15.558 39.212-35.991 42.685v.229h-1.504a43.732 43.732 0 0 1-5.803.385c-1.968 0-3.905-.131-5.804-.385Z",
                fill: "url(#paint0_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 78.603,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 90.448H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.191,
                cy: 84.526,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.112,
                y: 81.762,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint1_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 94.326,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 106.17H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.191,
                cy: 100.249,
                r: 1.974,
                fill: "#F07EFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.112,
                y: 97.485,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint2_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 110.049,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 121.894H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.191,
                cy: 115.972,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.112,
                y: 113.208,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint3_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 125.772,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 137.617H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.191,
                cy: 131.695,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.112,
                y: 128.931,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint4_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 141.495,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fill: "#947DFF",
                d: "M24.479 153.339H85.28v3.948H24.479z"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.191,
                cy: 147.417,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.112,
                y: 144.654,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint5_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 22.11,
                y: 157.218,
                width: 65.538,
                height: 11.844,
                rx: 1.579,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24.479 169.062h60.8v.411a3.538 3.538 0 0 1-3.537 3.538H28.016a3.538 3.538 0 0 1-3.537-3.538v-.411Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 31.19,
                cy: 163.14,
                r: 1.974,
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 37.113,
                y: 160.377,
                width: 44.219,
                height: 5.527,
                rx: 0.79,
                fill: "url(#paint6_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M24.468 78.21a3.537 3.537 0 0 1 3.537-3.537h53.459A3.537 3.537 0 0 1 85 78.21v.394H24.468v-.394Z",
                fill: "#947DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 94.93,
                y: 38.172,
                width: 47.656,
                height: 66.406,
                rx: 12.5,
                fill: "url(#paint7_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100.399,
                y: 73.842,
                width: 36.719,
                height: 6.896,
                rx: 2.778,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 100.399,
                y: 84.966,
                width: 36.719,
                height: 6.896,
                rx: 2.778,
                fill: "#FBF9FF",
                stroke: "#815AE3",
                strokeWidth: 0.694
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 128.414,
                y: 86.853,
                width: 0.768,
                height: 3.125,
                rx: 0.384,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M104.479 77.29c0-.382.309-.69.69-.69h14.94a.69.69 0 1 1 0 1.379h-14.94a.69.69 0 0 1-.69-.69Zm19.04 0c0-.382.308-.69.689-.69h4.061a.69.69 0 1 1 0 1.379h-4.061a.689.689 0 0 1-.689-.69Zm7.489-.69a.69.69 0 1 0 0 1.379h1.34a.69.69 0 1 0 0-1.38h-1.34Z",
                fill: "#9877EA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 107.878,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 113.319,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 118.758,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("ellipse", {
                cx: 124.198,
                cy: 88.413,
                rx: 1.36,
                ry: 1.379,
                fill: "#956AFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 109.774,
                y: 49.11,
                width: 17.969,
                height: 17.969,
                rx: 6.016,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 118.758,
                cy: 54.351,
                r: 2.995,
                fill: "#FFB95A"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M114.266 61.102a3.008 3.008 0 0 1 3.009-3.008h2.968a3.008 3.008 0 0 1 3.008 3.008v1.477c0 .831-.674 1.504-1.504 1.504h-5.976a1.505 1.505 0 0 1-1.505-1.504v-1.477Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                fill: "url(#paint8_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                fill: "url(#paint9_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M79.287 116.905a3.906 3.906 0 0 1 3.906-3.906h83.75a3.906 3.906 0 0 1 3.906 3.906v53.382H79.287v-53.382Z",
                stroke: "url(#paint10_linear_377_52050)",
                strokeWidth: 2.529
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M70.078 168.889H179.23v1.276a2.585 2.585 0 0 1-2.585 2.585H73.309a3.23 3.23 0 0 1-3.231-3.231v-.63Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M70.078 168.889H179.23v1.276a2.585 2.585 0 0 1-2.585 2.585H73.309a3.23 3.23 0 0 1-3.231-3.231v-.63Z",
                fill: "#7958FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 167.917,
                y: 50.914,
                width: 5.015,
                height: 5.015,
                rx: 1.563,
                transform: "rotate(30.813 167.917 50.914)",
                fill: "#FFDDB5"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M186.482 66.6c0-.09.073-.162.163-.162h1.467c.09 0 .163.072.163.162v2.901l2.397-1.447a.155.155 0 0 1 .218.058l.739 1.339a.17.17 0 0 1-.061.227l-2.397 1.447 2.397 1.448a.17.17 0 0 1 .061.227l-.739 1.338a.155.155 0 0 1-.218.058l-2.397-1.447v2.9c0 .09-.073.163-.163.163h-1.467a.163.163 0 0 1-.163-.162v-2.901l-2.397 1.448a.156.156 0 0 1-.219-.059l-.738-1.338a.17.17 0 0 1 .06-.227l2.398-1.448-2.398-1.448a.172.172 0 0 1-.061-.227l.739-1.338a.156.156 0 0 1 .219-.058l2.397 1.447v-2.9Z",
                fill: "#E5E1EC"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M91.024 57.875h-31a8 8 0 0 0-8 8v6",
                stroke: "#A782E8",
                strokeWidth: 0.781,
                strokeDasharray: "2.73 2.73"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M52.694 72.758a.781.781 0 0 1-1.34 0l-1.62-2.7a.781.781 0 0 1 .67-1.183h3.24c.608 0 .983.662.67 1.183l-1.62 2.7Z",
                fill: "#A782E8"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                opacity: 0.9,
                x: 104.885,
                y: 121.893,
                width: 56.714,
                height: 40.867,
                rx: 3.118,
                fill: "#E6DEFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.557,
                y: 132.736,
                width: 43.369,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.557,
                y: 152.752,
                width: 21.685,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.557,
                y: 146.08,
                width: 43.369,
                height: 3.336,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 111.557,
                y: 139.42,
                width: 29.533,
                height: 3.324,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("rect", {
                x: 144.654,
                y: 139.42,
                width: 10.272,
                height: 3.324,
                rx: 1.247,
                fill: "#C29DFF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 111.104,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 115.963,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("circle", {
                cx: 120.822,
                cy: 126.891,
                r: 1.215,
                fill: "#FBF9FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "m41.505 50.313-.867-1.502a1.734 1.734 0 0 0-2.368-.634v0c-.83.478-1.89.194-2.369-.635v0a1.734 1.734 0 0 0-2.368-.635l-1.502.867",
                stroke: "#FFDDB5",
                strokeWidth: 1.563,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58.48 130.884a.39.39 0 0 0 0 .782v-.782Zm0 .782h1.28v-.782h-1.28v.782Zm3.841 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.121 0h2.56v-.782h-2.56v.782Zm5.12 0h1.28v-.782h-1.28v.782Z",
                fill: "url(#paint11_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M97.894 131.074a.234.234 0 0 1 0 .402l-3.217 1.93a.235.235 0 0 1-.355-.201v-3.86c0-.182.199-.295.355-.201l3.217 1.93Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M58.48 142.662a.39.39 0 0 0 0 .782v-.782Zm0 .782h1.28v-.782h-1.28v.782Zm3.841 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.12 0h2.56v-.782h-2.56v.782Zm5.121 0h2.56v-.782h-2.56v.782Zm5.12 0h1.28v-.782h-1.28v.782Z",
                fill: "url(#paint12_linear_377_52050)"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M97.894 142.852a.234.234 0 0 1 0 .402l-3.217 1.93a.235.235 0 0 1-.355-.201v-3.86c0-.182.199-.295.355-.201l3.217 1.93ZM58.48 155.222a.39.39 0 0 0 0 .781v-.781Zm0 .781h1.28v-.781h-1.28v.781Zm3.841 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.12 0h2.56v-.781h-2.56v.781Zm5.121 0h2.56v-.781h-2.56v.781Zm5.12 0h1.28v-.781h-1.28v.781Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                d: "M97.894 155.412a.234.234 0 0 1 0 .402l-3.217 1.929a.234.234 0 0 1-.355-.201v-3.859c0-.182.199-.295.355-.201l3.217 1.93Z",
                fill: "#F3EEFA"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                opacity: 0.5,
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M167.093 95.67a6.278 6.278 0 0 0 6.7.265 6.277 6.277 0 1 0-6.277-10.873l-2.089-3.617-.4-.694",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter0_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M161.265 74.229a3.906 3.906 0 1 1 3.906 6.766 3.906 3.906 0 0 1-3.906-6.766Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M161.515 74.662a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter1_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M168.731 87.117a3.906 3.906 0 1 1 3.906 6.767 3.906 3.906 0 0 1-3.906-6.767Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M168.981 87.55a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("g", {
                        filter: "url(#filter2_b_377_52050)",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M153.731 86.984a3.906 3.906 0 1 1 3.906 6.767 3.906 3.906 0 0 1-3.906-6.767Z",
                                fill: "#CABEFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                                d: "M153.981 87.417a3.406 3.406 0 1 1 3.406 5.9 3.406 3.406 0 0 1-3.406-5.9Z",
                                stroke: "#AF9EFF",
                                strokeLinecap: "round"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M152.967 84.796a6.279 6.279 0 0 0 2.698 11.947 6.277 6.277 0 0 0 6.278-6.277h4.966",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                        d: "M169.337 78.12a6.28 6.28 0 0 0-11.696-3.637 6.277 6.277 0 0 0 2.298 8.575l-2.432 4.212",
                        stroke: "#AF9EFF",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $9zeGj.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M13.281 74.25a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25Zm0-1.563a1.563 1.563 0 1 0 0-3.125 1.563 1.563 0 0 0 0 3.126Z",
                fill: "#FFD5FF"
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint0_linear_377_52050",
                        x1: 98.767,
                        y1: 51.618,
                        x2: 98.767,
                        y2: 173.531,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#F3EFFA"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F3EFFA",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint1_linear_377_52050",
                        x1: 37.143,
                        y1: 86.947,
                        x2: 81.357,
                        y2: 81.641,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint2_linear_377_52050",
                        x1: 37.143,
                        y1: 102.67,
                        x2: 81.357,
                        y2: 97.364,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint3_linear_377_52050",
                        x1: 37.143,
                        y1: 118.393,
                        x2: 81.357,
                        y2: 113.087,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint4_linear_377_52050",
                        x1: 37.143,
                        y1: 134.116,
                        x2: 81.357,
                        y2: 128.81,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint5_linear_377_52050",
                        x1: 37.143,
                        y1: 149.838,
                        x2: 81.357,
                        y2: 144.533,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint6_linear_377_52050",
                        x1: 37.143,
                        y1: 165.562,
                        x2: 81.357,
                        y2: 160.256,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#B6A6FB"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.443,
                                stopColor: "#C1B3FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CABEFF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint7_linear_377_52050",
                        x1: 118.758,
                        y1: 38.172,
                        x2: 85.871,
                        y2: 96.888,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#C39EFF"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#906FEF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint8_linear_377_52050",
                        x1: 122.818,
                        y1: 113.085,
                        x2: 142.351,
                        y2: 178.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint9_linear_377_52050",
                        x1: 172.114,
                        y1: 171.553,
                        x2: 27.074,
                        y2: 79.746,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#BC97FD"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#BC97FD",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint10_linear_377_52050",
                        x1: 122.818,
                        y1: 113.085,
                        x2: 142.351,
                        y2: 178.875,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#492EF3"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#CF69FF"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint11_linear_377_52050",
                        x1: 57.938,
                        y1: 131.775,
                        x2: 93.779,
                        y2: 131.775,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("linearGradient", {
                        id: "paint12_linear_377_52050",
                        x1: 57.938,
                        y1: 143.553,
                        x2: 93.779,
                        y2: 143.553,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                stopColor: "#7F43E9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.615,
                                stopColor: "#A070F4"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 0.714,
                                stopColor: "#E6DCF9"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("stop", {
                                offset: 1,
                                stopColor: "#F2EEFA"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter0_b_377_52050",
                        x: 156.186,
                        y: 70.58,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter1_b_377_52050",
                        x: 163.652,
                        y: 83.468,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("filter", {
                        id: "filter2_b_377_52050",
                        x: 148.652,
                        y: 83.335,
                        width: 14.064,
                        height: 14.064,
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feGaussianBlur", {
                                in: "BackgroundImageFix",
                                stdDeviation: 1.563
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feComposite", {
                                in2: "SourceAlpha",
                                operator: "in",
                                result: "effect1_backgroundBlur_377_52050"
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_backgroundBlur_377_52050",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });
var $a034959df7aaa15b$export$2e2bcd8739ae039 = $a034959df7aaa15b$var$SvgWebhooksEmpty;






var $6ZMK7 = parcelRequire("6ZMK7");


var $kcPww = parcelRequire("kcPww");

var $fbeQ6 = parcelRequire("fbeQ6");




var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");

var $h7VLF = parcelRequire("h7VLF");

var $9zeGj = parcelRequire("9zeGj");

var $bFFWx = parcelRequire("bFFWx");

var $7iZsu = parcelRequire("7iZsu");

var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");

var $c3LX9 = parcelRequire("c3LX9");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");
var $j9r7N = parcelRequire("j9r7N");





var $2wPYZ = parcelRequire("2wPYZ");

var $kcPww = parcelRequire("kcPww");

var $bNHoO = parcelRequire("bNHoO");

var $2ANSb = parcelRequire("2ANSb");


var $bSFEw = parcelRequire("bSFEw");

function $30b89803591b74bf$var$CreateForm({ totalWebhookCount: totalWebhookCount, onClose: onClose }) {
    const { currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const { data: currentPlan } = (0, $098ebafe1d66e039$export$2e2bcd8739ae039)(currentTenantId);
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const shouldBlockCreation = (0, $ce29ac0c76414b31$export$1cc4b5152472cd4f)({
        quotaKey: "hooksLimit",
        usage: totalWebhookCount,
        plan: currentPlan
    });
    const formMethods = (0, $c3LX9.useForm)();
    const { handleSubmit: handleSubmit, formState: { isSubmitting: isSubmitting } } = formMethods;
    const api = (0, $2ANSb.default)();
    const onSubmit = handleSubmit((0, $bSFEw.trySubmitSafe)(async (data)=>{
        const { name: name, events: events, url: url } = data;
        const payload = {
            name: name,
            events: events,
            config: {
                url: url
            }
        };
        const created = await api.post("api/hooks", {
            json: payload
        }).json();
        onClose(created);
    }));
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $bNHoO.default), {
        title: "webhooks.create_form.title",
        subtitle: "webhooks.create_form.subtitle",
        footer: shouldBlockCreation && currentPlan ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $11524bf69118eb72$export$2e2bcd8739ae039), {
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $j9r7N.Trans), {
                components: {
                    a: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $954fb8e7e9037d3a$export$2e2bcd8739ae039), {}),
                    planName: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ec0d8eaa8ea67c57$export$2e2bcd8739ae039), {
                        name: currentPlan.name
                    })
                },
                children: t("upsell.paywall.hooks", {
                    count: currentPlan.quota.hooksLimit ?? 0
                })
            })
        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
            disabled: isSubmitting,
            htmlType: "submit",
            title: "webhooks.create_form.create_webhook",
            size: "large",
            type: "primary",
            onClick: onSubmit
        }),
        size: "large",
        onClose: onClose,
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c3LX9.FormProvider), {
            ...formMethods,
            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0543cf83d53dc95b$export$2e2bcd8739ae039), {})
        })
    });
}
var $30b89803591b74bf$export$2e2bcd8739ae039 = $30b89803591b74bf$var$CreateForm;


function $58a75ef2cd337c7c$var$CreateFormModal({ isOpen: isOpen, totalWebhookCount: totalWebhookCount, onClose: onClose }) {
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))), {
        shouldCloseOnOverlayClick: true,
        shouldCloseOnEsc: true,
        isOpen: isOpen,
        className: $7iZsu.content,
        overlayClassName: $7iZsu.overlay,
        onRequestClose: ()=>{
            onClose();
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $30b89803591b74bf$export$2e2bcd8739ae039), {
            totalWebhookCount: totalWebhookCount,
            onClose: onClose
        })
    });
}
var $58a75ef2cd337c7c$export$2e2bcd8739ae039 = $58a75ef2cd337c7c$var$CreateFormModal;


var $e08910c0ccd872ca$export$1ca1ec8b29a4ce27;
var $e08910c0ccd872ca$export$5dd7af07b99bbd1e;
var $e08910c0ccd872ca$export$bfd64c937657f93a;
var $e08910c0ccd872ca$export$4a6dd88bada4e7d2;
$e08910c0ccd872ca$export$1ca1ec8b29a4ce27 = `_PklPG_icon`;
$e08910c0ccd872ca$export$5dd7af07b99bbd1e = `_PklPG_requests`;
$e08910c0ccd872ca$export$bfd64c937657f93a = `_PklPG_rotating`;
$e08910c0ccd872ca$export$4a6dd88bada4e7d2 = `_PklPG_shimmer`;


const $65905a3084f8f322$var$pageSize = (0, $6ZMK7.defaultPageSize);
const $65905a3084f8f322$var$webhooksPathname = "/webhooks";
const $65905a3084f8f322$var$createWebhookPathname = `${$65905a3084f8f322$var$webhooksPathname}/create`;
const $65905a3084f8f322$var$buildDetailsPathname = (id)=>`${$65905a3084f8f322$var$webhooksPathname}/${id}`;
function $65905a3084f8f322$var$Webhooks() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { navigate: navigate, match: match } = (0, $4W0F0.default)();
    const [{ page: page }, updateSearchParameters] = (0, $844674d3e76c47e1$export$2e2bcd8739ae039)({
        page: 1
    });
    const { data: data, error: error, mutate: mutate } = (0, $2mi28.default)((0, $h7VLF.buildUrl)("api/hooks", {
        includeExecutionStats: String(true),
        page: String(page),
        page_size: String($65905a3084f8f322$var$pageSize)
    }));
    const isLoading = !data && !error;
    const [webhooks, totalCount] = data ?? [];
    const theme = (0, $93h5F.default)();
    const WebhookIcon = theme === (0, $bhvxB.Theme).Light ? (0, $574254d481c50565$export$2e2bcd8739ae039) : (0, $48f4fb72ccc36909$export$2e2bcd8739ae039);
    const isCreating = match($65905a3084f8f322$var$createWebhookPathname);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $00cb4947eb0d79c7$export$2e2bcd8739ae039), {
        title: {
            title: "webhooks.title",
            subtitle: "webhooks.subtitle"
        },
        pageMeta: {
            titleKey: "webhooks.page_title"
        },
        createButton: {
            title: "webhooks.create",
            onClick: ()=>{
                navigate({
                    pathname: $65905a3084f8f322$var$createWebhookPathname,
                    search: search
                });
            }
        },
        table: {
            rowGroups: [
                {
                    key: "hooks",
                    data: webhooks
                }
            ],
            rowIndexKey: "id",
            isLoading: isLoading,
            errorMessage: error?.body?.message ?? error?.message,
            columns: [
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "webhooks.table.name"
                    }),
                    dataIndex: "name",
                    colSpan: 5,
                    render: ({ id: id, name: name })=>{
                        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $82d274a280aee8c6$export$2e2bcd8739ae039), {
                            icon: /*#__PURE__*/ (0, $9zeGj.jsx)(WebhookIcon, {
                                className: $e08910c0ccd872ca$export$1ca1ec8b29a4ce27
                            }),
                            title: name || t("general.unnamed"),
                            to: $65905a3084f8f322$var$buildDetailsPathname(id)
                        });
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "webhooks.table.events"
                    }),
                    dataIndex: "events",
                    colSpan: 6,
                    render: ({ event: event, events: events })=>{
                        const eventArray = (0, $5CQIb.conditional)(events.length > 0 && events) ?? [
                            event
                        ];
                        return eventArray// eslint-disable-next-line unicorn/prefer-native-coercion-functions
                        .filter((_event)=>Boolean(_event)).map((_event)=>t((0, $d1ae2259def9c839$export$80c7b11c6af2a158)[_event])).join(", ");
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "webhooks.table.success_rate"
                    }),
                    dataIndex: "successRate",
                    colSpan: 3,
                    render: ({ enabled: enabled, executionStats: executionStats })=>{
                        return enabled ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a8a1dc292de95078$export$2e2bcd8739ae039), {
                            isNumberOnly: true,
                            stats: executionStats
                        }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $148d05f92bf3ea30$export$2e2bcd8739ae039), {
                            type: "state",
                            status: "info",
                            variant: "plain",
                            children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                                forKey: "webhook_details.not_in_use"
                            })
                        });
                    }
                },
                {
                    title: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbeQ6.default), {
                        forKey: "webhooks.table.requests"
                    }),
                    dataIndex: "Requests",
                    colSpan: 2,
                    render: ({ enabled: enabled, executionStats: { requestCount: requestCount } })=>{
                        return /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                            className: $e08910c0ccd872ca$export$5dd7af07b99bbd1e,
                            children: enabled ? requestCount.toLocaleString() : "-"
                        });
                    }
                }
            ],
            rowClickHandler: ({ id: id })=>{
                navigate($65905a3084f8f322$var$buildDetailsPathname(id));
            },
            placeholder: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $93faad655816a21c$export$2e2bcd8739ae039), {
                image: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a034959df7aaa15b$export$2e2bcd8739ae039), {}),
                imageDark: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1395df01f29832b6$export$2e2bcd8739ae039), {}),
                title: "webhooks.placeholder.title",
                description: "webhooks.placeholder.description",
                action: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                    title: "webhooks.placeholder.create_webhook",
                    type: "primary",
                    size: "large",
                    icon: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a9045f0908bf76b8$export$2e2bcd8739ae039), {}),
                    onClick: ()=>{
                        navigate({
                            pathname: $65905a3084f8f322$var$createWebhookPathname,
                            search: search
                        });
                    }
                })
            }),
            pagination: {
                page: page,
                totalCount: totalCount,
                pageSize: $65905a3084f8f322$var$pageSize,
                onChange: (page)=>{
                    updateSearchParameters({
                        page: page
                    });
                }
            }
        },
        widgets: totalCount !== undefined && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $58a75ef2cd337c7c$export$2e2bcd8739ae039), {
            isOpen: isCreating,
            totalWebhookCount: totalCount,
            onClose: (createdHook)=>{
                if (createdHook) {
                    mutate();
                    (0, $horhC.toast).success(t("webhooks.webhook_created", {
                        name: createdHook.name
                    }));
                    navigate($65905a3084f8f322$var$buildDetailsPathname(createdHook.id), {
                        replace: true
                    });
                    return;
                }
                navigate({
                    pathname: $65905a3084f8f322$var$webhooksPathname,
                    search: search
                });
            }
        })
    });
}
var $65905a3084f8f322$export$2e2bcd8739ae039 = (0, $gvHPO.withAppInsights)($65905a3084f8f322$var$Webhooks);



var $886858ebf2cfe30c$export$a7db06668cad9adb;
var $886858ebf2cfe30c$export$f22da7240b7add18;
var $886858ebf2cfe30c$export$1b0156572ca541be;
var $886858ebf2cfe30c$export$bfd64c937657f93a;
var $886858ebf2cfe30c$export$4a6dd88bada4e7d2;
$886858ebf2cfe30c$export$a7db06668cad9adb = `lQ-hZW_content`;
$886858ebf2cfe30c$export$f22da7240b7add18 = `lQ-hZW_main`;
$886858ebf2cfe30c$export$1b0156572ca541be = `lQ-hZW_overlayScrollbarWrapper`;
$886858ebf2cfe30c$export$bfd64c937657f93a = `lQ-hZW_rotating`;
$886858ebf2cfe30c$export$4a6dd88bada4e7d2 = `lQ-hZW_shimmer`;


function $105cad9d2b9a0410$var$ConsoleContent() {
    const { scrollableContent: scrollableContent } = (0, $9X5Bp.useOutletContext)();
    const { data: { getStartedHidden: getStartedHidden } } = (0, $cfea97097315f28a$export$2e2bcd8739ae039)();
    const { isDevTenant: isDevTenant } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: $886858ebf2cfe30c$export$a7db06668cad9adb,
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fb92937fea49e5ea$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d0Zvy.default), {
                className: $886858ebf2cfe30c$export$1b0156572ca541be,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                    ref: scrollableContent,
                    className: $886858ebf2cfe30c$export$f22da7240b7add18,
                    children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Routes), {
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "*",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $djktV.default), {})
                            }),
                            !getStartedHidden && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "get-started",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $434afc4a4409c455$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "dashboard",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $688da2f940aadd35$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "applications",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d89e5ea4d5929442$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d89e5ea4d5929442$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":id/guide/:guideId",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $79d4566b6fc7e849$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":id",
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.ApplicationDetailsTabs).Settings
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: ":tab",
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $79d4566b6fc7e849$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "api-resources",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9946707120d8d280$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9946707120d8d280$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":id/guide/:guideId",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3a92d6ed0a0d6f8e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":id",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $3a92d6ed0a0d6f8e$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.ApiResourceDetailsTabs).Settings
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.ApiResourceDetailsTabs).Settings,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $cd340641c4c30295$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.ApiResourceDetailsTabs).Permissions,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a87297d328861428$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "sign-in-experience",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                            replace: true,
                                            to: (0, $c40b4b371a14037f$export$8ce28b52dd68c0b7).Branding
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":tab",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c40b4b371a14037f$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "mfa",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e20e6edd0e42354f$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "connectors",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                            replace: true,
                                            to: (0, $emGEN.ConnectorsTabs).Passwordless
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":tab",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbf94a58443b74af$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":tab/create/:createType",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbf94a58443b74af$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":tab/guide/:factoryId",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbf94a58443b74af$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":tab/:connectorId",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $88f960af93587c98$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "enterprise-sso",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5a5c5c8d6a7ce863$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5a5c5c8d6a7ce863$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":ssoConnectorId",
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.EnterpriseSsoDetailsTabs).Connection
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: ":tab",
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fbee01ee803ba367$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "webhooks",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $65905a3084f8f322$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $65905a3084f8f322$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":id",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ecb1c6d3edd8c2c5$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.WebhookDetailsTabs).Settings
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.WebhookDetailsTabs).Settings,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $58201fc1320834ed$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.WebhookDetailsTabs).RecentRequests,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e4815dbea957c980$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: `:hookId/${(0, $emGEN.WebhookDetailsTabs).RecentRequests}/:logId`,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c0edd8f6d5f01a0d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "users",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c81b5ba82b4d0ed5$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c81b5ba82b4d0ed5$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":id",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ff62af747b089187$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.UserDetailsTabs).Settings
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.UserDetailsTabs).Settings,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c19b9e91e867edda$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.UserDetailsTabs).Roles,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0598482e2ffd0d75$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.UserDetailsTabs).Logs,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0245c19a15aab891$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.UserDetailsTabs).Organizations,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f9b18ef9fcf31f05$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: `:userId/${(0, $emGEN.UserDetailsTabs).Logs}/:logId`,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c0edd8f6d5f01a0d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "audit-logs",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $0cb561f1335407d8$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":logId",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c0edd8f6d5f01a0d$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "roles",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e74da459c6551bd7$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e74da459c6551bd7$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        path: ":id",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $28855ebc9a5ea4e0$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                                    replace: true,
                                                    to: (0, $emGEN.RoleDetailsTabs).Settings
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.RoleDetailsTabs).Settings,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $80ad8e84bbbd4435$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.RoleDetailsTabs).Permissions,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $769a181e89b69a89$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.RoleDetailsTabs).Users,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7f7c6316bd0afac9$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.RoleDetailsTabs).M2mApps,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d7ea78942d6988b9$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "organizations",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c70ac5e118c7eccf$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "create",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c70ac5e118c7eccf$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "template",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c70ac5e118c7eccf$export$2e2bcd8739ae039), {
                                            tab: "template"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: ":id/*",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $89f71c55405f67fe$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "organization-guide/*",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $409d60f5497292f3$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "profile",
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f1109971e06adf3b$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "verify-password",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a2740c5b351e2f1e$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "change-password",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $94b6d6f91f56539f$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "link-email",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $f7dc9254f7cd6e01$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: "verification-code",
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $af21ae4746dd3cb9$export$2e2bcd8739ae039), {})
                                    })
                                ]
                            }),
                            (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                path: "tenant-settings",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $c4930316e4ff1ac3$export$2e2bcd8739ae039), {}),
                                children: [
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        index: true,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                                            replace: true,
                                            to: (0, $emGEN.TenantSettingsTabs).Settings
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: (0, $emGEN.TenantSettingsTabs).Settings,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a1f3865920951bed$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: (0, $emGEN.TenantSettingsTabs).Domains,
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d18826402be754b7$export$2e2bcd8739ae039), {})
                                    }),
                                    !isDevTenant && /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9zeGj.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.TenantSettingsTabs).Subscription,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $61045557af6c324f$export$2e2bcd8739ae039), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: (0, $emGEN.TenantSettingsTabs).BillingHistory,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $21de7248c1e713c3$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
}
var $105cad9d2b9a0410$export$2e2bcd8739ae039 = $105cad9d2b9a0410$var$ConsoleContent;





var $2wPYZ = parcelRequire("2wPYZ");




var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");

var $iyeK6 = parcelRequire("iyeK6");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $2A6IJ = parcelRequire("2A6IJ");


var $kcPww = parcelRequire("kcPww");

var $iYZTa = parcelRequire("iYZTa");

var $4W0F0 = parcelRequire("4W0F0");

var $93h5F = parcelRequire("93h5F");
var $53ab2901d76f2951$exports = {};

$parcel$export($53ab2901d76f2951$exports, "button", function () { return $53ab2901d76f2951$export$2ba01fb71ed41cb6; }, function (v) { return $53ab2901d76f2951$export$2ba01fb71ed41cb6 = v; });
$parcel$export($53ab2901d76f2951$exports, "container", function () { return $53ab2901d76f2951$export$34e0f9847d4c02dd; }, function (v) { return $53ab2901d76f2951$export$34e0f9847d4c02dd = v; });
$parcel$export($53ab2901d76f2951$exports, "content", function () { return $53ab2901d76f2951$export$a7db06668cad9adb; }, function (v) { return $53ab2901d76f2951$export$a7db06668cad9adb = v; });
$parcel$export($53ab2901d76f2951$exports, "dark", function () { return $53ab2901d76f2951$export$55ce6f3a06c59543; }, function (v) { return $53ab2901d76f2951$export$55ce6f3a06c59543 = v; });
$parcel$export($53ab2901d76f2951$exports, "description", function () { return $53ab2901d76f2951$export$6d59db4903f20f7d; }, function (v) { return $53ab2901d76f2951$export$6d59db4903f20f7d = v; });
$parcel$export($53ab2901d76f2951$exports, "header", function () { return $53ab2901d76f2951$export$38e42c68cf43b5d4; }, function (v) { return $53ab2901d76f2951$export$38e42c68cf43b5d4 = v; });
$parcel$export($53ab2901d76f2951$exports, "light", function () { return $53ab2901d76f2951$export$a43af521ac8c3202; }, function (v) { return $53ab2901d76f2951$export$a43af521ac8c3202 = v; });
$parcel$export($53ab2901d76f2951$exports, "logo", function () { return $53ab2901d76f2951$export$db3c28d99448dcff; }, function (v) { return $53ab2901d76f2951$export$db3c28d99448dcff = v; });
$parcel$export($53ab2901d76f2951$exports, "placeholderBottom", function () { return $53ab2901d76f2951$export$d039a117f4b4a172; }, function (v) { return $53ab2901d76f2951$export$d039a117f4b4a172 = v; });
$parcel$export($53ab2901d76f2951$exports, "placeholderTop", function () { return $53ab2901d76f2951$export$2a783d3dea58cac6; }, function (v) { return $53ab2901d76f2951$export$2a783d3dea58cac6 = v; });
$parcel$export($53ab2901d76f2951$exports, "rotating", function () { return $53ab2901d76f2951$export$bfd64c937657f93a; }, function (v) { return $53ab2901d76f2951$export$bfd64c937657f93a = v; });
$parcel$export($53ab2901d76f2951$exports, "shimmer", function () { return $53ab2901d76f2951$export$4a6dd88bada4e7d2; }, function (v) { return $53ab2901d76f2951$export$4a6dd88bada4e7d2 = v; });
$parcel$export($53ab2901d76f2951$exports, "title", function () { return $53ab2901d76f2951$export$fb184b623420d9be; }, function (v) { return $53ab2901d76f2951$export$fb184b623420d9be = v; });
var $53ab2901d76f2951$export$2ba01fb71ed41cb6;
var $53ab2901d76f2951$export$34e0f9847d4c02dd;
var $53ab2901d76f2951$export$a7db06668cad9adb;
var $53ab2901d76f2951$export$55ce6f3a06c59543;
var $53ab2901d76f2951$export$6d59db4903f20f7d;
var $53ab2901d76f2951$export$38e42c68cf43b5d4;
var $53ab2901d76f2951$export$a43af521ac8c3202;
var $53ab2901d76f2951$export$db3c28d99448dcff;
var $53ab2901d76f2951$export$d039a117f4b4a172;
var $53ab2901d76f2951$export$2a783d3dea58cac6;
var $53ab2901d76f2951$export$bfd64c937657f93a;
var $53ab2901d76f2951$export$4a6dd88bada4e7d2;
var $53ab2901d76f2951$export$fb184b623420d9be;
$53ab2901d76f2951$export$2ba01fb71ed41cb6 = `hwnTFa_button`;
$53ab2901d76f2951$export$34e0f9847d4c02dd = `hwnTFa_container`;
$53ab2901d76f2951$export$a7db06668cad9adb = `hwnTFa_content`;
$53ab2901d76f2951$export$55ce6f3a06c59543 = `hwnTFa_dark`;
$53ab2901d76f2951$export$6d59db4903f20f7d = `hwnTFa_description`;
$53ab2901d76f2951$export$38e42c68cf43b5d4 = `hwnTFa_header`;
$53ab2901d76f2951$export$a43af521ac8c3202 = `hwnTFa_light`;
$53ab2901d76f2951$export$db3c28d99448dcff = `hwnTFa_logo`;
$53ab2901d76f2951$export$d039a117f4b4a172 = `hwnTFa_placeholderBottom`;
$53ab2901d76f2951$export$2a783d3dea58cac6 = `hwnTFa_placeholderTop`;
$53ab2901d76f2951$export$bfd64c937657f93a = `hwnTFa_rotating`;
$53ab2901d76f2951$export$4a6dd88bada4e7d2 = `hwnTFa_shimmer`;
$53ab2901d76f2951$export$fb184b623420d9be = `hwnTFa_title`;


function $a6d3f92a5fa03bab$var$Welcome() {
    const { t: t } = (0, $2A6IJ.useTranslation)(undefined, {
        keyPrefix: "admin_console"
    });
    const { navigate: navigate } = (0, $4W0F0.default)();
    const { isAuthenticated: isAuthenticated, signIn: signIn } = (0, $dtOpc.useLogto)();
    const theme = (0, $93h5F.default)();
    const redirectUri = (0, $iYZTa.default)();
    (0, $eCoWV.useEffect)(()=>{
        // If authenticated, navigate to the console root page directly
        if (isAuthenticated) navigate("/");
    }, [
        isAuthenticated,
        navigate
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($iyeK6)))($53ab2901d76f2951$exports.container, $53ab2901d76f2951$exports[theme]),
        children: [
            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                className: $53ab2901d76f2951$exports.header,
                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $d4e42755ce7365a4$export$2e2bcd8739ae039), {
                    className: $53ab2901d76f2951$exports.logo
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)("main", {
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $53ab2901d76f2951$exports.placeholderTop
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)("div", {
                        className: $53ab2901d76f2951$exports.content,
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $53ab2901d76f2951$exports.title,
                                children: t("welcome.title")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                                className: $53ab2901d76f2951$exports.description,
                                children: t("welcome.description")
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $kcPww.default), {
                                className: $53ab2901d76f2951$exports.button,
                                size: "large",
                                type: "branding",
                                title: "welcome.create_account",
                                onClick: ()=>{
                                    signIn(redirectUri.href);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)("div", {
                        className: $53ab2901d76f2951$exports.placeholderBottom
                    })
                ]
            })
        ]
    });
}
var $a6d3f92a5fa03bab$export$2e2bcd8739ae039 = $a6d3f92a5fa03bab$var$Welcome;



var $h7VLF = parcelRequire("h7VLF");


var $9zeGj = parcelRequire("9zeGj");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("8pPfi");
var $9X5Bp = parcelRequire("9X5Bp");

parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");
var $5Q2pm = parcelRequire("5Q2pm");
var $mbOAD = parcelRequire("mbOAD");

var $2ANSb = parcelRequire("2ANSb");

var $9ENFn = parcelRequire("9ENFn");

function $e6244ec582267912$var$HandleSocialCallback() {
    const { search: search } = (0, $9X5Bp.useLocation)();
    const { show: showModal } = (0, $9ENFn.useConfirmModal)();
    const api = (0, $2ANSb.useStaticApi)({
        prefixUrl: (0, $9oLtf.adminTenantEndpoint),
        resourceIndicator: (0, $5Q2pm.meApi).indicator,
        hideErrorToast: true
    });
    (0, $eCoWV.useEffect)(()=>{
        (async ()=>{
            const connectorId = sessionStorage.getItem((0, $mbOAD.storageKeys).linkingSocialConnector);
            sessionStorage.removeItem((0, $mbOAD.storageKeys).linkingSocialConnector);
            if (connectorId) {
                const queries = new URLSearchParams(search);
                queries.set("redirectUri", new URL(`/callback/${connectorId}`, new URL((0, $9oLtf.adminTenantEndpoint))).toString());
                const connectorData = Object.fromEntries(queries);
                try {
                    await api.post("me/social/link-identity", {
                        json: {
                            connectorId: connectorId,
                            connectorData: connectorData
                        }
                    });
                    window.close();
                } catch (error) {
                    (0, $4a20295e045d868b$export$d3da1ecaf1206c58)(error, async (code, message)=>{
                        if (code === "user.identity_already_in_use") {
                            await showModal({
                                ModalContent: message,
                                type: "alert",
                                cancelButtonText: "general.got_it"
                            });
                            window.close();
                            return true;
                        }
                    });
                }
            }
        })();
    }, [
        api,
        search,
        showModal
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}
var $e6244ec582267912$export$2e2bcd8739ae039 = $e6244ec582267912$var$HandleSocialCallback;


function $fab94cc2e5c3c7fc$var$Layout() {
    const swrOptions = (0, $451ef8ec75a8d7c6$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2mi28.SWRConfig), {
        value: swrOptions,
        children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $82e95263df22bc9e$export$2e2bcd8739ae039), {
            children: [
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $iuOAe.default), {
                    component: (0, $dusqy.Component).Console,
                    event: (0, $dusqy.GeneralEvent).Visit
                }),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $600b624765f10fdd$export$2e2bcd8739ae039), {}),
                /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Outlet), {})
            ]
        })
    });
}
function $fab94cc2e5c3c7fc$export$5fc098aa6da4c1ea() {
    return /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Routes), {
        children: [
            !(0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                path: "/",
                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Navigate), {
                    to: (0, $ceK0K.ossConsolePath)
                })
            }),
            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                path: "/:tenantId",
                element: /*#__PURE__*/ (0, $9zeGj.jsx)($fab94cc2e5c3c7fc$var$Layout, {}),
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                        path: "callback",
                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $ba8f7455b3577687$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                        path: "welcome",
                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a6d3f92a5fa03bab$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a56066727231a650$export$2e2bcd8739ae039), {}),
                        children: [
                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                path: "handle-social",
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $e6244ec582267912$export$2e2bcd8739ae039), {})
                            }),
                            /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $5f3e0712aacdcb31$export$2e2bcd8739ae039), {}),
                                children: [
                                    (0, $V1X8c.isCloud) && /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                        path: (0, $h7VLF.dropLeadingSlash)((0, $2wPYZ.GlobalRoute).CheckoutSuccessCallback),
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dfc4f3fe135b4f83$export$2e2bcd8739ae039), {})
                                    }),
                                    /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $9X5Bp.Route), {
                                        element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d4c5a47f1872192$export$2e2bcd8739ae039), {}),
                                        children: [
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                index: true,
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $6d4c5a47f1872192$export$468d45f4f0fe384a), {})
                                            }),
                                            /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.Route), {
                                                path: "*",
                                                element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $105cad9d2b9a0410$export$2e2bcd8739ae039), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


parcelRequire("6ZMK7");
var $9oLtf = parcelRequire("9oLtf");

var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $du5TZ = parcelRequire("du5TZ");
var $jwQhE = parcelRequire("jwQhE");
parcelRequire("bGN6i");
var $5CQIb = parcelRequire("5CQIb");


var $d2Ivz = parcelRequire("d2Ivz");

var $eCoWV = parcelRequire("eCoWV");
parcelRequire("dTZwU");
var $kiiuf = parcelRequire("kiiuf");


var $9zeGj = parcelRequire("9zeGj");
parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");

var $eCoWV = parcelRequire("eCoWV");

var $iYZTa = parcelRequire("iYZTa");


/** This component shows a loading indicator and tries to sign in again. */ function $35452f76e76897bb$var$SessionExpired() {
    const { signIn: signIn, isLoading: isLoading } = (0, $dtOpc.useLogto)();
    const redirectUri = (0, $iYZTa.default)();
    (0, $eCoWV.useEffect)(()=>{
        if (!isLoading) {
            (0, $dcd2d6b398a9e20d$export$5027ce2731efc4b9)();
            signIn(redirectUri.href);
        }
    }, [
        signIn,
        isLoading,
        redirectUri
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
}
var $35452f76e76897bb$export$2e2bcd8739ae039 = $35452f76e76897bb$var$SessionExpired;



var $h7VLF = parcelRequire("h7VLF");
/**
 * Returns true if the error is an OIDC invalid_grant error.
 *
 * OIDC request error is globally converted to the LogtoRequestError.
 * @see {@link @logto/core/packages/core/src/middleware/koa-oidc-error-handler.ts}
 * We need to check the error code to determine if it is an OIDC invalid_grant error.
 */ const $479246b995fd990d$var$isOidcInvalidGrantError = (error)=>{
    if (!(error instanceof (0, $du5TZ.LogtoRequestError))) return false;
    const oidcGrantErrors = [
        "oidc.invalid_grant",
        "oidc.invalid_target"
    ];
    return oidcGrantErrors.includes(error.code);
};
/**
 * An error boundary that catches errors in its children.
 * Note it uses several hooks and contexts:
 *
 * - Includes `useLogto()` (depending on `<LogtoProvider />`) to provide a "Sign in again" button for session expired errors.
 * - Includes `useTranslation()` to provide translations for the error messages.
 * - includes `useTheme()` (depending on `<AppThemeProvider />`) to provide the local stored theme.
 */ class $479246b995fd990d$var$ErrorBoundary extends (0, $eCoWV.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    render() {
        const { children: children, t: t } = this.props;
        const { error: error } = this.state;
        if (!error) return children;
        // Different strategies for handling errors in callback pages since the callback errors
        // are likely unexpected and unrecoverable.
        if ((0, $h7VLF.isInCallback)()) {
            if (error instanceof (0, $du5TZ.LogtoError) && error.data instanceof (0, $du5TZ.OidcError)) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
                errorCode: error.data.error,
                errorMessage: error.data.errorDescription,
                callStack: error.stack
            });
            return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
                errorCode: error.name,
                errorMessage: error.message,
                callStack: error.stack
            });
        }
        // Insecure contexts error is not recoverable
        if (error instanceof (0, $du5TZ.LogtoError) && error.code === "crypto_subtle_unavailable") return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
            errorMessage: t("errors.insecure_contexts"),
            callStack: error.stack
        });
        // Treat other Logto errors and 401 responses as session expired
        if (error instanceof (0, $du5TZ.LogtoError) || error instanceof (0, $jwQhE.LogtoClientError) || $479246b995fd990d$var$isOidcInvalidGrantError(error) || error instanceof (0, $d2Ivz.HTTPError) && error.response.status === 401 || error instanceof (0, $a819ec4606730a84$export$286baf652d0b1206) && error.status === 401) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $35452f76e76897bb$export$2e2bcd8739ae039), {});
        const callStack = (0, $5CQIb.conditional)(typeof error === "object" && typeof error.stack === "string" && error.stack.split("\n").slice(1).join("\n"));
        return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a274721f157217dc$export$2e2bcd8739ae039), {
            errorMessage: error.message,
            callStack: callStack
        });
    }
    constructor(...args){
        super(...args);
        this.state = {};
    }
}
var $479246b995fd990d$export$2e2bcd8739ae039 = (0, $kiiuf.withTranslation)("translation", {
    keyPrefix: "admin_console"
})($479246b995fd990d$var$ErrorBoundary);


parcelRequire("cDiVA");
var $dtOpc = parcelRequire("dtOpc");

var $eCoWV = parcelRequire("eCoWV");
function $7b422091e5fbfb5d$export$2e2bcd8739ae039({ children: children }) {
    const { error: error } = (0, $dtOpc.useLogto)();
    (0, $eCoWV.useEffect)(()=>{
        if (error) throw error;
    }, [
        error
    ]);
    return children;
}



var $8Rn6p = parcelRequire("8Rn6p");

var $eEyjP = parcelRequire("eEyjP");

var $1iAqo = parcelRequire("1iAqo");

var $2wPYZ = parcelRequire("2wPYZ");


var $awn06 = parcelRequire("awn06");

var $gfYX1 = parcelRequire("gfYX1");

var $gvD6c = parcelRequire("gvD6c");
var $6a1cb932fad224c1$var$arr = [];
var $6a1cb932fad224c1$var$each = $6a1cb932fad224c1$var$arr.forEach;
var $6a1cb932fad224c1$var$slice = $6a1cb932fad224c1$var$arr.slice;
function $6a1cb932fad224c1$var$defaults(obj) {
    $6a1cb932fad224c1$var$each.call($6a1cb932fad224c1$var$slice.call(arguments, 1), function(source) {
        if (source) {
            for(var prop in source)if (obj[prop] === undefined) obj[prop] = source[prop];
        }
    });
    return obj;
}
// eslint-disable-next-line no-control-regex
var $6a1cb932fad224c1$var$fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
var $6a1cb932fad224c1$var$serializeCookie = function serializeCookie(name, val, options) {
    var opt = options || {};
    opt.path = opt.path || "/";
    var value = encodeURIComponent(val);
    var str = "".concat(name, "=").concat(value);
    if (opt.maxAge > 0) {
        var maxAge = opt.maxAge - 0;
        if (Number.isNaN(maxAge)) throw new Error("maxAge should be a Number");
        str += "; Max-Age=".concat(Math.floor(maxAge));
    }
    if (opt.domain) {
        if (!$6a1cb932fad224c1$var$fieldContentRegExp.test(opt.domain)) throw new TypeError("option domain is invalid");
        str += "; Domain=".concat(opt.domain);
    }
    if (opt.path) {
        if (!$6a1cb932fad224c1$var$fieldContentRegExp.test(opt.path)) throw new TypeError("option path is invalid");
        str += "; Path=".concat(opt.path);
    }
    if (opt.expires) {
        if (typeof opt.expires.toUTCString !== "function") throw new TypeError("option expires is invalid");
        str += "; Expires=".concat(opt.expires.toUTCString());
    }
    if (opt.httpOnly) str += "; HttpOnly";
    if (opt.secure) str += "; Secure";
    if (opt.sameSite) {
        var sameSite = typeof opt.sameSite === "string" ? opt.sameSite.toLowerCase() : opt.sameSite;
        switch(sameSite){
            case true:
                str += "; SameSite=Strict";
                break;
            case "lax":
                str += "; SameSite=Lax";
                break;
            case "strict":
                str += "; SameSite=Strict";
                break;
            case "none":
                str += "; SameSite=None";
                break;
            default:
                throw new TypeError("option sameSite is invalid");
        }
    }
    return str;
};
var $6a1cb932fad224c1$var$cookie = {
    create: function create(name, value, minutes, domain) {
        var cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
            path: "/",
            sameSite: "strict"
        };
        if (minutes) {
            cookieOptions.expires = new Date();
            cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60000);
        }
        if (domain) cookieOptions.domain = domain;
        document.cookie = $6a1cb932fad224c1$var$serializeCookie(name, encodeURIComponent(value), cookieOptions);
    },
    read: function read(name) {
        var nameEQ = "".concat(name, "=");
        var ca = document.cookie.split(";");
        for(var i = 0; i < ca.length; i++){
            var c = ca[i];
            while(c.charAt(0) === " ")c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
        }
        return null;
    },
    remove: function remove(name) {
        this.create(name, "", -1);
    }
};
var $6a1cb932fad224c1$var$cookie$1 = {
    name: "cookie",
    lookup: function lookup(options) {
        var found;
        if (options.lookupCookie && typeof document !== "undefined") {
            var c = $6a1cb932fad224c1$var$cookie.read(options.lookupCookie);
            if (c) found = c;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupCookie && typeof document !== "undefined") $6a1cb932fad224c1$var$cookie.create(options.lookupCookie, lng, options.cookieMinutes, options.cookieDomain, options.cookieOptions);
    }
};
var $6a1cb932fad224c1$var$querystring = {
    name: "querystring",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var search = window.location.search;
            if (!window.location.search && window.location.hash && window.location.hash.indexOf("?") > -1) search = window.location.hash.substring(window.location.hash.indexOf("?"));
            var query = search.substring(1);
            var params = query.split("&");
            for(var i = 0; i < params.length; i++){
                var pos = params[i].indexOf("=");
                if (pos > 0) {
                    var key = params[i].substring(0, pos);
                    if (key === options.lookupQuerystring) found = params[i].substring(pos + 1);
                }
            }
        }
        return found;
    }
};
var $6a1cb932fad224c1$var$hasLocalStorageSupport = null;
var $6a1cb932fad224c1$var$localStorageAvailable = function localStorageAvailable() {
    if ($6a1cb932fad224c1$var$hasLocalStorageSupport !== null) return $6a1cb932fad224c1$var$hasLocalStorageSupport;
    try {
        $6a1cb932fad224c1$var$hasLocalStorageSupport = window !== "undefined" && window.localStorage !== null;
        var testKey = "i18next.translate.boo";
        window.localStorage.setItem(testKey, "foo");
        window.localStorage.removeItem(testKey);
    } catch (e) {
        $6a1cb932fad224c1$var$hasLocalStorageSupport = false;
    }
    return $6a1cb932fad224c1$var$hasLocalStorageSupport;
};
var $6a1cb932fad224c1$var$localStorage = {
    name: "localStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupLocalStorage && $6a1cb932fad224c1$var$localStorageAvailable()) {
            var lng = window.localStorage.getItem(options.lookupLocalStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupLocalStorage && $6a1cb932fad224c1$var$localStorageAvailable()) window.localStorage.setItem(options.lookupLocalStorage, lng);
    }
};
var $6a1cb932fad224c1$var$hasSessionStorageSupport = null;
var $6a1cb932fad224c1$var$sessionStorageAvailable = function sessionStorageAvailable() {
    if ($6a1cb932fad224c1$var$hasSessionStorageSupport !== null) return $6a1cb932fad224c1$var$hasSessionStorageSupport;
    try {
        $6a1cb932fad224c1$var$hasSessionStorageSupport = window !== "undefined" && window.sessionStorage !== null;
        var testKey = "i18next.translate.boo";
        window.sessionStorage.setItem(testKey, "foo");
        window.sessionStorage.removeItem(testKey);
    } catch (e) {
        $6a1cb932fad224c1$var$hasSessionStorageSupport = false;
    }
    return $6a1cb932fad224c1$var$hasSessionStorageSupport;
};
var $6a1cb932fad224c1$var$sessionStorage = {
    name: "sessionStorage",
    lookup: function lookup(options) {
        var found;
        if (options.lookupSessionStorage && $6a1cb932fad224c1$var$sessionStorageAvailable()) {
            var lng = window.sessionStorage.getItem(options.lookupSessionStorage);
            if (lng) found = lng;
        }
        return found;
    },
    cacheUserLanguage: function cacheUserLanguage(lng, options) {
        if (options.lookupSessionStorage && $6a1cb932fad224c1$var$sessionStorageAvailable()) window.sessionStorage.setItem(options.lookupSessionStorage, lng);
    }
};
var $6a1cb932fad224c1$var$navigator$1 = {
    name: "navigator",
    lookup: function lookup(options) {
        var found = [];
        if (typeof navigator !== "undefined") {
            if (navigator.languages) // chrome only; not an array, so can't use .push.apply instead of iterating
            for(var i = 0; i < navigator.languages.length; i++)found.push(navigator.languages[i]);
            if (navigator.userLanguage) found.push(navigator.userLanguage);
            if (navigator.language) found.push(navigator.language);
        }
        return found.length > 0 ? found : undefined;
    }
};
var $6a1cb932fad224c1$var$htmlTag = {
    name: "htmlTag",
    lookup: function lookup(options) {
        var found;
        var htmlTag = options.htmlTag || (typeof document !== "undefined" ? document.documentElement : null);
        if (htmlTag && typeof htmlTag.getAttribute === "function") found = htmlTag.getAttribute("lang");
        return found;
    }
};
var $6a1cb932fad224c1$var$path = {
    name: "path",
    lookup: function lookup(options) {
        var found;
        if (typeof window !== "undefined") {
            var language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
            if (language instanceof Array) {
                if (typeof options.lookupFromPathIndex === "number") {
                    if (typeof language[options.lookupFromPathIndex] !== "string") return undefined;
                    found = language[options.lookupFromPathIndex].replace("/", "");
                } else found = language[0].replace("/", "");
            }
        }
        return found;
    }
};
var $6a1cb932fad224c1$var$subdomain = {
    name: "subdomain",
    lookup: function lookup(options) {
        // If given get the subdomain index else 1
        var lookupFromSubdomainIndex = typeof options.lookupFromSubdomainIndex === "number" ? options.lookupFromSubdomainIndex + 1 : 1;
        // get all matches if window.location. is existing
        // first item of match is the match itself and the second is the first group macht which sould be the first subdomain match
        // is the hostname no public domain get the or option of localhost
        var language = typeof window !== "undefined" && window.location && window.location.hostname && window.location.hostname.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);
        // if there is no match (null) return undefined
        if (!language) return undefined;
        // return the given group match
        return language[lookupFromSubdomainIndex];
    }
};
function $6a1cb932fad224c1$var$getDefaults() {
    return {
        order: [
            "querystring",
            "cookie",
            "localStorage",
            "sessionStorage",
            "navigator",
            "htmlTag"
        ],
        lookupQuerystring: "lng",
        lookupCookie: "i18next",
        lookupLocalStorage: "i18nextLng",
        lookupSessionStorage: "i18nextLng",
        // cache user language
        caches: [
            "localStorage"
        ],
        excludeCacheFor: [
            "cimode"
        ]
    };
}
var $6a1cb932fad224c1$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function Browser(services) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        (0, $gfYX1.default)(this, Browser);
        this.type = "languageDetector";
        this.detectors = {};
        this.init(services, options);
    }
    (0, $gvD6c.default)(Browser, [
        {
            key: "init",
            value: function init(services) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
                this.services = services;
                this.options = $6a1cb932fad224c1$var$defaults(options, this.options || {}, $6a1cb932fad224c1$var$getDefaults());
                // backwards compatibility
                if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
                this.i18nOptions = i18nOptions;
                this.addDetector($6a1cb932fad224c1$var$cookie$1);
                this.addDetector($6a1cb932fad224c1$var$querystring);
                this.addDetector($6a1cb932fad224c1$var$localStorage);
                this.addDetector($6a1cb932fad224c1$var$sessionStorage);
                this.addDetector($6a1cb932fad224c1$var$navigator$1);
                this.addDetector($6a1cb932fad224c1$var$htmlTag);
                this.addDetector($6a1cb932fad224c1$var$path);
                this.addDetector($6a1cb932fad224c1$var$subdomain);
            }
        },
        {
            key: "addDetector",
            value: function addDetector(detector) {
                this.detectors[detector.name] = detector;
            }
        },
        {
            key: "detect",
            value: function detect(detectionOrder) {
                var _this = this;
                if (!detectionOrder) detectionOrder = this.options.order;
                var detected = [];
                detectionOrder.forEach(function(detectorName) {
                    if (_this.detectors[detectorName]) {
                        var lookup = _this.detectors[detectorName].lookup(_this.options);
                        if (lookup && typeof lookup === "string") lookup = [
                            lookup
                        ];
                        if (lookup) detected = detected.concat(lookup);
                    }
                });
                if (this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
                return detected.length > 0 ? detected[0] : null; // a little backward compatibility
            }
        },
        {
            key: "cacheUserLanguage",
            value: function cacheUserLanguage(lng, caches) {
                var _this2 = this;
                if (!caches) caches = this.options.caches;
                if (!caches) return;
                if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
                caches.forEach(function(cacheName) {
                    if (_this2.detectors[cacheName]) _this2.detectors[cacheName].cacheUserLanguage(lng, _this2.options);
                });
            }
        }
    ]);
    return Browser;
}();
$6a1cb932fad224c1$export$2e2bcd8739ae039.type = "languageDetector";


parcelRequire("dTZwU");
var $29gsH = parcelRequire("29gsH");
const $629851f1388fdb57$var$initI18n = async (language)=>(0, $awn06.default).use((0, $29gsH.initReactI18next)).use((0, $6a1cb932fad224c1$export$2e2bcd8739ae039)).init({
        resources: $824f1ad0d8aba615$export$2e2bcd8739ae039,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false
        },
        lng: language,
        detection: {
            lookupLocalStorage: "i18nextLogtoAcLng",
            lookupSessionStorage: "i18nextLogtoAcLng"
        }
    });
var $629851f1388fdb57$export$2e2bcd8739ae039 = $629851f1388fdb57$var$initI18n;


(0, $629851f1388fdb57$export$2e2bcd8739ae039)();
/**
 * The main entry of the project. It provides two fundamental context providers:
 *
 * - `RouterProvider`: the sole router provider of the project.
 * - `TenantsProvider`: manages the tenants data, requires the `RouterProvider` to
 * get the current tenant ID from the URL.
 */ function $65700101ac845e5f$var$App() {
    const router = (0, $8pPfi.createBrowserRouter)([
        {
            path: "*",
            element: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $2wPYZ.default), {
                children: /*#__PURE__*/ (0, $9zeGj.jsx)($65700101ac845e5f$var$Providers, {})
            })
        }
    ]);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $9X5Bp.RouterProvider), {
        router: router
    });
}
var $65700101ac845e5f$export$2e2bcd8739ae039 = $65700101ac845e5f$var$App;
/**
 * This component serves as a container for all the providers and boundary components.
 *
 * Since `TenantsContext` requires the `TenantsProvider` to be mounted, and the initialization
 * of `LogtoProvider` requires the `TenantsContext` to be available, we have to put them into
 * different components.
 */ function $65700101ac845e5f$var$Providers() {
    const { tenants: tenants, currentTenantId: currentTenantId } = (0, $eCoWV.useContext)((0, $2wPYZ.TenantsContext));
    const resources = (0, $eCoWV.useMemo)(()=>(0, $5t2HV.deduplicate)((0, $5CQIb.conditionalArray)(// Explicitly add `currentTenantId` and deduplicate since the user may directly
        // access a URL with Tenant ID, adding the ID from the URL here can possibly remove one
        // additional redirect.
        currentTenantId && (0, $5Q2pm.getManagementApi)(currentTenantId).indicator, ...tenants.map(({ id: id })=>(0, $5Q2pm.getManagementApi)(id).indicator), (0, $V1X8c.isCloud) && (0, $5Q2pm.cloudApi).indicator, (0, $5Q2pm.meApi).indicator)), [
        currentTenantId,
        tenants
    ]);
    const scopes = (0, $eCoWV.useMemo)(()=>[
            (0, $lvEG3.UserScope).Email,
            (0, $lvEG3.UserScope).Identities,
            (0, $lvEG3.UserScope).CustomData,
            (0, $lvEG3.UserScope).Organizations,
            (0, $az3ON.PredefinedScope).All,
            ...(0, $5CQIb.conditionalArray)((0, $V1X8c.isCloud) && (0, $5Q2pm.cloudApi).scopes.CreateTenant, (0, $V1X8c.isCloud) && (0, $5Q2pm.cloudApi).scopes.ManageTenant, (0, $V1X8c.isCloud) && (0, $5Q2pm.cloudApi).scopes.ManageTenantSelf)
        ], []);
    return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $dbZ39.LogtoProvider), {
        unstable_enableCache: true,
        config: {
            endpoint: (0, $9oLtf.adminTenantEndpoint).href,
            appId: (0, $faCyI.adminConsoleApplicationId),
            resources: resources,
            scopes: scopes
        },
        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1iAqo.AppThemeProvider), {
            children: /*#__PURE__*/ (0, $9zeGj.jsxs)((0, $ek0ZU.default), {
                cloudRole: "console",
                children: [
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $a7rB2.Helmet), {
                        titleTemplate: `%s - ${(0, $9oLtf.mainTitle)}`,
                        defaultTitle: (0, $9oLtf.mainTitle)
                    }),
                    /*#__PURE__*/ (0, $9zeGj.jsx)((0, $479246b995fd990d$export$2e2bcd8739ae039), {
                        children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $7b422091e5fbfb5d$export$2e2bcd8739ae039), {
                            children: !(0, $V1X8c.isCloud) || currentTenantId ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $eEyjP.default), {
                                children: /*#__PURE__*/ (0, $9zeGj.jsx)((0, $8Rn6p.default), {
                                    children: /*#__PURE__*/ (0, $9zeGj.jsx)($65700101ac845e5f$var$AppRoutes, {})
                                })
                            }) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $1239d6b35d459e42$export$2e2bcd8739ae039), {})
                        })
                    })
                ]
            })
        })
    });
}
/** Renders different routes based on the user's onboarding status. */ function $65700101ac845e5f$var$AppRoutes() {
    const { tenantEndpoint: tenantEndpoint } = (0, $eCoWV.useContext)((0, $eEyjP.AppDataContext));
    const { isLoaded: isLoaded } = (0, $dbaffd50cd7c731f$export$2e2bcd8739ae039)();
    const { isOnboarding: isOnboarding } = (0, $abb531754ca753b0$export$2e2bcd8739ae039)();
    const { isAuthenticated: isAuthenticated } = (0, $dtOpc.useLogto)();
    (0, $b53d2d1f9b4f7a6d$export$2e2bcd8739ae039)();
    // Authenticated user should load onboarding data before rendering the app.
    // This looks weird and it will be refactored soon by merging the onboarding
    // routes with the console routes.
    if (!tenantEndpoint || (0, $V1X8c.isCloud) && isAuthenticated && !isLoaded) return /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fa8a07d79ef6bb6a$export$2e2bcd8739ae039), {});
    return isAuthenticated && isOnboarding ? /*#__PURE__*/ (0, $9zeGj.jsx)((0, $96b2ff4afcb4ae6e$export$bd7ec0980162456), {}) : /*#__PURE__*/ (0, $9zeGj.jsx)((0, $fab94cc2e5c3c7fc$export$5fc098aa6da4c1ea), {});
}


const $3820a7fa9ca2bed3$var$app = document.querySelector("#app");
const $3820a7fa9ca2bed3$var$root = $3820a7fa9ca2bed3$var$app && (0, $1ac549a22f572cc5$export$882461b6382ed46c)($3820a7fa9ca2bed3$var$app);
(0, (/*@__PURE__*/$parcel$interopDefault($bFFWx))).setAppElement("#app");
$3820a7fa9ca2bed3$var$root?.render(/*#__PURE__*/ (0, $9zeGj.jsx)((0, $65700101ac845e5f$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.b0698af2.js.map
